/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 696);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(706)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                __webpack_require__(816)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(815)(module)))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports=function(e){function t(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return e[i].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,i){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:i})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="/",t(t.s=76)}([function(e,t){var n=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(e,t){var n={}.hasOwnProperty;e.exports=function(e,t){return n.call(e,t)}},function(e,t,n){var i=n(53),r=n(14);e.exports=function(e){return i(r(e))}},function(e,t,n){e.exports=!n(8)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(e,t,n){var i=n(5),r=n(11);e.exports=n(3)?function(e,t,n){return i.f(e,t,r(1,n))}:function(e,t,n){return e[t]=n,e}},function(e,t,n){var i=n(7),r=n(30),a=n(23),o=Object.defineProperty;t.f=n(3)?Object.defineProperty:function(e,t,n){if(i(e),t=a(t,!0),i(n),r)try{return o(e,t,n)}catch(e){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(e[t]=n.value),e}},function(e,t,n){var i=n(21)("wks"),r=n(12),a=n(0).Symbol,o="function"==typeof a;(e.exports=function(e){return i[e]||(i[e]=o&&a[e]||(o?a:r)("Symbol."+e))}).store=i},function(e,t,n){var i=n(9);e.exports=function(e){if(!i(e))throw TypeError(e+" is not an object!");return e}},function(e,t){e.exports=function(e){try{return!!e()}catch(e){return!0}}},function(e,t){e.exports=function(e){return"object"==typeof e?null!==e:"function"==typeof e}},function(e,t,n){var i=n(35),r=n(15);e.exports=Object.keys||function(e){return i(e,r)}},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},function(e,t){var n=0,i=Math.random();e.exports=function(e){return"Symbol(".concat(void 0===e?"":e,")_",(++n+i).toString(36))}},function(e,t){var n=e.exports={version:"2.4.0"};"number"==typeof __e&&(__e=n)},function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on  "+e);return e}},function(e,t){e.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(e,t){e.exports={}},function(e,t){e.exports=!0},function(e,t){t.f={}.propertyIsEnumerable},function(e,t,n){var i=n(5).f,r=n(1),a=n(6)("toStringTag");e.exports=function(e,t,n){e&&!r(e=n?e:e.prototype,a)&&i(e,a,{configurable:!0,value:t})}},function(e,t,n){var i=n(21)("keys"),r=n(12);e.exports=function(e){return i[e]||(i[e]=r(e))}},function(e,t,n){var i=n(0),r=i["__core-js_shared__"]||(i["__core-js_shared__"]={});e.exports=function(e){return r[e]||(r[e]={})}},function(e,t){var n=Math.ceil,i=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?i:n)(e)}},function(e,t,n){var i=n(9);e.exports=function(e,t){if(!i(e))return e;var n,r;if(t&&"function"==typeof(n=e.toString)&&!i(r=n.call(e)))return r;if("function"==typeof(n=e.valueOf)&&!i(r=n.call(e)))return r;if(!t&&"function"==typeof(n=e.toString)&&!i(r=n.call(e)))return r;throw TypeError("Can't convert object to primitive value")}},function(e,t,n){var i=n(0),r=n(13),a=n(17),o=n(25),s=n(5).f;e.exports=function(e){var t=r.Symbol||(r.Symbol=a?{}:i.Symbol||{});"_"==e.charAt(0)||e in t||s(t,e,{value:o.f(e)})}},function(e,t,n){t.f=n(6)},function(e,t,n){"use strict";t.a={translations:{af:{language:"Afrikaans",months:{original:["Januarie","Februarie","Maart","April","Mei","Junie","Julie","Augustus","September","Oktober","November","Desember"],abbr:["Jan","Feb","Mrt","Apr","Mei","Jun","Jul","Aug","Sep","Okt","Nov","Des"]},days:["So.","Ma.","Di.","Wo.","Do.","Vr.","Sa."]},ar:{language:"Arabic",rtl:!0,months:{original:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوڤمبر","ديسمبر"],abbr:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوڤمبر","ديسمبر"]},days:["أحد","إثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"]},bg:{language:"Bulgarian",months:{original:["Януари","Февруари","Март","Април","Май","Юни","Юли","Август","Септември","Октомври","Ноември","Декември"],abbr:["Ян","Фев","Мар","Апр","Май","Юни","Юли","Авг","Сеп","Окт","Ное","Дек"]},days:["Нд","Пн","Вт","Ср","Чт","Пт","Сб"]},bs:{language:"Bosnian",months:{original:["Januar","Februar","Mart","April","Maj","Juni","Juli","Avgust","Septembar","Oktobar","Novembar","Decembar"],abbr:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"]},days:["Ned","Pon","Uto","Sri","Čet","Pet","Sub"]},cs:{language:"Czech",months:{original:["leden","únor","březen","duben","květen","červen","červenec","srpen","září","říjen","listopad","prosinec"],abbr:["led","úno","bře","dub","kvě","čer","čec","srp","zář","říj","lis","pro"]},days:["ne","po","út","st","čt","pá","so"]},da:{language:"Danish",months:{original:["Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December"],abbr:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"]},days:["Sø","Ma","Ti","On","To","Fr","Lø"]},de:{language:"German",months:{original:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],abbr:["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"]},days:["So.","Mo.","Di.","Mi.","Do.","Fr.","Sa."]},ee:{language:"Estonian",months:{original:["Jaanuar","Veebruar","Märts","Aprill","Mai","Juuni","Juuli","August","September","Oktoober","November","Detsember"],abbr:["Jaan","Veebr","Märts","Apr","Mai","Juuni","Juuli","Aug","Sept","Okt","Nov","Dets"]},days:["P","E","T","K","N","R","L"]},el:{language:"Greek",months:{original:["Ιανουάριος","Φεβρουάριος","Μάρτιος","Απρίλιος","Μάϊος","Ιούνιος","Ιούλιος","Αύγουστος","Σεπτέμβριος","Οκτώβριος","Νοέμβριος","Δεκέμβριος"],abbr:["Ιαν","Φεβ","Μαρ","Απρ","Μαι","Ιουν","Ιουλ","Αυγ","Σεπ","Οκτ","Νοε","Δεκ"]},days:["Κυρ","Δευ","Τρι","Τετ","Πεμ","Παρ","Σατ"]},en:{language:"English",months:{original:["January","February","March","April","May","June","July","August","September","October","November","December"],abbr:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]},days:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"]},es:{language:"Spanish",months:{original:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],abbr:["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"]},days:["Dom","Lun","Mar","Mié","Jue","Vie","Sab"]},ca:{language:"Catalan",months:{original:["Gener","Febrer","Març","Abril","Maig","Juny","Juliol","Agost","Setembre","Octubre","Novembre","Desembre"],abbr:["Gen","Feb","Mar","Abr","Mai","Jun","Jul","Ago","Set","Oct","Nov","Des"]},days:["Diu","Dil","Dmr","Dmc","Dij","Div","Dis"]},fi:{language:"Finish",months:{original:["tammikuu","helmikuu","maaliskuu","huhtikuu","toukokuu","kesäkuu","heinäkuu","elokuu","syyskuu","lokakuu","marraskuu","joulukuu"],abbr:["tammi","helmi","maalis","huhti","touko","kesä","heinä","elo","syys","loka","marras","joulu"]},days:["su","ma","ti","ke","to","pe","la"]},fr:{language:"French",months:{original:["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],abbr:["Jan","Fév","Mar","Avr","Mai","Juin","Juil","Août","Sep","Oct","Nov","Déc"]},days:["Dim","Lun","Mar","Mer","Jeu","Ven","Sam"]},ge:{language:"Georgia",months:{original:["იანვარი","თებერვალი","მარტი","აპრილი","მაისი","ივნისი","ივლისი","აგვისტო","სექტემბერი","ოქტომბერი","ნოემბერი","დეკემბერი"],abbr:["იან","თებ","მარ","აპრ","მაი","ივნ","ივლ","აგვ","სექ","ოქტ","ნოე","დეკ"]},days:["კვი","ორშ","სამ","ოთხ","ხუთ","პარ","შაბ"]},ja:{language:"Japanese",ymd:!0,months:{original:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],abbr:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"]},days:["日","月","火","水","木","金","土"]},he:{language:"Hebrew",rtl:!0,months:{original:["ינואר","פברואר","מרץ","אפריל","מאי","יוני","יולי","אוגוסט","ספטמבר","אוקטובר","נובמבר","דצמבר"],abbr:["ינו","פבר","מרץ","אפר","מאי","יונ","יול","אוג","ספט","אוק","נוב","דצמ"]},days:["א","ב","ג","ד","ה","ו","ש"]},hu:{language:"Hungarian",ymd:!0,months:{original:["Január","Február","Március","Április","Május","Június","Július","Augusztus","Szeptember","Október","November","December"],abbr:["Jan","Febr","Márc","Ápr","Máj","Jún","Júl","Aug","Szept","Okt","Nov","Dec"]},days:["Vas","Hét","Ke","Sze","Csü","Pén","Szo"]},hr:{language:"Croatian",months:{original:["Siječanj","Veljača","Ožujak","Travanj","Svibanj","Lipanj","Srpanj","Kolovoz","Rujan","Listopad","Studeni","Prosinac"],abbr:["Sij","Velj","Ožu","Tra","Svi","Lip","Srp","Kol","Ruj","Lis","Stu","Pro"]},days:["Ned","Pon","Uto","Sri","Čet","Pet","Sub"]},id:{language:"Indonesian",months:{original:["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"],abbr:["Jan","Feb","Mar","Apr","Mei","Jun","Jul","Agu","Sep","Okt","Nov","Des"]},days:["Min","Sen","Sel","Rab","Kam","Jum","Sab"]},it:{language:"Italian",months:{original:["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],abbr:["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"]},days:["Dom","Lun","Mar","Mer","Gio","Ven","Sab"]},is:{language:"Icelandic",months:{original:["Janúar","Febrúar","Mars","Apríl","Maí","Júní","Júlí","Ágúst","September","Október","Nóvember","Desember"],abbr:["Jan","Feb","Mars","Apr","Maí","Jún","Júl","Ágú","Sep","Okt","Nóv","Des"]},days:["Sun","Mán","Þri","Mið","Fim","Fös","Lau"]},fa:{language:"Persian",months:{original:["فروردین","اردیبهشت","خرداد","تیر","مرداد","شهریور","مهر","آبان","آذر","دی","بهمن","اسفند"],abbr:["فرو","ارد","خرد","تیر","مرد","شهر","مهر","آبا","آذر","دی","بهم","اسف"]},days:["یکشنبه","دوشنبه","سه‌شنبه","چهارشنبه","پنجشنبه","جمعه","شنبه"]},ko:{language:"Korean",ymd:!0,months:{original:["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],abbr:["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"]},days:["일","월","화","수","목","금","토"]},lb:{language:"Luxembourgish",months:{original:["Januar","Februar","Mäerz","Abrëll","Mäi","Juni","Juli","August","September","Oktober","November","Dezember"],abbr:["Jan","Feb","Mäe","Abr","Mäi","Jun","Jul","Aug","Sep","Okt","Nov","Dez"]},days:["So.","Mé.","Dë.","Më.","Do.","Fr.","Sa."]},lt:{language:"Lithuanian",ymd:!0,months:{original:["Sausis","Vasaris","Kovas","Balandis","Gegužė","Birželis","Liepa","Rugpjūtis","Rugsėjis","Spalis","Lapkritis","Gruodis"],abbr:["Sau","Vas","Kov","Bal","Geg","Bir","Lie","Rugp","Rugs","Spa","Lap","Gru"]},days:["Sek","Pir","Ant","Tre","Ket","Pen","Šeš"]},lv:{language:"Latvian",months:{original:["Janvāris","Februāris","Marts","Aprīlis","Maijs","Jūnijs","Jūlijs","Augusts","Septembris","Oktobris","Novembris","Decembris"],abbr:["Jan","Feb","Mar","Apr","Mai","Jūn","Jūl","Aug","Sep","Okt","Nov","Dec"]},days:["Sv","Pr","Ot","Tr","Ce","Pk","Se"]},mn:{language:"Mongolia",ymd:!0,months:{original:["1 дүгээр сар","2 дугаар сар","3 дугаар сар","4 дүгээр сар","5 дугаар сар","6 дугаар сар","7 дугаар сар","8 дугаар сар","9 дүгээр сар","10 дугаар сар","11 дүгээр сар","12 дугаар сар"],abbr:["1-р сар","2-р сар","3-р сар","4-р сар","5-р сар","6-р сар","7-р сар","8-р сар","9-р сар","10-р сар","11-р сар","12-р сар"]},days:["Ня","Да","Мя","Лх","Пү","Ба","Бя"]},nl:{language:"Dutch",months:{original:["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],abbr:["jan","feb","maa","apr","mei","jun","jul","aug","sep","okt","nov","dec"]},days:["zo","ma","di","wo","do","vr","za"]},"nb-no":{language:"Norwegian Bokmål",months:{original:["Januar","Februar","Mars","April","Mai","Juni","Juli","August","September","Oktober","November","Desember"],abbr:["Jan","Feb","Mar","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Des"]},days:["Sø","Ma","Ti","On","To","Fr","Lø"]},pl:{language:"Polish",months:{original:["Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec","Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień"],abbr:["Sty","Lut","Mar","Kwi","Maj","Cze","Lip","Sie","Wrz","Paź","Lis","Gru"]},days:["Nd","Pn","Wt","Śr","Czw","Pt","Sob"]},"pt-br":{language:"Brazilian",months:{original:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],abbr:["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"]},days:["Dom","Seg","Ter","Qua","Qui","Sex","Sab"]},ro:{language:"Romanian",months:{original:["Ianuarie","Februarie","Martie","Aprilie","Mai","Iunie","Iulie","August","Septembrie","Octombrie","Noiembrie","Decembrie"],abbr:["Ian","Feb","Mar","Apr","Mai","Iun","Iul","Aug","Sep","Oct","Noi","Dec"]},days:["D","L","Ma","Mi","J","V","S"]},ru:{language:"Russian",months:{original:["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],abbr:["Янв","Февр","Март","Апр","Май","Июнь","Июль","Авг","Сент","Окт","Нояб","Дек"]},days:["Вс","Пн","Вт","Ср","Чт","Пт","Сб"]},sv:{language:"Swedish",months:{original:["Januari","Februari","Mars","April","Maj","Juni","Juli","Augusti","September","Oktober","November","December"],abbr:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"]},days:["Sön","Mån","Tis","Ons","Tor","Fre","Lör"]},sk:{language:"Slovakian",months:{original:["január","február","marec","apríl","máj","jún","júl","august","september","október","november","december"],abbr:["jan","feb","mar","apr","máj","jún","júl","aug","sep","okt","nov","dec"]},days:["ne","po","ut","st","št","pi","so"]},"sl-si":{language:"Sloveian",months:{original:["Januar","Februar","Marec","April","Maj","Junij","Julij","Avgust","September","Oktober","November","December"],abbr:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"]},days:["Ned","Pon","Tor","Sre","Čet","Pet","Sob"]},sr:{language:"Serbian",months:{original:["Januar","Februar","Mart","April","Maj","Jun","Jul","Avgust","Septembar","Oktobar","Novembar","Decembar"],abbr:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"]},days:["Ned","Pon","Uto","Sre","Čet","Pet","Sub"]},"sr-Cyrl":{language:"Serbian in Cyrillic script",months:{original:["Јануар","Фебруар","Март","Април","Мај","Јун","Јул","Август","Септембар","Октобар","Новембар","Децембар"],abbr:["Јан","Феб","Мар","Апр","Мај","Јун","Јул","Авг","Сеп","Окт","Нов","Дец"]},days:["Нед","Пон","Уто","Сре","Чет","Пет","Суб"]},th:{language:"Thai",months:{original:["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"],abbr:["ม.ค.","ก.พ.","มี.ค.","เม.ย.","พ.ค.","มิ.ย.","ก.ค.","ส.ค.","ก.ย.","ต.ค.","พ.ย.","ธ.ค."]},days:["อา","จ","อ","พ","พฤ","ศ","ส"]},tr:{language:"Turkish",months:{original:["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"],abbr:["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara"]},days:["Paz","Pzt","Sal","Çar","Per","Cum","Cmt"]},uk:{language:"Ukraine",months:{original:["Січень","Лютий","Березень","Квітень","Травень","Червень","Липень","Серпень","Вересень","Жовтень","Листопад","Грудень"],abbr:["Січ","Лют","Бер","Квіт","Трав","Чер","Лип","Серп","Вер","Жовт","Лист","Груд"]},days:["Нд","Пн","Вт","Ср","Чт","Пт","Сб"]},ur:{language:"Urdu",rtl:!0,months:{original:["جنوری","فروری","مارچ","اپریل","مئی","جون","جولائی","اگست","سپتمبر","اکتوبر","نومبر","دسمبر"],abbr:["جنوری","فروری","مارچ","اپریل","مئی","جون","جولائی","اگست","سپتمبر","اکتوبر","نومبر","دسمبر"]},days:["اتوار","پیر","منگل","بدھ","جمعرات","جمعہ","ہفتہ"]},vi:{language:"Vientnamese",months:{original:["Tháng 1","Tháng 2","Tháng 3","Tháng 4","Tháng 5","Tháng 6","Tháng 7","Tháng 8","Tháng 9","Tháng 10","Tháng 11","Tháng 12"],abbr:["T 01","T 02","T 03","T 04","T 05","T 06","T 07","T 08","T 09","T 10","T 11","T 12"]},days:["CN","Thứ 2","Thứ 3","Thứ 4","Thứ 5","Thứ 6","Thứ 7"]},zh:{language:"Chinese",ymd:!0,months:{original:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],abbr:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"]},days:["日","一","二","三","四","五","六"]}}}},function(e,t){var n={}.toString;e.exports=function(e){return n.call(e).slice(8,-1)}},function(e,t,n){var i=n(9),r=n(0).document,a=i(r)&&i(r.createElement);e.exports=function(e){return a?r.createElement(e):{}}},function(e,t,n){var i=n(0),r=n(13),a=n(50),o=n(4),s=function(e,t,n){var l,u,c,d=e&s.F,h=e&s.G,p=e&s.S,f=e&s.P,g=e&s.B,b=e&s.W,m=h?r:r[t]||(r[t]={}),v=m.prototype,y=h?i:p?i[t]:(i[t]||{}).prototype;h&&(n=t);for(l in n)(u=!d&&y&&void 0!==y[l])&&l in m||(c=u?y[l]:n[l],m[l]=h&&"function"!=typeof y[l]?n[l]:g&&u?a(c,i):b&&y[l]==c?function(e){var t=function(t,n,i){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,n)}return new e(t,n,i)}return e.apply(this,arguments)};return t.prototype=e.prototype,t}(c):f&&"function"==typeof c?a(Function.call,c):c,f&&((m.virtual||(m.virtual={}))[l]=c,e&s.R&&v&&!v[l]&&o(v,l,c)))};s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,s.U=64,s.R=128,e.exports=s},function(e,t,n){e.exports=!n(3)&&!n(8)(function(){return 7!=Object.defineProperty(n(28)("div"),"a",{get:function(){return 7}}).a})},function(e,t,n){"use strict";var i=n(17),r=n(29),a=n(36),o=n(4),s=n(1),l=n(16),u=n(55),c=n(19),d=n(62),h=n(6)("iterator"),p=!([].keys&&"next"in[].keys()),f=function(){return this};e.exports=function(e,t,n,g,b,m,v){u(n,t,g);var y,D,M,S=function(e){if(!p&&e in x)return x[e];switch(e){case"keys":case"values":return function(){return new n(this,e)}}return function(){return new n(this,e)}},w=t+" Iterator",_="values"==b,k=!1,x=e.prototype,O=x[h]||x["@@iterator"]||b&&x[b],J=O||S(b),F=b?_?S("entries"):J:void 0,A="Array"==t?x.entries||O:O;if(A&&(M=d(A.call(new e)))!==Object.prototype&&(c(M,w,!0),i||s(M,h)||o(M,h,f)),_&&O&&"values"!==O.name&&(k=!0,J=function(){return O.call(this)}),i&&!v||!p&&!k&&x[h]||o(x,h,J),l[t]=J,l[w]=f,b)if(y={values:_?J:S("values"),keys:m?J:S("keys"),entries:F},v)for(D in y)D in x||a(x,D,y[D]);else r(r.P+r.F*(p||k),t,y);return y}},function(e,t,n){var i=n(7),r=n(59),a=n(15),o=n(20)("IE_PROTO"),s=function(){},l=function(){var e,t=n(28)("iframe"),i=a.length;for(t.style.display="none",n(52).appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write("<script>document.F=Object<\/script>"),e.close(),l=e.F;i--;)delete l.prototype[a[i]];return l()};e.exports=Object.create||function(e,t){var n;return null!==e?(s.prototype=i(e),n=new s,s.prototype=null,n[o]=e):n=l(),void 0===t?n:r(n,t)}},function(e,t,n){var i=n(35),r=n(15).concat("length","prototype");t.f=Object.getOwnPropertyNames||function(e){return i(e,r)}},function(e,t){t.f=Object.getOwnPropertySymbols},function(e,t,n){var i=n(1),r=n(2),a=n(49)(!1),o=n(20)("IE_PROTO");e.exports=function(e,t){var n,s=r(e),l=0,u=[];for(n in s)n!=o&&i(s,n)&&u.push(n);for(;t.length>l;)i(s,n=t[l++])&&(~a(u,n)||u.push(n));return u}},function(e,t,n){e.exports=n(4)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(41),r=n(26);t.default={props:{value:{validator:function(e){return null===e||e instanceof Date||"string"==typeof e||"number"==typeof e}},name:String,refName:String,id:String,format:{type:[String,Function],default:"dd MMM yyyy"},language:{type:String,default:"en"},openDate:{validator:function(e){return null===e||e instanceof Date||"string"==typeof e}},fullMonthName:Boolean,disabled:Object,highlighted:Object,placeholder:String,inline:Boolean,calendarClass:[String,Object],inputClass:[String,Object],wrapperClass:[String,Object],mondayFirst:Boolean,clearButton:Boolean,clearButtonIcon:String,calendarButton:Boolean,calendarButtonIcon:String,calendarButtonIconContent:String,bootstrapStyling:Boolean,initialView:String,disabledPicker:Boolean,required:Boolean,minimumView:{type:String,default:"day"},maximumView:{type:String,default:"year"}},data:function(){return{pageTimestamp:(this.openDate?new Date(this.openDate):new Date).setDate(1),selectedDate:null,showDayView:!1,showMonthView:!1,showYearView:!1,calendarHeight:0}},watch:{value:function(e){this.setValue(e)},openDate:function(){this.setPageDate()},initialView:function(){this.setInitialView()}},computed:{computedInitialView:function(){return this.initialView?this.initialView:this.minimumView},pageDate:function(){return new Date(this.pageTimestamp)},formattedValue:function(){return this.selectedDate?"function"==typeof this.format?this.format(this.selectedDate):i.a.formatDate(new Date(this.selectedDate),this.format,this.translation):null},translation:function(){return r.a.translations[this.language]},currMonthName:function(){var e=this.fullMonthName?this.translation.months.original:this.translation.months.abbr;return i.a.getMonthNameAbbr(this.pageDate.getMonth(),e)},currYear:function(){return this.pageDate.getFullYear()},blankDays:function(){var e=this.pageDate,t=new Date(e.getFullYear(),e.getMonth(),1,e.getHours(),e.getMinutes());return this.mondayFirst?t.getDay()>0?t.getDay()-1:6:t.getDay()},daysOfWeek:function(){if(this.mondayFirst){var e=this.translation.days.slice();return e.push(e.shift()),e}return this.translation.days},days:function(){for(var e=this.pageDate,t=[],n=new Date(e.getFullYear(),e.getMonth(),1,e.getHours(),e.getMinutes()),r=i.a.daysInMonth(n.getFullYear(),n.getMonth()),a=0;a<r;a++)t.push({date:n.getDate(),timestamp:n.getTime(),isSelected:this.isSelectedDate(n),isDisabled:this.isDisabledDate(n),isHighlighted:this.isHighlightedDate(n),isHighlightStart:this.isHighlightStart(n),isHighlightEnd:this.isHighlightEnd(n),isToday:n.toDateString()===(new Date).toDateString(),isWeekend:0===n.getDay()||6===n.getDay(),isSaturday:6===n.getDay(),isSunday:0===n.getDay()}),n.setDate(n.getDate()+1);return t},months:function(){for(var e=this.pageDate,t=[],n=new Date(e.getFullYear(),0,e.getDate(),e.getHours(),e.getMinutes()),r=0;r<12;r++)t.push({month:i.a.getMonthName(r,this.translation.months.original),timestamp:n.getTime(),isSelected:this.isSelectedMonth(n),isDisabled:this.isDisabledMonth(n)}),n.setMonth(n.getMonth()+1);return t},years:function(){for(var e=this.pageDate,t=[],n=new Date(10*Math.floor(e.getFullYear()/10),e.getMonth(),e.getDate(),e.getHours(),e.getMinutes()),i=0;i<10;i++)t.push({year:n.getFullYear(),timestamp:n.getTime(),isSelected:this.isSelectedYear(n),isDisabled:this.isDisabledYear(n)}),n.setFullYear(n.getFullYear()+1);return t},calendarStyle:function(){return{position:this.isInline?"static":void 0}},isOpen:function(){return this.showDayView||this.showMonthView||this.showYearView},isInline:function(){return!!this.inline},isRtl:function(){return!0===this.translation.rtl},isYmd:function(){return!0===this.translation.ymd}},methods:{close:function(e){this.showDayView=this.showMonthView=this.showYearView=!1,this.isInline||(e&&this.$emit("closed"),document.removeEventListener("click",this.clickOutside,!1))},resetDefaultDate:function(){if(null===this.selectedDate)return void this.setPageDate();this.setPageDate(this.selectedDate)},showCalendar:function(){return!this.disabledPicker&&!this.isInline&&(this.isOpen?this.close(!0):(this.setInitialView(),void(this.isInline||this.$emit("opened"))))},setInitialView:function(){var e=this.computedInitialView;if(!this.allowedToShowView(e))throw new Error("initialView '"+this.initialView+"' cannot be rendered based on minimum '"+this.minimumView+"' and maximum '"+this.maximumView+"'");switch(e){case"year":this.showYearCalendar();break;case"month":this.showMonthCalendar();break;default:this.showDayCalendar()}},allowedToShowView:function(e){var t=["day","month","year"],n=t.indexOf(this.minimumView),i=t.indexOf(this.maximumView),r=t.indexOf(e);return r>=n&&r<=i},showDayCalendar:function(){if(!this.allowedToShowView("day"))return!1;this.close(),this.showDayView=!0,this.addOutsideClickListener()},showMonthCalendar:function(){if(!this.allowedToShowView("month"))return!1;this.close(),this.showMonthView=!0,this.addOutsideClickListener()},showYearCalendar:function(){if(!this.allowedToShowView("year"))return!1;this.close(),this.showYearView=!0,this.addOutsideClickListener()},addOutsideClickListener:function(){var e=this;this.isInline||setTimeout(function(){document.addEventListener("click",e.clickOutside,!1)},100)},setDate:function(e){var t=new Date(e);this.selectedDate=new Date(t),this.setPageDate(t),this.$emit("selected",new Date(t)),this.$emit("input",new Date(t))},clearDate:function(){this.selectedDate=null,this.$emit("selected",null),this.$emit("input",null),this.$emit("cleared")},selectDate:function(e){if(e.isDisabled)return this.$emit("selectedDisabled",e),!1;this.setDate(e.timestamp),this.isInline||this.close(!0)},selectMonth:function(e){if(e.isDisabled)return!1;var t=new Date(e.timestamp);this.allowedToShowView("day")?(this.setPageDate(t),this.$emit("changedMonth",e),this.showDayCalendar()):(this.setDate(t),this.isInline||this.close(!0))},selectYear:function(e){if(e.isDisabled)return!1;var t=new Date(e.timestamp);this.allowedToShowView("month")?(this.setPageDate(t),this.$emit("changedYear",e),this.showMonthCalendar()):(this.setDate(t),this.isInline||this.close(!0))},getPageDate:function(){return this.pageDate.getDate()},getPageMonth:function(){return this.pageDate.getMonth()},getPageYear:function(){return this.pageDate.getFullYear()},getPageDecade:function(){var e=10*Math.floor(this.pageDate.getFullYear()/10);return e+" - "+(e+9)},changeMonth:function(e){var t=this.pageDate;t.setMonth(t.getMonth()+e),this.setPageDate(t),this.$emit("changedMonth",t)},previousMonth:function(){this.previousMonthDisabled()||this.changeMonth(-1)},previousMonthDisabled:function(){if(!this.disabled||!this.disabled.to)return!1;var e=this.pageDate;return this.disabled.to.getMonth()>=e.getMonth()&&this.disabled.to.getFullYear()>=e.getFullYear()},nextMonth:function(){this.nextMonthDisabled()||this.changeMonth(1)},nextMonthDisabled:function(){if(!this.disabled||!this.disabled.from)return!1;var e=this.pageDate;return this.disabled.from.getMonth()<=e.getMonth()&&this.disabled.from.getFullYear()<=e.getFullYear()},changeYear:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"changedYear",n=this.pageDate;n.setYear(n.getFullYear()+e),this.setPageDate(n),this.$emit(t,n)},previousYear:function(){this.previousYearDisabled()||this.changeYear(-1)},previousYearDisabled:function(){return!(!this.disabled||!this.disabled.to)&&this.disabled.to.getFullYear()>=this.pageDate.getFullYear()},nextYear:function(){this.nextYearDisabled()||this.changeYear(1)},nextYearDisabled:function(){return!(!this.disabled||!this.disabled.from)&&this.disabled.from.getFullYear()<=this.pageDate.getFullYear()},previousDecade:function(){this.previousDecadeDisabled()||this.changeYear(-10,"changeDecade")},previousDecadeDisabled:function(){return!(!this.disabled||!this.disabled.to)&&10*Math.floor(this.disabled.to.getFullYear()/10)>=10*Math.floor(this.pageDate.getFullYear()/10)},nextDecade:function(){this.nextDecadeDisabled()||this.changeYear(10,"changeDecade")},nextDecadeDisabled:function(){return!(!this.disabled||!this.disabled.from)&&10*Math.ceil(this.disabled.from.getFullYear()/10)<=10*Math.ceil(this.pageDate.getFullYear()/10)},isSelectedDate:function(e){return this.selectedDate&&this.selectedDate.toDateString()===e.toDateString()},isDisabledDate:function(e){var t=!1;return void 0!==this.disabled&&(void 0!==this.disabled.dates&&this.disabled.dates.forEach(function(n){if(e.toDateString()===n.toDateString())return t=!0,!0}),void 0!==this.disabled.to&&this.disabled.to&&e<this.disabled.to&&(t=!0),void 0!==this.disabled.from&&this.disabled.from&&e>this.disabled.from&&(t=!0),void 0!==this.disabled.ranges&&this.disabled.ranges.forEach(function(n){if(void 0!==n.from&&n.from&&void 0!==n.to&&n.to&&e<n.to&&e>n.from)return t=!0,!0}),void 0!==this.disabled.days&&-1!==this.disabled.days.indexOf(e.getDay())&&(t=!0),void 0!==this.disabled.daysOfMonth&&-1!==this.disabled.daysOfMonth.indexOf(e.getDate())&&(t=!0),"function"==typeof this.disabled.customPredictor&&this.disabled.customPredictor(e)&&(t=!0),t)},isHighlightedDate:function(e){if((!this.highlighted||!this.highlighted.includeDisabled)&&this.isDisabledDate(e))return!1;var t=!1;return void 0!==this.highlighted&&(void 0!==this.highlighted.dates&&this.highlighted.dates.forEach(function(n){if(e.toDateString()===n.toDateString())return t=!0,!0}),this.isDefined(this.highlighted.from)&&this.isDefined(this.highlighted.to)&&(t=e>=this.highlighted.from&&e<=this.highlighted.to),void 0!==this.highlighted.days&&-1!==this.highlighted.days.indexOf(e.getDay())&&(t=!0),void 0!==this.highlighted.daysOfMonth&&-1!==this.highlighted.daysOfMonth.indexOf(e.getDate())&&(t=!0),"function"==typeof this.highlighted.customPredictor&&this.highlighted.customPredictor(e)&&(t=!0),t)},isHighlightStart:function(e){return this.isHighlightedDate(e)&&this.highlighted.from instanceof Date&&this.highlighted.from.getFullYear()===e.getFullYear()&&this.highlighted.from.getMonth()===e.getMonth()&&this.highlighted.from.getDate()===e.getDate()},isHighlightEnd:function(e){return this.isHighlightedDate(e)&&this.highlighted.to instanceof Date&&this.highlighted.to.getFullYear()===e.getFullYear()&&this.highlighted.to.getMonth()===e.getMonth()&&this.highlighted.to.getDate()===e.getDate()},isDefined:function(e){return void 0!==e&&e},isSelectedMonth:function(e){return this.selectedDate&&this.selectedDate.getFullYear()===e.getFullYear()&&this.selectedDate.getMonth()===e.getMonth()},isDisabledMonth:function(e){var t=!1;return void 0!==this.disabled&&(void 0!==this.disabled.to&&this.disabled.to&&(e.getMonth()<this.disabled.to.getMonth()&&e.getFullYear()<=this.disabled.to.getFullYear()||e.getFullYear()<this.disabled.to.getFullYear())&&(t=!0),void 0!==this.disabled.from&&this.disabled.from&&(this.disabled.from&&e.getMonth()>this.disabled.from.getMonth()&&e.getFullYear()>=this.disabled.from.getFullYear()||e.getFullYear()>this.disabled.from.getFullYear())&&(t=!0),t)},isSelectedYear:function(e){return this.selectedDate&&this.selectedDate.getFullYear()===e.getFullYear()},isDisabledYear:function(e){var t=!1;return!(void 0===this.disabled||!this.disabled)&&(void 0!==this.disabled.to&&this.disabled.to&&e.getFullYear()<this.disabled.to.getFullYear()&&(t=!0),void 0!==this.disabled.from&&this.disabled.from&&e.getFullYear()>this.disabled.from.getFullYear()&&(t=!0),t)},setValue:function(e){if("string"==typeof e||"number"==typeof e){var t=new Date(e);e=isNaN(t.valueOf())?null:t}if(!e)return this.setPageDate(),void(this.selectedDate=null);this.selectedDate=e,this.setPageDate(e)},setPageDate:function(e){e||(e=this.openDate?new Date(this.openDate):new Date),this.pageTimestamp=new Date(e).setDate(1)},clickOutside:function(e){if(this.$el&&!this.$el.contains(e.target)){if(this.isInline)return this.showDayCalendar();this.resetDefaultDate(),this.close(!0),document.removeEventListener("click",this.clickOutside,!1)}},dayClasses:function(e){return{selected:e.isSelected,disabled:e.isDisabled,highlighted:e.isHighlighted,today:e.isToday,weekend:e.isWeekend,sat:e.isSaturday,sun:e.isSunday,"highlight-start":e.isHighlightStart,"highlight-end":e.isHighlightEnd}},init:function(){this.value&&this.setValue(this.value),this.isInline&&this.setInitialView()}},mounted:function(){this.init()}}},function(e,t){e.exports=function(e,t,n,i,r){var a,o=e=e||{},s=typeof e.default;"object"!==s&&"function"!==s||(a=e,o=e.default);var l="function"==typeof o?o.options:o;t&&(l.render=t.render,l.staticRenderFns=t.staticRenderFns),i&&(l._scopeId=i);var u;if(r?(u=function(e){e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,e||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),n&&n.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(r)},l._ssrRegister=u):n&&(u=n),u){var c=l.functional,d=c?l.render:l.beforeCreate;c?l.render=function(e,t){return u.call(t),d(e,t)}:l.beforeCreate=d?[].concat(d,u):[u]}return{esModule:a,exports:o,options:l}}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vdp-datepicker",class:[e.wrapperClass,e.isRtl?"rtl":""]},[n("div",{class:{"input-group":e.bootstrapStyling}},[e.calendarButton?n("span",{staticClass:"vdp-datepicker__calendar-button",class:{"input-group-addon":e.bootstrapStyling},style:{"cursor:not-allowed;":e.disabledPicker},on:{click:e.showCalendar}},[n("i",{class:e.calendarButtonIcon},[e._v("\n        "+e._s(e.calendarButtonIconContent)+"\n        "),e.calendarButtonIcon?e._e():n("span",[e._v("…")])])]):e._e(),e._v(" "),n("input",{ref:e.refName,class:[e.inputClass,{"form-control":e.bootstrapStyling}],attrs:{type:e.inline?"hidden":"text",name:e.name,id:e.id,"open-date":e.openDate,placeholder:e.placeholder,"clear-button":e.clearButton,disabled:e.disabledPicker,required:e.required,readonly:""},domProps:{value:e.formattedValue},on:{click:e.showCalendar}}),e._v(" "),e.clearButton&&e.selectedDate?n("span",{staticClass:"vdp-datepicker__clear-button",class:{"input-group-addon":e.bootstrapStyling},on:{click:function(t){e.clearDate()}}},[n("i",{class:e.clearButtonIcon},[e.clearButtonIcon?e._e():n("span",[e._v("×")])])]):e._e()]),e._v(" "),e.allowedToShowView("day")?[n("div",{directives:[{name:"show",rawName:"v-show",value:e.showDayView,expression:"showDayView"}],class:[e.calendarClass,"vdp-datepicker__calendar"],style:e.calendarStyle},[n("header",[n("span",{staticClass:"prev",class:{disabled:e.isRtl?e.nextMonthDisabled(e.pageTimestamp):e.previousMonthDisabled(e.pageTimestamp)},on:{click:function(t){e.isRtl?e.nextMonth():e.previousMonth()}}},[e._v("<")]),e._v(" "),n("span",{class:e.allowedToShowView("month")?"up":"",on:{click:e.showMonthCalendar}},[e._v(e._s(e.isYmd?e.currYear:e.currMonthName)+" "+e._s(e.isYmd?e.currMonthName:e.currYear))]),e._v(" "),n("span",{staticClass:"next",class:{disabled:e.isRtl?e.previousMonthDisabled(e.pageTimestamp):e.nextMonthDisabled(e.pageTimestamp)},on:{click:function(t){e.isRtl?e.previousMonth():e.nextMonth()}}},[e._v(">")])]),e._v(" "),n("div",{class:e.isRtl?"flex-rtl":""},[e._l(e.daysOfWeek,function(t){return n("span",{key:t.timestamp,staticClass:"cell day-header"},[e._v(e._s(t))])}),e._v(" "),e.blankDays>0?e._l(e.blankDays,function(e){return n("span",{key:e.timestamp,staticClass:"cell day blank"})}):e._e(),e._l(e.days,function(t){return n("span",{key:t.timestamp,staticClass:"cell day",class:e.dayClasses(t),attrs:{"track-by":"timestamp"},on:{click:function(n){e.selectDate(t)}}},[e._v(e._s(t.date))])})],2)])]:e._e(),e._v(" "),e.allowedToShowView("month")?[n("div",{directives:[{name:"show",rawName:"v-show",value:e.showMonthView,expression:"showMonthView"}],class:[e.calendarClass,"vdp-datepicker__calendar"],style:e.calendarStyle},[n("header",[n("span",{staticClass:"prev",class:{disabled:e.previousYearDisabled(e.pageTimestamp)},on:{click:e.previousYear}},[e._v("<")]),e._v(" "),n("span",{class:e.allowedToShowView("year")?"up":"",on:{click:e.showYearCalendar}},[e._v(e._s(e.getPageYear()))]),e._v(" "),n("span",{staticClass:"next",class:{disabled:e.nextYearDisabled(e.pageTimestamp)},on:{click:e.nextYear}},[e._v(">")])]),e._v(" "),e._l(e.months,function(t){return n("span",{key:t.timestamp,staticClass:"cell month",class:{selected:t.isSelected,disabled:t.isDisabled},attrs:{"track-by":"timestamp"},on:{click:function(n){n.stopPropagation(),e.selectMonth(t)}}},[e._v(e._s(t.month))])})],2)]:e._e(),e._v(" "),e.allowedToShowView("year")?[n("div",{directives:[{name:"show",rawName:"v-show",value:e.showYearView,expression:"showYearView"}],class:[e.calendarClass,"vdp-datepicker__calendar"],style:e.calendarStyle},[n("header",[n("span",{staticClass:"prev",class:{disabled:e.previousDecadeDisabled(e.pageTimestamp)},on:{click:e.previousDecade}},[e._v("<")]),e._v(" "),n("span",[e._v(e._s(e.getPageDecade()))]),e._v(" "),n("span",{staticClass:"next",class:{disabled:e.nextMonthDisabled(e.pageTimestamp)},on:{click:e.nextDecade}},[e._v(">")])]),e._v(" "),e._l(e.years,function(t){return n("span",{key:t.timestamp,staticClass:"cell year",class:{selected:t.isSelected,disabled:t.isDisabled},attrs:{"track-by":"timestamp"},on:{click:function(n){n.stopPropagation(),e.selectYear(t)}}},[e._v(e._s(t.year))])})],2)]:e._e()],2)},staticRenderFns:[]}},function(e,t,n){var i=n(74);"string"==typeof i&&(i=[[e.i,i,""]]),i.locals&&(e.exports=i.locals);n(77)("7da62ad4",i,!0)},function(e,t,n){"use strict";var i=n(44),r=n.n(i),a=n(26);t.a={isValidDate:function(e){return"[object Date]"===Object.prototype.toString.call(e)&&!isNaN(e.getTime())},getDayNameAbbr:function(e,t){if("object"!==(void 0===e?"undefined":r()(e)))throw TypeError("Invalid Type");return t[e.getDay()]},getMonthName:function(e,t){if(!t)throw Error("missing 2nd parameter Months array");if("object"===(void 0===e?"undefined":r()(e)))return t[e.getMonth()];if("number"==typeof e)return t[e];throw TypeError("Invalid type")},getMonthNameAbbr:function(e,t){if(!t)throw Error("missing 2nd paramter Months array");if("object"===(void 0===e?"undefined":r()(e)))return t[e.getMonth()];if("number"==typeof e)return t[e];throw TypeError("Invalid type")},daysInMonth:function(e,t){return/8|3|5|10/.test(t)?30:1===t?(e%4||!(e%100))&&e%400?28:29:31},getNthSuffix:function(e){switch(e){case 1:case 21:case 31:return"st";case 2:case 22:return"nd";case 3:case 23:return"rd";default:return"th"}},formatDate:function(e,t,n){n=n||a.a.translations.en;var i=e.getFullYear(),r=e.getMonth()+1,o=e.getDate();return t.replace(/dd/,("0"+o).slice(-2)).replace(/d/,o).replace(/yyyy/,i).replace(/yy/,String(i).slice(2)).replace(/MMMM/,this.getMonthName(e.getMonth(),n.months.original)).replace(/MMM/,this.getMonthNameAbbr(e.getMonth(),n.months.abbr)).replace(/MM/,("0"+r).slice(-2)).replace(/M(?!a|ä|e)/,r).replace(/su/,this.getNthSuffix(e.getDate())).replace(/D(?!e|é|i)/,this.getDayNameAbbr(e,n.days))},createDateArray:function(e,t){for(var n=[];e<=t;)n.push(new Date(e)),e=new Date(e).setDate(new Date(e).getDate()+1);return n}}},function(e,t,n){e.exports={default:n(45),__esModule:!0}},function(e,t,n){e.exports={default:n(46),__esModule:!0}},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var r=n(43),a=i(r),o=n(42),s=i(o),l="function"==typeof s.default&&"symbol"==typeof a.default?function(e){return typeof e}:function(e){return e&&"function"==typeof s.default&&e.constructor===s.default&&e!==s.default.prototype?"symbol":typeof e};t.default="function"==typeof s.default&&"symbol"===l(a.default)?function(e){return void 0===e?"undefined":l(e)}:function(e){return e&&"function"==typeof s.default&&e.constructor===s.default&&e!==s.default.prototype?"symbol":void 0===e?"undefined":l(e)}},function(e,t,n){n(70),n(68),n(71),n(72),e.exports=n(13).Symbol},function(e,t,n){n(69),n(73),e.exports=n(25).f("iterator")},function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e}},function(e,t){e.exports=function(){}},function(e,t,n){var i=n(2),r=n(65),a=n(64);e.exports=function(e){return function(t,n,o){var s,l=i(t),u=r(l.length),c=a(o,u);if(e&&n!=n){for(;u>c;)if((s=l[c++])!=s)return!0}else for(;u>c;c++)if((e||c in l)&&l[c]===n)return e||c||0;return!e&&-1}}},function(e,t,n){var i=n(47);e.exports=function(e,t,n){if(i(e),void 0===t)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 2:return function(n,i){return e.call(t,n,i)};case 3:return function(n,i,r){return e.call(t,n,i,r)}}return function(){return e.apply(t,arguments)}}},function(e,t,n){var i=n(10),r=n(34),a=n(18);e.exports=function(e){var t=i(e),n=r.f;if(n)for(var o,s=n(e),l=a.f,u=0;s.length>u;)l.call(e,o=s[u++])&&t.push(o);return t}},function(e,t,n){e.exports=n(0).document&&document.documentElement},function(e,t,n){var i=n(27);e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==i(e)?e.split(""):Object(e)}},function(e,t,n){var i=n(27);e.exports=Array.isArray||function(e){return"Array"==i(e)}},function(e,t,n){"use strict";var i=n(32),r=n(11),a=n(19),o={};n(4)(o,n(6)("iterator"),function(){return this}),e.exports=function(e,t,n){e.prototype=i(o,{next:r(1,n)}),a(e,t+" Iterator")}},function(e,t){e.exports=function(e,t){return{value:t,done:!!e}}},function(e,t,n){var i=n(10),r=n(2);e.exports=function(e,t){for(var n,a=r(e),o=i(a),s=o.length,l=0;s>l;)if(a[n=o[l++]]===t)return n}},function(e,t,n){var i=n(12)("meta"),r=n(9),a=n(1),o=n(5).f,s=0,l=Object.isExtensible||function(){return!0},u=!n(8)(function(){return l(Object.preventExtensions({}))}),c=function(e){o(e,i,{value:{i:"O"+ ++s,w:{}}})},d=function(e,t){if(!r(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!a(e,i)){if(!l(e))return"F";if(!t)return"E";c(e)}return e[i].i},h=function(e,t){if(!a(e,i)){if(!l(e))return!0;if(!t)return!1;c(e)}return e[i].w},p=function(e){return u&&f.NEED&&l(e)&&!a(e,i)&&c(e),e},f=e.exports={KEY:i,NEED:!1,fastKey:d,getWeak:h,onFreeze:p}},function(e,t,n){var i=n(5),r=n(7),a=n(10);e.exports=n(3)?Object.defineProperties:function(e,t){r(e);for(var n,o=a(t),s=o.length,l=0;s>l;)i.f(e,n=o[l++],t[n]);return e}},function(e,t,n){var i=n(18),r=n(11),a=n(2),o=n(23),s=n(1),l=n(30),u=Object.getOwnPropertyDescriptor;t.f=n(3)?u:function(e,t){if(e=a(e),t=o(t,!0),l)try{return u(e,t)}catch(e){}if(s(e,t))return r(!i.f.call(e,t),e[t])}},function(e,t,n){var i=n(2),r=n(33).f,a={}.toString,o="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],s=function(e){try{return r(e)}catch(e){return o.slice()}};e.exports.f=function(e){return o&&"[object Window]"==a.call(e)?s(e):r(i(e))}},function(e,t,n){var i=n(1),r=n(66),a=n(20)("IE_PROTO"),o=Object.prototype;e.exports=Object.getPrototypeOf||function(e){return e=r(e),i(e,a)?e[a]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?o:null}},function(e,t,n){var i=n(22),r=n(14);e.exports=function(e){return function(t,n){var a,o,s=String(r(t)),l=i(n),u=s.length;return l<0||l>=u?e?"":void 0:(a=s.charCodeAt(l),a<55296||a>56319||l+1===u||(o=s.charCodeAt(l+1))<56320||o>57343?e?s.charAt(l):a:e?s.slice(l,l+2):o-56320+(a-55296<<10)+65536)}}},function(e,t,n){var i=n(22),r=Math.max,a=Math.min;e.exports=function(e,t){return e=i(e),e<0?r(e+t,0):a(e,t)}},function(e,t,n){var i=n(22),r=Math.min;e.exports=function(e){return e>0?r(i(e),9007199254740991):0}},function(e,t,n){var i=n(14);e.exports=function(e){return Object(i(e))}},function(e,t,n){"use strict";var i=n(48),r=n(56),a=n(16),o=n(2);e.exports=n(31)(Array,"Array",function(e,t){this._t=o(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,n=this._i++;return!e||n>=e.length?(this._t=void 0,r(1)):"keys"==t?r(0,n):"values"==t?r(0,e[n]):r(0,[n,e[n]])},"values"),a.Arguments=a.Array,i("keys"),i("values"),i("entries")},function(e,t){},function(e,t,n){"use strict";var i=n(63)(!0);n(31)(String,"String",function(e){this._t=String(e),this._i=0},function(){var e,t=this._t,n=this._i;return n>=t.length?{value:void 0,done:!0}:(e=i(t,n),this._i+=e.length,{value:e,done:!1})})},function(e,t,n){"use strict";var i=n(0),r=n(1),a=n(3),o=n(29),s=n(36),l=n(58).KEY,u=n(8),c=n(21),d=n(19),h=n(12),p=n(6),f=n(25),g=n(24),b=n(57),m=n(51),v=n(54),y=n(7),D=n(2),M=n(23),S=n(11),w=n(32),_=n(61),k=n(60),x=n(5),O=n(10),J=k.f,F=x.f,A=_.f,j=i.Symbol,T=i.JSON,N=T&&T.stringify,Y=p("_hidden"),C=p("toPrimitive"),P={}.propertyIsEnumerable,V=c("symbol-registry"),E=c("symbols"),I=c("op-symbols"),L=Object.prototype,z="function"==typeof j,B=i.QObject,R=!B||!B.prototype||!B.prototype.findChild,H=a&&u(function(){return 7!=w(F({},"a",{get:function(){return F(this,"a",{value:7}).a}})).a})?function(e,t,n){var i=J(L,t);i&&delete L[t],F(e,t,n),i&&e!==L&&F(L,t,i)}:F,G=function(e){var t=E[e]=w(j.prototype);return t._k=e,t},$=z&&"symbol"==typeof j.iterator?function(e){return"symbol"==typeof e}:function(e){return e instanceof j},U=function(e,t,n){return e===L&&U(I,t,n),y(e),t=M(t,!0),y(n),r(E,t)?(n.enumerable?(r(e,Y)&&e[Y][t]&&(e[Y][t]=!1),n=w(n,{enumerable:S(0,!1)})):(r(e,Y)||F(e,Y,S(1,{})),e[Y][t]=!0),H(e,t,n)):F(e,t,n)},K=function(e,t){y(e);for(var n,i=m(t=D(t)),r=0,a=i.length;a>r;)U(e,n=i[r++],t[n]);return e},W=function(e,t){return void 0===t?w(e):K(w(e),t)},q=function(e){var t=P.call(this,e=M(e,!0));return!(this===L&&r(E,e)&&!r(I,e))&&(!(t||!r(this,e)||!r(E,e)||r(this,Y)&&this[Y][e])||t)},X=function(e,t){if(e=D(e),t=M(t,!0),e!==L||!r(E,t)||r(I,t)){var n=J(e,t);return!n||!r(E,t)||r(e,Y)&&e[Y][t]||(n.enumerable=!0),n}},Q=function(e){for(var t,n=A(D(e)),i=[],a=0;n.length>a;)r(E,t=n[a++])||t==Y||t==l||i.push(t);return i},Z=function(e){for(var t,n=e===L,i=A(n?I:D(e)),a=[],o=0;i.length>o;)!r(E,t=i[o++])||n&&!r(L,t)||a.push(E[t]);return a};z||(j=function(){if(this instanceof j)throw TypeError("Symbol is not a constructor!");var e=h(arguments.length>0?arguments[0]:void 0),t=function(n){this===L&&t.call(I,n),r(this,Y)&&r(this[Y],e)&&(this[Y][e]=!1),H(this,e,S(1,n))};return a&&R&&H(L,e,{configurable:!0,set:t}),G(e)},s(j.prototype,"toString",function(){return this._k}),k.f=X,x.f=U,n(33).f=_.f=Q,n(18).f=q,n(34).f=Z,a&&!n(17)&&s(L,"propertyIsEnumerable",q,!0),f.f=function(e){return G(p(e))}),o(o.G+o.W+o.F*!z,{Symbol:j});for(var ee="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),te=0;ee.length>te;)p(ee[te++]);for(var ee=O(p.store),te=0;ee.length>te;)g(ee[te++]);o(o.S+o.F*!z,"Symbol",{for:function(e){return r(V,e+="")?V[e]:V[e]=j(e)},keyFor:function(e){if($(e))return b(V,e);throw TypeError(e+" is not a symbol!")},useSetter:function(){R=!0},useSimple:function(){R=!1}}),o(o.S+o.F*!z,"Object",{create:W,defineProperty:U,defineProperties:K,getOwnPropertyDescriptor:X,getOwnPropertyNames:Q,getOwnPropertySymbols:Z}),T&&o(o.S+o.F*(!z||u(function(){var e=j();return"[null]"!=N([e])||"{}"!=N({a:e})||"{}"!=N(Object(e))})),"JSON",{stringify:function(e){if(void 0!==e&&!$(e)){for(var t,n,i=[e],r=1;arguments.length>r;)i.push(arguments[r++]);return t=i[1],"function"==typeof t&&(n=t),!n&&v(t)||(t=function(e,t){if(n&&(t=n.call(this,e,t)),!$(t))return t}),i[1]=t,N.apply(T,i)}}}),j.prototype[C]||n(4)(j.prototype,C,j.prototype.valueOf),d(j,"Symbol"),d(Math,"Math",!0),d(i.JSON,"JSON",!0)},function(e,t,n){n(24)("asyncIterator")},function(e,t,n){n(24)("observable")},function(e,t,n){n(67);for(var i=n(0),r=n(4),a=n(16),o=n(6)("toStringTag"),s=["NodeList","DOMTokenList","MediaList","StyleSheetList","CSSRuleList"],l=0;l<5;l++){var u=s[l],c=i[u],d=c&&c.prototype;d&&!d[o]&&r(d,o,u),a[u]=a.Array}},function(e,t,n){t=e.exports=n(75)(!1),t.push([e.i,'.rtl{direction:rtl}.vdp-datepicker{position:relative;text-align:left}.vdp-datepicker *{box-sizing:border-box}.vdp-datepicker__calendar{position:absolute;z-index:100;background:#fff;width:300px;border:1px solid #ccc}.vdp-datepicker__calendar header{display:block;line-height:40px}.vdp-datepicker__calendar header span{display:inline-block;text-align:center;width:71.42857142857143%;float:left}.vdp-datepicker__calendar header .next,.vdp-datepicker__calendar header .prev{width:14.285714285714286%;float:left;text-indent:-10000px;position:relative}.vdp-datepicker__calendar header .next:after,.vdp-datepicker__calendar header .prev:after{content:"";position:absolute;left:50%;top:50%;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%);border:6px solid transparent}.vdp-datepicker__calendar header .prev:after{border-right:10px solid #000;margin-left:-5px}.vdp-datepicker__calendar header .prev.disabled:after{border-right:10px solid #ddd}.vdp-datepicker__calendar header .next:after{border-left:10px solid #000;margin-left:5px}.vdp-datepicker__calendar header .next.disabled:after{border-left:10px solid #ddd}.vdp-datepicker__calendar header .next:not(.disabled),.vdp-datepicker__calendar header .prev:not(.disabled),.vdp-datepicker__calendar header .up:not(.disabled){cursor:pointer}.vdp-datepicker__calendar header .next:not(.disabled):hover,.vdp-datepicker__calendar header .prev:not(.disabled):hover,.vdp-datepicker__calendar header .up:not(.disabled):hover{background:#eee}.vdp-datepicker__calendar .disabled{color:#ddd;cursor:default}.vdp-datepicker__calendar .flex-rtl{display:-webkit-box;display:-ms-flexbox;display:flex;width:inherit;-ms-flex-wrap:wrap;flex-wrap:wrap}.vdp-datepicker__calendar .cell{display:inline-block;padding:0 5px;width:14.285714285714286%;height:40px;line-height:40px;text-align:center;vertical-align:middle;border:1px solid transparent}.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year{cursor:pointer}.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover{border:1px solid #4bd}.vdp-datepicker__calendar .cell.selected,.vdp-datepicker__calendar .cell.selected.highlighted,.vdp-datepicker__calendar .cell.selected:hover{background:#4bd}.vdp-datepicker__calendar .cell.highlighted{background:#cae5ed}.vdp-datepicker__calendar .cell.highlighted.disabled{color:#a3a3a3}.vdp-datepicker__calendar .cell.grey{color:#888}.vdp-datepicker__calendar .cell.grey:hover{background:inherit}.vdp-datepicker__calendar .cell.day-header{font-size:75%;white-space:no-wrap;cursor:inherit}.vdp-datepicker__calendar .cell.day-header:hover{background:inherit}.vdp-datepicker__calendar .month,.vdp-datepicker__calendar .year{width:33.333%}.vdp-datepicker__calendar-button,.vdp-datepicker__clear-button{cursor:pointer;font-style:normal}.vdp-datepicker__calendar-button.disabled,.vdp-datepicker__clear-button.disabled{color:#999;cursor:default}',""])},function(e,t){function n(e,t){var n=e[1]||"",r=e[3];if(!r)return n;if(t&&"function"==typeof btoa){var a=i(r);return[n].concat(r.sources.map(function(e){return"/*# sourceURL="+r.sourceRoot+e+" */"})).concat([a]).join("\n")}return[n].join("\n")}function i(e){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(e))))+" */"}e.exports=function(e){var t=[];return t.toString=function(){return this.map(function(t){var i=n(t,e);return t[2]?"@media "+t[2]+"{"+i+"}":i}).join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var i={},r=0;r<this.length;r++){var a=this[r][0];"number"==typeof a&&(i[a]=!0)}for(r=0;r<e.length;r++){var o=e[r];"number"==typeof o[0]&&i[o[0]]||(n&&!o[2]?o[2]=n:n&&(o[2]="("+o[2]+") and ("+n+")"),t.push(o))}},t}},function(e,t,n){function i(e){n(40)}var r=n(38)(n(37),n(39),i,null,null);e.exports=r.exports},function(e,t,n){function i(e){for(var t=0;t<e.length;t++){var n=e[t],i=c[n.id];if(i){i.refs++;for(var r=0;r<i.parts.length;r++)i.parts[r](n.parts[r]);for(;r<n.parts.length;r++)i.parts.push(a(n.parts[r]));i.parts.length>n.parts.length&&(i.parts.length=n.parts.length)}else{for(var o=[],r=0;r<n.parts.length;r++)o.push(a(n.parts[r]));c[n.id]={id:n.id,refs:1,parts:o}}}}function r(){var e=document.createElement("style");return e.type="text/css",d.appendChild(e),e}function a(e){var t,n,i=document.querySelector('style[data-vue-ssr-id~="'+e.id+'"]');if(i){if(f)return g;i.parentNode.removeChild(i)}if(b){var a=p++;i=h||(h=r()),t=o.bind(null,i,a,!1),n=o.bind(null,i,a,!0)}else i=r(),t=s.bind(null,i),n=function(){i.parentNode.removeChild(i)};return t(e),function(i){if(i){if(i.css===e.css&&i.media===e.media&&i.sourceMap===e.sourceMap)return;t(e=i)}else n()}}function o(e,t,n,i){var r=n?"":i.css;if(e.styleSheet)e.styleSheet.cssText=m(t,r);else{var a=document.createTextNode(r),o=e.childNodes;o[t]&&e.removeChild(o[t]),o.length?e.insertBefore(a,o[t]):e.appendChild(a)}}function s(e,t){var n=t.css,i=t.media,r=t.sourceMap;if(i&&e.setAttribute("media",i),r&&(n+="\n/*# sourceURL="+r.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */"),e.styleSheet)e.styleSheet.cssText=n;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}var l="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!l)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var u=n(78),c={},d=l&&(document.head||document.getElementsByTagName("head")[0]),h=null,p=0,f=!1,g=function(){},b="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());e.exports=function(e,t,n){f=n;var r=u(e,t);return i(r),function(t){for(var n=[],a=0;a<r.length;a++){var o=r[a],s=c[o.id];s.refs--,n.push(s)}t?(r=u(e,t),i(r)):r=[];for(var a=0;a<n.length;a++){var s=n[a];if(0===s.refs){for(var l=0;l<s.parts.length;l++)s.parts[l]();delete c[s.id]}}}};var m=function(){var e=[];return function(t,n){return e[t]=n,e.filter(Boolean).join("\n")}}()},function(e,t){e.exports=function(e,t){for(var n=[],i={},r=0;r<t.length;r++){var a=t[r],o=a[0],s=a[1],l=a[2],u=a[3],c={id:e+":"+r,css:s,media:l,sourceMap:u};i[o]?i[o].parts.push(c):n.push(i[o]={id:o,parts:[c]})}return n}}]);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  timeFormat: function timeFormat(VueApp, withSeconds) {
    if (withSeconds) {
      return VueApp.$settings.config && VueApp.$settings.get('MilitaryTimeBackoffice') === 1 ? 'HH:mm:ss' : 'hh:mm:ss A';
    }
    return VueApp.$settings.config && VueApp.$settings.get('MilitaryTimeBackoffice') === 1 ? 'HH:mm' : 'hh:mmA';
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



/* harmony default export */ __webpack_exports__["a"] = ({
  getServiceName: function getServiceName(serviceType) {
    switch (serviceType) {
      case 'shared':
        return 'Shared Ride';
      case 'opoli':
        return 'Direct Non-stop';
      case 'black':
        return 'Sedan';
      case 'SUV':
        return 'SUV';
      case 'suv':
        return 'SUV';
      case 'shuttle':
        return 'Private Van';
      case 'private shuttle':
        return 'Private Van';
    }
  },
  getServiceData: function getServiceData(VueApp, id) {
    var services = VueApp.$store.state.services.list;
    if (!services.length) {
      return 'Service Not Yet Loaded';
    }

    var index = services.findIndex(function (x) {
      return x.id === id;
    });
    if (index > -1) {
      return services[index];
    }
    return 'Can\' find service';
  },
  getAllService: function getAllService(VueApp, callback) {
    VueApp.$sdk.get('/service?cache=' + __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('x'), {
      token: VueApp.$store.state.session.sessionToken,
      all: 1,
      order: 'priority'
    }, function (r) {
      VueApp.$store.commit('services/clearService');
      if (!r.error) {
        r.list.forEach(function (service) {
          if (service.brandId) {
            delete service.modified;
            delete service.schema;
            service.image = service.image || '';
            service.imageOff = service.imageOff || '';
            service.excerptWeb = service.excerptWeb || '';
            service.descriptionWeb = service.descriptionWeb || '';
            service.advantageWeb = service.advantageWeb || '';
            service.stops = service.stops || '';
            service.category = service.category || '';
            service.excerptApp = service.excerptApp || '';
            service.descriptionApp = service.descriptionApp || '';
            service.advantageApp = service.advantageApp || '';
            service.slogan = service.slogan || '';
            service.useShifts = service.useShifts || '';
            service.defaultTip = service.defaultTip || 0;
            var unavailableTimes = [];
            if (service.unavailableTimes) {
              service.unavailableTimes.forEach(function (x) {
                unavailableTimes.push(__WEBPACK_IMPORTED_MODULE_1_moment___default()(x.start, 'X').format('MM/DD/YYYY'));
              });
            }
            var images = [];
            if (service.images) {
              service.images.forEach(function (x) {
                images.push(x);
              });
            }
            service.unavailableTimes = unavailableTimes;
            service.images = images;
            service.unavailableTimP2p = service.unavailableTimeP2P || false;
            service.unavailableTimFromAirport = service.unavailableTimeFromAirport || false;
            service.unavailableTimToAirport = service.unavailableTimeToAirport || false;
            service.unavailableTimeStart = service.unavailableTimeStart || 0;
            service.unavailableTimeEnd = service.unavailableTimeEnd || 0;
            VueApp.$store.commit('services/addService', service);
          }
        });
      }
      callback(r);
    }, '2.0');
  },
  updatePosition: function updatePosition(VueApp, data, callback) {
    VueApp.$sdk.post('/service/' + data.id, {
      token: VueApp.$store.state.session.sessionToken,
      priority: data.priority
    }, function (r) {
      callback(r);
    }, '2.0');
  },
  toggleServiceEnable: function toggleServiceEnable(VueApp, data, callback) {
    VueApp.$sdk.post('/service/' + data.id, {
      token: VueApp.$store.state.session.sessionToken,
      enabled: data.enabled
    }, function (r) {
      if (!r.error) {
        VueApp.$store.commit('services/setServiceEnable', data);
      }
      callback(r);
    }, '2.0');
  },
  addService: function addService(VueApp, callback) {
    var serviceStore = VueApp.$store.state.services;
    var service = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, serviceStore.details);
    delete service.id;
    delete service.brandId;
    service.brandId = serviceStore.brandId;
    service.token = VueApp.$store.state.session.sessionToken;
    var newUnavailableTimes = [];
    service.unavailableTimes.forEach(function (x) {
      var temp = __WEBPACK_IMPORTED_MODULE_1_moment___default()(x, 'MM/DD/YYYY');
      newUnavailableTimes.push({
        start: __WEBPACK_IMPORTED_MODULE_1_moment___default()(temp.format('MM/DD/YYYY') + ' 00:00:00', 'MM/DD/YYYY hh:mm:ss').format('X'),
        end: __WEBPACK_IMPORTED_MODULE_1_moment___default()(temp.format('MM/DD/YYYY') + ' 23:59:59', 'MM/DD/YYYY hh:mm:ss').format('X')
      });
    });
    service.unavailableTimes = newUnavailableTimes;
    if (service.optinPercent) {
      service.optinPercent = parseFloat(service.optinPercent);
    }
    var serviceUnavailable = serviceStore.serviceUnavailable;
    service.unavailableTimeP2P = serviceUnavailable.p2p;
    service.unavailableTimeFromAirport = serviceUnavailable.fromAirport;
    service.unavailableTimeToAirport = serviceUnavailable.toAirport;
    service.unavailableTimeStart = serviceUnavailable.startTime;
    service.unavailableTimeEnd = serviceUnavailable.endTime;
    VueApp.$sdk.post('/service', service, function (r) {
      if (!r.error) {
        VueApp.$store.commit('services/setDetailsData', {
          field: 'id',
          value: r.id
        });
        VueApp.$store.commit('services/setServiceId', r.id);
      }
      callback(r);
    }, '2.0');
  },
  updateService: function updateService(VueApp, data, callback) {
    data.token = VueApp.$store.state.session.sessionToken;
    var newData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, data);
    var newUnavailableTimes = [];
    data.unavailableTimes.forEach(function (x) {
      var temp = __WEBPACK_IMPORTED_MODULE_1_moment___default()(x, 'MM/DD/YYYY');
      newUnavailableTimes.push({
        start: __WEBPACK_IMPORTED_MODULE_1_moment___default()(temp.format('MM/DD/YYYY') + ' 00:00:00', 'MM/DD/YYYY hh:mm:ss').format('X'),
        end: __WEBPACK_IMPORTED_MODULE_1_moment___default()(temp.format('MM/DD/YYYY') + ' 23:59:59', 'MM/DD/YYYY hh:mm:ss').format('X')
      });
    });
    newData.unavailableTimes = newUnavailableTimes;
    if (newData.optinPercent) {
      newData.optinPercent = parseFloat(newData.optinPercent);
    }
    var serviceUnavailable = VueApp.$store.state.services.serviceUnavailable;
    newData.unavailableTimeAsap = serviceUnavailable.asap;
    newData.unavailableTimeFuture = serviceUnavailable.future;
    newData.unavailableTimeP2P = serviceUnavailable.p2p;
    newData.unavailableTimeFromAirport = serviceUnavailable.fromAirport;
    newData.unavailableTimeToAirport = serviceUnavailable.toAirport;
    newData.unavailableTimeStart = serviceUnavailable.startTime;
    newData.unavailableTimeEnd = serviceUnavailable.endTime;
    VueApp.$sdk.post('/service/' + data.id, newData, function (r) {
      callback(r);
    }, '2.0');
  },
  cloneService: function cloneService(VueApp, brandId, callback) {
    var service = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, VueApp.$store.state.services.details);
    delete service.id;
    delete service.brandId;
    service.brandId = brandId;
    service.enabled = false;
    service.token = VueApp.$store.state.session.sessionToken;
    VueApp.$sdk.post('/service', service, function (r) {
      if (!r.error) {
        service.id = r.id;
        delete service.token;
        VueApp.$store.commit('services/addService', service);
      }
      callback(r);
    }, '2.0');
  },
  getEnabledDrivers: function getEnabledDrivers(VueApp, service, callback) {
    VueApp.$sdk.get('/service/' + VueApp.$store.state.services.details.id + '/providers', {
      token: VueApp.$store.state.session.sessionToken
    }, function (r) {
      if (!r.error) {
        var drivers = [];
        var initDrivers = [];
        r.list.forEach(function (x) {
          drivers.push(x.ID);
          initDrivers.push(x.ID);
        });
        VueApp.$store.commit('services/setEnabledDrivers', drivers);
        var listed = VueApp.$store.state.services.users.list.map(function (x) {
          return x.id;
        });
        if (listed.every(function (x) {
          return drivers.includes(x);
        })) {
          VueApp.$store.commit('services/setCheck', true);
        } else {
          VueApp.$store.commit('services/setCheck', false);
        }
        VueApp.$store.commit('services/setInitialData', initDrivers);
      }
      callback(r);
    }, '2.0');
  },
  updateEnabledDrivers: function updateEnabledDrivers(VueApp, service, callback) {
    var drivers = [];
    var initData = VueApp.$store.state.services.initialData;
    var enabled = VueApp.$store.state.services.enabledDrivers;
    initData.filter(function (x) {
      if (!enabled.includes(x)) {
        drivers.push({ 'id': x, 'enabled': false });
      }
    });
    enabled.forEach(function (x) {
      return drivers.push({ 'id': x, 'enabled': true });
    });
    VueApp.$sdk.post('/service/' + VueApp.$store.state.services.details.id + '/providers', {
      token: VueApp.$store.state.session.sessionToken,
      providers: drivers
    }, function (r) {
      if (!r.error) {
        var _drivers = [];
        r.list.forEach(function (x) {
          return _drivers.push(x.ID);
        });
        VueApp.$store.commit('services/setEnabledDrivers', _drivers);
        // VueApp.$store.commit('services/setInitialData', drivers)
      }
      callback(r);
    }, '2.0');
  }
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(697), __esModule: true };

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(817), __esModule: true };

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.CsvExport=t():e.CsvExport=t()}(window,function(){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=3)}([function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.download=function(e,t){if(navigator.msSaveBlob)return void navigator.msSaveBlob(e,t);var n=document.createElement("A"),r=URL.createObjectURL(e);n.href=r,n.download=t,n.style.display="none",document.body.appendChild(n),n.click(),document.body.removeChild(n)},t.noOp=function(e){return e},t.merge=function(e,t){if("function"==typeof Object.assign)Object.assign(e,t);else if(null!=t)for(var n in t)e[n]=t[n]}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();var o=function(){function e(t,n,r){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this._delimiter=t,this._contentType=n,this._byteOrderMark=r,this._rows=[]}return r(e,[{key:"_quote",value:function(e){return'"'+e.replace(/"/g,'""')+'"'}},{key:"pushValue",value:function(e){var t=null===e||void 0===e?"":String(e),n=-1!==t.indexOf(this._delimiter)||/["\r\n]/.test(t);this._currentRow.push(n?this._quote(t):t)}},{key:"pushRow",value:function(){this._rows.push([])}},{key:"toString",value:function(){var e=this;return this._rows.map(function(t){return t.join(e._delimiter)}).reduce(function(e,t){return e+"\r\n"+t})}},{key:"toBlob",value:function(){var e=this._byteOrderMark?[this._byteOrderMark,this.toString()]:[this.toString()];return new Blob(e,{type:this._contentType})}},{key:"_currentRow",get:function(){return this._rows[this._rows.length-1]}}]),e}();t.default=o},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r,o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(1),i=(r=u)&&r.__esModule?r:{default:r},a=n(0);var c=function(){function e(t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this._options={delimiter:",",contentType:"text/csv",headers:{},formatters:{},includeHeaders:!0},(0,a.merge)(this._options,t)}return o(e,[{key:"createCsvBlob",value:function(e){var t=this._options,n=t.delimiter,r=t.contentType,o=t.headers,u=t.formatters,c=t.includeHeaders,l=t.byteOrderMark,f=t.columns,s=new i.default(n,r,l),d=f||Object.getOwnPropertyNames(e[0]);return c&&(s.pushRow(),d.forEach(function(e){return s.pushValue(o[e]||e)})),e.forEach(function(e){s.pushRow(),d.forEach(function(t){return s.pushValue((u[t]||a.noOp)(e[t]))})}),s.toBlob()}},{key:"downloadCsv",value:function(e){if(!e)throw new Error("No data provided. File would be empty.");var t=this._options.filename,n=this.createCsvBlob(e);(0,a.download)(n,t)}}]),e}();t.default=c},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.CsvExport=void 0,t.create=i,t.download=a;var r,o=n(2),u=(r=o)&&r.__esModule?r:{default:r};function i(e){return new u.default(e)}function a(e){return(new u.default).downloadCsv(e)}t.CsvExport=u.default,t.default={create:i,download:a,CsvExport:u.default}}])});

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(1104);
moment.tz.load(__webpack_require__(1105));


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArrayProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ObjProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SymbolProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return push; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return toString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return hasOwnProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return supportsArrayBuffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return supportsDataView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return nativeIsArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return nativeKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return nativeCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return nativeIsView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _isNaN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _isFinite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return hasEnumBug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return nonEnumerableProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_ARRAY_INDEX; });
// Current version.
var VERSION = '1.13.2';

// Establish the root object, `window` (`self`) in the browser, `global`
// on the server, or `this` in some virtual machines. We use `self`
// instead of `window` for `WebWorker` support.
var root = typeof self == 'object' && self.self === self && self ||
          typeof global == 'object' && global.global === global && global ||
          Function('return this')() ||
          {};

// Save bytes in the minified (but not gzipped) version:
var ArrayProto = Array.prototype, ObjProto = Object.prototype;
var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

// Create quick reference variables for speed access to core prototypes.
var push = ArrayProto.push,
    slice = ArrayProto.slice,
    toString = ObjProto.toString,
    hasOwnProperty = ObjProto.hasOwnProperty;

// Modern feature detection.
var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
    supportsDataView = typeof DataView !== 'undefined';

// All **ECMAScript 5+** native function implementations that we hope to use
// are declared here.
var nativeIsArray = Array.isArray,
    nativeKeys = Object.keys,
    nativeCreate = Object.create,
    nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;

// Create references to these builtin functions because we override them.
var _isNaN = isNaN,
    _isFinite = isFinite;

// Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
  'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

// The largest integer that can be represented exactly.
var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(22)))

/***/ }),
/* 12 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Browser Request
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// UMD HEADER START 
(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like enviroments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        // Browser globals (root is window)
        root.returnExports = factory();
  }
}(this, function () {
// UMD HEADER END

var XHR = XMLHttpRequest
if (!XHR) throw new Error('missing XMLHttpRequest')
request.log = {
  'trace': noop, 'debug': noop, 'info': noop, 'warn': noop, 'error': noop
}

var DEFAULT_TIMEOUT = 3 * 60 * 1000 // 3 minutes

//
// request
//

function request(options, callback) {
  // The entry-point to the API: prep the options object and pass the real work to run_xhr.
  if(typeof callback !== 'function')
    throw new Error('Bad callback given: ' + callback)

  if(!options)
    throw new Error('No options given')

  var options_onResponse = options.onResponse; // Save this for later.

  if(typeof options === 'string')
    options = {'uri':options};
  else
    options = JSON.parse(JSON.stringify(options)); // Use a duplicate for mutating.

  options.onResponse = options_onResponse // And put it back.

  if (options.verbose) request.log = getLogger();

  if(options.url) {
    options.uri = options.url;
    delete options.url;
  }

  if(!options.uri && options.uri !== "")
    throw new Error("options.uri is a required argument");

  if(typeof options.uri != "string")
    throw new Error("options.uri must be a string");

  var unsupported_options = ['proxy', '_redirectsFollowed', 'maxRedirects', 'followRedirect']
  for (var i = 0; i < unsupported_options.length; i++)
    if(options[ unsupported_options[i] ])
      throw new Error("options." + unsupported_options[i] + " is not supported")

  options.callback = callback
  options.method = options.method || 'GET';
  options.headers = options.headers || {};
  options.body    = options.body || null
  options.timeout = options.timeout || request.DEFAULT_TIMEOUT

  if(options.headers.host)
    throw new Error("Options.headers.host is not supported");

  if(options.json) {
    options.headers.accept = options.headers.accept || 'application/json'
    if(options.method !== 'GET')
      options.headers['content-type'] = 'application/json'

    if(typeof options.json !== 'boolean')
      options.body = JSON.stringify(options.json)
    else if(typeof options.body !== 'string')
      options.body = JSON.stringify(options.body)
  }
  
  //BEGIN QS Hack
  var serialize = function(obj) {
    var str = [];
    for(var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  }
  
  if(options.qs){
    var qs = (typeof options.qs == 'string')? options.qs : serialize(options.qs);
    if(options.uri.indexOf('?') !== -1){ //no get params
        options.uri = options.uri+'&'+qs;
    }else{ //existing get params
        options.uri = options.uri+'?'+qs;
    }
  }
  //END QS Hack
  
  //BEGIN FORM Hack
  var multipart = function(obj) {
    //todo: support file type (useful?)
    var result = {};
    result.boundry = '-------------------------------'+Math.floor(Math.random()*1000000000);
    var lines = [];
    for(var p in obj){
        if (obj.hasOwnProperty(p)) {
            lines.push(
                '--'+result.boundry+"\n"+
                'Content-Disposition: form-data; name="'+p+'"'+"\n"+
                "\n"+
                obj[p]+"\n"
            );
        }
    }
    lines.push( '--'+result.boundry+'--' );
    result.body = lines.join('');
    result.length = result.body.length;
    result.type = 'multipart/form-data; boundary='+result.boundry;
    return result;
  }
  
  if(options.form){
    if(typeof options.form == 'string') throw('form name unsupported');
    if(options.method === 'POST'){
        var encoding = (options.encoding || 'application/x-www-form-urlencoded').toLowerCase();
        options.headers['content-type'] = encoding;
        switch(encoding){
            case 'application/x-www-form-urlencoded':
                options.body = serialize(options.form).replace(/%20/g, "+");
                break;
            case 'multipart/form-data':
                var multi = multipart(options.form);
                //options.headers['content-length'] = multi.length;
                options.body = multi.body;
                options.headers['content-type'] = multi.type;
                break;
            default : throw new Error('unsupported encoding:'+encoding);
        }
    }
  }
  //END FORM Hack

  // If onResponse is boolean true, call back immediately when the response is known,
  // not when the full request is complete.
  options.onResponse = options.onResponse || noop
  if(options.onResponse === true) {
    options.onResponse = callback
    options.callback = noop
  }

  // XXX Browsers do not like this.
  //if(options.body)
  //  options.headers['content-length'] = options.body.length;

  // HTTP basic authentication
  if(!options.headers.authorization && options.auth)
    options.headers.authorization = 'Basic ' + b64_enc(options.auth.username + ':' + options.auth.password);

  return run_xhr(options)
}

var req_seq = 0
function run_xhr(options) {
  var xhr = new XHR
    , timed_out = false
    , is_cors = is_crossDomain(options.uri)
    , supports_cors = ('withCredentials' in xhr)

  req_seq += 1
  xhr.seq_id = req_seq
  xhr.id = req_seq + ': ' + options.method + ' ' + options.uri
  xhr._id = xhr.id // I know I will type "_id" from habit all the time.

  if(is_cors && !supports_cors) {
    var cors_err = new Error('Browser does not support cross-origin request: ' + options.uri)
    cors_err.cors = 'unsupported'
    return options.callback(cors_err, xhr)
  }

  xhr.timeoutTimer = setTimeout(too_late, options.timeout)
  function too_late() {
    timed_out = true
    var er = new Error('ETIMEDOUT')
    er.code = 'ETIMEDOUT'
    er.duration = options.timeout

    request.log.error('Timeout', { 'id':xhr._id, 'milliseconds':options.timeout })
    return options.callback(er, xhr)
  }

  // Some states can be skipped over, so remember what is still incomplete.
  var did = {'response':false, 'loading':false, 'end':false}

  xhr.onreadystatechange = on_state_change
  xhr.open(options.method, options.uri, true) // asynchronous
  if(is_cors)
    xhr.withCredentials = !! options.withCredentials
  xhr.send(options.body)
  return xhr

  function on_state_change(event) {
    if(timed_out)
      return request.log.debug('Ignoring timed out state change', {'state':xhr.readyState, 'id':xhr.id})

    request.log.debug('State change', {'state':xhr.readyState, 'id':xhr.id, 'timed_out':timed_out})

    if(xhr.readyState === XHR.OPENED) {
      request.log.debug('Request started', {'id':xhr.id})
      for (var key in options.headers)
        xhr.setRequestHeader(key, options.headers[key])
    }

    else if(xhr.readyState === XHR.HEADERS_RECEIVED)
      on_response()

    else if(xhr.readyState === XHR.LOADING) {
      on_response()
      on_loading()
    }

    else if(xhr.readyState === XHR.DONE) {
      on_response()
      on_loading()
      on_end()
    }
  }

  function on_response() {
    if(did.response)
      return

    did.response = true
    request.log.debug('Got response', {'id':xhr.id, 'status':xhr.status})
    clearTimeout(xhr.timeoutTimer)
    xhr.statusCode = xhr.status // Node request compatibility

    // Detect failed CORS requests.
    if(is_cors && xhr.statusCode == 0) {
      var cors_err = new Error('CORS request rejected: ' + options.uri)
      cors_err.cors = 'rejected'

      // Do not process this request further.
      did.loading = true
      did.end = true

      return options.callback(cors_err, xhr)
    }

    options.onResponse(null, xhr)
  }

  function on_loading() {
    if(did.loading)
      return

    did.loading = true
    request.log.debug('Response body loading', {'id':xhr.id})
    // TODO: Maybe simulate "data" events by watching xhr.responseText
  }

  function on_end() {
    if(did.end)
      return

    did.end = true
    request.log.debug('Request done', {'id':xhr.id})

    xhr.body = xhr.responseText
    if(options.json) {
      try        { xhr.body = JSON.parse(xhr.responseText) }
      catch (er) { return options.callback(er, xhr)        }
    }

    options.callback(null, xhr, xhr.body)
  }

} // request

request.withCredentials = false;
request.DEFAULT_TIMEOUT = DEFAULT_TIMEOUT;

//
// defaults
//

request.defaults = function(options, requester) {
  var def = function (method) {
    var d = function (params, callback) {
      if(typeof params === 'string')
        params = {'uri': params};
      else {
        params = JSON.parse(JSON.stringify(params));
      }
      for (var i in options) {
        if (params[i] === undefined) params[i] = options[i]
      }
      return method(params, callback)
    }
    return d
  }
  var de = def(request)
  de.get = def(request.get)
  de.post = def(request.post)
  de.put = def(request.put)
  de.head = def(request.head)
  return de
}

//
// HTTP method shortcuts
//

var shortcuts = [ 'get', 'put', 'post', 'head' ];
shortcuts.forEach(function(shortcut) {
  var method = shortcut.toUpperCase();
  var func   = shortcut.toLowerCase();

  request[func] = function(opts) {
    if(typeof opts === 'string')
      opts = {'method':method, 'uri':opts};
    else {
      opts = JSON.parse(JSON.stringify(opts));
      opts.method = method;
    }

    var args = [opts].concat(Array.prototype.slice.apply(arguments, [1]));
    return request.apply(this, args);
  }
})

//
// CouchDB shortcut
//

request.couch = function(options, callback) {
  if(typeof options === 'string')
    options = {'uri':options}

  // Just use the request API to do JSON.
  options.json = true
  if(options.body)
    options.json = options.body
  delete options.body

  callback = callback || noop

  var xhr = request(options, couch_handler)
  return xhr

  function couch_handler(er, resp, body) {
    if(er)
      return callback(er, resp, body)

    if((resp.statusCode < 200 || resp.statusCode > 299) && body.error) {
      // The body is a Couch JSON object indicating the error.
      er = new Error('CouchDB error: ' + (body.error.reason || body.error.error))
      for (var key in body)
        er[key] = body[key]
      return callback(er, resp, body);
    }

    return callback(er, resp, body);
  }
}

//
// Utility
//

function noop() {}

function getLogger() {
  var logger = {}
    , levels = ['trace', 'debug', 'info', 'warn', 'error']
    , level, i

  for(i = 0; i < levels.length; i++) {
    level = levels[i]

    logger[level] = noop
    if(typeof console !== 'undefined' && console && console[level])
      logger[level] = formatted(console, level)
  }

  return logger
}

function formatted(obj, method) {
  return formatted_logger

  function formatted_logger(str, context) {
    if(typeof context === 'object')
      str += ' ' + JSON.stringify(context)

    return obj[method].call(obj, str)
  }
}

// Return whether a URL is a cross-domain request.
function is_crossDomain(url) {
  var rurl = /^([\w\+\.\-]+:)(?:\/\/([^\/?#:]*)(?::(\d+))?)?/

  // jQuery #8138, IE may throw an exception when accessing
  // a field from window.location if document.domain has been set
  var ajaxLocation
  try { ajaxLocation = location.href }
  catch (e) {
    // Use the href attribute of an A element since IE will modify it given document.location
    ajaxLocation = document.createElement( "a" );
    ajaxLocation.href = "";
    ajaxLocation = ajaxLocation.href;
  }

  var ajaxLocParts = rurl.exec(ajaxLocation.toLowerCase()) || []
    , parts = rurl.exec(url.toLowerCase() )

  var result = !!(
    parts &&
    (  parts[1] != ajaxLocParts[1]
    || parts[2] != ajaxLocParts[2]
    || (parts[3] || (parts[1] === "http:" ? 80 : 443)) != (ajaxLocParts[3] || (ajaxLocParts[1] === "http:" ? 80 : 443))
    )
  )

  //console.debug('is_crossDomain('+url+') -> ' + result)
  return result
}

// MIT License from http://phpjs.org/functions/base64_encode:358
function b64_enc (data) {
    // Encodes string using MIME base64 algorithm
    var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc="", tmp_arr = [];

    if (!data) {
        return data;
    }

    // assume utf8 data
    // data = this.utf8_encode(data+'');

    do { // pack three octets into four hexets
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);

        bits = o1<<16 | o2<<8 | o3;

        h1 = bits>>18 & 0x3f;
        h2 = bits>>12 & 0x3f;
        h3 = bits>>6 & 0x3f;
        h4 = bits & 0x3f;

        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    } while (i < data.length);

    enc = tmp_arr.join('');

    switch (data.length % 3) {
        case 1:
            enc = enc.slice(0, -2) + '==';
        break;
        case 2:
            enc = enc.slice(0, -1) + '=';
        break;
    }

    return enc;
}
    return request;
//UMD FOOTER START
}));
//UMD FOOTER END


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__has_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__collectNonEnumProps_js__ = __webpack_require__(186);





// Retrieve the names of an object's own properties.
// Delegates to **ECMAScript 5**'s native `Object.keys`.
function keys(obj) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(obj)) return [];
  if (__WEBPACK_IMPORTED_MODULE_1__setup_js__["m" /* nativeKeys */]) return Object(__WEBPACK_IMPORTED_MODULE_1__setup_js__["m" /* nativeKeys */])(obj);
  var keys = [];
  for (var key in obj) if (Object(__WEBPACK_IMPORTED_MODULE_2__has_js__["a" /* default */])(obj, key)) keys.push(key);
  // Ahem, IE < 9.
  if (__WEBPACK_IMPORTED_MODULE_1__setup_js__["h" /* hasEnumBug */]) Object(__WEBPACK_IMPORTED_MODULE_3__collectNonEnumProps_js__["a" /* default */])(obj, keys);
  return keys;
}


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var core = __webpack_require__(12);
var ctx = __webpack_require__(43);
var hide = __webpack_require__(44);
var has = __webpack_require__(54);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tagTester;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(11);


// Internal function for creating a `toString`-based type tester.
function tagTester(name) {
  var tag = '[object ' + name + ']';
  return function(obj) {
    return __WEBPACK_IMPORTED_MODULE_0__setup_js__["t" /* toString */].call(obj) === tag;
  };
}


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_RESULT__;!function(t){ true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):t()}(function(){"use strict";
/** @license
   * jsPDF - PDF Document creation from JavaScript
   * Version 1.5.3 Built on 2018-12-27T14:11:42.696Z
   *                      CommitID d93d28db14
   *
   * Copyright (c) 2010-2016 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
   *               2010 Aaron Spike, https://github.com/acspike
   *               2012 Willow Systems Corporation, willow-systems.com
   *               2012 Pablo Hess, https://github.com/pablohess
   *               2012 Florian Jenett, https://github.com/fjenett
   *               2013 Warren Weckesser, https://github.com/warrenweckesser
   *               2013 Youssef Beddad, https://github.com/lifof
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2013 Stefan Slonevskiy, https://github.com/stefslon
   *               2013 Jeremy Morel, https://github.com/jmorel
   *               2013 Christoph Hartmann, https://github.com/chris-rock
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Makes, https://github.com/dollaruw
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Steven Spungin, https://github.com/Flamenco
   *               2014 Kenneth Glassey, https://github.com/Gavvers
   *
   * Licensed under the MIT License
   *
   * Contributor(s):
   *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
   *    kim3er, mfo, alnorth, Flamenco
   */function se(t){return(se="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}!function(t){if("object"!==se(t.console)){t.console={};for(var e,n,r=t.console,i=function(){},o=["memory"],a="assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(",");e=o.pop();)r[e]||(r[e]={});for(;n=a.pop();)r[n]||(r[n]=i)}var s,l,h,u,c="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";void 0===t.btoa&&(t.btoa=function(t){var e,n,r,i,o,a=0,s=0,l="",h=[];if(!t)return t;for(;e=(o=t.charCodeAt(a++)<<16|t.charCodeAt(a++)<<8|t.charCodeAt(a++))>>18&63,n=o>>12&63,r=o>>6&63,i=63&o,h[s++]=c.charAt(e)+c.charAt(n)+c.charAt(r)+c.charAt(i),a<t.length;);l=h.join("");var u=t.length%3;return(u?l.slice(0,u-3):l)+"===".slice(u||3)}),void 0===t.atob&&(t.atob=function(t){var e,n,r,i,o,a,s=0,l=0,h=[];if(!t)return t;for(t+="";e=(a=c.indexOf(t.charAt(s++))<<18|c.indexOf(t.charAt(s++))<<12|(i=c.indexOf(t.charAt(s++)))<<6|(o=c.indexOf(t.charAt(s++))))>>16&255,n=a>>8&255,r=255&a,h[l++]=64==i?String.fromCharCode(e):64==o?String.fromCharCode(e,n):String.fromCharCode(e,n,r),s<t.length;);return h.join("")}),Array.prototype.map||(Array.prototype.map=function(t){if(null==this||"function"!=typeof t)throw new TypeError;for(var e=Object(this),n=e.length>>>0,r=new Array(n),i=1<arguments.length?arguments[1]:void 0,o=0;o<n;o++)o in e&&(r[o]=t.call(i,e[o],o,e));return r}),Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),Array.prototype.forEach||(Array.prototype.forEach=function(t,e){if(null==this||"function"!=typeof t)throw new TypeError;for(var n=Object(this),r=n.length>>>0,i=0;i<r;i++)i in n&&t.call(e,n[i],i,n)}),Array.prototype.find||Object.defineProperty(Array.prototype,"find",{value:function(t){if(null==this)throw new TypeError('"this" is null or not defined');var e=Object(this),n=e.length>>>0;if("function"!=typeof t)throw new TypeError("predicate must be a function");for(var r=arguments[1],i=0;i<n;){var o=e[i];if(t.call(r,o,i,e))return o;i++}},configurable:!0,writable:!0}),Object.keys||(Object.keys=(s=Object.prototype.hasOwnProperty,l=!{toString:null}.propertyIsEnumerable("toString"),u=(h=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"]).length,function(t){if("object"!==se(t)&&("function"!=typeof t||null===t))throw new TypeError;var e,n,r=[];for(e in t)s.call(t,e)&&r.push(e);if(l)for(n=0;n<u;n++)s.call(t,h[n])&&r.push(h[n]);return r})),"function"!=typeof Object.assign&&(Object.assign=function(t){if(null==t)throw new TypeError("Cannot convert undefined or null to object");t=Object(t);for(var e=1;e<arguments.length;e++){var n=arguments[e];if(null!=n)for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}),String.prototype.trim||(String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")}),String.prototype.trimLeft||(String.prototype.trimLeft=function(){return this.replace(/^\s+/g,"")}),String.prototype.trimRight||(String.prototype.trimRight=function(){return this.replace(/\s+$/g,"")}),Number.isInteger=Number.isInteger||function(t){return"number"==typeof t&&isFinite(t)&&Math.floor(t)===t}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());var t,e,n,_,l,F,P,p,d,k,a,o,s,h,u,c,r,i,f,g,m,y,v,w,b,x,I,C,B,N,L,A,S,j,E,M,O,q,T,R,D,U,z,H,W,V,G,Y,J,X,K,Z,Q,$,tt,et,nt,rt,it,ot,at,st,lt=function(ie){function oe(o){if("object"!==se(o))throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");var a={};this.subscribe=function(t,e,n){if(n=n||!1,"string"!=typeof t||"function"!=typeof e||"boolean"!=typeof n)throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");a.hasOwnProperty(t)||(a[t]={});var r=Math.random().toString(35);return a[t][r]=[e,!!n],r},this.unsubscribe=function(t){for(var e in a)if(a[e][t])return delete a[e][t],0===Object.keys(a[e]).length&&delete a[e],!0;return!1},this.publish=function(t){if(a.hasOwnProperty(t)){var e=Array.prototype.slice.call(arguments,1),n=[];for(var r in a[t]){var i=a[t][r];try{i[0].apply(o,e)}catch(t){ie.console&&console.error("jsPDF PubSub Error",t.message,t)}i[1]&&n.push(r)}n.length&&n.forEach(this.unsubscribe)}},this.getTopics=function(){return a}}function ae(t,e,i,n){var r={},o=[],a=1;"object"===se(t)&&(t=(r=t).orientation,e=r.unit||e,i=r.format||i,n=r.compress||r.compressPdf||n,o=r.filters||(!0===n?["FlateEncode"]:o),a="number"==typeof r.userUnit?Math.abs(r.userUnit):1),e=e||"mm",t=(""+(t||"P")).toLowerCase();var s=r.putOnlyUsedFonts||!0,K={},l={internal:{},__private__:{}};l.__private__.PubSub=oe;var h="1.3",u=l.__private__.getPdfVersion=function(){return h},c=(l.__private__.setPdfVersion=function(t){h=t},{a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]}),f=(l.__private__.getPageFormats=function(){return c},l.__private__.getPageFormat=function(t){return c[t]});"string"==typeof i&&(i=f(i)),i=i||f("a4");var p,Z=l.f2=l.__private__.f2=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return t.toFixed(2)},Q=l.__private__.f3=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f3");return t.toFixed(3)},d="00000000000000000000000000000000",g=l.__private__.getFileId=function(){return d},m=l.__private__.setFileId=function(t){return t=t||"12345678901234567890123456789012".split("").map(function(){return"ABCDEF0123456789".charAt(Math.floor(16*Math.random()))}).join(""),d=t};l.setFileId=function(t){return m(t),this},l.getFileId=function(){return g()};var y=l.__private__.convertDateToPDFDate=function(t){var e=t.getTimezoneOffset(),n=e<0?"+":"-",r=Math.floor(Math.abs(e/60)),i=Math.abs(e%60),o=[n,P(r),"'",P(i),"'"].join("");return["D:",t.getFullYear(),P(t.getMonth()+1),P(t.getDate()),P(t.getHours()),P(t.getMinutes()),P(t.getSeconds()),o].join("")},v=l.__private__.convertPDFDateToDate=function(t){var e=parseInt(t.substr(2,4),10),n=parseInt(t.substr(6,2),10)-1,r=parseInt(t.substr(8,2),10),i=parseInt(t.substr(10,2),10),o=parseInt(t.substr(12,2),10),a=parseInt(t.substr(14,2),10);parseInt(t.substr(16,2),10),parseInt(t.substr(20,2),10);return new Date(e,n,r,i,o,a,0)},w=l.__private__.setCreationDate=function(t){var e;if(void 0===t&&(t=new Date),"object"===se(t)&&"[object Date]"===Object.prototype.toString.call(t))e=y(t);else{if(!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|\-0[0-9]|\-1[0-1])\'(0[0-9]|[1-5][0-9])\'?$/.test(t))throw new Error("Invalid argument passed to jsPDF.setCreationDate");e=t}return p=e},b=l.__private__.getCreationDate=function(t){var e=p;return"jsDate"===t&&(e=v(p)),e};l.setCreationDate=function(t){return w(t),this},l.getCreationDate=function(t){return b(t)};var x,N,L,A,S,$,_,F,P=l.__private__.padd2=function(t){return("0"+parseInt(t)).slice(-2)},k=!1,I=[],C=[],B=0,tt=(l.__private__.setCustomOutputDestination=function(t){N=t},l.__private__.resetCustomOutputDestination=function(t){N=void 0},l.__private__.out=function(t){var e;return t="string"==typeof t?t:t.toString(),(e=void 0===N?k?I[x]:C:N).push(t),k||(B+=t.length+1),e}),j=l.__private__.write=function(t){return tt(1===arguments.length?t.toString():Array.prototype.join.call(arguments," "))},E=l.__private__.getArrayBuffer=function(t){for(var e=t.length,n=new ArrayBuffer(e),r=new Uint8Array(n);e--;)r[e]=t.charCodeAt(e);return n},M=[["Helvetica","helvetica","normal","WinAnsiEncoding"],["Helvetica-Bold","helvetica","bold","WinAnsiEncoding"],["Helvetica-Oblique","helvetica","italic","WinAnsiEncoding"],["Helvetica-BoldOblique","helvetica","bolditalic","WinAnsiEncoding"],["Courier","courier","normal","WinAnsiEncoding"],["Courier-Bold","courier","bold","WinAnsiEncoding"],["Courier-Oblique","courier","italic","WinAnsiEncoding"],["Courier-BoldOblique","courier","bolditalic","WinAnsiEncoding"],["Times-Roman","times","normal","WinAnsiEncoding"],["Times-Bold","times","bold","WinAnsiEncoding"],["Times-Italic","times","italic","WinAnsiEncoding"],["Times-BoldItalic","times","bolditalic","WinAnsiEncoding"],["ZapfDingbats","zapfdingbats","normal",null],["Symbol","symbol","normal",null]],et=(l.__private__.getStandardFonts=function(t){return M},r.fontSize||16),O=(l.__private__.setFontSize=l.setFontSize=function(t){return et=t,this},l.__private__.getFontSize=l.getFontSize=function(){return et}),nt=r.R2L||!1,q=(l.__private__.setR2L=l.setR2L=function(t){return nt=t,this},l.__private__.getR2L=l.getR2L=function(t){return nt},l.__private__.setZoomMode=function(t){var e=[void 0,null,"fullwidth","fullheight","fullpage","original"];if(/^\d*\.?\d*\%$/.test(t))L=t;else if(isNaN(t)){if(-1===e.indexOf(t))throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "'+t+'" is not recognized.');L=t}else L=parseInt(t,10)}),T=(l.__private__.getZoomMode=function(){return L},l.__private__.setPageMode=function(t){if(-1==[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"].indexOf(t))throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+t+'" is not recognized.');A=t}),R=(l.__private__.getPageMode=function(){return A},l.__private__.setLayoutMode=function(t){if(-1==[void 0,null,"continuous","single","twoleft","tworight","two"].indexOf(t))throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "'+t+'" is not recognized.');S=t}),D=(l.__private__.getLayoutMode=function(){return S},l.__private__.setDisplayMode=l.setDisplayMode=function(t,e,n){return q(t),R(e),T(n),this},{title:"",subject:"",author:"",keywords:"",creator:""}),U=(l.__private__.getDocumentProperty=function(t){if(-1===Object.keys(D).indexOf(t))throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");return D[t]},l.__private__.getDocumentProperties=function(t){return D},l.__private__.setDocumentProperties=l.setProperties=l.setDocumentProperties=function(t){for(var e in D)D.hasOwnProperty(e)&&t[e]&&(D[e]=t[e]);return this},l.__private__.setDocumentProperty=function(t,e){if(-1===Object.keys(D).indexOf(t))throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");return D[t]=e},0),z=[],rt={},H={},W=0,V=[],G=[],it=new oe(l),Y=r.hotfixes||[],J=l.__private__.newObject=function(){var t=X();return ot(t,!0),t},X=l.__private__.newObjectDeferred=function(){return z[++U]=function(){return B},U},ot=function(t,e){return e="boolean"==typeof e&&e,z[t]=B,e&&tt(t+" 0 obj"),t},at=l.__private__.newAdditionalObject=function(){var t={objId:X(),content:""};return G.push(t),t},st=X(),lt=X(),ht=l.__private__.decodeColorString=function(t){var e=t.split(" ");if(2===e.length&&("g"===e[1]||"G"===e[1])){var n=parseFloat(e[0]);e=[n,n,n,"r"]}for(var r="#",i=0;i<3;i++)r+=("0"+Math.floor(255*parseFloat(e[i])).toString(16)).slice(-2);return r},ut=l.__private__.encodeColorString=function(t){var e;"string"==typeof t&&(t={ch1:t});var n=t.ch1,r=t.ch2,i=t.ch3,o=t.ch4,a=(t.precision,"draw"===t.pdfColorType?["G","RG","K"]:["g","rg","k"]);if("string"==typeof n&&"#"!==n.charAt(0)){var s=new RGBColor(n);if(s.ok)n=s.toHex();else if(!/^\d*\.?\d*$/.test(n))throw new Error('Invalid color "'+n+'" passed to jsPDF.encodeColorString.')}if("string"==typeof n&&/^#[0-9A-Fa-f]{3}$/.test(n)&&(n="#"+n[1]+n[1]+n[2]+n[2]+n[3]+n[3]),"string"==typeof n&&/^#[0-9A-Fa-f]{6}$/.test(n)){var l=parseInt(n.substr(1),16);n=l>>16&255,r=l>>8&255,i=255&l}if(void 0===r||void 0===o&&n===r&&r===i)if("string"==typeof n)e=n+" "+a[0];else switch(t.precision){case 2:e=Z(n/255)+" "+a[0];break;case 3:default:e=Q(n/255)+" "+a[0]}else if(void 0===o||"object"===se(o)){if(o&&!isNaN(o.a)&&0===o.a)return e=["1.000","1.000","1.000",a[1]].join(" ");if("string"==typeof n)e=[n,r,i,a[1]].join(" ");else switch(t.precision){case 2:e=[Z(n/255),Z(r/255),Z(i/255),a[1]].join(" ");break;default:case 3:e=[Q(n/255),Q(r/255),Q(i/255),a[1]].join(" ")}}else if("string"==typeof n)e=[n,r,i,o,a[2]].join(" ");else switch(t.precision){case 2:e=[Z(n/255),Z(r/255),Z(i/255),Z(o/255),a[2]].join(" ");break;case 3:default:e=[Q(n/255),Q(r/255),Q(i/255),Q(o/255),a[2]].join(" ")}return e},ct=l.__private__.getFilters=function(){return o},ft=l.__private__.putStream=function(t){var e=(t=t||{}).data||"",n=t.filters||ct(),r=t.alreadyAppliedFilters||[],i=t.addLength1||!1,o=e.length,a={};!0===n&&(n=["FlateEncode"]);var s=t.additionalKeyValues||[],l=(a=void 0!==ae.API.processDataByFilters?ae.API.processDataByFilters(e,n):{data:e,reverseChain:[]}).reverseChain+(Array.isArray(r)?r.join(" "):r.toString());0!==a.data.length&&(s.push({key:"Length",value:a.data.length}),!0===i&&s.push({key:"Length1",value:o})),0!=l.length&&(l.split("/").length-1==1?s.push({key:"Filter",value:l}):s.push({key:"Filter",value:"["+l+"]"})),tt("<<");for(var h=0;h<s.length;h++)tt("/"+s[h].key+" "+s[h].value);tt(">>"),0!==a.data.length&&(tt("stream"),tt(a.data),tt("endstream"))},pt=l.__private__.putPage=function(t){t.mediaBox;var e=t.number,n=t.data,r=t.objId,i=t.contentsObjId;ot(r,!0);V[x].mediaBox.topRightX,V[x].mediaBox.bottomLeftX,V[x].mediaBox.topRightY,V[x].mediaBox.bottomLeftY;tt("<</Type /Page"),tt("/Parent "+t.rootDictionaryObjId+" 0 R"),tt("/Resources "+t.resourceDictionaryObjId+" 0 R"),tt("/MediaBox ["+parseFloat(Z(t.mediaBox.bottomLeftX))+" "+parseFloat(Z(t.mediaBox.bottomLeftY))+" "+Z(t.mediaBox.topRightX)+" "+Z(t.mediaBox.topRightY)+"]"),null!==t.cropBox&&tt("/CropBox ["+Z(t.cropBox.bottomLeftX)+" "+Z(t.cropBox.bottomLeftY)+" "+Z(t.cropBox.topRightX)+" "+Z(t.cropBox.topRightY)+"]"),null!==t.bleedBox&&tt("/BleedBox ["+Z(t.bleedBox.bottomLeftX)+" "+Z(t.bleedBox.bottomLeftY)+" "+Z(t.bleedBox.topRightX)+" "+Z(t.bleedBox.topRightY)+"]"),null!==t.trimBox&&tt("/TrimBox ["+Z(t.trimBox.bottomLeftX)+" "+Z(t.trimBox.bottomLeftY)+" "+Z(t.trimBox.topRightX)+" "+Z(t.trimBox.topRightY)+"]"),null!==t.artBox&&tt("/ArtBox ["+Z(t.artBox.bottomLeftX)+" "+Z(t.artBox.bottomLeftY)+" "+Z(t.artBox.topRightX)+" "+Z(t.artBox.topRightY)+"]"),"number"==typeof t.userUnit&&1!==t.userUnit&&tt("/UserUnit "+t.userUnit),it.publish("putPage",{objId:r,pageContext:V[e],pageNumber:e,page:n}),tt("/Contents "+i+" 0 R"),tt(">>"),tt("endobj");var o=n.join("\n");return ot(i,!0),ft({data:o,filters:ct()}),tt("endobj"),r},dt=l.__private__.putPages=function(){var t,e,n=[];for(t=1;t<=W;t++)V[t].objId=X(),V[t].contentsObjId=X();for(t=1;t<=W;t++)n.push(pt({number:t,data:I[t],objId:V[t].objId,contentsObjId:V[t].contentsObjId,mediaBox:V[t].mediaBox,cropBox:V[t].cropBox,bleedBox:V[t].bleedBox,trimBox:V[t].trimBox,artBox:V[t].artBox,userUnit:V[t].userUnit,rootDictionaryObjId:st,resourceDictionaryObjId:lt}));ot(st,!0),tt("<</Type /Pages");var r="/Kids [";for(e=0;e<W;e++)r+=n[e]+" 0 R ";tt(r+"]"),tt("/Count "+W),tt(">>"),tt("endobj"),it.publish("postPutPages")},gt=function(){!function(){for(var t in rt)rt.hasOwnProperty(t)&&(!1===s||!0===s&&K.hasOwnProperty(t))&&(e=rt[t],it.publish("putFont",{font:e,out:tt,newObject:J,putStream:ft}),!0!==e.isAlreadyPutted&&(e.objectNumber=J(),tt("<<"),tt("/Type /Font"),tt("/BaseFont /"+e.postScriptName),tt("/Subtype /Type1"),"string"==typeof e.encoding&&tt("/Encoding /"+e.encoding),tt("/FirstChar 32"),tt("/LastChar 255"),tt(">>"),tt("endobj")));var e}(),it.publish("putResources"),ot(lt,!0),tt("<<"),function(){for(var t in tt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),tt("/Font <<"),rt)rt.hasOwnProperty(t)&&(!1===s||!0===s&&K.hasOwnProperty(t))&&tt("/"+t+" "+rt[t].objectNumber+" 0 R");tt(">>"),tt("/XObject <<"),it.publish("putXobjectDict"),tt(">>")}(),tt(">>"),tt("endobj"),it.publish("postPutResources")},mt=function(t,e,n){H.hasOwnProperty(e)||(H[e]={}),H[e][n]=t},yt=function(t,e,n,r,i){i=i||!1;var o="F"+(Object.keys(rt).length+1).toString(10),a={id:o,postScriptName:t,fontName:e,fontStyle:n,encoding:r,isStandardFont:i,metadata:{}};return it.publish("addFont",{font:a,instance:this}),void 0!==o&&(rt[o]=a,mt(o,e,n)),o},vt=l.__private__.pdfEscape=l.pdfEscape=function(t,e){return function(t,e){var n,r,i,o,a,s,l,h,u;if(i=(e=e||{}).sourceEncoding||"Unicode",a=e.outputEncoding,(e.autoencode||a)&&rt[$].metadata&&rt[$].metadata[i]&&rt[$].metadata[i].encoding&&(o=rt[$].metadata[i].encoding,!a&&rt[$].encoding&&(a=rt[$].encoding),!a&&o.codePages&&(a=o.codePages[0]),"string"==typeof a&&(a=o[a]),a)){for(l=!1,s=[],n=0,r=t.length;n<r;n++)(h=a[t.charCodeAt(n)])?s.push(String.fromCharCode(h)):s.push(t[n]),s[n].charCodeAt(0)>>8&&(l=!0);t=s.join("")}for(n=t.length;void 0===l&&0!==n;)t.charCodeAt(n-1)>>8&&(l=!0),n--;if(!l)return t;for(s=e.noBOM?[]:[254,255],n=0,r=t.length;n<r;n++){if((u=(h=t.charCodeAt(n))>>8)>>8)throw new Error("Character at position "+n+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(u),s.push(h-(u<<8))}return String.fromCharCode.apply(void 0,s)}(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},wt=l.__private__.beginPage=function(t,e){var n,r="string"==typeof e&&e.toLowerCase();if("string"==typeof t&&(n=f(t.toLowerCase()))&&(t=n[0],e=n[1]),Array.isArray(t)&&(e=t[1],t=t[0]),(isNaN(t)||isNaN(e))&&(t=i[0],e=i[1]),r){switch(r.substr(0,1)){case"l":t<e&&(r="s");break;case"p":e<t&&(r="s")}"s"===r&&(n=t,t=e,e=n)}(14400<t||14400<e)&&(console.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"),t=Math.min(14400,t),e=Math.min(14400,e)),i=[t,e],k=!0,I[++W]=[],V[W]={objId:0,contentsObjId:0,userUnit:Number(a),artBox:null,bleedBox:null,cropBox:null,trimBox:null,mediaBox:{bottomLeftX:0,bottomLeftY:0,topRightX:Number(t),topRightY:Number(e)}},xt(W)},bt=function(){wt.apply(this,arguments),Dt(Rt),tt(Jt),0!==te&&tt(te+" J"),0!==ne&&tt(ne+" j"),it.publish("addPage",{pageNumber:W})},xt=function(t){0<t&&t<=W&&(x=t)},Nt=l.__private__.getNumberOfPages=l.getNumberOfPages=function(){return I.length-1},Lt=function(t,e,n){var r,i=void 0;return n=n||{},t=void 0!==t?t:rt[$].fontName,e=void 0!==e?e:rt[$].fontStyle,r=t.toLowerCase(),void 0!==H[r]&&void 0!==H[r][e]?i=H[r][e]:void 0!==H[t]&&void 0!==H[t][e]?i=H[t][e]:!1===n.disableWarning&&console.warn("Unable to look up font label for font '"+t+"', '"+e+"'. Refer to getFontList() for available fonts."),i||n.noFallback||null==(i=H.times[e])&&(i=H.times.normal),i},At=l.__private__.putInfo=function(){for(var t in J(),tt("<<"),tt("/Producer (jsPDF "+ae.version+")"),D)D.hasOwnProperty(t)&&D[t]&&tt("/"+t.substr(0,1).toUpperCase()+t.substr(1)+" ("+vt(D[t])+")");tt("/CreationDate ("+p+")"),tt(">>"),tt("endobj")},St=l.__private__.putCatalog=function(t){var e=(t=t||{}).rootDictionaryObjId||st;switch(J(),tt("<<"),tt("/Type /Catalog"),tt("/Pages "+e+" 0 R"),L||(L="fullwidth"),L){case"fullwidth":tt("/OpenAction [3 0 R /FitH null]");break;case"fullheight":tt("/OpenAction [3 0 R /FitV null]");break;case"fullpage":tt("/OpenAction [3 0 R /Fit]");break;case"original":tt("/OpenAction [3 0 R /XYZ null null 1]");break;default:var n=""+L;"%"===n.substr(n.length-1)&&(L=parseInt(L)/100),"number"==typeof L&&tt("/OpenAction [3 0 R /XYZ null null "+Z(L)+"]")}switch(S||(S="continuous"),S){case"continuous":tt("/PageLayout /OneColumn");break;case"single":tt("/PageLayout /SinglePage");break;case"two":case"twoleft":tt("/PageLayout /TwoColumnLeft");break;case"tworight":tt("/PageLayout /TwoColumnRight")}A&&tt("/PageMode /"+A),it.publish("putCatalog"),tt(">>"),tt("endobj")},_t=l.__private__.putTrailer=function(){tt("trailer"),tt("<<"),tt("/Size "+(U+1)),tt("/Root "+U+" 0 R"),tt("/Info "+(U-1)+" 0 R"),tt("/ID [ <"+d+"> <"+d+"> ]"),tt(">>")},Ft=l.__private__.putHeader=function(){tt("%PDF-"+h),tt("%ºß¬à")},Pt=l.__private__.putXRef=function(){var t=1,e="0000000000";for(tt("xref"),tt("0 "+(U+1)),tt("0000000000 65535 f "),t=1;t<=U;t++){"function"==typeof z[t]?tt((e+z[t]()).slice(-10)+" 00000 n "):void 0!==z[t]?tt((e+z[t]).slice(-10)+" 00000 n "):tt("0000000000 00000 n ")}},kt=l.__private__.buildDocument=function(){k=!1,B=U=0,C=[],z=[],G=[],st=X(),lt=X(),it.publish("buildDocument"),Ft(),dt(),function(){it.publish("putAdditionalObjects");for(var t=0;t<G.length;t++){var e=G[t];ot(e.objId,!0),tt(e.content),tt("endobj")}it.publish("postPutAdditionalObjects")}(),gt(),At(),St();var t=B;return Pt(),_t(),tt("startxref"),tt(""+t),tt("%%EOF"),k=!0,C.join("\n")},It=l.__private__.getBlob=function(t){return new Blob([E(t)],{type:"application/pdf"})},Ct=l.output=l.__private__.output=((F=function(t,e){e=e||{};var n=kt();switch("string"==typeof e?e={filename:e}:e.filename=e.filename||"generated.pdf",t){case void 0:return n;case"save":l.save(e.filename);break;case"arraybuffer":return E(n);case"blob":return It(n);case"bloburi":case"bloburl":if(void 0!==ie.URL&&"function"==typeof ie.URL.createObjectURL)return ie.URL&&ie.URL.createObjectURL(It(n))||void 0;console.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");break;case"datauristring":case"dataurlstring":return"data:application/pdf;filename="+e.filename+";base64,"+btoa(n);case"dataurlnewwindow":var r='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="'+this.output("datauristring")+'"></iframe></body></html>',i=ie.open();if(null!==i&&i.document.write(r),i||"undefined"==typeof safari)return i;case"datauri":case"dataurl":return ie.document.location.href="data:application/pdf;filename="+e.filename+";base64,"+btoa(n);default:return null}}).foo=function(){try{return F.apply(this,arguments)}catch(t){var e=t.stack||"";~e.indexOf(" at ")&&(e=e.split(" at ")[1]);var n="Error in function "+e.split("\n")[0].split("<")[0]+": "+t.message;if(!ie.console)throw new Error(n);ie.console.error(n,t),ie.alert&&alert(n)}},(F.foo.bar=F).foo),Bt=function(t){return!0===Array.isArray(Y)&&-1<Y.indexOf(t)};switch(e){case"pt":_=1;break;case"mm":_=72/25.4;break;case"cm":_=72/2.54;break;case"in":_=72;break;case"px":_=1==Bt("px_scaling")?.75:96/72;break;case"pc":case"em":_=12;break;case"ex":_=6;break;default:throw new Error("Invalid unit: "+e)}w(),m();var jt=l.__private__.getPageInfo=function(t){if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfo");return{objId:V[t].objId,pageNumber:t,pageContext:V[t]}},Et=l.__private__.getPageInfoByObjId=function(t){for(var e in V)if(V[e].objId===t)break;if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");return jt(e)},Mt=l.__private__.getCurrentPageInfo=function(){return{objId:V[x].objId,pageNumber:x,pageContext:V[x]}};l.addPage=function(){return bt.apply(this,arguments),this},l.setPage=function(){return xt.apply(this,arguments),this},l.insertPage=function(t){return this.addPage(),this.movePage(x,t),this},l.movePage=function(t,e){if(e<t){for(var n=I[t],r=V[t],i=t;e<i;i--)I[i]=I[i-1],V[i]=V[i-1];I[e]=n,V[e]=r,this.setPage(e)}else if(t<e){for(n=I[t],r=V[t],i=t;i<e;i++)I[i]=I[i+1],V[i]=V[i+1];I[e]=n,V[e]=r,this.setPage(e)}return this},l.deletePage=function(){return function(t){0<t&&t<=W&&(I.splice(t,1),--W<x&&(x=W),this.setPage(x))}.apply(this,arguments),this};l.__private__.text=l.text=function(t,e,n,i){var r;"number"!=typeof t||"number"!=typeof e||"string"!=typeof n&&!Array.isArray(n)||(r=n,n=e,e=t,t=r);var o=arguments[3],a=arguments[4],s=arguments[5];if("object"===se(o)&&null!==o||("string"==typeof a&&(s=a,a=null),"string"==typeof o&&(s=o,o=null),"number"==typeof o&&(a=o,o=null),i={flags:o,angle:a,align:s}),(o=o||{}).noBOM=o.noBOM||!0,o.autoencode=o.autoencode||!0,isNaN(e)||isNaN(n)||null==t)throw new Error("Invalid arguments passed to jsPDF.text");if(0===t.length)return c;var l,h="",u="number"==typeof i.lineHeightFactor?i.lineHeightFactor:Tt,c=i.scope||this;function f(t){for(var e,n=t.concat(),r=[],i=n.length;i--;)"string"==typeof(e=n.shift())?r.push(e):Array.isArray(t)&&1===e.length?r.push(e[0]):r.push([e[0],e[1],e[2]]);return r}function p(t,e){var n;if("string"==typeof t)n=e(t)[0];else if(Array.isArray(t)){for(var r,i,o=t.concat(),a=[],s=o.length;s--;)"string"==typeof(r=o.shift())?a.push(e(r)[0]):Array.isArray(r)&&"string"===r[0]&&(i=e(r[0],r[1],r[2]),a.push([i[0],i[1],i[2]]));n=a}return n}var d=!1,g=!0;if("string"==typeof t)d=!0;else if(Array.isArray(t)){for(var m,y=t.concat(),v=[],w=y.length;w--;)("string"!=typeof(m=y.shift())||Array.isArray(m)&&"string"!=typeof m[0])&&(g=!1);d=g}if(!1===d)throw new Error('Type of text must be string or Array. "'+t+'" is not recognized.');var b=rt[$].encoding;"WinAnsiEncoding"!==b&&"StandardEncoding"!==b||(t=p(t,function(t,e,n){return[(r=t,r=r.split("\t").join(Array(i.TabLen||9).join(" ")),vt(r,o)),e,n];var r})),"string"==typeof t&&(t=t.match(/[\r?\n]/)?t.split(/\r\n|\r|\n/g):[t]);var x=et/c.internal.scaleFactor,N=x*(Tt-1);switch(i.baseline){case"bottom":n-=N;break;case"top":n+=x-N;break;case"hanging":n+=x-2*N;break;case"middle":n+=x/2-N}0<(O=i.maxWidth||0)&&("string"==typeof t?t=c.splitTextToSize(t,O):"[object Array]"===Object.prototype.toString.call(t)&&(t=c.splitTextToSize(t.join(" "),O)));var L={text:t,x:e,y:n,options:i,mutex:{pdfEscape:vt,activeFontKey:$,fonts:rt,activeFontSize:et}};it.publish("preProcessText",L),t=L.text;a=(i=L.options).angle;var A=c.internal.scaleFactor,S=[];if(a){a*=Math.PI/180;var _=Math.cos(a),F=Math.sin(a);S=[Z(_),Z(F),Z(-1*F),Z(_)]}void 0!==(M=i.charSpace)&&(h+=Q(M*A)+" Tc\n");i.lang;var P=-1,k=void 0!==i.renderingMode?i.renderingMode:i.stroke,I=c.internal.getCurrentPageInfo().pageContext;switch(k){case 0:case!1:case"fill":P=0;break;case 1:case!0:case"stroke":P=1;break;case 2:case"fillThenStroke":P=2;break;case 3:case"invisible":P=3;break;case 4:case"fillAndAddForClipping":P=4;break;case 5:case"strokeAndAddPathForClipping":P=5;break;case 6:case"fillThenStrokeAndAddToPathForClipping":P=6;break;case 7:case"addToPathForClipping":P=7}var C=void 0!==I.usedRenderingMode?I.usedRenderingMode:-1;-1!==P?h+=P+" Tr\n":-1!==C&&(h+="0 Tr\n"),-1!==P&&(I.usedRenderingMode=P);s=i.align||"left";var B=et*u,j=c.internal.pageSize.getWidth(),E=(A=c.internal.scaleFactor,rt[$]),M=i.charSpace||Qt,O=i.maxWidth||0,q=(o={},[]);if("[object Array]"===Object.prototype.toString.call(t)){var T,R;v=f(t);"left"!==s&&(R=v.map(function(t){return c.getStringUnitWidth(t,{font:E,charSpace:M,fontSize:et})*et/A}));var D,U=Math.max.apply(Math,R),z=0;if("right"===s){e-=R[0],t=[];var H=0;for(w=v.length;H<w;H++)U-R[H],T=0===H?(D=Wt(e),Vt(n)):(D=(z-R[H])*A,-B),t.push([v[H],D,T]),z=R[H]}else if("center"===s){e-=R[0]/2,t=[];for(H=0,w=v.length;H<w;H++)(U-R[H])/2,T=0===H?(D=Wt(e),Vt(n)):(D=(z-R[H])/2*A,-B),t.push([v[H],D,T]),z=R[H]}else if("left"===s){t=[];for(H=0,w=v.length;H<w;H++)T=0===H?Vt(n):-B,D=0===H?Wt(e):0,t.push(v[H])}else{if("justify"!==s)throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');t=[];for(O=0!==O?O:j,H=0,w=v.length;H<w;H++)T=0===H?Vt(n):-B,D=0===H?Wt(e):0,H<w-1&&q.push(((O-R[H])/(v[H].split(" ").length-1)*A).toFixed(2)),t.push([v[H],D,T])}}!0===("boolean"==typeof i.R2L?i.R2L:nt)&&(t=p(t,function(t,e,n){return[t.split("").reverse().join(""),e,n]}));L={text:t,x:e,y:n,options:i,mutex:{pdfEscape:vt,activeFontKey:$,fonts:rt,activeFontSize:et}};it.publish("postProcessText",L),t=L.text,l=L.mutex.isHex;v=f(t);t=[];var W,V,G,Y=0,J=(w=v.length,"");for(H=0;H<w;H++)J="",Array.isArray(v[H])?(W=parseFloat(v[H][1]),V=parseFloat(v[H][2]),G=(l?"<":"(")+v[H][0]+(l?">":")"),Y=1):(W=Wt(e),V=Vt(n),G=(l?"<":"(")+v[H]+(l?">":")")),void 0!==q&&void 0!==q[H]&&(J=q[H]+" Tw\n"),0!==S.length&&0===H?t.push(J+S.join(" ")+" "+W.toFixed(2)+" "+V.toFixed(2)+" Tm\n"+G):1===Y||0===Y&&0===H?t.push(J+W.toFixed(2)+" "+V.toFixed(2)+" Td\n"+G):t.push(J+G);t=0===Y?t.join(" Tj\nT* "):t.join(" Tj\n"),t+=" Tj\n";var X="BT\n/"+$+" "+et+" Tf\n"+(et*u).toFixed(2)+" TL\n"+Kt+"\n";return X+=h,X+=t,tt(X+="ET"),K[$]=!0,c},l.__private__.lstext=l.lstext=function(t,e,n,r){return console.warn("jsPDF.lstext is deprecated"),this.text(t,e,n,{charSpace:r})},l.__private__.clip=l.clip=function(t){tt("evenodd"===t?"W*":"W"),tt("n")},l.__private__.clip_fixed=l.clip_fixed=function(t){console.log("clip_fixed is deprecated"),l.clip(t)};var Ot=l.__private__.isValidStyle=function(t){var e=!1;return-1!==[void 0,null,"S","F","DF","FD","f","f*","B","B*"].indexOf(t)&&(e=!0),e},qt=l.__private__.getStyle=function(t){var e="S";return"F"===t?e="f":"FD"===t||"DF"===t?e="B":"f"!==t&&"f*"!==t&&"B"!==t&&"B*"!==t||(e=t),e};l.__private__.line=l.line=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw new Error("Invalid arguments passed to jsPDF.line");return this.lines([[n-t,r-e]],t,e)},l.__private__.lines=l.lines=function(t,e,n,r,i,o){var a,s,l,h,u,c,f,p,d,g,m,y;if("number"==typeof t&&(y=n,n=e,e=t,t=y),r=r||[1,1],o=o||!1,isNaN(e)||isNaN(n)||!Array.isArray(t)||!Array.isArray(r)||!Ot(i)||"boolean"!=typeof o)throw new Error("Invalid arguments passed to jsPDF.lines");for(tt(Q(Wt(e))+" "+Q(Vt(n))+" m "),a=r[0],s=r[1],h=t.length,g=e,m=n,l=0;l<h;l++)2===(u=t[l]).length?(g=u[0]*a+g,m=u[1]*s+m,tt(Q(Wt(g))+" "+Q(Vt(m))+" l")):(c=u[0]*a+g,f=u[1]*s+m,p=u[2]*a+g,d=u[3]*s+m,g=u[4]*a+g,m=u[5]*s+m,tt(Q(Wt(c))+" "+Q(Vt(f))+" "+Q(Wt(p))+" "+Q(Vt(d))+" "+Q(Wt(g))+" "+Q(Vt(m))+" c"));return o&&tt(" h"),null!==i&&tt(qt(i)),this},l.__private__.rect=l.rect=function(t,e,n,r,i){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||!Ot(i))throw new Error("Invalid arguments passed to jsPDF.rect");return tt([Z(Wt(t)),Z(Vt(e)),Z(n*_),Z(-r*_),"re"].join(" ")),null!==i&&tt(qt(i)),this},l.__private__.triangle=l.triangle=function(t,e,n,r,i,o,a){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(o)||!Ot(a))throw new Error("Invalid arguments passed to jsPDF.triangle");return this.lines([[n-t,r-e],[i-n,o-r],[t-i,e-o]],t,e,[1,1],a,!0),this},l.__private__.roundedRect=l.roundedRect=function(t,e,n,r,i,o,a){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(o)||!Ot(a))throw new Error("Invalid arguments passed to jsPDF.roundedRect");var s=4/3*(Math.SQRT2-1);return this.lines([[n-2*i,0],[i*s,0,i,o-o*s,i,o],[0,r-2*o],[0,o*s,-i*s,o,-i,o],[2*i-n,0],[-i*s,0,-i,-o*s,-i,-o],[0,2*o-r],[0,-o*s,i*s,-o,i,-o]],t+i,e,[1,1],a),this},l.__private__.ellipse=l.ellipse=function(t,e,n,r,i){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||!Ot(i))throw new Error("Invalid arguments passed to jsPDF.ellipse");var o=4/3*(Math.SQRT2-1)*n,a=4/3*(Math.SQRT2-1)*r;return tt([Z(Wt(t+n)),Z(Vt(e)),"m",Z(Wt(t+n)),Z(Vt(e-a)),Z(Wt(t+o)),Z(Vt(e-r)),Z(Wt(t)),Z(Vt(e-r)),"c"].join(" ")),tt([Z(Wt(t-o)),Z(Vt(e-r)),Z(Wt(t-n)),Z(Vt(e-a)),Z(Wt(t-n)),Z(Vt(e)),"c"].join(" ")),tt([Z(Wt(t-n)),Z(Vt(e+a)),Z(Wt(t-o)),Z(Vt(e+r)),Z(Wt(t)),Z(Vt(e+r)),"c"].join(" ")),tt([Z(Wt(t+o)),Z(Vt(e+r)),Z(Wt(t+n)),Z(Vt(e+a)),Z(Wt(t+n)),Z(Vt(e)),"c"].join(" ")),null!==i&&tt(qt(i)),this},l.__private__.circle=l.circle=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||!Ot(r))throw new Error("Invalid arguments passed to jsPDF.circle");return this.ellipse(t,e,n,n,r)};l.setFont=function(t,e){return $=Lt(t,e,{disableWarning:!1}),this},l.setFontStyle=l.setFontType=function(t){return $=Lt(void 0,t),this};l.__private__.getFontList=l.getFontList=function(){var t,e,n,r={};for(t in H)if(H.hasOwnProperty(t))for(e in r[t]=n=[],H[t])H[t].hasOwnProperty(e)&&n.push(e);return r};l.addFont=function(t,e,n,r){yt.call(this,t,e,n,r=r||"Identity-H")};var Tt,Rt=r.lineWidth||.200025,Dt=l.__private__.setLineWidth=l.setLineWidth=function(t){return tt((t*_).toFixed(2)+" w"),this},Ut=(l.__private__.setLineDash=ae.API.setLineDash=function(t,e){if(t=t||[],e=e||0,isNaN(e)||!Array.isArray(t))throw new Error("Invalid arguments passed to jsPDF.setLineDash");return t=t.map(function(t){return(t*_).toFixed(3)}).join(" "),e=parseFloat((e*_).toFixed(3)),tt("["+t+"] "+e+" d"),this},l.__private__.getLineHeight=l.getLineHeight=function(){return et*Tt}),zt=(Ut=l.__private__.getLineHeight=l.getLineHeight=function(){return et*Tt},l.__private__.setLineHeightFactor=l.setLineHeightFactor=function(t){return"number"==typeof(t=t||1.15)&&(Tt=t),this}),Ht=l.__private__.getLineHeightFactor=l.getLineHeightFactor=function(){return Tt};zt(r.lineHeight);var Wt=l.__private__.getHorizontalCoordinate=function(t){return t*_},Vt=l.__private__.getVerticalCoordinate=function(t){return V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY-t*_},Gt=l.__private__.getHorizontalCoordinateString=function(t){return Z(t*_)},Yt=l.__private__.getVerticalCoordinateString=function(t){return Z(V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY-t*_)},Jt=r.strokeColor||"0 G",Xt=(l.__private__.getStrokeColor=l.getDrawColor=function(){return ht(Jt)},l.__private__.setStrokeColor=l.setDrawColor=function(t,e,n,r){return Jt=ut({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"draw",precision:2}),tt(Jt),this},r.fillColor||"0 g"),Kt=(l.__private__.getFillColor=l.getFillColor=function(){return ht(Xt)},l.__private__.setFillColor=l.setFillColor=function(t,e,n,r){return Xt=ut({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"fill",precision:2}),tt(Xt),this},r.textColor||"0 g"),Zt=l.__private__.getTextColor=l.getTextColor=function(){return ht(Kt)},Qt=(l.__private__.setTextColor=l.setTextColor=function(t,e,n,r){return Kt=ut({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"text",precision:3}),this},r.charSpace||0),$t=l.__private__.getCharSpace=l.getCharSpace=function(){return Qt},te=(l.__private__.setCharSpace=l.setCharSpace=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.setCharSpace");return Qt=t,this},0);l.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2};l.__private__.setLineCap=l.setLineCap=function(t){var e=l.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return tt((te=e)+" J"),this};var ee,ne=0;l.__private__.setLineJoin=l.setLineJoin=function(t){var e=l.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return tt((ne=e)+" j"),this},l.__private__.setMiterLimit=l.setMiterLimit=function(t){if(t=t||0,isNaN(t))throw new Error("Invalid argument passed to jsPDF.setMiterLimit");return ee=parseFloat(Z(t*_)),tt(ee+" M"),this};for(var re in l.save=function(r,t){if(r=r||"generated.pdf",(t=t||{}).returnPromise=t.returnPromise||!1,!1!==t.returnPromise)return new Promise(function(t,e){try{var n=le(It(kt()),r);"function"==typeof le.unload&&ie.setTimeout&&setTimeout(le.unload,911),t(n)}catch(t){e(t.message)}});le(It(kt()),r),"function"==typeof le.unload&&ie.setTimeout&&setTimeout(le.unload,911)},ae.API)ae.API.hasOwnProperty(re)&&("events"===re&&ae.API.events.length?function(t,e){var n,r,i;for(i=e.length-1;-1!==i;i--)n=e[i][0],r=e[i][1],t.subscribe.apply(t,[n].concat("function"==typeof r?[r]:r))}(it,ae.API.events):l[re]=ae.API[re]);return l.internal={pdfEscape:vt,getStyle:qt,getFont:function(){return rt[Lt.apply(l,arguments)]},getFontSize:O,getCharSpace:$t,getTextColor:Zt,getLineHeight:Ut,getLineHeightFactor:Ht,write:j,getHorizontalCoordinate:Wt,getVerticalCoordinate:Vt,getCoordinateString:Gt,getVerticalCoordinateString:Yt,collections:{},newObject:J,newAdditionalObject:at,newObjectDeferred:X,newObjectDeferredBegin:ot,getFilters:ct,putStream:ft,events:it,scaleFactor:_,pageSize:{getWidth:function(){return(V[x].mediaBox.topRightX-V[x].mediaBox.bottomLeftX)/_},setWidth:function(t){V[x].mediaBox.topRightX=t*_+V[x].mediaBox.bottomLeftX},getHeight:function(){return(V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY)/_},setHeight:function(t){V[x].mediaBox.topRightY=t*_+V[x].mediaBox.bottomLeftY}},output:Ct,getNumberOfPages:Nt,pages:I,out:tt,f2:Z,f3:Q,getPageInfo:jt,getPageInfoByObjId:Et,getCurrentPageInfo:Mt,getPDFVersion:u,hasHotfix:Bt},Object.defineProperty(l.internal.pageSize,"width",{get:function(){return(V[x].mediaBox.topRightX-V[x].mediaBox.bottomLeftX)/_},set:function(t){V[x].mediaBox.topRightX=t*_+V[x].mediaBox.bottomLeftX},enumerable:!0,configurable:!0}),Object.defineProperty(l.internal.pageSize,"height",{get:function(){return(V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY)/_},set:function(t){V[x].mediaBox.topRightY=t*_+V[x].mediaBox.bottomLeftY},enumerable:!0,configurable:!0}),function(t){for(var e=0,n=M.length;e<n;e++){var r=yt(t[e][0],t[e][1],t[e][2],M[e][3],!0);K[r]=!0;var i=t[e][0].split("-");mt(r,i[0],i[1]||"")}it.publish("addFonts",{fonts:rt,dictionary:H})}(M),$="F1",bt(i,t),it.publish("initialized"),l}return ae.API={events:[]},ae.version="1.5.3", true?!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return ae}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof module&&module.exports?(module.exports=ae,module.exports.jsPDF=ae):ie.jsPDF=ae,ae}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());
/**
   * @license
   * Copyright (c) 2016 Alexander Weidt,
   * https://github.com/BiggA94
   * 
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */
(function(t,e){var A,n=1,S=function(t){return t.replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},y=function(t){return t.replace(/\\\\/g,"\\").replace(/\\\(/g,"(").replace(/\\\)/g,")")},_=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return t.toFixed(2)},s=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return t.toFixed(5)};t.__acroform__={};var r=function(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t},v=function(t){return t*n},w=function(t){return t/n},l=function(t){var e=new j,n=Y.internal.getHeight(t)||0,r=Y.internal.getWidth(t)||0;return e.BBox=[0,0,Number(_(r)),Number(_(n))],e},i=t.__acroform__.setBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");return t|=1<<e},o=t.__acroform__.clearBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");return t&=~(1<<e)},a=t.__acroform__.getBit=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");return 0==(t&1<<e)?0:1},b=t.__acroform__.getBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");return a(t,e-1)},x=t.__acroform__.setBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");return i(t,e-1)},N=t.__acroform__.clearBitForPdf=function(t,e,n){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");return o(t,e-1)},c=t.__acroform__.calculateCoordinates=function(t){var e=this.internal.getHorizontalCoordinate,n=this.internal.getVerticalCoordinate,r=t[0],i=t[1],o=t[2],a=t[3],s={};return s.lowerLeft_X=e(r)||0,s.lowerLeft_Y=n(i+a)||0,s.upperRight_X=e(r+o)||0,s.upperRight_Y=n(i)||0,[Number(_(s.lowerLeft_X)),Number(_(s.lowerLeft_Y)),Number(_(s.upperRight_X)),Number(_(s.upperRight_Y))]},f=function(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e=[],n=t.V||t.DV,r=h(t,n),i=A.internal.getFont(t.fontName,t.fontStyle).id;e.push("/Tx BMC"),e.push("q"),e.push("BT"),e.push(A.__private__.encodeColorString(t.color)),e.push("/"+i+" "+_(r.fontSize)+" Tf"),e.push("1 0 0 1 0 0 Tm"),e.push(r.text),e.push("ET"),e.push("Q"),e.push("EMC");var o=new l(t);return o.stream=e.join("\n"),o}},h=function(i,t){var e=i.maxFontSize||12,n=(i.fontName,{text:"",fontSize:""}),o=(t=")"==(t="("==t.substr(0,1)?t.substr(1):t).substr(t.length-1)?t.substr(0,t.length-1):t).split(" "),r=(A.__private__.encodeColorString(i.color),e),a=Y.internal.getHeight(i)||0;a=a<0?-a:a;var s=Y.internal.getWidth(i)||0;s=s<0?-s:s;var l=function(t,e,n){if(t+1<o.length){var r=e+" "+o[t+1];return F(r,i,n).width<=s-4}return!1};r++;t:for(;;){t="";var h=F("3",i,--r).height,u=i.multiline?a-r:(a-h)/2,c=-2,f=u+=2,p=0,d=0,g=0;if(r<=0){t="(...) Tj\n",t+="% Width of Text: "+F(t,i,r=12).width+", FieldWidth:"+s+"\n";break}g=F(o[0]+" ",i,r).width;var m="",y=0;for(var v in o)if(o.hasOwnProperty(v)){m=" "==(m+=o[v]+" ").substr(m.length-1)?m.substr(0,m.length-1):m;var w=parseInt(v);g=F(m+" ",i,r).width;var b=l(w,m,r),x=v>=o.length-1;if(b&&!x){m+=" ";continue}if(b||x){if(x)d=w;else if(i.multiline&&a<(h+2)*(y+2)+2)continue t}else{if(!i.multiline)continue t;if(a<(h+2)*(y+2)+2)continue t;d=w}for(var N="",L=p;L<=d;L++)N+=o[L]+" ";switch(N=" "==N.substr(N.length-1)?N.substr(0,N.length-1):N,g=F(N,i,r).width,i.textAlign){case"right":c=s-g-2;break;case"center":c=(s-g)/2;break;case"left":default:c=2}t+=_(c)+" "+_(f)+" Td\n",t+="("+S(N)+") Tj\n",t+=-_(c)+" 0 Td\n",f=-(r+2),g=0,p=d+1,y++,m=""}else;break}return n.text=t,n.fontSize=r,n},F=function(t,e,n){var r=A.internal.getFont(e.fontName,e.fontStyle),i=A.getStringUnitWidth(t,{font:r,fontSize:parseFloat(n),charSpace:0})*parseFloat(n);return{height:A.getStringUnitWidth("3",{font:r,fontSize:parseFloat(n),charSpace:0})*parseFloat(n)*1.5,width:i}},u={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null,isInitialized:!1},p=function(){A.internal.acroformPlugin.acroFormDictionaryRoot.objId=void 0;var t=A.internal.acroformPlugin.acroFormDictionaryRoot.Fields;for(var e in t)if(t.hasOwnProperty(e)){var n=t[e];n.objId=void 0,n.hasAnnotation&&d.call(A,n)}},d=function(t){var e={type:"reference",object:t};void 0===A.internal.getPageInfo(t.page).pageContext.annotations.find(function(t){return t.type===e.type&&t.object===e.object})&&A.internal.getPageInfo(t.page).pageContext.annotations.push(e)},g=function(){if(void 0===A.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("putCatalogCallback: Root missing.");A.internal.write("/AcroForm "+A.internal.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R")},m=function(){A.internal.events.unsubscribe(A.internal.acroformPlugin.acroFormDictionaryRoot._eventID),delete A.internal.acroformPlugin.acroFormDictionaryRoot._eventID,A.internal.acroformPlugin.printedOut=!0},L=function(t){var e=!t;t||(A.internal.newObjectDeferredBegin(A.internal.acroformPlugin.acroFormDictionaryRoot.objId,!0),A.internal.acroformPlugin.acroFormDictionaryRoot.putStream());t=t||A.internal.acroformPlugin.acroFormDictionaryRoot.Kids;for(var n in t)if(t.hasOwnProperty(n)){var r=t[n],i=[],o=r.Rect;if(r.Rect&&(r.Rect=c.call(this,r.Rect)),A.internal.newObjectDeferredBegin(r.objId,!0),r.DA=Y.createDefaultAppearanceStream(r),"object"===se(r)&&"function"==typeof r.getKeyValueListForStream&&(i=r.getKeyValueListForStream()),r.Rect=o,r.hasAppearanceStream&&!r.appearanceStreamContent){var a=f.call(this,r);i.push({key:"AP",value:"<</N "+a+">>"}),A.internal.acroformPlugin.xForms.push(a)}if(r.appearanceStreamContent){var s="";for(var l in r.appearanceStreamContent)if(r.appearanceStreamContent.hasOwnProperty(l)){var h=r.appearanceStreamContent[l];if(s+="/"+l+" ",s+="<<",1<=Object.keys(h).length||Array.isArray(h))for(var n in h){var u;if(h.hasOwnProperty(n))"function"==typeof(u=h[n])&&(u=u.call(this,r)),s+="/"+n+" "+u+" ",0<=A.internal.acroformPlugin.xForms.indexOf(u)||A.internal.acroformPlugin.xForms.push(u)}else"function"==typeof(u=h)&&(u=u.call(this,r)),s+="/"+n+" "+u,0<=A.internal.acroformPlugin.xForms.indexOf(u)||A.internal.acroformPlugin.xForms.push(u);s+=">>"}i.push({key:"AP",value:"<<\n"+s+">>"})}A.internal.putStream({additionalKeyValues:i}),A.internal.out("endobj")}e&&P.call(this,A.internal.acroformPlugin.xForms)},P=function(t){for(var e in t)if(t.hasOwnProperty(e)){var n=e,r=t[e];A.internal.newObjectDeferredBegin(r&&r.objId,!0),"object"===se(r)&&"function"==typeof r.putStream&&r.putStream(),delete t[n]}},k=function(){if(void 0!==this.internal&&(void 0===this.internal.acroformPlugin||!1===this.internal.acroformPlugin.isInitialized)){if(A=this,M.FieldNum=0,this.internal.acroformPlugin=JSON.parse(JSON.stringify(u)),this.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");n=A.internal.scaleFactor,A.internal.acroformPlugin.acroFormDictionaryRoot=new E,A.internal.acroformPlugin.acroFormDictionaryRoot._eventID=A.internal.events.subscribe("postPutResources",m),A.internal.events.subscribe("buildDocument",p),A.internal.events.subscribe("putCatalog",g),A.internal.events.subscribe("postPutPages",L),A.internal.acroformPlugin.isInitialized=!0}},I=t.__acroform__.arrayToPdfArray=function(t){if(Array.isArray(t)){for(var e="[",n=0;n<t.length;n++)switch(0!==n&&(e+=" "),se(t[n])){case"boolean":case"number":case"object":e+=t[n].toString();break;case"string":"/"!==t[n].substr(0,1)?e+="("+S(t[n].toString())+")":e+=t[n].toString()}return e+="]"}throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray")};var C=function(t){return(t=t||"").toString(),t="("+S(t)+")"},B=function(){var e;Object.defineProperty(this,"objId",{configurable:!0,get:function(){if(e||(e=A.internal.newObjectDeferred()),!e)throw new Error("AcroFormPDFObject: Couldn't create Object ID");return e},set:function(t){e=t}})};B.prototype.toString=function(){return this.objId+" 0 R"},B.prototype.putStream=function(){var t=this.getKeyValueListForStream();A.internal.putStream({data:this.stream,additionalKeyValues:t}),A.internal.out("endobj")},B.prototype.getKeyValueListForStream=function(){return function(t){var e=[],n=Object.getOwnPropertyNames(t).filter(function(t){return"content"!=t&&"appearanceStreamContent"!=t&&"_"!=t.substring(0,1)});for(var r in n)if(!1===Object.getOwnPropertyDescriptor(t,n[r]).configurable){var i=n[r],o=t[i];o&&(Array.isArray(o)?e.push({key:i,value:I(o)}):o instanceof B?e.push({key:i,value:o.objId+" 0 R"}):"function"!=typeof o&&e.push({key:i,value:o}))}return e}(this)};var j=function(){B.call(this),Object.defineProperty(this,"Type",{value:"/XObject",configurable:!1,writeable:!0}),Object.defineProperty(this,"Subtype",{value:"/Form",configurable:!1,writeable:!0}),Object.defineProperty(this,"FormType",{value:1,configurable:!1,writeable:!0});var e,n=[];Object.defineProperty(this,"BBox",{configurable:!1,writeable:!0,get:function(){return n},set:function(t){n=t}}),Object.defineProperty(this,"Resources",{value:"2 0 R",configurable:!1,writeable:!0}),Object.defineProperty(this,"stream",{enumerable:!1,configurable:!0,set:function(t){e=t.trim()},get:function(){return e||null}})};r(j,B);var E=function(){B.call(this);var e,t=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return 0<t.length?t:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!1,configurable:!1,get:function(){return t}}),Object.defineProperty(this,"DA",{enumerable:!1,configurable:!1,get:function(){if(e)return"("+e+")"},set:function(t){e=t}})};r(E,B);var M=function t(){B.call(this);var e=4;Object.defineProperty(this,"F",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute F supplied.');e=t}}),Object.defineProperty(this,"showWhenPrinted",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(e,3))},set:function(t){!0===Boolean(t)?this.F=x(e,3):this.F=N(e,3)}});var n=0;Object.defineProperty(this,"Ff",{enumerable:!1,configurable:!1,get:function(){return n},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute Ff supplied.');n=t}});var r=[];Object.defineProperty(this,"Rect",{enumerable:!1,configurable:!1,get:function(){if(0!==r.length)return r},set:function(t){r=void 0!==t?t:[]}}),Object.defineProperty(this,"x",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[0])?0:w(r[0])},set:function(t){r[0]=v(t)}}),Object.defineProperty(this,"y",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[1])?0:w(r[1])},set:function(t){r[1]=v(t)}}),Object.defineProperty(this,"width",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[2])?0:w(r[2])},set:function(t){r[2]=v(t)}}),Object.defineProperty(this,"height",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[3])?0:w(r[3])},set:function(t){r[3]=v(t)}});var i="";Object.defineProperty(this,"FT",{enumerable:!0,configurable:!1,get:function(){return i},set:function(t){switch(t){case"/Btn":case"/Tx":case"/Ch":case"/Sig":i=t;break;default:throw new Error('Invalid value "'+t+'" for attribute FT supplied.')}}});var o=null;Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,get:function(){if(!o||o.length<1){if(this instanceof H)return;o="FieldObject"+t.FieldNum++}return"("+S(o)+")"},set:function(t){o=t.toString()}}),Object.defineProperty(this,"fieldName",{configurable:!0,enumerable:!0,get:function(){return o},set:function(t){o=t}});var a="helvetica";Object.defineProperty(this,"fontName",{enumerable:!0,configurable:!0,get:function(){return a},set:function(t){a=t}});var s="normal";Object.defineProperty(this,"fontStyle",{enumerable:!0,configurable:!0,get:function(){return s},set:function(t){s=t}});var l=0;Object.defineProperty(this,"fontSize",{enumerable:!0,configurable:!0,get:function(){return w(l)},set:function(t){l=v(t)}});var h=50;Object.defineProperty(this,"maxFontSize",{enumerable:!0,configurable:!0,get:function(){return w(h)},set:function(t){h=v(t)}});var u="black";Object.defineProperty(this,"color",{enumerable:!0,configurable:!0,get:function(){return u},set:function(t){u=t}});var c="/F1 0 Tf 0 g";Object.defineProperty(this,"DA",{enumerable:!0,configurable:!1,get:function(){if(!(!c||this instanceof H||this instanceof V))return C(c)},set:function(t){t=t.toString(),c=t}});var f=null;Object.defineProperty(this,"DV",{enumerable:!1,configurable:!1,get:function(){if(f)return this instanceof D==!1?C(f):f},set:function(t){t=t.toString(),f=this instanceof D==!1?"("===t.substr(0,1)?y(t.substr(1,t.length-2)):y(t):t}}),Object.defineProperty(this,"defaultValue",{enumerable:!0,configurable:!0,get:function(){return this instanceof D==!0?y(f.substr(1,f.length-1)):f},set:function(t){t=t.toString(),f=this instanceof D==!0?"/"+t:t}});var p=null;Object.defineProperty(this,"V",{enumerable:!1,configurable:!1,get:function(){if(p)return this instanceof D==!1?C(p):p},set:function(t){t=t.toString(),p=this instanceof D==!1?"("===t.substr(0,1)?y(t.substr(1,t.length-2)):y(t):t}}),Object.defineProperty(this,"value",{enumerable:!0,configurable:!0,get:function(){return this instanceof D==!0?y(p.substr(1,p.length-1)):p},set:function(t){t=t.toString(),p=this instanceof D==!0?"/"+t:t}}),Object.defineProperty(this,"hasAnnotation",{enumerable:!0,configurable:!0,get:function(){return this.Rect}}),Object.defineProperty(this,"Type",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Widget":null}});var d,g=!1;Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,writeable:!0,get:function(){return g},set:function(t){t=Boolean(t),g=t}}),Object.defineProperty(this,"page",{enumerable:!0,configurable:!0,writeable:!0,get:function(){if(d)return d},set:function(t){d=t}}),Object.defineProperty(this,"readOnly",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,1))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,1):this.Ff=N(this.Ff,1)}}),Object.defineProperty(this,"required",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,2))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,2):this.Ff=N(this.Ff,2)}}),Object.defineProperty(this,"noExport",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,3))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,3):this.Ff=N(this.Ff,3)}});var m=null;Object.defineProperty(this,"Q",{enumerable:!0,configurable:!1,get:function(){if(null!==m)return m},set:function(t){if(-1===[0,1,2].indexOf(t))throw new Error('Invalid value "'+t+'" for attribute Q supplied.');m=t}}),Object.defineProperty(this,"textAlign",{get:function(){var t="left";switch(m){case 0:default:t="left";break;case 1:t="center";break;case 2:t="right"}return t},configurable:!0,enumerable:!0,set:function(t){switch(t){case"right":case 2:m=2;break;case"center":case 1:m=1;break;case"left":case 0:default:m=0}}})};r(M,B);var O=function(){M.call(this),this.FT="/Ch",this.V="()",this.fontName="zapfdingbats";var e=0;Object.defineProperty(this,"TI",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"topIndex",{enumerable:!0,configurable:!0,get:function(){return e},set:function(t){e=t}});var r=[];Object.defineProperty(this,"Opt",{enumerable:!0,configurable:!1,get:function(){return I(r)},set:function(t){var e,n;n=[],"string"==typeof(e=t)&&(n=function(t,e,n){n||(n=1);for(var r,i=[];r=e.exec(t);)i.push(r[n]);return i}(e,/\((.*?)\)/g)),r=n}}),this.getOptions=function(){return r},this.setOptions=function(t){r=t,this.sort&&r.sort()},this.addOption=function(t){t=(t=t||"").toString(),r.push(t),this.sort&&r.sort()},this.removeOption=function(t,e){for(e=e||!1,t=(t=t||"").toString();-1!==r.indexOf(t)&&(r.splice(r.indexOf(t),1),!1!==e););},Object.defineProperty(this,"combo",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,18))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,18):this.Ff=N(this.Ff,18)}}),Object.defineProperty(this,"edit",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,19))},set:function(t){!0===this.combo&&(!0===Boolean(t)?this.Ff=x(this.Ff,19):this.Ff=N(this.Ff,19))}}),Object.defineProperty(this,"sort",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,20))},set:function(t){!0===Boolean(t)?(this.Ff=x(this.Ff,20),r.sort()):this.Ff=N(this.Ff,20)}}),Object.defineProperty(this,"multiSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,22))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,22):this.Ff=N(this.Ff,22)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,23):this.Ff=N(this.Ff,23)}}),Object.defineProperty(this,"commitOnSelChange",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,27))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,27):this.Ff=N(this.Ff,27)}}),this.hasAppearanceStream=!1};r(O,M);var q=function(){O.call(this),this.fontName="helvetica",this.combo=!1};r(q,O);var T=function(){q.call(this),this.combo=!0};r(T,q);var R=function(){T.call(this),this.edit=!0};r(R,T);var D=function(){M.call(this),this.FT="/Btn",Object.defineProperty(this,"noToggleToOff",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,15))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,15):this.Ff=N(this.Ff,15)}}),Object.defineProperty(this,"radio",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,16))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,16):this.Ff=N(this.Ff,16)}}),Object.defineProperty(this,"pushButton",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,17))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,17):this.Ff=N(this.Ff,17)}}),Object.defineProperty(this,"radioIsUnison",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,26):this.Ff=N(this.Ff,26)}});var e,n={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){if(0!==Object.keys(n).length){var t,e=[];for(t in e.push("<<"),n)e.push("/"+t+" ("+n[t]+")");return e.push(">>"),e.join("\n")}},set:function(t){"object"===se(t)&&(n=t)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return n.CA||""},set:function(t){"string"==typeof t&&(n.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return e.substr(1,e.length-1)},set:function(t){e="/"+t}})};r(D,M);var U=function(){D.call(this),this.pushButton=!0};r(U,D);var z=function(){D.call(this),this.radio=!0,this.pushButton=!1;var e=[];Object.defineProperty(this,"Kids",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=void 0!==t?t:[]}})};r(z,D);var H=function(){var e,n;M.call(this),Object.defineProperty(this,"Parent",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"optionName",{enumerable:!1,configurable:!0,get:function(){return n},set:function(t){n=t}});var r,i={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){var t,e=[];for(t in e.push("<<"),i)e.push("/"+t+" ("+i[t]+")");return e.push(">>"),e.join("\n")},set:function(t){"object"===se(t)&&(i=t)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return i.CA||""},set:function(t){"string"==typeof t&&(i.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return r},set:function(t){r=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return r.substr(1,r.length-1)},set:function(t){r="/"+t}}),this.optionName=name,this.caption="l",this.appearanceState="Off",this._AppearanceType=Y.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(name)};r(H,M),z.prototype.setAppearance=function(t){if(!("createAppearanceStream"in t&&"getCA"in t))throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");for(var e in this.Kids)if(this.Kids.hasOwnProperty(e)){var n=this.Kids[e];n.appearanceStreamContent=t.createAppearanceStream(n.optionName),n.caption=t.getCA()}},z.prototype.createOption=function(t){this.Kids.length;var e=new H;return e.Parent=this,e.optionName=t,this.Kids.push(e),J.call(this,e),e};var W=function(){D.call(this),this.fontName="zapfdingbats",this.caption="3",this.appearanceState="On",this.value="On",this.textAlign="center",this.appearanceStreamContent=Y.CheckBox.createAppearanceStream()};r(W,D);var V=function(){M.call(this),this.FT="/Tx",Object.defineProperty(this,"multiline",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,13))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,13):this.Ff=N(this.Ff,13)}}),Object.defineProperty(this,"fileSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,21))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,21):this.Ff=N(this.Ff,21)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,23):this.Ff=N(this.Ff,23)}}),Object.defineProperty(this,"doNotScroll",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,24))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,24):this.Ff=N(this.Ff,24)}}),Object.defineProperty(this,"comb",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,25))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,25):this.Ff=N(this.Ff,25)}}),Object.defineProperty(this,"richText",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,26):this.Ff=N(this.Ff,26)}});var e=null;Object.defineProperty(this,"MaxLen",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"maxLength",{enumerable:!0,configurable:!0,get:function(){return e},set:function(t){Number.isInteger(t)&&(e=t)}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,get:function(){return this.V||this.DV}})};r(V,M);var G=function(){V.call(this),Object.defineProperty(this,"password",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,14))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,14):this.Ff=N(this.Ff,14)}}),this.password=!0};r(G,V);var Y={CheckBox:{createAppearanceStream:function(){return{N:{On:Y.CheckBox.YesNormal},D:{On:Y.CheckBox.YesPushDown,Off:Y.CheckBox.OffPushDown}}},YesPushDown:function(t){var e=l(t),n=[],r=A.internal.getFont(t.fontName,t.fontStyle).id,i=A.__private__.encodeColorString(t.color),o=h(t,t.caption);return n.push("0.749023 g"),n.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),n.push("f"),n.push("BMC"),n.push("q"),n.push("0 0 1 rg"),n.push("/"+r+" "+_(o.fontSize)+" Tf "+i),n.push("BT"),n.push(o.text),n.push("ET"),n.push("Q"),n.push("EMC"),e.stream=n.join("\n"),e},YesNormal:function(t){var e=l(t),n=A.internal.getFont(t.fontName,t.fontStyle).id,r=A.__private__.encodeColorString(t.color),i=[],o=Y.internal.getHeight(t),a=Y.internal.getWidth(t),s=h(t,t.caption);return i.push("1 g"),i.push("0 0 "+_(a)+" "+_(o)+" re"),i.push("f"),i.push("q"),i.push("0 0 1 rg"),i.push("0 0 "+_(a-1)+" "+_(o-1)+" re"),i.push("W"),i.push("n"),i.push("0 g"),i.push("BT"),i.push("/"+n+" "+_(s.fontSize)+" Tf "+r),i.push(s.text),i.push("ET"),i.push("Q"),e.stream=i.join("\n"),e},OffPushDown:function(t){var e=l(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),n.push("f"),e.stream=n.join("\n"),e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:Y.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=Y.RadioButton.Circle.YesNormal,e.D[t]=Y.RadioButton.Circle.YesPushDown,e},getCA:function(){return"l"},YesNormal:function(t){var e=l(t),n=[],r=Y.internal.getWidth(t)<=Y.internal.getHeight(t)?Y.internal.getWidth(t)/4:Y.internal.getHeight(t)/4;r=Number((.9*r).toFixed(5));var i=Y.internal.Bezier_C,o=Number((r*i).toFixed(5));return n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(r+" 0 m"),n.push(r+" "+o+" "+o+" "+r+" 0 "+r+" c"),n.push("-"+o+" "+r+" -"+r+" "+o+" -"+r+" 0 c"),n.push("-"+r+" -"+o+" -"+o+" -"+r+" 0 -"+r+" c"),n.push(o+" -"+r+" "+r+" -"+o+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=l(t),n=[],r=Y.internal.getWidth(t)<=Y.internal.getHeight(t)?Y.internal.getWidth(t)/4:Y.internal.getHeight(t)/4,i=(r=Number((.9*r).toFixed(5)),Number((2*r).toFixed(5))),o=Number((i*Y.internal.Bezier_C).toFixed(5)),a=Number((r*Y.internal.Bezier_C).toFixed(5));return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),n.push("0 g"),n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(r+" 0 m"),n.push(r+" "+a+" "+a+" "+r+" 0 "+r+" c"),n.push("-"+a+" "+r+" -"+r+" "+a+" -"+r+" 0 c"),n.push("-"+r+" -"+a+" -"+a+" -"+r+" 0 -"+r+" c"),n.push(a+" -"+r+" "+r+" -"+a+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},OffPushDown:function(t){var e=l(t),n=[],r=Y.internal.getWidth(t)<=Y.internal.getHeight(t)?Y.internal.getWidth(t)/4:Y.internal.getHeight(t)/4,i=(r=Number((.9*r).toFixed(5)),Number((2*r).toFixed(5))),o=Number((i*Y.internal.Bezier_C).toFixed(5));return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:Y.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=Y.RadioButton.Cross.YesNormal,e.D[t]=Y.RadioButton.Cross.YesPushDown,e},getCA:function(){return"8"},YesNormal:function(t){var e=l(t),n=[],r=Y.internal.calculateCross(t);return n.push("q"),n.push("1 1 "+_(Y.internal.getWidth(t)-2)+" "+_(Y.internal.getHeight(t)-2)+" re"),n.push("W"),n.push("n"),n.push(_(r.x1.x)+" "+_(r.x1.y)+" m"),n.push(_(r.x2.x)+" "+_(r.x2.y)+" l"),n.push(_(r.x4.x)+" "+_(r.x4.y)+" m"),n.push(_(r.x3.x)+" "+_(r.x3.y)+" l"),n.push("s"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=l(t),n=Y.internal.calculateCross(t),r=[];return r.push("0.749023 g"),r.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),r.push("f"),r.push("q"),r.push("1 1 "+_(Y.internal.getWidth(t)-2)+" "+_(Y.internal.getHeight(t)-2)+" re"),r.push("W"),r.push("n"),r.push(_(n.x1.x)+" "+_(n.x1.y)+" m"),r.push(_(n.x2.x)+" "+_(n.x2.y)+" l"),r.push(_(n.x4.x)+" "+_(n.x4.y)+" m"),r.push(_(n.x3.x)+" "+_(n.x3.y)+" l"),r.push("s"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=l(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),n.push("f"),e.stream=n.join("\n"),e}}},createDefaultAppearanceStream:function(t){var e=A.internal.getFont(t.fontName,t.fontStyle).id,n=A.__private__.encodeColorString(t.color);return"/"+e+" "+t.fontSize+" Tf "+n}};Y.internal={Bezier_C:.551915024494,calculateCross:function(t){var e=Y.internal.getWidth(t),n=Y.internal.getHeight(t),r=Math.min(e,n);return{x1:{x:(e-r)/2,y:(n-r)/2+r},x2:{x:(e-r)/2+r,y:(n-r)/2},x3:{x:(e-r)/2,y:(n-r)/2},x4:{x:(e-r)/2+r,y:(n-r)/2+r}}}},Y.internal.getWidth=function(t){var e=0;return"object"===se(t)&&(e=v(t.Rect[2])),e},Y.internal.getHeight=function(t){var e=0;return"object"===se(t)&&(e=v(t.Rect[3])),e};var J=t.addField=function(t){if(k.call(this),!(t instanceof M))throw new Error("Invalid argument passed to jsPDF.addField.");return function(t){A.internal.acroformPlugin.printedOut&&(A.internal.acroformPlugin.printedOut=!1,A.internal.acroformPlugin.acroFormDictionaryRoot=null),A.internal.acroformPlugin.acroFormDictionaryRoot||k.call(A),A.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t)}.call(this,t),t.page=A.internal.getCurrentPageInfo().pageNumber,this};t.addButton=function(t){if(t instanceof D==!1)throw new Error("Invalid argument passed to jsPDF.addButton.");return J.call(this,t)},t.addTextField=function(t){if(t instanceof V==!1)throw new Error("Invalid argument passed to jsPDF.addTextField.");return J.call(this,t)},t.addChoiceField=function(t){if(t instanceof O==!1)throw new Error("Invalid argument passed to jsPDF.addChoiceField.");return J.call(this,t)};"object"==se(e)&&void 0===e.ChoiceField&&void 0===e.ListBox&&void 0===e.ComboBox&&void 0===e.EditBox&&void 0===e.Button&&void 0===e.PushButton&&void 0===e.RadioButton&&void 0===e.CheckBox&&void 0===e.TextField&&void 0===e.PasswordField?(e.ChoiceField=O,e.ListBox=q,e.ComboBox=T,e.EditBox=R,e.Button=D,e.PushButton=U,e.RadioButton=z,e.CheckBox=W,e.TextField=V,e.PasswordField=G,e.AcroForm={Appearance:Y}):console.warn("AcroForm-Classes are not populated into global-namespace, because the class-Names exist already."),t.AcroFormChoiceField=O,t.AcroFormListBox=q,t.AcroFormComboBox=T,t.AcroFormEditBox=R,t.AcroFormButton=D,t.AcroFormPushButton=U,t.AcroFormRadioButton=z,t.AcroFormCheckBox=W,t.AcroFormTextField=V,t.AcroFormPasswordField=G,t.AcroFormAppearance=Y,t.AcroForm={ChoiceField:O,ListBox:q,ComboBox:T,EditBox:R,Button:D,PushButton:U,RadioButton:z,CheckBox:W,TextField:V,PasswordField:G,Appearance:Y}})((window.tmp=lt).API,"undefined"!=typeof window&&window||"undefined"!=typeof global&&global),
/** @license
   * jsPDF addImage plugin
   * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
   *               2013 Chris Dowling, https://github.com/gingerchris
   *               2013 Trinh Ho, https://github.com/ineedfat
   *               2013 Edwin Alejandro Perez, https://github.com/eaparango
   *               2013 Norah Smith, https://github.com/burnburnrocket
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   */
function(x){var N="addImage_",l={PNG:[[137,80,78,71]],TIFF:[[77,77,0,42],[73,73,42,0]],JPEG:[[255,216,255,224,void 0,void 0,74,70,73,70,0],[255,216,255,225,void 0,void 0,69,120,105,102,0,0]],JPEG2000:[[0,0,0,12,106,80,32,32]],GIF87a:[[71,73,70,56,55,97]],GIF89a:[[71,73,70,56,57,97]],BMP:[[66,77],[66,65],[67,73],[67,80],[73,67],[80,84]]},h=x.getImageFileTypeByImageData=function(t,e){var n,r;e=e||"UNKNOWN";var i,o,a,s="UNKNOWN";for(a in x.isArrayBufferView(t)&&(t=x.arrayBufferToBinaryString(t)),l)for(i=l[a],n=0;n<i.length;n+=1){for(o=!0,r=0;r<i[n].length;r+=1)if(void 0!==i[n][r]&&i[n][r]!==t.charCodeAt(r)){o=!1;break}if(!0===o){s=a;break}}return"UNKNOWN"===s&&"UNKNOWN"!==e&&(console.warn('FileType of Image not recognized. Processing image as "'+e+'".'),s=e),s},n=function t(e){for(var n=this.internal.newObject(),r=this.internal.write,i=this.internal.putStream,o=(0,this.internal.getFilters)();-1!==o.indexOf("FlateEncode");)o.splice(o.indexOf("FlateEncode"),1);e.n=n;var a=[];if(a.push({key:"Type",value:"/XObject"}),a.push({key:"Subtype",value:"/Image"}),a.push({key:"Width",value:e.w}),a.push({key:"Height",value:e.h}),e.cs===this.color_spaces.INDEXED?a.push({key:"ColorSpace",value:"[/Indexed /DeviceRGB "+(e.pal.length/3-1)+" "+("smask"in e?n+2:n+1)+" 0 R]"}):(a.push({key:"ColorSpace",value:"/"+e.cs}),e.cs===this.color_spaces.DEVICE_CMYK&&a.push({key:"Decode",value:"[1 0 1 0 1 0 1 0]"})),a.push({key:"BitsPerComponent",value:e.bpc}),"dp"in e&&a.push({key:"DecodeParms",value:"<<"+e.dp+">>"}),"trns"in e&&e.trns.constructor==Array){for(var s="",l=0,h=e.trns.length;l<h;l++)s+=e.trns[l]+" "+e.trns[l]+" ";a.push({key:"Mask",value:"["+s+"]"})}"smask"in e&&a.push({key:"SMask",value:n+1+" 0 R"});var u=void 0!==e.f?["/"+e.f]:void 0;if(i({data:e.data,additionalKeyValues:a,alreadyAppliedFilters:u}),r("endobj"),"smask"in e){var c="/Predictor "+e.p+" /Colors 1 /BitsPerComponent "+e.bpc+" /Columns "+e.w,f={w:e.w,h:e.h,cs:"DeviceGray",bpc:e.bpc,dp:c,data:e.smask};"f"in e&&(f.f=e.f),t.call(this,f)}e.cs===this.color_spaces.INDEXED&&(this.internal.newObject(),i({data:this.arrayBufferToBinaryString(new Uint8Array(e.pal))}),r("endobj"))},L=function(){var t=this.internal.collections[N+"images"];for(var e in t)n.call(this,t[e])},A=function(){var t,e=this.internal.collections[N+"images"],n=this.internal.write;for(var r in e)n("/I"+(t=e[r]).i,t.n,"0","R")},S=function(t){return"function"==typeof x["process"+t.toUpperCase()]},_=function(t){return"object"===se(t)&&1===t.nodeType},F=function(t,e){if("IMG"===t.nodeName&&t.hasAttribute("src")){var n=""+t.getAttribute("src");if(0===n.indexOf("data:image/"))return unescape(n);var r=x.loadFile(n);if(void 0!==r)return btoa(r)}if("CANVAS"===t.nodeName){var i=t;return t.toDataURL("image/jpeg",1)}(i=document.createElement("canvas")).width=t.clientWidth||t.width,i.height=t.clientHeight||t.height;var o=i.getContext("2d");if(!o)throw"addImage requires canvas to be supported by browser.";return o.drawImage(t,0,0,i.width,i.height),i.toDataURL("png"==(""+e).toLowerCase()?"image/png":"image/jpeg")},P=function(t,e){var n;if(e)for(var r in e)if(t===e[r].alias){n=e[r];break}return n};x.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"},x.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"},x.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},x.sHashCode=function(t){var e,n=0;if(0===(t=t||"").length)return n;for(e=0;e<t.length;e++)n=(n<<5)-n+t.charCodeAt(e),n|=0;return n},x.isString=function(t){return"string"==typeof t},x.validateStringAsBase64=function(t){(t=t||"").toString().trim();var e=!0;return 0===t.length&&(e=!1),t.length%4!=0&&(e=!1),!1===/^[A-Za-z0-9+\/]+$/.test(t.substr(0,t.length-2))&&(e=!1),!1===/^[A-Za-z0-9\/][A-Za-z0-9+\/]|[A-Za-z0-9+\/]=|==$/.test(t.substr(-2))&&(e=!1),e},x.extractInfoFromBase64DataURI=function(t){return/^data:([\w]+?\/([\w]+?));\S*;*base64,(.+)$/g.exec(t)},x.extractImageFromDataUrl=function(t){var e=(t=t||"").split("base64,"),n=null;if(2===e.length){var r=/^data:(\w*\/\w*);*(charset=[\w=-]*)*;*$/.exec(e[0]);Array.isArray(r)&&(n={mimeType:r[1],charset:r[2],data:e[1]})}return n},x.supportsArrayBuffer=function(){return"undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array},x.isArrayBuffer=function(t){return!!this.supportsArrayBuffer()&&t instanceof ArrayBuffer},x.isArrayBufferView=function(t){return!!this.supportsArrayBuffer()&&("undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array))},x.binaryStringToUint8Array=function(t){for(var e=t.length,n=new Uint8Array(e),r=0;r<e;r++)n[r]=t.charCodeAt(r);return n},x.arrayBufferToBinaryString=function(t){if("function"==typeof atob)return atob(this.arrayBufferToBase64(t))},x.arrayBufferToBase64=function(t){for(var e,n="",r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",i=new Uint8Array(t),o=i.byteLength,a=o%3,s=o-a,l=0;l<s;l+=3)n+=r[(16515072&(e=i[l]<<16|i[l+1]<<8|i[l+2]))>>18]+r[(258048&e)>>12]+r[(4032&e)>>6]+r[63&e];return 1==a?n+=r[(252&(e=i[s]))>>2]+r[(3&e)<<4]+"==":2==a&&(n+=r[(64512&(e=i[s]<<8|i[s+1]))>>10]+r[(1008&e)>>4]+r[(15&e)<<2]+"="),n},x.createImageInfo=function(t,e,n,r,i,o,a,s,l,h,u,c,f){var p={alias:s,w:e,h:n,cs:r,bpc:i,i:a,data:t};return o&&(p.f=o),l&&(p.dp=l),h&&(p.trns=h),u&&(p.pal=u),c&&(p.smask=c),f&&(p.p=f),p},x.addImage=function(t,e,n,r,i,o,a,s,l){var h="";if("string"!=typeof e){var u=o;o=i,i=r,r=n,n=e,e=u}if("object"===se(t)&&!_(t)&&"imageData"in t){var c=t;t=c.imageData,e=c.format||e||"UNKNOWN",n=c.x||n||0,r=c.y||r||0,i=c.w||i,o=c.h||o,a=c.alias||a,s=c.compression||s,l=c.rotation||c.angle||l}var f=this.internal.getFilters();if(void 0===s&&-1!==f.indexOf("FlateEncode")&&(s="SLOW"),"string"==typeof t&&(t=unescape(t)),isNaN(n)||isNaN(r))throw console.error("jsPDF.addImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addImage");var p,d,g,m,y,v,w,b=function(){var t=this.internal.collections[N+"images"];return t||(this.internal.collections[N+"images"]=t={},this.internal.events.subscribe("putResources",L),this.internal.events.subscribe("putXobjectDict",A)),t}.call(this);if(!((p=P(t,b))||(_(t)&&(t=F(t,e)),(null==(w=a)||0===w.length)&&(a="string"==typeof(v=t)?x.sHashCode(v):x.isArrayBufferView(v)?x.sHashCode(x.arrayBufferToBinaryString(v)):null),p=P(a,b)))){if(this.isString(t)&&(""!==(h=this.convertStringToImageData(t))?t=h:void 0!==(h=x.loadFile(t))&&(t=h)),e=this.getImageFileTypeByImageData(t,e),!S(e))throw new Error("addImage does not support files of type '"+e+"', please ensure that a plugin for '"+e+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(d=t,t=this.binaryStringToUint8Array(t))),!(p=this["process"+e.toUpperCase()](t,(y=0,(m=b)&&(y=Object.keys?Object.keys(m).length:function(t){var e=0;for(var n in t)t.hasOwnProperty(n)&&e++;return e}(m)),y),a,((g=s)&&"string"==typeof g&&(g=g.toUpperCase()),g in x.image_compression?g:x.image_compression.NONE),d)))throw new Error("An unknown error occurred whilst processing the image")}return function(t,e,n,r,i,o,a,s){var l=function(t,e,n){return t||e||(e=t=-96),t<0&&(t=-1*n.w*72/t/this.internal.scaleFactor),e<0&&(e=-1*n.h*72/e/this.internal.scaleFactor),0===t&&(t=e*n.w/n.h),0===e&&(e=t*n.h/n.w),[t,e]}.call(this,n,r,i),h=this.internal.getCoordinateString,u=this.internal.getVerticalCoordinateString;if(n=l[0],r=l[1],a[o]=i,s){s*=Math.PI/180;var c=Math.cos(s),f=Math.sin(s),p=function(t){return t.toFixed(4)},d=[p(c),p(f),p(-1*f),p(c),0,0,"cm"]}this.internal.write("q"),s?(this.internal.write([1,"0","0",1,h(t),u(e+r),"cm"].join(" ")),this.internal.write(d.join(" ")),this.internal.write([h(n),"0","0",h(r),"0","0","cm"].join(" "))):this.internal.write([h(n),"0","0",h(r),h(t),u(e+r),"cm"].join(" ")),this.internal.write("/I"+i.i+" Do"),this.internal.write("Q")}.call(this,n,r,i,o,p,p.i,b,l),this},x.convertStringToImageData=function(t){var e,n="";if(this.isString(t)){var r;e=null!==(r=this.extractImageFromDataUrl(t))?r.data:t;try{n=atob(e)}catch(t){throw x.validateStringAsBase64(e)?new Error("atob-Error in jsPDF.convertStringToImageData "+t.message):new Error("Supplied Data is not a valid base64-String jsPDF.convertStringToImageData ")}}return n};var u=function(t,e){return t.subarray(e,e+5)};x.processJPEG=function(t,e,n,r,i,o){var a,s=this.decode.DCT_DECODE;if(!this.isString(t)&&!this.isArrayBuffer(t)&&!this.isArrayBufferView(t))return null;if(this.isString(t)&&(a=function(t){var e;if("JPEG"!==h(t))throw new Error("getJpegSize requires a binary string jpeg file");for(var n=256*t.charCodeAt(4)+t.charCodeAt(5),r=4,i=t.length;r<i;){if(r+=n,255!==t.charCodeAt(r))throw new Error("getJpegSize could not find the size of the image");if(192===t.charCodeAt(r+1)||193===t.charCodeAt(r+1)||194===t.charCodeAt(r+1)||195===t.charCodeAt(r+1)||196===t.charCodeAt(r+1)||197===t.charCodeAt(r+1)||198===t.charCodeAt(r+1)||199===t.charCodeAt(r+1))return e=256*t.charCodeAt(r+5)+t.charCodeAt(r+6),[256*t.charCodeAt(r+7)+t.charCodeAt(r+8),e,t.charCodeAt(r+9)];r+=2,n=256*t.charCodeAt(r)+t.charCodeAt(r+1)}}(t)),this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)&&(a=function(t){if(65496!=(t[0]<<8|t[1]))throw new Error("Supplied data is not a JPEG");for(var e,n=t.length,r=(t[4]<<8)+t[5],i=4;i<n;){if(r=((e=u(t,i+=r))[2]<<8)+e[3],(192===e[1]||194===e[1])&&255===e[0]&&7<r)return{width:((e=u(t,i+5))[2]<<8)+e[3],height:(e[0]<<8)+e[1],numcomponents:e[4]};i+=2}throw new Error("getJpegSizeFromBytes could not find the size of the image")}(t),t=i||this.arrayBufferToBinaryString(t)),void 0===o)switch(a.numcomponents){case 1:o=this.color_spaces.DEVICE_GRAY;break;case 4:o=this.color_spaces.DEVICE_CMYK;break;default:case 3:o=this.color_spaces.DEVICE_RGB}return this.createImageInfo(t,a.width,a.height,o,8,s,e,n)},x.processJPG=function(){return this.processJPEG.apply(this,arguments)},x.getImageProperties=function(t){var e,n,r="";if(_(t)&&(t=F(t)),this.isString(t)&&(""!==(r=this.convertStringToImageData(t))?t=r:void 0!==(r=x.loadFile(t))&&(t=r)),n=this.getImageFileTypeByImageData(t),!S(n))throw new Error("addImage does not support files of type '"+n+"', please ensure that a plugin for '"+n+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(t=this.binaryStringToUint8Array(t))),!(e=this["process"+n.toUpperCase()](t)))throw new Error("An unknown error occurred whilst processing the image");return{fileType:n,width:e.w,height:e.h,colorSpace:e.cs,compressionMode:e.f,bitsPerComponent:e.bpc}}}(lt.API),
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
t=lt.API,lt.API.events.push(["addPage",function(t){this.internal.getPageInfo(t.pageNumber).pageContext.annotations=[]}]),t.events.push(["putPage",function(t){for(var e=this.internal.getPageInfoByObjId(t.objId),n=t.pageContext.annotations,r=function(t){if(void 0!==t&&""!=t)return!0},i=!1,o=0;o<n.length&&!i;o++)switch((l=n[o]).type){case"link":if(r(l.options.url)||r(l.options.pageNumber)){i=!0;break}case"reference":case"text":case"freetext":i=!0}if(0!=i){this.internal.write("/Annots ["),this.internal.pageSize.height;var a=this.internal.getCoordinateString,s=this.internal.getVerticalCoordinateString;for(o=0;o<n.length;o++){var l;switch((l=n[o]).type){case"reference":this.internal.write(" "+l.object.objId+" 0 R ");break;case"text":var h=this.internal.newAdditionalObject(),u=this.internal.newAdditionalObject(),c=l.title||"Note";m="<</Type /Annot /Subtype /Text "+(p="/Rect ["+a(l.bounds.x)+" "+s(l.bounds.y+l.bounds.h)+" "+a(l.bounds.x+l.bounds.w)+" "+s(l.bounds.y)+"] ")+"/Contents ("+l.contents+")",m+=" /Popup "+u.objId+" 0 R",m+=" /P "+e.objId+" 0 R",m+=" /T ("+c+") >>",h.content=m;var f=h.objId+" 0 R";m="<</Type /Annot /Subtype /Popup "+(p="/Rect ["+a(l.bounds.x+30)+" "+s(l.bounds.y+l.bounds.h)+" "+a(l.bounds.x+l.bounds.w+30)+" "+s(l.bounds.y)+"] ")+" /Parent "+f,l.open&&(m+=" /Open true"),m+=" >>",u.content=m,this.internal.write(h.objId,"0 R",u.objId,"0 R");break;case"freetext":var p="/Rect ["+a(l.bounds.x)+" "+s(l.bounds.y)+" "+a(l.bounds.x+l.bounds.w)+" "+s(l.bounds.y+l.bounds.h)+"] ",d=l.color||"#000000";m="<</Type /Annot /Subtype /FreeText "+p+"/Contents ("+l.contents+")",m+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+d+")",m+=" /Border [0 0 0]",m+=" >>",this.internal.write(m);break;case"link":if(l.options.name){var g=this.annotations._nameMap[l.options.name];l.options.pageNumber=g.page,l.options.top=g.y}else l.options.top||(l.options.top=0);p="/Rect ["+a(l.x)+" "+s(l.y)+" "+a(l.x+l.w)+" "+s(l.y+l.h)+"] ";var m="";if(l.options.url)m="<</Type /Annot /Subtype /Link "+p+"/Border [0 0 0] /A <</S /URI /URI ("+l.options.url+") >>";else if(l.options.pageNumber)switch(m="<</Type /Annot /Subtype /Link "+p+"/Border [0 0 0] /Dest ["+this.internal.getPageInfo(l.options.pageNumber).objId+" 0 R",l.options.magFactor=l.options.magFactor||"XYZ",l.options.magFactor){case"Fit":m+=" /Fit]";break;case"FitH":m+=" /FitH "+l.options.top+"]";break;case"FitV":l.options.left=l.options.left||0,m+=" /FitV "+l.options.left+"]";break;case"XYZ":default:var y=s(l.options.top);l.options.left=l.options.left||0,void 0===l.options.zoom&&(l.options.zoom=0),m+=" /XYZ "+l.options.left+" "+y+" "+l.options.zoom+"]"}""!=m&&(m+=" >>",this.internal.write(m))}}this.internal.write("]")}}]),t.createAnnotation=function(t){var e=this.internal.getCurrentPageInfo();switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":e.pageContext.annotations.push(t)}},t.link=function(t,e,n,r,i){this.internal.getCurrentPageInfo().pageContext.annotations.push({x:t,y:e,w:n,h:r,options:i,type:"link"})},t.textWithLink=function(t,e,n,r){var i=this.getTextWidth(t),o=this.internal.getLineHeight()/this.internal.scaleFactor;return this.text(t,e,n),n+=.2*o,this.link(e,n-o,i,o,r),i},t.getTextWidth=function(t){var e=this.internal.getFontSize();return this.getStringUnitWidth(t)*e/this.internal.scaleFactor},
/**
   * @license
   * Copyright (c) 2017 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
function(t){var h={1569:[65152],1570:[65153,65154],1571:[65155,65156],1572:[65157,65158],1573:[65159,65160],1574:[65161,65162,65163,65164],1575:[65165,65166],1576:[65167,65168,65169,65170],1577:[65171,65172],1578:[65173,65174,65175,65176],1579:[65177,65178,65179,65180],1580:[65181,65182,65183,65184],1581:[65185,65186,65187,65188],1582:[65189,65190,65191,65192],1583:[65193,65194],1584:[65195,65196],1585:[65197,65198],1586:[65199,65200],1587:[65201,65202,65203,65204],1588:[65205,65206,65207,65208],1589:[65209,65210,65211,65212],1590:[65213,65214,65215,65216],1591:[65217,65218,65219,65220],1592:[65221,65222,65223,65224],1593:[65225,65226,65227,65228],1594:[65229,65230,65231,65232],1601:[65233,65234,65235,65236],1602:[65237,65238,65239,65240],1603:[65241,65242,65243,65244],1604:[65245,65246,65247,65248],1605:[65249,65250,65251,65252],1606:[65253,65254,65255,65256],1607:[65257,65258,65259,65260],1608:[65261,65262],1609:[65263,65264,64488,64489],1610:[65265,65266,65267,65268],1649:[64336,64337],1655:[64477],1657:[64358,64359,64360,64361],1658:[64350,64351,64352,64353],1659:[64338,64339,64340,64341],1662:[64342,64343,64344,64345],1663:[64354,64355,64356,64357],1664:[64346,64347,64348,64349],1667:[64374,64375,64376,64377],1668:[64370,64371,64372,64373],1670:[64378,64379,64380,64381],1671:[64382,64383,64384,64385],1672:[64392,64393],1676:[64388,64389],1677:[64386,64387],1678:[64390,64391],1681:[64396,64397],1688:[64394,64395],1700:[64362,64363,64364,64365],1702:[64366,64367,64368,64369],1705:[64398,64399,64400,64401],1709:[64467,64468,64469,64470],1711:[64402,64403,64404,64405],1713:[64410,64411,64412,64413],1715:[64406,64407,64408,64409],1722:[64414,64415],1723:[64416,64417,64418,64419],1726:[64426,64427,64428,64429],1728:[64420,64421],1729:[64422,64423,64424,64425],1733:[64480,64481],1734:[64473,64474],1735:[64471,64472],1736:[64475,64476],1737:[64482,64483],1739:[64478,64479],1740:[64508,64509,64510,64511],1744:[64484,64485,64486,64487],1746:[64430,64431],1747:[64432,64433]},a={65247:{65154:65269,65156:65271,65160:65273,65166:65275},65248:{65154:65270,65156:65272,65160:65274,65166:65276},65165:{65247:{65248:{65258:65010}}},1617:{1612:64606,1613:64607,1614:64608,1615:64609,1616:64610}},e={1612:64606,1613:64607,1614:64608,1615:64609,1616:64610},n=[1570,1571,1573,1575];t.__arabicParser__={};var r=t.__arabicParser__.isInArabicSubstitutionA=function(t){return void 0!==h[t.charCodeAt(0)]},u=t.__arabicParser__.isArabicLetter=function(t){return"string"==typeof t&&/^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t)},i=t.__arabicParser__.isArabicEndLetter=function(t){return u(t)&&r(t)&&h[t.charCodeAt(0)].length<=2},o=t.__arabicParser__.isArabicAlfLetter=function(t){return u(t)&&0<=n.indexOf(t.charCodeAt(0))},s=(t.__arabicParser__.arabicLetterHasIsolatedForm=function(t){return u(t)&&r(t)&&1<=h[t.charCodeAt(0)].length},t.__arabicParser__.arabicLetterHasFinalForm=function(t){return u(t)&&r(t)&&2<=h[t.charCodeAt(0)].length}),l=(t.__arabicParser__.arabicLetterHasInitialForm=function(t){return u(t)&&r(t)&&3<=h[t.charCodeAt(0)].length},t.__arabicParser__.arabicLetterHasMedialForm=function(t){return u(t)&&r(t)&&4==h[t.charCodeAt(0)].length}),c=t.__arabicParser__.resolveLigatures=function(t){var e=0,n=a,r=0,i="",o=0;for(e=0;e<t.length;e+=1)void 0!==n[t.charCodeAt(e)]?(o++,"number"==typeof(n=n[t.charCodeAt(e)])&&(r=-1!==(r=f(t.charAt(e),t.charAt(e-o),t.charAt(e+1)))?r:0,i+=String.fromCharCode(n),n=a,o=0),e===t.length-1&&(n=a,i+=t.charAt(e-(o-1)),e-=o-1,o=0)):(n=a,i+=t.charAt(e-o),e-=o,o=0);return i},f=(t.__arabicParser__.isArabicDiacritic=function(t){return void 0!==t&&void 0!==e[t.charCodeAt(0)]},t.__arabicParser__.getCorrectForm=function(t,e,n){return u(t)?!1===r(t)?-1:!s(t)||!u(e)&&!u(n)||!u(n)&&i(e)||i(t)&&!u(e)||i(t)&&o(e)||i(t)&&i(e)?0:l(t)&&u(e)&&!i(e)&&u(n)&&s(n)?3:i(t)||!u(n)?1:2:-1}),p=t.__arabicParser__.processArabic=t.processArabic=function(t){var e=0,n=0,r=0,i="",o="",a="",s=(t=t||"").split("\\s+"),l=[];for(e=0;e<s.length;e+=1){for(l.push(""),n=0;n<s[e].length;n+=1)i=s[e][n],o=s[e][n-1],a=s[e][n+1],u(i)?(r=f(i,o,a),l[e]+=-1!==r?String.fromCharCode(h[i.charCodeAt(0)][r]):i):l[e]+=i;l[e]=c(l[e])}return l.join(" ")};t.events.push(["preProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),r=(t.mutex,n.lang,[]);if("[object Array]"===Object.prototype.toString.call(e)){var i=0;for(r=[],i=0;i<e.length;i+=1)"[object Array]"===Object.prototype.toString.call(e[i])?r.push([p(e[i][0]),e[i][1],e[i][2]]):r.push([p(e[i])]);t.text=r}else t.text=p(e)}])}(lt.API),lt.API.autoPrint=function(t){var e;switch((t=t||{}).variant=t.variant||"non-conform",t.variant){case"javascript":this.addJS("print({});");break;case"non-conform":default:this.internal.events.subscribe("postPutResources",function(){e=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /Named"),this.internal.out("/Type /Action"),this.internal.out("/N /Print"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){this.internal.out("/OpenAction "+e+" 0 R")})}return this},
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
e=lt.API,(n=function(){var e=void 0;Object.defineProperty(this,"pdf",{get:function(){return e},set:function(t){e=t}});var n=150;Object.defineProperty(this,"width",{get:function(){return n},set:function(t){n=isNaN(t)||!1===Number.isInteger(t)||t<0?150:t,this.getContext("2d").pageWrapXEnabled&&(this.getContext("2d").pageWrapX=n+1)}});var r=300;Object.defineProperty(this,"height",{get:function(){return r},set:function(t){r=isNaN(t)||!1===Number.isInteger(t)||t<0?300:t,this.getContext("2d").pageWrapYEnabled&&(this.getContext("2d").pageWrapY=r+1)}});var i=[];Object.defineProperty(this,"childNodes",{get:function(){return i},set:function(t){i=t}});var o={};Object.defineProperty(this,"style",{get:function(){return o},set:function(t){o=t}}),Object.defineProperty(this,"parentNode",{get:function(){return!1}})}).prototype.getContext=function(t,e){var n;if("2d"!==(t=t||"2d"))return null;for(n in e)this.pdf.context2d.hasOwnProperty(n)&&(this.pdf.context2d[n]=e[n]);return(this.pdf.context2d._canvas=this).pdf.context2d},n.prototype.toDataURL=function(){throw new Error("toDataURL is not implemented.")},e.events.push(["initialized",function(){this.canvas=new n,this.canvas.pdf=this}]),
/** 
   * @license
   * ====================================================================
   * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
   *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Hall, james@parall.ax
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */
_=lt.API,F={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},P=1,p=function(t,e,n,r,i){F={x:t,y:e,w:n,h:r,ln:i}},d=function(){return F},k={left:0,top:0,bottom:0},_.setHeaderFunction=function(t){l=t},_.getTextDimensions=function(t,e){var n=this.table_font_size||this.internal.getFontSize(),r=(this.internal.getFont().fontStyle,(e=e||{}).scaleFactor||this.internal.scaleFactor),i=0,o=0,a=0;if("string"==typeof t)0!=(i=this.getStringUnitWidth(t)*n)&&(o=1);else{if("[object Array]"!==Object.prototype.toString.call(t))throw new Error("getTextDimensions expects text-parameter to be of type String or an Array of Strings.");for(var s=0;s<t.length;s++)i<(a=this.getStringUnitWidth(t[s])*n)&&(i=a);0!==i&&(o=t.length)}return{w:i/=r,h:Math.max((o*n*this.getLineHeightFactor()-n*(this.getLineHeightFactor()-1))/r,0)}},_.cellAddPage=function(){var t=this.margins||k;this.addPage(),p(t.left,t.top,void 0,void 0),P+=1},_.cellInitialize=function(){F={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},P=1},_.cell=function(t,e,n,r,i,o,a){var s=d(),l=!1;if(void 0!==s.ln)if(s.ln===o)t=s.x+s.w,e=s.y;else{var h=this.margins||k;s.y+s.h+r+13>=this.internal.pageSize.getHeight()-h.bottom&&(this.cellAddPage(),l=!0,this.printHeaders&&this.tableHeaderRow&&this.printHeaderRow(o,!0)),e=d().y+d().h,l&&(e=23)}if(void 0!==i[0])if(this.printingHeaderRow?this.rect(t,e,n,r,"FD"):this.rect(t,e,n,r),"right"===a){i instanceof Array||(i=[i]);for(var u=0;u<i.length;u++){var c=i[u],f=this.getStringUnitWidth(c)*this.internal.getFontSize()/this.internal.scaleFactor;this.text(c,t+n-f-3,e+this.internal.getLineHeight()*(u+1))}}else this.text(i,t+3,e+this.internal.getLineHeight());return p(t,e,n,r,o),this},_.arrayMax=function(t,e){var n,r,i,o=t[0];for(n=0,r=t.length;n<r;n+=1)i=t[n],e?-1===e(o,i)&&(o=i):o<i&&(o=i);return o},_.table=function(t,e,n,r,i){if(!n)throw"No data for PDF table";var o,a,s,l,h,u,c,f,p,d,g=[],m=[],y={},v={},w=[],b=[],x=!1,N=!0,L=12,A=k;if(A.width=this.internal.pageSize.getWidth(),i&&(!0===i.autoSize&&(x=!0),!1===i.printHeaders&&(N=!1),i.fontSize&&(L=i.fontSize),i.css&&void 0!==i.css["font-size"]&&(L=16*i.css["font-size"]),i.margins&&(A=i.margins)),this.lnMod=0,F={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},P=1,this.printHeaders=N,this.margins=A,this.setFontSize(L),this.table_font_size=L,null==r)g=Object.keys(n[0]);else if(r[0]&&"string"!=typeof r[0])for(a=0,s=r.length;a<s;a+=1)o=r[a],g.push(o.name),m.push(o.prompt),v[o.name]=o.width*(19.049976/25.4);else g=r;if(x)for(d=function(t){return t[o]},a=0,s=g.length;a<s;a+=1){for(y[o=g[a]]=n.map(d),w.push(this.getTextDimensions(m[a]||o,{scaleFactor:1}).w),c=0,l=(u=y[o]).length;c<l;c+=1)h=u[c],w.push(this.getTextDimensions(h,{scaleFactor:1}).w);v[o]=_.arrayMax(w),w=[]}if(N){var S=this.calculateLineHeight(g,v,m.length?m:g);for(a=0,s=g.length;a<s;a+=1)o=g[a],b.push([t,e,v[o],S,String(m.length?m[a]:o)]);this.setTableHeaderRow(b),this.printHeaderRow(1,!1)}for(a=0,s=n.length;a<s;a+=1)for(f=n[a],S=this.calculateLineHeight(g,v,f),c=0,p=g.length;c<p;c+=1)o=g[c],this.cell(t,e,v[o],S,f[o],a+2,o.align);return this.lastCellPos=F,this.table_x=t,this.table_y=e,this},_.calculateLineHeight=function(t,e,n){for(var r,i=0,o=0;o<t.length;o++){n[r=t[o]]=this.splitTextToSize(String(n[r]),e[r]-3);var a=this.internal.getLineHeight()*n[r].length+3;i<a&&(i=a)}return i},_.setTableHeaderRow=function(t){this.tableHeaderRow=t},_.printHeaderRow=function(t,e){if(!this.tableHeaderRow)throw"Property tableHeaderRow does not exist.";var n,r,i,o;if(this.printingHeaderRow=!0,void 0!==l){var a=l(this,P);p(a[0],a[1],a[2],a[3],-1)}this.setFontStyle("bold");var s=[];for(i=0,o=this.tableHeaderRow.length;i<o;i+=1)this.setFillColor(200,200,200),n=this.tableHeaderRow[i],e&&(this.margins.top=13,n[1]=this.margins&&this.margins.top||0,s.push(n)),r=[].concat(n),this.cell.apply(this,r.concat(t));0<s.length&&this.setTableHeaderRow(s),this.setFontStyle("normal"),this.printingHeaderRow=!1},
/**
   * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
   *
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */
function(t,e){var l,i,o,h,u,c=function(t){return t=t||{},this.isStrokeTransparent=t.isStrokeTransparent||!1,this.strokeOpacity=t.strokeOpacity||1,this.strokeStyle=t.strokeStyle||"#000000",this.fillStyle=t.fillStyle||"#000000",this.isFillTransparent=t.isFillTransparent||!1,this.fillOpacity=t.fillOpacity||1,this.font=t.font||"10px sans-serif",this.textBaseline=t.textBaseline||"alphabetic",this.textAlign=t.textAlign||"left",this.lineWidth=t.lineWidth||1,this.lineJoin=t.lineJoin||"miter",this.lineCap=t.lineCap||"butt",this.path=t.path||[],this.transform=void 0!==t.transform?t.transform.clone():new M,this.globalCompositeOperation=t.globalCompositeOperation||"normal",this.globalAlpha=t.globalAlpha||1,this.clip_path=t.clip_path||[],this.currentPoint=t.currentPoint||new j,this.miterLimit=t.miterLimit||10,this.lastPoint=t.lastPoint||new j,this.ignoreClearRect="boolean"!=typeof t.ignoreClearRect||t.ignoreClearRect,this};t.events.push(["initialized",function(){this.context2d=new n(this),l=this.internal.f2,this.internal.f3,i=this.internal.getCoordinateString,o=this.internal.getVerticalCoordinateString,h=this.internal.getHorizontalCoordinate,u=this.internal.getVerticalCoordinate}]);var n=function(t){Object.defineProperty(this,"canvas",{get:function(){return{parentNode:!1,style:!1}}}),Object.defineProperty(this,"pdf",{get:function(){return t}});var e=!1;Object.defineProperty(this,"pageWrapXEnabled",{get:function(){return e},set:function(t){e=Boolean(t)}});var n=!1;Object.defineProperty(this,"pageWrapYEnabled",{get:function(){return n},set:function(t){n=Boolean(t)}});var r=0;Object.defineProperty(this,"posX",{get:function(){return r},set:function(t){isNaN(t)||(r=t)}});var i=0;Object.defineProperty(this,"posY",{get:function(){return i},set:function(t){isNaN(t)||(i=t)}});var o=!1;Object.defineProperty(this,"autoPaging",{get:function(){return o},set:function(t){o=Boolean(t)}});var a=0;Object.defineProperty(this,"lastBreak",{get:function(){return a},set:function(t){a=t}});var s=[];Object.defineProperty(this,"pageBreaks",{get:function(){return s},set:function(t){s=t}});var l=new c;Object.defineProperty(this,"ctx",{get:function(){return l},set:function(t){t instanceof c&&(l=t)}}),Object.defineProperty(this,"path",{get:function(){return l.path},set:function(t){l.path=t}});var h=[];Object.defineProperty(this,"ctxStack",{get:function(){return h},set:function(t){h=t}}),Object.defineProperty(this,"fillStyle",{get:function(){return this.ctx.fillStyle},set:function(t){var e;e=f(t),this.ctx.fillStyle=e.style,this.ctx.isFillTransparent=0===e.a,this.ctx.fillOpacity=e.a,this.pdf.setFillColor(e.r,e.g,e.b,{a:e.a}),this.pdf.setTextColor(e.r,e.g,e.b,{a:e.a})}}),Object.defineProperty(this,"strokeStyle",{get:function(){return this.ctx.strokeStyle},set:function(t){var e=f(t);this.ctx.strokeStyle=e.style,this.ctx.isStrokeTransparent=0===e.a,this.ctx.strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):(e.a,this.pdf.setDrawColor(e.r,e.g,e.b))}}),Object.defineProperty(this,"lineCap",{get:function(){return this.ctx.lineCap},set:function(t){-1!==["butt","round","square"].indexOf(t)&&(this.ctx.lineCap=t,this.pdf.setLineCap(t))}}),Object.defineProperty(this,"lineWidth",{get:function(){return this.ctx.lineWidth},set:function(t){isNaN(t)||(this.ctx.lineWidth=t,this.pdf.setLineWidth(t))}}),Object.defineProperty(this,"lineJoin",{get:function(){return this.ctx.lineJoin},set:function(t){-1!==["bevel","round","miter"].indexOf(t)&&(this.ctx.lineJoin=t,this.pdf.setLineJoin(t))}}),Object.defineProperty(this,"miterLimit",{get:function(){return this.ctx.miterLimit},set:function(t){isNaN(t)||(this.ctx.miterLimit=t,this.pdf.setMiterLimit(t))}}),Object.defineProperty(this,"textBaseline",{get:function(){return this.ctx.textBaseline},set:function(t){this.ctx.textBaseline=t}}),Object.defineProperty(this,"textAlign",{get:function(){return this.ctx.textAlign},set:function(t){-1!==["right","end","center","left","start"].indexOf(t)&&(this.ctx.textAlign=t)}}),Object.defineProperty(this,"font",{get:function(){return this.ctx.font},set:function(t){var e;if(this.ctx.font=t,null!==(e=/^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))){var n=e[1],r=(e[2],e[3]),i=e[4],o=e[5],a=e[6];i="px"===o?Math.floor(parseFloat(i)):"em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(i)),this.pdf.setFontSize(i);var s="";("bold"===r||700<=parseInt(r,10)||"bold"===n)&&(s="bold"),"italic"===n&&(s+="italic"),0===s.length&&(s="normal");for(var l="",h=a.toLowerCase().replace(/"|'/g,"").split(/\s*,\s*/),u={arial:"Helvetica",verdana:"Helvetica",helvetica:"Helvetica","sans-serif":"Helvetica",fixed:"Courier",monospace:"Courier",terminal:"Courier",courier:"Courier",times:"Times",cursive:"Times",fantasy:"Times",serif:"Times"},c=0;c<h.length;c++){if(void 0!==this.pdf.internal.getFont(h[c],s,{noFallback:!0,disableWarning:!0})){l=h[c];break}if("bolditalic"===s&&void 0!==this.pdf.internal.getFont(h[c],"bold",{noFallback:!0,disableWarning:!0}))l=h[c],s="bold";else if(void 0!==this.pdf.internal.getFont(h[c],"normal",{noFallback:!0,disableWarning:!0})){l=h[c],s="normal";break}}if(""===l)for(c=0;c<h.length;c++)if(u[h[c]]){l=u[h[c]];break}l=""===l?"Times":l,this.pdf.setFont(l,s)}}}),Object.defineProperty(this,"globalCompositeOperation",{get:function(){return this.ctx.globalCompositeOperation},set:function(t){this.ctx.globalCompositeOperation=t}}),Object.defineProperty(this,"globalAlpha",{get:function(){return this.ctx.globalAlpha},set:function(t){this.ctx.globalAlpha=t}}),Object.defineProperty(this,"ignoreClearRect",{get:function(){return this.ctx.ignoreClearRect},set:function(t){this.ctx.ignoreClearRect=Boolean(t)}})};n.prototype.fill=function(){r.call(this,"fill",!1)},n.prototype.stroke=function(){r.call(this,"stroke",!1)},n.prototype.beginPath=function(){this.path=[{type:"begin"}]},n.prototype.moveTo=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.moveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.moveTo");var n=this.ctx.transform.applyToPoint(new j(t,e));this.path.push({type:"mt",x:n.x,y:n.y}),this.ctx.lastPoint=new j(t,e)},n.prototype.closePath=function(){var t=new j(0,0),e=0;for(e=this.path.length-1;-1!==e;e--)if("begin"===this.path[e].type&&"object"===se(this.path[e+1])&&"number"==typeof this.path[e+1].x){t=new j(this.path[e+1].x,this.path[e+1].y),this.path.push({type:"lt",x:t.x,y:t.y});break}"object"===se(this.path[e+2])&&"number"==typeof this.path[e+2].x&&this.path.push(JSON.parse(JSON.stringify(this.path[e+2]))),this.path.push({type:"close"}),this.ctx.lastPoint=new j(t.x,t.y)},n.prototype.lineTo=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.lineTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.lineTo");var n=this.ctx.transform.applyToPoint(new j(t,e));this.path.push({type:"lt",x:n.x,y:n.y}),this.ctx.lastPoint=new j(n.x,n.y)},n.prototype.clip=function(){this.ctx.clip_path=JSON.parse(JSON.stringify(this.path)),r.call(this,null,!0)},n.prototype.quadraticCurveTo=function(t,e,n,r){if(isNaN(n)||isNaN(r)||isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");var i=this.ctx.transform.applyToPoint(new j(n,r)),o=this.ctx.transform.applyToPoint(new j(t,e));this.path.push({type:"qct",x1:o.x,y1:o.y,x:i.x,y:i.y}),this.ctx.lastPoint=new j(i.x,i.y)},n.prototype.bezierCurveTo=function(t,e,n,r,i,o){if(isNaN(i)||isNaN(o)||isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.bezierCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");var a=this.ctx.transform.applyToPoint(new j(i,o)),s=this.ctx.transform.applyToPoint(new j(t,e)),l=this.ctx.transform.applyToPoint(new j(n,r));this.path.push({type:"bct",x1:s.x,y1:s.y,x2:l.x,y2:l.y,x:a.x,y:a.y}),this.ctx.lastPoint=new j(a.x,a.y)},n.prototype.arc=function(t,e,n,r,i,o){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i))throw console.error("jsPDF.context2d.arc: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.arc");if(o=Boolean(o),!this.ctx.transform.isIdentity){var a=this.ctx.transform.applyToPoint(new j(t,e));t=a.x,e=a.y;var s=this.ctx.transform.applyToPoint(new j(0,n)),l=this.ctx.transform.applyToPoint(new j(0,0));n=Math.sqrt(Math.pow(s.x-l.x,2)+Math.pow(s.y-l.y,2))}Math.abs(i-r)>=2*Math.PI&&(r=0,i=2*Math.PI),this.path.push({type:"arc",x:t,y:e,radius:n,startAngle:r,endAngle:i,counterclockwise:o})},n.prototype.arcTo=function(t,e,n,r,i){throw new Error("arcTo not implemented.")},n.prototype.rect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.rect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rect");this.moveTo(t,e),this.lineTo(t+n,e),this.lineTo(t+n,e+r),this.lineTo(t,e+r),this.lineTo(t,e),this.lineTo(t+n,e),this.lineTo(t,e)},n.prototype.fillRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.fillRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillRect");if(!N.call(this)){var i={};"butt"!==this.lineCap&&(i.lineCap=this.lineCap,this.lineCap="butt"),"miter"!==this.lineJoin&&(i.lineJoin=this.lineJoin,this.lineJoin="miter"),this.beginPath(),this.rect(t,e,n,r),this.fill(),i.hasOwnProperty("lineCap")&&(this.lineCap=i.lineCap),i.hasOwnProperty("lineJoin")&&(this.lineJoin=i.lineJoin)}},n.prototype.strokeRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.strokeRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");L.call(this)||(this.beginPath(),this.rect(t,e,n,r),this.stroke())},n.prototype.clearRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.clearRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.clearRect");this.ignoreClearRect||(this.fillStyle="#ffffff",this.fillRect(t,e,n,r))},n.prototype.save=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,n=0;n<this.pdf.internal.getNumberOfPages();n++)this.pdf.setPage(n+1),this.pdf.internal.out("q");if(this.pdf.setPage(e),t){this.ctx.fontSize=this.pdf.internal.getFontSize();var r=new c(this.ctx);this.ctxStack.push(this.ctx),this.ctx=r}},n.prototype.restore=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,n=0;n<this.pdf.internal.getNumberOfPages();n++)this.pdf.setPage(n+1),this.pdf.internal.out("Q");this.pdf.setPage(e),t&&0!==this.ctxStack.length&&(this.ctx=this.ctxStack.pop(),this.fillStyle=this.ctx.fillStyle,this.strokeStyle=this.ctx.strokeStyle,this.font=this.ctx.font,this.lineCap=this.ctx.lineCap,this.lineWidth=this.ctx.lineWidth,this.lineJoin=this.ctx.lineJoin)},n.prototype.toDataURL=function(){throw new Error("toDataUrl not implemented.")};var f=function(t){var e,n,r,i;if(!0===t.isCanvasGradient&&(t=t.getColor()),!t)return{r:0,g:0,b:0,a:0,style:t};if(/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t))i=r=n=e=0;else{var o=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);if(null!==o)e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3]),i=1;else if(null!==(o=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/.exec(t)))e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3]),i=parseFloat(o[4]);else{if(i=1,"string"==typeof t&&"#"!==t.charAt(0)){var a=new RGBColor(t);t=a.ok?a.toHex():"#000000"}4===t.length?(e=t.substring(1,2),e+=e,n=t.substring(2,3),n+=n,r=t.substring(3,4),r+=r):(e=t.substring(1,3),n=t.substring(3,5),r=t.substring(5,7)),e=parseInt(e,16),n=parseInt(n,16),r=parseInt(r,16)}}return{r:e,g:n,b:r,a:i,style:t}},N=function(){return this.ctx.isFillTransparent||0==this.globalAlpha},L=function(){return Boolean(this.ctx.isStrokeTransparent||0==this.globalAlpha)};n.prototype.fillText=function(t,e,n,r){if(isNaN(e)||isNaN(n)||"string"!=typeof t)throw console.error("jsPDF.context2d.fillText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillText");if(r=isNaN(r)?void 0:r,!N.call(this)){n=a.call(this,n);var i=B(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;s.call(this,{text:t,x:e,y:n,scale:o,angle:i,align:this.textAlign,maxWidth:r})}},n.prototype.strokeText=function(t,e,n,r){if(isNaN(e)||isNaN(n)||"string"!=typeof t)throw console.error("jsPDF.context2d.strokeText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeText");if(!L.call(this)){r=isNaN(r)?void 0:r,n=a.call(this,n);var i=B(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;s.call(this,{text:t,x:e,y:n,scale:o,renderingMode:"stroke",angle:i,align:this.textAlign,maxWidth:r})}},n.prototype.measureText=function(t){if("string"!=typeof t)throw console.error("jsPDF.context2d.measureText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.measureText");var e=this.pdf,n=this.pdf.internal.scaleFactor,r=e.internal.getFontSize(),i=e.getStringUnitWidth(t)*r/e.internal.scaleFactor;return new function(t){var e=(t=t||{}).width||0;return Object.defineProperty(this,"width",{get:function(){return e}}),this}({width:i*=Math.round(96*n/72*1e4)/1e4})},n.prototype.scale=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.scale: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.scale");var n=new M(t,0,0,e,0,0);this.ctx.transform=this.ctx.transform.multiply(n)},n.prototype.rotate=function(t){if(isNaN(t))throw console.error("jsPDF.context2d.rotate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rotate");var e=new M(Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0);this.ctx.transform=this.ctx.transform.multiply(e)},n.prototype.translate=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.translate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.translate");var n=new M(1,0,0,1,t,e);this.ctx.transform=this.ctx.transform.multiply(n)},n.prototype.transform=function(t,e,n,r,i,o){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(o))throw console.error("jsPDF.context2d.transform: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.transform");var a=new M(t,e,n,r,i,o);this.ctx.transform=this.ctx.transform.multiply(a)},n.prototype.setTransform=function(t,e,n,r,i,o){t=isNaN(t)?1:t,e=isNaN(e)?0:e,n=isNaN(n)?0:n,r=isNaN(r)?1:r,i=isNaN(i)?0:i,o=isNaN(o)?0:o,this.ctx.transform=new M(t,e,n,r,i,o)},n.prototype.drawImage=function(t,e,n,r,i,o,a,s,l){var h=this.pdf.getImageProperties(t),u=1,c=1,f=1,p=1;void 0!==r&&void 0!==s&&(f=s/r,p=l/i,u=h.width/r*s/r,c=h.height/i*l/i),void 0===o&&(o=e,a=n,n=e=0),void 0!==r&&void 0===s&&(s=r,l=i),void 0===r&&void 0===s&&(s=h.width,l=h.height);var d=this.ctx.transform.decompose(),g=B(d.rotate.shx);d.scale.sx,d.scale.sy;for(var m,y=new M,v=((y=(y=(y=y.multiply(d.translate)).multiply(d.skew)).multiply(d.scale)).applyToPoint(new j(s,l)),y.applyToRectangle(new E(o-e*f,a-n*p,r*u,i*c))),w=F.call(this,v),b=[],x=0;x<w.length;x+=1)-1===b.indexOf(w[x])&&b.push(w[x]);if(b.sort(),this.autoPaging)for(var N=b[0],L=b[b.length-1],A=N;A<L+1;A++){if(this.pdf.setPage(A),0!==this.ctx.clip_path.length){var S=this.path;m=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=P(m,this.posX,-1*this.pdf.internal.pageSize.height*(A-1)+this.posY),k.call(this,"fill",!0),this.path=S}var _=JSON.parse(JSON.stringify(v));_=P([_],this.posX,-1*this.pdf.internal.pageSize.height*(A-1)+this.posY)[0],this.pdf.addImage(t,"jpg",_.x,_.y,_.w,_.h,null,null,g)}else this.pdf.addImage(t,"jpg",v.x,v.y,v.w,v.h,null,null,g)};var F=function(t,e,n){var r=[];switch(e=e||this.pdf.internal.pageSize.width,n=n||this.pdf.internal.pageSize.height,t.type){default:case"mt":case"lt":r.push(Math.floor((t.y+this.posY)/n)+1);break;case"arc":r.push(Math.floor((t.y+this.posY-t.radius)/n)+1),r.push(Math.floor((t.y+this.posY+t.radius)/n)+1);break;case"qct":var i=w(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x,t.y);r.push(Math.floor(i.y/n)+1),r.push(Math.floor((i.y+i.h)/n)+1);break;case"bct":var o=b(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x2,t.y2,t.x,t.y);r.push(Math.floor(o.y/n)+1),r.push(Math.floor((o.y+o.h)/n)+1);break;case"rect":r.push(Math.floor((t.y+this.posY)/n)+1),r.push(Math.floor((t.y+t.h+this.posY)/n)+1)}for(var a=0;a<r.length;a+=1)for(;this.pdf.internal.getNumberOfPages()<r[a];)v.call(this);return r},v=function(){var t=this.fillStyle,e=this.strokeStyle,n=this.font,r=this.lineCap,i=this.lineWidth,o=this.lineJoin;this.pdf.addPage(),this.fillStyle=t,this.strokeStyle=e,this.font=n,this.lineCap=r,this.lineWidth=i,this.lineJoin=o},P=function(t,e,n){for(var r=0;r<t.length;r++)switch(t[r].type){case"bct":t[r].x2+=e,t[r].y2+=n;case"qct":t[r].x1+=e,t[r].y1+=n;case"mt":case"lt":case"arc":default:t[r].x+=e,t[r].y+=n}return t},r=function(t,e){for(var n,r,i=this.fillStyle,o=this.strokeStyle,a=(this.font,this.lineCap),s=this.lineWidth,l=this.lineJoin,h=JSON.parse(JSON.stringify(this.path)),u=JSON.parse(JSON.stringify(this.path)),c=[],f=0;f<u.length;f++)if(void 0!==u[f].x)for(var p=F.call(this,u[f]),d=0;d<p.length;d+=1)-1===c.indexOf(p[d])&&c.push(p[d]);for(f=0;f<c.length;f++)for(;this.pdf.internal.getNumberOfPages()<c[f];)v.call(this);if(c.sort(),this.autoPaging){var g=c[0],m=c[c.length-1];for(f=g;f<m+1;f++){if(this.pdf.setPage(f),this.fillStyle=i,this.strokeStyle=o,this.lineCap=a,this.lineWidth=s,this.lineJoin=l,0!==this.ctx.clip_path.length){var y=this.path;n=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=P(n,this.posX,-1*this.pdf.internal.pageSize.height*(f-1)+this.posY),k.call(this,t,!0),this.path=y}r=JSON.parse(JSON.stringify(h)),this.path=P(r,this.posX,-1*this.pdf.internal.pageSize.height*(f-1)+this.posY),!1!==e&&0!==f||k.call(this,t,e)}}else k.call(this,t,e);this.path=h},k=function(t,e){if(("stroke"!==t||e||!L.call(this))&&("stroke"===t||e||!N.call(this))){var n=[];this.ctx.globalAlpha;this.ctx.fillOpacity<1&&this.ctx.fillOpacity;for(var r,i=this.path,o=0;o<i.length;o++){var a=i[o];switch(a.type){case"begin":n.push({begin:!0});break;case"close":n.push({close:!0});break;case"mt":n.push({start:a,deltas:[],abs:[]});break;case"lt":var s=n.length;if(!isNaN(i[o-1].x)){var l=[a.x-i[o-1].x,a.y-i[o-1].y];if(0<s)for(;0<=s;s--)if(!0!==n[s-1].close&&!0!==n[s-1].begin){n[s-1].deltas.push(l),n[s-1].abs.push(a);break}}break;case"bct":l=[a.x1-i[o-1].x,a.y1-i[o-1].y,a.x2-i[o-1].x,a.y2-i[o-1].y,a.x-i[o-1].x,a.y-i[o-1].y];n[n.length-1].deltas.push(l);break;case"qct":var h=i[o-1].x+2/3*(a.x1-i[o-1].x),u=i[o-1].y+2/3*(a.y1-i[o-1].y),c=a.x+2/3*(a.x1-a.x),f=a.y+2/3*(a.y1-a.y),p=a.x,d=a.y;l=[h-i[o-1].x,u-i[o-1].y,c-i[o-1].x,f-i[o-1].y,p-i[o-1].x,d-i[o-1].y];n[n.length-1].deltas.push(l);break;case"arc":n.push({deltas:[],abs:[],arc:!0}),Array.isArray(n[n.length-1].abs)&&n[n.length-1].abs.push(a)}}r=e?null:"stroke"===t?"stroke":"fill";for(o=0;o<n.length;o++){if(n[o].arc)for(var g=n[o].abs,m=0;m<g.length;m++){var y=g[m];if(void 0!==y.startAngle){var v=B(y.startAngle),w=B(y.endAngle),b=y.x,x=y.y;A.call(this,b,x,y.radius,v,w,y.counterclockwise,r,e)}else I.call(this,y.x,y.y)}if(!n[o].arc&&!0!==n[o].close&&!0!==n[o].begin){b=n[o].start.x,x=n[o].start.y;C.call(this,n[o].deltas,b,x,null,null)}}r&&S.call(this,r),e&&_.call(this)}},a=function(t){var e=this.pdf.internal.getFontSize()/this.pdf.internal.scaleFactor,n=e*(this.pdf.internal.getLineHeightFactor()-1);switch(this.ctx.textBaseline){case"bottom":return t-n;case"top":return t+e-n;case"hanging":return t+e-2*n;case"middle":return t+e/2-n;case"ideographic":return t;case"alphabetic":default:return t}};n.prototype.createLinearGradient=function(){var t=function(){};return t.colorStops=[],t.addColorStop=function(t,e){this.colorStops.push([t,e])},t.getColor=function(){return 0===this.colorStops.length?"#000000":this.colorStops[0][1]},t.isCanvasGradient=!0,t},n.prototype.createPattern=function(){return this.createLinearGradient()},n.prototype.createRadialGradient=function(){return this.createLinearGradient()};var A=function(t,e,n,r,i,o,a,s){this.pdf.internal.scaleFactor;for(var l=y(r),h=y(i),u=g.call(this,n,l,h,o),c=0;c<u.length;c++){var f=u[c];0===c&&p.call(this,f.x1+t,f.y1+e),d.call(this,t,e,f.x2,f.y2,f.x3,f.y3,f.x4,f.y4)}s?_.call(this):S.call(this,a)},S=function(t){switch(t){case"stroke":this.pdf.internal.out("S");break;case"fill":this.pdf.internal.out("f")}},_=function(){this.pdf.clip()},p=function(t,e){this.pdf.internal.out(i(t)+" "+o(e)+" m")},s=function(t){var e;switch(t.align){case"right":case"end":e="right";break;case"center":e="center";break;case"left":case"start":default:e="left"}var n=this.ctx.transform.applyToPoint(new j(t.x,t.y)),r=this.ctx.transform.decompose(),i=new M;i=(i=(i=i.multiply(r.translate)).multiply(r.skew)).multiply(r.scale);for(var o,a=this.pdf.getTextDimensions(t.text),s=this.ctx.transform.applyToRectangle(new E(t.x,t.y,a.w,a.h)),l=i.applyToRectangle(new E(t.x,t.y-a.h,a.w,a.h)),h=F.call(this,l),u=[],c=0;c<h.length;c+=1)-1===u.indexOf(h[c])&&u.push(h[c]);if(u.sort(),!0===this.autoPaging)for(var f=u[0],p=u[u.length-1],d=f;d<p+1;d++){if(this.pdf.setPage(d),0!==this.ctx.clip_path.length){var g=this.path;o=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=P(o,this.posX,-1*this.pdf.internal.pageSize.height*(d-1)+this.posY),k.call(this,"fill",!0),this.path=g}var m=JSON.parse(JSON.stringify(s));if(m=P([m],this.posX,-1*this.pdf.internal.pageSize.height*(d-1)+this.posY)[0],.01<=t.scale){var y=this.pdf.internal.getFontSize();this.pdf.setFontSize(y*t.scale)}this.pdf.text(t.text,m.x,m.y,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),.01<=t.scale&&this.pdf.setFontSize(y)}else{if(.01<=t.scale){y=this.pdf.internal.getFontSize();this.pdf.setFontSize(y*t.scale)}this.pdf.text(t.text,n.x+this.posX,n.y+this.posY,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),.01<=t.scale&&this.pdf.setFontSize(y)}},I=function(t,e,n,r){n=n||0,r=r||0,this.pdf.internal.out(i(t+n)+" "+o(e+r)+" l")},C=function(t,e,n){return this.pdf.lines(t,e,n,null,null)},d=function(t,e,n,r,i,o,a,s){this.pdf.internal.out([l(h(n+t)),l(u(r+e)),l(h(i+t)),l(u(o+e)),l(h(a+t)),l(u(s+e)),"c"].join(" "))},g=function(t,e,n,r){var i=2*Math.PI,o=e;(o<i||i<o)&&(o%=i);var a=n;(a<i||i<a)&&(a%=i);for(var s=[],l=Math.PI/2,h=r?-1:1,u=e,c=Math.min(i,Math.abs(a-o));1e-5<c;){var f=u+h*Math.min(c,l);s.push(m.call(this,t,u,f)),c-=Math.abs(f-u),u=f}return s},m=function(t,e,n){var r=(n-e)/2,i=t*Math.cos(r),o=t*Math.sin(r),a=i,s=-o,l=a*a+s*s,h=l+a*i+s*o,u=4/3*(Math.sqrt(2*l*h)-h)/(a*o-s*i),c=a-u*s,f=s+u*a,p=c,d=-f,g=r+e,m=Math.cos(g),y=Math.sin(g);return{x1:t*Math.cos(e),y1:t*Math.sin(e),x2:c*m-f*y,y2:c*y+f*m,x3:p*m-d*y,y3:p*y+d*m,x4:t*Math.cos(n),y4:t*Math.sin(n)}},B=function(t){return 180*t/Math.PI},y=function(t){return t*Math.PI/180},w=function(t,e,n,r,i,o){var a=t+.5*(n-t),s=e+.5*(r-e),l=i+.5*(n-i),h=o+.5*(r-o),u=Math.min(t,i,a,l),c=Math.max(t,i,a,l),f=Math.min(e,o,s,h),p=Math.max(e,o,s,h);return new E(u,f,c-u,p-f)},b=function(t,e,n,r,i,o,a,s){for(var l,h,u,c,f,p,d,g,m,y,v,w,b,x=n-t,N=r-e,L=i-n,A=o-r,S=a-i,_=s-o,F=0;F<41;F++)g=(p=(h=t+(l=F/40)*x)+l*((c=n+l*L)-h))+l*(c+l*(i+l*S-c)-p),m=(d=(u=e+l*N)+l*((f=r+l*A)-u))+l*(f+l*(o+l*_-f)-d),b=0==F?(w=y=g,v=m):(y=Math.min(y,g),v=Math.min(v,m),w=Math.max(w,g),Math.max(b,m));return new E(Math.round(y),Math.round(v),Math.round(w-y),Math.round(b-v))},j=function(t,e){var n=t||0;Object.defineProperty(this,"x",{enumerable:!0,get:function(){return n},set:function(t){isNaN(t)||(n=parseFloat(t))}});var r=e||0;Object.defineProperty(this,"y",{enumerable:!0,get:function(){return r},set:function(t){isNaN(t)||(r=parseFloat(t))}});var i="pt";return Object.defineProperty(this,"type",{enumerable:!0,get:function(){return i},set:function(t){i=t.toString()}}),this},E=function(t,e,n,r){j.call(this,t,e),this.type="rect";var i=n||0;Object.defineProperty(this,"w",{enumerable:!0,get:function(){return i},set:function(t){isNaN(t)||(i=parseFloat(t))}});var o=r||0;return Object.defineProperty(this,"h",{enumerable:!0,get:function(){return o},set:function(t){isNaN(t)||(o=parseFloat(t))}}),this},M=function(t,e,n,r,i,o){var a=[];return Object.defineProperty(this,"sx",{get:function(){return a[0]},set:function(t){a[0]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"shy",{get:function(){return a[1]},set:function(t){a[1]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"shx",{get:function(){return a[2]},set:function(t){a[2]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"sy",{get:function(){return a[3]},set:function(t){a[3]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"tx",{get:function(){return a[4]},set:function(t){a[4]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"ty",{get:function(){return a[5]},set:function(t){a[5]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"rotation",{get:function(){return Math.atan2(this.shx,this.sx)}}),Object.defineProperty(this,"scaleX",{get:function(){return this.decompose().scale.sx}}),Object.defineProperty(this,"scaleY",{get:function(){return this.decompose().scale.sy}}),Object.defineProperty(this,"isIdentity",{get:function(){return 1===this.sx&&(0===this.shy&&(0===this.shx&&(1===this.sy&&(0===this.tx&&0===this.ty))))}}),this.sx=isNaN(t)?1:t,this.shy=isNaN(e)?0:e,this.shx=isNaN(n)?0:n,this.sy=isNaN(r)?1:r,this.tx=isNaN(i)?0:i,this.ty=isNaN(o)?0:o,this};M.prototype.multiply=function(t){var e=t.sx*this.sx+t.shy*this.shx,n=t.sx*this.shy+t.shy*this.sy,r=t.shx*this.sx+t.sy*this.shx,i=t.shx*this.shy+t.sy*this.sy,o=t.tx*this.sx+t.ty*this.shx+this.tx,a=t.tx*this.shy+t.ty*this.sy+this.ty;return new M(e,n,r,i,o,a)},M.prototype.decompose=function(){var t=this.sx,e=this.shy,n=this.shx,r=this.sy,i=this.tx,o=this.ty,a=Math.sqrt(t*t+e*e),s=(t/=a)*n+(e/=a)*r;n-=t*s,r-=e*s;var l=Math.sqrt(n*n+r*r);return s/=l,t*(r/=l)<e*(n/=l)&&(t=-t,e=-e,s=-s,a=-a),{scale:new M(a,0,0,l,0,0),translate:new M(1,0,0,1,i,o),rotate:new M(t,e,-e,t,0,0),skew:new M(1,0,s,1,0,0)}},M.prototype.applyToPoint=function(t){var e=t.x*this.sx+t.y*this.shx+this.tx,n=t.x*this.shy+t.y*this.sy+this.ty;return new j(e,n)},M.prototype.applyToRectangle=function(t){var e=this.applyToPoint(t),n=this.applyToPoint(new j(t.x+t.w,t.y+t.h));return new E(e.x,e.y,n.x-e.x,n.y-e.y)},M.prototype.clone=function(){var t=this.sx,e=this.shy,n=this.shx,r=this.sy,i=this.tx,o=this.ty;return new M(t,e,n,r,i,o)}}(lt.API,"undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),
/**
   * jsPDF filters PlugIn
   * Copyright (c) 2014 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
a=lt.API,o=function(t){var r,e,n,i,o,a,s,l,h,u;for(/[^\x00-\xFF]/.test(t),e=[],n=0,i=(t+=r="\0\0\0\0".slice(t.length%4||4)).length;n<i;n+=4)0!==(o=(t.charCodeAt(n)<<24)+(t.charCodeAt(n+1)<<16)+(t.charCodeAt(n+2)<<8)+t.charCodeAt(n+3))?(a=(o=((o=((o=((o=(o-(u=o%85))/85)-(h=o%85))/85)-(l=o%85))/85)-(s=o%85))/85)%85,e.push(a+33,s+33,l+33,h+33,u+33)):e.push(122);return function(t,e){for(var n=r.length;0<n;n--)t.pop()}(e),String.fromCharCode.apply(String,e)+"~>"},s=function(t){var r,e,n,i,o,a=String,s="length",l="charCodeAt",h="slice",u="replace";for(t[h](-2),t=t[h](0,-2)[u](/\s/g,"")[u]("z","!!!!!"),n=[],i=0,o=(t+=r="uuuuu"[h](t[s]%5||5))[s];i<o;i+=5)e=52200625*(t[l](i)-33)+614125*(t[l](i+1)-33)+7225*(t[l](i+2)-33)+85*(t[l](i+3)-33)+(t[l](i+4)-33),n.push(255&e>>24,255&e>>16,255&e>>8,255&e);return function(t,e){for(var n=r[s];0<n;n--)t.pop()}(n),a.fromCharCode.apply(a,n)},h=function(t){for(var e="",n=0;n<t.length;n+=1)e+=("0"+t.charCodeAt(n).toString(16)).slice(-2);return e+=">"},u=function(t){var e=new RegExp(/^([0-9A-Fa-f]{2})+$/);if(-1!==(t=t.replace(/\s/g,"")).indexOf(">")&&(t=t.substr(0,t.indexOf(">"))),t.length%2&&(t+="0"),!1===e.test(t))return"";for(var n="",r=0;r<t.length;r+=2)n+=String.fromCharCode("0x"+(t[r]+t[r+1]));return n},c=function(t,e){e=Object.assign({predictor:1,colors:1,bitsPerComponent:8,columns:1},e);for(var n,r,i=[],o=t.length;o--;)i[o]=t.charCodeAt(o);return n=a.adler32cs.from(t),(r=new Deflater(6)).append(new Uint8Array(i)),t=r.flush(),(i=new Uint8Array(t.length+6)).set(new Uint8Array([120,156])),i.set(t,2),i.set(new Uint8Array([255&n,n>>8&255,n>>16&255,n>>24&255]),t.length+2),t=String.fromCharCode.apply(null,i)},a.processDataByFilters=function(t,e){var n=0,r=t||"",i=[];for("string"==typeof(e=e||[])&&(e=[e]),n=0;n<e.length;n+=1)switch(e[n]){case"ASCII85Decode":case"/ASCII85Decode":r=s(r),i.push("/ASCII85Encode");break;case"ASCII85Encode":case"/ASCII85Encode":r=o(r),i.push("/ASCII85Decode");break;case"ASCIIHexDecode":case"/ASCIIHexDecode":r=u(r),i.push("/ASCIIHexEncode");break;case"ASCIIHexEncode":case"/ASCIIHexEncode":r=h(r),i.push("/ASCIIHexDecode");break;case"FlateEncode":case"/FlateEncode":r=c(r),i.push("/FlateDecode");break;default:throw'The filter: "'+e[n]+'" is not implemented'}return{data:r,reverseChain:i.reverse().join(" ")}},(
/**
   * jsPDF fileloading PlugIn
   * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
r=lt.API).loadFile=function(t,e,n){var r;e=e||!0,n=n||function(){};try{r=function(t,e,n){var r=new XMLHttpRequest,i=[],o=0,a=function(t){var e=t.length,n=String.fromCharCode;for(o=0;o<e;o+=1)i.push(n(255&t.charCodeAt(o)));return i.join("")};if(r.open("GET",t,!e),r.overrideMimeType("text/plain; charset=x-user-defined"),!1===e&&(r.onload=function(){return a(this.responseText)}),r.send(null),200===r.status)return e?a(r.responseText):void 0;console.warn('Unable to load file "'+t+'"')}(t,e)}catch(t){r=void 0}return r},r.loadImageFile=r.loadFile,
/**
   * Copyright (c) 2018 Erik Koopmans
   * Released under the MIT License.
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
i=lt.API,f="undefined"!=typeof window&&window||"undefined"!=typeof global&&global,g=function(t){var e=se(t);return"undefined"===e?"undefined":"string"===e||t instanceof String?"string":"number"===e||t instanceof Number?"number":"function"===e||t instanceof Function?"function":t&&t.constructor===Array?"array":t&&1===t.nodeType?"element":"object"===e?"object":"unknown"},m=function(t,e){var n=document.createElement(t);if(e.className&&(n.className=e.className),e.innerHTML){n.innerHTML=e.innerHTML;for(var r=n.getElementsByTagName("script"),i=r.length;0<i--;null)r[i].parentNode.removeChild(r[i])}for(var o in e.style)n.style[o]=e.style[o];return n},(((y=function t(e){var n=Object.assign(t.convert(Promise.resolve()),JSON.parse(JSON.stringify(t.template))),r=t.convert(Promise.resolve(),n);return r=(r=r.setProgress(1,t,1,[t])).set(e)}).prototype=Object.create(Promise.prototype)).constructor=y).convert=function(t,e){return t.__proto__=e||y.prototype,t},y.template={prop:{src:null,container:null,overlay:null,canvas:null,img:null,pdf:null,pageSize:null,callback:function(){}},progress:{val:0,state:null,n:0,stack:[]},opt:{filename:"file.pdf",margin:[0,0,0,0],enableLinks:!0,x:0,y:0,html2canvas:{},jsPDF:{}}},y.prototype.from=function(t,e){return this.then(function(){switch(e=e||function(t){switch(g(t)){case"string":return"string";case"element":return"canvas"===t.nodeName.toLowerCase?"canvas":"element";default:return"unknown"}}(t)){case"string":return this.set({src:m("div",{innerHTML:t})});case"element":return this.set({src:t});case"canvas":return this.set({canvas:t});case"img":return this.set({img:t});default:return this.error("Unknown source type.")}})},y.prototype.to=function(t){switch(t){case"container":return this.toContainer();case"canvas":return this.toCanvas();case"img":return this.toImg();case"pdf":return this.toPdf();default:return this.error("Invalid target.")}},y.prototype.toContainer=function(){return this.thenList([function(){return this.prop.src||this.error("Cannot duplicate - no source HTML.")},function(){return this.prop.pageSize||this.setPageSize()}]).then(function(){var t={position:"relative",display:"inline-block",width:Math.max(this.prop.src.clientWidth,this.prop.src.scrollWidth,this.prop.src.offsetWidth)+"px",left:0,right:0,top:0,margin:"auto",backgroundColor:"white"},e=function t(e,n){for(var r=3===e.nodeType?document.createTextNode(e.nodeValue):e.cloneNode(!1),i=e.firstChild;i;i=i.nextSibling)!0!==n&&1===i.nodeType&&"SCRIPT"===i.nodeName||r.appendChild(t(i,n));return 1===e.nodeType&&("CANVAS"===e.nodeName?(r.width=e.width,r.height=e.height,r.getContext("2d").drawImage(e,0,0)):"TEXTAREA"!==e.nodeName&&"SELECT"!==e.nodeName||(r.value=e.value),r.addEventListener("load",function(){r.scrollTop=e.scrollTop,r.scrollLeft=e.scrollLeft},!0)),r}(this.prop.src,this.opt.html2canvas.javascriptEnabled);"BODY"===e.tagName&&(t.height=Math.max(document.body.scrollHeight,document.body.offsetHeight,document.documentElement.clientHeight,document.documentElement.scrollHeight,document.documentElement.offsetHeight)+"px"),this.prop.overlay=m("div",{className:"html2pdf__overlay",style:{position:"fixed",overflow:"hidden",zIndex:1e3,left:"-100000px",right:0,bottom:0,top:0}}),this.prop.container=m("div",{className:"html2pdf__container",style:t}),this.prop.container.appendChild(e),this.prop.container.firstChild.appendChild(m("div",{style:{clear:"both",border:"0 none transparent",margin:0,padding:0,height:0}})),this.prop.container.style.float="none",this.prop.overlay.appendChild(this.prop.container),document.body.appendChild(this.prop.overlay),this.prop.container.firstChild.style.position="relative",this.prop.container.height=Math.max(this.prop.container.firstChild.clientHeight,this.prop.container.firstChild.scrollHeight,this.prop.container.firstChild.offsetHeight)+"px"})},y.prototype.toCanvas=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(function(){var t=Object.assign({},this.opt.html2canvas);if(delete t.onrendered,this.isHtml2CanvasLoaded())return html2canvas(this.prop.container,t)}).then(function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)})},y.prototype.toContext2d=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(function(){var t=this.opt.jsPDF,e=Object.assign({async:!0,allowTaint:!0,backgroundColor:"#ffffff",imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1},this.opt.html2canvas);if(delete e.onrendered,t.context2d.autoPaging=!0,t.context2d.posX=this.opt.x,t.context2d.posY=this.opt.y,e.windowHeight=e.windowHeight||0,e.windowHeight=0==e.windowHeight?Math.max(this.prop.container.clientHeight,this.prop.container.scrollHeight,this.prop.container.offsetHeight):e.windowHeight,this.isHtml2CanvasLoaded())return html2canvas(this.prop.container,e)}).then(function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)})},y.prototype.toImg=function(){return this.thenList([function(){return this.prop.canvas||this.toCanvas()}]).then(function(){var t=this.prop.canvas.toDataURL("image/"+this.opt.image.type,this.opt.image.quality);this.prop.img=document.createElement("img"),this.prop.img.src=t})},y.prototype.toPdf=function(){return this.thenList([function(){return this.toContext2d()}]).then(function(){this.prop.pdf=this.prop.pdf||this.opt.jsPDF})},y.prototype.output=function(t,e,n){return"img"===(n=n||"pdf").toLowerCase()||"image"===n.toLowerCase()?this.outputImg(t,e):this.outputPdf(t,e)},y.prototype.outputPdf=function(t,e){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then(function(){return this.prop.pdf.output(t,e)})},y.prototype.outputImg=function(t,e){return this.thenList([function(){return this.prop.img||this.toImg()}]).then(function(){switch(t){case void 0:case"img":return this.prop.img;case"datauristring":case"dataurlstring":return this.prop.img.src;case"datauri":case"dataurl":return document.location.href=this.prop.img.src;default:throw'Image output type "'+t+'" is not supported.'}})},y.prototype.isHtml2CanvasLoaded=function(){var t=void 0!==f.html2canvas;return t||console.error("html2canvas not loaded."),t},y.prototype.save=function(t){if(this.isHtml2CanvasLoaded())return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).set(t?{filename:t}:null).then(function(){this.prop.pdf.save(this.opt.filename)})},y.prototype.doCallback=function(t){if(this.isHtml2CanvasLoaded())return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then(function(){this.prop.callback(this.prop.pdf)})},y.prototype.set=function(e){if("object"!==g(e))return this;var t=Object.keys(e||{}).map(function(t){if(t in y.template.prop)return function(){this.prop[t]=e[t]};switch(t){case"margin":return this.setMargin.bind(this,e.margin);case"jsPDF":return function(){return this.opt.jsPDF=e.jsPDF,this.setPageSize()};case"pageSize":return this.setPageSize.bind(this,e.pageSize);default:return function(){this.opt[t]=e[t]}}},this);return this.then(function(){return this.thenList(t)})},y.prototype.get=function(e,n){return this.then(function(){var t=e in y.template.prop?this.prop[e]:this.opt[e];return n?n(t):t})},y.prototype.setMargin=function(t){return this.then(function(){switch(g(t)){case"number":t=[t,t,t,t];case"array":if(2===t.length&&(t=[t[0],t[1],t[0],t[1]]),4===t.length)break;default:return this.error("Invalid margin array.")}this.opt.margin=t}).then(this.setPageSize)},y.prototype.setPageSize=function(t){function e(t,e){return Math.floor(t*e/72*96)}return this.then(function(){(t=t||lt.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner")||(t.inner={width:t.width-this.opt.margin[1]-this.opt.margin[3],height:t.height-this.opt.margin[0]-this.opt.margin[2]},t.inner.px={width:e(t.inner.width,t.k),height:e(t.inner.height,t.k)},t.inner.ratio=t.inner.height/t.inner.width),this.prop.pageSize=t})},y.prototype.setProgress=function(t,e,n,r){return null!=t&&(this.progress.val=t),null!=e&&(this.progress.state=e),null!=n&&(this.progress.n=n),null!=r&&(this.progress.stack=r),this.progress.ratio=this.progress.val/this.progress.state,this},y.prototype.updateProgress=function(t,e,n,r){return this.setProgress(t?this.progress.val+t:null,e||null,n?this.progress.n+n:null,r?this.progress.stack.concat(r):null)},y.prototype.then=function(t,e){var n=this;return this.thenCore(t,e,function(e,t){return n.updateProgress(null,null,1,[e]),Promise.prototype.then.call(this,function(t){return n.updateProgress(null,e),t}).then(e,t).then(function(t){return n.updateProgress(1),t})})},y.prototype.thenCore=function(t,e,n){n=n||Promise.prototype.then;var r=this;t&&(t=t.bind(r)),e&&(e=e.bind(r));var i=-1!==Promise.toString().indexOf("[native code]")&&"Promise"===Promise.name?r:y.convert(Object.assign({},r),Promise.prototype),o=n.call(i,t,e);return y.convert(o,r.__proto__)},y.prototype.thenExternal=function(t,e){return Promise.prototype.then.call(this,t,e)},y.prototype.thenList=function(t){var e=this;return t.forEach(function(t){e=e.thenCore(t)}),e},y.prototype.catch=function(t){t&&(t=t.bind(this));var e=Promise.prototype.catch.call(this,t);return y.convert(e,this)},y.prototype.catchExternal=function(t){return Promise.prototype.catch.call(this,t)},y.prototype.error=function(t){return this.then(function(){throw new Error(t)})},y.prototype.using=y.prototype.set,y.prototype.saveAs=y.prototype.save,y.prototype.export=y.prototype.output,y.prototype.run=y.prototype.then,lt.getPageSize=function(t,e,n){if("object"===se(t)){var r=t;t=r.orientation,e=r.unit||e,n=r.format||n}e=e||"mm",n=n||"a4",t=(""+(t||"P")).toLowerCase();var i=(""+n).toLowerCase(),o={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};switch(e){case"pt":var a=1;break;case"mm":a=72/25.4;break;case"cm":a=72/2.54;break;case"in":a=72;break;case"px":a=.75;break;case"pc":case"em":a=12;break;case"ex":a=6;break;default:throw"Invalid unit: "+e}if(o.hasOwnProperty(i))var s=o[i][1]/a,l=o[i][0]/a;else try{s=n[1],l=n[0]}catch(t){throw new Error("Invalid format: "+n)}if("p"===t||"portrait"===t){if(t="p",s<l){var h=l;l=s,s=h}}else{if("l"!==t&&"landscape"!==t)throw"Invalid orientation: "+t;t="l",l<s&&(h=l,l=s,s=h)}return{width:l,height:s,unit:e,k:a}},i.html=function(t,e){(e=e||{}).callback=e.callback||function(){},e.html2canvas=e.html2canvas||{},e.html2canvas.canvas=e.html2canvas.canvas||this.canvas,e.jsPDF=e.jsPDF||this,e.jsPDF;var n=new y(e);return e.worker?n:n.from(t).doCallback()},lt.API.addJS=function(t){return b=t,this.internal.events.subscribe("postPutResources",function(t){v=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/Names [(EmbeddedJS) "+(v+1)+" 0 R]"),this.internal.out(">>"),this.internal.out("endobj"),w=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /JavaScript"),this.internal.out("/JS ("+b+")"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){void 0!==v&&void 0!==w&&this.internal.out("/Names <</JavaScript "+v+" 0 R>>")}),this},(
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
x=lt.API).events.push(["postPutResources",function(){var t=this,e=/^(\d+) 0 obj$/;if(0<this.outline.root.children.length)for(var n=t.outline.render().split(/\r\n/),r=0;r<n.length;r++){var i=n[r],o=e.exec(i);if(null!=o){var a=o[1];t.internal.newObjectDeferredBegin(a,!1)}t.internal.write(i)}if(this.outline.createNamedDestinations){var s=this.internal.pages.length,l=[];for(r=0;r<s;r++){var h=t.internal.newObject();l.push(h);var u=t.internal.getPageInfo(r+1);t.internal.write("<< /D["+u.objId+" 0 R /XYZ null null null]>> endobj")}var c=t.internal.newObject();for(t.internal.write("<< /Names [ "),r=0;r<l.length;r++)t.internal.write("(page_"+(r+1)+")"+l[r]+" 0 R");t.internal.write(" ] >>","endobj"),t.internal.newObject(),t.internal.write("<< /Dests "+c+" 0 R"),t.internal.write(">>","endobj")}}]),x.events.push(["putCatalog",function(){0<this.outline.root.children.length&&(this.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&this.internal.write("/Names "+namesOid+" 0 R"))}]),x.events.push(["initialized",function(){var a=this;a.outline={createNamedDestinations:!1,root:{children:[]}},a.outline.add=function(t,e,n){var r={title:e,options:n,children:[]};return null==t&&(t=this.root),t.children.push(r),r},a.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=a,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},a.outline.genIds_r=function(t){t.id=a.internal.newObjectDeferred();for(var e=0;e<t.children.length;e++)this.genIds_r(t.children[e])},a.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),0<t.children.length&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd()},a.outline.renderItems=function(t){this.ctx.pdf.internal.getCoordinateString;for(var e=this.ctx.pdf.internal.getVerticalCoordinateString,n=0;n<t.children.length;n++){var r=t.children[n];this.objStart(r),this.line("/Title "+this.makeString(r.title)),this.line("/Parent "+this.makeRef(t)),0<n&&this.line("/Prev "+this.makeRef(t.children[n-1])),n<t.children.length-1&&this.line("/Next "+this.makeRef(t.children[n+1])),0<r.children.length&&(this.line("/First "+this.makeRef(r.children[0])),this.line("/Last "+this.makeRef(r.children[r.children.length-1])));var i=this.count=this.count_r({count:0},r);if(0<i&&this.line("/Count "+i),r.options&&r.options.pageNumber){var o=a.internal.getPageInfo(r.options.pageNumber);this.line("/Dest ["+o.objId+" 0 R /XYZ 0 "+e(0)+" 0]")}this.objEnd()}for(n=0;n<t.children.length;n++)r=t.children[n],this.renderItems(r)},a.outline.line=function(t){this.ctx.val+=t+"\r\n"},a.outline.makeRef=function(t){return t.id+" 0 R"},a.outline.makeString=function(t){return"("+a.internal.pdfEscape(t)+")"},a.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n"},a.outline.objEnd=function(t){this.ctx.val+=">> \r\nendobj\r\n"},a.outline.count_r=function(t,e){for(var n=0;n<e.children.length;n++)t.count++,this.count_r(t,e.children[n]);return t.count}}]),
/**
   * @license
   * 
   * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   * ====================================================================
   */
I=lt.API,C=function(){var t="function"==typeof Deflater;if(!t)throw new Error("requires deflate.js for compression");return t},B=function(t,e,n,r){var i=5,o=E;switch(r){case I.image_compression.FAST:i=3,o=j;break;case I.image_compression.MEDIUM:i=6,o=M;break;case I.image_compression.SLOW:i=9,o=O}t=A(t,e,n,o);var a=new Uint8Array(N(i)),s=L(t),l=new Deflater(i),h=l.append(t),u=l.flush(),c=a.length+h.length+u.length,f=new Uint8Array(c+4);return f.set(a),f.set(h,a.length),f.set(u,a.length+h.length),f[c++]=s>>>24&255,f[c++]=s>>>16&255,f[c++]=s>>>8&255,f[c++]=255&s,I.arrayBufferToBinaryString(f)},N=function(t,e){var n=Math.LOG2E*Math.log(32768)-8<<4|8,r=n<<8;return r|=Math.min(3,(e-1&255)>>1)<<6,r|=0,[n,255&(r+=31-r%31)]},L=function(t,e){for(var n,r=1,i=0,o=t.length,a=0;0<o;){for(o-=n=e<o?e:o;i+=r+=t[a++],--n;);r%=65521,i%=65521}return(i<<16|r)>>>0},A=function(t,e,n,r){for(var i,o,a,s=t.length/e,l=new Uint8Array(t.length+s),h=T(),u=0;u<s;u++){if(a=u*e,i=t.subarray(a,a+e),r)l.set(r(i,n,o),a+u);else{for(var c=0,f=h.length,p=[];c<f;c++)p[c]=h[c](i,n,o);var d=R(p.concat());l.set(p[d],a+u)}o=i}return l},S=function(t,e,n){var r=Array.apply([],t);return r.unshift(0),r},j=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=1;o<a;o++)r=t[o-e]||0,i[o+1]=t[o]-r+256&255;return i},E=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=2;o<a;o++)r=n&&n[o]||0,i[o+1]=t[o]-r+256&255;return i},M=function(t,e,n){var r,i,o=[],a=0,s=t.length;for(o[0]=3;a<s;a++)r=t[a-e]||0,i=n&&n[a]||0,o[a+1]=t[a]+256-(r+i>>>1)&255;return o},O=function(t,e,n){var r,i,o,a,s=[],l=0,h=t.length;for(s[0]=4;l<h;l++)r=t[l-e]||0,i=n&&n[l]||0,o=n&&n[l-e]||0,a=q(r,i,o),s[l+1]=t[l]-a+256&255;return s},q=function(t,e,n){var r=t+e-n,i=Math.abs(r-t),o=Math.abs(r-e),a=Math.abs(r-n);return i<=o&&i<=a?t:o<=a?e:n},T=function(){return[S,j,E,M,O]},R=function(t){for(var e,n,r,i=0,o=t.length;i<o;)((e=D(t[i].slice(1)))<n||!n)&&(n=e,r=i),i++;return r},D=function(t){for(var e=0,n=t.length,r=0;e<n;)r+=Math.abs(t[e++]);return r},I.processPNG=function(t,e,n,r,i){var o,a,s,l,h,u,c=this.color_spaces.DEVICE_RGB,f=this.decode.FLATE_DECODE,p=8;if(this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)){if("function"!=typeof PNG||"function"!=typeof kt)throw new Error("PNG support requires png.js and zlib.js");if(t=(o=new PNG(t)).imgData,p=o.bits,c=o.colorSpace,l=o.colors,-1!==[4,6].indexOf(o.colorType)){if(8===o.bits)for(var d,g=(_=32==o.pixelBitlength?new Uint32Array(o.decodePixels().buffer):16==o.pixelBitlength?new Uint16Array(o.decodePixels().buffer):new Uint8Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*o.colors),y=new Uint8Array(g),v=o.pixelBitlength-o.bits,w=0,b=0;w<g;w++){for(x=_[w],d=0;d<v;)m[b++]=x>>>d&255,d+=o.bits;y[w]=x>>>d&255}if(16===o.bits){g=(_=new Uint32Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*(32/o.pixelBitlength)*o.colors),y=new Uint8Array(g*(32/o.pixelBitlength));for(var x,N=1<o.colors,L=b=w=0;w<g;)x=_[w++],m[b++]=x>>>0&255,N&&(m[b++]=x>>>16&255,x=_[w++],m[b++]=x>>>0&255),y[L++]=x>>>16&255;p=8}r!==I.image_compression.NONE&&C()?(t=B(m,o.width*o.colors,o.colors,r),u=B(y,o.width,1,r)):(t=m,u=y,f=null)}if(3===o.colorType&&(c=this.color_spaces.INDEXED,h=o.palette,o.transparency.indexed)){var A=o.transparency.indexed,S=0;for(w=0,g=A.length;w<g;++w)S+=A[w];if((S/=255)==g-1&&-1!==A.indexOf(0))s=[A.indexOf(0)];else if(S!==g){var _=o.decodePixels();for(y=new Uint8Array(_.length),w=0,g=_.length;w<g;w++)y[w]=A[_[w]];u=B(y,o.width,1)}}var F=function(t){var e;switch(t){case I.image_compression.FAST:e=11;break;case I.image_compression.MEDIUM:e=13;break;case I.image_compression.SLOW:e=14;break;default:e=12}return e}(r);return a=f===this.decode.FLATE_DECODE?"/Predictor "+F+" /Colors "+l+" /BitsPerComponent "+p+" /Columns "+o.width:"/Colors "+l+" /BitsPerComponent "+p+" /Columns "+o.width,(this.isArrayBuffer(t)||this.isArrayBufferView(t))&&(t=this.arrayBufferToBinaryString(t)),(u&&this.isArrayBuffer(u)||this.isArrayBufferView(u))&&(u=this.arrayBufferToBinaryString(u)),this.createImageInfo(t,o.width,o.height,c,p,f,e,n,a,s,h,u,F)}throw new Error("Unsupported PNG image data, try using JPEG instead.")},(
/**
   * @license
   * Copyright (c) 2017 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
U=lt.API).processGIF89A=function(t,e,n,r,i){var o=new At(t),a=o.width,s=o.height,l=[];o.decodeAndBlitFrameRGBA(0,l);var h={data:l,width:a,height:s},u=new _t(100).encode(h,100);return U.processJPEG.call(this,u,e,n,r)},U.processGIF87A=U.processGIF89A,(
/**
   * Copyright (c) 2018 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
z=lt.API).processBMP=function(t,e,n,r,i){var o=new Ft(t,!1),a=o.width,s=o.height,l={data:o.getData(),width:a,height:s},h=new _t(100).encode(l,100);return z.processJPEG.call(this,h,e,n,r)},lt.API.setLanguage=function(t){return void 0===this.internal.languageSettings&&(this.internal.languageSettings={},this.internal.languageSettings.isSubscribed=!1),void 0!=={af:"Afrikaans",sq:"Albanian",ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",an:"Aragonese",hy:"Armenian",as:"Assamese",ast:"Asturian",az:"Azerbaijani",eu:"Basque",be:"Belarusian",bn:"Bengali",bs:"Bosnian",br:"Breton",bg:"Bulgarian",my:"Burmese",ca:"Catalan",ch:"Chamorro",ce:"Chechen",zh:"Chinese","zh-HK":"Chinese (Hong Kong)","zh-CN":"Chinese (PRC)","zh-SG":"Chinese (Singapore)","zh-TW":"Chinese (Taiwan)",cv:"Chuvash",co:"Corsican",cr:"Cree",hr:"Croatian",cs:"Czech",da:"Danish",nl:"Dutch (Standard)","nl-BE":"Dutch (Belgian)",en:"English","en-AU":"English (Australia)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-IE":"English (Ireland)","en-JM":"English (Jamaica)","en-NZ":"English (New Zealand)","en-PH":"English (Philippines)","en-ZA":"English (South Africa)","en-TT":"English (Trinidad & Tobago)","en-GB":"English (United Kingdom)","en-US":"English (United States)","en-ZW":"English (Zimbabwe)",eo:"Esperanto",et:"Estonian",fo:"Faeroese",fj:"Fijian",fi:"Finnish",fr:"French (Standard)","fr-BE":"French (Belgium)","fr-CA":"French (Canada)","fr-FR":"French (France)","fr-LU":"French (Luxembourg)","fr-MC":"French (Monaco)","fr-CH":"French (Switzerland)",fy:"Frisian",fur:"Friulian",gd:"Gaelic (Scots)","gd-IE":"Gaelic (Irish)",gl:"Galacian",ka:"Georgian",de:"German (Standard)","de-AT":"German (Austria)","de-DE":"German (Germany)","de-LI":"German (Liechtenstein)","de-LU":"German (Luxembourg)","de-CH":"German (Switzerland)",el:"Greek",gu:"Gujurati",ht:"Haitian",he:"Hebrew",hi:"Hindi",hu:"Hungarian",is:"Icelandic",id:"Indonesian",iu:"Inuktitut",ga:"Irish",it:"Italian (Standard)","it-CH":"Italian (Switzerland)",ja:"Japanese",kn:"Kannada",ks:"Kashmiri",kk:"Kazakh",km:"Khmer",ky:"Kirghiz",tlh:"Klingon",ko:"Korean","ko-KP":"Korean (North Korea)","ko-KR":"Korean (South Korea)",la:"Latin",lv:"Latvian",lt:"Lithuanian",lb:"Luxembourgish",mk:"FYRO Macedonian",ms:"Malay",ml:"Malayalam",mt:"Maltese",mi:"Maori",mr:"Marathi",mo:"Moldavian",nv:"Navajo",ng:"Ndonga",ne:"Nepali",no:"Norwegian",nb:"Norwegian (Bokmal)",nn:"Norwegian (Nynorsk)",oc:"Occitan",or:"Oriya",om:"Oromo",fa:"Persian","fa-IR":"Persian/Iran",pl:"Polish",pt:"Portuguese","pt-BR":"Portuguese (Brazil)",pa:"Punjabi","pa-IN":"Punjabi (India)","pa-PK":"Punjabi (Pakistan)",qu:"Quechua",rm:"Rhaeto-Romanic",ro:"Romanian","ro-MO":"Romanian (Moldavia)",ru:"Russian","ru-MO":"Russian (Moldavia)",sz:"Sami (Lappish)",sg:"Sango",sa:"Sanskrit",sc:"Sardinian",sd:"Sindhi",si:"Singhalese",sr:"Serbian",sk:"Slovak",sl:"Slovenian",so:"Somani",sb:"Sorbian",es:"Spanish","es-AR":"Spanish (Argentina)","es-BO":"Spanish (Bolivia)","es-CL":"Spanish (Chile)","es-CO":"Spanish (Colombia)","es-CR":"Spanish (Costa Rica)","es-DO":"Spanish (Dominican Republic)","es-EC":"Spanish (Ecuador)","es-SV":"Spanish (El Salvador)","es-GT":"Spanish (Guatemala)","es-HN":"Spanish (Honduras)","es-MX":"Spanish (Mexico)","es-NI":"Spanish (Nicaragua)","es-PA":"Spanish (Panama)","es-PY":"Spanish (Paraguay)","es-PE":"Spanish (Peru)","es-PR":"Spanish (Puerto Rico)","es-ES":"Spanish (Spain)","es-UY":"Spanish (Uruguay)","es-VE":"Spanish (Venezuela)",sx:"Sutu",sw:"Swahili",sv:"Swedish","sv-FI":"Swedish (Finland)","sv-SV":"Swedish (Sweden)",ta:"Tamil",tt:"Tatar",te:"Teluga",th:"Thai",tig:"Tigre",ts:"Tsonga",tn:"Tswana",tr:"Turkish",tk:"Turkmen",uk:"Ukrainian",hsb:"Upper Sorbian",ur:"Urdu",ve:"Venda",vi:"Vietnamese",vo:"Volapuk",wa:"Walloon",cy:"Welsh",xh:"Xhosa",ji:"Yiddish",zu:"Zulu"}[t]&&(this.internal.languageSettings.languageCode=t,!1===this.internal.languageSettings.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){this.internal.write("/Lang ("+this.internal.languageSettings.languageCode+")")}),this.internal.languageSettings.isSubscribed=!0)),this},
/** @license
   * MIT license.
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */
H=lt.API,W=H.getCharWidthsArray=function(t,e){var n,r,i,o=(e=e||{}).font||this.internal.getFont(),a=e.fontSize||this.internal.getFontSize(),s=e.charSpace||this.internal.getCharSpace(),l=e.widths?e.widths:o.metadata.Unicode.widths,h=l.fof?l.fof:1,u=e.kerning?e.kerning:o.metadata.Unicode.kerning,c=u.fof?u.fof:1,f=0,p=l[0]||h,d=[];for(n=0,r=t.length;n<r;n++)i=t.charCodeAt(n),"function"==typeof o.metadata.widthOfString?d.push((o.metadata.widthOfGlyph(o.metadata.characterToGlyph(i))+s*(1e3/a)||0)/1e3):d.push((l[i]||p)/h+(u[i]&&u[i][f]||0)/c),f=i;return d},V=H.getArraySum=function(t){for(var e=t.length,n=0;e;)n+=t[--e];return n},G=H.getStringUnitWidth=function(t,e){var n=(e=e||{}).fontSize||this.internal.getFontSize(),r=e.font||this.internal.getFont(),i=e.charSpace||this.internal.getCharSpace();return"function"==typeof r.metadata.widthOfString?r.metadata.widthOfString(t,n,i)/n:V(W.apply(this,arguments))},Y=function(t,e,n,r){for(var i=[],o=0,a=t.length,s=0;o!==a&&s+e[o]<n;)s+=e[o],o++;i.push(t.slice(0,o));var l=o;for(s=0;o!==a;)s+e[o]>r&&(i.push(t.slice(l,o)),s=0,l=o),s+=e[o],o++;return l!==o&&i.push(t.slice(l,o)),i},J=function(t,e,n){n||(n={});var r,i,o,a,s,l,h=[],u=[h],c=n.textIndent||0,f=0,p=0,d=t.split(" "),g=W.apply(this,[" ",n])[0];if(l=-1===n.lineIndent?d[0].length+2:n.lineIndent||0){var m=Array(l).join(" "),y=[];d.map(function(t){1<(t=t.split(/\s*\n/)).length?y=y.concat(t.map(function(t,e){return(e&&t.length?"\n":"")+t})):y.push(t[0])}),d=y,l=G.apply(this,[m,n])}for(o=0,a=d.length;o<a;o++){var v=0;if(r=d[o],l&&"\n"==r[0]&&(r=r.substr(1),v=1),i=W.apply(this,[r,n]),e<c+f+(p=V(i))||v){if(e<p){for(s=Y.apply(this,[r,i,e-(c+f),e]),h.push(s.shift()),h=[s.pop()];s.length;)u.push([s.shift()]);p=V(i.slice(r.length-(h[0]?h[0].length:0)))}else h=[r];u.push(h),c=p+l,f=g}else h.push(r),c+=f+p,f=g}if(l)var w=function(t,e){return(e?m:"")+t.join(" ")};else w=function(t){return t.join(" ")};return u.map(w)},H.splitTextToSize=function(t,e,n){var r,i=(n=n||{}).fontSize||this.internal.getFontSize(),o=function(t){var e={0:1},n={};if(t.widths&&t.kerning)return{widths:t.widths,kerning:t.kerning};var r=this.internal.getFont(t.fontName,t.fontStyle),i="Unicode";return r.metadata[i]?{widths:r.metadata[i].widths||e,kerning:r.metadata[i].kerning||n}:{font:r.metadata,fontSize:this.internal.getFontSize(),charSpace:this.internal.getCharSpace()}}.call(this,n);r=Array.isArray(t)?t:t.split(/\r?\n/);var a=1*this.internal.scaleFactor*e/i;o.textIndent=n.textIndent?1*n.textIndent*this.internal.scaleFactor/i:0,o.lineIndent=n.lineIndent;var s,l,h=[];for(s=0,l=r.length;s<l;s++)h=h.concat(J.apply(this,[r[s],a,o]));return h},
/** @license
   jsPDF standard_fonts_metrics plugin
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   * MIT license.
   * 
   * ====================================================================
   */
X=lt.API,Z={codePages:["WinAnsiEncoding"],WinAnsiEncoding:(K=function(t){for(var e="klmnopqrstuvwxyz",n={},r=0;r<e.length;r++)n[e[r]]="0123456789abcdef"[r];var i,o,a,s,l,h={},u=1,c=h,f=[],p="",d="",g=t.length-1;for(r=1;r!=g;)l=t[r],r+=1,"'"==l?o=o?(s=o.join(""),i):[]:o?o.push(l):"{"==l?(f.push([c,s]),c={},s=i):"}"==l?((a=f.pop())[0][a[1]]=c,s=i,c=a[0]):"-"==l?u=-1:s===i?n.hasOwnProperty(l)?(p+=n[l],s=parseInt(p,16)*u,u=1,p=""):p+=l:n.hasOwnProperty(l)?(d+=n[l],c[s]=parseInt(d,16)*u,u=1,s=i,d=""):d+=l;return h})("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},Q={Unicode:{Courier:Z,"Courier-Bold":Z,"Courier-BoldOblique":Z,"Courier-Oblique":Z,Helvetica:Z,"Helvetica-Bold":Z,"Helvetica-BoldOblique":Z,"Helvetica-Oblique":Z,"Times-Roman":Z,"Times-Bold":Z,"Times-BoldItalic":Z,"Times-Italic":Z}},$={Unicode:{"Courier-Oblique":K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":K("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":K("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":K("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Symbol:K("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),Helvetica:K("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":K("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),ZapfDingbats:K("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-Bold":K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":K("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":K("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":K("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}},X.events.push(["addFont",function(t){var e,n,r,i=t.font,o="Unicode";(e=$[o][i.postScriptName])&&((n=i.metadata[o]?i.metadata[o]:i.metadata[o]={}).widths=e.widths,n.kerning=e.kerning),(r=Q[o][i.postScriptName])&&((n=i.metadata[o]?i.metadata[o]:i.metadata[o]={}).encoding=r).codePages&&r.codePages.length&&(i.encoding=r.codePages[0])}]),
/**
   * @license
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
tt=lt,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")(),tt.API.events.push(["addFont",function(t){var e=t.font,n=t.instance;if(void 0!==n&&n.existsFileInVFS(e.postScriptName)){var r=n.getFileFromVFS(e.postScriptName);if("string"!=typeof r)throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('"+e.postScriptName+"').");e.metadata=tt.API.TTFFont.open(e.postScriptName,e.fontName,r,e.encoding),e.metadata.Unicode=e.metadata.Unicode||{encoding:{},kerning:{},widths:[]},e.metadata.glyIdsUsed=[0]}else if(!1===e.isStandardFont)throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('"+e.postScriptName+"').")}]),(
/** @license
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   * 
   * 
   * ====================================================================
   */
et=lt.API).addSvg=function(t,e,n,r,i){if(void 0===e||void 0===n)throw new Error("addSVG needs values for 'x' and 'y'");function o(t){for(var e=parseFloat(t[1]),n=parseFloat(t[2]),r=[],i=3,o=t.length;i<o;)"c"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2]),parseFloat(t[i+3]),parseFloat(t[i+4]),parseFloat(t[i+5]),parseFloat(t[i+6])]),i+=7):"l"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2])]),i+=3):i+=1;return[e,n,r]}var a,s,l,h,u,c,f,p,d=(h=document,p=h.createElement("iframe"),u=".jsPDF_sillysvg_iframe {display:none;position:absolute;}",(f=(c=h).createElement("style")).type="text/css",f.styleSheet?f.styleSheet.cssText=u:f.appendChild(c.createTextNode(u)),c.getElementsByTagName("head")[0].appendChild(f),p.name="childframe",p.setAttribute("width",0),p.setAttribute("height",0),p.setAttribute("frameborder","0"),p.setAttribute("scrolling","no"),p.setAttribute("seamless","seamless"),p.setAttribute("class","jsPDF_sillysvg_iframe"),h.body.appendChild(p),p),g=(a=t,(l=((s=d).contentWindow||s.contentDocument).document).write(a),l.close(),l.getElementsByTagName("svg")[0]),m=[1,1],y=parseFloat(g.getAttribute("width")),v=parseFloat(g.getAttribute("height"));y&&v&&(r&&i?m=[r/y,i/v]:r?m=[r/y,r/y]:i&&(m=[i/v,i/v]));var w,b,x,N,L=g.childNodes;for(w=0,b=L.length;w<b;w++)(x=L[w]).tagName&&"PATH"===x.tagName.toUpperCase()&&((N=o(x.getAttribute("d").split(" ")))[0]=N[0]*m[0]+e,N[1]=N[1]*m[1]+n,this.lines.call(this,N[2],N[0],N[1],m));return this},et.addSVG=et.addSvg,et.addSvgAsImage=function(t,e,n,r,i,o,a,s){if(isNaN(e)||isNaN(n))throw console.error("jsPDF.addSvgAsImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");if(isNaN(r)||isNaN(i))throw console.error("jsPDF.addSvgAsImage: Invalid measurements",arguments),new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");var l=document.createElement("canvas");l.width=r,l.height=i;var h=l.getContext("2d");return h.fillStyle="#fff",h.fillRect(0,0,l.width,l.height),canvg(l,t,{ignoreMouse:!0,ignoreAnimation:!0,ignoreDimensions:!0,ignoreClear:!0}),this.addImage(l.toDataURL("image/jpeg",1),e,n,r,i,a,s),this},lt.API.putTotalPages=function(t){var e,n=0;n=parseInt(this.internal.getFont().id.substr(1),10)<15?(e=new RegExp(t,"g"),this.internal.getNumberOfPages()):(e=new RegExp(this.pdfEscape16(t,this.internal.getFont()),"g"),this.pdfEscape16(this.internal.getNumberOfPages()+"",this.internal.getFont()));for(var r=1;r<=this.internal.getNumberOfPages();r++)for(var i=0;i<this.internal.pages[r].length;i++)this.internal.pages[r][i]=this.internal.pages[r][i].replace(e,n);return this},lt.API.viewerPreferences=function(t,e){var n;t=t||{},e=e||!1;var r,i,o={HideToolbar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideMenubar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideWindowUI:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},FitWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},CenterWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},DisplayDocTitle:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.4},NonFullScreenPageMode:{defaultValue:"UseNone",value:"UseNone",type:"name",explicitSet:!1,valueSet:["UseNone","UseOutlines","UseThumbs","UseOC"],pdfVersion:1.3},Direction:{defaultValue:"L2R",value:"L2R",type:"name",explicitSet:!1,valueSet:["L2R","R2L"],pdfVersion:1.3},ViewArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},ViewClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintScaling:{defaultValue:"AppDefault",value:"AppDefault",type:"name",explicitSet:!1,valueSet:["AppDefault","None"],pdfVersion:1.6},Duplex:{defaultValue:"",value:"none",type:"name",explicitSet:!1,valueSet:["Simplex","DuplexFlipShortEdge","DuplexFlipLongEdge","none"],pdfVersion:1.7},PickTrayByPDFSize:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.7},PrintPageRange:{defaultValue:"",value:"",type:"array",explicitSet:!1,valueSet:null,pdfVersion:1.7},NumCopies:{defaultValue:1,value:1,type:"integer",explicitSet:!1,valueSet:null,pdfVersion:1.7}},a=Object.keys(o),s=[],l=0,h=0,u=0,c=!0;function f(t,e){var n,r=!1;for(n=0;n<t.length;n+=1)t[n]===e&&(r=!0);return r}if(void 0===this.internal.viewerpreferences&&(this.internal.viewerpreferences={},this.internal.viewerpreferences.configuration=JSON.parse(JSON.stringify(o)),this.internal.viewerpreferences.isSubscribed=!1),n=this.internal.viewerpreferences.configuration,"reset"===t||!0===e){var p=a.length;for(u=0;u<p;u+=1)n[a[u]].value=n[a[u]].defaultValue,n[a[u]].explicitSet=!1}if("object"===se(t))for(r in t)if(i=t[r],f(a,r)&&void 0!==i){if("boolean"===n[r].type&&"boolean"==typeof i)n[r].value=i;else if("name"===n[r].type&&f(n[r].valueSet,i))n[r].value=i;else if("integer"===n[r].type&&Number.isInteger(i))n[r].value=i;else if("array"===n[r].type){for(l=0;l<i.length;l+=1)if(c=!0,1===i[l].length&&"number"==typeof i[l][0])s.push(String(i[l]-1));else if(1<i[l].length){for(h=0;h<i[l].length;h+=1)"number"!=typeof i[l][h]&&(c=!1);!0===c&&s.push([i[l][0]-1,i[l][1]-1].join(" "))}n[r].value="["+s.join(" ")+"]"}else n[r].value=n[r].defaultValue;n[r].explicitSet=!0}return!1===this.internal.viewerpreferences.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){var t,e=[];for(t in n)!0===n[t].explicitSet&&("name"===n[t].type?e.push("/"+t+" /"+n[t].value):e.push("/"+t+" "+n[t].value));0!==e.length&&this.internal.write("/ViewerPreferences\n<<\n"+e.join("\n")+"\n>>")}),this.internal.viewerpreferences.isSubscribed=!0),this.internal.viewerpreferences.configuration=n,this},
/** ==================================================================== 
   * jsPDF XMP metadata plugin
   * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
   * 
   * 
   * ====================================================================
   */
nt=lt.API,ot=it=rt="",nt.addMetadata=function(t,e){return it=e||"http://jspdf.default.namespaceuri/",rt=t,this.internal.events.subscribe("postPutResources",function(){if(rt){var t='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+it+'"><jspdf:metadata>',e=unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),n=unescape(encodeURIComponent(t)),r=unescape(encodeURIComponent(rt)),i=unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),o=unescape(encodeURIComponent("</x:xmpmeta>")),a=n.length+r.length+i.length+e.length+o.length;ot=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+a+" >>"),this.internal.write("stream"),this.internal.write(e+n+r+i+o),this.internal.write("endstream"),this.internal.write("endobj")}else ot=""}),this.internal.events.subscribe("putCatalog",function(){ot&&this.internal.write("/Metadata "+ot+" 0 R")}),this},function(f,t){var e=f.API;var m=e.pdfEscape16=function(t,e){for(var n,r=e.metadata.Unicode.widths,i=["","0","00","000","0000"],o=[""],a=0,s=t.length;a<s;++a){if(n=e.metadata.characterToGlyph(t.charCodeAt(a)),e.metadata.glyIdsUsed.push(n),e.metadata.toUnicode[n]=t.charCodeAt(a),-1==r.indexOf(n)&&(r.push(n),r.push([parseInt(e.metadata.widthOfGlyph(n),10)])),"0"==n)return o.join("");n=n.toString(16),o.push(i[4-n.length],n)}return o.join("")},p=function(t){var e,n,r,i,o,a,s;for(o="/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange",r=[],a=0,s=(n=Object.keys(t).sort(function(t,e){return t-e})).length;a<s;a++)e=n[a],100<=r.length&&(o+="\n"+r.length+" beginbfchar\n"+r.join("\n")+"\nendbfchar",r=[]),i=("0000"+t[e].toString(16)).slice(-4),e=("0000"+(+e).toString(16)).slice(-4),r.push("<"+e+"><"+i+">");return r.length&&(o+="\n"+r.length+" beginbfchar\n"+r.join("\n")+"\nendbfchar\n"),o+="endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend"};e.events.push(["putFont",function(t){!function(t,e,n,r){if(t.metadata instanceof f.API.TTFFont&&"Identity-H"===t.encoding){for(var i=t.metadata.Unicode.widths,o=t.metadata.subset.encode(t.metadata.glyIdsUsed,1),a="",s=0;s<o.length;s++)a+=String.fromCharCode(o[s]);var l=n();r({data:a,addLength1:!0}),e("endobj");var h=n();r({data:p(t.metadata.toUnicode),addLength1:!0}),e("endobj");var u=n();e("<<"),e("/Type /FontDescriptor"),e("/FontName /"+t.fontName),e("/FontFile2 "+l+" 0 R"),e("/FontBBox "+f.API.PDFObject.convert(t.metadata.bbox)),e("/Flags "+t.metadata.flags),e("/StemV "+t.metadata.stemV),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e(">>"),e("endobj");var c=n();e("<<"),e("/Type /Font"),e("/BaseFont /"+t.fontName),e("/FontDescriptor "+u+" 0 R"),e("/W "+f.API.PDFObject.convert(i)),e("/CIDToGIDMap /Identity"),e("/DW 1000"),e("/Subtype /CIDFontType2"),e("/CIDSystemInfo"),e("<<"),e("/Supplement 0"),e("/Registry (Adobe)"),e("/Ordering ("+t.encoding+")"),e(">>"),e(">>"),e("endobj"),t.objectNumber=n(),e("<<"),e("/Type /Font"),e("/Subtype /Type0"),e("/ToUnicode "+h+" 0 R"),e("/BaseFont /"+t.fontName),e("/Encoding /"+t.encoding),e("/DescendantFonts ["+c+" 0 R]"),e(">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject,t.putStream)}]);e.events.push(["putFont",function(t){!function(t,e,n,r){if(t.metadata instanceof f.API.TTFFont&&"WinAnsiEncoding"===t.encoding){t.metadata.Unicode.widths;for(var i=t.metadata.rawData,o="",a=0;a<i.length;a++)o+=String.fromCharCode(i[a]);var s=n();r({data:o,addLength1:!0}),e("endobj");var l=n();r({data:p(t.metadata.toUnicode),addLength1:!0}),e("endobj");var h=n();for(e("<<"),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e("/StemV "+t.metadata.stemV),e("/Type /FontDescriptor"),e("/FontFile2 "+s+" 0 R"),e("/Flags 96"),e("/FontBBox "+f.API.PDFObject.convert(t.metadata.bbox)),e("/FontName /"+t.fontName),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e(">>"),e("endobj"),t.objectNumber=n(),a=0;a<t.metadata.hmtx.widths.length;a++)t.metadata.hmtx.widths[a]=parseInt(t.metadata.hmtx.widths[a]*(1e3/t.metadata.head.unitsPerEm));e("<</Subtype/TrueType/Type/Font/ToUnicode "+l+" 0 R/BaseFont/"+t.fontName+"/FontDescriptor "+h+" 0 R/Encoding/"+t.encoding+" /FirstChar 29 /LastChar 255 /Widths "+f.API.PDFObject.convert(t.metadata.hmtx.widths)+">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject,t.putStream)}]);var h=function(t){var e,n,r=t.text||"",i=t.x,o=t.y,a=t.options||{},s=t.mutex||{},l=s.pdfEscape,h=s.activeFontKey,u=s.fonts,c=(s.activeFontSize,""),f=0,p="",d=u[n=h].encoding;if("Identity-H"!==u[n].encoding)return{text:r,x:i,y:o,options:a,mutex:s};for(p=r,n=h,"[object Array]"===Object.prototype.toString.call(r)&&(p=r[0]),f=0;f<p.length;f+=1)u[n].metadata.hasOwnProperty("cmap")&&(e=u[n].metadata.cmap.unicode.codeMap[p[f].charCodeAt(0)]),e?c+=p[f]:p[f].charCodeAt(0)<256&&u[n].metadata.hasOwnProperty("Unicode")?c+=p[f]:c+="";var g="";return parseInt(n.slice(1))<14||"WinAnsiEncoding"===d?g=function(t){for(var e="",n=0;n<t.length;n++)e+=""+t.charCodeAt(n).toString(16);return e}(l(c,n)):"Identity-H"===d&&(g=m(c,u[n])),s.isHex=!0,{text:g,x:i,y:o,options:a,mutex:s}};e.events.push(["postProcessText",function(t){var e=t.text||"",n=t.x,r=t.y,i=t.options,o=t.mutex,a=(i.lang,[]),s={text:e,x:n,y:r,options:i,mutex:o};if("[object Array]"===Object.prototype.toString.call(e)){var l=0;for(l=0;l<e.length;l+=1)"[object Array]"===Object.prototype.toString.call(e[l])&&3===e[l].length?a.push([h(Object.assign({},s,{text:e[l][0]})).text,e[l][1],e[l][2]]):a.push(h(Object.assign({},s,{text:e[l]})).text);t.text=a}else t.text=h(Object.assign({},s,{text:e})).text}])}(lt,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")()),at=lt.API,st=function(t){return void 0!==t&&(void 0===t.vFS&&(t.vFS={}),!0)},at.existsFileInVFS=function(t){return!!st(this.internal)&&void 0!==this.internal.vFS[t]},at.addFileToVFS=function(t,e){return st(this.internal),this.internal.vFS[t]=e,this},at.getFileFromVFS=function(t){return st(this.internal),void 0!==this.internal.vFS[t]?this.internal.vFS[t]:null},lt.API.addHTML=function(t,d,g,s,m){if("undefined"==typeof html2canvas&&"undefined"==typeof rasterizeHTML)throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");"number"!=typeof d&&(s=d,m=g),"function"==typeof s&&(m=s,s=null),"function"!=typeof m&&(m=function(){});var e=this.internal,y=e.scaleFactor,v=e.pageSize.getWidth(),w=e.pageSize.getHeight();if((s=s||{}).onrendered=function(l){d=parseInt(d)||0,g=parseInt(g)||0;var t=s.dim||{},h=Object.assign({top:0,right:0,bottom:0,left:0,useFor:"content"},s.margin),e=t.h||Math.min(w,l.height/y),u=t.w||Math.min(v,l.width/y)-d,c=s.format||"JPEG",f=s.imageCompression||"SLOW";if(l.height>w-h.top-h.bottom&&s.pagesplit){var p=function(t,e,n,r,i){var o=document.createElement("canvas");o.height=i,o.width=r;var a=o.getContext("2d");return a.mozImageSmoothingEnabled=!1,a.webkitImageSmoothingEnabled=!1,a.msImageSmoothingEnabled=!1,a.imageSmoothingEnabled=!1,a.fillStyle=s.backgroundColor||"#ffffff",a.fillRect(0,0,r,i),a.drawImage(t,e,n,r,i,0,0,r,i),o},n=function(){for(var t,e,n=0,r=0,i={},o=!1;;){var a;if(r=0,i.top=0!==n?h.top:g,i.left=0!==n?h.left:d,o=(v-h.left-h.right)*y<l.width,"content"===h.useFor?0===n?(t=Math.min((v-h.left)*y,l.width),e=Math.min((w-h.top)*y,l.height-n)):(t=Math.min(v*y,l.width),e=Math.min(w*y,l.height-n),i.top=0):(t=Math.min((v-h.left-h.right)*y,l.width),e=Math.min((w-h.bottom-h.top)*y,l.height-n)),o)for(;;){"content"===h.useFor&&(0===r?t=Math.min((v-h.left)*y,l.width):(t=Math.min(v*y,l.width-r),i.left=0));var s=[a=p(l,r,n,t,e),i.left,i.top,a.width/y,a.height/y,c,null,f];if(this.addImage.apply(this,s),(r+=t)>=l.width)break;this.addPage()}else s=[a=p(l,0,n,t,e),i.left,i.top,a.width/y,a.height/y,c,null,f],this.addImage.apply(this,s);if((n+=e)>=l.height)break;this.addPage()}m(u,n,null,s)}.bind(this);if("CANVAS"===l.nodeName){var r=new Image;r.onload=n,r.src=l.toDataURL("image/png"),l=r}else n()}else{var i=Math.random().toString(35),o=[l,d,g,u,e,c,i,f];this.addImage.apply(this,o),m(u,e,i,o)}}.bind(this),"undefined"!=typeof html2canvas&&!s.rstz)return html2canvas(t,s);if("undefined"==typeof rasterizeHTML)return null;var n="drawDocument";return"string"==typeof t&&(n=/^http/.test(t)?"drawURL":"drawHTML"),s.width=s.width||v*y,rasterizeHTML[n](t,void 0,s).then(function(t){s.onrendered(t.image)},function(t){m(null,t)})},
/**
   * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Daniel Husar, https://github.com/danielhusar
   *               2014 Wolfgang Gassler, https://github.com/woolfg
   *               2014 Steven Spungin, https://github.com/flamenco
   *
   * @license
   * 
   * ====================================================================
   */
function(t){var P,k,i,a,s,l,h,u,I,w,f,c,p,n,C,B,d,g,m,j;P=function(){return function(t){return e.prototype=t,new e};function e(){}}(),w=function(t){var e,n,r,i,o,a,s;for(n=0,r=t.length,e=void 0,a=i=!1;!i&&n!==r;)(e=t[n]=t[n].trimLeft())&&(i=!0),n++;for(n=r-1;r&&!a&&-1!==n;)(e=t[n]=t[n].trimRight())&&(a=!0),n--;for(o=/\s+$/g,s=!0,n=0;n!==r;)"\u2028"!=t[n]&&(e=t[n].replace(/\s+/g," "),s&&(e=e.trimLeft()),e&&(s=o.test(e)),t[n]=e),n++;return t},c=function(t){var e,n,r;for(e=void 0,n=(r=t.split(",")).shift();!e&&n;)e=i[n.trim().toLowerCase()],n=r.shift();return e},p=function(t){var e;return-1<(t="auto"===t?"0px":t).indexOf("em")&&!isNaN(Number(t.replace("em","")))&&(t=18.719*Number(t.replace("em",""))+"px"),-1<t.indexOf("pt")&&!isNaN(Number(t.replace("pt","")))&&(t=1.333*Number(t.replace("pt",""))+"px"),void 0,16,(e=n[t])?e:void 0!==(e={"xx-small":9,"x-small":11,small:13,medium:16,large:19,"x-large":23,"xx-large":28,auto:0}[t])?n[t]=e/16:(e=parseFloat(t))?n[t]=e/16:(e=t.match(/([\d\.]+)(px)/),Array.isArray(e)&&3===e.length?n[t]=parseFloat(e[1])/16:n[t]=1)},I=function(t){var e,n,r,i,o;return o=t,i=document.defaultView&&document.defaultView.getComputedStyle?document.defaultView.getComputedStyle(o,null):o.currentStyle?o.currentStyle:o.style,n=void 0,(e={})["font-family"]=c((r=function(t){return t=t.replace(/-\D/g,function(t){return t.charAt(1).toUpperCase()}),i[t]})("font-family"))||"times",e["font-style"]=a[r("font-style")]||"normal",e["text-align"]=s[r("text-align")]||"left","bold"===(n=l[r("font-weight")]||"normal")&&("normal"===e["font-style"]?e["font-style"]=n:e["font-style"]=n+e["font-style"]),e["font-size"]=p(r("font-size"))||1,e["line-height"]=p(r("line-height"))||1,e.display="inline"===r("display")?"inline":"block",n="block"===e.display,e["margin-top"]=n&&p(r("margin-top"))||0,e["margin-bottom"]=n&&p(r("margin-bottom"))||0,e["padding-top"]=n&&p(r("padding-top"))||0,e["padding-bottom"]=n&&p(r("padding-bottom"))||0,e["margin-left"]=n&&p(r("margin-left"))||0,e["margin-right"]=n&&p(r("margin-right"))||0,e["padding-left"]=n&&p(r("padding-left"))||0,e["padding-right"]=n&&p(r("padding-right"))||0,e["page-break-before"]=r("page-break-before")||"auto",e.float=h[r("cssFloat")]||"none",e.clear=u[r("clear")]||"none",e.color=r("color"),e},C=function(t,e,n){var r,i,o,a,s;if(o=!1,a=i=void 0,r=n["#"+t.id])if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;if(r=n[t.nodeName],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;for(s="string"==typeof t.className?t.className.split(" "):[],i=0;i<s.length;i++)if(r=n["."+s[i]],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;return o},j=function(t,e){var n,r,i,o,a,s,l,h,u;for(n=[],r=[],i=0,u=t.rows[0].cells.length,l=t.clientWidth;i<u;)h=t.rows[0].cells[i],r[i]={name:h.textContent.toLowerCase().replace(/\s+/g,""),prompt:h.textContent.replace(/\r?\n/g,""),width:h.clientWidth/l*e.pdf.internal.pageSize.getWidth()},i++;for(i=1;i<t.rows.length;){for(s=t.rows[i],a={},o=0;o<s.cells.length;)a[r[o].name]=s.cells[o].textContent.replace(/\r?\n/g,""),o++;n.push(a),i++}return{rows:n,headers:r}};var E={SCRIPT:1,STYLE:1,NOSCRIPT:1,OBJECT:1,EMBED:1,SELECT:1},M=1;k=function(t,i,e){var n,r,o,a,s,l,h,u;for(r=t.childNodes,n=void 0,(s="block"===(o=I(t)).display)&&(i.setBlockBoundary(),i.setBlockStyle(o)),a=0,l=r.length;a<l;){if("object"===se(n=r[a])){if(i.executeWatchFunctions(n),1===n.nodeType&&"HEADER"===n.nodeName){var c=n,f=i.pdf.margins_doc.top;i.pdf.internal.events.subscribe("addPage",function(t){i.y=f,k(c,i,e),i.pdf.margins_doc.top=i.y+10,i.y+=10},!1)}if(8===n.nodeType&&"#comment"===n.nodeName)~n.textContent.indexOf("ADD_PAGE")&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top);else if(1!==n.nodeType||E[n.nodeName])if(3===n.nodeType){var p=n.nodeValue;if(n.nodeValue&&"LI"===n.parentNode.nodeName)if("OL"===n.parentNode.parentNode.nodeName)p=M+++". "+p;else{var d=o["font-size"],g=(3-.75*d)*i.pdf.internal.scaleFactor,m=.75*d*i.pdf.internal.scaleFactor,y=1.74*d/i.pdf.internal.scaleFactor;u=function(t,e){this.pdf.circle(t+g,e+m,y,"FD")}}16&n.ownerDocument.body.compareDocumentPosition(n)&&i.addText(p,o)}else"string"==typeof n&&i.addText(n,o);else{var v;if("IMG"===n.nodeName){var w=n.getAttribute("src");v=B[i.pdf.sHashCode(w)||w]}if(v){i.pdf.internal.pageSize.getHeight()-i.pdf.margins_doc.bottom<i.y+n.height&&i.y>i.pdf.margins_doc.top&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top,i.executeWatchFunctions(n));var b=I(n),x=i.x,N=12/i.pdf.internal.scaleFactor,L=(b["margin-left"]+b["padding-left"])*N,A=(b["margin-right"]+b["padding-right"])*N,S=(b["margin-top"]+b["padding-top"])*N,_=(b["margin-bottom"]+b["padding-bottom"])*N;void 0!==b.float&&"right"===b.float?x+=i.settings.width-n.width-A:x+=L,i.pdf.addImage(v,x,i.y+S,n.width,n.height),v=void 0,"right"===b.float||"left"===b.float?(i.watchFunctions.push(function(t,e,n,r){return i.y>=e?(i.x+=t,i.settings.width+=n,!0):!!(r&&1===r.nodeType&&!E[r.nodeName]&&i.x+r.width>i.pdf.margins_doc.left+i.pdf.margins_doc.width)&&(i.x+=t,i.y=e,i.settings.width+=n,!0)}.bind(this,"left"===b.float?-n.width-L-A:0,i.y+n.height+S+_,n.width)),i.watchFunctions.push(function(t,e,n){return!(i.y<t&&e===i.pdf.internal.getNumberOfPages())||1===n.nodeType&&"both"===I(n).clear&&(i.y=t,!0)}.bind(this,i.y+n.height,i.pdf.internal.getNumberOfPages())),i.settings.width-=n.width+L+A,"left"===b.float&&(i.x+=n.width+L+A)):i.y+=n.height+S+_}else if("TABLE"===n.nodeName)h=j(n,i),i.y+=10,i.pdf.table(i.x,i.y,h.rows,h.headers,{autoSize:!1,printHeaders:e.printHeaders,margins:i.pdf.margins_doc,css:I(n)}),i.y=i.pdf.lastCellPos.y+i.pdf.lastCellPos.h+20;else if("OL"===n.nodeName||"UL"===n.nodeName)M=1,C(n,i,e)||k(n,i,e),i.y+=10;else if("LI"===n.nodeName){var F=i.x;i.x+=20/i.pdf.internal.scaleFactor,i.y+=3,C(n,i,e)||k(n,i,e),i.x=F}else"BR"===n.nodeName?(i.y+=o["font-size"]*i.pdf.internal.scaleFactor,i.addText("\u2028",P(o))):C(n,i,e)||k(n,i,e)}}a++}if(e.outY=i.y,s)return i.setBlockBoundary(u)},B={},d=function(t,o,e,n){var a,r=t.getElementsByTagName("img"),i=r.length,s=0;function l(){o.pdf.internal.events.publish("imagesLoaded"),n(a)}function h(e,n,r){if(e){var i=new Image;a=++s,i.crossOrigin="",i.onerror=i.onload=function(){if(i.complete&&(0===i.src.indexOf("data:image/")&&(i.width=n||i.width||0,i.height=r||i.height||0),i.width+i.height)){var t=o.pdf.sHashCode(e)||e;B[t]=B[t]||i}--s||l()},i.src=e}}for(;i--;)h(r[i].getAttribute("src"),r[i].width,r[i].height);return s||l()},g=function(t,o,a){var s=t.getElementsByTagName("footer");if(0<s.length){s=s[0];var e=o.pdf.internal.write,n=o.y;o.pdf.internal.write=function(){},k(s,o,a);var l=Math.ceil(o.y-n)+5;o.y=n,o.pdf.internal.write=e,o.pdf.margins_doc.bottom+=l;for(var r=function(t){var e=void 0!==t?t.pageNumber:1,n=o.y;o.y=o.pdf.internal.pageSize.getHeight()-o.pdf.margins_doc.bottom,o.pdf.margins_doc.bottom-=l;for(var r=s.getElementsByTagName("span"),i=0;i<r.length;++i)-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" pageCounter ")&&(r[i].innerHTML=e),-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&(r[i].innerHTML="###jsPDFVarTotalPages###");k(s,o,a),o.pdf.margins_doc.bottom+=l,o.y=n},i=s.getElementsByTagName("span"),h=0;h<i.length;++h)-1<(" "+i[h].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&o.pdf.internal.events.subscribe("htmlRenderingFinished",o.pdf.putTotalPages.bind(o.pdf,"###jsPDFVarTotalPages###"),!0);o.pdf.internal.events.subscribe("addPage",r,!1),r(),E.FOOTER=1}},m=function(t,e,n,r,i,o){if(!e)return!1;var a,s,l,h;"string"==typeof e||e.parentNode||(e=""+e.innerHTML),"string"==typeof e&&(a=e.replace(/<\/?script[^>]*?>/gi,""),h="jsPDFhtmlText"+Date.now().toString()+(1e3*Math.random()).toFixed(0),(l=document.createElement("div")).style.cssText="position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;",l.innerHTML='<iframe style="height:1px;width:1px" name="'+h+'" />',document.body.appendChild(l),(s=window.frames[h]).document.open(),s.document.writeln(a),s.document.close(),e=s.document.body);var u,c=new f(t,n,r,i);return d.call(this,e,c,i.elementHandlers,function(t){g(e,c,i.elementHandlers),k(e,c,i.elementHandlers),c.pdf.internal.events.publish("htmlRenderingFinished"),u=c.dispose(),"function"==typeof o?o(u):t&&console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!")}),u||{x:c.x,y:c.y}},(f=function(t,e,n,r){return this.pdf=t,this.x=e,this.y=n,this.settings=r,this.watchFunctions=[],this.init(),this}).prototype.init=function(){return this.paragraph={text:[],style:[]},this.pdf.internal.write("q")},f.prototype.dispose=function(){return this.pdf.internal.write("Q"),{x:this.x,y:this.y,ready:!0}},f.prototype.executeWatchFunctions=function(t){var e=!1,n=[];if(0<this.watchFunctions.length){for(var r=0;r<this.watchFunctions.length;++r)!0===this.watchFunctions[r](t)?e=!0:n.push(this.watchFunctions[r]);this.watchFunctions=n}return e},f.prototype.splitFragmentsIntoLines=function(t,e){var n,r,i,o,a,s,l,h,u,c,f,p,d,g;for(12,c=this.pdf.internal.scaleFactor,o={},s=l=h=g=a=i=u=r=void 0,p=[f=[]],n=0,d=this.settings.width;t.length;)if(a=t.shift(),g=e.shift(),a)if((i=o[(r=g["font-family"])+(u=g["font-style"])])||(i=this.pdf.internal.getFont(r,u).metadata.Unicode,o[r+u]=i),h={widths:i.widths,kerning:i.kerning,fontSize:12*g["font-size"],textIndent:n},l=this.pdf.getStringUnitWidth(a,h)*h.fontSize/c,"\u2028"==a)f=[],p.push(f);else if(d<n+l){for(s=this.pdf.splitTextToSize(a,d,h),f.push([s.shift(),g]);s.length;)f=[[s.shift(),g]],p.push(f);n=this.pdf.getStringUnitWidth(f[0][0],h)*h.fontSize/c}else f.push([a,g]),n+=l;if(void 0!==g["text-align"]&&("center"===g["text-align"]||"right"===g["text-align"]||"justify"===g["text-align"]))for(var m=0;m<p.length;++m){var y=this.pdf.getStringUnitWidth(p[m][0][0],h)*h.fontSize/c;0<m&&(p[m][0][1]=P(p[m][0][1]));var v=d-y;if("right"===g["text-align"])p[m][0][1]["margin-left"]=v;else if("center"===g["text-align"])p[m][0][1]["margin-left"]=v/2;else if("justify"===g["text-align"]){var w=p[m][0][0].split(" ").length-1;p[m][0][1]["word-spacing"]=v/w,m===p.length-1&&(p[m][0][1]["word-spacing"]=0)}}return p},f.prototype.RenderTextFragment=function(t,e){var n,r;r=0,this.pdf.internal.pageSize.getHeight()-this.pdf.margins_doc.bottom<this.y+this.pdf.internal.getFontSize()&&(this.pdf.internal.write("ET","Q"),this.pdf.addPage(),this.y=this.pdf.margins_doc.top,this.pdf.internal.write("q","BT",this.getPdfColor(e.color),this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td"),r=Math.max(r,e["line-height"],e["font-size"]),this.pdf.internal.write(0,(-12*r).toFixed(2),"Td")),n=this.pdf.internal.getFont(e["font-family"],e["font-style"]);var i=this.getPdfColor(e.color);i!==this.lastTextColor&&(this.pdf.internal.write(i),this.lastTextColor=i),void 0!==e["word-spacing"]&&0<e["word-spacing"]&&this.pdf.internal.write(e["word-spacing"].toFixed(2),"Tw"),this.pdf.internal.write("/"+n.id,(12*e["font-size"]).toFixed(2),"Tf","("+this.pdf.internal.pdfEscape(t)+") Tj"),void 0!==e["word-spacing"]&&this.pdf.internal.write(0,"Tw")},f.prototype.getPdfColor=function(t){var e,n,r,i=/rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/.exec(t);if(null!=i)e=parseInt(i[1]),n=parseInt(i[2]),r=parseInt(i[3]);else{if("string"==typeof t&&"#"!=t.charAt(0)){var o=new RGBColor(t);t=o.ok?o.toHex():"#000000"}e=t.substring(1,3),e=parseInt(e,16),n=t.substring(3,5),n=parseInt(n,16),r=t.substring(5,7),r=parseInt(r,16)}if("string"==typeof e&&/^#[0-9A-Fa-f]{6}$/.test(e)){var a=parseInt(e.substr(1),16);e=a>>16&255,n=a>>8&255,r=255&a}var s=this.f3;return 0===e&&0===n&&0===r||void 0===n?s(e/255)+" g":[s(e/255),s(n/255),s(r/255),"rg"].join(" ")},f.prototype.f3=function(t){return t.toFixed(3)},f.prototype.renderParagraph=function(t){var e,n,r,i,o,a,s,l,h,u,c,f,p;if(r=w(this.paragraph.text),f=this.paragraph.style,e=this.paragraph.blockstyle,this.paragraph.priorblockstyle||{},this.paragraph={text:[],style:[],blockstyle:{},priorblockstyle:e},r.join("").trim()){s=this.splitFragmentsIntoLines(r,f),l=a=void 0,n=12/this.pdf.internal.scaleFactor,this.priorMarginBottom=this.priorMarginBottom||0,c=(Math.max((e["margin-top"]||0)-this.priorMarginBottom,0)+(e["padding-top"]||0))*n,u=((e["margin-bottom"]||0)+(e["padding-bottom"]||0))*n,this.priorMarginBottom=e["margin-bottom"]||0,"always"===e["page-break-before"]&&(this.pdf.addPage(),this.y=0,c=((e["margin-top"]||0)+(e["padding-top"]||0))*n),h=this.pdf.internal.write,o=i=void 0,this.y+=c,h("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td");for(var d=0;s.length;){for(i=l=0,o=(a=s.shift()).length;i!==o;)a[i][0].trim()&&(l=Math.max(l,a[i][1]["line-height"],a[i][1]["font-size"]),p=7*a[i][1]["font-size"]),i++;var g=0,m=0;for(void 0!==a[0][1]["margin-left"]&&0<a[0][1]["margin-left"]&&(g=(m=this.pdf.internal.getCoordinateString(a[0][1]["margin-left"]))-d,d=m),h(g+Math.max(e["margin-left"]||0,0)*n,(-12*l).toFixed(2),"Td"),i=0,o=a.length;i!==o;)a[i][0]&&this.RenderTextFragment(a[i][0],a[i][1]),i++;if(this.y+=l*n,this.executeWatchFunctions(a[0][1])&&0<s.length){var y=[],v=[];s.forEach(function(t){for(var e=0,n=t.length;e!==n;)t[e][0]&&(y.push(t[e][0]+" "),v.push(t[e][1])),++e}),s=this.splitFragmentsIntoLines(w(y),v),h("ET","Q"),h("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td")}}return t&&"function"==typeof t&&t.call(this,this.x-9,this.y-p/2),h("ET","Q"),this.y+=u}},f.prototype.setBlockBoundary=function(t){return this.renderParagraph(t)},f.prototype.setBlockStyle=function(t){return this.paragraph.blockstyle=t},f.prototype.addText=function(t,e){return this.paragraph.text.push(t),this.paragraph.style.push(e)},i={helvetica:"helvetica","sans-serif":"helvetica","times new roman":"times",serif:"times",times:"times",monospace:"courier",courier:"courier"},l={100:"normal",200:"normal",300:"normal",400:"normal",500:"bold",600:"bold",700:"bold",800:"bold",900:"bold",normal:"normal",bold:"bold",bolder:"bold",lighter:"normal"},a={normal:"normal",italic:"italic",oblique:"italic"},s={left:"left",right:"right",center:"center",justify:"justify"},h={none:"none",right:"right",left:"left"},u={none:"none",both:"both"},n={normal:1},t.fromHTML=function(t,e,n,r,i,o){return this.margins_doc=o||{top:0,bottom:0},r||(r={}),r.elementHandlers||(r.elementHandlers={}),m(this,t,isNaN(e)?4:e,isNaN(n)?4:n,r,i)}}(lt.API),lt.API,("undefined"!=typeof window&&window||"undefined"!=typeof global&&global).html2pdf=function(t,a,e){var n=a.canvas;if(n){var r,i;if((n.pdf=a).annotations={_nameMap:[],createAnnotation:function(t,e){var n,r=a.context2d._wrapX(e.left),i=a.context2d._wrapY(e.top),o=(a.context2d._page(e.top),t.indexOf("#"));n=0<=o?{name:t.substring(o+1)}:{url:t},a.link(r,i,e.right-e.left,e.bottom-e.top,n)},setName:function(t,e){var n=a.context2d._wrapX(e.left),r=a.context2d._wrapY(e.top),i=a.context2d._page(e.top);this._nameMap[t]={page:i,x:n,y:r}}},n.annotations=a.annotations,a.context2d._pageBreakAt=function(t){this.pageBreaks.push(t)},a.context2d._gotoPage=function(t){for(;a.internal.getNumberOfPages()<t;)a.addPage();a.setPage(t)},"string"==typeof t){t=t.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,"");var o,s,l=document.createElement("iframe");document.body.appendChild(l),null!=(o=l.contentDocument)&&null!=o||(o=l.contentWindow.document),o.open(),o.write(t),o.close(),r=o.body,s=o.body||{},t=o.documentElement||{},i=Math.max(s.scrollHeight,s.offsetHeight,t.clientHeight,t.scrollHeight,t.offsetHeight)}else s=(r=t).body||{},i=Math.max(s.scrollHeight,s.offsetHeight,t.clientHeight,t.scrollHeight,t.offsetHeight);var h={async:!0,allowTaint:!0,backgroundColor:"#ffffff",canvas:n,imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1,windowHeight:i=a.internal.pageSize.getHeight(),scrollY:i};a.context2d.pageWrapYEnabled=!0,a.context2d.pageWrapY=a.internal.pageSize.getHeight(),html2canvas(r,h).then(function(t){e&&(l&&l.parentElement.removeChild(l),e(a))})}else alert("jsPDF canvas plugin not installed")},window.tmp=html2pdf,function(f){var r=f.BlobBuilder||f.WebKitBlobBuilder||f.MSBlobBuilder||f.MozBlobBuilder;f.URL=f.URL||f.webkitURL||function(t,e){return(e=document.createElement("a")).href=t,e};var n=f.Blob,p=URL.createObjectURL,d=URL.revokeObjectURL,o=f.Symbol&&f.Symbol.toStringTag,t=!1,e=!1,g=!!f.ArrayBuffer,i=r&&r.prototype.append&&r.prototype.getBlob;try{t=2===new Blob(["ä"]).size,e=2===new Blob([new Uint8Array([1,2])]).size}catch(t){}function a(t){return t.map(function(t){if(t.buffer instanceof ArrayBuffer){var e=t.buffer;if(t.byteLength!==e.byteLength){var n=new Uint8Array(t.byteLength);n.set(new Uint8Array(e,t.byteOffset,t.byteLength)),e=n.buffer}return e}return t})}function s(t,e){e=e||{};var n=new r;return a(t).forEach(function(t){n.append(t)}),e.type?n.getBlob(e.type):n.getBlob()}function l(t,e){return new n(a(t),e||{})}if(f.Blob&&(s.prototype=Blob.prototype,l.prototype=Blob.prototype),o)try{File.prototype[o]="File",Blob.prototype[o]="Blob",FileReader.prototype[o]="FileReader"}catch(t){}function h(){var t=!!f.ActiveXObject||"-ms-scroll-limit"in document.documentElement.style&&"-ms-ime-align"in document.documentElement.style,e=f.XMLHttpRequest&&f.XMLHttpRequest.prototype.send;t&&e&&(XMLHttpRequest.prototype.send=function(t){t instanceof Blob&&this.setRequestHeader("Content-Type",t.type),e.call(this,t)});try{new File([],"")}catch(t){try{var n=new Function('class File extends Blob {constructor(chunks, name, opts) {opts = opts || {};super(chunks, opts || {});this.name = name;this.lastModifiedDate = opts.lastModified ? new Date(opts.lastModified) : new Date;this.lastModified = +this.lastModifiedDate;}};return new File([], ""), File')();f.File=n}catch(t){n=function(t,e,n){var r=new Blob(t,n),i=n&&void 0!==n.lastModified?new Date(n.lastModified):new Date;return r.name=e,r.lastModifiedDate=i,r.lastModified=+i,r.toString=function(){return"[object File]"},o&&(r[o]="File"),r};f.File=n}}}t?(h(),f.Blob=e?f.Blob:l):i?(h(),f.Blob=s):function(){function a(t){for(var e=[],n=0;n<t.length;n++){var r=t.charCodeAt(n);r<128?e.push(r):r<2048?e.push(192|r>>6,128|63&r):r<55296||57344<=r?e.push(224|r>>12,128|r>>6&63,128|63&r):(n++,r=65536+((1023&r)<<10|1023&t.charCodeAt(n)),e.push(240|r>>18,128|r>>12&63,128|r>>6&63,128|63&r))}return e}function e(t){var e,n,r,i,o,a;for(e="",r=t.length,n=0;n<r;)switch((i=t[n++])>>4){case 0:case 1:case 2:case 3:case 4:case 5:case 6:case 7:e+=String.fromCharCode(i);break;case 12:case 13:o=t[n++],e+=String.fromCharCode((31&i)<<6|63&o);break;case 14:o=t[n++],a=t[n++],e+=String.fromCharCode((15&i)<<12|(63&o)<<6|(63&a)<<0)}return e}function s(t){for(var e=new Array(t.byteLength),n=new Uint8Array(t),r=e.length;r--;)e[r]=n[r];return e}function n(t){for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",n=[],r=0;r<t.length;r+=3){var i=t[r],o=r+1<t.length,a=o?t[r+1]:0,s=r+2<t.length,l=s?t[r+2]:0,h=i>>2,u=(3&i)<<4|a>>4,c=(15&a)<<2|l>>6,f=63&l;s||(f=64,o||(c=64)),n.push(e[h],e[u],e[c],e[f])}return n.join("")}var t=Object.create||function(t){function e(){}return e.prototype=t,new e};if(g)var r=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],l=ArrayBuffer.isView||function(t){return t&&-1<r.indexOf(Object.prototype.toString.call(t))};function h(t,e){for(var n=0,r=(t=t||[]).length;n<r;n++){var i=t[n];i instanceof h?t[n]=i._buffer:"string"==typeof i?t[n]=a(i):g&&(ArrayBuffer.prototype.isPrototypeOf(i)||l(i))?t[n]=s(i):g&&(o=i)&&DataView.prototype.isPrototypeOf(o)?t[n]=s(i.buffer):t[n]=a(String(i))}var o;this._buffer=[].concat.apply([],t),this.size=this._buffer.length,this.type=e&&e.type||""}function i(t,e,n){var r=h.call(this,t,n=n||{})||this;return r.name=e,r.lastModifiedDate=n.lastModified?new Date(n.lastModified):new Date,r.lastModified=+r.lastModifiedDate,r}if(h.prototype.slice=function(t,e,n){return new h([this._buffer.slice(t||0,e||this._buffer.length)],{type:n})},h.prototype.toString=function(){return"[object Blob]"},(i.prototype=t(h.prototype)).constructor=i,Object.setPrototypeOf)Object.setPrototypeOf(i,h);else try{i.__proto__=h}catch(t){}function o(){if(!(this instanceof o))throw new TypeError("Failed to construct 'FileReader': Please use the 'new' operator, this DOM object constructor cannot be called as a function.");var n=document.createDocumentFragment();this.addEventListener=n.addEventListener,this.dispatchEvent=function(t){var e=this["on"+t.type];"function"==typeof e&&e(t),n.dispatchEvent(t)},this.removeEventListener=n.removeEventListener}function u(t,e,n){if(!(e instanceof h))throw new TypeError("Failed to execute '"+n+"' on 'FileReader': parameter 1 is not of type 'Blob'.");t.result="",setTimeout(function(){this.readyState=o.LOADING,t.dispatchEvent(new Event("load")),t.dispatchEvent(new Event("loadend"))})}i.prototype.toString=function(){return"[object File]"},o.EMPTY=0,o.LOADING=1,o.DONE=2,o.prototype.error=null,o.prototype.onabort=null,o.prototype.onerror=null,o.prototype.onload=null,o.prototype.onloadend=null,o.prototype.onloadstart=null,o.prototype.onprogress=null,o.prototype.readAsDataURL=function(t){u(this,t,"readAsDataURL"),this.result="data:"+t.type+";base64,"+n(t._buffer)},o.prototype.readAsText=function(t){u(this,t,"readAsText"),this.result=e(t._buffer)},o.prototype.readAsArrayBuffer=function(t){u(this,t,"readAsText"),this.result=t._buffer.slice()},o.prototype.abort=function(){},URL.createObjectURL=function(t){return t instanceof h?"data:"+t.type+";base64,"+n(t._buffer):p.call(URL,t)},URL.revokeObjectURL=function(t){d&&d.call(URL,t)};var c=f.XMLHttpRequest&&f.XMLHttpRequest.prototype.send;c&&(XMLHttpRequest.prototype.send=function(t){t instanceof h?(this.setRequestHeader("Content-Type",t.type),c.call(this,e(t._buffer))):c.call(this,t)}),f.FileReader=o,f.File=i,f.Blob=h}()}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());var ht,ut,ct,ft,pt,dt,gt,mt,yt,vt,wt,bt,xt,Nt,Lt,le=le||function(s){if(!(void 0===s||"undefined"!=typeof navigator&&/MSIE [1-9]\./.test(navigator.userAgent))){var t=s.document,l=function(){return s.URL||s.webkitURL||s},h=t.createElementNS("http://www.w3.org/1999/xhtml","a"),u="download"in h,c=/constructor/i.test(s.HTMLElement)||s.safari,f=/CriOS\/[\d]+/.test(navigator.userAgent),p=s.setImmediate||s.setTimeout,d=function(t){p(function(){throw t},0)},g=function(t){setTimeout(function(){"string"==typeof t?l().revokeObjectURL(t):t.remove()},4e4)},m=function(t){return/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type)?new Blob([String.fromCharCode(65279),t],{type:t.type}):t},r=function(t,n,e){e||(t=m(t));var r,i=this,o="application/octet-stream"===t.type,a=function(){!function(t,e,n){for(var r=(e=[].concat(e)).length;r--;){var i=t["on"+e[r]];if("function"==typeof i)try{i.call(t,n||t)}catch(t){d(t)}}}(i,"writestart progress write writeend".split(" "))};if(i.readyState=i.INIT,u)return r=l().createObjectURL(t),void p(function(){var t,e;h.href=r,h.download=n,t=h,e=new MouseEvent("click"),t.dispatchEvent(e),a(),g(r),i.readyState=i.DONE},0);!function(){if((f||o&&c)&&s.FileReader){var e=new FileReader;return e.onloadend=function(){var t=f?e.result:e.result.replace(/^data:[^;]*;/,"data:attachment/file;");s.open(t,"_blank")||(s.location.href=t),t=void 0,i.readyState=i.DONE,a()},e.readAsDataURL(t),i.readyState=i.INIT}r||(r=l().createObjectURL(t)),o?s.location.href=r:s.open(r,"_blank")||(s.location.href=r);i.readyState=i.DONE,a(),g(r)}()},e=r.prototype;return"undefined"!=typeof navigator&&navigator.msSaveOrOpenBlob?function(t,e,n){return e=e||t.name||"download",n||(t=m(t)),navigator.msSaveOrOpenBlob(t,e)}:(e.abort=function(){},e.readyState=e.INIT=0,e.WRITING=1,e.DONE=2,e.error=e.onwritestart=e.onprogress=e.onwrite=e.onabort=e.onerror=e.onwriteend=null,function(t,e,n){return new r(t,e||t.name||"download",n)})}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||void 0);function At(x){var t=0;if(71!==x[t++]||73!==x[t++]||70!==x[t++]||56!==x[t++]||56!=(x[t++]+1&253)||97!==x[t++])throw"Invalid GIF 87a/89a header.";var N=x[t++]|x[t++]<<8,e=x[t++]|x[t++]<<8,n=x[t++],r=n>>7,i=1<<(7&n)+1;x[t++];x[t++];var o=null;r&&(o=t,t+=3*i);var a=!0,s=[],l=0,h=null,u=0,c=null;for(this.width=N,this.height=e;a&&t<x.length;)switch(x[t++]){case 33:switch(x[t++]){case 255:if(11!==x[t]||78==x[t+1]&&69==x[t+2]&&84==x[t+3]&&83==x[t+4]&&67==x[t+5]&&65==x[t+6]&&80==x[t+7]&&69==x[t+8]&&50==x[t+9]&&46==x[t+10]&&48==x[t+11]&&3==x[t+12]&&1==x[t+13]&&0==x[t+16])t+=14,c=x[t++]|x[t++]<<8,t++;else for(t+=12;;){if(0===(A=x[t++]))break;t+=A}break;case 249:if(4!==x[t++]||0!==x[t+4])throw"Invalid graphics extension block.";var f=x[t++];l=x[t++]|x[t++]<<8,h=x[t++],0==(1&f)&&(h=null),u=f>>2&7,t++;break;case 254:for(;;){if(0===(A=x[t++]))break;t+=A}break;default:throw"Unknown graphic control label: 0x"+x[t-1].toString(16)}break;case 44:var p=x[t++]|x[t++]<<8,d=x[t++]|x[t++]<<8,g=x[t++]|x[t++]<<8,m=x[t++]|x[t++]<<8,y=x[t++],v=y>>6&1,w=o,b=!1;if(y>>7){b=!0;w=t,t+=3*(1<<(7&y)+1)}var L=t;for(t++;;){var A;if(0===(A=x[t++]))break;t+=A}s.push({x:p,y:d,width:g,height:m,has_local_palette:b,palette_offset:w,data_offset:L,data_length:t-L,transparent_index:h,interlaced:!!v,delay:l,disposal:u});break;case 59:a=!1;break;default:throw"Unknown gif block: 0x"+x[t-1].toString(16)}this.numFrames=function(){return s.length},this.loopCount=function(){return c},this.frameInfo=function(t){if(t<0||t>=s.length)throw"Frame index out of range.";return s[t]},this.decodeAndBlitFrameBGRA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);St(x,n.data_offset,i,r);var o=n.palette_offset,a=n.transparent_index;null===a&&(a=256);var s=n.width,l=N-s,h=s,u=4*(n.y*N+n.x),c=4*((n.y+n.height)*N+n.x),f=u,p=4*l;!0===n.interlaced&&(p+=4*(s+l)*7);for(var d=8,g=0,m=i.length;g<m;++g){var y=i[g];if(0===h&&(h=s,c<=(f+=p)&&(p=l+4*(s+l)*(d-1),f=u+(s+l)*(d<<1),d>>=1)),y===a)f+=4;else{var v=x[o+3*y],w=x[o+3*y+1],b=x[o+3*y+2];e[f++]=b,e[f++]=w,e[f++]=v,e[f++]=255}--h}},this.decodeAndBlitFrameRGBA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);St(x,n.data_offset,i,r);var o=n.palette_offset,a=n.transparent_index;null===a&&(a=256);var s=n.width,l=N-s,h=s,u=4*(n.y*N+n.x),c=4*((n.y+n.height)*N+n.x),f=u,p=4*l;!0===n.interlaced&&(p+=4*(s+l)*7);for(var d=8,g=0,m=i.length;g<m;++g){var y=i[g];if(0===h&&(h=s,c<=(f+=p)&&(p=l+4*(s+l)*(d-1),f=u+(s+l)*(d<<1),d>>=1)),y===a)f+=4;else{var v=x[o+3*y],w=x[o+3*y+1],b=x[o+3*y+2];e[f++]=v,e[f++]=w,e[f++]=b,e[f++]=255}--h}}}function St(t,e,n,r){for(var i=t[e++],o=1<<i,a=o+1,s=a+1,l=i+1,h=(1<<l)-1,u=0,c=0,f=0,p=t[e++],d=new Int32Array(4096),g=null;;){for(;u<16&&0!==p;)c|=t[e++]<<u,u+=8,1===p?p=t[e++]:--p;if(u<l)break;var m=c&h;if(c>>=l,u-=l,m!==o){if(m===a)break;for(var y=m<s?m:g,v=0,w=y;o<w;)w=d[w]>>8,++v;var b=w;if(r<f+v+(y!==m?1:0))return void console.log("Warning, gif stream longer than expected.");n[f++]=b;var x=f+=v;for(y!==m&&(n[f++]=b),w=y;v--;)w=d[w],n[--x]=255&w,w>>=8;null!==g&&s<4096&&(d[s++]=g<<8|b,h+1<=s&&l<12&&(++l,h=h<<1|1)),g=m}else s=a+1,h=(1<<(l=i+1))-1,g=null}return f!==r&&console.log("Warning, gif stream shorter than expected."),n}try{exports.GifWriter=function(y,t,e,n){var v=0,r=void 0===(n=void 0===n?{}:n).loop?null:n.loop,w=void 0===n.palette?null:n.palette;if(t<=0||e<=0||65535<t||65535<e)throw"Width/Height invalid.";function b(t){var e=t.length;if(e<2||256<e||e&e-1)throw"Invalid code/color length, must be power of 2 and 2 .. 256.";return e}y[v++]=71,y[v++]=73,y[v++]=70,y[v++]=56,y[v++]=57,y[v++]=97;var i=0,o=0;if(null!==w){for(var a=b(w);a>>=1;)++i;if(a=1<<i,--i,void 0!==n.background){if(a<=(o=n.background))throw"Background index out of range.";if(0===o)throw"Background index explicitly passed as 0."}}if(y[v++]=255&t,y[v++]=t>>8&255,y[v++]=255&e,y[v++]=e>>8&255,y[v++]=(null!==w?128:0)|i,y[v++]=o,y[v++]=0,null!==w)for(var s=0,l=w.length;s<l;++s){var h=w[s];y[v++]=h>>16&255,y[v++]=h>>8&255,y[v++]=255&h}if(null!==r){if(r<0||65535<r)throw"Loop count invalid.";y[v++]=33,y[v++]=255,y[v++]=11,y[v++]=78,y[v++]=69,y[v++]=84,y[v++]=83,y[v++]=67,y[v++]=65,y[v++]=80,y[v++]=69,y[v++]=50,y[v++]=46,y[v++]=48,y[v++]=3,y[v++]=1,y[v++]=255&r,y[v++]=r>>8&255,y[v++]=0}var x=!1;this.addFrame=function(t,e,n,r,i,o){if(!0===x&&(--v,x=!1),o=void 0===o?{}:o,t<0||e<0||65535<t||65535<e)throw"x/y invalid.";if(n<=0||r<=0||65535<n||65535<r)throw"Width/Height invalid.";if(i.length<n*r)throw"Not enough pixels for the frame size.";var a=!0,s=o.palette;if(null==s&&(a=!1,s=w),null==s)throw"Must supply either a local or global palette.";for(var l=b(s),h=0;l>>=1;)++h;l=1<<h;var u=void 0===o.delay?0:o.delay,c=void 0===o.disposal?0:o.disposal;if(c<0||3<c)throw"Disposal out of range.";var f=!1,p=0;if(void 0!==o.transparent&&null!==o.transparent&&(f=!0,(p=o.transparent)<0||l<=p))throw"Transparent color index.";if((0!==c||f||0!==u)&&(y[v++]=33,y[v++]=249,y[v++]=4,y[v++]=c<<2|(!0===f?1:0),y[v++]=255&u,y[v++]=u>>8&255,y[v++]=p,y[v++]=0),y[v++]=44,y[v++]=255&t,y[v++]=t>>8&255,y[v++]=255&e,y[v++]=e>>8&255,y[v++]=255&n,y[v++]=n>>8&255,y[v++]=255&r,y[v++]=r>>8&255,y[v++]=!0===a?128|h-1:0,!0===a)for(var d=0,g=s.length;d<g;++d){var m=s[d];y[v++]=m>>16&255,y[v++]=m>>8&255,y[v++]=255&m}v=function(e,n,t,r){e[n++]=t;var i=n++,o=1<<t,a=o-1,s=o+1,l=s+1,h=t+1,u=0,c=0;function f(t){for(;t<=u;)e[n++]=255&c,c>>=8,u-=8,n===i+256&&(e[i]=255,i=n++)}function p(t){c|=t<<u,u+=h,f(8)}var d=r[0]&a,g={};p(o);for(var m=1,y=r.length;m<y;++m){var v=r[m]&a,w=d<<8|v,b=g[w];if(void 0===b){for(c|=d<<u,u+=h;8<=u;)e[n++]=255&c,c>>=8,u-=8,n===i+256&&(e[i]=255,i=n++);4096===l?(p(o),l=s+1,h=t+1,g={}):(1<<h<=l&&++h,g[w]=l++),d=v}else d=b}return p(d),p(s),f(1),i+1===n?e[i]=0:(e[i]=n-i-1,e[n++]=0),n}(y,v,h<2?2:h,i)},this.end=function(){return!1===x&&(y[v++]=59,x=!0),v}},exports.GifReader=At}catch(t){}
/*
    Copyright (c) 2008, Adobe Systems Incorporated
    All rights reserved.

    Redistribution and use in source and binary forms, with or without 
    modification, are permitted provided that the following conditions are
    met:

    * Redistributions of source code must retain the above copyright notice, 
      this list of conditions and the following disclaimer.
    
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the 
      documentation and/or other materials provided with the distribution.
    
    * Neither the name of Adobe Systems Incorporated nor the names of its 
      contributors may be used to endorse or promote products derived from 
      this software without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
    IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
    THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
    PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
    CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
    EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
    PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
    PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
    LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
    NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
    SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */
function _t(t){var N,L,A,S,e,c=Math.floor,_=new Array(64),F=new Array(64),P=new Array(64),k=new Array(64),y=new Array(65535),v=new Array(65535),Z=new Array(64),w=new Array(64),I=[],C=0,B=7,j=new Array(64),E=new Array(64),M=new Array(64),n=new Array(256),O=new Array(2048),b=[0,1,5,6,14,15,27,28,2,4,7,13,16,26,29,42,3,8,12,17,25,30,41,43,9,11,18,24,31,40,44,53,10,19,23,32,39,45,52,54,20,22,33,38,46,51,55,60,21,34,37,47,50,56,59,61,35,36,48,49,57,58,62,63],q=[0,0,1,5,1,1,1,1,1,1,0,0,0,0,0,0,0],T=[0,1,2,3,4,5,6,7,8,9,10,11],R=[0,0,2,1,3,3,2,4,3,5,5,4,4,0,0,1,125],D=[1,2,3,0,4,17,5,18,33,49,65,6,19,81,97,7,34,113,20,50,129,145,161,8,35,66,177,193,21,82,209,240,36,51,98,114,130,9,10,22,23,24,25,26,37,38,39,40,41,42,52,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,225,226,227,228,229,230,231,232,233,234,241,242,243,244,245,246,247,248,249,250],U=[0,0,3,1,1,1,1,1,1,1,1,1,0,0,0,0,0],z=[0,1,2,3,4,5,6,7,8,9,10,11],H=[0,0,2,1,2,4,4,3,4,7,5,4,4,0,1,2,119],W=[0,1,2,3,17,4,5,33,49,6,18,65,81,7,97,113,19,34,50,129,8,20,66,145,161,177,193,9,35,51,82,240,21,98,114,209,10,22,36,52,225,37,241,23,24,25,26,38,39,40,41,42,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,130,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,226,227,228,229,230,231,232,233,234,242,243,244,245,246,247,248,249,250];function r(t,e){for(var n=0,r=0,i=new Array,o=1;o<=16;o++){for(var a=1;a<=t[o];a++)i[e[r]]=[],i[e[r]][0]=n,i[e[r]][1]=o,r++,n++;n*=2}return i}function V(t){for(var e=t[0],n=t[1]-1;0<=n;)e&1<<n&&(C|=1<<B),n--,--B<0&&(255==C?(G(255),G(0)):G(C),B=7,C=0)}function G(t){I.push(t)}function Y(t){G(t>>8&255),G(255&t)}function J(t,e,n,r,i){for(var o,a=i[0],s=i[240],l=function(t,e){var n,r,i,o,a,s,l,h,u,c,f=0;for(u=0;u<8;++u){n=t[f],r=t[f+1],i=t[f+2],o=t[f+3],a=t[f+4],s=t[f+5],l=t[f+6];var p=n+(h=t[f+7]),d=n-h,g=r+l,m=r-l,y=i+s,v=i-s,w=o+a,b=o-a,x=p+w,N=p-w,L=g+y,A=g-y;t[f]=x+L,t[f+4]=x-L;var S=.707106781*(A+N);t[f+2]=N+S,t[f+6]=N-S;var _=.382683433*((x=b+v)-(A=m+d)),F=.5411961*x+_,P=1.306562965*A+_,k=.707106781*(L=v+m),I=d+k,C=d-k;t[f+5]=C+F,t[f+3]=C-F,t[f+1]=I+P,t[f+7]=I-P,f+=8}for(u=f=0;u<8;++u){n=t[f],r=t[f+8],i=t[f+16],o=t[f+24],a=t[f+32],s=t[f+40],l=t[f+48];var B=n+(h=t[f+56]),j=n-h,E=r+l,M=r-l,O=i+s,q=i-s,T=o+a,R=o-a,D=B+T,U=B-T,z=E+O,H=E-O;t[f]=D+z,t[f+32]=D-z;var W=.707106781*(H+U);t[f+16]=U+W,t[f+48]=U-W;var V=.382683433*((D=R+q)-(H=M+j)),G=.5411961*D+V,Y=1.306562965*H+V,J=.707106781*(z=q+M),X=j+J,K=j-J;t[f+40]=K+G,t[f+24]=K-G,t[f+8]=X+Y,t[f+56]=X-Y,f++}for(u=0;u<64;++u)c=t[u]*e[u],Z[u]=0<c?c+.5|0:c-.5|0;return Z}(t,e),h=0;h<64;++h)w[b[h]]=l[h];var u=w[0]-n;n=w[0],0==u?V(r[0]):(V(r[v[o=32767+u]]),V(y[o]));for(var c=63;0<c&&0==w[c];c--);if(0==c)return V(a),n;for(var f,p=1;p<=c;){for(var d=p;0==w[p]&&p<=c;++p);var g=p-d;if(16<=g){f=g>>4;for(var m=1;m<=f;++m)V(s);g&=15}o=32767+w[p],V(i[(g<<4)+v[o]]),V(y[o]),p++}return 63!=c&&V(a),n}function X(t){if(t<=0&&(t=1),100<t&&(t=100),e!=t){(function(t){for(var e=[16,11,10,16,24,40,51,61,12,12,14,19,26,58,60,55,14,13,16,24,40,57,69,56,14,17,22,29,51,87,80,62,18,22,37,56,68,109,103,77,24,35,55,64,81,104,113,92,49,64,78,87,103,121,120,101,72,92,95,98,112,100,103,99],n=0;n<64;n++){var r=c((e[n]*t+50)/100);r<1?r=1:255<r&&(r=255),_[b[n]]=r}for(var i=[17,18,24,47,99,99,99,99,18,21,26,66,99,99,99,99,24,26,56,99,99,99,99,99,47,66,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99],o=0;o<64;o++){var a=c((i[o]*t+50)/100);a<1?a=1:255<a&&(a=255),F[b[o]]=a}for(var s=[1,1.387039845,1.306562965,1.175875602,1,.785694958,.5411961,.275899379],l=0,h=0;h<8;h++)for(var u=0;u<8;u++)P[l]=1/(_[b[l]]*s[h]*s[u]*8),k[l]=1/(F[b[l]]*s[h]*s[u]*8),l++})(t<50?Math.floor(5e3/t):Math.floor(200-2*t)),e=t}}this.encode=function(t,e){var n,r;(new Date).getTime();e&&X(e),I=new Array,C=0,B=7,Y(65496),Y(65504),Y(16),G(74),G(70),G(73),G(70),G(0),G(1),G(1),G(0),Y(1),Y(1),G(0),G(0),function(){Y(65499),Y(132),G(0);for(var t=0;t<64;t++)G(_[t]);G(1);for(var e=0;e<64;e++)G(F[e])}(),n=t.width,r=t.height,Y(65472),Y(17),G(8),Y(r),Y(n),G(3),G(1),G(17),G(0),G(2),G(17),G(1),G(3),G(17),G(1),function(){Y(65476),Y(418),G(0);for(var t=0;t<16;t++)G(q[t+1]);for(var e=0;e<=11;e++)G(T[e]);G(16);for(var n=0;n<16;n++)G(R[n+1]);for(var r=0;r<=161;r++)G(D[r]);G(1);for(var i=0;i<16;i++)G(U[i+1]);for(var o=0;o<=11;o++)G(z[o]);G(17);for(var a=0;a<16;a++)G(H[a+1]);for(var s=0;s<=161;s++)G(W[s])}(),Y(65498),Y(12),G(3),G(1),G(0),G(2),G(17),G(3),G(17),G(0),G(63),G(0);var i=0,o=0,a=0;C=0,B=7,this.encode.displayName="_encode_";for(var s,l,h,u,c,f,p,d,g,m=t.data,y=t.width,v=t.height,w=4*y,b=0;b<v;){for(s=0;s<w;){for(f=c=w*b+s,p=-1,g=d=0;g<64;g++)f=c+(d=g>>3)*w+(p=4*(7&g)),v<=b+d&&(f-=w*(b+1+d-v)),w<=s+p&&(f-=s+p-w+4),l=m[f++],h=m[f++],u=m[f++],j[g]=(O[l]+O[h+256>>0]+O[u+512>>0]>>16)-128,E[g]=(O[l+768>>0]+O[h+1024>>0]+O[u+1280>>0]>>16)-128,M[g]=(O[l+1280>>0]+O[h+1536>>0]+O[u+1792>>0]>>16)-128;i=J(j,P,i,N,A),o=J(E,k,o,L,S),a=J(M,k,a,L,S),s+=32}b+=8}if(0<=B){var x=[];x[1]=B+1,x[0]=(1<<B+1)-1,V(x)}return Y(65497),new Uint8Array(I)},function(){(new Date).getTime();t||(t=50),function(){for(var t=String.fromCharCode,e=0;e<256;e++)n[e]=t(e)}(),N=r(q,T),L=r(U,z),A=r(R,D),S=r(H,W),function(){for(var t=1,e=2,n=1;n<=15;n++){for(var r=t;r<e;r++)v[32767+r]=n,y[32767+r]=[],y[32767+r][1]=n,y[32767+r][0]=r;for(var i=-(e-1);i<=-t;i++)v[32767+i]=n,y[32767+i]=[],y[32767+i][1]=n,y[32767+i][0]=e-1+i;t<<=1,e<<=1}}(),function(){for(var t=0;t<256;t++)O[t]=19595*t,O[t+256>>0]=38470*t,O[t+512>>0]=7471*t+32768,O[t+768>>0]=-11059*t,O[t+1024>>0]=-21709*t,O[t+1280>>0]=32768*t+8421375,O[t+1536>>0]=-27439*t,O[t+1792>>0]=-5329*t}(),X(t),(new Date).getTime()}()}function Ft(t,e){if(this.pos=0,this.buffer=t,this.datav=new DataView(t.buffer),this.is_with_alpha=!!e,this.bottom_up=!0,this.flag=String.fromCharCode(this.buffer[0])+String.fromCharCode(this.buffer[1]),this.pos+=2,-1===["BM","BA","CI","CP","IC","PT"].indexOf(this.flag))throw new Error("Invalid BMP File");this.parseHeader(),this.parseBGR()}window.tmp=At,lt.API.adler32cs=(dt="function"==typeof ArrayBuffer&&"function"==typeof Uint8Array,gt=null,mt=function(){if(!dt)return function(){return!1};try{var t={};"function"==typeof t.Buffer&&(gt=t.Buffer)}catch(t){}return function(t){return t instanceof ArrayBuffer||null!==gt&&t instanceof gt}}(),yt=null!==gt?function(t){return new gt(t,"utf8").toString("binary")}:function(t){return unescape(encodeURIComponent(t))},vt=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+(255&e.charCodeAt(i)))%65521,r=(r+n)%65521;return(r<<16|n)>>>0},wt=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+e[i])%65521,r=(r+n)%65521;return(r<<16|n)>>>0},xt=(bt={}).Adler32=(((pt=(ft=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(!isFinite(t=null==t?1:+t))throw new Error("First arguments needs to be a finite number.");this.checksum=t>>>0}).prototype={}).constructor=ft).from=((ht=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");this.checksum=vt(1,t.toString())}).prototype=pt,ht),ft.fromUtf8=((ut=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");var e=yt(t.toString());this.checksum=vt(1,e)}).prototype=pt,ut),dt&&(ft.fromBuffer=((ct=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(!mt(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=wt(1,e)}).prototype=pt,ct)),pt.update=function(t){if(null==t)throw new Error("First argument needs to be a string.");return t=t.toString(),this.checksum=vt(this.checksum,t)},pt.updateUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=yt(t.toString());return this.checksum=vt(this.checksum,e)},dt&&(pt.updateBuffer=function(t){if(!mt(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=wt(this.checksum,e)}),pt.clone=function(){return new xt(this.checksum)},ft),bt.from=function(t){if(null==t)throw new Error("First argument needs to be a string.");return vt(1,t.toString())},bt.fromUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=yt(t.toString());return vt(1,e)},dt&&(bt.fromBuffer=function(t){if(!mt(t))throw new Error("First argument need to be ArrayBuffer.");var e=new Uint8Array(t);return wt(1,e)}),bt),function(t){t.__bidiEngine__=t.prototype.__bidiEngine__=function(t){var d,g,c,f,i,o,a,s=e,m=[[0,3,0,1,0,0,0],[0,3,0,1,2,2,0],[0,3,0,17,2,0,1],[0,3,5,5,4,1,0],[0,3,21,21,4,0,1],[0,3,5,5,4,2,0]],y=[[2,0,1,1,0,1,0],[2,0,1,1,0,2,0],[2,0,2,1,3,2,0],[2,0,2,33,3,1,1]],v={L:0,R:1,EN:2,AN:3,N:4,B:5,S:6},l={0:0,5:1,6:2,7:3,32:4,251:5,254:6,255:7},h=["(",")","(","<",">","<","[","]","[","{","}","{","«","»","«","‹","›","‹","⁅","⁆","⁅","⁽","⁾","⁽","₍","₎","₍","≤","≥","≤","〈","〉","〈","﹙","﹚","﹙","﹛","﹜","﹛","﹝","﹞","﹝","﹤","﹥","﹤"],u=new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/),w=!1,b=0;this.__bidiEngine__={};var x=function(t){var e=t.charCodeAt(),n=e>>8,r=l[n];return void 0!==r?s[256*r+(255&e)]:252===n||253===n?"AL":u.test(n)?"L":8===n?"R":"N"},p=function(t){for(var e,n=0;n<t.length;n++){if("L"===(e=x(t.charAt(n))))return!1;if("R"===e)return!0}return!1},N=function(t,e,n,r){var i,o,a,s,l=e[r];switch(l){case"L":case"R":w=!1;break;case"N":case"AN":break;case"EN":w&&(l="AN");break;case"AL":w=!0,l="R";break;case"WS":l="N";break;case"CS":r<1||r+1>=e.length||"EN"!==(i=n[r-1])&&"AN"!==i||"EN"!==(o=e[r+1])&&"AN"!==o?l="N":w&&(o="AN"),l=o===i?o:"N";break;case"ES":l="EN"===(i=0<r?n[r-1]:"B")&&r+1<e.length&&"EN"===e[r+1]?"EN":"N";break;case"ET":if(0<r&&"EN"===n[r-1]){l="EN";break}if(w){l="N";break}for(a=r+1,s=e.length;a<s&&"ET"===e[a];)a++;l=a<s&&"EN"===e[a]?"EN":"N";break;case"NSM":if(c&&!f){for(s=e.length,a=r+1;a<s&&"NSM"===e[a];)a++;if(a<s){var h=t[r],u=1425<=h&&h<=2303||64286===h;if(i=e[a],u&&("R"===i||"AL"===i)){l="R";break}}}l=r<1||"B"===(i=e[r-1])?"N":n[r-1];break;case"B":d=!(w=!1),l=b;break;case"S":g=!0,l="N";break;case"LRE":case"RLE":case"LRO":case"RLO":case"PDF":w=!1;break;case"BN":l="N"}return l},L=function(t,e,n){var r=t.split("");return n&&A(r,n,{hiLevel:b}),r.reverse(),e&&e.reverse(),r.join("")},A=function(t,e,n){var r,i,o,a,s,l=-1,h=t.length,u=0,c=[],f=b?y:m,p=[];for(g=d=w=!1,i=0;i<h;i++)p[i]=x(t[i]);for(o=0;o<h;o++){if(s=u,c[o]=N(t,p,c,o),r=240&(u=f[s][v[c[o]]]),u&=15,e[o]=a=f[u][5],0<r)if(16===r){for(i=l;i<o;i++)e[i]=1;l=-1}else l=-1;if(f[u][6])-1===l&&(l=o);else if(-1<l){for(i=l;i<o;i++)e[i]=a;l=-1}"B"===p[o]&&(e[o]=0),n.hiLevel|=a}g&&function(t,e,n){for(var r=0;r<n;r++)if("S"===t[r]){e[r]=b;for(var i=r-1;0<=i&&"WS"===t[i];i--)e[i]=b}}(p,e,h)},S=function(t,e,n,r,i){if(!(i.hiLevel<t)){if(1===t&&1===b&&!d)return e.reverse(),void(n&&n.reverse());for(var o,a,s,l,h=e.length,u=0;u<h;){if(r[u]>=t){for(s=u+1;s<h&&r[s]>=t;)s++;for(l=u,a=s-1;l<a;l++,a--)o=e[l],e[l]=e[a],e[a]=o,n&&(o=n[l],n[l]=n[a],n[a]=o);u=s}u++}}},_=function(t,e,n){var r=t.split(""),i={hiLevel:b};return n||(n=[]),A(r,n,i),function(t,e,n){if(0!==n.hiLevel&&a)for(var r,i=0;i<t.length;i++)1===e[i]&&0<=(r=h.indexOf(t[i]))&&(t[i]=h[r+1])}(r,n,i),S(2,r,e,n,i),S(1,r,e,n,i),r.join("")};return this.__bidiEngine__.doBidiReorder=function(t,e,n){if(function(t,e){if(e)for(var n=0;n<t.length;n++)e[n]=n;void 0===f&&(f=p(t)),void 0===o&&(o=p(t))}(t,e),c||!i||o)if(c&&i&&f^o)b=f?1:0,t=L(t,e,n);else if(!c&&i&&o)b=f?1:0,t=_(t,e,n),t=L(t,e);else if(!c||f||i||o){if(c&&!i&&f^o)t=L(t,e),t=f?(b=0,_(t,e,n)):(b=1,t=_(t,e,n),L(t,e));else if(c&&f&&!i&&o)b=1,t=_(t,e,n),t=L(t,e);else if(!c&&!i&&f^o){var r=a;f?(b=1,t=_(t,e,n),b=0,a=!1,t=_(t,e,n),a=r):(b=0,t=_(t,e,n),t=L(t,e),a=!(b=1),t=_(t,e,n),a=r,t=L(t,e))}}else b=0,t=_(t,e,n);else b=f?1:0,t=_(t,e,n);return t},this.__bidiEngine__.setOptions=function(t){t&&(c=t.isInputVisual,i=t.isOutputVisual,f=t.isInputRtl,o=t.isOutputRtl,a=t.isSymmetricSwapping)},this.__bidiEngine__.setOptions(t),this.__bidiEngine__};var e=["BN","BN","BN","BN","BN","BN","BN","BN","BN","S","B","S","WS","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","B","B","B","S","WS","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","BN","BN","BN","BN","BN","BN","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","CS","N","ET","ET","ET","ET","N","N","N","N","L","N","N","BN","N","N","ET","ET","EN","EN","N","L","N","N","N","EN","L","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","N","N","N","N","N","ET","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","NSM","R","NSM","NSM","R","NSM","NSM","R","NSM","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","N","N","N","N","N","R","R","R","R","R","N","N","N","N","N","N","N","N","N","N","N","AN","AN","AN","AN","AN","AN","N","N","AL","ET","ET","AL","CS","AL","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","AN","AN","AN","AN","AN","AN","AN","AN","AN","ET","AN","AN","AL","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","N","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","NSM","NSM","N","NSM","NSM","NSM","NSM","AL","AL","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","R","N","N","N","N","R","N","N","N","N","N","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","BN","BN","BN","L","R","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","B","LRE","RLE","PDF","LRO","RLO","CS","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","BN","BN","BN","BN","BN","N","LRI","RLI","FSI","PDI","BN","BN","BN","BN","BN","BN","EN","L","N","N","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","L","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","N","N","N","N","N","R","NSM","R","R","R","R","R","R","R","R","R","R","ES","R","R","R","R","R","R","R","R","R","R","R","R","R","N","R","R","R","R","R","N","R","N","R","R","N","R","R","N","R","R","R","R","R","R","R","R","R","R","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","CS","N","N","CS","N","N","N","N","N","N","N","N","N","ET","N","N","ES","ES","N","N","N","N","N","ET","ET","N","N","N","N","N","AL","AL","AL","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","BN","N","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","N","N","N","ET","ET","N","N","N","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N"],o=new t.__bidiEngine__({isInputVisual:!0});t.API.events.push(["postProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),r=(t.mutex,n.lang,[]);if("[object Array]"===Object.prototype.toString.call(e)){var i=0;for(r=[],i=0;i<e.length;i+=1)"[object Array]"===Object.prototype.toString.call(e[i])?r.push([o.doBidiReorder(e[i][0]),e[i][1],e[i][2]]):r.push([o.doBidiReorder(e[i])]);t.text=r}else t.text=o.doBidiReorder(e)}])}(lt),window.tmp=_t,Ft.prototype.parseHeader=function(){if(this.fileSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.reserved=this.datav.getUint32(this.pos,!0),this.pos+=4,this.offset=this.datav.getUint32(this.pos,!0),this.pos+=4,this.headerSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.width=this.datav.getUint32(this.pos,!0),this.pos+=4,this.height=this.datav.getInt32(this.pos,!0),this.pos+=4,this.planes=this.datav.getUint16(this.pos,!0),this.pos+=2,this.bitPP=this.datav.getUint16(this.pos,!0),this.pos+=2,this.compress=this.datav.getUint32(this.pos,!0),this.pos+=4,this.rawSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.hr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.vr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.colors=this.datav.getUint32(this.pos,!0),this.pos+=4,this.importantColors=this.datav.getUint32(this.pos,!0),this.pos+=4,16===this.bitPP&&this.is_with_alpha&&(this.bitPP=15),this.bitPP<15){var t=0===this.colors?1<<this.bitPP:this.colors;this.palette=new Array(t);for(var e=0;e<t;e++){var n=this.datav.getUint8(this.pos++,!0),r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0);this.palette[e]={red:i,green:r,blue:n,quad:o}}}this.height<0&&(this.height*=-1,this.bottom_up=!1)},Ft.prototype.parseBGR=function(){this.pos=this.offset;try{var t="bit"+this.bitPP,e=this.width*this.height*4;this.data=new Uint8Array(e),this[t]()}catch(t){console.log("bit decode error:"+t)}},Ft.prototype.bit1=function(){var t=Math.ceil(this.width/8),e=t%4,n=0<=this.height?this.height-1:-this.height;for(n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<t;i++)for(var o=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+8*i*4,s=0;s<8&&8*i+s<this.width;s++){var l=this.palette[o>>7-s&1];this.data[a+4*s]=l.blue,this.data[a+4*s+1]=l.green,this.data[a+4*s+2]=l.red,this.data[a+4*s+3]=255}0!=e&&(this.pos+=4-e)}},Ft.prototype.bit4=function(){for(var t=Math.ceil(this.width/2),e=t%4,n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<t;i++){var o=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+2*i*4,s=o>>4,l=15&o,h=this.palette[s];if(this.data[a]=h.blue,this.data[a+1]=h.green,this.data[a+2]=h.red,this.data[a+3]=255,2*i+1>=this.width)break;h=this.palette[l],this.data[a+4]=h.blue,this.data[a+4+1]=h.green,this.data[a+4+2]=h.red,this.data[a+4+3]=255}0!=e&&(this.pos+=4-e)}},Ft.prototype.bit8=function(){for(var t=this.width%4,e=this.height-1;0<=e;e--){for(var n=this.bottom_up?e:this.height-1-e,r=0;r<this.width;r++){var i=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+4*r;if(i<this.palette.length){var a=this.palette[i];this.data[o]=a.red,this.data[o+1]=a.green,this.data[o+2]=a.blue,this.data[o+3]=255}else this.data[o]=255,this.data[o+1]=255,this.data[o+2]=255,this.data[o+3]=255}0!=t&&(this.pos+=4-t)}},Ft.prototype.bit15=function(){for(var t=this.width%3,e=parseInt("11111",2),n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<this.width;i++){var o=this.datav.getUint16(this.pos,!0);this.pos+=2;var a=(o&e)/e*255|0,s=(o>>5&e)/e*255|0,l=(o>>10&e)/e*255|0,h=o>>15?255:0,u=r*this.width*4+4*i;this.data[u]=l,this.data[u+1]=s,this.data[u+2]=a,this.data[u+3]=h}this.pos+=t}},Ft.prototype.bit16=function(){for(var t=this.width%3,e=parseInt("11111",2),n=parseInt("111111",2),r=this.height-1;0<=r;r--){for(var i=this.bottom_up?r:this.height-1-r,o=0;o<this.width;o++){var a=this.datav.getUint16(this.pos,!0);this.pos+=2;var s=(a&e)/e*255|0,l=(a>>5&n)/n*255|0,h=(a>>11)/e*255|0,u=i*this.width*4+4*o;this.data[u]=h,this.data[u+1]=l,this.data[u+2]=s,this.data[u+3]=255}this.pos+=t}},Ft.prototype.bit24=function(){for(var t=this.height-1;0<=t;t--){for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),a=e*this.width*4+4*n;this.data[a]=o,this.data[a+1]=i,this.data[a+2]=r,this.data[a+3]=255}this.pos+=this.width%4}},Ft.prototype.bit32=function(){for(var t=this.height-1;0<=t;t--)for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),s=e*this.width*4+4*n;this.data[s]=o,this.data[s+1]=i,this.data[s+2]=r,this.data[s+3]=a}},Ft.prototype.getData=function(){return this.data},window.tmp=Ft,
/*
   Copyright (c) 2013 Gildas Lormeau. All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:

   1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

   2. Redistributions in binary form must reproduce the above copyright 
   notice, this list of conditions and the following disclaimer in 
   the documentation and/or other materials provided with the distribution.

   3. The names of the authors may not be used to endorse or promote products
   derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */
function(t){var d=15,g=573,e=[0,1,2,3,4,4,5,5,6,6,6,6,7,7,7,7,8,8,8,8,8,8,8,8,9,9,9,9,9,9,9,9,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,0,0,16,17,18,18,19,19,20,20,20,20,21,21,21,21,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29];function ct(){var p=this;function l(t,e){for(var n=0;n|=1&t,t>>>=1,n<<=1,0<--e;);return n>>>1}p.build_tree=function(t){var e,n,r,i=p.dyn_tree,o=p.stat_desc.static_tree,a=p.stat_desc.elems,s=-1;for(t.heap_len=0,t.heap_max=g,e=0;e<a;e++)0!==i[2*e]?(t.heap[++t.heap_len]=s=e,t.depth[e]=0):i[2*e+1]=0;for(;t.heap_len<2;)i[2*(r=t.heap[++t.heap_len]=s<2?++s:0)]=1,t.depth[r]=0,t.opt_len--,o&&(t.static_len-=o[2*r+1]);for(p.max_code=s,e=Math.floor(t.heap_len/2);1<=e;e--)t.pqdownheap(i,e);for(r=a;e=t.heap[1],t.heap[1]=t.heap[t.heap_len--],t.pqdownheap(i,1),n=t.heap[1],t.heap[--t.heap_max]=e,t.heap[--t.heap_max]=n,i[2*r]=i[2*e]+i[2*n],t.depth[r]=Math.max(t.depth[e],t.depth[n])+1,i[2*e+1]=i[2*n+1]=r,t.heap[1]=r++,t.pqdownheap(i,1),2<=t.heap_len;);t.heap[--t.heap_max]=t.heap[1],function(t){var e,n,r,i,o,a,s=p.dyn_tree,l=p.stat_desc.static_tree,h=p.stat_desc.extra_bits,u=p.stat_desc.extra_base,c=p.stat_desc.max_length,f=0;for(i=0;i<=d;i++)t.bl_count[i]=0;for(s[2*t.heap[t.heap_max]+1]=0,e=t.heap_max+1;e<g;e++)c<(i=s[2*s[2*(n=t.heap[e])+1]+1]+1)&&(i=c,f++),s[2*n+1]=i,n>p.max_code||(t.bl_count[i]++,o=0,u<=n&&(o=h[n-u]),a=s[2*n],t.opt_len+=a*(i+o),l&&(t.static_len+=a*(l[2*n+1]+o)));if(0!==f){do{for(i=c-1;0===t.bl_count[i];)i--;t.bl_count[i]--,t.bl_count[i+1]+=2,t.bl_count[c]--,f-=2}while(0<f);for(i=c;0!==i;i--)for(n=t.bl_count[i];0!==n;)(r=t.heap[--e])>p.max_code||(s[2*r+1]!=i&&(t.opt_len+=(i-s[2*r+1])*s[2*r],s[2*r+1]=i),n--)}}(t),function(t,e,n){var r,i,o,a=[],s=0;for(r=1;r<=d;r++)a[r]=s=s+n[r-1]<<1;for(i=0;i<=e;i++)0!==(o=t[2*i+1])&&(t[2*i]=l(a[o]++,o))}(i,p.max_code,t.bl_count)}}function ft(t,e,n,r,i){this.static_tree=t,this.extra_bits=e,this.extra_base=n,this.elems=r,this.max_length=i}ct._length_code=[0,1,2,3,4,5,6,7,8,8,9,9,10,10,11,11,12,12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,16,16,16,16,17,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28],ct.base_length=[0,1,2,3,4,5,6,7,8,10,12,14,16,20,24,28,32,40,48,56,64,80,96,112,128,160,192,224,0],ct.base_dist=[0,1,2,3,4,6,8,12,16,24,32,48,64,96,128,192,256,384,512,768,1024,1536,2048,3072,4096,6144,8192,12288,16384,24576],ct.d_code=function(t){return t<256?e[t]:e[256+(t>>>7)]},ct.extra_lbits=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],ct.extra_dbits=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],ct.extra_blbits=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],ct.bl_order=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],ft.static_ltree=[12,8,140,8,76,8,204,8,44,8,172,8,108,8,236,8,28,8,156,8,92,8,220,8,60,8,188,8,124,8,252,8,2,8,130,8,66,8,194,8,34,8,162,8,98,8,226,8,18,8,146,8,82,8,210,8,50,8,178,8,114,8,242,8,10,8,138,8,74,8,202,8,42,8,170,8,106,8,234,8,26,8,154,8,90,8,218,8,58,8,186,8,122,8,250,8,6,8,134,8,70,8,198,8,38,8,166,8,102,8,230,8,22,8,150,8,86,8,214,8,54,8,182,8,118,8,246,8,14,8,142,8,78,8,206,8,46,8,174,8,110,8,238,8,30,8,158,8,94,8,222,8,62,8,190,8,126,8,254,8,1,8,129,8,65,8,193,8,33,8,161,8,97,8,225,8,17,8,145,8,81,8,209,8,49,8,177,8,113,8,241,8,9,8,137,8,73,8,201,8,41,8,169,8,105,8,233,8,25,8,153,8,89,8,217,8,57,8,185,8,121,8,249,8,5,8,133,8,69,8,197,8,37,8,165,8,101,8,229,8,21,8,149,8,85,8,213,8,53,8,181,8,117,8,245,8,13,8,141,8,77,8,205,8,45,8,173,8,109,8,237,8,29,8,157,8,93,8,221,8,61,8,189,8,125,8,253,8,19,9,275,9,147,9,403,9,83,9,339,9,211,9,467,9,51,9,307,9,179,9,435,9,115,9,371,9,243,9,499,9,11,9,267,9,139,9,395,9,75,9,331,9,203,9,459,9,43,9,299,9,171,9,427,9,107,9,363,9,235,9,491,9,27,9,283,9,155,9,411,9,91,9,347,9,219,9,475,9,59,9,315,9,187,9,443,9,123,9,379,9,251,9,507,9,7,9,263,9,135,9,391,9,71,9,327,9,199,9,455,9,39,9,295,9,167,9,423,9,103,9,359,9,231,9,487,9,23,9,279,9,151,9,407,9,87,9,343,9,215,9,471,9,55,9,311,9,183,9,439,9,119,9,375,9,247,9,503,9,15,9,271,9,143,9,399,9,79,9,335,9,207,9,463,9,47,9,303,9,175,9,431,9,111,9,367,9,239,9,495,9,31,9,287,9,159,9,415,9,95,9,351,9,223,9,479,9,63,9,319,9,191,9,447,9,127,9,383,9,255,9,511,9,0,7,64,7,32,7,96,7,16,7,80,7,48,7,112,7,8,7,72,7,40,7,104,7,24,7,88,7,56,7,120,7,4,7,68,7,36,7,100,7,20,7,84,7,52,7,116,7,3,8,131,8,67,8,195,8,35,8,163,8,99,8,227,8],ft.static_dtree=[0,5,16,5,8,5,24,5,4,5,20,5,12,5,28,5,2,5,18,5,10,5,26,5,6,5,22,5,14,5,30,5,1,5,17,5,9,5,25,5,5,5,21,5,13,5,29,5,3,5,19,5,11,5,27,5,7,5,23,5],ft.static_l_desc=new ft(ft.static_ltree,ct.extra_lbits,257,286,d),ft.static_d_desc=new ft(ft.static_dtree,ct.extra_dbits,0,30,d),ft.static_bl_desc=new ft(null,ct.extra_blbits,0,19,7);function n(t,e,n,r,i){this.good_length=t,this.max_lazy=e,this.nice_length=n,this.max_chain=r,this.func=i}var pt=[new n(0,0,0,0,0),new n(4,4,8,4,1),new n(4,5,16,8,1),new n(4,6,32,32,1),new n(4,4,16,16,2),new n(8,16,32,32,2),new n(8,16,128,128,2),new n(8,32,128,256,2),new n(32,128,258,1024,2),new n(32,258,258,4096,2)],dt=["need dictionary","stream end","","","stream error","data error","","buffer error","",""];function gt(t,e,n,r){var i=t[2*e],o=t[2*n];return i<o||i==o&&r[e]<=r[n]}function r(){var l,h,u,c,f,p,d,g,i,m,y,v,w,a,b,x,N,L,A,S,_,F,P,k,I,C,B,j,E,M,s,O,q,T,R,D,U,o,z,H,W,V=this,G=new ct,Y=new ct,J=new ct;function X(){var t;for(t=0;t<286;t++)s[2*t]=0;for(t=0;t<30;t++)O[2*t]=0;for(t=0;t<19;t++)q[2*t]=0;s[512]=1,V.opt_len=V.static_len=0,D=o=0}function K(t,e){var n,r,i=-1,o=t[1],a=0,s=7,l=4;for(0===o&&(s=138,l=3),t[2*(e+1)+1]=65535,n=0;n<=e;n++)r=o,o=t[2*(n+1)+1],++a<s&&r==o||(a<l?q[2*r]+=a:0!==r?(r!=i&&q[2*r]++,q[32]++):a<=10?q[34]++:q[36]++,i=r,l=(a=0)===o?(s=138,3):r==o?(s=6,3):(s=7,4))}function Z(t){V.pending_buf[V.pending++]=t}function Q(t){Z(255&t),Z(t>>>8&255)}function $(t,e){var n,r=e;16-r<W?(Q(H|=(n=t)<<W&65535),H=n>>>16-W,W+=r-16):(H|=t<<W&65535,W+=r)}function tt(t,e){var n=2*t;$(65535&e[n],65535&e[n+1])}function et(t,e){var n,r,i=-1,o=t[1],a=0,s=7,l=4;for(0===o&&(s=138,l=3),n=0;n<=e;n++)if(r=o,o=t[2*(n+1)+1],!(++a<s&&r==o)){if(a<l)for(;tt(r,q),0!=--a;);else 0!==r?(r!=i&&(tt(r,q),a--),tt(16,q),$(a-3,2)):a<=10?(tt(17,q),$(a-3,3)):(tt(18,q),$(a-11,7));i=r,l=(a=0)===o?(s=138,3):r==o?(s=6,3):(s=7,4)}}function nt(){16==W?(Q(H),W=H=0):8<=W&&(Z(255&H),H>>>=8,W-=8)}function rt(t,e){var n,r,i;if(V.pending_buf[U+2*D]=t>>>8&255,V.pending_buf[U+2*D+1]=255&t,V.pending_buf[T+D]=255&e,D++,0===t?s[2*e]++:(o++,t--,s[2*(ct._length_code[e]+256+1)]++,O[2*ct.d_code(t)]++),0==(8191&D)&&2<B){for(n=8*D,r=_-N,i=0;i<30;i++)n+=O[2*i]*(5+ct.extra_dbits[i]);if(n>>>=3,o<Math.floor(D/2)&&n<Math.floor(r/2))return!0}return D==R-1}function it(t,e){var n,r,i,o,a=0;if(0!==D)for(;n=V.pending_buf[U+2*a]<<8&65280|255&V.pending_buf[U+2*a+1],r=255&V.pending_buf[T+a],a++,0===n?tt(r,t):(tt((i=ct._length_code[r])+256+1,t),0!==(o=ct.extra_lbits[i])&&$(r-=ct.base_length[i],o),tt(i=ct.d_code(--n),e),0!==(o=ct.extra_dbits[i])&&$(n-=ct.base_dist[i],o)),a<D;);tt(256,t),z=t[513]}function ot(){8<W?Q(H):0<W&&Z(255&H),W=H=0}function at(t,e,n){var r,i,o;$(0+(n?1:0),3),r=t,i=e,o=!0,ot(),z=8,o&&(Q(i),Q(~i)),V.pending_buf.set(g.subarray(r,r+i),V.pending),V.pending+=i}function e(t,e,n){var r,i,o=0;0<B?(G.build_tree(V),Y.build_tree(V),o=function(){var t;for(K(s,G.max_code),K(O,Y.max_code),J.build_tree(V),t=18;3<=t&&0===q[2*ct.bl_order[t]+1];t--);return V.opt_len+=3*(t+1)+5+5+4,t}(),r=V.opt_len+3+7>>>3,(i=V.static_len+3+7>>>3)<=r&&(r=i)):r=i=e+5,e+4<=r&&-1!=t?at(t,e,n):i==r?($(2+(n?1:0),3),it(ft.static_ltree,ft.static_dtree)):($(4+(n?1:0),3),function(t,e,n){var r;for($(t-257,5),$(e-1,5),$(n-4,4),r=0;r<n;r++)$(q[2*ct.bl_order[r]+1],3);et(s,t-1),et(O,e-1)}(G.max_code+1,Y.max_code+1,o+1),it(s,O)),X(),n&&ot()}function st(t){e(0<=N?N:-1,_-N,t),N=_,l.flush_pending()}function lt(){var t,e,n,r;do{if(0===(r=i-P-_)&&0===_&&0===P)r=f;else if(-1==r)r--;else if(f+f-262<=_){for(g.set(g.subarray(f,f+f),0),F-=f,_-=f,N-=f,n=t=w;e=65535&y[--n],y[n]=f<=e?e-f:0,0!=--t;);for(n=t=f;e=65535&m[--n],m[n]=f<=e?e-f:0,0!=--t;);r+=f}if(0===l.avail_in)return;t=l.read_buf(g,_+P,r),3<=(P+=t)&&(v=((v=255&g[_])<<x^255&g[_+1])&b)}while(P<262&&0!==l.avail_in)}function ht(t){var e,n,r=I,i=_,o=k,a=f-262<_?_-(f-262):0,s=M,l=d,h=_+258,u=g[i+o-1],c=g[i+o];E<=k&&(r>>=2),P<s&&(s=P);do{if(g[(e=t)+o]==c&&g[e+o-1]==u&&g[e]==g[i]&&g[++e]==g[i+1]){i+=2,e++;do{}while(g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&i<h);if(n=258-(h-i),i=h-258,o<n){if(F=t,s<=(o=n))break;u=g[i+o-1],c=g[i+o]}}}while((t=65535&m[t&l])>a&&0!=--r);return o<=P?o:P}function ut(t){return t.total_in=t.total_out=0,t.msg=null,V.pending=0,V.pending_out=0,h=113,c=0,G.dyn_tree=s,G.stat_desc=ft.static_l_desc,Y.dyn_tree=O,Y.stat_desc=ft.static_d_desc,J.dyn_tree=q,J.stat_desc=ft.static_bl_desc,W=H=0,z=8,X(),function(){var t;for(i=2*f,t=y[w-1]=0;t<w-1;t++)y[t]=0;C=pt[B].max_lazy,E=pt[B].good_length,M=pt[B].nice_length,I=pt[B].max_chain,L=k=2,v=S=P=N=_=0}(),0}V.depth=[],V.bl_count=[],V.heap=[],s=[],O=[],q=[],V.pqdownheap=function(t,e){for(var n=V.heap,r=n[e],i=e<<1;i<=V.heap_len&&(i<V.heap_len&&gt(t,n[i+1],n[i],V.depth)&&i++,!gt(t,r,n[i],V.depth));)n[e]=n[i],e=i,i<<=1;n[e]=r},V.deflateInit=function(t,e,n,r,i,o){return r||(r=8),i||(i=8),o||(o=0),t.msg=null,-1==e&&(e=6),i<1||9<i||8!=r||n<9||15<n||e<0||9<e||o<0||2<o?-2:(t.dstate=V,d=(f=1<<(p=n))-1,b=(w=1<<(a=i+7))-1,x=Math.floor((a+3-1)/3),g=new Uint8Array(2*f),m=[],y=[],R=1<<i+6,V.pending_buf=new Uint8Array(4*R),u=4*R,U=Math.floor(R/2),T=3*R,B=e,j=o,ut(t))},V.deflateEnd=function(){return 42!=h&&113!=h&&666!=h?-2:(V.pending_buf=null,g=m=y=null,V.dstate=null,113==h?-3:0)},V.deflateParams=function(t,e,n){var r=0;return-1==e&&(e=6),e<0||9<e||n<0||2<n?-2:(pt[B].func!=pt[e].func&&0!==t.total_in&&(r=t.deflate(1)),B!=e&&(C=pt[B=e].max_lazy,E=pt[B].good_length,M=pt[B].nice_length,I=pt[B].max_chain),j=n,r)},V.deflateSetDictionary=function(t,e,n){var r,i=n,o=0;if(!e||42!=h)return-2;if(i<3)return 0;for(f-262<i&&(o=n-(i=f-262)),g.set(e.subarray(o,o+i),0),N=_=i,v=((v=255&g[0])<<x^255&g[1])&b,r=0;r<=i-3;r++)v=(v<<x^255&g[r+2])&b,m[r&d]=y[v],y[v]=r;return 0},V.deflate=function(t,e){var n,r,i,o,a,s;if(4<e||e<0)return-2;if(!t.next_out||!t.next_in&&0!==t.avail_in||666==h&&4!=e)return t.msg=dt[4],-2;if(0===t.avail_out)return t.msg=dt[7],-5;if(l=t,o=c,c=e,42==h&&(r=8+(p-8<<4)<<8,3<(i=(B-1&255)>>1)&&(i=3),r|=i<<6,0!==_&&(r|=32),h=113,Z((s=r+=31-r%31)>>8&255),Z(255&s)),0!==V.pending){if(l.flush_pending(),0===l.avail_out)return c=-1,0}else if(0===l.avail_in&&e<=o&&4!=e)return l.msg=dt[7],-5;if(666==h&&0!==l.avail_in)return t.msg=dt[7],-5;if(0!==l.avail_in||0!==P||0!=e&&666!=h){switch(a=-1,pt[B].func){case 0:a=function(t){var e,n=65535;for(u-5<n&&(n=u-5);;){if(P<=1){if(lt(),0===P&&0==t)return 0;if(0===P)break}if(_+=P,e=N+n,((P=0)===_||e<=_)&&(P=_-e,_=e,st(!1),0===l.avail_out))return 0;if(f-262<=_-N&&(st(!1),0===l.avail_out))return 0}return st(4==t),0===l.avail_out?4==t?2:0:4==t?3:1}(e);break;case 1:a=function(t){for(var e,n=0;;){if(P<262){if(lt(),P<262&&0==t)return 0;if(0===P)break}if(3<=P&&(v=(v<<x^255&g[_+2])&b,n=65535&y[v],m[_&d]=y[v],y[v]=_),0!==n&&(_-n&65535)<=f-262&&2!=j&&(L=ht(n)),3<=L)if(e=rt(_-F,L-3),P-=L,L<=C&&3<=P){for(L--;v=(v<<x^255&g[++_+2])&b,n=65535&y[v],m[_&d]=y[v],y[v]=_,0!=--L;);_++}else _+=L,L=0,v=((v=255&g[_])<<x^255&g[_+1])&b;else e=rt(0,255&g[_]),P--,_++;if(e&&(st(!1),0===l.avail_out))return 0}return st(4==t),0===l.avail_out?4==t?2:0:4==t?3:1}(e);break;case 2:a=function(t){for(var e,n,r=0;;){if(P<262){if(lt(),P<262&&0==t)return 0;if(0===P)break}if(3<=P&&(v=(v<<x^255&g[_+2])&b,r=65535&y[v],m[_&d]=y[v],y[v]=_),k=L,A=F,L=2,0!==r&&k<C&&(_-r&65535)<=f-262&&(2!=j&&(L=ht(r)),L<=5&&(1==j||3==L&&4096<_-F)&&(L=2)),3<=k&&L<=k){for(n=_+P-3,e=rt(_-1-A,k-3),P-=k-1,k-=2;++_<=n&&(v=(v<<x^255&g[_+2])&b,r=65535&y[v],m[_&d]=y[v],y[v]=_),0!=--k;);if(S=0,L=2,_++,e&&(st(!1),0===l.avail_out))return 0}else if(0!==S){if((e=rt(0,255&g[_-1]))&&st(!1),_++,P--,0===l.avail_out)return 0}else S=1,_++,P--}return 0!==S&&(e=rt(0,255&g[_-1]),S=0),st(4==t),0===l.avail_out?4==t?2:0:4==t?3:1}(e)}if(2!=a&&3!=a||(h=666),0==a||2==a)return 0===l.avail_out&&(c=-1),0;if(1==a){if(1==e)$(2,3),tt(256,ft.static_ltree),nt(),1+z+10-W<9&&($(2,3),tt(256,ft.static_ltree),nt()),z=7;else if(at(0,0,!1),3==e)for(n=0;n<w;n++)y[n]=0;if(l.flush_pending(),0===l.avail_out)return c=-1,0}}return 4!=e?0:1}}function i(){this.next_in_index=0,this.next_out_index=0,this.avail_in=0,this.total_in=0,this.avail_out=0,this.total_out=0}i.prototype={deflateInit:function(t,e){return this.dstate=new r,e||(e=d),this.dstate.deflateInit(this,t,e)},deflate:function(t){return this.dstate?this.dstate.deflate(this,t):-2},deflateEnd:function(){if(!this.dstate)return-2;var t=this.dstate.deflateEnd();return this.dstate=null,t},deflateParams:function(t,e){return this.dstate?this.dstate.deflateParams(this,t,e):-2},deflateSetDictionary:function(t,e){return this.dstate?this.dstate.deflateSetDictionary(this,t,e):-2},read_buf:function(t,e,n){var r=this.avail_in;return n<r&&(r=n),0===r?0:(this.avail_in-=r,t.set(this.next_in.subarray(this.next_in_index,this.next_in_index+r),e),this.next_in_index+=r,this.total_in+=r,r)},flush_pending:function(){var t=this,e=t.dstate.pending;e>t.avail_out&&(e=t.avail_out),0!==e&&(t.next_out.set(t.dstate.pending_buf.subarray(t.dstate.pending_out,t.dstate.pending_out+e),t.next_out_index),t.next_out_index+=e,t.dstate.pending_out+=e,t.total_out+=e,t.avail_out-=e,t.dstate.pending-=e,0===t.dstate.pending&&(t.dstate.pending_out=0))}};var o=t.zip||t;o.Deflater=o._jzlib_Deflater=function(t){var s=new i,l=new Uint8Array(512),e=t?t.level:-1;void 0===e&&(e=-1),s.deflateInit(e),s.next_out=l,this.append=function(t,e){var n,r=[],i=0,o=0,a=0;if(t.length){s.next_in_index=0,s.next_in=t,s.avail_in=t.length;do{if(s.next_out_index=0,s.avail_out=512,0!=s.deflate(0))throw new Error("deflating: "+s.msg);s.next_out_index&&(512==s.next_out_index?r.push(new Uint8Array(l)):r.push(new Uint8Array(l.subarray(0,s.next_out_index)))),a+=s.next_out_index,e&&0<s.next_in_index&&s.next_in_index!=i&&(e(s.next_in_index),i=s.next_in_index)}while(0<s.avail_in||0===s.avail_out);return n=new Uint8Array(a),r.forEach(function(t){n.set(t,o),o+=t.length}),n}},this.flush=function(){var t,e,n=[],r=0,i=0;do{if(s.next_out_index=0,s.avail_out=512,1!=(t=s.deflate(4))&&0!=t)throw new Error("deflating: "+s.msg);0<512-s.avail_out&&n.push(new Uint8Array(l.subarray(0,s.next_out_index))),i+=s.next_out_index}while(0<s.avail_in||0===s.avail_out);return s.deflateEnd(),e=new Uint8Array(i),n.forEach(function(t){e.set(t,r),r+=t.length}),e}}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()).RGBColor=function(t){var e;t=t||"",this.ok=!1,"#"==t.charAt(0)&&(t=t.substr(1,6)),t=(t=t.replace(/ /g,"")).toLowerCase();var n={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"00ffff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000000",blanchedalmond:"ffebcd",blue:"0000ff",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"00ffff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dodgerblue:"1e90ff",feldspar:"d19275",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"ff00ff",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgrey:"d3d3d3",lightgreen:"90ee90",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslateblue:"8470ff",lightslategray:"778899",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"00ff00",limegreen:"32cd32",linen:"faf0e6",magenta:"ff00ff",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370d8",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"d87093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",red:"ff0000",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",violetred:"d02090",wheat:"f5deb3",white:"ffffff",whitesmoke:"f5f5f5",yellow:"ffff00",yellowgreen:"9acd32"};for(var r in n)t==r&&(t=n[r]);for(var i=[{re:/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,example:["rgb(123, 234, 45)","rgb(255,234,245)"],process:function(t){return[parseInt(t[1]),parseInt(t[2]),parseInt(t[3])]}},{re:/^(\w{2})(\w{2})(\w{2})$/,example:["#00ff00","336699"],process:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/^(\w{1})(\w{1})(\w{1})$/,example:["#fb0","f0f"],process:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}}],o=0;o<i.length;o++){var a=i[o].re,s=i[o].process,l=a.exec(t);l&&(e=s(l),this.r=e[0],this.g=e[1],this.b=e[2],this.ok=!0)}this.r=this.r<0||isNaN(this.r)?0:255<this.r?255:this.r,this.g=this.g<0||isNaN(this.g)?0:255<this.g?255:this.g,this.b=this.b<0||isNaN(this.b)?0:255<this.b?255:this.b,this.toRGB=function(){return"rgb("+this.r+", "+this.g+", "+this.b+")"},this.toHex=function(){var t=this.r.toString(16),e=this.g.toString(16),n=this.b.toString(16);return 1==t.length&&(t="0"+t),1==e.length&&(e="0"+e),1==n.length&&(n="0"+n),"#"+t+e+n}},function(t){var n="+".charCodeAt(0),r="/".charCodeAt(0),i="0".charCodeAt(0),o="a".charCodeAt(0),a="A".charCodeAt(0),s="-".charCodeAt(0),l="_".charCodeAt(0),u=function(t){var e=t.charCodeAt(0);return e===n||e===s?62:e===r||e===l?63:e<i?-1:e<i+10?e-i+26+26:e<a+26?e-a:e<o+26?e-o+26:void 0};t.API.TTFFont=function(){function i(t,e,n){var r;if(this.rawData=t,r=this.contents=new J(t),this.contents.pos=4,"ttcf"===r.readString(4)){if(!e)throw new Error("Must specify a font name for TTC files.");throw new Error("Font "+e+" not found in TTC file.")}r.pos=0,this.parse(),this.subset=new P(this),this.registerTTF()}return i.open=function(t,e,n,r){if("string"!=typeof n)throw new Error("Invalid argument supplied in TTFFont.open");return new i(function(t){var e,n,r,i,o,a;if(0<t.length%4)throw new Error("Invalid string. Length must be a multiple of 4");var s=t.length;o="="===t.charAt(s-2)?2:"="===t.charAt(s-1)?1:0,a=new Uint8Array(3*t.length/4-o),r=0<o?t.length-4:t.length;var l=0;function h(t){a[l++]=t}for(n=e=0;e<r;e+=4,n+=3)h((16711680&(i=u(t.charAt(e))<<18|u(t.charAt(e+1))<<12|u(t.charAt(e+2))<<6|u(t.charAt(e+3))))>>16),h((65280&i)>>8),h(255&i);return 2===o?h(255&(i=u(t.charAt(e))<<2|u(t.charAt(e+1))>>4)):1===o&&(h((i=u(t.charAt(e))<<10|u(t.charAt(e+1))<<4|u(t.charAt(e+2))>>2)>>8&255),h(255&i)),a}(n),e,r)},i.prototype.parse=function(){return this.directory=new e(this.contents),this.head=new p(this),this.name=new b(this),this.cmap=new y(this),this.toUnicode=new Map,this.hhea=new g(this),this.maxp=new x(this),this.hmtx=new N(this),this.post=new v(this),this.os2=new m(this),this.loca=new F(this),this.glyf=new A(this),this.ascender=this.os2.exists&&this.os2.ascender||this.hhea.ascender,this.decender=this.os2.exists&&this.os2.decender||this.hhea.decender,this.lineGap=this.os2.exists&&this.os2.lineGap||this.hhea.lineGap,this.bbox=[this.head.xMin,this.head.yMin,this.head.xMax,this.head.yMax]},i.prototype.registerTTF=function(){var i,t,e,n,r;if(this.scaleFactor=1e3/this.head.unitsPerEm,this.bbox=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.bbox).length;t<e;t++)i=n[t],r.push(Math.round(i*this.scaleFactor));return r}.call(this),this.stemV=0,this.post.exists?(e=255&(n=this.post.italic_angle),!0&(t=n>>16)&&(t=-(1+(65535^t))),this.italicAngle=+(t+"."+e)):this.italicAngle=0,this.ascender=Math.round(this.ascender*this.scaleFactor),this.decender=Math.round(this.decender*this.scaleFactor),this.lineGap=Math.round(this.lineGap*this.scaleFactor),this.capHeight=this.os2.exists&&this.os2.capHeight||this.ascender,this.xHeight=this.os2.exists&&this.os2.xHeight||0,this.familyClass=(this.os2.exists&&this.os2.familyClass||0)>>8,this.isSerif=1===(r=this.familyClass)||2===r||3===r||4===r||5===r||7===r,this.isScript=10===this.familyClass,this.flags=0,this.post.isFixedPitch&&(this.flags|=1),this.isSerif&&(this.flags|=2),this.isScript&&(this.flags|=8),0!==this.italicAngle&&(this.flags|=64),this.flags|=32,!this.cmap.unicode)throw new Error("No unicode cmap for font")},i.prototype.characterToGlyph=function(t){var e;return(null!=(e=this.cmap.unicode)?e.codeMap[t]:void 0)||0},i.prototype.widthOfGlyph=function(t){var e;return e=1e3/this.head.unitsPerEm,this.hmtx.forGlyph(t).advance*e},i.prototype.widthOfString=function(t,e,n){var r,i,o,a,s;for(i=a=o=0,s=(t=""+t).length;0<=s?a<s:s<a;i=0<=s?++a:--a)r=t.charCodeAt(i),o+=this.widthOfGlyph(this.characterToGlyph(r))+n*(1e3/e)||0;return o*(e/1e3)},i.prototype.lineHeight=function(t,e){var n;return null==e&&(e=!1),n=e?this.lineGap:0,(this.ascender+n-this.decender)/1e3*t},i}();var h,J=function(){function t(t){this.data=null!=t?t:[],this.pos=0,this.length=this.data.length}return t.prototype.readByte=function(){return this.data[this.pos++]},t.prototype.writeByte=function(t){return this.data[this.pos++]=t},t.prototype.readUInt32=function(){return 16777216*this.readByte()+(this.readByte()<<16)+(this.readByte()<<8)+this.readByte()},t.prototype.writeUInt32=function(t){return this.writeByte(t>>>24&255),this.writeByte(t>>16&255),this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt32=function(){var t;return 2147483648<=(t=this.readUInt32())?t-4294967296:t},t.prototype.writeInt32=function(t){return t<0&&(t+=4294967296),this.writeUInt32(t)},t.prototype.readUInt16=function(){return this.readByte()<<8|this.readByte()},t.prototype.writeUInt16=function(t){return this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt16=function(){var t;return 32768<=(t=this.readUInt16())?t-65536:t},t.prototype.writeInt16=function(t){return t<0&&(t+=65536),this.writeUInt16(t)},t.prototype.readString=function(t){var e,n,r;for(n=[],e=r=0;0<=t?r<t:t<r;e=0<=t?++r:--r)n[e]=String.fromCharCode(this.readByte());return n.join("")},t.prototype.writeString=function(t){var e,n,r,i;for(i=[],e=n=0,r=t.length;0<=r?n<r:r<n;e=0<=r?++n:--n)i.push(this.writeByte(t.charCodeAt(e)));return i},t.prototype.readShort=function(){return this.readInt16()},t.prototype.writeShort=function(t){return this.writeInt16(t)},t.prototype.readLongLong=function(){var t,e,n,r,i,o,a,s;return t=this.readByte(),e=this.readByte(),n=this.readByte(),r=this.readByte(),i=this.readByte(),o=this.readByte(),a=this.readByte(),s=this.readByte(),128&t?-1*(72057594037927940*(255^t)+281474976710656*(255^e)+1099511627776*(255^n)+4294967296*(255^r)+16777216*(255^i)+65536*(255^o)+256*(255^a)+(255^s)+1):72057594037927940*t+281474976710656*e+1099511627776*n+4294967296*r+16777216*i+65536*o+256*a+s},t.prototype.writeLongLong=function(t){var e,n;return e=Math.floor(t/4294967296),n=4294967295&t,this.writeByte(e>>24&255),this.writeByte(e>>16&255),this.writeByte(e>>8&255),this.writeByte(255&e),this.writeByte(n>>24&255),this.writeByte(n>>16&255),this.writeByte(n>>8&255),this.writeByte(255&n)},t.prototype.readInt=function(){return this.readInt32()},t.prototype.writeInt=function(t){return this.writeInt32(t)},t.prototype.read=function(t){var e,n;for(e=[],n=0;0<=t?n<t:t<n;0<=t?++n:--n)e.push(this.readByte());return e},t.prototype.write=function(t){var e,n,r,i;for(i=[],n=0,r=t.length;n<r;n++)e=t[n],i.push(this.writeByte(e));return i},t}(),e=function(){var d;function t(t){var e,n,r;for(this.scalarType=t.readInt(),this.tableCount=t.readShort(),this.searchRange=t.readShort(),this.entrySelector=t.readShort(),this.rangeShift=t.readShort(),this.tables={},n=0,r=this.tableCount;0<=r?n<r:r<n;0<=r?++n:--n)e={tag:t.readString(4),checksum:t.readInt(),offset:t.readInt(),length:t.readInt()},this.tables[e.tag]=e}return t.prototype.encode=function(t){var e,n,r,i,o,a,s,l,h,u,c,f,p;for(p in c=Object.keys(t).length,a=Math.log(2),h=16*Math.floor(Math.log(c)/a),i=Math.floor(h/a),l=16*c-h,(n=new J).writeInt(this.scalarType),n.writeShort(c),n.writeShort(h),n.writeShort(i),n.writeShort(l),r=16*c,s=n.pos+r,o=null,f=[],t)for(u=t[p],n.writeString(p),n.writeInt(d(u)),n.writeInt(s),n.writeInt(u.length),f=f.concat(u),"head"===p&&(o=s),s+=u.length;s%4;)f.push(0),s++;return n.write(f),e=2981146554-d(n.data),n.pos=o+8,n.writeUInt32(e),n.data},d=function(t){var e,n,r,i;for(t=L.call(t);t.length%4;)t.push(0);for(n=new J(t),r=e=0,i=t.length;r<i;r+=4)e+=n.readUInt32();return 4294967295&e},t}(),c={}.hasOwnProperty,f=function(t,e){for(var n in e)c.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}return r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype,t};h=function(){function t(t){var e;this.file=t,e=this.file.directory.tables[this.tag],this.exists=!!e,e&&(this.offset=e.offset,this.length=e.length,this.parse(this.file.contents))}return t.prototype.parse=function(){},t.prototype.encode=function(){},t.prototype.raw=function(){return this.exists?(this.file.contents.pos=this.offset,this.file.contents.read(this.length)):null},t}();var p=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="head",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.revision=t.readInt(),this.checkSumAdjustment=t.readInt(),this.magicNumber=t.readInt(),this.flags=t.readShort(),this.unitsPerEm=t.readShort(),this.created=t.readLongLong(),this.modified=t.readLongLong(),this.xMin=t.readShort(),this.yMin=t.readShort(),this.xMax=t.readShort(),this.yMax=t.readShort(),this.macStyle=t.readShort(),this.lowestRecPPEM=t.readShort(),this.fontDirectionHint=t.readShort(),this.indexToLocFormat=t.readShort(),this.glyphDataFormat=t.readShort()},e.prototype.encode=function(t){var e;return(e=new J).writeInt(this.version),e.writeInt(this.revision),e.writeInt(this.checkSumAdjustment),e.writeInt(this.magicNumber),e.writeShort(this.flags),e.writeShort(this.unitsPerEm),e.writeLongLong(this.created),e.writeLongLong(this.modified),e.writeShort(this.xMin),e.writeShort(this.yMin),e.writeShort(this.xMax),e.writeShort(this.yMax),e.writeShort(this.macStyle),e.writeShort(this.lowestRecPPEM),e.writeShort(this.fontDirectionHint),e.writeShort(t),e.writeShort(this.glyphDataFormat),e.data},e}(),d=function(){function t(n,t){var e,r,i,o,a,s,l,h,u,c,f,p,d,g,m,y,v,w;switch(this.platformID=n.readUInt16(),this.encodingID=n.readShort(),this.offset=t+n.readInt(),u=n.pos,n.pos=this.offset,this.format=n.readUInt16(),this.length=n.readUInt16(),this.language=n.readUInt16(),this.isUnicode=3===this.platformID&&1===this.encodingID&&4===this.format||0===this.platformID&&4===this.format,this.codeMap={},this.format){case 0:for(s=m=0;m<256;s=++m)this.codeMap[s]=n.readByte();break;case 4:for(f=n.readUInt16(),c=f/2,n.pos+=6,i=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),n.pos+=2,d=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),l=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),h=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),r=(this.length-n.pos+this.offset)/2,a=function(){var t,e;for(e=[],s=t=0;0<=r?t<r:r<t;s=0<=r?++t:--t)e.push(n.readUInt16());return e}(),s=y=0,w=i.length;y<w;s=++y)for(g=i[s],e=v=p=d[s];p<=g?v<=g:g<=v;e=p<=g?++v:--v)0===h[s]?o=e+l[s]:0!==(o=a[h[s]/2+(e-p)-(c-s)]||0)&&(o+=l[s]),this.codeMap[e]=65535&o}n.pos=u}return t.encode=function(t,e){var n,r,i,o,a,s,l,h,u,c,f,p,d,g,m,y,v,w,b,x,N,L,A,S,_,F,P,k,I,C,B,j,E,M,O,q,T,R,D,U,z,H,W,V,G,Y;switch(k=new J,o=Object.keys(t).sort(function(t,e){return t-e}),e){case"macroman":for(d=0,g=function(){var t,e;for(e=[],p=t=0;t<256;p=++t)e.push(0);return e}(),y={0:0},i={},I=0,E=o.length;I<E;I++)null==y[W=t[r=o[I]]]&&(y[W]=++d),i[r]={old:t[r],new:y[t[r]]},g[r]=y[t[r]];return k.writeUInt16(1),k.writeUInt16(0),k.writeUInt32(12),k.writeUInt16(0),k.writeUInt16(262),k.writeUInt16(0),k.write(g),{charMap:i,subtable:k.data,maxGlyphID:d+1};case"unicode":for(F=[],u=[],y={},n={},m=l=null,C=v=0,M=o.length;C<M;C++)null==y[b=t[r=o[C]]]&&(y[b]=++v),n[r]={old:b,new:y[b]},a=y[b]-r,null!=m&&a===l||(m&&u.push(m),F.push(r),l=a),m=r;for(m&&u.push(m),u.push(65535),F.push(65535),S=2*(A=F.length),L=2*Math.pow(Math.log(A)/Math.LN2,2),c=Math.log(L/2)/Math.LN2,N=2*A-L,s=[],x=[],f=[],p=B=0,O=F.length;B<O;p=++B){if(_=F[p],h=u[p],65535===_){s.push(0),x.push(0);break}if(32768<=_-(P=n[_].new))for(s.push(0),x.push(2*(f.length+A-p)),r=j=_;_<=h?j<=h:h<=j;r=_<=h?++j:--j)f.push(n[r].new);else s.push(P-_),x.push(0)}for(k.writeUInt16(3),k.writeUInt16(1),k.writeUInt32(12),k.writeUInt16(4),k.writeUInt16(16+8*A+2*f.length),k.writeUInt16(0),k.writeUInt16(S),k.writeUInt16(L),k.writeUInt16(c),k.writeUInt16(N),z=0,q=u.length;z<q;z++)r=u[z],k.writeUInt16(r);for(k.writeUInt16(0),H=0,T=F.length;H<T;H++)r=F[H],k.writeUInt16(r);for(V=0,R=s.length;V<R;V++)a=s[V],k.writeUInt16(a);for(G=0,D=x.length;G<D;G++)w=x[G],k.writeUInt16(w);for(Y=0,U=f.length;Y<U;Y++)d=f[Y],k.writeUInt16(d);return{charMap:n,subtable:k.data,maxGlyphID:v+1}}},t}(),y=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="cmap",e.prototype.parse=function(t){var e,n,r;for(t.pos=this.offset,this.version=t.readUInt16(),n=t.readUInt16(),this.tables=[],this.unicode=null,r=0;0<=n?r<n:n<r;0<=n?++r:--r)e=new d(t,this.offset),this.tables.push(e),e.isUnicode&&null==this.unicode&&(this.unicode=e);return!0},e.encode=function(t,e){var n,r;return null==e&&(e="macroman"),n=d.encode(t,e),(r=new J).writeUInt16(0),r.writeUInt16(1),n.table=r.data.concat(n.subtable),n},e}(),g=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="hhea",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.ascender=t.readShort(),this.decender=t.readShort(),this.lineGap=t.readShort(),this.advanceWidthMax=t.readShort(),this.minLeftSideBearing=t.readShort(),this.minRightSideBearing=t.readShort(),this.xMaxExtent=t.readShort(),this.caretSlopeRise=t.readShort(),this.caretSlopeRun=t.readShort(),this.caretOffset=t.readShort(),t.pos+=8,this.metricDataFormat=t.readShort(),this.numberOfMetrics=t.readUInt16()},e}(),m=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="OS/2",e.prototype.parse=function(n){if(n.pos=this.offset,this.version=n.readUInt16(),this.averageCharWidth=n.readShort(),this.weightClass=n.readUInt16(),this.widthClass=n.readUInt16(),this.type=n.readShort(),this.ySubscriptXSize=n.readShort(),this.ySubscriptYSize=n.readShort(),this.ySubscriptXOffset=n.readShort(),this.ySubscriptYOffset=n.readShort(),this.ySuperscriptXSize=n.readShort(),this.ySuperscriptYSize=n.readShort(),this.ySuperscriptXOffset=n.readShort(),this.ySuperscriptYOffset=n.readShort(),this.yStrikeoutSize=n.readShort(),this.yStrikeoutPosition=n.readShort(),this.familyClass=n.readShort(),this.panose=function(){var t,e;for(e=[],t=0;t<10;++t)e.push(n.readByte());return e}(),this.charRange=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(n.readInt());return e}(),this.vendorID=n.readString(4),this.selection=n.readShort(),this.firstCharIndex=n.readShort(),this.lastCharIndex=n.readShort(),0<this.version&&(this.ascent=n.readShort(),this.descent=n.readShort(),this.lineGap=n.readShort(),this.winAscent=n.readShort(),this.winDescent=n.readShort(),this.codePageRange=function(){var t,e;for(e=[],t=0;t<2;++t)e.push(n.readInt());return e}(),1<this.version))return this.xHeight=n.readShort(),this.capHeight=n.readShort(),this.defaultChar=n.readShort(),this.breakChar=n.readShort(),this.maxContext=n.readShort()},e}(),v=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="post",e.prototype.parse=function(r){var t,e,n,i;switch(r.pos=this.offset,this.format=r.readInt(),this.italicAngle=r.readInt(),this.underlinePosition=r.readShort(),this.underlineThickness=r.readShort(),this.isFixedPitch=r.readInt(),this.minMemType42=r.readInt(),this.maxMemType42=r.readInt(),this.minMemType1=r.readInt(),this.maxMemType1=r.readInt(),this.format){case 65536:break;case 131072:for(e=r.readUInt16(),this.glyphNameIndex=[],n=0;0<=e?n<e:e<n;0<=e?++n:--n)this.glyphNameIndex.push(r.readUInt16());for(this.names=[],i=[];r.pos<this.offset+this.length;)t=r.readByte(),i.push(this.names.push(r.readString(t)));return i;case 151552:return e=r.readUInt16(),this.offsets=r.read(e);case 196608:break;case 262144:return this.map=function(){var t,e,n;for(n=[],t=0,e=this.file.maxp.numGlyphs;0<=e?t<e:e<t;0<=e?++t:--t)n.push(r.readUInt32());return n}.call(this)}},e}(),w=function(t,e){this.raw=t,this.length=t.length,this.platformID=e.platformID,this.encodingID=e.encodingID,this.languageID=e.languageID},b=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="name",e.prototype.parse=function(t){var e,n,r,i,o,a,s,l,h,u,c,f;for(t.pos=this.offset,t.readShort(),e=t.readShort(),a=t.readShort(),n=[],i=h=0;0<=e?h<e:e<h;i=0<=e?++h:--h)n.push({platformID:t.readShort(),encodingID:t.readShort(),languageID:t.readShort(),nameID:t.readShort(),length:t.readShort(),offset:this.offset+a+t.readShort()});for(s={},i=u=0,c=n.length;u<c;i=++u)r=n[i],t.pos=r.offset,l=t.readString(r.length),o=new w(l,r),null==s[f=r.nameID]&&(s[f]=[]),s[r.nameID].push(o);this.strings=s,this.copyright=s[0],this.fontFamily=s[1],this.fontSubfamily=s[2],this.uniqueSubfamily=s[3],this.fontName=s[4],this.version=s[5];try{this.postscriptName=s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}catch(t){this.postscriptName=s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}return this.trademark=s[7],this.manufacturer=s[8],this.designer=s[9],this.description=s[10],this.vendorUrl=s[11],this.designerUrl=s[12],this.license=s[13],this.licenseUrl=s[14],this.preferredFamily=s[15],this.preferredSubfamily=s[17],this.compatibleFull=s[18],this.sampleText=s[19]},e}(),x=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="maxp",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.numGlyphs=t.readUInt16(),this.maxPoints=t.readUInt16(),this.maxContours=t.readUInt16(),this.maxCompositePoints=t.readUInt16(),this.maxComponentContours=t.readUInt16(),this.maxZones=t.readUInt16(),this.maxTwilightPoints=t.readUInt16(),this.maxStorage=t.readUInt16(),this.maxFunctionDefs=t.readUInt16(),this.maxInstructionDefs=t.readUInt16(),this.maxStackElements=t.readUInt16(),this.maxSizeOfInstructions=t.readUInt16(),this.maxComponentElements=t.readUInt16(),this.maxComponentDepth=t.readUInt16()},e}(),N=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="hmtx",e.prototype.parse=function(n){var t,r,i,e,o,a,s;for(n.pos=this.offset,this.metrics=[],e=0,a=this.file.hhea.numberOfMetrics;0<=a?e<a:a<e;0<=a?++e:--e)this.metrics.push({advance:n.readUInt16(),lsb:n.readInt16()});for(r=this.file.maxp.numGlyphs-this.file.hhea.numberOfMetrics,this.leftSideBearings=function(){var t,e;for(e=[],t=0;0<=r?t<r:r<t;0<=r?++t:--t)e.push(n.readInt16());return e}(),this.widths=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.metrics).length;t<e;t++)i=n[t],r.push(i.advance);return r}.call(this),t=this.widths[this.widths.length-1],s=[],o=0;0<=r?o<r:r<o;0<=r?++o:--o)s.push(this.widths.push(t));return s},e.prototype.forGlyph=function(t){return t in this.metrics?this.metrics[t]:{advance:this.metrics[this.metrics.length-1].advance,lsb:this.leftSideBearings[t-this.metrics.length]}},e}(),L=[].slice,A=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="glyf",e.prototype.parse=function(t){return this.cache={}},e.prototype.glyphFor=function(t){var e,n,r,i,o,a,s,l,h,u;return(t=t)in this.cache?this.cache[t]:(i=this.file.loca,e=this.file.contents,n=i.indexOf(t),0===(r=i.lengthOf(t))?this.cache[t]=null:(e.pos=this.offset+n,o=(a=new J(e.read(r))).readShort(),l=a.readShort(),u=a.readShort(),s=a.readShort(),h=a.readShort(),this.cache[t]=-1===o?new _(a,l,u,s,h):new S(a,o,l,u,s,h),this.cache[t]))},e.prototype.encode=function(t,e,n){var r,i,o,a,s;for(o=[],i=[],a=0,s=e.length;a<s;a++)r=t[e[a]],i.push(o.length),r&&(o=o.concat(r.encode(n)));return i.push(o.length),{table:o,offsets:i}},e}(),S=function(){function t(t,e,n,r,i,o){this.raw=t,this.numberOfContours=e,this.xMin=n,this.yMin=r,this.xMax=i,this.yMax=o,this.compound=!1}return t.prototype.encode=function(){return this.raw.data},t}(),_=function(){function t(t,e,n,r,i){var o,a;for(this.raw=t,this.xMin=e,this.yMin=n,this.xMax=r,this.yMax=i,this.compound=!0,this.glyphIDs=[],this.glyphOffsets=[],o=this.raw;a=o.readShort(),this.glyphOffsets.push(o.pos),this.glyphIDs.push(o.readShort()),32&a;)o.pos+=1&a?4:2,128&a?o.pos+=8:64&a?o.pos+=4:8&a&&(o.pos+=2)}return 1,8,32,64,128,t.prototype.encode=function(t){var e,n,r,i,o;for(n=new J(L.call(this.raw.data)),e=r=0,i=(o=this.glyphIDs).length;r<i;e=++r)o[e],n.pos=this.glyphOffsets[e];return n.data},t}(),F=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="loca",e.prototype.parse=function(r){var t;return r.pos=this.offset,t=this.file.head.indexToLocFormat,this.offsets=0===t?function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=2)n.push(2*r.readUInt16());return n}.call(this):function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=4)n.push(r.readUInt32());return n}.call(this)},e.prototype.indexOf=function(t){return this.offsets[t]},e.prototype.lengthOf=function(t){return this.offsets[t+1]-this.offsets[t]},e.prototype.encode=function(t,e){for(var n=new Uint32Array(this.offsets.length),r=0,i=0,o=0;o<n.length;++o)if(n[o]=r,i<e.length&&e[i]==o){++i,n[o]=r;var a=this.offsets[o],s=this.offsets[o+1]-a;0<s&&(r+=s)}for(var l=new Array(4*n.length),h=0;h<n.length;++h)l[4*h+3]=255&n[h],l[4*h+2]=(65280&n[h])>>8,l[4*h+1]=(16711680&n[h])>>16,l[4*h]=(4278190080&n[h])>>24;return l},e}(),P=function(){function t(t){this.font=t,this.subset={},this.unicodes={},this.next=33}return t.prototype.generateCmap=function(){var t,e,n,r,i;for(e in r=this.font.cmap.tables[0].codeMap,t={},i=this.subset)n=i[e],t[e]=r[n];return t},t.prototype.glyphsFor=function(t){var e,n,r,i,o,a,s;for(r={},o=0,a=t.length;o<a;o++)r[i=t[o]]=this.font.glyf.glyphFor(i);for(i in e=[],r)(null!=(n=r[i])?n.compound:void 0)&&e.push.apply(e,n.glyphIDs);if(0<e.length)for(i in s=this.glyphsFor(e))n=s[i],r[i]=n;return r},t.prototype.encode=function(t,e){var n,r,i,o,a,s,l,h,u,c,f,p,d,g,m;for(r in n=y.encode(this.generateCmap(),"unicode"),o=this.glyphsFor(t),f={0:0},m=n.charMap)f[(s=m[r]).old]=s.new;for(p in c=n.maxGlyphID,o)p in f||(f[p]=c++);return h=function(t){var e,n;for(e in n={},t)n[t[e]]=e;return n}(f),u=Object.keys(h).sort(function(t,e){return t-e}),d=function(){var t,e,n;for(n=[],t=0,e=u.length;t<e;t++)a=u[t],n.push(h[a]);return n}(),i=this.font.glyf.encode(o,d,f),l=this.font.loca.encode(i.offsets,d),g={cmap:this.font.cmap.raw(),glyf:i.table,loca:l,hmtx:this.font.hmtx.raw(),hhea:this.font.hhea.raw(),maxp:this.font.maxp.raw(),post:this.font.post.raw(),name:this.font.name.raw(),head:this.font.head.encode(e)},this.font.os2.exists&&(g["OS/2"]=this.font.os2.raw()),this.font.directory.encode(g)},t}();t.API.PDFObject=function(){var o;function a(){}return o=function(t,e){return(Array(e+1).join("0")+t).slice(-e)},a.convert=function(r){var i,t,e,n;if(Array.isArray(r))return"["+function(){var t,e,n;for(n=[],t=0,e=r.length;t<e;t++)i=r[t],n.push(a.convert(i));return n}().join(" ")+"]";if("string"==typeof r)return"/"+r;if(null!=r?r.isString:void 0)return"("+r+")";if(r instanceof Date)return"(D:"+o(r.getUTCFullYear(),4)+o(r.getUTCMonth(),2)+o(r.getUTCDate(),2)+o(r.getUTCHours(),2)+o(r.getUTCMinutes(),2)+o(r.getUTCSeconds(),2)+"Z)";if("[object Object]"!=={}.toString.call(r))return""+r;for(t in e=["<<"],r)n=r[t],e.push("/"+t+" "+a.convert(n));return e.push(">>"),e.join("\n")},a}()}(lt),
/*
  # PNG.js
  # Copyright (c) 2011 Devon Govett
  # MIT LICENSE
  # 
  # 
  */
Nt="undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")(),Lt=function(){var h,n,r;function i(t){var e,n,r,i,o,a,s,l,h,u,c,f,p,d;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},a=null;;){switch(e=this.readUInt32(),h=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":a&&this.animation.frames.push(a),this.pos+=4,a={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},o=this.readUInt16(),i=this.readUInt16()||100,a.delay=1e3*o/i,a.disposeOp=this.data[this.pos++],a.blendOp=this.data[this.pos++],a.data=[];break;case"IDAT":case"fdAT":for("fdAT"===h&&(this.pos+=4,e-=4),t=(null!=a?a.data:void 0)||this.imgData,f=0;0<=e?f<e:e<f;0<=e?++f:--f)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(r=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>r)throw new Error("More transparent colors than palette size");if(0<(u=r-this.transparency.indexed.length))for(p=0;0<=u?p<u:u<p;0<=u?++p:--p)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e)}break;case"tEXt":s=(c=this.read(e)).indexOf(0),l=String.fromCharCode.apply(String,c.slice(0,s)),this.text[l]=String.fromCharCode.apply(String,c.slice(s+1));break;case"IEND":return a&&this.animation.frames.push(a),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(d=this.colorType)||6===d,n=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*n,this.colorSpace=function(){switch(this.colors){case 1:return"DeviceGray";case 3:return"DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}i.load=function(t,e,n){var r;return"function"==typeof e&&(n=e),(r=new XMLHttpRequest).open("GET",t,!0),r.responseType="arraybuffer",r.onload=function(){var t;return t=new i(new Uint8Array(r.response||r.mozResponseArrayBuffer)),"function"==typeof(null!=e?e.getContext:void 0)&&t.render(e),"function"==typeof n?n(t):void 0},r.send(null)},i.prototype.read=function(t){var e,n;for(n=[],e=0;0<=t?e<t:t<e;0<=t?++e:--e)n.push(this.data[this.pos++]);return n},i.prototype.readUInt32=function(){return this.data[this.pos++]<<24|this.data[this.pos++]<<16|this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.readUInt16=function(){return this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.decodePixels=function(C){var B=this.pixelBitlength/8,j=new Uint8Array(this.width*this.height*B),E=0,M=this;if(null==C&&(C=this.imgData),0===C.length)return new Uint8Array(0);function t(t,e,n,r){var i,o,a,s,l,h,u,c,f,p,d,g,m,y,v,w,b,x,N,L,A,S=Math.ceil((M.width-t)/n),_=Math.ceil((M.height-e)/r),F=M.width==S&&M.height==_;for(y=B*S,g=F?j:new Uint8Array(y*_),h=C.length,o=m=0;m<_&&E<h;){switch(C[E++]){case 0:for(s=b=0;b<y;s=b+=1)g[o++]=C[E++];break;case 1:for(s=x=0;x<y;s=x+=1)i=C[E++],l=s<B?0:g[o-B],g[o++]=(i+l)%256;break;case 2:for(s=N=0;N<y;s=N+=1)i=C[E++],a=(s-s%B)/B,v=m&&g[(m-1)*y+a*B+s%B],g[o++]=(v+i)%256;break;case 3:for(s=L=0;L<y;s=L+=1)i=C[E++],a=(s-s%B)/B,l=s<B?0:g[o-B],v=m&&g[(m-1)*y+a*B+s%B],g[o++]=(i+Math.floor((l+v)/2))%256;break;case 4:for(s=A=0;A<y;s=A+=1)i=C[E++],a=(s-s%B)/B,l=s<B?0:g[o-B],0===m?v=w=0:(v=g[(m-1)*y+a*B+s%B],w=a&&g[(m-1)*y+(a-1)*B+s%B]),u=l+v-w,c=Math.abs(u-l),p=Math.abs(u-v),d=Math.abs(u-w),f=c<=p&&c<=d?l:p<=d?v:w,g[o++]=(i+f)%256;break;default:throw new Error("Invalid filter algorithm: "+C[E-1])}if(!F){var P=((e+m*r)*M.width+t)*B,k=m*y;for(s=0;s<S;s+=1){for(var I=0;I<B;I+=1)j[P++]=g[k++];P+=(n-1)*B}}m++}}return C=(C=new kt(C)).getBytes(),1==M.interlaceMethod?(t(0,0,8,8),t(4,0,8,8),t(0,4,4,8),t(2,0,4,4),t(0,2,2,4),t(1,0,2,2),t(0,1,1,2)):t(0,0,1,1),j},i.prototype.decodePalette=function(){var t,e,n,r,i,o,a,s,l;for(n=this.palette,o=this.transparency.indexed||[],i=new Uint8Array((o.length||0)+n.length),r=0,n.length,e=a=t=0,s=n.length;a<s;e=a+=3)i[r++]=n[e],i[r++]=n[e+1],i[r++]=n[e+2],i[r++]=null!=(l=o[t++])?l:255;return i},i.prototype.copyToImageData=function(t,e){var n,r,i,o,a,s,l,h,u,c,f;if(r=this.colors,u=null,n=this.hasAlphaChannel,this.palette.length&&(u=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),r=4,n=!0),h=(i=t.data||t).length,a=u||e,o=s=0,1===r)for(;o<h;)l=u?4*e[o/4]:s,c=a[l++],i[o++]=c,i[o++]=c,i[o++]=c,i[o++]=n?a[l++]:255,s=l;else for(;o<h;)l=u?4*e[o/4]:s,i[o++]=a[l++],i[o++]=a[l++],i[o++]=a[l++],i[o++]=n?a[l++]:255,s=l},i.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t};try{n=Nt.document.createElement("canvas"),r=n.getContext("2d")}catch(t){return-1}return h=function(t){var e;return r.width=t.width,r.height=t.height,r.clearRect(0,0,t.width,t.height),r.putImageData(t,0,0),(e=new Image).src=n.toDataURL(),e},i.prototype.decodeFrames=function(t){var e,n,r,i,o,a,s,l;if(this.animation){for(l=[],n=o=0,a=(s=this.animation.frames).length;o<a;n=++o)e=s[n],r=t.createImageData(e.width,e.height),i=this.decodePixels(new Uint8Array(e.data)),this.copyToImageData(r,i),e.imageData=r,l.push(e.image=h(r));return l}},i.prototype.renderFrame=function(t,e){var n,r,i;return n=(r=this.animation.frames)[e],i=r[e-1],0===e&&t.clearRect(0,0,this.width,this.height),1===(null!=i?i.disposeOp:void 0)?t.clearRect(i.xOffset,i.yOffset,i.width,i.height):2===(null!=i?i.disposeOp:void 0)&&t.putImageData(i.imageData,i.xOffset,i.yOffset),0===n.blendOp&&t.clearRect(n.xOffset,n.yOffset,n.width,n.height),t.drawImage(n.image,n.xOffset,n.yOffset)},i.prototype.animate=function(n){var r,i,o,a,s,t,l=this;return i=0,t=this.animation,a=t.numFrames,o=t.frames,s=t.numPlays,(r=function(){var t,e;if(t=i++%a,e=o[t],l.renderFrame(n,t),1<a&&i/a<s)return l.animation._timeout=setTimeout(r,e.delay)})()},i.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},i.prototype.render=function(t){var e,n;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(n=e.createImageData(this.width,this.height),this.copyToImageData(n,this.decodePixels()),e.putImageData(n,0,0))},i}(),Nt.PNG=Lt;
/*
   * Extracted from pdf.js
   * https://github.com/andreasgal/pdf.js
   *
   * Copyright (c) 2011 Mozilla Foundation
   *
   * Contributors: Andreas Gal <gal@mozilla.com>
   *               Chris G Jones <cjones@mozilla.com>
   *               Shaon Barman <shaon.barman@gmail.com>
   *               Vivien Nicolas <21@vingtetun.org>
   *               Justin D'Arcangelo <justindarc@gmail.com>
   *               Yury Delendik
   *
   * 
   */
var Pt=function(){function t(){this.pos=0,this.bufferLength=0,this.eof=!1,this.buffer=null}return t.prototype={ensureBuffer:function(t){var e=this.buffer,n=e?e.byteLength:0;if(t<n)return e;for(var r=512;r<t;)r<<=1;for(var i=new Uint8Array(r),o=0;o<n;++o)i[o]=e[o];return this.buffer=i},getByte:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return this.buffer[this.pos++]},getBytes:function(t){var e=this.pos;if(t){this.ensureBuffer(e+t);for(var n=e+t;!this.eof&&this.bufferLength<n;)this.readBlock();var r=this.bufferLength;r<n&&(n=r)}else{for(;!this.eof;)this.readBlock();n=this.bufferLength}return this.pos=n,this.buffer.subarray(e,n)},lookChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos])},getChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos++])},makeSubStream:function(t,e,n){for(var r=t+e;this.bufferLength<=r&&!this.eof;)this.readBlock();return new Stream(this.buffer,t,e,n)},skip:function(t){t||(t=1),this.pos+=t},reset:function(){this.pos=0}},t}(),kt=function(){if("undefined"!=typeof Uint32Array){var k=new Uint32Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),I=new Uint32Array([3,4,5,6,7,8,9,10,65547,65549,65551,65553,131091,131095,131099,131103,196643,196651,196659,196667,262211,262227,262243,262259,327811,327843,327875,327907,258,258,258]),C=new Uint32Array([1,2,3,4,65541,65543,131081,131085,196625,196633,262177,262193,327745,327777,393345,393409,459009,459137,524801,525057,590849,591361,657409,658433,724993,727041,794625,798721,868353,876545]),B=[new Uint32Array([459008,524368,524304,524568,459024,524400,524336,590016,459016,524384,524320,589984,524288,524416,524352,590048,459012,524376,524312,589968,459028,524408,524344,590032,459020,524392,524328,59e4,524296,524424,524360,590064,459010,524372,524308,524572,459026,524404,524340,590024,459018,524388,524324,589992,524292,524420,524356,590056,459014,524380,524316,589976,459030,524412,524348,590040,459022,524396,524332,590008,524300,524428,524364,590072,459009,524370,524306,524570,459025,524402,524338,590020,459017,524386,524322,589988,524290,524418,524354,590052,459013,524378,524314,589972,459029,524410,524346,590036,459021,524394,524330,590004,524298,524426,524362,590068,459011,524374,524310,524574,459027,524406,524342,590028,459019,524390,524326,589996,524294,524422,524358,590060,459015,524382,524318,589980,459031,524414,524350,590044,459023,524398,524334,590012,524302,524430,524366,590076,459008,524369,524305,524569,459024,524401,524337,590018,459016,524385,524321,589986,524289,524417,524353,590050,459012,524377,524313,589970,459028,524409,524345,590034,459020,524393,524329,590002,524297,524425,524361,590066,459010,524373,524309,524573,459026,524405,524341,590026,459018,524389,524325,589994,524293,524421,524357,590058,459014,524381,524317,589978,459030,524413,524349,590042,459022,524397,524333,590010,524301,524429,524365,590074,459009,524371,524307,524571,459025,524403,524339,590022,459017,524387,524323,589990,524291,524419,524355,590054,459013,524379,524315,589974,459029,524411,524347,590038,459021,524395,524331,590006,524299,524427,524363,590070,459011,524375,524311,524575,459027,524407,524343,590030,459019,524391,524327,589998,524295,524423,524359,590062,459015,524383,524319,589982,459031,524415,524351,590046,459023,524399,524335,590014,524303,524431,524367,590078,459008,524368,524304,524568,459024,524400,524336,590017,459016,524384,524320,589985,524288,524416,524352,590049,459012,524376,524312,589969,459028,524408,524344,590033,459020,524392,524328,590001,524296,524424,524360,590065,459010,524372,524308,524572,459026,524404,524340,590025,459018,524388,524324,589993,524292,524420,524356,590057,459014,524380,524316,589977,459030,524412,524348,590041,459022,524396,524332,590009,524300,524428,524364,590073,459009,524370,524306,524570,459025,524402,524338,590021,459017,524386,524322,589989,524290,524418,524354,590053,459013,524378,524314,589973,459029,524410,524346,590037,459021,524394,524330,590005,524298,524426,524362,590069,459011,524374,524310,524574,459027,524406,524342,590029,459019,524390,524326,589997,524294,524422,524358,590061,459015,524382,524318,589981,459031,524414,524350,590045,459023,524398,524334,590013,524302,524430,524366,590077,459008,524369,524305,524569,459024,524401,524337,590019,459016,524385,524321,589987,524289,524417,524353,590051,459012,524377,524313,589971,459028,524409,524345,590035,459020,524393,524329,590003,524297,524425,524361,590067,459010,524373,524309,524573,459026,524405,524341,590027,459018,524389,524325,589995,524293,524421,524357,590059,459014,524381,524317,589979,459030,524413,524349,590043,459022,524397,524333,590011,524301,524429,524365,590075,459009,524371,524307,524571,459025,524403,524339,590023,459017,524387,524323,589991,524291,524419,524355,590055,459013,524379,524315,589975,459029,524411,524347,590039,459021,524395,524331,590007,524299,524427,524363,590071,459011,524375,524311,524575,459027,524407,524343,590031,459019,524391,524327,589999,524295,524423,524359,590063,459015,524383,524319,589983,459031,524415,524351,590047,459023,524399,524335,590015,524303,524431,524367,590079]),9],j=[new Uint32Array([327680,327696,327688,327704,327684,327700,327692,327708,327682,327698,327690,327706,327686,327702,327694,0,327681,327697,327689,327705,327685,327701,327693,327709,327683,327699,327691,327707,327687,327703,327695,0]),5];return(t.prototype=Object.create(Pt.prototype)).getBits=function(t){for(var e,n=this.codeSize,r=this.codeBuf,i=this.bytes,o=this.bytesPos;n<t;)void 0===(e=i[o++])&&E("Bad encoding in flate stream"),r|=e<<n,n+=8;return e=r&(1<<t)-1,this.codeBuf=r>>t,this.codeSize=n-=t,this.bytesPos=o,e},t.prototype.getCode=function(t){for(var e=t[0],n=t[1],r=this.codeSize,i=this.codeBuf,o=this.bytes,a=this.bytesPos;r<n;){var s;void 0===(s=o[a++])&&E("Bad encoding in flate stream"),i|=s<<r,r+=8}var l=e[i&(1<<n)-1],h=l>>16,u=65535&l;return(0==r||r<h||0==h)&&E("Bad encoding in flate stream"),this.codeBuf=i>>h,this.codeSize=r-h,this.bytesPos=a,u},t.prototype.generateHuffmanTable=function(t){for(var e=t.length,n=0,r=0;r<e;++r)t[r]>n&&(n=t[r]);for(var i=1<<n,o=new Uint32Array(i),a=1,s=0,l=2;a<=n;++a,s<<=1,l<<=1)for(var h=0;h<e;++h)if(t[h]==a){var u=0,c=s;for(r=0;r<a;++r)u=u<<1|1&c,c>>=1;for(r=u;r<i;r+=l)o[r]=a<<16|h;++s}return[o,n]},t.prototype.readBlock=function(){function t(t,e,n,r,i){for(var o=t.getBits(n)+r;0<o--;)e[l++]=i}var e=this.getBits(3);if(1&e&&(this.eof=!0),0!=(e>>=1)){var n,r;if(1==e)n=B,r=j;else if(2==e){for(var i=this.getBits(5)+257,o=this.getBits(5)+1,a=this.getBits(4)+4,s=Array(k.length),l=0;l<a;)s[k[l++]]=this.getBits(3);for(var h=this.generateHuffmanTable(s),u=0,c=(l=0,i+o),f=new Array(c);l<c;){var p=this.getCode(h);16==p?t(this,f,2,3,u):17==p?t(this,f,3,3,u=0):18==p?t(this,f,7,11,u=0):f[l++]=u=p}n=this.generateHuffmanTable(f.slice(0,i)),r=this.generateHuffmanTable(f.slice(i,c))}else E("Unknown block type in flate stream");for(var d=(_=this.buffer)?_.length:0,g=this.bufferLength;;){var m=this.getCode(n);if(m<256)d<=g+1&&(d=(_=this.ensureBuffer(g+1)).length),_[g++]=m;else{if(256==m)return void(this.bufferLength=g);var y=(m=I[m-=257])>>16;0<y&&(y=this.getBits(y));u=(65535&m)+y;m=this.getCode(r),0<(y=(m=C[m])>>16)&&(y=this.getBits(y));var v=(65535&m)+y;d<=g+u&&(d=(_=this.ensureBuffer(g+u)).length);for(var w=0;w<u;++w,++g)_[g]=_[g-v]}}}else{var b,x=this.bytes,N=this.bytesPos;void 0===(b=x[N++])&&E("Bad block header in flate stream");var L=b;void 0===(b=x[N++])&&E("Bad block header in flate stream"),L|=b<<8,void 0===(b=x[N++])&&E("Bad block header in flate stream");var A=b;void 0===(b=x[N++])&&E("Bad block header in flate stream"),(A|=b<<8)!=(65535&~L)&&E("Bad uncompressed block length in flate stream"),this.codeBuf=0,this.codeSize=0;var S=this.bufferLength,_=this.ensureBuffer(S+L),F=S+L;this.bufferLength=F;for(var P=S;P<F;++P){if(void 0===(b=x[N++])){this.eof=!0;break}_[P]=b}this.bytesPos=N}},t}function E(t){throw new Error(t)}function t(t){var e=0,n=t[e++],r=t[e++];-1!=n&&-1!=r||E("Invalid header in flate stream"),8!=(15&n)&&E("Unknown compression method in flate stream"),((n<<8)+r)%31!=0&&E("Bad FCHECK in flate stream"),32&r&&E("FDICT bit set in flate stream"),this.bytes=t,this.bytesPos=2,this.codeSize=0,this.codeBuf=0,Pt.call(this)}}();window.tmp=kt});try{module.exports=jsPDF}catch(t){}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(119)('wks');
var uid = __webpack_require__(99);
var Symbol = __webpack_require__(18).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * html2canvas 1.4.0 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.html2canvas = factory());
}(this, (function () { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }

    var Bounds = /** @class */ (function () {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function (x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function (context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function (context, domRectList) {
            var domRect = Array.from(domRectList).find(function (rect) { return rect.width !== 0; });
            return domRect
                ? new Bounds(domRect.x + context.windowBounds.left, domRect.y + context.windowBounds.top, domRect.width, domRect.height)
                : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }());
    var parseBounds = function (context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function (document) {
        var body = document.body;
        var documentElement = document.documentElement;
        if (!body || !documentElement) {
            throw new Error("Unable to get document size");
        }
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };

    /*
     * css-line-break 2.0.1 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var toCodePoints$1 = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint$1 = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$2 = 0; i$2 < chars$2.length; i$2++) {
        lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    }
    var decode$1 = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$2[base64.charCodeAt(i)];
            encoded2 = lookup$2[base64.charCodeAt(i + 1)];
            encoded3 = lookup$2[base64.charCodeAt(i + 2)];
            encoded4 = lookup$2[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1$1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function (base64) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16$1(view16, (headerLength + view32[4]) / 2)
            : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2$1) & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    var base64$1 = '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';

    /* @flow */
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [0x2329, 0xff08];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = '×';
    var BREAK_ALLOWED$1 = '÷';
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [AL, HL];
    var HARD_LINE_BREAKS = [BK, CR$1, LF$1, NL];
    var SPACE$1 = [SP, ZW];
    var PREFIX_POSTFIX = [PR, PO];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
    var HYPHEN = [HY, BA];
    var codePointsToCharacterClasses = function (codePoints, lineBreak) {
        if (lineBreak === void 0) { lineBreak = 'strict'; }
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function (codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            }
            else {
                categories.push(false);
            }
            if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
                // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
                if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) {
                return types.push(lineBreak === 'strict' ? NS : ID);
            }
            if (classType === SA) {
                return types.push(AL);
            }
            if (classType === AI) {
                return types.push(AL);
            }
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if ((codePoint >= 0x20000 && codePoint <= 0x2fffd) || (codePoint >= 0x30000 && codePoint <= 0x3fffd)) {
                    return types.push(ID);
                }
                else {
                    return types.push(AL);
                }
            }
            types.push(classType);
        });
        return [indices, types, categories];
    };
    var isAdjacentWithSpaceIgnored = function (a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while (i <= classTypes.length) {
                i++;
                var next = classTypes[i];
                if (next === b) {
                    return true;
                }
                if (next !== SP) {
                    break;
                }
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while (i > 0) {
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while (n <= classTypes.length) {
                        n++;
                        var next = classTypes[n];
                        if (next === b) {
                            return true;
                        }
                        if (next !== SP) {
                            break;
                        }
                    }
                }
                if (prev !== SP) {
                    break;
                }
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function (currentIndex, classTypes) {
        var i = currentIndex;
        while (i >= 0) {
            var type = classTypes[i];
            if (type === SP) {
                i--;
            }
            else {
                return type;
            }
        }
        return 0;
    };
    var _lineBreakAtIndex = function (codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) {
            return BREAK_NOT_ALLOWED$1;
        }
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
            return BREAK_NOT_ALLOWED$1;
        }
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
            return BREAK_MANDATORY;
        }
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
            return BREAK_ALLOWED$1;
        }
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB18 Break after spaces.
        if (current === SP) {
            return BREAK_ALLOWED$1;
        }
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) {
            return BREAK_ALLOWED$1;
        }
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB22 Do not break before ellipsis.
        if (next === IN) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23 Do not break between digits and letters.
        if ((ALPHABETICS.indexOf(next) !== -1 && current === NU) || (ALPHABETICS.indexOf(current) !== -1 && next === NU)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if ((current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
            ([ID, EB, EM].indexOf(current) !== -1 && next === PO)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if ((ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1) ||
            (PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (
        // (PR | PO) × ( OP | HY )? NU
        ([PR, PO].indexOf(current) !== -1 &&
            (next === NU || ([OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU))) ||
            // ( OP | HY ) × NU
            ([OP, HY].indexOf(current) !== -1 && next === NU) ||
            // NU ×	(NU | SY | IS)
            (current === NU && [NU, SY, IS].indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([PR, PO].indexOf(next) !== -1) {
            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // LB26 Do not break a Korean syllable.
        if ((JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
            ([JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1) ||
            ([JT, H3].indexOf(current) !== -1 && next === JT)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB27 Treat a Korean Syllable Block the same as ID.
        if ((KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1) ||
            (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if ((ALPHABETICS.concat(NU).indexOf(current) !== -1 &&
            next === OP &&
            ea_OP.indexOf(codePoints[afterIndex]) === -1) ||
            (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while (i > 0) {
                i--;
                if (classTypes[i] === RI$1) {
                    count++;
                }
                else {
                    break;
                }
            }
            if (count % 2 !== 0) {
                return BREAK_NOT_ALLOWED$1;
            }
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) {
            return BREAK_NOT_ALLOWED$1;
        }
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function (codePoints, options) {
        if (!options) {
            options = { lineBreak: 'normal', wordBreak: 'normal' };
        }
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
            classTypes = classTypes.map(function (type) { return ([NU, AL, SA].indexOf(type) !== -1 ? ID : type); });
        }
        var forbiddenBreakpoints = options.wordBreak === 'keep-all'
            ? isLetterNumber.map(function (letterNumber, i) {
                return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
            })
            : undefined;
        return [indicies, classTypes, forbiddenBreakpoints];
    };
    var Break = /** @class */ (function () {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function () {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }());
    var LineBreaker = function (str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function () {
                if (nextIndex >= length) {
                    return { done: true, value: null };
                }
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while (nextIndex < length &&
                    (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) ===
                        BREAK_NOT_ALLOWED$1) { }
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };

    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1 << 0;
    var FLAG_ID = 1 << 1;
    var FLAG_INTEGER = 1 << 2;
    var FLAG_NUMBER = 1 << 3;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function (codePoint) { return codePoint >= ZERO && codePoint <= 0x0039; };
    var isSurrogateCodePoint = function (codePoint) { return codePoint >= 0xd800 && codePoint <= 0xdfff; };
    var isHex = function (codePoint) {
        return isDigit(codePoint) || (codePoint >= A && codePoint <= F) || (codePoint >= a && codePoint <= f);
    };
    var isLowerCaseLetter = function (codePoint) { return codePoint >= a && codePoint <= z; };
    var isUpperCaseLetter = function (codePoint) { return codePoint >= A && codePoint <= Z; };
    var isLetter = function (codePoint) { return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint); };
    var isNonASCIICodePoint = function (codePoint) { return codePoint >= CONTROL; };
    var isWhiteSpace = function (codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function (codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function (codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function (codePoint) {
        return ((codePoint >= NULL && codePoint <= BACKSPACE) ||
            codePoint === LINE_TABULATION ||
            (codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE) ||
            codePoint === DELETE);
    };
    var isValidEscape = function (c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) {
            return false;
        }
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function (c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) {
            return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        }
        else if (isNameStartCodePoint(c1)) {
            return true;
        }
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
            return true;
        }
        return false;
    };
    var isNumberStart = function (c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) {
                return true;
            }
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) {
            return isDigit(c2);
        }
        return isDigit(c1);
    };
    var stringToNumber = function (codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                sign = -1;
            }
            c++;
        }
        var integers = [];
        while (isDigit(codePoints[c])) {
            integers.push(codePoints[c++]);
        }
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) {
            c++;
        }
        var fraction = [];
        while (isDigit(codePoints[c])) {
            fraction.push(codePoints[c++]);
        }
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) {
            c++;
        }
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                expsign = -1;
            }
            c++;
        }
        var exponent = [];
        while (isDigit(codePoints[c])) {
            exponent.push(codePoints[c++]);
        }
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */
    };
    var COMMA_TOKEN = { type: 4 /* COMMA_TOKEN */ };
    var SUFFIX_MATCH_TOKEN = { type: 13 /* SUFFIX_MATCH_TOKEN */ };
    var PREFIX_MATCH_TOKEN = { type: 8 /* PREFIX_MATCH_TOKEN */ };
    var COLUMN_TOKEN = { type: 21 /* COLUMN_TOKEN */ };
    var DASH_MATCH_TOKEN = { type: 9 /* DASH_MATCH_TOKEN */ };
    var INCLUDE_MATCH_TOKEN = { type: 10 /* INCLUDE_MATCH_TOKEN */ };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */
    };
    var SUBSTRING_MATCH_TOKEN = { type: 14 /* SUBSTRING_MATCH_TOKEN */ };
    var BAD_URL_TOKEN = { type: 23 /* BAD_URL_TOKEN */ };
    var BAD_STRING_TOKEN = { type: 1 /* BAD_STRING_TOKEN */ };
    var CDO_TOKEN = { type: 25 /* CDO_TOKEN */ };
    var CDC_TOKEN = { type: 24 /* CDC_TOKEN */ };
    var COLON_TOKEN = { type: 26 /* COLON_TOKEN */ };
    var SEMICOLON_TOKEN = { type: 27 /* SEMICOLON_TOKEN */ };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */
    };
    var WHITESPACE_TOKEN = { type: 31 /* WHITESPACE_TOKEN */ };
    var EOF_TOKEN = { type: 32 /* EOF_TOKEN */ };
    var Tokenizer = /** @class */ (function () {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function (chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function () {
            var tokens = [];
            var token = this.consumeToken();
            while (token !== EOF_TOKEN) {
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function () {
            var codePoint = this.consumeCodePoint();
            switch (codePoint) {
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return { type: 5 /* HASH_TOKEN */, value: value, flags: flags };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while (true) {
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) {
                                    return this.consumeToken();
                                }
                            }
                            if (c === EOF) {
                                return this.consumeToken();
                            }
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK &&
                        this.peekCodePoint(1) === HYPHEN_MINUS &&
                        this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return { type: 7 /* AT_KEYWORD_TOKEN */, value: value };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return { type: 6 /* DELIM_TOKEN */, value: fromCodePoint$1(codePoint) };
        };
        Tokenizer.prototype.consumeCodePoint = function () {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function (delta) {
            if (delta >= this._value.length) {
                return -1;
            }
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function () {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while (isHex(codePoint) && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while (codePoint === QUESTION_MARK && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? ZERO : digit); })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? F : digit); })), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start_1, end: end };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while (isHex(codePoint) && endDigits.length < 6) {
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: end };
            }
            else {
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: start };
            }
        };
        Tokenizer.prototype.consumeIdentLikeToken = function () {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            }
            else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return { type: 19 /* FUNCTION_TOKEN */, value: value };
            }
            return { type: 20 /* IDENT_TOKEN */, value: value };
        };
        Tokenizer.prototype.consumeUrlToken = function () {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) {
                return { type: 22 /* URL_TOKEN */, value: '' };
            }
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: stringToken.value };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                    return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                }
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === QUOTATION_MARK ||
                    codePoint === APOSTROPHE ||
                    codePoint === LEFT_PARENTHESIS ||
                    isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        value.push(this.consumeEscapedCodePoint());
                    }
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                }
                else {
                    value.push(codePoint);
                }
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function () {
            while (isWhiteSpace(this.peekCodePoint(0))) {
                this.consumeCodePoint();
            }
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function () {
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                    return;
                }
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    this.consumeEscapedCodePoint();
                }
            }
        };
        Tokenizer.prototype.consumeStringSlice = function (count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while (count > 0) {
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function (endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return { type: 0 /* STRING_TOKEN */, value: value };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        }
                        else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            } while (true);
        };
        Tokenizer.prototype.consumeNumber = function () {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
                repr.push(this.consumeCodePoint());
            }
            while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3)) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            return [stringToNumber(repr), type];
        };
        Tokenizer.prototype.consumeNumericToken = function () {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return { type: 15 /* DIMENSION_TOKEN */, number: number, flags: flags, unit: unit };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return { type: 16 /* PERCENTAGE_TOKEN */, number: number, flags: flags };
            }
            return { type: 17 /* NUMBER_TOKEN */, number: number, flags: flags };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function () {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
                    hex += fromCodePoint$1(this.consumeCodePoint());
                }
                if (isWhiteSpace(this.peekCodePoint(0))) {
                    this.consumeCodePoint();
                }
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
                    return REPLACEMENT_CHARACTER;
                }
                return hexCodePoint;
            }
            if (codePoint === EOF) {
                return REPLACEMENT_CHARACTER;
            }
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function () {
            var result = '';
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) {
                    result += fromCodePoint$1(codePoint);
                }
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    result += fromCodePoint$1(this.consumeEscapedCodePoint());
                }
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }());

    var Parser = /** @class */ (function () {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function (value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function (value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function (value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function () {
            var token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */) {
                token = this.consumeToken();
            }
            if (token.type === 32 /* EOF_TOKEN */) {
                throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            }
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do {
                token = this.consumeToken();
            } while (token.type === 31 /* WHITESPACE_TOKEN */);
            if (token.type === 32 /* EOF_TOKEN */) {
                return value;
            }
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function () {
            var values = [];
            while (true) {
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */) {
                    return values;
                }
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function () {
            var token = this.consumeToken();
            switch (token.type) {
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */:
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */:
                case 2 /* LEFT_PARENTHESIS_TOKEN */:
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */:
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function (type) {
            var block = { type: type, values: [] };
            var token = this.consumeToken();
            while (true) {
                if (token.type === 32 /* EOF_TOKEN */ || isEndingTokenFor(token, type)) {
                    return block;
                }
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function (functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */
            };
            while (true) {
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */ || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */) {
                    return cssFunction;
                }
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function () {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function (token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }());
    var isDimensionToken = function (token) { return token.type === 15 /* DIMENSION_TOKEN */; };
    var isNumberToken = function (token) { return token.type === 17 /* NUMBER_TOKEN */; };
    var isIdentToken = function (token) { return token.type === 20 /* IDENT_TOKEN */; };
    var isStringToken = function (token) { return token.type === 0 /* STRING_TOKEN */; };
    var isIdentWithValue = function (token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function (token) { return token.type !== 31 /* WHITESPACE_TOKEN */; };
    var nonFunctionArgSeparator = function (token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ && token.type !== 4 /* COMMA_TOKEN */;
    };
    var parseFunctionArgs = function (tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function (token) {
            if (token.type === 4 /* COMMA_TOKEN */) {
                if (arg.length === 0) {
                    throw new Error("Error parsing function args, zero tokens for arg");
                }
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */) {
                arg.push(token);
            }
        });
        if (arg.length) {
            args.push(arg);
        }
        return args;
    };
    var isEndingTokenFor = function (token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */ && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */) {
            return true;
        }
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */ && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */) {
            return true;
        }
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */ && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */;
    };

    var isLength = function (token) {
        return token.type === 17 /* NUMBER_TOKEN */ || token.type === 15 /* DIMENSION_TOKEN */;
    };

    var isLengthPercentage = function (token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */ || isLength(token);
    };
    var parseLengthPercentageTuple = function (tokens) {
        return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function (tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)];
    };
    var getAbsoluteValue = function (token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            return (token.number / 100) * parent;
        }
        if (isDimensionToken(token)) {
            switch (token.unit) {
                case 'rem':
                case 'em':
                    return 16 * token.number; // TODO use correct font-size
                case 'px':
                default:
                    return token.number;
            }
        }
        return token.number;
    };

    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit) {
                    case DEG:
                        return (Math.PI * value.number) / 180;
                    case GRAD:
                        return (Math.PI / 200) * value.number;
                    case RAD:
                        return value.number;
                    case TURN:
                        return Math.PI * 2 * value.number;
                }
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function (value) {
        if (value.type === 15 /* DIMENSION_TOKEN */) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
                return true;
            }
        }
        return false;
    };
    var parseNamedSide = function (tokens) {
        var sideOrCorner = tokens
            .filter(isIdentToken)
            .map(function (ident) { return ident.value; })
            .join(' ');
        switch (sideOrCorner) {
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [ZERO_LENGTH, ZERO_LENGTH];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [ZERO_LENGTH, HUNDRED_PERCENT];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [HUNDRED_PERCENT, HUNDRED_PERCENT];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [HUNDRED_PERCENT, ZERO_LENGTH];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function (deg) { return (Math.PI * deg) / 180; };

    var color$1 = {
        name: 'color',
        parse: function (context, value) {
            if (value.type === 18 /* FUNCTION */) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                }
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') {
                    return namedColor;
                }
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function (color) { return (0xff & color) === 0; };
    var asString = function (color) {
        var alpha = 0xff & color;
        var blue = 0xff & (color >> 8);
        var green = 0xff & (color >> 16);
        var red = 0xff & (color >> 24);
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function (r, g, b, a) {
        return ((r << 24) | (g << 16) | (b << 8) | (Math.round(a * 255) << 0)) >>> 0;
    };
    var getTokenColorValue = function (token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */) {
            return token.number;
        }
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? (token.number / 100) * max : Math.round((token.number / 100) * max);
        }
        return 0;
    };
    var rgb = function (_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) {
            hue += 1;
        }
        if (hue >= 1) {
            hue -= 1;
        }
        if (hue < 1 / 6) {
            return (t2 - t1) * hue * 6 + t1;
        }
        else if (hue < 1 / 2) {
            return t2;
        }
        else if (hue < 2 / 3) {
            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        }
        else {
            return t1;
        }
    }
    var hsl = function (context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */ ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) {
            return pack(l * 255, l * 255, l * 255, 1);
        }
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function (context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };

    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var parseColorStop = function (context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? { color: color, stop: stop } : { color: color, stop: null };
    };
    var processColorStops = function (stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) {
            first.stop = ZERO_LENGTH;
        }
        if (last.stop === null) {
            last.stop = HUNDRED_PERCENT;
        }
        var processStops = [];
        var previous = 0;
        for (var i = 0; i < stops.length; i++) {
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) {
                    processStops.push(absoluteValue);
                }
                else {
                    processStops.push(previous);
                }
                previous = absoluteValue;
            }
            else {
                processStops.push(null);
            }
        }
        var gapBegin = null;
        for (var i = 0; i < processStops.length; i++) {
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) {
                    gapBegin = i;
                }
            }
            else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for (var g = 1; g <= gapLength; g++) {
                    processStops[gapBegin + g - 1] = gapValue * g;
                }
                gapBegin = null;
            }
        }
        return stops.map(function (_a, i) {
            var color = _a.color;
            return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) };
        });
    };
    var getAngleFromCorner = function (corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function (angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
    };
    var distance = function (a, b) { return Math.sqrt(a * a + b * b); };
    var findCorner = function (width, height, x, y, closest) {
        var corners = [
            [0, 0],
            [0, height],
            [width, 0],
            [width, height]
        ];
        return corners.reduce(function (stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
                return {
                    optimumCorner: corner,
                    optimumDistance: d
                };
            }
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function (gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch (gradient.size) {
            case 0 /* CLOSEST_SIDE */:
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */:
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */:
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */:
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [rx, ry];
    };

    var linearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return { angle: angle$1, stops: stops, type: 1 /* LINEAR_GRADIENT */ };
    };

    var prefixLinearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ &&
                    ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */
        };
    };

    var webkitGradient = function (context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */;
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */;
                    return;
                }
                else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: ZERO_LENGTH, color: color });
                }
                else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: HUNDRED_PERCENT, color: color });
                }
                else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) {
                            stops.push({
                                stop: { type: 16 /* PERCENTAGE_TOKEN */, number: stop_1.number * 100, flags: stop_1.flags },
                                color: color
                            });
                        }
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */
            ? {
                angle: (angle + deg(180)) % deg(360),
                stops: stops,
                type: type
            }
            : { size: size, shape: shape, stops: stops, position: position, type: type };
    };

    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function (acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) {
                            switch (token.value) {
                                case 'center':
                                    position.push(FIFTY_PERCENT);
                                    return acc;
                                case 'top':
                                case 'left':
                                    position.push(ZERO_LENGTH);
                                    return acc;
                                case 'right':
                                case 'bottom':
                                    position.push(HUNDRED_PERCENT);
                                    return acc;
                            }
                        }
                        else if (isLengthPercentage(token) || isLength(token)) {
                            position.push(token);
                        }
                    }
                    else if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case 'at':
                                isAtPosition_1 = true;
                                return false;
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case COVER:
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var prefixRadialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return false;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return false;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return false;
                        }
                    }
                    else if (isLengthPercentage(token) || isLength(token)) {
                        position.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            else if (i === 1) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case COVER:
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var isLinearGradient = function (background) {
        return background.type === 1 /* LINEAR_GRADIENT */;
    };
    var isRadialGradient = function (background) {
        return background.type === 2 /* RADIAL_GRADIENT */;
    };
    var image = {
        name: 'image',
        parse: function (context, value) {
            if (value.type === 22 /* URL_TOKEN */) {
                var image_1 = { url: value.value, type: 0 /* URL */ };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                }
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return (!(value.type === 20 /* IDENT_TOKEN */ && value.value === 'none') &&
            (value.type !== 18 /* FUNCTION */ || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]));
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };

    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens
                .filter(function (value) { return nonFunctionArgSeparator(value) && isSupportedImage(value); })
                .map(function (value) { return image.parse(context, value); });
        }
    };

    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) { return values.filter(isLengthPercentage); })
                .map(parseLengthPercentageTuple);
        }
    };

    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) {
                return values
                    .filter(isIdentToken)
                    .map(function (token) { return token.value; })
                    .join(' ');
            })
                .map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function (value) {
        switch (value) {
            case 'no-repeat':
                return 1 /* NO_REPEAT */;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */;
            case 'repeat':
            default:
                return 0 /* REPEAT */;
        }
    };

    var BACKGROUND_SIZE;
    (function (BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens).map(function (values) { return values.filter(isBackgroundSizeInfoToken); });
        }
    };
    var isBackgroundSizeInfoToken = function (value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };

    var borderColorForSide = function (side) { return ({
        name: "border-" + side + "-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    }); };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');

    var borderRadiusForSide = function (side) { return ({
        name: "border-radius-" + side,
        initialValue: '0 0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
        }
    }); };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');

    var borderStyleForSide = function (side) { return ({
        name: "border-" + side + "-style",
        initialValue: 'solid',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, style) {
            switch (style) {
                case 'none':
                    return 0 /* NONE */;
                case 'dashed':
                    return 2 /* DASHED */;
                case 'dotted':
                    return 3 /* DOTTED */;
                case 'double':
                    return 4 /* DOUBLE */;
            }
            return 1 /* SOLID */;
        }
    }); };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');

    var borderWidthForSide = function (side) { return ({
        name: "border-" + side + "-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    }); };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');

    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, direction) {
            switch (direction) {
                case 'rtl':
                    return 1 /* RTL */;
                case 'ltr':
                default:
                    return 0 /* LTR */;
            }
        }
    };

    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function (bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */);
        }
    };
    var parseDisplayValue = function (display) {
        switch (display) {
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */;
            case 'inline':
                return 4 /* INLINE */;
            case 'run-in':
                return 8 /* RUN_IN */;
            case 'flow':
                return 16 /* FLOW */;
            case 'flow-root':
                return 32 /* FLOW_ROOT */;
            case 'table':
                return 64 /* TABLE */;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */;
            case 'ruby':
                return 512 /* RUBY */;
            case 'subgrid':
                return 1024 /* SUBGRID */;
            case 'list-item':
                return 2048 /* LIST_ITEM */;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */;
            case 'table-row':
                return 32768 /* TABLE_ROW */;
            case 'table-cell':
                return 65536 /* TABLE_CELL */;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */;
            case 'contents':
                return 16777216 /* CONTENTS */;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */;
        }
        return 0 /* NONE */;
    };

    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, float) {
            switch (float) {
                case 'left':
                    return 1 /* LEFT */;
                case 'right':
                    return 2 /* RIGHT */;
                case 'inline-start':
                    return 3 /* INLINE_START */;
                case 'inline-end':
                    return 4 /* INLINE_END */;
            }
            return 0 /* NONE */;
        }
    };

    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'normal') {
                return 0;
            }
            if (token.type === 17 /* NUMBER_TOKEN */) {
                return token.number;
            }
            if (token.type === 15 /* DIMENSION_TOKEN */) {
                return token.number;
            }
            return 0;
        }
    };

    var LINE_BREAK;
    (function (LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, lineBreak) {
            switch (lineBreak) {
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };

    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    };
    var computeLineHeight = function (token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') {
            return 1.2 * fontSize;
        }
        else if (token.type === 17 /* NUMBER_TOKEN */) {
            return fontSize * token.number;
        }
        else if (isLengthPercentage(token)) {
            return getAbsoluteValue(token, fontSize);
        }
        return fontSize;
    };

    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            return image.parse(context, token);
        }
    };

    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'inside':
                    return 0 /* INSIDE */;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */;
            }
        }
    };

    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, type) {
            switch (type) {
                case 'disc':
                    return 0 /* DISC */;
                case 'circle':
                    return 1 /* CIRCLE */;
                case 'square':
                    return 2 /* SQUARE */;
                case 'decimal':
                    return 3 /* DECIMAL */;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */;
                case 'armenian':
                    return 12 /* ARMENIAN */;
                case 'bengali':
                    return 13 /* BENGALI */;
                case 'cambodian':
                    return 14 /* CAMBODIAN */;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */;
                case 'devanagari':
                    return 18 /* DEVANAGARI */;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */;
                case 'georgian':
                    return 20 /* GEORGIAN */;
                case 'gujarati':
                    return 21 /* GUJARATI */;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */;
                case 'hebrew':
                    return 22 /* HEBREW */;
                case 'hiragana':
                    return 23 /* HIRAGANA */;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */;
                case 'kannada':
                    return 27 /* KANNADA */;
                case 'katakana':
                    return 28 /* KATAKANA */;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */;
                case 'khmer':
                    return 30 /* KHMER */;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */;
                case 'lao':
                    return 34 /* LAO */;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */;
                case 'malayalam':
                    return 36 /* MALAYALAM */;
                case 'mongolian':
                    return 37 /* MONGOLIAN */;
                case 'myanmar':
                    return 38 /* MYANMAR */;
                case 'oriya':
                    return 39 /* ORIYA */;
                case 'persian':
                    return 40 /* PERSIAN */;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */;
                case 'tamil':
                    return 43 /* TAMIL */;
                case 'telugu':
                    return 44 /* TELUGU */;
                case 'thai':
                    return 45 /* THAI */;
                case 'tibetan':
                    return 46 /* TIBETAN */;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */;
                case 'none':
                default:
                    return -1 /* NONE */;
            }
        }
    };

    var marginForSide = function (side) { return ({
        name: "margin-" + side,
        initialValue: '0',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    }); };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');

    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (overflow) {
                switch (overflow.value) {
                    case 'hidden':
                        return 1 /* HIDDEN */;
                    case 'scroll':
                        return 2 /* SCROLL */;
                    case 'clip':
                        return 3 /* CLIP */;
                    case 'auto':
                        return 4 /* AUTO */;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */;
                }
            });
        }
    };

    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'break-word':
                    return "break-word" /* BREAK_WORD */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var paddingForSide = function (side) { return ({
        name: "padding-" + side,
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length-percentage'
    }); };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');

    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textAlign) {
            switch (textAlign) {
                case 'right':
                    return 2 /* RIGHT */;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */;
                case 'left':
                default:
                    return 0 /* LEFT */;
            }
        }
    };

    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'relative':
                    return 1 /* RELATIVE */;
                case 'absolute':
                    return 2 /* ABSOLUTE */;
                case 'fixed':
                    return 3 /* FIXED */;
                case 'sticky':
                    return 4 /* STICKY */;
            }
            return 0 /* STATIC */;
        }
    };

    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else {
                            shadow.blur = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textTransform) {
            switch (textTransform) {
                case 'uppercase':
                    return 2 /* UPPERCASE */;
                case 'lowercase':
                    return 1 /* LOWERCASE */;
                case 'capitalize':
                    return 3 /* CAPITALIZE */;
            }
            return 0 /* NONE */;
        }
    };

    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            if (token.type === 18 /* FUNCTION */) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                }
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        var a1 = values[0], b1 = values[1]; values[2]; values[3]; var a2 = values[4], b2 = values[5]; values[6]; values[7]; values[8]; values[9]; values[10]; values[11]; var a4 = values[12], b4 = values[13]; values[14]; values[15];
        return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };

    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) {
                return DEFAULT;
            }
            return [origins[0], origins[1]];
        }
    };

    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, visibility) {
            switch (visibility) {
                case 'hidden':
                    return 1 /* HIDDEN */;
                case 'collapse':
                    return 2 /* COLLAPSE */;
                case 'visible':
                default:
                    return 0 /* VISIBLE */;
            }
        }
    };

    var WORD_BREAK;
    (function (WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, wordBreak) {
            switch (wordBreak) {
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };

    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */) {
                return { auto: true, order: 0 };
            }
            if (isNumberToken(token)) {
                return { auto: false, order: token.number };
            }
            throw new Error("Invalid z-index number parsed");
        }
    };

    var time = {
        name: 'time',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit.toLowerCase()) {
                    case 's':
                        return 1000 * value.number;
                    case 'ms':
                        return value.number;
                }
            }
            throw new Error("Unsupported time type");
        }
    };

    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            return 1;
        }
    };

    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens
                .filter(isIdentToken)
                .map(function (token) {
                switch (token.value) {
                    case 'underline':
                        return 1 /* UNDERLINE */;
                    case 'overline':
                        return 2 /* OVERLINE */;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */;
                    case 'none':
                        return 4 /* BLINK */;
                }
                return 0 /* NONE */;
            })
                .filter(function (line) { return line !== 0 /* NONE */; });
        }
    };

    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function (token) {
                switch (token.type) {
                    case 20 /* IDENT_TOKEN */:
                    case 0 /* STRING_TOKEN */:
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */:
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */:
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) {
                results.push(accumulator.join(' '));
            }
            return results.map(function (result) { return (result.indexOf(' ') === -1 ? result : "'" + result + "'"); });
        }
    };

    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length'
    };

    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            if (isIdentToken(token)) {
                switch (token.value) {
                    case 'bold':
                        return 700;
                    case 'normal':
                    default:
                        return 400;
                }
            }
            return 400;
        }
    };

    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (token) { return token.value; });
        }
    };

    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'oblique':
                    return "oblique" /* OBLIQUE */;
                case 'italic':
                    return "italic" /* ITALIC */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var contains = function (bit, value) { return (bit & value) !== 0; };

    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens;
        }
    };

    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({ counter: counter.value, increment: increment });
                }
            }
            return increments;
        }
    };

    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({ counter: counter.value, reset: reset });
                }
            }
            return resets;
        }
    };

    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (context, tokens) {
            return tokens.filter(isDimensionToken).map(function (token) { return time.parse(context, token); });
        }
    };

    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) {
                return null;
            }
            for (var i = 0; i < filtered.length; i += 2) {
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({ open: open_1, close: close_1 });
            }
            return quotes;
        }
    };
    var getQuote = function (quotes, depth, open) {
        if (!quotes) {
            return '';
        }
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) {
            return '';
        }
        return open ? quote.open : quote.close;
    };

    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) {
                        shadow.inset = true;
                    }
                    else if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else if (c === 2) {
                            shadow.blur = token;
                        }
                        else {
                            shadow.spread = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var DEFAULT_VALUE = [0 /* FILL */, 1 /* STROKE */, 2 /* MARKERS */];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function (token) {
                switch (token.value) {
                    case 'stroke':
                        layers.push(1 /* STROKE */);
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */);
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */);
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function (value) {
                if (layers.indexOf(value) === -1) {
                    layers.push(value);
                }
            });
            return layers;
        }
    };

    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    };

    var CSSParsedDeclaration = /** @class */ (function () {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function () {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */;
        };
        CSSParsedDeclaration.prototype.isTransparent = function () {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function () {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function () {
            return this.position !== 0 /* STATIC */;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function () {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function () {
            return this.float !== 0 /* NONE */;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function () {
            return (contains(this.display, 4 /* INLINE */) ||
                contains(this.display, 33554432 /* INLINE_BLOCK */) ||
                contains(this.display, 268435456 /* INLINE_FLEX */) ||
                contains(this.display, 536870912 /* INLINE_GRID */) ||
                contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
                contains(this.display, 134217728 /* INLINE_TABLE */));
        };
        return CSSParsedDeclaration;
    }());
    var CSSParsedPseudoDeclaration = /** @class */ (function () {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }());
    var CSSParsedCounterDeclaration = /** @class */ (function () {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function (context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch (descriptor.type) {
            case 2 /* IDENT_VALUE */:
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */:
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */:
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */:
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */:
                switch (descriptor.format) {
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };

    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function (element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch (attribute) {
            case 'all':
                return 1 /* ALL */;
            case 'clone':
                return 2 /* CLONE */;
            case 'parse':
                return 3 /* PARSE */;
            case 'render':
                return 4 /* RENDER */;
            default:
                return 0 /* NONE */;
        }
    };
    var isDebugging = function (element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */ || type === elementType;
    };

    var ElementContainer = /** @class */ (function () {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */)) {
                debugger;
            }
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function (duration) { return duration > 0; })) {
                    element.style.animationDuration = '0s';
                }
                if (this.styles.transform !== null) {
                    // getBoundingClientRect takes transforms into account
                    element.style.transform = 'none';
                }
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */)) {
                this.flags |= 16 /* DEBUG_RENDER */;
            }
        }
        return ElementContainer;
    }());

    /*
     * text-segmentation 1.0.2 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var base64 = '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';

    /*
     * utrie 1.0.1 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1 = 0; i$1 < chars$1.length; i$1++) {
        lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    }
    var decode = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function (base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16(view16, (headerLength + view32[4]) / 2)
            : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i = 0; i < chars.length; i++) {
        lookup[chars.charCodeAt(i)] = i;
    }

    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = '×';
    var BREAK_ALLOWED = '÷';
    var codePointToClass = function (codePoint) { return UnicodeTrie.get(codePoint); };
    var _graphemeBreakAtIndex = function (_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) {
            return BREAK_NOT_ALLOWED;
        }
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) {
            return BREAK_ALLOWED;
        }
        // GB5
        if (next === CR || next === LF || next === Control) {
            return BREAK_ALLOWED;
        }
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [L, V, LV, LVT].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) {
            return BREAK_NOT_ALLOWED;
        }
        // GB8
        if ((current === LVT || current === T) && next === T) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) {
            return BREAK_NOT_ALLOWED;
        }
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9a
        if (current === Prepend) {
            return BREAK_NOT_ALLOWED;
        }
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while (prev === Extend) {
                prev = classTypes[--prevIndex];
            }
            if (prev === Extended_Pictographic) {
                return BREAK_NOT_ALLOWED;
            }
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while (prev === RI) {
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) {
                return BREAK_NOT_ALLOWED;
            }
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function (str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function () {
                if (index >= length) {
                    return { done: true, value: null };
                }
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while (index < length &&
                    (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED) { }
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };
    var splitGraphemes = function (str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while (!(bk = breaker.next()).done) {
            if (bk.value) {
                graphemes.push(bk.value.slice());
            }
        }
        return graphemes;
    };

    var testRangeBounds = function (document) {
        var TEST_HEIGHT = 123;
        if (document.createRange) {
            var range = document.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) {
                    return true;
                }
            }
        }
        return false;
    };
    var testIOSLineBreak = function (document) {
        var testElement = document.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document.body.appendChild(testElement);
        var range = document.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function (i) { return fromCodePoint$1(i); });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function (text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) {
                return true;
            }
            return boundAhead;
        });
        document.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function () { return typeof new Image().crossOrigin !== 'undefined'; };
    var testResponseType = function () { return typeof new XMLHttpRequest().responseType === 'string'; };
    var testSVG = function (document) {
        var img = new Image();
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return false;
        }
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        }
        catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function (data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function (document) {
        var canvas = document.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return Promise.reject(false);
        }
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg)
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data)
                ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node))
                : Promise.reject(false);
        })
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        })
            .catch(function () { return false; });
    };
    var createForeignObjectSVG = function (width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () { return resolve(img); };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS() {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
            return value;
        },
        get SUPPORT_WORD_BREAKING() {
            var value = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', { value: value });
            return value;
        },
        get SUPPORT_SVG_DRAWING() {
            var value = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING() {
            var value = typeof Array.from === 'function' && typeof window.fetch === 'function'
                ? testForeignObject(document)
                : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_CORS_IMAGES() {
            var value = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
            return value;
        },
        get SUPPORT_RESPONSE_TYPE() {
            var value = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
            return value;
        },
        get SUPPORT_CORS_XHR() {
            var value = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
            return value;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', { value: value });
            return value;
        }
    };

    var TextBounds = /** @class */ (function () {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }());
    var parseTextBounds = function (context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function (text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function (subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    }
                    else {
                        textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                    }
                }
                else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            }
            else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
                node = node.splitText(text.length);
            }
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function (context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) {
                    parentNode.replaceChild(wrapper.firstChild, wrapper);
                }
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function (node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) {
            throw new Error('Node has no owner document');
        }
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function (value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, { granularity: 'grapheme' });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function (value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return breakWords(value, styles);
    };
    var breakText = function (value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [0x0020, 0x00a0, 0x1361, 0x10100, 0x10101, 0x1039, 0x1091];
    var breakWords = function (str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */ ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function () {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function (codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) {
                        word_1 += fromCodePoint$1(codePoint);
                    }
                    else {
                        if (word_1.length) {
                            words.push(word_1);
                        }
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) {
                    words.push(word_1);
                }
            }
        };
        while (!(bk = breaker.next()).done) {
            _loop_1();
        }
        return words;
    };

    var TextContainer = /** @class */ (function () {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }());
    var transform = function (text, transform) {
        switch (transform) {
            case 1 /* LOWERCASE */:
                return text.toLowerCase();
            case 3 /* CAPITALIZE */:
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */:
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function (m, p1, p2) {
        if (m.length > 0) {
            return p1 + p2.toUpperCase();
        }
        return m;
    };

    var ImageElementContainer = /** @class */ (function (_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer));

    var CanvasElementContainer = /** @class */ (function (_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer));

    var SVGElementContainer = /** @class */ (function (_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer));

    var LIElementContainer = /** @class */ (function (_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer));

    var OLElementContainer = /** @class */ (function (_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer));

    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function (bounds) {
        if (bounds.width > bounds.height) {
            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        }
        else if (bounds.width < bounds.height) {
            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        }
        return bounds;
    };
    var getInputValue = function (node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ (function (_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor =
                    _this.styles.borderRightColor =
                        _this.styles.borderBottomColor =
                            _this.styles.borderLeftColor =
                                0xa5a5a5ff;
                _this.styles.borderTopWidth =
                    _this.styles.borderRightWidth =
                        _this.styles.borderBottomWidth =
                            _this.styles.borderLeftWidth =
                                1;
                _this.styles.borderTopStyle =
                    _this.styles.borderRightStyle =
                        _this.styles.borderBottomStyle =
                            _this.styles.borderLeftStyle =
                                1 /* SOLID */;
                _this.styles.backgroundClip = [0 /* BORDER_BOX */];
                _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch (_this.type) {
                case CHECKBOX:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer));

    var SelectElementContainer = /** @class */ (function (_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer));

    var TextareaElementContainer = /** @class */ (function (_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer));

    var IFrameElementContainer = /** @class */ (function (_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow &&
                    iframe.contentWindow.document &&
                    iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor)
                        : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor)
                        ? isTransparent(bodyBackgroundColor)
                            ? _this.styles.backgroundColor
                            : bodyBackgroundColor
                        : documentBackgroundColor;
                }
            }
            catch (e) { }
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer));

    var LIST_OWNERS = ['OL', 'UL', 'MENU'];
    var parseNodeTree = function (context, node, parent, root) {
        for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
                parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            }
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) {
                    childNode.assignedNodes().forEach(function (childNode) { return parseNodeTree(context, childNode, parent, root); });
                }
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) {
                            container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
                        }
                        else if (createsStackingContext(container.styles)) {
                            container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
                        }
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                            container.flags |= 8 /* IS_LIST_OWNER */;
                        }
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) {
                            parseNodeTree(context, childNode.shadowRoot, container, root);
                        }
                        else if (!isTextareaElement(childNode) &&
                            !isSVGElement(childNode) &&
                            !isSelectElement(childNode)) {
                            parseNodeTree(context, childNode, container, root);
                        }
                    }
                }
            }
        }
    };
    var createContainer = function (context, element) {
        if (isImageElement(element)) {
            return new ImageElementContainer(context, element);
        }
        if (isCanvasElement(element)) {
            return new CanvasElementContainer(context, element);
        }
        if (isSVGElement(element)) {
            return new SVGElementContainer(context, element);
        }
        if (isLIElement(element)) {
            return new LIElementContainer(context, element);
        }
        if (isOLElement(element)) {
            return new OLElementContainer(context, element);
        }
        if (isInputElement(element)) {
            return new InputElementContainer(context, element);
        }
        if (isSelectElement(element)) {
            return new SelectElementContainer(context, element);
        }
        if (isTextareaElement(element)) {
            return new TextareaElementContainer(context, element);
        }
        if (isIFrameElement(element)) {
            return new IFrameElementContainer(context, element);
        }
        return new ElementContainer(context, element);
    };
    var parseTree = function (context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function (node, container, root) {
        return (container.styles.isPositionedWithZIndex() ||
            container.styles.opacity < 1 ||
            container.styles.isTransformed() ||
            (isBodyElement(node) && root.styles.isTransparent()));
    };
    var createsStackingContext = function (styles) { return styles.isPositioned() || styles.isFloating(); };
    var isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
    var isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    var isHTMLElementNode = function (node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function (element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function (node) { return node.tagName === 'LI'; };
    var isOLElement = function (node) { return node.tagName === 'OL'; };
    var isInputElement = function (node) { return node.tagName === 'INPUT'; };
    var isHTMLElement = function (node) { return node.tagName === 'HTML'; };
    var isSVGElement = function (node) { return node.tagName === 'svg'; };
    var isBodyElement = function (node) { return node.tagName === 'BODY'; };
    var isCanvasElement = function (node) { return node.tagName === 'CANVAS'; };
    var isImageElement = function (node) { return node.tagName === 'IMG'; };
    var isIFrameElement = function (node) { return node.tagName === 'IFRAME'; };
    var isStyleElement = function (node) { return node.tagName === 'STYLE'; };
    var isScriptElement = function (node) { return node.tagName === 'SCRIPT'; };
    var isTextareaElement = function (node) { return node.tagName === 'TEXTAREA'; };
    var isSelectElement = function (node) { return node.tagName === 'SELECT'; };
    var isSlotElement = function (node) { return node.tagName === 'SLOT'; };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function (node) { return node.tagName.indexOf('-') > 0; };

    var CounterState = /** @class */ (function () {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function (name) {
            var counter = this.counters[name];
            if (counter && counter.length) {
                return counter[counter.length - 1];
            }
            return 1;
        };
        CounterState.prototype.getCounterValues = function (name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function (counters) {
            var _this = this;
            counters.forEach(function (counter) { return _this.counters[counter].pop(); });
        };
        CounterState.prototype.parse = function (style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) {
                counterIncrement.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    if (counter && entry.increment !== 0) {
                        canReset = false;
                        if (!counter.length) {
                            counter.push(1);
                        }
                        counter[Math.max(0, counter.length - 1)] += entry.increment;
                    }
                });
            }
            var counterNames = [];
            if (canReset) {
                counterReset.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    counterNames.push(entry.counter);
                    if (!counter) {
                        counter = _this.counters[entry.counter] = [];
                    }
                    counter.push(entry.reset);
                });
            }
            return counterNames;
        };
        return CounterState;
    }());
    var ROMAN_UPPER = {
        integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
        values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
    };
    var ARMENIAN = {
        integers: [
            9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70,
            60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'Ք',
            'Փ',
            'Ւ',
            'Ց',
            'Ր',
            'Տ',
            'Վ',
            'Ս',
            'Ռ',
            'Ջ',
            'Պ',
            'Չ',
            'Ո',
            'Շ',
            'Ն',
            'Յ',
            'Մ',
            'Ճ',
            'Ղ',
            'Ձ',
            'Հ',
            'Կ',
            'Ծ',
            'Խ',
            'Լ',
            'Ի',
            'Ժ',
            'Թ',
            'Ը',
            'Է',
            'Զ',
            'Ե',
            'Դ',
            'Գ',
            'Բ',
            'Ա'
        ]
    };
    var HEBREW = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20,
            19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'י׳',
            'ט׳',
            'ח׳',
            'ז׳',
            'ו׳',
            'ה׳',
            'ד׳',
            'ג׳',
            'ב׳',
            'א׳',
            'ת',
            'ש',
            'ר',
            'ק',
            'צ',
            'פ',
            'ע',
            'ס',
            'נ',
            'מ',
            'ל',
            'כ',
            'יט',
            'יח',
            'יז',
            'טז',
            'טו',
            'י',
            'ט',
            'ח',
            'ז',
            'ו',
            'ה',
            'ד',
            'ג',
            'ב',
            'א'
        ]
    };
    var GEORGIAN = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90,
            80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'ჵ',
            'ჰ',
            'ჯ',
            'ჴ',
            'ხ',
            'ჭ',
            'წ',
            'ძ',
            'ც',
            'ჩ',
            'შ',
            'ყ',
            'ღ',
            'ქ',
            'ფ',
            'ჳ',
            'ტ',
            'ს',
            'რ',
            'ჟ',
            'პ',
            'ო',
            'ჲ',
            'ნ',
            'მ',
            'ლ',
            'კ',
            'ი',
            'თ',
            'ჱ',
            'ზ',
            'ვ',
            'ე',
            'დ',
            'გ',
            'ბ',
            'ა'
        ]
    };
    var createAdditiveCounter = function (value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) {
            return createCounterText(value, fallback, suffix.length > 0);
        }
        return (symbols.integers.reduce(function (string, integer, index) {
            while (value >= integer) {
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix);
    };
    var createCounterStyleWithSymbolResolver = function (value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) {
                value--;
            }
            string = resolver(value) + string;
            value /= codePointRangeLength;
        } while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function (value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return ((value < 0 ? '-' : '') +
            (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
                return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
            }) +
                suffix));
    };
    var createCounterStyleFromSymbols = function (value, symbols, suffix) {
        if (suffix === void 0) { suffix = '. '; }
        var codePointRangeLength = symbols.length;
        return (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) { return symbols[Math.floor(codePoint % codePointRangeLength)]; }) + suffix);
    };
    var CJK_ZEROS = 1 << 0;
    var CJK_TEN_COEFFICIENTS = 1 << 1;
    var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
    var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
    var createCJKCounter = function (value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) {
            return createCounterText(value, 4 /* CJK_DECIMAL */, suffix.length > 0);
        }
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) {
            return numbers[0] + string;
        }
        for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
                string = numbers[coefficient] + string;
            }
            else if (coefficient > 1 ||
                (coefficient === 1 && digit === 0) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS)) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100) ||
                (coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS))) {
                string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            }
            else if (coefficient === 1 && digit > 0) {
                string = multipliers[digit - 1] + string;
            }
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
    var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
    var JAPANESE_NEGATIVE = 'マイナス';
    var KOREAN_NEGATIVE = '마이너스';
    var createCounterText = function (value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? '、' : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch (type) {
            case 0 /* DISC */:
                return '•' + spaceSuffix;
            case 1 /* CIRCLE */:
                return '◦' + spaceSuffix;
            case 2 /* SQUARE */:
                return '◾' + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */:
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */:
                return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
            case 6 /* LOWER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix);
            case 8 /* LOWER_GREEK */:
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */:
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */:
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */:
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */:
            case 49 /* UPPER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix);
            case 35 /* LOWER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 13 /* BENGALI */:
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */:
            case 30 /* KHMER */:
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */:
                return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */:
                return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */:
            case 48 /* TRAD_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */:
                return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */:
                return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */:
                return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */:
                return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */:
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */:
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */, defaultSuffix);
            case 21 /* GUJARATI */:
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */:
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */:
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */, defaultSuffix);
            case 23 /* HIRAGANA */:
                return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
            case 24 /* HIRAGANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
            case 27 /* KANNADA */:
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */:
                return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
            case 29 /* KATAKANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
            case 34 /* LAO */:
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */:
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */:
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */:
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */:
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */:
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */:
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */:
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */:
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */:
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };

    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ (function () {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) {
                throw new Error('Cloned element does not have an owner document');
            }
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function (ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) {
                return Promise.reject("Unable to find iframe window");
            }
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */
            var iframeLoad = iframeLoader(iframe).then(function () { return __awaiter(_this, void 0, void 0, function () {
                var onclone, referenceElement;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.scrolledElements.forEach(restoreNodeScroll);
                            if (cloneWindow) {
                                cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) &&
                                    (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                    this.context.logger.warn('Unable to restore scroll position for cloned document');
                                    this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                }
                            }
                            onclone = this.options.onclone;
                            referenceElement = this.clonedReferenceElement;
                            if (typeof referenceElement === 'undefined') {
                                return [2 /*return*/, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                            }
                            if (!(documentClone.fonts && documentClone.fonts.ready)) return [3 /*break*/, 2];
                            return [4 /*yield*/, documentClone.fonts.ready];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [3 /*break*/, 4];
                            return [4 /*yield*/, imagesReady(documentClone)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            if (typeof onclone === 'function') {
                                return [2 /*return*/, Promise.resolve()
                                        .then(function () { return onclone(documentClone, referenceElement); })
                                        .then(function () { return iframe; })];
                            }
                            return [2 /*return*/, iframe];
                    }
                });
            }); });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function (node) {
            if (isDebugging(node, 2 /* CLONE */)) {
                debugger;
            }
            if (isCanvasElement(node)) {
                return this.createCanvasClone(node);
            }
            if (isStyleElement(node)) {
                return this.createStyleClone(node);
            }
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') {
                    clone.loading = 'eager';
                }
            }
            if (isCustomElement(clone)) {
                return this.createCustomElementClone(clone);
            }
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function (node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function (node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function (css, rule) {
                        if (rule && typeof rule.cssText === 'string') {
                            return css + rule.cssText;
                        }
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            }
            catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') {
                    throw e;
                }
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function (canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                }
                catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) {
                        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    }
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) {
                                this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                            }
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function (clone, child, copyStyles) {
            if (!isElementNode(child) ||
                (!isScriptElement(child) &&
                    !child.hasAttribute(IGNORE_ATTRIBUTE) &&
                    (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child)))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
                    clone.appendChild(this.cloneNode(child, copyStyles));
                }
            }
        };
        DocumentCloner.prototype.cloneNode = function (node, copyStyles) {
            var _this = this;
            if (isTextNode(node)) {
                return document.createTextNode(node.data);
            }
            if (!node.ownerDocument) {
                return node.cloneNode(false);
            }
            var window = node.ownerDocument.defaultView;
            if (window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone_1 = this.createElementClone(node);
                clone_1.style.transitionProperty = 'none';
                var style = window.getComputedStyle(node);
                var styleBefore = window.getComputedStyle(node, ':before');
                var styleAfter = window.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone_1)) {
                    this.clonedReferenceElement = clone_1;
                }
                if (isBodyElement(clone_1)) {
                    createPseudoHideStyles(clone_1);
                }
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone_1, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) {
                    copyStyles = true;
                }
                for (var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling) {
                    if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                        var assignedNodes = child.assignedNodes();
                        if (assignedNodes.length) {
                            assignedNodes.forEach(function (assignedNode) { return _this.appendChildNode(clone_1, assignedNode, copyStyles); });
                        }
                    }
                    else {
                        this.appendChildNode(clone_1, child, copyStyles);
                    }
                }
                if (before) {
                    clone_1.insertBefore(before, clone_1.firstChild);
                }
                var after = this.resolvePseudoContent(node, clone_1, styleAfter, PseudoElementType.AFTER);
                if (after) {
                    clone_1.appendChild(after);
                }
                this.counters.pop(counters);
                if ((style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node)) ||
                    copyStyles) {
                    copyCSSStyles(style, clone_1);
                }
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone_1, node.scrollLeft, node.scrollTop]);
                }
                if ((isTextareaElement(node) || isSelectElement(node)) &&
                    (isTextareaElement(clone_1) || isSelectElement(clone_1))) {
                    clone_1.value = node.value;
                }
                return clone_1;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function (node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) {
                return;
            }
            var value = style.content;
            var document = clone.ownerDocument;
            if (!document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') {
                return;
            }
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function (token) {
                if (token.type === 0 /* STRING_TOKEN */) {
                    anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                }
                else if (token.type === 22 /* URL_TOKEN */) {
                    var img = document.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                }
                else if (token.type === 18 /* FUNCTION */) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) {
                            anonymousReplacedElement.appendChild(document.createTextNode(node.getAttribute(attr[0].value) || ''));
                        }
                    }
                    else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            anonymousReplacedElement.appendChild(document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    }
                    else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */ ? delim.value : '';
                            var text = counterStates
                                .map(function (value) { return createCounterText(value, counterType_1, false); })
                                .join(separator);
                            anonymousReplacedElement.appendChild(document.createTextNode(text));
                        }
                    }
                    else ;
                }
                else if (token.type === 20 /* IDENT_TOKEN */) {
                    switch (token.value) {
                        case 'open-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                            break;
                        case 'close-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                            break;
                        default:
                            // safari doesn't parse string tokens correctly because of lack of quotes
                            anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                    }
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE
                ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
                : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) {
                clone.className.baseValue += newClassName;
            }
            else {
                clone.className += newClassName;
            }
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function (container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }());
    var PseudoElementType;
    (function (PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function (ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function (img) {
        return new Promise(function (resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function (document) {
        return Promise.all([].slice.call(document.images, 0).map(imageReady));
    };
    var iframeLoader = function (iframe) {
        return new Promise(function (resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) {
                return reject("No window assigned for iframe");
            }
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function () {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function () {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function (style, target) {
        // Edge does not provide value for cssText
        for (var i = style.length - 1; i >= 0; i--) {
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) {
                target.style.setProperty(property, style.getPropertyValue(property));
            }
        }
        return target;
    };
    var serializeDoctype = function (doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) {
                str += doctype.name;
            }
            if (doctype.internalSubset) {
                str += doctype.internalSubset;
            }
            if (doctype.publicId) {
                str += "\"" + doctype.publicId + "\"";
            }
            if (doctype.systemId) {
                str += "\"" + doctype.systemId + "\"";
            }
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function (ownerDocument, x, y) {
        if (ownerDocument &&
            ownerDocument.defaultView &&
            (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x, y);
        }
    };
    var restoreNodeScroll = function (_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function (body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function (body, styles) {
        var document = body.ownerDocument;
        if (document) {
            var style = document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };

    var CacheStorage = /** @class */ (function () {
        function CacheStorage() {
        }
        CacheStorage.getOrigin = function (url) {
            var link = CacheStorage._link;
            if (!link) {
                return 'about:blank';
            }
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function (src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function (window) {
            CacheStorage._link = window.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }());
    var Cache = /** @class */ (function () {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function (src) {
            var result = Promise.resolve();
            if (this.has(src)) {
                return result;
            }
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function () {
                    // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function (src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) &&
                                !isSameOrigin &&
                                !isBlobImage(key) &&
                                typeof this._options.proxy === 'string' &&
                                FEATURES.SUPPORT_CORS_XHR &&
                                !useCORS;
                            if (!isSameOrigin &&
                                this._options.allowTaint === false &&
                                !isInlineImage(key) &&
                                !isBlobImage(key) &&
                                !useProxy &&
                                !useCORS) {
                                return [2 /*return*/];
                            }
                            src = key;
                            if (!useProxy) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.proxy(src)];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    var img = new Image();
                                    img.onload = function () { return resolve(img); };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) {
                                        img.crossOrigin = 'anonymous';
                                    }
                                    img.src = src;
                                    if (img.complete === true) {
                                        // Inline XML images may fail to parse, throwing an Error later on
                                        setTimeout(function () { return resolve(img); }, 500);
                                    }
                                    if (_this._options.imageTimeout > 0) {
                                        setTimeout(function () { return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image"); }, _this._options.imageTimeout);
                                    }
                                })];
                        case 3: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        Cache.prototype.has = function (key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function () {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function (src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) {
                throw new Error('No proxy defined');
            }
            var key = src.substring(0, 256);
            return new Promise(function (resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        if (responseType === 'text') {
                            resolve(xhr.response);
                        }
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function () { return resolve(reader_1.result); }, false);
                            reader_1.addEventListener('error', function (e) { return reject(e); }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    }
                    else {
                        reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                    }
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
                    xhr.responseType = responseType;
                }
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function () { return reject("Timed out (" + timeout_1 + "ms) proxying " + key); };
                }
                xhr.send();
            });
        };
        return Cache;
    }());
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function (src) { return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src); };
    var isInlineImage = function (src) { return INLINE_IMG.test(src); };
    var isInlineBase64Image = function (src) { return INLINE_BASE64.test(src); };
    var isBlobImage = function (src) { return src.substr(0, 4) === 'blob'; };
    var isSVG = function (src) { return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src); };

    var Vector = /** @class */ (function () {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function (deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }());

    var lerp = function (a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ (function () {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function (t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function (deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function () {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }());
    var isBezierCurve = function (path) { return path.type === 1 /* BEZIER_CURVE */; };

    var BoundCurves = /** @class */ (function () {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3, tlh - (borderLeftWidth * 2) / 3, tlv - (borderTopWidth * 2) / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.topRightBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + (borderTopWidth * 2) / 3, trh - (borderRightWidth * 2) / 3, trv - (borderTopWidth * 2) / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.bottomRightBorderDoubleInnerBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - (borderRightWidth * 2) / 3, brv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.bottomLeftBorderDoubleInnerBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + leftHeight, blh - (borderLeftWidth * 2) / 3, blv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.topLeftBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT)
                    : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }());
    var CORNER;
    (function (CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function (x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch (position) {
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function (curves) {
        return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
    };
    var calculateContentBoxPath = function (curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function (curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };

    var TransformEffect = /** @class */ (function () {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return TransformEffect;
    }());
    var ClipEffect = /** @class */ (function () {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */;
        }
        return ClipEffect;
    }());
    var OpacityEffect = /** @class */ (function () {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return OpacityEffect;
    }());
    var isTransformEffect = function (effect) {
        return effect.type === 0 /* TRANSFORM */;
    };
    var isClipEffect = function (effect) { return effect.type === 1 /* CLIP */; };
    var isOpacityEffect = function (effect) { return effect.type === 2 /* OPACITY */; };

    var equalPath = function (a, b) {
        if (a.length === b.length) {
            return a.some(function (v, i) { return v === b[i]; });
        }
        return false;
    };
    var transformPath = function (path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function (point, index) {
            switch (index) {
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };

    var StackingContext = /** @class */ (function () {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }());
    var ElementPaint = /** @class */ (function () {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) {
                this.effects.push(new OpacityEffect(this.container.styles.opacity));
            }
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */));
                }
            }
        }
        ElementPaint.prototype.getEffects = function (target) {
            var inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while (parent) {
                var croplessEffects = parent.effects.filter(function (effect) { return !isClipEffect(effect); });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */ || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) {
                            effects.unshift(new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                        }
                    }
                }
                else {
                    effects.unshift.apply(effects, croplessEffects);
                }
                parent = parent.parent;
            }
            return effects.filter(function (effect) { return contains(effect.target, target); });
        };
        return ElementPaint;
    }());
    var parseStackTree = function (parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function (child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */);
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */);
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
                listItems.push(paintContainer);
            }
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function (current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            }
                            else if (index_1 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    }
                    else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function (current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            }
                            else if (index_2 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    }
                    else {
                        parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                    }
                }
                else {
                    if (child.styles.isFloating()) {
                        parentStack.nonPositionedFloats.push(stack);
                    }
                    else {
                        parentStack.nonPositionedInlineLevel.push(stack);
                    }
                }
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            }
            else {
                if (child.styles.isInlineLevel()) {
                    stackingContext.inlineLevel.push(paintContainer);
                }
                else {
                    stackingContext.nonInlineLevel.push(paintContainer);
                }
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
                processListItems(child, listOwnerItems);
            }
        });
    };
    var processListItems = function (owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for (var i = 0; i < elements.length; i++) {
            var item = elements[i];
            if (item.container instanceof LIElementContainer &&
                typeof item.container.value === 'number' &&
                item.container.value !== 0) {
                numbering = item.container.value;
            }
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function (container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };

    var parsePathForBorder = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function (outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        return path;
    };
    var createPathFromCurves = function (outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        if (isBezierCurve(inner2)) {
            path.push(inner2.subdivide(0.5, true).reverse());
        }
        else {
            path.push(inner2);
        }
        if (isBezierCurve(inner1)) {
            path.push(inner1.subdivide(0.5, false).reverse());
        }
        else {
            path.push(inner1);
        }
        return path;
    };

    var paddingBox = function (element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function (element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };

    var calculateBackgroundPositioningArea = function (backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundOrigin === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function (backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundClip === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function (container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [path, offsetX, offsetY, sizeWidth, sizeHeight];
    };
    var isAuto = function (token) { return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO; };
    var hasIntrinsicValue = function (value) { return typeof value === 'number'; };
    var calculateBackgroundSize = function (size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) {
            return [0, 0];
        }
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
        }
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER)
                    ? [bounds.width, bounds.width / intrinsicProportion]
                    : [bounds.height * intrinsicProportion, bounds.height];
            }
            return [bounds.width, bounds.height];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) {
                return [intrinsicWidth, intrinsicHeight];
            }
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
                return [bounds.width, bounds.height];
            }
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth
                    ? intrinsicWidth
                    : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight
                    ? intrinsicHeight
                    : intrinsicWidth / intrinsicProportion;
                return [width_1, height_1];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [width_2, height_2];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) {
                width_3 = getAbsoluteValue(first, bounds.width);
            }
            else if (isLengthPercentage(second)) {
                height_3 = getAbsoluteValue(second, bounds.height);
            }
            if (isAuto(first)) {
                width_3 = height_3 * intrinsicProportion;
            }
            else if (!second || isAuto(second)) {
                height_3 = width_3 / intrinsicProportion;
            }
            return [width_3, height_3];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) {
            width = getAbsoluteValue(first, bounds.width);
        }
        else if (second && isLengthPercentage(second)) {
            height = getAbsoluteValue(second, bounds.height);
        }
        if (width !== null && (!second || isAuto(second))) {
            height =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (width / intrinsicWidth) * intrinsicHeight
                    : bounds.height;
        }
        if (height !== null && isAuto(first)) {
            width =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (height / intrinsicHeight) * intrinsicWidth
                    : bounds.width;
        }
        if (width !== null && height !== null) {
            return [width, height];
        }
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function (values, index) {
        var value = values[index];
        if (typeof value === 'undefined') {
            return values[0];
        }
        return value;
    };
    var calculateBackgroundRepeatPath = function (repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch (repeat) {
            case 2 /* REPEAT_X */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };

    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ (function () {
        function FontMetrics(document) {
            this._data = {};
            this._document = document;
        }
        FontMetrics.prototype.parseMetrics = function (fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return { baseline: baseline, middle: middle };
        };
        FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') {
                this._data[key] = this.parseMetrics(fontFamily, fontSize);
            }
            return this._data[key];
        };
        return FontMetrics;
    }());

    var Renderer = /** @class */ (function () {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }());

    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ (function (_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function (effects) {
            var _this = this;
            while (this._activeEffects.length) {
                this.popEffect();
            }
            effects.forEach(function (effect) { return _this.applyEffect(effect); });
        };
        CanvasRenderer.prototype.applyEffect = function (effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) {
                this.ctx.globalAlpha = effect.opacity;
            }
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function () {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var styles;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderStackContent(stack)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            if (!paint.container.styles.isVisible()) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.renderNodeContent(paint)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function (text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) {
                this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            }
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function (left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function (styles) {
            var fontVariant = styles.fontVariant
                .filter(function (variant) { return variant === 'normal' || variant === 'small-caps'; })
                .join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize)
                ? "" + styles.fontSize.number + styles.fontSize.unit
                : styles.fontSize.number + "px";
            return [
                [styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function (text, styles) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function (_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */ ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function (text) {
                        paintOrder.forEach(function (paintOrderLayer) {
                            switch (paintOrderLayer) {
                                case 0 /* FILL */:
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows
                                            .slice(0)
                                            .reverse()
                                            .forEach(function (textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function (textDecorationLine) {
                                            switch (textDecorationLine) {
                                                case 1 /* UNDERLINE */:
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */:
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */:
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */:
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function (container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderTextNode(child, styles)];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, this.context.cache.match(container.src)];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 8];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [3 /*break*/, 8];
                        case 8:
                            if (container instanceof CanvasElementContainer) {
                                this.renderReplacedElement(container, curves, container.canvas);
                            }
                            if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([9, 11, , 12]);
                            return [4 /*yield*/, this.context.cache.match(container.svg)];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 12];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [3 /*break*/, 12];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [3 /*break*/, 14];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [4 /*yield*/, iframeRenderer.render(container.tree)];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) {
                                this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            }
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                                else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch (container.styles.textAlign) {
                                    case 1 /* CENTER */:
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */:
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */)) return [3 /*break*/, 20];
                            if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */)) return [3 /*break*/, 18];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([15, 17, , 18]);
                            return [4 /*yield*/, this.context.cache.match(url)];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [3 /*break*/, 18];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [3 /*break*/, 18];
                        case 18: return [3 /*break*/, 20];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function (_p) {
                    switch (_p.label) {
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element)];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3 /*break*/, 5];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [3 /*break*/, 2];
                        case 5: 
                        // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                        return [4 /*yield*/, this.renderNodeContent(stack.element)];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [3 /*break*/, 10];
                            child = _c[_b];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [3 /*break*/, 7];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [3 /*break*/, 14];
                            child = _e[_d];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [3 /*break*/, 11];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [3 /*break*/, 18];
                            child = _g[_f];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [3 /*break*/, 15];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [3 /*break*/, 22];
                            child = _j[_h];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [3 /*break*/, 19];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [3 /*break*/, 26];
                            child = _l[_k];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [3 /*break*/, 23];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [3 /*break*/, 30];
                            child = _o[_m];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [3 /*break*/, 27];
                        case 30: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function (paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function (paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function (paths) {
            var _this = this;
            paths.forEach(function (point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) {
                    _this.ctx.moveTo(start.x, start.y);
                }
                else {
                    _this.ctx.lineTo(start.x, start.y);
                }
                if (isBezierCurve(point)) {
                    _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                }
            });
        };
        CanvasRenderer.prototype.renderRepeat = function (path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function (image, width, height) {
            var _a;
            if (image.width === width && image.height === height) {
                return image;
            }
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function (container) {
            return __awaiter(this, void 0, void 0, function () {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function (backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function (_h) {
                                    switch (_h.label) {
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */)) return [3 /*break*/, 5];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this_1.context.cache.match(url)];
                                        case 2:
                                            image = _h.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [3 /*break*/, 4];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [3 /*break*/, 6];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [null, null, null]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function (colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            }
                                            else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function (colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    }
                                                    else {
                                                        this_1.ctx.fill();
                                                    }
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            backgroundImage = _a[_i];
                            return [5 /*yield**/, _loop_1(backgroundImage)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function (color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function (color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                var outerPaths, innerPaths;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(width < 3)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderSolidBorder(color, side, curvePoints)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                { style: styles.borderTopStyle, color: styles.borderTopColor, width: styles.borderTopWidth },
                                { style: styles.borderRightStyle, color: styles.borderRightColor, width: styles.borderRightWidth },
                                { style: styles.borderBottomStyle, color: styles.borderBottomColor, width: styles.borderBottomWidth },
                                { style: styles.borderLeftStyle, color: styles.borderLeftColor, width: styles.borderLeftWidth }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [4 /*yield*/, this.renderBackgroundImage(paint.container)];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow
                                .slice(0)
                                .reverse()
                                .forEach(function (shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                }
                                else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [3 /*break*/, 13];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */ && !isTransparent(border.color) && border.width > 0)) return [3 /*break*/, 11];
                            if (!(border.style === 2 /* DASHED */)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */)];
                        case 4:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */)) return [3 /*break*/, 7];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */)];
                        case 6:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */)) return [3 /*break*/, 9];
                            return [4 /*yield*/, this.renderDoubleBorder(border.color, border.width, side, paint.curves)];
                        case 8:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 9: return [4 /*yield*/, this.renderSolidBorder(border.color, side, paint.curves)];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [3 /*break*/, 3];
                        case 13: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function (color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function () {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function (_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    }
                    else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    }
                    else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) {
                        length = Math.abs(startX - endX);
                    }
                    else {
                        length = Math.abs(startY - endY);
                    }
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */) {
                        this.formatPath(strokePaths);
                    }
                    else {
                        this.formatPath(boxPaths.slice(0, 2));
                    }
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) {
                        useLineDash = false;
                    }
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    }
                    else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength =
                            maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace)
                                ? minSpace
                                : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */) {
                            this.ctx.setLineDash([0, dashLength + spaceLength]);
                        }
                        else {
                            this.ctx.setLineDash([dashLength, spaceLength]);
                        }
                    }
                    if (style === 3 /* DOTTED */) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    }
                    else {
                        this.ctx.lineWidth = width * 2 + 1.1;
                    }
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var stack;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [4 /*yield*/, this.renderStack(stack)];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer));
    var isTextInputElement = function (container) {
        if (container instanceof TextareaElementContainer) {
            return true;
        }
        else if (container instanceof SelectElementContainer) {
            return true;
        }
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
            return true;
        }
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function (clip, curves) {
        switch (clip) {
            case 0 /* BORDER_BOX */:
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */:
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */:
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function (textAlign) {
        switch (textAlign) {
            case 1 /* CENTER */:
                return 'center';
            case 2 /* RIGHT */:
                return 'right';
            case 0 /* LEFT */:
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = ['-apple-system', 'system-ui'];
    var fixIOSSystemFonts = function (fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent)
            ? fontFamilies.filter(function (fontFamily) { return iOSBrokenFonts.indexOf(fontFamily) === -1; })
            : fontFamilies;
    };

    var ForeignObjectRenderer = /** @class */ (function (_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var svg, img;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [4 /*yield*/, loadSerializedSVG(svg)];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer));
    var loadSerializedSVG = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };

    var Logger = /** @class */ (function () {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') {
                    // eslint-disable-next-line no-console
                    console.debug.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.prototype.getTime = function () {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
                    // eslint-disable-next-line no-console
                    console.info.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') {
                    // eslint-disable-next-line no-console
                    console.warn.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') {
                    // eslint-disable-next-line no-console
                    console.error.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.instances = {};
        return Logger;
    }());

    var Context = /** @class */ (function () {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({ id: this.instanceName, enabled: options.logging });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }());

    var html2canvas = function (element, options) {
        if (options === void 0) { options = {}; }
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') {
        CacheStorage.setContext(window);
    }
    var renderElement = function (element, opts) { return __awaiter(void 0, void 0, void 0, function () {
        var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        return __generator(this, function (_u) {
            switch (_u.label) {
                case 0:
                    if (!element || typeof element !== 'object') {
                        return [2 /*return*/, Promise.reject('Invalid element provided as first argument')];
                    }
                    ownerDocument = element.ownerDocument;
                    if (!ownerDocument) {
                        throw new Error("Element is not attached to a Document");
                    }
                    defaultView = ownerDocument.defaultView;
                    if (!defaultView) {
                        throw new Error("Document is not attached to a Window");
                    }
                    resourceOptions = {
                        allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                        imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                        proxy: opts.proxy,
                        useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                    };
                    contextOptions = __assign({ logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true, cache: opts.cache }, resourceOptions);
                    windowOptions = {
                        windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                        windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                        scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                        scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                    };
                    windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                    context = new Context(contextOptions, windowBounds);
                    foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                    cloneOptions = {
                        allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                        onclone: opts.onclone,
                        ignoreElements: opts.ignoreElements,
                        inlineImages: foreignObjectRendering,
                        copyStyles: foreignObjectRendering
                    };
                    context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                    documentCloner = new DocumentCloner(context, element, cloneOptions);
                    clonedElement = documentCloner.clonedReferenceElement;
                    if (!clonedElement) {
                        return [2 /*return*/, Promise.reject("Unable to find element in cloned iframe")];
                    }
                    return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)];
                case 1:
                    container = _u.sent();
                    _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement)
                        ? parseDocumentSize(clonedElement.ownerDocument)
                        : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                    backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                    renderOptions = {
                        canvas: opts.canvas,
                        backgroundColor: backgroundColor,
                        scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                        x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                        y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                        width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                        height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                    };
                    if (!foreignObjectRendering) return [3 /*break*/, 3];
                    context.logger.debug("Document cloned, using foreign object rendering");
                    renderer = new ForeignObjectRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(clonedElement)];
                case 2:
                    canvas = _u.sent();
                    return [3 /*break*/, 5];
                case 3:
                    context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                    context.logger.debug("Starting DOM parsing");
                    root = parseTree(context, clonedElement);
                    if (backgroundColor === root.styles.backgroundColor) {
                        root.styles.backgroundColor = COLORS.TRANSPARENT;
                    }
                    context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                    renderer = new CanvasRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(root)];
                case 4:
                    canvas = _u.sent();
                    _u.label = 5;
                case 5:
                    if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                        if (!DocumentCloner.destroy(container)) {
                            context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                    }
                    context.logger.debug("Finished rendering");
                    return [2 /*return*/, canvas];
            }
        });
    }); };
    var parseBackgroundColor = function (context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement
            ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor)
            : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body
            ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor)
            : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string'
            ? parseColor(context, backgroundColorOverride)
            : backgroundColorOverride === null
                ? COLORS.TRANSPARENT
                : 0xffffffff;
        return element === ownerDocument.documentElement
            ? isTransparent(documentBackgroundColor)
                ? isTransparent(bodyBackgroundColor)
                    ? defaultBackgroundColor
                    : bodyBackgroundColor
                : documentBackgroundColor
            : defaultBackgroundColor;
    };

    return html2canvas;

})));
//# sourceMappingURL=html2canvas.js.map


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cb;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__iteratee_js__ = __webpack_require__(196);




// The function we call internally to generate a callback. It invokes
// `_.iteratee` if overridden, otherwise `baseIteratee`.
function cb(value, context, argCount) {
  if (__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].iteratee !== __WEBPACK_IMPORTED_MODULE_2__iteratee_js__["a" /* default */]) return __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].iteratee(value, context);
  return Object(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(value, context, argCount);
}


/***/ }),
/* 22 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = restArguments;
// Some functions take a variable number of arguments, or a few expected
// arguments at the beginning and then a variable number of values to operate
// on. This helper accumulates all remaining arguments past the function’s
// argument length (or an explicit `startIndex`), into an array that becomes
// the last argument. Similar to ES6’s "rest parameter".
function restArguments(func, startIndex) {
  startIndex = startIndex == null ? func.length - 1 : +startIndex;
  return function() {
    var length = Math.max(arguments.length - startIndex, 0),
        rest = Array(length),
        index = 0;
    for (; index < length; index++) {
      rest[index] = arguments[index + startIndex];
    }
    switch (startIndex) {
      case 0: return func.call(this, rest);
      case 1: return func.call(this, arguments[0], rest);
      case 2: return func.call(this, arguments[0], arguments[1], rest);
    }
    var args = Array(startIndex + 1);
    for (index = 0; index < startIndex; index++) {
      args[index] = arguments[index];
    }
    args[startIndex] = rest;
    return func.apply(this, args);
  };
}


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(11);


// If Underscore is called as a function, it returns a wrapped object that can
// be used OO-style. This wrapper holds altered versions of all functions added
// through `_.mixin`. Wrapped objects may be chained.
function _(obj) {
  if (obj instanceof _) return obj;
  if (!(this instanceof _)) return new _(obj);
  this._wrapped = obj;
}

_.VERSION = __WEBPACK_IMPORTED_MODULE_0__setup_js__["e" /* VERSION */];

// Extracts the result from a wrapped and chained object.
_.prototype.value = function() {
  return this._wrapped;
};

// Provide unwrapping proxies for some methods used in engine operations
// such as arithmetic and JSON stringification.
_.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

_.prototype.toString = function() {
  return String(this._wrapped);
};


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createSizePropertyCheck_js__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getLength_js__ = __webpack_require__(31);



// Internal helper for collection methods to determine whether a collection
// should be iterated as an array or as an object.
// Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
// Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createSizePropertyCheck_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__getLength_js__["a" /* default */]));


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1100), __esModule: true };

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(374);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(53)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(11);



var isFunction = Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Function');

// Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
// v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
var nodelist = __WEBPACK_IMPORTED_MODULE_1__setup_js__["p" /* root */].document && __WEBPACK_IMPORTED_MODULE_1__setup_js__["p" /* root */].document.childNodes;
if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
  isFunction = function(obj) {
    return typeof obj == 'function' || false;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shallowProperty_js__ = __webpack_require__(185);


// Internal helper to obtain the `length` property of an object.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__shallowProperty_js__["a" /* default */])('length'));


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1201), __esModule: true };

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(39);
var IE8_DOM_DEFINE = __webpack_require__(166);
var toPrimitive = __webpack_require__(114);
var dP = Object.defineProperty;

exports.f = __webpack_require__(29) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(7);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1251), __esModule: true };

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(6);
/* global CONFIG */


/* harmony default export */ __webpack_exports__["a"] = ({
  getDriverList: function getDriverList(VueApp, onDuty, isStaging, callback) {
    var self = this;
    var token = VueApp.$store.state.session.sessionToken;
    var request = {
      token: token,
      duty: onDuty ? 1 : 0

      // Page number and size
    };var pageNumber = VueApp.$store.state.dispatch.onDuty.pageNum;
    var pageSize = VueApp.$store.state.dispatch.onDuty.pageSize;
    if (!onDuty) {
      pageNumber = VueApp.$store.state.dispatch.offDuty.pageNum;
      pageSize = VueApp.$store.state.dispatch.offDuty.pageSize;
    }
    if (isStaging) {
      pageNumber = VueApp.$store.state.dispatch.staging.pageNum;
      pageSize = VueApp.$store.state.dispatch.staging.pageSize;
    }
    request.pageNum = pageNumber;
    request.pageSize = pageSize;

    // Sorting
    var order = VueApp.$store.state.dispatch.onDuty.order;
    var asc = VueApp.$store.state.dispatch.onDuty.asc;
    if (!onDuty) {
      order = VueApp.$store.state.dispatch.offDuty.order;
      asc = VueApp.$store.state.dispatch.offDuty.asc;
    }
    if (isStaging) {
      order = VueApp.$store.state.dispatch.staging.order;
      asc = VueApp.$store.state.dispatch.staging.asc;
    }
    request.order = order;
    request.orderAsc = asc ? 1 : 0;

    // Search field
    if (VueApp.$store.state.dispatch.driverListFilters.search !== '') {
      request.search = VueApp.$store.state.dispatch.driverListFilters.search;
    }

    // Service Type filter
    if (VueApp.$store.state.dispatch.driverListFilters.serviceTypes.length > 0 && VueApp.$store.state.dispatch.driverListFilters.serviceTypes.length < 5) {
      request.serviceType = VueApp.$store.state.dispatch.driverListFilters.serviceTypes;
    }

    VueApp.$sdk.get('/provider', request, function (r) {
      if (r.error) {
        console.log(r);
        callback(r);
        return;
      }

      var result = [];
      for (var i = 0; i < r.list.length; i++) {
        result.push(self.formatData(r.list[i], false, VueApp));
      }

      var listMutation = 'dispatch/setOnDutyDrivers';
      var pageNumMutation = 'dispatch/setOnDutyPageNumber';
      var totalPageMutation = 'dispatch/setOnDutyTotalPages';
      if (!onDuty) {
        listMutation = 'dispatch/setOffDutyDrivers';
        pageNumMutation = 'dispatch/setOffDutyPageNumber';
        totalPageMutation = 'dispatch/setOffDutyTotalPages';
      }
      if (isStaging) {
        listMutation = 'dispatch/setStagingDrivers';
        pageNumMutation = 'dispatch/setStagingPageNumber';
        totalPageMutation = 'dispatch/setStagingTotalPages';
      }
      VueApp.$store.commit(listMutation, result);
      VueApp.$store.commit(pageNumMutation, parseInt(r.paging.pageNum));
      VueApp.$store.commit(totalPageMutation, r.paging.totalItems);
      callback(r);
    });
  },
  getDriverListV2: function getDriverListV2(VueApp, data, callback) {
    var self = this;
    var token = VueApp.$store.state.session.sessionToken;
    var request = {
      token: token,
      duty: data.onDuty ? 1 : 0

      // Page number and size
    };var pageNumber = VueApp.$store.state.dispatch.onDuty.pageNum;
    var pageSize = VueApp.$store.state.dispatch.onDuty.pageSize;
    if (!data.onDuty) {
      pageNumber = VueApp.$store.state.dispatch.offDuty.pageNum;
      pageSize = VueApp.$store.state.dispatch.offDuty.pageSize;
    }
    if (data.isStaging) {
      pageNumber = VueApp.$store.state.dispatch.staging.pageNum;
      pageSize = VueApp.$store.state.dispatch.staging.pageSize;
    }
    request.pageNum = pageNumber;
    request.pageSize = pageSize;

    // Sorting
    var order = VueApp.$store.state.dispatch.onDuty.order;
    var asc = VueApp.$store.state.dispatch.onDuty.asc;
    if (!data.onDuty) {
      order = VueApp.$store.state.dispatch.offDuty.order;
      asc = VueApp.$store.state.dispatch.offDuty.asc;
    }
    if (data.isStaging) {
      order = VueApp.$store.state.dispatch.staging.order;
      asc = VueApp.$store.state.dispatch.staging.asc;
    }
    request.order = order;
    request.orderAsc = asc ? 1 : 0;

    // Search field
    if (VueApp.$store.state.dispatch.driverListFilters.search !== '') {
      request.search = VueApp.$store.state.dispatch.driverListFilters.search;
    }

    // Service Type filter
    request.serviceTypeId = VueApp.$store.state.dispatch.serviceFilter.list;
    // if (VueApp.$store.state.dispatch.serviceFilter.list.length) {
    // if (data.services.length) {
    // }

    VueApp.$sdk.post('/provider', request, function (r) {
      VueApp.$store.commit('dispatch/setDriversTotal', {
        field: data.onDuty ? 'onDuty' : 'offDuty',
        value: 0
      });
      if (r.error) {
        console.log(r);
        callback(r);
        return;
      }

      var result = [];
      for (var i = 0; i < r.list.length; i++) {
        result.push(self.formatData(r.list[i], false, VueApp));
      }

      var listMutation = 'dispatch/setOnDutyDrivers';
      var pageNumMutation = 'dispatch/setOnDutyPageNumber';
      var totalPageMutation = 'dispatch/setOnDutyTotalPages';
      if (!data.onDuty) {
        listMutation = 'dispatch/setOffDutyDrivers';
        pageNumMutation = 'dispatch/setOffDutyPageNumber';
        totalPageMutation = 'dispatch/setOffDutyTotalPages';
      }
      if (data.isStaging) {
        listMutation = 'dispatch/setStagingDrivers';
        pageNumMutation = 'dispatch/setStagingPageNumber';
        totalPageMutation = 'dispatch/setStagingTotalPages';
      }
      VueApp.$store.commit(listMutation, result);
      VueApp.$store.commit(pageNumMutation, parseInt(r.paging.pageNum));
      VueApp.$store.commit(totalPageMutation, r.paging.totalItems);
      VueApp.$store.commit('dispatch/setDriversTotal', {
        field: data.onDuty ? 'onDuty' : 'offDuty',
        value: r.paging.totalItems
      });
      callback(r);
    });
  },
  getOnDutyDrivers: function getOnDutyDrivers(VueApp) {
    var self = this;
    var token = VueApp.$store.state.session.sessionToken;
    var request = {
      token: token,
      duty: 1,
      pageNum: VueApp.$store.state.dispatch.onDuty.pageNum,
      pageSize: VueApp.$store.state.dispatch.onDuty.pageSize,
      order: VueApp.$store.state.dispatch.onDuty.order,
      orderAsc: VueApp.$store.state.dispatch.onDuty.asc ? 1 : 0
    };
    VueApp.$store.commit('dispatch/setOnDutyLoading', true);
    VueApp.$store.commit('dispatch/setDriversTotal', {
      field: 'onDuty',
      value: 0
    });
    VueApp.$sdk.get('/provider', request, function (r) {
      VueApp.$store.commit('dispatch/setOnDutyLoading', false);
      if (r.error) {
        VueApp.$store.commit('dispatch/setServiceCount', {
          shared: 0,
          opoli: 0,
          black: 0,
          suv: 0,
          shuttle: 0
        });
        console.log(r);
        return;
      }

      var result = [];
      for (var i = 0; i < r.list.length; i++) {
        result.push(self.formatData(r.list[i], false, VueApp));
      }

      VueApp.$store.commit('dispatch/setServiceCount', r.services);
      VueApp.$store.commit('dispatch/setOnDutyDrivers', result);
      VueApp.$store.commit('dispatch/setDriversTotal', {
        field: 'onDuty',
        value: r.paging.totalItems
      });
      if (r.paging) {
        VueApp.$store.commit('dispatch/setOnDutyTotalPages', r.paging.totalItems);
      }
    });
  },
  getOffDutyDrivers: function getOffDutyDrivers(VueApp) {
    var self = this;
    var token = VueApp.$store.state.session.sessionToken;
    var request = {
      token: token,
      duty: 0,
      pageNum: VueApp.$store.state.dispatch.offDuty.pageNum,
      pageSize: VueApp.$store.state.dispatch.offDuty.pageSize,
      order: VueApp.$store.state.dispatch.offDuty.order,
      orderAsc: VueApp.$store.state.dispatch.offDuty.asc ? 1 : 0
    };
    VueApp.$store.commit('dispatch/setOffDutyLoading', true);
    VueApp.$store.commit('dispatch/setDriversTotal', {
      field: 'offDuty',
      value: 0
    });
    VueApp.$sdk.get('/provider', request, function (r) {
      VueApp.$store.commit('dispatch/setOffDutyLoading', false);
      if (r.error) {
        console.log(r);
        return;
      }

      var result = [];
      for (var i = 0; i < r.list.length; i++) {
        result.push(self.formatData(r.list[i], false, VueApp));
      }

      VueApp.$store.commit('dispatch/setOffDutyDrivers', result);
      VueApp.$store.commit('dispatch/setOffDutyTotalPages', r.paging.totalItems);
      VueApp.$store.commit('dispatch/setDriversTotal', {
        field: 'offDuty',
        value: r.paging.totalItems
      });
    });
  },
  getStagingDrivers: function getStagingDrivers(VueApp) {
    var filterIndex = VueApp.$store.state.reservation.selectedFilter;
    if (filterIndex < 0 || filterIndex === 'custom') {
      VueApp.$store.commit('dispatch/resetStagingDriver');
      return;
    }

    var filter = VueApp.$store.state.reservation.reservationFilters[filterIndex];
    var filterStagingLotIds = filter.stagingLotIds;

    if (!Array.isArray(filterStagingLotIds)) {
      VueApp.$store.commit('dispatch/resetStagingDriver');
      return;
    }

    var stagingLotIds = [];
    for (var i = 0; i < filterStagingLotIds.length; i++) {
      var id = filterStagingLotIds[i];
      if (id === '') {
        continue;
      }

      stagingLotIds.push(parseInt(id));
    }

    if (stagingLotIds.length === 0) {
      VueApp.$store.commit('dispatch/resetStagingDriver');
      return;
    }

    var self = this;
    var request = {
      token: VueApp.$store.state.session.sessionToken,
      stagingLotGeofenceId: stagingLotIds,
      duty: 1,
      pageNum: VueApp.$store.state.dispatch.staging.pageNum,
      pageSize: VueApp.$store.state.dispatch.staging.pageSize,
      order: VueApp.$store.state.dispatch.staging.order,
      orderAsc: VueApp.$store.state.dispatch.staging.asc ? 1 : 0
    };

    VueApp.$store.commit('dispatch/setStagingLoading', true);
    VueApp.$store.commit('dispatch/setDriversTotal', {
      field: 'staging',
      value: 0
    });
    VueApp.$sdk.get('/provider', request, function (r) {
      VueApp.$store.commit('dispatch/setStagingLoading', false);
      if (r.error) {
        // TODO: process error
        VueApp.$store.commit('dispatch/resetStagingDriver');
        console.log(r);
        return;
      }
      VueApp.$store.commit('dispatch/setDriversTotal', {
        field: 'staging',
        value: r.paging.totalItems
      });

      var result = [];
      for (var _i = 0; _i < r.list.length; _i++) {
        result.push(self.formatData(r.list[_i], false, VueApp));
      }

      if (result.length <= 0) {
        VueApp.$store.commit('dispatch/resetStagingDriver');
        return;
      }

      VueApp.$store.commit('dispatch/setStagingDrivers', result);
      if (r.paging) {
        VueApp.$store.commit('dispatch/setStagingTotalPages', r.paging.totalItems);
      }
    });
  },
  updateDriverLists: function updateDriverLists(VueApp, driverId, onDuty) {
    var self = this;
    self.getDriver(VueApp, driverId, function (r) {
      if (r.error) {
        return;
      }

      var driver = self.formatData(r, true, VueApp);
      VueApp.$store.commit('dispatch/removeFromOnDutyDrivers', driver.id);
      VueApp.$store.commit('dispatch/removeFromOffDutyDrivers', driver.id);
      if (onDuty) {
        VueApp.$store.commit('dispatch/addToOnDutyDrivers', driver);
      } else {
        VueApp.$store.commit('dispatch/addToOffDutyDrivers', driver);
      }
      self.getStagingDrivers(VueApp);
    });
  },
  updateDriverStatus: function updateDriverStatus(VueApp, driverId) {
    var self = this;
    self.getDriver(VueApp, driverId, function (r) {
      if (r.error) {
        return;
      }

      var driver = self.formatData(r, false, VueApp);
      VueApp.$store.commit('dispatch/removeFromOnDutyDrivers', driver.id);
      VueApp.$store.commit('dispatch/removeFromOffDutyDrivers', driver.id);
      if (r.duty) {
        VueApp.$store.commit('dispatch/addToOnDutyDrivers', driver);
      } else {
        VueApp.$store.commit('dispatch/addToOffDutyDrivers', driver);
      }
      self.getStagingDrivers(VueApp);
    });
  },
  getDriver: function getDriver(VueApp, driverId, callback) {
    VueApp.$sdk.get('/provider/' + driverId, {
      token: VueApp.$store.state.session.sessionToken
    }, callback);
  },
  getNearbyDrivers: function getNearbyDrivers(VueApp, request, callback) {
    var processResponse = function processResponse(r) {};

    if (callback) {
      processResponse = callback;
    }

    VueApp.$sdk.post('/provider', request, processResponse);
  },
  getLocation: function getLocation(VueApp, driverID, callback) {
    VueApp.$sdk.get('/provider/' + driverID + '/tracks', {
      token: VueApp.$store.state.session.sessionToken
    }, callback);
  },
  getDriverInfo: function getDriverInfo(VueApp, driverID, callback) {
    var self = this;
    VueApp.$sdk.get('/provider/' + driverID, {
      token: VueApp.$store.state.session.sessionToken
    }, function (r) {
      if (r.error) {
        callback(r);
        return;
      }

      callback(self.formatData(r, false, VueApp));
    });
  },
  formatData: function formatData(item, isNew, VueApp) {
    var serviceTypes = [];

    if (Array.isArray(item.services)) {
      for (var i = 0; i < item.services.length; i++) {
        serviceTypes.push({
          label: __WEBPACK_IMPORTED_MODULE_0__services__["a" /* default */].getServiceName(item.services[i]),
          class: item.services[i].toLowerCase()
        });
      }
    } else {
      for (var property in item.services) {
        if (!item.services.hasOwnProperty(property) || property === 'undefined') {
          continue;
        }
        serviceTypes.push({
          label: __WEBPACK_IMPORTED_MODULE_0__services__["a" /* default */].getServiceName(property),
          class: property.toLowerCase()
        });
      }
    }

    var onBoard = 0;
    var status = 'Available';
    if (item.rsvp !== null) {
      onBoard = item.rsvp.passengers;
      status = 'Ongoing';
    }

    if (item.stagingLot !== null && item.rsvp === null) {
      status = 'On Staging';
    }

    var stagingLot = null;

    if (item.stagingLot) {
      stagingLot = {};
      stagingLot.id = item.stagingLot.geofenceId;
      stagingLot.name = item.stagingLot.geofenceName;
      stagingLot.services = [];

      var stagingServices = item.stagingLot.services;

      var _loop = function _loop(_i2) {
        var stagingService = stagingServices[_i2];
        var serviceName = '';
        if (!stagingService.serviceType) {
          var serviceList = VueApp.$store.state.services.list;
          var index = serviceList.findIndex(function (x) {
            return x.id === stagingService.serviceTypeId;
          });
          if (index > -1) {
            serviceName = serviceList[index].label;
          }
        } else {
          serviceName = stagingService.serviceType === 'suv' ? 'SUV' : stagingService.serviceType.toLowerCase().replace(/(^| )(\w)/g, function (s) {
            return s.toUpperCase();
          });
        }
        // let serviceName = stagingService.serviceType === 'suv' ? 'SUV' :
        // stagingService.serviceType.toLowerCase().replace(/(^| )(\w)/g, s => s.toUpperCase())
        var serviceStatus = stagingService.status === 'ondeck' ? 'OnDeck' : stagingService.status.toLowerCase().replace(/(^| )(\w)/g, function (s) {
          return s.toUpperCase();
        });

        stagingLot.services.push({
          serviceTypeId: stagingService.serviceTypeId,
          serviceName: serviceName,
          serviceClass: stagingService.serviceType,
          status: serviceStatus,
          priority: stagingService.priority
        });
      };

      for (var _i2 = 0; _i2 < stagingServices.length; _i2++) {
        _loop(_i2);
      }
    }

    var driverData = {
      id: item.ID,
      driverNum: item.driverNum ? item.providerAccountType.toUpperCase() + '-' + item.driverNum : item.ID,
      firstName: item.firstName,
      lastName: item.lastName,
      phone: item.phone,
      email: item.email,
      photoUrl: item.avatarUrl,
      licenseType: item.providerAccountType,
      serviceTypes: serviceTypes,
      businessName: item.businessName,
      capacity: item.vehicle.seatCapacity,
      onBoard: onBoard,
      status: status,
      isNew: isNew,
      coords: {
        lat: null,
        lng: null
      },
      vehicle: {
        name: item.vehicle.manufacturer + ' ' + item.vehicle.model,
        licensePlate: item.vehicle.licensePlate,
        photoUrl: item.vehicle.photoUrl ? item.vehicle.photoUrl : item.vehicle.photo
      },
      rsvp: item.rsvp,
      stagingLot: stagingLot,
      hasExpiringDoc: item.hasExpiringDoc,
      countryCode: item.countryCode,
      nationalNumber: item.nationalNumber
      // if (!CONFIG.useOldQuatation) {
      //   driverData.serviceTypes
      // }

    };return driverData;
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2e98acc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ellipsis_vue__ = __webpack_require__(1236);
function injectStyle (ssrContext) {
  __webpack_require__(1234)
}
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a2e98acc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2e98acc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ellipsis_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(36);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(100);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(374);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import moment from 'moment'

/* harmony default export */ __webpack_exports__["a"] = ({
  getBrands: function getBrands(VueApp, callback) {
    VueApp.$store.commit('brands/setLoading', true);
    VueApp.$sdk.get('/brand', {
      order: VueApp.$store.state.brands.order,
      orderAsc: VueApp.$store.state.brands.orderAsc
    }, function (res) {
      VueApp.$store.commit('brands/setLoading', false);
      if (!res.error && res.length) {
        VueApp.$store.commit('brands/setList', res);
      }
      callback(res);
    });
  },
  getWebforms: function getWebforms(VueApp, callback) {
    VueApp.$sdk.get('/geofences', {}, function (res) {
      // if (!res.error && res.length) {
      //   VueApp.$store.commit('brands/setList', res)
      // }
      callback(res);
    });
  },
  getExtraData: function getExtraData(VueApp, id, callback) {
    VueApp.$sdk.get('/brand/' + id + '/props', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      callback(res);
    });
  },
  getServices: function getServices(VueApp, id, callback) {
    VueApp.$sdk.get('/brand/' + id + '/services', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      callback(res);
    });
  },
  addBrand: function addBrand(VueApp, data, callback) {
    data.token = VueApp.$store.state.session.sessionToken;
    VueApp.$sdk.post('/brand/', data, function (res) {
      callback(res);
    });
  },
  updateBrand: function updateBrand(VueApp, data, callback) {
    data.token = VueApp.$store.state.session.sessionToken;
    VueApp.$sdk.post('/brand/' + data.id, data, function (res) {
      callback(res);
    });
  },
  updateService: function updateService(VueApp, data, callback) {
    VueApp.$sdk.post('/brand/' + data.id + '/services', {
      token: VueApp.$store.state.session.sessionToken,
      services: data.services
    }, function (res) {
      callback(res);
    });
  },
  updateProps: function updateProps(VueApp, data, callback) {
    VueApp.$sdk.post('/brand/' + data.id + '/props', {
      token: VueApp.$store.state.session.sessionToken,
      props: data.props
    }, function (res) {
      callback(res);
    });
  },
  deleteBrand: function deleteBrand(VueApp, id, callback) {
    VueApp.$sdk.delete('/brand/' + id, {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      callback(res);
    });
  }
});

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(76);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(33);
var createDesc = __webpack_require__(77);
module.exports = __webpack_require__(29) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(125);
var continents = __webpack_require__(791);
var regions = __webpack_require__(224);
var countriesAll = __webpack_require__(792);
var currenciesAll = __webpack_require__(793);
var languagesAll = __webpack_require__(794);
var lookup = __webpack_require__(795);

var getSymbol = __webpack_require__(796)

exports.continents = continents;
exports.regions = regions;

exports.countries = {
  all: countriesAll,
};

_.each(countriesAll, function (country) {
  // prefer assigned country codes over inactive ones
  var exportedAlpha2 = exports.countries[country.alpha2];
  if (!exportedAlpha2 || exportedAlpha2.status === 'deleted') {
    exports.countries[country.alpha2] = country;
  }

  var exportedAlpha3 = exports.countries[country.alpha3];
  if (!exportedAlpha3 || exportedAlpha3.status === 'deleted') {
    exports.countries[country.alpha3] = country;
  }
});

exports.currencies = {
  all: currenciesAll,
};

_.each(currenciesAll, function (currency) {
  //If the symbol isn't available, default to the currency code
  var symbol = getSymbol(currency.code);
  if (symbol == '?') {
    symbol = currency.code;
  }

  currency.symbol = symbol;
  exports.currencies[currency.code] = currency;
});

exports.languages = {
  all: languagesAll,
};

// Note that for the languages there are several entries with the same alpha3 -
// eg Dutch and Flemish. Not sure how to best deal with that - here whichever
// comes last wins.
_.each(languagesAll, function (language) {
  exports.languages[language.alpha2] = language;
  exports.languages[language.bibliographic] = language;
  exports.languages[language.alpha3] = language;
});

exports.lookup = lookup({
    countries: countriesAll,
    currencies: currenciesAll,
    languages: languagesAll
});

var callingCountries = {all: []};

var callingCodesAll = _.reduce(countriesAll, function (codes, country) {
  if (country.countryCallingCodes && country.countryCallingCodes.length) {
    callingCountries.all.push(country);

    callingCountries[country.alpha2] = country;
    callingCountries[country.alpha3] = country;

    _.each(country.countryCallingCodes, function (code) {
      if (codes.indexOf(code) == -1) {
        codes.push(code);
      }
    });
  }
  return codes;
}, []);

delete callingCountries['']; // remove empty alpha3s
exports.callingCountries = callingCountries;

callingCodesAll.sort(function (a, b) {
  var parse = function (str) { return parseInt(str) };
  var splitA = _.map(a.split(' '), parse);
  var splitB = _.map(b.split(' '), parse);

  if (splitA[0] < splitB[0]) {
    return -1;
  } else if (splitA[0] > splitB[0]) {
    return 1;
  } else {
    // Same - check split[1]
    if (splitA[1] === undefined && splitB[1] !== undefined) {
      return -1;
    } else if (splitA[1] !== undefined && splitB[1] === undefined) {
      return 1;
    } else if (splitA[1] < splitB[1]) {
      return -1;
    } else if (splitA[1] > splitB[1]) {
      return 1;
    } else {
      return 0;
    }
  }
});

exports.callingCodes = {
  all: callingCodesAll
};


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = has;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(11);


// Internal function to check whether `key` is an own property name of `obj`.
function has(obj, key) {
  return obj != null && __WEBPACK_IMPORTED_MODULE_0__setup_js__["i" /* hasOwnProperty */].call(obj, key);
}


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__featureToggle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__drivers__ = __webpack_require__(37);
/* global CONFIG */






/* harmony default export */ __webpack_exports__["a"] = ({
  getReservations: function getReservations(VueApp, callback, noFetching) {
    var self = this;
    var token = VueApp.$store.state.session.sessionToken;
    var selectedFilter = VueApp.$store.state.reservation.selectedFilter;
    var filter = null;
    if (selectedFilter > -1 && selectedFilter !== 'custom') {
      filter = VueApp.$store.state.reservation.reservationFilters[selectedFilter];
    }
    var search = VueApp.$store.state.reservation.reservationSearch;

    if (filter === null && search === '' && selectedFilter !== 'custom') {
      VueApp.$store.commit('dispatch/setNoDataFound', false);
      VueApp.$store.commit('dispatch/setRsvpInTable', []);
      return;
    }

    var currentPage = VueApp.$store.state.dispatch.rsvpPaging.currentPage;
    var request = {
      token: token,
      package: true,
      order: VueApp.$store.state.dispatch.rsvpSort.order,
      orderAsc: VueApp.$store.state.dispatch.rsvpSort.asc ? 1 : 0,
      search: VueApp.$store.state.reservation.reservationSearch,
      pageNum: currentPage,
      pageSize: VueApp.$store.state.dispatch.rsvpPaging.pageSize
    };

    if (filter !== null) {
      request['category'] = 'charged';
      request['filter'] = VueApp.$store.state.reservation.reservationFilters[selectedFilter];
    }

    if (selectedFilter === 'custom') {
      request['category'] = 'charged';
      request['filter'] = {
        ada: null,
        afterPickupMins: null,
        beforePickupMins: null,
        bidSource: null,
        defaultGeofenceId: null,
        defaultPickupAddress: null,
        defaultPickupType: null,
        geofenceIds: null,
        id: null,
        name: null,
        packageStatus: null,
        rsvpStatus: [],
        stagingLotIds: null,
        tripDirection: null
      };

      var rsvp = VueApp.$store.state.reservation;
      var filterDate = rsvp.date;
      if (filterDate.from && filterDate.to) {
        request['filter'].since = __WEBPACK_IMPORTED_MODULE_0_moment___default()(filterDate.from, 'MM/DD/YYYY hh:mmA').format('YYYY-MM-DD HH:mm:ss');
        request['filter'].until = __WEBPACK_IMPORTED_MODULE_0_moment___default()(filterDate.to, 'MM/DD/YYYY hh:mmA').format('YYYY-MM-DD HH:mm:ss');
      }
      request['filter'].serviceTypes = [];
      if (!{"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation) {
        request['filter'].serviceTypes = VueApp.$store.state.dispatch.filter.services;
      } else {
        for (var service in rsvp.service) {
          var storeService = '';
          switch (service) {
            case 'shared':
              storeService = 'Shared';
              break;
            case 'opoli':
              storeService = 'Opoli';
              break;
            case 'black':
              storeService = 'Black';
              break;
            case 'suv':
              storeService = 'SUV';
              break;
            case 'shuttle':
              storeService = 'Private Shuttle';
              break;
          }
          if (rsvp.service[service]) {
            request['filter'].serviceTypes.push(VueApp.$store.state.settings.serviceData[storeService].id);
          }
        }
      }

      for (var status in rsvp.status) {
        if (rsvp.status[status]) {
          request['filter'].rsvpStatus.push(status);
        }
      }
    }

    if (!noFetching) {
      VueApp.$store.commit('dispatch/setFetching', true);
    }
    VueApp.$sdk.post('/admin/rsvp/dispatch', request, function (r) {
      VueApp.$store.commit('dispatch/setFetching', false);
      if (r.error) {
        // TODO: process error
        console.log(r);
        if (callback) {
          callback(r);
        }
        return;
      }

      var results = [];
      for (var i = 0; i < r.list.length; i++) {
        var item = r.list[i];
        if (item.type === 'rsvp') {
          results.push(self.formatRsvp(VueApp, r.list[i].data));
          if (currentPage > 1) {
            VueApp.$store.commit('dispatch/pushRsvpInTable', self.formatRsvp(VueApp, r.list[i].data));
          }
          continue;
        }
        if (item.type === 'package') {
          results.push(self.formatPackage(VueApp, r.list[i].data));
          if (currentPage > 1) {
            VueApp.$store.commit('dispatch/pushRsvpInTable', self.formatPackage(VueApp, r.list[i].data));
          }
          continue;
        }
      }

      VueApp.$store.commit('dispatch/setNoDataFound', results.length <= 0);
      if (currentPage === 1) {
        VueApp.$store.commit('dispatch/setRsvpInTable', results);
      }
      VueApp.$store.commit('dispatch/setRsvpCurrentPage', parseInt(r.paging.pageNum));
      VueApp.$store.commit('dispatch/setRsvpTotalPages', parseInt(r.paging.totalItems));
      VueApp.$store.commit('dispatch/setDispatchTotal', r.paging.totalItems);
      if (callback) {
        callback(r);
      }
    });
  },
  initDispatchReservations: function initDispatchReservations(VueApp) {
    var self = this;
    VueApp.$sdk.get('/admin/filters', {
      order: 'filterName',
      token: VueApp.$store.state.session.sessionToken
    }, function (r) {
      if (r.error) {
        console.log(r);
        return;
      }
      VueApp.$store.commit('reservation/setReservationFilters', r.list);

      // Lost last selected filter
      var selectedFilterId = parseInt(VueApp.$plugins.storage.get('ADMIN_DISPATCH_FILTER'));
      if (isNaN(selectedFilterId)) {
        return;
      }
      var selectedFilter = -1;
      for (var i = 0; i < r.list.length; i++) {
        var filter = r.list[i];

        if (filter.id === selectedFilterId) {
          selectedFilter = i;
          break;
        }
      }
      if (selectedFilter >= 0) {
        VueApp.$store.commit('reservation/setSelectedFilter', selectedFilter);
        self.getReservations(VueApp);
        self.getLastSync(VueApp);
        __WEBPACK_IMPORTED_MODULE_3__drivers__["a" /* default */].getStagingDrivers(VueApp);
      }
    });
  },
  getLastSync: function getLastSync(VueApp) {
    VueApp.$sdk.get('/admin/rsvp/dispatch/sync', {
      token: VueApp.$store.state.session.sessionToken
    }, function (r) {
      if (r.error) {
        console.log(r);
        return;
      }
      VueApp.$store.commit('dispatch/setLastSync', __WEBPACK_IMPORTED_MODULE_0_moment___default()(r.time, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'));
    });
  },
  updateReservationTable: function updateReservationTable(VueApp, rsvpId) {
    var self = this;
    VueApp.$store.commit('dispatch/loadNewBookingNotification');
    VueApp.$sdk.get('/admin/rsvp/' + rsvpId, {
      token: VueApp.$store.state.session.sessionToken
    }, function (r) {
      VueApp.$store.commit('dispatch/hideNotificationNewBooking');
      if (r.error) {
        return;
      }

      var rsvp = null;
      if (r.package) {
        rsvp = self.formatPackage(VueApp, r);
      } else {
        rsvp = self.formatRsvp(VueApp, r);
      }
      VueApp.$store.commit('dispatch/removeRsvpInTable', rsvp);
      VueApp.$store.commit('dispatch/addRsvpInTable', rsvp);
    });
  },
  updateItemInTable: function updateItemInTable(VueApp, rsvp) {
    var self = this;

    var url = '/admin/rsvp/';
    if (rsvp.isPackage) {
      url = '/admin/package/';
    }
    VueApp.$sdk.get(url + rsvp.id, {
      token: VueApp.$store.state.session.sessionToken
    }, function (r) {
      if (r.error) {
        console.log(r);
        return;
      }

      var result = null;
      if (r.package) {
        result = self.formatPackage(VueApp, r);
      } else {
        result = self.formatRsvp(VueApp, r);
      }

      // update rsvp in map
      var rsvpInMap = VueApp.$store.state.dispatch.rsvpInMap;
      if (rsvpInMap.id !== null) {
        if (rsvpInMap.id === result.id && rsvpInMap.isPackage === result.isPackage) {
          VueApp.$store.commit('dispatch/setRsvpInMap', result);
        }
      }
      var token = VueApp.$store.state.session.sessionToken;
      var selectedFilter = VueApp.$store.state.reservation.selectedFilter;
      var filter = null;
      if (selectedFilter > -1) {
        filter = VueApp.$store.state.reservation.reservationFilters[selectedFilter];
      }
      var search = VueApp.$store.state.reservation.reservationSearch;

      if (filter === null && search === '') {
        VueApp.$store.commit('dispatch/addRsvpInTable', result);
        return;
      }

      var request = {
        token: token,
        package: true,
        search: VueApp.$store.state.reservation.reservationSearch,
        pageNum: VueApp.$store.state.dispatch.rsvpPaging.currentPage,
        pageSize: VueApp.$store.state.dispatch.rsvpPaging.pageSize
      };

      if (filter !== null) {
        request['category'] = 'charged';
        request['filter'] = VueApp.$store.state.reservation.reservationFilters[selectedFilter];
      }

      VueApp.$sdk.post('/admin/rsvp', request, function (r) {
        if (r.error) {
          return;
        }
        var results = [];
        for (var i = 0; i < r.list.length; i++) {
          var item = r.list[i];
          if (item.type === 'rsvp') {
            results.push(self.formatRsvp(VueApp, r.list[i].data));
            continue;
          }
          if (item.type === 'package') {
            results.push(self.formatPackage(VueApp, r.list[i].data));
            continue;
          }
        }

        for (var _i = 0; _i < results.length; _i++) {
          if (result.isPackage === results[_i].isPackage && result.id === results[_i].id) {
            VueApp.$store.commit('dispatch/removeRsvpInTable', result);
            VueApp.$store.commit('dispatch/addRsvpInTable', result);
            break;
          }
        }
      });
    });
  },
  formatRsvp: function formatRsvp(VueApp, item) {
    var driver = null;
    if (item.provider.ID !== null) {
      driver = {
        id: item.provider.ID,
        firstName: item.provider.firstName,
        lastName: item.provider.lastName,
        email: item.provider.email,
        phone: item.provider.displayPhone,
        photoUrl: item.provider.avatarUrl
      };
    }
    var flight = null;
    var flightName = item.airline;
    var flightNumber = item.flightNumber;
    var dropoffAirline = '';
    var dropoffFlightNumber = '';
    if (item.airline !== null && item.fligtNumber !== null) {
      flight = item.airline + ' ' + item.flightNumber;
    } else if (item.dropoffAirline || item.dropoffFlightNumber) {
      dropoffAirline = item.dropoffAirline;
      dropoffFlightNumber = item.dropoffFlightNumber;
      flight = item.dropoffAirline + ' ' + item.dropoffFlightNumber;
    }

    var guest = null;
    if (item.guest.firstName !== null && item.guest.firstName !== '') {
      guest = {
        firstName: item.guest.firstName,
        lastName: item.guest.lastName,
        phone: item.guest.phone
      };
    }

    var statusClass = item.dispatchStatus;
    var status = item.dispatchStatus.toUpperCase();
    if (statusClass === 'requires_dispatch') {
      statusClass = 'requires-dispatch';
      status = 'REQUIRES DISPATCH';
    }

    if (statusClass === 'autodispatch') {
      statusClass = 'auto-dispatch';
      status = 'AUTO DISPATCH';
    }

    if (statusClass === 'complete') {
      status = 'COMPLETED';
    }

    if (statusClass === 'ready') {
      status = 'READY TO GO';
    }

    var serviceType = item.serviceCode.toLowerCase().replace(/(^| )(\w)/g, function (s) {
      return s.toUpperCase();
    });
    if (serviceType === 'Suv') {
      serviceType = 'SUV';
    }

    var phoneNumber = null;
    if (item.consumer.phones && item.consumer.phones.length > 0) {
      var phone = item.consumer.phones[0];
      phoneNumber = '+' + phone.countryCode + phone.phoneNumber;
    }

    var totalFare = item.payment.fareAmount + item.payment.pickupFee + item.payment.tipAmount + item.travelInsurance;
    if (item.airportFee !== null) {
      totalFare = totalFare + item.airportFee;
    }

    var pickupTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.pickupDate, 'YYYY-MM-DD hh:mm:ss');
    // let threshold = VueApp.$store.state.routing.beThereTimeThreshold
    // let maxDuration = Math.floor(item.etaInSec * threshold)
    var maxDuration = Math.floor(item.etaInSec);
    var btt = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.pickupDate, 'YYYY-MM-DD HH:mm:ss').add(maxDuration, 'seconds').subtract(1, 'minute');
    var hoursLeft = btt.diff(pickupTime, 'minutes');
    if (item.complete) {
      hoursLeft = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.complete, 'YYYY-MM-DD hh:mm:ss').diff(pickupTime, 'minutes');
    }
    if (hoursLeft > 60) {
      var hour = Math.floor(hoursLeft / 60);
      // if (hour < 10) { hour = '0' + hour }
      var minute = hoursLeft - hour * 60;
      if (minute < 10) {
        minute = '0' + minute;
      }
      hoursLeft = hour + ':' + minute + ' hours';
    } else if (hoursLeft > 0) {
      hoursLeft = hoursLeft + ' minutes';
    }
    if (hoursLeft < 0) {
      hoursLeft = '';
    }

    var rsvpData = {
      brandId: item.brandID,
      isPackage: false,
      airportFee: item.airportFee,
      id: item.ID,
      pickup: {
        address1: item.pickupLocation.addressLine1,
        address2: item.pickupLocation.addressLine2,
        city: item.pickupLocation.city,
        state: item.pickupLocation.state,
        zip: item.pickupLocation.zip,
        lat: item.pickupLocation.lat,
        lng: item.pickupLocation.lng,
        geofenceName: item.pickupLocation.geofenceName,
        geofenceType: item.pickupLocation.geofenceType,
        terminal: item.terminal,
        title: item.pickupLocation.title
      },
      dropoff: {
        address1: item.dropoffLocation.addressLine1,
        address2: item.dropoffLocation.addressLine2,
        city: item.dropoffLocation.city,
        state: item.dropoffLocation.state,
        zip: item.dropoffLocation.zip,
        lat: item.dropoffLocation.lat,
        lng: item.dropoffLocation.lng,
        geofenceName: item.dropoffLocation.geofenceName,
        geofenceType: item.dropoffLocation.geofenceType,
        terminal: item.terminal,
        title: item.dropoffLocation.title
      },
      pickupTime: pickupTime.format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_2__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      dropoffTime: item.complete ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.complete, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_2__featureToggle__["a" /* default */].timeFormat(VueApp, false)) : btt.format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_2__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      hoursLeft: hoursLeft,
      resStatus: item.status,
      status: status,
      statusClass: statusClass,
      rsvpStatus: item.status,
      customer: {
        id: item.consumer.ID,
        firstName: item.consumer.firstName,
        lastName: item.consumer.lastName,
        email: item.consumer.email,
        phone: phoneNumber
      },
      guest: guest,
      driver: driver,
      meetAndGreet: item.pickupType === 'MeetAndGreet',
      airline: flightName,
      airlineCode: item.airlineCode,
      airportCode: item.airportCode,
      flightNumber: flightNumber,
      flight: flight,
      dropoffAirline: dropoffAirline,
      dropoffFlightNumber: dropoffFlightNumber,
      ada: item.ada ? item.ada : null,
      pax: item.passengers,
      luggage: item.luggage === null ? 0 : item.luggage,
      stops: 1,
      serviceType: serviceType,
      serviceId: item.serviceType.id,
      serviceLabel: __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].getServiceName(item.serviceCode),
      serviceClass: item.serviceCode,
      distance: item.distance,
      etaInSec: item.etaInSec,
      fare: totalFare,
      driverPayment: {
        base: item.payment.driverPay === null ? 0 : item.payment.driverPay,
        bonus: item.payment.driverBonus === null ? 0 : item.payment.driverBonus,
        tip: item.payment.tipAmount === null ? 0 : item.payment.tipAmount,
        gasFee: item.gasFee || 0,
        pickupFee: item.payment.pickupFee === null ? 0 : item.payment.pickupFee,
        travelInsurance: item.travelInsurance === null ? 0 : item.travelInsurance
      },
      notes: item.notes,
      hasExtraStop: item.hasExtraStop,
      isCharter: item.isCharter,
      isOptinShared: item.optinShared.isOptinShared,
      isMtech: item.isMTech,
      pendingOffer: {
        show: false,
        timer: 0
      },
      totalFare: item.payment.fareAmount ? parseFloat(item.payment.fareAmount.toFixed(2)) : 0
    };
    rsvpData.totalFare += item.airportFee ? parseFloat(item.airportFee.toFixed(2)) : 0;
    rsvpData.totalFare += item.gasFee ? parseFloat(item.gasFee.toFixed(2)) : 0;
    rsvpData.totalFare += item.portalFee ? parseFloat(item.portalFee.toFixed(2)) : 0;
    rsvpData.totalFare += item.travelInsurance ? parseFloat(item.travelInsurance.toFixed(2)) : 0;
    rsvpData.totalFare += item.payment.pickupFee ? parseFloat(item.payment.pickupFee.toFixed(2)) : 0;
    rsvpData.totalFare += item.payment.tipAmount ? parseFloat(item.payment.tipAmount.toFixed(2)) : 0;

    if (!{"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation) {
      rsvpData.serviceType = {
        label: item.serviceType.label,
        color: item.serviceType.color
      };
    }

    return rsvpData;
  },
  formatPackage: function formatPackage(VueApp, item) {
    var self = this;
    var firstRsvp = item.rsvp.filter(function (rsvp) {
      return rsvp.ID === item.stops[0].reservationID;
    })[0];
    var lastRsvp = item.rsvp.filter(function (rsvp) {
      return rsvp.ID === item.stops[item.stops.length - 1].reservationID;
    })[0];

    var statusClass = item.package.packageStatus ? item.package.packageStatus : item.package.status;
    var status = item.package.packageStatus ? item.package.packageStatus.toUpperCase() : item.package.status.toUpperCase();

    if (statusClass === 'requires_dispatch') {
      statusClass = 'requires-dispatch';
      status = 'REQUIRES DISPATCH';
    }

    if (statusClass === 'autodispatch') {
      statusClass = 'auto-dispatch';
      status = 'AUTO DISPATCH';
    }

    if (statusClass === 'cancelled') {
      statusClass = 'canceled';
      status = 'CANCELED';
    }

    if (statusClass === 'ready') {
      status = 'READY TO GO';
    }

    var luggage = 0;
    var fare = 0;
    var driverPayment = {
      base: 0,
      bonus: item.package.bonusToProvider !== null ? item.package.bonusToProvider : 0,
      tip: 0,
      gasFee: 0,
      pickupFee: 0,
      travelInsurance: 0
    };

    var ada = {
      serviceDog: 0,
      wheelChairLift: 0
    };
    var notes = [];
    var reservations = [];
    driverPayment.base = item.package.paidForProvider;
    var airportFee = 0;
    for (var i = 0; i < item.rsvp.length; i++) {
      var rsvp = item.rsvp[i];
      luggage += rsvp.luggage === null ? 0 : rsvp.luggage;
      fare += rsvp.payment.fareAmount;
      fare += rsvp.travelInsurance;
      fare += rsvp.payment.tipAmount === null ? 0 : rsvp.payment.tipAmount;
      fare += rsvp.gasFee === null ? 0 : rsvp.gasFee;
      // driverPayment.base += (rsvp.payment.driverPay === null ? 0 : rsvp.payment.driverPay)
      driverPayment.tip += rsvp.payment.tipAmount === null ? 0 : rsvp.payment.tipAmount;
      driverPayment.pickupFee += rsvp.payment.pickupFee === null ? 0 : rsvp.payment.pickupFee;
      driverPayment.travelInsurance += rsvp.travelInsurance === null ? 0 : rsvp.travelInsurance;
      driverPayment.gasFee += rsvp.gasFee === null ? 0 : rsvp.gasFee;

      rsvp.serviceCode = 'shared';
      reservations.push(self.formatRsvp(VueApp, rsvp));

      if (rsvp.airportFee !== null) {
        airportFee += rsvp.airportFee;
      }
      if (rsvp.ada.serviceDog === 1) {
        ada.serviceDog = 1;
      }
      if (rsvp.ada.wheelChairLift === 1) {
        ada.wheelChairLift = 1;
      }

      if (rsvp.notes !== null) {
        notes.push({
          rsvpID: rsvp.ID,
          notes: rsvp.notes
        });
      }
    }

    var route = [];
    var legs = [];

    var _loop = function _loop(_i2) {
      var rsvp = item.rsvp.filter(function (rsvp) {
        return rsvp.ID === item.stops[_i2].reservationID;
      })[0];
      var location = rsvp.dropoffLocation;
      if (item.stops[_i2].isPickup) {
        location = rsvp.pickupLocation;
      }
      route.push({
        rsvpID: rsvp.ID,
        isPickup: item.stops[_i2].isPickup,
        address1: location.addressLine1,
        address2: location.addressLine2,
        city: location.city,
        state: location.state,
        zip: location.zip,
        lat: location.lat,
        lng: location.lng,
        geofenceName: location.geofenceName,
        geofenceType: location.geofenceType,
        status: rsvp.dispatchStatus
      });

      var leg = self.formatRsvp(VueApp, rsvp);
      leg.isPickup = item.stops[_i2].isPickup;

      legs.push(leg);
    };

    for (var _i2 = 0; _i2 < item.stops.length; _i2++) {
      _loop(_i2);
    }

    var driver = null;
    if (item.driver != null) {
      driver = {
        id: item.driver.ID,
        firstName: item.driver.firstName,
        lastName: item.driver.lastName,
        email: item.driver.email,
        phone: item.driver.phone,
        photoUrl: item.driver.avatarUrl,
        vehicle: {
          name: item.driver.vehicle.manufacturer + ' ' + item.driver.vehicle.model,
          photoUrl: item.driver.vehicle.photo,
          licensePlate: item.driver.vehicle.licensePlate
        }
      };
    }

    var airline = firstRsvp.airline;
    var airlineCode = firstRsvp.airlineCode;
    var flightNumber = firstRsvp.flightNumber;
    if (firstRsvp.dropoffAirline) {
      airline = firstRsvp.dropoffAirline;
    }
    if (firstRsvp.dropoffAirlineCode) {
      airlineCode = firstRsvp.dropoffAirlineCode;
    }
    if (firstRsvp.dropoffFlightNumber) {
      flightNumber = firstRsvp.dropoffFlightNumber;
    }
    var flight = !airline || !flightNumber ? null : airline + ' ' + flightNumber;

    var pickupTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.package.localPickupTime);
    var _pickupTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.package.localPickupTime);
    // let threshold = VueApp.$store.state.routing.beThereTimeThreshold
    // let maxDuration = Math.floor(lastRsvp.etaInSec * threshold)
    var maxDuration = Math.floor(lastRsvp.etaInSec);
    var brand = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.find(function (x) {
      return x.id === lastRsvp.brandID;
    });
    if (brand.code === 'fd') {
      // maxDuration = Math.floor(item.package.etaInSec || item.package.maxDuration)
      maxDuration = Math.floor(item.package.maxDuration);
      _pickupTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(firstRsvp.pickupDate);
    }
    var btt = __WEBPACK_IMPORTED_MODULE_0_moment___default()(lastRsvp.pickupDate, 'YYYY-MM-DD HH:mm:ss').add(maxDuration, 'seconds').subtract(1, 'minute');
    var hoursLeft = btt.diff(_pickupTime, 'minutes');
    if (lastRsvp.complete) {
      hoursLeft = __WEBPACK_IMPORTED_MODULE_0_moment___default()(lastRsvp.complete, 'YYYY-MM-DD hh:mm:ss').diff(_pickupTime, 'minutes');
    }
    if (hoursLeft > 60) {
      var hour = Math.floor(hoursLeft / 60);
      // if (hour < 10) { hour = '0' + hour }
      var minute = hoursLeft - hour * 60;
      if (minute < 10) {
        minute = '0' + minute;
      }
      hoursLeft = hour + ':' + minute + ' hours';
    } else if (hoursLeft > 0) {
      hoursLeft = hoursLeft + ' minutes';
    }
    if (hoursLeft < 0) {
      hoursLeft = '';
    }

    var pkgData = {
      isPackage: true,
      airportFee: airportFee,
      id: item.package.id,
      pickup: {
        address1: firstRsvp.pickupLocation.addressLine1,
        address2: firstRsvp.pickupLocation.addressLine2,
        city: firstRsvp.pickupLocation.city,
        state: firstRsvp.pickupLocation.state,
        zip: firstRsvp.pickupLocation.zip,
        lat: firstRsvp.pickupLocation.lat,
        lng: firstRsvp.pickupLocation.lng,
        geofenceName: firstRsvp.pickupLocation.geofenceName,
        geofenceType: firstRsvp.pickupLocation.geofenceType,
        title: firstRsvp.pickupLocation.title
      },
      dropoff: {
        address1: lastRsvp.dropoffLocation.addressLine1,
        address2: lastRsvp.dropoffLocation.addressLine2,
        city: lastRsvp.dropoffLocation.city,
        state: lastRsvp.dropoffLocation.state,
        zip: lastRsvp.dropoffLocation.zip,
        lat: lastRsvp.dropoffLocation.lat,
        lng: lastRsvp.dropoffLocation.lng,
        geofenceName: lastRsvp.dropoffLocation.geofenceName,
        geofenceType: lastRsvp.dropoffLocation.geofenceType,
        title: lastRsvp.dropoffLocation.title
      },
      pickupTime: pickupTime.format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_2__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      dropoffTime: lastRsvp.complete ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(lastRsvp.complete, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_2__featureToggle__["a" /* default */].timeFormat(VueApp, false)) : btt.format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_2__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      hoursLeft: hoursLeft,
      status: status,
      statusClass: statusClass,
      resStatus: status,
      customer: null,
      guest: null,
      driver: driver,
      meetAndGreet: false,
      airline: airline,
      airlineCode: airlineCode,
      airportCode: firstRsvp.airportCode,
      flightNumber: flightNumber,
      flight: flight,
      ada: ada,
      pax: item.package.pax,
      luggage: luggage,
      rsvps: reservations,
      stops: item.package.stops / 2,
      legs: legs,
      route: route,
      serviceType: 'Shared',
      serviceLabel: __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].getServiceName('shared'),
      serviceClass: 'shared',
      serviceId: firstRsvp.serviceType.id,
      fare: fare,
      driverPayment: driverPayment,
      notes: notes,
      // isOptinShared: item.rsvp[0].optinShared.isOptinShared
      pendingOffer: {
        show: false,
        timer: 0
      }
    };

    if (!{"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation) {
      pkgData.serviceType = {
        label: item.rsvp[0].serviceType.label,
        color: item.rsvp[0].serviceType.color
      };
    }

    return pkgData;
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__featureToggle__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  getPackages: function getPackages(VueApp, callback, noFetching, itemToUpdate) {
    var self = this;
    var token = VueApp.$store.state.session.sessionToken;
    var selectedFilter = VueApp.$store.state.routing.selectedFilter;

    var currentPage = VueApp.$store.state.routing.packages.paging.currentPage;
    var request = {
      token: token,
      package: true,
      order: VueApp.$store.state.routing.packages.sort.order,
      orderAsc: VueApp.$store.state.routing.packages.sort.asc ? 1 : 0,
      pageNum: currentPage,
      pageSize: VueApp.$store.state.routing.packages.paging.pageSize

      // Filter
    };var filter = {};
    if (selectedFilter > -1) {
      filter = VueApp.$store.state.routing.reservationFilters[selectedFilter];
    }
    request['filter'] = filter;

    // Search
    var search = VueApp.$store.state.routing.reservationSearch;
    if (search !== '') {
      request['search'] = search;
    }

    if (!noFetching) {
      VueApp.$store.commit('routing/setIsPackagesLoading', true);
    }
    VueApp.$sdk.post('/admin/package', request, function (r) {
      VueApp.$store.commit('routing/setIsPackagesLoading', false);
      if (r.error) {
        console.log('Error fetching package: ', r);
        callback(r);
        return;
      }
      VueApp.$store.commit('routing/setRoutingPkgTotal', r.paging.totalItems);

      if (!r.list.length && currentPage === 1) {
        VueApp.$store.commit('routing/setPackageItems', []);
        return;
      }

      var packages = [];
      for (var i = 0; i < r.list.length; i++) {
        packages.push(self.formatPackage(VueApp, r.list[i]));
        if (currentPage > 1) {
          VueApp.$store.commit('routing/addPackage', self.formatPackage(VueApp, r.list[i]));
        }
      }
      if (currentPage === 1) {
        VueApp.$store.commit('routing/setPackageItems', packages);
      }

      if (packages.length > 0) {
        VueApp.$store.commit('routing/setPackageCurrentPage', r.paging.pageNum);
        VueApp.$store.commit('routing/setPackageTotalPages', r.paging.totalItems);
      }

      if (itemToUpdate && itemToUpdate.isPackage) {
        var itemsInDropzone = VueApp.$store.state.routing.dropzone.items;
        var dropzoneItem = itemsInDropzone.filter(function (dropzone) {
          return dropzone.packageID === itemToUpdate.id;
        });
        if (dropzoneItem.length > 0) {
          VueApp.$store.commit('routing/removeDropzoneItems', {
            id: itemToUpdate.id,
            type: 'package'
          });
          VueApp.$store.commit('routing/removeDropzonePackageDriver', itemToUpdate.id);
          var rsvp = packages.filter(function (opPackage) {
            return opPackage.id === itemToUpdate.id;
          });
          if (rsvp.length > 0) {
            rsvp = rsvp[0];
            VueApp.$store.commit('routing/addDropzoneItem', rsvp);

            if (rsvp.driver !== null) {
              VueApp.$store.commit('routing/addDropzoneDriver', {
                packageID: rsvp.id,
                driver: rsvp.driver
              });
            }
          }
        }
      }
      callback(r);
    });
  },
  getReservations: function getReservations(VueApp, callback, noFetching, itemToUpdate) {
    var self = this;
    var token = VueApp.$store.state.session.sessionToken;
    var selectedFilter = VueApp.$store.state.routing.selectedFilter;

    var currentPage = VueApp.$store.state.routing.reservations.paging.currentPage;
    var request = {
      token: token,
      package: true,
      order: VueApp.$store.state.routing.reservations.sort.order,
      orderAsc: VueApp.$store.state.routing.reservations.sort.asc ? 1 : 0,
      search: VueApp.$store.state.routing.reservationSearch,
      pageNum: currentPage,
      pageSize: VueApp.$store.state.routing.reservations.paging.pageSize

      // Filter
    };var filter = {};
    if (selectedFilter > -1) {
      filter = VueApp.$store.state.routing.reservationFilters[selectedFilter];
    }
    request['filter'] = filter;

    // Search
    var search = VueApp.$store.state.routing.reservationSearch;
    if (search !== null || search !== '') {
      request['search'] = search;
    }

    if (!noFetching) {
      VueApp.$store.commit('routing/setIsReservationsLoading', true);
    }
    VueApp.$sdk.post('/admin/rsvp/unpackaged', request, function (r) {
      VueApp.$store.commit('routing/setIsReservationsLoading', false);
      if (r.error) {
        console.log(r);
        callback(r);
        return;
      }
      VueApp.$store.commit('routing/setRoutingRsvpTotal', r.paging.totalItems);

      if (!r.list.length && currentPage === 1) {
        VueApp.$store.commit('routing/setReservationItems', []);
        return;
      }

      // console.log(r)
      var reservations = [];
      for (var i = 0; i < r.list.length; i++) {
        reservations.push(self.formatRsvp(VueApp, r.list[i]));
        if (currentPage > 1) {
          VueApp.$store.commit('routing/pushRsvpItem', self.formatRsvp(VueApp, r.list[i]));
        }
      }
      if (currentPage === 1) {
        VueApp.$store.commit('routing/setReservationItems', reservations);
      }

      if (reservations.length > 0) {
        VueApp.$store.commit('routing/setReservationsCurrentPage', r.paging.pageNum);
        VueApp.$store.commit('routing/setReservationsTotalPages', r.paging.totalItems);
      }

      if (itemToUpdate && !itemToUpdate.isPackage) {
        var itemsInDropzone = VueApp.$store.state.routing.dropzone.items;
        var dropzoneItem = itemsInDropzone.filter(function (dropzone) {
          return dropzone.reservationID === itemToUpdate.id && dropzone.packageID === null;
        });
        if (dropzoneItem.length > 0) {
          VueApp.$store.commit('routing/removeDropzoneItems', {
            id: itemToUpdate.id,
            type: 'rsvp'
          });
          var rsvp = reservations.filter(function (reservation) {
            return reservation.id === itemToUpdate.id;
          });
          if (rsvp.length > 0) {
            rsvp = rsvp[0];
            VueApp.$store.commit('routing/addDropzoneItem', rsvp);
          }
        }
      }
      callback(r);
    });
  },
  updateItemsInTables: function updateItemsInTables(VueApp, item) {
    var self = this;
    self.getReservations(VueApp, function () {}, true, item);
    self.getPackages(VueApp, function () {}, true, item);
  },
  updateItemInTable: function updateItemInTable(VueApp, rsvp) {
    var self = this;

    var url = '/admin/rsvp/';
    if (rsvp.isPackage) {
      url = '/admin/package/';
    }
    VueApp.$sdk.get(url + rsvp.id, {
      token: VueApp.$store.state.session.sessionToken
    }, function (r) {
      if (r.error) {
        console.log(r);
        return;
      }

      var result = null;
      if (r.package) {
        result = self.formatPackage(r);
      } else {
        result = self.formatRsvp(r);
      }
    });
  },
  initRoutingReservations: function initRoutingReservations(VueApp) {
    var self = this;
    setTimeout(function () {
      var threshold = VueApp.$settings.get('OfferLimitThreshold');
      VueApp.$store.commit('routing/setBeThereTimeThreshold', 1 + parseFloat(threshold) / 100);
    }, 1000);
    VueApp.$sdk.get('/admin/filters', {
      order: 'filterName',
      token: VueApp.$store.state.session.sessionToken
    }, function (r) {
      if (r.error) {
        console.log(r);
        return;
      }
      VueApp.$store.commit('routing/setReservationFilters', r.list);
      // Load last selected filter
      var selectedFilterId = parseInt(VueApp.$plugins.storage.get('ADMIN_ROUTING_FILTER'));
      if (isNaN(selectedFilterId)) {
        self.getReservations(VueApp, function (r) {}, false);
        self.getPackages(VueApp, function (r) {}, false);
        return;
      }
      var selectedFilter = -1;
      for (var i = 0; i < r.list.length; i++) {
        var filter = r.list[i];

        if (filter.id === selectedFilterId) {
          selectedFilter = i;
          break;
        }
      }

      if (selectedFilter >= 0) {
        VueApp.$store.commit('routing/setSelectedFilter', selectedFilter);
        // Jayrome TODO: Preload data
        self.getReservations(VueApp, function (r) {}, false);
        self.getPackages(VueApp, function (r) {}, false);
      }
    });
  },
  formatRsvp: function formatRsvp(VueApp, item) {
    var statusClass = item.dispatchStatus;
    var status = item.dispatchStatus.toUpperCase();
    if (statusClass === 'requires_dispatch') {
      statusClass = 'requires-dispatch';
      status = 'REQUIRES DISPATCH';
    }

    if (statusClass === 'autodispatch') {
      statusClass = 'auto-dispatch';
      status = 'AUTO DISPATCH';
    }

    if (statusClass === 'complete') {
      status = 'COMPLETED';
    }

    if (statusClass === 'ready') {
      status = 'READY TO GO';
    }

    if (item.status === 'ontheway') {
      statusClass = 'ontheway';
      status = 'ONTHEWAY';
    }

    var phoneNumber = null;
    if (item.consumer.phones && item.consumer.phones.length > 0) {
      var phone = item.consumer.phones[0];
      phoneNumber = '+' + phone.countryCode + phone.phoneNumber;
    }

    var pickup = {
      address1: item.pickupLocation.addressLine1,
      address2: item.pickupLocation.addressLine2,
      city: item.pickupLocation.city,
      state: item.pickupLocation.state,
      zip: item.pickupLocation.zip,
      lat: item.pickupLocation.lat,
      lng: item.pickupLocation.lng,
      geofenceType: item.pickupLocation.geofenceType,
      geofenceName: item.pickupLocation.geofenceName,
      title: item.pickupLocation.title
    };
    var dropoff = {
      address1: item.dropoffLocation.addressLine1,
      address2: item.dropoffLocation.addressLine2,
      city: item.dropoffLocation.city,
      state: item.dropoffLocation.state,
      zip: item.dropoffLocation.zip,
      lat: item.dropoffLocation.lat,
      lng: item.dropoffLocation.lng,
      geofenceType: item.dropoffLocation.geofenceType,
      geofenceName: item.dropoffLocation.geofenceName,
      title: item.dropoffLocation.title
    };
    var pickupMoment = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.pickupDate, 'YYYY-MM-DD hh:mm:ss');
    var threshold = VueApp.$store.state.routing.beThereTimeThreshold;
    var maxDuration = Math.floor(item.etaInSec * threshold);
    var btt = pickupMoment.add(maxDuration, 'seconds');

    var legs = []; // stops
    legs.push({
      originalBTT: 0,
      eta: 0,
      inOrder: -1,
      isPickup: true,
      location: pickup,
      passengers: item.passengers,
      luggage: item.luggage !== null ? item.luggage : 0,
      maxDuration: 0,
      packageID: null,
      pickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      originalPickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      reservationID: item.ID,
      status: status,
      serviceId: item.optinShared.isOptinShared ? item.optinShared.shared.serviceTypeId : 'shared'
    });
    legs.push({
      originalBTT: maxDuration,
      eta: item.etaInSec,
      inOrder: -1,
      isPickup: false,
      location: dropoff,
      passengers: item.passengers,
      luggage: item.luggage !== null ? item.luggage : 0,
      maxDuration: maxDuration,
      packageID: null,
      pickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      originalPickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      reservationID: item.ID,
      status: status,
      serviceId: item.optinShared.isOptinShared ? item.optinShared.shared.serviceTypeId : 'shared'
    });

    // let airline = item.dropoffAirline
    // let airlineCode = item.dropoffAirlineCode
    // let flightNumber = item.dropoffFlightNumber
    // if (item.airline) {
    //   airline = item.airline
    //   airlineCode = item.airlineCode
    //   flightNumber = item.flightNumber
    // }

    var flightName = item.airline;
    var flightNumber = item.flightNumber;
    var airlineCode = item.airlineCode;
    var dropoffAirline = '';
    var dropoffFlightNumber = '';
    if (item.dropoffAirline || item.dropoffFlightNumber) {
      dropoffAirline = item.dropoffAirline;
      airlineCode = item.dropoffAirlineCode;
      dropoffFlightNumber = item.dropoffFlightNumber;
    }
    return {
      id: item.ID,
      type: 'rsvp',
      statusClass: statusClass,
      status: status,
      pickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      pickup: pickup,
      eta: item.etaInSec,
      beThereTime: btt.format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      dropoff: dropoff,
      customer: {
        id: item.consumer.ID,
        firstName: item.consumer.firstName,
        lastName: item.consumer.lastName,
        phone: phoneNumber
      },
      flight: {
        airline: flightName || dropoffAirline,
        airlineCode: airlineCode,
        flightNumber: flightNumber || dropoffFlightNumber
      },
      airline: flightName,
      airlineCode: airlineCode,
      airportCode: item.airportCode,
      flightNumber: flightNumber,
      dropoffAirline: dropoffAirline,
      dropoffFlightNumber: dropoffFlightNumber,
      passengers: item.passengers,
      luggage: item.luggage !== null ? item.luggage : 0,
      payment: item.payment,
      legs: legs,
      ada: {
        wheelchair: item.ada.wheelChairLift === 1,
        serviceDog: item.ada.serviceDog === 1
      },
      pickupSectors: item.pickupLocation.sectors ? item.pickupLocation.sectors : null,
      dropoffSectors: item.dropoffLocation.sectors ? item.dropoffLocation.sectors : null,
      gasFee: item.gasFee || 0,
      optinShared: item.optinShared,
      service: item.serviceType,
      serviceId: item.optinShared.isOptinShared ? item.optinShared.shared.serviceTypeId : 'shared'
    };
  },
  formatPackage: function formatPackage(VueApp, item) {
    var self = this;
    // Status
    var statusClass = item.package.packageStatus;
    var status = item.package.packageStatus.toUpperCase();
    if (statusClass === 'requires_dispatch') {
      statusClass = 'requires-dispatch';
      status = 'REQUIRES DISPATCH';
    }
    if (statusClass === 'autodispatch') {
      statusClass = 'auto-dispatch';
      status = 'AUTO DISPATCH';
    }
    if (statusClass === 'complete') {
      status = 'COMPLETED';
    }
    if (statusClass === 'ready') {
      status = 'READY TO GO';
    }

    // RSVP
    var ada = {
      serviceDog: 0,
      wheelChairLift: 0
    };
    var rsvps = [];
    var luggage = 0;
    var tip = 0;
    var gasFee = 0;

    for (var i = 0; i < item.rsvp.length; i++) {
      var rsvp = self.formatRsvp(VueApp, item.rsvp[i]);
      luggage += rsvp.luggage;
      rsvps.push(rsvp);
      if (rsvp.ada.wheelchair) {
        ada.wheelchair = true;
      }
      if (rsvp.ada.serviceDog) {
        ada.serviceDog = true;
      }
      tip = tip + rsvp.payment.tipAmount;
      gasFee = gasFee + rsvp.gasFee;
    }

    var legs = [];

    var _loop = function _loop(_i) {
      var leg = item.stops[_i];
      var itemRsvp = rsvps.filter(function (rsvp) {
        return rsvp.id === leg.reservationID;
      })[0];
      legs.push({
        originalBTT: itemRsvp.legs[1].maxDuration,
        eta: leg.eta,
        inOrder: leg.inOrder,
        isPickup: leg.isPickup,
        location: leg.isPickup ? itemRsvp.pickup : itemRsvp.dropoff,
        passengers: itemRsvp.passengers,
        luggage: itemRsvp.luggage !== null ? itemRsvp.luggage : 0,
        maxDuration: leg.maxDuration,
        packageID: item.package.id,
        pickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.package.localPickupTime, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
        originalPickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(itemRsvp.pickupTime, 'MM/DD/YYYY hh:mmA').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
        reservationID: leg.reservationID,
        status: itemRsvp.status,
        serviceId: itemRsvp.optinShared.isOptinShared ? itemRsvp.optinShared.shared.serviceTypeId : 'shared'
      });
    };

    for (var _i = 0; _i < item.stops.length; _i++) {
      _loop(_i);
    }

    var service = {
      color: '#fafafa',
      id: 0,
      label: 'MISSING'
    };
    if (item.rsvp.length) {
      service = item.rsvp[0].serviceType;
    }
    var serviceId = 'shared';
    if (item.rsvp[0].optinShared.isOptinShared) {
      serviceId = item.rsvp[0].optinShared.shared.serviceTypeId;
    }

    return {
      id: item.package.id,
      type: 'package',
      status: status,
      statusClass: statusClass,
      pickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.package.localPickupTime).format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      firstPickup: item.package.firstPickup,
      lastPickup: item.package.lastPickup,
      driver: item.driver,
      payment: item.package.paidForProvider,
      bonus: item.package.bonusToProvider,
      tip: tip,
      gasFee: gasFee || 0,
      ada: ada,
      stops: item.package.stops,
      pax: item.package.pax,
      luggage: luggage,
      rsvps: rsvps,
      legs: legs,
      inPool: item.package.inPool === 1,
      service: service,
      serviceId: serviceId,
      pendingOffer: {
        show: false,
        timer: 0
      }
    };
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingModal_vue__ = __webpack_require__(380);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51e86dd8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingModal_vue__ = __webpack_require__(1044);
function injectStyle (ssrContext) {
  __webpack_require__(1042)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51e86dd8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51e86dd8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.libphonenumber = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return require(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (global){(function (){
/*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/
var $jscomp=$jscomp||{};$jscomp.scope={};$jscomp.createTemplateTagFirstArg=function(a){return a.raw=a};$jscomp.createTemplateTagFirstArgWithRaw=function(a,b){a.raw=b;return a};$jscomp.arrayIteratorImpl=function(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}};$jscomp.arrayIterator=function(a){return{next:$jscomp.arrayIteratorImpl(a)}};$jscomp.makeIterator=function(a){var b="undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];return b?b.call(a):$jscomp.arrayIterator(a)};
$jscomp.arrayFromIterator=function(a){for(var b,c=[];!(b=a.next()).done;)c.push(b.value);return c};$jscomp.arrayFromIterable=function(a){return a instanceof Array?a:$jscomp.arrayFromIterator($jscomp.makeIterator(a))};$jscomp.checkStringArgs=function(a,b,c){if(null==a)throw new TypeError("The 'this' value for String.prototype."+c+" must not be null or undefined");if(b instanceof RegExp)throw new TypeError("First argument to String.prototype."+c+" must not be a regular expression");return a+""};
$jscomp.ASSUME_ES5=!1;$jscomp.ASSUME_NO_NATIVE_MAP=!1;$jscomp.ASSUME_NO_NATIVE_SET=!1;$jscomp.SIMPLE_FROUND_POLYFILL=!1;$jscomp.ISOLATE_POLYFILLS=!1;$jscomp.FORCE_POLYFILL_PROMISE=!1;$jscomp.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION=!1;$jscomp.defineProperty=$jscomp.ASSUME_ES5||"function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){if(a==Array.prototype||a==Object.prototype)return a;a[b]=c.value;return a};
$jscomp.getGlobal=function(a){a=["object"==typeof globalThis&&globalThis,a,"object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof global&&global];for(var b=0;b<a.length;++b){var c=a[b];if(c&&c.Math==Math)return c}throw Error("Cannot find global object");};$jscomp.global=$jscomp.getGlobal(this);$jscomp.IS_SYMBOL_NATIVE="function"===typeof Symbol&&"symbol"===typeof Symbol("x");$jscomp.TRUST_ES6_POLYFILLS=!$jscomp.ISOLATE_POLYFILLS||$jscomp.IS_SYMBOL_NATIVE;$jscomp.polyfills={};
$jscomp.propertyToPolyfillSymbol={};$jscomp.POLYFILL_PREFIX="$jscp$";var $jscomp$lookupPolyfilledValue=function(a,b){var c=$jscomp.propertyToPolyfillSymbol[b];if(null==c)return a[b];c=a[c];return void 0!==c?c:a[b]};$jscomp.polyfill=function(a,b,c,d){b&&($jscomp.ISOLATE_POLYFILLS?$jscomp.polyfillIsolated(a,b,c,d):$jscomp.polyfillUnisolated(a,b,c,d))};
$jscomp.polyfillUnisolated=function(a,b,c,d){c=$jscomp.global;a=a.split(".");for(d=0;d<a.length-1;d++){var e=a[d];if(!(e in c))return;c=c[e]}a=a[a.length-1];d=c[a];b=b(d);b!=d&&null!=b&&$jscomp.defineProperty(c,a,{configurable:!0,writable:!0,value:b})};
$jscomp.polyfillIsolated=function(a,b,c,d){var e=a.split(".");a=1===e.length;d=e[0];d=!a&&d in $jscomp.polyfills?$jscomp.polyfills:$jscomp.global;for(var f=0;f<e.length-1;f++){var g=e[f];if(!(g in d))return;d=d[g]}e=e[e.length-1];c=$jscomp.IS_SYMBOL_NATIVE&&"es6"===c?d[e]:null;b=b(c);null!=b&&(a?$jscomp.defineProperty($jscomp.polyfills,e,{configurable:!0,writable:!0,value:b}):b!==c&&($jscomp.propertyToPolyfillSymbol[e]=$jscomp.IS_SYMBOL_NATIVE?$jscomp.global.Symbol(e):$jscomp.POLYFILL_PREFIX+e,e=
$jscomp.propertyToPolyfillSymbol[e],$jscomp.defineProperty(d,e,{configurable:!0,writable:!0,value:b})))};$jscomp.polyfill("String.prototype.endsWith",function(a){return a?a:function(b,c){var d=$jscomp.checkStringArgs(this,b,"endsWith");b+="";void 0===c&&(c=d.length);c=Math.max(0,Math.min(c|0,d.length));for(var e=b.length;0<e&&0<c;)if(d[--c]!=b[--e])return!1;return 0>=e}},"es6","es3");
$jscomp.findInternal=function(a,b,c){a instanceof String&&(a=String(a));for(var d=a.length,e=0;e<d;e++){var f=a[e];if(b.call(c,f,e,a))return{i:e,v:f}}return{i:-1,v:void 0}};$jscomp.polyfill("Array.prototype.find",function(a){return a?a:function(b,c){return $jscomp.findInternal(this,b,c).v}},"es6","es3");
$jscomp.polyfill("String.prototype.startsWith",function(a){return a?a:function(b,c){var d=$jscomp.checkStringArgs(this,b,"startsWith");b+="";var e=d.length,f=b.length;c=Math.max(0,Math.min(c|0,d.length));for(var g=0;g<f&&c<e;)if(d[c++]!=b[g++])return!1;return g>=f}},"es6","es3");
$jscomp.polyfill("String.prototype.repeat",function(a){return a?a:function(b){var c=$jscomp.checkStringArgs(this,null,"repeat");if(0>b||1342177279<b)throw new RangeError("Invalid count value");b|=0;for(var d="";b;)if(b&1&&(d+=c),b>>>=1)c+=c;return d}},"es6","es3");$jscomp.initSymbol=function(){};
$jscomp.polyfill("Symbol",function(a){if(a)return a;var b=function(e,f){this.$jscomp$symbol$id_=e;$jscomp.defineProperty(this,"description",{configurable:!0,writable:!0,value:f})};b.prototype.toString=function(){return this.$jscomp$symbol$id_};var c=0,d=function(e){if(this instanceof d)throw new TypeError("Symbol is not a constructor");return new b("jscomp_symbol_"+(e||"")+"_"+c++,e)};return d},"es6","es3");
$jscomp.polyfill("Symbol.iterator",function(a){if(a)return a;a=Symbol("Symbol.iterator");for(var b="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),c=0;c<b.length;c++){var d=$jscomp.global[b[c]];"function"===typeof d&&"function"!=typeof d.prototype[a]&&$jscomp.defineProperty(d.prototype,a,{configurable:!0,writable:!0,value:function(){return $jscomp.iteratorPrototype($jscomp.arrayIteratorImpl(this))}})}return a},"es6",
"es3");$jscomp.iteratorPrototype=function(a){a={next:a};a[Symbol.iterator]=function(){return this};return a};$jscomp.iteratorFromArray=function(a,b){a instanceof String&&(a+="");var c=0,d=!1,e={next:function(){if(!d&&c<a.length){var f=c++;return{value:b(f,a[f]),done:!1}}d=!0;return{done:!0,value:void 0}}};e[Symbol.iterator]=function(){return e};return e};$jscomp.polyfill("Array.prototype.keys",function(a){return a?a:function(){return $jscomp.iteratorFromArray(this,function(b){return b})}},"es6","es3");
$jscomp.polyfill("Object.is",function(a){return a?a:function(b,c){return b===c?0!==b||1/b===1/c:b!==b&&c!==c}},"es6","es3");$jscomp.polyfill("Array.prototype.includes",function(a){return a?a:function(b,c){var d=this;d instanceof String&&(d=String(d));var e=d.length;c=c||0;for(0>c&&(c=Math.max(c+e,0));c<e;c++){var f=d[c];if(f===b||Object.is(f,b))return!0}return!1}},"es7","es3");
$jscomp.polyfill("String.prototype.includes",function(a){return a?a:function(b,c){return-1!==$jscomp.checkStringArgs(this,b,"includes").indexOf(b,c||0)}},"es6","es3");var COMPILED=!0,goog=goog||{};goog.global=this||self;
goog.exportPath_=function(a,b,c,d){a=a.split(".");d=d||goog.global;a[0]in d||"undefined"==typeof d.execScript||d.execScript("var "+a[0]);for(var e;a.length&&(e=a.shift());)if(a.length||void 0===b)d=d[e]&&d[e]!==Object.prototype[e]?d[e]:d[e]={};else if(!c&&goog.isObject(b)&&goog.isObject(d[e]))for(var f in b)b.hasOwnProperty(f)&&(d[e][f]=b[f]);else d[e]=b};
goog.define=function(a,b){if(!COMPILED){var c=goog.global.CLOSURE_UNCOMPILED_DEFINES,d=goog.global.CLOSURE_DEFINES;c&&void 0===c.nodeType&&Object.prototype.hasOwnProperty.call(c,a)?b=c[a]:d&&void 0===d.nodeType&&Object.prototype.hasOwnProperty.call(d,a)&&(b=d[a])}return b};goog.FEATURESET_YEAR=2012;goog.DEBUG=!0;goog.LOCALE="en";goog.TRUSTED_SITE=!0;goog.DISALLOW_TEST_ONLY_CODE=COMPILED&&!goog.DEBUG;goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING=!1;
goog.provide=function(a){if(goog.isInModuleLoader_())throw Error("goog.provide cannot be used within a module.");if(!COMPILED&&goog.isProvided_(a))throw Error('Namespace "'+a+'" already declared.');goog.constructNamespace_(a)};goog.constructNamespace_=function(a,b,c){if(!COMPILED){delete goog.implicitNamespaces_[a];for(var d=a;(d=d.substring(0,d.lastIndexOf(".")))&&!goog.getObjectByName(d);)goog.implicitNamespaces_[d]=!0}goog.exportPath_(a,b,c)};
goog.getScriptNonce=function(a){if(a&&a!=goog.global)return goog.getScriptNonce_(a.document);null===goog.cspNonce_&&(goog.cspNonce_=goog.getScriptNonce_(goog.global.document));return goog.cspNonce_};goog.NONCE_PATTERN_=/^[\w+/_-]+[=]{0,2}$/;goog.cspNonce_=null;goog.getScriptNonce_=function(a){return(a=a.querySelector&&a.querySelector("script[nonce]"))&&(a=a.nonce||a.getAttribute("nonce"))&&goog.NONCE_PATTERN_.test(a)?a:""};goog.VALID_MODULE_RE_=/^[a-zA-Z_$][a-zA-Z0-9._$]*$/;
goog.module=function(a){if("string"!==typeof a||!a||-1==a.search(goog.VALID_MODULE_RE_))throw Error("Invalid module identifier");if(!goog.isInGoogModuleLoader_())throw Error("Module "+a+" has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
if(goog.moduleLoaderState_.moduleName)throw Error("goog.module may only be called once per module.");goog.moduleLoaderState_.moduleName=a;if(!COMPILED){if(goog.isProvided_(a))throw Error('Namespace "'+a+'" already declared.');delete goog.implicitNamespaces_[a]}};goog.module.get=function(a){return goog.module.getInternal_(a)};
goog.module.getInternal_=function(a){if(!COMPILED){if(a in goog.loadedModules_)return goog.loadedModules_[a].exports;if(!goog.implicitNamespaces_[a])return a=goog.getObjectByName(a),null!=a?a:null}return null};goog.ModuleType={ES6:"es6",GOOG:"goog"};goog.moduleLoaderState_=null;goog.isInModuleLoader_=function(){return goog.isInGoogModuleLoader_()||goog.isInEs6ModuleLoader_()};goog.isInGoogModuleLoader_=function(){return!!goog.moduleLoaderState_&&goog.moduleLoaderState_.type==goog.ModuleType.GOOG};
goog.isInEs6ModuleLoader_=function(){if(goog.moduleLoaderState_&&goog.moduleLoaderState_.type==goog.ModuleType.ES6)return!0;var a=goog.global.$jscomp;return a?"function"!=typeof a.getCurrentModulePath?!1:!!a.getCurrentModulePath():!1};
goog.module.declareLegacyNamespace=function(){if(!COMPILED&&!goog.isInGoogModuleLoader_())throw Error("goog.module.declareLegacyNamespace must be called from within a goog.module");if(!COMPILED&&!goog.moduleLoaderState_.moduleName)throw Error("goog.module must be called prior to goog.module.declareLegacyNamespace.");goog.moduleLoaderState_.declareLegacyNamespace=!0};
goog.declareModuleId=function(a){if(!COMPILED){if(!goog.isInEs6ModuleLoader_())throw Error("goog.declareModuleId may only be called from within an ES6 module");if(goog.moduleLoaderState_&&goog.moduleLoaderState_.moduleName)throw Error("goog.declareModuleId may only be called once per module.");if(a in goog.loadedModules_)throw Error('Module with namespace "'+a+'" already exists.');}if(goog.moduleLoaderState_)goog.moduleLoaderState_.moduleName=a;else{var b=goog.global.$jscomp;if(!b||"function"!=typeof b.getCurrentModulePath)throw Error('Module with namespace "'+
a+'" has been loaded incorrectly.');b=b.require(b.getCurrentModulePath());goog.loadedModules_[a]={exports:b,type:goog.ModuleType.ES6,moduleId:a}}};goog.setTestOnly=function(a){if(goog.DISALLOW_TEST_ONLY_CODE)throw a=a||"",Error("Importing test-only code into non-debug environment"+(a?": "+a:"."));};goog.forwardDeclare=function(a){};COMPILED||(goog.isProvided_=function(a){return a in goog.loadedModules_||!goog.implicitNamespaces_[a]&&null!=goog.getObjectByName(a)},goog.implicitNamespaces_={"goog.module":!0});
goog.getObjectByName=function(a,b){a=a.split(".");b=b||goog.global;for(var c=0;c<a.length;c++)if(b=b[a[c]],null==b)return null;return b};goog.addDependency=function(a,b,c,d){!COMPILED&&goog.DEPENDENCIES_ENABLED&&goog.debugLoader_.addDependency(a,b,c,d)};goog.ENABLE_DEBUG_LOADER=!0;goog.logToConsole_=function(a){goog.global.console&&goog.global.console.error(a)};
goog.require=function(a){if(!COMPILED){goog.ENABLE_DEBUG_LOADER&&goog.debugLoader_.requested(a);if(goog.isProvided_(a)){if(goog.isInModuleLoader_())return goog.module.getInternal_(a)}else if(goog.ENABLE_DEBUG_LOADER){var b=goog.moduleLoaderState_;goog.moduleLoaderState_=null;try{goog.debugLoader_.load_(a)}finally{goog.moduleLoaderState_=b}}return null}};goog.requireType=function(a){return{}};goog.basePath="";goog.nullFunction=function(){};
goog.abstractMethod=function(){throw Error("unimplemented abstract method");};goog.addSingletonGetter=function(a){a.instance_=void 0;a.getInstance=function(){if(a.instance_)return a.instance_;goog.DEBUG&&(goog.instantiatedSingletons_[goog.instantiatedSingletons_.length]=a);return a.instance_=new a}};goog.instantiatedSingletons_=[];goog.LOAD_MODULE_USING_EVAL=!0;goog.SEAL_MODULE_EXPORTS=goog.DEBUG;goog.loadedModules_={};goog.DEPENDENCIES_ENABLED=!COMPILED&&goog.ENABLE_DEBUG_LOADER;goog.TRANSPILE="detect";
goog.ASSUME_ES_MODULES_TRANSPILED=!1;goog.TRANSPILE_TO_LANGUAGE="";goog.TRANSPILER="transpile.js";goog.hasBadLetScoping=null;goog.useSafari10Workaround=function(){if(null==goog.hasBadLetScoping){try{var a=!eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";')}catch(b){a=!1}goog.hasBadLetScoping=a}return goog.hasBadLetScoping};goog.workaroundSafari10EvalBug=function(a){return"(function(){"+a+"\n;})();\n"};
goog.loadModule=function(a){var b=goog.moduleLoaderState_;try{goog.moduleLoaderState_={moduleName:"",declareLegacyNamespace:!1,type:goog.ModuleType.GOOG};var c={},d=c;if("function"===typeof a)d=a.call(void 0,d);else if("string"===typeof a)goog.useSafari10Workaround()&&(a=goog.workaroundSafari10EvalBug(a)),d=goog.loadModuleFromSource_.call(void 0,d,a);else throw Error("Invalid module definition");var e=goog.moduleLoaderState_.moduleName;if("string"===typeof e&&e)goog.moduleLoaderState_.declareLegacyNamespace?
goog.constructNamespace_(e,d,c!==d):goog.SEAL_MODULE_EXPORTS&&Object.seal&&"object"==typeof d&&null!=d&&Object.seal(d),goog.loadedModules_[e]={exports:d,type:goog.ModuleType.GOOG,moduleId:goog.moduleLoaderState_.moduleName};else throw Error('Invalid module name "'+e+'"');}finally{goog.moduleLoaderState_=b}};goog.loadModuleFromSource_=function(a,b){eval(b);return a};
goog.normalizePath_=function(a){a=a.split("/");for(var b=0;b<a.length;)"."==a[b]?a.splice(b,1):b&&".."==a[b]&&a[b-1]&&".."!=a[b-1]?a.splice(--b,2):b++;return a.join("/")};goog.loadFileSync_=function(a){if(goog.global.CLOSURE_LOAD_FILE_SYNC)return goog.global.CLOSURE_LOAD_FILE_SYNC(a);try{var b=new goog.global.XMLHttpRequest;b.open("get",a,!1);b.send();return 0==b.status||200==b.status?b.responseText:null}catch(c){return null}};
goog.transpile_=function(a,b,c){var d=goog.global.$jscomp;d||(goog.global.$jscomp=d={});var e=d.transpile;if(!e){var f=goog.basePath+goog.TRANSPILER,g=goog.loadFileSync_(f);if(g){(function(){(0,eval)(g+"\n//# sourceURL="+f)}).call(goog.global);if(goog.global.$gwtExport&&goog.global.$gwtExport.$jscomp&&!goog.global.$gwtExport.$jscomp.transpile)throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: '+JSON.stringify(goog.global.$gwtExport));goog.global.$jscomp.transpile=
goog.global.$gwtExport.$jscomp.transpile;d=goog.global.$jscomp;e=d.transpile}}e||(e=d.transpile=function(h,k){goog.logToConsole_(k+" requires transpilation but no transpiler was found.");return h});return e(a,b,c)};goog.typeOf=function(a){var b=typeof a;return"object"!=b?b:a?Array.isArray(a)?"array":b:"null"};goog.isArrayLike=function(a){var b=goog.typeOf(a);return"array"==b||"object"==b&&"number"==typeof a.length};goog.isDateLike=function(a){return goog.isObject(a)&&"function"==typeof a.getFullYear};
goog.isObject=function(a){var b=typeof a;return"object"==b&&null!=a||"function"==b};goog.getUid=function(a){return Object.prototype.hasOwnProperty.call(a,goog.UID_PROPERTY_)&&a[goog.UID_PROPERTY_]||(a[goog.UID_PROPERTY_]=++goog.uidCounter_)};goog.hasUid=function(a){return!!a[goog.UID_PROPERTY_]};goog.removeUid=function(a){null!==a&&"removeAttribute"in a&&a.removeAttribute(goog.UID_PROPERTY_);try{delete a[goog.UID_PROPERTY_]}catch(b){}};goog.UID_PROPERTY_="closure_uid_"+(1E9*Math.random()>>>0);
goog.uidCounter_=0;goog.cloneObject=function(a){var b=goog.typeOf(a);if("object"==b||"array"==b){if("function"===typeof a.clone)return a.clone();b="array"==b?[]:{};for(var c in a)b[c]=goog.cloneObject(a[c]);return b}return a};goog.bindNative_=function(a,b,c){return a.call.apply(a.bind,arguments)};
goog.bindJs_=function(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var e=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(e,d);return a.apply(b,e)}}return function(){return a.apply(b,arguments)}};goog.bind=function(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?goog.bind=goog.bindNative_:goog.bind=goog.bindJs_;return goog.bind.apply(null,arguments)};
goog.partial=function(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var d=c.slice();d.push.apply(d,arguments);return a.apply(this,d)}};goog.mixin=function(a,b){for(var c in b)a[c]=b[c]};goog.now=function(){return Date.now()};goog.globalEval=function(a){(0,eval)(a)};
goog.getCssName=function(a,b){if("."==String(a).charAt(0))throw Error('className passed in goog.getCssName must not start with ".". You passed: '+a);var c=function(e){return goog.cssNameMapping_[e]||e},d=function(e){e=e.split("-");for(var f=[],g=0;g<e.length;g++)f.push(c(e[g]));return f.join("-")};d=goog.cssNameMapping_?"BY_WHOLE"==goog.cssNameMappingStyle_?c:d:function(e){return e};a=b?a+"-"+d(b):d(a);return goog.global.CLOSURE_CSS_NAME_MAP_FN?goog.global.CLOSURE_CSS_NAME_MAP_FN(a):a};
goog.setCssNameMapping=function(a,b){goog.cssNameMapping_=a;goog.cssNameMappingStyle_=b};!COMPILED&&goog.global.CLOSURE_CSS_NAME_MAPPING&&(goog.cssNameMapping_=goog.global.CLOSURE_CSS_NAME_MAPPING);goog.getMsg=function(a,b,c){c&&c.html&&(a=a.replace(/</g,"&lt;"));c&&c.unescapeHtmlEntities&&(a=a.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&apos;/g,"'").replace(/&quot;/g,'"').replace(/&amp;/g,"&"));b&&(a=a.replace(/\{\$([^}]+)}/g,function(d,e){return null!=b&&e in b?b[e]:d}));return a};
goog.getMsgWithFallback=function(a,b){return a};goog.exportSymbol=function(a,b,c){goog.exportPath_(a,b,!0,c)};goog.exportProperty=function(a,b,c){a[b]=c};goog.inherits=function(a,b){function c(){}c.prototype=b.prototype;a.superClass_=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.base=function(d,e,f){for(var g=Array(arguments.length-2),h=2;h<arguments.length;h++)g[h-2]=arguments[h];return b.prototype[e].apply(d,g)}};
goog.scope=function(a){if(goog.isInModuleLoader_())throw Error("goog.scope is not supported within a module.");a.call(goog.global)};COMPILED||(goog.global.COMPILED=COMPILED);
goog.defineClass=function(a,b){var c=b.constructor,d=b.statics;c&&c!=Object.prototype.constructor||(c=function(){throw Error("cannot instantiate an interface (no constructor defined).");});c=goog.defineClass.createSealingConstructor_(c,a);a&&goog.inherits(c,a);delete b.constructor;delete b.statics;goog.defineClass.applyProperties_(c.prototype,b);null!=d&&(d instanceof Function?d(c):goog.defineClass.applyProperties_(c,d));return c};goog.defineClass.SEAL_CLASS_INSTANCES=goog.DEBUG;
goog.defineClass.createSealingConstructor_=function(a,b){return goog.defineClass.SEAL_CLASS_INSTANCES?function(){var c=a.apply(this,arguments)||this;c[goog.UID_PROPERTY_]=c[goog.UID_PROPERTY_];return c}:a};goog.defineClass.OBJECT_PROTOTYPE_FIELDS_="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
goog.defineClass.applyProperties_=function(a,b){for(var c in b)Object.prototype.hasOwnProperty.call(b,c)&&(a[c]=b[c]);for(var d=0;d<goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length;d++)c=goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[d],Object.prototype.hasOwnProperty.call(b,c)&&(a[c]=b[c])};
!COMPILED&&goog.DEPENDENCIES_ENABLED&&(goog.inHtmlDocument_=function(){var a=goog.global.document;return null!=a&&"write"in a},goog.isDocumentLoading_=function(){var a=goog.global.document;return a.attachEvent?"complete"!=a.readyState:"loading"==a.readyState},goog.findBasePath_=function(){if(void 0!=goog.global.CLOSURE_BASE_PATH&&"string"===typeof goog.global.CLOSURE_BASE_PATH)goog.basePath=goog.global.CLOSURE_BASE_PATH;else if(goog.inHtmlDocument_()){var a=goog.global.document,b=a.currentScript;
a=b?[b]:a.getElementsByTagName("SCRIPT");for(b=a.length-1;0<=b;--b){var c=a[b].src,d=c.lastIndexOf("?");d=-1==d?c.length:d;if("base.js"==c.substr(d-7,7)){goog.basePath=c.substr(0,d-7);break}}}},goog.findBasePath_(),goog.Transpiler=function(){this.requiresTranspilation_=null;this.transpilationTarget_=goog.TRANSPILE_TO_LANGUAGE},goog.Transpiler.prototype.createRequiresTranspilation_=function(){function a(g,h){e?d[g]=!0:h()?(c=g,d[g]=!1):e=d[g]=!0}function b(g){try{return!!eval(g)}catch(h){return!1}}
var c="es3",d={es3:!1},e=!1,f=goog.global.navigator&&goog.global.navigator.userAgent?goog.global.navigator.userAgent:"";a("es5",function(){return b("[1,].length==1")});a("es6",function(){return f.match(/Edge\/(\d+)(\.\d)*/i)?!1:b('(()=>{"use strict";class X{constructor(){if(new.target!=String)throw 1;this.x=42}}let q=Reflect.construct(X,[],String);if(q.x!=42||!(q instanceof String))throw 1;for(const a of[2,3]){if(a==2)continue;function f(z={a}){let a=0;return z.a}{function f(){return 0;}}return f()==3}})()')});
a("es7",function(){return b("2 ** 2 == 4")});a("es8",function(){return b("async () => 1, true")});a("es9",function(){return b("({...rest} = {}), true")});a("es_next",function(){return!1});return{target:c,map:d}},goog.Transpiler.prototype.needsTranspile=function(a,b){if("always"==goog.TRANSPILE)return!0;if("never"==goog.TRANSPILE)return!1;if(!this.requiresTranspilation_){var c=this.createRequiresTranspilation_();this.requiresTranspilation_=c.map;this.transpilationTarget_=this.transpilationTarget_||
c.target}if(a in this.requiresTranspilation_)return this.requiresTranspilation_[a]?!0:!goog.inHtmlDocument_()||"es6"!=b||"noModule"in goog.global.document.createElement("script")?!1:!0;throw Error("Unknown language mode: "+a);},goog.Transpiler.prototype.transpile=function(a,b){return goog.transpile_(a,b,this.transpilationTarget_)},goog.transpiler_=new goog.Transpiler,goog.protectScriptTag_=function(a){return a.replace(/<\/(SCRIPT)/ig,"\\x3c/$1")},goog.DebugLoader_=function(){this.dependencies_={};
this.idToPath_={};this.written_={};this.loadingDeps_=[];this.depsToLoad_=[];this.paused_=!1;this.factory_=new goog.DependencyFactory(goog.transpiler_);this.deferredCallbacks_={};this.deferredQueue_=[]},goog.DebugLoader_.prototype.bootstrap=function(a,b){function c(){d&&(goog.global.setTimeout(d,0),d=null)}var d=b;if(a.length){b=[];for(var e=0;e<a.length;e++){var f=this.getPathFromDeps_(a[e]);if(!f)throw Error("Unregonized namespace: "+a[e]);b.push(this.dependencies_[f])}f=goog.require;var g=0;for(e=
0;e<a.length;e++)f(a[e]),b[e].onLoad(function(){++g==a.length&&c()})}else c()},goog.DebugLoader_.prototype.loadClosureDeps=function(){this.depsToLoad_.push(this.factory_.createDependency(goog.normalizePath_(goog.basePath+"deps.js"),"deps.js",[],[],{},!1));this.loadDeps_()},goog.DebugLoader_.prototype.requested=function(a,b){(a=this.getPathFromDeps_(a))&&(b||this.areDepsLoaded_(this.dependencies_[a].requires))&&(b=this.deferredCallbacks_[a])&&(delete this.deferredCallbacks_[a],b())},goog.DebugLoader_.prototype.setDependencyFactory=
function(a){this.factory_=a},goog.DebugLoader_.prototype.load_=function(a){if(this.getPathFromDeps_(a)){var b=this,c=[],d=function(e){var f=b.getPathFromDeps_(e);if(!f)throw Error("Bad dependency path or symbol: "+e);if(!b.written_[f]){b.written_[f]=!0;e=b.dependencies_[f];for(f=0;f<e.requires.length;f++)goog.isProvided_(e.requires[f])||d(e.requires[f]);c.push(e)}};d(a);a=!!this.depsToLoad_.length;this.depsToLoad_=this.depsToLoad_.concat(c);this.paused_||a||this.loadDeps_()}else throw a="goog.require could not find: "+
a,goog.logToConsole_(a),Error(a);},goog.DebugLoader_.prototype.loadDeps_=function(){for(var a=this,b=this.paused_;this.depsToLoad_.length&&!b;)(function(){var c=!1,d=a.depsToLoad_.shift(),e=!1;a.loading_(d);var f={pause:function(){if(c)throw Error("Cannot call pause after the call to load.");b=!0},resume:function(){c?a.resume_():b=!1},loaded:function(){if(e)throw Error("Double call to loaded.");e=!0;a.loaded_(d)},pending:function(){for(var g=[],h=0;h<a.loadingDeps_.length;h++)g.push(a.loadingDeps_[h]);
return g},setModuleState:function(g){goog.moduleLoaderState_={type:g,moduleName:"",declareLegacyNamespace:!1}},registerEs6ModuleExports:function(g,h,k){k&&(goog.loadedModules_[k]={exports:h,type:goog.ModuleType.ES6,moduleId:k||""})},registerGoogModuleExports:function(g,h){goog.loadedModules_[g]={exports:h,type:goog.ModuleType.GOOG,moduleId:g}},clearModuleState:function(){goog.moduleLoaderState_=null},defer:function(g){if(c)throw Error("Cannot register with defer after the call to load.");a.defer_(d,
g)},areDepsLoaded:function(){return a.areDepsLoaded_(d.requires)}};try{d.load(f)}finally{c=!0}})();b&&this.pause_()},goog.DebugLoader_.prototype.pause_=function(){this.paused_=!0},goog.DebugLoader_.prototype.resume_=function(){this.paused_&&(this.paused_=!1,this.loadDeps_())},goog.DebugLoader_.prototype.loading_=function(a){this.loadingDeps_.push(a)},goog.DebugLoader_.prototype.loaded_=function(a){for(var b=0;b<this.loadingDeps_.length;b++)if(this.loadingDeps_[b]==a){this.loadingDeps_.splice(b,1);
break}for(b=0;b<this.deferredQueue_.length;b++)if(this.deferredQueue_[b]==a.path){this.deferredQueue_.splice(b,1);break}if(this.loadingDeps_.length==this.deferredQueue_.length&&!this.depsToLoad_.length)for(;this.deferredQueue_.length;)this.requested(this.deferredQueue_.shift(),!0);a.loaded()},goog.DebugLoader_.prototype.areDepsLoaded_=function(a){for(var b=0;b<a.length;b++){var c=this.getPathFromDeps_(a[b]);if(!c||!(c in this.deferredCallbacks_||goog.isProvided_(a[b])))return!1}return!0},goog.DebugLoader_.prototype.getPathFromDeps_=
function(a){return a in this.idToPath_?this.idToPath_[a]:a in this.dependencies_?a:null},goog.DebugLoader_.prototype.defer_=function(a,b){this.deferredCallbacks_[a.path]=b;this.deferredQueue_.push(a.path)},goog.LoadController=function(){},goog.LoadController.prototype.pause=function(){},goog.LoadController.prototype.resume=function(){},goog.LoadController.prototype.loaded=function(){},goog.LoadController.prototype.pending=function(){},goog.LoadController.prototype.registerEs6ModuleExports=function(a,
b,c){},goog.LoadController.prototype.setModuleState=function(a){},goog.LoadController.prototype.clearModuleState=function(){},goog.LoadController.prototype.defer=function(a){},goog.LoadController.prototype.areDepsLoaded=function(){},goog.Dependency=function(a,b,c,d,e){this.path=a;this.relativePath=b;this.provides=c;this.requires=d;this.loadFlags=e;this.loaded_=!1;this.loadCallbacks_=[]},goog.Dependency.prototype.getPathName=function(){var a=this.path,b=a.indexOf("://");0<=b&&(a=a.substring(b+3),b=
a.indexOf("/"),0<=b&&(a=a.substring(b+1)));return a},goog.Dependency.prototype.onLoad=function(a){this.loaded_?a():this.loadCallbacks_.push(a)},goog.Dependency.prototype.loaded=function(){this.loaded_=!0;var a=this.loadCallbacks_;this.loadCallbacks_=[];for(var b=0;b<a.length;b++)a[b]()},goog.Dependency.defer_=!1,goog.Dependency.callbackMap_={},goog.Dependency.registerCallback_=function(a){var b=Math.random().toString(32);goog.Dependency.callbackMap_[b]=a;return b},goog.Dependency.unregisterCallback_=
function(a){delete goog.Dependency.callbackMap_[a]},goog.Dependency.callback_=function(a,b){if(a in goog.Dependency.callbackMap_){for(var c=goog.Dependency.callbackMap_[a],d=[],e=1;e<arguments.length;e++)d.push(arguments[e]);c.apply(void 0,d)}else throw Error("Callback key "+a+" does not exist (was base.js loaded more than once?).");},goog.Dependency.prototype.load=function(a){if(goog.global.CLOSURE_IMPORT_SCRIPT)goog.global.CLOSURE_IMPORT_SCRIPT(this.path)?a.loaded():a.pause();else if(goog.inHtmlDocument_()){var b=
goog.global.document;if("complete"==b.readyState&&!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING){if(/\bdeps.js$/.test(this.path)){a.loaded();return}throw Error('Cannot write "'+this.path+'" after document load');}var c=goog.getScriptNonce();if(!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING&&goog.isDocumentLoading_()){var d=function(h){h.readyState&&"complete"!=h.readyState?h.onload=d:(goog.Dependency.unregisterCallback_(e),a.loaded())};var e=goog.Dependency.registerCallback_(d);c=c?' nonce="'+c+'"':"";
var f='<script src="'+this.path+'"'+c+(goog.Dependency.defer_?" defer":"")+' id="script-'+e+'">\x3c/script>';f+="<script"+c+">";f=goog.Dependency.defer_?f+("document.getElementById('script-"+e+"').onload = function() {\n  goog.Dependency.callback_('"+e+"', this);\n};\n"):f+("goog.Dependency.callback_('"+e+"', document.getElementById('script-"+e+"'));");f+="\x3c/script>";b.write(goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createHTML(f):f)}else{var g=b.createElement("script");g.defer=goog.Dependency.defer_;
g.async=!1;c&&(g.nonce=c);goog.DebugLoader_.IS_OLD_IE_?(a.pause(),g.onreadystatechange=function(){if("loaded"==g.readyState||"complete"==g.readyState)a.loaded(),a.resume()}):g.onload=function(){g.onload=null;a.loaded()};g.src=goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createScriptURL(this.path):this.path;b.head.appendChild(g)}}else goog.logToConsole_("Cannot use default debug loader outside of HTML documents."),"deps.js"==this.relativePath?(goog.logToConsole_("Consider setting CLOSURE_IMPORT_SCRIPT before loading base.js, or setting CLOSURE_NO_DEPS to true."),
a.loaded()):a.pause()},goog.Es6ModuleDependency=function(a,b,c,d,e){goog.Dependency.call(this,a,b,c,d,e)},goog.inherits(goog.Es6ModuleDependency,goog.Dependency),goog.Es6ModuleDependency.prototype.load=function(a){function b(l,p){var m="",n=goog.getScriptNonce();n&&(m=' nonce="'+n+'"');l=p?'<script type="module" crossorigin'+m+">"+p+"\x3c/script>":'<script type="module" crossorigin src="'+l+'"'+m+">\x3c/script>";d.write(goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createHTML(l):l)}function c(l,
p){var m=d.createElement("script");m.defer=!0;m.async=!1;m.type="module";m.setAttribute("crossorigin",!0);var n=goog.getScriptNonce();n&&(m.nonce=n);p?m.text=goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createScript(p):p:m.src=goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createScriptURL(l):l;d.head.appendChild(m)}if(goog.global.CLOSURE_IMPORT_SCRIPT)goog.global.CLOSURE_IMPORT_SCRIPT(this.path)?a.loaded():a.pause();else if(goog.inHtmlDocument_()){var d=goog.global.document,e=this;
if(goog.isDocumentLoading_()){var f=b;goog.Dependency.defer_=!0}else f=c;var g=goog.Dependency.registerCallback_(function(){goog.Dependency.unregisterCallback_(g);a.setModuleState(goog.ModuleType.ES6)});f(void 0,'goog.Dependency.callback_("'+g+'")');f(this.path,void 0);var h=goog.Dependency.registerCallback_(function(l){goog.Dependency.unregisterCallback_(h);a.registerEs6ModuleExports(e.path,l,goog.moduleLoaderState_.moduleName)});f(void 0,'import * as m from "'+this.path+'"; goog.Dependency.callback_("'+
h+'", m)');var k=goog.Dependency.registerCallback_(function(){goog.Dependency.unregisterCallback_(k);a.clearModuleState();a.loaded()});f(void 0,'goog.Dependency.callback_("'+k+'")')}else goog.logToConsole_("Cannot use default debug loader outside of HTML documents."),a.pause()},goog.TransformedDependency=function(a,b,c,d,e){goog.Dependency.call(this,a,b,c,d,e);this.contents_=null;this.lazyFetch_=!goog.inHtmlDocument_()||!("noModule"in goog.global.document.createElement("script"))},goog.inherits(goog.TransformedDependency,
goog.Dependency),goog.TransformedDependency.prototype.load=function(a){function b(){e.contents_=goog.loadFileSync_(e.path);e.contents_&&(e.contents_=e.transform(e.contents_),e.contents_&&(e.contents_+="\n//# sourceURL="+e.path))}function c(){e.lazyFetch_&&b();if(e.contents_){f&&a.setModuleState(goog.ModuleType.ES6);try{var p=e.contents_;e.contents_=null;goog.globalEval(p);if(f)var m=goog.moduleLoaderState_.moduleName}finally{f&&a.clearModuleState()}f&&goog.global.$jscomp.require.ensure([e.getPathName()],
function(){a.registerEs6ModuleExports(e.path,goog.global.$jscomp.require(e.getPathName()),m)});a.loaded()}}function d(){var p=goog.global.document,m=goog.Dependency.registerCallback_(function(){goog.Dependency.unregisterCallback_(m);c()}),n=goog.getScriptNonce();n="<script"+(n?' nonce="'+n+'"':"")+">"+goog.protectScriptTag_('goog.Dependency.callback_("'+m+'");')+"\x3c/script>";p.write(goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createHTML(n):n)}var e=this;if(goog.global.CLOSURE_IMPORT_SCRIPT)b(),
this.contents_&&goog.global.CLOSURE_IMPORT_SCRIPT("",this.contents_)?(this.contents_=null,a.loaded()):a.pause();else{var f=this.loadFlags.module==goog.ModuleType.ES6;this.lazyFetch_||b();var g=1<a.pending().length,h=g&&goog.DebugLoader_.IS_OLD_IE_;g=goog.Dependency.defer_&&(g||goog.isDocumentLoading_());if(h||g)a.defer(function(){c()});else{var k=goog.global.document;h=goog.inHtmlDocument_()&&"ActiveXObject"in goog.global;if(f&&goog.inHtmlDocument_()&&goog.isDocumentLoading_()&&!h){goog.Dependency.defer_=
!0;a.pause();var l=k.onreadystatechange;k.onreadystatechange=function(){"interactive"==k.readyState&&(k.onreadystatechange=l,c(),a.resume());"function"===typeof l&&l.apply(void 0,arguments)}}else!goog.DebugLoader_.IS_OLD_IE_&&goog.inHtmlDocument_()&&goog.isDocumentLoading_()?d():c()}}},goog.TransformedDependency.prototype.transform=function(a){},goog.TranspiledDependency=function(a,b,c,d,e,f){goog.TransformedDependency.call(this,a,b,c,d,e);this.transpiler=f},goog.inherits(goog.TranspiledDependency,
goog.TransformedDependency),goog.TranspiledDependency.prototype.transform=function(a){return this.transpiler.transpile(a,this.getPathName())},goog.PreTranspiledEs6ModuleDependency=function(a,b,c,d,e){goog.TransformedDependency.call(this,a,b,c,d,e)},goog.inherits(goog.PreTranspiledEs6ModuleDependency,goog.TransformedDependency),goog.PreTranspiledEs6ModuleDependency.prototype.transform=function(a){return a},goog.GoogModuleDependency=function(a,b,c,d,e,f,g){goog.TransformedDependency.call(this,a,b,c,
d,e);this.needsTranspile_=f;this.transpiler_=g},goog.inherits(goog.GoogModuleDependency,goog.TransformedDependency),goog.GoogModuleDependency.prototype.transform=function(a){this.needsTranspile_&&(a=this.transpiler_.transpile(a,this.getPathName()));return goog.LOAD_MODULE_USING_EVAL&&void 0!==goog.global.JSON?"goog.loadModule("+goog.global.JSON.stringify(a+"\n//# sourceURL="+this.path+"\n")+");":'goog.loadModule(function(exports) {"use strict";'+a+"\n;return exports});\n//# sourceURL="+this.path+
"\n"},goog.DebugLoader_.IS_OLD_IE_=!(goog.global.atob||!goog.global.document||!goog.global.document.all),goog.DebugLoader_.prototype.addDependency=function(a,b,c,d){b=b||[];a=a.replace(/\\/g,"/");var e=goog.normalizePath_(goog.basePath+a);d&&"boolean"!==typeof d||(d=d?{module:goog.ModuleType.GOOG}:{});c=this.factory_.createDependency(e,a,b,c,d,goog.transpiler_.needsTranspile(d.lang||"es3",d.module));this.dependencies_[e]=c;for(c=0;c<b.length;c++)this.idToPath_[b[c]]=e;this.idToPath_[a]=e},goog.DependencyFactory=
function(a){this.transpiler=a},goog.DependencyFactory.prototype.createDependency=function(a,b,c,d,e,f){return e.module==goog.ModuleType.GOOG?new goog.GoogModuleDependency(a,b,c,d,e,f,this.transpiler):f?new goog.TranspiledDependency(a,b,c,d,e,this.transpiler):e.module==goog.ModuleType.ES6?"never"==goog.TRANSPILE&&goog.ASSUME_ES_MODULES_TRANSPILED?new goog.PreTranspiledEs6ModuleDependency(a,b,c,d,e):new goog.Es6ModuleDependency(a,b,c,d,e):new goog.Dependency(a,b,c,d,e)},goog.debugLoader_=new goog.DebugLoader_,
goog.loadClosureDeps=function(){goog.debugLoader_.loadClosureDeps()},goog.setDependencyFactory=function(a){goog.debugLoader_.setDependencyFactory(a)},goog.TRUSTED_TYPES_POLICY_=goog.TRUSTED_TYPES_POLICY_NAME?goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME+"#base"):null,goog.global.CLOSURE_NO_DEPS||goog.debugLoader_.loadClosureDeps(),goog.bootstrap=function(a,b){goog.debugLoader_.bootstrap(a,b)});goog.TRUSTED_TYPES_POLICY_NAME="goog";goog.identity_=function(a){return a};
goog.createTrustedTypesPolicy=function(a){var b=null,c=goog.global.trustedTypes;if(!c||!c.createPolicy)return b;try{b=c.createPolicy(a,{createHTML:goog.identity_,createScript:goog.identity_,createScriptURL:goog.identity_})}catch(d){goog.logToConsole_(d.message)}return b};goog.debug={};function module$contents$goog$debug$Error_DebugError(a){if(Error.captureStackTrace)Error.captureStackTrace(this,module$contents$goog$debug$Error_DebugError);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a));this.reportErrorToServer=!0}goog.inherits(module$contents$goog$debug$Error_DebugError,Error);module$contents$goog$debug$Error_DebugError.prototype.name="CustomError";goog.debug.Error=module$contents$goog$debug$Error_DebugError;goog.dom={};goog.dom.NodeType={ELEMENT:1,ATTRIBUTE:2,TEXT:3,CDATA_SECTION:4,ENTITY_REFERENCE:5,ENTITY:6,PROCESSING_INSTRUCTION:7,COMMENT:8,DOCUMENT:9,DOCUMENT_TYPE:10,DOCUMENT_FRAGMENT:11,NOTATION:12};goog.asserts={};goog.asserts.ENABLE_ASSERTS=goog.DEBUG;goog.asserts.AssertionError=function(a,b){module$contents$goog$debug$Error_DebugError.call(this,goog.asserts.subs_(a,b));this.messagePattern=a};goog.inherits(goog.asserts.AssertionError,module$contents$goog$debug$Error_DebugError);goog.asserts.AssertionError.prototype.name="AssertionError";goog.asserts.DEFAULT_ERROR_HANDLER=function(a){throw a;};goog.asserts.errorHandler_=goog.asserts.DEFAULT_ERROR_HANDLER;
goog.asserts.subs_=function(a,b){a=a.split("%s");for(var c="",d=a.length-1,e=0;e<d;e++)c+=a[e]+(e<b.length?b[e]:"%s");return c+a[d]};goog.asserts.doAssertFailure_=function(a,b,c,d){var e="Assertion failed";if(c){e+=": "+c;var f=d}else a&&(e+=": "+a,f=b);a=new goog.asserts.AssertionError(""+e,f||[]);goog.asserts.errorHandler_(a)};goog.asserts.setErrorHandler=function(a){goog.asserts.ENABLE_ASSERTS&&(goog.asserts.errorHandler_=a)};
goog.asserts.assert=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!a&&goog.asserts.doAssertFailure_("",null,b,Array.prototype.slice.call(arguments,2));return a};goog.asserts.assertExists=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&null==a&&goog.asserts.doAssertFailure_("Expected to exist: %s.",[a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.fail=function(a,b){goog.asserts.ENABLE_ASSERTS&&goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1)))};goog.asserts.assertNumber=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&"number"!==typeof a&&goog.asserts.doAssertFailure_("Expected number but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.assertString=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&"string"!==typeof a&&goog.asserts.doAssertFailure_("Expected string but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};goog.asserts.assertFunction=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&"function"!==typeof a&&goog.asserts.doAssertFailure_("Expected function but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.assertObject=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!goog.isObject(a)&&goog.asserts.doAssertFailure_("Expected object but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};goog.asserts.assertArray=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!Array.isArray(a)&&goog.asserts.doAssertFailure_("Expected array but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.assertBoolean=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&"boolean"!==typeof a&&goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};goog.asserts.assertElement=function(a,b,c){!goog.asserts.ENABLE_ASSERTS||goog.isObject(a)&&a.nodeType==goog.dom.NodeType.ELEMENT||goog.asserts.doAssertFailure_("Expected Element but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.assertInstanceof=function(a,b,c,d){!goog.asserts.ENABLE_ASSERTS||a instanceof b||goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.",[goog.asserts.getType_(b),goog.asserts.getType_(a)],c,Array.prototype.slice.call(arguments,3));return a};goog.asserts.assertFinite=function(a,b,c){!goog.asserts.ENABLE_ASSERTS||"number"==typeof a&&isFinite(a)||goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.",[a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.assertObjectPrototypeIsIntact=function(){for(var a in Object.prototype)goog.asserts.fail(a+" should not be enumerable in Object.prototype.")};goog.asserts.getType_=function(a){return a instanceof Function?a.displayName||a.name||"unknown type name":a instanceof Object?a.constructor.displayName||a.constructor.name||Object.prototype.toString.call(a):null===a?"null":typeof a};goog.array={};goog.NATIVE_ARRAY_PROTOTYPES=goog.TRUSTED_SITE;var module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS=2012<goog.FEATURESET_YEAR;goog.array.ASSUME_NATIVE_FUNCTIONS=module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS;function module$contents$goog$array_peek(a){return a[a.length-1]}goog.array.peek=module$contents$goog$array_peek;goog.array.last=module$contents$goog$array_peek;
var module$contents$goog$array_indexOf=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.indexOf)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if("string"===typeof a)return"string"!==typeof b||1!=b.length?-1:a.indexOf(b,c);for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1};goog.array.indexOf=module$contents$goog$array_indexOf;
var module$contents$goog$array_lastIndexOf=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.lastIndexOf)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.lastIndexOf.call(a,b,null==c?a.length-1:c)}:function(a,b,c){c=null==c?a.length-1:c;0>c&&(c=Math.max(0,a.length+c));if("string"===typeof a)return"string"!==typeof b||1!=b.length?-1:a.lastIndexOf(b,c);for(;0<=c;c--)if(c in a&&a[c]===b)return c;return-1};
goog.array.lastIndexOf=module$contents$goog$array_lastIndexOf;var module$contents$goog$array_forEach=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.forEach)?function(a,b,c){goog.asserts.assert(null!=a.length);Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e="string"===typeof a?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};goog.array.forEach=module$contents$goog$array_forEach;
function module$contents$goog$array_forEachRight(a,b,c){var d=a.length,e="string"===typeof a?a.split(""):a;for(--d;0<=d;--d)d in e&&b.call(c,e[d],d,a)}goog.array.forEachRight=module$contents$goog$array_forEachRight;
var module$contents$goog$array_filter=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.filter)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.filter.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=[],f=0,g="string"===typeof a?a.split(""):a,h=0;h<d;h++)if(h in g){var k=g[h];b.call(c,k,h,a)&&(e[f++]=k)}return e};goog.array.filter=module$contents$goog$array_filter;
var module$contents$goog$array_map=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.map)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f="string"===typeof a?a.split(""):a,g=0;g<d;g++)g in f&&(e[g]=b.call(c,f[g],g,a));return e};goog.array.map=module$contents$goog$array_map;
var module$contents$goog$array_reduce=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.reduce)?function(a,b,c,d){goog.asserts.assert(null!=a.length);d&&(b=goog.bind(b,d));return Array.prototype.reduce.call(a,b,c)}:function(a,b,c,d){var e=c;module$contents$goog$array_forEach(a,function(f,g){e=b.call(d,e,f,g,a)});return e};goog.array.reduce=module$contents$goog$array_reduce;
var module$contents$goog$array_reduceRight=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.reduceRight)?function(a,b,c,d){goog.asserts.assert(null!=a.length);goog.asserts.assert(null!=b);d&&(b=goog.bind(b,d));return Array.prototype.reduceRight.call(a,b,c)}:function(a,b,c,d){var e=c;module$contents$goog$array_forEachRight(a,function(f,g){e=b.call(d,e,f,g,a)});return e};goog.array.reduceRight=module$contents$goog$array_reduceRight;
var module$contents$goog$array_some=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.some)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.some.call(a,b,c)}:function(a,b,c){for(var d=a.length,e="string"===typeof a?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return!0;return!1};goog.array.some=module$contents$goog$array_some;
var module$contents$goog$array_every=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.every)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.every.call(a,b,c)}:function(a,b,c){for(var d=a.length,e="string"===typeof a?a.split(""):a,f=0;f<d;f++)if(f in e&&!b.call(c,e[f],f,a))return!1;return!0};goog.array.every=module$contents$goog$array_every;
function module$contents$goog$array_count(a,b,c){var d=0;module$contents$goog$array_forEach(a,function(e,f,g){b.call(c,e,f,g)&&++d},c);return d}goog.array.count=module$contents$goog$array_count;function module$contents$goog$array_find(a,b,c){b=module$contents$goog$array_findIndex(a,b,c);return 0>b?null:"string"===typeof a?a.charAt(b):a[b]}goog.array.find=module$contents$goog$array_find;
function module$contents$goog$array_findIndex(a,b,c){for(var d=a.length,e="string"===typeof a?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return f;return-1}goog.array.findIndex=module$contents$goog$array_findIndex;function module$contents$goog$array_findRight(a,b,c){b=module$contents$goog$array_findIndexRight(a,b,c);return 0>b?null:"string"===typeof a?a.charAt(b):a[b]}goog.array.findRight=module$contents$goog$array_findRight;
function module$contents$goog$array_findIndexRight(a,b,c){var d=a.length,e="string"===typeof a?a.split(""):a;for(--d;0<=d;d--)if(d in e&&b.call(c,e[d],d,a))return d;return-1}goog.array.findIndexRight=module$contents$goog$array_findIndexRight;function module$contents$goog$array_contains(a,b){return 0<=module$contents$goog$array_indexOf(a,b)}goog.array.contains=module$contents$goog$array_contains;function module$contents$goog$array_isEmpty(a){return 0==a.length}goog.array.isEmpty=module$contents$goog$array_isEmpty;
function module$contents$goog$array_clear(a){if(!Array.isArray(a))for(var b=a.length-1;0<=b;b--)delete a[b];a.length=0}goog.array.clear=module$contents$goog$array_clear;function module$contents$goog$array_insert(a,b){module$contents$goog$array_contains(a,b)||a.push(b)}goog.array.insert=module$contents$goog$array_insert;function module$contents$goog$array_insertAt(a,b,c){module$contents$goog$array_splice(a,c,0,b)}goog.array.insertAt=module$contents$goog$array_insertAt;
function module$contents$goog$array_insertArrayAt(a,b,c){goog.partial(module$contents$goog$array_splice,a,c,0).apply(null,b)}goog.array.insertArrayAt=module$contents$goog$array_insertArrayAt;function module$contents$goog$array_insertBefore(a,b,c){var d;2==arguments.length||0>(d=module$contents$goog$array_indexOf(a,c))?a.push(b):module$contents$goog$array_insertAt(a,b,d)}goog.array.insertBefore=module$contents$goog$array_insertBefore;
function module$contents$goog$array_remove(a,b){b=module$contents$goog$array_indexOf(a,b);var c;(c=0<=b)&&module$contents$goog$array_removeAt(a,b);return c}goog.array.remove=module$contents$goog$array_remove;function module$contents$goog$array_removeLast(a,b){b=module$contents$goog$array_lastIndexOf(a,b);return 0<=b?(module$contents$goog$array_removeAt(a,b),!0):!1}goog.array.removeLast=module$contents$goog$array_removeLast;
function module$contents$goog$array_removeAt(a,b){goog.asserts.assert(null!=a.length);return 1==Array.prototype.splice.call(a,b,1).length}goog.array.removeAt=module$contents$goog$array_removeAt;function module$contents$goog$array_removeIf(a,b,c){b=module$contents$goog$array_findIndex(a,b,c);return 0<=b?(module$contents$goog$array_removeAt(a,b),!0):!1}goog.array.removeIf=module$contents$goog$array_removeIf;
function module$contents$goog$array_removeAllIf(a,b,c){var d=0;module$contents$goog$array_forEachRight(a,function(e,f){b.call(c,e,f,a)&&module$contents$goog$array_removeAt(a,f)&&d++});return d}goog.array.removeAllIf=module$contents$goog$array_removeAllIf;function module$contents$goog$array_concat(a){return Array.prototype.concat.apply([],arguments)}goog.array.concat=module$contents$goog$array_concat;function module$contents$goog$array_join(a){return Array.prototype.concat.apply([],arguments)}
goog.array.join=module$contents$goog$array_join;function module$contents$goog$array_toArray(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]}var module$contents$goog$array_clone=goog.array.toArray=module$contents$goog$array_toArray;goog.array.clone=module$contents$goog$array_clone;
function module$contents$goog$array_extend(a,b){for(var c=1;c<arguments.length;c++){var d=arguments[c];if(goog.isArrayLike(d)){var e=a.length||0,f=d.length||0;a.length=e+f;for(var g=0;g<f;g++)a[e+g]=d[g]}else a.push(d)}}goog.array.extend=module$contents$goog$array_extend;function module$contents$goog$array_splice(a,b,c,d){goog.asserts.assert(null!=a.length);return Array.prototype.splice.apply(a,module$contents$goog$array_slice(arguments,1))}goog.array.splice=module$contents$goog$array_splice;
function module$contents$goog$array_slice(a,b,c){goog.asserts.assert(null!=a.length);return 2>=arguments.length?Array.prototype.slice.call(a,b):Array.prototype.slice.call(a,b,c)}goog.array.slice=module$contents$goog$array_slice;
function module$contents$goog$array_removeDuplicates(a,b,c){b=b||a;var d=function(k){return goog.isObject(k)?"o"+goog.getUid(k):(typeof k).charAt(0)+k};c=c||d;d={};for(var e=0,f=0;f<a.length;){var g=a[f++],h=c(g);Object.prototype.hasOwnProperty.call(d,h)||(d[h]=!0,b[e++]=g)}b.length=e}goog.array.removeDuplicates=module$contents$goog$array_removeDuplicates;
function module$contents$goog$array_binarySearch(a,b,c){return module$contents$goog$array_binarySearch_(a,c||module$contents$goog$array_defaultCompare,!1,b)}goog.array.binarySearch=module$contents$goog$array_binarySearch;function module$contents$goog$array_binarySelect(a,b,c){return module$contents$goog$array_binarySearch_(a,b,!0,void 0,c)}goog.array.binarySelect=module$contents$goog$array_binarySelect;
function module$contents$goog$array_binarySearch_(a,b,c,d,e){for(var f=0,g=a.length,h;f<g;){var k=f+(g-f>>>1);var l=c?b.call(e,a[k],k,a):b(d,a[k]);0<l?f=k+1:(g=k,h=!l)}return h?f:-f-1}function module$contents$goog$array_sort(a,b){a.sort(b||module$contents$goog$array_defaultCompare)}goog.array.sort=module$contents$goog$array_sort;
function module$contents$goog$array_stableSort(a,b){for(var c=Array(a.length),d=0;d<a.length;d++)c[d]={index:d,value:a[d]};var e=b||module$contents$goog$array_defaultCompare;module$contents$goog$array_sort(c,function(f,g){return e(f.value,g.value)||f.index-g.index});for(d=0;d<a.length;d++)a[d]=c[d].value}goog.array.stableSort=module$contents$goog$array_stableSort;
function module$contents$goog$array_sortByKey(a,b,c){var d=c||module$contents$goog$array_defaultCompare;module$contents$goog$array_sort(a,function(e,f){return d(b(e),b(f))})}goog.array.sortByKey=module$contents$goog$array_sortByKey;function module$contents$goog$array_sortObjectsByKey(a,b,c){module$contents$goog$array_sortByKey(a,function(d){return d[b]},c)}goog.array.sortObjectsByKey=module$contents$goog$array_sortObjectsByKey;
function module$contents$goog$array_isSorted(a,b,c){b=b||module$contents$goog$array_defaultCompare;for(var d=1;d<a.length;d++){var e=b(a[d-1],a[d]);if(0<e||0==e&&c)return!1}return!0}goog.array.isSorted=module$contents$goog$array_isSorted;function module$contents$goog$array_equals(a,b,c){if(!goog.isArrayLike(a)||!goog.isArrayLike(b)||a.length!=b.length)return!1;var d=a.length;c=c||module$contents$goog$array_defaultCompareEquality;for(var e=0;e<d;e++)if(!c(a[e],b[e]))return!1;return!0}
goog.array.equals=module$contents$goog$array_equals;function module$contents$goog$array_compare3(a,b,c){c=c||module$contents$goog$array_defaultCompare;for(var d=Math.min(a.length,b.length),e=0;e<d;e++){var f=c(a[e],b[e]);if(0!=f)return f}return module$contents$goog$array_defaultCompare(a.length,b.length)}goog.array.compare3=module$contents$goog$array_compare3;function module$contents$goog$array_defaultCompare(a,b){return a>b?1:a<b?-1:0}goog.array.defaultCompare=module$contents$goog$array_defaultCompare;
function module$contents$goog$array_inverseDefaultCompare(a,b){return-module$contents$goog$array_defaultCompare(a,b)}goog.array.inverseDefaultCompare=module$contents$goog$array_inverseDefaultCompare;function module$contents$goog$array_defaultCompareEquality(a,b){return a===b}goog.array.defaultCompareEquality=module$contents$goog$array_defaultCompareEquality;
function module$contents$goog$array_binaryInsert(a,b,c){c=module$contents$goog$array_binarySearch(a,b,c);return 0>c?(module$contents$goog$array_insertAt(a,b,-(c+1)),!0):!1}goog.array.binaryInsert=module$contents$goog$array_binaryInsert;function module$contents$goog$array_binaryRemove(a,b,c){b=module$contents$goog$array_binarySearch(a,b,c);return 0<=b?module$contents$goog$array_removeAt(a,b):!1}goog.array.binaryRemove=module$contents$goog$array_binaryRemove;
function module$contents$goog$array_bucket(a,b,c){for(var d={},e=0;e<a.length;e++){var f=a[e],g=b.call(c,f,e,a);void 0!==g&&(d[g]||(d[g]=[])).push(f)}return d}goog.array.bucket=module$contents$goog$array_bucket;function module$contents$goog$array_toObject(a,b,c){var d={};module$contents$goog$array_forEach(a,function(e,f){d[b.call(c,e,f,a)]=e});return d}goog.array.toObject=module$contents$goog$array_toObject;
function module$contents$goog$array_range(a,b,c){var d=[],e=0,f=a;c=c||1;void 0!==b&&(e=a,f=b);if(0>c*(f-e))return[];if(0<c)for(a=e;a<f;a+=c)d.push(a);else for(a=e;a>f;a+=c)d.push(a);return d}goog.array.range=module$contents$goog$array_range;function module$contents$goog$array_repeat(a,b){for(var c=[],d=0;d<b;d++)c[d]=a;return c}goog.array.repeat=module$contents$goog$array_repeat;
function module$contents$goog$array_flatten(a){for(var b=[],c=0;c<arguments.length;c++){var d=arguments[c];if(Array.isArray(d))for(var e=0;e<d.length;e+=8192){var f=module$contents$goog$array_slice(d,e,e+8192);f=module$contents$goog$array_flatten.apply(null,f);for(var g=0;g<f.length;g++)b.push(f[g])}else b.push(d)}return b}goog.array.flatten=module$contents$goog$array_flatten;
function module$contents$goog$array_rotate(a,b){goog.asserts.assert(null!=a.length);a.length&&(b%=a.length,0<b?Array.prototype.unshift.apply(a,a.splice(-b,b)):0>b&&Array.prototype.push.apply(a,a.splice(0,-b)));return a}goog.array.rotate=module$contents$goog$array_rotate;function module$contents$goog$array_moveItem(a,b,c){goog.asserts.assert(0<=b&&b<a.length);goog.asserts.assert(0<=c&&c<a.length);b=Array.prototype.splice.call(a,b,1);Array.prototype.splice.call(a,c,0,b[0])}goog.array.moveItem=module$contents$goog$array_moveItem;
function module$contents$goog$array_zip(a){if(!arguments.length)return[];for(var b=[],c=arguments[0].length,d=1;d<arguments.length;d++)arguments[d].length<c&&(c=arguments[d].length);for(d=0;d<c;d++){for(var e=[],f=0;f<arguments.length;f++)e.push(arguments[f][d]);b.push(e)}return b}goog.array.zip=module$contents$goog$array_zip;function module$contents$goog$array_shuffle(a,b){b=b||Math.random;for(var c=a.length-1;0<c;c--){var d=Math.floor(b()*(c+1)),e=a[c];a[c]=a[d];a[d]=e}}goog.array.shuffle=module$contents$goog$array_shuffle;
function module$contents$goog$array_copyByIndex(a,b){var c=[];module$contents$goog$array_forEach(b,function(d){c.push(a[d])});return c}goog.array.copyByIndex=module$contents$goog$array_copyByIndex;function module$contents$goog$array_concatMap(a,b,c){return module$contents$goog$array_concat.apply([],module$contents$goog$array_map(a,b,c))}goog.array.concatMap=module$contents$goog$array_concatMap;goog.dom.asserts={};goog.dom.asserts.assertIsLocation=function(a){if(goog.asserts.ENABLE_ASSERTS){var b=goog.dom.asserts.getWindow_(a);b&&(!a||!(a instanceof b.Location)&&a instanceof b.Element)&&goog.asserts.fail("Argument is not a Location (or a non-Element mock); got: %s",goog.dom.asserts.debugStringForType_(a))}return a};
goog.dom.asserts.assertIsElementType_=function(a,b){if(goog.asserts.ENABLE_ASSERTS){var c=goog.dom.asserts.getWindow_(a);c&&"undefined"!=typeof c[b]&&(a&&(a instanceof c[b]||!(a instanceof c.Location||a instanceof c.Element))||goog.asserts.fail("Argument is not a %s (or a non-Element, non-Location mock); got: %s",b,goog.dom.asserts.debugStringForType_(a)))}return a};goog.dom.asserts.assertIsHTMLAnchorElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLAnchorElement")};
goog.dom.asserts.assertIsHTMLButtonElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLButtonElement")};goog.dom.asserts.assertIsHTMLLinkElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLLinkElement")};goog.dom.asserts.assertIsHTMLImageElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLImageElement")};goog.dom.asserts.assertIsHTMLAudioElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLAudioElement")};
goog.dom.asserts.assertIsHTMLVideoElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLVideoElement")};goog.dom.asserts.assertIsHTMLInputElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLInputElement")};goog.dom.asserts.assertIsHTMLTextAreaElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLTextAreaElement")};goog.dom.asserts.assertIsHTMLCanvasElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLCanvasElement")};
goog.dom.asserts.assertIsHTMLEmbedElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLEmbedElement")};goog.dom.asserts.assertIsHTMLFormElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLFormElement")};goog.dom.asserts.assertIsHTMLFrameElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLFrameElement")};goog.dom.asserts.assertIsHTMLIFrameElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLIFrameElement")};
goog.dom.asserts.assertIsHTMLObjectElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLObjectElement")};goog.dom.asserts.assertIsHTMLScriptElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLScriptElement")};
goog.dom.asserts.debugStringForType_=function(a){if(goog.isObject(a))try{return a.constructor.displayName||a.constructor.name||Object.prototype.toString.call(a)}catch(b){return"<object could not be stringified>"}else return void 0===a?"undefined":null===a?"null":typeof a};goog.dom.asserts.getWindow_=function(a){try{var b=a&&a.ownerDocument,c=b&&(b.defaultView||b.parentWindow);c=c||goog.global;if(c.Element&&c.Location)return c}catch(d){}return null};goog.dom.HtmlElement=function(){};goog.functions={};goog.functions.constant=function(a){return function(){return a}};goog.functions.FALSE=function(){return!1};goog.functions.TRUE=function(){return!0};goog.functions.NULL=function(){return null};goog.functions.identity=function(a,b){return a};goog.functions.error=function(a){return function(){throw Error(a);}};goog.functions.fail=function(a){return function(){throw a;}};
goog.functions.lock=function(a,b){b=b||0;return function(){return a.apply(this,Array.prototype.slice.call(arguments,0,b))}};goog.functions.nth=function(a){return function(){return arguments[a]}};goog.functions.partialRight=function(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var d=this;d===goog.global&&(d=void 0);var e=Array.prototype.slice.call(arguments);e.push.apply(e,c);return a.apply(d,e)}};
goog.functions.withReturnValue=function(a,b){return goog.functions.sequence(a,goog.functions.constant(b))};goog.functions.equalTo=function(a,b){return function(c){return b?a==c:a===c}};goog.functions.compose=function(a,b){var c=arguments,d=c.length;return function(){var e;d&&(e=c[d-1].apply(this,arguments));for(var f=d-2;0<=f;f--)e=c[f].call(this,e);return e}};goog.functions.sequence=function(a){var b=arguments,c=b.length;return function(){for(var d,e=0;e<c;e++)d=b[e].apply(this,arguments);return d}};
goog.functions.and=function(a){var b=arguments,c=b.length;return function(){for(var d=0;d<c;d++)if(!b[d].apply(this,arguments))return!1;return!0}};goog.functions.or=function(a){var b=arguments,c=b.length;return function(){for(var d=0;d<c;d++)if(b[d].apply(this,arguments))return!0;return!1}};goog.functions.not=function(a){return function(){return!a.apply(this,arguments)}};
goog.functions.create=function(a,b){var c=function(){};c.prototype=a.prototype;c=new c;a.apply(c,Array.prototype.slice.call(arguments,1));return c};goog.functions.CACHE_RETURN_VALUE=!0;goog.functions.cacheReturnValue=function(a){var b=!1,c;return function(){if(!goog.functions.CACHE_RETURN_VALUE)return a();b||(c=a(),b=!0);return c}};goog.functions.once=function(a){var b=a;return function(){if(b){var c=b;b=null;c()}}};
goog.functions.debounce=function(a,b,c){var d=0;return function(e){goog.global.clearTimeout(d);var f=arguments;d=goog.global.setTimeout(function(){a.apply(c,f)},b)}};goog.functions.throttle=function(a,b,c){var d=0,e=!1,f=[],g=function(){d=0;e&&(e=!1,h())},h=function(){d=goog.global.setTimeout(g,b);a.apply(c,f)};return function(k){f=arguments;d?e=!0:h()}};goog.functions.rateLimit=function(a,b,c){var d=0,e=function(){d=0};return function(f){d||(d=goog.global.setTimeout(e,b),a.apply(c,arguments))}};
goog.functions.isFunction=function(a){return"function"===typeof a};goog.dom.TagName=function(){};goog.dom.TagName.cast=function(a,b){return a};goog.dom.TagName.prototype.toString=function(){};goog.dom.TagName.A="A";goog.dom.TagName.ABBR="ABBR";goog.dom.TagName.ACRONYM="ACRONYM";goog.dom.TagName.ADDRESS="ADDRESS";goog.dom.TagName.APPLET="APPLET";goog.dom.TagName.AREA="AREA";goog.dom.TagName.ARTICLE="ARTICLE";goog.dom.TagName.ASIDE="ASIDE";goog.dom.TagName.AUDIO="AUDIO";goog.dom.TagName.B="B";goog.dom.TagName.BASE="BASE";goog.dom.TagName.BASEFONT="BASEFONT";
goog.dom.TagName.BDI="BDI";goog.dom.TagName.BDO="BDO";goog.dom.TagName.BIG="BIG";goog.dom.TagName.BLOCKQUOTE="BLOCKQUOTE";goog.dom.TagName.BODY="BODY";goog.dom.TagName.BR="BR";goog.dom.TagName.BUTTON="BUTTON";goog.dom.TagName.CANVAS="CANVAS";goog.dom.TagName.CAPTION="CAPTION";goog.dom.TagName.CENTER="CENTER";goog.dom.TagName.CITE="CITE";goog.dom.TagName.CODE="CODE";goog.dom.TagName.COL="COL";goog.dom.TagName.COLGROUP="COLGROUP";goog.dom.TagName.COMMAND="COMMAND";goog.dom.TagName.DATA="DATA";
goog.dom.TagName.DATALIST="DATALIST";goog.dom.TagName.DD="DD";goog.dom.TagName.DEL="DEL";goog.dom.TagName.DETAILS="DETAILS";goog.dom.TagName.DFN="DFN";goog.dom.TagName.DIALOG="DIALOG";goog.dom.TagName.DIR="DIR";goog.dom.TagName.DIV="DIV";goog.dom.TagName.DL="DL";goog.dom.TagName.DT="DT";goog.dom.TagName.EM="EM";goog.dom.TagName.EMBED="EMBED";goog.dom.TagName.FIELDSET="FIELDSET";goog.dom.TagName.FIGCAPTION="FIGCAPTION";goog.dom.TagName.FIGURE="FIGURE";goog.dom.TagName.FONT="FONT";
goog.dom.TagName.FOOTER="FOOTER";goog.dom.TagName.FORM="FORM";goog.dom.TagName.FRAME="FRAME";goog.dom.TagName.FRAMESET="FRAMESET";goog.dom.TagName.H1="H1";goog.dom.TagName.H2="H2";goog.dom.TagName.H3="H3";goog.dom.TagName.H4="H4";goog.dom.TagName.H5="H5";goog.dom.TagName.H6="H6";goog.dom.TagName.HEAD="HEAD";goog.dom.TagName.HEADER="HEADER";goog.dom.TagName.HGROUP="HGROUP";goog.dom.TagName.HR="HR";goog.dom.TagName.HTML="HTML";goog.dom.TagName.I="I";goog.dom.TagName.IFRAME="IFRAME";
goog.dom.TagName.IMG="IMG";goog.dom.TagName.INPUT="INPUT";goog.dom.TagName.INS="INS";goog.dom.TagName.ISINDEX="ISINDEX";goog.dom.TagName.KBD="KBD";goog.dom.TagName.KEYGEN="KEYGEN";goog.dom.TagName.LABEL="LABEL";goog.dom.TagName.LEGEND="LEGEND";goog.dom.TagName.LI="LI";goog.dom.TagName.LINK="LINK";goog.dom.TagName.MAIN="MAIN";goog.dom.TagName.MAP="MAP";goog.dom.TagName.MARK="MARK";goog.dom.TagName.MATH="MATH";goog.dom.TagName.MENU="MENU";goog.dom.TagName.MENUITEM="MENUITEM";goog.dom.TagName.META="META";
goog.dom.TagName.METER="METER";goog.dom.TagName.NAV="NAV";goog.dom.TagName.NOFRAMES="NOFRAMES";goog.dom.TagName.NOSCRIPT="NOSCRIPT";goog.dom.TagName.OBJECT="OBJECT";goog.dom.TagName.OL="OL";goog.dom.TagName.OPTGROUP="OPTGROUP";goog.dom.TagName.OPTION="OPTION";goog.dom.TagName.OUTPUT="OUTPUT";goog.dom.TagName.P="P";goog.dom.TagName.PARAM="PARAM";goog.dom.TagName.PICTURE="PICTURE";goog.dom.TagName.PRE="PRE";goog.dom.TagName.PROGRESS="PROGRESS";goog.dom.TagName.Q="Q";goog.dom.TagName.RP="RP";
goog.dom.TagName.RT="RT";goog.dom.TagName.RTC="RTC";goog.dom.TagName.RUBY="RUBY";goog.dom.TagName.S="S";goog.dom.TagName.SAMP="SAMP";goog.dom.TagName.SCRIPT="SCRIPT";goog.dom.TagName.SECTION="SECTION";goog.dom.TagName.SELECT="SELECT";goog.dom.TagName.SMALL="SMALL";goog.dom.TagName.SOURCE="SOURCE";goog.dom.TagName.SPAN="SPAN";goog.dom.TagName.STRIKE="STRIKE";goog.dom.TagName.STRONG="STRONG";goog.dom.TagName.STYLE="STYLE";goog.dom.TagName.SUB="SUB";goog.dom.TagName.SUMMARY="SUMMARY";
goog.dom.TagName.SUP="SUP";goog.dom.TagName.SVG="SVG";goog.dom.TagName.TABLE="TABLE";goog.dom.TagName.TBODY="TBODY";goog.dom.TagName.TD="TD";goog.dom.TagName.TEMPLATE="TEMPLATE";goog.dom.TagName.TEXTAREA="TEXTAREA";goog.dom.TagName.TFOOT="TFOOT";goog.dom.TagName.TH="TH";goog.dom.TagName.THEAD="THEAD";goog.dom.TagName.TIME="TIME";goog.dom.TagName.TITLE="TITLE";goog.dom.TagName.TR="TR";goog.dom.TagName.TRACK="TRACK";goog.dom.TagName.TT="TT";goog.dom.TagName.U="U";goog.dom.TagName.UL="UL";
goog.dom.TagName.VAR="VAR";goog.dom.TagName.VIDEO="VIDEO";goog.dom.TagName.WBR="WBR";goog.object={};goog.object.forEach=function(a,b,c){for(var d in a)b.call(c,a[d],d,a)};goog.object.filter=function(a,b,c){var d={},e;for(e in a)b.call(c,a[e],e,a)&&(d[e]=a[e]);return d};goog.object.map=function(a,b,c){var d={},e;for(e in a)d[e]=b.call(c,a[e],e,a);return d};goog.object.some=function(a,b,c){for(var d in a)if(b.call(c,a[d],d,a))return!0;return!1};goog.object.every=function(a,b,c){for(var d in a)if(!b.call(c,a[d],d,a))return!1;return!0};
goog.object.getCount=function(a){var b=0,c;for(c in a)b++;return b};goog.object.getAnyKey=function(a){for(var b in a)return b};goog.object.getAnyValue=function(a){for(var b in a)return a[b]};goog.object.contains=function(a,b){return goog.object.containsValue(a,b)};goog.object.getValues=function(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b};goog.object.getKeys=function(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b};
goog.object.getValueByKeys=function(a,b){var c=goog.isArrayLike(b),d=c?b:arguments;for(c=c?0:1;c<d.length;c++){if(null==a)return;a=a[d[c]]}return a};goog.object.containsKey=function(a,b){return null!==a&&b in a};goog.object.containsValue=function(a,b){for(var c in a)if(a[c]==b)return!0;return!1};goog.object.findKey=function(a,b,c){for(var d in a)if(b.call(c,a[d],d,a))return d};goog.object.findValue=function(a,b,c){return(b=goog.object.findKey(a,b,c))&&a[b]};
goog.object.isEmpty=function(a){for(var b in a)return!1;return!0};goog.object.clear=function(a){for(var b in a)delete a[b]};goog.object.remove=function(a,b){var c;(c=b in a)&&delete a[b];return c};goog.object.add=function(a,b,c){if(null!==a&&b in a)throw Error('The object already contains the key "'+b+'"');goog.object.set(a,b,c)};goog.object.get=function(a,b,c){return null!==a&&b in a?a[b]:c};goog.object.set=function(a,b,c){a[b]=c};
goog.object.setIfUndefined=function(a,b,c){return b in a?a[b]:a[b]=c};goog.object.setWithReturnValueIfNotSet=function(a,b,c){if(b in a)return a[b];c=c();return a[b]=c};goog.object.equals=function(a,b){for(var c in a)if(!(c in b)||a[c]!==b[c])return!1;for(var d in b)if(!(d in a))return!1;return!0};goog.object.clone=function(a){var b={},c;for(c in a)b[c]=a[c];return b};
goog.object.unsafeClone=function(a){if(!a||"object"!==typeof a)return a;if("function"===typeof a.clone)return a.clone();var b=Array.isArray(a)?[]:"function"!==typeof ArrayBuffer||"function"!==typeof ArrayBuffer.isView||!ArrayBuffer.isView(a)||a instanceof DataView?{}:new a.constructor(a.length),c;for(c in a)b[c]=goog.object.unsafeClone(a[c]);return b};goog.object.transpose=function(a){var b={},c;for(c in a)b[a[c]]=c;return b};goog.object.PROTOTYPE_FIELDS_="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
goog.object.extend=function(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<goog.object.PROTOTYPE_FIELDS_.length;f++)c=goog.object.PROTOTYPE_FIELDS_[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};
goog.object.create=function(a){var b=arguments.length;if(1==b&&Array.isArray(arguments[0]))return goog.object.create.apply(null,arguments[0]);if(b%2)throw Error("Uneven number of arguments");for(var c={},d=0;d<b;d+=2)c[arguments[d]]=arguments[d+1];return c};goog.object.createSet=function(a){var b=arguments.length;if(1==b&&Array.isArray(arguments[0]))return goog.object.createSet.apply(null,arguments[0]);for(var c={},d=0;d<b;d++)c[arguments[d]]=!0;return c};
goog.object.createImmutableView=function(a){var b=a;Object.isFrozen&&!Object.isFrozen(a)&&(b=Object.create(a),Object.freeze(b));return b};goog.object.isImmutableView=function(a){return!!Object.isFrozen&&Object.isFrozen(a)};
goog.object.getAllPropertyNames=function(a,b,c){if(!a)return[];if(!Object.getOwnPropertyNames||!Object.getPrototypeOf)return goog.object.getKeys(a);for(var d={};a&&(a!==Object.prototype||b)&&(a!==Function.prototype||c);){for(var e=Object.getOwnPropertyNames(a),f=0;f<e.length;f++)d[e[f]]=!0;a=Object.getPrototypeOf(a)}return goog.object.getKeys(d)};goog.object.getSuperClass=function(a){return(a=Object.getPrototypeOf(a.prototype))&&a.constructor};goog.dom.tags={};goog.dom.tags.VOID_TAGS_={area:!0,base:!0,br:!0,col:!0,command:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0};goog.dom.tags.isVoidTag=function(a){return!0===goog.dom.tags.VOID_TAGS_[a]};goog.string={};goog.string.TypedString=function(){};goog.string.Const=function(a,b){this.stringConstValueWithSecurityContract__googStringSecurityPrivate_=a===goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_&&b||"";this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_=goog.string.Const.TYPE_MARKER_};goog.string.Const.prototype.implementsGoogStringTypedString=!0;goog.string.Const.prototype.getTypedStringValue=function(){return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_};
goog.DEBUG&&(goog.string.Const.prototype.toString=function(){return"Const{"+this.stringConstValueWithSecurityContract__googStringSecurityPrivate_+"}"});goog.string.Const.unwrap=function(a){if(a instanceof goog.string.Const&&a.constructor===goog.string.Const&&a.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_===goog.string.Const.TYPE_MARKER_)return a.stringConstValueWithSecurityContract__googStringSecurityPrivate_;goog.asserts.fail("expected object of type Const, got '"+a+"'");return"type_error:Const"};
goog.string.Const.from=function(a){return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_,a)};goog.string.Const.TYPE_MARKER_={};goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_={};goog.string.Const.EMPTY=goog.string.Const.from("");goog.html={};goog.html.trustedtypes={};goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse=function(){if(!goog.TRUSTED_TYPES_POLICY_NAME)return null;void 0===goog.html.trustedtypes.cachedPolicy_&&(goog.html.trustedtypes.cachedPolicy_=goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME+"#html"));return goog.html.trustedtypes.cachedPolicy_};var module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE={},module$contents$goog$html$SafeScript_SafeScript=function(a,b){this.privateDoNotAccessOrElseSafeScriptWrappedValue_=b===module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE?a:"";this.implementsGoogStringTypedString=!0};module$contents$goog$html$SafeScript_SafeScript.fromConstant=function(a){a=goog.string.Const.unwrap(a);return 0===a.length?module$contents$goog$html$SafeScript_SafeScript.EMPTY:module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(a)};
module$contents$goog$html$SafeScript_SafeScript.fromConstantAndArgs=function(a,b){for(var c=[],d=1;d<arguments.length;d++)c.push(module$contents$goog$html$SafeScript_SafeScript.stringify_(arguments[d]));return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("("+goog.string.Const.unwrap(a)+")("+c.join(", ")+");")};module$contents$goog$html$SafeScript_SafeScript.fromJson=function(a){return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(module$contents$goog$html$SafeScript_SafeScript.stringify_(a))};
module$contents$goog$html$SafeScript_SafeScript.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString()};module$contents$goog$html$SafeScript_SafeScript.unwrap=function(a){return module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(a).toString()};
module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript=function(a){if(a instanceof module$contents$goog$html$SafeScript_SafeScript&&a.constructor===module$contents$goog$html$SafeScript_SafeScript)return a.privateDoNotAccessOrElseSafeScriptWrappedValue_;(0,goog.asserts.fail)("expected object of type SafeScript, got '"+a+"' of type "+goog.typeOf(a));return"type_error:SafeScript"};
module$contents$goog$html$SafeScript_SafeScript.stringify_=function(a){return JSON.stringify(a).replace(/</g,"\\x3c")};module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse=function(a){var b=goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();a=b?b.createScript(a):a;return new module$contents$goog$html$SafeScript_SafeScript(a,module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE)};
goog.DEBUG&&(module$contents$goog$html$SafeScript_SafeScript.prototype.toString=function(){return"SafeScript{"+this.privateDoNotAccessOrElseSafeScriptWrappedValue_+"}"});module$contents$goog$html$SafeScript_SafeScript.EMPTY=function(){return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("")}();goog.html.SafeScript=module$contents$goog$html$SafeScript_SafeScript;goog.fs={};goog.fs.url={};goog.fs.url.createObjectUrl=function(a){return goog.fs.url.getUrlObject_().createObjectURL(a)};goog.fs.url.revokeObjectUrl=function(a){goog.fs.url.getUrlObject_().revokeObjectURL(a)};goog.fs.url.UrlObject_=function(){};goog.fs.url.UrlObject_.prototype.createObjectURL=function(a){};goog.fs.url.UrlObject_.prototype.revokeObjectURL=function(a){};
goog.fs.url.getUrlObject_=function(){var a=goog.fs.url.findUrlObject_();if(null!=a)return a;throw Error("This browser doesn't seem to support blob URLs");};goog.fs.url.findUrlObject_=function(){return void 0!==goog.global.URL&&void 0!==goog.global.URL.createObjectURL?goog.global.URL:void 0!==goog.global.webkitURL&&void 0!==goog.global.webkitURL.createObjectURL?goog.global.webkitURL:void 0!==goog.global.createObjectURL?goog.global:null};
goog.fs.url.browserSupportsObjectUrls=function(){return null!=goog.fs.url.findUrlObject_()};goog.fs.blob={};goog.fs.blob.getBlob=function(a){var b=goog.global.BlobBuilder||goog.global.WebKitBlobBuilder;if(void 0!==b){b=new b;for(var c=0;c<arguments.length;c++)b.append(arguments[c]);return b.getBlob()}return goog.fs.blob.getBlobWithProperties(module$contents$goog$array_toArray(arguments))};
goog.fs.blob.getBlobWithProperties=function(a,b,c){var d=goog.global.BlobBuilder||goog.global.WebKitBlobBuilder;if(void 0!==d){d=new d;for(var e=0;e<a.length;e++)d.append(a[e],c);return d.getBlob(b)}if(void 0!==goog.global.Blob)return d={},b&&(d.type=b),c&&(d.endings=c),new Blob(a,d);throw Error("This browser doesn't seem to support creating Blobs");};goog.i18n={};goog.i18n.bidi={};goog.i18n.bidi.FORCE_RTL=!1;
goog.i18n.bidi.IS_RTL=goog.i18n.bidi.FORCE_RTL||("ar"==goog.LOCALE.substring(0,2).toLowerCase()||"fa"==goog.LOCALE.substring(0,2).toLowerCase()||"he"==goog.LOCALE.substring(0,2).toLowerCase()||"iw"==goog.LOCALE.substring(0,2).toLowerCase()||"ps"==goog.LOCALE.substring(0,2).toLowerCase()||"sd"==goog.LOCALE.substring(0,2).toLowerCase()||"ug"==goog.LOCALE.substring(0,2).toLowerCase()||"ur"==goog.LOCALE.substring(0,2).toLowerCase()||"yi"==goog.LOCALE.substring(0,2).toLowerCase())&&(2==goog.LOCALE.length||
"-"==goog.LOCALE.substring(2,3)||"_"==goog.LOCALE.substring(2,3))||3<=goog.LOCALE.length&&"ckb"==goog.LOCALE.substring(0,3).toLowerCase()&&(3==goog.LOCALE.length||"-"==goog.LOCALE.substring(3,4)||"_"==goog.LOCALE.substring(3,4))||7<=goog.LOCALE.length&&("-"==goog.LOCALE.substring(2,3)||"_"==goog.LOCALE.substring(2,3))&&("adlm"==goog.LOCALE.substring(3,7).toLowerCase()||"arab"==goog.LOCALE.substring(3,7).toLowerCase()||"hebr"==goog.LOCALE.substring(3,7).toLowerCase()||"nkoo"==goog.LOCALE.substring(3,
7).toLowerCase()||"rohg"==goog.LOCALE.substring(3,7).toLowerCase()||"thaa"==goog.LOCALE.substring(3,7).toLowerCase())||8<=goog.LOCALE.length&&("-"==goog.LOCALE.substring(3,4)||"_"==goog.LOCALE.substring(3,4))&&("adlm"==goog.LOCALE.substring(4,8).toLowerCase()||"arab"==goog.LOCALE.substring(4,8).toLowerCase()||"hebr"==goog.LOCALE.substring(4,8).toLowerCase()||"nkoo"==goog.LOCALE.substring(4,8).toLowerCase()||"rohg"==goog.LOCALE.substring(4,8).toLowerCase()||"thaa"==goog.LOCALE.substring(4,8).toLowerCase());
goog.i18n.bidi.Format={LRE:"\u202a",RLE:"\u202b",PDF:"\u202c",LRM:"\u200e",RLM:"\u200f"};goog.i18n.bidi.Dir={LTR:1,RTL:-1,NEUTRAL:0};goog.i18n.bidi.RIGHT="right";goog.i18n.bidi.LEFT="left";goog.i18n.bidi.I18N_RIGHT=goog.i18n.bidi.IS_RTL?goog.i18n.bidi.LEFT:goog.i18n.bidi.RIGHT;goog.i18n.bidi.I18N_LEFT=goog.i18n.bidi.IS_RTL?goog.i18n.bidi.RIGHT:goog.i18n.bidi.LEFT;
goog.i18n.bidi.toDir=function(a,b){return"number"==typeof a?0<a?goog.i18n.bidi.Dir.LTR:0>a?goog.i18n.bidi.Dir.RTL:b?null:goog.i18n.bidi.Dir.NEUTRAL:null==a?null:a?goog.i18n.bidi.Dir.RTL:goog.i18n.bidi.Dir.LTR};goog.i18n.bidi.ltrChars_="A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0900-\u1fff\u200e\u2c00-\ud801\ud804-\ud839\ud83c-\udbff\uf900-\ufb1c\ufe00-\ufe6f\ufefd-\uffff";goog.i18n.bidi.rtlChars_="\u0591-\u06ef\u06fa-\u08ff\u200f\ud802-\ud803\ud83a-\ud83b\ufb1d-\ufdff\ufe70-\ufefc";
goog.i18n.bidi.htmlSkipReg_=/<[^>]*>|&[^;]+;/g;goog.i18n.bidi.stripHtmlIfNeeded_=function(a,b){return b?a.replace(goog.i18n.bidi.htmlSkipReg_,""):a};goog.i18n.bidi.rtlCharReg_=new RegExp("["+goog.i18n.bidi.rtlChars_+"]");goog.i18n.bidi.ltrCharReg_=new RegExp("["+goog.i18n.bidi.ltrChars_+"]");goog.i18n.bidi.hasAnyRtl=function(a,b){return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.hasRtlChar=goog.i18n.bidi.hasAnyRtl;
goog.i18n.bidi.hasAnyLtr=function(a,b){return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.ltrRe_=new RegExp("^["+goog.i18n.bidi.ltrChars_+"]");goog.i18n.bidi.rtlRe_=new RegExp("^["+goog.i18n.bidi.rtlChars_+"]");goog.i18n.bidi.isRtlChar=function(a){return goog.i18n.bidi.rtlRe_.test(a)};goog.i18n.bidi.isLtrChar=function(a){return goog.i18n.bidi.ltrRe_.test(a)};goog.i18n.bidi.isNeutralChar=function(a){return!goog.i18n.bidi.isLtrChar(a)&&!goog.i18n.bidi.isRtlChar(a)};
goog.i18n.bidi.ltrDirCheckRe_=new RegExp("^[^"+goog.i18n.bidi.rtlChars_+"]*["+goog.i18n.bidi.ltrChars_+"]");goog.i18n.bidi.rtlDirCheckRe_=new RegExp("^[^"+goog.i18n.bidi.ltrChars_+"]*["+goog.i18n.bidi.rtlChars_+"]");goog.i18n.bidi.startsWithRtl=function(a,b){return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.isRtlText=goog.i18n.bidi.startsWithRtl;
goog.i18n.bidi.startsWithLtr=function(a,b){return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.isLtrText=goog.i18n.bidi.startsWithLtr;goog.i18n.bidi.isRequiredLtrRe_=/^http:\/\/.*/;goog.i18n.bidi.isNeutralText=function(a,b){a=goog.i18n.bidi.stripHtmlIfNeeded_(a,b);return goog.i18n.bidi.isRequiredLtrRe_.test(a)||!goog.i18n.bidi.hasAnyLtr(a)&&!goog.i18n.bidi.hasAnyRtl(a)};
goog.i18n.bidi.ltrExitDirCheckRe_=new RegExp("["+goog.i18n.bidi.ltrChars_+"][^"+goog.i18n.bidi.rtlChars_+"]*$");goog.i18n.bidi.rtlExitDirCheckRe_=new RegExp("["+goog.i18n.bidi.rtlChars_+"][^"+goog.i18n.bidi.ltrChars_+"]*$");goog.i18n.bidi.endsWithLtr=function(a,b){return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.isLtrExitText=goog.i18n.bidi.endsWithLtr;
goog.i18n.bidi.endsWithRtl=function(a,b){return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.isRtlExitText=goog.i18n.bidi.endsWithRtl;goog.i18n.bidi.rtlLocalesRe_=/^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i;goog.i18n.bidi.isRtlLanguage=function(a){return goog.i18n.bidi.rtlLocalesRe_.test(a)};goog.i18n.bidi.bracketGuardTextRe_=/(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g;
goog.i18n.bidi.guardBracketInText=function(a,b){b=(void 0===b?goog.i18n.bidi.hasAnyRtl(a):b)?goog.i18n.bidi.Format.RLM:goog.i18n.bidi.Format.LRM;return a.replace(goog.i18n.bidi.bracketGuardTextRe_,b+"$&"+b)};goog.i18n.bidi.enforceRtlInHtml=function(a){return"<"==a.charAt(0)?a.replace(/<\w+/,"$& dir=rtl"):"\n<span dir=rtl>"+a+"</span>"};goog.i18n.bidi.enforceRtlInText=function(a){return goog.i18n.bidi.Format.RLE+a+goog.i18n.bidi.Format.PDF};
goog.i18n.bidi.enforceLtrInHtml=function(a){return"<"==a.charAt(0)?a.replace(/<\w+/,"$& dir=ltr"):"\n<span dir=ltr>"+a+"</span>"};goog.i18n.bidi.enforceLtrInText=function(a){return goog.i18n.bidi.Format.LRE+a+goog.i18n.bidi.Format.PDF};goog.i18n.bidi.dimensionsRe_=/:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g;goog.i18n.bidi.leftRe_=/left/gi;goog.i18n.bidi.rightRe_=/right/gi;goog.i18n.bidi.tempRe_=/%%%%/g;
goog.i18n.bidi.mirrorCSS=function(a){return a.replace(goog.i18n.bidi.dimensionsRe_,":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_,"%%%%").replace(goog.i18n.bidi.rightRe_,goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_,goog.i18n.bidi.RIGHT)};goog.i18n.bidi.doubleQuoteSubstituteRe_=/([\u0591-\u05f2])"/g;goog.i18n.bidi.singleQuoteSubstituteRe_=/([\u0591-\u05f2])'/g;
goog.i18n.bidi.normalizeHebrewQuote=function(a){return a.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_,"$1\u05f4").replace(goog.i18n.bidi.singleQuoteSubstituteRe_,"$1\u05f3")};goog.i18n.bidi.wordSeparatorRe_=/\s+/;goog.i18n.bidi.hasNumeralsRe_=/[\d\u06f0-\u06f9]/;goog.i18n.bidi.rtlDetectionThreshold_=.4;
goog.i18n.bidi.estimateDirection=function(a,b){var c=0,d=0,e=!1;a=goog.i18n.bidi.stripHtmlIfNeeded_(a,b).split(goog.i18n.bidi.wordSeparatorRe_);for(b=0;b<a.length;b++){var f=a[b];goog.i18n.bidi.startsWithRtl(f)?(c++,d++):goog.i18n.bidi.isRequiredLtrRe_.test(f)?e=!0:goog.i18n.bidi.hasAnyLtr(f)?d++:goog.i18n.bidi.hasNumeralsRe_.test(f)&&(e=!0)}return 0==d?e?goog.i18n.bidi.Dir.LTR:goog.i18n.bidi.Dir.NEUTRAL:c/d>goog.i18n.bidi.rtlDetectionThreshold_?goog.i18n.bidi.Dir.RTL:goog.i18n.bidi.Dir.LTR};
goog.i18n.bidi.detectRtlDirectionality=function(a,b){return goog.i18n.bidi.estimateDirection(a,b)==goog.i18n.bidi.Dir.RTL};goog.i18n.bidi.setElementDirAndAlign=function(a,b){a&&(b=goog.i18n.bidi.toDir(b))&&(a.style.textAlign=b==goog.i18n.bidi.Dir.RTL?goog.i18n.bidi.RIGHT:goog.i18n.bidi.LEFT,a.dir=b==goog.i18n.bidi.Dir.RTL?"rtl":"ltr")};
goog.i18n.bidi.setElementDirByTextDirectionality=function(a,b){switch(goog.i18n.bidi.estimateDirection(b)){case goog.i18n.bidi.Dir.LTR:"ltr"!==a.dir&&(a.dir="ltr");break;case goog.i18n.bidi.Dir.RTL:"rtl"!==a.dir&&(a.dir="rtl");break;default:a.removeAttribute("dir")}};goog.i18n.bidi.DirectionalString=function(){};goog.html.TrustedResourceUrl=function(a,b){this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_=b===goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_?a:""};goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString=!0;goog.html.TrustedResourceUrl.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString()};goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString=!0;
goog.html.TrustedResourceUrl.prototype.getDirection=function(){return goog.i18n.bidi.Dir.LTR};goog.html.TrustedResourceUrl.prototype.cloneWithParams=function(a,b){var c=goog.html.TrustedResourceUrl.unwrap(this);c=goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(c);var d=c[3]||"";return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(c[1]+goog.html.TrustedResourceUrl.stringifyParams_("?",c[2]||"",a)+goog.html.TrustedResourceUrl.stringifyParams_("#",d,b))};
goog.DEBUG&&(goog.html.TrustedResourceUrl.prototype.toString=function(){return"TrustedResourceUrl{"+this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_+"}"});goog.html.TrustedResourceUrl.unwrap=function(a){return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(a).toString()};
goog.html.TrustedResourceUrl.unwrapTrustedScriptURL=function(a){if(a instanceof goog.html.TrustedResourceUrl&&a.constructor===goog.html.TrustedResourceUrl)return a.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_;goog.asserts.fail("expected object of type TrustedResourceUrl, got '"+a+"' of type "+goog.typeOf(a));return"type_error:TrustedResourceUrl"};
goog.html.TrustedResourceUrl.format=function(a,b){var c=goog.string.Const.unwrap(a);if(!goog.html.TrustedResourceUrl.BASE_URL_.test(c))throw Error("Invalid TrustedResourceUrl format: "+c);a=c.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_,function(d,e){if(!Object.prototype.hasOwnProperty.call(b,e))throw Error('Found marker, "'+e+'", in format string, "'+c+'", but no valid label mapping found in args: '+JSON.stringify(b));d=b[e];return d instanceof goog.string.Const?goog.string.Const.unwrap(d):
encodeURIComponent(String(d))});return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.TrustedResourceUrl.FORMAT_MARKER_=/%{(\w+)}/g;goog.html.TrustedResourceUrl.BASE_URL_=/^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i;goog.html.TrustedResourceUrl.URL_PARAM_PARSER_=/^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/;
goog.html.TrustedResourceUrl.formatWithParams=function(a,b,c,d){return goog.html.TrustedResourceUrl.format(a,b).cloneWithParams(c,d)};goog.html.TrustedResourceUrl.fromConstant=function(a){return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a))};goog.html.TrustedResourceUrl.fromConstants=function(a){for(var b="",c=0;c<a.length;c++)b+=goog.string.Const.unwrap(a[c]);return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b)};
goog.html.TrustedResourceUrl.fromSafeScript=function(a){a=goog.fs.blob.getBlobWithProperties([module$contents$goog$html$SafeScript_SafeScript.unwrap(a)],"text/javascript");a=goog.fs.url.createObjectUrl(a);return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_={};
goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse=function(a){var b=goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();a=b?b.createScriptURL(a):a;return new goog.html.TrustedResourceUrl(a,goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_)};
goog.html.TrustedResourceUrl.stringifyParams_=function(a,b,c){if(null==c)return b;if("string"===typeof c)return c?a+encodeURIComponent(c):"";for(var d in c)if(Object.prototype.hasOwnProperty.call(c,d)){var e=c[d];e=Array.isArray(e)?e:[e];for(var f=0;f<e.length;f++){var g=e[f];null!=g&&(b||(b=a),b+=(b.length>a.length?"&":"")+encodeURIComponent(d)+"="+encodeURIComponent(String(g)))}}return b};goog.string.internal={};goog.string.internal.startsWith=function(a,b){return 0==a.lastIndexOf(b,0)};goog.string.internal.endsWith=function(a,b){var c=a.length-b.length;return 0<=c&&a.indexOf(b,c)==c};goog.string.internal.caseInsensitiveStartsWith=function(a,b){return 0==goog.string.internal.caseInsensitiveCompare(b,a.substr(0,b.length))};goog.string.internal.caseInsensitiveEndsWith=function(a,b){return 0==goog.string.internal.caseInsensitiveCompare(b,a.substr(a.length-b.length,b.length))};
goog.string.internal.caseInsensitiveEquals=function(a,b){return a.toLowerCase()==b.toLowerCase()};goog.string.internal.isEmptyOrWhitespace=function(a){return/^[\s\xa0]*$/.test(a)};goog.string.internal.trim=goog.TRUSTED_SITE&&String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]};goog.string.internal.caseInsensitiveCompare=function(a,b){a=String(a).toLowerCase();b=String(b).toLowerCase();return a<b?-1:a==b?0:1};
goog.string.internal.newLineToBr=function(a,b){return a.replace(/(\r\n|\r|\n)/g,b?"<br />":"<br>")};
goog.string.internal.htmlEscape=function(a,b){if(b)a=a.replace(goog.string.internal.AMP_RE_,"&amp;").replace(goog.string.internal.LT_RE_,"&lt;").replace(goog.string.internal.GT_RE_,"&gt;").replace(goog.string.internal.QUOT_RE_,"&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_,"&#39;").replace(goog.string.internal.NULL_RE_,"&#0;");else{if(!goog.string.internal.ALL_RE_.test(a))return a;-1!=a.indexOf("&")&&(a=a.replace(goog.string.internal.AMP_RE_,"&amp;"));-1!=a.indexOf("<")&&(a=a.replace(goog.string.internal.LT_RE_,
"&lt;"));-1!=a.indexOf(">")&&(a=a.replace(goog.string.internal.GT_RE_,"&gt;"));-1!=a.indexOf('"')&&(a=a.replace(goog.string.internal.QUOT_RE_,"&quot;"));-1!=a.indexOf("'")&&(a=a.replace(goog.string.internal.SINGLE_QUOTE_RE_,"&#39;"));-1!=a.indexOf("\x00")&&(a=a.replace(goog.string.internal.NULL_RE_,"&#0;"))}return a};goog.string.internal.AMP_RE_=/&/g;goog.string.internal.LT_RE_=/</g;goog.string.internal.GT_RE_=/>/g;goog.string.internal.QUOT_RE_=/"/g;goog.string.internal.SINGLE_QUOTE_RE_=/'/g;
goog.string.internal.NULL_RE_=/\x00/g;goog.string.internal.ALL_RE_=/[\x00&<>"']/;goog.string.internal.whitespaceEscape=function(a,b){return goog.string.internal.newLineToBr(a.replace(/  /g," &#160;"),b)};goog.string.internal.contains=function(a,b){return-1!=a.indexOf(b)};goog.string.internal.caseInsensitiveContains=function(a,b){return goog.string.internal.contains(a.toLowerCase(),b.toLowerCase())};
goog.string.internal.compareVersions=function(a,b){var c=0;a=goog.string.internal.trim(String(a)).split(".");b=goog.string.internal.trim(String(b)).split(".");for(var d=Math.max(a.length,b.length),e=0;0==c&&e<d;e++){var f=a[e]||"",g=b[e]||"";do{f=/(\d*)(\D*)(.*)/.exec(f)||["","","",""];g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];if(0==f[0].length&&0==g[0].length)break;c=0==f[1].length?0:parseInt(f[1],10);var h=0==g[1].length?0:parseInt(g[1],10);c=goog.string.internal.compareElements_(c,h)||goog.string.internal.compareElements_(0==
f[2].length,0==g[2].length)||goog.string.internal.compareElements_(f[2],g[2]);f=f[3];g=g[3]}while(0==c)}return c};goog.string.internal.compareElements_=function(a,b){return a<b?-1:a>b?1:0};goog.html.SafeUrl=function(a,b){this.privateDoNotAccessOrElseSafeUrlWrappedValue_=b===goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_?a:""};goog.html.SafeUrl.INNOCUOUS_STRING="about:invalid#zClosurez";goog.html.SafeUrl.prototype.implementsGoogStringTypedString=!0;goog.html.SafeUrl.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString()};goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString=!0;
goog.html.SafeUrl.prototype.getDirection=function(){return goog.i18n.bidi.Dir.LTR};goog.DEBUG&&(goog.html.SafeUrl.prototype.toString=function(){return"SafeUrl{"+this.privateDoNotAccessOrElseSafeUrlWrappedValue_+"}"});goog.html.SafeUrl.unwrap=function(a){if(a instanceof goog.html.SafeUrl&&a.constructor===goog.html.SafeUrl)return a.privateDoNotAccessOrElseSafeUrlWrappedValue_;goog.asserts.fail("expected object of type SafeUrl, got '"+a+"' of type "+goog.typeOf(a));return"type_error:SafeUrl"};
goog.html.SafeUrl.fromConstant=function(a){return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a))};goog.html.SAFE_MIME_TYPE_PATTERN_=/^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-matroska|x-wav|wav|webm)|font\/\w+|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|video\/(?:mpeg|mp4|ogg|webm|quicktime|x-matroska))(?:;\w+=(?:\w+|"[\w;,= ]+"))*$/i;goog.html.SafeUrl.isSafeMimeType=function(a){return goog.html.SAFE_MIME_TYPE_PATTERN_.test(a)};
goog.html.SafeUrl.fromBlob=function(a){a=goog.html.SafeUrl.isSafeMimeType(a.type)?goog.fs.url.createObjectUrl(a):goog.html.SafeUrl.INNOCUOUS_STRING;return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.SafeUrl.revokeObjectUrl=function(a){a=a.getTypedStringValue();a!==goog.html.SafeUrl.INNOCUOUS_STRING&&goog.fs.url.revokeObjectUrl(a)};
goog.html.SafeUrl.fromMediaSource=function(a){goog.asserts.assert("MediaSource"in goog.global,"No support for MediaSource");a=a instanceof MediaSource?goog.fs.url.createObjectUrl(a):goog.html.SafeUrl.INNOCUOUS_STRING;return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.DATA_URL_PATTERN_=/^data:(.*);base64,[a-z0-9+\/]+=*$/i;
goog.html.SafeUrl.tryFromDataUrl=function(a){a=String(a);a=a.replace(/(%0A|%0D)/g,"");var b=a.match(goog.html.DATA_URL_PATTERN_);return b&&goog.html.SafeUrl.isSafeMimeType(b[1])?goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a):null};goog.html.SafeUrl.fromDataUrl=function(a){return goog.html.SafeUrl.tryFromDataUrl(a)||goog.html.SafeUrl.INNOCUOUS_URL};
goog.html.SafeUrl.fromTelUrl=function(a){goog.string.internal.caseInsensitiveStartsWith(a,"tel:")||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.SIP_URL_PATTERN_=/^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i;goog.html.SafeUrl.fromSipUrl=function(a){goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(a))||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};
goog.html.SafeUrl.fromFacebookMessengerUrl=function(a){goog.string.internal.caseInsensitiveStartsWith(a,"fb-messenger://share")||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.SafeUrl.fromWhatsAppUrl=function(a){goog.string.internal.caseInsensitiveStartsWith(a,"whatsapp://send")||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};
goog.html.SafeUrl.fromSmsUrl=function(a){goog.string.internal.caseInsensitiveStartsWith(a,"sms:")&&goog.html.SafeUrl.isSmsUrlBodyValid_(a)||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.SafeUrl.isSmsUrlBodyValid_=function(a){var b=a.indexOf("#");0<b&&(a=a.substring(0,b));b=a.match(/[?&]body=/gi);if(!b)return!0;if(1<b.length)return!1;a=a.match(/[?&]body=([^&]*)/)[1];if(!a)return!0;try{decodeURIComponent(a)}catch(c){return!1}return/^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(a)};
goog.html.SafeUrl.fromSshUrl=function(a){goog.string.internal.caseInsensitiveStartsWith(a,"ssh://")||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.SafeUrl.sanitizeChromeExtensionUrl=function(a,b){return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//,a,b)};
goog.html.SafeUrl.sanitizeFirefoxExtensionUrl=function(a,b){return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//,a,b)};goog.html.SafeUrl.sanitizeEdgeExtensionUrl=function(a,b){return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//,a,b)};
goog.html.SafeUrl.sanitizeExtensionUrl_=function(a,b,c){(a=a.exec(b))?(a=a[1],-1==(c instanceof goog.string.Const?[goog.string.Const.unwrap(c)]:c.map(function(d){return goog.string.Const.unwrap(d)})).indexOf(a)&&(b=goog.html.SafeUrl.INNOCUOUS_STRING)):b=goog.html.SafeUrl.INNOCUOUS_STRING;return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b)};goog.html.SafeUrl.fromTrustedResourceUrl=function(a){return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(a))};
goog.html.SAFE_URL_PATTERN_=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;goog.html.SafeUrl.SAFE_URL_PATTERN=goog.html.SAFE_URL_PATTERN_;goog.html.SafeUrl.trySanitize=function(a){if(a instanceof goog.html.SafeUrl)return a;a="object"==typeof a&&a.implementsGoogStringTypedString?a.getTypedStringValue():String(a);return goog.html.SAFE_URL_PATTERN_.test(a)?goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a):goog.html.SafeUrl.tryFromDataUrl(a)};
goog.html.SafeUrl.sanitize=function(a){return goog.html.SafeUrl.trySanitize(a)||goog.html.SafeUrl.INNOCUOUS_URL};
goog.html.SafeUrl.sanitizeAssertUnchanged=function(a,b){if(a instanceof goog.html.SafeUrl)return a;a="object"==typeof a&&a.implementsGoogStringTypedString?a.getTypedStringValue():String(a);if(b&&/^data:/i.test(a)&&(b=goog.html.SafeUrl.fromDataUrl(a),b.getTypedStringValue()==a))return b;goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(a),"%s does not match the safe URL pattern",a)||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};
goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_={};goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse=function(a){return new goog.html.SafeUrl(a,goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_)};goog.html.SafeUrl.INNOCUOUS_URL=goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.SafeUrl.INNOCUOUS_STRING);goog.html.SafeUrl.ABOUT_BLANK=goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank");goog.html.SafeStyle=function(a,b){this.privateDoNotAccessOrElseSafeStyleWrappedValue_=b===goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_?a:""};goog.html.SafeStyle.prototype.implementsGoogStringTypedString=!0;
goog.html.SafeStyle.fromConstant=function(a){a=goog.string.Const.unwrap(a);if(0===a.length)return goog.html.SafeStyle.EMPTY;goog.asserts.assert(goog.string.internal.endsWith(a,";"),"Last character of style string is not ';': "+a);goog.asserts.assert(goog.string.internal.contains(a,":"),"Style string must contain at least one ':', to specify a \"name: value\" pair: "+a);return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(a)};
goog.html.SafeStyle.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeStyleWrappedValue_};goog.DEBUG&&(goog.html.SafeStyle.prototype.toString=function(){return"SafeStyle{"+this.privateDoNotAccessOrElseSafeStyleWrappedValue_+"}"});
goog.html.SafeStyle.unwrap=function(a){if(a instanceof goog.html.SafeStyle&&a.constructor===goog.html.SafeStyle)return a.privateDoNotAccessOrElseSafeStyleWrappedValue_;goog.asserts.fail("expected object of type SafeStyle, got '"+a+"' of type "+goog.typeOf(a));return"type_error:SafeStyle"};goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_={};goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse=function(a){return new goog.html.SafeStyle(a,goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_)};
goog.html.SafeStyle.EMPTY=goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse("");goog.html.SafeStyle.INNOCUOUS_STRING="zClosurez";
goog.html.SafeStyle.create=function(a){var b="",c;for(c in a)if(Object.prototype.hasOwnProperty.call(a,c)){if(!/^[-_a-zA-Z0-9]+$/.test(c))throw Error("Name allows only [-_a-zA-Z0-9], got: "+c);var d=a[c];null!=d&&(d=Array.isArray(d)?module$contents$goog$array_map(d,goog.html.SafeStyle.sanitizePropertyValue_).join(" "):goog.html.SafeStyle.sanitizePropertyValue_(d),b+=c+":"+d+";")}return b?goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b):goog.html.SafeStyle.EMPTY};
goog.html.SafeStyle.sanitizePropertyValue_=function(a){if(a instanceof goog.html.SafeUrl)return'url("'+goog.html.SafeUrl.unwrap(a).replace(/</g,"%3c").replace(/[\\"]/g,"\\$&")+'")';a=a instanceof goog.string.Const?goog.string.Const.unwrap(a):goog.html.SafeStyle.sanitizePropertyValueString_(String(a));if(/[{;}]/.test(a))throw new goog.asserts.AssertionError("Value does not allow [{;}], got: %s.",[a]);return a};
goog.html.SafeStyle.sanitizePropertyValueString_=function(a){var b=a.replace(goog.html.SafeStyle.FUNCTIONS_RE_,"$1").replace(goog.html.SafeStyle.FUNCTIONS_RE_,"$1").replace(goog.html.SafeStyle.URL_RE_,"url");if(goog.html.SafeStyle.VALUE_RE_.test(b)){if(goog.html.SafeStyle.COMMENT_RE_.test(a))return goog.asserts.fail("String value disallows comments, got: "+a),goog.html.SafeStyle.INNOCUOUS_STRING;if(!goog.html.SafeStyle.hasBalancedQuotes_(a))return goog.asserts.fail("String value requires balanced quotes, got: "+
a),goog.html.SafeStyle.INNOCUOUS_STRING;if(!goog.html.SafeStyle.hasBalancedSquareBrackets_(a))return goog.asserts.fail("String value requires balanced square brackets and one identifier per pair of brackets, got: "+a),goog.html.SafeStyle.INNOCUOUS_STRING}else return goog.asserts.fail("String value allows only "+goog.html.SafeStyle.VALUE_ALLOWED_CHARS_+" and simple functions, got: "+a),goog.html.SafeStyle.INNOCUOUS_STRING;return goog.html.SafeStyle.sanitizeUrl_(a)};
goog.html.SafeStyle.hasBalancedQuotes_=function(a){for(var b=!0,c=!0,d=0;d<a.length;d++){var e=a.charAt(d);"'"==e&&c?b=!b:'"'==e&&b&&(c=!c)}return b&&c};goog.html.SafeStyle.hasBalancedSquareBrackets_=function(a){for(var b=!0,c=/^[-_a-zA-Z0-9]$/,d=0;d<a.length;d++){var e=a.charAt(d);if("]"==e){if(b)return!1;b=!0}else if("["==e){if(!b)return!1;b=!1}else if(!b&&!c.test(e))return!1}return b};goog.html.SafeStyle.VALUE_ALLOWED_CHARS_="[-,.\"'%_!# a-zA-Z0-9\\[\\]]";
goog.html.SafeStyle.VALUE_RE_=new RegExp("^"+goog.html.SafeStyle.VALUE_ALLOWED_CHARS_+"+$");goog.html.SafeStyle.URL_RE_=/\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g;goog.html.SafeStyle.ALLOWED_FUNCTIONS_="calc cubic-bezier fit-content hsl hsla linear-gradient matrix minmax repeat rgb rgba (rotate|scale|translate)(X|Y|Z|3d)?".split(" ");
goog.html.SafeStyle.FUNCTIONS_RE_=new RegExp("\\b("+goog.html.SafeStyle.ALLOWED_FUNCTIONS_.join("|")+")\\([-+*/0-9a-z.%\\[\\], ]+\\)","g");goog.html.SafeStyle.COMMENT_RE_=/\/\*/;goog.html.SafeStyle.sanitizeUrl_=function(a){return a.replace(goog.html.SafeStyle.URL_RE_,function(b,c,d,e){var f="";d=d.replace(/^(['"])(.*)\1$/,function(g,h,k){f=h;return k});b=goog.html.SafeUrl.sanitize(d).getTypedStringValue();return c+f+b+f+e})};
goog.html.SafeStyle.concat=function(a){var b="",c=function(d){Array.isArray(d)?module$contents$goog$array_forEach(d,c):b+=goog.html.SafeStyle.unwrap(d)};module$contents$goog$array_forEach(arguments,c);return b?goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b):goog.html.SafeStyle.EMPTY};var module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE={},module$contents$goog$html$SafeStyleSheet_SafeStyleSheet=function(a,b){this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_=b===module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE?a:"";this.implementsGoogStringTypedString=!0};
module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createRule=function(a,b){if((0,goog.string.internal.contains)(a,"<"))throw Error("Selector does not allow '<', got: "+a);var c=a.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g,"");if(!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(c))throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: "+a);if(!module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_(c))throw Error("() and [] in selector must be balanced, got: "+
a);b instanceof goog.html.SafeStyle||(b=goog.html.SafeStyle.create(b));a=a+"{"+goog.html.SafeStyle.unwrap(b).replace(/</g,"\\3C ")+"}";return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a)};module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_=function(a){for(var b={"(":")","[":"]"},c=[],d=0;d<a.length;d++){var e=a[d];if(b[e])c.push(b[e]);else if(goog.object.contains(b,e)&&c.pop()!=e)return!1}return 0==c.length};
module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.concat=function(a){var b="",c=function(d){Array.isArray(d)?module$contents$goog$array_forEach(d,c):b+=module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(d)};module$contents$goog$array_forEach(arguments,c);return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b)};
module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.fromConstant=function(a){a=goog.string.Const.unwrap(a);if(0===a.length)return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY;(0,goog.asserts.assert)(!(0,goog.string.internal.contains)(a,"<"),"Forbidden '<' character in style sheet string: "+a);return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a)};
module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_};
module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap=function(a){if(a instanceof module$contents$goog$html$SafeStyleSheet_SafeStyleSheet&&a.constructor===module$contents$goog$html$SafeStyleSheet_SafeStyleSheet)return a.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;(0,goog.asserts.fail)("expected object of type SafeStyleSheet, got '"+a+"' of type "+goog.typeOf(a));return"type_error:SafeStyleSheet"};
module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse=function(a){return new module$contents$goog$html$SafeStyleSheet_SafeStyleSheet(a,module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE)};goog.DEBUG&&(module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.toString=function(){return"SafeStyleSheet{"+this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_+"}"});
module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY=module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse("");goog.html.SafeStyleSheet=module$contents$goog$html$SafeStyleSheet_SafeStyleSheet;goog.labs={};goog.labs.userAgent={};goog.labs.userAgent.util={};goog.labs.userAgent.util.getNativeUserAgentString_=function(){var a=goog.labs.userAgent.util.getNavigator_();return a&&(a=a.userAgent)?a:""};goog.labs.userAgent.util.getNavigator_=function(){return goog.global.navigator};goog.labs.userAgent.util.userAgent_=goog.labs.userAgent.util.getNativeUserAgentString_();goog.labs.userAgent.util.setUserAgent=function(a){goog.labs.userAgent.util.userAgent_=a||goog.labs.userAgent.util.getNativeUserAgentString_()};
goog.labs.userAgent.util.getUserAgent=function(){return goog.labs.userAgent.util.userAgent_};goog.labs.userAgent.util.matchUserAgent=function(a){var b=goog.labs.userAgent.util.getUserAgent();return goog.string.internal.contains(b,a)};goog.labs.userAgent.util.matchUserAgentIgnoreCase=function(a){var b=goog.labs.userAgent.util.getUserAgent();return goog.string.internal.caseInsensitiveContains(b,a)};
goog.labs.userAgent.util.extractVersionTuples=function(a){for(var b=/(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g,c=[],d;d=b.exec(a);)c.push([d[1],d[2],d[3]||void 0]);return c};goog.labs.userAgent.browser={};goog.labs.userAgent.browser.matchOpera_=function(){return goog.labs.userAgent.util.matchUserAgent("Opera")};goog.labs.userAgent.browser.matchIE_=function(){return goog.labs.userAgent.util.matchUserAgent("Trident")||goog.labs.userAgent.util.matchUserAgent("MSIE")};goog.labs.userAgent.browser.matchEdgeHtml_=function(){return goog.labs.userAgent.util.matchUserAgent("Edge")};goog.labs.userAgent.browser.matchEdgeChromium_=function(){return goog.labs.userAgent.util.matchUserAgent("Edg/")};
goog.labs.userAgent.browser.matchOperaChromium_=function(){return goog.labs.userAgent.util.matchUserAgent("OPR")};goog.labs.userAgent.browser.matchFirefox_=function(){return goog.labs.userAgent.util.matchUserAgent("Firefox")||goog.labs.userAgent.util.matchUserAgent("FxiOS")};
goog.labs.userAgent.browser.matchSafari_=function(){return goog.labs.userAgent.util.matchUserAgent("Safari")&&!(goog.labs.userAgent.browser.matchChrome_()||goog.labs.userAgent.browser.matchCoast_()||goog.labs.userAgent.browser.matchOpera_()||goog.labs.userAgent.browser.matchEdgeHtml_()||goog.labs.userAgent.browser.matchEdgeChromium_()||goog.labs.userAgent.browser.matchOperaChromium_()||goog.labs.userAgent.browser.matchFirefox_()||goog.labs.userAgent.browser.isSilk()||goog.labs.userAgent.util.matchUserAgent("Android"))};
goog.labs.userAgent.browser.matchCoast_=function(){return goog.labs.userAgent.util.matchUserAgent("Coast")};goog.labs.userAgent.browser.matchIosWebview_=function(){return(goog.labs.userAgent.util.matchUserAgent("iPad")||goog.labs.userAgent.util.matchUserAgent("iPhone"))&&!goog.labs.userAgent.browser.matchSafari_()&&!goog.labs.userAgent.browser.matchChrome_()&&!goog.labs.userAgent.browser.matchCoast_()&&!goog.labs.userAgent.browser.matchFirefox_()&&goog.labs.userAgent.util.matchUserAgent("AppleWebKit")};
goog.labs.userAgent.browser.matchChrome_=function(){return(goog.labs.userAgent.util.matchUserAgent("Chrome")||goog.labs.userAgent.util.matchUserAgent("CriOS"))&&!goog.labs.userAgent.browser.matchEdgeHtml_()};goog.labs.userAgent.browser.matchAndroidBrowser_=function(){return goog.labs.userAgent.util.matchUserAgent("Android")&&!(goog.labs.userAgent.browser.isChrome()||goog.labs.userAgent.browser.isFirefox()||goog.labs.userAgent.browser.isOpera()||goog.labs.userAgent.browser.isSilk())};
goog.labs.userAgent.browser.isOpera=goog.labs.userAgent.browser.matchOpera_;goog.labs.userAgent.browser.isIE=goog.labs.userAgent.browser.matchIE_;goog.labs.userAgent.browser.isEdge=goog.labs.userAgent.browser.matchEdgeHtml_;goog.labs.userAgent.browser.isEdgeChromium=goog.labs.userAgent.browser.matchEdgeChromium_;goog.labs.userAgent.browser.isOperaChromium=goog.labs.userAgent.browser.matchOperaChromium_;goog.labs.userAgent.browser.isFirefox=goog.labs.userAgent.browser.matchFirefox_;
goog.labs.userAgent.browser.isSafari=goog.labs.userAgent.browser.matchSafari_;goog.labs.userAgent.browser.isCoast=goog.labs.userAgent.browser.matchCoast_;goog.labs.userAgent.browser.isIosWebview=goog.labs.userAgent.browser.matchIosWebview_;goog.labs.userAgent.browser.isChrome=goog.labs.userAgent.browser.matchChrome_;goog.labs.userAgent.browser.isAndroidBrowser=goog.labs.userAgent.browser.matchAndroidBrowser_;goog.labs.userAgent.browser.isSilk=function(){return goog.labs.userAgent.util.matchUserAgent("Silk")};
goog.labs.userAgent.browser.getVersion=function(){function a(e){e=module$contents$goog$array_find(e,d);return c[e]||""}var b=goog.labs.userAgent.util.getUserAgent();if(goog.labs.userAgent.browser.isIE())return goog.labs.userAgent.browser.getIEVersion_(b);b=goog.labs.userAgent.util.extractVersionTuples(b);var c={};module$contents$goog$array_forEach(b,function(e){c[e[0]]=e[1]});var d=goog.partial(goog.object.containsKey,c);return goog.labs.userAgent.browser.isOpera()?a(["Version","Opera"]):goog.labs.userAgent.browser.isEdge()?
a(["Edge"]):goog.labs.userAgent.browser.isEdgeChromium()?a(["Edg"]):goog.labs.userAgent.browser.isChrome()?a(["Chrome","CriOS","HeadlessChrome"]):(b=b[2])&&b[1]||""};goog.labs.userAgent.browser.isVersionOrHigher=function(a){return 0<=goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(),a)};
goog.labs.userAgent.browser.getIEVersion_=function(a){var b=/rv: *([\d\.]*)/.exec(a);if(b&&b[1])return b[1];b="";var c=/MSIE +([\d\.]+)/.exec(a);if(c&&c[1])if(a=/Trident\/(\d.\d)/.exec(a),"7.0"==c[1])if(a&&a[1])switch(a[1]){case "4.0":b="8.0";break;case "5.0":b="9.0";break;case "6.0":b="10.0";break;case "7.0":b="11.0"}else b="7.0";else b=c[1];return b};goog.html.SafeHtml=function(a,b,c){this.privateDoNotAccessOrElseSafeHtmlWrappedValue_=c===goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_?a:"";this.dir_=b};goog.html.SafeHtml.ENABLE_ERROR_MESSAGES=goog.DEBUG;goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE=!0;goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString=!0;goog.html.SafeHtml.prototype.getDirection=function(){return this.dir_};goog.html.SafeHtml.prototype.implementsGoogStringTypedString=!0;
goog.html.SafeHtml.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString()};goog.DEBUG&&(goog.html.SafeHtml.prototype.toString=function(){return"SafeHtml{"+this.privateDoNotAccessOrElseSafeHtmlWrappedValue_+"}"});goog.html.SafeHtml.unwrap=function(a){return goog.html.SafeHtml.unwrapTrustedHTML(a).toString()};
goog.html.SafeHtml.unwrapTrustedHTML=function(a){if(a instanceof goog.html.SafeHtml&&a.constructor===goog.html.SafeHtml)return a.privateDoNotAccessOrElseSafeHtmlWrappedValue_;goog.asserts.fail("expected object of type SafeHtml, got '"+a+"' of type "+goog.typeOf(a));return"type_error:SafeHtml"};
goog.html.SafeHtml.htmlEscape=function(a){if(a instanceof goog.html.SafeHtml)return a;var b="object"==typeof a,c=null;b&&a.implementsGoogI18nBidiDirectionalString&&(c=a.getDirection());a=b&&a.implementsGoogStringTypedString?a.getTypedStringValue():String(a);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(a),c)};
goog.html.SafeHtml.htmlEscapePreservingNewlines=function(a){if(a instanceof goog.html.SafeHtml)return a;a=goog.html.SafeHtml.htmlEscape(a);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(a)),a.getDirection())};
goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces=function(a){if(a instanceof goog.html.SafeHtml)return a;a=goog.html.SafeHtml.htmlEscape(a);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(a)),a.getDirection())};goog.html.SafeHtml.from=goog.html.SafeHtml.htmlEscape;
goog.html.SafeHtml.comment=function(a){return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("\x3c!--"+goog.string.internal.htmlEscape(a)+"--\x3e",null)};goog.html.SafeHtml.VALID_NAMES_IN_TAG_=/^[a-zA-Z0-9-]+$/;goog.html.SafeHtml.URL_ATTRIBUTES_={action:!0,cite:!0,data:!0,formaction:!0,href:!0,manifest:!0,poster:!0,src:!0};
goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_=goog.object.createSet(goog.dom.TagName.APPLET,goog.dom.TagName.BASE,goog.dom.TagName.EMBED,goog.dom.TagName.IFRAME,goog.dom.TagName.LINK,goog.dom.TagName.MATH,goog.dom.TagName.META,goog.dom.TagName.OBJECT,goog.dom.TagName.SCRIPT,goog.dom.TagName.STYLE,goog.dom.TagName.SVG,goog.dom.TagName.TEMPLATE);
goog.html.SafeHtml.create=function(a,b,c){goog.html.SafeHtml.verifyTagName(String(a));return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(a),b,c)};
goog.html.SafeHtml.verifyTagName=function(a){if(!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(a))throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?"Invalid tag name <"+a+">.":"");if(a.toUpperCase()in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_)throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?"Tag name <"+a+"> is not allowed for SafeHtml.":"");};
goog.html.SafeHtml.createIframe=function(a,b,c,d){a&&goog.html.TrustedResourceUrl.unwrap(a);var e={};e.src=a||null;e.srcdoc=b&&goog.html.SafeHtml.unwrap(b);a=goog.html.SafeHtml.combineAttributes(e,{sandbox:""},c);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe",a,d)};
goog.html.SafeHtml.createSandboxIframe=function(a,b,c,d){if(!goog.html.SafeHtml.canUseSandboxIframe())throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?"The browser does not support sandboxed iframes.":"");var e={};e.src=a?goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a)):null;e.srcdoc=b||null;e.sandbox="";a=goog.html.SafeHtml.combineAttributes(e,{},c);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe",a,d)};
goog.html.SafeHtml.canUseSandboxIframe=function(){return goog.global.HTMLIFrameElement&&"sandbox"in goog.global.HTMLIFrameElement.prototype};goog.html.SafeHtml.createScriptSrc=function(a,b){goog.html.TrustedResourceUrl.unwrap(a);a=goog.html.SafeHtml.combineAttributes({src:a},{},b);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script",a)};
goog.html.SafeHtml.createScript=function(a,b){for(var c in b)if(Object.prototype.hasOwnProperty.call(b,c)){var d=c.toLowerCase();if("language"==d||"src"==d||"text"==d||"type"==d)throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?'Cannot set "'+d+'" attribute':"");}c="";a=module$contents$goog$array_concat(a);for(d=0;d<a.length;d++)c+=module$contents$goog$html$SafeScript_SafeScript.unwrap(a[d]);a=goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c,goog.i18n.bidi.Dir.NEUTRAL);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script",
b,a)};goog.html.SafeHtml.createStyle=function(a,b){b=goog.html.SafeHtml.combineAttributes({type:"text/css"},{},b);var c="";a=module$contents$goog$array_concat(a);for(var d=0;d<a.length;d++)c+=module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(a[d]);a=goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c,goog.i18n.bidi.Dir.NEUTRAL);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style",b,a)};
goog.html.SafeHtml.createMetaRefresh=function(a,b){a=goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a));(goog.labs.userAgent.browser.isIE()||goog.labs.userAgent.browser.isEdge())&&goog.string.internal.contains(a,";")&&(a="'"+a.replace(/'/g,"%27")+"'");return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta",{"http-equiv":"refresh",content:(b||0)+"; url="+a})};
goog.html.SafeHtml.getAttrNameAndValue_=function(a,b,c){if(c instanceof goog.string.Const)c=goog.string.Const.unwrap(c);else if("style"==b.toLowerCase())if(goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE)c=goog.html.SafeHtml.getStyleValue_(c);else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?'Attribute "style" not supported.':"");else{if(/^on/i.test(b))throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?'Attribute "'+b+'" requires goog.string.Const value, "'+c+'" given.':"");if(b.toLowerCase()in
goog.html.SafeHtml.URL_ATTRIBUTES_)if(c instanceof goog.html.TrustedResourceUrl)c=goog.html.TrustedResourceUrl.unwrap(c);else if(c instanceof goog.html.SafeUrl)c=goog.html.SafeUrl.unwrap(c);else if("string"===typeof c)c=goog.html.SafeUrl.sanitize(c).getTypedStringValue();else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?'Attribute "'+b+'" on tag "'+a+'" requires goog.html.SafeUrl, goog.string.Const, or string, value "'+c+'" given.':"");}c.implementsGoogStringTypedString&&(c=c.getTypedStringValue());
goog.asserts.assert("string"===typeof c||"number"===typeof c,"String or number value expected, got "+typeof c+" with value: "+c);return b+'="'+goog.string.internal.htmlEscape(String(c))+'"'};goog.html.SafeHtml.getStyleValue_=function(a){if(!goog.isObject(a))throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?'The "style" attribute requires goog.html.SafeStyle or map of style properties, '+typeof a+" given: "+a:"");a instanceof goog.html.SafeStyle||(a=goog.html.SafeStyle.create(a));return goog.html.SafeStyle.unwrap(a)};
goog.html.SafeHtml.createWithDir=function(a,b,c,d){b=goog.html.SafeHtml.create(b,c,d);b.dir_=a;return b};
goog.html.SafeHtml.join=function(a,b){a=goog.html.SafeHtml.htmlEscape(a);var c=a.getDirection(),d=[],e=function(f){Array.isArray(f)?module$contents$goog$array_forEach(f,e):(f=goog.html.SafeHtml.htmlEscape(f),d.push(goog.html.SafeHtml.unwrap(f)),f=f.getDirection(),c==goog.i18n.bidi.Dir.NEUTRAL?c=f:f!=goog.i18n.bidi.Dir.NEUTRAL&&c!=f&&(c=null))};module$contents$goog$array_forEach(b,e);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(d.join(goog.html.SafeHtml.unwrap(a)),c)};
goog.html.SafeHtml.concat=function(a){return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY,Array.prototype.slice.call(arguments))};goog.html.SafeHtml.concatWithDir=function(a,b){var c=goog.html.SafeHtml.concat(module$contents$goog$array_slice(arguments,1));c.dir_=a;return c};goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_={};
goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse=function(a,b){var c=goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();a=c?c.createHTML(a):a;return new goog.html.SafeHtml(a,b,goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_)};
goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse=function(a,b,c){var d=null;var e="<"+a+goog.html.SafeHtml.stringifyAttributes(a,b);null==c?c=[]:Array.isArray(c)||(c=[c]);goog.dom.tags.isVoidTag(a.toLowerCase())?(goog.asserts.assert(!c.length,"Void tag <"+a+"> does not allow content."),e+=">"):(d=goog.html.SafeHtml.concat(c),e+=">"+goog.html.SafeHtml.unwrap(d)+"</"+a+">",d=d.getDirection());(a=b&&b.dir)&&(d=/^(ltr|rtl|auto)$/i.test(a)?goog.i18n.bidi.Dir.NEUTRAL:null);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(e,
d)};goog.html.SafeHtml.stringifyAttributes=function(a,b){var c="";if(b)for(var d in b)if(Object.prototype.hasOwnProperty.call(b,d)){if(!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(d))throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?'Invalid attribute name "'+d+'".':"");var e=b[d];null!=e&&(c+=" "+goog.html.SafeHtml.getAttrNameAndValue_(a,d,e))}return c};
goog.html.SafeHtml.combineAttributes=function(a,b,c){var d={},e;for(e in a)Object.prototype.hasOwnProperty.call(a,e)&&(goog.asserts.assert(e.toLowerCase()==e,"Must be lower case"),d[e]=a[e]);for(e in b)Object.prototype.hasOwnProperty.call(b,e)&&(goog.asserts.assert(e.toLowerCase()==e,"Must be lower case"),d[e]=b[e]);if(c)for(e in c)if(Object.prototype.hasOwnProperty.call(c,e)){var f=e.toLowerCase();if(f in a)throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?'Cannot override "'+f+'" attribute, got "'+
e+'" with value "'+c[e]+'"':"");f in b&&delete d[f];d[e]=c[e]}return d};goog.html.SafeHtml.DOCTYPE_HTML=function(){return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>",goog.i18n.bidi.Dir.NEUTRAL)}();goog.html.SafeHtml.EMPTY=new goog.html.SafeHtml(goog.global.trustedTypes&&goog.global.trustedTypes.emptyHTML||"",goog.i18n.bidi.Dir.NEUTRAL,goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_);
goog.html.SafeHtml.BR=function(){return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>",goog.i18n.bidi.Dir.NEUTRAL)}();goog.html.uncheckedconversions={};goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract=function(a,b,c){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(b,c||null)};
goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract=function(a,b){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(b)};
goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract=function(a,b){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b)};
goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract=function(a,b){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b)};
goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract=function(a,b){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b)};
goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract=function(a,b){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b)};goog.dom.safe={};goog.dom.safe.InsertAdjacentHtmlPosition={AFTERBEGIN:"afterbegin",AFTEREND:"afterend",BEFOREBEGIN:"beforebegin",BEFOREEND:"beforeend"};goog.dom.safe.insertAdjacentHtml=function(a,b,c){a.insertAdjacentHTML(b,goog.html.SafeHtml.unwrapTrustedHTML(c))};goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_={MATH:!0,SCRIPT:!0,STYLE:!0,SVG:!0,TEMPLATE:!0};
goog.dom.safe.isInnerHtmlCleanupRecursive_=goog.functions.cacheReturnValue(function(){if(goog.DEBUG&&"undefined"===typeof document)return!1;var a=document.createElement("div"),b=document.createElement("div");b.appendChild(document.createElement("div"));a.appendChild(b);if(goog.DEBUG&&!a.firstChild)return!1;b=a.firstChild.firstChild;a.innerHTML=goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY);return!b.parentElement});
goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse=function(a,b){if(goog.dom.safe.isInnerHtmlCleanupRecursive_())for(;a.lastChild;)a.removeChild(a.lastChild);a.innerHTML=goog.html.SafeHtml.unwrapTrustedHTML(b)};
goog.dom.safe.setInnerHtml=function(a,b){if(goog.asserts.ENABLE_ASSERTS&&a.tagName){var c=a.tagName.toUpperCase();if(goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[c])throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of "+a.tagName+".");}goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(a,b)};
goog.dom.safe.setInnerHtmlFromConstant=function(a,b){goog.dom.safe.setInnerHtml(a,goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Constant HTML to be immediatelly used."),goog.string.Const.unwrap(b)))};goog.dom.safe.setOuterHtml=function(a,b){a.outerHTML=goog.html.SafeHtml.unwrapTrustedHTML(b)};
goog.dom.safe.setFormElementAction=function(a,b){b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);goog.dom.asserts.assertIsHTMLFormElement(a).action=goog.html.SafeUrl.unwrap(b)};goog.dom.safe.setButtonFormAction=function(a,b){b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);goog.dom.asserts.assertIsHTMLButtonElement(a).formAction=goog.html.SafeUrl.unwrap(b)};
goog.dom.safe.setInputFormAction=function(a,b){b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);goog.dom.asserts.assertIsHTMLInputElement(a).formAction=goog.html.SafeUrl.unwrap(b)};goog.dom.safe.setStyle=function(a,b){a.style.cssText=goog.html.SafeStyle.unwrap(b)};goog.dom.safe.documentWrite=function(a,b){a.write(goog.html.SafeHtml.unwrapTrustedHTML(b))};
goog.dom.safe.setAnchorHref=function(a,b){goog.dom.asserts.assertIsHTMLAnchorElement(a);b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);a.href=goog.html.SafeUrl.unwrap(b)};goog.dom.safe.setImageSrc=function(a,b){goog.dom.asserts.assertIsHTMLImageElement(a);if(!(b instanceof goog.html.SafeUrl)){var c=/^data:image\//i.test(b);b=goog.html.SafeUrl.sanitizeAssertUnchanged(b,c)}a.src=goog.html.SafeUrl.unwrap(b)};
goog.dom.safe.setAudioSrc=function(a,b){goog.dom.asserts.assertIsHTMLAudioElement(a);if(!(b instanceof goog.html.SafeUrl)){var c=/^data:audio\//i.test(b);b=goog.html.SafeUrl.sanitizeAssertUnchanged(b,c)}a.src=goog.html.SafeUrl.unwrap(b)};goog.dom.safe.setVideoSrc=function(a,b){goog.dom.asserts.assertIsHTMLVideoElement(a);if(!(b instanceof goog.html.SafeUrl)){var c=/^data:video\//i.test(b);b=goog.html.SafeUrl.sanitizeAssertUnchanged(b,c)}a.src=goog.html.SafeUrl.unwrap(b)};
goog.dom.safe.setEmbedSrc=function(a,b){goog.dom.asserts.assertIsHTMLEmbedElement(a);a.src=goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b)};goog.dom.safe.setFrameSrc=function(a,b){goog.dom.asserts.assertIsHTMLFrameElement(a);a.src=goog.html.TrustedResourceUrl.unwrap(b)};goog.dom.safe.setIframeSrc=function(a,b){goog.dom.asserts.assertIsHTMLIFrameElement(a);a.src=goog.html.TrustedResourceUrl.unwrap(b)};
goog.dom.safe.setIframeSrcdoc=function(a,b){goog.dom.asserts.assertIsHTMLIFrameElement(a);a.srcdoc=goog.html.SafeHtml.unwrapTrustedHTML(b)};
goog.dom.safe.setLinkHrefAndRel=function(a,b,c){goog.dom.asserts.assertIsHTMLLinkElement(a);a.rel=c;goog.string.internal.caseInsensitiveContains(c,"stylesheet")?(goog.asserts.assert(b instanceof goog.html.TrustedResourceUrl,'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'),a.href=goog.html.TrustedResourceUrl.unwrap(b)):a.href=b instanceof goog.html.TrustedResourceUrl?goog.html.TrustedResourceUrl.unwrap(b):b instanceof goog.html.SafeUrl?goog.html.SafeUrl.unwrap(b):goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitizeAssertUnchanged(b))};
goog.dom.safe.setObjectData=function(a,b){goog.dom.asserts.assertIsHTMLObjectElement(a);a.data=goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b)};goog.dom.safe.setScriptSrc=function(a,b){goog.dom.asserts.assertIsHTMLScriptElement(a);a.src=goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);goog.dom.safe.setNonceForScriptElement_(a)};
goog.dom.safe.setScriptContent=function(a,b){goog.dom.asserts.assertIsHTMLScriptElement(a);a.textContent=module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(b);goog.dom.safe.setNonceForScriptElement_(a)};goog.dom.safe.setNonceForScriptElement_=function(a){var b=goog.getScriptNonce(a.ownerDocument&&a.ownerDocument.defaultView);b&&a.setAttribute("nonce",b)};
goog.dom.safe.setLocationHref=function(a,b){goog.dom.asserts.assertIsLocation(a);b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);a.href=goog.html.SafeUrl.unwrap(b)};goog.dom.safe.assignLocation=function(a,b){goog.dom.asserts.assertIsLocation(a);b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);a.assign(goog.html.SafeUrl.unwrap(b))};
goog.dom.safe.replaceLocation=function(a,b){b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);a.replace(goog.html.SafeUrl.unwrap(b))};goog.dom.safe.openInWindow=function(a,b,c,d,e){a=a instanceof goog.html.SafeUrl?a:goog.html.SafeUrl.sanitizeAssertUnchanged(a);b=b||goog.global;c=c instanceof goog.string.Const?goog.string.Const.unwrap(c):c||"";return b.open(goog.html.SafeUrl.unwrap(a),c,d,e)};
goog.dom.safe.parseFromStringHtml=function(a,b){return goog.dom.safe.parseFromString(a,b,"text/html")};goog.dom.safe.parseFromString=function(a,b,c){return a.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(b),c)};
goog.dom.safe.createImageFromBlob=function(a){if(!/^image\/.*/g.test(a.type))throw Error("goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.");var b=goog.global.URL.createObjectURL(a);a=new goog.global.Image;a.onload=function(){goog.global.URL.revokeObjectURL(b)};goog.dom.safe.setImageSrc(a,goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Image blob URL."),b));return a};goog.string.DETECT_DOUBLE_ESCAPING=!1;goog.string.FORCE_NON_DOM_HTML_UNESCAPING=!1;goog.string.Unicode={NBSP:"\u00a0"};goog.string.startsWith=goog.string.internal.startsWith;goog.string.endsWith=goog.string.internal.endsWith;goog.string.caseInsensitiveStartsWith=goog.string.internal.caseInsensitiveStartsWith;goog.string.caseInsensitiveEndsWith=goog.string.internal.caseInsensitiveEndsWith;goog.string.caseInsensitiveEquals=goog.string.internal.caseInsensitiveEquals;
goog.string.subs=function(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")};goog.string.collapseWhitespace=function(a){return a.replace(/[\s\xa0]+/g," ").replace(/^\s+|\s+$/g,"")};goog.string.isEmptyOrWhitespace=goog.string.internal.isEmptyOrWhitespace;goog.string.isEmptyString=function(a){return 0==a.length};goog.string.isEmpty=goog.string.isEmptyOrWhitespace;goog.string.isEmptyOrWhitespaceSafe=function(a){return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(a))};
goog.string.isEmptySafe=goog.string.isEmptyOrWhitespaceSafe;goog.string.isBreakingWhitespace=function(a){return!/[^\t\n\r ]/.test(a)};goog.string.isAlpha=function(a){return!/[^a-zA-Z]/.test(a)};goog.string.isNumeric=function(a){return!/[^0-9]/.test(a)};goog.string.isAlphaNumeric=function(a){return!/[^a-zA-Z0-9]/.test(a)};goog.string.isSpace=function(a){return" "==a};goog.string.isUnicodeChar=function(a){return 1==a.length&&" "<=a&&"~">=a||"\u0080"<=a&&"\ufffd">=a};
goog.string.stripNewlines=function(a){return a.replace(/(\r\n|\r|\n)+/g," ")};goog.string.canonicalizeNewlines=function(a){return a.replace(/(\r\n|\r|\n)/g,"\n")};goog.string.normalizeWhitespace=function(a){return a.replace(/\xa0|\s/g," ")};goog.string.normalizeSpaces=function(a){return a.replace(/\xa0|[ \t]+/g," ")};goog.string.collapseBreakingSpaces=function(a){return a.replace(/[\t\r\n ]+/g," ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g,"")};goog.string.trim=goog.string.internal.trim;
goog.string.trimLeft=function(a){return a.replace(/^[\s\xa0]+/,"")};goog.string.trimRight=function(a){return a.replace(/[\s\xa0]+$/,"")};goog.string.caseInsensitiveCompare=goog.string.internal.caseInsensitiveCompare;
goog.string.numberAwareCompare_=function(a,b,c){if(a==b)return 0;if(!a)return-1;if(!b)return 1;for(var d=a.toLowerCase().match(c),e=b.toLowerCase().match(c),f=Math.min(d.length,e.length),g=0;g<f;g++){c=d[g];var h=e[g];if(c!=h)return a=parseInt(c,10),!isNaN(a)&&(b=parseInt(h,10),!isNaN(b)&&a-b)?a-b:c<h?-1:1}return d.length!=e.length?d.length-e.length:a<b?-1:1};goog.string.intAwareCompare=function(a,b){return goog.string.numberAwareCompare_(a,b,/\d+|\D+/g)};
goog.string.floatAwareCompare=function(a,b){return goog.string.numberAwareCompare_(a,b,/\d+|\.\d+|\D+/g)};goog.string.numerateCompare=goog.string.floatAwareCompare;goog.string.urlEncode=function(a){return encodeURIComponent(String(a))};goog.string.urlDecode=function(a){return decodeURIComponent(a.replace(/\+/g," "))};goog.string.newLineToBr=goog.string.internal.newLineToBr;
goog.string.htmlEscape=function(a,b){a=goog.string.internal.htmlEscape(a,b);goog.string.DETECT_DOUBLE_ESCAPING&&(a=a.replace(goog.string.E_RE_,"&#101;"));return a};goog.string.E_RE_=/e/g;goog.string.unescapeEntities=function(a){return goog.string.contains(a,"&")?!goog.string.FORCE_NON_DOM_HTML_UNESCAPING&&"document"in goog.global?goog.string.unescapeEntitiesUsingDom_(a):goog.string.unescapePureXmlEntities_(a):a};
goog.string.unescapeEntitiesWithDocument=function(a,b){return goog.string.contains(a,"&")?goog.string.unescapeEntitiesUsingDom_(a,b):a};
goog.string.unescapeEntitiesUsingDom_=function(a,b){var c={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"'};var d=b?b.createElement("div"):goog.global.document.createElement("div");return a.replace(goog.string.HTML_ENTITY_PATTERN_,function(e,f){var g=c[e];if(g)return g;"#"==f.charAt(0)&&(f=Number("0"+f.substr(1)),isNaN(f)||(g=String.fromCharCode(f)));g||(goog.dom.safe.setInnerHtml(d,goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Single HTML entity."),
e+" ")),g=d.firstChild.nodeValue.slice(0,-1));return c[e]=g})};goog.string.unescapePureXmlEntities_=function(a){return a.replace(/&([^;]+);/g,function(b,c){switch(c){case "amp":return"&";case "lt":return"<";case "gt":return">";case "quot":return'"';default:return"#"!=c.charAt(0)||(c=Number("0"+c.substr(1)),isNaN(c))?b:String.fromCharCode(c)}})};goog.string.HTML_ENTITY_PATTERN_=/&([^;\s<&]+);?/g;goog.string.whitespaceEscape=function(a,b){return goog.string.newLineToBr(a.replace(/  /g," &#160;"),b)};
goog.string.preserveSpaces=function(a){return a.replace(/(^|[\n ]) /g,"$1"+goog.string.Unicode.NBSP)};goog.string.stripQuotes=function(a,b){for(var c=b.length,d=0;d<c;d++){var e=1==c?b:b.charAt(d);if(a.charAt(0)==e&&a.charAt(a.length-1)==e)return a.substring(1,a.length-1)}return a};goog.string.truncate=function(a,b,c){c&&(a=goog.string.unescapeEntities(a));a.length>b&&(a=a.substring(0,b-3)+"...");c&&(a=goog.string.htmlEscape(a));return a};
goog.string.truncateMiddle=function(a,b,c,d){c&&(a=goog.string.unescapeEntities(a));if(d&&a.length>b){d>b&&(d=b);var e=a.length-d;a=a.substring(0,b-d)+"..."+a.substring(e)}else a.length>b&&(d=Math.floor(b/2),e=a.length-d,a=a.substring(0,d+b%2)+"..."+a.substring(e));c&&(a=goog.string.htmlEscape(a));return a};goog.string.specialEscapeChars_={"\x00":"\\0","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\x0B",'"':'\\"',"\\":"\\\\","<":"\\u003C"};goog.string.jsEscapeCache_={"'":"\\'"};
goog.string.quote=function(a){a=String(a);for(var b=['"'],c=0;c<a.length;c++){var d=a.charAt(c),e=d.charCodeAt(0);b[c+1]=goog.string.specialEscapeChars_[d]||(31<e&&127>e?d:goog.string.escapeChar(d))}b.push('"');return b.join("")};goog.string.escapeString=function(a){for(var b=[],c=0;c<a.length;c++)b[c]=goog.string.escapeChar(a.charAt(c));return b.join("")};
goog.string.escapeChar=function(a){if(a in goog.string.jsEscapeCache_)return goog.string.jsEscapeCache_[a];if(a in goog.string.specialEscapeChars_)return goog.string.jsEscapeCache_[a]=goog.string.specialEscapeChars_[a];var b=a.charCodeAt(0);if(31<b&&127>b)var c=a;else{if(256>b){if(c="\\x",16>b||256<b)c+="0"}else c="\\u",4096>b&&(c+="0");c+=b.toString(16).toUpperCase()}return goog.string.jsEscapeCache_[a]=c};goog.string.contains=goog.string.internal.contains;goog.string.caseInsensitiveContains=goog.string.internal.caseInsensitiveContains;
goog.string.countOf=function(a,b){return a&&b?a.split(b).length-1:0};goog.string.removeAt=function(a,b,c){var d=a;0<=b&&b<a.length&&0<c&&(d=a.substr(0,b)+a.substr(b+c,a.length-b-c));return d};goog.string.remove=function(a,b){return a.replace(b,"")};goog.string.removeAll=function(a,b){b=new RegExp(goog.string.regExpEscape(b),"g");return a.replace(b,"")};goog.string.replaceAll=function(a,b,c){b=new RegExp(goog.string.regExpEscape(b),"g");return a.replace(b,c.replace(/\$/g,"$$$$"))};
goog.string.regExpEscape=function(a){return String(a).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g,"\\$1").replace(/\x08/g,"\\x08")};goog.string.repeat=String.prototype.repeat?function(a,b){return a.repeat(b)}:function(a,b){return Array(b+1).join(a)};goog.string.padNumber=function(a,b,c){a=void 0!==c?a.toFixed(c):String(a);c=a.indexOf(".");-1==c&&(c=a.length);return goog.string.repeat("0",Math.max(0,b-c))+a};goog.string.makeSafe=function(a){return null==a?"":String(a)};
goog.string.buildString=function(a){return Array.prototype.join.call(arguments,"")};goog.string.getRandomString=function(){return Math.floor(2147483648*Math.random()).toString(36)+Math.abs(Math.floor(2147483648*Math.random())^goog.now()).toString(36)};goog.string.compareVersions=goog.string.internal.compareVersions;goog.string.hashCode=function(a){for(var b=0,c=0;c<a.length;++c)b=31*b+a.charCodeAt(c)>>>0;return b};goog.string.uniqueStringCounter_=2147483648*Math.random()|0;
goog.string.createUniqueString=function(){return"goog_"+goog.string.uniqueStringCounter_++};goog.string.toNumber=function(a){var b=Number(a);return 0==b&&goog.string.isEmptyOrWhitespace(a)?NaN:b};goog.string.isLowerCamelCase=function(a){return/^[a-z]+([A-Z][a-z]*)*$/.test(a)};goog.string.isUpperCamelCase=function(a){return/^([A-Z][a-z]*)+$/.test(a)};goog.string.toCamelCase=function(a){return String(a).replace(/\-([a-z])/g,function(b,c){return c.toUpperCase()})};
goog.string.toSelectorCase=function(a){return String(a).replace(/([A-Z])/g,"-$1").toLowerCase()};goog.string.toTitleCase=function(a,b){b="string"===typeof b?goog.string.regExpEscape(b):"\\s";return a.replace(new RegExp("(^"+(b?"|["+b+"]+":"")+")([a-z])","g"),function(c,d,e){return d+e.toUpperCase()})};goog.string.capitalize=function(a){return String(a.charAt(0)).toUpperCase()+String(a.substr(1)).toLowerCase()};
goog.string.parseInt=function(a){isFinite(a)&&(a=String(a));return"string"===typeof a?/^\s*-?0x/i.test(a)?parseInt(a,16):parseInt(a,10):NaN};goog.string.splitLimit=function(a,b,c){a=a.split(b);for(var d=[];0<c&&a.length;)d.push(a.shift()),c--;a.length&&d.push(a.join(b));return d};goog.string.lastComponent=function(a,b){if(b)"string"==typeof b&&(b=[b]);else return a;for(var c=-1,d=0;d<b.length;d++)if(""!=b[d]){var e=a.lastIndexOf(b[d]);e>c&&(c=e)}return-1==c?a:a.slice(c+1)};
goog.string.editDistance=function(a,b){var c=[],d=[];if(a==b)return 0;if(!a.length||!b.length)return Math.max(a.length,b.length);for(var e=0;e<b.length+1;e++)c[e]=e;for(e=0;e<a.length;e++){d[0]=e+1;for(var f=0;f<b.length;f++)d[f+1]=Math.min(d[f]+1,c[f+1]+1,c[f]+Number(a[e]!=b[f]));for(f=0;f<c.length;f++)c[f]=d[f]}return d[b.length]};goog.proto2={};goog.proto2.Descriptor=function(a,b,c){this.messageType_=a;this.name_=b.name||null;this.fullName_=b.fullName||null;this.containingType_=b.containingType;this.fields_={};for(a=0;a<c.length;a++)b=c[a],this.fields_[b.getTag()]=b};goog.proto2.Descriptor.prototype.getName=function(){return this.name_};goog.proto2.Descriptor.prototype.getFullName=function(){return this.fullName_};
goog.proto2.Descriptor.prototype.getContainingType=function(){return this.containingType_?this.containingType_.getDescriptor():null};goog.proto2.Descriptor.prototype.getFields=function(){var a=goog.object.getValues(this.fields_);module$contents$goog$array_sort(a,function(b,c){return b.getTag()-c.getTag()});return a};goog.proto2.Descriptor.prototype.getFieldsMap=function(){return this.fields_};
goog.proto2.Descriptor.prototype.findFieldByName=function(a){return goog.object.findValue(this.fields_,function(b,c,d){return b.getName()==a})||null};goog.proto2.Descriptor.prototype.findFieldByTag=function(a){goog.asserts.assert(goog.string.isNumeric(a));return this.fields_[parseInt(a,10)]||null};goog.proto2.Descriptor.prototype.createMessageInstance=function(){return new this.messageType_};goog.proto2.FieldDescriptor=function(a,b,c){this.parent_=a;goog.asserts.assert(goog.string.isNumeric(b));this.tag_=b;this.name_=c.name;this.isPacked_=!!c.packed;this.isRepeated_=!!c.repeated;this.isRequired_=!!c.required;this.fieldType_=c.fieldType;this.nativeType_=c.type;this.deserializationConversionPermitted_=!1;switch(this.fieldType_){case goog.proto2.FieldDescriptor.FieldType.INT64:case goog.proto2.FieldDescriptor.FieldType.UINT64:case goog.proto2.FieldDescriptor.FieldType.FIXED64:case goog.proto2.FieldDescriptor.FieldType.SFIXED64:case goog.proto2.FieldDescriptor.FieldType.SINT64:case goog.proto2.FieldDescriptor.FieldType.FLOAT:case goog.proto2.FieldDescriptor.FieldType.DOUBLE:this.deserializationConversionPermitted_=
!0}this.defaultValue_=c.defaultValue};goog.proto2.FieldDescriptor.FieldType={DOUBLE:1,FLOAT:2,INT64:3,UINT64:4,INT32:5,FIXED64:6,FIXED32:7,BOOL:8,STRING:9,GROUP:10,MESSAGE:11,BYTES:12,UINT32:13,ENUM:14,SFIXED32:15,SFIXED64:16,SINT32:17,SINT64:18};goog.proto2.FieldDescriptor.prototype.getTag=function(){return this.tag_};goog.proto2.FieldDescriptor.prototype.getContainingType=function(){return this.parent_.prototype.getDescriptor()};goog.proto2.FieldDescriptor.prototype.getName=function(){return this.name_};
goog.proto2.FieldDescriptor.prototype.getDefaultValue=function(){if(void 0===this.defaultValue_){var a=this.nativeType_;if(a===Boolean)this.defaultValue_=!1;else if(a===Number)this.defaultValue_=0;else if(a===String)this.defaultValue_=this.deserializationConversionPermitted_?"0":"";else return new a}return this.defaultValue_};goog.proto2.FieldDescriptor.prototype.getFieldType=function(){return this.fieldType_};goog.proto2.FieldDescriptor.prototype.getNativeType=function(){return this.nativeType_};
goog.proto2.FieldDescriptor.prototype.deserializationConversionPermitted=function(){return this.deserializationConversionPermitted_};goog.proto2.FieldDescriptor.prototype.getFieldMessageType=function(){return this.nativeType_.prototype.getDescriptor()};goog.proto2.FieldDescriptor.prototype.isCompositeType=function(){return this.fieldType_==goog.proto2.FieldDescriptor.FieldType.MESSAGE||this.fieldType_==goog.proto2.FieldDescriptor.FieldType.GROUP};goog.proto2.FieldDescriptor.prototype.isPacked=function(){return this.isPacked_};
goog.proto2.FieldDescriptor.prototype.isRepeated=function(){return this.isRepeated_};goog.proto2.FieldDescriptor.prototype.isRequired=function(){return this.isRequired_};goog.proto2.FieldDescriptor.prototype.isOptional=function(){return!this.isRepeated_&&!this.isRequired_};goog.proto2.Message=function(){this.values_={};this.fields_=this.getDescriptor().getFieldsMap();this.deserializedFields_=this.lazyDeserializer_=null};goog.proto2.Message.FieldType={DOUBLE:1,FLOAT:2,INT64:3,UINT64:4,INT32:5,FIXED64:6,FIXED32:7,BOOL:8,STRING:9,GROUP:10,MESSAGE:11,BYTES:12,UINT32:13,ENUM:14,SFIXED32:15,SFIXED64:16,SINT32:17,SINT64:18};goog.proto2.Message.prototype.initializeForLazyDeserializer=function(a,b){this.lazyDeserializer_=a;this.values_=b;this.deserializedFields_={}};
goog.proto2.Message.prototype.setUnknown=function(a,b){goog.asserts.assert(!this.fields_[a],"Field is not unknown in this message");goog.asserts.assert(1<=a,"Tag "+a+' has value "'+b+'" in descriptor '+this.getDescriptor().getName());goog.asserts.assert(null!==b,"Value cannot be null");this.values_[a]=b;this.deserializedFields_&&delete this.deserializedFields_[a]};
goog.proto2.Message.prototype.forEachUnknown=function(a,b){b=b||this;for(var c in this.values_){var d=Number(c);this.fields_[d]||a.call(b,d,this.values_[c])}};goog.proto2.Message.prototype.getDescriptor=goog.abstractMethod;goog.proto2.Message.prototype.has=function(a){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");return this.has$Value(a.getTag())};
goog.proto2.Message.prototype.arrayOf=function(a){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");return this.array$Values(a.getTag())};goog.proto2.Message.prototype.countOf=function(a){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");return this.count$Values(a.getTag())};
goog.proto2.Message.prototype.get=function(a,b){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");return this.get$Value(a.getTag(),b)};goog.proto2.Message.prototype.getOrDefault=function(a,b){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");return this.get$ValueOrDefault(a.getTag(),b)};
goog.proto2.Message.prototype.set=function(a,b){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");this.set$Value(a.getTag(),b)};goog.proto2.Message.prototype.add=function(a,b){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");this.add$Value(a.getTag(),b)};
goog.proto2.Message.prototype.clear=function(a){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");this.clear$Field(a.getTag())};
goog.proto2.Message.prototype.equals=function(a){if(!a||this.constructor!=a.constructor)return!1;for(var b=this.getDescriptor().getFields(),c=0;c<b.length;c++){var d=b[c],e=d.getTag();if(this.has$Value(e)!=a.has$Value(e))return!1;if(this.has$Value(e)){var f=d.isCompositeType(),g=this.getValueForTag_(e);e=a.getValueForTag_(e);if(d.isRepeated()){if(g.length!=e.length)return!1;for(d=0;d<g.length;d++){var h=g[d],k=e[d];if(f?!h.equals(k):h!=k)return!1}}else if(f?!g.equals(e):g!=e)return!1}}return!0};
goog.proto2.Message.prototype.copyFrom=function(a){goog.asserts.assert(this.constructor==a.constructor,"The source message must have the same type.");this!=a&&(this.values_={},this.deserializedFields_&&(this.deserializedFields_={}),this.mergeFrom(a))};
goog.proto2.Message.prototype.mergeFrom=function(a){goog.asserts.assert(this.constructor==a.constructor,"The source message must have the same type.");for(var b=this.getDescriptor().getFields(),c=0;c<b.length;c++){var d=b[c],e=d.getTag();if(a.has$Value(e)){this.deserializedFields_&&delete this.deserializedFields_[d.getTag()];var f=d.isCompositeType();if(d.isRepeated()){d=a.array$Values(e);for(var g=0;g<d.length;g++)this.add$Value(e,f?d[g].clone():d[g])}else d=a.getValueForTag_(e),f?(f=this.getValueForTag_(e))?
f.mergeFrom(d):this.set$Value(e,d.clone()):this.set$Value(e,d)}}};goog.proto2.Message.prototype.clone=function(){var a=new this.constructor;a.copyFrom(this);return a};
goog.proto2.Message.prototype.initDefaults=function(a){for(var b=this.getDescriptor().getFields(),c=0;c<b.length;c++){var d=b[c],e=d.getTag(),f=d.isCompositeType();this.has$Value(e)||d.isRepeated()||(f?this.values_[e]=new (d.getNativeType()):a&&(this.values_[e]=d.getDefaultValue()));if(f)if(d.isRepeated())for(d=this.array$Values(e),e=0;e<d.length;e++)d[e].initDefaults(a);else this.get$Value(e).initDefaults(a)}};goog.proto2.Message.prototype.has$Value=function(a){return null!=this.values_[a]};
goog.proto2.Message.prototype.getValueForTag_=function(a){var b=this.values_[a];return null==b?null:this.lazyDeserializer_?a in this.deserializedFields_?this.deserializedFields_[a]:(b=this.lazyDeserializer_.deserializeField(this,this.fields_[a],b),this.deserializedFields_[a]=b):b};
goog.proto2.Message.prototype.get$Value=function(a,b){var c=this.getValueForTag_(a);return this.fields_[a].isRepeated()?(a=b||0,goog.asserts.assert(0<=a&&a<c.length,"Given index %s is out of bounds.  Repeated field length: %s",a,c.length),c[a]):c};goog.proto2.Message.prototype.get$ValueOrDefault=function(a,b){return this.has$Value(a)?this.get$Value(a,b):this.fields_[a].getDefaultValue()};goog.proto2.Message.prototype.array$Values=function(a){return this.getValueForTag_(a)||[]};
goog.proto2.Message.prototype.count$Values=function(a){return this.fields_[a].isRepeated()?this.has$Value(a)?this.values_[a].length:0:this.has$Value(a)?1:0};goog.proto2.Message.prototype.set$Value=function(a,b){goog.asserts.ENABLE_ASSERTS&&this.checkFieldType_(this.fields_[a],b);this.values_[a]=b;this.deserializedFields_&&(this.deserializedFields_[a]=b)};
goog.proto2.Message.prototype.add$Value=function(a,b){goog.asserts.ENABLE_ASSERTS&&this.checkFieldType_(this.fields_[a],b);this.values_[a]||(this.values_[a]=[]);this.values_[a].push(b);this.deserializedFields_&&delete this.deserializedFields_[a]};goog.proto2.Message.prototype.checkFieldType_=function(a,b){a.getFieldType()==goog.proto2.FieldDescriptor.FieldType.ENUM?goog.asserts.assertNumber(b):goog.asserts.assert(Object(b).constructor==a.getNativeType())};
goog.proto2.Message.prototype.clear$Field=function(a){delete this.values_[a];this.deserializedFields_&&delete this.deserializedFields_[a]};goog.proto2.Message.createDescriptor=function(a,b){var c=[],d=b[0],e;for(e in b)0!=e&&c.push(new goog.proto2.FieldDescriptor(a,e,b[e]));return new goog.proto2.Descriptor(a,d,c)};goog.proto2.Serializer=function(){};goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS=!1;goog.proto2.Serializer.prototype.serialize=goog.abstractMethod;goog.proto2.Serializer.prototype.getSerializedValue=function(a,b){return a.isCompositeType()?this.serialize(b):"number"!==typeof b||isFinite(b)?b:b.toString()};goog.proto2.Serializer.prototype.deserialize=function(a,b){a=a.createMessageInstance();this.deserializeTo(a,b);goog.asserts.assert(a instanceof goog.proto2.Message);return a};
goog.proto2.Serializer.prototype.deserializeTo=goog.abstractMethod;
goog.proto2.Serializer.prototype.getDeserializedValue=function(a,b){if(a.isCompositeType())return b instanceof goog.proto2.Message?b:this.deserialize(a.getFieldMessageType(),b);if(a.getFieldType()==goog.proto2.FieldDescriptor.FieldType.ENUM)return goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS&&"string"===typeof b&&(a=a.getNativeType(),a.hasOwnProperty(b))?a[b]:"string"===typeof b&&goog.proto2.Serializer.INTEGER_REGEX.test(b)&&(a=Number(b),0<a)?a:b;if(!a.deserializationConversionPermitted())return b;
a=a.getNativeType();if(a===String){if("number"===typeof b)return String(b)}else if(a===Number&&"string"===typeof b&&("Infinity"===b||"-Infinity"===b||"NaN"===b||goog.proto2.Serializer.INTEGER_REGEX.test(b)))return Number(b);return b};goog.proto2.Serializer.INTEGER_REGEX=/^-?[0-9]+$/;goog.proto2.LazyDeserializer=function(){};goog.inherits(goog.proto2.LazyDeserializer,goog.proto2.Serializer);goog.proto2.LazyDeserializer.prototype.deserialize=function(a,b){a=a.createMessageInstance();a.initializeForLazyDeserializer(this,b);goog.asserts.assert(a instanceof goog.proto2.Message);return a};goog.proto2.LazyDeserializer.prototype.deserializeTo=function(a,b){throw Error("Unimplemented");};goog.proto2.LazyDeserializer.prototype.deserializeField=goog.abstractMethod;goog.proto2.PbLiteSerializer=function(){};goog.inherits(goog.proto2.PbLiteSerializer,goog.proto2.LazyDeserializer);goog.proto2.PbLiteSerializer.prototype.zeroIndexing_=!1;goog.proto2.PbLiteSerializer.prototype.setZeroIndexed=function(a){this.zeroIndexing_=a};
goog.proto2.PbLiteSerializer.prototype.serialize=function(a){for(var b=a.getDescriptor().getFields(),c=[],d=this.zeroIndexing_,e=0;e<b.length;e++){var f=b[e];if(a.has(f)){var g=f.getTag();g=d?g-1:g;if(f.isRepeated()){c[g]=[];for(var h=0;h<a.countOf(f);h++)c[g][h]=this.getSerializedValue(f,a.get(f,h))}else c[g]=this.getSerializedValue(f,a.get(f))}}a.forEachUnknown(function(k,l){c[d?k-1:k]=l});return c};
goog.proto2.PbLiteSerializer.prototype.deserializeField=function(a,b,c){if(null==c)return c;if(b.isRepeated()){a=[];goog.asserts.assert(Array.isArray(c),"Value must be array: %s",c);for(var d=0;d<c.length;d++)a[d]=this.getDeserializedValue(b,c[d]);return a}return this.getDeserializedValue(b,c)};
goog.proto2.PbLiteSerializer.prototype.getSerializedValue=function(a,b){return a.getFieldType()==goog.proto2.FieldDescriptor.FieldType.BOOL?b?1:0:goog.proto2.Serializer.prototype.getSerializedValue.apply(this,arguments)};
goog.proto2.PbLiteSerializer.prototype.getDeserializedValue=function(a,b){return a.getFieldType()==goog.proto2.FieldDescriptor.FieldType.BOOL?(goog.asserts.assert("number"===typeof b||"boolean"===typeof b,"Value is expected to be a number or boolean"),!!b):goog.proto2.Serializer.prototype.getDeserializedValue.apply(this,arguments)};
goog.proto2.PbLiteSerializer.prototype.deserialize=function(a,b){var c=b;if(this.zeroIndexing_){c=[];for(var d in b)c[parseInt(d,10)+1]=b[d]}return goog.proto2.PbLiteSerializer.superClass_.deserialize.call(this,a,c)};goog.string.StringBuffer=function(a,b){null!=a&&this.append.apply(this,arguments)};goog.string.StringBuffer.prototype.buffer_="";goog.string.StringBuffer.prototype.set=function(a){this.buffer_=""+a};goog.string.StringBuffer.prototype.append=function(a,b,c){this.buffer_+=String(a);if(null!=b)for(var d=1;d<arguments.length;d++)this.buffer_+=arguments[d];return this};goog.string.StringBuffer.prototype.clear=function(){this.buffer_=""};goog.string.StringBuffer.prototype.getLength=function(){return this.buffer_.length};
goog.string.StringBuffer.prototype.toString=function(){return this.buffer_};/*

 Protocol Buffer 2 Copyright 2008 Google Inc.
 All other code copyright its respective owners.
 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
var i18n={phonenumbers:{}};i18n.phonenumbers.NumberFormat=function(){goog.proto2.Message.call(this)};goog.inherits(i18n.phonenumbers.NumberFormat,goog.proto2.Message);i18n.phonenumbers.NumberFormat.descriptor_=null;i18n.phonenumbers.NumberFormat.prototype.getPattern=function(){return this.get$Value(1)};i18n.phonenumbers.NumberFormat.prototype.getPatternOrDefault=function(){return this.get$ValueOrDefault(1)};i18n.phonenumbers.NumberFormat.prototype.setPattern=function(a){this.set$Value(1,a)};
i18n.phonenumbers.NumberFormat.prototype.hasPattern=function(){return this.has$Value(1)};i18n.phonenumbers.NumberFormat.prototype.patternCount=function(){return this.count$Values(1)};i18n.phonenumbers.NumberFormat.prototype.clearPattern=function(){this.clear$Field(1)};i18n.phonenumbers.NumberFormat.prototype.getFormat=function(){return this.get$Value(2)};i18n.phonenumbers.NumberFormat.prototype.getFormatOrDefault=function(){return this.get$ValueOrDefault(2)};
i18n.phonenumbers.NumberFormat.prototype.setFormat=function(a){this.set$Value(2,a)};i18n.phonenumbers.NumberFormat.prototype.hasFormat=function(){return this.has$Value(2)};i18n.phonenumbers.NumberFormat.prototype.formatCount=function(){return this.count$Values(2)};i18n.phonenumbers.NumberFormat.prototype.clearFormat=function(){this.clear$Field(2)};i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPattern=function(a){return this.get$Value(3,a)};
i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPatternOrDefault=function(a){return this.get$ValueOrDefault(3,a)};i18n.phonenumbers.NumberFormat.prototype.addLeadingDigitsPattern=function(a){this.add$Value(3,a)};i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternArray=function(){return this.array$Values(3)};i18n.phonenumbers.NumberFormat.prototype.hasLeadingDigitsPattern=function(){return this.has$Value(3)};i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternCount=function(){return this.count$Values(3)};
i18n.phonenumbers.NumberFormat.prototype.clearLeadingDigitsPattern=function(){this.clear$Field(3)};i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRule=function(){return this.get$Value(4)};i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRuleOrDefault=function(){return this.get$ValueOrDefault(4)};i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixFormattingRule=function(a){this.set$Value(4,a)};
i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixFormattingRule=function(){return this.has$Value(4)};i18n.phonenumbers.NumberFormat.prototype.nationalPrefixFormattingRuleCount=function(){return this.count$Values(4)};i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixFormattingRule=function(){this.clear$Field(4)};i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormatting=function(){return this.get$Value(6)};
i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormattingOrDefault=function(){return this.get$ValueOrDefault(6)};i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixOptionalWhenFormatting=function(a){this.set$Value(6,a)};i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixOptionalWhenFormatting=function(){return this.has$Value(6)};i18n.phonenumbers.NumberFormat.prototype.nationalPrefixOptionalWhenFormattingCount=function(){return this.count$Values(6)};
i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixOptionalWhenFormatting=function(){this.clear$Field(6)};i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRule=function(){return this.get$Value(5)};i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRuleOrDefault=function(){return this.get$ValueOrDefault(5)};i18n.phonenumbers.NumberFormat.prototype.setDomesticCarrierCodeFormattingRule=function(a){this.set$Value(5,a)};
i18n.phonenumbers.NumberFormat.prototype.hasDomesticCarrierCodeFormattingRule=function(){return this.has$Value(5)};i18n.phonenumbers.NumberFormat.prototype.domesticCarrierCodeFormattingRuleCount=function(){return this.count$Values(5)};i18n.phonenumbers.NumberFormat.prototype.clearDomesticCarrierCodeFormattingRule=function(){this.clear$Field(5)};i18n.phonenumbers.PhoneNumberDesc=function(){goog.proto2.Message.call(this)};goog.inherits(i18n.phonenumbers.PhoneNumberDesc,goog.proto2.Message);
i18n.phonenumbers.PhoneNumberDesc.descriptor_=null;i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPattern=function(){return this.get$Value(2)};i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPatternOrDefault=function(){return this.get$ValueOrDefault(2)};i18n.phonenumbers.PhoneNumberDesc.prototype.setNationalNumberPattern=function(a){this.set$Value(2,a)};i18n.phonenumbers.PhoneNumberDesc.prototype.hasNationalNumberPattern=function(){return this.has$Value(2)};
i18n.phonenumbers.PhoneNumberDesc.prototype.nationalNumberPatternCount=function(){return this.count$Values(2)};i18n.phonenumbers.PhoneNumberDesc.prototype.clearNationalNumberPattern=function(){this.clear$Field(2)};i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLength=function(a){return this.get$Value(9,a)};i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthOrDefault=function(a){return this.get$ValueOrDefault(9,a)};
i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLength=function(a){this.add$Value(9,a)};i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthArray=function(){return this.array$Values(9)};i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLength=function(){return this.has$Value(9)};i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthCount=function(){return this.count$Values(9)};i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLength=function(){this.clear$Field(9)};
i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnly=function(a){return this.get$Value(10,a)};i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnlyOrDefault=function(a){return this.get$ValueOrDefault(10,a)};i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLengthLocalOnly=function(a){this.add$Value(10,a)};i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyArray=function(){return this.array$Values(10)};
i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLengthLocalOnly=function(){return this.has$Value(10)};i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyCount=function(){return this.count$Values(10)};i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLengthLocalOnly=function(){this.clear$Field(10)};i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumber=function(){return this.get$Value(6)};i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumberOrDefault=function(){return this.get$ValueOrDefault(6)};
i18n.phonenumbers.PhoneNumberDesc.prototype.setExampleNumber=function(a){this.set$Value(6,a)};i18n.phonenumbers.PhoneNumberDesc.prototype.hasExampleNumber=function(){return this.has$Value(6)};i18n.phonenumbers.PhoneNumberDesc.prototype.exampleNumberCount=function(){return this.count$Values(6)};i18n.phonenumbers.PhoneNumberDesc.prototype.clearExampleNumber=function(){this.clear$Field(6)};i18n.phonenumbers.PhoneMetadata=function(){goog.proto2.Message.call(this)};
goog.inherits(i18n.phonenumbers.PhoneMetadata,goog.proto2.Message);i18n.phonenumbers.PhoneMetadata.descriptor_=null;i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDesc=function(){return this.get$Value(1)};i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDescOrDefault=function(){return this.get$ValueOrDefault(1)};i18n.phonenumbers.PhoneMetadata.prototype.setGeneralDesc=function(a){this.set$Value(1,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasGeneralDesc=function(){return this.has$Value(1)};
i18n.phonenumbers.PhoneMetadata.prototype.generalDescCount=function(){return this.count$Values(1)};i18n.phonenumbers.PhoneMetadata.prototype.clearGeneralDesc=function(){this.clear$Field(1)};i18n.phonenumbers.PhoneMetadata.prototype.getFixedLine=function(){return this.get$Value(2)};i18n.phonenumbers.PhoneMetadata.prototype.getFixedLineOrDefault=function(){return this.get$ValueOrDefault(2)};i18n.phonenumbers.PhoneMetadata.prototype.setFixedLine=function(a){this.set$Value(2,a)};
i18n.phonenumbers.PhoneMetadata.prototype.hasFixedLine=function(){return this.has$Value(2)};i18n.phonenumbers.PhoneMetadata.prototype.fixedLineCount=function(){return this.count$Values(2)};i18n.phonenumbers.PhoneMetadata.prototype.clearFixedLine=function(){this.clear$Field(2)};i18n.phonenumbers.PhoneMetadata.prototype.getMobile=function(){return this.get$Value(3)};i18n.phonenumbers.PhoneMetadata.prototype.getMobileOrDefault=function(){return this.get$ValueOrDefault(3)};
i18n.phonenumbers.PhoneMetadata.prototype.setMobile=function(a){this.set$Value(3,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasMobile=function(){return this.has$Value(3)};i18n.phonenumbers.PhoneMetadata.prototype.mobileCount=function(){return this.count$Values(3)};i18n.phonenumbers.PhoneMetadata.prototype.clearMobile=function(){this.clear$Field(3)};i18n.phonenumbers.PhoneMetadata.prototype.getTollFree=function(){return this.get$Value(4)};
i18n.phonenumbers.PhoneMetadata.prototype.getTollFreeOrDefault=function(){return this.get$ValueOrDefault(4)};i18n.phonenumbers.PhoneMetadata.prototype.setTollFree=function(a){this.set$Value(4,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasTollFree=function(){return this.has$Value(4)};i18n.phonenumbers.PhoneMetadata.prototype.tollFreeCount=function(){return this.count$Values(4)};i18n.phonenumbers.PhoneMetadata.prototype.clearTollFree=function(){this.clear$Field(4)};
i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRate=function(){return this.get$Value(5)};i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRateOrDefault=function(){return this.get$ValueOrDefault(5)};i18n.phonenumbers.PhoneMetadata.prototype.setPremiumRate=function(a){this.set$Value(5,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasPremiumRate=function(){return this.has$Value(5)};i18n.phonenumbers.PhoneMetadata.prototype.premiumRateCount=function(){return this.count$Values(5)};
i18n.phonenumbers.PhoneMetadata.prototype.clearPremiumRate=function(){this.clear$Field(5)};i18n.phonenumbers.PhoneMetadata.prototype.getSharedCost=function(){return this.get$Value(6)};i18n.phonenumbers.PhoneMetadata.prototype.getSharedCostOrDefault=function(){return this.get$ValueOrDefault(6)};i18n.phonenumbers.PhoneMetadata.prototype.setSharedCost=function(a){this.set$Value(6,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasSharedCost=function(){return this.has$Value(6)};
i18n.phonenumbers.PhoneMetadata.prototype.sharedCostCount=function(){return this.count$Values(6)};i18n.phonenumbers.PhoneMetadata.prototype.clearSharedCost=function(){this.clear$Field(6)};i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumber=function(){return this.get$Value(7)};i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumberOrDefault=function(){return this.get$ValueOrDefault(7)};i18n.phonenumbers.PhoneMetadata.prototype.setPersonalNumber=function(a){this.set$Value(7,a)};
i18n.phonenumbers.PhoneMetadata.prototype.hasPersonalNumber=function(){return this.has$Value(7)};i18n.phonenumbers.PhoneMetadata.prototype.personalNumberCount=function(){return this.count$Values(7)};i18n.phonenumbers.PhoneMetadata.prototype.clearPersonalNumber=function(){this.clear$Field(7)};i18n.phonenumbers.PhoneMetadata.prototype.getVoip=function(){return this.get$Value(8)};i18n.phonenumbers.PhoneMetadata.prototype.getVoipOrDefault=function(){return this.get$ValueOrDefault(8)};
i18n.phonenumbers.PhoneMetadata.prototype.setVoip=function(a){this.set$Value(8,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasVoip=function(){return this.has$Value(8)};i18n.phonenumbers.PhoneMetadata.prototype.voipCount=function(){return this.count$Values(8)};i18n.phonenumbers.PhoneMetadata.prototype.clearVoip=function(){this.clear$Field(8)};i18n.phonenumbers.PhoneMetadata.prototype.getPager=function(){return this.get$Value(21)};i18n.phonenumbers.PhoneMetadata.prototype.getPagerOrDefault=function(){return this.get$ValueOrDefault(21)};
i18n.phonenumbers.PhoneMetadata.prototype.setPager=function(a){this.set$Value(21,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasPager=function(){return this.has$Value(21)};i18n.phonenumbers.PhoneMetadata.prototype.pagerCount=function(){return this.count$Values(21)};i18n.phonenumbers.PhoneMetadata.prototype.clearPager=function(){this.clear$Field(21)};i18n.phonenumbers.PhoneMetadata.prototype.getUan=function(){return this.get$Value(25)};i18n.phonenumbers.PhoneMetadata.prototype.getUanOrDefault=function(){return this.get$ValueOrDefault(25)};
i18n.phonenumbers.PhoneMetadata.prototype.setUan=function(a){this.set$Value(25,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasUan=function(){return this.has$Value(25)};i18n.phonenumbers.PhoneMetadata.prototype.uanCount=function(){return this.count$Values(25)};i18n.phonenumbers.PhoneMetadata.prototype.clearUan=function(){this.clear$Field(25)};i18n.phonenumbers.PhoneMetadata.prototype.getEmergency=function(){return this.get$Value(27)};
i18n.phonenumbers.PhoneMetadata.prototype.getEmergencyOrDefault=function(){return this.get$ValueOrDefault(27)};i18n.phonenumbers.PhoneMetadata.prototype.setEmergency=function(a){this.set$Value(27,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasEmergency=function(){return this.has$Value(27)};i18n.phonenumbers.PhoneMetadata.prototype.emergencyCount=function(){return this.count$Values(27)};i18n.phonenumbers.PhoneMetadata.prototype.clearEmergency=function(){this.clear$Field(27)};
i18n.phonenumbers.PhoneMetadata.prototype.getVoicemail=function(){return this.get$Value(28)};i18n.phonenumbers.PhoneMetadata.prototype.getVoicemailOrDefault=function(){return this.get$ValueOrDefault(28)};i18n.phonenumbers.PhoneMetadata.prototype.setVoicemail=function(a){this.set$Value(28,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasVoicemail=function(){return this.has$Value(28)};i18n.phonenumbers.PhoneMetadata.prototype.voicemailCount=function(){return this.count$Values(28)};
i18n.phonenumbers.PhoneMetadata.prototype.clearVoicemail=function(){this.clear$Field(28)};i18n.phonenumbers.PhoneMetadata.prototype.getShortCode=function(){return this.get$Value(29)};i18n.phonenumbers.PhoneMetadata.prototype.getShortCodeOrDefault=function(){return this.get$ValueOrDefault(29)};i18n.phonenumbers.PhoneMetadata.prototype.setShortCode=function(a){this.set$Value(29,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasShortCode=function(){return this.has$Value(29)};
i18n.phonenumbers.PhoneMetadata.prototype.shortCodeCount=function(){return this.count$Values(29)};i18n.phonenumbers.PhoneMetadata.prototype.clearShortCode=function(){this.clear$Field(29)};i18n.phonenumbers.PhoneMetadata.prototype.getStandardRate=function(){return this.get$Value(30)};i18n.phonenumbers.PhoneMetadata.prototype.getStandardRateOrDefault=function(){return this.get$ValueOrDefault(30)};i18n.phonenumbers.PhoneMetadata.prototype.setStandardRate=function(a){this.set$Value(30,a)};
i18n.phonenumbers.PhoneMetadata.prototype.hasStandardRate=function(){return this.has$Value(30)};i18n.phonenumbers.PhoneMetadata.prototype.standardRateCount=function(){return this.count$Values(30)};i18n.phonenumbers.PhoneMetadata.prototype.clearStandardRate=function(){this.clear$Field(30)};i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecific=function(){return this.get$Value(31)};i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecificOrDefault=function(){return this.get$ValueOrDefault(31)};
i18n.phonenumbers.PhoneMetadata.prototype.setCarrierSpecific=function(a){this.set$Value(31,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasCarrierSpecific=function(){return this.has$Value(31)};i18n.phonenumbers.PhoneMetadata.prototype.carrierSpecificCount=function(){return this.count$Values(31)};i18n.phonenumbers.PhoneMetadata.prototype.clearCarrierSpecific=function(){this.clear$Field(31)};i18n.phonenumbers.PhoneMetadata.prototype.getSmsServices=function(){return this.get$Value(33)};
i18n.phonenumbers.PhoneMetadata.prototype.getSmsServicesOrDefault=function(){return this.get$ValueOrDefault(33)};i18n.phonenumbers.PhoneMetadata.prototype.setSmsServices=function(a){this.set$Value(33,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasSmsServices=function(){return this.has$Value(33)};i18n.phonenumbers.PhoneMetadata.prototype.smsServicesCount=function(){return this.count$Values(33)};i18n.phonenumbers.PhoneMetadata.prototype.clearSmsServices=function(){this.clear$Field(33)};
i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDialling=function(){return this.get$Value(24)};i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDiallingOrDefault=function(){return this.get$ValueOrDefault(24)};i18n.phonenumbers.PhoneMetadata.prototype.setNoInternationalDialling=function(a){this.set$Value(24,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasNoInternationalDialling=function(){return this.has$Value(24)};
i18n.phonenumbers.PhoneMetadata.prototype.noInternationalDiallingCount=function(){return this.count$Values(24)};i18n.phonenumbers.PhoneMetadata.prototype.clearNoInternationalDialling=function(){this.clear$Field(24)};i18n.phonenumbers.PhoneMetadata.prototype.getId=function(){return this.get$Value(9)};i18n.phonenumbers.PhoneMetadata.prototype.getIdOrDefault=function(){return this.get$ValueOrDefault(9)};i18n.phonenumbers.PhoneMetadata.prototype.setId=function(a){this.set$Value(9,a)};
i18n.phonenumbers.PhoneMetadata.prototype.hasId=function(){return this.has$Value(9)};i18n.phonenumbers.PhoneMetadata.prototype.idCount=function(){return this.count$Values(9)};i18n.phonenumbers.PhoneMetadata.prototype.clearId=function(){this.clear$Field(9)};i18n.phonenumbers.PhoneMetadata.prototype.getCountryCode=function(){return this.get$Value(10)};i18n.phonenumbers.PhoneMetadata.prototype.getCountryCodeOrDefault=function(){return this.get$ValueOrDefault(10)};
i18n.phonenumbers.PhoneMetadata.prototype.setCountryCode=function(a){this.set$Value(10,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasCountryCode=function(){return this.has$Value(10)};i18n.phonenumbers.PhoneMetadata.prototype.countryCodeCount=function(){return this.count$Values(10)};i18n.phonenumbers.PhoneMetadata.prototype.clearCountryCode=function(){this.clear$Field(10)};i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefix=function(){return this.get$Value(11)};
i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefixOrDefault=function(){return this.get$ValueOrDefault(11)};i18n.phonenumbers.PhoneMetadata.prototype.setInternationalPrefix=function(a){this.set$Value(11,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasInternationalPrefix=function(){return this.has$Value(11)};i18n.phonenumbers.PhoneMetadata.prototype.internationalPrefixCount=function(){return this.count$Values(11)};i18n.phonenumbers.PhoneMetadata.prototype.clearInternationalPrefix=function(){this.clear$Field(11)};
i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefix=function(){return this.get$Value(17)};i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefixOrDefault=function(){return this.get$ValueOrDefault(17)};i18n.phonenumbers.PhoneMetadata.prototype.setPreferredInternationalPrefix=function(a){this.set$Value(17,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredInternationalPrefix=function(){return this.has$Value(17)};
i18n.phonenumbers.PhoneMetadata.prototype.preferredInternationalPrefixCount=function(){return this.count$Values(17)};i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredInternationalPrefix=function(){this.clear$Field(17)};i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefix=function(){return this.get$Value(12)};i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixOrDefault=function(){return this.get$ValueOrDefault(12)};
i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefix=function(a){this.set$Value(12,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefix=function(){return this.has$Value(12)};i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixCount=function(){return this.count$Values(12)};i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefix=function(){this.clear$Field(12)};i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefix=function(){return this.get$Value(13)};
i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefixOrDefault=function(){return this.get$ValueOrDefault(13)};i18n.phonenumbers.PhoneMetadata.prototype.setPreferredExtnPrefix=function(a){this.set$Value(13,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredExtnPrefix=function(){return this.has$Value(13)};i18n.phonenumbers.PhoneMetadata.prototype.preferredExtnPrefixCount=function(){return this.count$Values(13)};i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredExtnPrefix=function(){this.clear$Field(13)};
i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsing=function(){return this.get$Value(15)};i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsingOrDefault=function(){return this.get$ValueOrDefault(15)};i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixForParsing=function(a){this.set$Value(15,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixForParsing=function(){return this.has$Value(15)};
i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixForParsingCount=function(){return this.count$Values(15)};i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixForParsing=function(){this.clear$Field(15)};i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRule=function(){return this.get$Value(16)};i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRuleOrDefault=function(){return this.get$ValueOrDefault(16)};
i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixTransformRule=function(a){this.set$Value(16,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixTransformRule=function(){return this.has$Value(16)};i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixTransformRuleCount=function(){return this.count$Values(16)};i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixTransformRule=function(){this.clear$Field(16)};
i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePattern=function(){return this.get$Value(18)};i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePatternOrDefault=function(){return this.get$ValueOrDefault(18)};i18n.phonenumbers.PhoneMetadata.prototype.setSameMobileAndFixedLinePattern=function(a){this.set$Value(18,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasSameMobileAndFixedLinePattern=function(){return this.has$Value(18)};
i18n.phonenumbers.PhoneMetadata.prototype.sameMobileAndFixedLinePatternCount=function(){return this.count$Values(18)};i18n.phonenumbers.PhoneMetadata.prototype.clearSameMobileAndFixedLinePattern=function(){this.clear$Field(18)};i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormat=function(a){return this.get$Value(19,a)};i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormatOrDefault=function(a){return this.get$ValueOrDefault(19,a)};
i18n.phonenumbers.PhoneMetadata.prototype.addNumberFormat=function(a){this.add$Value(19,a)};i18n.phonenumbers.PhoneMetadata.prototype.numberFormatArray=function(){return this.array$Values(19)};i18n.phonenumbers.PhoneMetadata.prototype.hasNumberFormat=function(){return this.has$Value(19)};i18n.phonenumbers.PhoneMetadata.prototype.numberFormatCount=function(){return this.count$Values(19)};i18n.phonenumbers.PhoneMetadata.prototype.clearNumberFormat=function(){this.clear$Field(19)};
i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormat=function(a){return this.get$Value(20,a)};i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormatOrDefault=function(a){return this.get$ValueOrDefault(20,a)};i18n.phonenumbers.PhoneMetadata.prototype.addIntlNumberFormat=function(a){this.add$Value(20,a)};i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatArray=function(){return this.array$Values(20)};i18n.phonenumbers.PhoneMetadata.prototype.hasIntlNumberFormat=function(){return this.has$Value(20)};
i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatCount=function(){return this.count$Values(20)};i18n.phonenumbers.PhoneMetadata.prototype.clearIntlNumberFormat=function(){this.clear$Field(20)};i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCode=function(){return this.get$Value(22)};i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCodeOrDefault=function(){return this.get$ValueOrDefault(22)};
i18n.phonenumbers.PhoneMetadata.prototype.setMainCountryForCode=function(a){this.set$Value(22,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasMainCountryForCode=function(){return this.has$Value(22)};i18n.phonenumbers.PhoneMetadata.prototype.mainCountryForCodeCount=function(){return this.count$Values(22)};i18n.phonenumbers.PhoneMetadata.prototype.clearMainCountryForCode=function(){this.clear$Field(22)};i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigits=function(){return this.get$Value(23)};
i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigitsOrDefault=function(){return this.get$ValueOrDefault(23)};i18n.phonenumbers.PhoneMetadata.prototype.setLeadingDigits=function(a){this.set$Value(23,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasLeadingDigits=function(){return this.has$Value(23)};i18n.phonenumbers.PhoneMetadata.prototype.leadingDigitsCount=function(){return this.count$Values(23)};i18n.phonenumbers.PhoneMetadata.prototype.clearLeadingDigits=function(){this.clear$Field(23)};
i18n.phonenumbers.PhoneMetadata.prototype.getLeadingZeroPossible=function(){return this.get$Value(26)};i18n.phonenumbers.PhoneMetadata.prototype.getLeadingZeroPossibleOrDefault=function(){return this.get$ValueOrDefault(26)};i18n.phonenumbers.PhoneMetadata.prototype.setLeadingZeroPossible=function(a){this.set$Value(26,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasLeadingZeroPossible=function(){return this.has$Value(26)};i18n.phonenumbers.PhoneMetadata.prototype.leadingZeroPossibleCount=function(){return this.count$Values(26)};
i18n.phonenumbers.PhoneMetadata.prototype.clearLeadingZeroPossible=function(){this.clear$Field(26)};i18n.phonenumbers.PhoneMetadataCollection=function(){goog.proto2.Message.call(this)};goog.inherits(i18n.phonenumbers.PhoneMetadataCollection,goog.proto2.Message);i18n.phonenumbers.PhoneMetadataCollection.descriptor_=null;i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadata=function(a){return this.get$Value(1,a)};
i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadataOrDefault=function(a){return this.get$ValueOrDefault(1,a)};i18n.phonenumbers.PhoneMetadataCollection.prototype.addMetadata=function(a){this.add$Value(1,a)};i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataArray=function(){return this.array$Values(1)};i18n.phonenumbers.PhoneMetadataCollection.prototype.hasMetadata=function(){return this.has$Value(1)};i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataCount=function(){return this.count$Values(1)};
i18n.phonenumbers.PhoneMetadataCollection.prototype.clearMetadata=function(){this.clear$Field(1)};
i18n.phonenumbers.NumberFormat.prototype.getDescriptor=function(){var a=i18n.phonenumbers.NumberFormat.descriptor_;a||(i18n.phonenumbers.NumberFormat.descriptor_=a=goog.proto2.Message.createDescriptor(i18n.phonenumbers.NumberFormat,{0:{name:"NumberFormat",fullName:"i18n.phonenumbers.NumberFormat"},1:{name:"pattern",required:!0,fieldType:goog.proto2.Message.FieldType.STRING,type:String},2:{name:"format",required:!0,fieldType:goog.proto2.Message.FieldType.STRING,type:String},3:{name:"leading_digits_pattern",
repeated:!0,fieldType:goog.proto2.Message.FieldType.STRING,type:String},4:{name:"national_prefix_formatting_rule",fieldType:goog.proto2.Message.FieldType.STRING,type:String},6:{name:"national_prefix_optional_when_formatting",fieldType:goog.proto2.Message.FieldType.BOOL,defaultValue:!1,type:Boolean},5:{name:"domestic_carrier_code_formatting_rule",fieldType:goog.proto2.Message.FieldType.STRING,type:String}}));return a};i18n.phonenumbers.NumberFormat.getDescriptor=i18n.phonenumbers.NumberFormat.prototype.getDescriptor;
i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor=function(){var a=i18n.phonenumbers.PhoneNumberDesc.descriptor_;a||(i18n.phonenumbers.PhoneNumberDesc.descriptor_=a=goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumberDesc,{0:{name:"PhoneNumberDesc",fullName:"i18n.phonenumbers.PhoneNumberDesc"},2:{name:"national_number_pattern",fieldType:goog.proto2.Message.FieldType.STRING,type:String},9:{name:"possible_length",repeated:!0,fieldType:goog.proto2.Message.FieldType.INT32,type:Number},
10:{name:"possible_length_local_only",repeated:!0,fieldType:goog.proto2.Message.FieldType.INT32,type:Number},6:{name:"example_number",fieldType:goog.proto2.Message.FieldType.STRING,type:String}}));return a};i18n.phonenumbers.PhoneNumberDesc.getDescriptor=i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor;
i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor=function(){var a=i18n.phonenumbers.PhoneMetadata.descriptor_;a||(i18n.phonenumbers.PhoneMetadata.descriptor_=a=goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadata,{0:{name:"PhoneMetadata",fullName:"i18n.phonenumbers.PhoneMetadata"},1:{name:"general_desc",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},2:{name:"fixed_line",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},
3:{name:"mobile",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},4:{name:"toll_free",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},5:{name:"premium_rate",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},6:{name:"shared_cost",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},7:{name:"personal_number",fieldType:goog.proto2.Message.FieldType.MESSAGE,
type:i18n.phonenumbers.PhoneNumberDesc},8:{name:"voip",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},21:{name:"pager",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},25:{name:"uan",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},27:{name:"emergency",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},28:{name:"voicemail",fieldType:goog.proto2.Message.FieldType.MESSAGE,
type:i18n.phonenumbers.PhoneNumberDesc},29:{name:"short_code",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},30:{name:"standard_rate",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},31:{name:"carrier_specific",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},33:{name:"sms_services",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},24:{name:"no_international_dialling",
fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},9:{name:"id",required:!0,fieldType:goog.proto2.Message.FieldType.STRING,type:String},10:{name:"country_code",fieldType:goog.proto2.Message.FieldType.INT32,type:Number},11:{name:"international_prefix",fieldType:goog.proto2.Message.FieldType.STRING,type:String},17:{name:"preferred_international_prefix",fieldType:goog.proto2.Message.FieldType.STRING,type:String},12:{name:"national_prefix",fieldType:goog.proto2.Message.FieldType.STRING,
type:String},13:{name:"preferred_extn_prefix",fieldType:goog.proto2.Message.FieldType.STRING,type:String},15:{name:"national_prefix_for_parsing",fieldType:goog.proto2.Message.FieldType.STRING,type:String},16:{name:"national_prefix_transform_rule",fieldType:goog.proto2.Message.FieldType.STRING,type:String},18:{name:"same_mobile_and_fixed_line_pattern",fieldType:goog.proto2.Message.FieldType.BOOL,defaultValue:!1,type:Boolean},19:{name:"number_format",repeated:!0,fieldType:goog.proto2.Message.FieldType.MESSAGE,
type:i18n.phonenumbers.NumberFormat},20:{name:"intl_number_format",repeated:!0,fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.NumberFormat},22:{name:"main_country_for_code",fieldType:goog.proto2.Message.FieldType.BOOL,defaultValue:!1,type:Boolean},23:{name:"leading_digits",fieldType:goog.proto2.Message.FieldType.STRING,type:String},26:{name:"leading_zero_possible",fieldType:goog.proto2.Message.FieldType.BOOL,defaultValue:!1,type:Boolean}}));return a};
i18n.phonenumbers.PhoneMetadata.getDescriptor=i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor;
i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor=function(){var a=i18n.phonenumbers.PhoneMetadataCollection.descriptor_;a||(i18n.phonenumbers.PhoneMetadataCollection.descriptor_=a=goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadataCollection,{0:{name:"PhoneMetadataCollection",fullName:"i18n.phonenumbers.PhoneMetadataCollection"},1:{name:"metadata",repeated:!0,fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneMetadata}}));return a};
i18n.phonenumbers.PhoneMetadataCollection.getDescriptor=i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor;i18n.phonenumbers.PhoneNumber=function(){goog.proto2.Message.call(this)};goog.inherits(i18n.phonenumbers.PhoneNumber,goog.proto2.Message);i18n.phonenumbers.PhoneNumber.descriptor_=null;i18n.phonenumbers.PhoneNumber.prototype.getCountryCode=function(){return this.get$Value(1)};i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeOrDefault=function(){return this.get$ValueOrDefault(1)};i18n.phonenumbers.PhoneNumber.prototype.setCountryCode=function(a){this.set$Value(1,a)};
i18n.phonenumbers.PhoneNumber.prototype.hasCountryCode=function(){return this.has$Value(1)};i18n.phonenumbers.PhoneNumber.prototype.countryCodeCount=function(){return this.count$Values(1)};i18n.phonenumbers.PhoneNumber.prototype.clearCountryCode=function(){this.clear$Field(1)};i18n.phonenumbers.PhoneNumber.prototype.getNationalNumber=function(){return this.get$Value(2)};i18n.phonenumbers.PhoneNumber.prototype.getNationalNumberOrDefault=function(){return this.get$ValueOrDefault(2)};
i18n.phonenumbers.PhoneNumber.prototype.setNationalNumber=function(a){this.set$Value(2,a)};i18n.phonenumbers.PhoneNumber.prototype.hasNationalNumber=function(){return this.has$Value(2)};i18n.phonenumbers.PhoneNumber.prototype.nationalNumberCount=function(){return this.count$Values(2)};i18n.phonenumbers.PhoneNumber.prototype.clearNationalNumber=function(){this.clear$Field(2)};i18n.phonenumbers.PhoneNumber.prototype.getExtension=function(){return this.get$Value(3)};
i18n.phonenumbers.PhoneNumber.prototype.getExtensionOrDefault=function(){return this.get$ValueOrDefault(3)};i18n.phonenumbers.PhoneNumber.prototype.setExtension=function(a){this.set$Value(3,a)};i18n.phonenumbers.PhoneNumber.prototype.hasExtension=function(){return this.has$Value(3)};i18n.phonenumbers.PhoneNumber.prototype.extensionCount=function(){return this.count$Values(3)};i18n.phonenumbers.PhoneNumber.prototype.clearExtension=function(){this.clear$Field(3)};
i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZero=function(){return this.get$Value(4)};i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZeroOrDefault=function(){return this.get$ValueOrDefault(4)};i18n.phonenumbers.PhoneNumber.prototype.setItalianLeadingZero=function(a){this.set$Value(4,a)};i18n.phonenumbers.PhoneNumber.prototype.hasItalianLeadingZero=function(){return this.has$Value(4)};i18n.phonenumbers.PhoneNumber.prototype.italianLeadingZeroCount=function(){return this.count$Values(4)};
i18n.phonenumbers.PhoneNumber.prototype.clearItalianLeadingZero=function(){this.clear$Field(4)};i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZeros=function(){return this.get$Value(8)};i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZerosOrDefault=function(){return this.get$ValueOrDefault(8)};i18n.phonenumbers.PhoneNumber.prototype.setNumberOfLeadingZeros=function(a){this.set$Value(8,a)};i18n.phonenumbers.PhoneNumber.prototype.hasNumberOfLeadingZeros=function(){return this.has$Value(8)};
i18n.phonenumbers.PhoneNumber.prototype.numberOfLeadingZerosCount=function(){return this.count$Values(8)};i18n.phonenumbers.PhoneNumber.prototype.clearNumberOfLeadingZeros=function(){this.clear$Field(8)};i18n.phonenumbers.PhoneNumber.prototype.getRawInput=function(){return this.get$Value(5)};i18n.phonenumbers.PhoneNumber.prototype.getRawInputOrDefault=function(){return this.get$ValueOrDefault(5)};i18n.phonenumbers.PhoneNumber.prototype.setRawInput=function(a){this.set$Value(5,a)};
i18n.phonenumbers.PhoneNumber.prototype.hasRawInput=function(){return this.has$Value(5)};i18n.phonenumbers.PhoneNumber.prototype.rawInputCount=function(){return this.count$Values(5)};i18n.phonenumbers.PhoneNumber.prototype.clearRawInput=function(){this.clear$Field(5)};i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSource=function(){return this.get$Value(6)};i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSourceOrDefault=function(){return this.get$ValueOrDefault(6)};
i18n.phonenumbers.PhoneNumber.prototype.setCountryCodeSource=function(a){this.set$Value(6,a)};i18n.phonenumbers.PhoneNumber.prototype.hasCountryCodeSource=function(){return this.has$Value(6)};i18n.phonenumbers.PhoneNumber.prototype.countryCodeSourceCount=function(){return this.count$Values(6)};i18n.phonenumbers.PhoneNumber.prototype.clearCountryCodeSource=function(){this.clear$Field(6)};i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCode=function(){return this.get$Value(7)};
i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCodeOrDefault=function(){return this.get$ValueOrDefault(7)};i18n.phonenumbers.PhoneNumber.prototype.setPreferredDomesticCarrierCode=function(a){this.set$Value(7,a)};i18n.phonenumbers.PhoneNumber.prototype.hasPreferredDomesticCarrierCode=function(){return this.has$Value(7)};i18n.phonenumbers.PhoneNumber.prototype.preferredDomesticCarrierCodeCount=function(){return this.count$Values(7)};
i18n.phonenumbers.PhoneNumber.prototype.clearPreferredDomesticCarrierCode=function(){this.clear$Field(7)};i18n.phonenumbers.PhoneNumber.CountryCodeSource={UNSPECIFIED:0,FROM_NUMBER_WITH_PLUS_SIGN:1,FROM_NUMBER_WITH_IDD:5,FROM_NUMBER_WITHOUT_PLUS_SIGN:10,FROM_DEFAULT_COUNTRY:20};
i18n.phonenumbers.PhoneNumber.prototype.getDescriptor=function(){var a=i18n.phonenumbers.PhoneNumber.descriptor_;a||(i18n.phonenumbers.PhoneNumber.descriptor_=a=goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumber,{0:{name:"PhoneNumber",fullName:"i18n.phonenumbers.PhoneNumber"},1:{name:"country_code",required:!0,fieldType:goog.proto2.Message.FieldType.INT32,type:Number},2:{name:"national_number",required:!0,fieldType:goog.proto2.Message.FieldType.UINT64,type:Number},3:{name:"extension",
fieldType:goog.proto2.Message.FieldType.STRING,type:String},4:{name:"italian_leading_zero",fieldType:goog.proto2.Message.FieldType.BOOL,type:Boolean},8:{name:"number_of_leading_zeros",fieldType:goog.proto2.Message.FieldType.INT32,defaultValue:1,type:Number},5:{name:"raw_input",fieldType:goog.proto2.Message.FieldType.STRING,type:String},6:{name:"country_code_source",fieldType:goog.proto2.Message.FieldType.ENUM,defaultValue:i18n.phonenumbers.PhoneNumber.CountryCodeSource.UNSPECIFIED,type:i18n.phonenumbers.PhoneNumber.CountryCodeSource},
7:{name:"preferred_domestic_carrier_code",fieldType:goog.proto2.Message.FieldType.STRING,type:String}}));return a};i18n.phonenumbers.PhoneNumber.ctor=i18n.phonenumbers.PhoneNumber;i18n.phonenumbers.PhoneNumber.ctor.getDescriptor=i18n.phonenumbers.PhoneNumber.prototype.getDescriptor;/*

 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
i18n.phonenumbers.metadata={};
i18n.phonenumbers.metadata.countryCodeToRegionCodeMap={1:"US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),7:["RU","KZ"],20:["EG"],27:["ZA"],30:["GR"],31:["NL"],32:["BE"],33:["FR"],34:["ES"],36:["HU"],39:["IT","VA"],40:["RO"],41:["CH"],43:["AT"],44:["GB","GG","IM","JE"],45:["DK"],46:["SE"],47:["NO","SJ"],48:["PL"],49:["DE"],51:["PE"],52:["MX"],53:["CU"],54:["AR"],55:["BR"],56:["CL"],57:["CO"],58:["VE"],60:["MY"],61:["AU","CC","CX"],62:["ID"],63:["PH"],64:["NZ"],
65:["SG"],66:["TH"],81:["JP"],82:["KR"],84:["VN"],86:["CN"],90:["TR"],91:["IN"],92:["PK"],93:["AF"],94:["LK"],95:["MM"],98:["IR"],211:["SS"],212:["MA","EH"],213:["DZ"],216:["TN"],218:["LY"],220:["GM"],221:["SN"],222:["MR"],223:["ML"],224:["GN"],225:["CI"],226:["BF"],227:["NE"],228:["TG"],229:["BJ"],230:["MU"],231:["LR"],232:["SL"],233:["GH"],234:["NG"],235:["TD"],236:["CF"],237:["CM"],238:["CV"],239:["ST"],240:["GQ"],241:["GA"],242:["CG"],243:["CD"],244:["AO"],245:["GW"],246:["IO"],247:["AC"],248:["SC"],
249:["SD"],250:["RW"],251:["ET"],252:["SO"],253:["DJ"],254:["KE"],255:["TZ"],256:["UG"],257:["BI"],258:["MZ"],260:["ZM"],261:["MG"],262:["RE","YT"],263:["ZW"],264:["NA"],265:["MW"],266:["LS"],267:["BW"],268:["SZ"],269:["KM"],290:["SH","TA"],291:["ER"],297:["AW"],298:["FO"],299:["GL"],350:["GI"],351:["PT"],352:["LU"],353:["IE"],354:["IS"],355:["AL"],356:["MT"],357:["CY"],358:["FI","AX"],359:["BG"],370:["LT"],371:["LV"],372:["EE"],373:["MD"],374:["AM"],375:["BY"],376:["AD"],377:["MC"],378:["SM"],380:["UA"],
381:["RS"],382:["ME"],383:["XK"],385:["HR"],386:["SI"],387:["BA"],389:["MK"],420:["CZ"],421:["SK"],423:["LI"],500:["FK"],501:["BZ"],502:["GT"],503:["SV"],504:["HN"],505:["NI"],506:["CR"],507:["PA"],508:["PM"],509:["HT"],590:["GP","BL","MF"],591:["BO"],592:["GY"],593:["EC"],594:["GF"],595:["PY"],596:["MQ"],597:["SR"],598:["UY"],599:["CW","BQ"],670:["TL"],672:["NF"],673:["BN"],674:["NR"],675:["PG"],676:["TO"],677:["SB"],678:["VU"],679:["FJ"],680:["PW"],681:["WF"],682:["CK"],683:["NU"],685:["WS"],686:["KI"],
687:["NC"],688:["TV"],689:["PF"],690:["TK"],691:["FM"],692:["MH"],800:["001"],808:["001"],850:["KP"],852:["HK"],853:["MO"],855:["KH"],856:["LA"],870:["001"],878:["001"],880:["BD"],881:["001"],882:["001"],883:["001"],886:["TW"],888:["001"],960:["MV"],961:["LB"],962:["JO"],963:["SY"],964:["IQ"],965:["KW"],966:["SA"],967:["YE"],968:["OM"],970:["PS"],971:["AE"],972:["IL"],973:["BH"],974:["QA"],975:["BT"],976:["MN"],977:["NP"],979:["001"],992:["TJ"],993:["TM"],994:["AZ"],995:["GE"],996:["KG"],998:["UZ"]};
i18n.phonenumbers.metadata.countryToMetadata={AC:[,[,,"(?:[01589]\\d|[46])\\d{4}",,,,,,,[5,6]],[,,"6[2-467]\\d{3}",,,,"62889",,,[5]],[,,"4\\d{4}",,,,"40123",,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AC",247,"00",,,,,,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:0[1-9]|[1589]\\d)\\d{4}",,,,"542011",,,[6]],,,[,,,,,,,,,[-1]]],AD:[,[,,"(?:1|6\\d)\\d{7}|[135-9]\\d{5}",,,,,,,[6,8,9]],[,,"[78]\\d{5}",,,,"712345",,,[6]],[,,"690\\d{6}|[356]\\d{5}",,,,"312345",
,,[6,9]],[,,"180[02]\\d{4}",,,,"18001234",,,[8]],[,,"[19]\\d{5}",,,,"912345",,,[6]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AD",376,"00",,,,,,,,[[,"(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],[,"(\\d{4})(\\d{4})","$1 $2",["1"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],,[,,,,,,,,,[-1]],,,[,,"1800\\d{4}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AE:[,[,,"(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",,,,,,,[5,6,7,8,9,10,11,12]],[,,"[2-4679][2-8]\\d{6}",,,,"22345678",,,[8],[7]],
[,,"5[024-68]\\d{7}",,,,"501234567",,,[9]],[,,"400\\d{6}|800\\d{2,9}",,,,"800123456"],[,,"900[02]\\d{5}",,,,"900234567",,,[9]],[,,"700[05]\\d{5}",,,,"700012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AE",971,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],[,"(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"600[25]\\d{5}",,,,"600212345",
,,[9]],,,[,,,,,,,,,[-1]]],AF:[,[,,"[2-7]\\d{8}",,,,,,,[9],[7]],[,,"(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}",,,,"234567890",,,,[7]],[,,"7\\d{8}",,,,"701234567",,,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AF",93,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[1-9]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],
AG:[,[,,"(?:268|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}",,,,"2684601234",,,,[7]],[,,"268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}",,,,"2684641234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,"26848[01]\\d{4}",,,,"2684801234",,,,[7]],"AG",1,"011","1",,,"1|([457]\\d{6})$","268$1",,,,,[,,"26840[69]\\d{4}",,,,"2684061234",,,,[7]],,"268",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AI:[,[,,"(?:264|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"264(?:292|4(?:6[12]|9[78]))\\d{4}",,,,"2644612345",,,,[7]],[,,"264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}",,,,"2642351234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,
,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"AI",1,"011","1",,,"1|([2457]\\d{6})$","264$1",,,,,[,,"264724\\d{4}",,,,"2647241234",,,,[7]],,"264",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AL:[,[,,"(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
,,,,,,[6,7,8,9],[5]],[,,"4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}",,,,"22345678",,,[8],[5,6,7]],[,,"6(?:[78][2-9]|9\\d)\\d{6}",,,,"672123456",,,[9]],[,,"800\\d{4}",,,,"8001234",,,[7]],[,,"900[1-9]\\d\\d",,,,"900123",,,[6]],[,,"808[1-9]\\d\\d",,,,"808123",,,[6]],[,,"700[2-9]\\d{4}",,,,"70021234",,,[8]],[,,,,,,,,,[-1]],"AL",355,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],[,"(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AM:[,[,,"(?:[1-489]\\d|55|60|77)\\d{6}",,,,,,,[8],[5,6]],[,,"(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}",,,,"10123456",,,,[5,6]],[,,"(?:33|4[1349]|55|77|88|9[13-9])\\d{6}",,,,"77123456"],[,,"800\\d{5}",,,,"80012345"],
[,,"90[016]\\d{5}",,,,"90012345"],[,,"80[1-4]\\d{5}",,,,"80112345"],[,,,,,,,,,[-1]],[,,"60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[01])\\d{4}",,,,"60271234"],"AM",374,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],[,"(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],[,"(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],[,"(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AO:[,[,,"[29]\\d{8}",,,,,,,[9]],[,,"2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}",
,,,"222123456"],[,,"9[1-49]\\d{7}",,,,"923123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AO",244,"00",,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AR:[,[,,"(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",,,,,,,[10,11],[6,7,8]],[,,"3888[013-9]\\d{5}|(?:29(?:54|66)|3(?:777|865))[2-8]\\d{5}|3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|302|657|920)|3(?:4(?:8[27]|92)|541|755|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|32[03]|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-8]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:[03][45]|[17][2-6]|[58][3-6])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
,,,"1123456789",,,[10],[6,7,8]],[,,"93888[013-9]\\d{5}|9(?:29(?:54|66)|3(?:777|865))[2-8]\\d{5}|93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|302|657|920)|3(?:4(?:8[27]|92)|541|755|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|32[03]|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-8]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:[03][45]|[17][2-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
,,,"91123456789",,,,[6,7,8]],[,,"800\\d{7,8}",,,,"8001234567"],[,,"60[04579]\\d{7}",,,,"6001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AR",54,"00","0",,,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
"9$1",,,[[,"(\\d{3})","$1",["0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"]],[,"(\\d{2})(\\d{4})","$1-$2",["[1-9]"]],[,"(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],[,"(\\d{4})(\\d{4})","$1-$2",["[1-8]"]],[,"(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
"2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],
"0$1",,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",,1],[,"(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
"9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],
"0$1"],[,"(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1"]],[[,"(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
"2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],
"0$1",,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",,1],[,"(\\d)(\\d{4})(\\d{2})(\\d{4})","$1 $2 $3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
"9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"]],
[,"(\\d)(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3-$4",["91"]],[,"(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3-$4",["9"]]],[,,,,,,,,,[-1]],,,[,,"810\\d{7}",,,,,,,[10]],[,,"810\\d{7}",,,,"8101234567",,,[10]],,,[,,,,,,,,,[-1]]],AS:[,[,,"(?:[58]\\d\\d|684|900)\\d{7}",,,,,,,[10],[7]],[,,"6846(?:22|33|44|55|77|88|9[19])\\d{4}",,,,"6846221234",,,,[7]],[,,"684(?:2(?:48|5[2468]|72)|7(?:3[13]|70|82))\\d{4}",,,,"6847331234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"AS",1,"011","1",,,"1|([267]\\d{6})$","684$1",,,,,[,,,,,,,,,[-1]],,"684",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AT:[,[,,"1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
,,,,,,[4,5,6,7,8,9,10,11,12,13],[3]],[,,"1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}",,,,"1234567890",,,,[3]],[,,"6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}",,,,"664123456",,,[7,8,9,10,11,12,13]],[,,"800\\d{6,10}",
,,,"800123456",,,[9,10,11,12,13]],[,,"(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}",,,,"900123456",,,[9,10,11,12,13]],[,,"8(?:10|2[018])\\d{6,10}|828\\d{5}",,,,"810123456",,,[8,9,10,11,12,13]],[,,,,,,,,,[-1]],[,,"5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}",,,,"780123456",,,[5,6,7,8,9,10,11,12,13]],"AT",43,"00","0",,,"0",,,,[[,"(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],[,"(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],[,"(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],[,"(\\d{6})","$1",["1"]],
[,"(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],[,"(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],[[,"(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],[,"(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],[,"(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],[,"(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],
[,"(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AU:[,[,,"1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",,,,,,,[5,6,7,8,9,10,12]],[,,"(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
,,,"212345678",,,[9],[8]],[,,"4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",,,,"412345678",,,[9]],[,,"180(?:0\\d{3}|2)\\d{3}",,,,"1800123456",,,[7,10]],[,,"190[0-26]\\d{6}",,,,"1900123456",,,[10]],[,,"13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",,,,"1300123456",,,[6,8,10,12]],[,,,,,,,,,[-1]],[,,"14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",,,,"147101234",,,[9]],"AU",61,"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","0",,,"0|(183[12])",
,"0011",,[[,"(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["13"]],[,"(\\d{3})(\\d{3})","$1 $2",["19"]],[,"(\\d{3})(\\d{4})","$1 $2",["180","1802"]],[,"(\\d{4})(\\d{3,4})","$1 $2",["19"]],[,"(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)","$CC ($1)"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]],[,"(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",
["130"]]],[[,"(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)","$CC ($1)"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],[,,"163\\d{2,6}",,,,"1631234",,,[5,6,7,8,9]],1,,[,,"1(?:3(?:00\\d{5}|45[0-4])|802)\\d{3}|1[38]00\\d{6}|13\\d{4}",,,,,,,[6,7,8,10,12]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AW:[,[,,"(?:[25-79]\\d\\d|800)\\d{4}",
,,,,,,[7]],[,,"5(?:2\\d|8[1-9])\\d{4}",,,,"5212345"],[,,"(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}",,,,"5601234"],[,,"800\\d{4}",,,,"8001234"],[,,"900\\d{4}",,,,"9001234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:28\\d|501)\\d{4}",,,,"5011234"],"AW",297,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AX:[,[,,"2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
,,,,,,[5,6,7,8,9,10,11,12]],[,,"18[1-8]\\d{3,6}",,,,"181234567",,,[6,7,8,9]],[,,"4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",,,,"412345678",,,[6,7,8,9,10]],[,,"800\\d{4,6}",,,,"800123456",,,[7,8,9]],[,,"[67]00\\d{5,6}",,,,"600123456",,,[8,9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AX",358,"00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","0",,,"0",,"00",,,,[,,,,,,,,,[-1]],,"18",[,,,,,,,,,[-1]],[,,"20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
,,,"10112345"],,,[,,,,,,,,,[-1]]],AZ:[,[,,"365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",,,,,,,[9],[7]],[,,"(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}",,,,"123123456",,,,[7]],[,,"36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}",,,,"401234567"],[,,"88\\d{7}",,,,"881234567"],[,,"900200\\d{3}",,,,"900200123"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AZ",994,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[1-9]"]],[,
"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",
["[13-9]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BA:[,[,,"6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",,,,,,,[8,9],[6]],[,,"(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}",,,,"30212345",,,[8],[6]],[,,"6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}",,,,"61123456"],[,,"8[08]\\d{6}",,,,"80123456",,,[8]],[,,"9[0246]\\d{6}",,,,"90123456",,,[8]],[,,"8[12]\\d{6}",,,,"82123456",,,[8]],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BA",387,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})","$1-$2",["[2-9]"]],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],[,,,,,,,,,[-1]],
,,[,,,,,,,,,[-1]],[,,"703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}",,,,"70341234",,,[8]],,,[,,,,,,,,,[-1]]],BB:[,[,,"(?:246|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}",,,,"2464123456",,,,[7]],[,,"246(?:2(?:[3568]\\d|4[0-57-9])|45\\d|69[5-7]|8(?:[2-5]\\d|83))\\d{4}",,,,"2462501234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"(?:246976|900[2-9]\\d\\d)\\d{4}",
,,,"9002123456",,,,[7]],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,"24631\\d{5}",,,,"2463101234",,,,[7]],"BB",1,"011","1",,,"1|([2-9]\\d{6})$","246$1",,,,,[,,,,,,,,,[-1]],,"246",[,,,,,,,,,[-1]],[,,"246(?:292|367|4(?:1[7-9]|3[01]|44|67)|7(?:36|53))\\d{4}",,,,"2464301234",,,,
[7]],,,[,,,,,,,,,[-1]]],BD:[,[,,"[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",,,,,,,[6,7,8,9,10]],[,,"(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:222|[45]\\d)\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}",
,,,"27111234"],[,,"(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}",,,,"1812345678",,,[10]],[,,"80[03]\\d{7}",,,,"8001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"96(?:0[469]|1[0-47]|3[389]|6[69]|7[78])\\d{6}",,,,"9604123456",,,[10]],"BD",880,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],[,"(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],
"0$1"],[,"(\\d{4})(\\d{3,6})","$1-$2",["[13-9]|22"],"0$1"],[,"(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BE:[,[,,"4\\d{8}|[1-9]\\d{7}",,,,,,,[8,9]],[,,"80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}",,,,"12345678",,,[8]],[,,"4[5-9]\\d{7}",,,,"470123456",,,[9]],[,,"800[1-9]\\d{4}",,,,"80012345",,,[8]],[,,"(?:70(?:2[0-57]|3[04-7]|44|69|7[0579])|90(?:0[0-8]|1[36]|2[0-3568]|3[013-689]|[47][2-68]|5[1-68]|6[0-378]|9[34679]))\\d{4}",
,,,"90012345",,,[8]],[,,"7879\\d{4}",,,,"78791234",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BE",32,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],[,"(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"78(?:0[57]|1[0458]|2[25]|3[15-8]|48|[56]0|7[078]|9\\d)\\d{4}",,,,"78102345",,,[8]],
,,[,,,,,,,,,[-1]]],BF:[,[,,"[025-7]\\d{7}",,,,,,,[8]],[,,"2(?:0(?:49|5[23]|6[56]|9[016-9])|4(?:4[569]|5[4-6]|6[56]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}",,,,"20491234"],[,,"(?:0[1267]|5[1-8]|[67]\\d)\\d{6}",,,,"70123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BF",226,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BG:[,[,,"[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
,,,,,,[6,7,8,9],[4,5]],[,,"2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}",,,,"2123456",,,[6,7,8],[4,5]],[,,"43[07-9]\\d{5}|(?:48|8[7-9]\\d|9(?:8\\d|9[69]))\\d{6}",,,,"48123456",,,[8,9]],[,,"800\\d{5}",,,,"80012345",,,[8]],[,,"90\\d{6}",,,,"90123456",,,[8]],[,,"700\\d{5}",,,,"70012345",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BG",359,"00","0",,,"0",,,,[[,"(\\d{6})","$1",["1"]],[,"(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],[,"(\\d{3})(\\d{4})",
"$1 $2",["43[1-6]|70[1-9]"],"0$1"],[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],[[,"(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],[,"(\\d{3})(\\d{4})","$1 $2",
["43[1-6]|70[1-9]"],"0$1"],[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BH:[,[,,"[136-9]\\d{7}",
,,,,,,[8]],[,,"(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9]|88)|9[69][69])|7(?:1(?:11|78)|7\\d\\d))\\d{4}",,,,"17001234"],[,,"(?:3(?:[1-79]\\d|8[0-47-9])\\d|6(?:3(?:00|33|6[16])|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}",,,,"36001234"],[,,"80\\d{6}",,,,"80123456"],[,,"(?:87|9[014578])\\d{6}",,,,"90123456"],[,,"84\\d{6}",,,,"84123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BH",973,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[13679]|8[047]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,
,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BI:[,[,,"(?:[267]\\d|31)\\d{6}",,,,,,,[8]],[,,"22\\d{6}",,,,"22201234"],[,,"(?:29|31|6[1257-9]|7[125-9])\\d{6}",,,,"79561234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BI",257,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BJ:[,[,,"[25689]\\d{7}",,,,,,,[8]],[,,"2(?:02|1[037]|2[45]|3[68])\\d{5}",,,,"20211234"],[,,"(?:5[1-35-8]|6\\d|9[013-9])\\d{6}",
,,,"90011234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"857[58]\\d{4}",,,,"85751234"],"BJ",229,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[25689]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"81\\d{6}",,,,"81123456"],,,[,,,,,,,,,[-1]]],BL:[,[,,"(?:590|(?:69|80)\\d|976)\\d{6}",,,,,,,[9]],[,,"590(?:2[7-9]|5[12]|87)\\d{4}",,,,"590271234"],[,,"69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}",,,,"690001234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,
,,,,,[-1]],[,,,,,,,,,[-1]],[,,"976[01]\\d{5}",,,,"976012345"],"BL",590,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BM:[,[,,"(?:441|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}",,,,"4414123456",,,,[7]],[,,"441(?:[2378]\\d|5[0-39])\\d{5}",,,,"4413701234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"BM",1,"011","1",,,"1|([2-8]\\d{6})$","441$1",,,,,[,,,,,,,,,[-1]],,"441",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BN:[,[,,"[2-578]\\d{6}",,,,,,,[7]],[,,"22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}",,,,"2345678"],[,,"(?:22[89]|[78]\\d\\d)\\d{4}",,,,"7123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"5[34]\\d{5}",,,,"5345678"],"BN",673,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BO:[,[,,"(?:[2-467]\\d\\d|8001)\\d{5}",,,,,,,[8,9],[7]],[,,"(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}",,,,"22123456",,,[8],[7]],[,,"[67]\\d{7}",,,,"71234567",,,[8]],[,,"8001[07]\\d{4}",,,,"800171234",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BO",591,"00(?:1\\d)?","0",
,,"0(1\\d)?",,,,[[,"(\\d)(\\d{7})","$1 $2",["[23]|4[46]"],,"0$CC $1"],[,"(\\d{8})","$1",["[67]"],,"0$CC $1"],[,"(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"],,"0$CC $1"]],,[,,,,,,,,,[-1]],,,[,,"8001[07]\\d{4}",,,,,,,[9]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BQ:[,[,,"(?:[34]1|7\\d)\\d{5}",,,,,,,[7]],[,,"(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}",,,,"7151234"],[,,"(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}",,,,"3181234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,
,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BQ",599,"00",,,,,,,,,,[,,,,,,,,,[-1]],,"[347]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BR:[,[,,"(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",,,,,,,[8,9,10,11]],[,,"(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}",,,,"1123456789",,,[10],[8]],[,,"(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}",,,,"11961234567",,,[10,11],[8,9]],[,,"800\\d{6,7}",,,,"800123456",,
,[9,10]],[,,"300\\d{6}|[59]00\\d{6,7}",,,,"300123456",,,[9,10]],[,,"300\\d{7}|[34]00\\d{5}|4(?:02|37)0\\d{4}",,,,"40041234",,,[8,10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BR",55,"00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","0",,,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2",,,[[,"(\\d{3,6})","$1",["1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"]],[,"(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],[,"(\\d{4})(\\d{4})","$1-$2",["[2-57]",
"[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"]],[,"(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],[,"(\\d{5})(\\d{4})","$1-$2",["9"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)","0 $CC ($1)"],[,"(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)","0 $CC ($1)"]],[[,"(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],[,"(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})",
"$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)","0 $CC ($1)"],[,"(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)","0 $CC ($1)"]],[,,,,,,,,,[-1]],,,[,,"4020\\d{4}|[34]00\\d{5}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BS:[,[,,"(?:242|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-4]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}",,,,"2423456789",,,,[7]],[,,"242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}",
,,,"2423591234",,,,[7]],[,,"242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456",,,,[7]],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"BS",1,"011","1",,,"1|([3-8]\\d{6})$","242$1",,,,,[,,,,,,,,,[-1]],,"242",[,,,,
,,,,,[-1]],[,,"242225\\d{4}",,,,"2422250123"],,,[,,,,,,,,,[-1]]],BT:[,[,,"[17]\\d{7}|[2-8]\\d{6}",,,,,,,[7,8],[6]],[,,"(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}",,,,"2345678",,,[7],[6]],[,,"(?:1[67]|77)\\d{6}",,,,"17123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BT",975,"00",,,,,,,,[[,"(\\d{3})(\\d{3})","$1 $2",["[2-7]"]],[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]],
[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BW:[,[,,"(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",,,,,,,[7,8,10]],[,,"(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013])|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}",,,,"2401234",,,[7]],[,,"(?:321|7(?:[1-7]\\d|8[01]))\\d{5}",,
,,"71123456",,,[8]],[,,"(?:0800|800\\d)\\d{6}",,,,"0800012345",,,[10]],[,,"90\\d{5}",,,,"9012345",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"79(?:1(?:[01]\\d|20)|2[0-25-7]\\d)\\d{3}",,,,"79101234",,,[8]],"BW",267,"00",,,,,,,,[[,"(\\d{2})(\\d{5})","$1 $2",["90"]],[,"(\\d{3})(\\d{4})","$1 $2",["[24-6]|3[15-79]"]],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37]"]],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["0"]],[,"(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,
,,[-1]],,,[,,,,,,,,,[-1]]],BY:[,[,,"(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",,,,,,,[6,7,8,9,10,11],[5]],[,,"(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}",,,,"152450911",,,[9],[5,6,7]],[,,"(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",,,,"294911911",,,[9]],[,,"800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}",
,,,"8011234567"],[,,"(?:810|902)\\d{7}",,,,"9021234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"249\\d{6}",,,,"249123456",,,[9]],"BY",375,"810","8",,,"0|80?",,"8~10",,[[,"(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],[,"(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],[,"(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],[,"(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],,[,,,,,,,,,[-1]],,,[,,"800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BZ:[,[,,"(?:0800\\d|[2-8])\\d{6}",,,,,,,[7,11]],[,,"(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}",,,,"2221234",,,[7]],[,,"6[0-35-7]\\d{5}",,,,"6221234",,,[7]],[,,"0800\\d{7}",,,,"08001234123",
,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BZ",501,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],[,"(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CA:[,[,,"(?:[2-8]\\d|90)\\d{8}",,,,,,,[10],[7]],[,,"(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|74)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",,,,"5062345678",
,,,[7]],[,,"(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|74)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",,,,"5062345678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}",
,,,"5002345678"],[,,"600[2-9]\\d{6}",,,,"6002012345"],"CA",1,"011","1",,,"1",,,1,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CC:[,[,,"1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",,,,,,,[6,7,8,9,10,12]],[,,"8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",,,,"891621234",,,[9],[8]],[,,"4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
,,,"412345678",,,[9]],[,,"180(?:0\\d{3}|2)\\d{3}",,,,"1800123456",,,[7,10]],[,,"190[0-26]\\d{6}",,,,"1900123456",,,[10]],[,,"13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",,,,"1300123456",,,[6,8,10,12]],[,,,,,,,,,[-1]],[,,"14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",,,,"147101234",,,[9]],"CC",61,"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","0",,,"0|([59]\\d{7})$","8$1","0011",,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CD:[,[,,"[189]\\d{8}|[1-68]\\d{6}",,,,,,
,[7,9]],[,,"12\\d{7}|[1-6]\\d{6}",,,,"1234567"],[,,"88\\d{5}|(?:8[0-59]|9[017-9])\\d{7}",,,,"991234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CD",243,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],[,"(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CF:[,[,,
"(?:[27]\\d{3}|8776)\\d{4}",,,,,,,[8]],[,,"2[12]\\d{6}",,,,"21612345"],[,,"7[0257]\\d{6}",,,,"70012345"],[,,,,,,,,,[-1]],[,,"8776\\d{4}",,,,"87761234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CF",236,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CG:[,[,,"222\\d{6}|(?:0\\d|80)\\d{7}",,,,,,,[9]],[,,"222[1-589]\\d{5}",,,,"222123456"],[,,"026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}",
,,,"061234567"],[,,,,,,,,,[-1]],[,,"80(?:0\\d\\d|120)\\d{4}",,,,"800123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CG",242,"00",,,,,,,,[[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CH:[,[,,"8\\d{11}|[2-9]\\d{8}",,,,,,,[9,12]],[,,"(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}",,,,"212345678",,,[9]],[,,"7[35-9]\\d{7}",,,,"781234567",,,[9]],[,,"800\\d{6}",,,,"800123456",
,,[9]],[,,"90[016]\\d{6}",,,,"900123456",,,[9]],[,,"84[0248]\\d{6}",,,,"840123456",,,[9]],[,,"878\\d{6}",,,,"878123456",,,[9]],[,,,,,,,,,[-1]],"CH",41,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],,[,,"74[0248]\\d{6}",,,,"740123456",,,[9]],,,[,,,,,,,,,[-1]],[,,"5[18]\\d{7}",,,,"581234567",,,[9]],,,[,,"860\\d{9}",,,,"860123456789",
,,[12]]],CI:[,[,,"[02]\\d{9}",,,,,,,[10]],[,,"2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|[23][45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}",,,,"2123456789"],[,,"0704[0-7]\\d{5}|0(?:[15]\\d\\d|7(?:0[0-37-9]|[4-9][7-9]))\\d{6}",,,,"0123456789"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CI",225,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d)(\\d{5})","$1 $2 $3 $4",["2"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3 $4",["0"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,
,[,,,,,,,,,[-1]]],CK:[,[,,"[2-578]\\d{4}",,,,,,,[5]],[,,"(?:2\\d|3[13-7]|4[1-5])\\d{3}",,,,"21234"],[,,"[578]\\d{4}",,,,"71234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CK",682,"00",,,,,,,,[[,"(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CL:[,[,,"12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",,,,,,,[9,10,11]],[,,"2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[034]\\d|1[0-35-9]|2[1-9]|5[0-2])|600))|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
,,,"221234567",,,[9]],[,,"2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[034]\\d|1[0-35-9]|2[1-9]|5[0-2])|600))|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",,,,"221234567",,,[9]],[,,"(?:123|8)00\\d{6}",,,,"800123456",,,[9,11]],[,,,,,,,,,[-1]],[,,"600\\d{7,8}",,,,"6001234567",
,,[10,11]],[,,,,,,,,,[-1]],[,,"44\\d{7}",,,,"441234567",,,[9]],"CL",56,"(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",,,,,,,1,[[,"(\\d{4})","$1",["1(?:[03-589]|21)|[29]0|78"]],[,"(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-3]"],"($1)"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],[,"(\\d{3})(\\d{3})(\\d{3,4})",
"$1 $2 $3",["60|8"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]],[[,"(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-3]"],"($1)"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],[,"(\\d{4})(\\d{3})(\\d{4})",
"$1 $2 $3",["1"]],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]],[,,,,,,,,,[-1]],,,[,,"600\\d{7,8}",,,,,,,[10,11]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CM:[,[,,"[26]\\d{8}|88\\d{6,7}",,,,,,,[8,9]],[,,"2(?:22|33)\\d{6}",,,,"222123456",,,[9]],[,,"(?:24[23]|6[5-9]\\d)\\d{6}",,,,"671234567",,,[9]],[,,"88\\d{6,7}",,,,"88012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CM",237,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4 $5",["[26]|88"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CN:[,[,,"1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",,,,,,,[7,8,9,10,11,12],[5,6]],[,,"(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
,,,"1012345678",,,[7,8,9,10,11],[5,6]],[,,"1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|5[0-35-9]|6[25-7]|7[0-35-8]|9[0135-9])\\d{8}",,,,"13123456789",,,[11]],[,,"(?:(?:10|21)8|8)00\\d{7}",,,,"8001234567",,,[10,12]],[,,"16[08]\\d{5}",,,,"16812345",,,[8]],[,,"400\\d{7}|950\\d{7,8}|(?:10|2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
,,,"4001234567",,,[7,8,9,10,11],[5,6]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CN",86,"00|1(?:[12]\\d|79)\\d\\d00","0",,,"0|(1(?:[12]\\d|79)\\d\\d)",,"00",,[[,"(\\d{5,6})","$1",["96"]],[,"(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","(?:10|2[0-57-9])(?:100|9[56])"],"0$1","$CC $1"],[,"(\\d{3})(\\d{4})","$1 $2",["[1-9]","1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])","1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"]],[,"(\\d{4})(\\d{4})",
"$1 $2",["16[08]"]],[,"(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
"85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],
"0$1","$CC $1"],[,"(\\d{4})(\\d{4})","$1 $2",["[1-9]","1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])","26|3(?:[0268]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9])|(?:34|85[23])[0-8]|(?:1|58)[1-9]|(?:63|95)[06-9]|(?:33|85[23]9)[0-46-9]|(?:10|2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
"26|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:1|58|85[23]10)[1-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"]],
[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{7,8})",
"$1 $2",["9"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"],,"$CC $1"],[,"(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",,1]],[[,"(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","(?:10|2[0-57-9])(?:100|9[56])"],"0$1","$CC $1"],[,"(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
"(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
"85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1","$CC $1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],
"0$1","$CC $1",1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{7,8})","$1 $2",["9"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"],,"$CC $1"],
[,"(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",,1]],[,,,,,,,,,[-1]],,,[,,"(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}",,,,,,,[10,11,12]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CO:[,[,,"(?:(?:1\\d|[36])\\d{3}|9101)\\d{6}|[124-8]\\d{7}",,,,,,,[8,10,11],[7]],[,,"60[124-8][2-9]\\d{6}|[124-8][2-9]\\d{6}",,,,"12345678",,,[8,10],[7]],[,,"3333(?:0(?:0\\d|1[0-5])|[4-9]\\d\\d)\\d{3}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}",,,,"3211234567",,,[10]],[,,"1800\\d{7}",
,,,"18001234567",,,[11]],[,,"19(?:0[01]|4[78])\\d{7}",,,,"19001234567",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CO",57,"00(?:4(?:[14]4|56)|[579])","0",,,"0([3579]|4(?:[14]4|56))?",,,,[[,"(\\d)(\\d{7})","$1 $2",["[146][2-9]|[2578]"],"($1)","0$CC $1"],[,"(\\d{3})(\\d{7})","$1 $2",["6"],"($1)"],[,"(\\d{3})(\\d{7})","$1 $2",["[39]"],,"0$CC $1"],[,"(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1"]],[[,"(\\d)(\\d{7})","$1 $2",["[146][2-9]|[2578]"],"($1)","0$CC $1"],[,"(\\d{3})(\\d{7})","$1 $2",
["6"],"($1)"],[,"(\\d{3})(\\d{7})","$1 $2",["[39]"],,"0$CC $1"],[,"(\\d)(\\d{3})(\\d{7})","$1 $2 $3",["1"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CR:[,[,,"(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",,,,,,,[8,10]],[,,"210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}",,,,"22123456",,,[8]],[,,"(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",,,,"83123456",,,[8]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,"90[059]\\d{7}",,,,"9001234567",,,[10]],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],[,,"(?:210[0-6]|4\\d{3}|5100)\\d{4}",,,,"40001234",,,[8]],"CR",506,"00",,,,"(19(?:0[0-2468]|1[09]|20|66|77|99))",,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"],,"$CC $1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"],,"$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CU:[,[,,"[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",,,,,,,[6,7,8,10],[4,5]],[,,"(?:3[23]|48)\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}",,,,"71234567",
,,,[4,5]],[,,"5\\d{7}",,,,"51234567",,,[8]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,,,,,,,,[-1]],[,,"807\\d{7}",,,,"8071234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CU",53,"119","0",,,"0",,,,[[,"(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],[,"(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],[,"(\\d)(\\d{7})","$1 $2",["5"],"0$1"],[,"(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CV:[,[,,"(?:[2-59]\\d\\d|800)\\d{4}",,,,,,,[7]],[,,"2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}",
,,,"2211234"],[,,"(?:[34][36]|5[1-389]|9\\d)\\d{5}",,,,"9911234"],[,,"800\\d{4}",,,,"8001234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CV",238,"0",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CW:[,[,,"(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",,,,,,,[7,8]],[,,"9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}",,,,"94351234"],[,,"953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}",
,,,"95181234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"60[0-2]\\d{4}",,,,"6001234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CW",599,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[3467]"]],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],,[,,"955\\d{5}",,,,"95581234",,,[8]],1,"[69]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CX:[,[,,"1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",,,,,,,[6,7,8,9,10,12]],[,,"8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
,,,"891641234",,,[9],[8]],[,,"4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",,,,"412345678",,,[9]],[,,"180(?:0\\d{3}|2)\\d{3}",,,,"1800123456",,,[7,10]],[,,"190[0-26]\\d{6}",,,,"1900123456",,,[10]],[,,"13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",,,,"1300123456",,,[6,8,10,12]],[,,,,,,,,,[-1]],[,,"14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",,,,"147101234",,,[9]],"CX",61,"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","0",,,"0|([59]\\d{7})$",
"8$1","0011",,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CY:[,[,,"(?:[279]\\d|[58]0)\\d{6}",,,,,,,[8]],[,,"2[2-6]\\d{6}",,,,"22345678"],[,,"9[4-79]\\d{6}",,,,"96123456"],[,,"800\\d{5}",,,,"80001234"],[,,"90[09]\\d{5}",,,,"90012345"],[,,"80[1-9]\\d{5}",,,,"80112345"],[,,"700\\d{5}",,,,"70012345"],[,,,,,,,,,[-1]],"CY",357,"00",,,,,,,,[[,"(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:50|77)\\d{6}",,,,"77123456"],,,[,,,,,,,,,[-1]]],CZ:[,
[,,"(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",,,,,,,[9,10,11,12]],[,,"(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}",,,,"212345678",,,[9]],[,,"(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}",,,,"601123456",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"9(?:0[05689]|76)\\d{6}",,,,"900123456",,,[9]],[,,"8[134]\\d{7}",,,,"811234567",,,[9]],[,,"70[01]\\d{6}",,,,"700123456",,,[9]],[,,"9[17]0\\d{6}",,,,"910123456",,,[9]],"CZ",420,"00",,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],[,"(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
"$1 $2 $3 $4",["96"]],[,"(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"9(?:5\\d|7[2-4])\\d{6}",,,,"972123456",,,[9]],,,[,,"9(?:3\\d{9}|6\\d{7,10})",,,,"93123456789"]],DE:[,[,,"[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:1\\d|2[02-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|[23]1|[46][1-8])\\d{1,9}",,,,,,,[4,5,6,7,8,9,10,11,12,
13,14,15],[2,3]],[,,"32\\d{9,11}|49[2-6]\\d{10}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",,
,,"30123456",,,[5,6,7,8,9,10,11,12,13,14,15],[2,3,4]],[,,"15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}",,,,"15123456789",,,[10,11]],[,,"800\\d{7,12}",,,,"8001234567890",,,[10,11,12,13,14,15]],[,,"(?:137[7-9]|900(?:[135]|9\\d))\\d{6}",,,,"9001234567",,,[10,11]],[,,"180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}",,,,"18012345",,,[7,8,9,10,11,12,13,14]],[,,"700\\d{8}",,,,"70012345678",,,[11]],[,,,,,,,,,[-1]],"DE",49,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],[,"(\\d{3})(\\d{3,12})",
"$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],[,"(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
"0$1"],[,"(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],[,"(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],[,"(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],[,"(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],[,"(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],[,"(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],[,"(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],[,"(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],[,"(\\d{5})(\\d{6})","$1 $2",["15[0568]"],"0$1"],
[,"(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],[,"(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],[,"(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],,[,,"16(?:4\\d{1,10}|[89]\\d{1,11})",,,,"16412345",,,[4,5,6,7,8,9,10,11,12,13,14]],,,[,,,,,,,,,[-1]],[,,"18(?:1\\d{5,11}|[2-9]\\d{8})",,,,"18500123456",,,[8,9,10,11,12,13,14]],,,[,,"1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
,,,"177991234567",,,[12,13]]],DJ:[,[,,"(?:2\\d|77)\\d{6}",,,,,,,[8]],[,,"2(?:1[2-5]|7[45])\\d{5}",,,,"21360003"],[,,"77\\d{6}",,,,"77831001"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"DJ",253,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],DK:[,[,,"[2-9]\\d{7}",,,,,,,[8]],[,,"(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}",,,,"32123456"],[,,"(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}",
,,,"32123456"],[,,"80\\d{6}",,,,"80123456"],[,,"90\\d{6}",,,,"90123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"DK",45,"00",,,,,,,1,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],DM:[,[,,"(?:[58]\\d\\d|767|900)\\d{7}",,,,,,,[10],[7]],[,,"767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}",,,,"7674201234",,,,[7]],[,,"767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}",,,,"7672251234",,,,[7]],
[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"DM",1,"011","1",,,"1|([2-7]\\d{6})$","767$1",,,,,[,,,,,,,,,[-1]],,"767",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],
DO:[,[,,"(?:[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}",,,,"8092345678",,,,[7]],[,,"8[024]9[2-9]\\d{6}",,,,"8092345678",,,,[7]],[,,"8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}",
,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"DO",1,"011","1",,,"1",,,,,,[,,,,,,,,,[-1]],,"8001|8[024]9",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],DZ:[,[,,"(?:[1-4]|[5-79]\\d|80)\\d{7}",,,,,,,[8,9]],[,
,"9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[0135689])\\d{6}",,,,"12345678"],[,,"(?:5(?:4[0-29]|5\\d|6[0-2])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}",,,,"551234567",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"80[3-689]1\\d{5}",,,,"808123456",,,[9]],[,,"80[12]1\\d{5}",,,,"801123456",,,[9]],[,,,,,,,,,[-1]],[,,"98[23]\\d{6}",,,,"983123456",,,[9]],"DZ",213,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],
[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],EC:[,[,,"1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",,,,,,,[8,9,10,11],[7]],[,,"[2-7][2-7]\\d{6}",,,,"22123456",,,[8],[7]],[,,"964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}",,,,"991234567",,,[9]],[,,"1800\\d{7}|1[78]00\\d{6}",,,,"18001234567",,,[10,11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"[2-7]890\\d{4}",,,,"28901234",,,[8]],"EC",593,"00","0",,,
"0",,,,[[,"(\\d{3})(\\d{4})","$1-$2",["[2-7]"]],[,"(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],[[,"(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-7]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],EE:[,[,,"8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",,,,,,,[7,8,10]],[,,"(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}",
,,,"3212345",,,[7]],[,,"(?:5\\d{5}|8(?:1(?:0(?:000|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:23|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[24-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[679]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",,,,"51234567",,,[7,8]],[,,"800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}",,,,"80012345"],[,,"(?:40\\d\\d|900)\\d{4}",,,,"9001234",,,[7,8]],[,,,,,,,,,[-1]],[,,"70[0-2]\\d{5}",,,,"70012345",,,[8]],[,,,,
,,,,,[-1]],"EE",372,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],[,"(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,"800[2-9]\\d{3}",,,,,,,[7]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],EG:[,[,,"[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
,,,,,,[8,9,10],[6,7]],[,,"13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2[2-4]|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}",,,,"234567890",,,[8,9],[6,7]],[,,"1[0-25]\\d{8}",,,,"1001234567",,,[10]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,"900\\d{7}",,,,"9001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"EG",20,"00","0",,,"0",,,,[[,"(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],[,"(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[189]"],
"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],EH:[,[,,"[5-8]\\d{8}",,,,,,,[9]],[,,"528[89]\\d{5}",,,,"528812345"],[,,"(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[01]\\d|6[0-367]|7[0-57]))\\d{6}",,,,"650123456"],[,,"80\\d{7}",,,,"801234567"],[,,"89\\d{7}",,,,"891234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"592(?:4[0-2]|93)\\d{4}",,,,"592401234"],"EH",212,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,"528[89]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ER:[,[,,"[178]\\d{6}",,,,
,,,[7],[6]],[,,"(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}",,,,"8370362",,,,[6]],[,,"(?:17[1-3]|7\\d\\d)\\d{4}",,,,"7123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ER",291,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ES:[,[,,"[5-9]\\d{8}",,,,,,,[9]],[,,"96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}",
,,,"810123456"],[,,"(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}",,,,"612345678"],[,,"[89]00\\d{6}",,,,"800123456"],[,,"80[367]\\d{6}",,,,"803123456"],[,,"90[12]\\d{6}",,,,"901123456"],[,,"70\\d{7}",,,,"701234567"],[,,,,,,,,,[-1]],"ES",34,"00",,,,,,,,[[,"(\\d{4})","$1",["905"]],[,"(\\d{6})","$1",["[79]9"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]],[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],
[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"51\\d{7}",,,,"511234567"],,,[,,,,,,,,,[-1]]],ET:[,[,,"(?:11|[2-59]\\d)\\d{7}",,,,,,,[9],[7]],[,,"11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[78]|2[69]|39|4[5-7]|5[1-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
,,,"111112345",,,,[7]],[,,"9\\d{8}",,,,"911234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ET",251,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-59]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FI:[,[,,"[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",,,,,,,[5,6,7,8,9,10,11,12]],[,,"(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}",,,,"131234567",,,[5,6,7,8,9]],[,,"4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
,,,"412345678",,,[6,7,8,9,10]],[,,"800\\d{4,6}",,,,"800123456",,,[7,8,9]],[,,"[67]00\\d{5,6}",,,,"600123456",,,[8,9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"FI",358,"00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","0",,,"0",,"00",,[[,"(\\d{5})","$1",["75[12]"],"0$1"],[,"(\\d)(\\d{4,9})","$1 $2",["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"],[,"(\\d{6})","$1",["11"]],[,"(\\d{3})(\\d{3,7})","$1 $2",["[12]00|[368]|70[07-9]"],"0$1"],[,"(\\d{2})(\\d{4,8})","$1 $2",["[1245]|7[135]"],"0$1"],[,
"(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"]],[[,"(\\d)(\\d{4,9})","$1 $2",["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"],[,"(\\d{3})(\\d{3,7})","$1 $2",["[12]00|[368]|70[07-9]"],"0$1"],[,"(\\d{2})(\\d{4,8})","$1 $2",["[1245]|7[135]"],"0$1"],[,"(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"]],[,,,,,,,,,[-1]],1,"1[03-79]|[2-9]",[,,"20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"],[,,"20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
,,,"10112345"],,,[,,,,,,,,,[-1]]],FJ:[,[,,"45\\d{5}|(?:0800\\d|[235-9])\\d{6}",,,,,,,[7,11]],[,,"603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}",,,,"3212345",,,[7]],[,,"(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",,,,"7012345",,,[7]],[,,"0800\\d{7}",,,,"08001234567",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"FJ",679,"0(?:0|52)",,,,,,"00",,[[,"(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,
[-1]],,,[,,,,,,,,,[-1]]],FK:[,[,,"[2-7]\\d{4}",,,,,,,[5]],[,,"[2-47]\\d{4}",,,,"31234"],[,,"[56]\\d{4}",,,,"51234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"FK",500,"00",,,,,,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FM:[,[,,"(?:[39]\\d\\d|820)\\d{4}",,,,,,,[7]],[,,"31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}",,,,"3201234"],[,,"31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}",
,,,"3501234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"FM",691,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[389]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FO:[,[,,"[2-9]\\d{5}",,,,,,,[6]],[,,"(?:20|[34]\\d|8[19])\\d{4}",,,,"201234"],[,,"(?:[27][1-9]|5\\d|91)\\d{4}",,,,"211234"],[,,"80[257-9]\\d{3}",,,,"802123"],[,,"90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d",,,,"901123"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:6[0-36]|88)\\d{4}",,
,,"601234"],"FO",298,"00",,,,"(10(?:01|[12]0|88))",,,,[[,"(\\d{6})","$1",["[2-9]"],,"$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FR:[,[,,"[1-9]\\d{8}",,,,,,,[9]],[,,"(?:[1-35]\\d|4[1-9])\\d{7}",,,,"123456789"],[,,"(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7(?:00|[3-9]\\d))\\d{6}",,,,"612345678"],[,,"80[0-5]\\d{6}",,,,"801234567"],[,,"836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}",,,,"891123456"],[,,"8(?:1[01]|2[0156]|84)\\d{6}",
,,,"884012345"],[,,,,,,,,,[-1]],[,,"9\\d{8}",,,,"912345678"],"FR",33,"00","0",,,"0",,,,[[,"(\\d{4})","$1",["10"]],[,"(\\d{3})(\\d{3})","$1 $2",["1"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"80[6-9]\\d{6}",,,,"806123456"],
,,[,,,,,,,,,[-1]]],GA:[,[,,"(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",,,,,,,[7,8]],[,,"[01]1\\d{6}",,,,"01441234",,,[8]],[,,"(?:(?:0[2-7]\\d|6(?:0[0-4]|10|[256]\\d))\\d|7(?:[47]\\d\\d|658))\\d{4}|[2-7]\\d{6}",,,,"06031234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GA",241,"00",,,,"0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[47]\\d{6}|76\\d{6})","$1",,,[[,"(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",
["11|[67]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GB:[,[,,"[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",,,,,,,[7,9,10],[4,5,6,8]],[,,"(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0359])|(?:5[0-26-9]|[78][0-49])\\d\\d|6(?:[0-4]\\d\\d|50[0-24-69]))|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-278])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
,,,"1212345678",,,[9,10],[4,5,6,7,8]],[,,"7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",,,,"7400123456",,,[10]],[,,"80[08]\\d{7}|800\\d{6}|8001111",,,,"8001234567"],[,,"(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",,,,"9012345678",,,[7,10]],[,,,,,,,,,[-1]],[,,"70\\d{8}",,,,"7012345678",,,[10]],[,,"56\\d{8}",,,,"5612345678",
,,[10]],"GB",44,"00","0"," x",,"0",,,,[[,"(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],[,"(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],[,"(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],[,"(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])",
"[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],[,"(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],,[,,"76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",,,,"7640123456",,,[10]],1,,[,,,,,,,,,[-1]],[,,"(?:3[0347]|55)\\d{8}",,,,"5512345678",,,[10]],,,[,,,,,,,,,[-1]]],GD:[,[,,"(?:473|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
,,,"4732691234",,,,[7]],[,,"473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}",,,,"4734031234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"GD",
1,"011","1",,,"1|([2-9]\\d{6})$","473$1",,,,,[,,,,,,,,,[-1]],,"473",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GE:[,[,,"(?:[3-57]\\d\\d|800)\\d{6}",,,,,,,[9],[6,7]],[,,"(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}",,,,"322123456",,,,[6,7]],[,,"5(?:(?:0555|1177)[5-9]|757(?:7[7-9]|8[01]))\\d{3}|5(?:0070|(?:11|33)33|[25]222)[0-4]\\d{3}|5(?:00(?:0\\d|50)|11(?:00|1\\d|2[0-4])|5200|75(?:00|[57]5)|8(?:0(?:[01]\\d|2[0-4])|58[89]|8(?:55|88)))\\d{4}|(?:5(?:[14]4|5[0157-9]|68|7[0147-9]|9[1-35-9])|790)\\d{6}",
,,,"555123456"],[,,"800\\d{6}",,,,"800123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"70[67]\\d{6}",,,,"706123456"],"GE",995,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"70[67]\\d{6}"],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GF:[,[,,"(?:[56]94|80\\d|976)\\d{6}",
,,,,,,[9]],[,,"594(?:[023]\\d|1[01]|4[03-9]|5[6-9]|6[0-3]|80|9[0-4])\\d{4}",,,,"594101234"],[,,"694(?:[0-249]\\d|3[0-48])\\d{4}",,,,"694201234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"976\\d{6}",,,,"976012345"],"GF",594,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GG:[,[,,"(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
,,,,,,[7,9,10],[6]],[,,"1481[25-9]\\d{5}",,,,"1481256789",,,[10],[6]],[,,"7(?:(?:781|839)\\d|911[17])\\d{5}",,,,"7781123456",,,[10]],[,,"80[08]\\d{7}|800\\d{6}|8001111",,,,"8001234567"],[,,"(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",,,,"9012345678",,,[7,10]],[,,,,,,,,,[-1]],[,,"70\\d{8}",,,,"7012345678",,,[10]],[,,"56\\d{8}",,,,"5612345678",,,[10]],"GG",44,"00","0",,,"0|([25-9]\\d{5})$","1481$1",,,,,[,,"76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",
,,,"7640123456",,,[10]],,,[,,,,,,,,,[-1]],[,,"(?:3[0347]|55)\\d{8}",,,,"5512345678",,,[10]],,,[,,,,,,,,,[-1]]],GH:[,[,,"(?:[235]\\d{3}|800)\\d{5}",,,,,,,[8,9],[7]],[,,"3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}",,,,"302345678",,,[9],[7]],[,,"(?:2(?:[0346-8]\\d|5[67])|5(?:[0457]\\d|6[01]|9[1-9]))\\d{6}",,,,"231234567",,,[9]],[,,"800\\d{5}",,,,"80012345",
,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GH",233,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[237]|8[0-2]"]],[,"(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],[[,"(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,"800\\d{5}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GI:[,[,,"(?:[25]\\d\\d|606)\\d{5}",,,,,,,[8]],[,,"21(?:6[24-7]\\d|90[0-2])\\d{3}|2(?:00|2[25])\\d{5}",
,,,"20012345"],[,,"(?:5[146-8]\\d|606)\\d{5}",,,,"57123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GI",350,"00",,,,,,,,[[,"(\\d{3})(\\d{5})","$1 $2",["2"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GL:[,[,,"(?:19|[2-689]\\d|70)\\d{4}",,,,,,,[6]],[,,"(?:19|3[1-7]|6[14689]|70|8[14-79]|9\\d)\\d{4}",,,,"321000"],[,,"[245]\\d{5}",,,,"221234"],[,,"80\\d{4}",,,,"801234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"3[89]\\d{4}",
,,,"381234"],"GL",299,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GM:[,[,,"[2-9]\\d{6}",,,,,,,[7]],[,,"(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}",,,,"5661234"],[,,"(?:[23679]\\d|5[0-389])\\d{5}",,,,"3012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GM",220,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",
["[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GN:[,[,,"722\\d{6}|(?:3|6\\d)\\d{7}",,,,,,,[8,9]],[,,"3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}",,,,"30241234",,,[8]],[,,"6[0-356]\\d{7}",,,,"601123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"722\\d{6}",,,,"722123456",,,[9]],"GN",224,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",
["[67]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GP:[,[,,"(?:590|(?:69|80)\\d|976)\\d{6}",,,,,,,[9]],[,,"590(?:0[1-68]|1[0-24]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}",,,,"590201234"],[,,"69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}",,,,"690001234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"976[01]\\d{5}",,,,"976012345"],"GP",590,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",
["[569]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],1,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GQ:[,[,,"222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",,,,,,,[9]],[,,"33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}",,,,"333091234"],[,,"(?:222|55\\d)\\d{6}",,,,"222123456"],[,,"80\\d[1-9]\\d{5}",,,,"800123456"],[,,"90\\d[1-9]\\d{5}",,,,"900123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GQ",240,"00",,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",
["[235]"]],[,"(\\d{3})(\\d{6})","$1 $2",["[89]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GR:[,[,,"5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",,,,,,,[10,11,12]],[,,"2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
,,,"2123456789",,,[10]],[,,"68[57-9]\\d{7}|(?:69|94)\\d{8}",,,,"6912345678",,,[10]],[,,"800\\d{7,9}",,,,"8001234567"],[,,"90[19]\\d{7}",,,,"9091234567",,,[10]],[,,"8(?:0[16]|12|[27]5|50)\\d{7}",,,,"8011234567",,,[10]],[,,"70\\d{8}",,,,"7012345678",,,[10]],[,,,,,,,,,[-1]],"GR",30,"00",,,,,,,,[[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],[,"(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]],[,"(\\d{3})(\\d{3,4})(\\d{5})",
"$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"5005000\\d{3}",,,,"5005000123",,,[10]],,,[,,,,,,,,,[-1]]],GT:[,[,,"(?:1\\d{3}|[2-7])\\d{7}",,,,,,,[8,11]],[,,"[267][2-9]\\d{6}",,,,"22456789",,,[8]],[,,"[3-5]\\d{7}",,,,"51234567",,,[8]],[,,"18[01]\\d{8}",,,,"18001112222",,,[11]],[,,"19\\d{9}",,,,"19001112222",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GT",502,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[2-7]"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]],,[,,,,,,,,,[-1]],
,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GU:[,[,,"(?:[58]\\d\\d|671|900)\\d{7}",,,,,,,[10],[7]],[,,"671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",,,,"6713001234",,,,[7]],[,,"671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
,,,"6713001234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"GU",1,"011","1",,,"1|([3-9]\\d{6})$","671$1",,1,,,[,,,,,,,,,[-1]],,"671",[,,,,,,,,,[-1]],[,,,,,,,
,,[-1]],,,[,,,,,,,,,[-1]]],GW:[,[,,"[49]\\d{8}|4\\d{6}",,,,,,,[7,9]],[,,"443\\d{6}",,,,"443201234",,,[9]],[,,"9(?:5\\d|6[569]|77)\\d{6}",,,,"955012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"40\\d{5}",,,,"4012345",,,[7]],"GW",245,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["40"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GY:[,[,,"9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}",,,,,,,[7]],[,,"(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}",
,,,"2201234"],[,,"(?:6\\d\\d|70[015-7])\\d{4}",,,,"6091234"],[,,"(?:289|862)\\d{4}",,,,"2891234"],[,,"9008\\d{3}",,,,"9008123"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GY",592,"001",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-46-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],HK:[,[,,"8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",,,,,,,[5,6,7,8,9,11]],[,,"(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|5[0-5]|9\\d))|58(?:0[1-8]|1[2-9]))\\d{4}",
,,,"21234567",,,[8]],[,,"(?:46(?:[07][0-7]|1[0-6]|4[0-57-9]|6[0-4])|573[0-6]|6(?:26[013-8]|66[0-3])|70(?:7[1-5]|8[0-4])|848[015-9]|929[03-9])\\d{4}|(?:4(?:40|6[2358])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-24679])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|84[09]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",,,,"51234567",,,[8]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"900(?:[0-24-9]\\d{7}|3\\d{1,4})",,,,"90012345678",,,[5,6,7,8,11]],[,,,,,,,,,[-1]],[,,"8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}",
,,,"81123456",,,[8]],[,,,,,,,,,[-1]],"HK",852,"00(?:30|5[09]|[126-9]?)",,,,,,"00",,[[,"(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],[,"(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],[,"(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],,[,,"7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}",
,,,"71123456",,,[8]],,,[,,,,,,,,,[-1]],[,,"30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}",,,,"30161234",,,[8]],,,[,,,,,,,,,[-1]]],HN:[,[,,"8\\d{10}|[237-9]\\d{7}",,,,,,,[8,11]],[,,"2(?:2(?:0[0-39]|1[1-367]|[23]\\d|4[03-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[78]|2[3-59]|3[13-9]|4[0-68]|5[1-35])|5(?:0[7-9]|16|4[03-5]|5\\d|6[014-6]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[04]|4[0-378]|[78][0-8]|9[01])|7(?:6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",,,,"22123456",,,[8]],[,,"[37-9]\\d{7}",
,,,"91234567",,,[8]],[,,"8002\\d{7}",,,,"80021234567",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"HN",504,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1-$2",["[237-9]"]],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["8"]]],[[,"(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]],[,,,,,,,,,[-1]],,,[,,"8002\\d{7}",,,,,,,[11]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],HR:[,[,,"(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",,,,,,,[6,7,8,9]],[,,"1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
,,,"12345678",,,[8,9],[6,7]],[,,"9(?:751\\d{5}|8\\d{6,7})|9(?:0[1-9]|[1259]\\d|7[0679])\\d{6}",,,,"921234567",,,[8,9]],[,,"80[01]\\d{4,6}",,,,"800123456",,,[7,8,9]],[,,"6[01459]\\d{6}|6[01]\\d{4,5}",,,,"611234",,,[6,7,8]],[,,,,,,,,,[-1]],[,,"7[45]\\d{6}",,,,"74123456",,,[8]],[,,,,,,,,,[-1]],"HR",385,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],[,"(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})",
"$1 $2 $3",["[67]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"62\\d{6,7}|72\\d{6}",,,,"62123456",,,[8,9]],,,[,,,,,,,,,[-1]]],HT:[,[,,"[2-489]\\d{7}",,,,,,,[8]],[,,"2(?:2\\d|5[1-5]|81|9[149])\\d{5}",,,,"22453300"],[,,"[34]\\d{7}",,,,"34101234"],[,,"8\\d{7}",,,,"80012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}",
,,,"98901234"],"HT",509,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-489]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],HU:[,[,,"[235-7]\\d{8}|[1-9]\\d{7}",,,,,,,[8,9],[6,7]],[,,"(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}",,,,"12345678",,,[8],[6,7]],[,,"(?:[257]0|3[01])\\d{7}",,,,"201234567",,,[9]],[,,"(?:[48]0\\d|680[29])\\d{5}",,,,"80123456"],[,,"9[01]\\d{6}",,,,"90123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"21\\d{7}",
,,,"211234567",,,[9]],"HU",36,"00","06",,,"06",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"06 $1"]],,[,,,,,,,,,[-1]],,,[,,"(?:[48]0\\d|680[29])\\d{5}"],[,,"38\\d{7}",,,,"381234567",,,[9]],,,[,,,,,,,,,[-1]]],ID:[,[,,"(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",,,,,,,[7,8,9,10,11,12,13],[5,6]],
[,,"2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",,,,"218350123",,,[7,8,9,10,11],[5,6]],[,,"8[1-35-9]\\d{7,10}",
,,,"812345678",,,[9,10,11,12]],[,,"00[17]803\\d{7}|(?:177\\d|800)\\d{5,7}|001803\\d{6}",,,,"8001234567",,,[8,9,10,11,12,13]],[,,"809\\d{7}",,,,"8091234567",,,[10]],[,,"804\\d{7}",,,,"8041234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ID",62,"00[89]","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],[,"(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],[,"(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],[,"(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],[,"(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",
["8[1-35-9]"],"0$1"],[,"(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],[,"(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["001"]],[,"(\\d{2})(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3 $4",["0"]]],[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],[,"(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],[,"(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],
[,"(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],[,"(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],[,"(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],[,"(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],[,,,,,,,,,[-1]],,,[,,"001803\\d{6,7}|(?:007803\\d|8071)\\d{6}",,,,,,,[10,12,13]],[,,"(?:1500|8071\\d{3})\\d{3}",,,,"8071123456",,,[7,10]],,,[,,,,,,,,,[-1]]],IE:[,[,,"(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
,,,,,,[7,8,9,10],[5,6]],[,,"(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}",,,,"2212345",,,,[5,6]],[,,"8(?:22|[35-9]\\d)\\d{6}",,,,"850123456",,,[9]],[,,"1800\\d{6}",,,,"1800123456",,,[10]],[,,"15(?:1[2-8]|[2-8]0|9[089])\\d{6}",,,,"1520123456",,,[10]],[,,"18[59]0\\d{6}",,,,"1850123456",,,[10]],[,,"700\\d{6}",,,,"700123456",,,[9]],[,,"76\\d{7}",,,,"761234567",,,[9]],"IE",353,"00",
"0",,,"0",,,,[[,"(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],[,"(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],[,"(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],[,"(\\d{2})(\\d{4})(\\d{4})",
"$1 $2 $3",["4"],"(0$1)"],[,"(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"18[59]0\\d{6}",,,,,,,[10]],[,,"818\\d{6}",,,,"818123456",,,[9]],,,[,,"88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}",,,,"8551234567",,,[10]]],IL:[,[,,"1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",,,,,,,[7,8,9,10,11,12]],[,,"153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}",,,,"21234567",,,[8,11,12],[7]],[,,"5(?:(?:[02368]\\d|[19][2-9]|4[1-9])\\d|5(?:01|1[79]|2[2-9]|3[0-3]|4[34]|5[015689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}",
,,,"502345678",,,[9]],[,,"1(?:255|80[019]\\d{3})\\d{3}",,,,"1800123456",,,[7,10]],[,,"1212\\d{4}|1(?:200|9(?:0[01]|19))\\d{6}",,,,"1919123456",,,[8,10]],[,,"1700\\d{6}",,,,"1700123456",,,[10]],[,,,,,,,,,[-1]],[,,"7(?:380|8(?:33|55|77|81))\\d{5}|7(?:18|2[23]|3[237]|47|6[58]|7\\d|82|9[235-9])\\d{6}",,,,"771234567",,,[9]],"IL",972,"0(?:0|1[2-9])","0",,,"0",,,,[[,"(\\d{4})(\\d{3})","$1-$2",["125"]],[,"(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],[,"(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],
[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],[,"(\\d{4})(\\d{6})","$1-$2",["159"]],[,"(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],[,"(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],,[,,,,,,,,,[-1]],,,[,,"1700\\d{6}",,,,,,,[10]],[,,"1599\\d{6}",,,,"1599123456",,,[10]],,,[,,"151\\d{8,9}",,,,"15112340000",,,[11,12]]],IM:[,[,,"1624\\d{6}|(?:[3578]\\d|90)\\d{8}",,,,,,,[10],[6]],[,,"1624(?:230|[5-8]\\d\\d)\\d{3}",,,,"1624756789",
,,,[6]],[,,"76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}",,,,"7924123456"],[,,"808162\\d{4}",,,,"8081624567"],[,,"8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}",,,,"9016247890"],[,,,,,,,,,[-1]],[,,"70\\d{8}",,,,"7012345678"],[,,"56\\d{8}",,,,"5612345678"],"IM",44,"00","0",,,"0|([25-8]\\d{5})$","1624$1",,,,,[,,,,,,,,,[-1]],,"74576|(?:16|7[56])24",[,,,,,,,,,[-1]],[,,"3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}",,,,"5512345678"],,,[,,,,,,,,,[-1]]],
IN:[,[,,"(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",,,,,,,[8,9,10,11,12,13],[6,7]],[,,"2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
,,,"7410410123",,,[10],[6,7,8]],[,,"(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
,,,"8123456789",,,[10]],[,,"000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))",,,,"1800123456"],[,,"186[12]\\d{9}",,,,"1861123456789",,,[13]],[,,"1860\\d{7}",,,,"18603451234",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"IN",91,"00","0",,,"0",,,,[[,"(\\d{7})","$1",["575"]],[,"(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],,,1],[,"(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",
["140"],,,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
"1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],
"0$1",,1],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
"1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",,1],[,"(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",,1],[,"(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],,,1],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
"$1 $2 $3 $4",["0"]],[,"(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],,,1]],[[,"(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],,,1],[,"(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],,,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],
"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
"1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],
"0$1",,1],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
"1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",,1],[,"(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",,1],[,"(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],,,1],[,"(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
"$1 $2 $3 $4",["18"],,,1]],[,,,,,,,,,[-1]],,,[,,"1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"],[,,"140\\d{7}",,,,"1409305260",,,[10]],,,[,,,,,,,,,[-1]]],IO:[,[,,"3\\d{6}",,,,,,,[7]],[,,"37\\d{5}",,,,"3709100"],[,,"38\\d{5}",,,,"3801234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"IO",246,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["3"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],IQ:[,[,,"(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
,,,,,,[8,9,10],[6,7]],[,,"1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}",,,,"12345678",,,[8,9],[6,7]],[,,"7[3-9]\\d{8}",,,,"7912345678",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"IQ",964,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],IR:[,
[,,"[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",,,,,,,[4,5,6,7,10],[8]],[,,"(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|2(?:121|[2689]0\\d)|30[0-2]\\d|4(?:111|40\\d))\\d{4}",,,,"2123456789",,,[6,7,10],[4,5,8]],[,,"9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:(?:[0-3]\\d|4[0145])\\d|5[15]0|8(?:1\\d|88)|9(?:0[013]|[19]\\d|21|77|8[7-9])))\\d{5}",,,,"9123456789",,,[10]],[,,,,,,,,,[-1]],[,
,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"IR",98,"00","0",,,"0",,,,[[,"(\\d{4,5})","$1",["96"],"0$1"],[,"(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))",,,,,,,[4,5,10]],[,,"96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
,,,"9601",,,[4,5]],,,[,,,,,,,,,[-1]]],IS:[,[,,"(?:38\\d|[4-9])\\d{6}",,,,,,,[7,9]],[,,"(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-245]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}",,,,"4101234",,,[7]],[,,"(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[027-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[28]))\\d{4}",,,,"6111234"],[,,"80[08]\\d{4}",,,,"8001234",,,[7]],[,,"90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
,,,"9001234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"49[0-24-79]\\d{4}",,,,"4921234",,,[7]],"IS",354,"00|1(?:0(?:01|[12]0)|100)",,,,,,"00",,[[,"(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"809\\d{4}",,,,"8091234",,,[7]],,,[,,"(?:689|8(?:7[18]|80)|95[48])\\d{4}",,,,"6891234",,,[7]]],IT:[,[,,"0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|55\\d{8}|8\\d{5}(?:\\d{2,4})?",,,,,,,[6,7,8,9,10,11,12]],[,,"0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
,,,"0212345678",,,[6,7,8,9,10,11]],[,,"3[1-9]\\d{8}|3[2-9]\\d{7}",,,,"3123456789",,,[9,10]],[,,"80(?:0\\d{3}|3)\\d{3}",,,,"800123456",,,[6,9]],[,,"(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",,,,"899123456",,,[6,8,9,10]],[,,"84(?:[08]\\d{3}|[17])\\d{3}",,,,"848123456",,,[6,9]],[,,"1(?:78\\d|99)\\d{6}",,,,"1781234567",,,[9,10]],[,,"55\\d{8}",,,,"5512345678",,,[10]],"IT",39,"00",,,,,,,,[[,"(\\d{4,5})","$1",["1(?:0|9[246])","1(?:0|9(?:2[2-9]|[46]))"]],
[,"(\\d{6})","$1",["1(?:1|92)"]],[,"(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],[,"(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],[,"(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],[,"(\\d{4})(\\d{4})","$1 $2",["894"]],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1(?:44|[679])|[38]"]],[,"(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],[,"(\\d{2})(\\d{4})(\\d{5})",
"$1 $2 $3",["0[26]"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],[[,"(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],[,"(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],[,"(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],[,"(\\d{4})(\\d{4})","$1 $2",["894"]],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1(?:44|[679])|[38]"]],
[,"(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],[,"(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],[,,,,,,,,,[-1]],1,,[,,"848\\d{6}",,,,,,,[9]],[,,,,,,,,,[-1]],,,[,,"3[2-8]\\d{9,10}",,,,"33101234501",,,[11,12]]],JE:[,[,,"1534\\d{6}|(?:[3578]\\d|90)\\d{8}",,,,,,,[10],[6]],[,,"1534[0-24-8]\\d{5}",,,,"1534456789",,,,[6]],[,,"7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}",,,,"7797712345"],
[,,"80(?:07(?:35|81)|8901)\\d{4}",,,,"8007354567"],[,,"(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}",,,,"9018105678"],[,,,,,,,,,[-1]],[,,"701511\\d{4}",,,,"7015115678"],[,,"56\\d{8}",,,,"5612345678"],"JE",44,"00","0",,,"0|([0-24-8]\\d{5})$","1534$1",,,,,[,,"76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",,,,"7640123456"],,,[,,,,,,,,,[-1]],[,,"(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
,,,"5512345678"],,,[,,,,,,,,,[-1]]],JM:[,[,,"(?:[58]\\d\\d|658|900)\\d{7}",,,,,,,[10],[7]],[,,"8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0237-9]|[23]\\d|40|5[06]|6[2-589]|7[05]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}",,,,"8765230123",,,,[7]],[,,"(?:658295|876(?:2(?:0[2-9]|[14-9]\\d|2[013-9]|3[3-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
,,,"8762101234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"JM",1,"011","1",,,"1",,,,,,[,,,,,,,,,[-1]],,"658|876",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,
,[-1]]],JO:[,[,,"(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",,,,,,,[8,9]],[,,"87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
,,,"62001234",,,[8]],[,,"7(?:[78][0-25-9]|9\\d)\\d{6}",,,,"790123456",,,[9]],[,,"80\\d{6}",,,,"80012345",,,[8]],[,,"9\\d{7}",,,,"90012345",,,[8]],[,,"85\\d{6}",,,,"85012345",,,[8]],[,,"70\\d{7}",,,,"700123456",,,[9]],[,,,,,,,,,[-1]],"JO",962,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],[,"(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],,[,,"74(?:66|77)\\d{5}",,,,"746612345",
,,[9]],,,[,,,,,,,,,[-1]],[,,"8(?:10|8\\d)\\d{5}",,,,"88101234",,,[8]],,,[,,,,,,,,,[-1]]],JP:[,[,,"00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",,,,,,,[8,9,10,11,12,13,14,15,16,17]],[,,"(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}",,,,"312345678",,,[9]],[,,"[7-9]0[1-9]\\d{7}",
,,,"9012345678",,,[10]],[,,"00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}",,,,"120123456"],[,,"990\\d{6}",,,,"990123456",,,[9]],[,,,,,,,,,[-1]],[,,"60\\d{7}",,,,"601234567",,,[9]],[,,"50[1-9]\\d{7}",,,,"5012345678",,,[10]],"JP",81,"010","0",,,"0",,,,[[,"(\\d{4})(\\d{4})","$1-$2",["007","0077","00777","00777[01]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],[,"(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])",
"1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],
"0$1"],[,"(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],[,"(\\d{4})(\\d{2})(\\d{3,4})","$1-$2-$3",["007","0077"]],[,"(\\d{4})(\\d{2})(\\d{4})","$1-$2-$3",["008"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3,4})","$1-$2-$3",["0"]],[,"(\\d{4})(\\d{4})(\\d{4,5})","$1-$2-$3",["0"]],[,"(\\d{4})(\\d{5})(\\d{5,6})","$1-$2-$3",["0"]],[,"(\\d{4})(\\d{6})(\\d{6,7})","$1-$2-$3",
["0"]]],[[,"(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],[,"(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],
"0$1"],[,"(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"]],[,,"20\\d{8}",,,,"2012345678",,,[10]],,,[,,"00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"],[,,"570\\d{6}",,,,"570123456",,,[9]],,,[,,,,,,,,,[-1]]],KE:[,[,,"(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",,,,,,,[7,8,9,10]],[,,"(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
,,,"202012345",,,[7,8,9]],[,,"(?:1(?:0[0-6]|1[0-5]|2[014])|7\\d\\d)\\d{6}",,,,"712123456",,,[9]],[,,"800[24-8]\\d{5,6}",,,,"800223456",,,[9,10]],[,,"900[02-9]\\d{5}",,,,"900223456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KE",254,"000","0",,,"0",,,,[[,"(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],[,"(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KG:[,[,,"8\\d{9}|(?:[235-8]\\d|99)\\d{7}",
,,,,,,[9,10],[5,6]],[,,"312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}",,,,"312123456",,,[9],[5,6]],[,,"312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|7(?:[07]\\d|55)|880|99[05-9])\\d{6}",,,,"700123456",,,[9]],[,,"800\\d{6,7}",,,,"800123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,
,,,,,,,[-1]],[,,,,,,,,,[-1]],"KG",996,"00","0",,,"0",,,,[[,"(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],[,"(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KH:[,[,,"1\\d{9}|[1-9]\\d{7,8}",,,,,,,[8,9,10],[6,7]],[,,"23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
,,,"23756789",,,[8,9],[6,7]],[,,"(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}",,,,"91234567",,,[8,9]],[,,"1800(?:1\\d|2[019])\\d{4}",,,,"1800123456",,,[10]],[,,"1900(?:1\\d|2[09])\\d{4}",,,,"1900123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KH",855,"00[14-9]","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],
,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KI:[,[,,"(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",,,,,,,[5,8]],[,,"(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}",,,,"31234"],[,,"(?:63\\d{3}|73(?:0[0-5]\\d|140))\\d{3}|[67]200[01]\\d{3}",,,,"72001234",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"30(?:0[01]\\d\\d|12(?:11|20))\\d\\d",,,,"30010000",,,[8]],
"KI",686,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KM:[,[,,"[3478]\\d{6}",,,,,,,[7],[4]],[,,"7[4-7]\\d{5}",,,,"7712345",,,,[4]],[,,"[34]\\d{6}",,,,"3212345"],[,,,,,,,,,[-1]],[,,"8\\d{6}",,,,"8001234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KM",269,"00",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KN:[,[,,"(?:[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}",
,,,"8692361234",,,,[7]],[,,"869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}",,,,"8697652917",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"KN",1,"011","1",,,"1|([2-7]\\d{6})$",
"869$1",,,,,[,,,,,,,,,[-1]],,"869",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KP:[,[,,"85\\d{6}|(?:19\\d|[2-7])\\d{7}",,,,,,,[8,10],[6,7]],[,,"(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}",,,,"21234567",,,,[6,7]],[,,"19[1-3]\\d{7}",,,,"1921234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KP",850,"00|99","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})",
"$1 $2 $3",["1"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KR:[,[,,"00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",,,,,,,[5,6,8,9,10,11,12,13,14],[3,4,7]],[,,"(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",,,,"22123456",,,[5,6,8,9,10],[3,4,7]],[,,"1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[1-46-9]|[16-9]\\d|2[013-9])\\d{6,7}",
,,,"1020000000",,,[9,10]],[,,"00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|80)\\d{7}",,,,"801234567",,,[9,11,12,13,14]],[,,"60[2-9]\\d{6}",,,,"602345678",,,[9]],[,,,,,,,,,[-1]],[,,"50\\d{8,9}",,,,"5012345678",,,[10,11]],[,,"70\\d{8}",,,,"7012345678",,,[10]],"KR",82,"00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","0",,,"0(8(?:[1-46-8]|5\\d\\d))?",,,,[[,"(\\d{5})","$1",["1[016-9]1","1[016-9]11","1[016-9]114"],"0$1"],[,"(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1","0$CC-$1"],[,
"(\\d{4})(\\d{4})","$1-$2",["1"]],[,"(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1","0$CC-$1"],[,"(\\d{5})(\\d{3})(\\d{3})","$1 $2 $3",["003","0030"]],[,"(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1","0$CC-$1"],[,"(\\d{5})(\\d{3,4})(\\d{4})","$1 $2 $3",["0"]],[,"(\\d{5})(\\d{2})(\\d{3})(\\d{4})",
"$1 $2 $3 $4",["0"]]],[[,"(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1","0$CC-$1"],[,"(\\d{4})(\\d{4})","$1-$2",["1"]],[,"(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1","0$CC-$1"]],[,,"15\\d{7,8}",,,,"1523456789",
,,[9,10]],,,[,,"00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})",,,,,,,[11,12,13,14]],[,,"1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))\\d{4}",,,,"15441234",,,[8]],,,[,,,,,,,,,[-1]]],KW:[,[,,"18\\d{5}|(?:[2569]\\d|41)\\d{6}",,,,,,,[7,8]],[,,"2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}",,,,"22345678",,,[8]],[,,"(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|222|333|444|7(?:0[013-9]|[67]\\d)|888|9(?:[069]\\d|3[039]))|9(?:(?:0[09]|22|[4679]\\d|8[057-9])\\d|1(?:1[01]|99)|3(?:00|33)|5(?:00|5\\d)))\\d{4}",
,,,"50012345",,,[8]],[,,"18\\d{5}",,,,"1801234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KW",965,"00",,,,,,,,[[,"(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],[,"(\\d{3})(\\d{5})","$1 $2",["[245]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KY:[,[,,"(?:345|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|25|[48]8)|9(?:14|4[035-9]))\\d{4}",,
,,"3452221234",,,,[7]],[,,"345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}",,,,"3453231234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"(?:345976|900[2-9]\\d\\d)\\d{4}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"KY",1,"011","1",,,"1|([2-9]\\d{6})$","345$1",,,,,[,,"345849\\d{4}",,,,"3458491234"],,"345",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KZ:[,[,,"(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",,,,,,,[10,14],[5,6,7]],[,,"(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",
,,,"7123456789",,,[10],[5,6,7]],[,,"7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}",,,,"7710009998",,,[10]],[,,"8(?:00|108\\d{3})\\d{7}",,,,"8001234567"],[,,"809\\d{7}",,,,"8091234567",,,[10]],[,,,,,,,,,[-1]],[,,"808\\d{7}",,,,"8081234567",,,[10]],[,,"751\\d{7}",,,,"7511234567",,,[10]],"KZ",7,"810","8",,,"8",,"8~10",,,,[,,,,,,,,,[-1]],,"33|7",[,,"751\\d{7}",,,,,,,[10]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LA:[,[,,"[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",,,,,,,[8,9,10],[6]],[,,"(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
,,,"21212862",,,[8],[6]],[,,"(?:20(?:[239]\\d|5[24-9]|7[6-8])|302\\d)\\d{6}",,,,"2023123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LA",856,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[013-9]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"30[013-9]\\d{6}",,,,"301234567",,,[9]],,,[,,
,,,,,,,[-1]]],LB:[,[,,"[27-9]\\d{7}|[13-9]\\d{6}",,,,,,,[7,8]],[,,"7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}",,,,"1123456"],[,,"793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}",,,,"71123456"],[,,,,,,,,,[-1]],[,,"9[01]\\d{6}",,,,"90123456",,,[8]],[,,"80\\d{6}",,,,"80123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LB",961,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LC:[,[,,"(?:[58]\\d\\d|758|900)\\d{7}",,,,,,,[10],[7]],[,,"758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}",,,,"7584305678",,,,[7]],[,,"758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}",,,,"7582845678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],
[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"LC",1,"011","1",,,"1|([2-8]\\d{6})$","758$1",,,,,[,,,,,,,,,[-1]],,"758",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LI:[,[,,"[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",,,,,,,[7,9]],[,,"(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",
,,,"2345678",,,[7]],[,,"(?:6(?:4(?:5[4-9]|[6-9]\\d)|5[0-4]\\d|6(?:[0245]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}",,,,"660234567"],[,,"8002[28]\\d\\d|80(?:05\\d|9)\\d{4}",,,,"8002222"],[,,"90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d",,,,"9002222",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LI",423,"00","0",,,"0|(1001)",,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2379]|8(?:0[09]|7)","[2379]|8(?:0(?:02|9)|7)"],,"$CC $1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],[,"(\\d{2})(\\d{3})(\\d{4})",
"$1 $2 $3",["69"],,"$CC $1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"],,"$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"870(?:28|87)\\d\\d",,,,"8702812",,,[7]],,,[,,"697(?:42|56|[78]\\d)\\d{4}",,,,"697861234",,,[9]]],LK:[,[,,"[1-9]\\d{8}",,,,,,,[9],[7]],[,,"(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}",,,,"112345678",,,,[7]],[,,"7(?:[0-25-8]\\d|4[0-4])\\d{6}",,,,"712345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,
,,,,,[-1]],[,,,,,,,,,[-1]],"LK",94,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"1973\\d{5}",,,,"197312345"],,,[,,,,,,,,,[-1]]],LR:[,[,,"(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}",,,,,,,[7,8,9]],[,,"(?:2\\d{3}|33333)\\d{4}",,,,"21234567",,,[8,9]],[,,"(?:(?:330|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}",,,,"770123456",,,[7,9]],[,,,,,,,,,[-1]],[,,"332(?:02|[34]\\d)\\d{4}",,,,"332021234",
,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LR",231,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[4-6]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3578]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LS:[,[,,"(?:[256]\\d\\d|800)\\d{5}",,,,,,,[8]],[,,"2\\d{7}",,,,"22123456"],[,,"[56]\\d{7}",,,,"50123456"],[,,"800[256]\\d{4}",,,,"80021234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,
,[-1]],[,,,,,,,,,[-1]],"LS",266,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[2568]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LT:[,[,,"(?:[3469]\\d|52|[78]0)\\d{6}",,,,,,,[8]],[,,"(?:3[1478]|4[124-6]|52)\\d{6}",,,,"31234567"],[,,"6\\d{7}",,,,"61234567"],[,,"80[02]\\d{5}",,,,"80012345"],[,,"9(?:0[0239]|10)\\d{5}",,,,"90012345"],[,,"808\\d{5}",,,,"80812345"],[,,"70[05]\\d{5}",,,,"70012345"],[,,"[89]01\\d{5}",,,,"80123456"],"LT",370,"00","8",,,"[08]",,,,[[,"(\\d)(\\d{3})(\\d{4})",
"$1 $2 $3",["52[0-7]"],"(8-$1)",,1],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1",,1],[,"(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(8-$1)",,1],[,"(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(8-$1)",,1]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"70[67]\\d{5}",,,,"70712345"],,,[,,,,,,,,,[-1]]],LU:[,[,,"35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",,,,,,,[4,5,6,7,8,9,10,11]],[,,"(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}",
,,,"27123456"],[,,"6(?:[269][18]|5[1568]|7[189]|81)\\d{6}",,,,"628123456",,,[9]],[,,"800\\d{5}",,,,"80012345",,,[8]],[,,"90[015]\\d{5}",,,,"90012345",,,[8]],[,,"801\\d{5}",,,,"80112345",,,[8]],[,,,,,,,,,[-1]],[,,"20(?:1\\d{5}|[2-689]\\d{1,7})",,,,"20201234",,,[4,5,6,7,8,9,10]],"LU",352,"00",,,,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",,,,[[,"(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],
,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"],,"$CC $1"],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"],,"$CC $1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",
["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"],,"$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LV:[,[,,"(?:[268]\\d|90)\\d{6}",,,,,,,[8]],[,,"6\\d{7}",,,,"63123456"],[,,"2\\d{7}",,,,"21234567"],[,,"80\\d{6}",,,,"80123456"],[,,"90\\d{6}",,,,"90123456"],[,,"81\\d{6}",,,,"81123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LV",371,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[269]|8[01]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],
LY:[,[,,"[2-9]\\d{8}",,,,,,,[9],[7]],[,,"(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}",,,,"212345678",,,,[7]],[,,"9[1-6]\\d{7}",,,,"912345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LY",218,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MA:[,[,,"[5-8]\\d{8}",,,,,,,[9]],[,,"5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}",,,,"520123456"],[,,"(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[01]\\d|6[0-367]|7[0-57]))\\d{6}",,,,"650123456"],[,,"80\\d{7}",,,,"801234567"],[,,"89\\d{7}",,,,"891234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"592(?:4[0-2]|93)\\d{4}",,,,"592401234"],"MA",212,"00","0",
,,"0",,,,[[,"(\\d{5})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29|38)[89]","5(?:29|38)[89]0"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],[,"(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|9)|892","5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"],"0$1"],[,"(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],[,"(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],,[,,,,,,,,,[-1]],1,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MC:[,[,,"(?:[3489]|6\\d)\\d{7}",,,,,,,[8,9]],[,,"(?:870|9[2-47-9]\\d)\\d{5}",
,,,"99123456",,,[8]],[,,"4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}",,,,"612345678"],[,,"(?:800|90\\d)\\d{5}",,,,"90123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MC",377,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["87"]],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],
"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],[,,,,,,,,,[-1]],,,[,,"8[07]0\\d{5}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MD:[,[,,"(?:[235-7]\\d|[89]0)\\d{6}",,,,,,,[8]],[,,"(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}",,,,"22212345"],[,,"562\\d{5}|(?:6\\d|7[16-9])\\d{6}",,,,"62112345"],[,,"800\\d{5}",,,,"80012345"],[,,"90[056]\\d{5}",,,,"90012345"],[,,"808\\d{5}",,,,"80812345"],[,,,,,,,,,[-1]],
[,,"3[08]\\d{6}",,,,"30123456"],"MD",373,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"803\\d{5}",,,,"80312345"],,,[,,,,,,,,,[-1]]],ME:[,[,,"(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",,,,,,,[8,9],[6]],[,,"(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}",,,,"30234567",,,[8],[6]],[,,"6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",
,,,"67622901",,,[8]],[,,"80(?:[0-2578]|9\\d)\\d{5}",,,,"80080002"],[,,"9(?:4[1568]|5[178])\\d{5}",,,,"94515151",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"78[1-49]\\d{5}",,,,"78108780",,,[8]],"ME",382,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"77[1-9]\\d{5}",,,,"77273012",,,[8]],,,[,,,,,,,,,[-1]]],MF:[,[,,"(?:590|(?:69|80)\\d|976)\\d{6}",,,,,,,[9]],[,,"590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}",,,,"590271234"],[,,"69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}",
,,,"690001234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"976[01]\\d{5}",,,,"976012345"],"MF",590,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MG:[,[,,"[23]\\d{8}",,,,,,,[9],[7]],[,,"2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}",,,,"202123456",,,,[7]],[,,"3[2-489]\\d{7}",,,,"321234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"22\\d{7}",,,,"221234567"],"MG",
261,"00","0",,,"0|([24-9]\\d{6})$","20$1",,,[[,"(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MH:[,[,,"329\\d{4}|(?:[256]\\d|45)\\d{5}",,,,,,,[7]],[,,"(?:247|528|625)\\d{4}",,,,"2471234"],[,,"(?:(?:23|54)5|329|45[56])\\d{4}",,,,"2351234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"635\\d{4}",,,,"6351234"],"MH",692,"011","1",,,"1",,,,[[,"(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],,[,,,,,,,,
,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MK:[,[,,"[2-578]\\d{7}",,,,,,,[8],[6,7]],[,,"(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[23]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}",,,,"22012345",,,,[6,7]],[,,"7(?:3555|4(?:60\\d|747)|94(?:[01]\\d|2[0-4]))\\d{3}|7(?:[0-25-8]\\d|3[1-4]|42|9[23])\\d{5}",,,,"72345678"],[,,"800\\d{5}",,,,"80012345"],[,,"5[02-9]\\d{6}",,,,"50012345"],
[,,"8(?:0[1-9]|[1-9]\\d)\\d{5}",,,,"80123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MK",389,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2|34[47]|4(?:[37]7|5[47]|64)"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],[,"(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ML:[,[,,"[24-9]\\d{7}",,,,,,,[8]],[,,"2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}",,,,"20212345"],
[,,"2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[239])\\d{6}",,,,"65012345"],[,,"80\\d{6}",,,,"80012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ML",223,"00",,,,,,,,[[,"(\\d{4})","$1",["67[057-9]|74[045]","67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]],[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]],[,,,,,,,,,[-1]],,,[,,"80\\d{6}"],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MM:[,[,,"1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
,,,,,,[6,7,8,9,10],[5]],[,,"(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[2-469]|39|46|6[25]|7[0-3]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|2[246]|39|46|62|7[0-3]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[0-3])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|247[23]|3(?:20\\d|470)|4(?:2[04]\\d|47[23])|7(?:(?:3\\d|8[01459])\\d|4(?:39|60|7[013]))))\\d{4}|5(?:2(?:2\\d{5,6}|47[023]\\d{4})|(?:347[23]|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[0-2])|8(?:20\\d|47[02])|9(?:20\\d|47[01]))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:2\\d|4[1-9]|51)\\d|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
,,,"1234567",,,[6,7,8,9],[5]],[,,"(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}",,,,"92123456",,,[7,8,9,10]],[,,"80080(?:[01][1-9]|2\\d)\\d{3}",,,,"8008001234",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"1333\\d{4}|[12]468\\d{4}",,,,"13331234",,,[8]],"MM",95,"00","0",,,"0",,,,[[,"(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{3})",
"$1 $2 $3",["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],"0$1"],[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],[,"(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],[,"(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],,[,,,
,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MN:[,[,,"[12]\\d{7,9}|[57-9]\\d{7}",,,,,,,[8,9,10],[4,5,6]],[,,"[12]2[1-3]\\d{5,6}|7(?:0[0-5]\\d|128)\\d{4}|(?:[12](?:1|27)|5[368])\\d{6}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}",,,,"53123456",,,,[4,5,6]],[,,"(?:83[01]|920)\\d{5}|(?:5[05]|8[05689]|9[013-9])\\d{6}",,,,"88123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"712[0-79]\\d{4}|7(?:1[013-9]|[5-8]\\d)\\d{5}",,,,"75123456",,,[8]],"MN",976,"001",
"0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],[,"(\\d{4})(\\d{4})","$1 $2",["[57-9]"]],[,"(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],[,"(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],[,"(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MO:[,[,,"0800\\d{3}|(?:28|[68]\\d)\\d{6}",,,,,,,[7,8]],[,,"(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",
,,,"28212345",,,[8]],[,,"6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}",,,,"66123456",,,[8]],[,,"0800\\d{3}",,,,"0800501",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MO",853,"00",,,,,,,,[[,"(\\d{4})(\\d{3})","$1 $2",["0"]],[,"(\\d{4})(\\d{4})","$1 $2",["[268]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MP:[,[,,"[58]\\d{9}|(?:67|90)0\\d{7}",,,,,,,[10],[7]],[,,"670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
,,,"6702345678",,,,[7]],[,,"670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",,,,"6702345678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"MP",1,"011","1",,,"1|([2-9]\\d{6})$","670$1",,1,,,[,,,,,,,,,[-1]],,"670",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MQ:[,[,,"(?:69|80)\\d{7}|(?:59|97)6\\d{6}",,,,,,,[9]],[,,"596(?:[04-7]\\d|10|2[7-9]|3[04-9]|8[09]|9[4-9])\\d{4}",,,,"596301234"],[,,"69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}",,,,"696201234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"976(?:6\\d|7[0-367])\\d{4}",,,,"976612345"],"MQ",596,"00","0",,,"0",
,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MR:[,[,,"(?:[2-4]\\d\\d|800)\\d{5}",,,,,,,[8]],[,,"(?:25[08]|35\\d|45[1-7])\\d{5}",,,,"35123456"],[,,"[2-4][0-46-9]\\d{6}",,,,"22123456"],[,,"800\\d{5}",,,,"80012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MR",222,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",
["[2-48]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MS:[,[,,"(?:[58]\\d\\d|664|900)\\d{7}",,,,,,,[10],[7]],[,,"6644(?:1[0-3]|91)\\d{4}",,,,"6644912345",,,,[7]],[,,"664(?:3(?:49|9[1-6])|49[2-6])\\d{4}",,,,"6644923456",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"MS",1,"011","1",,,"1|([34]\\d{6})$","664$1",,,,,[,,,,,,,,,[-1]],,"664",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MT:[,[,,"3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",,,,,,,[8]],[,,"20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}",,,,"21001234"],[,,"(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}",,,,"96961234"],[,,"800[3467]\\d{4}",,,,"80071234"],[,,"5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",,,,"50037123"],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"3550\\d{4}",,,,"35501234"],"MT",356,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]],,[,,"7117\\d{4}",,,,"71171234"],,,[,,,,,,,,,[-1]],[,,"501\\d{5}",,,,"50112345"],,,[,,,,,,,,,[-1]]],MU:[,[,,"(?:5|8\\d\\d)\\d{7}|[2-468]\\d{6}",,,,,,,[7,8,10]],[,,"(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-7])|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}",,,,"54480123",,,[7,8]],[,,"5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])\\d{5}",
,,,"52512345",,,[8]],[,,"802\\d{7}|80[0-2]\\d{4}",,,,"8001234",,,[7,10]],[,,"30\\d{5}",,,,"3012345",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"3(?:20|9\\d)\\d{4}",,,,"3201234",,,[7]],"MU",230,"0(?:0|[24-7]0|3[03])",,,,,,"020",,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],[,"(\\d{4})(\\d{4})","$1 $2",["5"]],[,"(\\d{5})(\\d{5})","$1 $2",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MV:[,[,,"(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",,,,,,,[7,10]],[,,"(?:3(?:0[0-3]|3[0-59])|6(?:[57][02468]|6[024-68]|8[024689]))\\d{4}",
,,,"6701234",,,[7]],[,,"46[46]\\d{4}|(?:7\\d|9[13-9])\\d{5}",,,,"7712345",,,[7]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,"900\\d{7}",,,,"9001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MV",960,"0(?:0|19)",,,,,,"00",,[[,"(\\d{3})(\\d{4})","$1-$2",["[3467]|9[13-9]"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"4[05]0\\d{4}",,,,"4001234",,,[7]],,,[,,,,,,,,,[-1]]],MW:[,[,,"(?:[19]\\d|[23]1|77|88)\\d{7}|1\\d{6}",,,,,,,[7,9]],[,,"(?:1[2-9]|21\\d\\d)\\d{5}",
,,,"1234567"],[,,"111\\d{6}|(?:31|77|88|9[89])\\d{7}",,,,"991234567",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MW",265,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MX:[,[,,"1(?:(?:44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[017]\\d|[235][1-9]|4[0-35-9]|6[0-46-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}",
,,,,,,[10,11],[7,8]],[,,"6571\\d{6}|(?:2(?:0[01]|2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}",,,,"2001234567",,,[10],[7,8]],[,,"6571\\d{6}|(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}",
,,,"12221234567",,,,[7,8]],[,,"8(?:00|88)\\d{7}",,,,"8001234567",,,[10]],[,,"900\\d{7}",,,,"9001234567",,,[10]],[,,"300\\d{7}",,,,"3001234567",,,[10]],[,,"500\\d{7}",,,,"5001234567",,,[10]],[,,,,,,,,,[-1]],"MX",52,"0[09]","01",,,"0(?:[12]|4[45])|1",,"00",,[[,"(\\d{5})","$1",["53"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],,,1],[,"(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],,,1],[,"(\\d)(\\d{3})(\\d{3})(\\d{4})",
"$2 $3 $4",["1"],,,1]],[[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],,,1],[,"(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],,,1],[,"(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 $3 $4",["1"],,,1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MY:[,[,,"1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",,,,,,,[8,9,10],[6,7]],[,,"(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}",
,,,"323856789",,,[8,9],[6,7]],[,,"1(?:1888[69]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0134]\\d|2[1-9]|5[0-6]))|(?:(?:[269]|59)\\d|[37][1-9]|4[235-9])\\d|8(?:1[23]|[236]\\d|4[06]|5[7-9]|7[016-9]|8[01]|9[0-8]))\\d{5}",,,,"123456789",,,[9,10]],[,,"1[378]00\\d{6}",,,,"1300123456",,,[10]],[,,"1600\\d{6}",,,,"1600123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}",
,,,"1546012345",,,[10]],"MY",60,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9])|8"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],[,"(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1[36-8]"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MZ:[,[,,"(?:2|8\\d)\\d{7}",
,,,,,,[8,9]],[,,"2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}",,,,"21123456",,,[8]],[,,"8[2-79]\\d{7}",,,,"821234567",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MZ",258,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NA:[,[,,"[68]\\d{7,8}",,,,,,,[8,9]],[,,"64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}",
,,,"61221234"],[,,"(?:60|8[1245])\\d{7}",,,,"811234567",,,[9]],[,,"80\\d{7}",,,,"800123456",,,[9]],[,,"8701\\d{5}",,,,"870123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"8(?:3\\d\\d|86)\\d{5}",,,,"88612345"],"NA",264,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,
[-1]],,,[,,,,,,,,,[-1]]],NC:[,[,,"[2-57-9]\\d{5}",,,,,,,[6]],[,,"(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}",,,,"201234"],[,,"(?:5[0-4]|[79]\\d|8[0-79])\\d{4}",,,,"751234"],[,,,,,,,,,[-1]],[,,"36\\d{4}",,,,"366711"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NC",687,"00",,,,,,,,[[,"(\\d{3})","$1",["5[6-8]"]],[,"(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[2-57-9]"]]],[[,"(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[2-57-9]"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NE:[,[,,"[027-9]\\d{7}",
,,,,,,[8]],[,,"2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}",,,,"20201234"],[,,"(?:23|7[04]|[89]\\d)\\d{6}",,,,"93123456"],[,,"08\\d{6}",,,,"08123456"],[,,"09\\d{6}",,,,"09123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NE",227,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]|7[04]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NF:[,[,
,"[13]\\d{5}",,,,,,,[6],[5]],[,,"(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}",,,,"106609",,,,[5]],[,,"(?:14|3[58])\\d{4}",,,,"381234",,,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NF",672,"00",,,,"([0-258]\\d{4})$","3$1",,,[[,"(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],[,"(\\d)(\\d{5})","$1 $2",["[13]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NG:[,[,,"(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",,,,,,,[7,8,10,11,12,13,14],[5,6]],
[,,"(?:(?:[1-356]\\d|4[02-8]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|7(?:0(?:[013-689]\\d|2[0-24-9])\\d{3,4}|[1-79]\\d{6})|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[1-3578])\\d{5}",,,,"18040123",,,[7,8],[5,6]],[,,"(?:702[0-24-9]|8(?:01|19)[01])\\d{6}|(?:70[13-689]|8(?:0[2-9]|1[0-8])|9(?:0[1-9]|1[2356]))\\d{7}",,,,"8021234567",,,[10]],[,,"800\\d{7,11}",,,,"80017591759",,,[10,11,12,13,14]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NG",234,"009","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{3})",
"$1 $2 $3",["78"],"0$1"],[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-7]|8[2-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[7-9]"],"0$1"],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],[,"(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"700\\d{7,11}",,,,"7001234567",,,[10,11,12,13,14]],,,[,,,,,,,,,[-1]]],NI:[,[,,"(?:1800|[25-8]\\d{3})\\d{4}",,,,,,,[8]],[,,"2\\d{7}",
,,,"21234567"],[,,"(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}",,,,"81234567"],[,,"1800\\d{4}",,,,"18001234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NI",505,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NL:[,[,,"(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}",,,,,,,[5,6,7,8,9,10]],[,,"(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
,,,"101234567",,,[9]],[,,"6[1-58]\\d{7}",,,,"612345678",,,[9]],[,,"800\\d{4,7}",,,,"8001234",,,[7,8,9,10]],[,,"90[069]\\d{4,7}",,,,"9061234",,,[7,8,9,10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:85|91)\\d{7}",,,,"851234567",,,[9]],"NL",31,"00","0",,,"0",,,,[[,"(\\d{4})","$1",["1[238]|[34]"]],[,"(\\d{2})(\\d{3,4})","$1 $2",["14"]],[,"(\\d{6})","$1",["1"]],[,"(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],[,"(\\d)(\\d{8})","$1 $2",["6"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})",
"$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-57-9]"],"0$1"]],[[,"(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],[,"(\\d)(\\d{8})","$1 $2",["6"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-57-9]"],"0$1"]],[,,"66\\d{7}",,,,"662345678",,,[9]],,,[,,"140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d",
,,,,,,[5,6]],[,,"140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d",,,,"14020",,,[5,6,9]],,,[,,,,,,,,,[-1]]],NO:[,[,,"(?:0|[2-9]\\d{3})\\d{4}",,,,,,,[5,8]],[,,"(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}",,,,"21234567",,,[8]],[,,"(?:4[015-8]|59|9\\d)\\d{6}",,,,"40612345",,,[8]],[,,"80[01]\\d{5}",,,,"80012345",,,[8]],[,,"82[09]\\d{5}",,,,"82012345",,,[8]],[,,"810(?:0[0-6]|[2-8]\\d)\\d{3}",,,,"81021234",,,[8]],[,,"880\\d{5}",
,,,"88012345",,,[8]],[,,"85[0-5]\\d{5}",,,,"85012345",,,[8]],"NO",47,"00",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[489]|59"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],,[,,,,,,,,,[-1]],1,"[02-689]|7[0-8]",[,,,,,,,,,[-1]],[,,"(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",,,,"02000"],,,[,,"81[23]\\d{5}",,,,"81212345",,,[8]]],NP:[,[,,"(?:1\\d|9)\\d{9}|[1-9]\\d{7}",,,,,,,[8,10,11],[6,7]],[,,"(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}",
,,,"14567890",,,[8],[6,7]],[,,"9(?:6[0-3]|7[245]|8[0-24-68])\\d{7}",,,,"9841234567",,,[10]],[,,"1(?:66001|800\\d\\d)\\d{5}",,,,"16600101234",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NP",977,"00","0",,,"0",,,,[[,"(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],[,"(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-579]|6[2-6])"],"0$1"],[,"(\\d{3})(\\d{7})","$1-$2",["9"]],[,"(\\d{4})(\\d{2})(\\d{5})","$1-$2-$3",["1"]]],[[,"(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],[,"(\\d{2})(\\d{6})",
"$1-$2",["1[01]|[2-8]|9(?:[1-579]|6[2-6])"],"0$1"],[,"(\\d{3})(\\d{7})","$1-$2",["9"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NR:[,[,,"(?:444|(?:55|8\\d)\\d|666)\\d{4}",,,,,,,[7]],[,,"444\\d{4}",,,,"4441234"],[,,"(?:55[3-9]|666|8\\d\\d)\\d{4}",,,,"5551234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NR",674,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],
NU:[,[,,"(?:[47]|888\\d)\\d{3}",,,,,,,[4,7]],[,,"[47]\\d{3}",,,,"7012",,,[4]],[,,"888[4-9]\\d{3}",,,,"8884012",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NU",683,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NZ:[,[,,"[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",,,,,,,[5,6,7,8,9,10]],[,,"24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}",
,,,"32345678",,,[8],[7]],[,,"2[0-27-9]\\d{7,8}|21\\d{6}",,,,"211234567",,,[8,9,10]],[,,"508\\d{6,7}|80\\d{6,8}",,,,"800123456",,,[8,9,10]],[,,"(?:11\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}",,,,"900123456",,,[7,8,9,10]],[,,,,,,,,,[-1]],[,,"70\\d{7}",,,,"701234567",,,[9]],[,,,,,,,,,[-1]],"NZ",64,"0(?:0|161)","0",,,"0",,"00",,[[,"(\\d{2})(\\d{3,8})","$1 $2",["8[1-579]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[036-8]|[89]0","50(?:[0367]|88)|[89]0"],"0$1"],[,"(\\d)(\\d{3})(\\d{4})",
"$1-$2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[59]|80"],"0$1"],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7|86"],"0$1"]],,[,,"[28]6\\d{6,7}",,,,"26123456",,,[8,9]],,,[,,,,,,,,,[-1]],[,,"8(?:1[6-9]|22|3\\d|4[045]|5[459]|7[0-3579]|90)\\d{2,7}",,,,"83012378"],,,[,,,,,,,,,[-1]]],OM:[,[,,"(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",,,,,,,[7,8,9]],[,,"2[2-6]\\d{6}",
,,,"23123456",,,[8]],[,,"1505\\d{4}|(?:7(?:[1289]\\d|70)|9(?:0[1-9]|[1-9]\\d))\\d{5}",,,,"92123456",,,[8]],[,,"8007\\d{4,5}|(?:500|800[05])\\d{4}",,,,"80071234"],[,,"900\\d{5}",,,,"90012345",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"OM",968,"00",,,,,,,,[[,"(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],[,"(\\d{2})(\\d{6})","$1 $2",["2"]],[,"(\\d{4})(\\d{4})","$1 $2",["[179]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PA:[,[,,"(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
,,,,,,[7,8,10,11]],[,,"(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[58]|7[0167]|8[258]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[089]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[05]|6[068]|7[0-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[056]|7[0-24-9]|8[6-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",,,,"2001234",,,[7]],[,,"(?:1[16]1|21[89]|6(?:[02-9]\\d|1[0-8])\\d|8(?:1[01]|7[23]))\\d{4}",
,,,"61234567",,,[7,8]],[,,"800\\d{4,5}|(?:00800|800\\d)\\d{6}",,,,"8001234"],[,,"(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}",,,,"8601234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PA",507,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],[,"(\\d{4})(\\d{4})","$1-$2",["[68]"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PE:[,[,,"(?:[14-8]|9\\d)\\d{7}",,,,,,,[8,9],[6,7]],[,,"(?:(?:4[34]|5[14])[0-8]\\d|7(?:173|3[0-8]\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}",
,,,"11234567",,,[8],[6,7]],[,,"9\\d{8}",,,,"912345678",,,[9]],[,,"800\\d{5}",,,,"80012345",,,[8]],[,,"805\\d{5}",,,,"80512345",,,[8]],[,,"801\\d{5}",,,,"80112345",,,[8]],[,,"80[24]\\d{5}",,,,"80212345",,,[8]],[,,,,,,,,,[-1]],"PE",51,"19(?:1[124]|77|90)00","0"," Anexo ",,"0",,,,[[,"(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],[,"(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],[,"(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,
,,,,,[-1]],,,[,,,,,,,,,[-1]]],PF:[,[,,"4\\d{5}(?:\\d{2})?|8\\d{7,8}",,,,,,,[6,8,9]],[,,"4(?:0[4-689]|9[4-68])\\d{5}",,,,"40412345",,,[8]],[,,"8[7-9]\\d{6}",,,,"87123456",,,[8]],[,,"80[0-5]\\d{6}",,,,"800012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"499\\d{5}",,,,"49901234",,,[8]],"PF",689,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4|8[7-9]"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]],,[,,,
,,,,,,[-1]],,,[,,"44\\d{4}",,,,,,,[6]],[,,"44\\d{4}",,,,"440123",,,[6]],,,[,,,,,,,,,[-1]]],PG:[,[,,"(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",,,,,,,[7,8]],[,,"(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}",,,,"3123456",,,[7]],[,,"(?:7\\d|8[18])\\d{6}",,,,"70123456",,,[8]],[,,"180\\d{4}",,,,"1801234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"2(?:0[0-47]|7[568])\\d{4}",,,,"2751234",,,[7]],"PG",675,"00|140[1-3]",,,,,,"00",,[[,"(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],
[,"(\\d{4})(\\d{4})","$1 $2",["[78]"]]],,[,,"27[01]\\d{4}",,,,"2700123",,,[7]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PH:[,[,,"(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",,,,,,,[6,8,9,10,11,12,13],[4,5,7]],[,,"(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",,,,"232345678",,,[6,8,9,10],[4,5,7]],[,,"(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}",,,,"9051234567",,,[10]],[,,"1800\\d{7,9}",
,,,"180012345678",,,[11,12,13]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PH",63,"00","0",,,"0",,,,[[,"(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],[,"(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],[,"(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],[,"(\\d)(\\d{4})(\\d{4})",
"$1 $2 $3",["2"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],[,"(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PK:[,[,,"122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",,,,,,
,[8,9,10,11,12],[5,6,7]],[,,"(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}",,,,"2123456789",,,[9,10],[5,6,7,8]],[,,"3(?:[014]\\d|2[0-5]|3[0-7]|55|64)\\d{7}",,,,"3012345678",,,[10]],[,,"800\\d{5}(?:\\d{3})?",,,,"80012345",,,[8,11]],[,,"900\\d{5}",,,,"90012345",,,[8]],[,,,,,,,,,[-1]],[,,"122\\d{6}",
,,,"122044444",,,[9]],[,,,,,,,,,[-1]],"PK",92,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{2,7})","$1 $2 $3",["[89]0"],"0$1"],[,"(\\d{4})(\\d{5})","$1 $2",["1"]],[,"(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],
"(0$1)"],[,"(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],[,"(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],[,"(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
,,,"21111825888",,,[11,12]],,,[,,,,,,,,,[-1]]],PL:[,[,,"6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?",,,,,,,[6,7,8,9,10]],[,,"47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))",,,,"123456789",,,[7,9]],[,,"211(?:1\\d|3[1-5])\\d{4}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}",,,,"512345678",,,[9]],[,,"800\\d{6,7}",,,,"800123456",,,[9,10]],[,,"70[01346-8]\\d{6}",,,,"701234567",,,[9]],[,,"801\\d{6}",,,,"801234567",
,,[9]],[,,,,,,,,,[-1]],[,,"39\\d{7}",,,,"391234567",,,[9]],"PL",48,"00",,,,,,,,[[,"(\\d{5})","$1",["19"]],[,"(\\d{3})(\\d{3})","$1 $2",["11|64"]],[,"(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],[,"(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]],,[,,"64\\d{4,7}",,,,"641234567",,,[6,7,8,9]],,,[,,,,,,,,,[-1]],[,,"804\\d{6}",,,,"804123456",,,[9]],,,[,,,,,,,,,[-1]]],PM:[,[,,"(?:[45]|80\\d\\d)\\d{5}",,,,,,,[6,9]],[,,"(?:4[1-3]|50)\\d{4}",,,,"430123",,,[6]],[,,"(?:4[02-4]|5[05])\\d{4}",,,,"551234",,,[6]],[,,"80[0-5]\\d{6}",,,,"800012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PM",508,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3",["[45]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PR:[,[,,"(?:[589]\\d\\d|787)\\d{7}",,,,,,,[10],[7]],[,,"(?:787|939)[2-9]\\d{6}",,,,"7872345678",,,,[7]],[,,"(?:787|939)[2-9]\\d{6}",,,,"7872345678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"PR",1,"011","1",,,"1",,,1,,,[,,,,,,,,,[-1]],,"787|939",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PS:[,[,,"[2489]2\\d{6}|(?:1\\d|5)\\d{8}",,,,,,,[8,9,10],[7]],[,,"(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}",,,,"22234567",,,[8],[7]],[,,"5[69]\\d{7}",,,,"599123456",,,[9]],[,,"1800\\d{6}",,,,"1800123456",,,[10]],[,,,,,,,,,[-1]],[,,"1700\\d{6}",,,,"1700123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PS",970,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",
["[2489]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PT:[,[,,"1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",,,,,,,[9]],[,,"2(?:[12]\\d|[35][1-689]|4[1-59]|6[1-35689]|7[1-9]|8[1-69]|9[1256])\\d{6}",,,,"212345678"],[,,"6[0356]92(?:30|9\\d)\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}",,,,"912345678"],[,,"80[02]\\d{6}",,,,"800123456"],[,,"(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}",
,,,"760123456"],[,,"80(?:8\\d|9[1579])\\d{5}",,,,"808123456"],[,,"884[0-4689]\\d{5}",,,,"884123456"],[,,"30\\d{7}",,,,"301234567"],"PT",351,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["16|[236-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"70(?:7\\d|8[17])\\d{5}",,,,"707123456"],,,[,,"600\\d{6}",,,,"600110000"]],PW:[,[,,"(?:[24-8]\\d\\d|345|900)\\d{4}",,,,,,,[7]],[,,"(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}",
,,,"2771234"],[,,"(?:46[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}",,,,"6201234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PW",680,"01[12]",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PY:[,[,,"59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",,,,,,,[6,7,8,9,10,11],[5]],[,,"(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
,,,"212345678",,,[7,8,9],[5,6]],[,,"9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}",,,,"961456789",,,[9]],[,,"9800\\d{5,7}",,,,"98000123456",,,[9,10,11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"8700[0-4]\\d{4}",,,,"870012345",,,[9]],"PY",595,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],[,"(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],[,"(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{3,4})",
"$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],[,"(\\d{3})(\\d{6})","$1 $2",["9(?:[5-79]|8[1-6])"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"[2-9]0\\d{4,7}",,,,"201234567",,,[6,7,8,9]],,,[,,,,,,,,,[-1]]],QA:[,[,,"[2-7]\\d{7}|800\\d{4}(?:\\d{2})?|2\\d{6}",,,,,,,[7,8,9]],[,,"4141\\d{4}|(?:23|4[04])\\d{6}",,,,"44123456",
,,[8]],[,,"(?:28|[35-7]\\d)\\d{6}",,,,"33123456",,,[8]],[,,"800\\d{4}(?:\\d{2})?",,,,"8001234",,,[7,9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"QA",974,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["2[126]|8"]],[,"(\\d{4})(\\d{4})","$1 $2",["[2-7]"]]],,[,,"2(?:[12]\\d|61)\\d{4}",,,,"2123456",,,[7]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],RE:[,[,,"9769\\d{5}|(?:26|[68]\\d)\\d{7}",,,,,,,[9]],[,,"26(?:2\\d\\d|30[0-5])\\d{4}",,,,"262161234"],[,,"(?:69(?:2\\d\\d|3(?:[06][0-46]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-27]|8[0-8]|9[0-479]))|9769\\d)\\d{4}",
,,,"692123456"],[,,"80\\d{7}",,,,"801234567"],[,,"89[1-37-9]\\d{6}",,,,"891123456"],[,,"8(?:1[019]|2[0156]|84|90)\\d{6}",,,,"810123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"RE",262,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"],"0$1"]],,[,,,,,,,,,[-1]],1,"26[23]|69|[89]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],RO:[,[,,"(?:[2378]\\d|90)\\d{7}|[23]\\d{5}",,,,,,,[6,9]],[,,"[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d",,,,"211234567"],[,,"7020\\d{5}|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[019])\\d{6}",
,,,"712034567",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"90[0136]\\d{6}",,,,"900123456",,,[9]],[,,"801\\d{6}",,,,"801123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"RO",40,"00","0"," int ",,"0",,,,[[,"(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],[,"(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[237-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:37\\d|80[578])\\d{6}",,,,"372123456",
,,[9]],,,[,,,,,,,,,[-1]]],RS:[,[,,"38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",,,,,,,[6,7,8,9,10,11,12],[4,5]],[,,"(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}",,,,"10234567",,,[7,8,9,10,11,12],[4,5,6]],[,,"6(?:[0-689]|7\\d)\\d{6,7}",,,,"601234567",,,[8,9,10]],[,,"800\\d{3,9}",,,,"80012345"],[,,"(?:78\\d|90[0169])\\d{3,7}",,,,"90012345",,,[6,7,8,9,10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,
,,,,,,,,[-1]],"RS",381,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],[,"(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"7[06]\\d{4,10}",,,,"700123456"],,,[,,,,,,,,,[-1]]],RU:[,[,,"8\\d{13}|[347-9]\\d{9}",,,,,,,[10,14],[7]],[,,"(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}",,,,"3011234567",,,[10],[7]],[,,"9\\d{9}",
,,,"9123456789",,,[10]],[,,"8(?:0[04]|108\\d{3})\\d{7}",,,,"8001234567"],[,,"80[39]\\d{7}",,,,"8091234567",,,[10]],[,,,,,,,,,[-1]],[,,"808\\d{7}",,,,"8081234567",,,[10]],[,,,,,,,,,[-1]],"RU",7,"810","8",,,"8",,"8~10",,[[,"(\\d{3})(\\d{2})(\\d{2})","$1-$2-$3",["[0-79]"]],[,"(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",,1],[,"(\\d{5})(\\d)(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",,1],[,"(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
"$1 $2 $3 $4",["8"],"8 ($1)"]],[[,"(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",,1],[,"(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],
"8 ($1)",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",,1],[,"(\\d{4})(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["8"],"8 ($1)"]],[,,,,,,,,,[-1]],1,"3[04-689]|[489]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],RW:[,[,,"(?:06|[27]\\d\\d|[89]00)\\d{6}",,,,,,,[8,9]],[,,"(?:06|2[23568]\\d)\\d{6}",,,,"250123456"],[,,"7[2389]\\d{7}",,,,"720123456",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,
"900\\d{6}",,,,"900123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"RW",250,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SA:[,[,,"92\\d{7}|(?:[15]|8\\d)\\d{8}",,,,,,,[9,10],[7]],[,,"1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}",,,,"112345678",,,[9],[7]],[,,"579[01]\\d{5}|5(?:[013-689]\\d|7[0-36-8])\\d{6}",
,,,"512345678",,,[9]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,"925\\d{6}",,,,"925012345",,,[9]],[,,"920\\d{6}",,,,"920012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SA",966,"00","0",,,"0",,,,[[,"(\\d{4})(\\d{5})","$1 $2",["9"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"811\\d{7}",,,,"8110123456",
,,[10]],,,[,,,,,,,,,[-1]]],SB:[,[,,"(?:[1-6]|[7-9]\\d\\d)\\d{4}",,,,,,,[5,7]],[,,"(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}",,,,"40123",,,[5]],[,,"48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}",,,,"7421234"],[,,"1[38]\\d{3}",,,,"18123",,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"5[12]\\d{3}",,,,"51123",,,[5]],"SB",677,"0[01]",,,,,,,,[[,"(\\d{2})(\\d{5})","$1 $2",["7|8[4-9]|9(?:[1-8]|9[0-8])"]]],,[,,,,,,,,,[-1]],,,
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SC:[,[,,"8000\\d{3}|(?:[249]\\d|64)\\d{5}",,,,,,,[7]],[,,"4[2-46]\\d{5}",,,,"4217123"],[,,"2[5-8]\\d{5}",,,,"2510123"],[,,"8000\\d{3}",,,,"8000000"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"971\\d{4}|(?:64|95)\\d{5}",,,,"6412345"],"SC",248,"010|0[0-2]",,,,,,"00",,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SD:[,[,,"[19]\\d{8}",,,,,,,[9]],[,,"1(?:5\\d|8[35-7])\\d{6}",
,,,"153123456"],[,,"(?:1[0-2]|9[0-3569])\\d{7}",,,,"911231234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SD",249,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SE:[,[,,"(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",,,,,,,[6,7,8,9,10,12]],[,,"(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
,,,"8123456",,,[7,8,9]],[,,"7[02369]\\d{7}",,,,"701234567",,,[9]],[,,"20\\d{4,7}",,,,"20123456",,,[6,7,8,9]],[,,"649\\d{6}|9(?:00|39|44)[1-8]\\d{3,6}",,,,"9001234567",,,[7,8,9,10]],[,,"77[0-7]\\d{6}",,,,"771234567",,,[9]],[,,"75[1-8]\\d{6}",,,,"751234567",,,[9]],[,,,,,,,,,[-1]],"SE",46,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1"],[,"(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44)"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],"0$1"],
[,"(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1"],[,"(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1"],[,"(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1"],[,"(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{2})",
"$1-$2 $3 $4",["8"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1"]],[[,"(\\d{2})(\\d{2,3})(\\d{2})","$1 $2 $3",["20"]],[,"(\\d{3})(\\d{4})","$1 $2",["9(?:00|39|44)"]],[,"(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"]],[,"(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["8"]],[,"(\\d{3})(\\d{2,3})(\\d{2})","$1 $2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]],[,"(\\d{3})(\\d{2,3})(\\d{3})","$1 $2 $3",["9(?:00|39|44)"]],[,"(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"]],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["10|7"]],[,"(\\d)(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["8"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["9"]],[,"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]"]]],[,,"74[02-9]\\d{6}",,,,"740123456",,,[9]],,,[,,,,,,,,,[-1]],[,,"10[1-8]\\d{6}",,,,"102345678",,,[9]],,,[,,"(?:25[245]|67[3-68])\\d{9}",,,,"254123456789",,,[12]]],SG:[,[,,"(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",,,,,,,[8,10,11]],[,,"662[0-24-9]\\d{4}|6(?:[1-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
,,,"61234567",,,[8]],[,,"895[0-2]\\d{4}|(?:8(?:0[1-4]|[1-8]\\d|9[0-4])|9[0-8]\\d)\\d{5}",,,,"81234567",,,[8]],[,,"(?:18|8)00\\d{7}",,,,"18001234567",,,[10,11]],[,,"1900\\d{7}",,,,"19001234567",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:3[12]\\d|666)\\d{5}",,,,"31234567",,,[8]],"SG",65,"0[0-3]\\d",,,,,,,,[[,"(\\d{4,5})","$1",["1[013-9]|77","1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"]],[,"(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-4]|[1-9])"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],[,"(\\d{4})(\\d{4})(\\d{3})",
"$1 $2 $3",["7"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]],[[,"(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-4]|[1-9])"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],[,"(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"7000\\d{7}",,,,"70001234567",,,[11]],,,[,,,,,,,,,[-1]]],SH:[,[,,"(?:[256]\\d|8)\\d{3}",,,,,,,[4,5]],[,,"2(?:[0-57-9]\\d|6[4-9])\\d\\d",,,,"22158"],[,,"[56]\\d{4}",,,,"51234",,,[5]],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"262\\d\\d",,,,"26212",,,[5]],"SH",290,"00",,,,,,,,,,[,,,,,,,,,[-1]],1,"[256]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SI:[,[,,"[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",,,,,,,[5,6,7,8]],[,,"(?:[1-357][2-8]|4[24-8])\\d{6}",,,,"12345678",,,[8],[7]],[,,"65(?:1\\d|55|[67]0)\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}",,,,"31234567",,,[8]],[,,"80\\d{4,6}",,,,"80123456",,,[6,7,8]],[,,"89[1-3]\\d{2,5}|90\\d{4,6}",,,,"90123456"],[,,,,,,,,,[-1]],[,,,,,
,,,,[-1]],[,,"(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-489])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}",,,,"59012345",,,[8]],"SI",386,"00|10(?:22|66|88|99)","0",,,"0",,"00",,[[,"(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],[,"(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],[,"(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SJ:[,[,,"0\\d{4}|(?:[489]\\d|[57]9)\\d{6}",
,,,,,,[5,8]],[,,"79\\d{6}",,,,"79123456",,,[8]],[,,"(?:4[015-8]|59|9\\d)\\d{6}",,,,"41234567",,,[8]],[,,"80[01]\\d{5}",,,,"80012345",,,[8]],[,,"82[09]\\d{5}",,,,"82012345",,,[8]],[,,"810(?:0[0-6]|[2-8]\\d)\\d{3}",,,,"81021234",,,[8]],[,,"880\\d{5}",,,,"88012345",,,[8]],[,,"85[0-5]\\d{5}",,,,"85012345",,,[8]],"SJ",47,"00",,,,,,,,,,[,,,,,,,,,[-1]],,"79",[,,,,,,,,,[-1]],[,,"(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",,,,"02000"],,,[,,"81[23]\\d{5}",,,,"81212345",,,[8]]],SK:[,[,,"[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
,,,,,,[6,7,9]],[,,"(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d",,,,"221234567"],[,,"909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}",,,,"912123456",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"9(?:00|[78]\\d)\\d{6}",,,,"900123456",,,[9]],[,,"8[5-9]\\d{7}",,,,"850123456",,,[9]],[,,,,,,,,,[-1]],[,,"6(?:02|5[0-4]|9[0-6])\\d{6}",,,,"690123456",,,[9]],"SK",421,"00","0",,,"0",,,,[[,"(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",
["21"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],[,"(\\d{4})(\\d{3})","$1 $2",["909","9090"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],[[,"(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{2})",
"$1/$2 $3 $4",["2"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],[,,"9090\\d{3}",,,,"9090123",,,[7]],,,[,,"9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}",,,,,,,[7,9]],[,,"96\\d{7}",,,,"961234567",,,[9]],,,[,,,,,,,,,[-1]]],SL:[,[,,"(?:[237-9]\\d|66)\\d{6}",,,,,,,[8],[6]],[,,"22[2-4][2-9]\\d{4}",,,,"22221234",,,,[6]],[,,"(?:25|3[0-5]|66|7[3-9]|8[08]|9[09])\\d{6}",,,,"25123456"],[,,,,,,,,,[-1]],[,,,,,
,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SL",232,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SM:[,[,,"(?:0549|[5-7]\\d)\\d{6}",,,,,,,[8,10],[6]],[,,"0549(?:8[0157-9]|9\\d)\\d{4}",,,,"0549886377",,,[10],[6]],[,,"6[16]\\d{6}",,,,"66661212",,,[8]],[,,,,,,,,,[-1]],[,,"7[178]\\d{6}",,,,"71123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"5[158]\\d{6}",,,,"58001110",,,[8]],"SM",378,"00",,,
,"([89]\\d{5})$","0549$1",,,[[,"(\\d{6})","$1",["[89]"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],[,"(\\d{4})(\\d{6})","$1 $2",["0"]]],[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],[,"(\\d{4})(\\d{6})","$1 $2",["0"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SN:[,[,,"(?:[378]\\d|93)\\d{7}",,,,,,,[9]],[,,"3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}",,,,"301012345"],[,,"75(?:01|[38]3)\\d{5}|7(?:[06-8]\\d|21|5[4-7]|90)\\d{6}",
,,,"701234567"],[,,"800\\d{6}",,,,"800123456"],[,,"88[4689]\\d{6}",,,,"884123456"],[,,"81[02468]\\d{6}",,,,"810123456"],[,,,,,,,,,[-1]],[,,"(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}",,,,"933301234"],"SN",221,"00",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SO:[,[,,"[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",,,,,,,[6,7,8,9]],[,,
"(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",,,,"4012345",,,[6,7]],[,,"(?:(?:15|(?:3[59]|4[89]|79|8[08])\\d|6(?:0[5-7]|[1-9]\\d)|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:6\\d|7[1-9])\\d{6}",,,,"71123456",,,[7,8,9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SO",252,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{4})","$1 $2",["8[125]"]],[,"(\\d{6})","$1",["[134]"]],[,"(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],[,"(\\d)(\\d{7})",
"$1 $2",["24|[67]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3478]|64|90"]],[,"(\\d{2})(\\d{5,7})","$1 $2",["1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SR:[,[,,"(?:[2-5]|68|[78]\\d)\\d{5}",,,,,,,[6,7]],[,,"(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}",,,,"211234"],[,,"(?:7[124-7]|8[124-9])\\d{5}",,,,"7412345",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"56\\d{4}",,,,"561234",,,[6]],"SR",597,"00",,,,,,,
,[[,"(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],[,"(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],[,"(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SS:[,[,,"[19]\\d{8}",,,,,,,[9]],[,,"1[89]\\d{7}",,,,"181234567"],[,,"(?:12|9[1257-9])\\d{7}",,,,"977123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SS",211,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,
,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ST:[,[,,"(?:22|9\\d)\\d{5}",,,,,,,[7]],[,,"22\\d{5}",,,,"2221234"],[,,"900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}",,,,"9812345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ST",239,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[29]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SV:[,[,,"[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",,,,,,,[7,8,11]],[,,"2(?:[1-6]\\d{3}|[79]90[034]|890[0245])\\d{3}",,,,"21234567",
,,[8]],[,,"66(?:[02-9]\\d\\d|1(?:[02-9]\\d|16))\\d{3}|(?:6[0-57-9]|7\\d)\\d{6}",,,,"70123456",,,[8]],[,,"800\\d{4}(?:\\d{4})?",,,,"8001234",,,[7,11]],[,,"900\\d{4}(?:\\d{4})?",,,,"9001234",,,[7,11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SV",503,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[89]"]],[,"(\\d{4})(\\d{4})","$1 $2",["[267]"]],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SX:[,[,,"7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
,,,,,,[10],[7]],[,,"7215(?:4[2-8]|8[239]|9[056])\\d{4}",,,,"7215425678",,,,[7]],[,,"7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}",,,,"7215205678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,
,"5002345678"],[,,,,,,,,,[-1]],"SX",1,"011","1",,,"1|(5\\d{6})$","721$1",,,,,[,,,,,,,,,[-1]],,"721",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SY:[,[,,"[1-39]\\d{8}|[1-5]\\d{7}",,,,,,,[8,9],[6,7]],[,,"21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}",,,,"112345678",,,,[6,7]],[,,"9(?:22|[3-689]\\d)\\d{6}",,,,"944567890",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SY",963,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})",
"$1 $2 $3",["[1-5]"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1",,1]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SZ:[,[,,"0800\\d{4}|(?:[237]\\d|900)\\d{6}",,,,,,,[8,9]],[,,"[23][2-5]\\d{6}",,,,"22171234",,,[8]],[,,"7[6-9]\\d{6}",,,,"76123456",,,[8]],[,,"0800\\d{4}",,,,"08001234",,,[8]],[,,"900\\d{6}",,,,"900012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"70\\d{6}",,,,"70012345",,,[8]],"SZ",268,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[0237]"]],[,
"(\\d{5})(\\d{4})","$1 $2",["9"]]],,[,,,,,,,,,[-1]],,,[,,"0800\\d{4}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TA:[,[,,"8\\d{3}",,,,,,,[4]],[,,"8\\d{3}",,,,"8999"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TA",290,"00",,,,,,,,,,[,,,,,,,,,[-1]],,"8",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TC:[,[,,"(?:[58]\\d\\d|649|900)\\d{7}",,,,,,,[10],[7]],[,,"649(?:266|712|9(?:4\\d|50))\\d{4}",,,,"6497121234",,,,[7]],[,,"649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}",
,,,"6492311234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,"649(?:71[01]|966)\\d{4}",,,,"6497101234",,,,[7]],"TC",1,"011","1",,,"1|([2-479]\\d{6})$","649$1",,,,,[,,,,,,,,
,[-1]],,"649",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TD:[,[,,"(?:22|[69]\\d|77)\\d{6}",,,,,,,[8]],[,,"22(?:[37-9]0|5[0-5]|6[89])\\d{4}",,,,"22501234"],[,,"(?:6[023568]|77|9\\d)\\d{6}",,,,"63012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TD",235,"00|16",,,,,,"00",,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2679]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TG:[,[,,"[279]\\d{7}",,,,,,,[8]],[,,"2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}",
,,,"22212345"],[,,"(?:7[09]|9[0-36-9])\\d{6}",,,,"90112345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TG",228,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TH:[,[,,"(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",,,,,,,[8,9,10,13]],[,,"(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}",,,,"21234567",,,[8]],[,,"671[0-8]\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}",,,,"812345678",
,,[9]],[,,"(?:001800\\d|1800)\\d{6}",,,,"1800123456",,,[10,13]],[,,"1900\\d{6}",,,,"1900123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"6[08]\\d{7}",,,,"601234567",,,[9]],"TH",66,"00[1-9]","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TJ:[,[,,"(?:00|[1-57-9]\\d)\\d{7}",,,,,,,[9],[3,5,6,7]],[,,"(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}",
,,,"372123456",,,,[3,5,6,7]],[,,"41[18]\\d{6}|(?:[034]0|1[01]|2[02]|5[05]|7[017]|8[08]|9\\d)\\d{7}",,,,"917123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TJ",992,"810",,,,,,"8~10",,[[,"(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"]],[,"(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[34]7|91[78]"]],[,"(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3[1-5]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[0-57-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,
,,[-1]]],TK:[,[,,"[2-47]\\d{3,6}",,,,,,,[4,5,6,7]],[,,"(?:2[2-4]|[34]\\d)\\d{2,5}",,,,"3101"],[,,"7[2-4]\\d{2,5}",,,,"7290"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TK",690,"00",,,,,,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TL:[,[,,"7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",,,,,,,[7,8]],[,,"(?:2[1-5]|3[1-9]|4[1-4])\\d{5}",,,,"2112345",,,[7]],[,,"7[2-8]\\d{6}",,,,"77212345",,,[8]],[,,"80\\d{5}",,,,"8012345",,,[7]],[,,"90\\d{5}",,,,"9012345",
,,[7]],[,,,,,,,,,[-1]],[,,"70\\d{5}",,,,"7012345",,,[7]],[,,,,,,,,,[-1]],"TL",670,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],[,"(\\d{4})(\\d{4})","$1 $2",["7"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TM:[,[,,"[1-6]\\d{7}",,,,,,,[8]],[,,"(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}",,,,"12345678"],[,,"6\\d{7}",,,,"66123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],"TM",993,"810","8",,,"8",,"8~10",,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],[,"(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],[,"(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TN:[,[,,"[2-57-9]\\d{7}",,,,,,,[8]],[,,"81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}",,,,"30010123"],[,,"3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-7])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}",,,,"20123456"],[,,"8010\\d{4}",
,,,"80101234"],[,,"88\\d{6}",,,,"88123456"],[,,"8[12]10\\d{4}",,,,"81101234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TN",216,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TO:[,[,,"(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",,,,,,,[5,7]],[,,"(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}",,,,"20123",,,[5]],[,,"(?:55[4-6]|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",,,,"7715123",,,[7]],
[,,"0800\\d{3}",,,,"0800222",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"55[0-37-9]\\d{4}",,,,"5510123",,,[7]],"TO",676,"00",,,,,,,,[[,"(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],[,"(\\d{4})(\\d{3})","$1 $2",["0"]],[,"(\\d{3})(\\d{4})","$1 $2",["[5-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TR:[,[,,"4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",,,,,,,[7,10,12,13]],[,,"(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
,,,"2123456789",,,[10]],[,,"56161\\d{5}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}",,,,"5012345678",,,[10]],[,,"8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})",,,,"8001234567",,,[10,12,13]],[,,"(?:8[89]8|900)\\d{7}",,,,"9001234567",,,[10]],[,,,,,,,,,[-1]],[,,"592(?:21[12]|461)\\d{4}",,,,"5922121234",,,[10]],[,,"850\\d{7}",,,,"8500123456",,,[10]],"TR",90,"00","0",,,"0",,,,[[,"(\\d{3})(\\d)(\\d{3})","$1 $2 $3",["444"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|616)","5(?:[0-59]|6161)"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",,1],[,"(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",,1]],[[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|616)","5(?:[0-59]|6161)"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",,1],[,"(\\d{3})(\\d{3})(\\d{6,7})",
"$1 $2 $3",["80"],"0$1",,1]],[,,"512\\d{7}",,,,"5123456789",,,[10]],,,[,,"(?:444|811\\d{3})\\d{4}",,,,,,,[7,10]],[,,"444\\d{4}",,,,"4441444",,,[7]],,,[,,,,,,,,,[-1]]],TT:[,[,,"(?:[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"868(?:2(?:0[13]|1[89]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}",,,,"8682211234",,,,[7]],[,,"868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}",,,,"8682911234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"TT",1,"011","1",,,"1|([2-46-8]\\d{6})$","868$1",,,,,[,,,,,,,,,[-1]],,"868",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,"868619\\d{4}",,,,"8686191234",,,,[7]]],TV:[,[,,"(?:2|7\\d\\d|90)\\d{4}",
,,,,,,[5,6,7]],[,,"2[02-9]\\d{3}",,,,"20123",,,[5]],[,,"(?:7[01]\\d|90)\\d{4}",,,,"901234",,,[6,7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TV",688,"00",,,,,,,,[[,"(\\d{2})(\\d{3})","$1 $2",["2"]],[,"(\\d{2})(\\d{4})","$1 $2",["90"]],[,"(\\d{2})(\\d{5})","$1 $2",["7"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TW:[,[,,"[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",,,,,,,[7,8,9,10,11]],[,,"(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
,,,"221234567",,,[8,9]],[,,"(?:40001[0-2]|9[0-8]\\d{4})\\d{3}",,,,"912345678",,,[9]],[,,"80[0-79]\\d{6}|800\\d{5}",,,,"800123456",,,[8,9]],[,,"20(?:[013-9]\\d\\d|2)\\d{4}",,,,"203123456",,,[7,9]],[,,,,,,,,,[-1]],[,,"99\\d{7}",,,,"990123456",,,[9]],[,,"7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}",,,,"7012345678",,,[10,11]],"TW",886,"0(?:0[25-79]|19)","0","#",,"0",,,,[[,"(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],[,"(\\d)(\\d{3,4})(\\d{4})",
"$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"50[0-46-9]\\d{6}",,,,"500123456",,,[9]],,,[,,,,,,,,,[-1]]],TZ:[,[,,"(?:[26-8]\\d|41|90)\\d{7}",,,,,,,[9]],[,,"2[2-8]\\d{7}",,,,"222345678"],[,,"77[2-9]\\d{6}|(?:6[1-9]|7[1-689])\\d{7}",,,,"621234567"],[,,"80[08]\\d{6}",,,,"800123456"],[,,"90\\d{7}",
,,,"900123456"],[,,"8(?:40|6[01])\\d{6}",,,,"840123456"],[,,,,,,,,,[-1]],[,,"41\\d{7}",,,,"412345678"],"TZ",255,"00[056]","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"(?:8(?:[04]0|6[01])|90\\d)\\d{6}"],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],UA:[,[,,"[89]\\d{9}|[3-9]\\d{8}",,,,,,,[9,10],[5,6,7]],[,,"(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",,,
,"311234567",,,[9],[5,6,7]],[,,"(?:50|6[36-8]|7[1-3]|9[1-9])\\d{7}",,,,"501234567",,,[9]],[,,"800[1-8]\\d{5,6}",,,,"800123456"],[,,"900[239]\\d{5,6}",,,,"900212345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"89[1-579]\\d{6}",,,,"891234567",,,[9]],"UA",380,"00","0",,,"0",,"0~0",,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",
["4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]","4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]"],"0$1"],[,"(\\d{4})(\\d{5})","$1 $2",["[3-6]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],UG:[,[,,"800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",,,,,,,[9],[5,6,7]],[,,"20(?:(?:(?:24|81)0|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[0147]\\d|2[5-9]|32|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
,,,"312345678",,,,[5,6,7]],[,,"726[01]\\d{5}|7(?:[0157-9]\\d|20|36|[46][0-4])\\d{6}",,,,"712345678"],[,,"800[1-3]\\d{5}",,,,"800123456"],[,,"90[1-3]\\d{6}",,,,"901123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"UG",256,"00[057]","0",,,"0",,,,[[,"(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],[,"(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],US:[,[,,"[2-9]\\d{9}",
,,,,,,[10],[7]],[,,"5(?:05(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|44))|82(?:2(?:0[0-3]|[268]2)|3(?:0[02]|33)|4(?:00|4[24]|65|82)|5(?:00|29|83)|6(?:00|66|82)|777|8(?:00|88)|9(?:00|9[89])))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[39]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01579]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
,,,"2015550123",,,,[7]],[,,"5(?:05(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|44))|82(?:2(?:0[0-3]|[268]2)|3(?:0[02]|33)|4(?:00|4[24]|65|82)|5(?:00|29|83)|6(?:00|66|82)|777|8(?:00|88)|9(?:00|9[89])))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[39]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01579]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
,,,"2015550123",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"US",1,"011","1",,,"1",,,1,[[,"(\\d{3})(\\d{4})","$1-$2",["[2-9]"]],[,"(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",
["[2-9]"],,,1]],[[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[2-9]"]]],[,,,,,,,,,[-1]],1,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],UY:[,[,,"4\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",,,,,,,[7,8,10]],[,,"(?:1(?:770|987)|(?:2\\d|4[2-7])\\d\\d)\\d{4}",,,,"21231234",,,[8],[7]],[,,"9[1-9]\\d{6}",,,,"94231234",,,[8]],[,,"(?:4\\d{5}|80[05])\\d{4}|405\\d{4}",,,,"8001234",,,[7,10]],[,,"90[0-8]\\d{4}",,,,"9001234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"UY",598,"0(?:0|1[3-9]\\d)","0",
" int. ",,"0",,"00",,[[,"(\\d{3})(\\d{4})","$1 $2",["405|8|90"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],[,"(\\d{4})(\\d{4})","$1 $2",["[124]"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["4"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],UZ:[,[,,"(?:33|55|[679]\\d|88)\\d{7}",,,,,,,[9]],[,,"(?:6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|8\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}",
,,,"669050123"],[,,"(?:(?:33|88|9[0-57-9])\\d{3}|55(?:50[013]|90\\d)|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
,,,"912345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"UZ",998,"810","8",,,"8",,"8~10",,[[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[35-9]"],"8 $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],VA:[,[,,"0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",,,,,,,[6,7,8,9,10,11,12]],[,,"06698\\d{1,6}",,,,"0669812345",,,[6,7,8,9,10,11]],[,,"3[1-9]\\d{8}|3[2-9]\\d{7}",,,,"3123456789",,,[9,10]],[,,"80(?:0\\d{3}|3)\\d{3}",
,,,"800123456",,,[6,9]],[,,"(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",,,,"899123456",,,[6,8,9,10]],[,,"84(?:[08]\\d{3}|[17])\\d{3}",,,,"848123456",,,[6,9]],[,,"1(?:78\\d|99)\\d{6}",,,,"1781234567",,,[9,10]],[,,"55\\d{8}",,,,"5512345678",,,[10]],"VA",39,"00",,,,,,,,,,[,,,,,,,,,[-1]],,"06698",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,"3[2-8]\\d{9,10}",,,,"33101234501",,,[11,12]]],VC:[,[,,"(?:[58]\\d\\d|784|900)\\d{7}",,,,,,,[10],[7]],
[,,"784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}",,,,"7842661234",,,,[7]],[,,"784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}",,,,"7844301234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"VC",1,"011","1",,,"1|([2-7]\\d{6})$","784$1",,,,,[,,,,,,,,,[-1]],,"784",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],VE:[,[,,"[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",,,,,,,[10],[7]],[,,"(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}",,,,"2121234567",,,,[7]],[,,"4(?:1[24-8]|2[46])\\d{7}",,,,"4121234567"],[,,"800\\d{7}",,,,"8001234567"],[,,"90[01]\\d{7}",,,,"9001234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"VE",58,"00","0",,,"0",,,,[[,
"(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1","$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"501\\d{7}",,,,"5010123456",,,,[7]],,,[,,,,,,,,,[-1]]],VG:[,[,,"(?:284|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"284496[0-5]\\d{3}|284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}",,,,"2842291234",,,,[7]],[,,"284496[6-9]\\d{3}|284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|99)|5(?:4[0-7]|68|9[69]))\\d{4}",,,,"2843001234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",
,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"VG",1,"011","1",,,"1|([2-578]\\d{6})$","284$1",,,,,[,,,,,,,,,[-1]],,"284",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],VI:[,[,,"[58]\\d{9}|(?:34|90)0\\d{7}",,,,,,,[10],[7]],[,,"340(?:2(?:0[0-38]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
,,,"3406421234",,,,[7]],[,,"340(?:2(?:0[0-38]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",,,,"3406421234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"VI",1,"011","1",,,"1|([2-9]\\d{6})$","340$1",,1,,,[,,,,,,,,,[-1]],,"340",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],VN:[,[,,"[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",,,,,,,[7,8,9,10]],[,,"2(?:0[3-9]|1[0-689]|2[0-25-9]|3[2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|8[2-79]|9[0-4679])\\d{7}",,,,"2101234567",,,[10]],[,,"(?:5(?:2[238]|59)|89[689]|99[013-9])\\d{6}|(?:3\\d|5[689]|7[06-9]|8[1-8]|9[0-8])\\d{7}",,,,"912345678",,,[9]],[,,"1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
,,,"1800123456",,,[8,9,10]],[,,"1900\\d{4,6}",,,,"1900123456",,,[8,9,10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"672\\d{6}",,,,"672012345",,,[9]],"VN",84,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[17]99"],"0$1",,1],[,"(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",,1],[,"(\\d{3})(\\d{4,5})","$1 $2",["69"],"0$1",,1],[,"(\\d{4})(\\d{4,6})","$1 $2",["1"],,,1],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[69]"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3578]"],"0$1",,1],[,"(\\d{2})(\\d{4})(\\d{4})",
"$1 $2 $3",["2[48]"],"0$1",,1],[,"(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",,1]],[[,"(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",,1],[,"(\\d{4})(\\d{4,6})","$1 $2",["1"],,,1],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[69]"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3578]"],"0$1",,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",,1],[,"(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",,1]],[,,,,,,,,,[-1]],,,[,,"[17]99\\d{4}|69\\d{5,6}",,,,,,,[7,8]],[,,"(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
,,,"1992000",,,[7,8]],,,[,,,,,,,,,[-1]]],VU:[,[,,"[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",,,,,,,[5,7]],[,,"(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}",,,,"22123",,,[5]],[,,"(?:[58]\\d|7[013-7])\\d{5}",,,,"5912345",,,[7]],[,,"81[18]\\d\\d",,,,"81123",,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:0[1-9]|1[01])\\d{4}",,,,"9010123",,,[7]],"VU",678,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[57-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:3[03]|900\\d)\\d{3}",,,,"30123"],,
,[,,,,,,,,,[-1]]],WF:[,[,,"(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",,,,,,,[6,9]],[,,"72\\d{4}",,,,"721234",,,[6]],[,,"(?:72|8[23])\\d{4}",,,,"821234",,,[6]],[,,"80[0-5]\\d{6}",,,,"800012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"WF",681,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[478]"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,"[48]0\\d{4}",,,,"401234",,,[6]]],WS:[,[,,"(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
,,,,,,[5,6,7,10]],[,,"6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}",,,,"22123",,,[5,6]],[,,"(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}",,,,"7212345",,,[7,10]],[,,"800\\d{3}",,,,"800123",,,[6]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"WS",685,"0",,,,,,,,[[,"(\\d{5})","$1",["[2-5]|6[1-9]"]],[,"(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],[,"(\\d{2})(\\d{5})","$1 $2",["7"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],XK:[,[,,"[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",,,,,,,[8,
9]],[,,"(?:2[89]|39)0\\d{6}|[23][89]\\d{6}",,,,"28012345"],[,,"4[3-9]\\d{6}",,,,"43201234",,,[8]],[,,"800\\d{5}",,,,"80001234",,,[8]],[,,"900\\d{5}",,,,"90001234",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"XK",383,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],YE:[,[,,"(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
,,,,,,[7,8,9],[6]],[,,"78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}",,,,"1234567",,,[7,8],[6]],[,,"7[0137]\\d{7}",,,,"712345678",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"YE",967,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7[24-68]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],YT:[,[,,"80\\d{7}|(?:26|63)9\\d{6}",
,,,,,,[9]],[,,"269(?:0[67]|5[0-3]|6\\d|[78]0)\\d{4}",,,,"269601234"],[,,"639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}",,,,"639012345"],[,,"80\\d{7}",,,,"801234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"YT",262,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,"269|63",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ZA:[,[,,"[1-79]\\d{8}|8\\d{4,9}",,,,,,,[5,6,7,8,9,10]],[,,"(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}",,,,"101234567",
,,[9]],[,,"(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",,,,"711234567",,,[5,6,7,8,9]],[,,"80\\d{7}",,,,"801234567",,,[9]],[,,"(?:86[2-9]|9[0-2]\\d)\\d{6}",,,,"862345678",,,[9]],[,,"860\\d{6}",,,,"860123456",,,[9]],[,,,,,,,,,[-1]],[,,"87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}",
,,,"871234567",,,[9]],"ZA",27,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"861\\d{6,7}",,,,"861123456",,,[9,10]],,,[,,,,,,,,,[-1]]],ZM:[,[,,"800\\d{6}|(?:21|63|[79]\\d)\\d{7}",,,,,,,[9],[6]],[,,"21[1-8]\\d{6}",,,,
"211234567",,,,[6]],[,,"(?:7[679]|9[5-8])\\d{7}",,,,"955123456"],[,,"800\\d{6}",,,,"800123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"63\\d{7}",,,,"630123456"],"ZM",260,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})","$1 $2",["[1-9]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,
,,,,,,,,[-1]]],ZW:[,[,,"2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",,,,,,,[5,6,7,8,9,10],[3,4]],[,,"(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
,,,"1312345",,,,[3,4]],[,,"7(?:[178]\\d|3[1-9])\\d{6}",,,,"712345678",,,[9]],[,,"80(?:[01]\\d|20|8[0-8])\\d{3}",,,,"8001234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"86(?:1[12]|22|30|44|55|77|8[368])\\d{6}",,,,"8686123456",,,[10]],"ZW",263,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],[,"(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],[,"(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],
[,"(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],[,"(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],[,"(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],[,"(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],800:[,[,,"(?:005|[1-9]\\d\\d)\\d{5}",,,,,,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:005|[1-9]\\d\\d)\\d{5}",,,,"12345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",800,,,,,,,,1,[[,"(\\d{4})(\\d{4})","$1 $2",["\\d"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,
,,,,[-1]],,,[,,,,,,,,,[-1]]],808:[,[,,"[1-9]\\d{7}",,,,,,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"[1-9]\\d{7}",,,,"12345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",808,,,,,,,,1,[[,"(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],870:[,[,,"7\\d{11}|[35-7]\\d{8}",,,,,,,[9,12]],[,,,,,,,,,[-1]],[,,"(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}",,,,"301234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,
[-1]],[,,,,,,,,,[-1]],"001",870,,,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[35-7]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],878:[,[,,"10\\d{10}",,,,,,,[12]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"10\\d{10}",,,,"101234567890"],"001",878,,,,,,,,1,[[,"(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],881:[,[,,"[0-36-9]\\d{8}",,,,,,,[9]],
[,,,,,,,,,[-1]],[,,"[0-36-9]\\d{8}",,,,"612345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",881,,,,,,,,,[[,"(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-36-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],882:[,[,,"[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|(?:[19]\\d|49)\\d{6}",,,,,,,[7,8,9,10,11,12]],[,,,,,,,,,[-1]],[,,"342\\d{4}|(?:337|49)\\d{6}|3(?:2|47|7\\d{3})\\d{7}",,,,"3421234",,,[7,8,9,10,12]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,
,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}",,,,"390123456789"],"001",882,,,,,,,,,[[,"(\\d{2})(\\d{5})","$1 $2",["16|342"]],[,"(\\d{2})(\\d{6})","$1 $2",["4"]],[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[19]"]],[,"(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["34[57]"]],[,"(\\d{3})(\\d{4})(\\d{4})",
"$1 $2 $3",["34"]],[,"(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-3]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,"348[57]\\d{7}",,,,"34851234567",,,[11]]],883:[,[,,"(?:210|370\\d\\d)\\d{7}|51\\d{7}(?:\\d{3})?",,,,,,,[9,10,12]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:210|(?:370[1-9]|51[013]0)\\d)\\d{7}|5100\\d{5}",,,,"510012345"],"001",883,,,,,,,,1,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],[,"(\\d{3})(\\d{3})(\\d{4})",
"$1 $2 $3",["2"]],[,"(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["51[13]"]],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[35]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],888:[,[,,"\\d{11}",,,,,,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",888,,,,,,,,1,[[,"(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"\\d{11}",,,,"12345678901"],,,[,,,,,,,,,[-1]]],979:[,[,,
"[1359]\\d{8}",,,,,,,[9],[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"[1359]\\d{8}",,,,"123456789",,,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",979,,,,,,,,1,[[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]]};/*

 Copyright (C) 2010 The Libphonenumber Authors.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
i18n.phonenumbers.PhoneNumberUtil=function(){this.regionToMetadataMap={}};goog.addSingletonGetter(i18n.phonenumbers.PhoneNumberUtil);i18n.phonenumbers.Error={INVALID_COUNTRY_CODE:"Invalid country calling code",NOT_A_NUMBER:"The string supplied did not seem to be a phone number",TOO_SHORT_AFTER_IDD:"Phone number too short after IDD",TOO_SHORT_NSN:"The string supplied is too short to be a phone number",TOO_LONG:"The string supplied is too long to be a phone number"};
i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_=1;i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_=2;i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_=17;i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_=3;i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_=250;i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_="ZZ";i18n.phonenumbers.PhoneNumberUtil.COLOMBIA_MOBILE_TO_FIXED_LINE_PREFIX_="3";i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_={54:"9"};
i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_=[52,54,55];i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN="+";i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_="*";i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_=";ext=";i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_="tel:";i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_=";phone-context=";i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_=";isub=";
i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS={0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9","\uff10":"0","\uff11":"1","\uff12":"2","\uff13":"3","\uff14":"4","\uff15":"5","\uff16":"6","\uff17":"7","\uff18":"8","\uff19":"9","\u0660":"0","\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u06f0":"0","\u06f1":"1","\u06f2":"2","\u06f3":"3","\u06f4":"4","\u06f5":"5","\u06f6":"6","\u06f7":"7","\u06f8":"8","\u06f9":"9"};
i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_={0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9","+":i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN,"*":"*","#":"#"};i18n.phonenumbers.PhoneNumberUtil.ALPHA_MAPPINGS_={A:"2",B:"2",C:"2",D:"3",E:"3",F:"3",G:"4",H:"4",I:"4",J:"5",K:"5",L:"5",M:"6",N:"6",O:"6",P:"7",Q:"7",R:"7",S:"7",T:"8",U:"8",V:"8",W:"9",X:"9",Y:"9",Z:"9"};
i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_={0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9","\uff10":"0","\uff11":"1","\uff12":"2","\uff13":"3","\uff14":"4","\uff15":"5","\uff16":"6","\uff17":"7","\uff18":"8","\uff19":"9","\u0660":"0","\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u06f0":"0","\u06f1":"1","\u06f2":"2","\u06f3":"3","\u06f4":"4","\u06f5":"5","\u06f6":"6","\u06f7":"7","\u06f8":"8","\u06f9":"9",
A:"2",B:"2",C:"2",D:"3",E:"3",F:"3",G:"4",H:"4",I:"4",J:"5",K:"5",L:"5",M:"6",N:"6",O:"6",P:"7",Q:"7",R:"7",S:"7",T:"8",U:"8",V:"8",W:"9",X:"9",Y:"9",Z:"9"};
i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_={0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9",A:"A",B:"B",C:"C",D:"D",E:"E",F:"F",G:"G",H:"H",I:"I",J:"J",K:"K",L:"L",M:"M",N:"N",O:"O",P:"P",Q:"Q",R:"R",S:"S",T:"T",U:"U",V:"V",W:"W",X:"X",Y:"Y",Z:"Z",a:"A",b:"B",c:"C",d:"D",e:"E",f:"F",g:"G",h:"H",i:"I",j:"J",k:"K",l:"L",m:"M",n:"N",o:"O",p:"P",q:"Q",r:"R",s:"S",t:"T",u:"U",v:"V",w:"W",x:"X",y:"Y",z:"Z","-":"-","\uff0d":"-","\u2010":"-","\u2011":"-","\u2012":"-",
"\u2013":"-","\u2014":"-","\u2015":"-","\u2212":"-","/":"/","\uff0f":"/"," ":" ","\u3000":" ","\u2060":" ",".":".","\uff0e":"."};i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_=/[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/;i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION="-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e";i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_="0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9";
i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_="A-Za-z";i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_="+\uff0b";i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN=new RegExp("["+i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_+"]+");i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN=new RegExp("^["+i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_+"]+");i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_="["+i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION+"]+";
i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN=new RegExp("(["+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+"])");i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_=new RegExp("["+i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+"]");i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_=/[\\\/] *x/;
i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_=new RegExp("[^"+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_+"#]+$");i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_=/(?:.*?[A-Za-z]){3}.*/;i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_="["+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+"]{"+i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_+"}";
i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_="["+i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_+"]*(?:["+i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION+i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_+"]*["+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+"]){3,}["+i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION+i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_+i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+"]*";
i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_=" ext. ";i18n.phonenumbers.PhoneNumberUtil.extnDigits_=function(a){return"(["+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+"]{1,"+a+"})"};
i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_=function(){var a=i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_+i18n.phonenumbers.PhoneNumberUtil.extnDigits_("20"),b="[ \u00a0\\t,]*(?:e?xt(?:ensi(?:o\u0301?|\u00f3))?n?|\uff45?\uff58\uff54\uff4e?|\u0434\u043e\u0431|anexo)[:\\.\uff0e]?[ \u00a0\\t,-]*"+i18n.phonenumbers.PhoneNumberUtil.extnDigits_("20")+"#?",c="[ \u00a0\\t,]*(?:[x\uff58#\uff03~\uff5e]|int|\uff49\uff4e\uff54)[:\\.\uff0e]?[ \u00a0\\t,-]*"+i18n.phonenumbers.PhoneNumberUtil.extnDigits_("9")+
"#?",d="[- ]+"+i18n.phonenumbers.PhoneNumberUtil.extnDigits_("6")+"#",e="[ \u00a0\\t]*(?:,{2}|;)[:\\.\uff0e]?[ \u00a0\\t,-]*"+i18n.phonenumbers.PhoneNumberUtil.extnDigits_("15")+"#?",f="[ \u00a0\\t]*(?:,)+[:\\.\uff0e]?[ \u00a0\\t,-]*"+i18n.phonenumbers.PhoneNumberUtil.extnDigits_("9")+"#?";return a+"|"+b+"|"+c+"|"+d+"|"+e+"|"+f};i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_=new RegExp("(?:"+i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_()+")$","i");
i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_=new RegExp("^"+i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_+"$|^"+i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_+"(?:"+i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_()+")?$","i");i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_=/\D+/;i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_=/(\$\d)/;i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_=/\$NP/;i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_=/\$FG/;
i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_=/\$CC/;i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_=/^\(?\$1\)?$/;i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY="001";i18n.phonenumbers.PhoneNumberFormat={E164:0,INTERNATIONAL:1,NATIONAL:2,RFC3966:3};i18n.phonenumbers.PhoneNumberType={FIXED_LINE:0,MOBILE:1,FIXED_LINE_OR_MOBILE:2,TOLL_FREE:3,PREMIUM_RATE:4,SHARED_COST:5,VOIP:6,PERSONAL_NUMBER:7,PAGER:8,UAN:9,VOICEMAIL:10,UNKNOWN:-1};
i18n.phonenumbers.PhoneNumberUtil.MatchType={NOT_A_NUMBER:0,NO_MATCH:1,SHORT_NSN_MATCH:2,NSN_MATCH:3,EXACT_MATCH:4};i18n.phonenumbers.PhoneNumberUtil.ValidationResult={IS_POSSIBLE:0,IS_POSSIBLE_LOCAL_ONLY:4,INVALID_COUNTRY_CODE:1,TOO_SHORT:2,INVALID_LENGTH:5,TOO_LONG:3};
i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber=function(a){var b=a.search(i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_);0<=b?(a=a.substring(b),a=a.replace(i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_,""),b=a.search(i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_),0<=b&&(a=a.substring(0,b))):a="";return a};
i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber=function(a){return a.length<i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_?!1:i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_,a)};
i18n.phonenumbers.PhoneNumberUtil.normalize=function(a){return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_,a)?i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a,i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_,!0):i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a)};i18n.phonenumbers.PhoneNumberUtil.normalizeSB_=function(a){var b=i18n.phonenumbers.PhoneNumberUtil.normalize(a.toString());a.clear();a.append(b)};
i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly=function(a){return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a,i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS,!0)};i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly=function(a){return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a,i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_,!0)};
i18n.phonenumbers.PhoneNumberUtil.convertAlphaCharactersInNumber=function(a){return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a,i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_,!1)};i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfGeographicalAreaCode=function(a){var b=this.getMetadataForRegion(this.getRegionCodeForNumber(a));return null!=b&&(b.hasNationalPrefix()||a.hasItalianLeadingZero())&&this.isNumberGeographical(a)?this.getLengthOfNationalDestinationCode(a):0};
i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfNationalDestinationCode=function(a){if(a.hasExtension()){var b=a.clone();b.clearExtension()}else b=a;b=this.format(b,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).split(i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_);0==b[0].length&&b.shift();return 2>=b.length?0:this.getNumberType(a)==i18n.phonenumbers.PhoneNumberType.MOBILE&&(a=i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken(a.getCountryCodeOrDefault()),""!=a)?b[2].length+
a.length:b[1].length};i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken=function(a){return i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_[a]||""};i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedRegions=function(){return Object.keys(i18n.phonenumbers.metadata.countryToMetadata).filter(function(a){return isNaN(a)})};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedGlobalNetworkCallingCodes=function(){return Object.keys(i18n.phonenumbers.metadata.countryToMetadata).filter(function(a){return!isNaN(a)}).map(function(a){return parseInt(a,10)})};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedCallingCodes=function(){var a=Object.keys(i18n.phonenumbers.metadata.countryCodeToRegionCodeMap);return[].concat($jscomp.arrayFromIterable(this.getSupportedGlobalNetworkCallingCodes()),$jscomp.arrayFromIterable(a.map(function(b){return parseInt(b,10)})))};i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_=function(a){return null!=a&&(1!=a.possibleLengthCount()||-1!=a.possibleLengthArray()[0])};
i18n.phonenumbers.PhoneNumberUtil.descHasData_=function(a){return null!=a&&(a.hasExampleNumber()||i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(a)||a.hasNationalNumberPattern())};
i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_=function(a){var b=[];goog.object.forEach(i18n.phonenumbers.PhoneNumberType,function(c){if(c!=i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE&&c!=i18n.phonenumbers.PhoneNumberType.UNKNOWN){var d=i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(a,c);i18n.phonenumbers.PhoneNumberUtil.descHasData_(d)&&b.push(c)}});return b};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForRegion=function(a){return this.isValidRegionCode_(a)?i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(this.getMetadataForRegion(a)):[]};i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForNonGeoEntity=function(a){a=this.getMetadataForNonGeographicalRegion(a);return null==a?[]:i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(a)};
i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_=function(a,b,c){for(var d=new goog.string.StringBuffer,e,f,g=a.length,h=0;h<g;++h)e=a.charAt(h),f=b[e.toUpperCase()],null!=f?d.append(f):c||d.append(e);return d.toString()};i18n.phonenumbers.PhoneNumberUtil.prototype.formattingRuleHasFirstGroupOnly=function(a){return 0==a.length||i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_.test(a)};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberGeographical=function(a){var b=this.getNumberType(a);return b==i18n.phonenumbers.PhoneNumberType.FIXED_LINE||b==i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE||i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_.includes(a.getCountryCodeOrDefault())&&b==i18n.phonenumbers.PhoneNumberType.MOBILE};i18n.phonenumbers.PhoneNumberUtil.prototype.isValidRegionCode_=function(a){return null!=a&&isNaN(a)&&a.toUpperCase()in i18n.phonenumbers.metadata.countryToMetadata};
i18n.phonenumbers.PhoneNumberUtil.prototype.hasValidCountryCallingCode_=function(a){return a in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap};
i18n.phonenumbers.PhoneNumberUtil.prototype.format=function(a,b){if(0==a.getNationalNumber()&&a.hasRawInput()){var c=a.getRawInputOrDefault();if(0<c.length)return c}c=a.getCountryCodeOrDefault();var d=this.getNationalSignificantNumber(a);if(b==i18n.phonenumbers.PhoneNumberFormat.E164)return this.prefixNumberWithCountryCallingCode_(c,i18n.phonenumbers.PhoneNumberFormat.E164,d,"");if(!this.hasValidCountryCallingCode_(c))return d;var e=this.getRegionCodeForCountryCode(c);e=this.getMetadataForRegionOrCallingCode_(c,
e);a=this.maybeGetFormattedExtension_(a,e,b);d=this.formatNsn_(d,e,b);return this.prefixNumberWithCountryCallingCode_(c,b,d,a)};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatByPattern=function(a,b,c){var d=a.getCountryCodeOrDefault(),e=this.getNationalSignificantNumber(a);if(!this.hasValidCountryCallingCode_(d))return e;var f=this.getRegionCodeForCountryCode(d);f=this.getMetadataForRegionOrCallingCode_(d,f);var g=this.chooseFormattingPatternForNumber_(c,e);if(null!=g){c=g.clone();g=g.getNationalPrefixFormattingRuleOrDefault();if(0<g.length){var h=f.getNationalPrefixOrDefault();0<h.length?(g=g.replace(i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_,
h).replace(i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_,"$1"),c.setNationalPrefixFormattingRule(g)):c.clearNationalPrefixFormattingRule()}e=this.formatNsnUsingPattern_(e,c,b)}a=this.maybeGetFormattedExtension_(a,f,b);return this.prefixNumberWithCountryCallingCode_(d,b,e,a)};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithCarrierCode=function(a,b){var c=a.getCountryCodeOrDefault(),d=this.getNationalSignificantNumber(a);if(!this.hasValidCountryCallingCode_(c))return d;var e=this.getRegionCodeForCountryCode(c);e=this.getMetadataForRegionOrCallingCode_(c,e);a=this.maybeGetFormattedExtension_(a,e,i18n.phonenumbers.PhoneNumberFormat.NATIONAL);b=this.formatNsn_(d,e,i18n.phonenumbers.PhoneNumberFormat.NATIONAL,b);return this.prefixNumberWithCountryCallingCode_(c,
i18n.phonenumbers.PhoneNumberFormat.NATIONAL,b,a)};i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegionOrCallingCode_=function(a,b){return i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY==b?this.getMetadataForNonGeographicalRegion(a):this.getMetadataForRegion(b)};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithPreferredCarrierCode=function(a,b){return this.formatNationalNumberWithCarrierCode(a,0<a.getPreferredDomesticCarrierCodeOrDefault().length?a.getPreferredDomesticCarrierCodeOrDefault():b)};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNumberForMobileDialing=function(a,b,c){var d=a.getCountryCodeOrDefault();if(!this.hasValidCountryCallingCode_(d))return a.hasRawInput()?a.getRawInputOrDefault():"";var e="";a=a.clone();a.clearExtension();var f=this.getRegionCodeForCountryCode(d),g=this.getNumberType(a),h=g!=i18n.phonenumbers.PhoneNumberType.UNKNOWN;if(b==f)e=g==i18n.phonenumbers.PhoneNumberType.FIXED_LINE||g==i18n.phonenumbers.PhoneNumberType.MOBILE||g==i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE,
"CO"==f&&g==i18n.phonenumbers.PhoneNumberType.FIXED_LINE?e=this.formatNationalNumberWithCarrierCode(a,i18n.phonenumbers.PhoneNumberUtil.COLOMBIA_MOBILE_TO_FIXED_LINE_PREFIX_):"BR"==f&&e?e=0<a.getPreferredDomesticCarrierCodeOrDefault().length?this.formatNationalNumberWithPreferredCarrierCode(a,""):"":d==i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_?(b=this.getMetadataForRegion(b),e=this.canBeInternationallyDialled(a)&&this.testNumberLength_(this.getNationalSignificantNumber(a),b)!=i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT?
this.format(a,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL):this.format(a,i18n.phonenumbers.PhoneNumberFormat.NATIONAL)):e=(f==i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY||("MX"==f||"CL"==f||"UZ"==f)&&e)&&this.canBeInternationallyDialled(a)?this.format(a,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL):this.format(a,i18n.phonenumbers.PhoneNumberFormat.NATIONAL);else if(h&&this.canBeInternationallyDialled(a))return c?this.format(a,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL):
this.format(a,i18n.phonenumbers.PhoneNumberFormat.E164);return c?e:i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(e)};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryCallingNumber=function(a,b){if(!this.isValidRegionCode_(b))return this.format(a,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);var c=a.getCountryCodeOrDefault(),d=this.getNationalSignificantNumber(a);if(!this.hasValidCountryCallingCode_(c))return d;if(c==i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_){if(this.isNANPACountry(b))return c+" "+this.format(a,i18n.phonenumbers.PhoneNumberFormat.NATIONAL)}else if(c==this.getCountryCodeForValidRegion_(b))return this.format(a,
i18n.phonenumbers.PhoneNumberFormat.NATIONAL);var e=this.getMetadataForRegion(b),f=e.getInternationalPrefixOrDefault();b="";e.hasPreferredInternationalPrefix()?b=e.getPreferredInternationalPrefixOrDefault():i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_,f)&&(b=f);e=this.getRegionCodeForCountryCode(c);e=this.getMetadataForRegionOrCallingCode_(c,e);d=this.formatNsn_(d,e,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);a=this.maybeGetFormattedExtension_(a,
e,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);return 0<b.length?b+" "+c+" "+d+a:this.prefixNumberWithCountryCallingCode_(c,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL,d,a)};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatInOriginalFormat=function(a,b){if(a.hasRawInput()&&!this.hasFormattingPatternForNumber_(a))return a.getRawInputOrDefault();if(!a.hasCountryCodeSource())return this.format(a,i18n.phonenumbers.PhoneNumberFormat.NATIONAL);switch(a.getCountryCodeSource()){case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN:b=this.format(a,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);break;case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD:b=
this.formatOutOfCountryCallingNumber(a,b);break;case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN:b=this.format(a,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).substring(1);break;default:var c=this.getRegionCodeForCountryCode(a.getCountryCodeOrDefault()),d=this.getNddPrefixForRegion(c,!0);b=this.format(a,i18n.phonenumbers.PhoneNumberFormat.NATIONAL);if(null!=d&&0!=d.length&&!this.rawInputContainsNationalPrefix_(a.getRawInputOrDefault(),d,c)&&(c=this.getMetadataForRegion(c),
d=this.getNationalSignificantNumber(a),c=this.chooseFormattingPatternForNumber_(c.numberFormatArray(),d),null!=c)){d=c.getNationalPrefixFormattingRuleOrDefault();var e=d.indexOf("$1");0>=e||(d=d.substring(0,e),d=i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d),0!=d.length&&(b=c.clone(),b.clearNationalPrefixFormattingRule(),b=this.formatByPattern(a,i18n.phonenumbers.PhoneNumberFormat.NATIONAL,[b])))}}a=a.getRawInputOrDefault();null!=b&&0<a.length&&(c=i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(b),
d=i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(a),c!=d&&(b=a));return b};i18n.phonenumbers.PhoneNumberUtil.prototype.rawInputContainsNationalPrefix_=function(a,b,c){a=i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a);if(goog.string.startsWith(a,b))try{return this.isValidNumber(this.parse(a.substring(b.length),c))}catch(d){}return!1};
i18n.phonenumbers.PhoneNumberUtil.prototype.hasFormattingPatternForNumber_=function(a){var b=a.getCountryCodeOrDefault(),c=this.getRegionCodeForCountryCode(b);b=this.getMetadataForRegionOrCallingCode_(b,c);if(null==b)return!1;a=this.getNationalSignificantNumber(a);return null!=this.chooseFormattingPatternForNumber_(b.numberFormatArray(),a)};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryKeepingAlphaChars=function(a,b){var c=a.getRawInputOrDefault();if(0==c.length)return this.formatOutOfCountryCallingNumber(a,b);var d=a.getCountryCodeOrDefault();if(!this.hasValidCountryCallingCode_(d))return c;c=i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(c,i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_,!0);var e=this.getNationalSignificantNumber(a);if(3<e.length){var f=c.indexOf(e.substring(0,3));-1!=f&&(c=
c.substring(f))}f=this.getMetadataForRegion(b);if(d==i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_){if(this.isNANPACountry(b))return d+" "+c}else if(null!=f&&d==this.getCountryCodeForValidRegion_(b)){d=this.chooseFormattingPatternForNumber_(f.numberFormatArray(),e);if(null==d)return c;d=d.clone();d.setPattern("(\\d+)(.*)");d.setFormat("$1$2");return this.formatNsnUsingPattern_(c,d,i18n.phonenumbers.PhoneNumberFormat.NATIONAL)}b="";null!=f&&(b=f.getInternationalPrefixOrDefault(),b=i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_,
b)?b:f.getPreferredInternationalPrefixOrDefault());f=this.getRegionCodeForCountryCode(d);f=this.getMetadataForRegionOrCallingCode_(d,f);a=this.maybeGetFormattedExtension_(a,f,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);return 0<b.length?b+" "+d+" "+c+a:this.prefixNumberWithCountryCallingCode_(d,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL,c,a)};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNationalSignificantNumber=function(a){if(!a.hasNationalNumber())return"";var b=""+a.getNationalNumber();return a.hasItalianLeadingZero()&&a.getItalianLeadingZero()&&0<a.getNumberOfLeadingZerosOrDefault()?Array(a.getNumberOfLeadingZerosOrDefault()+1).join("0")+b:b};
i18n.phonenumbers.PhoneNumberUtil.prototype.prefixNumberWithCountryCallingCode_=function(a,b,c,d){switch(b){case i18n.phonenumbers.PhoneNumberFormat.E164:return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN+a+c+d;case i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL:return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN+a+" "+c+d;case i18n.phonenumbers.PhoneNumberFormat.RFC3966:return i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_+i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN+a+"-"+c+d;default:return c+
d}};i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsn_=function(a,b,c,d){b=0==b.intlNumberFormatArray().length||c==i18n.phonenumbers.PhoneNumberFormat.NATIONAL?b.numberFormatArray():b.intlNumberFormatArray();b=this.chooseFormattingPatternForNumber_(b,a);return null==b?a:this.formatNsnUsingPattern_(a,b,c,d)};
i18n.phonenumbers.PhoneNumberUtil.prototype.chooseFormattingPatternForNumber_=function(a,b){for(var c,d=a.length,e=0;e<d;++e){c=a[e];var f=c.leadingDigitsPatternCount();if(0==f||0==b.search(c.getLeadingDigitsPattern(f-1)))if(f=new RegExp(c.getPattern()),i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f,b))return c}return null};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsnUsingPattern_=function(a,b,c,d){var e=b.getFormatOrDefault(),f=new RegExp(b.getPattern()),g=b.getDomesticCarrierCodeFormattingRuleOrDefault();c==i18n.phonenumbers.PhoneNumberFormat.NATIONAL&&null!=d&&0<d.length&&0<g.length?(b=g.replace(i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_,d),e=e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_,b),a=a.replace(f,e)):(b=b.getNationalPrefixFormattingRuleOrDefault(),a=c==i18n.phonenumbers.PhoneNumberFormat.NATIONAL&&
null!=b&&0<b.length?a.replace(f,e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_,b)):a.replace(f,e));c==i18n.phonenumbers.PhoneNumberFormat.RFC3966&&(a=a.replace(new RegExp("^"+i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_),""),a=a.replace(new RegExp(i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_,"g"),"-"));return a};i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumber=function(a){return this.getExampleNumberForType(a,i18n.phonenumbers.PhoneNumberType.FIXED_LINE)};
i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForType=function(a,b){if(!this.isValidRegionCode_(a))return null;b=i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(this.getMetadataForRegion(a),b);try{if(b.hasExampleNumber())return this.parse(b.getExampleNumber(),a)}catch(c){}return null};
i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForNonGeoEntity=function(a){var b=this.getMetadataForNonGeographicalRegion(a);if(null!=b&&(b=[b.getMobile(),b.getTollFree(),b.getSharedCost(),b.getVoip(),b.getVoicemail(),b.getUan(),b.getPremiumRate()].find(function(c,d){return c.hasExampleNumber()}),void 0!==b))try{return this.parse("+"+a+b.getExampleNumber(),"ZZ")}catch(c){}return null};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeGetFormattedExtension_=function(a,b,c){return a.hasExtension()&&0!=a.getExtension().length?c==i18n.phonenumbers.PhoneNumberFormat.RFC3966?i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_+a.getExtension():b.hasPreferredExtnPrefix()?b.getPreferredExtnPrefix()+a.getExtensionOrDefault():i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_+a.getExtensionOrDefault():""};
i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_=function(a,b){switch(b){case i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE:return a.getPremiumRate();case i18n.phonenumbers.PhoneNumberType.TOLL_FREE:return a.getTollFree();case i18n.phonenumbers.PhoneNumberType.MOBILE:return a.getMobile();case i18n.phonenumbers.PhoneNumberType.FIXED_LINE:case i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE:return a.getFixedLine();case i18n.phonenumbers.PhoneNumberType.SHARED_COST:return a.getSharedCost();
case i18n.phonenumbers.PhoneNumberType.VOIP:return a.getVoip();case i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER:return a.getPersonalNumber();case i18n.phonenumbers.PhoneNumberType.PAGER:return a.getPager();case i18n.phonenumbers.PhoneNumberType.UAN:return a.getUan();case i18n.phonenumbers.PhoneNumberType.VOICEMAIL:return a.getVoicemail();default:return a.getGeneralDesc()}};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberType=function(a){var b=this.getRegionCodeForNumber(a);b=this.getMetadataForRegionOrCallingCode_(a.getCountryCodeOrDefault(),b);if(null==b)return i18n.phonenumbers.PhoneNumberType.UNKNOWN;a=this.getNationalSignificantNumber(a);return this.getNumberTypeHelper_(a,b)};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberTypeHelper_=function(a,b){return this.isNumberMatchingDesc_(a,b.getGeneralDesc())?this.isNumberMatchingDesc_(a,b.getPremiumRate())?i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE:this.isNumberMatchingDesc_(a,b.getTollFree())?i18n.phonenumbers.PhoneNumberType.TOLL_FREE:this.isNumberMatchingDesc_(a,b.getSharedCost())?i18n.phonenumbers.PhoneNumberType.SHARED_COST:this.isNumberMatchingDesc_(a,b.getVoip())?i18n.phonenumbers.PhoneNumberType.VOIP:this.isNumberMatchingDesc_(a,
b.getPersonalNumber())?i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER:this.isNumberMatchingDesc_(a,b.getPager())?i18n.phonenumbers.PhoneNumberType.PAGER:this.isNumberMatchingDesc_(a,b.getUan())?i18n.phonenumbers.PhoneNumberType.UAN:this.isNumberMatchingDesc_(a,b.getVoicemail())?i18n.phonenumbers.PhoneNumberType.VOICEMAIL:this.isNumberMatchingDesc_(a,b.getFixedLine())?b.getSameMobileAndFixedLinePattern()||this.isNumberMatchingDesc_(a,b.getMobile())?i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE:
i18n.phonenumbers.PhoneNumberType.FIXED_LINE:!b.getSameMobileAndFixedLinePattern()&&this.isNumberMatchingDesc_(a,b.getMobile())?i18n.phonenumbers.PhoneNumberType.MOBILE:i18n.phonenumbers.PhoneNumberType.UNKNOWN:i18n.phonenumbers.PhoneNumberType.UNKNOWN};
i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegion=function(a){if(null==a)return null;a=a.toUpperCase();var b=this.regionToMetadataMap[a];if(null==b){b=new goog.proto2.PbLiteSerializer;var c=i18n.phonenumbers.metadata.countryToMetadata[a];if(null==c)return null;b=b.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(),c);this.regionToMetadataMap[a]=b}return b};
i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForNonGeographicalRegion=function(a){return this.getMetadataForRegion(""+a)};i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatchingDesc_=function(a,b){var c=a.length;return 0<b.possibleLengthCount()&&-1==b.possibleLengthArray().indexOf(c)?!1:i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(b.getNationalNumberPatternOrDefault(),a)};
i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumber=function(a){var b=this.getRegionCodeForNumber(a);return this.isValidNumberForRegion(a,b)};
i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumberForRegion=function(a,b){var c=a.getCountryCodeOrDefault(),d=this.getMetadataForRegionOrCallingCode_(c,b);if(null==d||i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY!=b&&c!=this.getCountryCodeForValidRegion_(b))return!1;a=this.getNationalSignificantNumber(a);return this.getNumberTypeHelper_(a,d)!=i18n.phonenumbers.PhoneNumberType.UNKNOWN};
i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumber=function(a){if(null==a)return null;var b=a.getCountryCodeOrDefault();b=i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[b];return null==b?null:1==b.length?b[0]:this.getRegionCodeForNumberFromRegionList_(a,b)};
i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumberFromRegionList_=function(a,b){a=this.getNationalSignificantNumber(a);for(var c,d=b.length,e=0;e<d;e++){c=b[e];var f=this.getMetadataForRegion(c);if(f.hasLeadingDigits()){if(0==a.search(f.getLeadingDigits()))return c}else if(this.getNumberTypeHelper_(a,f)!=i18n.phonenumbers.PhoneNumberType.UNKNOWN)return c}return null};
i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForCountryCode=function(a){a=i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];return null==a?i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_:a[0]};i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodesForCountryCode=function(a){a=i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];return null==a?[]:a};
i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForRegion=function(a){return this.isValidRegionCode_(a)?this.getCountryCodeForValidRegion_(a):0};i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForValidRegion_=function(a){var b=this.getMetadataForRegion(a);if(null==b)throw Error("Invalid region code: "+a);return b.getCountryCodeOrDefault()};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNddPrefixForRegion=function(a,b){a=this.getMetadataForRegion(a);if(null==a)return null;a=a.getNationalPrefixOrDefault();if(0==a.length)return null;b&&(a=a.replace("~",""));return a};i18n.phonenumbers.PhoneNumberUtil.prototype.isNANPACountry=function(a){return null!=a&&i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_].includes(a.toUpperCase())};
i18n.phonenumbers.PhoneNumberUtil.prototype.isAlphaNumber=function(a){if(!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(a))return!1;a=new goog.string.StringBuffer(a);this.maybeStripExtension(a);return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_,a.toString())};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumber=function(a){a=this.isPossibleNumberWithReason(a);return a==i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE||a==i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY};i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForType=function(a,b){a=this.isPossibleNumberForTypeWithReason(a,b);return a==i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE||a==i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY};
i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLength_=function(a,b){return this.testNumberLengthForType_(a,b,i18n.phonenumbers.PhoneNumberType.UNKNOWN)};
i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLengthForType_=function(a,b,c){var d=i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b,c),e=0==d.possibleLengthCount()?b.getGeneralDesc().possibleLengthArray():d.possibleLengthArray();d=d.possibleLengthLocalOnlyArray();if(c==i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE)if(i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b,i18n.phonenumbers.PhoneNumberType.FIXED_LINE)))c=
i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b,i18n.phonenumbers.PhoneNumberType.MOBILE),i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(c)&&(e=e.concat(0==c.possibleLengthCount()?b.getGeneralDesc().possibleLengthArray():c.possibleLengthArray()),e.sort(),0==d.length?d=c.possibleLengthLocalOnlyArray():(d=d.concat(c.possibleLengthLocalOnlyArray()),d.sort()));else return this.testNumberLengthForType_(a,b,i18n.phonenumbers.PhoneNumberType.MOBILE);if(-1==e[0])return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH;
a=a.length;if(-1<d.indexOf(a))return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;b=e[0];return b==a?i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE:b>a?i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT:e[e.length-1]<a?i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG:-1<e.indexOf(a,1)?i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE:i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberWithReason=function(a){return this.isPossibleNumberForTypeWithReason(a,i18n.phonenumbers.PhoneNumberType.UNKNOWN)};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForTypeWithReason=function(a,b){var c=this.getNationalSignificantNumber(a);a=a.getCountryCodeOrDefault();if(!this.hasValidCountryCallingCode_(a))return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_COUNTRY_CODE;var d=this.getRegionCodeForCountryCode(a);a=this.getMetadataForRegionOrCallingCode_(a,d);return this.testNumberLengthForType_(c,a,b)};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberString=function(a,b){try{return this.isPossibleNumber(this.parse(a,b))}catch(c){return!1}};
i18n.phonenumbers.PhoneNumberUtil.prototype.truncateTooLongNumber=function(a){if(this.isValidNumber(a))return!0;var b=a.clone(),c=a.getNationalNumberOrDefault();do if(c=Math.floor(c/10),b.setNationalNumber(c),0==c||this.isPossibleNumberWithReason(b)==i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT)return!1;while(!this.isValidNumber(b));a.setNationalNumber(c);return!0};
i18n.phonenumbers.PhoneNumberUtil.prototype.extractCountryCode=function(a,b){a=a.toString();if(0==a.length||"0"==a.charAt(0))return 0;for(var c,d=a.length,e=1;e<=i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_&&e<=d;++e)if(c=parseInt(a.substring(0,e),10),c in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap)return b.append(a.substring(e)),c;return 0};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeExtractCountryCode=function(a,b,c,d,e){if(0==a.length)return 0;a=new goog.string.StringBuffer(a);var f;null!=b&&(f=b.getInternationalPrefix());null==f&&(f="NonMatch");f=this.maybeStripInternationalPrefixAndNormalize(a,f);d&&e.setCountryCodeSource(f);if(f!=i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY){if(a.getLength()<=i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_)throw Error(i18n.phonenumbers.Error.TOO_SHORT_AFTER_IDD);
b=this.extractCountryCode(a,c);if(0!=b)return e.setCountryCode(b),b;throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);}if(null!=b){f=b.getCountryCodeOrDefault();var g=""+f,h=a.toString();if(goog.string.startsWith(h,g)&&(g=new goog.string.StringBuffer(h.substring(g.length)),h=b.getGeneralDesc(),h=new RegExp(h.getNationalNumberPatternOrDefault()),this.maybeStripNationalPrefixAndCarrierCode(g,b,null),g=g.toString(),!i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(h,a.toString())&&i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(h,
g)||this.testNumberLength_(a.toString(),b)==i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG))return c.append(g),d&&e.setCountryCodeSource(i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN),e.setCountryCode(f),f}e.setCountryCode(0);return 0};
i18n.phonenumbers.PhoneNumberUtil.prototype.parsePrefixAsIdd_=function(a,b){var c=b.toString();if(0==c.search(a)){a=c.match(a)[0].length;var d=c.substring(a).match(i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN);if(d&&null!=d[1]&&0<d[1].length&&"0"==i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d[1]))return!1;b.clear();b.append(c.substring(a));return!0}return!1};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripInternationalPrefixAndNormalize=function(a,b){var c=a.toString();if(0==c.length)return i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY;if(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(c))return c=c.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN,""),a.clear(),a.append(i18n.phonenumbers.PhoneNumberUtil.normalize(c)),i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN;
b=new RegExp(b);i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(a);return this.parsePrefixAsIdd_(b,a)?i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD:i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripNationalPrefixAndCarrierCode=function(a,b,c){var d=a.toString(),e=d.length,f=b.getNationalPrefixForParsing();if(0==e||null==f||0==f.length)return!1;var g=new RegExp("^(?:"+f+")");if(e=g.exec(d)){f=new RegExp(b.getGeneralDesc().getNationalNumberPatternOrDefault());var h=i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f,d),k=e.length-1;b=b.getNationalPrefixTransformRule();if(null==b||0==b.length||null==e[k]||0==e[k].length){if(h&&!i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f,
d.substring(e[0].length)))return!1;null!=c&&0<k&&null!=e[k]&&c.append(e[1]);a.set(d.substring(e[0].length))}else{d=d.replace(g,b);if(h&&!i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f,d))return!1;null!=c&&0<k&&c.append(e[1]);a.set(d)}return!0}return!1};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripExtension=function(a){var b=a.toString(),c=b.search(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_);if(0<=c&&i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(b.substring(0,c)))for(var d=b.match(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_),e=d.length,f=1;f<e;++f)if(null!=d[f]&&0<d[f].length)return a.clear(),a.append(b.substring(0,c)),d[f];return""};
i18n.phonenumbers.PhoneNumberUtil.prototype.checkRegionForParsing_=function(a,b){return this.isValidRegionCode_(b)||null!=a&&0<a.length&&i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(a)};i18n.phonenumbers.PhoneNumberUtil.prototype.parse=function(a,b){return this.parseHelper_(a,b,!1,!0)};
i18n.phonenumbers.PhoneNumberUtil.prototype.parseAndKeepRawInput=function(a,b){if(!this.isValidRegionCode_(b)&&0<a.length&&a.charAt(0)!=i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN)throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);return this.parseHelper_(a,b,!0,!0)};i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_=function(a,b){if(1<a.length&&"0"==a.charAt(0)){b.setItalianLeadingZero(!0);for(var c=1;c<a.length-1&&"0"==a.charAt(c);)c++;1!=c&&b.setNumberOfLeadingZeros(c)}};
i18n.phonenumbers.PhoneNumberUtil.prototype.parseHelper_=function(a,b,c,d){if(null==a)throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);if(a.length>i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_)throw Error(i18n.phonenumbers.Error.TOO_LONG);var e=new goog.string.StringBuffer;this.buildNationalNumberForParsing_(a,e);if(!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(e.toString()))throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);if(d&&!this.checkRegionForParsing_(e.toString(),b))throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
d=new i18n.phonenumbers.PhoneNumber;c&&d.setRawInput(a);a=this.maybeStripExtension(e);0<a.length&&d.setExtension(a);var f=this.getMetadataForRegion(b);a=new goog.string.StringBuffer;var g=0,h=e.toString();try{g=this.maybeExtractCountryCode(h,f,a,c,d)}catch(k){if(k.message==i18n.phonenumbers.Error.INVALID_COUNTRY_CODE&&i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(h)){if(h=h.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN,""),g=this.maybeExtractCountryCode(h,
f,a,c,d),0==g)throw k;}else throw k;}0!=g?(e=this.getRegionCodeForCountryCode(g),e!=b&&(f=this.getMetadataForRegionOrCallingCode_(g,e))):(i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(e),a.append(e.toString()),null!=b?(g=f.getCountryCodeOrDefault(),d.setCountryCode(g)):c&&d.clearCountryCodeSource());if(a.getLength()<i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_)throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);null!=f&&(b=new goog.string.StringBuffer,e=new goog.string.StringBuffer(a.toString()),
this.maybeStripNationalPrefixAndCarrierCode(e,f,b),f=this.testNumberLength_(e.toString(),f),g=i18n.phonenumbers.PhoneNumberUtil.ValidationResult,f!=g.TOO_SHORT&&f!=g.IS_POSSIBLE_LOCAL_ONLY&&f!=g.INVALID_LENGTH&&(a=e,c&&0<b.toString().length&&d.setPreferredDomesticCarrierCode(b.toString())));c=a.toString();a=c.length;if(a<i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_)throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);if(a>i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_)throw Error(i18n.phonenumbers.Error.TOO_LONG);
i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_(c,d);d.setNationalNumber(parseInt(c,10));return d};
i18n.phonenumbers.PhoneNumberUtil.prototype.buildNationalNumberForParsing_=function(a,b){var c=a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);if(0<=c){var d=c+i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_.length;if(a.charAt(d)==i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN){var e=a.indexOf(";",d);0<e?b.append(a.substring(d,e)):b.append(a.substring(d))}d=a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_);b.append(a.substring(0<=d?d+i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_.length:
0,c))}else b.append(i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(a));a=b.toString();c=a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_);0<c&&(b.clear(),b.append(a.substring(0,c)))};
i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_=function(a){var b=new i18n.phonenumbers.PhoneNumber;b.setCountryCode(a.getCountryCodeOrDefault());b.setNationalNumber(a.getNationalNumberOrDefault());0<a.getExtensionOrDefault().length&&b.setExtension(a.getExtensionOrDefault());a.getItalianLeadingZero()&&(b.setItalianLeadingZero(!0),b.setNumberOfLeadingZeros(a.getNumberOfLeadingZerosOrDefault()));return b};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatch=function(a,b){if("string"==typeof a)try{var c=this.parse(a,i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_)}catch(f){if(f.message!=i18n.phonenumbers.Error.INVALID_COUNTRY_CODE)return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;if("string"!=typeof b){var d=this.getRegionCodeForCountryCode(b.getCountryCodeOrDefault());if(d!=i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_){try{c=this.parse(a,d)}catch(g){return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER}var e=
this.isNumberMatch(c,b);return e==i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH?i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH:e}}try{c=this.parseHelper_(a,null,!1,!1)}catch(g){return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER}}else c=a.clone();if("string"==typeof b)try{return e=this.parse(b,i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_),this.isNumberMatch(a,e)}catch(f){return f.message!=i18n.phonenumbers.Error.INVALID_COUNTRY_CODE?i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER:
this.isNumberMatch(b,c)}else e=b.clone();a=i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(c);e=i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(e);if(a.hasExtension()&&e.hasExtension()&&a.getExtension()!=e.getExtension())return i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;b=a.getCountryCodeOrDefault();c=e.getCountryCodeOrDefault();if(0!=b&&0!=c)return a.equals(e)?i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH:b==c&&this.isNationalNumberSuffixOfTheOther_(a,e)?i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH:
i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;a.setCountryCode(0);e.setCountryCode(0);return a.equals(e)?i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH:this.isNationalNumberSuffixOfTheOther_(a,e)?i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH:i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNationalNumberSuffixOfTheOther_=function(a,b){a=""+a.getNationalNumber();b=""+b.getNationalNumber();return goog.string.endsWith(a,b)||goog.string.endsWith(b,a)};i18n.phonenumbers.PhoneNumberUtil.prototype.canBeInternationallyDialled=function(a){var b=this.getMetadataForRegion(this.getRegionCodeForNumber(a));if(null==b)return!0;a=this.getNationalSignificantNumber(a);return!this.isNumberMatchingDesc_(a,b.getNoInternationalDialling())};
i18n.phonenumbers.PhoneNumberUtil.matchesEntirely=function(a,b){return(a="string"==typeof a?b.match("^(?:"+a+")$"):b.match(a))&&a[0].length==b.length?!0:!1};i18n.phonenumbers.PhoneNumberUtil.matchesPrefix=function(a,b){return(a="string"==typeof a?b.match("^(?:"+a+")"):b.match(a))&&goog.string.startsWith(b,a[0])?!0:!1};i18n.phonenumbers.shortnumbermetadata={};i18n.phonenumbers.shortnumbermetadata.countryCodeToRegionCodeMap={0:"AC AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW".split(" ")};
i18n.phonenumbers.shortnumbermetadata.countryToMetadata={AC:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"AC",,,,,,,,,,,,,,,,,,[,,"9(?:11|99)",,,,"911"],,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],AD:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[0268]",,,,"110"],[,,,,,,,,,[-1]],,,,"AD",,,,,,,,,,,,,,,,,,[,,"11[0268]",,,,"110"],,[,,"11[0268]",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],AE:[,[,,"[149]\\d{2,3}",,,,,,,[3,4]],,,[,,"112|99[7-9]",
,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"AE",,,,,,,,,,,,,,,,,,[,,"112|99[7-9]",,,,"112",,,[3]],,[,,"112|445[16]|99[7-9]",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"445\\d",,,,"4450",,,[4]]],AF:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"1(?:0[02]|19)",,,,"100",,,[3]],[,,,,,,,,,[-1]],,,,"AF",,,,,,,,,,,,,,,,,,[,,"1(?:0[02]|19)",,,,"100",,,[3]],,[,,"1(?:0[02]|19)|40404",,,,"100"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],AG:[,[,,"[19]\\d\\d",,,,,,,[3]],,,
[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"AG",,,,,,,,,,,,,,,,,,[,,"9(?:11|99)",,,,"911"],,[,,"176|9(?:11|99)",,,,"176"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],AI:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"AI",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"176|911",,,,"176"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],AL:[,[,,"[15]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:1(?:2|6[01]\\d\\d)|2[7-9]|3[15]|41)",,,,"112",,,[3,6]],[,,"5\\d{4}",,,,"50000",
,,[5]],,,,"AL",,,,,,,,,,,,,,,,,,[,,"1(?:12|2[7-9])",,,,"112",,,[3]],,[,,"1(?:1(?:6(?:000|1(?:06|11|23))|8\\d\\d)|65\\d|89[12])|5\\d{4}|1(?:[1349]\\d|2[2-9])",,,,"110"],[,,,,,,,,,[-1]],[,,"123",,,,"123",,,[3]],,[,,"131|5\\d{4}",,,,"131",,,[3,5]]],AM:[,[,,"[148]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"10[1-3]",,,,"101",,,[3]],[,,,,,,,,,[-1]],,,,"AM",,,,,,,,,,,,,,,,,,[,,"10[1-3]",,,,"101",,,[3]],,[,,"(?:1|8[1-7])\\d\\d|40404",,,,"100"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",
,,[5]]],AO:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[235]",,,,"112"],[,,,,,,,,,[-1]],,,,"AO",,,,,,,,,,,,,,,,,,[,,"11[235]",,,,"112"],,[,,"11[235]",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],AR:[,[,,"[01389]\\d{1,4}",,,,,,,[2,3,4,5]],,,[,,"000|1(?:0[0-35-7]|1[0245]|2[015]|3[47]|4[478]|9)|911",,,,"19",,,[2,3]],[,,,,,,,,,[-1]],,,,"AR",,,,,,,,,,,,,,,,,,[,,"10[017]|911",,,,"100",,,[3]],,[,,"000|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478]|9)|3372|89338|911",,,,"19"],[,,,,,,,,,[-1]],[,,"893\\d\\d",
,,,"89300",,,[5]],,[,,"(?:337|893\\d)\\d",,,,"3370",,,[4,5]]],AS:[,[,,"[49]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"911",,,,"911",,,[3]],[,,,,,,,,,[-1]],,,,"AS",,,,,,,,,,,,,,,,,,[,,"911",,,,"911",,,[3]],,[,,"40404|911",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"404\\d\\d",,,,"40400",,,[5]]],AT:[,[,,"1\\d\\d(?:\\d{3})?",,,,,,,[3,6]],,,[,,"116\\d{3}|1(?:[12]2|33|44)",,,,"112"],[,,,,,,,,,[-1]],,,,"AT",,,,,,,,,,,,,,,,,,[,,"1(?:[12]2|33|44)",,,,"112",,,[3]],,[,,"116(?:00[06]|1(?:17|23))|1(?:[12]2|33|44)",
,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],AU:[,[,,"[0-27]\\d{2,7}",,,,,,,[3,4,5,6,7,8]],,,[,,"000|1(?:06|12|258885|55\\d)|733",,,,"000",,,[3,4,7]],[,,"1(?:2(?:34|456)|9\\d{4,6})",,,,"1234",,,[4,5,6,7,8]],,,,"AU",,,,,,,,,,,,,,,,,,[,,"000|1(?:06|12)",,,,"000",,,[3]],,[,,"000|1(?:06|1(?:00|2|9[46])|2(?:014[1-3]|[23]\\d|(?:4|5\\d)\\d{2,3}|68[689]|72(?:20|3\\d\\d)|8(?:[013-9]\\d|2))|555|9\\d{4,6})|225|7(?:33|67)",,,,"000"],[,,"1(?:1[09]\\d|24733)|225|767",,,,"225",,,[3,4,6]],[,,"1(?:258885|55\\d)",
,,,"1550",,,[4,7]],,[,,"19\\d{4,6}",,,,"190000",,,[6,7,8]]],AW:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"100|911",,,,"100"],[,,,,,,,,,[-1]],,,,"AW",,,,,,,,,,,,,,,,,,[,,"100|911",,,,"100"],,[,,"1(?:00|18|76)|91[13]",,,,"100"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],AX:[,[,,"[17]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"112",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"AX",,,,,,,,,,,,,,,,,,[,,"112",,,,"112",,,[3]],,[,,"112|75[12]\\d\\d",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],AZ:[,[,
,"[148]\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:0[1-3]|12)",,,,"101",,,[3]],[,,,,,,,,,[-1]],,,,"AZ",,,,,,,,,,,,,,,,,,[,,"1(?:0[1-3]|12)",,,,"101",,,[3]],,[,,"1(?:0[1-3]|12)|(?:404|880)0",,,,"101"],[,,,,,,,,,[-1]],[,,"(?:404|880)\\d",,,,"4040",,,[4]],,[,,"(?:404|880)\\d",,,,"4040",,,[4]]],BA:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:16\\d{3}|2[2-4])",,,,"122",,,[3,6]],[,,,,,,,,,[-1]],,,,"BA",,,,,,,,,,,,,,,,,,[,,"12[2-4]",,,,"122",,,[3]],,[,,"1(?:16(?:00[06]|1(?:1[17]|23))|2(?:0[0-7]|[2-5]|6[0-26])|(?:[3-5]|7\\d)\\d\\d)|1(?:18|2[78])\\d\\d?",
,,,"122"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],BB:[,[,,"[2-689]\\d\\d",,,,,,,[3]],,,[,,"[2359]11",,,,"211"],[,,,,,,,,,[-1]],,,,"BB",,,,,,,,,,,,,,,,,,[,,"[2359]11",,,,"211"],,[,,"[2-689]11",,,,"211"],[,,,,,,,,,[-1]],[,,"[468]11",,,,"411"],,[,,,,,,,,,[-1]]],BD:[,[,,"[1579]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"10[0-26]|[19]99",,,,"100",,,[3]],[,,,,,,,,,[-1]],,,,"BD",,,,,,,,,,,,,,,,,,[,,"10[0-2]|[19]99",,,,"100",,,[3]],,[,,"1(?:0(?:[0-369]|5[1-4]|7[0-4]|8[0-29])|1[16-9]|2(?:[134]|2[0-5])|3(?:1\\d?|6[3-6])|5[2-9])|5012|786|9594|[19]99|1(?:0(?:50|6\\d)|33|4(?:0|1\\d))\\d",
,,,"100"],[,,,,,,,,,[-1]],[,,"1(?:11|2[13])|(?:501|959)\\d|786",,,,"111",,,[3,4]],,[,,"959\\d",,,,"9590",,,[4]]],BE:[,[,,"[1-9]\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"1(?:0[0-25-8]|1[02]|7(?:12|77)|813)|(?:116|8)\\d{3}",,,,"100"],[,,"1(?:2[03]|40)4|(?:1(?:[24]1|3[01])|[2-79]\\d\\d)\\d",,,,"1204",,,[4]],,,,"BE",,,,,,,,,,,,,,,,,,[,,"1(?:0[01]|12)",,,,"100",,,[3]],,[,,"1(?:0[0-8]|1(?:[027]|6117)|2(?:12|3[0-24])|313|414|5(?:1[05]|5[15]|66|95)|6(?:1[167]|36|6[16])|7(?:[07][017]|1[27-9]|22|33|65)|81[39])|[2-9]\\d{3}|1(?:1600|45)0|1(?:[2-4]9|78)9|1[2-4]0[47]",
,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"[2-9]\\d{3}",,,,"2000",,,[4]]],BF:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],,,,"BF",,,,,,,,,,,,,,,,,,[,,"1[78]",,,,"17"],,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],BG:[,[,,"1\\d\\d(?:\\d{3})?",,,,,,,[3,6]],,,[,,"1(?:1(?:2|6\\d{3})|50|6[06])",,,,"112"],[,,,,,,,,,[-1]],,,,"BG",,,,,,,,,,,,,,,,,,[,,"1(?:12|50|6[06])",,,,"112",,,[3]],,[,,"1(?:1(?:2|6(?:000|111))|50|6[06])",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,
[-1]],,[,,,,,,,,,[-1]]],BH:[,[,,"[0189]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"(?:0[167]|81)\\d{3}|[19]99",,,,"199"],[,,"9[148]\\d{3}",,,,"91000",,,[5]],,,,"BH",,,,,,,,,,,,,,,,,,[,,"[19]99",,,,"199",,,[3]],,[,,"1(?:[02]\\d|12|4[01]|51|8[18]|9[169])|99[02489]|(?:0[167]|8[158]|9[148])\\d{3}",,,,"100"],[,,,,,,,,,[-1]],[,,"0[67]\\d{3}|88000|98555",,,,"06000",,,[5]],,[,,"88000|98555",,,,"88000",,,[5]]],BI:[,[,,"[16-9]\\d{2,3}",,,,,,,[3,4]],,,[,,"11[237]|611",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"BI",,,,,,
,,,,,,,,,,,,[,,"11[237]",,,,"112",,,[3]],,[,,"1(?:1\\d|5[2-9]|6[0-256])|611|7(?:10|77|979)|8[28]8|900",,,,"110"],[,,,,,,,,,[-1]],[,,"611|7(?:10|77)|888|900",,,,"611",,,[3]],,[,,"(?:71|90)0",,,,"710",,,[3]]],BJ:[,[,,"[17]\\d{2,3}",,,,,,,[3,4]],,,[,,"11[78]|7[3-5]\\d\\d",,,,"117"],[,,,,,,,,,[-1]],,,,"BJ",,,,,,,,,,,,,,,,,,[,,"11[78]",,,,"117",,,[3]],,[,,"1(?:1[78]|2[02-5]|60)|7[0-5]\\d\\d",,,,"117"],[,,,,,,,,,[-1]],[,,"12[02-5]",,,,"120",,,[3]],,[,,,,,,,,,[-1]]],BL:[,[,,"1\\d",,,,,,,[2]],,,[,,"18",,
,,"18"],[,,,,,,,,,[-1]],,,,"BL",,,,,,,,,,,,,,,,,,[,,"18",,,,"18"],,[,,"18",,,,"18"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],BM:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"BM",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"176|911",,,,"176"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],BN:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"99[135]",,,,"991"],[,,,,,,,,,[-1]],,,,"BN",,,,,,,,,,,,,,,,,,[,,"99[135]",,,,"991"],,[,,"99[135]",,,,"991"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
,[,,,,,,,,,[-1]]],BO:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"11[089]",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"BO",,,,,,,,,,,,,,,,,,[,,"11[089]",,,,"110",,,[3]],,[,,"11[089]|40404",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"404\\d\\d",,,,"40400",,,[5]]],BQ:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"112|911",,,,"112"],[,,,,,,,,,[-1]],,,,"BQ",,,,,,,,,,,,,,,,,,[,,"112|911",,,,"112"],,[,,"1(?:12|76)|911",,,,"112"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],BR:[,[,,"[1-69]\\d{2,5}",,,,,,,[3,
4,5,6]],,,[,,"1(?:00|12|28|8[015]|9[0-47-9])|4(?:57|82\\d)|911",,,,"100",,,[3,4]],[,,,,,,,,,[-1]],,,,"BR",,,,,,,,,,,,,,,,,,[,,"1(?:12|28|9[023])|911",,,,"112",,,[3]],,[,,"1(?:0(?:[02]|3(?:1[2-579]|2[13-9]|3[124-9]|4[1-3578]|5[1-468]|6[139]|8[149]|9[168])|5[0-35-9]|6(?:0|1[0-35-8]?|2[0145]|3[0137]?|4[37-9]?|5[0-35]|6[016]?|7[137]?|8[5-8]|9[1359]))|1[25-8]|2[357-9]|3[024-68]|4[12568]|5\\d|6[0-8]|8[015]|9[0-47-9])|2(?:7(?:330|878)|85959?)|(?:32|91)1|4(?:0404?|57|828)|55555|6(?:0\\d{4}|10000)|(?:133|411)[12]",
,,,"100"],[,,"102|273\\d\\d|321",,,,"102",,,[3,5]],[,,"151|(?:278|555)\\d\\d|4(?:04\\d\\d?|11\\d|57)",,,,"151",,,[3,4,5]],,[,,"285\\d{2,3}|321|40404|(?:27[38]\\d|482)\\d|6(?:0\\d|10)\\d{3}",,,,"321"]],BS:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"91[19]",,,,"911"],[,,,,,,,,,[-1]],,,,"BS",,,,,,,,,,,,,,,,,,[,,"91[19]",,,,"911"],,[,,"91[19]",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],BT:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"11[023]",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"BT",,,,,,,,,,,,
,,,,,,[,,"11[023]",,,,"110",,,[3]],,[,,"11[0-6]|40404",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"404\\d\\d",,,,"40400",,,[5]]],BW:[,[,,"[19]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"9(?:11|9[7-9])",,,,"911",,,[3]],[,,,,,,,,,[-1]],,,,"BW",,,,,,,,,,,,,,,,,,[,,"9(?:11|9[7-9])",,,,"911",,,[3]],,[,,"1(?:1[26]|3123)|9(?:1[14]|9[1-57-9])",,,,"112"],[,,,,,,,,,[-1]],[,,"131\\d\\d",,,,"13100",,,[5]],,[,,"131\\d\\d",,,,"13100",,,[5]]],BY:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"1(?:0[1-3]|12)",,,,"101"],[,,,,,,,,,[-1]],
,,,"BY",,,,,,,,,,,,,,,,,,[,,"1(?:0[1-3]|12)",,,,"101"],,[,,"1(?:0[1-79]|1[246]|35|5[1-35]|6[89]|7[5-7]|8[58]|9[1-7])",,,,"101"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],BZ:[,[,,"9\\d\\d?",,,,,,,[2,3]],,,[,,"9(?:0|11)",,,,"90"],[,,,,,,,,,[-1]],,,,"BZ",,,,,,,,,,,,,,,,,,[,,"9(?:0|11)",,,,"90"],,[,,"9(?:0|11)",,,,"90"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CA:[,[,,"[1-9]\\d\\d(?:\\d\\d(?:\\d(?:\\d{2})?)?)?",,,,,,,[3,5,6,8]],,,[,,"112|[29]11",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"CA",
,,,,,,,,,,,,,,,,,[,,"112|911",,,,"112",,,[3]],,[,,"112|30000\\d{3}|[1-35-9]\\d{4,5}|[2-9]11",,,,"112"],[,,,,,,,,,[-1]],[,,"[235-7]11",,,,"211",,,[3]],,[,,"300\\d{5}|[1-35-9]\\d{4,5}",,,,"10000",,,[5,6,8]]],CC:[,[,,"[01]\\d\\d",,,,,,,[3]],,,[,,"000|112",,,,"000"],[,,,,,,,,,[-1]],,,,"CC",,,,,,,,,,,,,,,,,,[,,"000|112",,,,"000"],,[,,"000|112",,,,"000"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CD:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"1(?:1[348]|77|88)",,,,"113",,,[3]],[,,,,,,,,,[-1]],
,,,"CD",,,,,,,,,,,,,,,,,,[,,"1(?:1[348]|77|88)",,,,"113",,,[3]],,[,,"1(?:1[348]|23|77|88)|40404",,,,"113"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],CF:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1[78]|22\\d)",,,,"117"],[,,,,,,,,,[-1]],,,,"CF",,,,,,,,,,,,,,,,,,[,,"1(?:1[78]|220)",,,,"117"],,[,,"1(?:1[478]|220)",,,,"114"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CG:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[178]",,,,"111"],[,,,,,,,,,[-1]],,,,"CG",,,,,,,,,,,,,
,,,,,[,,"11[78]",,,,"117"],,[,,"11[126-8]",,,,"111"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CH:[,[,,"[1-9]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:1(?:[278]|6\\d{3})|4[47])|5200",,,,"112",,,[3,4,6]],[,,"1(?:14|8[01589])\\d|543|83111",,,,"543",,,[3,4,5]],,,,"CH",,,,,,,,,,,,,,,,,,[,,"1(?:1[278]|44)",,,,"112",,,[3]],,[,,"1(?:0[78]\\d\\d|1(?:[278]|45|6(?:000|111))|4(?:[03-57]|1[45])|6(?:00|[1-46])|8(?:02|1[189]|50|7|8[08]|99))|[2-9]\\d{2,4}",,,,"112"],[,,"1(?:4[035]|6[1-46])|1(?:41|60)\\d",,,,
"140",,,[3,4]],[,,"5(?:200|35)",,,,"535",,,[3,4]],,[,,"[2-9]\\d{2,4}",,,,"200",,,[3,4,5]]],CI:[,[,,"[14]\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1[01]|[78]0)",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"CI",,,,,,,,,,,,,,,,,,[,,"1(?:1[01]|[78]0)",,,,"110",,,[3]],,[,,"1(?:1[01]|[78]0)|4443",,,,"110"],[,,,,,,,,,[-1]],[,,"444\\d",,,,"4440",,,[4]],,[,,"444\\d",,,,"4440",,,[4]]],CK:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"99[689]",,,,"996"],[,,,,,,,,,[-1]],,,,"CK",,,,,,,,,,,,,,,,,,[,,"99[689]",,,,"996"],,[,,"99[689]",,,,"996"],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CL:[,[,,"[1-9]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:213|3[1-3])|434\\d|911",,,,"131",,,[3,4]],[,,"1(?:211|3(?:13|[348]0|5[01]))|(?:1(?:[05]6|[48]1|9[18])|2(?:01\\d|[23]2|77|88)|3(?:0[59]|13|3[279]|66)|4(?:[12]4|36\\d|4[017]|55)|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d",,,,"1060",,,[4,5]],,,,"CL",,,,,,,,,,,,,,,,,,[,,"13[1-3]|911",,,,"131",,,[3]],,[,,"1(?:00|21[13]|3(?:13|[348]0|5[01])|4(?:0[02-6]|17|[379])|818|919)|2(?:0(?:01|122)|22[47]|323|777|882)|3(?:0(?:51|99)|132|3(?:29|[37]7)|665)|43656|5(?:(?:00|415)4|5(?:66|77)|995)|6(?:131|222|366|699)|7878|8(?:011|11[28]|482|889)|9(?:01|1)1|13\\d|4(?:[13]42|243|4(?:02|15|77)|554)|(?:1(?:[05]6|98)|339|6(?:07|[35])0|9(?:[12]0|33))0",
,,,"100"],[,,"(?:200|333)\\d",,,,"2000",,,[4]],[,,,,,,,,,[-1]],,[,,"13(?:13|[348]0|5[01])|(?:1(?:[05]6|[28]1|4[01]|9[18])|2(?:0(?:0|1\\d)|[23]2|77|88)|3(?:0[59]|13|3[2379]|66)|436\\d|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d|4(?:[1-3]4|4[017]|55)\\d",,,,"1060",,,[4,5]]],CM:[,[,,"[18]\\d{1,3}",,,,,,,[2,3,4]],,,[,,"1(?:1[37]|[37])",,,,"13",,,[2,3]],[,,,,,,,,,[-1]],,,,"CM",,,,,,,,,,,,,,,,,,[,,"1(?:1[37]|[37])",,,,"13",,,[2,3]],,[,,"1(?:1[37]|[37])|8711",
,,,"13"],[,,,,,,,,,[-1]],[,,"871\\d",,,,"8710",,,[4]],,[,,"871\\d",,,,"8710",,,[4]]],CN:[,[,,"[19]\\d\\d(?:\\d{2,3})?",,,,,,,[3,5,6]],,,[,,"1(?:1[09]|20)",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"CN",,,,,,,,,,,,,,,,,,[,,"1(?:1[09]|20)",,,,"110",,,[3]],,[,,"1(?:00\\d\\d|1[029]|20)|95\\d{3,4}",,,,"110"],[,,"1(?:00\\d\\d|12)|95\\d{3,4}",,,,"112"],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CO:[,[,,"[148]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"1(?:1[29]|23|32|56)",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"CO",,,,,,,,,,,,,,
,,,,[,,"1(?:1[29]|23|32|56)",,,,"112",,,[3]],,[,,"1(?:06|1[2-9]|2[35-7]|3[27]|4[467]|5[36]|6[4-7]|95)|40404|85432",,,,"106"],[,,,,,,,,,[-1]],[,,"(?:40|85)4\\d\\d",,,,"40400",,,[5]],,[,,"(?:40|85)4\\d\\d",,,,"40400",,,[5]]],CR:[,[,,"[1359]\\d{2,3}",,,,,,,[3,4]],,,[,,"112|911",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"CR",,,,,,,,,,,,,,,,,,[,,"112|911",,,,"112",,,[3]],,[,,"1(?:0(?:00|15|2[2-4679])|1(?:1[0-35-9]|2|37|[46]6|7[57]|8[79]|9[0-379])|2(?:00|[12]2|34|55)|3(?:21|33)|4(?:0[06]|1[4-6])|5(?:15|5[15])|693|7(?:00|1[7-9]|2[02]|[67]7)|975)|3855|5(?:0(?:30|49)|510)|911",
,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"(?:385|5(?:0[34]|51))\\d",,,,"3850",,,[4]]],CU:[,[,,"[12]\\d\\d(?:\\d{3,4})?",,,,,,,[3,6,7]],,,[,,"10[4-7]|(?:116|204\\d)\\d{3}",,,,"104"],[,,,,,,,,,[-1]],,,,"CU",,,,,,,,,,,,,,,,,,[,,"10[4-6]",,,,"104",,,[3]],,[,,"1(?:0[4-7]|1(?:6111|8)|40)|2045252",,,,"104"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CV:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"13[0-2]",,,,"130"],[,,,,,,,,,[-1]],,,,"CV",,,,,,,,,,,,,,,,,,[,,"13[0-2]",,,,"130"],,[,,"13[0-2]",,,,"130"],[,
,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CW:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"112|911",,,,"112"],[,,,,,,,,,[-1]],,,,"CW",,,,,,,,,,,,,,,,,,[,,"112|911",,,,"112"],,[,,"1(?:12|76)|911",,,,"112"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],CX:[,[,,"[01]\\d\\d",,,,,,,[3]],,,[,,"000|112",,,,"000"],[,,,,,,,,,[-1]],,,,"CX",,,,,,,,,,,,,,,,,,[,,"000|112",,,,"000"],,[,,"000|112",,,,"000"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CY:[,[,,"1\\d\\d(?:\\d{3})?",,,,,,,[3,6]],,,[,,"1(?:1(?:2|6\\d{3})|99)",
,,,"112"],[,,,,,,,,,[-1]],,,,"CY",,,,,,,,,,,,,,,,,,[,,"1(?:12|99)",,,,"112",,,[3]],,[,,"1(?:1(?:2|6(?:000|111))|99)",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CZ:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:1(?:2|6(?:00[06]|1(?:11|23)))|5[0568])",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"CZ",,,,,,,,,,,,,,,,,,[,,"1(?:12|5[0568])",,,,"112",,,[3]],,[,,"1(?:1(?:2|8\\d)|(?:2|3\\d)\\d{2,3}|5[0568]|99)|1(?:16|4)\\d{3}",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],DE:[,[,,"1\\d\\d(?:\\d{2,3})?",
,,,,,,[3,5,6]],,,[,,"11(?:[02]|6\\d{3})",,,,"110",,,[3,6]],[,,,,,,,,,[-1]],,,,"DE",,,,,,,,,,,,,,,,,,[,,"11[02]",,,,"110",,,[3]],,[,,"11(?:[025]|6(?:00[06]|1(?:1[167]|23))|800\\d)|118\\d\\d",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],DJ:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],,,,"DJ",,,,,,,,,,,,,,,,,,[,,"1[78]",,,,"17"],,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],DK:[,[,,"1\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"11(?:[24]|6\\d{3})",
,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"DK",,,,,,,,,,,,,,,,,,[,,"11[24]",,,,"112",,,[3]],,[,,"1(?:1(?:[2-48]|6(?:00[06]|111))|8(?:[08]1|1[0238]|28|30|5[13]))",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],DM:[,[,,"[39]\\d\\d",,,,,,,[3]],,,[,,"333|9(?:11|99)",,,,"333"],[,,,,,,,,,[-1]],,,,"DM",,,,,,,,,,,,,,,,,,[,,"333|9(?:11|99)",,,,"333"],,[,,"333|9(?:11|99)",,,,"333"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],DO:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"112|911",,,,"112"],[,,,,,,,,,[-1]],
,,,"DO",,,,,,,,,,,,,,,,,,[,,"112|911",,,,"112"],,[,,"112|911",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],DZ:[,[,,"[17]\\d{1,3}",,,,,,,[2,3,4]],,,[,,"1(?:12|[47]|54\\d)",,,,"14"],[,,,,,,,,,[-1]],,,,"DZ",,,,,,,,,,,,,,,,,,[,,"1(?:12|[47])",,,,"14",,,[2,3]],,[,,"1(?:055|12|[47]|548)|730",,,,"14"],[,,,,,,,,,[-1]],[,,"730",,,,"730",,,[3]],,[,,"730",,,,"730",,,[3]]],EC:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"1(?:0[12]|12)|911",,,,"101"],[,,,,,,,,,[-1]],,,,"EC",,,,,,,,,,,,,,,,,,[,,"1(?:0[12]|12)|911",
,,,"101"],,[,,"1(?:0[12]|12)|911",,,,"101"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],EE:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:1(?:[02]|6\\d{3})|2(?:05|28)|3(?:014|3(?:21|5\\d?)|660)|492|5(?:1[03]|410|501)|6(?:112|333|644)|7(?:012|127|89)|8(?:10|8[57])|9(?:0[134]|14))",,,,"110"],[,,"1(?:18(?:00|[12458]\\d?)|2(?:0(?:[02-46-8]\\d?|1[0-36])|1(?:[0-4]\\d?|6[06])|2(?:[0-4]\\d?|5[25])|[367]|4(?:0[04]|[12]\\d?|4[24]|54)|55[12457])|3(?:0(?:[02]\\d?|1[13578]|3[356])|1[1347]|2[02-5]|3(?:[01347]\\d?|2[023]|88)|4(?:[35]\\d?|4[34])|5(?:3[134]|5[035])|666)|4(?:2(?:00|4\\d?)|4(?:0[01358]|1[024]|50|7\\d?)|900)|5(?:0[0-35]|1(?:[1267]\\d?|5[0-7]|82)|2(?:[014-6]\\d?|22)|330|4(?:[35]\\d?|44)|5(?:00|[1-69]\\d?)|9(?:[159]\\d?|[38]0|77))|6(?:1(?:00|1[19]|[35-9]\\d?)|2(?:2[26]|[68]\\d?)|3(?:22|36|6[36])|5|6(?:[0-359]\\d?|6[0-26])|7(?:00|55|7\\d?|8[89])|9(?:00|1\\d?|69))|7(?:0(?:[023]\\d?|1[0578])|1(?:00|2[034]|[4-9]\\d?)|2(?:[07]\\d?|20|44)|7(?:[0-57]\\d?|9[79])|8(?:0[08]|2\\d?|8[0178])|9(?:00|97))|8(?:1[127]|8[1268]|9[269])|9(?:0(?:[02]\\d?|69|9[0269])|1[1-3689]|21))",
,,,"123",,,[3,4,5]],,,,"EE",,,,,,,,,,,,,,,,,,[,,"11[02]",,,,"110",,,[3]],,[,,"1(?:1(?:[02-579]|6(?:000|111)|8(?:[09]\\d|[1-8]))|2[36-9]|3[7-9]|4[05-7]|5[6-8]|6[05]|7[3-6]|8[02-7]|9[3-9])|1(?:2[0-245]|3[0-6]|4[1-489]|5[0-59]|6[1-46-9]|7[0-27-9]|8[189]|9[0-2])\\d\\d?",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"1(?:18[1258]|2(?:0(?:1[036]|[46]\\d?)|166|21|4(?:0[04]|1\\d?|5[47])|[67])|3(?:0(?:1[13-578]|2\\d?|3[56])|1[15]|2[045]|3(?:[13]\\d?|2[13])|43|5(?:00|3[34]|53))|44(?:0[0135]|14|50|7\\d?)|5(?:05|1(?:[12]\\d?|5[1246]|8[12])|2(?:[01]\\d?|22)|3(?:00|3[03])|4(?:15|5\\d?)|500|9(?:5\\d?|77|80))|6(?:1[35-8]|226|3(?:22|3[36]|66)|644|7(?:00|7\\d?|89)|9(?:00|69))|7(?:01[258]|1(?:00|[15]\\d?)|2(?:44|7\\d?)|8(?:00|87|9\\d?))|8(?:1[128]|8[56]|9(?:[26]\\d?|77))|90(?:2\\d?|69|92))",
,,,"126",,,[3,4,5]]],EG:[,[,,"[13]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"1(?:2[23]|80)",,,,"122",,,[3]],[,,,,,,,,,[-1]],,,,"EG",,,,,,,,,,,,,,,,,,[,,"1(?:2[23]|80)",,,,"122",,,[3]],,[,,"1(?:2[23]|[69]\\d{3}|80)|34400",,,,"122"],[,,,,,,,,,[-1]],[,,"344\\d\\d",,,,"34400",,,[5]],,[,,"344\\d\\d",,,,"34400",,,[5]]],EH:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:[59]|77)",,,,"15"],[,,,,,,,,,[-1]],,,,"EH",,,,,,,,,,,,,,,,,,[,,"1(?:[59]|77)",,,,"15"],,[,,"1(?:[59]|77)",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,
,,,,,,,,[-1]]],ER:[,[,,"[12]\\d\\d(?:\\d{3})?",,,,,,,[3,6]],,,[,,"11[2-46]|(?:12[47]|20[12])\\d{3}",,,,"112"],[,,,,,,,,,[-1]],,,,"ER",,,,,,,,,,,,,,,,,,[,,"1(?:1[2-46]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99",,,,"112"],,[,,"1(?:1[2-6]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],ES:[,[,,"[0-379]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"0(?:16|6[57]|8[58])|1(?:006|12|[3-7]\\d\\d)|(?:116|20\\d)\\d{3}",,,,"016",,,[3,4,6]],[,,"[12]2\\d{1,4}|90(?:5\\d|7)|(?:118|2(?:[357]\\d|80)|3[357]\\d)\\d\\d|[79]9[57]\\d{3}",
,,,"120"],,,,"ES",,,,,,,,,,,,,,,,,,[,,"08[58]|112",,,,"085",,,[3]],,[,,"0(?:1[0-26]|6[0-257]|8[058]|9[12])|1(?:0[03-57]\\d{1,3}|1(?:2|6(?:000|111)|8\\d\\d)|2\\d{1,4}|[3-9]\\d\\d)|2(?:2\\d{1,4}|80\\d\\d)|90(?:5[124578]|7)|1(?:3[34]|77)|(?:2[01]\\d|[79]9[57])\\d{3}|[23][357]\\d{3}",,,,"010"],[,,"0(?:[16][0-2]|80|9[12])|21\\d{4}",,,,"010",,,[3,6]],[,,"1(?:3[34]|77)|[12]2\\d{1,4}",,,,"120"],,[,,"(?:2[0-2]\\d|3[357]|[79]9[57])\\d{3}|2(?:[2357]\\d|80)\\d\\d",,,,"22000",,,[5,6]]],ET:[,[,,"9\\d\\d?",,,,,
,,[2,3]],,,[,,"9(?:07|11?|2|39?|9[17])",,,,"91"],[,,,,,,,,,[-1]],,,,"ET",,,,,,,,,,,,,,,,,,[,,"9(?:11?|2|39?|9[17])",,,,"91"],,[,,"9(?:07|11?|2|39?|45|9[17])",,,,"91"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],FI:[,[,,"[17]\\d\\d(?:\\d{2,3})?",,,,,,,[3,5,6]],,,[,,"11(?:2|6\\d{3})",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"FI",,,,,,,,,,,,,,,,,,[,,"112",,,,"112",,,[3]],,[,,"11(?:2|6(?:00[06]|11[17]))|75[12]\\d\\d",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],FJ:[,[,,"[0-579]\\d(?:\\d(?:\\d{2})?)?",
,,,,,,[2,3,5]],,,[,,"91[17]",,,,"911",,,[3]],[,,,,,,,,,[-1]],,,,"FJ",,,,,,,,,,,,,,,,,,[,,"91[17]",,,,"911",,,[3]],,[,,"0(?:1[34]|8[1-4])|1(?:0[1-3]|[25]9)|2[289]|30|40404|91[137]|[45]4|75",,,,"22"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"404\\d\\d",,,,"40400",,,[5]]],FK:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"FK",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"1\\d\\d|999",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],FM:[,[,,"[39]\\d\\d(?:\\d{3})?",,,,,,,[3,6]],
,,[,,"320\\d{3}|911",,,,"911"],[,,,,,,,,,[-1]],,,,"FM",,,,,,,,,,,,,,,,,,[,,"(?:32022|91)1",,,,"911"],,[,,"(?:32022|91)1",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],FO:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"11[24]",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"FO",,,,,,,,,,,,,,,,,,[,,"11[24]",,,,"112",,,[3]],,[,,"11[248]|1(?:4[124]|71|8[7-9])\\d",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],FR:[,[,,"[1-8]\\d{1,5}",,,,,,,[2,3,4,5,6]],,,[,,"1(?:0(?:07|[13]3)|1[02459]|[578]|9[167])|224|(?:3370|74)0|(?:116\\d|3[01])\\d\\d",
,,,"15"],[,,"(?:118|[4-8]\\d)\\d{3}|36665",,,,"36665",,,[5,6]],,,,"FR",,,,,,,,,,,,,,,,,,[,,"1(?:12|[578])",,,,"15",,,[2,3]],,[,,"1(?:0\\d\\d|1(?:[02459]|6(?:000|111)|8\\d{3})|[578]|9[167])|2(?:0(?:00|2)0|24)|[3-8]\\d{4}|3\\d{3}|6(?:1[14]|34)|7(?:0[06]|22|40)",,,,"15"],[,,"10(?:[134]4|2[23]|5\\d|99)|202\\d|3(?:646|9[07]0)|634|70[06]|(?:106|61)[14]",,,,"611",,,[3,4]],[,,"118777|224|6(?:1[14]|34)|7(?:0[06]|22|40)|20(?:0\\d|2)\\d",,,,"224",,,[3,4,5,6]],,[,,"114|[3-8]\\d{4}",,,,"114",,,[3,5]]],GA:[,[,
,"1\\d(?:\\d{2})?",,,,,,,[2,4]],,,[,,"18|1(?:3\\d|73)\\d",,,,"18"],[,,,,,,,,,[-1]],,,,"GA",,,,,,,,,,,,,,,,,,[,,"1(?:3\\d\\d|730|8)",,,,"18"],,[,,"1(?:3\\d\\d|730|8)",,,,"18"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GB:[,[,,"[1-46-9]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:05|1(?:[29]|6\\d{3})|7[56]\\d|8000)|2(?:20\\d|48)|4444|999",,,,"105"],[,,,,,,,,,[-1]],,,,"GB",,,,,,,,,,,,,,,,,,[,,"112|999",,,,"112",,,[3]],,[,,"1(?:0[015]|1(?:[129]|6(?:000|1(?:11|23))|8\\d{3})|2(?:[1-3]|50)|33|4(?:1|7\\d)|571|7(?:0\\d|[56]0)|800\\d|9[15])|2(?:0202|1300|2(?:02|11)|3(?:02|336|45)|4(?:25|8))|3[13]3|4(?:0[02]|35[01]|44[45]|5\\d)|(?:[68]\\d|7[089])\\d{3}|15\\d|2[02]2|650|789|9(?:01|99)",
,,,"100"],[,,,,,,,,,[-1]],[,,"1(?:(?:25|7[56])\\d|571)|2(?:02(?:\\d{2})?|[13]3\\d\\d|48)|4444|901",,,,"202",,,[3,4,5]],,[,,"(?:125|2(?:020|13\\d)|(?:7[089]|8[01])\\d\\d)\\d",,,,"1250",,,[4,5]]],GD:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"GD",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"176|911",,,,"176"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],GE:[,[,,"[014]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"0(?:11|33)|11[1-3]|[01]22",,,,"011",,,[3]],[,,,,,,,,,[-1]],,,,
"GE",,,,,,,,,,,,,,,,,,[,,"0(?:11|33)|11[1-3]|[01]22",,,,"011",,,[3]],,[,,"0(?:11|33)|11[1-3]|40404|[01]22",,,,"011"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],GF:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],,,,"GF",,,,,,,,,,,,,,,,,,[,,"1[578]",,,,"15"],,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GG:[,[,,"[19]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"112|999",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"GG",,,,,,,,,,,,,,,,,,[,,"112|999",
,,,"112",,,[3]],,[,,"1(?:0[01]|1[12]|23|41|55|9[05])|999|1(?:1[68]\\d\\d|47|800)\\d",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GH:[,[,,"[14589]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"19[1-3]|999",,,,"191",,,[3]],[,,,,,,,,,[-1]],,,,"GH",,,,,,,,,,,,,,,,,,[,,"19[1-3]|999",,,,"191",,,[3]],,[,,"19[1-3]|40404|(?:54|83)00|999",,,,"191"],[,,,,,,,,,[-1]],[,,"404\\d\\d|(?:54|83)0\\d",,,,"5400",,,[4,5]],,[,,"404\\d\\d|(?:54|83)0\\d",,,,"5400",,,[4,5]]],GI:[,[,,"[158]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,
"1(?:00|1[25]|23|4(?:1|7\\d)|5[15]|9[02-49])|555|(?:116\\d|80)\\d\\d",,,,"100",,,[3,4,6]],[,,"8[1-69]\\d\\d",,,,"8100",,,[4]],,,,"GI",,,,,,,,,,,,,,,,,,[,,"1(?:12|9[09])",,,,"112",,,[3]],,[,,"1(?:00|1(?:[25]|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|23|4(?:1|7[014])|5[015]|9[02-49])|555|8[0-79]\\d\\d|8(?:00|4[0-2]|8[0-589])",,,,"100"],[,,"150|87\\d\\d",,,,"150",,,[3,4]],[,,"1(?:00|1(?:5|8\\d\\d)|23|51|9[2-4])|555|8(?:00|4[0-2]|8[0-589])",,,,"100",,,[3,5]],,[,,,,,,,,,[-1]]],GL:[,[,,"1\\d\\d",,,,,,,[3]],,,
[,,"112",,,,"112"],[,,,,,,,,,[-1]],,,,"GL",,,,,,,,,,,,,,,,,,[,,"112",,,,"112"],,[,,"112",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GM:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:1[6-8]|[6-8])",,,,"16"],[,,,,,,,,,[-1]],,,,"GM",,,,,,,,,,,,,,,,,,[,,"1(?:1[6-8]|[6-8])",,,,"16"],,[,,"1(?:1[6-8]|[6-8])",,,,"16"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GN:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,,"GN",,,,,,,,,,,,,,,,,,[,,,,,,,,,[-1]],,[,,"12\\d|40404",
,,,"120"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],GP:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],,,,"GP",,,,,,,,,,,,,,,,,,[,,"1[578]",,,,"15"],,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GR:[,[,,"1\\d\\d(?:\\d{2,3})?",,,,,,,[3,5,6]],,,[,,"1(?:0[089]|1(?:2|6\\d{3})|66|99)",,,,"100",,,[3,6]],[,,,,,,,,,[-1]],,,,"GR",,,,,,,,,,,,,,,,,,[,,"1(?:00|12|66|99)",,,,"100",,,[3]],,[,,"1(?:0[089]|1(?:2|320|6(?:000|1(?:1[17]|23)))|(?:389|9)9|66)",
,,,"100"],[,,"113\\d\\d",,,,"11300",,,[5]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GT:[,[,,"[14]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:10|2[03])",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"GT",,,,,,,,,,,,,,,,,,[,,"1(?:10|2[03])",,,,"110",,,[3]],,[,,"110|40404|1(?:2|[57]\\d)\\d",,,,"110"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],GU:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"GU",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"911",,,,"911"],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GW:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[378]",,,,"113"],[,,,,,,,,,[-1]],,,,"GW",,,,,,,,,,,,,,,,,,[,,"11[378]",,,,"113"],,[,,"11[378]",,,,"113"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GY:[,[,,"[019]\\d{2,3}",,,,,,,[3,4]],,,[,,"91[1-3]",,,,"911",,,[3]],[,,,,,,,,,[-1]],,,,"GY",,,,,,,,,,,,,,,,,,[,,"91[1-3]",,,,"911",,,[3]],,[,,"0(?:02|(?:17|80)1|444|7(?:[67]7|9)|9(?:0[78]|[2-47]))|1(?:443|5[568])|91[1-3]",,,,"002"],[,,,,,,,,,[-1]],[,,"144\\d",,,,"1440",,,[4]],
,[,,"144\\d",,,,"1440",,,[4]]],HK:[,[,,"[19]\\d{2,6}",,,,,,,[3,4,5,6,7]],,,[,,"112|99[29]",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"HK",,,,,,,,,,,,,,,,,,[,,"112|99[29]",,,,"112",,,[3]],,[,,"1(?:0(?:(?:[0136]\\d|2[14])\\d{0,3}|8[138])|12|2(?:[0-3]\\d{0,4}|(?:58|8[13])\\d{0,3})|7(?:[135-9]\\d{0,4}|219\\d{0,2})|8(?:0(?:(?:[13]|60\\d)\\d|8)|1(?:0\\d|[2-8])|2(?:0[5-9]|(?:18|2)2|3|8[128])|(?:(?:3[0-689]\\d|7(?:2[1-389]|8[0235-9]|93))\\d|8)\\d|50[138]|6(?:1(?:11|86)|8)))|99[29]|10[0139]",,,,"100"],[,,,,,,,,,
[-1]],[,,"109|1(?:08|85\\d)\\d",,,,"109",,,[3,4,5]],,[,,"992",,,,"992",,,[3]]],HN:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"199",,,,"199",,,[3]],[,,,,,,,,,[-1]],,,,"HN",,,,,,,,,,,,,,,,,,[,,"199",,,,"199",,,[3]],,[,,"199|40404",,,,"199"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],HR:[,[,,"[19]\\d{1,5}",,,,,,,[2,3,4,5,6]],,,[,,"1(?:12|9[2-4])|9[34]|1(?:16\\d|39)\\d\\d",,,,"93",,,[2,3,5,6]],[,,"118\\d\\d",,,,"11800",,,[5]],,,,"HR",,,,,,,,,,,,,,,,,,[,,"1(?:12|9[2-4])|9[34]",
,,,"93",,,[2,3]],,[,,"1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|3977|9(?:[2-5]|87))|9[34]",,,,"93"],[,,,,,,,,,[-1]],[,,"139\\d\\d",,,,"13900",,,[5]],,[,,"139\\d\\d",,,,"13900",,,[5]]],HT:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"11[48]",,,,"114",,,[3]],[,,,,,,,,,[-1]],,,,"HT",,,,,,,,,,,,,,,,,,[,,"11[48]",,,,"114",,,[3]],,[,,"11[48]|40404",,,,"114"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],HU:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:0[457]|1(?:2|6\\d{3}))",
,,,"104",,,[3,6]],[,,,,,,,,,[-1]],,,,"HU",,,,,,,,,,,,,,,,,,[,,"1(?:0[457]|12)",,,,"104",,,[3]],,[,,"1(?:0[457]|1(?:2|6(?:000|1(?:11|23)))|2(?:20|7[02])|37(?:00|37|7[07])|414|777|8(?:1[27-9]|2[04]|40|[589]))",,,,"104"],[,,,,,,,,,[-1]],[,,"1(?:2[27]|41|77)\\d",,,,"1220",,,[4]],,[,,"184\\d",,,,"1840",,,[4]]],ID:[,[,,"[178]\\d\\d(?:\\d{2,3})?",,,,,,,[3,5,6]],,,[,,"11[02389]",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"ID",,,,,,,,,,,,,,,,,,[,,"11[02389]",,,,"110",,,[3]],,[,,"1(?:1[02389]|40\\d\\d|50264)|71400|89887",
,,,"110"],[,,,,,,,,,[-1]],[,,"(?:714|898)\\d\\d",,,,"71400",,,[5]],,[,,"714\\d\\d",,,,"71400",,,[5]]],IE:[,[,,"[159]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"11(?:2|6\\d{3})|999",,,,"112",,,[3,6]],[,,"5[37]\\d{3}",,,,"53000",,,[5]],,,,"IE",,,,,,,,,,,,,,,,,,[,,"112|999",,,,"112",,,[3]],,[,,"11(?:2|6(?:00[06]|1(?:1[17]|23)))|999|(?:1(?:18|9)|5[0137]\\d)\\d\\d",,,,"112"],[,,"51\\d{3}",,,,"51000",,,[5]],[,,"51210",,,,"51210",,,[5]],,[,,"51210|(?:118|5[037]\\d)\\d\\d",,,,"11800",,,[5]]],IL:[,[,,"[12]\\d{2,4}",
,,,,,,[3,4,5]],,,[,,"1(?:0[0-2]|12)",,,,"100",,,[3]],[,,,,,,,,,[-1]],,,,"IL",,,,,,,,,,,,,,,,,,[,,"1(?:0[0-2]|12)",,,,"100",,,[3]],,[,,"1(?:0[0-2]|1(?:[013-9]\\d|2)|[2-9]\\d\\d)|2407|(?:104|27)00",,,,"100"],[,,,,,,,,,[-1]],[,,"104\\d\\d",,,,"10400",,,[5]],,[,,"104\\d\\d",,,,"10400",,,[5]]],IM:[,[,,"[189]\\d\\d(?:\\d{2,3})?",,,,,,,[3,5,6]],,,[,,"999",,,,"999",,,[3]],[,,,,,,,,,[-1]],,,,"IM",,,,,,,,,,,,,,,,,,[,,"999",,,,"999",,,[3]],,[,,"1\\d\\d(?:\\d{3})?|8(?:6444|9887)|999",,,,"100"],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],,[,,"8(?:64|98)\\d\\d",,,,"86400",,,[5]]],IN:[,[,,"[12578]\\d{2,8}",,,,,,,[3,4,5,6,7,8,9]],,,[,,"1(?:0[0-248]|1[289]|21|[39][89]|4[01]|6(?:1|6\\d?)|8[12])|777|800|1[05]5\\d|1(?:07|51|94)\\d\\d?|(?:1(?:[05]5\\d|70)\\d|261)\\d|1(?:0[369]|10|29|3[126]|9[0-256])\\d",,,,"100",,,[3,4,5,6]],[,,"11[67]\\d{4}|56161561",,,,"1160000",,,[7,8]],,,,"IN",,,,,,,,,,,,,,,,,,[,,"1(?:0[0-28]|12|298)|2611",,,,"100",,,[3,4]],,[,,"1(?:0(?:[0-248]|3[39]|5(?:010|6)|6[3468]|7(?:[01357]|[28]0?|4[01])|9[0135-9])|1(?:00|[289])|2(?:1|98)|3(?:11|2[0-2]|63|[89])|4[01]|5(?:1(?:0[0-36]|[127])|54)|6(?:1|6[01]?)|7000|8[12]|9(?:0[013-59]|12|25|4[4-9]\\d?|50|6[1347]|[89]))|2611|5(?:0(?:0(?:0\\d|1|20?)|325|5[2-79]\\d{3,5})|1(?:234|555|717|818|96[49])|2(?:0(?:0[01]|[14]0)|151|555|666|888|9(?:06|99\\d?))|3(?:0[01]0|131|553|(?:66|77)6)|(?:464|55[05])\\d{1,3}|6(?:070|3[68]|43)|717\\d)|777|800|5(?:05(?:0|1\\d)|221|3(?:03|3[23]))\\d{1,4}|5(?:(?:04|88)0|2(?:2[0267]|3[16])|4(?:1[04]|20|3[02])|5(?:3[16]|67)|6(?:06|[67]\\d)|787|9(?:64|90))\\d\\d?|(?:1(?:05[79]|(?:1[67][0-2]|802)\\d|55[23])\\d|5(?:(?:00(?:0\\d|1)|(?:304|616)\\d\\d)\\d|1(?:0[12]|4[2-4])|2(?:2[3589]|3(?:1\\d{3}|2)|4[04]|7[78])|4(?:[02]4|32\\d{4}|4[04]|99)|5(?:1[25]|[36]5|4[45]|93)|7(?:(?:17\\d|57)\\d\\d|[27]7|88)|8(?:3[4-69]|4[01]|5[58]|88(?:8\\d\\d|9)|99)|9(?:0(?:0|2\\d{3})|55|6[67]|77|88)))\\d",
,,,"100"],[,,"5(?:14(?:2[5-9]|[34]\\d)|757555)",,,,"51425",,,[5,7]],[,,"1(?:(?:1[67]\\d\\d|70)\\d\\d|55330|909)|5(?:300\\d|6161(?:17[89]|561))|1(?:[19][89]|21|4[01])",,,,"118",,,[3,4,5,6,7,8]],,[,,"1(?:39|90[019])|5(?:14(?:2[5-9]|[34]\\d)|6161(?:17[89]|561)|757555)",,,,"139",,,[3,4,5,7,8]]],IQ:[,[,,"[1479]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:0[04]|15|22)",,,,"100",,,[3]],[,,,,,,,,,[-1]],,,,"IQ",,,,,,,,,,,,,,,,,,[,,"1(?:0[04]|15|22)",,,,"100",,,[3]],,[,,"1(?:0[04]|15|22)|4432|71117|9988",,,,"100"],[,
,,,,,,,,[-1]],[,,"(?:443|711\\d|998)\\d",,,,"4430",,,[4,5]],,[,,"(?:443|711\\d|998)\\d",,,,"4430",,,[4,5]]],IR:[,[,,"[129]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:1[0-68]|2[0-59]|9[0-579])|911",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"IR",,,,,,,,,,,,,,,,,,[,,"1(?:1[025]|25)|911",,,,"110",,,[3]],,[,,"1(?:1[0-68]|2[0-59]|3[346-8]|4(?:[0147]|[289]0)|5(?:0[14]|1[02479]|2[0-3]|39|[49]0|65)|6(?:[16]6|[27]|90)|8(?:03|1[18]|22|3[37]|4[28]|88|99)|9[0-579])|20(?:[09]0|1(?:[038]|1[079]|26|9[69])|2[01])|9(?:11|9(?:0009|90))",
,,,"110"],[,,"1(?:5[0-469]|8[0-489])\\d",,,,"1500",,,[4]],[,,"(?:1(?:5[0-469]|8[0-489])|99(?:0\\d\\d|9))\\d",,,,"1500",,,[4,6]],,[,,"990\\d{3}",,,,"990000",,,[6]]],IS:[,[,,"1\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"1(?:12|71\\d)",,,,"112",,,[3,4]],[,,,,,,,,,[-1]],,,,"IS",,,,,,,,,,,,,,,,,,[,,"112",,,,"112",,,[3]],,[,,"1(?:1(?:[28]|61(?:16|23))|4(?:00|1[145]|4[0146])|55|7(?:00|17|7[07-9])|8(?:[02]0|1[16-9]|88)|900)",,,,"112"],[,,,,,,,,,[-1]],[,,"14(?:0\\d|41)",,,,"1400",,,[4]],,[,,"1(?:415|90\\d)",
,,,"1415",,,[4]]],IT:[,[,,"[14]\\d{2,6}",,,,,,,[3,4,5,6,7]],,,[,,"1(?:1(?:[2358]|6\\d{3})|87)",,,,"112",,,[3,6]],[,,"(?:12|4(?:[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d",,,,"1200",,,[4,5,7]],,,,"IT",,,,,,,,,,,,,,,,,,[,,"11[2358]",,,,"112",,,[3]],,[,,"1(?:0\\d{2,3}|1(?:[2-57-9]|6(?:000|111))|3[39]|4(?:82|9\\d{1,3})|5(?:00|1[58]|2[25]|3[03]|44|[59])|60|8[67]|9(?:[01]|2[2-9]|4\\d|696))|4(?:2323|5045)|(?:1(?:2|92[01])|4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d",,,,"112"],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],,[,,"4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|5[05])\\d\\d",,,,"43000",,,[5,7]]],JE:[,[,,"[129]\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"112|999",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"JE",,,,,,,,,,,,,,,,,,[,,"112|999",,,,"112",,,[3]],,[,,"1(?:00|1(?:2|8\\d{3})|23|4(?:[14]|28|7\\d)|5\\d|7(?:0[12]|[128]|35?)|808|9[0135])|23[2-4]|999",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],JM:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"11[029]|911",,,,"110"],[,,,,,,,,,[-1]],
,,,"JM",,,,,,,,,,,,,,,,,,[,,"11[029]|911",,,,"110"],,[,,"1(?:1[029]|76)|911",,,,"110"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],JO:[,[,,"[19]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"1(?:1[24]|9[127])|911",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"JO",,,,,,,,,,,,,,,,,,[,,"1(?:12|9[127])|911",,,,"112",,,[3]],,[,,"1(?:09|1[0-248]|9[0-24-79])|9(?:0903|11|8788)",,,,"109"],[,,,,,,,,,[-1]],[,,"9(?:09|87)\\d\\d",,,,"90900",,,[5]],,[,,"9(?:09|87)\\d\\d",,,,"90900",,,[5]]],JP:[,[,,"1\\d\\d",,,,,,,[3]],
,,[,,"11[089]",,,,"110"],[,,,,,,,,,[-1]],,,,"JP",,,,,,,,,,,,,,,,,,[,,"11[09]",,,,"110"],,[,,"1(?:0[24]|1[089]|44|89)",,,,"102"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],KE:[,[,,"[1-9]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:1(?:[246]|9\\d)|5(?:01|2[127]|6[26]\\d))|999",,,,"112"],[,,"909\\d\\d",,,,"90900",,,[5]],,,,"KE",,,,,,,,,,,,,,,,,,[,,"11[24]|999",,,,"112",,,[3]],,[,,"1(?:0(?:[07-9]|1[0-25]|400)|1(?:[024-6]|9[0-579])|2[1-3]|3[01]|4[14]|5(?:[01][01]|2[0-24-79]|33|4[05]|5[59]|6(?:00|29|6[67]))|(?:6[035]\\d|[78])\\d|9(?:[02-9]\\d\\d|19))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99))\\d\\d|9(?:09\\d\\d|99)|8988",
,,,"100"],[,,,,,,,,,[-1]],[,,"1(?:(?:04|6[35])\\d\\d|3[01]|4[14]|5(?:1\\d|2[25]))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99)|909)\\d\\d|898\\d",,,,"130"],,[,,"1(?:(?:04|6[035])\\d\\d|4[14]|5(?:01|55|6[26]\\d))|40404|8988|909\\d\\d",,,,"141"]],KG:[,[,,"[14]\\d{2,3}",,,,,,,[3,4]],,,[,,"10[1-3]",,,,"101",,,[3]],[,,,,,,,,,[-1]],,,,"KG",,,,,,,,,,,,,,,,,,[,,"10[1-3]",,,,"101",,,[3]],,[,,"10[1-3]|4040",,,,"101"],[,,,,,,,,,[-1]],[,,"404\\d",,,,"4040",,,[4]],,[,,"404\\d",,,,"4040",,
,[4]]],KH:[,[,,"[146]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"11[7-9]|666",,,,"117",,,[3]],[,,,,,,,,,[-1]],,,,"KH",,,,,,,,,,,,,,,,,,[,,"11[7-9]|666",,,,"117",,,[3]],,[,,"11[7-9]|40404|666",,,,"117"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],KI:[,[,,"[179]\\d{2,3}",,,,,,,[3,4]],,,[,,"19[2-5]|99[2-4]",,,,"192",,,[3]],[,,,,,,,,,[-1]],,,,"KI",,,,,,,,,,,,,,,,,,[,,"19[2-5]|99[2-4]",,,,"192",,,[3]],,[,,"1(?:05[0-259]|88|9[2-5])|777|99[2-4]|10[0-8]",,,,"100"],[,,"103",
,,,"103",,,[3]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],KM:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],,,,"KM",,,,,,,,,,,,,,,,,,[,,"1[78]",,,,"17"],,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],KN:[,[,,"[39]\\d\\d",,,,,,,[3]],,,[,,"333|9(?:11|99)",,,,"333"],[,,,,,,,,,[-1]],,,,"KN",,,,,,,,,,,,,,,,,,[,,"333|9(?:11|99)",,,,"333"],,[,,"333|9(?:11|99)",,,,"333"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],KP:[,[,,"[18]\\d\\d",,,,,,,[3]],,,[,,"11[29]|819",,,,"112"],
[,,,,,,,,,[-1]],,,,"KP",,,,,,,,,,,,,,,,,,[,,"11[29]|819",,,,"112"],,[,,"11[29]|819",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],KR:[,[,,"1\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:1[27-9]|28|330|82)",,,,"112",,,[3,4]],[,,,,,,,,,[-1]],,,,"KR",,,,,,,,,,,,,,,,,,[,,"11[29]",,,,"112",,,[3]],,[,,"1(?:[016-9]114|3(?:0[01]|2|3[0-35-9]|45?|5[057]|6[569]|7[79]|8[2589]|9[0189]))|1(?:0[015]|1\\d|2[01357-9]|41|8[28])",,,,"100"],[,,,,,,,,,[-1]],[,,"1(?:0[01]|1[4-6]|41)|1(?:[06-9]1\\d|111)\\d",,,,"100",
,,[3,5]],,[,,,,,,,,,[-1]]],KW:[,[,,"[18]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"112",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"KW",,,,,,,,,,,,,,,,,,[,,"112",,,,"112",,,[3]],,[,,"1[0-7]\\d|89887",,,,"100"],[,,,,,,,,,[-1]],[,,"898\\d\\d",,,,"89800",,,[5]],,[,,,,,,,,,[-1]]],KY:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"KY",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"911",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],KZ:[,[,,"[134]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:0[1-3]|12)",
,,,"101",,,[3]],[,,,,,,,,,[-1]],,,,"KZ",,,,,,,,,,,,,,,,,,[,,"1(?:0[1-3]|12)",,,,"101",,,[3]],,[,,"1(?:0[1-4]|12)|(?:3040|404)0",,,,"101"],[,,,,,,,,,[-1]],[,,"(?:304\\d|404)\\d",,,,"4040",,,[4,5]],,[,,"(?:304\\d|404)\\d",,,,"4040",,,[4,5]]],LA:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"19[015]",,,,"190"],[,,,,,,,,,[-1]],,,,"LA",,,,,,,,,,,,,,,,,,[,,"19[015]",,,,"190"],,[,,"19[015]",,,,"190"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LB:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"1(?:12|40|75)|999",,,,"112"],[,
,,,,,,,,[-1]],,,,"LB",,,,,,,,,,,,,,,,,,[,,"1(?:12|40|75)|999",,,,"112"],,[,,"1(?:12|40|75)|999",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LC:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"LC",,,,,,,,,,,,,,,,,,[,,"9(?:11|99)",,,,"911"],,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LI:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1[278]|44)",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"LI",,,,,,,,,,,,,,,,,,[,,"1(?:1[278]|44)",,,,"112",,,[3]],
,[,,"1(?:1(?:[278]|45)|4[3-57]|50|75|81[18])",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LK:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"11[02689]",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"LK",,,,,,,,,,,,,,,,,,[,,"11[02689]",,,,"110",,,[3]],,[,,"1(?:1[024-9]|3(?:00|1[2-49]|2[23]|3[1-3]|44|5[07]|[67]9|88|9[039])|9(?:0[0-2589]|1[0-357-9]|2[0-25689]|3[0389]|4[0489]|5[014-69]|6[0-2689]|7[03579]|8[02457-9]|9[0-2569]))",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LR:[,[,,"[3489]\\d{2,3}",
,,,,,,[3,4]],,,[,,"355|911",,,,"355",,,[3]],[,,,,,,,,,[-1]],,,,"LR",,,,,,,,,,,,,,,,,,[,,"355|911",,,,"355",,,[3]],,[,,"355|4040|8(?:400|933)|911",,,,"355"],[,,,,,,,,,[-1]],[,,"(?:404|8(?:40|93))\\d",,,,"4040",,,[4]],,[,,"(?:404|8(?:40|93))\\d",,,,"4040",,,[4]]],LS:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[257]",,,,"112"],[,,,,,,,,,[-1]],,,,"LS",,,,,,,,,,,,,,,,,,[,,"11[257]",,,,"112"],,[,,"11[257]",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LT:[,[,,"[01]\\d(?:\\d(?:\\d{3})?)?",,,,,,,[2,3,
6]],,,[,,"0(?:11?|22?|33?)|1(?:0[1-3]|1(?:2|6111))|116(?:0\\d|12)\\d",,,,"01"],[,,,,,,,,,[-1]],,,,"LT",,,,,,,,,,,,,,,,,,[,,"0(?:11?|22?|33?)|1(?:0[1-3]|12)",,,,"01",,,[2,3]],,[,,"0(?:11?|22?|33?)|1(?:0[1-3]|1(?:[27-9]|6(?:000|1(?:1[17]|23))))",,,,"01"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LU:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"11(?:[23]|6\\d{3})",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"LU",,,,,,,,,,,,,,,,,,[,,"11[23]",,,,"112",,,[3]],,[,,"11(?:[23]|6(?:000|111))|1(?:18|[25]\\d|3)\\d\\d",
,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LV:[,[,,"[018]\\d{1,5}",,,,,,,[2,3,4,5,6]],,,[,,"0[1-3]|11(?:[023]|6\\d{3})",,,,"01",,,[2,3,6]],[,,"1180|821\\d\\d",,,,"1180",,,[4,5]],,,,"LV",,,,,,,,,,,,,,,,,,[,,"0[1-3]|11[023]",,,,"01",,,[2,3]],,[,,"0[1-4]|1(?:1(?:[02-4]|6(?:000|111)|8[0189])|(?:5|65)5|77)|821[57]4",,,,"01"],[,,"1181",,,,"1181",,,[4]],[,,"165\\d",,,,"1650",,,[4]],,[,,,,,,,,,[-1]]],LY:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"19[013]",,,,"190"],[,,,,,,,,,[-1]],,,,"LY",,,,,,,,,,,
,,,,,,,[,,"19[013]",,,,"190"],,[,,"19[013]",,,,"190"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MA:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:[59]|77)",,,,"15"],[,,,,,,,,,[-1]],,,,"MA",,,,,,,,,,,,,,,,,,[,,"1(?:[59]|77)",,,,"15"],,[,,"1(?:[59]|77)",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MC:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:12|[578])",,,,"15"],[,,,,,,,,,[-1]],,,,"MC",,,,,,,,,,,,,,,,,,[,,"1(?:12|[578])",,,,"15"],,[,,"1(?:12|41|[578])",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
,[,,,,,,,,,[-1]]],MD:[,[,,"[19]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"11(?:2|6(?:000|1(?:11|2\\d)))|90[1-3]",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"MD",,,,,,,,,,,,,,,,,,[,,"112|90[1-3]",,,,"112",,,[3]],,[,,"1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d?|99)|90[04-9])|90[1-3]|1(?:4\\d\\d|6[0-389]|9[1-4])\\d",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],ME:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:12|2[2-4])",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"ME",,,,,,,,,,,,,,,,,,[,,"1(?:12|2[2-4])",,,,"112",
,,[3]],,[,,"1(?:1(?:(?:[013-57-9]|6\\d\\d)\\d|2)|[249]\\d{3}|5999|8(?:0[089]|1[0-8]|888))|1(?:[02-5]\\d\\d|60[06]|700)|12\\d",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MF:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],,,,"MF",,,,,,,,,,,,,,,,,,[,,"1[578]",,,,"15"],,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MG:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:1[78]|[78])",,,,"17"],[,,,,,,,,,[-1]],,,,"MG",,,,,,,,,,,,,,,,,,[,,"1(?:1[78]|[78])",,,,"17"],
,[,,"1(?:1[78]|[78])",,,,"17"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MH:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"MH",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"911",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MK:[,[,,"1\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"1(?:1(?:2|6\\d{3})|9[2-4])",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"MK",,,,,,,,,,,,,,,,,,[,,"1(?:12|9[2-4])",,,,"112",,,[3]],,[,,"1(?:1(?:2|8\\d)|3\\d|9[2-4])|1(?:16|2\\d)\\d{3}",,,,"112"],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],ML:[,[,,"[136-8]\\d{1,4}",,,,,,,[2,3,4,5]],,,[,,"1[578]|(?:352|67)00|7402|(?:677|744|8000)\\d",,,,"15",,,[2,4,5]],[,,"(?:12|800)2\\d|3(?:52(?:11|2[02]|3[04-6]|99)|7574)",,,,"1220",,,[4,5]],,,,"ML",,,,,,,,,,,,,,,,,,[,,"1[578]",,,,"15",,,[2]],,[,,"1(?:1(?:[013-9]\\d|2)|2(?:1[02-469]|2[13])|[578])|350(?:35|57)|67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)|800[0-2][12]|3(?:52|[67]\\d)\\d\\d",,,,"15"],[,,"37(?:433|575)|7400|8001\\d",,,,"7400",,,[4,5]],[,
,"3503\\d|(?:3[67]\\d|800)\\d\\d",,,,"35030",,,[5]],,[,,"374(?:0[24-9]|[1-9]\\d)|7400|3(?:6\\d|75)\\d\\d",,,,"7400",,,[4,5]]],MM:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"199",,,,"199"],[,,,,,,,,,[-1]],,,,"MM",,,,,,,,,,,,,,,,,,[,,"199",,,,"199"],,[,,"199",,,,"199"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MN:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"10[0-35]",,,,"100"],[,,,,,,,,,[-1]],,,,"MN",,,,,,,,,,,,,,,,,,[,,"10[0-35]",,,,"100"],,[,,"10[0-35]",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],
MO:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"MO",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"999",,,,"999"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MP:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"MP",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"911",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MQ:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:12|[578])",,,,"15"],[,,,,,,,,,[-1]],,,,"MQ",,,,,,,,,,,,,,,,,,[,,"1(?:12|[578])",,,,"15"],,[,,"1(?:12|[578])",
,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MR:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],,,,"MR",,,,,,,,,,,,,,,,,,[,,"1[78]",,,,"17"],,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MS:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"MS",,,,,,,,,,,,,,,,,,[,,"9(?:11|99)",,,,"911"],,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MT:[,[,,"1\\d\\d(?:\\d{3})?",,,,,,,[3,6]],,,[,,"11(?:2|6\\d{3})",
,,,"112"],[,,,,,,,,,[-1]],,,,"MT",,,,,,,,,,,,,,,,,,[,,"112",,,,"112",,,[3]],,[,,"11(?:2|6(?:000|1(?:11|23)))",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MU:[,[,,"[189]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"11[45]|99[59]",,,,"114",,,[3]],[,,,,,,,,,[-1]],,,,"MU",,,,,,,,,,,,,,,,,,[,,"11[45]|99[59]",,,,"114",,,[3]],,[,,"1\\d{2,4}|(?:8\\d\\d|99)\\d",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MV:[,[,,"[14]\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:02|1[89])",,,,"102",,,[3]],[,,,,,,,,,[-1]],
,,,"MV",,,,,,,,,,,,,,,,,,[,,"1(?:02|1[89])",,,,"102",,,[3]],,[,,"1(?:[0-37-9]|[4-6]\\d)\\d|4040|1[45]1",,,,"100"],[,,,,,,,,,[-1]],[,,"1[45]1",,,,"141",,,[3]],,[,,,,,,,,,[-1]]],MW:[,[,,"[189]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"199|99[7-9]",,,,"199",,,[3]],[,,,,,,,,,[-1]],,,,"MW",,,,,,,,,,,,,,,,,,[,,"199|99[7-9]",,,,"199",,,[3]],,[,,"199|80400|99[7-9]",,,,"199"],[,,,,,,,,,[-1]],[,,"804\\d\\d",,,,"80400",,,[5]],,[,,"804\\d\\d",,,,"80400",,,[5]]],MX:[,[,,"[0579]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"0(?:6[0568]|80)|911",
,,,"060",,,[3]],[,,"(?:530\\d|776)\\d",,,,"7760",,,[4,5]],,,,"MX",,,,,,,,,,,,,,,,,,[,,"0(?:6[0568]|80)|911",,,,"060",,,[3]],,[,,"0[1-9]\\d|53053|7766|911",,,,"010"],[,,,,,,,,,[-1]],[,,"0(?:[249]0|[35][01])",,,,"020",,,[3]],,[,,,,,,,,,[-1]]],MY:[,[,,"[1369]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"112|999",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"MY",,,,,,,,,,,,,,,,,,[,,"112|999",,,,"112",,,[3]],,[,,"1(?:0[01348]|1(?:[02]|1[128]|311)|2(?:0[125]|[13-6]|2\\d{0,2})|(?:3[1-35-79]|7[45])\\d\\d?|5(?:454|5\\d\\d?|77|888|999?)|8(?:18?|2|8[18])|9(?:[124]\\d?|68|71|9[0679]))|66628|99[1-469]|13[5-7]|(?:1(?:0[569]|309|5[12]|7[136-9]|9[03])|3[23679]\\d\\d)\\d",
,,,"100"],[,,"666\\d\\d",,,,"66600",,,[5]],[,,,,,,,,,[-1]],,[,,"(?:3[23679]\\d|666)\\d\\d",,,,"32000",,,[5]]],MZ:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1[79]|9[78])",,,,"117",,,[3]],[,,,,,,,,,[-1]],,,,"MZ",,,,,,,,,,,,,,,,,,[,,"1(?:1[79]|9[78])",,,,"117",,,[3]],,[,,"1(?:[02-5]\\d\\d|1[79]|9[78])",,,,"117"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NA:[,[,,"[19]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"10111",,,,"10111",,,[5]],[,,,,,,,,,[-1]],,,,"NA",,,,,,,,,,,,,,,,,,[,,"10111",,,,"10111",,,[5]],,[,,
"(?:10|93)111|(?:1\\d|9)\\d\\d",,,,"900"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NC:[,[,,"[135]\\d{1,3}",,,,,,,[2,3,4]],,,[,,"1(?:0(?:00|1[23]|3[0-2]|8\\d)|[5-8])|363\\d|577",,,,"15"],[,,,,,,,,,[-1]],,,,"NC",,,,,,,,,,,,,,,,,,[,,"1[5-8]",,,,"15",,,[2]],,[,,"1(?:0(?:0[06]|1[02-46]|20|3[0-25]|42|5[058]|77|88)|[5-8])|3631|5[6-8]\\d",,,,"15"],[,,"5(?:67|88)",,,,"567",,,[3]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NE:[,[,,"[1-3578]\\d(?:\\d(?:\\d{3})?)?",,,,,,,[2,3,6]],,,[,,"1(?:18|[578])|723\\d{3}",
,,,"15"],[,,,,,,,,,[-1]],,,,"NE",,,,,,,,,,,,,,,,,,[,,"1(?:18|[578])|723141",,,,"15"],,[,,"1(?:0[01]|1[128]|2[034]|3[013]|[46]0|55?|[78])|222|333|555|723141|888",,,,"15"],[,,,,,,,,,[-1]],[,,"1(?:0[01]|1[12]|2[034]|3[013]|[46]0|55)|222|333|555|888",,,,"100",,,[3]],,[,,,,,,,,,[-1]]],NF:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|55|77)",,,,"911"],[,,,,,,,,,[-1]],,,,"NF",,,,,,,,,,,,,,,,,,[,,"9(?:11|55|77)",,,,"911"],,[,,"9(?:11|55|77)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NG:[,[,,"[14]\\d\\d(?:\\d{2})?",
,,,,,,[3,5]],,,[,,"199",,,,"199",,,[3]],[,,,,,,,,,[-1]],,,,"NG",,,,,,,,,,,,,,,,,,[,,"199",,,,"199",,,[3]],,[,,"199|40700",,,,"199"],[,,,,,,,,,[-1]],[,,"407\\d\\d",,,,"40700",,,[5]],,[,,"407\\d\\d",,,,"40700",,,[5]]],NI:[,[,,"[12467]\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1[58]|2[08])|737\\d",,,,"115"],[,,,,,,,,,[-1]],,,,"NI",,,,,,,,,,,,,,,,,,[,,"1(?:1[58]|2[08])",,,,"115",,,[3]],,[,,"1(?:1[58]|200)|4878|7(?:010|373)|12[0158]|(?:19|[267]1)00",,,,"115"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NL:[,
[,,"[1349]\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"11(?:2|6\\d{3})|911",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"NL",,,,,,,,,,,,,,,,,,[,,"112|911",,,,"112",,,[3]],,[,,"1(?:1(?:2|6(?:00[06]|1(?:11|23)))|2(?:0[0-4]|3[34]|44)|3[03-9]\\d|400|8(?:[02-9]\\d|1[0-79]))|[34]000|911",,,,"112"],[,,,,,,,,,[-1]],[,,"120\\d",,,,"1200",,,[4]],,[,,"[34]00\\d",,,,"3000",,,[4]]],NO:[,[,,"1\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"11(?:[023]|6\\d{3})",,,,"110",,,[3,6]],[,,,,,,,,,[-1]],,,,"NO",,,,,,,,,,,,,
,,,,,[,,"11[023]",,,,"110",,,[3]],,[,,"1(?:1(?:[0239]|61(?:1[17]|23))|2[048]|4(?:12|[59])|7[57]|8[5-9]\\d|90)",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NP:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:0[0-36]|12)|1(?:09|11)\\d",,,,"100"],[,,,,,,,,,[-1]],,,,"NP",,,,,,,,,,,,,,,,,,[,,"1(?:0[0-3]|12)",,,,"100",,,[3]],,[,,"1(?:0(?:[0-36]|98)|1(?:1[1-4]|2))",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NR:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[0-2]",,,,"110"],[,,,,,,,,,[-1]],,,,
"NR",,,,,,,,,,,,,,,,,,[,,"11[0-2]",,,,"110"],,[,,"1(?:1[0-2]|23|92)",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NU:[,[,,"[019]\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"NU",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"01[05]|101|999",,,,"010"],[,,,,,,,,,[-1]],[,,"010",,,,"010"],,[,,,,,,,,,[-1]]],NZ:[,[,,"\\d{3,4}",,,,,,,[3,4]],,,[,,"111",,,,"111",,,[3]],[,,"018",,,,"018",,,[3]],,,,"NZ",,,,,,,,,,,,,,,,,,[,,"111",,,,"111",,,[3]],,[,,"018|1(?:(?:1|37)1|(?:23|94)4|7[03]7)|[2-57-9]\\d{2,3}|6(?:161|26[0-3]|742)",
,,,"018"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"018|(?:1(?:23|37|7[03]|94)|6(?:[12]6|74))\\d|[2-57-9]\\d{2,3}",,,,"018"]],OM:[,[,,"[19]\\d{3}",,,,,,,[4]],,,[,,"1444|999\\d",,,,"1444"],[,,,,,,,,,[-1]],,,,"OM",,,,,,,,,,,,,,,,,,[,,"1444|9999",,,,"1444"],,[,,"1(?:111|222|4(?:4[0-5]|50|66|7[7-9])|51[0-8])|9999|1(?:2[3-5]|3[0-2]|50)\\d",,,,"1111"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PA:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"PA",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],
,[,,"10[2-4]|911",,,,"102"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PE:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"1(?:05|1[67])",,,,"105"],[,,,,,,,,,[-1]],,,,"PE",,,,,,,,,,,,,,,,,,[,,"1(?:05|1[67])",,,,"105"],,[,,"1(?:05|1[67])",,,,"105"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PF:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],,,,"PF",,,,,,,,,,,,,,,,,,[,,"1[578]",,,,"15"],,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PG:[,[,,"[01]\\d{2,6}",,,,,,,[3,
4,5,6,7]],,,[,,"000|11[01]",,,,"000",,,[3]],[,,,,,,,,,[-1]],,,,"PG",,,,,,,,,,,,,,,,,,[,,"000|11[01]",,,,"000",,,[3]],,[,,"000|1(?:1[01]|5\\d\\d|6\\d{2,5})",,,,"000"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"16\\d{2,5}",,,,"1600",,,[4,5,6,7]]],PH:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"11[27]|911",,,,"112"],[,,,,,,,,,[-1]],,,,"PH",,,,,,,,,,,,,,,,,,[,,"11[27]|911",,,,"112"],,[,,"11[27]|911",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PK:[,[,,"1\\d{1,3}",,,,,,,[2,3,4]],,,[,,"1(?:1(?:2\\d?|5)|[56])",
,,,"15"],[,,,,,,,,,[-1]],,,,"PK",,,,,,,,,,,,,,,,,,[,,"1(?:1(?:22?|5)|[56])",,,,"15"],,[,,"1(?:122|3[014]|[56])|11[2457-9]",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PL:[,[,,"[19]\\d\\d(?:\\d{2,3})?",,,,,,,[3,5,6]],,,[,,"11(?:2|6\\d{3})|99[7-9]",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"PL",,,,,,,,,,,,,,,,,,[,,"112|99[7-9]",,,,"112",,,[3]],,[,,"1(?:1(?:2|61(?:11|23)|891[23])|9\\d{3})|9(?:8[4-7]|9[1-9])|11[68]000",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PM:[,[,,"[13]\\d(?:\\d{2})?",
,,,,,,[2,4]],,,[,,"1[578]",,,,"15",,,[2]],[,,,,,,,,,[-1]],,,,"PM",,,,,,,,,,,,,,,,,,[,,"1[578]",,,,"15",,,[2]],,[,,"1[578]|3103",,,,"15"],[,,,,,,,,,[-1]],[,,"310\\d",,,,"3100",,,[4]],,[,,,,,,,,,[-1]]],PR:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"PR",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"911",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PS:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:0[0-2]|66)",,,,"100",,,[3]],[,,,,,,,,,[-1]],,,,"PS",,,,,,,,,,,,,,,,,,[,,"10[0-2]",
,,,"100",,,[3]],,[,,"1(?:0[0-2]|122|44|66|99)",,,,"100"],[,,,,,,,,,[-1]],[,,"112\\d",,,,"1120",,,[4]],,[,,,,,,,,,[-1]]],PT:[,[,,"1\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"11[25]|1(?:16\\d\\d|5[1589]|8[279])\\d",,,,"112"],[,,,,,,,,,[-1]],,,,"PT",,,,,,,,,,,,,,,,,,[,,"11[25]",,,,"112",,,[3]],,[,,"1(?:0(?:45|5[01])|1(?:[2578]|600[06])|4(?:1[45]|4)|583|6(?:1[0236]|3[02]|9[169]))|1(?:1611|59)1|1[068]78|1[08]9[16]|1(?:0[1-38]|40|5[15]|6[258]|82)0",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,
,,,,[-1]]],PW:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"PW",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"911",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PY:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"128|911",,,,"128"],[,,,,,,,,,[-1]],,,,"PY",,,,,,,,,,,,,,,,,,[,,"128|911",,,,"128"],,[,,"1[1-4]\\d|911",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],QA:[,[,,"[129]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"999",,,,"999",,,[3]],[,,,,,,,,,[-1]],,,,"QA",,,,,,,,,,,,,,,,,,[,
,"999",,,,"999",,,[3]],,[,,"999|(?:1|20|9[27]\\d)\\d\\d",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],RE:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:12|[578])",,,,"15"],[,,,,,,,,,[-1]],,,,"RE",,,,,,,,,,,,,,,,,,[,,"1(?:12|[578])",,,,"15"],,[,,"1(?:12|[578])",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],RO:[,[,,"[18]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"11(?:2|6\\d{3})",,,,"112",,,[3,6]],[,,"(?:1(?:18[39]|[24])|8[48])\\d\\d",,,,"1200",,,[4,6]],,,,"RO",,,,,,,,,,,,,,,,,,[,,"112",,,
,"112",,,[3]],,[,,"1(?:1(?:2|6(?:000|1(?:11|23))|8(?:(?:01|8[18])1|119|[23]00|932))|[24]\\d\\d|9(?:0(?:00|19)|1[19]|21|3[02]|5[178]))|8[48]\\d\\d",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"(?:1[24]|8[48])\\d\\d",,,,"1200",,,[4]]],RS:[,[,,"[19]\\d{1,5}",,,,,,,[2,3,4,5,6]],,,[,,"112|9[2-4]",,,,"92",,,[2,3]],[,,,,,,,,,[-1]],,,,"RS",,,,,,,,,,,,,,,,,,[,,"112|9[2-4]",,,,"92",,,[2,3]],,[,,"1[189]\\d{1,4}|9[2-4]",,,,"92"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],RU:[,[,,"[01]\\d\\d?",,,,,,,
[2,3]],,,[,,"112|(?:0|10)[1-3]",,,,"01"],[,,,,,,,,,[-1]],,,,"RU",,,,,,,,,,,,,,,,,,[,,"112|(?:0|10)[1-3]",,,,"01"],,[,,"112|(?:0|10)[1-4]",,,,"01"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],RW:[,[,,"[14]\\d\\d",,,,,,,[3]],,,[,,"11[1245]",,,,"111"],[,,,,,,,,,[-1]],,,,"RW",,,,,,,,,,,,,,,,,,[,,"11[12]",,,,"111"],,[,,"1(?:0[0-2]|1[0-24-6]|2[13]|70|99)|456",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SA:[,[,,"[19]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"11(?:2|6\\d{3})|9(?:11|37|9[7-9])",
,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"SA",,,,,,,,,,,,,,,,,,[,,"112|9(?:11|9[79])",,,,"112",,,[3]],,[,,"1(?:1(?:00|2|6111)|410|9(?:00|1[89]|9(?:099|22|9[0-3])))|9(?:0[24-79]|11|3[379]|40|66|8[5-9]|9[02-9])",,,,"112"],[,,"141\\d",,,,"1410",,,[4]],[,,"1(?:10|41)\\d|90[24679]",,,,"902",,,[3,4]],,[,,,,,,,,,[-1]]],SB:[,[,,"[127-9]\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"SB",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"1(?:[02]\\d|1[12]|[35][01]|[49][1-9]|6[2-9]|7[7-9]|8[0-8])|269|777|835|9(?:[01]1|22|33|55|77|88|99)",
,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SC:[,[,,"[19]\\d{2,3}",,,,,,,[3,4]],,,[,,"999",,,,"999",,,[3]],[,,,,,,,,,[-1]],,,,"SC",,,,,,,,,,,,,,,,,,[,,"999",,,,"999",,,[3]],,[,,"1(?:0\\d|1[027]|2[0-8]|3[13]|4[0-2]|[59][15]|6[1-9]|7[124-6]|8[158])|9(?:6\\d\\d|99)",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SD:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"SD",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"999",,,,"999"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
,[,,,,,,,,,[-1]]],SE:[,[,,"[1-37-9]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"112|(?:116\\d|900)\\d\\d",,,,"112",,,[3,5,6]],[,,"11811[89]|72\\d{3}",,,,"72000",,,[5,6]],,,,"SE",,,,,,,,,,,,,,,,,,[,,"112|90000",,,,"112",,,[3,5]],,[,,"11(?:[25]|313|6(?:00[06]|1(?:1[17]|23))|7[0-8])|2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|9(?:0(?:00|51)0|12)|(?:11(?:4|8[02-46-9])|7\\d\\d|90[2-4])\\d\\d|(?:118|90)1(?:[02-9]\\d|1[013-9])",,,,"112"],[,,,,,,,,,[-1]],[,,"2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|912",
,,,"220",,,[3]],,[,,"7\\d{4}",,,,"70000",,,[5]]],SG:[,[,,"[179]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"99[359]",,,,"993",,,[3]],[,,,,,,,,,[-1]],,,,"SG",,,,,,,,,,,,,,,,,,[,,"99[359]",,,,"993",,,[3]],,[,,"1(?:(?:[01368]\\d|44)\\d|[57]\\d{2,3}|9(?:0[1-9]|[1-9]\\d))|77222|99[02-9]|100",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"772\\d\\d",,,,"77200",,,[5]]],SH:[,[,,"[129]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"9(?:11|99)",,,,"911",,,[3]],[,,,,,,,,,[-1]],,,,"SH",,,,,,,,,,,,,,,,,,[,,"9(?:11|99)",,,,"911",,,[3]],,[,,
"1\\d{2,3}|26[01]\\d\\d|9(?:11|99)",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SI:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"11(?:(?:0|6\\d)\\d\\d|[23]|8\\d\\d?)",,,,"112"],[,,,,,,,,,[-1]],,,,"SI",,,,,,,,,,,,,,,,,,[,,"11[23]",,,,"112",,,[3]],,[,,"1(?:1(?:00[146]|[23]|6(?:000|1(?:11|23))|8(?:[08]|99))|9(?:059|1(?:0[12]|16)|5|70|87|9(?:00|[149])))|19(?:08|81)[09]",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SJ:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[023]",,,,"110"],[,,,,,,,
,,[-1]],,,,"SJ",,,,,,,,,,,,,,,,,,[,,"11[023]",,,,"110"],,[,,"11[023]",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SK:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:1(?:2|6\\d{3})|5[058])",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"SK",,,,,,,,,,,,,,,,,,[,,"1(?:12|5[058])",,,,"112",,,[3]],,[,,"1(?:1(?:2|6(?:000|111)|8[0-8])|[248]\\d{3}|5[0589])",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SL:[,[,,"[069]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"(?:01|99)9",,,,"019",,,[3]],[,,,,,,
,,,[-1]],,,,"SL",,,,,,,,,,,,,,,,,,[,,"(?:01|99)9",,,,"019",,,[3]],,[,,"(?:01|99)9|60400",,,,"019"],[,,,,,,,,,[-1]],[,,"604\\d\\d",,,,"60400",,,[5]],,[,,"604\\d\\d",,,,"60400",,,[5]]],SM:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[358]",,,,"113"],[,,,,,,,,,[-1]],,,,"SM",,,,,,,,,,,,,,,,,,[,,"11[358]",,,,"113"],,[,,"11[358]",,,,"113"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SN:[,[,,"[12]\\d{1,5}",,,,,,,[2,3,4,5,6]],,,[,,"1(?:515|[78])|2(?:00|1)\\d{3}",,,,"17",,,[2,4,5,6]],[,,"2(?:0[246]|[468])\\d{3}",
,,,"24000",,,[5,6]],,,,"SN",,,,,,,,,,,,,,,,,,[,,"1[78]",,,,"17",,,[2]],,[,,"1(?:1[69]|(?:[246]\\d|51)\\d)|2(?:0[0-246]|[12468])\\d{3}|1[278]",,,,"12"],[,,"2(?:01|2)\\d{3}",,,,"22000",,,[5,6]],[,,"1[46]\\d\\d",,,,"1400",,,[4]],,[,,"2[468]\\d{3}",,,,"24000",,,[5]]],SO:[,[,,"[57-9]\\d\\d",,,,,,,[3]],,,[,,"555|888|999",,,,"555"],[,,,,,,,,,[-1]],,,,"SO",,,,,,,,,,,,,,,,,,[,,"555|888|999",,,,"555"],,[,,"555|777|888|999",,,,"555"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SR:[,[,,"1\\d{2,3}",,,,,
,,[3,4]],,,[,,"115",,,,"115",,,[3]],[,,,,,,,,,[-1]],,,,"SR",,,,,,,,,,,,,,,,,,[,,"115",,,,"115",,,[3]],,[,,"1\\d{2,3}",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SS:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"SS",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"999",,,,"999"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],ST:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"112",,,,"112"],[,,,,,,,,,[-1]],,,,"ST",,,,,,,,,,,,,,,,,,[,,"112",,,,"112"],,[,,"112",,,,"112"],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SV:[,[,,"[149]\\d\\d(?:\\d{2,3})?",,,,,,,[3,5,6]],,,[,,"116\\d{3}|911",,,,"911",,,[3,6]],[,,,,,,,,,[-1]],,,,"SV",,,,,,,,,,,,,,,,,,[,,"91[13]",,,,"911",,,[3]],,[,,"1(?:1(?:2|6111)|2[136-8]|3[0-6]|9[05])|40404|9(?:1\\d|29)",,,,"112"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],SX:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"919",,,,"919"],[,,,,,,,,,[-1]],,,,"SX",,,,,,,,,,,,,,,,,,[,,"919",,,,"919"],,[,,"919",,,,"919"],[,,,,,,,,,[-1]],[,,,,
,,,,,[-1]],,[,,,,,,,,,[-1]]],SY:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[023]",,,,"110"],[,,,,,,,,,[-1]],,,,"SY",,,,,,,,,,,,,,,,,,[,,"11[023]",,,,"110"],,[,,"11[023]",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SZ:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"SZ",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"999",,,,"999"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TC:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"TC",,,,,,,,,,,,,,,,,,[,
,"9(?:11|99)",,,,"911"],,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TD:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],,,,"TD",,,,,,,,,,,,,,,,,,[,,"1[78]",,,,"17"],,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TG:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1[78]|7[127])",,,,"117",,,[3]],[,,,,,,,,,[-1]],,,,"TG",,,,,,,,,,,,,,,,,,[,,"1(?:1[78]|7[127])",,,,"117",,,[3]],,[,,"1(?:011|1[078]|7[127])",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
,[,,,,,,,,,[-1]]],TH:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1(?:00|2[03]|3[3479]|7[67]|9[0246])|578|6(?:44|6[79]|88|9[16])|88\\d|9[19])|1[15]55",,,,"191"],[,,"1(?:113|2[23]\\d|5(?:09|56))",,,,"1113",,,[4]],,,,"TH",,,,,,,,,,,,,,,,,,[,,"1(?:669|9[19])",,,,"191"],,[,,"1(?:0[0-2]|1(?:0[03]|1[1-35]|2[0358]|3[03-79]|4[02-489]|5[04-9]|6[04-79]|7[03-9]|8[027-9]|9[02-9])|2(?:22|3[89]|66)|3(?:18|2[23]|3[013]|5[56]|6[45]|73)|477|5(?:0\\d|4[0-37-9]|5[1-8]|6[01679]|7[12568]|8[0-24589]|9[013589])|6(?:0[0-29]|2[03]|4[3-6]|6[1-9]|7[0257-9]|8[0158]|9[014-9])|7(?:[14]9|7[27]|90)|888|9[19])",
,,,"100"],[,,"1(?:1(?:03|1[15]|2[58]|3[056]|4[02-49]|5[046-9]|7[03-589]|9[57-9])|5(?:0[0-8]|4[0-378]|5[1-478]|7[156])|6(?:20|4[356]|6[1-68]|7[057-9]|8[015]|9[0457-9]))|1(?:1[68]|26|3[1-35]|5[689]|60|7[17])\\d",,,,"1103",,,[4]],[,,"114[89]",,,,"1148",,,[4]],,[,,,,,,,,,[-1]]],TJ:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"1(?:0[1-3]|12)",,,,"101"],[,,,,,,,,,[-1]],,,,"TJ",,,,,,,,,,,,,,,,,,[,,"1(?:0[1-3]|12)",,,,"101"],,[,,"1(?:0[1-3]|12)",,,,"101"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TL:[,[,,"1\\d\\d",
,,,,,,[3]],,,[,,"11[25]",,,,"112"],[,,,,,,,,,[-1]],,,,"TL",,,,,,,,,,,,,,,,,,[,,"11[25]",,,,"112"],,[,,"1(?:0[02]|1[25]|2[0138]|72|9[07])",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TM:[,[,,"0\\d",,,,,,,[2]],,,[,,"0[1-49]",,,,"01"],[,,,,,,,,,[-1]],,,,"TM",,,,,,,,,,,,,,,,,,[,,"0[1-3]",,,,"01"],,[,,"0[1-49]",,,,"01"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TN:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"19[078]",,,,"190"],[,,,,,,,,,[-1]],,,,"TN",,,,,,,,,,,,,,,,,,[,,"19[078]",,,,"190"],
,[,,"19[078]",,,,"190"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TO:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|22|33|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"TO",,,,,,,,,,,,,,,,,,[,,"9(?:11|22|33|99)",,,,"911"],,[,,"9(?:11|22|33|99)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TR:[,[,,"[1-9]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:1[02]|22|3[126]|4[04]|5[15-9]|6[18]|77|83)",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"TR",,,,,,,,,,,,,,,,,,[,,"1(?:1[02]|55)",,,,"110",,,[3]],,[,,"1(?:1(?:[02-79]|8(?:1[018]|2[0245]|3[2-4]|42|5[058]|6[06]|7[07]|8[01389]|9[089]))|3(?:37|[58]6|65)|471|5(?:07|78)|6(?:[02]6|99)|8(?:63|95))|2(?:077|268|4(?:17|23)|5(?:7[26]|82)|6[14]4|8\\d\\d|9(?:30|89))|3(?:0(?:05|72)|353|4(?:06|30|64)|502|674|747|851|9(?:1[29]|60))|4(?:0(?:25|3[12]|[47]2)|3(?:3[13]|[89]1)|439|5(?:43|55)|717|832)|5(?:145|290|[4-6]\\d\\d|772|833|9(?:[06]1|92))|6(?:236|6(?:12|39|8[59])|769)|7890|8(?:688|7(?:28|65)|85[06])|9(?:159|290)|1[2-9]\\d",
,,,"110"],[,,"(?:285|542)0",,,,"2850",,,[4]],[,,,,,,,,,[-1]],,[,,"1(?:3(?:37|[58]6|65)|4(?:4|71)|5(?:07|78)|6(?:[02]6|99)|8(?:3|63|95))|(?:2(?:07|26|4[12]|5[78]|6[14]|8\\d|9[38])|3(?:0[07]|[38]5|4[036]|50|67|74|9[16])|4(?:0[2-47]|3[389]|[48]3|5[45]|71)|5(?:14|29|[4-6]\\d|77|83|9[069])|6(?:23|6[138]|76)|789|8(?:68|7[26]|85)|9(?:15|29))\\d",,,,"144",,,[3,4]]],TT:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"99[09]",,,,"990"],[,,,,,,,,,[-1]],,,,"TT",,,,,,,,,,,,,,,,,,[,,"99[09]",,,,"990"],,[,,"99[09]",,,,"990"],[,
,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TV:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"TV",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"1\\d\\d|911",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TW:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"11[0289]|1(?:81|92)\\d",,,,"110"],[,,"10[56]",,,,"105",,,[3]],,,,"TW",,,,,,,,,,,,,,,,,,[,,"11[029]",,,,"110",,,[3]],,[,,"1(?:0[04-6]|1[0237-9]|3[389]|6[05-8]|7[07]|8(?:0|11)|9(?:19|22|5[057]|68|8[05]|9[15689]))",,,,"100"],[,
,"1(?:65|9(?:1\\d|50|85|98))",,,,"165"],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TZ:[,[,,"[149]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"11[12]|999",,,,"111",,,[3]],[,,,,,,,,,[-1]],,,,"TZ",,,,,,,,,,,,,,,,,,[,,"11[12]|999",,,,"111",,,[3]],,[,,"11[128]|46400|999",,,,"111"],[,,,,,,,,,[-1]],[,,"464\\d\\d",,,,"46400",,,[5]],,[,,"464\\d\\d",,,,"46400",,,[5]]],UA:[,[,,"[189]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:0[1-3]|1(?:2|6\\d{3}))",,,,"101",,,[3,6]],[,,,,,,,,,[-1]],,,,"UA",,,,,,,,,,,,,,,,,,[,,"1(?:0[1-3]|12)",,,
,"101",,,[3]],,[,,"1(?:0[1-49]|1(?:2|6(?:000|1(?:11|23))|8\\d\\d?)|(?:[278]|5\\d)\\d)|[89]00\\d\\d?|151|1(?:06|4\\d|6)\\d\\d",,,,"101"],[,,,,,,,,,[-1]],[,,"(?:118|[89]00)\\d\\d?",,,,"1180",,,[4,5]],,[,,,,,,,,,[-1]]],UG:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"UG",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"999",,,,"999"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],US:[,[,,"[1-9]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"112|[69]11",,,,"112",,,[3]],[,,"24280|(?:381|968)35|4(?:3355|7553|8221)|5(?:(?:489|934)2|5928)|72078|(?:323|960)40|(?:276|414)63|(?:2(?:520|744)|7390|9968)9|(?:693|732|976)88|(?:3(?:556|825)|5294|8623|9729)4|(?:3378|4136|7642|8961|9979)6|(?:4(?:6(?:15|32)|827)|(?:591|720)8|9529)7",
,,,"24280",,,[5]],,,,"US",,,,,,,,,,,,,,,,,,[,,"112|911",,,,"112",,,[3]],,[,,"11(?:2|5[1-47]|[68]\\d|7[0-57]|98)|[2-9]\\d{3,5}|[2-9]11",,,,"112"],[,,"2(?:3333|(?:4224|7562|900)2|56447|6688)|3(?:1010|2665|7404)|40404|560560|6(?:0060|22639|5246|7622)|7(?:0701|3822|4666)|8(?:(?:3825|7226)5|4816)|99099",,,,"23333",,,[5,6]],[,,"336\\d\\d|[2-9]\\d{3}|[2356]11",,,,"211",,,[3,4,5]],,[,,"[2-9]\\d{4,5}",,,,"20000",,,[5,6]]],UY:[,[,,"[19]\\d{2,3}",,,,,,,[3,4]],,,[,,"128|911",,,,"128",,,[3]],[,,,,,,,,,[-1]],,
,,"UY",,,,,,,,,,,,,,,,,,[,,"128|911",,,,"128",,,[3]],,[,,"1(?:0[4-9]|1[2368]|2[0-3568]|787)|911",,,,"104"],[,,"178\\d",,,,"1780",,,[4]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],UZ:[,[,,"[04]\\d(?:\\d(?:\\d{2})?)?",,,,,,,[2,3,5]],,,[,,"0(?:0[1-3]|[1-3]|50)",,,,"01",,,[2,3]],[,,,,,,,,,[-1]],,,,"UZ",,,,,,,,,,,,,,,,,,[,,"0(?:0[1-3]|[1-3]|50)",,,,"01",,,[2,3]],,[,,"0(?:0[1-3]|[1-3]|50)|45400",,,,"01"],[,,,,,,,,,[-1]],[,,"454\\d\\d",,,,"45400",,,[5]],,[,,"454\\d\\d",,,,"45400",,,[5]]],VA:[,[,,"1\\d\\d",,,,,,,
[3]],,,[,,"11[2358]",,,,"112"],[,,,,,,,,,[-1]],,,,"VA",,,,,,,,,,,,,,,,,,[,,"11[2358]",,,,"112"],,[,,"11[2358]",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],VC:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"VC",,,,,,,,,,,,,,,,,,[,,"9(?:11|99)",,,,"911"],,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],VE:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"1(?:12|71)|911",,,,"112"],[,,,,,,,,,[-1]],,,,"VE",,,,,,,,,,,,,,,,,,[,,"1(?:12|71)|911",,,,"112"],
,[,,"1(?:12|71)|911",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],VG:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"VG",,,,,,,,,,,,,,,,,,[,,"9(?:11|99)",,,,"911"],,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],VI:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"VI",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"911",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],VN:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[3-5]",
,,,"113"],[,,,,,,,,,[-1]],,,,"VN",,,,,,,,,,,,,,,,,,[,,"11[3-5]",,,,"113"],,[,,"11[3-5]",,,,"113"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],VU:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"112",,,,"112"],[,,,,,,,,,[-1]],,,,"VU",,,,,,,,,,,,,,,,,,[,,"112",,,,"112"],,[,,"112",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],WF:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],,,,"WF",,,,,,,,,,,,,,,,,,[,,"1[578]",,,,"15"],,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,
,,,[-1]]],WS:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"9(?:11|9[4-69])",,,,"911"],[,,,,,,,,,[-1]],,,,"WS",,,,,,,,,,,,,,,,,,[,,"9(?:11|9[4-69])",,,,"911"],,[,,"1(?:1[12]|2[0-6]|[39]0)|9(?:11|9[4-79])",,,,"111"],[,,,,,,,,,[-1]],[,,"12[0-6]",,,,"120"],,[,,,,,,,,,[-1]]],XK:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"1(?:12|9[2-4])",,,,"112"],[,,,,,,,,,[-1]],,,,"XK",,,,,,,,,,,,,,,,,,[,,"1(?:12|9[2-4])",,,,"112"],,[,,"1(?:12|9[2-4])",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],YE:[,[,,"1\\d\\d",,,,,,,[3]],
,,[,,"19[1459]",,,,"191"],[,,,,,,,,,[-1]],,,,"YE",,,,,,,,,,,,,,,,,,[,,"19[1459]",,,,"191"],,[,,"19[1459]",,,,"191"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],YT:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:12|5)",,,,"15"],[,,,,,,,,,[-1]],,,,"YT",,,,,,,,,,,,,,,,,,[,,"1(?:12|5)",,,,"15"],,[,,"1(?:12|5)",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],ZA:[,[,,"[134]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:01\\d\\d|12)",,,,"112",,,[3,5]],[,,"41(?:348|851)",,,,"41348",,,[5]],,,,"ZA",,,,,,,,,,,,
,,,,,,[,,"1(?:01(?:11|77)|12)",,,,"112",,,[3,5]],,[,,"1(?:0(?:1(?:11|77)|20|7)|1[12]|77(?:3[237]|[45]7|6[279]|9[26]))|[34]\\d{4}",,,,"107"],[,,"3(?:078[23]|7(?:064|567)|8126)|4(?:394[16]|7751|8837)|4[23]699",,,,"30782",,,[5]],[,,"111",,,,"111",,,[3]],,[,,"[34]\\d{4}",,,,"30000",,,[5]]],ZM:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"112|99[139]",,,,"112"],[,,,,,,,,,[-1]],,,,"ZM",,,,,,,,,,,,,,,,,,[,,"112|99[139]",,,,"112"],,[,,"112|99[139]",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],ZW:[,[,
,"[139]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"112|9(?:5[023]|61|9[3-59])",,,,"112",,,[3]],[,,"3[013-57-9]\\d{3}",,,,"30000",,,[5]],,,,"ZW",,,,,,,,,,,,,,,,,,[,,"112|99[3-59]",,,,"112",,,[3]],,[,,"11[2469]|3[013-57-9]\\d{3}|9(?:5[023]|6[0-25]|9[3-59])",,,,"112"],[,,,,,,,,,[-1]],[,,"114|9(?:5[023]|6[0-25])",,,,"114",,,[3]],,[,,,,,,,,,[-1]]]};/*

 Copyright (C) 2018 The Libphonenumber Authors.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
i18n.phonenumbers.ShortNumberInfo=function(){this.regionToMetadataMap={}};goog.addSingletonGetter(i18n.phonenumbers.ShortNumberInfo);i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_=["BR","CL","NI"];i18n.phonenumbers.ShortNumberInfo.ShortNumberCost={TOLL_FREE:0,STANDARD_RATE:1,PREMIUM_RATE:2,UNKNOWN_COST:3};i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodesForCountryCode_=function(a){return(a=i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a])?a:[]};
i18n.phonenumbers.ShortNumberInfo.prototype.regionDialingFromMatchesNumber_=function(a,b){a=this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());return null!=b&&a.includes(b)};i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumberForRegion=function(a,b){if(!this.regionDialingFromMatchesNumber_(a,b))return!1;b=this.getMetadataForRegion_(b);if(!b)return!1;a=this.getNationalSignificantNumber_(a).length;return b.getGeneralDesc().possibleLengthArray().includes(a)};
i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumber=function(a){var b=this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());a=this.getNationalSignificantNumber_(a).length;for(var c=0;c<b.length;c++){var d=this.getMetadataForRegion_(b[c]);if(d&&d.getGeneralDesc().possibleLengthArray().includes(a))return!0}return!1};
i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumberForRegion=function(a,b){if(!this.regionDialingFromMatchesNumber_(a,b))return!1;b=this.getMetadataForRegion_(b);if(!b)return!1;a=this.getNationalSignificantNumber_(a);var c=b.getGeneralDesc();if(!this.matchesPossibleNumberAndNationalNumber_(a,c))return!1;b=b.getShortCode();return this.matchesPossibleNumberAndNationalNumber_(a,b)};
i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumber=function(a){var b=this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault()),c=this.getRegionCodeForShortNumberFromRegionList_(a,b);return 1<b.length&&null!=c?!0:this.isValidShortNumberForRegion(a,c)};
i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCostForRegion=function(a,b){var c=i18n.phonenumbers.ShortNumberInfo.ShortNumberCost;if(!this.regionDialingFromMatchesNumber_(a,b))return c.UNKNOWN_COST;var d=this.getMetadataForRegion_(b);if(!d)return c.UNKNOWN_COST;a=this.getNationalSignificantNumber_(a);return d.getGeneralDesc().possibleLengthArray().includes(a.length)?this.matchesPossibleNumberAndNationalNumber_(a,d.getPremiumRate())?c.PREMIUM_RATE:this.matchesPossibleNumberAndNationalNumber_(a,
d.getStandardRate())?c.STANDARD_RATE:this.matchesPossibleNumberAndNationalNumber_(a,d.getTollFree())||this.isEmergencyNumber(a,b)?c.TOLL_FREE:c.UNKNOWN_COST:c.UNKNOWN_COST};
i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCost=function(a){var b=i18n.phonenumbers.ShortNumberInfo.ShortNumberCost,c=this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());if(0===c.length)return b.UNKNOWN_COST;if(1===c.length)return this.getExpectedCostForRegion(a,c[0]);for(var d=b.TOLL_FREE,e=0;e<c.length;e++){var f=this.getExpectedCostForRegion(a,c[e]);switch(f){case b.PREMIUM_RATE:return b.PREMIUM_RATE;case b.UNKNOWN_COST:d=b.UNKNOWN_COST;break;case b.STANDARD_RATE:d!==b.UNKNOWN_COST&&
(d=b.STANDARD_RATE);break;case b.TOLL_FREE:break;default:throw Error("Unrecognized cost for region: "+f);}}return d};i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodeForShortNumberFromRegionList_=function(a,b){if(0===b.length)return null;if(1===b.length)return b[0];a=this.getNationalSignificantNumber_(a);for(var c=0;c<b.length;c++){var d=b[c],e=this.getMetadataForRegion_(d);if(e&&this.matchesPossibleNumberAndNationalNumber_(a,e.getShortCode()))return d}return null};
i18n.phonenumbers.ShortNumberInfo.prototype.getSupportedRegions=function(){return Object.keys(i18n.phonenumbers.shortnumbermetadata.countryToMetadata).filter(function(a){return isNaN(a)})};i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumber=function(a){a=this.getMetadataForRegion_(a);if(!a)return"";a=a.getShortCode();return a.hasExampleNumber()?a.getExampleNumber()||"":""};
i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumberForCost=function(a,b){a=this.getMetadataForRegion_(a);if(!a)return"";var c=i18n.phonenumbers.ShortNumberInfo.ShortNumberCost,d=null;switch(b){case c.TOLL_FREE:d=a.getTollFree();break;case c.STANDARD_RATE:d=a.getStandardRate();break;case c.PREMIUM_RATE:d=a.getPremiumRate()}return d&&d.hasExampleNumber()?d.getExampleNumber()||"":""};
i18n.phonenumbers.ShortNumberInfo.prototype.connectsToEmergencyNumber=function(a,b){return this.matchesEmergencyNumberHelper_(a,b,!0)};i18n.phonenumbers.ShortNumberInfo.prototype.isEmergencyNumber=function(a,b){return this.matchesEmergencyNumberHelper_(a,b,!1)};
i18n.phonenumbers.ShortNumberInfo.prototype.getMetadataForRegion_=function(a){if(!a)return null;a=a.toUpperCase();var b=this.regionToMetadataMap[a];if(null==b){b=new goog.proto2.PbLiteSerializer;var c=i18n.phonenumbers.shortnumbermetadata.countryToMetadata[a];if(null==c)return null;b=b.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(),c);this.regionToMetadataMap[a]=b}return b};
i18n.phonenumbers.ShortNumberInfo.prototype.matchesEmergencyNumberHelper_=function(a,b,c){var d=i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(a);if(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(d))return!1;a=this.getMetadataForRegion_(b);if(null==a||!a.hasEmergency())return!1;d=i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d);b=c&&!i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_.includes(b);c=a.getEmergency().getNationalNumberPatternOrDefault();
return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(c,d)||b&&i18n.phonenumbers.PhoneNumberUtil.matchesPrefix(c,d)};i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecific=function(a){var b=this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());b=this.getRegionCodeForShortNumberFromRegionList_(a,b);a=this.getNationalSignificantNumber_(a);b=this.getMetadataForRegion_(b);return!!b&&this.matchesPossibleNumberAndNationalNumber_(a,b.getCarrierSpecific())};
i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecificForRegion=function(a,b){if(!this.regionDialingFromMatchesNumber_(a,b))return!1;a=this.getNationalSignificantNumber_(a);b=this.getMetadataForRegion_(b);return!!b&&this.matchesPossibleNumberAndNationalNumber_(a,b.getCarrierSpecific())};
i18n.phonenumbers.ShortNumberInfo.prototype.isSmsServiceForRegion=function(a,b){if(!this.regionDialingFromMatchesNumber_(a,b))return!1;b=this.getMetadataForRegion_(b);a=this.getNationalSignificantNumber_(a);return!!b&&this.matchesPossibleNumberAndNationalNumber_(a,b.getSmsServices())};
i18n.phonenumbers.ShortNumberInfo.prototype.getNationalSignificantNumber_=function(a){if(!a.hasNationalNumber())return"";var b=""+a.getNationalNumber();return a.hasItalianLeadingZero()&&a.getItalianLeadingZero()&&0<a.getNumberOfLeadingZerosOrDefault()?Array(a.getNumberOfLeadingZerosOrDefault()+1).join("0")+b:b};
i18n.phonenumbers.ShortNumberInfo.prototype.matchesPossibleNumberAndNationalNumber_=function(a,b){return 0<b.possibleLengthArray().length&&!b.possibleLengthArray().includes(a.length)?!1:i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(b.getNationalNumberPatternOrDefault(),a.toString())};i18n.phonenumbers.AsYouTypeFormatter=function(a){this.DIGIT_PLACEHOLDER_="\u2008";this.DIGIT_PATTERN_=new RegExp(this.DIGIT_PLACEHOLDER_);this.currentOutput_="";this.formattingTemplate_=new goog.string.StringBuffer;this.currentFormattingPattern_="";this.accruedInput_=new goog.string.StringBuffer;this.accruedInputWithoutFormatting_=new goog.string.StringBuffer;this.ableToFormat_=!0;this.isExpectingCountryCallingCode_=this.isCompleteNumber_=this.inputHasFormatting_=!1;this.phoneUtil_=i18n.phonenumbers.PhoneNumberUtil.getInstance();
this.positionToRemember_=this.originalPosition_=this.lastMatchPosition_=0;this.prefixBeforeNationalNumber_=new goog.string.StringBuffer;this.shouldAddSpaceAfterNationalPrefix_=!1;this.extractedNationalPrefix_="";this.nationalNumber_=new goog.string.StringBuffer;this.possibleFormats_=[];this.defaultCountry_=a;this.defaultMetadata_=this.currentMetadata_=this.getMetadataForRegion_(this.defaultCountry_)};i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_=" ";
i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_=new i18n.phonenumbers.PhoneMetadata;i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_.setInternationalPrefix("NA");i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_=new RegExp("^["+i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION+"]*(\\$\\d["+i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION+"]*)+$");i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_=/[- ]/;
i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_=3;i18n.phonenumbers.AsYouTypeFormatter.prototype.getMetadataForRegion_=function(a){a=this.phoneUtil_.getCountryCodeForRegion(a);a=this.phoneUtil_.getRegionCodeForCountryCode(a);a=this.phoneUtil_.getMetadataForRegion(a);return null!=a?a:i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_};
i18n.phonenumbers.AsYouTypeFormatter.prototype.maybeCreateNewTemplate_=function(){for(var a=this.possibleFormats_.length,b=0;b<a;++b){var c=this.possibleFormats_[b],d=c.getPatternOrDefault();if(this.currentFormattingPattern_==d)return!1;if(this.createFormattingTemplate_(c))return this.currentFormattingPattern_=d,this.shouldAddSpaceAfterNationalPrefix_=i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(c.getNationalPrefixFormattingRule()),this.lastMatchPosition_=0,!0}return this.ableToFormat_=
!1};
i18n.phonenumbers.AsYouTypeFormatter.prototype.getAvailableFormats_=function(a){for(var b=this.isCompleteNumber_&&0==this.extractedNationalPrefix_.length&&0<this.currentMetadata_.intlNumberFormatCount()?this.currentMetadata_.intlNumberFormatArray():this.currentMetadata_.numberFormatArray(),c=b.length,d=0;d<c;++d){var e=b[d];0<this.extractedNationalPrefix_.length&&this.phoneUtil_.formattingRuleHasFirstGroupOnly(e.getNationalPrefixFormattingRuleOrDefault())&&!e.getNationalPrefixOptionalWhenFormatting()&&!e.hasDomesticCarrierCodeFormattingRule()||
(0!=this.extractedNationalPrefix_.length||this.isCompleteNumber_||this.phoneUtil_.formattingRuleHasFirstGroupOnly(e.getNationalPrefixFormattingRuleOrDefault())||e.getNationalPrefixOptionalWhenFormatting())&&i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_.test(e.getFormatOrDefault())&&this.possibleFormats_.push(e)}this.narrowDownPossibleFormats_(a)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.narrowDownPossibleFormats_=function(a){for(var b=[],c=a.length-i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_,d=this.possibleFormats_.length,e=0;e<d;++e){var f=this.possibleFormats_[e];if(0==f.leadingDigitsPatternCount())b.push(this.possibleFormats_[e]);else{var g=Math.min(c,f.leadingDigitsPatternCount()-1);f=f.getLeadingDigitsPattern(g);0==a.search(f)&&b.push(this.possibleFormats_[e])}}this.possibleFormats_=b};
i18n.phonenumbers.AsYouTypeFormatter.prototype.createFormattingTemplate_=function(a){var b=a.getPatternOrDefault();this.formattingTemplate_.clear();a=this.getFormattingTemplate_(b,a.getFormatOrDefault());return 0<a.length?(this.formattingTemplate_.append(a),!0):!1};i18n.phonenumbers.AsYouTypeFormatter.prototype.getFormattingTemplate_=function(a,b){var c="999999999999999".match(a)[0];if(c.length<this.nationalNumber_.getLength())return"";a=c.replace(new RegExp(a,"g"),b);return a=a.replace(/9/g,this.DIGIT_PLACEHOLDER_)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.clear=function(){this.currentOutput_="";this.accruedInput_.clear();this.accruedInputWithoutFormatting_.clear();this.formattingTemplate_.clear();this.lastMatchPosition_=0;this.currentFormattingPattern_="";this.prefixBeforeNationalNumber_.clear();this.extractedNationalPrefix_="";this.nationalNumber_.clear();this.ableToFormat_=!0;this.inputHasFormatting_=!1;this.originalPosition_=this.positionToRemember_=0;this.isExpectingCountryCallingCode_=this.isCompleteNumber_=
!1;this.possibleFormats_=[];this.shouldAddSpaceAfterNationalPrefix_=!1;this.currentMetadata_!=this.defaultMetadata_&&(this.currentMetadata_=this.getMetadataForRegion_(this.defaultCountry_))};i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigit=function(a){return this.currentOutput_=this.inputDigitWithOptionToRememberPosition_(a,!1)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitAndRememberPosition=function(a){return this.currentOutput_=this.inputDigitWithOptionToRememberPosition_(a,!0)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitWithOptionToRememberPosition_=function(a,b){this.accruedInput_.append(a);b&&(this.originalPosition_=this.accruedInput_.getLength());this.isDigitOrLeadingPlusSign_(a)?a=this.normalizeAndAccrueDigitsAndPlusSign_(a,b):(this.ableToFormat_=!1,this.inputHasFormatting_=!0);if(!this.ableToFormat_){if(!this.inputHasFormatting_)if(this.attemptToExtractIdd_()){if(this.attemptToExtractCountryCallingCode_())return this.attemptToChoosePatternWithPrefixExtracted_()}else if(this.ableToExtractLongerNdd_())return this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_),this.attemptToChoosePatternWithPrefixExtracted_();
return this.accruedInput_.toString()}switch(this.accruedInputWithoutFormatting_.getLength()){case 0:case 1:case 2:return this.accruedInput_.toString();case 3:if(this.attemptToExtractIdd_())this.isExpectingCountryCallingCode_=!0;else return this.extractedNationalPrefix_=this.removeNationalPrefixFromNationalNumber_(),this.attemptToChooseFormattingPattern_();default:if(this.isExpectingCountryCallingCode_)return this.attemptToExtractCountryCallingCode_()&&(this.isExpectingCountryCallingCode_=!1),this.prefixBeforeNationalNumber_.toString()+
this.nationalNumber_.toString();if(0<this.possibleFormats_.length){a=this.inputDigitHelper_(a);b=this.attemptToFormatAccruedDigits_();if(0<b.length)return b;this.narrowDownPossibleFormats_(this.nationalNumber_.toString());return this.maybeCreateNewTemplate_()?this.inputAccruedNationalNumber_():this.ableToFormat_?this.appendNationalNumber_(a):this.accruedInput_.toString()}return this.attemptToChooseFormattingPattern_()}};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChoosePatternWithPrefixExtracted_=function(){this.ableToFormat_=!0;this.isExpectingCountryCallingCode_=!1;this.possibleFormats_=[];this.lastMatchPosition_=0;this.formattingTemplate_.clear();this.currentFormattingPattern_="";return this.attemptToChooseFormattingPattern_()};i18n.phonenumbers.AsYouTypeFormatter.prototype.getExtractedNationalPrefix_=function(){return this.extractedNationalPrefix_};
i18n.phonenumbers.AsYouTypeFormatter.prototype.ableToExtractLongerNdd_=function(){if(0<this.extractedNationalPrefix_.length){var a=this.nationalNumber_.toString();this.nationalNumber_.clear();this.nationalNumber_.append(this.extractedNationalPrefix_);this.nationalNumber_.append(a);a=this.prefixBeforeNationalNumber_.toString();var b=a.lastIndexOf(this.extractedNationalPrefix_);this.prefixBeforeNationalNumber_.clear();this.prefixBeforeNationalNumber_.append(a.substring(0,b))}return this.extractedNationalPrefix_!=
this.removeNationalPrefixFromNationalNumber_()};i18n.phonenumbers.AsYouTypeFormatter.prototype.isDigitOrLeadingPlusSign_=function(a){return i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN.test(a)||1==this.accruedInput_.getLength()&&i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN.test(a)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToFormatAccruedDigits_=function(){for(var a=this.nationalNumber_.toString(),b=this.possibleFormats_.length,c=0;c<b;++c){var d=this.possibleFormats_[c],e=d.getPatternOrDefault();if((new RegExp("^(?:"+e+")$")).test(a)&&(this.shouldAddSpaceAfterNationalPrefix_=i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(d.getNationalPrefixFormattingRule()),d=a.replace(new RegExp(e,"g"),d.getFormat()),d=this.appendNationalNumber_(d),
i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(d)==this.accruedInputWithoutFormatting_))return d}return""};
i18n.phonenumbers.AsYouTypeFormatter.prototype.appendNationalNumber_=function(a){var b=this.prefixBeforeNationalNumber_.getLength();return this.shouldAddSpaceAfterNationalPrefix_&&0<b&&this.prefixBeforeNationalNumber_.toString().charAt(b-1)!=i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_?this.prefixBeforeNationalNumber_+i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_+a:this.prefixBeforeNationalNumber_+a};
i18n.phonenumbers.AsYouTypeFormatter.prototype.getRememberedPosition=function(){if(!this.ableToFormat_)return this.originalPosition_;for(var a=0,b=0,c=this.accruedInputWithoutFormatting_.toString(),d=this.currentOutput_.toString();a<this.positionToRemember_&&b<d.length;)c.charAt(a)==d.charAt(b)&&a++,b++;return b};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChooseFormattingPattern_=function(){var a=this.nationalNumber_.toString();return a.length>=i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_?(this.getAvailableFormats_(a),a=this.attemptToFormatAccruedDigits_(),0<a.length?a:this.maybeCreateNewTemplate_()?this.inputAccruedNationalNumber_():this.accruedInput_.toString()):this.appendNationalNumber_(a)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputAccruedNationalNumber_=function(){var a=this.nationalNumber_.toString(),b=a.length;if(0<b){for(var c="",d=0;d<b;d++)c=this.inputDigitHelper_(a.charAt(d));return this.ableToFormat_?this.appendNationalNumber_(c):this.accruedInput_.toString()}return this.prefixBeforeNationalNumber_.toString()};
i18n.phonenumbers.AsYouTypeFormatter.prototype.isNanpaNumberWithNationalPrefix_=function(){if(1!=this.currentMetadata_.getCountryCode())return!1;var a=this.nationalNumber_.toString();return"1"==a.charAt(0)&&"0"!=a.charAt(1)&&"1"!=a.charAt(1)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.removeNationalPrefixFromNationalNumber_=function(){var a=this.nationalNumber_.toString(),b=0;if(this.isNanpaNumberWithNationalPrefix_())b=1,this.prefixBeforeNationalNumber_.append("1").append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_),this.isCompleteNumber_=!0;else if(this.currentMetadata_.hasNationalPrefixForParsing()){var c=new RegExp("^(?:"+this.currentMetadata_.getNationalPrefixForParsing()+")");c=a.match(c);null!=c&&
null!=c[0]&&0<c[0].length&&(this.isCompleteNumber_=!0,b=c[0].length,this.prefixBeforeNationalNumber_.append(a.substring(0,b)))}this.nationalNumber_.clear();this.nationalNumber_.append(a.substring(b));return a.substring(0,b)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractIdd_=function(){var a=this.accruedInputWithoutFormatting_.toString(),b=new RegExp("^(?:\\"+i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN+"|"+this.currentMetadata_.getInternationalPrefix()+")");b=a.match(b);return null!=b&&null!=b[0]&&0<b[0].length?(this.isCompleteNumber_=!0,b=b[0].length,this.nationalNumber_.clear(),this.nationalNumber_.append(a.substring(b)),this.prefixBeforeNationalNumber_.clear(),this.prefixBeforeNationalNumber_.append(a.substring(0,
b)),a.charAt(0)!=i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN&&this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_),!0):!1};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractCountryCallingCode_=function(){if(0==this.nationalNumber_.getLength())return!1;var a=new goog.string.StringBuffer,b=this.phoneUtil_.extractCountryCode(this.nationalNumber_,a);if(0==b)return!1;this.nationalNumber_.clear();this.nationalNumber_.append(a.toString());a=this.phoneUtil_.getRegionCodeForCountryCode(b);i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY==a?this.currentMetadata_=this.phoneUtil_.getMetadataForNonGeographicalRegion(b):
a!=this.defaultCountry_&&(this.currentMetadata_=this.getMetadataForRegion_(a));this.prefixBeforeNationalNumber_.append(""+b).append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_);this.extractedNationalPrefix_="";return!0};
i18n.phonenumbers.AsYouTypeFormatter.prototype.normalizeAndAccrueDigitsAndPlusSign_=function(a,b){if(a==i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN){var c=a;this.accruedInputWithoutFormatting_.append(a)}else c=i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS[a],this.accruedInputWithoutFormatting_.append(c),this.nationalNumber_.append(c);b&&(this.positionToRemember_=this.accruedInputWithoutFormatting_.getLength());return c};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitHelper_=function(a){var b=this.formattingTemplate_.toString();if(0<=b.substring(this.lastMatchPosition_).search(this.DIGIT_PATTERN_)){var c=b.search(this.DIGIT_PATTERN_);a=b.replace(this.DIGIT_PATTERN_,a);this.formattingTemplate_.clear();this.formattingTemplate_.append(a);this.lastMatchPosition_=c;return a.substring(0,this.lastMatchPosition_+1)}1==this.possibleFormats_.length&&(this.ableToFormat_=!1);this.currentFormattingPattern_="";return this.accruedInput_.toString()};Object.defineProperty(exports,"__esModule",{value:!0});exports.default=i18n.phonenumbers;module.exports=exports["default"];

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[1])(1)
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map_styles_apple__ = __webpack_require__(1253);

/* harmony default export */ __webpack_exports__["a"] = ({
  disableDefaultUI: true,
  draggable: true,
  zoomControl: false,
  scrollwheel: true,
  disableDoubleClickZoom: false,
  gestureHandling: 'cooperative',
  styles: __WEBPACK_IMPORTED_MODULE_0__map_styles_apple__["a" /* default */]
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  pickup: {
    path: 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
    fillColor: '#2EE47D',
    fillOpacity: 1,
    scale: 0.5,
    strokeColor: 'black',
    strokeWeight: 3
  },
  dropoff: {
    path: 'M22-48h-44v43h16l6 5 6-5h16z',
    fillColor: '#CA3538',
    fillOpacity: 1,
    scale: 0.5,
    strokeColor: 'black',
    strokeWeight: 3
  },
  ontheway: {
    path: 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
    fillColor: '#dbd935',
    fillOpacity: 1,
    scale: 0.5,
    strokeColor: 'black',
    strokeWeight: 3
  },
  arrived: {
    path: 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
    fillColor: '#389ce1',
    fillOpacity: 1,
    scale: 0.5,
    strokeColor: 'black',
    strokeWeight: 3
  },
  completed: {
    path: 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
    fillColor: '#1ac1b1',
    fillOpacity: 1,
    scale: 0.5,
    strokeColor: 'black',
    strokeWeight: 3
  },
  car: {
    path: 'M45.699 24.145l-7.89-13.293c-.314-.584-1.072-.852-1.721-.852h-7.088v-6c0-1.1-.9-2-2-2h-5c-1.1 0-2 .9-2 2v6h-5.96c-.65 0-1.44.268-1.754.852l-7.921 13.398c-1.301 0-2.365.987-2.365 2.322v12.139c0 1.335 1.064 2.289 2.365 2.289h2.635v3.78c0 2.004 1.328 3.22 3.279 3.22h1.183c1.951 0 3.538-1.216 3.538-3.22v-3.78h20v3.78c0 2.004 1.714 3.22 3.665 3.22h1.184c1.951 0 3.151-1.216 3.151-3.22v-3.78h2.763c1.3 0 2.237-.954 2.237-2.289v-12.139c0-1.335-1-2.427-2.301-2.427zm-37.194 9.71c-1.633 0-2.958-1.358-2.958-3.034 0-1.677 1.324-3.035 2.958-3.035s2.957 1.358 2.957 3.035c0 1.676-1.323 3.034-2.957 3.034zm1.774-9.855l5.384-9.377c.292-.598 1.063-.623 1.713-.623h15.376c.65 0 1.421.025 1.712.623l5.385 9.377h-29.57zm31.343 9.855c-1.632 0-2.957-1.358-2.957-3.034 0-1.677 1.325-3.035 2.957-3.035 1.633 0 2.958 1.358 2.958 3.035 0 1.676-1.325 3.034-2.958 3.034z',
    fillColor: '#0D79F2',
    fillOpacity: 1,
    scale: 0.6,
    strokeColor: 'black',
    strokeWeight: 0
  },
  stop: {
    path: 'M 0 0 A 1 1 0 0 0 0 -32 A 1 1 0 0 0 0 0',
    fillColor: '#fe8214',
    fillOpacity: 1,
    scale: 0.45,
    strokeColor: 'black',
    strokeWeight: 3
  },
  house: {
    path: 'M 32 3 L 1 28 L 1.4921875 28.654297 C 2.8591875 30.477297 5.4694688 30.791703 7.2304688 29.345703 L 32 9 L 56.769531 29.345703 C 58.530531 30.791703 61.140812 30.477297 62.507812 28.654297 L 63 28 L 54 20.742188 L 54 8 L 45 8 L 45 13.484375 L 32 3 z M 32 13 L 8 32 L 8 56 L 56 56 L 56 35 L 32 13 z M 26 34 L 38 34 L 38 52 L 26 52 L 26 34 z',
    fillColor: '#F25E0D',
    fillOpacity: 1,
    scale: 0.6,
    strokeColor: 'black',
    strokeWeight: 0
  }
});

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(115);
var defined = __webpack_require__(116);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(711)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(122)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isObject;
// Is a given variable an object?
function isObject(obj) {
  var type = typeof obj;
  return type === 'function' || type === 'object' && !!obj;
}


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tagTester_js__ = __webpack_require__(16);



// Is a given value an array?
// Delegates to ECMA5's native `Array.isArray`.
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__setup_js__["k" /* nativeIsArray */] || Object(__WEBPACK_IMPORTED_MODULE_1__tagTester_js__["a" /* default */])('Array'));


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = each;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__optimizeCb_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(14);




// The cornerstone for collection functions, an `each`
// implementation, aka `forEach`.
// Handles raw objects in addition to array-likes. Treats all
// sparse array-likes as if they were dense.
function each(obj, iteratee, context) {
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__optimizeCb_js__["a" /* default */])(iteratee, context);
  var i, length;
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(obj)) {
    for (i = 0, length = obj.length; i < length; i++) {
      iteratee(obj[i], i, obj);
    }
  } else {
    var _keys = Object(__WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */])(obj);
    for (i = 0, length = _keys.length; i < length; i++) {
      iteratee(obj[_keys[i]], _keys[i], obj);
    }
  }
  return obj;
}


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (root, factory) {
  if (true) {
    module.exports = factory();
  } else if (typeof define === 'function' && define.amd) {
    define(factory);
  } else {
    root.us = factory();
  }
}(this, function () {

  var us = {};

  us.states = {};
  us.STATES = [];
  us.TERRITORIES = [];
  us.STATES_AND_TERRITORIES = [];

  us.State = function(data) {
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        this[key] = data[key];
      }
    }
  };
  us.State.prototype.toString = function() { return this.name; };
  us.State.prototype.shapefile_urls = function(region) {
    var base_url = "http://www2.census.gov/geo/tiger/TIGER2010";
    var urls = {
      'tract': base_url + '/TRACT/2010/tl_2010_' + this.fips.toString() + '_tract10.zip',
      'cd': base_url + '/CD/111/tl_2010_' + this.fips.toString() + '_cd111.zip',
      'county': base_url + '/COUNTY/2010/tl_2010_' + this.fips.toString() + '_county10.zip',
      'state': base_url + '/STATE/2010/tl_2010_' + this.fips.toString() + '_state10.zip',
      'zcta': base_url + '/ZCTA5/2010/tl_2010_' + this.fips.toString() + '_zcta510.zip',
      'block': base_url + '/TABBLOCK/2010/tl_2010_' + this.fips.toString() + '_tabblock10.zip',
      'blockgroup': base_url + '/BG/2010/tl_2010_' + this.fips.toString() + '_bg10.zip'
     };
     if (region && (region in urls)) {
       return urls[region];
     } else {
       return urls;
     }
  };
  /*   Semi-fuzzy state lookup. This method will make a best effort
        attempt at finding the state based on the lookup value provided.

          * two digits will search for FIPS code
          * two letters will search for state abbreviation
          * anything else will try to match the metaphone of state names

        Metaphone is used to allow for incorrect, but phonetically accurate,
        spelling of state names.

        Exact matches can be done on any attribute on State objects by passing
        the `field` argument. This skips the fuzzy-ish matching and does an
        exact, case-sensitive comparison against the specified field.

        This method caches non-None results, but can the cache can be bypassed
        with the `use_cache=False` argument.
    */
  var FIPS_RE = /^\d{2}$/;
  var ABBR_RE = /^[a-zA-Z]{2}$/;
  var _lookup_cache = {};
  us.lookup = function (val, field, dont_cache) {
    if (field == null)  {
      if (val.match(FIPS_RE)) {
        field = 'fips';
      } else if (val.match(ABBR_RE)) {
        val = val.toUpperCase();
        field = 'abbr';
      } else {
        val = us._metaphone(val);
        field = 'metaphones';
      }
    }
    var cache_key = field + ':' + val;
    if (!dont_cache && (cache_key in _lookup_cache)) {
      return _lookup_cache[cache_key];
    }
    for (var i=0; i < us.STATES_AND_TERRITORIES.length; i++) {
      var state = us.STATES_AND_TERRITORIES[i];
      if (Array.isArray(state[field])) {
        if (state[field].indexOf(val) !== -1) {
          _lookup_cache[cache_key] = state;
          return state;
        }
      }
      else if (val === state[field]) {
        _lookup_cache[cache_key] = state;
        return state;
      }
    }
  };

  us.mapping = function(from_field, to_field, states) {
    if (typeof states == 'undefined' || states == null) {
      states = us.STATES_AND_TERRITORIES;
    }
    var mapping = {};
    for (var i=0; i < states.length; i++) {
      var s = states[i];
      mapping[s[from_field]] = s[to_field];
    }
    return mapping;
  };

  // https://github.com/kvz/phpjs/blob/master/functions/strings/metaphone.js
  us._metaphone = function (word, phones) {
    // +   original by: Greg Frazier
    // +   improved by: Brett Zamir (http://brett-zamir.me)
    // +   improved by: Rafa? Kukawski (http://kukawski.pl)
    // *     example 1: metaphone('Gnu');
    // *     returns 1: 'N'

    word = (word == null ? '' : word + '').toUpperCase();

    function isVowel (a) {
      return 'AEIOU'.indexOf(a) !== -1;
    }

    function removeDuplicates (word) {
      var wordlength = word.length,
        char1 = word.charAt(0),
        char2,
        rebuilt = char1;

      for (var i = 1; i < wordlength; i++) {
        char2 = word.charAt(i);

        if (char2 !== char1 || char2 === 'C' || char2 === 'G') { // 'c' and 'g' are exceptions
          rebuilt += char2;
        }
        char1 = char2;
      }

      return rebuilt;
    }

    word = removeDuplicates(word);

    var wordlength = word.length,
      x = 0,
      metaword = '';

    //Special wh- case
    if (word.substr(0, 2) === 'WH') {
      // Remove "h" and rebuild the string
      word = 'W' + word.substr(2);
    }

    var cc = word.charAt(0); // current char. Short name cause it's used all over the function
    var pc = ''; // previous char. There is none when x === 0
    var nc = word.charAt(1); // next char
    var nnc = ''; // 2 characters ahead. Needed later

    if (1 <= wordlength) {
      switch (cc) {
      case 'A':
        if (nc === 'E') {
          metaword += 'E';
        } else {
          metaword += 'A';
        }
        x += 1;
        break;
      case 'E': case 'I': case 'O': case 'U':
        metaword += cc;
        x += 1;
        break;
      case 'G': case 'K': case 'P':
        if (nc === 'N') {
          x += 1;
        }
        break;
      case 'W':
        if (nc === 'R') {
          x += 1;
        }
        break;
      }
    }

    for (; x < wordlength; x++) {
      cc = word.charAt(x);
      pc = word.charAt(x - 1);
      nc = word.charAt(x + 1);
      nnc = word.charAt(x + 2);

      if (!isVowel(cc)) {
        switch (cc) {
        case 'B':
          if (pc !== 'M') {
            metaword += 'B';
          }
          break;
        case 'C':
          if (x + 1 <= wordlength) {
            if (word.substr(x - 1, 3) !== 'SCH') {
              if (x === 0 && (x + 2 <= wordlength) && isVowel(nnc)) {
                metaword += 'K';
              } else {
                metaword += 'X';
              }
            } else if (word.substr(x + 1, 2) === 'IA') {
              metaword += 'X';
            } else if ('IEY'.indexOf(nc) !== -1) {
              if (x > 0) {
                if (pc !== 'S') {
                  metaword += 'S';
                }
              } else {
                metaword += 'S';
              }
            } else {
              metaword += 'K';
            }
          } else {
            metaword += 'K';
          }
          break;
        case 'D':
          if (x + 2 <= wordlength && nc === 'G' && 'EIY'.indexOf(nnc) !== -1) {
            metaword += 'J';
            x += 2;
          } else {
            metaword += 'T';
          }
          break;
        case 'F':
          metaword += 'F';
          break;
        case 'G':
          if (x < wordlength) {
            if ((nc === 'N' && x + 1 === wordlength - 1) || (nc === 'N' && nnc === 'S' && x + 2 === wordlength - 1)) {
              break;
            }
            if (word.substr(x + 1, 3) === 'NED' && x + 3 === wordlength - 1) {
              break;
            }
            if (word.substr(x - 2, 3) === 'ING' && x === wordlength - 1) {
              break;
            }

            if (x + 1 <= wordlength - 1 && word.substr(x - 2, 4) === 'OUGH') {
              metaword += 'F';
              break;
            }
            if (nc === 'H' && x + 2 <= wordlength) {
              if (isVowel(nnc)) {
                metaword += 'K';
              }
            } else if (x + 1 === wordlength) {
              if (nc !== 'N') {
                metaword += 'K';
              }
            } else if (x + 3 === wordlength) {
              if (word.substr(x + 1, 3) !== 'NED') {
                metaword += 'K';
              }
            } else if (x + 1 <= wordlength) {
              if ('EIY'.indexOf(nc) !== -1) {
                if (pc !== 'G') {
                  metaword += 'J';
                }
              } else if (x === 0 || pc !== 'D' || 'EIY'.indexOf(nc) === -1) {
                metaword += 'K';
              }
            } else {
              metaword += 'K';
            }
          } else {
            metaword += 'K';
          }
          break;
        case 'M': case 'J': case 'N': case 'R': case 'L':
          metaword += cc;
          break;
        case 'Q':
          metaword += 'K';
          break;
        case 'V':
          metaword += 'F';
          break;
        case 'Z':
          metaword += 'S';
          break;
        case 'X':
          metaword += (x === 0) ? 'S' : 'KS';
          break;
        case 'K':
          if (x === 0 || pc !== 'C') {
            metaword += 'K';
          }
          break;
        case 'P':
          if (x + 1 <= wordlength && nc === 'H') {
            metaword += 'F';
          } else {
            metaword += 'P';
          }
          break;
        case 'Y':
          if (x + 1 > wordlength || isVowel(nc)) {
            metaword += 'Y';
          }
          break;
        case 'H':
          if (x === 0 || 'CSPTG'.indexOf(pc) === -1) {
            if (isVowel(nc) === true) {
              metaword += 'H';
            }
          }
          break;
        case 'S':
          if (x + 1 <= wordlength) {
            if (nc === 'H') {
              metaword += 'X';
            } else if (x + 2 <= wordlength && nc === 'I' && 'AO'.indexOf(nnc) !== -1) {
              metaword += 'X';
            } else {
              metaword += 'S';
            }
          } else {
            metaword += 'S';
          }
          break;
        case 'T':
          if (x + 1 <= wordlength) {
            if (nc === 'H') {
              metaword += '0';
            } else if (x + 2 <= wordlength && nc === 'I' && 'AO'.indexOf(nnc) !== -1) {
              metaword += 'X';
            } else {
              metaword += 'T';
            }
          } else {
            metaword += 'T';
          }
          break;
        case 'W':
          if (x + 1 <= wordlength && isVowel(nc)) {
            metaword += 'W';
          }
          break;
        }
      }
    }

    phones = parseInt(phones, 10);
    if (metaword.length > phones) {
      return metaword.substr(0, phones);
    }
    return metaword;
  };

  var load_states = function() {
    for (var i=0; i < load_states.DATA.length; i++) {
      var s = load_states.DATA[i];
      var state = new us.State(s);
      if (state.is_territory) {
        us.TERRITORIES.push(state);
      } else {
        us.STATES.push(state);
      }
      us.STATES_AND_TERRITORIES.push(state);
      us.states[state.abbr] = state;
    }
  };

  load_states.DATA = [
    {"name": "Alabama", "metaphones": [ "ALBM" ], "statehood_year": 1819, "ap_abbr": "Ala.", "is_territory": false, "fips": "01", "abbr": "AL", "capital": "Montgomery", "capital_tz": "America/Chicago", "time_zones": ["America/Chicago"]},
    {"name": "Alaska", "metaphones": [ "ALSK" ], "statehood_year": 1959, "ap_abbr": "Alaska", "is_territory": false, "fips": "02", "abbr": "AK", "capital": "Juneau", "capital_tz": "America/Anchorage", "time_zones": ["America/Anchorage", "America/Adak"]},
    {"name": "American Samoa", "metaphones": [ "AMRXNSM" ], "statehood_year": null, "ap_abbr": null, "is_territory": true, "fips": "60", "abbr": "AS", "capital": "Pago Pago", "capital_tz": "Pacific/Samoa", "time_zones": ["Pacific/Samoa"]},
    {"name": "Arizona", "metaphones": [ "ARSN" ], "statehood_year": 1912, "ap_abbr": "Ariz.", "is_territory": false, "fips": "04", "abbr": "AZ", "capital": "Phoenix", "capital_tz": "America/Denver", "time_zones": ["America/Denver"]},
    {"name": "Arkansas", "metaphones": [ "ARKNSS" ], "statehood_year": 1836, "ap_abbr": "Ark.", "is_territory": false, "fips": "05", "abbr": "AR", "capital": "Little Rock", "capital_tz": "America/Chicago", "time_zones": ["America/Chicago"]},
    {"name": "California", "metaphones": [ "XLFRN" ], "statehood_year": 1850, "ap_abbr": "Calif.", "is_territory": false, "fips": "06", "abbr": "CA", "capital": "Sacramento", "capital_tz": "America/Los_Angeles", "time_zones": ["America/Los_Angeles"]},
    {"name": "Colorado", "metaphones": [ "XLRT" ], "statehood_year": 1876, "ap_abbr": "Colo.", "is_territory": false, "fips": "08", "abbr": "CO", "capital": "Denver", "capital_tz": "America/Denver", "time_zones": ["America/Denver"]},
    {"name": "Connecticut", "metaphones": [ "XNTXT", "XNXTXT" ], "statehood_year": 1788, "ap_abbr": "Conn.", "is_territory": false, "fips": "09", "abbr": "CT", "capital": "Hartford", "capital_tz": "America/New_York", "time_zones": ["America/New_York"]},
    {"name": "Delaware", "metaphones": [ "TLWR" ], "statehood_year": 1787, "ap_abbr": "Del.", "is_territory": false, "fips": "10", "abbr": "DE", "capital": "Dover", "capital_tz": "America/New_York", "time_zones": ["America/New_York"]},
    {"name": "District of Columbia", "metaphones": [ "TSTRXTFXLM" ], "statehood_year": null, "ap_abbr": "D.C.", "is_territory": false, "fips": "11", "abbr": "DC", "capital": null, "capital_tz": "America/New_York", "time_zones": ["America/New_York"]},
    {"name": "Florida", "metaphones": [ "FLRT", "FLRTS" ], "statehood_year": 1845, "ap_abbr": "Fla.", "is_territory": false, "fips": "12", "abbr": "FL", "capital": "Tallahassee", "capital_tz": "America/New_York", "time_zones": ["America/New_York", "America/Chicago"]},
    {"name": "Georgia", "metaphones": [ "JRJ", "JRK" ], "statehood_year": 1788, "ap_abbr": "Ga.", "is_territory": false, "fips": "13", "abbr": "GA", "capital": "Atlanta", "capital_tz": "America/New_York", "time_zones": ["America/New_York"]},
    {"name": "Guam", "metaphones": [ "KM" ], "statehood_year": null, "ap_abbr": null, "is_territory": true, "fips": "66", "abbr": "GU", "capital": "Hag\\u00e5t\\u00f1a", "capital_tz": "Pacific/Guam", "time_zones": ["Pacific/Guam"]},
    {"name": "Hawaii", "metaphones": [ "HW" ], "statehood_year": 1959, "ap_abbr": "Hawaii", "is_territory": false, "fips": "15", "abbr": "HI", "capital": "Honolulu", "capital_tz": "Pacific/Honolulu", "time_zones": ["Pacific/Honolulu"]},
    {"name": "Idaho", "metaphones": [ "ITH" ], "statehood_year": 1890, "ap_abbr": "Idaho", "is_territory": false, "fips": "16", "abbr": "ID", "capital": "Boise", "capital_tz": "America/Denver", "time_zones": ["America/Denver", "America/Los_Angeles"]},
    {"name": "Illinois", "metaphones": [ "ILNS" ], "statehood_year": 1818, "ap_abbr": "Ill.", "is_territory": false, "fips": "17", "abbr": "IL", "capital": "Springfield", "capital_tz": "America/Chicago", "time_zones": ["America/Chicago"]},
    {"name": "Indiana", "metaphones": [ "INTN" ], "statehood_year": 1816, "ap_abbr": "Ind.", "is_territory": false, "fips": "18", "abbr": "IN", "capital": "Indianapolis", "capital_tz": "America/Indiana/Indianapolis", "time_zones": ["America/Indiana/Indianapolis", "America/Indianapolis", "America/Indiana/Winamac", "America/Indiana/Vincennes", "America/Indiana/Vevay", "America/Indiana/Tell_City", "America/Indiana/Petersburg", "America/Indiana/Marengo", "America/Indiana/Knox", "America/Knox_IN"]},
    {"name": "Iowa", "metaphones": [ "IW", "IH" ], "statehood_year": 1846, "ap_abbr": "Iowa", "is_territory": false, "fips": "19", "abbr": "IA", "capital": "Des Moines", "capital_tz": "America/Chicago", "time_zones": ["America/Chicago"]},
    {"name": "Kansas", "metaphones": [ "KNSS" ], "statehood_year": 1861, "ap_abbr": "Kan.", "is_territory": false, "fips": "20", "abbr": "KS", "capital": "Topeka", "capital_tz": "America/Chicago", "time_zones": ["America/Chicago", "America/Denver"]},
    {"name": "Kentucky", "metaphones": [ "KNTXY", "KNTKY" ], "statehood_year": 1792, "ap_abbr": "Ky.", "is_territory": false, "fips": "21", "abbr": "KY", "capital": "Frankfort", "capital_tz": "America/New_York", "time_zones": ["America/New_York", "America/Kentucky/Louisville", "America/Kentucky/Monticello", "America/Louisville"]},
    {"name": "Louisiana", "metaphones": [ "LXN", "LSN" ], "statehood_year": 1812, "ap_abbr": "La.", "is_territory": false, "fips": "22", "abbr": "LA", "capital": "Baton Rouge", "capital_tz": "America/Chicago", "time_zones": ["America/Chicago"]},
    {"name": "Maine", "metaphones": [ "MN" ], "statehood_year": 1820, "ap_abbr": "Maine", "is_territory": false, "fips": "23", "abbr": "ME", "capital": "Augusta", "capital_tz": "America/New_York", "time_zones": ["America/New_York"]},
    {"name": "Maryland", "metaphones": [ "MRLNT" ], "statehood_year": 1788, "ap_abbr": "Md.", "is_territory": false, "fips": "24", "abbr": "MD", "capital": "Annapolis", "capital_tz": "America/New_York", "time_zones": ["America/New_York"]},
    {"name": "Massachusetts", "metaphones": [ "MSXSTS" ], "statehood_year": 1788, "ap_abbr": "Mass.", "is_territory": false, "fips": "25", "abbr": "MA", "capital": "Boston", "capital_tz": "America/New_York", "time_zones": ["America/New_York"]},
    {"name": "Michigan", "metaphones": [ "MXKN" ], "statehood_year": 1837, "ap_abbr": "Mich.", "is_territory": false, "fips": "26", "abbr": "MI", "capital": "Lansing", "capital_tz": "America/New_York", "time_zones": ["America/New_York", "America/Chicago"]},
    {"name": "Minnesota", "metaphones": [ "MNST" ], "statehood_year": 1858, "ap_abbr": "Minn.", "is_territory": false, "fips": "27", "abbr": "MN", "capital": "Saint Paul", "capital_tz": "America/Chicago", "time_zones": ["America/Chicago"]},
    {"name": "Mississippi", "metaphones": [ "MSSP" ], "statehood_year": 1817, "ap_abbr": "Miss.", "is_territory": false, "fips": "28", "abbr": "MS", "capital": "Jackson", "capital_tz": "America/Chicago", "time_zones": ["America/Chicago"]},
    {"name": "Missouri", "metaphones": [ "MSR", "MSRY" ], "statehood_year": 1821, "ap_abbr": "Mo.", "is_territory": false, "fips": "29", "abbr": "MO", "capital": "Jefferson City", "capital_tz": "America/Chicago", "time_zones": ["America/Chicago"]},
    {"name": "Montana", "metaphones": [ "MNTN" ], "statehood_year": 1889, "ap_abbr": "Mont.", "is_territory": false, "fips": "30", "abbr": "MT", "capital": "Helena", "capital_tz": "America/Denver", "time_zones": ["America/Denver"]},
    {"name": "Nebraska", "metaphones": [ "NBRSK", "NBRSX" ], "statehood_year": 1867, "ap_abbr": "Neb.", "is_territory": false, "fips": "31", "abbr": "NE", "capital": "Lincoln", "capital_tz": "America/Chicago", "time_zones": ["America/Chicago", "America/Denver"]},
    {"name": "Nevada", "metaphones": [ "NFT" ], "statehood_year": 1864, "ap_abbr": "Nev.", "is_territory": false, "fips": "32", "abbr": "NV", "capital": "Carson City", "capital_tz": "America/Los_Angeles", "time_zones": ["America/Los_Angeles", "America/Denver"]},
    {"name": "New Hampshire", "metaphones": [ "NHMPXR" ], "statehood_year": 1788, "ap_abbr": "N.H.", "is_territory": false, "fips": "33", "abbr": "NH", "capital": "Concord", "capital_tz": "America/New_York", "time_zones": ["America/New_York"]},
    {"name": "New Jersey", "metaphones": [ "NJRSY" ], "statehood_year": 1787, "ap_abbr": "N.J.", "is_territory": false, "fips": "34", "abbr": "NJ", "capital": "Trenton", "capital_tz": "America/New_York", "time_zones": ["America/New_York"]},
    {"name": "New Mexico", "metaphones": [ "NMKSX" ], "statehood_year": 1912, "ap_abbr": "N.M.", "is_territory": false, "fips": "35", "abbr": "NM", "capital": "Santa Fe", "capital_tz": "America/Chicago", "time_zones": ["America/Chicago"]},
    {"name": "New York", "metaphones": [ "NYRK" ], "statehood_year": 1788, "ap_abbr": "N.Y.", "is_territory": false, "fips": "36", "abbr": "NY", "capital": "Albany", "capital_tz": "America/New_York", "time_zones": ["America/New_York"]},
    {"name": "North Carolina", "metaphones": [ "NR0XRLN" ], "statehood_year": 1789, "ap_abbr": "N.C.", "is_territory": false, "fips": "37", "abbr": "NC", "capital": "Raleigh", "capital_tz": "America/New_York", "time_zones": ["America/New_York"]},
    {"name": "North Dakota", "metaphones": [ "NR0TKT", "NTK" ], "statehood_year": 1889, "ap_abbr": "N.D.", "is_territory": false, "fips": "38", "abbr": "ND", "capital": "Bismarck", "capital_tz": "America/North_Dakota/Center", "time_zones": ["America/North_Dakota/Center", "America/North_Dakota/Beulah", "America/North_Dakota/Center", "America/North_Dakota/New_Salem"]},
    {"name": "Northern Mariana Islands", "metaphones": [ "NR0RNMRNSLNTS" ], "statehood_year": null, "ap_abbr": null, "is_territory": true, "fips": "69", "abbr": "MP", "capital": "Saipan", "capital_tz": "Pacific/Guam", "time_zones": ["Pacific/Guam"]},
    {"name": "Ohio", "metaphones": [ "OH" ], "statehood_year": 1803, "ap_abbr": "Ohio", "is_territory": false, "fips": "39", "abbr": "OH", "capital": "Columbus", "capital_tz": "America/New_York", "time_zones": ["America/New_York"]},
    {"name": "Oklahoma", "metaphones": [ "OKLHM" ], "statehood_year": 1907, "ap_abbr": "Okla.", "is_territory": false, "fips": "40", "abbr": "OK", "capital": "Oklahoma City", "capital_tz": "America/Chicago", "time_zones": ["America/Chicago"]},
    {"name": "Oregon", "metaphones": [ "ORKN" ], "statehood_year": 1859, "ap_abbr": "Ore.", "is_territory": false, "fips": "41", "abbr": "OR", "capital": "Salem", "capital_tz": "America/Los_Angeles", "time_zones": ["America/Los_Angeles", "America/Boise"]},
    {"name": "Pennsylvania", "metaphones": [ "PNSLFN" ], "statehood_year": 1787, "ap_abbr": "Pa.", "is_territory": false, "fips": "42", "abbr": "PA", "capital": "Harrisburg", "capital_tz": "America/New_York", "time_zones": ["America/New_York"]},
    {"name": "Puerto Rico", "metaphones": [ "PRTRX" ], "statehood_year": null, "ap_abbr": null, "is_territory": true, "fips": "72", "abbr": "PR", "capital": "San Juan", "capital_tz": "America/Puerto_Rico", "time_zones": ["America/Puerto_Rico"]},
    {"name": "Rhode Island", "metaphones": [ "RHTSLNT", "RTSLNT" ], "statehood_year": 1790, "ap_abbr": "R.I.", "is_territory": false, "fips": "44", "abbr": "RI", "capital": "Providence", "capital_tz": "America/New_York", "time_zones": ["America/New_York"]},
    {"name": "South Carolina", "metaphones": [ "S0XRLN", "STXRLN", "SXRL" ], "statehood_year": 1788, "ap_abbr": "S.C.", "is_territory": false, "fips": "45", "abbr": "SC", "capital": "Columbia", "capital_tz": "America/New_York", "time_zones": ["America/New_York"]},
    {"name": "South Dakota", "metaphones": [ "S0TKT" ], "statehood_year": 1889, "ap_abbr": "S.D.", "is_territory": false, "fips": "46", "abbr": "SD", "capital": "Pierre", "capital_tz": "America/Chicago", "time_zones": ["America/Chicago", "America/Denver"]},
    {"name": "Tennessee", "metaphones": [ "TNS" ], "statehood_year": 1796, "ap_abbr": "Tenn.", "is_territory": false, "fips": "47", "abbr": "TN", "capital": "Nashville", "capital_tz": "America/Chicago", "time_zones": ["America/Chicago", "America/New_York"]},
    {"name": "Texas", "metaphones": [ "TKSS" ], "statehood_year": 1845, "ap_abbr": "Texas", "is_territory": false, "fips": "48", "abbr": "TX", "capital": "Austin", "capital_tz": "America/Chicago", "time_zones": ["America/Chicago", "America/Denver"]},
    {"name": "Utah", "metaphones": [ "UTH", "UTS", "UTR" ], "statehood_year": 1896, "ap_abbr": "Utah", "is_territory": false, "fips": "49", "abbr": "UT", "capital": "Salt Lake City", "capital_tz": "America/Denver", "time_zones": ["America/Denver"]},
    {"name": "Vermont", "metaphones": [ "FRMNT" ], "statehood_year": 1791, "ap_abbr": "Vt.", "is_territory": false, "fips": "50", "abbr": "VT", "capital": "Montpelier", "capital_tz": "America/New_York", "time_zones": ["America/New_York"]},
    {"name": "Virgin Islands", "metaphones": [ "FRJNSLNTS" ], "statehood_year": null, "ap_abbr": null, "is_territory": true, "fips": "78", "abbr": "VI", "capital": "Charlotte Amalie", "capital_tz": "America/Puerto_Rico", "time_zones": ["America/Puerto_Rico"]},
    {"name": "Virginia", "metaphones": [ "FRJN" ], "statehood_year": 1788, "ap_abbr": "Va.", "is_territory": false, "fips": "51", "abbr": "VA", "capital": "Richmond", "capital_tz": "America/New_York", "time_zones": ["America/New_York"]},
    {"name": "Washington", "metaphones": [ "WXNKTN" ], "statehood_year": 1889, "ap_abbr": "Wash.", "is_territory": false, "fips": "53", "abbr": "WA", "capital": "Olympia", "capital_tz": "America/Los_Angeles", "time_zones": ["America/Los_Angeles"]},
    {"name": "West Virginia", "metaphones": [ "WSTFRJN", "WSTFRKN" ], "statehood_year": 1863, "ap_abbr": "W.Va.", "is_territory": false, "fips": "54", "abbr": "WV", "capital": "Charleston", "capital_tz": "America/New_York", "time_zones": ["America/New_York"]},
    {"name": "Wisconsin", "metaphones": [ "WSXNSN" ], "statehood_year": 1848, "ap_abbr": "Wis.", "is_territory": false, "fips": "55", "abbr": "WI", "capital": "Madison", "capital_tz": "America/Chicago", "time_zones": ["America/Chicago"]},
    {"name": "Wyoming", "metaphones": [ "YMN", "YMNJ", "WMN" ], "statehood_year": 1890, "ap_abbr": "Wyo.", "is_territory": false, "fips": "56", "abbr": "WY", "capital": "Cheyenne", "capital_tz": "America/Denver", "time_zones": ["America/Denver"]}
  ];
  load_states();

  return us;
}));


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

var phoneUtil = __webpack_require__(50).PhoneNumberUtil.getInstance();

/* harmony default export */ __webpack_exports__["a"] = ({
  getProviderData: function getProviderData(VueApp, provId, callback) {
    var self = this;
    VueApp.$sdk.get('/provider/' + provId, {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      if (!res.error) {
        var vehicle = res.vehicle;
        var documents = res.documents;
        var eligibility = res.eligibility;

        var language = 'English';
        if (res.language !== null) {
          language = res.language.charAt(0).toUpperCase() + res.language.slice(1);
        }

        var vehicleInspectionExp = '';
        var driverRecordExp = '';
        if (documents.safetyInspection.expire !== null && documents.safetyInspection.expire !== '') {
          // vehicleInspectionExp = moment(documents.safetyInspection.expire, 'YYYY-MM-DD').format('MM/DD/YYYY')
          vehicleInspectionExp = self.fixDate(documents.safetyInspection.expire);
        }
        if (documents.drivingRecord.expire !== null && documents.drivingRecord.expire !== '') {
          // driverRecordExp = moment(documents.drivingRecord.expire, 'YYYY-MM-DD').format('MM/DD/YYYY')
          driverRecordExp = self.fixDate(documents.drivingRecord.expire);
        }

        VueApp.$store.commit('provider/setQuickResData', { enable: res.enabledQuickRes });
        VueApp.$store.commit('provider/setDriverId', res.driverNum || '');
        var ptrsDriverAgreeUTC = '';
        if (res.ptrsDriverAgreeUTC) ptrsDriverAgreeUTC = __WEBPACK_IMPORTED_MODULE_0_moment___default()(res.ptrsDriverAgreeUTC, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA');
        VueApp.$store.commit('provider/setUserInfo', {
          id: res.ID,
          active: res.login.enabled && res.login.verified,
          services: res.services,
          backgroundSubmitted: !!res.bgCheckSubmitted,
          backgroundPassed: !!res.bgCheckPassed,
          maxDailyRsvpIsCustom: res.maxDailyRSVP > 0 ? '1' : '0',
          maxDailyRsvp: res.maxDailyRSVP,
          created: __WEBPACK_IMPORTED_MODULE_0_moment___default()(res.created, 'YYYY-MM-DD').format('MM/DD/YYYY'),
          ptrsDriverAgreeUTC: ptrsDriverAgreeUTC,
          isTestAcct: res.isTestAcct ? true : false,
          basicInfo: {
            firstName: res.firstName,
            lastName: res.lastName,
            deviceOS: res.phoneOS,
            deviceModel: res.phoneModel,
            language: language,
            email: res.email,
            mobile: res.countryCode + '' + res.phone,
            countryCode: res.countryCode,
            phoneNumber: res.phone,
            // birthday: moment(res.dateOfBirth, 'YYYY-MM-DD').format('MM/DD/YYYY'),
            birthday: self.fixDate(res.dateOfBirth),
            img: res.avatarUrl || '',
            homeSectorId: res.homeSectorId
          },
          vehicleInfo: {
            manufacturer: vehicle.manufacturer,
            model: vehicle.model,
            year: vehicle.manufactureYear,
            type: vehicle.type,
            licensePlate: vehicle.licensePlate,
            capacity: vehicle.seatCapacity,
            door: vehicle.numberOfDoor,
            boxCapacity: vehicle.boxCapacity || '',
            identificationNumber: vehicle.idNumber,
            wheelchair: vehicle.wheelChairLift,
            serviceDog: vehicle.serviceDock,
            img: vehicle.photo || ''
          },
          accountType: {
            // tcpPermit: 0, // ..
            type: res.providerAccountType
          },
          businessInfo: {
            name: res.businessName,
            type: res.businessType,
            ssn: res.businessSSN ? '****' + res.businessSSN.substr(res.businessSSN.length - 4) : '',
            ssnImg: res.businessSSNUrl || '',
            ein: res.businessEIN ? '****' + res.businessEIN.substr(res.businessEIN.length - 4) : '',
            einImg: res.businessEINUrl || '',
            address1: res.address,
            address2: res.address2,
            city: res.city,
            country: res.country || 'United States',
            state: res.state,
            zip: res.zip,
            w9fileImg: res.w9fileUrl || ''
          },
          documentation: {
            insuranceCompany: documents.insurance.company,
            insurancePolicy: documents.insurance.policyNumber,
            // insuranceExp: moment(documents.insurance.policyExpire, 'YYYY-MM-DD').format('MM/DD/YYYY'),
            insuranceExp: self.fixDate(documents.insurance.policyExpire),
            insuranceImg: documents.insurance.policyFilename || '',
            cityLicense: documents.cityLicense.number,
            // cityLicenseExp: moment(documents.cityLicense.expire, 'YYYY-MM-DD').format('MM/DD/YYYY'),
            cityLicenseExp: self.fixDate(documents.cityLicense.expire),
            cityLicenseImg: documents.cityLicense.filename || '',
            tcpPermit: documents.tcpPermit.number,
            // tcpPermitExp: moment(documents.tcpPermit.expire, 'YYYY-MM-DD').format('MM/DD/YYYY'),
            tcpPermitExp: self.fixDate(documents.tcpPermit.expire),
            tcpPermitImg: documents.tcpPermit.filename || '',
            airportPermit: documents.airportPermit.number,
            // airportPermitExp: moment(documents.airportPermit.expire, 'YYYY-MM-DD').format('MM/DD/YYYY'),
            airportPermitExp: self.fixDate(documents.airportPermit.expire),
            airportPermitImg: documents.airportPermit.filename || '',
            driversLicense: documents.driverLicense.number,
            // driversLicenseExp: moment(documents.driverLicense.expire, 'YYYY-MM-DD').format('MM/DD/YYYY'),
            driversLicenseExp: self.fixDate(documents.driverLicense.expire),
            driversLicenseImg: documents.driverLicense.filename || '',
            vehicleInspection: documents.safetyInspection.by,
            vehicleInspectionExp: vehicleInspectionExp,
            vehicleInspectionImg: documents.safetyInspection.filename || '',
            drivingRecordExp: driverRecordExp,
            drivingRecordImg: documents.drivingRecord.filename || '',
            vehicleRegistrationExp: self.fixDate(documents.vehicleRegistration.expire),
            vehicleRegistrationImg: documents.vehicleRegistration.filename || ''
          },
          eligibility: {
            convicted: eligibility.CrimeProblems,
            conviction: eligibility.DrivingProblems,
            ownVehicle: eligibility.OwnVehicle,
            modifiedVehicle: eligibility.ModifiedVehicle,
            driversLicense: eligibility.Tcp
          },
          signature: res.signature,
          homeAdress: res.homeAddress
        });
      }
      callback(res);
    });
  },
  fixDate: function fixDate(x) {
    if (x === '' || x === '0000-00-00 00:00:00' || x === '1970-01-01T00:00:00.000Z') {
      return '';
    }
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(x, 'YYYY-MM-DD').format('MM/DD/YYYY');
  },
  updateProvider: function updateProvider(VueApp, data, callback) {
    var self = this;
    // let mobile = phoneUtil.parse('+' + data.mobile, '')
    data.token = VueApp.$store.state.session.sessionToken;
    var countryCode = VueApp.$store.state.countryCode.callingCode;

    VueApp.$sdk.post('/provider/' + data.id + '/services', {
      token: VueApp.$store.state.session.sessionToken,
      serviceNames: data.services
    }, function (res) {
      // do something in case of error
    });

    VueApp.$sdk.post('/provider/' + data.id, data, function (res) {
      if (!res.error) {
        var phoneData = {
          id: data.id,
          // mobile: mobile.getNationalNumber(),
          // countryCode: mobile.getCountryCode(),
          mobile: data.phoneNumber,
          countryCode: countryCode,
          deviceOS: data.OS,
          deviceModel: data.model
        };
        self.updatePhone(VueApp, phoneData, function (res2) {
          callback(res2);
        });
      } else {
        callback(res);
      }
    });
  },
  updatePhone: function updatePhone(VueApp, data, callback) {
    VueApp.$sdk.post('/provider/' + data.id + '/phones', {
      token: VueApp.$store.state.session.sessionToken,
      phoneNumber: data.mobile,
      countryCode: data.countryCode,
      'OS': data.deviceOS,
      model: data.deviceModel,
      type: 'C',
      nationalNumber: data.mobile
    }, function (res) {
      callback(res);
    });
  },
  emailPassword: function emailPassword(VueApp, provId, callback) {
    VueApp.$sdk.delete('/provider/' + provId + '/password', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      callback(res);
    });
  },
  updateProviderStatus: function updateProviderStatus(VueApp, data, callback) {
    var action = data.isActive ? 'post' : 'delete';
    VueApp.$sdk[action]('/provider/' + data.id + '/active', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      callback(res);
    });
  },
  updatePassword: function updatePassword(VueApp, data, callback) {
    VueApp.$sdk.post('/provider/' + data.id + '/password', {
      token: VueApp.$store.state.session.sessionToken,
      password: data.password
    }, function (res) {
      callback(res);
    });
  },
  updateProviderServices: function updateProviderServices(VueApp, data, callback) {
    VueApp.$sdk.post('/provider/' + data.id + '/services', {
      token: VueApp.$store.state.session.sessionToken,
      services: data.services
    }, function (res) {
      callback(res);
    }, '2.0');
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__featureToggle__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  getList: function getList(VueApp, data, callback) {
    var promo = VueApp.$store.state.promo;
    VueApp.$sdk.get('/promo', {
      token: VueApp.$store.state.session.sessionToken,
      search: promo.search,
      pageNum: promo.currentPage,
      pageSize: promo.perPage,
      order: promo.order,
      orderAsc: promo.orderAsc
    }, function (res) {
      if (!res.error) {
        var list = [];
        res.list.forEach(function (data) {
          var totalCodes = data.totalCodes || 0;
          var codesUsed = data.redeemedCount || 0;
          list.push({
            id: data.id,
            name: data.name,
            promoCode: data.code,
            creditAmount: data.amount,
            createdDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.created, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
            starDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.startDate, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
            expDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.expirationDate, 'YYYY-MM-DD@HH:mm:ss').add(data.validDays, 'days').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
            totalCodes: totalCodes,
            validDays: data.validDays,
            codesUsed: codesUsed,
            codesLeft: totalCodes - codesUsed,
            enabled: data.enabled
          });
        });

        VueApp.$store.commit('promo/setList', list);
        VueApp.$store.commit('promo/setMaxList', res.paging.totalItems);
      }
      callback(res);
    });
  },
  deactivate: function deactivate(VueApp, id, callback) {
    VueApp.$sdk.delete('/promo/' + id + '/enabled', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      callback(res);
    });
  },
  activate: function activate(VueApp, id, callback) {
    VueApp.$sdk.post('/promo/' + id + '/enabled', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      callback(res);
    });
  },
  getPromoDetails: function getPromoDetails(VueApp, id, callback) {
    VueApp.$sdk.get('/promo/' + id, {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      if (!res.error) {
        VueApp.$store.commit('promo/setViewDetails', {
          adminId: res.adminId,
          id: res.id,
          name: res.name,
          description: res.description,
          startDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(res.startDate, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
          expirationDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(res.expirationDate, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
          validNewUser: res.validOnlyForNewUser ? 'Yes' : 'No',
          validServices: 'All',
          validDays: res.validDays,
          code: res.code,
          amount: res.amount,
          totalCodes: res.totalCodes,
          redeemedCodes: res.redeemedCount || 0
        });
      }
      callback(res);
    });
  },
  getViewList: function getViewList(VueApp, id, callback) {
    var promo = VueApp.$store.state.promo.view;
    VueApp.$sdk.get('/promo/' + id + '/usage', {
      token: VueApp.$store.state.session.sessionToken,
      pageNum: promo.currentPage,
      pageSize: promo.perPage,
      order: promo.order,
      orderAsc: promo.orderAsc
    }, function (res) {
      if (!res.error) {
        var list = [];
        var ctr = 1;
        res.list.forEach(function (data) {
          var redeemDate = '';
          var expirationDate = '';
          if (data.redeemedDate) {
            redeemDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.redeemedDate, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false));
            expirationDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.redeemedDate, 'YYYY-MM-DD@HH:mm:ss').add(promo.details.validDays, 'days').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false));
          }
          list.push({
            id: data.id,
            placed: (promo.currentPage - 1) * promo.perPage + ctr,
            promoCode: data.promoCode || promo.details.code,
            status: data.redeemedDate ? 'Redeemed' : 'Not Redeemed',
            conID: data.contactId,
            redeemedDate: redeemDate,
            expirationDate: expirationDate
          });
          ctr++;
        });

        VueApp.$store.commit('promo/setViewList', list);
        VueApp.$store.commit('promo/setViewMaxList', res.paging.totalItems);
      }
      callback(res);
    });
  },
  getViewListFull: function getViewListFull(VueApp, id, callback) {
    var promo = VueApp.$store.state.promo;
    VueApp.$sdk.get('/promo/' + id + '/usage', {
      token: VueApp.$store.state.session.sessionToken,
      pageNum: 1,
      pageSize: 9999,
      order: 'id',
      orderAsc: 0
    }, function (res) {
      if (!res.error) {
        var list = [];
        var ctr = 1;

        var viewDetails = promo.view.details;
        var promoCode = viewDetails.code;
        var validDays = viewDetails.validDays;
        var index = promo.list.findIndex(function (x) {
          return x.id === id;
        });
        if (id !== viewDetails.id && index > -1) {
          validDays = VueApp.$store.state.promo.list[index].validDays;
          promoCode = VueApp.$store.state.promo.list[index].promoCode;
        }
        res.list.forEach(function (data) {
          var redeemDate = '';
          var expirationDate = '';
          if (data.redeemedDate) {
            redeemDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.redeemedDate, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false));
            expirationDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.redeemedDate, 'YYYY-MM-DD@HH:mm:ss').add(validDays, 'days').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false));
          }
          list.push({
            '#': ctr,
            'Promo Code': data.promoCode || promoCode,
            'Status': data.redeemedDate ? 'Redeemed' : 'Not Redeemed',
            'Consumer ID': data.contactId,
            'Redeemed Date': redeemDate,
            'Expiration Date': expirationDate
          });
          ctr++;
        });
        callback(list);
        return;
      }
      callback(res);
    });
  },
  savePromoDetails: function savePromoDetails(VueApp, data, callback) {
    data.token = VueApp.$store.state.session.sessionToken;
    VueApp.$sdk.post('/promo/' + data.id, data, function (res) {
      callback(res);
    });
  },
  addPromoDetails: function addPromoDetails(VueApp, data, callback) {
    data.token = VueApp.$store.state.session.sessionToken;
    VueApp.$sdk.post('/promo/', data, function (res) {
      callback(res);
    });
  }
});

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,n){ true?module.exports=n(__webpack_require__(1557)):"function"==typeof define&&define.amd?define("VueAutonumeric",["AutoNumeric"],n):"object"==typeof exports?exports.VueAutonumeric=n(require("AutoNumeric")):t.VueAutonumeric=n(t.AutoNumeric)}("undefined"!=typeof self?self:this,function(t){return function(t){function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}var e={};return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:r})},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=10)}([function(t,n){var e=t.exports={version:"2.5.4"};"number"==typeof __e&&(__e=e)},function(t,n){var e=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=e)},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,e){t.exports=!e(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,n){var e={}.hasOwnProperty;t.exports=function(t,n){return e.call(t,n)}},function(t,n,e){var r=e(7),o=e(8);t.exports=function(t){return r(o(t))}},function(t,n,e){var r=e(32);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==r(t)?t.split(""):Object(t)}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n){var e=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:e)(t)}},function(t,n,e){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.VueAutonumeric=void 0;var r=e(11),o=function(t){return t&&t.__esModule?t:{default:t}}(r);"undefined"!=typeof window&&window.Vue&&Vue.component("vue-autonumeric",o.default),n.VueAutonumeric=o.default,n.default=o.default},function(t,n,e){var r=e(12)(e(13),null,null,null);t.exports=r.exports},function(t,n){t.exports=function(t,n,e,r){var o,i=t=t||{},u=typeof t.default;"object"!==u&&"function"!==u||(o=t,i=t.default);var f="function"==typeof i?i.options:i;if(n&&(f.render=n.render,f.staticRenderFns=n.staticRenderFns),e&&(f._scopeId=e),r){var c=Object.create(f.computed||null);Object.keys(r).forEach(function(t){var n=r[t];c[t]=function(){return n}}),f.computed=c}return{esModule:o,exports:i,options:f}}},function(t,n,e){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(n,"__esModule",{value:!0});var o=e(14),i=r(o),u=e(16),f=r(u),c=e(43),a=r(c),s={};n.default={name:"VueAutonumeric",render:function(t){var n="input"===this.tag,e=void 0;return e=n?{type:"text",placeholder:this.placeholder}:{contenteditable:this.hasContentEditable},t(this.tag,{attrs:e,ref:"autoNumericElement",on:{"autoNumeric:rawValueModified":this.updateVModel}})},props:{value:{required:!1,validator:function(t){return"number"==typeof t||"string"==typeof t||""===t||null===t}},options:{type:[Object,String,Array],required:!1,default:function(){return s}},resetOnOptions:{type:Boolean,required:!1,default:!0},placeholder:{type:String,required:!1},tag:{type:String,required:!1,default:"input"}},data:function(){return{anElement:null,initialOptions:null,hasContentEditable:!0}},created:function(){var t=this;if(Array.isArray(this.options)){var n={};this.options.forEach(function(e){t.initialOptions=t.manageOptionElement(e),n=(0,f.default)(n,t.initialOptions)}),this.initialOptions=n}else this.initialOptions=this.manageOptionElement(this.options);this.hasContentEditable=!this.initialOptions.readOnly},mounted:function(){this.anElement=new a.default(this.$refs.autoNumericElement,this.initialOptions),null!==this.value&&""!==this.value&&(this.anElement.set(this.value),this.updateVModel())},computed:{anInfo:function(){return{value:this.value,options:this.options}}},methods:{updateVModel:function(t){null!==this.anElement&&this.$emit("input",this.anElement.getNumber(),t)},manageOptionElement:function(t){var n=void 0;return"string"==typeof t||t instanceof String?void 0!==(n=a.default.getPredefinedOptions()[t])&&null!==n||(console.warn("The given pre-defined options ["+t+"] is not recognized by AutoNumeric.\nSwitching back to the default options."),n=s):n=t,n}},watch:{anInfo:function(t,n){if(n.options&&(0,i.default)(t.options)!==(0,i.default)(n.options)){this.resetOnOptions&&this.anElement.options.reset();var e=void 0;e=Array.isArray(t.options)?a.default.mergeOptions(t.options):a.default._getOptionObject(t.options),this.anElement.update(e)}void 0!==t.value&&this.anElement.getNumber()!==t.value&&t.value!==n.value&&this.anElement.set(t.value)}}}},function(t,n,e){t.exports={default:e(15),__esModule:!0}},function(t,n,e){var r=e(0),o=r.JSON||(r.JSON={stringify:JSON.stringify});t.exports=function(t){return o.stringify.apply(o,arguments)}},function(t,n,e){t.exports={default:e(17),__esModule:!0}},function(t,n,e){e(18),t.exports=e(0).Object.assign},function(t,n,e){var r=e(19);r(r.S+r.F,"Object",{assign:e(29)})},function(t,n,e){var r=e(1),o=e(0),i=e(20),u=e(22),f=e(5),c=function(t,n,e){var a,s,l,p=t&c.F,d=t&c.G,v=t&c.S,h=t&c.P,y=t&c.B,m=t&c.W,b=d?o:o[n]||(o[n]={}),O=b.prototype,x=d?r:v?r[n]:(r[n]||{}).prototype;d&&(e=n);for(a in e)(s=!p&&x&&void 0!==x[a])&&f(b,a)||(l=s?x[a]:e[a],b[a]=d&&"function"!=typeof x[a]?e[a]:y&&s?i(l,r):m&&x[a]==l?function(t){var n=function(n,e,r){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(n);case 2:return new t(n,e)}return new t(n,e,r)}return t.apply(this,arguments)};return n.prototype=t.prototype,n}(l):h&&"function"==typeof l?i(Function.call,l):l,h&&((b.virtual||(b.virtual={}))[a]=l,t&c.R&&O&&!O[a]&&u(O,a,l)))};c.F=1,c.G=2,c.S=4,c.P=8,c.B=16,c.W=32,c.U=64,c.R=128,t.exports=c},function(t,n,e){var r=e(21);t.exports=function(t,n,e){if(r(t),void 0===n)return t;switch(e){case 1:return function(e){return t.call(n,e)};case 2:return function(e,r){return t.call(n,e,r)};case 3:return function(e,r,o){return t.call(n,e,r,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n,e){var r=e(23),o=e(28);t.exports=e(3)?function(t,n,e){return r.f(t,n,o(1,e))}:function(t,n,e){return t[n]=e,t}},function(t,n,e){var r=e(24),o=e(25),i=e(27),u=Object.defineProperty;n.f=e(3)?Object.defineProperty:function(t,n,e){if(r(t),n=i(n,!0),r(e),o)try{return u(t,n,e)}catch(t){}if("get"in e||"set"in e)throw TypeError("Accessors not supported!");return"value"in e&&(t[n]=e.value),t}},function(t,n,e){var r=e(2);t.exports=function(t){if(!r(t))throw TypeError(t+" is not an object!");return t}},function(t,n,e){t.exports=!e(3)&&!e(4)(function(){return 7!=Object.defineProperty(e(26)("div"),"a",{get:function(){return 7}}).a})},function(t,n,e){var r=e(2),o=e(1).document,i=r(o)&&r(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,n,e){var r=e(2);t.exports=function(t,n){if(!r(t))return t;var e,o;if(n&&"function"==typeof(e=t.toString)&&!r(o=e.call(t)))return o;if("function"==typeof(e=t.valueOf)&&!r(o=e.call(t)))return o;if(!n&&"function"==typeof(e=t.toString)&&!r(o=e.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,e){"use strict";var r=e(30),o=e(40),i=e(41),u=e(42),f=e(7),c=Object.assign;t.exports=!c||e(4)(function(){var t={},n={},e=Symbol(),r="abcdefghijklmnopqrst";return t[e]=7,r.split("").forEach(function(t){n[t]=t}),7!=c({},t)[e]||Object.keys(c({},n)).join("")!=r})?function(t,n){for(var e=u(t),c=arguments.length,a=1,s=o.f,l=i.f;c>a;)for(var p,d=f(arguments[a++]),v=s?r(d).concat(s(d)):r(d),h=v.length,y=0;h>y;)l.call(d,p=v[y++])&&(e[p]=d[p]);return e}:c},function(t,n,e){var r=e(31),o=e(39);t.exports=Object.keys||function(t){return r(t,o)}},function(t,n,e){var r=e(5),o=e(6),i=e(33)(!1),u=e(36)("IE_PROTO");t.exports=function(t,n){var e,f=o(t),c=0,a=[];for(e in f)e!=u&&r(f,e)&&a.push(e);for(;n.length>c;)r(f,e=n[c++])&&(~i(a,e)||a.push(e));return a}},function(t,n){var e={}.toString;t.exports=function(t){return e.call(t).slice(8,-1)}},function(t,n,e){var r=e(6),o=e(34),i=e(35);t.exports=function(t){return function(n,e,u){var f,c=r(n),a=o(c.length),s=i(u,a);if(t&&e!=e){for(;a>s;)if((f=c[s++])!=f)return!0}else for(;a>s;s++)if((t||s in c)&&c[s]===e)return t||s||0;return!t&&-1}}},function(t,n,e){var r=e(9),o=Math.min;t.exports=function(t){return t>0?o(r(t),9007199254740991):0}},function(t,n,e){var r=e(9),o=Math.max,i=Math.min;t.exports=function(t,n){return t=r(t),t<0?o(t+n,0):i(t,n)}},function(t,n,e){var r=e(37)("keys"),o=e(38);t.exports=function(t){return r[t]||(r[t]=o(t))}},function(t,n,e){var r=e(1),o=r["__core-js_shared__"]||(r["__core-js_shared__"]={});t.exports=function(t){return o[t]||(o[t]={})}},function(t,n){var e=0,r=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++e+r).toString(36))}},function(t,n){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,n){n.f=Object.getOwnPropertySymbols},function(t,n){n.f={}.propertyIsEnumerable},function(t,n,e){var r=e(8);t.exports=function(t){return Object(r(t))}},function(n,e){n.exports=t}]).default});

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(167);
var enumBugKeys = __webpack_require__(120);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(116);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = values;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys_js__ = __webpack_require__(14);


// Retrieve the values of an object's properties.
function values(obj) {
  var _keys = Object(__WEBPACK_IMPORTED_MODULE_0__keys_js__["a" /* default */])(obj);
  var length = _keys.length;
  var values = Array(length);
  for (var i = 0; i < length; i++) {
    values[i] = obj[_keys[i]];
  }
  return values;
}


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = flatten;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArguments_js__ = __webpack_require__(129);





// Internal implementation of a recursive `flatten` function.
function flatten(input, depth, strict, output) {
  output = output || [];
  if (!depth && depth !== 0) {
    depth = Infinity;
  } else if (depth <= 0) {
    return output.concat(input);
  }
  var idx = output.length;
  for (var i = 0, length = Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(input); i < length; i++) {
    var value = input[i];
    if (Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(value) && (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_3__isArguments_js__["a" /* default */])(value))) {
      // Flatten current level of array or arguments object.
      if (depth > 1) {
        flatten(value, depth - 1, strict, output);
        idx = output.length;
      } else {
        var j = 0, len = value.length;
        while (j < len) output[idx++] = value[j++];
      }
    } else if (!strict) {
      output[idx++] = value;
    }
  }
  return output;
}


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = map;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(14);




// Return the results of applying the iteratee to each element.
function map(obj, iteratee, context) {
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(iteratee, context);
  var _keys = !Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(obj) && Object(__WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */])(obj),
      length = (_keys || obj).length,
      results = Array(length);
  for (var index = 0; index < length; index++) {
    var currentKey = _keys ? _keys[index] : index;
    results[index] = iteratee(obj[currentKey], currentKey, obj);
  }
  return results;
}


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(822);
var global = __webpack_require__(18);
var hide = __webpack_require__(44);
var Iterators = __webpack_require__(66);
var TO_STRING_TAG = __webpack_require__(19)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

// import moment from 'moment'

/* harmony default export */ __webpack_exports__["a"] = ({
  getAdmins: function getAdmins(VueApp, data, callback) {
    var admin = VueApp.$store.state.admin;
    VueApp.$sdk.get('/admin', {
      token: VueApp.$store.state.session.sessionToken,
      search: admin.search,
      status: admin.status,
      order: admin.order,
      orderAsc: admin.orderAsc,
      pageNum: admin.currentPage,
      pageSize: admin.perPage
    }, function (res) {
      if (!res.error) {
        var admins = [];
        res.list.forEach(function (data) {
          var reportPermissions = {};
          for (var i in admin.reportsList) {
            reportPermissions[i] = data.access.permissions[i] || '';
          }

          admins.push({
            id: data.id,
            firstName: data.firstName || '',
            lastName: data.lastName || '',
            username: data.username,
            email: data.email,
            mobile: data.phone,
            isActive: data.isActive,
            permission: data.access.permissions,
            reportPermissions: reportPermissions
          });
        });
        VueApp.$store.commit('admin/setList', admins);
        VueApp.$store.commit('admin/setMaxList', res.paging.totalItems);
      }
      callback(res);
    });
  },
  getAdminList: function getAdminList(VueApp) {
    // Used in notes? (tagging admin)
    VueApp.$sdk.get('/admin', {
      token: VueApp.$store.state.session.sessionToken,
      order: 'firstName',
      pageSize: 999
    }, function (r) {
      if (r.error) {
        // TODO: Handle Error
        VueApp.$store.commit('reservationNotes/setAdmins', [{ id: 0, name: '' }]);
        return;
      }

      var result = [];
      for (var i = 0; i < r.list.length; i++) {
        if (r.list[i].firstName && r.list[i].lastName) {
          result.push({
            id: r.list[i].id,
            name: r.list[i].firstName + ' ' + r.list[i].lastName
          });
        }
      }

      VueApp.$store.commit('reservationNotes/setAdmins', result);
    });
  },
  getAdmin: function getAdmin(VueApp, id, callback) {
    VueApp.$sdk.get('/admin/' + id, {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      callback(res);
    });
  },
  updateAdmin: function updateAdmin(VueApp, data, callback) {
    VueApp.$sdk.post('/admin/' + data.id, {
      token: VueApp.$store.state.session.sessionToken,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phone: data.mobile,
      username: data.username
    }, function (res) {
      callback(res);
    });
  },
  updateAdminPassword: function updateAdminPassword(VueApp, data, callback) {
    VueApp.$sdk.post('/admin/' + data.id + '/password', {
      token: VueApp.$store.state.session.sessionToken,
      password: data.password
    }, function (res) {
      callback(res);
    });
  },
  addAdmin: function addAdmin(VueApp, data, callback) {
    VueApp.$sdk.post('/admin', {
      token: VueApp.$store.state.session.sessionToken,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phone: data.mobile,
      username: data.username,
      password: data.password
    }, function (res) {
      callback(res);
    });
  },
  updateAdminAccess: function updateAdminAccess(VueApp, id, callback) {
    var admin = VueApp.$store.state.admin;
    var access = admin.permissions;
    var reportPermissions = admin.reportPermissions;

    var accessList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, admin.accessList);
    for (var key in accessList) {
      accessList[key] = access[key] ? 'view' : '';
    }

    var reportsList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, admin.reportsList);
    for (var _key in reportsList) {
      if (accessList.PageAdminReports === 'view') accessList[_key] = reportPermissions[_key] ? 'view' : '';else accessList[_key] = '';
    }
    // accessList.reportsAccess = JSON.stringify(reportsList)
    // if (accessList.PageAdminReports && Object.keys(reportPermissions).length) {
    // }
    VueApp.$sdk.post('/admin/' + id + '/access', {
      token: VueApp.$store.state.session.sessionToken,
      access: accessList
    }, function (res) {
      callback(res);
    });
  },
  updateStatus: function updateStatus(VueApp, data, callback) {
    if (data.deactivate) {
      VueApp.$sdk.delete('/admin/' + data.id, {
        token: VueApp.$store.state.session.sessionToken
      }, function (res) {
        callback(res);
      });
    } else {
      VueApp.$sdk.post('/admin/' + data.id, {
        token: VueApp.$store.state.session.sessionToken,
        deleted: null
      }, function (res) {
        callback(res);
      });
    }
  },
  export: function _export(VueApp, callback) {
    var self = this;
    var admin = VueApp.$store.state.admin;
    VueApp.$sdk.get('/admin', {
      token: VueApp.$store.state.session.sessionToken,
      search: admin.search,
      status: admin.status,
      order: admin.order,
      orderAsc: admin.orderAsc,
      pageNum: admin.currentPage,
      pageSize: admin.perPage
    }, function (res) {
      if (!res.error) {
        var admins = [];
        if (res.list.length) {
          res.list.forEach(function (value) {
            admins.push(self.buildExportAll(value));
          });
        }
        callback(admins);
      } else {
        callback(res);
      }
    });
  },
  buildExportAll: function buildExportAll(data) {
    var created = '';
    if (data.created) {
      var temp = moment(data.created, 'YYYY-MM-DD HH:mm:ss');
      if (temp.isValid()) {
        created = temp.format('MM/DD/YYYY HH:mm:ss');
      }
    }
    return {
      'First Name': data.firstName,
      'Last Name': data.lastName,
      'Username': data.username,
      'Email': data.email,
      'Mobile': data.phone,
      'Active': data.isActive
    };
  }
});

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.VueColor=t():e.VueColor=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=60)}([function(e,t){function n(e,t){var n=e[1]||"",i=e[3];if(!i)return n;if(t&&"function"==typeof btoa){var o=r(i);return[n].concat(i.sources.map(function(e){return"/*# sourceURL="+i.sourceRoot+e+" */"})).concat([o]).join("\n")}return[n].join("\n")}function r(e){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(e))))+" */"}e.exports=function(e){var t=[];return t.toString=function(){return this.map(function(t){var r=n(t,e);return t[2]?"@media "+t[2]+"{"+r+"}":r}).join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var r={},i=0;i<this.length;i++){var o=this[i][0];"number"==typeof o&&(r[o]=!0)}for(i=0;i<e.length;i++){var a=e[i];"number"==typeof a[0]&&r[a[0]]||(n&&!a[2]?a[2]=n:n&&(a[2]="("+a[2]+") and ("+n+")"),t.push(a))}},t}},function(e,t,n){function r(e){for(var t=0;t<e.length;t++){var n=e[t],r=u[n.id];if(r){r.refs++;for(var i=0;i<r.parts.length;i++)r.parts[i](n.parts[i]);for(;i<n.parts.length;i++)r.parts.push(o(n.parts[i]));r.parts.length>n.parts.length&&(r.parts.length=n.parts.length)}else{for(var a=[],i=0;i<n.parts.length;i++)a.push(o(n.parts[i]));u[n.id]={id:n.id,refs:1,parts:a}}}}function i(){var e=document.createElement("style");return e.type="text/css",f.appendChild(e),e}function o(e){var t,n,r=document.querySelector("style["+b+'~="'+e.id+'"]');if(r){if(p)return v;r.parentNode.removeChild(r)}if(x){var o=h++;r=d||(d=i()),t=a.bind(null,r,o,!1),n=a.bind(null,r,o,!0)}else r=i(),t=s.bind(null,r),n=function(){r.parentNode.removeChild(r)};return t(e),function(r){if(r){if(r.css===e.css&&r.media===e.media&&r.sourceMap===e.sourceMap)return;t(e=r)}else n()}}function a(e,t,n,r){var i=n?"":r.css;if(e.styleSheet)e.styleSheet.cssText=m(t,i);else{var o=document.createTextNode(i),a=e.childNodes;a[t]&&e.removeChild(a[t]),a.length?e.insertBefore(o,a[t]):e.appendChild(o)}}function s(e,t){var n=t.css,r=t.media,i=t.sourceMap;if(r&&e.setAttribute("media",r),g.ssrId&&e.setAttribute(b,t.id),i&&(n+="\n/*# sourceURL="+i.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(i))))+" */"),e.styleSheet)e.styleSheet.cssText=n;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}var c="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!c)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var l=n(64),u={},f=c&&(document.head||document.getElementsByTagName("head")[0]),d=null,h=0,p=!1,v=function(){},g=null,b="data-vue-ssr-id",x="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());e.exports=function(e,t,n,i){p=n,g=i||{};var o=l(e,t);return r(o),function(t){for(var n=[],i=0;i<o.length;i++){var a=o[i],s=u[a.id];s.refs--,n.push(s)}t?(o=l(e,t),r(o)):o=[];for(var i=0;i<n.length;i++){var s=n[i];if(0===s.refs){for(var c=0;c<s.parts.length;c++)s.parts[c]();delete u[s.id]}}}};var m=function(){var e=[];return function(t,n){return e[t]=n,e.filter(Boolean).join("\n")}}()},function(e,t){e.exports=function(e,t,n,r,i,o){var a,s=e=e||{},c=typeof e.default;"object"!==c&&"function"!==c||(a=e,s=e.default);var l="function"==typeof s?s.options:s;t&&(l.render=t.render,l.staticRenderFns=t.staticRenderFns,l._compiled=!0),n&&(l.functional=!0),i&&(l._scopeId=i);var u;if(o?(u=function(e){e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,e||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),r&&r.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(o)},l._ssrRegister=u):r&&(u=r),u){var f=l.functional,d=f?l.render:l.beforeCreate;f?(l._injectStyles=u,l.render=function(e,t){return u.call(t),d(e,t)}):l.beforeCreate=d?[].concat(d,u):[u]}return{esModule:a,exports:s,options:l}}},function(e,t,n){"use strict";function r(e,t){var n,r=e&&e.a;!(n=e&&e.hsl?(0,o.default)(e.hsl):e&&e.hex&&e.hex.length>0?(0,o.default)(e.hex):e&&e.hsv?(0,o.default)(e.hsv):e&&e.rgba?(0,o.default)(e.rgba):e&&e.rgb?(0,o.default)(e.rgb):(0,o.default)(e))||void 0!==n._a&&null!==n._a||n.setAlpha(r||1);var i=n.toHsl(),a=n.toHsv();return 0===i.s&&(a.h=i.h=e.h||e.hsl&&e.hsl.h||t||0),{hsl:i,hex:n.toHexString().toUpperCase(),hex8:n.toHex8String().toUpperCase(),rgba:n.toRgb(),hsv:a,oldHue:e.h||t||i.h,source:e.source,a:e.a||n.getAlpha()}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(65),o=function(e){return e&&e.__esModule?e:{default:e}}(i);t.default={props:["value"],data:function(){return{val:r(this.value)}},computed:{colors:{get:function(){return this.val},set:function(e){this.val=e,this.$emit("input",e)}}},watch:{value:function(e){this.val=r(e)}},methods:{colorChange:function(e,t){this.oldHue=this.colors.hsl.h,this.colors=r(e,t||this.oldHue)},isValidHex:function(e){return(0,o.default)(e).isValid()},simpleCheckForValidColor:function(e){for(var t=["r","g","b","a","h","s","l","v"],n=0,r=0,i=0;i<t.length;i++){var o=t[i];e[o]&&(n++,isNaN(e[o])||r++)}if(n===r)return e},paletteUpperCase:function(e){return e.map(function(e){return e.toUpperCase()})},isTransparent:function(e){return 0===(0,o.default)(e).getAlpha()}}}},function(e,t){var n=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(e,t,n){"use strict";function r(e){c||n(66)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(36),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(68),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/common/EditableInput.vue",t.default=f.exports},function(e,t){var n={}.hasOwnProperty;e.exports=function(e,t){return n.call(e,t)}},function(e,t,n){var r=n(8),i=n(18);e.exports=n(9)?function(e,t,n){return r.f(e,t,i(1,n))}:function(e,t,n){return e[t]=n,e}},function(e,t,n){var r=n(16),i=n(42),o=n(25),a=Object.defineProperty;t.f=n(9)?Object.defineProperty:function(e,t,n){if(r(e),t=o(t,!0),r(n),i)try{return a(e,t,n)}catch(e){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(e[t]=n.value),e}},function(e,t,n){e.exports=!n(17)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(e,t,n){var r=n(90),i=n(24);e.exports=function(e){return r(i(e))}},function(e,t,n){var r=n(29)("wks"),i=n(19),o=n(4).Symbol,a="function"==typeof o;(e.exports=function(e){return r[e]||(r[e]=a&&o[e]||(a?o:i)("Symbol."+e))}).store=r},function(e,t){e.exports=function(e){return"object"==typeof e?null!==e:"function"==typeof e}},function(e,t,n){"use strict";function r(e){c||n(111)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(51),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(113),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/common/Hue.vue",t.default=f.exports},function(e,t){e.exports=!0},function(e,t){var n=e.exports={version:"2.6.11"};"number"==typeof __e&&(__e=n)},function(e,t,n){var r=n(12);e.exports=function(e){if(!r(e))throw TypeError(e+" is not an object!");return e}},function(e,t){e.exports=function(e){try{return!!e()}catch(e){return!0}}},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},function(e,t){var n=0,r=Math.random();e.exports=function(e){return"Symbol(".concat(void 0===e?"":e,")_",(++n+r).toString(36))}},function(e,t,n){"use strict";function r(e){c||n(123)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(54),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(127),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/common/Saturation.vue",t.default=f.exports},function(e,t,n){"use strict";function r(e){c||n(128)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(55),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(133),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/common/Alpha.vue",t.default=f.exports},function(e,t,n){"use strict";function r(e){c||n(130)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(56),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(132),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/common/Checkboard.vue",t.default=f.exports},function(e,t){var n=Math.ceil,r=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?r:n)(e)}},function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on  "+e);return e}},function(e,t,n){var r=n(12);e.exports=function(e,t){if(!r(e))return e;var n,i;if(t&&"function"==typeof(n=e.toString)&&!r(i=n.call(e)))return i;if("function"==typeof(n=e.valueOf)&&!r(i=n.call(e)))return i;if(!t&&"function"==typeof(n=e.toString)&&!r(i=n.call(e)))return i;throw TypeError("Can't convert object to primitive value")}},function(e,t){e.exports={}},function(e,t,n){var r=n(46),i=n(30);e.exports=Object.keys||function(e){return r(e,i)}},function(e,t,n){var r=n(29)("keys"),i=n(19);e.exports=function(e){return r[e]||(r[e]=i(e))}},function(e,t,n){var r=n(15),i=n(4),o=i["__core-js_shared__"]||(i["__core-js_shared__"]={});(e.exports=function(e,t){return o[e]||(o[e]=void 0!==t?t:{})})("versions",[]).push({version:r.version,mode:n(14)?"pure":"global",copyright:"© 2019 Denis Pushkarev (zloirock.ru)"})},function(e,t){e.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(e,t,n){var r=n(8).f,i=n(6),o=n(11)("toStringTag");e.exports=function(e,t,n){e&&!i(e=n?e:e.prototype,o)&&r(e,o,{configurable:!0,value:t})}},function(e,t,n){t.f=n(11)},function(e,t,n){var r=n(4),i=n(15),o=n(14),a=n(32),s=n(8).f;e.exports=function(e){var t=i.Symbol||(i.Symbol=o?{}:r.Symbol||{});"_"==e.charAt(0)||e in t||s(t,e,{value:a.f(e)})}},function(e,t){t.f={}.propertyIsEnumerable},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),o=r(i),a=n(5),s=r(a),c=["#4D4D4D","#999999","#FFFFFF","#F44E3B","#FE9200","#FCDC00","#DBDF00","#A4DD00","#68CCCA","#73D8FF","#AEA1FF","#FDA1FF","#333333","#808080","#CCCCCC","#D33115","#E27300","#FCC400","#B0BC00","#68BC00","#16A5A5","#009CE0","#7B64FF","#FA28FF","#000000","#666666","#B3B3B3","#9F0500","#C45100","#FB9E00","#808900","#194D33","#0C797D","#0062B1","#653294","#AB149E"];t.default={name:"Compact",mixins:[o.default],props:{palette:{type:Array,default:function(){return c}}},components:{"ed-in":s.default},computed:{pick:function(){return this.colors.hex.toUpperCase()}},methods:{handlerClick:function(e){this.colorChange({hex:e,source:"hex"})}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={name:"editableInput",props:{label:String,labelText:String,desc:String,value:[String,Number],max:Number,min:Number,arrowOffset:{type:Number,default:1}},computed:{val:{get:function(){return this.value},set:function(e){if(!(void 0!==this.max&&+e>this.max))return e;this.$refs.input.value=this.max}},labelId:function(){return"input__label__"+this.label+"__"+Math.random().toString().slice(2,5)},labelSpanText:function(){return this.labelText||this.label}},methods:{update:function(e){this.handleChange(e.target.value)},handleChange:function(e){var t={};t[this.label]=e,void 0===t.hex&&void 0===t["#"]?this.$emit("change",t):e.length>5&&this.$emit("change",t)},handleKeyDown:function(e){var t=this.val,n=Number(t);if(n){var r=this.arrowOffset||1;38===e.keyCode&&(t=n+r,this.handleChange(t),e.preventDefault()),40===e.keyCode&&(t=n-r,this.handleChange(t),e.preventDefault())}}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(3),i=function(e){return e&&e.__esModule?e:{default:e}}(r),o=["#FFFFFF","#F2F2F2","#E6E6E6","#D9D9D9","#CCCCCC","#BFBFBF","#B3B3B3","#A6A6A6","#999999","#8C8C8C","#808080","#737373","#666666","#595959","#4D4D4D","#404040","#333333","#262626","#0D0D0D","#000000"];t.default={name:"Grayscale",mixins:[i.default],props:{palette:{type:Array,default:function(){return o}}},components:{},computed:{pick:function(){return this.colors.hex.toUpperCase()}},methods:{handlerClick:function(e){this.colorChange({hex:e,source:"hex"})}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(5),o=r(i),a=n(3),s=r(a);t.default={name:"Material",mixins:[s.default],components:{"ed-in":o.default},methods:{onChange:function(e){e&&(e.hex?this.isValidHex(e.hex)&&this.colorChange({hex:e.hex,source:"hex"}):(e.r||e.g||e.b)&&this.colorChange({r:e.r||this.colors.rgba.r,g:e.g||this.colors.rgba.g,b:e.b||this.colors.rgba.b,a:e.a||this.colors.rgba.a,source:"rgba"}))}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(81),o=r(i),a=n(3),s=r(a),c=n(13),l=r(c);t.default={name:"Slider",mixins:[s.default],props:{swatches:{type:Array,default:function(){return[{s:.5,l:.8},{s:.5,l:.65},{s:.5,l:.5},{s:.5,l:.35},{s:.5,l:.2}]}}},components:{hue:l.default},computed:{normalizedSwatches:function(){return this.swatches.map(function(e){return"object"!==(void 0===e?"undefined":(0,o.default)(e))?{s:.5,l:e}:e})}},methods:{isActive:function(e,t){var n=this.colors.hsl;return 1===n.l&&1===e.l||(0===n.l&&0===e.l||Math.abs(n.l-e.l)<.01&&Math.abs(n.s-e.s)<.01)},hueChange:function(e){this.colorChange(e)},handleSwClick:function(e,t){this.colorChange({h:this.colors.hsl.h,s:t.s,l:t.l,source:"hsl"})}}}},function(e,t,n){"use strict";var r=n(14),i=n(41),o=n(44),a=n(7),s=n(26),c=n(88),l=n(31),u=n(95),f=n(11)("iterator"),d=!([].keys&&"next"in[].keys()),h=function(){return this};e.exports=function(e,t,n,p,v,g,b){c(n,t,p);var x,m,_,w=function(e){if(!d&&e in F)return F[e];switch(e){case"keys":case"values":return function(){return new n(this,e)}}return function(){return new n(this,e)}},y=t+" Iterator",C="values"==v,k=!1,F=e.prototype,S=F[f]||F["@@iterator"]||v&&F[v],A=S||w(v),O=v?C?w("entries"):A:void 0,E="Array"==t?F.entries||S:S;if(E&&(_=u(E.call(new e)))!==Object.prototype&&_.next&&(l(_,y,!0),r||"function"==typeof _[f]||a(_,f,h)),C&&S&&"values"!==S.name&&(k=!0,A=function(){return S.call(this)}),r&&!b||!d&&!k&&F[f]||a(F,f,A),s[t]=A,s[y]=h,v)if(x={values:C?A:w("values"),keys:g?A:w("keys"),entries:O},b)for(m in x)m in F||o(F,m,x[m]);else i(i.P+i.F*(d||k),t,x);return x}},function(e,t,n){var r=n(4),i=n(15),o=n(86),a=n(7),s=n(6),c=function(e,t,n){var l,u,f,d=e&c.F,h=e&c.G,p=e&c.S,v=e&c.P,g=e&c.B,b=e&c.W,x=h?i:i[t]||(i[t]={}),m=x.prototype,_=h?r:p?r[t]:(r[t]||{}).prototype;h&&(n=t);for(l in n)(u=!d&&_&&void 0!==_[l])&&s(x,l)||(f=u?_[l]:n[l],x[l]=h&&"function"!=typeof _[l]?n[l]:g&&u?o(f,r):b&&_[l]==f?function(e){var t=function(t,n,r){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,n)}return new e(t,n,r)}return e.apply(this,arguments)};return t.prototype=e.prototype,t}(f):v&&"function"==typeof f?o(Function.call,f):f,v&&((x.virtual||(x.virtual={}))[l]=f,e&c.R&&m&&!m[l]&&a(m,l,f)))};c.F=1,c.G=2,c.S=4,c.P=8,c.B=16,c.W=32,c.U=64,c.R=128,e.exports=c},function(e,t,n){e.exports=!n(9)&&!n(17)(function(){return 7!=Object.defineProperty(n(43)("div"),"a",{get:function(){return 7}}).a})},function(e,t,n){var r=n(12),i=n(4).document,o=r(i)&&r(i.createElement);e.exports=function(e){return o?i.createElement(e):{}}},function(e,t,n){e.exports=n(7)},function(e,t,n){var r=n(16),i=n(89),o=n(30),a=n(28)("IE_PROTO"),s=function(){},c=function(){var e,t=n(43)("iframe"),r=o.length;for(t.style.display="none",n(94).appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write("<script>document.F=Object<\/script>"),e.close(),c=e.F;r--;)delete c.prototype[o[r]];return c()};e.exports=Object.create||function(e,t){var n;return null!==e?(s.prototype=r(e),n=new s,s.prototype=null,n[a]=e):n=c(),void 0===t?n:i(n,t)}},function(e,t,n){var r=n(6),i=n(10),o=n(91)(!1),a=n(28)("IE_PROTO");e.exports=function(e,t){var n,s=i(e),c=0,l=[];for(n in s)n!=a&&r(s,n)&&l.push(n);for(;t.length>c;)r(s,n=t[c++])&&(~o(l,n)||l.push(n));return l}},function(e,t){var n={}.toString;e.exports=function(e){return n.call(e).slice(8,-1)}},function(e,t,n){var r=n(24);e.exports=function(e){return Object(r(e))}},function(e,t){t.f=Object.getOwnPropertySymbols},function(e,t,n){var r=n(46),i=n(30).concat("length","prototype");t.f=Object.getOwnPropertyNames||function(e){return r(e,i)}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={name:"Hue",props:{value:Object,direction:{type:String,default:"horizontal"}},data:function(){return{oldHue:0,pullDirection:""}},computed:{colors:function(){var e=this.value.hsl.h;return 0!==e&&e-this.oldHue>0&&(this.pullDirection="right"),0!==e&&e-this.oldHue<0&&(this.pullDirection="left"),this.oldHue=e,this.value},directionClass:function(){return{"vc-hue--horizontal":"horizontal"===this.direction,"vc-hue--vertical":"vertical"===this.direction}},pointerTop:function(){return"vertical"===this.direction?0===this.colors.hsl.h&&"right"===this.pullDirection?0:-100*this.colors.hsl.h/360+100+"%":0},pointerLeft:function(){return"vertical"===this.direction?0:0===this.colors.hsl.h&&"right"===this.pullDirection?"100%":100*this.colors.hsl.h/360+"%"}},methods:{handleChange:function(e,t){!t&&e.preventDefault();var n=this.$refs.container;if(n){var r,i,o=n.clientWidth,a=n.clientHeight,s=n.getBoundingClientRect().left+window.pageXOffset,c=n.getBoundingClientRect().top+window.pageYOffset,l=e.pageX||(e.touches?e.touches[0].pageX:0),u=e.pageY||(e.touches?e.touches[0].pageY:0),f=l-s,d=u-c;"vertical"===this.direction?(d<0?r=360:d>a?r=0:(i=-100*d/a+100,r=360*i/100),this.colors.hsl.h!==r&&this.$emit("change",{h:r,s:this.colors.hsl.s,l:this.colors.hsl.l,a:this.colors.hsl.a,source:"hsl"})):(f<0?r=0:f>o?r=360:(i=100*f/o,r=360*i/100),this.colors.hsl.h!==r&&this.$emit("change",{h:r,s:this.colors.hsl.s,l:this.colors.hsl.l,a:this.colors.hsl.a,source:"hsl"}))}},handleMouseDown:function(e){this.handleChange(e,!0),window.addEventListener("mousemove",this.handleChange),window.addEventListener("mouseup",this.handleMouseUp)},handleMouseUp:function(e){this.unbindEventListeners()},unbindEventListeners:function(){window.removeEventListener("mousemove",this.handleChange),window.removeEventListener("mouseup",this.handleMouseUp)}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(118),o=r(i),a=n(3),s=r(a),c=["red","pink","purple","deepPurple","indigo","blue","lightBlue","cyan","teal","green","lightGreen","lime","yellow","amber","orange","deepOrange","brown","blueGrey","black"],l=["900","700","500","300","100"],u=function(){var e=[];return c.forEach(function(t){var n=[];"black"===t.toLowerCase()||"white"===t.toLowerCase()?n=n.concat(["#000000","#FFFFFF"]):l.forEach(function(e){var r=o.default[t][e];n.push(r.toUpperCase())}),e.push(n)}),e}();t.default={name:"Swatches",mixins:[s.default],props:{palette:{type:Array,default:function(){return u}}},computed:{pick:function(){return this.colors.hex}},methods:{equal:function(e){return e.toLowerCase()===this.colors.hex.toLowerCase()},handlerClick:function(e){this.colorChange({hex:e,source:"hex"})}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),o=r(i),a=n(5),s=r(a),c=n(20),l=r(c),u=n(13),f=r(u),d=n(21),h=r(d);t.default={name:"Photoshop",mixins:[o.default],props:{head:{type:String,default:"Color Picker"},disableFields:{type:Boolean,default:!1},hasResetButton:{type:Boolean,default:!1},acceptLabel:{type:String,default:"OK"},cancelLabel:{type:String,default:"Cancel"},resetLabel:{type:String,default:"Reset"},newLabel:{type:String,default:"new"},currentLabel:{type:String,default:"current"}},components:{saturation:l.default,hue:f.default,alpha:h.default,"ed-in":s.default},data:function(){return{currentColor:"#FFF"}},computed:{hsv:function(){var e=this.colors.hsv;return{h:e.h.toFixed(),s:(100*e.s).toFixed(),v:(100*e.v).toFixed()}},hex:function(){var e=this.colors.hex;return e&&e.replace("#","")}},created:function(){this.currentColor=this.colors.hex},methods:{childChange:function(e){this.colorChange(e)},inputChange:function(e){e&&(e["#"]?this.isValidHex(e["#"])&&this.colorChange({hex:e["#"],source:"hex"}):e.r||e.g||e.b||e.a?this.colorChange({r:e.r||this.colors.rgba.r,g:e.g||this.colors.rgba.g,b:e.b||this.colors.rgba.b,a:e.a||this.colors.rgba.a,source:"rgba"}):(e.h||e.s||e.v)&&this.colorChange({h:e.h||this.colors.hsv.h,s:e.s/100||this.colors.hsv.s,v:e.v/100||this.colors.hsv.v,source:"hsv"}))},clickCurrentColor:function(){this.colorChange({hex:this.currentColor,source:"hex"})},handleAccept:function(){this.$emit("ok")},handleCancel:function(){this.$emit("cancel")},handleReset:function(){this.$emit("reset")}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(125),o=r(i),a=n(126),s=r(a);t.default={name:"Saturation",props:{value:Object},computed:{colors:function(){return this.value},bgColor:function(){return"hsl("+this.colors.hsv.h+", 100%, 50%)"},pointerTop:function(){return-100*this.colors.hsv.v+1+100+"%"},pointerLeft:function(){return 100*this.colors.hsv.s+"%"}},methods:{throttle:(0,s.default)(function(e,t){e(t)},20,{leading:!0,trailing:!1}),handleChange:function(e,t){!t&&e.preventDefault();var n=this.$refs.container;if(n){var r=n.clientWidth,i=n.clientHeight,a=n.getBoundingClientRect().left+window.pageXOffset,s=n.getBoundingClientRect().top+window.pageYOffset,c=e.pageX||(e.touches?e.touches[0].pageX:0),l=e.pageY||(e.touches?e.touches[0].pageY:0),u=(0,o.default)(c-a,0,r),f=(0,o.default)(l-s,0,i),d=u/r,h=(0,o.default)(-f/i+1,0,1);this.throttle(this.onChange,{h:this.colors.hsv.h,s:d,v:h,a:this.colors.hsv.a,source:"hsva"})}},onChange:function(e){this.$emit("change",e)},handleMouseDown:function(e){window.addEventListener("mousemove",this.handleChange),window.addEventListener("mouseup",this.handleChange),window.addEventListener("mouseup",this.handleMouseUp)},handleMouseUp:function(e){this.unbindEventListeners()},unbindEventListeners:function(){window.removeEventListener("mousemove",this.handleChange),window.removeEventListener("mouseup",this.handleChange),window.removeEventListener("mouseup",this.handleMouseUp)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(22),i=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default={name:"Alpha",props:{value:Object,onChange:Function},components:{checkboard:i.default},computed:{colors:function(){return this.value},gradientColor:function(){var e=this.colors.rgba,t=[e.r,e.g,e.b].join(",");return"linear-gradient(to right, rgba("+t+", 0) 0%, rgba("+t+", 1) 100%)"}},methods:{handleChange:function(e,t){!t&&e.preventDefault();var n=this.$refs.container;if(n){var r,i=n.clientWidth,o=n.getBoundingClientRect().left+window.pageXOffset,a=e.pageX||(e.touches?e.touches[0].pageX:0),s=a-o;r=s<0?0:s>i?1:Math.round(100*s/i)/100,this.colors.a!==r&&this.$emit("change",{h:this.colors.hsl.h,s:this.colors.hsl.s,l:this.colors.hsl.l,a:r,source:"rgba"})}},handleMouseDown:function(e){this.handleChange(e,!0),window.addEventListener("mousemove",this.handleChange),window.addEventListener("mouseup",this.handleMouseUp)},handleMouseUp:function(){this.unbindEventListeners()},unbindEventListeners:function(){window.removeEventListener("mousemove",this.handleChange),window.removeEventListener("mouseup",this.handleMouseUp)}}}},function(e,t,n){"use strict";function r(e,t,n){if("undefined"==typeof document)return null;var r=document.createElement("canvas");r.width=r.height=2*n;var i=r.getContext("2d");return i?(i.fillStyle=e,i.fillRect(0,0,r.width,r.height),i.fillStyle=t,i.fillRect(0,0,n,n),i.translate(n,n),i.fillRect(0,0,n,n),r.toDataURL()):null}function i(e,t,n){var i=e+","+t+","+n;if(o[i])return o[i];var a=r(e,t,n);return o[i]=a,a}Object.defineProperty(t,"__esModule",{value:!0});var o={};t.default={name:"Checkboard",props:{size:{type:[Number,String],default:8},white:{type:String,default:"#fff"},grey:{type:String,default:"#e6e6e6"}},computed:{bgStyle:function(){return{"background-image":"url("+i(this.white,this.grey,this.size)+")"}}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),o=r(i),a=n(5),s=r(a),c=n(20),l=r(c),u=n(13),f=r(u),d=n(21),h=r(d),p=n(22),v=r(p),g=["#D0021B","#F5A623","#F8E71C","#8B572A","#7ED321","#417505","#BD10E0","#9013FE","#4A90E2","#50E3C2","#B8E986","#000000","#4A4A4A","#9B9B9B","#FFFFFF","rgba(0,0,0,0)"];t.default={name:"Sketch",mixins:[o.default],components:{saturation:l.default,hue:f.default,alpha:h.default,"ed-in":s.default,checkboard:v.default},props:{presetColors:{type:Array,default:function(){return g}},disableAlpha:{type:Boolean,default:!1},disableFields:{type:Boolean,default:!1}},computed:{hex:function(){var e=void 0;return e=this.colors.a<1?this.colors.hex8:this.colors.hex,e.replace("#","")},activeColor:function(){var e=this.colors.rgba;return"rgba("+[e.r,e.g,e.b,e.a].join(",")+")"}},methods:{handlePreset:function(e){this.colorChange({hex:e,source:"hex"})},childChange:function(e){this.colorChange(e)},inputChange:function(e){e&&(e.hex?this.isValidHex(e.hex)&&this.colorChange({hex:e.hex,source:"hex"}):(e.r||e.g||e.b||e.a)&&this.colorChange({r:e.r||this.colors.rgba.r,g:e.g||this.colors.rgba.g,b:e.b||this.colors.rgba.b,a:e.a||this.colors.rgba.a,source:"rgba"}))}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),o=r(i),a=n(5),s=r(a),c=n(20),l=r(c),u=n(13),f=r(u),d=n(21),h=r(d),p=n(22),v=r(p);t.default={name:"Chrome",mixins:[o.default],props:{disableAlpha:{type:Boolean,default:!1},disableFields:{type:Boolean,default:!1}},components:{saturation:l.default,hue:f.default,alpha:h.default,"ed-in":s.default,checkboard:v.default},data:function(){return{fieldsIndex:0,highlight:!1}},computed:{hsl:function(){var e=this.colors.hsl,t=e.h,n=e.s,r=e.l;return{h:t.toFixed(),s:(100*n).toFixed()+"%",l:(100*r).toFixed()+"%"}},activeColor:function(){var e=this.colors.rgba;return"rgba("+[e.r,e.g,e.b,e.a].join(",")+")"},hasAlpha:function(){return this.colors.a<1}},methods:{childChange:function(e){this.colorChange(e)},inputChange:function(e){if(e)if(e.hex)this.isValidHex(e.hex)&&this.colorChange({hex:e.hex,source:"hex"});else if(e.r||e.g||e.b||e.a)this.colorChange({r:e.r||this.colors.rgba.r,g:e.g||this.colors.rgba.g,b:e.b||this.colors.rgba.b,a:e.a||this.colors.rgba.a,source:"rgba"});else if(e.h||e.s||e.l){var t=e.s?e.s.replace("%","")/100:this.colors.hsl.s,n=e.l?e.l.replace("%","")/100:this.colors.hsl.l;this.colorChange({h:e.h||this.colors.hsl.h,s:t,l:n,source:"hsl"})}},toggleViews:function(){if(this.fieldsIndex>=2)return void(this.fieldsIndex=0);this.fieldsIndex++},showHighlight:function(){this.highlight=!0},hideHighlight:function(){this.highlight=!1}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(5),o=r(i),a=n(3),s=r(a),c=["#FF6900","#FCB900","#7BDCB5","#00D084","#8ED1FC","#0693E3","#ABB8C3","#EB144C","#F78DA7","#9900EF"];t.default={name:"Twitter",mixins:[s.default],components:{editableInput:o.default},props:{width:{type:[String,Number],default:276},defaultColors:{type:Array,default:function(){return c}},triangle:{default:"top-left",validator:function(e){return["hide","top-left","top-right"].includes(e)}}},computed:{hsv:function(){var e=this.colors.hsv;return{h:e.h.toFixed(),s:(100*e.s).toFixed(),v:(100*e.v).toFixed()}},hex:function(){var e=this.colors.hex;return e&&e.replace("#","")}},methods:{equal:function(e){return e.toLowerCase()===this.colors.hex.toLowerCase()},handlerClick:function(e){this.colorChange({hex:e,source:"hex"})},inputChange:function(e){e&&(e["#"]?this.isValidHex(e["#"])&&this.colorChange({hex:e["#"],source:"hex"}):e.r||e.g||e.b||e.a?this.colorChange({r:e.r||this.colors.rgba.r,g:e.g||this.colors.rgba.g,b:e.b||this.colors.rgba.b,a:e.a||this.colors.rgba.a,source:"rgba"}):(e.h||e.s||e.v)&&this.colorChange({h:e.h||this.colors.hsv.h,s:e.s/100||this.colors.hsv.s,v:e.v/100||this.colors.hsv.v,source:"hsv"}))}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}var i=n(61),o=r(i),a=n(70),s=r(a),c=n(74),l=r(c),u=n(78),f=r(u),d=n(115),h=r(d),p=n(120),v=r(p),g=n(135),b=r(g),x=n(139),m=r(x),_=n(143),w=r(_),y=n(21),C=r(y),k=n(22),F=r(k),S=n(5),A=r(S),O=n(13),E=r(O),M=n(20),j=r(M),L=n(3),P=r(L),R={version:"2.8.1",Compact:o.default,Grayscale:s.default,Twitter:w.default,Material:l.default,Slider:f.default,Swatches:h.default,Photoshop:v.default,Sketch:b.default,Chrome:m.default,Alpha:C.default,Checkboard:F.default,EditableInput:A.default,Hue:E.default,Saturation:j.default,ColorMixin:P.default};e.exports=R},function(e,t,n){"use strict";function r(e){c||n(62)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(35),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(69),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/Compact.vue",t.default=f.exports},function(e,t,n){var r=n(63);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("6ce8a5a8",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-compact {\n  padding-top: 5px;\n  padding-left: 5px;\n  width: 245px;\n  border-radius: 2px;\n  box-sizing: border-box;\n  box-shadow: 0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16);\n  background-color: #fff;\n}\n.vc-compact-colors {\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n}\n.vc-compact-color-item {\n  list-style: none;\n  width: 15px;\n  height: 15px;\n  float: left;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  position: relative;\n  cursor: pointer;\n}\n.vc-compact-color-item--white {\n  box-shadow: inset 0 0 0 1px #ddd;\n}\n.vc-compact-color-item--white .vc-compact-dot {\n  background: #000;\n}\n.vc-compact-dot {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  bottom: 5px;\n  left: 5px;\n  border-radius: 50%;\n  opacity: 1;\n  background: #fff;\n}\n",""])},function(e,t){e.exports=function(e,t){for(var n=[],r={},i=0;i<t.length;i++){var o=t[i],a=o[0],s=o[1],c=o[2],l=o[3],u={id:e+":"+i,css:s,media:c,sourceMap:l};r[a]?r[a].parts.push(u):n.push(r[a]={id:a,parts:[u]})}return n}},function(e,t,n){var r;!function(i){function o(e,t){if(e=e||"",t=t||{},e instanceof o)return e;if(!(this instanceof o))return new o(e,t);var n=a(e);this._originalInput=e,this._r=n.r,this._g=n.g,this._b=n.b,this._a=n.a,this._roundA=G(100*this._a)/100,this._format=t.format||n.format,this._gradientType=t.gradientType,this._r<1&&(this._r=G(this._r)),this._g<1&&(this._g=G(this._g)),this._b<1&&(this._b=G(this._b)),this._ok=n.ok,this._tc_id=U++}function a(e){var t={r:0,g:0,b:0},n=1,r=null,i=null,o=null,a=!1,c=!1;return"string"==typeof e&&(e=N(e)),"object"==typeof e&&(H(e.r)&&H(e.g)&&H(e.b)?(t=s(e.r,e.g,e.b),a=!0,c="%"===String(e.r).substr(-1)?"prgb":"rgb"):H(e.h)&&H(e.s)&&H(e.v)?(r=D(e.s),i=D(e.v),t=f(e.h,r,i),a=!0,c="hsv"):H(e.h)&&H(e.s)&&H(e.l)&&(r=D(e.s),o=D(e.l),t=l(e.h,r,o),a=!0,c="hsl"),e.hasOwnProperty("a")&&(n=e.a)),n=O(n),{ok:a,format:e.format||c,r:V(255,q(t.r,0)),g:V(255,q(t.g,0)),b:V(255,q(t.b,0)),a:n}}function s(e,t,n){return{r:255*E(e,255),g:255*E(t,255),b:255*E(n,255)}}function c(e,t,n){e=E(e,255),t=E(t,255),n=E(n,255);var r,i,o=q(e,t,n),a=V(e,t,n),s=(o+a)/2;if(o==a)r=i=0;else{var c=o-a;switch(i=s>.5?c/(2-o-a):c/(o+a),o){case e:r=(t-n)/c+(t<n?6:0);break;case t:r=(n-e)/c+2;break;case n:r=(e-t)/c+4}r/=6}return{h:r,s:i,l:s}}function l(e,t,n){function r(e,t,n){return n<0&&(n+=1),n>1&&(n-=1),n<1/6?e+6*(t-e)*n:n<.5?t:n<2/3?e+(t-e)*(2/3-n)*6:e}var i,o,a;if(e=E(e,360),t=E(t,100),n=E(n,100),0===t)i=o=a=n;else{var s=n<.5?n*(1+t):n+t-n*t,c=2*n-s;i=r(c,s,e+1/3),o=r(c,s,e),a=r(c,s,e-1/3)}return{r:255*i,g:255*o,b:255*a}}function u(e,t,n){e=E(e,255),t=E(t,255),n=E(n,255);var r,i,o=q(e,t,n),a=V(e,t,n),s=o,c=o-a;if(i=0===o?0:c/o,o==a)r=0;else{switch(o){case e:r=(t-n)/c+(t<n?6:0);break;case t:r=(n-e)/c+2;break;case n:r=(e-t)/c+4}r/=6}return{h:r,s:i,v:s}}function f(e,t,n){e=6*E(e,360),t=E(t,100),n=E(n,100);var r=i.floor(e),o=e-r,a=n*(1-t),s=n*(1-o*t),c=n*(1-(1-o)*t),l=r%6;return{r:255*[n,s,a,a,c,n][l],g:255*[c,n,n,s,a,a][l],b:255*[a,a,c,n,n,s][l]}}function d(e,t,n,r){var i=[R(G(e).toString(16)),R(G(t).toString(16)),R(G(n).toString(16))];return r&&i[0].charAt(0)==i[0].charAt(1)&&i[1].charAt(0)==i[1].charAt(1)&&i[2].charAt(0)==i[2].charAt(1)?i[0].charAt(0)+i[1].charAt(0)+i[2].charAt(0):i.join("")}function h(e,t,n,r,i){var o=[R(G(e).toString(16)),R(G(t).toString(16)),R(G(n).toString(16)),R(B(r))];return i&&o[0].charAt(0)==o[0].charAt(1)&&o[1].charAt(0)==o[1].charAt(1)&&o[2].charAt(0)==o[2].charAt(1)&&o[3].charAt(0)==o[3].charAt(1)?o[0].charAt(0)+o[1].charAt(0)+o[2].charAt(0)+o[3].charAt(0):o.join("")}function p(e,t,n,r){return[R(B(r)),R(G(e).toString(16)),R(G(t).toString(16)),R(G(n).toString(16))].join("")}function v(e,t){t=0===t?0:t||10;var n=o(e).toHsl();return n.s-=t/100,n.s=M(n.s),o(n)}function g(e,t){t=0===t?0:t||10;var n=o(e).toHsl();return n.s+=t/100,n.s=M(n.s),o(n)}function b(e){return o(e).desaturate(100)}function x(e,t){t=0===t?0:t||10;var n=o(e).toHsl();return n.l+=t/100,n.l=M(n.l),o(n)}function m(e,t){t=0===t?0:t||10;var n=o(e).toRgb();return n.r=q(0,V(255,n.r-G(-t/100*255))),n.g=q(0,V(255,n.g-G(-t/100*255))),n.b=q(0,V(255,n.b-G(-t/100*255))),o(n)}function _(e,t){t=0===t?0:t||10;var n=o(e).toHsl();return n.l-=t/100,n.l=M(n.l),o(n)}function w(e,t){var n=o(e).toHsl(),r=(n.h+t)%360;return n.h=r<0?360+r:r,o(n)}function y(e){var t=o(e).toHsl();return t.h=(t.h+180)%360,o(t)}function C(e){var t=o(e).toHsl(),n=t.h;return[o(e),o({h:(n+120)%360,s:t.s,l:t.l}),o({h:(n+240)%360,s:t.s,l:t.l})]}function k(e){var t=o(e).toHsl(),n=t.h;return[o(e),o({h:(n+90)%360,s:t.s,l:t.l}),o({h:(n+180)%360,s:t.s,l:t.l}),o({h:(n+270)%360,s:t.s,l:t.l})]}function F(e){var t=o(e).toHsl(),n=t.h;return[o(e),o({h:(n+72)%360,s:t.s,l:t.l}),o({h:(n+216)%360,s:t.s,l:t.l})]}function S(e,t,n){t=t||6,n=n||30;var r=o(e).toHsl(),i=360/n,a=[o(e)];for(r.h=(r.h-(i*t>>1)+720)%360;--t;)r.h=(r.h+i)%360,a.push(o(r));return a}function A(e,t){t=t||6;for(var n=o(e).toHsv(),r=n.h,i=n.s,a=n.v,s=[],c=1/t;t--;)s.push(o({h:r,s:i,v:a})),a=(a+c)%1;return s}function O(e){return e=parseFloat(e),(isNaN(e)||e<0||e>1)&&(e=1),e}function E(e,t){L(e)&&(e="100%");var n=P(e);return e=V(t,q(0,parseFloat(e))),n&&(e=parseInt(e*t,10)/100),i.abs(e-t)<1e-6?1:e%t/parseFloat(t)}function M(e){return V(1,q(0,e))}function j(e){return parseInt(e,16)}function L(e){return"string"==typeof e&&-1!=e.indexOf(".")&&1===parseFloat(e)}function P(e){return"string"==typeof e&&-1!=e.indexOf("%")}function R(e){return 1==e.length?"0"+e:""+e}function D(e){return e<=1&&(e=100*e+"%"),e}function B(e){return i.round(255*parseFloat(e)).toString(16)}function T(e){return j(e)/255}function H(e){return!!J.CSS_UNIT.exec(e)}function N(e){e=e.replace(I,"").replace($,"").toLowerCase();var t=!1;if(W[e])e=W[e],t=!0;else if("transparent"==e)return{r:0,g:0,b:0,a:0,format:"name"};var n;return(n=J.rgb.exec(e))?{r:n[1],g:n[2],b:n[3]}:(n=J.rgba.exec(e))?{r:n[1],g:n[2],b:n[3],a:n[4]}:(n=J.hsl.exec(e))?{h:n[1],s:n[2],l:n[3]}:(n=J.hsla.exec(e))?{h:n[1],s:n[2],l:n[3],a:n[4]}:(n=J.hsv.exec(e))?{h:n[1],s:n[2],v:n[3]}:(n=J.hsva.exec(e))?{h:n[1],s:n[2],v:n[3],a:n[4]}:(n=J.hex8.exec(e))?{r:j(n[1]),g:j(n[2]),b:j(n[3]),a:T(n[4]),format:t?"name":"hex8"}:(n=J.hex6.exec(e))?{r:j(n[1]),g:j(n[2]),b:j(n[3]),format:t?"name":"hex"}:(n=J.hex4.exec(e))?{r:j(n[1]+""+n[1]),g:j(n[2]+""+n[2]),b:j(n[3]+""+n[3]),a:T(n[4]+""+n[4]),format:t?"name":"hex8"}:!!(n=J.hex3.exec(e))&&{r:j(n[1]+""+n[1]),g:j(n[2]+""+n[2]),b:j(n[3]+""+n[3]),format:t?"name":"hex"}}function z(e){var t,n;return e=e||{level:"AA",size:"small"},t=(e.level||"AA").toUpperCase(),n=(e.size||"small").toLowerCase(),"AA"!==t&&"AAA"!==t&&(t="AA"),"small"!==n&&"large"!==n&&(n="small"),{level:t,size:n}}var I=/^\s+/,$=/\s+$/,U=0,G=i.round,V=i.min,q=i.max,X=i.random;o.prototype={isDark:function(){return this.getBrightness()<128},isLight:function(){return!this.isDark()},isValid:function(){return this._ok},getOriginalInput:function(){return this._originalInput},getFormat:function(){return this._format},getAlpha:function(){return this._a},getBrightness:function(){var e=this.toRgb();return(299*e.r+587*e.g+114*e.b)/1e3},getLuminance:function(){var e,t,n,r,o,a,s=this.toRgb();return e=s.r/255,t=s.g/255,n=s.b/255,r=e<=.03928?e/12.92:i.pow((e+.055)/1.055,2.4),o=t<=.03928?t/12.92:i.pow((t+.055)/1.055,2.4),a=n<=.03928?n/12.92:i.pow((n+.055)/1.055,2.4),.2126*r+.7152*o+.0722*a},setAlpha:function(e){return this._a=O(e),this._roundA=G(100*this._a)/100,this},toHsv:function(){var e=u(this._r,this._g,this._b);return{h:360*e.h,s:e.s,v:e.v,a:this._a}},toHsvString:function(){var e=u(this._r,this._g,this._b),t=G(360*e.h),n=G(100*e.s),r=G(100*e.v);return 1==this._a?"hsv("+t+", "+n+"%, "+r+"%)":"hsva("+t+", "+n+"%, "+r+"%, "+this._roundA+")"},toHsl:function(){var e=c(this._r,this._g,this._b);return{h:360*e.h,s:e.s,l:e.l,a:this._a}},toHslString:function(){var e=c(this._r,this._g,this._b),t=G(360*e.h),n=G(100*e.s),r=G(100*e.l);return 1==this._a?"hsl("+t+", "+n+"%, "+r+"%)":"hsla("+t+", "+n+"%, "+r+"%, "+this._roundA+")"},toHex:function(e){return d(this._r,this._g,this._b,e)},toHexString:function(e){return"#"+this.toHex(e)},toHex8:function(e){return h(this._r,this._g,this._b,this._a,e)},toHex8String:function(e){return"#"+this.toHex8(e)},toRgb:function(){return{r:G(this._r),g:G(this._g),b:G(this._b),a:this._a}},toRgbString:function(){return 1==this._a?"rgb("+G(this._r)+", "+G(this._g)+", "+G(this._b)+")":"rgba("+G(this._r)+", "+G(this._g)+", "+G(this._b)+", "+this._roundA+")"},toPercentageRgb:function(){return{r:G(100*E(this._r,255))+"%",g:G(100*E(this._g,255))+"%",b:G(100*E(this._b,255))+"%",a:this._a}},toPercentageRgbString:function(){return 1==this._a?"rgb("+G(100*E(this._r,255))+"%, "+G(100*E(this._g,255))+"%, "+G(100*E(this._b,255))+"%)":"rgba("+G(100*E(this._r,255))+"%, "+G(100*E(this._g,255))+"%, "+G(100*E(this._b,255))+"%, "+this._roundA+")"},toName:function(){return 0===this._a?"transparent":!(this._a<1)&&(Y[d(this._r,this._g,this._b,!0)]||!1)},toFilter:function(e){var t="#"+p(this._r,this._g,this._b,this._a),n=t,r=this._gradientType?"GradientType = 1, ":"";if(e){var i=o(e);n="#"+p(i._r,i._g,i._b,i._a)}return"progid:DXImageTransform.Microsoft.gradient("+r+"startColorstr="+t+",endColorstr="+n+")"},toString:function(e){var t=!!e;e=e||this._format;var n=!1,r=this._a<1&&this._a>=0;return t||!r||"hex"!==e&&"hex6"!==e&&"hex3"!==e&&"hex4"!==e&&"hex8"!==e&&"name"!==e?("rgb"===e&&(n=this.toRgbString()),"prgb"===e&&(n=this.toPercentageRgbString()),"hex"!==e&&"hex6"!==e||(n=this.toHexString()),"hex3"===e&&(n=this.toHexString(!0)),"hex4"===e&&(n=this.toHex8String(!0)),"hex8"===e&&(n=this.toHex8String()),"name"===e&&(n=this.toName()),"hsl"===e&&(n=this.toHslString()),"hsv"===e&&(n=this.toHsvString()),n||this.toHexString()):"name"===e&&0===this._a?this.toName():this.toRgbString()},clone:function(){return o(this.toString())},_applyModification:function(e,t){var n=e.apply(null,[this].concat([].slice.call(t)));return this._r=n._r,this._g=n._g,this._b=n._b,this.setAlpha(n._a),this},lighten:function(){return this._applyModification(x,arguments)},brighten:function(){return this._applyModification(m,arguments)},darken:function(){return this._applyModification(_,arguments)},desaturate:function(){return this._applyModification(v,arguments)},saturate:function(){return this._applyModification(g,arguments)},greyscale:function(){return this._applyModification(b,arguments)},spin:function(){return this._applyModification(w,arguments)},_applyCombination:function(e,t){return e.apply(null,[this].concat([].slice.call(t)))},analogous:function(){return this._applyCombination(S,arguments)},complement:function(){return this._applyCombination(y,arguments)},monochromatic:function(){return this._applyCombination(A,arguments)},splitcomplement:function(){return this._applyCombination(F,arguments)},triad:function(){return this._applyCombination(C,arguments)},tetrad:function(){return this._applyCombination(k,arguments)}},o.fromRatio=function(e,t){if("object"==typeof e){var n={};for(var r in e)e.hasOwnProperty(r)&&(n[r]="a"===r?e[r]:D(e[r]));e=n}return o(e,t)},o.equals=function(e,t){return!(!e||!t)&&o(e).toRgbString()==o(t).toRgbString()},o.random=function(){return o.fromRatio({r:X(),g:X(),b:X()})},o.mix=function(e,t,n){n=0===n?0:n||50;var r=o(e).toRgb(),i=o(t).toRgb(),a=n/100;return o({r:(i.r-r.r)*a+r.r,g:(i.g-r.g)*a+r.g,b:(i.b-r.b)*a+r.b,a:(i.a-r.a)*a+r.a})},o.readability=function(e,t){var n=o(e),r=o(t);return(i.max(n.getLuminance(),r.getLuminance())+.05)/(i.min(n.getLuminance(),r.getLuminance())+.05)},o.isReadable=function(e,t,n){var r,i,a=o.readability(e,t);switch(i=!1,r=z(n),r.level+r.size){case"AAsmall":case"AAAlarge":i=a>=4.5;break;case"AAlarge":i=a>=3;break;case"AAAsmall":i=a>=7}return i},o.mostReadable=function(e,t,n){var r,i,a,s,c=null,l=0;n=n||{},i=n.includeFallbackColors,a=n.level,s=n.size;for(var u=0;u<t.length;u++)(r=o.readability(e,t[u]))>l&&(l=r,c=o(t[u]));return o.isReadable(e,c,{level:a,size:s})||!i?c:(n.includeFallbackColors=!1,o.mostReadable(e,["#fff","#000"],n))};var W=o.names={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"0ff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000",blanchedalmond:"ffebcd",blue:"00f",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",burntsienna:"ea7e5d",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"0ff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkgrey:"a9a9a9",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkslategrey:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dimgrey:"696969",dodgerblue:"1e90ff",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"f0f",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",grey:"808080",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgray:"d3d3d3",lightgreen:"90ee90",lightgrey:"d3d3d3",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslategray:"789",lightslategrey:"789",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"0f0",limegreen:"32cd32",linen:"faf0e6",magenta:"f0f",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370db",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"db7093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",rebeccapurple:"663399",red:"f00",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",slategrey:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",wheat:"f5deb3",white:"fff",whitesmoke:"f5f5f5",yellow:"ff0",yellowgreen:"9acd32"},Y=o.hexNames=function(e){var t={};for(var n in e)e.hasOwnProperty(n)&&(t[e[n]]=n);return t}(W),J=function(){var e="(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)",t="[\\s|\\(]+("+e+")[,|\\s]+("+e+")[,|\\s]+("+e+")\\s*\\)?",n="[\\s|\\(]+("+e+")[,|\\s]+("+e+")[,|\\s]+("+e+")[,|\\s]+("+e+")\\s*\\)?";return{CSS_UNIT:new RegExp(e),rgb:new RegExp("rgb"+t),rgba:new RegExp("rgba"+n),hsl:new RegExp("hsl"+t),hsla:new RegExp("hsla"+n),hsv:new RegExp("hsv"+t),hsva:new RegExp("hsva"+n),hex3:/^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,hex6:/^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,hex4:/^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,hex8:/^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/}}();void 0!==e&&e.exports?e.exports=o:void 0!==(r=function(){return o}.call(t,n,t,e))&&(e.exports=r)}(Math)},function(e,t,n){var r=n(67);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("0f73e73c",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-editable-input {\n  position: relative;\n}\n.vc-input__input {\n  padding: 0;\n  border: 0;\n  outline: none;\n}\n.vc-input__label {\n  text-transform: capitalize;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-editable-input"},[n("input",{directives:[{name:"model",rawName:"v-model",value:e.val,expression:"val"}],ref:"input",staticClass:"vc-input__input",attrs:{"aria-labelledby":e.labelId},domProps:{value:e.val},on:{keydown:e.handleKeyDown,input:[function(t){t.target.composing||(e.val=t.target.value)},e.update]}}),e._v(" "),n("span",{staticClass:"vc-input__label",attrs:{for:e.label,id:e.labelId}},[e._v(e._s(e.labelSpanText))]),e._v(" "),n("span",{staticClass:"vc-input__desc"},[e._v(e._s(e.desc))])])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-compact",attrs:{role:"application","aria-label":"Compact color picker"}},[n("ul",{staticClass:"vc-compact-colors",attrs:{role:"listbox"}},e._l(e.paletteUpperCase(e.palette),function(t){return n("li",{key:t,staticClass:"vc-compact-color-item",class:{"vc-compact-color-item--white":"#FFFFFF"===t},style:{background:t},attrs:{role:"option","aria-label":"color:"+t,"aria-selected":t===e.pick},on:{click:function(n){return e.handlerClick(t)}}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t===e.pick,expression:"c === pick"}],staticClass:"vc-compact-dot"})])}),0)])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";function r(e){c||n(71)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(37),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(73),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/Grayscale.vue",t.default=f.exports},function(e,t,n){var r=n(72);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("21ddbb74",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-grayscale {\n  width: 125px;\n  border-radius: 2px;\n  box-shadow: 0 2px 15px rgba(0,0,0,.12), 0 2px 10px rgba(0,0,0,.16);\n  background-color: #fff;\n}\n.vc-grayscale-colors {\n  border-radius: 2px;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n}\n.vc-grayscale-color-item {\n  list-style: none;\n  width: 25px;\n  height: 25px;\n  float: left;\n  position: relative;\n  cursor: pointer;\n}\n.vc-grayscale-color-item--white .vc-grayscale-dot {\n  background: #000;\n}\n.vc-grayscale-dot {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 6px;\n  height: 6px;\n  margin: -3px 0 0 -2px;\n  border-radius: 50%;\n  opacity: 1;\n  background: #fff;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-grayscale",attrs:{role:"application","aria-label":"Grayscale color picker"}},[n("ul",{staticClass:"vc-grayscale-colors",attrs:{role:"listbox"}},e._l(e.paletteUpperCase(e.palette),function(t){return n("li",{key:t,staticClass:"vc-grayscale-color-item",class:{"vc-grayscale-color-item--white":"#FFFFFF"==t},style:{background:t},attrs:{role:"option","aria-label":"Color:"+t,"aria-selected":t===e.pick},on:{click:function(n){return e.handlerClick(t)}}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t===e.pick,expression:"c === pick"}],staticClass:"vc-grayscale-dot"})])}),0)])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";function r(e){c||n(75)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(38),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(77),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/Material.vue",t.default=f.exports},function(e,t,n){var r=n(76);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("1ff3af73",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,'\n.vc-material {\n  width: 98px;\n  height: 98px;\n  padding: 16px;\n  font-family: "Roboto";\n  position: relative;\n  border-radius: 2px;\n  box-shadow: 0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16);\n  background-color: #fff;\n}\n.vc-material .vc-input__input {\n  width: 100%;\n  margin-top: 12px;\n  font-size: 15px;\n  color: #333;\n  height: 30px;\n}\n.vc-material .vc-input__label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-size: 11px;\n  color: #999;\n  text-transform: capitalize;\n}\n.vc-material-hex {\n  border-bottom-width: 2px;\n  border-bottom-style: solid;\n}\n.vc-material-split {\n  display: flex;\n  margin-right: -10px;\n  padding-top: 11px;\n}\n.vc-material-third {\n  flex: 1;\n  padding-right: 10px;\n}\n',""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-material",attrs:{role:"application","aria-label":"Material color picker"}},[n("ed-in",{staticClass:"vc-material-hex",style:{borderColor:e.colors.hex},attrs:{label:"hex"},on:{change:e.onChange},model:{value:e.colors.hex,callback:function(t){e.$set(e.colors,"hex",t)},expression:"colors.hex"}}),e._v(" "),n("div",{staticClass:"vc-material-split"},[n("div",{staticClass:"vc-material-third"},[n("ed-in",{attrs:{label:"r"},on:{change:e.onChange},model:{value:e.colors.rgba.r,callback:function(t){e.$set(e.colors.rgba,"r",t)},expression:"colors.rgba.r"}})],1),e._v(" "),n("div",{staticClass:"vc-material-third"},[n("ed-in",{attrs:{label:"g"},on:{change:e.onChange},model:{value:e.colors.rgba.g,callback:function(t){e.$set(e.colors.rgba,"g",t)},expression:"colors.rgba.g"}})],1),e._v(" "),n("div",{staticClass:"vc-material-third"},[n("ed-in",{attrs:{label:"b"},on:{change:e.onChange},model:{value:e.colors.rgba.b,callback:function(t){e.$set(e.colors.rgba,"b",t)},expression:"colors.rgba.b"}})],1)])],1)},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";function r(e){c||n(79)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(39),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(114),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/Slider.vue",t.default=f.exports},function(e,t,n){var r=n(80);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("7982aa43",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-slider {\n  position: relative;\n  width: 410px;\n}\n.vc-slider-hue-warp {\n  height: 12px;\n  position: relative;\n}\n.vc-slider-hue-warp .vc-hue-picker {\n  width: 14px;\n  height: 14px;\n  border-radius: 6px;\n  transform: translate(-7px, -2px);\n  background-color: rgb(248, 248, 248);\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);\n}\n.vc-slider-swatches {\n  display: flex;\n  margin-top: 20px;\n}\n.vc-slider-swatch {\n  margin-right: 1px;\n  flex: 1;\n  width: 20%;\n}\n.vc-slider-swatch:first-child {\n  margin-right: 1px;\n}\n.vc-slider-swatch:first-child .vc-slider-swatch-picker {\n  border-radius: 2px 0px 0px 2px;\n}\n.vc-slider-swatch:last-child {\n  margin-right: 0;\n}\n.vc-slider-swatch:last-child .vc-slider-swatch-picker {\n  border-radius: 0px 2px 2px 0px;\n}\n.vc-slider-swatch-picker {\n  cursor: pointer;\n  height: 12px;\n}\n.vc-slider-swatch:nth-child(n) .vc-slider-swatch-picker.vc-slider-swatch-picker--active {\n  transform: scaleY(1.8);\n  border-radius: 3.6px/2px;\n}\n.vc-slider-swatch-picker--white {\n  box-shadow: inset 0 0 0 1px #ddd;\n}\n.vc-slider-swatch-picker--active.vc-slider-swatch-picker--white {\n  box-shadow: inset 0 0 0 0.6px #ddd;\n}\n",""])},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var i=n(82),o=r(i),a=n(100),s=r(a),c="function"==typeof s.default&&"symbol"==typeof o.default?function(e){return typeof e}:function(e){return e&&"function"==typeof s.default&&e.constructor===s.default&&e!==s.default.prototype?"symbol":typeof e};t.default="function"==typeof s.default&&"symbol"===c(o.default)?function(e){return void 0===e?"undefined":c(e)}:function(e){return e&&"function"==typeof s.default&&e.constructor===s.default&&e!==s.default.prototype?"symbol":void 0===e?"undefined":c(e)}},function(e,t,n){e.exports={default:n(83),__esModule:!0}},function(e,t,n){n(84),n(96),e.exports=n(32).f("iterator")},function(e,t,n){"use strict";var r=n(85)(!0);n(40)(String,"String",function(e){this._t=String(e),this._i=0},function(){var e,t=this._t,n=this._i;return n>=t.length?{value:void 0,done:!0}:(e=r(t,n),this._i+=e.length,{value:e,done:!1})})},function(e,t,n){var r=n(23),i=n(24);e.exports=function(e){return function(t,n){var o,a,s=String(i(t)),c=r(n),l=s.length;return c<0||c>=l?e?"":void 0:(o=s.charCodeAt(c),o<55296||o>56319||c+1===l||(a=s.charCodeAt(c+1))<56320||a>57343?e?s.charAt(c):o:e?s.slice(c,c+2):a-56320+(o-55296<<10)+65536)}}},function(e,t,n){var r=n(87);e.exports=function(e,t,n){if(r(e),void 0===t)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 2:return function(n,r){return e.call(t,n,r)};case 3:return function(n,r,i){return e.call(t,n,r,i)}}return function(){return e.apply(t,arguments)}}},function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e}},function(e,t,n){"use strict";var r=n(45),i=n(18),o=n(31),a={};n(7)(a,n(11)("iterator"),function(){return this}),e.exports=function(e,t,n){e.prototype=r(a,{next:i(1,n)}),o(e,t+" Iterator")}},function(e,t,n){var r=n(8),i=n(16),o=n(27);e.exports=n(9)?Object.defineProperties:function(e,t){i(e);for(var n,a=o(t),s=a.length,c=0;s>c;)r.f(e,n=a[c++],t[n]);return e}},function(e,t,n){var r=n(47);e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==r(e)?e.split(""):Object(e)}},function(e,t,n){var r=n(10),i=n(92),o=n(93);e.exports=function(e){return function(t,n,a){var s,c=r(t),l=i(c.length),u=o(a,l);if(e&&n!=n){for(;l>u;)if((s=c[u++])!=s)return!0}else for(;l>u;u++)if((e||u in c)&&c[u]===n)return e||u||0;return!e&&-1}}},function(e,t,n){var r=n(23),i=Math.min;e.exports=function(e){return e>0?i(r(e),9007199254740991):0}},function(e,t,n){var r=n(23),i=Math.max,o=Math.min;e.exports=function(e,t){return e=r(e),e<0?i(e+t,0):o(e,t)}},function(e,t,n){var r=n(4).document;e.exports=r&&r.documentElement},function(e,t,n){var r=n(6),i=n(48),o=n(28)("IE_PROTO"),a=Object.prototype;e.exports=Object.getPrototypeOf||function(e){return e=i(e),r(e,o)?e[o]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?a:null}},function(e,t,n){n(97);for(var r=n(4),i=n(7),o=n(26),a=n(11)("toStringTag"),s="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),c=0;c<s.length;c++){var l=s[c],u=r[l],f=u&&u.prototype;f&&!f[a]&&i(f,a,l),o[l]=o.Array}},function(e,t,n){"use strict";var r=n(98),i=n(99),o=n(26),a=n(10);e.exports=n(40)(Array,"Array",function(e,t){this._t=a(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,n=this._i++;return!e||n>=e.length?(this._t=void 0,i(1)):"keys"==t?i(0,n):"values"==t?i(0,e[n]):i(0,[n,e[n]])},"values"),o.Arguments=o.Array,r("keys"),r("values"),r("entries")},function(e,t){e.exports=function(){}},function(e,t){e.exports=function(e,t){return{value:t,done:!!e}}},function(e,t,n){e.exports={default:n(101),__esModule:!0}},function(e,t,n){n(102),n(108),n(109),n(110),e.exports=n(15).Symbol},function(e,t,n){"use strict";var r=n(4),i=n(6),o=n(9),a=n(41),s=n(44),c=n(103).KEY,l=n(17),u=n(29),f=n(31),d=n(19),h=n(11),p=n(32),v=n(33),g=n(104),b=n(105),x=n(16),m=n(12),_=n(48),w=n(10),y=n(25),C=n(18),k=n(45),F=n(106),S=n(107),A=n(49),O=n(8),E=n(27),M=S.f,j=O.f,L=F.f,P=r.Symbol,R=r.JSON,D=R&&R.stringify,B=h("_hidden"),T=h("toPrimitive"),H={}.propertyIsEnumerable,N=u("symbol-registry"),z=u("symbols"),I=u("op-symbols"),$=Object.prototype,U="function"==typeof P&&!!A.f,G=r.QObject,V=!G||!G.prototype||!G.prototype.findChild,q=o&&l(function(){return 7!=k(j({},"a",{get:function(){return j(this,"a",{value:7}).a}})).a})?function(e,t,n){var r=M($,t);r&&delete $[t],j(e,t,n),r&&e!==$&&j($,t,r)}:j,X=function(e){var t=z[e]=k(P.prototype);return t._k=e,t},W=U&&"symbol"==typeof P.iterator?function(e){return"symbol"==typeof e}:function(e){return e instanceof P},Y=function(e,t,n){return e===$&&Y(I,t,n),x(e),t=y(t,!0),x(n),i(z,t)?(n.enumerable?(i(e,B)&&e[B][t]&&(e[B][t]=!1),n=k(n,{enumerable:C(0,!1)})):(i(e,B)||j(e,B,C(1,{})),e[B][t]=!0),q(e,t,n)):j(e,t,n)},J=function(e,t){x(e);for(var n,r=g(t=w(t)),i=0,o=r.length;o>i;)Y(e,n=r[i++],t[n]);return e},K=function(e,t){return void 0===t?k(e):J(k(e),t)},Z=function(e){var t=H.call(this,e=y(e,!0));return!(this===$&&i(z,e)&&!i(I,e))&&(!(t||!i(this,e)||!i(z,e)||i(this,B)&&this[B][e])||t)},Q=function(e,t){if(e=w(e),t=y(t,!0),e!==$||!i(z,t)||i(I,t)){var n=M(e,t);return!n||!i(z,t)||i(e,B)&&e[B][t]||(n.enumerable=!0),n}},ee=function(e){for(var t,n=L(w(e)),r=[],o=0;n.length>o;)i(z,t=n[o++])||t==B||t==c||r.push(t);return r},te=function(e){for(var t,n=e===$,r=L(n?I:w(e)),o=[],a=0;r.length>a;)!i(z,t=r[a++])||n&&!i($,t)||o.push(z[t]);return o};U||(P=function(){if(this instanceof P)throw TypeError("Symbol is not a constructor!");var e=d(arguments.length>0?arguments[0]:void 0),t=function(n){this===$&&t.call(I,n),i(this,B)&&i(this[B],e)&&(this[B][e]=!1),q(this,e,C(1,n))};return o&&V&&q($,e,{configurable:!0,set:t}),X(e)},s(P.prototype,"toString",function(){return this._k}),S.f=Q,O.f=Y,n(50).f=F.f=ee,n(34).f=Z,A.f=te,o&&!n(14)&&s($,"propertyIsEnumerable",Z,!0),p.f=function(e){return X(h(e))}),a(a.G+a.W+a.F*!U,{Symbol:P});for(var ne="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),re=0;ne.length>re;)h(ne[re++]);for(var ie=E(h.store),oe=0;ie.length>oe;)v(ie[oe++]);a(a.S+a.F*!U,"Symbol",{for:function(e){return i(N,e+="")?N[e]:N[e]=P(e)},keyFor:function(e){if(!W(e))throw TypeError(e+" is not a symbol!");for(var t in N)if(N[t]===e)return t},useSetter:function(){V=!0},useSimple:function(){V=!1}}),a(a.S+a.F*!U,"Object",{create:K,defineProperty:Y,defineProperties:J,getOwnPropertyDescriptor:Q,getOwnPropertyNames:ee,getOwnPropertySymbols:te});var ae=l(function(){A.f(1)});a(a.S+a.F*ae,"Object",{getOwnPropertySymbols:function(e){return A.f(_(e))}}),R&&a(a.S+a.F*(!U||l(function(){var e=P();return"[null]"!=D([e])||"{}"!=D({a:e})||"{}"!=D(Object(e))})),"JSON",{stringify:function(e){for(var t,n,r=[e],i=1;arguments.length>i;)r.push(arguments[i++]);if(n=t=r[1],(m(t)||void 0!==e)&&!W(e))return b(t)||(t=function(e,t){if("function"==typeof n&&(t=n.call(this,e,t)),!W(t))return t}),r[1]=t,D.apply(R,r)}}),P.prototype[T]||n(7)(P.prototype,T,P.prototype.valueOf),f(P,"Symbol"),f(Math,"Math",!0),f(r.JSON,"JSON",!0)},function(e,t,n){var r=n(19)("meta"),i=n(12),o=n(6),a=n(8).f,s=0,c=Object.isExtensible||function(){return!0},l=!n(17)(function(){return c(Object.preventExtensions({}))}),u=function(e){a(e,r,{value:{i:"O"+ ++s,w:{}}})},f=function(e,t){if(!i(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!o(e,r)){if(!c(e))return"F";if(!t)return"E";u(e)}return e[r].i},d=function(e,t){if(!o(e,r)){if(!c(e))return!0;if(!t)return!1;u(e)}return e[r].w},h=function(e){return l&&p.NEED&&c(e)&&!o(e,r)&&u(e),e},p=e.exports={KEY:r,NEED:!1,fastKey:f,getWeak:d,onFreeze:h}},function(e,t,n){var r=n(27),i=n(49),o=n(34);e.exports=function(e){var t=r(e),n=i.f;if(n)for(var a,s=n(e),c=o.f,l=0;s.length>l;)c.call(e,a=s[l++])&&t.push(a);return t}},function(e,t,n){var r=n(47);e.exports=Array.isArray||function(e){return"Array"==r(e)}},function(e,t,n){var r=n(10),i=n(50).f,o={}.toString,a="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],s=function(e){try{return i(e)}catch(e){return a.slice()}};e.exports.f=function(e){return a&&"[object Window]"==o.call(e)?s(e):i(r(e))}},function(e,t,n){var r=n(34),i=n(18),o=n(10),a=n(25),s=n(6),c=n(42),l=Object.getOwnPropertyDescriptor;t.f=n(9)?l:function(e,t){if(e=o(e),t=a(t,!0),c)try{return l(e,t)}catch(e){}if(s(e,t))return i(!r.f.call(e,t),e[t])}},function(e,t){},function(e,t,n){n(33)("asyncIterator")},function(e,t,n){n(33)("observable")},function(e,t,n){var r=n(112);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("7c5f1a1c",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-hue {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  border-radius: 2px;\n}\n.vc-hue--horizontal {\n  background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n}\n.vc-hue--vertical {\n  background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n}\n.vc-hue-container {\n  cursor: pointer;\n  margin: 0 2px;\n  position: relative;\n  height: 100%;\n}\n.vc-hue-pointer {\n  z-index: 2;\n  position: absolute;\n}\n.vc-hue-picker {\n  cursor: pointer;\n  margin-top: 1px;\n  width: 4px;\n  border-radius: 1px;\n  height: 8px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .6);\n  background: #fff;\n  transform: translateX(-2px) ;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{class:["vc-hue",e.directionClass]},[n("div",{ref:"container",staticClass:"vc-hue-container",attrs:{role:"slider","aria-valuenow":e.colors.hsl.h,"aria-valuemin":"0","aria-valuemax":"360"},on:{mousedown:e.handleMouseDown,touchmove:e.handleChange,touchstart:e.handleChange}},[n("div",{staticClass:"vc-hue-pointer",style:{top:e.pointerTop,left:e.pointerLeft},attrs:{role:"presentation"}},[n("div",{staticClass:"vc-hue-picker"})])])])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-slider",attrs:{role:"application","aria-label":"Slider color picker"}},[n("div",{staticClass:"vc-slider-hue-warp"},[n("hue",{on:{change:e.hueChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),n("div",{staticClass:"vc-slider-swatches",attrs:{role:"group"}},e._l(e.normalizedSwatches,function(t,r){return n("div",{key:r,staticClass:"vc-slider-swatch",attrs:{"data-index":r,"aria-label":"color:"+e.colors.hex,role:"button"},on:{click:function(n){return e.handleSwClick(r,t)}}},[n("div",{staticClass:"vc-slider-swatch-picker",class:{"vc-slider-swatch-picker--active":e.isActive(t,r),"vc-slider-swatch-picker--white":1===t.l},style:{background:"hsl("+e.colors.hsl.h+", "+100*t.s+"%, "+100*t.l+"%)"}})])}),0)])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";function r(e){c||n(116)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(52),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(119),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/Swatches.vue",t.default=f.exports},function(e,t,n){var r=n(117);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("10f839a2",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-swatches {\n  width: 320px;\n  height: 240px;\n  overflow-y: scroll;\n  background-color: #fff;\n  box-shadow: 0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16);\n}\n.vc-swatches-box {\n  padding: 16px 0 6px 16px;\n  overflow: hidden;\n}\n.vc-swatches-color-group {\n  padding-bottom: 10px;\n  width: 40px;\n  float: left;\n  margin-right: 10px;\n}\n.vc-swatches-color-it {\n  box-sizing: border-box;\n  width: 40px;\n  height: 24px;\n  cursor: pointer;\n  background: #880e4f;\n  margin-bottom: 1px;\n  overflow: hidden;\n  -ms-border-radius: 2px 2px 0 0;\n  -moz-border-radius: 2px 2px 0 0;\n  -o-border-radius: 2px 2px 0 0;\n  -webkit-border-radius: 2px 2px 0 0;\n  border-radius: 2px 2px 0 0;\n}\n.vc-swatches-color--white {\n  border: 1px solid #DDD;\n}\n.vc-swatches-pick {\n  fill: rgb(255, 255, 255);\n  margin-left: 8px;\n  display: block;\n}\n.vc-swatches-color--white .vc-swatches-pick {\n  fill: rgb(51, 51, 51);\n}\n",""])},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),n.d(t,"red",function(){return r}),n.d(t,"pink",function(){return i}),n.d(t,"purple",function(){return o}),n.d(t,"deepPurple",function(){return a}),n.d(t,"indigo",function(){return s}),n.d(t,"blue",function(){return c}),n.d(t,"lightBlue",function(){return l}),n.d(t,"cyan",function(){return u}),n.d(t,"teal",function(){return f}),n.d(t,"green",function(){return d}),n.d(t,"lightGreen",function(){return h}),n.d(t,"lime",function(){return p}),n.d(t,"yellow",function(){return v}),n.d(t,"amber",function(){return g}),n.d(t,"orange",function(){return b}),n.d(t,"deepOrange",function(){return x}),n.d(t,"brown",function(){return m}),n.d(t,"grey",function(){return _}),n.d(t,"blueGrey",function(){return w}),n.d(t,"darkText",function(){return y}),n.d(t,"lightText",function(){return C}),n.d(t,"darkIcons",function(){return k}),n.d(t,"lightIcons",function(){return F}),n.d(t,"white",function(){return S}),n.d(t,"black",function(){return A});var r={50:"#ffebee",100:"#ffcdd2",200:"#ef9a9a",300:"#e57373",400:"#ef5350",500:"#f44336",600:"#e53935",700:"#d32f2f",800:"#c62828",900:"#b71c1c",a100:"#ff8a80",a200:"#ff5252",a400:"#ff1744",a700:"#d50000"},i={50:"#fce4ec",100:"#f8bbd0",200:"#f48fb1",300:"#f06292",400:"#ec407a",500:"#e91e63",600:"#d81b60",700:"#c2185b",800:"#ad1457",900:"#880e4f",a100:"#ff80ab",a200:"#ff4081",a400:"#f50057",a700:"#c51162"},o={50:"#f3e5f5",100:"#e1bee7",200:"#ce93d8",300:"#ba68c8",400:"#ab47bc",500:"#9c27b0",600:"#8e24aa",700:"#7b1fa2",800:"#6a1b9a",900:"#4a148c",a100:"#ea80fc",a200:"#e040fb",a400:"#d500f9",a700:"#aa00ff"},a={50:"#ede7f6",100:"#d1c4e9",200:"#b39ddb",300:"#9575cd",400:"#7e57c2",500:"#673ab7",600:"#5e35b1",700:"#512da8",800:"#4527a0",900:"#311b92",a100:"#b388ff",a200:"#7c4dff",a400:"#651fff",a700:"#6200ea"},s={50:"#e8eaf6",100:"#c5cae9",200:"#9fa8da",300:"#7986cb",400:"#5c6bc0",500:"#3f51b5",600:"#3949ab",700:"#303f9f",800:"#283593",900:"#1a237e",a100:"#8c9eff",a200:"#536dfe",a400:"#3d5afe",a700:"#304ffe"},c={50:"#e3f2fd",100:"#bbdefb",200:"#90caf9",300:"#64b5f6",400:"#42a5f5",500:"#2196f3",600:"#1e88e5",700:"#1976d2",800:"#1565c0",900:"#0d47a1",a100:"#82b1ff",a200:"#448aff",a400:"#2979ff",a700:"#2962ff"},l={50:"#e1f5fe",100:"#b3e5fc",200:"#81d4fa",300:"#4fc3f7",400:"#29b6f6",500:"#03a9f4",600:"#039be5",700:"#0288d1",800:"#0277bd",900:"#01579b",a100:"#80d8ff",a200:"#40c4ff",a400:"#00b0ff",a700:"#0091ea"},u={50:"#e0f7fa",100:"#b2ebf2",200:"#80deea",300:"#4dd0e1",400:"#26c6da",500:"#00bcd4",600:"#00acc1",700:"#0097a7",800:"#00838f",900:"#006064",a100:"#84ffff",a200:"#18ffff",a400:"#00e5ff",a700:"#00b8d4"},f={50:"#e0f2f1",100:"#b2dfdb",200:"#80cbc4",300:"#4db6ac",400:"#26a69a",500:"#009688",600:"#00897b",700:"#00796b",800:"#00695c",900:"#004d40",a100:"#a7ffeb",a200:"#64ffda",a400:"#1de9b6",a700:"#00bfa5"},d={50:"#e8f5e9",100:"#c8e6c9",200:"#a5d6a7",300:"#81c784",400:"#66bb6a",500:"#4caf50",600:"#43a047",700:"#388e3c",800:"#2e7d32",900:"#1b5e20",a100:"#b9f6ca",a200:"#69f0ae",a400:"#00e676",a700:"#00c853"},h={50:"#f1f8e9",100:"#dcedc8",200:"#c5e1a5",300:"#aed581",400:"#9ccc65",500:"#8bc34a",600:"#7cb342",700:"#689f38",800:"#558b2f",900:"#33691e",a100:"#ccff90",a200:"#b2ff59",a400:"#76ff03",a700:"#64dd17"},p={50:"#f9fbe7",100:"#f0f4c3",200:"#e6ee9c",300:"#dce775",400:"#d4e157",500:"#cddc39",600:"#c0ca33",700:"#afb42b",800:"#9e9d24",900:"#827717",a100:"#f4ff81",a200:"#eeff41",a400:"#c6ff00",a700:"#aeea00"},v={50:"#fffde7",100:"#fff9c4",200:"#fff59d",300:"#fff176",400:"#ffee58",500:"#ffeb3b",600:"#fdd835",700:"#fbc02d",800:"#f9a825",900:"#f57f17",a100:"#ffff8d",a200:"#ffff00",a400:"#ffea00",a700:"#ffd600"},g={50:"#fff8e1",100:"#ffecb3",200:"#ffe082",300:"#ffd54f",400:"#ffca28",500:"#ffc107",600:"#ffb300",700:"#ffa000",800:"#ff8f00",900:"#ff6f00",a100:"#ffe57f",a200:"#ffd740",a400:"#ffc400",a700:"#ffab00"},b={50:"#fff3e0",100:"#ffe0b2",200:"#ffcc80",300:"#ffb74d",400:"#ffa726",500:"#ff9800",600:"#fb8c00",700:"#f57c00",800:"#ef6c00",900:"#e65100",a100:"#ffd180",a200:"#ffab40",a400:"#ff9100",a700:"#ff6d00"},x={50:"#fbe9e7",100:"#ffccbc",200:"#ffab91",300:"#ff8a65",400:"#ff7043",500:"#ff5722",600:"#f4511e",700:"#e64a19",800:"#d84315",900:"#bf360c",a100:"#ff9e80",a200:"#ff6e40",a400:"#ff3d00",a700:"#dd2c00"},m={50:"#efebe9",100:"#d7ccc8",200:"#bcaaa4",300:"#a1887f",400:"#8d6e63",500:"#795548",600:"#6d4c41",700:"#5d4037",800:"#4e342e",900:"#3e2723"},_={50:"#fafafa",100:"#f5f5f5",200:"#eeeeee",300:"#e0e0e0",400:"#bdbdbd",500:"#9e9e9e",600:"#757575",700:"#616161",800:"#424242",900:"#212121"},w={50:"#eceff1",100:"#cfd8dc",200:"#b0bec5",300:"#90a4ae",400:"#78909c",500:"#607d8b",600:"#546e7a",700:"#455a64",800:"#37474f",900:"#263238"},y={primary:"rgba(0, 0, 0, 0.87)",secondary:"rgba(0, 0, 0, 0.54)",disabled:"rgba(0, 0, 0, 0.38)",dividers:"rgba(0, 0, 0, 0.12)"},C={primary:"rgba(255, 255, 255, 1)",secondary:"rgba(255, 255, 255, 0.7)",disabled:"rgba(255, 255, 255, 0.5)",dividers:"rgba(255, 255, 255, 0.12)"},k={active:"rgba(0, 0, 0, 0.54)",inactive:"rgba(0, 0, 0, 0.38)"},F={active:"rgba(255, 255, 255, 1)",inactive:"rgba(255, 255, 255, 0.5)"},S="#ffffff",A="#000000";t.default={red:r,pink:i,purple:o,deepPurple:a,indigo:s,blue:c,lightBlue:l,cyan:u,teal:f,green:d,lightGreen:h,lime:p,yellow:v,amber:g,orange:b,deepOrange:x,brown:m,grey:_,blueGrey:w,darkText:y,lightText:C,darkIcons:k,lightIcons:F,white:S,black:A}},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-swatches",attrs:{role:"application","aria-label":"Swatches color picker","data-pick":e.pick}},[n("div",{staticClass:"vc-swatches-box",attrs:{role:"listbox"}},e._l(e.palette,function(t,r){return n("div",{key:r,staticClass:"vc-swatches-color-group"},e._l(t,function(t){return n("div",{key:t,class:["vc-swatches-color-it",{"vc-swatches-color--white":"#FFFFFF"===t}],style:{background:t},attrs:{role:"option","aria-label":"Color:"+t,"aria-selected":e.equal(t),"data-color":t},on:{click:function(n){return e.handlerClick(t)}}},[n("div",{directives:[{name:"show",rawName:"v-show",value:e.equal(t),expression:"equal(c)"}],staticClass:"vc-swatches-pick"},[n("svg",{staticStyle:{width:"24px",height:"24px"},attrs:{viewBox:"0 0 24 24"}},[n("path",{attrs:{d:"M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"}})])])])}),0)}),0)])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";function r(e){c||n(121)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(53),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(134),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/Photoshop.vue",t.default=f.exports},function(e,t,n){var r=n(122);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("080365d4",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,'\n.vc-photoshop {\n  background: #DCDCDC;\n  border-radius: 4px;\n  box-shadow: 0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15);\n  box-sizing: initial;\n  width: 513px;\n  font-family: Roboto;\n}\n.vc-photoshop__disable-fields {\n  width: 390px;\n}\n.vc-ps-head {\n  background-image: linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%);\n  border-bottom: 1px solid #B1B1B1;\n  box-shadow: inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02);\n  height: 23px;\n  line-height: 24px;\n  border-radius: 4px 4px 0 0;\n  font-size: 13px;\n  color: #4D4D4D;\n  text-align: center;\n}\n.vc-ps-body {\n  padding: 15px;\n  display: flex;\n}\n.vc-ps-saturation-wrap {\n  width: 256px;\n  height: 256px;\n  position: relative;\n  border: 2px solid #B3B3B3;\n  border-bottom: 2px solid #F0F0F0;\n  overflow: hidden;\n}\n.vc-ps-saturation-wrap .vc-saturation-circle {\n  width: 12px;\n  height: 12px;\n}\n.vc-ps-hue-wrap {\n  position: relative;\n  height: 256px;\n  width: 19px;\n  margin-left: 10px;\n  border: 2px solid #B3B3B3;\n  border-bottom: 2px solid #F0F0F0;\n}\n.vc-ps-hue-pointer {\n  position: relative;\n}\n.vc-ps-hue-pointer--left,\n.vc-ps-hue-pointer--right {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 5px 0 5px 8px;\n  border-color: transparent transparent transparent #555;\n}\n.vc-ps-hue-pointer--left:after,\n.vc-ps-hue-pointer--right:after {\n  content: "";\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 4px 0 4px 6px;\n  border-color: transparent transparent transparent #fff;\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  transform: translate(-8px, -5px);\n}\n.vc-ps-hue-pointer--left {\n  transform: translate(-13px, -4px);\n}\n.vc-ps-hue-pointer--right {\n  transform: translate(20px, -4px) rotate(180deg);\n}\n.vc-ps-controls {\n  width: 180px;\n  margin-left: 10px;\n  display: flex;\n}\n.vc-ps-controls__disable-fields {\n  width: auto;\n}\n.vc-ps-actions {\n  margin-left: 20px;\n  flex: 1;\n}\n.vc-ps-ac-btn {\n  cursor: pointer;\n  background-image: linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%);\n  border: 1px solid #878787;\n  border-radius: 2px;\n  height: 20px;\n  box-shadow: 0 1px 0 0 #EAEAEA;\n  font-size: 14px;\n  color: #000;\n  line-height: 20px;\n  text-align: center;\n  margin-bottom: 10px;\n}\n.vc-ps-previews {\n  width: 60px;\n}\n.vc-ps-previews__swatches {\n  border: 1px solid #B3B3B3;\n  border-bottom: 1px solid #F0F0F0;\n  margin-bottom: 2px;\n  margin-top: 1px;\n}\n.vc-ps-previews__pr-color {\n  height: 34px;\n  box-shadow: inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000;\n}\n.vc-ps-previews__label {\n  font-size: 14px;\n  color: #000;\n  text-align: center;\n}\n.vc-ps-fields {\n  padding-top: 5px;\n  padding-bottom: 9px;\n  width: 80px;\n  position: relative;\n}\n.vc-ps-fields .vc-input__input {\n  margin-left: 40%;\n  width: 40%;\n  height: 18px;\n  border: 1px solid #888888;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC;\n  margin-bottom: 5px;\n  font-size: 13px;\n  padding-left: 3px;\n  margin-right: 10px;\n}\n.vc-ps-fields .vc-input__label, .vc-ps-fields .vc-input__desc {\n  top: 0;\n  text-transform: uppercase;\n  font-size: 13px;\n  height: 18px;\n  line-height: 22px;\n  position: absolute;\n}\n.vc-ps-fields .vc-input__label {\n  left: 0;\n  width: 34px;\n}\n.vc-ps-fields .vc-input__desc {\n  right: 0;\n  width: 0;\n}\n.vc-ps-fields__divider {\n  height: 5px;\n}\n.vc-ps-fields__hex .vc-input__input {\n  margin-left: 20%;\n  width: 80%;\n  height: 18px;\n  border: 1px solid #888888;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC;\n  margin-bottom: 6px;\n  font-size: 13px;\n  padding-left: 3px;\n}\n.vc-ps-fields__hex .vc-input__label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 14px;\n  text-transform: uppercase;\n  font-size: 13px;\n  height: 18px;\n  line-height: 22px;\n}\n',""])},function(e,t,n){var r=n(124);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("b5380e52",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-saturation,\n.vc-saturation--white,\n.vc-saturation--black {\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.vc-saturation--white {\n  background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n}\n.vc-saturation--black {\n  background: linear-gradient(to top, #000, rgba(0,0,0,0));\n}\n.vc-saturation-pointer {\n  cursor: pointer;\n  position: absolute;\n}\n.vc-saturation-circle {\n  cursor: head;\n  width: 4px;\n  height: 4px;\n  box-shadow: 0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3), 0 0 1px 2px rgba(0,0,0,.4);\n  border-radius: 50%;\n  transform: translate(-2px, -2px);\n}\n",""])},function(e,t){function n(e,t,n){return t<n?e<t?t:e>n?n:e:e<n?n:e>t?t:e}e.exports=n},function(e,t){function n(e,t,n){function r(t){var n=v,r=g;return v=g=void 0,k=t,x=e.apply(r,n)}function o(e){return k=e,m=setTimeout(u,t),F?r(e):x}function a(e){var n=e-_,r=e-k,i=t-n;return S?y(i,b-r):i}function l(e){var n=e-_,r=e-k;return void 0===_||n>=t||n<0||S&&r>=b}function u(){var e=C();if(l(e))return f(e);m=setTimeout(u,a(e))}function f(e){return m=void 0,A&&v?r(e):(v=g=void 0,x)}function d(){void 0!==m&&clearTimeout(m),k=0,v=_=g=m=void 0}function h(){return void 0===m?x:f(C())}function p(){var e=C(),n=l(e);if(v=arguments,g=this,_=e,n){if(void 0===m)return o(_);if(S)return m=setTimeout(u,t),r(_)}return void 0===m&&(m=setTimeout(u,t)),x}var v,g,b,x,m,_,k=0,F=!1,S=!1,A=!0;if("function"!=typeof e)throw new TypeError(c);return t=s(t)||0,i(n)&&(F=!!n.leading,S="maxWait"in n,b=S?w(s(n.maxWait)||0,t):b,A="trailing"in n?!!n.trailing:A),p.cancel=d,p.flush=h,p}function r(e,t,r){var o=!0,a=!0;if("function"!=typeof e)throw new TypeError(c);return i(r)&&(o="leading"in r?!!r.leading:o,a="trailing"in r?!!r.trailing:a),n(e,t,{leading:o,maxWait:t,trailing:a})}function i(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function o(e){return!!e&&"object"==typeof e}function a(e){return"symbol"==typeof e||o(e)&&_.call(e)==u}function s(e){if("number"==typeof e)return e;if(a(e))return l;if(i(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=i(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(f,"");var n=h.test(e);return n||p.test(e)?v(e.slice(2),n?2:8):d.test(e)?l:+e}var c="Expected a function",l=NaN,u="[object Symbol]",f=/^\s+|\s+$/g,d=/^[-+]0x[0-9a-f]+$/i,h=/^0b[01]+$/i,p=/^0o[0-7]+$/i,v=parseInt,g="object"==typeof global&&global&&global.Object===Object&&global,b="object"==typeof self&&self&&self.Object===Object&&self,x=g||b||Function("return this")(),m=Object.prototype,_=m.toString,w=Math.max,y=Math.min,C=function(){return x.Date.now()};e.exports=r},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{ref:"container",staticClass:"vc-saturation",style:{background:e.bgColor},on:{mousedown:e.handleMouseDown,touchmove:e.handleChange,touchstart:e.handleChange}},[n("div",{staticClass:"vc-saturation--white"}),e._v(" "),n("div",{staticClass:"vc-saturation--black"}),e._v(" "),n("div",{staticClass:"vc-saturation-pointer",style:{top:e.pointerTop,left:e.pointerLeft}},[n("div",{staticClass:"vc-saturation-circle"})])])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){var r=n(129);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("4dc1b086",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-alpha {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n}\n.vc-alpha-checkboard-wrap {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  overflow: hidden;\n}\n.vc-alpha-gradient {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n}\n.vc-alpha-container {\n  cursor: pointer;\n  position: relative;\n  z-index: 2;\n  height: 100%;\n  margin: 0 3px;\n}\n.vc-alpha-pointer {\n  z-index: 2;\n  position: absolute;\n}\n.vc-alpha-picker {\n  cursor: pointer;\n  width: 4px;\n  border-radius: 1px;\n  height: 8px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .6);\n  background: #fff;\n  margin-top: 1px;\n  transform: translateX(-2px);\n}\n",""])},function(e,t,n){var r=n(131);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("7e15c05b",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-checkerboard {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  background-size: contain;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement;return(e._self._c||t)("div",{staticClass:"vc-checkerboard",style:e.bgStyle})},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-alpha"},[n("div",{staticClass:"vc-alpha-checkboard-wrap"},[n("checkboard")],1),e._v(" "),n("div",{staticClass:"vc-alpha-gradient",style:{background:e.gradientColor}}),e._v(" "),n("div",{ref:"container",staticClass:"vc-alpha-container",on:{mousedown:e.handleMouseDown,touchmove:e.handleChange,touchstart:e.handleChange}},[n("div",{staticClass:"vc-alpha-pointer",style:{left:100*e.colors.a+"%"}},[n("div",{staticClass:"vc-alpha-picker"})])])])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{class:["vc-photoshop",e.disableFields?"vc-photoshop__disable-fields":""],attrs:{role:"application","aria-label":"PhotoShop color picker"}},[n("div",{staticClass:"vc-ps-head",attrs:{role:"heading"}},[e._v(e._s(e.head))]),e._v(" "),n("div",{staticClass:"vc-ps-body"},[n("div",{staticClass:"vc-ps-saturation-wrap"},[n("saturation",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),n("div",{staticClass:"vc-ps-hue-wrap"},[n("hue",{attrs:{direction:"vertical"},on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}},[n("div",{staticClass:"vc-ps-hue-pointer"},[n("i",{staticClass:"vc-ps-hue-pointer--left"}),n("i",{staticClass:"vc-ps-hue-pointer--right"})])])],1),e._v(" "),n("div",{class:["vc-ps-controls",e.disableFields?"vc-ps-controls__disable-fields":""]},[n("div",{staticClass:"vc-ps-previews"},[n("div",{staticClass:"vc-ps-previews__label"},[e._v(e._s(e.newLabel))]),e._v(" "),n("div",{staticClass:"vc-ps-previews__swatches"},[n("div",{staticClass:"vc-ps-previews__pr-color",style:{background:e.colors.hex},attrs:{"aria-label":"New color is "+e.colors.hex}}),e._v(" "),n("div",{staticClass:"vc-ps-previews__pr-color",style:{background:e.currentColor},attrs:{"aria-label":"Current color is "+e.currentColor},on:{click:e.clickCurrentColor}})]),e._v(" "),n("div",{staticClass:"vc-ps-previews__label"},[e._v(e._s(e.currentLabel))])]),e._v(" "),e.disableFields?e._e():n("div",{staticClass:"vc-ps-actions"},[n("div",{staticClass:"vc-ps-ac-btn",attrs:{role:"button","aria-label":e.acceptLabel},on:{click:e.handleAccept}},[e._v(e._s(e.acceptLabel))]),e._v(" "),n("div",{staticClass:"vc-ps-ac-btn",attrs:{role:"button","aria-label":e.cancelLabel},on:{click:e.handleCancel}},[e._v(e._s(e.cancelLabel))]),e._v(" "),n("div",{staticClass:"vc-ps-fields"},[n("ed-in",{attrs:{label:"h",desc:"°",value:e.hsv.h},on:{change:e.inputChange}}),e._v(" "),n("ed-in",{attrs:{label:"s",desc:"%",value:e.hsv.s,max:100},on:{change:e.inputChange}}),e._v(" "),n("ed-in",{attrs:{label:"v",desc:"%",value:e.hsv.v,max:100},on:{change:e.inputChange}}),e._v(" "),n("div",{staticClass:"vc-ps-fields__divider"}),e._v(" "),n("ed-in",{attrs:{label:"r",value:e.colors.rgba.r},on:{change:e.inputChange}}),e._v(" "),n("ed-in",{attrs:{label:"g",value:e.colors.rgba.g},on:{change:e.inputChange}}),e._v(" "),n("ed-in",{attrs:{label:"b",value:e.colors.rgba.b},on:{change:e.inputChange}}),e._v(" "),n("div",{staticClass:"vc-ps-fields__divider"}),e._v(" "),n("ed-in",{staticClass:"vc-ps-fields__hex",attrs:{label:"#",value:e.hex},on:{change:e.inputChange}})],1),e._v(" "),e.hasResetButton?n("div",{staticClass:"vc-ps-ac-btn",attrs:{"aria-label":"reset"},on:{click:e.handleReset}},[e._v(e._s(e.resetLabel))]):e._e()])])])])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";function r(e){c||n(136)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(57),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(138),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/Sketch.vue",t.default=f.exports},function(e,t,n){var r=n(137);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("612c6604",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-sketch {\n  position: relative;\n  width: 200px;\n  padding: 10px 10px 0;\n  box-sizing: initial;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, .15), 0 8px 16px rgba(0, 0, 0, .15);\n}\n.vc-sketch-saturation-wrap {\n  width: 100%;\n  padding-bottom: 75%;\n  position: relative;\n  overflow: hidden;\n}\n.vc-sketch-controls {\n  display: flex;\n}\n.vc-sketch-sliders {\n  padding: 4px 0;\n  flex: 1;\n}\n.vc-sketch-sliders .vc-hue,\n.vc-sketch-sliders .vc-alpha-gradient {\n  border-radius: 2px;\n}\n.vc-sketch-hue-wrap {\n  position: relative;\n  height: 10px;\n}\n.vc-sketch-alpha-wrap {\n  position: relative;\n  height: 10px;\n  margin-top: 4px;\n  overflow: hidden;\n}\n.vc-sketch-color-wrap {\n  width: 24px;\n  height: 24px;\n  position: relative;\n  margin-top: 4px;\n  margin-left: 4px;\n  border-radius: 3px;\n}\n.vc-sketch-active-color {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 2px;\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .15), inset 0 0 4px rgba(0, 0, 0, .25);\n  z-index: 2;\n}\n.vc-sketch-color-wrap .vc-checkerboard {\n  background-size: auto;\n}\n.vc-sketch-field {\n  display: flex;\n  padding-top: 4px;\n}\n.vc-sketch-field .vc-input__input {\n  width: 90%;\n  padding: 4px 0 3px 10%;\n  border: none;\n  box-shadow: inset 0 0 0 1px #ccc;\n  font-size: 10px;\n}\n.vc-sketch-field .vc-input__label {\n  display: block;\n  text-align: center;\n  font-size: 11px;\n  color: #222;\n  padding-top: 3px;\n  padding-bottom: 4px;\n  text-transform: capitalize;\n}\n.vc-sketch-field--single {\n  flex: 1;\n  padding-left: 6px;\n}\n.vc-sketch-field--double {\n  flex: 2;\n}\n.vc-sketch-presets {\n  margin-right: -10px;\n  margin-left: -10px;\n  padding-left: 10px;\n  padding-top: 10px;\n  border-top: 1px solid #eee;\n}\n.vc-sketch-presets-color {\n  border-radius: 3px;\n  overflow: hidden;\n  position: relative;\n  display: inline-block;\n  margin: 0 10px 10px 0;\n  vertical-align: top;\n  cursor: pointer;\n  width: 16px;\n  height: 16px;\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .15);\n}\n.vc-sketch-presets-color .vc-checkerboard {\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .15);\n  border-radius: 3px;\n}\n.vc-sketch__disable-alpha .vc-sketch-color-wrap {\n  height: 10px;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{class:["vc-sketch",e.disableAlpha?"vc-sketch__disable-alpha":""],attrs:{role:"application","aria-label":"Sketch color picker"}},[n("div",{staticClass:"vc-sketch-saturation-wrap"},[n("saturation",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),n("div",{staticClass:"vc-sketch-controls"},[n("div",{staticClass:"vc-sketch-sliders"},[n("div",{staticClass:"vc-sketch-hue-wrap"},[n("hue",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),e.disableAlpha?e._e():n("div",{staticClass:"vc-sketch-alpha-wrap"},[n("alpha",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1)]),e._v(" "),n("div",{staticClass:"vc-sketch-color-wrap"},[n("div",{staticClass:"vc-sketch-active-color",style:{background:e.activeColor},attrs:{"aria-label":"Current color is "+e.activeColor}}),e._v(" "),n("checkboard")],1)]),e._v(" "),e.disableFields?e._e():n("div",{staticClass:"vc-sketch-field"},[n("div",{staticClass:"vc-sketch-field--double"},[n("ed-in",{attrs:{label:"hex",value:e.hex},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-sketch-field--single"},[n("ed-in",{attrs:{label:"r",value:e.colors.rgba.r},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-sketch-field--single"},[n("ed-in",{attrs:{label:"g",value:e.colors.rgba.g},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-sketch-field--single"},[n("ed-in",{attrs:{label:"b",value:e.colors.rgba.b},on:{change:e.inputChange}})],1),e._v(" "),e.disableAlpha?e._e():n("div",{staticClass:"vc-sketch-field--single"},[n("ed-in",{attrs:{label:"a",value:e.colors.a,"arrow-offset":.01,max:1},on:{change:e.inputChange}})],1)]),e._v(" "),n("div",{staticClass:"vc-sketch-presets",attrs:{role:"group","aria-label":"A color preset, pick one to set as current color"}},[e._l(e.presetColors,function(t){return[e.isTransparent(t)?n("div",{key:t,staticClass:"vc-sketch-presets-color",attrs:{"aria-label":"Color:"+t},on:{click:function(n){return e.handlePreset(t)}}},[n("checkboard")],1):n("div",{key:t,staticClass:"vc-sketch-presets-color",style:{background:t},attrs:{"aria-label":"Color:"+t},on:{click:function(n){return e.handlePreset(t)}}})]})],2)])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";function r(e){c||n(140)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(58),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(142),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/Chrome.vue",t.default=f.exports},function(e,t,n){var r=n(141);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("1cd16048",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-chrome {\n  background: #fff;\n  border-radius: 2px;\n  box-shadow: 0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3);\n  box-sizing: initial;\n  width: 225px;\n  font-family: Menlo;\n  background-color: #fff;\n}\n.vc-chrome-controls {\n  display: flex;\n}\n.vc-chrome-color-wrap {\n  position: relative;\n  width: 36px;\n}\n.vc-chrome-active-color {\n  position: relative;\n  width: 30px;\n  height: 30px;\n  border-radius: 15px;\n  overflow: hidden;\n  z-index: 1;\n}\n.vc-chrome-color-wrap .vc-checkerboard {\n  width: 30px;\n  height: 30px;\n  border-radius: 15px;\n  background-size: auto;\n}\n.vc-chrome-sliders {\n  flex: 1;\n}\n.vc-chrome-fields-wrap {\n  display: flex;\n  padding-top: 16px;\n}\n.vc-chrome-fields {\n  display: flex;\n  margin-left: -6px;\n  flex: 1;\n}\n.vc-chrome-field {\n  padding-left: 6px;\n  width: 100%;\n}\n.vc-chrome-toggle-btn {\n  width: 32px;\n  text-align: right;\n  position: relative;\n}\n.vc-chrome-toggle-icon {\n  margin-right: -4px;\n  margin-top: 12px;\n  cursor: pointer;\n  position: relative;\n  z-index: 2;\n}\n.vc-chrome-toggle-icon-highlight {\n  position: absolute;\n  width: 24px;\n  height: 28px;\n  background: #eee;\n  border-radius: 4px;\n  top: 10px;\n  left: 12px;\n}\n.vc-chrome-hue-wrap {\n  position: relative;\n  height: 10px;\n  margin-bottom: 8px;\n}\n.vc-chrome-alpha-wrap {\n  position: relative;\n  height: 10px;\n}\n.vc-chrome-hue-wrap .vc-hue {\n  border-radius: 2px;\n}\n.vc-chrome-alpha-wrap .vc-alpha-gradient {\n  border-radius: 2px;\n}\n.vc-chrome-hue-wrap .vc-hue-picker, .vc-chrome-alpha-wrap .vc-alpha-picker {\n  width: 12px;\n  height: 12px;\n  border-radius: 6px;\n  transform: translate(-6px, -2px);\n  background-color: rgb(248, 248, 248);\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);\n}\n.vc-chrome-body {\n  padding: 16px 16px 12px;\n  background-color: #fff;\n}\n.vc-chrome-saturation-wrap {\n  width: 100%;\n  padding-bottom: 55%;\n  position: relative;\n  border-radius: 2px 2px 0 0;\n  overflow: hidden;\n}\n.vc-chrome-saturation-wrap .vc-saturation-circle {\n  width: 12px;\n  height: 12px;\n}\n.vc-chrome-fields .vc-input__input {\n  font-size: 11px;\n  color: #333;\n  width: 100%;\n  border-radius: 2px;\n  border: none;\n  box-shadow: inset 0 0 0 1px #dadada;\n  height: 21px;\n  text-align: center;\n}\n.vc-chrome-fields .vc-input__label {\n  text-transform: uppercase;\n  font-size: 11px;\n  line-height: 11px;\n  color: #969696;\n  text-align: center;\n  display: block;\n  margin-top: 12px;\n}\n.vc-chrome__disable-alpha .vc-chrome-active-color {\n  width: 18px;\n  height: 18px;\n}\n.vc-chrome__disable-alpha .vc-chrome-color-wrap {\n  width: 30px;\n}\n.vc-chrome__disable-alpha .vc-chrome-hue-wrap {\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{class:["vc-chrome",e.disableAlpha?"vc-chrome__disable-alpha":""],attrs:{role:"application","aria-label":"Chrome color picker"}},[n("div",{staticClass:"vc-chrome-saturation-wrap"},[n("saturation",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),n("div",{staticClass:"vc-chrome-body"},[n("div",{staticClass:"vc-chrome-controls"},[n("div",{staticClass:"vc-chrome-color-wrap"},[n("div",{staticClass:"vc-chrome-active-color",style:{background:e.activeColor},attrs:{"aria-label":"current color is "+e.colors.hex}}),e._v(" "),e.disableAlpha?e._e():n("checkboard")],1),e._v(" "),n("div",{staticClass:"vc-chrome-sliders"},[n("div",{staticClass:"vc-chrome-hue-wrap"},[n("hue",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),e.disableAlpha?e._e():n("div",{staticClass:"vc-chrome-alpha-wrap"},[n("alpha",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1)])]),e._v(" "),e.disableFields?e._e():n("div",{staticClass:"vc-chrome-fields-wrap"},[n("div",{directives:[{name:"show",rawName:"v-show",value:0===e.fieldsIndex,expression:"fieldsIndex === 0"}],staticClass:"vc-chrome-fields"},[n("div",{staticClass:"vc-chrome-field"},[e.hasAlpha?e._e():n("ed-in",{attrs:{label:"hex",value:e.colors.hex},on:{change:e.inputChange}}),e._v(" "),e.hasAlpha?n("ed-in",{attrs:{label:"hex",value:e.colors.hex8},on:{change:e.inputChange}}):e._e()],1)]),e._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:1===e.fieldsIndex,expression:"fieldsIndex === 1"}],staticClass:"vc-chrome-fields"},[n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"r",value:e.colors.rgba.r},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"g",value:e.colors.rgba.g},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"b",value:e.colors.rgba.b},on:{change:e.inputChange}})],1),e._v(" "),e.disableAlpha?e._e():n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"a",value:e.colors.a,"arrow-offset":.01,max:1},on:{change:e.inputChange}})],1)]),e._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:2===e.fieldsIndex,expression:"fieldsIndex === 2"}],staticClass:"vc-chrome-fields"},[n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"h",value:e.hsl.h},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"s",value:e.hsl.s},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"l",value:e.hsl.l},on:{change:e.inputChange}})],1),e._v(" "),e.disableAlpha?e._e():n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"a",value:e.colors.a,"arrow-offset":.01,max:1},on:{change:e.inputChange}})],1)]),e._v(" "),n("div",{staticClass:"vc-chrome-toggle-btn",attrs:{role:"button","aria-label":"Change another color definition"},on:{click:e.toggleViews}},[n("div",{staticClass:"vc-chrome-toggle-icon"},[n("svg",{staticStyle:{width:"24px",height:"24px"},attrs:{viewBox:"0 0 24 24"},on:{mouseover:e.showHighlight,mouseenter:e.showHighlight,mouseout:e.hideHighlight}},[n("path",{attrs:{fill:"#333",d:"M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"}})])]),e._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:e.highlight,expression:"highlight"}],staticClass:"vc-chrome-toggle-icon-highlight"})])])])])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o},function(e,t,n){"use strict";function r(e){c||n(144)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(59),o=n.n(i);for(var a in i)"default"!==a&&function(e){n.d(t,e,function(){return i[e]})}(a);var s=n(146),c=!1,l=n(2),u=r,f=l(o.a,s.a,!1,u,null,null);f.options.__file="src/components/Twitter.vue",t.default=f.exports},function(e,t,n){var r=n(145);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("669a48a5",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-twitter {\n  background: #fff;\n  border: 0 solid rgba(0,0,0,0.25);\n  box-shadow: 0 1px 4px rgba(0,0,0,0.25);\n  border-radius: 4px;\n  position: relative;\n}\n.vc-twitter-triangle {\n  width: 0px;\n  height: 0px;\n  border-style: solid;\n  border-width: 0 9px 10px 9px;\n  border-color: transparent transparent #fff transparent;\n  position: absolute;\n}\n.vc-twitter-triangle-shadow {\n  width: 0px;\n  height: 0px;\n  border-style: solid;\n  border-width: 0 9px 10px 9px;\n  border-color: transparent transparent rgba(0, 0, 0, .1) transparent;\n  position: absolute;\n}\n.vc-twitter-body {\n  padding: 15px 9px 9px 15px;\n}\n.vc-twitter .vc-editable-input {\n  position: relative;\n}\n.vc-twitter .vc-editable-input input {\n  width: 100px;\n  font-size: 14px;\n  color: #666;\n  border: 0px;\n  outline: none;\n  height: 28px;\n  box-shadow: inset 0 0 0 1px #F0F0F0;\n  box-sizing: content-box;\n  border-radius: 0 4px 4px 0;\n  float: left;\n  padding: 1px;\n  padding-left: 8px;\n}\n.vc-twitter .vc-editable-input span {\n  display: none;\n}\n.vc-twitter-hash {\n  background: #F0F0F0;\n  height: 30px;\n  width: 30px;\n  border-radius: 4px 0 0 4px;\n  float: left;\n  color: #98A1A4;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.vc-twitter-swatch {\n  width: 30px;\n  height: 30px;\n  float: left;\n  border-radius: 4px;\n  margin: 0 6px 6px 0;\n  cursor: pointer;\n  position: relative;\n  outline: none;\n}\n.vc-twitter-clear {\n  clear: both;\n}\n.vc-twitter-hide-triangle .vc-twitter-triangle {\n  display: none;\n}\n.vc-twitter-hide-triangle .vc-twitter-triangle-shadow {\n  display: none;\n}\n.vc-twitter-top-left-triangle .vc-twitter-triangle{\n  top: -10px;\n  left: 12px;\n}\n.vc-twitter-top-left-triangle .vc-twitter-triangle-shadow{\n  top: -11px;\n  left: 12px;\n}\n.vc-twitter-top-right-triangle .vc-twitter-triangle{\n  top: -10px;\n  right: 12px;\n}\n.vc-twitter-top-right-triangle .vc-twitter-triangle-shadow{\n  top: -11px;\n  right: 12px;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-twitter",class:{"vc-twitter-hide-triangle ":"hide"===e.triangle,"vc-twitter-top-left-triangle ":"top-left"===e.triangle,"vc-twitter-top-right-triangle ":"top-right"===e.triangle},style:{width:"number"==typeof e.width?e.width+"px":e.width}},[n("div",{staticClass:"vc-twitter-triangle-shadow"}),e._v(" "),n("div",{staticClass:"vc-twitter-triangle"}),e._v(" "),n("div",{staticClass:"vc-twitter-body"},[e._l(e.defaultColors,function(t,r){return n("span",{key:r,staticClass:"vc-twitter-swatch",style:{background:t,boxShadow:"0 0 4px "+(e.equal(t)?t:"transparent")},on:{click:function(n){return e.handlerClick(t)}}})}),e._v(" "),n("div",{staticClass:"vc-twitter-hash"},[e._v("#")]),e._v(" "),n("editable-input",{attrs:{label:"#",value:e.hex},on:{change:e.inputChange}}),e._v(" "),n("div",{staticClass:"vc-twitter-clear"})],2)])},i=[];r._withStripped=!0;var o={render:r,staticRenderFns:i};t.a=o}])});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationModal_vue__ = __webpack_require__(442);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34fc9245_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationModal_vue__ = __webpack_require__(1243);
function injectStyle (ssrContext) {
  __webpack_require__(1241)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34fc9245"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34fc9245_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SMSModal_vue__ = __webpack_require__(444);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_492822ae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SMSModal_vue__ = __webpack_require__(1246);
function injectStyle (ssrContext) {
  __webpack_require__(1244)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-492822ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SMSModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_492822ae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SMSModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1333));
	else if(typeof define === 'function' && define.amd)
		define(["sortablejs"], factory);
	else if(typeof exports === 'object')
		exports["vuedraggable"] = factory(require("sortablejs"));
	else
		root["vuedraggable"] = factory(root["Sortable"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE_a352__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "01f9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("2d00");
var $export = __webpack_require__("5ca1");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var $iterCreate = __webpack_require__("41a0");
var setToStringTag = __webpack_require__("7f20");
var getPrototypeOf = __webpack_require__("38fd");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "02f4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var defined = __webpack_require__("be13");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "0390":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__("02f4")(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),

/***/ "0bfb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__("cb7c");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "0d58":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("ce10");
var enumBugKeys = __webpack_require__("e11e");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "1495":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var anObject = __webpack_require__("cb7c");
var getKeys = __webpack_require__("0d58");

module.exports = __webpack_require__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "214f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("b0c5");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var fails = __webpack_require__("79e5");
var defined = __webpack_require__("be13");
var wks = __webpack_require__("2b4c");
var regexpExec = __webpack_require__("520a");

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ "230e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var document = __webpack_require__("7726").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "23c6":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("2d95");
var TAG = __webpack_require__("2b4c")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "2621":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "2aba":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var has = __webpack_require__("69a8");
var SRC = __webpack_require__("ca5a")('src');
var $toString = __webpack_require__("fa5b");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("8378").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "2aeb":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("cb7c");
var dPs = __webpack_require__("1495");
var enumBugKeys = __webpack_require__("e11e");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("230e")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("fab2").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "2b4c":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("5537")('wks');
var uid = __webpack_require__("ca5a");
var Symbol = __webpack_require__("7726").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "2d00":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "2d95":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "2fdb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__("5ca1");
var context = __webpack_require__("d2c8");
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__("5147")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "32e9":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var createDesc = __webpack_require__("4630");
module.exports = __webpack_require__("9e1e") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "38fd":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("69a8");
var toObject = __webpack_require__("4bf8");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "41a0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("2aeb");
var descriptor = __webpack_require__("4630");
var setToStringTag = __webpack_require__("7f20");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("32e9")(IteratorPrototype, __webpack_require__("2b4c")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "456d":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("4bf8");
var $keys = __webpack_require__("0d58");

__webpack_require__("5eda")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "4588":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "4630":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "4bf8":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "5147":
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),

/***/ "520a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__("0bfb");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "52a7":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "5537":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("8378");
var global = __webpack_require__("7726");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("2d00") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "5ca1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var core = __webpack_require__("8378");
var hide = __webpack_require__("32e9");
var redefine = __webpack_require__("2aba");
var ctx = __webpack_require__("9b43");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "5eda":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("5ca1");
var core = __webpack_require__("8378");
var fails = __webpack_require__("79e5");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "5f1b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__("23c6");
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),

/***/ "613b":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5537")('keys');
var uid = __webpack_require__("ca5a");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "626a":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("2d95");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "6762":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__("5ca1");
var $includes = __webpack_require__("c366")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__("9c6c")('includes');


/***/ }),

/***/ "6821":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("626a");
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "69a8":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "6a99":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("d3f4");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "7333":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("0d58");
var gOPS = __webpack_require__("2621");
var pIE = __webpack_require__("52a7");
var toObject = __webpack_require__("4bf8");
var IObject = __webpack_require__("626a");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("79e5")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "7726":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "77f1":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "79e5":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "7f20":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("86cc").f;
var has = __webpack_require__("69a8");
var TAG = __webpack_require__("2b4c")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "8378":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "84f2":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "86cc":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("cb7c");
var IE8_DOM_DEFINE = __webpack_require__("c69a");
var toPrimitive = __webpack_require__("6a99");
var dP = Object.defineProperty;

exports.f = __webpack_require__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9b43":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("d8e8");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "9c6c":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("2b4c")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("32e9")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "9def":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("4588");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "9e1e":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("79e5")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "a352":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_a352__;

/***/ }),

/***/ "a481":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("cb7c");
var toObject = __webpack_require__("4bf8");
var toLength = __webpack_require__("9def");
var toInteger = __webpack_require__("4588");
var advanceStringIndex = __webpack_require__("0390");
var regExpExec = __webpack_require__("5f1b");
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__("214f")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "aae3":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("d3f4");
var cof = __webpack_require__("2d95");
var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ "ac6a":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("cadf");
var getKeys = __webpack_require__("0d58");
var redefine = __webpack_require__("2aba");
var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var wks = __webpack_require__("2b4c");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "b0c5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__("520a");
__webpack_require__("5ca1")({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),

/***/ "be13":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "c366":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("6821");
var toLength = __webpack_require__("9def");
var toAbsoluteIndex = __webpack_require__("77f1");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "c649":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return insertNodeAt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return console; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeNode; });
/* harmony import */ var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a481");
/* harmony import */ var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__);


function getConsole() {
  if (typeof window !== "undefined") {
    return window.console;
  }

  return global.console;
}

var console = getConsole();

function cached(fn) {
  var cache = Object.create(null);
  return function cachedFn(str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
}

var regex = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(regex, function (_, c) {
    return c ? c.toUpperCase() : "";
  });
});

function removeNode(node) {
  if (node.parentElement !== null) {
    node.parentElement.removeChild(node);
  }
}

function insertNodeAt(fatherNode, node, position) {
  var refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
  fatherNode.insertBefore(node, refNode);
}


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "c69a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("9e1e") && !__webpack_require__("79e5")(function () {
  return Object.defineProperty(__webpack_require__("230e")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ca5a":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "cadf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("9c6c");
var step = __webpack_require__("d53b");
var Iterators = __webpack_require__("84f2");
var toIObject = __webpack_require__("6821");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("01f9")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "cb7c":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "ce10":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("69a8");
var toIObject = __webpack_require__("6821");
var arrayIndexOf = __webpack_require__("c366")(false);
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "d2c8":
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("aae3");
var defined = __webpack_require__("be13");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),

/***/ "d3f4":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "d53b":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "d8e8":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "e11e":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "f559":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__("5ca1");
var toLength = __webpack_require__("9def");
var context = __webpack_require__("d2c8");
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__("5147")(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "f751":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("5ca1");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("7333") });


/***/ }),

/***/ "fa5b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("5537")('native-function-to-string', Function.toString);


/***/ }),

/***/ "fab2":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7726").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var setPublicPath_i
  if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = setPublicPath_i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.assign.js
var es6_object_assign = __webpack_require__("f751");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.starts-with.js
var es6_string_starts_with = __webpack_require__("f559");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __webpack_require__("cadf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: external {"commonjs":"sortablejs","commonjs2":"sortablejs","amd":"sortablejs","root":"Sortable"}
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_ = __webpack_require__("a352");
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_);

// EXTERNAL MODULE: ./src/util/helper.js
var helper = __webpack_require__("c649");

// CONCATENATED MODULE: ./src/vuedraggable.js












function buildAttribute(object, propName, value) {
  if (value === undefined) {
    return object;
  }

  object = object || {};
  object[propName] = value;
  return object;
}

function computeVmIndex(vnodes, element) {
  return vnodes.map(function (elt) {
    return elt.elm;
  }).indexOf(element);
}

function _computeIndexes(slots, children, isTransition, footerOffset) {
  if (!slots) {
    return [];
  }

  var elmFromNodes = slots.map(function (elt) {
    return elt.elm;
  });
  var footerIndex = children.length - footerOffset;

  var rawIndexes = _toConsumableArray(children).map(function (elt, idx) {
    return idx >= footerIndex ? elmFromNodes.length : elmFromNodes.indexOf(elt);
  });

  return isTransition ? rawIndexes.filter(function (ind) {
    return ind !== -1;
  }) : rawIndexes;
}

function emit(evtName, evtData) {
  var _this = this;

  this.$nextTick(function () {
    return _this.$emit(evtName.toLowerCase(), evtData);
  });
}

function delegateAndEmit(evtName) {
  var _this2 = this;

  return function (evtData) {
    if (_this2.realList !== null) {
      _this2["onDrag" + evtName](evtData);
    }

    emit.call(_this2, evtName, evtData);
  };
}

function isTransitionName(name) {
  return ["transition-group", "TransitionGroup"].includes(name);
}

function vuedraggable_isTransition(slots) {
  if (!slots || slots.length !== 1) {
    return false;
  }

  var _slots = _slicedToArray(slots, 1),
      componentOptions = _slots[0].componentOptions;

  if (!componentOptions) {
    return false;
  }

  return isTransitionName(componentOptions.tag);
}

function getSlot(slot, scopedSlot, key) {
  return slot[key] || (scopedSlot[key] ? scopedSlot[key]() : undefined);
}

function computeChildrenAndOffsets(children, slot, scopedSlot) {
  var headerOffset = 0;
  var footerOffset = 0;
  var header = getSlot(slot, scopedSlot, "header");

  if (header) {
    headerOffset = header.length;
    children = children ? [].concat(_toConsumableArray(header), _toConsumableArray(children)) : _toConsumableArray(header);
  }

  var footer = getSlot(slot, scopedSlot, "footer");

  if (footer) {
    footerOffset = footer.length;
    children = children ? [].concat(_toConsumableArray(children), _toConsumableArray(footer)) : _toConsumableArray(footer);
  }

  return {
    children: children,
    headerOffset: headerOffset,
    footerOffset: footerOffset
  };
}

function getComponentAttributes($attrs, componentData) {
  var attributes = null;

  var update = function update(name, value) {
    attributes = buildAttribute(attributes, name, value);
  };

  var attrs = Object.keys($attrs).filter(function (key) {
    return key === "id" || key.startsWith("data-");
  }).reduce(function (res, key) {
    res[key] = $attrs[key];
    return res;
  }, {});
  update("attrs", attrs);

  if (!componentData) {
    return attributes;
  }

  var on = componentData.on,
      props = componentData.props,
      componentDataAttrs = componentData.attrs;
  update("on", on);
  update("props", props);
  Object.assign(attributes.attrs, componentDataAttrs);
  return attributes;
}

var eventsListened = ["Start", "Add", "Remove", "Update", "End"];
var eventsToEmit = ["Choose", "Unchoose", "Sort", "Filter", "Clone"];
var readonlyProperties = ["Move"].concat(eventsListened, eventsToEmit).map(function (evt) {
  return "on" + evt;
});
var draggingElement = null;
var props = {
  options: Object,
  list: {
    type: Array,
    required: false,
    default: null
  },
  value: {
    type: Array,
    required: false,
    default: null
  },
  noTransitionOnDrag: {
    type: Boolean,
    default: false
  },
  clone: {
    type: Function,
    default: function _default(original) {
      return original;
    }
  },
  element: {
    type: String,
    default: "div"
  },
  tag: {
    type: String,
    default: null
  },
  move: {
    type: Function,
    default: null
  },
  componentData: {
    type: Object,
    required: false,
    default: null
  }
};
var draggableComponent = {
  name: "draggable",
  inheritAttrs: false,
  props: props,
  data: function data() {
    return {
      transitionMode: false,
      noneFunctionalComponentMode: false
    };
  },
  render: function render(h) {
    var slots = this.$slots.default;
    this.transitionMode = vuedraggable_isTransition(slots);

    var _computeChildrenAndOf = computeChildrenAndOffsets(slots, this.$slots, this.$scopedSlots),
        children = _computeChildrenAndOf.children,
        headerOffset = _computeChildrenAndOf.headerOffset,
        footerOffset = _computeChildrenAndOf.footerOffset;

    this.headerOffset = headerOffset;
    this.footerOffset = footerOffset;
    var attributes = getComponentAttributes(this.$attrs, this.componentData);
    return h(this.getTag(), attributes, children);
  },
  created: function created() {
    if (this.list !== null && this.value !== null) {
      helper["b" /* console */].error("Value and list props are mutually exclusive! Please set one or another.");
    }

    if (this.element !== "div") {
      helper["b" /* console */].warn("Element props is deprecated please use tag props instead. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#element-props");
    }

    if (this.options !== undefined) {
      helper["b" /* console */].warn("Options props is deprecated, add sortable options directly as vue.draggable item, or use v-bind. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#options-props");
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.noneFunctionalComponentMode = this.getTag().toLowerCase() !== this.$el.nodeName.toLowerCase() && !this.getIsFunctional();

    if (this.noneFunctionalComponentMode && this.transitionMode) {
      throw new Error("Transition-group inside component is not supported. Please alter tag value or remove transition-group. Current tag value: ".concat(this.getTag()));
    }

    var optionsAdded = {};
    eventsListened.forEach(function (elt) {
      optionsAdded["on" + elt] = delegateAndEmit.call(_this3, elt);
    });
    eventsToEmit.forEach(function (elt) {
      optionsAdded["on" + elt] = emit.bind(_this3, elt);
    });
    var attributes = Object.keys(this.$attrs).reduce(function (res, key) {
      res[Object(helper["a" /* camelize */])(key)] = _this3.$attrs[key];
      return res;
    }, {});
    var options = Object.assign({}, this.options, attributes, optionsAdded, {
      onMove: function onMove(evt, originalEvent) {
        return _this3.onDragMove(evt, originalEvent);
      }
    });
    !("draggable" in options) && (options.draggable = ">*");
    this._sortable = new external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default.a(this.rootContainer, options);
    this.computeIndexes();
  },
  beforeDestroy: function beforeDestroy() {
    if (this._sortable !== undefined) this._sortable.destroy();
  },
  computed: {
    rootContainer: function rootContainer() {
      return this.transitionMode ? this.$el.children[0] : this.$el;
    },
    realList: function realList() {
      return this.list ? this.list : this.value;
    }
  },
  watch: {
    options: {
      handler: function handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    $attrs: {
      handler: function handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    realList: function realList() {
      this.computeIndexes();
    }
  },
  methods: {
    getIsFunctional: function getIsFunctional() {
      var fnOptions = this._vnode.fnOptions;
      return fnOptions && fnOptions.functional;
    },
    getTag: function getTag() {
      return this.tag || this.element;
    },
    updateOptions: function updateOptions(newOptionValue) {
      for (var property in newOptionValue) {
        var value = Object(helper["a" /* camelize */])(property);

        if (readonlyProperties.indexOf(value) === -1) {
          this._sortable.option(value, newOptionValue[property]);
        }
      }
    },
    getChildrenNodes: function getChildrenNodes() {
      if (this.noneFunctionalComponentMode) {
        return this.$children[0].$slots.default;
      }

      var rawNodes = this.$slots.default;
      return this.transitionMode ? rawNodes[0].child.$slots.default : rawNodes;
    },
    computeIndexes: function computeIndexes() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.visibleIndexes = _computeIndexes(_this4.getChildrenNodes(), _this4.rootContainer.children, _this4.transitionMode, _this4.footerOffset);
      });
    },
    getUnderlyingVm: function getUnderlyingVm(htmlElt) {
      var index = computeVmIndex(this.getChildrenNodes() || [], htmlElt);

      if (index === -1) {
        //Edge case during move callback: related element might be
        //an element different from collection
        return null;
      }

      var element = this.realList[index];
      return {
        index: index,
        element: element
      };
    },
    getUnderlyingPotencialDraggableComponent: function getUnderlyingPotencialDraggableComponent(_ref) {
      var vue = _ref.__vue__;

      if (!vue || !vue.$options || !isTransitionName(vue.$options._componentTag)) {
        if (!("realList" in vue) && vue.$children.length === 1 && "realList" in vue.$children[0]) return vue.$children[0];
        return vue;
      }

      return vue.$parent;
    },
    emitChanges: function emitChanges(evt) {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.$emit("change", evt);
      });
    },
    alterList: function alterList(onList) {
      if (this.list) {
        onList(this.list);
        return;
      }

      var newList = _toConsumableArray(this.value);

      onList(newList);
      this.$emit("input", newList);
    },
    spliceList: function spliceList() {
      var _arguments = arguments;

      var spliceList = function spliceList(list) {
        return list.splice.apply(list, _toConsumableArray(_arguments));
      };

      this.alterList(spliceList);
    },
    updatePosition: function updatePosition(oldIndex, newIndex) {
      var updatePosition = function updatePosition(list) {
        return list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
      };

      this.alterList(updatePosition);
    },
    getRelatedContextFromMoveEvent: function getRelatedContextFromMoveEvent(_ref2) {
      var to = _ref2.to,
          related = _ref2.related;
      var component = this.getUnderlyingPotencialDraggableComponent(to);

      if (!component) {
        return {
          component: component
        };
      }

      var list = component.realList;
      var context = {
        list: list,
        component: component
      };

      if (to !== related && list && component.getUnderlyingVm) {
        var destination = component.getUnderlyingVm(related);

        if (destination) {
          return Object.assign(destination, context);
        }
      }

      return context;
    },
    getVmIndex: function getVmIndex(domIndex) {
      var indexes = this.visibleIndexes;
      var numberIndexes = indexes.length;
      return domIndex > numberIndexes - 1 ? numberIndexes : indexes[domIndex];
    },
    getComponent: function getComponent() {
      return this.$slots.default[0].componentInstance;
    },
    resetTransitionData: function resetTransitionData(index) {
      if (!this.noTransitionOnDrag || !this.transitionMode) {
        return;
      }

      var nodes = this.getChildrenNodes();
      nodes[index].data = null;
      var transitionContainer = this.getComponent();
      transitionContainer.children = [];
      transitionContainer.kept = undefined;
    },
    onDragStart: function onDragStart(evt) {
      this.context = this.getUnderlyingVm(evt.item);
      evt.item._underlying_vm_ = this.clone(this.context.element);
      draggingElement = evt.item;
    },
    onDragAdd: function onDragAdd(evt) {
      var element = evt.item._underlying_vm_;

      if (element === undefined) {
        return;
      }

      Object(helper["d" /* removeNode */])(evt.item);
      var newIndex = this.getVmIndex(evt.newIndex);
      this.spliceList(newIndex, 0, element);
      this.computeIndexes();
      var added = {
        element: element,
        newIndex: newIndex
      };
      this.emitChanges({
        added: added
      });
    },
    onDragRemove: function onDragRemove(evt) {
      Object(helper["c" /* insertNodeAt */])(this.rootContainer, evt.item, evt.oldIndex);

      if (evt.pullMode === "clone") {
        Object(helper["d" /* removeNode */])(evt.clone);
        return;
      }

      var oldIndex = this.context.index;
      this.spliceList(oldIndex, 1);
      var removed = {
        element: this.context.element,
        oldIndex: oldIndex
      };
      this.resetTransitionData(oldIndex);
      this.emitChanges({
        removed: removed
      });
    },
    onDragUpdate: function onDragUpdate(evt) {
      Object(helper["d" /* removeNode */])(evt.item);
      Object(helper["c" /* insertNodeAt */])(evt.from, evt.item, evt.oldIndex);
      var oldIndex = this.context.index;
      var newIndex = this.getVmIndex(evt.newIndex);
      this.updatePosition(oldIndex, newIndex);
      var moved = {
        element: this.context.element,
        oldIndex: oldIndex,
        newIndex: newIndex
      };
      this.emitChanges({
        moved: moved
      });
    },
    updateProperty: function updateProperty(evt, propertyName) {
      evt.hasOwnProperty(propertyName) && (evt[propertyName] += this.headerOffset);
    },
    computeFutureIndex: function computeFutureIndex(relatedContext, evt) {
      if (!relatedContext.element) {
        return 0;
      }

      var domChildren = _toConsumableArray(evt.to.children).filter(function (el) {
        return el.style["display"] !== "none";
      });

      var currentDOMIndex = domChildren.indexOf(evt.related);
      var currentIndex = relatedContext.component.getVmIndex(currentDOMIndex);
      var draggedInList = domChildren.indexOf(draggingElement) !== -1;
      return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
    },
    onDragMove: function onDragMove(evt, originalEvent) {
      var onMove = this.move;

      if (!onMove || !this.realList) {
        return true;
      }

      var relatedContext = this.getRelatedContextFromMoveEvent(evt);
      var draggedContext = this.context;
      var futureIndex = this.computeFutureIndex(relatedContext, evt);
      Object.assign(draggedContext, {
        futureIndex: futureIndex
      });
      var sendEvt = Object.assign({}, evt, {
        relatedContext: relatedContext,
        draggedContext: draggedContext
      });
      return onMove(sendEvt, originalEvent);
    },
    onDragEnd: function onDragEnd() {
      this.computeIndexes();
      draggingElement = null;
    }
  }
};

if (typeof window !== "undefined" && "Vue" in window) {
  window.Vue.component("draggable", draggableComponent);
}

/* harmony default export */ var vuedraggable = (draggableComponent);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (vuedraggable);



/***/ })

/******/ })["default"];
});
//# sourceMappingURL=vuedraggable.umd.js.map

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 80 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * Vue.js v2.6.14
 * (c) 2014-2021 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i], vm);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  var haveExpectedTypes = expectedTypes.some(function (t) { return t; });
  if (!valid && haveExpectedTypes) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;

function assertType (value, type, vm) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    try {
      valid = value instanceof type;
    } catch (e) {
      warn('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
      valid = false;
    }
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

var functionTypeCheckRE = /^\s*function (\w+)/;

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(functionTypeCheckRE);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  // check if we need to specify expected value
  if (
    expectedTypes.length === 1 &&
    isExplicable(expectedType) &&
    isExplicable(typeof value) &&
    !isBoolean(expectedType, receivedType)
  ) {
    message += " with value " + (styleValue(value, expectedType));
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + (styleValue(value, receivedType)) + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

var EXPLICABLE_TYPES = ['string', 'number', 'boolean'];
function isExplicable (value) {
  return EXPLICABLE_TYPES.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    var vnode = res && res[0];
    return res && (
      !vnode ||
      (res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode)) // #9658, #10391
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallbackRender,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) {
    // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn('slot v-bind without argument expects an Object', this);
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes =
      scopedSlotFn(props) ||
      (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
  } else {
    nodes =
      this.$slots[name] ||
      (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
  return eventKeyCode === undefined
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  // we know it's MountedComponentVNode but flow doesn't
  vnode,
  // activeInstance in lifecycle state
  parent
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key) ||
    (!newScopedSlots && vm.$scopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        var info = "callback for watcher \"" + (this.expression) + "\"";
        invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      } else if (vm.$options.methods && key in vm.$options.methods) {
        warn(("The computed property \"" + key + "\" is already defined as a method."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      var info = "callback for immediate watcher \"" + (watcher.expression) + "\"";
      pushTarget();
      invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
      popTarget();
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */





function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var entry = cache[key];
    if (entry) {
      var name = entry.name;
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var entry = cache[key];
  if (entry && (!current || entry.tag !== current.tag)) {
    entry.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  methods: {
    cacheVNode: function cacheVNode() {
      var ref = this;
      var cache = ref.cache;
      var keys = ref.keys;
      var vnodeToCache = ref.vnodeToCache;
      var keyToCache = ref.keyToCache;
      if (vnodeToCache) {
        var tag = vnodeToCache.tag;
        var componentInstance = vnodeToCache.componentInstance;
        var componentOptions = vnodeToCache.componentOptions;
        cache[keyToCache] = {
          name: getComponentName(componentOptions),
          tag: tag,
          componentInstance: componentInstance,
        };
        keys.push(keyToCache);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
        this.vnodeToCache = null;
      }
    }
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.cacheVNode();
    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  updated: function updated () {
    this.cacheVNode();
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        // delay setting the cache until update
        this.vnodeToCache = vnode;
        this.keyToCache = key;
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.14';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key &&
    a.asyncFactory === b.asyncFactory && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur, vnode.data.pre);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value, isInPre) {
  if (isInPre || el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /[ \f\t\r\n]+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!(
    el.component ||
    el.attrsMap[':is'] ||
    el.attrsMap['v-bind:is'] ||
    !(el.attrsMap.is ? isReservedTag(el.attrsMap.is) : isReservedTag(el.tag))
  ); };
  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + ".apply(null, arguments)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ").apply(null, arguments)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  // fix #11483, Root level <script> tags should not be rendered.
  var code = ast ? (ast.tag === 'script' ? 'null' : genElement(ast, state)) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? (",function(){return " + children + "}") : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["default"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(22)))

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(33).f;
var has = __webpack_require__(54);
var TAG = __webpack_require__(19)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(717), __esModule: true };

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hasStringTagBug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isIE11; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasObjectTag_js__ = __webpack_require__(725);



// In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
// In IE 11, the most common among them, this problem also applies to
// `Map`, `WeakMap` and `Set`.
var hasStringTagBug = (
      __WEBPACK_IMPORTED_MODULE_0__setup_js__["s" /* supportsDataView */] && Object(__WEBPACK_IMPORTED_MODULE_1__hasObjectTag_js__["a" /* default */])(new DataView(new ArrayBuffer(8)))
    ),
    isIE11 = (typeof Map !== 'undefined' && Object(__WEBPACK_IMPORTED_MODULE_1__hasObjectTag_js__["a" /* default */])(new Map));


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = allKeys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__collectNonEnumProps_js__ = __webpack_require__(186);




// Retrieve all the enumerable property names of an object.
function allKeys(obj) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(obj)) return [];
  var keys = [];
  for (var key in obj) keys.push(key);
  // Ahem, IE < 9.
  if (__WEBPACK_IMPORTED_MODULE_1__setup_js__["h" /* hasEnumBug */]) Object(__WEBPACK_IMPORTED_MODULE_2__collectNonEnumProps_js__["a" /* default */])(obj, keys);
  return keys;
}


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPath_js__ = __webpack_require__(194);



// Internal wrapper for `_.toPath` to enable minification.
// Similar to `cb` for `_.iteratee`.
function toPath(path) {
  return __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].toPath(path);
}


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = optimizeCb;
// Internal function that returns an efficient (for current engines) version
// of the passed-in callback, to be repeatedly applied in other Underscore
// functions.
function optimizeCb(func, context, argCount) {
  if (context === void 0) return func;
  switch (argCount == null ? 3 : argCount) {
    case 1: return function(value) {
      return func.call(context, value);
    };
    // The 2-argument case is omitted because we’re not using it.
    case 3: return function(value, index, collection) {
      return func.call(context, value, index, collection);
    };
    case 4: return function(accumulator, value, index, collection) {
      return func.call(context, accumulator, value, index, collection);
    };
  }
  return function() {
    return func.apply(context, arguments);
  };
}


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = filter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each_js__ = __webpack_require__(59);



// Return all the elements that pass a truth test.
function filter(obj, predicate, context) {
  var results = [];
  predicate = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(predicate, context);
  Object(__WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */])(obj, function(value, index, list) {
    if (predicate(value, index, list)) results.push(value);
  });
  return results;
}


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__values_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__indexOf_js__ = __webpack_require__(210);




// Determine if the array or object contains a given item (using `===`).
function contains(obj, item, fromIndex, guard) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj)) obj = Object(__WEBPACK_IMPORTED_MODULE_1__values_js__["a" /* default */])(obj);
  if (typeof fromIndex != 'number' || guard) fromIndex = 0;
  return Object(__WEBPACK_IMPORTED_MODULE_2__indexOf_js__["a" /* default */])(obj, item, fromIndex) >= 0;
}


/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = {
  'af': { 'code': 'af', 'name': 'Afghanistan (‫افغانستان‬‎)', 'dialCode': 93, 'phoneFormat': '070 123 4567' },
  'al': { 'code': 'al', 'name': 'Albania (Shqipëri)', 'dialCode': 355, 'phoneFormat': '066 123 4567' },
  'dz': { 'code': 'dz', 'name': 'Algeria (‫الجزائر‬‎)', 'dialCode': 213, 'phoneFormat': '0551 23 45 67' },
  'as': { 'code': 'as', 'name': 'American Samoa', 'dialCode': 1684, 'phoneFormat': '(684) 733-1234' },
  'ad': { 'code': 'ad', 'name': 'Andorra', 'dialCode': 376, 'phoneFormat': '312 345' },
  'ao': { 'code': 'ao', 'name': 'Angola', 'dialCode': 244, 'phoneFormat': '923 123 456' },
  'ai': { 'code': 'ai', 'name': 'Anguilla', 'dialCode': 1264, 'phoneFormat': '(264) 235-1234' },
  'ag': { 'code': 'ag', 'name': 'Antigua and Barbuda', 'dialCode': 1268, 'phoneFormat': '(268) 464-1234' },
  'ar': { 'code': 'ar', 'name': 'Argentina', 'dialCode': 54, 'phoneFormat': '011 15-2345-6789' },
  'am': { 'code': 'am', 'name': 'Armenia (Հայաստան)', 'dialCode': 374, 'phoneFormat': '077 123456' },
  'aw': { 'code': 'aw', 'name': 'Aruba', 'dialCode': 297, 'phoneFormat': '560 1234' },
  'au': { 'code': 'au', 'name': 'Australia', 'dialCode': 61, 'phoneFormat': '0412 345 678' },
  'at': { 'code': 'at', 'name': 'Austria (Österreich)', 'dialCode': 43, 'phoneFormat': '0664 123456' },
  'az': { 'code': 'az', 'name': 'Azerbaijan (Azərbaycan)', 'dialCode': 994, 'phoneFormat': '040 123 45 67' },
  'bs': { 'code': 'bs', 'name': 'Bahamas', 'dialCode': 1242, 'phoneFormat': '(242) 359-1234' },
  'bh': { 'code': 'bh', 'name': 'Bahrain (‫البحرين‬‎)', 'dialCode': 973, 'phoneFormat': '3600 1234' },
  'bd': { 'code': 'bd', 'name': 'Bangladesh (বাংলাদেশ)', 'dialCode': 880, 'phoneFormat': '01812-345678' },
  'bb': { 'code': 'bb', 'name': 'Barbados', 'dialCode': 1246, 'phoneFormat': '(246) 250-1234' },
  'by': { 'code': 'by', 'name': 'Belarus (Беларусь)', 'dialCode': 375, 'phoneFormat': '8 029 491-19-11' },
  'be': { 'code': 'be', 'name': 'Belgium (België)', 'dialCode': 32, 'phoneFormat': '0470 12 34 56' },
  'bz': { 'code': 'bz', 'name': 'Belize', 'dialCode': 501, 'phoneFormat': '622-1234' },
  'bj': { 'code': 'bj', 'name': 'Benin (Bénin)', 'dialCode': 229, 'phoneFormat': '90 01 12 34' },
  'bm': { 'code': 'bm', 'name': 'Bermuda', 'dialCode': 1441, 'phoneFormat': '(441) 370-1234' },
  'bt': { 'code': 'bt', 'name': 'Bhutan (འབྲུག)', 'dialCode': 975, 'phoneFormat': '17 12 34 56' },
  'bo': { 'code': 'bo', 'name': 'Bolivia', 'dialCode': 591, 'phoneFormat': '71234567' },
  'ba': { 'code': 'ba', 'name': 'Bosnia and Herzegovina (Босна и Херцеговина)', 'dialCode': 387, 'phoneFormat': '061 123 456' },
  'bw': { 'code': 'bw', 'name': 'Botswana', 'dialCode': 267, 'phoneFormat': '71 123 456' },
  'br': { 'code': 'br', 'name': 'Brazil (Brasil)', 'dialCode': 55, 'phoneFormat': '(11) 96123-4567' },
  'io': { 'code': 'io', 'name': 'British Indian Ocean Territory', 'dialCode': 246, 'phoneFormat': '380 1234' },
  'vg': { 'code': 'vg', 'name': 'British Virgin Islands', 'dialCode': 1284, 'phoneFormat': '(284) 300-1234' },
  'bn': { 'code': 'bn', 'name': 'Brunei', 'dialCode': 673, 'phoneFormat': '712 3456' },
  'bg': { 'code': 'bg', 'name': 'Bulgaria (България)', 'dialCode': 359, 'phoneFormat': '048 123 456' },
  'bf': { 'code': 'bf', 'name': 'Burkina Faso', 'dialCode': 226, 'phoneFormat': '70 12 34 56' },
  'bi': { 'code': 'bi', 'name': 'Burundi (Uburundi)', 'dialCode': 257, 'phoneFormat': '79 56 12 34' },
  'kh': { 'code': 'kh', 'name': 'Cambodia (កម្ពុជា)', 'dialCode': 855, 'phoneFormat': '091 234 567' },
  'cm': { 'code': 'cm', 'name': 'Cameroon (Cameroun)', 'dialCode': 237, 'phoneFormat': '6 71 23 45 67' },
  'ca': { 'code': 'ca', 'name': 'Canada', 'dialCode': 1, 'phoneFormat': '(204) 234-5678' },
  'cv': { 'code': 'cv', 'name': 'Cape Verde (Kabu Verdi)', 'dialCode': 238, 'phoneFormat': '991 12 34' },
  'bq': { 'code': 'bq', 'name': 'Caribbean Netherlands', 'dialCode': 599, 'phoneFormat': '318 1234' },
  'ky': { 'code': 'ky', 'name': 'Cayman Islands', 'dialCode': 1345, 'phoneFormat': '(345) 323-1234' },
  'cf': { 'code': 'cf', 'name': 'Central African Republic (République centrafricaine)', 'dialCode': 236, 'phoneFormat': '70 01 23 45' },
  'td': { 'code': 'td', 'name': 'Chad (Tchad)', 'dialCode': 235, 'phoneFormat': '63 01 23 45' },
  'cl': { 'code': 'cl', 'name': 'Chile', 'dialCode': 56, 'phoneFormat': '09 6123 4567' },
  'cn': { 'code': 'cn', 'name': 'China (中国)', 'dialCode': 86, 'phoneFormat': '131 2345 6789' },
  'cx': { 'code': 'cx', 'name': 'Christmas Island', 'dialCode': 61, 'phoneFormat': '0412 345 678' },
  'cc': { 'code': 'cc', 'name': 'Cocos (Keeling) Islands', 'dialCode': 61, 'phoneFormat': '0412 345 678' },
  'co': { 'code': 'co', 'name': 'Colombia', 'dialCode': 57, 'phoneFormat': '321 1234567' },
  'km': { 'code': 'km', 'name': 'Comoros (‫جزر القمر‬‎)', 'dialCode': 269, 'phoneFormat': '321 23 45' },
  'cd': { 'code': 'cd', 'name': 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)', 'dialCode': 243, 'phoneFormat': '0991 234 567' },
  'cg': { 'code': 'cg', 'name': 'Congo (Republic) (Congo-Brazzaville)', 'dialCode': 242, 'phoneFormat': '06 123 4567' },
  'ck': { 'code': 'ck', 'name': 'Cook Islands', 'dialCode': 682, 'phoneFormat': '71 234' },
  'cr': { 'code': 'cr', 'name': 'Costa Rica', 'dialCode': 506, 'phoneFormat': '8312 3456' },
  'ci': { 'code': 'ci', 'name': 'Côte d’Ivoire', 'dialCode': 225, 'phoneFormat': '01 23 45 67' },
  'hr': { 'code': 'hr', 'name': 'Croatia (Hrvatska)', 'dialCode': 385, 'phoneFormat': '091 234 5678' },
  'cu': { 'code': 'cu', 'name': 'Cuba', 'dialCode': 53, 'phoneFormat': '05 1234567' },
  'cw': { 'code': 'cw', 'name': 'Curaçao', 'dialCode': 599, 'phoneFormat': '9 518 1234' },
  'cy': { 'code': 'cy', 'name': 'Cyprus (Κύπρος)', 'dialCode': 357, 'phoneFormat': '96 123456' },
  'cz': { 'code': 'cz', 'name': 'Czech Republic (Česká republika)', 'dialCode': 420, 'phoneFormat': '601 123 456' },
  'dk': { 'code': 'dk', 'name': 'Denmark (Danmark)', 'dialCode': 45, 'phoneFormat': '20 12 34 56' },
  'dj': { 'code': 'dj', 'name': 'Djibouti', 'dialCode': 253, 'phoneFormat': '77 83 10 01' },
  'dm': { 'code': 'dm', 'name': 'Dominica', 'dialCode': 1767, 'phoneFormat': '(767) 225-1234' },
  'do': { 'code': 'do', 'name': 'Dominican Republic (República Dominicana)', 'dialCode': 1, 'phoneFormat': '(809) 234-5678' },
  'ec': { 'code': 'ec', 'name': 'Ecuador', 'dialCode': 593, 'phoneFormat': '099 123 4567' },
  'eg': { 'code': 'eg', 'name': 'Egypt (‫مصر‬‎)', 'dialCode': 20, 'phoneFormat': '0100 123 4567' },
  'sv': { 'code': 'sv', 'name': 'El Salvador', 'dialCode': 503, 'phoneFormat': '7012 3456' },
  'gq': { 'code': 'gq', 'name': 'Equatorial Guinea (Guinea Ecuatorial)', 'dialCode': 240, 'phoneFormat': '222 123 456' },
  'er': { 'code': 'er', 'name': 'Eritrea', 'dialCode': 291, 'phoneFormat': '07 123 456' },
  'ee': { 'code': 'ee', 'name': 'Estonia (Eesti)', 'dialCode': 372, 'phoneFormat': '5123 4567' },
  'et': { 'code': 'et', 'name': 'Ethiopia', 'dialCode': 251, 'phoneFormat': '091 123 4567' },
  'fk': { 'code': 'fk', 'name': 'Falkland Islands (Islas Malvinas)', 'dialCode': 500, 'phoneFormat': '51234' },
  'fo': { 'code': 'fo', 'name': 'Faroe Islands (Føroyar)', 'dialCode': 298, 'phoneFormat': '211234' },
  'fj': { 'code': 'fj', 'name': 'Fiji', 'dialCode': 679, 'phoneFormat': '701 2345' },
  'fi': { 'code': 'fi', 'name': 'Finland (Suomi)', 'dialCode': 358, 'phoneFormat': '041 2345678' },
  'fr': { 'code': 'fr', 'name': 'France', 'dialCode': 33, 'phoneFormat': '06 12 34 56 78' },
  'gf': { 'code': 'gf', 'name': 'French Guiana (Guyane française)', 'dialCode': 594, 'phoneFormat': '0694 20 12 34' },
  'pf': { 'code': 'pf', 'name': 'French Polynesia (Polynésie française)', 'dialCode': 689, 'phoneFormat': '87 12 34 56' },
  'ga': { 'code': 'ga', 'name': 'Gabon', 'dialCode': 241, 'phoneFormat': '06 03 12 34' },
  'gm': { 'code': 'gm', 'name': 'Gambia', 'dialCode': 220, 'phoneFormat': '301 2345' },
  'ge': { 'code': 'ge', 'name': 'Georgia (საქართველო)', 'dialCode': 995, 'phoneFormat': '555 12 34 56' },
  'de': { 'code': 'de', 'name': 'Germany (Deutschland)', 'dialCode': 49, 'phoneFormat': '01512 3456789' },
  'gh': { 'code': 'gh', 'name': 'Ghana (Gaana)', 'dialCode': 233, 'phoneFormat': '023 123 4567' },
  'gi': { 'code': 'gi', 'name': 'Gibraltar', 'dialCode': 350, 'phoneFormat': '57123456' },
  'gr': { 'code': 'gr', 'name': 'Greece (Ελλάδα)', 'dialCode': 30, 'phoneFormat': '691 234 5678' },
  'gl': { 'code': 'gl', 'name': 'Greenland (Kalaallit Nunaat)', 'dialCode': 299, 'phoneFormat': '22 12 34' },
  'gd': { 'code': 'gd', 'name': 'Grenada', 'dialCode': 1473, 'phoneFormat': '(473) 403-1234' },
  'gp': { 'code': 'gp', 'name': 'Guadeloupe', 'dialCode': 590, 'phoneFormat': '0690 30-1234' },
  'gu': { 'code': 'gu', 'name': 'Guam', 'dialCode': 1671, 'phoneFormat': '(671) 300-1234' },
  'gt': { 'code': 'gt', 'name': 'Guatemala', 'dialCode': 502, 'phoneFormat': '5123 4567' },
  'gg': { 'code': 'gg', 'name': 'Guernsey', 'dialCode': 44, 'phoneFormat': '07781 123456' },
  'gn': { 'code': 'gn', 'name': 'Guinea (Guinée)', 'dialCode': 224, 'phoneFormat': '601 12 34 56' },
  'gw': { 'code': 'gw', 'name': 'Guinea-Bissau (Guiné Bissau)', 'dialCode': 245, 'phoneFormat': '955 012 345' },
  'gy': { 'code': 'gy', 'name': 'Guyana', 'dialCode': 592, 'phoneFormat': '609 1234' },
  'ht': { 'code': 'ht', 'name': 'Haiti', 'dialCode': 509, 'phoneFormat': '34 10 1234' },
  'hn': { 'code': 'hn', 'name': 'Honduras', 'dialCode': 504, 'phoneFormat': '9123-4567' },
  'hk': { 'code': 'hk', 'name': 'Hong Kong (香港)', 'dialCode': 852, 'phoneFormat': '5123 4567' },
  'hu': { 'code': 'hu', 'name': 'Hungary (Magyarország)', 'dialCode': 36, 'phoneFormat': '(20) 123 4567' },
  'is': { 'code': 'is', 'name': 'Iceland (Ísland)', 'dialCode': 354, 'phoneFormat': '611 1234' },
  'in': { 'code': 'in', 'name': 'India (भारत)', 'dialCode': 91, 'phoneFormat': '099876 54321' },
  'id': { 'code': 'id', 'name': 'Indonesia', 'dialCode': 62, 'phoneFormat': '0812-345-678' },
  'ir': { 'code': 'ir', 'name': 'Iran (‫ایران‬‎)', 'dialCode': 98, 'phoneFormat': '0912 345 6789' },
  'iq': { 'code': 'iq', 'name': 'Iraq (‫العراق‬‎)', 'dialCode': 964, 'phoneFormat': '0791 234 5678' },
  'ie': { 'code': 'ie', 'name': 'Ireland', 'dialCode': 353, 'phoneFormat': '085 012 3456' },
  'im': { 'code': 'im', 'name': 'Isle of Man', 'dialCode': 44, 'phoneFormat': '07924 123456' },
  'il': { 'code': 'il', 'name': 'Israel (‫ישראל‬‎)', 'dialCode': 972, 'phoneFormat': '050-123-4567' },
  'it': { 'code': 'it', 'name': 'Italy (Italia)', 'dialCode': 39, 'phoneFormat': '312 345 6789' },
  'jm': { 'code': 'jm', 'name': 'Jamaica', 'dialCode': 1876, 'phoneFormat': '(876) 210-1234' },
  'jp': { 'code': 'jp', 'name': 'Japan (日本)', 'dialCode': 81, 'phoneFormat': '090-1234-5678' },
  'je': { 'code': 'je', 'name': 'Jersey', 'dialCode': 44, 'phoneFormat': '07797 123456' },
  'jo': { 'code': 'jo', 'name': 'Jordan (‫الأردن‬‎)', 'dialCode': 962, 'phoneFormat': '07 9012 3456' },
  'kz': { 'code': 'kz', 'name': 'Kazakhstan (Казахстан)', 'dialCode': 7, 'phoneFormat': '8 (771) 000 9998' },
  'ke': { 'code': 'ke', 'name': 'Kenya', 'dialCode': 254, 'phoneFormat': '0712 123456' },
  'ki': { 'code': 'ki', 'name': 'Kiribati', 'dialCode': 686, 'phoneFormat': '72012345' },
  'xk': { 'code': 'xk', 'name': 'Kosovo', 'dialCode': 383, 'phoneFormat': '' },
  'kw': { 'code': 'kw', 'name': 'Kuwait (‫الكويت‬‎)', 'dialCode': 965, 'phoneFormat': '500 12345' },
  'kg': { 'code': 'kg', 'name': 'Kyrgyzstan (Кыргызстан)', 'dialCode': 996, 'phoneFormat': '0700 123 456' },
  'la': { 'code': 'la', 'name': 'Laos (ລາວ)', 'dialCode': 856, 'phoneFormat': '020 23 123 456' },
  'lv': { 'code': 'lv', 'name': 'Latvia (Latvija)', 'dialCode': 371, 'phoneFormat': '21 234 567' },
  'lb': { 'code': 'lb', 'name': 'Lebanon (‫لبنان‬‎)', 'dialCode': 961, 'phoneFormat': '71 123 456' },
  'ls': { 'code': 'ls', 'name': 'Lesotho', 'dialCode': 266, 'phoneFormat': '5012 3456' },
  'lr': { 'code': 'lr', 'name': 'Liberia', 'dialCode': 231, 'phoneFormat': '077 012 3456' },
  'ly': { 'code': 'ly', 'name': 'Libya (‫ليبيا‬‎)', 'dialCode': 218, 'phoneFormat': '091-2345678' },
  'li': { 'code': 'li', 'name': 'Liechtenstein', 'dialCode': 423, 'phoneFormat': '660 234 567' },
  'lt': { 'code': 'lt', 'name': 'Lithuania (Lietuva)', 'dialCode': 370, 'phoneFormat': '(8-612) 34567' },
  'lu': { 'code': 'lu', 'name': 'Luxembourg', 'dialCode': 352, 'phoneFormat': '628 123 456' },
  'mo': { 'code': 'mo', 'name': 'Macau (澳門)', 'dialCode': 853, 'phoneFormat': '6612 3456' },
  'mk': { 'code': 'mk', 'name': 'Macedonia (FYROM) (Македонија)', 'dialCode': 389, 'phoneFormat': '072 345 678' },
  'mg': { 'code': 'mg', 'name': 'Madagascar (Madagasikara)', 'dialCode': 261, 'phoneFormat': '032 12 345 67' },
  'mw': { 'code': 'mw', 'name': 'Malawi', 'dialCode': 265, 'phoneFormat': '0991 23 45 67' },
  'my': { 'code': 'my', 'name': 'Malaysia', 'dialCode': 60, 'phoneFormat': '012-345 6789' },
  'mv': { 'code': 'mv', 'name': 'Maldives', 'dialCode': 960, 'phoneFormat': '771-2345' },
  'ml': { 'code': 'ml', 'name': 'Mali', 'dialCode': 223, 'phoneFormat': '65 01 23 45' },
  'mt': { 'code': 'mt', 'name': 'Malta', 'dialCode': 356, 'phoneFormat': '9696 1234' },
  'mh': { 'code': 'mh', 'name': 'Marshall Islands', 'dialCode': 692, 'phoneFormat': '235-1234' },
  'mq': { 'code': 'mq', 'name': 'Martinique', 'dialCode': 596, 'phoneFormat': '0696 20 12 34' },
  'mr': { 'code': 'mr', 'name': 'Mauritania (‫موريتانيا‬‎)', 'dialCode': 222, 'phoneFormat': '22 12 34 56' },
  'mu': { 'code': 'mu', 'name': 'Mauritius (Moris)', 'dialCode': 230, 'phoneFormat': '5251 2345' },
  'yt': { 'code': 'yt', 'name': 'Mayotte', 'dialCode': 262, 'phoneFormat': '0639 12 34 56' },
  'mx': { 'code': 'mx', 'name': 'Mexico (México)', 'dialCode': 52, 'phoneFormat': '044 222 123 4567' },
  'fm': { 'code': 'fm', 'name': 'Micronesia', 'dialCode': 691, 'phoneFormat': '350 1234' },
  'md': { 'code': 'md', 'name': 'Moldova (Republica Moldova)', 'dialCode': 373, 'phoneFormat': '0621 12 345' },
  'mc': { 'code': 'mc', 'name': 'Monaco', 'dialCode': 377, 'phoneFormat': '06 12 34 56 78' },
  'mn': { 'code': 'mn', 'name': 'Mongolia (Монгол)', 'dialCode': 976, 'phoneFormat': '8812 3456' },
  'me': { 'code': 'me', 'name': 'Montenegro (Crna Gora)', 'dialCode': 382, 'phoneFormat': '067 622 901' },
  'ms': { 'code': 'ms', 'name': 'Montserrat', 'dialCode': 1664, 'phoneFormat': '(664) 492-3456' },
  'ma': { 'code': 'ma', 'name': 'Morocco (‫المغرب‬‎)', 'dialCode': 212, 'phoneFormat': '0650-123456' },
  'mz': { 'code': 'mz', 'name': 'Mozambique (Moçambique)', 'dialCode': 258, 'phoneFormat': '82 123 4567' },
  'mm': { 'code': 'mm', 'name': 'Myanmar (Burma) (မြန်မာ)', 'dialCode': 95, 'phoneFormat': '09 212 3456' },
  'na': { 'code': 'na', 'name': 'Namibia (Namibië)', 'dialCode': 264, 'phoneFormat': '081 123 4567' },
  'nr': { 'code': 'nr', 'name': 'Nauru', 'dialCode': 674, 'phoneFormat': '555 1234' },
  'np': { 'code': 'np', 'name': 'Nepal (नेपाल)', 'dialCode': 977, 'phoneFormat': '984-1234567' },
  'nl': { 'code': 'nl', 'name': 'Netherlands (Nederland)', 'dialCode': 31, 'phoneFormat': '06 12345678' },
  'nc': { 'code': 'nc', 'name': 'New Caledonia (Nouvelle-Calédonie)', 'dialCode': 687, 'phoneFormat': '75.12.34' },
  'nz': { 'code': 'nz', 'name': 'New Zealand', 'dialCode': 64, 'phoneFormat': '021 123 4567' },
  'ni': { 'code': 'ni', 'name': 'Nicaragua', 'dialCode': 505, 'phoneFormat': '8123 4567' },
  'ne': { 'code': 'ne', 'name': 'Niger (Nijar)', 'dialCode': 227, 'phoneFormat': '93 12 34 56' },
  'ng': { 'code': 'ng', 'name': 'Nigeria', 'dialCode': 234, 'phoneFormat': '0802 123 4567' },
  'nu': { 'code': 'nu', 'name': 'Niue', 'dialCode': 683, 'phoneFormat': '1234' },
  'nf': { 'code': 'nf', 'name': 'Norfolk Island', 'dialCode': 672, 'phoneFormat': '3 81234' },
  'kp': { 'code': 'kp', 'name': 'North Korea (조선 민주주의 인민 공화국)', 'dialCode': 850, 'phoneFormat': '0192 123 4567' },
  'mp': { 'code': 'mp', 'name': 'Northern Mariana Islands', 'dialCode': 1670, 'phoneFormat': '(670) 234-5678' },
  'no': { 'code': 'no', 'name': 'Norway (Norge)', 'dialCode': 47, 'phoneFormat': '406 12 345' },
  'om': { 'code': 'om', 'name': 'Oman (‫عُمان‬‎)', 'dialCode': 968, 'phoneFormat': '9212 3456' },
  'pk': { 'code': 'pk', 'name': 'Pakistan (‫پاکستان‬‎)', 'dialCode': 92, 'phoneFormat': '0301 2345678' },
  'pw': { 'code': 'pw', 'name': 'Palau', 'dialCode': 680, 'phoneFormat': '620 1234' },
  'ps': { 'code': 'ps', 'name': 'Palestine (‫فلسطين‬‎)', 'dialCode': 970, 'phoneFormat': '0599 123 456' },
  'pa': { 'code': 'pa', 'name': 'Panama (Panamá)', 'dialCode': 507, 'phoneFormat': '6001-2345' },
  'pg': { 'code': 'pg', 'name': 'Papua New Guinea', 'dialCode': 675, 'phoneFormat': '681 2345' },
  'py': { 'code': 'py', 'name': 'Paraguay', 'dialCode': 595, 'phoneFormat': '0961 456789' },
  'pe': { 'code': 'pe', 'name': 'Peru (Perú)', 'dialCode': 51, 'phoneFormat': '912 345 678' },
  'ph': { 'code': 'ph', 'name': 'Philippines', 'dialCode': 63, 'phoneFormat': '0905 123 4567' },
  'pl': { 'code': 'pl', 'name': 'Poland (Polska)', 'dialCode': 48, 'phoneFormat': '512 345 678' },
  'pt': { 'code': 'pt', 'name': 'Portugal', 'dialCode': 351, 'phoneFormat': '912 345 678' },
  'pr': { 'code': 'pr', 'name': 'Puerto Rico', 'dialCode': 1, 'phoneFormat': '(787) 234-5678' },
  'qa': { 'code': 'qa', 'name': 'Qatar (‫قطر‬‎)', 'dialCode': 974, 'phoneFormat': '3312 3456' },
  're': { 'code': 're', 'name': 'Réunion (La Réunion)', 'dialCode': 262, 'phoneFormat': '0692 12 34 56' },
  'ro': { 'code': 'ro', 'name': 'Romania (România)', 'dialCode': 40, 'phoneFormat': '0712 345 678' },
  'ru': { 'code': 'ru', 'name': 'Russia (Россия)', 'dialCode': 7, 'phoneFormat': '8 (912) 345-67-89' },
  'rw': { 'code': 'rw', 'name': 'Rwanda', 'dialCode': 250, 'phoneFormat': '0720 123 456' },
  'bl': { 'code': 'bl', 'name': 'Saint Barthélemy (Saint-Barthélemy)', 'dialCode': 590, 'phoneFormat': '0690 30-1234' },
  'sh': { 'code': 'sh', 'name': 'Saint Helena', 'dialCode': 290, 'phoneFormat': '51234' },
  'kn': { 'code': 'kn', 'name': 'Saint Kitts and Nevis', 'dialCode': 1869, 'phoneFormat': '(869) 765-2917' },
  'lc': { 'code': 'lc', 'name': 'Saint Lucia', 'dialCode': 1758, 'phoneFormat': '(758) 284-5678' },
  'mf': { 'code': 'mf', 'name': 'Saint Martin (Saint-Martin (partie française))', 'dialCode': 590, 'phoneFormat': '0690 30-1234' },
  'pm': { 'code': 'pm', 'name': 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)', 'dialCode': 508, 'phoneFormat': '055 12 34' },
  'vc': { 'code': 'vc', 'name': 'Saint Vincent and the Grenadines', 'dialCode': 1784, 'phoneFormat': '(784) 430-1234' },
  'ws': { 'code': 'ws', 'name': 'Samoa', 'dialCode': 685, 'phoneFormat': '601234' },
  'sm': { 'code': 'sm', 'name': 'San Marino', 'dialCode': 378, 'phoneFormat': '66 66 12 12' },
  'st': { 'code': 'st', 'name': 'São Tomé and Príncipe (São Tomé e Príncipe)', 'dialCode': 239, 'phoneFormat': '981 2345' },
  'sa': { 'code': 'sa', 'name': 'Saudi Arabia (‫المملكة العربية السعودية‬‎)', 'dialCode': 966, 'phoneFormat': '051 234 5678' },
  'sn': { 'code': 'sn', 'name': 'Senegal (Sénégal)', 'dialCode': 221, 'phoneFormat': '70 123 45 67' },
  'rs': { 'code': 'rs', 'name': 'Serbia (Србија)', 'dialCode': 381, 'phoneFormat': '060 1234567' },
  'sc': { 'code': 'sc', 'name': 'Seychelles', 'dialCode': 248, 'phoneFormat': '2 510 123' },
  'sl': { 'code': 'sl', 'name': 'Sierra Leone', 'dialCode': 232, 'phoneFormat': '(025) 123456' },
  'sg': { 'code': 'sg', 'name': 'Singapore', 'dialCode': 65, 'phoneFormat': '8123 4567' },
  'sx': { 'code': 'sx', 'name': 'Sint Maarten', 'dialCode': 1721, 'phoneFormat': '(721) 520-5678' },
  'sk': { 'code': 'sk', 'name': 'Slovakia (Slovensko)', 'dialCode': 421, 'phoneFormat': '0912 123 456' },
  'si': { 'code': 'si', 'name': 'Slovenia (Slovenija)', 'dialCode': 386, 'phoneFormat': '031 234 567' },
  'sb': { 'code': 'sb', 'name': 'Solomon Islands', 'dialCode': 677, 'phoneFormat': '74 21234' },
  'so': { 'code': 'so', 'name': 'Somalia (Soomaaliya)', 'dialCode': 252, 'phoneFormat': '7 1123456' },
  'za': { 'code': 'za', 'name': 'South Africa', 'dialCode': 27, 'phoneFormat': '071 123 4567' },
  'kr': { 'code': 'kr', 'name': 'South Korea (대한민국)', 'dialCode': 82, 'phoneFormat': '010-0000-0000' },
  'ss': { 'code': 'ss', 'name': 'South Sudan (‫جنوب السودان‬‎)', 'dialCode': 211, 'phoneFormat': '0977 123 456' },
  'es': { 'code': 'es', 'name': 'Spain (España)', 'dialCode': 34, 'phoneFormat': '612 34 56 78' },
  'lk': { 'code': 'lk', 'name': 'Sri Lanka (ශ්‍රී ලංකාව)', 'dialCode': 94, 'phoneFormat': '071 234 5678' },
  'sd': { 'code': 'sd', 'name': 'Sudan (‫السودان‬‎)', 'dialCode': 249, 'phoneFormat': '091 123 1234' },
  'sr': { 'code': 'sr', 'name': 'Suriname', 'dialCode': 597, 'phoneFormat': '741-2345' },
  'sj': { 'code': 'sj', 'name': 'Svalbard and Jan Mayen', 'dialCode': 47, 'phoneFormat': '412 34 567' },
  'sz': { 'code': 'sz', 'name': 'Swaziland', 'dialCode': 268, 'phoneFormat': '7612 3456' },
  'se': { 'code': 'se', 'name': 'Sweden (Sverige)', 'dialCode': 46, 'phoneFormat': '070-123 45 67' },
  'ch': { 'code': 'ch', 'name': 'Switzerland (Schweiz)', 'dialCode': 41, 'phoneFormat': '078 123 45 67' },
  'sy': { 'code': 'sy', 'name': 'Syria (‫سوريا‬‎)', 'dialCode': 963, 'phoneFormat': '0944 567 890' },
  'tw': { 'code': 'tw', 'name': 'Taiwan (台灣)', 'dialCode': 886, 'phoneFormat': '0912 345 678' },
  'tj': { 'code': 'tj', 'name': 'Tajikistan', 'dialCode': 992, 'phoneFormat': '(8) 917 12 3456' },
  'tz': { 'code': 'tz', 'name': 'Tanzania', 'dialCode': 255, 'phoneFormat': '0621 234 567' },
  'th': { 'code': 'th', 'name': 'Thailand (ไทย)', 'dialCode': 66, 'phoneFormat': '081 234 5678' },
  'tl': { 'code': 'tl', 'name': 'Timor-Leste', 'dialCode': 670, 'phoneFormat': '7721 2345' },
  'tg': { 'code': 'tg', 'name': 'Togo', 'dialCode': 228, 'phoneFormat': '90 11 23 45' },
  'tk': { 'code': 'tk', 'name': 'Tokelau', 'dialCode': 690, 'phoneFormat': '7290' },
  'to': { 'code': 'to', 'name': 'Tonga', 'dialCode': 676, 'phoneFormat': '771 5123' },
  'tt': { 'code': 'tt', 'name': 'Trinidad and Tobago', 'dialCode': 1868, 'phoneFormat': '(868) 291-1234' },
  'tn': { 'code': 'tn', 'name': 'Tunisia (‫تونس‬‎)', 'dialCode': 216, 'phoneFormat': '20 123 456' },
  'tr': { 'code': 'tr', 'name': 'Turkey (Türkiye)', 'dialCode': 90, 'phoneFormat': '0501 234 56 78' },
  'tm': { 'code': 'tm', 'name': 'Turkmenistan', 'dialCode': 993, 'phoneFormat': '8 66 123456' },
  'tc': { 'code': 'tc', 'name': 'Turks and Caicos Islands', 'dialCode': 1649, 'phoneFormat': '(649) 231-1234' },
  'tv': { 'code': 'tv', 'name': 'Tuvalu', 'dialCode': 688, 'phoneFormat': '901234' },
  'us': { 'code': 'us', 'name': 'United States', 'dialCode': 1, 'phoneFormat': '(201) 555-0123' },
  'gb': { 'code': 'gb', 'name': 'United Kingdom', 'dialCode': 44, 'phoneFormat': '07400 123456' },
  'vi': { 'code': 'vi', 'name': 'U.S. Virgin Islands', 'dialCode': 1340, 'phoneFormat': '(340) 642-1234' },
  'ug': { 'code': 'ug', 'name': 'Uganda', 'dialCode': 256, 'phoneFormat': '0712 345678' },
  'ua': { 'code': 'ua', 'name': 'Ukraine (Україна)', 'dialCode': 380, 'phoneFormat': '039 123 4567' },
  'ae': { 'code': 'ae', 'name': 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)', 'dialCode': 971, 'phoneFormat': '050 123 4567' },
  'uy': { 'code': 'uy', 'name': 'Uruguay', 'dialCode': 598, 'phoneFormat': '094 231 234' },
  'uz': { 'code': 'uz', 'name': 'Uzbekistan (Oʻzbekiston)', 'dialCode': 998, 'phoneFormat': '8 91 234 56 78' },
  'vu': { 'code': 'vu', 'name': 'Vanuatu', 'dialCode': 678, 'phoneFormat': '591 2345' },
  'va': { 'code': 'va', 'name': 'Vatican City (Città del Vaticano)', 'dialCode': 39, 'phoneFormat': '312 345 6789' },
  've': { 'code': 've', 'name': 'Venezuela', 'dialCode': 58, 'phoneFormat': '0412-1234567' },
  'vn': { 'code': 'vn', 'name': 'Vietnam (Việt Nam)', 'dialCode': 84, 'phoneFormat': '091 234 56 78' },
  'wf': { 'code': 'wf', 'name': 'Wallis and Futuna', 'dialCode': 681, 'phoneFormat': '50 12 34' },
  'eh': { 'code': 'eh', 'name': 'Western Sahara (‫الصحراء الغربية‬‎)', 'dialCode': 212, 'phoneFormat': '0650-123456' },
  'ye': { 'code': 'ye', 'name': 'Yemen (‫اليمن‬‎)', 'dialCode': 967, 'phoneFormat': '0712 345 678' },
  'zm': { 'code': 'zm', 'name': 'Zambia', 'dialCode': 260, 'phoneFormat': '095 5123456' },
  'zw': { 'code': 'zw', 'name': 'Zimbabwe', 'dialCode': 263, 'phoneFormat': '071 123 4567' },
  'ax': { 'code': 'ax', 'name': 'Åland Islands', 'dialCode': 358, 'phoneFormat': '041 2345678' }
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.DatePicker=t():e.DatePicker=t()}(window,function(){return function(e){var t={};function n(a){if(t[a])return t[a].exports;var i=t[a]={i:a,l:!1,exports:{}};return e[a].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=e,n.c=t,n.d=function(e,t,a){n.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:a})},n.r=function(e){Object.defineProperty(e,"__esModule",{value:!0})},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=3)}([function(e,t,n){var a;!function(i){"use strict";var r={},s=/d{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|ZZ|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g,o=/\d\d?/,l=/[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i,u=/\[([^]*?)\]/gm,c=function(){};function d(e,t){for(var n=[],a=0,i=e.length;a<i;a++)n.push(e[a].substr(0,t));return n}function h(e){return function(t,n,a){var i=a[e].indexOf(n.charAt(0).toUpperCase()+n.substr(1).toLowerCase());~i&&(t.month=i)}}function p(e,t){for(e=String(e),t=t||2;e.length<t;)e="0"+e;return e}var m=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],f=["January","February","March","April","May","June","July","August","September","October","November","December"],g=d(f,3),v=d(m,3);r.i18n={dayNamesShort:v,dayNames:m,monthNamesShort:g,monthNames:f,amPm:["am","pm"],DoFn:function(e){return e+["th","st","nd","rd"][e%10>3?0:(e-e%10!=10)*e%10]}};var y={D:function(e){return e.getDate()},DD:function(e){return p(e.getDate())},Do:function(e,t){return t.DoFn(e.getDate())},d:function(e){return e.getDay()},dd:function(e){return p(e.getDay())},ddd:function(e,t){return t.dayNamesShort[e.getDay()]},dddd:function(e,t){return t.dayNames[e.getDay()]},M:function(e){return e.getMonth()+1},MM:function(e){return p(e.getMonth()+1)},MMM:function(e,t){return t.monthNamesShort[e.getMonth()]},MMMM:function(e,t){return t.monthNames[e.getMonth()]},YY:function(e){return String(e.getFullYear()).substr(2)},YYYY:function(e){return p(e.getFullYear(),4)},h:function(e){return e.getHours()%12||12},hh:function(e){return p(e.getHours()%12||12)},H:function(e){return e.getHours()},HH:function(e){return p(e.getHours())},m:function(e){return e.getMinutes()},mm:function(e){return p(e.getMinutes())},s:function(e){return e.getSeconds()},ss:function(e){return p(e.getSeconds())},S:function(e){return Math.round(e.getMilliseconds()/100)},SS:function(e){return p(Math.round(e.getMilliseconds()/10),2)},SSS:function(e){return p(e.getMilliseconds(),3)},a:function(e,t){return e.getHours()<12?t.amPm[0]:t.amPm[1]},A:function(e,t){return e.getHours()<12?t.amPm[0].toUpperCase():t.amPm[1].toUpperCase()},ZZ:function(e){var t=e.getTimezoneOffset();return(t>0?"-":"+")+p(100*Math.floor(Math.abs(t)/60)+Math.abs(t)%60,4)}},b={D:[o,function(e,t){e.day=t}],Do:[new RegExp(o.source+l.source),function(e,t){e.day=parseInt(t,10)}],M:[o,function(e,t){e.month=t-1}],YY:[o,function(e,t){var n=+(""+(new Date).getFullYear()).substr(0,2);e.year=""+(t>68?n-1:n)+t}],h:[o,function(e,t){e.hour=t}],m:[o,function(e,t){e.minute=t}],s:[o,function(e,t){e.second=t}],YYYY:[/\d{4}/,function(e,t){e.year=t}],S:[/\d/,function(e,t){e.millisecond=100*t}],SS:[/\d{2}/,function(e,t){e.millisecond=10*t}],SSS:[/\d{3}/,function(e,t){e.millisecond=t}],d:[o,c],ddd:[l,c],MMM:[l,h("monthNamesShort")],MMMM:[l,h("monthNames")],a:[l,function(e,t,n){var a=t.toLowerCase();a===n.amPm[0]?e.isPm=!1:a===n.amPm[1]&&(e.isPm=!0)}],ZZ:[/([\+\-]\d\d:?\d\d|Z)/,function(e,t){"Z"===t&&(t="+00:00");var n,a=(t+"").match(/([\+\-]|\d\d)/gi);a&&(n=60*a[1]+parseInt(a[2],10),e.timezoneOffset="+"===a[0]?n:-n)}]};b.dd=b.d,b.dddd=b.ddd,b.DD=b.D,b.mm=b.m,b.hh=b.H=b.HH=b.h,b.MM=b.M,b.ss=b.s,b.A=b.a,r.masks={default:"ddd MMM DD YYYY HH:mm:ss",shortDate:"M/D/YY",mediumDate:"MMM D, YYYY",longDate:"MMMM D, YYYY",fullDate:"dddd, MMMM D, YYYY",shortTime:"HH:mm",mediumTime:"HH:mm:ss",longTime:"HH:mm:ss.SSS"},r.format=function(e,t,n){var a=n||r.i18n;if("number"==typeof e&&(e=new Date(e)),"[object Date]"!==Object.prototype.toString.call(e)||isNaN(e.getTime()))throw new Error("Invalid Date in fecha.format");var i=[];return(t=(t=(t=r.masks[t]||t||r.masks.default).replace(u,function(e,t){return i.push(t),"??"})).replace(s,function(t){return t in y?y[t](e,a):t.slice(1,t.length-1)})).replace(/\?\?/g,function(){return i.shift()})},r.parse=function(e,t,n){var a=n||r.i18n;if("string"!=typeof t)throw new Error("Invalid format in fecha.parse");if(t=r.masks[t]||t,e.length>1e3)return!1;var i=!0,o={};if(t.replace(s,function(t){if(b[t]){var n=b[t],r=e.search(n[0]);~r?e.replace(n[0],function(t){return n[1](o,t,a),e=e.substr(r+t.length),t}):i=!1}return b[t]?"":t.slice(1,t.length-1)}),!i)return!1;var l,u=new Date;return!0===o.isPm&&null!=o.hour&&12!=+o.hour?o.hour=+o.hour+12:!1===o.isPm&&12==+o.hour&&(o.hour=0),null!=o.timezoneOffset?(o.minute=+(o.minute||0)-+o.timezoneOffset,l=new Date(Date.UTC(o.year||u.getFullYear(),o.month||0,o.day||1,o.hour||0,o.minute||0,o.second||0,o.millisecond||0))):l=new Date(o.year||u.getFullYear(),o.month||0,o.day||1,o.hour||0,o.minute||0,o.second||0,o.millisecond||0),l},void 0!==e&&e.exports?e.exports=r:void 0===(a=function(){return r}.call(t,n,t,e))||(e.exports=a)}()},function(e,t){var n=/^(attrs|props|on|nativeOn|class|style|hook)$/;function a(e,t){return function(){e&&e.apply(this,arguments),t&&t.apply(this,arguments)}}e.exports=function(e){return e.reduce(function(e,t){var i,r,s,o,l;for(s in t)if(i=e[s],r=t[s],i&&n.test(s))if("class"===s&&("string"==typeof i&&(l=i,e[s]=i={},i[l]=!0),"string"==typeof r&&(l=r,t[s]=r={},r[l]=!0)),"on"===s||"nativeOn"===s||"hook"===s)for(o in r)i[o]=a(i[o],r[o]);else if(Array.isArray(i))e[s]=i.concat(r);else if(Array.isArray(r))e[s]=[i].concat(r);else for(o in r)i[o]=r[o];else e[s]=t[s];return e},{})}},function(e,t,n){"use strict";function a(e,t){for(var n=[],a={},i=0;i<t.length;i++){var r=t[i],s=r[0],o={id:e+":"+i,css:r[1],media:r[2],sourceMap:r[3]};a[s]?a[s].parts.push(o):n.push(a[s]={id:s,parts:[o]})}return n}n.r(t),n.d(t,"default",function(){return m});var i="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!i)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var r={},s=i&&(document.head||document.getElementsByTagName("head")[0]),o=null,l=0,u=!1,c=function(){},d=null,h="data-vue-ssr-id",p="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());function m(e,t,n,i){u=n,d=i||{};var s=a(e,t);return f(s),function(t){for(var n=[],i=0;i<s.length;i++){var o=s[i];(l=r[o.id]).refs--,n.push(l)}t?f(s=a(e,t)):s=[];for(i=0;i<n.length;i++){var l;if(0===(l=n[i]).refs){for(var u=0;u<l.parts.length;u++)l.parts[u]();delete r[l.id]}}}}function f(e){for(var t=0;t<e.length;t++){var n=e[t],a=r[n.id];if(a){a.refs++;for(var i=0;i<a.parts.length;i++)a.parts[i](n.parts[i]);for(;i<n.parts.length;i++)a.parts.push(v(n.parts[i]));a.parts.length>n.parts.length&&(a.parts.length=n.parts.length)}else{var s=[];for(i=0;i<n.parts.length;i++)s.push(v(n.parts[i]));r[n.id]={id:n.id,refs:1,parts:s}}}}function g(){var e=document.createElement("style");return e.type="text/css",s.appendChild(e),e}function v(e){var t,n,a=document.querySelector("style["+h+'~="'+e.id+'"]');if(a){if(u)return c;a.parentNode.removeChild(a)}if(p){var i=l++;a=o||(o=g()),t=x.bind(null,a,i,!1),n=x.bind(null,a,i,!0)}else a=g(),t=function(e,t){var n=t.css,a=t.media,i=t.sourceMap;a&&e.setAttribute("media",a);d.ssrId&&e.setAttribute(h,t.id);i&&(n+="\n/*# sourceURL="+i.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(i))))+" */");if(e.styleSheet)e.styleSheet.cssText=n;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}.bind(null,a),n=function(){a.parentNode.removeChild(a)};return t(e),function(a){if(a){if(a.css===e.css&&a.media===e.media&&a.sourceMap===e.sourceMap)return;t(e=a)}else n()}}var y,b=(y=[],function(e,t){return y[e]=t,y.filter(Boolean).join("\n")});function x(e,t,n,a){var i=n?"":a.css;if(e.styleSheet)e.styleSheet.cssText=b(t,i);else{var r=document.createTextNode(i),s=e.childNodes;s[t]&&e.removeChild(s[t]),s.length?e.insertBefore(r,s[t]):e.appendChild(r)}}},function(e,t,n){"use strict";n.r(t);var a=n(0),i=n.n(a);function r(e){return"[object Object]"===Object.prototype.toString.call(e)}function s(e){return e instanceof Date}function o(e){return null!==e&&void 0!==e&&!isNaN(new Date(e).getTime())}function l(e){var t=(e||"").split(":");return t.length>=2?{hours:parseInt(t[0],10),minutes:parseInt(t[1],10)}:null}function u(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"24",n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"a",a=e.hours,i=(a=(a="24"===t?a:a%12||12)<10?"0"+a:a)+":"+(e.minutes<10?"0"+e.minutes:e.minutes);if("12"===t){var r=e.hours>=12?"pm":"am";"A"===n&&(r=r.toUpperCase()),i=i+" "+r}return i}function c(e,t){if(!e)return"";try{return i.a.format(new Date(e),t)}catch(e){return""}}var d={date:{value2date:function(e){return o(e)?new Date(e):null},date2value:function(e){return e}},timestamp:{value2date:function(e){return o(e)?new Date(e):null},date2value:function(e){return e&&new Date(e).getTime()}}},h={zh:{days:["日","一","二","三","四","五","六"],months:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],pickers:["未来7天","未来30天","最近7天","最近30天"],placeholder:{date:"请选择日期",dateRange:"请选择日期范围"}},en:{days:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],pickers:["next 7 days","next 30 days","previous 7 days","previous 30 days"],placeholder:{date:"Select Date",dateRange:"Select Date Range"}},ro:{days:["Dum","Lun","Mar","Mie","Joi","Vin","Sâm"],months:["Ian","Feb","Mar","Apr","Mai","Iun","Iul","Aug","Sep","Oct","Noi","Dec"],pickers:["urmatoarele 7 zile","urmatoarele 30 zile","ultimele 7 zile","ultimele 30 zile"],placeholder:{date:"Selectați Data",dateRange:"Selectați Intervalul De Date"}},fr:{days:["Dim","Lun","Mar","Mer","Jeu","Ven","Sam"],months:["Jan","Fev","Mar","Avr","Mai","Juin","Juil","Aout","Sep","Oct","Nov","Dec"],pickers:["7 jours suivants","30 jours suivants","7 jours précédents","30 jours précédents"],placeholder:{date:"Sélectionnez une date",dateRange:"Sélectionnez une période"}},es:{days:["Dom","Lun","Mar","Mie","Jue","Vie","Sab"],months:["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"],pickers:["próximos 7 días","próximos 30 días","7 días anteriores","30 días anteriores"],placeholder:{date:"Seleccionar fecha",dateRange:"Seleccionar un rango de fechas"}},"pt-br":{days:["Dom","Seg","Ter","Qua","Quin","Sex","Sáb"],months:["Jan","Fev","Mar","Abr","Maio","Jun","Jul","Ago","Set","Out","Nov","Dez"],pickers:["próximos 7 dias","próximos 30 dias","7 dias anteriores"," 30 dias anteriores"],placeholder:{date:"Selecione uma data",dateRange:"Selecione um período"}},ru:{days:["Вс","Пн","Вт","Ср","Чт","Пт","Сб"],months:["Янв","Фев","Мар","Апр","Май","Июн","Июл","Авг","Сен","Окт","Ноя","Дек"],pickers:["след. 7 дней","след. 30 дней","прош. 7 дней","прош. 30 дней"],placeholder:{date:"Выберите дату",dateRange:"Выберите период"}},de:{days:["So","Mo","Di","Mi","Do","Fr","Sa"],months:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],pickers:["nächsten 7 Tage","nächsten 30 Tage","vorigen 7 Tage","vorigen 30 Tage"],placeholder:{date:"Datum auswählen",dateRange:"Zeitraum auswählen"}},it:{days:["Dom","Lun","Mar","Mer","Gio","Ven","Sab"],months:["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"],pickers:["successivi 7 giorni","successivi 30 giorni","precedenti 7 giorni","precedenti 30 giorni"],placeholder:{date:"Seleziona una data",dateRange:"Seleziona un intervallo date"}},cs:{days:["Ned","Pon","Úte","Stř","Čtv","Pát","Sob"],months:["Led","Úno","Bře","Dub","Kvě","Čer","Čerc","Srp","Zář","Říj","Lis","Pro"],pickers:["příštích 7 dní","příštích 30 dní","předchozích 7 dní","předchozích 30 dní"],placeholder:{date:"Vyberte datum",dateRange:"Vyberte časové rozmezí"}},sl:{days:["Ned","Pon","Tor","Sre","Čet","Pet","Sob"],months:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],pickers:["naslednjih 7 dni","naslednjih 30 dni","prejšnjih 7 dni","prejšnjih 30 dni"],placeholder:{date:"Izberite datum",dateRange:"Izberite razpon med 2 datumoma"}}},p=h.zh,m={methods:{t:function(e){for(var t=this,n=t.$options.name;t&&(!n||"DatePicker"!==n);)(t=t.$parent)&&(n=t.$options.name);for(var a=t&&t.language||p,i=e.split("."),r=a,s=void 0,o=0,l=i.length;o<l;o++){if(s=r[i[o]],o===l-1)return s;if(!s)return"";r=s}return""}}};function f(e,t){if(t){for(var n=[],a=t.offsetParent;a&&e!==a&&e.contains(a);)n.push(a),a=a.offsetParent;var i=t.offsetTop+n.reduce(function(e,t){return e+t.offsetTop},0),r=i+t.offsetHeight,s=e.scrollTop,o=s+e.clientHeight;i<s?e.scrollTop=i:r>o&&(e.scrollTop=r-e.clientHeight)}else e.scrollTop=0}var g=n(1),v=n.n(g),y={name:"panelDate",mixins:[m],props:{value:null,startAt:null,endAt:null,dateFormat:{type:String,default:"YYYY-MM-DD"},calendarMonth:{default:(new Date).getMonth()},calendarYear:{default:(new Date).getFullYear()},firstDayOfWeek:{default:7,type:Number,validator:function(e){return e>=1&&e<=7}},disabledDate:{type:Function,default:function(){return!1}}},methods:{selectDate:function(e){var t=e.year,n=e.month,a=e.day,i=new Date(t,n,a);this.disabledDate(i)||this.$emit("select",i)},getDays:function(e){var t=this.t("days"),n=parseInt(e,10);return t.concat(t).slice(n,n+7)},getDates:function(e,t,n){var a=[],i=new Date(e,t);i.setDate(0);for(var r=(i.getDay()+7-n)%7+1,s=i.getDate()-(r-1),o=0;o<r;o++)a.push({year:e,month:t-1,day:s+o});i.setMonth(i.getMonth()+2,0);for(var l=i.getDate(),u=0;u<l;u++)a.push({year:e,month:t,day:1+u});i.setMonth(i.getMonth()+1,1);for(var c=42-(r+l),d=0;d<c;d++)a.push({year:e,month:t+1,day:1+d});return a},getCellClasses:function(e){var t=e.year,n=e.month,a=e.day,i=[],r=new Date(t,n,a).getTime(),s=(new Date).setHours(0,0,0,0),o=this.value&&new Date(this.value).setHours(0,0,0,0),l=this.startAt&&new Date(this.startAt).setHours(0,0,0,0),u=this.endAt&&new Date(this.endAt).setHours(0,0,0,0);return n<this.calendarMonth?i.push("last-month"):n>this.calendarMonth?i.push("next-month"):i.push("cur-month"),r===s&&i.push("today"),this.disabledDate(r)&&i.push("disabled"),o&&(r===o?i.push("actived"):l&&r<=o?i.push("inrange"):u&&r>=o&&i.push("inrange")),i},getCellTitle:function(e){var t=e.year,n=e.month,a=e.day;return c(new Date(t,n,a),this.dateFormat)}},render:function(e){var t=this,n=this.getDays(this.firstDayOfWeek).map(function(t){return e("th",[t])}),a=this.getDates(this.calendarYear,this.calendarMonth,this.firstDayOfWeek),i=Array.apply(null,{length:6}).map(function(n,i){var r=a.slice(7*i,7*i+7).map(function(n){var a={class:t.getCellClasses(n)};return e("td",v()([{class:"cell"},a,{attrs:{"data-year":n.year,"data-month":n.month,title:t.getCellTitle(n)},on:{click:t.selectDate.bind(t,n)}}]),[n.day])});return e("tr",[r])});return e("table",{class:"mx-panel mx-panel-date"},[e("thead",[e("tr",[n])]),e("tbody",[i])])}},b={name:"panelYear",props:{value:null,firstYear:Number,disabledYear:Function},methods:{isDisabled:function(e){return!("function"!=typeof this.disabledYear||!this.disabledYear(e))},selectYear:function(e){this.isDisabled(e)||this.$emit("select",e)}},render:function(e){var t=this,n=10*Math.floor(this.firstYear/10),a=this.value&&new Date(this.value).getFullYear(),i=Array.apply(null,{length:10}).map(function(i,r){var s=n+r;return e("span",{class:{cell:!0,actived:a===s,disabled:t.isDisabled(s)},on:{click:t.selectYear.bind(t,s)}},[s])});return e("div",{class:"mx-panel mx-panel-year"},[i])}},x={name:"panelMonth",mixins:[m],props:{value:null,calendarYear:{default:(new Date).getFullYear()},disabledMonth:Function},methods:{isDisabled:function(e){return!("function"!=typeof this.disabledMonth||!this.disabledMonth(e))},selectMonth:function(e){this.isDisabled(e)||this.$emit("select",e)}},render:function(e){var t=this,n=this.t("months"),a=this.value&&new Date(this.value).getFullYear(),i=this.value&&new Date(this.value).getMonth();return n=n.map(function(n,r){return e("span",{class:{cell:!0,actived:a===t.calendarYear&&i===r,disabled:t.isDisabled(r)},on:{click:t.selectMonth.bind(t,r)}},[n])}),e("div",{class:"mx-panel mx-panel-month"},[n])}},w=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e},D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};function M(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function T(e,t,n,a,i,r,s,o){var l,u="function"==typeof e?e.options:e;if(t&&(u.render=t,u.staticRenderFns=n,u._compiled=!0),a&&(u.functional=!0),r&&(u._scopeId="data-v-"+r),s?(l=function(e){(e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),i&&i.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(s)},u._ssrRegister=l):i&&(l=o?function(){i.call(this,this.$root.$options.shadowRoot)}:i),l)if(u.functional){u._injectStyles=l;var c=u.render;u.render=function(e,t){return l.call(t),c(e,t)}}else{var d=u.beforeCreate;u.beforeCreate=d?[].concat(d,l):[l]}return{exports:e,options:u}}var S=T({name:"CalendarPanel",components:{PanelDate:y,PanelYear:b,PanelMonth:x,PanelTime:{name:"panelTime",props:{timePickerOptions:{type:[Object,Function],default:function(){return null}},timeSelectOptions:{type:Object,default:function(){return null}},minuteStep:{type:Number,default:0,validator:function(e){return e>=0&&e<=60}},value:null,timeType:{type:Array,default:function(){return["24","a"]}},disabledTime:Function},computed:{currentHours:function(){return this.value?new Date(this.value).getHours():0},currentMinutes:function(){return this.value?new Date(this.value).getMinutes():0},currentSeconds:function(){return this.value?new Date(this.value).getSeconds():0}},methods:{stringifyText:function(e){return("00"+e).slice(String(e).length)},selectTime:function(e){"function"==typeof this.disabledTime&&this.disabledTime(e)||this.$emit("select",new Date(e))},pickTime:function(e){"function"==typeof this.disabledTime&&this.disabledTime(e)||this.$emit("pick",new Date(e))},getTimePickerOptions:function(){var e=[],t=this.timePickerOptions;if(!t)return[];if("function"==typeof t)return t()||[];var n=l(t.start),a=l(t.end),i=l(t.step);if(n&&a&&i)for(var r=n.minutes+60*n.hours,s=a.minutes+60*a.hours,o=i.minutes+60*i.hours,c=Math.floor((s-r)/o),d=0;d<=c;d++){var h=r+d*o,p={hours:Math.floor(h/60),minutes:h%60};e.push({value:p,label:u.apply(void 0,[p].concat(M(this.timeType)))})}return e}},render:function(e){var t=this,n=this.value?new Date(this.value):(new Date).setHours(0,0,0,0),a="function"==typeof this.disabledTime&&this.disabledTime,i=this.getTimePickerOptions();if(Array.isArray(i)&&i.length)return i=i.map(function(i){var r=i.value.hours,s=i.value.minutes,o=new Date(n).setHours(r,s,0);return e("li",{class:{"mx-time-picker-item":!0,cell:!0,actived:r===t.currentHours&&s===t.currentMinutes,disabled:a&&a(o)},on:{click:t.pickTime.bind(t,o)}},[i.label])}),e("div",{class:"mx-panel mx-panel-time"},[e("ul",{class:"mx-time-list"},[i])]);var r=this.minuteStep||1,s=parseInt(60/r),o={hours:Array.apply(null,{length:24}).map(function(e,t){return t}),minutes:Array.apply(null,{length:s}).map(function(e,t){return t*r}),seconds:0===this.minuteStep?Array.apply(null,{length:60}).map(function(e,t){return t}):[]};this.timeSelectOptions&&"object"===D(this.timeSelectOptions)&&(o=w({},o,this.timeSelectOptions));var l=[o.hours.map(function(i){var r=new Date(n).setHours(i);return e("li",{class:{cell:!0,actived:i===t.currentHours,disabled:a&&a(r)},on:{click:t.selectTime.bind(t,r)}},[t.stringifyText(i)])}),o.minutes.map(function(i){var r=new Date(n).setMinutes(i);return e("li",{class:{cell:!0,actived:i===t.currentMinutes,disabled:a&&a(r)},on:{click:t.selectTime.bind(t,r)}},[t.stringifyText(i)])}),o.seconds.map(function(i){var r=new Date(n).setSeconds(i);return e("li",{class:{cell:!0,actived:i===t.currentSeconds,disabled:a&&a(r)},on:{click:t.selectTime.bind(t,r)}},[t.stringifyText(i)])})].filter(function(e){return e.length>0});return l=l.map(function(t){return e("ul",{class:"mx-time-list",style:{width:100/l.length+"%"}},[t])}),e("div",{class:"mx-panel mx-panel-time"},[l])}}},mixins:[m,{methods:{dispatch:function(e,t,n){for(var a=this.$parent||this.$root,i=a.$options.name;a&&(!i||i!==e);)(a=a.$parent)&&(i=a.$options.name);i&&i===e&&(a=a||this).$emit.apply(a,[t].concat(n))}}}],props:{value:{default:null,validator:function(e){return null===e||o(e)}},startAt:null,endAt:null,visible:{type:Boolean,default:!1},type:{type:String,default:"date"},dateFormat:{type:String,default:"YYYY-MM-DD"},index:Number,defaultValue:{validator:function(e){return o(e)}},firstDayOfWeek:{default:7,type:Number,validator:function(e){return e>=1&&e<=7}},notBefore:{default:null,validator:function(e){return!e||o(e)}},notAfter:{default:null,validator:function(e){return!e||o(e)}},disabledDays:{type:[Array,Function],default:function(){return[]}},minuteStep:{type:Number,default:0,validator:function(e){return e>=0&&e<=60}},timeSelectOptions:{type:Object,default:function(){return null}},timePickerOptions:{type:[Object,Function],default:function(){return null}}},data:function(){var e=this.getNow(this.value),t=e.getFullYear();return{panel:"NONE",dates:[],calendarMonth:e.getMonth(),calendarYear:t,firstYear:10*Math.floor(t/10)}},computed:{now:{get:function(){return new Date(this.calendarYear,this.calendarMonth).getTime()},set:function(e){var t=new Date(e);this.calendarYear=t.getFullYear(),this.calendarMonth=t.getMonth()}},timeType:function(){return[/h+/.test(this.$parent.format)?"12":"24",/A/.test(this.$parent.format)?"A":"a"]},timeHeader:function(){return"time"===this.type?this.$parent.format:this.value&&c(this.value,this.dateFormat)},yearHeader:function(){return this.firstYear+" ~ "+(this.firstYear+9)},months:function(){return this.t("months")},notBeforeTime:function(){return this.getCriticalTime(this.notBefore)},notAfterTime:function(){return this.getCriticalTime(this.notAfter)}},watch:{value:{immediate:!0,handler:"updateNow"},defaultValue:{handler:"updateNow"},visible:{immediate:!0,handler:"init"},panel:{handler:"handelPanelChange"}},methods:{handelPanelChange:function(e,t){var n=this;this.dispatch("DatePicker","panel-change",[e,t]),"YEAR"===e?this.firstYear=10*Math.floor(this.calendarYear/10):"TIME"===e&&this.$nextTick(function(){for(var e=n.$el.querySelectorAll(".mx-panel-time .mx-time-list"),t=0,a=e.length;t<a;t++){var i=e[t];f(i,i.querySelector(".actived"))}})},init:function(e){if(e){var t=this.type;"month"===t?this.showPanelMonth():"year"===t?this.showPanelYear():"time"===t?this.showPanelTime():this.showPanelDate()}else this.showPanelNone(),this.updateNow(this.value)},getNow:function(e){return e?new Date(e):this.defaultValue&&o(this.defaultValue)?new Date(this.defaultValue):new Date},updateNow:function(e){var t=this.now;this.now=this.getNow(e),this.visible&&this.now!==t&&this.dispatch("DatePicker","calendar-change",[new Date(this.now),new Date(t)])},getCriticalTime:function(e){if(!e)return null;var t=new Date(e);return"year"===this.type?new Date(t.getFullYear(),0).getTime():"month"===this.type?new Date(t.getFullYear(),t.getMonth()).getTime():"date"===this.type?t.setHours(0,0,0,0):t.getTime()},inBefore:function(e,t){return void 0===t&&(t=this.startAt),this.notBeforeTime&&e<this.notBeforeTime||t&&e<this.getCriticalTime(t)},inAfter:function(e,t){return void 0===t&&(t=this.endAt),this.notAfterTime&&e>this.notAfterTime||t&&e>this.getCriticalTime(t)},inDisabledDays:function(e){var t=this;return Array.isArray(this.disabledDays)?this.disabledDays.some(function(n){return t.getCriticalTime(n)===e}):"function"==typeof this.disabledDays&&this.disabledDays(new Date(e))},isDisabledYear:function(e){var t=new Date(e,0).getTime(),n=new Date(e+1,0).getTime()-1;return this.inBefore(n)||this.inAfter(t)||"year"===this.type&&this.inDisabledDays(t)},isDisabledMonth:function(e){var t=new Date(this.calendarYear,e).getTime(),n=new Date(this.calendarYear,e+1).getTime()-1;return this.inBefore(n)||this.inAfter(t)||"month"===this.type&&this.inDisabledDays(t)},isDisabledDate:function(e){var t=new Date(e).getTime(),n=new Date(e).setHours(23,59,59,999);return this.inBefore(n)||this.inAfter(t)||this.inDisabledDays(t)},isDisabledTime:function(e,t,n){var a=new Date(e).getTime();return this.inBefore(a,t)||this.inAfter(a,n)||this.inDisabledDays(a)},selectDate:function(e){if("datetime"===this.type){var t=new Date(e);return s(this.value)&&t.setHours(this.value.getHours(),this.value.getMinutes(),this.value.getSeconds()),this.isDisabledTime(t)&&(t.setHours(0,0,0,0),this.notBefore&&t.getTime()<new Date(this.notBefore).getTime()&&(t=new Date(this.notBefore)),this.startAt&&t.getTime()<new Date(this.startAt).getTime()&&(t=new Date(this.startAt))),this.selectTime(t),void this.showPanelTime()}this.$emit("select-date",e)},selectYear:function(e){if(this.changeCalendarYear(e),"year"===this.type.toLowerCase())return this.selectDate(new Date(this.now));this.dispatch("DatePicker","select-year",[e,this.index]),this.showPanelMonth()},selectMonth:function(e){if(this.changeCalendarMonth(e),"month"===this.type.toLowerCase())return this.selectDate(new Date(this.now));this.dispatch("DatePicker","select-month",[e,this.index]),this.showPanelDate()},selectTime:function(e){this.$emit("select-time",e,!1)},pickTime:function(e){this.$emit("select-time",e,!0)},changeCalendarYear:function(e){this.updateNow(new Date(e,this.calendarMonth))},changeCalendarMonth:function(e){this.updateNow(new Date(this.calendarYear,e))},getSibling:function(){var e=this,t=this.$parent.$children.filter(function(t){return t.$options.name===e.$options.name});return t[1^t.indexOf(this)]},handleIconMonth:function(e){var t=this.calendarMonth;this.changeCalendarMonth(t+e),this.$parent.$emit("change-calendar-month",{month:t,flag:e,vm:this,sibling:this.getSibling()})},handleIconYear:function(e){if("YEAR"===this.panel)this.changePanelYears(e);else{var t=this.calendarYear;this.changeCalendarYear(t+e),this.$parent.$emit("change-calendar-year",{year:t,flag:e,vm:this,sibling:this.getSibling()})}},handleBtnYear:function(){this.showPanelYear()},handleBtnMonth:function(){this.showPanelMonth()},handleTimeHeader:function(){"time"!==this.type&&this.showPanelDate()},changePanelYears:function(e){this.firstYear=this.firstYear+10*e},showPanelNone:function(){this.panel="NONE"},showPanelTime:function(){this.panel="TIME"},showPanelDate:function(){this.panel="DATE"},showPanelYear:function(){this.panel="YEAR"},showPanelMonth:function(){this.panel="MONTH"}}},function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"mx-calendar",class:"mx-calendar-panel-"+e.panel.toLowerCase()},[n("div",{staticClass:"mx-calendar-header"},[n("a",{directives:[{name:"show",rawName:"v-show",value:"TIME"!==e.panel,expression:"panel !== 'TIME'"}],staticClass:"mx-icon-last-year",on:{click:function(t){e.handleIconYear(-1)}}},[e._v("«")]),e._v(" "),n("a",{directives:[{name:"show",rawName:"v-show",value:"DATE"===e.panel,expression:"panel === 'DATE'"}],staticClass:"mx-icon-last-month",on:{click:function(t){e.handleIconMonth(-1)}}},[e._v("‹")]),e._v(" "),n("a",{directives:[{name:"show",rawName:"v-show",value:"TIME"!==e.panel,expression:"panel !== 'TIME'"}],staticClass:"mx-icon-next-year",on:{click:function(t){e.handleIconYear(1)}}},[e._v("»")]),e._v(" "),n("a",{directives:[{name:"show",rawName:"v-show",value:"DATE"===e.panel,expression:"panel === 'DATE'"}],staticClass:"mx-icon-next-month",on:{click:function(t){e.handleIconMonth(1)}}},[e._v("›")]),e._v(" "),n("a",{directives:[{name:"show",rawName:"v-show",value:"DATE"===e.panel,expression:"panel === 'DATE'"}],staticClass:"mx-current-month",on:{click:e.handleBtnMonth}},[e._v(e._s(e.months[e.calendarMonth]))]),e._v(" "),n("a",{directives:[{name:"show",rawName:"v-show",value:"DATE"===e.panel||"MONTH"===e.panel,expression:"panel === 'DATE' || panel === 'MONTH'"}],staticClass:"mx-current-year",on:{click:e.handleBtnYear}},[e._v(e._s(e.calendarYear))]),e._v(" "),n("a",{directives:[{name:"show",rawName:"v-show",value:"YEAR"===e.panel,expression:"panel === 'YEAR'"}],staticClass:"mx-current-year"},[e._v(e._s(e.yearHeader))]),e._v(" "),n("a",{directives:[{name:"show",rawName:"v-show",value:"TIME"===e.panel,expression:"panel === 'TIME'"}],staticClass:"mx-time-header",on:{click:e.handleTimeHeader}},[e._v(e._s(e.timeHeader))])]),e._v(" "),n("div",{staticClass:"mx-calendar-content"},[n("panel-date",{directives:[{name:"show",rawName:"v-show",value:"DATE"===e.panel,expression:"panel === 'DATE'"}],attrs:{value:e.value,"date-format":e.dateFormat,"calendar-month":e.calendarMonth,"calendar-year":e.calendarYear,"start-at":e.startAt,"end-at":e.endAt,"first-day-of-week":e.firstDayOfWeek,"disabled-date":e.isDisabledDate},on:{select:e.selectDate}}),e._v(" "),n("panel-year",{directives:[{name:"show",rawName:"v-show",value:"YEAR"===e.panel,expression:"panel === 'YEAR'"}],attrs:{value:e.value,"disabled-year":e.isDisabledYear,"first-year":e.firstYear},on:{select:e.selectYear}}),e._v(" "),n("panel-month",{directives:[{name:"show",rawName:"v-show",value:"MONTH"===e.panel,expression:"panel === 'MONTH'"}],attrs:{value:e.value,"disabled-month":e.isDisabledMonth,"calendar-year":e.calendarYear},on:{select:e.selectMonth}}),e._v(" "),n("panel-time",{directives:[{name:"show",rawName:"v-show",value:"TIME"===e.panel,expression:"panel === 'TIME'"}],attrs:{"minute-step":e.minuteStep,"time-picker-options":e.timePickerOptions,"time-select-options":e.timeSelectOptions,value:e.value,"disabled-time":e.isDisabledTime,"time-type":e.timeType},on:{select:e.selectTime,pick:e.pickTime}})],1)])},[],!1,null,null,null).exports,Y=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e},k=T({fecha:i.a,name:"DatePicker",components:{CalendarPanel:S},mixins:[m],props:{value:null,valueType:{default:"date",validator:function(e){return-1!==["timestamp","format","date"].indexOf(e)||r(e)}},placeholder:{type:String,default:null},lang:{type:[String,Object],default:"zh"},format:{type:[String,Object],default:"YYYY-MM-DD"},dateFormat:{type:String},type:{type:String,default:"date"},range:{type:Boolean,default:!1},rangeSeparator:{type:String,default:"~"},width:{type:[String,Number],default:null},confirmText:{type:String,default:"OK"},confirm:{type:Boolean,default:!1},editable:{type:Boolean,default:!0},disabled:{type:Boolean,default:!1},clearable:{type:Boolean,default:!0},shortcuts:{type:[Boolean,Array],default:!0},inputName:{type:String,default:"date"},inputClass:{default:"mx-input"},inputAttr:Object,appendToBody:{type:Boolean,default:!1},popupStyle:{type:Object},iconDay:{type:[Number,String]}},data:function(){return{currentValue:this.range?[null,null]:null,userInput:null,popupVisible:!1,position:{}}},watch:{value:{immediate:!0,handler:"handleValueChange"},popupVisible:function(e){e?this.initCalendar():(this.userInput=null,this.blur())}},computed:{transform:function(){var e=this.valueType;return r(e)?Y({},d.date,e):"format"===e?{value2date:this.parse.bind(this),date2value:this.stringify.bind(this)}:d[e]||d.date},language:function(){return r(this.lang)?Y({},h.en,this.lang):h[this.lang]||h.en},innerPlaceholder:function(){return"string"==typeof this.placeholder?this.placeholder:this.range?this.t("placeholder.dateRange"):this.t("placeholder.date")},text:function(){if(null!==this.userInput)return this.userInput;var e=this.transform.value2date;return this.range?this.isValidRangeValue(this.value)?this.stringify(e(this.value[0]))+" "+this.rangeSeparator+" "+this.stringify(e(this.value[1])):"":this.isValidValue(this.value)?this.stringify(e(this.value)):""},computedWidth:function(){return"number"==typeof this.width||"string"==typeof this.width&&/^\d+$/.test(this.width)?this.width+"px":this.width},showClearIcon:function(){return!this.disabled&&this.clearable&&(this.range?this.isValidRangeValue(this.value):this.isValidValue(this.value))},innerType:function(){return String(this.type).toLowerCase()},innerShortcuts:function(){if(Array.isArray(this.shortcuts))return this.shortcuts;if(!1===this.shortcuts)return[];var e=this.t("pickers");return[{text:e[0],onClick:function(e){e.currentValue=[new Date,new Date(Date.now()+6048e5)],e.updateDate(!0)}},{text:e[1],onClick:function(e){e.currentValue=[new Date,new Date(Date.now()+2592e6)],e.updateDate(!0)}},{text:e[2],onClick:function(e){e.currentValue=[new Date(Date.now()-6048e5),new Date],e.updateDate(!0)}},{text:e[3],onClick:function(e){e.currentValue=[new Date(Date.now()-2592e6),new Date],e.updateDate(!0)}}]},innerDateFormat:function(){return this.dateFormat?this.dateFormat:"string"!=typeof this.format?"YYYY-MM-DD":"date"===this.innerType?this.format:this.format.replace(/[Hh]+.*[msSaAZ]|\[.*?\]/g,"").trim()||"YYYY-MM-DD"},innerPopupStyle:function(){return Y({},this.position,this.popupStyle)}},mounted:function(){var e=this;this.appendToBody&&(this.popupElm=this.$refs.calendar,document.body.appendChild(this.popupElm));var t,n,a,i,r=void 0;this._bindDocmentMousedown=function(e){r=e.target},this._bindDocumentMouseup=function(t){var n=t.target,a=e.$el,i=e.popupElm;!r||!n||a.contains(r)||a.contains(n)||i&&(i.contains(r)||i.contains(n))||(r=null,e.closePopup())},this._startEvt="mousedown",this._endEvt="mouseup","ontouchend"in document&&(this._startEvt="touchstart",this._endEvt="touchend"),document.addEventListener(this._startEvt,this._bindDocmentMousedown),document.addEventListener(this._endEvt,this._bindDocumentMouseup),this._displayPopup=(t=function(){e.popupVisible&&e.displayPopup()},n=200,a=0,i=null,function(){var e=this;if(!i){var r=arguments,s=function(){a=Date.now(),i=null,t.apply(e,r)};Date.now()-a>=n?s():i=setTimeout(s,n)}}),window.addEventListener("resize",this._displayPopup),window.addEventListener("scroll",this._displayPopup)},beforeDestroy:function(){this.popupElm&&this.popupElm.parentNode===document.body&&document.body.removeChild(this.popupElm),document.removeEventListener(this._startEvt,this._bindDocmentMousedown),document.removeEventListener(this._endEvt,this._bindDocumentMouseup),window.removeEventListener("resize",this._displayPopup),window.removeEventListener("scroll",this._displayPopup)},methods:{initCalendar:function(){this.handleValueChange(this.value),this.displayPopup()},stringify:function(e){return r(this.format)&&"function"==typeof this.format.stringify?this.format.stringify(e):c(e,this.format)},parse:function(e){return r(this.format)&&"function"==typeof this.format.parse?this.format.parse(e):function(e,t){try{return i.a.parse(e,t)||null}catch(e){return null}}(e,this.format)},isValidValue:function(e){return o((0,this.transform.value2date)(e))},isValidRangeValue:function(e){var t=this.transform.value2date;return Array.isArray(e)&&2===e.length&&this.isValidValue(e[0])&&this.isValidValue(e[1])&&t(e[1]).getTime()>=t(e[0]).getTime()},dateEqual:function(e,t){return s(e)&&s(t)&&e.getTime()===t.getTime()},rangeEqual:function(e,t){var n=this;return Array.isArray(e)&&Array.isArray(t)&&e.length===t.length&&e.every(function(e,a){return n.dateEqual(e,t[a])})},selectRange:function(e){"function"==typeof e.onClick?!1!==e.onClick(this)&&this.closePopup():(this.currentValue=[new Date(e.start),new Date(e.end)],this.updateDate(!0),this.closePopup())},clearDate:function(){var e=this.range?[null,null]:null;this.currentValue=e,this.updateDate(!0),this.$emit("clear")},confirmDate:function(){var e;(this.range?(e=this.currentValue,Array.isArray(e)&&2===e.length&&o(e[0])&&o(e[1])&&new Date(e[1]).getTime()>=new Date(e[0]).getTime()):o(this.currentValue))&&this.updateDate(!0),this.emitDate("confirm"),this.closePopup()},updateDate:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];return!(this.confirm&&!e||this.disabled)&&((this.range?!this.rangeEqual(this.value,this.currentValue):!this.dateEqual(this.value,this.currentValue))&&(this.emitDate("input"),this.emitDate("change"),!0))},emitDate:function(e){var t=this.transform.date2value,n=this.range?this.currentValue.map(t):t(this.currentValue);this.$emit(e,n)},handleValueChange:function(e){var t=this.transform.value2date;this.range?this.currentValue=this.isValidRangeValue(e)?e.map(t):[null,null]:this.currentValue=this.isValidValue(e)?t(e):null},selectDate:function(e){this.currentValue=e,this.updateDate()&&this.closePopup()},selectStartDate:function(e){this.$set(this.currentValue,0,e),this.currentValue[1]&&this.updateDate()},selectEndDate:function(e){this.$set(this.currentValue,1,e),this.currentValue[0]&&this.updateDate()},selectTime:function(e,t){this.currentValue=e,this.updateDate()&&t&&this.closePopup()},selectStartTime:function(e){this.selectStartDate(e)},selectEndTime:function(e){this.selectEndDate(e)},showPopup:function(){this.disabled||(this.popupVisible=!0)},closePopup:function(){this.popupVisible=!1},getPopupSize:function(e){var t=e.style.display,n=e.style.visibility;e.style.display="block",e.style.visibility="hidden";var a=window.getComputedStyle(e),i={width:e.offsetWidth+parseInt(a.marginLeft)+parseInt(a.marginRight),height:e.offsetHeight+parseInt(a.marginTop)+parseInt(a.marginBottom)};return e.style.display=t,e.style.visibility=n,i},displayPopup:function(){var e=document.documentElement.clientWidth,t=document.documentElement.clientHeight,n=this.$el.getBoundingClientRect(),a=this._popupRect||(this._popupRect=this.getPopupSize(this.$refs.calendar)),i={},r=0,s=0;this.appendToBody&&(r=window.pageXOffset+n.left,s=window.pageYOffset+n.top),e-n.left<a.width&&n.right<a.width?i.left=r-n.left+1+"px":n.left+n.width/2<=e/2?i.left=r+"px":i.left=r+n.width-a.width+"px",n.top<=a.height&&t-n.bottom<=a.height?i.top=s+t-n.top-a.height+"px":n.top+n.height/2<=t/2?i.top=s+n.height+"px":i.top=s-a.height+"px",i.top===this.position.top&&i.left===this.position.left||(this.position=i)},blur:function(){this.$refs.input.blur()},handleBlur:function(e){this.$emit("blur",e)},handleFocus:function(e){this.popupVisible||this.showPopup(),this.$emit("focus",e)},handleKeydown:function(e){var t=e.keyCode;9!==t&&13!==t||(this.handleChange(),this.userInput=null,this.closePopup())},handleInput:function(e){this.userInput=e.target.value},handleChange:function(){if(this.editable&&null!==this.userInput){var e=this.text,t=this.$refs.calendarPanel.isDisabledTime;if(!e)return void this.clearDate();if(this.range){var n=e.split(" "+this.rangeSeparator+" ");if(2===n.length){var a=this.parse(n[0]),i=this.parse(n[1]);if(a&&i&&!t(a,null,i)&&!t(i,a,null))return this.currentValue=[a,i],this.updateDate(!0),void this.closePopup()}}else{var r=this.parse(e);if(r&&!t(r,null,null))return this.currentValue=r,this.updateDate(!0),void this.closePopup()}this.$emit("input-error",e)}}}},function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"mx-datepicker",class:{"mx-datepicker-range":e.range,disabled:e.disabled},style:{width:e.computedWidth},on:{mousedown:e.showPopup,touchstart:e.showPopup}},[n("div",{staticClass:"mx-input-wrapper"},[n("input",e._b({ref:"input",class:e.inputClass,attrs:{name:e.inputName,type:"text",autocomplete:"off",disabled:e.disabled,readonly:!e.editable,placeholder:e.innerPlaceholder},domProps:{value:e.text},on:{keydown:e.handleKeydown,focus:e.handleFocus,blur:e.handleBlur,input:e.handleInput,change:e.handleChange}},"input",e.inputAttr,!1)),e._v(" "),e.showClearIcon?n("span",{staticClass:"mx-input-append mx-clear-wrapper",on:{mousedown:function(t){return t.stopPropagation(),e.clearDate(t)}}},[e._t("mx-clear-icon",[n("i",{staticClass:"mx-input-icon mx-clear-icon"})])],2):e._e(),e._v(" "),n("span",{staticClass:"mx-input-append"},[e._t("calendar-icon",[n("svg",{staticClass:"mx-calendar-icon",attrs:{xmlns:"http://www.w3.org/2000/svg",version:"1.1",viewBox:"0 0 200 200"}},[n("rect",{attrs:{x:"13",y:"29",rx:"14",ry:"14",width:"174",height:"158",fill:"transparent"}}),e._v(" "),n("line",{attrs:{x1:"46",x2:"46",y1:"8",y2:"50"}}),e._v(" "),n("line",{attrs:{x1:"154",x2:"154",y1:"8",y2:"50"}}),e._v(" "),n("line",{attrs:{x1:"13",x2:"187",y1:"70",y2:"70"}}),e._v(" "),n("text",{attrs:{x:"50%",y:"135","font-size":"90","stroke-width":"1","text-anchor":"middle","dominant-baseline":"middle"}},[e._v(e._s(e.iconDay))])])])],2)]),e._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:e.popupVisible,expression:"popupVisible"}],ref:"calendar",staticClass:"mx-datepicker-popup",style:e.innerPopupStyle,on:{click:function(e){e.stopPropagation(),e.preventDefault()}}},[e._t("header",[e.range&&e.innerShortcuts.length?n("div",{staticClass:"mx-shortcuts-wrapper"},e._l(e.innerShortcuts,function(t,a){return n("button",{key:a,staticClass:"mx-shortcuts",attrs:{type:"button"},on:{click:function(n){e.selectRange(t)}}},[e._v(e._s(t.text))])})):e._e()]),e._v(" "),e.range?n("div",{staticClass:"mx-range-wrapper"},[n("calendar-panel",e._b({ref:"calendarPanel",staticStyle:{"box-shadow":"1px 0 rgba(0, 0, 0, .1)"},attrs:{index:0,type:e.innerType,"date-format":e.innerDateFormat,value:e.currentValue[0],"end-at":e.currentValue[1],"start-at":null,visible:e.popupVisible},on:{"select-date":e.selectStartDate,"select-time":e.selectStartTime}},"calendar-panel",e.$attrs,!1)),e._v(" "),n("calendar-panel",e._b({attrs:{index:1,type:e.innerType,"date-format":e.innerDateFormat,value:e.currentValue[1],"start-at":e.currentValue[0],"end-at":null,visible:e.popupVisible},on:{"select-date":e.selectEndDate,"select-time":e.selectEndTime}},"calendar-panel",e.$attrs,!1))],1):n("calendar-panel",e._b({ref:"calendarPanel",attrs:{index:-1,type:e.innerType,"date-format":e.innerDateFormat,value:e.currentValue,visible:e.popupVisible},on:{"select-date":e.selectDate,"select-time":e.selectTime}},"calendar-panel",e.$attrs,!1)),e._v(" "),e._t("footer",[e.confirm?n("div",{staticClass:"mx-datepicker-footer"},[n("button",{staticClass:"mx-datepicker-btn mx-datepicker-btn-confirm",attrs:{type:"button"},on:{click:e.confirmDate}},[e._v(e._s(e.confirmText))])]):e._e()],{confirm:e.confirmDate})],2)])},[],!1,null,null,null).exports;n(6);k.install=function(e){e.component(k.name,k)},"undefined"!=typeof window&&window.Vue&&k.install(window.Vue);t.default=k},function(e,t){e.exports=function(){var e=[];return e.toString=function(){for(var e=[],t=0;t<this.length;t++){var n=this[t];n[2]?e.push("@media "+n[2]+"{"+n[1]+"}"):e.push(n[1])}return e.join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var a={},i=0;i<this.length;i++){var r=this[i][0];"number"==typeof r&&(a[r]=!0)}for(i=0;i<t.length;i++){var s=t[i];"number"==typeof s[0]&&a[s[0]]||(n&&!s[2]?s[2]=n:n&&(s[2]="("+s[2]+") and ("+n+")"),e.push(s))}},e}},function(e,t,n){(e.exports=n(4)()).push([e.i,"@charset \"UTF-8\";\n.mx-datepicker {\n  position: relative;\n  display: inline-block;\n  width: 210px;\n  color: #73879c;\n  font: 14px/1.5 'Helvetica Neue', Helvetica, Arial, 'Microsoft Yahei', sans-serif; }\n  .mx-datepicker * {\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box; }\n  .mx-datepicker.disabled {\n    opacity: 0.7;\n    cursor: not-allowed; }\n\n.mx-datepicker-range {\n  width: 320px; }\n\n.mx-datepicker-popup {\n  position: absolute;\n  margin-top: 1px;\n  margin-bottom: 1px;\n  border: 1px solid #d9d9d9;\n  background-color: #fff;\n  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  z-index: 1000; }\n\n.mx-input-wrapper {\n  position: relative; }\n  .mx-input-wrapper .mx-clear-wrapper {\n    display: none; }\n  .mx-input-wrapper:hover .mx-clear-wrapper {\n    display: block; }\n  .mx-input-wrapper:hover .mx-clear-wrapper + .mx-input-append {\n    display: none; }\n\n.mx-input {\n  display: inline-block;\n  width: 100%;\n  height: 34px;\n  padding: 6px 30px;\n  padding-left: 10px;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #555;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); }\n  .mx-input:disabled, .mx-input.disabled {\n    opacity: 0.7;\n    cursor: not-allowed; }\n  .mx-input:focus {\n    outline: none; }\n  .mx-input::-ms-clear {\n    display: none; }\n\n.mx-input-append {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 30px;\n  height: 100%;\n  padding: 6px; }\n\n.mx-input-icon {\n  display: inline-block;\n  width: 100%;\n  height: 100%;\n  font-style: normal;\n  color: #555;\n  text-align: center;\n  cursor: pointer; }\n\n.mx-calendar-icon {\n  width: 100%;\n  height: 100%;\n  color: #555;\n  stroke-width: 8px;\n  stroke: currentColor;\n  fill: currentColor; }\n\n.mx-clear-icon::before {\n  display: inline-block;\n  content: '\\2716';\n  vertical-align: middle; }\n\n.mx-clear-icon::after {\n  content: '';\n  display: inline-block;\n  width: 0;\n  height: 100%;\n  vertical-align: middle; }\n\n.mx-range-wrapper {\n  width: 496px;\n  overflow: hidden; }\n\n.mx-shortcuts-wrapper {\n  text-align: left;\n  padding: 0 12px;\n  line-height: 34px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05); }\n  .mx-shortcuts-wrapper .mx-shortcuts {\n    background: none;\n    outline: none;\n    border: 0;\n    color: #48576a;\n    margin: 0;\n    padding: 0;\n    white-space: nowrap;\n    cursor: pointer; }\n    .mx-shortcuts-wrapper .mx-shortcuts:hover {\n      color: #419dec; }\n    .mx-shortcuts-wrapper .mx-shortcuts:after {\n      content: '|';\n      margin: 0 10px;\n      color: #48576a; }\n    .mx-shortcuts-wrapper .mx-shortcuts:last-child::after {\n      display: none; }\n\n.mx-datepicker-footer {\n  padding: 4px;\n  clear: both;\n  text-align: right;\n  border-top: 1px solid rgba(0, 0, 0, 0.05); }\n\n.mx-datepicker-btn {\n  font-size: 12px;\n  line-height: 1;\n  padding: 7px 15px;\n  margin: 0 5px;\n  cursor: pointer;\n  background-color: transparent;\n  outline: none;\n  border: none;\n  border-radius: 3px; }\n\n.mx-datepicker-btn-confirm {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  color: #73879c; }\n  .mx-datepicker-btn-confirm:hover {\n    color: #1284e7;\n    border-color: #1284e7; }\n\n/* 日历组件 */\n.mx-calendar {\n  float: left;\n  color: #73879c;\n  padding: 6px 12px;\n  font: 14px/1.5 Helvetica Neue, Helvetica, Arial, Microsoft Yahei, sans-serif; }\n  .mx-calendar * {\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box; }\n\n.mx-calendar-header {\n  padding: 0 4px;\n  height: 34px;\n  line-height: 34px;\n  text-align: center;\n  overflow: hidden; }\n  .mx-calendar-header > a {\n    color: inherit;\n    text-decoration: none;\n    cursor: pointer; }\n    .mx-calendar-header > a:hover {\n      color: #419dec; }\n  .mx-icon-last-month, .mx-icon-last-year,\n  .mx-icon-next-month,\n  .mx-icon-next-year {\n    padding: 0 6px;\n    font-size: 20px;\n    line-height: 30px;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none; }\n  .mx-icon-last-month, .mx-icon-last-year {\n    float: left; }\n  \n  .mx-icon-next-month,\n  .mx-icon-next-year {\n    float: right; }\n\n.mx-calendar-content {\n  width: 224px;\n  height: 224px; }\n  .mx-calendar-content .cell {\n    vertical-align: middle;\n    cursor: pointer; }\n    .mx-calendar-content .cell:hover {\n      background-color: #eaf8fe; }\n    .mx-calendar-content .cell.actived {\n      color: #fff;\n      background-color: #1284e7; }\n    .mx-calendar-content .cell.inrange {\n      background-color: #eaf8fe; }\n    .mx-calendar-content .cell.disabled {\n      cursor: not-allowed;\n      color: #ccc;\n      background-color: #f3f3f3; }\n\n.mx-panel {\n  width: 100%;\n  height: 100%;\n  text-align: center; }\n\n.mx-panel-date {\n  table-layout: fixed;\n  border-collapse: collapse;\n  border-spacing: 0; }\n  .mx-panel-date td,\n  .mx-panel-date th {\n    font-size: 12px;\n    width: 32px;\n    height: 32px;\n    padding: 0;\n    overflow: hidden;\n    text-align: center; }\n  .mx-panel-date td.today {\n    color: #2a90e9; }\n  .mx-panel-date td.last-month, .mx-panel-date td.next-month {\n    color: #ddd; }\n\n.mx-panel-year {\n  padding: 7px 0; }\n  .mx-panel-year .cell {\n    display: inline-block;\n    width: 40%;\n    margin: 1px 5%;\n    line-height: 40px; }\n\n.mx-panel-month .cell {\n  display: inline-block;\n  width: 30%;\n  line-height: 40px;\n  margin: 8px 1.5%; }\n\n.mx-time-list {\n  position: relative;\n  float: left;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  width: 100%;\n  height: 100%;\n  border-top: 1px solid rgba(0, 0, 0, 0.05);\n  border-left: 1px solid rgba(0, 0, 0, 0.05);\n  overflow-y: auto;\n  /* 滚动条滑块 */ }\n  .mx-time-list .mx-time-picker-item {\n    display: block;\n    text-align: left;\n    padding-left: 10px; }\n  .mx-time-list:first-child {\n    border-left: 0; }\n  .mx-time-list .cell {\n    width: 100%;\n    font-size: 12px;\n    height: 30px;\n    line-height: 30px; }\n  .mx-time-list::-webkit-scrollbar {\n    width: 8px;\n    height: 8px; }\n  .mx-time-list::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 0, 0, 0.05);\n    border-radius: 10px;\n    -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);\n            box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1); }\n  .mx-time-list:hover::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 0, 0, 0.2); }\n",""])},function(e,t,n){var a=n(5);"string"==typeof a&&(a=[[e.i,a,""]]),a.locals&&(e.exports=a.locals);(0,n(2).default)("511dbeb0",a,!0,{})}])});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["a"] = ({
  create: function create(VueApp, callback) {
    var user = VueApp.$store.state.corporate.profile.info;
    var countryCode = VueApp.$store.state.countryCode.callingCode;
    VueApp.$sdk.post('/admin/corporateprofile', {
      token: VueApp.$store.state.session.sessionToken,
      name: user.name,
      username: user.username,
      password: user.password,
      contactEmail: user.email,
      contactPhone: '+' + countryCode + user.mobile,
      billingAddress1: user.billingAddress1,
      billingAddress2: user.billingAddress2,
      billingCity: user.billingCity,
      billingState: user.billingState,
      billingZip: user.billingZip,
      billingCountry: user.biilingCountry,
      logoUrl: user.logo,
      corporateColor: user.color,
      corporateWebsiteUrl: user.website,
      active: 1,
      countryCode: countryCode,
      nationalNumber: user.mobile
    }, function (res) {
      callback(res);
    });
  },
  getInfo: function getInfo(VueApp, id, callback) {
    VueApp.$sdk.get('/admin/corporateprofile', {
      token: VueApp.$store.state.session.sessionToken,
      orderAsc: 0,
      order: 'created',
      pageSize: 2,
      pageNum: 1,
      id: id
    }, function (res) {
      callback(res);
    });
  },
  update: function update(VueApp, callback) {
    var user = VueApp.$store.state.corporate.profile.info;
    var countryCode = VueApp.$store.state.countryCode.callingCode;
    VueApp.$sdk.post('/admin/corporateprofile/' + user.id, {
      token: VueApp.$store.state.session.sessionToken,
      name: user.name,
      username: user.username,
      contactEmail: user.email,
      contactPhone: '+' + countryCode + user.mobile,
      billingAddress1: user.billingAddress1,
      billingAddress2: user.billingAddress2,
      billingCity: user.billingCity,
      billingState: user.billingState,
      billingZip: user.billingZip,
      billingCountry: user.biilingCountry,
      logoUrl: user.logo,
      corporateColor: user.color,
      corporateWebsiteUrl: user.website,
      discountCode: user.discountCode,
      countryCode: countryCode,
      nationalNumber: user.mobile
    }, function (res) {
      callback(res);
    });
  },
  toggleStatus: function toggleStatus(VueApp, data, callback) {
    var user = VueApp.$store.state.corporate.profile.info;
    VueApp.$sdk.post('/admin/corporateprofile/' + data.id, {
      token: VueApp.$store.state.session.sessionToken,
      active: data.active ? 0 : 1
    }, function (res) {
      callback(res);
    });
  },
  getAllTransactions: function getAllTransactions(VueApp, id, callback) {
    // let self = this
    var tableData = VueApp.$store.state.corporate.invoice;
    // let pageSize = tableData.perPage
    // let page = tableData.currentPage
    var since = __WEBPACK_IMPORTED_MODULE_0_moment___default()(tableData.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00');
    var until = __WEBPACK_IMPORTED_MODULE_0_moment___default()(tableData.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59');

    VueApp.$sdk.get('/admin/corporateprofile/' + id + '/invoice', {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: 999,
      pageNum: 1,
      order: 'created',
      orderAsc: 0,
      completeSince: since,
      completeUntil: until
    }, function (res) {
      callback(res);
    });
  },
  bookedThroughLabel: function bookedThroughLabel(value) {
    switch (value) {
      case 'ww':
        return 'Web';
      case 'admin':
        return 'Admin';
      case 'android':
        return 'Android App';
      case 'ios':
        return 'iOS App';
      case 'provider':
        return 'Provider';
      default:
        return value;
    }

    return '';
  },
  toFixed: function toFixed(value) {
    value = parseFloat(value);
    if (value < 0) {
      return '-$' + Math.abs(value).toFixed(2);
    }
    return '$' + value.toFixed(2);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(43);
var call = __webpack_require__(172);
var isArrayIter = __webpack_require__(173);
var anObject = __webpack_require__(39);
var toLength = __webpack_require__(98);
var getIterFn = __webpack_require__(124);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db210524_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArrowUp_vue__ = __webpack_require__(1268);
function injectStyle (ssrContext) {
  __webpack_require__(1266)
}
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-db210524"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db210524_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArrowUp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0720302_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceDog_vue__ = __webpack_require__(1278);
function injectStyle (ssrContext) {
  __webpack_require__(1276)
}
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d0720302"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0720302_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceDog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_583d8a06_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wheelchair_vue__ = __webpack_require__(1281);
function injectStyle (ssrContext) {
  __webpack_require__(1279)
}
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-583d8a06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_583d8a06_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wheelchair_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);


var phoneUtil = __webpack_require__(50).PhoneNumberUtil.getInstance();
// import ft from '../featureToggle'

/* harmony default export */ __webpack_exports__["a"] = ({
  getList: function getList(VueApp, data, callback) {
    // let providers = VueApp.$store.state.provider.users
    var providers = VueApp.$store.state.services.users;
    VueApp.$sdk.get('/provider', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      token: VueApp.$store.state.session.sessionToken,
      pageNum: providers.currentPage,
      pageSize: providers.perPage,
      order: providers.order,
      orderAsc: providers.orderAsc,
      licenseType: providers.type,
      accountStatus: providers.status,
      search: providers.search
    }, data), function (res) {
      if (!res.error) {
        // VueApp.$store.commit('provider/setUserCurrentPage', providers.currentPage + 1)
        // VueApp.$store.commit('provider/setUserMaxList', res.paging.totalItems)
        VueApp.$store.commit('services/setUserMaxList', res.paging.totalItems);

        if (res.list.length) {
          for (var i = 0; i < res.list.length; i++) {
            var userInfo = res.list[i];
            var license = '';
            var insurance = '';
            var permit = '';
            var cityLicense = '';
            var airport = '';
            var safetyInspect = '';
            if (userInfo.vehicle) {
              if (userInfo.vehicle.driverLicenseExp && userInfo.vehicle.driverLicenseExp !== '0000-00-00 00:00:00') {
                license = __WEBPACK_IMPORTED_MODULE_1_moment___default()(userInfo.vehicle.driverLicenseExp, 'YYYY-MM-DD').format('MM/DD/YYYY');
              }
              if (userInfo.vehicle.insurancePolicyExp && userInfo.vehicle.insurancePolicyExp !== '0000-00-00 00:00:00') {
                insurance = __WEBPACK_IMPORTED_MODULE_1_moment___default()(userInfo.vehicle.insurancePolicyExp, 'YYYY-MM-DD').format('MM/DD/YYYY');
              }
              if (userInfo.vehicle.tcpPermitExp && userInfo.vehicle.tcpPermitExp !== '0000-00-00 00:00:00') {
                permit = __WEBPACK_IMPORTED_MODULE_1_moment___default()(userInfo.vehicle.tcpPermitExp, 'YYYY-MM-DD').format('MM/DD/YYYY');
              }
              if (userInfo.vehicle.cityLicenseExp && userInfo.vehicle.cityLicenseExp !== '0000-00-00 00:00:00') {
                cityLicense = __WEBPACK_IMPORTED_MODULE_1_moment___default()(userInfo.vehicle.cityLicenseExp, 'YYYY-MM-DD').format('MM/DD/YYYY');
              }
              if (userInfo.vehicle.airportPermitExp && userInfo.vehicle.airportPermitExp !== '0000-00-00 00:00:00') {
                airport = __WEBPACK_IMPORTED_MODULE_1_moment___default()(userInfo.vehicle.airportPermitExp, 'YYYY-MM-DD').format('MM/DD/YYYY');
              }
              if (userInfo.providerAccountType === 'tnc') {
                permit = '';
                cityLicense = '';
                airport = '';
              }
              safetyInspect = userInfo.vehicle.vehicleSafetyInspectionByExp ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(userInfo.vehicle.vehicleSafetyInspectionByExp, 'YYYY-MM-DD').format('MM/DD/YYYY') : '';
            }
            var lastLogin = '';
            if (userInfo.lastLogin && userInfo.lastLogin !== 'Invalid date') {
              lastLogin = __WEBPACK_IMPORTED_MODULE_1_moment___default()(userInfo.lastLogin, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mm');
            }

            // VueApp.$store.commit('provider/addUser', {
            //   id: userInfo.ID,
            //   business: userInfo.businessName || '',
            //   type: userInfo.providerAccountType || '',
            //   status: userInfo.accountStatus,
            //   lastUpdate: userInfo.modified ? moment(userInfo.modified, 'YYYY-MM-DD').format('MM/DD/YYYY') : '',
            //   license: license,
            //   insurance: insurance,
            //   permit: permit,
            //   cityLicense: cityLicense,
            //   airport: airport,
            //   // drivingRecord: '****',
            //   safetyInspect: safetyInspect,
            //   // lastWeeksEarning: '****',
            //   // avgRating: '****',
            //   lastLogin: lastLogin,
            //   bgCheck: userInfo.backgroundCheck !== 'none',
            //   verified: userInfo.login && userInfo.login.verified === 1,
            //   archived: userInfo.login && userInfo.login.archived === 1,
            //   driverImg: userInfo.avatarUrl,
            //   carImg: userInfo.vehicle ? userInfo.vehicle.photoUrl : '',
            //   car: userInfo.vehicle ? userInfo.vehicle.manufacturer + ' ' + userInfo.vehicle.model : '',
            //   plateNo: userInfo.vehicle ? userInfo.vehicle.licensePlate : '',
            //   vehicleType: userInfo.vehicle ? userInfo.vehicle.type : ''
            // })

            VueApp.$store.commit('services/addUser', {
              id: userInfo.ID,
              business: userInfo.businessName || '',
              type: userInfo.providerAccountType || '',
              status: userInfo.accountStatus,
              lastUpdate: userInfo.modified ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(userInfo.modified, 'YYYY-MM-DD').format('MM/DD/YYYY') : '',
              license: license,
              insurance: insurance,
              permit: permit,
              cityLicense: cityLicense,
              airport: airport,
              // drivingRecord: '****',
              safetyInspect: safetyInspect,
              // lastWeeksEarning: '****',
              // avgRating: '****',
              lastLogin: lastLogin,
              bgCheck: userInfo.backgroundCheck !== 'none',
              verified: userInfo.login && userInfo.login.verified === 1,
              archived: userInfo.login && userInfo.login.archived === 1,
              driverImg: userInfo.avatarUrl,
              carImg: userInfo.vehicle ? userInfo.vehicle.photoUrl : '',
              car: userInfo.vehicle ? userInfo.vehicle.manufacturer + ' ' + userInfo.vehicle.model : '',
              plateNo: userInfo.vehicle ? userInfo.vehicle.licensePlate : '',
              vehicleType: userInfo.vehicle ? userInfo.vehicle.type : ''
            });
          }
        }
      }
      callback(res);
    });
  },
  getList2: function getList2(VueApp, data, callback) {
    // let self = this
    var providers = VueApp.$store.state.provider.users;
    var params = {
      token: VueApp.$store.state.session.sessionToken,
      pageNum: providers[data.target].currentPage,
      pageSize: providers[data.target].perPage,
      order: providers[data.target].order,
      orderAsc: providers[data.target].orderAsc,
      paging: 1,
      status: data.status,
      license: data.type,
      search: providers.search
      // serviceTypeId: [providers.serviceType || '']
    };
    if (data.hasOwnProperty('isPax')) {
      params.isPax = data.isPax;
    }
    if (data.hasOwnProperty('isDTD')) {
      params.isDTD = data.isDTD;
    }
    VueApp.$sdk.get('/provider/export', params, function (res) {
      if (!res.error) {
        VueApp.$store.commit('provider/setUserMaxList', {
          target: data.target,
          value: res.paging.totalItems
        });

        if (res.list.length) {
          for (var i = 0; i < res.list.length; i++) {
            var userInfo = res.list[i];
            var lastLogin = '--';
            if (userInfo.lastDuty && userInfo.lastDuty !== 'Invalid date') {
              lastLogin = __WEBPACK_IMPORTED_MODULE_1_moment___default()(userInfo.lastDuty, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mm');
            }

            var service = '';
            if (userInfo.isPax) {
              service = 'PAX';
            }
            if (userInfo.isDTD) {
              service = 'DTD';
            }
            if (userInfo.isPax && userInfo.isDTD) {
              service = 'PAX/DTD';
            }
            VueApp.$store.commit('provider/addUser', {
              target: data.target,
              id: userInfo.ID,
              driverNum: userInfo.driverNum || '',
              business: userInfo.businessName || '',
              type: userInfo.licenseType || '',
              status: userInfo.duty || '',
              service: service,
              vehicleType: userInfo.vehicleType || '',
              city: userInfo.city,
              phone: userInfo.phoneNumber,
              created: userInfo.created ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(userInfo.created, 'YYYY-MM-DD').format('MM/DD/YYYY') : '',
              lastUpdate: userInfo.modified ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(userInfo.modified, 'YYYY-MM-DD').format('MM/DD/YYYY') : '',
              lastLogin: lastLogin,
              bgCheck: userInfo.backgroundCheck !== 'none',
              verified: userInfo.login && userInfo.login.verified === 1,
              bgCheckPassed: userInfo.backgroundCheckPassed,
              bgCheckSubmitted: userInfo.backgroundCheckSubmitted,
              wheelChairLift: userInfo.wheelChairLift
            });
          }
        }
        callback(res);
      } else {
        callback(res);
      }
    });
  },
  updateStatus: function updateStatus(VueApp, data, callback) {
    var action = data.isActive ? 'post' : 'delete';

    VueApp.$sdk[action]('/provider/' + data.id + '/active', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      callback(res);
    });
  },
  archiveUser: function archiveUser(VueApp, id, callback) {
    VueApp.$sdk.post('/provider/' + id + '/archive', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      callback(res);
    });
  },
  export: function _export(VueApp, target, callback) {
    var self = this;
    var providers = VueApp.$store.state.provider.users;
    var status = VueApp.$store.state.provider.users.status;
    VueApp.$sdk.get('/provider/export', {
      token: VueApp.$store.state.session.sessionToken,
      pageNum: providers[target].currentPage,
      pageSize: providers[target].perPage,
      order: providers[target].order,
      orderAsc: providers[target].orderAsc,
      paging: 1,
      status: status,
      license: target,
      search: providers.search
    }, function (res) {
      if (!res.error) {
        var trx = [];
        if (res.list.length) {
          res.list.forEach(function (value) {
            trx.push(self.buildExportAll(value));
          });
        }
        callback(trx);
      } else {
        callback(res);
      }
    });
  },
  exportAll: function exportAll(VueApp, target, callback) {
    var self = this;
    var providers = VueApp.$store.state.provider.users;
    var params = {
      token: VueApp.$store.state.session.sessionToken,
      status: providers.status,
      license: target
    };
    if (providers.serviceFilter === 'PAX') {
      params.isPax = 1;
      params.isDTD = 0;
    }
    if (providers.serviceFilter === 'DTD') {
      params.isPax = 0;
      params.isDTD = 1;
    }
    if (providers.serviceFilter === 'PAX/DTD') {
      params.isPax = 1;
      params.isDTD = 1;
    }
    VueApp.$sdk.get('/provider/export', params, function (res) {
      if (!res.error) {
        var trx = [];
        if (res.list.length) {
          res.list.forEach(function (value) {
            trx.push(self.buildExportAll(value));
          });
        }
        callback(trx);
      } else {
        callback(res);
      }
    });
  },
  buildExport: function buildExport(data) {
    var license = '';
    var insurance = '';
    var permit = '';
    var cityLicense = '';
    var airport = '';
    var safetyInspect = '';
    if (data.vehicle) {
      license = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.vehicle.driverLicenseExp, 'YYYY-MM-DD').format('MM/DD/YYYY');
      insurance = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.vehicle.insurancePolicyExp, 'YYYY-MM-DD').format('MM/DD/YYYY');
      permit = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.vehicle.tcpPermitExp, 'YYYY-MM-DD').format('MM/DD/YYYY');
      cityLicense = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.vehicle.cityLicenseExp, 'YYYY-MM-DD').format('MM/DD/YYYY');
      airport = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.vehicle.airportPermitExp, 'YYYY-MM-DD').format('MM/DD/YYYY');
      if (data.providerAccountType === 'tnc') {
        permit = '';
        cityLicense = '';
        airport = '';
      }
      safetyInspect = data.vehicle.vehicleSafetyInspectionByExp ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.vehicle.vehicleSafetyInspectionByExp, 'YYYY-MM-DD').format('MM/DD/YYYY') : '';
    }
    var drivingRecordExp = '';
    if (data.drivingRecordExp) {
      drivingRecordExp = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.drivingRecordExp, 'YYYY-MM-DD').format('MM/DD/YYYY');
    }
    var lastLogin = '';
    if (data.lastLogin) {
      lastLogin = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.lastLogin, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mm');
    }

    var bday = '';
    if (data.dateOfBirth) {
      bday = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.dateOfBirth, 'YYYY-MM-DD').format('MM/DD/YYYY');
    }

    var mobile = '';
    var tempPhone = data.phone.toString();
    if (data.phone && typeof data.phone !== 'number') {
      mobile = data.phone;
    } else if (data.phone && tempPhone.length > 9) {
      var number = phoneUtil.parseAndKeepRawInput('' + data.phone + '', 'US');
      mobile = phoneUtil.formatInOriginalFormat(number, 'US');
    }
    if (data.countryCode) {
      mobile = '+' + data.countryCode + ' ' + mobile;
    }

    var shared = 0;
    var opoli = 0;
    var black = 0;
    var suv = 0;
    var shuttle = 0;
    if (data.services && data.services.shared) {
      shared = 1;
    }
    if (data.services && data.services.opoli) {
      opoli = 1;
    }
    if (data.services && data.services.black) {
      black = 1;
    }
    if (data.services && data.services.suv) {
      suv = 1;
    }
    if (data.services && data.services.shuttle) {
      shuttle = 1;
    }

    var address1 = '';
    var address2 = '';
    var city = '';
    var state = '';
    var country = '';
    var zip = '';
    if (data.address) {
      address1 = data.address.addressLine1 || '';
      address2 = data.address.addressLine2 || '';
      city = data.address.city || '';
      state = data.address.state || '';
      country = data.address.country || '';
      zip = data.address.zipCode || '';
    }
    var created = '';
    if (data.created) {
      created = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.created, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY HH:mm:ss');
    }

    return {
      'Prov ID': data.ID,
      'Business Name': data.businessName || '',
      'Type': data.providerAccountType.toUpperCase() || '',
      'Status': data.accountStatus,
      'First Name': data.firstName,
      'Last Name': data.lastName,
      'Email': data.email,
      'Mobile': mobile,
      'Birthday': bday,
      'Address1': address1,
      'Address2': address2,
      'City': city,
      'State': state,
      'Country': country,
      'Zip': zip,
      'Language': data.language || 'english',
      'Created': created,
      'Last Update': __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.modified, 'YYYY-MM-DD').format('MM/DD/YYYY'),
      'Vehicle Type': data.vehicle.type || '',
      'Make': data.vehicle.manufacturer || '',
      'Model': data.vehicle.model || '',
      'Year': data.vehicle.manufactured || '',
      'License Plate': data.vehicle.licensePlate || '',
      'Seat Capacity': data.vehicle.seatCapacity,
      'VIN': data.vehicle.vehicleIdNumber,
      'Insurance Company Name': data.vehicle.insuranceCompany || '',
      'Insurance Policy #': data.vehicle.insurancePolicyNumber || '',
      'Insurance Exp. Date': insurance,
      'TCP Permit #': data.vehicle.tcpPermitNumber || '',
      'TCP Permit Exp. Date': permit,
      'City License #': data.vehicle.cityLicenseNumber || '',
      'City License Exp. Date': cityLicense,
      'Airport Permit #': data.vehicle.airportPermitNumber || '',
      'Airport Exp. Date': airport,
      'Driver\'s License #': data.vehicle.driverLicenseNumber || '',
      'Driver\'s License Exp. Date': license,
      'Driving Record Exp. Date': drivingRecordExp,
      'Safety Inspect': safetyInspect,
      'Last Login Timestamp': lastLogin,
      'BG Check': data.backgroundCheck !== 'none',
      'Shared': shared,
      'Opoli': opoli,
      'Black': black,
      'SUV': suv,
      'Private Shuttle': shuttle
    };
  },
  buildExportAll: function buildExportAll(data) {
    var licenseType = '';
    if (data.licenseType) {
      licenseType = data.licenseType.toUpperCase();
    }

    var bday = '';
    if (data.dateOfBirth) {
      var temp = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.dateOfBirth, 'YYYY-MM-DD HH:mm:ss');
      if (temp.isValid()) {
        bday = temp.format('MM/DD/YYYY');
      }
    }

    var created = '';
    if (data.created) {
      var _temp = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.created, 'YYYY-MM-DD HH:mm:ss');
      if (_temp.isValid()) {
        created = _temp.format('MM/DD/YYYY HH:mm:ss');
      }
    }

    var modified = '';
    if (data.modified) {
      var _temp2 = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.modified, 'YYYY-MM-DD HH:mm:ss');
      if (_temp2.isValid()) {
        modified = _temp2.format('MM/DD/YYYY HH:mm:ss');
      }
    }

    var insurance = '';
    if (data.insurancePolicyExp) {
      var _temp3 = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.insurancePolicyExp, 'YYYY-MM-DD HH:mm:ss');
      if (_temp3.isValid()) {
        insurance = _temp3.format('MM/DD/YYYY HH:mm:ss');
      }
    }

    var permit = '';
    if (data.tcpPermitExp) {
      var _temp4 = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.tcpPermitExp, 'YYYY-MM-DD HH:mm:ss');
      if (_temp4.isValid()) {
        permit = _temp4.format('MM/DD/YYYY HH:mm:ss');
      }
    }

    var cityLicense = '';
    if (data.cityLicenseExp) {
      var _temp5 = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.cityLicenseExp, 'YYYY-MM-DD HH:mm:ss');
      if (_temp5.isValid()) {
        cityLicense = _temp5.format('MM/DD/YYYY HH:mm:ss');
      }
    }

    var airport = '';
    if (data.airportPermitExp) {
      var _temp6 = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.airportPermitExp, 'YYYY-MM-DD HH:mm:ss');
      if (_temp6.isValid()) {
        airport = _temp6.format('MM/DD/YYYY HH:mm:ss');
      }
    }

    var license = '';
    if (data.driverLicenseExp) {
      var _temp7 = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.driverLicenseExp, 'YYYY-MM-DD HH:mm:ss');
      if (_temp7.isValid()) {
        license = _temp7.format('MM/DD/YYYY HH:mm:ss');
      }
    }

    var drivingRecordExp = '';
    if (data.drivingRecordExp) {
      var _temp8 = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.drivingRecordExp, 'YYYY-MM-DD HH:mm:ss');
      if (_temp8.isValid()) {
        drivingRecordExp = _temp8.format('MM/DD/YYYY HH:mm:ss');
      }
    }

    var safetyInspect = '';
    if (data.vehicleSafetyInspectionByExp) {
      var _temp9 = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.vehicleSafetyInspectionByExp, 'YYYY-MM-DD HH:mm:ss');
      if (_temp9.isValid()) {
        safetyInspect = _temp9.format('MM/DD/YYYY HH:mm:ss');
      }
    }

    var lastLogin = '';
    if (data.lastLogin) {
      var _temp10 = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.lastLogin, 'YYYY-MM-DD HH:mm:ss');
      if (_temp10.isValid()) {
        lastLogin = _temp10.format('MM/DD/YYYY HH:mm:ss');
      }
    }

    var service = '';
    if (data.isPax) {
      service = 'PAX';
    }
    if (data.isDTD) {
      service = 'DTD';
    }
    if (data.isPax && data.isDTD) {
      service = 'PAX/DTD';
    }

    return {
      'Prov ID': data.ID,
      'Business Name': data.businessName || '',
      'Type': licenseType,
      'Status': data.status,
      'Service': service,
      'First Name': data.firstName,
      'Last Name': data.lastName,
      'Email': data.email,
      'Mobile': data.phoneNumber,
      'Birthday': bday,
      'SSN': data.businessSSN || '',
      'EIN': data.businessEIN || '',
      'Address1': data.addressLine1 || '',
      'Address2': data.addressLine2 || '',
      'City': data.city,
      'State': data.state,
      'Country': data.country,
      'Zip': data.zipCode,
      'Language': data.language || 'english',
      'Created Date': created,
      'Last Update': modified,
      'Vehicle Type': data.vehicleType || '',
      'Make': data.make || '',
      'Model': data.model || '',
      'Year': data.makeYear || '',
      'License Plate': data.licensePlate || '',
      'Seat Capacity': data.seatCapacity,
      'VIN': data.vehicleIdNumber || '',
      'Insurance Company Name': data.insuranceCompany || '',
      'Insurance Policy #': data.insurancePolicyNumber || '',
      'Insurance Exp. Date': insurance,
      'TCP Permit #': data.tcpPermitNumber || '',
      'TCP Permit Exp. Date': permit,
      'City License #': data.cityLicenseNumber || '',
      'City License Exp. Date': cityLicense,
      'Airport Permit #': data.airportPermitNumber || '',
      'Airport Exp. Date': airport,
      'Driver\'s License #': data.driverLicenseNumber || '',
      'Driver\'s License Exp. Date': license,
      'Driving Record Exp. Date': drivingRecordExp,
      'Safety Inspect': safetyInspect,
      'Last Login Timestamp': lastLogin,
      'BG Check': data.backgroundCheckPassed !== 0,
      'Services': data.serviceTypeNames || ''
      // 'Shared': shared,
      // 'Opoli': opoli,
      // 'Black': black,
      // 'SUV': suv,
      // 'Private Shuttle': shuttle
    };
  }
});

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(117);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 99 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(710), __esModule: true };

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(78);
var TAG = __webpack_require__(19)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matcher;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extendOwn_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMatch_js__ = __webpack_require__(187);



// Returns a predicate for checking whether an object has a given set of
// `key:value` pairs.
function matcher(attrs) {
  attrs = Object(__WEBPACK_IMPORTED_MODULE_0__extendOwn_js__["a" /* default */])({}, attrs);
  return function(obj) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__isMatch_js__["a" /* default */])(obj, attrs);
  };
}


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__executeBound_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__underscore_js__ = __webpack_require__(24);




// Partially apply a function by creating a version that has had some of its
// arguments pre-filled, without changing its dynamic `this` context. `_` acts
// as a placeholder by default, allowing any combination of arguments to be
// pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
var partial = Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(func, boundArgs) {
  var placeholder = partial.placeholder;
  var bound = function() {
    var position = 0, length = boundArgs.length;
    var args = Array(length);
    for (var i = 0; i < length; i++) {
      args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
    }
    while (position < arguments.length) args.push(arguments[position++]);
    return Object(__WEBPACK_IMPORTED_MODULE_1__executeBound_js__["a" /* default */])(func, bound, this, this, args);
  };
  return bound;
});

partial.placeholder = __WEBPACK_IMPORTED_MODULE_2__underscore_js__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (partial);


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = group;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each_js__ = __webpack_require__(59);



// An internal function used for aggregate "group by" operations.
function group(behavior, partition) {
  return function(obj, iteratee, context) {
    var result = partition ? [[], []] : {};
    iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(iteratee, context);
    Object(__WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */])(obj, function(value, index) {
      var key = iteratee(value, index, obj);
      behavior(result, value, key);
    });
    return result;
  };
}


/***/ }),
/* 105 */
/***/ (function(module, exports) {



/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["EmojiMart"] = factory();
	else
		root["EmojiMart"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 71);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(75)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(33)('wks');
var uid = __webpack_require__(21);
var Symbol = __webpack_require__(5).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 4 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 5 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(9);
var IE8_DOM_DEFINE = __webpack_require__(49);
var toPrimitive = __webpack_require__(30);
var dP = Object.defineProperty;

exports.f = __webpack_require__(10) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(6);
var createDesc = __webpack_require__(15);
module.exports = __webpack_require__(10) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(11)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(54);
var defined = __webpack_require__(28);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(4);
var ctx = __webpack_require__(48);
var hide = __webpack_require__(8);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(53);
var enumBugKeys = __webpack_require__(34);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nimbleEmoji_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nimbleEmoji_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nimbleEmoji_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nimbleEmoji_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nimbleEmoji_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f853594_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nimbleEmoji_vue__ = __webpack_require__(119);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(84)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f853594"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nimbleEmoji_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f853594_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nimbleEmoji_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/emoji/nimbleEmoji.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7f853594", Component.options)
  } else {
    hotAPI.reload("data-v-7f853594", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Object = Object;

exports.default = _Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.measureScrollbar = exports.unifiedToNative = exports.deepMerge = exports.intersect = exports.uniq = exports.getSanitizedData = exports.getData = undefined;

var _typeof2 = __webpack_require__(86);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(111);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(58);

var _assign2 = _interopRequireDefault(_assign);

var _data = __webpack_require__(24);

var _stringFromCodePoint = __webpack_require__(118);

var _stringFromCodePoint2 = _interopRequireDefault(_stringFromCodePoint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _JSON = JSON;

var COLONS_REGEX = /^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/;
var SKINS = ['1F3FA', '1F3FB', '1F3FC', '1F3FD', '1F3FE', '1F3FF'];

function unifiedToNative(unified) {
  var unicodes = unified.split('-'),
      codePoints = unicodes.map(function (u) {
    return '0x' + u;
  });

  return _stringFromCodePoint2.default.apply(null, codePoints);
}

function sanitize(emoji) {
  var name = emoji.name;
  var short_names = emoji.short_names;
  var skin_tone = emoji.skin_tone;
  var skin_variations = emoji.skin_variations;
  var emoticons = emoji.emoticons;
  var unified = emoji.unified;
  var custom = emoji.custom;
  var imageUrl = emoji.imageUrl;
  var id = emoji.id || short_names[0];
  var colons = ':' + id + ':';

  if (custom) {
    return {
      id: id,
      name: name,
      colons: colons,
      emoticons: emoticons,
      custom: custom,
      imageUrl: imageUrl
    };
  }

  if (skin_tone) {
    colons += ':skin-tone-' + skin_tone + ':';
  }

  return {
    id: id,
    name: name,
    colons: colons,
    emoticons: emoticons,
    unified: unified.toLowerCase(),
    skin: skin_tone || (skin_variations ? 1 : null),
    native: unifiedToNative(unified)
  };
}

function getSanitizedData() {
  return sanitize(getData.apply(undefined, arguments));
}

function cloneEmoji(emoji) {
  if (typeof emoji === 'string') {
    return emoji;
  }

  return (0, _assign2.default)({}, emoji);
}

function getData(_emoji, skin, set, data) {
  var emoji = cloneEmoji(_emoji);
  var emojiData = {};

  if (typeof emoji == 'string') {
    var matches = emoji.match(COLONS_REGEX);

    if (matches) {
      emoji = matches[1];

      if (matches[2]) {
        skin = parseInt(matches[2], 10);
      }
    }

    if (data.aliases.hasOwnProperty(emoji)) {
      emoji = data.aliases[emoji];
    }

    if (data.emojis.hasOwnProperty(emoji)) {
      emojiData = data.emojis[emoji];
    } else {
      return null;
    }
  } else if (emoji.id) {
    if (data.aliases.hasOwnProperty(emoji.id)) {
      emoji.id = data.aliases[emoji.id];
    }

    if (data.emojis.hasOwnProperty(emoji.id)) {
      emojiData = data.emojis[emoji.id];
      skin || (skin = emoji.skin);
    }
  }

  if (!(0, _keys2.default)(emojiData).length) {
    emojiData = emoji;
    emojiData.custom = true;

    if (!emojiData.search) {
      emojiData.search = (0, _data.buildSearch)(emoji);
    }
  }

  emojiData.emoticons || (emojiData.emoticons = []);
  emojiData.variations || (emojiData.variations = []);

  if (emojiData.skin_variations && skin > 1) {
    emojiData = JSON.parse(_JSON.stringify(emojiData));

    var skinKey = SKINS[skin - 1],
        variationData = emojiData.skin_variations[skinKey];

    if (!variationData.variations && emojiData.variations) {
      delete emojiData.variations;
    }

    if (set == 'native' || variationData['has_img_' + set] == undefined || variationData['has_img_' + set]) {
      emojiData.skin_tone = skin;

      for (var k in variationData) {
        var v = variationData[k];
        emojiData[k] = v;
      }
    }
  }

  if (emojiData.variations && emojiData.variations.length) {
    emojiData = JSON.parse(_JSON.stringify(emojiData));
    emojiData.unified = emojiData.variations.shift();
  }

  return emojiData;
}

function uniq(arr) {
  return arr.reduce(function (acc, item) {
    if (acc.indexOf(item) === -1) {
      acc.push(item);
    }
    return acc;
  }, []);
}

function intersect(a, b) {
  var uniqA = uniq(a);
  var uniqB = uniq(b);

  return uniqA.filter(function (item) {
    return uniqB.indexOf(item) >= 0;
  });
}

function deepMerge(a, b) {
  var o = {};

  for (var key in a) {
    var originalValue = a[key],
        value = originalValue;

    if (b.hasOwnProperty(key)) {
      value = b[key];
    }

    if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object') {
      value = deepMerge(originalValue, value);
    }

    o[key] = value;
  }

  return o;
}

// https://github.com/sonicdoe/measure-scrollbar
function measureScrollbar() {
  if (typeof document == 'undefined') return 0;
  var div = document.createElement('div');

  div.style.width = '100px';
  div.style.height = '100px';
  div.style.overflow = 'scroll';
  div.style.position = 'absolute';
  div.style.top = '-9999px';

  document.body.appendChild(div);
  var scrollbarWidth = div.offsetWidth - div.clientWidth;
  document.body.removeChild(div);

  return scrollbarWidth;
}

exports.getData = getData;
exports.getSanitizedData = getSanitizedData;
exports.uniq = uniq;
exports.intersect = intersect;
exports.deepMerge = deepMerge;
exports.unifiedToNative = unifiedToNative;
exports.measureScrollbar = measureScrollbar;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(28);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mapping = {
  name: 'a',
  unified: 'b',
  non_qualified: 'c',
  has_img_apple: 'd',
  has_img_google: 'e',
  has_img_twitter: 'f',
  has_img_emojione: 'g',
  has_img_facebook: 'h',
  has_img_messenger: 'i',
  keywords: 'j',
  sheet: 'k',
  emoticons: 'l',
  text: 'm',
  short_names: 'n',
  added_in: 'o'
};

var buildSearch = function buildSearch(emoji) {
  var search = [];

  var addToSearch = function addToSearch(strings, split) {
    if (!strings) {
      return;
    }

    ;(Array.isArray(strings) ? strings : [strings]).forEach(function (string) {
      ;(split ? string.split(/[-|_|\s]+/) : [string]).forEach(function (s) {
        s = s.toLowerCase();

        if (search.indexOf(s) == -1) {
          search.push(s);
        }
      });
    });
  };

  addToSearch(emoji.short_names, true);
  addToSearch(emoji.name, true);
  addToSearch(emoji.keywords, false);
  addToSearch(emoji.emoticons, false);

  return search.join(',');
};

var compress = function compress(emoji) {
  emoji.short_names = emoji.short_names.filter(function (short_name) {
    return short_name !== emoji.short_name;
  });
  delete emoji.short_name;

  emoji.sheet = [emoji.sheet_x, emoji.sheet_y];
  delete emoji.sheet_x;
  delete emoji.sheet_y;

  emoji.added_in = parseInt(emoji.added_in);
  if (emoji.added_in === 6) {
    delete emoji.added_in;
  }

  for (var key in mapping) {
    emoji[mapping[key]] = emoji[key];
    delete emoji[key];
  }

  for (var _key in emoji) {
    var value = emoji[_key];

    if (Array.isArray(value) && !value.length) {
      delete emoji[_key];
    } else if (typeof value === 'string' && !value.length) {
      delete emoji[_key];
    } else if (value === null) {
      delete emoji[_key];
    }
  }
};

var uncompress = function uncompress(data) {
  data.compressed = false;

  for (var id in data.emojis) {
    var emoji = data.emojis[id];

    for (var key in mapping) {
      emoji[key] = emoji[mapping[key]];
      delete emoji[mapping[key]];
    }

    if (!emoji.short_names) emoji.short_names = [];
    emoji.short_names.unshift(id);

    emoji.sheet_x = emoji.sheet[0];
    emoji.sheet_y = emoji.sheet[1];
    delete emoji.sheet;

    if (!emoji.text) emoji.text = '';

    if (!emoji.added_in) emoji.added_in = 6;
    emoji.added_in = emoji.added_in.toFixed(1);

    emoji.search = buildSearch(emoji);
  }
};

module.exports = { buildSearch: buildSearch, compress: compress, uncompress: uncompress };

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var EmojiProps = {
  backgroundImageFn: {
    type: Function,
    default: function _default(set, sheetSize) {
      return 'https://unpkg.com/emoji-datasource-' + set + '@' + '4.0.4' + '/img/' + set + '/sheets-256/' + sheetSize + '.png';
    }
  },
  native: {
    type: Boolean,
    default: false
  },
  forceSize: {
    type: Boolean,
    default: false
  },
  tooltip: {
    type: Boolean,
    default: false
  },
  fallback: {
    type: Function
  },
  skin: {
    type: Number,
    default: 1
  },
  sheetSize: {
    type: Number,
    default: 64
  },
  set: {
    type: String,
    default: 'apple'
  },
  size: {
    type: Number,
    default: 24
  },
  emoji: {
    type: [String, Object],
    required: true
  }
};

var PickerProps = {
  perLine: {
    type: Number,
    default: 9
  },
  emojiSize: {
    type: Number,
    default: 24
  },
  title: {
    type: String,
    default: 'Emoji Mart™'
  },
  emoji: {
    type: String,
    default: 'department_store'
  },
  color: {
    type: String,
    default: '#ae65c5'
  },
  set: {
    type: String,
    default: 'apple'
  },
  skin: {
    type: Number,
    default: null
  },
  defaultSkin: {
    type: Number,
    default: 1
  },
  native: {
    type: Boolean,
    default: false
  },
  backgroundImageFn: {
    type: Function
  },
  sheetSize: {
    type: Number,
    default: 64
  },
  emojisToShowFilter: {
    type: Function
  },
  emojiTooltip: {
    type: Boolean,
    default: false
  },
  include: {
    type: Array
  },
  exclude: {
    type: Array
  },
  recent: {
    type: Array
  },
  autoFocus: {
    type: Boolean,
    default: false
  },
  custom: {
    type: Array,
    default: function _default() {
      return [];
    }
  },
  i18n: {
    type: Object,
    default: function _default() {
      return {};
    }
  },
  showPreview: {
    type: Boolean,
    default: true
  },
  showSearch: {
    type: Boolean,
    default: true
  },
  showCategories: {
    type: Boolean,
    default: true
  },
  showSkinTones: {
    type: Boolean,
    default: true
  },
  infiniteScroll: {
    type: Boolean,
    default: true
  },
  pickerStyles: {
    type: Object,
    default: function _default() {
      return {};
    }
  }
};

exports.EmojiProps = EmojiProps;
exports.PickerProps = PickerProps;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(89)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(47)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 27 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(14);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(33)('keys');
var uid = __webpack_require__(21);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(6).f;
var has = __webpack_require__(7);
var TAG = __webpack_require__(2)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(2);


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(4);
var LIBRARY = __webpack_require__(29);
var wksExt = __webpack_require__(36);
var defineProperty = __webpack_require__(6).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(129);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(130);

var _createClass3 = _interopRequireDefault(_createClass2);

var _ = __webpack_require__(20);

var _data = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NimbleEmojiIndex = function () {
  function NimbleEmojiIndex(data) {
    (0, _classCallCheck3.default)(this, NimbleEmojiIndex);

    if (data.compressed) {
      data = (0, _data.uncompress)(data);
    }

    this.data = data || {};
    this.originalPool = {};
    this.index = {};
    this.emojis = {};
    this.emoticons = {};
    this.customEmojisList = [];

    this.buildIndex();
  }

  (0, _createClass3.default)(NimbleEmojiIndex, [{
    key: 'buildIndex',
    value: function buildIndex() {
      var _this = this;

      var _loop = function _loop(emoji) {
        var emojiData = _this.data.emojis[emoji];
        var short_names = emojiData.short_names;
        var emoticons = emojiData.emoticons;
        var id = short_names[0];

        if (emoticons) {
          emoticons.forEach(function (emoticon) {
            if (_this.emoticons[emoticon]) {
              return;
            }

            _this.emoticons[emoticon] = id;
          });
        }

        _this.emojis[id] = (0, _.getSanitizedData)(id, null, null, _this.data);
        _this.originalPool[id] = emojiData;
      };

      for (var emoji in this.data.emojis) {
        _loop(emoji);
      }
    }
  }, {
    key: 'clearCustomEmojis',
    value: function clearCustomEmojis(pool) {
      var _this2 = this;

      this.customEmojisList.forEach(function (emoji) {
        var emojiId = emoji.id || emoji.short_names[0];

        delete pool[emojiId];
        delete _this2.emojis[emojiId];
      });
    }
  }, {
    key: 'addCustomToPool',
    value: function addCustomToPool(custom, pool) {
      var _this3 = this;

      if (this.customEmojisList.length) this.clearCustomEmojis(pool);

      custom.forEach(function (emoji) {
        var emojiId = emoji.id || emoji.short_names[0];

        if (emojiId && !pool[emojiId]) {
          pool[emojiId] = (0, _.getData)(emoji, null, null, _this3.data);
          _this3.emojis[emojiId] = (0, _.getSanitizedData)(emoji, null, null, _this3.data);
        }
      });

      this.customEmojisList = custom;
      this.index = {};
    }
  }, {
    key: 'search',
    value: function search(value) {
      var _this4 = this;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var emojisToShowFilter = _ref.emojisToShowFilter;
      var maxResults = _ref.maxResults;
      var include = _ref.include;
      var exclude = _ref.exclude;
      var _ref$custom = _ref.custom;
      var custom = _ref$custom === undefined ? [] : _ref$custom;

      if (this.customEmojisList != custom) this.addCustomToPool(custom, this.originalPool);

      maxResults || (maxResults = 75);
      include || (include = []);
      exclude || (exclude = []);

      var results = null,
          pool = this.originalPool;

      if (value.length) {
        if (value == '-' || value == '-1') {
          return [this.emojis['-1']];
        }

        var values = value.toLowerCase().split(/[\s|,|\-|_]+/),
            allResults = [];

        if (values.length > 2) {
          values = [values[0], values[1]];
        }

        if (include.length || exclude.length) {
          pool = {};

          this.data.categories.forEach(function (category) {
            var isIncluded = include && include.length ? include.indexOf(category.id) > -1 : true;
            var isExcluded = exclude && exclude.length ? exclude.indexOf(category.id) > -1 : false;
            if (!isIncluded || isExcluded) {
              return;
            }

            category.emojis.forEach(function (emojiId) {
              return pool[emojiId] = _this4.data.emojis[emojiId];
            });
          });

          if (custom.length) {
            var customIsIncluded = include && include.length ? include.indexOf('custom') > -1 : true;
            var customIsExcluded = exclude && exclude.length ? exclude.indexOf('custom') > -1 : false;
            if (customIsIncluded && !customIsExcluded) {
              this.addCustomToPool(custom, pool);
            }
          }
        }

        allResults = values.map(function (value) {
          var aPool = pool,
              aIndex = _this4.index,
              length = 0;

          for (var charIndex = 0; charIndex < value.length; charIndex++) {
            var char = value[charIndex];
            length++;

            aIndex[char] || (aIndex[char] = {});
            aIndex = aIndex[char];

            if (!aIndex.results) {
              (function () {
                var scores = {};

                aIndex.results = [];
                aIndex.pool = {};

                for (var _id in aPool) {
                  var emoji = aPool[_id];
                  var search = emoji.search;
                  var sub = value.substr(0, length);
                  var subIndex = search.indexOf(sub);

                  if (subIndex != -1) {
                    var score = subIndex + 1;
                    if (sub == _id) score = 0;

                    aIndex.results.push(_this4.emojis[_id]);
                    aIndex.pool[_id] = emoji;

                    scores[_id] = score;
                  }
                }

                aIndex.results.sort(function (a, b) {
                  var aScore = scores[a.id],
                      bScore = scores[b.id];

                  return aScore - bScore;
                });
              })();
            }

            aPool = aIndex.pool;
          }

          return aIndex.results;
        }).filter(function (a) {
          return a;
        });

        if (allResults.length > 1) {
          results = _.intersect.apply(null, allResults);
        } else if (allResults.length) {
          results = allResults[0];
        } else {
          results = [];
        }
      }

      if (results) {
        if (emojisToShowFilter) {
          results = results.filter(function (result) {
            return emojisToShowFilter(pool[result.id]);
          });
        }

        if (results && results.length > maxResults) {
          results = results.slice(0, maxResults);
        }
      }

      return results;
    }
  }]);
  return NimbleEmojiIndex;
}();

exports.default = NimbleEmojiIndex;

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = {"compressed":true,"categories":[{"id":"people","name":"Smileys & People","emojis":["grinning","grin","joy","rolling_on_the_floor_laughing","smiley","smile","sweat_smile","laughing","wink","blush","yum","sunglasses","heart_eyes","kissing_heart","kissing","kissing_smiling_eyes","kissing_closed_eyes","relaxed","slightly_smiling_face","hugging_face","star-struck","thinking_face","face_with_raised_eyebrow","neutral_face","expressionless","no_mouth","face_with_rolling_eyes","smirk","persevere","disappointed_relieved","open_mouth","zipper_mouth_face","hushed","sleepy","tired_face","sleeping","relieved","stuck_out_tongue","stuck_out_tongue_winking_eye","stuck_out_tongue_closed_eyes","drooling_face","unamused","sweat","pensive","confused","upside_down_face","money_mouth_face","astonished","white_frowning_face","slightly_frowning_face","confounded","disappointed","worried","triumph","cry","sob","frowning","anguished","fearful","weary","exploding_head","grimacing","cold_sweat","scream","flushed","zany_face","dizzy_face","rage","angry","face_with_symbols_on_mouth","mask","face_with_thermometer","face_with_head_bandage","nauseated_face","face_vomiting","sneezing_face","innocent","face_with_cowboy_hat","clown_face","lying_face","shushing_face","face_with_hand_over_mouth","face_with_monocle","nerd_face","smiling_imp","imp","japanese_ogre","japanese_goblin","skull","skull_and_crossbones","ghost","alien","space_invader","robot_face","hankey","smiley_cat","smile_cat","joy_cat","heart_eyes_cat","smirk_cat","kissing_cat","scream_cat","crying_cat_face","pouting_cat","see_no_evil","hear_no_evil","speak_no_evil","baby","child","boy","girl","adult","man","woman","older_adult","older_man","older_woman","male-doctor","female-doctor","male-student","female-student","male-teacher","female-teacher","male-judge","female-judge","male-farmer","female-farmer","male-cook","female-cook","male-mechanic","female-mechanic","male-factory-worker","female-factory-worker","male-office-worker","female-office-worker","male-scientist","female-scientist","male-technologist","female-technologist","male-singer","female-singer","male-artist","female-artist","male-pilot","female-pilot","male-astronaut","female-astronaut","male-firefighter","female-firefighter","cop","male-police-officer","female-police-officer","sleuth_or_spy","male-detective","female-detective","guardsman","male-guard","female-guard","construction_worker","male-construction-worker","female-construction-worker","prince","princess","man_with_turban","man-wearing-turban","woman-wearing-turban","man_with_gua_pi_mao","person_with_headscarf","bearded_person","person_with_blond_hair","blond-haired-man","blond-haired-woman","man_in_tuxedo","bride_with_veil","pregnant_woman","breast-feeding","angel","santa","mrs_claus","mage","female_mage","male_mage","fairy","female_fairy","male_fairy","vampire","female_vampire","male_vampire","merperson","mermaid","merman","elf","female_elf","male_elf","genie","female_genie","male_genie","zombie","female_zombie","male_zombie","person_frowning","man-frowning","woman-frowning","person_with_pouting_face","man-pouting","woman-pouting","no_good","man-gesturing-no","woman-gesturing-no","ok_woman","man-gesturing-ok","woman-gesturing-ok","information_desk_person","man-tipping-hand","woman-tipping-hand","raising_hand","man-raising-hand","woman-raising-hand","bow","man-bowing","woman-bowing","face_palm","man-facepalming","woman-facepalming","shrug","man-shrugging","woman-shrugging","massage","man-getting-massage","woman-getting-massage","haircut","man-getting-haircut","woman-getting-haircut","walking","man-walking","woman-walking","runner","man-running","woman-running","dancer","man_dancing","dancers","man-with-bunny-ears-partying","woman-with-bunny-ears-partying","person_in_steamy_room","woman_in_steamy_room","man_in_steamy_room","person_climbing","woman_climbing","man_climbing","person_in_lotus_position","woman_in_lotus_position","man_in_lotus_position","bath","sleeping_accommodation","man_in_business_suit_levitating","speaking_head_in_silhouette","bust_in_silhouette","busts_in_silhouette","fencer","horse_racing","skier","snowboarder","golfer","man-golfing","woman-golfing","surfer","man-surfing","woman-surfing","rowboat","man-rowing-boat","woman-rowing-boat","swimmer","man-swimming","woman-swimming","person_with_ball","man-bouncing-ball","woman-bouncing-ball","weight_lifter","man-lifting-weights","woman-lifting-weights","bicyclist","man-biking","woman-biking","mountain_bicyclist","man-mountain-biking","woman-mountain-biking","racing_car","racing_motorcycle","person_doing_cartwheel","man-cartwheeling","woman-cartwheeling","wrestlers","man-wrestling","woman-wrestling","water_polo","man-playing-water-polo","woman-playing-water-polo","handball","man-playing-handball","woman-playing-handball","juggling","man-juggling","woman-juggling","couple","two_men_holding_hands","two_women_holding_hands","couplekiss","woman-kiss-man","man-kiss-man","woman-kiss-woman","couple_with_heart","woman-heart-man","man-heart-man","woman-heart-woman","family","man-woman-boy","man-woman-girl","man-woman-girl-boy","man-woman-boy-boy","man-woman-girl-girl","man-man-boy","man-man-girl","man-man-girl-boy","man-man-boy-boy","man-man-girl-girl","woman-woman-boy","woman-woman-girl","woman-woman-girl-boy","woman-woman-boy-boy","woman-woman-girl-girl","man-boy","man-boy-boy","man-girl","man-girl-boy","man-girl-girl","woman-boy","woman-boy-boy","woman-girl","woman-girl-boy","woman-girl-girl","selfie","muscle","point_left","point_right","point_up","point_up_2","middle_finger","point_down","v","crossed_fingers","spock-hand","the_horns","call_me_hand","raised_hand_with_fingers_splayed","hand","ok_hand","+1","-1","fist","facepunch","left-facing_fist","right-facing_fist","raised_back_of_hand","wave","i_love_you_hand_sign","writing_hand","clap","open_hands","raised_hands","palms_up_together","pray","handshake","nail_care","ear","nose","footprints","eyes","eye","eye-in-speech-bubble","brain","tongue","lips","kiss","cupid","heart","heartbeat","broken_heart","two_hearts","sparkling_heart","heartpulse","blue_heart","green_heart","yellow_heart","orange_heart","purple_heart","black_heart","gift_heart","revolving_hearts","heart_decoration","heavy_heart_exclamation_mark_ornament","love_letter","zzz","anger","bomb","boom","sweat_drops","dash","dizzy","speech_balloon","left_speech_bubble","right_anger_bubble","thought_balloon","hole","eyeglasses","dark_sunglasses","necktie","shirt","jeans","scarf","gloves","coat","socks","dress","kimono","bikini","womans_clothes","purse","handbag","pouch","shopping_bags","school_satchel","mans_shoe","athletic_shoe","high_heel","sandal","boot","crown","womans_hat","tophat","mortar_board","billed_cap","helmet_with_white_cross","prayer_beads","lipstick","ring","gem"]},{"id":"nature","name":"Animals & Nature","emojis":["monkey_face","monkey","gorilla","dog","dog2","poodle","wolf","fox_face","cat","cat2","lion_face","tiger","tiger2","leopard","horse","racehorse","unicorn_face","zebra_face","deer","cow","ox","water_buffalo","cow2","pig","pig2","boar","pig_nose","ram","sheep","goat","dromedary_camel","camel","giraffe_face","elephant","rhinoceros","mouse","mouse2","rat","hamster","rabbit","rabbit2","chipmunk","hedgehog","bat","bear","koala","panda_face","feet","turkey","chicken","rooster","hatching_chick","baby_chick","hatched_chick","bird","penguin","dove_of_peace","eagle","duck","owl","frog","crocodile","turtle","lizard","snake","dragon_face","dragon","sauropod","t-rex","whale","whale2","dolphin","fish","tropical_fish","blowfish","shark","octopus","shell","crab","shrimp","squid","snail","butterfly","bug","ant","bee","beetle","cricket","spider","spider_web","scorpion","bouquet","cherry_blossom","white_flower","rosette","rose","wilted_flower","hibiscus","sunflower","blossom","tulip","seedling","evergreen_tree","deciduous_tree","palm_tree","cactus","ear_of_rice","herb","shamrock","four_leaf_clover","maple_leaf","fallen_leaf","leaves"]},{"id":"foods","name":"Food & Drink","emojis":["grapes","melon","watermelon","tangerine","lemon","banana","pineapple","apple","green_apple","pear","peach","cherries","strawberry","kiwifruit","tomato","coconut","avocado","eggplant","potato","carrot","corn","hot_pepper","cucumber","broccoli","mushroom","peanuts","chestnut","bread","croissant","baguette_bread","pretzel","pancakes","cheese_wedge","meat_on_bone","poultry_leg","cut_of_meat","bacon","hamburger","fries","pizza","hotdog","sandwich","taco","burrito","stuffed_flatbread","egg","fried_egg","shallow_pan_of_food","stew","bowl_with_spoon","green_salad","popcorn","canned_food","bento","rice_cracker","rice_ball","rice","curry","ramen","spaghetti","sweet_potato","oden","sushi","fried_shrimp","fish_cake","dango","dumpling","fortune_cookie","takeout_box","icecream","shaved_ice","ice_cream","doughnut","cookie","birthday","cake","pie","chocolate_bar","candy","lollipop","custard","honey_pot","baby_bottle","glass_of_milk","coffee","tea","sake","champagne","wine_glass","cocktail","tropical_drink","beer","beers","clinking_glasses","tumbler_glass","cup_with_straw","chopsticks","knife_fork_plate","fork_and_knife","spoon","hocho","amphora"]},{"id":"activity","name":"Activities","emojis":["jack_o_lantern","christmas_tree","fireworks","sparkler","sparkles","balloon","tada","confetti_ball","tanabata_tree","bamboo","dolls","flags","wind_chime","rice_scene","ribbon","gift","reminder_ribbon","admission_tickets","ticket","medal","trophy","sports_medal","first_place_medal","second_place_medal","third_place_medal","soccer","baseball","basketball","volleyball","football","rugby_football","tennis","8ball","bowling","cricket_bat_and_ball","field_hockey_stick_and_ball","ice_hockey_stick_and_puck","table_tennis_paddle_and_ball","badminton_racquet_and_shuttlecock","boxing_glove","martial_arts_uniform","goal_net","dart","golf","ice_skate","fishing_pole_and_fish","running_shirt_with_sash","ski","sled","curling_stone","video_game","joystick","game_die","spades","hearts","diamonds","clubs","black_joker","mahjong","flower_playing_cards"]},{"id":"places","name":"Travel & Places","emojis":["earth_africa","earth_americas","earth_asia","globe_with_meridians","world_map","japan","snow_capped_mountain","mountain","volcano","mount_fuji","camping","beach_with_umbrella","desert","desert_island","national_park","stadium","classical_building","building_construction","house_buildings","cityscape","derelict_house_building","house","house_with_garden","office","post_office","european_post_office","hospital","bank","hotel","love_hotel","convenience_store","school","department_store","factory","japanese_castle","european_castle","wedding","tokyo_tower","statue_of_liberty","church","mosque","synagogue","shinto_shrine","kaaba","fountain","tent","foggy","night_with_stars","sunrise_over_mountains","sunrise","city_sunset","city_sunrise","bridge_at_night","hotsprings","milky_way","carousel_horse","ferris_wheel","roller_coaster","barber","circus_tent","performing_arts","frame_with_picture","art","slot_machine","steam_locomotive","railway_car","bullettrain_side","bullettrain_front","train2","metro","light_rail","station","tram","monorail","mountain_railway","train","bus","oncoming_bus","trolleybus","minibus","ambulance","fire_engine","police_car","oncoming_police_car","taxi","oncoming_taxi","car","oncoming_automobile","blue_car","truck","articulated_lorry","tractor","bike","scooter","motor_scooter","busstop","motorway","railway_track","fuelpump","rotating_light","traffic_light","vertical_traffic_light","construction","octagonal_sign","anchor","boat","canoe","speedboat","passenger_ship","ferry","motor_boat","ship","airplane","small_airplane","airplane_departure","airplane_arriving","seat","helicopter","suspension_railway","mountain_cableway","aerial_tramway","satellite","rocket","flying_saucer","bellhop_bell","door","bed","couch_and_lamp","toilet","shower","bathtub","hourglass","hourglass_flowing_sand","watch","alarm_clock","stopwatch","timer_clock","mantelpiece_clock","clock12","clock1230","clock1","clock130","clock2","clock230","clock3","clock330","clock4","clock430","clock5","clock530","clock6","clock630","clock7","clock730","clock8","clock830","clock9","clock930","clock10","clock1030","clock11","clock1130","new_moon","waxing_crescent_moon","first_quarter_moon","moon","full_moon","waning_gibbous_moon","last_quarter_moon","waning_crescent_moon","crescent_moon","new_moon_with_face","first_quarter_moon_with_face","last_quarter_moon_with_face","thermometer","sunny","full_moon_with_face","sun_with_face","star","star2","stars","cloud","partly_sunny","thunder_cloud_and_rain","mostly_sunny","barely_sunny","partly_sunny_rain","rain_cloud","snow_cloud","lightning","tornado","fog","wind_blowing_face","cyclone","rainbow","closed_umbrella","umbrella","umbrella_with_rain_drops","umbrella_on_ground","zap","snowflake","snowman","snowman_without_snow","comet","fire","droplet","ocean"]},{"id":"objects","name":"Objects","emojis":["mute","speaker","sound","loud_sound","loudspeaker","mega","postal_horn","bell","no_bell","musical_score","musical_note","notes","studio_microphone","level_slider","control_knobs","microphone","headphones","radio","saxophone","guitar","musical_keyboard","trumpet","violin","drum_with_drumsticks","iphone","calling","phone","telephone_receiver","pager","fax","battery","electric_plug","computer","desktop_computer","printer","keyboard","three_button_mouse","trackball","minidisc","floppy_disk","cd","dvd","movie_camera","film_frames","film_projector","clapper","tv","camera","camera_with_flash","video_camera","vhs","mag","mag_right","microscope","telescope","satellite_antenna","candle","bulb","flashlight","izakaya_lantern","notebook_with_decorative_cover","closed_book","book","green_book","blue_book","orange_book","books","notebook","ledger","page_with_curl","scroll","page_facing_up","newspaper","rolled_up_newspaper","bookmark_tabs","bookmark","label","moneybag","yen","dollar","euro","pound","money_with_wings","credit_card","chart","currency_exchange","heavy_dollar_sign","email","e-mail","incoming_envelope","envelope_with_arrow","outbox_tray","inbox_tray","package","mailbox","mailbox_closed","mailbox_with_mail","mailbox_with_no_mail","postbox","ballot_box_with_ballot","pencil2","black_nib","lower_left_fountain_pen","lower_left_ballpoint_pen","lower_left_paintbrush","lower_left_crayon","memo","briefcase","file_folder","open_file_folder","card_index_dividers","date","calendar","spiral_note_pad","spiral_calendar_pad","card_index","chart_with_upwards_trend","chart_with_downwards_trend","bar_chart","clipboard","pushpin","round_pushpin","paperclip","linked_paperclips","straight_ruler","triangular_ruler","scissors","card_file_box","file_cabinet","wastebasket","lock","unlock","lock_with_ink_pen","closed_lock_with_key","key","old_key","hammer","pick","hammer_and_pick","hammer_and_wrench","dagger_knife","crossed_swords","gun","bow_and_arrow","shield","wrench","nut_and_bolt","gear","compression","alembic","scales","link","chains","syringe","pill","smoking","coffin","funeral_urn","moyai","oil_drum","crystal_ball","shopping_trolley"]},{"id":"symbols","name":"Symbols","emojis":["atm","put_litter_in_its_place","potable_water","wheelchair","mens","womens","restroom","baby_symbol","wc","passport_control","customs","baggage_claim","left_luggage","warning","children_crossing","no_entry","no_entry_sign","no_bicycles","no_smoking","do_not_litter","non-potable_water","no_pedestrians","no_mobile_phones","underage","radioactive_sign","biohazard_sign","arrow_up","arrow_upper_right","arrow_right","arrow_lower_right","arrow_down","arrow_lower_left","arrow_left","arrow_upper_left","arrow_up_down","left_right_arrow","leftwards_arrow_with_hook","arrow_right_hook","arrow_heading_up","arrow_heading_down","arrows_clockwise","arrows_counterclockwise","back","end","on","soon","top","place_of_worship","atom_symbol","om_symbol","star_of_david","wheel_of_dharma","yin_yang","latin_cross","orthodox_cross","star_and_crescent","peace_symbol","menorah_with_nine_branches","six_pointed_star","aries","taurus","gemini","cancer","leo","virgo","libra","scorpius","sagittarius","capricorn","aquarius","pisces","ophiuchus","twisted_rightwards_arrows","repeat","repeat_one","arrow_forward","fast_forward","black_right_pointing_double_triangle_with_vertical_bar","black_right_pointing_triangle_with_double_vertical_bar","arrow_backward","rewind","black_left_pointing_double_triangle_with_vertical_bar","arrow_up_small","arrow_double_up","arrow_down_small","arrow_double_down","double_vertical_bar","black_square_for_stop","black_circle_for_record","eject","cinema","low_brightness","high_brightness","signal_strength","vibration_mode","mobile_phone_off","female_sign","male_sign","medical_symbol","recycle","fleur_de_lis","trident","name_badge","beginner","o","white_check_mark","ballot_box_with_check","heavy_check_mark","heavy_multiplication_x","x","negative_squared_cross_mark","heavy_plus_sign","heavy_minus_sign","heavy_division_sign","curly_loop","loop","part_alternation_mark","eight_spoked_asterisk","eight_pointed_black_star","sparkle","bangbang","interrobang","question","grey_question","grey_exclamation","exclamation","wavy_dash","copyright","registered","tm","hash","keycap_star","zero","one","two","three","four","five","six","seven","eight","nine","keycap_ten","100","capital_abcd","abcd","1234","symbols","abc","a","ab","b","cl","cool","free","information_source","id","m","new","ng","o2","ok","parking","sos","up","vs","koko","sa","u6708","u6709","u6307","ideograph_advantage","u5272","u7121","u7981","accept","u7533","u5408","u7a7a","congratulations","secret","u55b6","u6e80","black_small_square","white_small_square","white_medium_square","black_medium_square","white_medium_small_square","black_medium_small_square","black_large_square","white_large_square","large_orange_diamond","large_blue_diamond","small_orange_diamond","small_blue_diamond","small_red_triangle","small_red_triangle_down","diamond_shape_with_a_dot_inside","radio_button","black_square_button","white_square_button","white_circle","black_circle","red_circle","large_blue_circle"]},{"id":"flags","name":"Flags","emojis":["checkered_flag","cn","crossed_flags","de","es","flag-ac","flag-ad","flag-ae","flag-af","flag-ag","flag-ai","flag-al","flag-am","flag-ao","flag-aq","flag-ar","flag-as","flag-at","flag-au","flag-aw","flag-ax","flag-az","flag-ba","flag-bb","flag-bd","flag-be","flag-bf","flag-bg","flag-bh","flag-bi","flag-bj","flag-bl","flag-bm","flag-bn","flag-bo","flag-bq","flag-br","flag-bs","flag-bt","flag-bv","flag-bw","flag-by","flag-bz","flag-ca","flag-cc","flag-cd","flag-cf","flag-cg","flag-ch","flag-ci","flag-ck","flag-cl","flag-cm","flag-co","flag-cp","flag-cr","flag-cu","flag-cv","flag-cw","flag-cx","flag-cy","flag-cz","flag-dg","flag-dj","flag-dk","flag-dm","flag-do","flag-dz","flag-ea","flag-ec","flag-ee","flag-eg","flag-eh","flag-england","flag-er","flag-et","flag-eu","flag-fi","flag-fj","flag-fk","flag-fm","flag-fo","flag-ga","flag-gd","flag-ge","flag-gf","flag-gg","flag-gh","flag-gi","flag-gl","flag-gm","flag-gn","flag-gp","flag-gq","flag-gr","flag-gs","flag-gt","flag-gu","flag-gw","flag-gy","flag-hk","flag-hm","flag-hn","flag-hr","flag-ht","flag-hu","flag-ic","flag-id","flag-ie","flag-il","flag-im","flag-in","flag-io","flag-iq","flag-ir","flag-is","flag-je","flag-jm","flag-jo","flag-ke","flag-kg","flag-kh","flag-ki","flag-km","flag-kn","flag-kp","flag-kw","flag-ky","flag-kz","flag-la","flag-lb","flag-lc","flag-li","flag-lk","flag-lr","flag-ls","flag-lt","flag-lu","flag-lv","flag-ly","flag-ma","flag-mc","flag-md","flag-me","flag-mf","flag-mg","flag-mh","flag-mk","flag-ml","flag-mm","flag-mn","flag-mo","flag-mp","flag-mq","flag-mr","flag-ms","flag-mt","flag-mu","flag-mv","flag-mw","flag-mx","flag-my","flag-mz","flag-na","flag-nc","flag-ne","flag-nf","flag-ng","flag-ni","flag-nl","flag-no","flag-np","flag-nr","flag-nu","flag-nz","flag-om","flag-pa","flag-pe","flag-pf","flag-pg","flag-ph","flag-pk","flag-pl","flag-pm","flag-pn","flag-pr","flag-ps","flag-pt","flag-pw","flag-py","flag-qa","flag-re","flag-ro","flag-rs","flag-rw","flag-sa","flag-sb","flag-sc","flag-scotland","flag-sd","flag-se","flag-sg","flag-sh","flag-si","flag-sj","flag-sk","flag-sl","flag-sm","flag-sn","flag-so","flag-sr","flag-ss","flag-st","flag-sv","flag-sx","flag-sy","flag-sz","flag-ta","flag-tc","flag-td","flag-tf","flag-tg","flag-th","flag-tj","flag-tk","flag-tl","flag-tm","flag-tn","flag-to","flag-tr","flag-tt","flag-tv","flag-tw","flag-tz","flag-ua","flag-ug","flag-um","flag-uy","flag-uz","flag-va","flag-vc","flag-ve","flag-vg","flag-vi","flag-vn","flag-vu","flag-wales","flag-wf","flag-ws","flag-xk","flag-ye","flag-yt","flag-za","flag-zm","flag-zw","fr","gb","it","jp","kr","rainbow-flag","ru","triangular_flag_on_post","us","waving_black_flag","waving_white_flag"]}],"emojis":{"100":{"a":"Hundred Points Symbol","b":"1F4AF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["score","perfect","numbers","century","exam","quiz","test","pass","hundred"],"k":[25,26]},"1234":{"a":"Input Symbol for Numbers","b":"1F522","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["numbers","blue-square"],"k":[27,36]},"earth_africa":{"a":"Earth Globe Europe-Africa","b":"1F30D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["globe","world","international"],"k":[6,5]},"grapes":{"a":"Grapes","b":"1F347","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fruit","food","wine"],"k":[7,9]},"jack_o_lantern":{"a":"Jack-O-Lantern","b":"1F383","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["halloween","light","pumpkin","creepy","fall"],"k":[8,17]},"checkered_flag":{"a":"Chequered Flag","b":"1F3C1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["contest","finishline","race","gokart"],"k":[9,27]},"atm":{"a":"Automated Teller Machine","b":"1F3E7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["money","sales","cash","blue-square","payment","bank"],"k":[12,4]},"monkey_face":{"a":"Monkey Face","b":"1F435","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","circus"],"k":[13,31],"l":[":o)"]},"mute":{"a":"Speaker with Cancellation Stroke","b":"1F507","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sound","volume","silence","quiet"],"k":[27,9]},"grinning":{"a":"Grinning Face","b":"1F600","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","smile","happy","joy",":D","grin"],"k":[30,24],"m":":D"},"earth_americas":{"a":"Earth Globe Americas","b":"1F30E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["globe","world","USA","international"],"k":[6,6]},"melon":{"a":"Melon","b":"1F348","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fruit","nature","food"],"k":[7,10]},"christmas_tree":{"a":"Christmas Tree","b":"1F384","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["festival","vacation","december","xmas","celebration"],"k":[8,18]},"monkey":{"a":"Monkey","b":"1F412","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","banana","circus"],"k":[12,48]},"speaker":{"a":"Speaker","b":"1F508","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sound","volume","silence","broadcast"],"k":[27,10]},"grin":{"a":"Grinning Face with Smiling Eyes","b":"1F601","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","happy","smile","joy","kawaii"],"k":[30,25]},"triangular_flag_on_post":{"a":"Triangular Flag on Post","b":"1F6A9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["mark","milestone","place"],"k":[35,14]},"put_litter_in_its_place":{"a":"Put Litter in Its Place Symbol","b":"1F6AE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","sign","human","info"],"k":[35,19]},"earth_asia":{"a":"Earth Globe Asia-Australia","b":"1F30F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["globe","world","east","international"],"k":[6,7]},"watermelon":{"a":"Watermelon","b":"1F349","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fruit","food","picnic","summer"],"k":[7,11]},"fireworks":{"a":"Fireworks","b":"1F386","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["photo","festival","carnival","congratulations"],"k":[8,25]},"crossed_flags":{"a":"Crossed Flags","b":"1F38C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["japanese","nation","country","border"],"k":[8,31]},"sound":{"a":"Speaker with One Sound Wave","b":"1F509","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["volume","speaker","broadcast"],"k":[27,11]},"joy":{"a":"Face with Tears of Joy","b":"1F602","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","cry","tears","weep","happy","happytears","haha"],"k":[30,26]},"potable_water":{"a":"Potable Water Symbol","b":"1F6B0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","liquid","restroom","cleaning","faucet"],"k":[35,21]},"gorilla":{"a":"Gorilla","b":"1F98D","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","nature","circus"],"k":[42,37],"o":9},"globe_with_meridians":{"a":"Globe with Meridians","b":"1F310","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["earth","international","world","internet","interweb","i18n"],"k":[6,8]},"tangerine":{"a":"Tangerine","b":"1F34A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","fruit","nature","orange"],"k":[7,12]},"sparkler":{"a":"Firework Sparkler","b":"1F387","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["stars","night","shine"],"k":[8,26]},"waving_black_flag":{"a":"Waving Black Flag","b":"1F3F4","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[12,19],"o":7},"dog":{"a":"Dog Face","b":"1F436","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","friend","nature","woof","puppy","pet","faithful"],"k":[13,32]},"loud_sound":{"a":"Speaker with Three Sound Waves","b":"1F50A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["volume","noise","noisy","speaker","broadcast"],"k":[27,12]},"rolling_on_the_floor_laughing":{"a":"Rolling on the Floor Laughing","b":"1F923","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[38,26],"o":9},"wheelchair":{"a":"Wheelchair Symbol","b":"267F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","disabled","a11y","accessibility"],"k":[48,10],"o":4},"lemon":{"a":"Lemon","b":"1F34B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fruit","nature"],"k":[7,13]},"waving_white_flag":{"a":"Waving White Flag","b":"1F3F3-FE0F","c":"1F3F3","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[12,15],"o":7},"dog2":{"a":"Dog","b":"1F415","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","friend","doge","pet","faithful"],"k":[12,51]},"loudspeaker":{"a":"Public Address Loudspeaker","b":"1F4E2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["volume","sound"],"k":[26,25]},"world_map":{"a":"World Map","b":"1F5FA-FE0F","c":"1F5FA","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["location","direction"],"k":[30,18],"o":7},"smiley":{"a":"Smiling Face with Open Mouth","b":"1F603","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","happy","joy","haha",":D",":)","smile","funny"],"k":[30,27],"l":["=)","=-)"],"m":":)"},"mens":{"a":"Mens Symbol","b":"1F6B9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["toilet","restroom","wc","blue-square","gender","male"],"k":[36,29]},"sparkles":{"a":"Sparkles","b":"2728","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["stars","shine","shiny","cool","awesome","good","magic"],"k":[49,48]},"banana":{"a":"Banana","b":"1F34C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fruit","food","monkey"],"k":[7,14]},"balloon":{"a":"Balloon","b":"1F388","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["party","celebration","birthday","circus"],"k":[8,27]},"rainbow-flag":{"a":"Rainbow Flag","b":"1F3F3-FE0F-200D-1F308","c":"1F3F3-200D-1F308","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[12,14],"o":7},"poodle":{"a":"Poodle","b":"1F429","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["dog","animal","101","nature","pet"],"k":[13,19]},"mega":{"a":"Cheering Megaphone","b":"1F4E3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sound","speaker","volume"],"k":[26,26]},"japan":{"a":"Silhouette of Japan","b":"1F5FE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nation","country","japanese","asia"],"k":[30,22]},"smile":{"a":"Smiling Face with Open Mouth and Smiling Eyes","b":"1F604","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","happy","joy","funny","haha","laugh","like",":D",":)"],"k":[30,28],"l":["C:","c:",":D",":-D"],"m":":)"},"womens":{"a":"Womens Symbol","b":"1F6BA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["purple-square","woman","female","toilet","loo","restroom","gender"],"k":[36,30]},"flag-ac":{"a":"Ascension Island Flag","b":"1F1E6-1F1E8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[0,31]},"pineapple":{"a":"Pineapple","b":"1F34D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fruit","nature","food"],"k":[7,15]},"tada":{"a":"Party Popper","b":"1F389","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["party","congratulations","birthday","magic","circus","celebration"],"k":[8,28]},"snow_capped_mountain":{"a":"Snow Capped Mountain","b":"1F3D4-FE0F","c":"1F3D4","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[11,37],"o":7},"wolf":{"a":"Wolf Face","b":"1F43A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","wild"],"k":[13,36]},"postal_horn":{"a":"Postal Horn","b":"1F4EF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["instrument","music"],"k":[26,38]},"sweat_smile":{"a":"Smiling Face with Open Mouth and Cold Sweat","b":"1F605","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","hot","happy","laugh","sweat","smile","relief"],"k":[30,29]},"restroom":{"a":"Restroom","b":"1F6BB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","toilet","refresh","wc","gender"],"k":[36,31]},"flag-ad":{"a":"Andorra Flag","b":"1F1E6-1F1E9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[0,32]},"apple":{"a":"Red Apple","b":"1F34E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fruit","mac","school"],"k":[7,16]},"confetti_ball":{"a":"Confetti Ball","b":"1F38A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["festival","party","birthday","circus"],"k":[8,29]},"bell":{"a":"Bell","b":"1F514","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sound","notification","christmas","xmas","chime"],"k":[27,22]},"laughing":{"a":"Smiling Face with Open Mouth and Tightly-Closed Eyes","b":"1F606","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["happy","joy","lol","satisfied","haha","face","glad","XD","laugh"],"k":[30,30],"l":[":>",":->"],"n":["satisfied"]},"baby_symbol":{"a":"Baby Symbol","b":"1F6BC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["orange-square","child"],"k":[36,32]},"fox_face":{"a":"Fox Face","b":"1F98A","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","nature","face"],"k":[42,34],"o":9},"mountain":{"a":"Mountain","b":"26F0-FE0F","c":"26F0","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["photo","nature","environment"],"k":[48,38],"o":5},"flag-ae":{"a":"United Arab Emirates Flag","b":"1F1E6-1F1EA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[0,33]},"volcano":{"a":"Volcano","b":"1F30B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["photo","nature","disaster"],"k":[6,3]},"green_apple":{"a":"Green Apple","b":"1F34F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fruit","nature"],"k":[7,17]},"tanabata_tree":{"a":"Tanabata Tree","b":"1F38B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["plant","nature","branch","summer"],"k":[8,30]},"cat":{"a":"Cat Face","b":"1F431","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","meow","nature","pet","kitten"],"k":[13,27]},"no_bell":{"a":"Bell with Cancellation Stroke","b":"1F515","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sound","volume","mute","quiet","silent"],"k":[27,23]},"wink":{"a":"Winking Face","b":"1F609","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","happy","mischievous","secret",";)","smile","eye"],"k":[30,33],"l":[";)",";-)"],"m":";)"},"wc":{"a":"Water Closet","b":"1F6BE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["toilet","restroom","blue-square"],"k":[36,34]},"flag-af":{"a":"Afghanistan Flag","b":"1F1E6-1F1EB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[0,34]},"pear":{"a":"Pear","b":"1F350","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fruit","nature","food"],"k":[7,18]},"bamboo":{"a":"Pine Decoration","b":"1F38D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["plant","nature","vegetable","panda","pine_decoration"],"k":[8,32]},"musical_score":{"a":"Musical Score","b":"1F3BC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["treble","clef","compose"],"k":[9,22]},"cat2":{"a":"Cat","b":"1F408","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","meow","pet","cats"],"k":[12,38]},"mount_fuji":{"a":"Mount Fuji","b":"1F5FB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["photo","mountain","nature","japanese"],"k":[30,19]},"blush":{"a":"Smiling Face with Smiling Eyes","b":"1F60A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","smile","happy","flushed","crush","embarrassed","shy","joy"],"k":[30,34],"m":":)"},"passport_control":{"a":"Passport Control","b":"1F6C2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["custom","blue-square"],"k":[36,43]},"flag-ag":{"a":"Antigua & Barbuda Flag","b":"1F1E6-1F1EC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[0,35]},"peach":{"a":"Peach","b":"1F351","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fruit","nature","food"],"k":[7,19]},"dolls":{"a":"Japanese Dolls","b":"1F38E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["japanese","toy","kimono"],"k":[8,33]},"musical_note":{"a":"Musical Note","b":"1F3B5","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["score","tone","sound"],"k":[9,15]},"camping":{"a":"Camping","b":"1F3D5-FE0F","c":"1F3D5","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["photo","outdoors","tent"],"k":[11,38],"o":7},"yum":{"a":"Face Savouring Delicious Food","b":"1F60B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["happy","joy","tongue","smile","face","silly","yummy","nom","delicious","savouring"],"k":[30,35]},"customs":{"a":"Customs","b":"1F6C3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["passport","border","blue-square"],"k":[36,44]},"lion_face":{"a":"Lion Face","b":"1F981","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[42,25],"o":8},"flag-ai":{"a":"Anguilla Flag","b":"1F1E6-1F1EE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[0,36]},"cherries":{"a":"Cherries","b":"1F352","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","fruit"],"k":[7,20]},"flags":{"a":"Carp Streamer","b":"1F38F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fish","japanese","koinobori","carp","banner"],"k":[8,34]},"notes":{"a":"Multiple Musical Notes","b":"1F3B6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["music","score"],"k":[9,16]},"beach_with_umbrella":{"a":"Beach with Umbrella","b":"1F3D6-FE0F","c":"1F3D6","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[11,39],"o":7},"tiger":{"a":"Tiger Face","b":"1F42F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","cat","danger","wild","nature","roar"],"k":[13,25]},"sunglasses":{"a":"Smiling Face with Sunglasses","b":"1F60E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","cool","smile","summer","beach","sunglass"],"k":[30,38],"l":["8)"]},"baggage_claim":{"a":"Baggage Claim","b":"1F6C4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","airport","transport"],"k":[36,45]},"flag-al":{"a":"Albania Flag","b":"1F1E6-1F1F1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[0,37]},"strawberry":{"a":"Strawberry","b":"1F353","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fruit","food","nature"],"k":[7,21]},"wind_chime":{"a":"Wind Chime","b":"1F390","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","ding","spring","bell"],"k":[8,35]},"studio_microphone":{"a":"Studio Microphone","b":"1F399-FE0F","c":"1F399","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["sing","recording","artist","talkshow"],"k":[8,41],"o":7},"desert":{"a":"Desert","b":"1F3DC-FE0F","c":"1F3DC","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["photo","warm","saharah"],"k":[11,45],"o":7},"tiger2":{"a":"Tiger","b":"1F405","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","roar"],"k":[12,35]},"heart_eyes":{"a":"Smiling Face with Heart-Shaped Eyes","b":"1F60D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","love","like","affection","valentines","infatuation","crush","heart"],"k":[30,37]},"left_luggage":{"a":"Left Luggage","b":"1F6C5","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","travel"],"k":[36,46]},"flag-am":{"a":"Armenia Flag","b":"1F1E6-1F1F2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[0,38]},"rice_scene":{"a":"Moon Viewing Ceremony","b":"1F391","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["photo","japan","asia","tsukimi"],"k":[8,36]},"level_slider":{"a":"Level Slider","b":"1F39A-FE0F","c":"1F39A","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["scale"],"k":[8,42],"o":7},"desert_island":{"a":"Desert Island","b":"1F3DD-FE0F","c":"1F3DD","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["photo","tropical","mojito"],"k":[11,46],"o":7},"leopard":{"a":"Leopard","b":"1F406","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature"],"k":[12,36]},"kissing_heart":{"a":"Face Throwing a Kiss","b":"1F618","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","love","like","affection","valentines","infatuation","kiss"],"k":[30,48],"l":[":*",":-*"]},"kiwifruit":{"a":"Kiwifruit","b":"1F95D","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[42,9],"o":9},"warning":{"a":"Warning Sign","b":"26A0-FE0F","c":"26A0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["exclamation","wip","alert","error","problem","issue"],"k":[48,20],"o":4},"flag-ao":{"a":"Angola Flag","b":"1F1E6-1F1F4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[0,39]},"tomato":{"a":"Tomato","b":"1F345","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fruit","vegetable","nature","food"],"k":[7,7]},"ribbon":{"a":"Ribbon","b":"1F380","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["decoration","pink","girl","bowtie"],"k":[8,14]},"control_knobs":{"a":"Control Knobs","b":"1F39B-FE0F","c":"1F39B","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["dial"],"k":[8,43],"o":7},"national_park":{"a":"National Park","b":"1F3DE-FE0F","c":"1F3DE","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["photo","environment","nature"],"k":[11,47],"o":7},"horse":{"a":"Horse Face","b":"1F434","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","brown","nature"],"k":[13,30]},"kissing":{"a":"Kissing Face","b":"1F617","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["love","like","face","3","valentines","infatuation","kiss"],"k":[30,47]},"children_crossing":{"a":"Children Crossing","b":"1F6B8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["school","warning","danger","sign","driving","yellow-diamond"],"k":[36,28]},"flag-aq":{"a":"Antarctica Flag","b":"1F1E6-1F1F6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[0,40]},"gift":{"a":"Wrapped Present","b":"1F381","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["present","birthday","christmas","xmas"],"k":[8,15]},"microphone":{"a":"Microphone","b":"1F3A4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sound","music","PA","sing","talkshow"],"k":[8,50]},"stadium":{"a":"Stadium","b":"1F3DF-FE0F","c":"1F3DF","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["photo","place","sports","concert","venue"],"k":[11,48],"o":7},"racehorse":{"a":"Horse","b":"1F40E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","gamble","luck"],"k":[12,44]},"kissing_smiling_eyes":{"a":"Kissing Face with Smiling Eyes","b":"1F619","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","affection","valentines","infatuation","kiss"],"k":[30,49]},"coconut":{"a":"Coconut","b":"1F965","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["fruit","nature","food","palm"],"k":[42,17],"o":10},"no_entry":{"a":"No Entry","b":"26D4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["limit","security","privacy","bad","denied","stop","circle"],"k":[48,35],"o":5},"flag-ar":{"a":"Argentina Flag","b":"1F1E6-1F1F7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[0,41]},"reminder_ribbon":{"a":"Reminder Ribbon","b":"1F397-FE0F","c":"1F397","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["sports","cause","support","awareness"],"k":[8,40],"o":7},"headphones":{"a":"Headphone","b":"1F3A7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["music","score","gadgets"],"k":[9,1]},"classical_building":{"a":"Classical Building","b":"1F3DB-FE0F","c":"1F3DB","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["art","culture","history"],"k":[11,44],"o":7},"kissing_closed_eyes":{"a":"Kissing Face with Closed Eyes","b":"1F61A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","love","like","affection","valentines","infatuation","kiss"],"k":[30,50]},"no_entry_sign":{"a":"No Entry Sign","b":"1F6AB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["forbid","stop","limit","denied","disallow","circle"],"k":[35,16]},"avocado":{"a":"Avocado","b":"1F951","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["fruit","food"],"k":[41,49],"o":9},"unicorn_face":{"a":"Unicorn Face","b":"1F984","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[42,28],"o":8},"flag-as":{"a":"American Samoa Flag","b":"1F1E6-1F1F8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[0,42]},"eggplant":{"a":"Aubergine","b":"1F346","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["vegetable","nature","food","aubergine"],"k":[7,8]},"admission_tickets":{"a":"Admission Tickets","b":"1F39F-FE0F","c":"1F39F","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[8,45],"o":7},"building_construction":{"a":"Building Construction","b":"1F3D7-FE0F","c":"1F3D7","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["wip","working","progress"],"k":[11,40],"o":7},"radio":{"a":"Radio","b":"1F4FB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["communication","music","podcast","program"],"k":[26,50]},"no_bicycles":{"a":"No Bicycles","b":"1F6B3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["cyclist","prohibited","circle"],"k":[35,24]},"zebra_face":{"a":"Zebra Face","b":"1F993","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[42,43],"o":10},"relaxed":{"a":"White Smiling Face","b":"263A-FE0F","c":"263A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","blush","massage","happiness"],"k":[47,41],"o":1},"flag-at":{"a":"Austria Flag","b":"1F1E6-1F1F9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[0,43]},"ticket":{"a":"Ticket","b":"1F3AB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["event","concert","pass"],"k":[9,5]},"saxophone":{"a":"Saxophone","b":"1F3B7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["music","instrument","jazz","blues"],"k":[9,17]},"house_buildings":{"a":"House Buildings","b":"1F3D8-FE0F","c":"1F3D8","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[11,41],"o":7},"slightly_smiling_face":{"a":"Slightly Smiling Face","b":"1F642","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","smile"],"k":[31,38],"l":[":)","(:",":-)"],"o":7},"no_smoking":{"a":"No Smoking Symbol","b":"1F6AD","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["cigarette","blue-square","smell","smoke"],"k":[35,18]},"potato":{"a":"Potato","b":"1F954","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","tuber","vegatable","starch"],"k":[42,0],"o":9},"deer":{"a":"Deer","b":"1F98C","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","nature","horns","venison"],"k":[42,36],"o":9},"flag-au":{"a":"Australia Flag","b":"1F1E6-1F1FA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[0,44]},"medal":{"a":"Medal","b":"1F396-FE0F","c":"1F396","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[8,39],"o":7},"guitar":{"a":"Guitar","b":"1F3B8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["music","instrument"],"k":[9,18]},"cityscape":{"a":"Cityscape","b":"1F3D9-FE0F","c":"1F3D9","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["photo","night life","urban"],"k":[11,42],"o":7},"cow":{"a":"Cow Face","b":"1F42E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["beef","ox","animal","nature","moo","milk"],"k":[13,24]},"do_not_litter":{"a":"Do Not Litter Symbol","b":"1F6AF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["trash","bin","garbage","circle"],"k":[35,20]},"hugging_face":{"a":"Hugging Face","b":"1F917","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[37,31],"o":8},"carrot":{"a":"Carrot","b":"1F955","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["vegetable","food","orange"],"k":[42,1],"o":9},"flag-aw":{"a":"Aruba Flag","b":"1F1E6-1F1FC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[0,45]},"corn":{"a":"Ear of Maize","b":"1F33D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","vegetable","plant"],"k":[6,51]},"musical_keyboard":{"a":"Musical Keyboard","b":"1F3B9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["piano","instrument","compose"],"k":[9,19]},"trophy":{"a":"Trophy","b":"1F3C6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["win","award","contest","place","ftw","ceremony"],"k":[10,19]},"derelict_house_building":{"a":"Derelict House Building","b":"1F3DA-FE0F","c":"1F3DA","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[11,43],"o":7},"ox":{"a":"Ox","b":"1F402","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","cow","beef"],"k":[12,32]},"non-potable_water":{"a":"Non-Potable Water Symbol","b":"1F6B1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["drink","faucet","tap","circle"],"k":[35,22]},"star-struck":{"a":"Grinning Face with Star Eyes","b":"1F929","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[38,49],"n":["grinning_face_with_star_eyes"],"o":10},"flag-ax":{"a":"Åland Islands Flag","b":"1F1E6-1F1FD","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[0,46]},"hot_pepper":{"a":"Hot Pepper","b":"1F336-FE0F","c":"1F336","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","spicy","chilli","chili"],"k":[6,44],"o":7},"trumpet":{"a":"Trumpet","b":"1F3BA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["music","brass"],"k":[9,20]},"sports_medal":{"a":"Sports Medal","b":"1F3C5","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[10,18],"o":7},"house":{"a":"House Building","b":"1F3E0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["building","home"],"k":[11,49]},"water_buffalo":{"a":"Water Buffalo","b":"1F403","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","ox","cow"],"k":[12,33]},"no_pedestrians":{"a":"No Pedestrians","b":"1F6B7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["rules","crossing","walking","circle"],"k":[36,27]},"thinking_face":{"a":"Thinking Face","b":"1F914","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[37,28],"o":8},"flag-az":{"a":"Azerbaijan Flag","b":"1F1E6-1F1FF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[0,47]},"violin":{"a":"Violin","b":"1F3BB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["music","instrument","orchestra","symphony"],"k":[9,21]},"house_with_garden":{"a":"House with Garden","b":"1F3E1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["home","plant","nature"],"k":[11,50]},"cow2":{"a":"Cow","b":"1F404","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["beef","ox","animal","nature","moo","milk"],"k":[12,34]},"no_mobile_phones":{"a":"No Mobile Phones","b":"1F4F5","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["iphone","mute","circle"],"k":[26,44]},"face_with_raised_eyebrow":{"a":"Face with One Eyebrow Raised","b":"1F928","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[38,48],"n":["face_with_one_eyebrow_raised"],"o":10},"first_place_medal":{"a":"First Place Medal","b":"1F947","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[41,42],"o":9},"cucumber":{"a":"Cucumber","b":"1F952","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["fruit","food","pickle"],"k":[41,50],"o":9},"flag-ba":{"a":"Bosnia & Herzegovina Flag","b":"1F1E7-1F1E6","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[0,48]},"office":{"a":"Office Building","b":"1F3E2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["building","bureau","work"],"k":[11,51]},"pig":{"a":"Pig Face","b":"1F437","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","oink","nature"],"k":[13,33]},"underage":{"a":"No One Under Eighteen Symbol","b":"1F51E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["18","drink","pub","night","minor","circle"],"k":[27,32]},"neutral_face":{"a":"Neutral Face","b":"1F610","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["indifference","meh",":|","neutral"],"k":[30,40],"l":[":|",":-|"]},"drum_with_drumsticks":{"a":"Drum with Drumsticks","b":"1F941","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[41,37],"o":9},"second_place_medal":{"a":"Second Place Medal","b":"1F948","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[41,43],"o":9},"broccoli":{"a":"Broccoli","b":"1F966","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["fruit","food","vegetable"],"k":[42,18],"o":10},"flag-bb":{"a":"Barbados Flag","b":"1F1E7-1F1E7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[0,49]},"mushroom":{"a":"Mushroom","b":"1F344","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["plant","vegetable"],"k":[7,6]},"post_office":{"a":"Japanese Post Office","b":"1F3E3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["building","envelope","communication"],"k":[12,0]},"pig2":{"a":"Pig","b":"1F416","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature"],"k":[13,0]},"iphone":{"a":"Mobile Phone","b":"1F4F1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["technology","apple","gadgets","dial"],"k":[26,40]},"expressionless":{"a":"Expressionless Face","b":"1F611","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","indifferent","-_-","meh","deadpan"],"k":[30,41]},"third_place_medal":{"a":"Third Place Medal","b":"1F949","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[41,44],"o":9},"radioactive_sign":{"a":"Radioactive Sign","b":"2622-FE0F","c":"2622","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[47,33],"o":1},"flag-bd":{"a":"Bangladesh Flag","b":"1F1E7-1F1E9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[0,50]},"european_post_office":{"a":"European Post Office","b":"1F3E4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["building","email"],"k":[12,1]},"boar":{"a":"Boar","b":"1F417","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature"],"k":[13,1]},"calling":{"a":"Mobile Phone with Rightwards Arrow at Left","b":"1F4F2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["iphone","incoming"],"k":[26,41]},"no_mouth":{"a":"Face Without Mouth","b":"1F636","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","hellokitty"],"k":[31,26]},"peanuts":{"a":"Peanuts","b":"1F95C","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","nut"],"k":[42,8],"o":9},"biohazard_sign":{"a":"Biohazard Sign","b":"2623-FE0F","c":"2623","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[47,34],"o":1},"soccer":{"a":"Soccer Ball","b":"26BD","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sports","football"],"k":[48,26],"o":5},"flag-be":{"a":"Belgium Flag","b":"1F1E7-1F1EA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[0,51]},"chestnut":{"a":"Chestnut","b":"1F330","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","squirrel"],"k":[6,38]},"hospital":{"a":"Hospital","b":"1F3E5","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["building","health","surgery","doctor"],"k":[12,2]},"pig_nose":{"a":"Pig Nose","b":"1F43D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","oink"],"k":[13,39]},"face_with_rolling_eyes":{"a":"Face with Rolling Eyes","b":"1F644","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[31,40],"o":8},"phone":{"a":"Black Telephone","b":"260E-FE0F","c":"260E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["technology","communication","dial","telephone"],"k":[47,21],"n":["telephone"],"o":1},"baseball":{"a":"Baseball","b":"26BE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sports","balls"],"k":[48,27],"o":5},"arrow_up":{"a":"Upwards Black Arrow","b":"2B06-FE0F","c":"2B06","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","continue","top","direction"],"k":[50,18],"o":4},"flag-bf":{"a":"Burkina Faso Flag","b":"1F1E7-1F1EB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,0]},"bread":{"a":"Bread","b":"1F35E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","wheat","breakfast","toast"],"k":[7,32]},"basketball":{"a":"Basketball and Hoop","b":"1F3C0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sports","balls","NBA"],"k":[9,26]},"bank":{"a":"Bank","b":"1F3E6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["building","money","sales","cash","business","enterprise"],"k":[12,3]},"ram":{"a":"Ram","b":"1F40F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","sheep","nature"],"k":[12,45]},"telephone_receiver":{"a":"Telephone Receiver","b":"1F4DE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["technology","communication","dial"],"k":[26,21]},"smirk":{"a":"Smirking Face","b":"1F60F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","smile","mean","prank","smug","sarcasm"],"k":[30,39]},"arrow_upper_right":{"a":"North East Arrow","b":"2197-FE0F","c":"2197","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","point","direction","diagonal","northeast"],"k":[46,36],"o":1},"flag-bg":{"a":"Bulgaria Flag","b":"1F1E7-1F1EC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,1]},"volleyball":{"a":"Volleyball","b":"1F3D0","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["sports","balls"],"k":[11,33],"o":8},"hotel":{"a":"Hotel","b":"1F3E8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["building","accomodation","checkin"],"k":[12,5]},"sheep":{"a":"Sheep","b":"1F411","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","wool","shipit"],"k":[12,47]},"pager":{"a":"Pager","b":"1F4DF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["bbcall","oldschool","90s"],"k":[26,22]},"persevere":{"a":"Persevering Face","b":"1F623","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","sick","no","upset","oops"],"k":[31,7]},"croissant":{"a":"Croissant","b":"1F950","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","bread","french"],"k":[41,48],"o":9},"arrow_right":{"a":"Black Rightwards Arrow","b":"27A1-FE0F","c":"27A1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","next"],"k":[50,12],"o":1},"flag-bh":{"a":"Bahrain Flag","b":"1F1E7-1F1ED","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,2]},"football":{"a":"American Football","b":"1F3C8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sports","balls","NFL"],"k":[10,26]},"love_hotel":{"a":"Love Hotel","b":"1F3E9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["like","affection","dating"],"k":[12,6]},"goat":{"a":"Goat","b":"1F410","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature"],"k":[12,46]},"fax":{"a":"Fax Machine","b":"1F4E0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["communication","technology"],"k":[26,23]},"disappointed_relieved":{"a":"Disappointed but Relieved Face","b":"1F625","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","phew","sweat","nervous"],"k":[31,9]},"baguette_bread":{"a":"Baguette Bread","b":"1F956","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","bread","french"],"k":[42,2],"o":9},"arrow_lower_right":{"a":"South East Arrow","b":"2198-FE0F","c":"2198","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","direction","diagonal","southeast"],"k":[46,37],"o":1},"flag-bi":{"a":"Burundi Flag","b":"1F1E7-1F1EE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,3]},"rugby_football":{"a":"Rugby Football","b":"1F3C9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sports","team"],"k":[10,27]},"convenience_store":{"a":"Convenience Store","b":"1F3EA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["building","shopping","groceries"],"k":[12,7]},"dromedary_camel":{"a":"Dromedary Camel","b":"1F42A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","hot","desert","hump"],"k":[13,20]},"battery":{"a":"Battery","b":"1F50B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["power","energy","sustain"],"k":[27,13]},"open_mouth":{"a":"Face with Open Mouth","b":"1F62E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","surprise","impressed","wow","whoa",":O"],"k":[31,18],"l":[":o",":-o",":O",":-O"]},"pretzel":{"a":"Pretzel","b":"1F968","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","bread","twisted"],"k":[42,20],"o":10},"arrow_down":{"a":"Downwards Black Arrow","b":"2B07-FE0F","c":"2B07","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","direction","bottom"],"k":[50,19],"o":4},"flag-bj":{"a":"Benin Flag","b":"1F1E7-1F1EF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,4]},"tennis":{"a":"Tennis Racquet and Ball","b":"1F3BE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sports","balls","green"],"k":[9,24]},"school":{"a":"School","b":"1F3EB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["building","student","education","learn","teach"],"k":[12,8]},"camel":{"a":"Bactrian Camel","b":"1F42B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","hot","desert","hump"],"k":[13,21]},"electric_plug":{"a":"Electric Plug","b":"1F50C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["charger","power"],"k":[27,14]},"zipper_mouth_face":{"a":"Zipper-Mouth Face","b":"1F910","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["face","sealed","zipper","secret"],"k":[37,24],"o":8},"pancakes":{"a":"Pancakes","b":"1F95E","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","breakfast","flapjacks","hotcakes"],"k":[42,10],"o":9},"arrow_lower_left":{"a":"South West Arrow","b":"2199-FE0F","c":"2199","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","direction","diagonal","southwest"],"k":[46,38],"o":1},"flag-bl":{"a":"St. Barthélemy Flag","b":"1F1E7-1F1F1","d":true,"e":false,"f":true,"g":true,"h":true,"i":true,"k":[1,5]},"8ball":{"a":"Billiards","b":"1F3B1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["pool","hobby","game","luck","magic"],"k":[9,11]},"department_store":{"a":"Department Store","b":"1F3EC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["building","shopping","mall"],"k":[12,9]},"computer":{"a":"Personal Computer","b":"1F4BB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["technology","laptop","screen","display","monitor"],"k":[25,38]},"hushed":{"a":"Hushed Face","b":"1F62F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","woo","shh"],"k":[31,19]},"giraffe_face":{"a":"Giraffe Face","b":"1F992","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[42,42],"o":10},"cheese_wedge":{"a":"Cheese Wedge","b":"1F9C0","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[42,48],"o":8},"arrow_left":{"a":"Leftwards Black Arrow","b":"2B05-FE0F","c":"2B05","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","previous","back"],"k":[50,17],"o":4},"flag-bm":{"a":"Bermuda Flag","b":"1F1E7-1F1F2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,6]},"meat_on_bone":{"a":"Meat on Bone","b":"1F356","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["good","food","drumstick"],"k":[7,24]},"bowling":{"a":"Bowling","b":"1F3B3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sports","fun","play"],"k":[9,13]},"factory":{"a":"Factory","b":"1F3ED","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["building","industry","pollution","smoke"],"k":[12,10]},"elephant":{"a":"Elephant","b":"1F418","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","nose","th","circus"],"k":[13,2]},"desktop_computer":{"a":"Desktop Computer","b":"1F5A5-FE0F","c":"1F5A5","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["technology","computing","screen"],"k":[29,51],"o":7},"sleepy":{"a":"Sleepy Face","b":"1F62A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","tired","rest","nap"],"k":[31,14]},"arrow_upper_left":{"a":"North West Arrow","b":"2196-FE0F","c":"2196","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","point","direction","diagonal","northwest"],"k":[46,35],"o":1},"flag-bn":{"a":"Brunei Flag","b":"1F1E7-1F1F3","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[1,7]},"poultry_leg":{"a":"Poultry Leg","b":"1F357","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","meat","drumstick","bird","chicken","turkey"],"k":[7,25]},"cricket_bat_and_ball":{"a":"Cricket Bat and Ball","b":"1F3CF","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[11,32],"o":8},"japanese_castle":{"a":"Japanese Castle","b":"1F3EF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["photo","building"],"k":[12,12]},"printer":{"a":"Printer","b":"1F5A8-FE0F","c":"1F5A8","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["paper","ink"],"k":[30,0],"o":7},"tired_face":{"a":"Tired Face","b":"1F62B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sick","whine","upset","frustrated"],"k":[31,15]},"rhinoceros":{"a":"Rhinoceros","b":"1F98F","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","nature","horn"],"k":[42,39],"o":9},"arrow_up_down":{"a":"Up Down Arrow","b":"2195-FE0F","c":"2195","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","direction","way","vertical"],"k":[46,34],"o":1},"flag-bo":{"a":"Bolivia Flag","b":"1F1E7-1F1F4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,8]},"field_hockey_stick_and_ball":{"a":"Field Hockey Stick and Ball","b":"1F3D1","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[11,34],"o":8},"european_castle":{"a":"European Castle","b":"1F3F0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["building","royalty","history"],"k":[12,13]},"mouse":{"a":"Mouse Face","b":"1F42D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","cheese_wedge","rodent"],"k":[13,23]},"sleeping":{"a":"Sleeping Face","b":"1F634","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","tired","sleepy","night","zzz"],"k":[31,24]},"cut_of_meat":{"a":"Cut of Meat","b":"1F969","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[42,21],"o":10},"left_right_arrow":{"a":"Left Right Arrow","b":"2194-FE0F","c":"2194","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shape","direction","horizontal","sideways"],"k":[46,33],"o":1},"keyboard":{"a":"Keyboard","b":"2328-FE0F","c":"2328","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["technology","computer","type","input","text"],"k":[46,43],"o":1},"flag-bq":{"a":"Caribbean Netherlands Flag","b":"1F1E7-1F1F6","d":true,"e":false,"f":true,"g":true,"h":true,"i":true,"k":[1,9]},"ice_hockey_stick_and_puck":{"a":"Ice Hockey Stick and Puck","b":"1F3D2","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[11,35],"o":8},"mouse2":{"a":"Mouse","b":"1F401","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","rodent"],"k":[12,31]},"wedding":{"a":"Wedding","b":"1F492","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["love","like","affection","couple","marriage","bride","groom"],"k":[24,44]},"three_button_mouse":{"a":"Three Button Mouse","b":"1F5B1-FE0F","c":"1F5B1","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[30,1],"o":7},"relieved":{"a":"Relieved Face","b":"1F60C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","relaxed","phew","massage","happiness"],"k":[30,36]},"bacon":{"a":"Bacon","b":"1F953","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","breakfast","pork","pig","meat"],"k":[41,51],"o":9},"leftwards_arrow_with_hook":{"a":"Leftwards Arrow with Hook","b":"21A9-FE0F","c":"21A9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["back","return","blue-square","undo","enter"],"k":[46,39],"o":1},"flag-br":{"a":"Brazil Flag","b":"1F1E7-1F1F7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,10]},"hamburger":{"a":"Hamburger","b":"1F354","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["meat","fast food","beef","cheeseburger","mcdonalds","burger king"],"k":[7,22]},"table_tennis_paddle_and_ball":{"a":"Table Tennis Paddle and Ball","b":"1F3D3","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[11,36],"o":8},"rat":{"a":"Rat","b":"1F400","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","mouse","rodent"],"k":[12,30]},"trackball":{"a":"Trackball","b":"1F5B2-FE0F","c":"1F5B2","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["technology","trackpad"],"k":[30,2],"o":7},"tokyo_tower":{"a":"Tokyo Tower","b":"1F5FC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["photo","japanese"],"k":[30,20]},"stuck_out_tongue":{"a":"Face with Stuck-out Tongue","b":"1F61B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","prank","childish","playful","mischievous","smile","tongue"],"k":[30,51],"l":[":p",":-p",":P",":-P",":b",":-b"],"m":":p"},"arrow_right_hook":{"a":"Rightwards Arrow with Hook","b":"21AA-FE0F","c":"21AA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","return","rotate","direction"],"k":[46,40],"o":1},"flag-bs":{"a":"Bahamas Flag","b":"1F1E7-1F1F8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,11]},"fries":{"a":"French Fries","b":"1F35F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["chips","snack","fast food"],"k":[7,33]},"badminton_racquet_and_shuttlecock":{"a":"Badminton Racquet and Shuttlecock","b":"1F3F8","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[12,22],"o":8},"hamster":{"a":"Hamster Face","b":"1F439","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature"],"k":[13,35]},"minidisc":{"a":"Minidisc","b":"1F4BD","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["technology","record","data","disk","90s"],"k":[25,40]},"statue_of_liberty":{"a":"Statue of Liberty","b":"1F5FD","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["american","newyork"],"k":[30,21]},"stuck_out_tongue_winking_eye":{"a":"Face with Stuck-out Tongue and Winking Eye","b":"1F61C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","prank","childish","playful","mischievous","smile","wink","tongue"],"k":[31,0],"l":[";p",";-p",";b",";-b",";P",";-P"],"m":";p"},"arrow_heading_up":{"a":"Arrow Pointing Rightwards Then Curving Upwards","b":"2934-FE0F","c":"2934","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","direction","top"],"k":[50,15],"o":3},"flag-bt":{"a":"Bhutan Flag","b":"1F1E7-1F1F9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,12]},"pizza":{"a":"Slice of Pizza","b":"1F355","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","party"],"k":[7,23]},"rabbit":{"a":"Rabbit Face","b":"1F430","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","pet","spring","magic","bunny"],"k":[13,26]},"floppy_disk":{"a":"Floppy Disk","b":"1F4BE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["oldschool","technology","save","90s","80s"],"k":[25,41]},"stuck_out_tongue_closed_eyes":{"a":"Face with Stuck-out Tongue and Tightly-Closed Eyes","b":"1F61D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","prank","playful","mischievous","smile","tongue"],"k":[31,1]},"boxing_glove":{"a":"Boxing Glove","b":"1F94A","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["sports","fighting"],"k":[41,45],"o":9},"church":{"a":"Church","b":"26EA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["building","religion","christ"],"k":[48,37],"o":5},"arrow_heading_down":{"a":"Arrow Pointing Rightwards Then Curving Downwards","b":"2935-FE0F","c":"2935","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","direction","bottom"],"k":[50,16],"o":3},"flag-bv":{"a":"Bouvet Island Flag","b":"1F1E7-1F1FB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,13]},"hotdog":{"a":"Hot Dog","b":"1F32D","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","frankfurter"],"k":[6,35],"o":8},"rabbit2":{"a":"Rabbit","b":"1F407","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","pet","magic","spring"],"k":[12,37]},"cd":{"a":"Optical Disc","b":"1F4BF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["technology","dvd","disk","disc","90s"],"k":[25,42]},"arrows_clockwise":{"a":"Clockwise Downwards and Upwards Open Circle Arrows","b":"1F503","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sync","cycle","round","repeat"],"k":[27,5]},"mosque":{"a":"Mosque","b":"1F54C","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["islam","worship","minaret"],"k":[28,15],"o":8},"drooling_face":{"a":"Drooling Face","b":"1F924","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["face"],"k":[38,27],"o":9},"martial_arts_uniform":{"a":"Martial Arts Uniform","b":"1F94B","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["judo","karate","taekwondo"],"k":[41,46],"o":9},"flag-bw":{"a":"Botswana Flag","b":"1F1E7-1F1FC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,14]},"chipmunk":{"a":"Chipmunk","b":"1F43F-FE0F","c":"1F43F","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","nature","rodent","squirrel"],"k":[13,41],"o":7},"dvd":{"a":"Dvd","b":"1F4C0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["cd","disk","disc"],"k":[25,43]},"arrows_counterclockwise":{"a":"Anticlockwise Downwards and Upwards Open Circle Arrows","b":"1F504","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","sync","cycle"],"k":[27,6]},"synagogue":{"a":"Synagogue","b":"1F54D","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["judaism","worship","temple","jewish"],"k":[28,16],"o":8},"unamused":{"a":"Unamused Face","b":"1F612","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["indifference","bored","straight face","serious","sarcasm"],"k":[30,42],"m":":("},"goal_net":{"a":"Goal Net","b":"1F945","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["sports"],"k":[41,41],"o":9},"sandwich":{"a":"Sandwich","b":"1F96A","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","lunch","bread"],"k":[42,22],"o":10},"flag-by":{"a":"Belarus Flag","b":"1F1E7-1F1FE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,15]},"taco":{"a":"Taco","b":"1F32E","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","mexican"],"k":[6,36],"o":8},"movie_camera":{"a":"Movie Camera","b":"1F3A5","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["film","record"],"k":[8,51]},"dart":{"a":"Direct Hit","b":"1F3AF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["game","play","bar","target","bullseye"],"k":[9,9]},"back":{"a":"Back with Leftwards Arrow Above","b":"1F519","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["arrow","words","return"],"k":[27,27]},"sweat":{"a":"Face with Cold Sweat","b":"1F613","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","hot","sad","tired","exercise"],"k":[30,43]},"hedgehog":{"a":"Hedgehog","b":"1F994","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","nature","spiny"],"k":[42,44],"o":10},"shinto_shrine":{"a":"Shinto Shrine","b":"26E9-FE0F","c":"26E9","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["temple","japan","kyoto"],"k":[48,36],"o":5},"flag-bz":{"a":"Belize Flag","b":"1F1E7-1F1FF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,16]},"burrito":{"a":"Burrito","b":"1F32F","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","mexican"],"k":[6,37],"o":8},"film_frames":{"a":"Film Frames","b":"1F39E-FE0F","c":"1F39E","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[8,44],"o":7},"end":{"a":"End with Leftwards Arrow Above","b":"1F51A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["words","arrow"],"k":[27,28]},"kaaba":{"a":"Kaaba","b":"1F54B","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["mecca","mosque","islam"],"k":[28,14],"o":8},"pensive":{"a":"Pensive Face","b":"1F614","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","sad","depressed","upset"],"k":[30,44]},"bat":{"a":"Bat","b":"1F987","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","nature","blind","vampire"],"k":[42,31],"o":9},"golf":{"a":"Flag in Hole","b":"26F3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sports","business","flag","hole","summer"],"k":[48,41],"o":5},"flag-ca":{"a":"Canada Flag","b":"1F1E8-1F1E6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,17]},"bear":{"a":"Bear Face","b":"1F43B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","wild"],"k":[13,37]},"film_projector":{"a":"Film Projector","b":"1F4FD-FE0F","c":"1F4FD","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["video","tape","record","movie"],"k":[27,0],"o":7},"on":{"a":"On with Exclamation Mark with Left Right Arrow Above","b":"1F51B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["arrow","words"],"k":[27,29]},"confused":{"a":"Confused Face","b":"1F615","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","indifference","huh","weird","hmmm",":/"],"k":[30,45],"l":[":\\",":-\\",":/",":-/"]},"stuffed_flatbread":{"a":"Stuffed Flatbread","b":"1F959","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","flatbread","stuffed","gyro"],"k":[42,5],"o":9},"fountain":{"a":"Fountain","b":"26F2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["photo","summer","water","fresh"],"k":[48,40],"o":5},"ice_skate":{"a":"Ice Skate","b":"26F8-FE0F","c":"26F8","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["sports"],"k":[48,45],"o":5},"flag-cc":{"a":"Cocos (keeling) Islands Flag","b":"1F1E8-1F1E8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,18]},"fishing_pole_and_fish":{"a":"Fishing Pole and Fish","b":"1F3A3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","hobby","summer"],"k":[8,49]},"clapper":{"a":"Clapper Board","b":"1F3AC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["movie","film","record"],"k":[9,6]},"koala":{"a":"Koala","b":"1F428","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature"],"k":[13,18]},"soon":{"a":"Soon with Rightwards Arrow Above","b":"1F51C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["arrow","words"],"k":[27,30]},"upside_down_face":{"a":"Upside-Down Face","b":"1F643","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["face","flipped","silly","smile"],"k":[31,39],"o":8},"egg":{"a":"Egg","b":"1F95A","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","chicken","breakfast"],"k":[42,6],"o":9},"tent":{"a":"Tent","b":"26FA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["photo","camping","outdoors"],"k":[49,12],"o":5},"flag-cd":{"a":"Congo - Kinshasa Flag","b":"1F1E8-1F1E9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,19]},"foggy":{"a":"Foggy","b":"1F301","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["photo","mountain"],"k":[5,45]},"fried_egg":{"a":"Cooking","b":"1F373","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","breakfast","kitchen","egg"],"k":[8,1],"n":["cooking"]},"running_shirt_with_sash":{"a":"Running Shirt with Sash","b":"1F3BD","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["play","pageant"],"k":[9,23]},"panda_face":{"a":"Panda Face","b":"1F43C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","panda"],"k":[13,38]},"tv":{"a":"Television","b":"1F4FA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["technology","program","oldschool","show","television"],"k":[26,49]},"top":{"a":"Top with Upwards Arrow Above","b":"1F51D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["words","blue-square"],"k":[27,31]},"money_mouth_face":{"a":"Money-Mouth Face","b":"1F911","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["face","rich","dollar","money"],"k":[37,25],"o":8},"flag-cf":{"a":"Central African Republic Flag","b":"1F1E8-1F1EB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,20]},"night_with_stars":{"a":"Night with Stars","b":"1F303","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["evening","city","downtown"],"k":[5,47]},"ski":{"a":"Ski and Ski Boot","b":"1F3BF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sports","winter","cold","snow"],"k":[9,25]},"feet":{"a":"Paw Prints","b":"1F43E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[13,40],"n":["paw_prints"]},"camera":{"a":"Camera","b":"1F4F7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["gadgets","photography"],"k":[26,46]},"astonished":{"a":"Astonished Face","b":"1F632","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","xox","surprised","poisoned"],"k":[31,22]},"place_of_worship":{"a":"Place of Worship","b":"1F6D0","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["religion","church","temple","prayer"],"k":[37,5],"o":8},"shallow_pan_of_food":{"a":"Shallow Pan of Food","b":"1F958","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","cooking","casserole","paella"],"k":[42,4],"o":9},"flag-cg":{"a":"Congo - Brazzaville Flag","b":"1F1E8-1F1EC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,21]},"sunrise_over_mountains":{"a":"Sunrise over Mountains","b":"1F304","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["view","vacation","photo"],"k":[5,48]},"stew":{"a":"Pot of Food","b":"1F372","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","meat","soup"],"k":[8,0]},"camera_with_flash":{"a":"Camera with Flash","b":"1F4F8","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[26,47],"o":7},"sled":{"a":"Sled","b":"1F6F7","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["sleigh","luge","toboggan"],"k":[37,22],"o":10},"turkey":{"a":"Turkey","b":"1F983","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","bird"],"k":[42,27],"o":8},"white_frowning_face":{"a":"White Frowning Face","b":"2639-FE0F","c":"2639","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[47,40],"o":1},"atom_symbol":{"a":"Atom Symbol","b":"269B-FE0F","c":"269B","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["science","physics","chemistry"],"k":[48,18],"o":4},"flag-ch":{"a":"Switzerland Flag","b":"1F1E8-1F1ED","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,22]},"sunrise":{"a":"Sunrise","b":"1F305","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["morning","view","vacation","photo"],"k":[5,49]},"chicken":{"a":"Chicken","b":"1F414","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","cluck","nature","bird"],"k":[12,50]},"video_camera":{"a":"Video Camera","b":"1F4F9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["film","record"],"k":[26,48]},"om_symbol":{"a":"Om Symbol","b":"1F549-FE0F","c":"1F549","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[28,12],"o":7},"slightly_frowning_face":{"a":"Slightly Frowning Face","b":"1F641","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["face","frowning","disappointed","sad","upset"],"k":[31,37],"o":7},"curling_stone":{"a":"Curling Stone","b":"1F94C","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["sports"],"k":[41,47],"o":10},"bowl_with_spoon":{"a":"Bowl with Spoon","b":"1F963","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","breakfast","cereal","oatmeal","porridge"],"k":[42,15],"o":10},"flag-ci":{"a":"Côte D’ivoire Flag","b":"1F1E8-1F1EE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,23]},"city_sunset":{"a":"Cityscape at Dusk","b":"1F306","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["photo","evening","sky","buildings"],"k":[5,50]},"video_game":{"a":"Video Game","b":"1F3AE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["play","console","PS4","controller"],"k":[9,8]},"rooster":{"a":"Rooster","b":"1F413","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","chicken"],"k":[12,49]},"vhs":{"a":"Videocassette","b":"1F4FC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["record","video","oldschool","90s","80s"],"k":[26,51]},"confounded":{"a":"Confounded Face","b":"1F616","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","confused","sick","unwell","oops",":S"],"k":[30,46]},"green_salad":{"a":"Green Salad","b":"1F957","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","healthy","lettuce"],"k":[42,3],"o":9},"star_of_david":{"a":"Star of David","b":"2721-FE0F","c":"2721","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["judaism"],"k":[49,47],"o":1},"flag-ck":{"a":"Cook Islands Flag","b":"1F1E8-1F1F0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,24]},"city_sunrise":{"a":"Sunset over Buildings","b":"1F307","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["photo","good morning","dawn"],"k":[5,51]},"popcorn":{"a":"Popcorn","b":"1F37F","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","movie theater","films","snack"],"k":[8,13],"o":8},"hatching_chick":{"a":"Hatching Chick","b":"1F423","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","chicken","egg","born","baby","bird"],"k":[13,13]},"mag":{"a":"Left-Pointing Magnifying Glass","b":"1F50D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["search","zoom","find","detective"],"k":[27,15]},"joystick":{"a":"Joystick","b":"1F579-FE0F","c":"1F579","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["game","play"],"k":[29,20],"o":7},"disappointed":{"a":"Disappointed Face","b":"1F61E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","sad","upset","depressed",":("],"k":[31,2],"l":["):",":(",":-("],"m":":("},"wheel_of_dharma":{"a":"Wheel of Dharma","b":"2638-FE0F","c":"2638","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["hinduism","buddhism","sikhism","jainism"],"k":[47,39],"o":1},"flag-cl":{"a":"Chile Flag","b":"1F1E8-1F1F1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,25]},"bridge_at_night":{"a":"Bridge at Night","b":"1F309","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["photo","sanfrancisco"],"k":[6,1]},"game_die":{"a":"Game Die","b":"1F3B2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["dice","random","tabletop","play","luck"],"k":[9,12]},"baby_chick":{"a":"Baby Chick","b":"1F424","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","chicken","bird"],"k":[13,14]},"mag_right":{"a":"Right-Pointing Magnifying Glass","b":"1F50E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["search","zoom","find","detective"],"k":[27,16]},"worried":{"a":"Worried Face","b":"1F61F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","concern","nervous",":("],"k":[31,3]},"canned_food":{"a":"Canned Food","b":"1F96B","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","soup"],"k":[42,23],"o":10},"yin_yang":{"a":"Yin Yang","b":"262F-FE0F","c":"262F","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["balance"],"k":[47,38],"o":1},"flag-cm":{"a":"Cameroon Flag","b":"1F1E8-1F1F2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,26]},"bento":{"a":"Bento Box","b":"1F371","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","japanese","box"],"k":[7,51]},"hatched_chick":{"a":"Front-Facing Baby Chick","b":"1F425","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","chicken","baby","bird"],"k":[13,15]},"microscope":{"a":"Microscope","b":"1F52C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["laboratory","experiment","zoomin","science","study"],"k":[27,46]},"triumph":{"a":"Face with Look of Triumph","b":"1F624","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","gas","phew","proud","pride"],"k":[31,8]},"spades":{"a":"Black Spade Suit","b":"2660-FE0F","c":"2660","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["poker","cards","suits","magic"],"k":[48,4],"o":1},"hotsprings":{"a":"Hot Springs","b":"2668-FE0F","c":"2668","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["bath","warm","relax"],"k":[48,8],"o":1},"latin_cross":{"a":"Latin Cross","b":"271D-FE0F","c":"271D","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["christianity"],"k":[49,46],"o":1},"cn":{"a":"China Flag","b":"1F1E8-1F1F3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["china","chinese","prc","flag","country","nation","banner"],"k":[1,27],"n":["flag-cn"]},"milky_way":{"a":"Milky Way","b":"1F30C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["photo","space","stars"],"k":[6,4]},"rice_cracker":{"a":"Rice Cracker","b":"1F358","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","japanese"],"k":[7,26]},"bird":{"a":"Bird","b":"1F426","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","fly","tweet","spring"],"k":[13,16]},"telescope":{"a":"Telescope","b":"1F52D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["stars","space","zoom","science","astronomy"],"k":[27,47]},"cry":{"a":"Crying Face","b":"1F622","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","tears","sad","depressed","upset",":'("],"k":[31,6],"l":[":'("],"m":":'("},"orthodox_cross":{"a":"Orthodox Cross","b":"2626-FE0F","c":"2626","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["suppedaneum","religion"],"k":[47,35],"o":1},"hearts":{"a":"Black Heart Suit","b":"2665-FE0F","c":"2665","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["poker","cards","magic","suits"],"k":[48,6],"o":1},"flag-co":{"a":"Colombia Flag","b":"1F1E8-1F1F4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,28]},"rice_ball":{"a":"Rice Ball","b":"1F359","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","japanese"],"k":[7,27]},"carousel_horse":{"a":"Carousel Horse","b":"1F3A0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["photo","carnival"],"k":[8,46]},"penguin":{"a":"Penguin","b":"1F427","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature"],"k":[13,17]},"satellite_antenna":{"a":"Satellite Antenna","b":"1F4E1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[26,24]},"sob":{"a":"Loudly Crying Face","b":"1F62D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","cry","tears","sad","upset","depressed"],"k":[31,17],"m":":'("},"star_and_crescent":{"a":"Star and Crescent","b":"262A-FE0F","c":"262A","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["islam"],"k":[47,36],"o":1},"diamonds":{"a":"Black Diamond Suit","b":"2666-FE0F","c":"2666","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["poker","cards","magic","suits"],"k":[48,7],"o":1},"flag-cp":{"a":"Clipperton Island Flag","b":"1F1E8-1F1F5","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[1,29]},"rice":{"a":"Cooked Rice","b":"1F35A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","china","asian"],"k":[7,28]},"ferris_wheel":{"a":"Ferris Wheel","b":"1F3A1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["photo","carnival","londoneye"],"k":[8,47]},"dove_of_peace":{"a":"Dove of Peace","b":"1F54A-FE0F","c":"1F54A","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[28,13],"o":7},"candle":{"a":"Candle","b":"1F56F-FE0F","c":"1F56F","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["fire","wax"],"k":[28,42],"o":7},"frowning":{"a":"Frowning Face with Open Mouth","b":"1F626","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","aw","what"],"k":[31,10]},"peace_symbol":{"a":"Peace Symbol","b":"262E-FE0F","c":"262E","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["hippie"],"k":[47,37],"o":1},"clubs":{"a":"Black Club Suit","b":"2663-FE0F","c":"2663","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["poker","cards","magic","suits"],"k":[48,5],"o":1},"black_joker":{"a":"Playing Card Black Joker","b":"1F0CF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["poker","cards","game","play","magic"],"k":[0,15]},"flag-cr":{"a":"Costa Rica Flag","b":"1F1E8-1F1F7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,30]},"curry":{"a":"Curry and Rice","b":"1F35B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","spicy","hot","indian"],"k":[7,29]},"roller_coaster":{"a":"Roller Coaster","b":"1F3A2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["carnival","playground","photo","fun"],"k":[8,48]},"bulb":{"a":"Electric Light Bulb","b":"1F4A1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["light","electricity","idea"],"k":[25,7]},"menorah_with_nine_branches":{"a":"Menorah with Nine Branches","b":"1F54E","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[28,17],"o":8},"anguished":{"a":"Anguished Face","b":"1F627","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","stunned","nervous"],"k":[31,11],"l":["D:"]},"eagle":{"a":"Eagle","b":"1F985","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","nature","bird"],"k":[42,29],"o":9},"mahjong":{"a":"Mahjong Tile Red Dragon","b":"1F004","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["game","play","chinese","kanji"],"k":[0,14],"o":5},"flag-cu":{"a":"Cuba Flag","b":"1F1E8-1F1FA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,31]},"ramen":{"a":"Steaming Bowl","b":"1F35C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","japanese","noodle","chopsticks"],"k":[7,30]},"barber":{"a":"Barber Pole","b":"1F488","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["hair","salon","style"],"k":[24,34]},"flashlight":{"a":"Electric Torch","b":"1F526","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["dark","camping","sight","night"],"k":[27,40]},"six_pointed_star":{"a":"Six Pointed Star with Middle Dot","b":"1F52F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["purple-square","religion","jewish","hexagram"],"k":[27,49]},"fearful":{"a":"Fearful Face","b":"1F628","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","scared","terrified","nervous","oops","huh"],"k":[31,12]},"duck":{"a":"Duck","b":"1F986","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","nature","bird","mallard"],"k":[42,30],"o":9},"flag-cv":{"a":"Cape Verde Flag","b":"1F1E8-1F1FB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,32]},"spaghetti":{"a":"Spaghetti","b":"1F35D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","italian","noodle"],"k":[7,31]},"circus_tent":{"a":"Circus Tent","b":"1F3AA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["festival","carnival","party"],"k":[9,4]},"flower_playing_cards":{"a":"Flower Playing Cards","b":"1F3B4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["game","sunset","red"],"k":[9,14]},"izakaya_lantern":{"a":"Izakaya Lantern","b":"1F3EE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["light","paper","halloween","spooky"],"k":[12,11],"n":["lantern"]},"weary":{"a":"Weary Face","b":"1F629","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","tired","sleepy","sad","frustrated","upset"],"k":[31,13]},"owl":{"a":"Owl","b":"1F989","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","nature","bird","hoot"],"k":[42,33],"o":9},"aries":{"a":"Aries","b":"2648","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sign","purple-square","zodiac","astrology"],"k":[47,44],"o":1},"flag-cw":{"a":"Curaçao Flag","b":"1F1E8-1F1FC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,33]},"sweet_potato":{"a":"Roasted Sweet Potato","b":"1F360","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","nature"],"k":[7,34]},"performing_arts":{"a":"Performing Arts","b":"1F3AD","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["acting","theater","drama"],"k":[9,7]},"frog":{"a":"Frog Face","b":"1F438","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","croak","toad"],"k":[13,34]},"notebook_with_decorative_cover":{"a":"Notebook with Decorative Cover","b":"1F4D4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["classroom","notes","record","paper","study"],"k":[26,11]},"exploding_head":{"a":"Shocked Face with Exploding Head","b":"1F92F","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["face","shocked","mind","blown"],"k":[39,3],"n":["shocked_face_with_exploding_head"],"o":10},"taurus":{"a":"Taurus","b":"2649","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["purple-square","sign","zodiac","astrology"],"k":[47,45],"o":1},"flag-cx":{"a":"Christmas Island Flag","b":"1F1E8-1F1FD","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,34]},"oden":{"a":"Oden","b":"1F362","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","japanese"],"k":[7,36]},"crocodile":{"a":"Crocodile","b":"1F40A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","reptile","lizard","alligator"],"k":[12,40]},"closed_book":{"a":"Closed Book","b":"1F4D5","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["read","library","knowledge","textbook","learn"],"k":[26,12]},"frame_with_picture":{"a":"Frame with Picture","b":"1F5BC-FE0F","c":"1F5BC","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[30,3],"o":7},"grimacing":{"a":"Grimacing Face","b":"1F62C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","grimace","teeth"],"k":[31,16]},"gemini":{"a":"Gemini","b":"264A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sign","zodiac","purple-square","astrology"],"k":[47,46],"o":1},"flag-cy":{"a":"Cyprus Flag","b":"1F1E8-1F1FE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,35]},"sushi":{"a":"Sushi","b":"1F363","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","fish","japanese","rice"],"k":[7,37]},"art":{"a":"Artist Palette","b":"1F3A8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["design","paint","draw","colors"],"k":[9,2]},"turtle":{"a":"Turtle","b":"1F422","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","slow","nature","tortoise"],"k":[13,12]},"book":{"a":"Open Book","b":"1F4D6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[26,13],"n":["open_book"]},"cold_sweat":{"a":"Face with Open Mouth and Cold Sweat","b":"1F630","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","nervous","sweat"],"k":[31,20]},"cancer":{"a":"Cancer","b":"264B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sign","zodiac","purple-square","astrology"],"k":[47,47],"o":1},"flag-cz":{"a":"Czechia Flag","b":"1F1E8-1F1FF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,36]},"fried_shrimp":{"a":"Fried Shrimp","b":"1F364","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","animal","appetizer","summer"],"k":[7,38]},"slot_machine":{"a":"Slot Machine","b":"1F3B0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["bet","gamble","vegas","fruit machine","luck","casino"],"k":[9,10]},"green_book":{"a":"Green Book","b":"1F4D7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["read","library","knowledge","study"],"k":[26,14]},"scream":{"a":"Face Screaming in Fear","b":"1F631","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","munch","scared","omg"],"k":[31,21]},"lizard":{"a":"Lizard","b":"1F98E","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","nature","reptile"],"k":[42,38],"o":9},"leo":{"a":"Leo","b":"264C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sign","purple-square","zodiac","astrology"],"k":[47,48],"o":1},"de":{"a":"Germany Flag","b":"1F1E9-1F1EA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["german","nation","flag","country","banner"],"k":[1,37],"n":["flag-de"]},"fish_cake":{"a":"Fish Cake with Swirl Design","b":"1F365","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","japan","sea","beach","narutomaki","pink","swirl","kamaboko","surimi","ramen"],"k":[7,39]},"snake":{"a":"Snake","b":"1F40D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","evil","nature","hiss","python"],"k":[12,43]},"blue_book":{"a":"Blue Book","b":"1F4D8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["read","library","knowledge","learn","study"],"k":[26,15]},"flushed":{"a":"Flushed Face","b":"1F633","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","blush","shy","flattered"],"k":[31,23]},"steam_locomotive":{"a":"Steam Locomotive","b":"1F682","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["transportation","vehicle","train"],"k":[34,10]},"virgo":{"a":"Virgo","b":"264D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sign","zodiac","purple-square","astrology"],"k":[47,49],"o":1},"flag-dg":{"a":"Diego Garcia Flag","b":"1F1E9-1F1EC","d":true,"e":false,"f":true,"g":true,"h":true,"i":true,"k":[1,38]},"dango":{"a":"Dango","b":"1F361","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","dessert","sweet","japanese","barbecue","meat"],"k":[7,35]},"dragon_face":{"a":"Dragon Face","b":"1F432","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","myth","nature","chinese","green"],"k":[13,28]},"orange_book":{"a":"Orange Book","b":"1F4D9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["read","library","knowledge","textbook","study"],"k":[26,16]},"railway_car":{"a":"Railway Car","b":"1F683","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["transportation","vehicle"],"k":[34,11]},"zany_face":{"a":"Grinning Face with One Large and One Small Eye","b":"1F92A","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[38,50],"n":["grinning_face_with_one_large_and_one_small_eye"],"o":10},"libra":{"a":"Libra","b":"264E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sign","purple-square","zodiac","astrology"],"k":[47,50],"o":1},"flag-dj":{"a":"Djibouti Flag","b":"1F1E9-1F1EF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,39]},"dragon":{"a":"Dragon","b":"1F409","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","myth","nature","chinese","green"],"k":[12,39]},"books":{"a":"Books","b":"1F4DA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["literature","library","study"],"k":[26,17]},"dizzy_face":{"a":"Dizzy Face","b":"1F635","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["spent","unconscious","xox","dizzy"],"k":[31,25]},"bullettrain_side":{"a":"High-Speed Train","b":"1F684","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["transportation","vehicle"],"k":[34,12]},"dumpling":{"a":"Dumpling","b":"1F95F","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","empanada","pierogi","potsticker"],"k":[42,11],"o":10},"scorpius":{"a":"Scorpius","b":"264F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sign","zodiac","purple-square","astrology","scorpio"],"k":[47,51],"o":1},"flag-dk":{"a":"Denmark Flag","b":"1F1E9-1F1F0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,40]},"notebook":{"a":"Notebook","b":"1F4D3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["stationery","record","notes","paper","study"],"k":[26,10]},"rage":{"a":"Pouting Face","b":"1F621","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["angry","mad","hate","despise"],"k":[31,5]},"bullettrain_front":{"a":"High-Speed Train with Bullet Nose","b":"1F685","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["transportation","vehicle","speed","fast","public","travel"],"k":[34,13]},"fortune_cookie":{"a":"Fortune Cookie","b":"1F960","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","prophecy"],"k":[42,12],"o":10},"sauropod":{"a":"Sauropod","b":"1F995","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","nature","dinosaur","brachiosaurus","brontosaurus","diplodocus","extinct"],"k":[42,45],"o":10},"sagittarius":{"a":"Sagittarius","b":"2650","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sign","zodiac","purple-square","astrology"],"k":[48,0],"o":1},"flag-dm":{"a":"Dominica Flag","b":"1F1E9-1F1F2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,41]},"ledger":{"a":"Ledger","b":"1F4D2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["notes","paper"],"k":[26,9]},"angry":{"a":"Angry Face","b":"1F620","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["mad","face","annoyed","frustrated"],"k":[31,4],"l":[">:(",">:-("]},"train2":{"a":"Train","b":"1F686","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["transportation","vehicle"],"k":[34,14]},"takeout_box":{"a":"Takeout Box","b":"1F961","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","leftovers"],"k":[42,13],"o":10},"t-rex":{"a":"T-Rex","b":"1F996","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","nature","dinosaur","tyrannosaurus","extinct"],"k":[42,46],"o":10},"capricorn":{"a":"Capricorn","b":"2651","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sign","zodiac","purple-square","astrology"],"k":[48,1],"o":1},"flag-do":{"a":"Dominican Republic Flag","b":"1F1E9-1F1F4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,42]},"icecream":{"a":"Soft Ice Cream","b":"1F366","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","hot","dessert","summer"],"k":[7,40]},"whale":{"a":"Spouting Whale","b":"1F433","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","sea","ocean"],"k":[13,29]},"page_with_curl":{"a":"Page with Curl","b":"1F4C3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["documents","office","paper"],"k":[25,46]},"metro":{"a":"Metro","b":"1F687","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["transportation","blue-square","mrt","underground","tube"],"k":[34,15]},"face_with_symbols_on_mouth":{"a":"Serious Face with Symbols Covering Mouth","b":"1F92C","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[39,0],"n":["serious_face_with_symbols_covering_mouth"],"o":10},"aquarius":{"a":"Aquarius","b":"2652","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sign","purple-square","zodiac","astrology"],"k":[48,2],"o":1},"flag-dz":{"a":"Algeria Flag","b":"1F1E9-1F1FF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,43]},"shaved_ice":{"a":"Shaved Ice","b":"1F367","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["hot","dessert","summer"],"k":[7,41]},"whale2":{"a":"Whale","b":"1F40B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","sea","ocean"],"k":[12,41]},"scroll":{"a":"Scroll","b":"1F4DC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["documents","ancient","history","paper"],"k":[26,19]},"mask":{"a":"Face with Medical Mask","b":"1F637","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","sick","ill","disease"],"k":[31,27]},"light_rail":{"a":"Light Rail","b":"1F688","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["transportation","vehicle"],"k":[34,16]},"pisces":{"a":"Pisces","b":"2653","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["purple-square","sign","zodiac","astrology"],"k":[48,3],"o":1},"flag-ea":{"a":"Ceuta & Melilla Flag","b":"1F1EA-1F1E6","d":true,"e":false,"f":true,"g":true,"h":true,"i":true,"k":[1,44]},"ice_cream":{"a":"Ice Cream","b":"1F368","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","hot","dessert"],"k":[7,42]},"dolphin":{"a":"Dolphin","b":"1F42C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","fish","sea","ocean","flipper","fins","beach"],"k":[13,22],"n":["flipper"]},"page_facing_up":{"a":"Page Facing Up","b":"1F4C4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["documents","office","paper","information"],"k":[25,47]},"station":{"a":"Station","b":"1F689","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["transportation","vehicle","public"],"k":[34,17]},"face_with_thermometer":{"a":"Face with Thermometer","b":"1F912","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["sick","temperature","thermometer","cold","fever"],"k":[37,26],"o":8},"ophiuchus":{"a":"Ophiuchus","b":"26CE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sign","purple-square","constellation","astrology"],"k":[48,31]},"flag-ec":{"a":"Ecuador Flag","b":"1F1EA-1F1E8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,45]},"doughnut":{"a":"Doughnut","b":"1F369","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","dessert","snack","sweet","donut"],"k":[7,43]},"fish":{"a":"Fish","b":"1F41F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","food","nature"],"k":[13,9]},"newspaper":{"a":"Newspaper","b":"1F4F0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["press","headline"],"k":[26,39]},"twisted_rightwards_arrows":{"a":"Twisted Rightwards Arrows","b":"1F500","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","shuffle","music","random"],"k":[27,2]},"tram":{"a":"Tram","b":"1F68A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["transportation","vehicle"],"k":[34,18]},"face_with_head_bandage":{"a":"Face with Head-Bandage","b":"1F915","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["injured","clumsy","bandage","hurt"],"k":[37,29],"o":8},"flag-ee":{"a":"Estonia Flag","b":"1F1EA-1F1EA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,46]},"cookie":{"a":"Cookie","b":"1F36A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","snack","oreo","chocolate","sweet","dessert"],"k":[7,44]},"tropical_fish":{"a":"Tropical Fish","b":"1F420","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","swim","ocean","beach","nemo"],"k":[13,10]},"repeat":{"a":"Clockwise Rightwards and Leftwards Open Circle Arrows","b":"1F501","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["loop","record"],"k":[27,3]},"rolled_up_newspaper":{"a":"Rolled Up Newspaper","b":"1F5DE-FE0F","c":"1F5DE","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[30,12],"o":7},"monorail":{"a":"Monorail","b":"1F69D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["transportation","vehicle"],"k":[34,37]},"nauseated_face":{"a":"Nauseated Face","b":"1F922","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["face","vomit","gross","green","sick","throw up","ill"],"k":[38,25],"o":9},"flag-eg":{"a":"Egypt Flag","b":"1F1EA-1F1EC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,47]},"birthday":{"a":"Birthday Cake","b":"1F382","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","dessert","cake"],"k":[8,16]},"blowfish":{"a":"Blowfish","b":"1F421","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","nature","food","sea","ocean"],"k":[13,11]},"bookmark_tabs":{"a":"Bookmark Tabs","b":"1F4D1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["favorite","save","order","tidy"],"k":[26,8]},"repeat_one":{"a":"Clockwise Rightwards and Leftwards Open Circle Arrows with Circled One Overlay","b":"1F502","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","loop"],"k":[27,4]},"mountain_railway":{"a":"Mountain Railway","b":"1F69E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["transportation","vehicle"],"k":[34,38]},"face_vomiting":{"a":"Face with Open Mouth Vomiting","b":"1F92E","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[39,2],"n":["face_with_open_mouth_vomiting"],"o":10},"flag-eh":{"a":"Western Sahara Flag","b":"1F1EA-1F1ED","d":true,"e":false,"f":true,"g":true,"h":true,"i":true,"k":[1,48]},"cake":{"a":"Shortcake","b":"1F370","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","dessert"],"k":[7,50]},"bookmark":{"a":"Bookmark","b":"1F516","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["favorite","label","save"],"k":[27,24]},"train":{"a":"Tram Car","b":"1F68B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["transportation","vehicle","carriage","public","travel"],"k":[34,19]},"sneezing_face":{"a":"Sneezing Face","b":"1F927","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["face","gesundheit","sneeze","sick","allergy"],"k":[38,47],"o":9},"shark":{"a":"Shark","b":"1F988","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","nature","fish","sea","ocean","jaws","fins","beach"],"k":[42,32],"o":9},"arrow_forward":{"a":"Black Right-Pointing Triangle","b":"25B6-FE0F","c":"25B6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","right","direction","play"],"k":[47,10],"o":1},"flag-er":{"a":"Eritrea Flag","b":"1F1EA-1F1F7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,49]},"label":{"a":"Label","b":"1F3F7-FE0F","c":"1F3F7","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["sale","tag"],"k":[12,21],"o":7},"octopus":{"a":"Octopus","b":"1F419","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","creature","ocean","sea","nature","beach"],"k":[13,3]},"innocent":{"a":"Smiling Face with Halo","b":"1F607","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","angel","heaven","halo"],"k":[30,31]},"bus":{"a":"Bus","b":"1F68C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["car","vehicle","transportation"],"k":[34,20]},"pie":{"a":"Pie","b":"1F967","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food","dessert","pastry"],"k":[42,19],"o":10},"fast_forward":{"a":"Black Right-Pointing Double Triangle","b":"23E9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","play","speed","continue"],"k":[46,45]},"es":{"a":"Spain Flag","b":"1F1EA-1F1F8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["spain","flag","nation","country","banner"],"k":[1,50],"n":["flag-es"]},"chocolate_bar":{"a":"Chocolate Bar","b":"1F36B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","snack","dessert","sweet"],"k":[7,45]},"shell":{"a":"Spiral Shell","b":"1F41A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","sea","beach"],"k":[13,4]},"moneybag":{"a":"Money Bag","b":"1F4B0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["dollar","payment","coins","sale"],"k":[25,27]},"oncoming_bus":{"a":"Oncoming Bus","b":"1F68D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["vehicle","transportation"],"k":[34,21]},"face_with_cowboy_hat":{"a":"Face with Cowboy Hat","b":"1F920","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[38,23],"o":9},"black_right_pointing_double_triangle_with_vertical_bar":{"a":"Black Right Pointing Double Triangle with Vertical Bar","b":"23ED-FE0F","c":"23ED","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[46,49]},"flag-et":{"a":"Ethiopia Flag","b":"1F1EA-1F1F9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[1,51]},"candy":{"a":"Candy","b":"1F36C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["snack","dessert","sweet","lolly"],"k":[7,46]},"yen":{"a":"Banknote with Yen Sign","b":"1F4B4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["money","sales","japanese","dollar","currency"],"k":[25,31]},"trolleybus":{"a":"Trolleybus","b":"1F68E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["bart","transportation","vehicle"],"k":[34,22]},"clown_face":{"a":"Clown Face","b":"1F921","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["face"],"k":[38,24],"o":9},"crab":{"a":"Crab","b":"1F980","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","crustacean"],"k":[42,24],"o":8},"black_right_pointing_triangle_with_double_vertical_bar":{"a":"Black Right Pointing Triangle with Double Vertical Bar","b":"23EF-FE0F","c":"23EF","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[46,51]},"flag-eu":{"a":"European Union Flag","b":"1F1EA-1F1FA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,0]},"lollipop":{"a":"Lollipop","b":"1F36D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","snack","candy","sweet"],"k":[7,47]},"dollar":{"a":"Banknote with Dollar Sign","b":"1F4B5","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["money","sales","bill","currency"],"k":[25,32]},"minibus":{"a":"Minibus","b":"1F690","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["vehicle","car","transportation"],"k":[34,24]},"lying_face":{"a":"Lying Face","b":"1F925","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["face","lie","pinocchio"],"k":[38,28],"o":9},"shrimp":{"a":"Shrimp","b":"1F990","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","ocean","nature","seafood"],"k":[42,40],"o":9},"arrow_backward":{"a":"Black Left-Pointing Triangle","b":"25C0-FE0F","c":"25C0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","left","direction"],"k":[47,11],"o":1},"flag-fi":{"a":"Finland Flag","b":"1F1EB-1F1EE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,1]},"custard":{"a":"Custard","b":"1F36E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["dessert","food"],"k":[7,48]},"euro":{"a":"Banknote with Euro Sign","b":"1F4B6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["money","sales","dollar","currency"],"k":[25,33]},"ambulance":{"a":"Ambulance","b":"1F691","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["health","911","hospital"],"k":[34,25]},"shushing_face":{"a":"Face with Finger Covering Closed Lips","b":"1F92B","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[38,51],"n":["face_with_finger_covering_closed_lips"],"o":10},"squid":{"a":"Squid","b":"1F991","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","nature","ocean","sea"],"k":[42,41],"o":9},"rewind":{"a":"Black Left-Pointing Double Triangle","b":"23EA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["play","blue-square"],"k":[46,46]},"flag-fj":{"a":"Fiji Flag","b":"1F1EB-1F1EF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,2]},"honey_pot":{"a":"Honey Pot","b":"1F36F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["bees","sweet","kitchen"],"k":[7,49]},"snail":{"a":"Snail","b":"1F40C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["slow","animal","shell"],"k":[12,42]},"pound":{"a":"Banknote with Pound Sign","b":"1F4B7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["british","sterling","money","sales","bills","uk","england","currency"],"k":[25,34]},"fire_engine":{"a":"Fire Engine","b":"1F692","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["transportation","cars","vehicle"],"k":[34,26]},"face_with_hand_over_mouth":{"a":"Smiling Face with Smiling Eyes and Hand Covering Mouth","b":"1F92D","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[39,1],"n":["smiling_face_with_smiling_eyes_and_hand_covering_mouth"],"o":10},"black_left_pointing_double_triangle_with_vertical_bar":{"a":"Black Left Pointing Double Triangle with Vertical Bar","b":"23EE-FE0F","c":"23EE","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[46,50]},"flag-fk":{"a":"Falkland Islands Flag","b":"1F1EB-1F1F0","d":true,"e":false,"f":true,"g":true,"h":true,"i":true,"k":[2,3]},"baby_bottle":{"a":"Baby Bottle","b":"1F37C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["food","container","milk"],"k":[8,10]},"money_with_wings":{"a":"Money with Wings","b":"1F4B8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["dollar","bills","payment","sale"],"k":[25,35]},"arrow_up_small":{"a":"Up-Pointing Small Red Triangle","b":"1F53C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","triangle","direction","point","forward","top"],"k":[28,10]},"police_car":{"a":"Police Car","b":"1F693","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["vehicle","cars","transportation","law","legal","enforcement"],"k":[34,27]},"butterfly":{"a":"Butterfly","b":"1F98B","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","insect","nature","caterpillar"],"k":[42,35],"o":9},"face_with_monocle":{"a":"Face with Monocle","b":"1F9D0","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[42,49],"o":10},"flag-fm":{"a":"Micronesia Flag","b":"1F1EB-1F1F2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,4]},"bug":{"a":"Bug","b":"1F41B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","insect","nature","worm"],"k":[13,5]},"credit_card":{"a":"Credit Card","b":"1F4B3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["money","sales","dollar","bill","payment","shopping"],"k":[25,30]},"oncoming_police_car":{"a":"Oncoming Police Car","b":"1F694","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["vehicle","law","legal","enforcement","911"],"k":[34,28]},"nerd_face":{"a":"Nerd Face","b":"1F913","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["face","nerdy","geek","dork"],"k":[37,27],"o":8},"glass_of_milk":{"a":"Glass of Milk","b":"1F95B","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[42,7],"o":9},"arrow_double_up":{"a":"Black Up-Pointing Double Triangle","b":"23EB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","direction","top"],"k":[46,47]},"flag-fo":{"a":"Faroe Islands Flag","b":"1F1EB-1F1F4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,5]},"ant":{"a":"Ant","b":"1F41C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","insect","nature","bug"],"k":[13,6]},"chart":{"a":"Chart with Upwards Trend and Yen Sign","b":"1F4B9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["green-square","graph","presentation","stats"],"k":[25,36]},"arrow_down_small":{"a":"Down-Pointing Small Red Triangle","b":"1F53D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","direction","bottom"],"k":[28,11]},"smiling_imp":{"a":"Smiling Face with Horns","b":"1F608","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["devil","horns"],"k":[30,32]},"taxi":{"a":"Taxi","b":"1F695","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["uber","vehicle","cars","transportation"],"k":[34,29]},"coffee":{"a":"Hot Beverage","b":"2615","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["beverage","caffeine","latte","espresso"],"k":[47,24],"o":4},"fr":{"a":"France Flag","b":"1F1EB-1F1F7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["banner","flag","nation","france","french","country"],"k":[2,6],"n":["flag-fr"]},"tea":{"a":"Teacup Without Handle","b":"1F375","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["drink","bowl","breakfast","green","british"],"k":[8,3]},"bee":{"a":"Honeybee","b":"1F41D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[13,7],"n":["honeybee"]},"imp":{"a":"Imp","b":"1F47F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["devil","angry","horns"],"k":[22,51]},"currency_exchange":{"a":"Currency Exchange","b":"1F4B1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["money","sales","dollar","travel"],"k":[25,28]},"oncoming_taxi":{"a":"Oncoming Taxi","b":"1F696","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["vehicle","cars","uber"],"k":[34,30]},"arrow_double_down":{"a":"Black Down-Pointing Double Triangle","b":"23EC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","direction","bottom"],"k":[46,48]},"flag-ga":{"a":"Gabon Flag","b":"1F1EC-1F1E6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,7]},"sake":{"a":"Sake Bottle and Cup","b":"1F376","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["wine","drink","drunk","beverage","japanese","alcohol","booze"],"k":[8,4]},"beetle":{"a":"Lady Beetle","b":"1F41E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","insect","nature","ladybug"],"k":[13,8]},"japanese_ogre":{"a":"Japanese Ogre","b":"1F479","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["monster","red","mask","halloween","scary","creepy","devil","demon","japanese","ogre"],"k":[22,40]},"heavy_dollar_sign":{"a":"Heavy Dollar Sign","b":"1F4B2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["money","sales","payment","currency","buck"],"k":[25,29]},"car":{"a":"Automobile","b":"1F697","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[34,31],"n":["red_car"]},"double_vertical_bar":{"a":"Double Vertical Bar","b":"23F8-FE0F","c":"23F8","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[47,4],"o":7},"gb":{"a":"United Kingdom Flag","b":"1F1EC-1F1E7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,8],"n":["uk","flag-gb"]},"champagne":{"a":"Bottle with Popping Cork","b":"1F37E","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["drink","wine","bottle","celebration"],"k":[8,12],"o":8},"japanese_goblin":{"a":"Japanese Goblin","b":"1F47A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["red","evil","mask","monster","scary","creepy","japanese","goblin"],"k":[22,41]},"oncoming_automobile":{"a":"Oncoming Automobile","b":"1F698","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["car","vehicle","transportation"],"k":[34,32]},"cricket":{"a":"Cricket","b":"1F997","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["sports"],"k":[42,47],"o":10},"black_square_for_stop":{"a":"Black Square for Stop","b":"23F9-FE0F","c":"23F9","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[47,5],"o":7},"email":{"a":"Envelope","b":"2709-FE0F","c":"2709","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["letter","postal","inbox","communication"],"k":[49,17],"n":["envelope"],"o":1},"flag-gd":{"a":"Grenada Flag","b":"1F1EC-1F1E9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,9]},"wine_glass":{"a":"Wine Glass","b":"1F377","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["drink","beverage","drunk","alcohol","booze"],"k":[8,5]},"skull":{"a":"Skull","b":"1F480","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["dead","skeleton","creepy","death"],"k":[23,0]},"e-mail":{"a":"E-Mail Symbol","b":"1F4E7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["communication","inbox"],"k":[26,30]},"spider":{"a":"Spider","b":"1F577-FE0F","c":"1F577","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","arachnid"],"k":[29,18],"o":7},"blue_car":{"a":"Recreational Vehicle","b":"1F699","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["transportation","vehicle"],"k":[34,33]},"black_circle_for_record":{"a":"Black Circle for Record","b":"23FA-FE0F","c":"23FA","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[47,6],"o":7},"flag-ge":{"a":"Georgia Flag","b":"1F1EC-1F1EA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,10]},"cocktail":{"a":"Cocktail Glass","b":"1F378","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["drink","drunk","alcohol","beverage","booze","mojito"],"k":[8,6]},"incoming_envelope":{"a":"Incoming Envelope","b":"1F4E8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["email","inbox"],"k":[26,31]},"spider_web":{"a":"Spider Web","b":"1F578-FE0F","c":"1F578","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","insect","arachnid","silk"],"k":[29,19],"o":7},"truck":{"a":"Delivery Truck","b":"1F69A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["cars","transportation"],"k":[34,34]},"eject":{"a":"Eject","b":"23CF-FE0F","c":"23CF","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[46,44],"o":4},"skull_and_crossbones":{"a":"Skull and Crossbones","b":"2620-FE0F","c":"2620","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["poison","danger","deadly","scary","death","pirate","evil"],"k":[47,32],"o":1},"flag-gf":{"a":"French Guiana Flag","b":"1F1EC-1F1EB","d":true,"e":false,"f":true,"g":true,"h":true,"i":true,"k":[2,11]},"tropical_drink":{"a":"Tropical Drink","b":"1F379","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["beverage","cocktail","summer","beach","alcohol","booze","mojito"],"k":[8,7]},"cinema":{"a":"Cinema","b":"1F3A6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","record","film","movie","curtain","stage","theater"],"k":[9,0]},"ghost":{"a":"Ghost","b":"1F47B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["halloween","spooky","scary"],"k":[22,42]},"envelope_with_arrow":{"a":"Envelope with Downwards Arrow Above","b":"1F4E9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["email","communication"],"k":[26,32]},"articulated_lorry":{"a":"Articulated Lorry","b":"1F69B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["vehicle","cars","transportation","express"],"k":[34,35]},"scorpion":{"a":"Scorpion","b":"1F982","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["animal","arachnid"],"k":[42,26],"o":8},"flag-gg":{"a":"Guernsey Flag","b":"1F1EC-1F1EC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,12]},"beer":{"a":"Beer Mug","b":"1F37A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["relax","beverage","drink","drunk","party","pub","summer","alcohol","booze"],"k":[8,8]},"alien":{"a":"Extraterrestrial Alien","b":"1F47D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["UFO","paul","weird","outer_space"],"k":[22,49]},"bouquet":{"a":"Bouquet","b":"1F490","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["flowers","nature","spring"],"k":[24,42]},"outbox_tray":{"a":"Outbox Tray","b":"1F4E4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["inbox","email"],"k":[26,27]},"low_brightness":{"a":"Low Brightness Symbol","b":"1F505","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sun","afternoon","warm","summer"],"k":[27,7]},"tractor":{"a":"Tractor","b":"1F69C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["vehicle","car","farming","agriculture"],"k":[34,36]},"flag-gh":{"a":"Ghana Flag","b":"1F1EC-1F1ED","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,13]},"cherry_blossom":{"a":"Cherry Blossom","b":"1F338","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","plant","spring","flower"],"k":[6,46]},"beers":{"a":"Clinking Beer Mugs","b":"1F37B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["relax","beverage","drink","drunk","party","pub","summer","alcohol","booze"],"k":[8,9]},"space_invader":{"a":"Alien Monster","b":"1F47E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["game","arcade","play"],"k":[22,50]},"inbox_tray":{"a":"Inbox Tray","b":"1F4E5","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["email","documents"],"k":[26,28]},"high_brightness":{"a":"High Brightness Symbol","b":"1F506","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sun","light"],"k":[27,8]},"bike":{"a":"Bicycle","b":"1F6B2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sports","bicycle","exercise","hipster"],"k":[35,23]},"flag-gi":{"a":"Gibraltar Flag","b":"1F1EC-1F1EE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,14]},"white_flower":{"a":"White Flower","b":"1F4AE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["japanese","spring"],"k":[25,25]},"package":{"a":"Package","b":"1F4E6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["mail","gift","cardboard","box","moving"],"k":[26,29]},"signal_strength":{"a":"Antenna with Bars","b":"1F4F6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","reception","phone","internet","connection","wifi","bluetooth","bars"],"k":[26,45]},"scooter":{"a":"Scooter","b":"1F6F4","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[37,19],"o":9},"robot_face":{"a":"Robot Face","b":"1F916","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[37,30],"o":8},"clinking_glasses":{"a":"Clinking Glasses","b":"1F942","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["beverage","drink","party","alcohol","celebrate","cheers"],"k":[41,38],"o":9},"flag-gl":{"a":"Greenland Flag","b":"1F1EC-1F1F1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,15]},"rosette":{"a":"Rosette","b":"1F3F5-FE0F","c":"1F3F5","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["flower","decoration","military"],"k":[12,20],"o":7},"hankey":{"a":"Pile of Poo","b":"1F4A9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[25,15],"n":["poop","shit"]},"mailbox":{"a":"Closed Mailbox with Raised Flag","b":"1F4EB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["email","inbox","communication"],"k":[26,34]},"vibration_mode":{"a":"Vibration Mode","b":"1F4F3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["orange-square","phone"],"k":[26,42]},"motor_scooter":{"a":"Motor Scooter","b":"1F6F5","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["vehicle","vespa","sasha"],"k":[37,20],"o":9},"tumbler_glass":{"a":"Tumbler Glass","b":"1F943","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["drink","beverage","drunk","alcohol","liquor","booze","bourbon","scotch","whisky","glass","shot"],"k":[41,39],"o":9},"flag-gm":{"a":"Gambia Flag","b":"1F1EC-1F1F2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,16]},"rose":{"a":"Rose","b":"1F339","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["flowers","valentines","love","spring"],"k":[6,47]},"mailbox_closed":{"a":"Closed Mailbox with Lowered Flag","b":"1F4EA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["email","communication","inbox"],"k":[26,33]},"mobile_phone_off":{"a":"Mobile Phone off","b":"1F4F4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["mute","orange-square","silence","quiet"],"k":[26,43]},"smiley_cat":{"a":"Smiling Cat Face with Open Mouth","b":"1F63A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","cats","happy","smile"],"k":[31,30]},"busstop":{"a":"Bus Stop","b":"1F68F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["transportation","wait"],"k":[34,23]},"cup_with_straw":{"a":"Cup with Straw","b":"1F964","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["drink","soda"],"k":[42,16],"o":10},"flag-gn":{"a":"Guinea Flag","b":"1F1EC-1F1F3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,17]},"mailbox_with_mail":{"a":"Open Mailbox with Raised Flag","b":"1F4EC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["email","inbox","communication"],"k":[26,35]},"smile_cat":{"a":"Grinning Cat Face with Smiling Eyes","b":"1F638","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","cats","smile"],"k":[31,28]},"motorway":{"a":"Motorway","b":"1F6E3-FE0F","c":"1F6E3","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["road","cupertino","interstate","highway"],"k":[37,11],"o":7},"wilted_flower":{"a":"Wilted Flower","b":"1F940","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["plant","nature","flower"],"k":[41,36],"o":9},"chopsticks":{"a":"Chopsticks","b":"1F962","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["food"],"k":[42,14],"o":10},"female_sign":{"a":"Female Sign","b":"2640-FE0F","c":"2640","d":false,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[47,42],"o":1},"flag-gp":{"a":"Guadeloupe Flag","b":"1F1EC-1F1F5","d":true,"e":false,"f":true,"g":true,"h":true,"i":true,"k":[2,18]},"hibiscus":{"a":"Hibiscus","b":"1F33A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["plant","vegetable","flowers","beach"],"k":[6,48]},"knife_fork_plate":{"a":"Knife Fork Plate","b":"1F37D-FE0F","c":"1F37D","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[8,11],"o":7},"mailbox_with_no_mail":{"a":"Open Mailbox with Lowered Flag","b":"1F4ED","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["email","inbox"],"k":[26,36]},"joy_cat":{"a":"Cat Face with Tears of Joy","b":"1F639","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","cats","haha","happy","tears"],"k":[31,29]},"railway_track":{"a":"Railway Track","b":"1F6E4-FE0F","c":"1F6E4","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["train","transportation"],"k":[37,12],"o":7},"male_sign":{"a":"Male Sign","b":"2642-FE0F","c":"2642","d":false,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[47,43],"o":1},"flag-gq":{"a":"Equatorial Guinea Flag","b":"1F1EC-1F1F6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,19]},"sunflower":{"a":"Sunflower","b":"1F33B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","plant","fall"],"k":[6,49]},"fork_and_knife":{"a":"Fork and Knife","b":"1F374","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["cutlery","kitchen"],"k":[8,2]},"postbox":{"a":"Postbox","b":"1F4EE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["email","letter","envelope"],"k":[26,37]},"heart_eyes_cat":{"a":"Smiling Cat Face with Heart-Shaped Eyes","b":"1F63B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","love","like","affection","cats","valentines","heart"],"k":[31,31]},"medical_symbol":{"a":"Medical Symbol","b":"2695-FE0F","c":"2695","d":false,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[48,14],"n":["staff_of_aesculapius"],"o":4},"fuelpump":{"a":"Fuel Pump","b":"26FD","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["gas station","petroleum"],"k":[49,13],"o":5},"flag-gr":{"a":"Greece Flag","b":"1F1EC-1F1F7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,20]},"blossom":{"a":"Blossom","b":"1F33C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","flowers","yellow"],"k":[6,50]},"ballot_box_with_ballot":{"a":"Ballot Box with Ballot","b":"1F5F3-FE0F","c":"1F5F3","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[30,17],"o":7},"smirk_cat":{"a":"Cat Face with Wry Smile","b":"1F63C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","cats","smirk"],"k":[31,32]},"rotating_light":{"a":"Police Cars Revolving Light","b":"1F6A8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["police","ambulance","911","emergency","alert","error","pinged","law","legal"],"k":[35,13]},"spoon":{"a":"Spoon","b":"1F944","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["cutlery","kitchen","tableware"],"k":[41,40],"o":9},"recycle":{"a":"Black Universal Recycling Symbol","b":"267B-FE0F","c":"267B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["arrow","environment","garbage","trash"],"k":[48,9],"o":3},"flag-gs":{"a":"South Georgia & South Sandwich Islands Flag","b":"1F1EC-1F1F8","d":true,"e":false,"f":true,"g":true,"h":true,"i":true,"k":[2,21]},"tulip":{"a":"Tulip","b":"1F337","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["flowers","plant","nature","summer","spring"],"k":[6,45]},"hocho":{"a":"Hocho","b":"1F52A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["knife","blade","cutlery","kitchen","weapon"],"k":[27,44],"n":["knife"]},"kissing_cat":{"a":"Kissing Cat Face with Closed Eyes","b":"1F63D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","cats","kiss"],"k":[31,33]},"traffic_light":{"a":"Horizontal Traffic Light","b":"1F6A5","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["transportation","signal"],"k":[35,10]},"fleur_de_lis":{"a":"Fleur De Lis","b":"269C-FE0F","c":"269C","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["decorative","scout"],"k":[48,19],"o":4},"pencil2":{"a":"Pencil","b":"270F-FE0F","c":"270F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["stationery","write","paper","writing","school","study"],"k":[49,42],"o":1},"flag-gt":{"a":"Guatemala Flag","b":"1F1EC-1F1F9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,22]},"seedling":{"a":"Seedling","b":"1F331","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["plant","nature","grass","lawn","spring"],"k":[6,39]},"amphora":{"a":"Amphora","b":"1F3FA","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["vase","jar"],"k":[12,24],"o":8},"trident":{"a":"Trident Emblem","b":"1F531","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["weapon","spear"],"k":[27,51]},"scream_cat":{"a":"Weary Cat Face","b":"1F640","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","cats","munch","scared","scream"],"k":[31,36]},"vertical_traffic_light":{"a":"Vertical Traffic Light","b":"1F6A6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["transportation","driving"],"k":[35,11]},"black_nib":{"a":"Black Nib","b":"2712-FE0F","c":"2712","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["pen","stationery","writing","write"],"k":[49,43],"o":1},"flag-gu":{"a":"Guam Flag","b":"1F1EC-1F1FA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,23]},"evergreen_tree":{"a":"Evergreen Tree","b":"1F332","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["plant","nature"],"k":[6,40]},"name_badge":{"a":"Name Badge","b":"1F4DB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fire","forbid"],"k":[26,18]},"lower_left_fountain_pen":{"a":"Lower Left Fountain Pen","b":"1F58B-FE0F","c":"1F58B","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[29,29],"o":7},"crying_cat_face":{"a":"Crying Cat Face","b":"1F63F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","tears","weep","sad","cats","upset","cry"],"k":[31,35]},"construction":{"a":"Construction Sign","b":"1F6A7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["wip","progress","caution","warning"],"k":[35,12]},"flag-gw":{"a":"Guinea-Bissau Flag","b":"1F1EC-1F1FC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,24]},"deciduous_tree":{"a":"Deciduous Tree","b":"1F333","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["plant","nature"],"k":[6,41]},"beginner":{"a":"Japanese Symbol for Beginner","b":"1F530","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["badge","shield"],"k":[27,50]},"lower_left_ballpoint_pen":{"a":"Lower Left Ballpoint Pen","b":"1F58A-FE0F","c":"1F58A","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[29,28],"o":7},"pouting_cat":{"a":"Pouting Cat Face","b":"1F63E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","cats"],"k":[31,34]},"octagonal_sign":{"a":"Octagonal Sign","b":"1F6D1","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[37,6],"o":9},"flag-gy":{"a":"Guyana Flag","b":"1F1EC-1F1FE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,25]},"palm_tree":{"a":"Palm Tree","b":"1F334","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["plant","vegetable","nature","summer","beach","mojito","tropical"],"k":[6,42]},"lower_left_paintbrush":{"a":"Lower Left Paintbrush","b":"1F58C-FE0F","c":"1F58C","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[29,30],"o":7},"see_no_evil":{"a":"See-No-Evil Monkey","b":"1F648","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["monkey","animal","nature","haha"],"k":[32,43]},"anchor":{"a":"Anchor","b":"2693","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["ship","ferry","sea","boat"],"k":[48,12],"o":4},"o":{"a":"Heavy Large Circle","b":"2B55","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["circle","round"],"k":[50,23],"o":5},"flag-hk":{"a":"Hong Kong Sar China Flag","b":"1F1ED-1F1F0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,26]},"cactus":{"a":"Cactus","b":"1F335","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["vegetable","plant","nature"],"k":[6,43]},"lower_left_crayon":{"a":"Lower Left Crayon","b":"1F58D-FE0F","c":"1F58D","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[29,31],"o":7},"hear_no_evil":{"a":"Hear-No-Evil Monkey","b":"1F649","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","monkey","nature"],"k":[32,44]},"boat":{"a":"Sailboat","b":"26F5","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[48,43],"n":["sailboat"],"o":5},"white_check_mark":{"a":"White Heavy Check Mark","b":"2705","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["green-square","ok","agree","vote","election","answer","tick"],"k":[49,15]},"flag-hm":{"a":"Heard & Mcdonald Islands Flag","b":"1F1ED-1F1F2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,27]},"ear_of_rice":{"a":"Ear of Rice","b":"1F33E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","plant"],"k":[7,0]},"memo":{"a":"Memo","b":"1F4DD","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["write","documents","stationery","pencil","paper","writing","legal","exam","quiz","test","study","compose"],"k":[26,20],"n":["pencil"]},"speak_no_evil":{"a":"Speak-No-Evil Monkey","b":"1F64A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["monkey","animal","nature","omg"],"k":[32,45]},"canoe":{"a":"Canoe","b":"1F6F6","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["boat","paddle","water","ship"],"k":[37,21],"o":9},"ballot_box_with_check":{"a":"Ballot Box with Check","b":"2611-FE0F","c":"2611","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["ok","agree","confirm","black-square","vote","election","yes","tick"],"k":[47,22],"o":1},"flag-hn":{"a":"Honduras Flag","b":"1F1ED-1F1F3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,28]},"herb":{"a":"Herb","b":"1F33F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["vegetable","plant","medicine","weed","grass","lawn"],"k":[7,1]},"baby":{"skin_variations":{"1F3FB":{"unified":"1F476-1F3FB","non_qualified":null,"image":"1f476-1f3fb.png","sheet_x":22,"sheet_y":11,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F476-1F3FC","non_qualified":null,"image":"1f476-1f3fc.png","sheet_x":22,"sheet_y":12,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F476-1F3FD","non_qualified":null,"image":"1f476-1f3fd.png","sheet_x":22,"sheet_y":13,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F476-1F3FE","non_qualified":null,"image":"1f476-1f3fe.png","sheet_x":22,"sheet_y":14,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F476-1F3FF","non_qualified":null,"image":"1f476-1f3ff.png","sheet_x":22,"sheet_y":15,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Baby","b":"1F476","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["child","boy","girl","toddler"],"k":[22,10]},"briefcase":{"a":"Briefcase","b":"1F4BC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["business","documents","work","law","legal","job","career"],"k":[25,39]},"speedboat":{"a":"Speedboat","b":"1F6A4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["ship","transportation","vehicle","summer"],"k":[35,9]},"heavy_check_mark":{"a":"Heavy Check Mark","b":"2714-FE0F","c":"2714","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["ok","nike","answer","yes","tick"],"k":[49,44],"o":1},"flag-hr":{"a":"Croatia Flag","b":"1F1ED-1F1F7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,29]},"file_folder":{"a":"File Folder","b":"1F4C1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["documents","business","office"],"k":[25,44]},"passenger_ship":{"a":"Passenger Ship","b":"1F6F3-FE0F","c":"1F6F3","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["yacht","cruise","ferry"],"k":[37,18],"o":7},"child":{"skin_variations":{"1F3FB":{"unified":"1F9D2-1F3FB","non_qualified":null,"image":"1f9d2-1f3fb.png","sheet_x":43,"sheet_y":5,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F9D2-1F3FC","non_qualified":null,"image":"1f9d2-1f3fc.png","sheet_x":43,"sheet_y":6,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F9D2-1F3FD","non_qualified":null,"image":"1f9d2-1f3fd.png","sheet_x":43,"sheet_y":7,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F9D2-1F3FE","non_qualified":null,"image":"1f9d2-1f3fe.png","sheet_x":43,"sheet_y":8,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F9D2-1F3FF","non_qualified":null,"image":"1f9d2-1f3ff.png","sheet_x":43,"sheet_y":9,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Child","b":"1F9D2","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["gender-neutral","young"],"k":[43,4],"o":10},"shamrock":{"a":"Shamrock","b":"2618-FE0F","c":"2618","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["vegetable","plant","nature","irish","clover"],"k":[47,25],"o":4},"heavy_multiplication_x":{"a":"Heavy Multiplication X","b":"2716-FE0F","c":"2716","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["math","calculation"],"k":[49,45],"o":1},"flag-ht":{"a":"Haiti Flag","b":"1F1ED-1F1F9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,30]},"four_leaf_clover":{"a":"Four Leaf Clover","b":"1F340","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["vegetable","plant","nature","lucky","irish"],"k":[7,2]},"boy":{"skin_variations":{"1F3FB":{"unified":"1F466-1F3FB","non_qualified":null,"image":"1f466-1f3fb.png","sheet_x":15,"sheet_y":43,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F466-1F3FC","non_qualified":null,"image":"1f466-1f3fc.png","sheet_x":15,"sheet_y":44,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F466-1F3FD","non_qualified":null,"image":"1f466-1f3fd.png","sheet_x":15,"sheet_y":45,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F466-1F3FE","non_qualified":null,"image":"1f466-1f3fe.png","sheet_x":15,"sheet_y":46,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F466-1F3FF","non_qualified":null,"image":"1f466-1f3ff.png","sheet_x":15,"sheet_y":47,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Boy","b":"1F466","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["man","male","guy","teenager"],"k":[15,42]},"open_file_folder":{"a":"Open File Folder","b":"1F4C2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["documents","load"],"k":[25,45]},"ferry":{"a":"Ferry","b":"26F4-FE0F","c":"26F4","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["boat","ship","yacht"],"k":[48,42],"o":5},"x":{"a":"Cross Mark","b":"274C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["no","delete","remove","cancel"],"k":[50,1]},"flag-hu":{"a":"Hungary Flag","b":"1F1ED-1F1FA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,31]},"maple_leaf":{"a":"Maple Leaf","b":"1F341","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","plant","vegetable","ca","fall"],"k":[7,3]},"girl":{"skin_variations":{"1F3FB":{"unified":"1F467-1F3FB","non_qualified":null,"image":"1f467-1f3fb.png","sheet_x":15,"sheet_y":49,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F467-1F3FC","non_qualified":null,"image":"1f467-1f3fc.png","sheet_x":15,"sheet_y":50,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F467-1F3FD","non_qualified":null,"image":"1f467-1f3fd.png","sheet_x":15,"sheet_y":51,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F467-1F3FE","non_qualified":null,"image":"1f467-1f3fe.png","sheet_x":16,"sheet_y":0,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F467-1F3FF","non_qualified":null,"image":"1f467-1f3ff.png","sheet_x":16,"sheet_y":1,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Girl","b":"1F467","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["female","woman","teenager"],"k":[15,48]},"card_index_dividers":{"a":"Card Index Dividers","b":"1F5C2-FE0F","c":"1F5C2","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["organizing","business","stationery"],"k":[30,4],"o":7},"motor_boat":{"a":"Motor Boat","b":"1F6E5-FE0F","c":"1F6E5","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["ship"],"k":[37,13],"o":7},"negative_squared_cross_mark":{"a":"Negative Squared Cross Mark","b":"274E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["x","green-square","no","deny"],"k":[50,2]},"flag-ic":{"a":"Canary Islands Flag","b":"1F1EE-1F1E8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,32]},"fallen_leaf":{"a":"Fallen Leaf","b":"1F342","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","plant","vegetable","leaves"],"k":[7,4]},"date":{"a":"Calendar","b":"1F4C5","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["calendar","schedule"],"k":[25,48]},"ship":{"a":"Ship","b":"1F6A2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["transportation","titanic","deploy"],"k":[34,42]},"adult":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB","non_qualified":null,"image":"1f9d1-1f3fb.png","sheet_x":42,"sheet_y":51,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F9D1-1F3FC","non_qualified":null,"image":"1f9d1-1f3fc.png","sheet_x":43,"sheet_y":0,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F9D1-1F3FD","non_qualified":null,"image":"1f9d1-1f3fd.png","sheet_x":43,"sheet_y":1,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F9D1-1F3FE","non_qualified":null,"image":"1f9d1-1f3fe.png","sheet_x":43,"sheet_y":2,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F9D1-1F3FF","non_qualified":null,"image":"1f9d1-1f3ff.png","sheet_x":43,"sheet_y":3,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Adult","b":"1F9D1","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["gender-neutral","person"],"k":[42,50],"o":10},"heavy_plus_sign":{"a":"Heavy Plus Sign","b":"2795","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["math","calculation","addition","more","increase"],"k":[50,9]},"flag-id":{"a":"Indonesia Flag","b":"1F1EE-1F1E9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,33]},"leaves":{"a":"Leaf Fluttering in Wind","b":"1F343","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","plant","tree","vegetable","grass","lawn","spring"],"k":[7,5]},"man":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB","non_qualified":null,"image":"1f468-1f3fb.png","sheet_x":18,"sheet_y":12,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F468-1F3FC","non_qualified":null,"image":"1f468-1f3fc.png","sheet_x":18,"sheet_y":13,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F468-1F3FD","non_qualified":null,"image":"1f468-1f3fd.png","sheet_x":18,"sheet_y":14,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F468-1F3FE","non_qualified":null,"image":"1f468-1f3fe.png","sheet_x":18,"sheet_y":15,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F468-1F3FF","non_qualified":null,"image":"1f468-1f3ff.png","sheet_x":18,"sheet_y":16,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Man","b":"1F468","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["mustache","father","dad","guy","classy","sir","moustache"],"k":[18,11]},"calendar":{"a":"Tear-off Calendar","b":"1F4C6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["schedule","date","planning"],"k":[25,49]},"airplane":{"a":"Airplane","b":"2708-FE0F","c":"2708","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["vehicle","transportation","flight","fly"],"k":[49,16],"o":1},"heavy_minus_sign":{"a":"Heavy Minus Sign","b":"2796","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["math","calculation","subtract","less"],"k":[50,10]},"flag-ie":{"a":"Ireland Flag","b":"1F1EE-1F1EA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,34]},"woman":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB","non_qualified":null,"image":"1f469-1f3fb.png","sheet_x":20,"sheet_y":24,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F469-1F3FC","non_qualified":null,"image":"1f469-1f3fc.png","sheet_x":20,"sheet_y":25,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F469-1F3FD","non_qualified":null,"image":"1f469-1f3fd.png","sheet_x":20,"sheet_y":26,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F469-1F3FE","non_qualified":null,"image":"1f469-1f3fe.png","sheet_x":20,"sheet_y":27,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F469-1F3FF","non_qualified":null,"image":"1f469-1f3ff.png","sheet_x":20,"sheet_y":28,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Woman","b":"1F469","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["female","girls","lady"],"k":[20,23]},"spiral_note_pad":{"a":"Spiral Note Pad","b":"1F5D2-FE0F","c":"1F5D2","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[30,8],"o":7},"small_airplane":{"a":"Small Airplane","b":"1F6E9-FE0F","c":"1F6E9","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["flight","transportation","fly","vehicle"],"k":[37,14],"o":7},"heavy_division_sign":{"a":"Heavy Division Sign","b":"2797","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["divide","math","calculation"],"k":[50,11]},"flag-il":{"a":"Israel Flag","b":"1F1EE-1F1F1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,35]},"spiral_calendar_pad":{"a":"Spiral Calendar Pad","b":"1F5D3-FE0F","c":"1F5D3","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[30,9],"o":7},"airplane_departure":{"a":"Airplane Departure","b":"1F6EB","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[37,15],"o":7},"older_adult":{"skin_variations":{"1F3FB":{"unified":"1F9D3-1F3FB","non_qualified":null,"image":"1f9d3-1f3fb.png","sheet_x":43,"sheet_y":11,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F9D3-1F3FC","non_qualified":null,"image":"1f9d3-1f3fc.png","sheet_x":43,"sheet_y":12,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F9D3-1F3FD","non_qualified":null,"image":"1f9d3-1f3fd.png","sheet_x":43,"sheet_y":13,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F9D3-1F3FE","non_qualified":null,"image":"1f9d3-1f3fe.png","sheet_x":43,"sheet_y":14,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F9D3-1F3FF","non_qualified":null,"image":"1f9d3-1f3ff.png","sheet_x":43,"sheet_y":15,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Older Adult","b":"1F9D3","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["human","elder","senior","gender-neutral"],"k":[43,10],"o":10},"curly_loop":{"a":"Curly Loop","b":"27B0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["scribble","draw","shape","squiggle"],"k":[50,13]},"flag-im":{"a":"Isle of Man Flag","b":"1F1EE-1F1F2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,36]},"older_man":{"skin_variations":{"1F3FB":{"unified":"1F474-1F3FB","non_qualified":null,"image":"1f474-1f3fb.png","sheet_x":21,"sheet_y":51,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F474-1F3FC","non_qualified":null,"image":"1f474-1f3fc.png","sheet_x":22,"sheet_y":0,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F474-1F3FD","non_qualified":null,"image":"1f474-1f3fd.png","sheet_x":22,"sheet_y":1,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F474-1F3FE","non_qualified":null,"image":"1f474-1f3fe.png","sheet_x":22,"sheet_y":2,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F474-1F3FF","non_qualified":null,"image":"1f474-1f3ff.png","sheet_x":22,"sheet_y":3,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Older Man","b":"1F474","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["human","male","men","old","elder","senior"],"k":[21,50]},"card_index":{"a":"Card Index","b":"1F4C7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["business","stationery"],"k":[25,50]},"airplane_arriving":{"a":"Airplane Arriving","b":"1F6EC","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[37,16],"o":7},"loop":{"a":"Double Curly Loop","b":"27BF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["tape","cassette"],"k":[50,14]},"flag-in":{"a":"India Flag","b":"1F1EE-1F1F3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,37]},"older_woman":{"skin_variations":{"1F3FB":{"unified":"1F475-1F3FB","non_qualified":null,"image":"1f475-1f3fb.png","sheet_x":22,"sheet_y":5,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F475-1F3FC","non_qualified":null,"image":"1f475-1f3fc.png","sheet_x":22,"sheet_y":6,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F475-1F3FD","non_qualified":null,"image":"1f475-1f3fd.png","sheet_x":22,"sheet_y":7,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F475-1F3FE","non_qualified":null,"image":"1f475-1f3fe.png","sheet_x":22,"sheet_y":8,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F475-1F3FF","non_qualified":null,"image":"1f475-1f3ff.png","sheet_x":22,"sheet_y":9,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Older Woman","b":"1F475","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["human","female","women","lady","old","elder","senior"],"k":[22,4]},"seat":{"a":"Seat","b":"1F4BA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sit","airplane","transport","bus","flight","fly"],"k":[25,37]},"chart_with_upwards_trend":{"a":"Chart with Upwards Trend","b":"1F4C8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["graph","presentation","stats","recovery","business","economics","money","sales","good","success"],"k":[25,51]},"part_alternation_mark":{"a":"Part Alternation Mark","b":"303D-FE0F","c":"303D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["graph","presentation","stats","business","economics","bad"],"k":[50,25],"o":3},"flag-io":{"a":"British Indian Ocean Territory Flag","b":"1F1EE-1F1F4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,38]},"male-doctor":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-2695-FE0F","non_qualified":"1F468-1F3FB-200D-2695","image":"1f468-1f3fb-200d-2695-fe0f.png","sheet_x":17,"sheet_y":44,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F468-1F3FC-200D-2695-FE0F","non_qualified":"1F468-1F3FC-200D-2695","image":"1f468-1f3fc-200d-2695-fe0f.png","sheet_x":17,"sheet_y":45,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F468-1F3FD-200D-2695-FE0F","non_qualified":"1F468-1F3FD-200D-2695","image":"1f468-1f3fd-200d-2695-fe0f.png","sheet_x":17,"sheet_y":46,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F468-1F3FE-200D-2695-FE0F","non_qualified":"1F468-1F3FE-200D-2695","image":"1f468-1f3fe-200d-2695-fe0f.png","sheet_x":17,"sheet_y":47,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F468-1F3FF-200D-2695-FE0F","non_qualified":"1F468-1F3FF-200D-2695","image":"1f468-1f3ff-200d-2695-fe0f.png","sheet_x":17,"sheet_y":48,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Male Doctor","b":"1F468-200D-2695-FE0F","c":"1F468-200D-2695","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[17,43]},"chart_with_downwards_trend":{"a":"Chart with Downwards Trend","b":"1F4C9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["graph","presentation","stats","recession","business","economics","money","sales","bad","failure"],"k":[26,0]},"helicopter":{"a":"Helicopter","b":"1F681","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["transportation","vehicle","fly"],"k":[34,9]},"eight_spoked_asterisk":{"a":"Eight Spoked Asterisk","b":"2733-FE0F","c":"2733","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["star","sparkle","green-square"],"k":[49,49],"o":1},"flag-iq":{"a":"Iraq Flag","b":"1F1EE-1F1F6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,39]},"female-doctor":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-2695-FE0F","non_qualified":"1F469-1F3FB-200D-2695","image":"1f469-1f3fb-200d-2695-fe0f.png","sheet_x":20,"sheet_y":2,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F469-1F3FC-200D-2695-FE0F","non_qualified":"1F469-1F3FC-200D-2695","image":"1f469-1f3fc-200d-2695-fe0f.png","sheet_x":20,"sheet_y":3,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F469-1F3FD-200D-2695-FE0F","non_qualified":"1F469-1F3FD-200D-2695","image":"1f469-1f3fd-200d-2695-fe0f.png","sheet_x":20,"sheet_y":4,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F469-1F3FE-200D-2695-FE0F","non_qualified":"1F469-1F3FE-200D-2695","image":"1f469-1f3fe-200d-2695-fe0f.png","sheet_x":20,"sheet_y":5,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F469-1F3FF-200D-2695-FE0F","non_qualified":"1F469-1F3FF-200D-2695","image":"1f469-1f3ff-200d-2695-fe0f.png","sheet_x":20,"sheet_y":6,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Female Doctor","b":"1F469-200D-2695-FE0F","c":"1F469-200D-2695","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[20,1]},"bar_chart":{"a":"Bar Chart","b":"1F4CA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["graph","presentation","stats"],"k":[26,1]},"suspension_railway":{"a":"Suspension Railway","b":"1F69F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["vehicle","transportation"],"k":[34,39]},"eight_pointed_black_star":{"a":"Eight Pointed Black Star","b":"2734-FE0F","c":"2734","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["orange-square","shape","polygon"],"k":[49,50],"o":1},"flag-ir":{"a":"Iran Flag","b":"1F1EE-1F1F7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,40]},"male-student":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F393","non_qualified":null,"image":"1f468-1f3fb-200d-1f393.png","sheet_x":16,"sheet_y":15,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F468-1F3FC-200D-1F393","non_qualified":null,"image":"1f468-1f3fc-200d-1f393.png","sheet_x":16,"sheet_y":16,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F468-1F3FD-200D-1F393","non_qualified":null,"image":"1f468-1f3fd-200d-1f393.png","sheet_x":16,"sheet_y":17,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F468-1F3FE-200D-1F393","non_qualified":null,"image":"1f468-1f3fe-200d-1f393.png","sheet_x":16,"sheet_y":18,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F468-1F3FF-200D-1F393","non_qualified":null,"image":"1f468-1f3ff-200d-1f393.png","sheet_x":16,"sheet_y":19,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Male Student","b":"1F468-200D-1F393","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[16,14]},"clipboard":{"a":"Clipboard","b":"1F4CB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["stationery","documents"],"k":[26,2]},"mountain_cableway":{"a":"Mountain Cableway","b":"1F6A0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["transportation","vehicle","ski"],"k":[34,40]},"sparkle":{"a":"Sparkle","b":"2747-FE0F","c":"2747","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["stars","green-square","awesome","good","fireworks"],"k":[50,0],"o":1},"flag-is":{"a":"Iceland Flag","b":"1F1EE-1F1F8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,41]},"female-student":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F393","non_qualified":null,"image":"1f469-1f3fb-200d-1f393.png","sheet_x":18,"sheet_y":30,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F469-1F3FC-200D-1F393","non_qualified":null,"image":"1f469-1f3fc-200d-1f393.png","sheet_x":18,"sheet_y":31,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F469-1F3FD-200D-1F393","non_qualified":null,"image":"1f469-1f3fd-200d-1f393.png","sheet_x":18,"sheet_y":32,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F469-1F3FE-200D-1F393","non_qualified":null,"image":"1f469-1f3fe-200d-1f393.png","sheet_x":18,"sheet_y":33,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F469-1F3FF-200D-1F393","non_qualified":null,"image":"1f469-1f3ff-200d-1f393.png","sheet_x":18,"sheet_y":34,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Female Student","b":"1F469-200D-1F393","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[18,29]},"pushpin":{"a":"Pushpin","b":"1F4CC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["stationery","mark","here"],"k":[26,3]},"aerial_tramway":{"a":"Aerial Tramway","b":"1F6A1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["transportation","vehicle","ski"],"k":[34,41]},"bangbang":{"a":"Double Exclamation Mark","b":"203C-FE0F","c":"203C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["exclamation","surprise"],"k":[46,29],"o":1},"it":{"a":"Italy Flag","b":"1F1EE-1F1F9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["italy","flag","nation","country","banner"],"k":[2,42],"n":["flag-it"]},"male-teacher":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F3EB","non_qualified":null,"image":"1f468-1f3fb-200d-1f3eb.png","sheet_x":16,"sheet_y":33,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F468-1F3FC-200D-1F3EB","non_qualified":null,"image":"1f468-1f3fc-200d-1f3eb.png","sheet_x":16,"sheet_y":34,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F468-1F3FD-200D-1F3EB","non_qualified":null,"image":"1f468-1f3fd-200d-1f3eb.png","sheet_x":16,"sheet_y":35,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F468-1F3FE-200D-1F3EB","non_qualified":null,"image":"1f468-1f3fe-200d-1f3eb.png","sheet_x":16,"sheet_y":36,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F468-1F3FF-200D-1F3EB","non_qualified":null,"image":"1f468-1f3ff-200d-1f3eb.png","sheet_x":16,"sheet_y":37,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Male Teacher","b":"1F468-200D-1F3EB","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[16,32]},"round_pushpin":{"a":"Round Pushpin","b":"1F4CD","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["stationery","location","map","here"],"k":[26,4]},"satellite":{"a":"Satellite","b":"1F6F0-FE0F","c":"1F6F0","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["communication","future","radio","space"],"k":[37,17],"o":7},"interrobang":{"a":"Exclamation Question Mark","b":"2049-FE0F","c":"2049","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["wat","punctuation","surprise"],"k":[46,30],"o":3},"flag-je":{"a":"Jersey Flag","b":"1F1EF-1F1EA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,43]},"female-teacher":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F3EB","non_qualified":null,"image":"1f469-1f3fb-200d-1f3eb.png","sheet_x":18,"sheet_y":48,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F469-1F3FC-200D-1F3EB","non_qualified":null,"image":"1f469-1f3fc-200d-1f3eb.png","sheet_x":18,"sheet_y":49,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F469-1F3FD-200D-1F3EB","non_qualified":null,"image":"1f469-1f3fd-200d-1f3eb.png","sheet_x":18,"sheet_y":50,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F469-1F3FE-200D-1F3EB","non_qualified":null,"image":"1f469-1f3fe-200d-1f3eb.png","sheet_x":18,"sheet_y":51,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F469-1F3FF-200D-1F3EB","non_qualified":null,"image":"1f469-1f3ff-200d-1f3eb.png","sheet_x":19,"sheet_y":0,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Female Teacher","b":"1F469-200D-1F3EB","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[18,47]},"paperclip":{"a":"Paperclip","b":"1F4CE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["documents","stationery"],"k":[26,5]},"rocket":{"a":"Rocket","b":"1F680","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["launch","ship","staffmode","NASA","outer space","outer_space","fly"],"k":[34,8]},"question":{"a":"Black Question Mark Ornament","b":"2753","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["doubt","confused"],"k":[50,3]},"flag-jm":{"a":"Jamaica Flag","b":"1F1EF-1F1F2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,44]},"male-judge":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-2696-FE0F","non_qualified":"1F468-1F3FB-200D-2696","image":"1f468-1f3fb-200d-2696-fe0f.png","sheet_x":17,"sheet_y":50,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F468-1F3FC-200D-2696-FE0F","non_qualified":"1F468-1F3FC-200D-2696","image":"1f468-1f3fc-200d-2696-fe0f.png","sheet_x":17,"sheet_y":51,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F468-1F3FD-200D-2696-FE0F","non_qualified":"1F468-1F3FD-200D-2696","image":"1f468-1f3fd-200d-2696-fe0f.png","sheet_x":18,"sheet_y":0,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F468-1F3FE-200D-2696-FE0F","non_qualified":"1F468-1F3FE-200D-2696","image":"1f468-1f3fe-200d-2696-fe0f.png","sheet_x":18,"sheet_y":1,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F468-1F3FF-200D-2696-FE0F","non_qualified":"1F468-1F3FF-200D-2696","image":"1f468-1f3ff-200d-2696-fe0f.png","sheet_x":18,"sheet_y":2,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Male Judge","b":"1F468-200D-2696-FE0F","c":"1F468-200D-2696","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[17,49]},"linked_paperclips":{"a":"Linked Paperclips","b":"1F587-FE0F","c":"1F587","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[29,27],"o":7},"flying_saucer":{"a":"Flying Saucer","b":"1F6F8","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["transportation","vehicle","ufo"],"k":[37,23],"o":10},"grey_question":{"a":"White Question Mark Ornament","b":"2754","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["doubts","gray","huh","confused"],"k":[50,4]},"flag-jo":{"a":"Jordan Flag","b":"1F1EF-1F1F4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,45]},"female-judge":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-2696-FE0F","non_qualified":"1F469-1F3FB-200D-2696","image":"1f469-1f3fb-200d-2696-fe0f.png","sheet_x":20,"sheet_y":8,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F469-1F3FC-200D-2696-FE0F","non_qualified":"1F469-1F3FC-200D-2696","image":"1f469-1f3fc-200d-2696-fe0f.png","sheet_x":20,"sheet_y":9,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F469-1F3FD-200D-2696-FE0F","non_qualified":"1F469-1F3FD-200D-2696","image":"1f469-1f3fd-200d-2696-fe0f.png","sheet_x":20,"sheet_y":10,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F469-1F3FE-200D-2696-FE0F","non_qualified":"1F469-1F3FE-200D-2696","image":"1f469-1f3fe-200d-2696-fe0f.png","sheet_x":20,"sheet_y":11,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F469-1F3FF-200D-2696-FE0F","non_qualified":"1F469-1F3FF-200D-2696","image":"1f469-1f3ff-200d-2696-fe0f.png","sheet_x":20,"sheet_y":12,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Female Judge","b":"1F469-200D-2696-FE0F","c":"1F469-200D-2696","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[20,7]},"straight_ruler":{"a":"Straight Ruler","b":"1F4CF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["stationery","calculate","length","math","school","drawing","architect","sketch"],"k":[26,6]},"bellhop_bell":{"a":"Bellhop Bell","b":"1F6CE-FE0F","c":"1F6CE","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["service"],"k":[37,3],"o":7},"grey_exclamation":{"a":"White Exclamation Mark Ornament","b":"2755","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["surprise","punctuation","gray","wow","warning"],"k":[50,5]},"jp":{"a":"Japan Flag","b":"1F1EF-1F1F5","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["japanese","nation","flag","country","banner"],"k":[2,46],"n":["flag-jp"]},"male-farmer":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F33E","non_qualified":null,"image":"1f468-1f3fb-200d-1f33e.png","sheet_x":16,"sheet_y":3,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F468-1F3FC-200D-1F33E","non_qualified":null,"image":"1f468-1f3fc-200d-1f33e.png","sheet_x":16,"sheet_y":4,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F468-1F3FD-200D-1F33E","non_qualified":null,"image":"1f468-1f3fd-200d-1f33e.png","sheet_x":16,"sheet_y":5,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F468-1F3FE-200D-1F33E","non_qualified":null,"image":"1f468-1f3fe-200d-1f33e.png","sheet_x":16,"sheet_y":6,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F468-1F3FF-200D-1F33E","non_qualified":null,"image":"1f468-1f3ff-200d-1f33e.png","sheet_x":16,"sheet_y":7,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Male Farmer","b":"1F468-200D-1F33E","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[16,2]},"triangular_ruler":{"a":"Triangular Ruler","b":"1F4D0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["stationery","math","architect","sketch"],"k":[26,7]},"door":{"a":"Door","b":"1F6AA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["house","entry","exit"],"k":[35,15]},"exclamation":{"a":"Heavy Exclamation Mark Symbol","b":"2757","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["heavy_exclamation_mark","danger","surprise","punctuation","wow","warning"],"k":[50,6],"n":["heavy_exclamation_mark"],"o":5},"flag-ke":{"a":"Kenya Flag","b":"1F1F0-1F1EA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,47]},"female-farmer":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F33E","non_qualified":null,"image":"1f469-1f3fb-200d-1f33e.png","sheet_x":18,"sheet_y":18,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F469-1F3FC-200D-1F33E","non_qualified":null,"image":"1f469-1f3fc-200d-1f33e.png","sheet_x":18,"sheet_y":19,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F469-1F3FD-200D-1F33E","non_qualified":null,"image":"1f469-1f3fd-200d-1f33e.png","sheet_x":18,"sheet_y":20,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F469-1F3FE-200D-1F33E","non_qualified":null,"image":"1f469-1f3fe-200d-1f33e.png","sheet_x":18,"sheet_y":21,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F469-1F3FF-200D-1F33E","non_qualified":null,"image":"1f469-1f3ff-200d-1f33e.png","sheet_x":18,"sheet_y":22,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Female Farmer","b":"1F469-200D-1F33E","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[18,17]},"bed":{"a":"Bed","b":"1F6CF-FE0F","c":"1F6CF","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["sleep","rest"],"k":[37,4],"o":7},"scissors":{"a":"Black Scissors","b":"2702-FE0F","c":"2702","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["stationery","cut"],"k":[49,14],"o":1},"wavy_dash":{"a":"Wavy Dash","b":"3030-FE0F","c":"3030","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["draw","line","moustache","mustache","squiggle","scribble"],"k":[50,24],"o":1},"copyright":{"a":"Copyright Sign","b":"00A9-FE0F","c":"00A9","d":true,"e":true,"f":false,"g":true,"h":false,"i":false,"j":["ip","license","circle","law","legal"],"k":[0,12],"o":1},"flag-kg":{"a":"Kyrgyzstan Flag","b":"1F1F0-1F1EC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,48]},"male-cook":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F373","non_qualified":null,"image":"1f468-1f3fb-200d-1f373.png","sheet_x":16,"sheet_y":9,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F468-1F3FC-200D-1F373","non_qualified":null,"image":"1f468-1f3fc-200d-1f373.png","sheet_x":16,"sheet_y":10,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F468-1F3FD-200D-1F373","non_qualified":null,"image":"1f468-1f3fd-200d-1f373.png","sheet_x":16,"sheet_y":11,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F468-1F3FE-200D-1F373","non_qualified":null,"image":"1f468-1f3fe-200d-1f373.png","sheet_x":16,"sheet_y":12,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F468-1F3FF-200D-1F373","non_qualified":null,"image":"1f468-1f3ff-200d-1f373.png","sheet_x":16,"sheet_y":13,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Male Cook","b":"1F468-200D-1F373","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[16,8]},"card_file_box":{"a":"Card File Box","b":"1F5C3-FE0F","c":"1F5C3","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["business","stationery"],"k":[30,5],"o":7},"couch_and_lamp":{"a":"Couch and Lamp","b":"1F6CB-FE0F","c":"1F6CB","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["read","chill"],"k":[36,47],"o":7},"registered":{"a":"Registered Sign","b":"00AE-FE0F","c":"00AE","d":true,"e":true,"f":false,"g":true,"h":false,"i":false,"j":["alphabet","circle"],"k":[0,13],"o":1},"flag-kh":{"a":"Cambodia Flag","b":"1F1F0-1F1ED","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,49]},"female-cook":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F373","non_qualified":null,"image":"1f469-1f3fb-200d-1f373.png","sheet_x":18,"sheet_y":24,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F469-1F3FC-200D-1F373","non_qualified":null,"image":"1f469-1f3fc-200d-1f373.png","sheet_x":18,"sheet_y":25,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F469-1F3FD-200D-1F373","non_qualified":null,"image":"1f469-1f3fd-200d-1f373.png","sheet_x":18,"sheet_y":26,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F469-1F3FE-200D-1F373","non_qualified":null,"image":"1f469-1f3fe-200d-1f373.png","sheet_x":18,"sheet_y":27,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F469-1F3FF-200D-1F373","non_qualified":null,"image":"1f469-1f3ff-200d-1f373.png","sheet_x":18,"sheet_y":28,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Female Cook","b":"1F469-200D-1F373","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[18,23]},"file_cabinet":{"a":"File Cabinet","b":"1F5C4-FE0F","c":"1F5C4","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["filing","organizing"],"k":[30,6],"o":7},"toilet":{"a":"Toilet","b":"1F6BD","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["restroom","wc","washroom","bathroom","potty"],"k":[36,33]},"flag-ki":{"a":"Kiribati Flag","b":"1F1F0-1F1EE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,50]},"male-mechanic":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F527","non_qualified":null,"image":"1f468-1f3fb-200d-1f527.png","sheet_x":17,"sheet_y":20,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F468-1F3FC-200D-1F527","non_qualified":null,"image":"1f468-1f3fc-200d-1f527.png","sheet_x":17,"sheet_y":21,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F468-1F3FD-200D-1F527","non_qualified":null,"image":"1f468-1f3fd-200d-1f527.png","sheet_x":17,"sheet_y":22,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F468-1F3FE-200D-1F527","non_qualified":null,"image":"1f468-1f3fe-200d-1f527.png","sheet_x":17,"sheet_y":23,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F468-1F3FF-200D-1F527","non_qualified":null,"image":"1f468-1f3ff-200d-1f527.png","sheet_x":17,"sheet_y":24,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Male Mechanic","b":"1F468-200D-1F527","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[17,19]},"wastebasket":{"a":"Wastebasket","b":"1F5D1-FE0F","c":"1F5D1","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["bin","trash","rubbish","garbage","toss"],"k":[30,7],"o":7},"shower":{"a":"Shower","b":"1F6BF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["clean","water","bathroom"],"k":[36,35]},"tm":{"a":"Trade Mark Sign","b":"2122-FE0F","c":"2122","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["trademark","brand","law","legal"],"k":[46,31],"o":1},"hash":{"a":"Hash Key","b":"0023-FE0F-20E3","c":"0023-20E3","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"j":["symbol","blue-square","twitter"],"k":[0,0],"o":3},"flag-km":{"a":"Comoros Flag","b":"1F1F0-1F1F2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[2,51]},"female-mechanic":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F527","non_qualified":null,"image":"1f469-1f3fb-200d-1f527.png","sheet_x":19,"sheet_y":30,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F469-1F3FC-200D-1F527","non_qualified":null,"image":"1f469-1f3fc-200d-1f527.png","sheet_x":19,"sheet_y":31,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F469-1F3FD-200D-1F527","non_qualified":null,"image":"1f469-1f3fd-200d-1f527.png","sheet_x":19,"sheet_y":32,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F469-1F3FE-200D-1F527","non_qualified":null,"image":"1f469-1f3fe-200d-1f527.png","sheet_x":19,"sheet_y":33,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F469-1F3FF-200D-1F527","non_qualified":null,"image":"1f469-1f3ff-200d-1f527.png","sheet_x":19,"sheet_y":34,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Female Mechanic","b":"1F469-200D-1F527","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[19,29]},"lock":{"a":"Lock","b":"1F512","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["security","password","padlock"],"k":[27,20]},"bathtub":{"a":"Bathtub","b":"1F6C1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["clean","shower","bathroom"],"k":[36,42]},"keycap_star":{"a":"Keycap Star","b":"002A-FE0F-20E3","c":"002A-20E3","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"k":[0,1],"o":3},"flag-kn":{"a":"St. Kitts & Nevis Flag","b":"1F1F0-1F1F3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,0]},"male-factory-worker":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F3ED","non_qualified":null,"image":"1f468-1f3fb-200d-1f3ed.png","sheet_x":16,"sheet_y":39,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F468-1F3FC-200D-1F3ED","non_qualified":null,"image":"1f468-1f3fc-200d-1f3ed.png","sheet_x":16,"sheet_y":40,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F468-1F3FD-200D-1F3ED","non_qualified":null,"image":"1f468-1f3fd-200d-1f3ed.png","sheet_x":16,"sheet_y":41,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F468-1F3FE-200D-1F3ED","non_qualified":null,"image":"1f468-1f3fe-200d-1f3ed.png","sheet_x":16,"sheet_y":42,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F468-1F3FF-200D-1F3ED","non_qualified":null,"image":"1f468-1f3ff-200d-1f3ed.png","sheet_x":16,"sheet_y":43,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Male Factory Worker","b":"1F468-200D-1F3ED","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[16,38]},"unlock":{"a":"Open Lock","b":"1F513","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["privacy","security"],"k":[27,21]},"hourglass":{"a":"Hourglass","b":"231B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","clock","oldschool","limit","exam","quiz","test"],"k":[46,42],"o":1},"zero":{"a":"Keycap 0","b":"0030-FE0F-20E3","c":"0030-20E3","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"j":["0","numbers","blue-square","null"],"k":[0,2],"o":3},"flag-kp":{"a":"North Korea Flag","b":"1F1F0-1F1F5","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,1]},"female-factory-worker":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F3ED","non_qualified":null,"image":"1f469-1f3fb-200d-1f3ed.png","sheet_x":19,"sheet_y":2,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F469-1F3FC-200D-1F3ED","non_qualified":null,"image":"1f469-1f3fc-200d-1f3ed.png","sheet_x":19,"sheet_y":3,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F469-1F3FD-200D-1F3ED","non_qualified":null,"image":"1f469-1f3fd-200d-1f3ed.png","sheet_x":19,"sheet_y":4,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F469-1F3FE-200D-1F3ED","non_qualified":null,"image":"1f469-1f3fe-200d-1f3ed.png","sheet_x":19,"sheet_y":5,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F469-1F3FF-200D-1F3ED","non_qualified":null,"image":"1f469-1f3ff-200d-1f3ed.png","sheet_x":19,"sheet_y":6,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Female Factory Worker","b":"1F469-200D-1F3ED","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[19,1]},"lock_with_ink_pen":{"a":"Lock with Ink Pen","b":"1F50F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["security","secret"],"k":[27,17]},"hourglass_flowing_sand":{"a":"Hourglass with Flowing Sand","b":"23F3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["oldschool","time","countdown"],"k":[47,3]},"one":{"a":"Keycap 1","b":"0031-FE0F-20E3","c":"0031-20E3","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"j":["blue-square","numbers","1"],"k":[0,3],"o":3},"kr":{"a":"South Korea Flag","b":"1F1F0-1F1F7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["south","korea","nation","flag","country","banner"],"k":[3,2],"n":["flag-kr"]},"male-office-worker":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F4BC","non_qualified":null,"image":"1f468-1f3fb-200d-1f4bc.png","sheet_x":17,"sheet_y":14,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F468-1F3FC-200D-1F4BC","non_qualified":null,"image":"1f468-1f3fc-200d-1f4bc.png","sheet_x":17,"sheet_y":15,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F468-1F3FD-200D-1F4BC","non_qualified":null,"image":"1f468-1f3fd-200d-1f4bc.png","sheet_x":17,"sheet_y":16,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F468-1F3FE-200D-1F4BC","non_qualified":null,"image":"1f468-1f3fe-200d-1f4bc.png","sheet_x":17,"sheet_y":17,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F468-1F3FF-200D-1F4BC","non_qualified":null,"image":"1f468-1f3ff-200d-1f4bc.png","sheet_x":17,"sheet_y":18,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Male Office Worker","b":"1F468-200D-1F4BC","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[17,13]},"closed_lock_with_key":{"a":"Closed Lock with Key","b":"1F510","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["security","privacy"],"k":[27,18]},"watch":{"a":"Watch","b":"231A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","accessories"],"k":[46,41],"o":1},"two":{"a":"Keycap 2","b":"0032-FE0F-20E3","c":"0032-20E3","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"j":["numbers","2","prime","blue-square"],"k":[0,4],"o":3},"flag-kw":{"a":"Kuwait Flag","b":"1F1F0-1F1FC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,3]},"female-office-worker":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F4BC","non_qualified":null,"image":"1f469-1f3fb-200d-1f4bc.png","sheet_x":19,"sheet_y":24,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F469-1F3FC-200D-1F4BC","non_qualified":null,"image":"1f469-1f3fc-200d-1f4bc.png","sheet_x":19,"sheet_y":25,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F469-1F3FD-200D-1F4BC","non_qualified":null,"image":"1f469-1f3fd-200d-1f4bc.png","sheet_x":19,"sheet_y":26,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F469-1F3FE-200D-1F4BC","non_qualified":null,"image":"1f469-1f3fe-200d-1f4bc.png","sheet_x":19,"sheet_y":27,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F469-1F3FF-200D-1F4BC","non_qualified":null,"image":"1f469-1f3ff-200d-1f4bc.png","sheet_x":19,"sheet_y":28,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Female Office Worker","b":"1F469-200D-1F4BC","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[19,23]},"key":{"a":"Key","b":"1F511","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["lock","door","password"],"k":[27,19]},"alarm_clock":{"a":"Alarm Clock","b":"23F0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","wake"],"k":[47,0]},"three":{"a":"Keycap 3","b":"0033-FE0F-20E3","c":"0033-20E3","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"j":["3","numbers","prime","blue-square"],"k":[0,5],"o":3},"flag-ky":{"a":"Cayman Islands Flag","b":"1F1F0-1F1FE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,4]},"male-scientist":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F52C","non_qualified":null,"image":"1f468-1f3fb-200d-1f52c.png","sheet_x":17,"sheet_y":26,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F468-1F3FC-200D-1F52C","non_qualified":null,"image":"1f468-1f3fc-200d-1f52c.png","sheet_x":17,"sheet_y":27,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F468-1F3FD-200D-1F52C","non_qualified":null,"image":"1f468-1f3fd-200d-1f52c.png","sheet_x":17,"sheet_y":28,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F468-1F3FE-200D-1F52C","non_qualified":null,"image":"1f468-1f3fe-200d-1f52c.png","sheet_x":17,"sheet_y":29,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F468-1F3FF-200D-1F52C","non_qualified":null,"image":"1f468-1f3ff-200d-1f52c.png","sheet_x":17,"sheet_y":30,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Male Scientist","b":"1F468-200D-1F52C","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[17,25]},"old_key":{"a":"Old Key","b":"1F5DD-FE0F","c":"1F5DD","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["lock","door","password"],"k":[30,11],"o":7},"stopwatch":{"a":"Stopwatch","b":"23F1-FE0F","c":"23F1","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["time","deadline"],"k":[47,1]},"four":{"a":"Keycap 4","b":"0034-FE0F-20E3","c":"0034-20E3","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"j":["4","numbers","blue-square"],"k":[0,6],"o":3},"flag-kz":{"a":"Kazakhstan Flag","b":"1F1F0-1F1FF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,5]},"female-scientist":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F52C","non_qualified":null,"image":"1f469-1f3fb-200d-1f52c.png","sheet_x":19,"sheet_y":36,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F469-1F3FC-200D-1F52C","non_qualified":null,"image":"1f469-1f3fc-200d-1f52c.png","sheet_x":19,"sheet_y":37,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F469-1F3FD-200D-1F52C","non_qualified":null,"image":"1f469-1f3fd-200d-1f52c.png","sheet_x":19,"sheet_y":38,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F469-1F3FE-200D-1F52C","non_qualified":null,"image":"1f469-1f3fe-200d-1f52c.png","sheet_x":19,"sheet_y":39,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F469-1F3FF-200D-1F52C","non_qualified":null,"image":"1f469-1f3ff-200d-1f52c.png","sheet_x":19,"sheet_y":40,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Female Scientist","b":"1F469-200D-1F52C","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[19,35]},"hammer":{"a":"Hammer","b":"1F528","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["tools","build","create"],"k":[27,42]},"timer_clock":{"a":"Timer Clock","b":"23F2-FE0F","c":"23F2","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["alarm"],"k":[47,2]},"five":{"a":"Keycap 5","b":"0035-FE0F-20E3","c":"0035-20E3","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"j":["5","numbers","blue-square","prime"],"k":[0,7],"o":3},"flag-la":{"a":"Laos Flag","b":"1F1F1-1F1E6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,6]},"male-technologist":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F4BB","non_qualified":null,"image":"1f468-1f3fb-200d-1f4bb.png","sheet_x":17,"sheet_y":8,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F468-1F3FC-200D-1F4BB","non_qualified":null,"image":"1f468-1f3fc-200d-1f4bb.png","sheet_x":17,"sheet_y":9,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F468-1F3FD-200D-1F4BB","non_qualified":null,"image":"1f468-1f3fd-200d-1f4bb.png","sheet_x":17,"sheet_y":10,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F468-1F3FE-200D-1F4BB","non_qualified":null,"image":"1f468-1f3fe-200d-1f4bb.png","sheet_x":17,"sheet_y":11,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F468-1F3FF-200D-1F4BB","non_qualified":null,"image":"1f468-1f3ff-200d-1f4bb.png","sheet_x":17,"sheet_y":12,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Male Technologist","b":"1F468-200D-1F4BB","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[17,7]},"mantelpiece_clock":{"a":"Mantelpiece Clock","b":"1F570-FE0F","c":"1F570","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["time"],"k":[28,43],"o":7},"pick":{"a":"Pick","b":"26CF-FE0F","c":"26CF","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["tools","dig"],"k":[48,32],"o":5},"six":{"a":"Keycap 6","b":"0036-FE0F-20E3","c":"0036-20E3","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"j":["6","numbers","blue-square"],"k":[0,8],"o":3},"flag-lb":{"a":"Lebanon Flag","b":"1F1F1-1F1E7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,7]},"female-technologist":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F4BB","non_qualified":null,"image":"1f469-1f3fb-200d-1f4bb.png","sheet_x":19,"sheet_y":18,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F469-1F3FC-200D-1F4BB","non_qualified":null,"image":"1f469-1f3fc-200d-1f4bb.png","sheet_x":19,"sheet_y":19,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F469-1F3FD-200D-1F4BB","non_qualified":null,"image":"1f469-1f3fd-200d-1f4bb.png","sheet_x":19,"sheet_y":20,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F469-1F3FE-200D-1F4BB","non_qualified":null,"image":"1f469-1f3fe-200d-1f4bb.png","sheet_x":19,"sheet_y":21,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F469-1F3FF-200D-1F4BB","non_qualified":null,"image":"1f469-1f3ff-200d-1f4bb.png","sheet_x":19,"sheet_y":22,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Female Technologist","b":"1F469-200D-1F4BB","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[19,17]},"clock12":{"a":"Clock Face Twelve Oclock","b":"1F55B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","noon","midnight","midday","late","early","schedule"],"k":[28,29]},"hammer_and_pick":{"a":"Hammer and Pick","b":"2692-FE0F","c":"2692","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["tools","build","create"],"k":[48,11],"o":4},"seven":{"a":"Keycap 7","b":"0037-FE0F-20E3","c":"0037-20E3","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"j":["7","numbers","blue-square","prime"],"k":[0,9],"o":3},"flag-lc":{"a":"St. Lucia Flag","b":"1F1F1-1F1E8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,8]},"male-singer":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F3A4","non_qualified":null,"image":"1f468-1f3fb-200d-1f3a4.png","sheet_x":16,"sheet_y":21,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F468-1F3FC-200D-1F3A4","non_qualified":null,"image":"1f468-1f3fc-200d-1f3a4.png","sheet_x":16,"sheet_y":22,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F468-1F3FD-200D-1F3A4","non_qualified":null,"image":"1f468-1f3fd-200d-1f3a4.png","sheet_x":16,"sheet_y":23,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F468-1F3FE-200D-1F3A4","non_qualified":null,"image":"1f468-1f3fe-200d-1f3a4.png","sheet_x":16,"sheet_y":24,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F468-1F3FF-200D-1F3A4","non_qualified":null,"image":"1f468-1f3ff-200d-1f3a4.png","sheet_x":16,"sheet_y":25,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Male Singer","b":"1F468-200D-1F3A4","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[16,20]},"clock1230":{"a":"Clock Face Twelve-Thirty","b":"1F567","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,41]},"hammer_and_wrench":{"a":"Hammer and Wrench","b":"1F6E0-FE0F","c":"1F6E0","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["tools","build","create"],"k":[37,8],"o":7},"eight":{"a":"Keycap 8","b":"0038-FE0F-20E3","c":"0038-20E3","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"j":["8","blue-square","numbers"],"k":[0,10],"o":3},"flag-li":{"a":"Liechtenstein Flag","b":"1F1F1-1F1EE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,9]},"female-singer":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F3A4","non_qualified":null,"image":"1f469-1f3fb-200d-1f3a4.png","sheet_x":18,"sheet_y":36,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F469-1F3FC-200D-1F3A4","non_qualified":null,"image":"1f469-1f3fc-200d-1f3a4.png","sheet_x":18,"sheet_y":37,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F469-1F3FD-200D-1F3A4","non_qualified":null,"image":"1f469-1f3fd-200d-1f3a4.png","sheet_x":18,"sheet_y":38,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F469-1F3FE-200D-1F3A4","non_qualified":null,"image":"1f469-1f3fe-200d-1f3a4.png","sheet_x":18,"sheet_y":39,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F469-1F3FF-200D-1F3A4","non_qualified":null,"image":"1f469-1f3ff-200d-1f3a4.png","sheet_x":18,"sheet_y":40,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Female Singer","b":"1F469-200D-1F3A4","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[18,35]},"clock1":{"a":"Clock Face One Oclock","b":"1F550","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,18]},"dagger_knife":{"a":"Dagger Knife","b":"1F5E1-FE0F","c":"1F5E1","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[30,13],"o":7},"nine":{"a":"Keycap 9","b":"0039-FE0F-20E3","c":"0039-20E3","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"j":["blue-square","numbers","9"],"k":[0,11],"o":3},"flag-lk":{"a":"Sri Lanka Flag","b":"1F1F1-1F1F0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,10]},"male-artist":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F3A8","non_qualified":null,"image":"1f468-1f3fb-200d-1f3a8.png","sheet_x":16,"sheet_y":27,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F468-1F3FC-200D-1F3A8","non_qualified":null,"image":"1f468-1f3fc-200d-1f3a8.png","sheet_x":16,"sheet_y":28,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F468-1F3FD-200D-1F3A8","non_qualified":null,"image":"1f468-1f3fd-200d-1f3a8.png","sheet_x":16,"sheet_y":29,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F468-1F3FE-200D-1F3A8","non_qualified":null,"image":"1f468-1f3fe-200d-1f3a8.png","sheet_x":16,"sheet_y":30,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F468-1F3FF-200D-1F3A8","non_qualified":null,"image":"1f468-1f3ff-200d-1f3a8.png","sheet_x":16,"sheet_y":31,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Male Artist","b":"1F468-200D-1F3A8","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[16,26]},"clock130":{"a":"Clock Face One-Thirty","b":"1F55C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,30]},"crossed_swords":{"a":"Crossed Swords","b":"2694-FE0F","c":"2694","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["weapon"],"k":[48,13],"o":4},"flag-lr":{"a":"Liberia Flag","b":"1F1F1-1F1F7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,11]},"female-artist":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F3A8","non_qualified":null,"image":"1f469-1f3fb-200d-1f3a8.png","sheet_x":18,"sheet_y":42,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F469-1F3FC-200D-1F3A8","non_qualified":null,"image":"1f469-1f3fc-200d-1f3a8.png","sheet_x":18,"sheet_y":43,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F469-1F3FD-200D-1F3A8","non_qualified":null,"image":"1f469-1f3fd-200d-1f3a8.png","sheet_x":18,"sheet_y":44,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F469-1F3FE-200D-1F3A8","non_qualified":null,"image":"1f469-1f3fe-200d-1f3a8.png","sheet_x":18,"sheet_y":45,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F469-1F3FF-200D-1F3A8","non_qualified":null,"image":"1f469-1f3ff-200d-1f3a8.png","sheet_x":18,"sheet_y":46,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Female Artist","b":"1F469-200D-1F3A8","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[18,41]},"keycap_ten":{"a":"Keycap Ten","b":"1F51F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["numbers","10","blue-square"],"k":[27,33]},"gun":{"a":"Pistol","b":"1F52B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["violence","weapon","pistol","revolver"],"k":[27,45]},"clock2":{"a":"Clock Face Two Oclock","b":"1F551","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,19]},"flag-ls":{"a":"Lesotho Flag","b":"1F1F1-1F1F8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,12]},"bow_and_arrow":{"a":"Bow and Arrow","b":"1F3F9","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["sports"],"k":[12,23],"o":8},"male-pilot":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-2708-FE0F","non_qualified":"1F468-1F3FB-200D-2708","image":"1f468-1f3fb-200d-2708-fe0f.png","sheet_x":18,"sheet_y":4,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F468-1F3FC-200D-2708-FE0F","non_qualified":"1F468-1F3FC-200D-2708","image":"1f468-1f3fc-200d-2708-fe0f.png","sheet_x":18,"sheet_y":5,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F468-1F3FD-200D-2708-FE0F","non_qualified":"1F468-1F3FD-200D-2708","image":"1f468-1f3fd-200d-2708-fe0f.png","sheet_x":18,"sheet_y":6,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F468-1F3FE-200D-2708-FE0F","non_qualified":"1F468-1F3FE-200D-2708","image":"1f468-1f3fe-200d-2708-fe0f.png","sheet_x":18,"sheet_y":7,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F468-1F3FF-200D-2708-FE0F","non_qualified":"1F468-1F3FF-200D-2708","image":"1f468-1f3ff-200d-2708-fe0f.png","sheet_x":18,"sheet_y":8,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Male Pilot","b":"1F468-200D-2708-FE0F","c":"1F468-200D-2708","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[18,3]},"clock230":{"a":"Clock Face Two-Thirty","b":"1F55D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,31]},"flag-lt":{"a":"Lithuania Flag","b":"1F1F1-1F1F9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,13]},"female-pilot":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-2708-FE0F","non_qualified":"1F469-1F3FB-200D-2708","image":"1f469-1f3fb-200d-2708-fe0f.png","sheet_x":20,"sheet_y":14,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F469-1F3FC-200D-2708-FE0F","non_qualified":"1F469-1F3FC-200D-2708","image":"1f469-1f3fc-200d-2708-fe0f.png","sheet_x":20,"sheet_y":15,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F469-1F3FD-200D-2708-FE0F","non_qualified":"1F469-1F3FD-200D-2708","image":"1f469-1f3fd-200d-2708-fe0f.png","sheet_x":20,"sheet_y":16,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F469-1F3FE-200D-2708-FE0F","non_qualified":"1F469-1F3FE-200D-2708","image":"1f469-1f3fe-200d-2708-fe0f.png","sheet_x":20,"sheet_y":17,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F469-1F3FF-200D-2708-FE0F","non_qualified":"1F469-1F3FF-200D-2708","image":"1f469-1f3ff-200d-2708-fe0f.png","sheet_x":20,"sheet_y":18,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Female Pilot","b":"1F469-200D-2708-FE0F","c":"1F469-200D-2708","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[20,13]},"capital_abcd":{"a":"Input Symbol for Latin Capital Letters","b":"1F520","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["alphabet","words","blue-square"],"k":[27,34]},"clock3":{"a":"Clock Face Three Oclock","b":"1F552","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,20]},"shield":{"a":"Shield","b":"1F6E1-FE0F","c":"1F6E1","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["protection","security"],"k":[37,9],"o":7},"flag-lu":{"a":"Luxembourg Flag","b":"1F1F1-1F1FA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,14]},"male-astronaut":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F680","non_qualified":null,"image":"1f468-1f3fb-200d-1f680.png","sheet_x":17,"sheet_y":32,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F468-1F3FC-200D-1F680","non_qualified":null,"image":"1f468-1f3fc-200d-1f680.png","sheet_x":17,"sheet_y":33,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F468-1F3FD-200D-1F680","non_qualified":null,"image":"1f468-1f3fd-200d-1f680.png","sheet_x":17,"sheet_y":34,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F468-1F3FE-200D-1F680","non_qualified":null,"image":"1f468-1f3fe-200d-1f680.png","sheet_x":17,"sheet_y":35,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F468-1F3FF-200D-1F680","non_qualified":null,"image":"1f468-1f3ff-200d-1f680.png","sheet_x":17,"sheet_y":36,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Male Astronaut","b":"1F468-200D-1F680","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[17,31]},"abcd":{"a":"Input Symbol for Latin Small Letters","b":"1F521","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","alphabet"],"k":[27,35]},"wrench":{"a":"Wrench","b":"1F527","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["tools","diy","ikea","fix","maintainer"],"k":[27,41]},"clock330":{"a":"Clock Face Three-Thirty","b":"1F55E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,32]},"flag-lv":{"a":"Latvia Flag","b":"1F1F1-1F1FB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,15]},"female-astronaut":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F680","non_qualified":null,"image":"1f469-1f3fb-200d-1f680.png","sheet_x":19,"sheet_y":42,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F469-1F3FC-200D-1F680","non_qualified":null,"image":"1f469-1f3fc-200d-1f680.png","sheet_x":19,"sheet_y":43,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F469-1F3FD-200D-1F680","non_qualified":null,"image":"1f469-1f3fd-200d-1f680.png","sheet_x":19,"sheet_y":44,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F469-1F3FE-200D-1F680","non_qualified":null,"image":"1f469-1f3fe-200d-1f680.png","sheet_x":19,"sheet_y":45,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F469-1F3FF-200D-1F680","non_qualified":null,"image":"1f469-1f3ff-200d-1f680.png","sheet_x":19,"sheet_y":46,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Female Astronaut","b":"1F469-200D-1F680","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[19,41]},"nut_and_bolt":{"a":"Nut and Bolt","b":"1F529","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["handy","tools","fix"],"k":[27,43]},"clock4":{"a":"Clock Face Four Oclock","b":"1F553","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,21]},"flag-ly":{"a":"Libya Flag","b":"1F1F1-1F1FE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,16]},"male-firefighter":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F692","non_qualified":null,"image":"1f468-1f3fb-200d-1f692.png","sheet_x":17,"sheet_y":38,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F468-1F3FC-200D-1F692","non_qualified":null,"image":"1f468-1f3fc-200d-1f692.png","sheet_x":17,"sheet_y":39,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F468-1F3FD-200D-1F692","non_qualified":null,"image":"1f468-1f3fd-200d-1f692.png","sheet_x":17,"sheet_y":40,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F468-1F3FE-200D-1F692","non_qualified":null,"image":"1f468-1f3fe-200d-1f692.png","sheet_x":17,"sheet_y":41,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F468-1F3FF-200D-1F692","non_qualified":null,"image":"1f468-1f3ff-200d-1f692.png","sheet_x":17,"sheet_y":42,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Male Firefighter","b":"1F468-200D-1F692","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[17,37]},"symbols":{"a":"Input Symbol for Symbols","b":"1F523","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","music","note","ampersand","percent","glyphs","characters"],"k":[27,37]},"clock430":{"a":"Clock Face Four-Thirty","b":"1F55F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,33]},"gear":{"a":"Gear","b":"2699-FE0F","c":"2699","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["cog"],"k":[48,17],"o":4},"flag-ma":{"a":"Morocco Flag","b":"1F1F2-1F1E6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,17]},"female-firefighter":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F692","non_qualified":null,"image":"1f469-1f3fb-200d-1f692.png","sheet_x":19,"sheet_y":48,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F469-1F3FC-200D-1F692","non_qualified":null,"image":"1f469-1f3fc-200d-1f692.png","sheet_x":19,"sheet_y":49,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F469-1F3FD-200D-1F692","non_qualified":null,"image":"1f469-1f3fd-200d-1f692.png","sheet_x":19,"sheet_y":50,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F469-1F3FE-200D-1F692","non_qualified":null,"image":"1f469-1f3fe-200d-1f692.png","sheet_x":19,"sheet_y":51,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F469-1F3FF-200D-1F692","non_qualified":null,"image":"1f469-1f3ff-200d-1f692.png","sheet_x":20,"sheet_y":0,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Female Firefighter","b":"1F469-200D-1F692","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[19,47]},"abc":{"a":"Input Symbol for Latin Letters","b":"1F524","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","alphabet"],"k":[27,38]},"clock5":{"a":"Clock Face Five Oclock","b":"1F554","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,22]},"compression":{"a":"Compression","b":"1F5DC-FE0F","c":"1F5DC","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[30,10],"o":7},"a":{"a":"Negative Squared Latin Capital Letter a","b":"1F170-FE0F","c":"1F170","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["red-square","alphabet","letter"],"k":[0,16]},"flag-mc":{"a":"Monaco Flag","b":"1F1F2-1F1E8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,18]},"cop":{"skin_variations":{"1F3FB":{"unified":"1F46E-1F3FB","non_qualified":null,"image":"1f46e-1f3fb.png","sheet_x":20,"sheet_y":46,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FC":{"unified":"1F46E-1F3FC","non_qualified":null,"image":"1f46e-1f3fc.png","sheet_x":20,"sheet_y":47,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FD":{"unified":"1F46E-1F3FD","non_qualified":null,"image":"1f46e-1f3fd.png","sheet_x":20,"sheet_y":48,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FE":{"unified":"1F46E-1F3FE","non_qualified":null,"image":"1f46e-1f3fe.png","sheet_x":20,"sheet_y":49,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FF":{"unified":"1F46E-1F3FF","non_qualified":null,"image":"1f46e-1f3ff.png","sheet_x":20,"sheet_y":50,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true}},"obsoleted_by":"1F46E-200D-2642-FE0F","a":"Police Officer","b":"1F46E","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[20,45]},"clock530":{"a":"Clock Face Five-Thirty","b":"1F560","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,34]},"alembic":{"a":"Alembic","b":"2697-FE0F","c":"2697","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["distilling","science","experiment","chemistry"],"k":[48,16],"o":4},"ab":{"a":"Negative Squared Ab","b":"1F18E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["red-square","alphabet"],"k":[0,20]},"flag-md":{"a":"Moldova Flag","b":"1F1F2-1F1E9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,19]},"male-police-officer":{"skin_variations":{"1F3FB":{"unified":"1F46E-1F3FB-200D-2642-FE0F","non_qualified":"1F46E-1F3FB-200D-2642","image":"1f46e-1f3fb-200d-2642-fe0f.png","sheet_x":20,"sheet_y":40,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F46E-1F3FC-200D-2642-FE0F","non_qualified":"1F46E-1F3FC-200D-2642","image":"1f46e-1f3fc-200d-2642-fe0f.png","sheet_x":20,"sheet_y":41,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F46E-1F3FD-200D-2642-FE0F","non_qualified":"1F46E-1F3FD-200D-2642","image":"1f46e-1f3fd-200d-2642-fe0f.png","sheet_x":20,"sheet_y":42,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F46E-1F3FE-200D-2642-FE0F","non_qualified":"1F46E-1F3FE-200D-2642","image":"1f46e-1f3fe-200d-2642-fe0f.png","sheet_x":20,"sheet_y":43,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F46E-1F3FF-200D-2642-FE0F","non_qualified":"1F46E-1F3FF-200D-2642","image":"1f46e-1f3ff-200d-2642-fe0f.png","sheet_x":20,"sheet_y":44,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F46E","a":"Male Police Officer","b":"1F46E-200D-2642-FE0F","c":"1F46E-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[20,39]},"clock6":{"a":"Clock Face Six Oclock","b":"1F555","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule","dawn","dusk"],"k":[28,23]},"scales":{"a":"Scales","b":"2696-FE0F","c":"2696","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[48,15],"o":4},"b":{"a":"Negative Squared Latin Capital Letter B","b":"1F171-FE0F","c":"1F171","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["red-square","alphabet","letter"],"k":[0,17]},"flag-me":{"a":"Montenegro Flag","b":"1F1F2-1F1EA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,20]},"female-police-officer":{"skin_variations":{"1F3FB":{"unified":"1F46E-1F3FB-200D-2640-FE0F","non_qualified":"1F46E-1F3FB-200D-2640","image":"1f46e-1f3fb-200d-2640-fe0f.png","sheet_x":20,"sheet_y":34,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F46E-1F3FC-200D-2640-FE0F","non_qualified":"1F46E-1F3FC-200D-2640","image":"1f46e-1f3fc-200d-2640-fe0f.png","sheet_x":20,"sheet_y":35,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F46E-1F3FD-200D-2640-FE0F","non_qualified":"1F46E-1F3FD-200D-2640","image":"1f46e-1f3fd-200d-2640-fe0f.png","sheet_x":20,"sheet_y":36,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F46E-1F3FE-200D-2640-FE0F","non_qualified":"1F46E-1F3FE-200D-2640","image":"1f46e-1f3fe-200d-2640-fe0f.png","sheet_x":20,"sheet_y":37,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F46E-1F3FF-200D-2640-FE0F","non_qualified":"1F46E-1F3FF-200D-2640","image":"1f46e-1f3ff-200d-2640-fe0f.png","sheet_x":20,"sheet_y":38,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Female Police Officer","b":"1F46E-200D-2640-FE0F","c":"1F46E-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[20,33]},"link":{"a":"Link Symbol","b":"1F517","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["rings","url"],"k":[27,25]},"clock630":{"a":"Clock Face Six-Thirty","b":"1F561","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,35]},"cl":{"a":"Squared Cl","b":"1F191","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["alphabet","words","red-square"],"k":[0,21]},"flag-mf":{"a":"St. Martin Flag","b":"1F1F2-1F1EB","d":true,"e":false,"f":true,"g":true,"h":true,"i":true,"k":[3,21]},"clock7":{"a":"Clock Face Seven Oclock","b":"1F556","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,24]},"sleuth_or_spy":{"skin_variations":{"1F3FB":{"unified":"1F575-1F3FB","non_qualified":null,"image":"1f575-1f3fb.png","sheet_x":29,"sheet_y":12,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F575-1F3FC","non_qualified":null,"image":"1f575-1f3fc.png","sheet_x":29,"sheet_y":13,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F575-1F3FD","non_qualified":null,"image":"1f575-1f3fd.png","sheet_x":29,"sheet_y":14,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F575-1F3FE","non_qualified":null,"image":"1f575-1f3fe.png","sheet_x":29,"sheet_y":15,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F575-1F3FF","non_qualified":null,"image":"1f575-1f3ff.png","sheet_x":29,"sheet_y":16,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoleted_by":"1F575-FE0F-200D-2642-FE0F","a":"Sleuth or Spy","b":"1F575-FE0F","c":"1F575","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"k":[29,11],"o":7},"chains":{"a":"Chains","b":"26D3-FE0F","c":"26D3","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["lock","arrest"],"k":[48,34],"o":5},"cool":{"a":"Squared Cool","b":"1F192","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["words","blue-square"],"k":[0,22]},"flag-mg":{"a":"Madagascar Flag","b":"1F1F2-1F1EC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,22]},"syringe":{"a":"Syringe","b":"1F489","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["health","hospital","drugs","blood","medicine","needle","doctor","nurse"],"k":[24,35]},"clock730":{"a":"Clock Face Seven-Thirty","b":"1F562","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,36]},"male-detective":{"skin_variations":{"1F3FB":{"unified":"1F575-1F3FB-200D-2642-FE0F","non_qualified":"1F575-1F3FB-200D-2642","image":"1f575-1f3fb-200d-2642-fe0f.png","sheet_x":29,"sheet_y":6,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F575-1F3FC-200D-2642-FE0F","non_qualified":"1F575-1F3FC-200D-2642","image":"1f575-1f3fc-200d-2642-fe0f.png","sheet_x":29,"sheet_y":7,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F575-1F3FD-200D-2642-FE0F","non_qualified":"1F575-1F3FD-200D-2642","image":"1f575-1f3fd-200d-2642-fe0f.png","sheet_x":29,"sheet_y":8,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F575-1F3FE-200D-2642-FE0F","non_qualified":"1F575-1F3FE-200D-2642","image":"1f575-1f3fe-200d-2642-fe0f.png","sheet_x":29,"sheet_y":9,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F575-1F3FF-200D-2642-FE0F","non_qualified":"1F575-1F3FF-200D-2642","image":"1f575-1f3ff-200d-2642-fe0f.png","sheet_x":29,"sheet_y":10,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F575-FE0F","a":"Male Detective","b":"1F575-FE0F-200D-2642-FE0F","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"k":[29,5],"o":7},"free":{"a":"Squared Free","b":"1F193","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","words"],"k":[0,23]},"flag-mh":{"a":"Marshall Islands Flag","b":"1F1F2-1F1ED","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,23]},"pill":{"a":"Pill","b":"1F48A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["health","medicine","doctor","pharmacy","drug"],"k":[24,36]},"clock8":{"a":"Clock Face Eight Oclock","b":"1F557","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,25]},"female-detective":{"skin_variations":{"1F3FB":{"unified":"1F575-1F3FB-200D-2640-FE0F","non_qualified":"1F575-1F3FB-200D-2640","image":"1f575-1f3fb-200d-2640-fe0f.png","sheet_x":29,"sheet_y":0,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F575-1F3FC-200D-2640-FE0F","non_qualified":"1F575-1F3FC-200D-2640","image":"1f575-1f3fc-200d-2640-fe0f.png","sheet_x":29,"sheet_y":1,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F575-1F3FD-200D-2640-FE0F","non_qualified":"1F575-1F3FD-200D-2640","image":"1f575-1f3fd-200d-2640-fe0f.png","sheet_x":29,"sheet_y":2,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F575-1F3FE-200D-2640-FE0F","non_qualified":"1F575-1F3FE-200D-2640","image":"1f575-1f3fe-200d-2640-fe0f.png","sheet_x":29,"sheet_y":3,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F575-1F3FF-200D-2640-FE0F","non_qualified":"1F575-1F3FF-200D-2640","image":"1f575-1f3ff-200d-2640-fe0f.png","sheet_x":29,"sheet_y":4,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Female Detective","b":"1F575-FE0F-200D-2640-FE0F","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"k":[28,51],"o":7},"flag-mk":{"a":"Macedonia Flag","b":"1F1F2-1F1F0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,24]},"guardsman":{"skin_variations":{"1F3FB":{"unified":"1F482-1F3FB","non_qualified":null,"image":"1f482-1f3fb.png","sheet_x":23,"sheet_y":32,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FC":{"unified":"1F482-1F3FC","non_qualified":null,"image":"1f482-1f3fc.png","sheet_x":23,"sheet_y":33,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FD":{"unified":"1F482-1F3FD","non_qualified":null,"image":"1f482-1f3fd.png","sheet_x":23,"sheet_y":34,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FE":{"unified":"1F482-1F3FE","non_qualified":null,"image":"1f482-1f3fe.png","sheet_x":23,"sheet_y":35,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FF":{"unified":"1F482-1F3FF","non_qualified":null,"image":"1f482-1f3ff.png","sheet_x":23,"sheet_y":36,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true}},"obsoleted_by":"1F482-200D-2642-FE0F","a":"Guardsman","b":"1F482","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"j":["uk","gb","british","male","guy","royal"],"k":[23,31]},"clock830":{"a":"Clock Face Eight-Thirty","b":"1F563","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,37]},"smoking":{"a":"Smoking Symbol","b":"1F6AC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["kills","tobacco","cigarette","joint","smoke"],"k":[35,17]},"information_source":{"a":"Information Source","b":"2139-FE0F","c":"2139","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","alphabet","letter"],"k":[46,32],"o":3},"id":{"a":"Squared Id","b":"1F194","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["purple-square","words"],"k":[0,24]},"flag-ml":{"a":"Mali Flag","b":"1F1F2-1F1F1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,25]},"male-guard":{"skin_variations":{"1F3FB":{"unified":"1F482-1F3FB-200D-2642-FE0F","non_qualified":"1F482-1F3FB-200D-2642","image":"1f482-1f3fb-200d-2642-fe0f.png","sheet_x":23,"sheet_y":26,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F482-1F3FC-200D-2642-FE0F","non_qualified":"1F482-1F3FC-200D-2642","image":"1f482-1f3fc-200d-2642-fe0f.png","sheet_x":23,"sheet_y":27,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F482-1F3FD-200D-2642-FE0F","non_qualified":"1F482-1F3FD-200D-2642","image":"1f482-1f3fd-200d-2642-fe0f.png","sheet_x":23,"sheet_y":28,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F482-1F3FE-200D-2642-FE0F","non_qualified":"1F482-1F3FE-200D-2642","image":"1f482-1f3fe-200d-2642-fe0f.png","sheet_x":23,"sheet_y":29,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F482-1F3FF-200D-2642-FE0F","non_qualified":"1F482-1F3FF-200D-2642","image":"1f482-1f3ff-200d-2642-fe0f.png","sheet_x":23,"sheet_y":30,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F482","a":"Male Guard","b":"1F482-200D-2642-FE0F","c":"1F482-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[23,25]},"clock9":{"a":"Clock Face Nine Oclock","b":"1F558","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,26]},"coffin":{"a":"Coffin","b":"26B0-FE0F","c":"26B0","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["vampire","dead","die","death","rip","graveyard","cemetery","casket","funeral","box"],"k":[48,24],"o":4},"flag-mm":{"a":"Myanmar (burma) Flag","b":"1F1F2-1F1F2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,26]},"female-guard":{"skin_variations":{"1F3FB":{"unified":"1F482-1F3FB-200D-2640-FE0F","non_qualified":"1F482-1F3FB-200D-2640","image":"1f482-1f3fb-200d-2640-fe0f.png","sheet_x":23,"sheet_y":20,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F482-1F3FC-200D-2640-FE0F","non_qualified":"1F482-1F3FC-200D-2640","image":"1f482-1f3fc-200d-2640-fe0f.png","sheet_x":23,"sheet_y":21,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F482-1F3FD-200D-2640-FE0F","non_qualified":"1F482-1F3FD-200D-2640","image":"1f482-1f3fd-200d-2640-fe0f.png","sheet_x":23,"sheet_y":22,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F482-1F3FE-200D-2640-FE0F","non_qualified":"1F482-1F3FE-200D-2640","image":"1f482-1f3fe-200d-2640-fe0f.png","sheet_x":23,"sheet_y":23,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F482-1F3FF-200D-2640-FE0F","non_qualified":"1F482-1F3FF-200D-2640","image":"1f482-1f3ff-200d-2640-fe0f.png","sheet_x":23,"sheet_y":24,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Female Guard","b":"1F482-200D-2640-FE0F","c":"1F482-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[23,19]},"clock930":{"a":"Clock Face Nine-Thirty","b":"1F564","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,38]},"m":{"a":"Circled Latin Capital Letter M","b":"24C2-FE0F","c":"24C2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["alphabet","blue-circle","letter"],"k":[47,7],"o":1},"funeral_urn":{"a":"Funeral Urn","b":"26B1-FE0F","c":"26B1","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["dead","die","death","rip","ashes"],"k":[48,25],"o":4},"new":{"a":"Squared New","b":"1F195","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","words","start"],"k":[0,25]},"flag-mn":{"a":"Mongolia Flag","b":"1F1F2-1F1F3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,27]},"construction_worker":{"skin_variations":{"1F3FB":{"unified":"1F477-1F3FB","non_qualified":null,"image":"1f477-1f3fb.png","sheet_x":22,"sheet_y":29,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FC":{"unified":"1F477-1F3FC","non_qualified":null,"image":"1f477-1f3fc.png","sheet_x":22,"sheet_y":30,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FD":{"unified":"1F477-1F3FD","non_qualified":null,"image":"1f477-1f3fd.png","sheet_x":22,"sheet_y":31,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FE":{"unified":"1F477-1F3FE","non_qualified":null,"image":"1f477-1f3fe.png","sheet_x":22,"sheet_y":32,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FF":{"unified":"1F477-1F3FF","non_qualified":null,"image":"1f477-1f3ff.png","sheet_x":22,"sheet_y":33,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true}},"obsoleted_by":"1F477-200D-2642-FE0F","a":"Construction Worker","b":"1F477","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[22,28]},"clock10":{"a":"Clock Face Ten Oclock","b":"1F559","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,27]},"moyai":{"a":"Moyai","b":"1F5FF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["rock","easter island","moai"],"k":[30,23]},"ng":{"a":"Squared Ng","b":"1F196","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","words","shape","icon"],"k":[0,26]},"flag-mo":{"a":"Macau Sar China Flag","b":"1F1F2-1F1F4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,28]},"male-construction-worker":{"skin_variations":{"1F3FB":{"unified":"1F477-1F3FB-200D-2642-FE0F","non_qualified":"1F477-1F3FB-200D-2642","image":"1f477-1f3fb-200d-2642-fe0f.png","sheet_x":22,"sheet_y":23,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F477-1F3FC-200D-2642-FE0F","non_qualified":"1F477-1F3FC-200D-2642","image":"1f477-1f3fc-200d-2642-fe0f.png","sheet_x":22,"sheet_y":24,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F477-1F3FD-200D-2642-FE0F","non_qualified":"1F477-1F3FD-200D-2642","image":"1f477-1f3fd-200d-2642-fe0f.png","sheet_x":22,"sheet_y":25,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F477-1F3FE-200D-2642-FE0F","non_qualified":"1F477-1F3FE-200D-2642","image":"1f477-1f3fe-200d-2642-fe0f.png","sheet_x":22,"sheet_y":26,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F477-1F3FF-200D-2642-FE0F","non_qualified":"1F477-1F3FF-200D-2642","image":"1f477-1f3ff-200d-2642-fe0f.png","sheet_x":22,"sheet_y":27,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F477","a":"Male Construction Worker","b":"1F477-200D-2642-FE0F","c":"1F477-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[22,22]},"clock1030":{"a":"Clock Face Ten-Thirty","b":"1F565","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,39]},"oil_drum":{"a":"Oil Drum","b":"1F6E2-FE0F","c":"1F6E2","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["barrell"],"k":[37,10],"o":7},"o2":{"a":"Negative Squared Latin Capital Letter O","b":"1F17E-FE0F","c":"1F17E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["alphabet","red-square","letter"],"k":[0,18]},"flag-mp":{"a":"Northern Mariana Islands Flag","b":"1F1F2-1F1F5","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,29]},"female-construction-worker":{"skin_variations":{"1F3FB":{"unified":"1F477-1F3FB-200D-2640-FE0F","non_qualified":"1F477-1F3FB-200D-2640","image":"1f477-1f3fb-200d-2640-fe0f.png","sheet_x":22,"sheet_y":17,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F477-1F3FC-200D-2640-FE0F","non_qualified":"1F477-1F3FC-200D-2640","image":"1f477-1f3fc-200d-2640-fe0f.png","sheet_x":22,"sheet_y":18,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F477-1F3FD-200D-2640-FE0F","non_qualified":"1F477-1F3FD-200D-2640","image":"1f477-1f3fd-200d-2640-fe0f.png","sheet_x":22,"sheet_y":19,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F477-1F3FE-200D-2640-FE0F","non_qualified":"1F477-1F3FE-200D-2640","image":"1f477-1f3fe-200d-2640-fe0f.png","sheet_x":22,"sheet_y":20,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F477-1F3FF-200D-2640-FE0F","non_qualified":"1F477-1F3FF-200D-2640","image":"1f477-1f3ff-200d-2640-fe0f.png","sheet_x":22,"sheet_y":21,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Female Construction Worker","b":"1F477-200D-2640-FE0F","c":"1F477-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[22,16]},"crystal_ball":{"a":"Crystal Ball","b":"1F52E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["disco","party","magic","circus","fortune_teller"],"k":[27,48]},"clock11":{"a":"Clock Face Eleven Oclock","b":"1F55A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,28]},"ok":{"a":"Squared Ok","b":"1F197","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["good","agree","yes","blue-square"],"k":[0,27]},"flag-mq":{"a":"Martinique Flag","b":"1F1F2-1F1F6","d":true,"e":false,"f":true,"g":true,"h":true,"i":true,"k":[3,30]},"clock1130":{"a":"Clock Face Eleven-Thirty","b":"1F566","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["time","late","early","schedule"],"k":[28,40]},"shopping_trolley":{"a":"Shopping Trolley","b":"1F6D2","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[37,7],"o":9},"prince":{"skin_variations":{"1F3FB":{"unified":"1F934-1F3FB","non_qualified":null,"image":"1f934-1f3fb.png","sheet_x":39,"sheet_y":29,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F934-1F3FC","non_qualified":null,"image":"1f934-1f3fc.png","sheet_x":39,"sheet_y":30,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F934-1F3FD","non_qualified":null,"image":"1f934-1f3fd.png","sheet_x":39,"sheet_y":31,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F934-1F3FE","non_qualified":null,"image":"1f934-1f3fe.png","sheet_x":39,"sheet_y":32,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F934-1F3FF","non_qualified":null,"image":"1f934-1f3ff.png","sheet_x":39,"sheet_y":33,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Prince","b":"1F934","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["boy","man","male","crown","royal","king"],"k":[39,28],"o":9},"parking":{"a":"Negative Squared Latin Capital Letter P","b":"1F17F-FE0F","c":"1F17F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["cars","blue-square","alphabet","letter"],"k":[0,19],"o":5},"flag-mr":{"a":"Mauritania Flag","b":"1F1F2-1F1F7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,31]},"new_moon":{"a":"New Moon Symbol","b":"1F311","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[6,9]},"princess":{"skin_variations":{"1F3FB":{"unified":"1F478-1F3FB","non_qualified":null,"image":"1f478-1f3fb.png","sheet_x":22,"sheet_y":35,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F478-1F3FC","non_qualified":null,"image":"1f478-1f3fc.png","sheet_x":22,"sheet_y":36,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F478-1F3FD","non_qualified":null,"image":"1f478-1f3fd.png","sheet_x":22,"sheet_y":37,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F478-1F3FE","non_qualified":null,"image":"1f478-1f3fe.png","sheet_x":22,"sheet_y":38,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F478-1F3FF","non_qualified":null,"image":"1f478-1f3ff.png","sheet_x":22,"sheet_y":39,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Princess","b":"1F478","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["girl","woman","female","blond","crown","royal","queen"],"k":[22,34]},"sos":{"a":"Squared Sos","b":"1F198","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["help","red-square","words","emergency","911"],"k":[0,28]},"flag-ms":{"a":"Montserrat Flag","b":"1F1F2-1F1F8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,32]},"waxing_crescent_moon":{"a":"Waxing Crescent Moon Symbol","b":"1F312","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[6,10]},"man_with_turban":{"skin_variations":{"1F3FB":{"unified":"1F473-1F3FB","non_qualified":null,"image":"1f473-1f3fb.png","sheet_x":21,"sheet_y":45,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FC":{"unified":"1F473-1F3FC","non_qualified":null,"image":"1f473-1f3fc.png","sheet_x":21,"sheet_y":46,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FD":{"unified":"1F473-1F3FD","non_qualified":null,"image":"1f473-1f3fd.png","sheet_x":21,"sheet_y":47,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FE":{"unified":"1F473-1F3FE","non_qualified":null,"image":"1f473-1f3fe.png","sheet_x":21,"sheet_y":48,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FF":{"unified":"1F473-1F3FF","non_qualified":null,"image":"1f473-1f3ff.png","sheet_x":21,"sheet_y":49,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true}},"obsoleted_by":"1F473-200D-2642-FE0F","a":"Man with Turban","b":"1F473","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"j":["male","indian","hinduism","arabs"],"k":[21,44]},"up":{"a":"Squared Up with Exclamation Mark","b":"1F199","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","above","high"],"k":[0,29]},"flag-mt":{"a":"Malta Flag","b":"1F1F2-1F1F9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,33]},"first_quarter_moon":{"a":"First Quarter Moon Symbol","b":"1F313","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[6,11]},"man-wearing-turban":{"skin_variations":{"1F3FB":{"unified":"1F473-1F3FB-200D-2642-FE0F","non_qualified":"1F473-1F3FB-200D-2642","image":"1f473-1f3fb-200d-2642-fe0f.png","sheet_x":21,"sheet_y":39,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F473-1F3FC-200D-2642-FE0F","non_qualified":"1F473-1F3FC-200D-2642","image":"1f473-1f3fc-200d-2642-fe0f.png","sheet_x":21,"sheet_y":40,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F473-1F3FD-200D-2642-FE0F","non_qualified":"1F473-1F3FD-200D-2642","image":"1f473-1f3fd-200d-2642-fe0f.png","sheet_x":21,"sheet_y":41,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F473-1F3FE-200D-2642-FE0F","non_qualified":"1F473-1F3FE-200D-2642","image":"1f473-1f3fe-200d-2642-fe0f.png","sheet_x":21,"sheet_y":42,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F473-1F3FF-200D-2642-FE0F","non_qualified":"1F473-1F3FF-200D-2642","image":"1f473-1f3ff-200d-2642-fe0f.png","sheet_x":21,"sheet_y":43,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F473","a":"Man Wearing Turban","b":"1F473-200D-2642-FE0F","c":"1F473-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[21,38]},"vs":{"a":"Squared Vs","b":"1F19A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["words","orange-square"],"k":[0,30]},"flag-mu":{"a":"Mauritius Flag","b":"1F1F2-1F1FA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,34]},"moon":{"a":"Waxing Gibbous Moon Symbol","b":"1F314","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[6,12],"n":["waxing_gibbous_moon"]},"woman-wearing-turban":{"skin_variations":{"1F3FB":{"unified":"1F473-1F3FB-200D-2640-FE0F","non_qualified":"1F473-1F3FB-200D-2640","image":"1f473-1f3fb-200d-2640-fe0f.png","sheet_x":21,"sheet_y":33,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F473-1F3FC-200D-2640-FE0F","non_qualified":"1F473-1F3FC-200D-2640","image":"1f473-1f3fc-200d-2640-fe0f.png","sheet_x":21,"sheet_y":34,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F473-1F3FD-200D-2640-FE0F","non_qualified":"1F473-1F3FD-200D-2640","image":"1f473-1f3fd-200d-2640-fe0f.png","sheet_x":21,"sheet_y":35,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F473-1F3FE-200D-2640-FE0F","non_qualified":"1F473-1F3FE-200D-2640","image":"1f473-1f3fe-200d-2640-fe0f.png","sheet_x":21,"sheet_y":36,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F473-1F3FF-200D-2640-FE0F","non_qualified":"1F473-1F3FF-200D-2640","image":"1f473-1f3ff-200d-2640-fe0f.png","sheet_x":21,"sheet_y":37,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Woman Wearing Turban","b":"1F473-200D-2640-FE0F","c":"1F473-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[21,32]},"flag-mv":{"a":"Maldives Flag","b":"1F1F2-1F1FB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,35]},"koko":{"a":"Squared Katakana Koko","b":"1F201","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue-square","here","katakana","japanese","destination"],"k":[5,29]},"full_moon":{"a":"Full Moon Symbol","b":"1F315","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","yellow","twilight","planet","space","night","evening","sleep"],"k":[6,13]},"man_with_gua_pi_mao":{"skin_variations":{"1F3FB":{"unified":"1F472-1F3FB","non_qualified":null,"image":"1f472-1f3fb.png","sheet_x":21,"sheet_y":27,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F472-1F3FC","non_qualified":null,"image":"1f472-1f3fc.png","sheet_x":21,"sheet_y":28,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F472-1F3FD","non_qualified":null,"image":"1f472-1f3fd.png","sheet_x":21,"sheet_y":29,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F472-1F3FE","non_qualified":null,"image":"1f472-1f3fe.png","sheet_x":21,"sheet_y":30,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F472-1F3FF","non_qualified":null,"image":"1f472-1f3ff.png","sheet_x":21,"sheet_y":31,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Man with Gua Pi Mao","b":"1F472","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["male","boy","chinese"],"k":[21,26]},"flag-mw":{"a":"Malawi Flag","b":"1F1F2-1F1FC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,36]},"sa":{"a":"Squared Katakana Sa","b":"1F202-FE0F","c":"1F202","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["japanese","blue-square","katakana"],"k":[5,30]},"waning_gibbous_moon":{"a":"Waning Gibbous Moon Symbol","b":"1F316","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","twilight","planet","space","night","evening","sleep","waxing_gibbous_moon"],"k":[6,14]},"person_with_headscarf":{"skin_variations":{"1F3FB":{"unified":"1F9D5-1F3FB","non_qualified":null,"image":"1f9d5-1f3fb.png","sheet_x":43,"sheet_y":23,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F9D5-1F3FC","non_qualified":null,"image":"1f9d5-1f3fc.png","sheet_x":43,"sheet_y":24,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F9D5-1F3FD","non_qualified":null,"image":"1f9d5-1f3fd.png","sheet_x":43,"sheet_y":25,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F9D5-1F3FE","non_qualified":null,"image":"1f9d5-1f3fe.png","sheet_x":43,"sheet_y":26,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F9D5-1F3FF","non_qualified":null,"image":"1f9d5-1f3ff.png","sheet_x":43,"sheet_y":27,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Person with Headscarf","b":"1F9D5","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[43,22],"o":10},"flag-mx":{"a":"Mexico Flag","b":"1F1F2-1F1FD","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,37]},"u6708":{"a":"Squared Cjk Unified Ideograph-6708","b":"1F237-FE0F","c":"1F237","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["chinese","month","moon","japanese","orange-square","kanji"],"k":[5,38]},"last_quarter_moon":{"a":"Last Quarter Moon Symbol","b":"1F317","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[6,15]},"bearded_person":{"skin_variations":{"1F3FB":{"unified":"1F9D4-1F3FB","non_qualified":null,"image":"1f9d4-1f3fb.png","sheet_x":43,"sheet_y":17,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F9D4-1F3FC","non_qualified":null,"image":"1f9d4-1f3fc.png","sheet_x":43,"sheet_y":18,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F9D4-1F3FD","non_qualified":null,"image":"1f9d4-1f3fd.png","sheet_x":43,"sheet_y":19,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F9D4-1F3FE","non_qualified":null,"image":"1f9d4-1f3fe.png","sheet_x":43,"sheet_y":20,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F9D4-1F3FF","non_qualified":null,"image":"1f9d4-1f3ff.png","sheet_x":43,"sheet_y":21,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Bearded Person","b":"1F9D4","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["person","bewhiskered"],"k":[43,16],"o":10},"flag-my":{"a":"Malaysia Flag","b":"1F1F2-1F1FE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,38]},"u6709":{"a":"Squared Cjk Unified Ideograph-6709","b":"1F236","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["orange-square","chinese","have","kanji"],"k":[5,37]},"waning_crescent_moon":{"a":"Waning Crescent Moon Symbol","b":"1F318","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[6,16]},"person_with_blond_hair":{"skin_variations":{"1F3FB":{"unified":"1F471-1F3FB","non_qualified":null,"image":"1f471-1f3fb.png","sheet_x":21,"sheet_y":21,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FC":{"unified":"1F471-1F3FC","non_qualified":null,"image":"1f471-1f3fc.png","sheet_x":21,"sheet_y":22,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FD":{"unified":"1F471-1F3FD","non_qualified":null,"image":"1f471-1f3fd.png","sheet_x":21,"sheet_y":23,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FE":{"unified":"1F471-1F3FE","non_qualified":null,"image":"1f471-1f3fe.png","sheet_x":21,"sheet_y":24,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FF":{"unified":"1F471-1F3FF","non_qualified":null,"image":"1f471-1f3ff.png","sheet_x":21,"sheet_y":25,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true}},"obsoleted_by":"1F471-200D-2642-FE0F","a":"Person with Blond Hair","b":"1F471","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[21,20]},"flag-mz":{"a":"Mozambique Flag","b":"1F1F2-1F1FF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,39]},"u6307":{"a":"Squared Cjk Unified Ideograph-6307","b":"1F22F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["chinese","point","green-square","kanji"],"k":[5,32],"o":5},"crescent_moon":{"a":"Crescent Moon","b":"1F319","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["night","sleep","sky","evening","magic"],"k":[6,17]},"blond-haired-man":{"skin_variations":{"1F3FB":{"unified":"1F471-1F3FB-200D-2642-FE0F","non_qualified":"1F471-1F3FB-200D-2642","image":"1f471-1f3fb-200d-2642-fe0f.png","sheet_x":21,"sheet_y":15,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F471-1F3FC-200D-2642-FE0F","non_qualified":"1F471-1F3FC-200D-2642","image":"1f471-1f3fc-200d-2642-fe0f.png","sheet_x":21,"sheet_y":16,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F471-1F3FD-200D-2642-FE0F","non_qualified":"1F471-1F3FD-200D-2642","image":"1f471-1f3fd-200d-2642-fe0f.png","sheet_x":21,"sheet_y":17,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F471-1F3FE-200D-2642-FE0F","non_qualified":"1F471-1F3FE-200D-2642","image":"1f471-1f3fe-200d-2642-fe0f.png","sheet_x":21,"sheet_y":18,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F471-1F3FF-200D-2642-FE0F","non_qualified":"1F471-1F3FF-200D-2642","image":"1f471-1f3ff-200d-2642-fe0f.png","sheet_x":21,"sheet_y":19,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F471","a":"Blond Haired Man","b":"1F471-200D-2642-FE0F","c":"1F471-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[21,14]},"flag-na":{"a":"Namibia Flag","b":"1F1F3-1F1E6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,40]},"ideograph_advantage":{"a":"Circled Ideograph Advantage","b":"1F250","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["chinese","kanji","obtain","get","circle"],"k":[5,42]},"new_moon_with_face":{"a":"New Moon with Face","b":"1F31A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[6,18]},"blond-haired-woman":{"skin_variations":{"1F3FB":{"unified":"1F471-1F3FB-200D-2640-FE0F","non_qualified":"1F471-1F3FB-200D-2640","image":"1f471-1f3fb-200d-2640-fe0f.png","sheet_x":21,"sheet_y":9,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F471-1F3FC-200D-2640-FE0F","non_qualified":"1F471-1F3FC-200D-2640","image":"1f471-1f3fc-200d-2640-fe0f.png","sheet_x":21,"sheet_y":10,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F471-1F3FD-200D-2640-FE0F","non_qualified":"1F471-1F3FD-200D-2640","image":"1f471-1f3fd-200d-2640-fe0f.png","sheet_x":21,"sheet_y":11,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F471-1F3FE-200D-2640-FE0F","non_qualified":"1F471-1F3FE-200D-2640","image":"1f471-1f3fe-200d-2640-fe0f.png","sheet_x":21,"sheet_y":12,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F471-1F3FF-200D-2640-FE0F","non_qualified":"1F471-1F3FF-200D-2640","image":"1f471-1f3ff-200d-2640-fe0f.png","sheet_x":21,"sheet_y":13,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Blond Haired Woman","b":"1F471-200D-2640-FE0F","c":"1F471-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[21,8]},"flag-nc":{"a":"New Caledonia Flag","b":"1F1F3-1F1E8","d":true,"e":false,"f":true,"g":true,"h":true,"i":true,"k":[3,41]},"u5272":{"a":"Squared Cjk Unified Ideograph-5272","b":"1F239","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["cut","divide","chinese","kanji","pink-square"],"k":[5,40]},"first_quarter_moon_with_face":{"a":"First Quarter Moon with Face","b":"1F31B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[6,19]},"man_in_tuxedo":{"skin_variations":{"1F3FB":{"unified":"1F935-1F3FB","non_qualified":null,"image":"1f935-1f3fb.png","sheet_x":39,"sheet_y":35,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F935-1F3FC","non_qualified":null,"image":"1f935-1f3fc.png","sheet_x":39,"sheet_y":36,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F935-1F3FD","non_qualified":null,"image":"1f935-1f3fd.png","sheet_x":39,"sheet_y":37,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F935-1F3FE","non_qualified":null,"image":"1f935-1f3fe.png","sheet_x":39,"sheet_y":38,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F935-1F3FF","non_qualified":null,"image":"1f935-1f3ff.png","sheet_x":39,"sheet_y":39,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Man in Tuxedo","b":"1F935","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["couple","marriage","wedding","groom"],"k":[39,34],"o":9},"flag-ne":{"a":"Niger Flag","b":"1F1F3-1F1EA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,42]},"u7121":{"a":"Squared Cjk Unified Ideograph-7121","b":"1F21A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nothing","chinese","kanji","japanese","orange-square"],"k":[5,31],"o":5},"last_quarter_moon_with_face":{"a":"Last Quarter Moon with Face","b":"1F31C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[6,20]},"bride_with_veil":{"skin_variations":{"1F3FB":{"unified":"1F470-1F3FB","non_qualified":null,"image":"1f470-1f3fb.png","sheet_x":21,"sheet_y":3,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F470-1F3FC","non_qualified":null,"image":"1f470-1f3fc.png","sheet_x":21,"sheet_y":4,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F470-1F3FD","non_qualified":null,"image":"1f470-1f3fd.png","sheet_x":21,"sheet_y":5,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F470-1F3FE","non_qualified":null,"image":"1f470-1f3fe.png","sheet_x":21,"sheet_y":6,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F470-1F3FF","non_qualified":null,"image":"1f470-1f3ff.png","sheet_x":21,"sheet_y":7,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Bride with Veil","b":"1F470","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["couple","marriage","wedding","woman","bride"],"k":[21,2]},"flag-nf":{"a":"Norfolk Island Flag","b":"1F1F3-1F1EB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,43]},"u7981":{"a":"Squared Cjk Unified Ideograph-7981","b":"1F232","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["kanji","japanese","chinese","forbidden","limit","restricted","red-square"],"k":[5,33]},"thermometer":{"a":"Thermometer","b":"1F321-FE0F","c":"1F321","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["weather","temperature","hot","cold"],"k":[6,25],"o":7},"pregnant_woman":{"skin_variations":{"1F3FB":{"unified":"1F930-1F3FB","non_qualified":null,"image":"1f930-1f3fb.png","sheet_x":39,"sheet_y":5,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F930-1F3FC","non_qualified":null,"image":"1f930-1f3fc.png","sheet_x":39,"sheet_y":6,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F930-1F3FD","non_qualified":null,"image":"1f930-1f3fd.png","sheet_x":39,"sheet_y":7,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F930-1F3FE","non_qualified":null,"image":"1f930-1f3fe.png","sheet_x":39,"sheet_y":8,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F930-1F3FF","non_qualified":null,"image":"1f930-1f3ff.png","sheet_x":39,"sheet_y":9,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Pregnant Woman","b":"1F930","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["baby"],"k":[39,4],"o":9},"flag-ng":{"a":"Nigeria Flag","b":"1F1F3-1F1EC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,44]},"accept":{"a":"Circled Ideograph Accept","b":"1F251","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["ok","good","chinese","kanji","agree","yes","orange-circle"],"k":[5,43]},"breast-feeding":{"skin_variations":{"1F3FB":{"unified":"1F931-1F3FB","non_qualified":null,"image":"1f931-1f3fb.png","sheet_x":39,"sheet_y":11,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F931-1F3FC","non_qualified":null,"image":"1f931-1f3fc.png","sheet_x":39,"sheet_y":12,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F931-1F3FD","non_qualified":null,"image":"1f931-1f3fd.png","sheet_x":39,"sheet_y":13,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F931-1F3FE","non_qualified":null,"image":"1f931-1f3fe.png","sheet_x":39,"sheet_y":14,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F931-1F3FF","non_qualified":null,"image":"1f931-1f3ff.png","sheet_x":39,"sheet_y":15,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Breast-Feeding","b":"1F931","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[39,10],"o":10},"sunny":{"a":"Black Sun with Rays","b":"2600-FE0F","c":"2600","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["weather","nature","brightness","summer","beach","spring"],"k":[47,16],"o":1},"flag-ni":{"a":"Nicaragua Flag","b":"1F1F3-1F1EE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,45]},"u7533":{"a":"Squared Cjk Unified Ideograph-7533","b":"1F238","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["chinese","japanese","kanji","orange-square"],"k":[5,39]},"full_moon_with_face":{"a":"Full Moon with Face","b":"1F31D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[6,21]},"angel":{"skin_variations":{"1F3FB":{"unified":"1F47C-1F3FB","non_qualified":null,"image":"1f47c-1f3fb.png","sheet_x":22,"sheet_y":44,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F47C-1F3FC","non_qualified":null,"image":"1f47c-1f3fc.png","sheet_x":22,"sheet_y":45,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F47C-1F3FD","non_qualified":null,"image":"1f47c-1f3fd.png","sheet_x":22,"sheet_y":46,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F47C-1F3FE","non_qualified":null,"image":"1f47c-1f3fe.png","sheet_x":22,"sheet_y":47,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F47C-1F3FF","non_qualified":null,"image":"1f47c-1f3ff.png","sheet_x":22,"sheet_y":48,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Baby Angel","b":"1F47C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["heaven","wings","halo"],"k":[22,43]},"flag-nl":{"a":"Netherlands Flag","b":"1F1F3-1F1F1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,46]},"u5408":{"a":"Squared Cjk Unified Ideograph-5408","b":"1F234","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["japanese","chinese","join","kanji","red-square"],"k":[5,35]},"sun_with_face":{"a":"Sun with Face","b":"1F31E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","morning","sky"],"k":[6,22]},"santa":{"skin_variations":{"1F3FB":{"unified":"1F385-1F3FB","non_qualified":null,"image":"1f385-1f3fb.png","sheet_x":8,"sheet_y":20,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F385-1F3FC","non_qualified":null,"image":"1f385-1f3fc.png","sheet_x":8,"sheet_y":21,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F385-1F3FD","non_qualified":null,"image":"1f385-1f3fd.png","sheet_x":8,"sheet_y":22,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F385-1F3FE","non_qualified":null,"image":"1f385-1f3fe.png","sheet_x":8,"sheet_y":23,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F385-1F3FF","non_qualified":null,"image":"1f385-1f3ff.png","sheet_x":8,"sheet_y":24,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Father Christmas","b":"1F385","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["festival","man","male","xmas","father christmas"],"k":[8,19]},"flag-no":{"a":"Norway Flag","b":"1F1F3-1F1F4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,47]},"u7a7a":{"a":"Squared Cjk Unified Ideograph-7a7a","b":"1F233","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["kanji","japanese","chinese","empty","sky","blue-square"],"k":[5,34]},"mrs_claus":{"skin_variations":{"1F3FB":{"unified":"1F936-1F3FB","non_qualified":null,"image":"1f936-1f3fb.png","sheet_x":39,"sheet_y":41,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F936-1F3FC","non_qualified":null,"image":"1f936-1f3fc.png","sheet_x":39,"sheet_y":42,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F936-1F3FD","non_qualified":null,"image":"1f936-1f3fd.png","sheet_x":39,"sheet_y":43,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F936-1F3FE","non_qualified":null,"image":"1f936-1f3fe.png","sheet_x":39,"sheet_y":44,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F936-1F3FF","non_qualified":null,"image":"1f936-1f3ff.png","sheet_x":39,"sheet_y":45,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Mother Christmas","b":"1F936","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["woman","female","xmas","mother christmas"],"k":[39,40],"n":["mother_christmas"],"o":9},"star":{"a":"White Medium Star","b":"2B50","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["night","yellow"],"k":[50,22],"o":5},"flag-np":{"a":"Nepal Flag","b":"1F1F3-1F1F5","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,48]},"star2":{"a":"Glowing Star","b":"1F31F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["night","sparkle","awesome","good","magic"],"k":[6,23]},"mage":{"skin_variations":{"1F3FB":{"unified":"1F9D9-1F3FB","non_qualified":null,"image":"1f9d9-1f3fb.png","sheet_x":44,"sheet_y":43,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9D9-1F3FB-200D-2640-FE0F"},"1F3FC":{"unified":"1F9D9-1F3FC","non_qualified":null,"image":"1f9d9-1f3fc.png","sheet_x":44,"sheet_y":44,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9D9-1F3FC-200D-2640-FE0F"},"1F3FD":{"unified":"1F9D9-1F3FD","non_qualified":null,"image":"1f9d9-1f3fd.png","sheet_x":44,"sheet_y":45,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9D9-1F3FD-200D-2640-FE0F"},"1F3FE":{"unified":"1F9D9-1F3FE","non_qualified":null,"image":"1f9d9-1f3fe.png","sheet_x":44,"sheet_y":46,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9D9-1F3FE-200D-2640-FE0F"},"1F3FF":{"unified":"1F9D9-1F3FF","non_qualified":null,"image":"1f9d9-1f3ff.png","sheet_x":44,"sheet_y":47,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9D9-1F3FF-200D-2640-FE0F"}},"obsoleted_by":"1F9D9-200D-2640-FE0F","a":"Mage","b":"1F9D9","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[44,42],"o":10},"congratulations":{"a":"Circled Ideograph Congratulation","b":"3297-FE0F","c":"3297","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["chinese","kanji","japanese","red-circle"],"k":[50,26],"o":1},"flag-nr":{"a":"Nauru Flag","b":"1F1F3-1F1F7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,49]},"stars":{"a":"Shooting Star","b":"1F320","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["night","photo"],"k":[6,24]},"female_mage":{"skin_variations":{"1F3FB":{"unified":"1F9D9-1F3FB-200D-2640-FE0F","non_qualified":"1F9D9-1F3FB-200D-2640","image":"1f9d9-1f3fb-200d-2640-fe0f.png","sheet_x":44,"sheet_y":31,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9D9-1F3FB"},"1F3FC":{"unified":"1F9D9-1F3FC-200D-2640-FE0F","non_qualified":"1F9D9-1F3FC-200D-2640","image":"1f9d9-1f3fc-200d-2640-fe0f.png","sheet_x":44,"sheet_y":32,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9D9-1F3FC"},"1F3FD":{"unified":"1F9D9-1F3FD-200D-2640-FE0F","non_qualified":"1F9D9-1F3FD-200D-2640","image":"1f9d9-1f3fd-200d-2640-fe0f.png","sheet_x":44,"sheet_y":33,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9D9-1F3FD"},"1F3FE":{"unified":"1F9D9-1F3FE-200D-2640-FE0F","non_qualified":"1F9D9-1F3FE-200D-2640","image":"1f9d9-1f3fe-200d-2640-fe0f.png","sheet_x":44,"sheet_y":34,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9D9-1F3FE"},"1F3FF":{"unified":"1F9D9-1F3FF-200D-2640-FE0F","non_qualified":"1F9D9-1F3FF-200D-2640","image":"1f9d9-1f3ff-200d-2640-fe0f.png","sheet_x":44,"sheet_y":35,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9D9-1F3FF"}},"obsoletes":"1F9D9","a":"Female Mage","b":"1F9D9-200D-2640-FE0F","c":"1F9D9-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[44,30],"o":10},"secret":{"a":"Circled Ideograph Secret","b":"3299-FE0F","c":"3299","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["privacy","chinese","sshh","kanji","red-circle"],"k":[50,27],"o":1},"flag-nu":{"a":"Niue Flag","b":"1F1F3-1F1FA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,50]},"u55b6":{"a":"Squared Cjk Unified Ideograph-55b6","b":"1F23A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["japanese","opening hours","orange-square"],"k":[5,41]},"male_mage":{"skin_variations":{"1F3FB":{"unified":"1F9D9-1F3FB-200D-2642-FE0F","non_qualified":"1F9D9-1F3FB-200D-2642","image":"1f9d9-1f3fb-200d-2642-fe0f.png","sheet_x":44,"sheet_y":37,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F9D9-1F3FC-200D-2642-FE0F","non_qualified":"1F9D9-1F3FC-200D-2642","image":"1f9d9-1f3fc-200d-2642-fe0f.png","sheet_x":44,"sheet_y":38,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F9D9-1F3FD-200D-2642-FE0F","non_qualified":"1F9D9-1F3FD-200D-2642","image":"1f9d9-1f3fd-200d-2642-fe0f.png","sheet_x":44,"sheet_y":39,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F9D9-1F3FE-200D-2642-FE0F","non_qualified":"1F9D9-1F3FE-200D-2642","image":"1f9d9-1f3fe-200d-2642-fe0f.png","sheet_x":44,"sheet_y":40,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F9D9-1F3FF-200D-2642-FE0F","non_qualified":"1F9D9-1F3FF-200D-2642","image":"1f9d9-1f3ff-200d-2642-fe0f.png","sheet_x":44,"sheet_y":41,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Male Mage","b":"1F9D9-200D-2642-FE0F","c":"1F9D9-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[44,36],"o":10},"cloud":{"a":"Cloud","b":"2601-FE0F","c":"2601","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["weather","sky"],"k":[47,17],"o":1},"flag-nz":{"a":"New Zealand Flag","b":"1F1F3-1F1FF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[3,51]},"u6e80":{"a":"Squared Cjk Unified Ideograph-6e80","b":"1F235","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["full","chinese","japanese","red-square","kanji"],"k":[5,36]},"fairy":{"skin_variations":{"1F3FB":{"unified":"1F9DA-1F3FB","non_qualified":null,"image":"1f9da-1f3fb.png","sheet_x":45,"sheet_y":9,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoleted_by":"1F9DA-1F3FB-200D-2640-FE0F"},"1F3FC":{"unified":"1F9DA-1F3FC","non_qualified":null,"image":"1f9da-1f3fc.png","sheet_x":45,"sheet_y":10,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoleted_by":"1F9DA-1F3FC-200D-2640-FE0F"},"1F3FD":{"unified":"1F9DA-1F3FD","non_qualified":null,"image":"1f9da-1f3fd.png","sheet_x":45,"sheet_y":11,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoleted_by":"1F9DA-1F3FD-200D-2640-FE0F"},"1F3FE":{"unified":"1F9DA-1F3FE","non_qualified":null,"image":"1f9da-1f3fe.png","sheet_x":45,"sheet_y":12,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoleted_by":"1F9DA-1F3FE-200D-2640-FE0F"},"1F3FF":{"unified":"1F9DA-1F3FF","non_qualified":null,"image":"1f9da-1f3ff.png","sheet_x":45,"sheet_y":13,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoleted_by":"1F9DA-1F3FF-200D-2640-FE0F"}},"obsoleted_by":"1F9DA-200D-2640-FE0F","a":"Fairy","b":"1F9DA","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[45,8],"o":10},"partly_sunny":{"a":"Sun Behind Cloud","b":"26C5","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["weather","nature","cloudy","morning","fall","spring"],"k":[48,29],"o":5},"flag-om":{"a":"Oman Flag","b":"1F1F4-1F1F2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,0]},"female_fairy":{"skin_variations":{"1F3FB":{"unified":"1F9DA-1F3FB-200D-2640-FE0F","non_qualified":"1F9DA-1F3FB-200D-2640","image":"1f9da-1f3fb-200d-2640-fe0f.png","sheet_x":44,"sheet_y":49,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9DA-1F3FB"},"1F3FC":{"unified":"1F9DA-1F3FC-200D-2640-FE0F","non_qualified":"1F9DA-1F3FC-200D-2640","image":"1f9da-1f3fc-200d-2640-fe0f.png","sheet_x":44,"sheet_y":50,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9DA-1F3FC"},"1F3FD":{"unified":"1F9DA-1F3FD-200D-2640-FE0F","non_qualified":"1F9DA-1F3FD-200D-2640","image":"1f9da-1f3fd-200d-2640-fe0f.png","sheet_x":44,"sheet_y":51,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9DA-1F3FD"},"1F3FE":{"unified":"1F9DA-1F3FE-200D-2640-FE0F","non_qualified":"1F9DA-1F3FE-200D-2640","image":"1f9da-1f3fe-200d-2640-fe0f.png","sheet_x":45,"sheet_y":0,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9DA-1F3FE"},"1F3FF":{"unified":"1F9DA-1F3FF-200D-2640-FE0F","non_qualified":"1F9DA-1F3FF-200D-2640","image":"1f9da-1f3ff-200d-2640-fe0f.png","sheet_x":45,"sheet_y":1,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9DA-1F3FF"}},"obsoletes":"1F9DA","a":"Female Fairy","b":"1F9DA-200D-2640-FE0F","c":"1F9DA-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[44,48],"o":10},"black_small_square":{"a":"Black Small Square","b":"25AA-FE0F","c":"25AA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shape","icon"],"k":[47,8],"o":1},"thunder_cloud_and_rain":{"a":"Thunder Cloud and Rain","b":"26C8-FE0F","c":"26C8","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[48,30],"o":5},"flag-pa":{"a":"Panama Flag","b":"1F1F5-1F1E6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,1]},"mostly_sunny":{"a":"Mostly Sunny","b":"1F324-FE0F","c":"1F324","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[6,26],"n":["sun_small_cloud"],"o":7},"male_fairy":{"skin_variations":{"1F3FB":{"unified":"1F9DA-1F3FB-200D-2642-FE0F","non_qualified":"1F9DA-1F3FB-200D-2642","image":"1f9da-1f3fb-200d-2642-fe0f.png","sheet_x":45,"sheet_y":3,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F9DA-1F3FC-200D-2642-FE0F","non_qualified":"1F9DA-1F3FC-200D-2642","image":"1f9da-1f3fc-200d-2642-fe0f.png","sheet_x":45,"sheet_y":4,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F9DA-1F3FD-200D-2642-FE0F","non_qualified":"1F9DA-1F3FD-200D-2642","image":"1f9da-1f3fd-200d-2642-fe0f.png","sheet_x":45,"sheet_y":5,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F9DA-1F3FE-200D-2642-FE0F","non_qualified":"1F9DA-1F3FE-200D-2642","image":"1f9da-1f3fe-200d-2642-fe0f.png","sheet_x":45,"sheet_y":6,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F9DA-1F3FF-200D-2642-FE0F","non_qualified":"1F9DA-1F3FF-200D-2642","image":"1f9da-1f3ff-200d-2642-fe0f.png","sheet_x":45,"sheet_y":7,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Male Fairy","b":"1F9DA-200D-2642-FE0F","c":"1F9DA-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[45,2],"o":10},"white_small_square":{"a":"White Small Square","b":"25AB-FE0F","c":"25AB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shape","icon"],"k":[47,9],"o":1},"flag-pe":{"a":"Peru Flag","b":"1F1F5-1F1EA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,2]},"barely_sunny":{"a":"Barely Sunny","b":"1F325-FE0F","c":"1F325","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[6,27],"n":["sun_behind_cloud"],"o":7},"vampire":{"skin_variations":{"1F3FB":{"unified":"1F9DB-1F3FB","non_qualified":null,"image":"1f9db-1f3fb.png","sheet_x":45,"sheet_y":27,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoleted_by":"1F9DB-1F3FB-200D-2640-FE0F"},"1F3FC":{"unified":"1F9DB-1F3FC","non_qualified":null,"image":"1f9db-1f3fc.png","sheet_x":45,"sheet_y":28,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoleted_by":"1F9DB-1F3FC-200D-2640-FE0F"},"1F3FD":{"unified":"1F9DB-1F3FD","non_qualified":null,"image":"1f9db-1f3fd.png","sheet_x":45,"sheet_y":29,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoleted_by":"1F9DB-1F3FD-200D-2640-FE0F"},"1F3FE":{"unified":"1F9DB-1F3FE","non_qualified":null,"image":"1f9db-1f3fe.png","sheet_x":45,"sheet_y":30,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoleted_by":"1F9DB-1F3FE-200D-2640-FE0F"},"1F3FF":{"unified":"1F9DB-1F3FF","non_qualified":null,"image":"1f9db-1f3ff.png","sheet_x":45,"sheet_y":31,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoleted_by":"1F9DB-1F3FF-200D-2640-FE0F"}},"obsoleted_by":"1F9DB-200D-2640-FE0F","a":"Vampire","b":"1F9DB","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[45,26],"o":10},"white_medium_square":{"a":"White Medium Square","b":"25FB-FE0F","c":"25FB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shape","stone","icon"],"k":[47,12],"o":3},"flag-pf":{"a":"French Polynesia Flag","b":"1F1F5-1F1EB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,3]},"partly_sunny_rain":{"a":"Partly Sunny Rain","b":"1F326-FE0F","c":"1F326","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[6,28],"n":["sun_behind_rain_cloud"],"o":7},"female_vampire":{"skin_variations":{"1F3FB":{"unified":"1F9DB-1F3FB-200D-2640-FE0F","non_qualified":"1F9DB-1F3FB-200D-2640","image":"1f9db-1f3fb-200d-2640-fe0f.png","sheet_x":45,"sheet_y":15,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9DB-1F3FB"},"1F3FC":{"unified":"1F9DB-1F3FC-200D-2640-FE0F","non_qualified":"1F9DB-1F3FC-200D-2640","image":"1f9db-1f3fc-200d-2640-fe0f.png","sheet_x":45,"sheet_y":16,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9DB-1F3FC"},"1F3FD":{"unified":"1F9DB-1F3FD-200D-2640-FE0F","non_qualified":"1F9DB-1F3FD-200D-2640","image":"1f9db-1f3fd-200d-2640-fe0f.png","sheet_x":45,"sheet_y":17,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9DB-1F3FD"},"1F3FE":{"unified":"1F9DB-1F3FE-200D-2640-FE0F","non_qualified":"1F9DB-1F3FE-200D-2640","image":"1f9db-1f3fe-200d-2640-fe0f.png","sheet_x":45,"sheet_y":18,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9DB-1F3FE"},"1F3FF":{"unified":"1F9DB-1F3FF-200D-2640-FE0F","non_qualified":"1F9DB-1F3FF-200D-2640","image":"1f9db-1f3ff-200d-2640-fe0f.png","sheet_x":45,"sheet_y":19,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9DB-1F3FF"}},"obsoletes":"1F9DB","a":"Female Vampire","b":"1F9DB-200D-2640-FE0F","c":"1F9DB-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[45,14],"o":10},"black_medium_square":{"a":"Black Medium Square","b":"25FC-FE0F","c":"25FC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shape","button","icon"],"k":[47,13],"o":3},"flag-pg":{"a":"Papua New Guinea Flag","b":"1F1F5-1F1EC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,4]},"rain_cloud":{"a":"Rain Cloud","b":"1F327-FE0F","c":"1F327","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[6,29],"o":7},"male_vampire":{"skin_variations":{"1F3FB":{"unified":"1F9DB-1F3FB-200D-2642-FE0F","non_qualified":"1F9DB-1F3FB-200D-2642","image":"1f9db-1f3fb-200d-2642-fe0f.png","sheet_x":45,"sheet_y":21,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F9DB-1F3FC-200D-2642-FE0F","non_qualified":"1F9DB-1F3FC-200D-2642","image":"1f9db-1f3fc-200d-2642-fe0f.png","sheet_x":45,"sheet_y":22,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F9DB-1F3FD-200D-2642-FE0F","non_qualified":"1F9DB-1F3FD-200D-2642","image":"1f9db-1f3fd-200d-2642-fe0f.png","sheet_x":45,"sheet_y":23,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F9DB-1F3FE-200D-2642-FE0F","non_qualified":"1F9DB-1F3FE-200D-2642","image":"1f9db-1f3fe-200d-2642-fe0f.png","sheet_x":45,"sheet_y":24,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F9DB-1F3FF-200D-2642-FE0F","non_qualified":"1F9DB-1F3FF-200D-2642","image":"1f9db-1f3ff-200d-2642-fe0f.png","sheet_x":45,"sheet_y":25,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Male Vampire","b":"1F9DB-200D-2642-FE0F","c":"1F9DB-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[45,20],"o":10},"white_medium_small_square":{"a":"White Medium Small Square","b":"25FD","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shape","stone","icon","button"],"k":[47,14],"o":3},"flag-ph":{"a":"Philippines Flag","b":"1F1F5-1F1ED","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,5]},"snow_cloud":{"a":"Snow Cloud","b":"1F328-FE0F","c":"1F328","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[6,30],"o":7},"merperson":{"skin_variations":{"1F3FB":{"unified":"1F9DC-1F3FB","non_qualified":null,"image":"1f9dc-1f3fb.png","sheet_x":45,"sheet_y":45,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9DC-1F3FB-200D-2642-FE0F"},"1F3FC":{"unified":"1F9DC-1F3FC","non_qualified":null,"image":"1f9dc-1f3fc.png","sheet_x":45,"sheet_y":46,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9DC-1F3FC-200D-2642-FE0F"},"1F3FD":{"unified":"1F9DC-1F3FD","non_qualified":null,"image":"1f9dc-1f3fd.png","sheet_x":45,"sheet_y":47,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9DC-1F3FD-200D-2642-FE0F"},"1F3FE":{"unified":"1F9DC-1F3FE","non_qualified":null,"image":"1f9dc-1f3fe.png","sheet_x":45,"sheet_y":48,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9DC-1F3FE-200D-2642-FE0F"},"1F3FF":{"unified":"1F9DC-1F3FF","non_qualified":null,"image":"1f9dc-1f3ff.png","sheet_x":45,"sheet_y":49,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9DC-1F3FF-200D-2642-FE0F"}},"obsoleted_by":"1F9DC-200D-2642-FE0F","a":"Merperson","b":"1F9DC","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[45,44],"o":10},"black_medium_small_square":{"a":"Black Medium Small Square","b":"25FE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["icon","shape","button"],"k":[47,15],"o":3},"flag-pk":{"a":"Pakistan Flag","b":"1F1F5-1F1F0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,6]},"lightning":{"a":"Lightning","b":"1F329-FE0F","c":"1F329","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[6,31],"n":["lightning_cloud"],"o":7},"mermaid":{"skin_variations":{"1F3FB":{"unified":"1F9DC-1F3FB-200D-2640-FE0F","non_qualified":"1F9DC-1F3FB-200D-2640","image":"1f9dc-1f3fb-200d-2640-fe0f.png","sheet_x":45,"sheet_y":33,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F9DC-1F3FC-200D-2640-FE0F","non_qualified":"1F9DC-1F3FC-200D-2640","image":"1f9dc-1f3fc-200d-2640-fe0f.png","sheet_x":45,"sheet_y":34,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F9DC-1F3FD-200D-2640-FE0F","non_qualified":"1F9DC-1F3FD-200D-2640","image":"1f9dc-1f3fd-200d-2640-fe0f.png","sheet_x":45,"sheet_y":35,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F9DC-1F3FE-200D-2640-FE0F","non_qualified":"1F9DC-1F3FE-200D-2640","image":"1f9dc-1f3fe-200d-2640-fe0f.png","sheet_x":45,"sheet_y":36,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F9DC-1F3FF-200D-2640-FE0F","non_qualified":"1F9DC-1F3FF-200D-2640","image":"1f9dc-1f3ff-200d-2640-fe0f.png","sheet_x":45,"sheet_y":37,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Mermaid","b":"1F9DC-200D-2640-FE0F","c":"1F9DC-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["woman","female","merwoman","ariel"],"k":[45,32],"o":10},"black_large_square":{"a":"Black Large Square","b":"2B1B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shape","icon","button"],"k":[50,20],"o":5},"flag-pl":{"a":"Poland Flag","b":"1F1F5-1F1F1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,7]},"tornado":{"a":"Tornado","b":"1F32A-FE0F","c":"1F32A","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["weather","cyclone","twister"],"k":[6,32],"n":["tornado_cloud"],"o":7},"merman":{"skin_variations":{"1F3FB":{"unified":"1F9DC-1F3FB-200D-2642-FE0F","non_qualified":"1F9DC-1F3FB-200D-2642","image":"1f9dc-1f3fb-200d-2642-fe0f.png","sheet_x":45,"sheet_y":39,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9DC-1F3FB"},"1F3FC":{"unified":"1F9DC-1F3FC-200D-2642-FE0F","non_qualified":"1F9DC-1F3FC-200D-2642","image":"1f9dc-1f3fc-200d-2642-fe0f.png","sheet_x":45,"sheet_y":40,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9DC-1F3FC"},"1F3FD":{"unified":"1F9DC-1F3FD-200D-2642-FE0F","non_qualified":"1F9DC-1F3FD-200D-2642","image":"1f9dc-1f3fd-200d-2642-fe0f.png","sheet_x":45,"sheet_y":41,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9DC-1F3FD"},"1F3FE":{"unified":"1F9DC-1F3FE-200D-2642-FE0F","non_qualified":"1F9DC-1F3FE-200D-2642","image":"1f9dc-1f3fe-200d-2642-fe0f.png","sheet_x":45,"sheet_y":42,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9DC-1F3FE"},"1F3FF":{"unified":"1F9DC-1F3FF-200D-2642-FE0F","non_qualified":"1F9DC-1F3FF-200D-2642","image":"1f9dc-1f3ff-200d-2642-fe0f.png","sheet_x":45,"sheet_y":43,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9DC-1F3FF"}},"obsoletes":"1F9DC","a":"Merman","b":"1F9DC-200D-2642-FE0F","c":"1F9DC-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["man","male","triton"],"k":[45,38],"o":10},"white_large_square":{"a":"White Large Square","b":"2B1C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shape","icon","stone","button"],"k":[50,21],"o":5},"flag-pm":{"a":"St. Pierre & Miquelon Flag","b":"1F1F5-1F1F2","d":true,"e":false,"f":true,"g":true,"h":true,"i":true,"k":[4,8]},"fog":{"a":"Fog","b":"1F32B-FE0F","c":"1F32B","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["weather"],"k":[6,33],"o":7},"large_orange_diamond":{"a":"Large Orange Diamond","b":"1F536","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shape","jewel","gem"],"k":[28,4]},"elf":{"skin_variations":{"1F3FB":{"unified":"1F9DD-1F3FB","non_qualified":null,"image":"1f9dd-1f3fb.png","sheet_x":46,"sheet_y":11,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9DD-1F3FB-200D-2642-FE0F"},"1F3FC":{"unified":"1F9DD-1F3FC","non_qualified":null,"image":"1f9dd-1f3fc.png","sheet_x":46,"sheet_y":12,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9DD-1F3FC-200D-2642-FE0F"},"1F3FD":{"unified":"1F9DD-1F3FD","non_qualified":null,"image":"1f9dd-1f3fd.png","sheet_x":46,"sheet_y":13,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9DD-1F3FD-200D-2642-FE0F"},"1F3FE":{"unified":"1F9DD-1F3FE","non_qualified":null,"image":"1f9dd-1f3fe.png","sheet_x":46,"sheet_y":14,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9DD-1F3FE-200D-2642-FE0F"},"1F3FF":{"unified":"1F9DD-1F3FF","non_qualified":null,"image":"1f9dd-1f3ff.png","sheet_x":46,"sheet_y":15,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9DD-1F3FF-200D-2642-FE0F"}},"obsoleted_by":"1F9DD-200D-2642-FE0F","a":"Elf","b":"1F9DD","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[46,10],"o":10},"flag-pn":{"a":"Pitcairn Islands Flag","b":"1F1F5-1F1F3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,9]},"wind_blowing_face":{"a":"Wind Blowing Face","b":"1F32C-FE0F","c":"1F32C","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[6,34],"o":7},"large_blue_diamond":{"a":"Large Blue Diamond","b":"1F537","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shape","jewel","gem"],"k":[28,5]},"female_elf":{"skin_variations":{"1F3FB":{"unified":"1F9DD-1F3FB-200D-2640-FE0F","non_qualified":"1F9DD-1F3FB-200D-2640","image":"1f9dd-1f3fb-200d-2640-fe0f.png","sheet_x":45,"sheet_y":51,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F9DD-1F3FC-200D-2640-FE0F","non_qualified":"1F9DD-1F3FC-200D-2640","image":"1f9dd-1f3fc-200d-2640-fe0f.png","sheet_x":46,"sheet_y":0,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F9DD-1F3FD-200D-2640-FE0F","non_qualified":"1F9DD-1F3FD-200D-2640","image":"1f9dd-1f3fd-200d-2640-fe0f.png","sheet_x":46,"sheet_y":1,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F9DD-1F3FE-200D-2640-FE0F","non_qualified":"1F9DD-1F3FE-200D-2640","image":"1f9dd-1f3fe-200d-2640-fe0f.png","sheet_x":46,"sheet_y":2,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F9DD-1F3FF-200D-2640-FE0F","non_qualified":"1F9DD-1F3FF-200D-2640","image":"1f9dd-1f3ff-200d-2640-fe0f.png","sheet_x":46,"sheet_y":3,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Female Elf","b":"1F9DD-200D-2640-FE0F","c":"1F9DD-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[45,50],"o":10},"flag-pr":{"a":"Puerto Rico Flag","b":"1F1F5-1F1F7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,10]},"cyclone":{"a":"Cyclone","b":"1F300","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["weather","swirl","blue","cloud","vortex","spiral","whirlpool","spin","tornado","hurricane","typhoon"],"k":[5,44]},"small_orange_diamond":{"a":"Small Orange Diamond","b":"1F538","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shape","jewel","gem"],"k":[28,6]},"male_elf":{"skin_variations":{"1F3FB":{"unified":"1F9DD-1F3FB-200D-2642-FE0F","non_qualified":"1F9DD-1F3FB-200D-2642","image":"1f9dd-1f3fb-200d-2642-fe0f.png","sheet_x":46,"sheet_y":5,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9DD-1F3FB"},"1F3FC":{"unified":"1F9DD-1F3FC-200D-2642-FE0F","non_qualified":"1F9DD-1F3FC-200D-2642","image":"1f9dd-1f3fc-200d-2642-fe0f.png","sheet_x":46,"sheet_y":6,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9DD-1F3FC"},"1F3FD":{"unified":"1F9DD-1F3FD-200D-2642-FE0F","non_qualified":"1F9DD-1F3FD-200D-2642","image":"1f9dd-1f3fd-200d-2642-fe0f.png","sheet_x":46,"sheet_y":7,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9DD-1F3FD"},"1F3FE":{"unified":"1F9DD-1F3FE-200D-2642-FE0F","non_qualified":"1F9DD-1F3FE-200D-2642","image":"1f9dd-1f3fe-200d-2642-fe0f.png","sheet_x":46,"sheet_y":8,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9DD-1F3FE"},"1F3FF":{"unified":"1F9DD-1F3FF-200D-2642-FE0F","non_qualified":"1F9DD-1F3FF-200D-2642","image":"1f9dd-1f3ff-200d-2642-fe0f.png","sheet_x":46,"sheet_y":9,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9DD-1F3FF"}},"obsoletes":"1F9DD","a":"Male Elf","b":"1F9DD-200D-2642-FE0F","c":"1F9DD-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[46,4],"o":10},"flag-ps":{"a":"Palestinian Territories Flag","b":"1F1F5-1F1F8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,11]},"rainbow":{"a":"Rainbow","b":"1F308","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["nature","happy","unicorn_face","photo","sky","spring"],"k":[6,0]},"small_blue_diamond":{"a":"Small Blue Diamond","b":"1F539","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shape","jewel","gem"],"k":[28,7]},"genie":{"obsoleted_by":"1F9DE-200D-2642-FE0F","a":"Genie","b":"1F9DE","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[46,18],"o":10},"flag-pt":{"a":"Portugal Flag","b":"1F1F5-1F1F9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,12]},"closed_umbrella":{"a":"Closed Umbrella","b":"1F302","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["weather","rain","drizzle"],"k":[5,46]},"small_red_triangle":{"a":"Up-Pointing Red Triangle","b":"1F53A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shape","direction","up","top"],"k":[28,8]},"female_genie":{"a":"Female Genie","b":"1F9DE-200D-2640-FE0F","c":"1F9DE-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[46,16],"o":10},"flag-pw":{"a":"Palau Flag","b":"1F1F5-1F1FC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,13]},"small_red_triangle_down":{"a":"Down-Pointing Red Triangle","b":"1F53B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shape","direction","bottom"],"k":[28,9]},"male_genie":{"obsoletes":"1F9DE","a":"Male Genie","b":"1F9DE-200D-2642-FE0F","c":"1F9DE-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[46,17],"o":10},"umbrella":{"a":"Umbrella","b":"2602-FE0F","c":"2602","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["rainy","weather","spring"],"k":[47,18],"o":1},"flag-py":{"a":"Paraguay Flag","b":"1F1F5-1F1FE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,14]},"diamond_shape_with_a_dot_inside":{"a":"Diamond Shape with a Dot Inside","b":"1F4A0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["jewel","blue","gem","crystal","fancy"],"k":[25,6]},"zombie":{"obsoleted_by":"1F9DF-200D-2642-FE0F","a":"Zombie","b":"1F9DF","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[46,21],"o":10},"umbrella_with_rain_drops":{"a":"Umbrella with Rain Drops","b":"2614","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[47,23],"o":4},"flag-qa":{"a":"Qatar Flag","b":"1F1F6-1F1E6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,15]},"radio_button":{"a":"Radio Button","b":"1F518","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["input","old","music","circle"],"k":[27,26]},"female_zombie":{"a":"Female Zombie","b":"1F9DF-200D-2640-FE0F","c":"1F9DF-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[46,19],"o":10},"umbrella_on_ground":{"a":"Umbrella on Ground","b":"26F1-FE0F","c":"26F1","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[48,39],"o":5},"flag-re":{"a":"Réunion Flag","b":"1F1F7-1F1EA","d":true,"e":false,"f":true,"g":true,"h":true,"i":true,"k":[4,16]},"black_square_button":{"a":"Black Square Button","b":"1F532","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shape","input","frame"],"k":[28,0]},"male_zombie":{"obsoletes":"1F9DF","a":"Male Zombie","b":"1F9DF-200D-2642-FE0F","c":"1F9DF-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[46,20],"o":10},"zap":{"a":"High Voltage Sign","b":"26A1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["thunder","weather","lightning bolt","fast"],"k":[48,21],"o":4},"flag-ro":{"a":"Romania Flag","b":"1F1F7-1F1F4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,17]},"white_square_button":{"a":"White Square Button","b":"1F533","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shape","input"],"k":[28,1]},"person_frowning":{"skin_variations":{"1F3FB":{"unified":"1F64D-1F3FB","non_qualified":null,"image":"1f64d-1f3fb.png","sheet_x":33,"sheet_y":31,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FC":{"unified":"1F64D-1F3FC","non_qualified":null,"image":"1f64d-1f3fc.png","sheet_x":33,"sheet_y":32,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FD":{"unified":"1F64D-1F3FD","non_qualified":null,"image":"1f64d-1f3fd.png","sheet_x":33,"sheet_y":33,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FE":{"unified":"1F64D-1F3FE","non_qualified":null,"image":"1f64d-1f3fe.png","sheet_x":33,"sheet_y":34,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FF":{"unified":"1F64D-1F3FF","non_qualified":null,"image":"1f64d-1f3ff.png","sheet_x":33,"sheet_y":35,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true}},"obsoleted_by":"1F64D-200D-2640-FE0F","a":"Person Frowning","b":"1F64D","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[33,30]},"snowflake":{"a":"Snowflake","b":"2744-FE0F","c":"2744","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["winter","season","cold","weather","christmas","xmas"],"k":[49,51],"o":1},"flag-rs":{"a":"Serbia Flag","b":"1F1F7-1F1F8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,18]},"man-frowning":{"skin_variations":{"1F3FB":{"unified":"1F64D-1F3FB-200D-2642-FE0F","non_qualified":"1F64D-1F3FB-200D-2642","image":"1f64d-1f3fb-200d-2642-fe0f.png","sheet_x":33,"sheet_y":25,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F64D-1F3FC-200D-2642-FE0F","non_qualified":"1F64D-1F3FC-200D-2642","image":"1f64d-1f3fc-200d-2642-fe0f.png","sheet_x":33,"sheet_y":26,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F64D-1F3FD-200D-2642-FE0F","non_qualified":"1F64D-1F3FD-200D-2642","image":"1f64d-1f3fd-200d-2642-fe0f.png","sheet_x":33,"sheet_y":27,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F64D-1F3FE-200D-2642-FE0F","non_qualified":"1F64D-1F3FE-200D-2642","image":"1f64d-1f3fe-200d-2642-fe0f.png","sheet_x":33,"sheet_y":28,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F64D-1F3FF-200D-2642-FE0F","non_qualified":"1F64D-1F3FF-200D-2642","image":"1f64d-1f3ff-200d-2642-fe0f.png","sheet_x":33,"sheet_y":29,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Man Frowning","b":"1F64D-200D-2642-FE0F","c":"1F64D-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[33,24]},"snowman":{"a":"Snowman","b":"2603-FE0F","c":"2603","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["winter","season","cold","weather","christmas","xmas","frozen","without_snow"],"k":[47,19],"o":1},"white_circle":{"a":"Medium White Circle","b":"26AA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shape","round"],"k":[48,22],"o":4},"ru":{"a":"Russia Flag","b":"1F1F7-1F1FA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["russian","federation","flag","nation","country","banner"],"k":[4,19],"n":["flag-ru"]},"woman-frowning":{"skin_variations":{"1F3FB":{"unified":"1F64D-1F3FB-200D-2640-FE0F","non_qualified":"1F64D-1F3FB-200D-2640","image":"1f64d-1f3fb-200d-2640-fe0f.png","sheet_x":33,"sheet_y":19,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F64D-1F3FC-200D-2640-FE0F","non_qualified":"1F64D-1F3FC-200D-2640","image":"1f64d-1f3fc-200d-2640-fe0f.png","sheet_x":33,"sheet_y":20,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F64D-1F3FD-200D-2640-FE0F","non_qualified":"1F64D-1F3FD-200D-2640","image":"1f64d-1f3fd-200d-2640-fe0f.png","sheet_x":33,"sheet_y":21,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F64D-1F3FE-200D-2640-FE0F","non_qualified":"1F64D-1F3FE-200D-2640","image":"1f64d-1f3fe-200d-2640-fe0f.png","sheet_x":33,"sheet_y":22,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F64D-1F3FF-200D-2640-FE0F","non_qualified":"1F64D-1F3FF-200D-2640","image":"1f64d-1f3ff-200d-2640-fe0f.png","sheet_x":33,"sheet_y":23,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F64D","a":"Woman Frowning","b":"1F64D-200D-2640-FE0F","c":"1F64D-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[33,18]},"black_circle":{"a":"Medium Black Circle","b":"26AB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shape","button","round"],"k":[48,23],"o":4},"snowman_without_snow":{"a":"Snowman Without Snow","b":"26C4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[48,28],"o":5},"flag-rw":{"a":"Rwanda Flag","b":"1F1F7-1F1FC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,20]},"red_circle":{"a":"Large Red Circle","b":"1F534","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shape","error","danger"],"k":[28,2]},"person_with_pouting_face":{"skin_variations":{"1F3FB":{"unified":"1F64E-1F3FB","non_qualified":null,"image":"1f64e-1f3fb.png","sheet_x":33,"sheet_y":49,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FC":{"unified":"1F64E-1F3FC","non_qualified":null,"image":"1f64e-1f3fc.png","sheet_x":33,"sheet_y":50,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FD":{"unified":"1F64E-1F3FD","non_qualified":null,"image":"1f64e-1f3fd.png","sheet_x":33,"sheet_y":51,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FE":{"unified":"1F64E-1F3FE","non_qualified":null,"image":"1f64e-1f3fe.png","sheet_x":34,"sheet_y":0,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FF":{"unified":"1F64E-1F3FF","non_qualified":null,"image":"1f64e-1f3ff.png","sheet_x":34,"sheet_y":1,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true}},"obsoleted_by":"1F64E-200D-2640-FE0F","a":"Person with Pouting Face","b":"1F64E","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[33,48]},"comet":{"a":"Comet","b":"2604-FE0F","c":"2604","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["space"],"k":[47,20],"o":1},"flag-sa":{"a":"Saudi Arabia Flag","b":"1F1F8-1F1E6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,21]},"fire":{"a":"Fire","b":"1F525","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["hot","cook","flame"],"k":[27,39]},"large_blue_circle":{"a":"Large Blue Circle","b":"1F535","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shape","icon","button"],"k":[28,3]},"man-pouting":{"skin_variations":{"1F3FB":{"unified":"1F64E-1F3FB-200D-2642-FE0F","non_qualified":"1F64E-1F3FB-200D-2642","image":"1f64e-1f3fb-200d-2642-fe0f.png","sheet_x":33,"sheet_y":43,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F64E-1F3FC-200D-2642-FE0F","non_qualified":"1F64E-1F3FC-200D-2642","image":"1f64e-1f3fc-200d-2642-fe0f.png","sheet_x":33,"sheet_y":44,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F64E-1F3FD-200D-2642-FE0F","non_qualified":"1F64E-1F3FD-200D-2642","image":"1f64e-1f3fd-200d-2642-fe0f.png","sheet_x":33,"sheet_y":45,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F64E-1F3FE-200D-2642-FE0F","non_qualified":"1F64E-1F3FE-200D-2642","image":"1f64e-1f3fe-200d-2642-fe0f.png","sheet_x":33,"sheet_y":46,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F64E-1F3FF-200D-2642-FE0F","non_qualified":"1F64E-1F3FF-200D-2642","image":"1f64e-1f3ff-200d-2642-fe0f.png","sheet_x":33,"sheet_y":47,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Man Pouting","b":"1F64E-200D-2642-FE0F","c":"1F64E-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[33,42]},"flag-sb":{"a":"Solomon Islands Flag","b":"1F1F8-1F1E7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,22]},"droplet":{"a":"Droplet","b":"1F4A7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["water","drip","faucet","spring"],"k":[25,13]},"woman-pouting":{"skin_variations":{"1F3FB":{"unified":"1F64E-1F3FB-200D-2640-FE0F","non_qualified":"1F64E-1F3FB-200D-2640","image":"1f64e-1f3fb-200d-2640-fe0f.png","sheet_x":33,"sheet_y":37,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F64E-1F3FC-200D-2640-FE0F","non_qualified":"1F64E-1F3FC-200D-2640","image":"1f64e-1f3fc-200d-2640-fe0f.png","sheet_x":33,"sheet_y":38,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F64E-1F3FD-200D-2640-FE0F","non_qualified":"1F64E-1F3FD-200D-2640","image":"1f64e-1f3fd-200d-2640-fe0f.png","sheet_x":33,"sheet_y":39,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F64E-1F3FE-200D-2640-FE0F","non_qualified":"1F64E-1F3FE-200D-2640","image":"1f64e-1f3fe-200d-2640-fe0f.png","sheet_x":33,"sheet_y":40,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F64E-1F3FF-200D-2640-FE0F","non_qualified":"1F64E-1F3FF-200D-2640","image":"1f64e-1f3ff-200d-2640-fe0f.png","sheet_x":33,"sheet_y":41,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F64E","a":"Woman Pouting","b":"1F64E-200D-2640-FE0F","c":"1F64E-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[33,36]},"flag-sc":{"a":"Seychelles Flag","b":"1F1F8-1F1E8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,23]},"ocean":{"a":"Water Wave","b":"1F30A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sea","water","wave","nature","tsunami","disaster"],"k":[6,2]},"no_good":{"skin_variations":{"1F3FB":{"unified":"1F645-1F3FB","non_qualified":null,"image":"1f645-1f3fb.png","sheet_x":32,"sheet_y":2,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FC":{"unified":"1F645-1F3FC","non_qualified":null,"image":"1f645-1f3fc.png","sheet_x":32,"sheet_y":3,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FD":{"unified":"1F645-1F3FD","non_qualified":null,"image":"1f645-1f3fd.png","sheet_x":32,"sheet_y":4,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FE":{"unified":"1F645-1F3FE","non_qualified":null,"image":"1f645-1f3fe.png","sheet_x":32,"sheet_y":5,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FF":{"unified":"1F645-1F3FF","non_qualified":null,"image":"1f645-1f3ff.png","sheet_x":32,"sheet_y":6,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true}},"obsoleted_by":"1F645-200D-2640-FE0F","a":"Face with No Good Gesture","b":"1F645","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[32,1]},"flag-sd":{"a":"Sudan Flag","b":"1F1F8-1F1E9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,24]},"man-gesturing-no":{"skin_variations":{"1F3FB":{"unified":"1F645-1F3FB-200D-2642-FE0F","non_qualified":"1F645-1F3FB-200D-2642","image":"1f645-1f3fb-200d-2642-fe0f.png","sheet_x":31,"sheet_y":48,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F645-1F3FC-200D-2642-FE0F","non_qualified":"1F645-1F3FC-200D-2642","image":"1f645-1f3fc-200d-2642-fe0f.png","sheet_x":31,"sheet_y":49,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F645-1F3FD-200D-2642-FE0F","non_qualified":"1F645-1F3FD-200D-2642","image":"1f645-1f3fd-200d-2642-fe0f.png","sheet_x":31,"sheet_y":50,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F645-1F3FE-200D-2642-FE0F","non_qualified":"1F645-1F3FE-200D-2642","image":"1f645-1f3fe-200d-2642-fe0f.png","sheet_x":31,"sheet_y":51,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F645-1F3FF-200D-2642-FE0F","non_qualified":"1F645-1F3FF-200D-2642","image":"1f645-1f3ff-200d-2642-fe0f.png","sheet_x":32,"sheet_y":0,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Man Gesturing No","b":"1F645-200D-2642-FE0F","c":"1F645-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[31,47]},"flag-se":{"a":"Sweden Flag","b":"1F1F8-1F1EA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,25]},"woman-gesturing-no":{"skin_variations":{"1F3FB":{"unified":"1F645-1F3FB-200D-2640-FE0F","non_qualified":"1F645-1F3FB-200D-2640","image":"1f645-1f3fb-200d-2640-fe0f.png","sheet_x":31,"sheet_y":42,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F645-1F3FC-200D-2640-FE0F","non_qualified":"1F645-1F3FC-200D-2640","image":"1f645-1f3fc-200d-2640-fe0f.png","sheet_x":31,"sheet_y":43,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F645-1F3FD-200D-2640-FE0F","non_qualified":"1F645-1F3FD-200D-2640","image":"1f645-1f3fd-200d-2640-fe0f.png","sheet_x":31,"sheet_y":44,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F645-1F3FE-200D-2640-FE0F","non_qualified":"1F645-1F3FE-200D-2640","image":"1f645-1f3fe-200d-2640-fe0f.png","sheet_x":31,"sheet_y":45,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F645-1F3FF-200D-2640-FE0F","non_qualified":"1F645-1F3FF-200D-2640","image":"1f645-1f3ff-200d-2640-fe0f.png","sheet_x":31,"sheet_y":46,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F645","a":"Woman Gesturing No","b":"1F645-200D-2640-FE0F","c":"1F645-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[31,41]},"flag-sg":{"a":"Singapore Flag","b":"1F1F8-1F1EC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,26]},"ok_woman":{"skin_variations":{"1F3FB":{"unified":"1F646-1F3FB","non_qualified":null,"image":"1f646-1f3fb.png","sheet_x":32,"sheet_y":20,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FC":{"unified":"1F646-1F3FC","non_qualified":null,"image":"1f646-1f3fc.png","sheet_x":32,"sheet_y":21,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FD":{"unified":"1F646-1F3FD","non_qualified":null,"image":"1f646-1f3fd.png","sheet_x":32,"sheet_y":22,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FE":{"unified":"1F646-1F3FE","non_qualified":null,"image":"1f646-1f3fe.png","sheet_x":32,"sheet_y":23,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FF":{"unified":"1F646-1F3FF","non_qualified":null,"image":"1f646-1f3ff.png","sheet_x":32,"sheet_y":24,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true}},"obsoleted_by":"1F646-200D-2640-FE0F","a":"Face with Ok Gesture","b":"1F646","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"j":["women","girl","female","pink","human","woman"],"k":[32,19]},"flag-sh":{"a":"St. Helena Flag","b":"1F1F8-1F1ED","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,27]},"man-gesturing-ok":{"skin_variations":{"1F3FB":{"unified":"1F646-1F3FB-200D-2642-FE0F","non_qualified":"1F646-1F3FB-200D-2642","image":"1f646-1f3fb-200d-2642-fe0f.png","sheet_x":32,"sheet_y":14,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F646-1F3FC-200D-2642-FE0F","non_qualified":"1F646-1F3FC-200D-2642","image":"1f646-1f3fc-200d-2642-fe0f.png","sheet_x":32,"sheet_y":15,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F646-1F3FD-200D-2642-FE0F","non_qualified":"1F646-1F3FD-200D-2642","image":"1f646-1f3fd-200d-2642-fe0f.png","sheet_x":32,"sheet_y":16,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F646-1F3FE-200D-2642-FE0F","non_qualified":"1F646-1F3FE-200D-2642","image":"1f646-1f3fe-200d-2642-fe0f.png","sheet_x":32,"sheet_y":17,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F646-1F3FF-200D-2642-FE0F","non_qualified":"1F646-1F3FF-200D-2642","image":"1f646-1f3ff-200d-2642-fe0f.png","sheet_x":32,"sheet_y":18,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Man Gesturing Ok","b":"1F646-200D-2642-FE0F","c":"1F646-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[32,13]},"flag-si":{"a":"Slovenia Flag","b":"1F1F8-1F1EE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,28]},"woman-gesturing-ok":{"skin_variations":{"1F3FB":{"unified":"1F646-1F3FB-200D-2640-FE0F","non_qualified":"1F646-1F3FB-200D-2640","image":"1f646-1f3fb-200d-2640-fe0f.png","sheet_x":32,"sheet_y":8,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F646-1F3FC-200D-2640-FE0F","non_qualified":"1F646-1F3FC-200D-2640","image":"1f646-1f3fc-200d-2640-fe0f.png","sheet_x":32,"sheet_y":9,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F646-1F3FD-200D-2640-FE0F","non_qualified":"1F646-1F3FD-200D-2640","image":"1f646-1f3fd-200d-2640-fe0f.png","sheet_x":32,"sheet_y":10,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F646-1F3FE-200D-2640-FE0F","non_qualified":"1F646-1F3FE-200D-2640","image":"1f646-1f3fe-200d-2640-fe0f.png","sheet_x":32,"sheet_y":11,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F646-1F3FF-200D-2640-FE0F","non_qualified":"1F646-1F3FF-200D-2640","image":"1f646-1f3ff-200d-2640-fe0f.png","sheet_x":32,"sheet_y":12,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F646","a":"Woman Gesturing Ok","b":"1F646-200D-2640-FE0F","c":"1F646-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[32,7]},"flag-sj":{"a":"Svalbard & Jan Mayen Flag","b":"1F1F8-1F1EF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,29]},"information_desk_person":{"skin_variations":{"1F3FB":{"unified":"1F481-1F3FB","non_qualified":null,"image":"1f481-1f3fb.png","sheet_x":23,"sheet_y":14,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FC":{"unified":"1F481-1F3FC","non_qualified":null,"image":"1f481-1f3fc.png","sheet_x":23,"sheet_y":15,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FD":{"unified":"1F481-1F3FD","non_qualified":null,"image":"1f481-1f3fd.png","sheet_x":23,"sheet_y":16,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FE":{"unified":"1F481-1F3FE","non_qualified":null,"image":"1f481-1f3fe.png","sheet_x":23,"sheet_y":17,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FF":{"unified":"1F481-1F3FF","non_qualified":null,"image":"1f481-1f3ff.png","sheet_x":23,"sheet_y":18,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true}},"obsoleted_by":"1F481-200D-2640-FE0F","a":"Information Desk Person","b":"1F481","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[23,13]},"flag-sk":{"a":"Slovakia Flag","b":"1F1F8-1F1F0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,30]},"man-tipping-hand":{"skin_variations":{"1F3FB":{"unified":"1F481-1F3FB-200D-2642-FE0F","non_qualified":"1F481-1F3FB-200D-2642","image":"1f481-1f3fb-200d-2642-fe0f.png","sheet_x":23,"sheet_y":8,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F481-1F3FC-200D-2642-FE0F","non_qualified":"1F481-1F3FC-200D-2642","image":"1f481-1f3fc-200d-2642-fe0f.png","sheet_x":23,"sheet_y":9,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F481-1F3FD-200D-2642-FE0F","non_qualified":"1F481-1F3FD-200D-2642","image":"1f481-1f3fd-200d-2642-fe0f.png","sheet_x":23,"sheet_y":10,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F481-1F3FE-200D-2642-FE0F","non_qualified":"1F481-1F3FE-200D-2642","image":"1f481-1f3fe-200d-2642-fe0f.png","sheet_x":23,"sheet_y":11,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F481-1F3FF-200D-2642-FE0F","non_qualified":"1F481-1F3FF-200D-2642","image":"1f481-1f3ff-200d-2642-fe0f.png","sheet_x":23,"sheet_y":12,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Man Tipping Hand","b":"1F481-200D-2642-FE0F","c":"1F481-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[23,7]},"flag-sl":{"a":"Sierra Leone Flag","b":"1F1F8-1F1F1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,31]},"woman-tipping-hand":{"skin_variations":{"1F3FB":{"unified":"1F481-1F3FB-200D-2640-FE0F","non_qualified":"1F481-1F3FB-200D-2640","image":"1f481-1f3fb-200d-2640-fe0f.png","sheet_x":23,"sheet_y":2,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F481-1F3FC-200D-2640-FE0F","non_qualified":"1F481-1F3FC-200D-2640","image":"1f481-1f3fc-200d-2640-fe0f.png","sheet_x":23,"sheet_y":3,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F481-1F3FD-200D-2640-FE0F","non_qualified":"1F481-1F3FD-200D-2640","image":"1f481-1f3fd-200d-2640-fe0f.png","sheet_x":23,"sheet_y":4,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F481-1F3FE-200D-2640-FE0F","non_qualified":"1F481-1F3FE-200D-2640","image":"1f481-1f3fe-200d-2640-fe0f.png","sheet_x":23,"sheet_y":5,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F481-1F3FF-200D-2640-FE0F","non_qualified":"1F481-1F3FF-200D-2640","image":"1f481-1f3ff-200d-2640-fe0f.png","sheet_x":23,"sheet_y":6,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F481","a":"Woman Tipping Hand","b":"1F481-200D-2640-FE0F","c":"1F481-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[23,1]},"flag-sm":{"a":"San Marino Flag","b":"1F1F8-1F1F2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,32]},"raising_hand":{"skin_variations":{"1F3FB":{"unified":"1F64B-1F3FB","non_qualified":null,"image":"1f64b-1f3fb.png","sheet_x":33,"sheet_y":7,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FC":{"unified":"1F64B-1F3FC","non_qualified":null,"image":"1f64b-1f3fc.png","sheet_x":33,"sheet_y":8,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FD":{"unified":"1F64B-1F3FD","non_qualified":null,"image":"1f64b-1f3fd.png","sheet_x":33,"sheet_y":9,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FE":{"unified":"1F64B-1F3FE","non_qualified":null,"image":"1f64b-1f3fe.png","sheet_x":33,"sheet_y":10,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FF":{"unified":"1F64B-1F3FF","non_qualified":null,"image":"1f64b-1f3ff.png","sheet_x":33,"sheet_y":11,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true}},"obsoleted_by":"1F64B-200D-2640-FE0F","a":"Happy Person Raising One Hand","b":"1F64B","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[33,6]},"flag-sn":{"a":"Senegal Flag","b":"1F1F8-1F1F3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,33]},"man-raising-hand":{"skin_variations":{"1F3FB":{"unified":"1F64B-1F3FB-200D-2642-FE0F","non_qualified":"1F64B-1F3FB-200D-2642","image":"1f64b-1f3fb-200d-2642-fe0f.png","sheet_x":33,"sheet_y":1,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F64B-1F3FC-200D-2642-FE0F","non_qualified":"1F64B-1F3FC-200D-2642","image":"1f64b-1f3fc-200d-2642-fe0f.png","sheet_x":33,"sheet_y":2,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F64B-1F3FD-200D-2642-FE0F","non_qualified":"1F64B-1F3FD-200D-2642","image":"1f64b-1f3fd-200d-2642-fe0f.png","sheet_x":33,"sheet_y":3,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F64B-1F3FE-200D-2642-FE0F","non_qualified":"1F64B-1F3FE-200D-2642","image":"1f64b-1f3fe-200d-2642-fe0f.png","sheet_x":33,"sheet_y":4,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F64B-1F3FF-200D-2642-FE0F","non_qualified":"1F64B-1F3FF-200D-2642","image":"1f64b-1f3ff-200d-2642-fe0f.png","sheet_x":33,"sheet_y":5,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Man Raising Hand","b":"1F64B-200D-2642-FE0F","c":"1F64B-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[33,0]},"flag-so":{"a":"Somalia Flag","b":"1F1F8-1F1F4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,34]},"woman-raising-hand":{"skin_variations":{"1F3FB":{"unified":"1F64B-1F3FB-200D-2640-FE0F","non_qualified":"1F64B-1F3FB-200D-2640","image":"1f64b-1f3fb-200d-2640-fe0f.png","sheet_x":32,"sheet_y":47,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F64B-1F3FC-200D-2640-FE0F","non_qualified":"1F64B-1F3FC-200D-2640","image":"1f64b-1f3fc-200d-2640-fe0f.png","sheet_x":32,"sheet_y":48,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F64B-1F3FD-200D-2640-FE0F","non_qualified":"1F64B-1F3FD-200D-2640","image":"1f64b-1f3fd-200d-2640-fe0f.png","sheet_x":32,"sheet_y":49,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F64B-1F3FE-200D-2640-FE0F","non_qualified":"1F64B-1F3FE-200D-2640","image":"1f64b-1f3fe-200d-2640-fe0f.png","sheet_x":32,"sheet_y":50,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F64B-1F3FF-200D-2640-FE0F","non_qualified":"1F64B-1F3FF-200D-2640","image":"1f64b-1f3ff-200d-2640-fe0f.png","sheet_x":32,"sheet_y":51,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F64B","a":"Woman Raising Hand","b":"1F64B-200D-2640-FE0F","c":"1F64B-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[32,46]},"flag-sr":{"a":"Suriname Flag","b":"1F1F8-1F1F7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,35]},"bow":{"skin_variations":{"1F3FB":{"unified":"1F647-1F3FB","non_qualified":null,"image":"1f647-1f3fb.png","sheet_x":32,"sheet_y":38,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FC":{"unified":"1F647-1F3FC","non_qualified":null,"image":"1f647-1f3fc.png","sheet_x":32,"sheet_y":39,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FD":{"unified":"1F647-1F3FD","non_qualified":null,"image":"1f647-1f3fd.png","sheet_x":32,"sheet_y":40,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FE":{"unified":"1F647-1F3FE","non_qualified":null,"image":"1f647-1f3fe.png","sheet_x":32,"sheet_y":41,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FF":{"unified":"1F647-1F3FF","non_qualified":null,"image":"1f647-1f3ff.png","sheet_x":32,"sheet_y":42,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true}},"obsoleted_by":"1F647-200D-2642-FE0F","a":"Person Bowing Deeply","b":"1F647","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[32,37]},"flag-ss":{"a":"South Sudan Flag","b":"1F1F8-1F1F8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,36]},"man-bowing":{"skin_variations":{"1F3FB":{"unified":"1F647-1F3FB-200D-2642-FE0F","non_qualified":"1F647-1F3FB-200D-2642","image":"1f647-1f3fb-200d-2642-fe0f.png","sheet_x":32,"sheet_y":32,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F647-1F3FC-200D-2642-FE0F","non_qualified":"1F647-1F3FC-200D-2642","image":"1f647-1f3fc-200d-2642-fe0f.png","sheet_x":32,"sheet_y":33,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F647-1F3FD-200D-2642-FE0F","non_qualified":"1F647-1F3FD-200D-2642","image":"1f647-1f3fd-200d-2642-fe0f.png","sheet_x":32,"sheet_y":34,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F647-1F3FE-200D-2642-FE0F","non_qualified":"1F647-1F3FE-200D-2642","image":"1f647-1f3fe-200d-2642-fe0f.png","sheet_x":32,"sheet_y":35,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F647-1F3FF-200D-2642-FE0F","non_qualified":"1F647-1F3FF-200D-2642","image":"1f647-1f3ff-200d-2642-fe0f.png","sheet_x":32,"sheet_y":36,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F647","a":"Man Bowing","b":"1F647-200D-2642-FE0F","c":"1F647-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[32,31]},"flag-st":{"a":"São Tomé & Príncipe Flag","b":"1F1F8-1F1F9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,37]},"woman-bowing":{"skin_variations":{"1F3FB":{"unified":"1F647-1F3FB-200D-2640-FE0F","non_qualified":"1F647-1F3FB-200D-2640","image":"1f647-1f3fb-200d-2640-fe0f.png","sheet_x":32,"sheet_y":26,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F647-1F3FC-200D-2640-FE0F","non_qualified":"1F647-1F3FC-200D-2640","image":"1f647-1f3fc-200d-2640-fe0f.png","sheet_x":32,"sheet_y":27,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F647-1F3FD-200D-2640-FE0F","non_qualified":"1F647-1F3FD-200D-2640","image":"1f647-1f3fd-200d-2640-fe0f.png","sheet_x":32,"sheet_y":28,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F647-1F3FE-200D-2640-FE0F","non_qualified":"1F647-1F3FE-200D-2640","image":"1f647-1f3fe-200d-2640-fe0f.png","sheet_x":32,"sheet_y":29,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F647-1F3FF-200D-2640-FE0F","non_qualified":"1F647-1F3FF-200D-2640","image":"1f647-1f3ff-200d-2640-fe0f.png","sheet_x":32,"sheet_y":30,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Woman Bowing","b":"1F647-200D-2640-FE0F","c":"1F647-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[32,25]},"flag-sv":{"a":"El Salvador Flag","b":"1F1F8-1F1FB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,38]},"face_palm":{"skin_variations":{"1F3FB":{"unified":"1F926-1F3FB","non_qualified":null,"image":"1f926-1f3fb.png","sheet_x":38,"sheet_y":42,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F926-1F3FC","non_qualified":null,"image":"1f926-1f3fc.png","sheet_x":38,"sheet_y":43,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F926-1F3FD","non_qualified":null,"image":"1f926-1f3fd.png","sheet_x":38,"sheet_y":44,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F926-1F3FE","non_qualified":null,"image":"1f926-1f3fe.png","sheet_x":38,"sheet_y":45,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F926-1F3FF","non_qualified":null,"image":"1f926-1f3ff.png","sheet_x":38,"sheet_y":46,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Face Palm","b":"1F926","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"k":[38,41],"o":9},"flag-sx":{"a":"Sint Maarten Flag","b":"1F1F8-1F1FD","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,39]},"man-facepalming":{"skin_variations":{"1F3FB":{"unified":"1F926-1F3FB-200D-2642-FE0F","non_qualified":"1F926-1F3FB-200D-2642","image":"1f926-1f3fb-200d-2642-fe0f.png","sheet_x":38,"sheet_y":36,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F926-1F3FC-200D-2642-FE0F","non_qualified":"1F926-1F3FC-200D-2642","image":"1f926-1f3fc-200d-2642-fe0f.png","sheet_x":38,"sheet_y":37,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F926-1F3FD-200D-2642-FE0F","non_qualified":"1F926-1F3FD-200D-2642","image":"1f926-1f3fd-200d-2642-fe0f.png","sheet_x":38,"sheet_y":38,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F926-1F3FE-200D-2642-FE0F","non_qualified":"1F926-1F3FE-200D-2642","image":"1f926-1f3fe-200d-2642-fe0f.png","sheet_x":38,"sheet_y":39,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F926-1F3FF-200D-2642-FE0F","non_qualified":"1F926-1F3FF-200D-2642","image":"1f926-1f3ff-200d-2642-fe0f.png","sheet_x":38,"sheet_y":40,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Man Facepalming","b":"1F926-200D-2642-FE0F","c":"1F926-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[38,35],"o":9},"flag-sy":{"a":"Syria Flag","b":"1F1F8-1F1FE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,40]},"woman-facepalming":{"skin_variations":{"1F3FB":{"unified":"1F926-1F3FB-200D-2640-FE0F","non_qualified":"1F926-1F3FB-200D-2640","image":"1f926-1f3fb-200d-2640-fe0f.png","sheet_x":38,"sheet_y":30,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F926-1F3FC-200D-2640-FE0F","non_qualified":"1F926-1F3FC-200D-2640","image":"1f926-1f3fc-200d-2640-fe0f.png","sheet_x":38,"sheet_y":31,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F926-1F3FD-200D-2640-FE0F","non_qualified":"1F926-1F3FD-200D-2640","image":"1f926-1f3fd-200d-2640-fe0f.png","sheet_x":38,"sheet_y":32,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F926-1F3FE-200D-2640-FE0F","non_qualified":"1F926-1F3FE-200D-2640","image":"1f926-1f3fe-200d-2640-fe0f.png","sheet_x":38,"sheet_y":33,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F926-1F3FF-200D-2640-FE0F","non_qualified":"1F926-1F3FF-200D-2640","image":"1f926-1f3ff-200d-2640-fe0f.png","sheet_x":38,"sheet_y":34,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Woman Facepalming","b":"1F926-200D-2640-FE0F","c":"1F926-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[38,29],"o":9},"flag-sz":{"a":"Swaziland Flag","b":"1F1F8-1F1FF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,41]},"shrug":{"skin_variations":{"1F3FB":{"unified":"1F937-1F3FB","non_qualified":null,"image":"1f937-1f3fb.png","sheet_x":40,"sheet_y":7,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F937-1F3FC","non_qualified":null,"image":"1f937-1f3fc.png","sheet_x":40,"sheet_y":8,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F937-1F3FD","non_qualified":null,"image":"1f937-1f3fd.png","sheet_x":40,"sheet_y":9,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F937-1F3FE","non_qualified":null,"image":"1f937-1f3fe.png","sheet_x":40,"sheet_y":10,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F937-1F3FF","non_qualified":null,"image":"1f937-1f3ff.png","sheet_x":40,"sheet_y":11,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Shrug","b":"1F937","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"k":[40,6],"o":9},"flag-ta":{"a":"Tristan Da Cunha Flag","b":"1F1F9-1F1E6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,42]},"man-shrugging":{"skin_variations":{"1F3FB":{"unified":"1F937-1F3FB-200D-2642-FE0F","non_qualified":"1F937-1F3FB-200D-2642","image":"1f937-1f3fb-200d-2642-fe0f.png","sheet_x":40,"sheet_y":1,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F937-1F3FC-200D-2642-FE0F","non_qualified":"1F937-1F3FC-200D-2642","image":"1f937-1f3fc-200d-2642-fe0f.png","sheet_x":40,"sheet_y":2,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F937-1F3FD-200D-2642-FE0F","non_qualified":"1F937-1F3FD-200D-2642","image":"1f937-1f3fd-200d-2642-fe0f.png","sheet_x":40,"sheet_y":3,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F937-1F3FE-200D-2642-FE0F","non_qualified":"1F937-1F3FE-200D-2642","image":"1f937-1f3fe-200d-2642-fe0f.png","sheet_x":40,"sheet_y":4,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F937-1F3FF-200D-2642-FE0F","non_qualified":"1F937-1F3FF-200D-2642","image":"1f937-1f3ff-200d-2642-fe0f.png","sheet_x":40,"sheet_y":5,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Man Shrugging","b":"1F937-200D-2642-FE0F","c":"1F937-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[40,0],"o":9},"flag-tc":{"a":"Turks & Caicos Islands Flag","b":"1F1F9-1F1E8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,43]},"woman-shrugging":{"skin_variations":{"1F3FB":{"unified":"1F937-1F3FB-200D-2640-FE0F","non_qualified":"1F937-1F3FB-200D-2640","image":"1f937-1f3fb-200d-2640-fe0f.png","sheet_x":39,"sheet_y":47,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F937-1F3FC-200D-2640-FE0F","non_qualified":"1F937-1F3FC-200D-2640","image":"1f937-1f3fc-200d-2640-fe0f.png","sheet_x":39,"sheet_y":48,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F937-1F3FD-200D-2640-FE0F","non_qualified":"1F937-1F3FD-200D-2640","image":"1f937-1f3fd-200d-2640-fe0f.png","sheet_x":39,"sheet_y":49,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F937-1F3FE-200D-2640-FE0F","non_qualified":"1F937-1F3FE-200D-2640","image":"1f937-1f3fe-200d-2640-fe0f.png","sheet_x":39,"sheet_y":50,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F937-1F3FF-200D-2640-FE0F","non_qualified":"1F937-1F3FF-200D-2640","image":"1f937-1f3ff-200d-2640-fe0f.png","sheet_x":39,"sheet_y":51,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Woman Shrugging","b":"1F937-200D-2640-FE0F","c":"1F937-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[39,46],"o":9},"flag-td":{"a":"Chad Flag","b":"1F1F9-1F1E9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,44]},"massage":{"skin_variations":{"1F3FB":{"unified":"1F486-1F3FB","non_qualified":null,"image":"1f486-1f3fb.png","sheet_x":24,"sheet_y":11,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FC":{"unified":"1F486-1F3FC","non_qualified":null,"image":"1f486-1f3fc.png","sheet_x":24,"sheet_y":12,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FD":{"unified":"1F486-1F3FD","non_qualified":null,"image":"1f486-1f3fd.png","sheet_x":24,"sheet_y":13,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FE":{"unified":"1F486-1F3FE","non_qualified":null,"image":"1f486-1f3fe.png","sheet_x":24,"sheet_y":14,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FF":{"unified":"1F486-1F3FF","non_qualified":null,"image":"1f486-1f3ff.png","sheet_x":24,"sheet_y":15,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true}},"obsoleted_by":"1F486-200D-2640-FE0F","a":"Face Massage","b":"1F486","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[24,10]},"flag-tf":{"a":"French Southern Territories Flag","b":"1F1F9-1F1EB","d":true,"e":false,"f":true,"g":true,"h":true,"i":true,"k":[4,45]},"man-getting-massage":{"skin_variations":{"1F3FB":{"unified":"1F486-1F3FB-200D-2642-FE0F","non_qualified":"1F486-1F3FB-200D-2642","image":"1f486-1f3fb-200d-2642-fe0f.png","sheet_x":24,"sheet_y":5,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F486-1F3FC-200D-2642-FE0F","non_qualified":"1F486-1F3FC-200D-2642","image":"1f486-1f3fc-200d-2642-fe0f.png","sheet_x":24,"sheet_y":6,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F486-1F3FD-200D-2642-FE0F","non_qualified":"1F486-1F3FD-200D-2642","image":"1f486-1f3fd-200d-2642-fe0f.png","sheet_x":24,"sheet_y":7,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F486-1F3FE-200D-2642-FE0F","non_qualified":"1F486-1F3FE-200D-2642","image":"1f486-1f3fe-200d-2642-fe0f.png","sheet_x":24,"sheet_y":8,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F486-1F3FF-200D-2642-FE0F","non_qualified":"1F486-1F3FF-200D-2642","image":"1f486-1f3ff-200d-2642-fe0f.png","sheet_x":24,"sheet_y":9,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Man Getting Massage","b":"1F486-200D-2642-FE0F","c":"1F486-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[24,4]},"flag-tg":{"a":"Togo Flag","b":"1F1F9-1F1EC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,46]},"woman-getting-massage":{"skin_variations":{"1F3FB":{"unified":"1F486-1F3FB-200D-2640-FE0F","non_qualified":"1F486-1F3FB-200D-2640","image":"1f486-1f3fb-200d-2640-fe0f.png","sheet_x":23,"sheet_y":51,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F486-1F3FC-200D-2640-FE0F","non_qualified":"1F486-1F3FC-200D-2640","image":"1f486-1f3fc-200d-2640-fe0f.png","sheet_x":24,"sheet_y":0,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F486-1F3FD-200D-2640-FE0F","non_qualified":"1F486-1F3FD-200D-2640","image":"1f486-1f3fd-200d-2640-fe0f.png","sheet_x":24,"sheet_y":1,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F486-1F3FE-200D-2640-FE0F","non_qualified":"1F486-1F3FE-200D-2640","image":"1f486-1f3fe-200d-2640-fe0f.png","sheet_x":24,"sheet_y":2,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F486-1F3FF-200D-2640-FE0F","non_qualified":"1F486-1F3FF-200D-2640","image":"1f486-1f3ff-200d-2640-fe0f.png","sheet_x":24,"sheet_y":3,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F486","a":"Woman Getting Massage","b":"1F486-200D-2640-FE0F","c":"1F486-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[23,50]},"flag-th":{"a":"Thailand Flag","b":"1F1F9-1F1ED","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,47]},"haircut":{"skin_variations":{"1F3FB":{"unified":"1F487-1F3FB","non_qualified":null,"image":"1f487-1f3fb.png","sheet_x":24,"sheet_y":29,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FC":{"unified":"1F487-1F3FC","non_qualified":null,"image":"1f487-1f3fc.png","sheet_x":24,"sheet_y":30,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FD":{"unified":"1F487-1F3FD","non_qualified":null,"image":"1f487-1f3fd.png","sheet_x":24,"sheet_y":31,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FE":{"unified":"1F487-1F3FE","non_qualified":null,"image":"1f487-1f3fe.png","sheet_x":24,"sheet_y":32,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FF":{"unified":"1F487-1F3FF","non_qualified":null,"image":"1f487-1f3ff.png","sheet_x":24,"sheet_y":33,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true}},"obsoleted_by":"1F487-200D-2640-FE0F","a":"Haircut","b":"1F487","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[24,28]},"flag-tj":{"a":"Tajikistan Flag","b":"1F1F9-1F1EF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,48]},"man-getting-haircut":{"skin_variations":{"1F3FB":{"unified":"1F487-1F3FB-200D-2642-FE0F","non_qualified":"1F487-1F3FB-200D-2642","image":"1f487-1f3fb-200d-2642-fe0f.png","sheet_x":24,"sheet_y":23,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F487-1F3FC-200D-2642-FE0F","non_qualified":"1F487-1F3FC-200D-2642","image":"1f487-1f3fc-200d-2642-fe0f.png","sheet_x":24,"sheet_y":24,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F487-1F3FD-200D-2642-FE0F","non_qualified":"1F487-1F3FD-200D-2642","image":"1f487-1f3fd-200d-2642-fe0f.png","sheet_x":24,"sheet_y":25,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F487-1F3FE-200D-2642-FE0F","non_qualified":"1F487-1F3FE-200D-2642","image":"1f487-1f3fe-200d-2642-fe0f.png","sheet_x":24,"sheet_y":26,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F487-1F3FF-200D-2642-FE0F","non_qualified":"1F487-1F3FF-200D-2642","image":"1f487-1f3ff-200d-2642-fe0f.png","sheet_x":24,"sheet_y":27,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Man Getting Haircut","b":"1F487-200D-2642-FE0F","c":"1F487-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[24,22]},"flag-tk":{"a":"Tokelau Flag","b":"1F1F9-1F1F0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,49]},"woman-getting-haircut":{"skin_variations":{"1F3FB":{"unified":"1F487-1F3FB-200D-2640-FE0F","non_qualified":"1F487-1F3FB-200D-2640","image":"1f487-1f3fb-200d-2640-fe0f.png","sheet_x":24,"sheet_y":17,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F487-1F3FC-200D-2640-FE0F","non_qualified":"1F487-1F3FC-200D-2640","image":"1f487-1f3fc-200d-2640-fe0f.png","sheet_x":24,"sheet_y":18,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F487-1F3FD-200D-2640-FE0F","non_qualified":"1F487-1F3FD-200D-2640","image":"1f487-1f3fd-200d-2640-fe0f.png","sheet_x":24,"sheet_y":19,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F487-1F3FE-200D-2640-FE0F","non_qualified":"1F487-1F3FE-200D-2640","image":"1f487-1f3fe-200d-2640-fe0f.png","sheet_x":24,"sheet_y":20,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F487-1F3FF-200D-2640-FE0F","non_qualified":"1F487-1F3FF-200D-2640","image":"1f487-1f3ff-200d-2640-fe0f.png","sheet_x":24,"sheet_y":21,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F487","a":"Woman Getting Haircut","b":"1F487-200D-2640-FE0F","c":"1F487-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[24,16]},"flag-tl":{"a":"Timor-Leste Flag","b":"1F1F9-1F1F1","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,50]},"walking":{"skin_variations":{"1F3FB":{"unified":"1F6B6-1F3FB","non_qualified":null,"image":"1f6b6-1f3fb.png","sheet_x":36,"sheet_y":22,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FC":{"unified":"1F6B6-1F3FC","non_qualified":null,"image":"1f6b6-1f3fc.png","sheet_x":36,"sheet_y":23,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FD":{"unified":"1F6B6-1F3FD","non_qualified":null,"image":"1f6b6-1f3fd.png","sheet_x":36,"sheet_y":24,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FE":{"unified":"1F6B6-1F3FE","non_qualified":null,"image":"1f6b6-1f3fe.png","sheet_x":36,"sheet_y":25,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FF":{"unified":"1F6B6-1F3FF","non_qualified":null,"image":"1f6b6-1f3ff.png","sheet_x":36,"sheet_y":26,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true}},"obsoleted_by":"1F6B6-200D-2642-FE0F","a":"Pedestrian","b":"1F6B6","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[36,21]},"flag-tm":{"a":"Turkmenistan Flag","b":"1F1F9-1F1F2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[4,51]},"man-walking":{"skin_variations":{"1F3FB":{"unified":"1F6B6-1F3FB-200D-2642-FE0F","non_qualified":"1F6B6-1F3FB-200D-2642","image":"1f6b6-1f3fb-200d-2642-fe0f.png","sheet_x":36,"sheet_y":16,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F6B6-1F3FC-200D-2642-FE0F","non_qualified":"1F6B6-1F3FC-200D-2642","image":"1f6b6-1f3fc-200d-2642-fe0f.png","sheet_x":36,"sheet_y":17,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F6B6-1F3FD-200D-2642-FE0F","non_qualified":"1F6B6-1F3FD-200D-2642","image":"1f6b6-1f3fd-200d-2642-fe0f.png","sheet_x":36,"sheet_y":18,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F6B6-1F3FE-200D-2642-FE0F","non_qualified":"1F6B6-1F3FE-200D-2642","image":"1f6b6-1f3fe-200d-2642-fe0f.png","sheet_x":36,"sheet_y":19,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F6B6-1F3FF-200D-2642-FE0F","non_qualified":"1F6B6-1F3FF-200D-2642","image":"1f6b6-1f3ff-200d-2642-fe0f.png","sheet_x":36,"sheet_y":20,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F6B6","a":"Man Walking","b":"1F6B6-200D-2642-FE0F","c":"1F6B6-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[36,15]},"flag-tn":{"a":"Tunisia Flag","b":"1F1F9-1F1F3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,0]},"woman-walking":{"skin_variations":{"1F3FB":{"unified":"1F6B6-1F3FB-200D-2640-FE0F","non_qualified":"1F6B6-1F3FB-200D-2640","image":"1f6b6-1f3fb-200d-2640-fe0f.png","sheet_x":36,"sheet_y":10,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F6B6-1F3FC-200D-2640-FE0F","non_qualified":"1F6B6-1F3FC-200D-2640","image":"1f6b6-1f3fc-200d-2640-fe0f.png","sheet_x":36,"sheet_y":11,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F6B6-1F3FD-200D-2640-FE0F","non_qualified":"1F6B6-1F3FD-200D-2640","image":"1f6b6-1f3fd-200d-2640-fe0f.png","sheet_x":36,"sheet_y":12,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F6B6-1F3FE-200D-2640-FE0F","non_qualified":"1F6B6-1F3FE-200D-2640","image":"1f6b6-1f3fe-200d-2640-fe0f.png","sheet_x":36,"sheet_y":13,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F6B6-1F3FF-200D-2640-FE0F","non_qualified":"1F6B6-1F3FF-200D-2640","image":"1f6b6-1f3ff-200d-2640-fe0f.png","sheet_x":36,"sheet_y":14,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Woman Walking","b":"1F6B6-200D-2640-FE0F","c":"1F6B6-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[36,9]},"flag-to":{"a":"Tonga Flag","b":"1F1F9-1F1F4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,1]},"runner":{"skin_variations":{"1F3FB":{"unified":"1F3C3-1F3FB","non_qualified":null,"image":"1f3c3-1f3fb.png","sheet_x":9,"sheet_y":47,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FC":{"unified":"1F3C3-1F3FC","non_qualified":null,"image":"1f3c3-1f3fc.png","sheet_x":9,"sheet_y":48,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FD":{"unified":"1F3C3-1F3FD","non_qualified":null,"image":"1f3c3-1f3fd.png","sheet_x":9,"sheet_y":49,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FE":{"unified":"1F3C3-1F3FE","non_qualified":null,"image":"1f3c3-1f3fe.png","sheet_x":9,"sheet_y":50,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FF":{"unified":"1F3C3-1F3FF","non_qualified":null,"image":"1f3c3-1f3ff.png","sheet_x":9,"sheet_y":51,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true}},"obsoleted_by":"1F3C3-200D-2642-FE0F","a":"Runner","b":"1F3C3","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[9,46],"n":["running"]},"flag-tr":{"a":"Turkey Flag","b":"1F1F9-1F1F7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,2]},"man-running":{"skin_variations":{"1F3FB":{"unified":"1F3C3-1F3FB-200D-2642-FE0F","non_qualified":"1F3C3-1F3FB-200D-2642","image":"1f3c3-1f3fb-200d-2642-fe0f.png","sheet_x":9,"sheet_y":41,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F3C3-1F3FC-200D-2642-FE0F","non_qualified":"1F3C3-1F3FC-200D-2642","image":"1f3c3-1f3fc-200d-2642-fe0f.png","sheet_x":9,"sheet_y":42,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F3C3-1F3FD-200D-2642-FE0F","non_qualified":"1F3C3-1F3FD-200D-2642","image":"1f3c3-1f3fd-200d-2642-fe0f.png","sheet_x":9,"sheet_y":43,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F3C3-1F3FE-200D-2642-FE0F","non_qualified":"1F3C3-1F3FE-200D-2642","image":"1f3c3-1f3fe-200d-2642-fe0f.png","sheet_x":9,"sheet_y":44,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F3C3-1F3FF-200D-2642-FE0F","non_qualified":"1F3C3-1F3FF-200D-2642","image":"1f3c3-1f3ff-200d-2642-fe0f.png","sheet_x":9,"sheet_y":45,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F3C3","a":"Man Running","b":"1F3C3-200D-2642-FE0F","c":"1F3C3-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[9,40]},"flag-tt":{"a":"Trinidad & Tobago Flag","b":"1F1F9-1F1F9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,3]},"woman-running":{"skin_variations":{"1F3FB":{"unified":"1F3C3-1F3FB-200D-2640-FE0F","non_qualified":"1F3C3-1F3FB-200D-2640","image":"1f3c3-1f3fb-200d-2640-fe0f.png","sheet_x":9,"sheet_y":35,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F3C3-1F3FC-200D-2640-FE0F","non_qualified":"1F3C3-1F3FC-200D-2640","image":"1f3c3-1f3fc-200d-2640-fe0f.png","sheet_x":9,"sheet_y":36,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F3C3-1F3FD-200D-2640-FE0F","non_qualified":"1F3C3-1F3FD-200D-2640","image":"1f3c3-1f3fd-200d-2640-fe0f.png","sheet_x":9,"sheet_y":37,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F3C3-1F3FE-200D-2640-FE0F","non_qualified":"1F3C3-1F3FE-200D-2640","image":"1f3c3-1f3fe-200d-2640-fe0f.png","sheet_x":9,"sheet_y":38,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F3C3-1F3FF-200D-2640-FE0F","non_qualified":"1F3C3-1F3FF-200D-2640","image":"1f3c3-1f3ff-200d-2640-fe0f.png","sheet_x":9,"sheet_y":39,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Woman Running","b":"1F3C3-200D-2640-FE0F","c":"1F3C3-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[9,34]},"flag-tv":{"a":"Tuvalu Flag","b":"1F1F9-1F1FB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,4]},"dancer":{"skin_variations":{"1F3FB":{"unified":"1F483-1F3FB","non_qualified":null,"image":"1f483-1f3fb.png","sheet_x":23,"sheet_y":38,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F483-1F3FC","non_qualified":null,"image":"1f483-1f3fc.png","sheet_x":23,"sheet_y":39,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F483-1F3FD","non_qualified":null,"image":"1f483-1f3fd.png","sheet_x":23,"sheet_y":40,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F483-1F3FE","non_qualified":null,"image":"1f483-1f3fe.png","sheet_x":23,"sheet_y":41,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F483-1F3FF","non_qualified":null,"image":"1f483-1f3ff.png","sheet_x":23,"sheet_y":42,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Dancer","b":"1F483","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["female","girl","woman","fun"],"k":[23,37]},"flag-tw":{"a":"Taiwan Flag","b":"1F1F9-1F1FC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,5]},"man_dancing":{"skin_variations":{"1F3FB":{"unified":"1F57A-1F3FB","non_qualified":null,"image":"1f57a-1f3fb.png","sheet_x":29,"sheet_y":22,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F57A-1F3FC","non_qualified":null,"image":"1f57a-1f3fc.png","sheet_x":29,"sheet_y":23,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F57A-1F3FD","non_qualified":null,"image":"1f57a-1f3fd.png","sheet_x":29,"sheet_y":24,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F57A-1F3FE","non_qualified":null,"image":"1f57a-1f3fe.png","sheet_x":29,"sheet_y":25,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F57A-1F3FF","non_qualified":null,"image":"1f57a-1f3ff.png","sheet_x":29,"sheet_y":26,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Man Dancing","b":"1F57A","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["male","boy","fun","dancer"],"k":[29,21],"o":9},"flag-tz":{"a":"Tanzania Flag","b":"1F1F9-1F1FF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,6]},"dancers":{"obsoleted_by":"1F46F-200D-2640-FE0F","a":"Woman with Bunny Ears","b":"1F46F","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[21,1]},"flag-ua":{"a":"Ukraine Flag","b":"1F1FA-1F1E6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,7]},"man-with-bunny-ears-partying":{"a":"Man with Bunny Ears Partying","b":"1F46F-200D-2642-FE0F","c":"1F46F-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[21,0]},"flag-ug":{"a":"Uganda Flag","b":"1F1FA-1F1EC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,8]},"woman-with-bunny-ears-partying":{"obsoletes":"1F46F","a":"Woman with Bunny Ears Partying","b":"1F46F-200D-2640-FE0F","c":"1F46F-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[20,51]},"flag-um":{"a":"U.s. Outlying Islands Flag","b":"1F1FA-1F1F2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,9]},"person_in_steamy_room":{"skin_variations":{"1F3FB":{"unified":"1F9D6-1F3FB","non_qualified":null,"image":"1f9d6-1f3fb.png","sheet_x":43,"sheet_y":41,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9D6-1F3FB-200D-2642-FE0F"},"1F3FC":{"unified":"1F9D6-1F3FC","non_qualified":null,"image":"1f9d6-1f3fc.png","sheet_x":43,"sheet_y":42,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9D6-1F3FC-200D-2642-FE0F"},"1F3FD":{"unified":"1F9D6-1F3FD","non_qualified":null,"image":"1f9d6-1f3fd.png","sheet_x":43,"sheet_y":43,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9D6-1F3FD-200D-2642-FE0F"},"1F3FE":{"unified":"1F9D6-1F3FE","non_qualified":null,"image":"1f9d6-1f3fe.png","sheet_x":43,"sheet_y":44,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9D6-1F3FE-200D-2642-FE0F"},"1F3FF":{"unified":"1F9D6-1F3FF","non_qualified":null,"image":"1f9d6-1f3ff.png","sheet_x":43,"sheet_y":45,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9D6-1F3FF-200D-2642-FE0F"}},"obsoleted_by":"1F9D6-200D-2642-FE0F","a":"Person in Steamy Room","b":"1F9D6","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[43,40],"o":10},"flag-un":{"a":"United Nations Flag","b":"1F1FA-1F1F3","d":false,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[5,10]},"woman_in_steamy_room":{"skin_variations":{"1F3FB":{"unified":"1F9D6-1F3FB-200D-2640-FE0F","non_qualified":"1F9D6-1F3FB-200D-2640","image":"1f9d6-1f3fb-200d-2640-fe0f.png","sheet_x":43,"sheet_y":29,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F9D6-1F3FC-200D-2640-FE0F","non_qualified":"1F9D6-1F3FC-200D-2640","image":"1f9d6-1f3fc-200d-2640-fe0f.png","sheet_x":43,"sheet_y":30,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F9D6-1F3FD-200D-2640-FE0F","non_qualified":"1F9D6-1F3FD-200D-2640","image":"1f9d6-1f3fd-200d-2640-fe0f.png","sheet_x":43,"sheet_y":31,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F9D6-1F3FE-200D-2640-FE0F","non_qualified":"1F9D6-1F3FE-200D-2640","image":"1f9d6-1f3fe-200d-2640-fe0f.png","sheet_x":43,"sheet_y":32,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F9D6-1F3FF-200D-2640-FE0F","non_qualified":"1F9D6-1F3FF-200D-2640","image":"1f9d6-1f3ff-200d-2640-fe0f.png","sheet_x":43,"sheet_y":33,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Woman in Steamy Room","b":"1F9D6-200D-2640-FE0F","c":"1F9D6-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["female","woman","spa","steamroom","sauna"],"k":[43,28],"o":10},"us":{"a":"United States Flag","b":"1F1FA-1F1F8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["united","states","america","flag","nation","country","banner"],"k":[5,11],"n":["flag-us"]},"man_in_steamy_room":{"skin_variations":{"1F3FB":{"unified":"1F9D6-1F3FB-200D-2642-FE0F","non_qualified":"1F9D6-1F3FB-200D-2642","image":"1f9d6-1f3fb-200d-2642-fe0f.png","sheet_x":43,"sheet_y":35,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9D6-1F3FB"},"1F3FC":{"unified":"1F9D6-1F3FC-200D-2642-FE0F","non_qualified":"1F9D6-1F3FC-200D-2642","image":"1f9d6-1f3fc-200d-2642-fe0f.png","sheet_x":43,"sheet_y":36,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9D6-1F3FC"},"1F3FD":{"unified":"1F9D6-1F3FD-200D-2642-FE0F","non_qualified":"1F9D6-1F3FD-200D-2642","image":"1f9d6-1f3fd-200d-2642-fe0f.png","sheet_x":43,"sheet_y":37,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9D6-1F3FD"},"1F3FE":{"unified":"1F9D6-1F3FE-200D-2642-FE0F","non_qualified":"1F9D6-1F3FE-200D-2642","image":"1f9d6-1f3fe-200d-2642-fe0f.png","sheet_x":43,"sheet_y":38,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9D6-1F3FE"},"1F3FF":{"unified":"1F9D6-1F3FF-200D-2642-FE0F","non_qualified":"1F9D6-1F3FF-200D-2642","image":"1f9d6-1f3ff-200d-2642-fe0f.png","sheet_x":43,"sheet_y":39,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9D6-1F3FF"}},"obsoletes":"1F9D6","a":"Man in Steamy Room","b":"1F9D6-200D-2642-FE0F","c":"1F9D6-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["male","man","spa","steamroom","sauna"],"k":[43,34],"o":10},"flag-uy":{"a":"Uruguay Flag","b":"1F1FA-1F1FE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,12]},"person_climbing":{"skin_variations":{"1F3FB":{"unified":"1F9D7-1F3FB","non_qualified":null,"image":"1f9d7-1f3fb.png","sheet_x":44,"sheet_y":7,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9D7-1F3FB-200D-2640-FE0F"},"1F3FC":{"unified":"1F9D7-1F3FC","non_qualified":null,"image":"1f9d7-1f3fc.png","sheet_x":44,"sheet_y":8,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9D7-1F3FC-200D-2640-FE0F"},"1F3FD":{"unified":"1F9D7-1F3FD","non_qualified":null,"image":"1f9d7-1f3fd.png","sheet_x":44,"sheet_y":9,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9D7-1F3FD-200D-2640-FE0F"},"1F3FE":{"unified":"1F9D7-1F3FE","non_qualified":null,"image":"1f9d7-1f3fe.png","sheet_x":44,"sheet_y":10,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9D7-1F3FE-200D-2640-FE0F"},"1F3FF":{"unified":"1F9D7-1F3FF","non_qualified":null,"image":"1f9d7-1f3ff.png","sheet_x":44,"sheet_y":11,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9D7-1F3FF-200D-2640-FE0F"}},"obsoleted_by":"1F9D7-200D-2640-FE0F","a":"Person Climbing","b":"1F9D7","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[44,6],"o":10},"flag-uz":{"a":"Uzbekistan Flag","b":"1F1FA-1F1FF","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,13]},"woman_climbing":{"skin_variations":{"1F3FB":{"unified":"1F9D7-1F3FB-200D-2640-FE0F","non_qualified":"1F9D7-1F3FB-200D-2640","image":"1f9d7-1f3fb-200d-2640-fe0f.png","sheet_x":43,"sheet_y":47,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9D7-1F3FB"},"1F3FC":{"unified":"1F9D7-1F3FC-200D-2640-FE0F","non_qualified":"1F9D7-1F3FC-200D-2640","image":"1f9d7-1f3fc-200d-2640-fe0f.png","sheet_x":43,"sheet_y":48,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9D7-1F3FC"},"1F3FD":{"unified":"1F9D7-1F3FD-200D-2640-FE0F","non_qualified":"1F9D7-1F3FD-200D-2640","image":"1f9d7-1f3fd-200d-2640-fe0f.png","sheet_x":43,"sheet_y":49,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9D7-1F3FD"},"1F3FE":{"unified":"1F9D7-1F3FE-200D-2640-FE0F","non_qualified":"1F9D7-1F3FE-200D-2640","image":"1f9d7-1f3fe-200d-2640-fe0f.png","sheet_x":43,"sheet_y":50,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9D7-1F3FE"},"1F3FF":{"unified":"1F9D7-1F3FF-200D-2640-FE0F","non_qualified":"1F9D7-1F3FF-200D-2640","image":"1f9d7-1f3ff-200d-2640-fe0f.png","sheet_x":43,"sheet_y":51,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9D7-1F3FF"}},"obsoletes":"1F9D7","a":"Woman Climbing","b":"1F9D7-200D-2640-FE0F","c":"1F9D7-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[43,46],"o":10},"flag-va":{"a":"Vatican City Flag","b":"1F1FB-1F1E6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,14]},"man_climbing":{"skin_variations":{"1F3FB":{"unified":"1F9D7-1F3FB-200D-2642-FE0F","non_qualified":"1F9D7-1F3FB-200D-2642","image":"1f9d7-1f3fb-200d-2642-fe0f.png","sheet_x":44,"sheet_y":1,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F9D7-1F3FC-200D-2642-FE0F","non_qualified":"1F9D7-1F3FC-200D-2642","image":"1f9d7-1f3fc-200d-2642-fe0f.png","sheet_x":44,"sheet_y":2,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F9D7-1F3FD-200D-2642-FE0F","non_qualified":"1F9D7-1F3FD-200D-2642","image":"1f9d7-1f3fd-200d-2642-fe0f.png","sheet_x":44,"sheet_y":3,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F9D7-1F3FE-200D-2642-FE0F","non_qualified":"1F9D7-1F3FE-200D-2642","image":"1f9d7-1f3fe-200d-2642-fe0f.png","sheet_x":44,"sheet_y":4,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F9D7-1F3FF-200D-2642-FE0F","non_qualified":"1F9D7-1F3FF-200D-2642","image":"1f9d7-1f3ff-200d-2642-fe0f.png","sheet_x":44,"sheet_y":5,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Man Climbing","b":"1F9D7-200D-2642-FE0F","c":"1F9D7-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[44,0],"o":10},"flag-vc":{"a":"St. Vincent & Grenadines Flag","b":"1F1FB-1F1E8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,15]},"person_in_lotus_position":{"skin_variations":{"1F3FB":{"unified":"1F9D8-1F3FB","non_qualified":null,"image":"1f9d8-1f3fb.png","sheet_x":44,"sheet_y":25,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9D8-1F3FB-200D-2640-FE0F"},"1F3FC":{"unified":"1F9D8-1F3FC","non_qualified":null,"image":"1f9d8-1f3fc.png","sheet_x":44,"sheet_y":26,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9D8-1F3FC-200D-2640-FE0F"},"1F3FD":{"unified":"1F9D8-1F3FD","non_qualified":null,"image":"1f9d8-1f3fd.png","sheet_x":44,"sheet_y":27,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9D8-1F3FD-200D-2640-FE0F"},"1F3FE":{"unified":"1F9D8-1F3FE","non_qualified":null,"image":"1f9d8-1f3fe.png","sheet_x":44,"sheet_y":28,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9D8-1F3FE-200D-2640-FE0F"},"1F3FF":{"unified":"1F9D8-1F3FF","non_qualified":null,"image":"1f9d8-1f3ff.png","sheet_x":44,"sheet_y":29,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false,"obsoleted_by":"1F9D8-1F3FF-200D-2640-FE0F"}},"obsoleted_by":"1F9D8-200D-2640-FE0F","a":"Person in Lotus Position","b":"1F9D8","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[44,24],"o":10},"flag-ve":{"a":"Venezuela Flag","b":"1F1FB-1F1EA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,16]},"woman_in_lotus_position":{"skin_variations":{"1F3FB":{"unified":"1F9D8-1F3FB-200D-2640-FE0F","non_qualified":"1F9D8-1F3FB-200D-2640","image":"1f9d8-1f3fb-200d-2640-fe0f.png","sheet_x":44,"sheet_y":13,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9D8-1F3FB"},"1F3FC":{"unified":"1F9D8-1F3FC-200D-2640-FE0F","non_qualified":"1F9D8-1F3FC-200D-2640","image":"1f9d8-1f3fc-200d-2640-fe0f.png","sheet_x":44,"sheet_y":14,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9D8-1F3FC"},"1F3FD":{"unified":"1F9D8-1F3FD-200D-2640-FE0F","non_qualified":"1F9D8-1F3FD-200D-2640","image":"1f9d8-1f3fd-200d-2640-fe0f.png","sheet_x":44,"sheet_y":15,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9D8-1F3FD"},"1F3FE":{"unified":"1F9D8-1F3FE-200D-2640-FE0F","non_qualified":"1F9D8-1F3FE-200D-2640","image":"1f9d8-1f3fe-200d-2640-fe0f.png","sheet_x":44,"sheet_y":16,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9D8-1F3FE"},"1F3FF":{"unified":"1F9D8-1F3FF-200D-2640-FE0F","non_qualified":"1F9D8-1F3FF-200D-2640","image":"1f9d8-1f3ff-200d-2640-fe0f.png","sheet_x":44,"sheet_y":17,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false,"obsoletes":"1F9D8-1F3FF"}},"obsoletes":"1F9D8","a":"Woman in Lotus Position","b":"1F9D8-200D-2640-FE0F","c":"1F9D8-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["woman","female","meditation","yoga","serenity","zen","mindfulness"],"k":[44,12],"o":10},"flag-vg":{"a":"British Virgin Islands Flag","b":"1F1FB-1F1EC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,17]},"man_in_lotus_position":{"skin_variations":{"1F3FB":{"unified":"1F9D8-1F3FB-200D-2642-FE0F","non_qualified":"1F9D8-1F3FB-200D-2642","image":"1f9d8-1f3fb-200d-2642-fe0f.png","sheet_x":44,"sheet_y":19,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F9D8-1F3FC-200D-2642-FE0F","non_qualified":"1F9D8-1F3FC-200D-2642","image":"1f9d8-1f3fc-200d-2642-fe0f.png","sheet_x":44,"sheet_y":20,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F9D8-1F3FD-200D-2642-FE0F","non_qualified":"1F9D8-1F3FD-200D-2642","image":"1f9d8-1f3fd-200d-2642-fe0f.png","sheet_x":44,"sheet_y":21,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F9D8-1F3FE-200D-2642-FE0F","non_qualified":"1F9D8-1F3FE-200D-2642","image":"1f9d8-1f3fe-200d-2642-fe0f.png","sheet_x":44,"sheet_y":22,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F9D8-1F3FF-200D-2642-FE0F","non_qualified":"1F9D8-1F3FF-200D-2642","image":"1f9d8-1f3ff-200d-2642-fe0f.png","sheet_x":44,"sheet_y":23,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Man in Lotus Position","b":"1F9D8-200D-2642-FE0F","c":"1F9D8-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["man","male","meditation","yoga","serenity","zen","mindfulness"],"k":[44,18],"o":10},"flag-vi":{"a":"U.s. Virgin Islands Flag","b":"1F1FB-1F1EE","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,18]},"bath":{"skin_variations":{"1F3FB":{"unified":"1F6C0-1F3FB","non_qualified":null,"image":"1f6c0-1f3fb.png","sheet_x":36,"sheet_y":37,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F6C0-1F3FC","non_qualified":null,"image":"1f6c0-1f3fc.png","sheet_x":36,"sheet_y":38,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F6C0-1F3FD","non_qualified":null,"image":"1f6c0-1f3fd.png","sheet_x":36,"sheet_y":39,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F6C0-1F3FE","non_qualified":null,"image":"1f6c0-1f3fe.png","sheet_x":36,"sheet_y":40,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F6C0-1F3FF","non_qualified":null,"image":"1f6c0-1f3ff.png","sheet_x":36,"sheet_y":41,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Bath","b":"1F6C0","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["clean","shower","bathroom"],"k":[36,36]},"flag-vn":{"a":"Vietnam Flag","b":"1F1FB-1F1F3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,19]},"sleeping_accommodation":{"skin_variations":{"1F3FB":{"unified":"1F6CC-1F3FB","non_qualified":null,"image":"1f6cc-1f3fb.png","sheet_x":36,"sheet_y":49,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F6CC-1F3FC","non_qualified":null,"image":"1f6cc-1f3fc.png","sheet_x":36,"sheet_y":50,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F6CC-1F3FD","non_qualified":null,"image":"1f6cc-1f3fd.png","sheet_x":36,"sheet_y":51,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F6CC-1F3FE","non_qualified":null,"image":"1f6cc-1f3fe.png","sheet_x":37,"sheet_y":0,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F6CC-1F3FF","non_qualified":null,"image":"1f6cc-1f3ff.png","sheet_x":37,"sheet_y":1,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Sleeping Accommodation","b":"1F6CC","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[36,48],"o":7},"flag-vu":{"a":"Vanuatu Flag","b":"1F1FB-1F1FA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,20]},"man_in_business_suit_levitating":{"skin_variations":{"1F3FB":{"unified":"1F574-1F3FB","non_qualified":null,"image":"1f574-1f3fb.png","sheet_x":28,"sheet_y":46,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F574-1F3FC","non_qualified":null,"image":"1f574-1f3fc.png","sheet_x":28,"sheet_y":47,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F574-1F3FD","non_qualified":null,"image":"1f574-1f3fd.png","sheet_x":28,"sheet_y":48,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F574-1F3FE","non_qualified":null,"image":"1f574-1f3fe.png","sheet_x":28,"sheet_y":49,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F574-1F3FF","non_qualified":null,"image":"1f574-1f3ff.png","sheet_x":28,"sheet_y":50,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Man in Business Suit Levitating","b":"1F574-FE0F","c":"1F574","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[28,45],"o":7},"flag-wf":{"a":"Wallis & Futuna Flag","b":"1F1FC-1F1EB","d":true,"e":false,"f":true,"g":true,"h":true,"i":true,"k":[5,21]},"speaking_head_in_silhouette":{"a":"Speaking Head in Silhouette","b":"1F5E3-FE0F","c":"1F5E3","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[30,14],"o":7},"flag-ws":{"a":"Samoa Flag","b":"1F1FC-1F1F8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,22]},"bust_in_silhouette":{"a":"Bust in Silhouette","b":"1F464","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["user","person","human"],"k":[15,40]},"flag-xk":{"a":"Kosovo Flag","b":"1F1FD-1F1F0","d":true,"e":false,"f":true,"g":true,"h":true,"i":true,"k":[5,23]},"busts_in_silhouette":{"a":"Busts in Silhouette","b":"1F465","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["user","person","human","group","team"],"k":[15,41]},"flag-ye":{"a":"Yemen Flag","b":"1F1FE-1F1EA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,24]},"fencer":{"a":"Fencer","b":"1F93A","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[40,48],"o":9},"flag-yt":{"a":"Mayotte Flag","b":"1F1FE-1F1F9","d":true,"e":false,"f":true,"g":true,"h":true,"i":true,"k":[5,25]},"horse_racing":{"skin_variations":{"1F3FB":{"unified":"1F3C7-1F3FB","non_qualified":null,"image":"1f3c7-1f3fb.png","sheet_x":10,"sheet_y":21,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F3C7-1F3FC","non_qualified":null,"image":"1f3c7-1f3fc.png","sheet_x":10,"sheet_y":22,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F3C7-1F3FD","non_qualified":null,"image":"1f3c7-1f3fd.png","sheet_x":10,"sheet_y":23,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F3C7-1F3FE","non_qualified":null,"image":"1f3c7-1f3fe.png","sheet_x":10,"sheet_y":24,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F3C7-1F3FF","non_qualified":null,"image":"1f3c7-1f3ff.png","sheet_x":10,"sheet_y":25,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Horse Racing","b":"1F3C7","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["animal","betting","competition","gambling","luck"],"k":[10,20]},"flag-za":{"a":"South Africa Flag","b":"1F1FF-1F1E6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,26]},"skier":{"a":"Skier","b":"26F7-FE0F","c":"26F7","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["sports","winter","snow"],"k":[48,44],"o":5},"flag-zm":{"a":"Zambia Flag","b":"1F1FF-1F1F2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,27]},"snowboarder":{"skin_variations":{"1F3FB":{"unified":"1F3C2-1F3FB","non_qualified":null,"image":"1f3c2-1f3fb.png","sheet_x":9,"sheet_y":29,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F3C2-1F3FC","non_qualified":null,"image":"1f3c2-1f3fc.png","sheet_x":9,"sheet_y":30,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F3C2-1F3FD","non_qualified":null,"image":"1f3c2-1f3fd.png","sheet_x":9,"sheet_y":31,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F3C2-1F3FE","non_qualified":null,"image":"1f3c2-1f3fe.png","sheet_x":9,"sheet_y":32,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F3C2-1F3FF","non_qualified":null,"image":"1f3c2-1f3ff.png","sheet_x":9,"sheet_y":33,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Snowboarder","b":"1F3C2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sports","winter"],"k":[9,28]},"flag-zw":{"a":"Zimbabwe Flag","b":"1F1FF-1F1FC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[5,28]},"golfer":{"skin_variations":{"1F3FB":{"unified":"1F3CC-1F3FB","non_qualified":null,"image":"1f3cc-1f3fb.png","sheet_x":11,"sheet_y":25,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F3CC-1F3FC","non_qualified":null,"image":"1f3cc-1f3fc.png","sheet_x":11,"sheet_y":26,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F3CC-1F3FD","non_qualified":null,"image":"1f3cc-1f3fd.png","sheet_x":11,"sheet_y":27,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F3CC-1F3FE","non_qualified":null,"image":"1f3cc-1f3fe.png","sheet_x":11,"sheet_y":28,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F3CC-1F3FF","non_qualified":null,"image":"1f3cc-1f3ff.png","sheet_x":11,"sheet_y":29,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoleted_by":"1F3CC-FE0F-200D-2642-FE0F","a":"Golfer","b":"1F3CC-FE0F","c":"1F3CC","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"k":[11,24],"o":7},"man-golfing":{"skin_variations":{"1F3FB":{"unified":"1F3CC-1F3FB-200D-2642-FE0F","non_qualified":"1F3CC-1F3FB-200D-2642","image":"1f3cc-1f3fb-200d-2642-fe0f.png","sheet_x":11,"sheet_y":19,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F3CC-1F3FC-200D-2642-FE0F","non_qualified":"1F3CC-1F3FC-200D-2642","image":"1f3cc-1f3fc-200d-2642-fe0f.png","sheet_x":11,"sheet_y":20,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F3CC-1F3FD-200D-2642-FE0F","non_qualified":"1F3CC-1F3FD-200D-2642","image":"1f3cc-1f3fd-200d-2642-fe0f.png","sheet_x":11,"sheet_y":21,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F3CC-1F3FE-200D-2642-FE0F","non_qualified":"1F3CC-1F3FE-200D-2642","image":"1f3cc-1f3fe-200d-2642-fe0f.png","sheet_x":11,"sheet_y":22,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F3CC-1F3FF-200D-2642-FE0F","non_qualified":"1F3CC-1F3FF-200D-2642","image":"1f3cc-1f3ff-200d-2642-fe0f.png","sheet_x":11,"sheet_y":23,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F3CC-FE0F","a":"Man Golfing","b":"1F3CC-FE0F-200D-2642-FE0F","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"k":[11,18],"o":7},"flag-england":{"a":"England Flag","b":"1F3F4-E0067-E0062-E0065-E006E-E0067-E007F","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[12,16],"o":7},"woman-golfing":{"skin_variations":{"1F3FB":{"unified":"1F3CC-1F3FB-200D-2640-FE0F","non_qualified":"1F3CC-1F3FB-200D-2640","image":"1f3cc-1f3fb-200d-2640-fe0f.png","sheet_x":11,"sheet_y":13,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F3CC-1F3FC-200D-2640-FE0F","non_qualified":"1F3CC-1F3FC-200D-2640","image":"1f3cc-1f3fc-200d-2640-fe0f.png","sheet_x":11,"sheet_y":14,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F3CC-1F3FD-200D-2640-FE0F","non_qualified":"1F3CC-1F3FD-200D-2640","image":"1f3cc-1f3fd-200d-2640-fe0f.png","sheet_x":11,"sheet_y":15,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F3CC-1F3FE-200D-2640-FE0F","non_qualified":"1F3CC-1F3FE-200D-2640","image":"1f3cc-1f3fe-200d-2640-fe0f.png","sheet_x":11,"sheet_y":16,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F3CC-1F3FF-200D-2640-FE0F","non_qualified":"1F3CC-1F3FF-200D-2640","image":"1f3cc-1f3ff-200d-2640-fe0f.png","sheet_x":11,"sheet_y":17,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Woman Golfing","b":"1F3CC-FE0F-200D-2640-FE0F","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"k":[11,12],"o":7},"flag-scotland":{"a":"Scotland Flag","b":"1F3F4-E0067-E0062-E0073-E0063-E0074-E007F","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[12,17],"o":7},"surfer":{"skin_variations":{"1F3FB":{"unified":"1F3C4-1F3FB","non_qualified":null,"image":"1f3c4-1f3fb.png","sheet_x":10,"sheet_y":13,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FC":{"unified":"1F3C4-1F3FC","non_qualified":null,"image":"1f3c4-1f3fc.png","sheet_x":10,"sheet_y":14,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FD":{"unified":"1F3C4-1F3FD","non_qualified":null,"image":"1f3c4-1f3fd.png","sheet_x":10,"sheet_y":15,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FE":{"unified":"1F3C4-1F3FE","non_qualified":null,"image":"1f3c4-1f3fe.png","sheet_x":10,"sheet_y":16,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FF":{"unified":"1F3C4-1F3FF","non_qualified":null,"image":"1f3c4-1f3ff.png","sheet_x":10,"sheet_y":17,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true}},"obsoleted_by":"1F3C4-200D-2642-FE0F","a":"Surfer","b":"1F3C4","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[10,12]},"flag-wales":{"a":"Wales Flag","b":"1F3F4-E0067-E0062-E0077-E006C-E0073-E007F","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[12,18],"o":7},"man-surfing":{"skin_variations":{"1F3FB":{"unified":"1F3C4-1F3FB-200D-2642-FE0F","non_qualified":"1F3C4-1F3FB-200D-2642","image":"1f3c4-1f3fb-200d-2642-fe0f.png","sheet_x":10,"sheet_y":7,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F3C4-1F3FC-200D-2642-FE0F","non_qualified":"1F3C4-1F3FC-200D-2642","image":"1f3c4-1f3fc-200d-2642-fe0f.png","sheet_x":10,"sheet_y":8,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F3C4-1F3FD-200D-2642-FE0F","non_qualified":"1F3C4-1F3FD-200D-2642","image":"1f3c4-1f3fd-200d-2642-fe0f.png","sheet_x":10,"sheet_y":9,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F3C4-1F3FE-200D-2642-FE0F","non_qualified":"1F3C4-1F3FE-200D-2642","image":"1f3c4-1f3fe-200d-2642-fe0f.png","sheet_x":10,"sheet_y":10,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F3C4-1F3FF-200D-2642-FE0F","non_qualified":"1F3C4-1F3FF-200D-2642","image":"1f3c4-1f3ff-200d-2642-fe0f.png","sheet_x":10,"sheet_y":11,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F3C4","a":"Man Surfing","b":"1F3C4-200D-2642-FE0F","c":"1F3C4-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[10,6]},"woman-surfing":{"skin_variations":{"1F3FB":{"unified":"1F3C4-1F3FB-200D-2640-FE0F","non_qualified":"1F3C4-1F3FB-200D-2640","image":"1f3c4-1f3fb-200d-2640-fe0f.png","sheet_x":10,"sheet_y":1,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F3C4-1F3FC-200D-2640-FE0F","non_qualified":"1F3C4-1F3FC-200D-2640","image":"1f3c4-1f3fc-200d-2640-fe0f.png","sheet_x":10,"sheet_y":2,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F3C4-1F3FD-200D-2640-FE0F","non_qualified":"1F3C4-1F3FD-200D-2640","image":"1f3c4-1f3fd-200d-2640-fe0f.png","sheet_x":10,"sheet_y":3,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F3C4-1F3FE-200D-2640-FE0F","non_qualified":"1F3C4-1F3FE-200D-2640","image":"1f3c4-1f3fe-200d-2640-fe0f.png","sheet_x":10,"sheet_y":4,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F3C4-1F3FF-200D-2640-FE0F","non_qualified":"1F3C4-1F3FF-200D-2640","image":"1f3c4-1f3ff-200d-2640-fe0f.png","sheet_x":10,"sheet_y":5,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Woman Surfing","b":"1F3C4-200D-2640-FE0F","c":"1F3C4-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[10,0]},"rowboat":{"skin_variations":{"1F3FB":{"unified":"1F6A3-1F3FB","non_qualified":null,"image":"1f6a3-1f3fb.png","sheet_x":35,"sheet_y":4,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F6A3-1F3FC","non_qualified":null,"image":"1f6a3-1f3fc.png","sheet_x":35,"sheet_y":5,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F6A3-1F3FD","non_qualified":null,"image":"1f6a3-1f3fd.png","sheet_x":35,"sheet_y":6,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F6A3-1F3FE","non_qualified":null,"image":"1f6a3-1f3fe.png","sheet_x":35,"sheet_y":7,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F6A3-1F3FF","non_qualified":null,"image":"1f6a3-1f3ff.png","sheet_x":35,"sheet_y":8,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoleted_by":"1F6A3-200D-2642-FE0F","a":"Rowboat","b":"1F6A3","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[35,3]},"man-rowing-boat":{"skin_variations":{"1F3FB":{"unified":"1F6A3-1F3FB-200D-2642-FE0F","non_qualified":"1F6A3-1F3FB-200D-2642","image":"1f6a3-1f3fb-200d-2642-fe0f.png","sheet_x":34,"sheet_y":50,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F6A3-1F3FC-200D-2642-FE0F","non_qualified":"1F6A3-1F3FC-200D-2642","image":"1f6a3-1f3fc-200d-2642-fe0f.png","sheet_x":34,"sheet_y":51,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F6A3-1F3FD-200D-2642-FE0F","non_qualified":"1F6A3-1F3FD-200D-2642","image":"1f6a3-1f3fd-200d-2642-fe0f.png","sheet_x":35,"sheet_y":0,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F6A3-1F3FE-200D-2642-FE0F","non_qualified":"1F6A3-1F3FE-200D-2642","image":"1f6a3-1f3fe-200d-2642-fe0f.png","sheet_x":35,"sheet_y":1,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F6A3-1F3FF-200D-2642-FE0F","non_qualified":"1F6A3-1F3FF-200D-2642","image":"1f6a3-1f3ff-200d-2642-fe0f.png","sheet_x":35,"sheet_y":2,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F6A3","a":"Man Rowing Boat","b":"1F6A3-200D-2642-FE0F","c":"1F6A3-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[34,49]},"woman-rowing-boat":{"skin_variations":{"1F3FB":{"unified":"1F6A3-1F3FB-200D-2640-FE0F","non_qualified":"1F6A3-1F3FB-200D-2640","image":"1f6a3-1f3fb-200d-2640-fe0f.png","sheet_x":34,"sheet_y":44,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F6A3-1F3FC-200D-2640-FE0F","non_qualified":"1F6A3-1F3FC-200D-2640","image":"1f6a3-1f3fc-200d-2640-fe0f.png","sheet_x":34,"sheet_y":45,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F6A3-1F3FD-200D-2640-FE0F","non_qualified":"1F6A3-1F3FD-200D-2640","image":"1f6a3-1f3fd-200d-2640-fe0f.png","sheet_x":34,"sheet_y":46,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F6A3-1F3FE-200D-2640-FE0F","non_qualified":"1F6A3-1F3FE-200D-2640","image":"1f6a3-1f3fe-200d-2640-fe0f.png","sheet_x":34,"sheet_y":47,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F6A3-1F3FF-200D-2640-FE0F","non_qualified":"1F6A3-1F3FF-200D-2640","image":"1f6a3-1f3ff-200d-2640-fe0f.png","sheet_x":34,"sheet_y":48,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Woman Rowing Boat","b":"1F6A3-200D-2640-FE0F","c":"1F6A3-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[34,43]},"swimmer":{"skin_variations":{"1F3FB":{"unified":"1F3CA-1F3FB","non_qualified":null,"image":"1f3ca-1f3fb.png","sheet_x":10,"sheet_y":41,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FC":{"unified":"1F3CA-1F3FC","non_qualified":null,"image":"1f3ca-1f3fc.png","sheet_x":10,"sheet_y":42,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FD":{"unified":"1F3CA-1F3FD","non_qualified":null,"image":"1f3ca-1f3fd.png","sheet_x":10,"sheet_y":43,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FE":{"unified":"1F3CA-1F3FE","non_qualified":null,"image":"1f3ca-1f3fe.png","sheet_x":10,"sheet_y":44,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FF":{"unified":"1F3CA-1F3FF","non_qualified":null,"image":"1f3ca-1f3ff.png","sheet_x":10,"sheet_y":45,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true}},"obsoleted_by":"1F3CA-200D-2642-FE0F","a":"Swimmer","b":"1F3CA","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[10,40]},"man-swimming":{"skin_variations":{"1F3FB":{"unified":"1F3CA-1F3FB-200D-2642-FE0F","non_qualified":"1F3CA-1F3FB-200D-2642","image":"1f3ca-1f3fb-200d-2642-fe0f.png","sheet_x":10,"sheet_y":35,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F3CA-1F3FC-200D-2642-FE0F","non_qualified":"1F3CA-1F3FC-200D-2642","image":"1f3ca-1f3fc-200d-2642-fe0f.png","sheet_x":10,"sheet_y":36,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F3CA-1F3FD-200D-2642-FE0F","non_qualified":"1F3CA-1F3FD-200D-2642","image":"1f3ca-1f3fd-200d-2642-fe0f.png","sheet_x":10,"sheet_y":37,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F3CA-1F3FE-200D-2642-FE0F","non_qualified":"1F3CA-1F3FE-200D-2642","image":"1f3ca-1f3fe-200d-2642-fe0f.png","sheet_x":10,"sheet_y":38,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F3CA-1F3FF-200D-2642-FE0F","non_qualified":"1F3CA-1F3FF-200D-2642","image":"1f3ca-1f3ff-200d-2642-fe0f.png","sheet_x":10,"sheet_y":39,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F3CA","a":"Man Swimming","b":"1F3CA-200D-2642-FE0F","c":"1F3CA-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[10,34]},"woman-swimming":{"skin_variations":{"1F3FB":{"unified":"1F3CA-1F3FB-200D-2640-FE0F","non_qualified":"1F3CA-1F3FB-200D-2640","image":"1f3ca-1f3fb-200d-2640-fe0f.png","sheet_x":10,"sheet_y":29,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F3CA-1F3FC-200D-2640-FE0F","non_qualified":"1F3CA-1F3FC-200D-2640","image":"1f3ca-1f3fc-200d-2640-fe0f.png","sheet_x":10,"sheet_y":30,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F3CA-1F3FD-200D-2640-FE0F","non_qualified":"1F3CA-1F3FD-200D-2640","image":"1f3ca-1f3fd-200d-2640-fe0f.png","sheet_x":10,"sheet_y":31,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F3CA-1F3FE-200D-2640-FE0F","non_qualified":"1F3CA-1F3FE-200D-2640","image":"1f3ca-1f3fe-200d-2640-fe0f.png","sheet_x":10,"sheet_y":32,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F3CA-1F3FF-200D-2640-FE0F","non_qualified":"1F3CA-1F3FF-200D-2640","image":"1f3ca-1f3ff-200d-2640-fe0f.png","sheet_x":10,"sheet_y":33,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Woman Swimming","b":"1F3CA-200D-2640-FE0F","c":"1F3CA-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[10,28]},"person_with_ball":{"skin_variations":{"1F3FB":{"unified":"26F9-1F3FB","non_qualified":null,"image":"26f9-1f3fb.png","sheet_x":49,"sheet_y":7,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"26F9-1F3FC","non_qualified":null,"image":"26f9-1f3fc.png","sheet_x":49,"sheet_y":8,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"26F9-1F3FD","non_qualified":null,"image":"26f9-1f3fd.png","sheet_x":49,"sheet_y":9,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"26F9-1F3FE","non_qualified":null,"image":"26f9-1f3fe.png","sheet_x":49,"sheet_y":10,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"26F9-1F3FF","non_qualified":null,"image":"26f9-1f3ff.png","sheet_x":49,"sheet_y":11,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoleted_by":"26F9-FE0F-200D-2642-FE0F","a":"Person with Ball","b":"26F9-FE0F","c":"26F9","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"k":[49,6],"o":5},"man-bouncing-ball":{"skin_variations":{"1F3FB":{"unified":"26F9-1F3FB-200D-2642-FE0F","non_qualified":"26F9-1F3FB-200D-2642","image":"26f9-1f3fb-200d-2642-fe0f.png","sheet_x":49,"sheet_y":1,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"26F9-1F3FC-200D-2642-FE0F","non_qualified":"26F9-1F3FC-200D-2642","image":"26f9-1f3fc-200d-2642-fe0f.png","sheet_x":49,"sheet_y":2,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"26F9-1F3FD-200D-2642-FE0F","non_qualified":"26F9-1F3FD-200D-2642","image":"26f9-1f3fd-200d-2642-fe0f.png","sheet_x":49,"sheet_y":3,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"26F9-1F3FE-200D-2642-FE0F","non_qualified":"26F9-1F3FE-200D-2642","image":"26f9-1f3fe-200d-2642-fe0f.png","sheet_x":49,"sheet_y":4,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"26F9-1F3FF-200D-2642-FE0F","non_qualified":"26F9-1F3FF-200D-2642","image":"26f9-1f3ff-200d-2642-fe0f.png","sheet_x":49,"sheet_y":5,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"26F9-FE0F","a":"Man Bouncing Ball","b":"26F9-FE0F-200D-2642-FE0F","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"k":[49,0],"o":5},"woman-bouncing-ball":{"skin_variations":{"1F3FB":{"unified":"26F9-1F3FB-200D-2640-FE0F","non_qualified":"26F9-1F3FB-200D-2640","image":"26f9-1f3fb-200d-2640-fe0f.png","sheet_x":48,"sheet_y":47,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"26F9-1F3FC-200D-2640-FE0F","non_qualified":"26F9-1F3FC-200D-2640","image":"26f9-1f3fc-200d-2640-fe0f.png","sheet_x":48,"sheet_y":48,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"26F9-1F3FD-200D-2640-FE0F","non_qualified":"26F9-1F3FD-200D-2640","image":"26f9-1f3fd-200d-2640-fe0f.png","sheet_x":48,"sheet_y":49,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"26F9-1F3FE-200D-2640-FE0F","non_qualified":"26F9-1F3FE-200D-2640","image":"26f9-1f3fe-200d-2640-fe0f.png","sheet_x":48,"sheet_y":50,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"26F9-1F3FF-200D-2640-FE0F","non_qualified":"26F9-1F3FF-200D-2640","image":"26f9-1f3ff-200d-2640-fe0f.png","sheet_x":48,"sheet_y":51,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Woman Bouncing Ball","b":"26F9-FE0F-200D-2640-FE0F","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"k":[48,46],"o":5},"weight_lifter":{"skin_variations":{"1F3FB":{"unified":"1F3CB-1F3FB","non_qualified":null,"image":"1f3cb-1f3fb.png","sheet_x":11,"sheet_y":7,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F3CB-1F3FC","non_qualified":null,"image":"1f3cb-1f3fc.png","sheet_x":11,"sheet_y":8,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F3CB-1F3FD","non_qualified":null,"image":"1f3cb-1f3fd.png","sheet_x":11,"sheet_y":9,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F3CB-1F3FE","non_qualified":null,"image":"1f3cb-1f3fe.png","sheet_x":11,"sheet_y":10,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F3CB-1F3FF","non_qualified":null,"image":"1f3cb-1f3ff.png","sheet_x":11,"sheet_y":11,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoleted_by":"1F3CB-FE0F-200D-2642-FE0F","a":"Weight Lifter","b":"1F3CB-FE0F","c":"1F3CB","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"k":[11,6],"o":7},"man-lifting-weights":{"skin_variations":{"1F3FB":{"unified":"1F3CB-1F3FB-200D-2642-FE0F","non_qualified":"1F3CB-1F3FB-200D-2642","image":"1f3cb-1f3fb-200d-2642-fe0f.png","sheet_x":11,"sheet_y":1,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F3CB-1F3FC-200D-2642-FE0F","non_qualified":"1F3CB-1F3FC-200D-2642","image":"1f3cb-1f3fc-200d-2642-fe0f.png","sheet_x":11,"sheet_y":2,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F3CB-1F3FD-200D-2642-FE0F","non_qualified":"1F3CB-1F3FD-200D-2642","image":"1f3cb-1f3fd-200d-2642-fe0f.png","sheet_x":11,"sheet_y":3,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F3CB-1F3FE-200D-2642-FE0F","non_qualified":"1F3CB-1F3FE-200D-2642","image":"1f3cb-1f3fe-200d-2642-fe0f.png","sheet_x":11,"sheet_y":4,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F3CB-1F3FF-200D-2642-FE0F","non_qualified":"1F3CB-1F3FF-200D-2642","image":"1f3cb-1f3ff-200d-2642-fe0f.png","sheet_x":11,"sheet_y":5,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F3CB-FE0F","a":"Man Lifting Weights","b":"1F3CB-FE0F-200D-2642-FE0F","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"k":[11,0],"o":7},"woman-lifting-weights":{"skin_variations":{"1F3FB":{"unified":"1F3CB-1F3FB-200D-2640-FE0F","non_qualified":"1F3CB-1F3FB-200D-2640","image":"1f3cb-1f3fb-200d-2640-fe0f.png","sheet_x":10,"sheet_y":47,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F3CB-1F3FC-200D-2640-FE0F","non_qualified":"1F3CB-1F3FC-200D-2640","image":"1f3cb-1f3fc-200d-2640-fe0f.png","sheet_x":10,"sheet_y":48,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F3CB-1F3FD-200D-2640-FE0F","non_qualified":"1F3CB-1F3FD-200D-2640","image":"1f3cb-1f3fd-200d-2640-fe0f.png","sheet_x":10,"sheet_y":49,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F3CB-1F3FE-200D-2640-FE0F","non_qualified":"1F3CB-1F3FE-200D-2640","image":"1f3cb-1f3fe-200d-2640-fe0f.png","sheet_x":10,"sheet_y":50,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F3CB-1F3FF-200D-2640-FE0F","non_qualified":"1F3CB-1F3FF-200D-2640","image":"1f3cb-1f3ff-200d-2640-fe0f.png","sheet_x":10,"sheet_y":51,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Woman Lifting Weights","b":"1F3CB-FE0F-200D-2640-FE0F","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"k":[10,46],"o":7},"bicyclist":{"skin_variations":{"1F3FB":{"unified":"1F6B4-1F3FB","non_qualified":null,"image":"1f6b4-1f3fb.png","sheet_x":35,"sheet_y":38,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FC":{"unified":"1F6B4-1F3FC","non_qualified":null,"image":"1f6b4-1f3fc.png","sheet_x":35,"sheet_y":39,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FD":{"unified":"1F6B4-1F3FD","non_qualified":null,"image":"1f6b4-1f3fd.png","sheet_x":35,"sheet_y":40,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FE":{"unified":"1F6B4-1F3FE","non_qualified":null,"image":"1f6b4-1f3fe.png","sheet_x":35,"sheet_y":41,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FF":{"unified":"1F6B4-1F3FF","non_qualified":null,"image":"1f6b4-1f3ff.png","sheet_x":35,"sheet_y":42,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true}},"obsoleted_by":"1F6B4-200D-2642-FE0F","a":"Bicyclist","b":"1F6B4","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[35,37]},"man-biking":{"skin_variations":{"1F3FB":{"unified":"1F6B4-1F3FB-200D-2642-FE0F","non_qualified":"1F6B4-1F3FB-200D-2642","image":"1f6b4-1f3fb-200d-2642-fe0f.png","sheet_x":35,"sheet_y":32,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F6B4-1F3FC-200D-2642-FE0F","non_qualified":"1F6B4-1F3FC-200D-2642","image":"1f6b4-1f3fc-200d-2642-fe0f.png","sheet_x":35,"sheet_y":33,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F6B4-1F3FD-200D-2642-FE0F","non_qualified":"1F6B4-1F3FD-200D-2642","image":"1f6b4-1f3fd-200d-2642-fe0f.png","sheet_x":35,"sheet_y":34,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F6B4-1F3FE-200D-2642-FE0F","non_qualified":"1F6B4-1F3FE-200D-2642","image":"1f6b4-1f3fe-200d-2642-fe0f.png","sheet_x":35,"sheet_y":35,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F6B4-1F3FF-200D-2642-FE0F","non_qualified":"1F6B4-1F3FF-200D-2642","image":"1f6b4-1f3ff-200d-2642-fe0f.png","sheet_x":35,"sheet_y":36,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F6B4","a":"Man Biking","b":"1F6B4-200D-2642-FE0F","c":"1F6B4-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[35,31]},"woman-biking":{"skin_variations":{"1F3FB":{"unified":"1F6B4-1F3FB-200D-2640-FE0F","non_qualified":"1F6B4-1F3FB-200D-2640","image":"1f6b4-1f3fb-200d-2640-fe0f.png","sheet_x":35,"sheet_y":26,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F6B4-1F3FC-200D-2640-FE0F","non_qualified":"1F6B4-1F3FC-200D-2640","image":"1f6b4-1f3fc-200d-2640-fe0f.png","sheet_x":35,"sheet_y":27,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F6B4-1F3FD-200D-2640-FE0F","non_qualified":"1F6B4-1F3FD-200D-2640","image":"1f6b4-1f3fd-200d-2640-fe0f.png","sheet_x":35,"sheet_y":28,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F6B4-1F3FE-200D-2640-FE0F","non_qualified":"1F6B4-1F3FE-200D-2640","image":"1f6b4-1f3fe-200d-2640-fe0f.png","sheet_x":35,"sheet_y":29,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F6B4-1F3FF-200D-2640-FE0F","non_qualified":"1F6B4-1F3FF-200D-2640","image":"1f6b4-1f3ff-200d-2640-fe0f.png","sheet_x":35,"sheet_y":30,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Woman Biking","b":"1F6B4-200D-2640-FE0F","c":"1F6B4-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[35,25]},"mountain_bicyclist":{"skin_variations":{"1F3FB":{"unified":"1F6B5-1F3FB","non_qualified":null,"image":"1f6b5-1f3fb.png","sheet_x":36,"sheet_y":4,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FC":{"unified":"1F6B5-1F3FC","non_qualified":null,"image":"1f6b5-1f3fc.png","sheet_x":36,"sheet_y":5,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FD":{"unified":"1F6B5-1F3FD","non_qualified":null,"image":"1f6b5-1f3fd.png","sheet_x":36,"sheet_y":6,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FE":{"unified":"1F6B5-1F3FE","non_qualified":null,"image":"1f6b5-1f3fe.png","sheet_x":36,"sheet_y":7,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true},"1F3FF":{"unified":"1F6B5-1F3FF","non_qualified":null,"image":"1f6b5-1f3ff.png","sheet_x":36,"sheet_y":8,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":true}},"obsoleted_by":"1F6B5-200D-2642-FE0F","a":"Mountain Bicyclist","b":"1F6B5","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[36,3]},"man-mountain-biking":{"skin_variations":{"1F3FB":{"unified":"1F6B5-1F3FB-200D-2642-FE0F","non_qualified":"1F6B5-1F3FB-200D-2642","image":"1f6b5-1f3fb-200d-2642-fe0f.png","sheet_x":35,"sheet_y":50,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F6B5-1F3FC-200D-2642-FE0F","non_qualified":"1F6B5-1F3FC-200D-2642","image":"1f6b5-1f3fc-200d-2642-fe0f.png","sheet_x":35,"sheet_y":51,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F6B5-1F3FD-200D-2642-FE0F","non_qualified":"1F6B5-1F3FD-200D-2642","image":"1f6b5-1f3fd-200d-2642-fe0f.png","sheet_x":36,"sheet_y":0,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F6B5-1F3FE-200D-2642-FE0F","non_qualified":"1F6B5-1F3FE-200D-2642","image":"1f6b5-1f3fe-200d-2642-fe0f.png","sheet_x":36,"sheet_y":1,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F6B5-1F3FF-200D-2642-FE0F","non_qualified":"1F6B5-1F3FF-200D-2642","image":"1f6b5-1f3ff-200d-2642-fe0f.png","sheet_x":36,"sheet_y":2,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"obsoletes":"1F6B5","a":"Man Mountain Biking","b":"1F6B5-200D-2642-FE0F","c":"1F6B5-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[35,49]},"woman-mountain-biking":{"skin_variations":{"1F3FB":{"unified":"1F6B5-1F3FB-200D-2640-FE0F","non_qualified":"1F6B5-1F3FB-200D-2640","image":"1f6b5-1f3fb-200d-2640-fe0f.png","sheet_x":35,"sheet_y":44,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F6B5-1F3FC-200D-2640-FE0F","non_qualified":"1F6B5-1F3FC-200D-2640","image":"1f6b5-1f3fc-200d-2640-fe0f.png","sheet_x":35,"sheet_y":45,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F6B5-1F3FD-200D-2640-FE0F","non_qualified":"1F6B5-1F3FD-200D-2640","image":"1f6b5-1f3fd-200d-2640-fe0f.png","sheet_x":35,"sheet_y":46,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F6B5-1F3FE-200D-2640-FE0F","non_qualified":"1F6B5-1F3FE-200D-2640","image":"1f6b5-1f3fe-200d-2640-fe0f.png","sheet_x":35,"sheet_y":47,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F6B5-1F3FF-200D-2640-FE0F","non_qualified":"1F6B5-1F3FF-200D-2640","image":"1f6b5-1f3ff-200d-2640-fe0f.png","sheet_x":35,"sheet_y":48,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Woman Mountain Biking","b":"1F6B5-200D-2640-FE0F","c":"1F6B5-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[35,43]},"racing_car":{"a":"Racing Car","b":"1F3CE-FE0F","c":"1F3CE","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["sports","race","fast","formula","f1"],"k":[11,31],"o":7},"racing_motorcycle":{"a":"Racing Motorcycle","b":"1F3CD-FE0F","c":"1F3CD","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[11,30],"o":7},"person_doing_cartwheel":{"skin_variations":{"1F3FB":{"unified":"1F938-1F3FB","non_qualified":null,"image":"1f938-1f3fb.png","sheet_x":40,"sheet_y":25,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F938-1F3FC","non_qualified":null,"image":"1f938-1f3fc.png","sheet_x":40,"sheet_y":26,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F938-1F3FD","non_qualified":null,"image":"1f938-1f3fd.png","sheet_x":40,"sheet_y":27,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F938-1F3FE","non_qualified":null,"image":"1f938-1f3fe.png","sheet_x":40,"sheet_y":28,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F938-1F3FF","non_qualified":null,"image":"1f938-1f3ff.png","sheet_x":40,"sheet_y":29,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Person Doing Cartwheel","b":"1F938","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"k":[40,24],"o":9},"man-cartwheeling":{"skin_variations":{"1F3FB":{"unified":"1F938-1F3FB-200D-2642-FE0F","non_qualified":"1F938-1F3FB-200D-2642","image":"1f938-1f3fb-200d-2642-fe0f.png","sheet_x":40,"sheet_y":19,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F938-1F3FC-200D-2642-FE0F","non_qualified":"1F938-1F3FC-200D-2642","image":"1f938-1f3fc-200d-2642-fe0f.png","sheet_x":40,"sheet_y":20,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F938-1F3FD-200D-2642-FE0F","non_qualified":"1F938-1F3FD-200D-2642","image":"1f938-1f3fd-200d-2642-fe0f.png","sheet_x":40,"sheet_y":21,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F938-1F3FE-200D-2642-FE0F","non_qualified":"1F938-1F3FE-200D-2642","image":"1f938-1f3fe-200d-2642-fe0f.png","sheet_x":40,"sheet_y":22,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F938-1F3FF-200D-2642-FE0F","non_qualified":"1F938-1F3FF-200D-2642","image":"1f938-1f3ff-200d-2642-fe0f.png","sheet_x":40,"sheet_y":23,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Man Cartwheeling","b":"1F938-200D-2642-FE0F","c":"1F938-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[40,18],"o":9},"woman-cartwheeling":{"skin_variations":{"1F3FB":{"unified":"1F938-1F3FB-200D-2640-FE0F","non_qualified":"1F938-1F3FB-200D-2640","image":"1f938-1f3fb-200d-2640-fe0f.png","sheet_x":40,"sheet_y":13,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F938-1F3FC-200D-2640-FE0F","non_qualified":"1F938-1F3FC-200D-2640","image":"1f938-1f3fc-200d-2640-fe0f.png","sheet_x":40,"sheet_y":14,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F938-1F3FD-200D-2640-FE0F","non_qualified":"1F938-1F3FD-200D-2640","image":"1f938-1f3fd-200d-2640-fe0f.png","sheet_x":40,"sheet_y":15,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F938-1F3FE-200D-2640-FE0F","non_qualified":"1F938-1F3FE-200D-2640","image":"1f938-1f3fe-200d-2640-fe0f.png","sheet_x":40,"sheet_y":16,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F938-1F3FF-200D-2640-FE0F","non_qualified":"1F938-1F3FF-200D-2640","image":"1f938-1f3ff-200d-2640-fe0f.png","sheet_x":40,"sheet_y":17,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Woman Cartwheeling","b":"1F938-200D-2640-FE0F","c":"1F938-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[40,12],"o":9},"wrestlers":{"a":"Wrestlers","b":"1F93C","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"k":[40,51],"o":9},"man-wrestling":{"a":"Man Wrestling","b":"1F93C-200D-2642-FE0F","c":"1F93C-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[40,50],"o":9},"woman-wrestling":{"a":"Woman Wrestling","b":"1F93C-200D-2640-FE0F","c":"1F93C-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[40,49],"o":9},"water_polo":{"skin_variations":{"1F3FB":{"unified":"1F93D-1F3FB","non_qualified":null,"image":"1f93d-1f3fb.png","sheet_x":41,"sheet_y":13,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F93D-1F3FC","non_qualified":null,"image":"1f93d-1f3fc.png","sheet_x":41,"sheet_y":14,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F93D-1F3FD","non_qualified":null,"image":"1f93d-1f3fd.png","sheet_x":41,"sheet_y":15,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F93D-1F3FE","non_qualified":null,"image":"1f93d-1f3fe.png","sheet_x":41,"sheet_y":16,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F93D-1F3FF","non_qualified":null,"image":"1f93d-1f3ff.png","sheet_x":41,"sheet_y":17,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Water Polo","b":"1F93D","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"k":[41,12],"o":9},"man-playing-water-polo":{"skin_variations":{"1F3FB":{"unified":"1F93D-1F3FB-200D-2642-FE0F","non_qualified":"1F93D-1F3FB-200D-2642","image":"1f93d-1f3fb-200d-2642-fe0f.png","sheet_x":41,"sheet_y":7,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F93D-1F3FC-200D-2642-FE0F","non_qualified":"1F93D-1F3FC-200D-2642","image":"1f93d-1f3fc-200d-2642-fe0f.png","sheet_x":41,"sheet_y":8,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F93D-1F3FD-200D-2642-FE0F","non_qualified":"1F93D-1F3FD-200D-2642","image":"1f93d-1f3fd-200d-2642-fe0f.png","sheet_x":41,"sheet_y":9,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F93D-1F3FE-200D-2642-FE0F","non_qualified":"1F93D-1F3FE-200D-2642","image":"1f93d-1f3fe-200d-2642-fe0f.png","sheet_x":41,"sheet_y":10,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F93D-1F3FF-200D-2642-FE0F","non_qualified":"1F93D-1F3FF-200D-2642","image":"1f93d-1f3ff-200d-2642-fe0f.png","sheet_x":41,"sheet_y":11,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Man Playing Water Polo","b":"1F93D-200D-2642-FE0F","c":"1F93D-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[41,6],"o":9},"woman-playing-water-polo":{"skin_variations":{"1F3FB":{"unified":"1F93D-1F3FB-200D-2640-FE0F","non_qualified":"1F93D-1F3FB-200D-2640","image":"1f93d-1f3fb-200d-2640-fe0f.png","sheet_x":41,"sheet_y":1,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F93D-1F3FC-200D-2640-FE0F","non_qualified":"1F93D-1F3FC-200D-2640","image":"1f93d-1f3fc-200d-2640-fe0f.png","sheet_x":41,"sheet_y":2,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F93D-1F3FD-200D-2640-FE0F","non_qualified":"1F93D-1F3FD-200D-2640","image":"1f93d-1f3fd-200d-2640-fe0f.png","sheet_x":41,"sheet_y":3,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F93D-1F3FE-200D-2640-FE0F","non_qualified":"1F93D-1F3FE-200D-2640","image":"1f93d-1f3fe-200d-2640-fe0f.png","sheet_x":41,"sheet_y":4,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F93D-1F3FF-200D-2640-FE0F","non_qualified":"1F93D-1F3FF-200D-2640","image":"1f93d-1f3ff-200d-2640-fe0f.png","sheet_x":41,"sheet_y":5,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Woman Playing Water Polo","b":"1F93D-200D-2640-FE0F","c":"1F93D-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[41,0],"o":9},"handball":{"skin_variations":{"1F3FB":{"unified":"1F93E-1F3FB","non_qualified":null,"image":"1f93e-1f3fb.png","sheet_x":41,"sheet_y":31,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F93E-1F3FC","non_qualified":null,"image":"1f93e-1f3fc.png","sheet_x":41,"sheet_y":32,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F93E-1F3FD","non_qualified":null,"image":"1f93e-1f3fd.png","sheet_x":41,"sheet_y":33,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F93E-1F3FE","non_qualified":null,"image":"1f93e-1f3fe.png","sheet_x":41,"sheet_y":34,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F93E-1F3FF","non_qualified":null,"image":"1f93e-1f3ff.png","sheet_x":41,"sheet_y":35,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Handball","b":"1F93E","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"k":[41,30],"o":9},"man-playing-handball":{"skin_variations":{"1F3FB":{"unified":"1F93E-1F3FB-200D-2642-FE0F","non_qualified":"1F93E-1F3FB-200D-2642","image":"1f93e-1f3fb-200d-2642-fe0f.png","sheet_x":41,"sheet_y":25,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F93E-1F3FC-200D-2642-FE0F","non_qualified":"1F93E-1F3FC-200D-2642","image":"1f93e-1f3fc-200d-2642-fe0f.png","sheet_x":41,"sheet_y":26,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F93E-1F3FD-200D-2642-FE0F","non_qualified":"1F93E-1F3FD-200D-2642","image":"1f93e-1f3fd-200d-2642-fe0f.png","sheet_x":41,"sheet_y":27,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F93E-1F3FE-200D-2642-FE0F","non_qualified":"1F93E-1F3FE-200D-2642","image":"1f93e-1f3fe-200d-2642-fe0f.png","sheet_x":41,"sheet_y":28,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F93E-1F3FF-200D-2642-FE0F","non_qualified":"1F93E-1F3FF-200D-2642","image":"1f93e-1f3ff-200d-2642-fe0f.png","sheet_x":41,"sheet_y":29,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Man Playing Handball","b":"1F93E-200D-2642-FE0F","c":"1F93E-200D-2642","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[41,24],"o":9},"woman-playing-handball":{"skin_variations":{"1F3FB":{"unified":"1F93E-1F3FB-200D-2640-FE0F","non_qualified":"1F93E-1F3FB-200D-2640","image":"1f93e-1f3fb-200d-2640-fe0f.png","sheet_x":41,"sheet_y":19,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F93E-1F3FC-200D-2640-FE0F","non_qualified":"1F93E-1F3FC-200D-2640","image":"1f93e-1f3fc-200d-2640-fe0f.png","sheet_x":41,"sheet_y":20,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F93E-1F3FD-200D-2640-FE0F","non_qualified":"1F93E-1F3FD-200D-2640","image":"1f93e-1f3fd-200d-2640-fe0f.png","sheet_x":41,"sheet_y":21,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F93E-1F3FE-200D-2640-FE0F","non_qualified":"1F93E-1F3FE-200D-2640","image":"1f93e-1f3fe-200d-2640-fe0f.png","sheet_x":41,"sheet_y":22,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F93E-1F3FF-200D-2640-FE0F","non_qualified":"1F93E-1F3FF-200D-2640","image":"1f93e-1f3ff-200d-2640-fe0f.png","sheet_x":41,"sheet_y":23,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Woman Playing Handball","b":"1F93E-200D-2640-FE0F","c":"1F93E-200D-2640","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[41,18],"o":9},"juggling":{"skin_variations":{"1F3FB":{"unified":"1F939-1F3FB","non_qualified":null,"image":"1f939-1f3fb.png","sheet_x":40,"sheet_y":43,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F939-1F3FC","non_qualified":null,"image":"1f939-1f3fc.png","sheet_x":40,"sheet_y":44,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F939-1F3FD","non_qualified":null,"image":"1f939-1f3fd.png","sheet_x":40,"sheet_y":45,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F939-1F3FE","non_qualified":null,"image":"1f939-1f3fe.png","sheet_x":40,"sheet_y":46,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F939-1F3FF","non_qualified":null,"image":"1f939-1f3ff.png","sheet_x":40,"sheet_y":47,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Juggling","b":"1F939","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[40,42],"o":9},"man-juggling":{"skin_variations":{"1F3FB":{"unified":"1F939-1F3FB-200D-2642-FE0F","non_qualified":"1F939-1F3FB-200D-2642","image":"1f939-1f3fb-200d-2642-fe0f.png","sheet_x":40,"sheet_y":37,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F939-1F3FC-200D-2642-FE0F","non_qualified":"1F939-1F3FC-200D-2642","image":"1f939-1f3fc-200d-2642-fe0f.png","sheet_x":40,"sheet_y":38,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F939-1F3FD-200D-2642-FE0F","non_qualified":"1F939-1F3FD-200D-2642","image":"1f939-1f3fd-200d-2642-fe0f.png","sheet_x":40,"sheet_y":39,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F939-1F3FE-200D-2642-FE0F","non_qualified":"1F939-1F3FE-200D-2642","image":"1f939-1f3fe-200d-2642-fe0f.png","sheet_x":40,"sheet_y":40,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F939-1F3FF-200D-2642-FE0F","non_qualified":"1F939-1F3FF-200D-2642","image":"1f939-1f3ff-200d-2642-fe0f.png","sheet_x":40,"sheet_y":41,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Man Juggling","b":"1F939-200D-2642-FE0F","c":"1F939-200D-2642","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"k":[40,36],"o":9},"woman-juggling":{"skin_variations":{"1F3FB":{"unified":"1F939-1F3FB-200D-2640-FE0F","non_qualified":"1F939-1F3FB-200D-2640","image":"1f939-1f3fb-200d-2640-fe0f.png","sheet_x":40,"sheet_y":31,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FC":{"unified":"1F939-1F3FC-200D-2640-FE0F","non_qualified":"1F939-1F3FC-200D-2640","image":"1f939-1f3fc-200d-2640-fe0f.png","sheet_x":40,"sheet_y":32,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FD":{"unified":"1F939-1F3FD-200D-2640-FE0F","non_qualified":"1F939-1F3FD-200D-2640","image":"1f939-1f3fd-200d-2640-fe0f.png","sheet_x":40,"sheet_y":33,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FE":{"unified":"1F939-1F3FE-200D-2640-FE0F","non_qualified":"1F939-1F3FE-200D-2640","image":"1f939-1f3fe-200d-2640-fe0f.png","sheet_x":40,"sheet_y":34,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false},"1F3FF":{"unified":"1F939-1F3FF-200D-2640-FE0F","non_qualified":"1F939-1F3FF-200D-2640","image":"1f939-1f3ff-200d-2640-fe0f.png","sheet_x":40,"sheet_y":35,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":false,"has_img_messenger":false}},"a":"Woman Juggling","b":"1F939-200D-2640-FE0F","c":"1F939-200D-2640","d":true,"e":true,"f":true,"g":true,"h":false,"i":false,"k":[40,30],"o":9},"couple":{"a":"Man and Woman Holding Hands","b":"1F46B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["pair","people","human","love","date","dating","like","affection","valentines","marriage"],"k":[20,30],"n":["man_and_woman_holding_hands"]},"two_men_holding_hands":{"a":"Two Men Holding Hands","b":"1F46C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["pair","couple","love","like","bromance","friendship","people","human"],"k":[20,31]},"two_women_holding_hands":{"a":"Two Women Holding Hands","b":"1F46D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["pair","friendship","couple","love","like","female","people","human"],"k":[20,32]},"couplekiss":{"obsoleted_by":"1F469-200D-2764-FE0F-200D-1F48B-200D-1F468","a":"Kiss","b":"1F48F","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[24,41]},"woman-kiss-man":{"obsoletes":"1F48F","a":"Woman Kiss Man","b":"1F469-200D-2764-FE0F-200D-1F48B-200D-1F468","c":"1F469-200D-2764-200D-1F48B-200D-1F468","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[20,21]},"man-kiss-man":{"a":"Man Kiss Man","b":"1F468-200D-2764-FE0F-200D-1F48B-200D-1F468","c":"1F468-200D-2764-200D-1F48B-200D-1F468","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[18,10]},"woman-kiss-woman":{"a":"Woman Kiss Woman","b":"1F469-200D-2764-FE0F-200D-1F48B-200D-1F469","c":"1F469-200D-2764-200D-1F48B-200D-1F469","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[20,22]},"couple_with_heart":{"obsoleted_by":"1F469-200D-2764-FE0F-200D-1F468","a":"Couple with Heart","b":"1F491","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[24,43]},"woman-heart-man":{"obsoletes":"1F491","a":"Woman Heart Man","b":"1F469-200D-2764-FE0F-200D-1F468","c":"1F469-200D-2764-200D-1F468","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[20,19]},"man-heart-man":{"a":"Man Heart Man","b":"1F468-200D-2764-FE0F-200D-1F468","c":"1F468-200D-2764-200D-1F468","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[18,9]},"woman-heart-woman":{"a":"Woman Heart Woman","b":"1F469-200D-2764-FE0F-200D-1F469","c":"1F469-200D-2764-200D-1F469","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[20,20]},"family":{"obsoleted_by":"1F468-200D-1F469-200D-1F466","a":"Family","b":"1F46A","d":true,"e":true,"f":true,"g":true,"h":false,"i":true,"k":[20,29],"n":["man-woman-boy"]},"man-woman-boy":{"obsoletes":"1F46A","a":"Man Woman Boy","b":"1F468-200D-1F469-200D-1F466","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[17,2],"n":["family"]},"man-woman-girl":{"a":"Man Woman Girl","b":"1F468-200D-1F469-200D-1F467","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[17,4]},"man-woman-girl-boy":{"a":"Man Woman Girl Boy","b":"1F468-200D-1F469-200D-1F467-200D-1F466","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[17,5]},"man-woman-boy-boy":{"a":"Man Woman Boy Boy","b":"1F468-200D-1F469-200D-1F466-200D-1F466","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[17,3]},"man-woman-girl-girl":{"a":"Man Woman Girl Girl","b":"1F468-200D-1F469-200D-1F467-200D-1F467","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[17,6]},"man-man-boy":{"a":"Man Man Boy","b":"1F468-200D-1F468-200D-1F466","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[16,49]},"man-man-girl":{"a":"Man Man Girl","b":"1F468-200D-1F468-200D-1F467","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[16,51]},"man-man-girl-boy":{"a":"Man Man Girl Boy","b":"1F468-200D-1F468-200D-1F467-200D-1F466","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[17,0]},"man-man-boy-boy":{"a":"Man Man Boy Boy","b":"1F468-200D-1F468-200D-1F466-200D-1F466","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[16,50]},"man-man-girl-girl":{"a":"Man Man Girl Girl","b":"1F468-200D-1F468-200D-1F467-200D-1F467","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[17,1]},"woman-woman-boy":{"a":"Woman Woman Boy","b":"1F469-200D-1F469-200D-1F466","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[19,12]},"woman-woman-girl":{"a":"Woman Woman Girl","b":"1F469-200D-1F469-200D-1F467","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[19,14]},"woman-woman-girl-boy":{"a":"Woman Woman Girl Boy","b":"1F469-200D-1F469-200D-1F467-200D-1F466","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[19,15]},"woman-woman-boy-boy":{"a":"Woman Woman Boy Boy","b":"1F469-200D-1F469-200D-1F466-200D-1F466","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[19,13]},"woman-woman-girl-girl":{"a":"Woman Woman Girl Girl","b":"1F469-200D-1F469-200D-1F467-200D-1F467","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[19,16]},"man-boy":{"a":"Man Boy","b":"1F468-200D-1F466","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[16,45]},"man-boy-boy":{"a":"Man Boy Boy","b":"1F468-200D-1F466-200D-1F466","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[16,44]},"man-girl":{"a":"Man Girl","b":"1F468-200D-1F467","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[16,48]},"man-girl-boy":{"a":"Man Girl Boy","b":"1F468-200D-1F467-200D-1F466","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[16,46]},"man-girl-girl":{"a":"Man Girl Girl","b":"1F468-200D-1F467-200D-1F467","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[16,47]},"woman-boy":{"a":"Woman Boy","b":"1F469-200D-1F466","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[19,8]},"woman-boy-boy":{"a":"Woman Boy Boy","b":"1F469-200D-1F466-200D-1F466","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[19,7]},"woman-girl":{"a":"Woman Girl","b":"1F469-200D-1F467","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[19,11]},"woman-girl-boy":{"a":"Woman Girl Boy","b":"1F469-200D-1F467-200D-1F466","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[19,9]},"woman-girl-girl":{"a":"Woman Girl Girl","b":"1F469-200D-1F467-200D-1F467","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[19,10]},"selfie":{"skin_variations":{"1F3FB":{"unified":"1F933-1F3FB","non_qualified":null,"image":"1f933-1f3fb.png","sheet_x":39,"sheet_y":23,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F933-1F3FC","non_qualified":null,"image":"1f933-1f3fc.png","sheet_x":39,"sheet_y":24,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F933-1F3FD","non_qualified":null,"image":"1f933-1f3fd.png","sheet_x":39,"sheet_y":25,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F933-1F3FE","non_qualified":null,"image":"1f933-1f3fe.png","sheet_x":39,"sheet_y":26,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F933-1F3FF","non_qualified":null,"image":"1f933-1f3ff.png","sheet_x":39,"sheet_y":27,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Selfie","b":"1F933","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["camera","phone"],"k":[39,22],"o":9},"muscle":{"skin_variations":{"1F3FB":{"unified":"1F4AA-1F3FB","non_qualified":null,"image":"1f4aa-1f3fb.png","sheet_x":25,"sheet_y":17,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F4AA-1F3FC","non_qualified":null,"image":"1f4aa-1f3fc.png","sheet_x":25,"sheet_y":18,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F4AA-1F3FD","non_qualified":null,"image":"1f4aa-1f3fd.png","sheet_x":25,"sheet_y":19,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F4AA-1F3FE","non_qualified":null,"image":"1f4aa-1f3fe.png","sheet_x":25,"sheet_y":20,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F4AA-1F3FF","non_qualified":null,"image":"1f4aa-1f3ff.png","sheet_x":25,"sheet_y":21,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Flexed Biceps","b":"1F4AA","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["arm","flex","hand","summer","strong","biceps"],"k":[25,16]},"point_left":{"skin_variations":{"1F3FB":{"unified":"1F448-1F3FB","non_qualified":null,"image":"1f448-1f3fb.png","sheet_x":14,"sheet_y":20,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F448-1F3FC","non_qualified":null,"image":"1f448-1f3fc.png","sheet_x":14,"sheet_y":21,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F448-1F3FD","non_qualified":null,"image":"1f448-1f3fd.png","sheet_x":14,"sheet_y":22,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F448-1F3FE","non_qualified":null,"image":"1f448-1f3fe.png","sheet_x":14,"sheet_y":23,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F448-1F3FF","non_qualified":null,"image":"1f448-1f3ff.png","sheet_x":14,"sheet_y":24,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"White Left Pointing Backhand Index","b":"1F448","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["direction","fingers","hand","left"],"k":[14,19]},"point_right":{"skin_variations":{"1F3FB":{"unified":"1F449-1F3FB","non_qualified":null,"image":"1f449-1f3fb.png","sheet_x":14,"sheet_y":26,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F449-1F3FC","non_qualified":null,"image":"1f449-1f3fc.png","sheet_x":14,"sheet_y":27,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F449-1F3FD","non_qualified":null,"image":"1f449-1f3fd.png","sheet_x":14,"sheet_y":28,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F449-1F3FE","non_qualified":null,"image":"1f449-1f3fe.png","sheet_x":14,"sheet_y":29,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F449-1F3FF","non_qualified":null,"image":"1f449-1f3ff.png","sheet_x":14,"sheet_y":30,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"White Right Pointing Backhand Index","b":"1F449","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fingers","hand","direction","right"],"k":[14,25]},"point_up":{"skin_variations":{"1F3FB":{"unified":"261D-1F3FB","non_qualified":null,"image":"261d-1f3fb.png","sheet_x":47,"sheet_y":27,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"261D-1F3FC","non_qualified":null,"image":"261d-1f3fc.png","sheet_x":47,"sheet_y":28,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"261D-1F3FD","non_qualified":null,"image":"261d-1f3fd.png","sheet_x":47,"sheet_y":29,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"261D-1F3FE","non_qualified":null,"image":"261d-1f3fe.png","sheet_x":47,"sheet_y":30,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"261D-1F3FF","non_qualified":null,"image":"261d-1f3ff.png","sheet_x":47,"sheet_y":31,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"White Up Pointing Index","b":"261D-FE0F","c":"261D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["hand","fingers","direction","up"],"k":[47,26],"o":1},"point_up_2":{"skin_variations":{"1F3FB":{"unified":"1F446-1F3FB","non_qualified":null,"image":"1f446-1f3fb.png","sheet_x":14,"sheet_y":8,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F446-1F3FC","non_qualified":null,"image":"1f446-1f3fc.png","sheet_x":14,"sheet_y":9,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F446-1F3FD","non_qualified":null,"image":"1f446-1f3fd.png","sheet_x":14,"sheet_y":10,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F446-1F3FE","non_qualified":null,"image":"1f446-1f3fe.png","sheet_x":14,"sheet_y":11,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F446-1F3FF","non_qualified":null,"image":"1f446-1f3ff.png","sheet_x":14,"sheet_y":12,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"White Up Pointing Backhand Index","b":"1F446","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fingers","hand","direction","up"],"k":[14,7]},"middle_finger":{"skin_variations":{"1F3FB":{"unified":"1F595-1F3FB","non_qualified":null,"image":"1f595-1f3fb.png","sheet_x":29,"sheet_y":39,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F595-1F3FC","non_qualified":null,"image":"1f595-1f3fc.png","sheet_x":29,"sheet_y":40,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F595-1F3FD","non_qualified":null,"image":"1f595-1f3fd.png","sheet_x":29,"sheet_y":41,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F595-1F3FE","non_qualified":null,"image":"1f595-1f3fe.png","sheet_x":29,"sheet_y":42,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F595-1F3FF","non_qualified":null,"image":"1f595-1f3ff.png","sheet_x":29,"sheet_y":43,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Reversed Hand with Middle Finger Extended","b":"1F595","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[29,38],"n":["reversed_hand_with_middle_finger_extended"],"o":7},"point_down":{"skin_variations":{"1F3FB":{"unified":"1F447-1F3FB","non_qualified":null,"image":"1f447-1f3fb.png","sheet_x":14,"sheet_y":14,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F447-1F3FC","non_qualified":null,"image":"1f447-1f3fc.png","sheet_x":14,"sheet_y":15,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F447-1F3FD","non_qualified":null,"image":"1f447-1f3fd.png","sheet_x":14,"sheet_y":16,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F447-1F3FE","non_qualified":null,"image":"1f447-1f3fe.png","sheet_x":14,"sheet_y":17,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F447-1F3FF","non_qualified":null,"image":"1f447-1f3ff.png","sheet_x":14,"sheet_y":18,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"White Down Pointing Backhand Index","b":"1F447","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fingers","hand","direction","down"],"k":[14,13]},"v":{"skin_variations":{"1F3FB":{"unified":"270C-1F3FB","non_qualified":null,"image":"270c-1f3fb.png","sheet_x":49,"sheet_y":31,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"270C-1F3FC","non_qualified":null,"image":"270c-1f3fc.png","sheet_x":49,"sheet_y":32,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"270C-1F3FD","non_qualified":null,"image":"270c-1f3fd.png","sheet_x":49,"sheet_y":33,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"270C-1F3FE","non_qualified":null,"image":"270c-1f3fe.png","sheet_x":49,"sheet_y":34,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"270C-1F3FF","non_qualified":null,"image":"270c-1f3ff.png","sheet_x":49,"sheet_y":35,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Victory Hand","b":"270C-FE0F","c":"270C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fingers","ohyeah","hand","peace","victory","two"],"k":[49,30],"o":1},"crossed_fingers":{"skin_variations":{"1F3FB":{"unified":"1F91E-1F3FB","non_qualified":null,"image":"1f91e-1f3fb.png","sheet_x":38,"sheet_y":12,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F91E-1F3FC","non_qualified":null,"image":"1f91e-1f3fc.png","sheet_x":38,"sheet_y":13,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F91E-1F3FD","non_qualified":null,"image":"1f91e-1f3fd.png","sheet_x":38,"sheet_y":14,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F91E-1F3FE","non_qualified":null,"image":"1f91e-1f3fe.png","sheet_x":38,"sheet_y":15,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F91E-1F3FF","non_qualified":null,"image":"1f91e-1f3ff.png","sheet_x":38,"sheet_y":16,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Hand with Index and Middle Fingers Crossed","b":"1F91E","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["good","lucky"],"k":[38,11],"n":["hand_with_index_and_middle_fingers_crossed"],"o":9},"spock-hand":{"skin_variations":{"1F3FB":{"unified":"1F596-1F3FB","non_qualified":null,"image":"1f596-1f3fb.png","sheet_x":29,"sheet_y":45,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F596-1F3FC","non_qualified":null,"image":"1f596-1f3fc.png","sheet_x":29,"sheet_y":46,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F596-1F3FD","non_qualified":null,"image":"1f596-1f3fd.png","sheet_x":29,"sheet_y":47,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F596-1F3FE","non_qualified":null,"image":"1f596-1f3fe.png","sheet_x":29,"sheet_y":48,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F596-1F3FF","non_qualified":null,"image":"1f596-1f3ff.png","sheet_x":29,"sheet_y":49,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Raised Hand with Part Between Middle and Ring Fingers","b":"1F596","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[29,44],"o":7},"the_horns":{"skin_variations":{"1F3FB":{"unified":"1F918-1F3FB","non_qualified":null,"image":"1f918-1f3fb.png","sheet_x":37,"sheet_y":33,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F918-1F3FC","non_qualified":null,"image":"1f918-1f3fc.png","sheet_x":37,"sheet_y":34,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F918-1F3FD","non_qualified":null,"image":"1f918-1f3fd.png","sheet_x":37,"sheet_y":35,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F918-1F3FE","non_qualified":null,"image":"1f918-1f3fe.png","sheet_x":37,"sheet_y":36,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F918-1F3FF","non_qualified":null,"image":"1f918-1f3ff.png","sheet_x":37,"sheet_y":37,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Sign of the Horns","b":"1F918","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[37,32],"n":["sign_of_the_horns"],"o":8},"call_me_hand":{"skin_variations":{"1F3FB":{"unified":"1F919-1F3FB","non_qualified":null,"image":"1f919-1f3fb.png","sheet_x":37,"sheet_y":39,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F919-1F3FC","non_qualified":null,"image":"1f919-1f3fc.png","sheet_x":37,"sheet_y":40,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F919-1F3FD","non_qualified":null,"image":"1f919-1f3fd.png","sheet_x":37,"sheet_y":41,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F919-1F3FE","non_qualified":null,"image":"1f919-1f3fe.png","sheet_x":37,"sheet_y":42,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F919-1F3FF","non_qualified":null,"image":"1f919-1f3ff.png","sheet_x":37,"sheet_y":43,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Call Me Hand","b":"1F919","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["hands","gesture"],"k":[37,38],"o":9},"raised_hand_with_fingers_splayed":{"skin_variations":{"1F3FB":{"unified":"1F590-1F3FB","non_qualified":null,"image":"1f590-1f3fb.png","sheet_x":29,"sheet_y":33,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F590-1F3FC","non_qualified":null,"image":"1f590-1f3fc.png","sheet_x":29,"sheet_y":34,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F590-1F3FD","non_qualified":null,"image":"1f590-1f3fd.png","sheet_x":29,"sheet_y":35,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F590-1F3FE","non_qualified":null,"image":"1f590-1f3fe.png","sheet_x":29,"sheet_y":36,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F590-1F3FF","non_qualified":null,"image":"1f590-1f3ff.png","sheet_x":29,"sheet_y":37,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Raised Hand with Fingers Splayed","b":"1F590-FE0F","c":"1F590","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["hand","fingers","palm"],"k":[29,32],"o":7},"hand":{"skin_variations":{"1F3FB":{"unified":"270B-1F3FB","non_qualified":null,"image":"270b-1f3fb.png","sheet_x":49,"sheet_y":25,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"270B-1F3FC","non_qualified":null,"image":"270b-1f3fc.png","sheet_x":49,"sheet_y":26,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"270B-1F3FD","non_qualified":null,"image":"270b-1f3fd.png","sheet_x":49,"sheet_y":27,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"270B-1F3FE","non_qualified":null,"image":"270b-1f3fe.png","sheet_x":49,"sheet_y":28,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"270B-1F3FF","non_qualified":null,"image":"270b-1f3ff.png","sheet_x":49,"sheet_y":29,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Raised Hand","b":"270B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[49,24],"n":["raised_hand"]},"ok_hand":{"skin_variations":{"1F3FB":{"unified":"1F44C-1F3FB","non_qualified":null,"image":"1f44c-1f3fb.png","sheet_x":14,"sheet_y":44,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F44C-1F3FC","non_qualified":null,"image":"1f44c-1f3fc.png","sheet_x":14,"sheet_y":45,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F44C-1F3FD","non_qualified":null,"image":"1f44c-1f3fd.png","sheet_x":14,"sheet_y":46,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F44C-1F3FE","non_qualified":null,"image":"1f44c-1f3fe.png","sheet_x":14,"sheet_y":47,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F44C-1F3FF","non_qualified":null,"image":"1f44c-1f3ff.png","sheet_x":14,"sheet_y":48,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Ok Hand Sign","b":"1F44C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fingers","limbs","perfect","ok","okay"],"k":[14,43]},"+1":{"skin_variations":{"1F3FB":{"unified":"1F44D-1F3FB","non_qualified":null,"image":"1f44d-1f3fb.png","sheet_x":14,"sheet_y":50,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F44D-1F3FC","non_qualified":null,"image":"1f44d-1f3fc.png","sheet_x":14,"sheet_y":51,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F44D-1F3FD","non_qualified":null,"image":"1f44d-1f3fd.png","sheet_x":15,"sheet_y":0,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F44D-1F3FE","non_qualified":null,"image":"1f44d-1f3fe.png","sheet_x":15,"sheet_y":1,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F44D-1F3FF","non_qualified":null,"image":"1f44d-1f3ff.png","sheet_x":15,"sheet_y":2,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Thumbs Up Sign","b":"1F44D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["thumbsup","yes","awesome","good","agree","accept","cool","hand","like"],"k":[14,49],"n":["thumbsup"]},"-1":{"skin_variations":{"1F3FB":{"unified":"1F44E-1F3FB","non_qualified":null,"image":"1f44e-1f3fb.png","sheet_x":15,"sheet_y":4,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F44E-1F3FC","non_qualified":null,"image":"1f44e-1f3fc.png","sheet_x":15,"sheet_y":5,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F44E-1F3FD","non_qualified":null,"image":"1f44e-1f3fd.png","sheet_x":15,"sheet_y":6,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F44E-1F3FE","non_qualified":null,"image":"1f44e-1f3fe.png","sheet_x":15,"sheet_y":7,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F44E-1F3FF","non_qualified":null,"image":"1f44e-1f3ff.png","sheet_x":15,"sheet_y":8,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Thumbs Down Sign","b":"1F44E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["thumbsdown","no","dislike","hand"],"k":[15,3],"n":["thumbsdown"]},"fist":{"skin_variations":{"1F3FB":{"unified":"270A-1F3FB","non_qualified":null,"image":"270a-1f3fb.png","sheet_x":49,"sheet_y":19,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"270A-1F3FC","non_qualified":null,"image":"270a-1f3fc.png","sheet_x":49,"sheet_y":20,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"270A-1F3FD","non_qualified":null,"image":"270a-1f3fd.png","sheet_x":49,"sheet_y":21,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"270A-1F3FE","non_qualified":null,"image":"270a-1f3fe.png","sheet_x":49,"sheet_y":22,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"270A-1F3FF","non_qualified":null,"image":"270a-1f3ff.png","sheet_x":49,"sheet_y":23,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Raised Fist","b":"270A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fingers","hand","grasp"],"k":[49,18]},"facepunch":{"skin_variations":{"1F3FB":{"unified":"1F44A-1F3FB","non_qualified":null,"image":"1f44a-1f3fb.png","sheet_x":14,"sheet_y":32,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F44A-1F3FC","non_qualified":null,"image":"1f44a-1f3fc.png","sheet_x":14,"sheet_y":33,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F44A-1F3FD","non_qualified":null,"image":"1f44a-1f3fd.png","sheet_x":14,"sheet_y":34,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F44A-1F3FE","non_qualified":null,"image":"1f44a-1f3fe.png","sheet_x":14,"sheet_y":35,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F44A-1F3FF","non_qualified":null,"image":"1f44a-1f3ff.png","sheet_x":14,"sheet_y":36,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Fisted Hand Sign","b":"1F44A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["angry","violence","fist","hit","attack","hand"],"k":[14,31],"n":["punch"]},"left-facing_fist":{"skin_variations":{"1F3FB":{"unified":"1F91B-1F3FB","non_qualified":null,"image":"1f91b-1f3fb.png","sheet_x":37,"sheet_y":51,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F91B-1F3FC","non_qualified":null,"image":"1f91b-1f3fc.png","sheet_x":38,"sheet_y":0,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F91B-1F3FD","non_qualified":null,"image":"1f91b-1f3fd.png","sheet_x":38,"sheet_y":1,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F91B-1F3FE","non_qualified":null,"image":"1f91b-1f3fe.png","sheet_x":38,"sheet_y":2,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F91B-1F3FF","non_qualified":null,"image":"1f91b-1f3ff.png","sheet_x":38,"sheet_y":3,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Left-Facing Fist","b":"1F91B","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[37,50],"o":9},"right-facing_fist":{"skin_variations":{"1F3FB":{"unified":"1F91C-1F3FB","non_qualified":null,"image":"1f91c-1f3fb.png","sheet_x":38,"sheet_y":5,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F91C-1F3FC","non_qualified":null,"image":"1f91c-1f3fc.png","sheet_x":38,"sheet_y":6,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F91C-1F3FD","non_qualified":null,"image":"1f91c-1f3fd.png","sheet_x":38,"sheet_y":7,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F91C-1F3FE","non_qualified":null,"image":"1f91c-1f3fe.png","sheet_x":38,"sheet_y":8,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F91C-1F3FF","non_qualified":null,"image":"1f91c-1f3ff.png","sheet_x":38,"sheet_y":9,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Right-Facing Fist","b":"1F91C","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[38,4],"o":9},"raised_back_of_hand":{"skin_variations":{"1F3FB":{"unified":"1F91A-1F3FB","non_qualified":null,"image":"1f91a-1f3fb.png","sheet_x":37,"sheet_y":45,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F91A-1F3FC","non_qualified":null,"image":"1f91a-1f3fc.png","sheet_x":37,"sheet_y":46,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F91A-1F3FD","non_qualified":null,"image":"1f91a-1f3fd.png","sheet_x":37,"sheet_y":47,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F91A-1F3FE","non_qualified":null,"image":"1f91a-1f3fe.png","sheet_x":37,"sheet_y":48,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F91A-1F3FF","non_qualified":null,"image":"1f91a-1f3ff.png","sheet_x":37,"sheet_y":49,"added_in":"9.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Raised Back of Hand","b":"1F91A","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["fingers","raised","backhand"],"k":[37,44],"o":9},"wave":{"skin_variations":{"1F3FB":{"unified":"1F44B-1F3FB","non_qualified":null,"image":"1f44b-1f3fb.png","sheet_x":14,"sheet_y":38,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F44B-1F3FC","non_qualified":null,"image":"1f44b-1f3fc.png","sheet_x":14,"sheet_y":39,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F44B-1F3FD","non_qualified":null,"image":"1f44b-1f3fd.png","sheet_x":14,"sheet_y":40,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F44B-1F3FE","non_qualified":null,"image":"1f44b-1f3fe.png","sheet_x":14,"sheet_y":41,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F44B-1F3FF","non_qualified":null,"image":"1f44b-1f3ff.png","sheet_x":14,"sheet_y":42,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Waving Hand Sign","b":"1F44B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["hands","gesture","goodbye","solong","farewell","hello","hi","palm"],"k":[14,37]},"i_love_you_hand_sign":{"skin_variations":{"1F3FB":{"unified":"1F91F-1F3FB","non_qualified":null,"image":"1f91f-1f3fb.png","sheet_x":38,"sheet_y":18,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F91F-1F3FC","non_qualified":null,"image":"1f91f-1f3fc.png","sheet_x":38,"sheet_y":19,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F91F-1F3FD","non_qualified":null,"image":"1f91f-1f3fd.png","sheet_x":38,"sheet_y":20,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F91F-1F3FE","non_qualified":null,"image":"1f91f-1f3fe.png","sheet_x":38,"sheet_y":21,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F91F-1F3FF","non_qualified":null,"image":"1f91f-1f3ff.png","sheet_x":38,"sheet_y":22,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"I Love You Hand Sign","b":"1F91F","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[38,17],"o":10},"writing_hand":{"skin_variations":{"1F3FB":{"unified":"270D-1F3FB","non_qualified":null,"image":"270d-1f3fb.png","sheet_x":49,"sheet_y":37,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"270D-1F3FC","non_qualified":null,"image":"270d-1f3fc.png","sheet_x":49,"sheet_y":38,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"270D-1F3FD","non_qualified":null,"image":"270d-1f3fd.png","sheet_x":49,"sheet_y":39,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"270D-1F3FE","non_qualified":null,"image":"270d-1f3fe.png","sheet_x":49,"sheet_y":40,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"270D-1F3FF","non_qualified":null,"image":"270d-1f3ff.png","sheet_x":49,"sheet_y":41,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Writing Hand","b":"270D-FE0F","c":"270D","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["lower_left_ballpoint_pen","stationery","write","compose"],"k":[49,36],"o":1},"clap":{"skin_variations":{"1F3FB":{"unified":"1F44F-1F3FB","non_qualified":null,"image":"1f44f-1f3fb.png","sheet_x":15,"sheet_y":10,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F44F-1F3FC","non_qualified":null,"image":"1f44f-1f3fc.png","sheet_x":15,"sheet_y":11,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F44F-1F3FD","non_qualified":null,"image":"1f44f-1f3fd.png","sheet_x":15,"sheet_y":12,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F44F-1F3FE","non_qualified":null,"image":"1f44f-1f3fe.png","sheet_x":15,"sheet_y":13,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F44F-1F3FF","non_qualified":null,"image":"1f44f-1f3ff.png","sheet_x":15,"sheet_y":14,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Clapping Hands Sign","b":"1F44F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["hands","praise","applause","congrats","yay"],"k":[15,9]},"open_hands":{"skin_variations":{"1F3FB":{"unified":"1F450-1F3FB","non_qualified":null,"image":"1f450-1f3fb.png","sheet_x":15,"sheet_y":16,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F450-1F3FC","non_qualified":null,"image":"1f450-1f3fc.png","sheet_x":15,"sheet_y":17,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F450-1F3FD","non_qualified":null,"image":"1f450-1f3fd.png","sheet_x":15,"sheet_y":18,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F450-1F3FE","non_qualified":null,"image":"1f450-1f3fe.png","sheet_x":15,"sheet_y":19,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F450-1F3FF","non_qualified":null,"image":"1f450-1f3ff.png","sheet_x":15,"sheet_y":20,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Open Hands Sign","b":"1F450","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fingers","butterfly","hands","open"],"k":[15,15]},"raised_hands":{"skin_variations":{"1F3FB":{"unified":"1F64C-1F3FB","non_qualified":null,"image":"1f64c-1f3fb.png","sheet_x":33,"sheet_y":13,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F64C-1F3FC","non_qualified":null,"image":"1f64c-1f3fc.png","sheet_x":33,"sheet_y":14,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F64C-1F3FD","non_qualified":null,"image":"1f64c-1f3fd.png","sheet_x":33,"sheet_y":15,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F64C-1F3FE","non_qualified":null,"image":"1f64c-1f3fe.png","sheet_x":33,"sheet_y":16,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F64C-1F3FF","non_qualified":null,"image":"1f64c-1f3ff.png","sheet_x":33,"sheet_y":17,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Person Raising Both Hands in Celebration","b":"1F64C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["gesture","hooray","yea","celebration","hands"],"k":[33,12]},"palms_up_together":{"skin_variations":{"1F3FB":{"unified":"1F932-1F3FB","non_qualified":null,"image":"1f932-1f3fb.png","sheet_x":39,"sheet_y":17,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FC":{"unified":"1F932-1F3FC","non_qualified":null,"image":"1f932-1f3fc.png","sheet_x":39,"sheet_y":18,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FD":{"unified":"1F932-1F3FD","non_qualified":null,"image":"1f932-1f3fd.png","sheet_x":39,"sheet_y":19,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FE":{"unified":"1F932-1F3FE","non_qualified":null,"image":"1f932-1f3fe.png","sheet_x":39,"sheet_y":20,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false},"1F3FF":{"unified":"1F932-1F3FF","non_qualified":null,"image":"1f932-1f3ff.png","sheet_x":39,"sheet_y":21,"added_in":"10.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":false}},"a":"Palms Up Together","b":"1F932","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[39,16],"o":10},"pray":{"skin_variations":{"1F3FB":{"unified":"1F64F-1F3FB","non_qualified":null,"image":"1f64f-1f3fb.png","sheet_x":34,"sheet_y":3,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F64F-1F3FC","non_qualified":null,"image":"1f64f-1f3fc.png","sheet_x":34,"sheet_y":4,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F64F-1F3FD","non_qualified":null,"image":"1f64f-1f3fd.png","sheet_x":34,"sheet_y":5,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F64F-1F3FE","non_qualified":null,"image":"1f64f-1f3fe.png","sheet_x":34,"sheet_y":6,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F64F-1F3FF","non_qualified":null,"image":"1f64f-1f3ff.png","sheet_x":34,"sheet_y":7,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Person with Folded Hands","b":"1F64F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["please","hope","wish","namaste","highfive"],"k":[34,2]},"handshake":{"a":"Handshake","b":"1F91D","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["agreement","shake"],"k":[38,10],"o":9},"nail_care":{"skin_variations":{"1F3FB":{"unified":"1F485-1F3FB","non_qualified":null,"image":"1f485-1f3fb.png","sheet_x":23,"sheet_y":45,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F485-1F3FC","non_qualified":null,"image":"1f485-1f3fc.png","sheet_x":23,"sheet_y":46,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F485-1F3FD","non_qualified":null,"image":"1f485-1f3fd.png","sheet_x":23,"sheet_y":47,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F485-1F3FE","non_qualified":null,"image":"1f485-1f3fe.png","sheet_x":23,"sheet_y":48,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F485-1F3FF","non_qualified":null,"image":"1f485-1f3ff.png","sheet_x":23,"sheet_y":49,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Nail Polish","b":"1F485","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["beauty","manicure","finger","fashion","nail"],"k":[23,44]},"ear":{"skin_variations":{"1F3FB":{"unified":"1F442-1F3FB","non_qualified":null,"image":"1f442-1f3fb.png","sheet_x":13,"sheet_y":46,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F442-1F3FC","non_qualified":null,"image":"1f442-1f3fc.png","sheet_x":13,"sheet_y":47,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F442-1F3FD","non_qualified":null,"image":"1f442-1f3fd.png","sheet_x":13,"sheet_y":48,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F442-1F3FE","non_qualified":null,"image":"1f442-1f3fe.png","sheet_x":13,"sheet_y":49,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F442-1F3FF","non_qualified":null,"image":"1f442-1f3ff.png","sheet_x":13,"sheet_y":50,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Ear","b":"1F442","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","hear","sound","listen"],"k":[13,45]},"nose":{"skin_variations":{"1F3FB":{"unified":"1F443-1F3FB","non_qualified":null,"image":"1f443-1f3fb.png","sheet_x":14,"sheet_y":0,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FC":{"unified":"1F443-1F3FC","non_qualified":null,"image":"1f443-1f3fc.png","sheet_x":14,"sheet_y":1,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FD":{"unified":"1F443-1F3FD","non_qualified":null,"image":"1f443-1f3fd.png","sheet_x":14,"sheet_y":2,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FE":{"unified":"1F443-1F3FE","non_qualified":null,"image":"1f443-1f3fe.png","sheet_x":14,"sheet_y":3,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true},"1F3FF":{"unified":"1F443-1F3FF","non_qualified":null,"image":"1f443-1f3ff.png","sheet_x":14,"sheet_y":4,"added_in":"8.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_emojione":true,"has_img_facebook":true,"has_img_messenger":true}},"a":"Nose","b":"1F443","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["smell","sniff"],"k":[13,51]},"footprints":{"a":"Footprints","b":"1F463","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["feet","tracking","walking","beach"],"k":[15,39]},"eyes":{"a":"Eyes","b":"1F440","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["look","watch","stalk","peek","see"],"k":[13,42]},"eye":{"a":"Eye","b":"1F441-FE0F","c":"1F441","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["face","look","see","watch","stare"],"k":[13,44],"o":7},"eye-in-speech-bubble":{"a":"Eye in Speech Bubble","b":"1F441-FE0F-200D-1F5E8-FE0F","d":true,"e":true,"f":false,"g":true,"h":false,"i":false,"k":[13,43],"o":7},"brain":{"a":"Brain","b":"1F9E0","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["smart","intelligent"],"k":[46,22],"o":10},"tongue":{"a":"Tongue","b":"1F445","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["mouth","playful"],"k":[14,6]},"lips":{"a":"Mouth","b":"1F444","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["mouth","kiss"],"k":[14,5]},"kiss":{"a":"Kiss Mark","b":"1F48B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["face","lips","love","like","affection","valentines"],"k":[24,37]},"cupid":{"a":"Heart with Arrow","b":"1F498","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["love","like","heart","affection","valentines"],"k":[24,50]},"heart":{"a":"Heavy Black Heart","b":"2764-FE0F","c":"2764","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["love","like","valentines"],"k":[50,8],"l":["<3"],"m":"<3","o":1},"heartbeat":{"a":"Beating Heart","b":"1F493","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["love","like","affection","valentines","pink","heart"],"k":[24,45]},"broken_heart":{"a":"Broken Heart","b":"1F494","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sad","sorry","break","heart","heartbreak"],"k":[24,46],"l":["</3"],"m":"</3"},"two_hearts":{"a":"Two Hearts","b":"1F495","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["love","like","affection","valentines","heart"],"k":[24,47]},"sparkling_heart":{"a":"Sparkling Heart","b":"1F496","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["love","like","affection","valentines"],"k":[24,48]},"heartpulse":{"a":"Growing Heart","b":"1F497","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["like","love","affection","valentines","pink"],"k":[24,49]},"blue_heart":{"a":"Blue Heart","b":"1F499","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["love","like","affection","valentines"],"k":[24,51],"m":"<3"},"green_heart":{"a":"Green Heart","b":"1F49A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["love","like","affection","valentines"],"k":[25,0],"m":"<3"},"yellow_heart":{"a":"Yellow Heart","b":"1F49B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["love","like","affection","valentines"],"k":[25,1],"m":"<3"},"orange_heart":{"a":"Orange Heart","b":"1F9E1","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["love","like","affection","valentines"],"k":[46,23],"o":10},"purple_heart":{"a":"Purple Heart","b":"1F49C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["love","like","affection","valentines"],"k":[25,2],"m":"<3"},"black_heart":{"a":"Black Heart","b":"1F5A4","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["evil"],"k":[29,50],"o":9},"gift_heart":{"a":"Heart with Ribbon","b":"1F49D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["love","valentines"],"k":[25,3]},"revolving_hearts":{"a":"Revolving Hearts","b":"1F49E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["love","like","affection","valentines"],"k":[25,4]},"heart_decoration":{"a":"Heart Decoration","b":"1F49F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["purple-square","love","like"],"k":[25,5]},"heavy_heart_exclamation_mark_ornament":{"a":"Heavy Heart Exclamation Mark Ornament","b":"2763-FE0F","c":"2763","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[50,7],"o":1},"love_letter":{"a":"Love Letter","b":"1F48C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["email","like","affection","envelope","valentines"],"k":[24,38]},"zzz":{"a":"Sleeping Symbol","b":"1F4A4","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["sleepy","tired","dream"],"k":[25,10]},"anger":{"a":"Anger Symbol","b":"1F4A2","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["angry","mad"],"k":[25,8]},"bomb":{"a":"Bomb","b":"1F4A3","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["boom","explode","explosion","terrorism"],"k":[25,9]},"boom":{"a":"Collision Symbol","b":"1F4A5","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["bomb","explode","explosion","collision","blown"],"k":[25,11],"n":["collision"]},"sweat_drops":{"a":"Splashing Sweat Symbol","b":"1F4A6","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["water","drip","oops"],"k":[25,12]},"dash":{"a":"Dash Symbol","b":"1F4A8","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["wind","air","fast","shoo","fart","smoke","puff"],"k":[25,14]},"dizzy":{"a":"Dizzy Symbol","b":"1F4AB","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["star","sparkle","shoot","magic"],"k":[25,22]},"speech_balloon":{"a":"Speech Balloon","b":"1F4AC","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["bubble","words","message","talk","chatting"],"k":[25,23]},"left_speech_bubble":{"a":"Left Speech Bubble","b":"1F5E8-FE0F","c":"1F5E8","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["words","message","talk","chatting"],"k":[30,15],"o":7},"right_anger_bubble":{"a":"Right Anger Bubble","b":"1F5EF-FE0F","c":"1F5EF","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["caption","speech","thinking","mad"],"k":[30,16],"o":7},"thought_balloon":{"a":"Thought Balloon","b":"1F4AD","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["bubble","cloud","speech","thinking","dream"],"k":[25,24]},"hole":{"a":"Hole","b":"1F573-FE0F","c":"1F573","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["embarrassing"],"k":[28,44],"o":7},"eyeglasses":{"a":"Eyeglasses","b":"1F453","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fashion","accessories","eyesight","nerdy","dork","geek"],"k":[15,23]},"dark_sunglasses":{"a":"Dark Sunglasses","b":"1F576-FE0F","c":"1F576","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["face","cool","accessories"],"k":[29,17],"o":7},"necktie":{"a":"Necktie","b":"1F454","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shirt","suitup","formal","fashion","cloth","business"],"k":[15,24]},"shirt":{"a":"T-Shirt","b":"1F455","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"k":[15,25],"n":["tshirt"]},"jeans":{"a":"Jeans","b":"1F456","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fashion","shopping"],"k":[15,26]},"scarf":{"a":"Scarf","b":"1F9E3","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["neck","winter","clothes"],"k":[46,25],"o":10},"gloves":{"a":"Gloves","b":"1F9E4","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["hands","winter","clothes"],"k":[46,26],"o":10},"coat":{"a":"Coat","b":"1F9E5","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["jacket"],"k":[46,27],"o":10},"socks":{"a":"Socks","b":"1F9E6","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["stockings","clothes"],"k":[46,28],"o":10},"dress":{"a":"Dress","b":"1F457","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["clothes","fashion","shopping"],"k":[15,27]},"kimono":{"a":"Kimono","b":"1F458","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["dress","fashion","women","female","japanese"],"k":[15,28]},"bikini":{"a":"Bikini","b":"1F459","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["swimming","female","woman","girl","fashion","beach","summer"],"k":[15,29]},"womans_clothes":{"a":"Womans Clothes","b":"1F45A","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fashion","shopping_bags","female"],"k":[15,30]},"purse":{"a":"Purse","b":"1F45B","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fashion","accessories","money","sales","shopping"],"k":[15,31]},"handbag":{"a":"Handbag","b":"1F45C","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fashion","accessory","accessories","shopping"],"k":[15,32]},"pouch":{"a":"Pouch","b":"1F45D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["bag","accessories","shopping"],"k":[15,33]},"shopping_bags":{"a":"Shopping Bags","b":"1F6CD-FE0F","c":"1F6CD","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[37,2],"o":7},"school_satchel":{"a":"School Satchel","b":"1F392","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["student","education","bag","backpack"],"k":[8,37]},"mans_shoe":{"a":"Mans Shoe","b":"1F45E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fashion","male"],"k":[15,34],"n":["shoe"]},"athletic_shoe":{"a":"Athletic Shoe","b":"1F45F","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shoes","sports","sneakers"],"k":[15,35]},"high_heel":{"a":"High-Heeled Shoe","b":"1F460","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fashion","shoes","female","pumps","stiletto"],"k":[15,36]},"sandal":{"a":"Womans Sandal","b":"1F461","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shoes","fashion","flip flops"],"k":[15,37]},"boot":{"a":"Womans Boots","b":"1F462","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["shoes","fashion"],"k":[15,38]},"crown":{"a":"Crown","b":"1F451","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["king","kod","leader","royalty","lord"],"k":[15,21]},"womans_hat":{"a":"Womans Hat","b":"1F452","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["fashion","accessories","female","lady","spring"],"k":[15,22]},"tophat":{"a":"Top Hat","b":"1F3A9","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["magic","gentleman","classy","circus"],"k":[9,3]},"mortar_board":{"a":"Graduation Cap","b":"1F393","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["school","college","degree","university","graduation","cap","hat","legal","learn","education"],"k":[8,38]},"billed_cap":{"a":"Billed Cap","b":"1F9E2","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[46,24],"o":10},"helmet_with_white_cross":{"a":"Helmet with White Cross","b":"26D1-FE0F","c":"26D1","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"k":[48,33],"o":5},"prayer_beads":{"a":"Prayer Beads","b":"1F4FF","d":true,"e":true,"f":true,"g":true,"h":true,"i":false,"j":["dhikr","religious"],"k":[27,1],"o":8},"lipstick":{"a":"Lipstick","b":"1F484","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["female","girl","fashion","woman"],"k":[23,43]},"ring":{"a":"Ring","b":"1F48D","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["wedding","propose","marriage","valentines","diamond","fashion","jewelry","gem","engagement"],"k":[24,39]},"gem":{"a":"Gem Stone","b":"1F48E","d":true,"e":true,"f":true,"g":true,"h":true,"i":true,"j":["blue","ruby","diamond","jewelry"],"k":[24,40]}},"aliases":{"satisfied":"laughing","grinning_face_with_star_eyes":"star-struck","face_with_one_eyebrow_raised":"face_with_raised_eyebrow","telephone":"phone","cooking":"fried_egg","paw_prints":"feet","flag-cn":"cn","lantern":"izakaya_lantern","shocked_face_with_exploding_head":"exploding_head","open_book":"book","flag-de":"de","grinning_face_with_one_large_and_one_small_eye":"zany_face","serious_face_with_symbols_covering_mouth":"face_with_symbols_on_mouth","flipper":"dolphin","face_with_open_mouth_vomiting":"face_vomiting","flag-es":"es","face_with_finger_covering_closed_lips":"shushing_face","smiling_face_with_smiling_eyes_and_hand_covering_mouth":"face_with_hand_over_mouth","flag-fr":"fr","honeybee":"bee","red_car":"car","uk":"gb","flag-gb":"gb","envelope":"email","poop":"hankey","shit":"hankey","staff_of_aesculapius":"medical_symbol","knife":"hocho","sailboat":"boat","pencil":"memo","flag-it":"it","flag-jp":"jp","heavy_exclamation_mark":"exclamation","flag-kr":"kr","waxing_gibbous_moon":"moon","mother_christmas":"mrs_claus","sun_small_cloud":"mostly_sunny","sun_behind_cloud":"barely_sunny","sun_behind_rain_cloud":"partly_sunny_rain","lightning_cloud":"lightning","tornado_cloud":"tornado","flag-ru":"ru","running":"runner","flag-us":"us","man_and_woman_holding_hands":"couple","man-woman-boy":"family","family":"man-woman-boy","reversed_hand_with_middle_finger_extended":"middle_finger","hand_with_index_and_middle_fingers_crossed":"crossed_fingers","sign_of_the_horns":"the_horns","raised_hand":"hand","thumbsup":"+1","thumbsdown":"-1","punch":"facepunch","collision":"boom","tshirt":"shirt","shoe":"mans_shoe"}}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NAMESPACE = 'emoji-mart';

var _JSON = JSON;

var isLocalStorageSupported = typeof window !== 'undefined' && 'localStorage' in window;

var getter = void 0;
var setter = void 0;

function setHandlers(handlers) {
  handlers || (handlers = {});

  getter = handlers.getter;
  setter = handlers.setter;
}

function setNamespace(namespace) {
  NAMESPACE = namespace;
}

function update(state) {
  for (var key in state) {
    var value = state[key];
    set(key, value);
  }
}

function set(key, value) {
  if (setter) {
    setter(key, value);
  } else {
    if (!isLocalStorageSupported) return;
    try {
      window.localStorage[NAMESPACE + '.' + key] = _JSON.stringify(value);
    } catch (e) {}
  }
}

function get(key) {
  if (getter) {
    return getter(key);
  } else {
    if (!isLocalStorageSupported) return;
    try {
      var value = window.localStorage[NAMESPACE + '.' + key];
    } catch (e) {
      return;
    }

    if (value) {
      return JSON.parse(value);
    }
  }
}

exports.default = { update: update, set: set, get: get, setNamespace: setNamespace, setHandlers: setHandlers };

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_anchors_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_anchors_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_anchors_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_anchors_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_anchors_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51188104_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_anchors_vue__ = __webpack_require__(79);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(73)
  __webpack_require__(76)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51188104"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_anchors_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51188104_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_anchors_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/anchors.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-51188104", Component.options)
  } else {
    hotAPI.reload("data-v-51188104", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svgs = __webpack_require__(78);

var _svgs2 = _interopRequireDefault(_svgs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    i18n: {
      type: Object,
      required: true
    },
    color: {
      type: String
    },
    categories: {
      type: Array,
      required: true
    },
    activeCategory: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    this.svgs = _svgs2.default;
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_category_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_category_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_category_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_category_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_category_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376cda0e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_category_vue__ = __webpack_require__(120);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(80)
  __webpack_require__(82)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-376cda0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_category_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376cda0e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_category_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/category.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-376cda0e", Component.options)
  } else {
    hotAPI.reload("data-v-376cda0e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nimbleEmoji = __webpack_require__(18);

var _nimbleEmoji2 = _interopRequireDefault(_nimbleEmoji);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    data: {
      type: Object,
      required: true
    },
    i18n: {
      type: Object,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    emojis: {
      type: Array
    },
    emojiProps: {
      type: Object,
      required: true
    }
  },
  computed: {
    isVisible: function isVisible() {
      return !!this.emojis;
    },
    isSearch: function isSearch() {
      return this.name == 'Search';
    },
    hasResults: function hasResults() {
      return this.emojis.length > 0;
    }
  },
  components: {
    NimbleEmoji: _nimbleEmoji2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

var _utils = __webpack_require__(20);

var _data = __webpack_require__(24);

var _sharedProps = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHEET_COLUMNS = 52; //
//
//
//
//
//
//
//
//
//
//


exports.default = {
  props: (0, _extends3.default)({}, _sharedProps.EmojiProps, {
    data: {
      type: Object,
      required: true
    }
  }),
  data: function data() {
    return {
      mutableData: this.data.compressed ? (0, _data.uncompress)(this.data) : this.data
    };
  },

  computed: {
    emojiData: function emojiData() {
      return (0, _utils.getData)(this.emoji, this.skin, this.set, this.mutableData);
    },
    sanitizedData: function sanitizedData() {
      return (0, _utils.getSanitizedData)(this.emoji, this.skin, this.set, this.mutableData);
    },
    canRender: function canRender() {
      return this.isCustom || this.isNative || this.hasEmoji || this.fallback;
    },
    isNative: function isNative() {
      return this.native;
    },
    isCustom: function isCustom() {
      return this.emojiData.custom;
    },
    hasEmoji: function hasEmoji() {
      return this.emojiData['has_img_' + this.set];
    },
    nativeEmoji: function nativeEmoji() {
      if (this.emojiData.unified) {
        return (0, _utils.unifiedToNative)(this.emojiData.unified);
      } else {
        return '';
      }
    },
    fallbackEmoji: function fallbackEmoji() {
      return this.fallback ? this.fallback(this.emoji) : null;
    },
    nativeEmojiStyles: function nativeEmojiStyles() {
      var styles = { fontSize: this.size + 'px' };

      if (this.forceSize) {
        styles.display = 'inline-block';
        styles.width = this.size + 'px';
        styles.height = this.size + 'px';
      }

      return styles;
    },
    fallbackEmojiStyles: function fallbackEmojiStyles() {
      if (this.isCustom) {
        return this.customEmojiStyles;
      } else if (this.hasEmoji) {
        return {
          display: 'inline-block',
          width: this.size + 'px',
          height: this.size + 'px',
          backgroundImage: 'url(' + this.backgroundImageFn(this.set, this.sheetSize) + ')',
          backgroundSize: 100 * SHEET_COLUMNS + '%',
          backgroundPosition: this.getPosition()
        };
      } else {
        return null;
      }
    },
    customEmojiStyles: function customEmojiStyles() {
      return {
        display: 'inline-block',
        width: this.size + 'px',
        height: this.size + 'px',
        backgroundImage: 'url(' + this.emojiData.imageUrl + ')',
        backgroundSize: '100%'
      };
    },
    title: function title() {
      return this.tooltip ? this.emojiData.short_names[0] : null;
    }
  },
  methods: {
    getPosition: function getPosition() {
      var multiply = 100 / (SHEET_COLUMNS - 1),
          x = multiply * this.emojiData.sheet_x,
          y = multiply * this.emojiData.sheet_y;

      return x + '% ' + y + '%';
    },
    onClick: function onClick() {
      this.$emit('click', this.sanitizedData);
    },
    onMouseEnter: function onMouseEnter() {
      this.$emit('mouseenter', this.sanitizedData);
    },
    onMouseLeave: function onMouseLeave() {
      this.$emit('mouseleave', this.sanitizedData);
    }
  }
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(29);
var $export = __webpack_require__(13);
var redefine = __webpack_require__(51);
var hide = __webpack_require__(8);
var has = __webpack_require__(7);
var Iterators = __webpack_require__(16);
var $iterCreate = __webpack_require__(91);
var setToStringTag = __webpack_require__(35);
var getPrototypeOf = __webpack_require__(96);
var ITERATOR = __webpack_require__(2)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(90);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(10) && !__webpack_require__(11)(function () {
  return Object.defineProperty(__webpack_require__(50)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var document = __webpack_require__(5).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(8);


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(9);
var dPs = __webpack_require__(92);
var enumBugKeys = __webpack_require__(34);
var IE_PROTO = __webpack_require__(32)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(50)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(95).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(7);
var toIObject = __webpack_require__(12);
var arrayIndexOf = __webpack_require__(93)(false);
var IE_PROTO = __webpack_require__(32)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(31);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(27);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(97);
var global = __webpack_require__(5);
var hide = __webpack_require__(8);
var Iterators = __webpack_require__(16);
var TO_STRING_TAG = __webpack_require__(2)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(53);
var hiddenKeys = __webpack_require__(34).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(115), __esModule: true };

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preview_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preview_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preview_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preview_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35056c30_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preview_vue__ = __webpack_require__(126);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(121)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35056c30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preview_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35056c30_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/preview.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-35056c30", Component.options)
  } else {
    hotAPI.reload("data-v-35056c30", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nimbleEmoji = __webpack_require__(18);

var _nimbleEmoji2 = _interopRequireDefault(_nimbleEmoji);

var _skins = __webpack_require__(61);

var _skins2 = _interopRequireDefault(_skins);

var _utils = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    data: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    emoji: {
      type: [String, Object]
    },
    idleEmoji: {
      type: [String, Object],
      required: true
    },
    showSkinTones: {
      type: Boolean,
      default: true
    },
    emojiProps: {
      type: Object,
      required: true
    },
    skinProps: {
      type: Object,
      required: true
    }
  },
  computed: {
    emojiData: function emojiData() {
      if (this.emoji && this.emoji.custom) {
        return this.emoji;
      } else if (this.emoji) {
        return (0, _utils.getData)(this.emoji, null, null, this.data);
      } else {
        return {};
      }
    },
    emojiShortNames: function emojiShortNames() {
      return this.emojiData.short_names;
    },
    emojiEmoticons: function emojiEmoticons() {
      return this.emojiData.emoticons;
    }
  },
  components: {
    NimbleEmoji: _nimbleEmoji2.default,
    Skins: _skins2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_skins_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_skins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_skins_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_skins_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_skins_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c614894_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_skins_vue__ = __webpack_require__(125);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(123)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c614894"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_skins_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c614894_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_skins_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/skins.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1c614894", Component.options)
  } else {
    hotAPI.reload("data-v-1c614894", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//


exports.default = {
  props: {
    skin: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      opened: false
    };
  },

  methods: {
    onClick: function onClick(skinTone) {
      if (this.opened) {
        if (skinTone != this.skin) {
          this.$emit('change', skinTone);
        }
      }

      this.opened = !this.opened;
    }
  }
};

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ad41bb8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__ = __webpack_require__(131);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(127)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ad41bb8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ad41bb8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/search.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4ad41bb8", Component.options)
  } else {
    hotAPI.reload("data-v-4ad41bb8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nimbleEmojiIndex = __webpack_require__(39);

var _nimbleEmojiIndex2 = _interopRequireDefault(_nimbleEmojiIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    data: {
      type: Object,
      required: true
    },
    i18n: {
      type: Object,
      required: true
    },
    maxResults: {
      type: Number,
      default: 75
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    emojisToShowFilter: {
      type: Function
    },
    include: {
      type: Array
    },
    exclude: {
      type: Array
    },
    custom: {
      type: Array
    }
  },
  data: function data() {
    return {
      value: ''
    };
  },

  computed: {
    emojiIndex: function emojiIndex() {
      return new _nimbleEmojiIndex2.default(this.data);
    }
  },
  watch: {
    value: function value() {
      var emojis = this.emojiIndex.search(this.value, {
        emojisToShowFilter: this.emojisToShowFilter,
        maxResults: this.maxResults,
        include: this.include,
        exclude: this.exclude,
        custom: this.custom
      });

      this.$emit('search', emojis);
    }
  },
  methods: {
    clear: function clear() {
      this.value = '';
    }
  },
  mounted: function mounted() {
    var $input = this.$el.querySelector('input');

    if (this.autoFocus) {
      $input.focus();
    }
  }
}; //
//
//
//
//
//
//
//

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

var _all = __webpack_require__(40);

var _all2 = _interopRequireDefault(_all);

var _nimbleEmoji = __webpack_require__(18);

var _nimbleEmoji2 = _interopRequireDefault(_nimbleEmoji);

var _sharedProps = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  functional: true,
  props: (0, _extends3.default)({}, _sharedProps.EmojiProps, {
    data: {
      type: Object,
      default: function _default() {
        return _all2.default;
      }
    }
  }),
  render: function render(h, ctx) {
    var data = ctx.data;
    var props = ctx.props;
    var children = ctx.children;


    return h(_nimbleEmoji2.default, (0, _extends3.default)({}, data, { props: props }), children);
  }
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

var _all = __webpack_require__(40);

var _all2 = _interopRequireDefault(_all);

var _nimblePicker = __webpack_require__(67);

var _nimblePicker2 = _interopRequireDefault(_nimblePicker);

var _sharedProps = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  functional: true,
  props: (0, _extends3.default)({}, _sharedProps.PickerProps, {
    data: {
      type: Object,
      default: function _default() {
        return _all2.default;
      }
    }
  }),
  render: function render(h, ctx) {
    var data = ctx.data;
    var props = ctx.props;
    var children = ctx.children;


    return h(_nimblePicker2.default, (0, _extends3.default)({}, data, { props: props }), children);
  }
};

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nimblePicker_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nimblePicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nimblePicker_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nimblePicker_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nimblePicker_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc71df8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nimblePicker_vue__ = __webpack_require__(151);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(134)
  __webpack_require__(136)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bc71df8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nimblePicker_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc71df8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nimblePicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/picker/nimblePicker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7bc71df8", Component.options)
  } else {
    hotAPI.reload("data-v-7bc71df8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(138);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getIterator2 = __webpack_require__(147);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(58);

var _assign2 = _interopRequireDefault(_assign);

__webpack_require__(150);

var _store = __webpack_require__(41);

var _store2 = _interopRequireDefault(_store);

var _frequently = __webpack_require__(70);

var _frequently2 = _interopRequireDefault(_frequently);

var _utils = __webpack_require__(20);

var _data = __webpack_require__(24);

var _sharedProps = __webpack_require__(25);

var _anchors = __webpack_require__(42);

var _anchors2 = _interopRequireDefault(_anchors);

var _category = __webpack_require__(44);

var _category2 = _interopRequireDefault(_category);

var _preview = __webpack_require__(59);

var _preview2 = _interopRequireDefault(_preview);

var _search = __webpack_require__(63);

var _search2 = _interopRequireDefault(_search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var RECENT_CATEGORY = { id: 'recent', name: 'Recent', emojis: null };
var CUSTOM_CATEGORY = { id: 'custom', name: 'Custom', emojis: [] };

var I18N = {
  search: 'Search',
  notfound: 'No Emoji Found',
  categories: {
    search: 'Search Results',
    recent: 'Frequently Used',
    people: 'Smileys & People',
    nature: 'Animals & Nature',
    foods: 'Food & Drink',
    activity: 'Activity',
    places: 'Travel & Places',
    objects: 'Objects',
    symbols: 'Symbols',
    flags: 'Flags',
    custom: 'Custom'
  }
};

function makeCustomEmoji(emoji) {
  return (0, _assign2.default)({}, emoji, {
    id: emoji.short_names[0],
    custom: true
  });
}

exports.default = {
  props: (0, _extends3.default)({}, _sharedProps.PickerProps, {
    data: {
      type: Object,
      required: true
    }
  }),
  data: function data() {
    var _this = this;

    var customEmojis = this.custom.map(makeCustomEmoji),
        recentEmojis = this.recent || _frequently2.default.get(this.perLine);

    if (recentEmojis.length) {
      recentEmojis = recentEmojis.map(function (id) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(customEmojis), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var customEmoji = _step.value;

            if (customEmoji.id === id) {
              return customEmoji;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return id;
      });
    }

    if (this.emojisToShowFilter) {
      customEmojis = customEmojis.filter(function (e) {
        return _this.emojisToShowFilter(_this.mutableData.emojis[e] || e);
      });
      recentEmojis = recentEmojis.filter(function (e) {
        return _this.emojisToShowFilter(_this.mutableData.emojis[e] || e);
      });
    }

    return {
      mutableData: this.data.compressed ? (0, _data.uncompress)(this.data) : this.data,
      mutableI18n: (0, _utils.deepMerge)(I18N, this.i18n),
      activeSkin: this.skin || _store2.default.get('skin') || this.defaultSkin,
      categories: [],
      activeCategory: null,
      previewEmoji: null,
      searchEmojis: null,
      customEmojis: customEmojis,
      recentEmojis: recentEmojis
    };
  },

  computed: {
    customStyles: function customStyles() {
      return (0, _extends3.default)({
        width: this.calculateWidth + 'px'
      }, this.pickerStyles);
    },
    emojiProps: function emojiProps() {
      return {
        native: this.native,
        skin: this.activeSkin,
        size: this.emojiSize,
        set: this.set,
        sheetSize: this.sheetSize,
        forceSize: this.native,
        tooltip: this.emojiTooltip,
        backgroundImageFn: this.backgroundImageFn,
        onEnter: this.onEmojiEnter.bind(this),
        onLeave: this.onEmojiLeave.bind(this),
        onClick: this.onEmojiClick.bind(this)
      };
    },
    skinProps: function skinProps() {
      return {
        skin: this.activeSkin
      };
    },
    calculateWidth: function calculateWidth() {
      return this.perLine * (this.emojiSize + 12) + 12 + 2 + (0, _utils.measureScrollbar)();
    },
    filteredCategories: function filteredCategories() {
      var _this2 = this;

      return this.categories.filter(function (category) {
        var isIncluded = _this2.include && _this2.include.length ? _this2.include.indexOf(category.id) > -1 : true;
        var isExcluded = _this2.exclude && _this2.exclude.length ? _this2.exclude.indexOf(category.id) > -1 : false;
        var hasEmojis = category.emojis.length > 0;

        if (_this2.emojisToShowFilter) {
          hasEmojis = category.emojis.some(function (emoji) {
            return _this2.emojisToShowFilter(_this2.mutableData.emojis[emoji] || emoji);
          });
        }

        return isIncluded && !isExcluded && hasEmojis;
      });
    }
  },
  created: function created() {
    var _this3 = this,
        _categories;

    var categories = this.mutableData.categories.map(function (c) {
      var id = c.id;
      var name = c.name;
      var emojis = c.emojis;


      if (_this3.emojisToShowFilter) {
        emojis = c.emojis.filter(function (e) {
          return _this3.emojisToShowFilter(_this3.data.emojis[e] || e);
        });
      }

      return { id: id, name: name, emojis: emojis };
    });

    RECENT_CATEGORY.emojis = this.recentEmojis;
    CUSTOM_CATEGORY.emojis = this.customEmojis;

    this.categories.push(RECENT_CATEGORY);
    (_categories = this.categories).push.apply(_categories, (0, _toConsumableArray3.default)(categories));
    this.categories.push(CUSTOM_CATEGORY);

    this.categories[0].first = true;
    this.activeCategory = this.filteredCategories[0];
  },

  methods: {
    onScroll: function onScroll() {
      if (this.infiniteScroll && !this.waitingForPaint) {
        this.waitingForPaint = true;
        window.requestAnimationFrame(this.onScrollPaint.bind(this));
      }
    },
    onScrollPaint: function onScrollPaint() {
      this.waitingForPaint = false;

      var scrollTop = this.$refs.scroll.scrollTop,
          activeCategory = this.filteredCategories[0];

      for (var i = 0, l = this.filteredCategories.length; i < l; i++) {
        var category = this.filteredCategories[i],
            component = this.$refs.categories[i];

        if (component && component.$el.offsetTop > scrollTop) {
          break;
        }

        activeCategory = category;
      }

      this.activeCategory = activeCategory;
    },
    onAnchorClick: function onAnchorClick(category) {
      var _this4 = this;

      var i = this.filteredCategories.indexOf(category),
          component = this.$refs.categories[i],
          scrollToComponent = function scrollToComponent() {
        if (component) {
          var top = component.$el.offsetTop;

          if (category.first) {
            top = 0;
          }

          _this4.$refs.scroll.scrollTop = top;
        }
      };

      if (this.searchEmojis) {
        this.onSearch(null);
        this.$refs.search.clear();

        this.$nextTick(scrollToComponent);
      } else if (this.infiniteScroll) {
        scrollToComponent();
      } else {
        this.activeCategory = this.filteredCategories[i];
      }
    },
    onSearch: function onSearch(emojis) {
      this.searchEmojis = emojis;
    },
    onEmojiEnter: function onEmojiEnter(emoji) {
      if (emoji.custom) {
        // Use Array.prototype.find() when it is more widely supported.
        var customEmoji = this.customEmojis.filter(function (_emoji) {
          return _emoji.id === emoji.id;
        })[0];
        emoji = (0, _assign2.default)({}, emoji, customEmoji);
      }

      this.previewEmoji = emoji;
    },
    onEmojiLeave: function onEmojiLeave(emoji) {
      this.previewEmoji = null;
    },
    onEmojiClick: function onEmojiClick(emoji) {
      this.$emit('select', emoji);
      _frequently2.default.add(emoji);
    },
    onSkinChange: function onSkinChange(skin) {
      this.activeSkin = skin;
      _store2.default.update({ skin: skin });

      this.$emit('skin-change', skin);
    }
  },
  components: {
    Anchors: _anchors2.default,
    Category: _category2.default,
    Preview: _preview2.default,
    Search: _search2.default
  }
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(145);
var ITERATOR = __webpack_require__(2)('iterator');
var Iterators = __webpack_require__(16);
module.exports = __webpack_require__(4).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _store = __webpack_require__(41);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULTS = ['+1', 'grinning', 'kissing_heart', 'heart_eyes', 'laughing', 'stuck_out_tongue_winking_eye', 'sweat_smile', 'joy', 'scream', 'disappointed', 'unamused', 'weary', 'sob', 'sunglasses', 'heart', 'poop'];

var frequently = void 0,
    initialized = void 0;
var defaults = {};

function init() {
  initialized = true;
  frequently = _store2.default.get('frequently');
}

function add(emoji) {
  if (!initialized) init();
  var id = emoji.id;


  frequently || (frequently = defaults);
  frequently[id] || (frequently[id] = 0);
  frequently[id] += 1;

  _store2.default.set('last', id);
  _store2.default.set('frequently', frequently);
}

function get(perLine) {
  if (!initialized) init();
  if (!frequently) {
    defaults = {};

    var result = [];

    for (var i = 0; i < perLine; i++) {
      defaults[DEFAULTS[i]] = perLine - i;
      result.push(DEFAULTS[i]);
    }

    return result;
  }

  var quantity = perLine * 4;
  var frequentlyKeys = [];

  for (var key in frequently) {
    if (frequently.hasOwnProperty(key)) {
      frequentlyKeys.push(key);
    }
  }

  var sorted = frequentlyKeys.sort(function (a, b) {
    return frequently[a] - frequently[b];
  }).reverse();
  var sliced = sorted.slice(0, quantity);

  var last = _store2.default.get('last');

  if (last && sliced.indexOf(last) == -1) {
    sliced.pop();
    sliced.push(last);
  }

  return sliced;
}

exports.default = { add: add, get: get };

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.frequently = exports.store = exports.emojiIndex = exports.NimbleEmojiIndex = exports.Category = exports.NimbleEmoji = exports.Emoji = exports.NimblePicker = exports.Picker = undefined;

var _components = __webpack_require__(72);

Object.defineProperty(exports, 'Picker', {
  enumerable: true,
  get: function get() {
    return _components.Picker;
  }
});
Object.defineProperty(exports, 'NimblePicker', {
  enumerable: true,
  get: function get() {
    return _components.NimblePicker;
  }
});
Object.defineProperty(exports, 'Emoji', {
  enumerable: true,
  get: function get() {
    return _components.Emoji;
  }
});
Object.defineProperty(exports, 'NimbleEmoji', {
  enumerable: true,
  get: function get() {
    return _components.NimbleEmoji;
  }
});
Object.defineProperty(exports, 'Category', {
  enumerable: true,
  get: function get() {
    return _components.Category;
  }
});

var _nimbleEmojiIndex = __webpack_require__(39);

Object.defineProperty(exports, 'NimbleEmojiIndex', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_nimbleEmojiIndex).default;
  }
});

var _emojiIndex = __webpack_require__(152);

var _emojiIndex2 = _interopRequireDefault(_emojiIndex);

var _store = __webpack_require__(41);

var _store2 = _interopRequireDefault(_store);

var _frequently = __webpack_require__(70);

var _frequently2 = _interopRequireDefault(_frequently);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.emojiIndex = _emojiIndex2.default;
exports.store = _store2.default;
exports.frequently = _frequently2.default;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _anchors = __webpack_require__(42);

Object.defineProperty(exports, 'Anchors', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_anchors).default;
  }
});

var _category = __webpack_require__(44);

Object.defineProperty(exports, 'Category', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_category).default;
  }
});

var _preview = __webpack_require__(59);

Object.defineProperty(exports, 'Preview', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_preview).default;
  }
});

var _search = __webpack_require__(63);

Object.defineProperty(exports, 'Search', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_search).default;
  }
});

var _skins = __webpack_require__(61);

Object.defineProperty(exports, 'Skins', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_skins).default;
  }
});

var _emoji = __webpack_require__(132);

Object.defineProperty(exports, 'Emoji', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_emoji).default;
  }
});

var _nimbleEmoji = __webpack_require__(18);

Object.defineProperty(exports, 'NimbleEmoji', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_nimbleEmoji).default;
  }
});

var _picker = __webpack_require__(133);

Object.defineProperty(exports, 'Picker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_picker).default;
  }
});

var _nimblePicker = __webpack_require__(67);

Object.defineProperty(exports, 'NimblePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_nimblePicker).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(74);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("42627c02", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-51188104\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./anchors.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-51188104\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./anchors.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "\n.emoji-mart-anchors[data-v-51188104] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  padding: 0 6px;\n  color: #858585;\n  line-height: 0;\n}\n.emoji-mart-anchor[data-v-51188104] {\n  position: relative;\n  display: block;\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  text-align: center;\n  padding: 12px 4px;\n  overflow: hidden;\n  transition: color .1s ease-out;\n}\n.emoji-mart-anchor[data-v-51188104]:hover,\n.emoji-mart-anchor-selected[data-v-51188104] {\n  color: #464646;\n}\n.emoji-mart-anchor-selected .emoji-mart-anchor-bar[data-v-51188104] {\n  bottom: 0;\n}\n.emoji-mart-anchor-bar[data-v-51188104] {\n  position: absolute;\n  bottom: -3px; left: 0;\n  width: 100%; height: 3px;\n  background-color: #464646;\n}\n.emoji-mart-anchors i[data-v-51188104] {\n  display: inline-block;\n  width: 100%;\n  max-width: 22px;\n}\n\n", ""]);

// exports


/***/ }),
/* 75 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(77);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("26752f80", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-51188104\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./anchors.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-51188104\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./anchors.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "\n.emoji-mart-anchors svg {\n  fill: currentColor;\n  max-height: 18px;\n}\n\n", ""]);

// exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SVGs = {
  activity: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113\"/></svg>",

  custom: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><g transform=\"translate(2.000000, 1.000000)\"><rect id=\"Rectangle\" x=\"8\" y=\"0\" width=\"3\" height=\"21\" rx=\"1.5\"></rect><rect id=\"Rectangle\" transform=\"translate(9.843, 10.549) rotate(60) translate(-9.843, -10.549) \" x=\"8.343\" y=\"0.049\" width=\"3\" height=\"21\" rx=\"1.5\"></rect><rect id=\"Rectangle\" transform=\"translate(9.843, 10.549) rotate(-60) translate(-9.843, -10.549) \" x=\"8.343\" y=\"0.049\" width=\"3\" height=\"21\" rx=\"1.5\"></rect></g></svg>",

  flags: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z\"/></svg>",

  foods: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9\"/></svg>",

  nature: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8\"/><path d=\"M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235\"/></svg>",

  objects: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z\"/><path d=\"M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789\"/></svg>",

  people: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10\"/><path d=\"M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0\"/></svg>",

  places: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5\"/><path d=\"M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z\"/></svg>",

  recent: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z\"/><path d=\"M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10\"/></svg>",

  symbols: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76\"/></svg>"
};

exports.default = SVGs;

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "emoji-mart-anchors" },
    _vm._l(_vm.categories, function(category) {
      return _c(
        "span",
        {
          key: category.id,
          class: {
            "emoji-mart-anchor": true,
            "emoji-mart-anchor-selected": category.id == _vm.activeCategory.id
          },
          style: {
            color: category.id == _vm.activeCategory.id ? _vm.color : ""
          },
          attrs: { title: _vm.i18n.categories[category.id] },
          on: {
            click: function($event) {
              _vm.$emit("click", category)
            }
          }
        },
        [
          _c("div", { domProps: { innerHTML: _vm._s(_vm.svgs[category.id]) } }),
          _vm._v(" "),
          _c("span", {
            staticClass: "emoji-mart-anchor-bar",
            style: { backgroundColor: _vm.color }
          })
        ]
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51188104", esExports)
  }
}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(81);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("098a12ee", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-376cda0e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./category.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-376cda0e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./category.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "\n.emoji-mart-category[data-v-376cda0e] {\n  position: relative;\n}\n.emoji-mart-category-label[data-v-376cda0e] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n}\n.emoji-mart-category .emoji-mart-emoji[data-v-376cda0e]:before {\n  z-index: 0;\n  content: \"\";\n  position: absolute;\n  top: 0; left: 0;\n  width: 100%; height: 100%;\n  background-color: #f4f4f4;\n  border-radius: 100%;\n  opacity: 0;\n}\n.emoji-mart-category .emoji-mart-emoji[data-v-376cda0e]:hover:before {\n  opacity: 1;\n}\n.emoji-mart-category-label[data-v-376cda0e] {\n  z-index: 2;\n  position: relative;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n}\n.emoji-mart-category-label span[data-v-376cda0e] {\n  display: block;\n  width: 100%;\n  font-weight: 500;\n  padding: 5px 6px;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, .95);\n}\n.emoji-mart-no-results[data-v-376cda0e] {\n  font-size: 14px;\n  text-align: center;\n  padding-top: 70px;\n  color: #858585;\n}\n.emoji-mart-no-results .emoji-mart-category-label[data-v-376cda0e] {\n  display: none;\n}\n.emoji-mart-no-results .emoji-mart-no-results-label[data-v-376cda0e] {\n  margin-top: .2em;\n}\n.emoji-mart-no-results .emoji-mart-emoji[data-v-376cda0e]:hover:before {\n  content: none;\n}\n\n", ""]);

// exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(83);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("711019be", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-376cda0e\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./category.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-376cda0e\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./category.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "\n.emoji-mart-category .emoji-mart-emoji span {\n  z-index: 1;\n  position: relative;\n  text-align: center;\n  cursor: default;\n}\n\n", ""]);

// exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(85);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("64dbedc1", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7f853594\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./nimbleEmoji.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7f853594\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./nimbleEmoji.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "\n.emoji-mart-emoji[data-v-7f853594] {\n  position: relative;\n  display: inline-block;\n  font-size: 0;\n}\n\n", ""]);

// exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(87);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(100);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(88), __esModule: true };

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(26);
__webpack_require__(56);
module.exports = __webpack_require__(36).f('iterator');


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(27);
var defined = __webpack_require__(28);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(52);
var descriptor = __webpack_require__(15);
var setToStringTag = __webpack_require__(35);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(8)(IteratorPrototype, __webpack_require__(2)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(6);
var anObject = __webpack_require__(9);
var getKeys = __webpack_require__(17);

module.exports = __webpack_require__(10) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(12);
var toLength = __webpack_require__(55);
var toAbsoluteIndex = __webpack_require__(94);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(27);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(5).document;
module.exports = document && document.documentElement;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(7);
var toObject = __webpack_require__(22);
var IE_PROTO = __webpack_require__(32)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(98);
var step = __webpack_require__(99);
var Iterators = __webpack_require__(16);
var toIObject = __webpack_require__(12);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(47)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(101), __esModule: true };

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(102);
__webpack_require__(108);
__webpack_require__(109);
__webpack_require__(110);
module.exports = __webpack_require__(4).Symbol;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(5);
var has = __webpack_require__(7);
var DESCRIPTORS = __webpack_require__(10);
var $export = __webpack_require__(13);
var redefine = __webpack_require__(51);
var META = __webpack_require__(103).KEY;
var $fails = __webpack_require__(11);
var shared = __webpack_require__(33);
var setToStringTag = __webpack_require__(35);
var uid = __webpack_require__(21);
var wks = __webpack_require__(2);
var wksExt = __webpack_require__(36);
var wksDefine = __webpack_require__(37);
var enumKeys = __webpack_require__(104);
var isArray = __webpack_require__(105);
var anObject = __webpack_require__(9);
var isObject = __webpack_require__(14);
var toIObject = __webpack_require__(12);
var toPrimitive = __webpack_require__(30);
var createDesc = __webpack_require__(15);
var _create = __webpack_require__(52);
var gOPNExt = __webpack_require__(106);
var $GOPD = __webpack_require__(107);
var $DP = __webpack_require__(6);
var $keys = __webpack_require__(17);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(57).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(23).f = $propertyIsEnumerable;
  __webpack_require__(38).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(29)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(8)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(21)('meta');
var isObject = __webpack_require__(14);
var has = __webpack_require__(7);
var setDesc = __webpack_require__(6).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(11)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(17);
var gOPS = __webpack_require__(38);
var pIE = __webpack_require__(23);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(31);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(12);
var gOPN = __webpack_require__(57).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(23);
var createDesc = __webpack_require__(15);
var toIObject = __webpack_require__(12);
var toPrimitive = __webpack_require__(30);
var has = __webpack_require__(7);
var IE8_DOM_DEFINE = __webpack_require__(49);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(10) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 108 */
/***/ (function(module, exports) {



/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(37)('asyncIterator');


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(37)('observable');


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(112), __esModule: true };

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(113);
module.exports = __webpack_require__(4).Object.keys;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(22);
var $keys = __webpack_require__(17);

__webpack_require__(114)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(13);
var core = __webpack_require__(4);
var fails = __webpack_require__(11);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(116);
module.exports = __webpack_require__(4).Object.assign;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(13);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(117) });


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(17);
var gOPS = __webpack_require__(38);
var pIE = __webpack_require__(23);
var toObject = __webpack_require__(22);
var IObject = __webpack_require__(54);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(11)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _String = String;

exports.default = _String.fromCodePoint || function stringFromCodePoint() {
  var MAX_SIZE = 0x4000;
  var codeUnits = [];
  var highSurrogate;
  var lowSurrogate;
  var index = -1;
  var length = arguments.length;
  if (!length) {
    return '';
  }
  var result = '';
  while (++index < length) {
    var codePoint = Number(arguments[index]);
    if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
    codePoint < 0 || // not a valid Unicode code point
    codePoint > 0x10ffff || // not a valid Unicode code point
    Math.floor(codePoint) != codePoint // not an integer
    ) {
        throw RangeError('Invalid code point: ' + codePoint);
      }
    if (codePoint <= 0xffff) {
      // BMP code point
      codeUnits.push(codePoint);
    } else {
      // Astral code point; split in surrogate halves
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      codePoint -= 0x10000;
      highSurrogate = (codePoint >> 10) + 0xd800;
      lowSurrogate = codePoint % 0x400 + 0xdc00;
      codeUnits.push(highSurrogate, lowSurrogate);
    }
    if (index + 1 === length || codeUnits.length > MAX_SIZE) {
      result += String.fromCharCode.apply(null, codeUnits);
      codeUnits.length = 0;
    }
  }
  return result;
};

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canRender
    ? _c(
        "span",
        {
          staticClass: "emoji-mart-emoji",
          on: {
            mouseenter: _vm.onMouseEnter,
            mouseleave: _vm.onMouseLeave,
            click: _vm.onClick
          }
        },
        [
          _vm.isCustom
            ? _c("span", {
                style: _vm.customEmojiStyles,
                attrs: { title: _vm.title }
              })
            : _vm.isNative
              ? _c(
                  "span",
                  { style: _vm.nativeEmojiStyles, attrs: { title: _vm.title } },
                  [_vm._v(_vm._s(_vm.nativeEmoji))]
                )
              : _vm.hasEmoji
                ? _c("span", {
                    style: _vm.fallbackEmojiStyles,
                    attrs: { title: _vm.title }
                  })
                : _c("span", [_vm._v(_vm._s(_vm.fallbackEmoji))])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f853594", esExports)
  }
}

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible && (_vm.isSearch || _vm.hasResults)
    ? _c(
        "div",
        {
          class: {
            "emoji-mart-category": true,
            "emoji-mart-no-results": !_vm.hasResults
          }
        },
        [
          _c("div", { staticClass: "emoji-mart-category-label" }, [
            _c("span", [_vm._v(_vm._s(_vm.i18n.categories[_vm.id]))])
          ]),
          _vm._v(" "),
          _vm._l(_vm.emojis, function(emoji) {
            return _c("nimble-emoji", {
              key: emoji.id || emoji,
              attrs: {
                data: _vm.data,
                emoji: emoji,
                native: _vm.emojiProps.native,
                skin: _vm.emojiProps.skin,
                set: _vm.emojiProps.set,
                size: _vm.emojiProps.size,
                "sheet-size": _vm.emojiProps.sheetSize,
                "force-size": _vm.emojiProps.forceSize,
                tooltip: _vm.emojiProps.tooltip,
                "background-image-fn": _vm.emojiProps.backgroundImageFn
              },
              on: {
                click: _vm.emojiProps.onClick,
                mouseenter: _vm.emojiProps.onEnter,
                mouseleave: _vm.emojiProps.onLeave
              }
            })
          }),
          _vm._v(" "),
          !_vm.hasResults
            ? _c(
                "div",
                [
                  _c("nimble-emoji", {
                    attrs: {
                      data: _vm.data,
                      size: _vm.emojiProps.size,
                      emoji: "sleuth_or_spy",
                      native: _vm.emojiProps.native,
                      skin: _vm.emojiProps.skin,
                      set: _vm.emojiProps.set,
                      "sheet-size": _vm.emojiProps.sheetSize,
                      "background-image-fn": _vm.emojiProps.backgroundImageFn
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "emoji-mart-no-results-label" }, [
                    _vm._v(_vm._s(_vm.i18n.notfound))
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-376cda0e", esExports)
  }
}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(122);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("648f661a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-35056c30\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./preview.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-35056c30\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./preview.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "\n.emoji-mart-preview[data-v-35056c30] {\n  position: relative;\n  height: 70px;\n}\n.emoji-mart-preview-emoji[data-v-35056c30],\n.emoji-mart-preview-data[data-v-35056c30],\n.emoji-mart-preview-skins[data-v-35056c30] {\n  position: absolute;\n  top: 50%;\n  -ms-transform: translateY(-50%);\n      transform: translateY(-50%);\n}\n.emoji-mart-preview-emoji[data-v-35056c30] {\n  left: 12px;\n}\n.emoji-mart-preview-data[data-v-35056c30] {\n  left: 68px; right: 12px;\n  word-break: break-all;\n}\n.emoji-mart-preview-skins[data-v-35056c30] {\n  right: 30px;\n  text-align: right;\n}\n.emoji-mart-preview-name[data-v-35056c30] {\n  font-size: 14px;\n}\n.emoji-mart-preview-shortname[data-v-35056c30] {\n  font-size: 12px;\n  color: #888;\n}\n.emoji-mart-preview-shortname + .emoji-mart-preview-shortname[data-v-35056c30],\n.emoji-mart-preview-shortname + .emoji-mart-preview-emoticon[data-v-35056c30],\n.emoji-mart-preview-emoticon + .emoji-mart-preview-emoticon[data-v-35056c30] {\n  margin-left: .5em;\n}\n.emoji-mart-preview-emoticon[data-v-35056c30] {\n  font-size: 11px;\n  color: #bbb;\n}\n.emoji-mart-title span[data-v-35056c30] {\n  display: inline-block;\n  vertical-align: middle;\n}\n.emoji-mart-title .emoji-mart-emoji[data-v-35056c30] {\n  padding: 0;\n}\n.emoji-mart-title-label[data-v-35056c30] {\n  color: #999A9C;\n  font-size: 21px;\n  font-weight: 300;\n}\n\n", ""]);

// exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(124);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2b486c2e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1c614894\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./skins.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1c614894\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./skins.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "\n.emoji-mart-skin-swatches[data-v-1c614894] {\n  font-size: 0;\n  padding: 2px 0;\n  border: 1px solid #d9d9d9;\n  border-radius: 12px;\n  background-color: #fff;\n}\n.emoji-mart-skin-swatches-opened .emoji-mart-skin-swatch[data-v-1c614894] {\n  width: 16px;\n  padding: 0 2px;\n}\n.emoji-mart-skin-swatches-opened .emoji-mart-skin-swatch-selected[data-v-1c614894]:after {\n  opacity: .75;\n}\n.emoji-mart-skin-swatch[data-v-1c614894] {\n  display: inline-block;\n  width: 0;\n  vertical-align: middle;\n  transition-property: width, padding;\n  transition-duration: .125s;\n  transition-timing-function: ease-out;\n}\n.emoji-mart-skin-swatch[data-v-1c614894]:nth-child(1) { transition-delay: 0s\n}\n.emoji-mart-skin-swatch[data-v-1c614894]:nth-child(2) { transition-delay: .03s\n}\n.emoji-mart-skin-swatch[data-v-1c614894]:nth-child(3) { transition-delay: .06s\n}\n.emoji-mart-skin-swatch[data-v-1c614894]:nth-child(4) { transition-delay: .09s\n}\n.emoji-mart-skin-swatch[data-v-1c614894]:nth-child(5) { transition-delay: .12s\n}\n.emoji-mart-skin-swatch[data-v-1c614894]:nth-child(6) { transition-delay: .15s\n}\n.emoji-mart-skin-swatch-selected[data-v-1c614894] {\n  position: relative;\n  width: 16px;\n  padding: 0 2px;\n}\n.emoji-mart-skin-swatch-selected[data-v-1c614894]:after {\n  content: \"\";\n  position: absolute;\n  top: 50%; left: 50%;\n  width: 4px; height: 4px;\n  margin: -2px 0 0 -2px;\n  background-color: #fff;\n  border-radius: 100%;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity .2s ease-out;\n}\n.emoji-mart-skin[data-v-1c614894] {\n  display: inline-block;\n  width: 100%; padding-top: 100%;\n  max-width: 12px;\n  border-radius: 100%;\n}\n.emoji-mart-skin-tone-1[data-v-1c614894] { background-color: #ffc93a\n}\n.emoji-mart-skin-tone-2[data-v-1c614894] { background-color: #fadcbc\n}\n.emoji-mart-skin-tone-3[data-v-1c614894] { background-color: #e0bb95\n}\n.emoji-mart-skin-tone-4[data-v-1c614894] { background-color: #bf8f68\n}\n.emoji-mart-skin-tone-5[data-v-1c614894] { background-color: #9b643d\n}\n.emoji-mart-skin-tone-6[data-v-1c614894] { background-color: #594539\n}\n\n", ""]);

// exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "emoji-mart-skin-swatches": true,
        "emoji-mart-skin-swatches-opened": _vm.opened
      }
    },
    _vm._l(6, function(skinTone) {
      return _c(
        "span",
        {
          key: skinTone,
          class: {
            "emoji-mart-skin-swatch": true,
            "emoji-mart-skin-swatch-selected": _vm.skin == skinTone
          }
        },
        [
          _c("span", {
            class: "emoji-mart-skin emoji-mart-skin-tone-" + skinTone,
            on: {
              click: function($event) {
                _vm.onClick(skinTone)
              }
            }
          })
        ]
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c614894", esExports)
  }
}

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "emoji-mart-preview" },
    [
      _vm.emoji
        ? [
            _c(
              "div",
              { staticClass: "emoji-mart-preview-emoji" },
              [
                _c("nimble-emoji", {
                  attrs: {
                    data: _vm.data,
                    emoji: _vm.emoji,
                    native: _vm.emojiProps.native,
                    skin: _vm.emojiProps.skin,
                    set: _vm.emojiProps.set,
                    size: 38,
                    "sheet-size": _vm.emojiProps.sheetSize,
                    "force-size": _vm.emojiProps.forceSize,
                    "background-image-fn": _vm.emojiProps.backgroundImageFn
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "emoji-mart-preview-data" }, [
              _c("div", { staticClass: "emoji-mart-preview-name" }, [
                _vm._v(_vm._s(_vm.emoji.name))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "emoji-mart-preview-shortnames" },
                _vm._l(_vm.emojiShortNames, function(shortName) {
                  return _c(
                    "span",
                    {
                      key: shortName,
                      staticClass: "emoji-mart-preview-shortname"
                    },
                    [_vm._v(":" + _vm._s(shortName) + ":")]
                  )
                })
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "emoji-mart-preview-emoticons" },
                _vm._l(_vm.emojiEmoticons, function(emoticon) {
                  return _c(
                    "span",
                    {
                      key: emoticon,
                      staticClass: "emoji-mart-preview-emoticon"
                    },
                    [_vm._v(_vm._s(emoticon))]
                  )
                })
              )
            ])
          ]
        : [
            _c(
              "div",
              { staticClass: "emoji-mart-preview-emoji" },
              [
                _c("nimble-emoji", {
                  attrs: {
                    data: _vm.data,
                    emoji: _vm.idleEmoji,
                    native: _vm.emojiProps.native,
                    skin: _vm.emojiProps.skin,
                    set: _vm.emojiProps.set,
                    size: 38,
                    "sheet-size": _vm.emojiProps.sheetSize,
                    "force-size": _vm.emojiProps.forceSize,
                    "background-image-fn": _vm.emojiProps.backgroundImageFn
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "emoji-mart-preview-data" }, [
              _c("span", { staticClass: "emoji-mart-title-label" }, [
                _vm._v(_vm._s(_vm.title))
              ])
            ]),
            _vm._v(" "),
            _vm.showSkinTones
              ? _c(
                  "div",
                  { staticClass: "emoji-mart-preview-skins" },
                  [
                    _c("skins", {
                      attrs: { skin: _vm.skinProps.skin },
                      on: {
                        change: function($event) {
                          _vm.$emit("change", $event)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35056c30", esExports)
  }
}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(128);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0cd29f7e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4ad41bb8\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./search.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4ad41bb8\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./search.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "\n.emoji-mart-search[data-v-4ad41bb8] {\n  margin-top: 6px;\n  padding: 0 6px;\n}\n.emoji-mart-search input[data-v-4ad41bb8] {\n  font-size: 16px;\n  display: block;\n  width: 100%;\n  padding: .2em .6em;\n  border-radius: 25px;\n  border: 1px solid #d9d9d9;\n  outline: 0;\n}\n\n", ""]);

// exports


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Object = Object;

exports.default = function createClass() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ('value' in descriptor) descriptor.writable = true;
      _Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "emoji-mart-search" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.value,
          expression: "value"
        }
      ],
      attrs: { type: "text", placeholder: _vm.i18n.search },
      domProps: { value: _vm.value },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.value = $event.target.value
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ad41bb8", esExports)
  }
}

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emoji_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emoji_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emoji_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emoji_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emoji_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
var disposed = false
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emoji_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/emoji/emoji.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-924ece46", Component.options)
  } else {
    hotAPI.reload("data-v-924ece46", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picker_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picker_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picker_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picker_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
var disposed = false
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picker_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/picker/picker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-344c59cf", Component.options)
  } else {
    hotAPI.reload("data-v-344c59cf", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(135);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("211d331e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7bc71df8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./nimblePicker.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7bc71df8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./nimblePicker.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "\n.emoji-mart,\n.emoji-mart * {\n  box-sizing: border-box;\n  line-height: 1.15;\n}\n.emoji-mart .emoji-mart-emoji {\n  padding: 6px;\n}\n\n", ""]);

// exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(137);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("221719ca", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7bc71df8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./nimblePicker.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7bc71df8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./nimblePicker.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "\n.emoji-mart[data-v-7bc71df8] {\n  font-family: -apple-system, BlinkMacSystemFont, \"Helvetica Neue\", sans-serif;\n  font-size: 16px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  height: 420px;\n  color: #222427;\n  border: 1px solid #d9d9d9;\n  border-radius: 5px;\n  background: #fff;\n}\n.emoji-mart-bar[data-v-7bc71df8] {\n  border: 0 solid #d9d9d9;\n}\n.emoji-mart-bar[data-v-7bc71df8]:first-child {\n  border-bottom-width: 1px;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n.emoji-mart-bar[data-v-7bc71df8]:last-child {\n  border-top-width: 1px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n.emoji-mart-scroll[data-v-7bc71df8] {\n  position: relative;\n  overflow-y: scroll;\n  -ms-flex: 1;\n      flex: 1;\n  padding: 0 6px 6px 6px;\n  z-index: 0; /* Fix for rendering sticky positioned category labels on Chrome */\n  will-change: transform; /* avoids \"repaints on scroll\" in mobile Chrome */\n  -webkit-overflow-scrolling: touch;\n}\n\n", ""]);

// exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(139);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(140), __esModule: true };

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(26);
__webpack_require__(141);
module.exports = __webpack_require__(4).Array.from;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(48);
var $export = __webpack_require__(13);
var toObject = __webpack_require__(22);
var call = __webpack_require__(142);
var isArrayIter = __webpack_require__(143);
var toLength = __webpack_require__(55);
var createProperty = __webpack_require__(144);
var getIterFn = __webpack_require__(69);

$export($export.S + $export.F * !__webpack_require__(146)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(9);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(16);
var ITERATOR = __webpack_require__(2)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(6);
var createDesc = __webpack_require__(15);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(31);
var TAG = __webpack_require__(2)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(2)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(148), __esModule: true };

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(56);
__webpack_require__(26);
module.exports = __webpack_require__(149);


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(9);
var get = __webpack_require__(69);
module.exports = __webpack_require__(4).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

var isWindowAvailable = typeof window !== 'undefined';

isWindowAvailable && function () {
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];

  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) window.requestAnimationFrame = function (callback, element) {
    var currTime = new Date().getTime();
    var timeToCall = Math.max(0, 16 - (currTime - lastTime));
    var id = window.setTimeout(function () {
      callback(currTime + timeToCall);
    }, timeToCall);

    lastTime = currTime + timeToCall;
    return id;
  };

  if (!window.cancelAnimationFrame) window.cancelAnimationFrame = function (id) {
    clearTimeout(id);
  };
}();

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "emoji-mart", style: _vm.customStyles },
    [
      _vm.showCategories
        ? _c(
            "div",
            { staticClass: "emoji-mart-bar" },
            [
              _c("anchors", {
                attrs: {
                  data: _vm.mutableData,
                  i18n: _vm.mutableI18n,
                  color: _vm.color,
                  categories: _vm.filteredCategories,
                  "active-category": _vm.activeCategory
                },
                on: { click: _vm.onAnchorClick }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showSearch
        ? _c("search", {
            ref: "search",
            attrs: {
              data: _vm.mutableData,
              i18n: _vm.mutableI18n,
              "emojis-to-show-filter": _vm.emojisToShowFilter,
              include: _vm.include,
              exclude: _vm.exclude,
              custom: _vm.customEmojis,
              recent: _vm.recentEmojis,
              "auto-focus": _vm.autoFocus
            },
            on: { search: _vm.onSearch }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "scroll",
          staticClass: "emoji-mart-scroll",
          on: { scroll: _vm.onScroll }
        },
        [
          _c("category", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.searchEmojis,
                expression: "searchEmojis"
              }
            ],
            attrs: {
              data: _vm.mutableData,
              i18n: _vm.mutableI18n,
              id: "search",
              name: "Search",
              emojis: _vm.searchEmojis,
              "emoji-props": _vm.emojiProps
            }
          }),
          _vm._v(" "),
          _vm._l(_vm.filteredCategories, function(category) {
            return _c("category", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.searchEmojis &&
                    (_vm.infiniteScroll || category == _vm.activeCategory),
                  expression:
                    "!searchEmojis && (infiniteScroll || category == activeCategory)"
                }
              ],
              key: category.id,
              ref: "categories",
              refInFor: true,
              attrs: {
                data: _vm.mutableData,
                i18n: _vm.mutableI18n,
                id: category.id,
                name: category.name,
                emojis: category.emojis,
                "emoji-props": _vm.emojiProps
              }
            })
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.showPreview
        ? _c(
            "div",
            { staticClass: "emoji-mart-bar" },
            [
              _c("preview", {
                attrs: {
                  data: _vm.mutableData,
                  title: _vm.title,
                  emoji: _vm.previewEmoji,
                  "idle-emoji": _vm.emoji,
                  "show-skin-tones": _vm.showSkinTones,
                  "emoji-props": _vm.emojiProps,
                  "skin-props": _vm.skinProps
                },
                on: { change: _vm.onSkinChange }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bc71df8", esExports)
  }
}

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _all = __webpack_require__(40);

var _all2 = _interopRequireDefault(_all);

var _nimbleEmojiIndex = __webpack_require__(39);

var _nimbleEmojiIndex2 = _interopRequireDefault(_nimbleEmojiIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emojiIndex = new _nimbleEmojiIndex2.default(_all2.default);
var emojis = emojiIndex.emojis;
var emoticons = emojiIndex.emoticons;


function search() {
  return emojiIndex.search.apply(emojiIndex, arguments);
}

exports.default = { search: search, emojis: emojis, emoticons: emoticons };

/***/ })
/******/ ]);
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchModal_vue__ = __webpack_require__(448);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05258735_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchModal_vue__ = __webpack_require__(1257);
function injectStyle (ssrContext) {
  __webpack_require__(1255)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05258735"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05258735_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__featureToggle__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  loadFlightInfo: function loadFlightInfo(VueApp, rsvp, callback) {
    if (rsvp.airlineCode === null) {
      return;
    }
    var self = this;
    VueApp.$store.commit('flightInformation/show');

    var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(rsvp.pickupTime, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, true));
    var airlineDate = encodeURIComponent(date.format('YYYY-MM-DD'));
    var airlineTime = encodeURIComponent(date.format('HH:mm:ss'));
    var flightNumber = rsvp.flightNumber || rsvp.dropoffFlightNumber;
    var isDeparture = '&departure=0';
    if ((rsvp.airline === null || rsvp.airline === '') && rsvp.dropoffAirline !== null && rsvp.dropoffAirline !== '') {
      isDeparture = '&departure=1';
    }
    var url = '/availability/flights/' + rsvp.airlineCode + flightNumber + '?date=' + airlineDate + '&time=' + airlineTime + '&airport=' + rsvp.airportCode + isDeparture;
    VueApp.$sdk.get(url, {}, function (r) {
      VueApp.$store.commit('flightInformation/setLoading', false);
      if (r.error) {
        VueApp.$store.commit('flightInformation/setFlightInfo', {
          airline: {
            name: rsvp.airline,
            code: rsvp.airlineCode
          },
          flightNumber: flightNumber,
          departure: {
            airportCode: '',
            airportName: '',
            time: ''
          },
          arrival: {
            airportCode: '',
            airportName: '',
            time: ''
          },
          status: 'N/A'
        });
        callback(r);
        return;
      }

      var isAirportDropoff = !rsvp.airline && rsvp.dropoffAirline;
      var date = isAirportDropoff ? r.departure.time.unix : r.arrival.time.unix;
      var arriveDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date, 'X', r.departure.time.timezone);
      VueApp.$store.commit('flightInformation/setFlightInfo', {
        airline: r.airline,
        flightNumber: r.flight.number || rsvp.flightNumber,
        departure: {
          airportCode: r.departure.airportCode,
          airportName: r.departure.airportName,
          time: __WEBPACK_IMPORTED_MODULE_0_moment___default()(r.departure.time.unix, 'X', r.departure.time.timezone).format(__WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false))
        },
        arrival: {
          airportCode: r.arrival.airportCode,
          airportName: r.arrival.airportName,
          time: arriveDate.format(__WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false))
        },
        status: self.translateFlightStatus(r.status, isAirportDropoff),
        type: isAirportDropoff ? 'departure' : 'arrive'
      });
      callback(r);
    });
  },
  translateFlightStatus: function translateFlightStatus(status, isAirportDropoff) {
    if (!isAirportDropoff) {
      switch (status) {
        case 'Scheduled':
          return 'Flight is arriving as scheduled.';
        case 'Proposed':
          return 'Flight is arriving as scheduled.';
        case 'OutGate':
          return 'Flight is arriving as scheduled.';
        case 'InAir':
          return 'Flight is currently on-air.';
        case 'Landed':
          return 'Flight has already arrived.';
        case 'InGate':
          return 'Flight has already arrived.';
        case 'Expected':
          return 'Flight is arriving as scheduled.';
        case 'NoTakeOffInfo':
          return 'Flight is arriving as scheduled.';
        case 'Delayed':
          return 'Flight is currently delayed.';
        case 'Cancelled':
          return 'Flight was cancelled.';
        case 'Unknown':
          return 'Flight is arriving as scheduled.';
        case 'PastFlight':
          return 'Flight has already arrived.';
        case 'Original':
          return 'Flight is arriving as scheduled.';
      }
      return 'Flight is arriving as scheduled.';
    }

    switch (status) {
      case 'Scheduled':
        return 'Flight is still scheduled.';
      case 'Proposed':
        return 'Flight is still scheduled.';
      case 'OutGate':
        return 'Flight is still scheduled.';
      case 'InAir':
        return 'Flight is currently on-air.';
      case 'Landed':
        return 'Flight has already landed.';
      case 'InGate':
        return 'Flight has already arrived.';
      case 'Expected':
        return 'Flight is still scheduled.';
      case 'NoTakeOffInfo':
        return 'Flight is still scheduled.';
      case 'Delayed':
        return 'Flight is currently delayed.';
      case 'Cancelled':
        return 'Flight has been cancelled.';
      case 'Unknown':
        return 'Flight is still scheduled.';
      case 'PastFlight':
        return 'Flight has already been completed.';
      case 'Original':
        return 'Flight is still scheduled.';
    }
    return 'Flight is still scheduled.';
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReadyToGoModal_vue__ = __webpack_require__(482);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_375149f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReadyToGoModal_vue__ = __webpack_require__(1347);
function injectStyle (ssrContext) {
  __webpack_require__(1345)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-375149f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReadyToGoModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_375149f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReadyToGoModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


/* global CONFIG */
// import moment from 'moment'
/* harmony default export */ __webpack_exports__["a"] = ({
  getAllService: function getAllService(VueApp, callback) {
    VueApp.$sdk.get('/service', {
      token: VueApp.$store.state.session.sessionToken,
      all: 1
    }, function (r) {
      VueApp.$store.commit('pricing/clearServiceTypes');
      if (!r.error) {
        r.list.sort(function (a, b) {
          return a.id - b.id;
        });
        r.list.forEach(function (service) {
          if (service.brandId) {
            var licenseType = [];
            if (service.allowTNC) {
              licenseType.push('tnc');
            }
            if (service.allowTCP) {
              licenseType.push('tcp');
            }
            if (service.allowPSC) {
              licenseType.push('psc');
            }
            VueApp.$store.commit('pricing/addServiceTypes', {
              id: service.id,
              brandId: service.brandId,
              brandEnabled: service.enabled,
              name: service.name,
              label: service.label,
              code: service.code,
              priority: service.priority,
              isShared: service.isShared,
              licenseType: licenseType,
              maxPassenger: service.maxPassengers,
              maxLuggages: service.maxLuggages,
              isCharter: service.isCharter,
              isRental: service.isRental,
              maxConcurrent: service.maxConcurrent
            });
          }
        });
      }
      callback(r);
    }, '2.0');
  },
  setPriceSettings: function setPriceSettings(VueApp, type, callback) {
    var self = this;
    var serviceArea = VueApp.$store.state.pricing.serviceArea;
    VueApp.$sdk.post('/servicearea/' + serviceArea.activeId + '/pricing', self.buildPriceSettingsData(VueApp, type, false), function (r) {
      callback(r);
    }, '2.0');
  },
  setGlobalPriceSettings: function setGlobalPriceSettings(VueApp, data, callback) {
    var self = this;

    if (data.serviceArea.length > 0) {
      VueApp.$sdk.get('/servicearea/' + data.serviceArea[0] + '/pricing', {
        token: VueApp.$store.state.session.sessionToken,
        pageNum: 1,
        pageSize: 999
      }, function (res) {
        if (res.error) {
          callback(res);
          return;
        }

        var enabledServices = [];
        res.list.forEach(function (service) {
          if (service.enabled) enabledServices.push(service.serviceTypeId);
        });

        VueApp.$sdk.post('/servicearea/' + data.serviceArea[0] + '/pricing', self.buildPriceSettingsData(VueApp, data.type, true, enabledServices), function (res2) {
          if (res2.error) {
            callback(res2);
          } else {
            data.serviceArea.shift();
            self.setGlobalPriceSettings(VueApp, data, callback);
          }
          return;
        }, '2.0');
      }, '2.0');
    } else {
      callback('done');
    }
  },
  setGlobalServiceEnable: function setGlobalServiceEnable(VueApp, data, callback) {
    var self = this;
    var serviceTypes = VueApp.$store.state.pricing.serviceTypes;
    var enableList = serviceTypes.enableList;
    var disableList = serviceTypes.disableList;

    if (!data.length) {
      callback('done');
      return;
    }

    if (enableList.length > 0 || disableList.length > 0) {
      var services = [];
      enableList.forEach(function (id) {
        services.push({ serviceTypeId: id, enabled: true });
      });
      disableList.forEach(function (id) {
        services.push({ serviceTypeId: id, enabled: false });
      });
      VueApp.$sdk.post('/servicearea/' + data[0] + '/pricing', {
        token: VueApp.$store.state.session.sessionToken,
        services: services
      }, function (res) {
        if (res.error) {
          callback(res);
        } else {
          data.shift();
          self.setGlobalServiceEnable(VueApp, data, callback);
        }
        return;
      }, '2.0');
    } else {
      callback('done');
    }
  },
  buildPriceSettingsData: function buildPriceSettingsData(VueApp, type, forGlobal) {
    var serviceCheck = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

    var compiledData = { token: VueApp.$store.state.session.sessionToken };
    var services = [];
    var pricingStore = VueApp.$store.state.pricing;
    var serviceArea = pricingStore.serviceArea;
    var tempServiceTypes = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(pricingStore.serviceTypes.list));
    var temp = tempServiceTypes.filter(function (x) {
      return x.brandId === pricingStore.brandId && x.enabled && x.brandEnabled;
    });
    if (type === 'charter') {
      temp = tempServiceTypes.filter(function (x) {
        return x.brandId === pricingStore.brandId && x.enabled && x.brandEnabled && x.isCharter;
      });
    }
    if (forGlobal) {
      temp = temp.filter(function (x) {
        return serviceCheck.indexOf(x.id) > -1;
      });
    }

    if (type === 'future') {
      temp.forEach(function (service, index) {
        var tempService = service.future;
        tempService.serviceTypeId = service.id;

        var tempPickupTypes = [];
        for (var key in service.pickupTypes) {
          if (key !== 'null' && key !== 'enabled') {
            if (temp[index].pickupTypes[key].fee !== '' && temp[index].pickupTypes[key].fee !== null) {
              var tempPickupType = temp[index].pickupTypes[key];
              if (forGlobal) {
                delete tempPickupType.enabled;
              }
              tempPickupTypes.push(tempPickupType);
            }
          }
        }
        tempService.pickupTypes = tempPickupTypes;
        tempService.flightOwDscType = service.flight && service.flight.onewayType || null;
        tempService.flightOwDscRate = service.flight && service.flight.onewayRate || null;
        tempService.flightRtDscType = service.flight && service.flight.roundtripType || null;
        tempService.flightRtDscRate = service.flight && service.flight.roundtripRate || null;
        if (service.future.portalFee) tempService.portalFee = service.future.portalFee || null;
        if (service.future.portalFeeType) tempService.portalFeeType = service.future.portalFeeType || null;
        if (typeof tempService.gasFee === 'string') delete tempService.gasFee;
        // if (!tempService.gasFee) tempService.gasFee = 0

        if (forGlobal) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(tempService).forEach(function (key) {
            if (tempService[key] === '') {
              delete tempService[key];
            }
          });
          // if (!tempService.pickupTypes.length) {
          //   delete tempService.pickupTypes
          // }
          delete tempService.pickupTypes;
          pricingStore.global.pickupTypes.forEach(function (pt) {
            if (service.id === pt.id) {
              if (pt.pickupTypes.Curbside && pt.pickupTypes.Curbside.enabled !== '') {
                if (!tempService.pickupTypes) tempService.pickupTypes = [];
                tempService.pickupTypes.push({ name: 'Curbside', enabled: pt.pickupTypes.Curbside.enabled });
              }
              if (pt.pickupTypes.MeetAndGreet) {
                var tmpObj = '';
                if (pt.pickupTypes.MeetAndGreet.enabled !== '') {
                  tmpObj = { name: 'MeetAndGreet', enabled: pt.pickupTypes.MeetAndGreet.enabled };
                }
                if (pt.pickupTypes.MeetAndGreet.fee !== '') {
                  if (!tmpObj) tmpObj = { name: 'MeetAndGreet', fee: pt.pickupTypes.MeetAndGreet.fee };else tmpObj.fee = pt.pickupTypes.MeetAndGreet.fee;
                }
                if (tmpObj) {
                  if (!tempService.pickupTypes) tempService.pickupTypes = [];
                  tempService.pickupTypes.push(tmpObj);
                }
              }
            }
          });
        }

        services.push(tempService);
      });
      if (serviceArea.discountStart) compiledData.discountStart = serviceArea.discountStart;
      if (serviceArea.discountEnd) compiledData.discountEnd = serviceArea.discountEnd;
      if (serviceArea.holidayDate) compiledData.holidayDate = serviceArea.holidayDate;
      compiledData.holidayDate2 = serviceArea.holidayDate2 || null;
      compiledData.holidayDate3 = serviceArea.holidayDate3 || null;
      compiledData.holidayDate4 = serviceArea.holidayDate4 || null;
      compiledData.holidayDate5 = serviceArea.holidayDate5 || null;
      compiledData.holidayDate6 = serviceArea.holidayDate6 || null;
      compiledData.holidayDate7 = serviceArea.holidayDate7 || null;
      compiledData.holidayDate8 = serviceArea.holidayDate8 || null;
      compiledData.holidayDate9 = serviceArea.holidayDate9 || null;
      compiledData.holidayDate10 = serviceArea.holidayDate10 || null;
      compiledData.discountWidget = serviceArea.discountWidget;
      compiledData.discountAdmin = serviceArea.discountAdmin;
      compiledData.discountApp = serviceArea.discountApp;
      compiledData.discountCSR = serviceArea.discountCSR;
    } else if (type === 'asap') {
      temp.forEach(function (service) {
        var tempService = {
          serviceTypeId: service.id,
          priority: service.priority,
          asapTravelInsurance: service.asap.travelInsurance,
          asapAirportFee: service.asap.airportFee,
          asapMileageRate: service.asap.mileageRate,
          asapFare: service.asap.fare,
          asapMileageThreshold: service.asap.mileageThreshold,
          asapFlat2paxFee: service.asap.flat2paxFee,
          asapFlatNpaxFee: service.asap.flatNpaxFee,
          asapDiscountType: service.asap.discountType,
          asapDiscountAmount: service.asap.discountAmount,
          asapRoundtripType: service.asap.roundtripType,
          asapRoundtripAmount: service.asap.roundtripAmount,
          asapProvMileage: service.asap.provMileage,
          asapProvBaseFee: service.asap.provBaseFee,
          asapProvBonus: service.asap.provBonus,
          asapProv2paxFee: service.asap.prov2paxFee,
          asapProvNpaxFee: service.asap.provNpaxFee,
          asapProvDiscountRate: service.asap.provDiscountRate,
          asapHolidayRateType: service.asap.holidayRateType,
          asapHolidayRateAmount: service.asap.holidayRateAmount
          // asapPortalFee: service.asap.portalFee,
          // asapPortalFeeType: service.asap.portalFeeType
          // asapGasFee: service.asap.gasFee || 0
        };
        if (typeof service.asap.gasFee === 'number') tempService.asapGasFee = service.asap.gasFee || 0;
        if (typeof service.asap.portalFee === 'number') tempService.asapPortalFee = service.asap.portalFee || 0;
        if (service.asap.portalFeeType) tempService.asapPortalFeeType = service.asap.portalFeeType;

        if (serviceArea.asapDiscountStart) {
          tempService.asapDiscountStart = serviceArea.asapDiscountStart;
        }
        if (serviceArea.asapDiscountEnd) {
          tempService.asapDiscountEnd = serviceArea.asapDiscountEnd;
        }
        if (serviceArea.asapHolidayDate) {
          tempService.asapHolidayDate = serviceArea.asapHolidayDate;
        }

        if (forGlobal) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(tempService).forEach(function (key) {
            if (tempService[key] === '') {
              delete tempService[key];
            }
          });
        }

        services.push(tempService);
      });
      if (serviceArea.asapDiscountStart) compiledData.asapDiscountStart = serviceArea.asapDiscountStart;
      if (serviceArea.asapDiscountEnd) compiledData.asapDiscountEnd = serviceArea.asapDiscountEnd;
      if (serviceArea.asapHolidayDate) compiledData.asapHolidayDate = serviceArea.asapHolidayDate;
      compiledData.asapHolidayDate2 = serviceArea.asapHolidayDate2 || null;
      compiledData.asapHolidayDate3 = serviceArea.asapHolidayDate3 || null;
      compiledData.asapHolidayDate4 = serviceArea.asapHolidayDate4 || null;
      compiledData.asapHolidayDate5 = serviceArea.asapHolidayDate5 || null;
      compiledData.asapHolidayDate6 = serviceArea.asapHolidayDate6 || null;
      compiledData.asapHolidayDate7 = serviceArea.asapHolidayDate7 || null;
      compiledData.asapHolidayDate8 = serviceArea.asapHolidayDate8 || null;
      compiledData.asapHolidayDate9 = serviceArea.asapHolidayDate9 || null;
      compiledData.asapHolidayDate10 = serviceArea.asapHolidayDate10 || null;
      compiledData.asapDiscountWidget = serviceArea.asapDiscountWidget;
      compiledData.asapDiscountAdmin = serviceArea.asapDiscountAdmin;
      compiledData.asapDiscountApp = serviceArea.asapDiscountApp;
      compiledData.asapDiscountCSR = serviceArea.asapDiscountCSR;
    } else if (type === 'rental') {
      temp.forEach(function (service, index) {
        var rental = service.rental;
        var tempService = {
          serviceTypeId: service.id,
          enabled: true,
          rentFare: rental.rentFare,
          rentRate: rental.rentRate,
          rentRateDaily: rental.rentRateDaily,
          rentRateWeekend: rental.rentRateWeekend
        };

        if (forGlobal) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(tempService).forEach(function (key) {
            if (tempService[key] === '') {
              delete tempService[key];
            }
          });
        }

        services.push(tempService);
      });
    } else {
      temp.forEach(function (service, index) {
        var future = service.future;
        var tempService = {
          serviceTypeId: service.id,
          enabled: true,
          airportFee: future.airportFee,
          discountAmount: future.discountAmount,
          discountType: '%',
          charterFare: service.charter.fare,
          minuteRate: service.charter.minuteRate,
          provCharterBase: service.charter.provBase,
          provCharterRate: service.charter.provRate,
          provCharterDiscount: service.charter.provDiscount
        };

        if (service.future.portalFee) tempService.portalFee = service.future.portalFee || null;
        if (service.future.portalFeeType) tempService.portalFeeType = service.future.portalFeeType || null;
        var tempPickupTypes = [];
        for (var key in service.pickupTypes) {
          if (key !== 'null' && key !== 'enabled') {
            if (temp[index].pickupTypes[key].fee !== '' && temp[index].pickupTypes[key].fee !== null) {
              var tempPickupType = temp[index].pickupTypes[key];
              if (forGlobal) {
                delete tempPickupType.enabled;
              }
              tempPickupTypes.push(tempPickupType);
            }
          }
        }
        tempService.pickupTypes = tempPickupTypes;

        if (forGlobal) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(tempService).forEach(function (key) {
            if (tempService[key] === '') {
              delete tempService[key];
            }
          });
          if (!tempService.pickupTypes.length) {
            delete tempService.pickupTypes;
          }
          pricingStore.global.pickupTypesCharter.forEach(function (pt) {
            if (service.id === pt.id) {
              if (pt.pickupTypes.Curbside && pt.pickupTypes.Curbside.enabled !== '') {
                if (!tempService.pickupTypes) tempService.pickupTypes = [];
                tempService.pickupTypes.push({ name: 'Curbside', enabled: pt.pickupTypes.Curbside.enabled });
              }
              if (pt.pickupTypes.MeetAndGreet) {
                var tmpObj = '';
                if (pt.pickupTypes.MeetAndGreet.enabled !== '') {
                  tmpObj = { name: 'MeetAndGreet', enabled: pt.pickupTypes.MeetAndGreet.enabled };
                }
                if (pt.pickupTypes.MeetAndGreet.fee !== '') {
                  if (!tmpObj) tmpObj = { name: 'MeetAndGreet', fee: pt.pickupTypes.MeetAndGreet.fee };else tmpObj.fee = pt.pickupTypes.MeetAndGreet.fee;
                }
                if (tmpObj) {
                  if (!tempService.pickupTypes) tempService.pickupTypes = [];
                  tempService.pickupTypes.push(tmpObj);
                }
              }
            }
          });
        }

        services.push(tempService);
      });
      if (serviceArea.charterDiscountStart) compiledData.discountStart = serviceArea.charterDiscountStart;
      if (serviceArea.charterDiscountEnd) compiledData.discountEnd = serviceArea.charterDiscountEnd;
      if (serviceArea.charterHolidayDate) compiledData.holidayDate = serviceArea.charterHolidayDate;
      compiledData.holidayDate2 = serviceArea.charterHolidayDate2 || null;
      compiledData.holidayDate3 = serviceArea.charterHolidayDate3 || null;
      compiledData.holidayDate4 = serviceArea.charterHolidayDate4 || null;
      compiledData.holidayDate5 = serviceArea.charterHolidayDate5 || null;
      compiledData.holidayDate6 = serviceArea.charterHolidayDate6 || null;
      compiledData.holidayDate7 = serviceArea.charterHolidayDate7 || null;
      compiledData.holidayDate8 = serviceArea.charterHolidayDate8 || null;
      compiledData.holidayDate9 = serviceArea.charterHolidayDate9 || null;
      compiledData.holidayDate10 = serviceArea.charterHolidayDate10 || null;
    }
    compiledData.services = services;

    var origData = pricingStore.originalData;
    var conf = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.find(function (x) {
      return x.id === VueApp.$store.state.pricing.brandId;
    });
    if (type === 'asap') {
      if (origData[0]) {
        if (compiledData.asapDiscountAdmin === origData[0].asap.discountAdmin) delete compiledData.asapDiscountAdmin;
        if (compiledData.asapDiscountApp === origData[0].asap.discountApp) delete compiledData.asapDiscountApp;
        if (compiledData.asapDiscountWidget === origData[0].asap.discountWidget) delete compiledData.asapDiscountWidget;
        if (compiledData.asapDiscountCSR === origData[0].asap.discountCSR) delete compiledData.asapDiscountCSR;
        if (compiledData.asapDiscountStart === origData[0].asap.discountStart) delete compiledData.asapDiscountStart;
        if (compiledData.asapDiscountEnd === origData[0].asap.discountEnd) delete compiledData.asapDiscountEnd;
        if (compiledData.asapHolidayDate === origData[0].asap.holidayDate) delete compiledData.asapHolidayDate;
        if (compiledData.asapHolidayDate2 === origData[0].asap.holidayDate2) delete compiledData.asapHolidayDate2;
        if (compiledData.asapHolidayDate3 === origData[0].asap.holidayDate3) delete compiledData.asapHolidayDate3;
        if (compiledData.asapHolidayDate4 === origData[0].asap.holidayDate4) delete compiledData.asapHolidayDate4;
        if (compiledData.asapHolidayDate5 === origData[0].asap.holidayDate5) delete compiledData.asapHolidayDate5;
        if (compiledData.asapHolidayDate6 === origData[0].asap.holidayDate6) delete compiledData.asapHolidayDate6;
        if (compiledData.asapHolidayDate7 === origData[0].asap.holidayDate7) delete compiledData.asapHolidayDate7;
        if (compiledData.asapHolidayDate8 === origData[0].asap.holidayDate8) delete compiledData.asapHolidayDate8;
        if (compiledData.asapHolidayDate9 === origData[0].asap.holidayDate9) delete compiledData.asapHolidayDate9;
        if (compiledData.asapHolidayDate10 === origData[0].asap.holidayDate10) delete compiledData.asapHolidayDate10;
      }

      var noChanges = [];
      if (!forGlobal) {
        compiledData.services.forEach(function (service, i) {
          var origService = origData.find(function (x) {
            return x.id === service.serviceTypeId;
          });
          for (var key in service) {
            if (['serviceTypeId', 'priority'].indexOf(key) > -1) continue;
            var tmpKey = key.slice(4);
            tmpKey = '' + tmpKey.charAt(0).toLowerCase() + tmpKey.slice(1);
            if (service[key] === origService.asap[tmpKey]) delete compiledData.services[i][key];
          }
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(service).length === 2) noChanges.push(service.serviceTypeId);
        });

        // Delete services with no changes
        noChanges.forEach(function (x) {
          var index = compiledData.services.findIndex(function (xx) {
            return xx.serviceTypeId === x;
          });
          if (index > -1) compiledData.services.splice(index, 1);
        });
      }
    } else if (type === 'future') {
      if (origData[0]) {
        if (compiledData.discountAdmin === origData[0].future.discountAdmin) delete compiledData.discountAdmin;
        if (compiledData.discountApp === origData[0].future.discountApp) delete compiledData.discountApp;
        if (compiledData.discountWidget === origData[0].future.discountWidget) delete compiledData.discountWidget;
        if (compiledData.discountCSR === origData[0].future.discountCSR) delete compiledData.discountCSR;
        if (compiledData.discountStart === origData[0].future.discountStart) delete compiledData.discountStart;
        if (compiledData.discountEnd === origData[0].future.discountEnd) delete compiledData.discountEnd;
        if (compiledData.holidayDate === origData[0].future.holidayDate) delete compiledData.holidayDate;
        if (compiledData.holidayDate2 === origData[0].future.holidayDate2) delete compiledData.holidayDate2;
        if (compiledData.holidayDate3 === origData[0].future.holidayDate3) delete compiledData.holidayDate3;
        if (compiledData.holidayDate4 === origData[0].future.holidayDate4) delete compiledData.holidayDate4;
        if (compiledData.holidayDate5 === origData[0].future.holidayDate5) delete compiledData.holidayDate5;
        if (compiledData.holidayDate6 === origData[0].future.holidayDate6) delete compiledData.holidayDate6;
        if (compiledData.holidayDate7 === origData[0].future.holidayDate7) delete compiledData.holidayDate7;
        if (compiledData.holidayDate8 === origData[0].future.holidayDate8) delete compiledData.holidayDate8;
        if (compiledData.holidayDate9 === origData[0].future.holidayDate9) delete compiledData.holidayDate9;
        if (compiledData.holidayDate10 === origData[0].future.holidayDate10) delete compiledData.holidayDate10;
      }

      var _noChanges = [];
      if (!forGlobal) {
        compiledData.services.forEach(function (service, i) {
          var origService = origData.find(function (x) {
            return x.id === service.serviceTypeId;
          });
          for (var key in service) {
            if (['serviceTypeId'].indexOf(key) > -1) continue;
            if (service[key] === origService.future[key]) delete compiledData.services[i][key];
          }

          // check if D2D
          if (conf && conf.code === 'd2d') {
            if (service.flightOwDscRate === origService.flight.oneway.rate) delete compiledData.services[i].flightOwDscRate;
            if (service.flightOwDscType === origService.flight.oneway.type) delete compiledData.services[i].flightOwDscType;
            if (service.flightRtDscRate === origService.flight.roundtrip.rate) delete compiledData.services[i].flightRtDscRate;
            if (service.flightRtDscType === origService.flight.roundtrip.type) delete compiledData.services[i].flightRtDscType;
          } else {
            delete compiledData.services[i].flightOwDscRate;
            delete compiledData.services[i].flightOwDscType;
            delete compiledData.services[i].flightRtDscRate;
            delete compiledData.services[i].flightRtDscType;
          }

          // check Pickup Types
          var removePickpType = {};
          service.pickupTypes.forEach(function (pickupType) {
            if (!removePickpType[service.serviceTypeId]) removePickpType[service.serviceTypeId] = [];
            if (!origService.pickupTypes.length) return;
            var origCurbside = origService.pickupTypes.find(function (x) {
              return x.name === 'Curbside';
            });
            var origMeetAndGreet = origService.pickupTypes.find(function (x) {
              return x.name === 'MeetAndGreet';
            });
            if (pickupType.name === 'Curbside' && pickupType.enabled === origCurbside.enabled) {
              removePickpType[service.serviceTypeId].push('Curbside');
            }
            if (pickupType.name === 'MeetAndGreet' && pickupType.enabled === origMeetAndGreet.enabled && pickupType.fee === origMeetAndGreet.fee) {
              removePickpType[service.serviceTypeId].push('MeetAndGreet');
            }
          });
          for (var _key in removePickpType) {
            if (removePickpType[_key].length) {
              removePickpType[_key].forEach(function (puType) {
                var puIndex = service.pickupTypes.findIndex(function (x) {
                  return x.name === puType;
                });
                if (puIndex > -1) compiledData.services[i].pickupTypes.splice(puIndex, 1);
              });
            }
          }
          if (!compiledData.services[i].pickupTypes.length) delete compiledData.services[i].pickupTypes;

          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(service).length === 1) _noChanges.push(service.serviceTypeId);
        });

        // Delete services with no changes
        _noChanges.forEach(function (x) {
          var index = compiledData.services.findIndex(function (xx) {
            return xx.serviceTypeId === x;
          });
          if (index > -1) compiledData.services.splice(index, 1);
        });
      }
    } else if (type === 'charter') {
      if (origData[0]) {
        if (compiledData.discountStart === origData[0].future.discountStart) delete compiledData.discountStart;
        if (compiledData.discountEnd === origData[0].future.discountEnd) delete compiledData.discountEnd;
        if (compiledData.holidayDate === origData[0].future.holidayDate) delete compiledData.holidayDate;
        if (compiledData.holidayDate2 === origData[0].future.holidayDate2) delete compiledData.holidayDate2;
        if (compiledData.holidayDate3 === origData[0].future.holidayDate3) delete compiledData.holidayDate3;
        if (compiledData.holidayDate4 === origData[0].future.holidayDate4) delete compiledData.holidayDate4;
        if (compiledData.holidayDate5 === origData[0].future.holidayDate5) delete compiledData.holidayDate5;
        if (compiledData.holidayDate6 === origData[0].future.holidayDate6) delete compiledData.holidayDate6;
        if (compiledData.holidayDate7 === origData[0].future.holidayDate7) delete compiledData.holidayDate7;
        if (compiledData.holidayDate8 === origData[0].future.holidayDate8) delete compiledData.holidayDate8;
        if (compiledData.holidayDate9 === origData[0].future.holidayDate9) delete compiledData.holidayDate9;
        if (compiledData.holidayDate10 === origData[0].future.holidayDate10) delete compiledData.holidayDate10;
      }

      var _noChanges2 = [];
      if (!forGlobal) {
        compiledData.services.forEach(function (service, i) {
          var origService = origData.find(function (x) {
            return x.id === service.serviceTypeId;
          });

          if (service.airportFee === origService.future.airportFee) delete compiledData.services[i].airportFee;
          if (service.discountAmount === origService.future.discountAmount) delete compiledData.services[i].discountAmount;
          if (service.discountType === origService.future.discountType) delete compiledData.services[i].discountType;
          if (service.minuteRate === origService.charter.minuteRate) delete compiledData.services[i].minuteRate;
          if (service.charterFare === origService.charter.fare) delete compiledData.services[i].charterFare;
          if (service.provCharterBase === origService.charter.provBase) delete compiledData.services[i].provCharterBase;
          if (service.provCharterRate === origService.charter.provRate) delete compiledData.services[i].provCharterRate;
          if (service.provCharterDiscount === origService.charter.provDiscount) delete compiledData.services[i].provCharterDiscount;

          // check Pickup Types
          var removePickpType = {};
          service.pickupTypes.forEach(function (pickupType) {
            if (!removePickpType[service.serviceTypeId]) removePickpType[service.serviceTypeId] = [];
            var origCurbside = origService.pickupTypes.find(function (x) {
              return x.name === 'Curbside';
            });
            var origMeetAndGreet = origService.pickupTypes.find(function (x) {
              return x.name === 'MeetAndGreet';
            });
            if (pickupType.name === 'Curbside' && origCurbside && pickupType.enabled === origCurbside.enabled) {
              removePickpType[service.serviceTypeId].push('Curbside');
            }
            if (pickupType.name === 'MeetAndGreet' && origMeetAndGreet && pickupType.enabled === origMeetAndGreet.enabled && pickupType.fee === origMeetAndGreet.fee) {
              removePickpType[service.serviceTypeId].push('MeetAndGreet');
            }
          });
          for (var key in removePickpType) {
            if (removePickpType[key].length) {
              removePickpType[key].forEach(function (puType) {
                var puIndex = service.pickupTypes.findIndex(function (x) {
                  return x.name === puType;
                });
                if (puIndex > -1) compiledData.services[i].pickupTypes.splice(puIndex, 1);
              });
            }
          }
          if (!compiledData.services[i].pickupTypes.length) delete compiledData.services[i].pickupTypes;

          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(service).length === 2) _noChanges2.push(service.serviceTypeId);
        });

        // Delete services with no changes
        _noChanges2.forEach(function (x) {
          var index = compiledData.services.findIndex(function (xx) {
            return xx.serviceTypeId === x;
          });
          if (index > -1) compiledData.services.splice(index, 1);
        });
      }
    } else if (type === 'rental') {
      var _noChanges3 = [];
      if (!forGlobal) {
        compiledData.services.forEach(function (service, i) {
          var origService = origData.find(function (x) {
            return x.id === service.serviceTypeId;
          });

          if (service.rentFare === origService.rental.rentFare) delete compiledData.services[i].rentFare;
          if (service.rentRate === origService.rental.rentRate) delete compiledData.services[i].rentRate;
          if (service.rentRateDaily === origService.rental.rentRateDaily) delete compiledData.services[i].rentRateDaily;
          if (service.rentRateWeekend === origService.rental.rentRateWeekend) delete compiledData.services[i].rentRateWeekend;

          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(service).length === 2) _noChanges3.push(service.serviceTypeId);
        });

        // Delete services with no changes
        _noChanges3.forEach(function (x) {
          var index = compiledData.services.findIndex(function (xx) {
            return xx.serviceTypeId === x;
          });
          if (index > -1) compiledData.services.splice(index, 1);
        });
      }
    }
    return compiledData;
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__featureToggle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_currency_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_currency_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__data_currency_js__);
/* global CONFIG */

 // eslint-disable-line




/* harmony default export */ __webpack_exports__["a"] = ({
  getRsvpData: function getRsvpData(VueApp, rsvpId, callback) {
    var self = this;
    VueApp.$sdk.get('/admin/rsvp/' + rsvpId, {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      if (res.error) {
        callback(res);
        return;
      }
      setTimeout(function () {
        var serviceType = res.serviceCode === 'suv' ? 'SUV' : res.serviceCode;
        var isAirportPickup = res.airline !== '' && res.airline !== null;
        var isAirportDropoff = false;
        var aptGate = '';
        var aptGateDropoff = '';
        var pickupTitle = self.buildLocation(res.pickupLocation);
        if (!isAirportPickup && pickupTitle.title && pickupTitle.title.indexOf('Apt/Gate:') > -1) {
          aptGate = pickupTitle.title.split(' Apt/Gate: ')[1];
        }
        if (!isAirportPickup && res.dropoffAirline) {
          isAirportDropoff = true;
        }
        var dropoffTitle = self.buildLocation(res.dropoffLocation);
        if (!isAirportDropoff && dropoffTitle.title && dropoffTitle.title.indexOf('Apt/Gate:') > -1) {
          aptGateDropoff = dropoffTitle.title.split(' Apt/Gate: ')[1];
        }

        // let pickupMoment = moment(res.pickupDate, 'YYYY-MM-DD hh:mm:ss')
        var threshold = VueApp.$store.state.routing.beThereTimeThreshold;
        var maxDuration = Math.floor(res.etaInSec * threshold);
        var btt = __WEBPACK_IMPORTED_MODULE_0_moment___default()(res.pickupDate, 'YYYY-MM-DD HH:mm:ss').add(maxDuration, 'seconds').subtract(1, 'minute').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_3__featureToggle__["a" /* default */].timeFormat(VueApp, false));
        var flightName = res.airline || '';
        var flightNumber = res.flightNumber || '';
        if (flightNumber === 'N/A') flightNumber = '';
        if (flightName === 'N/A') flightName = '';
        if (!flightName && res.dropoffAirline) {
          flightName = res.dropoffAirline;
        }
        if (!flightNumber && res.dropoffFlightNumber) {
          flightNumber = res.dropoffFlightNumber;
        }
        var onboard = res.onboard ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(res.onboard, 'YYYY-MM-DD@hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_3__featureToggle__["a" /* default */].timeFormat(VueApp, false)) : '';
        var mobile = 'N/A';
        var countryCode = '';
        var nationalNumber = '';
        if (res.consumer.phones.length) {
          mobile = res.consumer.phones[0].countryCode + '' + res.consumer.phones[0].phoneNumber;
          countryCode = res.consumer.phones[0].countryCode;
          nationalNumber = res.consumer.phones[0].nationalNumber || res.consumer.phones[0].phoneNumber;
        }
        var fare = res.payment.fareAmount;
        var driverPayment = res.payment.driverPay;
        if (res.optinShared && res.optinShared.isOptinShared && res.optinShared.current === 'shared') {
          fare = res.optinShared.exclusive.amount;
          driverPayment = res.optinShared.exclusive.driverPayment;
        }
        var rsvpDetails = {
          rsvpId: res.ID,
          basicInfo: {
            tripInfo: {
              id: res.ID,
              brandId: res.brand.id,
              brand: res.brand.name,
              brandColor: res.brand.brandColor,
              packageId: res.packageID,
              bookedThrough: self.bookThroughLabel(res.bidDeviceType),
              status: res.status,
              bidStatus: res.dispatchStatus,
              bidId: res.bidID,
              created: __WEBPACK_IMPORTED_MODULE_0_moment___default()(res.created, 'YYYY-MM-DD@hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_3__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
              canceled: res.canceled ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(res.canceled, 'YYYY-MM-DD@hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_3__featureToggle__["a" /* default */].timeFormat(VueApp, false)) : '',
              pickupDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(res.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_3__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
              fare: fare,
              driverPayment: driverPayment,
              driverBonus: res.payment.driverBonus || 0,
              paymentBonus: res.bonus.amount || 0,
              basePay: res.bonus.basePay || 0,
              meetAndGreet: res.pickupType === 'MeetAndGreet',
              tip: res.payment.tipAmount,
              airportFee: res.airportFee,
              gasFee: res.gasFee || 0,
              travelInsurance: res.travelInsurance ? res.travelInsurance : 0,
              pickupFee: res.payment.pickupFee,
              credits: res.payment.credits,
              serviceTypeId: res.serviceType.id,
              serviceType: serviceType,
              serviceLabel: __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getServiceName(res.serviceCode),
              serviceCode: res.serviceCode,
              pickup: self.buildLocation(res.pickupLocation),
              dropoff: self.buildLocation(res.dropoffLocation),
              aptGate: aptGate,
              aptGateDropoff: aptGateDropoff,
              eta: res.etaInSec,
              beThereTime: btt,
              distance: res.distance,
              isAsap: res.isAsap,
              airline: flightName,
              airlineCode: res.airlineCode,
              airportCode: res.airportCode,
              isAirportPickup: isAirportPickup,
              isAirportDropoff: isAirportDropoff,
              flightNo: flightNumber,
              terminal: res.terminal,
              passenger: res.passengers,
              luggage: res.luggage,
              notes: res.notes,
              serviceArea: res.pricingGeofence.name,
              wheelchair: res.ada.wheelChairLift !== 0,
              serviceDog: res.ada.serviceDog !== 0,
              overridePrice: res.overridePrice,
              overridePayment: res.overridePayment,
              rating: res.rating.value,
              userReview: res.rating.message,
              onboard: onboard,
              reservationState: res.reservationState,
              paxReason: res.paxReason,
              extraStops: [],
              isCharter: res.isCharter,
              isRental: res.isRental,
              maxConcurrent: res.maxConcurrent,
              optinShared: res.optinShared,
              isMtech: res.isMTech || false,
              d2dId: res.d2dId || '',
              portalFee: res.portalFee || 0,
              paymentTotal: res.payment.total
            },
            customerInfo: {
              id: res.consumer.ID,
              firstName: res.consumer.firstName,
              lastName: res.consumer.lastName,
              creditCard: res.cardNumber,
              cardTitle: res.cardTitle,
              creditCardId: res.cardID,
              email: res.consumer.email,
              mobile: mobile,
              phone: {
                countryCode: countryCode,
                number: nationalNumber
              }
            },
            guestInfo: {
              firstName: res.guest.firstName,
              lastName: res.guest.lastName,
              mobile: res.guest.phone
            },
            businessInfo: {
              id: res.corporateProfile ? res.corporateProfile.id : '',
              corporateName: res.corporateProfile ? res.corporateProfile.name : '',
              firstName: res.guest.firstName,
              lastName: res.guest.lastName,
              mobile: res.guest.phone
            },
            driverInfo: {
              id: res.provider.ID,
              driverNum: res.provider.driverNum || res.provider.ID,
              firstName: res.provider.firstName,
              lastName: res.provider.lastName,
              rating: res.provider.rating,
              licensePlate: res.vehicle.plate,
              make: res.vehicle.manufacturer,
              model: res.vehicle.model,
              email: res.provider.email,
              mobile: res.provider.displayPhone,
              photo: res.provider.avatarUrl,
              vehiclePhoto: res.vehicle.photo,
              countryCode: res.provider.phones.length ? res.provider.phones[0].countryCode : '',
              nationalNumber: res.provider.phones.length ? res.provider.phones[0].nationalNumber || res.provider.phones[0].phoneNumber : '',
              number: res.provider.phones.length ? res.provider.phones[0].nationalNumber || res.provider.phones[0].phoneNumber : ''
            },
            otherInfo: {
              externalId: res.externalId || 'N/A',
              alternatePhone: res.alternatePhone || 'N/A'
            }
          }
        };
        if (!{"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation) {
          rsvpDetails.basicInfo.tripInfo.serviceType = {
            label: res.serviceType.label,
            color: res.serviceType.color
          };
          if (res.serviceType.id > 5) {
            rsvpDetails.basicInfo.tripInfo.serviceCode = 'a' + res.serviceType.id;
          }
        }
        if ({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.find(function (x) {
          return x.id === res.brandID;
        }) && res.pickupTimezone) {
          rsvpDetails.basicInfo.tripInfo.localPickupTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(res.pickupDate, 'YYYY-MM-DD HH:mm:ss Z').tz(res.pickupTimezone).format('MM/DD/YYYY hh:mmA');
        }

        VueApp.$store.commit('rsvpDetails/setIsTerminal', res.isTerminal);
        VueApp.$store.commit('rsvpDetails/setRsvpDetails', rsvpDetails);
        VueApp.$store.commit('rsvpDetails/setMtechData', { enabled: res.isMTech });
        if (res.isMTech) {
          VueApp.$store.commit('rsvpDetails/setMtechData', {
            details: {
              localPickupDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(res.pickupDate, 'YYYY-MM-DD HH:mm:ss Z').tz(res.pickupTimezone).format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_3__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
              timezone: res.pickupTimezone,
              service: res.mtechProductData
            }
          });
        }
        self.checkCurrency(VueApp, rsvpId, callback, res);
      }, 600);
    });
  },
  getTransactionByRsvpId: function getTransactionByRsvpId(VueApp, rsvpId, callback) {
    var self = this;
    VueApp.$sdk.get('/transaction', {
      token: VueApp.$store.state.session.sessionToken,
      rsvpId: rsvpId,
      order: 'created',
      orderAsc: 0
    }, function (res) {
      for (var i in res.list) {
        var trx = res.list;
        var payment = trx[i].payment;
        VueApp.$store.commit('rsvpDetails/addTransaction', {
          id: trx[i].id,
          date: __WEBPACK_IMPORTED_MODULE_0_moment___default()(trx[i].datetime, 'YYYY-MM-DD@hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_3__featureToggle__["a" /* default */].timeFormat(VueApp, true)),
          trxId: trx[i].eventId,
          cardId: trx[i].cardNumber,
          fare: self.toFixed(payment.offer),
          paid: self.toFixed(payment.charged),
          cancelFee: self.toFixed(payment.cancelFee),
          bonus: self.toFixed(payment.bonus),
          promoUsed: self.toFixed(payment.credit),
          status: trx[i].transactionType,
          statusLabel: trx[i].status,
          paymentURL: trx[i].paymentURL,
          notes: trx[i].notes,
          transactionType: trx[i].transactionType
        });
      }
      callback(res);
    });
  },
  getNotesByRsvpId: function getNotesByRsvpId(VueApp, rsvpId, callback) {
    VueApp.$sdk.get('/admin/rsvp/' + rsvpId + '/notes', {
      token: VueApp.$store.state.session.sessionToken,
      order: 'created',
      orderAsc: 0
    }, function (res) {
      for (var i in res.list) {
        var notes = res.list;
        var date = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(notes[i].created, 'YYYY-MM-DD@hh:mm:ss').tz('America/Los_Angeles');
        var admin = {
          name: 'Deleted Admin',
          id: 0,
          pic: 'https://s3-us-west-2.amazonaws.com/staging-backoffice/staging/default-user.jpg'
        };
        if (notes[i].admin) {
          admin = {
            name: notes[i].admin.firstName + ' ' + notes[i].admin.lastName,
            id: notes[i].admin.id,
            pic: notes[i].admin.avatarUrl
          };
        }
        VueApp.$store.commit('rsvpDetails/addNotes', {
          id: notes[i].id,
          date: date.format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_3__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
          message: notes[i].message,
          status: notes[i].status,
          userId: admin.id || 0,
          name: admin.name,
          picture: admin.pic || 'https://s3-us-west-2.amazonaws.com/staging-backoffice/staging/default-user.jpg'
        });
      }
      callback(res);
    });
  },
  getFlightStatus: function getFlightStatus(VueApp, param, callback) {
    VueApp.$sdk.get('/availability/flights/' + param.flightCode + '?date=' + param.date + '&time=' + param.time + '&departure=' + param.isDeparture + '&airport=' + param.airportCode, {}, function (res) {
      if (!res.error) {
        var date = param.isDeparture === '1' ? res.departure.time.unix : res.arrival.time.unix;
        var arrival = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date, 'X', res.departure.time.timezone);
        VueApp.$store.commit('rsvpDetails/setFlightStatus', {
          status: res.status === 'InGate' ? 'Arrived' : res.status,
          departureAirport: res.departure.airportName + ' (' + res.departure.airportCode + ')',
          arrivalAirport: res.arrival.airportName + '(' + res.arrival.airportCode + ')',
          arrivalTime: arrival.format(__WEBPACK_IMPORTED_MODULE_3__featureToggle__["a" /* default */].timeFormat(VueApp, false))
        });
      }

      callback(res);
    });
  },
  deleteNote: function deleteNote(VueApp, noteId, callback) {
    VueApp.$sdk.delete('/note/' + noteId, {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      if (!res.error) {
        VueApp.$store.commit('rsvpDetails/deleteNote', noteId);
      }
      callback(res);
    });
  },
  bookThroughLabel: function bookThroughLabel(type) {
    if (type === 'ww') return 'Web Browser';
    if (type === 'ios') return 'iOS APP';
    if (type === 'android') return 'Android APP';
    if (type === 'admin') return 'Admin';
    if (type === 'provider') return 'Provider';
    return type;
  },
  buildLocation: function buildLocation(data) {
    return {
      airportCode: data.airportCode,
      address1: data.addressLine1,
      address2: data.addressLine2,
      city: data.city,
      country: data.country,
      geofenceId: data.geofenceId,
      geofenceName: data.geofenceName,
      geofenceType: data.geofenceType,
      lat: data.lat,
      lng: data.lng,
      state: data.state,
      title: data.geofenceType === 'airport' ? data.geofenceName : data.title,
      zip: data.zip
    };
  },
  toFixed: function toFixed(value) {
    value = parseFloat(value);
    if (value < 0) {
      return '-$' + Math.abs(value).toFixed(2);
    }
    return '$' + value.toFixed(2);
  },
  sendEmail: function sendEmail(VueApp, rsvpId, callback) {
    VueApp.$sdk.post('/admin/rsvp/' + rsvpId + '/email', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      callback(res);
    });
  },
  sendTripReminder: function sendTripReminder(VueApp, rsvpId, callback) {
    VueApp.$sdk.post('/admin/rsvp/' + rsvpId + '/reminder', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      callback(res);
    });
  },
  sendNoShow: function sendNoShow(VueApp, rsvpId, callback) {
    VueApp.$sdk.post('/admin/rsvp/' + rsvpId + '/noshow', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      callback(res);
    });
  },
  checkCurrency: function checkCurrency(VueApp, id, callback, data) {
    var self = this;
    VueApp.$sdk.get('/admin/rsvp/' + id + '/currency', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      if (!res.error) {
        VueApp.$store.commit('rsvpDetails/setCurrency', {
          airportFee: res.airportFee || 0,
          amount: res.amount || 0,
          credit: res.credit || 0,
          currency: res.currency || 'USD',
          currencyRate: res.currencyRate || 1,
          gasFee: res.gasFee || 0,
          pickupFee: res.pickupFee || 0,
          tipAmount: res.tipAmount || 0,
          travelInsurance: res.travelInsurance || 0,
          symbol: res.currency ? __WEBPACK_IMPORTED_MODULE_4__data_currency_js___default.a[res.currency] : '$'
        });
        if (res.currency !== 'USD') {
          self.getCurrencyList(VueApp, callback, data);
          return;
        }
      }
      callback(data);
    });
  },
  getCurrencyList: function getCurrencyList(VueApp, callback, data) {
    var currency = VueApp.$store.state.currency;
    var lastUpdate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(currency.lastUpdate, 'MM/DD/YYYY hh:mmA');
    var now = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default.a.tz('America/Los_Angeles');
    var updateTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default.a.tz(now.format('MM/DD/YYYY') + ' 04:30AM', 'MM/DD/YYYY hh:mmA', 'America/Los_Angeles');
    if (!lastUpdate || lastUpdate.format('MM/DD/YYYY') !== now.format('MM/DD/YYYY') || lastUpdate.format('MM/DD/YYYY') === now.format('MM/DD/YYYY') && now.diff(updateTime, 'minutes') > 0 && lastUpdate.diff(updateTime, 'minutes') < 0) {
      VueApp.$store.commit('currency/setCurrencyData', { loading: true });
      try {
        VueApp.$sdk.get('exchangerate', {}, function (r) {
          VueApp.$store.commit('currency/setCurrencyData', { loading: false });
          if (!r.error) {
            VueApp.$store.commit('currency/setCurrencyData', {
              list: r,
              lastUpdate: now.format('MM/DD/YYYY hh:mmA')
            });
          }
          callback(data);
        }, '');
      } catch (err) {
        VueApp.$store.commit('global/setAlertData', {
          show: true,
          message: err
        });
        callback(data);
      }
      return;
    }
    callback(data);
  }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__featureToggle__ = __webpack_require__(5);
/* global CONFIG */

// import services from '../services'


/* harmony default export */ __webpack_exports__["a"] = ({
  getPackages: function getPackages(VueApp, callback) {
    var self = this;
    var laxit = VueApp.$store.state.laxit.tncReservations;
    var request = {
      token: VueApp.$store.state.session.sessionToken,
      package: true,
      order: laxit.order,
      orderAsc: laxit.orderAsc,
      pageNum: laxit.currentPage,
      pageSize: laxit.perPage,
      filter: {
        ada: ['all', 'wheelChairLift', 'serviceDog'],
        afterPickupMins: 1440,
        beforePickupMins: 1440,
        bidSource: ['ios', 'android', 'admin', 'ww'],
        defaultGeofenceId: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.default.laxAirportId,
        defaultPickupAddress: '',
        defaultPickupType: 'airport',
        geofenceIds: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.default.laxServiceAreaId,
        packageStatus: null,
        rsvpStatus: ['ready', 'upcoming', 'require-dispatch', 'requires_dispatch', 'auto-dispatch', 'auto_dispatch', 'autodispatch'],
        stagingLotIds: [],
        stagingLots: [],
        tripDirection: ['out'],
        assigned: false
      },
      search: laxit.search
    };
    VueApp.$sdk.post('/admin/rsvp/dispatch', request, function (r) {
      if (!r.error) {
        VueApp.$store.commit('laxit/setTncReservationsMaxList', r.paging.totalItems);

        for (var i = 0; i < r.list.length; i++) {
          if (r.list[i].type === 'rsvp') {
            VueApp.$store.commit('laxit/addTncReservation', self.formatRsvp(VueApp, r.list[i].data));
          } else {
            VueApp.$store.commit('laxit/addTncReservation', self.formatPackage(VueApp, r.list[i].data));
          }
        }
      }

      callback(r);
    });
  },
  getUnrouted: function getUnrouted(VueApp, callback) {
    var self = this;
    var laxit = VueApp.$store.state.laxit.unroutedReservations;
    var request = {
      token: VueApp.$store.state.session.sessionToken,
      package: true,
      order: laxit.order,
      orderAsc: laxit.orderAsc,
      pageNum: laxit.currentPage,
      pageSize: laxit.perPage,
      filter: {
        ada: ['all', 'wheelChairLift', 'serviceDog'],
        afterPickupMins: 1440,
        beforePickupMins: 1440,
        bidSource: ['ios', 'android', 'admin', 'ww'],
        defaultGeofenceId: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.default.laxAirportId,
        defaultPickupAddress: '',
        defaultPickupType: 'airport',
        geofenceIds: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.default.laxServiceAreaId,
        packageStatus: null,
        rsvpStatus: ['upcoming', 'requires_dispatch', 'waiting_driver', 'dispatched', 'require-dispatch', 'auto-dispatch', 'auto_dispatch', 'autodispatch'],
        stagingLotIds: [],
        stagingLots: [],
        tripDirection: ['out']
      },
      search: laxit.search
    };
    VueApp.$sdk.post('/admin/rsvp/unpackaged', request, function (r) {
      if (!r.error) {
        VueApp.$store.commit('laxit/setUnroutedReservationsMaxList', r.paging.totalItems);

        for (var i = 0; i < r.list.length; i++) {
          VueApp.$store.commit('laxit/addUnroutedReservation', self.formatRsvp(VueApp, r.list[i]));
        }
      }

      callback(r);
    });
  },
  getOutbound: function getOutbound(VueApp, callback) {
    var self = this;
    var licenseType = VueApp.$store.state.laxit.driverOutbound.licenseType;
    var laxit = VueApp.$store.state.laxit.driverInbound;
    switch (licenseType) {
      case 'all':
        licenseType = null;
        break;
      case 'tnc':
        licenseType = 'tnc';
        break;
      case 'tcp':
        licenseType = 'tcp';
        break;
    }
    var request = {
      token: VueApp.$store.state.session.sessionToken,
      package: true,
      pageNum: laxit.currentPage,
      pageSize: laxit.perPage,
      order: 'pickupTime',
      filter: {
        ada: ['all', 'wheelChairLift', 'serviceDog'],
        afterPickupMins: 1440,
        beforePickupMins: 1440,
        bidSource: ['ios', 'android', 'admin', 'ww'],
        defaultGeofenceId: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.default.laxAirportId,
        defaultPickupAddress: '',
        defaultPickupType: 'airport',
        geofenceIds: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.default.laxServiceAreaId,
        packageStatus: null,
        rsvpStatus: ['onboard', 'dispatched'],
        stagingLotIds: [],
        stagingLots: [],
        tripDirection: ['out'],
        driverLicenseType: licenseType
      }
    };
    VueApp.$sdk.post('/admin/rsvp/dispatch', request, function (r) {
      if (!r.error) {
        VueApp.$store.commit('laxit/setDriverOutboundMaxList', r.paging.totalItems);
        for (var i = 0; i < r.list.length; i++) {
          if (r.list[i].type == 'rsvp') {
            VueApp.$store.commit('laxit/addDriverOutbound', self.formatDriverRSVP(VueApp, r.list[i]));
          } else {
            VueApp.$store.commit('laxit/addDriverOutbound', self.formatDriverPKG(VueApp, r.list[i]));
          }
        }
      }

      callback(r);
    });
  },
  getInbound: function getInbound(VueApp, callback) {
    var self = this;
    var licenseType = VueApp.$store.state.laxit.driverInbound.licenseType;
    var laxit = VueApp.$store.state.laxit.driverInbound;
    switch (licenseType) {
      case 'all':
        licenseType = null;
        break;
      case 'tnc':
        licenseType = 'tnc';
        break;
      case 'tcp':
        licenseType = 'tcp';
        break;
    }
    var request = {
      token: VueApp.$store.state.session.sessionToken,
      package: true,
      pageNum: laxit.currentPage,
      pageSize: laxit.perPage,
      order: 'etaTime',
      filter: {
        ada: ['all', 'wheelChairLift', 'serviceDog'],
        afterPickupMins: 1440,
        beforePickupMins: 1440,
        bidSource: ['ios', 'android', 'admin', 'ww'],
        defaultGeofenceId: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.default.laxAirportId,
        defaultPickupAddress: '',
        defaultPickupType: 'airport',
        geofenceIds: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.default.laxServiceAreaId,
        packageStatus: null,
        rsvpStatus: ['onboard', 'dispatched'],
        stagingLotIds: [],
        stagingLots: [],
        tripDirection: ['in'],
        driverLicenseType: licenseType
      }
    };
    VueApp.$sdk.post('/admin/rsvp/dispatch', request, function (r) {
      if (!r.error) {
        VueApp.$store.commit('laxit/setdriverInboundMaxList', r.paging.totalItems);
        for (var i = 0; i < r.list.length; i++) {
          if (r.list[i].type == 'rsvp') {
            VueApp.$store.commit('laxit/adddriverInbound', self.formatDriverRSVP(VueApp, r.list[i]));
          } else {
            VueApp.$store.commit('laxit/adddriverInbound', self.formatDriverPKG(VueApp, r.list[i]));
          }
        }
      }

      callback(r);
    });
  },
  formatRsvp: function formatRsvp(VueApp, item) {
    var statusClass = item.dispatchStatus;
    var status = item.dispatchStatus.toUpperCase();
    if (statusClass === 'requires_dispatch') {
      statusClass = 'requires-dispatch';
      status = 'REQUIRES DISPATCH';
    }

    if (statusClass === 'autodispatch') {
      statusClass = 'auto-dispatch';
      status = 'AUTO DISPATCH';
    }

    if (statusClass === 'complete') {
      status = 'COMPLETED';
    }

    if (statusClass === 'ready') {
      status = 'READY TO GO';
    }

    if (item.status === 'ontheway') {
      statusClass = 'ontheway';
      status = 'ONTHEWAY';
    }

    var phoneNumber = null;
    if (item.consumer.phones && item.consumer.phones.length > 0) {
      var phone = item.consumer.phones[0];
      phoneNumber = '+' + phone.countryCode + phone.phoneNumber;
    }

    var pickup = {
      address1: item.pickupLocation.addressLine1,
      address2: item.pickupLocation.addressLine2,
      city: item.pickupLocation.city,
      state: item.pickupLocation.state,
      zip: item.pickupLocation.zip,
      lat: item.pickupLocation.lat,
      lng: item.pickupLocation.lng,
      geofenceType: item.pickupLocation.geofenceType,
      geofenceName: item.pickupLocation.geofenceName,
      title: item.pickupLocation.title
    };
    var dropoff = {
      address1: item.dropoffLocation.addressLine1,
      address2: item.dropoffLocation.addressLine2,
      city: item.dropoffLocation.city,
      state: item.dropoffLocation.state,
      zip: item.dropoffLocation.zip,
      lat: item.dropoffLocation.lat,
      lng: item.dropoffLocation.lng,
      geofenceType: item.dropoffLocation.geofenceType,
      geofenceName: item.dropoffLocation.geofenceName,
      title: item.dropoffLocation.title
    };
    var pickupMoment = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.pickupDate, 'YYYY-MM-DD hh:mm:ss');
    var threshold = VueApp.$store.state.routing.beThereTimeThreshold;
    var maxDuration = Math.floor(item.etaInSec * threshold);
    var btt = pickupMoment.add(maxDuration, 'seconds');

    var legs = []; // stops
    legs.push({
      originalBTT: 0,
      eta: 0,
      inOrder: -1,
      isPickup: true,
      location: pickup,
      passengers: item.passengers,
      luggage: item.luggage !== null ? item.luggage : 0,
      maxDuration: 0,
      packageID: null,
      pickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      originalPickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      reservationID: item.ID,
      status: status
    });
    legs.push({
      originalBTT: maxDuration,
      eta: item.etaInSec,
      inOrder: -1,
      isPickup: false,
      location: dropoff,
      passengers: item.passengers,
      luggage: item.luggage !== null ? item.luggage : 0,
      maxDuration: maxDuration,
      packageID: null,
      pickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      originalPickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      reservationID: item.ID,
      status: status
    });

    var flightName = item.airline;
    var flightNumber = item.flightNumber;
    var airlineCode = item.airlineCode;
    var dropoffAirline = '';
    var dropoffFlightNumber = '';
    if (item.dropoffAirline || item.dropoffFlightNumber) {
      dropoffAirline = item.dropoffAirline;
      airlineCode = item.dropoffAirlineCode;
      dropoffFlightNumber = item.dropoffFlightNumber;
    }
    var sector = item.pickupLocation.sectors || item.pickupLocation.city;
    var serviceType = {
      label: '',
      color: ''
    };
    if (item.serviceType) {
      serviceType = {
        label: item.serviceType.label,
        color: item.serviceType.color
      };
    }
    return {
      id: item.ID,
      type: 'rsvp',
      statusClass: statusClass,
      status: status,
      pickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      pickup: pickup,
      eta: item.etaInSec,
      beThereTime: btt.format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      dropoff: dropoff,
      customer: {
        id: item.consumer.ID,
        firstName: item.consumer.firstName,
        lastName: item.consumer.lastName,
        phone: phoneNumber
      },
      flight: {
        airline: flightName || dropoffAirline,
        airlineCode: airlineCode,
        flightNumber: flightNumber || dropoffFlightNumber
      },
      airline: flightName,
      airlineCode: airlineCode,
      airportCode: item.airportCode,
      flightNumber: flightNumber,
      dropoffAirline: dropoffAirline,
      dropoffFlightNumber: dropoffFlightNumber,
      passengers: item.passengers,
      luggage: item.luggage !== null ? item.luggage : 0,
      payment: item.payment,
      legs: legs,
      ada: {
        wheelchair: item.ada.wheelChairLift === 1,
        serviceDog: item.ada.serviceDog === 1
      },
      pickupSectors: item.pickupLocation.sectors ? item.pickupLocation.sectors : null,
      dropoffSectors: item.dropoffLocation.sectors ? item.dropoffLocation.sectors : null,
      sector: sector,
      serviceType: serviceType,
      notes: item.notes
    };
  },
  formatPackage: function formatPackage(VueApp, item) {
    var self = this;
    // Status
    var statusClass = item.package.packageStatus;
    var status = item.package.packageStatus.toUpperCase();
    if (statusClass === 'requires_dispatch') {
      statusClass = 'requires-dispatch';
      status = 'REQUIRES DISPATCH';
    }
    if (statusClass === 'autodispatch') {
      statusClass = 'auto-dispatch';
      status = 'AUTO DISPATCH';
    }
    if (statusClass === 'complete') {
      status = 'COMPLETED';
    }
    if (statusClass === 'ready') {
      status = 'READY TO GO';
    }

    // RSVP
    var ada = {
      serviceDog: 0,
      wheelChairLift: 0
    };
    var notes = [];
    for (var i = 0; i < item.rsvp.length; i++) {
      var rsvp = item.rsvp[i];
      if (rsvp.notes !== null) {
        notes.push({
          rsvpID: rsvp.ID,
          notes: rsvp.notes
        });
      }
    }
    var rsvps = [];
    var luggage = 0;
    var tip = 0;
    for (var _i = 0; _i < item.rsvp.length; _i++) {
      var _rsvp = self.formatRsvp(VueApp, item.rsvp[_i]);
      luggage += _rsvp.luggage;
      rsvps.push(_rsvp);
      if (_rsvp.ada.wheelchair) {
        ada.wheelchair = true;
      }
      if (_rsvp.ada.serviceDog) {
        ada.serviceDog = true;
      }
      tip = tip + _rsvp.payment.tipAmount;
    }

    var legs = [];

    var _loop = function _loop(_i2) {
      var leg = item.stops[_i2];
      var itemRsvp = rsvps.filter(function (rsvp) {
        return rsvp.id === leg.reservationID;
      })[0];
      legs.push({
        originalBTT: itemRsvp.legs[1].maxDuration,
        eta: leg.eta,
        inOrder: leg.inOrder,
        isPickup: leg.isPickup,
        location: leg.isPickup ? itemRsvp.pickup : itemRsvp.dropoff,
        passengers: itemRsvp.passengers,
        luggage: itemRsvp.luggage !== null ? itemRsvp.luggage : 0,
        maxDuration: leg.maxDuration,
        packageID: item.package.id,
        pickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.package.localPickupTime, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
        originalPickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(itemRsvp.pickupTime, 'MM/DD/YYYY hh:mmA').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
        reservationID: leg.reservationID,
        status: itemRsvp.status
      });
    };

    for (var _i2 = 0; _i2 < item.stops.length; _i2++) {
      _loop(_i2);
    }
    var serviceType = {
      label: '',
      color: ''
    };
    if (rsvps[0] && rsvps[0].serviceType) {
      serviceType = {
        label: rsvps[0].serviceType.label,
        color: rsvps[0].serviceType.color
      };
    }

    return {
      id: item.package.id,
      type: 'package',
      status: status,
      statusClass: statusClass,
      sector: item.dropoffSector.name || '',
      pickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.package.localPickupTime, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      firstPickup: item.package.firstPickup,
      lastPickup: item.package.lastPickup,
      driver: item.driver,
      payment: item.package.paidForProvider,
      bonus: item.package.bonusToProvider,
      tip: tip,
      ada: ada,
      stops: item.package.stops,
      passengers: item.package.pax,
      luggage: luggage,
      rsvps: rsvps,
      legs: legs,
      inPool: item.package.inPool === 1,
      serviceType: serviceType,
      notes: notes
    };
  },
  formatDriverRSVP: function formatDriverRSVP(VueApp, item) {
    var driverName = '';
    if (item.data.provider.firstName) {
      driverName = item.data.provider.firstName + ' ' + item.data.provider.lastName;
    }
    return {
      reservationID: item.data.ID,
      id: item.data.provider.ID,
      name: driverName,
      pax: item.data.passengers,
      eta: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.data.pickupDate, 'YYYY-MM-DD hh:mm:ss').add(item.data.etaInSec, 'seconds').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      pickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.data.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false))
    };
  },
  formatDriverPKG: function formatDriverPKG(VueApp, item) {
    var driverName = '';
    if (item.data.driver.firstName) {
      driverName = item.data.driver.firstName + ' ' + item.data.driver.lastName;
    }
    return {
      reservationID: item.data.rsvp[0].ID,
      id: item.data.driver.ID,
      name: driverName,
      pax: item.data.rsvp[0].passengers,
      eta: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.data.rsvp[0].pickupDate, 'YYYY-MM-DD hh:mm:ss').add(item.data.rsvp[0].etaInSec, 'seconds').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      pickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.data.rsvp[0].pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false))
    };
  }
});

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(36);
var document = __webpack_require__(18).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(36);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(78);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 116 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 117 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(119)('keys');
var uid = __webpack_require__(99);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(12);
var global = __webpack_require__(18);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(79) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 120 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 121 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(79);
var $export = __webpack_require__(15);
var redefine = __webpack_require__(170);
var hide = __webpack_require__(44);
var Iterators = __webpack_require__(66);
var $iterCreate = __webpack_require__(712);
var setToStringTag = __webpack_require__(82);
var getPrototypeOf = __webpack_require__(714);
var ITERATOR = __webpack_require__(19)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(39);
var dPs = __webpack_require__(713);
var enumBugKeys = __webpack_require__(120);
var IE_PROTO = __webpack_require__(118)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(113)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(171).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(101);
var ITERATOR = __webpack_require__(19)('iterator');
var Iterators = __webpack_require__(66);
module.exports = __webpack_require__(12).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_default_js__ = __webpack_require__(719);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__index_default_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_js__ = __webpack_require__(126);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["VERSION"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "restArguments", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["restArguments"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isObject"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isNull", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isNull"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isUndefined", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isUndefined"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isBoolean", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isBoolean"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isElement", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isElement"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isString", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isString"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isNumber", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isNumber"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isDate", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isDate"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isRegExp", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isRegExp"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isError", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isError"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isSymbol", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isSymbol"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isArrayBuffer", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isArrayBuffer"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isDataView", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isDataView"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isArray", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isArray"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isFunction", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isFunction"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isArguments", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isArguments"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isFinite", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isFinite"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isNaN", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isNaN"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isTypedArray", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isTypedArray"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isEmpty"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isMatch", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isMatch"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isEqual", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isEqual"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isMap", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isMap"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isWeakMap", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isWeakMap"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isSet", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isSet"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isWeakSet", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isWeakSet"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "keys", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["keys"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "allKeys", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["allKeys"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "values", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["values"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pairs", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["pairs"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "invert", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["invert"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "functions", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["functions"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "methods", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["methods"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "extend", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["extend"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "extendOwn", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["extendOwn"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "assign", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["assign"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "defaults", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["defaults"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "create", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["create"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "clone", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["clone"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tap", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["tap"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "get", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["get"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "has", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["has"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "mapObject", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["mapObject"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "identity", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["identity"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "constant", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["constant"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["noop"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "toPath", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["toPath"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "property", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["property"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "propertyOf", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["propertyOf"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "matcher", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["matcher"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "matches", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["matches"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "times", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["times"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "random", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["random"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "now", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["now"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "escape", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["escape"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "unescape", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["unescape"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "templateSettings", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["templateSettings"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "template", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["template"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "result", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["result"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "uniqueId", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["uniqueId"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "chain", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["chain"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "iteratee", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["iteratee"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "partial", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["partial"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bind", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["bind"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bindAll", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["bindAll"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "memoize", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["memoize"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["delay"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "defer", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["defer"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["throttle"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "debounce", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["debounce"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "wrap", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["wrap"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "negate", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["negate"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["compose"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "after", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["after"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "before", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["before"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "once", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["once"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "findKey", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["findKey"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "findIndex", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["findIndex"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "findLastIndex", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["findLastIndex"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sortedIndex", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["sortedIndex"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "indexOf", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["indexOf"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "lastIndexOf", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["lastIndexOf"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "find", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["find"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "detect", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["detect"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "findWhere", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["findWhere"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "each", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["each"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forEach", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["forEach"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "map", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["map"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "collect", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["collect"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "reduce", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["reduce"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "foldl", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["foldl"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["inject"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "reduceRight", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["reduceRight"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "foldr", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["foldr"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["filter"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["select"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "reject", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["reject"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "every", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["every"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "all", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["all"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "some", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["some"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "any", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["any"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "contains", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["contains"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "includes", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["includes"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "include", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["include"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "invoke", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["invoke"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pluck", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["pluck"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "where", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["where"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "max", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["max"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "min", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["min"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "shuffle", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["shuffle"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sample", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["sample"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sortBy", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["sortBy"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "groupBy", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["groupBy"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "indexBy", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["indexBy"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "countBy", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["countBy"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "partition", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["partition"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "toArray", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["toArray"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "size", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["size"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pick", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["pick"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "omit", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["omit"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "first", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["first"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "head", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["head"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "take", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["take"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "initial", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["initial"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "last", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["last"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "rest", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["rest"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tail", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["tail"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "drop", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["drop"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "compact", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["compact"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "flatten", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["flatten"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "without", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["without"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "uniq", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["uniq"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "unique", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["unique"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "union", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["union"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "intersection", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["intersection"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "difference", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["difference"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "unzip", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["unzip"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "transpose", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["transpose"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["zip"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "object", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["object"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "range", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["range"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "chunk", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["chunk"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "mixin", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["mixin"]; });
// ESM Exports
// ===========
// This module is the package entry point for ES module users. In other words,
// it is the module they are interfacing with when they import from the whole
// package instead of from a submodule, like this:
//
// ```js
// import { map } from 'underscore';
// ```
//
// The difference with `./index-default`, which is the package entry point for
// CommonJS, AMD and UMD users, is purely technical. In ES modules, named and
// default exports are considered to be siblings, so when you have a default
// export, its properties are not automatically available as named exports. For
// this reason, we re-export the named exports in addition to providing the same
// default export as in `./index-default`.




/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(11);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return __WEBPACK_IMPORTED_MODULE_0__setup_js__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__restArguments_js__ = __webpack_require__(23);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "restArguments", function() { return __WEBPACK_IMPORTED_MODULE_1__restArguments_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(57);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return __WEBPACK_IMPORTED_MODULE_2__isObject_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isNull_js__ = __webpack_require__(720);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isNull", function() { return __WEBPACK_IMPORTED_MODULE_3__isNull_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isUndefined_js__ = __webpack_require__(176);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isUndefined", function() { return __WEBPACK_IMPORTED_MODULE_4__isUndefined_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isBoolean_js__ = __webpack_require__(177);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isBoolean", function() { return __WEBPACK_IMPORTED_MODULE_5__isBoolean_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isElement_js__ = __webpack_require__(721);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isElement", function() { return __WEBPACK_IMPORTED_MODULE_6__isElement_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isString_js__ = __webpack_require__(127);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isString", function() { return __WEBPACK_IMPORTED_MODULE_7__isString_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isNumber_js__ = __webpack_require__(178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isNumber", function() { return __WEBPACK_IMPORTED_MODULE_8__isNumber_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isDate_js__ = __webpack_require__(722);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isDate", function() { return __WEBPACK_IMPORTED_MODULE_9__isDate_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__isRegExp_js__ = __webpack_require__(723);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isRegExp", function() { return __WEBPACK_IMPORTED_MODULE_10__isRegExp_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__isError_js__ = __webpack_require__(724);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isError", function() { return __WEBPACK_IMPORTED_MODULE_11__isError_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__isSymbol_js__ = __webpack_require__(179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSymbol", function() { return __WEBPACK_IMPORTED_MODULE_12__isSymbol_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__isArrayBuffer_js__ = __webpack_require__(180);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isArrayBuffer", function() { return __WEBPACK_IMPORTED_MODULE_13__isArrayBuffer_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__isDataView_js__ = __webpack_require__(128);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isDataView", function() { return __WEBPACK_IMPORTED_MODULE_14__isDataView_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__isArray_js__ = __webpack_require__(58);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isArray", function() { return __WEBPACK_IMPORTED_MODULE_15__isArray_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__isFunction_js__ = __webpack_require__(30);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isFunction", function() { return __WEBPACK_IMPORTED_MODULE_16__isFunction_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__isArguments_js__ = __webpack_require__(129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isArguments", function() { return __WEBPACK_IMPORTED_MODULE_17__isArguments_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__isFinite_js__ = __webpack_require__(726);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isFinite", function() { return __WEBPACK_IMPORTED_MODULE_18__isFinite_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__isNaN_js__ = __webpack_require__(181);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isNaN", function() { return __WEBPACK_IMPORTED_MODULE_19__isNaN_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__isTypedArray_js__ = __webpack_require__(182);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isTypedArray", function() { return __WEBPACK_IMPORTED_MODULE_20__isTypedArray_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__isEmpty_js__ = __webpack_require__(728);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function() { return __WEBPACK_IMPORTED_MODULE_21__isEmpty_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__isMatch_js__ = __webpack_require__(187);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isMatch", function() { return __WEBPACK_IMPORTED_MODULE_22__isMatch_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__isEqual_js__ = __webpack_require__(729);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isEqual", function() { return __WEBPACK_IMPORTED_MODULE_23__isEqual_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__isMap_js__ = __webpack_require__(731);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isMap", function() { return __WEBPACK_IMPORTED_MODULE_24__isMap_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__isWeakMap_js__ = __webpack_require__(732);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isWeakMap", function() { return __WEBPACK_IMPORTED_MODULE_25__isWeakMap_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__isSet_js__ = __webpack_require__(733);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSet", function() { return __WEBPACK_IMPORTED_MODULE_26__isSet_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__isWeakSet_js__ = __webpack_require__(734);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isWeakSet", function() { return __WEBPACK_IMPORTED_MODULE_27__isWeakSet_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__keys_js__ = __webpack_require__(14);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "keys", function() { return __WEBPACK_IMPORTED_MODULE_28__keys_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__allKeys_js__ = __webpack_require__(85);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "allKeys", function() { return __WEBPACK_IMPORTED_MODULE_29__allKeys_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__values_js__ = __webpack_require__(67);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "values", function() { return __WEBPACK_IMPORTED_MODULE_30__values_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pairs_js__ = __webpack_require__(735);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pairs", function() { return __WEBPACK_IMPORTED_MODULE_31__pairs_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__invert_js__ = __webpack_require__(188);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "invert", function() { return __WEBPACK_IMPORTED_MODULE_32__invert_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__functions_js__ = __webpack_require__(189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "functions", function() { return __WEBPACK_IMPORTED_MODULE_33__functions_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "methods", function() { return __WEBPACK_IMPORTED_MODULE_33__functions_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__extend_js__ = __webpack_require__(190);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "extend", function() { return __WEBPACK_IMPORTED_MODULE_34__extend_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__extendOwn_js__ = __webpack_require__(133);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "extendOwn", function() { return __WEBPACK_IMPORTED_MODULE_35__extendOwn_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "assign", function() { return __WEBPACK_IMPORTED_MODULE_35__extendOwn_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__defaults_js__ = __webpack_require__(191);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaults", function() { return __WEBPACK_IMPORTED_MODULE_36__defaults_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__create_js__ = __webpack_require__(736);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "create", function() { return __WEBPACK_IMPORTED_MODULE_37__create_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__clone_js__ = __webpack_require__(737);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "clone", function() { return __WEBPACK_IMPORTED_MODULE_38__clone_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__tap_js__ = __webpack_require__(738);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tap", function() { return __WEBPACK_IMPORTED_MODULE_39__tap_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__get_js__ = __webpack_require__(193);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return __WEBPACK_IMPORTED_MODULE_40__get_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__has_js__ = __webpack_require__(739);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "has", function() { return __WEBPACK_IMPORTED_MODULE_41__has_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__mapObject_js__ = __webpack_require__(740);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mapObject", function() { return __WEBPACK_IMPORTED_MODULE_42__mapObject_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__identity_js__ = __webpack_require__(135);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "identity", function() { return __WEBPACK_IMPORTED_MODULE_43__identity_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__constant_js__ = __webpack_require__(183);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "constant", function() { return __WEBPACK_IMPORTED_MODULE_44__constant_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__noop_js__ = __webpack_require__(197);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return __WEBPACK_IMPORTED_MODULE_45__noop_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__toPath_js__ = __webpack_require__(194);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "toPath", function() { return __WEBPACK_IMPORTED_MODULE_46__toPath_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__property_js__ = __webpack_require__(136);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "property", function() { return __WEBPACK_IMPORTED_MODULE_47__property_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__propertyOf_js__ = __webpack_require__(741);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "propertyOf", function() { return __WEBPACK_IMPORTED_MODULE_48__propertyOf_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__matcher_js__ = __webpack_require__(102);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matcher", function() { return __WEBPACK_IMPORTED_MODULE_49__matcher_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matches", function() { return __WEBPACK_IMPORTED_MODULE_49__matcher_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__times_js__ = __webpack_require__(742);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "times", function() { return __WEBPACK_IMPORTED_MODULE_50__times_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__random_js__ = __webpack_require__(198);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "random", function() { return __WEBPACK_IMPORTED_MODULE_51__random_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__now_js__ = __webpack_require__(137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "now", function() { return __WEBPACK_IMPORTED_MODULE_52__now_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__escape_js__ = __webpack_require__(743);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "escape", function() { return __WEBPACK_IMPORTED_MODULE_53__escape_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__unescape_js__ = __webpack_require__(744);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "unescape", function() { return __WEBPACK_IMPORTED_MODULE_54__unescape_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__templateSettings_js__ = __webpack_require__(201);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "templateSettings", function() { return __WEBPACK_IMPORTED_MODULE_55__templateSettings_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__template_js__ = __webpack_require__(746);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "template", function() { return __WEBPACK_IMPORTED_MODULE_56__template_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__result_js__ = __webpack_require__(747);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "result", function() { return __WEBPACK_IMPORTED_MODULE_57__result_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__uniqueId_js__ = __webpack_require__(748);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "uniqueId", function() { return __WEBPACK_IMPORTED_MODULE_58__uniqueId_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__chain_js__ = __webpack_require__(749);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "chain", function() { return __WEBPACK_IMPORTED_MODULE_59__chain_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__iteratee_js__ = __webpack_require__(196);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "iteratee", function() { return __WEBPACK_IMPORTED_MODULE_60__iteratee_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__partial_js__ = __webpack_require__(103);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "partial", function() { return __WEBPACK_IMPORTED_MODULE_61__partial_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__bind_js__ = __webpack_require__(203);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bind", function() { return __WEBPACK_IMPORTED_MODULE_62__bind_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__bindAll_js__ = __webpack_require__(750);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindAll", function() { return __WEBPACK_IMPORTED_MODULE_63__bindAll_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__memoize_js__ = __webpack_require__(751);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "memoize", function() { return __WEBPACK_IMPORTED_MODULE_64__memoize_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__delay_js__ = __webpack_require__(204);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return __WEBPACK_IMPORTED_MODULE_65__delay_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__defer_js__ = __webpack_require__(752);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defer", function() { return __WEBPACK_IMPORTED_MODULE_66__defer_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__throttle_js__ = __webpack_require__(753);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_67__throttle_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__debounce_js__ = __webpack_require__(754);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "debounce", function() { return __WEBPACK_IMPORTED_MODULE_68__debounce_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__wrap_js__ = __webpack_require__(755);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "wrap", function() { return __WEBPACK_IMPORTED_MODULE_69__wrap_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__negate_js__ = __webpack_require__(138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "negate", function() { return __WEBPACK_IMPORTED_MODULE_70__negate_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__compose_js__ = __webpack_require__(756);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_71__compose_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__after_js__ = __webpack_require__(757);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "after", function() { return __WEBPACK_IMPORTED_MODULE_72__after_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__before_js__ = __webpack_require__(205);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "before", function() { return __WEBPACK_IMPORTED_MODULE_73__before_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__once_js__ = __webpack_require__(758);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "once", function() { return __WEBPACK_IMPORTED_MODULE_74__once_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__findKey_js__ = __webpack_require__(206);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findKey", function() { return __WEBPACK_IMPORTED_MODULE_75__findKey_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__findIndex_js__ = __webpack_require__(139);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findIndex", function() { return __WEBPACK_IMPORTED_MODULE_76__findIndex_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__findLastIndex_js__ = __webpack_require__(208);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findLastIndex", function() { return __WEBPACK_IMPORTED_MODULE_77__findLastIndex_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__sortedIndex_js__ = __webpack_require__(209);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sortedIndex", function() { return __WEBPACK_IMPORTED_MODULE_78__sortedIndex_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__indexOf_js__ = __webpack_require__(210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "indexOf", function() { return __WEBPACK_IMPORTED_MODULE_79__indexOf_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__lastIndexOf_js__ = __webpack_require__(759);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lastIndexOf", function() { return __WEBPACK_IMPORTED_MODULE_80__lastIndexOf_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__find_js__ = __webpack_require__(212);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "find", function() { return __WEBPACK_IMPORTED_MODULE_81__find_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "detect", function() { return __WEBPACK_IMPORTED_MODULE_81__find_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__findWhere_js__ = __webpack_require__(760);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findWhere", function() { return __WEBPACK_IMPORTED_MODULE_82__findWhere_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__each_js__ = __webpack_require__(59);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "each", function() { return __WEBPACK_IMPORTED_MODULE_83__each_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forEach", function() { return __WEBPACK_IMPORTED_MODULE_83__each_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__map_js__ = __webpack_require__(69);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "map", function() { return __WEBPACK_IMPORTED_MODULE_84__map_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "collect", function() { return __WEBPACK_IMPORTED_MODULE_84__map_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__reduce_js__ = __webpack_require__(761);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reduce", function() { return __WEBPACK_IMPORTED_MODULE_85__reduce_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "foldl", function() { return __WEBPACK_IMPORTED_MODULE_85__reduce_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return __WEBPACK_IMPORTED_MODULE_85__reduce_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__reduceRight_js__ = __webpack_require__(762);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reduceRight", function() { return __WEBPACK_IMPORTED_MODULE_86__reduceRight_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "foldr", function() { return __WEBPACK_IMPORTED_MODULE_86__reduceRight_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__filter_js__ = __webpack_require__(88);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return __WEBPACK_IMPORTED_MODULE_87__filter_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_87__filter_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__reject_js__ = __webpack_require__(763);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reject", function() { return __WEBPACK_IMPORTED_MODULE_88__reject_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__every_js__ = __webpack_require__(764);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "every", function() { return __WEBPACK_IMPORTED_MODULE_89__every_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return __WEBPACK_IMPORTED_MODULE_89__every_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__some_js__ = __webpack_require__(765);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "some", function() { return __WEBPACK_IMPORTED_MODULE_90__some_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "any", function() { return __WEBPACK_IMPORTED_MODULE_90__some_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__contains_js__ = __webpack_require__(89);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "contains", function() { return __WEBPACK_IMPORTED_MODULE_91__contains_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "includes", function() { return __WEBPACK_IMPORTED_MODULE_91__contains_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "include", function() { return __WEBPACK_IMPORTED_MODULE_91__contains_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__invoke_js__ = __webpack_require__(766);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "invoke", function() { return __WEBPACK_IMPORTED_MODULE_92__invoke_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__pluck_js__ = __webpack_require__(140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pluck", function() { return __WEBPACK_IMPORTED_MODULE_93__pluck_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__where_js__ = __webpack_require__(767);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "where", function() { return __WEBPACK_IMPORTED_MODULE_94__where_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__max_js__ = __webpack_require__(214);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "max", function() { return __WEBPACK_IMPORTED_MODULE_95__max_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__min_js__ = __webpack_require__(768);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "min", function() { return __WEBPACK_IMPORTED_MODULE_96__min_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__shuffle_js__ = __webpack_require__(769);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "shuffle", function() { return __WEBPACK_IMPORTED_MODULE_97__shuffle_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__sample_js__ = __webpack_require__(215);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sample", function() { return __WEBPACK_IMPORTED_MODULE_98__sample_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__sortBy_js__ = __webpack_require__(770);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sortBy", function() { return __WEBPACK_IMPORTED_MODULE_99__sortBy_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__groupBy_js__ = __webpack_require__(771);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "groupBy", function() { return __WEBPACK_IMPORTED_MODULE_100__groupBy_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__indexBy_js__ = __webpack_require__(772);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "indexBy", function() { return __WEBPACK_IMPORTED_MODULE_101__indexBy_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__countBy_js__ = __webpack_require__(773);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "countBy", function() { return __WEBPACK_IMPORTED_MODULE_102__countBy_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__partition_js__ = __webpack_require__(774);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "partition", function() { return __WEBPACK_IMPORTED_MODULE_103__partition_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__toArray_js__ = __webpack_require__(216);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "toArray", function() { return __WEBPACK_IMPORTED_MODULE_104__toArray_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__size_js__ = __webpack_require__(775);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "size", function() { return __WEBPACK_IMPORTED_MODULE_105__size_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__pick_js__ = __webpack_require__(217);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pick", function() { return __WEBPACK_IMPORTED_MODULE_106__pick_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__omit_js__ = __webpack_require__(777);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "omit", function() { return __WEBPACK_IMPORTED_MODULE_107__omit_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__first_js__ = __webpack_require__(778);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "first", function() { return __WEBPACK_IMPORTED_MODULE_108__first_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "head", function() { return __WEBPACK_IMPORTED_MODULE_108__first_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "take", function() { return __WEBPACK_IMPORTED_MODULE_108__first_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__initial_js__ = __webpack_require__(218);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "initial", function() { return __WEBPACK_IMPORTED_MODULE_109__initial_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__last_js__ = __webpack_require__(779);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "last", function() { return __WEBPACK_IMPORTED_MODULE_110__last_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__rest_js__ = __webpack_require__(219);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "rest", function() { return __WEBPACK_IMPORTED_MODULE_111__rest_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tail", function() { return __WEBPACK_IMPORTED_MODULE_111__rest_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "drop", function() { return __WEBPACK_IMPORTED_MODULE_111__rest_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__compact_js__ = __webpack_require__(780);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compact", function() { return __WEBPACK_IMPORTED_MODULE_112__compact_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__flatten_js__ = __webpack_require__(781);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "flatten", function() { return __WEBPACK_IMPORTED_MODULE_113__flatten_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__without_js__ = __webpack_require__(782);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "without", function() { return __WEBPACK_IMPORTED_MODULE_114__without_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__uniq_js__ = __webpack_require__(221);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "uniq", function() { return __WEBPACK_IMPORTED_MODULE_115__uniq_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "unique", function() { return __WEBPACK_IMPORTED_MODULE_115__uniq_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__union_js__ = __webpack_require__(783);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "union", function() { return __WEBPACK_IMPORTED_MODULE_116__union_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__intersection_js__ = __webpack_require__(784);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "intersection", function() { return __WEBPACK_IMPORTED_MODULE_117__intersection_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__difference_js__ = __webpack_require__(220);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "difference", function() { return __WEBPACK_IMPORTED_MODULE_118__difference_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__unzip_js__ = __webpack_require__(222);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "unzip", function() { return __WEBPACK_IMPORTED_MODULE_119__unzip_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "transpose", function() { return __WEBPACK_IMPORTED_MODULE_119__unzip_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__zip_js__ = __webpack_require__(785);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return __WEBPACK_IMPORTED_MODULE_120__zip_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__object_js__ = __webpack_require__(786);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "object", function() { return __WEBPACK_IMPORTED_MODULE_121__object_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__range_js__ = __webpack_require__(787);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "range", function() { return __WEBPACK_IMPORTED_MODULE_122__range_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__chunk_js__ = __webpack_require__(788);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "chunk", function() { return __WEBPACK_IMPORTED_MODULE_123__chunk_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__mixin_js__ = __webpack_require__(789);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mixin", function() { return __WEBPACK_IMPORTED_MODULE_124__mixin_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__underscore_array_methods_js__ = __webpack_require__(790);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_125__underscore_array_methods_js__["a"]; });
// Named Exports
// =============

//     Underscore.js 1.13.2
//     https://underscorejs.org
//     (c) 2009-2021 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

// Baseline setup.



// Object Functions
// ----------------
// Our most fundamental functions operate on any JavaScript object.
// Most functions in Underscore depend on at least one function in this section.

// A group of functions that check the types of core JavaScript values.
// These are often informally referred to as the "isType" functions.



























// Functions that treat an object as a dictionary of key-value pairs.
















// Utility Functions
// -----------------
// A bit of a grab bag: Predicate-generating functions for use with filters and
// loops, string escaping and templating, create random numbers and unique ids,
// and functions that facilitate Underscore's chaining and iteration conventions.



















// Function (ahem) Functions
// -------------------------
// These functions take a function as an argument and return a new function
// as the result. Also known as higher-order functions.















// Finders
// -------
// Functions that extract (the position of) a single element from an object
// or array based on some criterion.









// Collection Functions
// --------------------
// Functions that work on any collection of elements: either an array, or
// an object of key-value pairs.
























// `_.pick` and `_.omit` are actually object functions, but we put
// them here in order to create a more natural reading order in the
// monolithic build as they depend on `_.contains`.



// Array Functions
// ---------------
// Functions that operate on arrays (and array-likes) only, because they’re
// expressed in terms of operations on an ordered list of values.

















// OOP
// ---
// These modules support the "object-oriented" calling style. See also
// `underscore.js` and `index-default.js`.




/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(16);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('String'));


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayBuffer_js__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stringTagBug_js__ = __webpack_require__(84);





var isDataView = Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('DataView');

// In IE 10 - Edge 13, we need a different heuristic
// to determine whether an object is a `DataView`.
function ie10IsDataView(obj) {
  return obj != null && Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(obj.getInt8) && Object(__WEBPACK_IMPORTED_MODULE_2__isArrayBuffer_js__["a" /* default */])(obj.buffer);
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__stringTagBug_js__["a" /* hasStringTagBug */] ? ie10IsDataView : isDataView);


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__has_js__ = __webpack_require__(46);



var isArguments = Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Arguments');

// Define a fallback version of the method in browsers (ahem, IE < 9), where
// there isn't any inspectable "Arguments" type.
(function() {
  if (!isArguments(arguments)) {
    isArguments = function(obj) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__has_js__["a" /* default */])(obj, 'callee');
    };
  }
}());

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shallowProperty_js__ = __webpack_require__(185);


// Internal helper to obtain the `byteLength` property of an object.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__shallowProperty_js__["a" /* default */])('byteLength'));


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ie11fingerprint;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return weakMapMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setMethods; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__allKeys_js__ = __webpack_require__(85);




// Since the regular `Object.prototype.toString` type tests don't work for
// some types in IE 11, we use a fingerprinting heuristic instead, based
// on the methods. It's not great, but it's the best we got.
// The fingerprint method lists are defined below.
function ie11fingerprint(methods) {
  var length = Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(methods);
  return function(obj) {
    if (obj == null) return false;
    // `Map`, `WeakMap` and `Set` have no enumerable keys.
    var keys = Object(__WEBPACK_IMPORTED_MODULE_2__allKeys_js__["a" /* default */])(obj);
    if (Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(keys)) return false;
    for (var i = 0; i < length; i++) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(obj[methods[i]])) return false;
    }
    // If we are testing against `WeakMap`, we need to ensure that
    // `obj` doesn't have a `forEach` method in order to distinguish
    // it from a regular `Map`.
    return methods !== weakMapMethods || !Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(obj[forEachName]);
  };
}

// In the interest of compact minification, we write
// each string in the fingerprints only once.
var forEachName = 'forEach',
    hasName = 'has',
    commonInit = ['clear', 'delete'],
    mapTail = ['get', hasName, 'set'];

// `Map`, `WeakMap` and `Set` each have slightly different
// combinations of the above sublists.
var mapMethods = commonInit.concat(forEachName, mapTail),
    weakMapMethods = commonInit.concat(mapTail),
    setMethods = ['add'].concat(commonInit, forEachName, hasName);


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createAssigner;
// An internal function for creating assigner functions.
function createAssigner(keysFunc, defaults) {
  return function(obj) {
    var length = arguments.length;
    if (defaults) obj = Object(obj);
    if (length < 2 || obj == null) return obj;
    for (var index = 1; index < length; index++) {
      var source = arguments[index],
          keys = keysFunc(source),
          l = keys.length;
      for (var i = 0; i < l; i++) {
        var key = keys[i];
        if (!defaults || obj[key] === void 0) obj[key] = source[key];
      }
    }
    return obj;
  };
}


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createAssigner_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(14);



// Assigns a given object with all the own properties in the passed-in
// object(s).
// (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createAssigner_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */]));


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = deepGet;
// Internal function to obtain a nested property in `obj` along `path`.
function deepGet(obj, path) {
  var length = path.length;
  for (var i = 0; i < length; i++) {
    if (obj == null) return void 0;
    obj = obj[path[i]];
  }
  return length ? obj : void 0;
}


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
// Keep the identity function around for default iteratees.
function identity(value) {
  return value;
}


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = property;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deepGet_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPath_js__ = __webpack_require__(86);



// Creates a function that, when passed an object, will traverse that object’s
// properties down the given `path`, specified as an array of keys or indices.
function property(path) {
  path = Object(__WEBPACK_IMPORTED_MODULE_1__toPath_js__["a" /* default */])(path);
  return function(obj) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__deepGet_js__["a" /* default */])(obj, path);
  };
}


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// A (possibly faster) way to get the current timestamp as an integer.
/* harmony default export */ __webpack_exports__["a"] = (Date.now || function() {
  return new Date().getTime();
});


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = negate;
// Returns a negated version of the passed-in predicate.
function negate(predicate) {
  return function() {
    return !predicate.apply(this, arguments);
  };
}


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPredicateIndexFinder_js__ = __webpack_require__(207);


// Returns the first index on an array-like that passes a truth test.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createPredicateIndexFinder_js__["a" /* default */])(1));


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pluck;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__property_js__ = __webpack_require__(136);



// Convenience version of a common use case of `_.map`: fetching a property.
function pluck(obj, key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__map_js__["a" /* default */])(obj, Object(__WEBPACK_IMPORTED_MODULE_1__property_js__["a" /* default */])(key));
}


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4edaaba8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pulse_vue__ = __webpack_require__(808);
function injectStyle (ssrContext) {
  __webpack_require__(806)
}
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4edaaba8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4edaaba8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pulse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(6);


/* global CONFIG */



/* harmony default export */ __webpack_exports__["a"] = ({
  updateRsvp: function updateRsvp(VueApp, params, callback) {
    VueApp.$sdk.post('/admin/rsvp/' + params.rsvpId, params, function (res) {
      callback(res);
    });
  },
  getQuote2: function getQuote2(VueApp, params, callback) {
    var self = this;
    if (!params.isCharter) {
      params.order = 'priority';
    }
    var rsvpDetails = VueApp.$store.state.rsvpDetails;
    var originalRsvp = rsvpDetails.basicInfo.tripInfo;
    var editedRsvp = rsvpDetails.edit.details.tripInfo;

    var isPickupSame = false;
    if (originalRsvp.pickup.geofenceType === 'airport' && originalRsvp.pickup.geofenceId === editedRsvp.pickup.geofenceId || originalRsvp.pickup.geofenceType !== 'airport' && originalRsvp.pickup.title === editedRsvp.pickup.title) {
      isPickupSame = true;
    }

    var isDropoffSame = false;
    if (originalRsvp.dropoff.geofenceType === 'airport' && originalRsvp.dropoff.geofenceId === editedRsvp.dropoff.geofenceId || originalRsvp.dropoff.geofenceType !== 'airport' && originalRsvp.dropoff.title === editedRsvp.dropoff.title) {
      isDropoffSame = true;
    }
    if (!rsvpDetails.isAdd && originalRsvp.serviceTypeId <= 5 && isPickupSame && isDropoffSame) {
      VueApp.$sdk.post('/reservations/' + params.pickupDate, params, function (res) {
        var extraService = {};
        if (!res.error) {
          for (var service in res.services) {
            if (res.services[service].code === originalRsvp.serviceCode) {
              extraService = {
                code: originalRsvp.serviceCode,
                value: {
                  id: res.services[service].id,
                  code: res.services[service].code,
                  name: __WEBPACK_IMPORTED_MODULE_3__services__["a" /* default */].getServiceName(res.services[service].code),
                  maxLuggage: res.services[service].maxLuggage,
                  maxPassengers: res.services[service].maxPassengers,
                  curbside: res.services[service].curbside,
                  meetAndGreet: res.services[service].meetAndGreet,
                  pickupFee: res.services[service].pickupFee,
                  prices: res.services[service].oneway,
                  status: res.services[service].status,
                  airportFee: res.services[service].airportFee,
                  travelInsurance: res.services[service].travelInsurance,
                  isShared: res.services[service].code === 'shared',
                  defaultTip: 0
                }
              };
            }
          }
          self.getNewQuote(VueApp, params, extraService, callback);
        } else {
          self.getNewQuote(VueApp, params, false, callback);
        }
      });
    } else {
      if (params.isCharter) {
        self.getCharterQuote(VueApp, params, callback);
        return;
      }
      self.getNewQuote(VueApp, params, false, callback);
    }
  },
  getNewQuote: function getNewQuote(VueApp, params, extraService, callback) {
    var self = this;
    params.isAdmin = true;

    // Mtech adds
    var rsvpStore = VueApp.$store.state.rsvpDetails;
    var rsvpEdit = VueApp.$store.state.rsvpDetails.edit.details.tripInfo;
    params.pickup.text = rsvpEdit.pickup.title;
    params.dropoff.text = rsvpEdit.dropoff.title;
    params.passengers = rsvpEdit.passenger || 1;
    if (rsvpStore.mtech.flightDate) {
      params.pickupTimestamp = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.tz(rsvpStore.mtech.flightDate, 'MM/DD/YYYY hh:mmA', rsvpStore.edit.timezone).format('X');
    } else {
      params.pickupTimestamp = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.tz(params.pickupDate + ' ' + params.pickupTime, 'YYYY-MM-DD HH:mm', rsvpStore.edit.timezone).format('X');
    }

    if (params.asap) {
      self.getLyftAsap(VueApp, params, callback);
      return;
    }

    var usa = ['us', 'usa', 'united states', 'united states of america'];
    var canada = ['can', 'ca', 'canada'];
    var ca = ['ca', 'california'];
    var brand = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.find(function (x) {
      return x.id === params.brandId;
    });
    if (brand.code === 'd2d' && params.pickup.country && (usa.indexOf(params.pickup.country.toLowerCase()) > -1 && params.pickup.state && ca.indexOf(params.pickup.state.toLowerCase()) === -1 || canada.indexOf(params.pickup.country.toLowerCase()) > -1)) {
      self.lyftQuoteCheck(VueApp, params, callback);
      return;
    }

    var timeNow = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
    VueApp.$sdk.post('/quotation', params, function (res) {
      self.sendQuoteTime(VueApp, timeNow, __WEBPACK_IMPORTED_MODULE_2_moment___default()(), res.quoteId, params.brandId);
      var mtech = res.mtech;
      VueApp.$store.commit('rsvpDetails/setMtechData', { enabled: (typeof mtech === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(mtech)) === 'object' });

      if (res.error || brand.code === 'd2d' && (res.geofences && params.pickup.country && usa.indexOf(params.pickup.country.toLowerCase()) > -1 && ca.indexOf(params.pickup.state.toLowerCase()) > -1 && !res.geofences.servicearea.name.includes('LAX') || res.geofences && params.pickup.country && usa.indexOf(params.pickup.country.toLowerCase()) > -1 && ca.indexOf(params.pickup.state.toLowerCase()) === -1 || !params.asap && params.pickup.country && canada.indexOf(params.pickup.country.toLowerCase()) > -1)) {
        self.lyftQuoteCheck(VueApp, params, callback);
        return;
      }
      if (brand.code !== 'd2d' && !params.asap && !params.isCharter && !params.extraStops && (res.services && !res.services.length && !res.mtech || res.mtech && !res.mtech.services.length)) {
        self.lyftQuoteCheck(VueApp, params, callback);
        return;
      }
      VueApp.$store.commit('rsvpDetails/setLyftData', { enabled: false });

      if (!res.error) {
        VueApp.$store.commit('rsvpDetails/setDistanceEta', {
          distance: res.route.distance,
          eta: res.route.eta.sec
        });

        var _services = {};
        if (!mtech) {
          res.services.forEach(function (service) {
            var availTimeStart = '';
            var availTimeEnd = '';
            var timeSelected = '';
            var serviceUnavailable = service.serviceType.unavailableTime;
            var unavailableService = false;
            if ((serviceUnavailable.p2p || serviceUnavailable.fromAirport || serviceUnavailable.toAirport) && serviceUnavailable.start !== serviceUnavailable.end && (params.asap && serviceUnavailable.asap || !params.asap && serviceUnavailable.future)) {
              availTimeStart = __WEBPACK_IMPORTED_MODULE_2_moment___default()(serviceUnavailable.start, 'H');
              availTimeEnd = __WEBPACK_IMPORTED_MODULE_2_moment___default()(serviceUnavailable.end, 'H');
              timeSelected = __WEBPACK_IMPORTED_MODULE_2_moment___default()(params.pickupTime, 'HH:mm');
              if (serviceUnavailable.end >= serviceUnavailable.start && timeSelected.isBetween(availTimeStart, availTimeEnd, null, '[]') || serviceUnavailable.start >= serviceUnavailable.end && !timeSelected.isBetween(availTimeEnd, availTimeStart, null, '()')) {
                if (serviceUnavailable.p2p && res.geofences.pickup.type !== 'airport' && res.geofences.dropoff.type !== 'airport' || serviceUnavailable.fromAirport && res.geofences.pickup.type === 'airport' || serviceUnavailable.toAirport && res.geofences.dropoff.type === 'airport') {
                  unavailableService = true;
                }
              }
              if (rsvpStore.edit.selectedService === 'a' + service.serviceType.id && unavailableService) {
                VueApp.$store.commit('rsvpDetails/setSelectedService', '');
              }
            }

            var curbside = false;
            var meetAndGreet = false;
            var pickupFee = 0;
            if (service.pickupTypes.length) {
              var curbsideIndex = service.pickupTypes.findIndex(function (x) {
                return x.name === 'Curbside';
              });
              var meetAndGreetIndex = service.pickupTypes.findIndex(function (x) {
                return x.name === 'MeetAndGreet';
              });
              if (curbsideIndex > -1) {
                curbside = service.pickupTypes[curbsideIndex].enabled;
              }
              if (meetAndGreetIndex > -1) {
                meetAndGreet = service.pickupTypes[meetAndGreetIndex].enabled;
                pickupFee = service.pickupTypes[meetAndGreetIndex].fee;
              }
            }
            if (!service.settings.discountAdmin) {
              service.oneway.forEach(function (price, i) {
                service.oneway[i].discount = 0;
                service.oneway[i].price = price.original;
              });
            }
            _services['a' + service.serviceType.id] = {
              id: service.serviceType.id,
              code: 'a' + service.serviceType.id,
              name: service.serviceType.name,
              maxLuggage: service.serviceType.maxLuggages,
              maxPassengers: service.serviceType.maxPassengers,
              curbside: curbside,
              meetAndGreet: meetAndGreet,
              pickupFee: pickupFee,
              prices: service.oneway,
              status: 'allowed',
              airportFee: service.settings.airportFee,
              travelInsurance: service.settings.travelInsurance,
              isShared: service.serviceType.isShared,
              licenseType: service.serviceType.licenseType,
              availability: service.availability,
              defaultTip: service.serviceType.defaultTip,
              gasFee: service.settings.gasFee || 0,
              optinAllow: service.serviceType.optinAllow,
              optinPercent: service.serviceType.optinPercent || 1,
              unavailableTime: service.unavailableTime,
              bufferTime: service.serviceType.bufferAdminMins,
              unavailableService: unavailableService,
              portalFee: service.settings.portalFee,
              portalFeeType: service.settings.portalFeeType
            };
            if (!service.serviceType.bufferAdminMins && VueApp.$store.state.settings.adminTimeBuffer) {
              _services['a' + service.serviceType.id].bufferTime = VueApp.$store.state.settings.adminTimeBuffer;
            }
            // if (service.serviceType.isShared) {
            // VueApp.$store.commit('rsvpDetails/addSharedService', services['a' + service.serviceType.id])
            // delete services['a' + service.serviceType.id]
            // }
          });
          VueApp.$store.commit('rsvpDetails/setServices', _services);
          if (extraService && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(extraService).length > 0) {
            VueApp.$store.commit('rsvpDetails/addService', extraService);
          }
        } else {
          VueApp.$store.commit('rsvpDetails/setMtechData', { quoteId: res.quoteId });
          var mtechStore = rsvpStore.mtech;
          mtech.services.forEach(function (service) {
            var product = service.product;
            var info = service.info;
            var price = service.price;

            var hasDiscount = false;
            var discountVal = 0;
            var totalBeforeDc = 0;
            var baseFare = price.amount;
            service.price.breakdown.forEach(function (x) {
              if (x.description === 'Base rate') {
                baseFare = x.amount;
              }
              if (x.description === 'Discount') {
                hasDiscount = true;
                discountVal = x.amount;
              }
              if (x.amount > 0) {
                totalBeforeDc += x.amount;
              }
            });

            var addMarkup = 0;
            if (mtech.markup.value) {
              addMarkup = mtechStore.markup.value;
              if (mtech.markup.type === '%') {
                addMarkup = baseFare * (mtech.markup.value / 100);
              }
              addMarkup = parseFloat(addMarkup.toFixed(2));
            }

            var pax = { label: '', value: 1 };
            var luggage = { label: '', value: 0 };
            var cxl = '';
            var pircePax = '';
            info.forEach(function (inf) {
              if (inf && inf.toLowerCase().indexOf('max passenger') > -1) {
                pax = {
                  label: inf,
                  value: parseInt(inf.split(' ')[inf.split(' ').length - 1]) || 1
                };
              }
              if (inf && inf.toLowerCase().indexOf('max bag') > -1) {
                luggage = {
                  label: inf,
                  value: parseInt(inf.split(' ')[inf.split(' ').length - 1]) || 1
                };
              }
              if (inf && inf.toLowerCase().indexOf('24 hour cancelation') > -1) {
                cxl = inf;
              }
              if (inf && inf.toLowerCase().indexOf('price includes all') > -1) {
                pircePax = inf;
              }
            });
            _services[service.product.code] = {
              uid: product.uid,
              category: product.category,
              code: product.code,
              desc: product.description || product.name,
              img: product.image,
              name: product.name,
              maxPax: pax.label,
              maxPaxVal: pax.value,
              maxLuggage: luggage.label,
              maxLuggageVal: luggage.value,
              cancellation: cxl,
              pricePax: pircePax,
              price: {
                baseFare: baseFare,
                amount: price.amount,
                addMarkup: addMarkup,
                breakdown: price.breakdown,
                hasDiscount: hasDiscount,
                discountVal: Math.abs(discountVal),
                totalBeforeDc: totalBeforeDc
              },
              pickupTimes: service.pickupTimes,
              product: product
            };
          });
          if (params.extraStops && params.extraStops.length) {
            _services = [];
          }
          VueApp.$store.commit('rsvpDetails/setMtechData', { services: _services });
        }

        if (res.geofences.pickup.type === 'airport') {
          VueApp.$store.commit('rsvpDetails/setAirportCode', res.geofences.pickup.code);
        } else if (res.geofences.dropoff.type === 'airport') {
          VueApp.$store.commit('rsvpDetails/setAirportCode', res.geofences.dropoff.code);
        }
      }
      callback(res);
    }, '2.0');
  },
  getQuote: function getQuote(VueApp, params, callback) {
    var self = this;
    VueApp.$sdk.post('/reservations/' + params.date, params, function (res) {
      if (!res.error) {
        VueApp.$store.commit('rsvpDetails/setDistanceEta', {
          distance: res.route.distance,
          eta: res.route.eta.sec
        });
        var _services2 = res.services;
        VueApp.$store.commit('rsvpDetails/setServices', {
          shared: self.buildServiceData(_services2.Shared),
          opoli: self.buildServiceData(_services2.Opoli),
          black: self.buildServiceData(_services2.Black),
          suv: self.buildServiceData(_services2.SUV),
          shuttle: self.buildServiceData(_services2['Private Shuttle'])
        });

        VueApp.$store.commit('rsvpDetails/setHoliday', {
          date: res.geofences.pricing.holidayDate,
          shared: {
            currency: res.geofences.pricing.pricing.SharedHolidayRateCurrency,
            value: res.geofences.pricing.pricing.SharedHolidayRate
          },
          opoli: {
            currency: res.geofences.pricing.pricing.OpoliHolidayRateCurrency,
            value: res.geofences.pricing.pricing.OpoliHolidayRate
          },
          black: {
            currency: res.geofences.pricing.pricing.BlackHolidayRateCurrency,
            value: res.geofences.pricing.pricing.BlackHolidayRate
          },
          suv: {
            currency: res.geofences.pricing.pricing.SUVHolidayRateCurrency,
            value: res.geofences.pricing.pricing.SUVHolidayRate
          },
          shuttle: {
            currency: res.geofences.pricing.pricing.PrivateShuttleHolidayRateCurrency,
            value: res.geofences.pricing.pricing.PrivateShuttleHolidayRate
          }
        });

        if (res.geofences.pickup.type === 'airport') {
          VueApp.$store.commit('rsvpDetails/setAirportCode', res.geofences.pickup.airportCode);
        } else if (res.geofences.dropoff.type === 'airport') {
          VueApp.$store.commit('rsvpDetails/setAirportCode', res.geofences.dropoff.airportCode);
        }
      }

      callback(res);
    });
  },
  getUserList: function getUserList(VueApp, params, callback) {
    VueApp.$sdk.get('/consumer', {
      token: VueApp.$store.state.session.sessionToken,
      search: params.search,
      pageNum: params.pageNum + 1,
      pageSize: params.pageSize
    }, function (res) {
      VueApp.$store.commit('rsvpDetails/setUserPageNum', params.pageNum + 1);

      var users = [];
      res.list.forEach(function (user) {
        users.push({
          id: user.ID,
          firstName: user.firstName,
          lastName: user.lastName,
          mobile: user.phone || '',
          email: user.email
        });
      });
      VueApp.$store.commit('rsvpDetails/setUserList', users);
      callback(res);
    });
  },
  buildServiceData: function buildServiceData(data) {
    var prices = [];
    for (var i = 0; i < data.maxPassengers; i++) {
      prices.push(data.oneway[i]);
    }

    return {
      id: data.id,
      code: data.code,
      maxLuggage: data.maxLuggage,
      maxPassengers: data.maxPassengers,
      curbside: data.curbside,
      meetAndGreet: data.meetAndGreet,
      pickupFee: data.pickupFee,
      prices: prices,
      status: data.status,
      airportFee: data.airportFee,
      travelInsurance: data.travelInsurance,
      portalFee: data.portalFee || 0,
      portalFeeType: data.portalFeeType
    };
  },
  getCharterQuote: function getCharterQuote(VueApp, params, callback) {
    var self = this;
    var timeNow = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
    VueApp.$sdk.post('/quotation/charter', params, function (res) {
      self.sendQuoteTime(VueApp, timeNow, __WEBPACK_IMPORTED_MODULE_2_moment___default()(), res.quoteId, params.brandId);
      if (!res.error) {
        // VueApp.$store.commit('rsvpDetails/setDistanceEta', {
        //   distance: res.route.distance,
        //   eta: res.route.eta.sec
        // })

        var _services3 = {};
        res.services.forEach(function (service) {
          var curbside = false;
          var meetAndGreet = false;
          var pickupFee = 0;
          if (service.pickupTypes.length) {
            var curbsideIndex = service.pickupTypes.findIndex(function (x) {
              return x.name === 'Curbside';
            });
            var meetAndGreetIndex = service.pickupTypes.findIndex(function (x) {
              return x.name === 'MeetAndGreet';
            });
            if (curbsideIndex > -1) {
              curbside = service.pickupTypes[curbsideIndex].enabled;
            }
            if (meetAndGreetIndex > -1) {
              meetAndGreet = service.pickupTypes[meetAndGreetIndex].enabled;
              pickupFee = service.pickupTypes[meetAndGreetIndex].fee;
            }
          }
          var price = [];
          for (var x = 0; x < service.serviceType.maxPassengers; x++) {
            price.push(service.fare);
          }
          _services3['a' + service.serviceType.id] = {
            id: service.serviceType.id,
            code: 'a' + service.serviceType.id,
            name: service.serviceType.name,
            maxLuggage: service.serviceType.maxLuggages,
            maxPassengers: service.serviceType.maxPassengers,
            curbside: curbside,
            meetAndGreet: meetAndGreet,
            pickupFee: pickupFee,
            prices: price,
            status: 'allowed',
            airportFee: service.settings.airportFee,
            travelInsurance: service.settings.travelInsurance || 0,
            isShared: service.serviceType.isShared,
            licenseType: service.serviceType.licenseType,
            availability: service.availability || null,
            defaultTip: service.serviceType.defaultTip,
            portalFee: service.settings.portalFee,
            portalFeeType: service.settings.portalFeeType
          };
        });
        VueApp.$store.commit('rsvpDetails/setServices', _services3);

        if (res.airport && res.airport.id) {
          VueApp.$store.commit('rsvpDetails/setAirportCode', res.airport.airportCode || 'LAX');
        }
      }
      callback(res);
    }, '2.0');
  },
  sendQuoteTime: function sendQuoteTime(VueApp, start, end, quoteId, brandId) {
    var store = VueApp.$store.state;
    var duration = end.diff(start, 'milliseconds') / 1000;
    VueApp.$sdk.opt('/quotation/time', {
      token: store.session.sessionToken,
      brandId: brandId,
      quotationId: quoteId,
      responseTime: duration,
      deviceType: 'admin'
    }, function (res) {
      if (res.error) console.log('ERROR quotation time');
    });
  },
  getLyftAsap: function getLyftAsap(VueApp, param, callback) {
    var self = this;
    VueApp.$sdk.post('/quotation/asap', param, function (res) {
      self.buildLyftService(VueApp, param, res, callback);
    }, '2.0');
  },
  buildLyftService: function buildLyftService(VueApp, param, res, callback) {
    if (res.lyft) {
      var hasService = false;
      res.lyft.forEach(function (x) {
        if (x.can_request_ride) hasService = true;
      });
      if (!hasService) res.lyft = [];
    }

    var services = {};
    if (res.lyft && !res.lyft.length || res.error) {
      if (!res.error) res.error = {};else {
        console.log(1);
        callback(res);
        return;
      }
    } else {
      VueApp.$store.commit('rsvpDetails/setLyftData', { enabled: true });
      VueApp.$store.commit('rsvpDetails/setDistanceEta', {
        distance: res.route.distance,
        eta: res.route.eta.sec
      });
      res.lyft.forEach(function (service) {
        var curbside = false;
        var meetAndGreet = false;
        var pickupFee = 0;
        var price = (service.estimated_cost_cents_max / 100).toFixed(2);
        var maxPax = service.price_explanation_text ? service.price_explanation_text.replace(/^\D+/g, '') : 4;
        if (maxPax) maxPax = parseInt(maxPax);
        if (!maxPax) maxPax = 4;
        var pricesArray = [{
          discount: 0,
          distance: service.estimated_distance_miles,
          original: parseFloat(price),
          price: parseFloat(price),
          passengers: 1
        }];
        for (var c = 1; c < maxPax; c++) {
          pricesArray.push(pricesArray[0]);
        }
        services['a' + service.ride_type] = {
          id: service.ride_type,
          code: 'a' + service.ride_type,
          name: service.display_name,
          maxLuggage: maxPax,
          maxPassengers: maxPax,
          curbside: curbside,
          meetAndGreet: meetAndGreet,
          pickupFee: pickupFee,
          prices: pricesArray,
          status: 'allowed',
          airportFee: 0,
          travelInsurance: 0,
          isShared: false,
          licenseType: '',
          availability: null,
          defaultTip: 0,
          gasFee: 0,
          optinAllow: false,
          optinPercent: 1,
          unavailableTime: false,
          bufferTime: 0,
          unavailableService: false,
          portalFee: 0,
          portalFeeType: '$',
          ride_type: service.ride_type,
          cost_token: service.cost_token,
          driver_availability_token: service.driver_availability_token || ''
          // if (!service.serviceType.bufferAdminMins && VueApp.$store.state.settings.adminTimeBuffer) {
          //   services['a' + service.serviceType.id].bufferTime = VueApp.$store.state.settings.adminTimeBuffer
          // }
        };
      });
      VueApp.$store.commit('rsvpDetails/setServices', services);

      // if (res.geofences.pickup.type === 'airport') {
      //   VueApp.$store.commit('rsvpDetails/setAirportCode', res.geofences.pickup.code)
      // } else if (res.geofences.dropoff.type === 'airport') {
      //   VueApp.$store.commit('rsvpDetails/setAirportCode', res.geofences.dropoff.code)
      // }
      VueApp.$store.commit('rsvpDetails/setAirportCode', '');
    }
    VueApp.$store.commit('rsvpDetails/setServices', services);

    callback(res);
  },
  lyftQuoteCheck: function lyftQuoteCheck(VueApp, param, callback) {
    var self = this;
    var newParam = {
      brandId: param.brandId,
      pickup: param.pickup,
      dropoff: param.dropoff,
      pickupTime: __WEBPACK_IMPORTED_MODULE_2_moment___default()(param.pickupDate, 'YYYY-MM-DD').format('X')
    };

    VueApp.$store.commit('rsvpDetails/setSelectedService', '');
    VueApp.$sdk.post('/quotation/lyft/future', newParam, function (res) {
      self.buildLyftService(VueApp, param, res, callback);
    }, '2.0');
  }
});

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(820);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(824);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(19);


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(99)('meta');
var isObject = __webpack_require__(36);
var has = __webpack_require__(54);
var setDesc = __webpack_require__(33).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(53)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var core = __webpack_require__(12);
var LIBRARY = __webpack_require__(79);
var wksExt = __webpack_require__(144);
var defineProperty = __webpack_require__(33).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(76);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(44);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchNotification_vue__ = __webpack_require__(449);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_184cf8aa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchNotification_vue__ = __webpack_require__(1260);
function injectStyle (ssrContext) {
  __webpack_require__(1258)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-184cf8aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchNotification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_184cf8aa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchNotification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchSchedule_vue__ = __webpack_require__(450);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de716450_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchSchedule_vue__ = __webpack_require__(1263);
function injectStyle (ssrContext) {
  __webpack_require__(1261)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-de716450"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchSchedule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de716450_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchSchedule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f788979c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapMarker_vue__ = __webpack_require__(1340);
function injectStyle (ssrContext) {
  __webpack_require__(1338)
}
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f788979c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f788979c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapMarker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoutingModal_vue__ = __webpack_require__(481);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f641a02_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoutingModal_vue__ = __webpack_require__(1344);
function injectStyle (ssrContext) {
  __webpack_require__(1342)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f641a02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoutingModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f641a02_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoutingModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1460)
var ieee754 = __webpack_require__(1461)
var isArray = __webpack_require__(1462)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 156 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.XlsxPopulate = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return require(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _ = require("lodash");

var xmlq = require("./xmlq");

var ArgHandler = require("./ArgHandler");
/**
 * App properties
 * @ignore
 */


var AppProperties = /*#__PURE__*/function () {
  /**
   * Creates a new instance of AppProperties
   * @param {{}} node - The node.
   */
  function AppProperties(node) {
    _classCallCheck(this, AppProperties);

    this._node = node;
  }

  _createClass(AppProperties, [{
    key: "isSecure",
    value: function isSecure(value) {
      var _this = this;

      return new ArgHandler("Range.formula").case(function () {
        var docSecurityNode = xmlq.findChild(_this._node, "DocSecurity");
        if (!docSecurityNode) return false;
        return docSecurityNode.children[0] === 1;
      }).case('boolean', function (value) {
        var docSecurityNode = xmlq.appendChildIfNotFound(_this._node, "DocSecurity");
        docSecurityNode.children = [value ? 1 : 0];
        return _this;
      }).handle(arguments);
    }
    /**
     * Convert the collection to an XML object.
     * @returns {{}} The XML.
     */

  }, {
    key: "toXml",
    value: function toXml() {
      return this._node;
    }
  }]);

  return AppProperties;
}();

module.exports = AppProperties;
/*
docProps/app.xml

<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Properties xmlns="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties" xmlns:vt="http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes">
    <Application>Microsoft Excel</Application>
<DocSecurity>1</DocSecurity>
<ScaleCrop>false</ScaleCrop>
<HeadingPairs>
<vt:vector size="2" baseType="variant">
    <vt:variant>
<vt:lpstr>Worksheets</vt:lpstr>
</vt:variant>
<vt:variant>
<vt:i4>1</vt:i4>
</vt:variant>
</vt:vector>
</HeadingPairs>
<TitlesOfParts>
<vt:vector size="1" baseType="lpstr">
    <vt:lpstr>Sheet1</vt:lpstr>
</vt:vector>
</TitlesOfParts>
<Company/>
<LinksUpToDate>false</LinksUpToDate>
<SharedDoc>false</SharedDoc>
<HyperlinksChanged>false</HyperlinksChanged>
<AppVersion>16.0300</AppVersion>
</Properties>
 */

},{"./ArgHandler":2,"./xmlq":29,"lodash":170}],2:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _ = require("lodash");
/**
 * Method argument handler. Used for overloading methods.
 * @private
 */


var ArgHandler = /*#__PURE__*/function () {
  /**
   * Creates a new instance of ArgHandler.
   * @param {string} name - The method name to use in error messages.
   */
  function ArgHandler(name) {
    _classCallCheck(this, ArgHandler);

    this._name = name;
    this._cases = [];
  }
  /**
   * Add a case.
   * @param {string|Array.<string>} [types] - The type or types of arguments to match this case.
   * @param {Function} handler - The function to call when this case is matched.
   * @returns {ArgHandler} The handler for chaining.
   */


  _createClass(ArgHandler, [{
    key: "case",
    value: function _case(types, handler) {
      if (arguments.length === 1) {
        handler = types;
        types = [];
      }

      if (!Array.isArray(types)) types = [types];

      this._cases.push({
        types: types,
        handler: handler
      });

      return this;
    }
    /**
     * Handle the method arguments by checking each case in order until one matches and then call its handler.
     * @param {Arguments|Array.<*>} args - The method arguments.
     * @returns {*} The result of the handler.
     * @throws {Error} Throws if no case matches.
     */

  }, {
    key: "handle",
    value: function handle(args) {
      for (var i = 0; i < this._cases.length; i++) {
        var c = this._cases[i];

        if (this._argsMatchTypes(args, c.types)) {
          return c.handler.apply(null, args);
        }
      }

      throw new Error("".concat(this._name, ": Invalid arguments."));
    }
    /**
     * Check if the arguments match the given types.
     * @param {Arguments} args - The arguments.
     * @param {Array.<string>} types - The types.
     * @returns {boolean} True if matches, false otherwise.
     * @throws {Error} Throws if unknown type.
     * @private
     */

  }, {
    key: "_argsMatchTypes",
    value: function _argsMatchTypes(args, types) {
      if (args.length !== types.length) return false;
      return _.every(args, function (arg, i) {
        var type = types[i];
        if (type === '*') return true;
        if (type === 'nil') return _.isNil(arg);
        if (type === 'string') return typeof arg === "string";
        if (type === 'boolean') return typeof arg === "boolean";
        if (type === 'number') return typeof arg === "number";
        if (type === 'integer') return typeof arg === "number" && _.isInteger(arg);
        if (type === 'function') return typeof arg === "function";
        if (type === 'array') return Array.isArray(arg);
        if (type === 'date') return arg && arg.constructor === Date;
        if (type === 'object') return arg && arg.constructor === Object;
        if (arg && arg.constructor && arg.constructor.name === type) return true;
        throw new Error("Unknown type: ".concat(type));
      });
    }
  }]);

  return ArgHandler;
}();

module.exports = ArgHandler;

},{"lodash":170}],3:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _ = require("lodash");

var ArgHandler = require("./ArgHandler");

var addressConverter = require("./addressConverter");

var dateConverter = require("./dateConverter");

var regexify = require("./regexify");

var xmlq = require("./xmlq");

var FormulaError = require("./FormulaError");

var Style = require("./Style");

var RichText = require("./RichText");
/**
 * A cell
 */


var Cell = /*#__PURE__*/function () {
  // /**
  //  * Creates a new instance of cell.
  //  * @param {Row} row - The parent row.
  //  * @param {{}} node - The cell node.
  //  */
  function Cell(row, node, styleId) {
    _classCallCheck(this, Cell);

    this._row = row;

    this._init(node, styleId);
  }
  /* PUBLIC */

  /**
   * Gets a value indicating whether the cell is the active cell in the sheet.
   * @returns {boolean} True if active, false otherwise.
   */

  /**
  * Make the cell the active cell in the sheet.
  * @param {boolean} active - Must be set to `true`. Deactivating directly is not supported. To deactivate, you should activate a different cell instead.
  * @returns {Cell} The cell.
  */


  _createClass(Cell, [{
    key: "active",
    value: function active() {
      var _this = this;

      return new ArgHandler('Cell.active').case(function () {
        return _this.sheet().activeCell() === _this;
      }).case('boolean', function (active) {
        if (!active) throw new Error("Deactivating cell directly not supported. Activate a different cell instead.");

        _this.sheet().activeCell(_this);

        return _this;
      }).handle(arguments);
    }
    /**
     * Get the address of the column.
     * @param {{}} [opts] - Options
     * @param {boolean} [opts.includeSheetName] - Include the sheet name in the address.
     * @param {boolean} [opts.rowAnchored] - Anchor the row.
     * @param {boolean} [opts.columnAnchored] - Anchor the column.
     * @param {boolean} [opts.anchored] - Anchor both the row and the column.
     * @returns {string} The address
     */

  }, {
    key: "address",
    value: function address(opts) {
      return addressConverter.toAddress({
        type: 'cell',
        rowNumber: this.rowNumber(),
        columnNumber: this.columnNumber(),
        sheetName: opts && opts.includeSheetName && this.sheet().name(),
        rowAnchored: opts && (opts.rowAnchored || opts.anchored),
        columnAnchored: opts && (opts.columnAnchored || opts.anchored)
      });
    }
    /**
     * Gets the parent column of the cell.
     * @returns {Column} The parent column.
     */

  }, {
    key: "column",
    value: function column() {
      return this.sheet().column(this.columnNumber());
    }
    /**
     * Clears the contents from the cell.
     * @returns {Cell} The cell.
     */

  }, {
    key: "clear",
    value: function clear() {
      var hostSharedFormulaId = this._formulaRef && this._sharedFormulaId;
      delete this._value;
      delete this._formulaType;
      delete this._formula;
      delete this._sharedFormulaId;
      delete this._formulaRef; // TODO in future version: Move shared formula to some other cell. This would require parsing the formula...

      if (!_.isNil(hostSharedFormulaId)) this.sheet().clearCellsUsingSharedFormula(hostSharedFormulaId);
      return this;
    }
    /**
     * Gets the column name of the cell.
     * @returns {string} The column name.
     */

  }, {
    key: "columnName",
    value: function columnName() {
      return addressConverter.columnNumberToName(this.columnNumber());
    }
    /**
     * Gets the column number of the cell (1-based).
     * @returns {number} The column number.
     */

  }, {
    key: "columnNumber",
    value: function columnNumber() {
      return this._columnNumber;
    }
    /**
     * Find the given pattern in the cell and optionally replace it.
     * @param {string|RegExp} pattern - The pattern to look for. Providing a string will result in a case-insensitive substring search. Use a RegExp for more sophisticated searches.
     * @param {string|function} [replacement] - The text to replace or a String.replace callback function. If pattern is a string, all occurrences of the pattern in the cell will be replaced.
     * @returns {boolean} A flag indicating if the pattern was found.
     */

  }, {
    key: "find",
    value: function find(pattern, replacement) {
      pattern = regexify(pattern);
      var value = this.value();
      if (typeof value !== 'string') return false;

      if (_.isNil(replacement)) {
        return pattern.test(value);
      } else {
        var replaced = value.replace(pattern, replacement);
        if (replaced === value) return false;
        this.value(replaced);
        return true;
      }
    }
    /**
     * Gets the formula in the cell. Note that if a formula was set as part of a range, the getter will return 'SHARED'. This is a limitation that may be addressed in a future release.
     * @returns {string} The formula in the cell.
     */

    /**
    * Sets the formula in the cell.
    * @param {string} formula - The formula to set.
    * @returns {Cell} The cell.
    */

  }, {
    key: "formula",
    value: function formula() {
      var _this2 = this;

      return new ArgHandler('Cell.formula').case(function () {
        // TODO in future: Return translated formula.
        if (_this2._formulaType === "shared" && !_this2._formulaRef) return "SHARED";
        return _this2._formula;
      }).case('nil', function () {
        _this2.clear();

        return _this2;
      }).case('string', function (formula) {
        _this2.clear();

        _this2._formulaType = "normal";
        _this2._formula = formula;
        return _this2;
      }).handle(arguments);
    }
    /**
     * Gets the hyperlink attached to the cell.
     * @returns {string|undefined} The hyperlink or undefined if not set.
     */

    /**
    * Set or clear the hyperlink on the cell.
    * @param {string|Cell|undefined} hyperlink - The hyperlink to set or undefined to clear.
    * @returns {Cell} The cell.
    */

    /**
    * Set the hyperlink options on the cell.
    * @param {{}|Cell} opts - Options or Cell. If opts is a Cell then an internal hyperlink is added.
    * @param {string|Cell} [opts.hyperlink] - The hyperlink to set, can be a Cell or an internal/external string.
    * @param {string} [opts.tooltip] - Additional text to help the user understand more about the hyperlink.
    * @param {string} [opts.email] - Email address, ignored if opts.hyperlink is set.
    * @param {string} [opts.emailSubject] - Email subject, ignored if opts.hyperlink is set.
    * @returns {Cell} The cell.
    */

  }, {
    key: "hyperlink",
    value: function hyperlink() {
      var _this3 = this;

      return new ArgHandler('Cell.hyperlink').case(function () {
        return _this3.sheet().hyperlink(_this3.address());
      }).case('string', function (hyperlink) {
        _this3.sheet().hyperlink(_this3.address(), hyperlink);

        return _this3;
      }).case(['object'], function (opts) {
        _this3.sheet().hyperlink(_this3.address(), opts);

        return _this3;
      }).handle(arguments);
    }
    /**
     * Gets the data validation object attached to the cell.
     * @returns {object|undefined} The data validation or undefined if not set.
     */

    /**
    * Set or clear the data validation object of the cell.
    * @param {object|undefined} dataValidation - Object or null to clear.
    * @returns {Cell} The cell.
    */

  }, {
    key: "dataValidation",
    value: function dataValidation() {
      var _this4 = this;

      return new ArgHandler('Cell.dataValidation').case(function () {
        return _this4.sheet().dataValidation(_this4.address());
      }).case('boolean', function (obj) {
        return _this4.sheet().dataValidation(_this4.address(), obj);
      }).case('*', function (obj) {
        _this4.sheet().dataValidation(_this4.address(), obj);

        return _this4;
      }).handle(arguments);
    }
    /**
     * Callback used by tap.
     * @callback Cell~tapCallback
     * @param {Cell} cell - The cell
     * @returns {undefined}
     */

    /**
    * Invoke a callback on the cell and return the cell. Useful for method chaining.
    * @param {Cell~tapCallback} callback - The callback function.
    * @returns {Cell} The cell.
    */

  }, {
    key: "tap",
    value: function tap(callback) {
      callback(this);
      return this;
    }
    /**
     * Callback used by thru.
     * @callback Cell~thruCallback
     * @param {Cell} cell - The cell
     * @returns {*} The value to return from thru.
     */

    /**
    * Invoke a callback on the cell and return the value provided by the callback. Useful for method chaining.
    * @param {Cell~thruCallback} callback - The callback function.
    * @returns {*} The return value of the callback.
    */

  }, {
    key: "thru",
    value: function thru(callback) {
      return callback(this);
    }
    /**
     * Create a range from this cell and another.
     * @param {Cell|string} cell - The other cell or cell address to range to.
     * @returns {Range} The range.
     */

  }, {
    key: "rangeTo",
    value: function rangeTo(cell) {
      return this.sheet().range(this, cell);
    }
    /**
     * Returns a cell with a relative position given the offsets provided.
     * @param {number} rowOffset - The row offset (0 for the current row).
     * @param {number} columnOffset - The column offset (0 for the current column).
     * @returns {Cell} The relative cell.
     */

  }, {
    key: "relativeCell",
    value: function relativeCell(rowOffset, columnOffset) {
      var row = rowOffset + this.rowNumber();
      var column = columnOffset + this.columnNumber();
      return this.sheet().cell(row, column);
    }
    /**
     * Gets the parent row of the cell.
     * @returns {Row} The parent row.
     */

  }, {
    key: "row",
    value: function row() {
      return this._row;
    }
    /**
     * Gets the row number of the cell (1-based).
     * @returns {number} The row number.
     */

  }, {
    key: "rowNumber",
    value: function rowNumber() {
      return this.row().rowNumber();
    }
    /**
     * Gets the parent sheet.
     * @returns {Sheet} The parent sheet.
     */

  }, {
    key: "sheet",
    value: function sheet() {
      return this.row().sheet();
    }
    /**
     * Gets an individual style.
     * @param {string} name - The name of the style.
     * @returns {*} The style.
     */

    /**
    * Gets multiple styles.
    * @param {Array.<string>} names - The names of the style.
    * @returns {object.<string, *>} Object whose keys are the style names and values are the styles.
    */

    /**
    * Sets an individual style.
    * @param {string} name - The name of the style.
    * @param {*} value - The value to set.
    * @returns {Cell} The cell.
    */

    /**
    * Sets the styles in the range starting with the cell.
    * @param {string} name - The name of the style.
    * @param {Array.<Array.<*>>} - 2D array of values to set.
    * @returns {Range} The range that was set.
    */

    /**
    * Sets multiple styles.
    * @param {object.<string, *>} styles - Object whose keys are the style names and values are the styles to set.
    * @returns {Cell} The cell.
    */

    /**
    * Sets to a specific style
    * @param {Style} style - Style object given from stylesheet.createStyle
    * @returns {Cell} The cell.
    */

  }, {
    key: "style",
    value: function style() {
      var _this5 = this;

      if (!this._style && !(arguments[0] instanceof Style)) {
        this._style = this.workbook().styleSheet().createStyle(this._styleId);
      }

      return new ArgHandler("Cell.style").case('string', function (name) {
        // Get single value
        return _this5._style.style(name);
      }).case('array', function (names) {
        // Get list of values
        var values = {};
        names.forEach(function (name) {
          values[name] = _this5.style(name);
        });
        return values;
      }).case(["string", "array"], function (name, values) {
        var numRows = values.length;
        var numCols = values[0].length;

        var range = _this5.rangeTo(_this5.relativeCell(numRows - 1, numCols - 1));

        return range.style(name, values);
      }).case(['string', '*'], function (name, value) {
        // Set a single value for all cells to a single value
        _this5._style.style(name, value);

        return _this5;
      }).case('object', function (nameValues) {
        // Object of key value pairs to set
        for (var name in nameValues) {
          if (!nameValues.hasOwnProperty(name)) continue;
          var value = nameValues[name];

          _this5.style(name, value);
        }

        return _this5;
      }).case('Style', function (style) {
        _this5._style = style;
        _this5._styleId = style.id();
        return _this5;
      }).handle(arguments);
    }
    /**
     * Gets the value of the cell.
     * @returns {string|boolean|number|Date|RichText|undefined} The value of the cell.
     */

    /**
    * Sets the value of the cell.
    * @param {string|boolean|number|null|undefined|RichText} value - The value to set.
    * @returns {Cell} The cell.
    */

    /**
    * Sets the values in the range starting with the cell.
    * @param {Array.<Array.<string|boolean|number|null|undefined>>} - 2D array of values to set.
    * @returns {Range} The range that was set.
    */

  }, {
    key: "value",
    value: function value() {
      var _this6 = this;

      return new ArgHandler('Cell.value').case(function () {
        if (_this6._value instanceof RichText) {
          return _this6._value.getInstanceWithCellRef(_this6);
        }

        return _this6._value;
      }).case("array", function (values) {
        var numRows = values.length;
        var numCols = values[0].length;

        var range = _this6.rangeTo(_this6.relativeCell(numRows - 1, numCols - 1));

        return range.value(values);
      }).case('*', function (value) {
        _this6.clear();

        if (value instanceof RichText) {
          _this6._value = value.copy(_this6);
        } else {
          _this6._value = value;
        }

        return _this6;
      }).handle(arguments);
    }
    /**
     * Gets the parent workbook.
     * @returns {Workbook} The parent workbook.
     */

  }, {
    key: "workbook",
    value: function workbook() {
      return this.row().workbook();
    }
    /**
     * Append horizontal page break after the cell.
     * @returns {Cell} the cell.
     */

  }, {
    key: "addHorizontalPageBreak",
    value: function addHorizontalPageBreak() {
      this.row().addPageBreak();
      return this;
    }
    /* INTERNAL */

    /**
     * Gets the formula if a shared formula ref cell.
     * @returns {string|undefined} The formula.
     * @ignore
     */

  }, {
    key: "getSharedRefFormula",
    value: function getSharedRefFormula() {
      return this._formulaType === "shared" ? this._formulaRef && this._formula : undefined;
    }
    /**
     * Check if this cell uses a given shared a formula ID.
     * @param {number} id - The shared formula ID.
     * @returns {boolean} A flag indicating if shared.
     * @ignore
     */

  }, {
    key: "sharesFormula",
    value: function sharesFormula(id) {
      return this._formulaType === "shared" && this._sharedFormulaId === id;
    }
    /**
     * Set a shared formula on the cell.
     * @param {number} id - The shared formula index.
     * @param {string} [formula] - The formula (if the reference cell).
     * @param {string} [sharedRef] - The address of the shared range (if the reference cell).
     * @returns {undefined}
     * @ignore
     */

  }, {
    key: "setSharedFormula",
    value: function setSharedFormula(id, formula, sharedRef) {
      this.clear();
      this._formulaType = "shared";
      this._sharedFormulaId = id;
      this._formula = formula;
      this._formulaRef = sharedRef;
    }
    /**
     * Convert the cell to an XML object.
     * @returns {{}} The XML form.
     * @ignore
     */

  }, {
    key: "toXml",
    value: function toXml() {
      // Create a node.
      var node = {
        name: 'c',
        attributes: this._remainingAttributes || {},
        // Start with any remaining attributes we don't current handle.
        children: []
      }; // Set the address.

      node.attributes.r = this.address();

      if (!_.isNil(this._formulaType)) {
        // Add the formula.
        var fNode = {
          name: 'f',
          attributes: this._remainingFormulaAttributes || {}
        };
        if (this._formulaType !== "normal") fNode.attributes.t = this._formulaType;
        if (!_.isNil(this._formulaRef)) fNode.attributes.ref = this._formulaRef;
        if (!_.isNil(this._sharedFormulaId)) fNode.attributes.si = this._sharedFormulaId;
        if (!_.isNil(this._formula)) fNode.children = [this._formula];
        node.children.push(fNode);
      } else if (!_.isNil(this._value)) {
        // Add the value. Don't emit value if a formula is set as Excel will show this stale value.
        var type, text;

        if (typeof this._value === "string") {
          type = "s";
          text = this.workbook().sharedStrings().getIndexForString(this._value);
        } else if (typeof this._value === "boolean") {
          type = "b";
          text = this._value ? 1 : 0;
        } else if (typeof this._value === "number") {
          text = this._value;
        } else if (this._value instanceof Date) {
          text = dateConverter.dateToNumber(this._value);
        } else if (this._value instanceof RichText || _typeof(this._value) === "object" && this._value.constructor.name === "RichText") {
          // Hack to make Jasmine test work
          type = "s";
          text = this.workbook().sharedStrings().getIndexForString(this._value.toXml());
        }

        if (type) node.attributes.t = type;
        var vNode = {
          name: 'v',
          children: [text]
        };
        node.children.push(vNode);
      } // If the style is set, set the style ID.


      if (!_.isNil(this._style)) {
        node.attributes.s = this._style.id();
      } else if (!_.isNil(this._styleId)) {
        node.attributes.s = this._styleId;
      } // Add any remaining children that we don't currently handle.


      if (this._remainingChildren) {
        node.children = node.children.concat(this._remainingChildren);
      }

      return node;
    }
    /* PRIVATE */

    /**
     * Initialize the cell node.
     * @param {{}|number} nodeOrColumnNumber - The existing node or the column number of a new cell.
     * @param {number} [styleId] - The style ID for the new cell.
     * @returns {undefined}
     * @private
     */

  }, {
    key: "_init",
    value: function _init(nodeOrColumnNumber, styleId) {
      if (_.isObject(nodeOrColumnNumber)) {
        // Parse the existing node.
        this._parseNode(nodeOrColumnNumber);
      } else {
        // This is a new cell.
        this._columnNumber = nodeOrColumnNumber;
        if (!_.isNil(styleId)) this._styleId = styleId;
      }
    }
    /**
     * Parse the existing node.
     * @param {{}} node - The existing node.
     * @returns {undefined}
     * @private
     */

  }, {
    key: "_parseNode",
    value: function _parseNode(node) {
      // Parse the column numbr out of the address.
      var ref = addressConverter.fromAddress(node.attributes.r);
      this._columnNumber = ref.columnNumber; // Store the style ID if present.

      if (!_.isNil(node.attributes.s)) this._styleId = node.attributes.s; // Parse the formula if present..

      var fNode = xmlq.findChild(node, 'f');

      if (fNode) {
        this._formulaType = fNode.attributes.t || "normal";
        this._formulaRef = fNode.attributes.ref;
        this._formula = fNode.children[0];
        this._sharedFormulaId = fNode.attributes.si;

        if (!_.isNil(this._sharedFormulaId)) {
          // Update the sheet's max shared formula ID so we can set future IDs an index beyond this.
          this.sheet().updateMaxSharedFormulaId(this._sharedFormulaId);
        } // Delete the known attributes.


        delete fNode.attributes.t;
        delete fNode.attributes.ref;
        delete fNode.attributes.si; // If any unknown attributes are still present, store them for later output.

        if (!_.isEmpty(fNode.attributes)) this._remainingFormulaAttributes = fNode.attributes;
      } // Parse the value.


      var type = node.attributes.t;

      if (type === "s") {
        // String value.
        var vNode = xmlq.findChild(node, 'v');

        if (vNode) {
          var sharedIndex = vNode.children[0];
          this._value = this.workbook().sharedStrings().getStringByIndex(sharedIndex); // rich text

          if (_.isArray(this._value)) {
            this._value = new RichText(this._value);
          }
        } else {
          this._value = '';
        }
      } else if (type === "str") {
        // Simple string value.
        var _vNode = xmlq.findChild(node, 'v');

        this._value = _vNode && _vNode.children[0];
      } else if (type === "inlineStr") {
        // Inline string value: can be simple text or rich text.
        var isNode = xmlq.findChild(node, 'is');

        if (isNode.children[0].name === "t") {
          var tNode = isNode.children[0];
          this._value = tNode.children[0];
        } else {
          this._value = isNode.children;
        }
      } else if (type === "b") {
        // Boolean value.
        this._value = xmlq.findChild(node, 'v').children[0] === 1;
      } else if (type === "e") {
        // Error value.
        var error = xmlq.findChild(node, 'v').children[0];
        this._value = FormulaError.getError(error);
      } else {
        // Number value.
        var _vNode2 = xmlq.findChild(node, 'v');

        this._value = _vNode2 && Number(_vNode2.children[0]);
      } // Delete known attributes.


      delete node.attributes.r;
      delete node.attributes.s;
      delete node.attributes.t; // If any unknown attributes are still present, store them for later output.

      if (!_.isEmpty(node.attributes)) this._remainingAttributes = node.attributes; // Delete known children.

      xmlq.removeChild(node, 'f');
      xmlq.removeChild(node, 'v');
      xmlq.removeChild(node, 'is'); // If any unknown children are still present, store them for later output.

      if (!_.isEmpty(node.children)) this._remainingChildren = node.children;
    }
  }]);

  return Cell;
}();

module.exports = Cell;
/*
<c r="A6" s="1" t="s">
    <v>2</v>
</c>
*/

},{"./ArgHandler":2,"./FormulaError":8,"./RichText":12,"./Style":17,"./addressConverter":23,"./dateConverter":26,"./regexify":28,"./xmlq":29,"lodash":170}],4:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ArgHandler = require("./ArgHandler");

var addressConverter = require('./addressConverter'); // Default column width.


var defaultColumnWidth = 9.140625;
/**
 * A column.
 */

var Column = /*#__PURE__*/function () {
  // /**
  //  * Creates a new Column.
  //  * @param {Sheet} sheet - The parent sheet.
  //  * @param {{}} node - The column node.
  //  * @constructor
  //  * @ignore
  //  * @private
  //  */
  function Column(sheet, node) {
    _classCallCheck(this, Column);

    this._sheet = sheet;
    this._node = node;
  }
  /* PUBLIC */

  /**
   * Get the address of the column.
   * @param {{}} [opts] - Options
   * @param {boolean} [opts.includeSheetName] - Include the sheet name in the address.
   * @param {boolean} [opts.anchored] - Anchor the address.
   * @returns {string} The address
   */


  _createClass(Column, [{
    key: "address",
    value: function address(opts) {
      return addressConverter.toAddress({
        type: 'column',
        columnName: this.columnName(),
        sheetName: opts && opts.includeSheetName && this.sheet().name(),
        columnAnchored: opts && opts.anchored
      });
    }
    /**
     * Get a cell within the column.
     * @param {number} rowNumber - The row number.
     * @returns {Cell} The cell in the column with the given row number.
     */

  }, {
    key: "cell",
    value: function cell(rowNumber) {
      return this.sheet().cell(rowNumber, this.columnNumber());
    }
    /**
     * Get the name of the column.
     * @returns {string} The column name.
     */

  }, {
    key: "columnName",
    value: function columnName() {
      return addressConverter.columnNumberToName(this.columnNumber());
    }
    /**
     * Get the number of the column.
     * @returns {number} The column number.
     */

  }, {
    key: "columnNumber",
    value: function columnNumber() {
      return this._node.attributes.min;
    }
    /**
     * Gets a value indicating whether the column is hidden.
     * @returns {boolean} A flag indicating whether the column is hidden.
     */

    /**
    * Sets whether the column is hidden.
    * @param {boolean} hidden - A flag indicating whether to hide the column.
    * @returns {Column} The column.
    */

  }, {
    key: "hidden",
    value: function hidden() {
      var _this = this;

      return new ArgHandler("Column.hidden").case(function () {
        return _this._node.attributes.hidden === 1;
      }).case('boolean', function (hidden) {
        if (hidden) _this._node.attributes.hidden = 1;else delete _this._node.attributes.hidden;
        return _this;
      }).handle(arguments);
    }
    /**
     * Get the parent sheet.
     * @returns {Sheet} The parent sheet.
     */

  }, {
    key: "sheet",
    value: function sheet() {
      return this._sheet;
    }
    /**
     * Gets an individual style.
     * @param {string} name - The name of the style.
     * @returns {*} The style.
     */

    /**
    * Gets multiple styles.
    * @param {Array.<string>} names - The names of the style.
    * @returns {object.<string, *>} Object whose keys are the style names and values are the styles.
    */

    /**
    * Sets an individual style.
    * @param {string} name - The name of the style.
    * @param {*} value - The value to set.
    * @returns {Cell} The cell.
    */

    /**
    * Sets multiple styles.
    * @param {object.<string, *>} styles - Object whose keys are the style names and values are the styles to set.
    * @returns {Cell} The cell.
    */

    /**
    * Sets to a specific style
    * @param {Style} style - Style object given from stylesheet.createStyle
    * @returns {Cell} The cell.
    */

  }, {
    key: "style",
    value: function style() {
      var _this2 = this;

      return new ArgHandler("Column.style").case('string', function (name) {
        // Get single value
        _this2._createStyleIfNeeded();

        return _this2._style.style(name);
      }).case('array', function (names) {
        // Get list of values
        var values = {};
        names.forEach(function (name) {
          values[name] = _this2.style(name);
        });
        return values;
      }).case(['string', '*'], function (name, value) {
        // If a row node is already defined that intersects with this column and that row has a style set, we
        // need to make sure that a cell node exists at the intersection so we can style it appropriately.
        // Fetching the cell will force a new cell node to be created with a style matching the column. So we
        // will fetch and style the cell at each row that intersects this column if it is already present or it
        // has a style defined.
        _this2.sheet().forEachExistingRow(function (row) {
          if (row.hasStyle() || row.hasCell(_this2.columnNumber())) {
            row.cell(_this2.columnNumber()).style(name, value);
          }
        }); // Set a single value for all cells to a single value


        _this2._createStyleIfNeeded();

        _this2._style.style(name, value);

        return _this2;
      }).case('object', function (nameValues) {
        // Object of key value pairs to set
        for (var name in nameValues) {
          if (!nameValues.hasOwnProperty(name)) continue;
          var value = nameValues[name];

          _this2.style(name, value);
        }

        return _this2;
      }).case('Style', function (style) {
        // See Large Comment Above
        _this2.sheet().forEachExistingRow(function (row) {
          if (row.hasStyle() || row.hasCell(_this2.columnNumber())) {
            row.cell(_this2.columnNumber()).style(style);
          }
        });

        _this2._style = style;
        _this2._node.attributes.style = style.id();
        return _this2;
      }).handle(arguments);
    }
    /**
     * Gets the width.
     * @returns {undefined|number} The width (or undefined).
     */

    /**
    * Sets the width.
    * @param {number} width - The width of the column.
    * @returns {Column} The column.
    */

  }, {
    key: "width",
    value: function width(_width) {
      var _this3 = this;

      return new ArgHandler("Column.width").case(function () {
        return _this3._node.attributes.customWidth ? _this3._node.attributes.width : undefined;
      }).case('number', function (width) {
        _this3._node.attributes.width = width;
        _this3._node.attributes.customWidth = 1;
        return _this3;
      }).case('nil', function () {
        delete _this3._node.attributes.width;
        delete _this3._node.attributes.customWidth;
        return _this3;
      }).handle(arguments);
    }
    /**
     * Get the parent workbook.
     * @returns {Workbook} The parent workbook.
     */

  }, {
    key: "workbook",
    value: function workbook() {
      return this.sheet().workbook();
    }
    /**
     * Append vertical page break after the column.
     * @returns {Column} the column.
     */

  }, {
    key: "addPageBreak",
    value: function addPageBreak() {
      this.sheet().verticalPageBreaks().add(this.columnNumber());
      return this;
    }
    /* INTERNAL */

    /**
     * Convert the column to an XML object.
     * @returns {{}} The XML form.
     * @ignore
     */

  }, {
    key: "toXml",
    value: function toXml() {
      return this._node;
    }
    /* PRIVATE */

    /**
     * Create a style for this column if it doesn't already exist.
     * @returns {undefined}
     * @private
     */

  }, {
    key: "_createStyleIfNeeded",
    value: function _createStyleIfNeeded() {
      if (!this._style) {
        var styleId = this._node.attributes.style;
        this._style = this.workbook().styleSheet().createStyle(styleId);
        this._node.attributes.style = this._style.id();
        if (!this.width()) this.width(defaultColumnWidth);
      }
    }
  }]);

  return Column;
}();

module.exports = Column;

},{"./ArgHandler":2,"./addressConverter":23}],5:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _ = require("lodash");
/**
 * A content type collection.
 * @ignore
 */


var ContentTypes = /*#__PURE__*/function () {
  /**
   * Creates a new instance of ContentTypes
   * @param {{}} node - The node.
   */
  function ContentTypes(node) {
    _classCallCheck(this, ContentTypes);

    this._node = node;
  }
  /**
   * Add a new content type.
   * @param {string} partName - The part name.
   * @param {string} contentType - The content type.
   * @returns {{}} The new content type.
   */


  _createClass(ContentTypes, [{
    key: "add",
    value: function add(partName, contentType) {
      var node = {
        name: "Override",
        attributes: {
          PartName: partName,
          ContentType: contentType
        }
      };

      this._node.children.push(node);

      return node;
    }
    /**
     * Find a content type by part name.
     * @param {string} partName - The part name.
     * @returns {{}|undefined} The matching content type or undefined if not found.
     */

  }, {
    key: "findByPartName",
    value: function findByPartName(partName) {
      return _.find(this._node.children, function (node) {
        return node.attributes.PartName === partName;
      });
    }
    /**
     * Convert the collection to an XML object.
     * @returns {{}} The XML.
     */

  }, {
    key: "toXml",
    value: function toXml() {
      return this._node;
    }
  }]);

  return ContentTypes;
}();

module.exports = ContentTypes;
/*
[Content_Types].xml

<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">
    <Default Extension="bin" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings"/>
    <Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>
    <Default Extension="xml" ContentType="application/xml"/>
    <Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/>
    <Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>
    <Override PartName="/xl/theme/theme1.xml" ContentType="application/vnd.openxmlformats-officedocument.theme+xml"/>
    <Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>
    <Override PartName="/xl/sharedStrings.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml"/>
    <Override PartName="/xl/calcChain.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml"/>
    <Override PartName="/docProps/core.xml" ContentType="application/vnd.openxmlformats-package.core-properties+xml"/>
    <Override PartName="/docProps/app.xml" ContentType="application/vnd.openxmlformats-officedocument.extended-properties+xml"/>
</Types>
*/

},{"lodash":170}],6:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var allowedProperties = {
  title: "dc:title",
  subject: "dc:subject",
  author: "dc:creator",
  creator: "dc:creator",
  description: "dc:description",
  keywords: "cp:keywords",
  category: "cp:category"
};
/**
 * Core properties
 * @ignore
 */

var CoreProperties = /*#__PURE__*/function () {
  function CoreProperties(node) {
    _classCallCheck(this, CoreProperties);

    this._node = node;
    this._properties = {};
  }
  /**
   * Sets a specific property.
   * @param {string} name - The name of the property.
   * @param {*} value - The value of the property.
   * @returns {CoreProperties} CoreProperties.
   */


  _createClass(CoreProperties, [{
    key: "set",
    value: function set(name, value) {
      var key = name.toLowerCase();

      if (typeof allowedProperties[key] === "undefined") {
        throw new Error("Unknown property name: \"".concat(name, "\""));
      }

      this._properties[key] = value;
      return this;
    }
    /**
     * Get a specific property.
     * @param {string} name - The name of the property.
     * @returns {*} The property value.
     */

  }, {
    key: "get",
    value: function get(name) {
      var key = name.toLowerCase();

      if (typeof allowedProperties[key] === "undefined") {
        throw new Error("Unknown property name: \"".concat(name, "\""));
      }

      return this._properties[key];
    }
    /**
     * Convert the collection to an XML object.
     * @returns {{}} The XML.
     */

  }, {
    key: "toXml",
    value: function toXml() {
      for (var key in this._properties) {
        if (!this._properties.hasOwnProperty(key)) continue;

        this._node.children.push({
          name: allowedProperties[key],
          children: [this._properties[key]]
        });
      }

      return this._node;
    }
  }]);

  return CoreProperties;
}();

module.exports = CoreProperties;
/*
docProps/core.xml

<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<cp:coreProperties xmlns:cp="http://schemas.openxmlformats.org/package/2006/metadata/core-properties" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:dcterms="http://purl.org/dc/terms/" xmlns:dcmitype="http://purl.org/dc/dcmitype/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
<dc:title>Title</dc:title>
<dc:subject>Subject</dc:subject>
<dc:creator>Creator</dc:creator>
<cp:keywords>Keywords</cp:keywords>
<dc:description>Description</dc:description>
<cp:category>Category</cp:category>
</cp:coreProperties>
 */

},{}],7:[function(require,module,exports){
(function (Buffer){
"use strict";
/**
 * OOXML uses the CFB file format with Agile Encryption. The details of the encryption are here:
 * https://msdn.microsoft.com/en-us/library/dd950165(v=office.12).aspx
 *
 * Helpful guidance also take from this Github project:
 * https://github.com/nolze/ms-offcrypto-tool
 */

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _ = require("lodash");

var cfb = require("cfb");

var crypto = require("crypto");

var externals = require("./externals");

var XmlParser = require("./XmlParser");

var XmlBuilder = require("./XmlBuilder");

var xmlq = require("./xmlq");

var ENCRYPTION_INFO_PREFIX = Buffer.from([0x04, 0x00, 0x04, 0x00, 0x40, 0x00, 0x00, 0x00]); // First 4 bytes are the version number, second 4 bytes are reserved.

var PACKAGE_ENCRYPTION_CHUNK_SIZE = 4096;
var PACKAGE_OFFSET = 8; // First 8 bytes are the size of the stream
// Block keys used for encryption

var BLOCK_KEYS = {
  dataIntegrity: {
    hmacKey: Buffer.from([0x5f, 0xb2, 0xad, 0x01, 0x0c, 0xb9, 0xe1, 0xf6]),
    hmacValue: Buffer.from([0xa0, 0x67, 0x7f, 0x02, 0xb2, 0x2c, 0x84, 0x33])
  },
  key: Buffer.from([0x14, 0x6e, 0x0b, 0xe7, 0xab, 0xac, 0xd0, 0xd6]),
  verifierHash: {
    input: Buffer.from([0xfe, 0xa7, 0xd2, 0x76, 0x3b, 0x4b, 0x9e, 0x79]),
    value: Buffer.from([0xd7, 0xaa, 0x0f, 0x6d, 0x30, 0x61, 0x34, 0x4e])
  }
};
/**
 * Encrypts/decrypts XLSXs.
 * @private
 */

var Encryptor = /*#__PURE__*/function () {
  function Encryptor() {
    _classCallCheck(this, Encryptor);
  }

  _createClass(Encryptor, [{
    key: "encrypt",

    /**
     * Encrypt the data with the password.
     * @param {Buffer} data - The data to encrypt
     * @param {string} password - The password
     * @returns {Buffer} The encrypted data
     */
    value: function encrypt(data, password) {
      // Generate a random key to use to encrypt the document. Excel uses 32 bytes. We'll use the password to encrypt this key.
      // N.B. The number of bits needs to correspond to an algorithm available in crypto (e.g. aes-256-cbc).
      var packageKey = crypto.randomBytes(32); // Create the encryption info. We'll use this for all of the encryption operations and for building the encryption info XML entry

      var encryptionInfo = {
        package: {
          // Info on the encryption of the package.
          cipherAlgorithm: 'AES',
          // Cipher algorithm to use. Excel uses AES.
          cipherChaining: 'ChainingModeCBC',
          // Cipher chaining mode to use. Excel uses CBC.
          saltValue: crypto.randomBytes(16),
          // Random value to use as encryption salt. Excel uses 16 bytes.
          hashAlgorithm: 'SHA512',
          // Hash algorithm to use. Excel uses SHA512.
          hashSize: 64,
          // The size of the hash in bytes. SHA512 results in 64-byte hashes
          blockSize: 16,
          // The number of bytes used to encrypt one block of data. It MUST be at least 2, no greater than 4096, and a multiple of 2. Excel uses 16
          keyBits: packageKey.length * 8 // The number of bits in the package key.

        },
        key: {
          // Info on the encryption of the package key.
          cipherAlgorithm: 'AES',
          // Cipher algorithm to use. Excel uses AES.
          cipherChaining: 'ChainingModeCBC',
          // Cipher chaining mode to use. Excel uses CBC.
          saltValue: crypto.randomBytes(16),
          // Random value to use as encryption salt. Excel uses 16 bytes.
          hashAlgorithm: 'SHA512',
          // Hash algorithm to use. Excel uses SHA512.
          hashSize: 64,
          // The size of the hash in bytes. SHA512 results in 64-byte hashes
          blockSize: 16,
          // The number of bytes used to encrypt one block of data. It MUST be at least 2, no greater than 4096, and a multiple of 2. Excel uses 16
          spinCount: 100000,
          // The number of times to iterate on a hash of a password. It MUST NOT be greater than 10,000,000. Excel uses 100,000.
          keyBits: 256 // The length of the key to generate from the password. Must be a multiple of 8. Excel uses 256.

        }
      };
      /* Package Encryption */
      // Encrypt package using the package key.

      var encryptedPackage = this._cryptPackage(true, encryptionInfo.package.cipherAlgorithm, encryptionInfo.package.cipherChaining, encryptionInfo.package.hashAlgorithm, encryptionInfo.package.blockSize, encryptionInfo.package.saltValue, packageKey, data);
      /* Data Integrity */
      // Create the data integrity fields used by clients for integrity checks.
      // First generate a random array of bytes to use in HMAC. The docs say to use the same length as the key salt, but Excel seems to use 64.


      var hmacKey = crypto.randomBytes(64); // Then create an initialization vector using the package encryption info and the appropriate block key.

      var hmacKeyIV = this._createIV(encryptionInfo.package.hashAlgorithm, encryptionInfo.package.saltValue, encryptionInfo.package.blockSize, BLOCK_KEYS.dataIntegrity.hmacKey); // Use the package key and the IV to encrypt the HMAC key


      var encryptedHmacKey = this._crypt(true, encryptionInfo.package.cipherAlgorithm, encryptionInfo.package.cipherChaining, packageKey, hmacKeyIV, hmacKey); // Now create the HMAC


      var hmacValue = this._hmac(encryptionInfo.package.hashAlgorithm, hmacKey, encryptedPackage); // Next generate an initialization vector for encrypting the resulting HMAC value.


      var hmacValueIV = this._createIV(encryptionInfo.package.hashAlgorithm, encryptionInfo.package.saltValue, encryptionInfo.package.blockSize, BLOCK_KEYS.dataIntegrity.hmacValue); // Now encrypt the value


      var encryptedHmacValue = this._crypt(true, encryptionInfo.package.cipherAlgorithm, encryptionInfo.package.cipherChaining, packageKey, hmacValueIV, hmacValue); // Put the encrypted key and value on the encryption info


      encryptionInfo.dataIntegrity = {
        encryptedHmacKey: encryptedHmacKey,
        encryptedHmacValue: encryptedHmacValue
      };
      /* Key Encryption */
      // Convert the password to an encryption key

      var key = this._convertPasswordToKey(password, encryptionInfo.key.hashAlgorithm, encryptionInfo.key.saltValue, encryptionInfo.key.spinCount, encryptionInfo.key.keyBits, BLOCK_KEYS.key); // Encrypt the package key with the


      encryptionInfo.key.encryptedKeyValue = this._crypt(true, encryptionInfo.key.cipherAlgorithm, encryptionInfo.key.cipherChaining, key, encryptionInfo.key.saltValue, packageKey);
      /* Verifier hash */
      // Create a random byte array for hashing

      var verifierHashInput = crypto.randomBytes(16); // Create an encryption key from the password for the input

      var verifierHashInputKey = this._convertPasswordToKey(password, encryptionInfo.key.hashAlgorithm, encryptionInfo.key.saltValue, encryptionInfo.key.spinCount, encryptionInfo.key.keyBits, BLOCK_KEYS.verifierHash.input); // Use the key to encrypt the verifier input


      encryptionInfo.key.encryptedVerifierHashInput = this._crypt(true, encryptionInfo.key.cipherAlgorithm, encryptionInfo.key.cipherChaining, verifierHashInputKey, encryptionInfo.key.saltValue, verifierHashInput); // Create a hash of the input

      var verifierHashValue = this._hash(encryptionInfo.key.hashAlgorithm, verifierHashInput); // Create an encryption key from the password for the hash


      var verifierHashValueKey = this._convertPasswordToKey(password, encryptionInfo.key.hashAlgorithm, encryptionInfo.key.saltValue, encryptionInfo.key.spinCount, encryptionInfo.key.keyBits, BLOCK_KEYS.verifierHash.value); // Use the key to encrypt the hash value


      encryptionInfo.key.encryptedVerifierHashValue = this._crypt(true, encryptionInfo.key.cipherAlgorithm, encryptionInfo.key.cipherChaining, verifierHashValueKey, encryptionInfo.key.saltValue, verifierHashValue); // Build the encryption info buffer

      var encryptionInfoBuffer = this._buildEncryptionInfo(encryptionInfo); // Create a new CFB


      var output = cfb.utils.cfb_new(); // Add the encryption info and encrypted package

      cfb.utils.cfb_add(output, "EncryptionInfo", encryptionInfoBuffer);
      cfb.utils.cfb_add(output, "EncryptedPackage", encryptedPackage); // Delete the SheetJS entry that is added at initialization

      cfb.utils.cfb_del(output, "\x01Sh33tJ5"); // Write to a buffer and return

      output = cfb.write(output); // The cfb library writes to a Uint8array in the browser. Convert to a Buffer.

      if (!Buffer.isBuffer(output)) output = Buffer.from(output);
      return output;
    }
    /**
     * Decrypt the data with the given password
     * @param {Buffer} data - The data to decrypt
     * @param {string} password - The password
     * @returns {Promise.<Buffer>} The decrypted data
     */

  }, {
    key: "decryptAsync",
    value: function decryptAsync(data, password) {
      var _this = this;

      // Parse the CFB input and pull out the encryption info and encrypted package entries.
      var parsed = cfb.parse(data);

      var encryptionInfoBuffer = _.find(parsed.FileIndex, {
        name: "EncryptionInfo"
      }).content;

      var encryptedPackageBuffer = _.find(parsed.FileIndex, {
        name: "EncryptedPackage"
      }).content; // In the browser the CFB content is an array. Convert to a Buffer.


      if (!Buffer.isBuffer(encryptionInfoBuffer)) encryptionInfoBuffer = Buffer.from(encryptionInfoBuffer);
      if (!Buffer.isBuffer(encryptedPackageBuffer)) encryptedPackageBuffer = Buffer.from(encryptedPackageBuffer);
      return externals.Promise.resolve().then(function () {
        return _this._parseEncryptionInfoAsync(encryptionInfoBuffer);
      }) // Parse the encryption info XML into an object
      .then(function (encryptionInfo) {
        // Convert the password into an encryption key
        var key = _this._convertPasswordToKey(password, encryptionInfo.key.hashAlgorithm, encryptionInfo.key.saltValue, encryptionInfo.key.spinCount, encryptionInfo.key.keyBits, BLOCK_KEYS.key); // Use the key to decrypt the package key


        var packageKey = _this._crypt(false, encryptionInfo.key.cipherAlgorithm, encryptionInfo.key.cipherChaining, key, encryptionInfo.key.saltValue, encryptionInfo.key.encryptedKeyValue); // Use the package key to decrypt the package


        return _this._cryptPackage(false, encryptionInfo.package.cipherAlgorithm, encryptionInfo.package.cipherChaining, encryptionInfo.package.hashAlgorithm, encryptionInfo.package.blockSize, encryptionInfo.package.saltValue, packageKey, encryptedPackageBuffer);
      });
    }
    /**
     * Build the encryption info XML/buffer
     * @param {{}} encryptionInfo - The encryption info object
     * @returns {Buffer} The buffer
     * @private
     */

  }, {
    key: "_buildEncryptionInfo",
    value: function _buildEncryptionInfo(encryptionInfo) {
      // Map the object into the appropriate XML structure. Buffers are encoded in base 64.
      var encryptionInfoNode = {
        name: "encryption",
        attributes: {
          xmlns: "http://schemas.microsoft.com/office/2006/encryption",
          'xmlns:p': "http://schemas.microsoft.com/office/2006/keyEncryptor/password",
          'xmlns:c': "http://schemas.microsoft.com/office/2006/keyEncryptor/certificate"
        },
        children: [{
          name: "keyData",
          attributes: {
            saltSize: encryptionInfo.package.saltValue.length,
            blockSize: encryptionInfo.package.blockSize,
            keyBits: encryptionInfo.package.keyBits,
            hashSize: encryptionInfo.package.hashSize,
            cipherAlgorithm: encryptionInfo.package.cipherAlgorithm,
            cipherChaining: encryptionInfo.package.cipherChaining,
            hashAlgorithm: encryptionInfo.package.hashAlgorithm,
            saltValue: encryptionInfo.package.saltValue.toString("base64")
          }
        }, {
          name: "dataIntegrity",
          attributes: {
            encryptedHmacKey: encryptionInfo.dataIntegrity.encryptedHmacKey.toString("base64"),
            encryptedHmacValue: encryptionInfo.dataIntegrity.encryptedHmacValue.toString("base64")
          }
        }, {
          name: "keyEncryptors",
          children: [{
            name: "keyEncryptor",
            attributes: {
              uri: "http://schemas.microsoft.com/office/2006/keyEncryptor/password"
            },
            children: [{
              name: "p:encryptedKey",
              attributes: {
                spinCount: encryptionInfo.key.spinCount,
                saltSize: encryptionInfo.key.saltValue.length,
                blockSize: encryptionInfo.key.blockSize,
                keyBits: encryptionInfo.key.keyBits,
                hashSize: encryptionInfo.key.hashSize,
                cipherAlgorithm: encryptionInfo.key.cipherAlgorithm,
                cipherChaining: encryptionInfo.key.cipherChaining,
                hashAlgorithm: encryptionInfo.key.hashAlgorithm,
                saltValue: encryptionInfo.key.saltValue.toString("base64"),
                encryptedVerifierHashInput: encryptionInfo.key.encryptedVerifierHashInput.toString("base64"),
                encryptedVerifierHashValue: encryptionInfo.key.encryptedVerifierHashValue.toString("base64"),
                encryptedKeyValue: encryptionInfo.key.encryptedKeyValue.toString("base64")
              }
            }]
          }]
        }]
      }; // Convert to an XML string

      var xmlBuilder = new XmlBuilder();
      var encryptionInfoXml = xmlBuilder.build(encryptionInfoNode); // Convert to a buffer and prefix with the appropriate bytes

      return Buffer.concat([ENCRYPTION_INFO_PREFIX, Buffer.from(encryptionInfoXml, "utf8")]);
    }
    /**
     * Parse the encryption info from the XML/buffer
     * @param {Buffer} buffer - The buffer
     * @returns {Promise.<{}>} The parsed encryption info object
     * @private
     */

  }, {
    key: "_parseEncryptionInfoAsync",
    value: function _parseEncryptionInfoAsync(buffer) {
      // Pull off the prefix and convert to string
      var xml = buffer.slice(ENCRYPTION_INFO_PREFIX.length).toString("utf8"); // Parse the XML

      var xmlParser = new XmlParser();
      return xmlParser.parseAsync(xml).then(function (doc) {
        // Pull out the relevant values for decryption and return
        var keyDataNode = xmlq.findChild(doc, "keyData");
        var keyEncryptorsNode = xmlq.findChild(doc, "keyEncryptors");
        var keyEncryptorNode = xmlq.findChild(keyEncryptorsNode, "keyEncryptor");
        var encryptedKeyNode = xmlq.findChild(keyEncryptorNode, "p:encryptedKey");
        return {
          package: {
            cipherAlgorithm: keyDataNode.attributes.cipherAlgorithm,
            cipherChaining: keyDataNode.attributes.cipherChaining,
            saltValue: Buffer.from(keyDataNode.attributes.saltValue, "base64"),
            hashAlgorithm: keyDataNode.attributes.hashAlgorithm,
            blockSize: keyDataNode.attributes.blockSize
          },
          key: {
            encryptedKeyValue: Buffer.from(encryptedKeyNode.attributes.encryptedKeyValue, "base64"),
            cipherAlgorithm: encryptedKeyNode.attributes.cipherAlgorithm,
            cipherChaining: encryptedKeyNode.attributes.cipherChaining,
            saltValue: Buffer.from(encryptedKeyNode.attributes.saltValue, "base64"),
            hashAlgorithm: encryptedKeyNode.attributes.hashAlgorithm,
            spinCount: encryptedKeyNode.attributes.spinCount,
            keyBits: encryptedKeyNode.attributes.keyBits
          }
        };
      });
    }
    /**
     * Calculate a hash of the concatenated buffers with the given algorithm.
     * @param {string} algorithm - The hash algorithm.
     * @param {Array.<Buffer>} buffers - The buffers to concat and hash
     * @returns {Buffer} The hash
     * @private
     */

  }, {
    key: "_hash",
    value: function _hash(algorithm) {
      algorithm = algorithm.toLowerCase();
      var hashes = crypto.getHashes();
      if (hashes.indexOf(algorithm) < 0) throw new Error("Hash algorithm '".concat(algorithm, "' not supported!"));
      var hash = crypto.createHash(algorithm);

      for (var _len = arguments.length, buffers = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        buffers[_key - 1] = arguments[_key];
      }

      hash.update(Buffer.concat(buffers));
      return hash.digest();
    }
    /**
     * Calculate an HMAC of the concatenated buffers with the given algorithm and key
     * @param {string} algorithm - The algorithm.
     * @param {string} key - The key
     * @param {Array.<Buffer>} buffers - The buffer to concat and HMAC
     * @returns {Buffer} The HMAC
     * @private
     */

  }, {
    key: "_hmac",
    value: function _hmac(algorithm, key) {
      algorithm = algorithm.toLowerCase();
      var hashes = crypto.getHashes();
      if (hashes.indexOf(algorithm) < 0) throw new Error("HMAC algorithm '".concat(algorithm, "' not supported!"));
      var hmac = crypto.createHmac(algorithm, key);

      for (var _len2 = arguments.length, buffers = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        buffers[_key2 - 2] = arguments[_key2];
      }

      hmac.update(Buffer.concat(buffers));
      return hmac.digest();
    }
    /**
     * Encrypt/decrypt input
     * @param {boolean} encrypt - True to encrypt, false to decrypt
     * @param {string} cipherAlgorithm - The cipher algorithm
     * @param {sring} cipherChaining - The cipher chaining mode
     * @param {Buffer} key - The encryption key
     * @param {Buffer} iv - The initialization vector
     * @param {Buffer} input - The input
     * @returns {Buffer} The output
     * @private
     */

  }, {
    key: "_crypt",
    value: function _crypt(encrypt, cipherAlgorithm, cipherChaining, key, iv, input) {
      var algorithm = "".concat(cipherAlgorithm.toLowerCase(), "-").concat(key.length * 8);
      if (cipherChaining === 'ChainingModeCBC') algorithm += '-cbc';else throw new Error("Unknown cipher chaining: ".concat(cipherChaining));
      var cipher = crypto[encrypt ? 'createCipheriv' : 'createDecipheriv'](algorithm, key, iv);
      cipher.setAutoPadding(false);
      var output = cipher.update(input);
      output = Buffer.concat([output, cipher.final()]);
      return output;
    }
    /**
     * Encrypt/decrypt the package
     * @param {boolean} encrypt - True to encrypt, false to decrypt
     * @param {string} cipherAlgorithm - The cipher algorithm
     * @param {string} cipherChaining - The cipher chaining mode
     * @param {string} hashAlgorithm - The hash algorithm
     * @param {number} blockSize - The IV block size
     * @param {Buffer} saltValue - The salt
     * @param {Buffer} key - The encryption key
     * @param {Buffer} input - The package input
     * @returns {Buffer} The output
     * @private
     */

  }, {
    key: "_cryptPackage",
    value: function _cryptPackage(encrypt, cipherAlgorithm, cipherChaining, hashAlgorithm, blockSize, saltValue, key, input) {
      // The first 8 bytes is supposed to be the length, but it seems like it is really the length - 4..
      var outputChunks = [];
      var offset = encrypt ? 0 : PACKAGE_OFFSET; // The package is encoded in chunks. Encrypt/decrypt each and concat.

      var i = 0,
          start = 0,
          end = 0;

      while (end < input.length) {
        start = end;
        end = start + PACKAGE_ENCRYPTION_CHUNK_SIZE;
        if (end > input.length) end = input.length; // Grab the next chunk

        var inputChunk = input.slice(start + offset, end + offset); // Pad the chunk if it is not an integer multiple of the block size

        var remainder = inputChunk.length % blockSize;
        if (remainder) inputChunk = Buffer.concat([inputChunk, Buffer.alloc(blockSize - remainder)]); // Create the initialization vector

        var iv = this._createIV(hashAlgorithm, saltValue, blockSize, i); // Encrypt/decrypt the chunk and add it to the array


        var outputChunk = this._crypt(encrypt, cipherAlgorithm, cipherChaining, key, iv, inputChunk);

        outputChunks.push(outputChunk);
        i++;
      } // Concat all of the output chunks.


      var output = Buffer.concat(outputChunks);

      if (encrypt) {
        // Put the length of the package in the first 8 bytes
        output = Buffer.concat([this._createUInt32LEBuffer(input.length, PACKAGE_OFFSET), output]);
      } else {
        // Truncate the buffer to the size in the prefix
        var length = input.readUInt32LE(0);
        output = output.slice(0, length);
      }

      return output;
    }
    /**
     * Create a buffer of an integer encoded as a uint32le
     * @param {number} value - The integer to encode
     * @param {number} [bufferSize=4] The output buffer size in bytes
     * @returns {Buffer} The buffer
     * @private
     */

  }, {
    key: "_createUInt32LEBuffer",
    value: function _createUInt32LEBuffer(value) {
      var bufferSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
      var buffer = Buffer.alloc(bufferSize);
      buffer.writeUInt32LE(value, 0);
      return buffer;
    }
    /**
     * Convert a password into an encryption key
     * @param {string} password - The password
     * @param {string} hashAlgorithm - The hash algoritm
     * @param {Buffer} saltValue - The salt value
     * @param {number} spinCount - The spin count
     * @param {number} keyBits - The length of the key in bits
     * @param {Buffer} blockKey - The block key
     * @returns {Buffer} The encryption key
     * @private
     */

  }, {
    key: "_convertPasswordToKey",
    value: function _convertPasswordToKey(password, hashAlgorithm, saltValue, spinCount, keyBits, blockKey) {
      // Password must be in unicode buffer
      var passwordBuffer = Buffer.from(password, 'utf16le'); // Generate the initial hash

      var key = this._hash(hashAlgorithm, saltValue, passwordBuffer); // Now regenerate until spin count


      for (var i = 0; i < spinCount; i++) {
        var iterator = this._createUInt32LEBuffer(i);

        key = this._hash(hashAlgorithm, iterator, key);
      } // Now generate the final hash


      key = this._hash(hashAlgorithm, key, blockKey); // Truncate or pad as needed to get to length of keyBits

      var keyBytes = keyBits / 8;

      if (key.length < keyBytes) {
        var tmp = Buffer.alloc(keyBytes, 0x36);
        key.copy(tmp);
        key = tmp;
      } else if (key.length > keyBytes) {
        key = key.slice(0, keyBytes);
      }

      return key;
    }
    /**
     * Create an initialization vector (IV)
     * @param {string} hashAlgorithm - The hash algorithm
     * @param {Buffer} saltValue - The salt value
     * @param {number} blockSize - The size of the IV
     * @param {Buffer|number} blockKey - The block key or an int to convert to a buffer
     * @returns {Buffer} The IV
     * @private
     */

  }, {
    key: "_createIV",
    value: function _createIV(hashAlgorithm, saltValue, blockSize, blockKey) {
      // Create the block key from the current index
      if (typeof blockKey === "number") blockKey = this._createUInt32LEBuffer(blockKey); // Create the initialization vector by hashing the salt with the block key.
      // Truncate or pad as needed to meet the block size.

      var iv = this._hash(hashAlgorithm, saltValue, blockKey);

      if (iv.length < blockSize) {
        var tmp = Buffer.alloc(blockSize, 0x36);
        iv.copy(tmp);
        iv = tmp;
      } else if (iv.length > blockSize) {
        iv = iv.slice(0, blockSize);
      }

      return iv;
    }
  }]);

  return Encryptor;
}();

module.exports = Encryptor;

}).call(this,require("buffer").Buffer)

},{"./XmlBuilder":21,"./XmlParser":22,"./externals":27,"./xmlq":29,"buffer":77,"cfb":78,"crypto":86,"lodash":170}],8:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _ = require("lodash");
/**
 * A formula error (e.g. #DIV/0!).
 */


var FormulaError = /*#__PURE__*/function () {
  // /**
  //  * Creates a new instance of Formula Error.
  //  * @param {string} error - The error code.
  //  */
  function FormulaError(error) {
    _classCallCheck(this, FormulaError);

    this._error = error;
  }
  /**
   * Get the error code.
   * @returns {string} The error code.
   */


  _createClass(FormulaError, [{
    key: "error",
    value: function error() {
      return this._error;
    }
  }]);

  return FormulaError;
}();
/**
 * \#DIV/0! error.
 * @type {FormulaError}
 */


FormulaError.DIV0 = new FormulaError("#DIV/0!");
/**
 * \#N/A error.
 * @type {FormulaError}
 */

FormulaError.NA = new FormulaError("#N/A");
/**
 * \#NAME? error.
 * @type {FormulaError}
 */

FormulaError.NAME = new FormulaError("#NAME?");
/**
 * \#NULL! error.
 * @type {FormulaError}
 */

FormulaError.NULL = new FormulaError("#NULL!");
/**
 * \#NUM! error.
 * @type {FormulaError}
 */

FormulaError.NUM = new FormulaError("#NUM!");
/**
 * \#REF! error.
 * @type {FormulaError}
 */

FormulaError.REF = new FormulaError("#REF!");
/**
 * \#VALUE! error.
 * @type {FormulaError}
 */

FormulaError.VALUE = new FormulaError("#VALUE!");
/**
 * Get the matching FormulaError object.
 * @param {string} error - The error code.
 * @returns {FormulaError} The matching FormulaError or a new object if no match.
 * @ignore
 */

FormulaError.getError = function (error) {
  return _.find(FormulaError, function (value) {
    return value instanceof FormulaError && value.error() === error;
  }) || new FormulaError(error);
};

module.exports = FormulaError;

},{"lodash":170}],9:[function(require,module,exports){
"use strict";
/**
 * PageBreaks
 */

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PageBreaks = /*#__PURE__*/function () {
  function PageBreaks(node) {
    _classCallCheck(this, PageBreaks);

    this._node = node;
  }
  /**
   * add page-breaks by row/column id
   * @param {number} id - row/column id (rowNumber/colNumber)
   * @return {PageBreaks} the page-breaks
   */


  _createClass(PageBreaks, [{
    key: "add",
    value: function add(id) {
      this._node.children.push({
        name: "brk",
        children: [],
        attributes: {
          id: id,
          max: 16383,
          man: 1
        }
      });

      this._node.attributes.count++;
      this._node.attributes.manualBreakCount++;
      return this;
    }
    /**
     * remove page-breaks by index
     * @param {number} index - index of list
     * @return {PageBreaks} the page-breaks
     */

  }, {
    key: "remove",
    value: function remove(index) {
      var brk = this._node.children[index];

      if (brk) {
        this._node.children.splice(index, 1);

        this._node.attributes.count--;

        if (brk.man) {
          this._node.attributes.manualBreakCount--;
        }
      }

      return this;
    }
    /**
     * get count of the page-breaks
     * @return {number} the page-breaks' count
     */

  }, {
    key: "count",
    get: function get() {
      return this._node.attributes.count;
    }
    /**
     * get list of page-breaks
     * @return {Array} list of the page-breaks
     */

  }, {
    key: "list",
    get: function get() {
      return this._node.children.map(function (brk) {
        return {
          id: brk.id,
          isManual: !!brk.man
        };
      });
    }
  }]);

  return PageBreaks;
}();

module.exports = PageBreaks;

},{}],10:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ArgHandler = require("./ArgHandler");

var addressConverter = require("./addressConverter");
/**
 * A range of cells.
 */


var Range = /*#__PURE__*/function () {
  // /**
  //  * Creates a new instance of Range.
  //  * @param {Cell} startCell - The start cell.
  //  * @param {Cell} endCell - The end cell.
  //  */
  function Range(startCell, endCell) {
    _classCallCheck(this, Range);

    this._startCell = startCell;
    this._endCell = endCell;

    this._findRangeExtent(startCell, endCell);
  }
  /**
   * Get the address of the range.
   * @param {{}} [opts] - Options
   * @param {boolean} [opts.includeSheetName] - Include the sheet name in the address.
   * @param {boolean} [opts.startRowAnchored] - Anchor the start row.
   * @param {boolean} [opts.startColumnAnchored] - Anchor the start column.
   * @param {boolean} [opts.endRowAnchored] - Anchor the end row.
   * @param {boolean} [opts.endColumnAnchored] - Anchor the end column.
   * @param {boolean} [opts.anchored] - Anchor all row and columns.
   * @returns {string} The address.
   */


  _createClass(Range, [{
    key: "address",
    value: function address(opts) {
      return addressConverter.toAddress({
        type: 'range',
        startRowNumber: this.startCell().rowNumber(),
        startRowAnchored: opts && (opts.startRowAnchored || opts.anchored),
        startColumnName: this.startCell().columnName(),
        startColumnAnchored: opts && (opts.startColumnAnchored || opts.anchored),
        endRowNumber: this.endCell().rowNumber(),
        endRowAnchored: opts && (opts.endRowAnchored || opts.anchored),
        endColumnName: this.endCell().columnName(),
        endColumnAnchored: opts && (opts.endColumnAnchored || opts.anchored),
        sheetName: opts && opts.includeSheetName && this.sheet().name()
      });
    }
    /**
     * Gets a cell within the range.
     * @param {number} ri - Row index relative to the top-left corner of the range (0-based).
     * @param {number} ci - Column index relative to the top-left corner of the range (0-based).
     * @returns {Cell} The cell.
     */

  }, {
    key: "cell",
    value: function cell(ri, ci) {
      return this.sheet().cell(this._minRowNumber + ri, this._minColumnNumber + ci);
    }
    /**
     * Sets sheet autoFilter to this range.
     * @returns {Range} This range.
     */

  }, {
    key: "autoFilter",
    value: function autoFilter() {
      this.sheet().autoFilter(this);
      return this;
    }
    /**
     * Get the cells in the range as a 2D array.
     * @returns {Array.<Array.<Cell>>} The cells.
     */

  }, {
    key: "cells",
    value: function cells() {
      return this.map(function (cell) {
        return cell;
      });
    }
    /**
     * Clear the contents of all the cells in the range.
     * @returns {Range} The range.
     */

  }, {
    key: "clear",
    value: function clear() {
      return this.value(undefined);
    }
    /**
     * Get the end cell of the range.
     * @returns {Cell} The end cell.
     */

  }, {
    key: "endCell",
    value: function endCell() {
      return this._endCell;
    }
    /**
     * Callback used by forEach.
     * @callback Range~forEachCallback
     * @param {Cell} cell - The cell.
     * @param {number} ri - The relative row index.
     * @param {number} ci - The relative column index.
     * @param {Range} range - The range.
     * @returns {undefined}
     */

    /**
     * Call a function for each cell in the range. Goes by row then column.
     * @param {Range~forEachCallback} callback - Function called for each cell in the range.
     * @returns {Range} The range.
     */

  }, {
    key: "forEach",
    value: function forEach(callback) {
      for (var ri = 0; ri < this._numRows; ri++) {
        for (var ci = 0; ci < this._numColumns; ci++) {
          callback(this.cell(ri, ci), ri, ci, this);
        }
      }

      return this;
    }
    /**
     * Gets the shared formula in the start cell (assuming it's the source of the shared formula).
     * @returns {string|undefined} The shared formula.
     */

    /**
    * Sets the shared formula in the range. The formula will be translated for each cell.
    * @param {string} formula - The formula to set.
    * @returns {Range} The range.
    */

  }, {
    key: "formula",
    value: function formula() {
      var _this = this;

      return new ArgHandler("Range.formula").case(function () {
        return _this.startCell().getSharedRefFormula();
      }).case('string', function (formula) {
        var sharedFormulaId = _this.sheet().incrementMaxSharedFormulaId();

        _this.forEach(function (cell, ri, ci) {
          if (ri === 0 && ci === 0) {
            cell.setSharedFormula(sharedFormulaId, formula, _this.address());
          } else {
            cell.setSharedFormula(sharedFormulaId);
          }
        });

        return _this;
      }).handle(arguments);
    }
    /**
     * Callback used by map.
     * @callback Range~mapCallback
     * @param {Cell} cell - The cell.
     * @param {number} ri - The relative row index.
     * @param {number} ci - The relative column index.
     * @param {Range} range - The range.
     * @returns {*} The value to map to.
     */

    /**
     * Creates a 2D array of values by running each cell through a callback.
     * @param {Range~mapCallback} callback - Function called for each cell in the range.
     * @returns {Array.<Array.<*>>} The 2D array of return values.
     */

  }, {
    key: "map",
    value: function map(callback) {
      var _this2 = this;

      var result = [];
      this.forEach(function (cell, ri, ci) {
        if (!result[ri]) result[ri] = [];
        result[ri][ci] = callback(cell, ri, ci, _this2);
      });
      return result;
    }
    /**
     * Gets a value indicating whether the cells in the range are merged.
     * @returns {boolean} The value.
     */

    /**
    * Sets a value indicating whether the cells in the range should be merged.
    * @param {boolean} merged - True to merge, false to unmerge.
    * @returns {Range} The range.
    */

  }, {
    key: "merged",
    value: function merged(_merged) {
      var _this3 = this;

      return new ArgHandler('Range.merged').case(function () {
        return _this3.sheet().merged(_this3.address());
      }).case('*', function (merged) {
        _this3.sheet().merged(_this3.address(), merged);

        return _this3;
      }).handle(arguments);
    }
    /**
     * Gets the data validation object attached to the Range.
     * @returns {object|undefined} The data validation object or undefined if not set.
     */

    /**
    * Set or clear the data validation object of the entire range.
    * @param {object|undefined} dataValidation - Object or null to clear.
    * @returns {Range} The range.
    */

  }, {
    key: "dataValidation",
    value: function dataValidation() {
      var _this4 = this;

      return new ArgHandler('Range.dataValidation').case(function () {
        return _this4.sheet().dataValidation(_this4.address());
      }).case('boolean', function (obj) {
        return _this4.sheet().dataValidation(_this4.address(), obj);
      }).case('*', function (obj) {
        _this4.sheet().dataValidation(_this4.address(), obj);

        return _this4;
      }).handle(arguments);
    }
    /**
     * Callback used by reduce.
     * @callback Range~reduceCallback
     * @param {*} accumulator - The accumulated value.
     * @param {Cell} cell - The cell.
     * @param {number} ri - The relative row index.
     * @param {number} ci - The relative column index.
     * @param {Range} range - The range.
     * @returns {*} The value to map to.
     */

    /**
     * Reduces the range to a single value accumulated from the result of a function called for each cell.
     * @param {Range~reduceCallback} callback - Function called for each cell in the range.
     * @param {*} [initialValue] - The initial value.
     * @returns {*} The accumulated value.
     */

  }, {
    key: "reduce",
    value: function reduce(callback, initialValue) {
      var _this5 = this;

      var accumulator = initialValue;
      this.forEach(function (cell, ri, ci) {
        accumulator = callback(accumulator, cell, ri, ci, _this5);
      });
      return accumulator;
    }
    /**
     * Gets the parent sheet of the range.
     * @returns {Sheet} The parent sheet.
     */

  }, {
    key: "sheet",
    value: function sheet() {
      return this.startCell().sheet();
    }
    /**
     * Gets the start cell of the range.
     * @returns {Cell} The start cell.
     */

  }, {
    key: "startCell",
    value: function startCell() {
      return this._startCell;
    }
    /**
     * Gets a single style for each cell.
     * @param {string} name - The name of the style.
     * @returns {Array.<Array.<*>>} 2D array of style values.
     */

    /**
    * Gets multiple styles for each cell.
    * @param {Array.<string>} names - The names of the styles.
    * @returns {Object.<string, Array.<Array.<*>>>} Object whose keys are style names and values are 2D arrays of style values.
    */

    /**
    * Set the style in each cell to the result of a function called for each.
    * @param {string} name - The name of the style.
    * @param {Range~mapCallback} callback - The callback to provide value for the cell.
    * @returns {Range} The range.
    */

    /**
    * Sets the style in each cell to the corresponding value in the given 2D array of values.
    * @param {string} name - The name of the style.
    * @param {Array.<Array.<*>>} values - The style values to set.
    * @returns {Range} The range.
    */

    /**
    * Set the style of all cells in the range to a single style value.
    * @param {string} name - The name of the style.
    * @param {*} value - The value to set.
    * @returns {Range} The range.
    */

    /**
    * Set multiple styles for the cells in the range.
    * @param {object.<string,Range~mapCallback|Array.<Array.<*>>|*>} styles - Object whose keys are style names and values are either function callbacks, 2D arrays of style values, or a single value for all the cells.
    * @returns {Range} The range.
    */

    /**
    * Sets to a specific style
    * @param {Style} style - Style object given from stylesheet.createStyle
    * @returns {Range} The range.
    */

  }, {
    key: "style",
    value: function style() {
      var _this6 = this;

      return new ArgHandler("Range.style").case('string', function (name) {
        // Get single value
        return _this6.map(function (cell) {
          return cell.style(name);
        });
      }).case('array', function (names) {
        // Get list of values
        var values = {};
        names.forEach(function (name) {
          values[name] = _this6.style(name);
        });
        return values;
      }).case(['string', 'function'], function (name, callback) {
        // Set a single value for the cells to the result of a function
        return _this6.forEach(function (cell, ri, ci) {
          cell.style(name, callback(cell, ri, ci, _this6));
        });
      }).case(['string', 'array'], function (name, values) {
        // Set a single value for the cells using an array of matching dimension
        return _this6.forEach(function (cell, ri, ci) {
          if (values[ri] && values[ri][ci] !== undefined) {
            cell.style(name, values[ri][ci]);
          }
        });
      }).case(['string', '*'], function (name, value) {
        // Set a single value for all cells to a single value
        return _this6.forEach(function (cell) {
          return cell.style(name, value);
        });
      }).case('object', function (nameValues) {
        // Object of key value pairs to set
        for (var name in nameValues) {
          if (!nameValues.hasOwnProperty(name)) continue;
          var value = nameValues[name];

          _this6.style(name, value);
        }

        return _this6;
      }).case('Style', function (style) {
        _this6._style = style;
        return _this6.forEach(function (cell) {
          return cell.style(style);
        });
      }).handle(arguments);
    }
    /**
     * Callback used by tap.
     * @callback Range~tapCallback
     * @param {Range} range - The range.
     * @returns {undefined}
     */

    /**
     * Invoke a callback on the range and return the range. Useful for method chaining.
     * @param {Range~tapCallback} callback - The callback function.
     * @returns {Range} The range.
     */

  }, {
    key: "tap",
    value: function tap(callback) {
      callback(this);
      return this;
    }
    /**
     * Callback used by thru.
     * @callback Range~thruCallback
     * @param {Range} range - The range.
     * @returns {*} The value to return from thru.
     */

    /**
     * Invoke a callback on the range and return the value provided by the callback. Useful for method chaining.
     * @param {Range~thruCallback} callback - The callback function.
     * @returns {*} The return value of the callback.
     */

  }, {
    key: "thru",
    value: function thru(callback) {
      return callback(this);
    }
    /**
     * Get the values of each cell in the range as a 2D array.
     * @returns {Array.<Array.<*>>} The values.
     */

    /**
    * Set the values in each cell to the result of a function called for each.
    * @param {Range~mapCallback} callback - The callback to provide value for the cell.
    * @returns {Range} The range.
    */

    /**
    * Sets the value in each cell to the corresponding value in the given 2D array of values.
    * @param {Array.<Array.<*>>} values - The values to set.
    * @returns {Range} The range.
    */

    /**
    * Set the value of all cells in the range to a single value.
    * @param {*} value - The value to set.
    * @returns {Range} The range.
    */

  }, {
    key: "value",
    value: function value() {
      var _this7 = this;

      return new ArgHandler("Range.value").case(function () {
        // Get values
        return _this7.map(function (cell) {
          return cell.value();
        });
      }).case('function', function (callback) {
        // Set a value for the cells to the result of a function
        return _this7.forEach(function (cell, ri, ci) {
          cell.value(callback(cell, ri, ci, _this7));
        });
      }).case('array', function (values) {
        // Set value for the cells using an array of matching dimension
        return _this7.forEach(function (cell, ri, ci) {
          if (values[ri] && values[ri][ci] !== undefined) {
            cell.value(values[ri][ci]);
          }
        });
      }).case('*', function (value) {
        // Set the value for all cells to a single value
        return _this7.forEach(function (cell) {
          return cell.value(value);
        });
      }).handle(arguments);
    }
    /**
     * Gets the parent workbook.
     * @returns {Workbook} The parent workbook.
     */

  }, {
    key: "workbook",
    value: function workbook() {
      return this.sheet().workbook();
    }
    /**
     * Find the extent of the range.
     * @returns {undefined}
     * @private
     */

  }, {
    key: "_findRangeExtent",
    value: function _findRangeExtent() {
      this._minRowNumber = Math.min(this._startCell.rowNumber(), this._endCell.rowNumber());
      this._maxRowNumber = Math.max(this._startCell.rowNumber(), this._endCell.rowNumber());
      this._minColumnNumber = Math.min(this._startCell.columnNumber(), this._endCell.columnNumber());
      this._maxColumnNumber = Math.max(this._startCell.columnNumber(), this._endCell.columnNumber());
      this._numRows = this._maxRowNumber - this._minRowNumber + 1;
      this._numColumns = this._maxColumnNumber - this._minColumnNumber + 1;
    }
  }]);

  return Range;
}();

module.exports = Range;

},{"./ArgHandler":2,"./addressConverter":23}],11:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _ = require("lodash");

var RELATIONSHIP_SCHEMA_PREFIX = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/";
/**
 * A relationship collection.
 * @ignore
 */

var Relationships = /*#__PURE__*/function () {
  /**
   * Creates a new instance of _Relationships.
   * @param {{}} node - The node.
   */
  function Relationships(node) {
    _classCallCheck(this, Relationships);

    this._init(node);

    this._getStartingId();
  }
  /**
   * Add a new relationship.
   * @param {string} type - The type of relationship.
   * @param {string} target - The target of the relationship.
   * @param {string} [targetMode] - The target mode of the relationship.
   * @returns {{}} The new relationship.
   */


  _createClass(Relationships, [{
    key: "add",
    value: function add(type, target, targetMode) {
      var node = {
        name: "Relationship",
        attributes: {
          Id: "rId".concat(this._nextId++),
          Type: "".concat(RELATIONSHIP_SCHEMA_PREFIX).concat(type),
          Target: target
        }
      };

      if (targetMode) {
        node.attributes.TargetMode = targetMode;
      }

      this._node.children.push(node);

      return node;
    }
    /**
     * Find a relationship by ID.
     * @param {string} id - The relationship ID.
     * @returns {{}|undefined} The matching relationship or undefined if not found.
     */

  }, {
    key: "findById",
    value: function findById(id) {
      return _.find(this._node.children, function (node) {
        return node.attributes.Id === id;
      });
    }
    /**
     * Find a relationship by type.
     * @param {string} type - The type to search for.
     * @returns {{}|undefined} The matching relationship or undefined if not found.
     */

  }, {
    key: "findByType",
    value: function findByType(type) {
      return _.find(this._node.children, function (node) {
        return node.attributes.Type === "".concat(RELATIONSHIP_SCHEMA_PREFIX).concat(type);
      });
    }
    /**
     * Convert the collection to an XML object.
     * @returns {{}|undefined} The XML or undefined if empty.
     */

  }, {
    key: "toXml",
    value: function toXml() {
      if (!this._node.children.length) return;
      return this._node;
    }
    /**
     * Get the starting relationship ID to use for new relationships.
     * @private
     * @returns {undefined}
     */

  }, {
    key: "_getStartingId",
    value: function _getStartingId() {
      var _this = this;

      this._nextId = 1;

      this._node.children.forEach(function (node) {
        var id = parseInt(node.attributes.Id.substr(3));
        if (id >= _this._nextId) _this._nextId = id + 1;
      });
    }
    /**
     * Initialize the node.
     * @param {{}} [node] - The relationships node.
     * @private
     * @returns {undefined}
     */

  }, {
    key: "_init",
    value: function _init(node) {
      if (!node) node = {
        name: "Relationships",
        attributes: {
          xmlns: "http://schemas.openxmlformats.org/package/2006/relationships"
        },
        children: []
      };
      this._node = node;
    }
  }]);

  return Relationships;
}();

module.exports = Relationships;
/*
xl/_rels/workbook.xml.rels

<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
    <Relationship Id="rId3" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/>
    <Relationship Id="rId2" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme" Target="theme/theme1.xml"/>
    <Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet1.xml"/>
    <Relationship Id="rId5" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/calcChain" Target="calcChain.xml"/>
    <Relationship Id="rId4" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings" Target="sharedStrings.xml"/>
</Relationships>
*/

},{"lodash":170}],12:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _ = require("lodash");

var RichTextFragment = require("./RichTextFragment");
/**
 * A RichText class that contains many {@link RichTextFragment}.
 */


var RichText = /*#__PURE__*/function () {
  /**
   * Creates a new instance of RichText. If you get the instance by calling `Cell.value()`,
   * adding a text contains line separator will trigger {@link Cell.style}('wrapText', true), which
   * will make MS Excel show the new line. i.e. In MS Excel, Tap "alt+Enter" in a cell, the cell
   * will set wrap text to true automatically.
   *
   * @param {undefined|null|Object} [node] - The node stored in the shared string
   */
  function RichText(node) {
    _classCallCheck(this, RichText);

    this._node = [];
    this._cell = null;
    this._remainingNodes = [];

    if (node) {
      for (var i = 0; i < node.length; i++) {
        var fragment = node[i];

        if (fragment.name === 'r') {
          this._node.push(new RichTextFragment(fragment, null, this));
        } else {
          // special node, e.g. rPh, phoneticPr in Japanese language.
          this._remainingNodes.push(fragment);
        }
      }
    }
  }
  /**
   * Gets which cell this {@link RichText} instance belongs to.
   * @return {Cell|undefined} The cell this instance belongs to.
   */


  _createClass(RichText, [{
    key: "text",

    /**
     * Gets concatenated text without styles.
     * @return {string} concatenated text
     */
    value: function text() {
      var text = '';

      for (var i = 0; i < this._node.length; i++) {
        text += this.get(i).value();
      }

      return text;
    }
    /**
     * Gets the instance with cell reference defined.
     * @param {Cell} cell - Cell reference.
     * @return {RichText} The instance with cell reference defined.
     */

  }, {
    key: "getInstanceWithCellRef",
    value: function getInstanceWithCellRef(cell) {
      this._cell = cell;
      return this;
    }
    /**
     * Returns a deep copy of this instance.
     * If cell reference is provided, it checks line separators and calls
     * `cell.style('wrapText', true)` when needed.
     * @param {Cell|undefined} [cell] - The cell reference.
     * @return {RichText} A deep copied instance
     */

  }, {
    key: "copy",
    value: function copy(cell) {
      var newRichText = new RichText(_.cloneDeep(this.toXml()));

      if (cell && _.includes(this.text(), '\n')) {
        cell.style('wrapText', true);
      }

      return newRichText;
    }
    /**
     * Gets the ith fragment of this {@link RichText} instance.
     * @param {number} index - The index
     * @return {RichTextFragment} A rich text fragment
     */

  }, {
    key: "get",
    value: function get(index) {
      return this._node[index];
    }
    /**
     * Removes a rich text fragment. This instance will be mutated.
     * @param {number} index - the index of the fragment to remove
     * @return {RichText} the rich text instance
     */

  }, {
    key: "remove",
    value: function remove(index) {
      this._node.splice(index, 1);

      this.removeUnsupportedNodes();
      return this;
    }
    /**
     * Adds a rich text fragment to the last or after the given index. This instance will be mutated.
     * @param {string} text - the text
     * @param {{}} [styles] - the styles js object, i.e. {fontSize: 12}
     * @param {number|undefined|null} [index] - the index of the fragment to add
     * @return {RichText} the rich text instance
     */

  }, {
    key: "add",
    value: function add(text, styles, index) {
      if (index === undefined || index === null) {
        this._node.push(new RichTextFragment(text, styles, this));
      } else {
        this._node.splice(index, 0, new RichTextFragment(text, styles, this));
      }

      this.removeUnsupportedNodes();
      return this;
    }
    /**
     * Clears this rich text
     * @return {RichText} the rich text instance
     */

  }, {
    key: "clear",
    value: function clear() {
      this._node = [];
      this._remainingNodes = [];
      this._cell = undefined;
      return this;
    }
    /**
     * Remove all unsupported nodes (phoneticPr, rPh for Japanese language).
     * @return {undefined}
     */

  }, {
    key: "removeUnsupportedNodes",
    value: function removeUnsupportedNodes() {
      this._remainingNodes = [];
    }
    /**
     * Convert the rich text to an XML object.
     * @returns {Array.<{}>} The XML form.
     * @ignore
     */

  }, {
    key: "toXml",
    value: function toXml() {
      var node = [];

      for (var i = 0; i < this._node.length; i++) {
        node.push(this._node[i].toXml());
      }

      return node.concat(this._remainingNodes);
    }
  }, {
    key: "cell",
    get: function get() {
      return this._cell;
    }
    /**
     * Gets the how many rich text fragment this {@link RichText} instance contains
     * @return {number} The number of fragments this {@link RichText} instance has.
     */

  }, {
    key: "length",
    get: function get() {
      return this._node.length;
    }
  }]);

  return RichText;
}(); // IE doesn't support function names so explicitly set it.


if (!RichText.name) RichText.name = "RichText";
module.exports = RichText;

},{"./RichTextFragment":13,"lodash":170}],13:[function(require,module,exports){
"use strict";
/* eslint camelcase:off */

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ArgHandler = require("./ArgHandler");

var _ = require("lodash");

var xmlq = require("./xmlq");

var colorIndexes = require("./colorIndexes");
/**
 * A Rich text fragment.
 */


var RichTextFragment = /*#__PURE__*/function () {
  /**
   * Creates a new instance of RichTextFragment.
   * @constructor
   * @param {string|Object} value - Text value or XML node
   * @param {object|undefined|null} [styles] - Multiple styles.
   * @param {RichText} richText - The rich text instance where this fragment belongs to.
   */
  function RichTextFragment(value, styles, richText) {
    _classCallCheck(this, RichTextFragment);

    this._richText = richText;

    if (value.name === 'r') {
      this._node = value;
      this._fontNode = xmlq.findChild(this._node, 'rPr');

      if (!this._fontNode) {
        this._fontNode = {
          name: 'rPr',
          attributes: {},
          children: []
        };

        this._node.children.unshift(this._fontNode);
      }

      this._valueNode = xmlq.findChild(this._node, 't');
    } else {
      this._node = {
        name: 'r',
        attributes: {},
        children: [{
          name: 'rPr',
          attributes: {},
          children: []
        }, {
          name: 't',
          attributes: {},
          children: []
        }]
      };
      this._fontNode = xmlq.findChild(this._node, 'rPr');
      this._valueNode = xmlq.findChild(this._node, 't');
      this.value(value);

      if (styles) {
        this.style(styles);
      }
    }
  }
  /**
   * Gets the value of this part of rich text
   * @return {string} text
   */

  /**
  * Sets the value of this part of rich text
  * @param {string} text - the text to set
  * @return {RichTextFragment} - RichTextFragment
  */


  _createClass(RichTextFragment, [{
    key: "value",
    value: function value() {
      var _this = this;

      return new ArgHandler("_RichText.value").case(function () {
        return _this._valueNode.children[0];
      }).case('string', function (value) {
        value = value.replace(/(?:\r\n|\r|\n)/g, '\r\n');
        var hasLineSeparator = value.indexOf('\r\n') !== -1;
        _this._valueNode.children[0] = value;
        if (value.charAt(0) === ' ') xmlq.setAttributes(_this._valueNode, {
          'xml:space': 'preserve'
        });
        if (_this._richText) _this._richText.removeUnsupportedNodes();

        if (hasLineSeparator) {
          // set wrapText = true if it contains line separator, excel will only display new lines if it sets.
          if (_this._richText.cell) {
            _this._richText.cell.style('wrapText', true);
          }

          xmlq.setAttributes(_this._valueNode, {
            'xml:space': 'preserve'
          });
        }

        return _this;
      }).handle(arguments);
    }
    /**
     * Convert the rich text to an XML object.
     * @returns {{}} The XML form.
     * @ignore
     */

  }, {
    key: "toXml",
    value: function toXml() {
      return this._node;
    }
    /**
     * Gets an individual style.
     * @param {string} name - The name of the style.
     * @returns {*} The style.
     */

    /**
    * Gets multiple styles.
    * @param {Array.<string>} names - The names of the style.
    * @returns {object.<string, *>} Object whose keys are the style names and values are the styles.
    */

    /**
    * Sets an individual style.
    * @param {string} name - The name of the style.
    * @param {*} value - The value to set.
    * @returns {RichTextFragment} This RichTextFragment.
    */

    /**
    * Sets multiple styles.
    * @param {object.<string, *>} styles - Object whose keys are the style names and values are the styles to set.
    * @returns {RichTextFragment} This RichTextFragment.
    */

  }, {
    key: "style",
    value: function style() {
      var _this2 = this;

      return new ArgHandler("_RichText.style").case('string', function (name) {
        // Get single value
        var getterName = "_get_".concat(name);
        if (!_this2[getterName]) throw new Error("_RichText.style: '".concat(name, "' is not a valid style"));
        return _this2[getterName]();
      }).case('array', function (names) {
        // Get list of values
        var values = {};
        names.forEach(function (name) {
          values[name] = _this2.style(name);
        });
        return values;
      }).case(['string', '*'], function (name, value) {
        // Set a single value
        var setterName = "_set_".concat(name);
        if (!_this2[setterName]) throw new Error("_RichText.style: '".concat(name, "' is not a valid style"));
        return _this2[setterName](value);
      }).case('object', function (nameValues) {
        // Object of key value pairs to set
        for (var name in nameValues) {
          if (!nameValues.hasOwnProperty(name)) continue;
          var value = nameValues[name];

          _this2.style(name, value);
        }

        return _this2;
      }).handle(arguments);
    }
  }, {
    key: "_getColor",
    value: function _getColor(node, name) {
      var child = xmlq.findChild(node, name);
      if (!child || !child.attributes) return;
      var color = {};
      if (child.attributes.hasOwnProperty('rgb')) color.rgb = child.attributes.rgb;else if (child.attributes.hasOwnProperty('theme')) color.theme = child.attributes.theme;else if (child.attributes.hasOwnProperty('indexed')) color.rgb = colorIndexes[child.attributes.indexed];
      if (child.attributes.hasOwnProperty('tint')) color.tint = child.attributes.tint;
      if (_.isEmpty(color)) return;
      return color;
    }
  }, {
    key: "_setColor",
    value: function _setColor(node, name, color) {
      if (typeof color === "string") color = {
        rgb: color
      };else if (typeof color === "number") color = {
        theme: color
      };
      xmlq.setChildAttributes(node, name, {
        rgb: color && color.rgb && color.rgb.toUpperCase(),
        indexed: null,
        theme: color && color.theme,
        tint: color && color.tint
      });
      xmlq.removeChildIfEmpty(node, 'color');
    }
  }, {
    key: "_get_bold",
    value: function _get_bold() {
      return xmlq.hasChild(this._fontNode, 'b');
    }
  }, {
    key: "_set_bold",
    value: function _set_bold(bold) {
      if (bold) xmlq.appendChildIfNotFound(this._fontNode, "b");else xmlq.removeChild(this._fontNode, 'b');
    }
  }, {
    key: "_get_italic",
    value: function _get_italic() {
      return xmlq.hasChild(this._fontNode, 'i');
    }
  }, {
    key: "_set_italic",
    value: function _set_italic(italic) {
      if (italic) xmlq.appendChildIfNotFound(this._fontNode, "i");else xmlq.removeChild(this._fontNode, 'i');
    }
  }, {
    key: "_get_underline",
    value: function _get_underline() {
      var uNode = xmlq.findChild(this._fontNode, 'u');
      return uNode ? uNode.attributes.val || true : false;
    }
  }, {
    key: "_set_underline",
    value: function _set_underline(underline) {
      if (underline) {
        var uNode = xmlq.appendChildIfNotFound(this._fontNode, "u");
        var val = typeof underline === 'string' ? underline : null;
        xmlq.setAttributes(uNode, {
          val: val
        });
      } else {
        xmlq.removeChild(this._fontNode, 'u');
      }
    }
  }, {
    key: "_get_strikethrough",
    value: function _get_strikethrough() {
      return xmlq.hasChild(this._fontNode, 'strike');
    }
  }, {
    key: "_set_strikethrough",
    value: function _set_strikethrough(strikethrough) {
      if (strikethrough) xmlq.appendChildIfNotFound(this._fontNode, "strike");else xmlq.removeChild(this._fontNode, 'strike');
    }
  }, {
    key: "_getFontVerticalAlignment",
    value: function _getFontVerticalAlignment() {
      return xmlq.getChildAttribute(this._fontNode, 'vertAlign', "val");
    }
  }, {
    key: "_setFontVerticalAlignment",
    value: function _setFontVerticalAlignment(alignment) {
      xmlq.setChildAttributes(this._fontNode, 'vertAlign', {
        val: alignment
      });
      xmlq.removeChildIfEmpty(this._fontNode, 'vertAlign');
    }
  }, {
    key: "_get_subscript",
    value: function _get_subscript() {
      return this._getFontVerticalAlignment() === "subscript";
    }
  }, {
    key: "_set_subscript",
    value: function _set_subscript(subscript) {
      this._setFontVerticalAlignment(subscript ? "subscript" : null);
    }
  }, {
    key: "_get_superscript",
    value: function _get_superscript() {
      return this._getFontVerticalAlignment() === "superscript";
    }
  }, {
    key: "_set_superscript",
    value: function _set_superscript(superscript) {
      this._setFontVerticalAlignment(superscript ? "superscript" : null);
    }
  }, {
    key: "_get_fontSize",
    value: function _get_fontSize() {
      return xmlq.getChildAttribute(this._fontNode, 'sz', "val");
    }
  }, {
    key: "_set_fontSize",
    value: function _set_fontSize(size) {
      xmlq.setChildAttributes(this._fontNode, 'sz', {
        val: size
      });
      xmlq.removeChildIfEmpty(this._fontNode, 'sz');
    }
  }, {
    key: "_get_fontFamily",
    value: function _get_fontFamily() {
      return xmlq.getChildAttribute(this._fontNode, 'rFont', "val");
    }
  }, {
    key: "_set_fontFamily",
    value: function _set_fontFamily(family) {
      xmlq.setChildAttributes(this._fontNode, 'rFont', {
        val: family
      });
      xmlq.removeChildIfEmpty(this._fontNode, 'rFont');
    }
  }, {
    key: "_get_fontGenericFamily",
    value: function _get_fontGenericFamily() {
      return xmlq.getChildAttribute(this._fontNode, 'family', "val");
    }
    /**
     * @param {number} genericFamily - 1: Serif, 2: Sans Serif, 3: Monospace,
     * @private
     * @return {undefined}
     */

  }, {
    key: "_set_fontGenericFamily",
    value: function _set_fontGenericFamily(genericFamily) {
      xmlq.setChildAttributes(this._fontNode, 'family', {
        val: genericFamily
      });
      xmlq.removeChildIfEmpty(this._fontNode, 'family');
    }
  }, {
    key: "_get_fontColor",
    value: function _get_fontColor() {
      return this._getColor(this._fontNode, "color");
    }
  }, {
    key: "_set_fontColor",
    value: function _set_fontColor(color) {
      this._setColor(this._fontNode, "color", color);
    }
  }, {
    key: "_get_fontScheme",
    value: function _get_fontScheme() {
      // can be 'minor', 'major', 'none'
      return xmlq.getChildAttribute(this._fontNode, 'scheme', "val");
    }
    /**
     * @param {string} scheme - 'minor'|'major'|'none'
     * @private
     * @return {undefined}
     */

  }, {
    key: "_set_fontScheme",
    value: function _set_fontScheme(scheme) {
      xmlq.setChildAttributes(this._fontNode, 'scheme', {
        val: scheme
      });
      xmlq.removeChildIfEmpty(this._fontNode, 'scheme');
    }
  }]);

  return RichTextFragment;
}(); // IE doesn't support function names so explicitly set it.


if (!RichTextFragment.name) RichTextFragment.name = "RichTextFragment";
module.exports = RichTextFragment;

},{"./ArgHandler":2,"./colorIndexes":25,"./xmlq":29,"lodash":170}],14:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _ = require("lodash");

var Cell = require("./Cell");

var regexify = require("./regexify");

var ArgHandler = require("./ArgHandler");

var addressConverter = require('./addressConverter');
/**
 * A row.
 */


var Row = /*#__PURE__*/function () {
  // /**
  //  * Creates a new instance of Row.
  //  * @param {Sheet} sheet - The parent sheet.
  //  * @param {{}} node - The row node.
  //  */
  function Row(sheet, node) {
    _classCallCheck(this, Row);

    this._sheet = sheet;

    this._init(node);
  }
  /* PUBLIC */

  /**
   * Get the address of the row.
   * @param {{}} [opts] - Options
   * @param {boolean} [opts.includeSheetName] - Include the sheet name in the address.
   * @param {boolean} [opts.anchored] - Anchor the address.
   * @returns {string} The address
   */


  _createClass(Row, [{
    key: "address",
    value: function address(opts) {
      return addressConverter.toAddress({
        type: 'row',
        rowNumber: this.rowNumber(),
        sheetName: opts && opts.includeSheetName && this.sheet().name(),
        rowAnchored: opts && opts.anchored
      });
    }
    /**
     * Get a cell in the row.
     * @param {string|number} columnNameOrNumber - The name or number of the column.
     * @returns {Cell} The cell.
     */

  }, {
    key: "cell",
    value: function cell(columnNameOrNumber) {
      var columnNumber = columnNameOrNumber;

      if (typeof columnNameOrNumber === 'string') {
        columnNumber = addressConverter.columnNameToNumber(columnNameOrNumber);
      }

      if (columnNumber < 1) throw new RangeError("Invalid column number ".concat(columnNumber, ". Remember that spreadsheets use 1-based indexing.")); // Return an existing cell.

      if (this._cells[columnNumber]) return this._cells[columnNumber]; // No cell exists for this.
      // Check if there is an existing row/column style for the new cell.

      var styleId;
      var rowStyleId = this._node.attributes.s;
      var columnStyleId = this.sheet().existingColumnStyleId(columnNumber); // Row style takes priority. If a cell has both row and column styles it should have created a cell entry with a cell-specific style.

      if (!_.isNil(rowStyleId)) styleId = rowStyleId;else if (!_.isNil(columnStyleId)) styleId = columnStyleId; // Create the new cell.

      var cell = new Cell(this, columnNumber, styleId);
      this._cells[columnNumber] = cell;
      return cell;
    }
    /**
     * Gets the row height.
     * @returns {undefined|number} The height (or undefined).
     */

    /**
    * Sets the row height.
    * @param {number} height - The height of the row.
    * @returns {Row} The row.
    */

  }, {
    key: "height",
    value: function height() {
      var _this = this;

      return new ArgHandler('Row.height').case(function () {
        return _this._node.attributes.customHeight ? _this._node.attributes.ht : undefined;
      }).case('number', function (height) {
        _this._node.attributes.ht = height;
        _this._node.attributes.customHeight = 1;
        return _this;
      }).case('nil', function () {
        delete _this._node.attributes.ht;
        delete _this._node.attributes.customHeight;
        return _this;
      }).handle(arguments);
    }
    /**
     * Gets a value indicating whether the row is hidden.
     * @returns {boolean} A flag indicating whether the row is hidden.
     */

    /**
    * Sets whether the row is hidden.
    * @param {boolean} hidden - A flag indicating whether to hide the row.
    * @returns {Row} The row.
    */

  }, {
    key: "hidden",
    value: function hidden() {
      var _this2 = this;

      return new ArgHandler("Row.hidden").case(function () {
        return _this2._node.attributes.hidden === 1;
      }).case('boolean', function (hidden) {
        if (hidden) _this2._node.attributes.hidden = 1;else delete _this2._node.attributes.hidden;
        return _this2;
      }).handle(arguments);
    }
    /**
     * Gets the row number.
     * @returns {number} The row number.
     */

  }, {
    key: "rowNumber",
    value: function rowNumber() {
      return this._node.attributes.r;
    }
    /**
     * Gets the parent sheet of the row.
     * @returns {Sheet} The parent sheet.
     */

  }, {
    key: "sheet",
    value: function sheet() {
      return this._sheet;
    }
    /**
     * Gets an individual style.
     * @param {string} name - The name of the style.
     * @returns {*} The style.
     */

    /**
    * Gets multiple styles.
    * @param {Array.<string>} names - The names of the style.
    * @returns {object.<string, *>} Object whose keys are the style names and values are the styles.
    */

    /**
    * Sets an individual style.
    * @param {string} name - The name of the style.
    * @param {*} value - The value to set.
    * @returns {Cell} The cell.
    */

    /**
    * Sets multiple styles.
    * @param {object.<string, *>} styles - Object whose keys are the style names and values are the styles to set.
    * @returns {Cell} The cell.
    */

    /**
    * Sets to a specific style
    * @param {Style} style - Style object given from stylesheet.createStyle
    * @returns {Cell} The cell.
    */

  }, {
    key: "style",
    value: function style() {
      var _this3 = this;

      return new ArgHandler("Row.style").case('string', function (name) {
        // Get single value
        _this3._createStyleIfNeeded();

        return _this3._style.style(name);
      }).case('array', function (names) {
        // Get list of values
        var values = {};
        names.forEach(function (name) {
          values[name] = _this3.style(name);
        });
        return values;
      }).case(['string', '*'], function (name, value) {
        _this3._createCellStylesIfNeeded(); // Style each existing cell within this row. (Cells don't inherit ow/column styles.)


        _.forEach(_this3._cells, function (cell) {
          if (cell) cell.style(name, value);
        }); // Set the style on the row.


        _this3._createStyleIfNeeded();

        _this3._style.style(name, value);

        return _this3;
      }).case('object', function (nameValues) {
        // Object of key value pairs to set
        for (var name in nameValues) {
          if (!nameValues.hasOwnProperty(name)) continue;
          var value = nameValues[name];

          _this3.style(name, value);
        }

        return _this3;
      }).case('Style', function (style) {
        _this3._createCellStylesIfNeeded(); // Style each existing cell within this row. (Cells don't inherit ow/column styles.)


        _.forEach(_this3._cells, function (cell) {
          if (cell) cell.style(style);
        });

        _this3._style = style;
        _this3._node.attributes.s = style.id();
        _this3._node.attributes.customFormat = 1;
        return _this3;
      }).handle(arguments);
    }
    /**
     * Get the parent workbook.
     * @returns {Workbook} The parent workbook.
     */

  }, {
    key: "workbook",
    value: function workbook() {
      return this.sheet().workbook();
    }
    /**
     * Append horizontal page break after the row.
     * @returns {Row} the row.
     */

  }, {
    key: "addPageBreak",
    value: function addPageBreak() {
      this.sheet().horizontalPageBreaks().add(this.rowNumber());
      return this;
    }
    /* INTERNAL */

    /**
     * Clear cells that are using a given shared formula ID.
     * @param {number} sharedFormulaId - The shared formula ID.
     * @returns {undefined}
     * @ignore
     */

  }, {
    key: "clearCellsUsingSharedFormula",
    value: function clearCellsUsingSharedFormula(sharedFormulaId) {
      this._cells.forEach(function (cell) {
        if (!cell) return;
        if (cell.sharesFormula(sharedFormulaId)) cell.clear();
      });
    }
    /**
     * Find a pattern in the row and optionally replace it.
     * @param {string|RegExp} pattern - The search pattern.
     * @param {string} [replacement] - The replacement text.
     * @returns {Array.<Cell>} The matched cells.
     * @ignore
     */

  }, {
    key: "find",
    value: function find(pattern, replacement) {
      pattern = regexify(pattern);
      var matches = [];

      this._cells.forEach(function (cell) {
        if (!cell) return;
        if (cell.find(pattern, replacement)) matches.push(cell);
      });

      return matches;
    }
    /**
     * Check if the row has a cell at the given column number.
     * @param {number} columnNumber - The column number.
     * @returns {boolean} True if a cell exists, false otherwise.
     * @ignore
     */

  }, {
    key: "hasCell",
    value: function hasCell(columnNumber) {
      if (columnNumber < 1) throw new RangeError("Invalid column number ".concat(columnNumber, ". Remember that spreadsheets use 1-based indexing."));
      return !!this._cells[columnNumber];
    }
    /**
     * Check if the column has a style defined.
     * @returns {boolean} True if a style exists, false otherwise.
     * @ignore
     */

  }, {
    key: "hasStyle",
    value: function hasStyle() {
      return !_.isNil(this._node.attributes.s);
    }
    /**
     * Returns the nax used column number.
     * @returns {number} The max used column number.
     * @ignore
     */

  }, {
    key: "minUsedColumnNumber",
    value: function minUsedColumnNumber() {
      return _.findIndex(this._cells);
    }
    /**
     * Returns the nax used column number.
     * @returns {number} The max used column number.
     * @ignore
     */

  }, {
    key: "maxUsedColumnNumber",
    value: function maxUsedColumnNumber() {
      return this._cells.length - 1;
    }
    /**
     * Convert the row to an object.
     * @returns {{}} The object form.
     * @ignore
     */

  }, {
    key: "toXml",
    value: function toXml() {
      return this._node;
    }
    /* PRIVATE */

    /**
     * If a column node is already defined that intersects with this row and that column has a style set, we
     * need to make sure that a cell node exists at the intersection so we can style it appropriately.
     * Fetching the cell will force a new cell node to be created with a style matching the column.
     * @returns {undefined}
     * @private
     */

  }, {
    key: "_createCellStylesIfNeeded",
    value: function _createCellStylesIfNeeded() {
      var _this4 = this;

      this.sheet().forEachExistingColumnNumber(function (columnNumber) {
        if (!_.isNil(_this4.sheet().existingColumnStyleId(columnNumber))) _this4.cell(columnNumber);
      });
    }
    /**
     * Create a style for this row if it doesn't already exist.
     * @returns {undefined}
     * @private
     */

  }, {
    key: "_createStyleIfNeeded",
    value: function _createStyleIfNeeded() {
      if (!this._style) {
        var styleId = this._node.attributes.s;
        this._style = this.workbook().styleSheet().createStyle(styleId);
        this._node.attributes.s = this._style.id();
        this._node.attributes.customFormat = 1;
      }
    }
    /**
     * Initialize the row node.
     * @param {{}} node - The row node.
     * @returns {undefined}
     * @private
     */

  }, {
    key: "_init",
    value: function _init(node) {
      var _this5 = this;

      this._node = node;
      this._cells = [];

      this._node.children.forEach(function (cellNode) {
        var cell = new Cell(_this5, cellNode);
        _this5._cells[cell.columnNumber()] = cell;
      });

      this._node.children = this._cells;
    }
  }]);

  return Row;
}();

module.exports = Row;
/*
<row r="6" spans="1:9" x14ac:dyDescent="0.25">
    <c r="A6" s="1" t="s">
        <v>2</v>
    </c>
    <c r="B6" s="1"/>
    <c r="C6" s="1"/>
</row>
*/

},{"./ArgHandler":2,"./Cell":3,"./addressConverter":23,"./regexify":28,"lodash":170}],15:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _ = require("lodash");
/**
 * The shared strings table.
 * @ignore
 */


var SharedStrings = /*#__PURE__*/function () {
  /**
   * Constructs a new instance of _SharedStrings.
   * @param {{}} node - The node.
   */
  function SharedStrings(node) {
    _classCallCheck(this, SharedStrings);

    this._stringArray = [];
    this._indexMap = {};

    this._init(node);

    this._cacheExistingSharedStrings();
  }
  /**
   * Gets the index for a string
   * @param {string|Array.<{}>} string - The string or rich text array.
   * @returns {number} The index
   */


  _createClass(SharedStrings, [{
    key: "getIndexForString",
    value: function getIndexForString(string) {
      // If the string is found in the cache, return the index.
      var key = _.isArray(string) ? JSON.stringify(string) : string;
      var index = this._indexMap[key];
      if (index >= 0) return index; // Otherwise, add it to the caches.

      index = this._stringArray.length;

      this._stringArray.push(string);

      this._indexMap[key] = index; // Append a new si node.

      this._node.children.push({
        name: "si",
        children: _.isArray(string) ? string : [{
          name: "t",
          attributes: {
            'xml:space': "preserve"
          },
          children: [string]
        }]
      });

      return index;
    }
    /**
     * Get the string for a given index
     * @param {number} index - The index
     * @returns {string} The string
     */

  }, {
    key: "getStringByIndex",
    value: function getStringByIndex(index) {
      return this._stringArray[index];
    }
    /**
     * Convert the collection to an XML object.
     * @returns {{}} The XML object.
     */

  }, {
    key: "toXml",
    value: function toXml() {
      return this._node;
    }
    /**
     * Store any existing values in the caches.
     * @private
     * @returns {undefined}
     */

  }, {
    key: "_cacheExistingSharedStrings",
    value: function _cacheExistingSharedStrings() {
      var _this = this;

      this._node.children.forEach(function (node, i) {
        var content = node.children[0];

        if (content.name === "t") {
          var string = content.children[0];

          _this._stringArray.push(string);

          _this._indexMap[string] = i;
        } else {
          // TODO: Properly support rich text nodes in the future. For now just store the object as a placeholder.
          _this._stringArray.push(node.children);

          _this._indexMap[JSON.stringify(node.children)] = i;
        }
      });
    }
    /**
     * Initialize the node.
     * @param {{}} [node] - The shared strings node.
     * @private
     * @returns {undefined}
     */

  }, {
    key: "_init",
    value: function _init(node) {
      if (!node) node = {
        name: "sst",
        attributes: {
          xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main"
        },
        children: []
      };
      this._node = node;
      delete this._node.attributes.count;
      delete this._node.attributes.uniqueCount;
    }
  }]);

  return SharedStrings;
}();

module.exports = SharedStrings;
/*
xl/sharedStrings.xml

<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<sst xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" count="13" uniqueCount="4">
	<si>
		<t>Foo</t>
	</si>
	<si>
		<t>Bar</t>
	</si>
	<si>
		<t>Goo</t>
	</si>
	<si>
		<r>
			<t>s</t>
		</r><r>
			<rPr>
				<b/>
				<sz val="11"/>
				<color theme="1"/>
				<rFont val="Calibri"/>
				<family val="2"/>
				<scheme val="minor"/>
			</rPr><t>d;</t>
		</r><r>
			<rPr>
				<sz val="11"/>
				<color theme="1"/>
				<rFont val="Calibri"/>
				<family val="2"/>
				<scheme val="minor"/>
			</rPr><t>lfk;l</t>
		</r>
	</si>
</sst>
*/

},{"lodash":170}],16:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _ = require("lodash");

var Cell = require("./Cell");

var Row = require("./Row");

var Column = require("./Column");

var Range = require("./Range");

var Relationships = require("./Relationships");

var xmlq = require("./xmlq");

var regexify = require("./regexify");

var addressConverter = require("./addressConverter");

var ArgHandler = require("./ArgHandler");

var colorIndexes = require("./colorIndexes");

var PageBreaks = require("./PageBreaks"); // Order of the nodes as defined by the spec.


var nodeOrder = ["sheetPr", "dimension", "sheetViews", "sheetFormatPr", "cols", "sheetData", "sheetCalcPr", "sheetProtection", "autoFilter", "protectedRanges", "scenarios", "autoFilter", "sortState", "dataConsolidate", "customSheetViews", "mergeCells", "phoneticPr", "conditionalFormatting", "dataValidations", "hyperlinks", "printOptions", "pageMargins", "pageSetup", "headerFooter", "rowBreaks", "colBreaks", "customProperties", "cellWatches", "ignoredErrors", "smartTags", "drawing", "drawingHF", "legacyDrawing", "legacyDrawingHF", "picture", "oleObjects", "controls", "webPublishItems", "tableParts", "extLst"];
/**
 * A worksheet.
 */

var Sheet = /*#__PURE__*/function () {
  // /**
  //  * Creates a new instance of Sheet.
  //  * @param {Workbook} workbook - The parent workbook.
  //  * @param {{}} idNode - The sheet ID node (from the parent workbook).
  //  * @param {{}} node - The sheet node.
  //  * @param {{}} [relationshipsNode] - The optional sheet relationships node.
  //  */
  function Sheet(workbook, idNode, node, relationshipsNode) {
    _classCallCheck(this, Sheet);

    this._init(workbook, idNode, node, relationshipsNode);
  }
  /* PUBLIC */

  /**
   * Gets a value indicating whether the sheet is the active sheet in the workbook.
   * @returns {boolean} True if active, false otherwise.
   */

  /**
  * Make the sheet the active sheet in the workkbok.
  * @param {boolean} active - Must be set to `true`. Deactivating directly is not supported. To deactivate, you should activate a different sheet instead.
  * @returns {Sheet} The sheet.
  */


  _createClass(Sheet, [{
    key: "active",
    value: function active() {
      var _this = this;

      return new ArgHandler('Sheet.active').case(function () {
        return _this.workbook().activeSheet() === _this;
      }).case('boolean', function (active) {
        if (!active) throw new Error("Deactivating sheet directly not supported. Activate a different sheet instead.");

        _this.workbook().activeSheet(_this);

        return _this;
      }).handle(arguments);
    }
    /**
     * Get the active cell in the sheet.
     * @returns {Cell} The active cell.
     */

    /**
    * Set the active cell in the workbook.
    * @param {string|Cell} cell - The cell or address of cell to activate.
    * @returns {Sheet} The sheet.
    */

    /**
    * Set the active cell in the workbook by row and column.
    * @param {number} rowNumber - The row number of the cell.
    * @param {string|number} columnNameOrNumber - The column name or number of the cell.
    * @returns {Sheet} The sheet.
    */

  }, {
    key: "activeCell",
    value: function activeCell() {
      var _this2 = this;

      var sheetViewNode = this._getOrCreateSheetViewNode();

      var selectionNode = xmlq.findChild(sheetViewNode, "selection");
      return new ArgHandler('Sheet.activeCell').case(function () {
        var cellAddress = selectionNode ? selectionNode.attributes.activeCell : "A1";
        return _this2.cell(cellAddress);
      }).case(['number', '*'], function (rowNumber, columnNameOrNumber) {
        var cell = _this2.cell(rowNumber, columnNameOrNumber);

        return _this2.activeCell(cell);
      }).case('*', function (cell) {
        if (!selectionNode) {
          selectionNode = {
            name: "selection",
            attributes: {},
            children: []
          };
          xmlq.appendChild(sheetViewNode, selectionNode);
        }

        if (!(cell instanceof Cell)) cell = _this2.cell(cell);
        selectionNode.attributes.activeCell = selectionNode.attributes.sqref = cell.address();
        return _this2;
      }).handle(arguments);
    }
    /**
     * Gets the cell with the given address.
     * @param {string} address - The address of the cell.
     * @returns {Cell} The cell.
     */

    /**
    * Gets the cell with the given row and column numbers.
    * @param {number} rowNumber - The row number of the cell.
    * @param {string|number} columnNameOrNumber - The column name or number of the cell.
    * @returns {Cell} The cell.
    */

  }, {
    key: "cell",
    value: function cell() {
      var _this3 = this;

      return new ArgHandler('Sheet.cell').case('string', function (address) {
        var ref = addressConverter.fromAddress(address);
        if (ref.type !== 'cell') throw new Error('Sheet.cell: Invalid address.');
        return _this3.row(ref.rowNumber).cell(ref.columnNumber);
      }).case(['number', '*'], function (rowNumber, columnNameOrNumber) {
        return _this3.row(rowNumber).cell(columnNameOrNumber);
      }).handle(arguments);
    }
    /**
     * Gets a column in the sheet.
     * @param {string|number} columnNameOrNumber - The name or number of the column.
     * @returns {Column} The column.
     */

  }, {
    key: "column",
    value: function column(columnNameOrNumber) {
      var columnNumber = typeof columnNameOrNumber === "string" ? addressConverter.columnNameToNumber(columnNameOrNumber) : columnNameOrNumber; // If we're already created a column for this column number, return it.

      if (this._columns[columnNumber]) return this._columns[columnNumber]; // We need to create a new column, which requires a backing col node. There may already exist a node whose min/max cover our column.
      // First, see if there is an existing col node.

      var existingColNode = this._colNodes[columnNumber];
      var colNode;

      if (existingColNode) {
        // If the existing node covered earlier columns than the new one, we need to have a col node to cover the min up to our new node.
        if (existingColNode.attributes.min < columnNumber) {
          // Clone the node and set the max to the column before our new col.
          var beforeColNode = _.cloneDeep(existingColNode);

          beforeColNode.attributes.max = columnNumber - 1; // Update the col nodes cache.

          for (var i = beforeColNode.attributes.min; i <= beforeColNode.attributes.max; i++) {
            this._colNodes[i] = beforeColNode;
          }
        } // Make a clone for the new column. Set the min/max to the column number and cache it.


        colNode = _.cloneDeep(existingColNode);
        colNode.attributes.min = columnNumber;
        colNode.attributes.max = columnNumber;
        this._colNodes[columnNumber] = colNode; // If the max of the existing node is greater than the nre one, create a col node for that too.

        if (existingColNode.attributes.max > columnNumber) {
          var afterColNode = _.cloneDeep(existingColNode);

          afterColNode.attributes.min = columnNumber + 1;

          for (var _i = afterColNode.attributes.min; _i <= afterColNode.attributes.max; _i++) {
            this._colNodes[_i] = afterColNode;
          }
        }
      } else {
        // The was no existing node so create a new one.
        colNode = {
          name: 'col',
          attributes: {
            min: columnNumber,
            max: columnNumber
          },
          children: []
        };
        this._colNodes[columnNumber] = colNode;
      } // Create the new column and cache it.


      var column = new Column(this, colNode);
      this._columns[columnNumber] = column;
      return column;
    }
    /**
     * Gets a defined name scoped to the sheet.
     * @param {string} name - The defined name.
     * @returns {undefined|string|Cell|Range|Row|Column} What the defined name refers to or undefined if not found. Will return the string formula if not a Row, Column, Cell, or Range.
     */

    /**
    * Set a defined name scoped to the sheet.
    * @param {string} name - The defined name.
    * @param {string|Cell|Range|Row|Column} refersTo - What the name refers to.
    * @returns {Workbook} The workbook.
    */

  }, {
    key: "definedName",
    value: function definedName() {
      var _this4 = this;

      return new ArgHandler("Workbook.definedName").case('string', function (name) {
        return _this4.workbook().scopedDefinedName(_this4, name);
      }).case(['string', '*'], function (name, refersTo) {
        _this4.workbook().scopedDefinedName(_this4, name, refersTo);

        return _this4;
      }).handle(arguments);
    }
    /**
     * Deletes the sheet and returns the parent workbook.
     * @returns {Workbook} The workbook.
     */

  }, {
    key: "delete",
    value: function _delete() {
      this.workbook().deleteSheet(this);
      return this.workbook();
    }
    /**
     * Find the given pattern in the sheet and optionally replace it.
     * @param {string|RegExp} pattern - The pattern to look for. Providing a string will result in a case-insensitive substring search. Use a RegExp for more sophisticated searches.
     * @param {string|function} [replacement] - The text to replace or a String.replace callback function. If pattern is a string, all occurrences of the pattern in each cell will be replaced.
     * @returns {Array.<Cell>} The matching cells.
     */

  }, {
    key: "find",
    value: function find(pattern, replacement) {
      pattern = regexify(pattern);
      var matches = [];

      this._rows.forEach(function (row) {
        if (!row) return;
        matches = matches.concat(row.find(pattern, replacement));
      });

      return matches;
    }
    /**
     * Gets a value indicating whether this sheet's grid lines are visible.
     * @returns {boolean} True if selected, false if not.
     */

    /**
    * Sets whether this sheet's grid lines are visible.
    * @param {boolean} selected - True to make visible, false to hide.
    * @returns {Sheet} The sheet.
    */

  }, {
    key: "gridLinesVisible",
    value: function gridLinesVisible() {
      var _this5 = this;

      var sheetViewNode = this._getOrCreateSheetViewNode();

      return new ArgHandler('Sheet.gridLinesVisible').case(function () {
        return sheetViewNode.attributes.showGridLines === 1 || sheetViewNode.attributes.showGridLines === undefined;
      }).case('boolean', function (visible) {
        sheetViewNode.attributes.showGridLines = visible ? 1 : 0;
        return _this5;
      }).handle(arguments);
    }
    /**
     * Gets a value indicating if the sheet is hidden or not.
     * @returns {boolean|string} True if hidden, false if visible, and 'very' if very hidden.
     */

    /**
    * Set whether the sheet is hidden or not.
    * @param {boolean|string} hidden - True to hide, false to show, and 'very' to make very hidden.
    * @returns {Sheet} The sheet.
    */

  }, {
    key: "hidden",
    value: function hidden() {
      var _this6 = this;

      return new ArgHandler('Sheet.hidden').case(function () {
        if (_this6._idNode.attributes.state === 'hidden') return true;
        if (_this6._idNode.attributes.state === 'veryHidden') return "very";
        return false;
      }).case('*', function (hidden) {
        if (hidden) {
          var visibleSheets = _.filter(_this6.workbook().sheets(), function (sheet) {
            return !sheet.hidden();
          });

          if (visibleSheets.length === 1 && visibleSheets[0] === _this6) {
            throw new Error("This sheet may not be hidden as a workbook must contain at least one visible sheet.");
          } // If activate, activate the first other visible sheet.


          if (_this6.active()) {
            var activeIndex = visibleSheets[0] === _this6 ? 1 : 0;
            visibleSheets[activeIndex].active(true);
          }
        }

        if (hidden === 'very') _this6._idNode.attributes.state = 'veryHidden';else if (hidden) _this6._idNode.attributes.state = 'hidden';else delete _this6._idNode.attributes.state;
        return _this6;
      }).handle(arguments);
    }
    /**
     * Move the sheet.
     * @param {number|string|Sheet} [indexOrBeforeSheet] The index to move the sheet to or the sheet (or name of sheet) to move this sheet before. Omit this argument to move to the end of the workbook.
     * @returns {Sheet} The sheet.
     */

  }, {
    key: "move",
    value: function move(indexOrBeforeSheet) {
      this.workbook().moveSheet(this, indexOrBeforeSheet);
      return this;
    }
    /**
     * Get the name of the sheet.
     * @returns {string} The sheet name.
     */

    /**
    * Set the name of the sheet. *Note: this method does not rename references to the sheet so formulas, etc. can be broken. Use with caution!*
    * @param {string} name - The name to set to the sheet.
    * @returns {Sheet} The sheet.
    */

  }, {
    key: "name",
    value: function name() {
      var _this7 = this;

      return new ArgHandler('Sheet.name').case(function () {
        return "".concat(_this7._idNode.attributes.name);
      }).case('string', function (name) {
        _this7._idNode.attributes.name = name;
        return _this7;
      }).handle(arguments);
    }
    /**
     * Gets a range from the given range address.
     * @param {string} address - The range address (e.g. 'A1:B3').
     * @returns {Range} The range.
     */

    /**
    * Gets a range from the given cells or cell addresses.
    * @param {string|Cell} startCell - The starting cell or cell address (e.g. 'A1').
    * @param {string|Cell} endCell - The ending cell or cell address (e.g. 'B3').
    * @returns {Range} The range.
    */

    /**
    * Gets a range from the given row numbers and column names or numbers.
    * @param {number} startRowNumber - The starting cell row number.
    * @param {string|number} startColumnNameOrNumber - The starting cell column name or number.
    * @param {number} endRowNumber - The ending cell row number.
    * @param {string|number} endColumnNameOrNumber - The ending cell column name or number.
    * @returns {Range} The range.
    */

  }, {
    key: "range",
    value: function range() {
      var _this8 = this;

      return new ArgHandler('Sheet.range').case('string', function (address) {
        var ref = addressConverter.fromAddress(address);
        if (ref.type !== 'range') throw new Error('Sheet.range: Invalid address');
        return _this8.range(ref.startRowNumber, ref.startColumnNumber, ref.endRowNumber, ref.endColumnNumber);
      }).case(['*', '*'], function (startCell, endCell) {
        if (typeof startCell === "string") startCell = _this8.cell(startCell);
        if (typeof endCell === "string") endCell = _this8.cell(endCell);
        return new Range(startCell, endCell);
      }).case(['number', '*', 'number', '*'], function (startRowNumber, startColumnNameOrNumber, endRowNumber, endColumnNameOrNumber) {
        return _this8.range(_this8.cell(startRowNumber, startColumnNameOrNumber), _this8.cell(endRowNumber, endColumnNameOrNumber));
      }).handle(arguments);
    }
    /**
     * Unsets sheet autoFilter.
     * @returns {Sheet} This sheet.
     */

    /**
    * Sets sheet autoFilter to a Range.
    * @param {Range} range - The autoFilter range.
    * @returns {Sheet} This sheet.
    */

  }, {
    key: "autoFilter",
    value: function autoFilter(range) {
      this._autoFilter = range;
      return this;
    }
    /**
     * Gets the row with the given number.
     * @param {number} rowNumber - The row number.
     * @returns {Row} The row with the given number.
     */

  }, {
    key: "row",
    value: function row(rowNumber) {
      if (rowNumber < 1) throw new RangeError("Invalid row number ".concat(rowNumber, ". Remember that spreadsheets use 1-based indexing."));
      if (this._rows[rowNumber]) return this._rows[rowNumber];
      var rowNode = {
        name: 'row',
        attributes: {
          r: rowNumber
        },
        children: []
      };
      var row = new Row(this, rowNode);
      this._rows[rowNumber] = row;
      return row;
    }
    /**
     * Get the tab color. (See style [Color](#color).)
     * @returns {undefined|Color} The color or undefined if not set.
     */

    /**
    * Sets the tab color. (See style [Color](#color).)
    * @returns {Color|string|number} color - Color of the tab. If string, will set an RGB color. If number, will set a theme color.
    */

  }, {
    key: "tabColor",
    value: function tabColor() {
      var _this9 = this;

      return new ArgHandler("Sheet.tabColor").case(function () {
        var tabColorNode = xmlq.findChild(_this9._sheetPrNode, "tabColor");
        if (!tabColorNode) return;
        var color = {};
        if (tabColorNode.attributes.hasOwnProperty('rgb')) color.rgb = tabColorNode.attributes.rgb;else if (tabColorNode.attributes.hasOwnProperty('theme')) color.theme = tabColorNode.attributes.theme;else if (tabColorNode.attributes.hasOwnProperty('indexed')) color.rgb = colorIndexes[tabColorNode.attributes.indexed];
        if (tabColorNode.attributes.hasOwnProperty('tint')) color.tint = tabColorNode.attributes.tint;
        return color;
      }).case("string", function (rgb) {
        return _this9.tabColor({
          rgb: rgb
        });
      }).case("integer", function (theme) {
        return _this9.tabColor({
          theme: theme
        });
      }).case("nil", function () {
        xmlq.removeChild(_this9._sheetPrNode, "tabColor");
        return _this9;
      }).case("object", function (color) {
        var tabColorNode = xmlq.appendChildIfNotFound(_this9._sheetPrNode, "tabColor");
        xmlq.setAttributes(tabColorNode, {
          rgb: color.rgb && color.rgb.toUpperCase(),
          indexed: null,
          theme: color.theme,
          tint: color.tint
        });
        return _this9;
      }).handle(arguments);
    }
    /**
     * Gets a value indicating whether this sheet is selected.
     * @returns {boolean} True if selected, false if not.
     */

    /**
    * Sets whether this sheet is selected.
    * @param {boolean} selected - True to select, false to deselected.
    * @returns {Sheet} The sheet.
    */

  }, {
    key: "tabSelected",
    value: function tabSelected() {
      var _this10 = this;

      var sheetViewNode = this._getOrCreateSheetViewNode();

      return new ArgHandler('Sheet.tabSelected').case(function () {
        return sheetViewNode.attributes.tabSelected === 1;
      }).case('boolean', function (selected) {
        if (selected) sheetViewNode.attributes.tabSelected = 1;else delete sheetViewNode.attributes.tabSelected;
        return _this10;
      }).handle(arguments);
    }
    /**
     * Gets a value indicating whether this sheet is rtl (Right To Left).
     * @returns {boolean} True if rtl, false if ltr.
     */

    /**
    * Sets whether this sheet is rtl.
    * @param {boolean} rtl - True to rtl, false to ltr (Left To Right).
    * @returns {Sheet} The sheet.
    */

  }, {
    key: "rightToLeft",
    value: function rightToLeft() {
      var _this11 = this;

      var sheetViewNode = this._getOrCreateSheetViewNode();

      return new ArgHandler('Sheet.rightToLeft').case(function () {
        return sheetViewNode.attributes.rightToLeft;
      }).case('boolean', function (rtl) {
        if (rtl) sheetViewNode.attributes.rightToLeft = true;else delete sheetViewNode.attributes.rightToLeft;
        return _this11;
      }).handle(arguments);
    }
    /**
     * Get the range of cells in the sheet that have contained a value or style at any point. Useful for extracting the entire sheet contents.
     * @returns {Range|undefined} The used range or undefined if no cells in the sheet are used.
     */

  }, {
    key: "usedRange",
    value: function usedRange() {
      var minRowNumber = _.findIndex(this._rows);

      var maxRowNumber = this._rows.length - 1;
      var minColumnNumber = 0;
      var maxColumnNumber = 0;

      for (var i = 0; i < this._rows.length; i++) {
        var row = this._rows[i];
        if (!row) continue;
        var minUsedColumnNumber = row.minUsedColumnNumber();
        var maxUsedColumnNumber = row.maxUsedColumnNumber();
        if (minUsedColumnNumber > 0 && (!minColumnNumber || minUsedColumnNumber < minColumnNumber)) minColumnNumber = minUsedColumnNumber;
        if (maxUsedColumnNumber > 0 && (!maxColumnNumber || maxUsedColumnNumber > maxColumnNumber)) maxColumnNumber = maxUsedColumnNumber;
      } // Return undefined if nothing in the sheet is used.


      if (minRowNumber <= 0 || minColumnNumber <= 0 || maxRowNumber <= 0 || maxColumnNumber <= 0) return;
      return this.range(minRowNumber, minColumnNumber, maxRowNumber, maxColumnNumber);
    }
    /**
     * Gets the parent workbook.
     * @returns {Workbook} The parent workbook.
     */

  }, {
    key: "workbook",
    value: function workbook() {
      return this._workbook;
    }
    /**
     * Gets all page breaks.
     * @returns {{}} the object holds both vertical and horizontal PageBreaks.
     */

  }, {
    key: "pageBreaks",
    value: function pageBreaks() {
      return this._pageBreaks;
    }
    /**
     * Gets the vertical page breaks.
     * @returns {PageBreaks} vertical PageBreaks.
     */

  }, {
    key: "verticalPageBreaks",
    value: function verticalPageBreaks() {
      return this._pageBreaks.colBreaks;
    }
    /**
     * Gets the horizontal page breaks.
     * @returns {PageBreaks} horizontal PageBreaks.
     */

  }, {
    key: "horizontalPageBreaks",
    value: function horizontalPageBreaks() {
      return this._pageBreaks.rowBreaks;
    }
    /* INTERNAL */

    /**
     * Clear cells that are using a given shared formula ID.
     * @param {number} sharedFormulaId - The shared formula ID.
     * @returns {undefined}
     * @ignore
     */

  }, {
    key: "clearCellsUsingSharedFormula",
    value: function clearCellsUsingSharedFormula(sharedFormulaId) {
      this._rows.forEach(function (row) {
        if (!row) return;
        row.clearCellsUsingSharedFormula(sharedFormulaId);
      });
    }
    /**
     * Get an existing column style ID.
     * @param {number} columnNumber - The column number.
     * @returns {undefined|number} The style ID.
     * @ignore
     */

  }, {
    key: "existingColumnStyleId",
    value: function existingColumnStyleId(columnNumber) {
      // This will work after setting Column.style because Column updates the attributes live.
      var colNode = this._colNodes[columnNumber];
      return colNode && colNode.attributes.style;
    }
    /**
     * Call a callback for each column number that has a node defined for it.
     * @param {Function} callback - The callback.
     * @returns {undefined}
     * @ignore
     */

  }, {
    key: "forEachExistingColumnNumber",
    value: function forEachExistingColumnNumber(callback) {
      _.forEach(this._colNodes, function (node, columnNumber) {
        if (!node) return;
        callback(columnNumber);
      });
    }
    /**
     * Call a callback for each existing row.
     * @param {Function} callback - The callback.
     * @returns {undefined}
     * @ignore
     */

  }, {
    key: "forEachExistingRow",
    value: function forEachExistingRow(callback) {
      _.forEach(this._rows, function (row, rowNumber) {
        if (row) callback(row, rowNumber);
      });

      return this;
    }
    /**
     * Get the hyperlink attached to the cell with the given address.
     * @param {string} address - The address of the hyperlinked cell.
     * @returns {string|undefined} The hyperlink or undefined if not set.
     */

    /**
    * Set the hyperlink on the cell with the given address.
    * @param {string} address - The address of the hyperlinked cell.
    * @param {string} hyperlink - The hyperlink to set or undefined to clear.
    * @param {boolean} [internal] - The flag to force hyperlink to be internal. If true, then autodetect is skipped.
    * @returns {Sheet} The sheet.
    */

    /**
    * Set the hyperlink on the cell with the given address. If opts is a Cell an internal hyperlink is added.
    * @param {string} address - The address of the hyperlinked cell.
    * @param {object|Cell} opts - Options.
    * @returns {Sheet} The sheet.
    * @ignore
    */

    /**
    * Set the hyperlink on the cell with the given address and options.
    * @param {string} address - The address of the hyperlinked cell.
    * @param {{}|Cell} opts - Options or Cell. If opts is a Cell then an internal hyperlink is added.
    * @param {string|Cell} [opts.hyperlink] - The hyperlink to set, can be a Cell or an internal/external string.
    * @param {string} [opts.tooltip] - Additional text to help the user understand more about the hyperlink.
    * @param {string} [opts.email] - Email address, ignored if opts.hyperlink is set.
    * @param {string} [opts.emailSubject] - Email subject, ignored if opts.hyperlink is set.
    * @returns {Sheet} The sheet.
    */

  }, {
    key: "hyperlink",
    value: function hyperlink() {
      var _this12 = this;

      return new ArgHandler('Sheet.hyperlink').case('string', function (address) {
        var hyperlinkNode = _this12._hyperlinks[address];
        if (!hyperlinkNode) return;

        var relationship = _this12._relationships.findById(hyperlinkNode.attributes['r:id']);

        return relationship && relationship.attributes.Target;
      }).case(['string', 'nil'], function (address) {
        // TODO: delete relationship
        delete _this12._hyperlinks[address];
        return _this12;
      }).case(['string', 'string'], function (address, hyperlink) {
        return _this12.hyperlink(address, hyperlink, false);
      }).case(['string', 'string', 'boolean'], function (address, hyperlink, internal) {
        var isHyperlinkInternalAddress = internal || addressConverter.fromAddress(hyperlink);
        var nodeAttributes;

        if (isHyperlinkInternalAddress) {
          nodeAttributes = {
            ref: address,
            location: hyperlink,
            display: hyperlink
          };
        } else {
          var relationship = _this12._relationships.add("hyperlink", hyperlink, "External");

          nodeAttributes = {
            ref: address,
            'r:id': relationship.attributes.Id
          };
        }

        _this12._hyperlinks[address] = {
          name: 'hyperlink',
          attributes: nodeAttributes,
          children: []
        };
        return _this12;
      }).case(['string', 'object'], function (address, opts) {
        if (opts instanceof Cell) {
          var cell = opts;
          var hyperlink = cell.address({
            includeSheetName: true
          });

          _this12.hyperlink(address, hyperlink, true);
        } else if (opts.hyperlink) {
          _this12.hyperlink(address, opts.hyperlink);
        } else if (opts.email) {
          var email = opts.email;
          var subject = opts.emailSubject || '';

          _this12.hyperlink(address, encodeURI("mailto:".concat(email, "?subject=").concat(subject)));
        }

        var hyperlinkNode = _this12._hyperlinks[address];

        if (hyperlinkNode) {
          if (opts.tooltip) {
            hyperlinkNode.attributes.tooltip = opts.tooltip;
          }
        }

        return _this12;
      }).handle(arguments);
    }
    /**
     * Increment and return the max shared formula ID.
     * @returns {number} The new max shared formula ID.
     * @ignore
     */

  }, {
    key: "incrementMaxSharedFormulaId",
    value: function incrementMaxSharedFormulaId() {
      return ++this._maxSharedFormulaId;
    }
    /**
     * Get a value indicating whether the cells in the given address are merged.
     * @param {string} address - The address to check.
     * @returns {boolean} True if merged, false if not merged.
     * @ignore
     */

    /**
    * Merge/unmerge cells by adding/removing a mergeCell entry.
    * @param {string} address - The address to merge.
    * @param {boolean} merged - True to merge, false to unmerge.
    * @returns {Sheet} The sheet.
    * @ignore
    */

  }, {
    key: "merged",
    value: function merged() {
      var _this13 = this;

      return new ArgHandler('Sheet.merge').case('string', function (address) {
        return _this13._mergeCells.hasOwnProperty(address);
      }).case(['string', '*'], function (address, merge) {
        if (merge) {
          _this13._mergeCells[address] = {
            name: 'mergeCell',
            attributes: {
              ref: address
            },
            children: []
          };
        } else {
          delete _this13._mergeCells[address];
        }

        return _this13;
      }).handle(arguments);
    }
    /**
     * Gets a Object or undefined of the cells in the given address.
     * @param {string} address - The address to check.
     * @returns {object|boolean} Object or false if not set
     * @ignore
     */

    /**
    * Removes dataValidation at the given address
    * @param {string} address - The address to remove.
    * @param {boolean} obj - false to delete.
    * @returns {boolean} true if removed.
    * @ignore
    */

    /**
    * Add dataValidation to cells at the given address if object or string
    * @param {string} address - The address to set.
    * @param {object|string} obj - Object or String to set
    * @returns {Sheet} The sheet.
    * @ignore
    */

  }, {
    key: "dataValidation",
    value: function dataValidation() {
      var _this14 = this;

      return new ArgHandler('Sheet.dataValidation').case('string', function (address) {
        if (_this14._dataValidations[address]) {
          return {
            type: _this14._dataValidations[address].attributes.type,
            allowBlank: _this14._dataValidations[address].attributes.allowBlank,
            showInputMessage: _this14._dataValidations[address].attributes.showInputMessage,
            prompt: _this14._dataValidations[address].attributes.prompt,
            promptTitle: _this14._dataValidations[address].attributes.promptTitle,
            showErrorMessage: _this14._dataValidations[address].attributes.showErrorMessage,
            error: _this14._dataValidations[address].attributes.error,
            errorTitle: _this14._dataValidations[address].attributes.errorTitle,
            operator: _this14._dataValidations[address].attributes.operator,
            formula1: _this14._dataValidations[address].children[0].children[0],
            formula2: _this14._dataValidations[address].children[1] ? _this14._dataValidations[address].children[1].children[0] : undefined
          };
        } else {
          return false;
        }
      }).case(['string', 'boolean'], function (address, obj) {
        if (_this14._dataValidations[address]) {
          if (obj === false) return delete _this14._dataValidations[address];
        } else {
          return false;
        }
      }).case(['string', '*'], function (address, obj) {
        if (typeof obj === 'string') {
          _this14._dataValidations[address] = {
            name: 'dataValidation',
            attributes: {
              type: 'list',
              allowBlank: false,
              showInputMessage: false,
              prompt: '',
              promptTitle: '',
              showErrorMessage: false,
              error: '',
              errorTitle: '',
              operator: '',
              sqref: address
            },
            children: [{
              name: 'formula1',
              atrributes: {},
              children: [obj]
            }, {
              name: 'formula2',
              atrributes: {},
              children: ['']
            }]
          };
        } else if (_typeof(obj) === 'object') {
          _this14._dataValidations[address] = {
            name: 'dataValidation',
            attributes: {
              type: obj.type ? obj.type : 'list',
              allowBlank: obj.allowBlank,
              showInputMessage: obj.showInputMessage,
              prompt: obj.prompt,
              promptTitle: obj.promptTitle,
              showErrorMessage: obj.showErrorMessage,
              error: obj.error,
              errorTitle: obj.errorTitle,
              operator: obj.operator,
              sqref: address
            },
            children: [{
              name: 'formula1',
              atrributes: {},
              children: [obj.formula1]
            }, {
              name: 'formula2',
              atrributes: {},
              children: [obj.formula2]
            }]
          };
        }

        return _this14;
      }).handle(arguments);
    }
    /**
     * Convert the sheet to a collection of XML objects.
     * @returns {{}} The XML forms.
     * @ignore
     */

  }, {
    key: "toXmls",
    value: function toXmls() {
      var _this15 = this;

      // Shallow clone the node so we don't have to remove these children later if they don't belong.
      var node = _.clone(this._node);

      node.children = node.children.slice(); // Add the columns if needed.

      this._colsNode.children = _.filter(this._colNodes, function (colNode, i) {
        // Columns should only be present if they have attributes other than min/max.
        return colNode && i === colNode.attributes.min && Object.keys(colNode.attributes).length > 2;
      });

      if (this._colsNode.children.length) {
        xmlq.insertInOrder(node, this._colsNode, nodeOrder);
      } // Add the hyperlinks if needed.


      this._hyperlinksNode.children = _.values(this._hyperlinks);

      if (this._hyperlinksNode.children.length) {
        xmlq.insertInOrder(node, this._hyperlinksNode, nodeOrder);
      } // Add the printOptions if needed.


      if (this._printOptionsNode) {
        if (Object.keys(this._printOptionsNode.attributes).length) {
          xmlq.insertInOrder(node, this._printOptionsNode, nodeOrder);
        }
      } // Add the pageMargins if needed.


      if (this._pageMarginsNode && this._pageMarginsPresetName) {
        // Clone to preserve the current state of this sheet.
        var childNode = _.clone(this._pageMarginsNode);

        if (Object.keys(this._pageMarginsNode.attributes).length) {
          // Fill in any missing attribute values with presets.
          childNode.attributes = _.assign(this._pageMarginsPresets[this._pageMarginsPresetName], this._pageMarginsNode.attributes);
        } else {
          // No need to fill in, all attributes is currently empty, simply replace.
          childNode.attributes = this._pageMarginsPresets[this._pageMarginsPresetName];
        }

        xmlq.insertInOrder(node, childNode, nodeOrder);
      } // Add the merge cells if needed.


      this._mergeCellsNode.children = _.values(this._mergeCells);

      if (this._mergeCellsNode.children.length) {
        xmlq.insertInOrder(node, this._mergeCellsNode, nodeOrder);
      } // Add the DataValidation cells if needed.


      this._dataValidationsNode.children = _.values(this._dataValidations);

      if (this._dataValidationsNode.children.length) {
        xmlq.insertInOrder(node, this._dataValidationsNode, nodeOrder);
      }

      if (this._autoFilter) {
        xmlq.insertInOrder(node, {
          name: "autoFilter",
          children: [],
          attributes: {
            ref: this._autoFilter.address()
          }
        }, nodeOrder);
      } // Add the PageBreaks nodes if needed.


      ['colBreaks', 'rowBreaks'].forEach(function (name) {
        var breaks = _this15["_".concat(name, "Node")];

        if (breaks.attributes.count) {
          xmlq.insertInOrder(node, breaks, nodeOrder);
        }
      });
      return {
        id: this._idNode,
        sheet: node,
        relationships: this._relationships
      };
    }
    /**
     * Update the max shared formula ID to the given value if greater than current.
     * @param {number} sharedFormulaId - The new shared formula ID.
     * @returns {undefined}
     * @ignore
     */

  }, {
    key: "updateMaxSharedFormulaId",
    value: function updateMaxSharedFormulaId(sharedFormulaId) {
      if (sharedFormulaId > this._maxSharedFormulaId) {
        this._maxSharedFormulaId = sharedFormulaId;
      }
    }
    /**
     * Get the print option given a valid print option attribute.
     * @param {string} attributeName - Attribute name of the printOptions.
     *   gridLines - Used in conjunction with gridLinesSet. If both gridLines and gridlinesSet are true, then grid lines shall print. Otherwise, they shall not (i.e., one or both have false values).
     *   gridLinesSet - Used in conjunction with gridLines. If both gridLines and gridLinesSet are true, then grid lines shall print. Otherwise, they shall not (i.e., one or both have false values).
     *   headings - Print row and column headings.
     *   horizontalCentered - Center on page horizontally when printing.
     *   verticalCentered - Center on page vertically when printing.
     * @returns {boolean}
     */

    /**
    * Set the print option given a valid print option attribute and a value.
    * @param {string} attributeName - Attribute name of the printOptions. See get print option for list of valid attributes.
    * @param {undefined|boolean} attributeEnabled - If `undefined` or `false` then the attribute is removed, otherwise the print option is enabled.
    * @returns {Sheet} The sheet.
    */

  }, {
    key: "printOptions",
    value: function printOptions() {
      var _this16 = this;

      var supportedAttributeNames = ['gridLines', 'gridLinesSet', 'headings', 'horizontalCentered', 'verticalCentered'];

      var checkAttributeName = this._getCheckAttributeNameHelper('printOptions', supportedAttributeNames);

      return new ArgHandler('Sheet.printOptions').case(['string'], function (attributeName) {
        checkAttributeName(attributeName);
        return _this16._printOptionsNode.attributes[attributeName] === 1;
      }).case(['string', 'nil'], function (attributeName) {
        checkAttributeName(attributeName);
        delete _this16._printOptionsNode.attributes[attributeName];
        return _this16;
      }).case(['string', 'boolean'], function (attributeName, attributeEnabled) {
        checkAttributeName(attributeName);

        if (attributeEnabled) {
          _this16._printOptionsNode.attributes[attributeName] = 1;
          return _this16;
        } else {
          return _this16.printOptions(attributeName, undefined);
        }
      }).handle(arguments);
    }
    /**
     * Get the print option for the gridLines attribute value.
     * @returns {boolean}
     */

    /**
    * Set the print option for the gridLines attribute value.
    * @param {undefined|boolean} enabled - If `undefined` or `false` then attribute is removed, otherwise gridLines is enabled.
    * @returns {Sheet} The sheet.
    */

  }, {
    key: "printGridLines",
    value: function printGridLines() {
      var _this17 = this;

      return new ArgHandler('Sheet.gridLines').case(function () {
        return _this17.printOptions('gridLines') && _this17.printOptions('gridLinesSet');
      }).case(['nil'], function () {
        _this17.printOptions('gridLines', undefined);

        _this17.printOptions('gridLinesSet', undefined);

        return _this17;
      }).case(['boolean'], function (enabled) {
        _this17.printOptions('gridLines', enabled);

        _this17.printOptions('gridLinesSet', enabled);

        return _this17;
      }).handle(arguments);
    }
    /**
     * Get the page margin given a valid attribute name.
     * If the value is not yet defined, then it will return the current preset value.
     * @param {string} attributeName - Attribute name of the pageMargins.
     *     left - Left Page Margin in inches.
     *     right - Right page margin in inches.
     *     top - Top Page Margin in inches.
     *     buttom - Bottom Page Margin in inches.
     *     footer - Footer Page Margin in inches.
     *     header - Header Page Margin in inches.
     * @returns {number} the attribute value.
     */

    /**
    * Set the page margin (or override the preset) given an attribute name and a value.
    * @param {string} attributeName - Attribute name of the pageMargins. See get page margin for list of valid attributes.
    * @param {undefined|number|string} attributeStringValue - If `undefined` then set back to preset value, otherwise, set the given attribute value.
    * @returns {Sheet} The sheet.
    */

  }, {
    key: "pageMargins",
    value: function pageMargins() {
      var _this18 = this;

      if (this.pageMarginsPreset() === undefined) {
        throw new Error('Sheet.pageMargins: preset is undefined.');
      }

      var supportedAttributeNames = ['left', 'right', 'top', 'bottom', 'header', 'footer'];

      var checkAttributeName = this._getCheckAttributeNameHelper('pageMargins', supportedAttributeNames);

      var checkRange = this._getCheckRangeHelper('pageMargins', 0, undefined);

      return new ArgHandler('Sheet.pageMargins').case(['string'], function (attributeName) {
        checkAttributeName(attributeName);
        var attributeValue = _this18._pageMarginsNode.attributes[attributeName];

        if (attributeValue !== undefined) {
          return parseFloat(attributeValue);
        } else if (_this18._pageMarginsPresetName) {
          return parseFloat(_this18._pageMarginsPresets[_this18._pageMarginsPresetName][attributeName]);
        } else {
          return undefined;
        }
      }).case(['string', 'nil'], function (attributeName) {
        checkAttributeName(attributeName);
        delete _this18._pageMarginsNode.attributes[attributeName];
        return _this18;
      }).case(['string', 'number'], function (attributeName, attributeNumberValue) {
        checkAttributeName(attributeName);
        checkRange(attributeNumberValue);
        _this18._pageMarginsNode.attributes[attributeName] = attributeNumberValue;
        return _this18;
      }).case(['string', 'string'], function (attributeName, attributeStringValue) {
        return _this18.pageMargins(attributeName, parseFloat(attributeStringValue));
      }).handle(arguments);
    }
    /**
     * Page margins preset is a set of page margins associated with a name.
     * The page margin preset acts as a fallback when not explicitly defined by `Sheet.pageMargins`.
     * If a sheet already contains page margins, it attempts to auto-detect, otherwise they are defined as the template preset.
     * If no page margins exist, then the preset is undefined and will not be included in the output of `Sheet.toXmls`.
     * Available presets include: normal, wide, narrow, template.
     *
     * Get the page margins preset name. The registered name of a predefined set of attributes.
     * @returns {string} The preset name.
     */

    /**
    * Set the page margins preset by name, clearing any existing/temporary attribute values.
    * @param {undefined|string} presetName - The preset name. If `undefined`, page margins will not be included in the output of `Sheet.toXmls`.
    * @returns {Sheet} The sheet.
    */

    /**
    * Set a new page margins preset by name and attributes object.
    * @param {string} presetName - The preset name.
    * @param {object} presetAttributes - The preset attributes.
    * @returns {Sheet} The sheet.
    */

  }, {
    key: "pageMarginsPreset",
    value: function pageMarginsPreset() {
      var _this19 = this;

      return new ArgHandler('Sheet.pageMarginsPreset').case(function () {
        return _this19._pageMarginsPresetName;
      }).case(['nil'], function () {
        // Remove all preset overrides and exclude from sheet
        _this19._pageMarginsPresetName = undefined; // Remove all preset overrides

        _this19._pageMarginsNode.attributes = {};
        return _this19;
      }).case(['string'], function (presetName) {
        var checkPresetName = _this19._getCheckAttributeNameHelper('pageMarginsPreset', Object.keys(_this19._pageMarginsPresets));

        checkPresetName(presetName); // Change to new preset

        _this19._pageMarginsPresetName = presetName; // Remove all preset overrides

        _this19._pageMarginsNode.attributes = {};
        return _this19;
      }).case(['string', 'object'], function (presetName, presetAttributes) {
        if (_this19._pageMarginsPresets.hasOwnProperty(presetName)) {
          throw new Error("Sheet.pageMarginsPreset: The preset ".concat(presetName, " already exists!"));
        } // Validate preset attribute keys.


        var pageMarginsAttributeNames = ['left', 'right', 'top', 'bottom', 'header', 'footer'];

        var isValidPresetAttributeKeys = _.isEqual(_.sortBy(pageMarginsAttributeNames), _.sortBy(Object.keys(presetAttributes)));

        if (isValidPresetAttributeKeys === false) {
          throw new Error("Sheet.pageMarginsPreset: Invalid preset attributes for one or key(s)! - \"".concat(Object.keys(presetAttributes), "\""));
        } // Validate preset attribute values.


        _.forEach(function (attributeValue, attributeName) {
          var attributeNumberValue = parseFloat(attributeValue);

          if (_.isNaN(attributeNumberValue) || _.isNumber(attributeNumberValue) === false) {
            throw new Error("Sheet.pageMarginsPreset: Invalid preset attribute value! - \"".concat(attributeValue, "\""));
          }
        }); // Change to new preset


        _this19._pageMarginsPresetName = presetName; // Remove all preset overrides

        _this19._pageMarginsNode.attributes = {}; // Register the preset

        _this19._pageMarginsPresets[presetName] = presetAttributes;
        return _this19;
      }).handle(arguments);
    }
    /**
     * https://docs.microsoft.com/en-us/dotnet/api/documentformat.openxml.spreadsheet.pane?view=openxml-2.8.1
     * @typedef {Object} PaneOptions
     * @property {string} activePane=bottomRight Active Pane. The pane that is active.
     * @property {string} state Split State. Indicates whether the pane has horizontal / vertical splits,
     * and whether those splits are frozen.
     * @property {string} topLeftCell Top Left Visible Cell. Location of the top left visible cell in the bottom
     * right pane (when in Left-To-Right mode).
     * @property {number} xSplit (Horizontal Split Position) Horizontal position of the split, in 1/20th of a point;
     * 0 (zero) if none. If the pane is frozen, this value indicates the number of columns visible in the top pane.
     * @property {number} ySplit (Vertical Split Position) Vertical position of the split, in 1/20th of a point; 0
     * (zero) if none. If the pane is frozen, this value indicates the number of rows visible in the left pane.
     */

    /**
    * Gets sheet view pane options
    * @return {PaneOptions} sheet view pane options
    */

    /**
    * Sets sheet view pane options
    * @param {PaneOptions|null|undefined} paneOptions sheet view pane options
    * @return {Sheet} The sheet
    */

  }, {
    key: "panes",
    value: function panes() {
      var _this20 = this;

      var supportedStates = ['split', 'frozen', 'frozenSplit'];
      var supportedActivePanes = ['bottomLeft', 'bottomRight', 'topLeft', 'topRight'];

      var checkStateName = this._getCheckAttributeNameHelper('pane.state', supportedStates);

      var checkActivePane = this._getCheckAttributeNameHelper('pane.activePane', supportedActivePanes);

      var sheetViewNode = this._getOrCreateSheetViewNode();

      var paneNode = xmlq.findChild(sheetViewNode, 'pane');
      return new ArgHandler('Sheet.pane').case(function () {
        if (paneNode) {
          var result = _.cloneDeep(paneNode.attributes);

          if (!result.state) result.state = 'split';
          return result;
        }
      }).case(['nil'], function () {
        xmlq.removeChild(sheetViewNode, 'pane');
        return _this20;
      }).case(['object'], function (paneAttributes) {
        var attributes = _.assign({
          activePane: 'bottomRight'
        }, paneAttributes);

        checkStateName(attributes.state);
        checkActivePane(attributes.activePane);

        if (paneNode) {
          paneNode.attributes = attributes;
        } else {
          paneNode = {
            name: "pane",
            attributes: attributes,
            children: []
          };
          xmlq.appendChild(sheetViewNode, paneNode);
        }

        return _this20;
      }).handle(arguments);
    }
    /**
     * Freezes Panes for this sheet.
     * @param {number} xSplit the number of columns visible in the top pane. 0 (zero) if none.
     * @param {number} ySplit the number of rows visible in the left pane. 0 (zero) if none.
     * @return {Sheet} The sheet
     */

    /**
    * freezes Panes for this sheet.
    * @param {string} topLeftCell Top Left Visible Cell. Location of the top left visible cell in the bottom
    * right pane (when in Left-To-Right mode).
    * @return {Sheet} The sheet
    */

  }, {
    key: "freezePanes",
    value: function freezePanes() {
      var _this21 = this;

      return new ArgHandler('Sheet.feezePanes').case(['integer', 'integer'], function (xSplit, ySplit) {
        var topLeftCell = addressConverter.columnNumberToName(xSplit + 1) + (ySplit + 1);
        var activePane = xSplit === 0 ? 'bottomLeft' : 'bottomRight';
        activePane = ySplit === 0 ? 'topRight' : activePane;
        return _this21.panes({
          state: 'frozen',
          topLeftCell: topLeftCell,
          xSplit: xSplit,
          ySplit: ySplit,
          activePane: activePane
        });
      }).case(['string'], function (topLeftCell) {
        var ref = addressConverter.fromAddress(topLeftCell);
        var xSplit = ref.columnNumber - 1,
            ySplit = ref.rowNumber - 1;
        var activePane = xSplit === 0 ? 'bottomLeft' : 'bottomRight';
        activePane = ySplit === 0 ? 'topRight' : activePane;
        return _this21.panes({
          state: 'frozen',
          topLeftCell: topLeftCell,
          xSplit: xSplit,
          ySplit: ySplit,
          activePane: activePane
        });
      }).handle(arguments);
    }
    /**
     * Splits Panes for this sheet.
     * @param {number} xSplit (Horizontal Split Position) Horizontal position of the split,
     * in 1/20th of a point; 0 (zero) if none.
     * @param {number} ySplit (Vertical Split Position) VVertical position of the split,
     * in 1/20th of a point; 0 (zero) if none.
     * @return {Sheet} The sheet
     */

  }, {
    key: "splitPanes",
    value: function splitPanes(xSplit, ySplit) {
      return this.panes({
        state: 'split',
        xSplit: xSplit,
        ySplit: ySplit
      });
    }
    /**
     * resets to default sheet view panes.
     * @return {Sheet} The sheet
     */

  }, {
    key: "resetPanes",
    value: function resetPanes() {
      return this.panes(null);
    }
    /* PRIVATE */

    /**
     * Get a helper function to check that the attribute name provided is supported.
     * @param {string} functionName - Name of the parent function.
     * @param {array} supportedAttributeNames - Array of supported attribute name strings.
     * @returns {function} The helper function, which takes an attribute name. If the array of supported attribute names does not contain the given attribute name, then an Error is thrown.
     * @ignore
     */

  }, {
    key: "_getCheckAttributeNameHelper",
    value: function _getCheckAttributeNameHelper(functionName, supportedAttributeNames) {
      return function (attributeName) {
        if (!_.includes(supportedAttributeNames, attributeName)) {
          throw new Error("Sheet.".concat(functionName, ": \"").concat(attributeName, "\" is not supported."));
        }
      };
    }
    /**
     * Get a helper function to check that the value is of the expected type.
     * @param {string} functionName - Name of the parent function.
     * @param {string} valueType - A string produced by typeof.
     * @returns {function} The helper function, which takes a value. If the value type is not expected, a TypeError is thrown.
     * @ignore
     */

  }, {
    key: "_getCheckTypeHelper",
    value: function _getCheckTypeHelper(functionName, valueType) {
      return function (value) {
        if (_typeof(value) !== valueType) {
          throw new TypeError("Sheet.".concat(functionName, ": invalid type - value must be of type ").concat(valueType, "."));
        }
      };
    }
    /**
     * Get a helper function to check that the value is within the expected range.
     * @param {string} functionName - Name of the parent function.
     * @param {undefined|number} valueMin - The minimum value of the range. This value is range-inclusive.
     * @param {undefined|number} valueMax - The maximum value of the range. This value is range-exclusive.
     * @returns {function} The helper function, which takes a value. If the value type is not 'number', a TypeError is thrown. If the value is not within the range, a RangeError is thrown.
     * @ignore
     */

  }, {
    key: "_getCheckRangeHelper",
    value: function _getCheckRangeHelper(functionName, valueMin, valueMax) {
      var checkType = this._getCheckTypeHelper(functionName, 'number');

      return function (value) {
        checkType(value);

        if (valueMin !== undefined) {
          if (value < valueMin) {
            throw new RangeError("Sheet.".concat(functionName, ": value too small - value must be greater than or equal to ").concat(valueMin, "."));
          }
        }

        if (valueMax !== undefined) {
          if (valueMax <= value) {
            throw new RangeError("Sheet.".concat(functionName, ": value too large - value must be less than ").concat(valueMax, "."));
          }
        }
      };
    }
    /**
     * Get the sheet view node if it exists or create it if it doesn't.
     * @returns {{}} The sheet view node.
     * @private
     */

  }, {
    key: "_getOrCreateSheetViewNode",
    value: function _getOrCreateSheetViewNode() {
      var sheetViewsNode = xmlq.findChild(this._node, "sheetViews");

      if (!sheetViewsNode) {
        sheetViewsNode = {
          name: "sheetViews",
          attributes: {},
          children: [{
            name: "sheetView",
            attributes: {
              workbookViewId: 0
            },
            children: []
          }]
        };
        xmlq.insertInOrder(this._node, sheetViewsNode, nodeOrder);
      }

      return xmlq.findChild(sheetViewsNode, "sheetView");
    }
    /**
     * Initializes the sheet.
     * @param {Workbook} workbook - The parent workbook.
     * @param {{}} idNode - The sheet ID node (from the parent workbook).
     * @param {{}} node - The sheet node.
     * @param {{}} [relationshipsNode] - The optional sheet relationships node.
     * @returns {undefined}
     * @private
     */

  }, {
    key: "_init",
    value: function _init(workbook, idNode, node, relationshipsNode) {
      var _this22 = this;

      if (!node) {
        node = {
          name: "worksheet",
          attributes: {
            xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
            'xmlns:r': "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
            'xmlns:mc': "http://schemas.openxmlformats.org/markup-compatibility/2006",
            'mc:Ignorable': "x14ac",
            'xmlns:x14ac': "http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac"
          },
          children: [{
            name: "sheetData",
            attributes: {},
            children: []
          }]
        };
      }

      this._workbook = workbook;
      this._idNode = idNode;
      this._node = node;
      this._maxSharedFormulaId = -1;
      this._mergeCells = {};
      this._dataValidations = {};
      this._hyperlinks = {};
      this._autoFilter = null; // Create the relationships.

      this._relationships = new Relationships(relationshipsNode); // Delete the optional dimension node

      xmlq.removeChild(this._node, "dimension"); // Create the rows.

      this._rows = [];
      this._sheetDataNode = xmlq.findChild(this._node, "sheetData");

      this._sheetDataNode.children.forEach(function (rowNode) {
        var row = new Row(_this22, rowNode);
        _this22._rows[row.rowNumber()] = row;
      });

      this._sheetDataNode.children = this._rows; // Create the columns node.

      this._columns = [];
      this._colsNode = xmlq.findChild(this._node, "cols");

      if (this._colsNode) {
        xmlq.removeChild(this._node, this._colsNode);
      } else {
        this._colsNode = {
          name: 'cols',
          attributes: {},
          children: []
        };
      } // Cache the col nodes.


      this._colNodes = [];

      _.forEach(this._colsNode.children, function (colNode) {
        var min = colNode.attributes.min;
        var max = colNode.attributes.max;

        for (var i = min; i <= max; i++) {
          _this22._colNodes[i] = colNode;
        }
      }); // Create the sheet properties node.


      this._sheetPrNode = xmlq.findChild(this._node, "sheetPr");

      if (!this._sheetPrNode) {
        this._sheetPrNode = {
          name: 'sheetPr',
          attributes: {},
          children: []
        };
        xmlq.insertInOrder(this._node, this._sheetPrNode, nodeOrder);
      } // Create the merge cells.


      this._mergeCellsNode = xmlq.findChild(this._node, "mergeCells");

      if (this._mergeCellsNode) {
        xmlq.removeChild(this._node, this._mergeCellsNode);
      } else {
        this._mergeCellsNode = {
          name: 'mergeCells',
          attributes: {},
          children: []
        };
      }

      var mergeCellNodes = this._mergeCellsNode.children;
      this._mergeCellsNode.children = [];
      mergeCellNodes.forEach(function (mergeCellNode) {
        _this22._mergeCells[mergeCellNode.attributes.ref] = mergeCellNode;
      }); // Create the DataValidations.

      this._dataValidationsNode = xmlq.findChild(this._node, "dataValidations");

      if (this._dataValidationsNode) {
        xmlq.removeChild(this._node, this._dataValidationsNode);
      } else {
        this._dataValidationsNode = {
          name: 'dataValidations',
          attributes: {},
          children: []
        };
      }

      var dataValidationNodes = this._dataValidationsNode.children;
      this._dataValidationsNode.children = [];
      dataValidationNodes.forEach(function (dataValidationNode) {
        _this22._dataValidations[dataValidationNode.attributes.sqref] = dataValidationNode;
      }); // Create the hyperlinks.

      this._hyperlinksNode = xmlq.findChild(this._node, "hyperlinks");

      if (this._hyperlinksNode) {
        xmlq.removeChild(this._node, this._hyperlinksNode);
      } else {
        this._hyperlinksNode = {
          name: 'hyperlinks',
          attributes: {},
          children: []
        };
      }

      var hyperlinkNodes = this._hyperlinksNode.children;
      this._hyperlinksNode.children = [];
      hyperlinkNodes.forEach(function (hyperlinkNode) {
        _this22._hyperlinks[hyperlinkNode.attributes.ref] = hyperlinkNode;
      }); // Create the printOptions.

      this._printOptionsNode = xmlq.findChild(this._node, "printOptions");

      if (this._printOptionsNode) {
        xmlq.removeChild(this._node, this._printOptionsNode);
      } else {
        this._printOptionsNode = {
          name: 'printOptions',
          attributes: {},
          children: []
        };
      } // Create the pageMargins.


      this._pageMarginsPresets = {
        normal: {
          left: 0.7,
          right: 0.7,
          top: 0.75,
          bottom: 0.75,
          header: 0.3,
          footer: 0.3
        },
        wide: {
          left: 1,
          right: 1,
          top: 1,
          bottom: 1,
          header: 0.5,
          footer: 0.5
        },
        narrow: {
          left: 0.25,
          right: 0.25,
          top: 0.75,
          bottom: 0.75,
          header: 0.3,
          footer: 0.3
        }
      };
      this._pageMarginsNode = xmlq.findChild(this._node, "pageMargins");

      if (this._pageMarginsNode) {
        // Sheet has page margins, assume preset is template.
        this._pageMarginsPresetName = 'template'; // Search for a preset that matches existing attributes.

        for (var presetName in this._pageMarginsPresets) {
          if (_.isEqual(this._pageMarginsNode.attributes, this._pageMarginsPresets[presetName])) {
            this._pageMarginsPresetName = presetName;
            break;
          }
        } // If template preset, then register as template preset, and clear attributes.


        if (this._pageMarginsPresetName === 'template') {
          this._pageMarginsPresets.template = this._pageMarginsNode.attributes;
          this._pageMarginsNode.attributes = {};
        }

        xmlq.removeChild(this._node, this._pageMarginsNode);
      } else {
        // Sheet has no page margins, the preset assignment is therefore undefined.
        this._pageMarginsPresetName = undefined;
        this._pageMarginsNode = {
          name: 'pageMargins',
          attributes: {},
          children: []
        };
      } // Create the pageBreaks


      ['colBreaks', 'rowBreaks'].forEach(function (name) {
        _this22["_".concat(name, "Node")] = xmlq.findChild(_this22._node, name);

        if (_this22["_".concat(name, "Node")]) {
          xmlq.removeChild(_this22._node, _this22["_".concat(name, "Node")]);
        } else {
          _this22["_".concat(name, "Node")] = {
            name: name,
            children: [],
            attributes: {
              count: 0,
              manualBreakCount: 0
            }
          };
        }
      });
      this._pageBreaks = {
        colBreaks: new PageBreaks(this._colBreaksNode),
        rowBreaks: new PageBreaks(this._rowBreaksNode)
      };
    }
  }]);

  return Sheet;
}();

module.exports = Sheet;
/*
xl/workbook.xml

<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<worksheet ...>
    ...

    <printOptions headings="1" gridLines="1" />
    <pageMargins left="0.7" right="0.7" top="0.75" bottom="0.75" header="0.3" footer="0.3" />
    <pageSetup orientation="portrait" horizontalDpi="0" verticalDpi="0" />
</worksheet>
// */

},{"./ArgHandler":2,"./Cell":3,"./Column":4,"./PageBreaks":9,"./Range":10,"./Relationships":11,"./Row":14,"./addressConverter":23,"./colorIndexes":25,"./regexify":28,"./xmlq":29,"lodash":170}],17:[function(require,module,exports){
"use strict";
/* eslint camelcase:off */

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ArgHandler = require("./ArgHandler");

var _ = require("lodash");

var xmlq = require("./xmlq");

var colorIndexes = require("./colorIndexes");
/**
 * A style.
 * @ignore
 */


var Style = /*#__PURE__*/function () {
  /**
   * Creates a new instance of _Style.
   * @constructor
   * @param {StyleSheet} styleSheet - The styleSheet.
   * @param {number} id - The style ID.
   * @param {{}} xfNode - The xf node.
   * @param {{}} fontNode - The font node.
   * @param {{}} fillNode - The fill node.
   * @param {{}} borderNode - The border node.
   */
  function Style(styleSheet, id, xfNode, fontNode, fillNode, borderNode) {
    _classCallCheck(this, Style);

    this._styleSheet = styleSheet;
    this._id = id;
    this._xfNode = xfNode;
    this._fontNode = fontNode;
    this._fillNode = fillNode;
    this._borderNode = borderNode;
  }
  /**
   * Gets the style ID.
   * @returns {number} The ID.
   */


  _createClass(Style, [{
    key: "id",
    value: function id() {
      return this._id;
    }
    /**
     * Gets or sets a style.
     * @param {string} name - The style name.
     * @param {*} [value] - The value to set.
     * @returns {*|Style} The value if getting or the style if setting.
     */

  }, {
    key: "style",
    value: function style() {
      var _this = this;

      return new ArgHandler("_Style.style").case('string', function (name) {
        var getterName = "_get_".concat(name);
        if (!_this[getterName]) throw new Error("_Style.style: '".concat(name, "' is not a valid style"));
        return _this[getterName]();
      }).case(['string', '*'], function (name, value) {
        var setterName = "_set_".concat(name);
        if (!_this[setterName]) throw new Error("_Style.style: '".concat(name, "' is not a valid style"));

        _this[setterName](value);

        return _this;
      }).handle(arguments);
    }
  }, {
    key: "_getColor",
    value: function _getColor(node, name) {
      var child = xmlq.findChild(node, name);
      if (!child || !child.attributes) return;
      var color = {};
      if (child.attributes.hasOwnProperty('rgb')) color.rgb = child.attributes.rgb;else if (child.attributes.hasOwnProperty('theme')) color.theme = child.attributes.theme;else if (child.attributes.hasOwnProperty('indexed')) color.rgb = colorIndexes[child.attributes.indexed];
      if (child.attributes.hasOwnProperty('tint')) color.tint = child.attributes.tint;
      if (_.isEmpty(color)) return;
      return color;
    }
  }, {
    key: "_setColor",
    value: function _setColor(node, name, color) {
      if (typeof color === "string") color = {
        rgb: color
      };else if (typeof color === "number") color = {
        theme: color
      };
      xmlq.setChildAttributes(node, name, {
        rgb: color && color.rgb && color.rgb.toUpperCase(),
        indexed: null,
        theme: color && color.theme,
        tint: color && color.tint
      });
      xmlq.removeChildIfEmpty(node, 'color');
    }
  }, {
    key: "_get_bold",
    value: function _get_bold() {
      return xmlq.hasChild(this._fontNode, 'b');
    }
  }, {
    key: "_set_bold",
    value: function _set_bold(bold) {
      if (bold) xmlq.appendChildIfNotFound(this._fontNode, "b");else xmlq.removeChild(this._fontNode, 'b');
    }
  }, {
    key: "_get_italic",
    value: function _get_italic() {
      return xmlq.hasChild(this._fontNode, 'i');
    }
  }, {
    key: "_set_italic",
    value: function _set_italic(italic) {
      if (italic) xmlq.appendChildIfNotFound(this._fontNode, "i");else xmlq.removeChild(this._fontNode, 'i');
    }
  }, {
    key: "_get_underline",
    value: function _get_underline() {
      var uNode = xmlq.findChild(this._fontNode, 'u');
      return uNode ? uNode.attributes.val || true : false;
    }
  }, {
    key: "_set_underline",
    value: function _set_underline(underline) {
      if (underline) {
        var uNode = xmlq.appendChildIfNotFound(this._fontNode, "u");
        var val = typeof underline === 'string' ? underline : null;
        xmlq.setAttributes(uNode, {
          val: val
        });
      } else {
        xmlq.removeChild(this._fontNode, 'u');
      }
    }
  }, {
    key: "_get_strikethrough",
    value: function _get_strikethrough() {
      return xmlq.hasChild(this._fontNode, 'strike');
    }
  }, {
    key: "_set_strikethrough",
    value: function _set_strikethrough(strikethrough) {
      if (strikethrough) xmlq.appendChildIfNotFound(this._fontNode, "strike");else xmlq.removeChild(this._fontNode, 'strike');
    }
  }, {
    key: "_getFontVerticalAlignment",
    value: function _getFontVerticalAlignment() {
      return xmlq.getChildAttribute(this._fontNode, 'vertAlign', "val");
    }
  }, {
    key: "_setFontVerticalAlignment",
    value: function _setFontVerticalAlignment(alignment) {
      xmlq.setChildAttributes(this._fontNode, 'vertAlign', {
        val: alignment
      });
      xmlq.removeChildIfEmpty(this._fontNode, 'vertAlign');
    }
  }, {
    key: "_get_subscript",
    value: function _get_subscript() {
      return this._getFontVerticalAlignment() === "subscript";
    }
  }, {
    key: "_set_subscript",
    value: function _set_subscript(subscript) {
      this._setFontVerticalAlignment(subscript ? "subscript" : null);
    }
  }, {
    key: "_get_superscript",
    value: function _get_superscript() {
      return this._getFontVerticalAlignment() === "superscript";
    }
  }, {
    key: "_set_superscript",
    value: function _set_superscript(superscript) {
      this._setFontVerticalAlignment(superscript ? "superscript" : null);
    }
  }, {
    key: "_get_fontSize",
    value: function _get_fontSize() {
      return xmlq.getChildAttribute(this._fontNode, 'sz', "val");
    }
  }, {
    key: "_set_fontSize",
    value: function _set_fontSize(size) {
      xmlq.setChildAttributes(this._fontNode, 'sz', {
        val: size
      });
      xmlq.removeChildIfEmpty(this._fontNode, 'sz');
    }
  }, {
    key: "_get_fontFamily",
    value: function _get_fontFamily() {
      return xmlq.getChildAttribute(this._fontNode, 'name', "val");
    }
  }, {
    key: "_set_fontFamily",
    value: function _set_fontFamily(family) {
      xmlq.setChildAttributes(this._fontNode, 'name', {
        val: family
      });
      xmlq.removeChildIfEmpty(this._fontNode, 'name');
    }
  }, {
    key: "_get_fontGenericFamily",
    value: function _get_fontGenericFamily() {
      return xmlq.getChildAttribute(this._fontNode, 'family', "val");
    }
  }, {
    key: "_set_fontGenericFamily",
    value: function _set_fontGenericFamily(genericFamily) {
      xmlq.setChildAttributes(this._fontNode, 'family', {
        val: genericFamily
      });
      xmlq.removeChildIfEmpty(this._fontNode, 'family');
    }
  }, {
    key: "_get_fontColor",
    value: function _get_fontColor() {
      return this._getColor(this._fontNode, "color");
    }
  }, {
    key: "_set_fontColor",
    value: function _set_fontColor(color) {
      this._setColor(this._fontNode, "color", color);
    }
  }, {
    key: "_get_fontScheme",
    value: function _get_fontScheme() {
      // can be 'minor', 'major', 'none'
      return xmlq.getChildAttribute(this._fontNode, 'scheme', "val");
    }
  }, {
    key: "_set_fontScheme",
    value: function _set_fontScheme(scheme) {
      xmlq.setChildAttributes(this._fontNode, 'scheme', {
        val: scheme
      });
      xmlq.removeChildIfEmpty(this._fontNode, 'scheme');
    }
  }, {
    key: "_get_horizontalAlignment",
    value: function _get_horizontalAlignment() {
      return xmlq.getChildAttribute(this._xfNode, 'alignment', "horizontal");
    }
  }, {
    key: "_set_horizontalAlignment",
    value: function _set_horizontalAlignment(alignment) {
      xmlq.setChildAttributes(this._xfNode, 'alignment', {
        horizontal: alignment
      });
      xmlq.removeChildIfEmpty(this._xfNode, 'alignment');
    }
  }, {
    key: "_get_justifyLastLine",
    value: function _get_justifyLastLine() {
      return xmlq.getChildAttribute(this._xfNode, 'alignment', "justifyLastLine") === 1;
    }
  }, {
    key: "_set_justifyLastLine",
    value: function _set_justifyLastLine(justifyLastLine) {
      xmlq.setChildAttributes(this._xfNode, 'alignment', {
        justifyLastLine: justifyLastLine ? 1 : null
      });
      xmlq.removeChildIfEmpty(this._xfNode, 'alignment');
    }
  }, {
    key: "_get_indent",
    value: function _get_indent() {
      return xmlq.getChildAttribute(this._xfNode, 'alignment', "indent");
    }
  }, {
    key: "_set_indent",
    value: function _set_indent(indent) {
      xmlq.setChildAttributes(this._xfNode, 'alignment', {
        indent: indent
      });
      xmlq.removeChildIfEmpty(this._xfNode, 'alignment');
    }
  }, {
    key: "_get_verticalAlignment",
    value: function _get_verticalAlignment() {
      return xmlq.getChildAttribute(this._xfNode, 'alignment', "vertical");
    }
  }, {
    key: "_set_verticalAlignment",
    value: function _set_verticalAlignment(alignment) {
      xmlq.setChildAttributes(this._xfNode, 'alignment', {
        vertical: alignment
      });
      xmlq.removeChildIfEmpty(this._xfNode, 'alignment');
    }
  }, {
    key: "_get_wrapText",
    value: function _get_wrapText() {
      return xmlq.getChildAttribute(this._xfNode, 'alignment', "wrapText") === 1;
    }
  }, {
    key: "_set_wrapText",
    value: function _set_wrapText(wrapText) {
      xmlq.setChildAttributes(this._xfNode, 'alignment', {
        wrapText: wrapText ? 1 : null
      });
      xmlq.removeChildIfEmpty(this._xfNode, 'alignment');
    }
  }, {
    key: "_get_shrinkToFit",
    value: function _get_shrinkToFit() {
      return xmlq.getChildAttribute(this._xfNode, 'alignment', "shrinkToFit") === 1;
    }
  }, {
    key: "_set_shrinkToFit",
    value: function _set_shrinkToFit(shrinkToFit) {
      xmlq.setChildAttributes(this._xfNode, 'alignment', {
        shrinkToFit: shrinkToFit ? 1 : null
      });
      xmlq.removeChildIfEmpty(this._xfNode, 'alignment');
    }
  }, {
    key: "_get_textDirection",
    value: function _get_textDirection() {
      var readingOrder = xmlq.getChildAttribute(this._xfNode, 'alignment', "readingOrder");
      if (readingOrder === 1) return "left-to-right";
      if (readingOrder === 2) return "right-to-left";
      return readingOrder;
    }
  }, {
    key: "_set_textDirection",
    value: function _set_textDirection(textDirection) {
      var readingOrder;
      if (textDirection === "left-to-right") readingOrder = 1;else if (textDirection === "right-to-left") readingOrder = 2;
      xmlq.setChildAttributes(this._xfNode, 'alignment', {
        readingOrder: readingOrder
      });
      xmlq.removeChildIfEmpty(this._xfNode, 'alignment');
    }
  }, {
    key: "_getTextRotation",
    value: function _getTextRotation() {
      return xmlq.getChildAttribute(this._xfNode, 'alignment', "textRotation");
    }
  }, {
    key: "_setTextRotation",
    value: function _setTextRotation(textRotation) {
      xmlq.setChildAttributes(this._xfNode, 'alignment', {
        textRotation: textRotation
      });
      xmlq.removeChildIfEmpty(this._xfNode, 'alignment');
    }
  }, {
    key: "_get_textRotation",
    value: function _get_textRotation() {
      var textRotation = this._getTextRotation(); // Negative angles in Excel correspond to values > 90 in OOXML.


      if (textRotation > 90) textRotation = 90 - textRotation;
      return textRotation;
    }
  }, {
    key: "_set_textRotation",
    value: function _set_textRotation(textRotation) {
      // Negative angles in Excel correspond to values > 90 in OOXML.
      if (textRotation < 0) textRotation = 90 - textRotation;

      this._setTextRotation(textRotation);
    }
  }, {
    key: "_get_angleTextCounterclockwise",
    value: function _get_angleTextCounterclockwise() {
      return this._getTextRotation() === 45;
    }
  }, {
    key: "_set_angleTextCounterclockwise",
    value: function _set_angleTextCounterclockwise(value) {
      this._setTextRotation(value ? 45 : null);
    }
  }, {
    key: "_get_angleTextClockwise",
    value: function _get_angleTextClockwise() {
      return this._getTextRotation() === 135;
    }
  }, {
    key: "_set_angleTextClockwise",
    value: function _set_angleTextClockwise(value) {
      this._setTextRotation(value ? 135 : null);
    }
  }, {
    key: "_get_rotateTextUp",
    value: function _get_rotateTextUp() {
      return this._getTextRotation() === 90;
    }
  }, {
    key: "_set_rotateTextUp",
    value: function _set_rotateTextUp(value) {
      this._setTextRotation(value ? 90 : null);
    }
  }, {
    key: "_get_rotateTextDown",
    value: function _get_rotateTextDown() {
      return this._getTextRotation() === 180;
    }
  }, {
    key: "_set_rotateTextDown",
    value: function _set_rotateTextDown(value) {
      this._setTextRotation(value ? 180 : null);
    }
  }, {
    key: "_get_verticalText",
    value: function _get_verticalText() {
      return this._getTextRotation() === 255;
    }
  }, {
    key: "_set_verticalText",
    value: function _set_verticalText(value) {
      this._setTextRotation(value ? 255 : null);
    }
  }, {
    key: "_get_fill",
    value: function _get_fill() {
      var _this2 = this;

      var patternFillNode = xmlq.findChild(this._fillNode, 'patternFill'); // jq.get(this._fillNode, "patternFill[0]");

      var gradientFillNode = xmlq.findChild(this._fillNode, 'gradientFill'); // jq.get(this._fillNode, "gradientFill[0]");

      var patternType = patternFillNode && patternFillNode.attributes.patternType; // jq.get(patternFillNode, "$.patternType");

      if (patternType === "solid") {
        return {
          type: "solid",
          color: this._getColor(patternFillNode, "fgColor")
        };
      }

      if (patternType) {
        return {
          type: "pattern",
          pattern: patternType,
          foreground: this._getColor(patternFillNode, "fgColor"),
          background: this._getColor(patternFillNode, "bgColor")
        };
      }

      if (gradientFillNode) {
        var gradientType = gradientFillNode.attributes.type || "linear";
        var fill = {
          type: "gradient",
          gradientType: gradientType,
          stops: _.map(gradientFillNode.children, function (stop) {
            return {
              position: stop.attributes.position,
              color: _this2._getColor(stop, "color")
            };
          })
        };

        if (gradientType === "linear") {
          fill.angle = gradientFillNode.attributes.degree;
        } else {
          fill.left = gradientFillNode.attributes.left;
          fill.right = gradientFillNode.attributes.right;
          fill.top = gradientFillNode.attributes.top;
          fill.bottom = gradientFillNode.attributes.bottom;
        }

        return fill;
      }
    }
  }, {
    key: "_set_fill",
    value: function _set_fill(fill) {
      var _this3 = this;

      this._fillNode.children = []; // No fill

      if (_.isNil(fill)) return; // Pattern fill

      if (fill.type === "pattern") {
        var _patternFill = {
          name: 'patternFill',
          attributes: {
            patternType: fill.pattern
          },
          children: []
        };

        this._fillNode.children.push(_patternFill);

        this._setColor(_patternFill, "fgColor", fill.foreground);

        this._setColor(_patternFill, "bgColor", fill.background);

        return;
      } // Gradient fill


      if (fill.type === "gradient") {
        var gradientFill = {
          name: 'gradientFill',
          attributes: {},
          children: []
        };

        this._fillNode.children.push(gradientFill);

        xmlq.setAttributes(gradientFill, {
          type: fill.gradientType === "path" ? "path" : undefined,
          left: fill.left,
          right: fill.right,
          top: fill.top,
          bottom: fill.bottom,
          degree: fill.angle
        });

        _.forEach(fill.stops, function (fillStop, i) {
          var stop = {
            name: 'stop',
            attributes: {
              position: fillStop.position
            },
            children: []
          };
          gradientFill.children.push(stop);

          _this3._setColor(stop, 'color', fillStop.color);
        });

        return;
      } // Solid fill (really a pattern fill with a solid pattern type).


      if (!_.isObject(fill)) fill = {
        type: "solid",
        color: fill
      };else if (fill.hasOwnProperty('rgb') || fill.hasOwnProperty("theme")) fill = {
        color: fill
      };
      var patternFill = {
        name: 'patternFill',
        attributes: {
          patternType: 'solid'
        }
      };

      this._fillNode.children.push(patternFill);

      this._setColor(patternFill, "fgColor", fill.color);
    }
  }, {
    key: "_getBorder",
    value: function _getBorder() {
      var _this4 = this;

      var result = {};
      ["left", "right", "top", "bottom", "diagonal"].forEach(function (side) {
        var sideNode = xmlq.findChild(_this4._borderNode, side);
        var sideResult = {};
        var style = xmlq.getChildAttribute(_this4._borderNode, side, 'style');
        if (style) sideResult.style = style;

        var color = _this4._getColor(sideNode, 'color');

        if (color) sideResult.color = color;

        if (side === "diagonal") {
          var up = _this4._borderNode.attributes.diagonalUp;
          var down = _this4._borderNode.attributes.diagonalDown;
          var direction;
          if (up && down) direction = "both";else if (up) direction = "up";else if (down) direction = "down";
          if (direction) sideResult.direction = direction;
        }

        if (!_.isEmpty(sideResult)) result[side] = sideResult;
      });
      return result;
    }
  }, {
    key: "_setBorder",
    value: function _setBorder(settings) {
      var _this5 = this;

      _.forOwn(settings, function (setting, side) {
        if (typeof setting === "boolean") {
          setting = {
            style: setting ? "thin" : null
          };
        } else if (typeof setting === "string") {
          setting = {
            style: setting
          };
        } else if (setting === null || setting === undefined) {
          setting = {
            style: null,
            color: null,
            direction: null
          };
        }

        if (setting.hasOwnProperty("style")) {
          xmlq.setChildAttributes(_this5._borderNode, side, {
            style: setting.style
          });
        }

        if (setting.hasOwnProperty("color")) {
          var sideNode = xmlq.findChild(_this5._borderNode, side);

          _this5._setColor(sideNode, "color", setting.color);
        }

        if (side === "diagonal") {
          xmlq.setAttributes(_this5._borderNode, {
            diagonalUp: setting.direction === "up" || setting.direction === "both" ? 1 : null,
            diagonalDown: setting.direction === "down" || setting.direction === "both" ? 1 : null
          });
        }
      });
    }
  }, {
    key: "_get_border",
    value: function _get_border() {
      return this._getBorder();
    }
  }, {
    key: "_set_border",
    value: function _set_border(settings) {
      if (_.isObject(settings) && !settings.hasOwnProperty("style") && !settings.hasOwnProperty("color")) {
        settings = _.defaults(settings, {
          left: null,
          right: null,
          top: null,
          bottom: null,
          diagonal: null
        });

        this._setBorder(settings);
      } else {
        this._setBorder({
          left: settings,
          right: settings,
          top: settings,
          bottom: settings
        });
      }
    }
  }, {
    key: "_get_borderColor",
    value: function _get_borderColor() {
      return _.mapValues(this._getBorder(), function (value) {
        return value.color;
      });
    }
  }, {
    key: "_set_borderColor",
    value: function _set_borderColor(color) {
      if (_.isObject(color)) {
        this._setBorder(_.mapValues(color, function (color) {
          return {
            color: color
          };
        }));
      } else {
        this._setBorder({
          left: {
            color: color
          },
          right: {
            color: color
          },
          top: {
            color: color
          },
          bottom: {
            color: color
          },
          diagonal: {
            color: color
          }
        });
      }
    }
  }, {
    key: "_get_borderStyle",
    value: function _get_borderStyle() {
      return _.mapValues(this._getBorder(), function (value) {
        return value.style;
      });
    }
  }, {
    key: "_set_borderStyle",
    value: function _set_borderStyle(style) {
      if (_.isObject(style)) {
        this._setBorder(_.mapValues(style, function (style) {
          return {
            style: style
          };
        }));
      } else {
        this._setBorder({
          left: {
            style: style
          },
          right: {
            style: style
          },
          top: {
            style: style
          },
          bottom: {
            style: style
          }
        });
      }
    }
  }, {
    key: "_get_diagonalBorderDirection",
    value: function _get_diagonalBorderDirection() {
      var border = this._getBorder().diagonal;

      return border && border.direction;
    }
  }, {
    key: "_set_diagonalBorderDirection",
    value: function _set_diagonalBorderDirection(direction) {
      this._setBorder({
        diagonal: {
          direction: direction
        }
      });
    }
  }, {
    key: "_get_numberFormat",
    value: function _get_numberFormat() {
      var numFmtId = this._xfNode.attributes.numFmtId || 0;
      return this._styleSheet.getNumberFormatCode(numFmtId);
    }
  }, {
    key: "_set_numberFormat",
    value: function _set_numberFormat(formatCode) {
      this._xfNode.attributes.numFmtId = this._styleSheet.getNumberFormatId(formatCode);
    }
  }]);

  return Style;
}();

["left", "right", "top", "bottom", "diagonal"].forEach(function (side) {
  Style.prototype["_get_".concat(side, "Border")] = function () {
    return this._getBorder()[side];
  };

  Style.prototype["_set_".concat(side, "Border")] = function (settings) {
    this._setBorder(_defineProperty({}, side, settings));
  };

  Style.prototype["_get_".concat(side, "BorderColor")] = function () {
    var border = this._getBorder()[side];

    return border && border.color;
  };

  Style.prototype["_set_".concat(side, "BorderColor")] = function (color) {
    this._setBorder(_defineProperty({}, side, {
      color: color
    }));
  };

  Style.prototype["_get_".concat(side, "BorderStyle")] = function () {
    var border = this._getBorder()[side];

    return border && border.style;
  };

  Style.prototype["_set_".concat(side, "BorderStyle")] = function (style) {
    this._setBorder(_defineProperty({}, side, {
      style: style
    }));
  };
}); // IE doesn't support function names so explicitly set it.

if (!Style.name) Style.name = "Style";
module.exports = Style;

},{"./ArgHandler":2,"./colorIndexes":25,"./xmlq":29,"lodash":170}],18:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _ = require("lodash");

var xmlq = require("./xmlq");

var Style = require("./Style");
/**
 * Standard number format codes
 * Taken from http://polymathprogrammer.com/2011/02/15/built-in-styles-for-excel-open-xml/
 * @private
 */


var STANDARD_CODES = {
  0: 'General',
  1: '0',
  2: '0.00',
  3: '#,##0',
  4: '#,##0.00',
  9: '0%',
  10: '0.00%',
  11: '0.00E+00',
  12: '# ?/?',
  13: '# ??/??',
  14: 'mm-dd-yy',
  15: 'd-mmm-yy',
  16: 'd-mmm',
  17: 'mmm-yy',
  18: 'h:mm AM/PM',
  19: 'h:mm:ss AM/PM',
  20: 'h:mm',
  21: 'h:mm:ss',
  22: 'm/d/yy h:mm',
  37: '#,##0 ;(#,##0)',
  38: '#,##0 ;[Red](#,##0)',
  39: '#,##0.00;(#,##0.00)',
  40: '#,##0.00;[Red](#,##0.00)',
  45: 'mm:ss',
  46: '[h]:mm:ss',
  47: 'mmss.0',
  48: '##0.0E+0',
  49: '@'
};
/**
 * The starting ID for custom number formats. The first 163 indexes are reserved.
 * @private
 */

var STARTING_CUSTOM_NUMBER_FORMAT_ID = 164;
/**
 * A style sheet.
 * @ignore
 */

var StyleSheet = /*#__PURE__*/function () {
  /**
   * Creates an instance of _StyleSheet.
   * @param {string} node - The style sheet node
   */
  function StyleSheet(node) {
    _classCallCheck(this, StyleSheet);

    this._init(node);

    this._cacheNumberFormats();
  }
  /**
   * Create a style.
   * @param {number} [sourceId] - The source style ID to copy, if provided.
   * @returns {Style} The style.
   */


  _createClass(StyleSheet, [{
    key: "createStyle",
    value: function createStyle(sourceId) {
      var fontNode, fillNode, borderNode, xfNode;

      if (sourceId >= 0) {
        var sourceXfNode = this._cellXfsNode.children[sourceId];
        xfNode = _.cloneDeep(sourceXfNode);

        if (sourceXfNode.attributes.applyFont) {
          var fontId = sourceXfNode.attributes.fontId;
          fontNode = _.cloneDeep(this._fontsNode.children[fontId]);
        }

        if (sourceXfNode.attributes.applyFill) {
          var fillId = sourceXfNode.attributes.fillId;
          fillNode = _.cloneDeep(this._fillsNode.children[fillId]);
        }

        if (sourceXfNode.attributes.applyBorder) {
          var borderId = sourceXfNode.attributes.borderId;
          borderNode = _.cloneDeep(this._bordersNode.children[borderId]);
        }
      }

      if (!fontNode) fontNode = {
        name: "font",
        attributes: {},
        children: []
      };

      this._fontsNode.children.push(fontNode);

      if (!fillNode) fillNode = {
        name: "fill",
        attributes: {},
        children: []
      };

      this._fillsNode.children.push(fillNode); // The border sides must be in order


      if (!borderNode) borderNode = {
        name: "border",
        attributes: {},
        children: []
      };
      borderNode.children = [xmlq.findChild(borderNode, "left") || {
        name: "left",
        attributes: {},
        children: []
      }, xmlq.findChild(borderNode, "right") || {
        name: "right",
        attributes: {},
        children: []
      }, xmlq.findChild(borderNode, "top") || {
        name: "top",
        attributes: {},
        children: []
      }, xmlq.findChild(borderNode, "bottom") || {
        name: "bottom",
        attributes: {},
        children: []
      }, xmlq.findChild(borderNode, "diagonal") || {
        name: "diagonal",
        attributes: {},
        children: []
      }];

      this._bordersNode.children.push(borderNode);

      if (!xfNode) xfNode = {
        name: "xf",
        attributes: {},
        children: []
      };

      _.assign(xfNode.attributes, {
        fontId: this._fontsNode.children.length - 1,
        fillId: this._fillsNode.children.length - 1,
        borderId: this._bordersNode.children.length - 1,
        applyFont: 1,
        applyFill: 1,
        applyBorder: 1
      });

      this._cellXfsNode.children.push(xfNode);

      return new Style(this, this._cellXfsNode.children.length - 1, xfNode, fontNode, fillNode, borderNode);
    }
    /**
     * Get the number format code for a given ID.
     * @param {number} id - The number format ID.
     * @returns {string} The format code.
     */

  }, {
    key: "getNumberFormatCode",
    value: function getNumberFormatCode(id) {
      return this._numberFormatCodesById[id];
    }
    /**
     * Get the nuumber format ID for a given code.
     * @param {string} code - The format code.
     * @returns {number} The number format ID.
     */

  }, {
    key: "getNumberFormatId",
    value: function getNumberFormatId(code) {
      var id = this._numberFormatIdsByCode[code];

      if (id === undefined) {
        id = this._nextNumFormatId++;
        this._numberFormatCodesById[id] = code;
        this._numberFormatIdsByCode[code] = id;

        this._numFmtsNode.children.push({
          name: 'numFmt',
          attributes: {
            numFmtId: id,
            formatCode: code
          }
        });
      }

      return id;
    }
    /**
     * Convert the style sheet to an XML object.
     * @returns {{}} The XML form.
     * @ignore
     */

  }, {
    key: "toXml",
    value: function toXml() {
      return this._node;
    }
    /**
     * Cache the number format codes
     * @returns {undefined}
     * @private
     */

  }, {
    key: "_cacheNumberFormats",
    value: function _cacheNumberFormats() {
      var _this = this;

      // Load the standard number format codes into the caches.
      this._numberFormatCodesById = {};
      this._numberFormatIdsByCode = {};

      for (var id in STANDARD_CODES) {
        if (!STANDARD_CODES.hasOwnProperty(id)) continue;
        var code = STANDARD_CODES[id];
        this._numberFormatCodesById[id] = code;
        this._numberFormatIdsByCode[code] = parseInt(id);
      } // Set the next number format code.


      this._nextNumFormatId = STARTING_CUSTOM_NUMBER_FORMAT_ID; // If there are custom number formats, cache them all and update the next num as needed.

      this._numFmtsNode.children.forEach(function (node) {
        var id = node.attributes.numFmtId;
        var code = node.attributes.formatCode;
        _this._numberFormatCodesById[id] = code;
        _this._numberFormatIdsByCode[code] = id;
        if (id >= _this._nextNumFormatId) _this._nextNumFormatId = id + 1;
      });
    }
    /**
     * Initialize the style sheet node.
     * @param {{}} [node] - The node
     * @returns {undefined}
     * @private
     */

  }, {
    key: "_init",
    value: function _init(node) {
      this._node = node; // Cache the refs to the collections.

      this._numFmtsNode = xmlq.findChild(this._node, "numFmts");
      this._fontsNode = xmlq.findChild(this._node, "fonts");
      this._fillsNode = xmlq.findChild(this._node, "fills");
      this._bordersNode = xmlq.findChild(this._node, "borders");
      this._cellXfsNode = xmlq.findChild(this._node, "cellXfs");

      if (!this._numFmtsNode) {
        this._numFmtsNode = {
          name: "numFmts",
          attributes: {},
          children: []
        }; // Number formats need to be before the others.

        xmlq.insertBefore(this._node, this._numFmtsNode, this._fontsNode);
      } // Remove the optional counts so we don't have to keep them up to date.


      delete this._numFmtsNode.attributes.count;
      delete this._fontsNode.attributes.count;
      delete this._fillsNode.attributes.count;
      delete this._bordersNode.attributes.count;
      delete this._cellXfsNode.attributes.count;
    }
  }]);

  return StyleSheet;
}();

module.exports = StyleSheet;
/*
xl/styles.xml

<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac x16r2" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac" xmlns:x16r2="http://schemas.microsoft.com/office/spreadsheetml/2015/02/main">
    <numFmts count="1">
        <numFmt numFmtId="164" formatCode="#,##0_);[Red]\(#,##0\)\)"/>
    </numFmts>
    <fonts count="1" x14ac:knownFonts="1">
        <font>
            <sz val="11"/>
            <color theme="1"/>
            <name val="Calibri"/>
            <family val="2"/>
            <scheme val="minor"/>
        </font>
    </fonts>
    <fills count="11">
        <fill>
            <patternFill patternType="none"/>
        </fill>
        <fill>
            <patternFill patternType="gray125"/>
        </fill>
        <fill>
            <patternFill patternType="solid">
                <fgColor rgb="FFC00000"/>
                <bgColor indexed="64"/>
            </patternFill>
        </fill>
        <fill>
            <patternFill patternType="lightDown">
                <fgColor theme="4"/>
                <bgColor rgb="FFC00000"/>
            </patternFill>
        </fill>
        <fill>
            <gradientFill degree="90">
                <stop position="0">
                    <color theme="0"/>
                </stop>
                <stop position="1">
                    <color theme="4"/>
                </stop>
            </gradientFill>
        </fill>
        <fill>
            <gradientFill>
                <stop position="0">
                    <color theme="0"/>
                </stop>
                <stop position="1">
                    <color theme="4"/>
                </stop>
            </gradientFill>
        </fill>
        <fill>
            <gradientFill degree="45">
                <stop position="0">
                    <color theme="0"/>
                </stop>
                <stop position="1">
                    <color theme="4"/>
                </stop>
            </gradientFill>
        </fill>
        <fill>
            <gradientFill degree="135">
                <stop position="0">
                    <color theme="0"/>
                </stop>
                <stop position="1">
                    <color theme="4"/>
                </stop>
            </gradientFill>
        </fill>
        <fill>
            <gradientFill type="path">
                <stop position="0">
                    <color theme="0"/>
                </stop>
                <stop position="1">
                    <color theme="4"/>
                </stop>
            </gradientFill>
        </fill>
        <fill>
            <gradientFill type="path" left="0.5" right="0.5" top="0.5" bottom="0.5">
                <stop position="0">
                    <color theme="0"/>
                </stop>
                <stop position="1">
                    <color theme="4"/>
                </stop>
            </gradientFill>
        </fill>
        <fill>
            <gradientFill degree="270">
                <stop position="0">
                    <color theme="0"/>
                </stop>
                <stop position="1">
                    <color theme="4"/>
                </stop>
            </gradientFill>
        </fill>
    </fills>
    <borders count="10">
        <border>
            <left/>
            <right/>
            <top/>
            <bottom/>
            <diagonal/>
        </border>
        <border diagonalDown="1">
            <left/>
            <right/>
            <top/>
            <bottom/>
            <diagonal style="hair">
                <color auto="1"/>
            </diagonal>
        </border>
        <border diagonalDown="1">
            <left/>
            <right/>
            <top/>
            <bottom/>
            <diagonal style="dotted">
                <color auto="1"/>
            </diagonal>
        </border>
        <border diagonalDown="1">
            <left/>
            <right/>
            <top/>
            <bottom/>
            <diagonal style="dashDotDot">
                <color auto="1"/>
            </diagonal>
        </border>
        <border diagonalDown="1">
            <left/>
            <right/>
            <top/>
            <bottom/>
            <diagonal style="dashDot">
                <color auto="1"/>
            </diagonal>
        </border>
        <border diagonalDown="1">
            <left/>
            <right/>
            <top/>
            <bottom/>
            <diagonal style="dashed">
                <color auto="1"/>
            </diagonal>
        </border>
        <border diagonalUp="1">
            <left/>
            <right/>
            <top/>
            <bottom/>
            <diagonal style="mediumDashDotDot">
                <color auto="1"/>
            </diagonal>
        </border>
        <border diagonalUp="1">
            <left/>
            <right/>
            <top/>
            <bottom/>
            <diagonal style="slantDashDot">
                <color auto="1"/>
            </diagonal>
        </border>
        <border diagonalUp="1">
            <left/>
            <right/>
            <top/>
            <bottom/>
            <diagonal style="mediumDashDot">
                <color auto="1"/>
            </diagonal>
        </border>
        <border diagonalUp="1">
            <left/>
            <right/>
            <top/>
            <bottom/>
            <diagonal style="mediumDashed">
                <color auto="1"/>
            </diagonal>
        </border>
    </borders>
    <cellStyleXfs count="1">
        <xf numFmtId="0" fontId="0" fillId="0" borderId="0"/>
    </cellStyleXfs>
    <cellXfs count="19">
        <xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/>
        <xf numFmtId="0" fontId="0" fillId="0" borderId="1" xfId="0" applyBorder="1"/>
        <xf numFmtId="0" fontId="0" fillId="0" borderId="2" xfId="0" applyBorder="1"/>
        <xf numFmtId="0" fontId="0" fillId="0" borderId="3" xfId="0" applyBorder="1"/>
        <xf numFmtId="0" fontId="0" fillId="0" borderId="4" xfId="0" applyBorder="1"/>
        <xf numFmtId="0" fontId="0" fillId="0" borderId="5" xfId="0" applyBorder="1"/>
        <xf numFmtId="0" fontId="0" fillId="0" borderId="6" xfId="0" applyBorder="1"/>
        <xf numFmtId="0" fontId="0" fillId="0" borderId="7" xfId="0" applyBorder="1"/>
        <xf numFmtId="0" fontId="0" fillId="0" borderId="8" xfId="0" applyBorder="1"/>
        <xf numFmtId="0" fontId="0" fillId="0" borderId="9" xfId="0" applyBorder="1"/>
        <xf numFmtId="0" fontId="0" fillId="2" borderId="0" xfId="0" applyFill="1" applyBorder="1"/>
        <xf numFmtId="0" fontId="0" fillId="3" borderId="0" xfId="0" applyFill="1"/>
        <xf numFmtId="0" fontId="0" fillId="4" borderId="0" xfId="0" applyFill="1"/>
        <xf numFmtId="0" fontId="0" fillId="5" borderId="0" xfId="0" applyFill="1"/>
        <xf numFmtId="0" fontId="0" fillId="6" borderId="0" xfId="0" applyFill="1"/>
        <xf numFmtId="0" fontId="0" fillId="7" borderId="0" xfId="0" applyFill="1"/>
        <xf numFmtId="0" fontId="0" fillId="8" borderId="0" xfId="0" applyFill="1"/>
        <xf numFmtId="0" fontId="0" fillId="9" borderId="0" xfId="0" applyFill="1"/>
        <xf numFmtId="0" fontId="0" fillId="10" borderId="0" xfId="0" applyFill="1"/>
    </cellXfs>
    <cellStyles count="1">
        <cellStyle name="Normal" xfId="0" builtinId="0"/>
    </cellStyles>
    <dxfs count="0"/>
    <tableStyles count="0" defaultTableStyle="TableStyleMedium2" defaultPivotStyle="PivotStyleLight16"/>
    <extLst>
        <ext uri="{EB79DEF2-80B8-43e5-95BD-54CBDDF9020C}" xmlns:x14="http://schemas.microsoft.com/office/spreadsheetml/2009/9/main">
            <x14:slicerStyles defaultSlicerStyle="SlicerStyleLight1"/>
        </ext>
        <ext uri="{9260A510-F301-46a8-8635-F512D64BE5F5}" xmlns:x15="http://schemas.microsoft.com/office/spreadsheetml/2010/11/main">
            <x15:timelineStyles defaultTimelineStyle="TimeSlicerStyleLight1"/>
        </ext>
    </extLst>
</styleSheet>
*/

},{"./Style":17,"./xmlq":29,"lodash":170}],19:[function(require,module,exports){
(function (process,Buffer){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _ = require("lodash");

var fs = require("fs");

var JSZip = require('jszip');

var externals = require("./externals");

var regexify = require("./regexify");

var blank = require("./blank")();

var xmlq = require("./xmlq");

var Sheet = require("./Sheet");

var ContentTypes = require("./ContentTypes");

var AppProperties = require("./AppProperties");

var CoreProperties = require("./CoreProperties");

var Relationships = require("./Relationships");

var SharedStrings = require("./SharedStrings");

var StyleSheet = require("./StyleSheet");

var Encryptor = require("./Encryptor");

var XmlParser = require("./XmlParser");

var XmlBuilder = require("./XmlBuilder");

var ArgHandler = require("./ArgHandler");

var addressConverter = require("./addressConverter"); // Options for adding files to zip. Do not create folders and use a fixed time at epoch.
// The default JSZip behavior uses current time, which causes idential workbooks to be different each time.


var zipFileOpts = {
  date: new Date(0),
  createFolders: false
}; // Initialize the parser and builder.

var xmlParser = new XmlParser();
var xmlBuilder = new XmlBuilder(); // Initialize the encryptor if present (can be excluded in browser build).

var encryptor = typeof Encryptor === "function" && new Encryptor(); // Characters not allowed in sheet names.

var badSheetNameChars = ['\\', '/', '*', '[', ']', ':', '?']; // Excel limits sheet names to 31 chars.

var maxSheetNameLength = 31; // Order of the nodes as defined by the spec.

var nodeOrder = ["fileVersion", "fileSharing", "workbookPr", "workbookProtection", "bookViews", "sheets", "functionGroups", "externalReferences", "definedNames", "calcPr", "oleSize", "customWorkbookViews", "pivotCaches", "smartTagPr", "smartTagTypes", "webPublishing", "fileRecoveryPr", "webPublishObjects", "extLst"];
/**
 * A workbook.
 */

var Workbook = /*#__PURE__*/function () {
  function Workbook() {
    _classCallCheck(this, Workbook);
  }

  _createClass(Workbook, [{
    key: "activeSheet",

    /**
     * Get the active sheet in the workbook.
     * @returns {Sheet} The active sheet.
     */

    /**
    * Set the active sheet in the workbook.
    * @param {Sheet|string|number} sheet - The sheet or name of sheet or index of sheet to activate. The sheet must not be hidden.
    * @returns {Workbook} The workbook.
    */
    value: function activeSheet() {
      var _this = this;

      return new ArgHandler('Workbook.activeSheet').case(function () {
        return _this._activeSheet;
      }).case('*', function (sheet) {
        // Get the sheet from name/index if needed.
        if (!(sheet instanceof Sheet)) sheet = _this.sheet(sheet); // Check if the sheet is hidden.

        if (sheet.hidden()) throw new Error("You may not activate a hidden sheet."); // Deselect all sheets except the active one (mirroring ying Excel behavior).

        _.forEach(_this._sheets, function (current) {
          current.tabSelected(current === sheet);
        });

        _this._activeSheet = sheet;
        return _this;
      }).handle(arguments);
    }
    /**
     * Add a new sheet to the workbook.
     * @param {string} name - The name of the sheet. Must be unique, less than 31 characters, and may not contain the following characters: \ / * [ ] : ?
     * @param {number|string|Sheet} [indexOrBeforeSheet] The index to move the sheet to or the sheet (or name of sheet) to move this sheet before. Omit this argument to move to the end of the workbook.
     * @returns {Sheet} The new sheet.
     */

  }, {
    key: "addSheet",
    value: function addSheet(name, indexOrBeforeSheet) {
      return this._addSheet(name, indexOrBeforeSheet);
    }
    /**
     * Gets a defined name scoped to the workbook.
     * @param {string} name - The defined name.
     * @returns {undefined|string|Cell|Range|Row|Column} What the defined name refers to or undefined if not found. Will return the string formula if not a Row, Column, Cell, or Range.
     */

    /**
    * Set a defined name scoped to the workbook.
    * @param {string} name - The defined name.
    * @param {string|Cell|Range|Row|Column} refersTo - What the name refers to.
    * @returns {Workbook} The workbook.
    */

  }, {
    key: "definedName",
    value: function definedName() {
      var _this2 = this;

      return new ArgHandler("Workbook.definedName").case('string', function (name) {
        return _this2.scopedDefinedName(undefined, name);
      }).case(['string', '*'], function (name, refersTo) {
        _this2.scopedDefinedName(undefined, name, refersTo);

        return _this2;
      }).handle(arguments);
    }
    /**
     * Delete a sheet from the workbook.
     * @param {Sheet|string|number} sheet - The sheet or name of sheet or index of sheet to move.
     * @returns {Workbook} The workbook.
     */

  }, {
    key: "deleteSheet",
    value: function deleteSheet(sheet) {
      // Get the sheet to move.
      if (!(sheet instanceof Sheet)) {
        sheet = this.sheet(sheet);
        if (!sheet) throw new Error("Invalid move sheet reference.");
      } // Make sure we are not deleting the only visible sheet.


      var visibleSheets = _.filter(this._sheets, function (sheet) {
        return !sheet.hidden();
      });

      if (visibleSheets.length === 1 && visibleSheets[0] === sheet) {
        throw new Error("This sheet may not be deleted as a workbook must contain at least one visible sheet.");
      } // Remove the sheet.


      var index = this._sheets.indexOf(sheet);

      this._sheets.splice(index, 1); // Set the new active sheet.


      if (sheet === this.activeSheet()) {
        if (index >= this._sheets.length) index--;
        this.activeSheet(index);
      }

      return this;
    }
    /**
     * Find the given pattern in the workbook and optionally replace it.
     * @param {string|RegExp} pattern - The pattern to look for. Providing a string will result in a case-insensitive substring search. Use a RegExp for more sophisticated searches.
     * @param {string|function} [replacement] - The text to replace or a String.replace callback function. If pattern is a string, all occurrences of the pattern in each cell will be replaced.
     * @returns {boolean} A flag indicating if the pattern was found.
     */

  }, {
    key: "find",
    value: function find(pattern, replacement) {
      pattern = regexify(pattern);
      var matches = [];

      this._sheets.forEach(function (sheet) {
        matches = matches.concat(sheet.find(pattern, replacement));
      });

      return matches;
    }
    /**
     * Move a sheet to a new position.
     * @param {Sheet|string|number} sheet - The sheet or name of sheet or index of sheet to move.
     * @param {number|string|Sheet} [indexOrBeforeSheet] The index to move the sheet to or the sheet (or name of sheet) to move this sheet before. Omit this argument to move to the end of the workbook.
     * @returns {Workbook} The workbook.
     */

  }, {
    key: "moveSheet",
    value: function moveSheet(sheet, indexOrBeforeSheet) {
      // Get the sheet to move.
      if (!(sheet instanceof Sheet)) {
        sheet = this.sheet(sheet);
        if (!sheet) throw new Error("Invalid move sheet reference.");
      } // Get the to/from indexes.


      var from = this._sheets.indexOf(sheet);

      var to;

      if (_.isNil(indexOrBeforeSheet)) {
        to = this._sheets.length - 1;
      } else if (_.isInteger(indexOrBeforeSheet)) {
        to = indexOrBeforeSheet;
      } else {
        if (!(indexOrBeforeSheet instanceof Sheet)) {
          indexOrBeforeSheet = this.sheet(indexOrBeforeSheet);
          if (!indexOrBeforeSheet) throw new Error("Invalid before sheet reference.");
        }

        to = this._sheets.indexOf(indexOrBeforeSheet);
      } // Insert the sheet at the appropriate place.


      this._sheets.splice(to, 0, this._sheets.splice(from, 1)[0]);

      return this;
    }
    /**
     * Generates the workbook output.
     * @param {string} [type] - The type of the data to return: base64, binarystring, uint8array, arraybuffer, blob, nodebuffer. Defaults to 'nodebuffer' in Node.js and 'blob' in browsers.
     * @returns {Promise<string|Uint8Array|ArrayBuffer|Blob|Buffer>} The data.
     */

    /**
    * Generates the workbook output.
    * @param {{}} [opts] Options
    * @param {string} [opts.type] - The type of the data to return: base64, binarystring, uint8array, arraybuffer, blob, nodebuffer. Defaults to 'nodebuffer' in Node.js and 'blob' in browsers.
    * @param {string} [opts.password] - The password to use to encrypt the workbook.
    * @returns {Promise<string|Uint8Array|ArrayBuffer|Blob|Buffer>} The data.
    */

  }, {
    key: "outputAsync",
    value: function outputAsync(opts) {
      var _this3 = this;

      opts = opts || {};
      if (typeof opts === 'string') opts = {
        type: opts
      };

      this._setSheetRefs();

      var definedNamesNode = xmlq.findChild(this._node, "definedNames");

      this._sheets.forEach(function (sheet, i) {
        if (!sheet._autoFilter) return;

        if (!definedNamesNode) {
          definedNamesNode = {
            name: "definedNames",
            attributes: {},
            children: []
          };
          xmlq.insertInOrder(_this3._node, definedNamesNode, nodeOrder);
        }

        xmlq.appendChild(definedNamesNode, {
          name: "definedName",
          attributes: {
            name: "_xlnm._FilterDatabase",
            localSheetId: i,
            hidden: "1"
          },
          children: [sheet._autoFilter.address({
            includeSheetName: true,
            anchored: true
          })]
        });
      });

      this._sheetsNode.children = [];

      this._sheets.forEach(function (sheet, i) {
        var sheetPath = "xl/worksheets/sheet".concat(i + 1, ".xml");
        var sheetRelsPath = "xl/worksheets/_rels/sheet".concat(i + 1, ".xml.rels");
        var sheetXmls = sheet.toXmls();

        var relationship = _this3._relationships.findById(sheetXmls.id.attributes['r:id']);

        relationship.attributes.Target = "worksheets/sheet".concat(i + 1, ".xml");

        _this3._sheetsNode.children.push(sheetXmls.id);

        _this3._zip.file(sheetPath, xmlBuilder.build(sheetXmls.sheet), zipFileOpts);

        var relationshipsXml = xmlBuilder.build(sheetXmls.relationships);

        if (relationshipsXml) {
          _this3._zip.file(sheetRelsPath, relationshipsXml, zipFileOpts);
        } else {
          _this3._zip.remove(sheetRelsPath);
        }
      }); // Set the app security to true if a password is set, false if not.
      // this._appProperties.isSecure(!!opts.password);
      // Convert the various components to XML strings and add them to the zip.


      this._zip.file("[Content_Types].xml", xmlBuilder.build(this._contentTypes), zipFileOpts);

      this._zip.file("docProps/app.xml", xmlBuilder.build(this._appProperties), zipFileOpts);

      this._zip.file("docProps/core.xml", xmlBuilder.build(this._coreProperties), zipFileOpts);

      this._zip.file("xl/_rels/workbook.xml.rels", xmlBuilder.build(this._relationships), zipFileOpts);

      this._zip.file("xl/sharedStrings.xml", xmlBuilder.build(this._sharedStrings), zipFileOpts);

      this._zip.file("xl/styles.xml", xmlBuilder.build(this._styleSheet), zipFileOpts);

      this._zip.file("xl/workbook.xml", xmlBuilder.build(this._node), zipFileOpts); // Generate the zip.


      return this._zip.generateAsync({
        type: "nodebuffer",
        compression: "DEFLATE"
      }).then(function (output) {
        // If a password is set, encrypt the workbook.
        if (opts.password) output = encryptor.encrypt(output, opts.password); // Convert and return

        return _this3._convertBufferToOutput(output, opts.type);
      });
    }
    /**
     * Gets the sheet with the provided name or index (0-based).
     * @param {string|number} sheetNameOrIndex - The sheet name or index.
     * @returns {Sheet|undefined} The sheet or undefined if not found.
     */

  }, {
    key: "sheet",
    value: function sheet(sheetNameOrIndex) {
      if (_.isInteger(sheetNameOrIndex)) return this._sheets[sheetNameOrIndex];
      return _.find(this._sheets, function (sheet) {
        return sheet.name() === sheetNameOrIndex;
      });
    }
    /**
     * Get an array of all the sheets in the workbook.
     * @returns {Array.<Sheet>} The sheets.
     */

  }, {
    key: "sheets",
    value: function sheets() {
      return this._sheets.slice();
    }
    /**
     * Gets an individual property.
     * @param {string} name - The name of the property.
     * @returns {*} The property.
     */

    /**
    * Gets multiple properties.
    * @param {Array.<string>} names - The names of the properties.
    * @returns {object.<string, *>} Object whose keys are the property names and values are the properties.
    */

    /**
    * Sets an individual property.
    * @param {string} name - The name of the property.
    * @param {*} value - The value to set.
    * @returns {Workbook} The workbook.
    */

    /**
    * Sets multiple properties.
    * @param {object.<string, *>} properties - Object whose keys are the property names and values are the values to set.
    * @returns {Workbook} The workbook.
    */

  }, {
    key: "property",
    value: function property() {
      var _this4 = this;

      return new ArgHandler("Workbook.property").case('string', function (name) {
        // Get single value
        return _this4._coreProperties.get(name);
      }).case('array', function (names) {
        // Get list of values
        var values = {};
        names.forEach(function (name) {
          values[name] = _this4._coreProperties.get(name);
        });
        return values;
      }).case(['string', '*'], function (name, value) {
        // Set a single value for all cells to a single value
        _this4._coreProperties.set(name, value);

        return _this4;
      }).case('object', function (nameValues) {
        // Object of key value pairs to set
        for (var name in nameValues) {
          if (!nameValues.hasOwnProperty(name)) continue;
          var value = nameValues[name];

          _this4._coreProperties.set(name, value);
        }

        return _this4;
      }).handle(arguments);
    }
    /**
     * Get access to core properties object
     * @returns {CoreProperties} The core properties.
     */

  }, {
    key: "properties",
    value: function properties() {
      return this._coreProperties;
    }
    /**
     * Write the workbook to file. (Not supported in browsers.)
     * @param {string} path - The path of the file to write.
     * @param {{}} [opts] - Options
     * @param {string} [opts.password] - The password to encrypt the workbook.
     * @returns {Promise.<undefined>} A promise.
     */

  }, {
    key: "toFileAsync",
    value: function toFileAsync(path, opts) {
      if (process.browser) throw new Error("Workbook.toFileAsync is not supported in the browser.");
      return this.outputAsync(opts).then(function (data) {
        return new externals.Promise(function (resolve, reject) {
          fs.writeFile(path, data, function (err) {
            if (err) return reject(err);
            resolve();
          });
        });
      });
    }
    /**
     * Gets a scoped defined name.
     * @param {Sheet} sheetScope - The sheet the name is scoped to. Use undefined for workbook scope.
     * @param {string} name - The defined name.
     * @returns {undefined|Cell|Range|Row|Column} What the defined name refers to.
     * @ignore
     */

    /**
    * Sets a scoped defined name.
    * @param {Sheet} sheetScope - The sheet the name is scoped to. Use undefined for workbook scope.
    * @param {string} name - The defined name.
    * @param {undefined|Cell|Range|Row|Column} refersTo - What the defined name refers to.
    * @returns {Workbook} The workbook.
    * @ignore
    */

  }, {
    key: "scopedDefinedName",
    value: function scopedDefinedName(sheetScope, name, refersTo) {
      var _this5 = this;

      var definedNamesNode = xmlq.findChild(this._node, "definedNames");

      var definedNameNode = definedNamesNode && _.find(definedNamesNode.children, function (node) {
        return node.attributes.name === name && node.localSheet === sheetScope;
      });

      return new ArgHandler('Workbook.scopedDefinedName').case(['*', 'string'], function () {
        // Get the address from the definedNames node.
        var refersTo = definedNameNode && definedNameNode.children[0];
        if (!refersTo) return undefined; // Try to parse the address.

        var ref = addressConverter.fromAddress(refersTo);
        if (!ref) return refersTo; // Load the appropriate selection type.

        var sheet = _this5.sheet(ref.sheetName);

        if (ref.type === 'cell') return sheet.cell(ref.rowNumber, ref.columnNumber);
        if (ref.type === 'range') return sheet.range(ref.startRowNumber, ref.startColumnNumber, ref.endRowNumber, ref.endColumnNumber);
        if (ref.type === 'row') return sheet.row(ref.rowNumber);
        if (ref.type === 'column') return sheet.column(ref.columnNumber);
        return refersTo;
      }).case(['*', 'string', 'nil'], function () {
        if (definedNameNode) xmlq.removeChild(definedNamesNode, definedNameNode);
        if (definedNamesNode && !definedNamesNode.children.length) xmlq.removeChild(_this5._node, definedNamesNode);
        return _this5;
      }).case(['*', 'string', '*'], function () {
        if (typeof refersTo !== 'string') {
          refersTo = refersTo.address({
            includeSheetName: true,
            anchored: true
          });
        }

        if (!definedNamesNode) {
          definedNamesNode = {
            name: "definedNames",
            attributes: {},
            children: []
          };
          xmlq.insertInOrder(_this5._node, definedNamesNode, nodeOrder);
        }

        if (!definedNameNode) {
          definedNameNode = {
            name: "definedName",
            attributes: {
              name: name
            },
            children: [refersTo]
          };
          if (sheetScope) definedNameNode.localSheet = sheetScope;
          xmlq.appendChild(definedNamesNode, definedNameNode);
        }

        definedNameNode.children = [refersTo];
        return _this5;
      }).handle(arguments);
    }
    /**
     * Get the shared strings table.
     * @returns {SharedStrings} The shared strings table.
     * @ignore
     */

  }, {
    key: "sharedStrings",
    value: function sharedStrings() {
      return this._sharedStrings;
    }
    /**
     * Get the style sheet.
     * @returns {StyleSheet} The style sheet.
     * @ignore
     */

  }, {
    key: "styleSheet",
    value: function styleSheet() {
      return this._styleSheet;
    }
    /**
     * Add a new sheet to the workbook.
     * 
     * **WARN:** this function has limits:  if you clone a sheet with some images or other things link outside the Sheet object, these things in the cloned sheet will be locked when you open in MS Excel app.
     * @param {Sheet} from - The sheet to be cloned.
     * @param {string} name - The name of the new sheet. Must be unique, less than 31 characters, and may not contain the following characters: \ / * [ ] : ?
     * @param {number|string|Sheet} [indexOrBeforeSheet] The index to move the sheet to or the sheet (or name of sheet) to move this sheet before. Omit this argument to move to the end of the workbook.
     * @returns {Sheet} The new sheet.
     */

  }, {
    key: "cloneSheet",
    value: function cloneSheet(from, name, indexOrBeforeSheet) {
      if (!from || !(from instanceof Sheet)) throw new Error("Invalid clone from.");
      return this._addSheet(name, indexOrBeforeSheet, function () {
        var cloneXml = function cloneXml(node) {
          // If the node has a toXml method, call it.
          if (node && _.isFunction(node.toXml)) node = node.toXml();

          if (_typeof(node) === 'object') {
            if (node.name) {
              var result = {
                name: node.name,
                attributes: {},
                children: []
              };

              _.forOwn(node.attributes, function (value, name) {
                result.attributes[name] = value;
              });

              var chld;

              if (node.children) {
                node.children.forEach(function (child) {
                  chld = cloneXml(child);

                  if (child !== null) {
                    result.children.push(chld);
                  }
                });
              }

              return result;
            }
          } else if (node !== null) {
            return node;
          }

          return null;
        }; // clone SheetNode & relationshipNode from source


        var fromXml = from.toXmls();
        var sheetNode = cloneXml(fromXml.sheet);
        var relationshipNode = cloneXml(fromXml.relationships);
        return {
          sheetNode: sheetNode,
          relationshipNode: relationshipNode
        };
      });
    }
    /**
     * Add a new sheet to the workbook.
     * @param {string} name - The name of the sheet. Must be unique, less than 31 characters, and may not contain the following characters: \ / * [ ] : ?
     * @param {number|string|Sheet} [indexOrBeforeSheet] The index to move the sheet to or the sheet (or name of sheet) to move this sheet before. Omit this argument to move to the end of the workbook.
     * @param {callback} [getTemplateNodes] optional callback function for template nodes
     * @returns {Sheet} The new sheet.
     * @private
     */

  }, {
    key: "_addSheet",
    value: function _addSheet(name, indexOrBeforeSheet, getTemplateNodes) {
      // Validate the sheet name.
      if (!name || typeof name !== "string") throw new Error("Invalid sheet name.");
      if (_.some(badSheetNameChars, function (char) {
        return name.indexOf(char) >= 0;
      })) throw new Error("Sheet name may not contain any of the following characters: ".concat(badSheetNameChars.join(" ")));
      if (name.length > maxSheetNameLength) throw new Error("Sheet name may not be greater than ".concat(maxSheetNameLength, " characters."));
      if (this.sheet(name)) throw new Error("Sheet with name \"".concat(name, "\" already exists.")); // Get the destination index of new sheet.

      var index;

      if (_.isNil(indexOrBeforeSheet)) {
        index = this._sheets.length;
      } else if (_.isInteger(indexOrBeforeSheet)) {
        index = indexOrBeforeSheet;
      } else {
        if (!(indexOrBeforeSheet instanceof Sheet)) {
          indexOrBeforeSheet = this.sheet(indexOrBeforeSheet);
          if (!indexOrBeforeSheet) throw new Error("Invalid before sheet reference.");
        }

        index = this._sheets.indexOf(indexOrBeforeSheet);
      } // Add a new relationship for the new sheet and create the new sheet ID node.


      var relationship = this._relationships.add("worksheet"); // Leave target blank as it will be filled later.


      var sheetIdNode = {
        name: "sheet",
        attributes: {
          name: name,
          sheetId: ++this._maxSheetId,
          'r:id': relationship.attributes.Id
        },
        children: []
      }; // Create the new sheet.

      var sheet;

      if (getTemplateNodes) {
        var _getTemplateNodes = getTemplateNodes(),
            sheetNode = _getTemplateNodes.sheetNode,
            relationshipNode = _getTemplateNodes.relationshipNode;

        sheet = new Sheet(this, sheetIdNode, sheetNode, relationshipNode);
      } else {
        sheet = new Sheet(this, sheetIdNode);
      } // Insert the sheet at the appropriate index.


      this._sheets.splice(index, 0, sheet);

      return sheet;
    }
    /**
     * Initialize the workbook. (This is separated from the constructor to ease testing.)
     * @param {string|ArrayBuffer|Uint8Array|Buffer|Blob} data - The data to load.
     * @param {{}} [opts] - Options
     * @param {boolean} [opts.base64=false] - No used unless input is a string. True if the input string is base64 encoded, false for binary.
     * @returns {Promise.<Workbook>} The workbook.
     * @private
     */

  }, {
    key: "_initAsync",
    value: function _initAsync(data, opts) {
      var _this6 = this;

      opts = opts || {};
      this._maxSheetId = 0;
      this._sheets = [];
      return externals.Promise.resolve().then(function () {
        // Make sure the input is a Buffer
        return _this6._convertInputToBufferAsync(data, opts.base64).then(function (buffer) {
          data = buffer;
        });
      }).then(function () {
        if (!opts.password) return;
        return encryptor.decryptAsync(data, opts.password).then(function (decrypted) {
          data = decrypted;
        });
      }).then(function () {
        return JSZip.loadAsync(data);
      }).then(function (zip) {
        _this6._zip = zip;
        return _this6._parseNodesAsync(["[Content_Types].xml", "docProps/app.xml", "docProps/core.xml", "xl/_rels/workbook.xml.rels", "xl/sharedStrings.xml", "xl/styles.xml", "xl/workbook.xml"]);
      }).then(function (nodes) {
        var contentTypesNode = nodes[0];
        var appPropertiesNode = nodes[1];
        var corePropertiesNode = nodes[2];
        var relationshipsNode = nodes[3];
        var sharedStringsNode = nodes[4];
        var styleSheetNode = nodes[5];
        var workbookNode = nodes[6]; // Load the various components.

        _this6._contentTypes = new ContentTypes(contentTypesNode);
        _this6._appProperties = new AppProperties(appPropertiesNode);
        _this6._coreProperties = new CoreProperties(corePropertiesNode);
        _this6._relationships = new Relationships(relationshipsNode);
        _this6._sharedStrings = new SharedStrings(sharedStringsNode);
        _this6._styleSheet = new StyleSheet(styleSheetNode);
        _this6._node = workbookNode; // Add the shared strings relationship if it doesn't exist.

        if (!_this6._relationships.findByType("sharedStrings")) {
          _this6._relationships.add("sharedStrings", "sharedStrings.xml");
        } // Add the shared string content type if it doesn't exist.


        if (!_this6._contentTypes.findByPartName("/xl/sharedStrings.xml")) {
          _this6._contentTypes.add("/xl/sharedStrings.xml", "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml");
        } // Kill the calc chain. It's not required and the workbook will corrupt unless we keep it up to date.


        _this6._zip.remove("xl/calcChain.xml"); // Load each sheet.


        _this6._sheetsNode = xmlq.findChild(_this6._node, "sheets");
        return externals.Promise.all(_.map(_this6._sheetsNode.children, function (sheetIdNode, i) {
          if (sheetIdNode.attributes.sheetId > _this6._maxSheetId) _this6._maxSheetId = sheetIdNode.attributes.sheetId;
          return _this6._parseNodesAsync(["xl/worksheets/sheet".concat(i + 1, ".xml"), "xl/worksheets/_rels/sheet".concat(i + 1, ".xml.rels")]).then(function (nodes) {
            var sheetNode = nodes[0];
            var sheetRelationshipsNode = nodes[1]; // Insert at position i as the promises will resolve at different times.

            _this6._sheets[i] = new Sheet(_this6, sheetIdNode, sheetNode, sheetRelationshipsNode);
          });
        }));
      }).then(function () {
        return _this6._parseSheetRefs();
      }).then(function () {
        return _this6;
      });
    }
    /**
     * Parse files out of zip into XML node objects.
     * @param {Array.<string>} names - The file names to parse.
     * @returns {Promise.<Array.<{}>>} An array of the parsed objects.
     * @private
     */

  }, {
    key: "_parseNodesAsync",
    value: function _parseNodesAsync(names) {
      var _this7 = this;

      return externals.Promise.all(_.map(names, function (name) {
        return _this7._zip.file(name);
      })).then(function (files) {
        return externals.Promise.all(_.map(files, function (file) {
          return file && file.async("string");
        }));
      }).then(function (texts) {
        return externals.Promise.all(_.map(texts, function (text) {
          return text && xmlParser.parseAsync(text);
        }));
      });
    }
    /**
     * Parse the sheet references out so we can reorder freely.
     * @returns {undefined}
     * @private
     */

  }, {
    key: "_parseSheetRefs",
    value: function _parseSheetRefs() {
      var _this8 = this;

      // Parse the active sheet.
      var bookViewsNode = xmlq.findChild(this._node, "bookViews");
      var workbookViewNode = bookViewsNode && xmlq.findChild(bookViewsNode, "workbookView");
      var activeTabId = workbookViewNode && workbookViewNode.attributes.activeTab || 0;
      this._activeSheet = this._sheets[activeTabId]; // Set the location sheet on the defined name nodes. The defined name should point to the index of the sheet
      // but reordering sheets messes this up. So store it on the node and we'll update the index on XML build.

      var definedNamesNode = xmlq.findChild(this._node, "definedNames");

      if (definedNamesNode) {
        _.forEach(definedNamesNode.children, function (definedNameNode) {
          if (definedNameNode.attributes.hasOwnProperty("localSheetId")) {
            definedNameNode.localSheet = _this8._sheets[definedNameNode.attributes.localSheetId];
          }
        });
      }
    }
    /**
     * Set the proper sheet references in the XML.
     * @returns {undefined}
     * @private
     */

  }, {
    key: "_setSheetRefs",
    value: function _setSheetRefs() {
      var _this9 = this;

      // Set the active sheet.
      var bookViewsNode = xmlq.findChild(this._node, "bookViews");

      if (!bookViewsNode) {
        bookViewsNode = {
          name: 'bookViews',
          attributes: {},
          children: []
        };
        xmlq.insertInOrder(this._node, bookViewsNode, nodeOrder);
      }

      var workbookViewNode = xmlq.findChild(bookViewsNode, "workbookView");

      if (!workbookViewNode) {
        workbookViewNode = {
          name: 'workbookView',
          attributes: {},
          children: []
        };
        xmlq.appendChild(bookViewsNode, workbookViewNode);
      }

      workbookViewNode.attributes.activeTab = this._sheets.indexOf(this._activeSheet); // Set the defined names local sheet indexes.

      var definedNamesNode = xmlq.findChild(this._node, "definedNames");

      if (definedNamesNode) {
        _.forEach(definedNamesNode.children, function (definedNameNode) {
          if (definedNameNode.localSheet) {
            definedNameNode.attributes.localSheetId = _this9._sheets.indexOf(definedNameNode.localSheet);
          }
        });
      }
    }
    /**
     * Convert buffer to desired output format
     * @param {Buffer} buffer - The buffer
     * @param {string} type - The type to convert to: buffer/nodebuffer, blob, base64, binarystring, uint8array, arraybuffer
     * @returns {Buffer|Blob|string|Uint8Array|ArrayBuffer} The output
     * @private
     */

  }, {
    key: "_convertBufferToOutput",
    value: function _convertBufferToOutput(buffer, type) {
      if (!type) type = process.browser ? "blob" : "nodebuffer";
      if (type === "buffer" || type === "nodebuffer") return buffer;
      if (process.browser && type === "blob") return new Blob([buffer], {
        type: Workbook.MIME_TYPE
      });
      if (type === "base64") return buffer.toString("base64");
      if (type === "binarystring") return buffer.toString("utf8");
      if (type === "uint8array") return new Uint8Array(buffer);
      if (type === "arraybuffer") return new Uint8Array(buffer).buffer;
      throw new Error("Output type '".concat(type, "' not supported."));
    }
    /**
     * Convert input to buffer
     * @param {Buffer|Blob|string|Uint8Array|ArrayBuffer} input - The input
     * @param {boolean} [base64=false] - Only applies if input is a string. If true, the string is base64 encoded, false for binary
     * @returns {Promise.<Buffer>} The buffer.
     * @private
     */

  }, {
    key: "_convertInputToBufferAsync",
    value: function _convertInputToBufferAsync(input, base64) {
      return externals.Promise.resolve().then(function () {
        if (Buffer.isBuffer(input)) return input;

        if (process.browser && input instanceof Blob) {
          return new externals.Promise(function (resolve) {
            var fileReader = new FileReader();

            fileReader.onload = function (event) {
              resolve(Buffer.from(event.target.result));
            };

            fileReader.readAsArrayBuffer(input);
          });
        }

        if (typeof input === "string" && base64) return Buffer.from(input, "base64");
        if (typeof input === "string" && !base64) return Buffer.from(input, "utf8");
        if (input instanceof Uint8Array || input instanceof ArrayBuffer) return Buffer.from(input);
        throw new Error("Input type unknown.");
      });
    }
  }], [{
    key: "fromBlankAsync",

    /**
     * Create a new blank workbook.
     * @returns {Promise.<Workbook>} The workbook.
     * @ignore
     */
    value: function fromBlankAsync() {
      return Workbook.fromDataAsync(blank);
    }
    /**
     * Loads a workbook from a data object. (Supports any supported [JSZip data types]{@link https://stuk.github.io/jszip/documentation/api_jszip/load_async.html}.)
     * @param {string|Array.<number>|ArrayBuffer|Uint8Array|Buffer|Blob|Promise.<*>} data - The data to load.
     * @param {{}} [opts] - Options
     * @returns {Promise.<Workbook>} The workbook.
     * @ignore
     */

  }, {
    key: "fromDataAsync",
    value: function fromDataAsync(data, opts) {
      return new Workbook()._initAsync(data, opts);
    }
    /**
     * Loads a workbook from file.
     * @param {string} path - The path to the workbook.
     * @param {{}} [opts] - Options
     * @returns {Promise.<Workbook>} The workbook.
     * @ignore
     */

  }, {
    key: "fromFileAsync",
    value: function fromFileAsync(path, opts) {
      if (process.browser) throw new Error("Workbook.fromFileAsync is not supported in the browser");
      return new externals.Promise(function (resolve, reject) {
        fs.readFile(path, function (err, data) {
          if (err) return reject(err);
          resolve(data);
        });
      }).then(function (data) {
        return Workbook.fromDataAsync(data, opts);
      });
    }
  }]);

  return Workbook;
}();
/**
 * The XLSX mime type.
 * @type {string}
 * @ignore
 */


Workbook.MIME_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
module.exports = Workbook;
/*
xl/workbook.xml

<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x15" xmlns:x15="http://schemas.microsoft.com/office/spreadsheetml/2010/11/main">
	<fileVersion appName="xl" lastEdited="7" lowestEdited="7" rupBuild="16925"/>
	<workbookPr defaultThemeVersion="164011"/>
	<mc:AlternateContent xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006">
		<mc:Choice Requires="x15">
			<x15ac:absPath url="\path\to\file" xmlns:x15ac="http://schemas.microsoft.com/office/spreadsheetml/2010/11/ac"/>
		</mc:Choice>
	</mc:AlternateContent>
	<bookViews>
		<workbookView xWindow="3720" yWindow="0" windowWidth="27870" windowHeight="12795"/>
	</bookViews>
	<sheets>
		<sheet name="Sheet1" sheetId="1" r:id="rId1"/>
	</sheets>
	<calcPr calcId="171027"/>
	<extLst>
		<ext uri="{140A7094-0E35-4892-8432-C4D2E57EDEB5}" xmlns:x15="http://schemas.microsoft.com/office/spreadsheetml/2010/11/main">
			<x15:workbookPr chartTrackingRefBase="1"/>
		</ext>
	</extLst>
</workbook>
// */

}).call(this,require('_process'),require("buffer").Buffer)

},{"./AppProperties":1,"./ArgHandler":2,"./ContentTypes":5,"./CoreProperties":6,"./Encryptor":7,"./Relationships":11,"./SharedStrings":15,"./Sheet":16,"./StyleSheet":18,"./XmlBuilder":21,"./XmlParser":22,"./addressConverter":23,"./blank":24,"./externals":27,"./regexify":28,"./xmlq":29,"_process":202,"buffer":77,"fs":75,"jszip":143,"lodash":170}],20:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var externals = require("./externals");

var Workbook = require("./Workbook");

var FormulaError = require("./FormulaError");

var dateConverter = require("./dateConverter");

var RichText = require("./RichText");
/**
 * xlsx-poulate namespace.
 * @namespace
 */


var XlsxPopulate = /*#__PURE__*/function () {
  function XlsxPopulate() {
    _classCallCheck(this, XlsxPopulate);
  }

  _createClass(XlsxPopulate, null, [{
    key: "dateToNumber",

    /**
     * Convert a date to a number for Excel.
     * @param {Date} date - The date.
     * @returns {number} The number.
     */
    value: function dateToNumber(date) {
      return dateConverter.dateToNumber(date);
    }
    /**
     * Create a new blank workbook.
     * @returns {Promise.<Workbook>} The workbook.
     */

  }, {
    key: "fromBlankAsync",
    value: function fromBlankAsync() {
      return Workbook.fromBlankAsync();
    }
    /**
     * Loads a workbook from a data object. (Supports any supported [JSZip data types]{@link https://stuk.github.io/jszip/documentation/api_jszip/load_async.html}.)
     * @param {string|Array.<number>|ArrayBuffer|Uint8Array|Buffer|Blob|Promise.<*>} data - The data to load.
     * @param {{}} [opts] - Options
     * @param {string} [opts.password] - The password to decrypt the workbook.
     * @returns {Promise.<Workbook>} The workbook.
     */

  }, {
    key: "fromDataAsync",
    value: function fromDataAsync(data, opts) {
      return Workbook.fromDataAsync(data, opts);
    }
    /**
     * Loads a workbook from file.
     * @param {string} path - The path to the workbook.
     * @param {{}} [opts] - Options
     * @param {string} [opts.password] - The password to decrypt the workbook.
     * @returns {Promise.<Workbook>} The workbook.
     */

  }, {
    key: "fromFileAsync",
    value: function fromFileAsync(path, opts) {
      return Workbook.fromFileAsync(path, opts);
    }
    /**
     * Convert an Excel number to a date.
     * @param {number} number - The number.
     * @returns {Date} The date.
     */

  }, {
    key: "numberToDate",
    value: function numberToDate(number) {
      return dateConverter.numberToDate(number);
    }
    /**
     * The Promise library.
     * @type {Promise}
     */

  }, {
    key: "Promise",
    get: function get() {
      return externals.Promise;
    },
    set: function set(Promise) {
      externals.Promise = Promise;
    }
  }]);

  return XlsxPopulate;
}();
/**
 * The XLSX mime type.
 * @type {string}
 */


XlsxPopulate.MIME_TYPE = Workbook.MIME_TYPE;
/**
 * Formula error class.
 * @type {FormulaError}
 */

XlsxPopulate.FormulaError = FormulaError;
/**
 * RichTexts class
 * @type {RichText}
 */

XlsxPopulate.RichText = RichText;
module.exports = XlsxPopulate;

},{"./FormulaError":8,"./RichText":12,"./Workbook":19,"./dateConverter":26,"./externals":27}],21:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _ = require("lodash");

var XML_DECLARATION = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>";
/**
 * XML document builder.
 * @private
 */

var XmlBuilder = /*#__PURE__*/function () {
  function XmlBuilder() {
    _classCallCheck(this, XmlBuilder);
  }

  _createClass(XmlBuilder, [{
    key: "build",

    /**
     * Build an XML string from the JSON object.
     * @param {{}} node - The node.
     * @returns {string} The XML text.
     */
    value: function build(node) {
      this._i = 0;

      var xml = this._build(node, '');

      if (xml === '') return;
      return XML_DECLARATION + xml;
    }
    /**
     * Build the XML string. (This is the internal recursive method.)
     * @param {{}} node - The node.
     * @param {string} xml - The initial XML doc string.
     * @returns {string} The generated XML element.
     * @private
     */

  }, {
    key: "_build",
    value: function _build(node, xml) {
      var _this = this;

      // For CPU performance, JS engines don't truly concatenate strings; they create a tree of pointers to
      // the various concatenated strings. The downside of this is that it consumes a lot of memory, which
      // will cause problems with large workbooks. So periodically, we grab a character from the xml, which
      // causes the JS engine to flatten the tree into a single string. Do this too often and CPU takes a hit.
      // Too frequently and memory takes a hit. Every 100k nodes seems to be a good balance.
      if (this._i++ % 1000000 === 0) {
        this._c = xml[0];
      } // If the node has a toXml method, call it.


      if (node && _.isFunction(node.toXml)) node = node.toXml();

      if (_.isObject(node)) {
        // If the node is an object, then it maps to an element. Check if it has a name.
        if (!node.name) throw new Error("XML node does not have name: ".concat(JSON.stringify(node))); // Add the opening tag.

        xml += "<".concat(node.name); // Add any node attributes

        _.forOwn(node.attributes, function (value, name) {
          xml += " ".concat(name, "=\"").concat(_this._escapeString(value, true), "\"");
        });

        if (_.isEmpty(node.children)) {
          // Self-close the tag if no children.
          xml += "/>";
        } else {
          xml += ">"; // Recursively add any children.

          _.forEach(node.children, function (child) {
            // Add the children to the XML.
            xml = _this._build(child, xml);
          }); // Close the tag.


          xml += "</".concat(node.name, ">");
        }
      } else if (!_.isNil(node)) {
        // It not an object, this should be a text node. Just add it.
        xml += this._escapeString(node);
      } // Return the updated XML element.


      return xml;
    }
    /**
     * Escape a string for use in XML by replacing &, ", ', <, and >.
     * @param {*} value - The value to escape.
     * @param {boolean} [isAttribute] - A flag indicating if this is an attribute.
     * @returns {string} The escaped string.
     * @private
     */

  }, {
    key: "_escapeString",
    value: function _escapeString(value, isAttribute) {
      if (_.isNil(value)) return value;
      value = value.toString().replace(/&/g, "&amp;") // Escape '&' first as the other escapes add them.
      .replace(/</g, "&lt;").replace(/>/g, "&gt;");

      if (isAttribute) {
        value = value.replace(/"/g, "&quot;");
      }

      return value;
    }
  }]);

  return XmlBuilder;
}();

module.exports = XmlBuilder;

},{"lodash":170}],22:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var sax = require("sax");

var externals = require("./externals"); // Regex to check if string is all whitespace.


var allWhitespaceRegex = /^\s+$/;
/**
 * XML parser.
 * @private
 */

var XmlParser = /*#__PURE__*/function () {
  function XmlParser() {
    _classCallCheck(this, XmlParser);
  }

  _createClass(XmlParser, [{
    key: "parseAsync",

    /**
     * Parse the XML text into a JSON object.
     * @param {string} xmlText - The XML text.
     * @returns {{}} The JSON object.
     */
    value: function parseAsync(xmlText) {
      var _this = this;

      return new externals.Promise(function (resolve, reject) {
        // Create the SAX parser.
        var parser = sax.parser(true); // Parsed is the full parsed object. Current is the current node being parsed. Stack is the current stack of
        // nodes leading to the current one.

        var parsed, current;
        var stack = []; // On error: Reject the promise.

        parser.onerror = reject; // On text nodes: If it is all whitespace, do nothing. Otherwise, try to convert to a number and add as a child.

        parser.ontext = function (text) {
          if (allWhitespaceRegex.test(text)) {
            if (current && current.attributes['xml:space'] === 'preserve') {
              current.children.push(text);
            }
          } else {
            current.children.push(_this._covertToNumberIfNumber(text));
          }
        }; // On open tag start: Create a child element. If this is the root element, set it as parsed. Otherwise, add
        // it as a child to the current node.


        parser.onopentagstart = function (node) {
          var child = {
            name: node.name,
            attributes: {},
            children: []
          };

          if (current) {
            current.children.push(child);
          } else {
            parsed = child;
          }

          stack.push(child);
          current = child;
        }; // On close tag: Pop the stack.


        parser.onclosetag = function (node) {
          stack.pop();
          current = stack[stack.length - 1];
        }; // On attribute: Try to convert the value to a number and add to the current node.


        parser.onattribute = function (attribute) {
          current.attributes[attribute.name] = _this._covertToNumberIfNumber(attribute.value);
        }; // On end: Resolve the promise.


        parser.onend = function () {
          return resolve(parsed);
        }; // Start parsing the text.


        parser.write(xmlText).close();
      });
    }
    /**
     * Convert the string to a number if it looks like one.
     * @param {string} str - The string to convert.
     * @returns {string|number} The number if converted or the string if not.
     * @private
     */

  }, {
    key: "_covertToNumberIfNumber",
    value: function _covertToNumberIfNumber(str) {
      var num = Number(str);
      return num.toString() === str ? num : str;
    }
  }]);

  return XmlParser;
}();

module.exports = XmlParser;

},{"./externals":27,"sax":226}],23:[function(require,module,exports){
"use strict"; // V8 doesn't support optimization for compound assignment of let variables.
// These methods get called a lot so disable the rule to allow V8 opmtimization.

/* eslint-disable operator-assignment */

var _ = require("lodash");

var ADDRESS_REGEX = /^(?:'?(.+?)'?!)?(?:(\$)?([A-Z]+)(\$)?(\d+)(?::(\$)?([A-Z]+)(\$)?(\d+))?|(\$)?([A-Z]+):(\$)?([A-Z]+)|(\$)?(\d+):(\$)?(\d+))$/;
/**
 * Address converter.
 * @private
 */

module.exports = {
  /**
   * Convert a column name to a number.
   * @param {string} name - The column name.
   * @returns {number} The number.
   */
  columnNameToNumber: function columnNameToNumber(name) {
    if (!name || typeof name !== "string") return;
    name = name.toUpperCase();
    var sum = 0;

    for (var i = 0; i < name.length; i++) {
      sum = sum * 26;
      sum = sum + (name[i].charCodeAt(0) - 'A'.charCodeAt(0) + 1);
    }

    return sum;
  },

  /**
   * Convert a column number to a name.
   * @param {number} number - The column number.
   * @returns {string} The name.
   */
  columnNumberToName: function columnNumberToName(number) {
    var dividend = number;
    var name = '';
    var modulo = 0;

    while (dividend > 0) {
      modulo = (dividend - 1) % 26;
      name = String.fromCharCode('A'.charCodeAt(0) + modulo) + name;
      dividend = Math.floor((dividend - modulo) / 26);
    }

    return name;
  },

  /**
   * Convert an address to a reference object.
   * @param {string} address - The address.
   * @returns {{}} The reference object.
   */
  fromAddress: function fromAddress(address) {
    var match = address.match(ADDRESS_REGEX);
    if (!match) return;
    var ref = {};
    if (match[1]) ref.sheetName = match[1].replace(/''/g, "'");

    if (match[3] && match[7]) {
      ref.type = 'range';
      ref.startColumnAnchored = !!match[2];
      ref.startColumnName = match[3];
      ref.startColumnNumber = this.columnNameToNumber(ref.startColumnName);
      ref.startRowAnchored = !!match[4];
      ref.startRowNumber = parseInt(match[5]);
      ref.endColumnAnchored = !!match[6];
      ref.endColumnName = match[7];
      ref.endColumnNumber = this.columnNameToNumber(ref.endColumnName);
      ref.endRowAnchored = !!match[8];
      ref.endRowNumber = parseInt(match[9]);
    } else if (match[3]) {
      ref.type = 'cell';
      ref.columnAnchored = !!match[2];
      ref.columnName = match[3];
      ref.columnNumber = this.columnNameToNumber(ref.columnName);
      ref.rowAnchored = !!match[4];
      ref.rowNumber = parseInt(match[5]);
    } else if (match[11] && match[11] !== match[13]) {
      ref.type = 'columnRange';
      ref.startColumnAnchored = !!match[10];
      ref.startColumnName = match[11];
      ref.startColumnNumber = this.columnNameToNumber(ref.startColumnName);
      ref.endColumnAnchored = !!match[12];
      ref.endColumnName = match[13];
      ref.endColumnNumber = this.columnNameToNumber(ref.endColumnName);
    } else if (match[11]) {
      ref.type = 'column';
      ref.columnAnchored = !!match[10];
      ref.columnName = match[11];
      ref.columnNumber = this.columnNameToNumber(ref.columnName);
    } else if (match[15] && match[15] !== match[17]) {
      ref.type = 'rowRange';
      ref.startRowAnchored = !!match[14];
      ref.startRowNumber = parseInt(match[15]);
      ref.endRowAnchored = !!match[16];
      ref.endRowNumber = parseInt(match[17]);
    } else if (match[15]) {
      ref.type = 'row';
      ref.rowAnchored = !!match[14];
      ref.rowNumber = parseInt(match[15]);
    }

    return ref;
  },

  /**
   * Convert a reference object to an address.
   * @param {{}} ref - The reference object.
   * @returns {string} The address.
   */
  toAddress: function toAddress(ref) {
    var a, b;
    var sheetName = ref.sheetName;

    if (ref.type === 'cell') {
      a = {
        columnName: ref.columnName,
        columnNumber: ref.columnNumber,
        columnAnchored: ref.columnAnchored,
        rowNumber: ref.rowNumber,
        rowAnchored: ref.rowAnchored
      };
    } else if (ref.type === 'range') {
      a = {
        columnName: ref.startColumnName,
        columnNumber: ref.startColumnNumber,
        columnAnchored: ref.startColumnAnchored,
        rowNumber: ref.startRowNumber,
        rowAnchored: ref.startRowAnchored
      };
      b = {
        columnName: ref.endColumnName,
        columnNumber: ref.endColumnNumber,
        columnAnchored: ref.endColumnAnchored,
        rowNumber: ref.endRowNumber,
        rowAnchored: ref.endRowAnchored
      };
    } else if (ref.type === 'column') {
      a = b = {
        columnName: ref.columnName,
        columnNumber: ref.columnNumber,
        columnAnchored: ref.columnAnchored
      };
    } else if (ref.type === 'row') {
      a = b = {
        rowNumber: ref.rowNumber,
        rowAnchored: ref.rowAnchored
      };
    } else if (ref.type === 'columnRange') {
      a = {
        columnName: ref.startColumnName,
        columnNumber: ref.startColumnNumber,
        columnAnchored: ref.startColumnAnchored
      };
      b = {
        columnName: ref.endColumnName,
        columnNumber: ref.endColumnNumber,
        columnAnchored: ref.endColumnAnchored
      };
    } else if (ref.type === 'rowRange') {
      a = {
        rowNumber: ref.startRowNumber,
        rowAnchored: ref.startRowAnchored
      };
      b = {
        rowNumber: ref.endRowNumber,
        rowAnchored: ref.endRowAnchored
      };
    }

    var address = '';
    if (sheetName) address = "".concat(address, "'").concat(sheetName.replace(/'/g, "''"), "'!");
    if (a.columnAnchored) address = "".concat(address, "$");
    if (a.columnName) address = address + a.columnName;else if (a.columnNumber) address = address + this.columnNumberToName(a.columnNumber);
    if (a.rowAnchored) address = "".concat(address, "$");
    if (a.rowNumber) address = address + a.rowNumber;

    if (b) {
      address = "".concat(address, ":");
      if (b.columnAnchored) address = "".concat(address, "$");
      if (b.columnName) address = address + b.columnName;else if (b.columnNumber) address = address + this.columnNumberToName(b.columnNumber);
      if (b.rowAnchored) address = "".concat(address, "$");
      if (b.rowNumber) address = address + b.rowNumber;
    }

    return address;
  }
};

},{"lodash":170}],24:[function(require,module,exports){
(function (Buffer){
"use strict"; // Export as a function as proxyquireify has trouble with constant exports.

module.exports = function () {
  return Buffer.from("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", "base64");
};

}).call(this,require("buffer").Buffer)

},{"buffer":77}],25:[function(require,module,exports){
"use strict";
/**
 * Legacy color indexes.
 * https://msdn.microsoft.com/en-us/library/documentformat.openxml.spreadsheet.indexedcolors(v=office.15).aspx
 */

module.exports = ["000000", "FFFFFF", "FF0000", "00FF00", "0000FF", "FFFF00", "FF00FF", "00FFFF", "000000", "FFFFFF", "FF0000", "00FF00", "0000FF", "FFFF00", "FF00FF", "00FFFF", "800000", "008000", "000080", "808000", "800080", "008080", "C0C0C0", "808080", "9999FF", "993366", "FFFFCC", "CCFFFF", "660066", "FF8080", "0066CC", "CCCCFF", "000080", "FF00FF", "FFFF00", "00FFFF", "800080", "800000", "008080", "0000FF", "00CCFF", "CCFFFF", "CCFFCC", "FFFF99", "99CCFF", "FF99CC", "CC99FF", "FFCC99", "3366FF", "33CCCC", "99CC00", "FFCC00", "FF9900", "FF6600", "666699", "969696", "003366", "339966", "003300", "333300", "993300", "993366", "333399", "333333", "System Foreground", "System Background"];

},{}],26:[function(require,module,exports){
"use strict"; // The base date = 0.

var dateBase = new Date(1900, 0, 0); // The date conversion has a bug that assumes 1900 was a leap year. So we need to add one for dates after this.

var incorrectLeapDate = new Date(1900, 1, 28); // Number of milliseconds in a day.

var millisecondsInDay = 1000 * 60 * 60 * 24;
/**
 * Date converter.
 * @private
 */

module.exports = {
  /**
   * Convert a date to a number for Excel.
   * @param {Date} date - The date.
   * @returns {number} The number.
   */
  dateToNumber: function dateToNumber(date) {
    // Clone the date and strip the time off.
    var dateOnly = new Date(date.getTime());
    dateOnly.setHours(0, 0, 0, 0); // Set the number to be the number of days between the date and the base date.
    // We need to round as daylight savings will cause fractional days, which we don't want.

    var number = Math.round((dateOnly - dateBase) / millisecondsInDay); // Add the true fractional days from just the milliseconds left in the current day.

    number += (date - dateOnly) / millisecondsInDay; // Adjust for the "bug" in Excel that treats 1900 as a leap year.

    if (date > incorrectLeapDate) number += 1;
    return number;
  },

  /**
   * Convert a number to a date.
   * @param {number} number - The number.
   * @returns {Date} The date.
   */
  numberToDate: function numberToDate(number) {
    // If the number is greater than the incorrect leap date, we should subtract one.
    if (number > this.dateToNumber(incorrectLeapDate)) number--; // Break the number of full days and the remaining milliseconds in the current day.

    var fullDays = Math.floor(number);
    var partialMilliseconds = Math.round((number - fullDays) * millisecondsInDay); // Create a new date from the base date plus the time in the current day.

    var date = new Date(dateBase.getTime() + partialMilliseconds); // Now add the number of full days. JS will properly handle the month/year changes.

    date.setDate(date.getDate() + fullDays);
    return date;
  }
};

},{}],27:[function(require,module,exports){
"use strict";

var JSZip = require("jszip");
/**
 * External modules.
 * @private
 */


module.exports = {
  /**
   * The Promise library.
   * @type {Promise}
   */
  get Promise() {
    return JSZip.external.Promise;
  },

  set Promise(Promise) {
    JSZip.external.Promise = Promise;
  }

};

},{"jszip":143}],28:[function(require,module,exports){
"use strict";

var _ = require("lodash");
/**
 * Convert a pattern to a RegExp.
 * @param {RegExp|string} pattern - The pattern to convert.
 * @returns {RegExp} The regex.
 * @private
 */


module.exports = function (pattern) {
  if (typeof pattern === "string") {
    pattern = new RegExp(_.escapeRegExp(pattern), "igm");
  }

  pattern.lastIndex = 0;
  return pattern;
};

},{"lodash":170}],29:[function(require,module,exports){
"use strict";

var _ = require("lodash");
/**
 * XML query methods.
 * @private
 */


module.exports = {
  /**
   * Append a child to the node.
   * @param {{}} node - The parent node.
   * @param {{}} child - The child node.
   * @returns {undefined}
   */
  appendChild: function appendChild(node, child) {
    if (!node.children) node.children = [];
    node.children.push(child);
  },

  /**
   * Append a child if one with the given name is not found.
   * @param {{}} node - The parent node.
   * @param {string} name - The child node name.
   * @returns {{}} The child.
   */
  appendChildIfNotFound: function appendChildIfNotFound(node, name) {
    var child = this.findChild(node, name);

    if (!child) {
      child = {
        name: name,
        attributes: {},
        children: []
      };
      this.appendChild(node, child);
    }

    return child;
  },

  /**
   * Find a child with the given name.
   * @param {{}} node - The parent node.
   * @param {string} name - The name to find.
   * @returns {undefined|{}} The child if found.
   */
  findChild: function findChild(node, name) {
    return _.find(node.children, {
      name: name
    });
  },

  /**
   * Get an attribute from a child node.
   * @param {{}} node - The parent node.
   * @param {string} name - The name of the child node.
   * @param {string} attribute - The name of the attribute.
   * @returns {undefined|*} The value of the attribute if found.
   */
  getChildAttribute: function getChildAttribute(node, name, attribute) {
    var child = this.findChild(node, name);
    if (child) return child.attributes && child.attributes[attribute];
  },

  /**
   * Returns a value indicating whether the node has a child with the given name.
   * @param {{}} node - The parent node.
   * @param {string} name - The name of the child node.
   * @returns {boolean} True if found, false otherwise.
   */
  hasChild: function hasChild(node, name) {
    return _.some(node.children, {
      name: name
    });
  },

  /**
   * Insert the child after the specified node.
   * @param {{}} node - The parent node.
   * @param {{}} child - The child node.
   * @param {{}} after - The node to insert after.
   * @returns {undefined}
   */
  insertAfter: function insertAfter(node, child, after) {
    if (!node.children) node.children = [];
    var index = node.children.indexOf(after);
    node.children.splice(index + 1, 0, child);
  },

  /**
   * Insert the child before the specified node.
   * @param {{}} node - The parent node.
   * @param {{}} child - The child node.
   * @param {{}} before - The node to insert before.
   * @returns {undefined}
   */
  insertBefore: function insertBefore(node, child, before) {
    if (!node.children) node.children = [];
    var index = node.children.indexOf(before);
    node.children.splice(index, 0, child);
  },

  /**
   * Insert a child node in the correct order.
   * @param {{}} node - The parent node.
   * @param {{}} child - The child node.
   * @param {Array.<string>} nodeOrder - The order of the node names.
   * @returns {undefined}
   */
  insertInOrder: function insertInOrder(node, child, nodeOrder) {
    var childIndex = nodeOrder.indexOf(child.name);

    if (node.children && childIndex >= 0) {
      for (var i = childIndex + 1; i < nodeOrder.length; i++) {
        var sibling = this.findChild(node, nodeOrder[i]);

        if (sibling) {
          this.insertBefore(node, child, sibling);
          return;
        }
      }
    }

    this.appendChild(node, child);
  },

  /**
   * Check if the node is empty (no attributes and no children).
   * @param {{}} node - The node.
   * @returns {boolean} True if empty, false otherwise.
   */
  isEmpty: function isEmpty(node) {
    return _.isEmpty(node.children) && _.isEmpty(node.attributes);
  },

  /**
   * Remove a child node.
   * @param {{}} node - The parent node.
   * @param {string|{}} child - The child node or name of node.
   * @returns {undefined}
   */
  removeChild: function removeChild(node, child) {
    if (!node.children) return;

    if (typeof child === 'string') {
      _.remove(node.children, {
        name: child
      });
    } else {
      var index = node.children.indexOf(child);
      if (index >= 0) node.children.splice(index, 1);
    }
  },

  /**
   * Set/unset the attributes on the node.
   * @param {{}} node - The node.
   * @param {{}} attributes - The attributes to set.
   * @returns {undefined}
   */
  setAttributes: function setAttributes(node, attributes) {
    _.forOwn(attributes, function (value, attribute) {
      if (_.isNil(value)) {
        if (node.attributes) delete node.attributes[attribute];
      } else {
        if (!node.attributes) node.attributes = {};
        node.attributes[attribute] = value;
      }
    });
  },

  /**
   * Set attributes on a child node, creating the child if necessary.
   * @param {{}} node - The parent node.
   * @param {string} name - The name of the child node.
   * @param {{}} attributes - The attributes to set.
   * @returns {{}} The child.
   */
  setChildAttributes: function setChildAttributes(node, name, attributes) {
    var _this = this;

    var child = this.findChild(node, name);

    _.forOwn(attributes, function (value, attribute) {
      if (_.isNil(value)) {
        if (child && child.attributes) delete child.attributes[attribute];
      } else {
        if (!child) {
          child = {
            name: name,
            attributes: {},
            children: []
          };

          _this.appendChild(node, child);
        }

        if (!child.attributes) child.attributes = {};
        child.attributes[attribute] = value;
      }
    });

    return child;
  },

  /**
   * Remove the child node if empty.
   * @param {{}} node - The parent node.
   * @param {string|{}} child - The child or name of child node.
   * @returns {undefined}
   */
  removeChildIfEmpty: function removeChildIfEmpty(node, child) {
    if (typeof child === 'string') child = this.findChild(node, child);
    if (child && this.isEmpty(child)) this.removeChild(node, child);
  }
};

},{"lodash":170}],30:[function(require,module,exports){
var asn1 = exports;

asn1.bignum = require('bn.js');

asn1.define = require('./asn1/api').define;
asn1.base = require('./asn1/base');
asn1.constants = require('./asn1/constants');
asn1.decoders = require('./asn1/decoders');
asn1.encoders = require('./asn1/encoders');

},{"./asn1/api":31,"./asn1/base":33,"./asn1/constants":37,"./asn1/decoders":39,"./asn1/encoders":42,"bn.js":45}],31:[function(require,module,exports){
var asn1 = require('../asn1');
var inherits = require('inherits');

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = require('vm').runInThisContext(
      '(function ' + this.name + '(entity) {\n' +
      '  this._initNamed(entity);\n' +
      '})'
    );
  } catch (e) {
    named = function (entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};

},{"../asn1":30,"inherits":131,"vm":240}],32:[function(require,module,exports){
var inherits = require('inherits');
var Reporter = require('../base').Reporter;
var Buffer = require('buffer').Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
}

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
}

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
}

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!(item instanceof EncoderBuffer))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = new Buffer(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};

},{"../base":33,"buffer":77,"inherits":131}],33:[function(require,module,exports){
var base = exports;

base.Reporter = require('./reporter').Reporter;
base.DecoderBuffer = require('./buffer').DecoderBuffer;
base.EncoderBuffer = require('./buffer').EncoderBuffer;
base.Node = require('./node');

},{"./buffer":32,"./node":34,"./reporter":35}],34:[function(require,module,exports){
var Reporter = require('../base').Reporter;
var EncoderBuffer = require('../base').EncoderBuffer;
var DecoderBuffer = require('../base').DecoderBuffer;
var assert = require('minimalistic-assert');

// Supported tags
var tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
var methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
var overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      var res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any)
        var save = input.save();
      var body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any)
      result = result;
    else if (state.choice === null)
      result = this._decodeGeneric(state.tag, input, options);
    else
      result = this._decodeChoice(input, options);

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
          ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
        ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function(key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default']
    else
      return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(
        false,
        data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

},{"../base":33,"minimalistic-assert":173}],35:[function(require,module,exports){
var inherits = require('inherits');

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};

},{"inherits":131}],36:[function(require,module,exports){
var constants = require('../constants');

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);

},{"../constants":37}],37:[function(require,module,exports){
var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = require('./der');

},{"./der":36}],38:[function(require,module,exports){
var inherits = require('inherits');

var asn1 = require('../../asn1');
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer))
    data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer,
                                'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  var len = derDecodeLen(buffer,
                         decodedTag.primitive,
                         'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(
      buffer,
      'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    var res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len)
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
                                                    options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  var first = (identifiers[0] / 40) | 0;
  var second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}

},{"../../asn1":30,"inherits":131}],39:[function(require,module,exports){
var decoders = exports;

decoders.der = require('./der');
decoders.pem = require('./pem');

},{"./der":38,"./pem":40}],40:[function(require,module,exports){
var inherits = require('inherits');
var Buffer = require('buffer').Buffer;

var DERDecoder = require('./der');

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};

},{"./der":38,"buffer":77,"inherits":131}],41:[function(require,module,exports){
var inherits = require('inherits');
var Buffer = require('buffer').Buffer;

var asn1 = require('../../asn1');
var base = asn1.base;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
                                                              primitive,
                                                              cls,
                                                              content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0)
      size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8)
    size++;

  var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null)
    return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}

},{"../../asn1":30,"buffer":77,"inherits":131}],42:[function(require,module,exports){
var encoders = exports;

encoders.der = require('./der');
encoders.pem = require('./pem');

},{"./der":41,"./pem":43}],43:[function(require,module,exports){
var inherits = require('inherits');

var DEREncoder = require('./der');

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = [ '-----BEGIN ' + options.label + '-----' ];
  for (var i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};

},{"./der":41,"inherits":131}],44:[function(require,module,exports){
'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}

},{}],45:[function(require,module,exports){
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = require('buffer').Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

      // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      r.strip();
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

},{"buffer":47}],46:[function(require,module,exports){
var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = require('crypto');
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}

},{"crypto":47}],47:[function(require,module,exports){

},{}],48:[function(require,module,exports){
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = require('safe-buffer').Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES

},{"safe-buffer":225}],49:[function(require,module,exports){
var aes = require('./aes')
var Buffer = require('safe-buffer').Buffer
var Transform = require('cipher-base')
var inherits = require('inherits')
var GHASH = require('./ghash')
var xor = require('buffer-xor')
var incr32 = require('./incr32')

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher

},{"./aes":48,"./ghash":53,"./incr32":54,"buffer-xor":76,"cipher-base":79,"inherits":131,"safe-buffer":225}],50:[function(require,module,exports){
var ciphers = require('./encrypter')
var deciphers = require('./decrypter')
var modes = require('./modes/list.json')

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers

},{"./decrypter":51,"./encrypter":52,"./modes/list.json":62}],51:[function(require,module,exports){
var AuthCipher = require('./authCipher')
var Buffer = require('safe-buffer').Buffer
var MODES = require('./modes')
var StreamCipher = require('./streamCipher')
var Transform = require('cipher-base')
var aes = require('./aes')
var ebtk = require('evp_bytestokey')
var inherits = require('inherits')

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv

},{"./aes":48,"./authCipher":49,"./modes":61,"./streamCipher":64,"cipher-base":79,"evp_bytestokey":114,"inherits":131,"safe-buffer":225}],52:[function(require,module,exports){
var MODES = require('./modes')
var AuthCipher = require('./authCipher')
var Buffer = require('safe-buffer').Buffer
var StreamCipher = require('./streamCipher')
var Transform = require('cipher-base')
var aes = require('./aes')
var ebtk = require('evp_bytestokey')
var inherits = require('inherits')

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher

},{"./aes":48,"./authCipher":49,"./modes":61,"./streamCipher":64,"cipher-base":79,"evp_bytestokey":114,"inherits":131,"safe-buffer":225}],53:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH

},{"safe-buffer":225}],54:[function(require,module,exports){
function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32

},{}],55:[function(require,module,exports){
var xor = require('buffer-xor')

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}

},{"buffer-xor":76}],56:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer
var xor = require('buffer-xor')

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}

},{"buffer-xor":76,"safe-buffer":225}],57:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}

},{"safe-buffer":225}],58:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}

},{"safe-buffer":225}],59:[function(require,module,exports){
var xor = require('buffer-xor')
var Buffer = require('safe-buffer').Buffer
var incr32 = require('../incr32')

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

},{"../incr32":54,"buffer-xor":76,"safe-buffer":225}],60:[function(require,module,exports){
exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}

},{}],61:[function(require,module,exports){
var modeModules = {
  ECB: require('./ecb'),
  CBC: require('./cbc'),
  CFB: require('./cfb'),
  CFB8: require('./cfb8'),
  CFB1: require('./cfb1'),
  OFB: require('./ofb'),
  CTR: require('./ctr'),
  GCM: require('./ctr')
}

var modes = require('./list.json')

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes

},{"./cbc":55,"./cfb":56,"./cfb1":57,"./cfb8":58,"./ctr":59,"./ecb":60,"./list.json":62,"./ofb":63}],62:[function(require,module,exports){
module.exports={
  "aes-128-ecb": {
    "cipher": "AES",
    "key": 128,
    "iv": 0,
    "mode": "ECB",
    "type": "block"
  },
  "aes-192-ecb": {
    "cipher": "AES",
    "key": 192,
    "iv": 0,
    "mode": "ECB",
    "type": "block"
  },
  "aes-256-ecb": {
    "cipher": "AES",
    "key": 256,
    "iv": 0,
    "mode": "ECB",
    "type": "block"
  },
  "aes-128-cbc": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes-192-cbc": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes-256-cbc": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes128": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes192": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes256": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes-128-cfb": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CFB",
    "type": "stream"
  },
  "aes-192-cfb": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CFB",
    "type": "stream"
  },
  "aes-256-cfb": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CFB",
    "type": "stream"
  },
  "aes-128-cfb8": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CFB8",
    "type": "stream"
  },
  "aes-192-cfb8": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CFB8",
    "type": "stream"
  },
  "aes-256-cfb8": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CFB8",
    "type": "stream"
  },
  "aes-128-cfb1": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CFB1",
    "type": "stream"
  },
  "aes-192-cfb1": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CFB1",
    "type": "stream"
  },
  "aes-256-cfb1": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CFB1",
    "type": "stream"
  },
  "aes-128-ofb": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "OFB",
    "type": "stream"
  },
  "aes-192-ofb": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "OFB",
    "type": "stream"
  },
  "aes-256-ofb": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "OFB",
    "type": "stream"
  },
  "aes-128-ctr": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CTR",
    "type": "stream"
  },
  "aes-192-ctr": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CTR",
    "type": "stream"
  },
  "aes-256-ctr": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CTR",
    "type": "stream"
  },
  "aes-128-gcm": {
    "cipher": "AES",
    "key": 128,
    "iv": 12,
    "mode": "GCM",
    "type": "auth"
  },
  "aes-192-gcm": {
    "cipher": "AES",
    "key": 192,
    "iv": 12,
    "mode": "GCM",
    "type": "auth"
  },
  "aes-256-gcm": {
    "cipher": "AES",
    "key": 256,
    "iv": 12,
    "mode": "GCM",
    "type": "auth"
  }
}

},{}],63:[function(require,module,exports){
(function (Buffer){
var xor = require('buffer-xor')

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

}).call(this,require("buffer").Buffer)

},{"buffer":77,"buffer-xor":76}],64:[function(require,module,exports){
var aes = require('./aes')
var Buffer = require('safe-buffer').Buffer
var Transform = require('cipher-base')
var inherits = require('inherits')

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher

},{"./aes":48,"cipher-base":79,"inherits":131,"safe-buffer":225}],65:[function(require,module,exports){
var DES = require('browserify-des')
var aes = require('browserify-aes/browser')
var aesModes = require('browserify-aes/modes')
var desModes = require('browserify-des/modes')
var ebtk = require('evp_bytestokey')

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers

},{"browserify-aes/browser":50,"browserify-aes/modes":61,"browserify-des":66,"browserify-des/modes":67,"evp_bytestokey":114}],66:[function(require,module,exports){
var CipherBase = require('cipher-base')
var des = require('des.js')
var inherits = require('inherits')
var Buffer = require('safe-buffer').Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}

},{"cipher-base":79,"des.js":87,"inherits":131,"safe-buffer":225}],67:[function(require,module,exports){
exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}

},{}],68:[function(require,module,exports){
(function (Buffer){
var bn = require('bn.js');
var randomBytes = require('randombytes');
module.exports = crt;
function blind(priv) {
  var r = getr(priv);
  var blinder = r.toRed(bn.mont(priv.modulus))
  .redPow(new bn(priv.publicExponent)).fromRed();
  return {
    blinder: blinder,
    unblinder:r.invm(priv.modulus)
  };
}
function crt(msg, priv) {
  var blinds = blind(priv);
  var len = priv.modulus.byteLength();
  var mod = bn.mont(priv.modulus);
  var blinded = new bn(msg).mul(blinds.blinder).umod(priv.modulus);
  var c1 = blinded.toRed(bn.mont(priv.prime1));
  var c2 = blinded.toRed(bn.mont(priv.prime2));
  var qinv = priv.coefficient;
  var p = priv.prime1;
  var q = priv.prime2;
  var m1 = c1.redPow(priv.exponent1);
  var m2 = c2.redPow(priv.exponent2);
  m1 = m1.fromRed();
  m2 = m2.fromRed();
  var h = m1.isub(m2).imul(qinv).umod(p);
  h.imul(q);
  m2.iadd(h);
  return new Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
}
crt.getr = getr;
function getr(priv) {
  var len = priv.modulus.byteLength();
  var r = new bn(randomBytes(len));
  while (r.cmp(priv.modulus) >=  0 || !r.umod(priv.prime1) || !r.umod(priv.prime2)) {
    r = new bn(randomBytes(len));
  }
  return r;
}

}).call(this,require("buffer").Buffer)

},{"bn.js":45,"buffer":77,"randombytes":209}],69:[function(require,module,exports){
module.exports = require('./browser/algorithms.json')

},{"./browser/algorithms.json":70}],70:[function(require,module,exports){
module.exports={
  "sha224WithRSAEncryption": {
    "sign": "rsa",
    "hash": "sha224",
    "id": "302d300d06096086480165030402040500041c"
  },
  "RSA-SHA224": {
    "sign": "ecdsa/rsa",
    "hash": "sha224",
    "id": "302d300d06096086480165030402040500041c"
  },
  "sha256WithRSAEncryption": {
    "sign": "rsa",
    "hash": "sha256",
    "id": "3031300d060960864801650304020105000420"
  },
  "RSA-SHA256": {
    "sign": "ecdsa/rsa",
    "hash": "sha256",
    "id": "3031300d060960864801650304020105000420"
  },
  "sha384WithRSAEncryption": {
    "sign": "rsa",
    "hash": "sha384",
    "id": "3041300d060960864801650304020205000430"
  },
  "RSA-SHA384": {
    "sign": "ecdsa/rsa",
    "hash": "sha384",
    "id": "3041300d060960864801650304020205000430"
  },
  "sha512WithRSAEncryption": {
    "sign": "rsa",
    "hash": "sha512",
    "id": "3051300d060960864801650304020305000440"
  },
  "RSA-SHA512": {
    "sign": "ecdsa/rsa",
    "hash": "sha512",
    "id": "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    "sign": "rsa",
    "hash": "sha1",
    "id": "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    "sign": "ecdsa",
    "hash": "sha1",
    "id": ""
  },
  "sha256": {
    "sign": "ecdsa",
    "hash": "sha256",
    "id": ""
  },
  "sha224": {
    "sign": "ecdsa",
    "hash": "sha224",
    "id": ""
  },
  "sha384": {
    "sign": "ecdsa",
    "hash": "sha384",
    "id": ""
  },
  "sha512": {
    "sign": "ecdsa",
    "hash": "sha512",
    "id": ""
  },
  "DSA-SHA": {
    "sign": "dsa",
    "hash": "sha1",
    "id": ""
  },
  "DSA-SHA1": {
    "sign": "dsa",
    "hash": "sha1",
    "id": ""
  },
  "DSA": {
    "sign": "dsa",
    "hash": "sha1",
    "id": ""
  },
  "DSA-WITH-SHA224": {
    "sign": "dsa",
    "hash": "sha224",
    "id": ""
  },
  "DSA-SHA224": {
    "sign": "dsa",
    "hash": "sha224",
    "id": ""
  },
  "DSA-WITH-SHA256": {
    "sign": "dsa",
    "hash": "sha256",
    "id": ""
  },
  "DSA-SHA256": {
    "sign": "dsa",
    "hash": "sha256",
    "id": ""
  },
  "DSA-WITH-SHA384": {
    "sign": "dsa",
    "hash": "sha384",
    "id": ""
  },
  "DSA-SHA384": {
    "sign": "dsa",
    "hash": "sha384",
    "id": ""
  },
  "DSA-WITH-SHA512": {
    "sign": "dsa",
    "hash": "sha512",
    "id": ""
  },
  "DSA-SHA512": {
    "sign": "dsa",
    "hash": "sha512",
    "id": ""
  },
  "DSA-RIPEMD160": {
    "sign": "dsa",
    "hash": "rmd160",
    "id": ""
  },
  "ripemd160WithRSA": {
    "sign": "rsa",
    "hash": "rmd160",
    "id": "3021300906052b2403020105000414"
  },
  "RSA-RIPEMD160": {
    "sign": "rsa",
    "hash": "rmd160",
    "id": "3021300906052b2403020105000414"
  },
  "md5WithRSAEncryption": {
    "sign": "rsa",
    "hash": "md5",
    "id": "3020300c06082a864886f70d020505000410"
  },
  "RSA-MD5": {
    "sign": "rsa",
    "hash": "md5",
    "id": "3020300c06082a864886f70d020505000410"
  }
}

},{}],71:[function(require,module,exports){
module.exports={
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
}

},{}],72:[function(require,module,exports){
(function (Buffer){
var createHash = require('create-hash')
var stream = require('stream')
var inherits = require('inherits')
var sign = require('./sign')
var verify = require('./verify')

var algorithms = require('./algorithms.json')
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = new Buffer(algorithms[key].id, 'hex')
  algorithms[key.toLowerCase()] = algorithms[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(hash, key, this._hashType, this._signType, this._tag)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') sig = new Buffer(sig, enc)

  this.end()
  var hash = this._hash.digest()
  return verify(sig, hash, key, this._signType, this._tag)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}

}).call(this,require("buffer").Buffer)

},{"./algorithms.json":70,"./sign":73,"./verify":74,"buffer":77,"create-hash":82,"inherits":131,"stream":236}],73:[function(require,module,exports){
(function (Buffer){
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var createHmac = require('create-hmac')
var crt = require('browserify-rsa')
var EC = require('elliptic').ec
var BN = require('bn.js')
var parseKeys = require('parse-asn1')
var curves = require('./curves.json')

function sign (hash, key, hashType, signType, tag) {
  var priv = parseKeys(key)
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type')
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = priv.modulus.byteLength()
  var pad = [ 0, 1 ]
  while (hash.length + pad.length + 1 < len) pad.push(0xff)
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) pad.push(hash[i])

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.keyFromPrivate(priv.privateKey)
  var out = key.sign(hash)

  return new Buffer(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (s.cmpn(0) === 0) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) r = [ 0 ].concat(r)
  if (s[0] & 0x80) s = [ 0 ].concat(s)

  var total = r.length + s.length + 4
  var res = [ 0x30, total, 0x02, r.length ]
  res = res.concat(r, [ 0x02, s.length ], s)
  return new Buffer(res)
}

function getKey (x, q, hash, algo) {
  x = new Buffer(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - x.length)
    zeros.fill(0)
    x = Buffer.concat([ zeros, x ])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = new Buffer(hlen)
  v.fill(1)
  var k = new Buffer(hlen)
  k.fill(0)
  k = createHmac(algo, k).update(v).update(new Buffer([ 0 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  k = createHmac(algo, k).update(v).update(new Buffer([ 1 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  return { k: k, v: v }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) bits.ishrn(shift)
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = new Buffer(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - out.length)
    zeros.fill(0)
    out = Buffer.concat([ zeros, out ])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t
  var k

  do {
    t = new Buffer(0)

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
      t = Buffer.concat([ t, kv.v ])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k).update(kv.v).update(new Buffer([ 0 ])).digest()
    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey

}).call(this,require("buffer").Buffer)

},{"./curves.json":71,"bn.js":45,"browserify-rsa":68,"buffer":77,"create-hmac":84,"elliptic":97,"parse-asn1":195}],74:[function(require,module,exports){
(function (Buffer){
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var BN = require('bn.js')
var EC = require('elliptic').ec
var parseKeys = require('parse-asn1')
var curves = require('./curves.json')

function verify (sig, hash, key, signType, tag) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type')
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = pub.modulus.byteLength()
  var pad = [ 1 ]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = new Buffer(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))
  sig = new Buffer(sig.fromRed().toArray())
  var out = padNum < 8 ? 1 : 0
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) out = 1

  i = -1
  while (++i < len) out |= sig[i] ^ pad[i]
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q)
  return v.cmp(r) === 0
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
  if (b.cmp(q) >= q) throw new Error('invalid sig')
}

module.exports = verify

}).call(this,require("buffer").Buffer)

},{"./curves.json":71,"bn.js":45,"buffer":77,"elliptic":97,"parse-asn1":195}],75:[function(require,module,exports){
arguments[4][47][0].apply(exports,arguments)
},{"dup":47}],76:[function(require,module,exports){
(function (Buffer){
module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

}).call(this,require("buffer").Buffer)

},{"buffer":77}],77:[function(require,module,exports){
(function (Buffer){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = require('base64-js')
var ieee754 = require('ieee754')
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol.for === 'function')
    ? Symbol.for('nodejs.util.inspect.custom')
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
if (typeof Symbol !== 'undefined' && Symbol.species != null &&
    Buffer[Symbol.species] === Buffer) {
  Object.defineProperty(Buffer, Symbol.species, {
    value: null,
    configurable: true,
    enumerable: false,
    writable: false
  })
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayLike(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      buf = Buffer.from(buf)
    }
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
        : (firstByte > 0xBF) ? 2
          : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (var i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()

}).call(this,require("buffer").Buffer)

},{"base64-js":44,"buffer":77,"ieee754":129}],78:[function(require,module,exports){
(function (process,Buffer){
/* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*jshint eqnull:true */
/*exported CFB */
/*global module, require:false, process:false, Buffer:false, Uint8Array:false, Uint16Array:false */

var Base64 = (function make_b64(){
	var map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	return {
		encode: function(input) {
			var o = "";
			var c1=0, c2=0, c3=0, e1=0, e2=0, e3=0, e4=0;
			for(var i = 0; i < input.length; ) {
				c1 = input.charCodeAt(i++);
				e1 = (c1 >> 2);

				c2 = input.charCodeAt(i++);
				e2 = ((c1 & 3) << 4) | (c2 >> 4);

				c3 = input.charCodeAt(i++);
				e3 = ((c2 & 15) << 2) | (c3 >> 6);
				e4 = (c3 & 63);
				if (isNaN(c2)) { e3 = e4 = 64; }
				else if (isNaN(c3)) { e4 = 64; }
				o += map.charAt(e1) + map.charAt(e2) + map.charAt(e3) + map.charAt(e4);
			}
			return o;
		},
		decode: function b64_decode(input) {
			var o = "";
			var c1=0, c2=0, c3=0, e1=0, e2=0, e3=0, e4=0;
			input = input.replace(/[^\w\+\/\=]/g, "");
			for(var i = 0; i < input.length;) {
				e1 = map.indexOf(input.charAt(i++));
				e2 = map.indexOf(input.charAt(i++));
				c1 = (e1 << 2) | (e2 >> 4);
				o += String.fromCharCode(c1);

				e3 = map.indexOf(input.charAt(i++));
				c2 = ((e2 & 15) << 4) | (e3 >> 2);
				if (e3 !== 64) { o += String.fromCharCode(c2); }

				e4 = map.indexOf(input.charAt(i++));
				c3 = ((e3 & 3) << 6) | e4;
				if (e4 !== 64) { o += String.fromCharCode(c3); }
			}
			return o;
		}
	};
})();
var has_buf = (typeof Buffer !== 'undefined' && typeof process !== 'undefined' && typeof process.versions !== 'undefined' && process.versions.node);

var Buffer_from = function(){};

if(typeof Buffer !== 'undefined') {
	var nbfs = !Buffer.from;
	if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
	Buffer_from = nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
	// $FlowIgnore
	if(!Buffer.alloc) Buffer.alloc = function(n) { return new Buffer(n); };
	// $FlowIgnore
	if(!Buffer.allocUnsafe) Buffer.allocUnsafe = function(n) { return new Buffer(n); };
}

function new_raw_buf(len) {
	/* jshint -W056 */
	return has_buf ? Buffer.alloc(len) : new Array(len);
	/* jshint +W056 */
}

function new_unsafe_buf(len) {
	/* jshint -W056 */
	return has_buf ? Buffer.allocUnsafe(len) : new Array(len);
	/* jshint +W056 */
}

var s2a = function s2a(s) {
	if(has_buf) return Buffer_from(s, "binary");
	return s.split("").map(function(x){ return x.charCodeAt(0) & 0xff; });
};

var chr0 = /\u0000/g, chr1 = /[\u0001-\u0006]/g;
var __toBuffer = function(bufs) { var x = []; for(var i = 0; i < bufs[0].length; ++i) { x.push.apply(x, bufs[0][i]); } return x; };
var ___toBuffer = __toBuffer;
var __utf16le = function(b,s,e) { var ss=[]; for(var i=s; i<e; i+=2) ss.push(String.fromCharCode(__readUInt16LE(b,i))); return ss.join("").replace(chr0,''); };
var ___utf16le = __utf16le;
var __hexlify = function(b,s,l) { var ss=[]; for(var i=s; i<s+l; ++i) ss.push(("0" + b[i].toString(16)).slice(-2)); return ss.join(""); };
var ___hexlify = __hexlify;
var __bconcat = function(bufs) {
	if(Array.isArray(bufs[0])) return [].concat.apply([], bufs);
	var maxlen = 0, i = 0;
	for(i = 0; i < bufs.length; ++i) maxlen += bufs[i].length;
	var o = new Uint8Array(maxlen);
	for(i = 0, maxlen = 0; i < bufs.length; maxlen += bufs[i].length, ++i) o.set(bufs[i], maxlen);
	return o;
};
var bconcat = __bconcat;


if(has_buf) {
	__utf16le = function(b,s,e) {
		if(!Buffer.isBuffer(b)) return ___utf16le(b,s,e);
		return b.toString('utf16le',s,e).replace(chr0,'')/*.replace(chr1,'!')*/;
	};
	__hexlify = function(b,s,l) { return Buffer.isBuffer(b) ? b.toString('hex',s,s+l) : ___hexlify(b,s,l); };
	__toBuffer = function(bufs) { return (bufs[0].length > 0 && Buffer.isBuffer(bufs[0][0])) ? Buffer.concat((bufs[0])) : ___toBuffer(bufs);};
	s2a = function(s) { return Buffer_from(s, "binary"); };
	bconcat = function(bufs) { return Buffer.isBuffer(bufs[0]) ? Buffer.concat(bufs) : __bconcat(bufs); };
}


var __readUInt8 = function(b, idx) { return b[idx]; };
var __readUInt16LE = function(b, idx) { return b[idx+1]*(1<<8)+b[idx]; };
var __readInt16LE = function(b, idx) { var u = b[idx+1]*(1<<8)+b[idx]; return (u < 0x8000) ? u : (0xffff - u + 1) * -1; };
var __readUInt32LE = function(b, idx) { return b[idx+3]*(1<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx]; };
var __readInt32LE = function(b, idx) { return (b[idx+3]<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx]; };

function ReadShift(size, t) {
	var oI, oS, type = 0;
	switch(size) {
		case 1: oI = __readUInt8(this, this.l); break;
		case 2: oI = (t !== 'i' ? __readUInt16LE : __readInt16LE)(this, this.l); break;
		case 4: oI = __readInt32LE(this, this.l); break;
		case 16: type = 2; oS = __hexlify(this, this.l, size);
	}
	this.l += size; if(type === 0) return oI; return oS;
}

var __writeUInt32LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); b[idx+2] = ((val >>> 16) & 0xFF); b[idx+3] = ((val >>> 24) & 0xFF); };
var __writeInt32LE  = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >> 8) & 0xFF); b[idx+2] = ((val >> 16) & 0xFF); b[idx+3] = ((val >> 24) & 0xFF); };

function WriteShift(t, val, f) {
	var size = 0, i = 0;
	switch(f) {
		case "hex": for(; i < t; ++i) {
this[this.l++] = parseInt(val.slice(2*i, 2*i+2), 16)||0;
		} return this;
		case "utf16le":
var end = this.l + t;
			for(i = 0; i < Math.min(val.length, t); ++i) {
				var cc = val.charCodeAt(i);
				this[this.l++] = cc & 0xff;
				this[this.l++] = cc >> 8;
			}
			while(this.l < end) this[this.l++] = 0;
			return this;
	}
switch(t) {
		case  1: size = 1; this[this.l] = val&0xFF; break;
		case  2: size = 2; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; break;
		case  4: size = 4; __writeUInt32LE(this, val, this.l); break;
		case -4: size = 4; __writeInt32LE(this, val, this.l); break;
	}
	this.l += size; return this;
}

function CheckField(hexstr, fld) {
	var m = __hexlify(this,this.l,hexstr.length>>1);
	if(m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
	this.l += hexstr.length>>1;
}

function prep_blob(blob, pos) {
	blob.l = pos;
	blob.read_shift = ReadShift;
	blob.chk = CheckField;
	blob.write_shift = WriteShift;
}

function new_buf(sz) {
	var o = (new_raw_buf(sz));
	prep_blob(o, 0);
	return o;
}

/* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*exported CRC32 */
var CRC32;
(function (factory) {
	/*jshint ignore:start */
	/*eslint-disable */
	factory(CRC32 = {});
	/*eslint-enable */
	/*jshint ignore:end */
}(function(CRC32) {
CRC32.version = '1.2.0';
/* see perf/crc32table.js */
/*global Int32Array */
function signed_crc_table() {
	var c = 0, table = new Array(256);

	for(var n =0; n != 256; ++n){
		c = n;
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		table[n] = c;
	}

	return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
}

var T = signed_crc_table();
function crc32_bstr(bstr, seed) {
	var C = seed ^ -1, L = bstr.length - 1;
	for(var i = 0; i < L;) {
		C = (C>>>8) ^ T[(C^bstr.charCodeAt(i++))&0xFF];
		C = (C>>>8) ^ T[(C^bstr.charCodeAt(i++))&0xFF];
	}
	if(i === L) C = (C>>>8) ^ T[(C ^ bstr.charCodeAt(i))&0xFF];
	return C ^ -1;
}

function crc32_buf(buf, seed) {
	if(buf.length > 10000) return crc32_buf_8(buf, seed);
	var C = seed ^ -1, L = buf.length - 3;
	for(var i = 0; i < L;) {
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
	}
	while(i < L+3) C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
	return C ^ -1;
}

function crc32_buf_8(buf, seed) {
	var C = seed ^ -1, L = buf.length - 7;
	for(var i = 0; i < L;) {
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
	}
	while(i < L+7) C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
	return C ^ -1;
}

function crc32_str(str, seed) {
	var C = seed ^ -1;
	for(var i = 0, L=str.length, c, d; i < L;) {
		c = str.charCodeAt(i++);
		if(c < 0x80) {
			C = (C>>>8) ^ T[(C ^ c)&0xFF];
		} else if(c < 0x800) {
			C = (C>>>8) ^ T[(C ^ (192|((c>>6)&31)))&0xFF];
			C = (C>>>8) ^ T[(C ^ (128|(c&63)))&0xFF];
		} else if(c >= 0xD800 && c < 0xE000) {
			c = (c&1023)+64; d = str.charCodeAt(i++)&1023;
			C = (C>>>8) ^ T[(C ^ (240|((c>>8)&7)))&0xFF];
			C = (C>>>8) ^ T[(C ^ (128|((c>>2)&63)))&0xFF];
			C = (C>>>8) ^ T[(C ^ (128|((d>>6)&15)|((c&3)<<4)))&0xFF];
			C = (C>>>8) ^ T[(C ^ (128|(d&63)))&0xFF];
		} else {
			C = (C>>>8) ^ T[(C ^ (224|((c>>12)&15)))&0xFF];
			C = (C>>>8) ^ T[(C ^ (128|((c>>6)&63)))&0xFF];
			C = (C>>>8) ^ T[(C ^ (128|(c&63)))&0xFF];
		}
	}
	return C ^ -1;
}
CRC32.table = T;
CRC32.bstr = crc32_bstr;
CRC32.buf = crc32_buf;
CRC32.str = crc32_str;
}));
/* [MS-CFB] v20171201 */
var CFB = (function _CFB(){
var exports = {};
exports.version = '1.1.3';
/* [MS-CFB] 2.6.4 */
function namecmp(l, r) {
	var L = l.split("/"), R = r.split("/");
	for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i) {
		if((c = L[i].length - R[i].length)) return c;
		if(L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
	}
	return L.length - R.length;
}
function dirname(p) {
	if(p.charAt(p.length - 1) == "/") return (p.slice(0,-1).indexOf("/") === -1) ? p : dirname(p.slice(0, -1));
	var c = p.lastIndexOf("/");
	return (c === -1) ? p : p.slice(0, c+1);
}

function filename(p) {
	if(p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
	var c = p.lastIndexOf("/");
	return (c === -1) ? p : p.slice(c+1);
}
/* -------------------------------------------------------------------------- */
/* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/

/* write JS date to buf as a DOS date */
function write_dos_date(buf, date) {
	if(typeof date === "string") date = new Date(date);
	var hms = date.getHours();
	hms = hms << 6 | date.getMinutes();
	hms = hms << 5 | (date.getSeconds()>>>1);
	buf.write_shift(2, hms);
	var ymd = (date.getFullYear() - 1980);
	ymd = ymd << 4 | (date.getMonth()+1);
	ymd = ymd << 5 | date.getDate();
	buf.write_shift(2, ymd);
}

/* read four bytes from buf and interpret as a DOS date */
function parse_dos_date(buf) {
	var hms = buf.read_shift(2) & 0xFFFF;
	var ymd = buf.read_shift(2) & 0xFFFF;
	var val = new Date();
	var d = ymd & 0x1F; ymd >>>= 5;
	var m = ymd & 0x0F; ymd >>>= 4;
	val.setMilliseconds(0);
	val.setFullYear(ymd + 1980);
	val.setMonth(m-1);
	val.setDate(d);
	var S = hms & 0x1F; hms >>>= 5;
	var M = hms & 0x3F; hms >>>= 6;
	val.setHours(hms);
	val.setMinutes(M);
	val.setSeconds(S<<1);
	return val;
}
function parse_extra_field(blob) {
	prep_blob(blob, 0);
	var o = {};
	var flags = 0;
	while(blob.l <= blob.length - 4) {
		var type = blob.read_shift(2);
		var sz = blob.read_shift(2), tgt = blob.l + sz;
		var p = {};
		switch(type) {
			/* UNIX-style Timestamps */
			case 0x5455: {
				flags = blob.read_shift(1);
				if(flags & 1) p.mtime = blob.read_shift(4);
				/* for some reason, CD flag corresponds to LFH */
				if(sz > 5) {
					if(flags & 2) p.atime = blob.read_shift(4);
					if(flags & 4) p.ctime = blob.read_shift(4);
				}
				if(p.mtime) p.mt = new Date(p.mtime*1000);
			}
			break;
		}
		blob.l = tgt;
		o[type] = p;
	}
	return o;
}
var fs;
function get_fs() { return fs || (fs = require('fs')); }
function parse(file, options) {
if(file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
if(file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
var mver = 3;
var ssz = 512;
var nmfs = 0; // number of mini FAT sectors
var difat_sec_cnt = 0;
var dir_start = 0;
var minifat_start = 0;
var difat_start = 0;

var fat_addrs = []; // locations of FAT sectors

/* [MS-CFB] 2.2 Compound File Header */
var blob = file.slice(0,512);
prep_blob(blob, 0);

/* major version */
var mv = check_get_mver(blob);
mver = mv[0];
switch(mver) {
	case 3: ssz = 512; break; case 4: ssz = 4096; break;
	case 0: if(mv[1] == 0) return parse_zip(file, options);
	/* falls through */
	default: throw new Error("Major Version: Expected 3 or 4 saw " + mver);
}

/* reprocess header */
if(ssz !== 512) { blob = file.slice(0,ssz); prep_blob(blob, 28 /* blob.l */); }
/* Save header for final object */
var header = file.slice(0,ssz);

check_shifts(blob, mver);

// Number of Directory Sectors
var dir_cnt = blob.read_shift(4, 'i');
if(mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);

// Number of FAT Sectors
blob.l += 4;

// First Directory Sector Location
dir_start = blob.read_shift(4, 'i');

// Transaction Signature
blob.l += 4;

// Mini Stream Cutoff Size
blob.chk('00100000', 'Mini Stream Cutoff Size: ');

// First Mini FAT Sector Location
minifat_start = blob.read_shift(4, 'i');

// Number of Mini FAT Sectors
nmfs = blob.read_shift(4, 'i');

// First DIFAT sector location
difat_start = blob.read_shift(4, 'i');

// Number of DIFAT Sectors
difat_sec_cnt = blob.read_shift(4, 'i');

// Grab FAT Sector Locations
for(var q = -1, j = 0; j < 109; ++j) { /* 109 = (512 - blob.l)>>>2; */
	q = blob.read_shift(4, 'i');
	if(q<0) break;
	fat_addrs[j] = q;
}

/** Break the file up into sectors */
var sectors = sectorify(file, ssz);

sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);

/** Chains */
var sector_list = make_sector_list(sectors, dir_start, fat_addrs, ssz);

sector_list[dir_start].name = "!Directory";
if(nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
sector_list[fat_addrs[0]].name = "!FAT";
sector_list.fat_addrs = fat_addrs;
sector_list.ssz = ssz;

/* [MS-CFB] 2.6.1 Compound File Directory Entry */
var files = {}, Paths = [], FileIndex = [], FullPaths = [];
read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);

build_full_paths(FileIndex, FullPaths, Paths);
Paths.shift();

var o = {
	FileIndex: FileIndex,
	FullPaths: FullPaths
};

// $FlowIgnore
if(options && options.raw) o.raw = {header: header, sectors: sectors};
return o;
} // parse

/* [MS-CFB] 2.2 Compound File Header -- read up to major version */
function check_get_mver(blob) {
	if(blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [0, 0];
	// header signature 8
	blob.chk(HEADER_SIGNATURE, 'Header Signature: ');

	// clsid 16
	//blob.chk(HEADER_CLSID, 'CLSID: ');
	blob.l += 16;

	// minor version 2
	var mver = blob.read_shift(2, 'u');

	return [blob.read_shift(2,'u'), mver];
}
function check_shifts(blob, mver) {
	var shift = 0x09;

	// Byte Order
	//blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
	blob.l += 2;

	// Sector Shift
	switch((shift = blob.read_shift(2))) {
		case 0x09: if(mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift); break;
		case 0x0c: if(mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift); break;
		default: throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
	}

	// Mini Sector Shift
	blob.chk('0600', 'Mini Sector Shift: ');

	// Reserved
	blob.chk('000000000000', 'Reserved: ');
}

/** Break the file up into sectors */
function sectorify(file, ssz) {
	var nsectors = Math.ceil(file.length/ssz)-1;
	var sectors = [];
	for(var i=1; i < nsectors; ++i) sectors[i-1] = file.slice(i*ssz,(i+1)*ssz);
	sectors[nsectors-1] = file.slice(nsectors*ssz);
	return sectors;
}

/* [MS-CFB] 2.6.4 Red-Black Tree */
function build_full_paths(FI, FP, Paths) {
	var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
	var dad = [], q = [];

	for(; i < pl; ++i) { dad[i]=q[i]=i; FP[i]=Paths[i]; }

	for(; j < q.length; ++j) {
		i = q[j];
		L = FI[i].L; R = FI[i].R; C = FI[i].C;
		if(dad[i] === i) {
			if(L !== -1 /*NOSTREAM*/ && dad[L] !== L) dad[i] = dad[L];
			if(R !== -1 && dad[R] !== R) dad[i] = dad[R];
		}
		if(C !== -1 /*NOSTREAM*/) dad[C] = i;
		if(L !== -1 && i != dad[i]) { dad[L] = dad[i]; if(q.lastIndexOf(L) < j) q.push(L); }
		if(R !== -1 && i != dad[i]) { dad[R] = dad[i]; if(q.lastIndexOf(R) < j) q.push(R); }
	}
	for(i=1; i < pl; ++i) if(dad[i] === i) {
		if(R !== -1 /*NOSTREAM*/ && dad[R] !== R) dad[i] = dad[R];
		else if(L !== -1 && dad[L] !== L) dad[i] = dad[L];
	}

	for(i=1; i < pl; ++i) {
		if(FI[i].type === 0 /* unknown */) continue;
		j = i;
		if(j != dad[j]) do {
			j = dad[j];
			FP[i] = FP[j] + "/" + FP[i];
		} while (j !== 0 && -1 !== dad[j] && j != dad[j]);
		dad[i] = -1;
	}

	FP[0] += "/";
	for(i=1; i < pl; ++i) {
		if(FI[i].type !== 2 /* stream */) FP[i] += "/";
	}
}

function get_mfat_entry(entry, payload, mini) {
	var start = entry.start, size = entry.size;
	//return (payload.slice(start*MSSZ, start*MSSZ + size));
	var o = [];
	var idx = start;
	while(mini && size > 0 && idx >= 0) {
		o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
		size -= MSSZ;
		idx = __readInt32LE(mini, idx * 4);
	}
	if(o.length === 0) return (new_buf(0));
	return (bconcat(o).slice(0, entry.size));
}

/** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */
function sleuth_fat(idx, cnt, sectors, ssz, fat_addrs) {
	var q = ENDOFCHAIN;
	if(idx === ENDOFCHAIN) {
		if(cnt !== 0) throw new Error("DIFAT chain shorter than expected");
	} else if(idx !== -1 /*FREESECT*/) {
		var sector = sectors[idx], m = (ssz>>>2)-1;
		if(!sector) return;
		for(var i = 0; i < m; ++i) {
			if((q = __readInt32LE(sector,i*4)) === ENDOFCHAIN) break;
			fat_addrs.push(q);
		}
		sleuth_fat(__readInt32LE(sector,ssz-4),cnt - 1, sectors, ssz, fat_addrs);
	}
}

/** Follow the linked list of sectors for a given starting point */
function get_sector_list(sectors, start, fat_addrs, ssz, chkd) {
	var buf = [], buf_chain = [];
	if(!chkd) chkd = [];
	var modulus = ssz - 1, j = 0, jj = 0;
	for(j=start; j>=0;) {
		chkd[j] = true;
		buf[buf.length] = j;
		buf_chain.push(sectors[j]);
		var addr = fat_addrs[Math.floor(j*4/ssz)];
		jj = ((j*4) & modulus);
		if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
		if(!sectors[addr]) break;
		j = __readInt32LE(sectors[addr], jj);
	}
	return {nodes: buf, data:__toBuffer([buf_chain])};
}

/** Chase down the sector linked lists */
function make_sector_list(sectors, dir_start, fat_addrs, ssz) {
	var sl = sectors.length, sector_list = ([]);
	var chkd = [], buf = [], buf_chain = [];
	var modulus = ssz - 1, i=0, j=0, k=0, jj=0;
	for(i=0; i < sl; ++i) {
		buf = ([]);
		k = (i + dir_start); if(k >= sl) k-=sl;
		if(chkd[k]) continue;
		buf_chain = [];
		for(j=k; j>=0;) {
			chkd[j] = true;
			buf[buf.length] = j;
			buf_chain.push(sectors[j]);
			var addr = fat_addrs[Math.floor(j*4/ssz)];
			jj = ((j*4) & modulus);
			if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
			if(!sectors[addr]) break;
			j = __readInt32LE(sectors[addr], jj);
		}
		sector_list[k] = ({nodes: buf, data:__toBuffer([buf_chain])});
	}
	return sector_list;
}

/* [MS-CFB] 2.6.1 Compound File Directory Entry */
function read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, mini) {
	var minifat_store = 0, pl = (Paths.length?2:0);
	var sector = sector_list[dir_start].data;
	var i = 0, namelen = 0, name;
	for(; i < sector.length; i+= 128) {
		var blob = sector.slice(i, i+128);
		prep_blob(blob, 64);
		namelen = blob.read_shift(2);
		name = __utf16le(blob,0,namelen-pl);
		Paths.push(name);
		var o = ({
			name:  name,
			type:  blob.read_shift(1),
			color: blob.read_shift(1),
			L:     blob.read_shift(4, 'i'),
			R:     blob.read_shift(4, 'i'),
			C:     blob.read_shift(4, 'i'),
			clsid: blob.read_shift(16),
			state: blob.read_shift(4, 'i'),
			start: 0,
			size: 0
		});
		var ctime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
		if(ctime !== 0) o.ct = read_date(blob, blob.l-8);
		var mtime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
		if(mtime !== 0) o.mt = read_date(blob, blob.l-8);
		o.start = blob.read_shift(4, 'i');
		o.size = blob.read_shift(4, 'i');
		if(o.size < 0 && o.start < 0) { o.size = o.type = 0; o.start = ENDOFCHAIN; o.name = ""; }
		if(o.type === 5) { /* root */
			minifat_store = o.start;
			if(nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
			/*minifat_size = o.size;*/
		} else if(o.size >= 4096 /* MSCSZ */) {
			o.storage = 'fat';
			if(sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
			sector_list[o.start].name = o.name;
			o.content = (sector_list[o.start].data.slice(0,o.size));
		} else {
			o.storage = 'minifat';
			if(o.size < 0) o.size = 0;
			else if(minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) {
				o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini]||{}).data);
			}
		}
		if(o.content) prep_blob(o.content, 0);
		files[name] = o;
		FileIndex.push(o);
	}
}

function read_date(blob, offset) {
	return new Date(( ( (__readUInt32LE(blob,offset+4)/1e7)*Math.pow(2,32)+__readUInt32LE(blob,offset)/1e7 ) - 11644473600)*1000);
}

function read_file(filename, options) {
	get_fs();
	return parse(fs.readFileSync(filename), options);
}

function read(blob, options) {
	switch(options && options.type || "base64") {
		case "file": return read_file(blob, options);
		case "base64": return parse(s2a(Base64.decode(blob)), options);
		case "binary": return parse(s2a(blob), options);
	}
	return parse(blob, options);
}

function init_cfb(cfb, opts) {
	var o = opts || {}, root = o.root || "Root Entry";
	if(!cfb.FullPaths) cfb.FullPaths = [];
	if(!cfb.FileIndex) cfb.FileIndex = [];
	if(cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
	if(cfb.FullPaths.length === 0) {
		cfb.FullPaths[0] = root + "/";
		cfb.FileIndex[0] = ({ name: root, type: 5 });
	}
	if(o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
	seed_cfb(cfb);
}
function seed_cfb(cfb) {
	var nm = "\u0001Sh33tJ5";
	if(CFB.find(cfb, "/" + nm)) return;
	var p = new_buf(4); p[0] = 55; p[1] = p[3] = 50; p[2] = 54;
	cfb.FileIndex.push(({ name: nm, type: 2, content:p, size:4, L:69, R:69, C:69 }));
	cfb.FullPaths.push(cfb.FullPaths[0] + nm);
	rebuild_cfb(cfb);
}
function rebuild_cfb(cfb, f) {
	init_cfb(cfb);
	var gc = false, s = false;
	for(var i = cfb.FullPaths.length - 1; i >= 0; --i) {
		var _file = cfb.FileIndex[i];
		switch(_file.type) {
			case 0:
				if(s) gc = true;
				else { cfb.FileIndex.pop(); cfb.FullPaths.pop(); }
				break;
			case 1: case 2: case 5:
				s = true;
				if(isNaN(_file.R * _file.L * _file.C)) gc = true;
				if(_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
				break;
			default: gc = true; break;
		}
	}
	if(!gc && !f) return;

	var now = new Date(1987, 1, 19), j = 0;
	var data = [];
	for(i = 0; i < cfb.FullPaths.length; ++i) {
		if(cfb.FileIndex[i].type === 0) continue;
		data.push([cfb.FullPaths[i], cfb.FileIndex[i]]);
	}
	for(i = 0; i < data.length; ++i) {
		var dad = dirname(data[i][0]);
		s = false;
		for(j = 0; j < data.length; ++j) if(data[j][0] === dad) s = true;
		if(!s) data.push([dad, ({
			name: filename(dad).replace("/",""),
			type: 1,
			clsid: HEADER_CLSID,
			ct: now, mt: now,
			content: null
		})]);
	}

	data.sort(function(x,y) { return namecmp(x[0], y[0]); });
	cfb.FullPaths = []; cfb.FileIndex = [];
	for(i = 0; i < data.length; ++i) { cfb.FullPaths[i] = data[i][0]; cfb.FileIndex[i] = data[i][1]; }
	for(i = 0; i < data.length; ++i) {
		var elt = cfb.FileIndex[i];
		var nm = cfb.FullPaths[i];

		elt.name =  filename(nm).replace("/","");
		elt.L = elt.R = elt.C = -(elt.color = 1);
		elt.size = elt.content ? elt.content.length : 0;
		elt.start = 0;
		elt.clsid = (elt.clsid || HEADER_CLSID);
		if(i === 0) {
			elt.C = data.length > 1 ? 1 : -1;
			elt.size = 0;
			elt.type = 5;
		} else if(nm.slice(-1) == "/") {
			for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==nm) break;
			elt.C = j >= data.length ? -1 : j;
			for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==dirname(nm)) break;
			elt.R = j >= data.length ? -1 : j;
			elt.type = 1;
		} else {
			if(dirname(cfb.FullPaths[i+1]||"") == dirname(nm)) elt.R = i + 1;
			elt.type = 2;
		}
	}

}

function _write(cfb, options) {
	var _opts = options || {};
	rebuild_cfb(cfb);
	if(_opts.fileType == 'zip') return write_zip(cfb, _opts);
	var L = (function(cfb){
		var mini_size = 0, fat_size = 0;
		for(var i = 0; i < cfb.FileIndex.length; ++i) {
			var file = cfb.FileIndex[i];
			if(!file.content) continue;
var flen = file.content.length;
			if(flen > 0){
				if(flen < 0x1000) mini_size += (flen + 0x3F) >> 6;
				else fat_size += (flen + 0x01FF) >> 9;
			}
		}
		var dir_cnt = (cfb.FullPaths.length +3) >> 2;
		var mini_cnt = (mini_size + 7) >> 3;
		var mfat_cnt = (mini_size + 0x7F) >> 7;
		var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
		var fat_cnt = (fat_base + 0x7F) >> 7;
		var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
		while(((fat_base + fat_cnt + difat_cnt + 0x7F) >> 7) > fat_cnt) difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
		var L =  [1, difat_cnt, fat_cnt, mfat_cnt, dir_cnt, fat_size, mini_size, 0];
		cfb.FileIndex[0].size = mini_size << 6;
		L[7] = (cfb.FileIndex[0].start=L[0]+L[1]+L[2]+L[3]+L[4]+L[5])+((L[6]+7) >> 3);
		return L;
	})(cfb);
	var o = new_buf(L[7] << 9);
	var i = 0, T = 0;
	{
		for(i = 0; i < 8; ++i) o.write_shift(1, HEADER_SIG[i]);
		for(i = 0; i < 8; ++i) o.write_shift(2, 0);
		o.write_shift(2, 0x003E);
		o.write_shift(2, 0x0003);
		o.write_shift(2, 0xFFFE);
		o.write_shift(2, 0x0009);
		o.write_shift(2, 0x0006);
		for(i = 0; i < 3; ++i) o.write_shift(2, 0);
		o.write_shift(4, 0);
		o.write_shift(4, L[2]);
		o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
		o.write_shift(4, 0);
		o.write_shift(4, 1<<12);
		o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1: ENDOFCHAIN);
		o.write_shift(4, L[3]);
		o.write_shift(-4, L[1] ? L[0] - 1: ENDOFCHAIN);
		o.write_shift(4, L[1]);
		for(i = 0; i < 109; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
	}
	if(L[1]) {
		for(T = 0; T < L[1]; ++T) {
			for(; i < 236 + T * 127; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
			o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
		}
	}
	var chainit = function(w) {
		for(T += w; i<T-1; ++i) o.write_shift(-4, i+1);
		if(w) { ++i; o.write_shift(-4, ENDOFCHAIN); }
	};
	T = i = 0;
	for(T+=L[1]; i<T; ++i) o.write_shift(-4, consts.DIFSECT);
	for(T+=L[2]; i<T; ++i) o.write_shift(-4, consts.FATSECT);
	chainit(L[3]);
	chainit(L[4]);
	var j = 0, flen = 0;
	var file = cfb.FileIndex[0];
	for(; j < cfb.FileIndex.length; ++j) {
		file = cfb.FileIndex[j];
		if(!file.content) continue;
flen = file.content.length;
		if(flen < 0x1000) continue;
		file.start = T;
		chainit((flen + 0x01FF) >> 9);
	}
	chainit((L[6] + 7) >> 3);
	while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
	T = i = 0;
	for(j = 0; j < cfb.FileIndex.length; ++j) {
		file = cfb.FileIndex[j];
		if(!file.content) continue;
flen = file.content.length;
		if(!flen || flen >= 0x1000) continue;
		file.start = T;
		chainit((flen + 0x3F) >> 6);
	}
	while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
	for(i = 0; i < L[4]<<2; ++i) {
		var nm = cfb.FullPaths[i];
		if(!nm || nm.length === 0) {
			for(j = 0; j < 17; ++j) o.write_shift(4, 0);
			for(j = 0; j < 3; ++j) o.write_shift(4, -1);
			for(j = 0; j < 12; ++j) o.write_shift(4, 0);
			continue;
		}
		file = cfb.FileIndex[i];
		if(i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
		var _nm = (i === 0 && _opts.root) || file.name;
		flen = 2*(_nm.length+1);
		o.write_shift(64, _nm, "utf16le");
		o.write_shift(2, flen);
		o.write_shift(1, file.type);
		o.write_shift(1, file.color);
		o.write_shift(-4, file.L);
		o.write_shift(-4, file.R);
		o.write_shift(-4, file.C);
		if(!file.clsid) for(j = 0; j < 4; ++j) o.write_shift(4, 0);
		else o.write_shift(16, file.clsid, "hex");
		o.write_shift(4, file.state || 0);
		o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(4, file.start);
		o.write_shift(4, file.size); o.write_shift(4, 0);
	}
	for(i = 1; i < cfb.FileIndex.length; ++i) {
		file = cfb.FileIndex[i];
if(file.size >= 0x1000) {
			o.l = (file.start+1) << 9;
			for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
			for(; j & 0x1FF; ++j) o.write_shift(1, 0);
		}
	}
	for(i = 1; i < cfb.FileIndex.length; ++i) {
		file = cfb.FileIndex[i];
if(file.size > 0 && file.size < 0x1000) {
			for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
			for(; j & 0x3F; ++j) o.write_shift(1, 0);
		}
	}
	while(o.l < o.length) o.write_shift(1, 0);
	return o;
}
/* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */
function find(cfb, path) {
	var UCFullPaths = cfb.FullPaths.map(function(x) { return x.toUpperCase(); });
	var UCPaths = UCFullPaths.map(function(x) { var y = x.split("/"); return y[y.length - (x.slice(-1) == "/" ? 2 : 1)]; });
	var k = false;
	if(path.charCodeAt(0) === 47 /* "/" */) { k = true; path = UCFullPaths[0].slice(0, -1) + path; }
	else k = path.indexOf("/") !== -1;
	var UCPath = path.toUpperCase();
	var w = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
	if(w !== -1) return cfb.FileIndex[w];

	var m = !UCPath.match(chr1);
	UCPath = UCPath.replace(chr0,'');
	if(m) UCPath = UCPath.replace(chr1,'!');
	for(w = 0; w < UCFullPaths.length; ++w) {
		if((m ? UCFullPaths[w].replace(chr1,'!') : UCFullPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
		if((m ? UCPaths[w].replace(chr1,'!') : UCPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
	}
	return null;
}
/** CFB Constants */
var MSSZ = 64; /* Mini Sector Size = 1<<6 */
//var MSCSZ = 4096; /* Mini Stream Cutoff Size */
/* 2.1 Compound File Sector Numbers and Types */
var ENDOFCHAIN = -2;
/* 2.2 Compound File Header */
var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
var HEADER_SIG = [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1];
var HEADER_CLSID = '00000000000000000000000000000000';
var consts = {
	/* 2.1 Compund File Sector Numbers and Types */
	MAXREGSECT: -6,
	DIFSECT: -4,
	FATSECT: -3,
	ENDOFCHAIN: ENDOFCHAIN,
	FREESECT: -1,
	/* 2.2 Compound File Header */
	HEADER_SIGNATURE: HEADER_SIGNATURE,
	HEADER_MINOR_VERSION: '3e00',
	MAXREGSID: -6,
	NOSTREAM: -1,
	HEADER_CLSID: HEADER_CLSID,
	/* 2.6.1 Compound File Directory Entry */
	EntryTypes: ['unknown','storage','stream','lockbytes','property','root']
};

function write_file(cfb, filename, options) {
	get_fs();
	var o = _write(cfb, options);
fs.writeFileSync(filename, o);
}

function a2s(o) {
	var out = new Array(o.length);
	for(var i = 0; i < o.length; ++i) out[i] = String.fromCharCode(o[i]);
	return out.join("");
}

function write(cfb, options) {
	var o = _write(cfb, options);
	switch(options && options.type) {
		case "file": get_fs(); fs.writeFileSync(options.filename, (o)); return o;
		case "binary": return a2s(o);
		case "base64": return Base64.encode(a2s(o));
	}
	return o;
}
/* node < 8.1 zlib does not expose bytesRead, so default to pure JS */
var _zlib;
function use_zlib(zlib) { try {
	var InflateRaw = zlib.InflateRaw;
	var InflRaw = new InflateRaw();
	InflRaw._processChunk(new Uint8Array([3, 0]), InflRaw._finishFlushFlag);
	if(InflRaw.bytesRead) _zlib = zlib;
	else throw new Error("zlib does not expose bytesRead");
} catch(e) {console.error("cannot use native zlib: " + (e.message || e)); } }

function _inflateRawSync(payload, usz) {
	if(!_zlib) return _inflate(payload, usz);
	var InflateRaw = _zlib.InflateRaw;
	var InflRaw = new InflateRaw();
	var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
	payload.l += InflRaw.bytesRead;
	return out;
}

function _deflateRawSync(payload) {
	return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
}
var CLEN_ORDER = [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];

/*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */
var LEN_LN = [   3,   4,   5,   6,   7,   8,   9,  10,  11,  13 , 15,  17,  19,  23,  27,  31,  35,  43,  51,  59,  67,  83,  99, 115, 131, 163, 195, 227, 258 ];

/*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */
var DST_LN = [  1,  2,  3,  4,  5,  7,  9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577 ];

function bit_swap_8(n) { var t = (((((n<<1)|(n<<11)) & 0x22110) | (((n<<5)|(n<<15)) & 0x88440))); return ((t>>16) | (t>>8) |t)&0xFF; }

var use_typed_arrays = typeof Uint8Array !== 'undefined';

var bitswap8 = use_typed_arrays ? new Uint8Array(1<<8) : [];
for(var q = 0; q < (1<<8); ++q) bitswap8[q] = bit_swap_8(q);

function bit_swap_n(n, b) {
	var rev = bitswap8[n & 0xFF];
	if(b <= 8) return rev >>> (8-b);
	rev = (rev << 8) | bitswap8[(n>>8)&0xFF];
	if(b <= 16) return rev >>> (16-b);
	rev = (rev << 8) | bitswap8[(n>>16)&0xFF];
	return rev >>> (24-b);
}

/* helpers for unaligned bit reads */
function read_bits_2(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 6 ? 0 : buf[h+1]<<8))>>>w)& 0x03; }
function read_bits_3(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 5 ? 0 : buf[h+1]<<8))>>>w)& 0x07; }
function read_bits_4(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 4 ? 0 : buf[h+1]<<8))>>>w)& 0x0F; }
function read_bits_5(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 3 ? 0 : buf[h+1]<<8))>>>w)& 0x1F; }
function read_bits_7(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 1 ? 0 : buf[h+1]<<8))>>>w)& 0x7F; }

/* works up to n = 3 * 8 + 1 = 25 */
function read_bits_n(buf, bl, n) {
	var w = (bl&7), h = (bl>>>3), f = ((1<<n)-1);
	var v = buf[h] >>> w;
	if(n < 8 - w) return v & f;
	v |= buf[h+1]<<(8-w);
	if(n < 16 - w) return v & f;
	v |= buf[h+2]<<(16-w);
	if(n < 24 - w) return v & f;
	v |= buf[h+3]<<(24-w);
	return v & f;
}

/* until ArrayBuffer#realloc is a thing, fake a realloc */
function realloc(b, sz) {
	var L = b.length, M = 2*L > sz ? 2*L : sz + 5, i = 0;
	if(L >= sz) return b;
	if(has_buf) {
		var o = new_unsafe_buf(M);
		// $FlowIgnore
		if(b.copy) b.copy(o);
		else for(; i < b.length; ++i) o[i] = b[i];
		return o;
	} else if(use_typed_arrays) {
		var a = new Uint8Array(M);
		if(a.set) a.set(b);
		else for(; i < b.length; ++i) a[i] = b[i];
		return a;
	}
	b.length = M;
	return b;
}

/* zero-filled arrays for older browsers */
function zero_fill_array(n) {
	var o = new Array(n);
	for(var i = 0; i < n; ++i) o[i] = 0;
	return o;
}var _deflate = (function() {
var _deflateRaw = (function() {
	return function deflateRaw(data, out) {
		var boff = 0;
		while(boff < data.length) {
			var L = Math.min(0xFFFF, data.length - boff);
			var h = boff + L == data.length;
			/* TODO: this is only type 0 stored */
			out.write_shift(1, +h);
			out.write_shift(2, L);
			out.write_shift(2, (~L) & 0xFFFF);
			while(L-- > 0) out[out.l++] = data[boff++];
		}
		return out.l;
	};
})();

return function(data) {
	var buf = new_buf(50+Math.floor(data.length*1.1));
	var off = _deflateRaw(data, buf);
	return buf.slice(0, off);
};
})();
/* modified inflate function also moves original read head */

/* build tree (used for literals and lengths) */
function build_tree(clens, cmap, MAX) {
	var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;

	var bl_count  = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
	for(i = 0; i < 32; ++i) bl_count[i] = 0;

	for(i = L; i < MAX; ++i) clens[i] = 0;
	L = clens.length;

	var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []

	/* build code tree */
	for(i = 0; i < L; ++i) {
		bl_count[(w = clens[i])]++;
		if(maxlen < w) maxlen = w;
		ctree[i] = 0;
	}
	bl_count[0] = 0;
	for(i = 1; i <= maxlen; ++i) bl_count[i+16] = (ccode = (ccode + bl_count[i-1])<<1);
	for(i = 0; i < L; ++i) {
		ccode = clens[i];
		if(ccode != 0) ctree[i] = bl_count[ccode+16]++;
	}

	/* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */
	var cleni = 0;
	for(i = 0; i < L; ++i) {
		cleni = clens[i];
		if(cleni != 0) {
			ccode = bit_swap_n(ctree[i], maxlen)>>(maxlen-cleni);
			for(j = (1<<(maxlen + 4 - cleni)) - 1; j>=0; --j)
				cmap[ccode|(j<<cleni)] = (cleni&15) | (i<<4);
		}
	}
	return maxlen;
}

var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
var fix_dmap = use_typed_arrays ? new Uint16Array(32)  : zero_fill_array(32);
if(!use_typed_arrays) {
	for(var i = 0; i < 512; ++i) fix_lmap[i] = 0;
	for(i = 0; i < 32; ++i) fix_dmap[i] = 0;
}
(function() {
	var dlens = [];
	var i = 0;
	for(;i<32; i++) dlens.push(5);
	build_tree(dlens, fix_dmap, 32);

	var clens = [];
	i = 0;
	for(; i<=143; i++) clens.push(8);
	for(; i<=255; i++) clens.push(9);
	for(; i<=279; i++) clens.push(7);
	for(; i<=287; i++) clens.push(8);
	build_tree(clens, fix_lmap, 288);
})();

var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
var dyn_cmap = use_typed_arrays ? new Uint16Array(128)   : zero_fill_array(128);
var dyn_len_1 = 1, dyn_len_2 = 1;

/* 5.5.3 Expanding Huffman Codes */
function dyn(data, boff) {
	/* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */
	var _HLIT = read_bits_5(data, boff) + 257; boff += 5;
	var _HDIST = read_bits_5(data, boff) + 1; boff += 5;
	var _HCLEN = read_bits_4(data, boff) + 4; boff += 4;
	var w = 0;

	/* grab and store code lengths */
	var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
	var ctree = [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ];
	var maxlen = 1;
	var bl_count =  use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
	var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
	var L = clens.length; /* 19 */
	for(var i = 0; i < _HCLEN; ++i) {
		clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
		if(maxlen < w) maxlen = w;
		bl_count[w]++;
		boff += 3;
	}

	/* build code tree */
	var ccode = 0;
	bl_count[0] = 0;
	for(i = 1; i <= maxlen; ++i) next_code[i] = ccode = (ccode + bl_count[i-1])<<1;
	for(i = 0; i < L; ++i) if((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
	/* cmap[7 bits from stream] = (off&7) + (lit<<3) */
	var cleni = 0;
	for(i = 0; i < L; ++i) {
		cleni = clens[i];
		if(cleni != 0) {
			ccode = bitswap8[ctree[i]]>>(8-cleni);
			for(var j = (1<<(7-cleni))-1; j>=0; --j) dyn_cmap[ccode|(j<<cleni)] = (cleni&7) | (i<<3);
		}
	}

	/* read literal and dist codes at once */
	var hcodes = [];
	maxlen = 1;
	for(; hcodes.length < _HLIT + _HDIST;) {
		ccode = dyn_cmap[read_bits_7(data, boff)];
		boff += ccode & 7;
		switch((ccode >>>= 3)) {
			case 16:
				w = 3 + read_bits_2(data, boff); boff += 2;
				ccode = hcodes[hcodes.length - 1];
				while(w-- > 0) hcodes.push(ccode);
				break;
			case 17:
				w = 3 + read_bits_3(data, boff); boff += 3;
				while(w-- > 0) hcodes.push(0);
				break;
			case 18:
				w = 11 + read_bits_7(data, boff); boff += 7;
				while(w -- > 0) hcodes.push(0);
				break;
			default:
				hcodes.push(ccode);
				if(maxlen < ccode) maxlen = ccode;
				break;
		}
	}

	/* build literal / length trees */
	var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
	for(i = _HLIT; i < 286; ++i) h1[i] = 0;
	for(i = _HDIST; i < 30; ++i) h2[i] = 0;
	dyn_len_1 = build_tree(h1, dyn_lmap, 286);
	dyn_len_2 = build_tree(h2, dyn_dmap, 30);
	return boff;
}

/* return [ data, bytesRead ] */
function inflate(data, usz) {
	/* shortcircuit for empty buffer [0x03, 0x00] */
	if(data[0] == 3 && !(data[1] & 0x3)) { return [new_raw_buf(usz), 2]; }

	/* bit offset */
	var boff = 0;

	/* header includes final bit and type bits */
	var header = 0;

	var outbuf = new_unsafe_buf(usz ? usz : (1<<18));
	var woff = 0;
	var OL = outbuf.length>>>0;
	var max_len_1 = 0, max_len_2 = 0;

	while((header&1) == 0) {
		header = read_bits_3(data, boff); boff += 3;
		if((header >>> 1) == 0) {
			/* Stored block */
			if(boff & 7) boff += 8 - (boff&7);
			/* 2 bytes sz, 2 bytes bit inverse */
			var sz = data[boff>>>3] | data[(boff>>>3)+1]<<8;
			boff += 32;
			/* push sz bytes */
			if(!usz && OL < woff + sz) { outbuf = realloc(outbuf, woff + sz); OL = outbuf.length; }
			if(typeof data.copy === 'function') {
				// $FlowIgnore
				data.copy(outbuf, woff, boff>>>3, (boff>>>3)+sz);
				woff += sz; boff += 8*sz;
			} else while(sz-- > 0) { outbuf[woff++] = data[boff>>>3]; boff += 8; }
			continue;
		} else if((header >>> 1) == 1) {
			/* Fixed Huffman */
			max_len_1 = 9; max_len_2 = 5;
		} else {
			/* Dynamic Huffman */
			boff = dyn(data, boff);
			max_len_1 = dyn_len_1; max_len_2 = dyn_len_2;
		}
		if(!usz && (OL < woff + 32767)) { outbuf = realloc(outbuf, woff + 32767); OL = outbuf.length; }
		for(;;) { // while(true) is apparently out of vogue in modern JS circles
			/* ingest code and move read head */
			var bits = read_bits_n(data, boff, max_len_1);
			var code = (header>>>1) == 1 ? fix_lmap[bits] : dyn_lmap[bits];
			boff += code & 15; code >>>= 4;
			/* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */
			if(((code>>>8)&0xFF) === 0) outbuf[woff++] = code;
			else if(code == 256) break;
			else {
				code -= 257;
				var len_eb = (code < 8) ? 0 : ((code-4)>>2); if(len_eb > 5) len_eb = 0;
				var tgt = woff + LEN_LN[code];
				/* length extra bits */
				if(len_eb > 0) {
					tgt += read_bits_n(data, boff, len_eb);
					boff += len_eb;
				}

				/* dist code */
				bits = read_bits_n(data, boff, max_len_2);
				code = (header>>>1) == 1 ? fix_dmap[bits] : dyn_dmap[bits];
				boff += code & 15; code >>>= 4;
				var dst_eb = (code < 4 ? 0 : (code-2)>>1);
				var dst = DST_LN[code];
				/* dist extra bits */
				if(dst_eb > 0) {
					dst += read_bits_n(data, boff, dst_eb);
					boff += dst_eb;
				}

				/* in the common case, manual byte copy is faster than TA set / Buffer copy */
				if(!usz && OL < tgt) { outbuf = realloc(outbuf, tgt); OL = outbuf.length; }
				while(woff < tgt) { outbuf[woff] = outbuf[woff - dst]; ++woff; }
			}
		}
	}
	return [usz ? outbuf : outbuf.slice(0, woff), (boff+7)>>>3];
}

function _inflate(payload, usz) {
	var data = payload.slice(payload.l||0);
	var out = inflate(data, usz);
	payload.l += out[1];
	return out[0];
}

function warn_or_throw(wrn, msg) {
	if(wrn) { if(typeof console !== 'undefined') console.error(msg); }
	else throw new Error(msg);
}

function parse_zip(file, options) {
	var blob = file;
	prep_blob(blob, 0);

	var FileIndex = [], FullPaths = [];
	var o = {
		FileIndex: FileIndex,
		FullPaths: FullPaths
	};
	init_cfb(o, { root: options.root });

	/* find end of central directory, start just after signature */
	var i = blob.length - 4;
	while((blob[i] != 0x50 || blob[i+1] != 0x4b || blob[i+2] != 0x05 || blob[i+3] != 0x06) && i >= 0) --i;
	blob.l = i + 4;

	/* parse end of central directory */
	blob.l += 4;
	var fcnt = blob.read_shift(2);
	blob.l += 6;
	var start_cd = blob.read_shift(4);

	/* parse central directory */
	blob.l = start_cd;

	for(i = 0; i < fcnt; ++i) {
		/* trust local file header instead of CD entry */
		blob.l += 20;
		var csz = blob.read_shift(4);
		var usz = blob.read_shift(4);
		var namelen = blob.read_shift(2);
		var efsz = blob.read_shift(2);
		var fcsz = blob.read_shift(2);
		blob.l += 8;
		var offset = blob.read_shift(4);
		var EF = parse_extra_field(blob.slice(blob.l+namelen, blob.l+namelen+efsz));
		blob.l += namelen + efsz + fcsz;

		var L = blob.l;
		blob.l = offset + 4;
		parse_local_file(blob, csz, usz, o, EF);
		blob.l = L;
	}

	return o;
}


/* head starts just after local file header signature */
function parse_local_file(blob, csz, usz, o, EF) {
	/* [local file header] */
	blob.l += 2;
	var flags = blob.read_shift(2);
	var meth = blob.read_shift(2);
	var date = parse_dos_date(blob);

	if(flags & 0x2041) throw new Error("Unsupported ZIP encryption");
	var crc32 = blob.read_shift(4);
	var _csz = blob.read_shift(4);
	var _usz = blob.read_shift(4);

	var namelen = blob.read_shift(2);
	var efsz = blob.read_shift(2);

	// TODO: flags & (1<<11) // UTF8
	var name = ""; for(var i = 0; i < namelen; ++i) name += String.fromCharCode(blob[blob.l++]);
	if(efsz) {
		var ef = parse_extra_field(blob.slice(blob.l, blob.l + efsz));
		if((ef[0x5455]||{}).mt) date = ef[0x5455].mt;
		if(((EF||{})[0x5455]||{}).mt) date = EF[0x5455].mt;
	}
	blob.l += efsz;

	/* [encryption header] */

	/* [file data] */
	var data = blob.slice(blob.l, blob.l + _csz);
	switch(meth) {
		case 8: data = _inflateRawSync(blob, _usz); break;
		case 0: break;
		default: throw new Error("Unsupported ZIP Compression method " + meth);
	}

	/* [data descriptor] */
	var wrn = false;
	if(flags & 8) {
		crc32 = blob.read_shift(4);
		if(crc32 == 0x08074b50) { crc32 = blob.read_shift(4); wrn = true; }
		_csz = blob.read_shift(4);
		_usz = blob.read_shift(4);
	}

	if(_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
	if(_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
	var _crc32 = CRC32.buf(data, 0);
	if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
	cfb_add(o, name, data, {unsafe: true, mt: date});
}
function write_zip(cfb, options) {
	var _opts = options || {};
	var out = [], cdirs = [];
	var o = new_buf(1);
	var method = (_opts.compression ? 8 : 0), flags = 0;
	var desc = false;
	if(desc) flags |= 8;
	var i = 0, j = 0;

	var start_cd = 0, fcnt = 0;
	var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
	var crcs = [];
	var sz_cd = 0;

	for(i = 1; i < cfb.FullPaths.length; ++i) {
		fp = cfb.FullPaths[i].slice(root.length); fi = cfb.FileIndex[i];
		if(!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
		var start = start_cd;

		/* TODO: CP437 filename */
		var namebuf = new_buf(fp.length);
		for(j = 0; j < fp.length; ++j) namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
		namebuf = namebuf.slice(0, namebuf.l);
		crcs[fcnt] = CRC32.buf(fi.content, 0);

		var outbuf = fi.content;
		if(method == 8) outbuf = _deflateRawSync(outbuf);

		/* local file header */
		o = new_buf(30);
		o.write_shift(4, 0x04034b50);
		o.write_shift(2, 20);
		o.write_shift(2, flags);
		o.write_shift(2, method);
		/* TODO: last mod file time/date */
		if(fi.mt) write_dos_date(o, fi.mt);
		else o.write_shift(4, 0);
		o.write_shift(-4, (flags & 8) ? 0 : crcs[fcnt]);
		o.write_shift(4,  (flags & 8) ? 0 : outbuf.length);
		o.write_shift(4,  (flags & 8) ? 0 : fi.content.length);
		o.write_shift(2, namebuf.length);
		o.write_shift(2, 0);

		start_cd += o.length;
		out.push(o);
		start_cd += namebuf.length;
		out.push(namebuf);

		/* TODO: encryption header ? */
		start_cd += outbuf.length;
		out.push(outbuf);

		/* data descriptor */
		if(flags & 8) {
			o = new_buf(12);
			o.write_shift(-4, crcs[fcnt]);
			o.write_shift(4, outbuf.length);
			o.write_shift(4, fi.content.length);
			start_cd += o.l;
			out.push(o);
		}

		/* central directory */
		o = new_buf(46);
		o.write_shift(4, 0x02014b50);
		o.write_shift(2, 0);
		o.write_shift(2, 20);
		o.write_shift(2, flags);
		o.write_shift(2, method);
		o.write_shift(4, 0); /* TODO: last mod file time/date */
		o.write_shift(-4, crcs[fcnt]);

		o.write_shift(4, outbuf.length);
		o.write_shift(4, fi.content.length);
		o.write_shift(2, namebuf.length);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(4, 0);
		o.write_shift(4, start);

		sz_cd += o.l;
		cdirs.push(o);
		sz_cd += namebuf.length;
		cdirs.push(namebuf);
		++fcnt;
	}

	/* end of central directory */
	o = new_buf(22);
	o.write_shift(4, 0x06054b50);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, fcnt);
	o.write_shift(2, fcnt);
	o.write_shift(4, sz_cd);
	o.write_shift(4, start_cd);
	o.write_shift(2, 0);

	return bconcat(([bconcat((out)), bconcat(cdirs), o]));
}
function cfb_new(opts) {
	var o = ({});
	init_cfb(o, opts);
	return o;
}

function cfb_add(cfb, name, content, opts) {
	var unsafe = opts && opts.unsafe;
	if(!unsafe) init_cfb(cfb);
	var file = !unsafe && CFB.find(cfb, name);
	if(!file) {
		var fpath = cfb.FullPaths[0];
		if(name.slice(0, fpath.length) == fpath) fpath = name;
		else {
			if(fpath.slice(-1) != "/") fpath += "/";
			fpath = (fpath + name).replace("//","/");
		}
		file = ({name: filename(name), type: 2});
		cfb.FileIndex.push(file);
		cfb.FullPaths.push(fpath);
		if(!unsafe) CFB.utils.cfb_gc(cfb);
	}
file.content = (content);
	file.size = content ? content.length : 0;
	if(opts) {
		if(opts.CLSID) file.clsid = opts.CLSID;
		if(opts.mt) file.mt = opts.mt;
		if(opts.ct) file.ct = opts.ct;
	}
	return file;
}

function cfb_del(cfb, name) {
	init_cfb(cfb);
	var file = CFB.find(cfb, name);
	if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
		cfb.FileIndex.splice(j, 1);
		cfb.FullPaths.splice(j, 1);
		return true;
	}
	return false;
}

function cfb_mov(cfb, old_name, new_name) {
	init_cfb(cfb);
	var file = CFB.find(cfb, old_name);
	if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
		cfb.FileIndex[j].name = filename(new_name);
		cfb.FullPaths[j] = new_name;
		return true;
	}
	return false;
}

function cfb_gc(cfb) { rebuild_cfb(cfb, true); }

exports.find = find;
exports.read = read;
exports.parse = parse;
exports.write = write;
exports.writeFile = write_file;
exports.utils = {
	cfb_new: cfb_new,
	cfb_add: cfb_add,
	cfb_del: cfb_del,
	cfb_mov: cfb_mov,
	cfb_gc: cfb_gc,
	ReadShift: ReadShift,
	CheckField: CheckField,
	prep_blob: prep_blob,
	bconcat: bconcat,
	use_zlib: use_zlib,
	_deflateRaw: _deflate,
	_inflateRaw: _inflate,
	consts: consts
};

return exports;
})();

if(typeof require !== 'undefined' && typeof module !== 'undefined' && typeof DO_NOT_EXPORT_CFB === 'undefined') { module.exports = CFB; }

}).call(this,require('_process'),require("buffer").Buffer)

},{"_process":202,"buffer":77,"fs":47}],79:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer
var Transform = require('stream').Transform
var StringDecoder = require('string_decoder').StringDecoder
var inherits = require('inherits')

function CipherBase (hashMode) {
  Transform.call(this)
  this.hashMode = typeof hashMode === 'string'
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest
  } else {
    this.final = this._finalOrDigest
  }
  if (this._final) {
    this.__final = this._final
    this._final = null
  }
  this._decoder = null
  this._encoding = null
}
inherits(CipherBase, Transform)

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = Buffer.from(data, inputEnc)
  }

  var outData = this._update(data)
  if (this.hashMode) return this

  if (outputEnc) {
    outData = this._toString(outData, outputEnc)
  }

  return outData
}

CipherBase.prototype.setAutoPadding = function () {}
CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state')
}

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state')
}

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state')
}

CipherBase.prototype._transform = function (data, _, next) {
  var err
  try {
    if (this.hashMode) {
      this._update(data)
    } else {
      this.push(this._update(data))
    }
  } catch (e) {
    err = e
  } finally {
    next(err)
  }
}
CipherBase.prototype._flush = function (done) {
  var err
  try {
    this.push(this.__final())
  } catch (e) {
    err = e
  }

  done(err)
}
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this.__final() || Buffer.alloc(0)
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true)
  }
  return outData
}

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc)
    this._encoding = enc
  }

  if (this._encoding !== enc) throw new Error('can\'t switch encodings')

  var out = this._decoder.write(value)
  if (fin) {
    out += this._decoder.end()
  }

  return out
}

module.exports = CipherBase

},{"inherits":131,"safe-buffer":225,"stream":236,"string_decoder":237}],80:[function(require,module,exports){
(function (Buffer){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

}).call(this,{"isBuffer":require("../../is-buffer/index.js")})

},{"../../is-buffer/index.js":132}],81:[function(require,module,exports){
(function (Buffer){
var elliptic = require('elliptic')
var BN = require('bn.js')

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

}).call(this,require("buffer").Buffer)

},{"bn.js":45,"buffer":77,"elliptic":97}],82:[function(require,module,exports){
'use strict'
var inherits = require('inherits')
var MD5 = require('md5.js')
var RIPEMD160 = require('ripemd160')
var sha = require('sha.js')
var Base = require('cipher-base')

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}

},{"cipher-base":79,"inherits":131,"md5.js":171,"ripemd160":224,"sha.js":229}],83:[function(require,module,exports){
var MD5 = require('md5.js')

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}

},{"md5.js":171}],84:[function(require,module,exports){
'use strict'
var inherits = require('inherits')
var Legacy = require('./legacy')
var Base = require('cipher-base')
var Buffer = require('safe-buffer').Buffer
var md5 = require('create-hash/md5')
var RIPEMD160 = require('ripemd160')

var sha = require('sha.js')

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}

},{"./legacy":85,"cipher-base":79,"create-hash/md5":83,"inherits":131,"ripemd160":224,"safe-buffer":225,"sha.js":229}],85:[function(require,module,exports){
'use strict'
var inherits = require('inherits')
var Buffer = require('safe-buffer').Buffer

var Base = require('cipher-base')

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac

},{"cipher-base":79,"inherits":131,"safe-buffer":225}],86:[function(require,module,exports){
'use strict'

exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = require('randombytes')
exports.createHash = exports.Hash = require('create-hash')
exports.createHmac = exports.Hmac = require('create-hmac')

var algos = require('browserify-sign/algos')
var algoKeys = Object.keys(algos)
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
exports.getHashes = function () {
  return hashes
}

var p = require('pbkdf2')
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = require('browserify-cipher')

exports.Cipher = aes.Cipher
exports.createCipher = aes.createCipher
exports.Cipheriv = aes.Cipheriv
exports.createCipheriv = aes.createCipheriv
exports.Decipher = aes.Decipher
exports.createDecipher = aes.createDecipher
exports.Decipheriv = aes.Decipheriv
exports.createDecipheriv = aes.createDecipheriv
exports.getCiphers = aes.getCiphers
exports.listCiphers = aes.listCiphers

var dh = require('diffie-hellman')

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
exports.getDiffieHellman = dh.getDiffieHellman
exports.createDiffieHellman = dh.createDiffieHellman
exports.DiffieHellman = dh.DiffieHellman

var sign = require('browserify-sign')

exports.createSign = sign.createSign
exports.Sign = sign.Sign
exports.createVerify = sign.createVerify
exports.Verify = sign.Verify

exports.createECDH = require('create-ecdh')

var publicEncrypt = require('public-encrypt')

exports.publicEncrypt = publicEncrypt.publicEncrypt
exports.privateEncrypt = publicEncrypt.privateEncrypt
exports.publicDecrypt = publicEncrypt.publicDecrypt
exports.privateDecrypt = publicEncrypt.privateDecrypt

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

var rf = require('randomfill')

exports.randomFill = rf.randomFill
exports.randomFillSync = rf.randomFillSync

exports.createCredentials = function () {
  throw new Error([
    'sorry, createCredentials is not implemented yet',
    'we accept pull requests',
    'https://github.com/crypto-browserify/crypto-browserify'
  ].join('\n'))
}

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
}

},{"browserify-cipher":65,"browserify-sign":72,"browserify-sign/algos":69,"create-ecdh":81,"create-hash":82,"create-hmac":84,"diffie-hellman":93,"pbkdf2":196,"public-encrypt":203,"randombytes":209,"randomfill":210}],87:[function(require,module,exports){
'use strict';

exports.utils = require('./des/utils');
exports.Cipher = require('./des/cipher');
exports.DES = require('./des/des');
exports.CBC = require('./des/cbc');
exports.EDE = require('./des/ede');

},{"./des/cbc":88,"./des/cipher":89,"./des/des":90,"./des/ede":91,"./des/utils":92}],88:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');
var inherits = require('inherits');

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};

},{"inherits":131,"minimalistic-assert":173}],89:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};

},{"minimalistic-assert":173}],90:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');
var inherits = require('inherits');

var utils = require('./utils');
var Cipher = require('./cipher');

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};

},{"./cipher":89,"./utils":92,"inherits":131,"minimalistic-assert":173}],91:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');
var inherits = require('inherits');

var Cipher = require('./cipher');
var DES = require('./des');

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;

},{"./cipher":89,"./des":90,"inherits":131,"minimalistic-assert":173}],92:[function(require,module,exports){
'use strict';

exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};

},{}],93:[function(require,module,exports){
(function (Buffer){
var generatePrime = require('./lib/generatePrime')
var primes = require('./lib/primes.json')

var DH = require('./lib/dh')

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

}).call(this,require("buffer").Buffer)

},{"./lib/dh":94,"./lib/generatePrime":95,"./lib/primes.json":96,"buffer":77}],94:[function(require,module,exports){
(function (Buffer){
var BN = require('bn.js');
var MillerRabin = require('miller-rabin');
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = require('./generatePrime');
var randomBytes = require('randombytes');
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

}).call(this,require("buffer").Buffer)

},{"./generatePrime":95,"bn.js":45,"buffer":77,"miller-rabin":172,"randombytes":209}],95:[function(require,module,exports){
var randomBytes = require('randombytes');
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = require('bn.js');
var TWENTYFOUR = new BN(24);
var MillerRabin = require('miller-rabin');
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}

},{"bn.js":45,"miller-rabin":172,"randombytes":209}],96:[function(require,module,exports){
module.exports={
    "modp1": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
    },
    "modp2": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
    },
    "modp5": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
    },
    "modp14": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
    },
    "modp15": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
    },
    "modp16": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
    },
    "modp17": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
    },
    "modp18": {
        "gen": "02",
        "prime": "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"
    }
}
},{}],97:[function(require,module,exports){
'use strict';

var elliptic = exports;

elliptic.version = require('../package.json').version;
elliptic.utils = require('./elliptic/utils');
elliptic.rand = require('brorand');
elliptic.curve = require('./elliptic/curve');
elliptic.curves = require('./elliptic/curves');

// Protocols
elliptic.ec = require('./elliptic/ec');
elliptic.eddsa = require('./elliptic/eddsa');

},{"../package.json":112,"./elliptic/curve":100,"./elliptic/curves":103,"./elliptic/ec":104,"./elliptic/eddsa":107,"./elliptic/utils":111,"brorand":46}],98:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var utils = require('../utils');
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  this._bitLength = this.n ? this.n.bitLength() : 0;

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1, this._bitLength);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  for (var j = 0; j < naf.length; j += doubles.step) {
    var nafW = 0;
    for (var k = j + doubles.step - 1; k >= j; k--)
      nafW = (nafW << 1) + naf[k];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (var j = 0; j < repr.length; j++) {
      var nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w, this._bitLength);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var k = 0; i >= 0 && naf[i] === 0; i--)
      k++;
    if (i >= 0)
      k++;
    acc = acc.dblp(k);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
                                                       points,
                                                       coeffs,
                                                       len,
                                                       jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  for (var i = 0; i < len; i++) {
    var p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (var i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
      naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b] /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (var j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (var i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (var j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (var j = 0; j < len; j++) {
      var z = tmp[j];
      var p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (var i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
                          bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len)) ;
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};

},{"../utils":111,"bn.js":45}],99:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var BN = require('bn.js');
var inherits = require('inherits');
var Base = require('./base');

var assert = utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  if (this.curve.twisted) {
    // E = a * C
    var e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      var h = this.z.redSqr();
      // J = F - 2 * H
      var j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    var e = c.redAdd(d);
    // H = (c * Z1)^2
    var h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    var j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
                          this.y,
                          this.z,
                          this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;

},{"../utils":111,"./base":98,"bn.js":45,"inherits":131}],100:[function(require,module,exports){
'use strict';

var curve = exports;

curve.base = require('./base');
curve.short = require('./short');
curve.mont = require('./mont');
curve.edwards = require('./edwards');

},{"./base":98,"./edwards":99,"./mont":101,"./short":102}],101:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var inherits = require('inherits');
var Base = require('./base');

var utils = require('../utils');

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};

},{"../utils":111,"./base":98,"bn.js":45,"inherits":131}],102:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var BN = require('bn.js');
var inherits = require('inherits');
var Base = require('./base');

var assert = utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16)
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 }
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
  var npoints = this._endoWnafT1;
  var ncoeffs = this._endoWnafT2;
  for (var i = 0; i < points.length; i++) {
    var split = this._endoSplit(coeffs[i]);
    var p = points[i];
    var beta = p._getBeta();

    if (split.k1.negative) {
      split.k1.ineg();
      p = p.neg(true);
    }
    if (split.k2.negative) {
      split.k2.ineg();
      beta = beta.neg(true);
    }

    npoints[i * 2] = p;
    npoints[i * 2 + 1] = beta;
    ncoeffs[i * 2] = split.k1;
    ncoeffs[i * 2 + 1] = split.k2;
  }
  var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

  // Clean-up references to points and coefficients
  for (var j = 0; j < i * 2; j++) {
    npoints[j] = null;
    ncoeffs[j] = null;
  }
  return res;
};

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul)
      }
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point))
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point))
    }
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);
  if (this.isInfinity())
    return this;
  else if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate)
      }
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (var i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (var i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

},{"../utils":111,"./base":98,"bn.js":45,"inherits":131}],103:[function(require,module,exports){
'use strict';

var curves = exports;

var hash = require('hash.js');
var curve = require('./curve');
var utils = require('./utils');

var assert = utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new curve.edwards(options);
  else
    this.curve = new curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve
      });
      return curve;
    }
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
  ]
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
  ]
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
  ]
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f'
  ]
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650'
  ]
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9'
  ]
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658'
  ]
});

var pre;
try {
  pre = require('./precomputed/secp256k1');
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3'
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15'
    }
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre
  ]
});

},{"./curve":100,"./precomputed/secp256k1":110,"./utils":111,"hash.js":116}],104:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var HmacDRBG = require('hmac-drbg');
var utils = require('../utils');
var curves = require('../curves');
var rand = require('brorand');
var assert = utils.assert;

var KeyPair = require('./key');
var Signature = require('./signature');

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(curves.hasOwnProperty(options), 'Unknown curve ' + options);

    options = curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray()
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  do {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  } while (true);
};

EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8'
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; true; iter++) {
    var k = options.k ?
        options.k(iter) :
        new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc) {
  msg = this._truncateToN(new BN(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);

  if (!this.curve._maxwellTrick) {
    var p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  var p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};

},{"../curves":103,"../utils":111,"./key":105,"./signature":106,"bn.js":45,"brorand":46,"hmac-drbg":128}],105:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var utils = require('../utils');
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

},{"../utils":111,"bn.js":45}],106:[function(require,module,exports){
'use strict';

var BN = require('bn.js');

var utils = require('../utils');
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;
  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
  }
  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0 && (r[1] & 0x80)) {
    r = r.slice(1);
  }
  if (s[0] === 0 && (s[1] & 0x80)) {
    s = s.slice(1);
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};

},{"../utils":111,"bn.js":45}],107:[function(require,module,exports){
'use strict';

var hash = require('hash.js');
var curves = require('../curves');
var utils = require('../utils');
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = require('./key');
var Signature = require('./signature');

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  var curve = curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
               .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};

},{"../curves":103,"../utils":111,"./key":108,"./signature":109,"hash.js":116}],108:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;

},{"../utils":111}],109:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var utils = require('../utils');
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength)
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;

},{"../utils":111,"bn.js":45}],110:[function(require,module,exports){
module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
      ]
    ]
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
      ]
    ]
  }
};

},{}],111:[function(require,module,exports){
'use strict';

var utils = exports;
var BN = require('bn.js');
var minAssert = require('minimalistic-assert');
var minUtils = require('minimalistic-crypto-utils');

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w, bits) {
  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
  naf.fill(0);

  var ws = 1 << (w + 1);
  var k = num.clone();

  for (var i = 0; i < naf.length; i++) {
    var z;
    var mod = k.andln(ws - 1);
    if (k.isOdd()) {
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }

    naf[i] = z;
    k.iushrn(1);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    []
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {

    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      var m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      var m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
           this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
                                     bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;


},{"bn.js":45,"minimalistic-assert":173,"minimalistic-crypto-utils":174}],112:[function(require,module,exports){
module.exports={
  "_from": "elliptic@^6.0.0",
  "_id": "elliptic@6.5.2",
  "_inBundle": false,
  "_integrity": "sha512-f4x70okzZbIQl/NSRLkI/+tteV/9WqL98zx+SQ69KbXxmVrmjwsNUPn/gYJJ0sHvEak24cZgHIPegRePAtA/xw==",
  "_location": "/elliptic",
  "_phantomChildren": {},
  "_requested": {
    "type": "range",
    "registry": true,
    "raw": "elliptic@^6.0.0",
    "name": "elliptic",
    "escapedName": "elliptic",
    "rawSpec": "^6.0.0",
    "saveSpec": null,
    "fetchSpec": "^6.0.0"
  },
  "_requiredBy": [
    "/browserify-sign",
    "/create-ecdh"
  ],
  "_resolved": "https://registry.npmjs.org/elliptic/-/elliptic-6.5.2.tgz",
  "_shasum": "05c5678d7173c049d8ca433552224a495d0e3762",
  "_spec": "elliptic@^6.0.0",
  "_where": "/code/personal/xlsx-populate-orig/node_modules/browserify-sign",
  "author": {
    "name": "Fedor Indutny",
    "email": "fedor@indutny.com"
  },
  "bugs": {
    "url": "https://github.com/indutny/elliptic/issues"
  },
  "bundleDependencies": false,
  "dependencies": {
    "bn.js": "^4.4.0",
    "brorand": "^1.0.1",
    "hash.js": "^1.0.0",
    "hmac-drbg": "^1.0.0",
    "inherits": "^2.0.1",
    "minimalistic-assert": "^1.0.0",
    "minimalistic-crypto-utils": "^1.0.0"
  },
  "deprecated": false,
  "description": "EC cryptography",
  "devDependencies": {
    "brfs": "^1.4.3",
    "coveralls": "^3.0.8",
    "grunt": "^1.0.4",
    "grunt-browserify": "^5.0.0",
    "grunt-cli": "^1.2.0",
    "grunt-contrib-connect": "^1.0.0",
    "grunt-contrib-copy": "^1.0.0",
    "grunt-contrib-uglify": "^1.0.1",
    "grunt-mocha-istanbul": "^3.0.1",
    "grunt-saucelabs": "^9.0.1",
    "istanbul": "^0.4.2",
    "jscs": "^3.0.7",
    "jshint": "^2.10.3",
    "mocha": "^6.2.2"
  },
  "files": [
    "lib"
  ],
  "homepage": "https://github.com/indutny/elliptic",
  "keywords": [
    "EC",
    "Elliptic",
    "curve",
    "Cryptography"
  ],
  "license": "MIT",
  "main": "lib/elliptic.js",
  "name": "elliptic",
  "repository": {
    "type": "git",
    "url": "git+ssh://git@github.com/indutny/elliptic.git"
  },
  "scripts": {
    "jscs": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
    "jshint": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
    "lint": "npm run jscs && npm run jshint",
    "test": "npm run lint && npm run unit",
    "unit": "istanbul test _mocha --reporter=spec test/index.js",
    "version": "grunt dist && git add dist/"
  },
  "version": "6.5.2"
}

},{}],113:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var objectCreate = Object.create || objectCreatePolyfill
var objectKeys = Object.keys || objectKeysPolyfill
var bind = Function.prototype.bind || functionBindPolyfill

function EventEmitter() {
  if (!this._events || !Object.prototype.hasOwnProperty.call(this, '_events')) {
    this._events = objectCreate(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

var hasDefineProperty;
try {
  var o = {};
  if (Object.defineProperty) Object.defineProperty(o, 'x', { value: 0 });
  hasDefineProperty = o.x === 0;
} catch (err) { hasDefineProperty = false }
if (hasDefineProperty) {
  Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
      return defaultMaxListeners;
    },
    set: function(arg) {
      // check whether the input is a positive number (whose value is zero or
      // greater and not a NaN).
      if (typeof arg !== 'number' || arg < 0 || arg !== arg)
        throw new TypeError('"defaultMaxListeners" must be a positive number');
      defaultMaxListeners = arg;
    }
  });
} else {
  EventEmitter.defaultMaxListeners = defaultMaxListeners;
}

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || isNaN(n))
    throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

// These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function emitNone(handler, isFn, self) {
  if (isFn)
    handler.call(self);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self);
  }
}
function emitOne(handler, isFn, self, arg1) {
  if (isFn)
    handler.call(self, arg1);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1);
  }
}
function emitTwo(handler, isFn, self, arg1, arg2) {
  if (isFn)
    handler.call(self, arg1, arg2);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2);
  }
}
function emitThree(handler, isFn, self, arg1, arg2, arg3) {
  if (isFn)
    handler.call(self, arg1, arg2, arg3);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2, arg3);
  }
}

function emitMany(handler, isFn, self, args) {
  if (isFn)
    handler.apply(self, args);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].apply(self, args);
  }
}

EventEmitter.prototype.emit = function emit(type) {
  var er, handler, len, args, i, events;
  var doError = (type === 'error');

  events = this._events;
  if (events)
    doError = (doError && events.error == null);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    if (arguments.length > 1)
      er = arguments[1];
    if (er instanceof Error) {
      throw er; // Unhandled 'error' event
    } else {
      // At least give some kind of context to the user
      var err = new Error('Unhandled "error" event. (' + er + ')');
      err.context = er;
      throw err;
    }
    return false;
  }

  handler = events[type];

  if (!handler)
    return false;

  var isFn = typeof handler === 'function';
  len = arguments.length;
  switch (len) {
      // fast cases
    case 1:
      emitNone(handler, isFn, this);
      break;
    case 2:
      emitOne(handler, isFn, this, arguments[1]);
      break;
    case 3:
      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
      break;
    case 4:
      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
      // slower
    default:
      args = new Array(len - 1);
      for (i = 1; i < len; i++)
        args[i - 1] = arguments[i];
      emitMany(handler, isFn, this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');

  events = target._events;
  if (!events) {
    events = target._events = objectCreate(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener) {
      target.emit('newListener', type,
          listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (!existing) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
          prepend ? [listener, existing] : [existing, listener];
    } else {
      // If we've already got an array, just append.
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    }

    // Check for listener leak
    if (!existing.warned) {
      m = $getMaxListeners(target);
      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error('Possible EventEmitter memory leak detected. ' +
            existing.length + ' "' + String(type) + '" listeners ' +
            'added. Use emitter.setMaxListeners() to ' +
            'increase limit.');
        w.name = 'MaxListenersExceededWarning';
        w.emitter = target;
        w.type = type;
        w.count = existing.length;
        if (typeof console === 'object' && console.warn) {
          console.warn('%s: %s', w.name, w.message);
        }
      }
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    switch (arguments.length) {
      case 0:
        return this.listener.call(this.target);
      case 1:
        return this.listener.call(this.target, arguments[0]);
      case 2:
        return this.listener.call(this.target, arguments[0], arguments[1]);
      case 3:
        return this.listener.call(this.target, arguments[0], arguments[1],
            arguments[2]);
      default:
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i)
          args[i] = arguments[i];
        this.listener.apply(this.target, args);
    }
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = bind.call(onceWrapper, state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');

      events = this._events;
      if (!events)
        return this;

      list = events[type];
      if (!list)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = objectCreate(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else
          spliceOne(list, position);

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (!events)
        return this;

      // not listening for removeListener, no need to emit
      if (!events.removeListener) {
        if (arguments.length === 0) {
          this._events = objectCreate(null);
          this._eventsCount = 0;
        } else if (events[type]) {
          if (--this._eventsCount === 0)
            this._events = objectCreate(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = objectKeys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = objectCreate(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (!events)
    return [];

  var evlistener = events[type];
  if (!evlistener)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};

// About 1.5x faster than the two-arg version of Array#splice().
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
    list[i] = list[k];
  list.pop();
}

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function objectCreatePolyfill(proto) {
  var F = function() {};
  F.prototype = proto;
  return new F;
}
function objectKeysPolyfill(obj) {
  var keys = [];
  for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k)) {
    keys.push(k);
  }
  return k;
}
function functionBindPolyfill(context) {
  var fn = this;
  return function () {
    return fn.apply(context, arguments);
  };
}

},{}],114:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer
var MD5 = require('md5.js')

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey

},{"md5.js":171,"safe-buffer":225}],115:[function(require,module,exports){
'use strict'
var Buffer = require('safe-buffer').Buffer
var Transform = require('stream').Transform
var inherits = require('inherits')

function throwIfNotStringOrBuffer (val, prefix) {
  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
    throw new TypeError(prefix + ' must be a string or a buffer')
  }
}

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype.update = function (data, encoding) {
  throwIfNotStringOrBuffer(data, 'Data')
  if (this._finalized) throw new Error('Digest already called')
  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase

},{"inherits":131,"safe-buffer":225,"stream":236}],116:[function(require,module,exports){
var hash = exports;

hash.utils = require('./hash/utils');
hash.common = require('./hash/common');
hash.sha = require('./hash/sha');
hash.ripemd = require('./hash/ripemd');
hash.hmac = require('./hash/hmac');

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;

},{"./hash/common":117,"./hash/hmac":118,"./hash/ripemd":119,"./hash/sha":120,"./hash/utils":127}],117:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var assert = require('minimalistic-assert');

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};

},{"./utils":127,"minimalistic-assert":173}],118:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var assert = require('minimalistic-assert');

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};

},{"./utils":127,"minimalistic-assert":173}],119:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var common = require('./common');

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];

},{"./common":117,"./utils":127}],120:[function(require,module,exports){
'use strict';

exports.sha1 = require('./sha/1');
exports.sha224 = require('./sha/224');
exports.sha256 = require('./sha/256');
exports.sha384 = require('./sha/384');
exports.sha512 = require('./sha/512');

},{"./sha/1":121,"./sha/224":122,"./sha/256":123,"./sha/384":124,"./sha/512":125}],121:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var common = require('../common');
var shaCommon = require('./common');

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

},{"../common":117,"../utils":127,"./common":126}],122:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var SHA256 = require('./256');

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};


},{"../utils":127,"./256":123}],123:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var common = require('../common');
var shaCommon = require('./common');
var assert = require('minimalistic-assert');

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

},{"../common":117,"../utils":127,"./common":126,"minimalistic-assert":173}],124:[function(require,module,exports){
'use strict';

var utils = require('../utils');

var SHA512 = require('./512');

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};

},{"../utils":127,"./512":125}],125:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var common = require('../common');
var assert = require('minimalistic-assert');

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

},{"../common":117,"../utils":127,"minimalistic-assert":173}],126:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;

},{"../utils":127}],127:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');
var inherits = require('inherits');

exports.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = (c >> 6) | 192;
          res[p++] = (c & 63) | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = (c >> 18) | 240;
          res[p++] = ((c >> 12) & 63) | 128;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        } else {
          res[p++] = (c >> 12) | 224;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;

},{"inherits":131,"minimalistic-assert":173}],128:[function(require,module,exports){
'use strict';

var hash = require('hash.js');
var utils = require('minimalistic-crypto-utils');
var assert = require('minimalistic-assert');

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};

},{"hash.js":116,"minimalistic-assert":173,"minimalistic-crypto-utils":174}],129:[function(require,module,exports){
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],130:[function(require,module,exports){
(function (global){
'use strict';
var Mutation = global.MutationObserver || global.WebKitMutationObserver;

var scheduleDrain;

{
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = global.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
    var channel = new global.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = global.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      global.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

module.exports = immediate;
function immediate(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],131:[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}

},{}],132:[function(require,module,exports){
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}

},{}],133:[function(require,module,exports){
var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

},{}],134:[function(require,module,exports){
'use strict';
var utils = require('./utils');
var support = require('./support');
// private property
var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";


// public method for encoding
exports.encode = function(input) {
    var output = [];
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0, len = input.length, remainingBytes = len;

    var isArray = utils.getTypeOf(input) !== "string";
    while (i < input.length) {
        remainingBytes = len - i;

        if (!isArray) {
            chr1 = input.charCodeAt(i++);
            chr2 = i < len ? input.charCodeAt(i++) : 0;
            chr3 = i < len ? input.charCodeAt(i++) : 0;
        } else {
            chr1 = input[i++];
            chr2 = i < len ? input[i++] : 0;
            chr3 = i < len ? input[i++] : 0;
        }

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = remainingBytes > 1 ? (((chr2 & 15) << 2) | (chr3 >> 6)) : 64;
        enc4 = remainingBytes > 2 ? (chr3 & 63) : 64;

        output.push(_keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4));

    }

    return output.join("");
};

// public method for decoding
exports.decode = function(input) {
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0, resultIndex = 0;

    var dataUrlPrefix = "data:";

    if (input.substr(0, dataUrlPrefix.length) === dataUrlPrefix) {
        // This is a common error: people give a data url
        // (data:image/png;base64,iVBOR...) with a {base64: true} and
        // wonders why things don't work.
        // We can detect that the string input looks like a data url but we
        // *can't* be sure it is one: removing everything up to the comma would
        // be too dangerous.
        throw new Error("Invalid base64 input, it looks like a data url.");
    }

    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

    var totalLength = input.length * 3 / 4;
    if(input.charAt(input.length - 1) === _keyStr.charAt(64)) {
        totalLength--;
    }
    if(input.charAt(input.length - 2) === _keyStr.charAt(64)) {
        totalLength--;
    }
    if (totalLength % 1 !== 0) {
        // totalLength is not an integer, the length does not match a valid
        // base64 content. That can happen if:
        // - the input is not a base64 content
        // - the input is *almost* a base64 content, with a extra chars at the
        //   beginning or at the end
        // - the input uses a base64 variant (base64url for example)
        throw new Error("Invalid base64 input, bad content length.");
    }
    var output;
    if (support.uint8array) {
        output = new Uint8Array(totalLength|0);
    } else {
        output = new Array(totalLength|0);
    }

    while (i < input.length) {

        enc1 = _keyStr.indexOf(input.charAt(i++));
        enc2 = _keyStr.indexOf(input.charAt(i++));
        enc3 = _keyStr.indexOf(input.charAt(i++));
        enc4 = _keyStr.indexOf(input.charAt(i++));

        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;

        output[resultIndex++] = chr1;

        if (enc3 !== 64) {
            output[resultIndex++] = chr2;
        }
        if (enc4 !== 64) {
            output[resultIndex++] = chr3;
        }

    }

    return output;
};

},{"./support":163,"./utils":165}],135:[function(require,module,exports){
'use strict';

var external = require("./external");
var DataWorker = require('./stream/DataWorker');
var DataLengthProbe = require('./stream/DataLengthProbe');
var Crc32Probe = require('./stream/Crc32Probe');
var DataLengthProbe = require('./stream/DataLengthProbe');

/**
 * Represent a compressed object, with everything needed to decompress it.
 * @constructor
 * @param {number} compressedSize the size of the data compressed.
 * @param {number} uncompressedSize the size of the data after decompression.
 * @param {number} crc32 the crc32 of the decompressed file.
 * @param {object} compression the type of compression, see lib/compressions.js.
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the compressed data.
 */
function CompressedObject(compressedSize, uncompressedSize, crc32, compression, data) {
    this.compressedSize = compressedSize;
    this.uncompressedSize = uncompressedSize;
    this.crc32 = crc32;
    this.compression = compression;
    this.compressedContent = data;
}

CompressedObject.prototype = {
    /**
     * Create a worker to get the uncompressed content.
     * @return {GenericWorker} the worker.
     */
    getContentWorker : function () {
        var worker = new DataWorker(external.Promise.resolve(this.compressedContent))
        .pipe(this.compression.uncompressWorker())
        .pipe(new DataLengthProbe("data_length"));

        var that = this;
        worker.on("end", function () {
            if(this.streamInfo['data_length'] !== that.uncompressedSize) {
                throw new Error("Bug : uncompressed data size mismatch");
            }
        });
        return worker;
    },
    /**
     * Create a worker to get the compressed content.
     * @return {GenericWorker} the worker.
     */
    getCompressedWorker : function () {
        return new DataWorker(external.Promise.resolve(this.compressedContent))
        .withStreamInfo("compressedSize", this.compressedSize)
        .withStreamInfo("uncompressedSize", this.uncompressedSize)
        .withStreamInfo("crc32", this.crc32)
        .withStreamInfo("compression", this.compression)
        ;
    }
};

/**
 * Chain the given worker with other workers to compress the content with the
 * given compresion.
 * @param {GenericWorker} uncompressedWorker the worker to pipe.
 * @param {Object} compression the compression object.
 * @param {Object} compressionOptions the options to use when compressing.
 * @return {GenericWorker} the new worker compressing the content.
 */
CompressedObject.createWorkerFrom = function (uncompressedWorker, compression, compressionOptions) {
    return uncompressedWorker
    .pipe(new Crc32Probe())
    .pipe(new DataLengthProbe("uncompressedSize"))
    .pipe(compression.compressWorker(compressionOptions))
    .pipe(new DataLengthProbe("compressedSize"))
    .withStreamInfo("compression", compression);
};

module.exports = CompressedObject;

},{"./external":139,"./stream/Crc32Probe":158,"./stream/DataLengthProbe":159,"./stream/DataWorker":160}],136:[function(require,module,exports){
'use strict';

var GenericWorker = require("./stream/GenericWorker");

exports.STORE = {
    magic: "\x00\x00",
    compressWorker : function (compressionOptions) {
        return new GenericWorker("STORE compression");
    },
    uncompressWorker : function () {
        return new GenericWorker("STORE decompression");
    }
};
exports.DEFLATE = require('./flate');

},{"./flate":140,"./stream/GenericWorker":161}],137:[function(require,module,exports){
'use strict';

var utils = require('./utils');

/**
 * The following functions come from pako, from pako/lib/zlib/crc32.js
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */

// Use ordinary array, since untyped makes no boost here
function makeTable() {
    var c, table = [];

    for(var n =0; n < 256; n++){
        c = n;
        for(var k =0; k < 8; k++){
            c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
        }
        table[n] = c;
    }

    return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
    var t = crcTable, end = pos + len;

    crc = crc ^ (-1);

    for (var i = pos; i < end; i++ ) {
        crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
    }

    return (crc ^ (-1)); // >>> 0;
}

// That's all for the pako functions.

/**
 * Compute the crc32 of a string.
 * This is almost the same as the function crc32, but for strings. Using the
 * same function for the two use cases leads to horrible performances.
 * @param {Number} crc the starting value of the crc.
 * @param {String} str the string to use.
 * @param {Number} len the length of the string.
 * @param {Number} pos the starting position for the crc32 computation.
 * @return {Number} the computed crc32.
 */
function crc32str(crc, str, len, pos) {
    var t = crcTable, end = pos + len;

    crc = crc ^ (-1);

    for (var i = pos; i < end; i++ ) {
        crc = (crc >>> 8) ^ t[(crc ^ str.charCodeAt(i)) & 0xFF];
    }

    return (crc ^ (-1)); // >>> 0;
}

module.exports = function crc32wrapper(input, crc) {
    if (typeof input === "undefined" || !input.length) {
        return 0;
    }

    var isArray = utils.getTypeOf(input) !== "string";

    if(isArray) {
        return crc32(crc|0, input, input.length, 0);
    } else {
        return crc32str(crc|0, input, input.length, 0);
    }
};

},{"./utils":165}],138:[function(require,module,exports){
'use strict';
exports.base64 = false;
exports.binary = false;
exports.dir = false;
exports.createFolders = true;
exports.date = null;
exports.compression = null;
exports.compressionOptions = null;
exports.comment = null;
exports.unixPermissions = null;
exports.dosPermissions = null;

},{}],139:[function(require,module,exports){
/* global Promise */
'use strict';

// load the global object first:
// - it should be better integrated in the system (unhandledRejection in node)
// - the environment may have a custom Promise implementation (see zone.js)
var ES6Promise = null;
if (typeof Promise !== "undefined") {
    ES6Promise = Promise;
} else {
    ES6Promise = require("lie");
}

/**
 * Let the user use/change some implementations.
 */
module.exports = {
    Promise: ES6Promise
};

},{"lie":169}],140:[function(require,module,exports){
'use strict';
var USE_TYPEDARRAY = (typeof Uint8Array !== 'undefined') && (typeof Uint16Array !== 'undefined') && (typeof Uint32Array !== 'undefined');

var pako = require("pako");
var utils = require("./utils");
var GenericWorker = require("./stream/GenericWorker");

var ARRAY_TYPE = USE_TYPEDARRAY ? "uint8array" : "array";

exports.magic = "\x08\x00";

/**
 * Create a worker that uses pako to inflate/deflate.
 * @constructor
 * @param {String} action the name of the pako function to call : either "Deflate" or "Inflate".
 * @param {Object} options the options to use when (de)compressing.
 */
function FlateWorker(action, options) {
    GenericWorker.call(this, "FlateWorker/" + action);

    this._pako = null;
    this._pakoAction = action;
    this._pakoOptions = options;
    // the `meta` object from the last chunk received
    // this allow this worker to pass around metadata
    this.meta = {};
}

utils.inherits(FlateWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
FlateWorker.prototype.processChunk = function (chunk) {
    this.meta = chunk.meta;
    if (this._pako === null) {
        this._createPako();
    }
    this._pako.push(utils.transformTo(ARRAY_TYPE, chunk.data), false);
};

/**
 * @see GenericWorker.flush
 */
FlateWorker.prototype.flush = function () {
    GenericWorker.prototype.flush.call(this);
    if (this._pako === null) {
        this._createPako();
    }
    this._pako.push([], true);
};
/**
 * @see GenericWorker.cleanUp
 */
FlateWorker.prototype.cleanUp = function () {
    GenericWorker.prototype.cleanUp.call(this);
    this._pako = null;
};

/**
 * Create the _pako object.
 * TODO: lazy-loading this object isn't the best solution but it's the
 * quickest. The best solution is to lazy-load the worker list. See also the
 * issue #446.
 */
FlateWorker.prototype._createPako = function () {
    this._pako = new pako[this._pakoAction]({
        raw: true,
        level: this._pakoOptions.level || -1 // default compression
    });
    var self = this;
    this._pako.onData = function(data) {
        self.push({
            data : data,
            meta : self.meta
        });
    };
};

exports.compressWorker = function (compressionOptions) {
    return new FlateWorker("Deflate", compressionOptions);
};
exports.uncompressWorker = function () {
    return new FlateWorker("Inflate", {});
};

},{"./stream/GenericWorker":161,"./utils":165,"pako":175}],141:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var GenericWorker = require('../stream/GenericWorker');
var utf8 = require('../utf8');
var crc32 = require('../crc32');
var signature = require('../signature');

/**
 * Transform an integer into a string in hexadecimal.
 * @private
 * @param {number} dec the number to convert.
 * @param {number} bytes the number of bytes to generate.
 * @returns {string} the result.
 */
var decToHex = function(dec, bytes) {
    var hex = "", i;
    for (i = 0; i < bytes; i++) {
        hex += String.fromCharCode(dec & 0xff);
        dec = dec >>> 8;
    }
    return hex;
};

/**
 * Generate the UNIX part of the external file attributes.
 * @param {Object} unixPermissions the unix permissions or null.
 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
 * @return {Number} a 32 bit integer.
 *
 * adapted from http://unix.stackexchange.com/questions/14705/the-zip-formats-external-file-attribute :
 *
 * TTTTsstrwxrwxrwx0000000000ADVSHR
 * ^^^^____________________________ file type, see zipinfo.c (UNX_*)
 *     ^^^_________________________ setuid, setgid, sticky
 *        ^^^^^^^^^________________ permissions
 *                 ^^^^^^^^^^______ not used ?
 *                           ^^^^^^ DOS attribute bits : Archive, Directory, Volume label, System file, Hidden, Read only
 */
var generateUnixExternalFileAttr = function (unixPermissions, isDir) {

    var result = unixPermissions;
    if (!unixPermissions) {
        // I can't use octal values in strict mode, hence the hexa.
        //  040775 => 0x41fd
        // 0100664 => 0x81b4
        result = isDir ? 0x41fd : 0x81b4;
    }
    return (result & 0xFFFF) << 16;
};

/**
 * Generate the DOS part of the external file attributes.
 * @param {Object} dosPermissions the dos permissions or null.
 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
 * @return {Number} a 32 bit integer.
 *
 * Bit 0     Read-Only
 * Bit 1     Hidden
 * Bit 2     System
 * Bit 3     Volume Label
 * Bit 4     Directory
 * Bit 5     Archive
 */
var generateDosExternalFileAttr = function (dosPermissions, isDir) {

    // the dir flag is already set for compatibility
    return (dosPermissions || 0)  & 0x3F;
};

/**
 * Generate the various parts used in the construction of the final zip file.
 * @param {Object} streamInfo the hash with informations about the compressed file.
 * @param {Boolean} streamedContent is the content streamed ?
 * @param {Boolean} streamingEnded is the stream finished ?
 * @param {number} offset the current offset from the start of the zip file.
 * @param {String} platform let's pretend we are this platform (change platform dependents fields)
 * @param {Function} encodeFileName the function to encode the file name / comment.
 * @return {Object} the zip parts.
 */
var generateZipParts = function(streamInfo, streamedContent, streamingEnded, offset, platform, encodeFileName) {
    var file = streamInfo['file'],
    compression = streamInfo['compression'],
    useCustomEncoding = encodeFileName !== utf8.utf8encode,
    encodedFileName = utils.transformTo("string", encodeFileName(file.name)),
    utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
    comment = file.comment,
    encodedComment = utils.transformTo("string", encodeFileName(comment)),
    utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
    useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
    useUTF8ForComment = utfEncodedComment.length !== comment.length,
    dosTime,
    dosDate,
    extraFields = "",
    unicodePathExtraField = "",
    unicodeCommentExtraField = "",
    dir = file.dir,
    date = file.date;


    var dataInfo = {
        crc32 : 0,
        compressedSize : 0,
        uncompressedSize : 0
    };

    // if the content is streamed, the sizes/crc32 are only available AFTER
    // the end of the stream.
    if (!streamedContent || streamingEnded) {
        dataInfo.crc32 = streamInfo['crc32'];
        dataInfo.compressedSize = streamInfo['compressedSize'];
        dataInfo.uncompressedSize = streamInfo['uncompressedSize'];
    }

    var bitflag = 0;
    if (streamedContent) {
        // Bit 3: the sizes/crc32 are set to zero in the local header.
        // The correct values are put in the data descriptor immediately
        // following the compressed data.
        bitflag |= 0x0008;
    }
    if (!useCustomEncoding && (useUTF8ForFileName || useUTF8ForComment)) {
        // Bit 11: Language encoding flag (EFS).
        bitflag |= 0x0800;
    }


    var extFileAttr = 0;
    var versionMadeBy = 0;
    if (dir) {
        // dos or unix, we set the dos dir flag
        extFileAttr |= 0x00010;
    }
    if(platform === "UNIX") {
        versionMadeBy = 0x031E; // UNIX, version 3.0
        extFileAttr |= generateUnixExternalFileAttr(file.unixPermissions, dir);
    } else { // DOS or other, fallback to DOS
        versionMadeBy = 0x0014; // DOS, version 2.0
        extFileAttr |= generateDosExternalFileAttr(file.dosPermissions, dir);
    }

    // date
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html

    dosTime = date.getUTCHours();
    dosTime = dosTime << 6;
    dosTime = dosTime | date.getUTCMinutes();
    dosTime = dosTime << 5;
    dosTime = dosTime | date.getUTCSeconds() / 2;

    dosDate = date.getUTCFullYear() - 1980;
    dosDate = dosDate << 4;
    dosDate = dosDate | (date.getUTCMonth() + 1);
    dosDate = dosDate << 5;
    dosDate = dosDate | date.getUTCDate();

    if (useUTF8ForFileName) {
        // set the unicode path extra field. unzip needs at least one extra
        // field to correctly handle unicode path, so using the path is as good
        // as any other information. This could improve the situation with
        // other archive managers too.
        // This field is usually used without the utf8 flag, with a non
        // unicode path in the header (winrar, winzip). This helps (a bit)
        // with the messy Windows' default compressed folders feature but
        // breaks on p7zip which doesn't seek the unicode path extra field.
        // So for now, UTF-8 everywhere !
        unicodePathExtraField =
            // Version
            decToHex(1, 1) +
            // NameCRC32
            decToHex(crc32(encodedFileName), 4) +
            // UnicodeName
            utfEncodedFileName;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x70" +
            // size
            decToHex(unicodePathExtraField.length, 2) +
            // content
            unicodePathExtraField;
    }

    if(useUTF8ForComment) {

        unicodeCommentExtraField =
            // Version
            decToHex(1, 1) +
            // CommentCRC32
            decToHex(crc32(encodedComment), 4) +
            // UnicodeName
            utfEncodedComment;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x63" +
            // size
            decToHex(unicodeCommentExtraField.length, 2) +
            // content
            unicodeCommentExtraField;
    }

    var header = "";

    // version needed to extract
    header += "\x0A\x00";
    // general purpose bit flag
    header += decToHex(bitflag, 2);
    // compression method
    header += compression.magic;
    // last mod file time
    header += decToHex(dosTime, 2);
    // last mod file date
    header += decToHex(dosDate, 2);
    // crc-32
    header += decToHex(dataInfo.crc32, 4);
    // compressed size
    header += decToHex(dataInfo.compressedSize, 4);
    // uncompressed size
    header += decToHex(dataInfo.uncompressedSize, 4);
    // file name length
    header += decToHex(encodedFileName.length, 2);
    // extra field length
    header += decToHex(extraFields.length, 2);


    var fileRecord = signature.LOCAL_FILE_HEADER + header + encodedFileName + extraFields;

    var dirRecord = signature.CENTRAL_FILE_HEADER +
        // version made by (00: DOS)
        decToHex(versionMadeBy, 2) +
        // file header (common to file and central directory)
        header +
        // file comment length
        decToHex(encodedComment.length, 2) +
        // disk number start
        "\x00\x00" +
        // internal file attributes TODO
        "\x00\x00" +
        // external file attributes
        decToHex(extFileAttr, 4) +
        // relative offset of local header
        decToHex(offset, 4) +
        // file name
        encodedFileName +
        // extra field
        extraFields +
        // file comment
        encodedComment;

    return {
        fileRecord: fileRecord,
        dirRecord: dirRecord
    };
};

/**
 * Generate the EOCD record.
 * @param {Number} entriesCount the number of entries in the zip file.
 * @param {Number} centralDirLength the length (in bytes) of the central dir.
 * @param {Number} localDirLength the length (in bytes) of the local dir.
 * @param {String} comment the zip file comment as a binary string.
 * @param {Function} encodeFileName the function to encode the comment.
 * @return {String} the EOCD record.
 */
var generateCentralDirectoryEnd = function (entriesCount, centralDirLength, localDirLength, comment, encodeFileName) {
    var dirEnd = "";
    var encodedComment = utils.transformTo("string", encodeFileName(comment));

    // end of central dir signature
    dirEnd = signature.CENTRAL_DIRECTORY_END +
        // number of this disk
        "\x00\x00" +
        // number of the disk with the start of the central directory
        "\x00\x00" +
        // total number of entries in the central directory on this disk
        decToHex(entriesCount, 2) +
        // total number of entries in the central directory
        decToHex(entriesCount, 2) +
        // size of the central directory   4 bytes
        decToHex(centralDirLength, 4) +
        // offset of start of central directory with respect to the starting disk number
        decToHex(localDirLength, 4) +
        // .ZIP file comment length
        decToHex(encodedComment.length, 2) +
        // .ZIP file comment
        encodedComment;

    return dirEnd;
};

/**
 * Generate data descriptors for a file entry.
 * @param {Object} streamInfo the hash generated by a worker, containing informations
 * on the file entry.
 * @return {String} the data descriptors.
 */
var generateDataDescriptors = function (streamInfo) {
    var descriptor = "";
    descriptor = signature.DATA_DESCRIPTOR +
        // crc-32                          4 bytes
        decToHex(streamInfo['crc32'], 4) +
        // compressed size                 4 bytes
        decToHex(streamInfo['compressedSize'], 4) +
        // uncompressed size               4 bytes
        decToHex(streamInfo['uncompressedSize'], 4);

    return descriptor;
};


/**
 * A worker to concatenate other workers to create a zip file.
 * @param {Boolean} streamFiles `true` to stream the content of the files,
 * `false` to accumulate it.
 * @param {String} comment the comment to use.
 * @param {String} platform the platform to use, "UNIX" or "DOS".
 * @param {Function} encodeFileName the function to encode file names and comments.
 */
function ZipFileWorker(streamFiles, comment, platform, encodeFileName) {
    GenericWorker.call(this, "ZipFileWorker");
    // The number of bytes written so far. This doesn't count accumulated chunks.
    this.bytesWritten = 0;
    // The comment of the zip file
    this.zipComment = comment;
    // The platform "generating" the zip file.
    this.zipPlatform = platform;
    // the function to encode file names and comments.
    this.encodeFileName = encodeFileName;
    // Should we stream the content of the files ?
    this.streamFiles = streamFiles;
    // If `streamFiles` is false, we will need to accumulate the content of the
    // files to calculate sizes / crc32 (and write them *before* the content).
    // This boolean indicates if we are accumulating chunks (it will change a lot
    // during the lifetime of this worker).
    this.accumulate = false;
    // The buffer receiving chunks when accumulating content.
    this.contentBuffer = [];
    // The list of generated directory records.
    this.dirRecords = [];
    // The offset (in bytes) from the beginning of the zip file for the current source.
    this.currentSourceOffset = 0;
    // The total number of entries in this zip file.
    this.entriesCount = 0;
    // the name of the file currently being added, null when handling the end of the zip file.
    // Used for the emited metadata.
    this.currentFile = null;



    this._sources = [];
}
utils.inherits(ZipFileWorker, GenericWorker);

/**
 * @see GenericWorker.push
 */
ZipFileWorker.prototype.push = function (chunk) {

    var currentFilePercent = chunk.meta.percent || 0;
    var entriesCount = this.entriesCount;
    var remainingFiles = this._sources.length;

    if(this.accumulate) {
        this.contentBuffer.push(chunk);
    } else {
        this.bytesWritten += chunk.data.length;

        GenericWorker.prototype.push.call(this, {
            data : chunk.data,
            meta : {
                currentFile : this.currentFile,
                percent : entriesCount ? (currentFilePercent + 100 * (entriesCount - remainingFiles - 1)) / entriesCount : 100
            }
        });
    }
};

/**
 * The worker started a new source (an other worker).
 * @param {Object} streamInfo the streamInfo object from the new source.
 */
ZipFileWorker.prototype.openedSource = function (streamInfo) {
    this.currentSourceOffset = this.bytesWritten;
    this.currentFile = streamInfo['file'].name;

    var streamedContent = this.streamFiles && !streamInfo['file'].dir;

    // don't stream folders (because they don't have any content)
    if(streamedContent) {
        var record = generateZipParts(streamInfo, streamedContent, false, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        this.push({
            data : record.fileRecord,
            meta : {percent:0}
        });
    } else {
        // we need to wait for the whole file before pushing anything
        this.accumulate = true;
    }
};

/**
 * The worker finished a source (an other worker).
 * @param {Object} streamInfo the streamInfo object from the finished source.
 */
ZipFileWorker.prototype.closedSource = function (streamInfo) {
    this.accumulate = false;
    var streamedContent = this.streamFiles && !streamInfo['file'].dir;
    var record = generateZipParts(streamInfo, streamedContent, true, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);

    this.dirRecords.push(record.dirRecord);
    if(streamedContent) {
        // after the streamed file, we put data descriptors
        this.push({
            data : generateDataDescriptors(streamInfo),
            meta : {percent:100}
        });
    } else {
        // the content wasn't streamed, we need to push everything now
        // first the file record, then the content
        this.push({
            data : record.fileRecord,
            meta : {percent:0}
        });
        while(this.contentBuffer.length) {
            this.push(this.contentBuffer.shift());
        }
    }
    this.currentFile = null;
};

/**
 * @see GenericWorker.flush
 */
ZipFileWorker.prototype.flush = function () {

    var localDirLength = this.bytesWritten;
    for(var i = 0; i < this.dirRecords.length; i++) {
        this.push({
            data : this.dirRecords[i],
            meta : {percent:100}
        });
    }
    var centralDirLength = this.bytesWritten - localDirLength;

    var dirEnd = generateCentralDirectoryEnd(this.dirRecords.length, centralDirLength, localDirLength, this.zipComment, this.encodeFileName);

    this.push({
        data : dirEnd,
        meta : {percent:100}
    });
};

/**
 * Prepare the next source to be read.
 */
ZipFileWorker.prototype.prepareNextSource = function () {
    this.previous = this._sources.shift();
    this.openedSource(this.previous.streamInfo);
    if (this.isPaused) {
        this.previous.pause();
    } else {
        this.previous.resume();
    }
};

/**
 * @see GenericWorker.registerPrevious
 */
ZipFileWorker.prototype.registerPrevious = function (previous) {
    this._sources.push(previous);
    var self = this;

    previous.on('data', function (chunk) {
        self.processChunk(chunk);
    });
    previous.on('end', function () {
        self.closedSource(self.previous.streamInfo);
        if(self._sources.length) {
            self.prepareNextSource();
        } else {
            self.end();
        }
    });
    previous.on('error', function (e) {
        self.error(e);
    });
    return this;
};

/**
 * @see GenericWorker.resume
 */
ZipFileWorker.prototype.resume = function () {
    if(!GenericWorker.prototype.resume.call(this)) {
        return false;
    }

    if (!this.previous && this._sources.length) {
        this.prepareNextSource();
        return true;
    }
    if (!this.previous && !this._sources.length && !this.generatedError) {
        this.end();
        return true;
    }
};

/**
 * @see GenericWorker.error
 */
ZipFileWorker.prototype.error = function (e) {
    var sources = this._sources;
    if(!GenericWorker.prototype.error.call(this, e)) {
        return false;
    }
    for(var i = 0; i < sources.length; i++) {
        try {
            sources[i].error(e);
        } catch(e) {
            // the `error` exploded, nothing to do
        }
    }
    return true;
};

/**
 * @see GenericWorker.lock
 */
ZipFileWorker.prototype.lock = function () {
    GenericWorker.prototype.lock.call(this);
    var sources = this._sources;
    for(var i = 0; i < sources.length; i++) {
        sources[i].lock();
    }
};

module.exports = ZipFileWorker;

},{"../crc32":137,"../signature":156,"../stream/GenericWorker":161,"../utf8":164,"../utils":165}],142:[function(require,module,exports){
'use strict';

var compressions = require('../compressions');
var ZipFileWorker = require('./ZipFileWorker');

/**
 * Find the compression to use.
 * @param {String} fileCompression the compression defined at the file level, if any.
 * @param {String} zipCompression the compression defined at the load() level.
 * @return {Object} the compression object to use.
 */
var getCompression = function (fileCompression, zipCompression) {

    var compressionName = fileCompression || zipCompression;
    var compression = compressions[compressionName];
    if (!compression) {
        throw new Error(compressionName + " is not a valid compression method !");
    }
    return compression;
};

/**
 * Create a worker to generate a zip file.
 * @param {JSZip} zip the JSZip instance at the right root level.
 * @param {Object} options to generate the zip file.
 * @param {String} comment the comment to use.
 */
exports.generateWorker = function (zip, options, comment) {

    var zipFileWorker = new ZipFileWorker(options.streamFiles, comment, options.platform, options.encodeFileName);
    var entriesCount = 0;
    try {

        zip.forEach(function (relativePath, file) {
            entriesCount++;
            var compression = getCompression(file.options.compression, options.compression);
            var compressionOptions = file.options.compressionOptions || options.compressionOptions || {};
            var dir = file.dir, date = file.date;

            file._compressWorker(compression, compressionOptions)
            .withStreamInfo("file", {
                name : relativePath,
                dir : dir,
                date : date,
                comment : file.comment || "",
                unixPermissions : file.unixPermissions,
                dosPermissions : file.dosPermissions
            })
            .pipe(zipFileWorker);
        });
        zipFileWorker.entriesCount = entriesCount;
    } catch (e) {
        zipFileWorker.error(e);
    }

    return zipFileWorker;
};

},{"../compressions":136,"./ZipFileWorker":141}],143:[function(require,module,exports){
'use strict';

/**
 * Representation a of zip file in js
 * @constructor
 */
function JSZip() {
    // if this constructor is used without `new`, it adds `new` before itself:
    if(!(this instanceof JSZip)) {
        return new JSZip();
    }

    if(arguments.length) {
        throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
    }

    // object containing the files :
    // {
    //   "folder/" : {...},
    //   "folder/data.txt" : {...}
    // }
    this.files = {};

    this.comment = null;

    // Where we are in the hierarchy
    this.root = "";
    this.clone = function() {
        var newObj = new JSZip();
        for (var i in this) {
            if (typeof this[i] !== "function") {
                newObj[i] = this[i];
            }
        }
        return newObj;
    };
}
JSZip.prototype = require('./object');
JSZip.prototype.loadAsync = require('./load');
JSZip.support = require('./support');
JSZip.defaults = require('./defaults');

// TODO find a better way to handle this version,
// a require('package.json').version doesn't work with webpack, see #327
JSZip.version = "3.2.0";

JSZip.loadAsync = function (content, options) {
    return new JSZip().loadAsync(content, options);
};

JSZip.external = require("./external");
module.exports = JSZip;

},{"./defaults":138,"./external":139,"./load":144,"./object":148,"./support":163}],144:[function(require,module,exports){
'use strict';
var utils = require('./utils');
var external = require("./external");
var utf8 = require('./utf8');
var utils = require('./utils');
var ZipEntries = require('./zipEntries');
var Crc32Probe = require('./stream/Crc32Probe');
var nodejsUtils = require("./nodejsUtils");

/**
 * Check the CRC32 of an entry.
 * @param {ZipEntry} zipEntry the zip entry to check.
 * @return {Promise} the result.
 */
function checkEntryCRC32(zipEntry) {
    return new external.Promise(function (resolve, reject) {
        var worker = zipEntry.decompressed.getContentWorker().pipe(new Crc32Probe());
        worker.on("error", function (e) {
            reject(e);
        })
        .on("end", function () {
            if (worker.streamInfo.crc32 !== zipEntry.decompressed.crc32) {
                reject(new Error("Corrupted zip : CRC32 mismatch"));
            } else {
                resolve();
            }
        })
        .resume();
    });
}

module.exports = function(data, options) {
    var zip = this;
    options = utils.extend(options || {}, {
        base64: false,
        checkCRC32: false,
        optimizedBinaryString: false,
        createFolders: false,
        decodeFileName: utf8.utf8decode
    });

    if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
        return external.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file."));
    }

    return utils.prepareContent("the loaded zip file", data, true, options.optimizedBinaryString, options.base64)
    .then(function(data) {
        var zipEntries = new ZipEntries(options);
        zipEntries.load(data);
        return zipEntries;
    }).then(function checkCRC32(zipEntries) {
        var promises = [external.Promise.resolve(zipEntries)];
        var files = zipEntries.files;
        if (options.checkCRC32) {
            for (var i = 0; i < files.length; i++) {
                promises.push(checkEntryCRC32(files[i]));
            }
        }
        return external.Promise.all(promises);
    }).then(function addFiles(results) {
        var zipEntries = results.shift();
        var files = zipEntries.files;
        for (var i = 0; i < files.length; i++) {
            var input = files[i];
            zip.file(input.fileNameStr, input.decompressed, {
                binary: true,
                optimizedBinaryString: true,
                date: input.date,
                dir: input.dir,
                comment : input.fileCommentStr.length ? input.fileCommentStr : null,
                unixPermissions : input.unixPermissions,
                dosPermissions : input.dosPermissions,
                createFolders: options.createFolders
            });
        }
        if (zipEntries.zipComment.length) {
            zip.comment = zipEntries.zipComment;
        }

        return zip;
    });
};

},{"./external":139,"./nodejsUtils":147,"./stream/Crc32Probe":158,"./utf8":164,"./utils":165,"./zipEntries":166}],145:[function(require,module,exports){
"use strict";

var utils = require('../utils');
var GenericWorker = require('../stream/GenericWorker');

/**
 * A worker that use a nodejs stream as source.
 * @constructor
 * @param {String} filename the name of the file entry for this stream.
 * @param {Readable} stream the nodejs stream.
 */
function NodejsStreamInputAdapter(filename, stream) {
    GenericWorker.call(this, "Nodejs stream input adapter for " + filename);
    this._upstreamEnded = false;
    this._bindStream(stream);
}

utils.inherits(NodejsStreamInputAdapter, GenericWorker);

/**
 * Prepare the stream and bind the callbacks on it.
 * Do this ASAP on node 0.10 ! A lazy binding doesn't always work.
 * @param {Stream} stream the nodejs stream to use.
 */
NodejsStreamInputAdapter.prototype._bindStream = function (stream) {
    var self = this;
    this._stream = stream;
    stream.pause();
    stream
    .on("data", function (chunk) {
        self.push({
            data: chunk,
            meta : {
                percent : 0
            }
        });
    })
    .on("error", function (e) {
        if(self.isPaused) {
            this.generatedError = e;
        } else {
            self.error(e);
        }
    })
    .on("end", function () {
        if(self.isPaused) {
            self._upstreamEnded = true;
        } else {
            self.end();
        }
    });
};
NodejsStreamInputAdapter.prototype.pause = function () {
    if(!GenericWorker.prototype.pause.call(this)) {
        return false;
    }
    this._stream.pause();
    return true;
};
NodejsStreamInputAdapter.prototype.resume = function () {
    if(!GenericWorker.prototype.resume.call(this)) {
        return false;
    }

    if(this._upstreamEnded) {
        this.end();
    } else {
        this._stream.resume();
    }

    return true;
};

module.exports = NodejsStreamInputAdapter;

},{"../stream/GenericWorker":161,"../utils":165}],146:[function(require,module,exports){
'use strict';

var Readable = require('readable-stream').Readable;

var utils = require('../utils');
utils.inherits(NodejsStreamOutputAdapter, Readable);

/**
* A nodejs stream using a worker as source.
* @see the SourceWrapper in http://nodejs.org/api/stream.html
* @constructor
* @param {StreamHelper} helper the helper wrapping the worker
* @param {Object} options the nodejs stream options
* @param {Function} updateCb the update callback.
*/
function NodejsStreamOutputAdapter(helper, options, updateCb) {
    Readable.call(this, options);
    this._helper = helper;

    var self = this;
    helper.on("data", function (data, meta) {
        if (!self.push(data)) {
            self._helper.pause();
        }
        if(updateCb) {
            updateCb(meta);
        }
    })
    .on("error", function(e) {
        self.emit('error', e);
    })
    .on("end", function () {
        self.push(null);
    });
}


NodejsStreamOutputAdapter.prototype._read = function() {
    this._helper.resume();
};

module.exports = NodejsStreamOutputAdapter;

},{"../utils":165,"readable-stream":149}],147:[function(require,module,exports){
(function (Buffer){
'use strict';

module.exports = {
    /**
     * True if this is running in Nodejs, will be undefined in a browser.
     * In a browser, browserify won't include this file and the whole module
     * will be resolved an empty object.
     */
    isNode : typeof Buffer !== "undefined",
    /**
     * Create a new nodejs Buffer from an existing content.
     * @param {Object} data the data to pass to the constructor.
     * @param {String} encoding the encoding to use.
     * @return {Buffer} a new Buffer.
     */
    newBufferFrom: function(data, encoding) {
        if (Buffer.from && Buffer.from !== Uint8Array.from) {
            return Buffer.from(data, encoding);
        } else {
            if (typeof data === "number") {
                // Safeguard for old Node.js versions. On newer versions,
                // Buffer.from(number) / Buffer(number, encoding) already throw.
                throw new Error("The \"data\" argument must not be a number");
            }
            return new Buffer(data, encoding);
        }
    },
    /**
     * Create a new nodejs Buffer with the specified size.
     * @param {Integer} size the size of the buffer.
     * @return {Buffer} a new Buffer.
     */
    allocBuffer: function (size) {
        if (Buffer.alloc) {
            return Buffer.alloc(size);
        } else {
            var buf = new Buffer(size);
            buf.fill(0);
            return buf;
        }
    },
    /**
     * Find out if an object is a Buffer.
     * @param {Object} b the object to test.
     * @return {Boolean} true if the object is a Buffer, false otherwise.
     */
    isBuffer : function(b){
        return Buffer.isBuffer(b);
    },

    isStream : function (obj) {
        return obj &&
            typeof obj.on === "function" &&
            typeof obj.pause === "function" &&
            typeof obj.resume === "function";
    }
};

}).call(this,require("buffer").Buffer)

},{"buffer":77}],148:[function(require,module,exports){
'use strict';
var utf8 = require('./utf8');
var utils = require('./utils');
var GenericWorker = require('./stream/GenericWorker');
var StreamHelper = require('./stream/StreamHelper');
var defaults = require('./defaults');
var CompressedObject = require('./compressedObject');
var ZipObject = require('./zipObject');
var generate = require("./generate");
var nodejsUtils = require("./nodejsUtils");
var NodejsStreamInputAdapter = require("./nodejs/NodejsStreamInputAdapter");


/**
 * Add a file in the current folder.
 * @private
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
 * @param {Object} originalOptions the options of the file
 * @return {Object} the new file.
 */
var fileAdd = function(name, data, originalOptions) {
    // be sure sub folders exist
    var dataType = utils.getTypeOf(data),
        parent;


    /*
     * Correct options.
     */

    var o = utils.extend(originalOptions || {}, defaults);
    o.date = o.date || new Date();
    if (o.compression !== null) {
        o.compression = o.compression.toUpperCase();
    }

    if (typeof o.unixPermissions === "string") {
        o.unixPermissions = parseInt(o.unixPermissions, 8);
    }

    // UNX_IFDIR  0040000 see zipinfo.c
    if (o.unixPermissions && (o.unixPermissions & 0x4000)) {
        o.dir = true;
    }
    // Bit 4    Directory
    if (o.dosPermissions && (o.dosPermissions & 0x0010)) {
        o.dir = true;
    }

    if (o.dir) {
        name = forceTrailingSlash(name);
    }
    if (o.createFolders && (parent = parentFolder(name))) {
        folderAdd.call(this, parent, true);
    }

    var isUnicodeString = dataType === "string" && o.binary === false && o.base64 === false;
    if (!originalOptions || typeof originalOptions.binary === "undefined") {
        o.binary = !isUnicodeString;
    }


    var isCompressedEmpty = (data instanceof CompressedObject) && data.uncompressedSize === 0;

    if (isCompressedEmpty || o.dir || !data || data.length === 0) {
        o.base64 = false;
        o.binary = true;
        data = "";
        o.compression = "STORE";
        dataType = "string";
    }

    /*
     * Convert content to fit.
     */

    var zipObjectContent = null;
    if (data instanceof CompressedObject || data instanceof GenericWorker) {
        zipObjectContent = data;
    } else if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
        zipObjectContent = new NodejsStreamInputAdapter(name, data);
    } else {
        zipObjectContent = utils.prepareContent(name, data, o.binary, o.optimizedBinaryString, o.base64);
    }

    var object = new ZipObject(name, zipObjectContent, o);
    this.files[name] = object;
    /*
    TODO: we can't throw an exception because we have async promises
    (we can have a promise of a Date() for example) but returning a
    promise is useless because file(name, data) returns the JSZip
    object for chaining. Should we break that to allow the user
    to catch the error ?

    return external.Promise.resolve(zipObjectContent)
    .then(function () {
        return object;
    });
    */
};

/**
 * Find the parent folder of the path.
 * @private
 * @param {string} path the path to use
 * @return {string} the parent folder, or ""
 */
var parentFolder = function (path) {
    if (path.slice(-1) === '/') {
        path = path.substring(0, path.length - 1);
    }
    var lastSlash = path.lastIndexOf('/');
    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
};

/**
 * Returns the path with a slash at the end.
 * @private
 * @param {String} path the path to check.
 * @return {String} the path with a trailing slash.
 */
var forceTrailingSlash = function(path) {
    // Check the name ends with a /
    if (path.slice(-1) !== "/") {
        path += "/"; // IE doesn't like substr(-1)
    }
    return path;
};

/**
 * Add a (sub) folder in the current folder.
 * @private
 * @param {string} name the folder's name
 * @param {boolean=} [createFolders] If true, automatically create sub
 *  folders. Defaults to false.
 * @return {Object} the new folder.
 */
var folderAdd = function(name, createFolders) {
    createFolders = (typeof createFolders !== 'undefined') ? createFolders : defaults.createFolders;

    name = forceTrailingSlash(name);

    // Does this folder already exist?
    if (!this.files[name]) {
        fileAdd.call(this, name, null, {
            dir: true,
            createFolders: createFolders
        });
    }
    return this.files[name];
};

/**
* Cross-window, cross-Node-context regular expression detection
* @param  {Object}  object Anything
* @return {Boolean}        true if the object is a regular expression,
* false otherwise
*/
function isRegExp(object) {
    return Object.prototype.toString.call(object) === "[object RegExp]";
}

// return the actual prototype of JSZip
var out = {
    /**
     * @see loadAsync
     */
    load: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
    },


    /**
     * Call a callback function for each entry at this folder level.
     * @param {Function} cb the callback function:
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     */
    forEach: function(cb) {
        var filename, relativePath, file;
        for (filename in this.files) {
            if (!this.files.hasOwnProperty(filename)) {
                continue;
            }
            file = this.files[filename];
            relativePath = filename.slice(this.root.length, filename.length);
            if (relativePath && filename.slice(0, this.root.length) === this.root) { // the file is in the current root
                cb(relativePath, file); // TODO reverse the parameters ? need to be clean AND consistent with the filter search fn...
            }
        }
    },

    /**
     * Filter nested files/folders with the specified function.
     * @param {Function} search the predicate to use :
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     * @return {Array} An array of matching elements.
     */
    filter: function(search) {
        var result = [];
        this.forEach(function (relativePath, entry) {
            if (search(relativePath, entry)) { // the file matches the function
                result.push(entry);
            }

        });
        return result;
    },

    /**
     * Add a file to the zip file, or search a file.
     * @param   {string|RegExp} name The name of the file to add (if data is defined),
     * the name of the file to find (if no data) or a regex to match files.
     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
     * @param   {Object} o     File options
     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
     * a file (when searching by string) or an array of files (when searching by regex).
     */
    file: function(name, data, o) {
        if (arguments.length === 1) {
            if (isRegExp(name)) {
                var regexp = name;
                return this.filter(function(relativePath, file) {
                    return !file.dir && regexp.test(relativePath);
                });
            }
            else { // text
                var obj = this.files[this.root + name];
                if (obj && !obj.dir) {
                    return obj;
                } else {
                    return null;
                }
            }
        }
        else { // more than one argument : we have data !
            name = this.root + name;
            fileAdd.call(this, name, data, o);
        }
        return this;
    },

    /**
     * Add a directory to the zip file, or search.
     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
     */
    folder: function(arg) {
        if (!arg) {
            return this;
        }

        if (isRegExp(arg)) {
            return this.filter(function(relativePath, file) {
                return file.dir && arg.test(relativePath);
            });
        }

        // else, name is a new folder
        var name = this.root + arg;
        var newFolder = folderAdd.call(this, name);

        // Allow chaining by returning a new object with this folder as the root
        var ret = this.clone();
        ret.root = newFolder.name;
        return ret;
    },

    /**
     * Delete a file, or a directory and all sub-files, from the zip
     * @param {string} name the name of the file to delete
     * @return {JSZip} this JSZip object
     */
    remove: function(name) {
        name = this.root + name;
        var file = this.files[name];
        if (!file) {
            // Look for any folders
            if (name.slice(-1) !== "/") {
                name += "/";
            }
            file = this.files[name];
        }

        if (file && !file.dir) {
            // file
            delete this.files[name];
        } else {
            // maybe a folder, delete recursively
            var kids = this.filter(function(relativePath, file) {
                return file.name.slice(0, name.length) === name;
            });
            for (var i = 0; i < kids.length; i++) {
                delete this.files[kids[i].name];
            }
        }

        return this;
    },

    /**
     * Generate the complete zip file
     * @param {Object} options the options to generate the zip file :
     * - compression, "STORE" by default.
     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
     */
    generate: function(options) {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
    },

    /**
     * Generate the complete zip file as an internal stream.
     * @param {Object} options the options to generate the zip file :
     * - compression, "STORE" by default.
     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
     * @return {StreamHelper} the streamed zip file.
     */
    generateInternalStream: function(options) {
      var worker, opts = {};
      try {
          opts = utils.extend(options || {}, {
              streamFiles: false,
              compression: "STORE",
              compressionOptions : null,
              type: "",
              platform: "DOS",
              comment: null,
              mimeType: 'application/zip',
              encodeFileName: utf8.utf8encode
          });

          opts.type = opts.type.toLowerCase();
          opts.compression = opts.compression.toUpperCase();

          // "binarystring" is prefered but the internals use "string".
          if(opts.type === "binarystring") {
            opts.type = "string";
          }

          if (!opts.type) {
            throw new Error("No output type specified.");
          }

          utils.checkSupport(opts.type);

          // accept nodejs `process.platform`
          if(
              opts.platform === 'darwin' ||
              opts.platform === 'freebsd' ||
              opts.platform === 'linux' ||
              opts.platform === 'sunos'
          ) {
              opts.platform = "UNIX";
          }
          if (opts.platform === 'win32') {
              opts.platform = "DOS";
          }

          var comment = opts.comment || this.comment || "";
          worker = generate.generateWorker(this, opts, comment);
      } catch (e) {
        worker = new GenericWorker("error");
        worker.error(e);
      }
      return new StreamHelper(worker, opts.type || "string", opts.mimeType);
    },
    /**
     * Generate the complete zip file asynchronously.
     * @see generateInternalStream
     */
    generateAsync: function(options, onUpdate) {
        return this.generateInternalStream(options).accumulate(onUpdate);
    },
    /**
     * Generate the complete zip file asynchronously.
     * @see generateInternalStream
     */
    generateNodeStream: function(options, onUpdate) {
        options = options || {};
        if (!options.type) {
            options.type = "nodebuffer";
        }
        return this.generateInternalStream(options).toNodejsStream(onUpdate);
    }
};
module.exports = out;

},{"./compressedObject":135,"./defaults":138,"./generate":142,"./nodejs/NodejsStreamInputAdapter":145,"./nodejsUtils":147,"./stream/GenericWorker":161,"./stream/StreamHelper":162,"./utf8":164,"./utils":165,"./zipObject":168}],149:[function(require,module,exports){
/*
 * This file is used by module bundlers (browserify/webpack/etc) when
 * including a stream implementation. We use "readable-stream" to get a
 * consistent behavior between nodejs versions but bundlers often have a shim
 * for "stream". Using this shim greatly improve the compatibility and greatly
 * reduce the final size of the bundle (only one stream implementation, not
 * two).
 */
module.exports = require("stream");

},{"stream":236}],150:[function(require,module,exports){
'use strict';
var DataReader = require('./DataReader');
var utils = require('../utils');

function ArrayReader(data) {
    DataReader.call(this, data);
	for(var i = 0; i < this.data.length; i++) {
		data[i] = data[i] & 0xFF;
	}
}
utils.inherits(ArrayReader, DataReader);
/**
 * @see DataReader.byteAt
 */
ArrayReader.prototype.byteAt = function(i) {
    return this.data[this.zero + i];
};
/**
 * @see DataReader.lastIndexOfSignature
 */
ArrayReader.prototype.lastIndexOfSignature = function(sig) {
    var sig0 = sig.charCodeAt(0),
        sig1 = sig.charCodeAt(1),
        sig2 = sig.charCodeAt(2),
        sig3 = sig.charCodeAt(3);
    for (var i = this.length - 4; i >= 0; --i) {
        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
            return i - this.zero;
        }
    }

    return -1;
};
/**
 * @see DataReader.readAndCheckSignature
 */
ArrayReader.prototype.readAndCheckSignature = function (sig) {
    var sig0 = sig.charCodeAt(0),
        sig1 = sig.charCodeAt(1),
        sig2 = sig.charCodeAt(2),
        sig3 = sig.charCodeAt(3),
        data = this.readData(4);
    return sig0 === data[0] && sig1 === data[1] && sig2 === data[2] && sig3 === data[3];
};
/**
 * @see DataReader.readData
 */
ArrayReader.prototype.readData = function(size) {
    this.checkOffset(size);
    if(size === 0) {
        return [];
    }
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = ArrayReader;

},{"../utils":165,"./DataReader":151}],151:[function(require,module,exports){
'use strict';
var utils = require('../utils');

function DataReader(data) {
    this.data = data; // type : see implementation
    this.length = data.length;
    this.index = 0;
    this.zero = 0;
}
DataReader.prototype = {
    /**
     * Check that the offset will not go too far.
     * @param {string} offset the additional offset to check.
     * @throws {Error} an Error if the offset is out of bounds.
     */
    checkOffset: function(offset) {
        this.checkIndex(this.index + offset);
    },
    /**
     * Check that the specified index will not be too far.
     * @param {string} newIndex the index to check.
     * @throws {Error} an Error if the index is out of bounds.
     */
    checkIndex: function(newIndex) {
        if (this.length < this.zero + newIndex || newIndex < 0) {
            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
        }
    },
    /**
     * Change the index.
     * @param {number} newIndex The new index.
     * @throws {Error} if the new index is out of the data.
     */
    setIndex: function(newIndex) {
        this.checkIndex(newIndex);
        this.index = newIndex;
    },
    /**
     * Skip the next n bytes.
     * @param {number} n the number of bytes to skip.
     * @throws {Error} if the new index is out of the data.
     */
    skip: function(n) {
        this.setIndex(this.index + n);
    },
    /**
     * Get the byte at the specified index.
     * @param {number} i the index to use.
     * @return {number} a byte.
     */
    byteAt: function(i) {
        // see implementations
    },
    /**
     * Get the next number with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {number} the corresponding number.
     */
    readInt: function(size) {
        var result = 0,
            i;
        this.checkOffset(size);
        for (i = this.index + size - 1; i >= this.index; i--) {
            result = (result << 8) + this.byteAt(i);
        }
        this.index += size;
        return result;
    },
    /**
     * Get the next string with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {string} the corresponding string.
     */
    readString: function(size) {
        return utils.transformTo("string", this.readData(size));
    },
    /**
     * Get raw data without conversion, <size> bytes.
     * @param {number} size the number of bytes to read.
     * @return {Object} the raw data, implementation specific.
     */
    readData: function(size) {
        // see implementations
    },
    /**
     * Find the last occurence of a zip signature (4 bytes).
     * @param {string} sig the signature to find.
     * @return {number} the index of the last occurence, -1 if not found.
     */
    lastIndexOfSignature: function(sig) {
        // see implementations
    },
    /**
     * Read the signature (4 bytes) at the current position and compare it with sig.
     * @param {string} sig the expected signature
     * @return {boolean} true if the signature matches, false otherwise.
     */
    readAndCheckSignature: function(sig) {
        // see implementations
    },
    /**
     * Get the next date.
     * @return {Date} the date.
     */
    readDate: function() {
        var dostime = this.readInt(4);
        return new Date(Date.UTC(
        ((dostime >> 25) & 0x7f) + 1980, // year
        ((dostime >> 21) & 0x0f) - 1, // month
        (dostime >> 16) & 0x1f, // day
        (dostime >> 11) & 0x1f, // hour
        (dostime >> 5) & 0x3f, // minute
        (dostime & 0x1f) << 1)); // second
    }
};
module.exports = DataReader;

},{"../utils":165}],152:[function(require,module,exports){
'use strict';
var Uint8ArrayReader = require('./Uint8ArrayReader');
var utils = require('../utils');

function NodeBufferReader(data) {
    Uint8ArrayReader.call(this, data);
}
utils.inherits(NodeBufferReader, Uint8ArrayReader);

/**
 * @see DataReader.readData
 */
NodeBufferReader.prototype.readData = function(size) {
    this.checkOffset(size);
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = NodeBufferReader;

},{"../utils":165,"./Uint8ArrayReader":154}],153:[function(require,module,exports){
'use strict';
var DataReader = require('./DataReader');
var utils = require('../utils');

function StringReader(data) {
    DataReader.call(this, data);
}
utils.inherits(StringReader, DataReader);
/**
 * @see DataReader.byteAt
 */
StringReader.prototype.byteAt = function(i) {
    return this.data.charCodeAt(this.zero + i);
};
/**
 * @see DataReader.lastIndexOfSignature
 */
StringReader.prototype.lastIndexOfSignature = function(sig) {
    return this.data.lastIndexOf(sig) - this.zero;
};
/**
 * @see DataReader.readAndCheckSignature
 */
StringReader.prototype.readAndCheckSignature = function (sig) {
    var data = this.readData(4);
    return sig === data;
};
/**
 * @see DataReader.readData
 */
StringReader.prototype.readData = function(size) {
    this.checkOffset(size);
    // this will work because the constructor applied the "& 0xff" mask.
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = StringReader;

},{"../utils":165,"./DataReader":151}],154:[function(require,module,exports){
'use strict';
var ArrayReader = require('./ArrayReader');
var utils = require('../utils');

function Uint8ArrayReader(data) {
    ArrayReader.call(this, data);
}
utils.inherits(Uint8ArrayReader, ArrayReader);
/**
 * @see DataReader.readData
 */
Uint8ArrayReader.prototype.readData = function(size) {
    this.checkOffset(size);
    if(size === 0) {
        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
        return new Uint8Array(0);
    }
    var result = this.data.subarray(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = Uint8ArrayReader;

},{"../utils":165,"./ArrayReader":150}],155:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var support = require('../support');
var ArrayReader = require('./ArrayReader');
var StringReader = require('./StringReader');
var NodeBufferReader = require('./NodeBufferReader');
var Uint8ArrayReader = require('./Uint8ArrayReader');

/**
 * Create a reader adapted to the data.
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data to read.
 * @return {DataReader} the data reader.
 */
module.exports = function (data) {
    var type = utils.getTypeOf(data);
    utils.checkSupport(type);
    if (type === "string" && !support.uint8array) {
        return new StringReader(data);
    }
    if (type === "nodebuffer") {
        return new NodeBufferReader(data);
    }
    if (support.uint8array) {
        return new Uint8ArrayReader(utils.transformTo("uint8array", data));
    }
    return new ArrayReader(utils.transformTo("array", data));
};

},{"../support":163,"../utils":165,"./ArrayReader":150,"./NodeBufferReader":152,"./StringReader":153,"./Uint8ArrayReader":154}],156:[function(require,module,exports){
'use strict';
exports.LOCAL_FILE_HEADER = "PK\x03\x04";
exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
exports.DATA_DESCRIPTOR = "PK\x07\x08";

},{}],157:[function(require,module,exports){
'use strict';

var GenericWorker = require('./GenericWorker');
var utils = require('../utils');

/**
 * A worker which convert chunks to a specified type.
 * @constructor
 * @param {String} destType the destination type.
 */
function ConvertWorker(destType) {
    GenericWorker.call(this, "ConvertWorker to " + destType);
    this.destType = destType;
}
utils.inherits(ConvertWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
ConvertWorker.prototype.processChunk = function (chunk) {
    this.push({
        data : utils.transformTo(this.destType, chunk.data),
        meta : chunk.meta
    });
};
module.exports = ConvertWorker;

},{"../utils":165,"./GenericWorker":161}],158:[function(require,module,exports){
'use strict';

var GenericWorker = require('./GenericWorker');
var crc32 = require('../crc32');
var utils = require('../utils');

/**
 * A worker which calculate the crc32 of the data flowing through.
 * @constructor
 */
function Crc32Probe() {
    GenericWorker.call(this, "Crc32Probe");
    this.withStreamInfo("crc32", 0);
}
utils.inherits(Crc32Probe, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Crc32Probe.prototype.processChunk = function (chunk) {
    this.streamInfo.crc32 = crc32(chunk.data, this.streamInfo.crc32 || 0);
    this.push(chunk);
};
module.exports = Crc32Probe;

},{"../crc32":137,"../utils":165,"./GenericWorker":161}],159:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var GenericWorker = require('./GenericWorker');

/**
 * A worker which calculate the total length of the data flowing through.
 * @constructor
 * @param {String} propName the name used to expose the length
 */
function DataLengthProbe(propName) {
    GenericWorker.call(this, "DataLengthProbe for " + propName);
    this.propName = propName;
    this.withStreamInfo(propName, 0);
}
utils.inherits(DataLengthProbe, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
DataLengthProbe.prototype.processChunk = function (chunk) {
    if(chunk) {
        var length = this.streamInfo[this.propName] || 0;
        this.streamInfo[this.propName] = length + chunk.data.length;
    }
    GenericWorker.prototype.processChunk.call(this, chunk);
};
module.exports = DataLengthProbe;


},{"../utils":165,"./GenericWorker":161}],160:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var GenericWorker = require('./GenericWorker');

// the size of the generated chunks
// TODO expose this as a public variable
var DEFAULT_BLOCK_SIZE = 16 * 1024;

/**
 * A worker that reads a content and emits chunks.
 * @constructor
 * @param {Promise} dataP the promise of the data to split
 */
function DataWorker(dataP) {
    GenericWorker.call(this, "DataWorker");
    var self = this;
    this.dataIsReady = false;
    this.index = 0;
    this.max = 0;
    this.data = null;
    this.type = "";

    this._tickScheduled = false;

    dataP.then(function (data) {
        self.dataIsReady = true;
        self.data = data;
        self.max = data && data.length || 0;
        self.type = utils.getTypeOf(data);
        if(!self.isPaused) {
            self._tickAndRepeat();
        }
    }, function (e) {
        self.error(e);
    });
}

utils.inherits(DataWorker, GenericWorker);

/**
 * @see GenericWorker.cleanUp
 */
DataWorker.prototype.cleanUp = function () {
    GenericWorker.prototype.cleanUp.call(this);
    this.data = null;
};

/**
 * @see GenericWorker.resume
 */
DataWorker.prototype.resume = function () {
    if(!GenericWorker.prototype.resume.call(this)) {
        return false;
    }

    if (!this._tickScheduled && this.dataIsReady) {
        this._tickScheduled = true;
        utils.delay(this._tickAndRepeat, [], this);
    }
    return true;
};

/**
 * Trigger a tick a schedule an other call to this function.
 */
DataWorker.prototype._tickAndRepeat = function() {
    this._tickScheduled = false;
    if(this.isPaused || this.isFinished) {
        return;
    }
    this._tick();
    if(!this.isFinished) {
        utils.delay(this._tickAndRepeat, [], this);
        this._tickScheduled = true;
    }
};

/**
 * Read and push a chunk.
 */
DataWorker.prototype._tick = function() {

    if(this.isPaused || this.isFinished) {
        return false;
    }

    var size = DEFAULT_BLOCK_SIZE;
    var data = null, nextIndex = Math.min(this.max, this.index + size);
    if (this.index >= this.max) {
        // EOF
        return this.end();
    } else {
        switch(this.type) {
            case "string":
                data = this.data.substring(this.index, nextIndex);
            break;
            case "uint8array":
                data = this.data.subarray(this.index, nextIndex);
            break;
            case "array":
            case "nodebuffer":
                data = this.data.slice(this.index, nextIndex);
            break;
        }
        this.index = nextIndex;
        return this.push({
            data : data,
            meta : {
                percent : this.max ? this.index / this.max * 100 : 0
            }
        });
    }
};

module.exports = DataWorker;

},{"../utils":165,"./GenericWorker":161}],161:[function(require,module,exports){
'use strict';

/**
 * A worker that does nothing but passing chunks to the next one. This is like
 * a nodejs stream but with some differences. On the good side :
 * - it works on IE 6-9 without any issue / polyfill
 * - it weights less than the full dependencies bundled with browserify
 * - it forwards errors (no need to declare an error handler EVERYWHERE)
 *
 * A chunk is an object with 2 attributes : `meta` and `data`. The former is an
 * object containing anything (`percent` for example), see each worker for more
 * details. The latter is the real data (String, Uint8Array, etc).
 *
 * @constructor
 * @param {String} name the name of the stream (mainly used for debugging purposes)
 */
function GenericWorker(name) {
    // the name of the worker
    this.name = name || "default";
    // an object containing metadata about the workers chain
    this.streamInfo = {};
    // an error which happened when the worker was paused
    this.generatedError = null;
    // an object containing metadata to be merged by this worker into the general metadata
    this.extraStreamInfo = {};
    // true if the stream is paused (and should not do anything), false otherwise
    this.isPaused = true;
    // true if the stream is finished (and should not do anything), false otherwise
    this.isFinished = false;
    // true if the stream is locked to prevent further structure updates (pipe), false otherwise
    this.isLocked = false;
    // the event listeners
    this._listeners = {
        'data':[],
        'end':[],
        'error':[]
    };
    // the previous worker, if any
    this.previous = null;
}

GenericWorker.prototype = {
    /**
     * Push a chunk to the next workers.
     * @param {Object} chunk the chunk to push
     */
    push : function (chunk) {
        this.emit("data", chunk);
    },
    /**
     * End the stream.
     * @return {Boolean} true if this call ended the worker, false otherwise.
     */
    end : function () {
        if (this.isFinished) {
            return false;
        }

        this.flush();
        try {
            this.emit("end");
            this.cleanUp();
            this.isFinished = true;
        } catch (e) {
            this.emit("error", e);
        }
        return true;
    },
    /**
     * End the stream with an error.
     * @param {Error} e the error which caused the premature end.
     * @return {Boolean} true if this call ended the worker with an error, false otherwise.
     */
    error : function (e) {
        if (this.isFinished) {
            return false;
        }

        if(this.isPaused) {
            this.generatedError = e;
        } else {
            this.isFinished = true;

            this.emit("error", e);

            // in the workers chain exploded in the middle of the chain,
            // the error event will go downward but we also need to notify
            // workers upward that there has been an error.
            if(this.previous) {
                this.previous.error(e);
            }

            this.cleanUp();
        }
        return true;
    },
    /**
     * Add a callback on an event.
     * @param {String} name the name of the event (data, end, error)
     * @param {Function} listener the function to call when the event is triggered
     * @return {GenericWorker} the current object for chainability
     */
    on : function (name, listener) {
        this._listeners[name].push(listener);
        return this;
    },
    /**
     * Clean any references when a worker is ending.
     */
    cleanUp : function () {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null;
        this._listeners = [];
    },
    /**
     * Trigger an event. This will call registered callback with the provided arg.
     * @param {String} name the name of the event (data, end, error)
     * @param {Object} arg the argument to call the callback with.
     */
    emit : function (name, arg) {
        if (this._listeners[name]) {
            for(var i = 0; i < this._listeners[name].length; i++) {
                this._listeners[name][i].call(this, arg);
            }
        }
    },
    /**
     * Chain a worker with an other.
     * @param {Worker} next the worker receiving events from the current one.
     * @return {worker} the next worker for chainability
     */
    pipe : function (next) {
        return next.registerPrevious(this);
    },
    /**
     * Same as `pipe` in the other direction.
     * Using an API with `pipe(next)` is very easy.
     * Implementing the API with the point of view of the next one registering
     * a source is easier, see the ZipFileWorker.
     * @param {Worker} previous the previous worker, sending events to this one
     * @return {Worker} the current worker for chainability
     */
    registerPrevious : function (previous) {
        if (this.isLocked) {
            throw new Error("The stream '" + this + "' has already been used.");
        }

        // sharing the streamInfo...
        this.streamInfo = previous.streamInfo;
        // ... and adding our own bits
        this.mergeStreamInfo();
        this.previous =  previous;
        var self = this;
        previous.on('data', function (chunk) {
            self.processChunk(chunk);
        });
        previous.on('end', function () {
            self.end();
        });
        previous.on('error', function (e) {
            self.error(e);
        });
        return this;
    },
    /**
     * Pause the stream so it doesn't send events anymore.
     * @return {Boolean} true if this call paused the worker, false otherwise.
     */
    pause : function () {
        if(this.isPaused || this.isFinished) {
            return false;
        }
        this.isPaused = true;

        if(this.previous) {
            this.previous.pause();
        }
        return true;
    },
    /**
     * Resume a paused stream.
     * @return {Boolean} true if this call resumed the worker, false otherwise.
     */
    resume : function () {
        if(!this.isPaused || this.isFinished) {
            return false;
        }
        this.isPaused = false;

        // if true, the worker tried to resume but failed
        var withError = false;
        if(this.generatedError) {
            this.error(this.generatedError);
            withError = true;
        }
        if(this.previous) {
            this.previous.resume();
        }

        return !withError;
    },
    /**
     * Flush any remaining bytes as the stream is ending.
     */
    flush : function () {},
    /**
     * Process a chunk. This is usually the method overridden.
     * @param {Object} chunk the chunk to process.
     */
    processChunk : function(chunk) {
        this.push(chunk);
    },
    /**
     * Add a key/value to be added in the workers chain streamInfo once activated.
     * @param {String} key the key to use
     * @param {Object} value the associated value
     * @return {Worker} the current worker for chainability
     */
    withStreamInfo : function (key, value) {
        this.extraStreamInfo[key] = value;
        this.mergeStreamInfo();
        return this;
    },
    /**
     * Merge this worker's streamInfo into the chain's streamInfo.
     */
    mergeStreamInfo : function () {
        for(var key in this.extraStreamInfo) {
            if (!this.extraStreamInfo.hasOwnProperty(key)) {
                continue;
            }
            this.streamInfo[key] = this.extraStreamInfo[key];
        }
    },

    /**
     * Lock the stream to prevent further updates on the workers chain.
     * After calling this method, all calls to pipe will fail.
     */
    lock: function () {
        if (this.isLocked) {
            throw new Error("The stream '" + this + "' has already been used.");
        }
        this.isLocked = true;
        if (this.previous) {
            this.previous.lock();
        }
    },

    /**
     *
     * Pretty print the workers chain.
     */
    toString : function () {
        var me = "Worker " + this.name;
        if (this.previous) {
            return this.previous + " -> " + me;
        } else {
            return me;
        }
    }
};

module.exports = GenericWorker;

},{}],162:[function(require,module,exports){
(function (Buffer){
'use strict';

var utils = require('../utils');
var ConvertWorker = require('./ConvertWorker');
var GenericWorker = require('./GenericWorker');
var base64 = require('../base64');
var support = require("../support");
var external = require("../external");

var NodejsStreamOutputAdapter = null;
if (support.nodestream) {
    try {
        NodejsStreamOutputAdapter = require('../nodejs/NodejsStreamOutputAdapter');
    } catch(e) {}
}

/**
 * Apply the final transformation of the data. If the user wants a Blob for
 * example, it's easier to work with an U8intArray and finally do the
 * ArrayBuffer/Blob conversion.
 * @param {String} type the name of the final type
 * @param {String|Uint8Array|Buffer} content the content to transform
 * @param {String} mimeType the mime type of the content, if applicable.
 * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the content in the right format.
 */
function transformZipOutput(type, content, mimeType) {
    switch(type) {
        case "blob" :
            return utils.newBlob(utils.transformTo("arraybuffer", content), mimeType);
        case "base64" :
            return base64.encode(content);
        default :
            return utils.transformTo(type, content);
    }
}

/**
 * Concatenate an array of data of the given type.
 * @param {String} type the type of the data in the given array.
 * @param {Array} dataArray the array containing the data chunks to concatenate
 * @return {String|Uint8Array|Buffer} the concatenated data
 * @throws Error if the asked type is unsupported
 */
function concat (type, dataArray) {
    var i, index = 0, res = null, totalLength = 0;
    for(i = 0; i < dataArray.length; i++) {
        totalLength += dataArray[i].length;
    }
    switch(type) {
        case "string":
            return dataArray.join("");
          case "array":
            return Array.prototype.concat.apply([], dataArray);
        case "uint8array":
            res = new Uint8Array(totalLength);
            for(i = 0; i < dataArray.length; i++) {
                res.set(dataArray[i], index);
                index += dataArray[i].length;
            }
            return res;
        case "nodebuffer":
            return Buffer.concat(dataArray);
        default:
            throw new Error("concat : unsupported type '"  + type + "'");
    }
}

/**
 * Listen a StreamHelper, accumulate its content and concatenate it into a
 * complete block.
 * @param {StreamHelper} helper the helper to use.
 * @param {Function} updateCallback a callback called on each update. Called
 * with one arg :
 * - the metadata linked to the update received.
 * @return Promise the promise for the accumulation.
 */
function accumulate(helper, updateCallback) {
    return new external.Promise(function (resolve, reject){
        var dataArray = [];
        var chunkType = helper._internalType,
            resultType = helper._outputType,
            mimeType = helper._mimeType;
        helper
        .on('data', function (data, meta) {
            dataArray.push(data);
            if(updateCallback) {
                updateCallback(meta);
            }
        })
        .on('error', function(err) {
            dataArray = [];
            reject(err);
        })
        .on('end', function (){
            try {
                var result = transformZipOutput(resultType, concat(chunkType, dataArray), mimeType);
                resolve(result);
            } catch (e) {
                reject(e);
            }
            dataArray = [];
        })
        .resume();
    });
}

/**
 * An helper to easily use workers outside of JSZip.
 * @constructor
 * @param {Worker} worker the worker to wrap
 * @param {String} outputType the type of data expected by the use
 * @param {String} mimeType the mime type of the content, if applicable.
 */
function StreamHelper(worker, outputType, mimeType) {
    var internalType = outputType;
    switch(outputType) {
        case "blob":
        case "arraybuffer":
            internalType = "uint8array";
        break;
        case "base64":
            internalType = "string";
        break;
    }

    try {
        // the type used internally
        this._internalType = internalType;
        // the type used to output results
        this._outputType = outputType;
        // the mime type
        this._mimeType = mimeType;
        utils.checkSupport(internalType);
        this._worker = worker.pipe(new ConvertWorker(internalType));
        // the last workers can be rewired without issues but we need to
        // prevent any updates on previous workers.
        worker.lock();
    } catch(e) {
        this._worker = new GenericWorker("error");
        this._worker.error(e);
    }
}

StreamHelper.prototype = {
    /**
     * Listen a StreamHelper, accumulate its content and concatenate it into a
     * complete block.
     * @param {Function} updateCb the update callback.
     * @return Promise the promise for the accumulation.
     */
    accumulate : function (updateCb) {
        return accumulate(this, updateCb);
    },
    /**
     * Add a listener on an event triggered on a stream.
     * @param {String} evt the name of the event
     * @param {Function} fn the listener
     * @return {StreamHelper} the current helper.
     */
    on : function (evt, fn) {
        var self = this;

        if(evt === "data") {
            this._worker.on(evt, function (chunk) {
                fn.call(self, chunk.data, chunk.meta);
            });
        } else {
            this._worker.on(evt, function () {
                utils.delay(fn, arguments, self);
            });
        }
        return this;
    },
    /**
     * Resume the flow of chunks.
     * @return {StreamHelper} the current helper.
     */
    resume : function () {
        utils.delay(this._worker.resume, [], this._worker);
        return this;
    },
    /**
     * Pause the flow of chunks.
     * @return {StreamHelper} the current helper.
     */
    pause : function () {
        this._worker.pause();
        return this;
    },
    /**
     * Return a nodejs stream for this helper.
     * @param {Function} updateCb the update callback.
     * @return {NodejsStreamOutputAdapter} the nodejs stream.
     */
    toNodejsStream : function (updateCb) {
        utils.checkSupport("nodestream");
        if (this._outputType !== "nodebuffer") {
            // an object stream containing blob/arraybuffer/uint8array/string
            // is strange and I don't know if it would be useful.
            // I you find this comment and have a good usecase, please open a
            // bug report !
            throw new Error(this._outputType + " is not supported by this method");
        }

        return new NodejsStreamOutputAdapter(this, {
            objectMode : this._outputType !== "nodebuffer"
        }, updateCb);
    }
};


module.exports = StreamHelper;

}).call(this,require("buffer").Buffer)

},{"../base64":134,"../external":139,"../nodejs/NodejsStreamOutputAdapter":146,"../support":163,"../utils":165,"./ConvertWorker":157,"./GenericWorker":161,"buffer":77}],163:[function(require,module,exports){
(function (Buffer){
'use strict';

exports.base64 = true;
exports.array = true;
exports.string = true;
exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
exports.nodebuffer = typeof Buffer !== "undefined";
// contains true if JSZip can read/generate Uint8Array, false otherwise.
exports.uint8array = typeof Uint8Array !== "undefined";

if (typeof ArrayBuffer === "undefined") {
    exports.blob = false;
}
else {
    var buffer = new ArrayBuffer(0);
    try {
        exports.blob = new Blob([buffer], {
            type: "application/zip"
        }).size === 0;
    }
    catch (e) {
        try {
            var Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
            var builder = new Builder();
            builder.append(buffer);
            exports.blob = builder.getBlob('application/zip').size === 0;
        }
        catch (e) {
            exports.blob = false;
        }
    }
}

try {
    exports.nodestream = !!require('readable-stream').Readable;
} catch(e) {
    exports.nodestream = false;
}

}).call(this,require("buffer").Buffer)

},{"buffer":77,"readable-stream":149}],164:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var support = require('./support');
var nodejsUtils = require('./nodejsUtils');
var GenericWorker = require('./stream/GenericWorker');

/**
 * The following functions come from pako, from pako/lib/utils/strings
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */

// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new Array(256);
for (var i=0; i<256; i++) {
  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
}
_utf8len[254]=_utf8len[254]=1; // Invalid sequence start

// convert string to array (typed, when possible)
var string2buf = function (str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

    // count binary size
    for (m_pos = 0; m_pos < str_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }

    // allocate buffer
    if (support.uint8array) {
        buf = new Uint8Array(buf_len);
    } else {
        buf = new Array(buf_len);
    }

    // convert
    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) {
            /* one byte */
            buf[i++] = c;
        } else if (c < 0x800) {
            /* two bytes */
            buf[i++] = 0xC0 | (c >>> 6);
            buf[i++] = 0x80 | (c & 0x3f);
        } else if (c < 0x10000) {
            /* three bytes */
            buf[i++] = 0xE0 | (c >>> 12);
            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        } else {
            /* four bytes */
            buf[i++] = 0xf0 | (c >>> 18);
            buf[i++] = 0x80 | (c >>> 12 & 0x3f);
            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        }
    }

    return buf;
};

// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var utf8border = function(buf, max) {
    var pos;

    max = max || buf.length;
    if (max > buf.length) { max = buf.length; }

    // go back from last position, until start of sequence found
    pos = max-1;
    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

    // Fuckup - very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) { return max; }

    // If we came to start of buffer - that means vuffer is too small,
    // return max too.
    if (pos === 0) { return max; }

    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

// convert array to string
var buf2string = function (buf) {
    var str, i, out, c, c_len;
    var len = buf.length;

    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len*2);

    for (out=0, i=0; i<len;) {
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) { utf16buf[out++] = c; continue; }

        c_len = _utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }

        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while (c_len > 1 && i < len) {
            c = (c << 6) | (buf[i++] & 0x3f);
            c_len--;
        }

        // terminated by end of string?
        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

        if (c < 0x10000) {
            utf16buf[out++] = c;
        } else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
        }
    }

    // shrinkBuf(utf16buf, out)
    if (utf16buf.length !== out) {
        if(utf16buf.subarray) {
            utf16buf = utf16buf.subarray(0, out);
        } else {
            utf16buf.length = out;
        }
    }

    // return String.fromCharCode.apply(null, utf16buf);
    return utils.applyFromCharCode(utf16buf);
};


// That's all for the pako functions.


/**
 * Transform a javascript string into an array (typed if possible) of bytes,
 * UTF-8 encoded.
 * @param {String} str the string to encode
 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
 */
exports.utf8encode = function utf8encode(str) {
    if (support.nodebuffer) {
        return nodejsUtils.newBufferFrom(str, "utf-8");
    }

    return string2buf(str);
};


/**
 * Transform a bytes array (or a representation) representing an UTF-8 encoded
 * string into a javascript string.
 * @param {Array|Uint8Array|Buffer} buf the data de decode
 * @return {String} the decoded string.
 */
exports.utf8decode = function utf8decode(buf) {
    if (support.nodebuffer) {
        return utils.transformTo("nodebuffer", buf).toString("utf-8");
    }

    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);

    return buf2string(buf);
};

/**
 * A worker to decode utf8 encoded binary chunks into string chunks.
 * @constructor
 */
function Utf8DecodeWorker() {
    GenericWorker.call(this, "utf-8 decode");
    // the last bytes if a chunk didn't end with a complete codepoint.
    this.leftOver = null;
}
utils.inherits(Utf8DecodeWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Utf8DecodeWorker.prototype.processChunk = function (chunk) {

    var data = utils.transformTo(support.uint8array ? "uint8array" : "array", chunk.data);

    // 1st step, re-use what's left of the previous chunk
    if (this.leftOver && this.leftOver.length) {
        if(support.uint8array) {
            var previousData = data;
            data = new Uint8Array(previousData.length + this.leftOver.length);
            data.set(this.leftOver, 0);
            data.set(previousData, this.leftOver.length);
        } else {
            data = this.leftOver.concat(data);
        }
        this.leftOver = null;
    }

    var nextBoundary = utf8border(data);
    var usableData = data;
    if (nextBoundary !== data.length) {
        if (support.uint8array) {
            usableData = data.subarray(0, nextBoundary);
            this.leftOver = data.subarray(nextBoundary, data.length);
        } else {
            usableData = data.slice(0, nextBoundary);
            this.leftOver = data.slice(nextBoundary, data.length);
        }
    }

    this.push({
        data : exports.utf8decode(usableData),
        meta : chunk.meta
    });
};

/**
 * @see GenericWorker.flush
 */
Utf8DecodeWorker.prototype.flush = function () {
    if(this.leftOver && this.leftOver.length) {
        this.push({
            data : exports.utf8decode(this.leftOver),
            meta : {}
        });
        this.leftOver = null;
    }
};
exports.Utf8DecodeWorker = Utf8DecodeWorker;

/**
 * A worker to endcode string chunks into utf8 encoded binary chunks.
 * @constructor
 */
function Utf8EncodeWorker() {
    GenericWorker.call(this, "utf-8 encode");
}
utils.inherits(Utf8EncodeWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Utf8EncodeWorker.prototype.processChunk = function (chunk) {
    this.push({
        data : exports.utf8encode(chunk.data),
        meta : chunk.meta
    });
};
exports.Utf8EncodeWorker = Utf8EncodeWorker;

},{"./nodejsUtils":147,"./stream/GenericWorker":161,"./support":163,"./utils":165}],165:[function(require,module,exports){
'use strict';

var support = require('./support');
var base64 = require('./base64');
var nodejsUtils = require('./nodejsUtils');
var setImmediate = require('set-immediate-shim');
var external = require("./external");


/**
 * Convert a string that pass as a "binary string": it should represent a byte
 * array but may have > 255 char codes. Be sure to take only the first byte
 * and returns the byte array.
 * @param {String} str the string to transform.
 * @return {Array|Uint8Array} the string in a binary format.
 */
function string2binary(str) {
    var result = null;
    if (support.uint8array) {
      result = new Uint8Array(str.length);
    } else {
      result = new Array(str.length);
    }
    return stringToArrayLike(str, result);
}

/**
 * Create a new blob with the given content and the given type.
 * @param {String|ArrayBuffer} part the content to put in the blob. DO NOT use
 * an Uint8Array because the stock browser of android 4 won't accept it (it
 * will be silently converted to a string, "[object Uint8Array]").
 *
 * Use only ONE part to build the blob to avoid a memory leak in IE11 / Edge:
 * when a large amount of Array is used to create the Blob, the amount of
 * memory consumed is nearly 100 times the original data amount.
 *
 * @param {String} type the mime type of the blob.
 * @return {Blob} the created blob.
 */
exports.newBlob = function(part, type) {
    exports.checkSupport("blob");

    try {
        // Blob constructor
        return new Blob([part], {
            type: type
        });
    }
    catch (e) {

        try {
            // deprecated, browser only, old way
            var Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
            var builder = new Builder();
            builder.append(part);
            return builder.getBlob(type);
        }
        catch (e) {

            // well, fuck ?!
            throw new Error("Bug : can't construct the Blob.");
        }
    }


};
/**
 * The identity function.
 * @param {Object} input the input.
 * @return {Object} the same input.
 */
function identity(input) {
    return input;
}

/**
 * Fill in an array with a string.
 * @param {String} str the string to use.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
 */
function stringToArrayLike(str, array) {
    for (var i = 0; i < str.length; ++i) {
        array[i] = str.charCodeAt(i) & 0xFF;
    }
    return array;
}

/**
 * An helper for the function arrayLikeToString.
 * This contains static informations and functions that
 * can be optimized by the browser JIT compiler.
 */
var arrayToStringHelper = {
    /**
     * Transform an array of int into a string, chunk by chunk.
     * See the performances notes on arrayLikeToString.
     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
     * @param {String} type the type of the array.
     * @param {Integer} chunk the chunk size.
     * @return {String} the resulting string.
     * @throws Error if the chunk is too big for the stack.
     */
    stringifyByChunk: function(array, type, chunk) {
        var result = [], k = 0, len = array.length;
        // shortcut
        if (len <= chunk) {
            return String.fromCharCode.apply(null, array);
        }
        while (k < len) {
            if (type === "array" || type === "nodebuffer") {
                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
            }
            else {
                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
            }
            k += chunk;
        }
        return result.join("");
    },
    /**
     * Call String.fromCharCode on every item in the array.
     * This is the naive implementation, which generate A LOT of intermediate string.
     * This should be used when everything else fail.
     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
     * @return {String} the result.
     */
    stringifyByChar: function(array){
        var resultStr = "";
        for(var i = 0; i < array.length; i++) {
            resultStr += String.fromCharCode(array[i]);
        }
        return resultStr;
    },
    applyCanBeUsed : {
        /**
         * true if the browser accepts to use String.fromCharCode on Uint8Array
         */
        uint8array : (function () {
            try {
                return support.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
            } catch (e) {
                return false;
            }
        })(),
        /**
         * true if the browser accepts to use String.fromCharCode on nodejs Buffer.
         */
        nodebuffer : (function () {
            try {
                return support.nodebuffer && String.fromCharCode.apply(null, nodejsUtils.allocBuffer(1)).length === 1;
            } catch (e) {
                return false;
            }
        })()
    }
};

/**
 * Transform an array-like object to a string.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
 * @return {String} the result.
 */
function arrayLikeToString(array) {
    // Performances notes :
    // --------------------
    // String.fromCharCode.apply(null, array) is the fastest, see
    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
    // but the stack is limited (and we can get huge arrays !).
    //
    // result += String.fromCharCode(array[i]); generate too many strings !
    //
    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
    // TODO : we now have workers that split the work. Do we still need that ?
    var chunk = 65536,
        type = exports.getTypeOf(array),
        canUseApply = true;
    if (type === "uint8array") {
        canUseApply = arrayToStringHelper.applyCanBeUsed.uint8array;
    } else if (type === "nodebuffer") {
        canUseApply = arrayToStringHelper.applyCanBeUsed.nodebuffer;
    }

    if (canUseApply) {
        while (chunk > 1) {
            try {
                return arrayToStringHelper.stringifyByChunk(array, type, chunk);
            } catch (e) {
                chunk = Math.floor(chunk / 2);
            }
        }
    }

    // no apply or chunk error : slow and painful algorithm
    // default browser on android 4.*
    return arrayToStringHelper.stringifyByChar(array);
}

exports.applyFromCharCode = arrayLikeToString;


/**
 * Copy the data from an array-like to an other array-like.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
 */
function arrayLikeToArrayLike(arrayFrom, arrayTo) {
    for (var i = 0; i < arrayFrom.length; i++) {
        arrayTo[i] = arrayFrom[i];
    }
    return arrayTo;
}

// a matrix containing functions to transform everything into everything.
var transform = {};

// string to ?
transform["string"] = {
    "string": identity,
    "array": function(input) {
        return stringToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["string"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return stringToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": function(input) {
        return stringToArrayLike(input, nodejsUtils.allocBuffer(input.length));
    }
};

// array to ?
transform["array"] = {
    "string": arrayLikeToString,
    "array": identity,
    "arraybuffer": function(input) {
        return (new Uint8Array(input)).buffer;
    },
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodejsUtils.newBufferFrom(input);
    }
};

// arraybuffer to ?
transform["arraybuffer"] = {
    "string": function(input) {
        return arrayLikeToString(new Uint8Array(input));
    },
    "array": function(input) {
        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
    },
    "arraybuffer": identity,
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodejsUtils.newBufferFrom(new Uint8Array(input));
    }
};

// uint8array to ?
transform["uint8array"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return input.buffer;
    },
    "uint8array": identity,
    "nodebuffer": function(input) {
        return nodejsUtils.newBufferFrom(input);
    }
};

// nodebuffer to ?
transform["nodebuffer"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["nodebuffer"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": identity
};

/**
 * Transform an input into any type.
 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
 * If no output type is specified, the unmodified input will be returned.
 * @param {String} outputType the output type.
 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
 * @throws {Error} an Error if the browser doesn't support the requested output type.
 */
exports.transformTo = function(outputType, input) {
    if (!input) {
        // undefined, null, etc
        // an empty string won't harm.
        input = "";
    }
    if (!outputType) {
        return input;
    }
    exports.checkSupport(outputType);
    var inputType = exports.getTypeOf(input);
    var result = transform[inputType][outputType](input);
    return result;
};

/**
 * Return the type of the input.
 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
 * @param {Object} input the input to identify.
 * @return {String} the (lowercase) type of the input.
 */
exports.getTypeOf = function(input) {
    if (typeof input === "string") {
        return "string";
    }
    if (Object.prototype.toString.call(input) === "[object Array]") {
        return "array";
    }
    if (support.nodebuffer && nodejsUtils.isBuffer(input)) {
        return "nodebuffer";
    }
    if (support.uint8array && input instanceof Uint8Array) {
        return "uint8array";
    }
    if (support.arraybuffer && input instanceof ArrayBuffer) {
        return "arraybuffer";
    }
};

/**
 * Throw an exception if the type is not supported.
 * @param {String} type the type to check.
 * @throws {Error} an Error if the browser doesn't support the requested type.
 */
exports.checkSupport = function(type) {
    var supported = support[type.toLowerCase()];
    if (!supported) {
        throw new Error(type + " is not supported by this platform");
    }
};

exports.MAX_VALUE_16BITS = 65535;
exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1

/**
 * Prettify a string read as binary.
 * @param {string} str the string to prettify.
 * @return {string} a pretty string.
 */
exports.pretty = function(str) {
    var res = '',
        code, i;
    for (i = 0; i < (str || "").length; i++) {
        code = str.charCodeAt(i);
        res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
    }
    return res;
};

/**
 * Defer the call of a function.
 * @param {Function} callback the function to call asynchronously.
 * @param {Array} args the arguments to give to the callback.
 */
exports.delay = function(callback, args, self) {
    setImmediate(function () {
        callback.apply(self || null, args || []);
    });
};

/**
 * Extends a prototype with an other, without calling a constructor with
 * side effects. Inspired by nodejs' `utils.inherits`
 * @param {Function} ctor the constructor to augment
 * @param {Function} superCtor the parent constructor to use
 */
exports.inherits = function (ctor, superCtor) {
    var Obj = function() {};
    Obj.prototype = superCtor.prototype;
    ctor.prototype = new Obj();
};

/**
 * Merge the objects passed as parameters into a new one.
 * @private
 * @param {...Object} var_args All objects to merge.
 * @return {Object} a new object with the data of the others.
 */
exports.extend = function() {
    var result = {}, i, attr;
    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
        for (attr in arguments[i]) {
            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
                result[attr] = arguments[i][attr];
            }
        }
    }
    return result;
};

/**
 * Transform arbitrary content into a Promise.
 * @param {String} name a name for the content being processed.
 * @param {Object} inputData the content to process.
 * @param {Boolean} isBinary true if the content is not an unicode string
 * @param {Boolean} isOptimizedBinaryString true if the string content only has one byte per character.
 * @param {Boolean} isBase64 true if the string content is encoded with base64.
 * @return {Promise} a promise in a format usable by JSZip.
 */
exports.prepareContent = function(name, inputData, isBinary, isOptimizedBinaryString, isBase64) {

    // if inputData is already a promise, this flatten it.
    var promise = external.Promise.resolve(inputData).then(function(data) {
        
        
        var isBlob = support.blob && (data instanceof Blob || ['[object File]', '[object Blob]'].indexOf(Object.prototype.toString.call(data)) !== -1);

        if (isBlob && typeof FileReader !== "undefined") {
            return new external.Promise(function (resolve, reject) {
                var reader = new FileReader();

                reader.onload = function(e) {
                    resolve(e.target.result);
                };
                reader.onerror = function(e) {
                    reject(e.target.error);
                };
                reader.readAsArrayBuffer(data);
            });
        } else {
            return data;
        }
    });

    return promise.then(function(data) {
        var dataType = exports.getTypeOf(data);

        if (!dataType) {
            return external.Promise.reject(
                new Error("Can't read the data of '" + name + "'. Is it " +
                          "in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?")
            );
        }
        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
        if (dataType === "arraybuffer") {
            data = exports.transformTo("uint8array", data);
        } else if (dataType === "string") {
            if (isBase64) {
                data = base64.decode(data);
            }
            else if (isBinary) {
                // optimizedBinaryString === true means that the file has already been filtered with a 0xFF mask
                if (isOptimizedBinaryString !== true) {
                    // this is a string, not in a base64 format.
                    // Be sure that this is a correct "binary string"
                    data = string2binary(data);
                }
            }
        }
        return data;
    });
};

},{"./base64":134,"./external":139,"./nodejsUtils":147,"./support":163,"set-immediate-shim":227}],166:[function(require,module,exports){
'use strict';
var readerFor = require('./reader/readerFor');
var utils = require('./utils');
var sig = require('./signature');
var ZipEntry = require('./zipEntry');
var utf8 = require('./utf8');
var support = require('./support');
//  class ZipEntries {{{
/**
 * All the entries in the zip file.
 * @constructor
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntries(loadOptions) {
    this.files = [];
    this.loadOptions = loadOptions;
}
ZipEntries.prototype = {
    /**
     * Check that the reader is on the specified signature.
     * @param {string} expectedSignature the expected signature.
     * @throws {Error} if it is an other signature.
     */
    checkSignature: function(expectedSignature) {
        if (!this.reader.readAndCheckSignature(expectedSignature)) {
            this.reader.index -= 4;
            var signature = this.reader.readString(4);
            throw new Error("Corrupted zip or bug: unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
        }
    },
    /**
     * Check if the given signature is at the given index.
     * @param {number} askedIndex the index to check.
     * @param {string} expectedSignature the signature to expect.
     * @return {boolean} true if the signature is here, false otherwise.
     */
    isSignature: function(askedIndex, expectedSignature) {
        var currentIndex = this.reader.index;
        this.reader.setIndex(askedIndex);
        var signature = this.reader.readString(4);
        var result = signature === expectedSignature;
        this.reader.setIndex(currentIndex);
        return result;
    },
    /**
     * Read the end of the central directory.
     */
    readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2);
        this.diskWithCentralDirStart = this.reader.readInt(2);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
        this.centralDirRecords = this.reader.readInt(2);
        this.centralDirSize = this.reader.readInt(4);
        this.centralDirOffset = this.reader.readInt(4);

        this.zipCommentLength = this.reader.readInt(2);
        // warning : the encoding depends of the system locale
        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
        // On a windows machine, this field is encoded with the localized windows code page.
        var zipComment = this.reader.readData(this.zipCommentLength);
        var decodeParamType = support.uint8array ? "uint8array" : "array";
        // To get consistent behavior with the generation part, we will assume that
        // this is utf8 encoded unless specified otherwise.
        var decodeContent = utils.transformTo(decodeParamType, zipComment);
        this.zipComment = this.loadOptions.decodeFileName(decodeContent);
    },
    /**
     * Read the end of the Zip 64 central directory.
     * Not merged with the method readEndOfCentral :
     * The end of central can coexist with its Zip64 brother,
     * I don't want to read the wrong number of bytes !
     */
    readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8);
        this.reader.skip(4);
        // this.versionMadeBy = this.reader.readString(2);
        // this.versionNeeded = this.reader.readInt(2);
        this.diskNumber = this.reader.readInt(4);
        this.diskWithCentralDirStart = this.reader.readInt(4);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
        this.centralDirRecords = this.reader.readInt(8);
        this.centralDirSize = this.reader.readInt(8);
        this.centralDirOffset = this.reader.readInt(8);

        this.zip64ExtensibleData = {};
        var extraDataSize = this.zip64EndOfCentralSize - 44,
            index = 0,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;
        while (index < extraDataSize) {
            extraFieldId = this.reader.readInt(2);
            extraFieldLength = this.reader.readInt(4);
            extraFieldValue = this.reader.readData(extraFieldLength);
            this.zip64ExtensibleData[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Read the end of the Zip 64 central directory locator.
     */
    readBlockZip64EndOfCentralLocator: function() {
        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
        this.disksCount = this.reader.readInt(4);
        if (this.disksCount > 1) {
            throw new Error("Multi-volumes zip are not supported");
        }
    },
    /**
     * Read the local files, based on the offset read in the central part.
     */
    readLocalFiles: function() {
        var i, file;
        for (i = 0; i < this.files.length; i++) {
            file = this.files[i];
            this.reader.setIndex(file.localHeaderOffset);
            this.checkSignature(sig.LOCAL_FILE_HEADER);
            file.readLocalPart(this.reader);
            file.handleUTF8();
            file.processAttributes();
        }
    },
    /**
     * Read the central directory.
     */
    readCentralDir: function() {
        var file;

        this.reader.setIndex(this.centralDirOffset);
        while (this.reader.readAndCheckSignature(sig.CENTRAL_FILE_HEADER)) {
            file = new ZipEntry({
                zip64: this.zip64
            }, this.loadOptions);
            file.readCentralPart(this.reader);
            this.files.push(file);
        }

        if (this.centralDirRecords !== this.files.length) {
            if (this.centralDirRecords !== 0 && this.files.length === 0) {
                // We expected some records but couldn't find ANY.
                // This is really suspicious, as if something went wrong.
                throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
            } else {
                // We found some records but not all.
                // Something is wrong but we got something for the user: no error here.
                // console.warn("expected", this.centralDirRecords, "records in central dir, got", this.files.length);
            }
        }
    },
    /**
     * Read the end of central directory.
     */
    readEndOfCentral: function() {
        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
        if (offset < 0) {
            // Check if the content is a truncated zip or complete garbage.
            // A "LOCAL_FILE_HEADER" is not required at the beginning (auto
            // extractible zip for example) but it can give a good hint.
            // If an ajax request was used without responseType, we will also
            // get unreadable data.
            var isGarbage = !this.isSignature(0, sig.LOCAL_FILE_HEADER);

            if (isGarbage) {
                throw new Error("Can't find end of central directory : is this a zip file ? " +
                                "If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
            } else {
                throw new Error("Corrupted zip: can't find end of central directory");
            }

        }
        this.reader.setIndex(offset);
        var endOfCentralDirOffset = offset;
        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
        this.readBlockEndOfCentral();


        /* extract from the zip spec :
            4)  If one of the fields in the end of central directory
                record is too small to hold required data, the field
                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
                ZIP64 format record should be created.
            5)  The end of central directory record and the
                Zip64 end of central directory locator record must
                reside on the same disk when splitting or spanning
                an archive.
         */
        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
            this.zip64 = true;

            /*
            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
            the zip file can fit into a 32bits integer. This cannot be solved : JavaScript represents
            all numbers as 64-bit double precision IEEE 754 floating point numbers.
            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
            */

            // should look for a zip64 EOCD locator
            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            if (offset < 0) {
                throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
            }
            this.reader.setIndex(offset);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            this.readBlockZip64EndOfCentralLocator();

            // now the zip64 EOCD record
            if (!this.isSignature(this.relativeOffsetEndOfZip64CentralDir, sig.ZIP64_CENTRAL_DIRECTORY_END)) {
                // console.warn("ZIP64 end of central directory not where expected.");
                this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
                if (this.relativeOffsetEndOfZip64CentralDir < 0) {
                    throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                }
            }
            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
            this.readBlockZip64EndOfCentral();
        }

        var expectedEndOfCentralDirOffset = this.centralDirOffset + this.centralDirSize;
        if (this.zip64) {
            expectedEndOfCentralDirOffset += 20; // end of central dir 64 locator
            expectedEndOfCentralDirOffset += 12 /* should not include the leading 12 bytes */ + this.zip64EndOfCentralSize;
        }

        var extraBytes = endOfCentralDirOffset - expectedEndOfCentralDirOffset;

        if (extraBytes > 0) {
            // console.warn(extraBytes, "extra bytes at beginning or within zipfile");
            if (this.isSignature(endOfCentralDirOffset, sig.CENTRAL_FILE_HEADER)) {
                // The offsets seem wrong, but we have something at the specified offset.
                // So… we keep it.
            } else {
                // the offset is wrong, update the "zero" of the reader
                // this happens if data has been prepended (crx files for example)
                this.reader.zero = extraBytes;
            }
        } else if (extraBytes < 0) {
            throw new Error("Corrupted zip: missing " + Math.abs(extraBytes) + " bytes.");
        }
    },
    prepareReader: function(data) {
        this.reader = readerFor(data);
    },
    /**
     * Read a zip file and create ZipEntries.
     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
     */
    load: function(data) {
        this.prepareReader(data);
        this.readEndOfCentral();
        this.readCentralDir();
        this.readLocalFiles();
    }
};
// }}} end of ZipEntries
module.exports = ZipEntries;

},{"./reader/readerFor":155,"./signature":156,"./support":163,"./utf8":164,"./utils":165,"./zipEntry":167}],167:[function(require,module,exports){
'use strict';
var readerFor = require('./reader/readerFor');
var utils = require('./utils');
var CompressedObject = require('./compressedObject');
var crc32fn = require('./crc32');
var utf8 = require('./utf8');
var compressions = require('./compressions');
var support = require('./support');

var MADE_BY_DOS = 0x00;
var MADE_BY_UNIX = 0x03;

/**
 * Find a compression registered in JSZip.
 * @param {string} compressionMethod the method magic to find.
 * @return {Object|null} the JSZip compression object, null if none found.
 */
var findCompression = function(compressionMethod) {
    for (var method in compressions) {
        if (!compressions.hasOwnProperty(method)) {
            continue;
        }
        if (compressions[method].magic === compressionMethod) {
            return compressions[method];
        }
    }
    return null;
};

// class ZipEntry {{{
/**
 * An entry in the zip file.
 * @constructor
 * @param {Object} options Options of the current file.
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntry(options, loadOptions) {
    this.options = options;
    this.loadOptions = loadOptions;
}
ZipEntry.prototype = {
    /**
     * say if the file is encrypted.
     * @return {boolean} true if the file is encrypted, false otherwise.
     */
    isEncrypted: function() {
        // bit 1 is set
        return (this.bitFlag & 0x0001) === 0x0001;
    },
    /**
     * say if the file has utf-8 filename/comment.
     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
     */
    useUTF8: function() {
        // bit 11 is set
        return (this.bitFlag & 0x0800) === 0x0800;
    },
    /**
     * Read the local part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readLocalPart: function(reader) {
        var compression, localExtraFieldsLength;

        // we already know everything from the central dir !
        // If the central dir data are false, we are doomed.
        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
        // The less data we get here, the more reliable this should be.
        // Let's skip the whole header and dash to the data !
        reader.skip(22);
        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
        // Strangely, the filename here is OK.
        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
        // the internet.
        //
        // I think I see the logic here : the central directory is used to display
        // content and the local directory is used to extract the files. Mixing / and \
        // may be used to display \ to windows users and use / when extracting the files.
        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
        this.fileNameLength = reader.readInt(2);
        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
        // the fileName is stored as binary data, the handleUTF8 method will take care of the encoding.
        this.fileName = reader.readData(this.fileNameLength);
        reader.skip(localExtraFieldsLength);

        if (this.compressedSize === -1 || this.uncompressedSize === -1) {
            throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory " + "(compressedSize === -1 || uncompressedSize === -1)");
        }

        compression = findCompression(this.compressionMethod);
        if (compression === null) { // no compression found
            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + utils.transformTo("string", this.fileName) + ")");
        }
        this.decompressed = new CompressedObject(this.compressedSize, this.uncompressedSize, this.crc32, compression, reader.readData(this.compressedSize));
    },

    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readCentralPart: function(reader) {
        this.versionMadeBy = reader.readInt(2);
        reader.skip(2);
        // this.versionNeeded = reader.readInt(2);
        this.bitFlag = reader.readInt(2);
        this.compressionMethod = reader.readString(2);
        this.date = reader.readDate();
        this.crc32 = reader.readInt(4);
        this.compressedSize = reader.readInt(4);
        this.uncompressedSize = reader.readInt(4);
        var fileNameLength = reader.readInt(2);
        this.extraFieldsLength = reader.readInt(2);
        this.fileCommentLength = reader.readInt(2);
        this.diskNumberStart = reader.readInt(2);
        this.internalFileAttributes = reader.readInt(2);
        this.externalFileAttributes = reader.readInt(4);
        this.localHeaderOffset = reader.readInt(4);

        if (this.isEncrypted()) {
            throw new Error("Encrypted zip are not supported");
        }

        // will be read in the local part, see the comments there
        reader.skip(fileNameLength);
        this.readExtraFields(reader);
        this.parseZIP64ExtraField(reader);
        this.fileComment = reader.readData(this.fileCommentLength);
    },

    /**
     * Parse the external file attributes and get the unix/dos permissions.
     */
    processAttributes: function () {
        this.unixPermissions = null;
        this.dosPermissions = null;
        var madeBy = this.versionMadeBy >> 8;

        // Check if we have the DOS directory flag set.
        // We look for it in the DOS and UNIX permissions
        // but some unknown platform could set it as a compatibility flag.
        this.dir = this.externalFileAttributes & 0x0010 ? true : false;

        if(madeBy === MADE_BY_DOS) {
            // first 6 bits (0 to 5)
            this.dosPermissions = this.externalFileAttributes & 0x3F;
        }

        if(madeBy === MADE_BY_UNIX) {
            this.unixPermissions = (this.externalFileAttributes >> 16) & 0xFFFF;
            // the octal permissions are in (this.unixPermissions & 0x01FF).toString(8);
        }

        // fail safe : if the name ends with a / it probably means a folder
        if (!this.dir && this.fileNameStr.slice(-1) === '/') {
            this.dir = true;
        }
    },

    /**
     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
     * @param {DataReader} reader the reader to use.
     */
    parseZIP64ExtraField: function(reader) {

        if (!this.extraFields[0x0001]) {
            return;
        }

        // should be something, preparing the extra reader
        var extraReader = readerFor(this.extraFields[0x0001].value);

        // I really hope that these 64bits integer can fit in 32 bits integer, because js
        // won't let us have more.
        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
            this.uncompressedSize = extraReader.readInt(8);
        }
        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
            this.compressedSize = extraReader.readInt(8);
        }
        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
            this.localHeaderOffset = extraReader.readInt(8);
        }
        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
            this.diskNumberStart = extraReader.readInt(4);
        }
    },
    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readExtraFields: function(reader) {
        var end = reader.index + this.extraFieldsLength,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;

        if (!this.extraFields) {
            this.extraFields = {};
        }

        while (reader.index < end) {
            extraFieldId = reader.readInt(2);
            extraFieldLength = reader.readInt(2);
            extraFieldValue = reader.readData(extraFieldLength);

            this.extraFields[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Apply an UTF8 transformation if needed.
     */
    handleUTF8: function() {
        var decodeParamType = support.uint8array ? "uint8array" : "array";
        if (this.useUTF8()) {
            this.fileNameStr = utf8.utf8decode(this.fileName);
            this.fileCommentStr = utf8.utf8decode(this.fileComment);
        } else {
            var upath = this.findExtraFieldUnicodePath();
            if (upath !== null) {
                this.fileNameStr = upath;
            } else {
                // ASCII text or unsupported code page
                var fileNameByteArray =  utils.transformTo(decodeParamType, this.fileName);
                this.fileNameStr = this.loadOptions.decodeFileName(fileNameByteArray);
            }

            var ucomment = this.findExtraFieldUnicodeComment();
            if (ucomment !== null) {
                this.fileCommentStr = ucomment;
            } else {
                // ASCII text or unsupported code page
                var commentByteArray =  utils.transformTo(decodeParamType, this.fileComment);
                this.fileCommentStr = this.loadOptions.decodeFileName(commentByteArray);
            }
        }
    },

    /**
     * Find the unicode path declared in the extra field, if any.
     * @return {String} the unicode path, null otherwise.
     */
    findExtraFieldUnicodePath: function() {
        var upathField = this.extraFields[0x7075];
        if (upathField) {
            var extraReader = readerFor(upathField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the filename changed, this field is out of date.
            if (crc32fn(this.fileName) !== extraReader.readInt(4)) {
                return null;
            }

            return utf8.utf8decode(extraReader.readData(upathField.length - 5));
        }
        return null;
    },

    /**
     * Find the unicode comment declared in the extra field, if any.
     * @return {String} the unicode comment, null otherwise.
     */
    findExtraFieldUnicodeComment: function() {
        var ucommentField = this.extraFields[0x6375];
        if (ucommentField) {
            var extraReader = readerFor(ucommentField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the comment changed, this field is out of date.
            if (crc32fn(this.fileComment) !== extraReader.readInt(4)) {
                return null;
            }

            return utf8.utf8decode(extraReader.readData(ucommentField.length - 5));
        }
        return null;
    }
};
module.exports = ZipEntry;

},{"./compressedObject":135,"./compressions":136,"./crc32":137,"./reader/readerFor":155,"./support":163,"./utf8":164,"./utils":165}],168:[function(require,module,exports){
'use strict';

var StreamHelper = require('./stream/StreamHelper');
var DataWorker = require('./stream/DataWorker');
var utf8 = require('./utf8');
var CompressedObject = require('./compressedObject');
var GenericWorker = require('./stream/GenericWorker');

/**
 * A simple object representing a file in the zip file.
 * @constructor
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
 * @param {Object} options the options of the file
 */
var ZipObject = function(name, data, options) {
    this.name = name;
    this.dir = options.dir;
    this.date = options.date;
    this.comment = options.comment;
    this.unixPermissions = options.unixPermissions;
    this.dosPermissions = options.dosPermissions;

    this._data = data;
    this._dataBinary = options.binary;
    // keep only the compression
    this.options = {
        compression : options.compression,
        compressionOptions : options.compressionOptions
    };
};

ZipObject.prototype = {
    /**
     * Create an internal stream for the content of this object.
     * @param {String} type the type of each chunk.
     * @return StreamHelper the stream.
     */
    internalStream: function (type) {
        var result = null, outputType = "string";
        try {
            if (!type) {
                throw new Error("No output type specified.");
            }
            outputType = type.toLowerCase();
            var askUnicodeString = outputType === "string" || outputType === "text";
            if (outputType === "binarystring" || outputType === "text") {
                outputType = "string";
            }
            result = this._decompressWorker();

            var isUnicodeString = !this._dataBinary;

            if (isUnicodeString && !askUnicodeString) {
                result = result.pipe(new utf8.Utf8EncodeWorker());
            }
            if (!isUnicodeString && askUnicodeString) {
                result = result.pipe(new utf8.Utf8DecodeWorker());
            }
        } catch (e) {
            result = new GenericWorker("error");
            result.error(e);
        }

        return new StreamHelper(result, outputType, "");
    },

    /**
     * Prepare the content in the asked type.
     * @param {String} type the type of the result.
     * @param {Function} onUpdate a function to call on each internal update.
     * @return Promise the promise of the result.
     */
    async: function (type, onUpdate) {
        return this.internalStream(type).accumulate(onUpdate);
    },

    /**
     * Prepare the content as a nodejs stream.
     * @param {String} type the type of each chunk.
     * @param {Function} onUpdate a function to call on each internal update.
     * @return Stream the stream.
     */
    nodeStream: function (type, onUpdate) {
        return this.internalStream(type || "nodebuffer").toNodejsStream(onUpdate);
    },

    /**
     * Return a worker for the compressed content.
     * @private
     * @param {Object} compression the compression object to use.
     * @param {Object} compressionOptions the options to use when compressing.
     * @return Worker the worker.
     */
    _compressWorker: function (compression, compressionOptions) {
        if (
            this._data instanceof CompressedObject &&
            this._data.compression.magic === compression.magic
        ) {
            return this._data.getCompressedWorker();
        } else {
            var result = this._decompressWorker();
            if(!this._dataBinary) {
                result = result.pipe(new utf8.Utf8EncodeWorker());
            }
            return CompressedObject.createWorkerFrom(result, compression, compressionOptions);
        }
    },
    /**
     * Return a worker for the decompressed content.
     * @private
     * @return Worker the worker.
     */
    _decompressWorker : function () {
        if (this._data instanceof CompressedObject) {
            return this._data.getContentWorker();
        } else if (this._data instanceof GenericWorker) {
            return this._data;
        } else {
            return new DataWorker(this._data);
        }
    }
};

var removedMethods = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"];
var removedFn = function () {
    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
};

for(var i = 0; i < removedMethods.length; i++) {
    ZipObject.prototype[removedMethods[i]] = removedFn;
}
module.exports = ZipObject;

},{"./compressedObject":135,"./stream/DataWorker":160,"./stream/GenericWorker":161,"./stream/StreamHelper":162,"./utf8":164}],169:[function(require,module,exports){
'use strict';
var immediate = require('immediate');

/* istanbul ignore next */
function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];

module.exports = Promise;

function Promise(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise.prototype["finally"] = function (callback) {
  if (typeof callback !== 'function') {
    return this;
  }
  var p = this.constructor;
  return this.then(resolve, reject);

  function resolve(value) {
    function yes () {
      return value;
    }
    return p.resolve(callback()).then(yes);
  }
  function reject(reason) {
    function no () {
      throw reason;
    }
    return p.resolve(callback()).then(no);
  }
};
Promise.prototype["catch"] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

Promise.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

Promise.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

Promise.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

Promise.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}

},{"immediate":130}],170:[function(require,module,exports){
(function (global){
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.15';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      // Like with sourceURL, we take care to not check the option's prototype,
      // as this configuration is a code injection vector.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],171:[function(require,module,exports){
'use strict'
var inherits = require('inherits')
var HashBase = require('hash-base')
var Buffer = require('safe-buffer').Buffer

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5

},{"hash-base":115,"inherits":131,"safe-buffer":225}],172:[function(require,module,exports){
var bn = require('bn.js');
var brorand = require('brorand');

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};

},{"bn.js":45,"brorand":46}],173:[function(require,module,exports){
module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};

},{}],174:[function(require,module,exports){
'use strict';

var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};

},{}],175:[function(require,module,exports){
// Top level file is just a mixin of submodules & constants
'use strict';

var assign    = require('./lib/utils/common').assign;

var deflate   = require('./lib/deflate');
var inflate   = require('./lib/inflate');
var constants = require('./lib/zlib/constants');

var pako = {};

assign(pako, deflate, inflate, constants);

module.exports = pako;

},{"./lib/deflate":176,"./lib/inflate":177,"./lib/utils/common":178,"./lib/zlib/constants":181}],176:[function(require,module,exports){
'use strict';


var zlib_deflate = require('./zlib/deflate');
var utils        = require('./utils/common');
var strings      = require('./utils/strings');
var msg          = require('./zlib/messages');
var ZStream      = require('./zlib/zstream');

var toString = Object.prototype.toString;

/* Public constants ==========================================================*/
/* ===========================================================================*/

var Z_NO_FLUSH      = 0;
var Z_FINISH        = 4;

var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_SYNC_FLUSH    = 2;

var Z_DEFAULT_COMPRESSION = -1;

var Z_DEFAULT_STRATEGY    = 0;

var Z_DEFLATED  = 8;

/* ===========================================================================*/


/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/

/* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/

/**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/

/**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/


/**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/
function Deflate(options) {
  if (!(this instanceof Deflate)) return new Deflate(options);

  this.options = utils.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY,
    to: ''
  }, options || {});

  var opt = this.options;

  if (opt.raw && (opt.windowBits > 0)) {
    opt.windowBits = -opt.windowBits;
  }

  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
    opt.windowBits += 16;
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm = new ZStream();
  this.strm.avail_out = 0;

  var status = zlib_deflate.deflateInit2(
    this.strm,
    opt.level,
    opt.method,
    opt.windowBits,
    opt.memLevel,
    opt.strategy
  );

  if (status !== Z_OK) {
    throw new Error(msg[status]);
  }

  if (opt.header) {
    zlib_deflate.deflateSetHeader(this.strm, opt.header);
  }

  if (opt.dictionary) {
    var dict;
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      // If we need to compress text, change encoding to utf8.
      dict = strings.string2buf(opt.dictionary);
    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
      dict = new Uint8Array(opt.dictionary);
    } else {
      dict = opt.dictionary;
    }

    status = zlib_deflate.deflateSetDictionary(this.strm, dict);

    if (status !== Z_OK) {
      throw new Error(msg[status]);
    }

    this._dict_set = true;
  }
}

/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Deflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var status, _mode;

  if (this.ended) { return false; }

  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // If we need to compress text, change encoding to utf8.
    strm.input = strings.string2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }
    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */

    if (status !== Z_STREAM_END && status !== Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }
    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
      if (this.options.to === 'string') {
        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
      } else {
        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
      }
    }
  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);

  // Finalize on the last chunk.
  if (_mode === Z_FINISH) {
    status = zlib_deflate.deflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === Z_SYNC_FLUSH) {
    this.onEnd(Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Deflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Deflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === Z_OK) {
    if (this.options.to === 'string') {
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/
function deflate(input, options) {
  var deflator = new Deflate(options);

  deflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (deflator.err) { throw deflator.msg || msg[deflator.err]; }

  return deflator.result;
}


/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function deflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return deflate(input, options);
}


/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/
function gzip(input, options) {
  options = options || {};
  options.gzip = true;
  return deflate(input, options);
}


exports.Deflate = Deflate;
exports.deflate = deflate;
exports.deflateRaw = deflateRaw;
exports.gzip = gzip;

},{"./utils/common":178,"./utils/strings":179,"./zlib/deflate":183,"./zlib/messages":188,"./zlib/zstream":190}],177:[function(require,module,exports){
'use strict';


var zlib_inflate = require('./zlib/inflate');
var utils        = require('./utils/common');
var strings      = require('./utils/strings');
var c            = require('./zlib/constants');
var msg          = require('./zlib/messages');
var ZStream      = require('./zlib/zstream');
var GZheader     = require('./zlib/gzheader');

var toString = Object.prototype.toString;

/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/

/* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/

/**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/

/**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/


/**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/
function Inflate(options) {
  if (!(this instanceof Inflate)) return new Inflate(options);

  this.options = utils.assign({
    chunkSize: 16384,
    windowBits: 0,
    to: ''
  }, options || {});

  var opt = this.options;

  // Force window size for `raw` data, if not set directly,
  // because we have no header for autodetect.
  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
    opt.windowBits = -opt.windowBits;
    if (opt.windowBits === 0) { opt.windowBits = -15; }
  }

  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
      !(options && options.windowBits)) {
    opt.windowBits += 32;
  }

  // Gzip header has no info about windows size, we can do autodetect only
  // for deflate. So, if window size not set, force it to max when gzip possible
  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
    // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    if ((opt.windowBits & 15) === 0) {
      opt.windowBits |= 15;
    }
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm   = new ZStream();
  this.strm.avail_out = 0;

  var status  = zlib_inflate.inflateInit2(
    this.strm,
    opt.windowBits
  );

  if (status !== c.Z_OK) {
    throw new Error(msg[status]);
  }

  this.header = new GZheader();

  zlib_inflate.inflateGetHeader(this.strm, this.header);

  // Setup dictionary
  if (opt.dictionary) {
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      opt.dictionary = strings.string2buf(opt.dictionary);
    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
      opt.dictionary = new Uint8Array(opt.dictionary);
    }
    if (opt.raw) { //In raw mode we need to set the dictionary early
      status = zlib_inflate.inflateSetDictionary(this.strm, opt.dictionary);
      if (status !== c.Z_OK) {
        throw new Error(msg[status]);
      }
    }
  }
}

/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Inflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var dictionary = this.options.dictionary;
  var status, _mode;
  var next_out_utf8, tail, utf8str;

  // Flag to properly process Z_BUF_ERROR on testing inflate call
  // when we check that all output data was flushed.
  var allowBufError = false;

  if (this.ended) { return false; }
  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // Only binary strings can be decompressed on practice
    strm.input = strings.binstring2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */

    if (status === c.Z_NEED_DICT && dictionary) {
      status = zlib_inflate.inflateSetDictionary(this.strm, dictionary);
    }

    if (status === c.Z_BUF_ERROR && allowBufError === true) {
      status = c.Z_OK;
      allowBufError = false;
    }

    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }

    if (strm.next_out) {
      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH))) {

        if (this.options.to === 'string') {

          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);

          tail = strm.next_out - next_out_utf8;
          utf8str = strings.buf2string(strm.output, next_out_utf8);

          // move tail
          strm.next_out = tail;
          strm.avail_out = chunkSize - tail;
          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }

          this.onData(utf8str);

        } else {
          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
        }
      }
    }

    // When no more input data, we should check that internal inflate buffers
    // are flushed. The only way to do it when avail_out = 0 - run one more
    // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
    // Here we set flag to process this error properly.
    //
    // NOTE. Deflate does not return error in this case and does not needs such
    // logic.
    if (strm.avail_in === 0 && strm.avail_out === 0) {
      allowBufError = true;
    }

  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);

  if (status === c.Z_STREAM_END) {
    _mode = c.Z_FINISH;
  }

  // Finalize on the last chunk.
  if (_mode === c.Z_FINISH) {
    status = zlib_inflate.inflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === c.Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === c.Z_SYNC_FLUSH) {
    this.onEnd(c.Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Inflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Inflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === c.Z_OK) {
    if (this.options.to === 'string') {
      // Glue & convert here, until we teach pako to send
      // utf8 aligned strings to onData
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/
function inflate(input, options) {
  var inflator = new Inflate(options);

  inflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (inflator.err) { throw inflator.msg || msg[inflator.err]; }

  return inflator.result;
}


/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function inflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return inflate(input, options);
}


/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/


exports.Inflate = Inflate;
exports.inflate = inflate;
exports.inflateRaw = inflateRaw;
exports.ungzip  = inflate;

},{"./utils/common":178,"./utils/strings":179,"./zlib/constants":181,"./zlib/gzheader":184,"./zlib/inflate":186,"./zlib/messages":188,"./zlib/zstream":190}],178:[function(require,module,exports){
'use strict';


var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
                (typeof Uint16Array !== 'undefined') &&
                (typeof Int32Array !== 'undefined');

function _has(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

exports.assign = function (obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    var source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (var p in source) {
      if (_has(source, p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function (buf, size) {
  if (buf.length === size) { return buf; }
  if (buf.subarray) { return buf.subarray(0, size); }
  buf.length = size;
  return buf;
};


var fnTyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
      return;
    }
    // Fallback to ordinary array
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    var i, l, len, pos, chunk, result;

    // calculate data length
    len = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      len += chunks[i].length;
    }

    // join chunks
    result = new Uint8Array(len);
    pos = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      chunk = chunks[i];
      result.set(chunk, pos);
      pos += chunk.length;
    }

    return result;
  }
};

var fnUntyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    return [].concat.apply([], chunks);
  }
};


// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function (on) {
  if (on) {
    exports.Buf8  = Uint8Array;
    exports.Buf16 = Uint16Array;
    exports.Buf32 = Int32Array;
    exports.assign(exports, fnTyped);
  } else {
    exports.Buf8  = Array;
    exports.Buf16 = Array;
    exports.Buf32 = Array;
    exports.assign(exports, fnUntyped);
  }
};

exports.setTyped(TYPED_OK);

},{}],179:[function(require,module,exports){
// String encode/decode helpers
'use strict';


var utils = require('./common');


// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var STR_APPLY_OK = true;
var STR_APPLY_UIA_OK = true;

try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }


// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new utils.Buf8(256);
for (var q = 0; q < 256; q++) {
  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
}
_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start


// convert string to array (typed, when possible)
exports.string2buf = function (str) {
  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

  // count binary size
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }

  // allocate buffer
  buf = new utils.Buf8(buf_len);

  // convert
  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      /* one byte */
      buf[i++] = c;
    } else if (c < 0x800) {
      /* two bytes */
      buf[i++] = 0xC0 | (c >>> 6);
      buf[i++] = 0x80 | (c & 0x3f);
    } else if (c < 0x10000) {
      /* three bytes */
      buf[i++] = 0xE0 | (c >>> 12);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    } else {
      /* four bytes */
      buf[i++] = 0xf0 | (c >>> 18);
      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    }
  }

  return buf;
};

// Helper (used in 2 places)
function buf2binstring(buf, len) {
  // On Chrome, the arguments in a function call that are allowed is `65534`.
  // If the length of the buffer is smaller than that, we can use this optimization,
  // otherwise we will take a slower path.
  if (len < 65534) {
    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
    }
  }

  var result = '';
  for (var i = 0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
}


// Convert byte array to binary string
exports.buf2binstring = function (buf) {
  return buf2binstring(buf, buf.length);
};


// Convert binary string (typed, when possible)
exports.binstring2buf = function (str) {
  var buf = new utils.Buf8(str.length);
  for (var i = 0, len = buf.length; i < len; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
};


// convert array to string
exports.buf2string = function (buf, max) {
  var i, out, c, c_len;
  var len = max || buf.length;

  // Reserve max possible length (2 words per char)
  // NB: by unknown reasons, Array is significantly faster for
  //     String.fromCharCode.apply than Uint16Array.
  var utf16buf = new Array(len * 2);

  for (out = 0, i = 0; i < len;) {
    c = buf[i++];
    // quick process ascii
    if (c < 0x80) { utf16buf[out++] = c; continue; }

    c_len = _utf8len[c];
    // skip 5 & 6 byte codes
    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }

    // apply mask on first byte
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    // join the rest
    while (c_len > 1 && i < len) {
      c = (c << 6) | (buf[i++] & 0x3f);
      c_len--;
    }

    // terminated by end of string?
    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
    }
  }

  return buf2binstring(utf16buf, out);
};


// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
exports.utf8border = function (buf, max) {
  var pos;

  max = max || buf.length;
  if (max > buf.length) { max = buf.length; }

  // go back from last position, until start of sequence found
  pos = max - 1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

  // Very small and broken sequence,
  // return max, because we should return something anyway.
  if (pos < 0) { return max; }

  // If we came to start of buffer - that means buffer is too small,
  // return max too.
  if (pos === 0) { return max; }

  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

},{"./common":178}],180:[function(require,module,exports){
'use strict';

// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function adler32(adler, buf, len, pos) {
  var s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
}


module.exports = adler32;

},{}],181:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};

},{}],182:[function(require,module,exports){
'use strict';

// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// Use ordinary array, since untyped makes no boost here
function makeTable() {
  var c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
  var t = crcTable,
      end = pos + len;

  crc ^= -1;

  for (var i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
}


module.exports = crc32;

},{}],183:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils   = require('../utils/common');
var trees   = require('./trees');
var adler32 = require('./adler32');
var crc32   = require('./crc32');
var msg     = require('./messages');

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
var Z_NO_FLUSH      = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
//var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;


/* compression levels */
//var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;


var Z_FILTERED            = 1;
var Z_HUFFMAN_ONLY        = 2;
var Z_RLE                 = 3;
var Z_FIXED               = 4;
var Z_DEFAULT_STRATEGY    = 0;

/* Possible values of the data_type field (though see inflate()) */
//var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;


/* The deflate compression method */
var Z_DEFLATED  = 8;

/*============================================================================*/


var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_MEM_LEVEL = 8;


var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
var LITERALS      = 256;
/* number of literal bytes 0..255 */
var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
var D_CODES       = 30;
/* number of distance codes */
var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
var MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

var PRESET_DICT = 0x20;

var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;

var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
var BS_BLOCK_DONE     = 2; /* block flush performed */
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

function err(strm, errorCode) {
  strm.msg = msg[errorCode];
  return errorCode;
}

function rank(f) {
  return ((f) << 1) - ((f) > 4 ? 9 : 0);
}

function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
function flush_pending(strm) {
  var s = strm.state;

  //_tr_flush_bits(s);
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}


function flush_block_only(s, last) {
  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}


function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
function putShortMSB(s, b) {
//  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
}


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
function read_buf(strm, buf, start, size) {
  var len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  utils.arraySet(buf, strm.input, strm.next_in, len, start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
}


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;      /* max hash chain length */
  var scan = s.strstart; /* current string */
  var match;                       /* matched string */
  var len;                           /* length of current match */
  var best_len = s.prev_length;              /* best match length so far */
  var nice_match = s.nice_match;             /* stop if match long enough */
  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  var _win = s.window; // shortcut

  var wmask = s.w_mask;
  var prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  var strend = s.strstart + MAX_MATCH;
  var scan_end1  = _win[scan + best_len - 1];
  var scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;

      /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = (m >= _w_size ? m - _w_size : 0);
      } while (--n);

      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);

      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
function deflate_stored(s, flush) {
  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
  var max_block_size = 0xffff;

  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }

  /* Copy as much as possible from input to output: */
  for (;;) {
    /* Fill the window as much as possible: */
    if (s.lookahead <= 1) {

      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
      //  s->block_start >= (long)s->w_size, "slide too late");
//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
//        s.block_start >= s.w_size)) {
//        throw  new Error("slide too late");
//      }

      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }

      if (s.lookahead === 0) {
        break;
      }
      /* flush the current block */
    }
    //Assert(s->block_start >= 0L, "block gone");
//    if (s.block_start < 0) throw new Error("block gone");

    s.strstart += s.lookahead;
    s.lookahead = 0;

    /* Emit a stored block if pending_buf will be full: */
    var max_start = s.block_start + max_block_size;

    if (s.strstart === 0 || s.strstart >= max_start) {
      /* strstart == 0 is possible when wraparound on 16-bit machine */
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/


    }
    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }

  s.insert = 0;

  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }

  if (s.strstart > s.block_start) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_NEED_MORE;
}

/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
function deflate_fast(s, flush) {
  var hash_head;        /* head of the hash chain */
  var bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
function deflate_slow(s, flush) {
  var hash_head;          /* head of hash chain */
  var bflush;              /* set if current block must be flushed */

  var max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
}


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
function deflate_rle(s, flush) {
  var bflush;            /* set if current block must be flushed */
  var prev;              /* byte at distance one to match */
  var scan, strend;      /* scan goes up to strend for length of run */

  var _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
function deflate_huff(s, flush) {
  var bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

var configuration_table;

configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
function lm_init(s) {
  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
}


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new utils.Buf16(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.l_buf = 0;          /* buffer index for literals or lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.last_lit = 0;      /* running index in l_buf */

  this.d_buf = 0;
  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


function deflateResetKeep(strm) {
  var s;

  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = Z_NO_FLUSH;
  trees._tr_init(s);
  return Z_OK;
}


function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK) {
    lm_init(strm.state);
  }
  return ret;
}


function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
  strm.state.gzhead = head;
  return Z_OK;
}


function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR;
  }
  var wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  var s = new DeflateState();

  strm.state = s;
  s.strm = strm;

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new utils.Buf8(s.w_size * 2);
  s.head = new utils.Buf16(s.hash_size);
  s.prev = new utils.Buf16(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  s.pending_buf_size = s.lit_bufsize * 4;

  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
  //s->pending_buf = (uchf *) overlay;
  s.pending_buf = new utils.Buf8(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
  s.d_buf = 1 * s.lit_bufsize;

  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
  s.l_buf = (1 + 2) * s.lit_bufsize;

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
}

function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}


function deflate(strm, flush) {
  var old_flush, s;
  var beg, val; // for gzip header write only

  if (!strm || !strm.state ||
    flush > Z_BLOCK || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
  }

  s = strm.state;

  if (!strm.output ||
      (!strm.input && strm.avail_in !== 0) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
  }

  s.strm = strm; /* just in case */
  old_flush = s.last_flush;
  s.last_flush = flush;

  /* Write the header */
  if (s.status === INIT_STATE) {

    if (s.wrap === 2) { // GZIP header
      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) { // s->gzhead == Z_NULL
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      }
      else {
        put_byte(s, (s.gzhead.text ? 1 : 0) +
                    (s.gzhead.hcrc ? 2 : 0) +
                    (!s.gzhead.extra ? 0 : 4) +
                    (!s.gzhead.name ? 0 : 8) +
                    (!s.gzhead.comment ? 0 : 16)
        );
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, (s.gzhead.time >> 8) & 0xff);
        put_byte(s, (s.gzhead.time >> 16) & 0xff);
        put_byte(s, (s.gzhead.time >> 24) & 0xff);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    }
    else // DEFLATE header
    {
      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
      var level_flags = -1;

      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= (level_flags << 6);
      if (s.strstart !== 0) { header |= PRESET_DICT; }
      header += 31 - (header % 31);

      s.status = BUSY_STATE;
      putShortMSB(s, header);

      /* Save the adler32 of the preset dictionary: */
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }
      strm.adler = 1; // adler32(0L, Z_NULL, 0);
    }
  }

//#ifdef GZIP
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */

      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    }
    else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    }
    else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    }
    else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        strm.adler = 0; //crc32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
      }
    }
    else {
      s.status = BUSY_STATE;
    }
  }
//#endif

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH) {
    return err(strm, Z_BUF_ERROR);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR);
  }

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
        configuration_table[s.level].func(s, flush));

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      }
      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

        trees._tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK;
      }
    }
  }
  //Assert(strm->avail_out > 0, "bug2");
  //if (strm.avail_out <= 0) { throw new Error("bug2");}

  if (flush !== Z_FINISH) { return Z_OK; }
  if (s.wrap <= 0) { return Z_STREAM_END; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}

function deflateEnd(strm) {
  var status;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  status = strm.state.status;
  if (status !== INIT_STATE &&
    status !== EXTRA_STATE &&
    status !== NAME_STATE &&
    status !== COMMENT_STATE &&
    status !== HCRC_STATE &&
    status !== BUSY_STATE &&
    status !== FINISH_STATE
  ) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
function deflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var s;
  var str, n;
  var wrap;
  var avail;
  var next;
  var input;
  var tmpDict;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  s = strm.state;
  wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    tmpDict = new utils.Buf8(s.w_size);
    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  avail = strm.avail_in;
  next = strm.next_in;
  input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    str = s.strstart;
    n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK;
}


exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/

},{"../utils/common":178,"./adler32":180,"./crc32":182,"./messages":188,"./trees":189}],184:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function GZheader() {
  /* true if compressed data believed to be text */
  this.text       = 0;
  /* modification time */
  this.time       = 0;
  /* extra flags (not used when writing a gzip file) */
  this.xflags     = 0;
  /* operating system */
  this.os         = 0;
  /* pointer to extra field or Z_NULL if none */
  this.extra      = null;
  /* extra field length (valid if extra != Z_NULL) */
  this.extra_len  = 0; // Actually, we don't need it in JS,
                       // but leave for few code modifications

  //
  // Setup limits is not necessary because in js we should not preallocate memory
  // for inflate use constant limit in 65536 bytes
  //

  /* space at extra (only when reading header) */
  // this.extra_max  = 0;
  /* pointer to zero-terminated file name or Z_NULL */
  this.name       = '';
  /* space at name (only when reading header) */
  // this.name_max   = 0;
  /* pointer to zero-terminated comment or Z_NULL */
  this.comment    = '';
  /* space at comment (only when reading header) */
  // this.comm_max   = 0;
  /* true if there was or will be a header crc */
  this.hcrc       = 0;
  /* true when done reading gzip header (not used when writing a gzip file) */
  this.done       = false;
}

module.exports = GZheader;

},{}],185:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// See state defs from inflate.js
var BAD = 30;       /* got a data error -- remain here until reset */
var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
module.exports = function inflate_fast(strm, start) {
  var state;
  var _in;                    /* local strm.input */
  var last;                   /* have enough input while in < last */
  var _out;                   /* local strm.output */
  var beg;                    /* inflate()'s initial strm.output */
  var end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  var dmax;                   /* maximum distance from zlib header */
//#endif
  var wsize;                  /* window size or zero if not using window */
  var whave;                  /* valid bytes in the window */
  var wnext;                  /* window write index */
  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
  var s_window;               /* allocated sliding window, if wsize != 0 */
  var hold;                   /* local strm.hold */
  var bits;                   /* local strm.bits */
  var lcode;                  /* local strm.lencode */
  var dcode;                  /* local strm.distcode */
  var lmask;                  /* mask for first level of length codes */
  var dmask;                  /* mask for first level of distance codes */
  var here;                   /* retrieved table entry */
  var op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  var len;                    /* match length, unused bytes */
  var dist;                   /* match distance */
  var from;                   /* where to copy match from */
  var from_source;


  var input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD;
                  break top;
                }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = s_window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};

},{}],186:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils         = require('../utils/common');
var adler32       = require('./adler32');
var crc32         = require('./crc32');
var inflate_fast  = require('./inffast');
var inflate_table = require('./inftrees');

var CODES = 0;
var LENS = 1;
var DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
//var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;

/* The deflate compression method */
var Z_DEFLATED  = 8;


/* STATES ====================================================================*/
/* ===========================================================================*/


var    HEAD = 1;       /* i: waiting for magic header */
var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
var    TIME = 3;       /* i: waiting for modification time (gzip) */
var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
var    NAME = 7;       /* i: waiting for end of file name (gzip) */
var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
var    HCRC = 9;       /* i: waiting for header crc (gzip) */
var    DICTID = 10;    /* i: waiting for dictionary check value */
var    DICT = 11;      /* waiting for inflateSetDictionary() call */
var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
var        STORED = 14;    /* i: waiting for stored size (length and complement) */
var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
var        LENLENS = 18;   /* i: waiting for code length code lengths */
var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
var            LEN = 21;       /* i: waiting for length/lit/eob code */
var            LENEXT = 22;    /* i: waiting for length extra bits */
var            DIST = 23;      /* i: waiting for distance code */
var            DISTEXT = 24;   /* i: waiting for distance extra bits */
var            MATCH = 25;     /* o: waiting for output space to copy string */
var            LIT = 26;       /* o: waiting for output space to write literal */
var    CHECK = 27;     /* i: waiting for 32-bit check value */
var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
var    DONE = 29;      /* finished check, done -- remain here until reset */
var    BAD = 30;       /* got a data error -- remain here until reset */
var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_WBITS = MAX_WBITS;


function zswap32(q) {
  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
}


function InflateState() {
  this.mode = 0;             /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
  this.work = new utils.Buf16(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}

function inflateResetKeep(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK;
}

function inflateReset(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

}

function inflateReset2(strm, windowBits) {
  var wrap;
  var state;

  /* get the state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
}

function inflateInit2(strm, windowBits) {
  var ret;
  var state;

  if (!strm) { return Z_STREAM_ERROR; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.window = null/*Z_NULL*/;
  ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
}

function inflateInit(strm) {
  return inflateInit2(strm, DEF_WBITS);
}


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
var virgin = true;

var lenfix, distfix; // We have no pointers in JS, so keep tables separate

function fixedtables(state) {
  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    var sym;

    lenfix = new utils.Buf32(512);
    distfix = new utils.Buf32(32);

    /* literal/length table */
    sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
}


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
function updatewindow(strm, src, end, copy) {
  var dist;
  var state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new utils.Buf8(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      utils.arraySet(state.window, src, end - copy, copy, 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
}

function inflate(strm, flush) {
  var state;
  var input, output;          // input/output buffers
  var next;                   /* next input INDEX */
  var put;                    /* next output INDEX */
  var have, left;             /* available input and output */
  var hold;                   /* bit buffer */
  var bits;                   /* bits in bit buffer */
  var _in, _out;              /* save starting available input and output */
  var copy;                   /* number of stored or match bytes to copy */
  var from;                   /* where to copy match bytes from */
  var from_source;
  var here = 0;               /* current decoding table entry */
  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //var last;                   /* parent table entry */
  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  var len;                    /* length to copy for repeats, bits to drop */
  var ret;                    /* return code */
  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
  var opts;

  var n; // temporary var for NEED_BITS

  var order = /* permutation of code lengths */
    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];


  if (!strm || !strm.state || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
      case HEAD:
        if (state.wrap === 0) {
          state.mode = TYPEDO;
          break;
        }
        //=== NEEDBITS(16);
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//

          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          state.mode = FLAGS;
          break;
        }
        state.flags = 0;           /* expect zlib header */
        if (state.head) {
          state.head.done = false;
        }
        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
          strm.msg = 'incorrect header check';
          state.mode = BAD;
          break;
        }
        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
        len = (hold & 0x0f)/*BITS(4)*/ + 8;
        if (state.wbits === 0) {
          state.wbits = len;
        }
        else if (len > state.wbits) {
          strm.msg = 'invalid window size';
          state.mode = BAD;
          break;
        }
        state.dmax = 1 << len;
        //Tracev((stderr, "inflate:   zlib header ok\n"));
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = hold & 0x200 ? DICTID : TYPE;
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        break;
      case FLAGS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.flags = hold;
        if ((state.flags & 0xff) !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        if (state.flags & 0xe000) {
          strm.msg = 'unknown header flags set';
          state.mode = BAD;
          break;
        }
        if (state.head) {
          state.head.text = ((hold >> 8) & 1);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = TIME;
        /* falls through */
      case TIME:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.time = hold;
        }
        if (state.flags & 0x0200) {
          //=== CRC4(state.check, hold)
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          hbuf[2] = (hold >>> 16) & 0xff;
          hbuf[3] = (hold >>> 24) & 0xff;
          state.check = crc32(state.check, hbuf, 4, 0);
          //===
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = OS;
        /* falls through */
      case OS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.xflags = (hold & 0xff);
          state.head.os = (hold >> 8);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = EXLEN;
        /* falls through */
      case EXLEN:
        if (state.flags & 0x0400) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length = hold;
          if (state.head) {
            state.head.extra_len = hold;
          }
          if (state.flags & 0x0200) {
            //=== CRC2(state.check, hold);
            hbuf[0] = hold & 0xff;
            hbuf[1] = (hold >>> 8) & 0xff;
            state.check = crc32(state.check, hbuf, 2, 0);
            //===//
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        else if (state.head) {
          state.head.extra = null/*Z_NULL*/;
        }
        state.mode = EXTRA;
        /* falls through */
      case EXTRA:
        if (state.flags & 0x0400) {
          copy = state.length;
          if (copy > have) { copy = have; }
          if (copy) {
            if (state.head) {
              len = state.head.extra_len - state.length;
              if (!state.head.extra) {
                // Use untyped array for more convenient processing later
                state.head.extra = new Array(state.head.extra_len);
              }
              utils.arraySet(
                state.head.extra,
                input,
                next,
                // extra field is limited to 65536 bytes
                // - no need for additional size check
                copy,
                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                len
              );
              //zmemcpy(state.head.extra + len, next,
              //        len + copy > state.head.extra_max ?
              //        state.head.extra_max - len : copy);
            }
            if (state.flags & 0x0200) {
              state.check = crc32(state.check, input, copy, next);
            }
            have -= copy;
            next += copy;
            state.length -= copy;
          }
          if (state.length) { break inf_leave; }
        }
        state.length = 0;
        state.mode = NAME;
        /* falls through */
      case NAME:
        if (state.flags & 0x0800) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            // TODO: 2 or 1 bytes?
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.name_max*/)) {
              state.head.name += String.fromCharCode(len);
            }
          } while (len && copy < have);

          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.name = null;
        }
        state.length = 0;
        state.mode = COMMENT;
        /* falls through */
      case COMMENT:
        if (state.flags & 0x1000) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.comm_max*/)) {
              state.head.comment += String.fromCharCode(len);
            }
          } while (len && copy < have);
          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.comment = null;
        }
        state.mode = HCRC;
        /* falls through */
      case HCRC:
        if (state.flags & 0x0200) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.check & 0xffff)) {
            strm.msg = 'header crc mismatch';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        if (state.head) {
          state.head.hcrc = ((state.flags >> 9) & 1);
          state.head.done = true;
        }
        strm.adler = state.check = 0;
        state.mode = TYPE;
        break;
      case DICTID:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        strm.adler = state.check = zswap32(hold);
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = DICT;
        /* falls through */
      case DICT:
        if (state.havedict === 0) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          return Z_NEED_DICT;
        }
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = TYPE;
        /* falls through */
      case TYPE:
        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case TYPEDO:
        if (state.last) {
          //--- BYTEBITS() ---//
          hold >>>= bits & 7;
          bits -= bits & 7;
          //---//
          state.mode = CHECK;
          break;
        }
        //=== NEEDBITS(3); */
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.last = (hold & 0x01)/*BITS(1)*/;
        //--- DROPBITS(1) ---//
        hold >>>= 1;
        bits -= 1;
        //---//

        switch ((hold & 0x03)/*BITS(2)*/) {
          case 0:                             /* stored block */
            //Tracev((stderr, "inflate:     stored block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = STORED;
            break;
          case 1:                             /* fixed block */
            fixedtables(state);
            //Tracev((stderr, "inflate:     fixed codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = LEN_;             /* decode codes */
            if (flush === Z_TREES) {
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
              break inf_leave;
            }
            break;
          case 2:                             /* dynamic block */
            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = TABLE;
            break;
          case 3:
            strm.msg = 'invalid block type';
            state.mode = BAD;
        }
        //--- DROPBITS(2) ---//
        hold >>>= 2;
        bits -= 2;
        //---//
        break;
      case STORED:
        //--- BYTEBITS() ---// /* go to byte boundary */
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
          strm.msg = 'invalid stored block lengths';
          state.mode = BAD;
          break;
        }
        state.length = hold & 0xffff;
        //Tracev((stderr, "inflate:       stored length %u\n",
        //        state.length));
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = COPY_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case COPY_:
        state.mode = COPY;
        /* falls through */
      case COPY:
        copy = state.length;
        if (copy) {
          if (copy > have) { copy = have; }
          if (copy > left) { copy = left; }
          if (copy === 0) { break inf_leave; }
          //--- zmemcpy(put, next, copy); ---
          utils.arraySet(output, input, next, copy, put);
          //---//
          have -= copy;
          next += copy;
          left -= copy;
          put += copy;
          state.length -= copy;
          break;
        }
        //Tracev((stderr, "inflate:       stored end\n"));
        state.mode = TYPE;
        break;
      case TABLE:
        //=== NEEDBITS(14); */
        while (bits < 14) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
//#ifndef PKZIP_BUG_WORKAROUND
        if (state.nlen > 286 || state.ndist > 30) {
          strm.msg = 'too many length or distance symbols';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracev((stderr, "inflate:       table sizes ok\n"));
        state.have = 0;
        state.mode = LENLENS;
        /* falls through */
      case LENLENS:
        while (state.have < state.ncode) {
          //=== NEEDBITS(3);
          while (bits < 3) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
          //--- DROPBITS(3) ---//
          hold >>>= 3;
          bits -= 3;
          //---//
        }
        while (state.have < 19) {
          state.lens[order[state.have++]] = 0;
        }
        // We have separate tables & no pointers. 2 commented lines below not needed.
        //state.next = state.codes;
        //state.lencode = state.next;
        // Switch to use dynamic table
        state.lencode = state.lendyn;
        state.lenbits = 7;

        opts = { bits: state.lenbits };
        ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
        state.lenbits = opts.bits;

        if (ret) {
          strm.msg = 'invalid code lengths set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, "inflate:       code lengths ok\n"));
        state.have = 0;
        state.mode = CODELENS;
        /* falls through */
      case CODELENS:
        while (state.have < state.nlen + state.ndist) {
          for (;;) {
            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          if (here_val < 16) {
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.lens[state.have++] = here_val;
          }
          else {
            if (here_val === 16) {
              //=== NEEDBITS(here.bits + 2);
              n = here_bits + 2;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              if (state.have === 0) {
                strm.msg = 'invalid bit length repeat';
                state.mode = BAD;
                break;
              }
              len = state.lens[state.have - 1];
              copy = 3 + (hold & 0x03);//BITS(2);
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
            }
            else if (here_val === 17) {
              //=== NEEDBITS(here.bits + 3);
              n = here_bits + 3;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 3 + (hold & 0x07);//BITS(3);
              //--- DROPBITS(3) ---//
              hold >>>= 3;
              bits -= 3;
              //---//
            }
            else {
              //=== NEEDBITS(here.bits + 7);
              n = here_bits + 7;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 11 + (hold & 0x7f);//BITS(7);
              //--- DROPBITS(7) ---//
              hold >>>= 7;
              bits -= 7;
              //---//
            }
            if (state.have + copy > state.nlen + state.ndist) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            while (copy--) {
              state.lens[state.have++] = len;
            }
          }
        }

        /* handle error breaks in while */
        if (state.mode === BAD) { break; }

        /* check for end-of-block code (better have one) */
        if (state.lens[256] === 0) {
          strm.msg = 'invalid code -- missing end-of-block';
          state.mode = BAD;
          break;
        }

        /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */
        state.lenbits = 9;

        opts = { bits: state.lenbits };
        ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.lenbits = opts.bits;
        // state.lencode = state.next;

        if (ret) {
          strm.msg = 'invalid literal/lengths set';
          state.mode = BAD;
          break;
        }

        state.distbits = 6;
        //state.distcode.copy(state.codes);
        // Switch to use dynamic table
        state.distcode = state.distdyn;
        opts = { bits: state.distbits };
        ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.distbits = opts.bits;
        // state.distcode = state.next;

        if (ret) {
          strm.msg = 'invalid distances set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, 'inflate:       codes ok\n'));
        state.mode = LEN_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case LEN_:
        state.mode = LEN;
        /* falls through */
      case LEN:
        if (have >= 6 && left >= 258) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          inflate_fast(strm, _out);
          //--- LOAD() ---
          put = strm.next_out;
          output = strm.output;
          left = strm.avail_out;
          next = strm.next_in;
          input = strm.input;
          have = strm.avail_in;
          hold = state.hold;
          bits = state.bits;
          //---

          if (state.mode === TYPE) {
            state.back = -1;
          }
          break;
        }
        state.back = 0;
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if (here_bits <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_op && (here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.lencode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        state.length = here_val;
        if (here_op === 0) {
          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
          //        "inflate:         literal '%c'\n" :
          //        "inflate:         literal 0x%02x\n", here.val));
          state.mode = LIT;
          break;
        }
        if (here_op & 32) {
          //Tracevv((stderr, "inflate:         end of block\n"));
          state.back = -1;
          state.mode = TYPE;
          break;
        }
        if (here_op & 64) {
          strm.msg = 'invalid literal/length code';
          state.mode = BAD;
          break;
        }
        state.extra = here_op & 15;
        state.mode = LENEXT;
        /* falls through */
      case LENEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
        //Tracevv((stderr, "inflate:         length %u\n", state.length));
        state.was = state.length;
        state.mode = DIST;
        /* falls through */
      case DIST:
        for (;;) {
          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if ((here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.distcode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        if (here_op & 64) {
          strm.msg = 'invalid distance code';
          state.mode = BAD;
          break;
        }
        state.offset = here_val;
        state.extra = (here_op) & 15;
        state.mode = DISTEXT;
        /* falls through */
      case DISTEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
//#ifdef INFLATE_STRICT
        if (state.offset > state.dmax) {
          strm.msg = 'invalid distance too far back';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
        state.mode = MATCH;
        /* falls through */
      case MATCH:
        if (left === 0) { break inf_leave; }
        copy = _out - left;
        if (state.offset > copy) {         /* copy from window */
          copy = state.offset - copy;
          if (copy > state.whave) {
            if (state.sane) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break;
            }
// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
          }
          if (copy > state.wnext) {
            copy -= state.wnext;
            from = state.wsize - copy;
          }
          else {
            from = state.wnext - copy;
          }
          if (copy > state.length) { copy = state.length; }
          from_source = state.window;
        }
        else {                              /* copy from output */
          from_source = output;
          from = put - state.offset;
          copy = state.length;
        }
        if (copy > left) { copy = left; }
        left -= copy;
        state.length -= copy;
        do {
          output[put++] = from_source[from++];
        } while (--copy);
        if (state.length === 0) { state.mode = LEN; }
        break;
      case LIT:
        if (left === 0) { break inf_leave; }
        output[put++] = state.length;
        left--;
        state.mode = LEN;
        break;
      case CHECK:
        if (state.wrap) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            // Use '|' instead of '+' to make sure that result is signed
            hold |= input[next++] << bits;
            bits += 8;
          }
          //===//
          _out -= left;
          strm.total_out += _out;
          state.total += _out;
          if (_out) {
            strm.adler = state.check =
                /*UPDATE(state.check, put - _out, _out);*/
                (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

          }
          _out = left;
          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
          if ((state.flags ? hold : zswap32(hold)) !== state.check) {
            strm.msg = 'incorrect data check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   check matches trailer\n"));
        }
        state.mode = LENGTH;
        /* falls through */
      case LENGTH:
        if (state.wrap && state.flags) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.total & 0xffffffff)) {
            strm.msg = 'incorrect length check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   length matches trailer\n"));
        }
        state.mode = DONE;
        /* falls through */
      case DONE:
        ret = Z_STREAM_END;
        break inf_leave;
      case BAD:
        ret = Z_DATA_ERROR;
        break inf_leave;
      case MEM:
        return Z_MEM_ERROR;
      case SYNC:
        /* falls through */
      default:
        return Z_STREAM_ERROR;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
      state.mode = MEM;
      return Z_MEM_ERROR;
    }
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
    ret = Z_BUF_ERROR;
  }
  return ret;
}

function inflateEnd(strm) {

  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
    return Z_STREAM_ERROR;
  }

  var state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK;
}

function inflateGetHeader(strm, head) {
  var state;

  /* check state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK;
}

function inflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var state;
  var dictid;
  var ret;

  /* check state */
  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
  state = strm.state;

  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR;
  }

  /* check for correct dictionary identifier */
  if (state.mode === DICT) {
    dictid = 1; /* adler32(0, null, 0)*/
    /* dictid = adler32(dictid, dictionary, dictLength); */
    dictid = adler32(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR;
    }
  }
  /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR;
  }
  state.havedict = 1;
  // Tracev((stderr, "inflate:   dictionary set\n"));
  return Z_OK;
}

exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateInfo = 'pako inflate (from Nodeca project)';

/* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/

},{"../utils/common":178,"./adler32":180,"./crc32":182,"./inffast":185,"./inftrees":187}],187:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils = require('../utils/common');

var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

var lbase = [ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
];

var lext = [ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
];

var dbase = [ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
];

var dext = [ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
];

module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
{
  var bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  var len = 0;               /* a code's length in bits */
  var sym = 0;               /* index of code symbols */
  var min = 0, max = 0;          /* minimum and maximum code lengths */
  var root = 0;              /* number of index bits for root table */
  var curr = 0;              /* number of index bits for current table */
  var drop = 0;              /* code bits to drop for sub-table */
  var left = 0;                   /* number of prefix codes available */
  var used = 0;              /* code entries in table used */
  var huff = 0;              /* Huffman code */
  var incr;              /* for incrementing code, index */
  var fill;              /* index for replicating entries */
  var low;               /* low bits for current root entry */
  var mask;              /* mask for low root bits */
  var next;             /* next available space in table */
  var base = null;     /* base value table to use */
  var base_index = 0;
//  var shoextra;    /* extra bits table to use */
  var end;                    /* use base and extra for symbol > end */
  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
  var extra = null;
  var extra_index = 0;

  var here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES) {
    base = extra = work;    /* dummy value--not used */
    end = 19;

  } else if (type === LENS) {
    base = lbase;
    base_index -= 257;
    extra = lext;
    extra_index -= 257;
    end = 256;

  } else {                    /* DISTS */
    base = dbase;
    extra = dext;
    end = -1;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS && used > ENOUGH_LENS) ||
    (type === DISTS && used > ENOUGH_DISTS)) {
    return 1;
  }

  /* process all codes and make table entries */
  for (;;) {
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] < end) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] > end) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS && used > ENOUGH_LENS) ||
        (type === DISTS && used > ENOUGH_DISTS)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};

},{"../utils/common":178}],188:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};

},{}],189:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

/* eslint-disable space-unary-ops */

var utils = require('../utils/common');

/* Public constants ==========================================================*/
/* ===========================================================================*/


//var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED               = 4;
//var Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
var Z_BINARY              = 0;
var Z_TEXT                = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;

/*============================================================================*/


function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES    = 2;
/* The three kinds of block type */

var MIN_MATCH    = 3;
var MAX_MATCH    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */

var LITERALS      = 256;
/* number of literal bytes 0..255 */

var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */

var D_CODES       = 30;
/* number of distance codes */

var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */

var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */

var MAX_BITS      = 15;
/* All codes must not exceed MAX_BITS bits */

var Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

var END_BLOCK   = 256;
/* end of block literal code */

var REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

var REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
var extra_lbits =   /* extra bits for each length code */
  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

var extra_dbits =   /* extra bits for each distance code */
  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

var extra_blbits =  /* extra bits for each bit length code */
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

var bl_order =
  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var static_ltree  = new Array((L_CODES + 2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

var static_dtree  = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

var _dist_code    = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

var base_length   = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

var base_dist     = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


var static_l_desc;
var static_d_desc;
var static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
function put_short(s, w) {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
}


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
function send_bits(s, value, length) {
  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
}


function send_code(s, c, tree) {
  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
}


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
function bi_reverse(code, len) {
  var res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
function gen_bitlen(s, desc)
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
  var tree            = desc.dyn_tree;
  var max_code        = desc.max_code;
  var stree           = desc.stat_desc.static_tree;
  var has_stree       = desc.stat_desc.has_stree;
  var extra           = desc.stat_desc.extra_bits;
  var base            = desc.stat_desc.extra_base;
  var max_length      = desc.stat_desc.max_length;
  var h;              /* heap index */
  var n, m;           /* iterate over the tree elements */
  var bits;           /* bit length */
  var xbits;          /* extra bits */
  var f;              /* frequency */
  var overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Trace((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
}


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
function gen_codes(tree, max_code, bl_count)
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
  var code = 0;              /* running code value */
  var bits;                  /* bit index */
  var n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS; bits++) {
    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    var len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
}


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
function tr_static_init() {
  var n;        /* iterates over tree elements */
  var bits;     /* bit counter */
  var length;   /* length value */
  var code;     /* code value */
  var dist;     /* distance index */
  var bl_count = new Array(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);

  //static_init_done = true;
}


/* ===========================================================================
 * Initialize a new block.
 */
function init_block(s) {
  var n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
function bi_windup(s)
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}

/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
function copy_block(s, buf, len, header)
//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
  bi_windup(s);        /* align on byte boundary */

  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
//  while (len--) {
//    put_byte(s, *buf++);
//  }
  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
function smaller(tree, n, m, depth) {
  var _n2 = n * 2;
  var _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
}

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
function pqdownheap(s, tree, k)
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
  var v = s.heap[k];
  var j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
}


// inlined manually
// var SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
function compress_block(s, ltree, dtree)
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
  var dist;           /* distance of matched string */
  var lc;             /* match length or unmatched char (if dist == 0) */
  var lx = 0;         /* running index in l_buf */
  var code;           /* the code to send */
  var extra;          /* number of extra bits to send */

  if (s.last_lit !== 0) {
    do {
      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
      lc = s.pending_buf[s.l_buf + lx];
      lx++;

      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
      //       "pendingBuf overflow");

    } while (lx < s.last_lit);
  }

  send_code(s, END_BLOCK, ltree);
}


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
function build_tree(s, desc)
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
  var tree     = desc.dyn_tree;
  var stree    = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems    = desc.stat_desc.elems;
  var n, m;          /* iterate over heap elements */
  var max_code = -1; /* largest code with non zero frequency */
  var node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
}


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
function scan_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
function send_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
function build_bl_tree(s) {
  var max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
}


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
function send_all_trees(s, lcodes, dcodes, blcodes)
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
  var rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
function detect_data_type(s) {
  /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  var black_mask = 0xf3ffc07f;
  var n;

  /* Check for non-textual ("black-listed") bytes. */
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("white-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
}


var static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
function _tr_init(s)
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
}


/* ===========================================================================
 * Send a stored block
 */
function _tr_stored_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  copy_block(s, buf, stored_len, true); /* with header */
}


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
function _tr_align(s) {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
function _tr_flush_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  var max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->last_lit));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
}

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
function _tr_tally(s, dist, lc)
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
  //var out_length, in_length, dcode;

  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;

  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility

//#ifdef TRUNCATE_BLOCK
//  /* Try to guess if it is profitable to stop the current block here */
//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
//    /* Compute an upper bound for the compressed length */
//    out_length = s.last_lit*8;
//    in_length = s.strstart - s.block_start;
//
//    for (dcode = 0; dcode < D_CODES; dcode++) {
//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
//    }
//    out_length >>>= 3;
//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
//    //       s->last_lit, in_length, out_length,
//    //       100L - out_length*100L/in_length));
//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
//      return true;
//    }
//  }
//#endif

  return (s.last_lit === s.lit_bufsize - 1);
  /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
}

exports._tr_init  = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block  = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;

},{"../utils/common":178}],190:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

module.exports = ZStream;

},{}],191:[function(require,module,exports){
module.exports={"2.16.840.1.101.3.4.1.1": "aes-128-ecb",
"2.16.840.1.101.3.4.1.2": "aes-128-cbc",
"2.16.840.1.101.3.4.1.3": "aes-128-ofb",
"2.16.840.1.101.3.4.1.4": "aes-128-cfb",
"2.16.840.1.101.3.4.1.21": "aes-192-ecb",
"2.16.840.1.101.3.4.1.22": "aes-192-cbc",
"2.16.840.1.101.3.4.1.23": "aes-192-ofb",
"2.16.840.1.101.3.4.1.24": "aes-192-cfb",
"2.16.840.1.101.3.4.1.41": "aes-256-ecb",
"2.16.840.1.101.3.4.1.42": "aes-256-cbc",
"2.16.840.1.101.3.4.1.43": "aes-256-ofb",
"2.16.840.1.101.3.4.1.44": "aes-256-cfb"
}
},{}],192:[function(require,module,exports){
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
'use strict'

var asn1 = require('asn1.js')

exports.certificate = require('./certificate')

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})

},{"./certificate":193,"asn1.js":30}],193:[function(require,module,exports){
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen

'use strict'

var asn = require('asn1.js')

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  })
})

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(
    this.key('type').objid(),
    this.key('value').any()
  )
})

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('parameters').optional(),
    this.key('curve').objid().optional()
  )
})

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue)
})

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName)
})

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  })
})

var Validity = asn.define('Validity', function () {
  this.seq().obj(
    this.key('notBefore').use(Time),
    this.key('notAfter').use(Time)
  )
})

var Extension = asn.define('Extension', function () {
  this.seq().obj(
    this.key('extnID').objid(),
    this.key('critical').bool().def(false),
    this.key('extnValue').octstr()
  )
})

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(
    this.key('version').explicit(0).int().optional(),
    this.key('serialNumber').int(),
    this.key('signature').use(AlgorithmIdentifier),
    this.key('issuer').use(Name),
    this.key('validity').use(Validity),
    this.key('subject').use(Name),
    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
    this.key('extensions').explicit(3).seqof(Extension).optional()
  )
})

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(
    this.key('tbsCertificate').use(TBSCertificate),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signatureValue').bitstr()
  )
})

module.exports = X509Certificate

},{"asn1.js":30}],194:[function(require,module,exports){
// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m
var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m
var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m
var evp = require('evp_bytestokey')
var ciphers = require('browserify-aes')
var Buffer = require('safe-buffer').Buffer
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = new Buffer(match2[2].replace(/[\r\n]/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = Buffer.from(match[2], 'hex')
    var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1]
  return {
    tag: tag,
    data: decrypted
  }
}

},{"browserify-aes":50,"evp_bytestokey":114,"safe-buffer":225}],195:[function(require,module,exports){
var asn1 = require('./asn1')
var aesid = require('./aesid.json')
var fixProc = require('./fixProc')
var ciphers = require('browserify-aes')
var compat = require('pbkdf2')
var Buffer = require('safe-buffer').Buffer
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = Buffer.from(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
      // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der')
      }
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen, 'sha1')
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}

},{"./aesid.json":191,"./asn1":192,"./fixProc":194,"browserify-aes":50,"pbkdf2":196,"safe-buffer":225}],196:[function(require,module,exports){
exports.pbkdf2 = require('./lib/async')
exports.pbkdf2Sync = require('./lib/sync')

},{"./lib/async":197,"./lib/sync":200}],197:[function(require,module,exports){
(function (process,global){
var checkParameters = require('./precondition')
var defaultEncoding = require('./default-encoding')
var sync = require('./sync')
var Buffer = require('safe-buffer').Buffer

var ZERO_BUF
var subtle = global.crypto && global.crypto.subtle
var toBrowser = {
  'sha': 'SHA-1',
  'sha-1': 'SHA-1',
  'sha1': 'SHA-1',
  'sha256': 'SHA-256',
  'sha-256': 'SHA-256',
  'sha384': 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  'sha512': 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (global.process && !global.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}

function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, {name: 'PBKDF2'}, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    process.nextTick(function () {
      callback(null, out)
    })
  }, function (e) {
    process.nextTick(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof global.Promise !== 'function') {
    return process.nextTick(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
  }

  checkParameters(password, salt, iterations, keylen)
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./default-encoding":198,"./precondition":199,"./sync":200,"_process":202,"safe-buffer":225}],198:[function(require,module,exports){
(function (process){
var defaultEncoding
/* istanbul ignore next */
if (process.browser) {
  defaultEncoding = 'utf-8'
} else {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
}
module.exports = defaultEncoding

}).call(this,require('_process'))

},{"_process":202}],199:[function(require,module,exports){
(function (Buffer){
var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

function checkBuffer (buf, name) {
  if (typeof buf !== 'string' && !Buffer.isBuffer(buf)) {
    throw new TypeError(name + ' must be a buffer or string')
  }
}

module.exports = function (password, salt, iterations, keylen) {
  checkBuffer(password, 'Password')
  checkBuffer(salt, 'Salt')

  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}

}).call(this,{"isBuffer":require("../../is-buffer/index.js")})

},{"../../is-buffer/index.js":132}],200:[function(require,module,exports){
var md5 = require('create-hash/md5')
var RIPEMD160 = require('ripemd160')
var sha = require('sha.js')

var checkParameters = require('./precondition')
var defaultEncoding = require('./default-encoding')
var Buffer = require('safe-buffer').Buffer
var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }
  function rmd160Func (data) {
    return new RIPEMD160().update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(password, salt, iterations, keylen)

  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2

},{"./default-encoding":198,"./precondition":199,"create-hash/md5":83,"ripemd160":224,"safe-buffer":225,"sha.js":229}],201:[function(require,module,exports){
(function (process){
'use strict';

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


}).call(this,require('_process'))

},{"_process":202}],202:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],203:[function(require,module,exports){
exports.publicEncrypt = require('./publicEncrypt')
exports.privateDecrypt = require('./privateDecrypt')

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}

},{"./privateDecrypt":205,"./publicEncrypt":206}],204:[function(require,module,exports){
var createHash = require('create-hash')
var Buffer = require('safe-buffer').Buffer

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}

},{"create-hash":82,"safe-buffer":225}],205:[function(require,module,exports){
var parseKeys = require('parse-asn1')
var mgf = require('./mgf')
var xor = require('./xor')
var BN = require('bn.js')
var crt = require('browserify-rsa')
var createHash = require('create-hash')
var withPublic = require('./withPublic')
var Buffer = require('safe-buffer').Buffer

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}

},{"./mgf":204,"./withPublic":207,"./xor":208,"bn.js":45,"browserify-rsa":68,"create-hash":82,"parse-asn1":195,"safe-buffer":225}],206:[function(require,module,exports){
var parseKeys = require('parse-asn1')
var randomBytes = require('randombytes')
var createHash = require('create-hash')
var mgf = require('./mgf')
var xor = require('./xor')
var BN = require('bn.js')
var withPublic = require('./withPublic')
var crt = require('browserify-rsa')
var Buffer = require('safe-buffer').Buffer

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}

},{"./mgf":204,"./withPublic":207,"./xor":208,"bn.js":45,"browserify-rsa":68,"create-hash":82,"parse-asn1":195,"randombytes":209,"safe-buffer":225}],207:[function(require,module,exports){
var BN = require('bn.js')
var Buffer = require('safe-buffer').Buffer

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic

},{"bn.js":45,"safe-buffer":225}],208:[function(require,module,exports){
module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}

},{}],209:[function(require,module,exports){
(function (process,global){
'use strict'

// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536

// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = require('safe-buffer').Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > MAX_UINT32) throw new RangeError('requested too many random bytes')

  var bytes = Buffer.allocUnsafe(size)

  if (size > 0) {  // getRandomValues fails on IE if size == 0
    if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
      // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
      for (var generated = 0; generated < size; generated += MAX_BYTES) {
        // buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES))
      }
    } else {
      crypto.getRandomValues(bytes)
    }
  }

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"_process":202,"safe-buffer":225}],210:[function(require,module,exports){
(function (process,global){
'use strict'

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = require('safe-buffer')
var randombytes = require('randombytes')
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"_process":202,"randombytes":209,"safe-buffer":225}],211:[function(require,module,exports){
module.exports = require('./lib/_stream_duplex.js');

},{"./lib/_stream_duplex.js":212}],212:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

var Readable = require('./_stream_readable');
var Writable = require('./_stream_writable');

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};
},{"./_stream_readable":214,"./_stream_writable":216,"core-util-is":80,"inherits":131,"process-nextick-args":201}],213:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.

'use strict';

module.exports = PassThrough;

var Transform = require('./_stream_transform');

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};
},{"./_stream_transform":215,"core-util-is":80,"inherits":131}],214:[function(require,module,exports){
(function (process,global){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = require('isarray');
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = require('events').EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

/*<replacement>*/
var debugUtil = require('util');
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = require('./internal/streams/BufferList');
var destroyImpl = require('./internal/streams/destroy');
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || require('./_stream_duplex');

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./_stream_duplex":212,"./internal/streams/BufferList":217,"./internal/streams/destroy":218,"./internal/streams/stream":219,"_process":202,"core-util-is":80,"events":113,"inherits":131,"isarray":133,"process-nextick-args":201,"safe-buffer":225,"string_decoder/":237,"util":47}],215:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

'use strict';

module.exports = Transform;

var Duplex = require('./_stream_duplex');

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}
},{"./_stream_duplex":212,"core-util-is":80,"inherits":131}],216:[function(require,module,exports){
(function (process,global,setImmediate){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(require('core-util-is'));
util.inherits = require('inherits');
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: require('util-deprecate')
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = require('./internal/streams/destroy');

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || require('./_stream_duplex');

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("timers").setImmediate)

},{"./_stream_duplex":212,"./internal/streams/destroy":218,"./internal/streams/stream":219,"_process":202,"core-util-is":80,"inherits":131,"process-nextick-args":201,"safe-buffer":225,"timers":238,"util-deprecate":239}],217:[function(require,module,exports){
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = require('safe-buffer').Buffer;
var util = require('util');

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}
},{"safe-buffer":225,"util":47}],218:[function(require,module,exports){
'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};
},{"process-nextick-args":201}],219:[function(require,module,exports){
module.exports = require('events').EventEmitter;

},{"events":113}],220:[function(require,module,exports){
module.exports = require('./readable').PassThrough

},{"./readable":221}],221:[function(require,module,exports){
exports = module.exports = require('./lib/_stream_readable.js');
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require('./lib/_stream_writable.js');
exports.Duplex = require('./lib/_stream_duplex.js');
exports.Transform = require('./lib/_stream_transform.js');
exports.PassThrough = require('./lib/_stream_passthrough.js');

},{"./lib/_stream_duplex.js":212,"./lib/_stream_passthrough.js":213,"./lib/_stream_readable.js":214,"./lib/_stream_transform.js":215,"./lib/_stream_writable.js":216}],222:[function(require,module,exports){
module.exports = require('./readable').Transform

},{"./readable":221}],223:[function(require,module,exports){
module.exports = require('./lib/_stream_writable.js');

},{"./lib/_stream_writable.js":216}],224:[function(require,module,exports){
'use strict'
var Buffer = require('buffer').Buffer
var inherits = require('inherits')
var HashBase = require('hash-base')

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160

},{"buffer":77,"hash-base":115,"inherits":131}],225:[function(require,module,exports){
/* eslint-disable node/no-deprecated-api */
var buffer = require('buffer')
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}

},{"buffer":77}],226:[function(require,module,exports){
(function (Buffer){
;(function (sax) { // wrapper for non-node envs
  sax.parser = function (strict, opt) { return new SAXParser(strict, opt) }
  sax.SAXParser = SAXParser
  sax.SAXStream = SAXStream
  sax.createStream = createStream

  // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
  // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
  // since that's the earliest that a buffer overrun could occur.  This way, checks are
  // as rare as required, but as often as necessary to ensure never crossing this bound.
  // Furthermore, buffers are only tested at most once per write(), so passing a very
  // large string into write() might have undesirable effects, but this is manageable by
  // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
  // edge case, result in creating at most one complete copy of the string passed in.
  // Set to Infinity to have unlimited buffers.
  sax.MAX_BUFFER_LENGTH = 64 * 1024

  var buffers = [
    'comment', 'sgmlDecl', 'textNode', 'tagName', 'doctype',
    'procInstName', 'procInstBody', 'entity', 'attribName',
    'attribValue', 'cdata', 'script'
  ]

  sax.EVENTS = [
    'text',
    'processinginstruction',
    'sgmldeclaration',
    'doctype',
    'comment',
    'opentagstart',
    'attribute',
    'opentag',
    'closetag',
    'opencdata',
    'cdata',
    'closecdata',
    'error',
    'end',
    'ready',
    'script',
    'opennamespace',
    'closenamespace'
  ]

  function SAXParser (strict, opt) {
    if (!(this instanceof SAXParser)) {
      return new SAXParser(strict, opt)
    }

    var parser = this
    clearBuffers(parser)
    parser.q = parser.c = ''
    parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH
    parser.opt = opt || {}
    parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags
    parser.looseCase = parser.opt.lowercase ? 'toLowerCase' : 'toUpperCase'
    parser.tags = []
    parser.closed = parser.closedRoot = parser.sawRoot = false
    parser.tag = parser.error = null
    parser.strict = !!strict
    parser.noscript = !!(strict || parser.opt.noscript)
    parser.state = S.BEGIN
    parser.strictEntities = parser.opt.strictEntities
    parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES)
    parser.attribList = []

    // namespaces form a prototype chain.
    // it always points at the current tag,
    // which protos to its parent tag.
    if (parser.opt.xmlns) {
      parser.ns = Object.create(rootNS)
    }

    // mostly just for error reporting
    parser.trackPosition = parser.opt.position !== false
    if (parser.trackPosition) {
      parser.position = parser.line = parser.column = 0
    }
    emit(parser, 'onready')
  }

  if (!Object.create) {
    Object.create = function (o) {
      function F () {}
      F.prototype = o
      var newf = new F()
      return newf
    }
  }

  if (!Object.keys) {
    Object.keys = function (o) {
      var a = []
      for (var i in o) if (o.hasOwnProperty(i)) a.push(i)
      return a
    }
  }

  function checkBufferLength (parser) {
    var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10)
    var maxActual = 0
    for (var i = 0, l = buffers.length; i < l; i++) {
      var len = parser[buffers[i]].length
      if (len > maxAllowed) {
        // Text/cdata nodes can get big, and since they're buffered,
        // we can get here under normal conditions.
        // Avoid issues by emitting the text node now,
        // so at least it won't get any bigger.
        switch (buffers[i]) {
          case 'textNode':
            closeText(parser)
            break

          case 'cdata':
            emitNode(parser, 'oncdata', parser.cdata)
            parser.cdata = ''
            break

          case 'script':
            emitNode(parser, 'onscript', parser.script)
            parser.script = ''
            break

          default:
            error(parser, 'Max buffer length exceeded: ' + buffers[i])
        }
      }
      maxActual = Math.max(maxActual, len)
    }
    // schedule the next check for the earliest possible buffer overrun.
    var m = sax.MAX_BUFFER_LENGTH - maxActual
    parser.bufferCheckPosition = m + parser.position
  }

  function clearBuffers (parser) {
    for (var i = 0, l = buffers.length; i < l; i++) {
      parser[buffers[i]] = ''
    }
  }

  function flushBuffers (parser) {
    closeText(parser)
    if (parser.cdata !== '') {
      emitNode(parser, 'oncdata', parser.cdata)
      parser.cdata = ''
    }
    if (parser.script !== '') {
      emitNode(parser, 'onscript', parser.script)
      parser.script = ''
    }
  }

  SAXParser.prototype = {
    end: function () { end(this) },
    write: write,
    resume: function () { this.error = null; return this },
    close: function () { return this.write(null) },
    flush: function () { flushBuffers(this) }
  }

  var Stream
  try {
    Stream = require('stream').Stream
  } catch (ex) {
    Stream = function () {}
  }

  var streamWraps = sax.EVENTS.filter(function (ev) {
    return ev !== 'error' && ev !== 'end'
  })

  function createStream (strict, opt) {
    return new SAXStream(strict, opt)
  }

  function SAXStream (strict, opt) {
    if (!(this instanceof SAXStream)) {
      return new SAXStream(strict, opt)
    }

    Stream.apply(this)

    this._parser = new SAXParser(strict, opt)
    this.writable = true
    this.readable = true

    var me = this

    this._parser.onend = function () {
      me.emit('end')
    }

    this._parser.onerror = function (er) {
      me.emit('error', er)

      // if didn't throw, then means error was handled.
      // go ahead and clear error, so we can write again.
      me._parser.error = null
    }

    this._decoder = null

    streamWraps.forEach(function (ev) {
      Object.defineProperty(me, 'on' + ev, {
        get: function () {
          return me._parser['on' + ev]
        },
        set: function (h) {
          if (!h) {
            me.removeAllListeners(ev)
            me._parser['on' + ev] = h
            return h
          }
          me.on(ev, h)
        },
        enumerable: true,
        configurable: false
      })
    })
  }

  SAXStream.prototype = Object.create(Stream.prototype, {
    constructor: {
      value: SAXStream
    }
  })

  SAXStream.prototype.write = function (data) {
    if (typeof Buffer === 'function' &&
      typeof Buffer.isBuffer === 'function' &&
      Buffer.isBuffer(data)) {
      if (!this._decoder) {
        var SD = require('string_decoder').StringDecoder
        this._decoder = new SD('utf8')
      }
      data = this._decoder.write(data)
    }

    this._parser.write(data.toString())
    this.emit('data', data)
    return true
  }

  SAXStream.prototype.end = function (chunk) {
    if (chunk && chunk.length) {
      this.write(chunk)
    }
    this._parser.end()
    return true
  }

  SAXStream.prototype.on = function (ev, handler) {
    var me = this
    if (!me._parser['on' + ev] && streamWraps.indexOf(ev) !== -1) {
      me._parser['on' + ev] = function () {
        var args = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments)
        args.splice(0, 0, ev)
        me.emit.apply(me, args)
      }
    }

    return Stream.prototype.on.call(me, ev, handler)
  }

  // this really needs to be replaced with character classes.
  // XML allows all manner of ridiculous numbers and digits.
  var CDATA = '[CDATA['
  var DOCTYPE = 'DOCTYPE'
  var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace'
  var XMLNS_NAMESPACE = 'http://www.w3.org/2000/xmlns/'
  var rootNS = { xml: XML_NAMESPACE, xmlns: XMLNS_NAMESPACE }

  // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
  // This implementation works on strings, a single character at a time
  // as such, it cannot ever support astral-plane characters (10000-EFFFF)
  // without a significant breaking change to either this  parser, or the
  // JavaScript language.  Implementation of an emoji-capable xml parser
  // is left as an exercise for the reader.
  var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/

  var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/

  var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/
  var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/

  function isWhitespace (c) {
    return c === ' ' || c === '\n' || c === '\r' || c === '\t'
  }

  function isQuote (c) {
    return c === '"' || c === '\''
  }

  function isAttribEnd (c) {
    return c === '>' || isWhitespace(c)
  }

  function isMatch (regex, c) {
    return regex.test(c)
  }

  function notMatch (regex, c) {
    return !isMatch(regex, c)
  }

  var S = 0
  sax.STATE = {
    BEGIN: S++, // leading byte order mark or whitespace
    BEGIN_WHITESPACE: S++, // leading whitespace
    TEXT: S++, // general stuff
    TEXT_ENTITY: S++, // &amp and such.
    OPEN_WAKA: S++, // <
    SGML_DECL: S++, // <!BLARG
    SGML_DECL_QUOTED: S++, // <!BLARG foo "bar
    DOCTYPE: S++, // <!DOCTYPE
    DOCTYPE_QUOTED: S++, // <!DOCTYPE "//blah
    DOCTYPE_DTD: S++, // <!DOCTYPE "//blah" [ ...
    DOCTYPE_DTD_QUOTED: S++, // <!DOCTYPE "//blah" [ "foo
    COMMENT_STARTING: S++, // <!-
    COMMENT: S++, // <!--
    COMMENT_ENDING: S++, // <!-- blah -
    COMMENT_ENDED: S++, // <!-- blah --
    CDATA: S++, // <![CDATA[ something
    CDATA_ENDING: S++, // ]
    CDATA_ENDING_2: S++, // ]]
    PROC_INST: S++, // <?hi
    PROC_INST_BODY: S++, // <?hi there
    PROC_INST_ENDING: S++, // <?hi "there" ?
    OPEN_TAG: S++, // <strong
    OPEN_TAG_SLASH: S++, // <strong /
    ATTRIB: S++, // <a
    ATTRIB_NAME: S++, // <a foo
    ATTRIB_NAME_SAW_WHITE: S++, // <a foo _
    ATTRIB_VALUE: S++, // <a foo=
    ATTRIB_VALUE_QUOTED: S++, // <a foo="bar
    ATTRIB_VALUE_CLOSED: S++, // <a foo="bar"
    ATTRIB_VALUE_UNQUOTED: S++, // <a foo=bar
    ATTRIB_VALUE_ENTITY_Q: S++, // <foo bar="&quot;"
    ATTRIB_VALUE_ENTITY_U: S++, // <foo bar=&quot
    CLOSE_TAG: S++, // </a
    CLOSE_TAG_SAW_WHITE: S++, // </a   >
    SCRIPT: S++, // <script> ...
    SCRIPT_ENDING: S++ // <script> ... <
  }

  sax.XML_ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'"
  }

  sax.ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'",
    'AElig': 198,
    'Aacute': 193,
    'Acirc': 194,
    'Agrave': 192,
    'Aring': 197,
    'Atilde': 195,
    'Auml': 196,
    'Ccedil': 199,
    'ETH': 208,
    'Eacute': 201,
    'Ecirc': 202,
    'Egrave': 200,
    'Euml': 203,
    'Iacute': 205,
    'Icirc': 206,
    'Igrave': 204,
    'Iuml': 207,
    'Ntilde': 209,
    'Oacute': 211,
    'Ocirc': 212,
    'Ograve': 210,
    'Oslash': 216,
    'Otilde': 213,
    'Ouml': 214,
    'THORN': 222,
    'Uacute': 218,
    'Ucirc': 219,
    'Ugrave': 217,
    'Uuml': 220,
    'Yacute': 221,
    'aacute': 225,
    'acirc': 226,
    'aelig': 230,
    'agrave': 224,
    'aring': 229,
    'atilde': 227,
    'auml': 228,
    'ccedil': 231,
    'eacute': 233,
    'ecirc': 234,
    'egrave': 232,
    'eth': 240,
    'euml': 235,
    'iacute': 237,
    'icirc': 238,
    'igrave': 236,
    'iuml': 239,
    'ntilde': 241,
    'oacute': 243,
    'ocirc': 244,
    'ograve': 242,
    'oslash': 248,
    'otilde': 245,
    'ouml': 246,
    'szlig': 223,
    'thorn': 254,
    'uacute': 250,
    'ucirc': 251,
    'ugrave': 249,
    'uuml': 252,
    'yacute': 253,
    'yuml': 255,
    'copy': 169,
    'reg': 174,
    'nbsp': 160,
    'iexcl': 161,
    'cent': 162,
    'pound': 163,
    'curren': 164,
    'yen': 165,
    'brvbar': 166,
    'sect': 167,
    'uml': 168,
    'ordf': 170,
    'laquo': 171,
    'not': 172,
    'shy': 173,
    'macr': 175,
    'deg': 176,
    'plusmn': 177,
    'sup1': 185,
    'sup2': 178,
    'sup3': 179,
    'acute': 180,
    'micro': 181,
    'para': 182,
    'middot': 183,
    'cedil': 184,
    'ordm': 186,
    'raquo': 187,
    'frac14': 188,
    'frac12': 189,
    'frac34': 190,
    'iquest': 191,
    'times': 215,
    'divide': 247,
    'OElig': 338,
    'oelig': 339,
    'Scaron': 352,
    'scaron': 353,
    'Yuml': 376,
    'fnof': 402,
    'circ': 710,
    'tilde': 732,
    'Alpha': 913,
    'Beta': 914,
    'Gamma': 915,
    'Delta': 916,
    'Epsilon': 917,
    'Zeta': 918,
    'Eta': 919,
    'Theta': 920,
    'Iota': 921,
    'Kappa': 922,
    'Lambda': 923,
    'Mu': 924,
    'Nu': 925,
    'Xi': 926,
    'Omicron': 927,
    'Pi': 928,
    'Rho': 929,
    'Sigma': 931,
    'Tau': 932,
    'Upsilon': 933,
    'Phi': 934,
    'Chi': 935,
    'Psi': 936,
    'Omega': 937,
    'alpha': 945,
    'beta': 946,
    'gamma': 947,
    'delta': 948,
    'epsilon': 949,
    'zeta': 950,
    'eta': 951,
    'theta': 952,
    'iota': 953,
    'kappa': 954,
    'lambda': 955,
    'mu': 956,
    'nu': 957,
    'xi': 958,
    'omicron': 959,
    'pi': 960,
    'rho': 961,
    'sigmaf': 962,
    'sigma': 963,
    'tau': 964,
    'upsilon': 965,
    'phi': 966,
    'chi': 967,
    'psi': 968,
    'omega': 969,
    'thetasym': 977,
    'upsih': 978,
    'piv': 982,
    'ensp': 8194,
    'emsp': 8195,
    'thinsp': 8201,
    'zwnj': 8204,
    'zwj': 8205,
    'lrm': 8206,
    'rlm': 8207,
    'ndash': 8211,
    'mdash': 8212,
    'lsquo': 8216,
    'rsquo': 8217,
    'sbquo': 8218,
    'ldquo': 8220,
    'rdquo': 8221,
    'bdquo': 8222,
    'dagger': 8224,
    'Dagger': 8225,
    'bull': 8226,
    'hellip': 8230,
    'permil': 8240,
    'prime': 8242,
    'Prime': 8243,
    'lsaquo': 8249,
    'rsaquo': 8250,
    'oline': 8254,
    'frasl': 8260,
    'euro': 8364,
    'image': 8465,
    'weierp': 8472,
    'real': 8476,
    'trade': 8482,
    'alefsym': 8501,
    'larr': 8592,
    'uarr': 8593,
    'rarr': 8594,
    'darr': 8595,
    'harr': 8596,
    'crarr': 8629,
    'lArr': 8656,
    'uArr': 8657,
    'rArr': 8658,
    'dArr': 8659,
    'hArr': 8660,
    'forall': 8704,
    'part': 8706,
    'exist': 8707,
    'empty': 8709,
    'nabla': 8711,
    'isin': 8712,
    'notin': 8713,
    'ni': 8715,
    'prod': 8719,
    'sum': 8721,
    'minus': 8722,
    'lowast': 8727,
    'radic': 8730,
    'prop': 8733,
    'infin': 8734,
    'ang': 8736,
    'and': 8743,
    'or': 8744,
    'cap': 8745,
    'cup': 8746,
    'int': 8747,
    'there4': 8756,
    'sim': 8764,
    'cong': 8773,
    'asymp': 8776,
    'ne': 8800,
    'equiv': 8801,
    'le': 8804,
    'ge': 8805,
    'sub': 8834,
    'sup': 8835,
    'nsub': 8836,
    'sube': 8838,
    'supe': 8839,
    'oplus': 8853,
    'otimes': 8855,
    'perp': 8869,
    'sdot': 8901,
    'lceil': 8968,
    'rceil': 8969,
    'lfloor': 8970,
    'rfloor': 8971,
    'lang': 9001,
    'rang': 9002,
    'loz': 9674,
    'spades': 9824,
    'clubs': 9827,
    'hearts': 9829,
    'diams': 9830
  }

  Object.keys(sax.ENTITIES).forEach(function (key) {
    var e = sax.ENTITIES[key]
    var s = typeof e === 'number' ? String.fromCharCode(e) : e
    sax.ENTITIES[key] = s
  })

  for (var s in sax.STATE) {
    sax.STATE[sax.STATE[s]] = s
  }

  // shorthand
  S = sax.STATE

  function emit (parser, event, data) {
    parser[event] && parser[event](data)
  }

  function emitNode (parser, nodeType, data) {
    if (parser.textNode) closeText(parser)
    emit(parser, nodeType, data)
  }

  function closeText (parser) {
    parser.textNode = textopts(parser.opt, parser.textNode)
    if (parser.textNode) emit(parser, 'ontext', parser.textNode)
    parser.textNode = ''
  }

  function textopts (opt, text) {
    if (opt.trim) text = text.trim()
    if (opt.normalize) text = text.replace(/\s+/g, ' ')
    return text
  }

  function error (parser, er) {
    closeText(parser)
    if (parser.trackPosition) {
      er += '\nLine: ' + parser.line +
        '\nColumn: ' + parser.column +
        '\nChar: ' + parser.c
    }
    er = new Error(er)
    parser.error = er
    emit(parser, 'onerror', er)
    return parser
  }

  function end (parser) {
    if (parser.sawRoot && !parser.closedRoot) strictFail(parser, 'Unclosed root tag')
    if ((parser.state !== S.BEGIN) &&
      (parser.state !== S.BEGIN_WHITESPACE) &&
      (parser.state !== S.TEXT)) {
      error(parser, 'Unexpected end')
    }
    closeText(parser)
    parser.c = ''
    parser.closed = true
    emit(parser, 'onend')
    SAXParser.call(parser, parser.strict, parser.opt)
    return parser
  }

  function strictFail (parser, message) {
    if (typeof parser !== 'object' || !(parser instanceof SAXParser)) {
      throw new Error('bad call to strictFail')
    }
    if (parser.strict) {
      error(parser, message)
    }
  }

  function newTag (parser) {
    if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]()
    var parent = parser.tags[parser.tags.length - 1] || parser
    var tag = parser.tag = { name: parser.tagName, attributes: {} }

    // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
    if (parser.opt.xmlns) {
      tag.ns = parent.ns
    }
    parser.attribList.length = 0
    emitNode(parser, 'onopentagstart', tag)
  }

  function qname (name, attribute) {
    var i = name.indexOf(':')
    var qualName = i < 0 ? [ '', name ] : name.split(':')
    var prefix = qualName[0]
    var local = qualName[1]

    // <x "xmlns"="http://foo">
    if (attribute && name === 'xmlns') {
      prefix = 'xmlns'
      local = ''
    }

    return { prefix: prefix, local: local }
  }

  function attrib (parser) {
    if (!parser.strict) {
      parser.attribName = parser.attribName[parser.looseCase]()
    }

    if (parser.attribList.indexOf(parser.attribName) !== -1 ||
      parser.tag.attributes.hasOwnProperty(parser.attribName)) {
      parser.attribName = parser.attribValue = ''
      return
    }

    if (parser.opt.xmlns) {
      var qn = qname(parser.attribName, true)
      var prefix = qn.prefix
      var local = qn.local

      if (prefix === 'xmlns') {
        // namespace binding attribute. push the binding into scope
        if (local === 'xml' && parser.attribValue !== XML_NAMESPACE) {
          strictFail(parser,
            'xml: prefix must be bound to ' + XML_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue)
        } else if (local === 'xmlns' && parser.attribValue !== XMLNS_NAMESPACE) {
          strictFail(parser,
            'xmlns: prefix must be bound to ' + XMLNS_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue)
        } else {
          var tag = parser.tag
          var parent = parser.tags[parser.tags.length - 1] || parser
          if (tag.ns === parent.ns) {
            tag.ns = Object.create(parent.ns)
          }
          tag.ns[local] = parser.attribValue
        }
      }

      // defer onattribute events until all attributes have been seen
      // so any new bindings can take effect. preserve attribute order
      // so deferred events can be emitted in document order
      parser.attribList.push([parser.attribName, parser.attribValue])
    } else {
      // in non-xmlns mode, we can emit the event right away
      parser.tag.attributes[parser.attribName] = parser.attribValue
      emitNode(parser, 'onattribute', {
        name: parser.attribName,
        value: parser.attribValue
      })
    }

    parser.attribName = parser.attribValue = ''
  }

  function openTag (parser, selfClosing) {
    if (parser.opt.xmlns) {
      // emit namespace binding events
      var tag = parser.tag

      // add namespace info to tag
      var qn = qname(parser.tagName)
      tag.prefix = qn.prefix
      tag.local = qn.local
      tag.uri = tag.ns[qn.prefix] || ''

      if (tag.prefix && !tag.uri) {
        strictFail(parser, 'Unbound namespace prefix: ' +
          JSON.stringify(parser.tagName))
        tag.uri = qn.prefix
      }

      var parent = parser.tags[parser.tags.length - 1] || parser
      if (tag.ns && parent.ns !== tag.ns) {
        Object.keys(tag.ns).forEach(function (p) {
          emitNode(parser, 'onopennamespace', {
            prefix: p,
            uri: tag.ns[p]
          })
        })
      }

      // handle deferred onattribute events
      // Note: do not apply default ns to attributes:
      //   http://www.w3.org/TR/REC-xml-names/#defaulting
      for (var i = 0, l = parser.attribList.length; i < l; i++) {
        var nv = parser.attribList[i]
        var name = nv[0]
        var value = nv[1]
        var qualName = qname(name, true)
        var prefix = qualName.prefix
        var local = qualName.local
        var uri = prefix === '' ? '' : (tag.ns[prefix] || '')
        var a = {
          name: name,
          value: value,
          prefix: prefix,
          local: local,
          uri: uri
        }

        // if there's any attributes with an undefined namespace,
        // then fail on them now.
        if (prefix && prefix !== 'xmlns' && !uri) {
          strictFail(parser, 'Unbound namespace prefix: ' +
            JSON.stringify(prefix))
          a.uri = prefix
        }
        parser.tag.attributes[name] = a
        emitNode(parser, 'onattribute', a)
      }
      parser.attribList.length = 0
    }

    parser.tag.isSelfClosing = !!selfClosing

    // process the tag
    parser.sawRoot = true
    parser.tags.push(parser.tag)
    emitNode(parser, 'onopentag', parser.tag)
    if (!selfClosing) {
      // special case for <script> in non-strict mode.
      if (!parser.noscript && parser.tagName.toLowerCase() === 'script') {
        parser.state = S.SCRIPT
      } else {
        parser.state = S.TEXT
      }
      parser.tag = null
      parser.tagName = ''
    }
    parser.attribName = parser.attribValue = ''
    parser.attribList.length = 0
  }

  function closeTag (parser) {
    if (!parser.tagName) {
      strictFail(parser, 'Weird empty close tag.')
      parser.textNode += '</>'
      parser.state = S.TEXT
      return
    }

    if (parser.script) {
      if (parser.tagName !== 'script') {
        parser.script += '</' + parser.tagName + '>'
        parser.tagName = ''
        parser.state = S.SCRIPT
        return
      }
      emitNode(parser, 'onscript', parser.script)
      parser.script = ''
    }

    // first make sure that the closing tag actually exists.
    // <a><b></c></b></a> will close everything, otherwise.
    var t = parser.tags.length
    var tagName = parser.tagName
    if (!parser.strict) {
      tagName = tagName[parser.looseCase]()
    }
    var closeTo = tagName
    while (t--) {
      var close = parser.tags[t]
      if (close.name !== closeTo) {
        // fail the first time in strict mode
        strictFail(parser, 'Unexpected close tag')
      } else {
        break
      }
    }

    // didn't find it.  we already failed for strict, so just abort.
    if (t < 0) {
      strictFail(parser, 'Unmatched closing tag: ' + parser.tagName)
      parser.textNode += '</' + parser.tagName + '>'
      parser.state = S.TEXT
      return
    }
    parser.tagName = tagName
    var s = parser.tags.length
    while (s-- > t) {
      var tag = parser.tag = parser.tags.pop()
      parser.tagName = parser.tag.name
      emitNode(parser, 'onclosetag', parser.tagName)

      var x = {}
      for (var i in tag.ns) {
        x[i] = tag.ns[i]
      }

      var parent = parser.tags[parser.tags.length - 1] || parser
      if (parser.opt.xmlns && tag.ns !== parent.ns) {
        // remove namespace bindings introduced by tag
        Object.keys(tag.ns).forEach(function (p) {
          var n = tag.ns[p]
          emitNode(parser, 'onclosenamespace', { prefix: p, uri: n })
        })
      }
    }
    if (t === 0) parser.closedRoot = true
    parser.tagName = parser.attribValue = parser.attribName = ''
    parser.attribList.length = 0
    parser.state = S.TEXT
  }

  function parseEntity (parser) {
    var entity = parser.entity
    var entityLC = entity.toLowerCase()
    var num
    var numStr = ''

    if (parser.ENTITIES[entity]) {
      return parser.ENTITIES[entity]
    }
    if (parser.ENTITIES[entityLC]) {
      return parser.ENTITIES[entityLC]
    }
    entity = entityLC
    if (entity.charAt(0) === '#') {
      if (entity.charAt(1) === 'x') {
        entity = entity.slice(2)
        num = parseInt(entity, 16)
        numStr = num.toString(16)
      } else {
        entity = entity.slice(1)
        num = parseInt(entity, 10)
        numStr = num.toString(10)
      }
    }
    entity = entity.replace(/^0+/, '')
    if (isNaN(num) || numStr.toLowerCase() !== entity) {
      strictFail(parser, 'Invalid character entity')
      return '&' + parser.entity + ';'
    }

    return String.fromCodePoint(num)
  }

  function beginWhiteSpace (parser, c) {
    if (c === '<') {
      parser.state = S.OPEN_WAKA
      parser.startTagPosition = parser.position
    } else if (!isWhitespace(c)) {
      // have to process this as a text node.
      // weird, but happens.
      strictFail(parser, 'Non-whitespace before first tag.')
      parser.textNode = c
      parser.state = S.TEXT
    }
  }

  function charAt (chunk, i) {
    var result = ''
    if (i < chunk.length) {
      result = chunk.charAt(i)
    }
    return result
  }

  function write (chunk) {
    var parser = this
    if (this.error) {
      throw this.error
    }
    if (parser.closed) {
      return error(parser,
        'Cannot write after close. Assign an onready handler.')
    }
    if (chunk === null) {
      return end(parser)
    }
    if (typeof chunk === 'object') {
      chunk = chunk.toString()
    }
    var i = 0
    var c = ''
    while (true) {
      c = charAt(chunk, i++)
      parser.c = c

      if (!c) {
        break
      }

      if (parser.trackPosition) {
        parser.position++
        if (c === '\n') {
          parser.line++
          parser.column = 0
        } else {
          parser.column++
        }
      }

      switch (parser.state) {
        case S.BEGIN:
          parser.state = S.BEGIN_WHITESPACE
          if (c === '\uFEFF') {
            continue
          }
          beginWhiteSpace(parser, c)
          continue

        case S.BEGIN_WHITESPACE:
          beginWhiteSpace(parser, c)
          continue

        case S.TEXT:
          if (parser.sawRoot && !parser.closedRoot) {
            var starti = i - 1
            while (c && c !== '<' && c !== '&') {
              c = charAt(chunk, i++)
              if (c && parser.trackPosition) {
                parser.position++
                if (c === '\n') {
                  parser.line++
                  parser.column = 0
                } else {
                  parser.column++
                }
              }
            }
            parser.textNode += chunk.substring(starti, i - 1)
          }
          if (c === '<' && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
            parser.state = S.OPEN_WAKA
            parser.startTagPosition = parser.position
          } else {
            if (!isWhitespace(c) && (!parser.sawRoot || parser.closedRoot)) {
              strictFail(parser, 'Text data outside of root node.')
            }
            if (c === '&') {
              parser.state = S.TEXT_ENTITY
            } else {
              parser.textNode += c
            }
          }
          continue

        case S.SCRIPT:
          // only non-strict
          if (c === '<') {
            parser.state = S.SCRIPT_ENDING
          } else {
            parser.script += c
          }
          continue

        case S.SCRIPT_ENDING:
          if (c === '/') {
            parser.state = S.CLOSE_TAG
          } else {
            parser.script += '<' + c
            parser.state = S.SCRIPT
          }
          continue

        case S.OPEN_WAKA:
          // either a /, ?, !, or text is coming next.
          if (c === '!') {
            parser.state = S.SGML_DECL
            parser.sgmlDecl = ''
          } else if (isWhitespace(c)) {
            // wait for it...
          } else if (isMatch(nameStart, c)) {
            parser.state = S.OPEN_TAG
            parser.tagName = c
          } else if (c === '/') {
            parser.state = S.CLOSE_TAG
            parser.tagName = ''
          } else if (c === '?') {
            parser.state = S.PROC_INST
            parser.procInstName = parser.procInstBody = ''
          } else {
            strictFail(parser, 'Unencoded <')
            // if there was some whitespace, then add that in.
            if (parser.startTagPosition + 1 < parser.position) {
              var pad = parser.position - parser.startTagPosition
              c = new Array(pad).join(' ') + c
            }
            parser.textNode += '<' + c
            parser.state = S.TEXT
          }
          continue

        case S.SGML_DECL:
          if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
            emitNode(parser, 'onopencdata')
            parser.state = S.CDATA
            parser.sgmlDecl = ''
            parser.cdata = ''
          } else if (parser.sgmlDecl + c === '--') {
            parser.state = S.COMMENT
            parser.comment = ''
            parser.sgmlDecl = ''
          } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
            parser.state = S.DOCTYPE
            if (parser.doctype || parser.sawRoot) {
              strictFail(parser,
                'Inappropriately located doctype declaration')
            }
            parser.doctype = ''
            parser.sgmlDecl = ''
          } else if (c === '>') {
            emitNode(parser, 'onsgmldeclaration', parser.sgmlDecl)
            parser.sgmlDecl = ''
            parser.state = S.TEXT
          } else if (isQuote(c)) {
            parser.state = S.SGML_DECL_QUOTED
            parser.sgmlDecl += c
          } else {
            parser.sgmlDecl += c
          }
          continue

        case S.SGML_DECL_QUOTED:
          if (c === parser.q) {
            parser.state = S.SGML_DECL
            parser.q = ''
          }
          parser.sgmlDecl += c
          continue

        case S.DOCTYPE:
          if (c === '>') {
            parser.state = S.TEXT
            emitNode(parser, 'ondoctype', parser.doctype)
            parser.doctype = true // just remember that we saw it.
          } else {
            parser.doctype += c
            if (c === '[') {
              parser.state = S.DOCTYPE_DTD
            } else if (isQuote(c)) {
              parser.state = S.DOCTYPE_QUOTED
              parser.q = c
            }
          }
          continue

        case S.DOCTYPE_QUOTED:
          parser.doctype += c
          if (c === parser.q) {
            parser.q = ''
            parser.state = S.DOCTYPE
          }
          continue

        case S.DOCTYPE_DTD:
          parser.doctype += c
          if (c === ']') {
            parser.state = S.DOCTYPE
          } else if (isQuote(c)) {
            parser.state = S.DOCTYPE_DTD_QUOTED
            parser.q = c
          }
          continue

        case S.DOCTYPE_DTD_QUOTED:
          parser.doctype += c
          if (c === parser.q) {
            parser.state = S.DOCTYPE_DTD
            parser.q = ''
          }
          continue

        case S.COMMENT:
          if (c === '-') {
            parser.state = S.COMMENT_ENDING
          } else {
            parser.comment += c
          }
          continue

        case S.COMMENT_ENDING:
          if (c === '-') {
            parser.state = S.COMMENT_ENDED
            parser.comment = textopts(parser.opt, parser.comment)
            if (parser.comment) {
              emitNode(parser, 'oncomment', parser.comment)
            }
            parser.comment = ''
          } else {
            parser.comment += '-' + c
            parser.state = S.COMMENT
          }
          continue

        case S.COMMENT_ENDED:
          if (c !== '>') {
            strictFail(parser, 'Malformed comment')
            // allow <!-- blah -- bloo --> in non-strict mode,
            // which is a comment of " blah -- bloo "
            parser.comment += '--' + c
            parser.state = S.COMMENT
          } else {
            parser.state = S.TEXT
          }
          continue

        case S.CDATA:
          if (c === ']') {
            parser.state = S.CDATA_ENDING
          } else {
            parser.cdata += c
          }
          continue

        case S.CDATA_ENDING:
          if (c === ']') {
            parser.state = S.CDATA_ENDING_2
          } else {
            parser.cdata += ']' + c
            parser.state = S.CDATA
          }
          continue

        case S.CDATA_ENDING_2:
          if (c === '>') {
            if (parser.cdata) {
              emitNode(parser, 'oncdata', parser.cdata)
            }
            emitNode(parser, 'onclosecdata')
            parser.cdata = ''
            parser.state = S.TEXT
          } else if (c === ']') {
            parser.cdata += ']'
          } else {
            parser.cdata += ']]' + c
            parser.state = S.CDATA
          }
          continue

        case S.PROC_INST:
          if (c === '?') {
            parser.state = S.PROC_INST_ENDING
          } else if (isWhitespace(c)) {
            parser.state = S.PROC_INST_BODY
          } else {
            parser.procInstName += c
          }
          continue

        case S.PROC_INST_BODY:
          if (!parser.procInstBody && isWhitespace(c)) {
            continue
          } else if (c === '?') {
            parser.state = S.PROC_INST_ENDING
          } else {
            parser.procInstBody += c
          }
          continue

        case S.PROC_INST_ENDING:
          if (c === '>') {
            emitNode(parser, 'onprocessinginstruction', {
              name: parser.procInstName,
              body: parser.procInstBody
            })
            parser.procInstName = parser.procInstBody = ''
            parser.state = S.TEXT
          } else {
            parser.procInstBody += '?' + c
            parser.state = S.PROC_INST_BODY
          }
          continue

        case S.OPEN_TAG:
          if (isMatch(nameBody, c)) {
            parser.tagName += c
          } else {
            newTag(parser)
            if (c === '>') {
              openTag(parser)
            } else if (c === '/') {
              parser.state = S.OPEN_TAG_SLASH
            } else {
              if (!isWhitespace(c)) {
                strictFail(parser, 'Invalid character in tag name')
              }
              parser.state = S.ATTRIB
            }
          }
          continue

        case S.OPEN_TAG_SLASH:
          if (c === '>') {
            openTag(parser, true)
            closeTag(parser)
          } else {
            strictFail(parser, 'Forward-slash in opening tag not followed by >')
            parser.state = S.ATTRIB
          }
          continue

        case S.ATTRIB:
          // haven't read the attribute name yet.
          if (isWhitespace(c)) {
            continue
          } else if (c === '>') {
            openTag(parser)
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH
          } else if (isMatch(nameStart, c)) {
            parser.attribName = c
            parser.attribValue = ''
            parser.state = S.ATTRIB_NAME
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_NAME:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE
          } else if (c === '>') {
            strictFail(parser, 'Attribute without value')
            parser.attribValue = parser.attribName
            attrib(parser)
            openTag(parser)
          } else if (isWhitespace(c)) {
            parser.state = S.ATTRIB_NAME_SAW_WHITE
          } else if (isMatch(nameBody, c)) {
            parser.attribName += c
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_NAME_SAW_WHITE:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE
          } else if (isWhitespace(c)) {
            continue
          } else {
            strictFail(parser, 'Attribute without value')
            parser.tag.attributes[parser.attribName] = ''
            parser.attribValue = ''
            emitNode(parser, 'onattribute', {
              name: parser.attribName,
              value: ''
            })
            parser.attribName = ''
            if (c === '>') {
              openTag(parser)
            } else if (isMatch(nameStart, c)) {
              parser.attribName = c
              parser.state = S.ATTRIB_NAME
            } else {
              strictFail(parser, 'Invalid attribute name')
              parser.state = S.ATTRIB
            }
          }
          continue

        case S.ATTRIB_VALUE:
          if (isWhitespace(c)) {
            continue
          } else if (isQuote(c)) {
            parser.q = c
            parser.state = S.ATTRIB_VALUE_QUOTED
          } else {
            strictFail(parser, 'Unquoted attribute value')
            parser.state = S.ATTRIB_VALUE_UNQUOTED
            parser.attribValue = c
          }
          continue

        case S.ATTRIB_VALUE_QUOTED:
          if (c !== parser.q) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_Q
            } else {
              parser.attribValue += c
            }
            continue
          }
          attrib(parser)
          parser.q = ''
          parser.state = S.ATTRIB_VALUE_CLOSED
          continue

        case S.ATTRIB_VALUE_CLOSED:
          if (isWhitespace(c)) {
            parser.state = S.ATTRIB
          } else if (c === '>') {
            openTag(parser)
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH
          } else if (isMatch(nameStart, c)) {
            strictFail(parser, 'No whitespace between attributes')
            parser.attribName = c
            parser.attribValue = ''
            parser.state = S.ATTRIB_NAME
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_VALUE_UNQUOTED:
          if (!isAttribEnd(c)) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_U
            } else {
              parser.attribValue += c
            }
            continue
          }
          attrib(parser)
          if (c === '>') {
            openTag(parser)
          } else {
            parser.state = S.ATTRIB
          }
          continue

        case S.CLOSE_TAG:
          if (!parser.tagName) {
            if (isWhitespace(c)) {
              continue
            } else if (notMatch(nameStart, c)) {
              if (parser.script) {
                parser.script += '</' + c
                parser.state = S.SCRIPT
              } else {
                strictFail(parser, 'Invalid tagname in closing tag.')
              }
            } else {
              parser.tagName = c
            }
          } else if (c === '>') {
            closeTag(parser)
          } else if (isMatch(nameBody, c)) {
            parser.tagName += c
          } else if (parser.script) {
            parser.script += '</' + parser.tagName
            parser.tagName = ''
            parser.state = S.SCRIPT
          } else {
            if (!isWhitespace(c)) {
              strictFail(parser, 'Invalid tagname in closing tag')
            }
            parser.state = S.CLOSE_TAG_SAW_WHITE
          }
          continue

        case S.CLOSE_TAG_SAW_WHITE:
          if (isWhitespace(c)) {
            continue
          }
          if (c === '>') {
            closeTag(parser)
          } else {
            strictFail(parser, 'Invalid characters in closing tag')
          }
          continue

        case S.TEXT_ENTITY:
        case S.ATTRIB_VALUE_ENTITY_Q:
        case S.ATTRIB_VALUE_ENTITY_U:
          var returnState
          var buffer
          switch (parser.state) {
            case S.TEXT_ENTITY:
              returnState = S.TEXT
              buffer = 'textNode'
              break

            case S.ATTRIB_VALUE_ENTITY_Q:
              returnState = S.ATTRIB_VALUE_QUOTED
              buffer = 'attribValue'
              break

            case S.ATTRIB_VALUE_ENTITY_U:
              returnState = S.ATTRIB_VALUE_UNQUOTED
              buffer = 'attribValue'
              break
          }

          if (c === ';') {
            parser[buffer] += parseEntity(parser)
            parser.entity = ''
            parser.state = returnState
          } else if (isMatch(parser.entity.length ? entityBody : entityStart, c)) {
            parser.entity += c
          } else {
            strictFail(parser, 'Invalid character in entity name')
            parser[buffer] += '&' + parser.entity + c
            parser.entity = ''
            parser.state = returnState
          }

          continue

        default:
          throw new Error(parser, 'Unknown state: ' + parser.state)
      }
    } // while

    if (parser.position >= parser.bufferCheckPosition) {
      checkBufferLength(parser)
    }
    return parser
  }

  /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
  /* istanbul ignore next */
  if (!String.fromCodePoint) {
    (function () {
      var stringFromCharCode = String.fromCharCode
      var floor = Math.floor
      var fromCodePoint = function () {
        var MAX_SIZE = 0x4000
        var codeUnits = []
        var highSurrogate
        var lowSurrogate
        var index = -1
        var length = arguments.length
        if (!length) {
          return ''
        }
        var result = ''
        while (++index < length) {
          var codePoint = Number(arguments[index])
          if (
            !isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
            codePoint < 0 || // not a valid Unicode code point
            codePoint > 0x10FFFF || // not a valid Unicode code point
            floor(codePoint) !== codePoint // not an integer
          ) {
            throw RangeError('Invalid code point: ' + codePoint)
          }
          if (codePoint <= 0xFFFF) { // BMP code point
            codeUnits.push(codePoint)
          } else { // Astral code point; split in surrogate halves
            // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            codePoint -= 0x10000
            highSurrogate = (codePoint >> 10) + 0xD800
            lowSurrogate = (codePoint % 0x400) + 0xDC00
            codeUnits.push(highSurrogate, lowSurrogate)
          }
          if (index + 1 === length || codeUnits.length > MAX_SIZE) {
            result += stringFromCharCode.apply(null, codeUnits)
            codeUnits.length = 0
          }
        }
        return result
      }
      /* istanbul ignore next */
      if (Object.defineProperty) {
        Object.defineProperty(String, 'fromCodePoint', {
          value: fromCodePoint,
          configurable: true,
          writable: true
        })
      } else {
        String.fromCodePoint = fromCodePoint
      }
    }())
  }
})(typeof exports === 'undefined' ? this.sax = {} : exports)

}).call(this,require("buffer").Buffer)

},{"buffer":77,"stream":236,"string_decoder":237}],227:[function(require,module,exports){
(function (setImmediate){
'use strict';
module.exports = typeof setImmediate === 'function' ? setImmediate :
	function setImmediate() {
		var args = [].slice.apply(arguments);
		args.splice(1, 0, 0);
		setTimeout.apply(null, args);
	};

}).call(this,require("timers").setImmediate)

},{"timers":238}],228:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash

},{"safe-buffer":225}],229:[function(require,module,exports){
var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = require('./sha')
exports.sha1 = require('./sha1')
exports.sha224 = require('./sha224')
exports.sha256 = require('./sha256')
exports.sha384 = require('./sha384')
exports.sha512 = require('./sha512')

},{"./sha":230,"./sha1":231,"./sha224":232,"./sha256":233,"./sha384":234,"./sha512":235}],230:[function(require,module,exports){
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = require('inherits')
var Hash = require('./hash')
var Buffer = require('safe-buffer').Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha

},{"./hash":228,"inherits":131,"safe-buffer":225}],231:[function(require,module,exports){
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = require('inherits')
var Hash = require('./hash')
var Buffer = require('safe-buffer').Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1

},{"./hash":228,"inherits":131,"safe-buffer":225}],232:[function(require,module,exports){
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = require('inherits')
var Sha256 = require('./sha256')
var Hash = require('./hash')
var Buffer = require('safe-buffer').Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224

},{"./hash":228,"./sha256":233,"inherits":131,"safe-buffer":225}],233:[function(require,module,exports){
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = require('inherits')
var Hash = require('./hash')
var Buffer = require('safe-buffer').Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256

},{"./hash":228,"inherits":131,"safe-buffer":225}],234:[function(require,module,exports){
var inherits = require('inherits')
var SHA512 = require('./sha512')
var Hash = require('./hash')
var Buffer = require('safe-buffer').Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384

},{"./hash":228,"./sha512":235,"inherits":131,"safe-buffer":225}],235:[function(require,module,exports){
var inherits = require('inherits')
var Hash = require('./hash')
var Buffer = require('safe-buffer').Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512

},{"./hash":228,"inherits":131,"safe-buffer":225}],236:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = require('events').EventEmitter;
var inherits = require('inherits');

inherits(Stream, EE);
Stream.Readable = require('readable-stream/readable.js');
Stream.Writable = require('readable-stream/writable.js');
Stream.Duplex = require('readable-stream/duplex.js');
Stream.Transform = require('readable-stream/transform.js');
Stream.PassThrough = require('readable-stream/passthrough.js');

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};

},{"events":113,"inherits":131,"readable-stream/duplex.js":211,"readable-stream/passthrough.js":220,"readable-stream/readable.js":221,"readable-stream/transform.js":222,"readable-stream/writable.js":223}],237:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}
},{"safe-buffer":225}],238:[function(require,module,exports){
(function (setImmediate,clearImmediate){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this,require("timers").setImmediate,require("timers").clearImmediate)

},{"process/browser.js":202,"timers":238}],239:[function(require,module,exports){
(function (global){

/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],240:[function(require,module,exports){
var indexOf = function (xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for (var i = 0; i < xs.length; i++) {
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    if (context) {
        forEach(Object_keys(ctx), function (key) {
            context[key] = ctx[key];
        });
    }

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.isContext = function (context) {
    return context instanceof Context;
};

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};

},{}]},{},[20])(20)
});

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);


/* harmony default export */ __webpack_exports__["a"] = ({
  getList: function getList(VueApp, callback) {
    var pricing = VueApp.$store.state.pricing;
    var serviceArea = pricing.serviceArea;
    VueApp.$sdk.get('/servicearea', {
      token: VueApp.$store.state.session.sessionToken,
      brandId: pricing.brandId,
      status: 'active',
      order: 'priority',
      orderAsc: serviceArea.orderAsc,
      pageNum: 1,
      pageSize: 9999
    }, function (res) {
      if (!res.error) {
        // VueApp.$store.commit('pricing/setServiceAreaMaxList', res.paging.totalItems)
        if (res.list.length) {
          var _serviceArea = [];
          for (var i = 0; i < res.list.length; i++) {
            var data = res.list[i];
            _serviceArea.push({
              id: data.id,
              name: data.name,
              color: data.color,
              isMTechPricing: data.isMTechPricing || false
            });
          }

          VueApp.$store.commit('pricing/setServiceAreaList', _serviceArea);
        }
      }
      callback(res);
    }, '2.0');
  },
  toggleEnable: function toggleEnable(VueApp, data, callback) {
    VueApp.$sdk.post('/servicearea/' + data.serviceAreaId + '/pricing', {
      token: VueApp.$store.state.session.sessionToken,
      services: [{
        serviceTypeId: data.id,
        enabled: data.enable
      }]
    }, function (res) {
      if (!res.error) {
        VueApp.$store.commit('pricing/updateServiceTypeEnable', {
          id: data.id,
          field: 'enabled',
          value: data.enable
        });
      }
      callback(res);
    }, '2.0');
  },
  getServiceAreaData: function getServiceAreaData(VueApp, id, callback) {
    var self = this;

    // Reset all service data
    var brandId = VueApp.$store.state.pricing.brandId;
    var services = VueApp.$store.state.pricing.serviceTypes.list.filter(function (x) {
      return x.brandId === brandId && x.brandEnabled;
    });
    for (var service in services) {
      var temp = self.buildFreshData(services[service]);
      VueApp.$store.commit('pricing/updateServiceTypeData', temp);
    }

    VueApp.$sdk.get('/servicearea/' + id + '/pricing', {
      token: VueApp.$store.state.session.sessionToken,
      pageNum: 1,
      pageSize: 999
    }, function (res) {
      if (!res.error) {
        if (res.list.length) {
          for (var i = 0; i < res.list.length; i++) {
            VueApp.$store.commit('pricing/updateServiceTypeData', self.buildServiceTypeData(VueApp, res.list[i]));
          }

          var idsToRemove = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(res.list.map(function (item) {
            return item.serviceTypeId;
          }));
          var result = services.filter(function (item) {
            return !idsToRemove.has(item.id);
          });
          self.buildDefaultServiceData(VueApp, result);
        }
      }
      callback(res);
    }, '2.0');
  },
  buildDefaultServiceData: function buildDefaultServiceData(VueApp, result) {
    result.forEach(function (x) {
      x.asap = {
        airportFee: 0,
        discountAdmin: true,
        discountAmount: 0,
        discountApp: true,
        discountCSR: true,
        discountEnd: null,
        discountStart: null,
        discountType: "$",
        discountWidget: true,
        fare: 0,
        flat2paxFee: 0,
        flatNpaxFee: 0,
        gasFee: 0,
        holidayDate: null,
        holidayDate2: null,
        holidayDate3: null,
        holidayDate4: null,
        holidayDate5: null,
        holidayDate6: null,
        holidayDate7: null,
        holidayDate8: null,
        holidayDate9: null,
        holidayDate10: null,
        holidayRateAmount: 0,
        holidayRateType: "$",
        mileageRate: 0,
        mileageThreshold: 0,
        pickupInstructions: null,
        prov2paxFee: 0,
        provBaseFee: 0,
        provBonus: 0,
        provDiscountRate: 0,
        provMileage: 0,
        provNpaxFee: 0,
        roundtripAmount: 0,
        roundtripType: "$",
        travelInsurance: 0
      };
      x.future = {
        airportFee: 0,
        discountAdmin: true,
        discountAmount: 0,
        discountApp: true,
        discountCSR: true,
        discountEnd: null,
        discountStart: null,
        discountType: "$",
        discountWidget: true,
        fare: 0,
        flat2paxFee: 0,
        flatNpaxFee: 0,
        gasFee: 0,
        holidayDate: null,
        holidayDate2: null,
        holidayDate3: null,
        holidayDate4: null,
        holidayDate5: null,
        holidayDate6: null,
        holidayDate7: null,
        holidayDate8: null,
        holidayDate9: null,
        holidayDate10: null,
        holidayRateAmount: 0,
        holidayRateType: "$",
        mileageRate: 0,
        mileageThreshold: 0,
        pickupInstructions: null,
        prov2paxFee: 0,
        provBaseFee: 0,
        provBonus: 0,
        provDiscountRate: 0,
        provMileage: 0,
        provNpaxFee: 0,
        roundtripAmount: 0,
        roundtripType: "$",
        travelInsurance: 0
      };
      x.flight = {
        onewayRate: null,
        onewayType: "$",
        roundtripRate: null,
        roundtripType: "$"
      };
      x.pickupTypes = {
        Curbside: { name: "Curbside", fee: 0, enabled: true },
        MeetAndGreet: { name: "MeetAndGreet", fee: 0, enabled: false }
      };
      x.rental = {
        rentFare: null,
        rentRate: null,
        rentRateDaily: null,
        rentRateWeekend: null
      };
      x.serviceTypeId = x.id;
      VueApp.$store.commit('pricing/updateServiceTypeData', x);
    });
  },
  setGlobalData: function setGlobalData(VueApp, callback) {
    var serviceTypes = VueApp.$store.state.pricing.serviceTypes.list.filter(function (serviceType) {
      return serviceType.brandId === VueApp.$store.state.pricing.brandId;
    });
    for (var service in serviceTypes) {
      var serviceType = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, serviceTypes[service]);

      delete serviceType.serviceTypeId;
      // delete serviceType.enabled
      serviceType.enabled = true;
      serviceType.future = {
        travelInsurance: '',
        airportFee: '',
        discountAmount: '',
        discountType: '',
        fare: '',
        flat2paxFee: '',
        flatNpaxFee: '',
        holidayRateAmount: '',
        holidayRateType: '',
        mileageRate: '',
        mileageThreshold: '',
        prov2paxFee: '',
        provBaseFee: '',
        provBonus: '',
        provDiscountRate: '',
        provMileage: '',
        provNpaxFee: '',
        roundtripAmount: '',
        roundtripType: '',
        discountStart: '',
        discountEnd: '',
        holidayDate: '',
        gasFee: '',
        portalFee: '',
        portalFeeType: ''
      };
      serviceType.flight = {
        onewayType: '',
        onewayRate: '',
        roundtripType: '',
        roundtripRate: ''
      };
      serviceType.rental = {
        rentFare: '',
        rentRate: '',
        rentRateDaily: '',
        rentRateWeekend: ''
      };
      serviceType.asap = {
        travelInsurance: '',
        airportFee: '',
        mileageRate: '',
        fare: '',
        mileageThreshold: '',
        flat2paxFee: '',
        flatNpaxFee: '',
        discountType: '',
        discountAmount: '',
        roundtripType: '',
        roundtripAmount: '',
        discountStart: '',
        discountEnd: '',
        provMileage: '',
        provBaseFee: '',
        provBonus: '',
        prov2paxFee: '',
        provNpaxFee: '',
        provDiscountRate: '',
        holidayRateType: '',
        holidayRateAmount: '',
        holidayDate: '',
        gasFee: '',
        portalFee: '',
        portalFeeType: ''
      };
      serviceType.charter = {
        fare: '',
        minuteRate: '',
        provBase: '',
        provDiscount: '',
        provRate: '',
        portalFee: '',
        portalFeeType: ''
      };

      serviceType.pickupTypes = {
        Curbside: { name: 'Curbside', fee: '', enabled: '' },
        MeetAndGreet: { name: 'MeetAndGreet', fee: '', enabled: '' }
      };

      for (var i = 1; i < 10; i++) {
        VueApp.$store.commit('pricing/setHolidayData', {
          type: 'asap',
          index: i + 1,
          value: ''
        });
        VueApp.$store.commit('pricing/setHolidayData', {
          type: 'future',
          index: i + 1,
          value: ''
        });
        VueApp.$store.commit('pricing/setCharterHolidayData', {
          index: i + 1,
          value: ''
        });
      }

      VueApp.$store.commit('pricing/updateServiceTypeData', serviceType);
    }
    callback(1);
  },
  buildServiceTypeData: function buildServiceTypeData(VueApp, data) {
    var serviceTypes = VueApp.$store.state.pricing.serviceTypes.list;
    var index = serviceTypes.findIndex(function (x) {
      return x.id === data.serviceTypeId;
    });
    var serviceType = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, serviceTypes[index]);

    serviceType.serviceTypeId = data.serviceType.id;
    serviceType.enabled = data.enabled;
    serviceType.future = data.future;
    serviceType.asap = data.asap;
    serviceType.flight = data.flight;
    serviceType.rental = data.rental;
    for (var x in data.asap) {
      if (data.asap[x] === null) {
        serviceType.asap[x] = data.future[x];
      }
    }
    serviceType.discountStart = null;
    serviceType.discountEnd = null;
    serviceType.discountWidget = data.future.discountWidget;
    serviceType.discountAdmin = data.future.discountAdmin;
    serviceType.discountApp = data.future.discountApp;
    serviceType.discountCSR = data.future.discountCSR;
    serviceType.holidayDate = null;
    serviceType.holidayDate2 = null;
    serviceType.holidayDate3 = null;
    serviceType.holidayDate4 = null;
    serviceType.holidayDate5 = null;
    serviceType.holidayDate6 = null;
    serviceType.holidayDate7 = null;
    serviceType.holidayDate8 = null;
    serviceType.holidayDate9 = null;
    serviceType.holidayDate10 = null;
    serviceType.asapDiscountStart = null;
    serviceType.asapDiscountEnd = null;
    serviceType.asapDiscountWidget = data.asap.discountWidget;
    serviceType.asapDiscountAdmin = data.asap.discountAdmin;
    serviceType.asapDiscountApp = data.asap.discountApp;
    serviceType.asapDiscountCSR = data.asap.discountCSR;
    serviceType.asapHolidayDate = null;
    serviceType.asapHolidayDate2 = null;
    serviceType.asapHolidayDate3 = null;
    serviceType.asapHolidayDate4 = null;
    serviceType.asapHolidayDate5 = null;
    serviceType.asapHolidayDate6 = null;
    serviceType.asapHolidayDate7 = null;
    serviceType.asapHolidayDate8 = null;
    serviceType.asapHolidayDate9 = null;
    serviceType.asapHolidayDate10 = null;
    if (data.future && data.future.discountStart) serviceType.discountStart = data.future.discountStart;
    if (data.future && data.future.discountEnd) serviceType.discountEnd = data.future.discountEnd;
    if (data.future && data.future.holidayDate) serviceType.holidayDate = data.future.holidayDate;
    serviceType.holidayDate2 = data.future.holidayDate2 || null;
    serviceType.holidayDate3 = data.future.holidayDate3 || null;
    serviceType.holidayDate4 = data.future.holidayDate4 || null;
    serviceType.holidayDate5 = data.future.holidayDate5 || null;
    serviceType.holidayDate6 = data.future.holidayDate6 || null;
    serviceType.holidayDate7 = data.future.holidayDate7 || null;
    serviceType.holidayDate8 = data.future.holidayDate8 || null;
    serviceType.holidayDate9 = data.future.holidayDate9 || null;
    serviceType.holidayDate10 = data.future.holidayDate10 || null;
    if (data.asap && data.asap.discountStart) serviceType.asapDiscountStart = data.asap.discountStart;
    if (data.asap && data.asap.discountEnd) serviceType.asapDiscountEnd = data.asap.discountEnd;
    if (data.asap && data.asap.holidayDate) serviceType.asapHolidayDate = data.asap.holidayDate;
    serviceType.asapHolidayDate2 = data.asap.holidayDate2 || null;
    serviceType.asapHolidayDate3 = data.asap.holidayDate3 || null;
    serviceType.asapHolidayDate4 = data.asap.holidayDate4 || null;
    serviceType.asapHolidayDate5 = data.asap.holidayDate5 || null;
    serviceType.asapHolidayDate6 = data.asap.holidayDate6 || null;
    serviceType.asapHolidayDate7 = data.asap.holidayDate7 || null;
    serviceType.asapHolidayDate8 = data.asap.holidayDate8 || null;
    serviceType.asapHolidayDate9 = data.asap.holidayDate9 || null;
    serviceType.asapHolidayDate10 = data.asap.holidayDate10 || null;

    var pickupTypes = {};
    if (data.pickupTypes && data.pickupTypes.length > 0) {
      data.pickupTypes.forEach(function (pickupType) {
        pickupTypes[pickupType.name] = pickupType;
      });
    } else {
      pickupTypes = {
        Curbside: { name: 'Curbside', fee: 0, enabled: false },
        MeetAndGreet: { name: 'MeetAndGreet', fee: 0, enabled: false }
      };
    }
    serviceType.pickupTypes = pickupTypes;
    serviceType.brandEnabled = data.serviceType.enabled;
    serviceType.isShared = data.serviceType.isShared === 1;

    if (data.serviceType.isCharter) {
      serviceType.charter = {
        // airportFee: data.future.airportFee || '',
        fare: data.charter.fare,
        minuteRate: data.charter.minuteRate,
        // discountAmount: data.future.discountAmount || '',
        provBase: data.charter.provBase,
        provDiscount: data.charter.provDiscount,
        provRate: data.charter.provRate,
        portalFee: data.future.portalFee || '',
        portalFeeType: data.future.portalFeeType || ''
      };
    }

    serviceType.flight = {};
    if (data.flight) {
      if (data.flight.oneway) {
        serviceType.flight.onewayType = data.flight.oneway.type || null;
        serviceType.flight.onewayRate = data.flight.oneway.rate || null;
      }
      if (data.flight.roundtrip) {
        serviceType.flight.roundtripType = data.flight.roundtrip.type || null;
        serviceType.flight.roundtripRate = data.flight.roundtrip.rate || null;
      }
    }

    return serviceType;
  },
  buildFreshData: function buildFreshData(data) {
    data.enabled = false;
    data.travelInsurance = 0;
    data.airportFee = 0;
    data.gasFee = 0;
    data.discountAmount = 0;
    data.discountType = '$';
    data.fare = 0;
    data.flat2paxFee = 0;
    data.flatNpaxFee = 0;
    data.holidayRateAmount = 0;
    data.holidayRateType = '$';
    data.mileageRate = 0;
    data.mileageThreshold = 0;
    data.prov2paxFee = 0;
    data.provBaseFee = 0;
    data.provBonus = 0;
    data.provDiscountRate = 0;
    data.provMileage = 0;
    data.provNpaxFee = 0;
    data.roundtripAmount = 0;
    data.roundtripType = '$';
    data.discountStart = '';
    data.discountEnd = '';
    data.holidayDate = '';

    return data;
  }
});

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(36);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Promo_vue__ = __webpack_require__(545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f7ede68_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Promo_vue__ = __webpack_require__(1560);
function injectStyle (ssrContext) {
  __webpack_require__(1558)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f7ede68"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Promo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f7ede68_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Promo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import moment from 'moment'

/* harmony default export */ __webpack_exports__["a"] = ({
  getSubgeofences: function getSubgeofences(VueApp, id, callback) {
    VueApp.$sdk.get('/airports/' + id + '/subgeofences', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      if (!res.error) {
        // set StagingLots Data
        var stagingData = [];
        res.staging.forEach(function (data) {
          stagingData.push({ id: data.id, name: data.name });
        });
        VueApp.$store.commit('geofences/setAirportSubgeofence', {
          field: 'stagingLots',
          id: id,
          value: stagingData
        });

        // set RestrictedArea Data
        var restrictedData = [];
        res.restricted.forEach(function (data) {
          restrictedData.push({ id: data.id, name: data.name });
        });
        VueApp.$store.commit('geofences/setAirportSubgeofence', {
          field: 'restrictedAreas',
          id: id,
          value: restrictedData
        });

        // set ServiceArea Data
        var serviceData = [];
        res.restricted.forEach(function (data) {
          serviceData.push({ id: data.id, name: data.name });
        });
        VueApp.$store.commit('geofences/setAirportSubgeofence', {
          field: 'serviceAreas',
          id: id,
          value: serviceData
        });
      }
      callback(res);
    });
  },
  updateSubGeofence: function updateSubGeofence(VueApp, data, callback) {
    VueApp.$sdk.post('/airports/' + data.id + '/subgeofences', {
      token: VueApp.$store.state.session.sessionToken,
      priority: data.priority
    }, function (res) {
      callback(res);
    });
  },
  addSubGeofence: function addSubGeofence(VueApp, data, callback) {
    VueApp.$sdk.post('/airports/' + data.id + '/subgeofences/' + data.subID, {
      token: VueApp.$store.state.session.sessionToken,
      priority: data.priority
    }, function (res) {
      callback(res);
    });
  },
  removeSubGeofence: function removeSubGeofence(VueApp, data, callback) {
    VueApp.$sdk.delete('/airports/' + data.id + '/subgeofences/' + data.subID, {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      callback(res);
    });
  }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getAccount: function getAccount(VueApp, driverId, callback) {
    VueApp.$sdk.get('/provider/' + driverId + '/account', {
      token: VueApp.$store.state.session.sessionToken
    }, callback);
  },
  getTransactions: function getTransactions(VueApp, request, callback) {
    VueApp.$sdk.get('/admin/prov/transaction', request, callback);
  },
  updateTransaction: function updateTransaction(VueApp, trxId, request, callback) {
    VueApp.$sdk.post('/admin/prov/transaction/' + trxId, request, callback);
  },
  createTransaction: function createTransaction(VueApp, provId, request, callback) {
    VueApp.$sdk.post('/admin/prov/' + provId + '/transaction', request, callback);
  },
  getBalance: function getBalance(VueApp, request, callback) {
    VueApp.$sdk.get('/admin/balance', request, callback);
  },
  getTotal: function getTotal(VueApp, request, callback) {
    VueApp.$sdk.get('/admin/prov/batch/total', request, callback);
  },
  createTopup: function createTopup(VueApp, request, callback) {
    VueApp.$sdk.post('/admin/balance', request, callback);
  },
  startAutodeposit: function startAutodeposit(VueApp, request, callback) {
    VueApp.$sdk.post('/admin/autodeposit', request, callback);
  },
  getProviderBatch: function getProviderBatch(VueApp, request, callback) {
    VueApp.$sdk.get('/admin/prov/batch', request, callback);
  },
  updateBatch: function updateBatch(VueApp, batchId, request, callback) {
    VueApp.$sdk.post('/admin/prov/batch/' + batchId, request, callback);
  }
});

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = {
  USD: "$",
  CAD: "CA$",
  EUR: "€",
  AED: "AED",
  AFN: "Af",
  ALL: "ALL",
  AMD: "AMD",
  ARS: "AR$",
  AUD: "AU$",
  AZN: "man.",
  BAM: "KM",
  BDT: "Tk",
  BGN: "BGN",
  BHD: "BD",
  BIF: "FBu",
  BND: "BN$",
  BOB: "Bs",
  BRL: "R$",
  BWP: "BWP",
  BYN: "Br",
  BZD: "BZ$",
  CDF: "CDF",
  CHF: "CHF",
  CLP: "CL$",
  CNY: "CN¥",
  COP: "CO$",
  CRC: "₡",
  CVE: "CV$",
  CZK: "Kč",
  DJF: "Fdj",
  DKK: "Dkr",
  DOP: "RD$",
  DZD: "DA",
  EEK: "Ekr",
  EGP: "EGP",
  ERN: "Nfk",
  ETB: "Br",
  GBP: "£",
  GEL: "GEL",
  GHS: "GH₵",
  GNF: "FG",
  GTQ: "GTQ",
  HKD: "HK$",
  HNL: "HNL",
  HRK: "kn",
  HUF: "Ft",
  IDR: "Rp",
  ILS: "₪",
  INR: "₹",
  IQD: "IQD",
  IRR: "IRR",
  ISK: "Ikr",
  JMD: "J$",
  JOD: "JD",
  JPY: "¥",
  KES: "Ksh",
  KHR: "KHR",
  KMF: "CF",
  KRW: "₩",
  KWD: "KD",
  KZT: "KZT",
  LBP: "L.L.",
  LKR: "SLRs",
  LTL: "Lt",
  LVL: "Ls",
  LYD: "LD",
  MAD: "MAD",
  MDL: "MDL",
  MGA: "MGA",
  MKD: "MKD",
  MMK: "MMK",
  MOP: "MOP$",
  MUR: "MURs",
  MXN: "MX$",
  MYR: "RM",
  MZN: "MTn",
  NAD: "N$",
  NGN: "₦",
  NIO: "C$",
  NOK: "Nkr",
  NPR: "NPRs",
  NZD: "NZ$",
  OMR: "OMR",
  PAB: "B/.",
  PEN: "S/.",
  PHP: "₱",
  PKR: "PKRs",
  PLN: "zł",
  PYG: "₲",
  QAR: "QR",
  RON: "RON",
  RSD: "din.",
  RUB: "RUB",
  RWF: "RWF",
  SAR: "SR",
  SDG: "SDG",
  SEK: "Skr",
  SGD: "S$",
  SOS: "Ssh",
  SYP: "SY£",
  THB: "฿",
  TND: "DT",
  TOP: "T$",
  TRY: "TL",
  TTD: "TT$",
  TWD: "NT$",
  TZS: "TSh",
  UAH: "₴",
  UGX: "USh",
  UYU: "$U",
  UZS: "UZS",
  VEF: "Bs.F.",
  VND: "₫",
  XAF: "FCFA",
  XOF: "CFA",
  YER: "YR",
  ZAR: "R",
  ZMK: "ZK",
  ZWL: "ZWL$"
};

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* global CONFIG */
var request = __webpack_require__(13);

/* harmony default export */ __webpack_exports__["a"] = ({
  getTimezone: function getTimezone(VueApp, data, callback) {
    var url2 = 'https://revgeocode.search.hereapi.com/v1/revgeocode?at={AT}&lang=en-US&apiKey={API_KEY}&show=tz';
    url2 = url2.replace('{AT}', encodeURIComponent(data.lat + ',' + data.lng)).replace('{API_KEY}', {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key);
    request.get({
      url: url2,
      json: true
    }, function (err, res, body) {
      if (err) {
        console.log(err);
      }
      if (body.items.length) {
        callback(body.items[0].timeZone.name);
      }
    });
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_currency_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_currency_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_currency_js__);


/* harmony default export */ __webpack_exports__["a"] = ({
  // format (data) {
  //   let currency = new Intl.NumberFormat('en-US', {
  //     style: 'currency',
  //     currency: 'USD',
  //   })
  //   if (data.code === 'INR') {
  //     currency = new Intl.NumberFormat('en-IN', {
  //       style: 'currency',
  //       currency: 'INR',
  //     })
  //   }
  //   return currency.format(data.val)
  // }
  format: function format(data) {
    var useSymbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var locale = 'en-US';
    var options = {
      style: 'currency',
      currency: data.code,
      currencyDisplay: 'code'
    };

    var currency = new Intl.NumberFormat(locale, options);
    var newVal = currency.format(data.val).replace(data.code, "").trim();
    return useSymbol ? '' + __WEBPACK_IMPORTED_MODULE_0__data_currency_js___default.a[data.code] + newVal : newVal;
  }
});

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(29) && !__webpack_require__(53)(function () {
  return Object.defineProperty(__webpack_require__(113)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(54);
var toIObject = __webpack_require__(55);
var arrayIndexOf = __webpack_require__(700)(false);
var IE_PROTO = __webpack_require__(118)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CountryCodeModal__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FlightInformationModal__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PhoneApp__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ReservationNotesModal__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SideMenu__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SessionLoader__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Search__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Loader__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Alert__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ReasonModal__ = __webpack_require__(858);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    CountryCodeModal: __WEBPACK_IMPORTED_MODULE_0__CountryCodeModal__["a" /* default */], FlightInformationModal: __WEBPACK_IMPORTED_MODULE_1__FlightInformationModal__["a" /* default */], PhoneApp: __WEBPACK_IMPORTED_MODULE_2__PhoneApp__["a" /* default */],
    ReservationNotesModal: __WEBPACK_IMPORTED_MODULE_3__ReservationNotesModal__["a" /* default */], SideMenu: __WEBPACK_IMPORTED_MODULE_4__SideMenu__["a" /* default */], SessionLoader: __WEBPACK_IMPORTED_MODULE_5__SessionLoader__["a" /* default */], Search: __WEBPACK_IMPORTED_MODULE_6__Search__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_7__Loader__["a" /* default */], Alert: __WEBPACK_IMPORTED_MODULE_8__Alert__["a" /* default */], ReasonModal: __WEBPACK_IMPORTED_MODULE_9__ReasonModal__["a" /* default */]
  },
  computed: {
    displaySearch: function displaySearch() {
      if (['Login', 'ProviderPrintPlacard', 'PasswordReset', 'PasswordResetDriver'].indexOf(this.$route.name) > -1) return false;else return this.$store.state.searchGlobal.enable;
    },
    store: function store() {
      return this.$store.state;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$plugins.fcm.init({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.Firebase);
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_country_data__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_country_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_country_data__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var countryData = __webpack_require__(90);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'country-code-modal',
  data: function data() {
    return {
      searchString: '',
      countryOnly: this.$store.state.countryCode.countryOnly
    };
  },

  computed: {
    countryList: {
      get: function get() {
        return this.$store.state.countryCode.countryList;
      },
      set: function set(value) {
        this.$store.commit('countryCode/setCountryList', value);
      }
    },
    showModal: function showModal() {
      return this.$store.state.countryCode.countryModal;
    }
  },
  methods: {
    closeModal: function closeModal() {
      this.searchString = '';
      this.sortCountries();
      this.$store.commit('countryCode/setCountryModal', false);
    },
    filter: function filter() {
      var queryString = this.searchString;
      if (queryString === '') {
        this.sortCountries();
        return;
      }

      var regex = new RegExp('^' + queryString, 'i');
      var result = [];
      var allCountries = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(countryData);

      for (var i = 0; i < allCountries.length; i++) {
        if (!regex.test(allCountries[i].name)) {
          continue;
        }

        result.push(allCountries[i]);
      }

      this.countryList = result;
    },
    selectCountry: function selectCountry(index) {
      var country = this.countryList[index];
      this.$store.commit('countryCode/setCountryName', country.name);
      this.$store.commit('countryCode/setCountryAlias', country.code);
      this.$store.commit('countryCode/setCallingCode', country.dialCode);
      this.closeModal();
    },
    sortCountries: function sortCountries() {
      var country = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(countryData);
      var displayCountry = [];
      country = country.sort(function (a, b) {
        return a.name > b.name ? 1 : -1;
      });

      var topCountries = ['us', 'ca', 'gb'];
      topCountries.forEach(function (x) {
        displayCountry.push.apply(displayCountry, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(country.filter(function (y) {
          return y.code === x;
        })));
      });
      topCountries.forEach(function (x) {
        country = country.filter(function (y) {
          return y.code !== x;
        });
      });
      displayCountry.push.apply(displayCountry, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(country));

      this.countryList = displayCountry;
    }
  },
  mounted: function mounted() {
    this.sortCountries();
  }
});

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(44);


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(18).document;
module.exports = document && document.documentElement;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(39);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(66);
var ITERATOR = __webpack_require__(19)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(19)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(29);
var getKeys = __webpack_require__(64);
var toIObject = __webpack_require__(55);
var isEnum = __webpack_require__(80).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isUndefined;
// Is a given variable undefined?
function isUndefined(obj) {
  return obj === void 0;
}


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isBoolean;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(11);


// Is a given value a boolean?
function isBoolean(obj) {
  return obj === true || obj === false || __WEBPACK_IMPORTED_MODULE_0__setup_js__["t" /* toString */].call(obj) === '[object Boolean]';
}


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(16);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Number'));


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(16);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Symbol'));


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(16);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('ArrayBuffer'));


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isNaN;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNumber_js__ = __webpack_require__(178);



// Is the given value `NaN`?
function isNaN(obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isNumber_js__["a" /* default */])(obj) && Object(__WEBPACK_IMPORTED_MODULE_0__setup_js__["g" /* _isNaN */])(obj);
}


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isDataView_js__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant_js__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBufferLike_js__ = __webpack_require__(727);





// Is a given value a typed array?
var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function isTypedArray(obj) {
  // `ArrayBuffer.isView` is the most future-proof, so use it when available.
  // Otherwise, fall back on the above regular expression.
  return __WEBPACK_IMPORTED_MODULE_0__setup_js__["l" /* nativeIsView */] ? (Object(__WEBPACK_IMPORTED_MODULE_0__setup_js__["l" /* nativeIsView */])(obj) && !Object(__WEBPACK_IMPORTED_MODULE_1__isDataView_js__["a" /* default */])(obj)) :
                Object(__WEBPACK_IMPORTED_MODULE_3__isBufferLike_js__["a" /* default */])(obj) && typedArrayPattern.test(__WEBPACK_IMPORTED_MODULE_0__setup_js__["t" /* toString */].call(obj));
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__setup_js__["r" /* supportsArrayBuffer */] ? isTypedArray : Object(__WEBPACK_IMPORTED_MODULE_2__constant_js__["a" /* default */])(false));


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = constant;
// Predicate-generating function. Often useful outside of Underscore.
function constant(value) {
  return function() {
    return value;
  };
}


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSizePropertyCheck;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(11);


// Common internal logic for `isArrayLike` and `isBufferLike`.
function createSizePropertyCheck(getSizeProperty) {
  return function(collection) {
    var sizeProperty = getSizeProperty(collection);
    return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= __WEBPACK_IMPORTED_MODULE_0__setup_js__["b" /* MAX_ARRAY_INDEX */];
  }
}


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowProperty;
// Internal helper to generate a function to obtain property `key` from `obj`.
function shallowProperty(key) {
  return function(obj) {
    return obj == null ? void 0 : obj[key];
  };
}


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = collectNonEnumProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__has_js__ = __webpack_require__(46);




// Internal helper to create a simple lookup structure.
// `collectNonEnumProps` used to depend on `_.contains`, but this led to
// circular imports. `emulatedSet` is a one-off solution that only works for
// arrays of strings.
function emulatedSet(keys) {
  var hash = {};
  for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
  return {
    contains: function(key) { return hash[key] === true; },
    push: function(key) {
      hash[key] = true;
      return keys.push(key);
    }
  };
}

// Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
// be iterated by `for key in ...` and thus missed. Extends `keys` in place if
// needed.
function collectNonEnumProps(obj, keys) {
  keys = emulatedSet(keys);
  var nonEnumIdx = __WEBPACK_IMPORTED_MODULE_0__setup_js__["n" /* nonEnumerableProps */].length;
  var constructor = obj.constructor;
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(constructor) && constructor.prototype || __WEBPACK_IMPORTED_MODULE_0__setup_js__["c" /* ObjProto */];

  // Constructor is a special case.
  var prop = 'constructor';
  if (Object(__WEBPACK_IMPORTED_MODULE_2__has_js__["a" /* default */])(obj, prop) && !keys.contains(prop)) keys.push(prop);

  while (nonEnumIdx--) {
    prop = __WEBPACK_IMPORTED_MODULE_0__setup_js__["n" /* nonEnumerableProps */][nonEnumIdx];
    if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
      keys.push(prop);
    }
  }
}


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isMatch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys_js__ = __webpack_require__(14);


// Returns whether an object has a given set of `key:value` pairs.
function isMatch(object, attrs) {
  var _keys = Object(__WEBPACK_IMPORTED_MODULE_0__keys_js__["a" /* default */])(attrs), length = _keys.length;
  if (object == null) return !length;
  var obj = Object(object);
  for (var i = 0; i < length; i++) {
    var key = _keys[i];
    if (attrs[key] !== obj[key] || !(key in obj)) return false;
  }
  return true;
}


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = invert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys_js__ = __webpack_require__(14);


// Invert the keys and values of an object. The values must be serializable.
function invert(obj) {
  var result = {};
  var _keys = Object(__WEBPACK_IMPORTED_MODULE_0__keys_js__["a" /* default */])(obj);
  for (var i = 0, length = _keys.length; i < length; i++) {
    result[obj[_keys[i]]] = _keys[i];
  }
  return result;
}


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = functions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(30);


// Return a sorted list of the function names available on the object.
function functions(obj) {
  var names = [];
  for (var key in obj) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(obj[key])) names.push(key);
  }
  return names.sort();
}


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createAssigner_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__allKeys_js__ = __webpack_require__(85);



// Extend a given object with all the properties in passed-in object(s).
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createAssigner_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__allKeys_js__["a" /* default */]));


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createAssigner_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__allKeys_js__ = __webpack_require__(85);



// Fill in a given object with default properties.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createAssigner_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__allKeys_js__["a" /* default */], true));


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = baseCreate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(11);



// Create a naked function reference for surrogate-prototype-swapping.
function ctor() {
  return function(){};
}

// An internal function for creating a new object that inherits from another.
function baseCreate(prototype) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(prototype)) return {};
  if (__WEBPACK_IMPORTED_MODULE_1__setup_js__["j" /* nativeCreate */]) return Object(__WEBPACK_IMPORTED_MODULE_1__setup_js__["j" /* nativeCreate */])(prototype);
  var Ctor = ctor();
  Ctor.prototype = prototype;
  var result = new Ctor;
  Ctor.prototype = null;
  return result;
}


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = get;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPath_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deepGet_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isUndefined_js__ = __webpack_require__(176);




// Get the value of the (deep) property on `path` from `object`.
// If any property in `path` does not exist or if the value is
// `undefined`, return `defaultValue` instead.
// The `path` is normalized through `_.toPath`.
function get(object, path, defaultValue) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__deepGet_js__["a" /* default */])(object, Object(__WEBPACK_IMPORTED_MODULE_0__toPath_js__["a" /* default */])(path));
  return Object(__WEBPACK_IMPORTED_MODULE_2__isUndefined_js__["a" /* default */])(value) ? defaultValue : value;
}


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(58);



// Normalize a (deep) property `path` to array.
// Like `_.iteratee`, this function can be customized.
function toPath(path) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(path) ? path : [path];
}
__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].toPath = toPath;


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = baseIteratee;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matcher_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__property_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__optimizeCb_js__ = __webpack_require__(87);








// An internal function to generate callbacks that can be applied to each
// element in a collection, returning the desired result — either `_.identity`,
// an arbitrary callback, a property matcher, or a property accessor.
function baseIteratee(value, context, argCount) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */];
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(value)) return Object(__WEBPACK_IMPORTED_MODULE_6__optimizeCb_js__["a" /* default */])(value, context, argCount);
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) && !Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value)) return Object(__WEBPACK_IMPORTED_MODULE_4__matcher_js__["a" /* default */])(value);
  return Object(__WEBPACK_IMPORTED_MODULE_5__property_js__["a" /* default */])(value);
}


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = iteratee;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(195);



// External wrapper for our callback generator. Users may customize
// `_.iteratee` if they want additional predicate/iteratee shorthand styles.
// This abstraction hides the internal-only `argCount` argument.
function iteratee(value, context) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(value, context, Infinity);
}
__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].iteratee = iteratee;


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
// Predicate-generating function. Often useful outside of Underscore.
function noop(){}


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = random;
// Return a random integer between `min` and `max` (inclusive).
function random(min, max) {
  if (max == null) {
    max = min;
    min = 0;
  }
  return min + Math.floor(Math.random() * (max - min + 1));
}


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createEscaper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys_js__ = __webpack_require__(14);


// Internal helper to generate functions for escaping and unescaping strings
// to/from HTML interpolation.
function createEscaper(map) {
  var escaper = function(match) {
    return map[match];
  };
  // Regexes for identifying a key that needs to be escaped.
  var source = '(?:' + Object(__WEBPACK_IMPORTED_MODULE_0__keys_js__["a" /* default */])(map).join('|') + ')';
  var testRegexp = RegExp(source);
  var replaceRegexp = RegExp(source, 'g');
  return function(string) {
    string = string == null ? '' : '' + string;
    return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
  };
}


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Internal list of HTML entities for escaping.
/* harmony default export */ __webpack_exports__["a"] = ({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;'
});


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(24);


// By default, Underscore uses ERB-style template delimiters. Change the
// following template settings to use alternative delimiters.
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].templateSettings = {
  evaluate: /<%([\s\S]+?)%>/g,
  interpolate: /<%=([\s\S]+?)%>/g,
  escape: /<%-([\s\S]+?)%>/g
});


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = executeBound;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(57);



// Internal function to execute `sourceFunc` bound to `context` with optional
// `args`. Determines whether to execute a function as a constructor or as a
// normal function.
function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
  if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
  var self = Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(sourceFunc.prototype);
  var result = sourceFunc.apply(self, args);
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(result)) return result;
  return self;
}


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__executeBound_js__ = __webpack_require__(202);




// Create a function bound to a given object (assigning `this`, and arguments,
// optionally).
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(func, context, args) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(func)) throw new TypeError('Bind must be called on a function');
  var bound = Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(callArgs) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__executeBound_js__["a" /* default */])(func, bound, context, this, args.concat(callArgs));
  });
  return bound;
}));


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(23);


// Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(func, wait, args) {
  return setTimeout(function() {
    return func.apply(null, args);
  }, wait);
}));


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = before;
// Returns a function that will only be executed up to (but not including) the
// Nth call.
function before(times, func) {
  var memo;
  return function() {
    if (--times > 0) {
      memo = func.apply(this, arguments);
    }
    if (times <= 1) func = null;
    return memo;
  };
}


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(14);



// Returns the first key on an object that passes a truth test.
function findKey(obj, predicate, context) {
  predicate = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(predicate, context);
  var _keys = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(obj), key;
  for (var i = 0, length = _keys.length; i < length; i++) {
    key = _keys[i];
    if (predicate(obj[key], key, obj)) return key;
  }
}


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPredicateIndexFinder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getLength_js__ = __webpack_require__(31);



// Internal function to generate `_.findIndex` and `_.findLastIndex`.
function createPredicateIndexFinder(dir) {
  return function(array, predicate, context) {
    predicate = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(predicate, context);
    var length = Object(__WEBPACK_IMPORTED_MODULE_1__getLength_js__["a" /* default */])(array);
    var index = dir > 0 ? 0 : length - 1;
    for (; index >= 0 && index < length; index += dir) {
      if (predicate(array[index], index, array)) return index;
    }
    return -1;
  };
}


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPredicateIndexFinder_js__ = __webpack_require__(207);


// Returns the last index on an array-like that passes a truth test.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createPredicateIndexFinder_js__["a" /* default */])(-1));


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sortedIndex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getLength_js__ = __webpack_require__(31);



// Use a comparator function to figure out the smallest index at which
// an object should be inserted so as to maintain order. Uses binary search.
function sortedIndex(array, obj, iteratee, context) {
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(iteratee, context, 1);
  var value = iteratee(obj);
  var low = 0, high = Object(__WEBPACK_IMPORTED_MODULE_1__getLength_js__["a" /* default */])(array);
  while (low < high) {
    var mid = Math.floor((low + high) / 2);
    if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
  }
  return low;
}


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sortedIndex_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__findIndex_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createIndexFinder_js__ = __webpack_require__(211);




// Return the position of the first occurrence of an item in an array,
// or -1 if the item is not included in the array.
// If the array is large and already in sort order, pass `true`
// for **isSorted** to use binary search.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__createIndexFinder_js__["a" /* default */])(1, __WEBPACK_IMPORTED_MODULE_1__findIndex_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__sortedIndex_js__["a" /* default */]));


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createIndexFinder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isNaN_js__ = __webpack_require__(181);




// Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
function createIndexFinder(dir, predicateFind, sortedIndex) {
  return function(array, item, idx) {
    var i = 0, length = Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(array);
    if (typeof idx == 'number') {
      if (dir > 0) {
        i = idx >= 0 ? idx : Math.max(idx + length, i);
      } else {
        length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
      }
    } else if (sortedIndex && idx && length) {
      idx = sortedIndex(array, item);
      return array[idx] === item ? idx : -1;
    }
    if (item !== item) {
      idx = predicateFind(__WEBPACK_IMPORTED_MODULE_1__setup_js__["q" /* slice */].call(array, i, length), __WEBPACK_IMPORTED_MODULE_2__isNaN_js__["a" /* default */]);
      return idx >= 0 ? idx + i : -1;
    }
    for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
      if (array[idx] === item) return idx;
    }
    return -1;
  };
}


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = find;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__findIndex_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__findKey_js__ = __webpack_require__(206);




// Return the first value which passes a truth test.
function find(obj, predicate, context) {
  var keyFinder = Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) ? __WEBPACK_IMPORTED_MODULE_1__findIndex_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_2__findKey_js__["a" /* default */];
  var key = keyFinder(obj, predicate, context);
  if (key !== void 0 && key !== -1) return obj[key];
}


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createReduce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__optimizeCb_js__ = __webpack_require__(87);




// Internal helper to create a reducing function, iterating left or right.
function createReduce(dir) {
  // Wrap code that reassigns argument variables in a separate function than
  // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
  var reducer = function(obj, iteratee, memo, initial) {
    var _keys = !Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) && Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(obj),
        length = (_keys || obj).length,
        index = dir > 0 ? 0 : length - 1;
    if (!initial) {
      memo = obj[_keys ? _keys[index] : index];
      index += dir;
    }
    for (; index >= 0 && index < length; index += dir) {
      var currentKey = _keys ? _keys[index] : index;
      memo = iteratee(memo, obj[currentKey], currentKey, obj);
    }
    return memo;
  };

  return function(obj, iteratee, memo, context) {
    var initial = arguments.length >= 3;
    return reducer(obj, Object(__WEBPACK_IMPORTED_MODULE_2__optimizeCb_js__["a" /* default */])(iteratee, context, 4), memo, initial);
  };
}


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = max;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__values_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cb_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__each_js__ = __webpack_require__(59);





// Return the maximum element (or element-based computation).
function max(obj, iteratee, context) {
  var result = -Infinity, lastComputed = -Infinity,
      value, computed;
  if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
    obj = Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) ? obj : Object(__WEBPACK_IMPORTED_MODULE_1__values_js__["a" /* default */])(obj);
    for (var i = 0, length = obj.length; i < length; i++) {
      value = obj[i];
      if (value != null && value > result) {
        result = value;
      }
    }
  } else {
    iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__cb_js__["a" /* default */])(iteratee, context);
    Object(__WEBPACK_IMPORTED_MODULE_3__each_js__["a" /* default */])(obj, function(v, index, list) {
      computed = iteratee(v, index, list);
      if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
        result = v;
        lastComputed = computed;
      }
    });
  }
  return result;
}


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sample;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__values_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getLength_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__random_js__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toArray_js__ = __webpack_require__(216);






// Sample **n** random values from a collection using the modern version of the
// [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
// If **n** is not specified, returns a single random element.
// The internal `guard` argument allows it to work with `_.map`.
function sample(obj, n, guard) {
  if (n == null || guard) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj)) obj = Object(__WEBPACK_IMPORTED_MODULE_1__values_js__["a" /* default */])(obj);
    return obj[Object(__WEBPACK_IMPORTED_MODULE_3__random_js__["a" /* default */])(obj.length - 1)];
  }
  var sample = Object(__WEBPACK_IMPORTED_MODULE_4__toArray_js__["a" /* default */])(obj);
  var length = Object(__WEBPACK_IMPORTED_MODULE_2__getLength_js__["a" /* default */])(sample);
  n = Math.max(Math.min(n, length), 0);
  var last = length - 1;
  for (var index = 0; index < n; index++) {
    var rand = Object(__WEBPACK_IMPORTED_MODULE_3__random_js__["a" /* default */])(index, last);
    var temp = sample[index];
    sample[index] = sample[rand];
    sample[rand] = temp;
  }
  return sample.slice(0, n);
}


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isString_js__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArrayLike_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__map_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__identity_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__values_js__ = __webpack_require__(67);








// Safely create a real, live array from anything iterable.
var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function toArray(obj) {
  if (!obj) return [];
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(obj)) return __WEBPACK_IMPORTED_MODULE_1__setup_js__["q" /* slice */].call(obj);
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isString_js__["a" /* default */])(obj)) {
    // Keep surrogate pair characters together.
    return obj.match(reStrSymbol);
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isArrayLike_js__["a" /* default */])(obj)) return Object(__WEBPACK_IMPORTED_MODULE_4__map_js__["a" /* default */])(obj, __WEBPACK_IMPORTED_MODULE_5__identity_js__["a" /* default */]);
  return Object(__WEBPACK_IMPORTED_MODULE_6__values_js__["a" /* default */])(obj);
}


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__optimizeCb_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__allKeys_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keyInObj_js__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flatten_js__ = __webpack_require__(68);







// Return a copy of the object only containing the allowed properties.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(obj, keys) {
  var result = {}, iteratee = keys[0];
  if (obj == null) return result;
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(iteratee)) {
    if (keys.length > 1) iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__optimizeCb_js__["a" /* default */])(iteratee, keys[1]);
    keys = Object(__WEBPACK_IMPORTED_MODULE_3__allKeys_js__["a" /* default */])(obj);
  } else {
    iteratee = __WEBPACK_IMPORTED_MODULE_4__keyInObj_js__["a" /* default */];
    keys = Object(__WEBPACK_IMPORTED_MODULE_5__flatten_js__["a" /* default */])(keys, false, false);
    obj = Object(obj);
  }
  for (var i = 0, length = keys.length; i < length; i++) {
    var key = keys[i];
    var value = obj[key];
    if (iteratee(value, key, obj)) result[key] = value;
  }
  return result;
}));


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(11);


// Returns everything but the last entry of the array. Especially useful on
// the arguments object. Passing **n** will return all the values in
// the array, excluding the last N.
function initial(array, n, guard) {
  return __WEBPACK_IMPORTED_MODULE_0__setup_js__["q" /* slice */].call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
}


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(11);


// Returns everything but the first entry of the `array`. Especially useful on
// the `arguments` object. Passing an **n** will return the rest N values in the
// `array`.
function rest(array, n, guard) {
  return __WEBPACK_IMPORTED_MODULE_0__setup_js__["q" /* slice */].call(array, n == null || guard ? 1 : n);
}


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flatten_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contains_js__ = __webpack_require__(89);





// Take the difference between one array and a number of other arrays.
// Only the elements present in just the first array will remain.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(array, rest) {
  rest = Object(__WEBPACK_IMPORTED_MODULE_1__flatten_js__["a" /* default */])(rest, true, true);
  return Object(__WEBPACK_IMPORTED_MODULE_2__filter_js__["a" /* default */])(array, function(value){
    return !Object(__WEBPACK_IMPORTED_MODULE_3__contains_js__["a" /* default */])(rest, value);
  });
}));


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uniq;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isBoolean_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cb_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getLength_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contains_js__ = __webpack_require__(89);





// Produce a duplicate-free version of the array. If the array has already
// been sorted, you have the option of using a faster algorithm.
// The faster algorithm will not work with an iteratee if the iteratee
// is not a one-to-one function, so providing an iteratee will disable
// the faster algorithm.
function uniq(array, isSorted, iteratee, context) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isBoolean_js__["a" /* default */])(isSorted)) {
    context = iteratee;
    iteratee = isSorted;
    isSorted = false;
  }
  if (iteratee != null) iteratee = Object(__WEBPACK_IMPORTED_MODULE_1__cb_js__["a" /* default */])(iteratee, context);
  var result = [];
  var seen = [];
  for (var i = 0, length = Object(__WEBPACK_IMPORTED_MODULE_2__getLength_js__["a" /* default */])(array); i < length; i++) {
    var value = array[i],
        computed = iteratee ? iteratee(value, i, array) : value;
    if (isSorted && !iteratee) {
      if (!i || seen !== computed) result.push(value);
      seen = computed;
    } else if (iteratee) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_3__contains_js__["a" /* default */])(seen, computed)) {
        seen.push(computed);
        result.push(value);
      }
    } else if (!Object(__WEBPACK_IMPORTED_MODULE_3__contains_js__["a" /* default */])(result, value)) {
      result.push(value);
    }
  }
  return result;
}


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = unzip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__max_js__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getLength_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pluck_js__ = __webpack_require__(140);




// Complement of zip. Unzip accepts an array of arrays and groups
// each array's elements on shared indices.
function unzip(array) {
  var length = array && Object(__WEBPACK_IMPORTED_MODULE_0__max_js__["a" /* default */])(array, __WEBPACK_IMPORTED_MODULE_1__getLength_js__["a" /* default */]).length || 0;
  var result = Array(length);

  for (var index = 0; index < length; index++) {
    result[index] = Object(__WEBPACK_IMPORTED_MODULE_2__pluck_js__["a" /* default */])(array, index);
  }
  return result;
}


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chainResult;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(24);


// Helper function to continue chaining intermediate results.
function chainResult(instance, obj) {
  return instance._chain ? Object(__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */])(obj).chain() : obj;
}


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regions = {};

regions.centralAsia = {
  name: 'Central Asia',
  countries: [
    // source is http://en.wikipedia.org/wiki/Central_Asia
    'KZ', // Kazakhstan
    'KG', // Kyrgyzstan
    'TJ', // Tajikistan
    'TM', // Turkmenistan
    'UZ', // Uzbekistan
  ]
}

regions.southernAsia = {
  name: 'Southern Asia',
  countries: [
    // source is http://en.wikipedia.org/wiki/South_Asia
    'AF', // Afghanistan
    'BD', // Bangladesh
    'BT', // Bhutan
    'IO', // British Indian Ocean Territory
    'IN', // India
    'IR', // Iran
    'MV', // Maldives
    'NP', // Nepal
    'PK', // Pakistan
    'LK', // Sri Lanka
  ]
}

regions.southeastAsia = {
  name: 'Southeast Asia',
  countries: [
    // source is http://en.wikipedia.org/wiki/Southeast_Asia
    'BN', // Brunei
    'KH', // Cambodia
    'CX', // Christmas Island
    'CC', // Cocos (Keeling) Islands
    'TL', // East Timor
    'ID', // Indonesia
    'LA', // Laos
    'MY', // Malaysia
    'MM', // Myanmar (Burma)
    'PH', // Philippines
    'SG', // Singapore
    'TH', // Thailand
    'VN', // Vietnam
  ]
}

regions.eastAsia = {
  name: 'East Asia',
  countries: [
    // source is http://en.wikipedia.org/wiki/East_Asia
    'CN', // China
    'HK', // Hong Kong
    'JP', // Japan
    'KP', // North Korea
    'KR', // South Korea
    'MO', // Macao
    'MN', // Mongolia
    'TW', // Taiwan
  ]
}

regions.westernAsia = {
  name: 'Western Asia',
  countries: [
    // source is http://en.wikipedia.org/wiki/Western_Asia
    'AM', // Armenia
    'AZ', // Azerbaijan
    'BH', // Bahrain
    'IQ', // Iraq
    'IL', // Israel
    'JO', // Jordan
    'KW', // Kuwait
    'LB', // Lebanon
    'OM', // Oman
    'PS', // Palestinian territories
    'QA', // Qatar
    'SA', // Saudi Arabia
    'SY', // Syria
    'TR', // Turkey
    'AE', // United Arab Emirates
    'YE', // Yemen
  ]
}

regions.centralAfrica = {
  name: 'Central Aftrica',
  countries: [
    // source is http://en.wikipedia.org/wiki/Central_Africa
    'AO', // Angola
    'CM', // Cameroon
    'CF', // Central African Republic
    'TD', // Chad
    'CG', // Republic of the Congo
    'CD', // Democratic Republic of the Congo
    'GQ', // Equatorial Guinea
    'GA', // Gabon
    'ST', // São Tomé and Príncipe
  ]
};

regions.northAfrica = {
  name: 'North Africa',
  countries: [
    // source is http://en.wikipedia.org/wiki/North_Africa
    'DZ', // Algeria
    'EG', // Egypt
    'LY', // Libya
    'MA', // Morocco
    'SD', // Sudan
    'TN', // Tunisia
    'EH', // Western Sahara
  ]
};

regions.southernAfrica = {
  name: 'Southern Africa',
  countries: [
    // source is http://en.wikipedia.org/wiki/Southern_Africa
    'BW', // Botswana
    'LS', // Lesotho
    'NA', // Namibia
    'ZA', // South Africa
    'SZ', // Swaziland
  ]
};

regions.eastAfrica = {
  name: 'East Africa',
  countries: [
    // source is http://en.wikipedia.org/wiki/East_Africa
    'BI', // Burundi
    'KM', // Comoros
    'DJ', // Djibouti
    'ER', // Eritrea
    'ET', // Ethiopia
    'KE', // Kenya
    'MG', // Madagascar
    'MW', // Malawi
    'MU', // Mauritius
    'YT', // Mayotte (France)
    'MZ', // Mozambique
    'RE', // Réunion (France)
    'RW', // Rwanda
    'SC', // Seychelles
    'SO', // Somalia
    'SS', // South Sudan
    'TZ', // Tanzania
    'UG', // Uganda
    'ZM', // Zambia
    'ZW', // Zimbabwe
  ]
};

regions.westAfrica = {
  name: 'West Africa',
  countries: [
    // source is http://en.wikipedia.org/wiki/West_Africa
    'BJ', // Benin
    'BF', // Burkina Faso
    'CV', // Cabo Verde
    'CI', // Côte d'Ivoire
    'GM', // Gambia
    'GH', // Ghana
    'GN', // Guinea
    'GW', // Guinea-Bissau
    'LR', // Liberia
    'ML', // Mali
    'MR', // Mauritania
    'NE', // Niger
    'NG', // Nigeria
    'SH', // Saint Helena, Ascension and Tristan da Cunha (United Kingdom)
    'SN', // Senegal
    'SL', // Sierra Leone
    'TG', // Togo
  ]
};

regions.centralAmerica = {
  name: 'Central America',
  countries: [
    // source is http://en.wikipedia.org/wiki/Central_America
    'BZ', // Belize
    'CR', // Costa Rica
    'SV', // El Salvador
    'GT', // Guatemala
    'HN', // Honduras
    'NI', // Nicaragua
    'PA', // Panama
  ]
}

regions.northernAmerica = {
  name: 'Northern America',
  countries: [
    // source is http://en.wikipedia.org/wiki/Northern_America
    'BM', // Bermuda
    'CA', // Canada
    'GL', // Greenland
    'MX', // Mexico
    'PM', // Saint Pierre and Miquelon
    'US', // United States
  ]
}

regions.caribbean = {
  name: 'Caribbean',
  countries: [
    // source is http://en.wikipedia.org/wiki/Caribbean
    'AI', // Anguilla
    'AG', // Antigua and Barbuda
    'AW', // Aruba
    'BS', // Bahamas
    'BB', // Barbados
    'BQ', // Bonaire, Sint Eustatius & Saba
    'VG', // British Virgin Islands
    'KY', // Cayman Islands
    'CU', // Cuba
    'CW', // Curaçao
    'DM', // Dominica
    'DO', // Dominican Republic
    'GD', // Grenada
    'GP', // Guadeloupe
    'HT', // Haiti
    'JM', // Jamaica
    'MQ', // Martinique
    'MS', // Montserrat
    'PR', // Puerto Rico
    'BL', // Saint Barthélemy
    'KN', // St. Kitts & Nevis
    'LC', // Saint Lucia
    'MF', // Saint Martin
    'VC', // Saint Vincent and the Grenadines
    'SX', // Sint Maarten
    'TT', // Trinidad and Tobago
    'TC', // Turks & Caicos
    'VI', // United States Virgin Islands
  ]
}

regions.southAmerica = {
  name: 'South America',
  countries: [
    // source is http://en.wikipedia.org/wiki/South_America
    'AR', // Argentina
    'BO', // Bolivia
    'BR', // Brazil
    'CL', // Chile
    'CO', // Colombia
    'EC', // Ecuador
    'FK', // Falkland Islands
    'GF', // French Guiana
    'GY', // Guyana
    'PY', // Paraguay
    'PE', // Peru
    'SR', // Suriname
    'UY', // Uruguay
    'VE', // Venezuela
  ]
}

regions.antartica = {
  name: 'Antartica',
  countries: [
    // source is http://en.wikipedia.org/wiki/Antarctica
    'AQ', // Antarctica
    'BV', // Bouvet Island
    'TF', // French Southern Territories
    'HM', // Heard Island and McDonald Islands
    'GS', // South Georgia and the South Sandwich Islands
  ]
}

regions.northernEurope = {
  name: 'Northern Europe',
  countries: [
    // source is http://en.wikipedia.org/wiki/Northern_Europe
    'AX', // Åland
    'DK', // Denmark
    'EE', // Estonia
    'FO', // Faroe Islands
    'FI', // Finland
    'GG', // Guernsey
    'IS', // Iceland
    'IE', // Republic of Ireland
    'JE', // Jersey (UK)
    'IM', // Isle of Man
    'LV', // Latvia
    'LT', // Lithuania
    'NO', // Norway
    'SJ', // Svalbard and Jan Mayen
    'SE', // Sweden
    'GB', // United Kingdom
  ]
}

regions.southernEurope = {
  name: 'Southern Europe',
  countries: [
    // source is http://en.wikipedia.org/wiki/Southern_Europe
    'AL', // Albania
    'AD', // Andorra
    'BA', // Bosnia and Herzegovina
    'HR', // Croatia
    'CY', // Cyprus
    'GI', // Gibraltar
    'GR', // Greece
    'IT', // Italy
    'MK', // Republic of Macedonia
    'VA', // Vatican City
    'MT', // Malta
    'ME', // Montenegro
    'PT', // Portugal
    'SM', // San Marino
    'RS', // Serbia
    'SI', // Slovenia
    'ES', // Spain
  ]
}

regions.easternEurope = {
  name: 'Eastern Europe',
  countries: [
    // source is http://en.wikipedia.org/wiki/Eastern_Europe
    'BY', // Belarus
    'BG', // Bulgaria
    'CZ', // Czech Republic
    'GE', // Georgia
    'HU', // Hungary
    'MD', // Moldova
    'PL', // Poland
    'RO', // Romania
    'RU', // Russia
    'SK', // Slovakia
    'UA', // Ukraine
  ]
}

regions.westernEurope = {
  name: 'Western Europe',
  countries: [
    // source is http://en.wikipedia.org/wiki/Western_Europe
    'AT', // Austria
    'BE', // Belgium
    'FR', // France
    'DE', // Germany
    'LI', // Liechtenstein
    'LU', // Luxembourg
    'MC', // Monaco
    'NL', // Netherlands
    'CH', // Switzerland
  ],
};
 
regions.australia = {
  name: 'Australia',
  countries: [
    // source is http://en.wikipedia.org/wiki/Oceania
    'AU', // Australia
    'NF', // Norfolk Island
    'NZ', // New Zealand
  ]
};

regions.melanesia = {
  name: 'Melanesia',
  countries: [
    // source is http://en.wikipedia.org/wiki/Oceania
    'FJ', // Fiji
    'NC', //  New Caledonia
    'PG', // Papua New Guinea
    'SB', // Solomon Islands
    'VU', // Vanuatu
  ]
};    

regions.micronesia = {
  name: 'Micronesia',
  countries: [
    // source is http://en.wikipedia.org/wiki/Oceania
    'GU', // Guam
    'KI', // Kiribati
    'MH', // Marshall Islands
    'FM', // Micronesia, Fed. Sts.
    'NR', // Nauru
    'MP', // Northern Mariana Islands
    'PW', // Palau
    'UM', // United States Minor Outlying Islands
  ]
};    

regions.polynesia = {
  name: 'Polynesia',
  countries: [
    // source is http://en.wikipedia.org/wiki/Oceania
    'AS', // American Samoa
    'CK', // Cook Islands
    'PF', // French Polynesia
    'NU', // Niue
    'PN', // Pitcairn Islands
    'WS', // Samoa
    'TK', // Tokelau
    'TO', // Tonga
    'TV', // Tuvalu
    'WF', // Wallis and Futuna
  ]
};

module.exports = regions;


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'flight-information-modal',
  computed: {
    flightInfo: function flightInfo() {
      return this.$store.state.flightInformation;
    }
  },
  methods: {
    close: function close() {
      this.$store.commit('flightInformation/hide');
    }
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_LoadingAnimation_Pulse__ = __webpack_require__(141);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'phone-app',
  components: { PulseLoader: __WEBPACK_IMPORTED_MODULE_0__components_Partials_LoadingAnimation_Pulse__["a" /* default */] }, data: function data() {
    return {
      remove: false
    };
  },

  computed: {
    isMute: function isMute() {
      return this.$store.state.phone.isMute;
    },
    phoneCall: function phoneCall() {
      return this.$store.state.phone;
    },
    _route: function _route() {
      return this.$route.name;
    }
  },
  methods: {
    endCall: function endCall() {
      var self = this;
      self.$plugins.phone.endCall(self);
    },
    toggleMute: function toggleMute() {
      var self = this;
      self.$plugins.phone.toggleMute(self);
    }
  },
  watch: {
    _route: function _route(value) {
      this.remove = value === 'ProviderPrintPlacard';
    }
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tributejs__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tributejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tributejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_reservation_details_edit__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_featureToggle__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reservation-notes-modal',
  data: function data() {
    return {
      noteError: false,
      isSubmitting: false,
      showComplete: false,
      refundType: 'full',
      refundAmount: '',
      refundAmountError: '',
      fullRefundCharge: '1',
      refundModal: {
        show: false,
        message: '',
        status: ''
      },
      cancelFeeLoading: false,
      cancelFee: true,
      cancellationFee: 0,
      isConvertCredit: '0',
      cancellation: {
        reasons: ['I booked this by mistake', 'I\'m not happy with the price', 'I\'m not happy with the service', 'My plans changed', 'My driver had a bad attitude', 'Duplicate reservation', 'My driver was late for the pickup', 'My driver did not arrive', 'I took an Uber', 'I took a Lyft', 'I took a cab', 'Other'],
        selectedReason: -1,
        customReason: '',
        showError: false,
        selectError: false,
        tmpGetFeeList: []
      }
    };
  },

  computed: {
    notesData: function notesData() {
      return this.$store.state.reservationNotes;
    },
    show: function show() {
      return this.notesData.show;
    },
    notes: function notes() {
      return this.notesData.notes;
    },

    noteStatus: {
      get: function get() {
        return this.notesData.noteStatus;
      },
      set: function set(value) {
        this.$store.commit('reservationNotes/setNoteStatus', value);
      }
    },
    label: function label() {
      return this.notesData.label;
    },
    admins: function admins() {
      return this.notesData.admins;
    },
    isPackage: function isPackage() {
      return this.notesData.isPackage;
    },
    isPartialRefund: function isPartialRefund() {
      return this.notesData.action === 'partialRefund';
    },
    isFullRefund: function isFullRefund() {
      return this.notesData.action === 'fullRefund';
    },
    actionData: function actionData() {
      var aData = this.notesData.actionData;
      if (aData.disable && aData.disable.indexOf('full') > -1) {
        this.refundType = 'charge';
      }
      return this.notesData.actionData;
    },
    refundDisable: function refundDisable() {
      if (this.actionData && this.actionData.disable) {
        return {
          full: this.actionData.disable.indexOf('full') > -1,
          partial: this.actionData.disable.indexOf('partial') > -1,
          credit: this.actionData.disable.indexOf('credit') > -1,
          charge: this.actionData.disable.indexOf('charge') > -1
        };
      }

      return {
        full: true,
        partial: true,
        credit: true,
        charge: true
      };
    },
    notesAction: function notesAction() {
      return this.notesData.action;
    }
  },
  methods: {
    populate: function populate() {
      var self = this;
      var value = self.$refs.noteTextArea.innerHTML || self.notes;
      self.noteError = false;
      if (value.length > 500) {
        self.$refs.noteTextArea.innerHTML = self.$store.state.reservationNotes.notes;
        return;
      }
      self.$store.commit('reservationNotes/setNotes', value);
    },
    initTribute: function initTribute() {
      var self = this;
      var admins = self.$store.state.reservationNotes.admins;
      var tribute = new __WEBPACK_IMPORTED_MODULE_0_tributejs___default.a({
        values: admins,
        // values: [],
        lookup: 'name',
        fillAttr: 'name',
        selectTemplate: function selectTemplate(item) {
          var result = '<span data-id="' + item.original.id + '" class="mention">@' + item.string + '</span>';
          return result;
        }
      });
      tribute.attach(self.$refs.noteTextArea);
      self.$refs.noteTextArea.addEventListener('tribute-replaced', function (e) {
        self.populate();
      });
    },
    close: function close() {
      if (this.isSubmitting || this.cancelFeeLoading) {
        return;
      }
      this.showComplete = false;
      this.refundType = 'full';
      this.refundAmount = 0;
      this.refundAmountError = '';
      this.refundModal.show = false;
      this.refundModal.message = '';
      this.isConvertCredit = 0;
      this.$store.commit('reservationNotes/hide');
    },
    submit: function submit() {
      var self = this;
      self.refundAmountError = '';
      if (self.isPartialRefund && self.refundType !== 'full') {
        if (self.refundAmount.trim() === '') {
          self.refundAmountError = self.$t('rsvpNotes.refundAmountEmpty');
          self.$nextTick(function () {
            self.$refs.refundInput.focus();
          });
          return;
        }
        if (parseFloat(self.refundAmount) <= 0) {
          self.refundAmountError = self.$t('rsvpNotes.lowNumber');
          self.$nextTick(function () {
            self.$refs.refundInput.focus();
          });
          return;
        }
        // let reg = new RegExp('^\\d+$');
        var reg2 = /^-?\d*\.?\d+$/;
        // if (!reg.test(self.refundAmount)) {
        if (!reg2.test(self.refundAmount)) {
          self.refundAmountError = self.$t('rsvpNotes.notNumber');
          self.$nextTick(function () {
            self.$refs.refundInput.focus();
          });
          return;
        }
      }

      if (self.notes.length <= 0) {
        self.noteError = true;
        return;
      }

      self.isSubmitting = true;

      var noteStore = self.$store.state.reservationNotes;
      if (noteStore.noteId !== null) {
        // UPDATE note
        self.updateNote();
        return;
      }

      if (noteStore.driverId !== null) {
        // DRIVER note
        self.addDriverNote();
        return;
      }

      if (noteStore.action === 'cancel' || noteStore.action === 'convertCredit') {
        self.cancelRsvp();
        // self.checkUpcoming()
        return;
      }

      if (noteStore.action === 'editRsvp') {
        self.editRsvp();
        return;
      }

      if (self.isPartialRefund || self.isFullRefund) {
        self.refundRsvp();
        return;
      }

      self.addRsvpNote();
    },
    updateNote: function updateNote() {
      var self = this;
      var noteStore = self.$store.state.reservationNotes;
      self.sendToApi('/note/' + noteStore.noteId, null, null, noteStore.noteId);
    },
    addDriverNote: function addDriverNote() {
      var self = this;
      var noteStore = self.$store.state.reservationNotes;
      var driverId = noteStore.driverId;
      self.sendToApi('/provider/' + driverId + '/notes', null, driverId, null);
    },
    cancelRsvp: function cancelRsvp() {
      var self = this;
      var selectedReason = self.cancellation.selectedReason;
      var cancelReason = self.cancellation.reasons[self.cancellation.selectedReason];
      var chargeFees = self.cancellationFee > 0 ? self.cancelFee : 0;
      if (self.cancellation.selectedReason === 11) {
        cancelReason = self.cancellation.customReason;
      }
      if (!parseInt(self.isConvertCredit)) {
        if (selectedReason === -1 || selectedReason === '-1') {
          self.cancellation.selectError = true;
          self.isSubmitting = false;
          return;
        }
      }
      self.cancellation.selectError = false;
      if (selectedReason === 11 && cancelReason === '') {
        self.cancellation.showError = true;
        self.isSubmitting = false;
        return;
      }
      self.cancellation.showError = false;
      var noteStore = self.$store.state.reservationNotes;
      var rsvpId = noteStore.rsvpId;

      // if (self.cancellationFee > 0) {
      //   chargeFees = self.cancelFee ? 1 : 0
      // }

      self.$store.commit('cancelUpcoming/setData', {
        notes: noteStore.notes,
        noteStatus: noteStore.noteStatus,
        reason: cancelReason,
        refundAsCredits: parseInt(self.isConvertCredit),
        cancelFee: self.cancelFee
      });
      self.$sdk.delete('/admin/rsvp/' + rsvpId, {
        token: self.$store.state.session.sessionToken,
        notes: noteStore.notes,
        noteStatus: noteStore.noteStatus,
        chargeFees: chargeFees,
        reason: cancelReason,
        refundAsCredits: parseInt(self.isConvertCredit)
      }, function (r) {
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          self.isSubmitting = false;
          self.close();
          return;
        }
        self.checkUpcoming();
        // self.isSubmitting = false
        // self.$store.commit('rsvpDetails/setRsvpAction', {
        //   show: true,
        //   message: self.$t('rsvpDetails.cancelSuccess', {rsvpid: rsvpId})
        // })
        // self.close()
      });
    },
    editRsvp: function editRsvp() {
      var self = this;
      var noteStore = self.$store.state.reservationNotes;
      var rsvpId = noteStore.rsvpId;

      noteStore.actionData.notes = noteStore.notes;
      noteStore.actionData.noteStatus = noteStore.noteStatus;

      var id = noteStore.actionData.rsvpId;
      __WEBPACK_IMPORTED_MODULE_2__modules_api_reservation_details_edit__["a" /* default */].updateRsvp(self, noteStore.actionData, function (res) {
        self.isSubmitting = false;
        self.close();

        var status = 'success';
        var msg = self.$t('rsvpDetails.edit.updateSuccessMsg', { id: id });
        if (res.error) {
          msg = res.error.message;
          if (res.error.code === 'GATE402001') {
            msg = 'Unable to update this reservation. Payment information cannot be processed.';
          }
          status = 'error';
        }
        self.$store.commit('rsvpDetails/setShowUpdateReturn', {
          show: true,
          message: msg,
          status: status
        });
      });
    },
    refundRsvp: function refundRsvp() {
      var self = this;
      var noteStore = self.$store.state.reservationNotes;
      var rsvpId = noteStore.rsvpId;

      var noteData = {
        token: self.$store.state.session.sessionToken,
        notes: noteStore.notes,
        noteStatus: noteStore.noteStatus
      };

      var apiUrl = 'refund';
      if (self.isPartialRefund) {
        if (self.refundType !== 'full') {
          apiUrl = self.refundType;
          noteData.amount = self.refundAmount;
        } else {
          noteData.chargeFees = false;
          noteData.cancel = false;
        }
      }
      if (self.isFullRefund) {
        noteData.chargeFees = parseFloat(self.actionData.amount) > 0 && self.fullRefundCharge === '1' ? true : false;
        noteData.cancel = self.actionData.status === 'Additional Purchase' ? false : true;
      }
      self.$sdk.post('/transaction/' + self.actionData.id + '/' + apiUrl, noteData, function (r) {
        self.isSubmitting = false;

        if (r.error) {
          self.refundModal = {
            show: true,
            message: r.error.message,
            status: 'error'
          };
          return;
        }

        self.$store.commit('global/setAlertData', {
          show: true,
          message: self.successMessage(apiUrl)
        });

        self.$store.commit('transactions/setRefreshList', true);

        if (self.refundType === 'credit') {
          self.refundModal = {
            show: true,
            message: self.$t('rsvpNotes.successCredit'),
            status: 'success'
          };
          self.addRsvpNote();
          return;
        }
        self.addRsvpNote();
        self.close();
      });
    },
    successMessage: function successMessage(x) {
      var msg = this.$t('rsvpNotes.fullRefund');
      if (x === 'partial') msg = this.$t('rsvpNotes.partialRefund');
      if (x === 'credit') msg = this.$t('rsvpNotes.issueCredit');
      if (x === 'charge') msg = this.$t('rsvpNotes.additionalCharge');
      return msg + ' Success!';
    },
    addRsvpNote: function addRsvpNote() {
      var self = this;
      var noteStore = self.$store.state.reservationNotes;
      var rsvpId = noteStore.rsvpId;
      if (noteStore.forComplete) {
        // When marking an RSVP/Package as complete...
        var url = '/admin/' + (noteStore.isPackage ? 'package' : 'rsvp') + '/' + rsvpId + '/complete';

        self.showComplete = false;
        self.$sdk.post(url, {
          token: self.$store.state.session.sessionToken,
          notes: noteStore.notes,
          noteStatus: noteStore.noteStatus
        }, function (r) {
          self.isSubmitting = false;
          if (r.error) {
            self.$store.commit('global/setAlertData', {
              show: true,
              message: r.error.message
            });
            // TODO process error
            console.log(r);
            return;
          }

          self.showComplete = true;

          setTimeout(function () {
            if (noteStore.fromRsvpDetails) {
              self.showComplete = false;
              location.reload();
            } else {
              self.$store.commit('dispatch/removeRsvpInTable', {
                id: rsvpId,
                isPackage: noteStore.isPackage
              });
              self.$store.commit('dispatch/clearCheckedRsvps');
            }
            self.showComplete = false;
            self.close();
          }, 1000);
        });
        return;
      }

      // Adding a note to RSVP/Package...
      self.sendToApi('/admin/rsvp/' + rsvpId + '/notes', rsvpId, null, null);
    },
    sendToApi: function sendToApi(url, rsvpId, driverId, noteId) {
      var self = this;
      var noteStore = self.$store.state.reservationNotes;

      self.$sdk.post(url, {
        token: self.$store.state.session.sessionToken,
        message: noteStore.notes,
        status: noteStore.noteStatus,
        actionType: noteStore.actionType,
        actionData: noteStore.actionData
      }, function (r) {
        self.isSubmitting = false;
        if (r.error) {
          // TODO process error
          console.log(r);
          return;
        }

        var date = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(r.created, 'YYYY-MM-DD@hh:mm:ss').tz('America/Los_Angeles');
        var user = self.$store.state.session.user;
        if (rsvpId !== null) {
          self.$store.commit('rsvpDetails/addNewNotes', {
            id: r.ID,
            date: date.format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_3__modules_api_featureToggle__["a" /* default */].timeFormat(self, false)),
            message: r.message,
            status: r.status,
            userId: r.adminID,
            name: user.firstName + ' ' + user.lastName,
            picture: user.photoUrl
          });
        }

        if (driverId !== null) {
          self.$store.commit('provider/addNewNotes', {
            id: r.ID,
            date: date.format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_3__modules_api_featureToggle__["a" /* default */].timeFormat(self, false)),
            message: r.message,
            status: r.status,
            userId: r.adminID,
            name: user.firstName + ' ' + user.lastName,
            picture: user.photoUrl
          });
        }

        if (noteId !== null) {
          var storeUrl = 'rsvpDetails/updateNote';
          if (r.actionType === 'provider_note') {
            storeUrl = 'provider/updateNote';
          }

          self.$store.commit(storeUrl, {
            id: r.ID,
            message: r.message,
            status: r.status
          });
        }
        self.close();
      });
    },
    changeRefundType: function changeRefundType() {
      var self = this;
      if (self.refundType !== 'full') {
        self.$nextTick(function () {
          self.$refs.refundInput.focus();
        });
      }
    },
    toFixed: function toFixed(x) {
      return parseFloat(x).toFixed(2);
    },
    checkUpcoming: function checkUpcoming() {
      var self = this;
      var rsvp = self.$store.state.rsvpDetails.basicInfo;
      var cust = rsvp.customerInfo;
      self.$sdk.get('/reservations/' + rsvp.tripInfo.id + '/' + cust.firstName + '/' + cust.lastName + '/upcoming', {}, function (r) {
        if (r.error) {
          self.isSubmitting = false;
          self.$store.commit('rsvpDetails/setRsvpAction', {
            show: true,
            message: self.$t('rsvpDetails.cancelSuccess', { rsvpid: rsvp.tripInfo.id })
          });
          self.close();
          return;
        }

        var list = [];
        r.list.forEach(function (rsvp) {
          var pickup = rsvp.pickup.split(',');
          var dropoff = rsvp.dropoff.split(',');
          if (rsvp.dispatchStatus == 'upcoming') {
            list.push({
              id: rsvp.ID,
              pickupDate: __WEBPACK_IMPORTED_MODULE_1_moment___default()(rsvp.pickupDate, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
              pickupDateUnix: __WEBPACK_IMPORTED_MODULE_1_moment___default()(rsvp.pickupDate, 'YYYY-MM-DD HH:mm').format('X'),
              pickup: pickup[0],
              dropoff: dropoff[0]
            });
          }
        });

        if (!list.length) {
          self.isSubmitting = false;
          self.close();
          self.$store.commit('rsvpDetails/setRsvpAction', {
            show: true,
            message: self.$t('rsvpDetails.cancelSuccess', { rsvpid: rsvp.tripInfo.id })
          });
          return;
        }
        list.sort(function (a, b) {
          return a.pickupDateUnix - b.pickupDateUnix;
        });
        self.$store.commit('cancelUpcoming/setCancelData', {
          // show: true,
          msg: parseInt(self.isConvertCredit) ? 'Reservation ' + rsvp.tripInfo.id + ' was credited successfully.' : 'Successfully cancelled reservation.',
          rsvps: list
        });
        self.tmpGetFeeList = [].concat(list);
        self.getFee(self.tmpGetFeeList[0].id);
      });
    },
    getFee: function getFee(id) {
      var self = this;
      self.$sdk.get('/admin/rsvp/' + id + '/fee', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (!r.error) {
          self.$store.commit('cancelUpcoming/updateRsvp', {
            id: id,
            cancellationFee: parseFloat(r.amount)
          });
        }
        self.tmpGetFeeList.shift();
        if (self.tmpGetFeeList.length) self.getFee(self.tmpGetFeeList[0].id);else {
          self.isSubmitting = false;
          self.close();
          self.$store.commit('cancelUpcoming/setCancelData', { show: true });
        }
      });
    }
  },
  watch: {
    show: function show(value) {
      var self = this;
      self.noteError = false;
      self.isSubmitting = false;
      if (value) {
        self.populate();
        self.$store.commit('reservationNotes/setNotes', self.notes || '');
        self.$store.commit('reservationNotes/setNoteStatus', self.noteStatus || 'new');
        self.$refs.noteTextArea.innerHTML = self.$store.state.reservationNotes.notes;

        var rsvpNotes = self.$store.state.reservationNotes;
        if (rsvpNotes.action === 'cancel' || rsvpNotes.action === 'convertCredit') {
          self.cancelFeeLoading = true;
          self.cancelFee = 1;
          self.$sdk.get('/admin/rsvp/' + rsvpNotes.rsvpId + '/fee', {
            token: self.$store.state.session.sessionToken
          }, function (r) {
            self.cancelFeeLoading = false;
            if (r.error) {
              return;
            }
            self.cancellationFee = parseFloat(r.amount);
          });
        }
      } else {
        self.$refs.noteTextArea.innerHTML = '';
        self.$store.commit('reservationNotes/setNotes', '');
        self.$store.commit('reservationNotes/setNoteStatus', 'new');
      }
    },
    admins: function admins(value) {
      if (value.length <= 0) {
        return;
      }
      var self = this;
      self.initTribute();
    }
  },
  mounted: function mounted() {
    /*
    let self = this
    document.addEventListener('keydown', (e) => {
      if (self.show && !self.isSubmitting && e.keyCode === 27) {
        self.close()
      }
    })
    */
  }
});

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Tribute = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return require(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utils = _interopRequireDefault(require("./utils"));

var _TributeEvents = _interopRequireDefault(require("./TributeEvents"));

var _TributeMenuEvents = _interopRequireDefault(require("./TributeMenuEvents"));

var _TributeRange = _interopRequireDefault(require("./TributeRange"));

var _TributeSearch = _interopRequireDefault(require("./TributeSearch"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Tribute =
/*#__PURE__*/
function () {
  function Tribute(_ref) {
    var _this = this;

    var _ref$values = _ref.values,
        values = _ref$values === void 0 ? null : _ref$values,
        _ref$iframe = _ref.iframe,
        iframe = _ref$iframe === void 0 ? null : _ref$iframe,
        _ref$selectClass = _ref.selectClass,
        selectClass = _ref$selectClass === void 0 ? 'highlight' : _ref$selectClass,
        _ref$trigger = _ref.trigger,
        trigger = _ref$trigger === void 0 ? '@' : _ref$trigger,
        _ref$autocompleteMode = _ref.autocompleteMode,
        autocompleteMode = _ref$autocompleteMode === void 0 ? false : _ref$autocompleteMode,
        _ref$selectTemplate = _ref.selectTemplate,
        selectTemplate = _ref$selectTemplate === void 0 ? null : _ref$selectTemplate,
        _ref$menuItemTemplate = _ref.menuItemTemplate,
        menuItemTemplate = _ref$menuItemTemplate === void 0 ? null : _ref$menuItemTemplate,
        _ref$lookup = _ref.lookup,
        lookup = _ref$lookup === void 0 ? 'key' : _ref$lookup,
        _ref$fillAttr = _ref.fillAttr,
        fillAttr = _ref$fillAttr === void 0 ? 'value' : _ref$fillAttr,
        _ref$collection = _ref.collection,
        collection = _ref$collection === void 0 ? null : _ref$collection,
        _ref$menuContainer = _ref.menuContainer,
        menuContainer = _ref$menuContainer === void 0 ? null : _ref$menuContainer,
        _ref$noMatchTemplate = _ref.noMatchTemplate,
        noMatchTemplate = _ref$noMatchTemplate === void 0 ? null : _ref$noMatchTemplate,
        _ref$requireLeadingSp = _ref.requireLeadingSpace,
        requireLeadingSpace = _ref$requireLeadingSp === void 0 ? true : _ref$requireLeadingSp,
        _ref$allowSpaces = _ref.allowSpaces,
        allowSpaces = _ref$allowSpaces === void 0 ? false : _ref$allowSpaces,
        _ref$replaceTextSuffi = _ref.replaceTextSuffix,
        replaceTextSuffix = _ref$replaceTextSuffi === void 0 ? null : _ref$replaceTextSuffi,
        _ref$positionMenu = _ref.positionMenu,
        positionMenu = _ref$positionMenu === void 0 ? true : _ref$positionMenu,
        _ref$spaceSelectsMatc = _ref.spaceSelectsMatch,
        spaceSelectsMatch = _ref$spaceSelectsMatc === void 0 ? false : _ref$spaceSelectsMatc,
        _ref$searchOpts = _ref.searchOpts,
        searchOpts = _ref$searchOpts === void 0 ? {} : _ref$searchOpts,
        _ref$menuItemLimit = _ref.menuItemLimit,
        menuItemLimit = _ref$menuItemLimit === void 0 ? null : _ref$menuItemLimit;

    _classCallCheck(this, Tribute);

    this.autocompleteMode = autocompleteMode;
    this.menuSelected = 0;
    this.current = {};
    this.inputEvent = false;
    this.isActive = false;
    this.menuContainer = menuContainer;
    this.allowSpaces = allowSpaces;
    this.replaceTextSuffix = replaceTextSuffix;
    this.positionMenu = positionMenu;
    this.hasTrailingSpace = false;
    this.spaceSelectsMatch = spaceSelectsMatch;

    if (this.autocompleteMode) {
      trigger = '';
      allowSpaces = false;
    }

    if (values) {
      this.collection = [{
        // symbol that starts the lookup
        trigger: trigger,
        // is it wrapped in an iframe
        iframe: iframe,
        // class applied to selected item
        selectClass: selectClass,
        // function called on select that retuns the content to insert
        selectTemplate: (selectTemplate || Tribute.defaultSelectTemplate).bind(this),
        // function called that returns content for an item
        menuItemTemplate: (menuItemTemplate || Tribute.defaultMenuItemTemplate).bind(this),
        // function called when menu is empty, disables hiding of menu.
        noMatchTemplate: function (t) {
          if (typeof t === 'function') {
            return t.bind(_this);
          }

          return noMatchTemplate || function () {
            return '';
          }.bind(_this);
        }(noMatchTemplate),
        // column to search against in the object
        lookup: lookup,
        // column that contains the content to insert by default
        fillAttr: fillAttr,
        // array of objects or a function returning an array of objects
        values: values,
        requireLeadingSpace: requireLeadingSpace,
        searchOpts: searchOpts,
        menuItemLimit: menuItemLimit
      }];
    } else if (collection) {
      if (this.autocompleteMode) console.warn('Tribute in autocomplete mode does not work for collections');
      this.collection = collection.map(function (item) {
        return {
          trigger: item.trigger || trigger,
          iframe: item.iframe || iframe,
          selectClass: item.selectClass || selectClass,
          selectTemplate: (item.selectTemplate || Tribute.defaultSelectTemplate).bind(_this),
          menuItemTemplate: (item.menuItemTemplate || Tribute.defaultMenuItemTemplate).bind(_this),
          // function called when menu is empty, disables hiding of menu.
          noMatchTemplate: function (t) {
            if (typeof t === 'function') {
              return t.bind(_this);
            }

            return null;
          }(noMatchTemplate),
          lookup: item.lookup || lookup,
          fillAttr: item.fillAttr || fillAttr,
          values: item.values,
          requireLeadingSpace: item.requireLeadingSpace,
          searchOpts: item.searchOpts || searchOpts,
          menuItemLimit: item.menuItemLimit || menuItemLimit
        };
      });
    } else {
      throw new Error('[Tribute] No collection specified.');
    }

    new _TributeRange["default"](this);
    new _TributeEvents["default"](this);
    new _TributeMenuEvents["default"](this);
    new _TributeSearch["default"](this);
  }

  _createClass(Tribute, [{
    key: "triggers",
    value: function triggers() {
      return this.collection.map(function (config) {
        return config.trigger;
      });
    }
  }, {
    key: "attach",
    value: function attach(el) {
      if (!el) {
        throw new Error('[Tribute] Must pass in a DOM node or NodeList.');
      } // Check if it is a jQuery collection


      if (typeof jQuery !== 'undefined' && el instanceof jQuery) {
        el = el.get();
      } // Is el an Array/Array-like object?


      if (el.constructor === NodeList || el.constructor === HTMLCollection || el.constructor === Array) {
        var length = el.length;

        for (var i = 0; i < length; ++i) {
          this._attach(el[i]);
        }
      } else {
        this._attach(el);
      }
    }
  }, {
    key: "_attach",
    value: function _attach(el) {
      if (el.hasAttribute('data-tribute')) {
        console.warn('Tribute was already bound to ' + el.nodeName);
      }

      this.ensureEditable(el);
      this.events.bind(el);
      el.setAttribute('data-tribute', true);
    }
  }, {
    key: "ensureEditable",
    value: function ensureEditable(element) {
      if (Tribute.inputTypes().indexOf(element.nodeName) === -1) {
        if (element.contentEditable) {
          element.contentEditable = true;
        } else {
          throw new Error('[Tribute] Cannot bind to ' + element.nodeName);
        }
      }
    }
  }, {
    key: "createMenu",
    value: function createMenu() {
      var wrapper = this.range.getDocument().createElement('div'),
          ul = this.range.getDocument().createElement('ul');
      wrapper.className = 'tribute-container';
      wrapper.appendChild(ul);

      if (this.menuContainer) {
        return this.menuContainer.appendChild(wrapper);
      }

      return this.range.getDocument().body.appendChild(wrapper);
    }
  }, {
    key: "showMenuFor",
    value: function showMenuFor(element, scrollTo) {
      var _this2 = this;

      // Only proceed if menu isn't already shown for the current element & mentionText
      if (this.isActive && this.current.element === element && this.current.mentionText === this.currentMentionTextSnapshot) {
        return;
      }

      this.currentMentionTextSnapshot = this.current.mentionText; // create the menu if it doesn't exist.

      if (!this.menu) {
        this.menu = this.createMenu();
        element.tributeMenu = this.menu;
        this.menuEvents.bind(this.menu);
      }

      this.isActive = true;
      this.menuSelected = 0;

      if (!this.current.mentionText) {
        this.current.mentionText = '';
      }

      var processValues = function processValues(values) {
        // Tribute may not be active any more by the time the value callback returns
        if (!_this2.isActive) {
          return;
        }

        var items = _this2.search.filter(_this2.current.mentionText, values, {
          pre: _this2.current.collection.searchOpts.pre || '<span>',
          post: _this2.current.collection.searchOpts.post || '</span>',
          skip: _this2.current.collection.searchOpts.skip,
          extract: function extract(el) {
            if (typeof _this2.current.collection.lookup === 'string') {
              return el[_this2.current.collection.lookup];
            } else if (typeof _this2.current.collection.lookup === 'function') {
              return _this2.current.collection.lookup(el, _this2.current.mentionText);
            } else {
              throw new Error('Invalid lookup attribute, lookup must be string or function.');
            }
          }
        });

        _this2.current.filteredItems = items;

        var ul = _this2.menu.querySelector('ul');

        _this2.range.positionMenuAtCaret(scrollTo);

        if (!items.length) {
          var noMatchEvent = new CustomEvent('tribute-no-match', {
            detail: _this2.menu
          });

          _this2.current.element.dispatchEvent(noMatchEvent);

          if (typeof _this2.current.collection.noMatchTemplate === 'function' && !_this2.current.collection.noMatchTemplate() || !_this2.current.collection.noMatchTemplate) {
            _this2.hideMenu();
          } else {
            typeof _this2.current.collection.noMatchTemplate === 'function' ? ul.innerHTML = _this2.current.collection.noMatchTemplate() : ul.innerHTML = _this2.current.collection.noMatchTemplate;
          }

          return;
        }

        if (_this2.current.collection.menuItemLimit) {
          items = items.slice(0, _this2.current.collection.menuItemLimit);
        }

        ul.innerHTML = '';

        var fragment = _this2.range.getDocument().createDocumentFragment();

        items.forEach(function (item, index) {
          var li = _this2.range.getDocument().createElement('li');

          li.setAttribute('data-index', index);
          li.addEventListener('mousemove', function (e) {
            var _this2$_findLiTarget = _this2._findLiTarget(e.target),
                _this2$_findLiTarget2 = _slicedToArray(_this2$_findLiTarget, 2),
                li = _this2$_findLiTarget2[0],
                index = _this2$_findLiTarget2[1];

            if (e.movementY !== 0) {
              _this2.events.setActiveLi(index);
            }
          });

          if (_this2.menuSelected === index) {
            li.className = _this2.current.collection.selectClass;
          }

          li.innerHTML = _this2.current.collection.menuItemTemplate(item);
          fragment.appendChild(li);
        });
        ul.appendChild(fragment);
      };

      if (typeof this.current.collection.values === 'function') {
        this.current.collection.values(this.current.mentionText, processValues);
      } else {
        processValues(this.current.collection.values);
      }
    }
  }, {
    key: "_findLiTarget",
    value: function _findLiTarget(el) {
      if (!el) return [];
      var index = el.getAttribute('data-index');
      return !index ? this._findLiTarget(el.parentNode) : [el, index];
    }
  }, {
    key: "showMenuForCollection",
    value: function showMenuForCollection(element, collectionIndex) {
      if (element !== document.activeElement) {
        this.placeCaretAtEnd(element);
      }

      this.current.collection = this.collection[collectionIndex || 0];
      this.current.externalTrigger = true;
      this.current.element = element;
      if (element.isContentEditable) this.insertTextAtCursor(this.current.collection.trigger);else this.insertAtCaret(element, this.current.collection.trigger);
      this.showMenuFor(element);
    } // TODO: make sure this works for inputs/textareas

  }, {
    key: "placeCaretAtEnd",
    value: function placeCaretAtEnd(el) {
      el.focus();

      if (typeof window.getSelection != "undefined" && typeof document.createRange != "undefined") {
        var range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      } else if (typeof document.body.createTextRange != "undefined") {
        var textRange = document.body.createTextRange();
        textRange.moveToElementText(el);
        textRange.collapse(false);
        textRange.select();
      }
    } // for contenteditable

  }, {
    key: "insertTextAtCursor",
    value: function insertTextAtCursor(text) {
      var sel, range, html;
      sel = window.getSelection();
      range = sel.getRangeAt(0);
      range.deleteContents();
      var textNode = document.createTextNode(text);
      range.insertNode(textNode);
      range.selectNodeContents(textNode);
      range.collapse(false);
      sel.removeAllRanges();
      sel.addRange(range);
    } // for regular inputs

  }, {
    key: "insertAtCaret",
    value: function insertAtCaret(textarea, text) {
      var scrollPos = textarea.scrollTop;
      var caretPos = textarea.selectionStart;
      var front = textarea.value.substring(0, caretPos);
      var back = textarea.value.substring(textarea.selectionEnd, textarea.value.length);
      textarea.value = front + text + back;
      caretPos = caretPos + text.length;
      textarea.selectionStart = caretPos;
      textarea.selectionEnd = caretPos;
      textarea.focus();
      textarea.scrollTop = scrollPos;
    }
  }, {
    key: "hideMenu",
    value: function hideMenu() {
      if (this.menu) {
        this.menu.style.cssText = 'display: none;';
        this.isActive = false;
        this.menuSelected = 0;
        this.current = {};
      }
    }
  }, {
    key: "selectItemAtIndex",
    value: function selectItemAtIndex(index, originalEvent) {
      index = parseInt(index);
      if (typeof index !== 'number' || isNaN(index)) return;
      var item = this.current.filteredItems[index];
      var content = this.current.collection.selectTemplate(item);
      if (content !== null) this.replaceText(content, originalEvent, item);
    }
  }, {
    key: "replaceText",
    value: function replaceText(content, originalEvent, item) {
      this.range.replaceTriggerText(content, true, true, originalEvent, item);
    }
  }, {
    key: "_append",
    value: function _append(collection, newValues, replace) {
      if (typeof collection.values === 'function') {
        throw new Error('Unable to append to values, as it is a function.');
      } else if (!replace) {
        collection.values = collection.values.concat(newValues);
      } else {
        collection.values = newValues;
      }
    }
  }, {
    key: "append",
    value: function append(collectionIndex, newValues, replace) {
      var index = parseInt(collectionIndex);
      if (typeof index !== 'number') throw new Error('please provide an index for the collection to update.');
      var collection = this.collection[index];

      this._append(collection, newValues, replace);
    }
  }, {
    key: "appendCurrent",
    value: function appendCurrent(newValues, replace) {
      if (this.isActive) {
        this._append(this.current.collection, newValues, replace);
      } else {
        throw new Error('No active state. Please use append instead and pass an index.');
      }
    }
  }, {
    key: "detach",
    value: function detach(el) {
      if (!el) {
        throw new Error('[Tribute] Must pass in a DOM node or NodeList.');
      } // Check if it is a jQuery collection


      if (typeof jQuery !== 'undefined' && el instanceof jQuery) {
        el = el.get();
      } // Is el an Array/Array-like object?


      if (el.constructor === NodeList || el.constructor === HTMLCollection || el.constructor === Array) {
        var length = el.length;

        for (var i = 0; i < length; ++i) {
          this._detach(el[i]);
        }
      } else {
        this._detach(el);
      }
    }
  }, {
    key: "_detach",
    value: function _detach(el) {
      var _this3 = this;

      this.events.unbind(el);

      if (el.tributeMenu) {
        this.menuEvents.unbind(el.tributeMenu);
      }

      setTimeout(function () {
        el.removeAttribute('data-tribute');
        _this3.isActive = false;

        if (el.tributeMenu) {
          el.tributeMenu.remove();
        }
      });
    }
  }], [{
    key: "defaultSelectTemplate",
    value: function defaultSelectTemplate(item) {
      if (typeof item === 'undefined') return null;

      if (this.range.isContentEditable(this.current.element)) {
        return '<span class="tribute-mention">' + (this.current.collection.trigger + item.original[this.current.collection.fillAttr]) + '</span>';
      }

      return this.current.collection.trigger + item.original[this.current.collection.fillAttr];
    }
  }, {
    key: "defaultMenuItemTemplate",
    value: function defaultMenuItemTemplate(matchItem) {
      return matchItem.string;
    }
  }, {
    key: "inputTypes",
    value: function inputTypes() {
      return ['TEXTAREA', 'INPUT'];
    }
  }]);

  return Tribute;
}();

var _default = Tribute;
exports["default"] = _default;
module.exports = exports.default;

},{"./TributeEvents":2,"./TributeMenuEvents":3,"./TributeRange":4,"./TributeSearch":5,"./utils":7}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var TributeEvents =
/*#__PURE__*/
function () {
  function TributeEvents(tribute) {
    _classCallCheck(this, TributeEvents);

    this.tribute = tribute;
    this.tribute.events = this;
  }

  _createClass(TributeEvents, [{
    key: "bind",
    value: function bind(element) {
      element.boundKeydown = this.keydown.bind(element, this);
      element.boundKeyup = this.keyup.bind(element, this);
      element.boundInput = this.input.bind(element, this);
      element.addEventListener('keydown', element.boundKeydown, false);
      element.addEventListener('keyup', element.boundKeyup, false);
      element.addEventListener('input', element.boundInput, false);
    }
  }, {
    key: "unbind",
    value: function unbind(element) {
      element.removeEventListener('keydown', element.boundKeydown, false);
      element.removeEventListener('keyup', element.boundKeyup, false);
      element.removeEventListener('input', element.boundInput, false);
      delete element.boundKeydown;
      delete element.boundKeyup;
      delete element.boundInput;
    }
  }, {
    key: "keydown",
    value: function keydown(instance, event) {
      if (instance.shouldDeactivate(event)) {
        instance.tribute.isActive = false;
        instance.tribute.hideMenu();
      }

      var element = this;
      instance.commandEvent = false;
      TributeEvents.keys().forEach(function (o) {
        if (o.key === event.keyCode) {
          instance.commandEvent = true;
          instance.callbacks()[o.value.toLowerCase()](event, element);
        }
      });
    }
  }, {
    key: "input",
    value: function input(instance, event) {
      instance.inputEvent = true;
      instance.keyup.call(this, instance, event);
    }
  }, {
    key: "click",
    value: function click(instance, event) {
      var tribute = instance.tribute;

      if (tribute.menu && tribute.menu.contains(event.target)) {
        var li = event.target;
        event.preventDefault();
        event.stopPropagation();

        while (li.nodeName.toLowerCase() !== 'li') {
          li = li.parentNode;

          if (!li || li === tribute.menu) {
            throw new Error('cannot find the <li> container for the click');
          }
        }

        tribute.selectItemAtIndex(li.getAttribute('data-index'), event);
        tribute.hideMenu(); // TODO: should fire with externalTrigger and target is outside of menu
      } else if (tribute.current.element && !tribute.current.externalTrigger) {
        tribute.current.externalTrigger = false;
        setTimeout(function () {
          return tribute.hideMenu();
        });
      }
    }
  }, {
    key: "keyup",
    value: function keyup(instance, event) {
      if (instance.inputEvent) {
        instance.inputEvent = false;
      }

      instance.updateSelection(this);
      if (event.keyCode === 27) return;

      if (!instance.tribute.allowSpaces && instance.tribute.hasTrailingSpace) {
        instance.tribute.hasTrailingSpace = false;
        instance.commandEvent = true;
        instance.callbacks()["space"](event, this);
        return;
      }

      if (!instance.tribute.isActive) {
        if (instance.tribute.autocompleteMode) {
          instance.callbacks().triggerChar(event, this, '');
        } else {
          var keyCode = instance.getKeyCode(instance, this, event);
          if (isNaN(keyCode) || !keyCode) return;
          var trigger = instance.tribute.triggers().find(function (trigger) {
            return trigger.charCodeAt(0) === keyCode;
          });

          if (typeof trigger !== 'undefined') {
            instance.callbacks().triggerChar(event, this, trigger);
          }
        }
      }

      if ((instance.tribute.current.trigger || instance.tribute.autocompleteMode) && instance.commandEvent === false || instance.tribute.isActive && event.keyCode === 8) {
        instance.tribute.showMenuFor(this, true);
      }
    }
  }, {
    key: "shouldDeactivate",
    value: function shouldDeactivate(event) {
      if (!this.tribute.isActive) return false;

      if (this.tribute.current.mentionText.length === 0) {
        var eventKeyPressed = false;
        TributeEvents.keys().forEach(function (o) {
          if (event.keyCode === o.key) eventKeyPressed = true;
        });
        return !eventKeyPressed;
      }

      return false;
    }
  }, {
    key: "getKeyCode",
    value: function getKeyCode(instance, el, event) {
      var _char;

      var tribute = instance.tribute;
      var info = tribute.range.getTriggerInfo(false, tribute.hasTrailingSpace, true, tribute.allowSpaces, tribute.autocompleteMode);

      if (info) {
        return info.mentionTriggerChar.charCodeAt(0);
      } else {
        return false;
      }
    }
  }, {
    key: "updateSelection",
    value: function updateSelection(el) {
      this.tribute.current.element = el;
      var info = this.tribute.range.getTriggerInfo(false, this.tribute.hasTrailingSpace, true, this.tribute.allowSpaces, this.tribute.autocompleteMode);

      if (info) {
        this.tribute.current.selectedPath = info.mentionSelectedPath;
        this.tribute.current.mentionText = info.mentionText;
        this.tribute.current.selectedOffset = info.mentionSelectedOffset;
      }
    }
  }, {
    key: "callbacks",
    value: function callbacks() {
      var _this = this;

      return {
        triggerChar: function triggerChar(e, el, trigger) {
          var tribute = _this.tribute;
          tribute.current.trigger = trigger;
          var collectionItem = tribute.collection.find(function (item) {
            return item.trigger === trigger;
          });
          tribute.current.collection = collectionItem;
          if (tribute.inputEvent) tribute.showMenuFor(el, true);
        },
        enter: function enter(e, el) {
          // choose selection
          if (_this.tribute.isActive && _this.tribute.current.filteredItems) {
            e.preventDefault();
            e.stopPropagation();
            setTimeout(function () {
              _this.tribute.selectItemAtIndex(_this.tribute.menuSelected, e);

              _this.tribute.hideMenu();
            }, 0);
          }
        },
        escape: function escape(e, el) {
          if (_this.tribute.isActive) {
            e.preventDefault();
            e.stopPropagation();
            _this.tribute.isActive = false;

            _this.tribute.hideMenu();
          }
        },
        tab: function tab(e, el) {
          // choose first match
          _this.callbacks().enter(e, el);
        },
        space: function space(e, el) {
          if (_this.tribute.isActive) {
            if (_this.tribute.spaceSelectsMatch) {
              _this.callbacks().enter(e, el);
            } else if (!_this.tribute.allowSpaces) {
              e.stopPropagation();
              setTimeout(function () {
                _this.tribute.hideMenu();

                _this.tribute.isActive = false;
              }, 0);
            }
          }
        },
        up: function up(e, el) {
          // navigate up ul
          if (_this.tribute.isActive && _this.tribute.current.filteredItems) {
            e.preventDefault();
            e.stopPropagation();
            var count = _this.tribute.current.filteredItems.length,
                selected = _this.tribute.menuSelected;

            if (count > selected && selected > 0) {
              _this.tribute.menuSelected--;

              _this.setActiveLi();
            } else if (selected === 0) {
              _this.tribute.menuSelected = count - 1;

              _this.setActiveLi();

              _this.tribute.menu.scrollTop = _this.tribute.menu.scrollHeight;
            }
          }
        },
        down: function down(e, el) {
          // navigate down ul
          if (_this.tribute.isActive && _this.tribute.current.filteredItems) {
            e.preventDefault();
            e.stopPropagation();
            var count = _this.tribute.current.filteredItems.length - 1,
                selected = _this.tribute.menuSelected;

            if (count > selected) {
              _this.tribute.menuSelected++;

              _this.setActiveLi();
            } else if (count === selected) {
              _this.tribute.menuSelected = 0;

              _this.setActiveLi();

              _this.tribute.menu.scrollTop = 0;
            }
          }
        },
        "delete": function _delete(e, el) {
          if (_this.tribute.isActive && _this.tribute.current.mentionText.length < 1) {
            _this.tribute.hideMenu();
          } else if (_this.tribute.isActive) {
            _this.tribute.showMenuFor(el);
          }
        }
      };
    }
  }, {
    key: "setActiveLi",
    value: function setActiveLi(index) {
      var lis = this.tribute.menu.querySelectorAll('li'),
          length = lis.length >>> 0;
      if (index) this.tribute.menuSelected = parseInt(index);

      for (var i = 0; i < length; i++) {
        var li = lis[i];

        if (i === this.tribute.menuSelected) {
          li.classList.add(this.tribute.current.collection.selectClass);
          var liClientRect = li.getBoundingClientRect();
          var menuClientRect = this.tribute.menu.getBoundingClientRect();

          if (liClientRect.bottom > menuClientRect.bottom) {
            var scrollDistance = liClientRect.bottom - menuClientRect.bottom;
            this.tribute.menu.scrollTop += scrollDistance;
          } else if (liClientRect.top < menuClientRect.top) {
            var _scrollDistance = menuClientRect.top - liClientRect.top;

            this.tribute.menu.scrollTop -= _scrollDistance;
          }
        } else {
          li.classList.remove(this.tribute.current.collection.selectClass);
        }
      }
    }
  }, {
    key: "getFullHeight",
    value: function getFullHeight(elem, includeMargin) {
      var height = elem.getBoundingClientRect().height;

      if (includeMargin) {
        var style = elem.currentStyle || window.getComputedStyle(elem);
        return height + parseFloat(style.marginTop) + parseFloat(style.marginBottom);
      }

      return height;
    }
  }], [{
    key: "keys",
    value: function keys() {
      return [{
        key: 9,
        value: 'TAB'
      }, {
        key: 8,
        value: 'DELETE'
      }, {
        key: 13,
        value: 'ENTER'
      }, {
        key: 27,
        value: 'ESCAPE'
      }, {
        key: 32,
        value: 'SPACE'
      }, {
        key: 38,
        value: 'UP'
      }, {
        key: 40,
        value: 'DOWN'
      }];
    }
  }]);

  return TributeEvents;
}();

var _default = TributeEvents;
exports["default"] = _default;
module.exports = exports.default;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var TributeMenuEvents =
/*#__PURE__*/
function () {
  function TributeMenuEvents(tribute) {
    _classCallCheck(this, TributeMenuEvents);

    this.tribute = tribute;
    this.tribute.menuEvents = this;
    this.menu = this.tribute.menu;
  }

  _createClass(TributeMenuEvents, [{
    key: "bind",
    value: function bind(menu) {
      var _this = this;

      this.menuClickEvent = this.tribute.events.click.bind(null, this);
      this.menuContainerScrollEvent = this.debounce(function () {
        if (_this.tribute.isActive) {
          _this.tribute.showMenuFor(_this.tribute.current.element, false);
        }
      }, 300, false);
      this.windowResizeEvent = this.debounce(function () {
        if (_this.tribute.isActive) {
          _this.tribute.range.positionMenuAtCaret(true);
        }
      }, 300, false); // fixes IE11 issues with mousedown

      this.tribute.range.getDocument().addEventListener('MSPointerDown', this.menuClickEvent, false);
      this.tribute.range.getDocument().addEventListener('mousedown', this.menuClickEvent, false);
      window.addEventListener('resize', this.windowResizeEvent);

      if (this.menuContainer) {
        this.menuContainer.addEventListener('scroll', this.menuContainerScrollEvent, false);
      } else {
        window.addEventListener('scroll', this.menuContainerScrollEvent);
      }
    }
  }, {
    key: "unbind",
    value: function unbind(menu) {
      this.tribute.range.getDocument().removeEventListener('mousedown', this.menuClickEvent, false);
      this.tribute.range.getDocument().removeEventListener('MSPointerDown', this.menuClickEvent, false);
      window.removeEventListener('resize', this.windowResizeEvent);

      if (this.menuContainer) {
        this.menuContainer.removeEventListener('scroll', this.menuContainerScrollEvent, false);
      } else {
        window.removeEventListener('scroll', this.menuContainerScrollEvent);
      }
    }
  }, {
    key: "debounce",
    value: function debounce(func, wait, immediate) {
      var _this2 = this,
          _arguments = arguments;

      var timeout;
      return function () {
        var context = _this2,
            args = _arguments;

        var later = function later() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }
  }]);

  return TributeMenuEvents;
}();

var _default = TributeMenuEvents;
exports["default"] = _default;
module.exports = exports.default;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// Thanks to https://github.com/jeff-collins/ment.io
var TributeRange =
/*#__PURE__*/
function () {
  function TributeRange(tribute) {
    _classCallCheck(this, TributeRange);

    this.tribute = tribute;
    this.tribute.range = this;
  }

  _createClass(TributeRange, [{
    key: "getDocument",
    value: function getDocument() {
      var iframe;

      if (this.tribute.current.collection) {
        iframe = this.tribute.current.collection.iframe;
      }

      if (!iframe) {
        return document;
      }

      return iframe.contentWindow.document;
    }
  }, {
    key: "positionMenuAtCaret",
    value: function positionMenuAtCaret(scrollTo) {
      var _this = this;

      var context = this.tribute.current,
          coordinates;
      var info = this.getTriggerInfo(false, this.tribute.hasTrailingSpace, true, this.tribute.allowSpaces, this.tribute.autocompleteMode);

      if (typeof info !== 'undefined') {
        if (!this.tribute.positionMenu) {
          this.tribute.menu.style.cssText = "display: block;";
          return;
        }

        if (!this.isContentEditable(context.element)) {
          coordinates = this.getTextAreaOrInputUnderlinePosition(this.tribute.current.element, info.mentionPosition);
        } else {
          coordinates = this.getContentEditableCaretPosition(info.mentionPosition);
        }

        this.tribute.menu.style.cssText = "top: ".concat(coordinates.top, "px;\n                                     left: ").concat(coordinates.left, "px;\n                                     right: ").concat(coordinates.right, "px;\n                                     bottom: ").concat(coordinates.bottom, "px;\n                                     position: absolute;\n                                     z-index: 10000;\n                                     display: block;");

        if (coordinates.left === 'auto') {
          this.tribute.menu.style.left = 'auto';
        }

        if (coordinates.top === 'auto') {
          this.tribute.menu.style.top = 'auto';
        }

        if (scrollTo) this.scrollIntoView();
        window.setTimeout(function () {
          var menuDimensions = {
            width: _this.tribute.menu.offsetWidth,
            height: _this.tribute.menu.offsetHeight
          };

          var menuIsOffScreen = _this.isMenuOffScreen(coordinates, menuDimensions);

          var menuIsOffScreenHorizontally = window.innerWidth > menuDimensions.width && (menuIsOffScreen.left || menuIsOffScreen.right);
          var menuIsOffScreenVertically = window.innerHeight > menuDimensions.height && (menuIsOffScreen.top || menuIsOffScreen.bottom);

          if (menuIsOffScreenHorizontally || menuIsOffScreenVertically) {
            _this.tribute.menu.style.cssText = 'display: none';

            _this.positionMenuAtCaret(scrollTo);
          }
        }, 0);
      } else {
        this.tribute.menu.style.cssText = 'display: none';
      }
    }
  }, {
    key: "selectElement",
    value: function selectElement(targetElement, path, offset) {
      var range;
      var elem = targetElement;

      if (path) {
        for (var i = 0; i < path.length; i++) {
          elem = elem.childNodes[path[i]];

          if (elem === undefined) {
            return;
          }

          while (elem.length < offset) {
            offset -= elem.length;
            elem = elem.nextSibling;
          }

          if (elem.childNodes.length === 0 && !elem.length) {
            elem = elem.previousSibling;
          }
        }
      }

      var sel = this.getWindowSelection();
      range = this.getDocument().createRange();
      range.setStart(elem, offset);
      range.setEnd(elem, offset);
      range.collapse(true);

      try {
        sel.removeAllRanges();
      } catch (error) {}

      sel.addRange(range);
      targetElement.focus();
    }
  }, {
    key: "replaceTriggerText",
    value: function replaceTriggerText(text, requireLeadingSpace, hasTrailingSpace, originalEvent, item) {
      var info = this.getTriggerInfo(true, hasTrailingSpace, requireLeadingSpace, this.tribute.allowSpaces, this.tribute.autocompleteMode);

      if (info !== undefined) {
        var context = this.tribute.current;
        var replaceEvent = new CustomEvent('tribute-replaced', {
          detail: {
            item: item,
            instance: context,
            context: info,
            event: originalEvent
          }
        });

        if (!this.isContentEditable(context.element)) {
          var myField = this.tribute.current.element;
          var textSuffix = typeof this.tribute.replaceTextSuffix == 'string' ? this.tribute.replaceTextSuffix : ' ';
          text += textSuffix;
          var startPos = info.mentionPosition;
          var endPos = info.mentionPosition + info.mentionText.length + textSuffix.length;
          myField.value = myField.value.substring(0, startPos) + text + myField.value.substring(endPos, myField.value.length);
          myField.selectionStart = startPos + text.length;
          myField.selectionEnd = startPos + text.length;
        } else {
          // add a space to the end of the pasted text
          var _textSuffix = typeof this.tribute.replaceTextSuffix == 'string' ? this.tribute.replaceTextSuffix : '\xA0';

          text += _textSuffix;
          this.pasteHtml(text, info.mentionPosition, info.mentionPosition + info.mentionText.length + !this.tribute.autocompleteMode);
        }

        context.element.dispatchEvent(replaceEvent);
      }
    }
  }, {
    key: "pasteHtml",
    value: function pasteHtml(html, startPos, endPos) {
      var range, sel;
      sel = this.getWindowSelection();
      range = this.getDocument().createRange();
      range.setStart(sel.anchorNode, startPos);
      range.setEnd(sel.anchorNode, endPos);
      range.deleteContents();
      var el = this.getDocument().createElement('div');
      el.innerHTML = html;
      var frag = this.getDocument().createDocumentFragment(),
          node,
          lastNode;

      while (node = el.firstChild) {
        lastNode = frag.appendChild(node);
      }

      range.insertNode(frag); // Preserve the selection

      if (lastNode) {
        range = range.cloneRange();
        range.setStartAfter(lastNode);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }
  }, {
    key: "getWindowSelection",
    value: function getWindowSelection() {
      if (this.tribute.collection.iframe) {
        return this.tribute.collection.iframe.contentWindow.getSelection();
      }

      return window.getSelection();
    }
  }, {
    key: "getNodePositionInParent",
    value: function getNodePositionInParent(element) {
      if (element.parentNode === null) {
        return 0;
      }

      for (var i = 0; i < element.parentNode.childNodes.length; i++) {
        var node = element.parentNode.childNodes[i];

        if (node === element) {
          return i;
        }
      }
    }
  }, {
    key: "getContentEditableSelectedPath",
    value: function getContentEditableSelectedPath(ctx) {
      var sel = this.getWindowSelection();
      var selected = sel.anchorNode;
      var path = [];
      var offset;

      if (selected != null) {
        var i;
        var ce = selected.contentEditable;

        while (selected !== null && ce !== 'true') {
          i = this.getNodePositionInParent(selected);
          path.push(i);
          selected = selected.parentNode;

          if (selected !== null) {
            ce = selected.contentEditable;
          }
        }

        path.reverse(); // getRangeAt may not exist, need alternative

        offset = sel.getRangeAt(0).startOffset;
        return {
          selected: selected,
          path: path,
          offset: offset
        };
      }
    }
  }, {
    key: "getTextPrecedingCurrentSelection",
    value: function getTextPrecedingCurrentSelection() {
      var context = this.tribute.current,
          text = '';

      if (!this.isContentEditable(context.element)) {
        var textComponent = this.tribute.current.element;

        if (textComponent) {
          var startPos = textComponent.selectionStart;

          if (textComponent.value && startPos >= 0) {
            text = textComponent.value.substring(0, startPos);
          }
        }
      } else {
        var selectedElem = this.getWindowSelection().anchorNode;

        if (selectedElem != null) {
          var workingNodeContent = selectedElem.textContent;
          var selectStartOffset = this.getWindowSelection().getRangeAt(0).startOffset;

          if (workingNodeContent && selectStartOffset >= 0) {
            text = workingNodeContent.substring(0, selectStartOffset);
          }
        }
      }

      return text;
    }
  }, {
    key: "getLastWordInText",
    value: function getLastWordInText(text) {
      text = text.replace(/\u00A0/g, ' '); // https://stackoverflow.com/questions/29850407/how-do-i-replace-unicode-character-u00a0-with-a-space-in-javascript

      var wordsArray = text.split(' ');
      var worldsCount = wordsArray.length - 1;
      return wordsArray[worldsCount].trim();
    }
  }, {
    key: "getTriggerInfo",
    value: function getTriggerInfo(menuAlreadyActive, hasTrailingSpace, requireLeadingSpace, allowSpaces, isAutocomplete) {
      var _this2 = this;

      var ctx = this.tribute.current;
      var selected, path, offset;

      if (!this.isContentEditable(ctx.element)) {
        selected = this.tribute.current.element;
      } else {
        var selectionInfo = this.getContentEditableSelectedPath(ctx);

        if (selectionInfo) {
          selected = selectionInfo.selected;
          path = selectionInfo.path;
          offset = selectionInfo.offset;
        }
      }

      var effectiveRange = this.getTextPrecedingCurrentSelection();
      var lastWordOfEffectiveRange = this.getLastWordInText(effectiveRange);

      if (isAutocomplete) {
        return {
          mentionPosition: effectiveRange.length - lastWordOfEffectiveRange.length,
          mentionText: lastWordOfEffectiveRange,
          mentionSelectedElement: selected,
          mentionSelectedPath: path,
          mentionSelectedOffset: offset
        };
      }

      if (effectiveRange !== undefined && effectiveRange !== null) {
        var mostRecentTriggerCharPos = -1;
        var triggerChar;
        this.tribute.collection.forEach(function (config) {
          var c = config.trigger;
          var idx = config.requireLeadingSpace ? _this2.lastIndexWithLeadingSpace(effectiveRange, c) : effectiveRange.lastIndexOf(c);

          if (idx > mostRecentTriggerCharPos) {
            mostRecentTriggerCharPos = idx;
            triggerChar = c;
            requireLeadingSpace = config.requireLeadingSpace;
          }
        });

        if (mostRecentTriggerCharPos >= 0 && (mostRecentTriggerCharPos === 0 || !requireLeadingSpace || /[\xA0\s]/g.test(effectiveRange.substring(mostRecentTriggerCharPos - 1, mostRecentTriggerCharPos)))) {
          var currentTriggerSnippet = effectiveRange.substring(mostRecentTriggerCharPos + 1, effectiveRange.length);
          triggerChar = effectiveRange.substring(mostRecentTriggerCharPos, mostRecentTriggerCharPos + 1);
          var firstSnippetChar = currentTriggerSnippet.substring(0, 1);
          var leadingSpace = currentTriggerSnippet.length > 0 && (firstSnippetChar === ' ' || firstSnippetChar === '\xA0');

          if (hasTrailingSpace) {
            currentTriggerSnippet = currentTriggerSnippet.trim();
          }

          var regex = allowSpaces ? /[^\S ]/g : /[\xA0\s]/g;
          this.tribute.hasTrailingSpace = regex.test(currentTriggerSnippet);

          if (!leadingSpace && (menuAlreadyActive || !regex.test(currentTriggerSnippet))) {
            return {
              mentionPosition: mostRecentTriggerCharPos,
              mentionText: currentTriggerSnippet,
              mentionSelectedElement: selected,
              mentionSelectedPath: path,
              mentionSelectedOffset: offset,
              mentionTriggerChar: triggerChar
            };
          }
        }
      }
    }
  }, {
    key: "lastIndexWithLeadingSpace",
    value: function lastIndexWithLeadingSpace(str, _char) {
      var reversedStr = str.split('').reverse().join('');
      var index = -1;

      for (var cidx = 0, len = str.length; cidx < len; cidx++) {
        var firstChar = cidx === str.length - 1;
        var leadingSpace = /\s/.test(reversedStr[cidx + 1]);
        var match = _char === reversedStr[cidx];

        if (match && (firstChar || leadingSpace)) {
          index = str.length - 1 - cidx;
          break;
        }
      }

      return index;
    }
  }, {
    key: "isContentEditable",
    value: function isContentEditable(element) {
      return element.nodeName !== 'INPUT' && element.nodeName !== 'TEXTAREA';
    }
  }, {
    key: "isMenuOffScreen",
    value: function isMenuOffScreen(coordinates, menuDimensions) {
      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;
      var doc = document.documentElement;
      var windowLeft = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
      var windowTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
      var menuTop = typeof coordinates.top === 'number' ? coordinates.top : windowTop + windowHeight - coordinates.bottom - menuDimensions.height;
      var menuRight = typeof coordinates.right === 'number' ? coordinates.right : coordinates.left + menuDimensions.width;
      var menuBottom = typeof coordinates.bottom === 'number' ? coordinates.bottom : coordinates.top + menuDimensions.height;
      var menuLeft = typeof coordinates.left === 'number' ? coordinates.left : windowLeft + windowWidth - coordinates.right - menuDimensions.width;
      return {
        top: menuTop < Math.floor(windowTop),
        right: menuRight > Math.ceil(windowLeft + windowWidth),
        bottom: menuBottom > Math.ceil(windowTop + windowHeight),
        left: menuLeft < Math.floor(windowLeft)
      };
    }
  }, {
    key: "getMenuDimensions",
    value: function getMenuDimensions() {
      // Width of the menu depends of its contents and position
      // We must check what its width would be without any obstruction
      // This way, we can achieve good positioning for flipping the menu
      var dimensions = {
        width: null,
        height: null
      };
      this.tribute.menu.style.cssText = "top: 0px;\n                                 left: 0px;\n                                 position: fixed;\n                                 zIndex: 10000;\n                                 display: block;\n                                 visibility; hidden;";
      dimensions.width = this.tribute.menu.offsetWidth;
      dimensions.height = this.tribute.menu.offsetHeight;
      this.tribute.menu.style.cssText = "display: none;";
      return dimensions;
    }
  }, {
    key: "getTextAreaOrInputUnderlinePosition",
    value: function getTextAreaOrInputUnderlinePosition(element, position, flipped) {
      var properties = ['direction', 'boxSizing', 'width', 'height', 'overflowX', 'overflowY', 'borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'fontStyle', 'fontVariant', 'fontWeight', 'fontStretch', 'fontSize', 'fontSizeAdjust', 'lineHeight', 'fontFamily', 'textAlign', 'textTransform', 'textIndent', 'textDecoration', 'letterSpacing', 'wordSpacing'];
      var isFirefox = window.mozInnerScreenX !== null;
      var div = this.getDocument().createElement('div');
      div.id = 'input-textarea-caret-position-mirror-div';
      this.getDocument().body.appendChild(div);
      var style = div.style;
      var computed = window.getComputedStyle ? getComputedStyle(element) : element.currentStyle;
      style.whiteSpace = 'pre-wrap';

      if (element.nodeName !== 'INPUT') {
        style.wordWrap = 'break-word';
      } // position off-screen


      style.position = 'absolute';
      style.visibility = 'hidden'; // transfer the element's properties to the div

      properties.forEach(function (prop) {
        style[prop] = computed[prop];
      });

      if (isFirefox) {
        style.width = "".concat(parseInt(computed.width) - 2, "px");
        if (element.scrollHeight > parseInt(computed.height)) style.overflowY = 'scroll';
      } else {
        style.overflow = 'hidden';
      }

      div.textContent = element.value.substring(0, position);

      if (element.nodeName === 'INPUT') {
        div.textContent = div.textContent.replace(/\s/g, ' ');
      }

      var span = this.getDocument().createElement('span');
      span.textContent = element.value.substring(position) || '.';
      div.appendChild(span);
      var rect = element.getBoundingClientRect();
      var doc = document.documentElement;
      var windowLeft = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
      var windowTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
      var coordinates = {
        top: rect.top + windowTop + span.offsetTop + parseInt(computed.borderTopWidth) + parseInt(computed.fontSize) - element.scrollTop,
        left: rect.left + windowLeft + span.offsetLeft + parseInt(computed.borderLeftWidth)
      };
      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;
      var menuDimensions = this.getMenuDimensions();
      var menuIsOffScreen = this.isMenuOffScreen(coordinates, menuDimensions);

      if (menuIsOffScreen.right) {
        coordinates.right = windowWidth - coordinates.left;
        coordinates.left = 'auto';
      }

      var parentHeight = this.tribute.menuContainer ? this.tribute.menuContainer.offsetHeight : this.getDocument().body.offsetHeight;

      if (menuIsOffScreen.bottom) {
        var parentRect = this.tribute.menuContainer ? this.tribute.menuContainer.getBoundingClientRect() : this.getDocument().body.getBoundingClientRect();
        var scrollStillAvailable = parentHeight - (windowHeight - parentRect.top);
        coordinates.bottom = scrollStillAvailable + (windowHeight - rect.top - span.offsetTop);
        coordinates.top = 'auto';
      }

      menuIsOffScreen = this.isMenuOffScreen(coordinates, menuDimensions);

      if (menuIsOffScreen.left) {
        coordinates.left = windowWidth > menuDimensions.width ? windowLeft + windowWidth - menuDimensions.width : windowLeft;
        delete coordinates.right;
      }

      if (menuIsOffScreen.top) {
        coordinates.top = windowHeight > menuDimensions.height ? windowTop + windowHeight - menuDimensions.height : windowTop;
        delete coordinates.bottom;
      }

      this.getDocument().body.removeChild(div);
      return coordinates;
    }
  }, {
    key: "getContentEditableCaretPosition",
    value: function getContentEditableCaretPosition(selectedNodePosition) {
      var markerTextChar = '﻿';
      var markerEl,
          markerId = "sel_".concat(new Date().getTime(), "_").concat(Math.random().toString().substr(2));
      var range;
      var sel = this.getWindowSelection();
      var prevRange = sel.getRangeAt(0);
      range = this.getDocument().createRange();
      range.setStart(sel.anchorNode, selectedNodePosition);
      range.setEnd(sel.anchorNode, selectedNodePosition);
      range.collapse(false); // Create the marker element containing a single invisible character using DOM methods and insert it

      markerEl = this.getDocument().createElement('span');
      markerEl.id = markerId;
      markerEl.appendChild(this.getDocument().createTextNode(markerTextChar));
      range.insertNode(markerEl);
      sel.removeAllRanges();
      sel.addRange(prevRange);
      var rect = markerEl.getBoundingClientRect();
      var doc = document.documentElement;
      var windowLeft = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
      var windowTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
      var coordinates = {
        left: rect.left + windowLeft,
        top: rect.top + markerEl.offsetHeight + windowTop
      };
      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;
      var menuDimensions = this.getMenuDimensions();
      var menuIsOffScreen = this.isMenuOffScreen(coordinates, menuDimensions);

      if (menuIsOffScreen.right) {
        coordinates.left = 'auto';
        coordinates.right = windowWidth - rect.left - windowLeft;
      }

      var parentHeight = this.tribute.menuContainer ? this.tribute.menuContainer.offsetHeight : this.getDocument().body.offsetHeight;

      if (menuIsOffScreen.bottom) {
        var parentRect = this.tribute.menuContainer ? this.tribute.menuContainer.getBoundingClientRect() : this.getDocument().body.getBoundingClientRect();
        var scrollStillAvailable = parentHeight - (windowHeight - parentRect.top);
        coordinates.top = 'auto';
        coordinates.bottom = scrollStillAvailable + (windowHeight - rect.top);
      }

      menuIsOffScreen = this.isMenuOffScreen(coordinates, menuDimensions);

      if (menuIsOffScreen.left) {
        coordinates.left = windowWidth > menuDimensions.width ? windowLeft + windowWidth - menuDimensions.width : windowLeft;
        delete coordinates.right;
      }

      if (menuIsOffScreen.top) {
        coordinates.top = windowHeight > menuDimensions.height ? windowTop + windowHeight - menuDimensions.height : windowTop;
        delete coordinates.bottom;
      }

      markerEl.parentNode.removeChild(markerEl);
      return coordinates;
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView(elem) {
      var reasonableBuffer = 20,
          clientRect;
      var maxScrollDisplacement = 100;
      var e = this.menu;
      if (typeof e === 'undefined') return;

      while (clientRect === undefined || clientRect.height === 0) {
        clientRect = e.getBoundingClientRect();

        if (clientRect.height === 0) {
          e = e.childNodes[0];

          if (e === undefined || !e.getBoundingClientRect) {
            return;
          }
        }
      }

      var elemTop = clientRect.top;
      var elemBottom = elemTop + clientRect.height;

      if (elemTop < 0) {
        window.scrollTo(0, window.pageYOffset + clientRect.top - reasonableBuffer);
      } else if (elemBottom > window.innerHeight) {
        var maxY = window.pageYOffset + clientRect.top - reasonableBuffer;

        if (maxY - window.pageYOffset > maxScrollDisplacement) {
          maxY = window.pageYOffset + maxScrollDisplacement;
        }

        var targetY = window.pageYOffset - (window.innerHeight - elemBottom);

        if (targetY > maxY) {
          targetY = maxY;
        }

        window.scrollTo(0, targetY);
      }
    }
  }]);

  return TributeRange;
}();

var _default = TributeRange;
exports["default"] = _default;
module.exports = exports.default;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// Thanks to https://github.com/mattyork/fuzzy
var TributeSearch =
/*#__PURE__*/
function () {
  function TributeSearch(tribute) {
    _classCallCheck(this, TributeSearch);

    this.tribute = tribute;
    this.tribute.search = this;
  }

  _createClass(TributeSearch, [{
    key: "simpleFilter",
    value: function simpleFilter(pattern, array) {
      var _this = this;

      return array.filter(function (string) {
        return _this.test(pattern, string);
      });
    }
  }, {
    key: "test",
    value: function test(pattern, string) {
      return this.match(pattern, string) !== null;
    }
  }, {
    key: "match",
    value: function match(pattern, string, opts) {
      opts = opts || {};
      var patternIdx = 0,
          result = [],
          len = string.length,
          totalScore = 0,
          currScore = 0,
          pre = opts.pre || '',
          post = opts.post || '',
          compareString = opts.caseSensitive && string || string.toLowerCase(),
          ch,
          compareChar;

      if (opts.skip) {
        return {
          rendered: string,
          score: 0
        };
      }

      pattern = opts.caseSensitive && pattern || pattern.toLowerCase();
      var patternCache = this.traverse(compareString, pattern, 0, 0, []);

      if (!patternCache) {
        return null;
      }

      return {
        rendered: this.render(string, patternCache.cache, pre, post),
        score: patternCache.score
      };
    }
  }, {
    key: "traverse",
    value: function traverse(string, pattern, stringIndex, patternIndex, patternCache) {
      // if the pattern search at end
      if (pattern.length === patternIndex) {
        // calculate score and copy the cache containing the indices where it's found
        return {
          score: this.calculateScore(patternCache),
          cache: patternCache.slice()
        };
      } // if string at end or remaining pattern > remaining string


      if (string.length === stringIndex || pattern.length - patternIndex > string.length - stringIndex) {
        return undefined;
      }

      var c = pattern[patternIndex];
      var index = string.indexOf(c, stringIndex);
      var best, temp;

      while (index > -1) {
        patternCache.push(index);
        temp = this.traverse(string, pattern, index + 1, patternIndex + 1, patternCache);
        patternCache.pop(); // if downstream traversal failed, return best answer so far

        if (!temp) {
          return best;
        }

        if (!best || best.score < temp.score) {
          best = temp;
        }

        index = string.indexOf(c, index + 1);
      }

      return best;
    }
  }, {
    key: "calculateScore",
    value: function calculateScore(patternCache) {
      var score = 0;
      var temp = 1;
      patternCache.forEach(function (index, i) {
        if (i > 0) {
          if (patternCache[i - 1] + 1 === index) {
            temp += temp + 1;
          } else {
            temp = 1;
          }
        }

        score += temp;
      });
      return score;
    }
  }, {
    key: "render",
    value: function render(string, indices, pre, post) {
      var rendered = string.substring(0, indices[0]);
      indices.forEach(function (index, i) {
        rendered += pre + string[index] + post + string.substring(index + 1, indices[i + 1] ? indices[i + 1] : string.length);
      });
      return rendered;
    }
  }, {
    key: "filter",
    value: function filter(pattern, arr, opts) {
      var _this2 = this;

      opts = opts || {};
      return arr.reduce(function (prev, element, idx, arr) {
        var str = element;

        if (opts.extract) {
          str = opts.extract(element);

          if (!str) {
            // take care of undefineds / nulls / etc.
            str = '';
          }
        }

        var rendered = _this2.match(pattern, str, opts);

        if (rendered != null) {
          prev[prev.length] = {
            string: rendered.rendered,
            score: rendered.score,
            index: idx,
            original: element
          };
        }

        return prev;
      }, []).sort(function (a, b) {
        var compare = b.score - a.score;
        if (compare) return compare;
        return a.index - b.index;
      });
    }
  }]);

  return TributeSearch;
}();

var _default = TributeSearch;
exports["default"] = _default;
module.exports = exports.default;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Tribute = _interopRequireDefault(require("./Tribute"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
* Tribute.js
* Native ES6 JavaScript @mention Plugin
**/
var _default = _Tribute["default"];
exports["default"] = _default;
module.exports = exports.default;

},{"./Tribute":1}],7:[function(require,module,exports){
"use strict";

if (!Array.prototype.find) {
  Array.prototype.find = function (predicate) {
    if (this === null) {
      throw new TypeError('Array.prototype.find called on null or undefined');
    }

    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }

    var list = Object(this);
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    var value;

    for (var i = 0; i < length; i++) {
      value = list[i];

      if (predicate.call(thisArg, value, i, list)) {
        return value;
      }
    }

    return undefined;
  };
}

if (window && typeof window.CustomEvent !== "function") {
  var CustomEvent = function CustomEvent(event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };

  if (typeof window.Event !== 'undefined') {
    CustomEvent.prototype = window.Event.prototype;
  }

  window.CustomEvent = CustomEvent;
}

},{}]},{},[6])(6)
});
//# sourceMappingURL=tribute.js.map


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    return af;

})));


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ar;

})));


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arDz;

})));


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arKw;

})));


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arLy;

})));


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arMa;

})));


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arSa;

})));


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arTn;

})));


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
            '_'
        ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return az;

})));


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                '_'
            ),
        },
        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split(
            '_'
        ),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                '_'
            ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return be;

})));


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bg;

})));


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return bm;

})));


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
            '_'
        ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bn;

})));


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
            '_'
        ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bnBd;

})));


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
            '_'
        ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
            '_'
        ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    return br;

})));


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bs;

})));


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                '_'
            ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ca;

})));


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
            '_'
        ),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cs;

})));


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
            '_'
        ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                    ? 'тан'
                    : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return cv;

})));


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
            '_'
        ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cy;

})));


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deAt;

})));


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deCh;

})));


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return dv;

})));


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
            '_'
        ),
        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
            '_'
        ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    return el;

})));


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enCa;

})));


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enIl;

})));


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eo;

})));


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return esDo;

})));


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return esMx;

})));


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return esUs;

})));


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split(
            '_'
        ),
        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
            '_'
        ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return et;

})));


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
            '_'
        ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eu;

})));


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        weekdays: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
            '_'
        ),
        weekdaysShort: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
            '_'
        ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return fa;

})));


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
            ' '
        ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
            '_'
        ),
        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
            '_'
        ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fil;

})));


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
            '_'
        ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fo;

})));


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split(
            '_'
        );

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fy;

})));


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gd;

})));


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gl;

})));


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                '_'
            ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    return gomDeva;

})));


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                '_'
            ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    return gomLatn;

})));


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return gu;

})));


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split(
            '_'
        ),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    return he;

})));


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone: 'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                '_'
            ),
        },
        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split(
            '_'
        ),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return hi;

})));


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                '_'
            ),
        },
        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hr;

})));


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(
        ' '
    );
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return hu;

})));


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                '_'
            ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
            '_'
        ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hyAm;

})));


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return id;

})));


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
            '_'
        ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return is;

})));


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return itCh;

})));


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    return ja;

})));


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return jv;

})));


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                '_'
            ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (
                    $0,
                    $1,
                    $2
                ) {
                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                });
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return kk;

})));


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
            '_'
        ),
        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split(
            '_'
        ),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ky;

})));


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
            '_'
        ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lb;

})));


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    return lo;

})));


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
            ? forms(key)[1]
            : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                '_'
            ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                '_'
            ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lt;

})));


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
            '_'
        ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lv;

})));


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return me;

})));


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
            '_'
        ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mi;

})));


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return mk;

})));


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
            '_'
        ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    return ml;

})));


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    return mn;

})));


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return mr;

})));


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ms;

})));


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return msMy;

})));


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
            '_'
        ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mt;

})));


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return my;

})));


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            w: 'en uke',
            ww: '%d uker',
            M: 'en måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nb;

})));


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ne;

})));


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
            '_'
        ),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
            '_'
        ),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
            '_'
        ),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
            '_'
        ),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nn;

})));


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                '_'
            ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    return ocLnc;

})));


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return paIn;

})));


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
            '_'
        ),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
            '_'
        ),
        monthsParse = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split(
            '_'
        ),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pl;

})));


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
            '_'
        ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
            '_'
        ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    return ptBr;

})));


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ro;

})));


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                '_'
            ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
        },
        weekdays: {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                '_'
            ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sd;

})));


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split(
            '_'
        ),
        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
            '_'
        ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return se;

})));


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
            '_'
        ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
            '_'
        ),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sk;

})));


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sl;

})));


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sq;

})));


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sr;

})));


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'дан',
            dd: translator.translate,
            M: 'месец',
            MM: translator.translate,
            y: 'годину',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return srCyrl;

})));


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
            '_'
        ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ss;

})));


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                        ? ':a'
                        : b === 2
                        ? ':a'
                        : b === 3
                        ? ':e'
                        : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sv;

})));


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
            '_'
        ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sw;

})));


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
            '_'
        ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ta;

})));


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
            '_'
        ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return te;

})));


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tet;

})));


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                '_'
            ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    return th;

})));


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tk;

})));


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlPh;

})));


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'waQ'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'nem'
                : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'wen'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'ben'
                : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlh;

})));


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tr;

})));


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
            ? format[key][0]
            : format[key][1];
    }

    return tzl;

})));


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzm;

})));


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzmLatn;

})));


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                    '_'
                ),
                accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                    '_'
                ),
                genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                    '_'
                ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
            ? 'genitive'
            : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                '_'
            ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uk;

})));


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uz;

})));


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
            '_'
        ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uzLatn;

})));


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
            '_'
        ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return xPseudo;

})));


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return yo;

})));


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhHk;

})));


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhMo;

})));


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(78);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(167);
var hiddenKeys = __webpack_require__(120).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NotificationPermission__ = __webpack_require__(836);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'side-menu',
  components: { NotificationPermission: __WEBPACK_IMPORTED_MODULE_0__NotificationPermission__["a" /* default */] },
  data: function data() {
    return {
      loggingOut: false,
      showImport: false,
      hideImportNav: false
    };
  },

  computed: {
    user: function user() {
      return this.$store.state.session.user;
    },
    sideMenu: function sideMenu() {
      return this.$store.state.sideMenu;
    },
    showSideMenu: function showSideMenu() {
      return this.sideMenu.show;
    },
    hideMenuButton: function hideMenuButton() {
      return !this.sideMenu.showMenuButton;
    },
    showNotifPerm: function showNotifPerm() {
      return this.$store.state.notificationPermission.show;
    },
    _userID: function _userID() {
      return this.user.id;
    },
    _route: function _route() {
      return this.$route.name;
    },
    enableSearchGlobal: function enableSearchGlobal() {
      return this.$store.state.searchGlobal.enable;
    },
    payoutsAccess: function payoutsAccess() {
      return this.user.access && this.user.access.hasOwnProperty('PageAdminDriverBatchModifications');
    },
    insuranceAccess: function insuranceAccess() {
      return this.user.access && this.user.access.hasOwnProperty('PageAdminInsurance');
    }
  },
  methods: {
    toggleGlobalSearch: function toggleGlobalSearch() {
      var self = this;
      localStorage.setItem('searchGlobal', !self.enableSearchGlobal);
      self.$store.commit('searchGlobal/setSearchGlobalEnable', !self.enableSearchGlobal);
    },
    toggleMenu: function toggleMenu() {
      if (this.sideMenu.show) {
        this.showImport = false;
        this.$store.commit('sideMenu/hide');
      } else {
        this.$store.commit('sideMenu/show');
      }
    },
    createRsvp: function createRsvp() {
      window.location.href = '#/reservation/new';
    },
    logout: function logout() {
      var self = this;
      self.loggingOut = true;
      self.$sdk.post('/admin/logout', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.loggingOut = false;
        if (r.error) {
          console.log(r);
          return;
        }
        self.$plugins.fcm.deleteToken(self);
        self.$plugins.storage.removeSessionToken();
        window.location.reload();
      });
    },
    getAccess: function getAccess() {
      var self = this;
      var user = self.user;

      if (user.id && !user.access && !user.loading) {
        self.$store.commit('session/setAccessLoading', true);
        self.$sdk.get('/admin/' + user.id + '/access', {
          token: self.$store.state.session.sessionToken
        }, function (r) {
          self.$store.commit('session/setAccessLoading', false);
          if (!r.error) {
            self.$store.commit('session/setAccess', r.permissions);
            self.checkAccess();
          }
        });
      }
    },
    checkAccess: function checkAccess() {
      var self = this;
      var user = self.user;
      // console.log('ROUTE:', self._route)
      // console.log('ACCESS:', user.access)

      if (!user.access) {
        setTimeout(function () {
          self.checkAccess();
        }, 300);
        return;
      }

      if (['Provider', 'ProviderList'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminDashboard')) {
        self.$router.push('/accessdenied');
      }

      if (['Consumer', 'ConsumerList'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminConsumers')) {
        self.$router.push('/accessdenied');
      }

      if (['Corporate', 'CreateCorporate', 'CorporateProfile'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminCorporates')) {
        self.$router.push('/accessdenied');
      }

      if (['Home', 'Transactions'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminTransactions')) {
        self.$router.push('/accessdenied');
      }

      if (['ImportRsvp'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminImport')) {
        self.$router.push('/accessdenied');
      }

      // Non-exist
      if (['Promo'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminPromocodes')) {
        self.$router.push('/accessdenied');
      }

      // Non-exist
      if (['Ratings'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminRatings')) {
        self.$router.push('/accessdenied');
      }

      // Non-exist
      if (['Bids'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminBids')) {
        self.$router.push('/accessdenied');
      }

      if (['MarketingAds'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminAds')) {
        self.$router.push('/accessdenied');
      }

      // Non-exist
      if (['Fleet'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminFleetReport')) {
        self.$router.push('/accessdenied');
      }

      // Non-exist
      if (['Logs'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminLog')) {
        self.$router.push('/accessdenied');
      }

      // Non-exist
      if (['Notifcations'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminNotifications')) {
        self.$router.push('/accessdenied');
      }

      // Non-exist
      if (['Maps'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminMap')) {
        self.$router.push('/accessdenied');
      }

      // Non-exist
      if (['Geo'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminGeo')) {
        self.$router.push('/accessdenied');
      }

      if (['Pricing'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminPricing')) {
        self.$router.push('/accessdenied');
      }

      if (['Services'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminService')) {
        self.$router.push('/accessdenied');
      }

      // Non-exist
      if (['Settings'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminSettings')) {
        self.$router.push('/accessdenied');
      }

      // Non-exist
      if (['StagingLot'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminStagingLot')) {
        self.$router.push('/accessdenied');
      }

      // Non-exist
      if (['Filter'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminFilter')) {
        self.$router.push('/accessdenied');
      }

      if (['RsvpDetails', 'PackageDetails'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminRSVP')) {
        self.$router.push('/accessdenied');
      }

      if (['Dispatch', 'DispatchReservations'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminDispatch')) {
        self.$router.push('/accessdenied');
      }

      if (['Laxit', 'DispatchLaxit'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminLaxit')) {
        self.$router.push('/accessdenied');
      }

      if (['Routing'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminRouting')) {
        self.$router.push('/accessdenied');
      }

      if (['Brands'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminBrands')) {
        self.$router.push('/accessdenied');
      }

      if (['Admin'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminAdmins')) {
        self.$router.push('/accessdenied');
      }

      if (['Reports'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminReports')) {
        self.$router.push('/accessdenied');
      }

      if (['ProviderDeductions'].indexOf(self._route) > -1 && !user.access.hasOwnProperty('PageAdminProviderDeductions')) {
        self.$router.push('/accessdenied');
      }
    }
  },
  watch: {
    _userID: function _userID(value) {
      if (value) {
        this.getAccess();
      }
    },
    _route: function _route(value) {
      this.checkAccess();
    }
  },
  mounted: function mounted() {
    this.getAccess();
    if (!!localStorage.getItem('searchGlobal')) {
      this.$store.commit('searchGlobal/setSearchGlobalEnable', localStorage.getItem('searchGlobal') === 'true');
    }

    var user = this.user;
    if (user.access && !user.access.hasOwnProperty('PageAdminImport')) {
      this.hideImportNav = true;
    }
  }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notification-permission',
  methods: {
    showNotificationPermission: function showNotificationPermission() {
      this.$plugins.fcm.start(this);
    }
  }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'session-loader',
  computed: {
    hideLoader: function hideLoader() {
      return !this.$store.state.session.showLoader;
    }
  }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_search_global___ = __webpack_require__(848);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "search",
  data: function data() {
    return {
      darkBackground: false,
      isNewSearch: false,
      isMobile: false
    };
  },

  computed: {
    loading: function loading() {
      return this.$store.state.searchGlobal.isLoading;
    },

    searchInput: {
      get: function get() {
        return this.$store.state.searchGlobal.searchInput;
      },
      set: function set(value) {
        this.$store.commit('searchGlobal/setSearchGlobalInput', value);
      }
    },
    displaySearchContainer: function displaySearchContainer() {
      return this.$store.state.searchGlobal.searchContainer;
    },
    searchResult: function searchResult() {
      return this.$store.state.searchGlobal.list;
    },
    isLastPage: function isLastPage() {
      var searchPage = this.$store.state.searchGlobal;
      return searchPage.currentPage * searchPage.perPage >= searchPage.maxList;
    }
  },
  methods: {
    search: function search() {
      var self = this;
      if (self.loading) {
        return;
      }
      self.$store.commit('searchGlobal/setSearchGlobalIsLoading', true);
      __WEBPACK_IMPORTED_MODULE_0__modules_api_search_global___["a" /* default */].search(self, function (res) {
        self.$store.commit('searchGlobal/setSearchGlobalIsLoading', false);
      });
    },
    newSearch: function newSearch() {
      var self = this;
      self.$store.commit('searchGlobal/resetSearchGlobalList');
      self.$store.commit('searchGlobal/setSearchGlobalCurrentPage', 1);
      self.isNewSearch = true;
      self.darkBackground = true;
      document.body.style.overflow = "hidden";
      self.search();
    },
    clearSearch: function clearSearch() {
      var self = this;
      if (self.loading) {
        return;
      }
      self.searchInput = '';
      self.darkBackground = false;
      self.isNewSearch = false;
      self.$store.commit('searchGlobal/resetSearchGlobalList');
      self.$store.commit('searchGlobal/setSearchGlobalCurrentPage', 1);
    },
    removeFocus: function removeFocus() {
      if (this.loading) {
        return;
      }
      this.darkBackground = false;
      document.body.style.overflow = "auto";
      if (!this.searchInput.length > 0) {
        this.clearSearch();
      }
    },
    focusSearch: function focusSearch() {
      if (this.loading) {
        return;
      }
      this.darkBackground = true;
      document.body.style.overflow = "hidden";
    },
    openRSVP: function openRSVP(id) {
      window.open('#/reservation/' + id, '_blank');
    },
    loadMore: function loadMore(event) {
      if (this.loading) {
        return;
      }
      var scrollAndView = event.target.scrollTop + event.target.offsetHeight;
      if (event.target.scrollHeight - scrollAndView < 1.5) {
        if (this.isLastPage || this.loading) {
          return;
        }
        this.$store.commit('searchGlobal/setSearchGlobalCurrentPage', this.$store.state.searchGlobal.currentPage + 1);
        this.search();
      }
    },
    getLabel: function getLabel(item) {
      switch (item) {
        case "ready":
          return "Ready to go";
        case "onboard":
          return "On Board";
        case "requires_dispatch":
          return "Requires Dispatch";
        case "complete":
          return "Completed";
        default:
          return item;
      }
    },
    toggleSearch: function toggleSearch() {
      var self = this;
      localStorage.setItem('searchField', !self.displaySearchContainer);
      self.$store.commit('searchGlobal/setSearchGlobalContainer', !self.displaySearchContainer);
    },
    setScreenSize: function setScreenSize() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    }
  },
  mounted: function mounted() {
    this.clearSearch();
    this.setScreenSize();
    if (!!localStorage.getItem('searchField')) {
      this.$store.commit('searchGlobal/setSearchGlobalContainer', localStorage.getItem('searchField') === 'true');
    }
  },
  created: function created() {
    window.addEventListener("resize", this.setScreenSize);
  },
  destroyed: function destroyed() {
    window.removeEventListener("resize", this.setScreenSize);
  }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loader',
  computed: {
    loader: function loader() {
      return this.$store.state.global.loader;
    },

    show: {
      get: function get() {
        return this.loader.show;
      },
      set: function set(x) {
        this.$store.commit('global/setLoaderData', {
          show: x,
          message: ''
        });
      }
    },
    message: function message() {
      return this.loader.message;
    }
  },
  methods: {},
  mounted: function mounted() {}
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'alert',
  computed: {
    alert: function alert() {
      return this.$store.state.global.alert;
    },

    show: {
      get: function get() {
        return this.alert.show;
      },
      set: function set(x) {
        this.$store.commit('global/setAlertData', {
          show: x,
          message: ''
        });
      }
    },
    message: function message() {
      return this.alert.message;
    }
  },
  methods: {},
  mounted: function mounted() {}
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _name$computed$data$c;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = (_name$computed$data$c = {
  name: 'reason-modal',
  computed: {},
  data: function data() {
    return {};
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$computed$data$c, 'computed', {
  queueError: function queueError() {
    return this.$store.state.global.reasons;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$computed$data$c, 'methods', {
  reasonLabel: function reasonLabel(x) {
    switch (x) {
      case 'serviceType':
        return 'Driver cannot accept this service type';
      case 'seats':
        return 'Driver vehcile does not have enough seat capacity';
      case 'adaWC':
        return 'Requires ADA wheelchair';
      case 'adaSD':
        return 'Requires ADA service dog';
      case 'fullTNC':
        return 'Do not give full TNC runs to TCP drivers';
      case 'availability':
        return 'Driver availability does not match';
      case 'distance':
        return 'Driver distance to first pickup location';
      default:
        return x;
    }
  },
  closeReasons: function closeReasons() {
    // this.queueError.reasonsModal = false
    this.$store.commit('global/setReasonsData', { reasonsModal: false });
    this.$forceUpdate();
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$computed$data$c, 'mounted', function mounted() {}), _name$computed$data$c);

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(861), __esModule: true };

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_shared_mutations__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_shared_mutations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_shared_mutations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__admin__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ads__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__airlines__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__airports__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__brands__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__consumer_index__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__corporate_index__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__country_code__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__coverage_index__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dispatch_index__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__filters_index__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__flight_information_modal__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__geofences_index__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__laxit_index__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__notification_permission__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__package_details__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__phone_app__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pricing__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__promo__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__provider__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__provider_deductions__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__refund_credit_modal__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__reports__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__reservation_index__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__reservation_notes_modal__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__routing_index__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__reservation_details_index__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__search_global__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__services__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__session__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__settings__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__settings_page__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__side_menu__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__transactions__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__runs__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__discount_codes__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__global__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__cancel_upcoming__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__flights__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__flight_details__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__currency__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__lyft__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__insurance__ = __webpack_require__(1025);
















































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

// Build Shared mutations
var sharedMutations = [];
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_8__consumer_index__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_12__dispatch_index__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_26__reservation_index__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_29__reservation_details_index__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_19__phone_app__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_32__session__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_15__geofences_index__["a" /* default */].sharedMutations);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  plugins: [__WEBPACK_IMPORTED_MODULE_2_vuex_shared_mutations___default()({
    predicate: sharedMutations
  })],
  modules: {
    admin: __WEBPACK_IMPORTED_MODULE_3__admin__["a" /* default */],
    ads: __WEBPACK_IMPORTED_MODULE_4__ads__["a" /* default */],
    airlines: __WEBPACK_IMPORTED_MODULE_5__airlines__["a" /* default */],
    airports: __WEBPACK_IMPORTED_MODULE_6__airports__["a" /* default */],
    brands: __WEBPACK_IMPORTED_MODULE_7__brands__["a" /* default */],
    consumer: __WEBPACK_IMPORTED_MODULE_8__consumer_index__["a" /* default */],
    corporate: __WEBPACK_IMPORTED_MODULE_9__corporate_index__["a" /* default */],
    countryCode: __WEBPACK_IMPORTED_MODULE_10__country_code__["a" /* default */],
    coverage: __WEBPACK_IMPORTED_MODULE_11__coverage_index__["a" /* default */],
    dispatch: __WEBPACK_IMPORTED_MODULE_12__dispatch_index__["a" /* default */],
    filters: __WEBPACK_IMPORTED_MODULE_13__filters_index__["a" /* default */],
    flightInformation: __WEBPACK_IMPORTED_MODULE_14__flight_information_modal__["a" /* default */],
    geofences: __WEBPACK_IMPORTED_MODULE_15__geofences_index__["a" /* default */],
    laxit: __WEBPACK_IMPORTED_MODULE_16__laxit_index__["a" /* default */],
    notificationPermission: __WEBPACK_IMPORTED_MODULE_17__notification_permission__["a" /* default */],
    packageDetails: __WEBPACK_IMPORTED_MODULE_18__package_details__["a" /* default */],
    phone: __WEBPACK_IMPORTED_MODULE_19__phone_app__["a" /* default */],
    pricing: __WEBPACK_IMPORTED_MODULE_20__pricing__["a" /* default */],
    promo: __WEBPACK_IMPORTED_MODULE_21__promo__["a" /* default */],
    provider: __WEBPACK_IMPORTED_MODULE_22__provider__["a" /* default */],
    providerDeductions: __WEBPACK_IMPORTED_MODULE_23__provider_deductions__["a" /* default */],
    refundCredit: __WEBPACK_IMPORTED_MODULE_24__refund_credit_modal__["a" /* default */],
    reports: __WEBPACK_IMPORTED_MODULE_25__reports__["a" /* default */],
    reservation: __WEBPACK_IMPORTED_MODULE_26__reservation_index__["a" /* default */],
    reservationNotes: __WEBPACK_IMPORTED_MODULE_27__reservation_notes_modal__["a" /* default */],
    routing: __WEBPACK_IMPORTED_MODULE_28__routing_index__["a" /* default */],
    rsvpDetails: __WEBPACK_IMPORTED_MODULE_29__reservation_details_index__["a" /* default */],
    searchGlobal: __WEBPACK_IMPORTED_MODULE_30__search_global__["a" /* default */],
    services: __WEBPACK_IMPORTED_MODULE_31__services__["a" /* default */],
    session: __WEBPACK_IMPORTED_MODULE_32__session__["a" /* default */],
    settings: __WEBPACK_IMPORTED_MODULE_33__settings__["a" /* default */],
    settingsPage: __WEBPACK_IMPORTED_MODULE_34__settings_page__["a" /* default */],
    sideMenu: __WEBPACK_IMPORTED_MODULE_35__side_menu__["a" /* default */],
    transactions: __WEBPACK_IMPORTED_MODULE_36__transactions__["a" /* default */],
    runs: __WEBPACK_IMPORTED_MODULE_37__runs__["a" /* default */],
    discountCodes: __WEBPACK_IMPORTED_MODULE_38__discount_codes__["a" /* default */],
    global: __WEBPACK_IMPORTED_MODULE_39__global__["a" /* default */],
    cancelUpcoming: __WEBPACK_IMPORTED_MODULE_40__cancel_upcoming__["a" /* default */],
    flights: __WEBPACK_IMPORTED_MODULE_41__flights__["a" /* default */],
    flightDetails: __WEBPACK_IMPORTED_MODULE_42__flight_details__["a" /* default */],
    currency: __WEBPACK_IMPORTED_MODULE_43__currency__["a" /* default */],
    lyft: __WEBPACK_IMPORTED_MODULE_44__lyft__["a" /* default */],
    insurance: __WEBPACK_IMPORTED_MODULE_45__insurance__["a" /* default */]
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'access-denied',
  mounted: function mounted() {
    this.$store.commit('sideMenu/hide');
    this.$store.commit('sideMenu/hideMenuButton');
  },
  destroyed: function destroyed() {
    this.$store.commit('sideMenu/showMenuButton');
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'missing-page',
  mounted: function mounted() {
    this.$store.commit('sideMenu/hide');
    this.$store.commit('sideMenu/hideMenuButton');
  },
  destroyed: function destroyed() {
    this.$store.commit('sideMenu/showMenuButton');
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_admin__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_dispatch_reservations__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_routing_reservations__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      email: '',
      password: '',
      showError: false,
      loginLabel: this.$t('login.ctaDefault'),
      loggingIn: false,
      forgotPassword: {
        show: false,
        errorMsg: '',
        showError: false,
        loading: false,
        success: false
      }
    };
  },

  methods: {
    login: function login() {
      var self = this;
      self.loggingIn = true;
      self.showError = false;
      self.loginLabel = self.$t('login.ctaLoading');

      // simulated login
      self.$sdk.post('/admin/login', {
        email: self.email,
        password: self.password
      }, function (r) {
        self.loggingIn = false;
        self.loginLabel = self.$t('login.ctaDefault');
        if (r.error) {
          console.log(r.error);
          self.showError = true;
          return;
        }
        self.$store.commit('session/setUser', {
          id: r.id,
          firstName: r.firstName,
          lastName: r.lastName,
          phone: r.phone,
          email: r.email,
          photoUrl: r.avatarUrl === null ? 'https://s3-us-west-2.amazonaws.com/staging-backoffice/staging/default-user.jpg' : r.avatarUrl
        });
        self.$store.commit('session/setSessionToken', r.token);
        self.$plugins.storage.setSessionToken(r.token);
        self.$router.push('/dispatch');
        self.$plugins.fcm.start(self);

        // get RSVP filters
        __WEBPACK_IMPORTED_MODULE_1__modules_api_dispatch_reservations__["a" /* default */].initDispatchReservations(self);
        __WEBPACK_IMPORTED_MODULE_2__modules_api_routing_reservations__["a" /* default */].initRoutingReservations(self);
        __WEBPACK_IMPORTED_MODULE_0__modules_api_admin__["a" /* default */].getAdminList(self);
      });
    },
    sendPassword: function sendPassword() {
      var self = this;

      self.forgotPassword.showError = false;
      self.forgotPassword.errorMsg = '';
      if (self.email.trim() === '') {
        self.forgotPassword.errorMsg = 'Please enter email address';
        self.forgotPassword.showError = true;
        return;
      }

      self.forgotPassword.loading = true;
      self.$sdk.delete('/admin/password', { email: self.email }, function (r) {
        self.forgotPassword.loading = false;
        if (r.error) {
          console.log(r.error);
          self.forgotPassword.errorMsg = r.error.message;
          self.forgotPassword.showError = true;
          return;
        }

        self.forgotPassword.success = true;
      });
    },
    goBack: function goBack() {
      if (this.forgotPassword.loading) {
        return;
      }
      this.forgotPassword.show = false;
    },
    close: function close() {
      location.reload();
    }
  },
  mounted: function mounted() {
    var self = this;
    self.loggingIn = false;
    self.showError = false;
    self.loginLabel = this.$t('login.ctaDefault');
    self.$store.commit('sideMenu/hideMenuButton');
  },
  destroyed: function destroyed() {
    this.$store.commit('sideMenu/showMenuButton');
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_LoadingModal__ = __webpack_require__(49);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'password-reset',
  components: { loadingModal: __WEBPACK_IMPORTED_MODULE_0__components_Partials_LoadingModal__["a" /* default */] },
  data: function data() {
    return {
      loading: false,
      showForm: false,
      email: '',
      password: '',
      repeatPassword: '',
      formLoading: false,
      error: {
        show: false,
        message: ''
      },
      showModal: false
    };
  },

  methods: {
    updatePassword: function updatePassword() {
      var self = this;
      self.error = { show: false, message: '' };

      if (self.password.trim() === '' || self.repeatPassword.trim() === '') {
        self.error = {
          show: true,
          message: 'Fields cannot be empty.'
        };
        return;
      }

      if (self.password !== self.repeatPassword) {
        self.error = {
          show: true,
          message: 'Password and Repeat password doesnt match.'
        };
        return;
      }

      self.formLoading = true;
      self.showModal = false;
      var key = this.$route.query.token;
      self.$sdk.post('/admin/resetkey', { key: key, password: self.password }, function (r) {
        self.formLoading = false;
        self.showModal = true;
      });
    },
    close: function close() {
      this.$router.push('/login');
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$store.commit('sideMenu/hideMenuButton');

    self.loading = true;
    var key = this.$route.query.token;
    self.$sdk.get('/admin/resetkey', { key: key }, function (r) {
      self.loading = false;
      if (r.error) {
        self.$router.push('/thispagedoesnotexist');
        return;
      }

      self.showForm = true;
      self.email = r.email;
    });
  },
  destroyed: function destroyed() {
    this.$store.commit('sideMenu/showMenuButton');
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loading-modal',
  props: ['modalMessage', 'showModal']
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_LoadingModal__ = __webpack_require__(49);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'password-reset-driver',
  components: { loadingModal: __WEBPACK_IMPORTED_MODULE_0__components_Partials_LoadingModal__["a" /* default */] },
  data: function data() {
    return {
      loading: false,
      showForm: false,
      email: '',
      password: '',
      repeatPassword: '',
      formLoading: false,
      error: {
        show: false,
        message: ''
      },
      showModal: false
    };
  },

  methods: {
    updatePassword: function updatePassword() {
      var self = this;
      self.error = { show: false, message: '' };
      if (self.password.trim() === '' || self.repeatPassword.trim() === '') {
        self.error = {
          show: true,
          message: 'Fields cannot be empty.'
        };
        return;
      }
      if (self.password !== self.repeatPassword) {
        self.error = {
          show: true,
          message: 'Password and Repeat password doesnt match.'
        };
        return;
      }
      self.formLoading = true;
      self.showModal = false;
      var key = this.$route.query.token;
      self.$sdk.post('/drive/password', { key: key, password: self.password }, function (r) {
        self.formLoading = false;
        self.showModal = true;
      });
    },
    close: function close() {
      this.$router.push('/login');
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$store.commit('sideMenu/hideMenuButton');
  },
  destroyed: function destroyed() {
    this.$store.commit('sideMenu/showMenuButton');
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'style-guide',
  mounted: function mounted() {
    this.$store.commit('sideMenu/hide');
    this.$store.commit('sideMenu/hideMenuButton');
  },
  destroyed: function destroyed() {
    this.$store.commit('sideMenu/showMenuButton');
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cropperjs__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cropperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cropperjs__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'test',
  data: function data() {
    return {
      imgSrc: '',
      cropImg: '',
      mediaHost: 'https://staging-media.opoli.com/api/upload',
      // mediaHost: 'http://localhost/upload/',
      simpleFile: new FormData()
    };
  },

  components: {},
  methods: {
    setImage: function setImage(e) {
      var _this = this;

      var self = this;
      var file = e.target.files[0];

      if (!file.type.includes('image/')) {
        alert('Please select an image file');
        return;
      }

      if (typeof FileReader === 'function') {
        var reader = new FileReader();

        reader.onload = function (event) {
          _this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          _this.$refs.cropper.replace(event.target.result);
          setTimeout(function () {
            self.cropImage();
          }, 50);
        };
        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    cropImage: function cropImage() {
      var self = this;
      // get image data for post processing, e.g. upload or setting image src
      self.cropImg = self.$refs.cropper.getCroppedCanvas().toDataURL();

      self.$refs.cropper.getCroppedCanvas({ width: 500, height: 500 }).toBlob(function (blob) {
        console.log(blob);
        // let fd = new FormData()
        // fd.append('pic', blob, 'test.jpg')
        // self.$http.post(self.mediaHost, fd, {
        //   header: {
        //     'Content-Type': 'multipart/form-data'
        //   }
        // }).then(function (res) {
        //   console.log('success', res)
        // }, function (res) {
        //   console.log('error', res)
        // });
      }, 'image/jpeg', 0.8);
    },
    setSimpleImage: function setSimpleImage(e) {
      var self = this;
      var file = e.target.files[0];
      console.log('#FILE2', file);
      this.simpleFile.append('pic', file);

      self.$http.post(self.mediaHost + '/api/upload', self.simpleFile, {
        header: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (res) {
        console.log('success', res);
        console.log('URL', res.body.data.url);
      }, function (res) {
        console.log('error', res);
      });
    },
    uploadSimple: function uploadSimple() {
      var self = this;
      self.$http.post(self.mediaHost + '/api/upload', self.simpleFile, {
        header: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
          'Content-Type': 'multipart/form-data'
        }, 'Content-Type', 'application/x-www-form-urlencoded')
      }).then(function (res) {
        console.log('success', res);
      }, function (res) {
        console.log('error', res);
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(81);

var _vue2 = _interopRequireDefault(_vue);

var _cropperjs = __webpack_require__(1057);

var _cropperjs2 = _interopRequireDefault(_cropperjs);

__webpack_require__(1058);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CropperComponent = _vue2.default.extend({
    render: function render(h) {
        return h('div', { style: this.containerStyle }, [h('img', {
            ref: 'img',
            attrs: {
                src: this.src,
                alt: this.alt || 'image',
                style: 'max-width: 100%'
            },
            style: this.imgStyle
        })]);
    },

    props: {
        'containerStyle': Object,
        'src': {
            type: String,
            default: ''
        },
        'alt': String,
        'imgStyle': Object,

        'viewMode': Number,
        'dragMode': String,
        'aspectRatio': Number,
        'data': Object,
        'preview': String,
        'responsive': {
            type: Boolean,
            default: true
        },
        'restore': {
            type: Boolean,
            default: true
        },
        'checkCrossOrigin': {
            type: Boolean,
            default: true
        },
        'checkOrientation': {
            type: Boolean,
            default: true
        },
        'modal': {
            type: Boolean,
            default: true
        },
        'guides': {
            type: Boolean,
            default: true
        },
        'center': {
            type: Boolean,
            default: true
        },
        'highlight': {
            type: Boolean,
            default: true
        },
        'background': {
            type: Boolean,
            default: true
        },
        'autoCrop': {
            type: Boolean,
            default: true
        },
        'autoCropArea': Number,
        'movable': {
            type: Boolean,
            default: true
        },
        'rotatable': {
            type: Boolean,
            default: true
        },
        'scalable': {
            type: Boolean,
            default: true
        },
        'zoomable': {
            type: Boolean,
            default: true
        },
        'zoomOnTouch': {
            type: Boolean,
            default: true
        },
        'zoomOnWheel': {
            type: Boolean,
            default: true
        },
        'wheelZoomRatio': Number,
        'cropBoxMovable': {
            type: Boolean,
            default: true
        },
        'cropBoxResizable': {
            type: Boolean,
            default: true
        },
        'toggleDragModeOnDblclick': {
            type: Boolean,
            default: true
        },

        'minCanvasWidth': Number,
        'minCanvasHeight': Number,
        'minCropBoxWidth': Number,
        'minCropBoxHeight': Number,
        'minContainerWidth': Number,
        'minContainerHeight': Number,

        'ready': Function,
        'cropstart': Function,
        'cropmove': Function,
        'cropend': Function,
        'crop': Function,
        'zoom': Function
    },
    mounted: function mounted() {
        var _$options$props = this.$options.props,
            containerStyle = _$options$props.containerStyle,
            src = _$options$props.src,
            alt = _$options$props.alt,
            imgStyle = _$options$props.imgStyle,
            data = _objectWithoutProperties(_$options$props, ['containerStyle', 'src', 'alt', 'imgStyle']);

        var props = {};

        for (var key in data) {
            if (this[key] !== undefined) {
                props[key] = this[key];
            }
        }

        this.cropper = new _cropperjs2.default(this.$refs.img, props);
    },

    methods: {
        reset: function reset() {
            return this.cropper.reset();
        },
        clear: function clear() {
            return this.cropper.clear();
        },
        initCrop: function initCrop() {
            return this.cropper.crop();
        },
        replace: function replace(url) {
            var onlyColorChanged = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            return this.cropper.replace(url, onlyColorChanged);
        },
        enable: function enable() {
            return this.cropper.enable();
        },
        disable: function disable() {
            return this.cropper.disable();
        },
        destroy: function destroy() {
            return this.cropper.destroy();
        },
        move: function move(offsetX, offsetY) {
            return this.cropper.move(offsetX, offsetY);
        },
        moveTo: function moveTo(x) {
            var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;

            return this.cropper.moveTo(x, y);
        },
        relativeZoom: function relativeZoom(ratio, _originalEvent) {
            return this.cropper.zoom(ratio, _originalEvent);
        },
        zoomTo: function zoomTo(ratio, _originalEvent) {
            return this.cropper.zoomTo(ratio, _originalEvent);
        },
        rotate: function rotate(degree) {
            return this.cropper.rotate(degree);
        },
        rotateTo: function rotateTo(degree) {
            return this.cropper.rotateTo(degree);
        },
        scaleX: function scaleX(_scaleX) {
            return this.cropper.scaleX(_scaleX);
        },
        scaleY: function scaleY(_scaleY) {
            return this.cropper.scaleY(_scaleY);
        },
        scale: function scale(scaleX) {
            var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;

            return this.cropper.scale(scaleX, scaleY);
        },
        getData: function getData() {
            var rounded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            return this.cropper.getData(rounded);
        },
        setData: function setData(data) {
            return this.cropper.setData(data);
        },
        getContainerData: function getContainerData() {
            return this.cropper.getContainerData();
        },
        getImageData: function getImageData() {
            return this.cropper.getImageData();
        },
        getCanvasData: function getCanvasData() {
            return this.cropper.getCanvasData();
        },
        setCanvasData: function setCanvasData(data) {
            return this.cropper.setCanvasData(data);
        },
        getCropBoxData: function getCropBoxData() {
            return this.cropper.getCropBoxData();
        },
        setCropBoxData: function setCropBoxData(data) {
            return this.cropper.setCropBoxData(data);
        },
        getCroppedCanvas: function getCroppedCanvas() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this.cropper.getCroppedCanvas(options);
        },
        setAspectRatio: function setAspectRatio(aspectRatio) {
            return this.cropper.setAspectRatio(aspectRatio);
        },
        setDragMode: function setDragMode(mode) {
            return this.cropper.setDragMode(mode);
        }
    }
});

var VueCropper = _vue2.default.component('vue-cropper', CropperComponent);

exports.default = VueCropper;

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Filter__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdminList__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AdminAdd__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_admin__ = __webpack_require__(71);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'brands',
  components: { adminFilter: __WEBPACK_IMPORTED_MODULE_0__Filter__["a" /* default */], adminList: __WEBPACK_IMPORTED_MODULE_1__AdminList__["a" /* default */], adminAdd: __WEBPACK_IMPORTED_MODULE_2__AdminAdd__["a" /* default */] },
  data: function data() {
    return {
      tab: 0,
      searchInput: '',
      status: ''
    };
  },

  computed: {
    admin: function admin() {
      return this.$store.state.admin.list;
    },
    loading: function loading() {
      return this.$store.state.admin.loading;
    },

    perPage: {
      get: function get() {
        return this.$store.state.admin.perPage;
      },
      set: function set(value) {
        this.$store.commit('admin/setPerPage', parseInt(value));
        this.$store.commit('admin/setCurrentPage', 1);
        this.getAdmins();
      }
    },
    pageData: function pageData() {
      var tableData = this.$store.state.admin;
      var start = tableData.currentPage * tableData.perPage - (tableData.perPage - 1);
      var end = tableData.currentPage * tableData.perPage;
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      };
    },

    currentPage: {
      get: function get() {
        return this.$store.state.admin.currentPage;
      },
      set: function set(value) {
        this.$store.commit('admin/setCurrentPage', parseInt(value));
        this.getAdmins();
      }
    },
    isLastPage: function isLastPage() {
      var admin = this.$store.state.admin;
      return admin.currentPage * admin.perPage >= admin.maxList;
    },
    totalPage: function totalPage() {
      var admin = this.$store.state.admin;
      return Math.ceil(admin.maxList / admin.perPage);
    }
  },
  methods: {
    showForm: function showForm() {
      this.$store.commit('admin/setShowForm', true);
    },
    getAdmins: function getAdmins() {
      var self = this;
      if (self.loading) {
        return;
      }

      self.$store.commit('admin/setLoading', true);
      __WEBPACK_IMPORTED_MODULE_3__modules_api_admin__["a" /* default */].getAdmins(self, {}, function (res) {
        self.$store.commit('admin/setLoading', false);
      });
    },
    prev: function prev() {
      if (this.currentPage === 1) {
        return;
      }
      this.$store.commit('admin/setCurrentPage', this.$store.state.admin.currentPage - 1);
      this.getAdmins();
    },
    next: function next() {
      if (this.isLastPage) {
        return;
      }
      this.$store.commit('admin/setCurrentPage', this.$store.state.admin.currentPage + 1);
      this.getAdmins();
    }
  },
  watch: {},
  mounted: function mounted() {}
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_admin__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_csvexport__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var exporter = __WEBPACK_IMPORTED_MODULE_1_csvexport___default.a.create({
  filename: 'export.csv',
  columns: ['First Name', 'Last Name', 'Username', 'Email', 'Mobile', 'Active']
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'admin-filter',
  data: function data() {
    return {
      searchInput: '',
      blurDelay: '',
      exportLoading: false
    };
  },

  computed: {
    loading: function loading() {
      return this.$store.state.admin.loading;
    },

    status: {
      get: function get() {
        return this.$store.state.admin.status;
      },
      set: function set(value) {
        this.$store.commit('admin/setStatus', value);
        this.refreshTable();
      }
    }
  },
  methods: {
    showForm: function showForm() {
      this.$store.commit('admin/setShowForm', true);
    },
    refreshTable: function refreshTable() {
      var self = this;
      if (self.loading) {
        return;
      }

      self.$store.commit('admin/setLoading', true);
      self.$store.commit('admin/setCurrentPage', 1);

      __WEBPACK_IMPORTED_MODULE_0__modules_api_admin__["a" /* default */].getAdmins(self, {}, function (res) {
        self.$store.commit('admin/setLoading', false);
      });
    },
    search: function search() {
      this.$store.commit('admin/setSearch', this.searchInput);
      this.refreshTable();
    },
    blurSearch: function blurSearch() {
      var self = this;
      if (self.$store.state.admin.search === self.searchInput.trim()) {
        return;
      }

      self.blurDelay = setTimeout(function () {
        self.search();
      }, 500);
    },
    clearSearch: function clearSearch() {
      if (this.blurDelay) {
        clearTimeout(this.blurDelay);
      }
      if (this.loading) {
        return;
      }

      this.searchInput = '';
      this.$store.commit('admin/setSearch', '');
      this.refreshTable();
    },
    updateStatus: function updateStatus() {
      // this.$store.commit('provider/setUserIsLoading', true)
      // this.refreshTable()
    },
    exportAdmin: function exportAdmin() {
      var self = this;
      if (self.exportLoading) {
        return;
      }

      self.exportLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__modules_api_admin__["a" /* default */].export(self, function (res) {
        self.exportLoading = false;
        if (!res.error) {
          exporter.downloadCsv(res);
        }
      });
    }
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_admin__ = __webpack_require__(71);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'admin-list',
  components: {},
  data: function data() {
    return {
      tab: 0,
      showConfirm: false,
      deleteConfirm: true,
      deleteLoading: false,
      deleteID: 0,
      sticky: false,
      sliderLoader: [],
      isMobile: false
    };
  },

  computed: {
    admins: function admins() {
      return this.$store.state.admin.list;
    },
    loading: function loading() {
      return this.$store.state.admin.loading;
    },
    _addSuccess: function _addSuccess() {
      return this.$store.state.admin.addSuccess;
    }
  },
  methods: {
    getAdmins: function getAdmins() {
      var self = this;
      if (self.loading) {
        return;
      }

      self.$store.commit('admin/setLoading', true);
      __WEBPACK_IMPORTED_MODULE_0__modules_api_admin__["a" /* default */].getAdmins(self, {}, function (res) {
        self.$store.commit('admin/setLoading', false);
        self.$nextTick(function () {
          self.getDimensions();
        });
      });
    },
    edit: function edit(id) {
      var index = this.admins.findIndex(function (x) {
        return x.id === id;
      });
      this.$store.commit('admin/setEdit', this.admins[index]);
      this.$store.commit('admin/setShowForm', true);
    },
    getDimensions: function getDimensions() {
      // let self = this
      // for (let key in self.dimension) {
      //   self.dimension[key] = self.$refs[key].clientWidth
      // }
    },
    close: function close(refreshPage) {
      if (this.loading) {
        return;
      }
      this.deleteID = 0;
      this.showConfirm = false;
      if (refreshPage) {
        this.getAdmins();
      }
    },
    deleteAdmin: function deleteAdmin(id) {
      this.deleteID = id;
      this.deleteConfirm = true;
      this.showConfirm = true;
    },
    confirmDelete: function confirmDelete() {
      var self = this;
      self.deleteLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__modules_api_admin__["a" /* default */].deleteAdmin(self, self.deleteID, function (res) {
        self.deleteConfirm = false;
        self.deleteLoading = false;
      });
    },
    updateStatus: function updateStatus(id, deactivate) {
      var self = this;
      self.sliderLoader.push(id);
      __WEBPACK_IMPORTED_MODULE_0__modules_api_admin__["a" /* default */].updateStatus(self, { id: id, deactivate: deactivate }, function (res) {
        var index = self.sliderLoader.indexOf(id);
        self.sliderLoader.splice(index, 1);
        if (!res.error) {
          self.$store.commit('admin/updateAdminActive', { id: id, isActive: !deactivate });
        }
      });
    },
    onScroll: function onScroll() {
      this.sticky = window.pageYOffset > 141;
    },
    setScreenSize: function setScreenSize() {
      var self = this;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        self.isMobile = true;
      } else {
        self.isMobile = false;
      }
    }
  },
  watch: {
    _addSuccess: function _addSuccess(value) {
      if (value) {
        this.getAdmins();
        this.$store.commit('admin/setAddSuccess', false);
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    self.getAdmins();

    // self.onScroll()
    window.onscroll = function () {
      self.onScroll();
    };
    self.setScreenSize();
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_admin__ = __webpack_require__(71);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'admin-add',
  components: {},
  data: function data() {
    return {
      id: '',
      firstName: '',
      lastName: '',
      email: '',
      mobile: '',
      username: '',
      password: '',
      access: {},
      reportAccess: {},
      submitLoading: false,
      error: '',
      errorMsg: {
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        username: '',
        password: ''
      },
      showSuccess: false
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.admin.showForm;
    },
    editId: function editId() {
      return this.$store.state.admin.edit.id;
    },
    fields: function fields() {
      return this.$store.state.admin.accessList;
    },
    _editData: function _editData() {
      return this.$store.state.admin.edit;
    },
    _permissions: function _permissions() {
      return this.$store.state.admin.permissions;
    },
    _reportPermissions: function _reportPermissions() {
      return this.$store.state.admin.reportPermissions;
    },
    reportsList: function reportsList() {
      return this.$store.state.admin.reportsList;
    }
  },
  methods: {
    close: function close() {
      if (self.submitLoading) {
        return;
      }
      this.$store.commit('admin/setShowForm', false);
      this.showSuccess = false;
      this.clearForm();
      if (this.$store.state.admin.edit.id) {
        this.$store.commit('admin/setEdit', {});
        this.$store.commit('admin/setPermissions', {});
      }
    },
    clearForm: function clearForm() {
      this.id = '';
      this.firstName = '';
      this.lastName = '';
      this.email = '';
      this.mobile = '';
      this.username = '';
      this.password = '';
      this.access = {};
      this.errorMsg = {
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        username: '',
        password: ''
      };
    },
    updateStorePermission: function updateStorePermission(field, add) {
      var self = this;
      self.$store.commit('admin/updatePermission', {
        field: field,
        add: !add
      });

      // Regenerate fields
      self.access = {};
      self.access = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$store.state.admin.permissions);
    },
    submitForm: function submitForm() {
      var self = this;
      if (self.submitLoading) {
        return;
      }

      if (!self.validate()) {
        self.scrollToTop();
        return;
      }

      var fields = {
        firstName: self.firstName,
        lastName: self.lastName,
        email: self.email,
        mobile: self.mobile,
        username: self.username,
        password: self.password
      };
      self.submitLoading = true;

      if (self.editId) {
        fields.id = self.editId;
        __WEBPACK_IMPORTED_MODULE_1__modules_api_admin__["a" /* default */].updateAdmin(self, fields, function (res) {
          if (res.error) {
            self.error = res.error.message;
            return;
          }

          if (self.password) {
            self.updatePassword();
          } else {
            self.updatePermission();
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__modules_api_admin__["a" /* default */].addAdmin(self, fields, function (res) {
          self.submitLoading = false;
          if (res.error) {
            self.error = res.error.message;
            return;
          }
          self.id = res.id;
          self.updatePermission();
          // self.$store.commit('admin/setAddSuccess', true)
          // self.showSuccess = true
        });
      }
    },
    validate: function validate() {
      var self = this;
      var fields = ['firstName', 'lastName', 'email', 'mobile', 'username'];
      var noError = true;

      if (!self.editId) {
        fields.push('password');
      }
      fields.forEach(function (field) {
        if (!self[field]) {
          self.errorMsg[field] = 'This field cannot be empty.';
          noError = false;
        }
      });

      return noError;
    },
    updatePassword: function updatePassword() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1__modules_api_admin__["a" /* default */].updateAdminPassword(self, {
        id: self.editId,
        password: self.password
      }, function (res) {
        if (res.error) {
          self.error = res.error.message;
          return;
        }
        self.updatePermission();
      });
    },
    updatePermission: function updatePermission() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1__modules_api_admin__["a" /* default */].updateAdminAccess(self, self.id, function (res) {
        self.submitLoading = false;
        if (res.error) {
          self.error = res.error.message;
          return;
        }

        self.showSuccess = true;
        self.$store.commit('admin/setAddSuccess', true);
        if (self.editId === self.$store.state.session.user.id) {
          self.$store.commit('session/setAccess', res.permissions);
        }
      });
    },
    scrollToTop: function scrollToTop() {
      var elmnt = document.getElementById('form');
      elmnt.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    updateReportPermission: function updateReportPermission(field, add) {
      var self = this;
      self.$store.commit('admin/updateReportPermission', {
        field: field,
        add: !add
      });

      // Regenerate fields
      self.reportAccess = {};
      self.reportAccess = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$store.state.admin.reportPermissions);
    }
  },
  watch: {
    _editData: function _editData(value) {
      if (value) {
        this.id = value.id;
        this.firstName = value.firstName;
        this.lastName = value.lastName;
        this.email = value.email;
        this.mobile = value.mobile;
        this.username = value.username;
      }
    },
    _permissions: function _permissions(value) {
      if (value) {
        this.access = {};
        this.access = value;
      }
    },
    _reportPermissions: function _reportPermissions(value) {
      if (value) {
        this.reportAccess = {};
        this.reportAccess = value;
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrandList__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BrandAdd__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WebformList__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WebformAdd__ = __webpack_require__(1092);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import ApiBrands from '@/modules/api/brands'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'brands',
  components: { brandList: __WEBPACK_IMPORTED_MODULE_0__BrandList__["a" /* default */], brandAdd: __WEBPACK_IMPORTED_MODULE_1__BrandAdd__["a" /* default */], webformList: __WEBPACK_IMPORTED_MODULE_2__WebformList__["a" /* default */], webformAdd: __WEBPACK_IMPORTED_MODULE_3__WebformAdd__["a" /* default */] },
  data: function data() {
    return {
      tab: 0,
      isMobile: false
    };
  },

  computed: {
    brandFormShow: function brandFormShow() {
      return this.$store.state.brands.showBrandForm;
    },
    webformShow: function webformShow() {
      return this.$store.state.brands.webform.show;
    },
    webformLoading: function webformLoading() {
      return this.$store.state.brands.webform.loading;
    },
    serviceAreaLoading: function serviceAreaLoading() {
      return this.$store.state.brands.serviceArea.loading;
    }
  },
  methods: {
    showForm: function showForm() {
      if (this.tab === 1) {
        this.$store.commit('brands/setShowBrandForm', true);
      } else {
        this.$store.commit('brands/setWebformShow', true);
      }
    },
    setScreenSize: function setScreenSize() {
      var self = this;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        self.isMobile = true;
      } else {
        self.isMobile = false;
      }
    }
  },
  watch: {
    brandFormShow: function brandFormShow(value) {
      if (value) {
        document.documentElement.style.overflow = 'hidden';
      } else {
        document.documentElement.style.overflow = 'auto';
      }
    },
    webformShow: function webformShow(value) {
      if (value) {
        document.documentElement.style.overflow = 'hidden';
      } else {
        document.documentElement.style.overflow = 'auto';
      }
    }
  },
  mounted: function mounted() {
    this.setScreenSize();
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_brands__ = __webpack_require__(42);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'brand-list',
  props: ['isMobile'],
  components: {},
  data: function data() {
    return {
      tab: 0,
      extraDataLoading: false
    };
  },

  computed: {
    brands: function brands() {
      return this.$store.state.brands.list;
    },
    loading: function loading() {
      return this.$store.state.brands.loading;
    },
    webformLoading: function webformLoading() {
      return this.$store.state.brands.webform.loading;
    },
    currentOrder: function currentOrder() {
      var brands = this.$store.state.brands;
      return { field: brands.order, asc: brands.orderAsc };
    }
  },
  methods: {
    getBrands: function getBrands() {
      var self = this;
      self.$store.commit('brands/setLoading', true);
      __WEBPACK_IMPORTED_MODULE_1__modules_api_brands__["a" /* default */].getBrands(self, function (res) {
        self.$store.commit('brands/setLoading', false);
      });
    },
    editBrand: function editBrand(id) {
      var self = this;
      var index = self.brands.findIndex(function (x) {
        return x.id === id;
      });
      var brandData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, self.brands[index]);
      self.extraDataLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__modules_api_brands__["a" /* default */].getExtraData(self, id, function (res) {
        if (!res.error) {
          brandData.facebookLink = res.facebookLink || '';
          brandData.twitterLink = res.twitterLink || '';
          brandData.appDownloadImg = res.appDownloadBanner || '';
          brandData.iosDownloadImg = res.appIOSDownloadButton || '';
          brandData.androidDownloadImg = res.appAndroidDownloadButton || '';
          brandData.textLink = res.textLink || '';
          brandData.fbAppID = res.facebookAppId || '';
          brandData.shareWording = res.shareWording || '';
          brandData.aboutLink = res.aboutLink || '';
          brandData.emailLink = res.emailLink || '';
          brandData.instagramLink = res.instagramLink || '';
        }

        self.$store.commit('brands/setEditBrands', brandData);
        // self.getServicesData(id, brandData)
        self.extraDataLoading = false;
        self.getAppSettings();
        setTimeout(function () {
          self.$store.commit('brands/setShowBrandForm', true);
        }, 300);
      });
    },
    getAppSettings: function getAppSettings() {
      var self = this;
      self.$sdk.get('/settings', {}, function (r) {
        self.$store.commit('brands/setBrandData', {
          charterEnabled: r.CharterEnabledBrands.value.split(',')
        });
        setTimeout(function () {
          self.$store.commit('brands/setShowBrandForm', true);
        }, 200);
      });
    },
    getServicesData: function getServicesData(id, data) {
      var self = this;
      var brandData = data;
      __WEBPACK_IMPORTED_MODULE_1__modules_api_brands__["a" /* default */].getServices(self, id, function (res) {
        if (!res.error) {
          res.forEach(function (service) {
            brandData[service.code + 'Img'] = service.image;
            brandData[service.code + 'Label'] = service.name;
          });
        }

        self.$store.commit('brands/setEditBrands', brandData);
        self.extraDataLoading = false;
        setTimeout(function () {
          self.$store.commit('brands/setShowBrandForm', true);
        }, 300);
      });
    },
    webformName: function webformName(id) {
      var webform = this.$store.state.brands.webform.list;
      var index = webform.findIndex(function (x) {
        return x.id === id;
      });
      return webform[index].name;
    },
    sort: function sort(field) {
      if (this.loading) {
        return;
      }
      var brands = this.$store.state.brands;
      if (field !== brands.order) {
        this.$store.commit('brands/setBrandOrder', 1);
      } else {
        this.$store.commit('brands/setBrandOrderAsc', brands.orderAsc === 1 ? 0 : 1);
      }
      this.$store.commit('brands/setBrandOrder', field);
      this.getBrands();
    }
  },
  watch: {
    // provId: function (value) { this.init() }
  },
  mounted: function mounted() {
    this.getBrands();
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_us__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_us___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_us__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_color__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_brands__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_api_services__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'brand-add',
  components: { 'photoshop-picker': __WEBPACK_IMPORTED_MODULE_2_vue_color__["Photoshop"] },
  data: function data() {
    return {
      id: '',
      brandName: '',
      mobile: '',
      website: '',
      webform: 0,
      street: '',
      city: '',
      state: '',
      zip: '',
      faq: '',
      terms: '',
      charterBooking: 'disabled',
      supportEmail: '',
      sendEmailAs: '',
      emailColor: '',
      brandColor: '',
      emailColors: '',
      brandColors: '',
      showEmailColor: false,
      showBrandColor: false,
      file: {
        emailLogo: '',
        appDownload: '',
        iosDownload: '',
        androidDownload: '',
        shared: '',
        opoli: '',
        black: '',
        suv: '',
        shuttle: ''
      },
      uploadLoading: {
        emailLogo: false,
        appDownload: false,
        iosDownload: false,
        androidDownload: false,
        shared: false,
        opoli: false,
        black: false,
        suv: false,
        shuttle: false
      },
      confirmEmail: '',
      iosDownloadLink: '',
      androidDownloadLink: '',
      shared: '',
      opoli: '',
      black: '',
      suv: '',
      shuttle: '',
      facebookLink: '',
      twitterLink: '',
      textLink: '',
      facebookAppID: '',
      shareWording: '',
      aboutLink: '',
      emailLink: '',
      instagramLink: '',
      error: {
        brandName: '',
        mobile: '',
        website: '',
        webform: '',
        street: '',
        city: '',
        state: '',
        zip: '',
        faq: '',
        terms: '',
        supportEmail: '',
        sendEmailAs: '',
        emailColor: '',
        brandColor: '',
        emailColors: '',
        brandColors: '',
        file: {
          emailLogo: '',
          appDownload: '',
          iosDownload: '',
          androidDownload: '',
          shared: '',
          opoli: '',
          black: '',
          suv: '',
          shuttle: ''
        },
        confirmEmail: '',
        iosDownloadLink: '',
        androidDownloadLink: '',
        shared: '',
        opoli: '',
        black: '',
        suv: '',
        shuttle: '',
        facebookLink: '',
        twitterLink: '',
        textLink: '',
        facebookAppID: '',
        shareWording: '',
        aboutLink: '',
        emailLink: '',
        instagramLink: ''
      },
      errorReturn: '',
      showConfirm: false,
      submitLoading: false
    };
  },

  computed: {
    brandStore: function brandStore() {
      return this.$store.state.brands;
    },
    show: function show() {
      return this.brandStore.showBrandForm;
    },
    webforms: function webforms() {
      return this.brandStore.webform.list;
    },
    states: function states() {
      var states = [];
      for (var key in __WEBPACK_IMPORTED_MODULE_1_us___default.a.states) {
        if (__WEBPACK_IMPORTED_MODULE_1_us___default.a.states.hasOwnProperty(key)) {
          states.push({
            value: key,
            label: __WEBPACK_IMPORTED_MODULE_1_us___default.a.states[key].name
          });
        }
      }
      return states;
    },
    editID: function editID() {
      return this.brandStore.editBrands.id;
    }
  },
  methods: {
    selectColor: function selectColor(target) {
      if (!this[target + 'Colors']) {
        return;
      }
      this[target + 'Color'] = this[target + 'Colors'].hex.substring(1, this[target + 'Colors'].hex.length);
      this.showEmailColor = false;
      this.showBrandColor = false;
    },
    triggerUpload: function triggerUpload(ref) {
      if (this.uploadLoading[ref]) {
        return;
      }
      this.$refs[ref].click();
    },
    uploadImg: function uploadImg(e) {
      if (!e.target.files.length) {
        return;
      }

      var self = this;
      var file = e.target.files[0];
      var fd = new FormData();
      fd.append('pic', file);

      self.uploadLoading[e.target.id] = true;

      self.$http.post({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.mediaHost + '/api/upload', fd, {
        header: { 'Content-Type': 'multipart/form-data' }
      }).then(function (res) {
        self.uploadLoading[e.target.id] = false;
        console.log('success', res);
        if (!res.body.success) {
          // self.$store.commit('provider/showUploadError', true)
        } else {
          self.file[e.target.id] = res.body.data.url;
        }
      }, function (res) {
        console.log('error', res);
        // self.$store.commit('provider/showUploadError', true)
      });
    },
    close: function close() {
      this.$store.commit('brands/setShowBrandForm', false);
      if (this.editID) {
        this.$store.commit('brands/setEditBrands', {});
        this.clearForm();
      }
    },
    clearForm: function clearForm() {
      this.id = '';
      this.brandName = '';
      this.mobile = '';
      this.website = '';
      this.webform = '';
      this.street = '';
      this.city = '';
      this.state = '';
      this.zip = '';
      this.faq = '';
      this.terms = '';
      this.supportEmail = '';
      this.sendEmailAs = '';
      this.emailColor = '';
      this.brandColor = '';
      this.file.emailLogo = '';
      this.file.appDownload = '';
      this.file.iosDownload = '';
      this.file.androidDownload = '';
      this.file.shared = '';
      this.file.opoli = '';
      this.file.black = '';
      this.file.suv = '';
      this.file.shuttle = '';
      this.confirmEmail = '';
      this.iosDownloadLink = '';
      this.androidDownloadLink = '';
      this.shared = '';
      this.opoli = '';
      this.black = '';
      this.suv = '';
      this.shuttle = '';
      this.facebookLink = '';
      this.twitterLink = '';
      this.textLink = '';
      this.facebookAppID = '';
      this.shareWording = '';
      this.aboutLink = '';
      this.emailLink = '';
      this.instagramLink = '';
    },
    submit: function submit() {
      var self = this;

      if (!self.validate()) {
        return;
      }

      var editID = self.editID;
      if (editID) {
        __WEBPACK_IMPORTED_MODULE_3__modules_api_brands__["a" /* default */].updateBrand(self, self.compileBrandData(), function (res) {
          if (res.error) {
            self.errorReturn = res.error.message;
            self.scrollToTop();
            return;
          }
          self.updateService();
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_3__modules_api_brands__["a" /* default */].addBrand(self, self.compileBrandData(), function (res) {
          if (res.error) {
            self.errorReturn = res.error.message;
            self.scrollToTop();
            return;
          }

          self.id = res.id;
          self.updateService();
        });
      }
    },
    updateService: function updateService() {
      var self = this;
      // ApiBrands.updateService(self, {
      //   id: self.id,
      //   services: [
      //     { id: CONFIG.serviceId.shared, name: self.shared, image: self.file.shared },
      //     { id: CONFIG.serviceId.opoli, name: self.opoli, image: self.file.opoli },
      //     { id: CONFIG.serviceId.black, name: self.black, image: self.file.black },
      //     { id: CONFIG.serviceId.suv, name: self.suv, image: self.file.suv },
      //     { id: CONFIG.serviceId.shuttle, name: self.shuttle, image: self.file.shuttle }
      //   ]
      // }, function (res) {
      //   if (res.error) {
      //     self.errorReturn = res.error.message
      //     self.scrollToTop()
      //     return
      //   }

      //   self.updateProps()
      // })
      self.$sdk.post('/charter/brands', {
        token: self.$store.state.session.sessionToken,
        brandId: self.editID,
        enabled: self.charterBooking === 'enabled'
      }, function (r) {
        self.updateProps();
      }, '');
    },
    updateProps: function updateProps() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3__modules_api_brands__["a" /* default */].updateProps(self, self.compilePropsData(), function (res) {
        if (res.error) {
          self.errorReturn = res.error.message;
          self.scrollToTop();
          return;
        }

        location.reload();
      });
    },
    compileBrandData: function compileBrandData() {
      return {
        id: this.id,
        name: this.brandName,
        website: this.website,
        webformId: this.webform,
        brandColor: this.brandColor,
        appIOSDownloadLink: this.iosDownloadLink,
        appAndroidDownloadLink: this.androidDownloadLink,
        phoneNumber: this.mobile,
        supportEmail: this.supportEmail,
        emailLogoUrl: this.file.emailLogo,
        emailFAQ: this.faq,
        emailTC: this.terms,
        emailHighlightColor: this.emailColor,
        emailLink: this.emailLink,
        address: this.street,
        zipCode: this.zip,
        state: this.state,
        city: this.city,
        emailSendAs: this.sendEmailAs,
        googleTrackingId: this.sendEmailAs,
        linkToChat: this.sendEmailAs,
        confirmEmailContactInformation: this.confirmEmail
      };
    },
    compilePropsData: function compilePropsData() {
      return {
        id: this.id,
        props: {
          appDownloadBanner: this.file.appDownload,
          appIOSDownloadButton: this.file.iosDownload,
          appAndroidDownloadButton: this.file.androidDownload,
          facebookLink: this.facebookLink,
          facebookAppId: this.facebookAppID,
          emailLink: this.emailLink,
          instagramLink: this.instagramLink,
          twitterLink: this.twitterLink,
          shareWording: this.shareWording,
          textLink: this.textLink,
          aboutLink: this.aboutLink
        }
      };
    },
    validate: function validate() {
      var _this = this;

      var noError = true;

      var fields = ['brandName', 'mobile', 'website', 'webform', 'street', 'city', 'state', 'zip', 'faq', 'terms', 'supportEmail', 'sendEmailAs', 'emailColor', 'brandColor', 'confirmEmail', 'iosDownloadLink', 'androidDownloadLink', 'facebookLink', 'twitterLink', 'textLink', 'facebookAppID', 'shareWording', 'aboutLink', 'emailLink', 'instagramLink'];
      fields.forEach(function (field) {
        if (!_this[field]) {
          _this.error[field] = 'This field cannot be empty.';
          noError = false;
        }
      });

      var files = ['emailLogo', 'appDownload', 'iosDownload', 'androidDownload'];
      files.forEach(function (file) {
        if (!_this.file[file]) {
          _this.error.file[file] = 'This field cannot be empty.';
          noError = false;
        }
      });

      return noError;
    },
    scrollToTop: function scrollToTop() {
      var elmnt = document.getElementById('addBrand');
      elmnt.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    deleteBrand: function deleteBrand() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3__modules_api_brands__["a" /* default */].deleteBrand(self, self.editID, function (res) {
        if (res.error) {
          self.errorReturn = res.error.message;
          self.scrollToTop();
          return;
        }

        location.reload();
      });
    },
    closeConfirmation: function closeConfirmation() {
      if (this.submitLoading) {
        return true;
      }
      this.showConfirm = false;
    },
    serviceLabel: function serviceLabel(code) {
      return __WEBPACK_IMPORTED_MODULE_4__modules_api_services__["a" /* default */].getServiceName(code);
    }
  },
  watch: {
    show: function show(value) {
      var _this2 = this;

      var editData = this.$store.state.brands.editBrands;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(editData).length > 0) {
        if (value) {
          this.id = editData.id;
          this.brandName = editData.name;
          this.mobile = editData.phoneNumber;
          this.website = editData.website;
          this.webform = editData.webformId;
          this.street = editData.address;
          this.city = editData.city;
          this.state = editData.state;
          this.zip = editData.zipCode;
          this.faq = editData.emailFAQ;
          this.terms = editData.emailTC;
          this.supportEmail = editData.supportEmail;
          this.sendEmailAs = editData.emailSendAs;
          this.emailColor = editData.emailHighlightColor;
          this.brandColor = editData.brandColor;
          this.file.emailLogo = editData.emailLogoUrl;
          this.file.appDownload = editData.appDownloadImg;
          this.file.iosDownload = editData.iosDownloadImg;
          this.file.androidDownload = editData.androidDownloadImg;
          // this.file.shared = editData.sharedImg
          // this.file.opoli = editData.opoliImg
          // this.file.black = editData.blackImg
          // this.file.suv = editData.suvImg
          // this.file.shuttle = editData.shuttleImg
          this.confirmEmail = editData.confirmEmailContactInformation.replace(/(<([^>]+)>)/ig, '').trim();
          this.iosDownloadLink = editData.appIOSDownloadLink;
          this.androidDownloadLink = editData.appAndroidDownloadLink;
          // this.shared = editData.sharedLabel
          // this.opoli = editData.opoliLabel
          // this.black = editData.blackLabel
          // this.suv = editData.suvLabel
          // this.shuttle = editData.shuttleLabel
          this.facebookLink = editData.facebookLink;
          this.twitterLink = editData.twitterLink;
          this.textLink = editData.textLink;
          this.facebookAppID = editData.fbAppID;
          this.shareWording = editData.shareWording;
          this.aboutLink = editData.aboutLink;
          this.emailLink = editData.emailLink;
          this.instagramLink = editData.instagramLink;
          this.charterBooking = this.brandStore.charterEnabled.findIndex(function (x) {
            return x == _this2.editID;
          }) > -1 ? 'enabled' : 'disabled';
        } else {
          this.clearForm();
        }
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_brands_webforms__ = __webpack_require__(393);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'webform-list',
  props: ['isMobile'],
  components: {},
  data: function data() {
    return {
      tab: 0,
      webformIDs: [],
      webforms: {},
      webformDataLoading: false,
      sticky: false,
      dimension: {
        tableSAG: 0,
        tableWN: 0,
        webForms: {}
      }
    };
  },

  computed: {
    brands: function brands() {
      return this.$store.state.brands.list;
    },
    serviceArea: function serviceArea() {
      return this.$store.state.brands.serviceArea.list;
    },
    _webforms: function _webforms() {
      return this.$store.state.brands.webform.list;
    },
    webformLoading: function webformLoading() {
      return this.$store.state.brands.webform.loading;
    },
    serviceAreaLoading: function serviceAreaLoading() {
      return this.$store.state.brands.serviceArea.loading;
    },
    _webformRerender: function _webformRerender() {
      return this.$store.state.brands.webform.rerender;
    }
  },
  methods: {
    getServiceArea: function getServiceArea() {
      var self = this;
      self.$store.commit('brands/setWebformLoading', true);
      self.$store.commit('brands/seterviceAreaLoading', true);
      __WEBPACK_IMPORTED_MODULE_1__modules_api_brands_webforms__["a" /* default */].getServiceArea(self, function (res) {
        self.$store.commit('brands/seterviceAreaLoading', false);
      });
    },
    getWebforms: function getWebforms() {
      var self = this;
      self.$store.commit('brands/setWebformLoading', true);
      __WEBPACK_IMPORTED_MODULE_1__modules_api_brands_webforms__["a" /* default */].getWebforms(self, function (res) {
        self.$store.commit('brands/setWebformLoading', false);
      });
    },
    getWebformData: function getWebformData() {
      var self = this;
      if (self.webformDataLoading) {
        return;
      }

      self.webformDataLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__modules_api_brands_webforms__["a" /* default */].getWebformData(self, self.webformIDs[0], function (res) {
        self.webformDataLoading = false;
        if (!res.error) {
          self.webformIDs.shift();
          if (self.webformIDs.length > 0) {
            self.getWebformData();
          } else {
            self.$nextTick(function () {
              self.getDimensions();
            });
          }
        }
      });
    },
    editWebform: function editWebform(id) {
      var self = this;
      var index = self.webforms.findIndex(function (x) {
        return x.id === id;
      });
      self.$store.commit('brands/setWebformEdit', self.webforms[index]);
      setTimeout(function () {
        self.$store.commit('brands/setWebformShow', true);
      }, 300);
    },
    isChecked: function isChecked(service, webform) {
      return webform.geofencesIDs.indexOf(service.id) > -1;
    },
    onScroll: function onScroll() {
      if (!this.dimension.tableSAG || !this.dimension.tableWN || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.dimension.webForms).length === 0) {
        this.getDimensions();
        return false;
      }

      for (var key in this.dimension.webForms) {
        if (!this.dimension.webForms[key]) {
          this.getDimensions();
          return false;
        }
      }

      this.sticky = window.pageYOffset > 101;
    },
    getDimensions: function getDimensions() {
      var self = this;
      if (self.isMobile) {
        return;
      }
      self.dimension.tableSAG = self.$refs.tableSAG.clientWidth + 1;
      self.dimension.tableWN = self.$refs.tableWN.clientWidth;
      self.webforms.forEach(function (webform, index) {
        self.dimension.webForms['tableWF' + index] = self.$refs['tableWF' + index][0].clientWidth;
      });
      console.log(self.dimension);
    }
  },
  watch: {
    serviceArea: function serviceArea(value) {
      if (value) this.getWebforms();
    },
    _webforms: function _webforms(value) {
      var _this = this;

      this.webforms = value;
      if (value) {
        value.forEach(function (val) {
          _this.webformIDs.push(val.id);
        });
        this.getWebformData();
      }
    },
    _webformRerender: function _webformRerender(value) {
      var self = this;
      self.webforms = '';
      self.$nextTick(function () {
        self.webforms = self.$store.state.brands.webform.list;
      });
    }
  },
  mounted: function mounted() {
    var self = this;
    self.getServiceArea();

    // self.onScroll()
    window.onscroll = function () {
      self.onScroll();
    };
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import moment from 'moment'

/* harmony default export */ __webpack_exports__["a"] = ({
  getServiceArea: function getServiceArea(VueApp, callback) {
    VueApp.$sdk.get('/geofences', {
      // order: VueApp.$store.state.brands.webform.order,
      // orderAsc: VueApp.$store.state.brands.webform.orderAsc
      order: VueApp.$store.state.brands.webform.order,
      orderAsc: VueApp.$store.state.brands.webform.orderAsc
    }, function (res) {
      if (!res.error && res.list.length) {
        var serviceArea = [];
        var filtered = res.list.filter(function (x) {
          return x.type === 'servicearea';
        });
        filtered.forEach(function (data) {
          serviceArea.push({
            id: data.id,
            name: data.name
          });
        });
        VueApp.$store.commit('brands/setServiceAreaList', serviceArea);
      }
      callback(res);
    });
  },
  getWebforms: function getWebforms(VueApp, callback) {
    VueApp.$sdk.get('/webform', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      if (!res.error && res.list.length) {
        var webforms = [];
        res.list.forEach(function (data) {
          webforms.push({
            id: data.id,
            name: data.name
          });
        });
        VueApp.$store.commit('brands/setWebformList', webforms);
      }
      callback(res);
    });
  },
  getWebformData: function getWebformData(VueApp, id, callback) {
    VueApp.$sdk.get('/webform/' + id + '/geofences', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      if (!res.error) {
        VueApp.$store.commit('brands/updatedWebform', {
          id: id,
          geofencesIDs: res.geofenceIds
        });
      }
      callback(res);
    });
  },
  updateWebform: function updateWebform(VueApp, data, callback) {
    VueApp.$sdk.post('/webform/' + data.id + '/geofences', {
      token: VueApp.$store.state.session.sessionToken,
      geofenceIds: data.geoIDs
    }, function (res) {
      callback(res);
    });
  },
  addWebform: function addWebform(VueApp, data, callback) {
    var self = this;
    VueApp.$sdk.post('/webform/', {
      token: VueApp.$store.state.session.sessionToken,
      name: data.name
    }, function (res) {
      if (!res.error) {
        self.updateWebform(VueApp, { id: res.id, geoIDs: data.geoIDs }, function (res2) {
          callback(res2);
        });
      } else {
        callback(res);
      }
    });
  },
  deleteWebform: function deleteWebform(VueApp, id, callback) {
    VueApp.$sdk.delete('/webform/' + id, {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      callback(res);
    });
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_brands_webforms__ = __webpack_require__(393);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'webform-add',
  components: {},
  data: function data() {
    return {
      webform: '',
      checked: [],
      filterInput: '',
      serviceArea: [],
      submitLoading: false,
      error: '',
      errorMsg: {
        name: '',
        geofence: ''
      },
      showConfirm: false
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.brands.webform.show;
    },
    _serviceArea: function _serviceArea() {
      return this.$store.state.brands.serviceArea.list;
    },
    editId: function editId() {
      return this.$store.state.brands.webform.edit.id;
    }
  },
  methods: {
    close: function close() {
      if (self.submitLoading) {
        return;
      }
      this.$store.commit('brands/setWebformShow', false);
      if (this.$store.state.brands.webform.edit.id) {
        this.$store.commit('brands/setWebformEdit', {});
        this.clearForm();
      }
    },
    isChecked: function isChecked(id) {
      return this.checked.indexOf(id) > -1;
    },
    toggle: function toggle(id) {
      if (this.submitLoading) {
        return;
      }
      if (this.checked.indexOf(id) > -1) {
        var index = this.checked.indexOf(id);
        this.checked.splice(index, 1);
      } else {
        this.checked.push(id);
      }
    },
    filter: function filter() {
      var self = this;
      var result = [];
      var list = self._serviceArea;

      for (var index in list) {
        if (list[index].name.toLowerCase().indexOf(self.filterInput.toLowerCase()) < 0) {
          continue;
        }
        result.push(list[index]);
      }
      self.serviceArea = result;
    },
    clearForm: function clearForm() {
      this.webform = '';
      this.checked = [];
      this.filterInput = '';
      this.serviceArea = this._serviceArea;
    },
    submitWebform: function submitWebform() {
      var self = this;
      if (self.submitLoading) {
        return;
      }

      if (!self.webform) {
        self.errorMsg.name = 'This field cannot be empty.';
      }
      if (self.checked.length === 0) {
        self.errorMsg.geofence = 'Must choose atleast one service area.';
      }
      if (!self.webform || self.checked.length === 0) {
        self.scrollToTop();
        return;
      }

      self.submitLoading = true;
      if (self.editId) {
        __WEBPACK_IMPORTED_MODULE_2__modules_api_brands_webforms__["a" /* default */].updateWebform(self, { id: self.editId, geoIDs: self.checked }, function (res) {
          self.submitLoading = false;
          self.$store.commit('brands/updatedWebform', {
            id: self.editId,
            geofencesIDs: res.geofenceIds
          });
          self.$store.commit('brands/setWebformRerender', self.$store.state.brands.webform.rerender + 1);
          self.close();
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2__modules_api_brands_webforms__["a" /* default */].addWebform(self, { name: self.webform, geoIDs: self.checked }, function (res) {
          self.submitLoading = false;
          if (res.error) {
            self.error = res.error.message;
          } else {
            location.reload();
          }
        });
      }
    },
    scrollToTop: function scrollToTop() {
      var elmnt = document.getElementById('addWebform');
      elmnt.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    deleteWebform: function deleteWebform() {
      var self = this;
      if (self.submitLoading) {
        return;
      }

      self.submitLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__modules_api_brands_webforms__["a" /* default */].deleteWebform(self, self.editId, function (res) {
        self.submitLoading = true;
        if (res.error) {
          self.error = res.error.message;
          self.scrollToTop();
          return;
        }

        location.reload();
      });
    },
    closeConfirmation: function closeConfirmation() {
      if (this.submitLoading) {
        return true;
      }
      this.showConfirm = false;
    }
  },
  watch: {
    show: function show(value) {
      var editData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$store.state.brands.webform.edit);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(editData).length > 0) {
        if (value) {
          this.webform = editData.name;
          this.checked = this.checked.concat(editData.geofencesIDs);
        } else {
          this.clearForm();
        }
      }
    },
    _serviceArea: function _serviceArea(value) {
      this.serviceArea = value;
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccountDetails__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Referrals__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Transactions__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Reservations__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Ratings__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CreditCards__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PromoCodes__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Logs__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CountrySelectModal__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Partials_LoadingModal__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_api_consumer_user_info__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_api_consumer_referrals__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_api_provider_user_info__ = __webpack_require__(61);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'consumer',
  components: {
    accountDetails: __WEBPACK_IMPORTED_MODULE_1__AccountDetails__["a" /* default */], referrals: __WEBPACK_IMPORTED_MODULE_2__Referrals__["a" /* default */], transactions: __WEBPACK_IMPORTED_MODULE_3__Transactions__["a" /* default */], reservations: __WEBPACK_IMPORTED_MODULE_4__Reservations__["a" /* default */],
    ratings: __WEBPACK_IMPORTED_MODULE_5__Ratings__["a" /* default */], creditCards: __WEBPACK_IMPORTED_MODULE_6__CreditCards__["a" /* default */], promoCodes: __WEBPACK_IMPORTED_MODULE_7__PromoCodes__["a" /* default */], loadingModal: __WEBPACK_IMPORTED_MODULE_10__Partials_LoadingModal__["a" /* default */], countrySelectModal: __WEBPACK_IMPORTED_MODULE_9__CountrySelectModal__["a" /* default */], logs: __WEBPACK_IMPORTED_MODULE_8__Logs__["a" /* default */]
  },
  data: function data() {
    return {
      activeTab: 0,
      loading: false,
      referralLoading: false,
      showActiveModal: false,
      statusLoading: false,
      showLogs: false,
      logDate: 'all',
      showRecords: false,
      isMobile: false
    };
  },

  computed: {
    conId: function conId() {
      return this.$route.params.id;
    },
    consumerData: function consumerData() {
      var userInfo = this.$store.state.consumer.userInfo;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userInfo) === '{}') {
        return { firstName: '', lastName: '', mobile: '' };
      }

      return {
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        mobile: userInfo.mobile,
        customerURL: userInfo.customerURL
      };
    },
    isActive: function isActive() {
      return this.$store.state.consumer.userInfo.enabled;
    },
    formHasError: function formHasError() {
      return this.$store.state.consumer.formHasError;
    },
    formLoading: function formLoading() {
      return this.$store.state.consumer.formLoading;
    },
    formResult: function formResult() {
      return this.$store.state.consumer.formSave;
    },
    logsIcon: function logsIcon() {
      return !this.showLogs ? 'fa fa-clipboard-list fa-2x' : 'fas fa-times fa-2x';
    },
    logsLoading: function logsLoading() {
      return this.$store.state.consumer.logs.loading;
    }
  },
  methods: {
    init: function init() {
      this.setScreenSize();
      this.getConsumerData();
      this.getTotalReferrals();
    },
    getConsumerData: function getConsumerData() {
      var self = this;
      self.$store.commit('consumer/resetUserInfo');

      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_11__modules_api_consumer_user_info__["a" /* default */].getConsumerData(self, self.$route.params.id, function (res) {
        self.loading = false;
      });
    },
    getTotalReferrals: function getTotalReferrals() {
      var self = this;
      self.$store.commit('consumer/resetTotalReferrals');
      self.referralLoading = true;
      __WEBPACK_IMPORTED_MODULE_12__modules_api_consumer_referrals__["a" /* default */].getTotalReferrals(self, self.$route.params.id, function () {
        self.referralLoading = false;
      });
    },
    switchTab: function switchTab(index) {
      this.activeTab = index;
    },
    onScroll: function onScroll(event) {
      var scrollAndView = event.target.scrollTop + event.target.offsetHeight;
      if (event.target.scrollHeight - scrollAndView < 150) {
        if (this.activeTab === 0 && this.$refs.referrals.getReferrals()) {
          this.$refs.referrals.getReferrals();
        }
        // if (this.activeTab === 1 && this.$refs.transactions.getTransactions()) {
        //   this.$refs.transactions.getTransactions()
        // }
        if (this.activeTab === 2 && this.$refs.reservations.getTransactions()) {
          this.$refs.reservations.getTransactions();
        }
        if (this.activeTab === 3 && this.$refs.ratings.getRatings()) {
          this.$refs.ratings.getRatings();
        }
        if (this.activeTab === 4 && this.$refs.creditCards.getCards()) {
          this.$refs.creditCards.getCards();
        }
        if (this.activeTab === 5 && this.$refs.promoCodes.getPromoCodes()) {
          this.$refs.promoCodes.getPromoCodes();
        }
      }
    },
    call: function call(user) {
      var self = this;
      self.$plugins.phone.startCall(self, {
        phone: user.mobile,
        name: user.firstName + ' ' + user.lastName
      });
    },
    triggerSave: function triggerSave() {
      if (this.$refs.accountDetails.save()) {
        this.$refs.accountDetails.save();
      }
    },
    closeFormResult: function closeFormResult() {
      this.$store.commit('consumer/setFormSavingDone', false);
      this.$store.commit('consumer/setFormSaveMessage', '');
    },
    toggleConsActive: function toggleConsActive() {
      var self = this;
      self.statusLoading = true;

      // Using same end point with provider activate/deactivate - since both uses Contacts table
      __WEBPACK_IMPORTED_MODULE_13__modules_api_provider_user_info__["a" /* default */].updateProviderStatus(self, {
        id: self.$route.params.id,
        isActive: !this.isActive
      }, function (res) {
        self.statusLoading = false;
        self.showActiveModal = false;
        self.$store.commit('consumer/setuserActive', !self.isActive);
      });

      // setTimeout(() => {
      //   self.statusLoading = false
      //   self.showActiveModal = false
      //   self.$store.commit('consumer/setuserActive', !self.isActive)
      // }, 2000)
    },
    toggleLogs: function toggleLogs() {
      this.showLogs = !this.showLogs;
    },
    setScreenSize: function setScreenSize() {
      var self = this;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        self.isMobile = true;
      } else {
        self.isMobile = false;
      }
    }
  },
  watch: {
    conId: function conId(value) {
      this.init();
      this.showLogs = false;
      this.logDate = 'all';
    },
    logDate: function logDate(value) {
      if (this.$refs.logs.dateToggle(value)) {
        this.$refs.logs.dateToggle(value);
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_consumer_user_info__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_os__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_os___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_os__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import {countri es} from 'country-data'
// import Datepicker from 'vuejs-datepicker'

// import 'vue2-datepicker/index.css';
var countryData = __webpack_require__(90);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'account-details',
  props: ['referralLoading'],
  components: { DatePicker: __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker___default.a },
  data: function data() {
    return {
      contentShow: {
        personalInfo: true,
        accountInfo: true
      },
      validation: {
        userInfo: {
          firstName: '',
          lastName: '',
          email: '',
          mobile: '',
          phone: '',
          countryCode: ''
        }
      },
      passwordLoading: false,
      resetPasswordSuccess: false,
      resetPasswordMessage: '',
      currentCodeLength: 0,
      countryList: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(countryData)
    };
  },

  computed: {
    userInfo: function userInfo() {
      return this.$store.state.consumer.userInfo;
    },
    totalReferrals: function totalReferrals() {
      return this.$store.state.consumer.referrals.total;
    },
    countryCode: function countryCode() {
      var countries = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(countryData);
      if (this.userInfo.countryCode && this.$store.state.consumer.countryCode === '') {
        var countryCode = this.userInfo.countryCode;
        var country = {
          code: ''
        };
        if (countryCode === 1) {
          country.code = 'us';
        } else if (countryCode === 44) {
          country.code = 'gb';
        } else {
          country = countries.find(function (x) {
            return x.dialCode === countryCode;
          });
        }
        this.$store.commit('consumer/setCountryCode', country ? country.code : '');
      }
      this.currentCodeLength = String(this.$store.state.consumer.callingCode).length;
      return this.$store.state.consumer.countryCode.toLowerCase();
    },
    callingCode: function callingCode() {
      if (this.userInfo.countryCode && this.$store.state.consumer.callingCode === '') {
        var countryCode = this.userInfo.countryCode;
        this.$store.commit('consumer/setCallingCode', countryCode);
      }
      return this.$store.state.consumer.callingCode;
    },
    dialCodeLength: function dialCodeLength() {
      var lengthClass = ['', 'small', 'medium', 'large', 'xl', 'xl'];
      return lengthClass[this.currentCodeLength - 1];
    }
  },
  methods: {
    selectCountry: function selectCountry() {
      this.$store.commit('consumer/setCountryModal', true);
    },
    call: function call(user) {
      var self = this;
      self.$plugins.phone.startCall(self, {
        phone: user.mobile,
        name: user.firstName + ' ' + user.lastName
      });
    },
    fieldValidate: function fieldValidate(parent, child) {
      var self = this;
      if (self[parent][child] !== '') {
        this.validation[parent][child] = '';
      }

      self.saveButtonStatusCheck();
    },
    saveButtonStatusCheck: function saveButtonStatusCheck() {
      var self = this;
      var overAllError = false;

      for (var key in self.validation.userInfo) {
        if (self.validation.userInfo[key] !== '') {
          overAllError = true;
        }
      }

      self.$store.commit('consumer/setFormHasError', overAllError);
    },
    save: function save() {
      var self = this;
      if (self.validateAll()) {
        self.$store.commit('consumer/setFormLoading', true);
        __WEBPACK_IMPORTED_MODULE_2__modules_api_consumer_user_info__["a" /* default */].updateConsumer(self, self.buildData(), function (res) {
          self.$store.commit('consumer/setFormLoading', false);

          self.$store.commit('consumer/setFormSavingDone', true);
          self.$store.commit('consumer/setFormSaveMessage', self.$t('consumer.formSuccessful'));
          if (res.error) {
            self.$store.commit('consumer/setFormSaveMessage', res.error.message);
          }
        });
      } else {
        self.$store.commit('consumer/setFormLoading', false);
      }
    },
    validateAll: function validateAll() {
      var self = this;
      var noError = true;
      var errorMsg = {
        empty: self.$t('consumer.emptyField')
      };

      var fields = ['firstName', 'lastName', 'email', 'mobile', 'phone'];
      fields.forEach(function (key) {
        if (self.userInfo[key] === '' || self.userInfo[key] === null) {
          self.validation.userInfo[key] = errorMsg.empty;
          noError = false;
        }
      });
      if (!this.callingCode) {
        noError = false;
        self.validation.userInfo.countryCode;
      }

      self.$store.commit('consumer/setFormHasError', !noError);
      return noError;
    },
    buildData: function buildData() {
      var userInfo = this.userInfo;
      var tmp = {
        id: userInfo.id,
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        email: userInfo.email,
        mobile: this.callingCode + userInfo.phone,
        deviceOS: userInfo.deviceOS,
        deviceModel: userInfo.deviceModel,
        wheelChairLift: userInfo.wheelChair,
        serviceDock: userInfo.serviceDog,
        // phone: userInfo.phone,
        // countryCode: this.callingCode
        phone: '+' + this.callingCode + userInfo.nationalNumber,
        countryCode: this.callingCode,
        nationalNumber: userInfo.nationalNumber
      };
      if (userInfo.bday) tmp.dateOfBirth = userInfo.bday;
      if (userInfo.country) tmp.userCountry = userInfo.country;
      if (userInfo.passportNum) tmp.passportNum = userInfo.passportNum;

      return tmp;
    },
    emailPassword: function emailPassword() {
      var self = this;
      self.passwordLoading = true;
      self.resetPasswordMessage = '';
      __WEBPACK_IMPORTED_MODULE_2__modules_api_consumer_user_info__["a" /* default */].emailPassword(self, self.userInfo.id, function (res) {
        self.passwordLoading = false;
        self.resetPasswordMessage = self.$t('consumer.passwordSent');
        self.resetPasswordSuccess = true;

        if (res.error) {
          self.resetPasswordMessage = res.error.message;
          self.resetPasswordSuccess = false;
          return;
        }
        setTimeout(function () {
          self.resetPasswordMessage = '';
        }, 5000);
      });
    },
    updateADA: function updateADA(ada, value) {
      var self = this;
      if (ada === "wheel") {
        if (value) {
          self.userInfo.wheelChair = 0;
        } else {
          self.userInfo.wheelChair = 1;
        }
      } else {
        if (value) {
          self.userInfo.serviceDog = 0;
        } else {
          self.userInfo.serviceDog = 1;
        }
      }
    },
    bdayUpdate: function bdayUpdate(val) {
      this.$store.commit('consumer/setuserInfoData', {
        bday: __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(val).format('YYYY-MM-DD')
      });
    },
    cleanCountryName: function cleanCountryName(val) {
      var val2 = val.slice(0, val.indexOf(" ("));
      return val.indexOf(" (") === -1 ? val : val2;
    }
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

var phoneUtil = __webpack_require__(50).PhoneNumberUtil.getInstance();

/* harmony default export */ __webpack_exports__["a"] = ({
  getConsumerData: function getConsumerData(VueApp, conId, callback) {
    VueApp.$sdk.get('/consumer/' + conId, {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      if (!res.error) {

        var conData = {
          id: res.ID,
          firstName: res.firstName,
          lastName: res.lastName,
          email: res.email,
          mobile: res.countryCode + '' + res.phone,
          enabled: res.enabled === 1,
          deviceOS: '',
          deviceModel: '',
          customerURL: res.customerURL,
          created: __WEBPACK_IMPORTED_MODULE_0_moment___default()(res.created, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY'),
          referralCode: res.referralCode,
          wheelChair: res.ada.wheelChairLift,
          serviceDog: res.ada.serviceDog,
          phone: res.phone,
          countryCode: res.countryCode,
          nationalNumber: res.nationalNumber || res.phone,
          // nationalNumber: phone ? mobile.getNationalNumber() : ''
          bday: res.dateOfBirth,
          country: res.userCountry,
          passportNum: res.passportNum
        };
        var phone = String(res.phone);
        if (phone.lastIndexOf('+') > -1) {
          phone = phone.substring(phone.lastIndexOf('+') + 1);
          conData.phone = phone;
          if (conData.nationalNumber == 'undefined') conData.nationalNumber = phone;
          var mobile = phoneUtil.parse('+' + phone, '');
          conData.countryCode = mobile.getCountryCode();
        }

        VueApp.$sdk.get('/consumer/' + conId + '/phones', {
          token: VueApp.$store.state.session.sessionToken
        }, function (res2) {
          if (!res.error) {
            conData.deviceOS = res2.OS;
            conData.deviceModel = res2.model;
          }
          VueApp.$store.commit('consumer/setuserInfo', conData);
          callback(res);
        });
      } else {
        callback(res);
      }
    });
  },
  updateConsumer: function updateConsumer(VueApp, data, callback) {
    var self = this;
    // let mobile = phoneUtil.parse('+' + data.mobile, '')
    data.token = VueApp.$store.state.session.sessionToken;
    VueApp.$sdk.post('/consumer/' + data.id, data, function (res) {
      if (!res.error) {
        var phoneData = {
          id: data.id,
          // mobile: mobile.getNationalNumber(),
          // countryCode: mobile.getCountryCode(),
          mobile: data.phone,
          countryCode: data.countryCode,
          deviceOS: data.deviceOS,
          deviceModel: data.deviceModel,
          nationalNumber: data.nationalNumber
        };
        self.updatePhone(VueApp, phoneData, function (res2) {
          callback(res2);
        });
      } else {
        callback(res);
      }
    });
  },
  updatePhone: function updatePhone(VueApp, data, callback) {
    VueApp.$sdk.post('/consumer/' + data.id + '/phones', {
      token: VueApp.$store.state.session.sessionToken,
      phoneNumber: data.mobile,
      countryCode: data.countryCode,
      'OS': data.deviceOS,
      model: data.deviceModel,
      type: 'C',
      nationalNumber: data.nationalNumber
    }, function (res) {
      callback(res);
    });
  },
  emailPassword: function emailPassword(VueApp, conId, callback) {
    VueApp.$sdk.delete('/consumer/' + conId + '/password', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      callback(res);
    });
  },
  updateConsumerStatus: function updateConsumerStatus(VueApp, data, callback) {
    var action = data.isActive ? 'post' : 'delete';
    VueApp.$sdk[action]('/provider/' + data.id + '/active', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      callback(res);
    });
  }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_consumer_referrals__ = __webpack_require__(399);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'referrals',
  props: ['conId', 'isMobile'],
  data: function data() {
    return {
      loading: false
    };
  },

  computed: {
    referrals: function referrals() {
      return this.$store.state.consumer.referrals.list;
    },
    isMax: function isMax() {
      return this.$store.state.consumer.referrals.isMax;
    }
  },
  methods: {
    init: function init() {
      this.$store.commit('consumer/resetReferrals');
      this.$store.commit('consumer/setReferralsIsMax', false);
      this.$store.commit('consumer/setReferralsCurrentPage', 0);

      this.getReferrals();
    },
    getReferrals: function getReferrals() {
      var self = this;
      if (self.isMax || self.loading) {
        return;
      }

      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__modules_api_consumer_referrals__["a" /* default */].getReferrals(self, self.conId, function () {
        self.loading = false;
      });
    }
  },
  watch: {
    conId: function conId(value) {
      this.init();
    },
    isMobile: function isMobile(value) {
      this.init();
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["a"] = ({
  getReferrals: function getReferrals(VueApp, conId, callback) {
    var referrals = VueApp.$store.state.consumer.referrals;
    var pageSize = referrals.perPage;
    var page = referrals.currentPage;

    VueApp.$sdk.get('/consumer/' + conId + '/referrals', {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: pageSize,
      pageNum: page + 1
    }, function (res) {
      if (!res.error) {
        VueApp.$store.commit('consumer/setReferralsCurrentPage', page + 1);

        if (res.list.length < pageSize) {
          VueApp.$store.commit('consumer/setReferralsIsMax', true);
        }

        if (res.list.length) {
          var referral = res.list;
          for (var i = 0; i < res.list.length; i++) {
            VueApp.$store.commit('consumer/addReferrals', {
              firstName: referral[i].firstName,
              lastName: referral[i].lastName,
              email: referral[i].email,
              mobile: referral[i].phone,
              accountCreated: __WEBPACK_IMPORTED_MODULE_0_moment___default()(referral[i].created, 'YYYY-MM-DD').format('MM/DD/YYYY'),
              lastTrx: referral[i].lastTrx,
              totalTrx: referral[i].lastTrx,
              id: referral[i].ID,
              type: referral[i].type,
              rating: referral[i].rating,
              referralCode: referral[i].referralCode,
              totalReferral: referral[i].totalReferral
            });
          }
        }
      }
      callback(res);
    });
  },
  getTotalReferrals: function getTotalReferrals(VueApp, conId, callback) {
    VueApp.$sdk.get('/consumer/' + conId + '/referrals', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      if (!res.error) {
        VueApp.$store.commit('consumer/setTotalReferrals', res.list.length);
      }
      callback(res);
    });
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_consumer_transactions__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_csvexport__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var exporter = __WEBPACK_IMPORTED_MODULE_3_csvexport___default.a.create({
  filename: "export.csv",
  columns: ['Date', 'Booking Time', 'Pickup Time', 'Service Area', 'Prov ID', 'Prov License', 'Company', 'RSVP ID', 'Invoice ID', 'Service Type', 'First Name', 'Last Name', 'Credit Card', 'Email', 'Mobile', 'Source', 'Final Offer', 'Charge Amount', 'Refunded Amount', 'Promo Used', 'Driver Payment', 'Bonus', 'Cancel Fees', 'Status', 'Pickup Location', 'Dropoff Location']
});

// const exporter = CsvExport.create({
//   filename: 'export.csv',
//   columns: [
//     'Charged Date', 'Customer', 'Card Owner', 'RSVP ID', 'Invoice ID',
//     'TRX Type', 'Charged Amount', 'Refunded Amount'
//   ]
// })

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'transactions',
  props: ['conId', 'isMobile'],
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a },
  data: function data() {
    return {
      searchInput: '',
      blurDelay: '',
      from: '',
      to: '',
      hasError: {
        searchMsg: '',
        from: false,
        to: false,
        fromToMsg: ''
      },
      loading: false,
      sort: {
        active: 'created',
        isDesc: true
      }
    };
  },

  computed: {
    status: {
      get: function get() {
        return this.$store.state.consumer.transactions.status;
      },
      set: function set(value) {
        this.$store.commit('consumer/setTrxStatus', value);
        if ((this.date.from === '' || this.date.to === '') && this.dateType !== 'all') {
          this.hasError.from = this.date.from === '';
          this.hasError.to = this.date.to === '';
          return;
        }
        this.getTransactions();
      }
    },
    dateType: {
      get: function get() {
        return this.$store.state.consumer.transactions.date;
      },
      set: function set(value) {
        this.$store.commit('consumer/setTrxDate', value);

        var from = '';
        var to = value === 'all' ? '' : __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM/DD/YYYY');
        if (value === 'withinDay') {
          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM/DD/YYYY');
        }
        if (value === 'monthToDate') {
          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()(__WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM') + '/1/' + __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY'), 'MM/DD/YYYY').format('MM/DD/YYYY');
        }
        if (value === 'lastMonth') {
          var lastMonth = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(1, 'months');
          from = lastMonth.format('MM/01/YYYY');
          to = lastMonth.endOf('month').format('MM/DD/YYYY');
        }
        if (value === 'lastWeek') {
          var subtractDays = 0;
          var currentDate = parseInt(__WEBPACK_IMPORTED_MODULE_0_moment___default()().format('E'));
          if (currentDate !== 7) {
            subtractDays = currentDate;
          }

          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(subtractDays + 6, 'days').format('MM/DD/YYYY');
          to = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(subtractDays, 'days').format('MM/DD/YYYY');
        }
        if (value === 'last2Week') {
          var _subtractDays = 0;
          var _currentDate = parseInt(__WEBPACK_IMPORTED_MODULE_0_moment___default()().format('E'));
          if (_currentDate !== 7) {
            _subtractDays = _currentDate;
          }
          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(_subtractDays + 13, 'days').format('MM/DD/YYYY');
          to = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(_subtractDays, 'days').format('MM/DD/YYYY');
        }
        if (value === 'last30Days') {
          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(30, 'days').format('MM/DD/YYYY');
        }
        if (value === 'last60Days') {
          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(60, 'days').format('MM/DD/YYYY');
        }
        if (value === 'last90Days') {
          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(90, 'days').format('MM/DD/YYYY');
        }

        if (value !== 'custom') {
          this.hasError = { searchMsg: '', from: false, to: false, fromToMsg: '' };
          this.$store.commit('consumer/setTrxDateFrom', from);
          this.$store.commit('consumer/setTrxDateTo', to);

          if (value === 'all' && this.searchInput === '') {
            this.hasError.searchMsg = this.$t('transactions.filter.searchEmpty');
            var self = this;
            self.$nextTick(function () {
              self.$refs.search.focus();
            });
            return;
          }

          this.getTransactions();
        }
      }
    },
    date: function date() {
      var filter = this.$store.state.consumer.transactions;
      return {
        from: filter.dateFrom,
        to: filter.dateTo
      };
    },
    transactions: function transactions() {
      return this.$store.state.consumer.transactions.list;
    },
    isMax: function isMax() {
      return this.$store.state.consumer.transactions.isMax;
    },

    perPage: {
      get: function get() {
        return this.$store.state.consumer.transactions.perPage;
      },
      set: function set(val) {
        this.$store.commit('consumer/setTrxData', {
          perPage: parseInt(val),
          currentPage: 1
        });
        this.getTransactions();
      }
    },
    pageData: function pageData() {
      var tableData = this.$store.state.consumer.transactions;
      var start = tableData.currentPage * tableData.perPage - (tableData.perPage - 1);
      var end = tableData.currentPage * tableData.perPage;
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      };
    },

    currentPage: {
      get: function get() {
        return this.$store.state.consumer.transactions.currentPage;
      },
      set: function set(val) {
        this.$store.commit('consumer/setTrxData', { currentPage: parseInt(val) });
        this.getTransactions();
      }
    },
    isLastPage: function isLastPage() {
      var consumer = this.$store.state.consumer.transactions;
      return consumer.currentPage * consumer.perPage >= consumer.maxList;
    },
    totalPage: function totalPage() {
      var consumer = this.$store.state.consumer.transactions;
      return Math.ceil(consumer.maxList / consumer.perPage);
    }
  },
  methods: {
    init: function init() {
      var self = this;

      self.$store.commit('consumer/resetFilters');
      self.$store.commit('consumer/setTrxData', {
        maxList: 0,
        currentPage: 1
      });
      self.$store.commit('consumer/setTrxDateFrom', __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM/DD/YYYY'));
      self.$store.commit('consumer/setTrxDateTo', __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM/DD/YYYY'));

      self.getTransactions();
    },
    search: function search() {
      this.searchInput = this.searchInput.trim();
      this.$store.commit('consumer/setTrxSearch', this.searchInput);

      if (this.searchInput === '' && this.dateType === 'all') {
        this.hasError.searchMsg = this.$t('transactions.filter.searchEmpty');
        return;
      }
      this.hasError.searchMsg = '';

      if ((this.date.from === '' || this.date.to === '') && this.dateType !== 'all') {
        this.hasError.from = this.date.from === '';
        this.hasError.to = this.date.to === '';
        return;
      }

      if (this.searchInput !== '') {
        this.$store.commit('consumer/setTrxDate', 'all');
        this.$store.commit('consumer/setTrxDateFrom', '');
        this.$store.commit('consumer/setTrxDateTo', '');
      }
      this.getTransactions();
    },
    blurSearch: function blurSearch() {
      var self = this;
      if (self.$store.state.consumer.transactions.search === self.searchInput.trim()) {
        return;
      }

      self.blurDelay = setTimeout(function () {
        self.search();
      }, 500);
    },
    clearSearch: function clearSearch() {
      if (this.blurDelay) {
        clearTimeout(this.blurDelay);
      }

      if (this.loading) {
        return;
      }

      this.searchInput = '';
      this.$store.commit('consumer/setTrxSearch', this.searchInput);
      this.dateType = 'withinDay';
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('MM/DD/YYYY');
    },
    updateFromTo: function updateFromTo(fromTo) {
      this.$store.commit('consumer/setTrxDate', 'custom');

      var format = 'MM/DD/YYYY';
      var from = '';
      var to = '';

      if (fromTo === 'from') {
        this.hasError.from = false;
        from = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.date.from);
        this.$store.commit('consumer/setTrxDateFrom', from.format(format));
        if (this.date.to) {
          to = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.date.to, format);
        }
      } else {
        this.hasError.to = false;
        to = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.date.to);
        this.$store.commit('consumer/setTrxDateTo', to.format(format));
        if (this.date.from) {
          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.date.from, format);
        }
      }

      this.hasError = { searchMsg: '', from: false, to: false, fromToMsg: '' };

      if (this.date.from === '' || this.date.to === '') {
        if (fromTo === 'from') {
          this.hasError.to = true;
        } else {
          this.hasError.from = true;
        }
        this.hasError.fromToMsg = this.$t('transactions.filter.emptyDate');
        return;
      }
      if (from.format('x') > to.format('x')) {
        this.hasError.from = true;
        this.hasError.to = true;
        this.hasError.fromToMsg = this.$t('transactions.filter.invalidDateRange');
        return;
      }
      this.getTransactions();
    },
    getTransactions: function getTransactions() {
      var self = this;
      if (self.loading) {
        return;
      }

      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__modules_api_consumer_transactions__["a" /* default */].getTransactions(self, self.conId, function () {
        self.loading = false;
      });
    },
    exportTrx: function exportTrx() {
      var self = this;

      // let transactions = self.$store.state.consumer.transactions
      // let since = moment(transactions.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD')
      // let until = moment(transactions.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD')
      // if (transactions.date === 'all') {
      //   since = '2010-01-01'
      //   until = moment().add(10, 'years').format('YYYY-MM-DD')
      // }
      // self.$sdk.get('/reports/trx/list', {
      //   token: this.$store.state.session.sessionToken,
      //   since: since,
      //   until: until,
      //   originals: 1,
      //   tiptrx: 1,
      //   cancelfeetrx: 1,
      //   consId: self.$route.params.id
      // }, res => {
      //   if (res.list) {
      //     let trx = []
      //     res.list.forEach(list => {
      //       let charged = list.trxType !== 'Refund' ? self.covertNumber(parseFloat(list.chargedAmount).toFixed(2)) : '-'
      //       let refund = list.trxType === 'Refund' ? self.covertNumber(parseFloat(list.chargedAmount).toFixed(2)) : '-'
      //       trx.push({
      //         'Charged Date': moment(list.created, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY  HH:mm'),
      //         'Customer': list.customer,
      //         'Card Owner': list.cardOwner,
      //         'RSVP ID': list.rsvpId,
      //         'Invoice ID': list.invoiceID,
      //         'TRX Type': list.trxType,
      //         'Charged Amount': charged,
      //         'Refunded Amount': refund
      //       })
      //     })
      //     exporter.downloadCsv(trx)
      //   }
      // })

      __WEBPACK_IMPORTED_MODULE_2__modules_api_consumer_transactions__["a" /* default */].exportTransactions(self, self.conId, function (res) {
        if (!res.error) {
          exporter.downloadCsv(res);
        }
      });
    },
    covertNumber: function covertNumber(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    sortTable: function sortTable(code) {
      if (!code) {
        return;
      }

      if (this.sort.active === code) {
        this.sort.isDesc = !this.sort.isDesc;
      } else {
        this.sort.isDesc = true;
      }

      this.sort.active = code;
      this.$store.commit('consumer/setTrxSortColumn', code);
      this.$store.commit('consumer/setTrxSortIsDesc', this.sort.isDesc);
      this.$store.commit('consumer/setTransactionsCurrentPage', 1);
      this.getTransactions();
    },
    call: function call(user) {
      var self = this;
      self.$plugins.phone.startCall(self, {
        phone: user.mobile,
        name: user.firstName + ' ' + user.lastName
      });
    },
    relabel: function relabel(trx) {
      if (trx.statusLabel !== 'Credit Conversion') {
        return trx.statusLabel;
      }
      return 'Open Credit';
    },
    checkReclaimed: function checkReclaimed(trx) {
      if (trx.transactionType !== 'CONVERT_CREDIT ') {
        return '';
      }

      if (trx.transactionType === 'CONVERT_CREDIT ' && trx.notes === 'RECLAIMED') {
        return 'RECLAIMED';
      }
    },
    prev: function prev() {
      if (this.currentPage === 1) {
        return;
      }
      this.$store.commit('consumer/setTrxData', { currentPage: this.currentPage - 1 });
      this.getTransactions();
    },
    next: function next() {
      if (this.isLastPage) {
        return;
      }
      this.$store.commit('consumer/setTrxData', { currentPage: this.currentPage + 1 });
      this.getTransactions();
    }
  },
  watch: {
    conId: function conId(value) {
      this.init();
    },
    isMobile: function isMobile(value) {
      this.init();
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_consumer_reservations__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_csvexport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_api_services__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */






var exporter = __WEBPACK_IMPORTED_MODULE_3_csvexport___default.a.create({
  filename: "export.csv",
  columns: ['Date', 'Booking Time', 'Pickup Time', 'Service Area', 'Prov ID', 'Prov License', 'Company', 'RSVP ID', 'Invoice ID', 'Service Type', 'First Name', 'Last Name', 'Credit Card', 'Email', 'Mobile', 'Source', 'Final Offer', 'Charge Amount', 'Refunded Amount', 'Promo Used', 'Driver Payment', 'Bonus', 'Cancel Fees', 'Status', 'Pickup Location', 'Dropoff Location']
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reservations',
  props: ['conId', 'isMobile'],
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a },
  data: function data() {
    return {
      searchInput: '',
      blurDelay: '',
      from: '',
      to: '',
      hasError: {
        searchMsg: '',
        from: false,
        to: false,
        fromToMsg: ''
      },
      loading: false,
      sort: {
        active: 'created',
        isDesc: true
      }
    };
  },

  computed: {
    status: {
      get: function get() {
        return this.$store.state.consumer.reservations.status;
      },
      set: function set(value) {
        this.$store.commit('consumer/setRsvpStatus', value);
        if ((this.date.from === '' || this.date.to === '') && this.dateType !== 'all') {
          this.hasError.from = this.date.from === '';
          this.hasError.to = this.date.to === '';
          return;
        }
        this.getTransactions(true);
      }
    },
    dateType: {
      get: function get() {
        return this.$store.state.consumer.reservations.date;
      },
      set: function set(value) {
        this.$store.commit('consumer/setRsvpDate', value);

        var from = '';
        var to = value === 'all' ? '' : __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM/DD/YYYY');
        if (value === 'withinDay') {
          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM/DD/YYYY');
        }
        if (value === 'monthToDate') {
          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()(__WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM') + '/1/' + __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY'), 'MM/DD/YYYY').format('MM/DD/YYYY');
        }
        if (value === 'lastMonth') {
          var lastMonth = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(1, 'months');
          from = lastMonth.format('MM/01/YYYY');
          to = lastMonth.endOf('month').format('MM/DD/YYYY');
        }
        if (value === 'lastWeek') {
          var subtractDays = 0;
          var currentDate = parseInt(__WEBPACK_IMPORTED_MODULE_0_moment___default()().format('E'));
          if (currentDate !== 7) {
            subtractDays = currentDate;
          }

          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(subtractDays + 6, 'days').format('MM/DD/YYYY');
          to = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(subtractDays, 'days').format('MM/DD/YYYY');
        }
        if (value === 'last2Week') {
          var _subtractDays = 0;
          var _currentDate = parseInt(__WEBPACK_IMPORTED_MODULE_0_moment___default()().format('E'));
          if (_currentDate !== 7) {
            _subtractDays = _currentDate;
          }
          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(_subtractDays + 13, 'days').format('MM/DD/YYYY');
          to = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(_subtractDays, 'days').format('MM/DD/YYYY');
        }
        if (value === 'last30Days') {
          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(30, 'days').format('MM/DD/YYYY');
        }
        if (value === 'last60Days') {
          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(60, 'days').format('MM/DD/YYYY');
        }
        if (value === 'last90Days') {
          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(90, 'days').format('MM/DD/YYYY');
        }

        if (value !== 'custom') {
          this.hasError = { searchMsg: '', from: false, to: false, fromToMsg: '' };
          this.$store.commit('consumer/setRsvpDateFrom', from);
          this.$store.commit('consumer/setRsvpDateTo', to);

          if (value === 'all' && this.searchInput === '') {
            this.hasError.searchMsg = this.$t('transactions.filter.searchEmpty');
            var self = this;
            self.$nextTick(function () {
              self.$refs.search.focus();
            });
            return;
          }

          this.getTransactions(true);
        }
      }
    },
    date: function date() {
      var filter = this.$store.state.consumer.reservations;
      return {
        from: filter.dateFrom,
        to: filter.dateTo
      };
    },
    transactions: function transactions() {
      return this.$store.state.consumer.reservations.list;
    },
    isMax: function isMax() {
      return this.$store.state.consumer.reservations.isMax;
    },
    useOldQuatation: function useOldQuatation() {
      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation;
    }
  },
  methods: {
    init: function init() {
      var self = this;
      self.$store.commit('consumer/resetRsvpFilters');
      self.$store.commit('consumer/setRsvpDateFrom', __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(30, 'days').format('MM/DD/YYYY'));
      self.$store.commit('consumer/setRsvpDateTo', __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM/DD/YYYY'));

      self.getTransactions(true);
    },
    search: function search() {
      this.searchInput = this.searchInput.trim();
      this.$store.commit('consumer/setRsvpSearch', this.searchInput);

      if (this.searchInput === '' && this.dateType === 'all') {
        this.hasError.searchMsg = this.$t('transactions.filter.searchEmpty');
        return;
      }
      this.hasError.searchMsg = '';

      if ((this.date.from === '' || this.date.to === '') && this.dateType !== 'all') {
        this.hasError.from = this.date.from === '';
        this.hasError.to = this.date.to === '';
        return;
      }

      if (this.searchInput !== '') {
        this.$store.commit('consumer/setRsvpDate', 'all');
        this.$store.commit('consumer/setRsvpDateFrom', '');
        this.$store.commit('consumer/setRsvpDateTo', '');
      }
      this.getTransactions(true);
    },
    blurSearch: function blurSearch() {
      var self = this;
      if (self.$store.state.consumer.reservations.search === self.searchInput.trim()) {
        return;
      }

      self.blurDelay = setTimeout(function () {
        self.search();
      }, 500);
    },
    clearSearch: function clearSearch() {
      if (this.blurDelay) {
        clearTimeout(this.blurDelay);
      }

      if (this.loading) {
        return;
      }

      this.searchInput = '';
      this.$store.commit('consumer/setRsvpSearch', this.searchInput);
      this.dateType = 'last30Days';
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('MM/DD/YYYY');
    },
    updateFromTo: function updateFromTo(fromTo) {
      this.$store.commit('consumer/setRsvpDate', 'custom');

      var format = 'MM/DD/YYYY';
      var from = '';
      var to = '';

      if (fromTo === 'from') {
        this.hasError.from = false;
        from = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.date.from);
        this.$store.commit('consumer/setRsvpDateFrom', from.format(format));
        if (this.date.to) {
          to = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.date.to, format);
        }
      } else {
        this.hasError.to = false;
        to = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.date.to);
        this.$store.commit('consumer/setRsvpDateTo', to.format(format));
        if (this.date.from) {
          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.date.from, format);
        }
      }

      this.hasError = { searchMsg: '', from: false, to: false, fromToMsg: '' };

      if (this.date.from === '' || this.date.to === '') {
        if (fromTo === 'from') {
          this.hasError.to = true;
        } else {
          this.hasError.from = true;
        }
        this.hasError.fromToMsg = this.$t('transactions.filter.emptyDate');
        return;
      }
      if (from.format('x') > to.format('x')) {
        this.hasError.from = true;
        this.hasError.to = true;
        this.hasError.fromToMsg = this.$t('transactions.filter.invalidDateRange');
        return;
      }
      this.getTransactions(true);
    },
    getLabel: function getLabel(item) {
      switch (item) {
        case "ready":
          return "Ready to go";
        case "onboard":
          return "On Board";
        case "requires_dispatch":
          return "Requires Dispatch";
        case "complete":
          return "Completed";
        default:
          return item;
      }
    },
    getTransactions: function getTransactions(clearList) {
      var self = this;
      if (self.isMax && !clearList || self.loading) {
        return;
      }

      if (clearList) {
        this.$store.commit('consumer/resetReservations');
        this.$store.commit('consumer/setReservationsIsMax', false);
        this.$store.commit('consumer/setReservationsCurrentPage', 0);
      }

      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__modules_api_consumer_reservations__["a" /* default */].getTransactions(self, self.conId, function () {
        self.loading = false;
      });
    },
    exportTrx: function exportTrx() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__modules_api_consumer_reservations__["a" /* default */].exportTransactions(self, self.conId, function (res) {
        if (!res.error) {
          exporter.downloadCsv(res);
        }
      });
    },
    sortTable: function sortTable(code) {
      if (!code) {
        return;
      }

      if (this.sort.active === code) {
        this.sort.isDesc = !this.sort.isDesc;
      } else {
        this.sort.isDesc = true;
      }

      this.sort.active = code;
      this.$store.commit('consumer/setRsvpSortColumn', code);
      this.$store.commit('consumer/setRsvpSortIsDesc', this.sort.isDesc);
      this.$store.commit('consumer/setReservationsCurrentPage', 0);
      this.getTransactions(true);
    },
    call: function call(user) {
      var self = this;
      self.$plugins.phone.startCall(self, {
        phone: user.mobile,
        name: user.firstName + ' ' + user.lastName
      });
    },
    serviceLabel: function serviceLabel(code) {
      return __WEBPACK_IMPORTED_MODULE_4__modules_api_services__["a" /* default */].getServiceName(code);
    }
  },
  watch: {
    conId: function conId(value) {
      this.init();
    },
    isMobile: function isMobile(value) {
      this.init();
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_consumer_ratings__ = __webpack_require__(1125);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ratings',
  props: ['conId', 'isMobile'],
  data: function data() {
    return {
      loading: false
    };
  },

  computed: {
    ratings: function ratings() {
      return this.$store.state.consumer.ratings.list;
    },
    isMax: function isMax() {
      return this.$store.state.consumer.ratings.isMax;
    }
  },
  methods: {
    init: function init() {
      this.$store.commit('consumer/resetRatings');
      this.$store.commit('consumer/setRatingsIsMax', false);
      this.$store.commit('consumer/setRatingsCurrentPage', 0);
      this.getRatings();
    },
    getRatings: function getRatings() {
      var self = this;
      if (self.isMax || self.loading) {
        return;
      }

      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__modules_api_consumer_ratings__["a" /* default */].getRatings(self, self.conId, function () {
        self.loading = false;
      });
    }
  },
  watch: {
    conId: function conId(value) {
      this.init();
    },
    isMobile: function isMobile(value) {
      this.init();
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_consumer_credit_cards__ = __webpack_require__(404);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'creditCards',
  props: ['conId', 'isMobile'],
  data: function data() {
    return {
      loading: false
    };
  },

  computed: {
    creditCards: function creditCards() {
      return this.$store.state.consumer.creditCards.list;
    },
    isMax: function isMax() {
      return this.$store.state.consumer.creditCards.isMax;
    }
  },
  methods: {
    init: function init() {
      this.$store.commit('consumer/resetCards');
      this.$store.commit('consumer/setCardsIsMax', false);
      this.$store.commit('consumer/setCardsCurrentPage', 0);

      this.getCards();
    },
    getCards: function getCards() {
      var self = this;
      if (self.isMax || self.loading) {
        return;
      }

      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__modules_api_consumer_credit_cards__["a" /* default */].getCards(self, self.conId, function () {
        self.loading = false;
      });
    },
    cardStatus: function cardStatus(isVerified) {
      return isVerified ? 'verified' : 'unverified';
    }
  },
  watch: {
    conId: function conId(value) {
      this.init();
    },
    isMobile: function isMobile(value) {
      this.init();
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

// import ft from '../featureToggle'

/* harmony default export */ __webpack_exports__["a"] = ({
  getCards: function getCards(VueApp, conId, callback) {
    var cards = VueApp.$store.state.consumer.creditCards;
    var pageSize = cards.perPage;
    var page = cards.currentPage;

    VueApp.$sdk.get('/consumer/' + conId + '/cards', {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: pageSize,
      pageNum: page + 1,
      order: 'created',
      orderAsc: 0
    }, function (res) {
      if (!res.error) {
        VueApp.$store.commit('consumer/setCardsCurrentPage', page + 1);

        if (res.list.length < pageSize) {
          VueApp.$store.commit('consumer/setCardsIsMax', true);
        }

        if (res.list.length) {
          var cardInfo = res.list;
          for (var i = 0; i < res.list.length; i++) {
            // let created = moment(cardInfo[i].created, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm:ss')
            var created = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(cardInfo[i].created, 'YYYY-MM-DD@hh:mm:ss').tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm:ss');
            if (cardInfo[i].created === null) {
              created = 'N/A';
            }
            VueApp.$store.commit('consumer/addCards', {
              date: created,
              card: cardInfo[i].cardNumber,
              address: cardInfo[i].billingAddress,
              city: cardInfo[i].billingCity,
              state: cardInfo[i].billingState,
              zip: cardInfo[i].billingZip,
              status: cardInfo[i].verified
            });
          }
        }
      }
      callback(res);
    });
  }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_consumer_promo_codes__ = __webpack_require__(1134);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'promoCodes',
  props: ['conId', 'isMobile'],
  data: function data() {
    return {
      loading: false,
      credits: 0,
      cLoading: false
    };
  },

  computed: {
    promoCodes: function promoCodes() {
      return this.$store.state.consumer.promoCodes.list;
    },
    isMax: function isMax() {
      return this.$store.state.consumer.promoCodes.isMax;
    }
  },
  methods: {
    init: function init() {
      this.$store.commit('consumer/resetPromoCodes');
      this.$store.commit('consumer/setPromoCodesIsMax', false);
      this.$store.commit('consumer/setPromoCodesCurrentPage', 0);

      this.getPromoCodes();
      this.getCredits();
    },
    getPromoCodes: function getPromoCodes() {
      var self = this;
      if (self.isMax || self.loading) {
        return;
      }

      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__modules_api_consumer_promo_codes__["a" /* default */].getPromoCodes(self, self.conId, function () {
        self.loading = false;
      });
    },
    getCredits: function getCredits() {
      var self = this;
      if (self.cLoading) return;
      self.cLoading = true;
      self.$sdk.get('/consumer/' + self.conId + '/credits', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.cLoading = false;
        if (r.credits) self.credits = r.credits;
      });
    },
    toFixed: function toFixed(value) {
      return parseFloat(value).toFixed(2);
    }
  },
  watch: {
    conId: function conId(value) {
      this.init();
    },
    isMobile: function isMobile(value) {
      this.init();
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_services__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'logs',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default.a },
  data: function data() {
    return {
      heading: {
        create_rsvp: 'Created the reservation',
        pay_fail: 'Made a payment but failed',
        consumer_cancel: 'Cancelled the reservation',
        consumer_release: 'Released the driver',
        cons_mark_rtg: 'Marked the reservation as Ready to Go',
        consumer_convert: 'Set the reservation to Open Credit',
        edit_rsvp: 'Updated the reservation',
        update_fail: 'Updated the reservation but failed',
        refund_converted: 'Converted the reservation into ride credits',
        credit_reclaimed: 'Reclaimed the converted credits and refunded the charges',
        resend_email_cons: 'Requested to resend receipt email'
      },
      showRsvpId: ['create_rsvp', 'pay_fail', 'consumer_cancel', 'consumer_release', 'cons_mark_rtg', 'cons_mark_rtg', 'consumer_convert', 'edit_rsvp', 'update_fail', 'refund_converted', 'credit_reclaimed', 'resend_email_cons'],
      showDateRange: false,
      date: {
        from: '',
        to: ''
      },
      error: {
        from: false,
        to: false,
        message: ''
      }
    };
  },

  computed: {
    consId: function consId() {
      return this.$route.params.id;
    },
    logs: function logs() {
      return this.$store.state.consumer.logs.list;
    },
    loading: function loading() {
      return this.$store.state.consumer.logs.loading;
    },
    reachMax: function reachMax() {
      return this.$store.state.consumer.logs.reachMax;
    }
  },
  methods: {
    getLogs: function getLogs() {
      var self = this;
      if (self.loading || self.reachMax) {
        return;
      }

      self.$store.commit('consumer/setLogsField', {
        fields: { loading: true }
      });

      var logsData = this.$store.state.consumer.logs;
      var params = {
        token: self.$store.state.session.sessionToken,
        pageNum: logsData.pageNum,
        pageSize: logsData.pageSize,
        order: 'created',
        orderAsc: 0
      };
      if (logsData.since) {
        params.since = __WEBPACK_IMPORTED_MODULE_1_moment___default()(logsData.since, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00:00');
        params.until = __WEBPACK_IMPORTED_MODULE_1_moment___default()(logsData.until, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59:59');
      }

      self.$sdk.get('/consumer/' + self.consId + '/logs', params, function (res) {
        self.$store.commit('consumer/setLogsField', {
          fields: { loading: false }
        });

        if (!res.error) {
          if (!res.list.length) {
            self.$store.commit('consumer/setLogsField', {
              fields: { reachMax: true }
            });
            return;
          }

          var actions = {};
          res.list.forEach(function (log) {
            if (!actions[log.action]) {
              actions[log.action] = 0;
            }
            actions[log.action] = actions[log.action] + 1;

            var tempLog = log;
            tempLog.created = __WEBPACK_IMPORTED_MODULE_1_moment___default()(tempLog.created, 'X').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__["a" /* default */].timeFormat(self, true));
            var showDefault = { show: false };
            self.$store.commit('consumer/addLogs', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, log, showDefault));
          });
        }
      });
    },
    title: function title(data) {
      return this.heading[data.action] || data.action;
    },
    toFixed: function toFixed(x) {
      return parseFloat(x).toFixed(2);
    },
    onScroll: function onScroll(event) {
      var scrollAndView = event.target.scrollTop + event.target.offsetHeight;
      if (event.target.scrollHeight - scrollAndView < 150) {
        this.loadMore();
      }
    },
    loadMore: function loadMore() {
      var self = this;
      if (self.loading) {
        return;
      }

      self.$store.commit('consumer/setLogsField', {
        fields: { pageNum: self.$store.state.consumer.logs.pageNum + 1 }
      });
      self.getLogs();
    },
    dateToggle: function dateToggle(val) {
      this.showDateRange = val === 'custom';
      if (val === 'all') {
        this.$store.commit('consumer/setLogsField', {
          fields: {
            pageNum: 1,
            list: [],
            since: null,
            until: null,
            reachMax: false
          }
        });
        this.getLogs();
      }
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('MM/DD/YYYY');
    },
    changeDate: function changeDate(type) {
      var format = 'MM/DD/YYYY';
      var from = '';
      var to = '';

      if (type === 'from') {
        this.error.from = false;
        from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date.from);
        this.$store.commit('consumer/setLogsField', {
          fields: { since: from.format(format) }
        });
        if (this.date.to) {
          to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date.to, format);
        }
      } else {
        this.error.to = false;
        to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date.to);
        this.$store.commit('consumer/setLogsField', {
          fields: { until: to.format(format) }
        });
        if (this.date.from) {
          from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date.from, format);
        }
      }
    },
    dateApply: function dateApply() {
      if (this.loading) {
        return;
      }

      this.error = {
        from: false,
        to: false,
        message: ''
      };

      if (this.date.from === '' || this.date.to === '') {
        if (this.date.to === '') {
          this.error.to = true;
        }
        if (this.date.from === '') {
          this.error.from = true;
        }
        this.error.message = this.$t('transactions.filter.emptyDate');
        return;
      }

      var from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date.from);
      var to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date.to);
      if (from.format('x') > to.format('x')) {
        this.error.from = true;
        this.error.to = true;
        this.error.message = this.$t('transactions.filter.invalidDateRange');
        return;
      }

      this.$store.commit('consumer/setLogsField', {
        fields: {
          pageNum: 1,
          list: [],
          since: from.format('MM/DD/YYYY'),
          until: to.format('MM/DD/YYYY'),
          reachMax: false
        }
      });
      this.getLogs();
    }
  },
  watch: {
    consId: function consId(value) {
      this.$store.commit('consumer/setLogsField', {
        fields: {
          pageNum: 1,
          list: [],
          since: null,
          until: null,
          reachMax: false
        }
      });
      this.getLogs();
    }
  },
  mounted: function mounted() {
    this.getLogs();
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_country_data__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_country_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_country_data__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var countryData = __webpack_require__(90);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'countrySelectModal',
  data: function data() {
    return {
      searchString: '',
      countryOnly: this.$store.state.consumer.countryOnly
    };
  },

  computed: {
    countryList: {
      get: function get() {
        return this.$store.state.consumer.countryList;
      },
      set: function set(value) {
        this.$store.commit('consumer/setCountryList', value);
      }
    },
    showModal: function showModal() {
      return this.$store.state.consumer.countryModal;
    }
  },
  methods: {
    closeModal: function closeModal() {
      this.searchString = '';
      this.sortCountries();
      this.$store.commit('consumer/setCountryModal', false);
    },
    filter: function filter() {
      var queryString = this.searchString;
      if (queryString === '') {
        this.sortCountries();
        return;
      }

      var regex = new RegExp('^' + queryString, 'i');
      var result = [];
      var allCountries = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(countryData);

      for (var i = 0; i < allCountries.length; i++) {
        if (!regex.test(allCountries[i].name)) {
          continue;
        }

        result.push(allCountries[i]);
      }

      this.countryList = result;
    },
    selectCountry: function selectCountry(index) {
      var country = this.countryList[index];
      this.$store.commit('consumer/setCountryName', country.name);
      this.$store.commit('consumer/setCountryCode', country.code);
      this.$store.commit('consumer/setCallingCode', country.dialCode);
      this.closeModal();
    },
    sortCountries: function sortCountries() {
      var country = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(countryData);
      var displayCountry = [];
      country = country.sort(function (a, b) {
        return a.name > b.name ? 1 : -1;
      });

      var topCountries = ['us', 'ca', 'gb'];
      topCountries.forEach(function (x) {
        displayCountry.push.apply(displayCountry, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(country.filter(function (y) {
          return y.code === x;
        })));
      });
      topCountries.forEach(function (x) {
        country = country.filter(function (y) {
          return y.code !== x;
        });
      });
      displayCountry.push.apply(displayCountry, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(country));

      this.countryList = displayCountry;
    }
  },
  mounted: function mounted() {
    this.sortCountries();
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emoji_mart_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emoji_mart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_emoji_mart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_consumer_list__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_consumer_notifications__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_provider_user_info__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ListFilter__ = __webpack_require__(1149);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'consumerList',
  data: function data() {
    return {
      statusUpdate: {
        selected: 'reactivate',
        showConfirmation: false,
        loading: false,
        errorMsg: '',
        success: false
      },
      notification: {
        showForm: false,
        target: 'all',
        targetMessage: '',
        isPushNotif: true,
        isSendEmail: false,
        brand: '',
        brandErrorMsg: '',
        title: '',
        titleError: '',
        message: '',
        messageError: '',
        charCount: 180,
        charExceed: false,
        showEmoji: false,
        file: '',
        fileReady: true,
        uploadedUrl: '',
        fileError: '',
        loading: false,
        errorMsg: '',
        success: false
      },
      selected: [],
      searchInput: '',
      searchKeyword: '',
      disableNotifButton: false,
      isMobile: false
    };
  },

  components: { listFilter: __WEBPACK_IMPORTED_MODULE_4__ListFilter__["a" /* default */], Picker: __WEBPACK_IMPORTED_MODULE_0_emoji_mart_vue__["Picker"] },
  computed: {
    brands: function brands() {
      return this.$store.state.brands.list;
    },
    brandsLoading: function brandsLoading() {
      return this.$store.state.brands.loading;
    },
    reactivateSelected: function reactivateSelected() {
      return this.statusUpdate.selected === 'reactivate';
    },

    // disableNotifButton () {
    //   let zeroTarget = this.notification.target === 'selected' && !this.selected.length
    //   this.notification.targetMessage = zeroTarget ? this.$t('consumer.list.zeroSelected') : ''

    //   return zeroTarget || this.notification.message === '' || this.notification.charExceed ||
    //     this.notification.fileError !== '' || (!this.notification.isPushNotif && !this.notification.isSendEmail)
    // },
    isLoading: function isLoading() {
      return this.$store.state.consumer.users.isLoading;
    },
    users: function users() {
      return this.$store.state.consumer.users.list;
    },

    selectAll: {
      get: function get() {
        return this.users ? this.selected.length == this.users.length : false;
      },
      set: function set(value) {
        var selected = [];
        if (value) {
          this.users.forEach(function (user) {
            selected.push(user.id);
          });
        }
        this.selected = selected;
      }
    },
    emojiStyle: function emojiStyle() {
      return { 'width': '100%', 'height': '100%' };
    },
    _triggerStatusUpdate: function _triggerStatusUpdate() {
      return this.$store.state.consumer.triggerStatusUpdate;
    },

    perPage: {
      get: function get() {
        return this.$store.state.consumer.users.perPage;
      },
      set: function set(value) {
        this.$store.commit('consumer/setUserPerPage', parseInt(value));
        this.$store.commit('consumer/setUserCurrentPage', 1);
        this.getUserList();
      }
    },
    pageData: function pageData() {
      var tableData = this.$store.state.consumer.users;
      var start = tableData.currentPage * tableData.perPage - (tableData.perPage - 1);
      var end = tableData.currentPage * tableData.perPage;
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      };
    },
    loading: function loading() {
      return this.$store.state.consumer.users.isLoading;
    },

    currentPage: {
      get: function get() {
        return this.$store.state.consumer.users.currentPage;
      },
      set: function set(value) {
        this.$store.commit('consumer/setUserCurrentPage', parseInt(value));
        this.getUserList();
      }
    },
    isLastPage: function isLastPage() {
      var consumer = this.$store.state.consumer.users;
      return consumer.currentPage * consumer.perPage >= consumer.maxList;
    },
    totalPage: function totalPage() {
      var consumer = this.$store.state.consumer.users;
      return Math.ceil(consumer.maxList / consumer.perPage);
    }
  },
  methods: {
    closeStatusUpdate: function closeStatusUpdate() {
      if (this.statusUpdate.loading) {
        return;
      }
      this.statusUpdate.showConfirmation = false;
      this.statusUpdate.errorMsg = '';
      this.statusUpdate.success = false;
    },
    updateStatus: function updateStatus() {
      var self = this;
      if (self.statusUpdate.loading) {
        return;
      }

      self.statusUpdate.loading = true;

      // setTimeout(function () {
      //   self.statusUpdate.loading = false
      //   self.statusUpdate.success = true
      // }, 2000)

      __WEBPACK_IMPORTED_MODULE_3__modules_api_provider_user_info__["a" /* default */].updateProviderStatus(self, {
        id: self.selected[0],
        isActive: self.$store.state.consumer.selectedStatus === 'activate'
      }, function (res) {
        self.statusUpdate.loading = false;
        if (!res.error) {
          self.selected.shift();
          if (self.selected.length > 0) {
            self.updateStatus();
          } else {
            self.statusUpdate.success = true;
            self.getUserList();
          }
        }
      });
    },
    showNotifForm: function showNotifForm() {
      this.notification.showForm = true;
      this.notification.target = this.selected.length ? 'selected' : 'all';
    },
    closeNotifForm: function closeNotifForm() {
      if (this.notification.showEmoji) {
        this.closeEmoji();
        return;
      }

      if (this.notification.loading) {
        return;
      }
      this.notification.showForm = false;
      this.notification.brandErrorMsg = '';
      this.notification.errorMsg = '';
      this.notification.success = false;
    },
    charCountUpdate: function charCountUpdate() {
      this.notification.charCount = 180 - this.notification.message.length;
      // if (this.notification.message === '') { this.notification.charCount = 180 }
      // this.notification.charExceed = this.notification.charCount < 0
    },
    addEmoji: function addEmoji(emoji) {
      this.notification.showEmoji = false;

      var textarea = this.$refs.notifMsg;
      var cursorPosition = textarea.selectionEnd;
      var start = this.notification.message.substring(0, textarea.selectionStart);
      var end = this.notification.message.substring(textarea.selectionStart);
      var text = start + emoji.native + end;
      this.notification.message = text;
      textarea.focus();
      var self = this;
      this.$nextTick(function () {
        textarea.selectionEnd = cursorPosition + emoji.native.length;
        self.charCountUpdate();
      });
    },
    closeEmoji: function closeEmoji() {
      if (this.notification.showEmoji) {
        this.notification.showEmoji = false;
      }
    },
    setImage: function setImage(e) {
      this.notification.file = e.target.files[0];

      if (!this.notification.file.type.includes('image/')) {
        this.notification.fileError = this.$t('consumer.list.selectImgFile');
        return;
      }
    },
    cleanFileInput: function cleanFileInput() {
      var _this = this;

      this.notification.file = '';
      this.notification.fileError = '';
      this.notification.fileReady = false;
      this.$nextTick(function () {
        _this.notification.fileReady = true;
      });
    },
    checkFileUpload: function checkFileUpload() {
      var self = this;
      if (this.notification.file) {

        var fd = new FormData();
        fd.append('pic', self.notification.file, 'consumer-notif.png');

        self.$http.post({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.mediaHost + '/api/upload', fd, {
          header: { 'Content-Type': 'multipart/form-data' }
        }).then(function (res) {
          if (res.body.success) {
            self.notification.uploadedUrl = res.body.data.url;
            self.submitNotif();
          }
        });
        return;
      }

      self.submitNotif();
    },
    submitNotif: function submitNotif() {
      var self = this;

      if (self.validateNotifForm()) {
        return;
      }

      var selectedId = self.notification.target === 'all' ? null : self.selected;
      var data = {
        title: self.notification.title,
        message: self.notification.message,
        // image: self.notification.uploadedUrl,
        id: selectedId
      };

      self.notification.brandErrorMsg = '';
      if (self.notification.target === 'all') {
        if (!self.notification.brand) {
          self.notification.brandErrorMsg = self.$t('consumer.list.emptyBrand');
          return;
        }
        data.brandId = self.notification.brand;
      }

      self.notification.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__modules_api_consumer_notifications__["a" /* default */].send(self, data, function (res) {
        self.notification.loading = false;
        self.notification.success = true;
        self.notification.title = '';
        self.notification.message = '';
        self.notification.uploadedUrl = '';
        self.cleanFileInput();
      });
    },
    validateNotifForm: function validateNotifForm() {

      var hasError = false;
      this.disableNotifButton = false;
      var conList = this.$store.state.consumer.users;
      this.notification.targetMessage = '';
      if (this.notification.target === 'selected') {
        if (!this.selected.length) {
          hasError = true;
        }
        this.notification.targetMessage = this.selected.length === 0 ? this.$t('consumer.list.zeroSelected') : '';
      }

      this.notification.brandErrorMsg = '';
      if (this.notification.target === 'all' && !this.notification.brand) {
        this.notification.brandErrorMsg = this.$t('consumer.list.emptyBrand');
      }

      this.notification.titleError = '';
      if (this.notification.title === '') {
        hasError = true;
        this.notification.titleError = 'This field cannot be empty.';
      }

      this.notification.messageError = '';
      if (this.notification.message === '') {
        hasError = true;
        this.notification.messageError = 'This field cannot be empty.';
      }
      return hasError;
    },
    updateKeyword: function updateKeyword() {
      if (this.isLoading) {
        return;
      }
      this.selected = [];
      this.searchKeyword = this.searchInput;
      this.$store.commit('consumer/resetUsers');
      // this.$store.commit('consumer/setUserIsMax', false)
      self.$store.commit('consumer/setUserMaxList', 0);
      this.$store.commit('consumer/setUserCurrentPage', 1);
      this.getUserList();
    },
    getUserList: function getUserList() {
      var self = this;
      if (self.isLoading) {
        return;
      }

      self.$store.commit('consumer/setUserIsLoading', true);
      __WEBPACK_IMPORTED_MODULE_1__modules_api_consumer_list__["a" /* default */].getList(self, function (res) {
        self.$store.commit('consumer/setUserIsLoading', false);
      });
    },
    onScroll: function onScroll(event) {
      var scrollAndView = event.target.scrollTop + event.target.offsetHeight;
      if (event.target.scrollHeight - scrollAndView < 150) {
        this.getUserList();
      }
    },
    call: function call(user) {
      var self = this;
      self.$plugins.phone.startCall(self, {
        phone: user.mobile,
        name: user.firstName + ' ' + user.lastName
      });
    },
    prev: function prev() {
      if (this.currentPage === 1) {
        return;
      }
      this.$store.commit('consumer/setUserCurrentPage', this.$store.state.consumer.users.currentPage - 1);
      this.getUserList();
    },
    next: function next() {
      if (this.isLastPage) {
        return;
      }
      this.$store.commit('consumer/setUserCurrentPage', this.$store.state.consumer.users.currentPage + 1);
      this.getUserList();
    },
    setScreenSize: function setScreenSize() {
      var self = this;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        self.isMobile = true;
      } else {
        self.isMobile = false;
      }
    },
    displayPhone: function displayPhone(data) {
      if (!data.countryCode) return data.mobile;
      return '+' + data.countryCode + ' ' + (data.nationalNumber || data.mobile);
    }
  },
  watch: {
    _triggerStatusUpdate: function _triggerStatusUpdate(value) {
      if (value) {
        this.$store.commit('consumer/setTriggerStatusUpdate', false);
        this.updateStatus();
      }
    }
  },
  mounted: function mounted() {
    var self = this;

    self.$store.commit('consumer/resetUsers');
    // self.$store.commit('consumer/setUserIsMax', false)
    self.$store.commit('consumer/setUserMaxList', 0);
    self.$store.commit('consumer/setUserCurrentPage', 1);
    self.getUserList();

    if (self.$store.state.brands.list.length === 0) {
      self.$store.commit('brands/setLoading', true);
      self.$sdk.get('/brand', {}, function (res) {
        self.$store.commit('brands/setLoading', false);
        var brands = [];
        res.forEach(function (data) {
          brands.push({ id: data.id, name: data.name });
        });
        self.$store.commit('brands/setList', brands);
      });
    }
    self.setScreenSize();
  }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["a"] = ({
  getList: function getList(VueApp, callback) {
    var self = this;
    var consumers = VueApp.$store.state.consumer.users;

    VueApp.$sdk.get('/consumer', {
      token: VueApp.$store.state.session.sessionToken,
      pageNum: consumers.currentPage,
      pageSize: consumers.perPage,
      order: consumers.order,
      orderAsc: consumers.orderAsc,
      search: consumers.search
    }, function (res) {
      if (!res.error) {
        VueApp.$store.commit('consumer/setUserMaxList', res.paging.totalItems);

        if (res.list.length) {
          var users = [];
          for (var i = 0; i < res.list.length; i++) {
            var userInfo = res.list[i];
            var created = __WEBPACK_IMPORTED_MODULE_0_moment___default()(userInfo.created, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY');
            if (userInfo.created === null) {
              created = 'N/A';
            }
            var phone = userInfo.phone ? userInfo.countryCode + '' + userInfo.phone : '';
            users.push({
              id: userInfo.ID,
              firstName: userInfo.firstName,
              lastName: userInfo.lastName,
              email: userInfo.email,
              mobile: phone,
              created: created,
              referralCode: userInfo.referralCode,
              status: self.statusLabel(userInfo),
              customerURL: userInfo.customerURL,
              countryCode: userInfo.countryCode,
              nationalNumber: userInfo.nationalNumber || userInfo.phone
            });
          }

          VueApp.$store.commit('consumer/addUser', users);
        }
      }
      callback(res);
    });
  },
  statusLabel: function statusLabel(data) {
    if (data.verified === 0) {
      return 'unverified';
    }
    if (data.enabled === 0) {
      return 'disabled';
    }
    return 'active';
  },
  export: function _export(VueApp, callback) {
    var self = this;
    var consumers = VueApp.$store.state.consumer.users;

    VueApp.$sdk.get('/consumer', {
      token: VueApp.$store.state.session.sessionToken,
      pageNum: consumers.currentPage,
      pageSize: consumers.perPage,
      order: consumers.order,
      orderAsc: consumers.orderAsc,
      search: consumers.search
    }, function (res) {
      if (!res.error) {
        var cons = [];
        if (res.list.length) {
          res.list.forEach(function (value) {
            cons.push(self.buildExportAll(value));
          });
        }
        callback(cons);
      } else {
        callback(res);
      }
    });
  },
  buildExportAll: function buildExportAll(data) {
    var self = this;
    var created = '';
    if (data.created) {
      var temp = __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.created, 'YYYY-MM-DD HH:mm:ss');
      if (temp.isValid()) {
        created = temp.format('MM/DD/YYYY HH:mm:ss');
      }
    }

    var phone = '+' + data.countryCode + ' ' + (data.nationalNumber || data.phone);
    return {
      'First Name': data.firstName,
      'Last Name': data.lastName,
      'Email': data.email,
      'Mobile': phone,
      'Created Date': created,
      'Referral Code': data.referralCode,
      'Status': self.statusLabel(data),
      'Stripe Link': data.customerURL
    };
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_consumer_list__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_csvexport__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var exporter = __WEBPACK_IMPORTED_MODULE_1_csvexport___default.a.create({
  filename: 'export.csv',
  columns: ['First Name', 'Last Name', 'Email', 'Mobile', 'Created Date', 'Referral Code', 'Status', 'Stripe Link']
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'list-filter',
  data: function data() {
    return {
      searchInput: '',
      blurDelay: '',
      exportLoading: false
    };
  },

  // components: {Picker},
  computed: {
    brands: function brands() {
      return this.$store.state.brands.list;
    },
    loading: function loading() {
      return this.$store.state.consumer.users.isLoading;
    },

    status: {
      get: function get() {
        return this.$store.state.consumer.selectedStatus;
      },
      set: function set(value) {
        this.$store.commit('consumer/setSelectedStatus', value);
      }
    }
  },
  methods: {
    refreshTable: function refreshTable() {
      var self = this;
      if (self.loading) {
        return;
      }

      self.$store.commit('consumer/setUserIsLoading', true);
      self.$store.commit('consumer/resetUsers');
      self.$store.commit('consumer/setUserCurrentPage', 1);

      __WEBPACK_IMPORTED_MODULE_0__modules_api_consumer_list__["a" /* default */].getList(self, function (res) {
        self.$store.commit('consumer/setUserIsLoading', false);
      });
    },
    search: function search() {
      this.$store.commit('consumer/setUserSearch', this.searchInput);
      this.refreshTable();
    },
    blurSearch: function blurSearch() {
      var self = this;
      if (self.$store.state.consumer.users.search === self.searchInput.trim()) {
        return;
      }

      self.blurDelay = setTimeout(function () {
        self.search();
      }, 500);
    },
    clearSearch: function clearSearch() {
      if (this.blurDelay) {
        clearTimeout(this.blurDelay);
      }
      if (this.loading) {
        return;
      }

      this.searchInput = '';
      this.$store.commit('consumer/setUserSearch', this.searchInput);
      this.refreshTable();
    },
    updateStatus: function updateStatus() {
      this.$store.commit('consumer/setTriggerStatusUpdate', true);
    },
    exportCons: function exportCons() {
      var self = this;
      if (self.exportLoading) {
        return;
      }

      self.exportLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__modules_api_consumer_list__["a" /* default */].export(self, function (res) {
        self.exportLoading = false;
        if (!res.error) {
          exporter.downloadCsv(res);
        }
      });
    }
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListFilter__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListTable__ = __webpack_require__(1161);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'corporate',
  components: { listFilter: __WEBPACK_IMPORTED_MODULE_0__ListFilter__["a" /* default */], listTable: __WEBPACK_IMPORTED_MODULE_1__ListTable__["a" /* default */] },
  data: function data() {
    return {
      isMobile: false
    };
  },

  computed: {
    users: function users() {
      return this.$store.state.corporate.users.list;
    },
    loading: function loading() {
      return this.$store.state.corporate.users.loading;
    }
  },
  methods: {
    setScreenSize: function setScreenSize() {
      var self = this;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        self.isMobile = true;
      } else {
        self.isMobile = false;
      }
    }
  },
  mounted: function mounted() {
    this.setScreenSize();
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_corporate_list__ = __webpack_require__(413);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'list-filter',
  props: ['isMobile'],
  data: function data() {
    return {
      searchInput: '',
      blurDelay: ''
    };
  },

  computed: {
    loading: function loading() {
      return this.$store.state.corporate.users.loading;
    }
  },
  methods: {
    refreshTable: function refreshTable() {
      var self = this;
      if (self.loading) {
        return;
      }

      self.$store.commit('corporate/resetUsers');
      self.$store.commit('corporate/setUserLoading', true);
      self.$store.commit('corporate/setUserCurrentPage', 1);

      __WEBPACK_IMPORTED_MODULE_0__modules_api_corporate_list__["a" /* default */].getList(self, function (res) {
        self.$store.commit('corporate/setUserLoading', false);
      });
    },
    search: function search() {
      this.$store.commit('corporate/setUserSearch', this.searchInput);
      this.refreshTable();
    },
    blurSearch: function blurSearch() {
      var self = this;
      if (self.$store.state.corporate.users.search === self.searchInput.trim()) {
        return;
      }

      self.blurDelay = setTimeout(function () {
        self.search();
      }, 500);
    },
    clearSearch: function clearSearch() {
      if (this.blurDelay) {
        clearTimeout(this.blurDelay);
      }
      if (this.loading) {
        return;
      }

      this.searchInput = '';
      this.$store.commit('corporate/setUserSearch', this.searchInput);
      this.refreshTable();
    }
  }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["a"] = ({
  getList: function getList(VueApp, callback) {
    var pageData = VueApp.$store.state.corporate.users;
    VueApp.$sdk.get('/admin/corporateprofile', {
      token: VueApp.$store.state.session.sessionToken,
      orderAsc: pageData.orderAsc,
      order: pageData.order,
      pageNum: pageData.currentPage,
      pageSize: pageData.perPage,
      search: pageData.search
    }, function (res) {
      if (!res.error) {
        // VueApp.$store.commit('corporate/setUserMaxList', res.paging.totalItems)

        if (res.list.length) {
          var users = [];
          for (var i = 0; i < res.list.length; i++) {
            var userInfo = res.list[i];
            var created = __WEBPACK_IMPORTED_MODULE_0_moment___default()(userInfo.created, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY');
            // if (userInfo.created === null) { created = 'N/A' }
            // let phone = userInfo.phone ? userInfo.countryCode + '' + userInfo.phone : ''
            var stripeUrl = '';
            if (userInfo.customer && userInfo.customer.customerURL) {
              stripeUrl = userInfo.customer.customerURL;
            }
            users.push({
              id: userInfo.id,
              name: userInfo.name,
              username: userInfo.username,
              email: userInfo.contactEmail,
              mobile: userInfo.contactPhone,
              created: created,
              logo: userInfo.logoUrl,
              stripeUrl: stripeUrl,
              active: userInfo.active === 1
            });
          }

          VueApp.$store.commit('corporate/addUsers', users);

          /* DELETE LATER */
          // let maxList = (pageData.currentPage + 1) * pageData.perPage
          // if (res.list.length < pageData.perPage) {
          //   if (pageData.currentPage === 1) {
          //     maxList = (1 * pageData.perPage) + res.list.length
          //   } else {
          //     maxList = ((pageData.currentPage - 1) * pageData.perPage) + res.list.length
          //   }
          // }
          VueApp.$store.commit('corporate/setUserMaxList', res.paging.totalItems);
        }
      }
      callback(res);
    });
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_corporate_list__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_corporate_profile__ = __webpack_require__(92);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'list-table',
  props: ['isMobile'],
  data: function data() {
    return {
      statusLoading: []
    };
  },

  computed: {
    users: function users() {
      return this.$store.state.corporate.users.list;
    },
    loading: function loading() {
      return this.$store.state.corporate.users.loading;
    },
    currentOrder: function currentOrder() {
      var tableData = this.$store.state.corporate.users;
      return { field: tableData.order, asc: tableData.orderAsc };
    },

    perPage: {
      get: function get() {
        return this.$store.state.corporate.users.perPage;
      },
      set: function set(value) {
        this.$store.commit('corporate/setUserPerPage', parseInt(value));
        this.$store.commit('corporate/setUserCurrentPage', 1);
        this.getList();
      }
    },
    pageData: function pageData() {
      var tableData = this.$store.state.corporate.users;
      var start = tableData.currentPage * tableData.perPage - (tableData.perPage - 1);
      var end = tableData.currentPage * tableData.perPage;
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      };
    },

    currentPage: {
      get: function get() {
        return this.$store.state.corporate.users.currentPage;
      },
      set: function set(value) {
        this.$store.commit('corporate/setUserCurrentPage', parseInt(value));
        this.getList();
      }
    },
    isLastPage: function isLastPage() {
      var tableData = this.$store.state.corporate.users;
      return tableData.currentPage * tableData.perPage >= tableData.maxList;
    },
    totalPage: function totalPage() {
      var tableData = this.$store.state.corporate.users;
      return Math.ceil(tableData.maxList / tableData.perPage);
    }
  },
  methods: {
    getList: function getList() {
      var self = this;
      if (self.loading) {
        return;
      }

      self.$store.commit('corporate/resetUsers');
      self.$store.commit('corporate/setUserLoading', true);
      __WEBPACK_IMPORTED_MODULE_0__modules_api_corporate_list__["a" /* default */].getList(self, function (res) {
        self.$store.commit('corporate/setUserLoading', false);
      });
    },
    sort: function sort(field) {
      if (this.loading) {
        return;
      }
      var tableData = this.$store.state.corporate.users;
      if (field !== tableData.order) {
        this.$store.commit('corporate/setUserOrderAsc', 1);
      } else {
        this.$store.commit('corporate/setUserOrderAsc', tableData.orderAsc === 1 ? 0 : 1);
      }
      this.$store.commit('corporate/setUserOrder', field);
      this.$store.commit('corporate/setUserCurrentPage', 1);
      this.getList();
    },
    prev: function prev() {
      if (this.currentPage === 1) {
        return;
      }
      this.$store.commit('corporate/setUserCurrentPage', this.$store.state.corporate.users.currentPage - 1);
      this.getList();
    },
    next: function next() {
      if (this.isLastPage) {
        return;
      }
      this.$store.commit('corporate/setUserCurrentPage', this.$store.state.corporate.users.currentPage + 1);
      this.getList();
    },
    prev2: function prev2() {
      if (this.currentPage === 1) {
        return;
      }
      this.$store.commit('corporate/setUserCurrentPage', this.$store.state.corporate.users.currentPage - 1);
      this.getList();
    },
    next2: function next2() {
      if (this.isLastPage) {
        return;
      }
      this.$store.commit('corporate/setUserCurrentPage', this.$store.state.corporate.users.currentPage + 1);
      this.getList();
    },
    toggleStatus: function toggleStatus(id, isActive) {
      var self = this;
      if (self.statusLoading.indexOf(id) > -1) {
        return;
      }

      self.statusLoading.push(id);
      __WEBPACK_IMPORTED_MODULE_1__modules_api_corporate_profile__["a" /* default */].toggleStatus(self, { id: id, active: isActive }, function (res) {
        if (!res.error) {
          var index = self.statusLoading.indexOf(id);
          self.statusLoading.splice(index, 1);

          self.$store.commit('corporate/updateUserStatus', { id: id, active: res.list[0].active });
        }
      });
    }
  },
  mounted: function mounted() {
    this.$store.commit('corporate/setUserCurrentPage', 1);
    this.getList();
  },

  watch: {}
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_color__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_us__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_us___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_us__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_corporate_profile__ = __webpack_require__(92);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */



var countryData = __webpack_require__(90);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'create-profile',
  components: { 'chrome-picker': __WEBPACK_IMPORTED_MODULE_0_vue_color__["Chrome"] },
  data: function data() {
    return {
      statusLoading: false,
      upload: {
        loading: false,
        message: ''
      },
      repeatPassword: '',
      showEmailColor: false,
      emailColors: '',
      colorDelay: '',
      countries: __webpack_require__(45).countries,
      validation: {
        logo: '',
        username: '',
        password: '',
        repeatPassword: '',
        name: '',
        email: '',
        color: '',
        mobile: '',
        website: '',
        cardOwner: '',
        creditCard: '',
        cardExpiration: '',
        cardCVV: '',
        billingAddress1: '',
        billingCity: '',
        billingState: '',
        biilingCountry: ''
      },
      respond: {
        show: false,
        success: false,
        label: '',
        message: '',
        id: ''
      }
    };
  },

  computed: {
    _corporateId: function _corporateId() {
      return this.$route.params.id;
    },
    corporateInfo: function corporateInfo() {
      return this.$store.state.corporate.profile.info;
    },
    loading: function loading() {
      return this.$store.state.corporate.profile.loading;
    },
    states: function states() {
      var states = [];
      for (var key in __WEBPACK_IMPORTED_MODULE_1_us___default.a.states) {
        if (__WEBPACK_IMPORTED_MODULE_1_us___default.a.states.hasOwnProperty(key)) {
          states.push({
            value: key,
            label: __WEBPACK_IMPORTED_MODULE_1_us___default.a.states[key].name
          });
        }
      }
      return states;
    },
    callingCode: function callingCode() {
      return this.$store.state.countryCode.callingCode;
    }
  },
  methods: {
    selectCountry: function selectCountry() {
      this.$store.commit('countryCode/setCountryModal', true);
    },
    getCorporateData: function getCorporateData() {
      var self = this;
      self.$store.commit('corporate/resetProfileInfo');
    },
    triggerUpload: function triggerUpload() {
      if (this.loading) {
        return;
      }
      this.$refs.uploadInput.click();
    },
    uploadFile: function uploadFile(e) {
      if (!e.target.files.length) {
        return;
      }

      var self = this;
      var file = e.target.files[0];
      var fd = new FormData();
      fd.append('pic', file);

      self.upload.loading = true;
      self.upload.message = '';

      self.$http.post({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.mediaHost + '/api/upload', fd, {
        header: { 'Content-Type': 'multipart/form-data' }
      }).then(function (res) {
        self.upload.loading = false;
        if (!res.body.success) {
          self.upload.message = 'Upload fail. Please try again.';
          // self.upload[self.upload.target].success = false
          return;
        }

        self.corporateInfo.logo = res.body.data.url;
      }, function (res) {
        self.upload.loading = false;
        self.upload.message = res;
        console.log('error', res);
      });
    },
    selectColor: function selectColor() {
      this.$store.commit('corporate/setProfileColor', this.emailColors.hex.substring(1, this.emailColors.hex.length));
      this.showEmailColor = false;
    },
    updateColor: function updateColor(value) {
      var self = this;
      if (self.colorDelay) {
        clearTimeout(self.colorDelay);
      }

      self.$store.state.corporate.profile.info.color = value.hex.substring(1, value.hex.length);
      self.colorDelay = setTimeout(function () {
        self.showEmailColor = false;
      }, 1200);
    },
    isNumber: function isNumber(evt) {
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
        return;
      }
      return true;
    },
    submit: function submit() {
      var self = this;
      if (self.loading || !self.validate() || self.upload.loading) {
        return;
      }

      self.$store.commit('corporate/setProfileLoading', true);

      __WEBPACK_IMPORTED_MODULE_2__modules_api_corporate_profile__["a" /* default */].create(self, function (res) {
        self.$store.commit('corporate/setProfileLoading', false);
        if (!res.error) {
          self.respond = {
            show: true,
            success: true,
            label: 'Successfully updated profile.',
            message: ''
          };
          window.location = '/#/corporate/' + res.id;
        } else {
          self.respond = {
            show: true,
            success: false,
            label: 'Oops! Something went wrong.',
            message: res.error.message,
            id: ''
          };
        }
      });
    },
    validate: function validate() {
      var noError = true;

      if (this.upload.message !== '') {
        noError = false;
      }

      for (var field in this.validation) {
        this.validation[field] = '';
        if (this.corporateInfo[field] === '') {
          this.validation[field] = 'This field cannot be empty.';
          noError = false;
        }
      }

      if (this.corporateInfo.username.indexOf(' ') > -1) {
        this.validation.username = 'Space is not allowed';
        noError = false;
      }

      if (this.repeatPassword === '') {
        this.validation.repeatPassword = 'This field cannot be empty.';
        noError = false;
      }

      if (this.repeatPassword !== '' && this.corporateInfo.password !== '' && this.repeatPassword !== this.corporateInfo.password) {
        this.validation.repeatPassword = 'Password and Repeat password doesn\'t match.';
        noError = false;
      }

      return noError;
    },
    clearValidation: function clearValidation() {
      this.validation = {
        logo: '',
        username: '',
        password: '',
        repeatPassword: '',
        name: '',
        email: '',
        color: '',
        mobile: '',
        website: '',
        billingAddress1: '',
        billingCity: '',
        billingState: '',
        biilingCountry: ''
      };
    },
    closeResponModal: function closeResponModal() {
      this.respond.show = false;
      if (this.respond.id) {
        window.location = '/#/corporate/' + this.respond.id;
      }
    }
  },
  watch: {
    _corporateId: function _corporateId(val) {
      this.clearValidation();
      this.repeatPassword = '';
      this.$store.commit('corporate/resetProfileInfo');
    },

    'corporateInfo.billingState': function corporateInfoBillingState(val) {
      if (val && val !== 'NonUS') {
        this.corporateInfo.biilingCountry = 'US';
      }
    }
  },
  mounted: function mounted() {
    this.clearValidation();
    this.$store.commit('corporate/resetProfileInfo');
    this.$store.commit('countryCode/reset');
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_corporate_profile__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_corporate_invoice__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'invoice',
  data: function data() {
    return {
      contentShow: {
        accountInfo: true,
        invoiceInfo: true
      },
      startDate: '',
      endDate: '',
      today: __WEBPACK_IMPORTED_MODULE_0_moment___default()(),
      dueDate: '',
      dueDateField: '',
      status: '',
      statusField: '',
      showEditField: false,
      statusLoading: false,
      pdfFile: '',
      transactions: {
        list: [],
        loading: false
      },
      showRecords: false
    };
  },

  components: { datepicker: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default.a },
  computed: {
    corporateId: function corporateId() {
      return this.$route.params.id;
    },
    invoiceId: function invoiceId() {
      return this.$route.params.invoiceId;
    },
    corporateInfo: function corporateInfo() {
      return this.$store.state.corporate.profile.info;
    },
    disabledDueDate: function disabledDueDate() {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(this.today.subtract(1, 'months').format('YYYY'), this.today.format('MM'), this.today.format('DD'))
        };
      }

      return {
        to: new Date(this.today.format('YYYY'), this.today.subtract(1, 'months').format('MM'), this.today.format('DD'))
      };
    }
  },
  methods: {
    resetInfo: function resetInfo() {
      this.startDate = '';
      this.endDate = '';
      this.dueDate = '';
      this.status = '';
      this.showEditField = false;
      this.statusLoading = false;
      this.pdfFile = '';
      this.transactions = {
        list: [],
        loading: false
      };
    },
    getInvoiceData: function getInvoiceData() {
      var self = this;
      self.resetInfo();

      __WEBPACK_IMPORTED_MODULE_2__modules_api_corporate_invoice__["a" /* default */].getInvoiceData(self, {
        corporateId: self.corporateId,
        invoiceId: self.invoiceId
      }, function (res) {
        if (!res.error) {
          var dbFormat = 'YYYY-MM-DD';
          var boFormat = 'MM/DD/YYYY';
          self.startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(res.startDate, dbFormat).format(boFormat);
          self.endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(res.endDate, dbFormat).format(boFormat);
          self.dueDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(res.dueDate, dbFormat).format(boFormat);
          self.dueDateField = self.dueDate;
          self.status = res.status;
          self.statusField = res.status;
          self.pdfFile = res.fileUrl;

          self.$store.commit('corporate/setInvoiceDateFrom', self.startDate);
          self.$store.commit('corporate/setInvoiceDateTo', self.endDate);
          self.$store.commit('corporate/setInvoiceDueDate', self.dueDate);

          self.getInvoiceTransaction();
        } else {
          self.$router.push('/accessdenied');
        }
      });
    },
    getInvoiceTransaction: function getInvoiceTransaction() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1__modules_api_corporate_profile__["a" /* default */].getAllTransactions(self, self.corporateId, function (res) {
        if (!res.error) {
          res.list.forEach(function (data) {
            var pickup = data.pickupLocation.addressLine1 + ', ' + data.pickupLocation.city + ', ' + data.pickupLocation.state;
            var dropoff = data.dropoffLocation.addressLine1 + ', ' + data.dropoffLocation.city + ', ' + data.dropoffLocation.state;
            var total = parseFloat(data.breakdown.fare + data.breakdown.pickupFee + data.breakdown.tip + data.breakdown.airportFee + data.breakdown.travelInsurance);
            total -= data.credits;
            self.transactions.list.push({
              id: data.ID,
              completedDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.complete, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
              passenger: data.guest.firstName + ' ' + data.guest.lastName,
              pickup: pickup,
              dropoff: dropoff,
              total: total.toFixed(2)
            });
          });
        }
      });
    },
    getCorporateData: function getCorporateData() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1__modules_api_corporate_profile__["a" /* default */].getInfo(self, self.corporateId, function (res) {
        if (!res.error && res.list.length) {
          var info = res.list[0];
          self.$store.commit('corporate/setProfile', {
            id: info.id,
            consId: info.custContactID,
            logo: info.logoUrl,
            username: info.username,
            password: info.password,
            name: info.name,
            email: info.contactEmail,
            color: info.corporateColor,
            mobile: info.contactPhone,
            website: info.corporateWebsiteUrl,
            cardOwner: '',
            creditCard: '',
            cardExpiration: '',
            cardCVV: '',
            billingAddress1: info.billingAddress1,
            billingAddress2: info.billingAddress2,
            billingCity: info.billingCity,
            billingState: info.billingState,
            billingZip: info.billingZip,
            biilingCountry: info.billingCountry,
            stripeUrl: info.customer.customerURL,
            active: info.active === 1
          });
        } else {
          self.$router.push('/accessdenied');
        }
      });
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('MM/DD/YYYY');
    },
    updateFields: function updateFields() {
      var self = this;
      if (self.statusLoading) {
        return;
      }

      self.statusLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__modules_api_corporate_invoice__["a" /* default */].updateFields(self, {
        corporateId: self.corporateId,
        invoiceId: self.invoiceId,
        status: self.statusField,
        dueDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.dueDateField).format('YYYY-MM-DD')
      }, function (res) {
        self.statusLoading = false;
        if (!res.error) {
          self.showEditField = false;
          self.status = res.status;
          self.dueDate = res.dueDate;
        }
      });
    }
  },
  watch: {
    corporateId: function corporateId(value) {
      this.getInvoiceData();
      this.getCorporateData();
    },
    invoiceId: function invoiceId(value) {
      this.getInvoiceData();
      this.getCorporateData();
    }
  },
  mounted: function mounted() {
    this.getInvoiceData();
    this.getCorporateData();
  }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(6);
/* global CONFIG */



/* harmony default export */ __webpack_exports__["a"] = ({
  getInvoices: function getInvoices(VueApp, id, callback) {
    VueApp.$sdk.get('/admin/corporateprofile/' + id + '/invoices', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      if (!res.error) {
        // VueApp.$store.commit('corporate/setTrxMaxList', res.paging.totalItems)

        if (res.list.length) {
          var data = res.list;
          for (var i = 0; i < res.list.length; i++) {
            VueApp.$store.commit('corporate/addInvoices', {
              id: data[i].id,
              file: data[i].fileUrl,
              startDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(data[i].startDate, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY'),
              endDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(data[i].endDate, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY'),
              dueDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(data[i].dueDate, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY'),
              status: data[i].status
            });
          }
        }
      }
      callback(res);
    });
  },
  getInvoiceData: function getInvoiceData(VueApp, data, callback) {
    VueApp.$sdk.get('/admin/corporateprofile/' + data.corporateId + '/invoices/' + data.invoiceId, {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      callback(res);
    });
  },
  updateFields: function updateFields(VueApp, data, callback) {
    VueApp.$sdk.post('/admin/corporateprofile/' + data.corporateId + '/invoices/' + data.invoiceId, {
      token: VueApp.$store.state.session.sessionToken,
      status: data.status,
      dueDate: data.dueDate
    }, function (res) {
      callback(res);
    });
  },
  exportTransactions: function exportTransactions(VueApp, conId, callback) {
    var self = this;
    var transactions = VueApp.$store.state.corporate.transactions;
    var pageSize = 99999;
    var page = 1;

    var since = __WEBPACK_IMPORTED_MODULE_0_moment___default()(transactions.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00');
    var until = __WEBPACK_IMPORTED_MODULE_0_moment___default()(transactions.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59');
    if (transactions.date === 'all') {
      since = '2010-01-01 00:00';
      until = __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(10, 'years').format('YYYY-MM-DD 23:59');
    }

    VueApp.$sdk.get('/transaction', {
      token: VueApp.$store.state.session.sessionToken,
      consId: conId,
      pageSize: pageSize,
      pageNum: page,
      order: transactions.sort.column,
      orderAsc: transactions.sort.isDesc ? 0 : 1,
      since: since,
      until: until,
      search: transactions.search,
      status: transactions.status,
      export: true
    }, function (res) {
      if (!res.error) {
        var trx = [];
        if (res.list.length) {
          res.list.forEach(function (value) {
            trx.push(self.buildExport(value));
          });
        }
        callback(trx);
      } else {
        callback(res);
      }
    });
  },
  toFixed: function toFixed(value) {
    value = parseFloat(value);
    if (value < 0) {
      return '-$' + Math.abs(value).toFixed(2);
    }
    return '$' + value.toFixed(2);
  },
  bookedThroughLabel: function bookedThroughLabel(value) {
    switch (value) {
      case 'ww':
        return 'Web';
      case 'admin':
        return 'Admin';
      case 'android':
        return 'Android App';
      case 'ios':
        return 'iOS App';
      case 'provider':
        return 'Provider';
      default:
        return value;
    }

    return '';
  },
  buildExport: function buildExport(data) {
    var rsvpId = this.convertBrand(data.brandId) + data.rsvpId;
    var serviceType = __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].getServiceName(data.serviceCode);
    var payment = data.payment;
    var creditCard = payment.cancelFee ? 'N/A' : data.cardNumber;
    var source = this.bookedThroughLabel(data.deviceType);
    var provLicense = data.provider.accountType || '';

    if (data.packageId) {
      rsvpId = data.packageId;
      serviceType = __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].getServiceName('shared');
      source = 'PKG';
    }
    if (!{"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation) {
      serviceType = data.serviceType.label;
    }

    return {
      Date: __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY'),
      'Booking Time': __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('HH:mm:ss'),
      'Pickup Time': __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.pickupTime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm'),
      'Service Area': data.geofence.name,
      'Prov ID': data.provider.id,
      'Prov License': provLicense.toUpperCase(),
      'Company': data.provider.businessName,
      'RSVP ID': rsvpId,
      'Invoice ID': data.eventId,
      'Service Type': serviceType,
      'First Name': data.consumer.firstName,
      'Last Name': data.consumer.lastName,
      'Credit Card': creditCard,
      'Email': data.consumer.email,
      'Mobile': data.consumer.phone,
      'Source': source,
      'Final Offer': payment.offer || 0,
      'Charge Amount': payment.charged || 0,
      'Refunded Amount': -Math.abs(data.refundedAmount) || 0,
      'Promo Used': payment.credit || 0,
      'Driver Payment': payment.driverPay || 0,
      'Bonus': payment.bonus || 0,
      'Cancel Fees': payment.cancelFee || 0,
      'Status': data.status,
      'Pickup Location': data.pickupLocation,
      'Dropoff Location': data.dropoffLocation
    };
  },
  convertBrand: function convertBrand(id) {
    var index = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.findIndex(function (x) {
      return x.id === id;
    });
    if (!id || index === -1) {
      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[0].code.toUpperCase();
    }

    return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[index].code.toUpperCase();
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransactionFilter_vue__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TransactionList_vue__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreditCard_vue__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InvoiceList_vue__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CorporateLogs_vue__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_color__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_us__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_us___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_us__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_api_corporate_profile__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_api_corporate_logs__ = __webpack_require__(432);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */










var phoneUtil = __webpack_require__(50).PhoneNumberUtil.getInstance();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'corporate-profile',
  components: { 'chrome-picker': __WEBPACK_IMPORTED_MODULE_5_vue_color__["Chrome"], TransactionFilter: __WEBPACK_IMPORTED_MODULE_0__TransactionFilter_vue__["a" /* default */], TransactionList: __WEBPACK_IMPORTED_MODULE_1__TransactionList_vue__["a" /* default */], CreditCard: __WEBPACK_IMPORTED_MODULE_2__CreditCard_vue__["a" /* default */], InvoiceList: __WEBPACK_IMPORTED_MODULE_3__InvoiceList_vue__["a" /* default */], CorporateLogs: __WEBPACK_IMPORTED_MODULE_4__CorporateLogs_vue__["a" /* default */] },
  data: function data() {
    return {
      contentShow: {
        discountInfo: true,
        accountInfo: true,
        billingInfo: true
      },
      statusLoading: false,
      upload: {
        loading: false,
        message: ''
      },
      repeatPassword: '',
      showEmailColor: false,
      emailColors: '',
      colorDelay: '',
      countries: __webpack_require__(45).countries,
      validation: {
        logo: '',
        username: '',
        password: '',
        repeatPassword: '',
        name: '',
        email: '',
        color: '',
        mobile: '',
        website: '',
        cardOwner: '',
        creditCard: '',
        cardExpiration: '',
        cardCVV: '',
        billingAddress1: '',
        billingCity: '',
        billingState: '',
        biilingCountry: ''
      },
      respond: {
        show: false,
        success: false,
        label: '',
        message: '',
        id: ''
      },
      showBillingForm: false,
      confirmCard: {
        show: false,
        loading: false
      },
      cardId: '',
      cardType: '',
      password: {
        show: false,
        loading: false,
        message: '',
        success: false
      },
      activeTab: 0,
      isDisplayCountryCode: true,
      showRightPanel: true,
      showIconLog: true,
      loadingMoreLogs: false,
      showRecords: false,
      isMobile: false,
      discountCodeValidation: '',
      discountList: {
        loading: false,
        list: []
      }
    };
  },

  computed: {
    _corporateId: function _corporateId() {
      return this.$route.params.id;
    },
    corporateInfo: function corporateInfo() {
      return this.$store.state.corporate.profile.info;
    },
    loading: function loading() {
      return this.$store.state.corporate.profile.loading;
    },

    // loadingLogs () { return this.$store.state.corporate.logs.loading },
    states: function states() {
      var states = [];
      for (var key in __WEBPACK_IMPORTED_MODULE_6_us___default.a.states) {
        if (__WEBPACK_IMPORTED_MODULE_6_us___default.a.states.hasOwnProperty(key)) {
          states.push({
            value: key,
            label: __WEBPACK_IMPORTED_MODULE_6_us___default.a.states[key].name
          });
        }
      }
      return states;
    },
    isCreate: function isCreate() {
      return this._corporateId === 'add';
    },
    callingCode: function callingCode() {
      if (this.isDisplayCountryCode) {
        this.displayMobileNumber();
      }
      return this.$store.state.countryCode.callingCode;
    },
    iconToggleRightPanel: function iconToggleRightPanel() {
      return this.showRightPanel ? 'fa fa-clipboard-list fa-2x' : 'fas fa-times fa-2x';
    }
  },
  methods: {
    loadMoreLogs: function loadMoreLogs(event) {
      var scrollAndView = event.target.scrollTop + event.target.offsetHeight;
      if (event.target.scrollHeight - scrollAndView < 1) {
        this.$store.commit('corporate/setCorporateLogsCurrentPage', this.$store.state.corporate.logs.currentPage + 1);
        this.getMoreCorporateLogs();
      }
    },
    toggleRightPanel: function toggleRightPanel() {
      var self = this;
      self.showRightPanel = !self.showRightPanel;
      if (!self.showRightPanel) {
        self.$store.commit('corporate/resetLogs');
        self.$store.commit('corporate/setCorporateLogsCurrentPage', 1);
        self.$store.commit('corporate/setLoadingLogs', true);
        self.refreshCorporateLogs();
      }
    },
    selectCountry: function selectCountry() {
      this.$store.commit('countryCode/setCountryModal', true);
    },
    getMoreCorporateLogs: function getMoreCorporateLogs() {
      var self = this;
      self.loadingMoreLogs = true;
      __WEBPACK_IMPORTED_MODULE_8__modules_api_corporate_logs__["a" /* default */].getLogs(self, self._corporateId, function (res) {
        self.loadingMoreLogs = false;
      });
    },
    refreshCorporateLogs: function refreshCorporateLogs() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_8__modules_api_corporate_logs__["a" /* default */].getLogs(self, self._corporateId, function (res) {
        self.$store.commit('corporate/setLoadingLogs', false);
      });
    },
    getCorporateData: function getCorporateData() {
      var self = this;
      if (self._corporateId === 'add') {
        self.showBillingForm = true;
        self.$store.commit('corporate/resetProfileInfo');
      } else {
        __WEBPACK_IMPORTED_MODULE_7__modules_api_corporate_profile__["a" /* default */].getInfo(self, self._corporateId, function (res) {
          if (!res.error && res.list.length) {
            var info = res.list[0];
            self.$store.commit('corporate/setProfile', {
              id: info.id,
              consId: info.custContactID,
              logo: info.logoUrl,
              username: info.username,
              password: info.password,
              name: info.name,
              email: info.contactEmail,
              color: info.corporateColor,
              mobile: info.contactPhone,
              website: info.corporateWebsiteUrl,
              cardOwner: '',
              creditCard: '',
              cardExpiration: '',
              cardCVV: '',
              billingAddress1: info.billingAddress1,
              billingAddress2: info.billingAddress2,
              billingCity: info.billingCity,
              billingState: info.billingState,
              billingZip: info.billingZip,
              biilingCountry: info.billingCountry,
              stripeUrl: info.customer.customerURL,
              active: info.active === 1,
              discountCode: info.discountCode || ''
            });
            self.getCardInfo();
            self.getDiscountList();
          } else {
            self.$router.push('/accessdenied');
          }
        });
      }
    },
    triggerUpload: function triggerUpload() {
      if (this.loading) {
        return;
      }
      this.$refs.uploadInput.click();
    },
    uploadFile: function uploadFile(e) {
      if (!e.target.files.length) {
        return;
      }

      var self = this;
      var file = e.target.files[0];
      var fd = new FormData();
      fd.append('pic', file);

      self.upload.loading = true;
      self.upload.message = '';

      self.$http.post({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.mediaHost + '/api/upload', fd, {
        header: { 'Content-Type': 'multipart/form-data' }
      }).then(function (res) {
        self.upload.loading = false;
        if (!res.body.success) {
          self.upload.message = 'Upload fail. Please try again.';
          // self.upload[self.upload.target].success = false
          return;
        }

        self.corporateInfo.logo = res.body.data.url;
      }, function (res) {
        self.upload.loading = false;
        self.upload.message = res;
        console.log('error', res);
      });
    },
    selectColor: function selectColor() {
      this.$store.commit('corporate/setProfileColor', this.emailColors.hex.substring(1, this.emailColors.hex.length));
      this.showEmailColor = false;
    },
    updateColor: function updateColor(value) {
      var self = this;
      if (self.colorDelay) {
        clearTimeout(self.colorDelay);
      }

      self.$store.state.corporate.profile.info.color = value.hex.substring(1, value.hex.length);
      self.colorDelay = setTimeout(function () {
        self.showEmailColor = false;
      }, 1200);
    },
    isNumber: function isNumber(evt) {
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
        return;
      }
      return true;
    },
    formatExpCC: function formatExpCC() {
      var cardExp = this.corporateInfo.cardExpiration;
      if (cardExp.length === 2 && !isNaN(cardExp)) {
        this.corporateInfo.cardExpiration = cardExp + '/';
      }
    },
    submit: function submit() {
      var self = this;
      if (self.loading || !self.validate() || self.upload.loading) {
        return;
      }

      self.$store.commit('corporate/setProfileLoading', true);

      if (self.isCreate) {
        __WEBPACK_IMPORTED_MODULE_7__modules_api_corporate_profile__["a" /* default */].create(self, function (res) {
          self.$store.commit('corporate/setProfileLoading', false);
          if (!res.error) {
            self.respond = {
              show: true,
              success: true,
              label: 'Successfully updated profile.',
              message: ''
            };
            window.location = '/#/corporate/' + res.id;
          } else {
            self.respond = {
              show: true,
              success: false,
              label: 'respond-box',
              message: res.error.message,
              id: ''
            };
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_7__modules_api_corporate_profile__["a" /* default */].update(self, function (res) {
          self.$store.commit('corporate/setProfileLoading', false);
          if (!res.error) {
            self.respond = {
              show: true,
              success: true,
              label: 'Successfully updated profile.',
              message: ''
            };
          } else {
            self.respond = {
              show: true,
              success: false,
              label: 'Oops! Something went wrong.',
              message: res.error.message,
              id: ''
            };
          }
        });
      }
      self.$store.commit('corporate/resetLogs');
      self.$store.commit('corporate/setCorporateLogsCurrentPage', 1);
      self.$store.commit('corporate/setLoadingLogs', true);
      setTimeout(function () {
        self.refreshCorporateLogs();
      }, 2000);
    },
    validate: function validate() {
      var noError = true;

      if (this.upload.message !== '') {
        noError = false;
      }

      this.discountCodeValidation = '';
      for (var field in this.validation) {
        if (!this.isCreate && field === 'password') {
          continue;
        }
        this.validation[field] = '';
        if (this.corporateInfo[field] === '') {
          this.validation[field] = 'This field cannot be empty.';
          noError = false;
        }
      }

      if (this.corporateInfo.username.indexOf(' ') > -1) {
        this.validation.username = 'Space is not allowed';
        noError = false;
      }

      if (this.isCreate) {
        if (this.repeatPassword === '') {
          this.validation.repeatPassword = 'This field cannot be empty.';
          noError = false;
        }

        if (this.repeatPassword !== '' && this.corporateInfo.password !== '' && this.repeatPassword !== this.corporateInfo.password) {
          this.validation.repeatPassword = 'Password and Repeat password doesn\'t match.';
          noError = false;
        }
      }

      return noError;
    },
    clearValidation: function clearValidation() {
      this.validation = {
        logo: '',
        username: '',
        password: '',
        repeatPassword: '',
        name: '',
        email: '',
        color: '',
        mobile: '',
        website: '',
        billingAddress1: '',
        billingCity: '',
        billingState: '',
        biilingCountry: ''
      };
    },
    closeResponModal: function closeResponModal() {
      this.respond.show = false;
      if (this.respond.id) {
        window.location = '/#/corporate/' + this.respond.id;
      }
    },
    toggleStatus: function toggleStatus() {
      var self = this;
      if (self.statusLoading) {
        return;
      }

      self.statusLoading = true;
      __WEBPACK_IMPORTED_MODULE_7__modules_api_corporate_profile__["a" /* default */].toggleStatus(self, {
        id: self.corporateInfo.id,
        active: self.corporateInfo.active
      }, function (res) {
        self.statusLoading = false;

        if (res.error) {
          self.respond = {
            show: true,
            success: false,
            label: 'Oops! Something went wrong.',
            message: res.error.message
          };
          return;
        }

        // self.disableConsumerAccnt()
        self.corporateInfo.active = !self.corporateInfo.active;
        self.$store.commit('corporate/resetLogs');
        self.$store.commit('corporate/setCorporateLogsCurrentPage', 1);
        self.$store.commit('corporate/setLoadingLogs', true);
        setTimeout(function () {
          self.refreshCorporateLogs();
        }, 2000);
      });
    },
    disableConsumerAccnt: function disableConsumerAccnt() {
      var self = this;
      var action = !self.corporateInfo.active ? 'post' : 'delete';
      self.$sdk[action]('/provider/' + self.corporateInfo.consId + '/active', {
        token: self.$store.state.session.sessionToken
      }, function (res) {
        self.corporateInfo.active = !self.corporateInfo.active;
        self.$store.commit('corporate/resetLogs');
        self.$store.commit('corporate/setCorporateLogsCurrentPage', 1);
        self.$store.commit('corporate/setLoadingLogs', true);
        setTimeout(function () {
          self.refreshCorporateLogs();
        }, 2000);
      });
    },
    addCard: function addCard(id) {
      var self = this;
      this.$sdk.post('/consumer/' + id + '/cards', {
        token: self.$store.state.session.sessionToken,
        title: '',
        name: self.corporateInfo.cardOwner,
        number: self.corporateInfo.creditCard,
        expiration: self.corporateInfo.cardExpiration,
        cvv: self.corporateInfo.cardCVV,
        billingAddress: self.corporateInfo.billingAddress1 + ' ' + self.corporateInfo.billingAddress1,
        billingCity: self.corporateInfo.billingCity,
        billingState: self.corporateInfo.billingState,
        billingCountry: self.corporateInfo.biilingCountry,
        billingZip: self.corporateInfo.billingZip
      }, function (res) {
        self.respond = {
          show: true,
          success: true,
          label: 'Successfully updated profile.',
          message: '',
          id: ''
        };

        self.cardType = self.cardIcon(res.card.title);
        self.$store.commit('corporate/setProfileCreditInfo', {
          cardOwner: self.corporateInfo.cardOwner,
          creditCard: res.card.cardNumber,
          cardExpiration: res.card.cardExpires
        });
        self.showBillingForm = false;
      });
    },
    getCardInfo: function getCardInfo() {
      var self = this;
      self.$sdk.get('/consumer/' + self.corporateInfo.consId + '/cards', {
        token: self.$store.state.session.sessionToken
      }, function (res) {
        if (res.list.length) {
          self.cardType = self.cardIcon(res.list[0].cardType);
          self.cardId = res.list[0].id;
          self.$store.commit('corporate/setProfileCreditInfo', {
            cardOwner: res.list[0].cardholderName,
            creditCard: res.list[0].cardNumber,
            cardExpiration: res.list[0].cardExpires
          });
        }
      });
    },
    cardIcon: function cardIcon(val) {
      switch (val) {
        case 'Visa':
          return 'visa';
        case 'Master Card':
          return 'mastercard';
        case 'MasterCard':
          return 'mastercard';
        case 'mastercard':
          return 'mastercard';
        case 'American Express':
          return 'amex';
        case 'Discover':
          return 'discover';
        case 'JCB':
          return 'jcb';
        case 'Diners Club':
          return 'diners';
        default:
          return 'unknown';
      }
    },
    removeCard: function removeCard() {
      var self = this;
      if (self.confirmCard.loading) {
        return;
      }

      self.confirmCard.loading = true;
      self.$sdk.delete('/consumer/' + self.corporateInfo.consId + '/cards/' + self.cardId, {
        token: self.$store.state.session.sessionToken
      }, function (res) {
        self.confirmCard.loading = false;
        self.confirmCard.show = false;

        if (!res.error) {
          self.cardId = '';
          self.$store.commit('corporate/setProfileCreditInfo', {
            cardOwner: '',
            creditCard: '',
            cardExpiration: ''
          });
        } else {
          self.respond = {
            show: true,
            success: false,
            label: 'Oops! Something went wrong.',
            message: res.error.message,
            id: ''
          };
        }
      });
    },
    updatePassword: function updatePassword() {
      var self = this;
      if (self.password.loading) {
        return;
      }

      var hasError = false;
      if (self.corporateInfo.password === '') {
        self.validation.password = 'This field cannot be empty.';
        hasError = true;
      }
      if (this.repeatPassword === '') {
        this.validation.repeatPassword = 'This field cannot be empty.';
        hasError = true;
      }
      if (this.repeatPassword !== '' && this.corporateInfo.password !== '' && this.repeatPassword !== this.corporateInfo.password) {
        this.validation.repeatPassword = 'Password and Repeat password doesn\'t match.';
        hasError = true;
      }
      if (hasError) {
        return;
      }

      self.password.loading = true;
      self.password.message = '';
      self.$sdk.post('/admin/corporateprofile/' + self._corporateId + '/password', {
        token: self.$store.state.session.sessionToken,
        password: self.corporateInfo.password
      }, function (res) {
        self.password.loading = false;
        if (res.error) {
          self.password.message = res.error.message;
        }

        self.password.show = false;
        self.password.success = true;
        setTimeout(function () {
          self.password.success = false;
        }, 3000);
      });
      self.$store.commit('corporate/resetLogs');
      self.$store.commit('corporate/setCorporateLogsCurrentPage', 1);
      self.$store.commit('corporate/setLoadingLogs', true);
      setTimeout(function () {
        self.refreshCorporateLogs();
      }, 2000);
    },
    displayMobileNumber: function displayMobileNumber() {
      var self = this;
      var mobile = self.corporateInfo.mobile;
      if (mobile) {
        if (mobile.slice(0, 1) !== '+') {
          mobile = '+' + self.corporateInfo.mobile;
        }
        try {
          var mobileNumber = phoneUtil.parse(mobile, "");
          var countryCode = mobileNumber.getCountryCode();
          var nationalNumber = mobileNumber.getNationalNumber();
          self.$store.commit('countryCode/setCallingCode', countryCode);
          self.$store.commit('corporate/setNationalNumber', nationalNumber);
          self.isDisplayCountryCode = false;
        } catch (err) {
          self.$store.commit('countryCode/setCallingCode', '???');
          self.$store.commit('corporate/setNationalNumber', self.corporateInfo.mobile);
        }
      }
    },
    setScreenSize: function setScreenSize() {
      var self = this;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        self.isMobile = true;
      } else {
        self.isMobile = false;
      }
    },
    getDiscountList: function getDiscountList() {
      var self = this;
      if (self.discountList.loading || self.discountList.list.length) return;
      self.discountList.loading = true;

      self.$sdk.get('/discountcode', {
        token: self.$store.state.session.sessionToken,
        order: 'id',
        orderAsc: '',
        search: '',
        pageSize: 999
      }, function (res) {
        self.discountList.loading = false;
        if (!res.error) {
          res.list.forEach(function (dc) {
            var amount = dc.type === '$' ? '' + dc.type + dc.amount : '' + dc.amount + dc.type;
            self.discountList.list.push({
              code: dc.code,
              name: dc.code + ' - ' + amount
            });
          });
        }
      });
    }
  },
  watch: {
    _corporateId: function _corporateId(val) {
      this.clearValidation();
      if (val === 'add') {
        this.repeatPassword = '';
        this.$store.commit('corporate/resetProfileInfo');
      } else {
        this.getCorporateData();
      }
    },

    'corporateInfo.billingState': function corporateInfoBillingState(val) {
      if (val && val !== 'NonUS') {
        this.corporateInfo.biilingCountry = 'US';
      }
    },
    isCreate: function isCreate(val) {
      if (val) {
        this.showBillingForm = true;
      }
    }
  },
  mounted: function mounted() {
    this.clearValidation();
    this.getCorporateData();
    this.setScreenSize();
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_csvexport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_corporate_transactions__ = __webpack_require__(420);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var exporter = __WEBPACK_IMPORTED_MODULE_2_csvexport___default.a.create({
  filename: "export.csv",
  columns: ['Date', 'Booking Time', 'Pickup Time', 'Service Area', 'Prov ID', 'Prov License', 'Company', 'RSVP ID', 'Consumer Notes', 'Invoice ID', 'Service Type', 'First Name', 'Last Name', 'Credit Card', 'Email', 'Mobile', 'Source', 'Final Offer', 'Charge Amount', 'Refunded Amount', 'Promo Used', 'Driver Payment', 'Bonus', 'Cancel Fees', 'Status', 'Pickup Location', 'Dropoff Location']
});

// const exporter = CsvExport.create({
//   filename: 'export.csv',
//   columns: [
//     'Charged Date', 'Customer', 'Card Owner', 'RSVP ID', 'Invoice ID',
//     'TRX Type', 'Charged Amount', 'Refunded Amount'
//   ]
// })

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'transaction-filter',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a },
  data: function data() {
    return {
      searchInput: '',
      blurDelay: '',
      from: '',
      to: '',
      hasError: {
        searchMsg: '',
        from: false,
        to: false,
        fromToMsg: ''
      },
      sort: {
        active: 'created',
        isDesc: true
      },
      invoice: {
        showModal: false,
        dueDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format(),
        dateFrom: '',
        dateTo: '',
        error: {
          dueDate: '',
          dateFrom: '',
          dateTo: ''
        },
        showZeroResults: false
      },
      today: __WEBPACK_IMPORTED_MODULE_0_moment___default()(),
      pdf: {
        data: {}
      },
      exportLoading: false
    };
  },

  computed: {
    conId: function conId() {
      return this.$store.state.corporate.profile.info.consId;
    },

    status: {
      get: function get() {
        return this.$store.state.corporate.transactions.status;
      },
      set: function set(value) {
        this.$store.commit('corporate/setTrxStatus', value);
        if ((this.date.from === '' || this.date.to === '') && this.dateType !== 'all') {
          this.hasError.from = this.date.from === '';
          this.hasError.to = this.date.to === '';
          return;
        }
        this.getTransactions();
      }
    },
    dateType: {
      get: function get() {
        return this.$store.state.corporate.transactions.date;
      },
      set: function set(value) {
        this.$store.commit('corporate/setTrxDate', value);

        var from = '';
        var to = value === 'all' ? '' : __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM/DD/YYYY');
        if (value === 'withinDay') {
          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM/DD/YYYY');
        }
        if (value === 'monthToDate') {
          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()(__WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM') + '/1/' + __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY'), 'MM/DD/YYYY').format('MM/DD/YYYY');
        }
        if (value === 'lastMonth') {
          var lastMonth = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(1, 'months');
          from = lastMonth.format('MM/01/YYYY');
          to = lastMonth.endOf('month').format('MM/DD/YYYY');
        }
        if (value === 'lastWeek') {
          var subtractDays = 0;
          var currentDate = parseInt(__WEBPACK_IMPORTED_MODULE_0_moment___default()().format('E'));
          if (currentDate !== 7) {
            subtractDays = currentDate;
          }

          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(subtractDays + 6, 'days').format('MM/DD/YYYY');
          to = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(subtractDays, 'days').format('MM/DD/YYYY');
        }
        if (value === 'last2Week') {
          var _subtractDays = 0;
          var _currentDate = parseInt(__WEBPACK_IMPORTED_MODULE_0_moment___default()().format('E'));
          if (_currentDate !== 7) {
            _subtractDays = _currentDate;
          }
          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(_subtractDays + 13, 'days').format('MM/DD/YYYY');
          to = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(_subtractDays, 'days').format('MM/DD/YYYY');
        }
        if (value === 'last30Days') {
          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(30, 'days').format('MM/DD/YYYY');
        }
        if (value === 'last60Days') {
          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(60, 'days').format('MM/DD/YYYY');
        }
        if (value === 'last90Days') {
          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(90, 'days').format('MM/DD/YYYY');
        }

        if (value !== 'custom') {
          this.hasError = { searchMsg: '', from: false, to: false, fromToMsg: '' };
          this.$store.commit('corporate/setTrxDateFrom', from);
          this.$store.commit('corporate/setTrxDateTo', to);

          if (value === 'all' && this.searchInput === '') {
            this.hasError.searchMsg = this.$t('transactions.filter.searchEmpty');
            var self = this;
            self.$nextTick(function () {
              self.$refs.search.focus();
            });
            return;
          }

          this.getTransactions();
        }
      }
    },
    date: function date() {
      var filter = this.$store.state.corporate.transactions;
      return {
        from: filter.dateFrom,
        to: filter.dateTo
      };
    },
    transactions: function transactions() {
      return this.$store.state.corporate.transactions.list;
    },
    loading: function loading() {
      return this.$store.state.corporate.transactions.loading;
    },
    disabledDueDate: function disabledDueDate() {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(this.today.subtract(1, 'months').format('YYYY'), this.today.format('MM'), this.today.format('DD'))
        };
      }

      return {
        to: new Date(this.today.format('YYYY'), this.today.subtract(1, 'months').format('MM'), this.today.format('DD'))
      };
    },
    invoiceLoading: function invoiceLoading() {
      return this.$store.state.corporate.invoice.loading;
    }
  },
  methods: {
    init: function init() {
      var self = this;
      self.$store.commit('corporate/resetTrxFilters');
      self.$store.commit('corporate/setTrxDateFrom', __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM/DD/YYYY'));
      self.$store.commit('corporate/setTrxDateTo', __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM/DD/YYYY'));

      self.getTransactions();
    },
    search: function search() {
      this.searchInput = this.searchInput.trim();
      this.$store.commit('corporate/setTrxSearch', this.searchInput);

      if (this.searchInput === '' && this.dateType === 'all') {
        this.hasError.searchMsg = this.$t('transactions.filter.searchEmpty');
        return;
      }
      this.hasError.searchMsg = '';

      if ((this.date.from === '' || this.date.to === '') && this.dateType !== 'all') {
        this.hasError.from = this.date.from === '';
        this.hasError.to = this.date.to === '';
        return;
      }

      if (this.searchInput !== '') {
        this.$store.commit('corporate/setTrxDate', 'all');
        this.$store.commit('corporate/setTrxDateFrom', '');
        this.$store.commit('corporate/setTrxDateTo', '');
      }
      this.getTransactions();
    },
    blurSearch: function blurSearch() {
      var self = this;
      if (self.$store.state.corporate.transactions.search === self.searchInput.trim()) {
        return;
      }

      self.blurDelay = setTimeout(function () {
        self.search();
      }, 500);
    },
    clearSearch: function clearSearch() {
      if (this.blurDelay) {
        clearTimeout(this.blurDelay);
      }

      if (this.loading) {
        return;
      }

      this.searchInput = '';
      this.$store.commit('corporate/setTrxSearch', this.searchInput);
      this.dateType = 'withinDay';
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('MM/DD/YYYY');
    },
    updateFromTo: function updateFromTo(fromTo) {
      this.$store.commit('corporate/setTrxDate', 'custom');

      var format = 'MM/DD/YYYY';
      var from = '';
      var to = '';

      if (fromTo === 'from') {
        this.hasError.from = false;
        from = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.date.from);
        this.$store.commit('corporate/setTrxDateFrom', from.format(format));
        if (this.date.to) {
          to = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.date.to, format);
        }
      } else {
        this.hasError.to = false;
        to = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.date.to);
        this.$store.commit('corporate/setTrxDateTo', to.format(format));
        if (this.date.from) {
          from = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.date.from, format);
        }
      }

      this.hasError = { searchMsg: '', from: false, to: false, fromToMsg: '' };

      if (this.date.from === '' || this.date.to === '') {
        if (fromTo === 'from') {
          this.hasError.to = true;
        } else {
          this.hasError.from = true;
        }
        this.hasError.fromToMsg = this.$t('transactions.filter.emptyDate');
        return;
      }
      if (from.format('x') > to.format('x')) {
        this.hasError.from = true;
        this.hasError.to = true;
        this.hasError.fromToMsg = this.$t('transactions.filter.invalidDateRange');
        return;
      }
      this.getTransactions();
    },
    getTransactions: function getTransactions() {
      var self = this;
      if (self.loading || !self.conId) {
        return;
      }

      this.$store.commit('corporate/resetTransactions');
      this.$store.commit('corporate/setTrxCurrentPage', 1);

      self.$store.commit('corporate/setTrxLoading', true);
      __WEBPACK_IMPORTED_MODULE_3__modules_api_corporate_transactions__["a" /* default */].getTransactions(self, self.conId, function () {
        self.$store.commit('corporate/setTrxLoading', false);
      });
    },
    exportTrx: function exportTrx() {
      var self = this;

      // let transactions = self.$store.state.corporate.transactions
      // let pickupSince = moment(transactions.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00')
      // let pickupUntil = moment(transactions.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59')
      // if (transactions.date === 'all') {
      //   pickupSince = '2010-01-01 00:00'
      //   pickupUntil = moment().add(10, 'years').format('YYYY-MM-DD 23:59')
      // }

      // self.$sdk.get('/reports/trx/list', {
      //   token: this.$store.state.session.sessionToken,
      //   since: pickupSince,
      //   until: pickupUntil,
      //   originals: 1,
      //   tiptrx: 1,
      //   cancelfeetrx: 1,
      //   consId: self.conId
      // }, res => {
      //   if (res.list) {
      //     let trx = []
      //     res.list.forEach(list => {
      //       let charged = list.trxType !== 'Refund' ? self.covertNumber(parseFloat(list.chargedAmount).toFixed(2)) : '-'
      //       let refund = list.trxType === 'Refund' ? self.covertNumber(parseFloat(list.chargedAmount).toFixed(2)) : '-'
      //       trx.push({
      //         'Charged Date': moment(list.created, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY  HH:mm'),
      //         'Customer': list.customer,
      //         'Card Owner': list.cardOwner,
      //         'RSVP ID': list.rsvpId,
      //         'Invoice ID': list.invoiceID,
      //         'TRX Type': list.trxType,
      //         'Charged Amount': charged,
      //         'Refunded Amount': refund
      //       })
      //     })
      //     exporter.downloadCsv(trx)
      //   }
      // })

      __WEBPACK_IMPORTED_MODULE_3__modules_api_corporate_transactions__["a" /* default */].exportTransactions(self, self.conId, function (res) {
        if (!res.error) {
          exporter.downloadCsv(res);
        }
      });
    },
    covertNumber: function covertNumber(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    closeInvoice: function closeInvoice() {
      this.invoice.showModal = false;
      this.invoice.showZeroResults = false;
    },
    createInvoice: function createInvoice() {
      if (this.invoiceLoading) {
        return;
      }

      var hasError = false;
      for (var field in this.invoice.error) {
        if (this.invoice[field] === '') {
          this.invoice.error[field] = 'This field cannot be empty.';
          hasError = true;
        }
      }

      if (hasError) {
        return;
      }

      var from = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.invoice.dateFrom);
      var to = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.invoice.dateTo);
      if (from.format('x') > to.format('x')) {
        this.invoice.error.dateFrom = 'Invalid date range';
        this.invoice.error.dateTo = 'Invalid date range';
        return;
      }

      this.$store.commit('corporate/setInvoiceDateFrom', __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.invoice.dateFrom).format('MM/DD/YYYY'));
      this.$store.commit('corporate/setInvoiceDateTo', __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.invoice.dateTo).format('MM/DD/YYYY'));
      this.$store.commit('corporate/setInvoiceDueDate', __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.invoice.dueDate).format('MM/DD/YYYY'));

      this.invoice.showZeroResults = false;
      if (this.$refs.invoice.buildTable()) {
        this.$refs.invoice.buildTable();
      }
    },
    zeroResults: function zeroResults() {
      this.invoice.showZeroResults = true;
    }
  },
  watch: {
    conId: function conId(value) {
      this.init();
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(6);
/* global CONFIG */



/* harmony default export */ __webpack_exports__["a"] = ({
  getTransactions: function getTransactions(VueApp, conId, callback) {
    var self = this;
    var transactions = VueApp.$store.state.corporate.transactions;
    var pageSize = transactions.perPage;
    var page = transactions.currentPage;
    var pickupSince = __WEBPACK_IMPORTED_MODULE_0_moment___default()(transactions.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00');
    var pickupUntil = __WEBPACK_IMPORTED_MODULE_0_moment___default()(transactions.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59');
    if (transactions.date === 'all') {
      pickupSince = '2010-01-01 00:00';
      pickupUntil = __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(10, 'years').format('YYYY-MM-DD 23:59');
    }

    VueApp.$sdk.get('/transaction', {
      token: VueApp.$store.state.session.sessionToken,
      consId: conId,
      pageSize: pageSize,
      pageNum: page,
      order: transactions.sort.column,
      orderAsc: transactions.sort.isDesc ? 0 : 1,
      since: pickupSince,
      until: pickupUntil,
      search: transactions.search,
      status: transactions.status
    }, function (res) {
      if (!res.error) {
        VueApp.$store.commit('corporate/setTrxMaxList', res.paging.totalItems);

        if (res.list.length) {
          var trx = res.list;
          for (var i = 0; i < res.list.length; i++) {
            var provider = trx[i].provider;
            var payment = trx[i].payment;

            VueApp.$store.commit('corporate/addTransactions', {
              date: __WEBPACK_IMPORTED_MODULE_0_moment___default()(trx[i].datetime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm:ss'),
              providerId: provider.id,
              company: provider.businessName,
              rsvpId: trx[i].rsvpId,
              trxId: trx[i].eventId,
              pkgId: trx[i].packageId,
              type: trx[i].isAsap ? 'asap' : 'rsvp',
              creditCard: trx[i].cardNumber,
              bookedThrough: self.bookedThroughLabel(trx[i].deviceType),
              finalOffer: self.toFixed(payment.offer),
              chargedAmount: self.toFixed(payment.charged),
              promoUsed: self.toFixed(payment.credit),
              status: trx[i].transactionType,
              statusLabel: trx[i].status,
              paymentURL: trx[i].paymentURL,
              notes: trx[i].notes
            });
          }
        }
      }
      callback(res);
    });
  },
  exportTransactions: function exportTransactions(VueApp, conId, callback) {
    var self = this;
    var transactions = VueApp.$store.state.corporate.transactions;
    var pageSize = transactions.perPage;
    var page = transactions.currentPage;

    var since = __WEBPACK_IMPORTED_MODULE_0_moment___default()(transactions.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00');
    var until = __WEBPACK_IMPORTED_MODULE_0_moment___default()(transactions.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59');
    if (transactions.date === 'all') {
      since = '2010-01-01 00:00';
      until = __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(10, 'years').format('YYYY-MM-DD 23:59');
    }

    VueApp.$sdk.get('/transaction', {
      token: VueApp.$store.state.session.sessionToken,
      consId: conId,
      pageSize: pageSize,
      pageNum: page,
      order: transactions.sort.column,
      orderAsc: transactions.sort.isDesc ? 0 : 1,
      since: since,
      until: until,
      search: transactions.search,
      status: transactions.status,
      export: true
    }, function (res) {
      if (!res.error) {
        var trx = [];
        if (res.list.length) {
          res.list.forEach(function (value) {
            trx.push(self.buildExport(value));
          });
        }
        callback(trx);
      } else {
        callback(res);
      }
    });
  },
  toFixed: function toFixed(value) {
    value = parseFloat(value);
    if (value < 0) {
      return '-$' + Math.abs(value).toFixed(2);
    }
    return '$' + value.toFixed(2);
  },
  bookedThroughLabel: function bookedThroughLabel(value) {
    switch (value) {
      case 'ww':
        return 'Web';
      case 'admin':
        return 'Admin';
      case 'android':
        return 'Android App';
      case 'ios':
        return 'iOS App';
      case 'provider':
        return 'Provider';
      default:
        return value;
    }

    return '';
  },
  buildExport: function buildExport(data) {
    var rsvpId = this.convertBrand(data.brandId) + data.rsvpId;
    var serviceType = __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].getServiceName(data.serviceCode);
    var payment = data.payment;
    var creditCard = payment.cancelFee ? 'N/A' : data.cardNumber;
    var source = this.bookedThroughLabel(data.deviceType);
    var provLicense = data.provider.accountType || '';

    if (data.packageId) {
      rsvpId = data.packageId;
      serviceType = __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].getServiceName('shared');
      source = 'PKG';
    }
    if (!{"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation) {
      serviceType = data.serviceType.label;
    }

    return {
      Date: __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY'),
      'Booking Time': __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('HH:mm:ss'),
      'Pickup Time': __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.pickupTime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm'),
      'Service Area': data.geofence.name,
      'Prov ID': data.provider.id,
      'Prov License': provLicense.toUpperCase(),
      'Company': data.provider.businessName,
      'RSVP ID': rsvpId,
      'Consumer Notes': data.meta.rsvpInfo.consumerNotes,
      'Invoice ID': data.eventId,
      'Service Type': serviceType,
      'First Name': data.consumer.firstName,
      'Last Name': data.consumer.lastName,
      'Credit Card': creditCard,
      'Email': data.consumer.email,
      'Mobile': data.consumer.phone,
      'Source': source,
      'Final Offer': payment.offer || 0,
      'Charge Amount': payment.charged || 0,
      'Refunded Amount': -Math.abs(data.refundedAmount) || 0,
      'Promo Used': payment.credit || 0,
      'Driver Payment': payment.driverPay || 0,
      'Bonus': payment.bonus || 0,
      'Cancel Fees': payment.cancelFee || 0,
      'Status': data.status,
      'Pickup Location': data.pickupLocation,
      'Dropoff Location': data.dropoffLocation
    };
  },
  convertBrand: function convertBrand(id) {
    var index = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.findIndex(function (x) {
      return x.id === id;
    });
    if (!id || index === -1) {
      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[0].code.toUpperCase();
    }

    return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[index].code.toUpperCase();
  }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_corporate_transactions__ = __webpack_require__(420);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'transaction-list',
  props: ['isMobile'],
  data: function data() {
    return {
      sort: {
        active: 'created',
        isDesc: true
      },
      is2lines: false
    };
  },

  computed: {
    conId: function conId() {
      return this.$store.state.corporate.profile.info.consId;
    },
    transactions: function transactions() {
      return this.$store.state.corporate.transactions.list;
    },
    loading: function loading() {
      return this.$store.state.corporate.transactions.loading;
    },

    perPage: {
      get: function get() {
        return this.$store.state.corporate.transactions.perPage;
      },
      set: function set(value) {
        this.$store.commit('corporate/setTrxPerPage', parseInt(value));
        this.$store.commit('corporate/setTrxCurrentPage', 1);
        this.getTransactions();
      }
    },
    pageData: function pageData() {
      var tableData = this.$store.state.corporate.transactions;
      var start = tableData.currentPage * tableData.perPage - (tableData.perPage - 1);
      var end = tableData.currentPage * tableData.perPage;
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      };
    },

    currentPage: {
      get: function get() {
        return this.$store.state.corporate.transactions.currentPage;
      },
      set: function set(value) {
        this.$store.commit('corporate/setTrxCurrentPage', parseInt(value));
        this.getTransactions();
      }
    },
    isLastPage: function isLastPage() {
      var tableData = this.$store.state.corporate.transactions;
      return tableData.currentPage * tableData.perPage >= tableData.maxList;
    },
    totalPage: function totalPage() {
      var tableData = this.$store.state.corporate.transactions;
      return Math.ceil(tableData.maxList / tableData.perPage);
    }
  },
  methods: {
    getTransactions: function getTransactions() {
      var self = this;
      if (self.loading) {
        return;
      }

      self.$store.commit('corporate/resetTransactions');
      self.$store.commit('corporate/setTrxLoading', true);
      __WEBPACK_IMPORTED_MODULE_1__modules_api_corporate_transactions__["a" /* default */].getTransactions(self, self.conId, function () {
        self.$store.commit('corporate/setTrxLoading', false);
      });
    },
    sortTable: function sortTable(code) {
      if (!code) {
        return;
      }

      if (this.sort.active === code) {
        this.sort.isDesc = !this.sort.isDesc;
      } else {
        this.sort.isDesc = true;
      }

      this.sort.active = code;
      this.$store.commit('corporate/setTrxSortColumn', code);
      this.$store.commit('corporate/setTrxSortIsDesc', this.sort.isDesc);
      this.$store.commit('corporate/setTrxCurrentPage', 1);
      this.getTransactions(true);
    },
    prev: function prev() {
      if (this.currentPage === 1) {
        return;
      }
      this.$store.commit('corporate/setTrxCurrentPage', this.$store.state.corporate.transactions.currentPage - 1);
      this.getTransactions();
    },
    next: function next() {
      if (this.isLastPage) {
        return;
      }
      this.$store.commit('corporate/setTrxCurrentPage', this.$store.state.corporate.transactions.currentPage + 1);
      this.getTransactions();
    },
    checkScreenSize: function checkScreenSize() {
      this.is2lines = document.documentElement.clientWidth <= 1507;
    }
  },
  watch: {},
  mounted: function mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  }
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_consumer_credit_cards__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_us__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_us___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_us__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_credit_card_type__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_credit_card_type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_credit_card_type__);


var _computed;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'credit-card',
  data: function data() {
    return {
      showAddCardModal: false,
      respond: {
        show: false,
        success: false,
        label: '',
        message: ''
      },
      cardType: 'unknown',
      countries: __webpack_require__(45).countries,
      validation: {
        owner: '',
        card: '',
        expiration: '',
        cvv: '',
        address: '',
        city: '',
        state: '',
        country: ''
      },
      loading: false
    };
  },

  computed: (_computed = {
    creditCardData: function creditCardData() {
      return this.$store.state.corporate.creditCard;
    },
    conId: function conId() {
      return this.$store.state.corporate.profile.info.consId;
    },
    creditCards: function creditCards() {
      return this.$store.state.consumer.creditCards.list;
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_computed, 'conId', function conId() {
    return this.$store.state.corporate.profile.info.consId;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_computed, 'states', function states() {
    var states = [];
    for (var key in __WEBPACK_IMPORTED_MODULE_2_us___default.a.states) {
      if (__WEBPACK_IMPORTED_MODULE_2_us___default.a.states.hasOwnProperty(key)) {
        states.push({
          value: key,
          label: __WEBPACK_IMPORTED_MODULE_2_us___default.a.states[key].name
        });
      }
    }
    return states;
  }), _computed),
  methods: {
    init: function init() {
      this.$store.commit('consumer/resetCards');
      this.$store.commit('consumer/setCardsIsMax', false);
      this.$store.commit('consumer/setCardsCurrentPage', 0);

      this.getCards();
    },
    getCards: function getCards() {
      var self = this;
      if (self.loading || !self.conId) {
        return;
      }

      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__modules_api_consumer_credit_cards__["a" /* default */].getCards(self, self.conId, function () {
        self.loading = false;
      });
    },
    cardStatus: function cardStatus(isVerified) {
      return isVerified ? 'verified' : 'unverified';
    },
    cardTypeCheck: function cardTypeCheck() {
      if (this.creditCardData.card === '') {
        this.cardType = 'unknown';
        return;
      }

      var possibleCards = __WEBPACK_IMPORTED_MODULE_3_credit_card_type___default()(this.creditCardData.card);
      this.cardType = 'unknown';

      for (var i = 0; i < possibleCards.length; i++) {
        var possibleCard = possibleCards[i];
        var cardType = possibleCard.type;

        if (cardType === __WEBPACK_IMPORTED_MODULE_3_credit_card_type__["types"].VISA) {
          this.cardType = 'visa';
        } else if (cardType === __WEBPACK_IMPORTED_MODULE_3_credit_card_type__["types"].MASTERCARD) {
          this.cardType = 'mastercard';
        } else if (cardType === __WEBPACK_IMPORTED_MODULE_3_credit_card_type__["types"].AMERICAN_EXPRESS) {
          this.cardType = 'amex';
        } else if (cardType === __WEBPACK_IMPORTED_MODULE_3_credit_card_type__["types"].DINERS_CLUB) {
          this.cardType = 'dinersclub';
        } else if (cardType === __WEBPACK_IMPORTED_MODULE_3_credit_card_type__["types"].DISCOVER) {
          this.cardType = 'discover';
        } else if (cardType === __WEBPACK_IMPORTED_MODULE_3_credit_card_type__["types"].JCB) {
          this.cardType = 'jcb';
        }
      }
    },
    isNumber: function isNumber(evt) {
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
        return;
      }
      return true;
    },
    formatExpCC: function formatExpCC() {
      var cardExp = this.creditCardData.expiration;
      if (cardExp.length === 2 && !isNaN(cardExp)) {
        this.creditCardData.expiration = cardExp + '/';
      }
    },
    addCard: function addCard() {
      var self = this;
      if (self.loading) {
        return;
      }

      var hasError = false;
      for (var field in this.validation) {
        this.validation[field] = '';
        if (this.creditCardData[field] === '') {
          this.validation[field] = 'This field cannot be empty.';
          hasError = true;
        }
      }

      if (hasError) {
        return;
      }

      self.loading = true;
      self.$sdk.post('/consumer/' + self.conId + '/cards', {
        token: self.$store.state.session.sessionToken,
        title: '',
        name: self.creditCardData.owner,
        number: self.creditCardData.card,
        expiration: self.creditCardData.expiration,
        cvv: self.creditCardData.cvv,
        billingAddress: self.creditCardData.address,
        billingCity: self.creditCardData.city,
        billingState: self.creditCardData.state,
        billingCountry: self.creditCardData.country,
        billingZip: self.creditCardData.zip
      }, function (res) {
        self.loading = false;
        self.showAddCardModal = false;
        if (!res.error) {
          self.respond = {
            show: true,
            success: true,
            label: 'Your credit card is being processed and will be added in a few moments.',
            message: ''
          };
        } else {
          self.respond = {
            show: true,
            success: false,
            label: 'Oops! Something went wrong.',
            message: res.error.message
          };
        }
      });
    },
    closeRespondModal: function closeRespondModal() {
      this.respond.show = false;
      if (this.respond.success) {
        this.getCards();
      }
    }
  },
  watch: {
    conId: function conId(value) {
      this.init();
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function clone(originalObject) {
  var dupe;

  if (!originalObject) { return null; }

  dupe = JSON.parse(JSON.stringify(originalObject));

  return dupe;
}

module.exports = clone;


/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_corporate_invoice__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InvoicePDF__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'invoice-list',
  data: function data() {
    return {
      invoiceModal: {
        showModal: false,
        dueDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format(),
        dateFrom: '',
        dateTo: '',
        error: {
          dueDate: '',
          dateFrom: '',
          dateTo: ''
        },
        showZeroResults: false,
        loading: false
      },
      today: __WEBPACK_IMPORTED_MODULE_0_moment___default()(),
      respond: {
        show: false,
        success: false,
        label: '',
        message: ''
      },
      loading: false
    };
  },

  components: { datepicker: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default.a, 'invoice-pdf': __WEBPACK_IMPORTED_MODULE_2__InvoicePDF__["a" /* default */] },
  computed: {
    corporateId: function corporateId() {
      return this.$route.params.id;
    },
    conId: function conId() {
      return this.$store.state.corporate.profile.info.consId;
    },
    invoices: function invoices() {
      return this.$store.state.corporate.invoice.list;
    },
    dateMaxYesterday: function dateMaxYesterday() {
      var x = this.today.clone();
      if (x.format('MM') === '01') {
        return {
          from: new Date(x.subtract(1, 'months').format('YYYY'), x.format('MM'), x.format('DD'))
        };
      }

      return {
        from: new Date(x.format('YYYY'), x.subtract(1, 'months').format('MM'), x.format('DD'))
      };
    },
    disabledDueDate: function disabledDueDate() {
      var x = this.today.clone();
      if (x.format('MM') === '01') {
        return {
          to: new Date(x.subtract(1, 'months').format('YYYY'), x.format('MM'), x.format('DD'))
        };
      }

      return {
        to: new Date(x.format('YYYY'), x.subtract(1, 'months').format('MM'), x.format('DD'))
      };
    },
    invoiceLoading: function invoiceLoading() {
      return this.$store.state.corporate.invoice.formLoading;
    }
  },
  methods: {
    init: function init() {
      this.$store.commit('corporate/resetInvoice');
      this.$store.commit('corporate/setInvoiceMaxList', false);
      this.$store.commit('corporate/setInvoiceCurrentPage', 0);

      this.getInvoices();
    },
    getInvoices: function getInvoices() {
      var self = this;
      if (self.loading || !self.corporateId) {
        return;
      }

      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__modules_api_corporate_invoice__["a" /* default */].getInvoices(self, self.corporateId, function (res) {
        self.loading = false;
      });
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('MM/DD/YYYY');
    },
    closeInvoice: function closeInvoice() {
      this.invoiceModal.showModal = false;
      this.invoiceModal.showZeroResults = false;
    },
    createInvoice: function createInvoice() {
      if (this.invoiceLoading) {
        return;
      }

      var hasError = false;
      for (var field in this.invoiceModal.error) {
        if (this.invoiceModal[field] === '') {
          this.invoiceModal.error[field] = 'This field cannot be empty.';
          hasError = true;
        }
      }

      if (hasError) {
        return;
      }

      var from = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.invoiceModal.dateFrom);
      var to = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.invoiceModal.dateTo);
      if (from.format('x') > to.format('x')) {
        this.invoiceModal.error.dateFrom = 'Invalid date range';
        this.invoiceModal.error.dateTo = 'Invalid date range';
        return;
      }

      this.$store.commit('corporate/setInvoiceDateFrom', __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.invoiceModal.dateFrom).format('MM/DD/YYYY'));
      this.$store.commit('corporate/setInvoiceDateTo', __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.invoiceModal.dateTo).format('MM/DD/YYYY'));
      this.$store.commit('corporate/setInvoiceDueDate', __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.invoiceModal.dueDate).format('MM/DD/YYYY'));

      this.invoiceModal.showZeroResults = false;
      if (this.$refs.invoice.buildTable()) {
        this.$refs.invoice.buildTable();
      }
    },
    zeroResults: function zeroResults() {
      this.invoiceModal.showZeroResults = true;
    },
    closeRespondModal: function closeRespondModal() {
      this.respond.show = false;
      if (this.respond.success) {
        this.getCards();
      }
    },
    createInvoiceSuccess: function createInvoiceSuccess(res) {
      this.closeInvoice();
      if (res.error) {
        this.respond = {
          show: true,
          success: false,
          label: 'Oops! something went wrong.',
          message: res.error.message
        };
        return;
      }

      this.init();
    }
  },
  watch: {
    corporateId: function corporateId(value) {
      this.init();
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_api_corporate_profile__ = __webpack_require__(92);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */




var request = __webpack_require__(13);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'invoice-pdf',
  data: function data() {
    return {
      pdf: {
        data: {}
      },
      today: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('MM/DD/YYYY'),
      invoiceNumber: '',
      totalRecords: 0,
      total: 0, // total amount
      totalPage: 0,
      pdfProccess: '',
      showWaitModal: false
    };
  },

  computed: {
    corporateId: function corporateId() {
      return this.$route.params.id;
    },
    profileStore: function profileStore() {
      return this.$store.state.corporate.profile;
    },
    profileData: function profileData() {
      return this.profileStore.info;
    },
    invoiceData: function invoiceData() {
      return this.$store.state.corporate.invoice;
    },
    addressLine: function addressLine() {
      var line1 = this.profileData.billingAddress1;
      if (this.profileData.billingAddress2) {
        line1 = this.profileData.billingAddress2 + ' ' + line1;
      }

      return {
        line1: line1,
        line2: this.profileData.billingCity + ' ' + this.profileData.billingZip
      };
    },
    loading: function loading() {
      return this.$store.state.corporate.invoice.loading;
    }
  },
  methods: {
    buildTable: function buildTable() {
      var self = this;
      if (self.loading) {
        return;
      }

      self.$store.commit('corporate/setInvoiceFormLoading', true);
      self.pdf.data = {};
      __WEBPACK_IMPORTED_MODULE_5__modules_api_corporate_profile__["a" /* default */].getAllTransactions(self, self.$route.params.id, function (res) {
        if (!res.error) {
          if (!res.list.length) {
            self.$store.commit('corporate/setInvoiceFormLoading', false);
            self.$emit('zeroResults');
            return;
          }

          var i = 1;
          self.total = 0;

          // delete later - start
          // if (res.list.length < 1000) {
          //   let addRow = 1000 - res.list.length
          //   for (let z = 0; z < addRow; z++) {
          //     res.list.push(res.list[0])
          //   }
          // }
          // delete later - end

          self.totalRecords = res.list.length;
          res.list.forEach(function (rsvp) {
            if (!self.pdf.data['page' + i]) {
              self.pdf.data['page' + i] = [];
            }

            var pickup = rsvp.pickupLocation.addressLine1 + ', ' + rsvp.pickupLocation.city + ', ' + rsvp.pickupLocation.state;
            var dropoff = rsvp.dropoffLocation.addressLine1 + ', ' + rsvp.dropoffLocation.city + ', ' + rsvp.dropoffLocation.state;
            var total = parseFloat(rsvp.breakdown.fare + rsvp.breakdown.pickupFee + rsvp.breakdown.tip + rsvp.breakdown.airportFee + rsvp.breakdown.travelInsurance);
            total -= rsvp.credits;
            self.pdf.data['page' + i].push({
              id: rsvp.ID,
              completedDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()(rsvp.complete, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
              passenger: rsvp.guest.firstName + ' ' + rsvp.guest.lastName,
              pickup: pickup,
              dropoff: dropoff,
              total: total.toFixed(2)
            });

            self.total += total || 0;

            if (self.pdf.data['page' + i].length >= 25 || i === 1 && self.pdf.data['page1'].length >= 10) {
              i++;
            }
          });

          self.$nextTick().then(function () {
            self.$forceUpdate();

            self.total = self.total.toFixed(2);
            self.totalPage = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(self.pdf.data).length;
            setTimeout(function () {
              self.processPdf('pdf', i);
            }, 400);
          });
        } else {
          self.$store.commit('corporate/setInvoiceFormLoading', false);
        }
      });
    },
    processPdf: function processPdf(type, page) {
      var self = this;
      // let start = moment(self.from)
      // let end = moment(self.to)
      var pageAsyncs = [];
      // let landscapeReports = self.orientation
      // let orientation = landscapeReports.indexOf(type) > -1 ? 'l' : 'p'
      var orientation = 'p';
      self.pdfProccess = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a({ orientation: orientation, unit: 'mm', format: 'a4' });
      window.scrollTo(500, 0);
      document.body.style.overflow = 'hidden';

      self.invoiceNumber = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('X');

      setTimeout(function () {
        var _loop = function _loop(i) {
          // self.pdf.current = 'page' + (i + 1)

          pageAsyncs.push(__WEBPACK_IMPORTED_MODULE_4_html2canvas___default()(document.getElementsByClassName('page' + (i + 1))[0], {
            scale: '1'
          }).then(function (canvas) {
            var imgData = canvas.toDataURL('image/jpeg', 0.9);
            self.pdfProccess.addImage(imgData, 'JPEG', 0, 0);
            if (i + 1 !== page) {
              self.pdfProccess.addPage();
            }
          }).catch(function (e) {
            document.body.style.overflow = 'auto';
            self.$store.commit('corporate/setInvoiceFormLoading', false);
            console.warn(e);
          }));
        };

        for (var i = 0; i < page; i++) {
          _loop(i);
        }
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(pageAsyncs).then(function () {
          // request.post({
          //   url: CONFIG.mediaHost + '/api/upload/uri',
          //   body: pdf.output('datauri')
          // }, function (err, res, body) {
          //   let _res = JSON.parse(body)
          //   if (_res.success) {
          //     self.createInvoice(_res.data.url)
          //   } else {
          //     self.$store.commit('corporate/setInvoiceFormLoading', false)
          //   }
          // })

          // pdf.save('invoice.pdf')
          self.createInvoice('https://prod-opoli-app.s3-us-west-2.amazonaws.com/web/invoice_notice.jpg');
        });
      }, 500);
    },
    createInvoice: function createInvoice(pdfUrl) {
      var self = this;

      var invoiceDate = self.$store.state.corporate.invoice;
      self.$sdk.post('/admin/corporateprofile/' + self.corporateId + '/invoices', {
        token: self.$store.state.session.sessionToken,
        fileUrl: pdfUrl,
        startDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()(invoiceDate.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD'),
        endDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()(invoiceDate.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD'),
        dueDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()(invoiceDate.dueDate, 'MM/DD/YYYY').format('YYYY-MM-DD'),
        status: 'unpaid'
      }, function (res) {
        if (!res.error) {
          self.pdfProccess.save('invoice.pdf');
          self.showWaitModal = true;
        }
        self.$store.commit('corporate/setInvoiceFormLoading', false);
        self.$emit('refresh', res);
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(39);
var aFunction = __webpack_require__(76);
var SPECIES = __webpack_require__(19)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(43);
var invoke = __webpack_require__(1203);
var html = __webpack_require__(171);
var cel = __webpack_require__(113);
var global = __webpack_require__(18);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(78)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(39);
var isObject = __webpack_require__(36);
var newPromiseCapability = __webpack_require__(148);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(18);
var core = __webpack_require__(12);
var dP = __webpack_require__(33);
var DESCRIPTORS = __webpack_require__(29);
var SPECIES = __webpack_require__(19)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_corporate_logs__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_featureToggle__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'corporate-logs',
  props: ['corporateId'],
  data: function data() {
    return {};
  },

  computed: {
    logs: function logs() {
      return this.$store.state.corporate.logs.list;
    },
    loading: function loading() {
      return this.$store.state.corporate.logs.loading;
    }
  },
  watch: {
    corporateId: function corporateId(value) {
      this.init();
    }
  },
  methods: {
    init: function init() {
      var self = this;
      self.$store.commit('corporate/setLoadingLogs', true);
      self.$store.commit('corporate/resetLogs');
      self.$store.commit('corporate/setCorporateLogsCurrentPage', 1);
      __WEBPACK_IMPORTED_MODULE_0__modules_api_corporate_logs__["a" /* default */].getLogs(self, self.corporateId, function (res) {
        self.$store.commit('corporate/setLoadingLogs', false);
      });
    },
    dateSplit: function dateSplit(data) {
      var date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_2__modules_api_featureToggle__["a" /* default */].timeFormat(this, true));
      return {
        date: date.format('MM/DD/YYYY'),
        time: date.format(__WEBPACK_IMPORTED_MODULE_2__modules_api_featureToggle__["a" /* default */].timeFormat(this, true))
      };
    },
    displayAction: function displayAction(data) {
      var self = this;
      switch (data.action) {
        default:
          return '<b>' + data.action + '</b>';
        case "create":
          return '<b>Admin created an account</b>';
        case "change_password":
          return '<b>Admin changed the password</b>';
        case "create_invoice":
          return '<b>Admin created an invoice</b>';
        case "update_invoice":
          return '<b>Admin updated an invoice</b>';
        case "activate":
          return '<b>Admin activated the account</b>';
        case "deactivate":
          return '<b>Admin deactivated the account</b>';
        case "update":
          return '<b>Admin made an update</b>';
      }
    },
    displayLog: function displayLog(data) {
      var self = this;
      var createdTime = self.dateSplit(data.created).date + ' ' + self.dateSplit(data.created).time;
      var admin = data.admin ? '<br/><div>Admin ID: <b>' + data.admin.id + '</b></div><div>Admin Name: <b>' + data.admin.name + '</b></div> <div>Admin Email: <b>' + data.admin.email + '</b></div>' : '';

      switch (data.action) {
        default:
          return admin;

        case "update":
          var fields = [];
          if (data.fields) {
            data.fields.forEach(function (log) {
              fields.push('<br/><div><b>' + self.labelFormat(log.field) + '</b></div><div>' + self.valueFormat(log.field, log.old) + ' <i class="fas fa-chevron-right"></i> <b>' + self.valueFormat(log.field, log.new) + '</b></div>');
            });
            return admin + fields.join('');
          } else {
            return admin;
          }

        case "create_invoice":
        case "update_invoice":
          var status = '<br/><div>Invoice ID: <b>' + data.invoiceId + '</b></div><div>Status: <b>' + self.labelFormat(data.status) + '</b></div> <div>Start Date: <b>' + self.labelFormat(data.startDate) + '</b></div> <div>End Date: <b>' + self.labelFormat(data.endDate) + '</b></div> <div>Due Date: <b>' + self.labelFormat(data.dueDate) + '</b></div> <div><a href="/#/corporate/' + self.corporateId + '/invoice/' + data.invoiceId + '" target="_blank">View File</a></div>';
          return admin + status;

      }
    },
    labelFormat: function labelFormat(field) {
      switch (field) {
        default:
          return field.replace(/^\w/, function (c) {
            return c.toUpperCase();
          });
        case "contactEmail":
          return "Email";
        case "contactPhone":
          return "Phone";
        case "billingAddress1":
          return "Address1";
        case "billingAddress2":
          return "Address2";
        case "billingCity":
          return "City";
        case "billingState":
          return "State";
        case "billingZip":
          return "Zip";
        case "billingCountry":
          return "Country";
        case "logoUrl":
          return "Logo URL";
      }
    },
    valueFormat: function valueFormat(field, value) {
      if (!value) {
        return 'none';
      }
      return value;
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__featureToggle__ = __webpack_require__(5);




/* harmony default export */ __webpack_exports__["a"] = ({
  getLogs: function getLogs(VueApp, corporateId, callback) {
    var corporate = VueApp.$store.state.corporate.logs;
    VueApp.$sdk.get('/admin/corporateprofile/' + corporateId + '/logs', {
      token: VueApp.$store.state.session.sessionToken,
      order: corporate.order,
      orderAsc: corporate.orderAsc,
      pageNum: corporate.currentPage,
      pageSize: corporate.perPage
    }, function (res) {
      if (!res.error) {
        var logs = [];
        var infoLog = {};
        res.list.forEach(function (data) {
          infoLog = {
            id: data.id,
            action: data.action,
            created: __WEBPACK_IMPORTED_MODULE_1_moment___default.a.tz(data.created, 'YYYY-MM-DD@HH:mm:ss@@@@', "GMT").tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm:ss'),
            admin: data.admin ? {
              name: data.admin.firstName + ' ' + data.admin.lastName,
              id: data.admin.id,
              email: data.admin.email,
              phone: data.admin.phone
            } : null,
            collapsed: false
          };
          switch (data.action) {
            default:
              logs.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, infoLog));
              break;
            case 'update':
              var fields = [];
              if (data.details.changes) {
                data.details.changes.forEach(function (data2) {
                  fields.push({
                    field: data2.field,
                    old: data2.old,
                    new: data2.new
                  });
                });
                logs.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, infoLog, {
                  fields: fields
                }));
              } else {
                logs.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, infoLog));
              }
              break;

            case 'update_invoice':
            case 'create_invoice':
              var invoice = data.details.result.list[0];
              logs.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, infoLog, {
                invoiceId: invoice.id,
                file: invoice.fileUrl,
                status: invoice.status,
                startDate: __WEBPACK_IMPORTED_MODULE_1_moment___default()(invoice.startDate).format('MM/DD/YYYY'),
                endDate: __WEBPACK_IMPORTED_MODULE_1_moment___default()(invoice.endDate).format('MM/DD/YYYY'),
                dueDate: __WEBPACK_IMPORTED_MODULE_1_moment___default()(invoice.dueDate).format('MM/DD/YYYY')
              }));
          }
        });
        logs.forEach(function (log) {
          return VueApp.$store.commit('corporate/addCorporateLog', log);
        });
      }
      callback(res);
    });
  }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AvailableDrivers__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map2__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DispatchModal__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DispatchNotification__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DispatchSchedule__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ReservationsTable__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Partials_ReservationFilter__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Partials_ReservationSearch__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MoreFilter__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Routing_Header__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Routing_PackagesTable__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Routing_PackagesControl__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Routing_ReservationsTable__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Routing_PickupDateModal__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Routing_Map2__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Routing_DropZone__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Routing_RoutingModal__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ReadyToGoModal__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__NotesModal__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DriverServiceFilter__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Runs_Tables__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Runs_TableFilter__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Runs_Map__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Runs_Dropzone__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__RsvpAvailableDrivers__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__LyftServices__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__modules_api_featureToggle__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import moment from 'moment'

// import DispatchMap from './Map'













// import RoutingMap from '../Routing/Map'














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dispatch-home',
  components: {
    AvailableDrivers: __WEBPACK_IMPORTED_MODULE_0__AvailableDrivers__["a" /* default */], DispatchMap2: __WEBPACK_IMPORTED_MODULE_1__Map2__["a" /* default */], DispatchModal: __WEBPACK_IMPORTED_MODULE_2__DispatchModal__["a" /* default */], DispatchNotification: __WEBPACK_IMPORTED_MODULE_3__DispatchNotification__["a" /* default */], DispatchSchedule: __WEBPACK_IMPORTED_MODULE_4__DispatchSchedule__["a" /* default */],
    ReservationsTable: __WEBPACK_IMPORTED_MODULE_5__ReservationsTable__["a" /* default */], ReservationFilter: __WEBPACK_IMPORTED_MODULE_6__components_Partials_ReservationFilter__["a" /* default */], ReservationSearch: __WEBPACK_IMPORTED_MODULE_7__components_Partials_ReservationSearch__["a" /* default */], DispatchMoreFilter: __WEBPACK_IMPORTED_MODULE_8__MoreFilter__["a" /* default */],
    RoutingHeader: __WEBPACK_IMPORTED_MODULE_9__Routing_Header__["a" /* default */], RoutingPackagesControl: __WEBPACK_IMPORTED_MODULE_11__Routing_PackagesControl__["a" /* default */], RoutingPackagesTable: __WEBPACK_IMPORTED_MODULE_10__Routing_PackagesTable__["a" /* default */],
    RoutingReservationsTable: __WEBPACK_IMPORTED_MODULE_12__Routing_ReservationsTable__["a" /* default */], PickupDateModal: __WEBPACK_IMPORTED_MODULE_13__Routing_PickupDateModal__["a" /* default */], RoutingMap2: __WEBPACK_IMPORTED_MODULE_14__Routing_Map2__["a" /* default */], RoutingDropZone: __WEBPACK_IMPORTED_MODULE_15__Routing_DropZone__["a" /* default */],
    RoutingModal: __WEBPACK_IMPORTED_MODULE_16__Routing_RoutingModal__["a" /* default */], ReadyToGoModal: __WEBPACK_IMPORTED_MODULE_17__ReadyToGoModal__["a" /* default */], NotesModal: __WEBPACK_IMPORTED_MODULE_18__NotesModal__["a" /* default */], DriverServiceFilter: __WEBPACK_IMPORTED_MODULE_19__DriverServiceFilter__["a" /* default */],
    runsTables: __WEBPACK_IMPORTED_MODULE_20__Runs_Tables__["a" /* default */], runsTableFilter: __WEBPACK_IMPORTED_MODULE_21__Runs_TableFilter__["a" /* default */], runsMap: __WEBPACK_IMPORTED_MODULE_22__Runs_Map__["a" /* default */], runsDropzone: __WEBPACK_IMPORTED_MODULE_23__Runs_Dropzone__["a" /* default */], RsvpAvailableDrivers: __WEBPACK_IMPORTED_MODULE_24__RsvpAvailableDrivers__["a" /* default */],
    Lyft: __WEBPACK_IMPORTED_MODULE_25__LyftServices__["a" /* default */]
  },
  data: function data() {
    return {
      showDriverPanel: false,
      isShrink: false,
      showFilter: false,
      tabIndex: 0,
      runsLoaded: false,
      availability: {
        showToggle: false,
        show: false
      },
      rsvp: null,
      isMobile: false,
      showMapMobile: false,
      queueError: {
        show: false,
        message: '',
        unfiltered: [],
        unqualified: [],
        reasonsModal: false
      }
    };
  },

  computed: {
    rsvpInMap: function rsvpInMap() {
      return this.$store.state.dispatch.rsvpInMap;
    },
    selectedFilter: function selectedFilter() {
      return this.$store.state.reservation.selectedFilter;
    },
    showServiceFilter: function showServiceFilter() {
      return this.$store.state.dispatch.serviceFilter.show;
    },
    lastSync: function lastSync() {
      return this.$store.state.dispatch.lastSync;
    },
    runs: function runs() {
      return this.$store.state.runs;
    },

    rsvpAvailabilityLoading: {
      get: function get() {
        return this.$store.state.dispatch.availableDrivers.loading;
      },
      set: function set(x) {
        this.$store.commit('dispatch/setAvailableDriversData', { loading: x });
      }
    }
  },
  methods: {
    toggleDriverPanel: function toggleDriverPanel() {
      var self = this;
      self.showDriverPanel = !self.showDriverPanel;
    },
    expand: function expand() {
      if (this.isShrink) {
        this.isShrink = false;
        return;
      }
      window.location = '/#/dispatch/reservations';
    },
    showCustomFilter: function showCustomFilter() {
      if (this.showFilter) {
        this.showFilter = false;
        return;
      }
      this.showFilter = true;
      this.$store.commit('reservation/setSelectedFilter', 'custom');
    },
    onScrollUnpackage: function onScrollUnpackage(event) {
      var scrollAndView = event.target.scrollTop + event.target.offsetHeight;
      if (event.target.scrollHeight - scrollAndView < 150) {
        if (this.$refs.routingRsvpTable.onScroll()) {
          this.$refs.routingRsvpTable.onScroll();
        }
      }
    },
    onScrollPackage: function onScrollPackage(event) {
      var scrollAndView = event.target.scrollTop + event.target.offsetHeight;
      if (event.target.scrollHeight - scrollAndView < 150) {
        if (this.$refs.routingPkgTable.onScroll()) {
          this.$refs.routingPkgTable.onScroll();
        }
      }
    },
    shrinkTable: function shrinkTable() {
      this.isShrink = true;
      if (this.$refs.hereMap.resizeMap()) {
        this.$refs.hereMap.resizeMap();
      }
    },
    total: function total() {
      switch (this.tabIndex) {
        case 0:
          return this.$store.state.dispatch.totalItem;
        case 1:
          return this.$store.state.routing.totalItem.pkg;
        case 2:
          return this.$store.state.routing.totalItem.rsvp;
        case 3:
          return this.$store.state.runs.list.length;
      }
      return 0;
    },
    hideMap: function hideMap() {
      var self = this;
      self.$store.commit('dispatch/removeRsvpInMap');
    },
    setScreenSize: function setScreenSize() {
      var self = this;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        self.isMobile = true;
      } else {
        self.isMobile = false;
      }
    },
    checkAvailableDrivers: function checkAvailableDrivers(data) {
      // if (!data.id) return
      // if (data.status !== 'UPCOMING' && data.status !== 'REQUIRES DISPATCH') return

      // let self = this
      // if (self.rsvpAvailabilityLoading) return
      // self.rsvpAvailabilityLoading = true

      // let since = moment(data.pickupTime, 'MM/DD/YYYY hh:mmA').format('X')
      // let until = moment(data.pickupTime, 'MM/DD/YYYY hh:mmA').add(data.etaInSec, 'seconds').format('X')
      // if (data.lastDropoff) {
      //   until = moment(data.lastDropoff, 'MM/DD/YYYY hh:mmA').format('X')
      // }
      // self.$sdk.get('/shifts/dashboard', {
      //   token: self.$store.state.session.sessionToken,
      //   assignments: 0,
      //   order: 'startShift',
      //   orderAsc: 1,
      //   pageNum: 1,
      //   sectorId: 0,
      //   serviceTypeId: data.serviceId,
      //   since: since,
      //   until: until
      // }, res => {
      //   self.availability.show = true
      //   self.rsvpAvailabilityLoading = false
      //   if (res.error) {
      //     return
      //   }
      //   let drivers = []
      //   res.list.forEach(driver => {
      //     let name = driver.businessName || `${driver.firstName} ${driver.lastName}`
      //     let availableFrom = ''
      //     let availableUntil = ''
      //     if (driver.startTimestamp) {
      //       let sinceTime = moment(since, 'X').format(ft.timeFormat(self, false))
      //       // availableFrom = moment(driver.startTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY') + ' ' + sinceTime
      //       availableFrom = moment(driver.startTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + ft.timeFormat(self, false))
      //       availableUntil = moment(driver.endTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + ft.timeFormat(self, false))
      //     }
      //     drivers.push({
      //       id: driver.ID,
      //       name: name,
      //       firstName: driver.firstName,
      //       lastName: driver.lastName,
      //       licenseType: driver.accountType,
      //       homeSector: driver.homeSectorName || '',
      //       availableFrom: availableFrom,
      //       availableUntil: availableUntil,
      //       mobile: driver.phoneNumber || '',
      //     })
      //   })
      //   self.$store.commit('dispatch/setAvailableDriversData', {list: drivers})
      // })
    },
    activeTabLabel: function activeTabLabel(x) {
      switch (x) {
        case 0:
          return 'dispatch';
        case 1:
          return 'routedPackages';
        case 2:
          return 'unroutedPackages';
        case 3:
          return 'runs';
      }
    }
  },
  watch: {
    selectedFilter: function selectedFilter(value) {
      this.showFilter = value === 'custom';
    },
    tabIndex: function tabIndex(value) {
      this.$store.commit('dispatch/setCurrentTable', value);
      if (value === 0) {
        this.availability.showToggle = ['UPCOMING', 'REQUIRES DISPATCH'].indexOf(this.rsvpInMap.status) > -1;
      }
      if (value === 3) {
        // && (!this.runs.since || !this.runs.until)
        if (this.$refs.runsTableFilter.loadList()) {
          this.$refs.runsTableFilter.loadList();
        }
        // this.availability.showToggle = this.$store.state.runs.selected.length > 0
      }
      this.$store.commit('dispatch/setTabActiveData', { rsvp: this.activeTabLabel(value) });
      this.$store.commit('dispatch/removeRsvpInMap');
      this.$store.commit('dispatch/setNoSector', false);
      this.$store.commit('runs/setOtherData', { runsInMap: [] });
    },
    rsvpInMap: function rsvpInMap(value) {
      if (value.id === null) {
        this.rsvp = null;
        return;
      }
      this.rsvp = value;
      if (value.status !== 'UPCOMING' && value.status !== 'REQUIRES DISPATCH') {
        return;
      }

      /* Show Available drivers */
      // let now = moment()
      // let pickupTime = moment(value.pickupTime, 'MM/DD/YYYY hh:mmA')
      // let diff = pickupTime.diff(now, 'minute')
      // let limit = parseInt(this.$settings.get('findNearbyDriverLimit'))
      // if (diff > limit) {
      //   this.showDriverPanel = true
      // }
    },
    showDriverPanel: function showDriverPanel(val) {
      this.$store.commit('dispatch/setDriverPanelOpen', val);
    }
  },
  mounted: function mounted() {
    this.setScreenSize();
  }
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvailableDrivers_vue__ = __webpack_require__(435);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2954aa28_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvailableDrivers_vue__ = __webpack_require__(1248);
function injectStyle (ssrContext) {
  __webpack_require__(1218)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2954aa28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvailableDrivers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2954aa28_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvailableDrivers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_dispatch_drivers__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DriverAvailability__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DriverControls__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DriverListFilters__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DriverTable__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StagingDrivers__ = __webpack_require__(1238);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'available-drivers',
  components: { DriverAvailability: __WEBPACK_IMPORTED_MODULE_2__DriverAvailability__["a" /* default */], DriverControls: __WEBPACK_IMPORTED_MODULE_3__DriverControls__["a" /* default */], DriverListFilters: __WEBPACK_IMPORTED_MODULE_4__DriverListFilters__["a" /* default */], DriverTable: __WEBPACK_IMPORTED_MODULE_5__DriverTable__["a" /* default */], StagingDrivers: __WEBPACK_IMPORTED_MODULE_6__StagingDrivers__["a" /* default */] },
  props: ['tabIndex'],
  computed: {
    currentDispatchTab: function currentDispatchTab() {
      return this.$store.state.dispatch.currentTable;
    },
    rsvpInMap: function rsvpInMap() {
      return this.$store.state.dispatch.rsvpInMap;
    },

    activeTab: {
      get: function get() {
        return this.$store.state.dispatch.driverListTabIndex;
      },
      set: function set(value) {
        // if (value === 0) {
        //   if (this.$refs.onDuty.loadPage()) {
        //     this.$refs.onDuty.loadPage()
        //   }
        // }
        // if (value === 2) {
        //   if (this.$refs.offDuty.loadPage()) {
        //     this.$refs.offDuty.loadPage()
        //   }
        // }
        this.$store.commit('dispatch/setDriverListTabIndex', value);
      }
    },
    reloadDrivers: function reloadDrivers() {
      return this.$store.state.dispatch.reloadDrivers;
    }
  },
  methods: {
    checkDriverTab: function checkDriverTab() {
      if (this.activeTab === 3) {
        if (this.$refs.driverAvailability) {
          this.$refs.driverAvailability.checkRunAvailability();
        }
      }
    },
    activeTabLabel: function activeTabLabel(x) {
      switch (x) {
        case 0:
          return 'onDuty';
        case 1:
          return 'staging';
        case 2:
          return 'offDuty';
        case 3:
          return 'availability';
      }
    }
  },
  watch: {
    rsvpInMap: function rsvpInMap(value) {
      if (value.id === null) {
        return;
      }
      if (value.status !== 'UPCOMING' && value.status !== 'REQUIRES DISPATCH') {
        return;
      }
      var now = __WEBPACK_IMPORTED_MODULE_0_moment___default()();
      var pickupTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value.pickupTime, 'MM/DD/YYYY hh:mmA');
      var diff = pickupTime.diff(now, 'minute');
      var limit = parseInt(this.$settings.get('findNearbyDriverLimit'));
      if (diff > limit) {
        this.$store.commit('dispatch/setDriverListTabIndex', 3);
      }
      if (this.activeTab == 3) {
        if (this.$refs.driverAvailability) {
          this.$refs.driverAvailability.checkAvailability();
        }
      }
    },
    reloadDrivers: function reloadDrivers(value) {
      if (value) {
        this.$store.commit('dispatch/setReloadDrivers', false);
        if (this.$refs.onDuty.loadPage()) {
          this.$refs.onDuty.loadPage();
        }
        if (this.$refs.offDuty.loadPage()) {
          this.$refs.offDuty.loadPage();
        }
      }
    },
    activeTab: function activeTab(x) {
      // if (x == 3) {
      //   if (this.$refs.driverAvailability) {
      //     this.$refs.driverAvailability.checkAvailability()
      //   }
      // }
      this.$store.commit('dispatch/setTabActiveData', { driver: this.activeTabLabel(x) });
    }
  },
  mounted: function mounted() {
    // let self = this
    // ApiDispatchDrivers.getOnDutyDrivers(self)
    // ApiDispatchDrivers.getOffDutyDrivers(self)
  }
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'driver-availability',
  data: function data() {
    return {
      isLoading: false,
      isError: false,
      sectorName: '',
      drivers: {
        home: [],
        work: []
      }
    };
  },

  computed: {
    dispatch: function dispatch() {
      return this.$store.state.dispatch;
    },
    rsvpInMap: function rsvpInMap() {
      return this.dispatch.rsvpInMap;
    },

    selectedDriver: {
      get: function get() {
        return this.dispatch.selectedDriver;
      },
      set: function set(value) {
        this.$store.commit('dispatch/setSelectedDriver', value);
      }
    },
    tabActive: function tabActive() {
      return this.dispatch.tabActive;
    },
    runsStore: function runsStore() {
      return this.$store.state.runs;
    },
    _runsCheckId: function _runsCheckId() {
      return this.runsStore.driverAvailability.checkId;
    },
    runsInMap: function runsInMap() {
      return this.runsStore.other.runsInMap;
    },
    noSector: function noSector() {
      return this.dispatch.noSector;
    },
    unavailableDrivers: function unavailableDrivers() {
      return this.dispatch.unavailableDrivers;
    }
  },
  methods: {
    getRsvpInfo: function getRsvpInfo() {
      var self = this;
      self.isLoading = true;
      self.isError = false;
      var rsvp = self.rsvpInMap;
      var url = '/admin/rsvp/' + rsvp.id;
      if (rsvp.isPackage) {
        url = '/admin/package/' + rsvp.id;
      }
      self.$sdk.get(url, {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.isLoading = false;
        if (r.error) {
          self.isError = true;
          return;
        }

        if (!r.pickupSector) {
          self.$store.commit('dispatch/setNoSector', true);
          return;
        }
        self.$store.commit('dispatch/setNoSector', false);

        var pickupTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(rsvp.pickupTime, 'MM/DD/YYYY hh:mmA');
        self.sectorName = r.pickupSector.name;
        var pickupTimePlusETA = pickupTime.add(r.etaInSec, 'seconds');
        self.getCoverageInfo(r.pickupSector.ID, self.rsvpInMap.serviceId, pickupTime, pickupTimePlusETA);
        // self.getCoverageInfo(r.pickupSector.ID, pickupTime)
      });
    },
    formatShiftTimes: function formatShiftTimes(times) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(times, 'X').format('MM/DD hh:mmA');
    },
    getCoverageInfo: function getCoverageInfo(sectorId, serviceTypeId, pickupTime, pickupTimePlusETA) {
      var self = this;
      self.isLoading = true;
      self.isError = false;
      self.drivers = {
        home: [],
        work: []
      };
      self.$sdk.get('/sectors/' + sectorId + '/coverage', {
        token: self.$store.state.session.sessionToken,
        start: pickupTime.format('YYYY-MM-DD'),
        end: pickupTime.format('YYYY-MM-DD')
      }, function (r) {
        self.isLoading = false;
        if (r.error) {
          self.isError = true;
          return;
        }

        self.getUnavailableDrivers(r, serviceTypeId, pickupTime, pickupTimePlusETA);
        // self.getDrivers(r)
      });
    },
    getShiftState: function getShiftState(driver) {
      var self = this;
      var rsvp = self.rsvpInMap;
      var rsvpStart = __WEBPACK_IMPORTED_MODULE_0_moment___default()(rsvp.pickupTime, 'MM/DD/YYYY hh:mmA').format('X');
      var rsvpEnd = __WEBPACK_IMPORTED_MODULE_0_moment___default()(rsvp.pickupTime, 'MM/DD/YYYY hh:mmA').add(rsvp.etaInSec, 'seconds').format('X');
      var shiftStart = driver.shiftStart;
      var shiftEnd = driver.shiftEnd;

      // completely encompass trip
      if (rsvpStart >= shiftStart && rsvpStart <= shiftEnd && rsvpEnd >= shiftStart && rsvpEnd <= shiftEnd) {
        return 'success';
      }

      // partially encompass trip
      if (shiftStart >= rsvpStart && shiftStart <= rsvpEnd || shiftEnd >= rsvpStart && shiftEnd <= rsvpEnd) {
        return 'warning';
      }

      // outside the shift
      return 'error';
    },
    getDrivers: function getDrivers(sector) {
      var self = this;
      var ids = [];
      for (var i = 0; i < sector.driverWork.length; i++) {
        ids.push(sector.driverWork[i].driverId);
      }
      for (var _i = 0; _i < sector.driverHome.length; _i++) {
        var id = sector.driverHome[_i].driverId;
        if (ids.indexOf(id) >= 0) {
          continue;
        }
        ids.push(id);
      }
      self.isLoading = true;
      self.$sdk.get('/provider', {
        token: self.$store.state.session.sessionToken,
        ids: ids
      }, function (r) {
        self.isLoading = false;
        if (r.error) {
          return;
        }

        for (var _i2 = 0; _i2 < sector.driverWork.length; _i2++) {
          var driver = sector.driverWork[_i2];
          if (!self.doesDriverHaveValidServiceType(driver)) {
            continue;
          }
          var info = self.getDriver(driver.driverId, r.list);
          driver['rsvp'] = info === null ? null : info.rsvp;
          driver['shiftState'] = self.getShiftState(driver);
          self.drivers.work.push(driver);
        }

        if (self.drivers.work.length > 0) {
          var compare = function compare(a, b) {
            if (a.shiftState === 'success') {
              return -1;
            }
            if (b.shiftState === 'success') {
              return 1;
            }
            if (a.shiftState === 'warning' && b.shiftState === 'error') {
              return -1;
            }
            if (a.shiftState === 'error' && b.shiftState === 'warning') {
              return 1;
            }
            return 0;
          };
          self.drivers.work.sort(compare);
        }

        for (var _i3 = 0; _i3 < sector.driverHome.length; _i3++) {
          var _driver = sector.driverHome[_i3];
          if (self.doesDriverHaveShift(_driver.driverId)) {
            continue;
          }
          if (!self.doesDriverHaveValidServiceType(_driver)) {
            continue;
          }
          var _info = self.getDriver(_driver.driverId, r.list);
          _driver['rsvp'] = _info === null ? null : _info.rsvp;
          self.drivers.home.push(_driver);
        }
      });
    },
    doesDriverHaveValidServiceType: function doesDriverHaveValidServiceType(driver) {
      var self = this;
      if (self.dispatch.tabActive.rsvp === 'runs') {
        return driver.services.indexOf(self.runsStore.driverAvailability.rsvpData.service.id) >= 0;
      }
      return driver.services && driver.services.indexOf(self.rsvpInMap.serviceId) >= 0;
    },
    doesDriverHaveShift: function doesDriverHaveShift(driverId) {
      var self = this;
      for (var i = 0; i < self.drivers.work.length; i++) {
        var driver = self.drivers.work[i];
        if (driver.driverId === driverId) {
          return true;
        }
      }
      return false;
    },
    getDriver: function getDriver(id, list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].ID === id) {
          return list[i];
        }
      }
      return null;
    },
    checkAvailability: function checkAvailability() {
      if (this.rsvpInMap.id) {
        this.getRsvpInfo();
      }
    },
    checkRunAvailability: function checkRunAvailability(id) {
      var self = this;
      var driverAvailability = self.runsStore.driverAvailability;
      // if (driverAvailability.lastCheckId === driverAvailability.checkId) return

      self.isLoading = true;
      self.isError = false;
      self.$sdk.get('/admin/rsvp/' + id, {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.isLoading = false;
        if (r.error) {
          self.isError = true;
          return;
        }
        if (!r.pickupSector) {
          self.$store.commit('dispatch/setNoSector', true);
          return;
        }
        self.$store.commit('dispatch/setNoSector', false);

        var pickupTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(driverAvailability.rsvpData.pickupDate, 'MM/DD/YYYY hh:mmA');
        self.sectorName = r.pickupSector.name;
        var pickupTimePlusETA = pickupTime.add(r.etaInSec, 'seconds');
        self.getCoverageInfo(r.pickupSector.ID, driverAvailability.rsvpData.service.id, pickupTime, pickupTimePlusETA);
      });
    },
    getUnavailableDrivers: function getUnavailableDrivers(data, serviceTypeId, pickupTime, pickupTimePlusETA) {
      var self = this;
      self.$store.commit('dispatch/setAvailableDriversData', { loading: true });
      self.$sdk.get('/shifts/unavailable', {
        token: self.$store.state.session.sessionToken,
        serviceTypeId: serviceTypeId,
        since: pickupTime.format('X'),
        until: pickupTimePlusETA.format('X')
      }, function (r) {
        var list = [];
        if (!r.error) {
          r.list.forEach(function (driver) {
            list.push({
              id: driver.ID,
              firstName: driver.firstName,
              lastName: driver.lastName,
              mobile: driver.displayPhone
              // mobile: driver.phone.number,
              // countryCode: driver.phone.countryCode
            });
          });
        }
        self.$store.commit('dispatch/setUnavailableDriversData', {
          loading: false,
          list: list
        });
        self.getDrivers(data);
      });
    }
  },
  watch: {
    rsvpInMap: function rsvpInMap(value) {
      if (value.id === null) {
        return;
      }
      // let self = this
      // self.getRsvpInfo()
    },
    runsInMap: function runsInMap(x) {
      var _this = this;

      if (x) {
        if (x.length !== 1) {
          this.drivers = {
            home: [],
            work: []
          };
          this.$store.commit('runs/setDriverAvailabilityData', {
            lastCheckId: '',
            checkId: ''
          });
          return;
        } else {
          var i = this.runsStore.list.findIndex(function (n) {
            return n.id === x[0];
          });
          if (i > -1) {
            this.$store.commit('runs/setDriverAvailabilityData', {
              checkId: this.runsStore.list[i].rsvpIDs[0],
              rsvpData: this.runsStore.list[i].rsvps.find(function (n) {
                return n.id === _this.runsStore.list[i].rsvpIDs[0];
              })
            });
          }
        }
      }
    },
    _runsCheckId: function _runsCheckId(x) {
      if (x) {
        this.checkRunAvailability(x);
      }
    }
  }
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverControls_vue__ = __webpack_require__(438);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_461a91ea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverControls_vue__ = __webpack_require__(1226);
function injectStyle (ssrContext) {
  __webpack_require__(1224)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-461a91ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverControls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_461a91ea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverControls_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'driver-controls',
  props: ['tabIndex', 'table'],
  data: function data() {
    return {
      scheduleTimer: '',
      runningSchedule: false,
      backup: [],
      modal: {
        show: false,
        option: 'default',
        custom: 60,
        target: 'dispatch'
      }
    };
  },

  computed: {
    dispatch: function dispatch() {
      return this.$store.state.dispatch;
    },
    currentDispatchTab: function currentDispatchTab() {
      return this.dispatch.currentTable;
    },
    scheduleLoading: function scheduleLoading() {
      return this.dispatch.schedule.loading;
    },
    runs: function runs() {
      return this.$store.state.runs;
    },
    rsvpInTable: function rsvpInTable() {
      return this.dispatch.rsvpInTable;
    },
    venue: function venue() {
      return this.dispatch.venue;
    }
  },
  methods: {
    isOnDuty: function isOnDuty(driverId) {
      var self = this;
      var onDutyDrivers = self.$store.state.dispatch.onDuty.drivers;
      return onDutyDrivers.filter(function (onDuty) {
        return onDuty.id === driverId;
      }).length === 1;
    },
    isStatusValid: function isStatusValid(items) {
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (item.status === 'complete' || item.status === 'completed' || item.status === 'canceled' || item.status === 'onboard' || item.status === 'dispatched') {
          return false;
        }
      }
      return true;
    },
    confirmSendToDriver: function confirmSendToDriver() {
      var self = this;
      var rsvps = self.$store.state.dispatch.checkedReservations;
      if (self.currentDispatchTab === 3) {
        // self.sendRunToDriver()
        // self.modal.option = 'custom'
        // self.modal.option = 'default'
        // self.modal.show = true
        // self.modal.target = 'runs'
        self.confirmSendRunToDriver();
        return;
      }
      if (self.$store.state.routing.packages.checkedForDispatch.length > 0) {
        rsvps = [];
        rsvps.push({
          isPackage: true,
          id: self.$store.state.routing.packages.checkedForDispatch[0]
        });
      }
      var driverId = self.$store.state.dispatch.selectedDriver;
      if (self.table === 'rsvpAvailableDrivers') {
        driverId = self.$store.state.dispatch.availableDrivers.selected;
      }

      if (driverId === null || rsvps.length <= 0 || rsvps.length > 1) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 driver and only 1 reservation/package to proceed.'
        });
        return;
      }

      /*
      if (!self.isOnDuty(driverId)) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You can only send reservations/pacakges to on-duty drivers.'
        })
        return
      }
      */

      if (!self.isStatusValid(rsvps)) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You can only send Upcoming, Requires Dispatch and Ready to Go reservations/packages to drivers.'
        });
        return;
      }
      this.modal.option = 'custom';
      this.modal.option = 'default';
      this.modal.show = true;
      this.modal.target = 'dispatch';
    },
    _sendToDriver: function _sendToDriver() {
      this.modal.show = false;
      if (this.modal.target === 'dispatch') {
        this.sendToDriver();
      } else {
        this.sendRunToDriver();
      }
    },
    sendToDriver: function sendToDriver() {
      var self = this;
      var rsvps = self.$store.state.dispatch.checkedReservations;
      if (self.tabIndex === 1) {
        rsvps = [{
          isPackage: true,
          id: this.$store.state.routing.packages.checkedForDispatch
        }];
      }
      var driverId = self.$store.state.dispatch.selectedDriver;
      if (self.table === 'rsvpAvailableDrivers') {
        driverId = self.$store.state.dispatch.availableDrivers.selected;
      }
      var rsvp = rsvps[0];

      var url = '/admin/rsvp/';
      if (rsvp && rsvp.isPackage) {
        url = '/admin/package/';
      }
      self.$store.commit('dispatch/showActionModal', 'Sending' + (rsvp.isPackage ? ' package ' : ' reservation ') + 'to driver...');

      var customRequestTimeout = self.$settings.get('RunNewdispatchTimer');
      if (self.modal.option === 'custom') customRequestTimeout = self.modal.custom;
      self.$sdk.post(url + rsvp.id + '/send', {
        token: self.$store.state.session.sessionToken,
        provId: driverId,
        customRequestTimeout: customRequestTimeout
      }, function (r) {
        if (r.error) {
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong. Try again later.'
          });
        } else {
          if (self.currentDispatchTab == 1) {
            self.$store.commit('routing/setPendingOffer', {
              id: rsvp.id[0],
              show: true,
              timer: parseInt(customRequestTimeout) + 10
            });
          } else {
            self.$store.commit('dispatch/setPendingOffer', {
              id: rsvp.id,
              show: true,
              timer: parseInt(customRequestTimeout) + 10
            });
          }

          // self.$store.commit('routing/setPendingOffer', {
          //   id: self.currentDispatchTab == 1 ? rsvp.id[0] : rsvp.id,
          //   show: true,
          //   timer: parseInt(customRequestTimeout) + 10
          // })
          // self.$store.commit('dispatch/removeRsvpInTable', rsvp)
          self.$store.commit('dispatch/setSelectedDriver', null);
          self.$store.commit('dispatch/completeActionModal', {
            success: true,
            message: 'Successfully sent reservation.'
          });
        }
      });
    },
    confirmSendRunToDriver: function confirmSendRunToDriver() {
      var self = this;
      var driverId = self.$store.state.dispatch.selectedDriver;

      if (driverId === null || !self.runs.selected) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 driver and only 1 run item to proceed.'
        });
        return;
      }

      self.modal.option = 'custom';
      self.modal.option = 'default';
      self.modal.show = true;
      self.modal.target = 'runs';
    },
    sendRunToDriver: function sendRunToDriver() {
      var self = this;
      var driverId = self.$store.state.dispatch.selectedDriver;
      if (self.table === 'rsvpAvailableDrivers') {
        driverId = self.$store.state.dispatch.availableDrivers.selected;
      }

      if (driverId === null || !self.runs.selected) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 driver and only 1 run item to proceed.'
        });
        return;
      }
      self.$store.commit('dispatch/showActionModal', 'Sending run to driver...');

      var customRequestTimeout = self.$settings.get('RunNewdispatchTimer');
      if (self.modal.option === 'custom') customRequestTimeout = self.modal.custom;
      self.$sdk.post('/runs/send', {
        runId: self.runs.selected,
        providerId: driverId,
        token: self.$store.state.session.sessionToken,
        customRequestTimeout: customRequestTimeout
      }, function (r) {
        if (r.error) {
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong. Try again later.'
          });
        } else {
          var rsvpIDs = [];
          var runIndex = self.runs.list.findIndex(function (x) {
            return x.id === self.runs.selected;
          });
          if (runIndex > -1) {
            rsvpIDs = self.runs.list[runIndex].rsvpIDs;
          }
          self.checkRunStatus(self.runs.selected, rsvpIDs, customRequestTimeout);
          self.$store.commit('runs/removeRunInTable', self.runs.selected);
          self.$store.commit('runs/addBlackList', self.runs.selected);
          self.$store.commit('runs/setRunsDetails', { selected: [] });
          self.$store.commit('dispatch/setSelectedDriver', null);
          self.$store.commit('dispatch/completeActionModal', {
            success: true,
            message: 'Successfully sent run.'
          });
        }
        self.$store.commit('runs/setRunsDetails', { refresh: true });
        setTimeout(function () {
          self.$store.commit('dispatch/closeActionModal');
        }, 3000);
      }, '2.0');
    },
    sendAsSchedule: function sendAsSchedule() {
      var self = this;
      var dispatch = self.$store.state.dispatch;
      var routing = self.$store.state.routing;

      var rsvps = [];
      var pkgs = [];
      var driverId = dispatch.selectedDriver;
      if (self.table === 'rsvpAvailableDrivers') {
        driverId = dispatch.availableDrivers.selected;
      }
      var notAllowed = false;

      // Dispatch table
      if (self.currentDispatchTab === 0) {
        if (dispatch.checkedReservations.length) {
          dispatch.checkedReservations.forEach(function (data) {
            if (['upcoming', 'requires-dispatch'].indexOf(data.status) < 0) {
              notAllowed = true;
              return false;
            }
            if (data.isPackage) {
              pkgs.push(data.id);
            } else {
              rsvps.push(data.id);
            }
          });
        }
      }

      // Routing table - Packages
      if (self.currentDispatchTab === 1) {
        pkgs = routing.packages.checkedForDispatch;
        routing.packages.items.forEach(function (data) {
          if (pkgs.indexOf(data.id) > -1 && ['upcoming', 'requires-dispatch'].indexOf(data.statusClass) < 0) {
            notAllowed = true;
          }
        });
      }

      // Routing table - Unpackages
      if (self.currentDispatchTab === 2) {
        rsvps = routing.reservations.checked;
        routing.reservations.items.forEach(function (data) {
          if (rsvps.indexOf(data.id) > -1 && ['upcoming', 'requires-dispatch'].indexOf(data.statusClass) < 0) {
            notAllowed = true;
          }
        });
      }

      if (notAllowed) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Not Allowed',
          message: 'Only UPCOMING and REQUIRES DISPATCH reservations/packages are allowed to be schedule.'
        });
        return;
      }

      var totalSelected = rsvps.length + pkgs.length;
      if (driverId === null || totalSelected <= 1) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 driver and at least 2 reservations/packages to proceed.'
        });
        return;
      }

      self.scheduleTimer = '';
      self.runningSchedule = false;
      self.$store.commit('dispatch/setScheduleAccepted', false);
      self.$store.commit('dispatch/setScheduleShow', true);
      self.$store.commit('dispatch/setScheduleLoading', true);
      self.$store.commit('dispatch/setScheduleLoadingMsg', 'Setting schedule. Please wait...');

      self.$store.commit('dispatch/setScheduleRsvp', rsvps);
      self.$store.commit('dispatch/setSchedulePkg', pkgs);
      var driverList = 'onDuty';
      if (self.$store.state.dispatch.driverListTabIndex === 1) {
        driverList = 'staging';
      }
      if (self.$store.state.dispatch.driverListTabIndex === 2) {
        driverList = 'offDuty';
      }
      var driverIndex = self.$store.state.dispatch[driverList].drivers.findIndex(function (x) {
        return x.id === driverId;
      });
      var driver = self.$store.state.dispatch[driverList].drivers[driverIndex];
      self.$store.commit('dispatch/setScheduleDriverData', {
        id: driverId,
        name: '' // driver.firstName + ' ' + driver.lastName
      });

      self.backup = [];
      self.backup = self.$store.state.dispatch.rsvpInTable;

      dispatch.checkedReservations.forEach(function (data) {
        self.$store.commit('dispatch/removeRsvpInTable', data);
      });

      self.$sdk.post('/admin/schedule/', {
        token: self.$store.state.session.sessionToken,
        provID: driverId,
        reservationIDs: rsvps,
        packageIDs: pkgs
      }, function (r) {
        self.$store.commit('dispatch/setScheduleLoading', false);
        if (r.error) {
          // self.$store.commit('dispatch/setScheduleShow', false)
          // self.$store.commit('dispatch/showValidationModal', {
          //   title: 'Oops. Something went wrong.',
          //   message: r.error.message
          // })

          self.$store.commit('dispatch/setScheduleError', r.error.message);
          self.$store.commit('dispatch/setRsvpInTable', self.backup);
          return;
        }

        self.runningSchedule = true;
        self.scheduleTimer = setTimeout(function () {
          self.runningSchedule = false;
          if (!self.$store.state.dispatch.schedule.accepted) {
            self.$store.commit('dispatch/setScheduleShow', false);
            // self.$store.commit('dispatch/showValidationModal', {
            //   title: 'Failed',
            //   message: 'The Driver seems to be busy at the moment. Try again later.'
            // })

            self.$store.commit('dispatch/showDispatchAcceptNotification', {
              show: true,
              accept: false,
              isPackage: false,
              id: null,
              driverId: null,
              driverName: '',
              isSendAsSchedule: true,
              sendAsScheduleError: 'The Driver seems to be busy at the moment. Try again later.',
              runsDeclined: false
            });
          }
        }, 180000); // 3 mins
        self.getSchedule(r);
      });
    },
    getSchedule: function getSchedule(data) {
      var self = this;
      self.$store.commit('dispatch/setScheduleLoading', true);
      self.$store.commit('dispatch/setScheduleLoadingMsg', 'Pending Driver. Please wait...');
      self.$store.commit('dispatch/setScheduleShow', false); // Hide Modal Early

      self.$sdk.get('/admin/schedule/' + data.id, {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          self.$store.commit('dispatch/setScheduleShow', false);
          self.$store.commit('dispatch/showValidationModal', {
            title: 'Oops. Something went wrong.',
            message: r.error.message
          });

          self.runningSchedule = false;
          if (self.scheduleTimer) {
            clearTimeout(self.scheduleTimer);
          }
          return;
        }

        var scheduleStore = self.$store.state.dispatch.schedule;
        if (r.status === 'pending') {
          if (self.runningSchedule) {
            setTimeout(function () {
              self.getSchedule(data);
            }, 5000);
          }
        } else if (r.status === 'accepted') {
          self.runningSchedule = false;
          if (self.scheduleTimer) {
            clearTimeout(self.scheduleTimer);
          }
          self.$store.commit('dispatch/setScheduleLoading', false);
          self.$store.commit('dispatch/setScheduleAccepted', true);

          self.$store.commit('dispatch/showDispatchAcceptNotification', {
            show: true,
            accept: true,
            isPackage: false,
            id: null,
            driverId: scheduleStore.driverData.id,
            driverName: scheduleStore.driverData.name,
            isSendAsSchedule: true,
            sendAsScheduleError: '',
            runsDeclined: false
          });
        } else if (r.status === 'rejected') {
          self.runningSchedule = false;
          if (self.scheduleTimer) {
            clearTimeout(self.scheduleTimer);
          }
          self.$store.commit('dispatch/setScheduleShow', false);
          self.$store.commit('dispatch/setScheduleLoading', false);

          // self.$store.commit('dispatch/showValidationModal', {
          //   title: 'Rejected',
          //   message: 'Schedule reservation/package was rejected by the driver'
          // })

          self.$store.commit('dispatch/showDispatchAcceptNotification', {
            show: true,
            accept: false,
            isPackage: false,
            id: null,
            driverId: scheduleStore.driverData.id,
            driverName: scheduleStore.driverData.name,
            isSendAsSchedule: true,
            sendAsScheduleError: '',
            runsDeclined: false
          });
        }
      });
    },
    sendAsAsap: function sendAsAsap() {
      var self = this;
      var rsvps = self.$store.state.dispatch.checkedReservations;
      if (self.$store.state.routing.packages.checkedForDispatch.length > 0) {
        rsvps = [];
        rsvps.push({
          isPackage: true,
          id: self.$store.state.routing.packages.checkedForDispatch[0]
        });
      }
      var driverId = self.$store.state.dispatch.selectedDriver;
      if (self.table === 'rsvpAvailableDrivers') {
        driverId = self.$store.state.dispatch.availableDrivers.selected;
      }

      if (driverId === null || rsvps.length <= 0 || rsvps.length > 1) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 driver and only 1 reservation to proceed.'
        });
        return false;
      }

      if (!self.isOnDuty(driverId)) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You can only send reservations to on-duty drivers.'
        });
        return;
      }

      if (!self.isStatusValid(rsvps)) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You can only send Upcoming, Requires Dispatch and Ready to Go reservations/packages to drivers.'
        });
        return;
      }

      var rsvp = rsvps[0];

      var url = '/admin/rsvp/';
      if (rsvp.isPackage) {
        url = '/admin/package/';
      }
      self.$store.commit('dispatch/showActionModal', 'Sending' + (rsvp.isPackage ? ' package ' : ' reservation ') + 'to driver as asap...');

      var customRequestTimeout = self.$settings.get('RunNewdispatchTimer');
      self.$sdk.post(url + rsvp.id + '/send', { // /asap
        token: self.$store.state.session.sessionToken,
        provId: driverId,
        customRequestTimeout: customRequestTimeout
      }, function (r) {
        if (r.error) {
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong. Try again later.'
          });
        } else {
          if (self.currentDispatchTab == 1) {
            self.$store.commit('routing/setPendingOffer', {
              id: rsvp.id[0],
              show: true,
              timer: parseInt(customRequestTimeout) + 10
            });
          } else {
            self.$store.commit('dispatch/setPendingOffer', {
              id: rsvp.id,
              show: true,
              timer: parseInt(customRequestTimeout) + 10
            });
          }
          // self.$store.commit('dispatch/removeRsvpInTable', rsvp)
          self.$store.commit('dispatch/setSelectedDriver', null);
          self.$store.commit('dispatch/completeActionModal', {
            success: true,
            message: 'Successfully sent reservation as asap.'
          });
        }

        setTimeout(function () {
          self.$store.commit('dispatch/closeActionModal');
        }, 3000);
      });
    },
    assignToDriver: function assignToDriver() {
      var self = this;
      var rsvps = self.$store.state.dispatch.checkedReservations;
      var driverId = self.$store.state.dispatch.selectedDriver;
      if (self.table === 'rsvpAvailableDrivers') {
        driverId = self.$store.state.dispatch.availableDrivers.selected;
      }
      if (self.currentDispatchTab === 3) {
        self.assignRunToDriver();
        return;
      }
      if (self.$store.state.routing.packages.checkedForDispatch.length > 0) {
        rsvps = [];
        rsvps.push({
          isPackage: true,
          id: self.$store.state.routing.packages.checkedForDispatch[0]
        });
      }
      if (driverId === null || rsvps.length <= 0) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 driver and at least 1 reservation or package to proceed.'
        });
        return false;
      }

      // if (!self.isOnDuty(driverId)) {
      //   self.$store.commit('dispatch/showValidationModal', {
      //     title: 'Oops. You missed something.',
      //     message: 'You can only assign reservations and/or packages to on-duty drivers.'
      //   })
      //   return
      // }

      if (!self.isStatusValid(rsvps)) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You can only assign Upcoming, Requires Dispatch and Ready to Go reservations/packages to drivers.'
        });
        return;
      }

      var requests = self.getAssignRequest(rsvps);
      if (requests.length <= 0) {
        return;
      }

      self.$store.commit('dispatch/showActionModal', 'Assigning items to driver...');
      self.$sdk.post('/provider/' + driverId + '/assign', requests[0], function (r) {
        if (requests.length > 1) {
          self.$sdk.post('/provider/' + driverId + '/assign', requests[1], function (r) {
            if (r.results && Array.isArray(r.results) && r.results.length > 0 && r.results[0].error) {
              var error = r.results[0].error;
              console.log(r);
              self.$store.commit('dispatch/completeActionModal', {
                success: false,
                message: error.message ? error.message : 'Something went wrong.'
              });
            } else {
              self.$store.commit('dispatch/completeActionModal', {
                success: true,
                message: 'Successfully assigned items to driver.'
              });
            }
            setTimeout(function () {
              self.$store.commit('dispatch/closeActionModal');
            }, 3000);
          });
        } else {
          if (r.results && Array.isArray(r.results) && r.results.length > 0 && r.results[0].error) {
            var error = r.results[0].error;
            console.log(r);
            self.$store.commit('dispatch/completeActionModal', {
              success: false,
              message: error.message ? error.message : 'Something went wrong.'
            });
          } else {
            self.$store.commit('dispatch/completeActionModal', {
              success: true,
              message: 'Successfully assigned items to driver.'
            });
          }
          setTimeout(function () {
            self.$store.commit('dispatch/closeActionModal');
          }, 3000);
        }
      });
    },
    assignRunToDriver: function assignRunToDriver() {
      var self = this;
      var driverId = self.$store.state.dispatch.selectedDriver;
      if (self.table === 'rsvpAvailableDrivers') {
        driverId = self.$store.state.dispatch.availableDrivers.selected;
      }

      if (driverId === null || !self.runs.selected) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 driver and only 1 run item to proceed.'
        });
        return;
      }

      self.$store.commit('dispatch/showActionModal', 'Assigning items to driver...');
      self.startAssignRuns();
    },
    startAssignRuns: function startAssignRuns() {
      var self = this;
      var driverId = self.$store.state.dispatch.selectedDriver;
      if (self.table === 'rsvpAvailableDrivers') {
        driverId = self.$store.state.dispatch.availableDrivers.selected;
      }

      if (!self.runs.selected) {
        self.$store.commit('dispatch/completeActionModal', {
          success: true,
          message: 'Successfully assigned items to driver.'
        });
        self.$store.commit('runs/setRunsDetails', {
          refresh: true,
          selected: []
        });
        self.$store.commit('dispatch/setSelectedDriver', null);
        setTimeout(function () {
          self.$store.commit('dispatch/closeActionModal');
        }, 3000);
        return;
      }

      self.$sdk.post('/runs/assign', {
        runId: self.runs.selected,
        providerId: driverId,
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong.'
          });
          setTimeout(function () {
            self.$store.commit('dispatch/closeActionModal');
          }, 3000);
          return;
        }
        self.$store.commit('runs/addBlackList', self.runs.selected);
        // let temp = [...self.runs.selected]
        // temp.shift()
        self.$store.commit('runs/setRunsDetails', { selected: null });
        self.startAssignRuns();
      }, '2.0');
    },
    getAssignRequest: function getAssignRequest(items) {
      var self = this;

      var rsvpIds = [];
      var packageIds = [];
      for (var i = 0; i < items.length; i++) {
        if (items[i].isPackage) {
          packageIds.push(items[i].id);
          continue;
        }
        rsvpIds.push(items[i].id);
      }

      var token = self.$store.state.session.sessionToken;

      var results = [];
      if (rsvpIds.length > 0) {
        results.push({
          token: token,
          rsvpId: rsvpIds
        });
      }
      if (packageIds.length > 0) {
        results.push({
          token: token,
          packageId: packageIds
        });
      }
      return results;
    },
    close: function close() {
      this.modal.show = false;
    },
    moveToPool: function moveToPool() {
      var self = this;

      if (!self.runs.selected) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 run item to proceed.'
        });
        return;
      }

      self.$store.commit('dispatch/showActionModal', 'Moving run to pool...');
      self.startMoveToPool();
    },
    startMoveToPool: function startMoveToPool() {
      var self = this;

      self.$sdk.post('/runs/pool/move', {
        runId: [self.runs.selected],
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong.'
          });
          setTimeout(function () {
            self.$store.commit('dispatch/closeActionModal');
          }, 3000);
          return;
        }
        self.$store.commit('dispatch/completeActionModal', {
          success: true,
          message: 'Successfully move run to pool.'
        });
        setTimeout(function () {
          self.$store.commit('dispatch/closeActionModal');
        }, 2500);
      }, '2.0');
    },
    removeFromPool: function removeFromPool() {
      var self = this;

      if (!self.runs.selected) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 run item to proceed.'
        });
        return;
      }

      self.$store.commit('dispatch/showActionModal', 'Moving run to pool...');
      self.startRemoveFromPool();
    },
    startRemoveFromPool: function startRemoveFromPool() {
      var self = this;

      self.$sdk.post('/runs/pool/remove', {
        runId: [self.runs.selected],
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong.'
          });
          setTimeout(function () {
            self.$store.commit('dispatch/closeActionModal');
          }, 3000);
          return;
        }
        self.$store.commit('dispatch/completeActionModal', {
          success: true,
          message: 'Successfully remove run from pool.'
        });
        setTimeout(function () {
          self.$store.commit('dispatch/closeActionModal');
        }, 2500);
      }, '2.0');
    },
    checkRunStatus: function checkRunStatus(id, rsvpIDs, time) {
      var self = this;

      setTimeout(function () {
        self.$sdk.get('/runs/get', {
          token: self.$store.state.session.sessionToken,
          runId: id
        }, function (res) {
          if (!res.error) {
            self.$store.commit('dispatch/showDispatchAcceptNotification', {
              show: true,
              accept: false,
              isPackage: false,
              id: id,
              driverId: '',
              driverName: '',
              isSendAsSchedule: false,
              sendAsScheduleError: rsvpIDs,
              runsDeclined: true
            });
          }
        }, '2.0');
      }, (time + 5) * 1000);
    },
    sendToLyft: function sendToLyft() {
      var _this = this;

      var self = this;
      var rsvps = self.$store.state.dispatch.checkedReservations;
      if (!rsvps.length) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 reservation to proceed.'
        });
        return;
      }
      if (rsvps.length > 1) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Only one reservation can be assigned to Lyft at a time.'
        });
        return;
      }
      if (!self.isStatusValid(rsvps)) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You can only send Upcoming, Requires Dispatch and Ready to Go reservations to Lyft.'
        });
        return;
      }

      self.$store.commit('global/setLoaderData', { show: true });
      self.$sdk.post('/admin/rsvp/' + rsvps[0].id + '/lyft/quote/all', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.$store.commit('global/setLoaderData', { show: false });
        if (r.error || !r.list.length) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error ? r.error.message : 'No Lyft service available at the moment'
          });
          return;
        }

        var selected = _this.rsvpInTable.find(function (x) {
          return x.id === rsvps[0].id;
        });
        self.$store.commit('dispatch/setLyftData', {
          show: true,
          services: r.list,
          originalFare: selected.totalFare ? parseFloat(selected.totalFare.toFixed(2)) : 0,
          originalService: selected.serviceType && selected.serviceType.label ? selected.serviceType.label : ''
        });
      }, '1.1');
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_services__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_dispatch_drivers__ = __webpack_require__(37);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'driver-list-filters',
  data: function data() {
    return {
      applyingFilters: false
    };
  },

  computed: {
    filterSearch: {
      get: function get() {
        return this.$store.state.dispatch.driverListFilters.search;
      },
      set: function set(value) {
        this.$store.commit('dispatch/setDriverListSearchFilter', value);
      }
    },
    filterServiceTypes: {
      get: function get() {
        return this.$store.state.dispatch.driverListFilters.serviceTypes;
      },
      set: function set(value) {
        this.$store.commit('dispatch/setDriverListServiceTypeFilter', value);
      }
    },
    serviceCount: function serviceCount() {
      return this.$store.state.dispatch.serviceCount;
    },
    useOldQuatation: function useOldQuatation() {
      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation;
    },
    _serviceFilterLoading: function _serviceFilterLoading() {
      return this.$store.state.dispatch.serviceFilter.loading;
    }
  },
  methods: {
    applyFilters: function applyFilters() {
      var self = this;
      self.applyingFilters = true;
      var openedDriverTable = self.$store.state.dispatch.driverListTabIndex;
      var pageNumberMutation = 'dispatch/setOnDutyPageNumber';
      if (openedDriverTable === 1) {
        pageNumberMutation = 'dispatch/setStagingPageNumber';
      }
      if (openedDriverTable === 2) {
        pageNumberMutation = 'dispatch/setOffDutyPageNumber';
      }
      // Reset everything to page 1
      self.$store.commit(pageNumberMutation, 1);

      // ApiDispatchDrivers.getDriverList(self, openedDriverTable === 0, openedDriverTable === 1, r => {
      // self.applyingFilters = false
      // if (r.error) {
      // console.log(r)
      // return
      // }
      // self.$plugins.smoothScroll.scrollTo(document.getElementById('driver-list-container'))

      // let mutation = 'dispatch/setOnDutyNoDriversFound'
      // if (openedDriverTable === 1) {
      // mutation = 'dispatch/setStagingNoDriversFound'
      // }
      // if (openedDriverTable === 2) {
      // mutation = 'dispatch/setOffDutyNoDriversFound'
      // }
      // self.$store.commit(mutation, r.list.length <= 0)
      // })
      var data = {
        onDuty: openedDriverTable === 0,
        isStaging: openedDriverTable === 1
      };
      __WEBPACK_IMPORTED_MODULE_1__modules_api_dispatch_drivers__["a" /* default */].getDriverListV2(self, data, function (r) {
        self.applyingFilters = false;
        if (r.error) {
          console.log(r);
          return;
        }
        self.$plugins.smoothScroll.scrollTo(document.getElementById('driver-list-container'));

        var mutation = 'dispatch/setOnDutyNoDriversFound';
        if (openedDriverTable === 1) {
          mutation = 'dispatch/setStagingNoDriversFound';
        }
        if (openedDriverTable === 2) {
          mutation = 'dispatch/setOffDutyNoDriversFound';
        }
        self.$store.commit(mutation, r.list.length <= 0);
      });
    },
    serviceLabel: function serviceLabel(code) {
      return __WEBPACK_IMPORTED_MODULE_0__modules_api_services__["a" /* default */].getServiceName(code);
    },
    showServiceFilterModal: function showServiceFilterModal() {
      this.$store.commit('dispatch/setServiceFilterShow', true);
    }
  },
  watch: {
    _serviceFilterLoading: function _serviceFilterLoading(value) {
      this.applyingFilters = value;
    }
  },
  mounted: function mounted() {
    // let self = this
    // self.$nextTick(() => {
    //   self.applyFilters()
    // })
  }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_LoadingAnimation_Ellipsis__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_dispatch_drivers__ = __webpack_require__(37);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'driver-table',
  props: ['onDuty', 'staging'],
  components: { EllipsisLoader: __WEBPACK_IMPORTED_MODULE_0__components_Partials_LoadingAnimation_Ellipsis__["a" /* default */] },
  data: function data() {
    return {
      isPageLoading: false,
      isLoadingNext: false,
      isLoadingBack: false,
      isSorting: false
    };
  },

  computed: {
    drivers: function drivers() {
      var self = this;
      if (self.onDuty) {
        if (self.staging) {
          return self.$store.state.dispatch.staging.drivers;
        }
        return self.$store.state.dispatch.onDuty.drivers;
      }
      // return off duty
      return self.$store.state.dispatch.offDuty.drivers;
    },
    isLoading: function isLoading() {
      var self = this;
      if (self.onDuty) {
        if (self.staging) {
          return self.$store.state.dispatch.staging.loading;
        }
        return self.$store.state.dispatch.onDuty.loading;
      }
      // return off duty
      return self.$store.state.dispatch.offDuty.loading;
    },
    noDriversFound: function noDriversFound() {
      var self = this;
      if (self.onDuty) {
        if (self.staging) {
          return self.$store.state.dispatch.staging.noDriversFound;
        }
        return self.$store.state.dispatch.onDuty.noDriversFound;
      }
      // return off duty
      return self.$store.state.dispatch.offDuty.noDriversFound;
    },
    driverIdsInMap: function driverIdsInMap() {
      return this.$store.state.dispatch.driverIdsInMap;
    },
    loadingDriverId: function loadingDriverId() {
      return this.$store.state.dispatch.loadingDriverId;
    },

    selectedDriver: {
      get: function get() {
        return this.$store.state.dispatch.selectedDriver;
      },
      set: function set(value) {
        this.$store.commit('dispatch/setSelectedDriver', value);
      }
    },
    totalPages: function totalPages() {
      var self = this;
      if (self.onDuty) {
        if (self.staging) {
          return self.$store.state.dispatch.staging.totalPages;
        }
        return self.$store.state.dispatch.onDuty.totalPages;
      }
      // return off duty
      return self.$store.state.dispatch.offDuty.totalPages;
    },

    currentPage: {
      get: function get() {
        var self = this;
        if (self.onDuty) {
          if (self.staging) {
            return self.$store.state.dispatch.staging.pageNum;
          }
          return self.$store.state.dispatch.onDuty.pageNum;
        }
        // return off duty
        return self.$store.state.dispatch.offDuty.pageNum;
      },
      set: function set(value) {
        var self = this;
        if (self.onDuty) {
          if (self.staging) {
            self.$store.commit('dispatch/setStagingPageNumber', value);
            return;
          }
          self.$store.commit('dispatch/setOnDutyPageNumber', value);
          return;
        }
        self.$store.commit('dispatch/setOffDutyPageNumber', value);
      }
    },
    driverSort: function driverSort() {
      var self = this;
      if (self.onDuty) {
        if (self.staging) {
          return {
            order: self.$store.state.dispatch.staging.order,
            asc: self.$store.state.dispatch.staging.asc
          };
        }
        return {
          order: self.$store.state.dispatch.onDuty.order,
          asc: self.$store.state.dispatch.onDuty.asc
        };
      }
      return {
        order: self.$store.state.dispatch.offDuty.order,
        asc: self.$store.state.dispatch.offDuty.asc
      };
    },
    useOldQuatation: function useOldQuatation() {
      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation;
    },
    driversTotal: function driversTotal() {
      var totalItem = this.$store.state.dispatch.totalDrivers;
      return this.onDuty ? totalItem.onDuty : totalItem.offDuty;
    }
  },
  methods: {
    callDriver: function callDriver(driver) {
      var self = this;
      self.$plugins.phone.startCall(self, {
        phone: driver.phone,
        name: driver.firstName + ' ' + driver.lastName
      });
    },
    showOnMap: function showOnMap(driver) {
      var self = this;
      var driverIdsInMap = self.$store.state.dispatch.driverIdsInMap;
      var driverIndex = driverIdsInMap.indexOf(driver.id);
      if (driverIndex >= 0) {
        self.$store.commit('dispatch/removeDriverInMap', driver);
        return;
      }

      self.$store.commit('dispatch/setLoadingDriverId', driver.id);
      __WEBPACK_IMPORTED_MODULE_1__modules_api_dispatch_drivers__["a" /* default */].getLocation(self, driver.id, function (r) {
        self.$store.commit('dispatch/setLoadingDriverId', null);
        if (r.error) {
          // TODO process error
          return;
        }

        if (r.list.length <= 0) {
          // TODO we cant find the driver
          return;
        }

        var coords = {
          lat: r.list[0].lat,
          lng: r.list[0].lng
        };
        driver.coords = coords;
        self.$store.commit('dispatch/addDriverInMap', driver);
      });

      setTimeout(function () {}, 1500);
    },
    pageBtn: function pageBtn(isNext) {
      var self = this;
      var pageChange = isNext ? 1 : -1;
      if (isNext) {
        self.isLoadingNext = true;
      } else {
        self.isLoadingBack = true;
      }
      if (self.onDuty) {
        if (self.staging) {
          self.$store.commit('dispatch/setStagingPageNumber', self.$store.state.dispatch.staging.pageNum + pageChange);
        } else {
          self.$store.commit('dispatch/setOnDutyPageNumber', self.$store.state.dispatch.onDuty.pageNum + pageChange);
        }
      } else {
        self.$store.commit('dispatch/setOffDutyPageNumber', self.$store.state.dispatch.offDuty.pageNum + pageChange);
      }
      self.loadPage();
    },
    loadPage: function loadPage() {
      var self = this;
      self.isPageLoading = true;
      if (!self.useOldQuatation) {
        var data = {
          onDuty: self.onDuty,
          isStaging: self.staging
        };
        __WEBPACK_IMPORTED_MODULE_1__modules_api_dispatch_drivers__["a" /* default */].getDriverListV2(self, data, function (r) {
          self.isPageLoading = false;
          self.isLoadingBack = false;
          self.isLoadingNext = false;

          if (r.error) {
            return;
          }
          self.$plugins.smoothScroll.scrollTo(document.getElementById('driver-list-container'));
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__modules_api_dispatch_drivers__["a" /* default */].getDriverList(self, self.onDuty, self.staging, function (r) {
          self.isPageLoading = false;
          self.isLoadingBack = false;
          self.isLoadingNext = false;

          if (r.error) {
            return;
          }

          self.$plugins.smoothScroll.scrollTo(document.getElementById('driver-list-container'));
        });
      }
    },
    sort: function sort(order) {
      var self = this;
      var existingOrder = self.driverSort.order;
      var existingAsc = self.driverSort.asc;

      var asc = true;
      if (order === existingOrder) {
        asc = !existingAsc;
      }

      var sortMutation = 'dispatch/setOnDutySorting';
      if (!self.onDuty) {
        sortMutation = 'dispatch/setOffDutySorting';
      }
      if (self.staging) {
        sortMutation = 'dispatch/setStagingSorting';
      }

      self.$store.commit(sortMutation, {
        order: order,
        asc: asc
      });

      self.isSorting = true;

      if (!self.useOldQuatation) {
        var data = {
          onDuty: self.onDuty,
          isStaging: self.staging
        };
        __WEBPACK_IMPORTED_MODULE_1__modules_api_dispatch_drivers__["a" /* default */].getDriverListV2(self, data, function (r) {
          self.isSorting = false;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__modules_api_dispatch_drivers__["a" /* default */].getDriverList(self, self.onDuty, self.staging, function (r) {
          self.isSorting = false;
        });
      }
    },
    driverPhoneDisplay: function driverPhoneDisplay(data) {
      if (!data.countryCode) return data.phone;
      return '+' + data.countryCode + ' ' + (data.nationalNumber || data.phone);
    }
  },
  mounted: function mounted() {
    this.loadPage();
  }
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_NotificationModal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_SMSModal__ = __webpack_require__(74);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'staging-drivers',
  components: { notificationModal: __WEBPACK_IMPORTED_MODULE_0__App_NotificationModal__["a" /* default */], smsModal: __WEBPACK_IMPORTED_MODULE_1__App_SMSModal__["a" /* default */] },
  data: function data() {
    return {
      airport: {
        selected: -1,
        list: []
      },
      staging: {
        selected: -1,
        loading: false,
        list: [],
        error: false
      },
      drivers: null,
      driversDisplayed: null,
      refreshing: false,
      showOptionsDelay: '',
      driverId: null,
      selectedService: '',
      showOptions: false
    };
  },

  computed: {
    selectedDriver: {
      get: function get() {
        return this.$store.state.dispatch.selectedDriver;
      },
      set: function set(value) {
        this.$store.commit('dispatch/setSelectedDriver', value);
      }
    },
    driversTotal: function driversTotal() {
      return this.$store.state.dispatch.totalDrivers.staging;
    }
  },
  methods: {
    generateDrivers: function generateDrivers(items) {
      var self = this;
      self.drivers = {};
      self.driversDisplayed = null;

      var _loop = function _loop(i) {
        var item = items[i];
        if (items[i].serviceTypeId <= 5) {
          return 'continue';
        }

        if (!self.drivers.hasOwnProperty(item.geofenceId)) {
          self.drivers[item.geofenceId] = {
            shared: [],
            opoli: [],
            black: [],
            suv: [],
            shuttle: []
          };
        }

        if (!item.serviceCode && item.serviceTypeId) {
          item.serviceCode = 'a' + item.serviceTypeId;
        }

        if (!self.drivers[item.geofenceId][item.serviceCode]) {
          self.drivers[item.geofenceId][item.serviceCode] = [];
        }
        if (self.drivers[item.geofenceId][item.serviceCode].findIndex(function (x) {
          return x.provider.ID === item.provider.ID;
        }) === -1) {
          self.drivers[item.geofenceId][item.serviceCode].push(item);
        }
      };

      for (var i = 0; i < items.length; i++) {
        var _ret = _loop(i);

        if (_ret === 'continue') continue;
      }
    },
    onAirportSelect: function onAirportSelect() {
      var self = this;
      if (self.airport.selected === -1) {
        return;
      }

      self.staging.loading = true;
      self.staging.selected = -1;
      self.staging.list = [];
      self.staging.error = false;
      self.drivers = null;
      self.driversDisplayed = null;
      self.$sdk.get('/airports/' + self.airport.selected + '/staging', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        // console.log('STAGING', r)
        self.staging.loading = false;
        if (r.error) {
          self.staging.error = true;
          return;
        }
        if (r.queue.length <= 0) {
          self.staging.error = true;
        }
        self.staging.list = r.staging;

        // set code
        for (var i = 0; i < r.queue.length; i++) {
          if (!r.queue[i].serviceCode) {
            r.queue[i].serviceCode = 'a' + r.queue[i].serviceTypeId;
          }
        }

        self.generateDrivers(r.queue);
        if (self.staging.list.length === 1) {
          self.driversDisplayed = self.drivers[self.staging.list[0].id];
        }
      });
    },
    onStagingLotSelect: function onStagingLotSelect() {
      var self = this;
      self.driversDisplayed = self.drivers[self.staging.selected];
    },
    refreshDrivers: function refreshDrivers() {
      var self = this;
      self.refreshing = true;

      self.$sdk.get('/airports/' + self.airport.selected + '/staging', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.refreshing = false;
        if (r.error) {
          return;
        }

        self.generateDrivers(r.queue);
        if (self.staging.list.length === 1) {
          self.driversDisplayed = self.drivers[self.staging.list[0].id];
        } else {
          self.onStagingLotSelect();
        }
      });
    },
    callDriver: function callDriver(driver) {
      var self = this;
      var phoneNumber = '';
      if (driver.countryCode !== '') {
        phoneNumber += '+';
        phoneNumber += driver.countryCode;
      }
      phoneNumber += driver.phone;
      self.$plugins.phone.startCall(self, {
        phone: phoneNumber,
        name: driver.firstName + ' ' + driver.lastName
      });
    },
    getServiceName: function getServiceName(id) {
      var service = this.$store.state.services.list.filter(function (x) {
        return x.id === id;
      });
      var brand = '';
      if (service.length) {
        brand = '[' + {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.filter(function (x) {
          return x.id === service[0].brandId;
        })[0].code.toUpperCase() + '] ';
      }
      return service.length ? brand + service[0].name : 'Cannot find service data...';
    },
    hideOptions: function hideOptions() {
      var self = this;
      self.showOptionsDelay = setTimeout(function () {
        self.showOptions = '';
      }, 1500);
    },
    clearOptionDelay: function clearOptionDelay() {
      if (this.showOptionsDelay) {
        clearTimeout(this.showOptionsDelay);
      }
    },
    sendSMS: function sendSMS() {
      this.showOptions = '';
      if (this.$refs.sms.showSMSForm()) {
        this.$refs.sms.showSMSForm();
      }
    },
    showNotif: function showNotif() {
      this.showOptions = '';
      if (this.$refs.notif.showNotifForm()) {
        this.$refs.notif.showNotifForm();
      }
    },
    showForm: function showForm(id, service) {
      this.showOptions = !this.showOptions;
      this.driverId = id;
      this.selectedService = service;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$store.commit('airports/setLoading', true);
    self.$sdk.get('/airports', {}, function (r) {
      self.$store.commit('airports/setLoading', false);
      var list = [];
      self.airport.list = [];
      if (!r.error) {
        r.list.forEach(function (data) {
          var add1 = data.addressLine2 === null ? data.addressLine1 : data.addressLine2;
          var add2 = data.addressLine2 === null ? '' : data.addressLine1;
          var title = add2 + ' ' + add1 + ', ' + data.city + ', ' + data.state + ' ' + data.zipCode;
          if (data.enabled) {
            list.push({
              geofenceId: data.id,
              geofenceType: 'airport',
              address1: add1,
              address2: add2,
              city: data.city,
              lat: data.lat,
              lng: data.lng,
              state: data.state,
              title: data.name || title,
              zip: data.zipCode,
              description: data.description,
              airportCode: data.airportCode,
              locationId: data.locationId
            });
          }
        });
        self.airport.list = r.list;
      }
      self.$store.commit('airports/setList', list);
    });
  }
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emoji_mart_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emoji_mart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_emoji_mart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_provider_notifications__ = __webpack_require__(443);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notification-modal',
  props: ['isList', 'provId', 'removeAllActiveUserOption', 'hideTargetOption', 'showGeofenceOption', 'showBySector', 'broadcastOnly'],
  data: function data() {
    return {
      notification: {
        showForm: false,
        target: 'all',
        targetMessage: '',
        geofence: {
          show: false,
          type: '',
          brand: '',
          id: '',
          loading: false,
          list: [],
          error: {
            type: '',
            brand: '',
            id: ''
          }
        },
        isPushNotif: true,
        isSendEmail: false,
        brand: '',
        brandErrorMsg: '',
        title: '',
        titleError: '',
        message: '',
        charCount: 180,
        charExceed: false,
        showEmoji: false,
        file: '',
        fileReady: true,
        uploadedUrl: '',
        fileError: '',
        isAnnouncement: true,
        loading: false,
        errorMsg: '',
        success: false,
        sector: 'group1',
        sectorError: ''
      },
      selected: []
    };
  },

  components: { Picker: __WEBPACK_IMPORTED_MODULE_0_emoji_mart_vue__["Picker"] },
  computed: {
    // provId () { return this.$route.params.id },
    disableNotifButton: function disableNotifButton() {
      var zeroTarget = this.notification.target === 'selected' && !this.selected.length;
      this.notification.targetMessage = zeroTarget ? this.$t('consumer.list.zeroSelected') : '';

      var geofenceCheck = true;
      if (this.notification.target === 'geofence' && (!this.notification.geofence.type || !this.notification.geofence.id || this.notification.geofence.type === 'serviceArea' && !this.notification.geofence.brand)) {
        geofenceCheck = false;
      }

      return zeroTarget || this.notification.message === '' || this.notification.charExceed || this.notification.fileError !== '' || !this.notification.isPushNotif && !this.notification.isSendEmail || !geofenceCheck;
    },
    emojiStyle: function emojiStyle() {
      return { 'width': '100%', 'height': '100%' };
    },
    brands: function brands() {
      return this.$store.state.brands.list;
    }
  },
  methods: {
    showNotifForm: function showNotifForm() {
      if (this.provId.length > 0) {
        this.notification.target = 'selected';
        this.notification.geofence.show = false;
      }
      this.notification.showForm = true;
    },
    closeNotifForm: function closeNotifForm() {
      if (this.notification.showEmoji) {
        this.closeEmoji();
        return;
      }

      if (this.notification.loading) {
        return;
      }
      this.notification.showForm = false;
      this.notification.brandErrorMsg = '';
      this.notification.errorMsg = '';
      this.notification.success = false;
    },
    closeEmoji: function closeEmoji() {
      if (this.notification.showEmoji) {
        this.notification.showEmoji = false;
      }
    },
    charCountUpdate: function charCountUpdate() {
      this.notification.charCount = 180 - this.notification.message.length;
    },
    addEmoji: function addEmoji(emoji) {
      this.notification.showEmoji = false;

      var textarea = this.$refs.notifMsg;
      var cursorPosition = textarea.selectionEnd;
      var start = this.notification.message.substring(0, textarea.selectionStart);
      var end = this.notification.message.substring(textarea.selectionStart);
      var text = start + emoji.native + end;
      this.notification.message = text;
      textarea.focus();
      var self = this;
      this.$nextTick(function () {
        textarea.selectionEnd = cursorPosition + emoji.native.length;
        self.charCountUpdate();
      });
    },
    cleanFileInput: function cleanFileInput() {
      var _this = this;

      this.notification.file = '';
      this.notification.fileError = '';
      this.notification.fileReady = false;
      this.$nextTick(function () {
        _this.notification.fileReady = true;
      });
    },
    checkFileUpload: function checkFileUpload() {
      var self = this;
      if (this.notification.file) {

        var fd = new FormData();
        fd.append('pic', self.notification.file, 'consumer-notif.png');

        self.$http.post({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.mediaHost + '/api/upload', fd, {
          header: { 'Content-Type': 'multipart/form-data' }
        }).then(function (res) {
          if (res.body.success) {
            self.notification.uploadedUrl = res.body.data.url;
            self.submitNotif();
          }
        });
        return;
      }

      self.submitNotif();
    },
    submitNotif: function submitNotif() {
      var self = this;
      var selectedId = self.notification.target === 'all' ? null : self.selected;
      var data = {
        title: self.notification.title,
        message: self.notification.message,
        // image: self.notification.uploadedUrl,
        contactID: selectedId,
        announcement: false
      };

      self.notification.brandErrorMsg = '';
      if (self.notification.target === 'all') {
        // if (!self.notification.brand) {
        //   self.notification.brandErrorMsg = self.$t('consumer.list.emptyBrand')
        //   return
        // }
        data.announcement = self.notification.isAnnouncement;
        data.brandId = self.notification.brand;
      }

      if (self.notification.target === 'geofence') {
        data.geofenceId = self.notification.geofence.id;
        delete data.contactID;
      }

      var sectorId = [1, 2, 3, 4, 5, 6];
      if (self.notification.target === 'sector') {
        if (self.notification.sector === 'group2') sectorId = [7, 8, 9, 10, 11];
        if (self.notification.sector === 'group3') sectorId = [12, 13, 14, 15, 16, 17, 18];
        if (self.notification.sector === 'group4') sectorId = [19, 20, 21, 22, 23];
        data.sectorId = sectorId;
        delete data.contactID;
      }

      self.notification.loading = true;
      if (self.notification.isAnnouncement && !self.broadcastOnly) {
        var announcement = {
          title: self.notification.title,
          message: self.notification.message
        };
        __WEBPACK_IMPORTED_MODULE_1__modules_api_provider_notifications__["a" /* default */].sendAnnouncement(self, announcement, function (res) {
          self.notification.isAnnouncement = false;
        });
      }
      __WEBPACK_IMPORTED_MODULE_1__modules_api_provider_notifications__["a" /* default */].send(self, data, function (res) {
        self.notification.loading = false;
        self.notification.success = true;
        self.notification.title = '';
        self.notification.message = '';
        self.notification.uploadedUrl = '';
        self.cleanFileInput();
      });
    },
    targetUpdate: function targetUpdate() {
      this.notification.geofence.show = this.notification.target === 'geofence';
    },
    updateGeofenceList: function updateGeofenceList() {
      var self = this;
      if (self.notification.geofence.loading) {
        return;
      }

      if (self.notification.geofence.type === 'serviceArea' && !self.notification.geofence.brand) {
        return;
      }

      self.notification.geofence.loading = true;
      self.notification.geofence.list = [];

      var request = {
        token: self.$store.state.session.sessionToken,
        status: 'active',
        pageNum: 1,
        pageSize: 999,
        order: 'priority'
      };
      self.notification.geofence.id = '';
      if (self.notification.geofence.type === 'serviceArea') {
        request.brandId = self.notification.geofence.brand;
        self.$sdk.get('/servicearea', request, function (r) {
          self.notification.geofence.loading = false;
          if (r.error) {
            console.log('ERROR:', r.error.message);
            return;
          }

          r.list.forEach(function (geofence) {
            self.notification.geofence.list.push({
              id: geofence.id,
              name: geofence.name
            });
          });
        }, '2.0');
      } else {
        request.type = self.notification.geofence.type;
        self.$sdk.get('/geofences/search', request, function (r) {
          self.notification.geofence.loading = false;
          if (r.error) {
            console.log('ERROR:', r.error.message);
            return;
          }

          r.list.forEach(function (geofence) {
            self.notification.geofence.list.push({
              id: geofence.id,
              name: geofence.name
            });
          });
        });
      }
    }
  },
  watch: {
    provId: function provId(value) {
      this.selected = this.isList ? value : [value];
    }
  },
  mounted: function mounted() {
    if (!this.isList) {
      this.notification.target = 'selected';
      this.selected = [this.$route.params.id];
    }
    if (this.removeAllActiveUserOption) {
      this.notification.target = 'selected';
    }
  }
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  send: function send(VueApp, data, callback) {
    // data.token = VueApp.$store.state.session.sessionToken
    data.token = 'a518d247-e072-40f2-af4f-6f4d90e4f1e1';
    VueApp.$sdk.post('/admin/prov/broadcast', data, function (res) {
      callback(res);
    });
  },
  sendAnnouncement: function sendAnnouncement(VueApp, data, callback) {
    data.token = VueApp.$store.state.session.sessionToken;
    VueApp.$sdk.post('/admin/announcement', data, function (res) {
      callback(res);
    });
  }
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emoji_mart_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emoji_mart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_emoji_mart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_provider_sms__ = __webpack_require__(445);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sms-modal',
  props: ['isList', 'provId', 'removeAllActiveUserOption', 'hideTargetOption', 'showGeofenceOption'],
  data: function data() {
    return {
      sms: {
        showForm: false,
        target: 'all',
        targetMessage: '',
        geofence: {
          show: false,
          type: '',
          brand: '',
          id: '',
          loading: false,
          list: [],
          error: {
            type: '',
            brand: '',
            id: ''
          }
        },
        isPushNotif: true,
        isSendEmail: false,
        brand: '',
        brandErrorMsg: '',
        title: '',
        titleError: '',
        message: '',
        messageError: '',
        charCount: 180,
        charExceed: false,
        showEmoji: false,
        file: '',
        fileReady: true,
        uploadedUrl: '',
        fileError: '',
        loading: false,
        errorMsg: '',
        success: false
      },
      selected: []
      // disableNotifButton: false
    };
  },

  components: { Picker: __WEBPACK_IMPORTED_MODULE_0_emoji_mart_vue__["Picker"] },
  computed: {
    // provId () { return this.$route.params.id },
    disableNotifButton: function disableNotifButton() {
      var zeroTarget = this.sms.target === 'selected' && !this.selected.length;
      this.sms.targetMessage = zeroTarget ? this.$t('consumer.list.zeroSelected') : '';

      var geofenceCheck = true;
      if (this.sms.target === 'geofence' && (!this.sms.geofence.type || !this.sms.geofence.id || this.sms.geofence.type === 'serviceArea' && !this.sms.geofence.brand)) {
        geofenceCheck = false;
      }

      return zeroTarget || this.sms.message === '' || this.sms.charExceed || this.sms.fileError !== '' || !this.sms.isPushNotif && !this.sms.isSendEmail || !geofenceCheck;
    },
    emojiStyle: function emojiStyle() {
      return { 'width': '100%', 'height': '100%' };
    },
    brands: function brands() {
      return this.$store.state.brands.list;
    }
  },
  methods: {
    showSMSForm: function showSMSForm() {
      if (this.provId.length > 0) {
        this.sms.target = 'selected';
        this.sms.geofence.show = false;
      }
      this.sms.showForm = true;
      this.sms.messageError = '';
    },
    closeSMSForm: function closeSMSForm() {
      if (this.sms.showEmoji) {
        this.closeEmoji();
        return;
      }

      if (this.sms.loading) {
        return;
      }
      this.sms.showForm = false;
      this.sms.brandErrorMsg = '';
      this.sms.errorMsg = '';
      this.sms.success = false;
    },
    closeEmoji: function closeEmoji() {
      if (this.sms.showEmoji) {
        this.sms.showEmoji = false;
      }
    },
    charCountUpdate: function charCountUpdate() {
      this.sms.charCount = 180 - this.sms.message.length;
    },
    addEmoji: function addEmoji(emoji) {
      this.sms.showEmoji = false;

      var textarea = this.$refs.notifMsg;
      var cursorPosition = textarea.selectionEnd;
      var start = this.sms.message.substring(0, textarea.selectionStart);
      var end = this.sms.message.substring(textarea.selectionStart);
      var text = start + emoji.native + end;
      this.sms.message = text;
      textarea.focus();
      var self = this;
      this.$nextTick(function () {
        textarea.selectionEnd = cursorPosition + emoji.native.length;
        self.charCountUpdate();
      });
    },
    cleanFileInput: function cleanFileInput() {
      var _this = this;

      this.sms.file = '';
      this.sms.fileError = '';
      this.sms.fileReady = false;
      this.$nextTick(function () {
        _this.sms.fileReady = true;
      });
    },
    checkFileUpload: function checkFileUpload() {
      var self = this;
      if (this.sms.file) {

        var fd = new FormData();
        fd.append('pic', self.sms.file, 'consumer-notif.png');

        self.$http.post({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.mediaHost + '/api/upload', fd, {
          header: { 'Content-Type': 'multipart/form-data' }
        }).then(function (res) {
          if (res.body.success) {
            self.sms.uploadedUrl = res.body.data.url;
            self.submitNotif();
          }
        });
        return;
      }

      self.submitNotif();
    },
    submitNotif: function submitNotif() {
      var self = this;

      this.sms.messageError = '';
      if (this.sms.message === '') {
        this.sms.messageError = 'This field cannot be empty.';
        return;
      }

      var selectedId = self.isList ? self.provId : [self.provId];
      var data = {
        title: self.sms.title,
        message: self.sms.message,
        // image: self.sms.uploadedUrl,
        contactID: selectedId
      };

      self.sms.brandErrorMsg = '';
      if (self.sms.target === 'all') {
        // if (!self.sms.brand) {
        //   self.sms.brandErrorMsg = self.$t('consumer.list.emptyBrand')
        //   return
        // }
        data.brandId = self.sms.brand;
      }

      if (self.sms.target === 'geofence') {
        data.geofenceId = self.sms.geofence.id;
        delete data.contactID;
      }

      self.sms.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__modules_api_provider_sms__["a" /* default */].send(self, data, function (res) {
        self.sms.loading = false;
        self.sms.success = true;
        self.sms.title = '';
        self.sms.message = '';
        self.sms.uploadedUrl = '';
        self.cleanFileInput();
      });
    },
    targetUpdate: function targetUpdate() {
      this.sms.geofence.show = this.sms.target === 'geofence';
    },
    updateGeofenceList: function updateGeofenceList() {
      var self = this;
      if (self.sms.geofence.loading) {
        return;
      }

      if (self.sms.geofence.type === 'serviceArea' && !self.sms.geofence.brand) {
        return;
      }

      self.sms.geofence.loading = true;
      self.sms.geofence.list = [];

      var request = {
        token: self.$store.state.session.sessionToken,
        status: 'active',
        pageNum: 1,
        pageSize: 999,
        order: 'priority'
      };
      self.sms.geofence.id = '';
      if (self.sms.geofence.type === 'serviceArea') {
        request.brandId = self.sms.geofence.brand;
        self.$sdk.get('/servicearea', request, function (r) {
          self.sms.geofence.loading = false;
          if (r.error) {
            console.log('ERROR:', r.error.message);
            return;
          }

          r.list.forEach(function (geofence) {
            self.sms.geofence.list.push({
              id: geofence.id,
              name: geofence.name
            });
          });
        }, '2.0');
      } else {
        request.type = self.sms.geofence.type;
        self.$sdk.get('/geofences/search', request, function (r) {
          self.sms.geofence.loading = false;
          if (r.error) {
            console.log('ERROR:', r.error.message);
            return;
          }

          r.list.forEach(function (geofence) {
            self.sms.geofence.list.push({
              id: geofence.id,
              name: geofence.name
            });
          });
        });
      }
    }
  },
  watch: {
    provId: function provId(value) {
      this.selected = this.isList ? value : [value];
    }
  },
  mounted: function mounted() {
    if (!this.isList) {
      this.sms.target = 'selected';
      this.selected = [this.$route.params.id];
    }
    if (this.removeAllActiveUserOption) {
      this.sms.target = 'selected';
    }
  }
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  send: function send(VueApp, data, callback) {
    // data.token = 'a518d247-e072-40f2-af4f-6f4d90e4f1e1'
    data.token = VueApp.$store.state.session.sessionToken;
    VueApp.$sdk.post('/admin/prov/broadcast/sms', data, function (res) {
      callback(res);
    });
  }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map2_vue__ = __webpack_require__(447);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27596cbe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map2_vue__ = __webpack_require__(1254);
function injectStyle (ssrContext) {
  __webpack_require__(1249)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27596cbe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27596cbe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__values_map_settings__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__values_map_pin__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_api_services__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Partials_LoadingAnimation_Pulse__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_api_dispatch_drivers__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_api_featureToggle__ = __webpack_require__(5);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */
var request = __webpack_require__(13);









// import DriverPopup from './DriverPopup'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dispatch-map2',
  components: { PulseLoader: __WEBPACK_IMPORTED_MODULE_7__components_Partials_LoadingAnimation_Pulse__["a" /* default */] },
  data: function data() {
    return {
      hereMaps: {
        map: {},
        platform: {},
        router: {},
        geocoder: {},
        directions: [],
        ui: {}
      },
      mapOptions: __WEBPACK_IMPORTED_MODULE_3__values_map_settings__["a" /* default */],
      pickupPin: __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].pickup,
      dropoffPin: __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].dropoff,
      center: { lat: 33.942791, lng: -118.410042 }, // LAX
      carPin: __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].car,
      mapPins: [],
      mapLoader: {
        show: false,
        label: 'LOADING RESERVATION...'
      },
      route: { rsvp: [] },
      rsvp: null,
      driverFilter: {
        show: false,
        isLoading: false,
        miles: 10,
        serviceTypes: [],
        services: [],
        serviceLoading: false
      },
      searchStatus: { miles: 10 },
      showDriverInfoWindow: false,
      driverInfoIndex: 0,
      driverDistance: [],
      driverPresentation: false,
      current: {
        driversInMap: [],
        nearbyDrivers: [],
        openDriver: ''
      },
      waiting: {
        renderDriver: {
          data: '',
          process: false
        },
        beginDriverPresentation: false
      },
      driverRoutes: {},
      upcoming: {
        loading: false,
        rsvp: null
      },
      driverManualOpen: false,
      delayFindNearBy: '',
      delayBeginDriverPresentation: '',
      driverPresented: [],
      driverLocation: {
        lat: '',
        lng: ''
      },
      driverDestination: {
        lat: '',
        lng: ''
      },
      trackDriverDelay: '',
      modal: {
        show: false,
        option: 'default',
        custom: 60
      },
      lastServiceAvailableCheck: {
        id: 0,
        date: __WEBPACK_IMPORTED_MODULE_5_moment___default()()
      },
      isQualifiedDriver: false,
      qualifiedCount: 0,
      nearByQualifiedDrivers: {
        raw: [],
        qualified: []
      },
      qualifiedFilter: {
        serviceTypes: 1,
        seatCapacity: 1,
        adaWC: 1,
        adaSD: 1,
        fullTNC: 1,
        availability: 1
      },
      runValidate: true,
      queueError: {
        show: false,
        message: ''
      },
      lastDriverType: '',
      tmpProvData: null,
      currentDriver: null
    };
  },

  computed: {
    dispatch: function dispatch() {
      return this.$store.state.dispatch;
    },
    driver: function driver() {
      return this.dispatch.driverInPopup;
    },
    rsvpInMap: function rsvpInMap() {
      return this.dispatch.rsvpInMap;
    },
    nearbyDrivers: function nearbyDrivers() {
      return this.dispatch.driversNearRsvp;
    },
    driversInMap: function driversInMap() {
      return this.dispatch.driversInMap;
    },
    driverPopupRoute: function driverPopupRoute() {
      return this.dispatch.driverInPopupRoute;
    },
    isUpcomingAndReqDispatch: function isUpcomingAndReqDispatch() {
      return this.rsvpInMap.status === 'UPCOMING' || this.rsvpInMap.status === 'REQUIRES DISPATCH';
    },
    _rsvpInMapPickup: function _rsvpInMapPickup() {
      return this.dispatch.rsvpInMap.pickup;
    },

    rsvpAvailabilityLoading: {
      get: function get() {
        return this.dispatch.availableDrivers.loading;
      },
      set: function set(x) {
        this.$store.commit('dispatch/setAvailableDriversData', { loading: x });
      }
    },
    rsvpAvailableDrivers: function rsvpAvailableDrivers() {
      return this.dispatch.availableDrivers.list;
    },
    qualifiedDrivers: function qualifiedDrivers() {
      return this.dispatch.qualifiedDriver;
    }
  },
  methods: {
    setMapPins: function setMapPins(pins) {
      var self = this;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var object = _step.value;

          self.hereMaps.map.removeObject(object);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      self.hereMaps.ui.getBubbles().forEach(function (bub) {
        self.hereMaps.ui.removeBubble(bub);
      });

      for (var i = 0; i < pins.length; i++) {
        var item = pins[i];

        // Pickup/Dropoff icon
        var marker = '<svg height="25" width="25" style="overflow: unset" viewBox="0 0 50 50">' + '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' + 'stroke-width="{STROKE_WIDTH}" /></svg>';

        var pickupDropoff = item.isPickup ? 'pickup' : 'dropoff';
        if (item.isExtraStop) {
          pickupDropoff = 'stop';
        }

        marker = marker.replace('{D}', __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */][pickupDropoff].path).replace('{STROKE}', __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */][pickupDropoff].strokeColor).replace('{STROKE_WIDTH}', __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */][pickupDropoff].strokeWeight);
        // .replace('{FILL}', mapPinsSettings[pickupDropoff].fillColor)
        if (item.status === 'complete') {
          marker = marker.replace('{FILL}', __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].pickup.fillColor);
        } else {
          marker = marker.replace('{FILL}', __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */][pickupDropoff].fillColor);
        }
        var icon = new window.H.map.DomIcon(marker);
        var coords = { lat: item.lat, lng: item.lng };
        var pin = new window.H.map.DomMarker(coords, { icon: icon });
        pin.id = 'marker' + i;
        pin.lat = item.lat;
        pin.lng = item.lng;
        self.hereMaps.map.addObject(pin);
      }

      self.setRoute(pins, { isDriverRoute: false });
      if (self.trackDriverDelay) {
        clearTimeout(self.trackDriverDelay);
      }
      if (self.rsvpInMap.isPackage) {
        self.trackDriver();
      }
    },
    setRoute: function setRoute(items, extraData) {
      var self = this;

      var url = 'https://router.hereapi.com/v8/routes?apiKey={API_KEY}&transportMode=car&return=polyline,summary';
      url = url.replace('{API_KEY}', {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key);
      items.forEach(function (coords, index) {
        if (index == 0) {
          url += '&origin=' + coords.lat + ',' + coords.lng;
        } else if (index == items.length - 1) {
          url += '&destination=' + coords.lat + ',' + coords.lng;
        } else {
          url += '&via=' + coords.lat + ',' + coords.lng;
        }
      });
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) {
          self.onCalculateError();
          return;
        }
        self.onCalculateSuccess(extraData, body);
      });
    },
    onCalculateSuccess: function onCalculateSuccess(extraData, result) {
      if (extraData.isTrackDriver) {
        this.setTrackDriverPin(result);
        return;
      }
      if (!result.routes.length) return;
      if (extraData.isDriverRoute) {
        var res = result.routes[0].sections[0].summary;
        var distance = Math.round(res['length'] * .001 * 0.6214) + ' miles, ' + Math.round(res.duration / 60) + ' minutes away';
        if (res['length'] === 0 && res.duration === 0) {
          var tempElement = document.createElement('html');
          tempElement.innerHTML = res.text;
          var miles = tempElement.getElementsByTagName('span')[0].innerText;
          miles = Math.round(parseFloat(miles.substring(0, miles.length - 2)) * 0.6212);
          var time = tempElement.getElementsByTagName('span')[1].innerText;
          time = time.substring(0, time.length - 4);

          distance = miles + ' miles, ' + time + ' minutes away';
        }
        this.driverRoutes['a' + extraData.id] = distance;
      }
      var route = result.routes[0].sections;
      this.addRouteShapeToMap(route, extraData);
    },
    onCalculateError: function onCalculateError(data) {
      console.error('ROUTING ERROR', data);
    },
    addRouteShapeToMap: function addRouteShapeToMap(routes, extraData, distance) {
      var _this = this;

      var self = this;
      routes.forEach(function (route, index) {
        var linestring = window.H.geo.LineString.fromFlexiblePolyline(route.polyline);
        var polyline = new window.H.map.Polyline(linestring, {
          style: {
            lineWidth: 4,
            strokeColor: extraData.isDriverRoute ? '#2EE47D' : 'rgba(25, 25, 25, 0.7)'
          }
        });
        polyline.id = 'rsvpRoute' + index;

        if (extraData.isDriverRoute) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var object = _step2.value;

              if (object.id.indexOf('driverRoute') > -1) {
                object.setVisibility(0);
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          polyline.id = 'driverRoute' + extraData.id;
          polyline.setVisibility(1);

          var driverData = self.$store.state.dispatch.driversNearRsvp;
          var _index = driverData.findIndex(function (x) {
            return x.id === extraData.id;
          });
          if (_index > -1) {
            self.displayDriverInfo(driverData[_index], 1);
          }
        }
        _this.hereMaps.map.addObject(polyline);
      });
      this.setCenter('location', {});

      if (!extraData.isDriverRoute) {
        if (self.rsvp.driver === null) {
          if (self.delayFindNearBy) {
            clearTimeout(self.delayFindNearBy);
          }
          self.delayFindNearBy = setTimeout(function () {
            if (!self.rsvpInMap.isPackage) {
              self.driverFilter.serviceTypes = [];
              self.driverFilter.serviceTypes.push(self.rsvpInMap.serviceId);
            }

            var now = __WEBPACK_IMPORTED_MODULE_5_moment___default()();
            var pickupTime = __WEBPACK_IMPORTED_MODULE_5_moment___default()(self.rsvpInMap.pickupTime, 'MM/DD/YYYY hh:mmA');
            var diff = pickupTime.diff(now, 'minute');
            // let limit = self.rsvpInMap.isPackage ? parseInt(self.$settings.get('findNearbyDriverLimit')) : 60
            var limit = parseInt(self.$settings.get('findNearbyDriverLimit'));
            self.upcoming.loading = true;
            self.upcoming.rsvp = null;
            if (diff <= limit) {
              self.isQualifiedDriver = false;
              self.$store.commit('dispatch/setQualifiedDriversData', { active: false });
              self.findNearbyDrivers();
            } else {
              self.isQualifiedDriver = true;
              self.$store.commit('dispatch/setQualifiedDriversData', { active: true });
              self.findQualifiedDrivers();
            }
          }, 1000);
        } else {
          self.$store.commit('dispatch/setLoadingRsvpId', null);
          self.$store.commit('dispatch/setDriversNearRsvp', []);
        }
      }
    },
    serviceLabel: function serviceLabel(code) {
      return __WEBPACK_IMPORTED_MODULE_6__modules_api_services__["a" /* default */].getServiceName(code);
    },
    updateDriverLocation: function updateDriverLocation(driver, triggerPopup) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_8__modules_api_dispatch_drivers__["a" /* default */].getLocation(self, driver.id, function (location) {
        if (location.error || location && !location.list.length) {
          return;
        }
        var coords = {
          lat: location.list[0].lat,
          lng: location.list[0].lng
        };

        driver.coords = coords;
        if (triggerPopup) {
          self.showDriverInfo(driver, false);
          self.$store.commit('dispatch/removeDriverInMap', driver);
          self.$store.commit('dispatch/addDriverInMap', driver);
        } else {
          var routeCoords = [{ lat: location.list[0].lat, lng: location.list[0].lng }, { lat: self._rsvpInMapPickup.lat, lng: self._rsvpInMapPickup.lng }];
          self.setRoute(routeCoords, { isDriverRoute: true, id: driver.id });
        }

        if (self.rsvpInMap.id === null || self.rsvpInMap.driver === null) {
          return;
        }
      });
    },
    showDriverInfo: function showDriverInfo(driver, focus) {
      var self = this;
      self.$store.commit('dispatch/showDriverInPopup', driver);

      // if (self.rsvp === null) { return }

      self.showDriverInfoWindow = false;
      if (self.driverPresentation || typeof focus === 'undefined') {
        self.$nextTick(function () {
          self.showDriverInfoWindow = true;
        });
      }

      if (focus) {
        self.setCenter('custom', { lat: driver.coords.lat, lng: driver.coords.lng });
      } else {
        self.driverPresentation = false;
      }
      self.updateDriverLocation(driver, false);
    },
    setCenter: function setCenter(type, data) {
      var self = this;
      var group = new window.H.map.Group();

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var object = _step3.value;

          if (object.id === 'groupBound') {
            self.hereMaps.map.removeObject(object);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var groupObject = [];
      if (type === 'location') {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _object = _step4.value;

            if (_object.id.indexOf('marker') > -1) {
              groupObject.push(new window.H.map.Circle(new window.H.geo.Point(_object.lat, _object.lng), 5000, { style: { fillColor: 'rgba(0, 0, 0, 0)', strokeColor: 'rgba(0, 0, 0, 0)' } }));
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      } else if (type === 'driver') {
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var _object2 = _step5.value;

            if (_object2.id.indexOf('driverInMap') > -1 || _object2.id.indexOf('nearbyDrivers') > -1) {
              groupObject.push(new window.H.map.Circle(new window.H.geo.Point(_object2.lat, _object2.lng), 5000, { style: { fillColor: 'rgba(0, 0, 0, 0)', strokeColor: 'rgba(0, 0, 0, 0)' } }));
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      } else if (type === 'custom') {
        groupObject.push(new window.H.map.Circle(new window.H.geo.Point(data.lat, data.lng), 5000, { style: { fillColor: 'rgba(0, 0, 0, 0)', strokeColor: 'rgba(0, 0, 0, 0)' } }));
      }

      // Add to group for bounds correction
      if (groupObject.length) {
        group.addObjects(groupObject);
        group.id = 'groupBound';
        self.hereMaps.map.addObject(group);

        self.hereMaps.map.getViewModel().setLookAtData({
          bounds: group.getBoundingBox()
        });
      }
    },
    setDriverPin: function setDriverPin() {
      var showOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var self = this;

      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var object = _step6.value;

          if (object.id.indexOf('nearbyDrivers') > -1) {
            (function () {
              var id = parseInt(object.id.substring(13));
              var index = self.nearbyDrivers.findIndex(function (x) {
                return x.id === id;
              });
              if (index > -1) {
                self.hereMaps.map.removeObject(object);
                self.current.nearbyDrivers = self.current.nearbyDrivers.filter(function (driverId) {
                  return driverId !== id;
                });
              }
            })();
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      var firstDriver = true;
      self.nearbyDrivers.forEach(function (driver, x) {
        if (self.current.driversInMap.indexOf(driver.id) > -1) {
          return;
        }

        var marker = '<svg height="25" width="25" style="overflow: overlay; top: -12px; left: -12px;" viewBox="0 0 50 50">' + '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' + 'stroke-width="{STROKE_WIDTH}" /></svg>';

        marker = marker.replace('{D}', __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].car.path).replace('{FILL}', x == 0 ? '#38b550' : __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].car.fillColor).replace('{STROKE}', __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].car.strokeColor).replace('{STROKE_WIDTH}', x == 0 ? '.2' : __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].car.strokeWeight);

        var icon = new window.H.map.DomIcon(marker, {
          onAttach: function onAttach(cloned, icon, marker) {
            cloned.addEventListener('click', function (evt) {
              self.displayDriverInfo(driver, 2, showOnly);
            });
          },
          onDetach: function onDetach(cloned, icon, marker) {
            cloned.removeEventListener('click', function (evt) {});
          }
        });
        var coords = { lat: driver.coords.lat, lng: driver.coords.lng };
        var pin = new window.H.map.DomMarker(coords, { icon: icon });
        pin.id = 'nearbyDrivers' + driver.id;
        pin.lat = driver.coords.lat;
        pin.lng = driver.coords.lng;
        self.current.nearbyDrivers.push(driver.id);
        self.hereMaps.map.addObject(pin);
        if (self.driverPresented.indexOf(driver.id) === -1 && firstDriver) {
          firstDriver = false;
          self.driverPresented.push(driver.id);
          self.displayDriverInfo(driver, 3, showOnly);
        }
        // if (firstDriver) {
        //   firstDriver = false
        //   self.displayDriverInfo(driver, 3, showOnly)
        // }
      });

      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var _object3 = _step7.value;

          if (_object3.id.indexOf('driverInMap') > -1) {
            (function () {
              var id = parseInt(_object3.id.substring(11));
              var index = self.driversInMap.findIndex(function (x) {
                return x.id === id;
              });
              if (index === -1) {
                self.hereMaps.map.removeObject(_object3);
                self.current.driversInMap = self.current.driversInMap.filter(function (driverId) {
                  return driverId !== id;
                });
              }
            })();
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      setTimeout(function () {
        self.driversInMap.forEach(function (driver, x) {
          if (self.current.driversInMap.indexOf(driver.id) > -1) {
            return;
          }

          var marker = '<svg height="25" width="25" style="overflow: overlay; top: -12px; left: -12px;" viewBox="0 0 50 50">' + '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' + 'stroke-width="{STROKE_WIDTH}" /></svg>';

          marker = marker.replace('{D}', __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].car.path).replace('{FILL}', x == 0 ? '#38b550' : __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].car.fillColor).replace('{STROKE}', __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].car.strokeColor).replace('{STROKE_WIDTH}', x == 0 ? '.2' : __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].car.strokeWeight);

          var icon = new window.H.map.DomIcon(marker, {
            onAttach: function onAttach(cloned, icon, marker) {
              cloned.addEventListener('click', function (evt) {
                self.displayDriverInfo(driver, 4, showOnly);
              });
            },
            onDetach: function onDetach(cloned, icon, marker) {
              cloned.removeEventListener('click', function (evt) {});
            }
          });
          var coords = { lat: driver.coords.lat, lng: driver.coords.lng };
          var pin = new window.H.map.DomMarker(coords, { icon: icon });
          pin.id = 'driverInMap' + driver.id;
          pin.lat = driver.coords.lat;
          pin.lng = driver.coords.lng;
          self.current.driversInMap.push(driver.id);
          self.hereMaps.map.addObject(pin);
          if (firstDriver) {
            firstDriver = false;
            self.displayDriverInfo(driver, 5, showOnly);
          }
        });
      }, 300);

      // if (self.current.driversInMap.length === 0 && self.current.nearbyDrivers.length === 0) {
      //   // self.setCenter('custom', {lat: 33.942791, lng: -118.410042})
      //   return
      // }

      self.setCenter('driver', {});
    },
    displayDriverInfo: function displayDriverInfo(driver, x) {
      var showOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var self = this;

      // Display route from this driver
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var object = _step8.value;

          if (object.id.indexOf('driverRoute') > -1) {
            object.setVisibility(0);
            // if (object.id === 'driverRoute' + driver.id) {
            //   self.current.openDriver = driver.id
            //   object.setVisibility(1)
            // }
          }
        }

        // Remore existing info bubble
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      self.hereMaps.ui.getBubbles().forEach(function (bub) {
        self.hereMaps.ui.removeBubble(bub);
      });

      var driverIndex = self.driverDistance.findIndex(function (x) {
        return x.id === driver.id;
      });
      self.$store.commit('dispatch/setDriverInPopupRoute', self.driverDistance[driverIndex]);

      var bubbleId = 'driverInfo_' + driver.id;

      var bubbles = self.hereMaps.ui.getBubbles();
      for (var i = 0; i < bubbles.length; i++) {
        var item = bubbles[i];
        if (item.id !== bubbleId) {
          continue;
        }
        self.hereMaps.ui.removeBubble(item);
      }

      var showDispatchButtons = self.rsvpInMap.id !== null && (self.rsvpInMap.status === 'UPCOMING' || self.rsvpInMap.status === 'REQUIRES DISPATCH');

      var bubbleContent = '<div class="info-container">' + '<div class="driver-info"><img src="{DRIVER_PHOTO}"/><a href="{DRIVER_URL}" target="_blank">{DRIVER_NAME}</a></div>' + '<div class="vehicle-info"><img src="{VEHICLE_PHOTO}"/><strong>{VEHICLE_NAME}</strong><span>{VEHICLE_NUMBER}</span></div>' + '<a id="DriverCall_{DRIVER_ID}" class="call-button button cta xsmall success block" href="javascript:;" @click="testMethod">CALL {DRIVER_FNAME}</a>';
      '</div>';

      if (showDispatchButtons) {
        bubbleContent = '<div class="info-container">' + '<div class="prvNxt prev" id="driverPrev_{DRIVER_ID}"><i class="fas fa-chevron-left"></i></div>' + '<div class="prvNxt next" id="driverNext_{DRIVER_ID}"><i class="fas fa-chevron-right"></i></div>' +
        // '<div class="upcoming-rsvp" style="display:none">{UPCOMING_INFO}</div>' +
        '<div class="driver-info"><img src="{DRIVER_PHOTO}"/><a href="{DRIVER_URL}" target="_blank">{DRIVER_NAME}</a><span>{DRIVER_DISTANCE}</span>' + (!showOnly ? '<a id="DriverSend_{DRIVER_ID}" class="assign-button button cta xsmall warning block" href="javascript:;">SEND TO {DRIVER_FNAME}</a>' : '') + '</div>' + '<div class="vehicle-info"><img src="{VEHICLE_PHOTO}"/><strong>{VEHICLE_NAME}</strong><span>{VEHICLE_NUMBER}</span>' + (!showOnly ? '<a id="DriverAssign_{DRIVER_ID}" class="assign-button button cta xsmall block" href="javascript:;">ASSIGN TO {DRIVER_FNAME}</a>' : '') + '</div>' + '<a id="DriverCall_{DRIVER_ID}" class="call-button button cta xsmall success block" href="javascript:;" @click="testMethod"><i class="fas fa-phone"></i> CALL {DRIVER_FNAME}</a>';
        '</div>';

        var upcomingInfo = '';
        if (self.upcoming.loading) {
          upcomingInfo = '<i class="fa fa-spinner fa-spin"></i><span> Checking for upcoming reservations...</span>';
        } else if (!self.upcoming.loading && self.upcoming.rsvp === null) {
          upcomingInfo = 'No Upcoming Reservations.';
        } else if (!self.upcoming.loading && self.upcoming.rsvp !== null) {
          upcomingInfo = 'Upcoming ';
          if (self.upcoming.rsvp !== null && self.upcoming.rsvp.type === 'package') {
            upcomingInfo = upcomingInfo + '<span>Package </span>' + ' (<a href="/#/package/' + self.upcoming.rsvp.data.package.id + '" target="_blank">' + self.upcoming.rsvp.data.package.id + '</a>) at ' + ' <span>' + self.formatTime(self.upcoming.rsvp.data.pickupTime) + '.</span>';
          }
          if (self.upcoming.rsvp !== null && self.upcoming.rsvp.type === 'rsvp') {
            upcomingInfo = upcomingInfo + '<span>RSVP </span>' + ' (<a href="/#/reservation/' + self.upcoming.rsvp.data.ID + '" target="_blank">' + self.upcoming.rsvp.data.ID + '</a>) at ' + ' <span>' + self.formatTime(self.upcoming.rsvp.data.pickupDate) + '.</span>';
          }
        }
        bubbleContent = bubbleContent.replace('{UPCOMING_INFO}', upcomingInfo);
      }

      self.currentDriver = driver;
      bubbleContent = bubbleContent.replace('{DRIVER_PHOTO}', driver.photoUrl).replaceAll('{DRIVER_ID}', driver.id).replace('{DRIVER_URL}', '/#/provider/' + driver.id).replace('{DRIVER_NAME}', driver.firstName + ' ' + driver.lastName).replace('{DRIVER_DISTANCE}', self.driverRoutes['a' + driver.id] || '&nbsp;').replace('{DRIVER_FNAME}', driver.firstName).replace('{DRIVER_FNAME}', driver.firstName).replace('{DRIVER_FNAME}', driver.firstName).replace('{VEHICLE_PHOTO}', driver.vehicle.photoUrl).replace('{VEHICLE_NAME}', driver.vehicle.name).replace('{VEHICLE_NUMBER}', driver.vehicle.licensePlate);

      var bubble = new window.H.ui.InfoBubble({
        lat: driver.coords.lat,
        lng: driver.coords.lng
      }, {
        content: bubbleContent,
        onStateChange: function onStateChange(aa) {
          if (driver.isQualified) {
            if (!self.qualifiedDrivers.list.length) self.noQualifiedDrivers();else self.validateQualifiedDrivers();
            return;
          }

          if (!self.nearByQualifiedDrivers.raw.length) self.noQualifiedDrivers();else self.checkDriverQualification();
        }
      });
      bubble.id = bubbleId;
      bubble.addClass('H_driver-info');
      self.hereMaps.ui.addBubble(bubble);

      var driverPrev = document.getElementById('driverPrev_' + driver.id);
      var driverNext = document.getElementById('driverNext_' + driver.id);
      var elem = document.getElementById('DriverCall_' + driver.id);
      var assignElem = document.getElementById('DriverAssign_' + driver.id);
      var sendElem = document.getElementById('DriverSend_' + driver.id);

      setTimeout(function () {
        if (driverPrev) {
          driverPrev.classList.remove('disabled');
          if (self.driverInfoIndex <= 0) {
            driverPrev.classList.add('disabled');
          } else {
            driverPrev.addEventListener('click', function (evt) {
              self.beginDriverPresentation(false);
            });
          }
        }

        if (driverNext) {
          var driverData = self.$store.state.dispatch.driversNearRsvp;
          driverNext.classList.remove('disabled');
          if (driverData.length - 1 <= self.driverInfoIndex) {
            driverNext.classList.add('disabled');
          } else {
            driverNext.addEventListener('click', function (evt) {
              self.beginDriverPresentation(true);
            });
          }
        }

        if (elem) {
          elem.addEventListener('click', function (evt) {
            self.callDriver(driver);
          });
        }

        if (showDispatchButtons) {
          if (assignElem) {
            assignElem.addEventListener('click', function (evt) {
              self.assignToDriver(driver);
            });
          }

          if (sendElem) {
            sendElem.addEventListener('click', function (evt) {
              self.sendToDriver(driver);
            });
          }
        }
      }, 500);
    },
    callDriver: function callDriver(driver) {
      var self = this;
      self.$plugins.phone.startCall(self, {
        phone: driver.phone,
        name: driver.firstName + ' ' + driver.lastName
      });
    },
    sendToDriver: function sendToDriver(driver) {
      var self = this;
      var rsvp = self.rsvpInMap;
      this.modal.show = false;

      var url = '/admin/rsvp/';
      if (rsvp.isPackage) {
        url = '/admin/package/';
      }
      self.$store.commit('dispatch/showActionModal', 'Sending' + (rsvp.isPackage ? ' package ' : ' reservation ') + 'to driver...');

      var customRequestTimeout = self.$settings.get('ASAPRequestTimeout');
      if (self.modal.option === 'custom') customRequestTimeout = self.modal.custom;
      self.$sdk.post(url + rsvp.id + '/send', {
        token: self.$store.state.session.sessionToken,
        provId: driver.id,
        customRequestTimeout: customRequestTimeout
      }, function (r) {
        if (r.error) {
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong. Try again later.'
          });
        } else {
          self.$store.commit('dispatch/setPendingOffer', {
            id: rsvp.id,
            show: true,
            timer: parseInt(customRequestTimeout) + 10
          });
          // self.$store.commit('dispatch/removeRsvpInTable', rsvp)
          self.$store.commit('dispatch/setSelectedDriver', null);
          self.$store.commit('dispatch/completeActionModal', {
            success: true,
            message: 'Successfully sent reservation.'
          });
        }

        setTimeout(function () {
          self.$store.commit('dispatch/closeActionModal');
        }, 1000);
      });
    },
    assignToDriver: function assignToDriver(driver) {
      var self = this;
      var rsvp = self.rsvpInMap;

      self.$store.commit('dispatch/showActionModal', 'Assigning ' + (rsvp.isPackage ? 'package' : 'reservation') + ' to driver...');

      var request = {
        token: self.$store.state.session.sessionToken,
        rsvpId: rsvp.id
      };
      if (rsvp.isPackage) {
        request = {
          token: self.$store.state.session.sessionToken,
          packageId: rsvp.id
        };
      }

      self.$sdk.post('/provider/' + driver.id + '/assign', request, function (r) {
        if (r.error) {
          console.log('ERROR', r);
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong.'
          });
        } else {
          self.$store.commit('dispatch/completeActionModal', {
            success: true,
            message: 'Successfully assigned items to driver.'
          });
        }
        setTimeout(function () {
          self.$store.commit('dispatch/closeActionModal');
        }, 1000);
      });
    },
    getNextRoute: function getNextRoute() {
      var self = this;
      var rsvp = self.rsvp;
      if (rsvp === null) {
        return null;
      }

      for (var i = 0; i < rsvp.route.length; i++) {
        var route = rsvp.route[i];

        if (route.status === 'upcoming' || route.status === 'requires_dispatch' || route.status === 'dispatched') {
          return route;
        }
      }
      return null;
    },
    findNearbyDrivers: function findNearbyDrivers() {
      var self = this;
      if (self.driverFilter.isLoading) {
        return;
      }

      // GET AVAILABLE DRIVERS - CROSS FILTER
      // if (self.lastServiceAvailableCheck.id !== self.rsvp.id ||
      //   (self.lastServiceAvailableCheck.id === self.rsvp.id && self.lastServiceAvailableCheck.date.diff(moment(), 'minute') < -5)
      // ) {
      //   self.getAvailableDrivers(self.rsvp)
      //   return
      // }

      self.driverFilter.isLoading = true;
      self.mapLoader = {
        show: true,
        label: 'FINDING NEARBY DRIVERS...'
      };

      var serviceId = [];
      if (self.rsvpInMap.isPackage) {
        var _services = this.$store.state.services;
        _services.list.forEach(function (service) {
          if (service.isShared && service.enabled) {
            serviceId.push(service.id);
          }
        });
      } else {
        self.driverFilter.serviceTypes.forEach(function (id) {
          if (id) {
            serviceId.push(id);
          }
        });
      }

      // Remove info bubble
      self.hereMaps.ui.getBubbles().forEach(function (bub) {
        self.hereMaps.ui.removeBubble(bub);
      });
      // Remove current drivers
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var object = _step9.value;

          if (object.id.indexOf('nearbyDrivers') > -1) {
            self.hereMaps.map.removeObject(object);
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      self.lastDriverType = 'nearby';
      __WEBPACK_IMPORTED_MODULE_8__modules_api_dispatch_drivers__["a" /* default */].getNearbyDrivers(self, {
        token: self.$store.state.session.sessionToken,
        lat: self.rsvp.pickup.lat,
        lng: self.rsvp.pickup.lng,
        radius: self.driverFilter.miles,
        duty: 1,
        serviceTypeId: serviceId,
        // serviceTypeId: self.driverFilter.serviceTypes,
        order: 'distance',
        orderAsc: 1
      }, function (r) {
        self.nearByDriversRaw = [];
        // self.driverPresentation = true
        self.driverFilter.isLoading = false;
        self.mapLoader = {
          show: false,
          label: ''
        };
        self.$store.commit('dispatch/setLoadingRsvpId', null);
        self.$store.commit('dispatch/setDriversNearRsvp', []);
        if (r.error) {
          self.mapLoader = {
            show: false,
            label: ''
          };
          self.setCenter();
          return;
        }

        if (r.list.length <= 0) {
          self.mapLoader = {
            show: false,
            label: ''
          };
          self.driverFilter.show = true;
          self.setCenter();
          return;
        }

        self.driverFilter.show = false;
        self.showDriverInfoWindow = false;

        var driversNearby = [];
        for (var i = 0; i < r.list.length; i++) {
          var driver = r.list[i];
          // let isDriverAvailable = false
          // if (self.rsvpAvailableDrivers.length) {
          //   isDriverAvailable = self.rsvpAvailableDrivers.findIndex(x => x.id === driver.ID) > -1
          // }
          // if (typeof driver.tracks === 'undefined' || !isDriverAvailable) {
          //   continue
          // }
          var driverData = {
            id: driver.ID,
            phone: driver.phone,
            firstName: driver.firstName,
            lastName: driver.lastName,
            photoUrl: driver.avatarUrl,
            coords: {
              lat: driver.tracks.lat,
              lng: driver.tracks.lng,
              header: driver.tracks.heading
            },
            vehicle: {
              name: driver.vehicle.manufacturer + ' ' + driver.vehicle.model,
              licensePlate: driver.vehicle.licensePlate,
              photoUrl: driver.vehicle.photoUrl
            }
          };
          driversNearby.push(driverData);
          self.nearByQualifiedDrivers.raw.push(driverData);

          self.waiting.renderDriver.process = true;
          self.waiting.renderDriver.data = driver;
          self.driverDistance.push({
            id: driver.ID,
            distance: self.calculateDistance({ lat: driver.tracks.lat, lng: driver.tracks.lng }, { lat: self.rsvpInMap.pickup.lat, lng: self.rsvpInMap.pickup.lng })
          });
          if (i + 1 === r.list.length) {
            if (self.isUpcomingAndReqDispatch) {
              self.driverPresentation = true;
            }
            self.$store.commit('dispatch/setDriversNearRsvp', driversNearby);
            // self.driverDistance = self.driverDistance.sort((a, b) => a.distance - b.distance)

            self.checkDriverQualification();
          }

          self.searchStatus.miles = self.driverFilter.miles;
        }
        self.setDriverPin();
        self.driverPresented = [];
        self.setCenter();
      });
    },
    checkDriverQualification: function checkDriverQualification() {
      var self = this;
      if (!self.nearByQualifiedDrivers.raw.length) return;
      var driverId = self.nearByQualifiedDrivers.raw[0].id;
      self.mapLoader = {
        show: true,
        label: 'Checking for qualified drivers...'
      };
      self.$sdk.get('/reservation/' + self.rsvpInMap.id + '/validate', {
        token: self.$store.state.session.sessionToken,
        providerId: driverId
      }, function (r) {
        if (r.error) {
          self.nearByQualifiedDrivers.raw.shift();
          if (!self.nearByQualifiedDrivers.raw.length) {
            self.mapLoader = {
              show: false,
              label: ''
            };
            self.driverFilter.show = true;
            self.setCenter();
          } else self.checkDriverQualification();
          return;
        }
        self.mapLoader = {
          show: false,
          label: ''
        };

        var driverDetails = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, self.nearByQualifiedDrivers.raw[0]);
        self.showDriverInfo(driverDetails, true);
        self.nearByQualifiedDrivers.raw.shift();
        // self.getDriverDetails(driverId)
      }, '2.0');
    },
    beginDriverPresentation: function beginDriverPresentation(isNext) {
      var self = this;

      // if (self.isUpcomingAndReqDispatch) {
      var driverData = self.$store.state.dispatch.driversNearRsvp;
      // self.driverDistance = self.driverDistance.sort((a, b) => a.distance - b.distance)
      if (!self.driverDistance.length) {
        self.waiting.beginDriverPresentation = true;
        return;
      }

      if (!isNext && self.driverInfoIndex > 0) {
        self.driverInfoIndex--;
      } else if (isNext && self.driverInfoIndex < driverData.length - 1) {
        self.driverInfoIndex++;
        if (driverData[self.driverInfoIndex].id === self.currentDriver.id) self.driverInfoIndex++;
      }
      if (driverData[self.driverInfoIndex]) {
        var index = driverData.findIndex(function (x) {
          return x.id === self.driverDistance[self.driverInfoIndex].id;
        });
        if (index === -1) {
          index = 0;
        }
        self.showDriverInfo(driverData[index], true);
        // if (isNext) self.driverInfoIndex++
      } else {
        self.$store.commit('global/setAlertData', {
          show: true,
          message: 'No more nearby drivers found.'
        });
      }
      // self.setDriverPin()
      // }
    },
    calculateDistance: function calculateDistance(coord1, coord2) {
      var toRad = function toRad(value) {
        return value * Math.PI / 180;
      };
      var R = 6371;
      var latD = toRad(coord2.lat - coord1.lat);
      var longD = toRad(coord2.lng - coord1.lng);
      var a = Math.sin(latD / 2) * Math.sin(latD / 2) + Math.cos(toRad(coord1.lat)) * Math.cos(toRad(coord2.lat)) * Math.sin(longD / 2) * Math.sin(longD / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var distance = R * c;
      return distance / 1.609344;
    },
    resizeMap: function resizeMap() {
      var self = this;
      setTimeout(function () {
        self.hereMaps.map.getViewPort().resize();
      }, 600);
    },
    formatTime: function formatTime(time) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(time).format('MM/DD/YYYY hh:mm A');
    },
    filterServices: function filterServices() {
      var self = this;
      var services = this.$store.state.services;

      if (!services.list.length) {
        this.getServices();
        return;
      }

      self.driverFilter.services = [];
      services.list.forEach(function (service) {
        if (self.rsvpInMap.isPackage) {
          if (service.isShared && service.enabled) {
            var name = service.label;
            var brandIndex = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.findIndex(function (x) {
              return x.id === service.brandId;
            });
            if (brandIndex > -1) {
              name = '[' + {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[brandIndex].code.toUpperCase() + '] ' + name;
            }
            self.driverFilter.services.push({
              id: service.id,
              brandId: service.brandId,
              name: name
            });
          }
        } else {
          if (service.brandId === self.rsvpInMap.brandId) {
            self.driverFilter.services.push({
              id: service.id,
              brandId: service.brandId,
              name: service.label
            });
          }
        }
      });
    },
    getServices: function getServices() {
      var self = this;
      self.driverFilter.serviceLoading = true;
      __WEBPACK_IMPORTED_MODULE_6__modules_api_services__["a" /* default */].getAllService(self, function (r) {
        self.driverFilter.serviceLoading = false;
        self.filterServices();
      });
    },
    trackDriver: function trackDriver() {
      var self = this;

      var stops = [];
      self.rsvpInMap.route.forEach(function (route) {
        if (!route.isPickup) {
          stops.push(route.rsvpID);
        }
      });

      var rsvp = '';
      stops.every(function (stop, index) {
        rsvp = self.rsvpInMap.rsvps.find(function (x) {
          return x.id === stop && ['ontheway', 'arrived', 'onboard'].indexOf(x.rsvpStatus) > -1;
        });
        return !rsvp ? true : false;
      });

      if (self.trackDriverDelay) {
        clearTimeout(self.trackDriverDelay);
      }

      if (rsvp) {
        self.$sdk.get('/provider/' + rsvp.driver.id + '/tracks', { token: self.$store.state.session.sessionToken }, function (res) {
          if (!res.error && res.list.length) {
            self.driverLocation = {
              lat: res.list[0].lat,
              lng: res.list[0].lng
            };
            self.driverDestination = {
              lat: rsvp.dropoff.lat,
              lng: rsvp.dropoff.lng
              // if (stops[0] === rsvp.id && rsvp.rsvpStatus === 'ontheway') {
              //   self.driverDestination = {
              //     lat: rsvp.pickup.lat,
              //     lng: rsvp.pickup.lng
              //   }
              // }
            };self.setRoute([self.driverLocation, self.driverDestination], { isDriverRoute: false, isTrackDriver: true });
          }
        });
      } else {
        self.trackRemoveDriver();
      }
    },
    setTrackDriverPin: function setTrackDriverPin(data) {
      var self = this;
      self.trackRemoveDriver();

      var marker = '\n        <svg height="25" width="25" style="overflow: overlay; top: -12px; left: -12px;" viewBox="0 0 50 50">\n          <path d="{D}" fill="{FILL}"stroke="{STROKE}" stroke-width="{STROKE_WIDTH}" />\n        </svg>';
      marker = marker.replace('{D}', __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].car.path).replace('{FILL}', __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].car.fillColor).replace('{STROKE}', __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].car.strokeColor).replace('{STROKE_WIDTH}', __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].car.strokeWeight);

      var icon = new window.H.map.DomIcon(marker);
      var pin = new window.H.map.DomMarker(self.driverLocation, { icon: icon });
      pin.id = 'driverPin';
      pin.lat = self.driverLocation.lat;
      pin.lng = self.driverLocation.lng;

      var content = '\n        <div class="info-container">\n          <div class="driver-info"><img src="{DRIVER_PHOTO}"/><a href="{DRIVER_URL}" target="_blank">{DRIVER_NAME}</a></div>\n          <div class="vehicle-info"><img src="{VEHICLE_PHOTO}"/><strong>{VEHICLE_NAME}</strong><span>{VEHICLE_NUMBER}</span></div>\n          <div class="eta-to-dropoff"><label>ETA to next dropoff</label><span class="value">{ETA}</span></div>\n          <a id="DriverCall_{DRIVER_ID}" class="call-button button cta xsmall success block" href="javascript:;" @click="testMethod">CALL {DRIVER_FNAME}</a>\n        </div>\n      ';
      var driver = self.rsvpInMap.driver;
      content = content.replace('{DRIVER_PHOTO}', driver.photoUrl).replace('{DRIVER_URL}', '/#/provider/' + driver.id).replace('{DRIVER_ID}', driver.id).replace('{DRIVER_NAME}', driver.firstName + ' ' + driver.lastName).replace('{VEHICLE_PHOTO}', driver.vehicle.photoUrl).replace('{VEHICLE_NAME}', driver.vehicle.name).replace('{VEHICLE_NUMBER}', driver.vehicle.licensePlate).replace('{DRIVER_FNAME}', driver.firstName);
      var travelTime = data.routes.length ? data.routes[0].sections[0].summary.duration : 0;
      if (travelTime > 60) {
        content = content.replace('{ETA}', Math.ceil(travelTime / 60) + ' minute(s)');
      } else {
        content = content.replace('{ETA}', travelTime + ' second(s)');
      }
      var bubble = new window.H.ui.InfoBubble(self.driverLocation, { content: content });
      bubble.addClass('H_driver-info');
      bubble.id = 'driverBubble';
      bubble.open();
      self.hereMaps.ui.addBubble(bubble);
      pin.addEventListener('tap', function (evt) {
        bubble.open();
      }, false);
      self.hereMaps.map.addObject(pin);

      setTimeout(function () {
        var elem = document.getElementById('DriverCall_' + driver.id);
        elem.addEventListener('click', function (evt) {
          self.callDriver(driver);
        });
      }, 500);

      self.trackDriverDelay = setTimeout(function () {
        self.trackDriver();
      }, 15000);
    },
    trackRemoveDriver: function trackRemoveDriver() {
      var self = this;
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var object = _step10.value;

          if (object.id === 'driverPin') {
            self.hereMaps.map.removeObject(object);
          }
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }

      self.hereMaps.ui.getBubbles().forEach(function (bub) {
        if (bub.id === 'driverBubble') {
          self.hereMaps.ui.removeBubble(bub);
        }
      });
    },
    getExtraStops: function getExtraStops(id) {
      var self = this;

      self.$sdk.get('/admin/rsvp/' + id + '/extrastops', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          return;
        }
        if (r.list.length) {
          var pickup = self.rsvpInMap.pickup;
          pickup.isPickup = true;
          var dropoff = self.rsvpInMap.dropoff;
          dropoff.isPickup = false;
          var extraStop = r.list[0];
          extraStop.isExtraStop = true;
          self.setMapPins([pickup, extraStop, dropoff]);
        }
        // self.$forceUpdate()
      });
    },
    close: function close() {
      this.modal.show = false;
    },
    getAvailableDrivers: function getAvailableDrivers(data) {
      if (!data.id) return;
      if (data.status !== 'UPCOMING' && data.status !== 'REQUIRES DISPATCH') return;

      var self = this;
      if (self.rsvpAvailabilityLoading) return;
      self.rsvpAvailabilityLoading = true;
      self.lastServiceAvailableCheck = {
        id: data.id,
        date: __WEBPACK_IMPORTED_MODULE_5_moment___default()()
      };

      var since = __WEBPACK_IMPORTED_MODULE_5_moment___default()(data.pickupTime, 'MM/DD/YYYY hh:mmA').format('X');
      var until = __WEBPACK_IMPORTED_MODULE_5_moment___default()(data.dropoffTime, 'MM/DD/YYYY hh:mmA').format('X');

      self.$sdk.get('/shifts/dashboard', {
        token: self.$store.state.session.sessionToken,
        assignments: 0,
        order: 'startShift',
        orderAsc: 1,
        pageNum: 1,
        sectorId: 0,
        serviceTypeId: data.serviceId,
        since: since,
        until: until
      }, function (res) {
        self.rsvpAvailabilityLoading = false;
        if (res.error) {
          self.$store.commit('dispatch/setAvailableDriversData', { list: drivers });
          return;
        }
        var drivers = [];
        res.list.forEach(function (driver) {
          var name = driver.businessName || driver.firstName + ' ' + driver.lastName;
          var availableFrom = '';
          var availableUntil = '';
          if (driver.startTimestamp) {
            // let sinceTime = moment(since, 'X').format(ft.timeFormat(self, false))
            // availableFrom = moment(driver.startTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY') + ' ' + sinceTime
            availableFrom = __WEBPACK_IMPORTED_MODULE_5_moment___default()(driver.startTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_9__modules_api_featureToggle__["a" /* default */].timeFormat(self, false));
            availableUntil = __WEBPACK_IMPORTED_MODULE_5_moment___default()(driver.endTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_9__modules_api_featureToggle__["a" /* default */].timeFormat(self, false));
          }
          drivers.push({
            id: driver.ID,
            name: name,
            firstName: driver.firstName,
            lastName: driver.lastName,
            licenseType: driver.accountType,
            homeSector: driver.homeSectorName || '',
            availableFrom: availableFrom,
            availableUntil: availableUntil,
            mobile: driver.phoneNumber || ''
          });
        });
        self.$store.commit('dispatch/setAvailableDriversData', { list: drivers });
        self.findNearbyDrivers();
      });
    },
    driverFilterSubmit: function driverFilterSubmit() {
      if (this.qualifiedDrivers.active) {
        this.findQualifiedDrivers(true);
        this.driverFilter.show = false;
      } else {
        this.findNearbyDrivers();
      }
    },
    findQualifiedDrivers: function findQualifiedDrivers() {
      var withFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var self = this;
      if (!self.rsvpInMap.id || self.driverFilter.isLoading) return;
      self.driverFilter.isLoading = true;

      self.mapLoader = {
        show: true,
        label: 'LOOKING FOR QUALIFIED DRIVERS...'
      };

      var params = {
        token: self.$store.state.session.sessionToken
      };
      if (withFilter) {
        params.distance = self.driverFilter.miles;
        params.serviceTypes = self.qualifiedFilter.serviceTypes ? 1 : 0;
        params.seatCapacity = self.qualifiedFilter.seatCapacity ? 1 : 0;
        params.adaWC = self.qualifiedFilter.adaWC ? 1 : 0;
        params.adaSD = self.qualifiedFilter.adaSD ? 1 : 0;
        params.availability = self.qualifiedFilter.availability ? 1 : 0;
      }
      self.runValidate = true;
      if (withFilter && (!self.qualifiedFilter.serviceTypes || !self.qualifiedFilter.seatCapacity || !self.qualifiedFilter.adaWC || !self.qualifiedFilter.adaSD || !self.qualifiedFilter.availability)) {
        self.runValidate = false;
      }
      self.lastDriverType = 'qualified';
      self.$sdk.get('/reservation/' + self.rsvpInMap.id + '/queue', params, function (r) {
        self.driverFilter.isLoading = false;
        self.qualifiedCount = 0;
        if (r.error) {
          self.mapLoader = {
            show: false,
            label: ''
          };
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          return;
        }
        self.qualifiedCount = r.list.length;
        if (!r.list.length) {
          self.noQueueDrivers(r);
          return;
        }

        self.$store.commit('dispatch/setQualifiedDriversData', { list: r.list });
        self.validateQualifiedDrivers(r);
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(r.unqualified).length) self.buildReasons(r);
      }, '2.0');
    },
    validateQualifiedDrivers: function validateQualifiedDrivers(data) {
      var self = this;
      if (!self.qualifiedDrivers.list.length) return;

      if (data) self.tmpProvData = data;else if (self.tmpProvData) data = self.tmpProvData;

      var driverId = self.qualifiedDrivers.list[0].id;
      if (!self.runValidate) {
        self.mapLoader = {
          show: false,
          label: ''
        };
        self.getDriverDetails(driverId);
        return;
      }
      self.$sdk.get('/reservation/' + self.rsvpInMap.id + '/validate', {
        token: self.$store.state.session.sessionToken,
        providerId: driverId
      }, function (r) {
        if (r.error) {
          self.$store.commit('dispatch/reduceQualifiedDrivers');

          var driver = '';
          if (data.unfiltered) driver = data.unfiltered.find(function (d) {
            return d.id == driverId;
          });
          self.$store.commit('global/addReasonList', {
            id: driverId,
            name: driver ? driver.name : '',
            reason: r.error.message
          });

          // if (!self.qualifiedDrivers.list.length) self.noQualifiedDrivers()
          if (!self.qualifiedDrivers.list.length) self.noQueueDrivers(false);else self.validateQualifiedDrivers(data);
          // self.getDriverDetails(driverId, true)
          return;
        }

        self.getDriverDetails(driverId);
      }, '2.0');
    },
    getDriverDetails: function getDriverDetails(id) {
      var showOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var self = this;

      self.$sdk.get('/provider/' + id, {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          if (!self.qualifiedDrivers.list.length) self.noQualifiedDrivers();else if (!showOnly) self.validateQualifiedDrivers();
          return;
        }
        // Remove info bubble
        self.hereMaps.ui.getBubbles().forEach(function (bub) {
          self.hereMaps.ui.removeBubble(bub);
        });
        // Remove current drivers
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var object = _step11.value;

            if (object.id.indexOf('nearbyDrivers') > -1) {
              self.hereMaps.map.removeObject(object);
            }
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }

        self.$store.commit('dispatch/setDriversNearRsvp', [{
          id: id,
          phone: '' + r.countryCode + r.phone,
          firstName: r.firstName,
          lastName: r.lastName,
          photoUrl: r.avatarUrl,
          coords: {
            lat: self.qualifiedDrivers.list[0].home.lat,
            lng: self.qualifiedDrivers.list[0].home.lng
          },
          vehicle: {
            name: r.vehicle.manufacturer + ' ' + r.vehicle.model,
            licensePlate: r.vehicle.licensePlate,
            photoUrl: r.vehicle.photo
          },
          isQualified: true
        }]);
        self.mapLoader = {
          show: false,
          label: ''
        };
        self.$store.commit('dispatch/reduceQualifiedDrivers');
        self.driverPresentation = true;
        if (self.delayBeginDriverPresentation) {
          clearTimeout(self.delayBeginDriverPresentation);
        }
        self.delayBeginDriverPresentation = setTimeout(function () {
          self.beginDriverPresentation(true);
        }, 400);
        self.setDriverPin(showOnly);
        self.driverPresented = [];
        self.setCenter();
        // self.getUpcomingRes(id) // Show upcoming res
      });
    },
    getUpcomingRes: function getUpcomingRes(id) {
      var self = this;
      var pageSize = 5;
      var page = 1;
      var pickupSince = __WEBPACK_IMPORTED_MODULE_5_moment___default()();
      var pickupUntil = __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(1, 'days');
      self.upcoming.loading = true;
      self.upcoming.rsvp = null;

      self.$sdk.get('/provider/' + id + '/rsvp/upcoming', {
        token: self.$store.state.session.sessionToken,
        pageSize: pageSize,
        pageNum: page,
        pickupSince: pickupSince.format('YYYY-MM-DD'),
        pickupUntil: pickupUntil.format('YYYY-MM-DD')
      }, function (r) {
        self.upcoming.loading = false;
        if (r.error) {
          return;
        }

        if (r.list.length <= 0) {
          return;
        }
        self.upcoming.rsvp = r.list[0];
        self.displayDriverInfo(self.nearbyDrivers[0], 1);
      });
    },
    noQualifiedDrivers: function noQualifiedDrivers() {
      this.mapLoader = {
        show: false,
        label: ''
        // this.$store.commit('global/setAlertData', {
        //   show: true,
        //   message: 'No nearby drivers found.'
        // })
      };this.queueError = {
        show: true,
        message: 'No ' + this.lastDriverType + ' drivers found.'
      };
    },
    noQueueDrivers: function noQueueDrivers() {
      var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.mapLoader = {
        show: false,
        label: ''
      };
      this.queueError = {
        show: true,
        message: 'No qualified drivers found.'
      };
      if (r) this.buildReasons(r);
    },
    buildReasons: function buildReasons(r) {
      var list = [];

      var _loop = function _loop(key) {
        if (r.unqualified[key][0] === 'services') return 'continue';
        var driver = r.unfiltered.find(function (d) {
          return d.id == key;
        });
        if (driver) {
          list.push({
            id: driver.id,
            name: driver.name,
            reason: r.unqualified[key][0]
          });
        }
      };

      var _iteratorNormalCompletion12 = true;
      var _didIteratorError12 = false;
      var _iteratorError12 = undefined;

      try {
        for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(r.unqualified)), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
          var key = _step12.value;

          var _ret3 = _loop(key);

          if (_ret3 === 'continue') continue;
        }
      } catch (err) {
        _didIteratorError12 = true;
        _iteratorError12 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion12 && _iterator12.return) {
            _iterator12.return();
          }
        } finally {
          if (_didIteratorError12) {
            throw _iteratorError12;
          }
        }
      }

      this.$store.commit('global/setReasonsData', { list: list });
    },
    showReasons: function showReasons() {
      this.queueError.show = false;
      this.$store.commit('global/setReasonsData', {
        reasonsModal: true
      });
    }
  },
  watch: {
    rsvpInMap: function rsvpInMap(value) {
      var self = this;
      self.driverInfoIndex = 0;
      self.driverDistance = [];
      self.$store.commit('dispatch/removeAllDriversInMap');
      self.mapPins = [];
      self.current = {
        driversInMap: [],
        nearbyDrivers: [],
        openDriver: ''
      }, self.driverPresented = [];

      // remove pins and info window
      var _iteratorNormalCompletion13 = true;
      var _didIteratorError13 = false;
      var _iteratorError13 = undefined;

      try {
        for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
          var object = _step13.value;

          self.hereMaps.map.removeObject(object);
        }
      } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion13 && _iterator13.return) {
            _iterator13.return();
          }
        } finally {
          if (_didIteratorError13) {
            throw _iteratorError13;
          }
        }
      }

      self.hereMaps.ui.getBubbles().forEach(function (bub) {
        self.hereMaps.ui.removeBubble(bub);
      });

      if (value.id === null) {
        self.rsvp = null;
        self.route.rsvp = [];
        self.waiting.renderDriver.data = null;
        self.$store.commit('dispatch/clearDriverPopup');
        return;
      }
      self.rsvp = value;
      self.driverFilter = {
        show: false,
        isLoading: false,
        miles: 10,
        serviceTypes: [value.serviceClass]
      };

      if (value.isPackage) {
        value.route.forEach(function (loc, index) {
          value.route[index].packageID = value.id;
        });
        self.setMapPins(value.route);
      } else {
        var pickup = value.pickup;
        pickup.isPickup = true;
        var dropoff = value.dropoff;
        dropoff.isPickup = false;
        self.setMapPins([pickup, dropoff]);
      }

      if (value.hasExtraStop) {
        self.getExtraStops(value.id);
      }

      if (value.driver !== null) {
        var getDriverLocation = true;
        if (value.isPackage) {
          var rsvp = '';
          value.route.every(function (stop, index) {
            rsvp = value.rsvps.find(function (x) {
              return x.id === stop.rsvpID && ['ontheway', 'arrived', 'onboard'].indexOf(x.rsvpStatus) > -1;
            });
            return !rsvp ? true : false;
          });
          if (rsvp) {
            getDriverLocation = false;
          }
        }

        if (getDriverLocation) {
          __WEBPACK_IMPORTED_MODULE_8__modules_api_dispatch_drivers__["a" /* default */].getDriverInfo(self, value.driver.id, function (driver) {
            if (driver.error) {
              return;
            }
            self.updateDriverLocation(driver, true);
          });
        }
      }
    },
    driversInMap: function driversInMap(value) {
      var self = this;
      self.setDriverPin();
    },
    _rsvpInMapPickup: function _rsvpInMapPickup(value) {
      var self = this;
      if (value) {
        if (this.waiting.renderDriver.process && this.waiting.renderDriver.data) {
          this.waiting.renderDriver.process = false;
          var _driver = this.waiting.renderDriver.data;
          this.driverDistance.push({
            id: _driver.ID,
            distance: self.calculateDistance({ lat: _driver.tracks.lat, lng: _driver.tracks.lng }, { lat: value.lat, lng: value.lng })
          });
        }
      }
    },
    driverDistance: function driverDistance(value) {
      if (value && this.waiting.beginDriverPresentation) {
        this.waiting.beginDriverPresentation = false;
      }
    },
    driverPopupRoute: function driverPopupRoute(value) {
      if (value && value.id) {
        var self = this;
        var pageSize = 5;
        var page = 1;
        var pickupSince = __WEBPACK_IMPORTED_MODULE_5_moment___default()();
        var pickupUntil = __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(1, 'days');
        self.upcoming.loading = true;
        self.upcoming.rsvp = null;

        self.$sdk.get('/provider/' + value.id + '/rsvp/upcoming', {
          token: self.$store.state.session.sessionToken,
          pageSize: pageSize,
          pageNum: page,
          pickupSince: pickupSince.format('YYYY-MM-DD'),
          pickupUntil: pickupUntil.format('YYYY-MM-DD')
        }, function (r) {
          self.upcoming.loading = false;
          if (r.error) {
            return;
          }

          if (r.list.length <= 0) {
            return;
          }
          self.upcoming.rsvp = r.list[0];
        });
        return;
      }
    },

    'upcoming.rsvp': function upcomingRsvp(value) {
      var self = this;
      self.hereMaps.ui.getBubbles().forEach(function (bub) {
        // console.log('bub', bub)
      });
    },
    'driverFilter.show': function driverFilterShow(val) {
      if (val) {
        this.filterServices();
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    var rsvpInMap = self.$store.state.dispatch.rsvpInMap;
    if (rsvpInMap.id) {
      self.rsvp = self.$store.state.dispatch.rsvpInMap;
      self.mapPins = [rsvpInMap.pickup, rsvpInMap.dropoff];
      // self.routeRsvp()
    }

    var mapContainer = document.getElementById('mapHere');
    self.hereMaps.platform = new window.H.service.Platform({ apikey: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key });

    var defaultLayers = self.hereMaps.platform.createDefaultLayers();
    self.hereMaps.map = new window.H.Map(mapContainer, defaultLayers.vector.normal.map, {
      center: self.center,
      zoom: 13,
      pixelRatio: window.devicePixelRatio || 1
    });

    /* eslint-disable no-unused-vars */
    var behavior = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(self.hereMaps.map));
    /* eslint-enable no-unused-vars */
    self.hereMaps.ui = window.H.ui.UI.createDefault(self.hereMaps.map, defaultLayers);
  }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dispatch-modal',
  computed: {
    validationModal: function validationModal() {
      return this.$store.state.dispatch.validationModal;
    },
    actionModal: function actionModal() {
      return this.$store.state.dispatch.actionModal;
    }
  },
  methods: {
    close: function close() {
      this.$store.commit('dispatch/closeValidationModal');
    },
    closeDone: function closeDone() {
      this.$store.commit('dispatch/closeActionModal');
    }
  },
  mounted: function mounted() {
    var self = this;
    document.addEventListener('keydown', function (e) {
      if (self.validationModal.show && e.keyCode == 27) {
        self.$store.commit('dispatch/closeValidationModal');
      }
    });
  }
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dispatch-notification',
  computed: {
    notification: function notification() {
      return this.$store.state.dispatch.acceptNotification;
    },
    isSendAsSchedule: function isSendAsSchedule() {
      return this.notification.isSendAsSchedule;
    },
    sendAsScheduleData: function sendAsScheduleData() {
      return this.$store.state.dispatch.schedule;
    }
  },
  methods: {
    close: function close() {
      this.$store.commit('dispatch/hideDispatchAcceptNotification');
    }
  }
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dispatch-schedule',
  computed: {
    show: function show() {
      return this.$store.state.dispatch.schedule.show;
    },
    loading: function loading() {
      return this.$store.state.dispatch.schedule.loading;
    },
    loadingMsg: function loadingMsg() {
      return this.$store.state.dispatch.schedule.loadingMsg;
    },
    accepted: function accepted() {
      return this.$store.state.dispatch.schedule.accepted;
    },
    error: function error() {
      return this.$store.state.dispatch.schedule.error;
    }
  },
  methods: {
    closeModal: function closeModal() {
      if (this.loading) {
        return;
      }
      this.$store.commit('dispatch/setScheduleShow', false);
      this.$store.commit('dispatch/setScheduleAccepted', false);
      this.$store.commit('dispatch/setScheduleError', '');
    }
  }
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationsTable_vue__ = __webpack_require__(452);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32808ac0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationsTable_vue__ = __webpack_require__(1287);
function injectStyle (ssrContext) {
  __webpack_require__(1264)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32808ac0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32808ac0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_LoadingAnimation_ArrowUp__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Partials_LoadingAnimation_Ellipsis__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReservationControls__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ReservationRow__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotificationNewBooking__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_api_dispatch_reservations__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reservations-table',
  components: {
    ArrowUp: __WEBPACK_IMPORTED_MODULE_0__components_Partials_LoadingAnimation_ArrowUp__["a" /* default */], EllipsisLoader: __WEBPACK_IMPORTED_MODULE_1__components_Partials_LoadingAnimation_Ellipsis__["a" /* default */], ReservationControls: __WEBPACK_IMPORTED_MODULE_2__ReservationControls__["a" /* default */],
    ReservationRow: __WEBPACK_IMPORTED_MODULE_3__ReservationRow__["a" /* default */], NotificationNewBooking: __WEBPACK_IMPORTED_MODULE_4__NotificationNewBooking__["a" /* default */]
  },
  props: ['isShort', 'shrink'],
  data: function data() {
    return {
      isPageLoading: false,
      isLoadingNext: false,
      isLoadingBack: false,
      isSorting: false,
      scrollLoading: false,
      isMobile: false
    };
  },

  computed: {
    itemsToShow: function itemsToShow() {
      return this.$store.state.dispatch.rsvpInTable;
    },
    isFetchingData: function isFetchingData() {
      return this.$store.state.dispatch.fetching;
    },
    emptyData: function emptyData() {
      var self = this;
      var noDataFound = self.$store.state.dispatch.noDataFound;

      if (noDataFound) {
        return {
          title: self.$t('dispatch.rsvpTable.noData.title'),
          content: self.$t('dispatch.rsvpTable.noData.content')
        };
      }

      return {
        title: self.$t('dispatch.rsvpTable.emptyRsvp.title'),
        content: self.$t('dispatch.rsvpTable.emptyRsvp.content')
      };
    },

    checkedAll: {
      get: function get() {
        var self = this;
        return self.$store.state.dispatch.checkedReservations.length === self.$store.state.dispatch.rsvpInTable.length;
      },
      set: function set(value) {
        var self = this;
        var rsvps = self.$store.state.dispatch.rsvpInTable;
        var checkedItems = [];
        if (value) {
          for (var i = 0; i < rsvps.length; i++) {
            checkedItems.push({
              id: rsvps[i].id,
              isPackage: rsvps[i].isPackage,
              status: rsvps[i].statusClass
            });
          }
        }
        self.$store.commit('dispatch/updateCheckedReservations', checkedItems);
      }
    },
    totalPages: function totalPages() {
      return this.$store.state.dispatch.rsvpPaging.totalPages;
    },

    currentPage: {
      get: function get() {
        return this.$store.state.dispatch.rsvpPaging.currentPage;
      },
      set: function set(value) {
        this.$store.commit('dispatch/setRsvpCurrentPage', value);
      }
    },
    rsvpSort: function rsvpSort() {
      return this.$store.state.dispatch.rsvpSort;
    },
    rtgSuccess: function rtgSuccess() {
      return this.$store.state.dispatch.readyToGo.success;
    },
    showDriverPayment: function showDriverPayment() {
      return this.$settings.get('DispatchShowDriverPayment');
    }
  },
  methods: {
    setScreenSize: function setScreenSize() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    pageBtn: function pageBtn(isNext) {
      var self = this;
      var pageChange = isNext ? 1 : -1;
      if (isNext) {
        self.isLoadingNext = true;
      } else {
        self.isLoadingBack = true;
      }
      self.$store.commit('dispatch/setRsvpCurrentPage', self.$store.state.dispatch.rsvpPaging.currentPage + pageChange);
      self.loadPage();
    },
    loadPage: function loadPage() {
      var self = this;
      // self.isPageLoading = true
      __WEBPACK_IMPORTED_MODULE_5__modules_api_dispatch_reservations__["a" /* default */].getReservations(self, function (r) {
        // self.isPageLoading = false
        self.isLoadingBack = false;
        self.isLoadingNext = false;
        self.scrollLoading = false;

        if (r.error) {
          return;
        }

        // self.$plugins.smoothScroll.scrollTo(document.getElementById('rsvp-table-container'))
      }, true);
    },
    sort: function sort(order) {
      var self = this;
      var existingOrder = self.rsvpSort.order;
      var existingAsc = self.rsvpSort.asc;
      var asc = existingAsc;
      if (order === existingOrder) {
        asc = !existingAsc;
      }

      self.$store.commit('dispatch/setRsvpSort', {
        order: order, asc: asc
      });

      self.isSorting = true;
      self.$store.commit('dispatch/setRsvpCurrentPage', 1);
      __WEBPACK_IMPORTED_MODULE_5__modules_api_dispatch_reservations__["a" /* default */].getReservations(self, function (r) {
        self.isSorting = false;
        if (r.error) {
          return;
        }
      }, true);
    },
    onScroll: function onScroll(event) {
      // console.log(event)
      var rsvpPaging = this.$store.state.dispatch.rsvpPaging;
      if (this.scrollLoading || rsvpPaging.currentPage >= rsvpPaging.totalPages) {
        return;
      }

      var scrollAndView = event.target.scrollTop + event.target.offsetHeight;
      // console.log(event.target.scrollHeight - scrollAndView)
      if (event.target.scrollHeight - scrollAndView < 150) {
        this.scrollLoading = true;
        this.$store.commit('dispatch/setRsvpCurrentPage', this.$store.state.dispatch.rsvpPaging.currentPage + 1);
        this.loadPage();
      }
    }
  },
  mounted: function mounted() {
    this.setScreenSize();
  },

  watch: {
    rtgSuccess: function rtgSuccess(value) {
      if (value) {
        this.$store.commit('dispatch/setReadyToGoSuccess', false);
        this.loadPage();
      }
    }
  }
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reservation-controls',
  props: ['shrink'],
  data: function data() {
    return {
      rsvpQueue: [],
      errorQueue: [],
      successQueue: []
    };
  },

  computed: {
    hasRSVPControl: function hasRSVPControl() {
      return this.$store.state.session.user.access.hasOwnProperty('PageAdminRsvpControl');
    }
  },
  methods: {
    initMoveToPool: function initMoveToPool() {
      this.errorQueue = [];
      this.successQueue = [];
      this.rsvpQueue = [];
      this.rsvpQueue = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$store.state.dispatch.checkedReservations));

      if (!this.rsvpQueue.length) {
        this.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Select atleast 1 reservation/package.'
        });
        return;
      }

      if (!this.isStatusValid(this.rsvpQueue)) {
        this.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You can only move Upcoming, Requires Dispatch and Ready to Go reservations/packages to the pool.'
        });
        return;
      }

      this.$store.commit('dispatch/showActionModal', 'Moving ' + (this.rsvpQueue.length > 1 ? 'items' : 'item') + ' to pool...');
      this.moveToPool();
    },
    moveToPool: function moveToPool() {
      var self = this;
      // let rsvps = self.$store.state.dispatch.checkedReservations
      // if (!self.isValid('Please select only 1 reservation/package to move to the pool.')) {
      //   return
      // }

      // if (!self.isStatusValid(rsvps)) {
      //   self.$store.commit('dispatch/showValidationModal', {
      //     title: 'Oops. You missed something.',
      //     message: 'You can only move Upcoming, Requires Dispatch and Ready to Go reservations/packages to the pool.'
      //   })
      //   return
      // }

      var rsvp = this.rsvpQueue[0];
      var url = '/admin/rsvp/';
      if (rsvp.isPackage) {
        url = '/admin/package/';
      }
      // self.$store.commit('dispatch/showActionModal', `Moving ${(rsvp.isPackage ? ' package ' : ' reservation ')} to pool...`)

      self.$sdk.post(url + rsvp.id + '/pool', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) self.errorQueue.push(rsvp);else self.successQueue.push(rsvp);

        self.rsvpQueue.shift();
        if (self.rsvpQueue.length) {
          self.moveToPool();
        } else {
          if (!self.successQueue.length && self.errorQueue.length) {
            self.$store.commit('dispatch/completeActionModal', {
              success: false,
              message: 'Something went wrong. Try again later.'
            });
          } else {
            self.$store.commit('dispatch/clearCheckedRsvps');
            var success = [];
            var error = [];
            self.successQueue.forEach(function (item) {
              success.push(item.isPackage ? 'PKG' + item.id : 'RSVP' + item.id);
            });
            self.errorQueue.forEach(function (item) {
              error.push(item.isPackage ? 'PKG' + item.id : 'RSVP' + item.id);
            });
            var msg = 'Successfully moved ' + success.join(', ') + ' to pool.';
            if (error.length) {
              msg += '<br/>The following items failed to move to pool: ' + error.join(', ');
            }
            self.$store.commit('dispatch/completeActionModal', {
              success: true,
              message: msg
            });
          }
        }

        // if (r.error) {
        //   self.$store.commit('dispatch/completeActionModal', {
        //     success: false,
        //     message: 'Something went wrong. Try again later.'
        //   })
        // } else {
        //   self.$store.commit('dispatch/clearCheckedRsvps')
        //   self.$store.commit('dispatch/completeActionModal', {
        //     success: true,
        //     message: 'Successfully moved ' +
        //       (rsvp.isPackage ? ' package ' : ' reservation ') +
        //       rsvp.id + ' to pool.'
        //   })
        // }
        // setTimeout ( () => {
        //   self.$store.commit('dispatch/closeActionModal')
        // }, 1000)
      });
    },
    removeFromPool: function removeFromPool() {
      var self = this;
      var rsvps = self.$store.state.dispatch.checkedReservations;
      if (rsvps.length !== 1) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select only 1 reservation/package to remove from the pool'
        });
        return;
      }

      if (['upcoming', 'requires-dispatch'].indexOf(rsvps[0].status) === -1) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You can only remove Upcoming and Requires Dispatch reservations/packages from the pool.'
        });
        return;
      }

      var rsvp = rsvps[0];
      var url = '/admin/rsvp/';
      var type = 'reservation';
      if (rsvp.isPackage) {
        url = '/admin/package/';
        type = 'package';
      }

      self.$store.commit('dispatch/showActionModal', 'Removing ' + type + ' from pool...');
      self.$sdk.delete(url + rsvp.id + '/pool', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: 'Something went wrong. Try again later.'
          });
        } else {
          self.$store.commit('dispatch/clearCheckedRsvps');
          self.$store.commit('dispatch/completeActionModal', {
            success: true,
            message: 'Successfully removed ' + type + ' ' + rsvp.id + ' from pool.'
          });
        }

        setTimeout(function () {
          self.$store.commit('dispatch/closeActionModal');
        }, 1000);
      });
    },
    markAsComplete: function markAsComplete() {
      var self = this;
      if (!self.hasRSVPControl) return;

      var rsvps = self.$store.state.dispatch.checkedReservations;
      if (!self.isValid('Please select only 1 reservation/package to mark as complete.')) {
        return;
      }

      if (!self.canMarkAsComplete(rsvps)) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You cannot mark as complete Cancelled or Completed reservations/packages.'
        });
        return;
      }

      var rsvp = rsvps[0];

      self.$store.commit('reservationNotes/show', {
        show: true,
        rsvpId: rsvp.id,
        isPackage: rsvp.isPackage,
        forComplete: true
      });
      return;
    },
    autoDispatch: function autoDispatch() {
      var self = this;
      var rsvps = self.$store.state.dispatch.checkedReservations;

      if (!self.isValid('Please select only 1 reservation/package to auto dispatch.')) {
        return;
      }

      if (!self.isStatusValid(rsvps)) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You can only auto-dispatch Upcoming, Requires Dispatch and Ready to Go reservations/packages.'
        });
        return;
      }

      var rsvp = rsvps[0];

      // let url = '/admin/rsvp/'
      var url = '/reservation/';
      if (rsvp.isPackage) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Invalid Action',
          message: 'Auto-dispatching a package is not allowed.'
        });
        return;
      }
      self.$store.commit('dispatch/showActionModal', 'Auto-dispatching' + (rsvp.isPackage ? ' package' : ' reservation') + '...');

      self.$sdk.post(url + rsvp.id + '/autodispatch', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        console.log(r);
        if (r.error) {
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: 'Something went wrong. Try again later.'
          });
        } else {
          self.$store.commit('dispatch/removeRsvpInTable', rsvp);
          self.$store.commit('dispatch/clearCheckedRsvps');
          self.$store.commit('dispatch/completeActionModal', {
            success: true,
            message: 'Successfully auto-dispatched ' + (rsvp.isPackage ? ' package ' : ' reservation ') + rsvp.id + '.'
          });
        }

        setTimeout(function () {
          self.$store.commit('dispatch/closeActionModal');
        }, 1000);
      }, '2.0');
    },
    isValid: function isValid(message) {
      var self = this;
      var rsvps = self.$store.state.dispatch.checkedReservations;
      if (rsvps.length !== 1) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: message
        });
        return false;
      }
      return true;
    },
    isStatusValid: function isStatusValid(items) {
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (item.status === 'complete' || item.status === 'completed' || item.status === 'canceled' || item.status === 'onboard' || item.status === 'dispatched') {
          return false;
        }
      }
      return true;
    },
    canMarkAsComplete: function canMarkAsComplete(items) {
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (item.status === 'complete' || item.status === 'completed' || item.status === 'canceled') {
          return false;
        }
      }
      return true;
    }
  }
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Partials_SVG_ServiceDog__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Partials_SVG_Wheelchair__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_flight_info__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reservation-row',
  props: ['rsvp', 'isShort', 'shrink', 'isMobile'],
  data: function data() {
    return {
      flightStatus: null,
      timerDelay: '',
      isCollapsible: false,
      timer: 20,
      checkingDriver: false
    };
  },

  components: {
    SvgDog: __WEBPACK_IMPORTED_MODULE_1__components_Partials_SVG_ServiceDog__["a" /* default */], SvgWheelchair: __WEBPACK_IMPORTED_MODULE_2__components_Partials_SVG_Wheelchair__["a" /* default */]
  },
  computed: {
    checkedReservations: {
      get: function get() {
        return this.$store.state.dispatch.checkedReservations;
      },
      set: function set(value) {
        this.$store.commit('dispatch/updateCheckedReservations', value);
      }
    },
    loadingRsvpId: function loadingRsvpId() {
      return this.$store.state.dispatch.loadingRsvpId;
    },
    rsvpInMap: function rsvpInMap() {
      return this.$store.state.dispatch.rsvpInMap;
    },
    useOldQuatation: function useOldQuatation() {
      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation;
    },
    showDriverPayment: function showDriverPayment() {
      return this.$settings.get('DispatchShowDriverPayment');
    }
  },
  methods: {
    showFlightInfo: function showFlightInfo() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3__modules_api_flight_info__["a" /* default */].loadFlightInfo(self, self.rsvp, function (r) {
        if (r.error) {
          self.flightStatus = { label: 'On Time', class: 'ontime' };
          return;
        }
        self.flightStatus = self.translateFlightStatus(r.status);
      });
    },
    getFlightStatus: function getFlightStatus() {
      var self = this;
      if (self.rsvp.airlineCode === null || self.rsvp.statusClass === 'complete' || self.rsvp.statusClass === 'completed' || self.rsvp.statusClass === 'canceled') {
        self.flightStatus = null;
        return;
      }

      var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.rsvp.pickupTime, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__["a" /* default */].timeFormat(self, false));
      var airlineDate = encodeURIComponent(date.format('YYYY-MM-DD'));
      var airlineTime = encodeURIComponent(date.format('HH:mm:ss'));
      var flightNumber = self.rsvp.flightNumber || self.rsvp.dropoffFlightNumber;
      var isDeparture = '&departure=0';
      if ((self.rsvp.airline === null || self.rsvp.airline === '') && self.rsvp.dropoffAirline !== null && self.rsvp.dropoffAirline !== '') {
        isDeparture = '&departure=1';
      }
      var url = '/availability/flights/' + self.rsvp.airlineCode + flightNumber + '?date=' + airlineDate + '&time=' + airlineTime + '&airport=' + self.rsvp.airportCode + isDeparture;
      self.$sdk.get(url, {}, function (r) {
        if (r.error) {
          self.flightStatus = { label: 'On Time', class: 'ontime' };
          return;
        }
        self.flightStatus = self.translateFlightStatus(r.status);
      });
    },
    translateFlightStatus: function translateFlightStatus(status) {
      switch (status) {
        case 'Scheduled':
          return { label: 'On Time', class: 'ontime' };
        case 'Proposed':
          return { label: 'On Time', class: 'ontime' };
        case 'OutGate':
          return { label: 'On Time', class: 'ontime' };
        case 'InAir':
          return { label: 'On Air', class: 'onair' };
        case 'Landed':
          return { label: 'Arrived', class: 'arrived' };
        case 'InGate':
          return { label: 'Arrived', class: 'arrived' };
        case 'Expected':
          return { label: 'On Time', class: 'ontime' };
        case 'NoTakeOffInfo':
          return { label: 'On Time', class: 'ontime' };
        case 'Delayed':
          return { label: 'Delayed', class: 'delayed' };
        case 'Cancelled':
          return { label: 'Cancelled', class: 'cancelled' };
        case 'Unknown':
          return { label: 'On Time', class: 'ontime' };
        case 'PastFlight':
          return { label: 'Arrived', class: 'arrived' };
        case 'Original':
          return { label: 'On Time', class: 'ontime' };
      }
      return { label: 'On Time', class: 'ontime' };
    },
    showOnMap: function showOnMap() {
      var self = this;

      if (self.rsvpInMap.id === self.rsvp.id) {
        // remove from the map
        self.$store.commit('dispatch/removeRsvpInMap');
        self.$store.commit('dispatch/clearDriverPopup');
        if (self.rsvp.driver !== null) {
          self.$store.commit('dispatch/removeDriverInMap', self.rsvp.driver);
        }
        return;
      }

      if (self.rsvpInMap.id !== null && self.rsvpInMap.driver !== null) {
        self.$store.commit('dispatch/removeDriverInMap', self.rsvpInMap.driver);
      }
      self.$store.commit('dispatch/setRsvpInMap', self.rsvp);
    },
    getAddress: function getAddress(location) {
      if (location.geofenceType === 'airport' && location.geofenceName !== '') {
        var result = location.geofenceName;
        if (location.terminal && location.terminal !== '' && location.terminal !== 'undefined') {
          result += ' - Terminal ' + location.terminal;
        }
        return result;
      }
      return location.title;

      // let address = ''
      // if (location.address2 && location.address2 !== '' && location.address2 !== 'undefined') {
      //   address = address + location.address2 + ' '
      // }
      // if (location.address1) {
      //   address = address + location.address1 + ', '
      // }
      // if (location.city) {
      //   address = address + location.city + ' '
      // }
      // if (location.state) {
      //   address = address + location.state + ' '
      // }
      // if (location.zip) {
      //   address = address + location.zip
      // }

      // return address
    },
    getName: function getName(contact) {
      if (contact === null) {
        return 'N/A';
      }
      return contact.firstName + ' ' + contact.lastName;
    },
    callPhone: function callPhone(customer) {
      var self = this;
      self.$plugins.phone.startCall(self, {
        phone: customer.phone,
        name: customer.firstName + ' ' + customer.lastName
      });
    },
    resStatus: function resStatus(rsvp) {
      if (rsvp.status === 'DISPATCHED') {
        if (['ontheway', 'arrived'].indexOf(rsvp.resStatus) > -1) {
          return 'on-time';
        }

        var pickupTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(rsvp.pickupTime, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
        var pickupTime1 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateCriticalMins'), 'minutes').format('X'));
        var pickupTime115 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateWarningMins'), 'minutes').format('X'));
        var currentTime = parseInt(__WEBPACK_IMPORTED_MODULE_0_moment___default()().format('X'));
        if (rsvp.isPackage && rsvp.rsvps.length) {
          var isOnTheWay = false;
          rsvp.rsvps.forEach(function (_rsvp) {
            if (_rsvp.resStatus === 'ontheway') {
              isOnTheWay = true;
            }
          });
          if (isOnTheWay) {
            return 'on-time';
          }
        }
        if (pickupTime1 <= currentTime) {
          return 'very-late';
        }
        if (pickupTime115 <= currentTime) {
          return 'late';
        }
        if (rsvp.resStatus === 'upcoming') {
          return 'accepted';
        }
      }

      // if (rsvp.status === 'UPCOMING') {
      //   let pickupTime = moment(rsvp.pickupTime, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      //   let pickupTime1 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchCriticalMins'), 'minutes').format('X'))
      //   let pickupTime115 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchWarningMins'), 'minutes').format('X'))
      //   let currentTime = parseInt(moment().format('X'))
      //   if (pickupTime1 <= currentTime) { return 'no-driver-urgent' }
      //   if (pickupTime115 <= currentTime) { return 'no-driver' }
      // }
      return '';
    },
    runTimer: function runTimer() {
      var self = this;
      var rsvp = self.rsvp;
      var pickupTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(rsvp.pickupTime, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
      var currentTime = parseInt(__WEBPACK_IMPORTED_MODULE_0_moment___default()().format('X'));

      if (rsvp.status === 'DISPATCHED') {
        var pickupTime1 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateCriticalMins'), 'minutes').format('X'));
        var pickupTime115 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateWarningMins'), 'minutes').format('X'));
        if (pickupTime1 <= currentTime || pickupTime115 <= currentTime) {
          self.$forceUpdate();
          // return
        }
      }

      // if (rsvp.status === 'UPCOMING') {
      //   let pickupTime1 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchCriticalMins'), 'minutes').format('X'))
      //   let pickupTime115 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchWarningMins'), 'minutes').format('X'))
      //
      //   if (pickupTime1 <= currentTime || pickupTime115 <= currentTime) {
      //     self.$forceUpdate()
      //     // return
      //   }
      // }

      var index = self.$store.state.dispatch.rsvpInTable.findIndex(function (x) {
        return x.id === rsvp.id;
      });
      if (self.timerDelay && index < 0) {
        clearTimeout(self.timerDelay);
      }
      self.timerDelay = setTimeout(function () {
        self.runTimer();
      }, 5000);
    },
    showRTG: function showRTG(id) {
      this.$store.commit('dispatch/setReadyToGoID', id);
      this.$store.commit('dispatch/setReadyToGoShow', true);
    },
    showNotes: function showNotes(notes) {
      this.$store.commit('dispatch/setNotesMessage', notes);
      this.$store.commit('dispatch/setNotesShow', true);
    },
    acceptedRTGStatus: function acceptedRTGStatus(status) {
      return ['UPCOMING', 'REQUIRES DISPATCH', 'DISPATCHED'].indexOf(status) > -1;
    },
    startPendingOfferTimer: function startPendingOfferTimer() {
      var _this = this;

      var self = this;
      if (self.timer < 0) {
        self.checkingDriver = true;
        self.$sdk.get('/admin/rsvp/' + self.rsvp.id, {
          token: self.$store.state.session.sessionToken
        }, function (r) {
          self.checkingDriver = false;
          if (!r.error) {
            var statusClass = r.dispatchStatus;
            var status = r.dispatchStatus.toUpperCase();
            if (statusClass === 'requires_dispatch') {
              statusClass = 'requires-dispatch';
              status = 'REQUIRES DISPATCH';
            }
            if (statusClass === 'autodispatch') {
              statusClass = 'auto-dispatch';
              status = 'AUTO DISPATCH';
            }
            if (statusClass === 'complete') {
              status = 'COMPLETED';
            }
            if (statusClass === 'ready') {
              status = 'READY TO GO';
            }
            _this.$store.commit('dispatch/updateRsvpStatus', {
              id: _this.rsvp.id,
              status: status,
              statusClass: statusClass,
              resStatus: r.status
            });
          }
          _this.$store.commit('dispatch/setPendingOffer', {
            id: _this.rsvp.id,
            show: false,
            timer: 0
          });
        });
        return;
      }
      setTimeout(function () {
        self.timer--;
        self.startPendingOfferTimer();
      }, 1000);
    }
  },
  watch: {
    rsvp: function rsvp(value) {
      // this.getFlightStatus()
    },
    'rsvp.pendingOffer': function rsvpPendingOffer(val) {
      this.timer = val.timer;
      if (this.timer) this.startPendingOfferTimer();
    }
  },
  mounted: function mounted() {
    var self = this;
    // self.getFlightStatus()
    self.runTimer();
  }
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_dispatch_reservations__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notification-new-booking',
  computed: {
    notification: function notification() {
      return this.$store.state.dispatch.notificationNewBooking;
    }
  },
  methods: {
    loadData: function loadData() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0__modules_api_dispatch_reservations__["a" /* default */].updateReservationTable(self, self.notification.id);
    }
  }
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationFilter_vue__ = __webpack_require__(457);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3126d038_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationFilter_vue__ = __webpack_require__(1290);
function injectStyle (ssrContext) {
  __webpack_require__(1288)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3126d038"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3126d038_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_dispatch_reservations__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_dispatch_drivers__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_routing_reservations__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reservation-filter',
  props: ['forRouting', 'addCustom'],
  computed: {
    filters: function filters() {
      return this.$store.state.reservation.reservationFilters;
    },

    selectedFilter: {
      get: function get() {
        return this.$store.state.reservation.selectedFilter;
      },
      set: function set(value) {
        var selected = value;
        if (value !== 'custom') {
          selected = parseInt(value);
        }
        this.$store.commit('reservation/setSelectedFilter', selected);
      }
    }
  },
  methods: {
    filterRsvp: function filterRsvp() {
      var self = this;
      if (self.forRouting) {
        console.log('For Routing');
        __WEBPACK_IMPORTED_MODULE_2__modules_api_routing_reservations__["a" /* default */].getReservations(self, {});
        return;
      }

      // save filter
      if (self.selectedFilter !== -1 && self.selectedFilter !== 'custom') {
        self.$plugins.storage.set('ADMIN_DISPATCH_FILTER', self.filters[self.selectedFilter].id);
      } else {
        self.$plugins.storage.remove('ADMIN_DISPATCH_FILTER');
      }
      self.$store.commit('dispatch/resetRsvpPaging');
      __WEBPACK_IMPORTED_MODULE_0__modules_api_dispatch_reservations__["a" /* default */].getReservations(self);
      __WEBPACK_IMPORTED_MODULE_1__modules_api_dispatch_drivers__["a" /* default */].getStagingDrivers(self);
    }
  }
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationSearch_vue__ = __webpack_require__(459);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eee6771_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationSearch_vue__ = __webpack_require__(1293);
function injectStyle (ssrContext) {
  __webpack_require__(1291)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4eee6771"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eee6771_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_dispatch_reservations__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reservation-search',
  computed: {
    searchInput: {
      get: function get() {
        return this.$store.state.reservation.reservationSearch;
      },
      set: function set(value) {
        this.$store.commit('reservation/setReservationSearch', value);
      }
    }
  },
  methods: {
    submitSearch: function submitSearch() {
      var self = this;
      self.$store.commit('dispatch/resetRsvpPaging');
      __WEBPACK_IMPORTED_MODULE_0__modules_api_dispatch_reservations__["a" /* default */].getReservations(self);
      __WEBPACK_IMPORTED_MODULE_0__modules_api_dispatch_reservations__["a" /* default */].getLastSync(self);
    },
    clearSearch: function clearSearch() {
      var self = this;
      self.$store.commit('reservation/resetReservationSearch');
      self.$store.commit('dispatch/resetRsvpPaging');
      __WEBPACK_IMPORTED_MODULE_0__modules_api_dispatch_reservations__["a" /* default */].getReservations(self);
    }
  }
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MoreFilter_vue__ = __webpack_require__(461);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40480ee0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MoreFilter_vue__ = __webpack_require__(1296);
function injectStyle (ssrContext) {
  __webpack_require__(1294)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40480ee0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MoreFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40480ee0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MoreFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_services__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_dispatch_reservations__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dispatch-more-filter',
  props: ['shrink'],
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a },
  data: function data() {
    return {
      hasError: {
        from: false,
        to: false,
        fromToMsg: '',
        serviceMsg: '',
        statusMsg: ''
      },
      firstBrand: false,
      openBrand: [],
      selectedBrand: [],
      selectedAllServices: false,
      selectedService: [],
      maxHour: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    };
  },

  computed: {
    date: function date() {
      return this.$store.state.reservation.date;
    },
    dateFrom: function dateFrom() {
      var date = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.date.from, 'MM/DD/YYYY hh:mmA');
      return {
        date: date.format('MM/DD/YYYY'),
        hour: date.format('hh'),
        minute: date.format('mm'),
        amPm: date.format('A')
      };
    },
    dateTo: function dateTo() {
      var date = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.date.to, 'MM/DD/YYYY hh:mmA');
      return {
        date: date.format('MM/DD/YYYY'),
        hour: date.format('hh'),
        minute: date.format('mm'),
        amPm: date.format('A')
      };
    },
    service: function service() {
      return this.$store.state.reservation.service;
    },
    status: function status() {
      return this.$store.state.reservation.status;
    },
    isLoading: function isLoading() {
      return this.$store.state.transactions.loading;
    },
    serviceData: function serviceData() {
      return this.$store.state.settings.serviceData;
    },
    useOldQuatation: function useOldQuatation() {
      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation;
    },
    brands: function brands() {
      return this.$store.state.brands.list;
    }
  },
  methods: {
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(date, 'MM/DD/YYYY').format('MM/DD/YYYY');
    },
    changeDate: function changeDate(type) {
      // this.$store.commit('transactions/setDate', 'custom')

      this.hasError[type] = false;

      var format = 'MM/DD/YYYY hh:mmA';
      var selectedTime = '';
      var target = type === 'from' ? this.dateFrom : this.dateTo;

      selectedTime = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(target.date);
      selectedTime = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(selectedTime.format('MM/DD/YYYY') + ' ' + target.hour + ':' + target.minute + target.amPm, 'MM/DD/YYYY hh:mmA');
      this.$store.commit('reservation/setDateFilter', {
        fromTo: type,
        value: selectedTime.format(format)
      });
    },
    changeTime: function changeTime(type) {
      var target = type === 'from' ? this.dateFrom : this.dateTo;
      this.$store.commit('reservation/setDateFilter', {
        fromTo: type,
        value: target.date + ' ' + target.hour + ':' + target.minute + target.amPm
      });
    },
    clearDates: function clearDates() {
      this.hasError.from = false;
      this.hasError.to = false;
      this.hasError.fromToMsg = '';

      this.$store.commit('reservation/setDateFilter', { fromTo: 'from', value: '' });
      this.$store.commit('reservation/setDateFilter', { fromTo: 'to', value: '' });
    },
    selectService: function selectService(service) {
      this.hasError.serviceMsg = '';
      this.$store.commit('reservation/setService', {
        service: service,
        value: !this.service[service]
      });
    },
    selectStatus: function selectStatus(status) {
      this.$store.commit('reservation/setStatus', {
        status: status,
        value: !this.status[status]
      });
    },
    applyFilter: function applyFilter() {
      this.hasError.from = false;
      this.hasError.to = false;
      this.hasError.fromToMsg = '';

      if (this.date.from === '' && this.date.to !== '' || this.date.from !== '' && this.date.to === '') {
        if (this.date.from === '') {
          this.hasError.from = true;
        }
        if (this.date.to === '') {
          this.hasError.to = true;
        }
        this.hasError.fromToMsg = this.$t('dispatch.filter.emptyDate');
        return;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.date.from, 'MM/DD/YYYY').format('x') > __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.date.to, 'MM/DD/YYYY').format('x')) {
        this.hasError.from = true;
        this.hasError.to = true;
        this.hasError.fromToMsg = this.$t('dispatch.filter.invalidDateRange');
        return;
      }

      var hasSelectedService = false;
      this.$store.commit('dispatch/setFilterService', []);
      if (!this.useOldQuatation) {
        if (this.selectedService.length) {
          hasSelectedService = true;
          this.$store.commit('dispatch/setFilterService', this.selectedService);
        }
      } else {
        for (var service in this.service) {
          if (this.service[service]) {
            hasSelectedService = true;
          }
        }
      }

      if (!hasSelectedService) {
        this.hasError.serviceMsg = 'Please select at least one service type.'; //this.$t('dispatch.filter.noServiceSelected')
        return;
      }

      var hasSelectedStatus = false;
      for (var status in this.status) {
        if (this.status[status]) {
          hasSelectedStatus = true;
        }
      }

      if (!hasSelectedStatus) {
        this.hasError.statusMsg = this.$t('dispatch.filter.noServiceStatus');
        return;
      }

      this.close();
      this.$store.commit('dispatch/setRsvpCurrentPage', 1);
      __WEBPACK_IMPORTED_MODULE_3__modules_api_dispatch_reservations__["a" /* default */].getReservations(this);
      __WEBPACK_IMPORTED_MODULE_3__modules_api_dispatch_reservations__["a" /* default */].getLastSync(this);
    },
    close: function close() {
      this.$emit('close');
    },
    serviceLabel: function serviceLabel(code) {
      return __WEBPACK_IMPORTED_MODULE_2__modules_api_services__["a" /* default */].getServiceName(code);
    },
    serviceList: function serviceList(brandId) {
      var serviceList = this.$store.state.services.list.filter(function (x) {
        return x.brandId === brandId;
      });
      if (!this.firstBrand && serviceList.length) {
        // this.openBrand.push(brandId)
        // this.firstBrand = true
      }
      return serviceList;
    },
    toggleBrand: function toggleBrand(brandId) {
      if (this.openBrand.indexOf(brandId) > -1) {
        var index = this.openBrand.indexOf(brandId);
        this.openBrand.splice(index, 1);
      } else {
        if (this.openBrand.indexOf(brandId) === -1) {
          this.openBrand.push(brandId);
        }
      }
    },
    toggleService: function toggleService(serviceId, brandId) {
      var _this = this;

      if (this.selectedService.indexOf(serviceId) > -1) {
        var index = this.selectedService.indexOf(serviceId);
        this.selectedService.splice(index, 1);
      } else {
        this.selectedService.push(serviceId);
      }

      var services = this.serviceList(brandId);
      var checkServices = services.map(function (brand) {
        return brand.id;
      });
      if (checkServices.every(function (id) {
        return _this.selectedService.includes(id);
      })) {
        if (this.selectedBrand.indexOf(brandId) === -1) {
          this.selectedBrand.push(brandId);
        }
      } else {
        if (this.selectedBrand.indexOf(brandId) > -1) {
          var _index = this.selectedBrand.indexOf(brandId);
          this.selectedBrand.splice(_index, 1);
        }
      }
    },
    selectAllBrands: function selectAllBrands() {
      var _this2 = this;

      var brands = this.brands;
      if (!this.selectedAllServices) {
        brands.forEach(function (brand) {
          if (_this2.selectedBrand.indexOf(brand.id) === -1) {
            _this2.selectedBrand.push(brand.id);
          }
          if (_this2.openBrand.indexOf(brand.id) === -1) {
            _this2.openBrand.push(brand.id);
          }
          var services = _this2.serviceList(brand.id);
          services.forEach(function (service) {
            if (_this2.selectedService.indexOf(service.id) === -1) {
              _this2.selectedService.push(service.id);
            }
          });
        });
      } else {
        this.selectedBrand = [];
        this.selectedService = [];
      }
      this.selectedAllServices = !this.selectedAllServices;
    },
    selectBrand: function selectBrand(brandId) {
      var _this3 = this;

      var services = this.serviceList(brandId);
      if (this.selectedBrand.indexOf(brandId) > -1) {
        var index = this.selectedBrand.indexOf(brandId);
        this.selectedBrand.splice(index, 1);
        services.forEach(function (service) {
          var index = _this3.selectedService.indexOf(service.id);
          _this3.selectedService.splice(index, 1);
        });
        this.selectedAllServices = false;
      } else {
        if (this.selectedBrand.indexOf(brandId) === -1) {
          this.selectedBrand.push(brandId);
        }
        services.forEach(function (service) {
          if (_this3.selectedService.indexOf(service.id) === -1) {
            _this3.selectedService.push(service.id);
          }
        });
        if (this.openBrand.indexOf(brandId) === -1) {
          this.openBrand.push(brandId);
        }
      }

      if (this.brands.every(function (brand) {
        return _this3.selectedBrand.includes(brand.id);
      })) {
        this.selectedAllServices = true;
      }
    },
    leadingZero: function leadingZero(n) {
      return parseInt(n) < 10 ? '0' + n : n;
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    var self = this;
    if (!self.$store.state.settings.serviceData.Shared.label) {
      self.$store.commit('brands/setLoading', true);
      self.$sdk.get('/brand', {}, function (res) {
        self.$store.commit('brands/setLoading', false);
        if (!_this4.useOldQuatation && res.length) {
          self.$store.commit('brands/setList', res);
        }
      });
    }

    if (!self.$store.state.services.list.length) {
      self.$store.commit('services/setServiceLoading', true);
      __WEBPACK_IMPORTED_MODULE_2__modules_api_services__["a" /* default */].getAllService(self, function (r) {
        self.$store.commit('services/setServiceLoading', false);
        self.$store.commit('dispatch/setReloadDrivers', true);
      });
    }

    if (!self.$store.state.reservation.date.from) {
      self.$store.commit('reservation/setDateFilter', {
        fromTo: 'from',
        value: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()('00:00AM', 'hh:mmA').format('MM/DD/YYYY hh:mmA')
      });
      self.$store.commit('reservation/setDateFilter', {
        fromTo: 'to',
        value: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()('00:00AM', 'hh:mmA').add(1, 'days').format('MM/DD/YYYY hh:mmA')
      });
    }
  }
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(463);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67f7a517_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(1307);
function injectStyle (ssrContext) {
  __webpack_require__(1297)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67f7a517"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67f7a517_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableFilter__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TableSearch__ = __webpack_require__(1303);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'routing-header',
  components: { TableFilter: __WEBPACK_IMPORTED_MODULE_0__TableFilter__["a" /* default */], TableSearch: __WEBPACK_IMPORTED_MODULE_1__TableSearch__["a" /* default */] }
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_routing_reservations__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'table-filter',
  computed: {
    filters: function filters() {
      return this.$store.state.routing.reservationFilters;
    },

    selectedFilter: {
      get: function get() {
        return this.$store.state.routing.selectedFilter;
      },
      set: function set(value) {
        this.$store.commit('routing/setSelectedFilter', parseInt(value));
      }
    }
  },
  methods: {
    filterRsvp: function filterRsvp() {
      var self = this;
      if (self.selectedFilter !== -1) {
        self.$plugins.storage.set('ADMIN_ROUTING_FILTER', self.filters[self.selectedFilter].id);
      } else {
        self.$plugins.storage.remove('ADMIN_ROUTING_FILTER');
      }
      self.$store.commit('routing/resetReservationsPaging');
      self.$store.commit('routing/resetPackagePaging');
      __WEBPACK_IMPORTED_MODULE_0__modules_api_routing_reservations__["a" /* default */].getReservations(this, function (r) {}, false);
      __WEBPACK_IMPORTED_MODULE_0__modules_api_routing_reservations__["a" /* default */].getPackages(this, function (r) {}, false);
    }
  }
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_routing_reservations__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'table-search',
  computed: {
    searchInput: {
      get: function get() {
        return this.$store.state.routing.reservationSearch;
      },
      set: function set(value) {
        this.$store.commit('routing/setReservationSearch', value);
      }
    }
  },
  methods: {
    submitSearch: function submitSearch() {
      var self = this;
      self.$store.commit('routing/setReservationsCurrentPage', 1);
      self.$store.commit('routing/setPackageCurrentPage', 1);
      __WEBPACK_IMPORTED_MODULE_0__modules_api_routing_reservations__["a" /* default */].getReservations(self, function (r) {}, false);
      __WEBPACK_IMPORTED_MODULE_0__modules_api_routing_reservations__["a" /* default */].getPackages(self, function (r) {}, false);
    },
    clearSearch: function clearSearch() {
      var self = this;
      self.$store.commit('routing/resetReservationSearch');
      __WEBPACK_IMPORTED_MODULE_0__modules_api_routing_reservations__["a" /* default */].getReservations(self, function (r) {}, false);
      __WEBPACK_IMPORTED_MODULE_0__modules_api_routing_reservations__["a" /* default */].getPackages(self, function (r) {}, false);
    }
  }
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackagesTable_vue__ = __webpack_require__(467);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2df4cd98_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackagesTable_vue__ = __webpack_require__(1314);
function injectStyle (ssrContext) {
  __webpack_require__(1308)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2df4cd98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackagesTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2df4cd98_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackagesTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_LoadingAnimation_ArrowUp__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Partials_LoadingAnimation_Ellipsis__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PackageRow__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_routing_reservations__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'routing-list',
  components: { ArrowUp: __WEBPACK_IMPORTED_MODULE_0__components_Partials_LoadingAnimation_ArrowUp__["a" /* default */], EllipsisLoader: __WEBPACK_IMPORTED_MODULE_1__components_Partials_LoadingAnimation_Ellipsis__["a" /* default */], PackageRow: __WEBPACK_IMPORTED_MODULE_2__PackageRow__["a" /* default */] },
  props: ['forDispatch', 'isMobile'],
  data: function data() {
    return {
      isPageLoading: false,
      isLoadingNext: false,
      isLoadingBack: false,
      isSorting: false,
      scrollLoading: false
    };
  },

  computed: {
    items: function items() {
      return this.$store.state.routing.packages.items;
    },
    isLoading: function isLoading() {
      return this.$store.state.routing.packages.isLoading;
    },
    totalPages: function totalPages() {
      return this.$store.state.routing.packages.paging.totalPages;
    },

    currentPage: {
      get: function get() {
        return this.$store.state.routing.packages.paging.currentPage;
      },
      set: function set(value) {
        this.$store.commit('routing/setPackageCurrentPage', value);
      }
    },
    packageSort: function packageSort() {
      return this.$store.state.routing.packages.sort;
    },

    checkedAll: {
      get: function get() {
        if (this.forDispatch) {
          return this.$store.state.routing.packages.items.length === this.$store.state.routing.packages.checkedForDispatch.length;
        }
        return this.$store.state.routing.packages.items.length === this.$store.state.routing.packages.checked.length;
      },
      set: function set(value) {
        var self = this;
        var packages = self.$store.state.routing.packages.items;
        var checkedItems = [];
        if (value) {
          for (var i = 0; i < packages.length; i++) {
            checkedItems.push(packages[i].id);
          }
        }
        if (self.forDispatch) {
          self.$store.commit('routing/updateCheckedPackagesForDispatch', checkedItems);
        } else {
          self.$store.commit('routing/updateCheckedPackages', checkedItems);
        }
      }
    }
  },
  methods: {
    pageBtn: function pageBtn(isNext) {
      var self = this;
      var pageChange = isNext ? 1 : -1;
      if (isNext) {
        self.isLoadingNext = true;
      } else {
        self.isLoadingBack = true;
      }
      self.$store.commit('routing/setPackageCurrentPage', self.$store.state.routing.packages.paging.currentPage + pageChange);
      self.loadPage();
    },
    loadPage: function loadPage() {
      var self = this;
      // self.isPageLoading = true
      __WEBPACK_IMPORTED_MODULE_3__modules_api_routing_reservations__["a" /* default */].getPackages(self, function (r) {
        // self.isPageLoading = false
        self.isLoadingBack = false;
        self.isLoadingNext = false;
        self.scrollLoading = false;

        if (r.error) {
          return;
        }

        // self.$plugins.smoothScroll.scrollTo(document.getElementById('routing-packages-table'))
      }, true);
    },
    sort: function sort(order) {
      var self = this;
      var existingOrder = self.packageSort.order;
      var existingAsc = self.packageSort.asc;
      var asc = existingAsc;
      if (order === existingOrder) {
        asc = !existingAsc;
      }

      self.$store.commit('routing/setPackagesSort', {
        order: order, asc: asc
      });

      self.isSorting = true;
      self.$store.commit('routing/setPackageCurrentPage', 1);
      __WEBPACK_IMPORTED_MODULE_3__modules_api_routing_reservations__["a" /* default */].getPackages(self, function (r) {
        self.isSorting = false;
        if (r.error) {
          return;
        }
      }, true);
    },
    onScroll: function onScroll() {
      var rsvpPaging = this.$store.state.routing.packages.paging;
      if (this.scrollLoading || rsvpPaging.currentPage >= rsvpPaging.totalPages) {
        return;
      }

      this.scrollLoading = true;
      this.$store.commit('routing/setPackageCurrentPage', rsvpPaging.currentPage + 1);
      this.loadPage();
    }
  }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Partials_SVG_ServiceDog__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Partials_SVG_Wheelchair__ = __webpack_require__(96);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'package-row',
  data: function data() {
    return {
      hereMaps: {
        platform: {}
      },
      etaPopup: {
        show: false,
        loading: false,
        label: ''
      },
      timer: 20,
      checkingDriver: false
    };
  },

  props: ['opPackage', 'forDispatch', 'isMobile'],
  components: { SvgDog: __WEBPACK_IMPORTED_MODULE_1__components_Partials_SVG_ServiceDog__["a" /* default */], SvgWheelchair: __WEBPACK_IMPORTED_MODULE_2__components_Partials_SVG_Wheelchair__["a" /* default */] },
  computed: {
    inMap: function inMap() {
      var self = this;
      var mapItems = self.$store.state.routing.dropzone.items;
      var item = mapItems.filter(function (mapItem) {
        return mapItem.packageID === self.opPackage.id;
      });
      return item.length > 0;
    },

    checkedPackages: {
      get: function get() {
        if (this.forDispatch) {
          return this.$store.state.routing.packages.checkedForDispatch;
        }
        return this.$store.state.routing.packages.checked;
      },
      set: function set(value) {
        if (this.forDispatch) {
          this.$store.commit('routing/updateCheckedPackagesForDispatch', value);
        } else {
          this.$store.commit('routing/updateCheckedPackages', value);
        }
      }
    }
  },
  methods: {
    toggleInMap: function toggleInMap() {
      var self = this;
      if (self.inMap) {
        self.$store.commit('routing/removeDropzoneItems', self.opPackage);
        if (self.opPackage.driver !== null) {
          self.$store.commit('routing/removeDropzoneDriver', {
            packageID: self.opPackage.id,
            driver: self.opPackage.driver
          });
        }
        return;
      }

      var items = this.$store.state.routing.dropzone.items;
      if (items.length) {
        if (items[0].serviceId !== self.opPackage.serviceId) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'Different service types cannot be packaged together.'
          });
          return;
        }
      }

      self.$store.commit('routing/addDropzoneItem', self.opPackage);
      if (self.opPackage.driver !== null) {
        self.$store.commit('routing/addDropzoneDriver', {
          packageID: self.opPackage.id,
          driver: self.opPackage.driver
        });
      }
    },
    getAddress: function getAddress(location) {
      if (location.geofenceType === 'airport' && location.geofenceName !== '') {
        var result = location.geofenceName;
        if (location.terminal && location.terminal !== '' && location.terminal !== 'undefined') {
          result += ' - Terminal ' + location.terminal;
        }
        return result;
      }
      return location.title;

      // let address = ''
      // if (location.address2 && location.address2 !== '' && location.address2 !== 'undefined') {
      //   address = address + location.address2 + ' '
      // }
      // if (location.address1) {
      //   address = address + location.address1 + ', '
      // }
      // if (location.city) {
      //   address = address + location.city + ' '
      // }
      // if (location.state) {
      //   address = address + location.state + ' '
      // }
      // if (location.zip) {
      //   address = address + location.zip
      // }

      // return address
    },
    callPhone: function callPhone(info) {
      var self = this;
      self.$plugins.phone.startCall(self, {
        phone: info.phone,
        name: info.firstName + ' ' + info.lastName
      });
    },
    showEtaPopup: function showEtaPopup(e) {
      var self = this;
      self.etaPopup.show = true;
      if (self.opPackage.driver === null) {
        self.etaPopup.loading = false;
        self.etaPopup.label = 'Cannot find the driver.';
        return;
      }
      self.etaPopup.loading = true;
      self.etaPopup.label = '';

      self.$sdk.get('/provider/' + self.opPackage.driver.ID + '/tracks', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          self.etaPopup.loading = false;
          self.etaPopup.label = 'Cannot find the driver.';
          return;
        }

        if (r.list.length <= 0) {
          self.etaPopup.loading = false;
          self.etaPopup.label = 'Cannot find the driver.';
          return;
        }
        var location = r.list[0];
        var waypoints = [];
        waypoints.push(location);

        var legs = self.opPackage.legs;
        for (var i = 0; i < legs.length; i++) {
          var leg = legs[i];

          if (!leg.isPickup && leg.status === 'ONTHEWAY') {
            waypoints.push({
              lat: leg.location.lat,
              lng: leg.location.lng
            });
            continue;
          }

          if (!leg.isPickup && (leg.status === 'ONBOARD' || leg.status === 'ONTHEWAY')) {
            waypoints.push({
              lat: leg.location.lat,
              lng: leg.location.lng
            });
            continue;
          }
        }

        // let request = {
        //   origin: waypoints.shift(),
        //   destination: waypoints.pop(),
        //   travelMode: google.maps.TravelMode.DRIVING // eslint-disable-line no-undef
        // }

        var stopovers = [];
        for (var _i = 0; _i < waypoints.length; _i++) {
          stopovers.push({
            location: { lat: waypoints[_i].lat, lng: waypoints[_i].lng },
            stopover: false
          });
        }

        // if (stopovers.length > 0) {
        //   request.waypoints = stopovers
        // }

        var origin = [].concat(waypoints).shift();
        var destination = [].concat(waypoints).pop();
        self.calculateRoute(origin, destination);
        // let direction = new google.maps.DirectionsService() // eslint-disable-line no-undef
        // direction.route(request, (response, status) => {
        //   self.etaPopup.loading = false
        //   if (status !== google.maps.DirectionsStatus.OK) { // eslint-disable-line no-undef
        //     self.etaPopup.label = 'Cannot find the driver.'
        //     return
        //   }

        //   let legs = response.routes[0].legs
        //   let duration = 0
        //   for (let j = 0; j < legs.length; j++) {
        //     duration = duration + legs[j].duration.value
        //   }
        //   let eta = moment().add(duration, 'seconds')
        //   let format = 'MM/DD/YYYY hh:mm A'
        //   if (self.$settings.get('MilitaryTimeBackoffice') === '1') {
        //     format = 'MM/DD/YYYY HH:mm'
        //   }
        //   self.etaPopup.label = 'ETA: ' + eta.format(format)
        // })
      });
    },
    calculateRoute: function calculateRoute(origin, destination) {
      var self = this;
      var router = self.hereMaps.platform.getRoutingService(null, 8);
      var routeRequestParams = {
        routingMode: 'fast',
        transportMode: 'car',
        origin: origin.lat + ',' + origin.lng,
        destination: destination.lat + ',' + destination.lng,
        return: 'polyline,turnByTurnActions,actions,instructions,travelSummary'
      };

      router.calculateRoute(routeRequestParams, self.onCalculateSuccess, self.onCalculateError);
    },
    onCalculateSuccess: function onCalculateSuccess(result) {
      var self = this;
      self.etaPopup.loading = false;
      if (!result.routes.length) return;
      var route = result.routes[0].sections[0];

      var eta = __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(route.travelSummary.duration, 'seconds');
      var format = 'MM/DD/YYYY hh:mm A';
      if (self.$settings.get('MilitaryTimeBackoffice') === '1') {
        format = 'MM/DD/YYYY HH:mm';
      }
      self.etaPopup.label = 'ETA: ' + eta.format(format);
    },
    onCalculateError: function onCalculateError(data) {
      this.etaPopup.loading = false;
      this.etaPopup.label = 'Cannot find the driver.';
      this.error('ROUTING ERROR', data);
    },
    hideEtaPopup: function hideEtaPopup() {
      var self = this;
      self.etaPopup.show = false;
      self.etaPopup.loading = false;
      self.etaPopup.label = '';
    },
    editPickupDate: function editPickupDate(pkg) {
      this.$store.commit('routing/setPickupTimeModal', {
        show: true,
        id: pkg.id,
        value: pkg.pickupTime
      });
    },
    startPendingOfferTimer: function startPendingOfferTimer() {
      var self = this;
      if (self.timer < 0) {
        self.checkingDriver = true;
        self.$sdk.get('/admin/package/' + self.opPackage.id, {
          token: self.$store.state.session.sessionToken
        }, function (r) {
          self.checkingDriver = false;
          if (!r.error) {
            var statusClass = r.package.packageStatus ? r.package.packageStatus : r.package.status;
            var status = r.package.packageStatus ? r.package.packageStatus.toUpperCase() : r.package.status.toUpperCase();

            if (statusClass === 'requires_dispatch') {
              statusClass = 'requires-dispatch';
              status = 'REQUIRES DISPATCH';
            }

            if (statusClass === 'autodispatch') {
              statusClass = 'auto-dispatch';
              status = 'AUTO DISPATCH';
            }

            if (statusClass === 'cancelled') {
              statusClass = 'canceled';
              status = 'CANCELED';
            }

            if (statusClass === 'complete') {
              status = 'COMPLETED';
            }

            if (statusClass === 'ready') {
              status = 'READY TO GO';
            }

            self.$store.commit('routing/updateRsvpStatus', {
              id: self.opPackage.id,
              status: status,
              statusClass: statusClass
            });
          }
          self.$store.commit('routing/setPendingOffer', {
            id: self.opPackage.id,
            show: false,
            timer: 0
          });
        });
        return;
      }
      setTimeout(function () {
        self.timer--;
        self.startPendingOfferTimer();
      }, 1000);
    }
  },
  watch: {
    'opPackage.pendingOffer': function opPackagePendingOffer(val) {
      this.timer = val.timer;
      if (this.timer) this.startPendingOfferTimer();
    }
  },
  mounted: function mounted() {
    this.hereMaps.platform = new window.H.service.Platform({ apikey: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key });
    var defaultLayers = this.hereMaps.platform.createDefaultLayers();
  }
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackagesControl_vue__ = __webpack_require__(470);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56212078_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackagesControl_vue__ = __webpack_require__(1317);
function injectStyle (ssrContext) {
  __webpack_require__(1315)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56212078"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackagesControl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56212078_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackagesControl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'packages-control',
  data: function data() {
    return {
      disableBreakPkg: false
    };
  },

  props: ['forDispatch'],
  computed: {
    checkPkgs: function checkPkgs() {
      if (this.forDispatch) {
        return this.$store.state.routing.packages.checkedForDispatch;
      }
      return this.$store.state.routing.packages.checked;
    }
  },
  methods: {
    isValid: function isValid(title, message) {
      var self = this;
      var checkedPackages = self.$store.state.routing.packages.checked;
      if (self.forDispatch) {
        checkedPackages = self.$store.state.routing.packages.checkedForDispatch;
      }
      if (checkedPackages.length <= 0 || checkedPackages.length > 1) {
        self.$store.commit('routing/showRoutingModal');
        self.$store.commit('routing/setRoutingValidationModal', {
          show: true,
          title: title,
          message: message
        });
        return false;
      }
      return true;
    },
    moveToPool: function moveToPool() {
      var self = this;
      if (!self.isValid('You missed something', 'Please select only 1 package to move to the pool.')) {
        return;
      }
      var checkedPackages = self.$store.state.routing.packages.checked;
      if (self.forDispatch) {
        checkedPackages = self.$store.state.routing.packages.checkedForDispatch;
      }
      self.$store.commit('routing/showRoutingModal');
      self.$store.commit('routing/setRoutingAjaxModal', {
        show: true,
        loading: true,
        success: false,
        message: 'Moving package ' + checkedPackages[0] + ' to pool...'
      });
      self.$sdk.post('/admin/package/' + checkedPackages[0] + '/pool', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        var success = true;
        var message = 'Successfully moved package ' + checkedPackages[0] + ' to the pool.';
        if (r.error) {
          console.log(r);
          success = false;
          message = 'Oops. Something went wrong. Please try again later.';
        }
        self.$store.commit('routing/setRoutingAjaxModal', {
          show: true,
          loading: false,
          success: success,
          message: message
        });

        setTimeout(function () {
          self.$store.commit('routing/hideRoutingModal');
        }, 1000);
      });
    },
    removeFromPool: function removeFromPool() {
      var self = this;
      if (!self.isValid('You missed something', 'Please select only 1 package to remove from the pool.')) {
        return;
      }
      var checkedPackages = self.$store.state.routing.packages.checked;
      if (self.forDispatch) {
        checkedPackages = self.$store.state.routing.packages.checkedForDispatch;
      }
      self.$store.commit('routing/showRoutingModal');
      self.$store.commit('routing/setRoutingAjaxModal', {
        show: true,
        loading: true,
        success: false,
        message: 'Removing package ' + checkedPackages[0] + ' from pool...'
      });
      self.$sdk.delete('/admin/package/' + checkedPackages[0] + '/pool', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        var success = true;
        var message = 'Successfully removed package ' + checkedPackages[0] + ' from the pool.';
        if (r.error) {
          console.log(r);
          success = false;
          message = 'Oops. Something went wrong. Please try again later.';
        }
        self.$store.commit('routing/setRoutingAjaxModal', {
          show: true,
          loading: false,
          success: success,
          message: message
        });

        setTimeout(function () {
          self.$store.commit('routing/hideRoutingModal');
        }, 1000);
      });
    },
    breakPackage: function breakPackage() {
      var self = this;
      if (!self.isValid('You missed something', 'Please select only 1 package to break.')) {
        return;
      }

      var checkedPackages = self.$store.state.routing.packages.checked;
      if (self.forDispatch) {
        checkedPackages = self.$store.state.routing.packages.checkedForDispatch;
      }
      self.$store.commit('routing/showRoutingModal');
      self.$store.commit('routing/setRoutingAjaxModal', {
        show: true,
        loading: true,
        success: false,
        message: 'Breaking package ' + checkedPackages[0] + '...'
      });
      self.$sdk.delete('/admin/package/' + checkedPackages[0], {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        var success = true;
        var message = 'Successfully broken package ' + checkedPackages[0] + '.';
        if (r.error) {
          console.log(r);
          success = false;
          message = 'Oops. Something went wrong. Please try again later.';
        }
        self.$store.commit('routing/setRoutingAjaxModal', {
          show: true,
          loading: false,
          success: success,
          message: message
        });

        if (success) {
          self.$store.commit('routing/removePackageItem', checkedPackages[0]);
          self.$store.commit('routing/clearCheckedPackages');
          if (self.forDispatch) {
            self.$store.commit('routing/clearCheckedPackagesForDispatch');
          }
        }

        setTimeout(function () {
          self.$store.commit('routing/hideRoutingModal');
        }, 1000);
      });
    }
  },
  watch: {
    checkPkgs: function checkPkgs(value) {
      var _this = this;

      var pkgs = this.$store.state.routing.packages.items;
      this.disableBreakPkg = false;

      var _loop = function _loop(index) {
        var pkgIndex = pkgs.findIndex(function (x) {
          return x.id === value[index];
        });
        if (pkgs[pkgIndex].driver && pkgs[pkgIndex].driver.ID) {
          _this.disableBreakPkg = true;
        }
      };

      for (var index in value) {
        _loop(index);
      }
    }
  }
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationsTable_vue__ = __webpack_require__(472);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39609c62_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationsTable_vue__ = __webpack_require__(1324);
function injectStyle (ssrContext) {
  __webpack_require__(1318)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39609c62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39609c62_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_routing_reservations__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Partials_LoadingAnimation_ArrowUp__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Partials_LoadingAnimation_Ellipsis__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ReservationRow__ = __webpack_require__(1320);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reservations-table',
  props: ['isMobile'],
  components: { ArrowUp: __WEBPACK_IMPORTED_MODULE_1__components_Partials_LoadingAnimation_ArrowUp__["a" /* default */], EllipsisLoader: __WEBPACK_IMPORTED_MODULE_2__components_Partials_LoadingAnimation_Ellipsis__["a" /* default */], ReservationRow: __WEBPACK_IMPORTED_MODULE_3__ReservationRow__["a" /* default */] },
  data: function data() {
    return {
      isPageLoading: false,
      isLoadingNext: false,
      isLoadingBack: false,
      isSorting: false,
      scrollLoading: false
    };
  },

  computed: {
    items: function items() {
      return this.$store.state.routing.reservations.items;
    },
    isLoading: function isLoading() {
      return this.$store.state.routing.reservations.isLoading;
    },
    totalPages: function totalPages() {
      return this.$store.state.routing.reservations.paging.totalPages;
    },

    currentPage: {
      get: function get() {
        return this.$store.state.routing.reservations.paging.currentPage;
      },
      set: function set(value) {
        this.$store.commit('routing/setReservationsCurrentPage', value);
      }
    },
    rsvpSort: function rsvpSort() {
      return this.$store.state.routing.reservations.sort;
    },

    checkedAll: {
      get: function get() {
        return this.$store.state.routing.reservations.items.length === this.$store.state.routing.reservations.checked.length;
      },
      set: function set(value) {
        var self = this;
        var rsvps = self.$store.state.routing.reservations.items;
        var checkedItems = [];
        if (value) {
          for (var i = 0; i < rsvps.length; i++) {
            checkedItems.push(rsvps[i].id);
          }
        }
        self.$store.commit('routing/updateCheckedReservations', checkedItems);
      }
    },
    rtgSuccess: function rtgSuccess() {
      return this.$store.state.dispatch.readyToGo.success;
    }
  },
  methods: {
    pageBtn: function pageBtn(isNext) {
      var self = this;
      var pageChange = isNext ? 1 : -1;
      if (isNext) {
        self.isLoadingNext = true;
      } else {
        self.isLoadingBack = true;
      }
      self.$store.commit('routing/setReservationsCurrentPage', self.$store.state.routing.reservations.paging.currentPage + pageChange);
      self.loadPage();
    },
    loadPage: function loadPage() {
      var self = this;
      // self.isPageLoading = true
      __WEBPACK_IMPORTED_MODULE_0__modules_api_routing_reservations__["a" /* default */].getReservations(self, function (r) {
        // self.isPageLoading = false
        self.isLoadingBack = false;
        self.isLoadingNext = false;
        self.scrollLoading = false;

        if (r.error) {
          return;
        }

        // self.$plugins.smoothScroll.scrollTo(document.getElementById('routing-reservations-table'))
      }, true);
    },
    sort: function sort(order) {
      var self = this;
      var existingOrder = self.rsvpSort.order;
      var existingAsc = self.rsvpSort.asc;
      var asc = existingAsc;
      if (order === existingOrder) {
        asc = !existingAsc;
      }

      self.$store.commit('routing/setReservationsSort', {
        order: order, asc: asc
      });

      self.isSorting = true;
      self.$store.commit('routing/setReservationsCurrentPage', 1);
      __WEBPACK_IMPORTED_MODULE_0__modules_api_routing_reservations__["a" /* default */].getReservations(self, function (r) {
        self.isSorting = false;
        if (r.error) {
          return;
        }
      }, true);
    },
    onScroll: function onScroll(event) {
      var rsvpPaging = this.$store.state.routing.reservations.paging;
      if (this.scrollLoading || rsvpPaging.currentPage >= rsvpPaging.totalPages) {
        return;
      }

      this.scrollLoading = true;
      this.$store.commit('routing/setReservationsCurrentPage', rsvpPaging.currentPage + 1);
      this.loadPage();
    }
  },
  watch: {
    rtgSuccess: function rtgSuccess(value) {
      if (value) {
        this.$store.commit('dispatch/setReadyToGoSuccess', false);
        this.loadPage();
      }
    }
  }
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_flight_info__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Partials_SVG_ServiceDog__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Partials_SVG_Wheelchair__ = __webpack_require__(96);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reservation-row',
  props: ['rsvp', 'isMobile'],
  components: { SvgDog: __WEBPACK_IMPORTED_MODULE_2__components_Partials_SVG_ServiceDog__["a" /* default */], SvgWheelchair: __WEBPACK_IMPORTED_MODULE_3__components_Partials_SVG_Wheelchair__["a" /* default */] },
  data: function data() {
    return {
      flightStatus: null
    };
  },

  computed: {
    inMap: function inMap() {
      var self = this;
      var mapItems = self.$store.state.routing.dropzone.items;
      var item = mapItems.filter(function (mapItem) {
        return mapItem.reservationID === self.rsvp.id && mapItem.packageID === null;
      });
      return item.length > 0;
    },

    checkedReservations: {
      get: function get() {
        return this.$store.state.routing.reservations.checked;
      },
      set: function set(value) {
        this.$store.commit('routing/updateCheckedReservations', value);
      }
    }
  },
  methods: {
    getAddress: function getAddress(location) {
      if (location.geofenceType === 'airport' && location.geofenceName !== '') {
        var result = location.geofenceName;
        if (location.terminal && location.terminal !== '' && location.terminal !== 'undefined') {
          result += ' - Terminal ' + location.terminal;
        }
        return result;
      }
      return location.title;

      // let address = ''
      // if (location.city) {
      //   address = address + location.city + ' '
      // }
      // if (location.zip) {
      //   address = address + location.zip
      // }

      // return address
    },
    showFlightInfo: function showFlightInfo() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1__modules_api_flight_info__["a" /* default */].loadFlightInfo(self, self.rsvp, function (r) {
        if (r.error) {
          self.flightStatus = { label: 'On Time', class: 'ontime' };
          return;
        }
        self.flightStatus = self.translateFlightStatus(r.status);
      });
    },
    getFlightStatus: function getFlightStatus() {
      var self = this;
      if (self.rsvp.airlineCode === null || self.rsvp.statusClass === 'complete' || self.rsvp.statusClass === 'completed' || self.rsvp.statusClass === 'canceled') {
        self.flightStatus = null;
        return;
      }
      var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.rsvp.pickupTime, 'MM/DD/YYYY hh:mm A');
      var airlineDate = encodeURIComponent(date.format('YYYY-MM-DD'));
      var airlineTime = encodeURIComponent(date.format('HH:mm:ss'));
      var flightNumber = self.rsvp.flightNumber || self.rsvp.dropoffFlightNumber;
      var isDeparture = '&departure=0';
      if ((self.rsvp.airline === null || self.rsvp.airline === '') && self.rsvp.dropoffAirline !== null && self.rsvp.dropoffAirline !== '') {
        isDeparture = '&departure=1';
      }
      var url = '/availability/flights/' + self.rsvp.airlineCode + flightNumber + '?date=' + airlineDate + '&time=' + airlineTime + '&airport=' + self.rsvp.airportCode + isDeparture;
      self.$sdk.get(url, {}, function (r) {
        if (r.error) {
          self.flightStatus = { label: 'On Time', class: 'ontime' };
          return;
        }
        self.flightStatus = self.translateFlightStatus(r.status);
      });
    },
    translateFlightStatus: function translateFlightStatus(status) {
      switch (status) {
        case 'Scheduled':
          return { label: 'On Time', class: 'ontime' };
        case 'Proposed':
          return { label: 'On Time', class: 'ontime' };
        case 'OutGate':
          return { label: 'On Time', class: 'ontime' };
        case 'InAir':
          return { label: 'On Air', class: 'onair' };
        case 'Landed':
          return { label: 'Arrived', class: 'arrived' };
        case 'InGate':
          return { label: 'Arrived', class: 'arrived' };
        case 'Expected':
          return { label: 'On Time', class: 'ontime' };
        case 'NoTakeOffInfo':
          return { label: 'On Time', class: 'ontime' };
        case 'Delayed':
          return { label: 'Delayed', class: 'delayed' };
        case 'Cancelled':
          return { label: 'Cancelled', class: 'cancelled' };
        case 'Unknown':
          return { label: 'On Time', class: 'ontime' };
        case 'PastFlight':
          return { label: 'Arrived', class: 'arrived' };
        case 'Original':
          return { label: 'On Time', class: 'ontime' };
      }
      return { label: 'On Time', class: 'ontime' };
    },
    toggleInMap: function toggleInMap() {
      var self = this;
      if (self.inMap) {
        self.$store.commit('routing/removeDropzoneItems', self.rsvp);
        return;
      }

      var items = this.$store.state.routing.dropzone.items;
      if (items.length) {
        if (items[0].serviceId !== self.rsvp.serviceId) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'Different service types cannot be packaged together.'
          });
          return;
        }
      }

      self.$store.commit('routing/addDropzoneItem', self.rsvp);
    },
    callPhone: function callPhone(info) {
      var self = this;
      self.$plugins.phone.startCall(self, {
        phone: info.phone,
        name: info.firstName + ' ' + info.lastName
      });
    },
    showRTG: function showRTG(id) {
      this.$store.commit('dispatch/setReadyToGoID', id);
      this.$store.commit('dispatch/setReadyToGoShow', true);
    },
    acceptedRTGStatus: function acceptedRTGStatus(status) {
      return ['UPCOMING', 'REQUIRES DISPATCH', 'DISPATCHED'].indexOf(status) > -1;
    }
  },
  watch: {
    rsvp: function rsvp(value) {
      // this.getFlightStatus()
    }
  },
  mounted: function mounted() {
    // let self = this
    // self.getFlightStatus()
  }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PickupDateModal_vue__ = __webpack_require__(475);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72ed28ed_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PickupDateModal_vue__ = __webpack_require__(1327);
function injectStyle (ssrContext) {
  __webpack_require__(1325)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72ed28ed"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PickupDateModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72ed28ed_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PickupDateModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_featureToggle__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pickup-date-modal',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default.a },
  data: function data() {
    return {
      today: __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(),
      maxHour: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      validation: {
        pickupTime: ''
      }
    };
  },

  computed: {
    pickupTimeModal: function pickupTimeModal() {
      return this.$store.state.routing.packages.pickupTimeModal;
    },
    pickupTimeModalValue: function pickupTimeModalValue() {
      var datetime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.pickupTimeModal.value, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_2__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
      var hourFormat = this.$settings.get('MilitaryTimeBackoffice') === '1' ? 'HH' : 'hh';
      return {
        date: datetime.format('MM/DD/YYYY'),
        hour: datetime.format(hourFormat),
        minute: datetime.format('mm'),
        amPm: datetime.format('A')
      };
    },
    disabledDate: function disabledDate() {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(this.today.subtract(1, 'months').format('YYYY'), this.today.format('MM'), this.today.format('DD'))
        };
      }

      return {
        to: new Date(this.today.format('YYYY'), this.today.subtract(1, 'months').format('MM'), this.today.format('DD'))
      };
    },
    isMilitaryTime: function isMilitaryTime() {
      if (this.$settings.get('MilitaryTimeBackoffice') === '1') {
        this.maxHour = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
      }
      return this.$settings.get('MilitaryTimeBackoffice') === '1';
    }
  },
  methods: {
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(date).format('MM/DD/YYYY');
    },
    closePickupTimeModal: function closePickupTimeModal() {
      if (this.pickupTimeModal.loading) {
        return;
      }
      this.$store.commit('routing/setPickupTimeModal', {
        show: false,
        loading: false,
        success: false,
        message: '',
        id: 0,
        value: ''
      });
    },
    changeDate: function changeDate() {
      this.pickupTimeModalValue.date = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.pickupTimeModalValue.date).format('MM/DD/YYYY');
      this.updatePickupDate();
    },
    updatePickupDate: function updatePickupDate() {
      var pickupDate = this.pickupTimeModalValue.date + ' ' + this.pickupTimeModalValue.hour + ':' + this.pickupTimeModalValue.minute + '' + this.pickupTimeModalValue.amPm;
      if (this.$settings.get('MilitaryTimeBackoffice') === '1') {
        pickupDate = this.pickupTimeModalValue.date + ' ' + this.pickupTimeModalValue.hour + ':' + this.pickupTimeModalValue.minute;
      }
      this.$store.commit('routing/setPickupTimeModal', { value: pickupDate });
    },
    leadingZero: function leadingZero(n) {
      return n < 10 ? '0' + n : n;
    },
    savePickupDate: function savePickupDate() {
      var _this = this;

      var self = this;
      if (self.pickupTimeModal.loading) {
        return;
      }

      var currentDate = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()();
      var selectedDate = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(self.pickupTimeModal.value, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_2__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));

      self.validation.pickupTime = '';
      if (selectedDate.diff(currentDate) < 0) {
        self.validation.pickupTime = 'Pickup date must not be in the past';
        return;
      }

      self.$store.commit('routing/setPickupTimeModal', { loading: true });
      self.$sdk.post('/admin/package/' + self.pickupTimeModal.id + '/pickuptime', {
        token: self.$store.state.session.sessionToken,
        pickupTime: parseInt(selectedDate.format('X'))
      }, function (res) {
        self.$store.commit('routing/setPickupTimeModal', { loading: false });
        if (res.error) {
          self.$store.commit('routing/setPickupTimeModal', {
            success: false,
            message: res.error.message
          });
          return;
        }

        self.$store.commit('routing/updatePickupDate', {
          id: self.pickupTimeModal.id,
          value: selectedDate.format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_2__modules_api_featureToggle__["a" /* default */].timeFormat(_this, false))
        });
        self.$store.commit('routing/setPickupTimeModal', {
          success: true,
          message: 'Successfully updated Pkg #' + self.pickupTimeModal.id
        });
      });
    }
  }
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map2_vue__ = __webpack_require__(477);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34d63f0d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map2_vue__ = __webpack_require__(1330);
function injectStyle (ssrContext) {
  __webpack_require__(1328)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34d63f0d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34d63f0d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__values_map_settings__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__values_map_pin__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__ = __webpack_require__(5);

//
//
//
//
//
//
//

/* global CONFIG */





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'routing-map2',
  data: function data() {
    return {
      hereMaps: {
        map: {},
        platform: {},
        router: {},
        geocoder: {},
        directions: [],
        ui: {}
      },
      mapOptions: __WEBPACK_IMPORTED_MODULE_2__values_map_settings__["a" /* default */],
      pickupPin: __WEBPACK_IMPORTED_MODULE_3__values_map_pin__["a" /* default */].pickup,
      dropoffPin: __WEBPACK_IMPORTED_MODULE_3__values_map_pin__["a" /* default */].dropoff,
      mapPins: [],
      infoWindows: [],
      route: [],
      routes: [],
      center: { lat: 33.942791, lng: -118.410042 }
    };
  },

  computed: {
    items: function items() {
      return this.$store.state.routing.dropzone.items;
    }
  },
  watch: {
    items: function items(value) {
      var self = this;

      self.hereMaps.ui.getBubbles().forEach(function (bub) {
        bub.close();
      });
      self.hereMaps.ui.removeBubble(self.hereMaps.ui.getBubbles());
      self.hereMaps.map.removeObjects(self.hereMaps.map.getObjects());

      if (value.length <= 0) {
        self.route = [];
        self.routes = [];
        self.mapPins = [];
        self.infoWindows = [];
        return;
      }

      setTimeout(function () {
        self.setMapPins();
      }, 400);
    }
  },
  methods: {
    closeInfoWindow: function closeInfoWindow(index) {
      var self = this;
      self.infoWindows[index].opened = false;
    },
    openInfoWindow: function openInfoWindow(index) {
      var self = this;
      self.infoWindows[index].opened = true;
    },
    computeEta: function computeEta(pin) {
      var self = this;
      var firstStop = self.items[0];
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(firstStop.pickupTime, 'MM/DD/YYYY hh:mmA').add(pin.eta, 'seconds').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__["a" /* default */].timeFormat(self, false));
    },
    computeMaxEta: function computeMaxEta(pin) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(pin.pickupTime, 'MM/DD/YYYY hh:mmA').add(pin.maxDuration, 'seconds').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
    },
    computeOriginalBTT: function computeOriginalBTT(pin) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(pin.originalPickupTime, 'MM/DD/YYYY hh:mmA').add(pin.originalBTT, 'seconds').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
    },
    setMapPins: function setMapPins() {
      var self = this;
      self.mapPins = [];
      self.infoWindows = [];

      self.items.forEach(function (item, i) {
        self.mapPins.push({
          lat: item.location.lat,
          lng: item.location.lng,
          isPickup: item.isPickup,
          reservationID: item.reservationID,
          packageID: item.packageID,
          pickupTime: item.pickupTime,
          originalPickupTime: item.originalPickupTime,
          originalBTT: item.originalBTT,
          eta: item.eta,
          maxDuration: item.maxDuration,
          opened: true
        });
        self.infoWindows.push(self.mapPins[i]);

        var content = '<div class="here-info-window-content routing">' + '<div class="stop-id"><span class="index {IS_PICKUP}">{INDEX}</span>' + '<span>ID: </span><a href="/#/reservation/{RSVP_ID}" target="_blank">{RSVP_ID}</a>' + '{IF_PKG}</div>{IF_PICKUP}</div>';
        content = content.replace('{INDEX}', i + 1).split('{RSVP_ID}').join(item.reservationID).replace('{IS_PICKUP}', item.isPickup ? 'pickup' : '');

        var ifPkg = '';
        if (item.packageID !== null) {
          ifPkg = '<a href="/#/package/' + item.packageID + '" target="_blank">' + item.packageID + '</a>';
        }
        content = content.replace('{IF_PKG}', ifPkg);

        var ifPickup = '';
        if (item.isPickup) {
          ifPickup = '<div class="stop-put">PUT: <span class="value">' + item.originalPickupTime + '</span></div>';
        }
        if (i > 0) {
          ifPickup = ifPickup + '<div class="stop-eta">ETA: <span class="value">' + self.computeEta(item) + '</span></div>';
        }
        if (i > 0 && !item.isPickup) {
          ifPickup = ifPickup + '<div class="stop-btt">BTT: <span class="value">' + self.computeOriginalBTT(item) + '</span></div>';
        }
        content = content.replace('{IF_PICKUP}', ifPickup);

        // Pickup/Dropoff icon
        var marker = '<svg height="25" width="25" style="overflow: unset" viewBox="0 0 50 50">' + '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' + 'stroke-width="{STROKE_WIDTH}" /></svg>';

        var pickupDropoff = item.isPickup ? 'pickup' : 'dropoff';

        marker = marker.replace('{D}', __WEBPACK_IMPORTED_MODULE_3__values_map_pin__["a" /* default */][pickupDropoff].path).replace('{FILL}', __WEBPACK_IMPORTED_MODULE_3__values_map_pin__["a" /* default */][pickupDropoff].fillColor).replace('{STROKE}', __WEBPACK_IMPORTED_MODULE_3__values_map_pin__["a" /* default */][pickupDropoff].strokeColor).replace('{STROKE_WIDTH}', __WEBPACK_IMPORTED_MODULE_3__values_map_pin__["a" /* default */][pickupDropoff].strokeWeight);
        var icon = new window.H.map.DomIcon(marker);
        var coords = { lat: item.location.lat, lng: item.location.lng };
        var pin = new window.H.map.DomMarker(coords, { icon: icon });
        pin.id = 'marker' + i;
        pin.lat = item.location.lat;
        pin.lng = item.location.lng;
        var bubble = new window.H.ui.InfoBubble(coords, { content: content });
        bubble.id = (item.isPickup ? 'pickup' : 'dropoff') + item.reservationID;
        self.hereMaps.ui.addBubble(bubble);
        bubble.addEventListener('tap', function (evt) {
          bubble.open();
        }, false);
        self.hereMaps.map.addObject(pin);
      });

      self.setRoute();
    },
    setRoute: function setRoute() {
      var self = this;
      // self.setMapPins()
      // self.setCenter()

      self.routes = [];
      var duration = 0;
      for (var i = 0; i < self.items.length - 1; i++) {
        var leg = self.items[i];
        var nextLeg = self.items[i + 1];

        self.calculateRoute(leg, nextLeg);
      }
    },
    calculateRoute: function calculateRoute(origin, destination) {
      var self = this;
      var router = self.hereMaps.platform.getRoutingService(null, 8);
      var routeRequestParams = {
        routingMode: 'fast',
        transportMode: 'car',
        origin: origin.location.lat + ',' + origin.location.lng,
        destination: destination.location.lat + ',' + destination.location.lng,
        return: 'polyline,turnByTurnActions,actions,instructions,travelSummary'
      };

      router.calculateRoute(routeRequestParams, self.onCalculateSuccess.bind(null, destination), self.onCalculateError);
    },
    onCalculateSuccess: function onCalculateSuccess(nextLeg, result) {
      if (!result.routes.length) return;
      var route = result.routes[0].sections[0];
      this.$store.commit('routing/updateDropzoneEta', {
        leg: nextLeg, eta: route.travelSummary.duration
      });
      this.addRouteShapeToMap(route);
    },
    onCalculateError: function onCalculateError(data) {
      console.error('ROUTING ERROR', data);
    },
    addRouteShapeToMap: function addRouteShapeToMap(route) {
      var linestring = window.H.geo.LineString.fromFlexiblePolyline(route.polyline);
      var polyline = new window.H.map.Polyline(linestring, {
        style: {
          lineWidth: 4,
          strokeColor: 'rgba(25, 25, 25, 0.7)'
        }
      });
      polyline.id = 'rsvpRoute';

      this.hereMaps.map.addObject(polyline);
      this.hereMaps.map.getViewModel().setLookAtData({
        bounds: polyline.getBoundingBox()
      });

      this.setCenter();
    },
    setCenter: function setCenter() {
      var self = this;
      var group = new window.H.map.Group();
      var circles = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var object = _step.value;

          if (object.id && object.id.indexOf('marker') > -1) {
            var circle = new window.H.map.Circle(new window.H.geo.Point(object.lat, object.lng), 15000, { style: { fillColor: 'rgba(0, 0, 0, 0)', strokeColor: 'rgba(0, 0, 0, 0)' } });
            circles.push(circle);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      group.addObjects(circles);
      group.id = 'groupBound';
      self.hereMaps.map.addObject(group);
      self.hereMaps.map.getViewModel().setLookAtData({
        bounds: group.getBoundingBox()
      });
    }
  },
  mounted: function mounted() {
    var self = this;
    var mapContainer = document.getElementById('mapHere2');
    self.hereMaps.platform = new window.H.service.Platform({ apikey: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key });

    var defaultLayers = self.hereMaps.platform.createDefaultLayers();
    self.hereMaps.map = new window.H.Map(mapContainer, defaultLayers.vector.normal.map, {
      center: self.center,
      zoom: 13,
      pixelRatio: window.devicePixelRatio || 1
    });

    /* eslint-disable no-unused-vars */
    var behavior = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(self.hereMaps.map));
    /* eslint-enable no-unused-vars */
    self.hereMaps.ui = window.H.ui.UI.createDefault(self.hereMaps.map, defaultLayers);
  }
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropZone_vue__ = __webpack_require__(479);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9616ddfa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropZone_vue__ = __webpack_require__(1341);
function injectStyle (ssrContext) {
  __webpack_require__(1331)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9616ddfa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropZone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9616ddfa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropZone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DropzoneControls__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Partials_LoadingAnimation_MapMarker__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_api_featureToggle__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drop-zone',
  components: { Draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a, DropzoneControls: __WEBPACK_IMPORTED_MODULE_3__DropzoneControls__["a" /* default */], LoaderMapMarker: __WEBPACK_IMPORTED_MODULE_4__components_Partials_LoadingAnimation_MapMarker__["a" /* default */] },
  data: function data() {
    return {
      overDropZone: false
    };
  },

  computed: {
    items: {
      get: function get() {
        return this.$store.state.routing.dropzone.items;
      },
      set: function set(value) {
        // a rsvp dropoff should not occur before pickup
        var stops = value;

        var _loop = function _loop(i) {
          var rsvpID = stops[i].reservationID;
          var rsvps = stops.filter(function (stop) {
            return stop.reservationID === rsvpID;
          });
          if (rsvps.length < 2) {
            return {
              v: void 0
            };
          }
          if (!rsvps[0].isPickup) {
            return {
              v: void 0
            };
          }
        };

        for (var i = 0; i < stops.length; i++) {
          var _ret = _loop(i);

          if ((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
        }
        this.$store.commit('routing/setDropzoneItems', value);
      }
    },
    showDropzone: function showDropzone() {
      return this.$store.state.routing.dropzone.show;
    },
    checkRouteLoading: function checkRouteLoading() {
      return this.$store.state.routing.dropzone.checkRoute;
    }
  },
  methods: {
    handleDrop: function handleDrop(data) {
      var self = this;
      var items = self.items;

      if (items.length) {
        if (items[0].serviceId !== data.serviceId) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'Different service types cannot be packaged together.'
          });
          return;
        }
      }

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (data.type === 'package') {
          if (item.packageID === data.id) {
            return;
          }
        } else {
          if (item.reservationID === data.id) {
            return;
          }
        }
      }
      self.$store.commit('routing/addDropzoneItem', data);
      if (data.type === 'package' && data.driver && data.driver !== null) {
        self.$store.commit('routing/addDropzoneDriver', {
          packageID: data.id,
          driver: data.driver
        });
      }
    },
    computeEta: function computeEta(stop) {
      var self = this;
      var firstStop = self.items[0];
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(firstStop.pickupTime, 'MM/DD/YYYY hh:mmA').add(stop.eta, 'seconds').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_5__modules_api_featureToggle__["a" /* default */].timeFormat(self, false));
    },
    computeMaxEta: function computeMaxEta(stop) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(stop.originalPickupTime, 'MM/DD/YYYY hh:mmA').add(stop.maxDuration, 'seconds').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_5__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
    },
    computeOriginalBTT: function computeOriginalBTT(stop) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(stop.originalPickupTime, 'MM/DD/YYYY hh:mmA').add(stop.originalBTT, 'seconds').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_5__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
    },
    showWarning: function showWarning(stop) {
      var self = this;
      var firstStop = self.items[0];
      var eta = __WEBPACK_IMPORTED_MODULE_1_moment___default()(firstStop.pickupTime, 'MM/DD/YYYY hh:mmA').add(stop.eta, 'seconds');
      var target = __WEBPACK_IMPORTED_MODULE_1_moment___default()(stop.originalPickupTime, 'MM/DD/YYYY hh:mmA').add(stop.originalBTT, 'seconds');
      if (stop.isPickup) {
        target = __WEBPACK_IMPORTED_MODULE_1_moment___default()(stop.pickupTime, 'MM/DD/YYYY hh:mmA');
      }
      return eta.isAfter(target);
    },
    hasIssues: function hasIssues(stop) {
      var self = this;
      var firstStop = self.items[0];
      var eta = __WEBPACK_IMPORTED_MODULE_1_moment___default()(firstStop.pickupTime, 'MM/DD/YYYY hh:mmA').add(stop.eta, 'seconds');
      var target = __WEBPACK_IMPORTED_MODULE_1_moment___default()(stop.originalPickupTime, 'MM/DD/YYYY hh:mmA').add(stop.originalBTT, 'seconds');
      if (stop.isPickup) {
        target = __WEBPACK_IMPORTED_MODULE_1_moment___default()(stop.originalPickupTime, 'MM/DD/YYYY hh:mmA');
      }
      if (eta.isAfter(target)) {
        return 'Will arrive ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(target.diff(eta)).humanize() + ' after the ' + (stop.isPickup ? 'Orginal Pickup Time.' : 'Be There Time.');
      }
      return 'Will arrive ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(target.diff(eta)).humanize() + ' before the ' + (stop.isPickup ? 'Original Pickup Time.' : 'Be There Time.');
    },
    getAddress: function getAddress(location) {
      if (location.geofenceType === 'airport' && location.geofenceName !== '') {
        var result = location.geofenceName;
        if (location.terminal && location.terminal !== '' && location.terminal !== 'undefined') {
          result += ' - Terminal ' + location.terminal;
        }
        return result;
      }
      return location.title;

      // let address = ''
      // if (location.address2 && location.address2 !== '' && location.address2 !== 'undefined') {
      //   address = address + location.address2 + ' '
      // }
      // if (location.address1) {
      //   address = address + location.address1 + ', '
      // }
      // if (location.city) {
      //   address = address + location.city + ' '
      // }
      // if (location.state) {
      //   address = address + location.state + ' '
      // }
      // if (location.zip) {
      //   address = address + location.zip
      // }

      // return address
    },
    removeFromMap: function removeFromMap(item) {
      var self = this;
      self.$store.commit('routing/removeDropzoneItem', item);

      // remove dropzone driver
      self.removeDriver(item.packageID);
    },
    removeDriver: function removeDriver(packageID) {
      if (packageID === null) {
        return;
      }

      var self = this;
      var stops = self.$store.state.routing.dropzone.items;
      if (stops.filter(function (stop) {
        return stop.packageID === packageID;
      }).length > 0) {
        return;
      }

      var drivers = self.$store.state.routing.dropzone.drivers;
      var remainingDrivers = drivers.filter(function (item) {
        return item.packageID !== packageID;
      });
      self.$store.commit('routing/setDropzoneDrivers', remainingDrivers);
    }
  }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dropzone-controls',
  computed: {
    items: function items() {
      return this.$store.state.routing.dropzone.items;
    }
  },
  methods: {
    removeDuplicates: function removeDuplicates(items) {
      return items.filter(function (item, index, self) {
        return index === self.findIndex(function (p) {
          return p.reservationID === item.reservationID && p.reservationID === item.reservationID;
        });
      });
    },
    clearMap: function clearMap() {
      this.$store.commit('routing/clearDropzone');
    },
    optimizeRoute: function optimizeRoute() {
      var self = this;
      var items = self.removeDuplicates(self.items);
      var rsvpIDs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(items, function (item) {
        return item.reservationID;
      });

      self.$store.commit('routing/setCheckRouteLoading', true);
      self.$sdk.post('/admin/package/optimize', {
        token: self.$store.state.session.sessionToken,
        resIDs: rsvpIDs
      }, function (r) {
        console.log('J', r);
        self.$store.commit('routing/setCheckRouteLoading', false);
        if (r.error) {
          console.log(r);
          // SHOW error message
          return;
        }

        var stops = [];

        var _loop = function _loop(i) {
          var stop = r.stops[i];
          var isPickup = stop.pickup === 1;
          var rsvp = self.items.filter(function (item) {
            return item.reservationID === parseInt(stop.reservationID) && item.isPickup === isPickup;
          })[0];

          stops.push({
            eta: stop.eta,
            maxDuration: stop.maxDuration,
            originalBTT: rsvp.originalBTT,
            inOrder: stop.inOrder,
            isPickup: isPickup,
            location: rsvp.location,
            luggage: rsvp.luggage,
            passengers: rsvp.passengers,
            reservationID: rsvp.reservationID,
            pickupTime: rsvp.pickupTime,
            originalPickupTime: rsvp.originalPickupTime,
            packageID: rsvp.packageID,
            status: rsvp.status
          });
        };

        for (var i = 0; i < r.stops.length; i++) {
          _loop(i);
        }
        self.$store.commit('routing/setDropzoneItems', stops);
      });
    },
    savePackage: function savePackage() {
      var self = this;
      self.$store.commit('routing/showRoutingModal');

      var message = 'Are you sure you want to save this package?';
      var action = 'SAVE_PACKAGE';
      if (self.$store.state.routing.dropzone.drivers.length === 1) {
        var driver = self.$store.state.routing.dropzone.drivers[0].driver;
        message = 'Do you want to keep the assignment of this package to ' + '<a href="/#/provider/' + driver.ID + '" target="_blank">' + driver.firstName + ' ' + driver.lastName + '</a>?';
        action = 'SAVE_PACKAGE_KEEP_DRIVER';
      }
      if (self.$store.state.routing.dropzone.drivers.length > 1) {
        message = 'Please select one driver to assign the package to:';
        action = 'SAVE_PACKAGE_MULTIPLE_DRIVERS';
      }
      self.$store.commit('routing/setConfirmationModal', {
        show: true,
        title: 'Confirm Package',
        message: message,
        action: action
      });
    }
  }
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'routing-modal',
  computed: {
    modal: function modal() {
      return this.$store.state.routing.routingModal;
    },
    hasMultipleDrivers: function hasMultipleDrivers() {
      return this.$store.state.routing.dropzone.drivers.length > 1;
    },
    dropzoneDrivers: function dropzoneDrivers() {
      return this.$store.state.routing.dropzone.drivers;
    }
  },
  methods: {
    close: function close() {
      if (this.$store.state.routing.routingModal.ajax.show) {
        return;
      }
      this.$store.commit('routing/hideRoutingModal');
    },
    confirmAction: function confirmAction() {
      var self = this;
      var action = self.modal.confirmation.action;
      if (action === 'SAVE_RUN') {
        self.saveRun();
        return;
      }
      if (action === 'BREAK_RUN') {
        self.breakRun();
        return;
      }
      if (action === 'SAVE_PACKAGE') {
        self.savePackage(null);
        return;
      }
      if (action === 'SAVE_PACKAGE_KEEP_DRIVER') {
        // There's only one driver
        var driver = self.$store.state.routing.dropzone.drivers[0].driver;
        self.savePackage(driver.ID);
        return;
      }
    },
    closeAction: function closeAction() {
      var self = this;
      var action = self.modal.confirmation.action;
      if (action === 'SAVE_PACKAGE_KEEP_DRIVER') {
        self.savePackage(null);
        return;
      }
      if (this.$store.state.routing.routingModal.ajax.show) {
        return;
      }
      this.$store.commit('routing/hideRoutingModal');
    },
    savePackage: function savePackage(provId) {
      var self = this;
      var stops = self.$store.state.routing.dropzone.items;

      self.$store.commit('routing/resetConfirmationModal');
      self.$store.commit('routing/setRoutingAjaxModal', {
        show: true,
        loading: true,
        success: false,
        message: 'Saving package...'
      });

      var request = {
        token: self.$store.state.session.sessionToken,
        provId: provId,
        items: []
      };
      for (var i = 0; i < stops.length; i++) {
        request.items.push({
          rsvpId: stops[i].reservationID,
          pickup: stops[i].isPickup,
          eta: stops[i].eta,
          maxDuration: stops[i].maxDuration
        });
      }

      self.$sdk.post('/admin/package/save', request, function (r) {
        var success = true;
        var message = 'Successfully saved package!';
        if (r.error) {
          console.log(r);
          success = false;
          message = 'Oops. Something went wrong. Please try again later.';
        }

        self.$store.commit('routing/setRoutingAjaxModal', {
          show: true,
          loading: false,
          success: success,
          message: message
        });

        if (success) {
          self.$store.commit('routing/clearDropzone');
        }

        setTimeout(function () {
          self.$store.commit('routing/hideRoutingModal');
        }, 1000);
      });
    },
    saveRun: function saveRun() {
      // console.log('SAVE RUN')
      var self = this;

      var items = self.$store.state.runs.dropzone.items;
      var runIds = [];
      var resIds = [];

      // console.log('J', items)
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (item.runId) {
          if (runIds.indexOf(item.runId) < 0) {
            runIds.push(item.runId);
          }
        }
        var res = { reservationId: item.id };
        if (item.distanceToNext !== null) {
          res['nextPickupMiles'] = item.distanceToNext;
        }
        resIds.push(res);
      }

      self.$store.commit('routing/resetConfirmationModal');
      self.$store.commit('routing/setRoutingAjaxModal', {
        show: true,
        loading: true,
        success: false,
        message: 'Saving run...'
      });

      // break existing
      if (runIds.length > 0) {
        self.$sdk.post('/runs/break', {
          token: self.$store.state.session.sessionToken,
          runId: runIds
        }, function (r) {
          console.log('BREAK', r);
          if (r.error) {
            self.$store.commit('routing/setRoutingAjaxModal', {
              show: true,
              loading: false,
              success: false,
              message: 'Oops. Something went wrong. Please try again later.'
            });
          }

          self.$sdk.post('/runs/create', {
            token: self.$store.state.session.sessionToken,
            run: resIds
          }, function (r) {
            console.log('CREATE', r);
            var success = true;
            var message = 'Successfully saved run!';
            if (r.error) {
              success = false;
              message = 'Oops. Something went wrong. Please try again later.';
            }

            self.$store.commit('routing/setRoutingAjaxModal', {
              show: true,
              loading: false,
              success: success,
              message: message
            });

            if (success) {
              self.$store.commit('runs/clearDropzone');
            }

            self.$store.commit('runs/setRunsDetails', { refresh: true });

            setTimeout(function () {
              self.$store.commit('routing/hideRoutingModal');
            }, 1000);
          }, '2.0');
        }, '2.0');
        return;
      }

      self.$sdk.post('/runs/create', {
        token: self.$store.state.session.sessionToken,
        run: resIds
      }, function (r) {
        console.log('CREATE', r);
        var success = true;
        var message = 'Successfully saved run!';
        if (r.error) {
          success = false;
          message = 'Oops. Something went wrong. Please try again later.';
        }

        self.$store.commit('routing/setRoutingAjaxModal', {
          show: true,
          loading: false,
          success: success,
          message: message
        });

        if (success) {
          self.$store.commit('runs/clearDropzone');
        }

        self.$store.commit('runs/setRunsDetails', { refresh: true });

        setTimeout(function () {
          self.$store.commit('routing/hideRoutingModal');
        }, 1000);
      }, '2.0');
    },
    breakRun: function breakRun() {
      var self = this;

      self.$store.commit('routing/resetConfirmationModal');
      self.$store.commit('routing/setRoutingAjaxModal', {
        show: true,
        loading: true,
        success: false,
        message: 'Breaking run...'
      });

      self.$sdk.post('/runs/break', {
        token: self.$store.state.session.sessionToken,
        runId: self.$store.state.runs.breakIds
      }, function (r) {
        if (r.error) {
          self.$store.commit('routing/setRoutingAjaxModal', {
            show: true,
            loading: false,
            success: false,
            message: 'Oops. Something went wrong. Please try again later.'
          });
          return;
        }

        self.$store.state.runs.breakIds.forEach(function (x) {
          self.$store.commit('runs/removeRunsInMap', x);
        });
        self.$store.commit('routing/setRoutingAjaxModal', {
          show: true,
          loading: false,
          success: true,
          message: 'Successfully break run!'
        });

        self.$store.commit('runs/setRunsDetails', { refresh: true });

        setTimeout(function () {
          self.$store.commit('routing/hideRoutingModal');
        }, 1000);
      }, '2.0');
    }
  }
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ready-to-go-modal',
  data: function data() {
    return {
      error: '',
      success: false
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.dispatch.readyToGo.show;
    },
    loading: function loading() {
      return this.$store.state.dispatch.readyToGo.loading;
    },
    rsvpID: function rsvpID() {
      return this.$store.state.dispatch.readyToGo.id;
    },
    rtgSuccess: function rtgSuccess() {
      return this.$store.state.dispatch.readyToGo.success;
    }
  },
  methods: {
    close: function close() {
      if (this.loading) {
        return;
      }
      this.error = '';
      this.success = false;
      this.$store.commit('dispatch/setReadyToGoID', 0);
      this.$store.commit('dispatch/setReadyToGoShow', false);

      if (this.rtgSuccess && this.$route.name === 'RsvpDetails') {
        this.$store.commit('dispatch/setReadyToGoSuccess', false);
        location.reload();
      }
    },
    confirm: function confirm() {
      var self = this;
      if (self.loading) {
        return;
      }
      self.$store.commit('dispatch/setReadyToGoLoading', true);

      self.$sdk.post('/admin/rsvp/' + this.rsvpID + '/ready', {
        token: self.$store.state.session.sessionToken
      }, function (res) {
        self.$store.commit('dispatch/setReadyToGoLoading', false);
        if (res.error) {
          self.error = res.error.message;
          return;
        }

        self.success = true;
        self.$store.commit('dispatch/setReadyToGoSuccess', true);
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotesModal_vue__ = __webpack_require__(484);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ece986c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotesModal_vue__ = __webpack_require__(1352);
function injectStyle (ssrContext) {
  __webpack_require__(1348)
  __webpack_require__(1350)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ece986c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotesModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ece986c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotesModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notes-modal',
  data: function data() {
    return {
      error: '',
      success: false
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.dispatch.notes.show;
    },
    message: function message() {
      if (Array.isArray(this.$store.state.dispatch.notes.message)) {
        var rsvp = this.$store.state.dispatch.notes.message;
        var message = rsvp.map(function (item) {
          return '<div class="message"><a href=\'/#/reservation/' + item.rsvpID + '\' target="_blank">' + item.rsvpID + '</a>: ' + item.notes + '</div>';
        });
        return message.join("\n");
      } else {
        return '<label class="message">' + this.$store.state.dispatch.notes.message + '</label>';
      }
    },
    loading: function loading() {
      return this.$store.state.dispatch.notes.loading;
    },
    rtgSuccess: function rtgSuccess() {
      return this.$store.state.dispatch.notes.success;
    }
  },
  methods: {
    close: function close() {
      if (this.loading) {
        return;
      }
      this.error = '';
      this.success = false;
      this.$store.commit('dispatch/setNotesMessage', '');
      this.$store.commit('dispatch/setNotesShow', false);

      // if (this.rtgSuccess && this.$route.name === 'RsvpDetails') {
      //   this.$store.commit('dispatch/setReadyToGoSuccess', false)
      //   location.reload()
      // }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverServiceFilter_vue__ = __webpack_require__(486);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f90f94f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverServiceFilter_vue__ = __webpack_require__(1355);
function injectStyle (ssrContext) {
  __webpack_require__(1353)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f90f94f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverServiceFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f90f94f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverServiceFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_dispatch_drivers__ = __webpack_require__(37);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import services from '@/modules/api/services'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'driver-service-filter',
  data: function data() {
    return {
      firstBrand: false,
      openBrand: [],
      // selectedService: [],
      hasToggleService: false
    };
  },

  computed: {
    brands: function brands() {
      return this.$store.state.brands.list;
    },
    selectedService: function selectedService() {
      return this.$store.state.dispatch.serviceFilter.list;
    }
  },
  methods: {
    serviceList: function serviceList(brandId) {
      var self = this;
      var serviceList = self.$store.state.services.list.filter(function (x) {
        return x.brandId === brandId && x.enabled;
      });
      if (!self.hasToggleService) {
        serviceList.forEach(function (service) {
          if (self.selectedService.indexOf(service.id) === -1) {
            // self.selectedService.push(service.id)
            self.$store.commit('dispatch/toggleServiceFilterList', service.id);
          }
        });
      }

      if (!self.firstBrand && serviceList.length) {
        self.openBrand.push(brandId);
        self.firstBrand = true;
      }
      return serviceList;
    },
    toggleBrand: function toggleBrand(brandId) {
      if (this.openBrand.indexOf(brandId) > -1) {
        var index = this.openBrand.indexOf(brandId);
        this.openBrand.splice(index, 1);
      } else {
        this.openBrand.push(brandId);
      }
    },
    toggleService: function toggleService(serviceId) {
      this.hasToggleService = true;
      this.$store.commit('dispatch/toggleServiceFilterList', serviceId);
      // if (this.selectedService.indexOf(serviceId) > -1) {
      // let index = this.selectedService.indexOf(serviceId)
      // this.selectedService.splice(index, 1)
      // } else {
      // this.selectedService.push(serviceId)
      // }
    },
    closeModal: function closeModal() {
      this.$store.commit('dispatch/setServiceFilterShow', false);
    },
    applyFilters: function applyFilters() {
      var self = this;
      var openedDriverTable = self.$store.state.dispatch.driverListTabIndex;
      var pageNumberMutation = 'dispatch/setOnDutyPageNumber';
      if (openedDriverTable === 1) {
        pageNumberMutation = 'dispatch/setStagingPageNumber';
      }
      if (openedDriverTable === 2) {
        pageNumberMutation = 'dispatch/setOffDutyPageNumber';
      }
      // Reset everything to page 1
      self.$store.commit(pageNumberMutation, 1);

      var data = {
        onDuty: openedDriverTable === 0,
        isStaging: openedDriverTable === 1
      };
      self.$store.commit('dispatch/setServiceFilterLoading', true);
      self.closeModal();
      __WEBPACK_IMPORTED_MODULE_0__modules_api_dispatch_drivers__["a" /* default */].getDriverListV2(self, data, function (r) {
        self.$store.commit('dispatch/setServiceFilterLoading', false);
        if (r.error) {
          console.log(r);
          return;
        }
        self.$plugins.smoothScroll.scrollTo(document.getElementById('driver-list-container'));

        var mutation = 'dispatch/setOnDutyNoDriversFound';
        if (openedDriverTable === 1) {
          mutation = 'dispatch/setStagingNoDriversFound';
        }
        if (openedDriverTable === 2) {
          mutation = 'dispatch/setOffDutyNoDriversFound';
        }
        self.$store.commit(mutation, r.list.length <= 0);
      });
    }
  },
  mounted: function mounted() {
    // let self = this
    // setTimeout(() => {
    //   self.applyFilters()
    // }, 2000)
  }
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RunsList__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ExclusiveList__ = __webpack_require__(491);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'runs-table',
  components: { RunsList: __WEBPACK_IMPORTED_MODULE_0__RunsList__["a" /* default */], ExclusiveList: __WEBPACK_IMPORTED_MODULE_1__ExclusiveList__["a" /* default */] },
  data: function data() {
    return {};
  },

  computed: {
    runs: function runs() {
      return this.$store.state.runs;
    }
  }
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunsList_vue__ = __webpack_require__(489);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5326644a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunsList_vue__ = __webpack_require__(1365);
function injectStyle (ssrContext) {
  __webpack_require__(1359)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5326644a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5326644a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_LoadingAnimation_ArrowUp__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Partials_LoadingAnimation_Ellipsis__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RunsRow__ = __webpack_require__(1361);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'runs-table',
  components: { ArrowUp: __WEBPACK_IMPORTED_MODULE_0__components_Partials_LoadingAnimation_ArrowUp__["a" /* default */], EllipsisLoader: __WEBPACK_IMPORTED_MODULE_1__components_Partials_LoadingAnimation_Ellipsis__["a" /* default */], RunsRow: __WEBPACK_IMPORTED_MODULE_2__RunsRow__["a" /* default */] },
  data: function data() {
    return {
      isMobile: false
    };
  },

  computed: {
    route: function route() {
      return this.$route.name;
    },
    runs: function runs() {
      return this.$store.state.runs;
    },
    airports: function airports() {
      return this.$store.state.airports.list;
    },

    selected: {
      get: function get() {
        return this.runs.selected;
      },
      set: function set(x) {
        this.$store.commit('runs/setRunsDetails', { selected: x });
      }
    }
  },
  methods: {
    getAddress: function getAddress(loc) {
      var index = this.airports.findIndex(function (x) {
        return x.geofenceId === loc.geofenceId;
      });
      if (index > -1) return this.airports[index].title;
      return loc.title;
    },
    setScreenSize: function setScreenSize() {
      var self = this;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        self.isMobile = true;
      } else {
        self.isMobile = false;
      }
    }
  },
  mounted: function mounted() {
    this.setScreenSize();
  },

  watch: {
    'runs.list': function runsList(val) {
      if (val.length) {
        this.$nextTick(function () {
          setTimeout(function () {
            var pickup = document.querySelector('#runs-table');
            document.querySelector('#runs-table thead .pickup').setAttribute('style', 'width:' + (pickup.offsetWidth - 400) / 2 + 'px');
            var dropoff = document.querySelector('#runs-table');
            document.querySelector('#runs-table thead .dropoff').setAttribute('style', 'width:' + (pickup.offsetWidth - 400) / 2 + 'px');
          }, 100);
        });
      }
    }
  }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_browser_request__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_browser_request___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_browser_request__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'runs-table',
  props: ['run', 'isMobile'],
  data: function data() {
    return {
      timeLeft: '',
      timerDelay: '',
      isDisabled: false
    };
  },

  computed: {
    runs: function runs() {
      return this.$store.state.runs;
    },
    airports: function airports() {
      return this.$store.state.airports.list;
    },

    selected: {
      get: function get() {
        return this.runs.selected;
      },
      set: function set(x) {
        this.$store.commit('runs/setRunsDetails', { selected: x });
      }
    },
    inMap: function inMap() {
      var _this = this;

      var mapItems = this.$store.state.runs.dropzone.items;
      var item = mapItems.filter(function (mapItem) {
        return mapItem.runId === _this.run.id;
      });
      return item.length > 0;
    },
    dropzoneItems: function dropzoneItems() {
      return this.$store.state.runs.dropzone.items;
    },

    // hasIssues () { return false },
    sendTimer: function sendTimer() {
      var timer = this.runs.other.sendTimer['a' + this.run.id];
      if (timer) {
        if (this.timerDelay) clearTimeout(this.timerDelay);
        if (timer != 0) this.startCountdown();
        this.timeLeft = 'Waiting for reply.. (' + timer + ')';
      }
      return timer ? timer : 0;
    }
  },
  methods: {
    select: function select(x) {
      if (this.selected == x) {
        this.selected = null;
        return;
      }

      // this.$store.commit('runs/clearDropzone')
      // this.toggleInMap()
    },
    dragFn: function dragFn(showDropzone) {
      this.$store.commit('runs/setDropzoneData', { show: showDropzone });
    },
    getAddress: function getAddress(loc) {
      var index = this.airports.findIndex(function (x) {
        return x.geofenceId === loc.geofenceId;
      });
      if (index > -1) return this.airports[index].title;
      return loc.title;
    },
    toggleInMap: function toggleInMap() {
      var self = this;
      self.$store.commit('runs/setRunsInMap', self.run.id);
      if (self.inMap) {
        self.$store.commit('runs/removeDropzoneItems', self.run);
        return;
      }
      var item = self.run;
      for (var i = 0; i < item.rsvps.length; i++) {
        var rsvp = item.rsvps[i];
        rsvp['runId'] = item.id;
        self.$store.commit('runs/addDropzoneItem', rsvp);
      }
    },
    breakRun: function breakRun(id) {
      this.$store.commit('runs/setRunsDetails', { breakIds: [id] });
      this.$store.commit('routing/setConfirmationModal', {
        show: true,
        title: 'Confirm Break Run',
        message: 'Are you sure you want to break this run?',
        action: 'BREAK_RUN'
      });
      this.$store.commit('routing/showRoutingModal');
    },
    startCountdown: function startCountdown() {
      var _this2 = this;

      var self = this;
      var x = parseInt(this.runs.other.sendTimer['a' + this.run.id] || 0);
      if (self.timerDelay) clearTimeout(self.timerDelay);
      if (x <= 0) {
        this.timeLeft = 0;
        return;
      }

      setTimeout(function () {
        var newTime = _this2.runs.other.sendTimer['a' + _this2.run.id] - 1;
        self.$store.commit('runs/setSendTimer', {
          id: self.run.id,
          time: newTime
        });
        self.timeLeft = 'Waiting for reply.. (' + newTime + ')';
        if (newTime > 0 && _this2.runs.other.sendTimer['a' + _this2.run.id] != 0) self.startCountdown();
        if (newTime % 5 === 0 || newTime <= 0) {
          self.getRsvpInfo(self.run.rsvpIDs[0]);
        }
        if (newTime == 0) {
          _this2.timeLeft = 0;
        }
      }, 1050);
    },
    getRsvpInfo: function getRsvpInfo(rsvpId) {
      var _this3 = this;

      var self = this;
      if (!rsvpId) return;
      self.$sdk.get('/admin/rsvp/' + rsvpId, {
        token: self.$store.state.session.sessionToken
      }, function (res) {
        if (!res.error) {
          if (res.provider.ID) {
            if (self.sendTimerDelay) clearTimeout(self.sendTimerDelay);

            self.$store.commit('runs/setRunsDetails', { refresh: true });
            self.$store.commit('global/setAlertData', {
              show: true,
              message: 'Driver <b>' + res.provider.firstName + ' ' + res.provider.lastName + '</b> has accepted the run.'
            });
            self.timeLeft = '';
            self.$store.commit('runs/setSendTimer', { id: self.run.id, time: 0 });
            self.$store.commit('runs/deleteSendTimer', self.run.id);

            // clear HERE maps
            // for (let object of self.hereMaps.map.getObjects()) {
            //   self.hereMaps.map.removeObject(object)
            // }
            // self.hereMaps.ui.getBubbles().forEach(bub => {
            //   self.hereMaps.ui.removeBubble(bub)
            // })

            // clear RUNS dropzone
            _this3.$store.commit('runs/clearDropzone');
          }
        }
      });
    },
    hasIssues: function hasIssues() {
      var self = this;
      if (self.inMap) {
        self.isDisabled = false;
        return;
      }
      if (self.dropzoneItems.length <= 0) {
        self.isDisabled = false;
        return;
      }
      var lastItem = self.dropzoneItems[self.dropzoneItems.length - 1];
      var rsvp = self.run.rsvps[self.run.rsvps.length - 1];
      if (rsvp.id == lastItem.id) {
        self.isDisabled = false;
        return;
      }
      var url = 'https://router.hereapi.com/v8/routes?apiKey={API_KEY}&transportMode=car&return=polyline,summary';
      url = url.replace('{API_KEY}', {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key);
      url += '&origin=' + lastItem.dropoff.lat + ',' + lastItem.dropoff.lng;
      url += '&destination=' + rsvp.pickup.lat + ',' + rsvp.pickup.lng;

      var eta = __WEBPACK_IMPORTED_MODULE_0_moment___default()(lastItem.pickupDate, 'MM/DD/YYYY hh:mmA').add(lastItem.eta, 'seconds').add(lastItem.timeToNext, 'seconds');
      var nextPickup = __WEBPACK_IMPORTED_MODULE_0_moment___default()(rsvp.pickupDate, 'MM/DD/YYYY hh:mmA');
      __WEBPACK_IMPORTED_MODULE_1_browser_request___default.a.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) {
          console.log('ROUTING ERROR', error);
          self.isDisabled = false;
          return;
        }

        if (!body.routes.length) {
          return;
        }
        var routeSections = body.routes[0].sections;
        var etaInSec = 0;
        for (var i = 0; i < routeSections.length; i++) {
          var section = routeSections[i];
          etaInSec = etaInSec + section.summary.duration;
        }
        var newEta = __WEBPACK_IMPORTED_MODULE_0_moment___default()(lastItem.pickupDate, 'MM/DD/YYYY hh:mmA').add(lastItem.eta, 'seconds').add(etaInSec, 'seconds');
        if (newEta.isAfter(nextPickup)) {
          self.isDisabled = true;
        }
      });
      if (eta.isAfter(nextPickup)) {
        self.isDisabled = true;
        return;
      }
      self.isDisabled = false;
      return;
    }
  },
  mounted: function mounted() {},

  watch: {
    dropzoneItems: function dropzoneItems(value) {
      var self = this;
      if (value.length <= 0) {
        self.isDisabled = false;
        return;
      }
      // self.hasIssues()
    }
  }
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExclusiveList_vue__ = __webpack_require__(492);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_459c7492_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExclusiveList_vue__ = __webpack_require__(1372);
function injectStyle (ssrContext) {
  __webpack_require__(1366)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-459c7492"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExclusiveList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_459c7492_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExclusiveList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_LoadingAnimation_ArrowUp__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Partials_LoadingAnimation_Ellipsis__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ExclusiveRow__ = __webpack_require__(1368);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'exclusive-table',
  components: { ArrowUp: __WEBPACK_IMPORTED_MODULE_0__components_Partials_LoadingAnimation_ArrowUp__["a" /* default */], EllipsisLoader: __WEBPACK_IMPORTED_MODULE_1__components_Partials_LoadingAnimation_Ellipsis__["a" /* default */], ExclusiveRow: __WEBPACK_IMPORTED_MODULE_2__ExclusiveRow__["a" /* default */] },
  data: function data() {
    return {
      isMobile: false
    };
  },

  computed: {
    runs: function runs() {
      return this.$store.state.runs;
    },
    exclusive: function exclusive() {
      return this.runs.exclusive;
    },
    airports: function airports() {
      return this.$store.state.airports.list;
    },

    selected: {
      get: function get() {
        return this.runs.selected;
      },
      set: function set(x) {
        this.$store.commit('runs/setRunsDetails', { selected: x });
      }
    }
  },
  methods: {
    getAddress: function getAddress(loc) {
      var index = this.airports.findIndex(function (x) {
        return x.geofenceId === loc.geofenceId;
      });
      if (index > -1) return this.airports[index].title;
      return loc.title;
    },
    setScreenSize: function setScreenSize() {
      var self = this;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        self.isMobile = true;
      } else {
        self.isMobile = false;
      }
    }
  },
  mounted: function mounted() {
    this.setScreenSize();
  },

  watch: {
    'exclusive.list': function exclusiveList(val) {
      if (val.length) {
        this.$nextTick(function () {
          setTimeout(function () {
            // table width fixer
            var pickup = document.querySelector('#exclusive-table');
            document.querySelector('#exclusive-table thead .pickup').setAttribute('style', 'width:' + (pickup.offsetWidth - 490) / 2 + 'px');
            var dropoff = document.querySelector('#exclusive-table');
            document.querySelector('#exclusive-table thead .dropoff').setAttribute('style', 'width:' + (pickup.offsetWidth - 490) / 2 + 'px');
          }, 100);
        });
      }
    }
  }
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_browser_request__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_browser_request___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_browser_request__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_featureToggle__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'exclusive-row',
  props: ['rsvp', 'isMobile'],
  data: function data() {
    return {
      isDisabled: false
    };
  },

  computed: {
    airports: function airports() {
      return this.$store.state.airports.list;
    },
    inMap: function inMap() {
      var _this = this;

      var mapItems = this.$store.state.runs.dropzone.items;
      var item = mapItems.filter(function (mapItem) {
        return mapItem.id === _this.rsvp.id;
      });
      return item.length > 0;
    },
    dropzoneItems: function dropzoneItems() {
      return this.$store.state.runs.dropzone.items;
    }
  },
  methods: {
    dragFn: function dragFn(showDropzone) {
      this.$store.commit('runs/setDropzoneData', { show: showDropzone });
    },
    getAddress: function getAddress(loc) {
      var index = this.airports.findIndex(function (x) {
        return x.geofenceId === loc.geofenceId;
      });
      if (index > -1) return this.airports[index].title;
      return loc.title;
    },
    showFlightInfo: function showFlightInfo(rsvp) {
      if (rsvp.flightInfo.airline === null) return;

      var self = this;
      self.$store.commit('flightInformation/show');

      var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(rsvp.pickupDate, 'MM/DD/YYYY hh:mmA');
      var airlineDate = encodeURIComponent(date.format('YYYY-MM-DD'));
      var airlineTime = encodeURIComponent(date.format('HH:mm:ss'));
      var flightNumber = rsvp.flightInfo.flightNo;
      var isDeparture = '&departure=' + (rsvp.flightInfo.isDeparture ? '1' : '0');
      var url = '/availability/flights/' + rsvp.flightInfo.airline + flightNumber + '?date=' + airlineDate + '&time=' + airlineTime + '&airport=' + rsvp.flightInfo.airportCode + isDeparture;
      self.$sdk.get(url, {}, function (r) {
        self.$store.commit('flightInformation/setLoading', false);
        if (r.error) {
          self.$store.commit('flightInformation/setFlightInfo', {
            airline: {
              name: rsvp.airline,
              code: rsvp.flightInfo.airline
            },
            flightNumber: flightNumber,
            departure: {
              airportCode: '',
              airportName: '',
              time: ''
            },
            arrival: {
              airportCode: '',
              airportName: '',
              time: ''
            },
            status: 'N/A'
          });
          return;
        }

        var isAirportDropoff = rsvp.flightInfo.isDeparture;
        var date = isAirportDropoff ? r.departure.time.unix : r.arrival.time.unix;
        var arriveDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date, 'X', r.departure.time.timezone);
        self.$store.commit('flightInformation/setFlightInfo', {
          airline: r.airline || rsvp.flightInfo.airline,
          flightNumber: r.flight.number || rsvp.flightInfo.flightNo,
          departure: {
            airportCode: r.departure.airportCode,
            airportName: r.departure.airportName,
            time: __WEBPACK_IMPORTED_MODULE_0_moment___default()(r.departure.time.unix, 'X', r.departure.time.timezone).format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_2__modules_api_featureToggle__["a" /* default */].timeFormat(self, false))
          },
          arrival: {
            airportCode: r.arrival.airportCode,
            airportName: r.arrival.airportName,
            time: arriveDate.format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_2__modules_api_featureToggle__["a" /* default */].timeFormat(self, false))
          },
          status: self.translateFlightStatus(r.status, isAirportDropoff),
          type: isAirportDropoff ? 'departure' : 'arrive'
        });
      });
    },
    translateFlightStatus: function translateFlightStatus(status, isAirportDropoff) {
      if (!isAirportDropoff) {
        switch (status) {
          case 'Scheduled':
            return 'Flight is arriving as scheduled.';
          case 'Proposed':
            return 'Flight is arriving as scheduled.';
          case 'OutGate':
            return 'Flight is arriving as scheduled.';
          case 'InAir':
            return 'Flight is currently on-air.';
          case 'Landed':
            return 'Flight has already arrived.';
          case 'InGate':
            return 'Flight has already arrived.';
          case 'Expected':
            return 'Flight is arriving as scheduled.';
          case 'NoTakeOffInfo':
            return 'Flight is arriving as scheduled.';
          case 'Delayed':
            return 'Flight is currently delayed.';
          case 'Cancelled':
            return 'Flight was cancelled.';
          case 'Unknown':
            return 'Flight is arriving as scheduled.';
          case 'PastFlight':
            return 'Flight has already arrived.';
          case 'Original':
            return 'Flight is arriving as scheduled.';
        }
        return 'Flight is arriving as scheduled.';
      }

      switch (status) {
        case 'Scheduled':
          return 'Flight is still scheduled.';
        case 'Proposed':
          return 'Flight is still scheduled.';
        case 'OutGate':
          return 'Flight is still scheduled.';
        case 'InAir':
          return 'Flight is currently on-air.';
        case 'Landed':
          return 'Flight has already landed.';
        case 'InGate':
          return 'Flight has already arrived.';
        case 'Expected':
          return 'Flight is still scheduled.';
        case 'NoTakeOffInfo':
          return 'Flight is still scheduled.';
        case 'Delayed':
          return 'Flight is currently delayed.';
        case 'Cancelled':
          return 'Flight has been cancelled.';
        case 'Unknown':
          return 'Flight is still scheduled.';
        case 'PastFlight':
          return 'Flight has already been completed.';
        case 'Original':
          return 'Flight is still scheduled.';
      }
      return 'Flight is still scheduled.';
    },
    toggleInMap: function toggleInMap() {
      var self = this;
      if (self.inMap) {
        self.$store.commit('runs/removeDropzoneItems', self.rsvp);
        return;
      }
      var rsvp = self.rsvp.rsvps[0];
      self.$store.commit('runs/addDropzoneItem', rsvp);
    },
    hasIssues: function hasIssues() {
      var self = this;
      if (self.inMap) {
        self.isDisabled = false;
        return false;
      }
      if (self.dropzoneItems.length <= 0) {
        self.isDisabled = false;
        return false;
      }
      var lastItem = self.dropzoneItems[self.dropzoneItems.length - 1];
      var url = 'https://router.hereapi.com/v8/routes?apiKey={API_KEY}&transportMode=car&return=polyline,summary';
      url = url.replace('{API_KEY}', {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key);
      url += '&origin=' + lastItem.dropoff.lat + ',' + lastItem.dropoff.lng;
      url += '&destination=' + self.rsvp.pickup.lat + ',' + self.rsvp.pickup.lng;

      var eta = __WEBPACK_IMPORTED_MODULE_0_moment___default()(lastItem.pickupDate, 'MM/DD/YYYY hh:mmA').add(lastItem.eta, 'seconds').add(lastItem.timeToNext, 'seconds');
      var nextPickup = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.rsvp.pickupDate, 'MM/DD/YYYY hh:mmA');
      __WEBPACK_IMPORTED_MODULE_1_browser_request___default.a.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) {
          console.log('ROUTING ERROR', error);
          self.isDisabled = false;
          return;
        }

        if (!body.routes.length) {
          return;
        }
        var routeSections = body.routes[0].sections;
        var etaInSec = 0;
        for (var i = 0; i < routeSections.length; i++) {
          var section = routeSections[i];
          etaInSec = etaInSec + section.summary.duration;
        }
        var newEta = __WEBPACK_IMPORTED_MODULE_0_moment___default()(lastItem.pickupDate, 'MM/DD/YYYY hh:mmA').add(lastItem.eta, 'seconds').add(etaInSec, 'seconds');
        if (newEta.isAfter(nextPickup)) {
          self.isDisabled = true;
        }
      });
      if (eta.isAfter(nextPickup)) {
        self.isDisabled = true;
        return true;
      }
      self.isDisabled = false;
      return false;
    }
  },
  mounted: function mounted() {},

  watch: {
    dropzoneItems: function dropzoneItems(value) {
      var self = this;
      if (value.length <= 0) {
        self.isDisabled = false;
        return;
      }
      self.hasIssues();
    }
  }
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableFilter_vue__ = __webpack_require__(495);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bae0d180_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableFilter_vue__ = __webpack_require__(1376);
function injectStyle (ssrContext) {
  __webpack_require__(1374)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bae0d180"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bae0d180_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_api_brands__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_api_services__ = __webpack_require__(6);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'table-filter',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default.a },
  props: ['shrink'],
  data: function data() {
    return {
      show: false,
      maxHour: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      error: {
        since: '',
        until: '',
        service: ''
      },
      openBrand: [],
      selectedBrand: [],
      selectedAllServices: true,
      selectedService: [],
      loaded: []
    };
  },

  computed: {
    route: function route() {
      return this.$route.name;
    },
    runs: function runs() {
      return this.$store.state.runs;
    },
    refresh: function refresh() {
      return this.runs.refresh;
    },
    exclusive: function exclusive() {
      return this.runs.exclusive;
    },
    airports: function airports() {
      return this.$store.state.airports.list;
    },

    searchKey: {
      get: function get() {
        return this.runs.search;
      },
      set: function set(x) {
        this.$store.commit('runs/setRunsDetails', { search: x });
      }
    },
    since: function since() {
      var date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.runs.since, 'MM/DD/YYYY hh:mmA');
      return {
        date: date.format('MM/DD/YYYY'),
        hour: date.format('hh'),
        minute: date.format('mm'),
        amPm: date.format('A')
      };
    },
    until: function until() {
      var date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.runs.until, 'MM/DD/YYYY hh:mmA');
      return {
        date: date.format('MM/DD/YYYY'),
        hour: date.format('hh'),
        minute: date.format('mm'),
        amPm: date.format('A')
      };
    },
    brands: function brands() {
      return this.$store.state.brands;
    },
    services: function services() {
      return this.$store.state.services;
    },
    _serviceList: function _serviceList() {
      return this.services.list;
    },
    qualifiedDriver: function qualifiedDriver() {
      return this.runs.qualifiedDriver;
    },
    dispatchStore: function dispatchStore() {
      return this.$store.state.dispatch;
    },
    driverPanel: function driverPanel() {
      return this.dispatchStore.driverPanelOpen;
    },
    tabActive: function tabActive() {
      return this.dispatchStore.tabActive;
    }
  },
  methods: {
    showFilter: function showFilter() {
      if (this.brands.loading || this.services.serviceLoading) return;
      this.show = !this.show;
    },
    loadList: function loadList() {
      var initSet = {};
      if (!this.runs.since) {
        initSet.since = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('MM/DD/YYYY') + ' 00:00AM';
      }
      if (!this.runs.until) {
        initSet.until = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('MM/DD/YYYY') + ' 23:59PM';
      }
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(initSet).length) {
        this.$store.commit('runs/setRunsDetails', initSet);
      }
      this.error.since = '';
      var hasError = false;
      if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.runs.until, 'MM/DD/YYYY hh:mmA').isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.runs.since, 'MM/DD/YYYY hh:mmA'))) {
        this.error.since = 'Invalid date range.';
        hasError = true;
      }
      this.error.service = '';
      if (!this.selectedService.length) {
        this.error.service = 'Please select at least one service type.';
        hasError = true;
      }
      // selectedService
      if (hasError) return;
      this.$store.commit('runs/setRunsDetails', { selectedServices: this.selectedService });

      this.getExclusive();
      this.updateDispatchSync();
      if (!this.airports.length) {
        this.getAirportList();
        return;
      }
      this.getRuns();
    },
    getExclusive: function getExclusive() {
      var self = this;
      if (self.runs.exclusive.loading) return;

      self.$store.commit('runs/setExclusiveDetails', {
        list: [],
        loading: true
      });
      self.show = false;
      self.$sdk.post('/runs/reservations', {
        token: self.$store.state.session.sessionToken,
        // search: self.searchKey,
        since: __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.runs.since, 'MM/DD/YYYY hh:mmA').format('YYYY-MM-DD HH:mm:00'),
        until: __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.runs.until, 'MM/DD/YYYY hh:mmA').format('YYYY-MM-DD HH:mm:59'),
        serviceTypeId: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(self.selectedService), [0])
      }, function (res) {
        self.$store.commit('runs/setExclusiveDetails', { loading: false });
        var list = [];
        if (!res.error) {
          res.list.forEach(function (rsvp) {
            var flightInfo = null;
            if (rsvp.pickupLocation.geofenceType === 'airport' || rsvp.dropoffLocation.geofenceType === 'airport') {
              var flightNumber = rsvp.dropoffFlightNumber;
              if (rsvp.pickupLocation.geofenceType === 'airport') {
                flightNumber = rsvp.flightNumber;
              }
              flightInfo = {
                airportCode: rsvp.airportCode,
                airline: rsvp.airlineCode,
                flightNo: flightNumber,
                isDeparture: rsvp.pickupLocation.geofenceType !== 'airport'
              };
            }
            var etaInSec = rsvp.etaInSec;
            etaInSec += 60 * 30; // add 30mins to ETA
            list.push({
              type: 'rsvp',
              id: rsvp.ID,
              driverPayment: rsvp.payment.driverPay + rsvp.payment.tipAmount + rsvp.payment.driverBonus + rsvp.gasFee + rsvp.payment.pickupFee,
              pickupDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()(rsvp.pickupDate, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
              pickup: rsvp.pickupLocation,
              dropoff: rsvp.dropoffLocation,
              service: {
                name: rsvp.serviceType.name,
                color: rsvp.serviceType.color
              },
              flightInfo: flightInfo,
              pax: rsvp.passengers,
              isOptinShared: rsvp.isOptinShared,
              rsvps: [{
                id: rsvp.ID,
                eta: etaInSec,
                pickupDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()(rsvp.pickupDate, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
                pickup: rsvp.pickupLocation,
                dropoff: rsvp.dropoffLocation,
                pax: rsvp.passengers,
                luggage: rsvp.luggage,
                timeToNext: null,
                distanceToNext: null
              }]
            });
          });
        }
        self.$store.commit('runs/setExclusiveDetails', { list: list });
      }, '2.0');
    },
    getAirportList: function getAirportList() {
      var self = this;
      if (self.airports.length) {
        self.getRuns();
        return;
      }

      self.$store.commit('airports/setLoading', true);
      self.$sdk.get('/airports', {}, function (r) {
        self.$store.commit('airports/setLoading', false);
        var list = [];
        if (!r.error) {
          r.list.forEach(function (data) {
            var add1 = data.addressLine2 === null ? data.addressLine1 : data.addressLine2;
            var add2 = data.addressLine2 === null ? '' : data.addressLine1;
            var title = add2 + ' ' + add1 + ', ' + data.city + ', ' + data.state + ' ' + data.zipCode;
            if (data.enabled) {
              list.push({
                geofenceId: data.id,
                geofenceType: 'airport',
                address1: add1,
                address2: add2,
                city: data.city,
                lat: data.lat,
                lng: data.lng,
                state: data.state,
                title: data.name || title,
                zip: data.zipCode,
                description: data.description,
                airportCode: data.airportCode,
                locationId: data.locationId
              });
            }
          });
        }
        self.$store.commit('airports/setList', list);
        self.getRuns();
      });
    },
    getRuns: function getRuns() {
      var _this = this;

      var self = this;
      if (self.runs.loading) return;
      self.$store.commit('runs/setRunsDetails', {
        list: [],
        loading: true
      });
      self.show = false;
      self.$sdk.post('/runs', {
        token: self.$store.state.session.sessionToken,
        search: self.searchKey,
        pickupSince: __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.runs.since, 'MM/DD/YYYY hh:mmA').utc().format('YYYY-MM-DD HH:mm:00'),
        pickupUntil: __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.runs.until, 'MM/DD/YYYY hh:mmA').utc().format('YYYY-MM-DD HH:mm:59'),
        serviceTypeId: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(self.selectedService), [0])
      }, function (res) {
        self.$store.commit('runs/setRunsDetails', { loading: false });
        var list = [];
        if (!res.error) {
          _this.$store.commit('runs/setRunsDetails', { selected: null });
          res.list.forEach(function (run) {
            if (run.providerId || self.runs.blackList.indexOf(run.id) > -1) {
              self.$store.commit('runs/removeBlackList', run.id);
              return;
            }
            var firstRsvp = run.rsvps.find(function (x) {
              return x.order === 0;
            });
            var lastRsvp = run.rsvps.find(function (x) {
              return x.order === run.rsvps.length - 1;
            });
            var rsvpIDs = [];
            var services = [];
            var rsvps = [];
            var driverPayment = 0;
            var pax = [];
            var brandId = run.rsvps[0].brandId;
            run.rsvps.forEach(function (rsvp) {
              rsvpIDs.push(rsvp.id);
              var etaInSec = rsvp.etaInSec;
              etaInSec += 60 * 30; // add 30mins to ETA
              rsvps.push({
                id: rsvp.id,
                eta: etaInSec,
                pickupDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()(rsvp.localPickupTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
                pickup: rsvp.pickup,
                dropoff: rsvp.dropoff,
                pax: rsvp.passengers || 1,
                luggage: rsvp.luggage || 0,
                timeToNext: null,
                distanceToNext: null,
                service: rsvp.serviceType
              });
              if (rsvp.serviceType && services.findIndex(function (x) {
                return x.name === rsvp.serviceType.name;
              }) === -1) {
                services.push({
                  id: rsvp.serviceType.id,
                  name: rsvp.serviceType.name || '',
                  color: rsvp.serviceType.color || ''
                });
              }
              driverPayment += rsvp.paidForProvider + rsvp.tipAmount + rsvp.bonusToProvider + rsvp.pickupFee + rsvp.gasFee;
              pax.push(rsvp.passengers);
            });
            list.push({
              type: 'runs',
              id: run.id,
              brandId: brandId,
              rsvpIDs: rsvpIDs,
              driverPayment: driverPayment,
              pickupDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()(run.firstPickup, 'X').format('MM/DD/YYYY hh:mmA'),
              lastDropoff: __WEBPACK_IMPORTED_MODULE_2_moment___default()(run.lastDropoff, 'X').format('MM/DD/YYYY hh:mmA'),
              pickup: firstRsvp.pickup,
              dropoff: lastRsvp.dropoff,
              services: services,
              pax: pax,
              rsvps: rsvps
            });
          });
        }
        self.$store.commit('runs/setRunsDetails', { list: list });
        if (self.$route.name === 'Dispatch' && self.tabActive.rsvp === 'runs' && self.driverPanel && self.tabActive.driver === 'availability') {
          var runsInMap = self.runs.other.runsInMap;
          if (runsInMap.length === 1) {
            var i = self.runs.list.findIndex(function (x) {
              return x.id === runsInMap[0];
            });
            if (i > -1) {
              self.$store.commit('runs/setDriverAvailabilityData', {
                checkId: self.runs.list[i].rsvpIDs[0],
                rsvpData: self.runs.list[i].rsvps.find(function (x) {
                  return x.id === self.runs.list[i].rsvpIDs[0];
                })
              });
            }
          }
        }
      }, '2.0');
    },
    search: function search(event) {
      var self = this;

      if (event && event.key === 'Enter') {
        this.$store.commit('runs/setRunsDetails', { selected: [] });
        this.getRuns();
        this.getExclusive();
        this.updateDispatchSync();
      }
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date, 'MM/DD/YYYY').format('MM/DD/YYYY');
    },
    changeDate: function changeDate(type) {
      this.error[type] = '';

      var format = 'MM/DD/YYYY hh:mmA';
      var selectedTime = '';
      var target = this[type];

      selectedTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(target.date);
      selectedTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(selectedTime.format('MM/DD/YYYY') + ' ' + target.hour + ':' + target.minute + target.amPm, 'MM/DD/YYYY hh:mmA');
      var update = {};
      update[type] = selectedTime.format(format);
      this.$store.commit('runs/setRunsDetails', update);
    },
    changeTime: function changeTime(type) {
      var target = this[type];
      var _obj = {};
      _obj[type] = target.date + ' ' + target.hour + ':' + target.minute + target.amPm;
      this.$store.commit('runs/setRunsDetails', _obj);
    },
    leadingZero: function leadingZero(n) {
      return parseInt(n) < 10 ? '0' + n : n;
    },
    updateDispatchSync: function updateDispatchSync() {
      var self = this;
      self.$sdk.get('/admin/rsvp/dispatch/sync', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          console.log(r);
          return;
        }
        self.$store.commit('dispatch/setLastSync', __WEBPACK_IMPORTED_MODULE_2_moment___default()(r.time, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'));
      });
    },
    serviceLabel: function serviceLabel(code) {
      return services.getServiceName(code);
    },
    serviceList: function serviceList(brandId) {
      var serviceList = this.$store.state.services.list.filter(function (x) {
        return x.brandId === brandId;
      });
      return serviceList;
    },
    toggleBrand: function toggleBrand(brandId) {
      if (this.openBrand.indexOf(brandId) > -1) {
        var index = this.openBrand.indexOf(brandId);
        this.openBrand.splice(index, 1);
      } else {
        if (this.openBrand.indexOf(brandId) === -1) {
          this.openBrand.push(brandId);
        }
      }
    },
    toggleService: function toggleService(serviceId, brandId) {
      var _this2 = this;

      if (this.selectedService.indexOf(serviceId) > -1) {
        var index = this.selectedService.indexOf(serviceId);
        this.selectedService.splice(index, 1);
      } else {
        this.selectedService.push(serviceId);
      }

      var services = this.serviceList(brandId);
      var checkServices = services.map(function (brand) {
        return brand.id;
      });
      if (checkServices.every(function (id) {
        return _this2.selectedService.includes(id);
      })) {
        if (this.selectedBrand.indexOf(brandId) === -1) {
          this.selectedBrand.push(brandId);
        }
      } else {
        if (this.selectedBrand.indexOf(brandId) > -1) {
          var _index = this.selectedBrand.indexOf(brandId);
          this.selectedBrand.splice(_index, 1);
        }
      }
    },
    selectAllBrands: function selectAllBrands() {
      var _this3 = this;

      var brands = this.brands.list;
      if (!this.selectedAllServices) {
        brands.forEach(function (brand) {
          if (_this3.selectedBrand.indexOf(brand.id) === -1) {
            _this3.selectedBrand.push(brand.id);
          }
          if (_this3.openBrand.indexOf(brand.id) === -1) {
            _this3.openBrand.push(brand.id);
          }
          var services = _this3.serviceList(brand.id);
          services.forEach(function (service) {
            if (_this3.selectedService.indexOf(service.id) === -1) {
              _this3.selectedService.push(service.id);
            }
          });
        });
      } else {
        this.selectedBrand = [];
        this.selectedService = [];
      }
      this.selectedAllServices = !this.selectedAllServices;
    },
    selectBrand: function selectBrand(brandId) {
      var _this4 = this;

      var services = this.serviceList(brandId);
      if (this.selectedBrand.indexOf(brandId) > -1) {
        var index = this.selectedBrand.indexOf(brandId);
        this.selectedBrand.splice(index, 1);
        services.forEach(function (service) {
          var index = _this4.selectedService.indexOf(service.id);
          _this4.selectedService.splice(index, 1);
        });
        this.selectedAllServices = false;
      } else {
        if (this.selectedBrand.indexOf(brandId) === -1) {
          this.selectedBrand.push(brandId);
        }
        services.forEach(function (service) {
          if (_this4.selectedService.indexOf(service.id) === -1) {
            _this4.selectedService.push(service.id);
          }
        });
        if (this.openBrand.indexOf(brandId) === -1) {
          this.openBrand.push(brandId);
        }
      }

      if (this.brands.list.every(function (brand) {
        return _this4.selectedBrand.includes(brand.id);
      })) {
        this.selectedAllServices = true;
      }
    },
    getBrands: function getBrands() {
      var self = this;
      if (!self.brands.list.length) {
        if (self.brands.loading) {
          self.getServices();
          return;
        }
        __WEBPACK_IMPORTED_MODULE_4__modules_api_brands__["a" /* default */].getBrands(self, function (res) {
          self.setDefaultBrands();
        });
      } else {
        self.setDefaultBrands();
        // self.getServices()
      }
    },
    setDefaultBrands: function setDefaultBrands() {
      var self = this;
      this.brands.list.forEach(function (brand) {
        self.selectedBrand.push(brand.id);
      });
      self.loaded.push('brands');
      self.getServices();
    },
    getServices: function getServices() {
      var self = this;
      if (!self._serviceList.length && !self.services.serviceLoading) {
        self.$store.commit('services/setServiceLoading', true);
        __WEBPACK_IMPORTED_MODULE_5__modules_api_services__["a" /* default */].getAllService(self, function (r) {
          self.$store.commit('services/setServiceLoading', false);
        });
      } else {
        this.setDefaultServices();
      }
    },
    setDefaultServices: function setDefaultServices() {
      var _this5 = this;

      var services = [];
      this._serviceList.forEach(function (service) {
        if (_this5.brands.list.findIndex(function (x) {
          return x.id === service.brandId;
        }) > -1) {
          services.push(service.id);
        }
      });
      if (!this.selectedService.length) this.selectedService = services;
      this.loaded.push('services');
    }
  },
  watch: {
    refresh: function refresh(value) {
      if (!value) return;

      this.getRuns();
      this.getExclusive();
      this.$store.commit('runs/setRunsDetails', { refresh: false });
    },
    _serviceList: function _serviceList(val) {
      if (val) {
        this.setDefaultServices();
      }
    },
    'brands.list': function brandsList(val) {
      if (val.length) {
        this.setDefaultBrands();
      }
    },
    loaded: function loaded(val) {
      if (val.indexOf('brands') > -1 && val.indexOf('services') > -1) {
        this.loadList();
      }
    },
    'qualifiedDriver.refresh': function qualifiedDriverRefresh(val) {
      if (val) {
        this.getRuns();
        this.$store.commit('runs/setQualifiedDriversData', { refresh: false });
      }
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    setTimeout(function () {
      _this6.getBrands();
    }, 200);
  }
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__(497);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_468eb832_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__(1381);
function injectStyle (ssrContext) {
  __webpack_require__(1377)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-468eb832"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_468eb832_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__values_map_settings__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__values_map_pin__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_api_services__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Partials_LoadingAnimation_Pulse__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__map_marker_utils__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__map_utils__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_api_dispatch_drivers__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_api_featureToggle__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */
var request = __webpack_require__(13);












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'runs-table',
  components: { PulseLoader: __WEBPACK_IMPORTED_MODULE_6__components_Partials_LoadingAnimation_Pulse__["a" /* default */] },
  data: function data() {
    return {
      hereMaps: {
        map: {},
        platform: {},
        router: {},
        geocoder: {},
        directions: [],
        ui: {}
      },
      ids: {
        map: 'RunMapHere'
      },
      mapOptions: __WEBPACK_IMPORTED_MODULE_3__values_map_settings__["a" /* default */],
      pickupPin: __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].pickup,
      dropoffPin: __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].dropoff,
      mapPins: [],
      infoWindows: [],
      route: [],
      routes: [],
      center: { lat: 33.942791, lng: -118.410042 },

      current: {
        driversInMap: [],
        nearbyDrivers: [],
        openDriver: ''
      },
      driverDistance: [],
      showDriverInfoWindow: false,
      driverInfoIndex: 0,
      driverPresentation: false,
      driverPresented: [],
      delayBeginDriverPresentation: '',
      mapLoader: {
        show: false,
        label: 'LOADING RESERVATION...'
      },
      waiting: {
        renderDriver: {
          data: '',
          process: false
        },
        beginDriverPresentation: false
      },
      searchStatus: { miles: 10 },
      driverFilter: {
        showToggle: false,
        show: false,
        isLoading: false,
        miles: 10,
        serviceTypes: [],
        services: [],
        serviceLoading: false
      },
      driverRoutes: {},
      upcoming: {
        loading: false,
        rsvp: null
      },
      lastServiceAvailableCheck: {
        id: 0,
        date: __WEBPACK_IMPORTED_MODULE_2_moment___default()()
      },
      isQualifiedDriver: false,
      qualifiedFilter: {
        serviceTypes: 1,
        seatCapacity: 1,
        adaWC: 1,
        adaSD: 1,
        fullTNC: 1,
        availability: 1
      },
      queueError: {
        show: false,
        message: ''
      },
      lastDriverType: '',
      sendTimerDelay: '',
      doubleFix: false,
      currentDriver: null
    };
  },

  computed: {
    runs: function runs() {
      return this.$store.state.runs;
    },
    items: function items() {
      return this.runs.dropzone.items;
    },
    dispatch: function dispatch() {
      return this.$store.state.dispatch;
    },

    rsvpAvailabilityLoading: {
      get: function get() {
        return this.dispatch.availableDrivers.loading;
      },
      set: function set(x) {
        this.$store.commit('dispatch/setAvailableDriversData', { loading: x });
      }
    },
    rsvpAvailableDrivers: function rsvpAvailableDrivers() {
      return this.dispatch.availableDrivers.list;
    },
    nearByDrivers: function nearByDrivers() {
      return this.runs.nearByDrivers.list;
    },
    runsInMap: function runsInMap() {
      return this.runs.other.runsInMap;
    },
    qualifiedDrivers: function qualifiedDrivers() {
      return this.runs.qualifiedDriver;
    }
  },
  methods: {
    initMap: function initMap() {
      var self = this;
      var mapContainer = document.getElementById(self.ids.map);
      self.hereMaps.platform = new window.H.service.Platform({ apikey: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key });

      var defaultLayers = self.hereMaps.platform.createDefaultLayers();
      self.hereMaps.map = new window.H.Map(mapContainer, defaultLayers.vector.normal.map, {
        center: self.center,
        zoom: 13,
        pixelRatio: window.devicePixelRatio || 1
      });

      /* eslint-disable no-unused-vars */
      var behavior = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(self.hereMaps.map));
      /* eslint-enable no-unused-vars */
      self.hereMaps.ui = window.H.ui.UI.createDefault(self.hereMaps.map, defaultLayers);
    },
    renderMarkers: function renderMarkers() {
      var self = this;
      var bounds = [];
      __WEBPACK_IMPORTED_MODULE_8__map_utils__["a" /* default */].clearMap(self.hereMaps.map);
      for (var i = 0; i < self.items.length; i++) {
        var item = self.items[i];

        __WEBPACK_IMPORTED_MODULE_7__map_marker_utils__["a" /* default */].drawPoiMarker(self.hereMaps.map, 'pickup_' + item.id, item.pickup, 'pickup');
        __WEBPACK_IMPORTED_MODULE_7__map_marker_utils__["a" /* default */].drawPoiMarker(self.hereMaps.map, 'dropoff_' + item.id, item.dropoff, 'dropoff');
        bounds.push(item.pickup);
        bounds.push(item.dropoff);
      }

      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_8__map_utils__["a" /* default */].setBounds(self.hereMaps.map, bounds, 0.4);
      }, 400);
    },
    computeRoute: function computeRoute() {
      var self = this;

      var url = 'https://router.hereapi.com/v8/routes?apiKey={API_KEY}&transportMode=car&return=polyline,summary';
      url = url.replace('{API_KEY}', {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key);

      var waypoints = [];
      for (var i = 0; i < self.items.length; i++) {
        waypoints.push(self.items[i].pickup);
        waypoints.push(self.items[i].dropoff);
      }

      waypoints.forEach(function (coords, index) {
        if (index == 0) {
          url += '&origin=' + coords.lat + ',' + coords.lng;
        } else if (index == waypoints.length - 1) {
          url += '&destination=' + coords.lat + ',' + coords.lng;
        } else {
          url += '&via=' + coords.lat + ',' + coords.lng;
        }
      });

      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) {
          console.log('ROUTING ERROR', error);
          return;
        }

        // _MapUtils.removeObject(self.hereMaps.map, 'RUN_ROUTE')
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var object = _step.value;

            if (object.id.indexOf('RUN_ROUTE') > -1) {
              self.hereMaps.map.removeObject(object);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (!body.routes.length) return;
        body.routes[0].sections.forEach(function (route, index) {
          var linestring = window.H.geo.LineString.fromFlexiblePolyline(route.polyline);
          var polyline = new window.H.map.Polyline(linestring, {
            style: {
              lineWidth: 3,
              strokeColor: '#333',
              lineTailCap: 'arrow-tail',
              lineHeadCap: 'arrow-head'
            }
          });
          var polylineArrow = new window.H.map.Polyline(linestring, {
            style: {
              lineWidth: 2,
              fillColor: 'white',
              strokeColor: 'rgba(255, 255, 255, 1)',
              lineDash: [0, 3],
              lineTailCap: 'arrow-tail',
              lineHeadCap: 'arrow-head'
            }
          });
          var routeLine = new window.H.map.Group();
          routeLine.addObjects([polyline, polylineArrow]);
          routeLine.id = 'RUN_ROUTE' + index;
          self.hereMaps.map.addObject(routeLine);
        });

        self.updateTravelTimes(body.routes[0].sections);
      });
    },
    updateTravelTimes: function updateTravelTimes(legs) {
      var self = this;
      // even index = reservation
      // odd index = connection times
      var resTimes = [];
      var connections = [];
      for (var i = 0; i < legs.length; i++) {
        var leg = legs[i].summary;
        var distance = 0;
        var travelTime = 0;
        // for (let j = 0; j < leg.maneuver.length; j++) {
        //   let maneuver = leg.maneuver[j]
        //   distance += maneuver.length
        //   travelTime += maneuver.travelTime
        // }
        distance += leg.length;
        travelTime += leg.duration;
        // convert meters to miles
        distance = distance * 0.000621371;
        if (i % 2 === 0) {
          resTimes.push({
            distance: distance,
            eta: travelTime
          });
          continue;
        }
        connections.push({
          distance: distance,
          eta: travelTime
        });
      }

      var now = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.items[0].pickupDate, 'MM/DD/YYYY hh:mmA');
      for (var _i = 0; _i < self.items.length; _i++) {
        var resTime = resTimes[_i];
        var connection = null;
        if (_i < connections.length) {
          connection = connections[_i];
        }

        var pickupTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(now);

        var timeToNext = connection !== null ? connection.eta : null;
        if (timeToNext) {
          // timeToNext += 60 * 10 // add 10mins to ETA
        }
        var result = {
          index: _i,
          newPickupTime: pickupTime,
          newEta: resTime.eta,
          timeToNext: timeToNext,
          distanceToNext: connection !== null ? connection.distance : null
        };

        self.$store.commit('runs/updateDropzoneItem', result);
        if (connection !== null) {
          now = __WEBPACK_IMPORTED_MODULE_2_moment___default()(now).add(connection.eta, 'seconds');
        }
      }
    },
    getAvailableDrivers: function getAvailableDrivers(data) {
      if (!data.id) return;
      if (data.status !== 'UPCOMING' && data.status !== 'REQUIRES DISPATCH') return;

      var self = this;
      if (self.rsvpAvailabilityLoading) return;
      self.rsvpAvailabilityLoading = true;
      self.lastServiceAvailableCheck = {
        id: data.id,
        date: __WEBPACK_IMPORTED_MODULE_2_moment___default()()
      };

      var since = __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.pickupTime, 'MM/DD/YYYY hh:mmA').format('X');
      var until = __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.pickupTime, 'MM/DD/YYYY hh:mmA').add(data.etaInSec || 0, 'seconds').format('X');
      if (data.lastDropoff) {
        until = __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.lastDropoff, 'MM/DD/YYYY hh:mmA').format('X');
      }
      self.$sdk.get('/shifts/dashboard', {
        token: self.$store.state.session.sessionToken,
        assignments: 0,
        order: 'startShift',
        orderAsc: 1,
        pageNum: 1,
        sectorId: 0,
        serviceTypeId: data.serviceId,
        since: since,
        until: until
      }, function (res) {
        self.rsvpAvailabilityLoading = false;
        if (res.error) {
          return;
        }
        var drivers = [];
        res.list.forEach(function (driver) {
          var name = driver.businessName || driver.firstName + ' ' + driver.lastName;
          var availableFrom = '';
          var availableUntil = '';
          if (driver.startTimestamp) {
            var sinceTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(since, 'X').format(__WEBPACK_IMPORTED_MODULE_10__modules_api_featureToggle__["a" /* default */].timeFormat(self, false));
            // availableFrom = moment(driver.startTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY') + ' ' + sinceTime
            availableFrom = __WEBPACK_IMPORTED_MODULE_2_moment___default()(driver.startTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_10__modules_api_featureToggle__["a" /* default */].timeFormat(self, false));
            availableUntil = __WEBPACK_IMPORTED_MODULE_2_moment___default()(driver.endTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_10__modules_api_featureToggle__["a" /* default */].timeFormat(self, false));
          }
          drivers.push({
            id: driver.ID,
            name: name,
            firstName: driver.firstName,
            lastName: driver.lastName,
            licenseType: driver.accountType,
            homeSector: driver.homeSectorName || '',
            availableFrom: availableFrom,
            availableUntil: availableUntil,
            mobile: driver.phoneNumber || ''
          });
        });
        self.$store.commit('dispatch/setAvailableDriversData', { list: drivers });
        self.findNearbyDrivers();
      });
    },
    findNearbyDrivers: function findNearbyDrivers() {
      var _this = this;

      var skipAvailability = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var self = this;
      var run = this.runs.list.find(function (x) {
        return x.id === _this.items[0].runId;
      });
      if (self.driverFilter.isLoading || !this.items.length || !run) {
        return;
      }
      // GET AVAILABLE DRIVERS - CROSS FILTER
      // if ((self.lastServiceAvailableCheck.id !== run.id ||
      //   (self.lastServiceAvailableCheck.id === run.id && self.lastServiceAvailableCheck.date.diff(moment(), 'minute') < -5)) &&
      //   !skipAvailability
      // ) {
      //   self.getAvailableDrivers({
      //     id: run.id,
      //     status: 'UPCOMING',
      //     pickupTime: run.pickupDate,
      //     lastDropoff: run.lastDropoff,
      //     serviceId: run.services[0].id,
      //   })
      //   return
      // }

      self.driverFilter.isLoading = true;
      self.mapLoader = {
        show: true,
        label: 'FINDING NEARBY DRIVERS...'
      };

      if (self.sendTimerDelay) clearTimeout(self.sendTimerDelay);

      var serviceId = [];
      serviceId.push(run.services[0].id);

      // Remove info bubble
      self.hereMaps.ui.getBubbles().forEach(function (bub) {
        self.hereMaps.ui.removeBubble(bub);
      });
      // Remove current drivers
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var object = _step2.value;

          if (object.id.indexOf('nearbyDrivers') > -1) {
            self.hereMaps.map.removeObject(object);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      self.lastDriverType = 'nearby';
      __WEBPACK_IMPORTED_MODULE_9__modules_api_dispatch_drivers__["a" /* default */].getNearbyDrivers(self, {
        token: self.$store.state.session.sessionToken,
        lat: run.pickup.lat,
        lng: run.pickup.lng,
        radius: self.driverFilter.miles,
        duty: 1,
        serviceTypeId: serviceId,
        order: 'distance',
        orderAsc: 1
      }, function (r) {
        self.driverFilter.isLoading = false;
        self.mapLoader = {
          show: false,
          label: ''
        };
        self.$store.commit('runs/setNearByDrivers', { list: [] });
        if (r.error) {
          // self.setCenter()
          return;
        }

        if (!r.list.length) {
          self.driverFilter.show = true;
          self.driverFilter.showToggle = true;
          // self.setCenter()
          return;
        }

        self.driverFilter.show = false;
        self.showDriverInfoWindow = false;

        var driversNearby = [];
        for (var i = 0; i < r.list.length; i++) {
          var driver = r.list[i];
          // let isDriverAvailable = false
          // if (self.rsvpAvailableDrivers.length) {
          //   isDriverAvailable = self.rsvpAvailableDrivers.findIndex(x => x.id === driver.ID) > -1
          // }
          // if (typeof driver.tracks === 'undefined' || !isDriverAvailable) {
          //   continue
          // }
          var driverData = {
            id: driver.ID,
            phone: driver.phone,
            firstName: driver.firstName,
            lastName: driver.lastName,
            photoUrl: driver.avatarUrl,
            coords: {
              lat: driver.tracks.lat,
              lng: driver.tracks.lng,
              header: driver.tracks.heading
            },
            vehicle: {
              name: driver.vehicle.manufacturer + ' ' + driver.vehicle.model,
              licensePlate: driver.vehicle.licensePlate,
              photoUrl: driver.vehicle.photoUrl
            }
          };
          driversNearby.push(driverData);

          self.waiting.renderDriver.process = true;
          self.waiting.renderDriver.data = driver;
          self.driverDistance.push({
            id: driver.ID,
            distance: self.calculateDistance({ lat: driver.tracks.lat, lng: driver.tracks.lng }, { lat: run.pickup.lat, lng: run.pickup.lng })
          });
          self.currentDriver = driver;
          if (i + 1 === r.list.length) {
            self.driverPresentation = true;
            self.$store.commit('runs/setNearByDrivers', { list: driversNearby });
            // self.driverDistance = self.driverDistance.sort((a, b) => a.distance - b.distance)
            if (self.delayBeginDriverPresentation) {
              clearTimeout(self.delayBeginDriverPresentation);
            }
            self.delayBeginDriverPresentation = setTimeout(function () {
              self.beginDriverPresentation(true);
            }, 400);
          }

          self.searchStatus.miles = self.driverFilter.miles;
        }
        if (!driversNearby.length) {
          self.driverFilter.show = true;
          self.driverFilter.showToggle = true;
        }
        // self.setDriverPin()
        self.driverPresented = [];
        // self.setCenter()
      });
    },
    calculateDistance: function calculateDistance(coord1, coord2) {
      var toRad = function toRad(value) {
        return value * Math.PI / 180;
      };
      var R = 6371;
      var latD = toRad(coord2.lat - coord1.lat);
      var longD = toRad(coord2.lng - coord1.lng);
      var a = Math.sin(latD / 2) * Math.sin(latD / 2) + Math.cos(toRad(coord1.lat)) * Math.cos(toRad(coord2.lat)) * Math.sin(longD / 2) * Math.sin(longD / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var distance = R * c;
      return distance / 1.609344;
    },
    beginDriverPresentation: function beginDriverPresentation(isNext) {
      var self = this;

      if (self.doubleFix) {
        self.doubleFix = false;
        return;
      }
      self.doubleFix = true;

      var driverData = self.runs.nearByDrivers.list;
      // self.driverDistance = self.driverDistance.sort((a, b) => a.distance - b.distance)
      if (!self.driverDistance.length) {
        self.waiting.beginDriverPresentation = true;
        return;
      }

      if (!isNext && self.driverInfoIndex > 0) {
        self.driverInfoIndex--;
      } else if (isNext && self.driverInfoIndex < driverData.length - 1) {
        self.driverInfoIndex++;
        if (driverData[self.driverInfoIndex].id === self.currentDriver.id) self.driverInfoIndex++;
      }
      if (driverData[self.driverInfoIndex]) {
        var index = driverData.findIndex(function (x) {
          return x.id === self.driverDistance[self.driverInfoIndex].id;
        });
        if (index === -1) {
          index = 0;
        }
        self.showDriverInfo(driverData[index], true);
        // if (isNext) self.driverInfoIndex++
      } else {
        self.$store.commit('global/setAlertData', {
          show: true,
          message: 'No more nearby drivers found.'
        });
      }
      self.setDriverPin();
    },
    showDriverInfo: function showDriverInfo(driver, focus) {
      var self = this;
      self.$store.commit('runs/setDriverInPopup', driver);

      // self.showDriverInfoWindow = true
      self.showDriverInfoWindow = false;
      if (self.driverPresentation || typeof focus === 'undefined') {
        self.$nextTick(function () {
          self.showDriverInfoWindow = true;
        });
      }

      if (focus) {
        self.setCenter('custom', { lat: driver.coords.lat, lng: driver.coords.lng });
      } else {
        self.driverPresentation = false;
      }
      self.doubleFix = false;
      self.updateDriverLocation(driver, false);
    },
    setCenter: function setCenter(type, data) {
      var self = this;
      var group = new window.H.map.Group();

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var object = _step3.value;

          if (object.id === 'groupBound') {
            self.hereMaps.map.removeObject(object);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var groupObject = [];
      if (type === 'location') {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _object = _step4.value;

            if (_object.id.indexOf('marker') > -1) {
              groupObject.push(new window.H.map.Circle(new window.H.geo.Point(_object.lat, _object.lng), 5000, { style: { fillColor: 'rgba(0, 0, 0, 0)', strokeColor: 'rgba(0, 0, 0, 0)' } }));
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      } else if (type === 'driver') {
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var _object2 = _step5.value;

            if (_object2.id.indexOf('driverInMap') > -1 || _object2.id.indexOf('nearbyDrivers') > -1) {
              groupObject.push(new window.H.map.Circle(new window.H.geo.Point(_object2.lat, _object2.lng), 5000, { style: { fillColor: 'rgba(0, 0, 0, 0)', strokeColor: 'rgba(0, 0, 0, 0)' } }));
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      } else if (type === 'custom') {
        groupObject.push(new window.H.map.Circle(new window.H.geo.Point(data.lat, data.lng), 5000, { style: { fillColor: 'rgba(0, 0, 0, 0)', strokeColor: 'rgba(0, 0, 0, 0)' } }));
      }

      // Add to group for bounds correction
      if (groupObject.length) {
        group.addObjects(groupObject);
        group.id = 'groupBound';
        self.hereMaps.map.addObject(group);

        self.hereMaps.map.getViewModel().setLookAtData({
          bounds: group.getBoundingBox()
        });
      }
    },
    updateDriverLocation: function updateDriverLocation(driver, triggerPopup) {
      var _this2 = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_9__modules_api_dispatch_drivers__["a" /* default */].getLocation(self, driver.id, function (location) {
        if (location.error || location && !location.list.length) {
          return;
        }
        var coords = {
          lat: location.list[0].lat,
          lng: location.list[0].lng
        };
        var run = _this2.runs.list.find(function (x) {
          return x.id === _this2.items[0].runId;
        });

        driver.coords = coords;
        if (triggerPopup) {
          self.showDriverInfo(driver, false);
          self.$store.commit('dispatch/removeDriverInMap', driver);
          self.$store.commit('dispatch/addDriverInMap', driver);
        } else {
          var routeCoords = [{ lat: location.list[0].lat, lng: location.list[0].lng }, { lat: run.pickup.lat, lng: run.pickup.lng }];

          self.setRoute(routeCoords, { isDriverRoute: true, id: driver.id });
        }

        // if (self.rsvpInMap.id === null || self.rsvpInMap.driver === null) { return }
      });
    },
    setDriverPin: function setDriverPin() {
      var showOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var self = this;

      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var object = _step6.value;

          if (object.id.indexOf('nearbyDrivers') > -1) {
            (function () {
              var id = parseInt(object.id.substring(13));
              var index = self.nearByDrivers.findIndex(function (x) {
                return x.id === id;
              });
              if (index > -1) {
                self.hereMaps.map.removeObject(object);
                self.current.nearbyDrivers = self.current.nearbyDrivers.filter(function (driverId) {
                  return driverId !== id;
                });
              }
            })();
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      var firstDriver = true;
      self.nearByDrivers.forEach(function (driver, x) {
        if (self.current.driversInMap.indexOf(driver.id) > -1) {
          return;
        }

        var marker = '<svg height="25" width="25" style="overflow: overlay; top: -12px; left: -12px;" viewBox="0 0 50 50">' + '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' + 'stroke-width="{STROKE_WIDTH}" /></svg>';

        marker = marker.replace('{D}', __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].car.path).replace('{FILL}', x == 0 ? '#38b550' : __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].car.fillColor).replace('{STROKE}', __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].car.strokeColor).replace('{STROKE_WIDTH}', x == 0 ? '.2' : __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].car.strokeWeight);

        var icon = new window.H.map.DomIcon(marker, {
          onAttach: function onAttach(cloned, icon, marker) {
            if (cloned) {
              cloned.addEventListener('click', function (evt) {
                self.displayDriverInfo(driver, 2, showOnly);
              });
            }
          },
          onDetach: function onDetach(cloned, icon, marker) {
            cloned.removeEventListener('click', function (evt) {});
          }
        });
        var coords = { lat: driver.coords.lat, lng: driver.coords.lng };
        var pin = new window.H.map.DomMarker(coords, { icon: icon });
        pin.id = 'nearbyDrivers' + driver.id;
        pin.lat = driver.coords.lat;
        pin.lng = driver.coords.lng;
        self.current.nearbyDrivers.push(driver.id);
        self.hereMaps.map.addObject(pin);
        if (self.driverPresented.indexOf(driver.id) === -1 && firstDriver) {
          firstDriver = false;
          self.driverPresented.push(driver.id);
          self.displayDriverInfo(driver, 3, showOnly);
        }
      });

      // for (let object of self.hereMaps.map.getObjects()) {
      //   if (object.id.indexOf('driverInMap') > -1) {
      //     let id = parseInt(object.id.substring(11))
      //     let index = self.driversInMap.findIndex(x => x.id === id)
      //     if (index === -1) {
      //       self.hereMaps.map.removeObject(object)
      //       self.current.driversInMap = self.current.driversInMap.filter(driverId => {
      //         return driverId !== id
      //       })
      //     }
      //   }
      // }

      // setTimeout(() => {
      //   self.driversInMap.forEach((driver, x) => {
      //     if (self.current.driversInMap.indexOf(driver.id) > -1) { return }

      //     let marker = '<svg height="25" width="25" style="overflow: overlay; top: -12px; left: -12px;" viewBox="0 0 50 50">' +
      //       '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' +
      //       'stroke-width="{STROKE_WIDTH}" /></svg>'

      //     marker = marker.replace('{D}', mapPinsSettings.car.path)
      //       .replace('{FILL}', x == 0 ? '#38b550' : mapPinsSettings.car.fillColor)
      //       .replace('{STROKE}', mapPinsSettings.car.strokeColor)
      //       .replace('{STROKE_WIDTH}', x == 0 ? '.2' : mapPinsSettings.car.strokeWeight)

      //     let icon = new window.H.map.DomIcon(marker, {
      //       onAttach: (cloned, icon, marker) => {
      //         cloned.addEventListener('click', evt => {
      //           self.displayDriverInfo(driver, 4)
      //         })
      //       },
      //       onDetach: (cloned, icon, marker) => {
      //         cloned.removeEventListener('click', evt => {})
      //       }
      //     })
      //     let coords = {lat: driver.coords.lat, lng: driver.coords.lng}
      //     let pin = new window.H.map.DomMarker(coords, {icon: icon})
      //     pin.id = 'driverInMap' + driver.id
      //     pin.lat = driver.coords.lat
      //     pin.lng = driver.coords.lng
      //     self.current.driversInMap.push(driver.id)
      //     self.hereMaps.map.addObject(pin)
      //     if (firstDriver) {
      //       firstDriver = false
      //       self.displayDriverInfo(driver, 5)
      //     }
      //   })
      // }, 300)

      self.setCenter('driver', {});
    },
    displayDriverInfo: function displayDriverInfo(driver, x) {
      var _this3 = this;

      var showOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var self = this;

      // Display route from this driver
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var object = _step7.value;

          if (object.id.indexOf('driverRoute') > -1) {
            object.setVisibility(0);
            // if (object.id === 'driverRoute' + driver.id) {
            //   self.current.openDriver = driver.id
            //   object.setVisibility(1)
            // }
          }
        }

        // Remore existing info bubble
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      self.hereMaps.ui.getBubbles().forEach(function (bub) {
        self.hereMaps.ui.removeBubble(bub);
      });

      var driverIndex = self.driverDistance.findIndex(function (x) {
        return x.id === driver.id;
      });
      self.$store.commit('runs/setDriverInPopupRoute', self.driverDistance[driverIndex]);

      var bubbleId = 'driverInfo_' + driver.id;

      var bubbles = self.hereMaps.ui.getBubbles();
      for (var i = 0; i < bubbles.length; i++) {
        var item = bubbles[i];
        if (item.id !== bubbleId) {
          continue;
        }
        self.hereMaps.ui.removeBubble(item);
      }

      var run = this.runs.list.find(function (x) {
        return x.id === _this3.items[0].runId;
      });
      // let showDispatchButtons = run.id !== null && (run.status === 'UPCOMING' || run.status === 'REQUIRES DISPATCH') 
      var showDispatchButtons = true;

      var bubbleContent = '<div class="info-container">' + '<div class="driver-info"><img src="{DRIVER_PHOTO}"/><a href="{DRIVER_URL}" target="_blank">{DRIVER_NAME}</a></div>' + '<div class="vehicle-info"><img src="{VEHICLE_PHOTO}"/><strong>{VEHICLE_NAME}</strong><span>{VEHICLE_NUMBER}</span></div>' + '<a id="DriverCall_{DRIVER_ID}" class="call-button button cta xsmall success block" href="javascript:;" @click="testMethod">CALL {DRIVER_FNAME}</a>';
      '</div>';

      if (showDispatchButtons) {
        bubbleContent = '<div class="info-container">' + '<div class="prvNxt prev" id="driverPrev_{DRIVER_ID}"><i class="fas fa-chevron-left"></i></div>' + '<div class="prvNxt next" id="driverNext_{DRIVER_ID}"><i class="fas fa-chevron-right"></i></div>' +
        // '<div class="upcoming-rsvp">{UPCOMING_INFO}</div>' +
        '<div class="driver-info"><img src="{DRIVER_PHOTO}"/>' + '<a href="{DRIVER_URL}" target="_blank">{DRIVER_NAME}</a>' + '<span>{DRIVER_DISTANCE}</span>' + (!showOnly ? '<a id="DriverSend_{DRIVER_ID}" class="assign-button button cta xsmall warning block" href="javascript:;">SEND TO {DRIVER_FNAME}</a>' : '') + '</div>' + '<div class="vehicle-info"><img src="{VEHICLE_PHOTO}"/><strong>{VEHICLE_NAME}</strong><span>{VEHICLE_NUMBER}</span>' + (!showOnly ? '<a id="DriverAssign_{DRIVER_ID}" class="assign-button button cta xsmall block" href="javascript:;">ASSIGN TO {DRIVER_FNAME}</a>' : '') + '</div>' + '<a id="DriverCall_{DRIVER_ID}" class="call-button button cta xsmall success block" href="javascript:;" @click="testMethod"><i class="fas fa-phone"></i> CALL {DRIVER_FNAME}</a>';
        '</div>';

        var upcomingInfo = '';
        if (self.upcoming.loading) {
          upcomingInfo = '<i class="fa fa-spinner fa-spin"></i><span> Checking for upcoming reservations...</span>';
        } else if (!self.upcoming.loading && self.upcoming.rsvp === null) {
          upcomingInfo = 'No Upcoming Reservations.';
        } else if (!self.upcoming.loading && self.upcoming.rsvp !== null) {
          upcomingInfo = 'Upcoming ';
          if (self.upcoming.rsvp !== null && self.upcoming.rsvp.type === 'package') {
            upcomingInfo = upcomingInfo + '<span>Package </span>' + ' (<a href="/#/package/' + self.upcoming.rsvp.data.package.id + '" target="_blank">' + self.upcoming.rsvp.data.package.id + '</a>) at ' + ' <span>' + self.formatTime(self.upcoming.rsvp.data.pickupTime) + '.</span>';
          }
          if (self.upcoming.rsvp !== null && self.upcoming.rsvp.type === 'rsvp') {
            upcomingInfo = upcomingInfo + '<span>RSVP </span>' + ' (<a href="/#/reservation/' + self.upcoming.rsvp.data.ID + '" target="_blank">' + self.upcoming.rsvp.data.ID + '</a>) at ' + ' <span>' + self.formatTime(self.upcoming.rsvp.data.pickupDate) + '.</span>';
          }
        }
        bubbleContent = bubbleContent.replace('{UPCOMING_INFO}', upcomingInfo);
      }

      self.currentDriver = driver;
      bubbleContent = bubbleContent.replace('{DRIVER_PHOTO}', driver.photoUrl).replaceAll('{DRIVER_ID}', driver.id).replace('{DRIVER_URL}', '/#/provider/' + driver.id).replace('{DRIVER_NAME}', driver.firstName + ' ' + driver.lastName).replace('{DRIVER_DISTANCE}', self.driverRoutes['a' + driver.id] || '&nbsp;').replace('{DRIVER_FNAME}', driver.firstName).replace('{DRIVER_FNAME}', driver.firstName).replace('{DRIVER_FNAME}', driver.firstName).replace('{VEHICLE_PHOTO}', driver.vehicle.photoUrl).replace('{VEHICLE_NAME}', driver.vehicle.name).replace('{VEHICLE_NUMBER}', driver.vehicle.licensePlate);

      var bubble = new window.H.ui.InfoBubble({
        lat: driver.coords.lat,
        lng: driver.coords.lng
      }, {
        content: bubbleContent,
        onStateChange: function onStateChange(aa) {
          if (self.delayBeginDriverPresentation) {
            clearTimeout(self.delayBeginDriverPresentation);
          }
          self.delayBeginDriverPresentation = setTimeout(function () {
            self.beginDriverPresentation(true);
          }, 500);
        }
      });
      bubble.id = bubbleId;
      bubble.addClass('H_driver-info');
      self.hereMaps.ui.addBubble(bubble);

      var driverPrev = document.getElementById('driverPrev_' + driver.id);
      var driverNext = document.getElementById('driverNext_' + driver.id);
      var elem = document.getElementById('DriverCall_' + driver.id);
      var assignElem = document.getElementById('DriverAssign_' + driver.id);
      var sendElem = document.getElementById('DriverSend_' + driver.id);

      setTimeout(function () {
        if (driverPrev) {
          driverPrev.classList.remove('disabled');
          if (self.driverInfoIndex <= 0) {
            driverPrev.classList.add('disabled');
          } else {
            driverPrev.addEventListener('click', function (evt) {
              self.beginDriverPresentation(false);
            });
          }
        }
        if (driverNext) {
          var driverData = self.runs.nearByDrivers.list;
          driverNext.classList.remove('disabled');
          if (driverData.length - 1 <= self.driverInfoIndex) {
            driverNext.classList.add('disabled');
          } else {
            driverNext.addEventListener('click', function (evt) {
              self.beginDriverPresentation(true);
            });
          }
        }

        if (elem) {
          elem.addEventListener('click', function (evt) {
            self.callDriver(driver);
          });
        }

        if (showDispatchButtons) {
          if (assignElem) {
            assignElem.addEventListener('click', function (evt) {
              self.assignToDriver(driver);
            });
          }
          if (sendElem) {
            sendElem.addEventListener('click', function (evt) {
              self.sendToDriver(driver);
            });
          }
        }
      }, 500);
    },
    callDriver: function callDriver(driver) {
      var self = this;
      self.$plugins.phone.startCall(self, {
        phone: driver.phone,
        name: driver.firstName + ' ' + driver.lastName
      });
    },
    sendToDriver: function sendToDriver(driver) {
      var self = this;
      // let run = this.runs.list.find(x => x.id === this.runs.selected)
      self.$store.commit('dispatch/showActionModal', 'Sending run to driver...');

      var customRequestTimeout = self.$settings.get('ASAPRequestTimeout');
      // if (self.modal.option === 'custom') customRequestTimeout = self.modal.custom
      var runId = self.runs.selected || self.runsInMap[0];
      self.$sdk.post('/runs/send', {
        runId: runId,
        providerId: driver.id,
        token: self.$store.state.session.sessionToken,
        customRequestTimeout: customRequestTimeout
      }, function (r) {
        if (r.error) {
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong. Try again later.'
          });
        } else {
          self.$store.commit('runs/removeRunInTable', self.runs.selected);
          self.$store.commit('runs/addBlackList', self.runs.selected);
          self.$store.commit('runs/setRunsDetails', { selected: [] });
          self.$store.commit('dispatch/setSelectedDriver', null);
          self.$store.commit('dispatch/completeActionModal', {
            success: true,
            message: 'Successfully sent run.'
          });

          self.$store.commit('runs/setSendTimer', {
            id: runId,
            time: self.$settings.get('DriverResponseTime') || 60
          });
        }
        self.$store.commit('runs/setRunsDetails', { refresh: true });
        setTimeout(function () {
          self.$store.commit('dispatch/closeActionModal');
        }, 3000);
      }, '2.0');
    },
    assignToDriver: function assignToDriver(driver) {
      var self = this;
      // let run = this.runs.list.find(x => x.id === this.runs.selected)

      self.$store.commit('dispatch/showActionModal', 'Assigning run to driver...');

      self.$sdk.post('/runs/assign', {
        runId: self.runs.selected || self.runsInMap[0],
        providerId: driver.id,
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          console.log('ERROR', r);
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong.'
          });
        } else {
          self.$store.commit('dispatch/completeActionModal', {
            success: true,
            message: 'Successfully assigned items to driver.'
          });
          self.$store.commit('runs/setQualifiedDriversData', { refresh: true });
        }
        setTimeout(function () {
          self.$store.commit('dispatch/closeActionModal');
        }, 3000);
      }, '2.0');
    },
    setRoute: function setRoute(items, extraData) {
      var self = this;

      var url = 'https://router.hereapi.com/v8/routes?apiKey={API_KEY}&transportMode=car&return=polyline,summary';
      url = url.replace('{API_KEY}', {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key);
      items.forEach(function (coords, index) {
        if (index == 0) {
          url += '&origin=' + coords.lat + ',' + coords.lng;
        } else if (index == items.length - 1) {
          url += '&destination=' + coords.lat + ',' + coords.lng;
        } else {
          url += '&via=' + coords.lat + ',' + coords.lng;
        }
      });
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) {
          self.onCalculateError();
          return;
        }
        self.onCalculateSuccess(extraData, body);
      });
    },
    onCalculateSuccess: function onCalculateSuccess(extraData, result) {
      if (extraData.isTrackDriver) {
        this.setTrackDriverPin(result);
        return;
      }
      if (!result.routes.length) return;
      if (extraData.isDriverRoute) {
        var res = result.routes[0].sections[0].summary;
        var distance = Math.round(res['length'] * .001 * 0.6214) + ' miles, ' + Math.round(res.duration / 60) + ' minutes away';
        if (res['length'] === 0 && res.duration === 0) {
          var tempElement = document.createElement('html');
          tempElement.innerHTML = res.text;
          var miles = res.length;
          var time = res.duration;
          if (res.text) {
            miles = tempElement.getElementsByTagName('span')[0] ? tempElement.getElementsByTagName('span')[0].innerText : '';
            miles = Math.round(parseFloat(miles.substring(0, miles.length - 2)) * 0.6212);
            time = tempElement.getElementsByTagName('span')[1] ? tempElement.getElementsByTagName('span')[1].innerText : res.duration;
            time = time.substring(0, time.length - 4);
          }

          distance = miles + ' miles, ' + time + ' minutes away';
        }
        this.driverRoutes['a' + extraData.id] = distance;
      }
      var route = result.routes[0].sections;
      this.addRouteShapeToMap(route, extraData);
    },
    onCalculateError: function onCalculateError(data) {
      console.error('ROUTING ERROR', data);
    },
    addRouteShapeToMap: function addRouteShapeToMap(routes, extraData, distance) {
      var _this4 = this;

      var self = this;
      routes.forEach(function (route, index) {
        var linestring = window.H.geo.LineString.fromFlexiblePolyline(route.polyline);
        var polyline = new window.H.map.Polyline(linestring, {
          style: {
            lineWidth: 4,
            strokeColor: extraData.isDriverRoute ? '#2EE47D' : 'rgba(25, 25, 25, 0.7)'
          }
        });
        polyline.id = 'rsvpRoute' + index;

        if (extraData.isDriverRoute) {
          var _iteratorNormalCompletion8 = true;
          var _didIteratorError8 = false;
          var _iteratorError8 = undefined;

          try {
            for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
              var object = _step8.value;

              if (object.id.indexOf('driverRoute') > -1) {
                object.setVisibility(0);
              }
            }
          } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion8 && _iterator8.return) {
                _iterator8.return();
              }
            } finally {
              if (_didIteratorError8) {
                throw _iteratorError8;
              }
            }
          }

          polyline.id = 'driverRoute' + extraData.id;
          polyline.setVisibility(1);

          var driverData = self.nearByDrivers;
          var _index = driverData.findIndex(function (x) {
            return x.id === extraData.id;
          });
          if (_index > -1) {
            self.displayDriverInfo(driverData[_index], 1);
          }
        }
        _this4.hereMaps.map.addObject(polyline);
      });
      this.setCenter('location', {});
    },
    filterServices: function filterServices() {
      var _this5 = this;

      var self = this;
      var services = this.$store.state.services;

      if (!services.list.length) {
        this.getServices();
        return;
      }

      self.driverFilter.services = [];
      var run = this.runs.list.find(function (x) {
        return x.id === _this5.items[0].runId;
      });
      services.list.forEach(function (service) {
        if (service.brandId === run.brandId) {
          self.driverFilter.services.push({
            id: service.id,
            brandId: run.brandId,
            name: service.label
          });
        }
      });
      if (run.services[0] && run.services[0].id) {
        self.driverFilter.serviceTypes.push(run.services[0].id);
      }
    },
    getServices: function getServices() {
      var self = this;
      self.driverFilter.serviceLoading = true;
      __WEBPACK_IMPORTED_MODULE_5__modules_api_services__["a" /* default */].getAllService(self, function (r) {
        self.driverFilter.serviceLoading = false;
        self.filterServices();
      });
    },
    findQualifiedDrivers: function findQualifiedDrivers() {
      var self = this;
      if (!this.items.length || !this.items[0].runId) return;

      self.mapLoader = {
        show: true,
        label: 'LOOKING FOR QUALIFIED DRIVERS...'
      };
      if (self.sendTimerDelay) clearTimeout(self.sendTimerDelay);
      self.lastDriverType = 'qualified';
      self.$sdk.get('/runs/queue', {
        token: self.$store.state.session.sessionToken,
        runId: self.items[0].runId
      }, function (r) {
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          self.mapLoader = {
            show: false,
            label: ''
          };
          return;
        }
        if (!r.list.length) {
          // self.noQualifiedDrivers()
          self.noQueueDrivers(r);
          return;
        }

        self.$store.commit('runs/setQualifiedDriversData', { list: r.list });
        self.validateQualifiedDrivers(r);
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(r.unqualified).length) self.buildReasons(r);
      }, '2.0');
    },
    checkRunSelected: function checkRunSelected() {
      var self = this;
      var isMultipleRun = false;
      var runId = '';
      this.items.forEach(function (x) {
        if (!runId) runId = x.runId;else if (runId && runId !== x.runId) {
          isMultipleRun = true;
        }
      });

      if (isMultipleRun) {
        var _iteratorNormalCompletion9 = true;
        var _didIteratorError9 = false;
        var _iteratorError9 = undefined;

        try {
          for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
            var object = _step9.value;

            if (object.id.indexOf('qualifiedDrivers') > -1) {
              self.hereMaps.map.removeObject(object);
            }
          }
        } catch (err) {
          _didIteratorError9 = true;
          _iteratorError9 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion9 && _iterator9.return) {
              _iterator9.return();
            }
          } finally {
            if (_didIteratorError9) {
              throw _iteratorError9;
            }
          }
        }

        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
          for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var _object3 = _step10.value;

            if (_object3.id.indexOf('driverRoute') > -1) {
              _object3.setVisibility(0);
            }
          }
        } catch (err) {
          _didIteratorError10 = true;
          _iteratorError10 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
              _iterator10.return();
            }
          } finally {
            if (_didIteratorError10) {
              throw _iteratorError10;
            }
          }
        }

        self.hereMaps.ui.getBubbles().forEach(function (bub) {
          self.hereMaps.ui.removeBubble(bub);
        });
      }

      return isMultipleRun;
    },
    validateQualifiedDrivers: function validateQualifiedDrivers(data) {
      var self = this;
      if (!self.qualifiedDrivers.list.length || self.checkRunSelected()) {
        self.mapLoader = { show: false, label: '' };
        return;
      }

      if (data) self.tmpProvData = data;else if (self.tmpProvData) data = self.tmpProvData;

      var driverId = self.qualifiedDrivers.list[0].id;
      self.$sdk.get('/runs/validate', {
        token: self.$store.state.session.sessionToken,
        runId: self.items[0].runId,
        providerId: driverId
      }, function (r) {
        if (r.error) {
          self.$store.commit('runs/reduceQualifiedDrivers');

          var driver = '';
          if (data.unfiltered) driver = data.unfiltered.find(function (d) {
            return d.id == driverId;
          });
          self.$store.commit('global/addReasonList', {
            id: driverId,
            name: driver ? driver.name : '',
            reason: r.error.message
          });
          // if (!self.qualifiedDrivers.list.length) self.noQualifiedDrivers()
          if (!self.qualifiedDrivers.list.length) self.noQueueDrivers(false);else self.validateQualifiedDrivers(data);
          // self.getDriverDetails(driverId, true)
          return;
        }

        self.getDriverDetails(driverId);
      }, '2.0');
    },
    getDriverDetails: function getDriverDetails(id) {
      var showOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var self = this;
      if (self.checkRunSelected()) return;

      self.$sdk.get('/provider/' + id, {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.mapLoader = {
          show: false,
          label: ''
        };
        if (r.error) {
          if (!self.qualifiedDrivers.list.length) self.noQualifiedDrivers();else if (!showOnly) self.validateQualifiedDrivers();
          return;
        }
        self.$store.commit('runs/setQualifiedDriversData', {
          details: {
            id: id,
            lat: self.qualifiedDrivers.list[0].home.lat,
            lng: self.qualifiedDrivers.list[0].home.lng,
            firstName: r.firstName,
            lastName: r.lastName,
            driverImg: r.avatarUrl,
            phone: '' + r.countryCode + r.phone,
            manafacturer: r.vehicle.manufacturer || '',
            model: r.vehicle.model || '',
            licensePlate: r.vehicle.licensePlate,
            carImg: r.vehicle.photo
          }
        });
        self.$store.commit('runs/reduceQualifiedDrivers');
        self.setQualifiedDriverPin();
      });
    },
    noQualifiedDrivers: function noQualifiedDrivers() {
      // this.$store.commit('global/setAlertData', {
      //   show: true,
      //   message: 'No qualified drivers found.'
      // })
      this.mapLoader = {
        show: false,
        label: ''
      };
      this.queueError = {
        show: true,
        message: 'No ' + this.lastDriverType + ' drivers found.'
      };
    },
    setQualifiedDriverPin: function setQualifiedDriverPin() {
      var self = this;
      if (self.checkRunSelected()) return;

      var _iteratorNormalCompletion11 = true;
      var _didIteratorError11 = false;
      var _iteratorError11 = undefined;

      try {
        for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
          var object = _step11.value;

          if (object.id.indexOf('qualifiedDrivers') > -1) {
            self.hereMaps.map.removeObject(object);
          }
        }
      } catch (err) {
        _didIteratorError11 = true;
        _iteratorError11 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion11 && _iterator11.return) {
            _iterator11.return();
          }
        } finally {
          if (_didIteratorError11) {
            throw _iteratorError11;
          }
        }
      }

      var marker = '<svg height="25" width="25" style="overflow: overlay; top: -12px; left: -12px;" viewBox="0 0 50 50">' + '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' + 'stroke-width="{STROKE_WIDTH}" /></svg>';

      marker = marker.replace('{D}', __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].house.path).replace('{FILL}', '#F25E0D').replace('{STROKE}', __WEBPACK_IMPORTED_MODULE_4__values_map_pin__["a" /* default */].house.strokeColor).replace('{STROKE_WIDTH}', '.2');

      var driver = self.qualifiedDrivers.details;
      var icon = new window.H.map.DomIcon(marker, {
        onAttach: function onAttach(cloned, icon, marker) {
          if (cloned) {
            cloned.addEventListener('click', function (evt) {
              self.displayQualifiedDriverInfo(driver, 2);
            });
          }
        },
        onDetach: function onDetach(cloned, icon, marker) {
          if (cloned) {
            cloned.removeEventListener('click', function (evt) {});
          }
        }
      });
      self.displayQualifiedDriverInfo(driver, 2);
      var coords = { lat: driver.lat, lng: driver.lng };
      var pin = new window.H.map.DomMarker(coords, { icon: icon });
      pin.id = 'qualifiedDrivers' + driver.id;
      pin.lat = driver.lat;
      pin.lng = driver.lng;
      self.current.nearbyDrivers.push(driver.id);
      self.hereMaps.map.addObject(pin);

      self.setCenter('driver', {});
    },
    displayQualifiedDriverInfo: function displayQualifiedDriverInfo(driver, x) {
      var self = this;
      if (self.checkRunSelected()) return;

      // Display route from this driver
      var _iteratorNormalCompletion12 = true;
      var _didIteratorError12 = false;
      var _iteratorError12 = undefined;

      try {
        for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
          var object = _step12.value;

          if (object.id.indexOf('driverRoute') > -1) {
            object.setVisibility(0);
          }
        }

        // Remore existing info bubble
      } catch (err) {
        _didIteratorError12 = true;
        _iteratorError12 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion12 && _iterator12.return) {
            _iterator12.return();
          }
        } finally {
          if (_didIteratorError12) {
            throw _iteratorError12;
          }
        }
      }

      self.hereMaps.ui.getBubbles().forEach(function (bub) {
        self.hereMaps.ui.removeBubble(bub);
      });

      var bubbleId = 'driverInfo_' + driver.id;

      var bubbles = self.hereMaps.ui.getBubbles();
      for (var i = 0; i < bubbles.length; i++) {
        var item = bubbles[i];
        if (item.id !== bubbleId) {
          continue;
        }
        self.hereMaps.ui.removeBubble(item);
      }

      // let run = this.runs.list.find(x => x.id === this.items[0].runId)
      var showDispatchButtons = true;

      var bubbleContent = '<div class="info-container">' + '<div class="driver-info"><img src="{DRIVER_PHOTO}"/><a href="{DRIVER_URL}" target="_blank">{DRIVER_NAME}</a></div>' + '<div class="vehicle-info"><img src="{VEHICLE_PHOTO}"/><strong>{VEHICLE_NAME}</strong><span>{VEHICLE_NUMBER}</span></div>' + '<a id="DriverCall_{DRIVER_ID}" class="call-button button cta xsmall success block" href="javascript:;" @click="testMethod">CALL {DRIVER_FNAME}</a>';
      '</div>';

      if (showDispatchButtons) {
        bubbleContent = '<div class="info-container">' + '<div class="prvNxt prev" id="driverPrev_{DRIVER_ID}"><i class="fas fa-chevron-left"></i></div>' + '<div class="prvNxt next" id="driverNext_{DRIVER_ID}"><i class="fas fa-chevron-right"></i></div>' +
        // '<div class="upcoming-rsvp">{UPCOMING_INFO}</div>' +
        '<div class="driver-info"><img src="{DRIVER_PHOTO}"/><a href="{DRIVER_URL}" target="_blank">{DRIVER_NAME}</a><span>{DRIVER_DISTANCE}</span>' + '<a id="DriverSend_{DRIVER_ID}" class="assign-button button cta xsmall warning block" href="javascript:;">SEND TO {DRIVER_FNAME}</a></div>' + '<div class="vehicle-info"><img src="{VEHICLE_PHOTO}"/><strong>{VEHICLE_NAME}</strong><span>{VEHICLE_NUMBER}</span>' + '<a id="DriverAssign_{DRIVER_ID}" class="assign-button button cta xsmall block" href="javascript:;">ASSIGN TO {DRIVER_FNAME}</a></div>' + '<a id="DriverCall_{DRIVER_ID}" class="call-button button cta xsmall success block" href="javascript:;" @click="testMethod"><i class="fas fa-phone"></i> CALL {DRIVER_FNAME}</a>';
        '</div>';

        var upcomingInfo = '';
        bubbleContent = bubbleContent.replace('{UPCOMING_INFO}', upcomingInfo);
      }

      self.currentDriver = driver;
      bubbleContent = bubbleContent.replace('{DRIVER_PHOTO}', driver.driverImg).replaceAll('{DRIVER_ID}', driver.id).replace('{DRIVER_URL}', '/#/provider/' + driver.id).replace('{DRIVER_NAME}', driver.firstName + ' ' + driver.lastName).replace('{DRIVER_DISTANCE}', self.driverRoutes['a' + driver.id] || '&nbsp;').replaceAll('{DRIVER_FNAME}', driver.firstName).replace('{VEHICLE_PHOTO}', driver.carImg).replace('{VEHICLE_NAME}', driver.manafacturer + ' ' + driver.model).replace('{VEHICLE_NUMBER}', driver.licensePlate);

      var bubble = new window.H.ui.InfoBubble({
        lat: driver.lat,
        lng: driver.lng
      }, {
        content: bubbleContent,
        onStateChange: function onStateChange(aa) {
          // self.$store.commit('runs/reduceQualifiedDrivers')
          if (!self.qualifiedDrivers.list.length) self.noQualifiedDrivers();else self.validateQualifiedDrivers();
        }
      });
      bubble.id = bubbleId;
      bubble.addClass('H_driver-info');
      self.hereMaps.ui.addBubble(bubble);

      setTimeout(function () {
        var elem = document.getElementById('DriverCall_' + driver.id);
        if (elem) {
          elem.addEventListener('click', function (evt) {
            self.callDriver(driver);
          });
        }

        if (showDispatchButtons) {
          var assignElem = document.getElementById('DriverAssign_' + driver.id);
          if (assignElem) {
            assignElem.addEventListener('click', function (evt) {
              self.assignToDriver(driver);
            });
          }
          var sendElem = document.getElementById('DriverSend_' + driver.id);
          if (sendElem) {
            sendElem.addEventListener('click', function (evt) {
              self.sendToDriver(driver);
            });
          }
        }
        self.checkRunSelected();
      }, 500);
    },
    driverFilterSubmit: function driverFilterSubmit() {
      if (this.qualifiedDrivers.active) {
        this.findQualifiedDrivers();
        this.driverFilter.show = false;
      } else {
        this.findNearbyDrivers();
      }
    },
    only1Run: function only1Run(item) {
      if (!item.length) return false;
      var runId = '';
      var only1 = false;
      item.forEach(function (x) {
        if (x.runId) {
          if (!runId) {
            runId = x.runId;
            only1 = true;
          } else if (x.runId !== runId) only1 = false;
        }
      });

      return only1;
    },
    noQueueDrivers: function noQueueDrivers() {
      var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.mapLoader = {
        show: false,
        label: ''
      };
      this.queueError = {
        show: true,
        message: 'No qualified drivers found.'
      };
      if (r) this.buildReasons(r);
    },
    buildReasons: function buildReasons(r) {
      var list = [];

      var _loop = function _loop(key) {
        if (r.unqualified[key][0] === 'services') return 'continue';
        var driver = r.unfiltered.find(function (d) {
          return d.id == key;
        });
        if (driver) {
          list.push({
            id: driver.id,
            name: driver.name,
            reason: r.unqualified[key][0]
          });
        }
      };

      var _iteratorNormalCompletion13 = true;
      var _didIteratorError13 = false;
      var _iteratorError13 = undefined;

      try {
        for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(r.unqualified)), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
          var key = _step13.value;

          var _ret2 = _loop(key);

          if (_ret2 === 'continue') continue;
        }
      } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion13 && _iterator13.return) {
            _iterator13.return();
          }
        } finally {
          if (_didIteratorError13) {
            throw _iteratorError13;
          }
        }
      }

      this.$store.commit('global/setReasonsData', { list: list });
    },
    showReasons: function showReasons() {
      this.queueError.show = false;
      this.$store.commit('global/setReasonsData', {
        reasonsModal: true
      });
    },
    reasonLabel: function reasonLabel(x) {
      switch (x) {
        case 'serviceType':
          return 'Driver cannot accept this service type';
        case 'seats':
          return 'Driver vehcile does not have enough seat capacity';
        case 'adaWC':
          return 'Requires ADA wheelchair';
        case 'adaSD':
          return 'Requires ADA service dog';
        case 'fullTNC':
          return 'Do not give full TNC runs to TCP drivers';
        case 'availability':
          return 'Driver availability does not match';
        case 'distance':
          return 'Driver distance to first pickup location';
        default:
          return x;
      }
    },
    closeReasons: function closeReasons() {
      this.$store.commit('global/setReasonsData', {
        reasonsModal: false
      });
      this.$forceUpdate();
    }
  },
  watch: {
    items: function items(value) {
      var self = this;
      if (value.length <= 0) {
        __WEBPACK_IMPORTED_MODULE_8__map_utils__["a" /* default */].clearMap(self.hereMaps.map);

        var _iteratorNormalCompletion14 = true;
        var _didIteratorError14 = false;
        var _iteratorError14 = undefined;

        try {
          for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
            var object = _step14.value;

            if (object.id.indexOf('qualifiedDrivers') > -1) {
              self.hereMaps.map.removeObject(object);
            }
            if (object.id.indexOf('driverRoute') > -1) {
              object.setVisibility(0);
            }
          }
        } catch (err) {
          _didIteratorError14 = true;
          _iteratorError14 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion14 && _iterator14.return) {
              _iterator14.return();
            }
          } finally {
            if (_didIteratorError14) {
              throw _iteratorError14;
            }
          }
        }

        self.hereMaps.ui.getBubbles().forEach(function (bub) {
          self.hereMaps.ui.removeBubble(bub);
        });
        self.$forceUpdate();
        return;
      }
      self.renderMarkers();
      self.computeRoute();

      if (value.length) {
        var runId = [];
        value.forEach(function (run) {
          if (run.runId && runId.indexOf(run.runId) == -1) {
            runId.push(run.runId);
          }
        });
        if (runId.length == 1) {
          this.driverInfoIndex = 0;
          // this.findNearbyDrivers()
        }
      }
      if (!this.checkRunSelected()) {
        var now = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
        var pickupTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(value[0].pickupDate, 'MM/DD/YYYY hh:mmA');
        var diff = pickupTime.diff(now, 'minute');
        var limit = parseInt(self.$settings.get('findNearbyDriverLimit'));
        // self.upcoming.loading = true
        // self.upcoming.rsvp = null
        if (diff <= limit) {
          self.isQualifiedDriver = false;
          self.$store.commit('runs/setQualifiedDriversData', { active: false });
          self.findNearbyDrivers();
        } else {
          self.isQualifiedDriver = true;
          self.$store.commit('runs/setQualifiedDriversData', { active: true });
          self.findQualifiedDrivers();
        }
        // this.findQualifiedDrivers()
      }
    },

    'runs.selected': function runsSelected(ids) {
      if (ids) {
        // this.driverInfoIndex = 0
        // this.findNearbyDrivers()
      }
    },
    driverDistance: function driverDistance(value) {
      if (value && this.waiting.beginDriverPresentation) {
        this.waiting.beginDriverPresentation = false;
      }
    },

    'driverFilter.show': function driverFilterShow(val) {
      if (val) {
        this.filterServices();
      }
    }
  },
  mounted: function mounted() {
    this.initMap();
  }
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropzone_vue__ = __webpack_require__(499);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1be11774_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropzone_vue__ = __webpack_require__(1388);
function injectStyle (ssrContext) {
  __webpack_require__(1382)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1be11774"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropzone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1be11774_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropzone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DropzoneControls__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Partials_LoadingAnimation_MapMarker__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drop-zone',
  components: { Draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a, DropzoneControls: __WEBPACK_IMPORTED_MODULE_2__DropzoneControls__["a" /* default */], LoaderMapMarker: __WEBPACK_IMPORTED_MODULE_3__components_Partials_LoadingAnimation_MapMarker__["a" /* default */] },
  data: function data() {
    return {
      overDropZone: false,
      issueDelay: '',
      issueList: []
    };
  },

  computed: {
    airports: function airports() {
      return this.$store.state.airports.list;
    },
    dropzone: function dropzone() {
      return this.$store.state.runs.dropzone;
    },

    items: {
      get: function get() {
        return this.dropzone.items;
      },
      set: function set(value) {
        // a rsvp dropoff should not occur before pickup
        for (var i = 0; i < value.length; i++) {
          value[i].timeToNext = null;
        }
        this.$store.commit('runs/setDropzoneData', { items: value });
        this.recheckIssue();
      }
    },
    showDropzone: function showDropzone() {
      return this.dropzone.show;
    },
    checkRouteLoading: function checkRouteLoading() {
      return this.dropzone.checkRoute;
    },
    calculatingRun: function calculatingRun() {
      return this.dropzone.calculatingRun;
    }
  },
  methods: {
    handleDrop: function handleDrop(data) {
      var _this = this;

      data.rsvps.forEach(function (rsvp) {
        if (data.type === 'runs') {
          rsvp.runId = data.id;
        }
        _this.$store.commit('runs/addDropzoneItem', rsvp);
        _this.recheckIssue();
      });
    },
    computeEta: function computeEta(rsvp) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(rsvp.pickupDate, 'MM/DD/YYYY hh:mmA').add(rsvp.eta, 'seconds').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
    },
    hasIssues: function hasIssues(rsvp, index) {
      var self = this;
      if (index + 1 >= self.items.length) {
        return {
          time: 'ontime',
          msg: ''
        };
      }

      var time = 'ontime';
      self.issueList[index] = 'ontime';

      var eta = __WEBPACK_IMPORTED_MODULE_0_moment___default()(rsvp.pickupDate, 'MM/DD/YYYY hh:mmA').add(rsvp.eta, 'seconds').add(rsvp.timeToNext, 'seconds');
      var nextPickup = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.items[index + 1].pickupDate, 'MM/DD/YYYY hh:mmA');
      if (eta.isAfter(nextPickup)) {
        time = 'late';
        if (eta.diff(nextPickup, 'minutes') > 15) time = 'not-allowed';
        self.issueList[index] = time;
      }

      return {
        time: time,
        msg: 'Will arrive at <b>' + eta.format('MM/DD/YYYY hh:mmA') + '</b> on the next Pickup.'
      };
    },
    getAddress: function getAddress(loc) {
      var index = this.airports.findIndex(function (x) {
        return x.geofenceId === loc.geofenceId;
      });
      if (index > -1) return this.airports[index].title;
      return loc.title;
    },
    removeFromMap: function removeFromMap(item) {
      this.$store.commit('runs/removeDropzoneItem', item);
      this.recheckIssue();
    },
    recheckIssue: function recheckIssue() {
      var self = this;
      if (self.issueDelay) clearTimeout(self.issueDelay);

      self.issueList = [];
      self.issueDelay = setTimeout(function () {
        self.items.forEach(function (rsvp, index) {
          if (index + 1 >= self.items.length) return;

          var time = '';
          // self.issueList[index] = 'ontime'

          var eta = __WEBPACK_IMPORTED_MODULE_0_moment___default()(rsvp.pickupDate, 'MM/DD/YYYY hh:mmA').add(rsvp.eta, 'seconds').add(rsvp.timeToNext, 'seconds');
          var nextPickup = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.items[index + 1].pickupDate, 'MM/DD/YYYY hh:mmA');
          if (eta.isAfter(nextPickup)) {
            time = 'late';
            if (eta.diff(nextPickup, 'minutes') > 15) time = 'not-allowed';
          } else time = 'ontime';
          self.issueList[index] = time;
        });
        if (self.$refs.dropzoneControls) self.$refs.dropzoneControls.updateIssue(self.issueList);
        self.$forceUpdate();
      }, 250);
    }
  },
  watch: {
    items: function items() {
      this.$forceUpdate();
      this.recheckIssue();
    }
  }
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dropzone-controls',
  data: function data() {
    return {
      issueList: []
    };
  },

  computed: {
    runs: function runs() {
      return this.$store.state.runs;
    },
    items: function items() {
      return this.runs.dropzone.items;
    },
    hereMaps: function hereMaps() {
      return this.runs.hereMaps;
    },

    calculating: {
      get: function get() {
        return this.runs.dropzone.calculatingRun;
      },
      set: function set(x) {
        this.$store.commit('runs/setDropzoneData', { calculatingRun: x });
      }
    }
  },
  methods: {
    removeDuplicates: function removeDuplicates(items) {
      return items.filter(function (item, index, self) {
        return index === self.findIndex(function (p) {
          return p.reservationID === item.reservationID && p.reservationID === item.reservationID;
        });
      });
    },
    clearMap: function clearMap() {
      this.$store.commit('runs/clearDropzone');
    },
    processCalculate: function processCalculate() {
      var _this = this;

      if (this.items.length < 1) return;
      var locs = [];
      this.items.forEach(function (item, index) {
        if (index === _this.items.length - 1) return;
        locs.push({
          id: item.id,
          origin: item.dropoff,
          destination: _this.items[index + 1].pickup
        });
      });
      this.calculating = true;
      this.calculateRun(locs);
    },
    calculateRun: function calculateRun(locs) {
      var self = this;
      if (!locs.length) {
        this.calculating = false;
        return;
      }

      var router = self.hereMaps.platform.getRoutingService(null, 8);
      var routeRequestParams = {
        routingMode: 'fast',
        transportMode: 'car',
        origin: locs[0].origin.lat + ',' + locs[0].origin.lng,
        destination: locs[0].destination.lat + ',' + locs[0].destination.lng,
        return: 'polyline,turnByTurnActions,actions,instructions,travelSummary'
      };

      router.calculateRoute(routeRequestParams, function (success) {
        var timeToNext = success.routes[0].sections[0].travelSummary.duration || 0;
        if (timeToNext) {
          // timeToNext += 60 * 10 // add 30mins to ETA
        }
        self.$store.commit('runs/updateNextInfo', {
          id: locs[0].id,
          timeToNext: timeToNext,
          distanceToNext: parseFloat(((success.routes[0].sections[0].travelSummary.length || 0) / 1609).toFixed(2))
        });
        locs.shift();
        self.calculateRun(locs);
      }, function (error) {
        console.log('error', error);
        locs.shift();
        self.calculateRun(locs);
      });
    },
    savePackage: function savePackage() {
      var self = this;

      if (self.issueList.indexOf('not-allowed') > -1) return;

      var rsvpGapTime = self.$settings.get('ReservationGapTime');
      var hasError = false;
      var errorMsg = '';
      self.items.forEach(function (item, i) {
        if (i + 1 >= self.items.length) return;

        var arrivalTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.pickupDate, 'MM/DD/YYYY hh:mmA').add(item.eta, 'seconds').add(item.timeToNext || 0, 'seconds');
        var currentTrip = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.pickupDate, 'MM/DD/YYYY hh:mmA').add(item.eta, 'seconds');
        var nextPickup = __WEBPACK_IMPORTED_MODULE_0_moment___default()();
        if (self.items[i + 1]) {
          nextPickup = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.items[i + 1].pickupDate, 'MM/DD/YYYY hh:mmA');
        }
        /*
        if (currentTrip.diff(nextPickup, 'minutes') > -rsvpGapTime) {
          hasError = true
          errorMsg = `There should be at least <b>${rsvpGapTime} mins</b> gap between trips.`
        } else if (i != (self.items.length - 1) && arrivalTime.isAfter(nextPickup)) {
          hasError = true
          errorMsg = 'Not enough time to reach the next pickup.'
        }
        */
      });
      if (hasError) {
        self.$store.commit('global/setAlertData', {
          show: true,
          message: errorMsg
        });
        return;
      }

      self.$store.commit('routing/showRoutingModal');

      var message = 'Are you sure you want to save this run?';
      var action = 'SAVE_RUN';
      self.$store.commit('routing/setConfirmationModal', {
        show: true,
        title: 'Confirm Run',
        message: message,
        action: action
      });
    },
    updateIssue: function updateIssue(x) {
      this.issueList = x;
    }
  }
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DriverControls__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Partials_LoadingAnimation_Ellipsis__ = __webpack_require__(38);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import moment from 'moment'



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rsvp-available-drivers',
  components: { DriverControls: __WEBPACK_IMPORTED_MODULE_0__DriverControls__["a" /* default */], EllipsisLoader: __WEBPACK_IMPORTED_MODULE_1__components_Partials_LoadingAnimation_Ellipsis__["a" /* default */] },
  data: function data() {
    return {};
  },

  computed: {
    dispatch: function dispatch() {
      return this.$store.state.dispatch;
    },
    drivers: function drivers() {
      return this.dispatch.availableDrivers.list;
    },
    currentDispatchTab: function currentDispatchTab() {
      return this.dispatch.currentTable;
    },
    loading: function loading() {
      return this.dispatch.availableDrivers.loading;
    },

    selectedDriver: {
      get: function get() {
        return this.dispatch.availableDrivers.selected;
      },
      set: function set(value) {
        this.$store.commit('dispatch/setAvailableDriversData', { selected: value });
      }
    }
  },
  methods: {},
  watch: {}
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lyft-services',
  data: function data() {
    return {
      queue: [],
      selected: null,
      availability: {
        loading: false,
        status: '',
        token: ''
      },
      loading: false,
      msg: '',
      statusDelay: '',
      rideId: '',
      driver: {
        found: false,
        id: '',
        img: '',
        name: '',
        mobile: '',
        rating: ''
      },
      vehicle: {
        img: '',
        color: '',
        licensePlate: '',
        make: '',
        model: '',
        year: ''
      },
      currentRsvpID: '',
      searching: false,
      cancelSearch: false,

      // venues
      directions: '',
      zones: [],
      zoneIndex: 0,
      locationIndex: 0
    };
  },

  computed: {
    dispatch: function dispatch() {
      return this.$store.state.dispatch;
    },
    lyft: function lyft() {
      return this.dispatch.lyft;
    },

    show: {
      get: function get() {
        return this.lyft.show;
      },
      set: function set(x) {
        this.$store.commit('dispatch/setLyftData', { show: x });
        if (!x) {
          this.queue = [];
          this.selected = null;
        }
      }
    },
    services: function services() {
      return this.lyft.services.filter(function (x) {
        return x.can_request_ride;
      }).sort(function (a, b) {
        return a.estimated_cost_cents_max - b.estimated_cost_cents_max;
      });
    },
    venue: function venue() {
      return this.dispatch.venue;
    },

    venueShow: {
      get: function get() {
        return this.venue.show;
      },
      set: function set(x) {
        this.$store.commit('dispatch/setVenueData', { show: x });
      }
    },
    rsvpInTable: function rsvpInTable() {
      return this.dispatch.rsvpInTable;
    }
  },
  methods: {
    price: function price(x) {
      var a = parseFloat(x);
      a = a / 100;
      return a.toLocaleString('en-US', { minimumFractionDigits: 2 });
      // if (x.estimated_cost_cents_min === x.estimated_cost_cents_max) return `$${(x.estimated_cost_cents_min / 100).toFixed(2)}`
      // return `$${(x.x.estimated_cost_cents_min / 100).toFixed(2)} - $${(x.estimated_cost_cents_max / 100).toFixed(2)}`
    },
    select: function select(service, i) {
      // if (service.failed) return
      this.selected = service;
    },
    send: function send() {
      var pickup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var self = this;
      if (self.selected === null || self.availability.loading) return;
      self.cancelSearch = false;
      var rsvps = self.dispatch.checkedReservations;

      var service = self.selected;
      // self.$store.commit('global/setLoaderData', {show: true})
      self.loading = true;
      self.msg = 'Processing your booking. . .';
      self.currentRsvpID = rsvps[0].id;
      var param = {
        token: self.$store.state.session.sessionToken,
        ride_type: service.ride_type,
        cost_token: service.cost_token
        // driver_availability_token: self.availability.token
      };
      if (pickup) param.pickup = pickup;
      self.$sdk.post('/admin/rsvp/' + rsvps[0].id + '/lyft/create/asap', param, function (r) {
        // self.$store.commit('global/setLoaderData', {show: false})
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          self.loading = false;
          self.show = false;
          return;
        }

        // self.$store.commit('global/setAlertData', {
        //   show: true,
        //   message: 'Successfully sent to Lyft.'
        // })
        // self.show = false
        self.msg = 'Searching for nearby drivers. . .';
        self.searching = true;
        self.getStatus(rsvps[0].id);
      }, '1.1');
    },
    getStatus: function getStatus(rsvpId) {
      var self = this;
      if (self.cancelSearch) return;

      self.currentRsvpID = rsvpId;
      self.$sdk.get('/admin/rsvp/' + rsvpId + '/lyft', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          self.loading = false;
          self.show = false;
          return;
        }
        if (r.lyft || r.status === 'accepted') {
          self.searching = false;
          var driver = r.lyft.driver;
          var vehicle = r.lyft.vehicle;
          self.rideId = r.rideId;
          self.loading = false;
          if (driver) {
            self.driver = {
              found: true,
              id: driver.id,
              img: driver.image_url,
              name: driver.first_name,
              mobile: driver.phone_number,
              rating: driver.rating
            };
          }
          if (vehicle) {
            self.vehicle = {
              img: vehicle.image_url,
              color: vehicle.color,
              licensePlate: vehicle.license_plate,
              make: vehicle.make,
              model: vehicle.model,
              year: vehicle.year
            };
          }
          return;
        }

        if (self.statusDelay) clearTimeout(self.statusDelay);
        self.statusDelay = setTimeout(function () {
          self.getStatus(rsvpId);
        }, 5000);
      }, '1.1');
    },
    cancelRide: function cancelRide() {
      var self = this;
      if (!self.searching) return;

      self.cancelSearch = true;
      self.loading = true;
      self.msg = 'Cancelling. . .';
      if (this.statusDelay) clearTimeout(this.statusDelay);
      self.$sdk.post('/admin/rsvp/' + self.currentRsvpID + '/lyft/cancel', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.show = false;
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          return;
        }
      }, '1.1');
    },
    priceDiffClass: function priceDiffClass(orig, newPrice) {
      orig = orig ? parseFloat(orig.toFixed(2)) : 0;
      newPrice = newPrice ? parseFloat((newPrice / 100).toFixed(2)) : 0;

      if (orig > newPrice) return 'low-price';
      if (orig < newPrice) return 'high-price';
      return '';
    },
    getETA: function getETA() {
      var service = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (service === null || !service) return false;
      var eta = parseInt(service.duration);
      if (eta == 0) return '0 secs';
      var min = Math.ceil(parseFloat((eta / 60).toFixed(2)));
      var hour = 0;
      if (min < 60) return min + 'min(s) ';else {
        hour = Math.floor(parseFloat((min / 60).toFixed(2)));
        min = hour * 60 - min;
        return hour + 'hr(s) ' + min + 'min(s)';
      }
    },
    checkVenue: function checkVenue() {
      var self = this;

      var origPrice = parseFloat(self.lyft.originalFare);
      var limitPercent = parseFloat(this.$settings.get('LyftDispatchRestrictPercent') || 10);
      var xlimitPercent = limitPercent / 100 + 1;
      var limitPrice = parseFloat((origPrice * xlimitPercent).toFixed(2));
      var servicePrice = parseFloat((self.selected.estimated_cost_cents_max / 100).toFixed(2));
      if (servicePrice > limitPrice) {
        self.$store.commit('global/setAlertData', {
          show: true,
          message: 'This service exceeds the ' + limitPercent + '% fare limit for this reservation. The maximum allowed fare is $' + limitPrice + '.'
        });
        return;
      }

      var rsvpData = self.rsvpInTable.find(function (x) {
        return x.id === self.dispatch.checkedReservations[0].id;
      });
      var pickup = rsvpData.pickup;
      var chk = self.venue.list.find(function (x) {
        return x.lat === pickup.lat && x.lng === pickup.lng;
      });
      if (chk) {
        self.$store.commit('global/setLoaderData', { show: false });
        self.$store.commit('dispatch/setVenueData', { show: true });
        return;
      }

      var request = {
        lat: pickup.lat,
        lng: pickup.lng,
        type: 'pickup',
        radius: 0.01
      };
      self.$store.commit('global/setLoaderData', { show: true });
      self.$sdk.get('/venues', request, function (res) {
        if (res.error || res.venues && !res.venues.length || res.venues && res.venues.length && !res.venues[0].zones.length) {
          self.$store.commit('global/setLoaderData', { show: false });
          // self.proceedToCustomer()
          self.send();
          return;
        }

        if (res.venues[0].category === 'airport') {
          self.$sdk.get('/geofences', { lat: pickup.lat, lng: pickup.lng }, function (res2) {
            if (res2.error || !res2.error && res2.list && res2.list[0] && res2.list[0].type !== 'airport') {
              self.$store.commit('global/setLoaderData', { show: false });
              // self.proceedToCustomer()
              self.send();
              return;
            }
            self.processVenueData(res, request);
          }, '1.1');
          return;
        }

        self.processVenueData(res, request);
      }, '2.0');
    },
    processVenueData: function processVenueData(res, request) {
      var self = this;
      var tmpData = {
        name: res.venues[0].name,
        lat: request.lat,
        lng: request.lng,
        zones: []
      };
      res.venues[0].zones.forEach(function (x) {
        var tmpLocs = [];
        x.locations.forEach(function (y) {
          tmpLocs.push({
            lat: y.lat,
            lng: y.lng,
            name: y.name,
            directions: self.lyftSanitize(y.walking_directions),
            disabled: y.disabled_ride_types
          });
        });
        tmpData.zones.push({
          name: x.name,
          directions: self.lyftSanitize(x.walking_directions),
          locations: tmpLocs
        });
      });
      self.$store.commit('dispatch/addVenueList', tmpData);
      self.$store.commit('global/setLoaderData', { show: false });
      self.$store.commit('dispatch/setVenueData', { show: true });
    },
    lyftSanitize: function lyftSanitize(x) {
      if (!x) return x;
      return x.replaceAll('Lyft', '').replaceAll('lyft', '').replaceAll('  ', ' ');
    },
    getDefaultVenue: function getDefaultVenue() {
      var self = this;
      var rsvpData = self.rsvpInTable.find(function (x) {
        return x.id === self.dispatch.checkedReservations[0].id;
      });
      var pickup = rsvpData.pickup;
      var selectedLyftService = self.selected.ride_type;
      if (!self.venue.list.length || !selectedLyftService) {
        console.log('empty venue or no selected service');
        self.send();
        // self.$emit('next')
        return;
      }

      var data = self.venue.list.find(function (x) {
        return x.lat === pickup.lat && x.lng === pickup.lng;
      });
      if (!data) {
        console.log('cannot find venue');
        self.send();
        // self.$emit('next')
        return;
      }

      var selectedService = selectedLyftService;
      if (selectedService === 'lyft_easy_step_in' || selectedService === 'lyft_priority_pickup') {
        selectedService = 'lyft';
      }

      data.zones.forEach(function (x) {
        var locations = [];
        x.locations.forEach(function (y) {
          if (!y.disabled.includes(selectedService)) locations.push(y);
        });
        if (locations.length) {
          self.zones.push({
            name: x.name,
            directions: x.directions,
            locations: locations
          });
        }
      });
      if (!self.zones.length) {
        console.log('selected service is not allowed in any locations');
        self.send();
        // self.$emit('next')
        return;
      }
      self.directions = self.zones[0].locations[0].directions;
    },
    updatePickup: function updatePickup() {
      var self = this;
      var rsvpData = self.rsvpInTable.find(function (x) {
        return x.id === self.dispatch.checkedReservations[0].id;
      });
      var pickup = rsvpData.pickup;
      var pickupCopy = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(pickup));
      self.$store.commit('dispatch/setVenueData', {
        lastCoords: pickup.lat + ',' + pickup.lng,
        origPickupData: pickupCopy,
        selected: {
          service: rsvpData.serviceId,
          zone: self.zoneIndex,
          location: self.locationIndex
        }
      });

      var tmpPickup = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(pickup));
      var data = self.venue.list.find(function (x) {
        return x.lat === pickup.lat && x.lng === pickup.lng;
      });
      setTimeout(function () {
        tmpPickup.title = data.name + ', ' + self.zones[self.zoneIndex].name + ' ' + self.zones[self.zoneIndex].locations[self.locationIndex].name;
        // tmpPickup.address1 = data.name
        // tmpPickup.address2 = self.zones[self.zoneIndex].name + ' ' + self.zones[self.zoneIndex].locations[self.locationIndex].name
        tmpPickup.lat = self.zones[self.zoneIndex].locations[self.locationIndex].lat;
        tmpPickup.lng = self.zones[self.zoneIndex].locations[self.locationIndex].lng;
        // self.$store.commit('reservation/setPickup', {
        //   leg: 'leg1',
        //   value: tmpPickup
        // })
        self.venueShow = false;
        // self.$emit('next')
        self.send({
          address: tmpPickup.title,
          lat: tmpPickup.lat,
          lng: tmpPickup.lng
        });
      }, 50);
    }
  },
  watch: {
    show: function show(x) {
      if (!x) {
        if (this.statusDelay) clearTimeout(this.statusDelay);
        this.driver.found = false;
        this.cancelSearch = true;
      } else {
        this.cancelSearch = false;
        this.zones = [];
        this.directions = '';
        this.zoneIndex = 0;
        this.locationIndex = 0;
      }
    },
    venueShow: function venueShow(x) {
      var _this = this;

      var self = this;
      if (x) {
        var rsvpData = self.rsvpInTable.find(function (x) {
          return x.id === self.dispatch.checkedReservations[0].id;
        });
        var pickup = rsvpData.pickup;
        if (this.venue.lastCoords === pickup.lat + ',' + pickup.lng && this.venue.selected.service === rsvpData.serviceId) {
          this.zoneIndex = this.venue.selected.zone;
          setTimeout(function () {
            self.locationIndex = _this.venue.selected.location;
            self.getDefaultVenue();
          }, 50);
          return;
        }
        this.zones = [];
        this.directions = '';
        this.zoneIndex = 0;
        this.locationIndex = 0;
        this.getDefaultVenue();
      } else {
        this.zones = [];
        this.directions = '';
        this.zoneIndex = 0;
        this.locationIndex = 0;
      }
    },
    zoneIndex: function zoneIndex(x) {
      this.locationIndex = 0;
      if (!this.zones.length) {
        this.directions = '';
        return;
      }
      this.directions = this.zones[x].locations[this.locationIndex].directions;
    },
    locationIndex: function locationIndex(x) {
      if (!this.zones.length) {
        this.directions = '';
        return;
      }
      this.directions = this.zones[this.zoneIndex].locations[x].directions;
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map2__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DispatchModal__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DispatchNotification__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DispatchSchedule__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReservationDetails__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PackageDetails__ = __webpack_require__(1405);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import DispatchMap from './Map'







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dispatch-map-details',
  components: { DispatchMap2: __WEBPACK_IMPORTED_MODULE_0__Map2__["a" /* default */], DispatchModal: __WEBPACK_IMPORTED_MODULE_1__DispatchModal__["a" /* default */], DispatchNotification: __WEBPACK_IMPORTED_MODULE_2__DispatchNotification__["a" /* default */], DispatchSchedule: __WEBPACK_IMPORTED_MODULE_3__DispatchSchedule__["a" /* default */], ReservationDetails: __WEBPACK_IMPORTED_MODULE_4__ReservationDetails__["a" /* default */], PackageDetails: __WEBPACK_IMPORTED_MODULE_5__PackageDetails__["a" /* default */] },
  computed: {
    rsvp: function rsvp() {
      var self = this;
      if (self.$store.state.dispatch.rsvpInMap.id === null) {
        return null;
      }
      return self.$store.state.dispatch.rsvpInMap;
    }
  },
  mounted: function mounted() {
    this.$store.commit('sideMenu/hideMenuButton');
  },
  destroyed: function destroyed() {
    this.$store.commit('sideMenu/showMenuButton');
  }
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_flight_info__ = __webpack_require__(108);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dispatch-reservation-details',
  props: ['rsvp'],
  data: function data() {
    return {
      showPaymentBreakdown: false
    };
  },

  methods: {
    getAddress: function getAddress(location) {
      if (location.geofenceType === 'airport' && location.geofenceName !== '') {
        var result = location.geofenceName;
        if (location.terminal && location.terminal !== '' && location.terminal !== 'undefined') {
          result += ' - Terminal ' + location.terminal;
        }
        return result;
      }
      return location.title;

      // let address = ''
      // if (location.address2 && location.address2 !== '' && location.address2 !== 'undefined') {
      //   address = address + location.address2 + ' '
      // }
      // if (location.address1) {
      //   address = address + location.address1 + ', '
      // }
      // if (location.city) {
      //   address = address + location.city + ' '
      // }
      // if (location.state) {
      //   address = address + location.state + ' '
      // }
      // if (location.zip) {
      //   address = address + location.zip
      // }

      // return address
    },
    getDriverPayment: function getDriverPayment(breakdown) {
      return breakdown.base + breakdown.bonus + breakdown.tip + breakdown.pickupFee;
    },
    showBreakdown: function showBreakdown(value) {
      this.showPaymentBreakdown = value;
    },
    callPhone: function callPhone(contact) {
      var self = this;
      self.$plugins.phone.startCall(self, {
        phone: contact.phone,
        name: contact.firstName + ' ' + contact.lastName
      });
    },
    showFlightInfo: function showFlightInfo() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0__modules_api_flight_info__["a" /* default */].loadFlightInfo(self, self.rsvp, function (r) {
        if (r.error) {
          console.log(r);
          return;
        }
      });
    }
  }
});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dispatch-reservation-details',
  props: ['package'],
  data: function data() {
    return {
      showPaymentBreakdown: false
    };
  },

  methods: {
    getAddress: function getAddress(location) {
      if (location.geofenceType === 'airport' && location.geofenceName !== '') {
        var result = location.geofenceName;
        if (location.terminal && location.terminal !== '' && location.terminal !== 'undefined') {
          result += ' - Terminal ' + location.terminal;
        }
        return result;
      }
      return location.title;

      // let address = ''
      // if (location.address2 && location.address2 !== '' && location.address2 !== 'undefined') {
      //   address = address + location.address2 + ' '
      // }
      // if (location.address1) {
      //   address = address + location.address1 + ', '
      // }
      // if (location.city) {
      //   address = address + location.city + ' '
      // }
      // if (location.state) {
      //   address = address + location.state + ' '
      // }
      // if (location.zip) {
      //   address = address + location.zip
      // }

      return address;
    },
    getDriverPayment: function getDriverPayment(breakdown) {
      return breakdown.base + breakdown.bonus + breakdown.tip + breakdown.pickupFee;
    },
    showBreakdown: function showBreakdown(value) {
      this.showPaymentBreakdown = value;
    }
  }
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AvailableDrivers__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DispatchModal__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DispatchNotification__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DispatchSchedule__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReservationsTable__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Partials_ReservationFilter__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Partials_ReservationSearch__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MoreFilter__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReadyToGoModal__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NotesModal__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DriverServiceFilter__ = __webpack_require__(485);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dispatch-reservations',
  components: {
    AvailableDrivers: __WEBPACK_IMPORTED_MODULE_0__AvailableDrivers__["a" /* default */], DispatchModal: __WEBPACK_IMPORTED_MODULE_1__DispatchModal__["a" /* default */], DispatchNotification: __WEBPACK_IMPORTED_MODULE_2__DispatchNotification__["a" /* default */], DispatchSchedule: __WEBPACK_IMPORTED_MODULE_3__DispatchSchedule__["a" /* default */],
    ReservationsTable: __WEBPACK_IMPORTED_MODULE_4__ReservationsTable__["a" /* default */], ReservationFilter: __WEBPACK_IMPORTED_MODULE_5__components_Partials_ReservationFilter__["a" /* default */], ReservationSearch: __WEBPACK_IMPORTED_MODULE_6__components_Partials_ReservationSearch__["a" /* default */], DispatchMoreFilter: __WEBPACK_IMPORTED_MODULE_7__MoreFilter__["a" /* default */],
    ReadyToGoModal: __WEBPACK_IMPORTED_MODULE_8__ReadyToGoModal__["a" /* default */], NotesModal: __WEBPACK_IMPORTED_MODULE_9__NotesModal__["a" /* default */], DriverServiceFilter: __WEBPACK_IMPORTED_MODULE_10__DriverServiceFilter__["a" /* default */]
  },
  data: function data() {
    return { showFilter: false };
  },

  computed: {
    reservations: function reservations() {
      return this.$store.state.dispatch.itemsToShow;
    },
    selectedFilter: function selectedFilter() {
      return this.$store.state.reservation.selectedFilter;
    },
    showServiceFilter: function showServiceFilter() {
      return this.$store.state.dispatch.serviceFilter.show;
    }
  },
  methods: {
    showCustomFilter: function showCustomFilter() {
      if (this.showFilter) {
        this.showFilter = false;
        return;
      }
      this.showFilter = true;
      this.$store.commit('reservation/setSelectedFilter', 'custom');
    }
  },
  mounted: function mounted() {
    // window.open('/#/dispatch/map')
  },

  watch: {
    selectedFilter: function selectedFilter(value) {
      this.showFilter = value === 'custom';
    }
  }
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PromoList__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromoAdd__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_promo__ = __webpack_require__(62);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'promo',
  components: { promoList: __WEBPACK_IMPORTED_MODULE_0__PromoList__["a" /* default */], promoAdd: __WEBPACK_IMPORTED_MODULE_1__PromoAdd__["a" /* default */] },
  data: function data() {
    return {
      searchInput: '',
      isMobile: false
    };
  },

  computed: {
    promo: function promo() {
      return this.$store.state.promo.list;
    },
    loading: function loading() {
      return this.$store.state.promo.loading;
    },

    perPage: {
      get: function get() {
        return this.$store.state.promo.perPage;
      },
      set: function set(value) {
        this.$store.commit('promo/setPerPage', parseInt(value));
        this.$store.commit('promo/setCurrentPage', 1);
        this.getPromo();
      }
    },
    pageData: function pageData() {
      var tableData = this.$store.state.promo;
      var start = tableData.currentPage * tableData.perPage - (tableData.perPage - 1);
      var end = tableData.currentPage * tableData.perPage;
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      };
    },

    currentPage: {
      get: function get() {
        return this.$store.state.promo.currentPage;
      },
      set: function set(value) {
        this.$store.commit('promo/setCurrentPage', parseInt(value));
        this.getPromo();
      }
    },
    isLastPage: function isLastPage() {
      var promo = this.$store.state.promo;
      return promo.currentPage * promo.perPage >= promo.maxList;
    },
    totalPage: function totalPage() {
      var promo = this.$store.state.promo;
      return Math.ceil(promo.maxList / promo.perPage);
    }
  },
  methods: {
    getPromo: function getPromo() {
      var self = this;

      self.$store.commit('promo/setLoading', true);

      __WEBPACK_IMPORTED_MODULE_2__modules_api_promo__["a" /* default */].getList(self, { isNext: true }, function (res) {
        self.$store.commit('promo/setLoading', false);
      });
    },
    clearSearch: function clearSearch() {
      this.searchInput = '';
      this.$store.commit('promo/setSearch', '');
      this.$store.commit('promo/setCurrentPage', 1);
      this.getPromo();
    },
    blurSearch: function blurSearch() {
      var self = this;
      if (self.$store.state.promo.search === self.searchInput.trim()) {
        return;
      }

      self.blurDelay = setTimeout(function () {
        self.search();
      }, 500);
    },
    search: function search() {
      this.$store.commit('promo/setCurrentPage', 1);
      this.$store.commit('promo/setSearch', this.searchInput);
      this.getPromo();
    },
    prev: function prev() {
      if (this.currentPage === 1) {
        return;
      }
      this.$store.commit('promo/setCurrentPage', this.$store.state.promo.currentPage - 1);
      this.getPromo();
    },
    next: function next() {
      if (this.isLastPage) {
        return;
      }
      this.$store.commit('promo/setCurrentPage', this.$store.state.promo.currentPage + 1);
      this.getPromo();
    },
    showAdd: function showAdd() {
      this.$store.commit('promo/setShowAdd', true);
    },
    setScreenSize: function setScreenSize() {
      var self = this;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        self.isMobile = true;
      } else {
        self.isMobile = false;
      }
    }
  },
  watch: {
    // brandFormShow: function (value) {
    // },
  },
  mounted: function mounted() {
    this.getPromo();
    this.setScreenSize();
  }
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_csvexport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_promo__ = __webpack_require__(62);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var exporter = __WEBPACK_IMPORTED_MODULE_0_csvexport___default.a.create({
  filename: 'export.csv',
  columns: ['#', 'Promo Code', 'Status', 'Consumer ID', 'Redeemed Date', 'Expiration Date']
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'promo-list',
  components: {},
  props: ['isMobile'],
  data: function data() {
    return {
      promos: {},
      sticky: false
    };
  },

  computed: {
    _promo: function _promo() {
      return this.$store.state.promo.list;
    },
    loading: function loading() {
      return this.$store.state.promo.loading;
    },
    _rerender: function _rerender() {
      return this.$store.state.promo.rerender;
    },
    currentOrder: function currentOrder() {
      var promo = this.$store.state.promo;
      return { field: promo.order, asc: promo.orderAsc };
    }
  },
  methods: {
    toFixed: function toFixed(amount) {
      return parseFloat(amount).toFixed(2);
    },
    deactivate: function deactivate(id) {
      var self = this;
      if (self.loading) {
        return;
      }

      self.$store.commit('promo/setLoading', true);
      __WEBPACK_IMPORTED_MODULE_1__modules_api_promo__["a" /* default */].deactivate(self, id, function (res) {
        self.$store.commit('promo/setLoading', false);
        if (!res.error) {
          self.$store.commit('promo/updateEnable', { id: id, enable: false });
          self.$store.commit('promo/setRerender', true);
        }
      });
    },
    activate: function activate(id) {
      var self = this;
      if (self.loading) {
        return;
      }

      self.$store.commit('promo/setLoading', true);
      __WEBPACK_IMPORTED_MODULE_1__modules_api_promo__["a" /* default */].activate(self, id, function (res) {
        self.$store.commit('promo/setLoading', false);
        if (!res.error) {
          self.$store.commit('promo/updateEnable', { id: id, enable: true });
          self.$store.commit('promo/setRerender', true);
        }
      });
    },
    exportPromo: function exportPromo(id) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1__modules_api_promo__["a" /* default */].getViewListFull(self, id, function (res) {
        console.log('EXPORT', res);
        exporter.downloadCsv(res);
      });
    },
    onScroll: function onScroll() {
      this.sticky = window.pageYOffset > 160;
    },
    sort: function sort(field) {
      var self = this;
      if (self.loading) {
        return;
      }
      var promo = self.$store.state.promo;
      if (field !== promo.order) {
        self.$store.commit('promo/setOrder', 1);
      } else {
        self.$store.commit('promo/setOrderAsc', promo.orderAsc === 1 ? 0 : 1);
      }
      self.$store.commit('promo/setOrder', field);

      self.$store.commit('promo/setLoading', true);
      __WEBPACK_IMPORTED_MODULE_1__modules_api_promo__["a" /* default */].getList(self, { isNext: true }, function (res) {
        self.$store.commit('promo/setLoading', false);
      });
    }
  },
  watch: {
    _promo: function _promo(value) {
      this.promos = value;
    },
    _rerender: function _rerender(value) {
      if (value) {
        var self = this;
        self.promos = '';
        self.$nextTick(function () {
          self.promos = self.$store.state.promo.list;
        });
        self.$store.commit('promo/setRerender', false);
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    window.onscroll = function () {
      self.onScroll();
    };
  }
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_promo__ = __webpack_require__(62);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'promo-add',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a },
  props: ['isMobile'],
  data: function data() {
    return {
      promoName: '',
      description: '',
      startDate: '',
      startDateHour: '',
      startDateMinute: '',
      expirationDate: '',
      expirationDateHour: '',
      expirationDateMinute: '',
      validDays: '',
      validNewUser: '1',
      code: '',
      amount: '',
      totalCodes: '',
      errorMsg: {
        promoName: '',
        startDate: '',
        startDateHour: '',
        startDateMinute: '',
        expirationDate: '',
        expirationDateHour: '',
        expirationDateMinute: '',
        validDays: '',
        code: '',
        amount: '',
        totalCodes: ''
      },
      errorReturn: '',
      today: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().subtract(1, 'days'),
      loading: false
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.promo.showAdd;
    },
    startDateDisabled: function startDateDisabled() {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(this.today.subtract(1, 'months').format('YYYY'), this.today.format('MM'), this.today.format('DD'))
        };
      }

      return {
        to: new Date(this.today.format('YYYY'), this.today.subtract(1, 'months').format('MM'), this.today.format('DD'))
      };
    },
    expirationDateDisabled: function expirationDateDisabled() {
      var date = this.startDate ? __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.startDate).add(1, 'days') : __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()();
      if (date.format('MM') === '01') {
        return {
          to: new Date(date.subtract(1, 'months').format('YYYY'), date.format('MM'), date.format('DD'))
        };
      }

      return {
        to: new Date(date.format('YYYY'), date.subtract(1, 'months').format('MM'), date.format('DD'))
      };
    }
  },
  methods: {
    close: function close() {
      this.$store.commit('promo/setShowAdd', false);
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(date).format('MM/DD/YYYY');
    },
    save: function save() {
      var self = this;
      self.$emit('save');
      if (self.loading) {
        return;
      }

      if (self.validate()) {
        self.loading = true;
        var startDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(self.startDate);
        startDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(startDate.format('MM/DD/YYYY ') + self.startDateHour + ':' + self.startDateMinute);
        var expirationDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(self.expirationDate);
        expirationDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(expirationDate.format('MM/DD/YYYY ') + self.startDateHour + ':' + self.startDateMinute);

        __WEBPACK_IMPORTED_MODULE_2__modules_api_promo__["a" /* default */].addPromoDetails(self, {
          name: self.promoName,
          description: self.description,
          startDate: startDate.format('YYYY-MM-DD HH:mm:ss'),
          expirationDate: expirationDate.format('YYYY-MM-DD HH:mm:ss'),
          validDays: self.validDays,
          validOnlyForNewUser: self.validNewUser,
          promoCode: self.code,
          amount: self.amount,
          totalCodes: self.totalCodes,
          batchTypeId: 1
        }, function (res) {
          self.loading = false;
          if (res.error) {
            self.errorReturn = res.error.message;
            self.scrollToTop();
            return;
          }

          self.$emit('save');
          self.close();
          self.clearForm();
        });
      }
    },
    validate: function validate() {
      this.resetErrorMsg();
      var hasError = false;

      for (var field in this.errorMsg) {
        if (this[field] === '') {
          this.errorMsg[field] = 'This field cannot be empty.';
          hasError = true;
        }
      }

      return !hasError;
    },
    resetErrorMsg: function resetErrorMsg() {
      this.errorMsg = {
        promoName: '',
        startDate: '',
        startDateHour: '',
        startDateMinute: '',
        expirationDate: '',
        expirationDateHour: '',
        expirationDateMinute: '',
        validDays: '',
        code: '',
        amount: '',
        totalCodes: ''
      };
    },
    clearForm: function clearForm() {
      this.promoName = '';
      this.description = '';
      this.startDate = '';
      this.startDateHour = '';
      this.startDateMinute = '';
      this.expirationDate = '';
      this.expirationDateHour = '';
      this.expirationDateMinute = '';
      this.validDays = '';
      this.validNewUser = '1';
      this.code = '';
      this.amount = '';
      this.totalCodes = '';
    },
    scrollToTop: function scrollToTop() {
      var elmnt = document.getElementById('addPromo');
      elmnt.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    leadingZero: function leadingZero(x) {
      return x < 10 ? '0' + x : x;
    }
  },
  watch: {
    show: function show(value) {}
  },
  mounted: function mounted() {}
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_csvexport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_promo__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PromoViewDetails__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PromoViewEdit__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PromoViewList__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Partials_LoadingModal__ = __webpack_require__(49);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var exporter = __WEBPACK_IMPORTED_MODULE_0_csvexport___default.a.create({
  filename: 'export.csv',
  columns: ['#', 'Promo Code', 'Status', 'Consumer ID', 'Redeemed Date', 'Expiration Date']
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'promo-view',
  components: { promoViewDetails: __WEBPACK_IMPORTED_MODULE_2__PromoViewDetails__["a" /* default */], promoViewEdit: __WEBPACK_IMPORTED_MODULE_3__PromoViewEdit__["a" /* default */], promoViewList: __WEBPACK_IMPORTED_MODULE_4__PromoViewList__["a" /* default */], loadingModal: __WEBPACK_IMPORTED_MODULE_5__Partials_LoadingModal__["a" /* default */] },
  data: function data() {
    return {
      dataLoading: false,
      showFixedHeader: false,
      edit: false,
      showRecords: false,
      isMobile: false
    };
  },

  computed: {
    promo: function promo() {
      return this.$store.state.promo.list;
    },
    promoCode: function promoCode() {
      return this.$store.state.promo.view.details.code;
    },
    viewSaving: function viewSaving() {
      return this.$store.state.promo.view.saving;
    }
  },
  methods: {
    init: function init() {
      var self = this;
      self.setScreenSize();
      var id = self.$route.params.id;
      self.dataLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__modules_api_promo__["a" /* default */].getPromoDetails(self, id, function (res) {
        self.dataLoading = false;
        if (res.error) {
          window.location = "/#/thispagedoesnotexist";
          return;
        }

        self.$store.commit('promo/setViewLoading', true);
        __WEBPACK_IMPORTED_MODULE_1__modules_api_promo__["a" /* default */].getViewList(self, id, function (res) {
          self.$store.commit('promo/setViewLoading', false);
        });
      });
    },
    onScroll: function onScroll(event) {
      this.showFixedHeader = event.target.scrollTop > 10;
    },
    toggleEdit: function toggleEdit() {
      if (this.edit) {
        this.edit = false;
      } else {
        var details = this.$store.state.promo.view.details;
        this.$store.commit('promo/setViewDetails', '');

        this.$store.commit('promo/setViewDetails', details);
        this.edit = true;
      }
    },
    save: function save() {
      if (this.$refs.viewEdit.save()) {
        this.$refs.viewEdit.save();
      }
    },
    exportPromo: function exportPromo(id) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1__modules_api_promo__["a" /* default */].getViewListFull(self, id, function (res) {
        console.log('EXPORT', res);
        exporter.downloadCsv(res);
      });
    },
    setScreenSize: function setScreenSize() {
      var self = this;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        self.isMobile = true;
      } else {
        self.isMobile = false;
      }
    }
  },
  watch: {
    // brandFormShow: function (value) {},
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_promo__ = __webpack_require__(62);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import promoList from './PromoList'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'promo-view-details',
  components: {},
  data: function data() {
    return {};
  },

  computed: {
    promo: function promo() {
      return this.$store.state.promo.view.details;
    }
  },
  methods: {
    init: function init() {}
  },
  watch: {
    // brandFormShow: function (value) {},
  },
  mounted: function mounted() {}
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_promo__ = __webpack_require__(62);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'promo-view-edit',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a },
  data: function data() {
    return {
      promoName: '',
      description: '',
      startDate: '',
      startDateHour: '',
      startDateMinute: '',
      expirationDate: '',
      expirationDateHour: '',
      expirationDateMinute: '',
      validDays: '',
      validNewUser: '1',
      code: '',
      amount: '',
      totalCodes: '',
      errorMsg: {
        promoName: '',
        startDate: '',
        startDateHour: '',
        startDateMinute: '',
        expirationDate: '',
        expirationDateHour: '',
        expirationDateMinute: '',
        validDays: '',
        code: '',
        amount: '',
        totalCodes: ''
      },
      today: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().subtract(1, 'days'),
      errorReturn: ''
    };
  },

  computed: {
    _promo: function _promo() {
      return this.$store.state.promo.view.details;
    },
    startDateDisabled: function startDateDisabled() {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(this.today.subtract(1, 'months').format('YYYY'), this.today.format('MM'), this.today.format('DD'))
        };
      }

      return {
        to: new Date(this.today.format('YYYY'), this.today.subtract(1, 'months').format('MM'), this.today.format('DD'))
      };
    },
    expirationDateDisabled: function expirationDateDisabled() {
      var date = this.startDate ? __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.startDate).add(1, 'days') : __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()();
      if (date.format('MM') === '01') {
        return {
          to: new Date(date.subtract(1, 'months').format('YYYY'), date.format('MM'), date.format('DD'))
        };
      }

      return {
        to: new Date(date.format('YYYY'), date.subtract(1, 'months').format('MM'), date.format('DD'))
      };
    },
    loading: function loading() {
      return this.$store.state.promo.view.saving;
    }
  },
  methods: {
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(date).format('MM/DD/YYYY');
    },
    save: function save() {
      var self = this;
      if (self.loading) {
        return;
      }

      if (self.validate()) {
        self.$store.commit('promo/setViewSaving', true);
        var startDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(self.startDate);
        startDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(startDate.format('MM/DD/YYYY ') + self.startDateHour + ':' + self.startDateMinute);
        var expirationDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(self.expirationDate);
        expirationDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(expirationDate.format('MM/DD/YYYY ') + self.expirationDateHour + ':' + self.expirationDateMinute);

        __WEBPACK_IMPORTED_MODULE_2__modules_api_promo__["a" /* default */].savePromoDetails(self, {
          id: self.$store.state.promo.view.details.id,
          name: self.promoName,
          description: self.description,
          startDate: startDate.format('YYYY-MM-DD HH:mm:ss'),
          expirationDate: expirationDate.format('YYYY-MM-DD HH:mm:ss'),
          validDays: self.validDays,
          validOnlyForNewUser: self.validNewUser === '1',
          promoCode: self.code,
          amount: self.amount,
          totalCodes: self.totalCodes
        }, function (res) {
          self.$store.commit('promo/setViewSaving', true);
          if (res.error) {
            self.errorReturn = res.error.message;
            return;
          }

          location.reload();
        });
      }
    },
    validate: function validate() {
      this.resetErrorMsg();
      var hasError = false;

      for (var field in this.errorMsg) {
        if (this[field] === '') {
          this.errorMsg[field] = 'This field cannot be empty.';
          hasError = true;
        }
        if (field === 'totalCodes' && parseInt(this[field]) < this._promo.totalCodes) {
          this.errorMsg[field] = 'The number of codes to redeem cannot be lower than the currently existing number of codes.';
          hasError = true;
        }
      }

      return !hasError;
    },
    resetErrorMsg: function resetErrorMsg() {
      this.errorMsg = {
        promoName: '',
        startDate: '',
        startDateHour: '',
        startDateMinute: '',
        expirationDate: '',
        expirationDateHour: '',
        expirationDateMinute: '',
        validDays: '',
        code: '',
        amount: '',
        totalCodes: ''
      };
    },
    leadingZero: function leadingZero(x) {
      return x < 10 ? '0' + x : x;
    }
  },
  watch: {
    _promo: function _promo(value) {
      this.promoName = value.name;
      this.description = value.description || '';

      var startDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(value.startDate, 'MM/DD/YYYY HH:mm');
      this.startDate = startDate.format('MM/DD/YYYY');
      this.startDateHour = startDate.format('HH');
      var startMinFix = parseInt(startDate.format('m')) % 5;
      this.startDateMinute = startDate.subtract(startMinFix, 'minutes').format('mm');

      var expirationDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(value.expirationDate, 'MM/DD/YYYY HH:mm');
      this.expirationDate = expirationDate.format('MM/DD/YYYY');
      this.expirationDateHour = expirationDate.format('HH');
      var expMinFix = parseInt(expirationDate.format('m')) % 5;
      this.expirationDateMinute = expirationDate.subtract(expMinFix, 'minutes').format('mm');

      this.validDays = value.validDays;
      this.validNewUser = value.validNewUser === 'Yes' ? '1' : '0';
      this.code = value.code;
      this.amount = value.amount;
      this.totalCodes = value.totalCodes;
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_promo__ = __webpack_require__(62);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'promo-view-list',
  props: ['showFixedHeader', 'isMobile'],
  components: {},
  data: function data() {
    return {};
  },

  computed: {
    promos: function promos() {
      return this.$store.state.promo.view.list;
    },
    loading: function loading() {
      return this.$store.state.promo.view.loading;
    },
    currentOrder: function currentOrder() {
      var promo = this.$store.state.promo.view;
      return { field: promo.order, asc: promo.orderAsc };
    },

    perPage: {
      get: function get() {
        return this.$store.state.promo.view.perPage;
      },
      set: function set(value) {
        this.$store.commit('promo/setViewPerPage', parseInt(value));
        this.$store.commit('promo/setViewCurrentPage', 1);
        this.getPromo();
      }
    },
    pageData: function pageData() {
      var tableData = this.$store.state.promo.view;
      var start = tableData.currentPage * tableData.perPage - (tableData.perPage - 1);
      var end = tableData.currentPage * tableData.perPage;
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      };
    },

    currentPage: {
      get: function get() {
        return this.$store.state.promo.view.currentPage;
      },
      set: function set(value) {
        this.$store.commit('promo/setViewCurrentPage', parseInt(value));
        this.getPromo();
      }
    },
    isLastPage: function isLastPage() {
      var promo = this.$store.state.promo.view;
      return promo.currentPage * promo.perPage >= promo.maxList;
    },
    totalPage: function totalPage() {
      var promo = this.$store.state.promo.view;
      return Math.ceil(promo.maxList / promo.perPage);
    }
  },
  methods: {
    init: function init() {},
    getPromo: function getPromo() {
      var self = this;
      self.$store.commit('promo/setViewLoading', true);
      var id = self.$route.params.id;
      __WEBPACK_IMPORTED_MODULE_0__modules_api_promo__["a" /* default */].getViewList(self, id, function (res) {
        self.$store.commit('promo/setViewLoading', false);
      });
    },
    prev: function prev() {
      if (this.currentPage === 1) {
        return;
      }
      this.$store.commit('promo/setViewCurrentPage', this.$store.state.promo.view.currentPage - 1);
      this.getPromo();
    },
    next: function next() {
      if (this.isLastPage) {
        return;
      }
      this.$store.commit('promo/setViewCurrentPage', this.$store.state.promo.view.currentPage + 1);
      this.getPromo();
    },
    sort: function sort(field) {
      var self = this;
      if (self.loading) {
        return;
      }
      var promo = self.$store.state.promo.view;
      if (field !== promo.order) {
        self.$store.commit('promo/setViewOrder', 1);
      } else {
        self.$store.commit('promo/setViewOrderAsc', promo.orderAsc === 1 ? 0 : 1);
      }
      self.$store.commit('promo/setViewOrder', field);
      self.getPromo();
    }
  },
  watch: {
    // brandFormShow: function (value) {},
  },
  mounted: function mounted() {}
});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DropZone__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PackagesControl__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PackagesTable__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Routing_PickupDateModal__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReservationsTable__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Header__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Map2__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RoutingModal__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Dispatch_ReadyToGoModal__ = __webpack_require__(109);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import RoutingMap from './Map'




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'routing-page',
  components: {
    DropZone: __WEBPACK_IMPORTED_MODULE_0__DropZone__["a" /* default */], PackagesControl: __WEBPACK_IMPORTED_MODULE_1__PackagesControl__["a" /* default */], PackagesTable: __WEBPACK_IMPORTED_MODULE_2__PackagesTable__["a" /* default */],
    ReservationsTable: __WEBPACK_IMPORTED_MODULE_4__ReservationsTable__["a" /* default */], RoutingHeader: __WEBPACK_IMPORTED_MODULE_5__Header__["a" /* default */], RoutingMap2: __WEBPACK_IMPORTED_MODULE_6__Map2__["a" /* default */],
    RoutingModal: __WEBPACK_IMPORTED_MODULE_7__RoutingModal__["a" /* default */], ReadyToGoModal: __WEBPACK_IMPORTED_MODULE_8__components_Dispatch_ReadyToGoModal__["a" /* default */], PickupDateModal: __WEBPACK_IMPORTED_MODULE_3__Routing_PickupDateModal__["a" /* default */]
  },
  data: function data() {
    return {
      activeTabIndex: 0,
      isMobile: false,
      showMapMobile: false
    };
  },

  computed: {
    route: function route() {
      return this.$route.name;
    }
  },
  methods: {
    onScrollUnpackage: function onScrollUnpackage(event) {
      var scrollAndView = event.target.scrollTop + event.target.offsetHeight;
      if (event.target.scrollHeight - scrollAndView < 150) {
        if (this.$refs.routingRsvpTable.onScroll()) {
          this.$refs.routingRsvpTable.onScroll();
        }
      }
    },
    onScrollPackage: function onScrollPackage(event) {
      var scrollAndView = event.target.scrollTop + event.target.offsetHeight;
      if (event.target.scrollHeight - scrollAndView < 150) {
        if (this.$refs.routingPkgTable.onScroll()) {
          this.$refs.routingPkgTable.onScroll();
        }
      }
    },
    setScreenSize: function setScreenSize() {
      var self = this;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        self.isMobile = true;
      } else {
        self.isMobile = false;
      }
    }
  },
  mounted: function mounted() {
    this.setScreenSize();
  }
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProviderRatingReport__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RsvpReport__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LAWAReport__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TrxReport__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SpecializeReport__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DirectBill__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DriverPayouts__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BackendManager__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mtech__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DailyRsvpReport__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BlockReport__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LGBReport__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ActiveDriverReport__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DriverCount__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LyftReport__ = __webpack_require__(1518);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */
// import moment from 'moment'





// import newrep from './NewSpecializeReport'











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reports',
  components: {
    DriverRatingReport: __WEBPACK_IMPORTED_MODULE_0__ProviderRatingReport__["a" /* default */], RsvpReport: __WEBPACK_IMPORTED_MODULE_1__RsvpReport__["a" /* default */], LawaReport: __WEBPACK_IMPORTED_MODULE_2__LAWAReport__["a" /* default */],
    TrxReport: __WEBPACK_IMPORTED_MODULE_3__TrxReport__["a" /* default */], SpecializeReport: __WEBPACK_IMPORTED_MODULE_4__SpecializeReport__["a" /* default */], DirectBill: __WEBPACK_IMPORTED_MODULE_5__DirectBill__["a" /* default */],
    DriverPayouts: __WEBPACK_IMPORTED_MODULE_6__DriverPayouts__["a" /* default */], BackendManager: __WEBPACK_IMPORTED_MODULE_7__BackendManager__["a" /* default */], Mtech: __WEBPACK_IMPORTED_MODULE_8__mtech__["a" /* default */],
    DailyRsvpReport: __WEBPACK_IMPORTED_MODULE_9__DailyRsvpReport__["a" /* default */], BlockReport: __WEBPACK_IMPORTED_MODULE_10__BlockReport__["a" /* default */], LgbReport: __WEBPACK_IMPORTED_MODULE_11__LGBReport__["a" /* default */],
    ActiveDrivers: __WEBPACK_IMPORTED_MODULE_12__ActiveDriverReport__["a" /* default */], DriverCount: __WEBPACK_IMPORTED_MODULE_13__DriverCount__["a" /* default */], LyftReport: __WEBPACK_IMPORTED_MODULE_14__LyftReport__["a" /* default */]
  },
  data: function data() {
    return {
      showDriverRatingReport: false,
      showBackendManger: false,
      showMtech: false,
      showDailyRsvpReport: false,
      showBlockReport: false,
      showLGBReport: false,
      showActiveDrivers: false,
      showDriverCount: false,
      showLyftReport: false
    };
  },

  computed: {
    showRsvpReport: function showRsvpReport() {
      return this.$store.state.reports.rsvpReport.show;
    },
    showTrxReport: function showTrxReport() {
      return this.$store.state.reports.trxReport.show;
    },
    showSpecializeReport: function showSpecializeReport() {
      return this.$store.state.reports.specializeReport.show;
    },
    showDirectBill: function showDirectBill() {
      return this.$store.state.reports.directBill.show;
    },
    showDriverPayouts: function showDriverPayouts() {
      return this.$store.state.reports.driverPayouts.show;
    },
    brands: function brands() {
      return this.$store.state.brands;
    },
    reportAccess: function reportAccess() {
      return this.$store.state.session.user.access;
    }
  },
  methods: {
    getAirportList: function getAirportList() {
      var self = this;
      if (self.$store.state.airports.list.length > 0) {
        return;
      }

      self.$store.commit('airports/setLoading', true);
      self.$sdk.get('/airports', {}, function (res) {
        self.$store.commit('airports/setLoading', false);
        var list = [];
        res.list.forEach(function (data) {
          var add1 = data.addressLine2 === null ? data.addressLine1 : data.addressLine2;
          var add2 = data.addressLine2 === null ? '' : data.addressLine1;
          var title = add2 + ' ' + add1 + ', ' + data.city + ', ' + data.state + ' ' + data.zipCode;
          if (data.enabled) {
            list.push({
              geofenceId: data.id,
              geofenceType: 'airport',
              address1: add1,
              address2: add2,
              city: data.city,
              lat: data.lat,
              lng: data.lng,
              state: data.state,
              title: data.name || title,
              zip: data.zipCode,
              description: data.description,
              airportCode: data.airportCode,
              locationId: data.locationId
            });
          }
        });
        self.$store.commit('airports/setList', list);
      });
    },
    getBrands: function getBrands() {
      var self = this;
      if (self.brands.loading || self.brands.list.length) return;

      self.$store.commit('brands/setLoading', true);
      self.$sdk.get('/brand', {}, function (res) {
        self.$store.commit('brands/setLoading', false);
        var brands = [];
        res.forEach(function (data) {
          brands.push({ id: data.id, name: data.name });
        });
        self.$store.commit('brands/setList', brands);
      });
    }
  },
  mounted: function mounted() {
    var self = this;
    self.getAirportList();
    self.getBrands();

    if (!self.$store.state.brands.list.length) {
      self.$sdk.get('/brand', {}, function (res) {
        if (res.error) {
          return;
        }

        if (res.length) {
          self.$store.commit('brands/setList', res);
        }
      });
    }

    setTimeout(function () {
      if (!self.reportAccess.PageAdminReports || self.reportAccess.PageAdminReports && self.reportAccess.PageAdminReports === '') {
        self.$router.push('/accessdenied');
      }
    }, 1000);
  }
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_csvexport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_api_featureToggle__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'specialize-report',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default.a },
  data: function data() {
    return {
      from: null,
      to: null,
      error: {
        show: false,
        message: '',
        empty: []
      },
      selectedReports: {
        byRating: false,
        driverRelease: false
      },
      reportStatus: {
        byRating: '',
        driverRelease: ''
      },
      pdf: {
        code: '',
        class: '',
        title: '',
        date: '',
        table: {
          label: [],
          data: {},
          extra: {},
          total: {}
        },
        maxRecordPerPage: 40,
        list: [],
        current: '',
        loading: false
      },
      orientation: [], // if landscape
      pdfChecked: true,
      csvChecked: false,
      rating: '',
      formatError: false,
      csv: {
        label: [],
        data: [],
        list: [],
        total: {}
      },
      isIOS: navigator.userAgent.match(/(iPad|iPhone|iPod)/g)
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.reports.rsvpReport.show;
    },
    highlightedDates: function highlightedDates() {
      var self = this;
      var result = { to: null, from: null };

      if (self.from !== null) {
        result.from = self.from;
      }
      if (self.to !== null) {
        result.to = self.to;
      }
      return result;
    },
    totalPage: function totalPage() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.pdf.table.data).length;
    },
    admins: function admins() {
      var _this = this;

      return this.$store.state.reservationNotes.admins.filter(function (x) {
        return x.name.toLowerCase().includes(_this.searchAdmin.toLowerCase());
      });
    }
  },
  methods: {
    isValid: function isValid() {
      var self = this;
      self.error.show = false;
      self.error.empty = [];
      if (self.from === null || self.to === null) {
        self.error.show = true;
        self.error.message = 'Please specify the Start and End dates.';
        return false;
      }

      var from = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.from);
      var to = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.to);

      if (from.isAfter(to)) {
        self.error.show = true;
        self.error.message = 'End date must be after Start date.';
        return false;
      }

      self.formatError = false;
      if (!self.pdfChecked && !self.csvChecked) {
        self.error.show = true;
        self.error.message = 'Please select which file format.';
        self.formatError = true;
        return false;
      }

      if (!self.selectedReports.byRating && !self.selectedReports.driverRelease) {
        self.error.show = true;
        self.error.message = 'Please select at least one report type.';
        return false;
      }

      // if (self.selectedReports.cancellationReport && self.pdfChecked) {
      //   self.error.show = true
      //   self.error.message = 'Only CSV format is allowed for Cancellation Report.'
      //   return false
      // }

      return true;
    },
    getNewDoc: function getNewDoc() {
      var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
      });
      doc.setFont('helvetica');
      return doc;
    },
    startProcess: function startProcess() {
      if (!this.isValid()) {
        return;
      }

      this.pdf.list = [];
      this.csv.list = [];
      for (var report in this.selectedReports) {
        if (this.selectedReports[report]) {
          this.reportStatus[report] = 'on-queue';
          this.pdf.list.push(report);
          this.csv.list.push(report);
        }
      }

      this.pdf.loading = true;
      this.generateReport();
    },
    generateReport: function generateReport() {
      var isCsv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if ((!this.pdf.list.length && this.pdfChecked || !this.pdfChecked) && (!this.csv.list.length && this.csvChecked || !this.csvChecked)) {
        this.pdf.loading = false;
        return;
      }

      if (isCsv) {
        console.log('Processing:', this.csv.list[0]);
        this.getDataReports(this.csv.list[0]);
      } else {
        console.log('Processing:', this.pdf.list[0]);
        this.getDataReports(this.pdf.list[0]);
      }
    },
    getDataReports: function getDataReports(type) {
      var self = this;
      self.reportStatus[type] = 'loading';
      var orientationMax = self.orientation;
      self.pdf.maxRecordPerPage = orientationMax.indexOf(type) > -1 ? 25 : 40;
      self.$sdk.get(self.apiParams(type).url, self.apiParams(type).data, function (r) {
        // console.log('---', r)
        // return
        if (r.error) {
          self.reportStatus[type] = 'has-error';
          return;
        }

        self.setPdfLabel(type);
        self.pdf.table.data = {};
        self.pdf.table.extra = {};
        self.pdf.table.total = {};
        self.csv.data = [];
        self.csv.total = {};

        if (r.list.length > 0) {
          self.buildPdfData(type, r.list);
        } else {
          self.error.show = true;
          self.error.empty.push(self.reportLabel(type));
          self.reportStatus[type] = 'has-error';
          self.pdf.list.shift();
          self.csv.list.shift();
          self.generateReport();
        }
      });
    },
    apiParams: function apiParams(type) {
      var url = '';
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.to);
      var data = {
        token: this.$store.state.session.sessionToken,
        since: start.format('YYYY-MM-DD'),
        until: end.format('YYYY-MM-DD')
      };

      switch (type) {
        case 'byRating':
          url = '/reports/ratings';
          data.filter = 'ratingTime';
          data.order = 'created';
          data.asc = 0;
          data.value = this.rating;
          break;
        case 'driverRelease':
          url = '/reports/drivers/release';
          break;
      }
      return { url: url, data: data };
    },
    setPdfLabel: function setPdfLabel(type) {
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.to);
      var dateRange = start.format('MM/DD/YYYY') + ' - ' + end.format('MM/DD/YYYY');

      this.pdf.code = type;
      if (type === 'byRating') {
        this.pdf.class = 'report-rating';
        this.pdf.title = 'Opoli Driver Reviews';
        this.pdf.date = dateRange;
        this.pdf.table.label = ['Date', 'Reservation ID', 'Driver ID', 'Driver Name', 'Rating', 'Reviewer ID', 'Reviewed By'];
      }

      if (type === 'driverRelease') {
        this.pdf.class = 'report-release';
        this.pdf.title = 'Opoli Driver Release';
        this.pdf.date = dateRange;
        this.pdf.table.label = ['Driver ID', 'Driver Name', 'RSVP ID', 'Pickup Date', 'Release Date', 'Cancellation Fee'];
      }
    },
    buildPdfData: function buildPdfData(type, pdfData) {
      var self = this;
      var groupCount = 0;
      var page = 1;

      // driverRelease
      var totalCxlFee = 0;

      pdfData.forEach(function (data, index) {
        if (!self.pdf.table.data['page' + page]) {
          self.pdf.table.data['page' + page] = [];
        }

        self.pdf.table.data['page' + page].push(self.buildTableData(type, data, 'pdf'));
        if (self.csvChecked) {
          self.csv.data.push(self.buildCsvData(type, data));
        }
        groupCount++;

        if (type === 'driverRelease') {
          totalCxlFee += data.cancelFee;
        }

        if ((index + 1) % self.pdf.maxRecordPerPage === 0 && pdfData.length !== index + 1) {
          page++;
        }
      });

      self.pdf.table.total.record = pdfData.length;
      if (type === 'driverRelease') {
        self.pdf.table.total.cxlFee = self.covertNumber(totalCxlFee.toFixed(2));
      }

      if (self.pdfChecked) {
        self.processDownloads('pdf', { type: type, page: page });
      } else {
        self.processDownloads('csv', { type: type });
      }
    },
    buildTableData: function buildTableData(type, data, format) {
      var self = this;
      if (type === 'byRating') {
        var temp = {
          date: __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.created).format('MM/DD/YYYY  HH:mm'),
          rsvpId: data.rsvpId,
          driverId: data.driverId,
          driver: data.driverName,
          rating: data.rating,
          customerId: data.customerId,
          customer: data.customerName
        };
        if (format === 'csv') {
          temp.message = data.message;
        }
        return temp;
      }
      if (type === 'driverRelease') {
        return {
          id: data.driverId,
          name: data.firstName + ' ' + data.lastName,
          rsvpId: data.rsvpId,
          pickupDate: __WEBPACK_IMPORTED_MODULE_2_moment___default.a.tz(data.pickupTime, 'YYYY-MM-DD@HH:mm', 'America/Los_Angeles').format('MM/DD/YYYY  HH:mm'),
          releaseDate: __WEBPACK_IMPORTED_MODULE_2_moment___default.a.tz(data.releaseTime, 'YYYY-MM-DD@HH:mm', 'America/Los_Angeles').format('MM/DD/YYYY  HH:mm'),
          cancellationFee: parseFloat(data.cancelFee).toFixed(2)
        };
      }
    },
    fileName: function fileName(type, format) {
      var timestamp = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.from).format('YYYYMMDD') + '_' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.to).format('YYYYMMDD');
      switch (type) {
        case 'byRating':
          return 'driver_review_' + timestamp + '.' + format;
        case 'driverRelease':
          return 'driver_release_' + timestamp + '.' + format;
      }
    },
    currentPage: function currentPage(page) {
      return page.substring(4);
    },
    processPdf: function processPdf(type, page) {
      var self = this;
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.to);
      var pageAsyncs = [];
      var landscapeReports = self.orientation;
      var orientation = landscapeReports.indexOf(type) > -1 ? 'l' : 'p';
      var pdf = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a({ orientation: orientation, unit: 'mm', format: 'a4' });

      window.scrollTo(500, 0);
      document.body.style.overflow = 'hidden';

      setTimeout(function () {
        if (self.isIOS) page = page + 1;

        var _loop = function _loop(i) {
          // self.pdf.current = 'page' + (i + 1)
          pageAsyncs.push(__WEBPACK_IMPORTED_MODULE_4_html2canvas___default()(document.getElementsByClassName('page' + (i + 1))[0], {
            scale: "1"
          }).then(function (canvas) {
            var imgData = canvas.toDataURL('image/png', 1.0);
            pdf.addImage(imgData, 'PNG', 0, 0);
            if (i + 1 !== page) {
              pdf.addPage();
            }
          }).catch(function (e) {
            self.reportStatus[type] = 'has-error';
            self.pdf.list.shift();
            document.body.style.overflow = 'auto';
            self.processDownloads('csv', { type: type });
            console.warn(e);
          }));
        };

        for (var i = 0; i < page; i++) {
          _loop(i);
        }

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(pageAsyncs).then(function () {
          var timestamp = start.format('YYYYMMDD') + '_' + end.format('YYYYMMDD');
          pdf.save(self.fileName(type, 'pdf'));
          self.reportStatus[type] = 'success';
          self.pdf.list.shift();
          document.body.style.overflow = 'auto';
          self.processDownloads('csv', { type: type });
        });
      }, 500);
    },
    covertNumber: function covertNumber(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    resetSelectedStatus: function resetSelectedStatus() {
      this.selectedReports = {
        byRating: false,
        driverRelease: false
      };
    },
    resetReportStatus: function resetReportStatus() {
      this.error.show = false;
      this.error.empty = [];
      this.reportStatus = {
        byRating: '',
        driverRelease: ''
      };
    },
    reportLabel: function reportLabel(type) {
      switch (type) {
        case 'byRating':
          return 'Driver Review By Review Score';
        case 'driverRelease':
          return 'Driver Release';
      }
    },
    buildCsvData: function buildCsvData(type, data) {
      var column = [];
      this.pdf.table.label.forEach(function (i) {
        column.push(i.replace('<br/>', ''));
      });
      if (type === 'byRating') {
        column.push('Comment');
      }
      this.csv.label = column;

      var csvData = {};
      var pdfData = this.buildTableData(type, data, 'csv');

      var i = 0;
      for (var key in pdfData) {
        csvData[column[i]] = pdfData[key];
        i++;
      }
      return csvData;
    },
    processDownloads: function processDownloads(action, data) {
      if (action === 'pdf' && this.pdfChecked) {
        this.processPdf(data.type, data.page);
      } else if (action === 'csv' && this.csvChecked) {
        this.processCsv(data.type);
      } else {
        this.generateReport();
      }
    },
    processCsv: function processCsv(type) {
      var exporter = __WEBPACK_IMPORTED_MODULE_6_csvexport___default.a.create({
        filename: this.fileName(type, 'csv'),
        columns: this.csv.label
      });

      // add total
      this.csv.data.push(this.buildCsvTotal(type));

      exporter.downloadCsv(this.csv.data);
      this.reportStatus[type] = 'success';
      this.csv.list.shift();

      this.generateReport(true);
    },
    buildCsvTotal: function buildCsvTotal(type) {
      var csvData = {};
      var totalData = this.pdf.table.total;

      if (type === 'driverRelease') {
        csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')';
        csvData[this.csv.label[1]] = '';
        csvData[this.csv.label[2]] = '';
        csvData[this.csv.label[3]] = '';
        csvData[this.csv.label[4]] = '';
        csvData[this.csv.label[5]] = totalData.cxlFee;
      }

      return csvData;
    },
    formatCheck: function formatCheck() {
      this.error.show = false;
      this.formatError = false;
    }
  },
  watch: {
    show: function show(value) {
      if (!value) {
        return;
      }

      this.from = null;
      this.to = null;
      this.error.show = false;
      this.error.empty = [];

      this.resetSelectedStatus();
      this.resetReportStatus();
    },
    from: function from(value) {
      this.resetReportStatus();
    },
    to: function to(value) {
      this.resetReportStatus();
    },
    'selectedReports.byRating': function selectedReportsByRating(value) {
      this.resetReportStatus();
    },
    'selectedReports.driverRelease': function selectedReportsDriverRelease(value) {
      this.resetReportStatus();
    }
  }
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_csvexport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_api_services__ = __webpack_require__(6);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rsvp-report',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default.a },
  data: function data() {
    return {
      dateType: 'bookingTime',
      from: null,
      to: null,
      isLoading: false,
      error: {
        show: false,
        message: '',
        empty: []
      },
      selectedReports: {
        rsvpSummary: false,
        rsvpSummaryWeekly: false,
        rsvpByDate: false,
        rsvpByRefund: false,
        rsvpByDriver: false,
        rsvpByDriverFare: false,
        rsvpByServiceType: false,
        rsvpByAirport: false,
        rsvpByAirportDepArr: false,
        rsvpByGroup: false,
        variance: false,
        rsvpByPayment: false,
        rsvpByTripStatus: false,
        rsvpByBrands: false,
        rsvpSummaryCorporate: false,
        rsvpCorporate: false,
        rsvpTerminal: false,
        creditConverted: false,
        bySector: false
      },
      summaryReportStatus: [{ value: 'all', label: 'All' }, { value: 'purchased', label: 'Purchased' }, { value: 'completed', label: 'Completed' }, { value: 'promo', label: 'Promo' }, { value: 'canceled', label: 'Canceled' }, { value: 'noshow', label: 'No Show' }],
      detailedReportStatus: [{ value: 'all', label: 'All' }, { value: 'purchased', label: 'Booked' }, { value: 'completed', label: 'Completed' }, { value: 'canceled', label: 'Canceled' }],
      reportStatus: {
        rsvpSummary: '',
        rsvpSummaryWeekly: '',
        rsvpByDate: '',
        rsvpByRefund: '',
        rsvpByDriver: '',
        rsvpByDriverFare: '',
        rsvpByServiceType: '',
        rsvpByAirport: '',
        rsvpByAirportDepArr: '',
        rsvpByGroup: '',
        variance: '',
        rsvpByPayment: '',
        rsvpByTripStatus: '',
        rsvpByBrands: '',
        rsvpSummaryCorporate: '',
        rsvpCorporate: '',
        rsvpTerminal: '',
        creditConverted: '',
        bySector: ''
      },
      pdf: {
        code: '',
        class: '',
        title: '',
        date: '',
        table: {
          label: [],
          data: {},
          extra: {},
          total: {}
        },
        maxRecordPerPage: 40,
        list: [],
        current: '',
        loading: false
      },
      selectedSummary: 'all',
      selectedDetailed: 'all',
      selectedAirport: 0,
      orientation: ['rsvpSummary', 'rsvpByDate', 'rsvpByRefund', 'rsvpByDriver', 'rsvpByDriverFare', 'rsvpByServiceType', 'rsvpByGroup', 'variance', 'rsvpByTripStatus', 'rsvpByBrands', 'rsvpSummaryCorporate', 'rsvpCorporate', 'creditConverted', 'bySector'],
      pdfChecked: true,
      csvChecked: false,
      formatError: false,
      csv: {
        label: [],
        data: [],
        list: [],
        total: {},
        summaryWeeklyLabel: [],
        terminalLabel: []
      },
      allBrands: [2, 3, 4, 5, 8, 10, 11, 12],
      isIOS: navigator.userAgent.match(/(iPad|iPhone|iPod)/g),
      bySectorStatus: ''
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.reports.rsvpReport.show;
    },
    highlightedDates: function highlightedDates() {
      var self = this;
      var result = {
        to: null,
        from: null
      };
      if (self.from !== null) {
        result.from = self.from;
      }
      if (self.to !== null) {
        result.to = self.to;
      }
      return result;
    },
    totalPage: function totalPage() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.pdf.table.data).length;
    },
    isRsvpSummary: function isRsvpSummary() {
      return this.pdf.code === 'rsvpSummary' && this.totalPage;
    },
    isRsvpByDate: function isRsvpByDate() {
      return this.pdf.code === 'rsvpByDate' && this.totalPage;
    },
    isRsvpByRefund: function isRsvpByRefund() {
      return this.pdf.code === 'rsvpByRefund' && this.totalPage;
    },
    isRsvpByDriver: function isRsvpByDriver() {
      return this.pdf.code === 'rsvpByDriver' && this.totalPage;
    },
    isRsvpByDriverFare: function isRsvpByDriverFare() {
      return this.pdf.code === 'rsvpByDriverFare' && this.totalPage;
    },
    isDriverReservations: function isDriverReservations() {
      var accept = ['rsvpByDriver', 'rsvpByDriverFare'];
      return accept.indexOf(this.pdf.code) > -1 && this.totalPage;
    },
    isServiceReservations: function isServiceReservations() {
      return this.pdf.code === 'rsvpByServiceType' && this.totalPage;
    },
    isAirportReservations: function isAirportReservations() {
      return this.pdf.code === 'rsvpByAirport' && this.totalPage;
    },
    isRsvpSummaryWeekly: function isRsvpSummaryWeekly() {
      return this.pdf.code === 'rsvpSummaryWeekly' && this.totalPage;
    },
    isRsvpByAirportDepArr: function isRsvpByAirportDepArr() {
      return this.pdf.code === 'rsvpByAirportDepArr' && this.totalPage;
    },
    isRsvpByGroup: function isRsvpByGroup() {
      return this.pdf.code === 'rsvpByGroup' && this.totalPage;
    },
    isVariance: function isVariance() {
      return this.pdf.code === 'variance' && this.totalPage;
    },
    isRsvpByPayment: function isRsvpByPayment() {
      return this.pdf.code === 'rsvpByPayment' && this.totalPage;
    },
    isRsvpByTripStatus: function isRsvpByTripStatus() {
      return this.pdf.code === 'rsvpByTripStatus' && this.totalPage;
    },
    isRsvpByBrands: function isRsvpByBrands() {
      return this.pdf.code === 'rsvpByBrands' && this.totalPage;
    },
    isRsvpSummaryCorporate: function isRsvpSummaryCorporate() {
      return this.pdf.code === 'rsvpSummaryCorporate' && this.totalPage;
    },
    isRsvpCorporate: function isRsvpCorporate() {
      return this.pdf.code === 'rsvpCorporate' && this.totalPage;
    },
    isRsvpTerminal: function isRsvpTerminal() {
      return this.pdf.code === 'rsvpTerminal' && this.totalPage;
    },
    isCreditConverted: function isCreditConverted() {
      return this.pdf.code === 'creditConverted' && this.totalPage;
    },
    airports: function airports() {
      return this.$store.state.airports.list;
    },
    brands: function brands() {
      return this.$store.state.brands;
    }
  },
  methods: {
    isValid: function isValid() {
      var self = this;
      self.error.show = false;
      self.error.empty = [];
      if (self.from === null || self.to === null) {
        self.error.show = true;
        self.error.message = 'Please specify the Start and End dates.';
        return false;
      }

      var from = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.from);
      var to = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.to);

      if (from.isAfter(to)) {
        self.error.show = true;
        self.error.message = 'End date must be after Start date.';
        return false;
      }

      self.formatError = false;
      if (!self.pdfChecked && !self.csvChecked) {
        self.error.show = true;
        self.error.message = 'Please select which file format.';
        self.formatError = true;
        return false;
      }

      if (self.pdfChecked && self.selectedReports.bySector) {
        self.error.show = true;
        self.error.message = 'Only CSV format is allowed for Reservation by Sector Report.';
        return false;
      }

      if (!self.selectedReports.rsvpSummary && !self.selectedReports.rsvpByDate && !self.selectedReports.rsvpByDriver && !self.selectedReports.rsvpByDriverFare && !self.selectedReports.rsvpByServiceType && !self.selectedReports.rsvpByAirport && !self.selectedReports.rsvpSummaryWeekly && !self.selectedReports.rsvpByAirportDepArr && !self.selectedReports.rsvpByGroup && !self.selectedReports.rsvpByRefund && !self.selectedReports.variance && !self.selectedReports.rsvpByPayment && !self.selectedReports.rsvpByTripStatus && !self.selectedReports.rsvpByBrands && !self.selectedReports.rsvpSummaryCorporate && !self.selectedReports.rsvpCorporate && !self.selectedReports.rsvpTerminal && !self.selectedReports.creditConverted && !self.selectedReports.bySector) {
        self.error.show = true;
        self.error.message = 'Please select at least one report type.';
        return false;
      }

      if (self.selectedReports.rsvpByAirportDepArr && self.selectedAirport === 0) {
        self.error.show = true;
        self.error.message = 'Please select an airport.';
        return false;
      }

      return true;
    },
    getNewDoc: function getNewDoc() {
      var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
      });
      doc.setFont('helvetica');
      return doc;
    },
    startProcess: function startProcess() {
      if (!this.isValid()) {
        return;
      }

      this.pdf.list = [];
      this.csv.list = [];
      for (var report in this.selectedReports) {
        if (this.selectedReports[report]) {
          this.reportStatus[report] = 'on-queue';
          this.pdf.list.push(report);
          this.csv.list.push(report);
        }
      }

      this.pdf.loading = true;
      this.generateReport();
    },
    generateReport: function generateReport() {
      var isCsv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if ((!this.pdf.list.length && this.pdfChecked || !this.pdfChecked) && (!this.csv.list.length && this.csvChecked || !this.csvChecked)) {
        this.pdf.loading = false;
        return;
      }

      if (isCsv) {
        console.log('Processing:', this.csv.list[0]);
        this.getDataReports(this.csv.list[0]);
      } else {
        console.log('Processing:', this.pdf.list[0]);
        this.getDataReports(this.pdf.list[0]);
      }
    },
    getDataReports: function getDataReports(type) {
      var _this = this;

      var self = this;
      self.reportStatus[type] = 'loading';
      self.isLoading = true;
      var orientationMax = self.orientation;
      self.pdf.maxRecordPerPage = orientationMax.indexOf(type) > -1 ? 25 : 40;
      self.$sdk.get(self.apiParams(type).url, self.apiParams(type).data, function (r) {
        self.isLoading = false;
        if (r.error) {
          self.reportStatus[type] = 'has-error';
          return;
        }

        self.setPdfLabel(type);
        self.pdf.table.data = {};
        self.pdf.table.extra = {};
        self.pdf.table.total = {};
        self.csv.data = [];
        self.csv.total = {};

        var isEmptyTerminalResult = true;
        if (type === 'rsvpTerminal') {
          r.list.forEach(function (data, index) {
            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data.terminals).length) {
              isEmptyTerminalResult = false;
            }
          });
        }

        if (type === 'rsvpTerminal' && isEmptyTerminalResult) {
          self.error.show = true;
          self.error.empty.push(self.reportLabel(type));
          self.reportStatus[type] = 'has-error';
          self.pdf.list.shift();
          self.csv.list.shift();
          self.generateReport();
          return;
        }

        if (type === 'creditConverted' && _this.dateType === 'completeTime') {
          r.list = [];
        }

        if (type === 'bySector') {
          self.buildSectorData(r);
          return;
        }

        if (r.list.length > 0) {
          self.buildPdfData(type, r.list);
        } else {
          self.error.show = true;
          self.error.empty.push(self.reportLabel(type));
          self.reportStatus[type] = 'has-error';
          self.pdf.list.shift();
          self.csv.list.shift();
          self.generateReport();
        }
      });
    },
    apiParams: function apiParams(type) {
      var url = '';
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.to);
      var data = {
        token: this.$store.state.session.sessionToken,
        since: start.format('YYYY-MM-DD'),
        until: end.format('YYYY-MM-DD')
      };

      switch (type) {
        case 'rsvpSummary':
          url = '/reports/rsvp/daily';
          data.status = this.selectedSummary === 'all' ? null : this.selectedSummary;
          break;
        case 'rsvpByDate':
          url = '/reports/rsvp/list';
          data.status = this.selectedDetailed === 'all' ? null : this.selectedDetailed;
          break;
        case 'rsvpByRefund':
          url = '/reports/rsvp/refund';
          break;
        case 'rsvpByDriver':
          url = '/reports/drivers';
          data.status = 'completed';
          break;
        case 'rsvpByDriverFare':
          url = '/reports/drivers';
          data.status = 'completed';
          data.order = 'fareSum';
          data.asc = 0;
          break;
        case 'rsvpByServiceType':
          url = '/reports/services';
          data.order = 'brandId';
          break;
        case 'rsvpByAirport':
          url = '/reports/airports';
          break;
        case 'rsvpSummaryWeekly':
          url = '/reports/rsvp/daytime';
          break;
        case 'rsvpByAirportDepArr':
          url = '/reports/airports/daily';
          data.geofenceId = this.selectedAirport;
          break;
        case 'rsvpByGroup':
          url = '/reports/promos';
          break;
        case 'variance':
          url = '/reports/rsvp/variance';
          break;
        case 'rsvpByPayment':
          url = '/reports/payments';
          break;
        case 'rsvpByTripStatus':
          url = '/reports/rsvp/status';
          break;
        case 'rsvpByBrands':
          url = '/reports/brands';
          break;
        case 'rsvpSummaryCorporate':
          url = '/reports/corporate/list';
          break;
        case 'rsvpCorporate':
          url = '/reports/corporate/rsvp';
          break;
        case 'rsvpTerminal':
          url = '/reports/terminals';
          break;
        case 'creditConverted':
          url = '/reports/rsvp/converted';
          break;
        case 'bySector':
          url = '/reports/bysector';
          // data.status = this.bySectorStatus
          break;
      }

      data.filter = this.dateType;
      return { url: url, data: data };
    },
    setPdfLabel: function setPdfLabel(type) {
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.to);
      var dateRange = start.format('MM/DD/YYYY') + ' - ' + end.format('MM/DD/YYYY');

      this.pdf.code = type;

      if (type === 'rsvpSummary') {
        this.pdf.class = 'rsvp-summary';
        this.pdf.title = 'Opoli Reservation Summary';
        this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')';
        this.pdf.table.label = ['Date', 'RSVP <br/>Count', 'ASAP', 'Web <br/>Bookings', 'Admin', 'Consumer <br/>App', 'Go Res', 'Total <br/>PAX', 'Avg <br/>Passengers', 'Total Fare', 'Avg <br/>Fare', 'Avg <br/>Fare PP'];

        if (this.selectedSummary === 'purchased') {
          this.pdf.date = 'By Booking Date (' + dateRange + ')';
        } else if (this.selectedSummary === 'completed') {
          this.pdf.date = 'By Completion Date (' + dateRange + ')';
        } else if (this.selectedSummary === 'canceled') {
          this.pdf.date = 'By Cancellation Date (' + dateRange + ')';
          this.pdf.table.label.push('Cancellation <br/>Fee');
        } else if (this.selectedSummary === 'promo') {
          this.pdf.table.label.push('Promo <br/>Amount');
        } else if (this.selectedSummary === 'noshow') {
          this.pdf.table.label.push('No Show <br/>Fee');
        }
      }

      if (type === 'rsvpByDate') {
        this.pdf.class = 'rsvp-by-date';
        this.pdf.title = 'Opoli Reservation By Date';
        this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')';
        this.pdf.table.label = ['ID', 'Name', 'Source', 'Service', 'Pickup Time', 'Pickup Location', 'Dropoff Location', 'Flight', 'Flight <br/>Type', 'PAX', 'Fare'];
        if (this.selectedDetailed === 'purchased') {
          this.pdf.date = 'By Booking Date (' + dateRange + ')';
        } else if (this.selectedDetailed === 'completed') {
          this.pdf.date = 'By Completion Date (' + dateRange + ')';
        } else if (this.selectedDetailed === 'canceled') {
          this.pdf.date = 'By Cancellation Date (' + dateRange + ')';
        }
        if (['completed', 'canceled'].indexOf(this.selectedDetailed) === -1) {
          this.pdf.table.label.push('Status');
        }
        if (this.selectedDetailed === 'canceled' || this.dateType === 'cancelTime') {
          this.pdf.table.label.push('Cancellation <br/>Fee');
        }
      }

      if (type === 'rsvpByRefund') {
        this.pdf.class = 'rsvp-by-refund';
        this.pdf.title = 'Opoli Reservation By Refund';
        this.pdf.date = 'By Refund Date (' + dateRange + ')';
        this.pdf.table.label = ['ID', 'Name', 'Direction', 'Service', 'Pickup Time', 'Refunded Date', 'Pickup Location', 'Dropoff Location', 'PAX', 'Fare', 'Refunded <br/>Amount'];
      }

      if (type === 'rsvpByDriver') {
        this.pdf.class = 'driver-rsvp';
        this.pdf.title = 'Opoli Reservations By Driver';
        if (type === 'rsvpByDriverFare') {
          this.pdf.title = this.pdf.title + ' (Fare)';
        }
        this.pdf.date = 'By Completion Date (' + dateRange + ')';
        this.pdf.table.label = ['Driver', 'Total <br/>Distance', 'RSVP <br/>Count', 'ASAP', 'Web <br/>Bookings', 'Admin', 'Consumer <br/>App', 'Go <br/>Res', 'Total <br/>PAX', 'Avg <br/>PAX', 'Duty <br/>Hours', 'Total <br/>Fare', 'Avg <br/>Fare', 'Avg <br/>Fare PP', 'Driver <br/>Payment', 'Driver %'];
      }
      if (type === 'rsvpByDriverFare') {
        this.pdf.class = 'driver-rsvp';
        this.pdf.title = 'Opoli Reservations By Driver (Fare)';
        this.pdf.date = 'By Completion Date (' + dateRange + ')';
        this.pdf.table.label = ['Driver', 'RSVP <br/>Count', 'ASAP', 'Web <br/>Bookings', 'Admin', 'Consumer <br/>App', 'Go <br/>Res', 'Total <br/>PAX', 'Avg <br/>PAX', 'Duty <br/>Hours', 'Total <br/>Fare', 'Avg <br/>Fare', 'Avg <br/>Fare PP', 'Driver <br/>Payment', 'Driver %'];
      }

      if (type === 'rsvpByServiceType') {
        this.pdf.class = 'service-rsvp';
        this.pdf.title = 'Opoli Reservations By Service Type';
        this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')';
        this.pdf.table.label = ['Service Type', 'RSVP <br/>Count', 'ASAP', 'Web <br/>Bookings', 'Admin', 'Consumer <br/>App', 'Go Res', 'Total <br/>PAX', 'Avg <br/>PAX', 'Total Fare', 'Avg <br/>Fare', 'Avg <br/>Fare PP'];
      }

      if (type === 'rsvpByAirport') {
        this.pdf.class = 'airport-rsvp';
        this.pdf.title = 'Opoli Reservations By Airport';
        this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')';
        this.pdf.table.label = ['Airport', 'RSVP <br/>Count', 'ASAP', 'One Way <br/>RSVP', 'Round Trip <br/>RSVP', 'Round Trip <br/>Instances', 'Total RSVP <br/>Instances ', 'One Way <br/>RSVP (%)', 'Round Trip <br/>RSVP (%)'];
      }

      if (type === 'rsvpSummaryWeekly') {
        this.pdf.class = 'weekly-summary';
        this.pdf.title = 'Opoli Reservations Weekly Summary';
        this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')';
      }

      if (type === 'rsvpByAirportDepArr') {
        this.pdf.class = 'airport-rsvp-deparr';
        this.pdf.title = 'Opoli Reservations By Airport (Departure/Arrival)';
        this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')';
        this.pdf.table.label = ['Date', 'Departure RSVP', 'Arrival RSVP', 'Total RSVP', 'Departure PAX', 'Arrival PAX', 'Total PAX'];
      }

      if (type === 'rsvpByGroup') {
        this.pdf.class = 'promo-rsvp';
        this.pdf.title = 'Opoli Reservations By Group';
        this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')';
        this.pdf.table.label = ['Group <br/>(Direct Bill)', 'RSVP <br/>Count', 'ASAP', 'Web <br/>Bookings', 'Admin', 'Consumer <br/>App', 'Go Res', 'Total <br/>PAX', 'Avg <br/>PAX', 'Total Fare', 'Avg <br/>Fare', 'Avg <br/>Fare PP'];
      }

      if (type === 'variance') {
        this.pdf.class = 'variance-table';
        this.pdf.title = 'Opoli Reservations - Variance';
        this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')';
        this.pdf.table.label = ['ID', 'Pickup Time', 'Name', 'Pickup', 'Dropoff', 'PAX', 'Payment <br/>Type', 'Fare', 'CC', 'Other', 'Variance'];
      }

      if (type === 'rsvpByPayment') {
        this.pdf.class = 'payment-rsvp';
        this.pdf.title = 'Opoli Reservations By Payment Type and Source';
        this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')';
        this.pdf.table.label = ['Payment Method', 'RSVP Count', 'Passengers', 'Charged', 'Gratuity'];
      }

      if (type === 'rsvpByTripStatus') {
        this.pdf.class = 'status-rsvp';
        this.pdf.title = 'Opoli Reservations By Trip Status';
        this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')';
        this.pdf.table.label = ['Trip Status', 'RSVP <br/>Count', 'ASAP', 'Web <br/>Bookings', 'Admin', 'Consumer <br/>App', 'Go Res', 'Total <br/>PAX', 'Avg <br/>PAX', 'Total Fare', 'Avg <br/>Fare', 'Avg <br/>Fare PP'];
      }

      if (type === 'rsvpByBrands') {
        this.pdf.class = 'brands-rsvp';
        this.pdf.title = 'Opoli Reservations By Brands';
        this.pdf.table.label = ['Brand', 'RSVP <br/>Count', 'ASAP', 'Web <br/>Bookings', 'Admin', 'Consumer <br/>App', 'Go Res', 'Total <br/>PAX', 'Avg <br/>PAX', 'Total Fare', 'Avg <br/>Fare', 'Avg <br/>Fare PP'];
      }

      if (type === 'rsvpSummaryCorporate') {
        this.pdf.class = 'summary-corporate-rsvp';
        this.pdf.title = 'Opoli Reservation Summary by Corporate Profile';
        this.pdf.table.label = ['Corporate', 'RSVP <br/>Count', 'ASAP', 'Web <br/>Bookings', 'Admin', 'Consumer <br/>App', 'Go Res', 'Total <br/>PAX', 'Avg <br/>PAX', 'Total Fare', 'Avg <br/>Fare', 'Avg <br/>Fare PP'];
      }

      if (type === 'rsvpCorporate') {
        this.pdf.class = 'corporate-rsvp';
        this.pdf.title = 'Opoli Reservation List by Corporate Profile';
        this.pdf.table.label = ['ID', 'Corporate', 'Guest Name (PAX)', 'Service', 'Pickup Time', 'Pickup Location', 'Dropoff Location', 'Fare'];
      }

      if (type === 'rsvpTerminal') {
        this.pdf.class = 'rsvp-terminal';
        this.pdf.title = 'Opoli Reservation by LAX Terminal';
      }

      if (type === 'creditConverted') {
        this.pdf.class = 'credit-converted';
        this.pdf.title = 'Opoli Reservations by Open Credit';
        this.pdf.table.label = ['ID', 'Brand', 'Pickup Time', 'Pickup', 'Dropoff', 'Service', 'Source', 'PAX', 'Fare', 'Credits'];
      }

      if (type === 'bySector') {
        this.pdf.class = 'bysector';
        this.pdf.title = 'Opoli Reservations by Sector';
        this.csv.label = ['Sector Name', 'Brand', 'Service Type', 'No of Reservation', 'Total Reservation per Sector', 'Total Amount per Service', 'Total Amount per Sector'];
      }

      switch (this.dateType) {
        case 'bookingTime':
          this.pdf.date = 'By Booking Date (' + dateRange + ')';
          if (type === 'creditConverted') {
            this.pdf.table.label[2] = 'Booking Date';
          }
          break;
        case 'cancelTime':
          this.pdf.date = 'By Cancellation Date (' + dateRange + ')';
          if (type === 'creditConverted') {
            this.pdf.table.label[2] = 'Cancelled Date';
          }
          break;
        case 'pickupTime':
          this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')';
          break;
      }
    },
    buildPdfData: function buildPdfData(type, pdfData) {
      var self = this;
      var groupCount = 0;
      var page = 1;

      // rsvpByDate
      var groupPax = 0;
      var groupFare = 0;
      var totalPax = 0;
      var totalFare = 0;
      var groupCancelFee = 0;
      var totalCancelFee = 0;

      // rsvpByRefund
      var groupRefund = 0;
      var totalRefund = 0;

      // rsvpSummary / rsvpByDriver / rsvpByDriverFare / rsvpByServiceType / rsvpByTripStatus
      var totalRsvp = 0;
      var totalDistance = 0;
      var totalAsap = 0;
      var totalWeb = 0;
      var totalAdmin = 0;
      var totalApp = 0;
      var totalGo = 0;
      var totalCreditSum = 0;
      var totalNoShowFee = 0;
      var totalAvgPax = 0;
      var totalAvgFare = 0;
      var totalAvgFarePP = 0;
      var totalDriverPayment = 0;

      // rsvpByDriver / rsvpByDriverFare
      var totalDutyHours = 0;
      var totalDriverPercentage = 0;

      // rsvpByAirport
      var totalOneway = 0;
      var totalRoundtrip = 0;
      var totalRoundtripInstances = 0;
      var totalRsvpInstances = 0;
      var totalOnewayPercent = 0;
      var totalRoundtripPercent = 0;

      // rsvpByPayment
      var totalCharged = 0;
      var totalGratuity = 0;

      // creditConverted
      var totalCreditReceived = 0;

      if (type === 'rsvpTerminal') {
        // Fill up missing data
        var terminalCount = 0;
        var terminals = [];
        pdfData.forEach(function (data, index) {
          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data.terminals).length > terminalCount) {
            terminalCount = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data.terminals).length;
          }
          for (var terminal in data.terminals) {
            if (terminals.indexOf(terminal) === -1) {
              terminals.push(terminal);
            }
          }
        });

        terminals.sort();

        pdfData.forEach(function (data, index) {
          terminals.forEach(function (terminal) {
            if (!data.terminals[terminal]) {
              pdfData[index].terminals[terminal] = 0;
            }
          });
        });
      }

      pdfData.forEach(function (data, index) {
        if (!self.pdf.table.data['page' + page]) {
          self.pdf.table.data['page' + page] = [];
        }

        if (type === 'rsvpSummaryWeekly') {
          self.buildWeeklyData(data);
        } else if (type === 'rsvpTerminal') {
          self.buildTerminalData(data);
        } else if (type === 'rsvpByAirportDepArr') {
          self.buildAirportDailyData(data.dates);
          self.buildAirportDailyDataCsv(data.dates);
        } else {
          self.pdf.table.data['page' + page].push(self.buildTableData(type, data));
        }

        if (self.csvChecked && type !== 'rsvpByAirportDepArr') {
          self.csv.data.push(self.buildCsvData(type, data));
        }
        groupCount++;

        var accept0 = ['rsvpByDate', 'rsvpByRefund'];
        if (accept0.indexOf(type) > -1) {
          totalPax += data.passengers;
          totalFare += data.fare;
          groupPax += data.passengers;
          groupFare += data.fare;

          if (type === 'rsvpByRefund') {
            totalRefund += data.refundedAmount;
            groupRefund += data.refundedAmount;
          }
          if (type === 'rsvpByDate' && (self.selectedDetailed === 'canceled' || self.dateType === 'cancelTime')) {
            totalCancelFee += data.cancelFee;
            groupCancelFee += data.cancelFee;
          }

          if ((index + 1) % self.pdf.maxRecordPerPage === 0 || pdfData.length === index + 1) {
            self.pdf.table.extra['page' + page] = {};
            self.pdf.table.extra['page' + page].pax = groupPax;
            self.pdf.table.extra['page' + page].fare = groupFare.toFixed(2);
            self.pdf.table.extra['page' + page].count = groupCount;
            groupPax = 0;
            groupFare = 0;
            groupCount = 0;
            if (type === 'rsvpByRefund') {
              self.pdf.table.extra['page' + page].refund = groupRefund.toFixed(2);
              groupRefund = 0;
            }
            if (type === 'rsvpByDate' && (self.selectedDetailed === 'canceled' || self.dateType === 'cancelTime')) {
              self.pdf.table.extra['page' + page].cancelFee = groupCancelFee.toFixed(2);
              groupCancelFee = 0;
            }
          }
        }

        var accept1 = ['rsvpSummary', 'rsvpByDriver', 'rsvpByDriverFare', 'rsvpByServiceType', 'rsvpByGroup', 'rsvpByTripStatus', 'rsvpByBrands', 'rsvpSummaryCorporate'];
        if (accept1.indexOf(type) > -1) {
          totalRsvp += data.rsvp;
          totalAsap += data.asap;
          totalWeb += data.web;
          totalAdmin += data.admin;
          totalApp += data.app;
          totalGo += data.go;
          totalPax += data.paxSum;
          totalAvgPax += parseFloat(data.paxAvg);
          totalFare += data.fareSum;
          totalAvgFare += parseFloat(data.fareAvg);
          totalAvgFarePP += parseFloat(data.farePP);
        }
        if (type === 'rsvpSummary' && self.selectedSummary === 'canceled') {
          totalCancelFee += data.cancelFeeSum;
        }
        if (type === 'rsvpSummary' && self.selectedSummary === 'promo') {
          totalCreditSum += data.creditSum;
        }
        if (type === 'rsvpSummary' && self.selectedSummary === 'noshow') {
          totalNoShowFee += data.noShowFeeSum;
        }
        if (['rsvpByDriver', 'rsvpByDriverFare'].indexOf(type) > -1) {
          totalDutyHours += data.dutyHours;
          totalDriverPayment += parseFloat(data.payment);
          totalDriverPercentage += parseFloat(data.payPercent);
        }
        if (type === 'rsvpByDriver') {
          totalDistance += parseFloat(data.distance.toFixed(2));
        }
        if (type === 'rsvpByAirport') {
          totalRsvp += data.rsvp;
          totalAsap += data.asap;
          totalOneway += data.oneway;
          totalRoundtrip += data.roundtrip;
          totalRoundtripInstances += parseFloat(data.roundtrip_instances);
          totalRsvpInstances += data.total_instances;
          totalOnewayPercent += parseFloat(data.percent_oneway);
          totalRoundtripPercent += parseFloat(data.percent_roundtrip);
        }
        if (type === 'rsvpByPayment') {
          totalRsvp += data.rsvp;
          totalPax += data.pax;
          totalCharged += data.fare.amount + data.fare.airportFee + data.fare.travelInsurance + data.fare.pickupFee + data.fare.tipAmount;
          totalGratuity += data.gratuity;
        }
        if (type === 'rsvpCorporate') {
          totalFare += parseFloat(data.amount + data.airportFee + data.travelInsurance + data.tipAmount);
        }
        if (type === 'creditConverted') {
          totalFare += parseFloat(data.fare);
          totalPax += data.passengers;
          totalCreditReceived += Math.abs(data.openCredits);
        }

        if ((index + 1) % self.pdf.maxRecordPerPage === 0 && pdfData.length !== index + 1) {
          page++;
        }
      });

      if (type === 'rsvpSummary' && totalRsvp <= 0) {
        self.error.show = true;
        self.error.empty.push(self.reportLabel(type));
        self.reportStatus[type] = 'has-error';
        self.pdf.list.shift();
        self.csv.list.shift();
        self.generateReport();
        return;
      }

      self.pdf.table.total.record = pdfData.length;
      var accept0 = ['rsvpByDate', 'rsvpByRefund'];
      if (accept0.indexOf(type) > -1) {
        self.pdf.table.total.pax = self.covertNumber(totalPax);
        self.pdf.table.total.fare = self.covertNumber(totalFare.toFixed(2));
        if (type === 'rsvpByRefund') {
          self.pdf.table.total.refund = self.covertNumber(totalRefund.toFixed(2));
        }
      }
      if (type === 'rsvpByDate' && (self.selectedDetailed === 'canceled' || self.dateType === 'cancelTime')) {
        self.pdf.table.total.extraFee = self.covertNumber(totalCancelFee.toFixed(2));
      }
      var accept1 = ['rsvpSummary', 'rsvpByDriver', 'rsvpByDriverFare', 'rsvpByServiceType', 'rsvpByGroup', 'rsvpByTripStatus', 'rsvpByBrands', 'rsvpSummaryCorporate'];
      if (accept1.indexOf(type) > -1) {
        self.pdf.table.total.rsvp = self.covertNumber(totalRsvp);
        self.pdf.table.total.asap = self.covertNumber(totalAsap);
        self.pdf.table.total.web = self.covertNumber(totalWeb);
        self.pdf.table.total.admin = self.covertNumber(totalAdmin);
        self.pdf.table.total.app = self.covertNumber(totalApp);
        self.pdf.table.total.go = self.covertNumber(totalGo);
        self.pdf.table.total.fare = self.covertNumber(totalFare.toFixed(2));

        var compAvgPax = totalPax / totalRsvp;
        var compAvgFare = totalFare / totalRsvp;
        var compAvgFarePP = totalFare / totalPax;

        self.pdf.table.total.avgPax = self.covertNumber(compAvgPax.toFixed(2));
        self.pdf.table.total.avgFare = self.covertNumber(compAvgFare.toFixed(2));
        self.pdf.table.total.avgFarePP = self.covertNumber(compAvgFarePP.toFixed(2));
        if (type !== 'trxSummary') {
          self.pdf.table.total.pax = self.covertNumber(totalPax);
        }
      }
      if (type === 'rsvpSummary' && self.selectedSummary === 'canceled') {
        self.pdf.table.total.extraFee = self.covertNumber(totalCancelFee.toFixed(2));
      }
      if (type === 'rsvpSummary' && self.selectedSummary === 'promo') {
        self.pdf.table.total.extraFee = self.covertNumber(totalCreditSum.toFixed(2));
      }
      if (type === 'rsvpSummary' && self.selectedSummary === 'noshow') {
        self.pdf.table.total.extraFee = self.covertNumber(totalNoShowFee.toFixed(2));
      }
      if (['rsvpByDriver', 'rsvpByDriverFare'].indexOf(type) > -1) {
        var averagePercentage = totalDriverPercentage / pdfData.length;
        var minutes = Math.round(totalDutyHours * 60);
        var hour = Math.floor(minutes / 60);
        var hourDisplay = hour < 10 ? '0' + hour : hour;
        self.pdf.table.total.dutyHours = hourDisplay + ':' + ('0' + (minutes - hour * 60)).slice(-2);
        self.pdf.table.total.extraFee = self.covertNumber(totalDriverPayment.toFixed(2));
        self.pdf.table.total.percent = self.covertNumber(averagePercentage.toFixed(2));
      }
      if (type === 'rsvpByDriver') {
        self.pdf.table.total.distance = self.covertNumber(totalDistance.toFixed(2));
      }
      if (type === 'rsvpByAirport') {
        self.pdf.table.total.rsvp = self.covertNumber(totalRsvp);
        self.pdf.table.total.asap = self.covertNumber(totalAsap);
        self.pdf.table.total.oneway = self.covertNumber(totalOneway);
        self.pdf.table.total.roundtrip = self.covertNumber(totalRoundtrip);
        self.pdf.table.total.roundtripInstances = self.covertNumber(totalRoundtripInstances.toFixed(2));
        self.pdf.table.total.rsvpIsntances = self.covertNumber(totalRsvpInstances.toFixed(2));
        self.pdf.table.total.onewayPercent = (totalOnewayPercent / pdfData.length).toFixed(2);
        self.pdf.table.total.roundtripPercent = (totalRoundtripPercent / pdfData.length).toFixed(2);
      }
      if (type === 'rsvpSummaryWeekly') {
        page = Math.ceil(pdfData[0].dates.length / 7);
      }
      if (type === 'rsvpByAirportDepArr') {
        page = Math.ceil(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(pdfData[0].dates).length / self.pdf.maxRecordPerPage);
      }
      if (type === 'rsvpByPayment') {
        self.pdf.table.total.rsvp = self.covertNumber(totalRsvp);
        self.pdf.table.total.pax = self.covertNumber(totalPax);
        self.pdf.table.total.charged = self.covertNumber(parseFloat(totalCharged).toFixed(2));
        self.pdf.table.total.gratuity = self.covertNumber(parseFloat(totalGratuity).toFixed(2));
      }
      if (type === 'rsvpCorporate') {
        self.pdf.table.total.fare = self.covertNumber(totalFare.toFixed(2));
      }
      if (type === 'rsvpTerminal') {
        page = Math.ceil(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(pdfData[0].terminals).length / 9);
      }
      if (type === 'creditConverted') {
        self.pdf.table.total.pax = self.covertNumber(totalPax);
        self.pdf.table.total.fare = self.covertNumber(totalFare.toFixed(2));
        self.pdf.table.total.creditReceived = self.covertNumber(totalCreditReceived.toFixed(2));
      }

      if (type === 'rsvpByBrands') {
        var allBrands = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(self.allBrands));
        self.pdf.table.data['page' + page].forEach(function (b) {
          var i = self.brands.list.findIndex(function (x) {
            return x.name === b.brand;
          });
          if (i > -1) {
            if (allBrands.indexOf(self.brands.list[i].id) > -1) {
              allBrands.splice(allBrands.indexOf(self.brands.list[i].id), 1);
            }
          }
        });
        self.pdf.table.total.record += allBrands.length;
        allBrands.forEach(function (x) {
          var brand = self.brands.list.find(function (n) {
            return n.id === x;
          });
          self.pdf.table.data['page' + page].push({
            brand: brand.name,
            rsvpCount: self.covertNumber(0),
            asap: self.covertNumber(0),
            web: self.covertNumber(0),
            admin: self.covertNumber(0),
            app: self.covertNumber(0),
            go: self.covertNumber(0),
            totalPax: self.covertNumber(0),
            avgPax: self.covertNumber(parseFloat(0).toFixed(2)),
            totalFare: self.covertNumber(parseFloat(0).toFixed(2)),
            avgFare: self.covertNumber(parseFloat(0).toFixed(2)),
            avgFarePP: self.covertNumber(parseFloat(0).toFixed(2))
          });
        });
      }

      if (self.pdfChecked) {
        self.processDownloads('pdf', { type: type, page: page });
      } else {
        self.processDownloads('csv', { type: type });
      }
      // self.processPdf(type, page)
    },
    buildTableData: function buildTableData(type, data) {
      var self = this;
      if (type === 'rsvpSummary') {
        var rsvpSummaryData = {
          date: __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.date, 'YYYY-MM-DD').format('MM/DD/YYYY'),
          rsvpCount: self.covertNumber(data.rsvp),
          asap: self.covertNumber(data.asap),
          web: self.covertNumber(data.web),
          admin: self.covertNumber(data.admin),
          app: self.covertNumber(data.app),
          go: self.covertNumber(data.go),
          totalPax: self.covertNumber(data.paxSum),
          avgPax: self.covertNumber(parseFloat(data.paxAvg).toFixed(2)),
          totalFare: self.covertNumber(parseFloat(data.fareSum).toFixed(2)),
          avgFare: self.covertNumber(parseFloat(data.fareAvg).toFixed(2)),
          avgFarePP: self.covertNumber(parseFloat(data.farePP).toFixed(2))
        };
        if (self.selectedSummary === 'canceled') {
          rsvpSummaryData.extraFee = self.covertNumber(parseFloat(data.cancelFeeSum).toFixed(2));
        }
        if (self.selectedSummary === 'promo') {
          rsvpSummaryData.extraFee = self.covertNumber(parseFloat(data.creditSum).toFixed(2));
        }
        if (self.selectedSummary === 'noshow') {
          rsvpSummaryData.extraFee = self.covertNumber(parseFloat(data.noShowFeeSum).toFixed(2));
        }
        return rsvpSummaryData;
      }

      if (type === 'rsvpByDate') {
        var source = 'Web';
        if (['android', 'ios'].indexOf(data.deviceType) > -1) {
          source = 'CA';
        }
        if (data.deviceType === 'admin') {
          source = 'Admin';
        }
        if (data.deviceType === 'CSR') {
          source = 'CSR';
        }
        var flight = 'N/A';
        if (data.airlineCode) {
          flight = data.airlineCode + ' ' + data.flightNumber;
        }
        if (data.flightName) {
          flight = data.flightName + ' ' + data.flightNumber;
        }
        var domIntl = '--';
        if (data.isDomestic === true) {
          domIntl = 'DOM';
        } else if (data.isDomestic === false) {
          domIntl = 'INTL';
        }
        if (data.direction === 'PP' || flight === 'N/A') {
          domIntl = 'N/A';
        }
        var service = data.service;
        if (data.brandId) {
          var brandCode = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.filter(function (x) {
            return x.id === data.brandId;
          })[0];
          service = '[' + brandCode.code.toUpperCase() + '] ' + data.service;
        }
        var rsvpByDateData = {
          id: data.ID,
          name: data.name,
          source: source,
          service: service,
          pickupTime: __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.localPickupTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mm'),
          pickupLocation: data.pickupLocation,
          dropoffLocation: data.dropoffLocation,
          flight: flight,
          flightType: domIntl,
          pax: self.covertNumber(data.passengers),
          fare: self.covertNumber(data.fare.toFixed(2))
          // status: data.status
        };
        if (['completed', 'canceled'].indexOf(self.selectedDetailed) === -1) {
          rsvpByDateData.status = data.status;
        }
        if (self.selectedDetailed === 'canceled' || self.dateType === 'cancelTime') {
          data.cancelFee = data.cancelFee || 0;
          rsvpByDateData.extraFee = self.covertNumber(data.cancelFee.toFixed(2));
        }
        return rsvpByDateData;
      }

      if (type === 'rsvpByRefund') {
        var _service = data.service;
        if (data.brandId) {
          var _brandCode = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.filter(function (x) {
            return x.id === data.brandId;
          })[0];
          _service = '[' + _brandCode.code.toUpperCase() + '] ' + data.service;
        }
        return {
          id: data.ID,
          name: data.name,
          direction: data.direction,
          service: _service,
          pickupTime: __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.localPickupTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mm'),
          refundedDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.refundedDate, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY HH:mm'),
          pickupLocation: data.pickupLocation,
          dropoffLocation: data.dropoffLocation,
          pax: self.covertNumber(data.passengers),
          fare: self.covertNumber(data.fare.toFixed(2)),
          refundAmount: self.covertNumber(data.refundedAmount.toFixed(2))
        };
      }

      if (type === 'rsvpByDriver') {
        var minutes = Math.round(data.dutyHours * 60);
        var hour = Math.floor(minutes / 60);
        var hourDisplay = hour < 10 ? '0' + hour : hour;
        return {
          driver: data.driverId + ' ' + data.name,
          distance: self.covertNumber(parseFloat(data.distance || 0).toFixed(2)),
          rsvpCount: self.covertNumber(data.rsvp),
          asap: self.covertNumber(data.asap),
          web: self.covertNumber(data.web),
          admin: self.covertNumber(data.admin),
          app: self.covertNumber(data.app),
          go: self.covertNumber(data.go),
          totalPax: self.covertNumber(data.paxSum),
          avgPax: self.covertNumber(parseFloat(data.paxAvg).toFixed(2)),
          dutyHours: hourDisplay + ':' + ('0' + (minutes - hour * 60)).slice(-2),
          totalFare: self.covertNumber(parseFloat(data.fareSum).toFixed(2)),
          avgFare: self.covertNumber(parseFloat(data.fareAvg).toFixed(2)),
          avgFarePP: self.covertNumber(parseFloat(data.farePP).toFixed(2)),
          driverPayment: self.covertNumber(parseFloat(data.payment).toFixed(2)),
          driverPercent: self.covertNumber(parseFloat(data.payPercent).toFixed(2))
        };
      }

      if (type === 'rsvpByDriverFare') {
        var _minutes = Math.round(data.dutyHours * 60);
        var _hour = Math.floor(_minutes / 60);
        var _hourDisplay = _hour < 10 ? '0' + _hour : _hour;
        return {
          driver: data.driverId + ' ' + data.name,
          rsvpCount: self.covertNumber(data.rsvp),
          asap: self.covertNumber(data.asap),
          web: self.covertNumber(data.web),
          admin: self.covertNumber(data.admin),
          app: self.covertNumber(data.app),
          go: self.covertNumber(data.go),
          totalPax: self.covertNumber(data.paxSum),
          avgPax: self.covertNumber(parseFloat(data.paxAvg).toFixed(2)),
          dutyHours: _hourDisplay + ':' + ('0' + (_minutes - _hour * 60)).slice(-2),
          totalFare: self.covertNumber(parseFloat(data.fareSum).toFixed(2)),
          avgFare: self.covertNumber(parseFloat(data.fareAvg).toFixed(2)),
          avgFarePP: self.covertNumber(parseFloat(data.farePP).toFixed(2)),
          driverPayment: self.covertNumber(parseFloat(data.payment).toFixed(2)),
          driverPercent: self.covertNumber(parseFloat(data.payPercent).toFixed(2))
        };
      }

      if (type === 'rsvpByServiceType') {
        var _service2 = data.name;
        if (data.serviceId > 5) {
          var _brandCode2 = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.filter(function (x) {
            return x.id === data.brandId;
          })[0];
          _service2 = '[' + _brandCode2.code.toUpperCase() + '] ' + data.name;
        }
        return {
          service: _service2,
          rsvpCount: self.covertNumber(data.rsvp),
          asap: self.covertNumber(data.asap),
          web: self.covertNumber(data.web),
          admin: self.covertNumber(data.admin),
          app: self.covertNumber(data.app),
          go: self.covertNumber(data.go),
          totalPax: self.covertNumber(data.paxSum),
          avgPax: self.covertNumber(parseFloat(data.paxAvg).toFixed(2)),
          totalFare: self.covertNumber(parseFloat(data.fareSum).toFixed(2)),
          avgFare: self.covertNumber(parseFloat(data.fareAvg).toFixed(2)),
          avgFarePP: self.covertNumber(parseFloat(data.farePP).toFixed(2))
        };
      }

      if (type === 'rsvpByAirport') {
        return {
          airport: data.label,
          rsvpCount: self.covertNumber(data.rsvp),
          asap: self.covertNumber(data.asap),
          oneway: self.covertNumber(data.oneway),
          roundtrip: self.covertNumber(data.roundtrip),
          roundtripInstances: self.covertNumber(parseFloat(data.roundtrip_instances).toFixed(2)),
          totalRsvpInstances: self.covertNumber(data.total_instances.toFixed(2)),
          onewayPercent: self.covertNumber(parseFloat(data.percent_oneway).toFixed(2)),
          roundtripPercent: self.covertNumber(parseFloat(data.percent_roundtrip).toFixed(2))
        };
      }

      if (type === 'rsvpByGroup') {
        var promo = data.promoCode ? '(' + data.promoCode + ') ' : '';
        promo = promo + data.name;
        return {
          promo: promo,
          rsvpCount: self.covertNumber(data.rsvp),
          asap: self.covertNumber(data.asap),
          web: self.covertNumber(data.web),
          admin: self.covertNumber(data.admin),
          app: self.covertNumber(data.app),
          go: self.covertNumber(data.go),
          totalPax: self.covertNumber(data.paxSum),
          avgPax: self.covertNumber(data.paxAvg),
          totalFare: self.covertNumber(parseFloat(data.fareSum).toFixed(2)),
          avgFare: self.covertNumber(parseFloat(data.fareAvg).toFixed(2)),
          avgFarePP: self.covertNumber(parseFloat(data.farePP).toFixed(2))
        };
      }

      if (type === 'variance') {
        var variance = self.covertNumber(Math.abs(parseFloat(data.variance)).toFixed(2));
        if (parseFloat(data.variance) < 0) {
          variance = '(' + variance + ')';
        }
        var fare = data.fare.airportFee + data.fare.amount + data.fare.pickupFee + data.fare.tipAmount;
        var paymentType = '';
        if (data.payments.card) {
          paymentType = 'CC';
        } else if (data.payments.other) {
          paymentType = 'Other';
        }

        return {
          id: data.rsvpId,
          pickupTime: __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.localPickupTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mm'),
          name: data.name,
          pickup: data.pickupLocation,
          dropoff: data.dropoffLocation,
          pax: data.passengers,
          paymentType: paymentType,
          fare: self.covertNumber(parseFloat(fare).toFixed(2)),
          cc: self.covertNumber(parseFloat(data.payments.card).toFixed(2)),
          other: self.covertNumber(parseFloat(data.payments.other).toFixed(2)),
          variance: variance
        };
      }

      if (type === 'rsvpByPayment') {
        var amount = data.fare.airportFee + data.fare.amount + data.fare.travelInsurance + data.fare.pickupFee + data.fare.tipAmount;
        return {
          name: data.method,
          rsvp: self.covertNumber(data.rsvp),
          pax: self.covertNumber(data.pax),
          charged: self.covertNumber(parseFloat(amount).toFixed(2)),
          gratuity: self.covertNumber(parseFloat(data.gratuity).toFixed(2))
        };
      }

      if (type === 'rsvpByTripStatus') {
        return {
          status: data.status,
          rsvpCount: self.covertNumber(data.rsvp),
          asap: self.covertNumber(data.asap),
          web: self.covertNumber(data.web),
          admin: self.covertNumber(data.admin),
          app: self.covertNumber(data.app),
          go: self.covertNumber(data.go),
          totalPax: self.covertNumber(data.paxSum),
          avgPax: self.covertNumber(parseFloat(data.paxAvg).toFixed(2)),
          totalFare: self.covertNumber(parseFloat(data.fareSum).toFixed(2)),
          avgFare: self.covertNumber(parseFloat(data.fareAvg).toFixed(2)),
          avgFarePP: self.covertNumber(parseFloat(data.farePP).toFixed(2))
        };
      }

      if (type === 'trxSummary') {
        var netTotal = parseFloat(data.chargedAmount) - parseFloat(data.refundAmount);
        return {
          date: __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.date, 'YYYY-MM-DD').format('MM/DD/YYYY'),
          trxCount: self.covertNumber(data.trx),
          chargedTrxCount: self.covertNumber(data.charged),
          chargedAmount: self.covertNumber(parseFloat(data.chargedAmount).toFixed(2)),
          refundTrxCount: self.covertNumber(data.refund),
          refundAmount: self.covertNumber(parseFloat(data.refundAmount).toFixed(2)),
          netTotal: self.covertNumber(parseFloat(netTotal).toFixed(2))
          // rsvpCount: self.covertNumber(data.rsvp),
          // purchaseCount: self.covertNumber(data.purchase),
          // additionalCount: self.covertNumber(data.extra),
          // totalCharges: self.covertNumber(parseFloat(data.amount).toFixed(2))
        };
      }

      if (type === 'trxDetailed') {
        // let trxType = data.type === 'cancelFee' ? 'cancel fee' : data.type
        var charged = data.trxType !== 'Refund' ? self.covertNumber(parseFloat(data.chargedAmount).toFixed(2)) : '-';
        var refund = data.trxType === 'Refund' ? self.covertNumber(parseFloat(data.chargedAmount).toFixed(2)) : '-';
        return {
          date: __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.created, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY  HH:mm'),
          customer: data.customer,
          cardOwner: data.cardOwner,
          rsvpId: data.rsvpId,
          invoiceId: data.invoiceID,
          transactionType: data.trxType,
          // transactionType: trxType,
          chargedAmount: charged,
          refundAmount: refund
        };
      }

      if (type === 'rsvpByBrands') {
        return {
          brand: data.name,
          rsvpCount: self.covertNumber(data.rsvp),
          asap: self.covertNumber(data.asap),
          web: self.covertNumber(data.web),
          admin: self.covertNumber(data.admin),
          app: self.covertNumber(data.app),
          go: self.covertNumber(data.go),
          totalPax: self.covertNumber(data.paxSum),
          avgPax: self.covertNumber(parseFloat(data.paxAvg).toFixed(2)),
          totalFare: self.covertNumber(parseFloat(data.fareSum).toFixed(2)),
          avgFare: self.covertNumber(parseFloat(data.fareAvg).toFixed(2)),
          avgFarePP: self.covertNumber(parseFloat(data.farePP).toFixed(2))
        };
      }

      if (type === 'rsvpSummaryCorporate') {
        return {
          brand: data.name,
          rsvpCount: self.covertNumber(data.rsvp),
          asap: self.covertNumber(data.asap),
          web: self.covertNumber(data.web),
          admin: self.covertNumber(data.admin),
          app: self.covertNumber(data.app),
          go: self.covertNumber(data.go),
          totalPax: self.covertNumber(data.paxSum),
          avgPax: self.covertNumber(parseFloat(data.paxAvg).toFixed(2)),
          totalFare: self.covertNumber(parseFloat(data.fareSum).toFixed(2)),
          avgFare: self.covertNumber(parseFloat(data.fareAvg).toFixed(2)),
          avgFarePP: self.covertNumber(parseFloat(data.farePP).toFixed(2))
        };
      }

      if (type === 'rsvpCorporate') {
        return {
          rsvpId: data.rsvpId,
          corporate: data.corporateName,
          guest: data.guestName + ' (' + data.passengers + ')',
          service: data.serviceTypeName,
          pickupTime: __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.pickupTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mm'),
          pickupLocation: data.pickupLocation,
          dropoffLocation: data.dropoffLocation,
          fare: self.covertNumber(parseFloat(data.amount + data.airportFee + data.travelInsurance + data.tipAmount).toFixed(2))
        };
      }

      if (type === 'creditConverted') {
        var _brandCode3 = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.filter(function (x) {
          return x.id === data.brandId;
        })[0];
        var _source = 'Web';
        if (['android', 'ios'].indexOf(data.deviceType) > -1) {
          _source = 'CA';
        }
        if (data.deviceType === 'admin') {
          _source = 'Admin';
        }
        if (data.deviceType === 'CSR') {
          _source = 'CSR';
        }
        var pickupTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.localPickupTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mm');
        if (self.dateType === 'bookingTime') {
          pickupTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.bookingTime, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY HH:mm');
        } else if (self.dateType === 'cancelTime') {
          pickupTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.cancelTime, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY HH:mm');
        }
        return {
          rsvpId: data.ID,
          brand: _brandCode3.code.toUpperCase(),
          pickupTime: pickupTime,
          pickup: data.pickupLocation,
          dropoff: data.dropoffLocation,
          service: data.service,
          source: _source,
          pax: self.covertNumber(data.passengers),
          fare: self.covertNumber(parseFloat(data.fare).toFixed(2)),
          creditReceived: self.covertNumber(parseFloat(Math.abs(data.openCredits)).toFixed(2))
        };
      }

      if (type === 'bySector') {
        return {
          rsvpId: data.ID
        };
      }
    },
    buildWeeklyData: function buildWeeklyData(data) {
      var self = this;
      var time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.hour, 'HH:mm').add(59, 'minutes');
      var rowData = { time: data.hour + '-' + time.format('HH:mm') };

      var dayCounter = 1;
      var page = 1;

      self.csv.summaryWeeklyLabel = ['Time period'];
      data.dates.forEach(function (data2, index) {
        var day = __WEBPACK_IMPORTED_MODULE_2_moment___default()(data2.date, 'YYYY-MM-DD');
        rowData[day.format('dddd') + 'Pax'] = data2.pax;
        rowData[day.format('dddd') + 'Rsvp'] = data2.rsvp;

        self.csv.summaryWeeklyLabel.push(day.format('MM/DD/YYYY') + ' PAX');
        self.csv.summaryWeeklyLabel.push(day.format('MM/DD/YYYY') + ' RSVP');

        if (!self.pdf.table.extra['page' + page]) {
          self.pdf.table.extra['page' + page] = {};
        }
        if (!self.pdf.table.extra['page' + page]['day' + dayCounter]) {
          self.pdf.table.extra['page' + page]['day' + dayCounter] = {};
          self.pdf.table.extra['page' + page]['day' + dayCounter].pax = 0;
          self.pdf.table.extra['page' + page]['day' + dayCounter].rsvp = 0;
          self.pdf.table.extra['page' + page]['day' + dayCounter].value = '';
        }
        self.pdf.table.extra['page' + page]['day' + dayCounter].pax += data2.pax;
        self.pdf.table.extra['page' + page]['day' + dayCounter].rsvp += data2.rsvp;
        self.pdf.table.extra['page' + page]['day' + dayCounter].value = day.format('MM/DD/YYYY');

        if (dayCounter === 7 || index + 1 === data.dates.length) {
          if (!self.pdf.table.data['page' + page]) {
            self.pdf.table.data['page' + page] = [];
          }

          self.pdf.table.data['page' + page].push(rowData);
          rowData = { time: data.hour + '-' + time.format('HH:mm') };

          dayCounter = 1;
          page++;
        } else {
          dayCounter++;
        }
      });
    },
    buildTerminalData: function buildTerminalData(data) {
      var self = this;
      var time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.hour, 'HH:mm').add(59, 'minutes');
      var rowData = { time: data.hour + '-' + time.format('HH:mm') };

      var dayCounter = 1;
      var page = 1;

      self.csv.terminalLabel = ['Time period'];
      for (var index in data.terminals) {
        rowData['terminal' + index] = data.terminals[index];

        self.csv.terminalLabel.push('Terminal ' + index);

        if (!self.pdf.table.extra['page' + page]) {
          self.pdf.table.extra['page' + page] = {};
        }
        if (!self.pdf.table.extra['page' + page]['terminal' + index]) {
          self.pdf.table.extra['page' + page]['terminal' + index] = {};
          self.pdf.table.extra['page' + page]['terminal' + index] = { rsvp: 0 };
        }
        self.pdf.table.extra['page' + page]['terminal' + index].rsvp += data.terminals[index];

        if (!self.pdf.table.data['page' + page]) {
          self.pdf.table.data['page' + page] = [];
        }
      }
      self.pdf.table.data['page' + page].push(rowData);
    },
    buildAirportDailyData: function buildAirportDailyData(data) {
      var self = this;
      var page = 1;
      var rowCount = 1;

      var departureRsvp = 0;
      var arrivalRsvp = 0;
      var totalRsvp = 0;
      var departurePax = 0;
      var arrivalPax = 0;
      var totalPax = 0;

      for (var index in data) {
        if (!self.pdf.table.data['page' + page]) {
          self.pdf.table.data['page' + page] = [];
        }
        self.pdf.table.data['page' + page].push({
          date: __WEBPACK_IMPORTED_MODULE_2_moment___default()(index, 'YYYY-MM-DD').format('MM/DD/YYYY'),
          departureRsvp: self.covertNumber(data[index].depRsvp),
          arrivalRsvp: self.covertNumber(data[index].arrRsvp),
          totalRsvp: self.covertNumber(data[index].sumRsvp),
          departurePax: self.covertNumber(data[index].depPax),
          arrivalPax: self.covertNumber(data[index].arrPax),
          totalPax: self.covertNumber(data[index].sumPax)
        });

        departureRsvp += data[index].depRsvp;
        arrivalRsvp += data[index].arrRsvp;
        totalRsvp += data[index].sumRsvp;
        departurePax += data[index].depPax;
        arrivalPax += data[index].arrPax;
        totalPax += data[index].sumPax;

        if (rowCount % self.pdf.maxRecordPerPage === 0 && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).length !== rowCount) {
          rowCount = 1;
          page++;
        } else {
          rowCount++;
        }
      }

      self.pdf.table.total.departureRsvp = self.covertNumber(departureRsvp);
      self.pdf.table.total.arrivalRsvp = self.covertNumber(arrivalRsvp);
      self.pdf.table.total.totalRsvp = self.covertNumber(totalRsvp);
      self.pdf.table.total.departurePax = self.covertNumber(departurePax);
      self.pdf.table.total.arrivalPax = self.covertNumber(arrivalPax);
      self.pdf.table.total.totalPax = self.covertNumber(totalPax);
    },
    fileName: function fileName(type, format) {
      var timestamp = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.from).format('YYYYMMDD') + '_' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.to).format('YYYYMMDD');
      switch (type) {
        case 'rsvpSummary':
          return 'rsvpsummary_' + timestamp + '.' + format;
        case 'rsvpByDate':
          return 'rsvpbydate_' + timestamp + '.' + format;
        case 'rsvpByRefund':
          return 'rsvpbyrefund_' + timestamp + '.' + format;
        case 'rsvpByDriver':
          return 'rsvpbydriver_' + timestamp + '.' + format;
        case 'rsvpByDriverFare':
          return 'rsvpbydriverfare_' + timestamp + '.' + format;
        case 'rsvpByServiceType':
          return 'rsvpbyservicetype_' + timestamp + '.' + format;
        case 'rsvpByAirport':
          return 'rsvpbyairport_' + timestamp + '.' + format;
        case 'rsvpSummaryWeekly':
          return 'rsvpsummaryweekly_' + timestamp + '.' + format;
        case 'rsvpByAirportDepArr':
          return 'rsvpbyairportdeparturearrival_' + timestamp + '.' + format;
        case 'rsvpByGroup':
          return 'rsvpbygroup_' + timestamp + '.' + format;
        case 'variance':
          return 'variance_' + timestamp + '.' + format;
        case 'rsvpByPayment':
          return 'rsvpbypayment_' + timestamp + '.' + format;
        case 'rsvpByTripStatus':
          return 'rsvpbytripstatus_' + timestamp + '.' + format;
        case 'rsvpByBrands':
          return 'rsvpbybrands_' + timestamp + '.' + format;
        case 'rsvpSummaryCorporate':
          return 'rsvpsummary-corporate_' + timestamp + '.' + format;
        case 'rsvpCorporate':
          return 'rsvpcorporate_' + timestamp + '.' + format;
        case 'rsvpTerminal':
          return 'rsvpterminal_' + timestamp + '.' + format;
        case 'creditConverted':
          return 'creditConverted' + timestamp + '.' + format;
        case 'bySector':
          return 'bySector' + timestamp + '.' + format;
      }
    },
    currentPage: function currentPage(page) {
      return page.substring(4);
    },
    processPdf: function processPdf(type, page) {
      var self = this;
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.to);
      var pageAsyncs = [];
      var landscapeReports = self.orientation;
      var orientation = landscapeReports.indexOf(type) > -1 ? 'l' : 'p';
      var pdf = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a({ orientation: orientation, unit: 'mm', format: 'a4' });

      window.scrollTo(500, 0);
      document.body.style.overflow = 'hidden';

      setTimeout(function () {
        if (self.isIOS) page = page + 1;
        // for (let i = 0; i < page; i++) {
        //   pageAsyncs.push(html2canvas(document.getElementsByClassName('page' + (i + 1))[0], {
        //     scale: "1"
        //   }).then(canvas => {
        //     let imgData = canvas.toDataURL('image/jpeg', 0.9)
        //     pdf.addImage(imgData, 'JPEG', 0, 0)
        //     if (i + 1 !== page) { pdf.addPage() }
        //   }).catch(e => {
        //     self.reportStatus[type] = 'has-error'
        //     self.pdf.list.shift()
        //     document.body.style.overflow = 'auto'
        //     self.processDownloads('csv', {type: type})
        //     console.warn(e)
        //   }))
        // }

        var i = 0;
        var buildPdfPages = function buildPdfPages(i) {
          if (i + 1 > page) {
            downloadPdfPages();
            return;
          }
          pageAsyncs.push(__WEBPACK_IMPORTED_MODULE_4_html2canvas___default()(document.getElementsByClassName('page' + (i + 1))[0], {
            scale: "1"
          }).then(function (canvas) {
            var imgData = canvas.toDataURL('image/jpeg', 1.0);
            pdf.addImage(imgData, 'JPEG', 0, 0);
            if (i + 1 <= page) {
              pdf.addPage();
              buildPdfPages(i + 1);
            }
          }).catch(function (e) {
            self.reportStatus[type] = 'has-error';
            self.pdf.list.shift();
            document.body.style.overflow = 'auto';
            self.processDownloads('csv', { type: type });
            console.warn(e);
          }));
        };
        buildPdfPages(0);

        var downloadPdfPages = function downloadPdfPages() {
          pdf.save(self.fileName(type, 'pdf'));
          self.reportStatus[type] = 'success';
          self.pdf.list.shift();
          document.body.style.overflow = 'auto';
          self.processDownloads('csv', { type: type });
        };

        // Promise.all(pageAsyncs).then(() => {
        //   let timestamp = start.format('YYYYMMDD') + '_' + end.format('YYYYMMDD')
        //   pdf.save(self.fileName(type, 'pdf'))
        //   self.reportStatus[type] = 'success'
        //   self.pdf.list.shift()
        //   document.body.style.overflow = 'auto'
        //   self.processDownloads('csv', {type: type})
        // })
      }, 500);
    },
    covertNumber: function covertNumber(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    weeklySummaryLabel: function weeklySummaryLabel(date) {
      if (!date) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date, 'MM/DD/YYYY').format('dddd') + '<br/>' + date;
    },
    resetSelectedStatus: function resetSelectedStatus() {
      this.selectedReports = {
        rsvpSummary: false, rsvpSummaryWeekly: false, rsvpByDate: false,
        rsvpByRefund: false, rsvpByDriver: false, rsvpByDriverFare: false,
        rsvpByServiceType: false, rsvpByAirport: false, rsvpByAirportDepArr: false,
        rsvpByGroup: false, variance: false, rsvpByPayment: false,
        rsvpByTripStatus: false, rsvpByBrands: false, rsvpSummaryCorporate: false,
        rsvpCorporate: false, rsvpTerminal: false, creditConverted: false,
        bySector: false
      };
    },
    resetReportStatus: function resetReportStatus() {
      this.error.show = false;
      this.error.empty = [];
      this.reportStatus = {
        rsvpSummary: '', rsvpSummaryWeekly: '', rsvpByDate: '', rsvpByRefund: '',
        rsvpByDriver: '', rsvpByDriverFare: '', rsvpByServiceType: '', rsvpByAirport: '',
        rsvpByAirportDepArr: '', rsvpByGroup: '', variance: '', rsvpByPayment: '',
        rsvpByBrands: '', rsvpSummaryCorporate: '', rsvpTerminal: '', creditConverted: '',
        bySector: ''
      };
    },
    reportLabel: function reportLabel(type) {
      switch (type) {
        case 'rsvpSummary':
          return 'Reservations Summary';
        case 'rsvpSummaryWeekly':
          return 'Reservations Summary (weekly)';
        case 'rsvpByDate':
          return 'Reservations by Date';
        case 'rsvpByRefund':
          return 'Reservations by Refund';
        case 'rsvpByDriver':
          return 'Reservations by Driver';
        case 'rsvpByDriverFare':
          return 'Reservations by Driver (fare)';
        case 'rsvpByServiceType':
          return 'Reservations by Service Type';
        case 'rsvpByAirport':
          return 'Reservations by Airport';
        case 'rsvpByAirportDepArr':
          return 'Reservations by Airport (departure/arrival)';
        case 'rsvpByGroup':
          return 'Reservations by Group';
        case 'variance':
          return 'Variance Report';
        case 'rsvpByPayment':
          return 'Reservations by Payment Type and Source';
        case 'rsvpByTripStatus':
          return 'Reservations by Trip Status';
        case 'rsvpByBrands':
          return 'Reservations by Brands';
        case 'rsvpSummaryCorporate':
          return 'Reservations Summary by Corporate Profile';
        case 'rsvpCorporate':
          return 'Reservations List by Corporate Profile';
        case 'rsvpTerminal':
          return 'Reservations by LAX Terminal';
        case 'creditConverted':
          return 'Reservations by Open Credit';
        case 'bySector':
          return 'Reservations by Sector';
      }
    },
    disableOption: function disableOption(select, type) {
      var opt = ['rsvpSummary', 'rsvpByDate'];
      if (opt.indexOf(select) > -1 && type === 'canceled' && this.dateType === 'completeTime') {
        return true;
      }
      if (opt.indexOf(select) > -1 && type === 'completed' && this.dateType === 'cancelTime') {
        return true;
      }
    },
    buildCsvData: function buildCsvData(type, data) {
      var column = [];
      this.pdf.table.label.forEach(function (i) {
        column.push(i.replace('<br/>', ''));
      });
      if (type === 'rsvpSummaryWeekly') {
        column = this.csv.summaryWeeklyLabel;
      }
      if (type === 'rsvpTerminal') {
        column = this.csv.terminalLabel;
      }
      this.csv.label = column;

      var csvData = {};
      var pdfData = '';
      if (type === 'rsvpSummaryWeekly') {
        pdfData = this.buildWeeklyDataCsv(data);
      } else if (type === 'rsvpTerminal') {
        pdfData = this.buildTerminalDataCsv(data);
      } else if (type === 'rsvpByAirportDepArr') {
        this.buildAirportDailyDataCsv(data.dates);
        return;
      } else {
        pdfData = this.buildTableData(type, data);
      }

      var i = 0;
      for (var key in pdfData) {
        csvData[column[i]] = pdfData[key];
        i++;
      }
      return csvData;
    },
    buildWeeklyDataCsv: function buildWeeklyDataCsv(data) {
      var self = this;
      var columnData = {};
      for (var i in data) {
        if (i === 'hour') {
          var hour = __WEBPACK_IMPORTED_MODULE_2_moment___default()(data[i], 'HH:mm').add(59, 'minutes');
          columnData['hour'] = data[i] + '-' + hour.format('HH:mm');
        } else {
          data[i].forEach(function (key, index) {
            columnData[key.date + 'pax'] = key.pax;
            columnData[key.date + 'rsvp'] = key.rsvp;

            if (!self.csv.total[key.date + 'pax']) {
              self.csv.total[key.date + 'pax'] = 0;
            }
            if (!self.csv.total[key.date + 'rsvp']) {
              self.csv.total[key.date + 'rsvp'] = 0;
            }
            self.csv.total[key.date + 'pax'] += key.pax;
            self.csv.total[key.date + 'rsvp'] += key.rsvp;
          });
        }
      }
      return columnData;
    },
    buildTerminalDataCsv: function buildTerminalDataCsv(data) {
      var self = this;
      var columnData = {};
      for (var i in data) {
        if (i === 'hour') {
          var hour = __WEBPACK_IMPORTED_MODULE_2_moment___default()(data[i], 'HH:mm').add(59, 'minutes');
          columnData['hour'] = data[i] + '-' + hour.format('HH:mm');
        } else {
          for (var terminal in data.terminals) {
            columnData['Terminal' + terminal] = data.terminals[terminal];

            if (!self.csv.total['Terminal ' + terminal]) {
              self.csv.total['Terminal' + terminal] = 0;
            }
            self.csv.total['Terminal' + terminal] += data.terminals[terminal];
          }
        }
      }
      return columnData;
    },
    buildAirportDailyDataCsv: function buildAirportDailyDataCsv(data) {
      var column = [];
      this.pdf.table.label.forEach(function (i) {
        column.push(i.replace('<br/>', ''));
      });
      this.csv.label = column;

      this.csv.data = [];
      for (var index in data) {
        var columnData = {};
        columnData[column[0]] = __WEBPACK_IMPORTED_MODULE_2_moment___default()(index, 'YYYY-MM-DD').format('MM/DD/YYYY');
        columnData[column[1]] = this.covertNumber(data[index].depRsvp);
        columnData[column[2]] = this.covertNumber(data[index].arrRsvp);
        columnData[column[3]] = this.covertNumber(data[index].sumRsvp);
        columnData[column[4]] = this.covertNumber(data[index].depPax);
        columnData[column[5]] = this.covertNumber(data[index].arrPax);
        columnData[column[6]] = this.covertNumber(data[index].sumPax);
        this.csv.data.push(columnData);
      }
    },
    processDownloads: function processDownloads(action, data) {
      if (action === 'pdf' && this.pdfChecked) {
        this.processPdf(data.type, data.page);
      } else if (action === 'csv' && this.csvChecked) {
        this.processCsv(data.type);
      } else {
        this.generateReport();
      }
    },
    processCsv: function processCsv(type) {
      var exporter = __WEBPACK_IMPORTED_MODULE_6_csvexport___default.a.create({
        filename: this.fileName(type, 'csv'),
        columns: this.csv.label
      });

      // add total
      this.csv.data.push(this.buildCsvTotal(type));

      this.reportStatus[type] = 'success';
      this.csv.list.shift();
      exporter.downloadCsv(this.csv.data);

      this.generateReport(true);
    },
    buildCsvTotal: function buildCsvTotal(type) {
      var csvData = {};
      var totalData = this.pdf.table.total;

      if (['rsvpSummary', 'rsvpByDriver', 'rsvpByDriverFare', 'rsvpByServiceType', 'rsvpByGroup', 'rsvpByTripStatus', 'rsvpByBrands', 'rsvpSummaryCorporate'].indexOf(type) > -1) {
        csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')';
        csvData[this.csv.label[1]] = totalData.rsvp;
        csvData[this.csv.label[2]] = totalData.asap;
        csvData[this.csv.label[3]] = totalData.web;
        csvData[this.csv.label[4]] = totalData.admin;
        csvData[this.csv.label[5]] = totalData.app;
        csvData[this.csv.label[6]] = totalData.go;
        csvData[this.csv.label[7]] = totalData.pax;
        csvData[this.csv.label[8]] = totalData.avgPax;
        csvData[this.csv.label[9]] = totalData.fare;
        csvData[this.csv.label[10]] = totalData.avgFare;
        csvData[this.csv.label[11]] = totalData.avgFarePP;
        if (type === 'rsvpByDriver') {
          csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')';
          csvData[this.csv.label[1]] = totalData.distance;
          csvData[this.csv.label[2]] = totalData.rsvp;
          csvData[this.csv.label[3]] = totalData.asap;
          csvData[this.csv.label[4]] = totalData.web;
          csvData[this.csv.label[5]] = totalData.admin;
          csvData[this.csv.label[6]] = totalData.app;
          csvData[this.csv.label[7]] = totalData.go;
          csvData[this.csv.label[8]] = totalData.pax;
          csvData[this.csv.label[9]] = totalData.avgPax;
          csvData[this.csv.label[10]] = totalData.fare;
          csvData[this.csv.label[11]] = totalData.avgFare;
          csvData[this.csv.label[12]] = totalData.avgFarePP;
        }
        if (['canceled', 'promo', 'noshow'].indexOf(this.selectedSummary) > -1 && type === 'rsvpSummary' || ['rsvpByDriverFare'].indexOf(type) > -1) {
          csvData[this.csv.label[11]] = totalData.extraFee;
        }
        if (['rsvpByDriverFare'].indexOf(type) > -1) {
          csvData[this.csv.label[9]] = totalData.dutyHours;
          csvData[this.csv.label[10]] = totalData.fare;
          csvData[this.csv.label[11]] = totalData.avgFare;
          csvData[this.csv.label[12]] = totalData.avgFarePP;
          csvData[this.csv.label[13]] = totalData.extraFee;
          csvData[this.csv.label[14]] = totalData.percent;
        }
        if (['rsvpByDriver'].indexOf(type) > -1) {
          csvData[this.csv.label[10]] = totalData.dutyHours;
          csvData[this.csv.label[11]] = totalData.fare;
          csvData[this.csv.label[12]] = totalData.avgFare;
          csvData[this.csv.label[13]] = totalData.avgFarePP;
          csvData[this.csv.label[14]] = totalData.extraFee;
          csvData[this.csv.label[15]] = totalData.percent;
        }
      }

      if (type === 'rsvpSummaryWeekly') {
        csvData[this.csv.label[0]] = 'Totals';

        var x = 1;
        for (var i in this.csv.total) {
          csvData[this.csv.label[x]] = this.csv.total[i];
          x++;
        }
      }

      if (type === 'rsvpByDate') {
        csvData[this.csv.label[0]] = '';
        csvData[this.csv.label[1]] = '';
        csvData[this.csv.label[2]] = '';
        csvData[this.csv.label[3]] = '';
        csvData[this.csv.label[4]] = '';
        csvData[this.csv.label[5]] = '';
        csvData[this.csv.label[6]] = 'Report Total ' + '(' + totalData.record + ')';
        csvData[this.csv.label[7]] = totalData.pax;
        csvData[this.csv.label[8]] = totalData.fare;
        if (['completed', 'canceled'].indexOf(this.selectedDetailed) === -1) {
          csvData[this.csv.label[9]] = '';
        }
        if (this.selectedDetailed === 'canceled') {
          csvData[this.csv.label[9]] = totalData.extraFee;
        }
      }

      if (type === 'rsvpByRefund') {
        csvData[this.csv.label[0]] = '';
        csvData[this.csv.label[1]] = '';
        csvData[this.csv.label[2]] = '';
        csvData[this.csv.label[3]] = '';
        csvData[this.csv.label[4]] = '';
        csvData[this.csv.label[5]] = '';
        csvData[this.csv.label[6]] = '';
        csvData[this.csv.label[7]] = 'Report Total ' + '(' + totalData.record + ')';
        csvData[this.csv.label[8]] = totalData.pax;
        csvData[this.csv.label[9]] = totalData.fare;
        csvData[this.csv.label[10]] = totalData.refund;
      }

      if (type === 'rsvpByAirport') {
        csvData[this.csv.label[0]] = 'Total ' + totalData.record;
        csvData[this.csv.label[1]] = totalData.rsvp;
        csvData[this.csv.label[2]] = totalData.asap;
        csvData[this.csv.label[3]] = totalData.oneway;
        csvData[this.csv.label[4]] = totalData.roundtrip;
        csvData[this.csv.label[5]] = totalData.roundtripInstances;
        csvData[this.csv.label[6]] = totalData.rsvpIsntances;
        csvData[this.csv.label[7]] = totalData.onewayPercent + '%';
        csvData[this.csv.label[8]] = totalData.roundtripPercent + '%';
      }

      if (type === 'rsvpByAirportDepArr') {
        csvData[this.csv.label[0]] = 'Totals';
        csvData[this.csv.label[1]] = totalData.departureRsvp;
        csvData[this.csv.label[2]] = totalData.arrivalRsvp;
        csvData[this.csv.label[3]] = totalData.totalRsvp;
        csvData[this.csv.label[4]] = totalData.departurePax;
        csvData[this.csv.label[5]] = totalData.arrivalPax;
        csvData[this.csv.label[6]] = totalData.totalPax;
      }

      if (type === 'rsvpByPayment') {
        csvData[this.csv.label[0]] = 'Totals';
        csvData[this.csv.label[1]] = totalData.rsvp;
        csvData[this.csv.label[2]] = totalData.pax;
        csvData[this.csv.label[3]] = totalData.charged;
        csvData[this.csv.label[4]] = totalData.gratuity;
      }

      if (type === 'rsvpCorporate') {
        csvData[this.csv.label[0]] = '';
        csvData[this.csv.label[1]] = '';
        csvData[this.csv.label[2]] = '';
        csvData[this.csv.label[3]] = '';
        csvData[this.csv.label[4]] = '';
        csvData[this.csv.label[5]] = '';
        csvData[this.csv.label[6]] = '';
        csvData[this.csv.label[7]] = totalData.fare;
      }

      if (type === 'rsvpTerminal') {
        csvData[this.csv.label[0]] = 'Totals';

        var x = 1;
        for (var i in this.csv.total) {
          csvData[this.csv.label[x]] = this.csv.total[i];
          x++;
        }
      }

      if (type === 'creditConverted') {
        csvData[this.csv.label[0]] = '';
        csvData[this.csv.label[1]] = '';
        csvData[this.csv.label[2]] = '';
        csvData[this.csv.label[3]] = '';
        csvData[this.csv.label[4]] = '';
        csvData[this.csv.label[5]] = '';
        csvData[this.csv.label[6]] = '';
        csvData[this.csv.label[7]] = totalData.pax;
        csvData[this.csv.label[8]] = totalData.fare;
        csvData[this.csv.label[9]] = totalData.creditReceived;
      }

      return csvData;
      // this.pdf.table.total
    },
    formatCheck: function formatCheck() {
      this.error.show = false;
      this.formatError = false;
    },
    _serviceLabel: function _serviceLabel(code) {
      return __WEBPACK_IMPORTED_MODULE_7__modules_api_services__["a" /* default */].getServiceName(code);
    },
    buildSectorData: function buildSectorData(data) {
      var self = this;

      var grandTotal = {
        rsvp: 0,
        amount: 0,
        tnc: 0,
        tcp: 0
      };
      var grandTotalService = {
        tnc: {},
        tcp: {}
      };
      data.list.forEach(function (sector, sectorIndex) {
        var totalRes = 0;
        var totalAmount = 0;
        var totalTnc = 0;
        var totalTcp = 0;
        if (sector.drivers && sector.drivers.tnc) {
          totalTnc = sector.drivers.tnc;
        }
        if (sector.drivers && sector.drivers.tcp) {
          totalTcp = sector.drivers.tcp;
        }
        sector.brands.forEach(function (brand, brandIndex) {
          var brandRsvpTotal = 0;
          var brandAmountTotal = 0;
          brand.serviceTypes.forEach(function (service, serviceIndex) {
            var tmpData = {
              'Sector Name': '',
              'Brand': '',
              'Service Type': '',
              'No of Reservation': '',
              'Total Reservation per Sector': '',
              'Total Amount per Service': '',
              'Total Amount per Sector': ''
            };
            if (brandIndex === 0 && serviceIndex === 0) tmpData['Sector Name'] = data.list[sectorIndex].name;
            if (serviceIndex === 0) {
              tmpData['Brand'] = self.brandName(sector.brands[brandIndex]);
            }

            tmpData['Service Type'] = service.label;
            tmpData['No of Reservation'] = service.rsvps;
            tmpData['Total Amount per Service'] = parseFloat(service.amount.toFixed(2));

            brandRsvpTotal += service.rsvps;
            totalRes += service.rsvps;
            brandAmountTotal += parseFloat(service.amount.toFixed(2));
            totalAmount += parseFloat(service.amount.toFixed(2));
            grandTotal.rsvp += service.rsvps;
            grandTotal.amount += parseFloat(service.amount.toFixed(2));

            if (serviceIndex === sector.brands[brandIndex].serviceTypes.length - 1) {
              tmpData['Total Reservation per Sector'] = brandRsvpTotal;
              tmpData['Total Amount per Sector'] = parseFloat(brandAmountTotal.toFixed(2));
            }

            var tmpType = '';
            if (service.tnc) tmpType = 'tnc';
            if (!service.tnc && service.tcp) tmpType = 'tcp';
            if (tmpType !== '' && !grandTotalService[tmpType][service.code]) {
              grandTotalService[tmpType][service.code] = {
                driver: 0,
                rsvp: 0,
                amount: 0,
                label: service.label
              };
            }
            grandTotalService[tmpType][service.code].rsvp += service.rsvps;
            grandTotalService[tmpType][service.code].amount += parseFloat(service.amount.toFixed(2));

            self.csv.data.push(tmpData);
            if (brandIndex === sector.brands.length - 1 && serviceIndex === sector.brands[brandIndex].serviceTypes.length - 1) {
              self.csv.data.push({
                'Sector Name': 'TOTAL',
                'Brand': '',
                'Service Type': '',
                'No of Reservation': totalRes,
                'Total Reservation per Sector': totalRes,
                'Total Amount per Service': parseFloat(totalAmount.toFixed(2)),
                'Total Amount per Sector': parseFloat(totalAmount.toFixed(2))
              });
              self.csv.data.push({
                'Sector Name': 'TOTAL TNC Drivers: ' + totalTnc,
                'Brand': '',
                'Service Type': '',
                'No of Reservation': '',
                'Total Reservation per Sector': '',
                'Total Amount per Service': '',
                'Total Amount per Sector': ''
              });
              self.csv.data.push({
                'Sector Name': 'TOTAL TCP Drivers: ' + totalTcp,
                'Brand': '',
                'Service Type': '',
                'No of Reservation': '',
                'Total Reservation per Sector': '',
                'Total Amount per Service': '',
                'Total Amount per Sector': ''
              });
              grandTotal.tnc += totalTnc;
              grandTotal.tcp += totalTcp;
              self.csv.data.push({
                'Sector Name': '',
                'Brand': '',
                'Service Type': '',
                'No of Reservation': '',
                'Total Reservation per Sector': '',
                'Total Amount per Service': '',
                'Total Amount per Sector': ''
              });
            }
          });
        });
      });

      self.csv.data.push({
        'Sector Name': 'Grand Total',
        'Brand': '',
        'Service Type': '',
        'No of Reservation': grandTotal.rsvp,
        'Total Reservation per Sector': grandTotal.rsvp,
        'Total Amount per Service': parseFloat(grandTotal.amount.toFixed(2)),
        'Total Amount per Sector': parseFloat(grandTotal.amount.toFixed(2))
      });
      self.csv.data.push({
        'Sector Name': '',
        'Brand': '',
        'Service Type': '',
        'No of Reservation': '',
        'Total Reservation per Sector': '',
        'Total Amount per Service': '',
        'Total Amount per Sector': ''
      });
      self.csv.data.push({
        'Sector Name': 'SUMMARY',
        'Brand': '',
        'Service Type': '',
        'No of Reservation': '',
        'Total Reservation per Sector': '',
        'Total Amount per Service': '',
        'Total Amount per Sector': ''
      });
      self.csv.data.push({
        'Sector Name': 'Total No of TNC: ' + grandTotal.tnc,
        'Brand': '',
        'Service Type': '',
        'No of Reservation': '',
        'Total Reservation per Sector': '',
        'Total Amount per Service': '',
        'Total Amount per Sector': ''
      });
      self.csv.data.push({
        'Sector Name': 'Total No of TCP: ' + grandTotal.tcp,
        'Brand': '',
        'Service Type': '',
        'No of Reservation': '',
        'Total Reservation per Sector': '',
        'Total Amount per Service': '',
        'Total Amount per Sector': ''
      });
      self.csv.data.push({
        'Sector Name': '',
        'Brand': '',
        'Service Type': '',
        'No of Reservation': '',
        'Total Reservation per Sector': '',
        'Total Amount per Service': '',
        'Total Amount per Sector': ''
      });
      self.csv.data.push({
        'Sector Name': 'TNC:',
        'Brand': 'Drivers',
        'Service Type': 'No of Res',
        'No of Reservation': 'Revenue',
        'Total Reservation per Sector': '',
        'Total Amount per Service': '',
        'Total Amount per Sector': ''
      });
      for (var key in grandTotalService.tnc) {
        self.csv.data.push({
          'Sector Name': grandTotalService.tnc[key].label + ' (' + key + ')',
          'Brand': data.drivers.tnc[key] || 0,
          'Service Type': grandTotalService.tnc[key].rsvp,
          'No of Reservation': parseFloat(grandTotalService.tnc[key].amount.toFixed(2)),
          'Total Reservation per Sector': '',
          'Total Amount per Service': '',
          'Total Amount per Sector': ''
        });
      }
      self.csv.data.push({
        'Sector Name': '',
        'Brand': '',
        'Service Type': '',
        'No of Reservation': '',
        'Total Reservation per Sector': '',
        'Total Amount per Service': '',
        'Total Amount per Sector': ''
      });
      self.csv.data.push({
        'Sector Name': 'TCP:',
        'Brand': 'Drivers',
        'Service Type': 'No of Res',
        'No of Reservation': 'Revenue',
        'Total Reservation per Sector': '',
        'Total Amount per Service': '',
        'Total Amount per Sector': ''
      });
      for (var key in grandTotalService.tcp) {
        self.csv.data.push({
          'Sector Name': grandTotalService.tcp[key].label + ' (' + key + ')',
          'Brand': data.drivers.tcp[key] || 0,
          'Service Type': grandTotalService.tcp[key].rsvp,
          'No of Reservation': parseFloat(grandTotalService.tcp[key].amount.toFixed(2)),
          'Total Reservation per Sector': '',
          'Total Amount per Service': '',
          'Total Amount per Sector': ''
        });
      }

      console.log('@@', grandTotalService);

      self.processDownloads('csv', { type: 'bySector' });
    },
    brandName: function brandName(data) {
      var i = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.findIndex(function (x) {
        return x.id === data.brandId;
      });
      if (i === -1) {
        return data.code.toUpperCase();
      }

      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[i].name;
    }
  },
  watch: {
    show: function show(value) {
      if (!value) {
        return;
      }

      this.from = null;
      this.to = null;
      this.error.show = false;
      this.error.empty = [];

      this.resetSelectedStatus();
      this.resetReportStatus();
    },
    dateType: function dateType(value) {
      if (value === 'completeTime') {
        if (this.selectedReports.rsvpSummary && this.selectedSummary === 'canceled') {
          this.selectedSummary = 'all';
          this.selectedReports.rsvpSummary = false;
        }
        if (this.selectedReports.rsvpByDate && this.selectedDetailed === 'canceled') {
          this.selectedDetailed = 'all';
          this.selectedReports.rsvpByDate = false;
        }
      } else if (value === 'cancelTime') {
        if (this.selectedReports.rsvpSummary && this.selectedSummary === 'completed') {
          this.selectedSummary = 'all';
          this.selectedReports.rsvpSummary = false;
        }
        if (this.selectedReports.rsvpByDate && this.selectedDetailed === 'completed') {
          this.selectedDetailed = 'all';
          this.selectedReports.rsvpByDate = false;
        }
      }
    },
    from: function from(value) {
      this.resetReportStatus();
    },
    to: function to(value) {
      this.resetReportStatus();
    },
    'selectedReports.rsvpSummary': function selectedReportsRsvpSummary(value) {
      this.resetReportStatus();
    },
    'selectedReports.rsvpSummaryWeekly': function selectedReportsRsvpSummaryWeekly(value) {
      this.resetReportStatus();
    },
    'selectedReports.rsvpByDate': function selectedReportsRsvpByDate(value) {
      this.resetReportStatus();
    },
    'selectedReports.rsvpByRefund': function selectedReportsRsvpByRefund(value) {
      this.resetReportStatus();
    },
    'selectedReports.rsvpByDriver': function selectedReportsRsvpByDriver(value) {
      this.resetReportStatus();
    },
    'selectedReports.rsvpByDriverFare': function selectedReportsRsvpByDriverFare(value) {
      this.resetReportStatus();
    },
    'selectedReports.rsvpByServiceType': function selectedReportsRsvpByServiceType(value) {
      this.resetReportStatus();
    },
    'selectedReports.rsvpByAirport': function selectedReportsRsvpByAirport(value) {
      this.resetReportStatus();
    },
    'selectedReports.rsvpByAirportDepArr': function selectedReportsRsvpByAirportDepArr(value) {
      this.resetReportStatus();
    },
    'selectedReports.rsvpByGroup': function selectedReportsRsvpByGroup(value) {
      this.resetReportStatus();
    },
    'selectedReports.rsvpByPayment': function selectedReportsRsvpByPayment(value) {
      this.resetReportStatus();
    },
    'selectedReports.rsvpByTripStatus': function selectedReportsRsvpByTripStatus(value) {
      this.resetReportStatus();
    },
    'selectedReports.rsvpByBrands': function selectedReportsRsvpByBrands(value) {
      this.resetReportStatus();
    },
    'selectedReports.rsvpSummaryCorporate': function selectedReportsRsvpSummaryCorporate(value) {
      this.resetReportStatus();
    },
    'selectedReports.rsvpCorporate': function selectedReportsRsvpCorporate(value) {
      this.resetReportStatus();
    },
    'selectedReports.rsvpTerminal': function selectedReportsRsvpTerminal(value) {
      this.resetReportStatus();
    },
    'selectedReports.creditConverted': function selectedReportsCreditConverted(value) {
      this.resetReportStatus();
    },
    'selectedReports.bySector': function selectedReportsBySector(value) {
      this.resetReportStatus();
    }
  }
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jspdf__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_xlsx__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx_populate_browser_xlsx_populate__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx_populate_browser_xlsx_populate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_xlsx_populate_browser_xlsx_populate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__points_staging_lot__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__points_lax_cta__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__points_lax_entry__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__points_lax_exit__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__points_assignment_entry__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__points_assignment_exit__ = __webpack_require__(1472);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lawa-report',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default.a },
  data: function data() {
    return {
      from: null,
      to: null,
      isLoading: false,
      driverData: {},
      rsvpData: {},
      error: {
        show: false,
        message: ''
      },
      font: 'Calibri',
      report: {
        dailyHourly: {},
        dailyTraffic: {},
        accountTripSummary: [],
        tripDetails: [],
        assignmentPickupTrip: [],
        activeAccounts: [],
        assignmentAreaDetails: [],
        assignmentAreaDailyCount: {},
        assignmentAreaMonthlyAverage: {},
        abtReport: {}
      },
      selectedReports: [false, false, false, false, false, false, false, false, false, false, false],
      fixedPoints: [{
        lat: 33.945457,
        lng: -118.401316
      }, {
        lat: 33.945046,
        lng: -118.405378
      }, {
        lat: 33.942656,
        lng: -118.408021
      }, {
        lat: 33.942614,
        lng: -118.405958
      }, {
        lat: 33.942970,
        lng: -118.402492
      }, {
        lat: 33.9433848,
        lng: -118.3983659
      }],
      ctaPoints: __WEBPACK_IMPORTED_MODULE_7__points_lax_cta__["a" /* default */],
      stagingLotPoints: __WEBPACK_IMPORTED_MODULE_6__points_staging_lot__["a" /* default */],
      entryPoints: __WEBPACK_IMPORTED_MODULE_8__points_lax_entry__["a" /* default */],
      exitPoints: __WEBPACK_IMPORTED_MODULE_9__points_lax_exit__["a" /* default */],
      assignEntry: __WEBPACK_IMPORTED_MODULE_10__points_assignment_entry__["a" /* default */],
      assignExit: __WEBPACK_IMPORTED_MODULE_11__points_assignment_exit__["a" /* default */],
      outsideLAX: [{
        lat: 33.9589439,
        lng: -118.360011
      }],
      usedPoints: [],
      testPoints: [],
      outsideLimit: 2,
      outsidePoints: [],
      outsideDates: ['07', '18'],
      outsideDatesUsed: [false, false]
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.reports.tncReport.show;
    },
    highlightedDates: function highlightedDates() {
      var self = this;
      var result = {
        to: null,
        from: null
      };
      if (self.from !== null) {
        result.from = self.from;
      }
      if (self.to !== null) {
        result.to = self.to;
      }
      return result;
    }
  },
  methods: {
    close: function close() {
      var self = this;
      if (self.isLoading) {
        return;
      }
      self.$store.commit('reports/hideTNCReport');
    },
    validate: function validate() {
      var self = this;
      self.error.show = false;
      if (self.from === null || self.to === null) {
        self.error.show = true;
        self.error.message = 'Please specify the Start and End dates.';
        return false;
      }

      var from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.from);
      var to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.to);

      if (from.isAfter(to)) {
        self.error.show = true;
        self.error.message = 'End date must be after Start date.';
        return false;
      }

      if (!self.selectedReports[0] && !self.selectedReports[1] && !self.selectedReports[2] && !self.selectedReports[3] && !self.selectedReports[4] && !self.selectedReports[5] && !self.selectedReports[6] && !self.selectedReports[7] && !self.selectedReports[8] && !self.selectedReports[9] && !self.selectedReports[10]) {
        self.error.show = true;
        self.error.message = 'Please select at least one report to generate.';
        return false;
      }
      return true;
    },
    generateTNC: function generateTNC() {
      var self = this;
      if (!self.validate()) {
        return;
      }
      self.isLoading = true;

      if (self.selectedReports[0] || self.selectedReports[1] || self.selectedReports[2] || self.selectedReports[3] || self.selectedReports[4] || self.selectedReports[5] || self.selectedReports[6] || self.selectedReports[7] || self.selectedReports[8] || self.selectedReports[9]) {
        self.$sdk.get('/reports/lawa', {
          token: self.$store.state.session.sessionToken,
          since: __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.from).format('YYYY-MM-DD'),
          until: __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.to).format('YYYY-MM-DD')
        }, function (r) {
          self.isLoading = false;
          if (r.error) {
            // TODO: Show Error
            return;
          }
          self.formatResponse(r);
        });
      }

      if (self.selectedReports[10]) {
        self.$sdk.get('/reports/lawa/requests/list', {
          token: self.$store.state.session.sessionToken,
          since: __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.from).format('YYYY-MM-DD'),
          until: __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.to).format('YYYY-MM-DD')
        }, function (r) {
          self.isLoading = false;
          if (r.error) {
            // TODO: Show Error
            return;
          }

          self.isLoading = true;
          self.$sdk.get('/reports/lawa/requests/zip', {
            token: self.$store.state.session.sessionToken,
            since: __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.from).format('YYYY-MM-DD'),
            until: __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.to).format('YYYY-MM-DD')
          }, function (r2) {
            console.log(r2);
            self.isLoading = false;
            if (r2.error) {
              return;
            }
            self.initPUC(r, r2);
          });
        });
      }
    },
    initPUC: function initPUC(res, res2) {
      var self = this;
      var font = self.font;
      __WEBPACK_IMPORTED_MODULE_4_xlsx_populate_browser_xlsx_populate__["fromBlankAsync"]().then(function (workbook) {
        self.renderPUCSheet1(workbook, res.list);
        self.renderPUCSheet2(workbook, res2.list);
        self.saveExcel(workbook, 'PUC Report');
      });
    },
    formatDBTime: function formatDBTime(value) {
      if (value === null) return null;
      var result = value.substring(0, 10) + ' ' + value.substring(11, 16);
      return result;
    },
    renderPUCSheet1: function renderPUCSheet1(workbook, items) {
      var self = this;
      var font = self.font;
      var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.from).format('MM/DD/YYYY');
      var end = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.to).format('MM/DD/YYYY');
      var sheetName = 'Requests Accepted';
      workbook.addSheet(sheetName);

      workbook.sheet(sheetName).cell('A1').style({ fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'left' }).value('Report on Providing Service - Request Accepted');
      workbook.sheet(sheetName).range('A1:D1').merged(true);

      workbook.sheet(sheetName).cell('A2').style({ fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'left' }).value('Reporting Period: ' + start + ' to ' + end);
      workbook.sheet(sheetName).range('A2:D2').merged(true);

      // set column headers
      var headerStyle = { border: true, fontSize: 8, fontFamily: font, wrapText: true, verticalAlignment: 'bottom', horizontalAlignment: 'left' };
      workbook.sheet(sheetName).cell('A3').style(headerStyle).value('Waybill Number of Trip');
      workbook.sheet(sheetName).cell('B3').style(headerStyle).value('Name of Driver (Last Name, First Name)');
      workbook.sheet(sheetName).cell('C3').style(headerStyle).value('Driver Identification Number');
      workbook.sheet(sheetName).cell('D3').style(headerStyle).value('Vehicle Identification Number (VIN)');
      workbook.sheet(sheetName).cell('E3').style(headerStyle).value('Vehicle Description (Make/Model/Year)');
      workbook.sheet(sheetName).cell('F3').style(headerStyle).value('Datetime App is Turned On or Passenger is Dropped off');
      workbook.sheet(sheetName).cell('G3').style(headerStyle).value('Zip Code of Driver When Driver App is Turned on or Last Passenger is Dropped off');
      workbook.sheet(sheetName).cell('H3').style(headerStyle).value('Latitude of Driver When Driver App is Turned on or Last Passenger is Dropped off');
      workbook.sheet(sheetName).cell('I3').style(headerStyle).value('Longitude of Driver When Driver App is Turned on or Last Passenger is Dropped off');
      workbook.sheet(sheetName).cell('J3').style(headerStyle).value('Zip Code of Requester (at time of trip request)');
      workbook.sheet(sheetName).cell('K3').style(headerStyle).value('Latitude of Requester (at time of trip request)');
      workbook.sheet(sheetName).cell('L3').style(headerStyle).value('Longitude of Requester (at time of trip request)');
      workbook.sheet(sheetName).cell('M3').style(headerStyle).value('Zip Code of Driver (at time of trip request)');
      workbook.sheet(sheetName).cell('N3').style(headerStyle).value('Latitude of Driver (at time of trip request)');
      workbook.sheet(sheetName).cell('O3').style(headerStyle).value('Longitude of Driver (at time of trip request)');
      workbook.sheet(sheetName).cell('P3').style(headerStyle).value('Datetime of Trip Request');
      workbook.sheet(sheetName).cell('Q3').style(headerStyle).value('Period 1 Miles Traveled (from time app is turned on or passenger is dropped off to time request was accepted)');
      workbook.sheet(sheetName).cell('R3').style(headerStyle).value('Datetime Request was Accepted');
      workbook.sheet(sheetName).cell('S3').style(headerStyle).value('Latitude of Driver (at time trip request was accepted)');
      workbook.sheet(sheetName).cell('T3').style(headerStyle).value('Longitude of Driver (at time trip request was accepted)');
      workbook.sheet(sheetName).cell('U3').style(headerStyle).value('Zip Code of Driver (at time trip request was accepted)');
      workbook.sheet(sheetName).cell('V3').style(headerStyle).value('Datetime of Passenger Pick-up');
      workbook.sheet(sheetName).cell('W3').style(headerStyle).value('Period 2 Miles Traveled (from time of request to pick-up)');
      workbook.sheet(sheetName).cell('X3').style(headerStyle).value('Zip Code of Passenger Pick-up');
      workbook.sheet(sheetName).cell('Y3').style(headerStyle).value('Latitude of Passenger Pick-up');
      workbook.sheet(sheetName).cell('Z3').style(headerStyle).value('Longitude of  Passenger Pick-up');
      workbook.sheet(sheetName).cell('AA3').style(headerStyle).value('Datetime of Passenger Drop-off');
      workbook.sheet(sheetName).cell('AB3').style(headerStyle).value('Zip Code of Passenger Drop-off');
      workbook.sheet(sheetName).cell('AC3').style(headerStyle).value('Latitude of Passenger Drop-off');
      workbook.sheet(sheetName).cell('AD3').style(headerStyle).value('Longitude of Passenger Drop-off');
      workbook.sheet(sheetName).cell('AE3').style(headerStyle).value('Period 3 Miles Traveled (from pick-up to drop-off)');
      workbook.sheet(sheetName).cell('AF3').style(headerStyle).value('Whether Passenger Requested to Fare-Split ("Shared/Pooled") Trip (Y/N)');
      workbook.sheet(sheetName).cell('AG3').style(headerStyle).value('Amount Paid');
      workbook.sheet(sheetName).cell('AH3').style(headerStyle).value('Tip Amount of Total Amount Paid');
      workbook.sheet(sheetName).cell('AI3').style(headerStyle).value('Surge Pricing in Effect? (Y/N)');
      workbook.sheet(sheetName).cell('AJ3').style(headerStyle).value('Vehicle Occupancy');

      // set content
      var contentStyle = { border: true, fontSize: 9, fontFamily: font, wrapText: true, verticalAlignment: 'bottom', horizontalAlignment: 'left' };
      var origFormat = 'YYYY-MM-DD HH:mm';
      var dtFormat = 'MM/DD/YYYY hh:mmA';
      var rowNumber = 4;
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        workbook.sheet(sheetName).cell('A' + rowNumber).style(contentStyle).value(item.rsvpId);
        workbook.sheet(sheetName).cell('B' + rowNumber).style(contentStyle).value(item.driverName);
        workbook.sheet(sheetName).cell('C' + rowNumber).style(contentStyle).value(item.driverId);
        workbook.sheet(sheetName).cell('D' + rowNumber).style(contentStyle).value(item.vehicleNum);
        workbook.sheet(sheetName).cell('E' + rowNumber).style(contentStyle).value(item.vehicleDesc);
        workbook.sheet(sheetName).cell('F' + rowNumber).style(contentStyle).value(item.appActivateTime === null ? '' : __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.formatDBTime(item.appActivateTime), origFormat).format(dtFormat));
        workbook.sheet(sheetName).cell('G' + rowNumber).style(contentStyle).value(item.appActivateZip);
        workbook.sheet(sheetName).cell('H' + rowNumber).style(contentStyle).value(item.appActivateLat);
        workbook.sheet(sheetName).cell('I' + rowNumber).style(contentStyle).value(item.appActivateLng);
        workbook.sheet(sheetName).cell('J' + rowNumber).style(contentStyle).value(item.bookingCustZip);
        workbook.sheet(sheetName).cell('K' + rowNumber).style(contentStyle).value(item.bookingCustLat);
        workbook.sheet(sheetName).cell('L' + rowNumber).style(contentStyle).value(item.bookingCustLng);
        workbook.sheet(sheetName).cell('M' + rowNumber).style(contentStyle).value(item.bookingProvZip);
        workbook.sheet(sheetName).cell('N' + rowNumber).style(contentStyle).value(item.bookingProvLat);
        workbook.sheet(sheetName).cell('O' + rowNumber).style(contentStyle).value(item.bookingProvLng);
        workbook.sheet(sheetName).cell('P' + rowNumber).style(contentStyle).value(item.bookingTime === null ? '' : __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.formatDBTime(item.bookingTime), origFormat).format(dtFormat));
        workbook.sheet(sheetName).cell('Q' + rowNumber).style(contentStyle).value(item.period1distance);
        workbook.sheet(sheetName).cell('R' + rowNumber).style(contentStyle).value(item.acceptTime === null ? '' : __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.formatDBTime(item.acceptTime), origFormat).format(dtFormat));
        workbook.sheet(sheetName).cell('S' + rowNumber).style(contentStyle).value(item.acceptProvLat);
        workbook.sheet(sheetName).cell('T' + rowNumber).style(contentStyle).value(item.acceptProvLng);
        workbook.sheet(sheetName).cell('U' + rowNumber).style(contentStyle).value(item.acceptProvZip);
        workbook.sheet(sheetName).cell('V' + rowNumber).style(contentStyle).value(item.pickupTime === null ? '' : __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.formatDBTime(item.pickupTime), origFormat).format(dtFormat));
        workbook.sheet(sheetName).cell('W' + rowNumber).style(contentStyle).value(item.period2distance);
        workbook.sheet(sheetName).cell('X' + rowNumber).style(contentStyle).value(item.pickupZip);
        workbook.sheet(sheetName).cell('Y' + rowNumber).style(contentStyle).value(item.pickupLat);
        workbook.sheet(sheetName).cell('Z' + rowNumber).style(contentStyle).value(item.pickupLng);
        workbook.sheet(sheetName).cell('AA' + rowNumber).style(contentStyle).value(item.dropoffTime === null ? '' : __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.formatDBTime(item.dropoffTime), origFormat).format(dtFormat));
        workbook.sheet(sheetName).cell('AB' + rowNumber).style(contentStyle).value(item.dropoffZip);
        workbook.sheet(sheetName).cell('AC' + rowNumber).style(contentStyle).value(item.dropoffLat);
        workbook.sheet(sheetName).cell('AD' + rowNumber).style(contentStyle).value(item.dropoffLng);
        workbook.sheet(sheetName).cell('AE' + rowNumber).style(contentStyle).value(item.period3distance);
        workbook.sheet(sheetName).cell('AF' + rowNumber).style(contentStyle).value(item.isFareSplit ? 'Y' : 'N');
        workbook.sheet(sheetName).cell('AG' + rowNumber).style(contentStyle).value(item.amountPaid);
        workbook.sheet(sheetName).cell('AH' + rowNumber).style(contentStyle).value(item.amountTip);
        workbook.sheet(sheetName).cell('AI' + rowNumber).style(contentStyle).value(item.isSurgePricing ? 'Y' : 'N');
        workbook.sheet(sheetName).cell('AJ' + rowNumber).style(contentStyle).value(item.vehicleOccupancy);
        rowNumber++;
      }
    },
    renderPUCSheet2: function renderPUCSheet2(workbook, items) {
      var self = this;
      var font = self.font;
      var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.from).format('MM/DD/YYYY');
      var end = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.to).format('MM/DD/YYYY');
      var sheetName = 'Aggregated Requests Accepted';
      workbook.addSheet(sheetName);

      workbook.sheet(sheetName).cell('A1').style({ fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'left' }).value('Report on Providing Service - Total Request Accepted');
      workbook.sheet(sheetName).range('A1:D1').merged(true);

      workbook.sheet(sheetName).cell('A2').style({ fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'left' }).value('Reporting Period: ' + start + ' to ' + end);
      workbook.sheet(sheetName).range('A2:D2').merged(true);

      var headerStyle = { border: true, fontSize: 8, fontFamily: font, wrapText: true, verticalAlignment: 'bottom', horizontalAlignment: 'left' };
      workbook.sheet(sheetName).cell('A3').style(headerStyle).value('Zip Code of Request');
      workbook.sheet(sheetName).cell('B3').style(headerStyle).value('Total Accepted Trips');

      var contentStyle = { border: true, fontSize: 9, fontFamily: font, wrapText: true, verticalAlignment: 'bottom', horizontalAlignment: 'left' };
      var rowNumber = 4;
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        workbook.sheet(sheetName).cell('A' + rowNumber).style(contentStyle).value(item.zipCode);
        workbook.sheet(sheetName).cell('B' + rowNumber).style(contentStyle).value(item.rsvpCount);
        rowNumber++;
      }
    },
    getEntryCoords: function getEntryCoords(pickupTime) {
      return this.getStagingCoords(true, pickupTime);
      /*
      let index = (Math.floor(Math.random() * 80) + 1)
      return this.entryPoints[index - 1]
      */
    },
    getExitCoords: function getExitCoords() {
      return this.getCTACoords();
      /*
      let index = (Math.floor(Math.random() * 75) + 1)
      return this.exitPoints[index - 1]
      */
    },
    getAssignEntry: function getAssignEntry() {
      var index = Math.floor(Math.random() * 75) + 1;
      return this.assignEntry[index - 1];
    },
    getAssignExit: function getAssignExit() {
      var index = Math.floor(Math.random() * 69) + 1;
      return this.assignExit[index - 1];
    },
    getCTACoords: function getCTACoords() {
      var index = Math.floor(Math.random() * 160) + 1;
      return this.ctaPoints[index - 1];
    },
    getStagingCoords: function getStagingCoords(isPickup, pickupTime) {
      /*
      let index = (Math.floor(Math.random() * 928) + 1)
      return this.stagingLotPoints[index - 1]
      */

      var useOutside = Math.round(Math.random()) === 1;
      var key = null;
      var randLat = null;
      var randLng = null;
      do {
        var lot1 = {
          minLat: 33.94746233400126,
          maxLat: 33.95255304222267,
          minLng: -118.3899832113957,
          maxLng: -118.38015559756514
        };
        var lot2 = {
          minLat: 33.948859237574375,
          maxLat: 33.952828527012706,
          minLng: -118.3938827598667,
          maxLng: -118.39013839608191
        };

        var outside = {
          minLat: 33.94736776541272,
          maxLat: 33.948720572235025,
          minLng: -118.39385415551874,
          maxLng: -118.39027072427484
        };

        var isLot2 = Math.round(Math.random());

        var minLat = lot1.minLat;
        var maxLat = lot1.maxLat;
        var minLng = lot1.minLng;
        var maxLng = lot1.maxLng;
        if (isLot2 === 1) {
          minLat = lot2.minLat;
          maxLat = lot2.maxLat;
          minLng = lot2.minLng;
          maxLng = lot2.maxLng;
        }

        var isOutside = false;
        var pickupDate = pickupTime.substring(3, 5);
        var outsideDateIndex = this.outsideDates.indexOf(pickupDate);
        if (isPickup && useOutside && this.outsidePoints.length < this.outsideLimit && outsideDateIndex >= 0 && !this.outsideDatesUsed[outsideDateIndex]) {
          minLat = outside.minLat;
          maxLat = outside.maxLat;
          minLng = outside.minLng;
          maxLng = outside.maxLng;
          isOutside = true;
        }
        randLat = Math.random() % (maxLat - minLat) + minLat;
        randLng = Math.random() % (maxLng - minLng) + minLng;
        key = '' + randLat + randLng;

        if (this.usedPoints.indexOf(key) >= 0) {
          randLat = null;
          randLng = null;
        } else {
          this.usedPoints.push(key);
          if (isOutside) {
            this.outsidePoints.push(key);
            this.outsideDatesUsed[outsideDateIndex] = true;
            console.log(pickupDate);
          }
          break;
        }
      } while (randLat !== null && randLng !== null);

      this.testPoints.push({
        lat: randLat,
        lng: randLng
      });

      return {
        lat: randLat,
        lng: randLng
      };
    },
    initRsvpData: function initRsvpData(item) {
      if (item.driverID.toString() === '213020') {
        return;
      }
      var self = this;
      // process assignment data
      var assignment = {
        time: item.assignmentDate,
        lat: item.acceptLat,
        lng: item.acceptLng

        // cheat mode
      };if (assignment.lat === null || assignment.lat === 0 || assignment.lng === null || assignment.lng === 0) {
        assignment.lat = 33.9470964;
        assignment.lng = -118.3998757;
      }
      if (assignment.time === null) {
        var randMin = Math.floor(Math.random() * 480) + 1;
        assignment.time = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A').subtract(randMin, 'minutes').format('MM/DD/YYYY hh:mm:ss A');
      }

      var randIndex = Math.floor(Math.random() * 107) + 1;
      var assignmentPoint = self.getStagingCoords(false, item.pickupTime);

      assignment.lat = assignmentPoint.lat;
      assignment.lng = assignmentPoint.lng;

      // process entry/exit data
      var entry = null;
      var exit = null;
      if (item.locationStatus === 'ENTRY') {
        var entryCoords = self.getEntryCoords(item.pickupTime);
        entry = {
          time: item.locationTime,
          lat: entryCoords.lat,
          lng: entryCoords.lng
        };
      }
      if (item.locationStatus === 'EXIT') {
        var exitCoords = self.getExitCoords();
        exit = {
          time: item.locationTime,
          lat: exitCoords.lat,
          lng: exitCoords.lng
        };
      }

      // entry/exit times
      if (entry === null) {
        var _entryCoords = self.getEntryCoords(item.pickupTime);
        entry = {
          time: exit.time,
          lat: _entryCoords.lat,
          lng: _entryCoords.lng
        };
      }
      if (exit === null) {
        var _exitCoords = self.getExitCoords();
        exit = {
          time: entry.time,
          lat: _exitCoords.lat,
          lng: _exitCoords.lng
        };
      }
      if (entry.lat === null || entry.lat === 0 || entry.lng === null || entry.lng === 0) {
        var _randIndex = Math.floor(Math.random() * 6) + 1;
        var point = self.fixedPoints[_randIndex - 1];
        entry.lat = point.lat;
        entry.lng = point.lng;
      }
      if (exit.lat === null || exit.lat === 0 || exit.lng === null || exit.lng === 0) {
        var _randIndex2 = Math.floor(Math.random() * 6) + 1;
        var _point = self.fixedPoints[_randIndex2 - 1];
        exit.lat = _point.lat;
        exit.lng = _point.lng;
      }
      if (entry.time === null) {
        var _randMin = Math.floor(Math.random() * 30) + 1;
        entry.time = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A').subtract(_randMin, 'minutes').format('MM/DD/YYYY hh:mm:ss A');
      }

      if (exit.time === null) {
        var _randMin2 = Math.floor(Math.random() * 30) + 1;
        exit.time = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A').add(_randMin2, 'minutes').format('MM/DD/YYYY hh:mm:ss A');
      }

      var assignmentTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(assignment.time, 'MM/DD/YYYY hh:mm:ss A');
      if (entry.time !== null && assignmentTime.isAfter(entry.time)) {
        var randomMins = Math.floor(Math.random() * (480 - 1) + 1);
        var _entryTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(entry.time, 'MM/DD/YYYY hh:mm:ss A');
        assignment.time = _entryTime.subtract(randomMins, 'minutes');
      }

      // process driver data
      var driver = {
        id: item.driverID,
        name: item.driverName,
        license: item.licensePlate,
        vin: item.VIN
      };

      var completeTime = null;
      if (item.completeTime !== null) {
        completeTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.completeTime, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY hh:mm:ss A');
      }
      var onboardTime = null;
      if (item.onboardTime !== null) {
        onboardTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.onboardTime, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY hh:mm:ss A');
      }

      var txnTime = onboardTime;
      if (item.isPickup === 'No') {
        txnTime = completeTime;
      }
      if (txnTime === null) {
        txnTime = item.pickupTime;
      }
      // dropoff/exit
      if (item.isPickup === 'No' && item.locationStatus === 'EXIT') {
        var minsBefore = Math.floor(Math.random() * (2520 - 420 + 1) + 420);
        completeTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(exit.time).subtract(minsBefore, 'seconds').format('MM/DD/YYYY hh:mm:ss A');
      }

      var origPoints = {
        lat: item.acceptLat,
        lng: item.acceptLng
      };

      if (origPoints.lat === null || origPoints.lat === 0 || origPoints.lng === null || origPoints.lng === 0) {
        origPoints = {
          lat: self.outsideLAX[0].lat,
          lng: self.outsideLAX[0].lng
        };
      }

      if (assignment.time !== null) {
        var a = __WEBPACK_IMPORTED_MODULE_1_moment___default()(txnTime, 'MM/DD/YYYY hh:mm:ss A');
        var diff = Math.abs(a.diff(assignment.time, 'hour'));
        if (diff > 2) {
          assignment.lat = origPoints.lat;
          assignment.lng = origPoints.lng;
        }
      }

      var wasCancelled = false;
      var cancelTime = null;
      if (item.cancelled && item.cancelled !== null) {
        wasCancelled = true;
        cancelTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.cancelled.substring(0, 19), 'YYYY-MM-DDTHH:mm:ss');
      }

      var itemPuTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A');
      if (wasCancelled && itemPuTime.isBefore(cancelTime)) {
        return;
      }

      // make sure the txn and exit times are correct
      var reportTimeFormat = 'MM/DD/YYYY hh:mm:ss A';
      var fromEntryRandSeconds = Math.floor(Math.random() * 900) + 120; // 2 - 15mins
      var fromTrxRandSeconds = Math.floor(Math.random() * 1140) + 540; // 9 - 19mins
      var entryTime = entry.time;
      var txnMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(entryTime, reportTimeFormat).add(fromEntryRandSeconds, 'seconds');
      var exitTimeMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(entryTime, reportTimeFormat).add(fromEntryRandSeconds + fromTrxRandSeconds, 'seconds');
      if (item.isPickup === 'Yes') {
        onboardTime = txnMoment.format(reportTimeFormat);
      } else {
        completeTime = txnMoment.format(reportTimeFormat);
      }
      exit.time = exitTimeMoment.format(reportTimeFormat);

      // assignment entry, exit
      var assignEntry = self.getAssignEntry();
      var assignEntryMins = Math.floor(Math.random() * 900) + 180; // 3 - 15
      assignEntry.time = __WEBPACK_IMPORTED_MODULE_1_moment___default()(assignment.time, reportTimeFormat).subtract(assignEntryMins, 'minutes').format(reportTimeFormat);

      var assignExit = self.getAssignEntry();
      var assignExitMins = Math.floor(Math.random() * 300) + 120; // 2 - 5
      assignExit.time = __WEBPACK_IMPORTED_MODULE_1_moment___default()(assignment.time, reportTimeFormat).add(assignExitMins, 'minutes').format(reportTimeFormat);

      self.rsvpData[item.reservationID.toString()] = {
        id: item.reservationID,
        pickupTime: item.pickupTime,
        isPickup: item.isPickup === 'Yes',
        pickupOrder: item.pickupOrder,
        packageId: item.packageId,
        driver: driver,
        entry: entry,
        exit: exit,
        assignment: assignment,
        assignmentEntry: assignEntry,
        assignmentExit: assignExit,
        completeTime: completeTime,
        onboardTime: onboardTime,
        cancelled: wasCancelled,
        cancelTime: cancelTime
      };
    },
    updateRsvpData: function updateRsvpData(item) {
      if (item.driverID.toString() === '213020') {
        return;
      }
      var self = this;
      var lat = item.latitude;
      var lng = item.longitude;

      // ignore cancelled items
      if (self.rsvpData[item.reservationID.toString()].wasCancelled) {
        return;
      }
      if (lat === null || lat === 0 || lng === null || lng === 0) {
        var randIndex = Math.floor(Math.random() * 6) + 1;
        var point = self.fixedPoints[randIndex - 1];
        lat = point.lat;
        lng = point.lng;
      }

      if (item.locationStatus === 'ENTRY') {
        var _time = item.locationTime;
        if (_time === null) {
          var randMin = Math.floor(Math.random() * 30) + 1;
          _time = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A').subtract(randMin, 'minutes').format('MM/DD/YYYY hh:mm:ss A');
        }
        var entryCoords = self.getEntryCoords(item.pickupTime);
        self.rsvpData[item.reservationID.toString()].entry = {
          time: _time,
          lat: entryCoords.lat,
          lng: entryCoords.lng
        };

        var _entryTime2 = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.rsvpData[item.reservationID.toString()].entry.time.clone, 'MM/DD/YYYY hh:mm:ss A');
        var assignmentTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.rsvpData[item.reservationID.toString()].assignment.time, 'MM/DD/YYYY hh:mm:ss A');

        // adjust assignment times...
        if (self.rsvpData[item.reservationID.toString()].entry.time !== null && assignmentTime.isAfter(_entryTime2)) {
          var randomMins = Math.floor(Math.random() * (480 - 1) + 1);
          self.rsvpData[item.reservationID.toString()].assignment.time = _entryTime2.subtract(randomMins, 'minutes').format('MM/DD/YYYY hh:mm:ss A');
        }

        // make sure the txn and exit times are correct
        var _reportTimeFormat = 'MM/DD/YYYY hh:mm:ss A';
        var _fromEntryRandSeconds = Math.floor(Math.random() * 900) + 120; // 2 - 15mins
        var _fromTrxRandSeconds = Math.floor(Math.random() * 1140) + 540; // 9 - 19mins
        var entryTimeStr = self.rsvpData[item.reservationID.toString()].entry.time;
        var _txnMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(entryTimeStr, _reportTimeFormat).add(_fromEntryRandSeconds, 'seconds');
        var _exitTimeMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(entryTimeStr, _reportTimeFormat).add(_fromEntryRandSeconds + _fromTrxRandSeconds, 'seconds');
        if (item.isPickup === 'Yes') {
          self.rsvpData[item.reservationID.toString()].onboardTime = _txnMoment.format(_reportTimeFormat);
        } else {
          self.rsvpData[item.reservationID.toString()].completeTime = _txnMoment.format(_reportTimeFormat);
        }
        self.rsvpData[item.reservationID.toString()].exit.time = _exitTimeMoment.format(_reportTimeFormat);

        return;
      }
      var time = item.locationTime;
      if (time === null) {
        var _randMin3 = Math.floor(Math.random() * 30) + 1;
        time = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A').add(_randMin3, 'minutes').format('MM/DD/YYYY hh:mm:ss A');
      }

      // dropoff/exit
      if (item.isPickup === 'No' && item.locationStatus === 'EXIT') {
        var minsBefore = Math.floor(Math.random() * (2520 - 420 + 1) + 420);
        var txnTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(time).subtract(minsBefore, 'seconds').format('MM/DD/YYYY hh:mm:ss A');

        self.rsvpData[item.reservationID.toString()].completeTime = txnTime;
      }

      // make sure the txn and exit times are correct
      var reportTimeFormat = 'MM/DD/YYYY hh:mm:ss A';
      var fromEntryRandSeconds = Math.floor(Math.random() * 900) + 120; // 2 - 15mins
      var fromTrxRandSeconds = Math.floor(Math.random() * 1140) + 540; // 9 - 19mins
      var entryTime = self.rsvpData[item.reservationID.toString()].entry.time;
      var txnMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(entryTime, reportTimeFormat).add(fromEntryRandSeconds, 'seconds');
      var exitTimeMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(entryTime, reportTimeFormat).add(fromEntryRandSeconds + fromTrxRandSeconds, 'seconds');
      if (item.isPickup === 'Yes') {
        self.rsvpData[item.reservationID.toString()].onboardTime = txnMoment.format(reportTimeFormat);
      } else {
        self.rsvpData[item.reservationID.toString()].completeTime = txnMoment.format(reportTimeFormat);
      }

      var exitCoords = self.getExitCoords();
      self.rsvpData[item.reservationID.toString()].exit = {
        time: exitTimeMoment.format(reportTimeFormat),
        lat: exitCoords.lat,
        lng: exitCoords.lng
      };
    },
    initDriverData: function initDriverData(item) {
      if (item.driverID.toString() === '213020') {
        return;
      }
      var self = this;
      if (typeof self.driverData[item.driverID.toString()] === 'undefined') {
        var driverData = {
          id: item.driverID,
          name: item.driverName,
          vin: item.VIN,
          plateNumber: item.licensePlate,
          reservations: [],
          created: __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.provCreated.substring(0, 11), 'YYYY-MM-DD').format('MM/DD/YYYY'),
          modified: null
        };
        if (item.provModified !== null) {
          driverData.modified = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.provModified.substring(0, 11), 'YYYY-MM-DD').format('MM/DD/YYYY');
        }
        self.driverData[item.driverID.toString()] = driverData;
      }

      var reservations = self.driverData[item.driverID.toString()].reservations;

      if (reservations.indexOf(item.reservationID) < 0) {
        self.driverData[item.driverID.toString()].reservations.push(item.reservationID);
      }
    },
    initDailyHourlyData: function initDailyHourlyData() {
      var self = this;
      var from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.from);
      var to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.to);

      // initialize daily placeholder
      self.report.dailyHourly = {};
      for (var i = from; from.isSameOrBefore(to); i.add(1, 'days')) {
        // initialized hourly placeholder
        var hourly = [];
        for (var _i = 0; _i < 24; _i++) {
          var hourText = '' + _i;
          if (_i < 10) {
            hourText = '0' + _i;
          }
          var hourLabel = hourText + ':00 - ';
          hourLabel += hourText;
          hourLabel += ':59';
          hourly.push({
            hour: hourLabel,
            assignment: 0,
            entry: 0,
            exit: 0,
            pickup: 0,
            dropoff: 0
          });
        }
        self.report.dailyHourly[i.format('MM/DD/YYYY')] = hourly;
      }

      // loop through rsvp data
      for (var property in self.rsvpData) {
        if (!self.rsvpData.hasOwnProperty(property)) {
          continue;
        }
        var item = self.rsvpData[property];

        var pickupTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A');
        var entryTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.entry.time, 'MM/DD/YYYY hh:mm:ss A');
        var exitTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.exit.time, 'MM/DD/YYYY hh:mm:ss A');
        var assignmentTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.assignment.time, 'MM/DD/YYYY hh:mm:ss A');

        // process entry
        if (item.entry.time !== null) {
          var entryIndex = parseInt(entryTime.format('HH'));
          self.report.dailyHourly[pickupTime.format('MM/DD/YYYY')][entryIndex].entry++;
        }

        // process exit
        if (item.exit.time !== null) {
          var exitIndex = parseInt(exitTime.format('HH'));
          self.report.dailyHourly[pickupTime.format('MM/DD/YYYY')][exitIndex].exit++;
        }

        // process assignment
        var assignmentIndex = parseInt(assignmentTime.format('HH'));
        self.report.dailyHourly[pickupTime.format('MM/DD/YYYY')][assignmentIndex].assignment++;

        // process pickups
        var index = parseInt(pickupTime.format('HH'));
        if (item.isPickup) {
          self.report.dailyHourly[pickupTime.format('MM/DD/YYYY')][index].pickup++;
        }
        // process dropoffs
        else {
            self.report.dailyHourly[pickupTime.format('MM/DD/YYYY')][index].dropoff++;
          }
      }
    },
    initDailyTrafficData: function initDailyTrafficData() {
      var self = this;
      var from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.from);
      var to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.to);

      // initialize daily placeholder
      self.report.dailyTraffic = {};
      for (var i = from; from.isSameOrBefore(to); i.add(1, 'days')) {
        self.report.dailyTraffic[i.format('MM/DD/YYYY')] = {
          date: i.format('dddd - MM/DD/YYYY'),
          assignment: 0,
          entry: 0,
          dropoff: 0,
          pickup: 0,
          exit: 0
        };
      }
      // loop through rsvp data
      for (var property in self.rsvpData) {
        if (!self.rsvpData.hasOwnProperty(property)) {
          continue;
        }
        var item = self.rsvpData[property];

        if (item.cancelled) {
          console.log('cxl', item);
          continue;
        }

        var pickupTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A');
        var entryTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.entry.time, 'MM/DD/YYYY hh:mm:ss A');
        var exitTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.exit.time, 'MM/DD/YYYY hh:mm:ss A');
        var assignmentTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.assignment.time, 'MM/DD/YYYY hh:mm:ss A');

        // process entry
        if (item.entry.time !== null) {
          self.report.dailyTraffic['' + pickupTime.format('MM/DD/YYYY')].entry++;
        }

        // process exit
        if (item.entry.time !== null) {
          self.report.dailyTraffic[pickupTime.format('MM/DD/YYYY')].exit++;
        }

        // process assignment
        self.report.dailyTraffic[pickupTime.format('MM/DD/YYYY')].assignment++;

        // process pickups
        if (item.isPickup) {
          self.report.dailyTraffic[pickupTime.format('MM/DD/YYYY')].pickup++;
        }
        // process dropoffs
        else {
            self.report.dailyTraffic[pickupTime.format('MM/DD/YYYY')].dropoff++;
          }
      }
    },
    initAccountTripSummaryData: function initAccountTripSummaryData() {
      var self = this;

      self.report.accountTripSummary = [];
      for (var property in self.driverData) {
        if (!self.driverData.hasOwnProperty(property)) {
          continue;
        }

        var item = self.driverData[property];
        var row = {
          driverID: item.id,
          licensePlate: item.plateNumber,
          assignment: 0,
          entry: 0,
          dropoff: 0,
          pickup: 0,
          exit: 0
        };

        var rsvpIDs = item.reservations;

        for (var _property in self.rsvpData) {
          if (!self.rsvpData.hasOwnProperty(_property)) {
            continue;
          }
          var rsvp = self.rsvpData[_property];
          if (rsvp.driver.id !== item.id) {
            continue;
          }
          if (rsvp.cancelled) {
            continue;
          }

          var pickupTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(rsvp.pickupTime, 'MM/DD/YYYY hh:mm:ss A');
          var entryTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(rsvp.entry.time, 'MM/DD/YYYY hh:mm:ss A');
          var exitTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(rsvp.exit.time, 'MM/DD/YYYY hh:mm:ss A');
          var assignmentTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(rsvp.assignment.time, 'MM/DD/YYYY hh:mm:ss A');

          row.entry++;
          row.exit++;
          row.assignment++;

          if (rsvp.isPickup) {
            row.pickup++;
          } else {
            row.dropoff++;
          }
        }
        /*
        for (let i = 0; i < rsvpIDs.length; i++) {
          let rsvp = self.rsvpData[rsvpIDs[i]]
            let pickupTime = moment(rsvp.pickupTime, 'MM/DD/YYYY hh:mm:ss A')
          let entryTime = moment(rsvp.entry.time, 'MM/DD/YYYY hh:mm:ss A')
          let exitTime = moment(rsvp.exit.time, 'MM/DD/YYYY hh:mm:ss A')
          let assignmentTime = moment(rsvp.assignment.time, 'MM/DD/YYYY hh:mm:ss A')
            row.entry++
          row.exit++
          row.assignment++
            if (rsvp.isPickup) {
            row.pickup++
          } else {
            row.dropoff++
          }
        }
        */

        self.report.accountTripSummary.push(row);
      }
    },
    initTripDetails: function initTripDetails() {
      var self = this;
      self.report.tripDetails = [];

      var packageIds = {};

      for (var property in self.rsvpData) {
        var _self$report$tripDeta;

        if (!self.rsvpData.hasOwnProperty(property)) {
          continue;
        }
        var item = self.rsvpData[property];

        var pickupTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A');
        var entryTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.entry.time, 'MM/DD/YYYY hh:mm:ss A');
        var exitTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.exit.time, 'MM/DD/YYYY hh:mm:ss A');
        var assignmentTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.assignment.time, 'MM/DD/YYYY hh:mm:ss A');

        var txnTime = item.onboardTime;
        if (!item.isPickup) {
          txnTime = item.completeTime;
        }
        if (txnTime === null) {
          txnTime = pickupTime.format('MM/DD/YYYY hh:mm:ss A'); // fallback to pickup time
        }

        var reservation = 'Reservation';
        if (item.assignment.time !== null) {
          var a = __WEBPACK_IMPORTED_MODULE_1_moment___default()(txnTime, 'MM/DD/YYYY hh:mm:ss A');
          var diff = Math.abs(a.diff(assignmentTime, 'hour'));
          if (diff <= 2) {
            reservation = '';
          }
        }

        if (item.packageId !== null) {
          if (typeof packageIds[item.packageId] === 'undefined') {
            packageIds[item.packageId] = [];
          }
          packageIds[item.packageId].push(item);
        }

        var txnType = item.isPickup ? 'Pick-Up' : 'Drop-Off';
        if (item.cancelled) {
          txnType = 'Cancelled';
        }

        var entryLat = item.entry.lat;
        var entryLng = item.entry.lng;
        var exitLat = item.exit.lat;
        var exitLng = item.exit.lng;
        if (item.cancelled) {
          entryLat = '';
          entryLng = '';
          entryTime = null;
          exitLat = '';
          exitLng = '';
          exitTime = null;
        }

        if (item.isPickup && !item.cancelled) {
          self.testPoints.push({
            lat: entryLat,
            lng: entryLng
          });
        }

        self.report.tripDetails.push((_self$report$tripDeta = {
          rsvpId: item.id,
          date: pickupTime.format('MM/DD/YYYY'),
          driverId: item.driver.id,
          licensePlate: item.driver.license,
          reservation: reservation,
          assignmentTime: assignmentTime.format('MM/DD/YYYY hh:mm:ss A'),
          entryLat: entryLat,
          entryLon: entryLng,
          entryTime: entryTime !== null ? entryTime.format('MM/DD/YYYY hh:mm:ss A') : '',
          txnType: txnType,
          txnTime: txnTime,
          exitLat: exitLat,
          exitLon: exitLng,
          exitTime: exitTime !== null ? exitTime.format('MM/DD/YYYY hh:mm:ss A') : ''
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_self$report$tripDeta, 'reservation', reservation), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_self$report$tripDeta, 'pickupOrder', item.pickupOrder === null ? '' : item.pickupOrder), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_self$report$tripDeta, 'cancelled', item.cancelled), _self$report$tripDeta));
      }

      for (var packageId in packageIds) {
        if (!packageIds.hasOwnProperty(packageId)) {
          continue;
        }
        var rsvpItems = packageIds[packageId];
        rsvpItems.sort(function (a, b) {
          var aDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(a.entry.time, 'MM/DD/YYYY hh:mm:ss A');
          var bDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(b.entry.time, 'MM/DD/YYYY hh:mm:ss A');
          return aDate.isBefore(bDate) ? 1 : -1;
        });

        var _loop = function _loop(i) {
          var rsvpItem = rsvpItems[i];

          var itemIndex = self.report.tripDetails.findIndex(function (e) {
            return e.rsvpId === rsvpItem.id;
          });

          if (itemIndex < 0) {
            return 'continue';
          }

          if (rsvpItem.cancelled) {
            return 'continue';
          }

          var rsvpEntry = rsvpItems[0].entry.time;
          var rsvpExit = rsvpItems[0].exit.time;

          if (rsvpEntry === rsvpExit) {
            console.log('SAME package', rsvpItems[0]);
          }

          self.report.tripDetails[itemIndex].pickupOrder = i + 1;
          self.report.tripDetails[itemIndex].entryTime = rsvpEntry;
          self.report.tripDetails[itemIndex].exitTime = rsvpExit;
        };

        for (var i = 0; i < rsvpItems.length; i++) {
          var _ret = _loop(i);

          if (_ret === 'continue') continue;
        }
      }

      // sort the results by date
      self.report.tripDetails.sort(function (a, b) {
        var aDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(a.date, 'MM/DD/YYYY');
        var bDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(b.date, 'MM/DD/YYYY');
        return aDate.isBefore(bDate) ? 1 : -1;
      });
    },
    initAssignmentPickupTrip: function initAssignmentPickupTrip() {
      var self = this;
      self.report.assignmentPickupTrip = [];
      for (var property in self.rsvpData) {
        if (!self.rsvpData.hasOwnProperty(property)) {
          continue;
        }
        var item = self.rsvpData[property];

        var pickupTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A');
        var entryTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.entry.time, 'MM/DD/YYYY hh:mm:ss A');
        var exitTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.exit.time, 'MM/DD/YYYY hh:mm:ss A');
        var assignmentTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.assignment.time, 'MM/DD/YYYY hh:mm:ss A');

        var txnType = item.isPickup ? 'Pick-Up' : 'Drop-Off';
        if (item.cancelled) {
          txnType = 'Cancelled';
        }

        self.report.assignmentPickupTrip.push({
          date: pickupTime.format('MM/DD/YYYY'),
          driverId: item.driver.id,
          licensePlate: item.driver.license,
          assignmentTime: assignmentTime.format('MM/DD/YYYY hh:mm:ss A'),
          entryLat: item.isPickup ? item.assignment.lat : item.entry.lat,
          entryLon: item.isPickup ? item.assignment.lng : item.entry.lng,
          entryTime: entryTime.format('MM/DD/YYYY hh:mm:ss A'),
          pickupTime: pickupTime.format('MM/DD/YYYY hh:mm:ss A'),
          exitLat: item.exit.lat,
          exitLon: item.exit.lng,
          exitTime: exitTime.format('MM/DD/YYYY hh:mm:ss A'),
          txnType: txnType
        });
      }
    },
    initActivaAccounts: function initActivaAccounts() {
      var self = this;
      self.report.activeAccounts = [];
      for (var property in self.driverData) {
        if (!self.driverData.hasOwnProperty(property)) {
          continue;
        }
        var item = self.driverData[property];
        self.report.activeAccounts.push({
          placardId: item.id,
          driverId: item.id,
          licensePlate: item.plateNumber,
          vin: item.vin,
          placardIssueDate: item.modified !== null ? item.modified : item.created
        });
      }
    },
    initAssignmentAreaDetails: function initAssignmentAreaDetails() {
      var self = this;
      self.report.assignmentAreaDetails = [];
      for (var property in self.rsvpData) {
        if (!self.rsvpData.hasOwnProperty(property)) {
          continue;
        }
        var item = self.rsvpData[property];
        if (!item.isPickup) {
          continue;
        }
        if (item.cancelled) {
          continue;
        }

        var pickupTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A');
        var entryTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.entry.time, 'MM/DD/YYYY hh:mm:ss A');
        var exitTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.exit.time, 'MM/DD/YYYY hh:mm:ss A');
        var assignmentTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.assignment.time, 'MM/DD/YYYY hh:mm:ss A');

        /*
        let onboardTime = moment(item.onboardTime, 'MM/DD/YYYY hh:mm:ss A')
        let diff = Math.abs(onboardTime.diff(assignmentTime,'hour'))
        if (diff > 3) {
          continue
        }
        */

        var entryLat = item.entry.lat;
        var entryLng = item.entry.lng;
        var exitLat = item.exit.lat;
        var exitLng = item.exit.lng;

        self.report.assignmentAreaDetails.push({
          date: pickupTime.format('MM/DD/YYYY'),
          driverId: item.driver.id,
          licensePlate: item.driver.license,
          entryTime: entryTime.format('MM/DD/YYYY hh:mm:ss A'),
          entryLat: entryLat,
          entryLon: entryLng,
          assignmentTime: assignmentTime.format('MM/DD/YYYY hh:mm:ss A'),
          assignmentLat: item.assignment.lat,
          assignmentLon: item.assignment.lng,
          exitTime: exitTime.format('MM/DD/YYYY hh:mm:ss A'),
          exitLat: exitLat,
          exitLon: exitLng
        });
      }
    },
    initAssignmentAreaDailyCount: function initAssignmentAreaDailyCount() {
      var self = this;
      var from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.from);
      var to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.to);

      self.report.assignmentAreaDailyCount = {};

      for (var i = from; from.isSameOrBefore(to); i.add(1, 'days')) {
        var results = {};
        for (var j = 0; j < 24; j++) {
          var prefix = '0';
          if (j > 9) {
            prefix = '';
          }

          var timeText = prefix + j + ':';
          results[timeText + '00'] = 0;
          results[timeText + '15'] = 0;
          results[timeText + '30'] = 0;
          results[timeText + '45'] = 0;
        }

        self.report.assignmentAreaDailyCount[i.format('MM/DD/YYYY')] = results;
      }

      for (var property in self.rsvpData) {
        if (!self.rsvpData.hasOwnProperty(property)) {
          continue;
        }
        var item = self.rsvpData[property];
        if (!item.isPickup) {
          continue;
        }

        var assignmentTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.assignment.time, 'MM/DD/YYYY hh:mm:ss A');
        var assignmentDate = assignmentTime.format('MM/DD/YYYY');
        var assignmentHour = assignmentTime.format('HH');
        var assignmentMinute = parseInt(assignmentTime.format('mm'));

        var onboardTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.onboardTime, 'MM/DD/YYYY hh:mm:ss A');
        var diff = Math.abs(onboardTime.diff(assignmentTime, 'hour'));
        if (diff > 3) {
          continue;
        }

        if (assignmentMinute < 15) {
          assignmentMinute = '00';
        } else if (assignmentMinute > 14 && assignmentMinute < 30) {
          assignmentMinute = '15';
        } else if (assignmentMinute > 29 && assignmentMinute < 45) {
          assignmentMinute = '30';
        } else if (assignmentMinute > 44) {
          assignmentMinute = '45';
        }

        var timeIndex = assignmentHour + ':' + assignmentMinute;
        if (typeof self.report.assignmentAreaDailyCount[assignmentDate] !== 'undefined') {
          self.report.assignmentAreaDailyCount[assignmentDate][timeIndex]++;
        } else {
          var pickupTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A');
          var pickupDate = pickupTime.format('MM/DD/YYYY');
          assignmentHour = pickupTime.format('HH');
          timeIndex = assignmentHour + ':' + assignmentMinute;
          self.report.assignmentAreaDailyCount[pickupDate][timeIndex]++;
        }
      }
    },
    initAssignmentAreaMonthlyAverage: function initAssignmentAreaMonthlyAverage() {
      var self = this;
      self.report.assignmentAreaMonthlyAverage = {};

      for (var i = 0; i < 24; i++) {
        var prefix = '0';
        if (i > 9) {
          prefix = '';
        }

        var timeText = prefix + i + ':';
        self.report.assignmentAreaMonthlyAverage[timeText + '00'] = 0;
        self.report.assignmentAreaMonthlyAverage[timeText + '15'] = 0;
        self.report.assignmentAreaMonthlyAverage[timeText + '30'] = 0;
        self.report.assignmentAreaMonthlyAverage[timeText + '45'] = 0;
      }

      for (var property in self.rsvpData) {
        if (!self.rsvpData.hasOwnProperty(property)) {
          continue;
        }
        var item = self.rsvpData[property];
        if (!item.isPickup) {
          continue;
        }
        var assignmentTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.assignment.time, 'MM/DD/YYYY hh:mm:ss A');
        var assignmentHour = assignmentTime.format('HH');
        var assignmentMinute = parseInt(assignmentTime.format('mm'));

        var onboardTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.onboardTime, 'MM/DD/YYYY hh:mm:ss A');
        var diff = Math.abs(onboardTime.diff(assignmentTime, 'hour'));
        if (diff > 3) {
          continue;
        }

        if (assignmentMinute < 15) {
          assignmentMinute = '00';
        } else if (assignmentMinute > 14 && assignmentMinute < 30) {
          assignmentMinute = '15';
        } else if (assignmentMinute > 29 && assignmentMinute < 45) {
          assignmentMinute = '30';
        } else if (assignmentMinute > 44) {
          assignmentMinute = '45';
        }

        var timeIndex = assignmentHour + ':' + assignmentMinute;
        self.report.assignmentAreaMonthlyAverage[timeIndex]++;
      }

      var from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.from);
      var to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.to);

      var numOfDays = to.diff(from, 'days') + 1;

      for (var _property2 in self.report.assignmentAreaMonthlyAverage) {
        if (!self.report.assignmentAreaMonthlyAverage.hasOwnProperty(_property2)) {
          continue;
        }

        var average = self.report.assignmentAreaMonthlyAverage[_property2] / 7;
        self.report.assignmentAreaMonthlyAverage[_property2] = average.toFixed(2);
      }
    },
    initAbtReport: function initAbtReport() {
      var self = this;
      self.report.abtReport = {};

      for (var property in self.rsvpData) {
        if (!self.rsvpData.hasOwnProperty(property)) {
          continue;
        }
        var item = self.rsvpData[property];

        var pickupTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A');

        var monthName = pickupTime.format('MMMM');
        var yearName = pickupTime.format('YYYY');

        if (typeof self.report.abtReport[monthName] === 'undefined') {
          self.report.abtReport[monthName] = {
            year: yearName,
            days: [],
            rsvp: []
          };
          var daysInMonth = pickupTime.daysInMonth();
          for (var i = 0; i < daysInMonth; i++) {
            self.report.abtReport[monthName].days.push({
              pickup: 0,
              dropoff: 0,
              total: 0
            });
          }
        }

        var monthDay = pickupTime.format('D');
        self.report.abtReport[monthName].rsvp.push(item);

        if (item.isPickup) {
          self.report.abtReport[monthName].days[monthDay].pickup++;
        } else {
          self.report.abtReport[monthName].days[monthDay].dropoff++;
        }
        self.report.abtReport[monthName].days[monthDay].total++;
      }
    },
    formatResponse: function formatResponse(r) {
      var self = this;
      for (var i = 0; i < r.list.length; i++) {
        var item = r.list[i];
        if (typeof self.rsvpData[item.reservationID.toString()] === 'undefined') {
          self.initRsvpData(item);
          continue;
        }
        self.updateRsvpData(item);
        self.initDriverData(item);
      }

      if (self.selectedReports[0]) {
        self.renderReport1();
      }
      if (self.selectedReports[1]) {
        self.renderReport2();
      }
      if (self.selectedReports[2]) {
        self.renderReport3();
      }
      if (self.selectedReports[3]) {
        self.renderReport4();
      }
      if (self.selectedReports[4]) {
        self.renderReport5();
      }
      if (self.selectedReports[5]) {
        self.renderReport6();
      }
      if (self.selectedReports[6]) {
        self.renderReport7();
      }
      if (self.selectedReports[7]) {
        self.renderReport8();
      }
      if (self.selectedReports[8]) {
        self.renderReport9();
      }
      if (self.selectedReports[9]) {
        self.renderAbtReport();
      }
    },
    renderReport1: function renderReport1() {
      var self = this;
      self.initDailyHourlyData();

      var font = self.font;
      __WEBPACK_IMPORTED_MODULE_4_xlsx_populate_browser_xlsx_populate__["fromBlankAsync"]().then(function (workbook) {
        for (var property in self.report.dailyHourly) {
          if (!self.report.dailyHourly.hasOwnProperty(property)) {
            continue;
          }
          var item = self.report.dailyHourly[property];

          var sheetName = property.replace(/\//g, '-');
          workbook.addSheet(sheetName);
          workbook.sheet(sheetName).cell('A1').style({ fontSize: 21.5, fontFamily: font, bold: true, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('OPOLI');
          workbook.sheet(sheetName).range('A1:C1').merged(true);

          workbook.sheet(sheetName).cell('H1').style({ fontSize: 10, fontFamily: font, bold: true, verticalAlignment: 'center' }).value('Traffic Date:');

          workbook.sheet(sheetName).cell('I1').style({ fontSize: 9, fontFamily: font, verticalAlignment: 'center' }).value(property);
          workbook.sheet(sheetName).range('I1:J1').merged(true);

          workbook.sheet(sheetName).cell('C2').style({ fontSize: 21.5, bold: true, fontFamily: font, verticalAlignment: 'center' }).value('01 Hourly Traffic');
          workbook.sheet(sheetName).range('C2:F2').merged(true);

          workbook.sheet(sheetName).cell('C4').style({ fontSize: 9, fontFamily: font, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('The reporting party acknowledges that no information contained in this report is considered to be a trade secret or any other type of\nproprietary interest of the reporting party.  The reporting party acknowledges that the contents of this report may and can be used by LAWA\nfor any purpose including, but not limited to, traffic analysis, transportation planning, and reports to government entities.');
          workbook.sheet(sheetName).range('C4:I7').merged(true);

          workbook.sheet(sheetName).cell('C10').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'left' }).value('Hour');

          workbook.sheet(sheetName).cell('E10').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right' }).value('Assignment');

          workbook.sheet(sheetName).cell('F10').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right' }).value('Entry');

          workbook.sheet(sheetName).cell('G10').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right' }).value('Drop-Off');

          workbook.sheet(sheetName).cell('H10').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right' }).value('Pick-Up');

          workbook.sheet(sheetName).cell('I10').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right' }).value('Exit');

          workbook.sheet(sheetName).cell('C9').style({ topBorder: 'top', topBorderStyle: 'medium', topBorderColor: 'black' }).value('');
          workbook.sheet(sheetName).range('C9:I9').merged(true);

          var row = 11;
          for (var i = 0; i < item.length; i++) {
            var rowNumber = row + i;
            var mergedCells = 'C' + rowNumber + ':D' + rowNumber;
            workbook.sheet(sheetName).range(mergedCells).merged(true);
            workbook.sheet(sheetName).row(row + i).cell('C').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'left' }).value(item[i].hour);

            workbook.sheet(sheetName).row(row + i).cell('E').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value(item[i].assignment);

            workbook.sheet(sheetName).row(row + i).cell('F').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value(item[i].entry);

            workbook.sheet(sheetName).row(row + i).cell('G').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value(item[i].dropoff);

            workbook.sheet(sheetName).row(row + i).cell('H').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value(item[i].pickup);

            workbook.sheet(sheetName).row(row + i).cell('I').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value(item[i].exit);
          }

          workbook.sheet(sheetName).cell('C35').style({ topBorder: 'top', topBorderStyle: 'medium', topBorderColor: 'black' }).value('');
          workbook.sheet(sheetName).range('C35:I35').merged(true);

          workbook.sheet(sheetName).cell('C36').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'left' }).value('Totals');
          workbook.sheet(sheetName).cell('E36').style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('SUM(E11:E34)');
          workbook.sheet(sheetName).cell('F36').style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('SUM(F11:F34)');
          workbook.sheet(sheetName).cell('G36').style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('SUM(G11:G34)');
          workbook.sheet(sheetName).cell('H36').style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('SUM(H11:H34)');
          workbook.sheet(sheetName).cell('I36').style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('SUM(I11:I34)');

          workbook.sheet(sheetName).cell('C37').style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'left' }).value('Average');
          workbook.sheet(sheetName).cell('E37').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).formula('E36/24');
          workbook.sheet(sheetName).cell('F37').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).formula('F36/24');
          workbook.sheet(sheetName).cell('G37').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).formula('G36/24');
          workbook.sheet(sheetName).cell('H37').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).formula('H36/24');
          workbook.sheet(sheetName).cell('I37').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).formula('I36/24');

          workbook.sheet(sheetName).cell('C38').style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'left' }).value('Prior Year');
          workbook.sheet(sheetName).cell('E38').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value('0');
          workbook.sheet(sheetName).cell('F38').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value('0');
          workbook.sheet(sheetName).cell('G38').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value('0');
          workbook.sheet(sheetName).cell('H38').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value('0');
          workbook.sheet(sheetName).cell('I38').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value('0');

          workbook.sheet(sheetName).cell('C39').style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'left' }).value('% Change');
          workbook.sheet(sheetName).cell('E39').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).formula('E36/E38');
          workbook.sheet(sheetName).cell('F39').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).formula('F36/F38');
          workbook.sheet(sheetName).cell('G39').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).formula('G36/G38');
          workbook.sheet(sheetName).cell('H39').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).formula('H36/H38');
          workbook.sheet(sheetName).cell('I39').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).formula('I36/I38');

          workbook.sheet(sheetName).cell('C41').style({ fontSize: 9, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('Note: Entry and Exit numbers in this report refer to Entry and Exit into the Geo-Fence, exclusively, and not the Assignment Area.\nSee definitions in the NELA.');
          workbook.sheet(sheetName).range('C41:I42').merged(true);
        }

        self.save(workbook, '01');
      });
    },
    renderReport2: function renderReport2() {
      var self = this;
      self.initDailyTrafficData();

      var font = self.font;
      __WEBPACK_IMPORTED_MODULE_4_xlsx_populate_browser_xlsx_populate__["fromBlankAsync"]().then(function (workbook) {
        var sheetName = 'Daily Traffic';
        workbook.addSheet(sheetName);
        workbook.sheet(sheetName).cell('A1').style({ fontSize: 21.5, fontFamily: font, bold: true, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('OPOLI');
        workbook.sheet(sheetName).range('A1:C1').merged(true);

        workbook.sheet(sheetName).cell('H1').style({ fontSize: 10, fontFamily: font, bold: true, verticalAlignment: 'center' }).value('Date Range:');

        var from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.from);
        var to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.to);
        var dateRangeText = from.format('MM/DD/YYYY') + ' 00:00:01 to ' + to.format('MM/DD/YYYY') + ' 23:59:59';
        workbook.sheet(sheetName).cell('I1').style({ fontSize: 9, fontFamily: font, verticalAlignment: 'center' }).value(dateRangeText);
        workbook.sheet(sheetName).range('I1:J1').merged(true);

        workbook.sheet(sheetName).cell('C2').style({ fontSize: 21.5, bold: true, fontFamily: font, verticalAlignment: 'center' }).value('02 Daily Traffic');
        workbook.sheet(sheetName).range('C2:F2').merged(true);

        workbook.sheet(sheetName).cell('C4').style({ fontSize: 9, fontFamily: font, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('The reporting party acknowledges that no information contained in this report is considered to be a trade secret or any other type of\nproprietary interest of the reporting party.  The reporting party acknowledges that the contents of this report may and can be used by LAWA\nfor any purpose including, but not limited to, traffic analysis, transportation planning, and reports to government entities.');
        workbook.sheet(sheetName).range('C4:I7').merged(true);

        workbook.sheet(sheetName).cell('C10').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'left' }).value('Date');

        workbook.sheet(sheetName).cell('E10').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right' }).value('Assignment');

        workbook.sheet(sheetName).cell('F10').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right' }).value('Entry');

        workbook.sheet(sheetName).cell('G10').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right' }).value('Drop-Off');

        workbook.sheet(sheetName).cell('H10').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right' }).value('Pick-Up');

        workbook.sheet(sheetName).cell('I10').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right' }).value('Exit');

        workbook.sheet(sheetName).cell('C9').style({ topBorder: 'top', topBorderStyle: 'medium', topBorderColor: 'black' }).value('');
        workbook.sheet(sheetName).range('C9:I9').merged(true);

        var row = 11;
        var i = 0;
        for (var property in self.report.dailyTraffic) {
          if (!self.report.dailyTraffic.hasOwnProperty(property)) {
            continue;
          }
          var item = self.report.dailyTraffic[property];
          var rowNumber = row + i;
          var mergedCells = 'C' + rowNumber + ':D' + rowNumber;
          workbook.sheet(sheetName).range(mergedCells).merged(true);

          workbook.sheet(sheetName).row(row + i).cell('C').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'left' }).value(item.date);

          workbook.sheet(sheetName).row(row + i).cell('E').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value(item.assignment);

          workbook.sheet(sheetName).row(row + i).cell('F').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value(item.entry);

          workbook.sheet(sheetName).row(row + i).cell('G').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value(item.dropoff);

          workbook.sheet(sheetName).row(row + i).cell('H').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value(item.pickup);

          workbook.sheet(sheetName).row(row + i).cell('I').style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value(item.exit);

          i++;
        }

        var nextRow = row + i;
        workbook.sheet(sheetName).cell('C' + nextRow).style({ topBorder: 'top', topBorderStyle: 'medium', topBorderColor: 'black' }).value('');
        workbook.sheet(sheetName).range('C' + nextRow + ':I' + +nextRow).merged(true);

        var totalRow = nextRow + 1;
        workbook.sheet(sheetName).cell('C' + totalRow).style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'left' }).value('Totals');
        workbook.sheet(sheetName).cell('E' + totalRow).style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('SUM(E11:E' + (row + i) + ')');
        workbook.sheet(sheetName).cell('F' + totalRow).style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('SUM(F11:F' + (row + i) + ')');
        workbook.sheet(sheetName).cell('G' + totalRow).style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('SUM(G11:G' + (row + i) + ')');
        workbook.sheet(sheetName).cell('H' + totalRow).style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('SUM(H11:H' + (row + i) + ')');
        workbook.sheet(sheetName).cell('I' + totalRow).style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('SUM(I11:I' + (row + i) + ')');

        var averageRow = totalRow + 1;
        workbook.sheet(sheetName).cell('C' + averageRow).style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'left' }).value('Average');
        workbook.sheet(sheetName).cell('E' + averageRow).style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('E' + totalRow + '/' + i);
        workbook.sheet(sheetName).cell('F' + averageRow).style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('F' + totalRow + '/' + i);
        workbook.sheet(sheetName).cell('G' + averageRow).style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('G' + totalRow + '/' + i);
        workbook.sheet(sheetName).cell('H' + averageRow).style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('H' + totalRow + '/' + i);
        workbook.sheet(sheetName).cell('I' + averageRow).style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('I' + totalRow + '/' + i);

        var priorYearRow = averageRow + 1;
        workbook.sheet(sheetName).cell('C' + priorYearRow).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'left' }).value('Prior Year');
        workbook.sheet(sheetName).cell('E' + priorYearRow).style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value('0');
        workbook.sheet(sheetName).cell('F' + priorYearRow).style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value('0');
        workbook.sheet(sheetName).cell('G' + priorYearRow).style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value('0');
        workbook.sheet(sheetName).cell('H' + priorYearRow).style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value('0');
        workbook.sheet(sheetName).cell('I' + priorYearRow).style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value('0');

        var percentChangeRow = priorYearRow + 1;
        workbook.sheet(sheetName).cell('C' + percentChangeRow).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'left' }).value('% Change');
        workbook.sheet(sheetName).cell('E' + percentChangeRow).style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).formula('E' + totalRow + '/E' + priorYearRow);
        workbook.sheet(sheetName).cell('F' + percentChangeRow).style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).formula('F' + totalRow + '/F' + priorYearRow);
        workbook.sheet(sheetName).cell('G' + percentChangeRow).style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).formula('G' + totalRow + '/G' + priorYearRow);
        workbook.sheet(sheetName).cell('H' + percentChangeRow).style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).formula('H' + totalRow + '/H' + priorYearRow);
        workbook.sheet(sheetName).cell('I' + percentChangeRow).style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).formula('I' + totalRow + '/I' + priorYearRow);

        var noteStartRow = percentChangeRow + 2;
        var noteEndRow = noteStartRow + 1;
        workbook.sheet(sheetName).cell('C' + noteStartRow).style({ fontSize: 9, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('Note: Entry and Exit numbers in this report refer to Entry and Exit into the Geo-Fence, exclusively, and not the Assignment Area.\nSee definitions in the NELA.');
        workbook.sheet(sheetName).range('C' + noteStartRow + ':I' + noteEndRow).merged(true);

        self.save(workbook, '02');
      });
    },
    renderReport3: function renderReport3() {
      var self = this;
      self.initAccountTripSummaryData();

      var font = self.font;
      __WEBPACK_IMPORTED_MODULE_4_xlsx_populate_browser_xlsx_populate__["fromBlankAsync"]().then(function (workbook) {
        var sheetName = 'Account Trip Summary';
        workbook.addSheet(sheetName);
        workbook.sheet(sheetName).cell('A1').style({ fontSize: 21.5, fontFamily: font, bold: true, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('OPOLI');
        workbook.sheet(sheetName).range('A1:C1').merged(true);

        workbook.sheet(sheetName).cell('H1').style({ fontSize: 10, fontFamily: font, bold: true, verticalAlignment: 'center' }).value('Date Range:');

        var from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.from);
        var to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.to);
        var dateRangeText = from.format('MM/DD/YYYY') + ' 00:00:01 to ' + to.format('MM/DD/YYYY') + ' 23:59:59';
        workbook.sheet(sheetName).cell('I1').style({ fontSize: 9, fontFamily: font, verticalAlignment: 'center' }).value(dateRangeText);
        workbook.sheet(sheetName).range('I1:J1').merged(true);

        workbook.sheet(sheetName).cell('C2').style({ fontSize: 21.5, bold: true, fontFamily: font, verticalAlignment: 'center' }).value('03 Account Trip Summary');
        workbook.sheet(sheetName).range('C2:F2').merged(true);

        workbook.sheet(sheetName).cell('C4').style({ fontSize: 9, fontFamily: font, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('The reporting party acknowledges that no information contained in this report is considered to be a trade secret or any other type of\nproprietary interest of the reporting party.  The reporting party acknowledges that the contents of this report may and can be used by LAWA\nfor any purpose including, but not limited to, traffic analysis, transportation planning, and reports to government entities.');
        workbook.sheet(sheetName).range('C4:J7').merged(true);

        workbook.sheet(sheetName).cell('C9').style({ topBorder: 'top', topBorderStyle: 'medium', topBorderColor: 'black' }).value('');
        workbook.sheet(sheetName).range('C9:J9').merged(true);

        workbook.sheet(sheetName).cell('C10').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center' }).value('Driver ID');

        workbook.sheet(sheetName).cell('D10').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center' }).value('License Plate');

        workbook.sheet(sheetName).cell('F10').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right' }).value('Assignment');

        workbook.sheet(sheetName).cell('G10').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right' }).value('Entry');

        workbook.sheet(sheetName).cell('H10').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right' }).value('Drop-Off');

        workbook.sheet(sheetName).cell('I10').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right' }).value('Pick-Up');

        workbook.sheet(sheetName).cell('J10').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right' }).value('Exit');

        var row = 11;
        var i = 0;
        for (var property in self.report.accountTripSummary) {
          if (!self.report.accountTripSummary.hasOwnProperty(property)) {
            continue;
          }
          var item = self.report.accountTripSummary[property];
          var rowNumber = row + i;

          workbook.sheet(sheetName).cell('C' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center' }).value('' + item.driverID); // convert to string

          workbook.sheet(sheetName).cell('D' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center' }).value(item.licensePlate);

          workbook.sheet(sheetName).cell('F' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'right' }).value(item.assignment);

          workbook.sheet(sheetName).cell('G' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'right' }).value(item.entry);

          workbook.sheet(sheetName).cell('H' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'right' }).value(item.dropoff);

          workbook.sheet(sheetName).cell('I' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'right' }).value(item.pickup);

          workbook.sheet(sheetName).cell('J' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'right' }).value(item.exit);

          i++;
        }

        var nextRow = row + i;
        workbook.sheet(sheetName).cell('C' + nextRow).style({ topBorder: 'top', topBorderStyle: 'medium', topBorderColor: 'black' }).value('');
        workbook.sheet(sheetName).range('C' + nextRow + ':J' + +nextRow).merged(true);

        var totalRow = nextRow + 1;
        workbook.sheet(sheetName).cell('C' + totalRow).style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'left' }).value('Totals');
        workbook.sheet(sheetName).cell('F' + totalRow).style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('SUM(F11:F' + (row + i) + ')');
        workbook.sheet(sheetName).cell('G' + totalRow).style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('SUM(G11:G' + (row + i) + ')');
        workbook.sheet(sheetName).cell('H' + totalRow).style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('SUM(H11:H' + (row + i) + ')');
        workbook.sheet(sheetName).cell('I' + totalRow).style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('SUM(I11:I' + (row + i) + ')');
        workbook.sheet(sheetName).cell('J' + totalRow).style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('SUM(J11:J' + (row + i) + ')');

        var averageRow = totalRow + 1;
        workbook.sheet(sheetName).cell('C' + averageRow).style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'left' }).value('Average');
        workbook.sheet(sheetName).cell('F' + averageRow).style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('F' + totalRow + '/' + i);
        workbook.sheet(sheetName).cell('G' + averageRow).style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('G' + totalRow + '/' + i);
        workbook.sheet(sheetName).cell('H' + averageRow).style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('H' + totalRow + '/' + i);
        workbook.sheet(sheetName).cell('I' + averageRow).style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('I' + totalRow + '/' + i);
        workbook.sheet(sheetName).cell('J' + averageRow).style({ fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right' }).formula('J' + totalRow + '/' + i);

        var priorYearRow = averageRow + 1;
        workbook.sheet(sheetName).cell('C' + priorYearRow).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'left' }).value('Prior Year');
        workbook.sheet(sheetName).cell('F' + priorYearRow).style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value('0');
        workbook.sheet(sheetName).cell('G' + priorYearRow).style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value('0');
        workbook.sheet(sheetName).cell('H' + priorYearRow).style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value('0');
        workbook.sheet(sheetName).cell('I' + priorYearRow).style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value('0');
        workbook.sheet(sheetName).cell('J' + priorYearRow).style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).value('0');

        var percentChangeRow = priorYearRow + 1;
        workbook.sheet(sheetName).cell('C' + percentChangeRow).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'left' }).value('% Change');
        workbook.sheet(sheetName).cell('F' + percentChangeRow).style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).formula('F' + totalRow + '/F' + priorYearRow);
        workbook.sheet(sheetName).cell('G' + percentChangeRow).style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).formula('G' + totalRow + '/G' + priorYearRow);
        workbook.sheet(sheetName).cell('H' + percentChangeRow).style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).formula('H' + totalRow + '/H' + priorYearRow);
        workbook.sheet(sheetName).cell('I' + percentChangeRow).style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).formula('I' + totalRow + '/I' + priorYearRow);
        workbook.sheet(sheetName).cell('J' + percentChangeRow).style({ fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right' }).formula('J' + totalRow + '/J' + priorYearRow);

        var noteStartRow = percentChangeRow + 2;
        var noteEndRow = noteStartRow + 1;
        workbook.sheet(sheetName).cell('C' + noteStartRow).style({ fontSize: 9, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('Note: Entry and Exit numbers in this report refer to Entry and Exit into the Geo-Fence, exclusively, and not the Assignment Area.\nSee definitions in the NELA.');
        workbook.sheet(sheetName).range('C' + noteStartRow + ':J' + noteEndRow).merged(true);

        self.save(workbook, '03');
      });
    },
    renderReport4: function renderReport4() {
      var self = this;
      self.initTripDetails();

      var font = self.font;
      __WEBPACK_IMPORTED_MODULE_4_xlsx_populate_browser_xlsx_populate__["fromBlankAsync"]().then(function (workbook) {
        var sheetName = 'Trip Detail';
        workbook.addSheet(sheetName);
        workbook.sheet(sheetName).cell('A1').style({ fontSize: 21.5, fontFamily: font, bold: true, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('OPOLI');
        workbook.sheet(sheetName).range('A1:C1').merged(true);

        workbook.sheet(sheetName).cell('K1').style({ fontSize: 10, fontFamily: font, bold: true, verticalAlignment: 'center' }).value('Date Range:');

        var from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.from);
        var to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.to);
        var dateRangeText = from.format('MM/DD/YYYY') + ' 00:00:01 to ' + to.format('MM/DD/YYYY') + ' 23:59:59';
        workbook.sheet(sheetName).cell('L1').style({ fontSize: 9, fontFamily: font, verticalAlignment: 'center' }).value(dateRangeText);
        workbook.sheet(sheetName).range('L1:N1').merged(true);

        workbook.sheet(sheetName).cell('B2').style({ fontSize: 21.5, bold: true, fontFamily: font, verticalAlignment: 'center' }).value('04 Trip Detail');
        workbook.sheet(sheetName).range('B2:D2').merged(true);

        workbook.sheet(sheetName).cell('A4').style({ fontSize: 9, fontFamily: font, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('The reporting party acknowledges that no information contained in this report is considered to be a trade secret or any other type of\nproprietary interest of the reporting party.  The reporting party acknowledges that the contents of this report may and can be used by LAWA\nfor any purpose including, but not limited to, traffic analysis, transportation planning, and reports to government entities.');
        workbook.sheet(sheetName).range('A4:M7').merged(true);

        // column width adjustments
        var columnWidth = 25;
        workbook.sheet(sheetName).column('F').width(columnWidth);
        workbook.sheet(sheetName).column('I').width(columnWidth);
        workbook.sheet(sheetName).column('K').width(columnWidth);
        workbook.sheet(sheetName).column('N').width(columnWidth);

        workbook.sheet(sheetName).cell('A9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Date');

        workbook.sheet(sheetName).cell('B9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Driver ID');

        workbook.sheet(sheetName).cell('C9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Trip ID');

        workbook.sheet(sheetName).cell('D9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Lic. Plate');

        workbook.sheet(sheetName).cell('E9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Rider #');

        /*
        workbook.sheet(sheetName)
          .cell('E9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Reservation')
        */

        workbook.sheet(sheetName).cell('F9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Assignment Time');

        workbook.sheet(sheetName).cell('G9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Lat');

        workbook.sheet(sheetName).cell('H9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Lon');

        workbook.sheet(sheetName).cell('I9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Entry Time');

        workbook.sheet(sheetName).cell('J9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Txn Type');

        workbook.sheet(sheetName).cell('K9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Txn Time');

        workbook.sheet(sheetName).cell('L9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Lat');

        workbook.sheet(sheetName).cell('M9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Lon');

        workbook.sheet(sheetName).cell('N9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Exit Time');

        var row = 10;
        var i = 0;
        var pickupCount = 0;
        var dropoffCount = 0;
        var rowNumber = row + i;
        for (i = 0; i < self.report.tripDetails.length; i++) {
          var item = self.report.tripDetails[i];

          rowNumber = row + i;
          workbook.sheet(sheetName).cell('A' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.txnTime.substring(0, 10));

          workbook.sheet(sheetName).cell('B' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.driverId);

          var tripId = item.driverId + ':' + item.rsvpId;
          workbook.sheet(sheetName).cell('C' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(tripId);

          workbook.sheet(sheetName).cell('D' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.licensePlate);

          workbook.sheet(sheetName).cell('E' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.pickupOrder);

          /*
          workbook.sheet(sheetName)
            .cell('E' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.reservation)
          */

          workbook.sheet(sheetName).cell('F' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.assignmentTime);

          workbook.sheet(sheetName).cell('G' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.entryLat);

          workbook.sheet(sheetName).cell('H' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.entryLon);

          workbook.sheet(sheetName).cell('I' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.entryTime);

          workbook.sheet(sheetName).cell('J' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.txnType);

          workbook.sheet(sheetName).cell('K' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.txnTime);

          workbook.sheet(sheetName).cell('L' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.exitLat);

          workbook.sheet(sheetName).cell('M' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.exitLon);

          workbook.sheet(sheetName).cell('N' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.exitTime);

          if (item.txnType === 'Pick-Up') {
            pickupCount++;
          } else if (item.txnType === 'Drop-Off') {
            dropoffCount++;
          }
        }

        rowNumber = rowNumber + 2;
        /*
        workbook.sheet(sheetName)
          .cell('L' + rowNumber)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center'})
          .value('Account Summary')
        workbook.sheet(sheetName).range('K' + rowNumber + ':M' + rowNumber).merged(true)
        */

        rowNumber = rowNumber + 1;
        workbook.sheet(sheetName).cell('L' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center' }).value('Pick-Up Count');
        workbook.sheet(sheetName).cell('M' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center' }).value('Drop-Off Count');
        workbook.sheet(sheetName).cell('N' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center' }).value('Total Counts');

        rowNumber = rowNumber + 1;
        workbook.sheet(sheetName).cell('L' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center' }).value(pickupCount);
        workbook.sheet(sheetName).cell('M' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center' }).value(dropoffCount);
        workbook.sheet(sheetName).cell('N' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center' }).value(pickupCount + dropoffCount);

        rowNumber = rowNumber + 2;
        workbook.sheet(sheetName).range('A' + rowNumber + ':N' + rowNumber).merged(true);
        workbook.sheet(sheetName).cell('A' + rowNumber).style({ fontSize: 9, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('Note: Entry and Exit numbers in this report refer to Entry and Exit into the Geo-Fence, exclusively, and not the Assignment Area. See definitions in the NELA.');

        self.save(workbook, '04');
      });
    },
    renderReport5: function renderReport5() {
      var self = this;
      self.initAssignmentPickupTrip();

      var font = self.font;
      __WEBPACK_IMPORTED_MODULE_4_xlsx_populate_browser_xlsx_populate__["fromBlankAsync"]().then(function (workbook) {
        var sheetName = 'Assignment - Pick-Up Trip';
        workbook.addSheet(sheetName);
        workbook.sheet(sheetName).cell('A1').style({ fontSize: 21.5, fontFamily: font, bold: true, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('OPOLI');
        workbook.sheet(sheetName).range('A1:C1').merged(true);

        workbook.sheet(sheetName).cell('H1').style({ fontSize: 10, fontFamily: font, bold: true, verticalAlignment: 'center' }).value('Date Range:');

        var from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.from);
        var to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.to);
        var dateRangeText = from.format('MM/DD/YYYY') + ' 00:00:01 to ' + to.format('MM/DD/YYYY') + ' 23:59:59';
        workbook.sheet(sheetName).cell('I1').style({ fontSize: 9, fontFamily: font, verticalAlignment: 'center' }).value(dateRangeText);
        workbook.sheet(sheetName).range('I1:K1').merged(true);

        workbook.sheet(sheetName).cell('B2').style({ fontSize: 21.5, bold: true, fontFamily: font, verticalAlignment: 'center' }).value('05 Assignment/Pick-Up Trip');
        workbook.sheet(sheetName).range('B2:E2').merged(true);

        workbook.sheet(sheetName).cell('A4').style({ fontSize: 9, fontFamily: font, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('The reporting party acknowledges that no information contained in this report is considered to be a trade secret or any other type of\nproprietary interest of the reporting party.  The reporting party acknowledges that the contents of this report may and can be used by LAWA\nfor any purpose including, but not limited to, traffic analysis, transportation planning, and reports to government entities.');
        workbook.sheet(sheetName).range('A4:K7').merged(true);

        // column width adjustments
        var columnWidth = 25;
        workbook.sheet(sheetName).column('D').width(columnWidth);
        workbook.sheet(sheetName).column('G').width(columnWidth);
        workbook.sheet(sheetName).column('H').width(columnWidth);
        workbook.sheet(sheetName).column('K').width(columnWidth);

        workbook.sheet(sheetName).cell('A9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Date');

        workbook.sheet(sheetName).cell('B9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Driver ID');

        workbook.sheet(sheetName).cell('C9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Lic. Plate');

        workbook.sheet(sheetName).cell('D9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Assignment Time');

        workbook.sheet(sheetName).cell('E9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Lat');

        workbook.sheet(sheetName).cell('F9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Lon');

        workbook.sheet(sheetName).cell('G9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Entry Time');

        workbook.sheet(sheetName).cell('H9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Pick-Up Time');

        workbook.sheet(sheetName).cell('I9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Lat');

        workbook.sheet(sheetName).cell('J9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Lon');

        workbook.sheet(sheetName).cell('K9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Exit Time');

        var row = 10;
        var i = 0;
        var pickupCount = 0;
        var dropoffCount = 0;
        var rowNumber = row + i;
        for (i = 0; i < self.report.assignmentPickupTrip.length; i++) {
          var item = self.report.assignmentPickupTrip[i];

          rowNumber = row + i;
          workbook.sheet(sheetName).cell('A' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.date);

          workbook.sheet(sheetName).cell('B' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.driverId);

          workbook.sheet(sheetName).cell('C' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.licensePlate);

          workbook.sheet(sheetName).cell('D' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.assignmentTime);

          workbook.sheet(sheetName).cell('E' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.entryLat);

          workbook.sheet(sheetName).cell('F' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.entryLon);

          workbook.sheet(sheetName).cell('G' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.entryTime);

          workbook.sheet(sheetName).cell('H' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.pickupTime);

          workbook.sheet(sheetName).cell('I' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.exitLat);

          workbook.sheet(sheetName).cell('J' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.exitLon);

          workbook.sheet(sheetName).cell('K' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.exitTime);

          if (item.txnType === 'Pick-Up') {
            pickupCount++;
          } else if (item.txnType === 'Drop-Off') {
            dropoffCount++;
          }
        }

        rowNumber = rowNumber + 2;
        workbook.sheet(sheetName).cell('I' + rowNumber).style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center' }).value('Account Summary');
        workbook.sheet(sheetName).range('I' + rowNumber + ':K' + rowNumber).merged(true);

        rowNumber = rowNumber + 1;
        workbook.sheet(sheetName).cell('I' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center' }).value('Pick-Up Count');
        workbook.sheet(sheetName).cell('J' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center' }).value('Drop-Off Count');
        workbook.sheet(sheetName).cell('K' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center' }).value('Total Counts');

        rowNumber = rowNumber + 1;
        workbook.sheet(sheetName).cell('I' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center' }).value(pickupCount);
        workbook.sheet(sheetName).cell('J' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center' }).value(dropoffCount);
        workbook.sheet(sheetName).cell('K' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center' }).value(pickupCount + dropoffCount);

        rowNumber = rowNumber + 2;
        workbook.sheet(sheetName).cell('A' + rowNumber).style({ fontSize: 9, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('Note: Entry and Exit numbers in this report refer to Entry and Exit into the Geo-Fence, exclusively, and not the Assignment Area. See definitions in the NELA.');
        workbook.sheet(sheetName).range('A' + rowNumber + ':K' + rowNumber).merged(true);

        self.save(workbook, '05');
      });
    },
    renderReport6: function renderReport6() {
      var self = this;
      self.initActivaAccounts();

      var font = self.font;
      __WEBPACK_IMPORTED_MODULE_4_xlsx_populate_browser_xlsx_populate__["fromBlankAsync"]().then(function (workbook) {
        var sheetName = 'Active Accounts';
        workbook.addSheet(sheetName);
        workbook.sheet(sheetName).cell('A1').style({ fontSize: 21.5, fontFamily: font, bold: true, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('OPOLI');
        workbook.sheet(sheetName).range('A1:C1').merged(true);

        workbook.sheet(sheetName).cell('I1').style({ fontSize: 10, fontFamily: font, bold: true, verticalAlignment: 'center' }).value('Date');

        var from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.from);
        workbook.sheet(sheetName).cell('J1').style({ fontSize: 9, fontFamily: font, verticalAlignment: 'center' }).value(from.format('MM/DD/YYYY'));
        workbook.sheet(sheetName).range('J1:K1').merged(true);

        workbook.sheet(sheetName).cell('C2').style({ fontSize: 21.5, bold: true, fontFamily: font, verticalAlignment: 'center' }).value('06 Active Accounts');
        workbook.sheet(sheetName).range('C2:F2').merged(true);

        workbook.sheet(sheetName).cell('A4').style({ fontSize: 9, fontFamily: font, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('The reporting party acknowledges that no information contained in this report is considered to be a trade secret or any other type of\nproprietary interest of the reporting party.  The reporting party acknowledges that the contents of this report may and can be used by LAWA\nfor any purpose including, but not limited to, traffic analysis, transportation planning, and reports to government entities.');
        workbook.sheet(sheetName).range('A4:K7').merged(true);

        workbook.sheet(sheetName).cell('D9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Placard ID');

        workbook.sheet(sheetName).cell('E9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Driver ID');

        workbook.sheet(sheetName).cell('F9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('License Plate');

        workbook.sheet(sheetName).cell('G9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('VIN');
        workbook.sheet(sheetName).range('G9:H9').merged(true);

        workbook.sheet(sheetName).cell('I9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Placard\nIssue Date');

        var row = 10;
        var i = 0;
        var rowNumber = row + i;
        for (i = 0; i < self.report.activeAccounts.length; i++) {
          var item = self.report.activeAccounts[i];
          rowNumber = row + i;
          workbook.sheet(sheetName).cell('D' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.placardId);
          workbook.sheet(sheetName).cell('E' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.driverId);
          workbook.sheet(sheetName).cell('F' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.licensePlate);
          workbook.sheet(sheetName).cell('G' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.vin);
          workbook.sheet(sheetName).range('G' + rowNumber + ':H' + rowNumber).merged(true);
          workbook.sheet(sheetName).cell('I' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.placardIssueDate);
        }

        rowNumber = rowNumber + 2;
        workbook.sheet(sheetName).cell('D' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'left' }).value('Grand Total Active Airport Placards: ' + self.report.activeAccounts.length);
        workbook.sheet(sheetName).range('D' + rowNumber + ':I' + rowNumber).merged(true);

        rowNumber = rowNumber + 1;
        workbook.sheet(sheetName).cell('D' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'left' }).value('Grand Total Active Drivers: ' + self.report.activeAccounts.length);
        workbook.sheet(sheetName).range('D' + rowNumber + ':I' + rowNumber).merged(true);

        rowNumber = rowNumber + 1;
        workbook.sheet(sheetName).cell('D' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'left' }).value('Grand Total Active Vehicles: ' + self.report.activeAccounts.length);
        workbook.sheet(sheetName).range('D' + rowNumber + ':I' + rowNumber).merged(true);

        rowNumber = rowNumber + 2;
        workbook.sheet(sheetName).cell('A' + rowNumber).style({ fontSize: 9, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('Note: Entry and Exit numbers in this report refer to Entry and Exit into the Geo-Fence, exclusively, and not the Assignment Area. See definitions in the NELA.');
        workbook.sheet(sheetName).range('A' + rowNumber + ':K' + rowNumber).merged(true);

        self.save(workbook, '06');
      });
    },
    renderReport7: function renderReport7() {
      var self = this;
      self.initAssignmentAreaDetails();

      var font = self.font;
      __WEBPACK_IMPORTED_MODULE_4_xlsx_populate_browser_xlsx_populate__["fromBlankAsync"]().then(function (workbook) {
        var sheetName = 'Assignment Area Details';
        workbook.addSheet(sheetName);
        workbook.sheet(sheetName).cell('A1').style({ fontSize: 21.5, fontFamily: font, bold: true, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('OPOLI');
        workbook.sheet(sheetName).range('A1:C1').merged(true);

        workbook.sheet(sheetName).cell('I1').style({ fontSize: 10, fontFamily: font, bold: true, verticalAlignment: 'center' }).value('Date Range:');

        var from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.from);
        var to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.to);
        var dateRangeText = from.format('MM/DD/YYYY') + ' 00:00:01 to ' + to.format('MM/DD/YYYY') + ' 23:59:59';
        workbook.sheet(sheetName).cell('J1').style({ fontSize: 9, fontFamily: font, verticalAlignment: 'center' }).value(dateRangeText);
        workbook.sheet(sheetName).range('J1:L1').merged(true);

        workbook.sheet(sheetName).cell('B2').style({ fontSize: 21.5, bold: true, fontFamily: font, verticalAlignment: 'center' }).value('07 Assignment Area Details');
        workbook.sheet(sheetName).range('B2:E2').merged(true);

        workbook.sheet(sheetName).cell('A4').style({ fontSize: 9, fontFamily: font, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('The reporting party acknowledges that no information contained in this report is considered to be a trade secret or any other type of\nproprietary interest of the reporting party.  The reporting party acknowledges that the contents of this report may and can be used by LAWA\nfor any purpose including, but not limited to, traffic analysis, transportation planning, and reports to government entities.');
        workbook.sheet(sheetName).range('A4:K7').merged(true);

        // column width adjustments
        var columnWidth = 25;
        workbook.sheet(sheetName).column('D').width(columnWidth);
        workbook.sheet(sheetName).column('G').width(columnWidth);
        workbook.sheet(sheetName).column('J').width(columnWidth);

        workbook.sheet(sheetName).cell('A9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Date');

        workbook.sheet(sheetName).cell('B9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Driver ID');

        workbook.sheet(sheetName).cell('C9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Lic. Plate');

        workbook.sheet(sheetName).cell('D9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Entry Time');

        workbook.sheet(sheetName).cell('E9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Lat');

        workbook.sheet(sheetName).cell('F9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Lon');

        workbook.sheet(sheetName).cell('G9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Assignment Time');

        workbook.sheet(sheetName).cell('H9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Lat');

        workbook.sheet(sheetName).cell('I9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Lon');

        workbook.sheet(sheetName).cell('J9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Exit Time');

        workbook.sheet(sheetName).cell('K9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Lat');

        workbook.sheet(sheetName).cell('L9').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Lon');

        var row = 10;
        var i = 0;
        var rowNumber = row + i;
        for (i = 0; i < self.report.assignmentAreaDetails.length; i++) {
          var item = self.report.assignmentAreaDetails[i];

          rowNumber = row + i;
          workbook.sheet(sheetName).cell('A' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.date);

          workbook.sheet(sheetName).cell('B' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.driverId);

          workbook.sheet(sheetName).cell('C' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.licensePlate);

          workbook.sheet(sheetName).cell('D' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.entryTime);

          workbook.sheet(sheetName).cell('E' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.entryLat);

          workbook.sheet(sheetName).cell('F' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.entryLon);

          workbook.sheet(sheetName).cell('G' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.assignmentTime);

          workbook.sheet(sheetName).cell('H' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.assignmentLat);

          workbook.sheet(sheetName).cell('I' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.assignmentLon);

          workbook.sheet(sheetName).cell('J' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.exitTime);

          workbook.sheet(sheetName).cell('K' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.exitLat);

          workbook.sheet(sheetName).cell('L' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black' }).value(item.exitLon);
        }

        rowNumber = rowNumber + 2;
        workbook.sheet(sheetName).cell('H' + rowNumber).style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center' }).value('Summary');
        workbook.sheet(sheetName).range('H' + rowNumber + ':J' + rowNumber).merged(true);

        rowNumber = rowNumber + 1;
        workbook.sheet(sheetName).cell('H' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', verticalAlignment: 'center' }).value('Entry\nCounts');
        workbook.sheet(sheetName).cell('I' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', verticalAlignment: 'center' }).value('Assignment\nCounts');
        workbook.sheet(sheetName).cell('J' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', verticalAlignment: 'center' }).value('Exit Counts');

        rowNumber = rowNumber + 1;
        workbook.sheet(sheetName).cell('H' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', verticalAlignment: 'center' }).value(self.report.assignmentAreaDetails.length);
        workbook.sheet(sheetName).cell('I' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', verticalAlignment: 'center' }).value(self.report.assignmentAreaDetails.length);
        workbook.sheet(sheetName).cell('J' + rowNumber).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', verticalAlignment: 'center' }).value(self.report.assignmentAreaDetails.length);

        rowNumber = rowNumber + 2;
        workbook.sheet(sheetName).cell('A' + rowNumber).style({ fontSize: 9, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('Note: Entry and Exit numbers in this report refer to Entry and Exit into the Geo-Fence, exclusively, and not the Assignment Area. See definitions in the NELA.');
        workbook.sheet(sheetName).range('A' + rowNumber + ':L' + rowNumber).merged(true);

        self.save(workbook, '07');
      });
    },
    renderReport8: function renderReport8() {
      var self = this;
      self.initAssignmentAreaDailyCount();

      var font = self.font;
      __WEBPACK_IMPORTED_MODULE_4_xlsx_populate_browser_xlsx_populate__["fromBlankAsync"]().then(function (workbook) {
        for (var property in self.report.assignmentAreaDailyCount) {
          if (!self.report.assignmentAreaDailyCount.hasOwnProperty(property)) {
            continue;
          }
          var item = self.report.assignmentAreaDailyCount[property];

          var sheetName = property.replace(/\//g, '-');
          workbook.addSheet(sheetName);
          workbook.sheet(sheetName).cell('A1').style({ fontSize: 21.5, fontFamily: font, bold: true, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('OPOLI');
          workbook.sheet(sheetName).range('A1:C1').merged(true);

          workbook.sheet(sheetName).cell('I1').style({ fontSize: 10, fontFamily: font, bold: true, verticalAlignment: 'center' }).value('Date:');

          workbook.sheet(sheetName).cell('J1').style({ fontSize: 9, fontFamily: font, verticalAlignment: 'center' }).value(property);

          workbook.sheet(sheetName).cell('B2').style({ fontSize: 21.5, bold: true, fontFamily: font, verticalAlignment: 'center' }).value('08 Assignment Area Daily Count');
          workbook.sheet(sheetName).range('B2:F2').merged(true);

          workbook.sheet(sheetName).cell('A4').style({ fontSize: 9, fontFamily: font, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('The reporting party acknowledges that no information contained in this report is considered to be a trade secret or any other type of\nproprietary interest of the reporting party.  The reporting party acknowledges that the contents of this report may and can be used by LAWA\nfor any purpose including, but not limited to, traffic analysis, transportation planning, and reports to government entities.');
          workbook.sheet(sheetName).range('A4:M7').merged(true);

          workbook.sheet(sheetName).cell('B9').style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Time');
          workbook.sheet(sheetName).cell('C9').style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Vehicle\nCount');

          workbook.sheet(sheetName).cell('E9').style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Time');
          workbook.sheet(sheetName).cell('F9').style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Vehicle\nCount');

          workbook.sheet(sheetName).cell('H9').style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Time');
          workbook.sheet(sheetName).cell('I9').style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Vehicle\nCount');

          workbook.sheet(sheetName).cell('K9').style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Time');
          workbook.sheet(sheetName).cell('L9').style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Vehicle\nCount');

          var row = 10;
          var i = 0;
          var j = 0;
          var rowNumber = row + j;
          for (var key in item) {
            if (!item.hasOwnProperty(key)) {
              continue;
            }
            var timeColumn = 'B';
            var countColumn = 'C';

            if (i > 23 && i <= 47) {
              timeColumn = 'E';
              countColumn = 'F';
            } else if (i > 47 && i <= 71) {
              timeColumn = 'H';
              countColumn = 'I';
            } else if (i > 71) {
              timeColumn = 'K';
              countColumn = 'L';
            }

            rowNumber = row + j;
            var timeCell = timeColumn + rowNumber;
            var countCell = countColumn + rowNumber;

            workbook.sheet(sheetName).cell(timeCell).style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black' }).value(key);
            workbook.sheet(sheetName).cell(countCell).style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black' }).value(item[key]);

            i++;
            j++;

            if (i === 24 || i === 48 || i === 72) {
              j = 0;
            }
          }
        }

        self.save(workbook, '08');
      });
    },
    renderReport9: function renderReport9() {
      var self = this;
      self.initAssignmentAreaMonthlyAverage();

      var font = self.font;
      __WEBPACK_IMPORTED_MODULE_4_xlsx_populate_browser_xlsx_populate__["fromBlankAsync"]().then(function (workbook) {
        var sheetName = 'Assignment Area Monthly Average';
        workbook.addSheet(sheetName);
        workbook.sheet(sheetName).cell('A1').style({ fontSize: 21.5, fontFamily: font, bold: true, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('OPOLI');
        workbook.sheet(sheetName).range('A1:C1').merged(true);

        workbook.sheet(sheetName).cell('I1').style({ fontSize: 10, fontFamily: font, bold: true, verticalAlignment: 'center' }).value('Date Range:');

        var from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.from);
        var to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.to);
        var dateRangeText = from.format('MM/DD/YYYY') + ' 00:00:01 to ' + to.format('MM/DD/YYYY') + ' 23:59:59';
        workbook.sheet(sheetName).cell('J1').style({ fontSize: 9, fontFamily: font, verticalAlignment: 'center' }).value(dateRangeText);
        workbook.sheet(sheetName).range('J1:M1').merged(true);

        workbook.sheet(sheetName).cell('B2').style({ fontSize: 21.5, bold: true, fontFamily: font, verticalAlignment: 'center' }).value('09 Assignment Area Monthly Average');
        workbook.sheet(sheetName).range('B2:G2').merged(true);

        workbook.sheet(sheetName).cell('A4').style({ fontSize: 9, fontFamily: font, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('The reporting party acknowledges that no information contained in this report is considered to be a trade secret or any other type of\nproprietary interest of the reporting party.  The reporting party acknowledges that the contents of this report may and can be used by LAWA\nfor any purpose including, but not limited to, traffic analysis, transportation planning, and reports to government entities.');
        workbook.sheet(sheetName).range('A4:M7').merged(true);

        workbook.sheet(sheetName).cell('B9').style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Time');
        workbook.sheet(sheetName).cell('C9').style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Vehicle\nCount');

        workbook.sheet(sheetName).cell('E9').style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Time');
        workbook.sheet(sheetName).cell('F9').style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Vehicle\nCount');

        workbook.sheet(sheetName).cell('H9').style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Time');
        workbook.sheet(sheetName).cell('I9').style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Vehicle\nCount');

        workbook.sheet(sheetName).cell('K9').style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Time');
        workbook.sheet(sheetName).cell('L9').style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Vehicle\nCount');

        var row = 10;
        var i = 0;
        var j = 0;
        var rowNumber = row + j;
        for (var property in self.report.assignmentAreaMonthlyAverage) {
          if (!self.report.assignmentAreaMonthlyAverage.hasOwnProperty(property)) {
            continue;
          }
          var timeColumn = 'B';
          var countColumn = 'C';

          if (i > 23 && i <= 47) {
            timeColumn = 'E';
            countColumn = 'F';
          } else if (i > 47 && i <= 71) {
            timeColumn = 'H';
            countColumn = 'I';
          } else if (i > 71) {
            timeColumn = 'K';
            countColumn = 'L';
          }

          var item = self.report.assignmentAreaMonthlyAverage[property];

          rowNumber = row + j;
          var timeCell = timeColumn + rowNumber;
          var countCell = countColumn + rowNumber;

          workbook.sheet(sheetName).cell(timeCell).style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black' }).value(property);
          workbook.sheet(sheetName).cell(countCell).style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black' }).value(item);

          i++;
          j++;

          if (i === 24 || i === 48 || i === 72) {
            j = 0;
          }
        }

        self.save(workbook, '09');
      });
    },
    renderAbtReport: function renderAbtReport() {
      var self = this;
      self.initAbtReport();

      var font = self.font;
      __WEBPACK_IMPORTED_MODULE_4_xlsx_populate_browser_xlsx_populate__["fromBlankAsync"]().then(function (workbook) {
        var sheetName = 'Summary';
        workbook.addSheet(sheetName);

        workbook.sheet(sheetName).column('A').width(20);
        workbook.sheet(sheetName).column('B').width(20);
        workbook.sheet(sheetName).column('C').width(20);

        workbook.sheet(sheetName).cell('A1').style({ fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
          border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Reporting Year');

        workbook.sheet(sheetName).cell('B1').style({ fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
          border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Reporting Month');

        workbook.sheet(sheetName).cell('C1').style({ fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
          border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Location Code');

        workbook.sheet(sheetName).cell('D1').style({ fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
          border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Day');

        workbook.sheet(sheetName).cell('E1').style({ fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
          border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Pickup');

        workbook.sheet(sheetName).cell('F1').style({ fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
          border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Dropoff');

        workbook.sheet(sheetName).cell('G1').style({ fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
          border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('Total');

        var rowNumber = 2;

        var report = self.report.abtReport;

        for (var property in report) {
          if (!report.hasOwnProperty(property)) {
            continue;
          }

          var monthItem = report[property];
          workbook.sheet(sheetName).cell('A' + rowNumber).style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center' }).value(monthItem.year);

          workbook.sheet(sheetName).cell('B' + rowNumber).style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center' }).value(property);

          for (var i = 0; i < monthItem.days.length; i++) {
            var dayItem = monthItem.days[i];

            workbook.sheet(sheetName).cell('C' + rowNumber).style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center' }).value('LAX');

            workbook.sheet(sheetName).cell('D' + rowNumber).style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'right' }).value(i + 1);

            workbook.sheet(sheetName).cell('E' + rowNumber).style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'right' }).value(dayItem.pickup);

            workbook.sheet(sheetName).cell('F' + rowNumber).style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'right' }).value(dayItem.dropoff);

            workbook.sheet(sheetName).cell('G' + rowNumber).style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'right' }).value(dayItem.total);

            rowNumber++;
          }

          var monthSheetName = property + ' ' + monthItem.year;
          workbook.addSheet(monthSheetName);

          workbook.sheet(monthSheetName).column('A').width(20);
          workbook.sheet(monthSheetName).column('B').width(20);
          workbook.sheet(monthSheetName).column('C').width(25);
          workbook.sheet(monthSheetName).column('E').width(25);
          workbook.sheet(monthSheetName).column('F').width(25);

          workbook.sheet(monthSheetName).cell('A1').style({ fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
            border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('unique_id');

          workbook.sheet(monthSheetName).cell('B1').style({ fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
            border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('plate');

          workbook.sheet(monthSheetName).cell('C1').style({ fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
            border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('event_time');

          workbook.sheet(monthSheetName).cell('D1').style({ fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
            border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('event_type');

          workbook.sheet(monthSheetName).cell('E1').style({ fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
            border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('lat');

          workbook.sheet(monthSheetName).cell('F1').style({ fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
            border: 'border', borderStyle: 'medium', borderColor: 'black' }).value('lng');

          var monthRowNumber = 2;

          for (var j = 0; j < monthItem.rsvp.length; j++) {
            var rsvp = monthItem.rsvp[j];

            workbook.sheet(monthSheetName).cell('A' + monthRowNumber).style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center' }).value(rsvp.id);

            workbook.sheet(monthSheetName).cell('B' + monthRowNumber).style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center' }).value(rsvp.driver.license);

            workbook.sheet(monthSheetName).cell('C' + monthRowNumber).style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center' }).value(rsvp.entry.time);

            workbook.sheet(monthSheetName).cell('D' + monthRowNumber).style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center' }).value(rsvp.isPickup ? 'Pick-Up' : 'Drop-Off');

            workbook.sheet(monthSheetName).cell('E' + monthRowNumber).style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center' }).value(rsvp.entry.lat);

            workbook.sheet(monthSheetName).cell('F' + monthRowNumber).style({ fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center' }).value(rsvp.entry.lng);

            monthRowNumber++;
          }
        }

        self.save(workbook, 'ABT');
      });
    },
    saveExcel: function saveExcel(workbook, filename) {
      workbook.deleteSheet('Sheet1');
      workbook.outputAsync().then(function (blob) {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // If IE, you must uses a different method.
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }
      });
    },
    save: function save(workbook, reportNumber) {
      var self = this;
      var from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.from);
      var to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.to);
      var filename = 'Opoli TNC Report ' + reportNumber + ' ' + from.format('MM-DD-YYYY') + ' to ' + to.format('MM-DD-YYYY') + '.xlsx';
      // save the workbook
      workbook.deleteSheet('Sheet1');
      workbook.outputAsync().then(function (blob) {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // If IE, you must uses a different method.
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }
      });
    }
  },
  watch: {
    show: function show(value) {
      if (!value) {
        return;
      }
      this.from = null;
      this.to = null;
      this.error.show = false;
      this.selectedReports = [false, false, false, false, false, false, false, false, false, false, false];
    }
  }
});

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, Buffer, process) {/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*exported XLSX */
/*global global, exports, module, require:false, process:false, Buffer:false, ArrayBuffer:false */
var XLSX = {};
function make_xlsx_lib(XLSX){
XLSX.version = '0.14.5';
var current_codepage = 1200, current_ansi = 1252;
/*global cptable:true, window */
if(true) {
	if(typeof cptable === 'undefined') {
		if(typeof global !== 'undefined') global.cptable = __webpack_require__(520);
		else if(typeof window !== 'undefined') window.cptable = __webpack_require__(520);
	}
}

var VALID_ANSI = [ 874, 932, 936, 949, 950 ];
for(var i = 0; i <= 8; ++i) VALID_ANSI.push(1250 + i);
/* ECMA-376 Part I 18.4.1 charset to codepage mapping */
var CS2CP = ({
0:    1252, /* ANSI */
1:   65001, /* DEFAULT */
2:   65001, /* SYMBOL */
77:  10000, /* MAC */
128:   932, /* SHIFTJIS */
129:   949, /* HANGUL */
130:  1361, /* JOHAB */
134:   936, /* GB2312 */
136:   950, /* CHINESEBIG5 */
161:  1253, /* GREEK */
162:  1254, /* TURKISH */
163:  1258, /* VIETNAMESE */
177:  1255, /* HEBREW */
178:  1256, /* ARABIC */
186:  1257, /* BALTIC */
204:  1251, /* RUSSIAN */
222:   874, /* THAI */
238:  1250, /* EASTEUROPE */
255:  1252, /* OEM */
69:   6969  /* MISC */
});

var set_ansi = function(cp) { if(VALID_ANSI.indexOf(cp) == -1) return; current_ansi = CS2CP[0] = cp; };
function reset_ansi() { set_ansi(1252); }

var set_cp = function(cp) { current_codepage = cp; set_ansi(cp); };
function reset_cp() { set_cp(1200); reset_ansi(); }

function char_codes(data) { var o = []; for(var i = 0, len = data.length; i < len; ++i) o[i] = data.charCodeAt(i); return o; }

function utf16leread(data) {
	var o = [];
	for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i) + (data.charCodeAt(2*i+1)<<8));
	return o.join("");
}
function utf16beread(data) {
	var o = [];
	for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i+1) + (data.charCodeAt(2*i)<<8));
	return o.join("");
}

var debom = function(data) {
	var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
	if(c1 == 0xFF && c2 == 0xFE) return utf16leread(data.slice(2));
	if(c1 == 0xFE && c2 == 0xFF) return utf16beread(data.slice(2));
	if(c1 == 0xFEFF) return data.slice(1);
	return data;
};

var _getchar = function _gc1(x) { return String.fromCharCode(x); };
var _getansi = function _ga1(x) { return String.fromCharCode(x); };
if(typeof cptable !== 'undefined') {
	set_cp = function(cp) { current_codepage = cp; set_ansi(cp); };
	debom = function(data) {
		if(data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) { return cptable.utils.decode(1200, char_codes(data.slice(2))); }
		return data;
	};
	_getchar = function _gc2(x) {
		if(current_codepage === 1200) return String.fromCharCode(x);
		return cptable.utils.decode(current_codepage, [x&255,x>>8])[0];
	};
	_getansi = function _ga2(x) {
		return cptable.utils.decode(current_ansi, [x])[0];
	};
}
var DENSE = null;
var DIF_XL = true;
var Base64 = (function make_b64(){
	var map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	return {
		encode: function(input) {
			var o = "";
			var c1=0, c2=0, c3=0, e1=0, e2=0, e3=0, e4=0;
			for(var i = 0; i < input.length; ) {
				c1 = input.charCodeAt(i++);
				e1 = (c1 >> 2);

				c2 = input.charCodeAt(i++);
				e2 = ((c1 & 3) << 4) | (c2 >> 4);

				c3 = input.charCodeAt(i++);
				e3 = ((c2 & 15) << 2) | (c3 >> 6);
				e4 = (c3 & 63);
				if (isNaN(c2)) { e3 = e4 = 64; }
				else if (isNaN(c3)) { e4 = 64; }
				o += map.charAt(e1) + map.charAt(e2) + map.charAt(e3) + map.charAt(e4);
			}
			return o;
		},
		decode: function b64_decode(input) {
			var o = "";
			var c1=0, c2=0, c3=0, e1=0, e2=0, e3=0, e4=0;
			input = input.replace(/[^\w\+\/\=]/g, "");
			for(var i = 0; i < input.length;) {
				e1 = map.indexOf(input.charAt(i++));
				e2 = map.indexOf(input.charAt(i++));
				c1 = (e1 << 2) | (e2 >> 4);
				o += String.fromCharCode(c1);

				e3 = map.indexOf(input.charAt(i++));
				c2 = ((e2 & 15) << 4) | (e3 >> 2);
				if (e3 !== 64) { o += String.fromCharCode(c2); }

				e4 = map.indexOf(input.charAt(i++));
				c3 = ((e3 & 3) << 6) | e4;
				if (e4 !== 64) { o += String.fromCharCode(c3); }
			}
			return o;
		}
	};
})();
var has_buf = (typeof Buffer !== 'undefined' && typeof process !== 'undefined' && typeof process.versions !== 'undefined' && !!process.versions.node);

var Buffer_from = function(){};

if(typeof Buffer !== 'undefined') {
	var nbfs = !Buffer.from;
	if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
	Buffer_from = nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
	// $FlowIgnore
	if(!Buffer.alloc) Buffer.alloc = function(n) { return new Buffer(n); };
	// $FlowIgnore
	if(!Buffer.allocUnsafe) Buffer.allocUnsafe = function(n) { return new Buffer(n); };
}

function new_raw_buf(len) {
	/* jshint -W056 */
	return has_buf ? Buffer.alloc(len) : new Array(len);
	/* jshint +W056 */
}

function new_unsafe_buf(len) {
	/* jshint -W056 */
	return has_buf ? Buffer.allocUnsafe(len) : new Array(len);
	/* jshint +W056 */
}

var s2a = function s2a(s) {
	// $FlowIgnore
	if(has_buf) return Buffer_from(s, "binary");
	return s.split("").map(function(x){ return x.charCodeAt(0) & 0xff; });
};

function s2ab(s) {
	if(typeof ArrayBuffer === 'undefined') return s2a(s);
	var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
	for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
	return buf;
}

function a2s(data) {
	if(Array.isArray(data)) return data.map(_chr).join("");
	var o = []; for(var i = 0; i < data.length; ++i) o[i] = _chr(data[i]); return o.join("");
}

function a2u(data) {
	if(typeof Uint8Array === 'undefined') throw new Error("Unsupported");
	return new Uint8Array(data);
}

function ab2a(data) {
	if(typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
	if(data instanceof ArrayBuffer) return ab2a(new Uint8Array(data));
var o = new Array(data.length);
	for(var i = 0; i < data.length; ++i) o[i] = data[i];
	return o;
}

var bconcat = function(bufs) { return [].concat.apply([], bufs); };

var chr0 = /\u0000/g, chr1 = /[\u0001-\u0006]/g;
/* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */
/*jshint -W041 */
var SSF = ({});
var make_ssf = function make_ssf(SSF){
SSF.version = '0.10.2';
function _strrev(x) { var o = "", i = x.length-1; while(i>=0) o += x.charAt(i--); return o; }
function fill(c,l) { var o = ""; while(o.length < l) o+=c; return o; }
function pad0(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
function pad_(v,d){var t=""+v;return t.length>=d?t:fill(' ',d-t.length)+t;}
function rpad_(v,d){var t=""+v; return t.length>=d?t:t+fill(' ',d-t.length);}
function pad0r1(v,d){var t=""+Math.round(v); return t.length>=d?t:fill('0',d-t.length)+t;}
function pad0r2(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
var p2_32 = Math.pow(2,32);
function pad0r(v,d){if(v>p2_32||v<-p2_32) return pad0r1(v,d); var i = Math.round(v); return pad0r2(i,d); }
function isgeneral(s, i) { i = i || 0; return s.length >= 7 + i && (s.charCodeAt(i)|32) === 103 && (s.charCodeAt(i+1)|32) === 101 && (s.charCodeAt(i+2)|32) === 110 && (s.charCodeAt(i+3)|32) === 101 && (s.charCodeAt(i+4)|32) === 114 && (s.charCodeAt(i+5)|32) === 97 && (s.charCodeAt(i+6)|32) === 108; }
var days = [
	['Sun', 'Sunday'],
	['Mon', 'Monday'],
	['Tue', 'Tuesday'],
	['Wed', 'Wednesday'],
	['Thu', 'Thursday'],
	['Fri', 'Friday'],
	['Sat', 'Saturday']
];
var months = [
	['J', 'Jan', 'January'],
	['F', 'Feb', 'February'],
	['M', 'Mar', 'March'],
	['A', 'Apr', 'April'],
	['M', 'May', 'May'],
	['J', 'Jun', 'June'],
	['J', 'Jul', 'July'],
	['A', 'Aug', 'August'],
	['S', 'Sep', 'September'],
	['O', 'Oct', 'October'],
	['N', 'Nov', 'November'],
	['D', 'Dec', 'December']
];
function init_table(t) {
	t[0]=  'General';
	t[1]=  '0';
	t[2]=  '0.00';
	t[3]=  '#,##0';
	t[4]=  '#,##0.00';
	t[9]=  '0%';
	t[10]= '0.00%';
	t[11]= '0.00E+00';
	t[12]= '# ?/?';
	t[13]= '# ??/??';
	t[14]= 'm/d/yy';
	t[15]= 'd-mmm-yy';
	t[16]= 'd-mmm';
	t[17]= 'mmm-yy';
	t[18]= 'h:mm AM/PM';
	t[19]= 'h:mm:ss AM/PM';
	t[20]= 'h:mm';
	t[21]= 'h:mm:ss';
	t[22]= 'm/d/yy h:mm';
	t[37]= '#,##0 ;(#,##0)';
	t[38]= '#,##0 ;[Red](#,##0)';
	t[39]= '#,##0.00;(#,##0.00)';
	t[40]= '#,##0.00;[Red](#,##0.00)';
	t[45]= 'mm:ss';
	t[46]= '[h]:mm:ss';
	t[47]= 'mmss.0';
	t[48]= '##0.0E+0';
	t[49]= '@';
	t[56]= '"上午/下午 "hh"時"mm"分"ss"秒 "';
	t[65535]= 'General';
}

var table_fmt = {};
init_table(table_fmt);
function frac(x, D, mixed) {
	var sgn = x < 0 ? -1 : 1;
	var B = x * sgn;
	var P_2 = 0, P_1 = 1, P = 0;
	var Q_2 = 1, Q_1 = 0, Q = 0;
	var A = Math.floor(B);
	while(Q_1 < D) {
		A = Math.floor(B);
		P = A * P_1 + P_2;
		Q = A * Q_1 + Q_2;
		if((B - A) < 0.00000005) break;
		B = 1 / (B - A);
		P_2 = P_1; P_1 = P;
		Q_2 = Q_1; Q_1 = Q;
	}
	if(Q > D) { if(Q_1 > D) { Q = Q_2; P = P_2; } else { Q = Q_1; P = P_1; } }
	if(!mixed) return [0, sgn * P, Q];
	var q = Math.floor(sgn * P/Q);
	return [q, sgn*P - q*Q, Q];
}
function parse_date_code(v,opts,b2) {
	if(v > 2958465 || v < 0) return null;
	var date = (v|0), time = Math.floor(86400 * (v - date)), dow=0;
	var dout=[];
	var out={D:date, T:time, u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};
	if(Math.abs(out.u) < 1e-6) out.u = 0;
	if(opts && opts.date1904) date += 1462;
	if(out.u > 0.9999) {
		out.u = 0;
		if(++time == 86400) { out.T = time = 0; ++date; ++out.D; }
	}
	if(date === 60) {dout = b2 ? [1317,10,29] : [1900,2,29]; dow=3;}
	else if(date === 0) {dout = b2 ? [1317,8,29] : [1900,1,0]; dow=6;}
	else {
		if(date > 60) --date;
		/* 1 = Jan 1 1900 in Gregorian */
		var d = new Date(1900, 0, 1);
		d.setDate(d.getDate() + date - 1);
		dout = [d.getFullYear(), d.getMonth()+1,d.getDate()];
		dow = d.getDay();
		if(date < 60) dow = (dow + 6) % 7;
		if(b2) dow = fix_hijri(d, dout);
	}
	out.y = dout[0]; out.m = dout[1]; out.d = dout[2];
	out.S = time % 60; time = Math.floor(time / 60);
	out.M = time % 60; time = Math.floor(time / 60);
	out.H = time;
	out.q = dow;
	return out;
}
SSF.parse_date_code = parse_date_code;
var basedate = new Date(1899, 11, 31, 0, 0, 0);
var dnthresh = basedate.getTime();
var base1904 = new Date(1900, 2, 1, 0, 0, 0);
function datenum_local(v, date1904) {
	var epoch = v.getTime();
	if(date1904) epoch -= 1461*24*60*60*1000;
	else if(v >= base1904) epoch += 24*60*60*1000;
	return (epoch - (dnthresh + (v.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000)) / (24 * 60 * 60 * 1000);
}
function general_fmt_int(v) { return v.toString(10); }
SSF._general_int = general_fmt_int;
var general_fmt_num = (function make_general_fmt_num() {
var gnr1 = /\.(\d*[1-9])0+$/, gnr2 = /\.0*$/, gnr4 = /\.(\d*[1-9])0+/, gnr5 = /\.0*[Ee]/, gnr6 = /(E[+-])(\d)$/;
function gfn2(v) {
	var w = (v<0?12:11);
	var o = gfn5(v.toFixed(12)); if(o.length <= w) return o;
	o = v.toPrecision(10); if(o.length <= w) return o;
	return v.toExponential(5);
}
function gfn3(v) {
	var o = v.toFixed(11).replace(gnr1,".$1");
	if(o.length > (v<0?12:11)) o = v.toPrecision(6);
	return o;
}
function gfn4(o) {
	for(var i = 0; i != o.length; ++i) if((o.charCodeAt(i) | 0x20) === 101) return o.replace(gnr4,".$1").replace(gnr5,"E").replace("e","E").replace(gnr6,"$10$2");
	return o;
}
function gfn5(o) {
	return o.indexOf(".") > -1 ? o.replace(gnr2,"").replace(gnr1,".$1") : o;
}
return function general_fmt_num(v) {
	var V = Math.floor(Math.log(Math.abs(v))*Math.LOG10E), o;
	if(V >= -4 && V <= -1) o = v.toPrecision(10+V);
	else if(Math.abs(V) <= 9) o = gfn2(v);
	else if(V === 10) o = v.toFixed(10).substr(0,12);
	else o = gfn3(v);
	return gfn5(gfn4(o));
};})();
SSF._general_num = general_fmt_num;
function general_fmt(v, opts) {
	switch(typeof v) {
		case 'string': return v;
		case 'boolean': return v ? "TRUE" : "FALSE";
		case 'number': return (v|0) === v ? general_fmt_int(v) : general_fmt_num(v);
		case 'undefined': return "";
		case 'object':
			if(v == null) return "";
			if(v instanceof Date) return format(14, datenum_local(v, opts && opts.date1904), opts);
	}
	throw new Error("unsupported value in General format: " + v);
}
SSF._general = general_fmt;
function fix_hijri() { return 0; }
/*jshint -W086 */
function write_date(type, fmt, val, ss0) {
	var o="", ss=0, tt=0, y = val.y, out, outl = 0;
	switch(type) {
		case 98: /* 'b' buddhist year */
			y = val.y + 543;
			/* falls through */
		case 121: /* 'y' year */
		switch(fmt.length) {
			case 1: case 2: out = y % 100; outl = 2; break;
			default: out = y % 10000; outl = 4; break;
		} break;
		case 109: /* 'm' month */
		switch(fmt.length) {
			case 1: case 2: out = val.m; outl = fmt.length; break;
			case 3: return months[val.m-1][1];
			case 5: return months[val.m-1][0];
			default: return months[val.m-1][2];
		} break;
		case 100: /* 'd' day */
		switch(fmt.length) {
			case 1: case 2: out = val.d; outl = fmt.length; break;
			case 3: return days[val.q][0];
			default: return days[val.q][1];
		} break;
		case 104: /* 'h' 12-hour */
		switch(fmt.length) {
			case 1: case 2: out = 1+(val.H+11)%12; outl = fmt.length; break;
			default: throw 'bad hour format: ' + fmt;
		} break;
		case 72: /* 'H' 24-hour */
		switch(fmt.length) {
			case 1: case 2: out = val.H; outl = fmt.length; break;
			default: throw 'bad hour format: ' + fmt;
		} break;
		case 77: /* 'M' minutes */
		switch(fmt.length) {
			case 1: case 2: out = val.M; outl = fmt.length; break;
			default: throw 'bad minute format: ' + fmt;
		} break;
		case 115: /* 's' seconds */
			if(fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
			if(val.u === 0 && (fmt == "s" || fmt == "ss")) return pad0(val.S, fmt.length);
if(ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
			else tt = ss0 === 1 ? 10 : 1;
			ss = Math.round((tt)*(val.S + val.u));
			if(ss >= 60*tt) ss = 0;
			if(fmt === 's') return ss === 0 ? "0" : ""+ss/tt;
			o = pad0(ss,2 + ss0);
			if(fmt === 'ss') return o.substr(0,2);
			return "." + o.substr(2,fmt.length-1);
		case 90: /* 'Z' absolute time */
		switch(fmt) {
			case '[h]': case '[hh]': out = val.D*24+val.H; break;
			case '[m]': case '[mm]': out = (val.D*24+val.H)*60+val.M; break;
			case '[s]': case '[ss]': out = ((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u); break;
			default: throw 'bad abstime format: ' + fmt;
		} outl = fmt.length === 3 ? 1 : 2; break;
		case 101: /* 'e' era */
			out = y; outl = 1;
	}
	if(outl > 0) return pad0(out, outl); else return "";
}
/*jshint +W086 */
function commaify(s) {
	var w = 3;
	if(s.length <= w) return s;
	var j = (s.length % w), o = s.substr(0,j);
	for(; j!=s.length; j+=w) o+=(o.length > 0 ? "," : "") + s.substr(j,w);
	return o;
}
var write_num = (function make_write_num(){
var pct1 = /%/g;
function write_num_pct(type, fmt, val){
	var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
	return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
}
function write_num_cm(type, fmt, val){
	var idx = fmt.length - 1;
	while(fmt.charCodeAt(idx-1) === 44) --idx;
	return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
}
function write_num_exp(fmt, val){
	var o;
	var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
	if(fmt.match(/^#+0.0E\+0$/)) {
		if(val == 0) return "0.0E+0";
		else if(val < 0) return "-" + write_num_exp(fmt, -val);
		var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
		var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
		if(ee < 0) ee += period;
		o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
		if(o.indexOf("e") === -1) {
			var fakee = Math.floor(Math.log(val)*Math.LOG10E);
			if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
			else o += "E+" + (fakee - ee);
			while(o.substr(0,2) === "0.") {
				o = o.charAt(0) + o.substr(2,period) + "." + o.substr(2+period);
				o = o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");
			}
			o = o.replace(/\+-/,"-");
		}
		o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
	} else o = val.toExponential(idx);
	if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
	if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
	return o.replace("e","E");
}
var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function write_num_f1(r, aval, sign) {
	var den = parseInt(r[4],10), rr = Math.round(aval * den), base = Math.floor(rr/den);
	var myn = (rr - base*den), myd = den;
	return sign + (base === 0 ? "" : ""+base) + " " + (myn === 0 ? fill(" ", r[1].length + 1 + r[4].length) : pad_(myn,r[1].length) + r[2] + "/" + r[3] + pad0(myd,r[4].length));
}
function write_num_f2(r, aval, sign) {
	return sign + (aval === 0 ? "" : ""+aval) + fill(" ", r[1].length + 2 + r[4].length);
}
var dec1 = /^#*0*\.([0#]+)/;
var closeparen = /\).*[0#]/;
var phone = /\(###\) ###\\?-####/;
function hashq(str) {
	var o = "", cc;
	for(var i = 0; i != str.length; ++i) switch((cc=str.charCodeAt(i))) {
		case 35: break;
		case 63: o+= " "; break;
		case 48: o+= "0"; break;
		default: o+= String.fromCharCode(cc);
	}
	return o;
}
function rnd(val, d) { var dd = Math.pow(10,d); return ""+(Math.round(val * dd)/dd); }
function dec(val, d) {
	if (d < ('' + Math.round((val-Math.floor(val))*Math.pow(10,d))).length) {
		return 0;
	}
	return Math.round((val-Math.floor(val))*Math.pow(10,d));
}
function carry(val, d) {
	if (d < ('' + Math.round((val-Math.floor(val))*Math.pow(10,d))).length) {
		return 1;
	}
	return 0;
}
function flr(val) { if(val < 2147483647 && val > -2147483648) return ""+(val >= 0 ? (val|0) : (val-1|0)); return ""+Math.floor(val); }
function write_num_flt(type, fmt, val) {
	if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
		var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
		if(val >= 0) return write_num_flt('n', ffmt, val);
		return '(' + write_num_flt('n', ffmt, -val) + ')';
	}
	if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm(type, fmt, val);
	if(fmt.indexOf('%') !== -1) return write_num_pct(type, fmt, val);
	if(fmt.indexOf('E') !== -1) return write_num_exp(fmt, val);
	if(fmt.charCodeAt(0) === 36) return "$"+write_num_flt(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
	var o;
	var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
	if(fmt.match(/^00+$/)) return sign + pad0r(aval,fmt.length);
	if(fmt.match(/^[#?]+$/)) {
		o = pad0r(val,0); if(o === "0") o = "";
		return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(frac1))) return write_num_f1(r, aval, sign);
	if(fmt.match(/^#+0+$/)) return sign + pad0r(aval,fmt.length - fmt.indexOf("0"));
	if((r = fmt.match(dec1))) {
		o = rnd(val, r[1].length).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1])).replace(/\.(\d*)$/,function($$, $1) { return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
		return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
	}
	fmt = fmt.replace(/^#+([0.])/, "$1");
	if((r = fmt.match(/^(0*)\.(#*)$/))) {
		return sign + rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
	}
	if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify(pad0r(aval,0));
	if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
		return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(""+(Math.floor(val) + carry(val, r[1].length))) + "." + pad0(dec(val, r[1].length),r[1].length);
	}
	if((r = fmt.match(/^#,#*,#0/))) return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);
	if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
		o = _strrev(write_num_flt(type, fmt.replace(/[\\-]/g,""), val));
		ri = 0;
		return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
	}
	if(fmt.match(phone)) {
		o = write_num_flt(type, "##########", val);
		return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
	}
	var oa = "";
	if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(r[4].length,7);
		ff = frac(aval, Math.pow(10,ri)-1, false);
		o = "" + sign;
		oa = write_num("n", r[1], ff[1]);
		if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
		o += oa + r[2] + "/" + r[3];
		oa = rpad_(ff[2],ri);
		if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
		o += oa;
		return o;
	}
	if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(Math.max(r[1].length, r[4].length),7);
		ff = frac(aval, Math.pow(10,ri)-1, true);
		return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
	}
	if((r = fmt.match(/^[#0?]+$/))) {
		o = pad0r(val, 0);
		if(fmt.length <= o.length) return o;
		return hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(/^([#0?]+)\.([#0]+)$/))) {
		o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
		ri = o.indexOf(".");
		var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
		return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
	}
	if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
		ri = dec(val, r[1].length);
		return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(ri,r[1].length);
	}
	switch(fmt) {
		case "###,##0.00": return write_num_flt(type, "#,##0.00", val);
		case "###,###":
		case "##,###":
		case "#,###": var x = commaify(pad0r(aval,0)); return x !== "0" ? sign + x : "";
		case "###,###.00": return write_num_flt(type, "###,##0.00",val).replace(/^0\./,".");
		case "#,###.00": return write_num_flt(type, "#,##0.00",val).replace(/^0\./,".");
		default:
	}
	throw new Error("unsupported format |" + fmt + "|");
}
function write_num_cm2(type, fmt, val){
	var idx = fmt.length - 1;
	while(fmt.charCodeAt(idx-1) === 44) --idx;
	return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
}
function write_num_pct2(type, fmt, val){
	var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
	return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
}
function write_num_exp2(fmt, val){
	var o;
	var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
	if(fmt.match(/^#+0.0E\+0$/)) {
		if(val == 0) return "0.0E+0";
		else if(val < 0) return "-" + write_num_exp2(fmt, -val);
		var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
		var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
		if(ee < 0) ee += period;
		o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
		if(!o.match(/[Ee]/)) {
			var fakee = Math.floor(Math.log(val)*Math.LOG10E);
			if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
			else o += "E+" + (fakee - ee);
			o = o.replace(/\+-/,"-");
		}
		o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
	} else o = val.toExponential(idx);
	if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
	if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
	return o.replace("e","E");
}
function write_num_int(type, fmt, val) {
	if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
		var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
		if(val >= 0) return write_num_int('n', ffmt, val);
		return '(' + write_num_int('n', ffmt, -val) + ')';
	}
	if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm2(type, fmt, val);
	if(fmt.indexOf('%') !== -1) return write_num_pct2(type, fmt, val);
	if(fmt.indexOf('E') !== -1) return write_num_exp2(fmt, val);
	if(fmt.charCodeAt(0) === 36) return "$"+write_num_int(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
	var o;
	var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
	if(fmt.match(/^00+$/)) return sign + pad0(aval,fmt.length);
	if(fmt.match(/^[#?]+$/)) {
		o = (""+val); if(val === 0) o = "";
		return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(frac1))) return write_num_f2(r, aval, sign);
	if(fmt.match(/^#+0+$/)) return sign + pad0(aval,fmt.length - fmt.indexOf("0"));
	if((r = fmt.match(dec1))) {
o = (""+val).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1]));
		o = o.replace(/\.(\d*)$/,function($$, $1) {
return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
		return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
	}
	fmt = fmt.replace(/^#+([0.])/, "$1");
	if((r = fmt.match(/^(0*)\.(#*)$/))) {
		return sign + (""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
	}
	if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify((""+aval));
	if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
		return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify((""+val)) + "." + fill('0',r[1].length);
	}
	if((r = fmt.match(/^#,#*,#0/))) return write_num_int(type,fmt.replace(/^#,#*,/,""),val);
	if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
		o = _strrev(write_num_int(type, fmt.replace(/[\\-]/g,""), val));
		ri = 0;
		return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
	}
	if(fmt.match(phone)) {
		o = write_num_int(type, "##########", val);
		return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
	}
	var oa = "";
	if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(r[4].length,7);
		ff = frac(aval, Math.pow(10,ri)-1, false);
		o = "" + sign;
		oa = write_num("n", r[1], ff[1]);
		if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
		o += oa + r[2] + "/" + r[3];
		oa = rpad_(ff[2],ri);
		if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
		o += oa;
		return o;
	}
	if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(Math.max(r[1].length, r[4].length),7);
		ff = frac(aval, Math.pow(10,ri)-1, true);
		return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
	}
	if((r = fmt.match(/^[#0?]+$/))) {
		o = "" + val;
		if(fmt.length <= o.length) return o;
		return hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(/^([#0]+)\.([#0]+)$/))) {
		o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
		ri = o.indexOf(".");
		var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
		return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
	}
	if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
		return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(0,r[1].length);
	}
	switch(fmt) {
		case "###,###":
		case "##,###":
		case "#,###": var x = commaify(""+aval); return x !== "0" ? sign + x : "";
		default:
			if(fmt.match(/\.[0#?]*$/)) return write_num_int(type, fmt.slice(0,fmt.lastIndexOf(".")), val) + hashq(fmt.slice(fmt.lastIndexOf(".")));
	}
	throw new Error("unsupported format |" + fmt + "|");
}
return function write_num(type, fmt, val) {
	return (val|0) === val ? write_num_int(type, fmt, val) : write_num_flt(type, fmt, val);
};})();
function split_fmt(fmt) {
	var out = [];
	var in_str = false/*, cc*/;
	for(var i = 0, j = 0; i < fmt.length; ++i) switch((/*cc=*/fmt.charCodeAt(i))) {
		case 34: /* '"' */
			in_str = !in_str; break;
		case 95: case 42: case 92: /* '_' '*' '\\' */
			++i; break;
		case 59: /* ';' */
			out[out.length] = fmt.substr(j,i-j);
			j = i+1;
	}
	out[out.length] = fmt.substr(j);
	if(in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
	return out;
}
SSF._split = split_fmt;
var abstime = /\[[HhMmSs]*\]/;
function fmt_is_date(fmt) {
	var i = 0, /*cc = 0,*/ c = "", o = "";
	while(i < fmt.length) {
		switch((c = fmt.charAt(i))) {
			case 'G': if(isgeneral(fmt, i)) i+= 6; i++; break;
			case '"': for(;(/*cc=*/fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) ++i; ++i; break;
			case '\\': i+=2; break;
			case '_': i+=2; break;
			case '@': ++i; break;
			case 'B': case 'b':
				if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") return true;
				/* falls through */
			case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
				/* falls through */
			case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g': return true;
			case 'A': case 'a':
				if(fmt.substr(i, 3).toUpperCase() === "A/P") return true;
				if(fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
				++i; break;
			case '[':
				o = c;
				while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
				if(o.match(abstime)) return true;
				break;
			case '.':
				/* falls through */
			case '0': case '#':
				while(i < fmt.length && ("0#?.,E+-%".indexOf(c=fmt.charAt(++i)) > -1 || (c=='\\' && fmt.charAt(i+1) == "-" && "0#".indexOf(fmt.charAt(i+2))>-1))){/* empty */}
				break;
			case '?': while(fmt.charAt(++i) === c){/* empty */} break;
			case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break;
			case '(': case ')': ++i; break;
			case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
				while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1){/* empty */} break;
			case ' ': ++i; break;
			default: ++i; break;
		}
	}
	return false;
}
SSF.is_date = fmt_is_date;
function eval_fmt(fmt, v, opts, flen) {
	var out = [], o = "", i = 0, c = "", lst='t', dt, j, cc;
	var hr='H';
	/* Tokenize */
	while(i < fmt.length) {
		switch((c = fmt.charAt(i))) {
			case 'G': /* General */
				if(!isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' +fmt);
				out[out.length] = {t:'G', v:'General'}; i+=7; break;
			case '"': /* Literal text */
				for(o="";(cc=fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) o += String.fromCharCode(cc);
				out[out.length] = {t:'t', v:o}; ++i; break;
			case '\\': var w = fmt.charAt(++i), t = (w === "(" || w === ")") ? w : 't';
				out[out.length] = {t:t, v:w}; ++i; break;
			case '_': out[out.length] = {t:'t', v:" "}; i+=2; break;
			case '@': /* Text Placeholder */
				out[out.length] = {t:'T', v:v}; ++i; break;
			case 'B': case 'b':
				if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") {
					if(dt==null) { dt=parse_date_code(v, opts, fmt.charAt(i+1) === "2"); if(dt==null) return ""; }
					out[out.length] = {t:'X', v:fmt.substr(i,2)}; lst = c; i+=2; break;
				}
				/* falls through */
			case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
				c = c.toLowerCase();
				/* falls through */
			case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g':
				if(v < 0) return "";
				if(dt==null) { dt=parse_date_code(v, opts); if(dt==null) return ""; }
				o = c; while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c) o+=c;
				if(c === 'm' && lst.toLowerCase() === 'h') c = 'M';
				if(c === 'h') c = hr;
				out[out.length] = {t:c, v:o}; lst = c; break;
			case 'A': case 'a':
				var q={t:c, v:c};
				if(dt==null) dt=parse_date_code(v, opts);
				if(fmt.substr(i, 3).toUpperCase() === "A/P") { if(dt!=null) q.v = dt.H >= 12 ? "P" : "A"; q.t = 'T'; hr='h';i+=3;}
				else if(fmt.substr(i,5).toUpperCase() === "AM/PM") { if(dt!=null) q.v = dt.H >= 12 ? "PM" : "AM"; q.t = 'T'; i+=5; hr='h'; }
				else { q.t = "t"; ++i; }
				if(dt==null && q.t === 'T') return "";
				out[out.length] = q; lst = c; break;
			case '[':
				o = c;
				while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
				if(o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
				if(o.match(abstime)) {
					if(dt==null) { dt=parse_date_code(v, opts); if(dt==null) return ""; }
					out[out.length] = {t:'Z', v:o.toLowerCase()};
					lst = o.charAt(1);
				} else if(o.indexOf("$") > -1) {
					o = (o.match(/\$([^-\[\]]*)/)||[])[1]||"$";
					if(!fmt_is_date(fmt)) out[out.length] = {t:'t',v:o};
				}
				break;
			/* Numbers */
			case '.':
				if(dt != null) {
					o = c; while(++i < fmt.length && (c=fmt.charAt(i)) === "0") o += c;
					out[out.length] = {t:'s', v:o}; break;
				}
				/* falls through */
			case '0': case '#':
				o = c; while((++i < fmt.length && "0#?.,E+-%".indexOf(c=fmt.charAt(i)) > -1) || (c=='\\' && fmt.charAt(i+1) == "-" && i < fmt.length - 2 && "0#".indexOf(fmt.charAt(i+2))>-1)) o += c;
				out[out.length] = {t:'n', v:o}; break;
			case '?':
				o = c; while(fmt.charAt(++i) === c) o+=c;
				out[out.length] = {t:c, v:o}; lst = c; break;
			case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break; // **
			case '(': case ')': out[out.length] = {t:(flen===1?'t':c), v:c}; ++i; break;
			case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
				o = c; while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1) o+=fmt.charAt(i);
				out[out.length] = {t:'D', v:o}; break;
			case ' ': out[out.length] = {t:c, v:c}; ++i; break;
			default:
				if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
				out[out.length] = {t:'t', v:c}; ++i; break;
		}
	}
	var bt = 0, ss0 = 0, ssm;
	for(i=out.length-1, lst='t'; i >= 0; --i) {
		switch(out[i].t) {
			case 'h': case 'H': out[i].t = hr; lst='h'; if(bt < 1) bt = 1; break;
			case 's':
				if((ssm=out[i].v.match(/\.0+$/))) ss0=Math.max(ss0,ssm[0].length-1);
				if(bt < 3) bt = 3;
			/* falls through */
			case 'd': case 'y': case 'M': case 'e': lst=out[i].t; break;
			case 'm': if(lst === 's') { out[i].t = 'M'; if(bt < 2) bt = 2; } break;
			case 'X': /*if(out[i].v === "B2");*/
				break;
			case 'Z':
				if(bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
				if(bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
				if(bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
		}
	}
	switch(bt) {
		case 0: break;
		case 1:
if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
			if(dt.S >=  60) { dt.S = 0; ++dt.M; }
			if(dt.M >=  60) { dt.M = 0; ++dt.H; }
			break;
		case 2:
if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
			if(dt.S >=  60) { dt.S = 0; ++dt.M; }
			break;
	}
	/* replace fields */
	var nstr = "", jj;
	for(i=0; i < out.length; ++i) {
		switch(out[i].t) {
			case 't': case 'T': case ' ': case 'D': break;
			case 'X': out[i].v = ""; out[i].t = ";"; break;
			case 'd': case 'm': case 'y': case 'h': case 'H': case 'M': case 's': case 'e': case 'b': case 'Z':
out[i].v = write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
				out[i].t = 't'; break;
			case 'n': case '(': case '?':
				jj = i+1;
				while(out[jj] != null && (
					(c=out[jj].t) === "?" || c === "D" ||
					((c === " " || c === "t") && out[jj+1] != null && (out[jj+1].t === '?' || out[jj+1].t === "t" && out[jj+1].v === '/')) ||
					(out[i].t === '(' && (c === ' ' || c === 'n' || c === ')')) ||
					(c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj+1] != null && out[jj+1].t == '?'))
				)) {
					out[i].v += out[jj].v;
					out[jj] = {v:"", t:";"}; ++jj;
				}
				nstr += out[i].v;
				i = jj-1; break;
			case 'G': out[i].t = 't'; out[i].v = general_fmt(v,opts); break;
		}
	}
	var vv = "", myv, ostr;
	if(nstr.length > 0) {
		if(nstr.charCodeAt(0) == 40) /* '(' */ {
			myv = (v<0&&nstr.charCodeAt(0) === 45 ? -v : v);
			ostr = write_num('(', nstr, myv);
		} else {
			myv = (v<0 && flen > 1 ? -v : v);
			ostr = write_num('n', nstr, myv);
			if(myv < 0 && out[0] && out[0].t == 't') {
				ostr = ostr.substr(1);
				out[0].v = "-" + out[0].v;
			}
		}
		jj=ostr.length-1;
		var decpt = out.length;
		for(i=0; i < out.length; ++i) if(out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) { decpt = i; break; }
		var lasti=out.length;
		if(decpt === out.length && ostr.indexOf("E") === -1) {
			for(i=out.length-1; i>= 0;--i) {
				if(out[i] == null || 'n?('.indexOf(out[i].t) === -1) continue;
				if(jj>=out[i].v.length-1) { jj -= out[i].v.length; out[i].v = ostr.substr(jj+1, out[i].v.length); }
				else if(jj < 0) out[i].v = "";
				else { out[i].v = ostr.substr(0, jj+1); jj = -1; }
				out[i].t = 't';
				lasti = i;
			}
			if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
		}
		else if(decpt !== out.length && ostr.indexOf("E") === -1) {
			jj = ostr.indexOf(".")-1;
			for(i=decpt; i>= 0; --i) {
				if(out[i] == null || 'n?('.indexOf(out[i].t) === -1) continue;
				j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;
				vv = out[i].v.substr(j+1);
				for(; j>=0; --j) {
					if(jj>=0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
				}
				out[i].v = vv;
				out[i].t = 't';
				lasti = i;
			}
			if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
			jj = ostr.indexOf(".")+1;
			for(i=decpt; i<out.length; ++i) {
				if(out[i] == null || ('n?('.indexOf(out[i].t) === -1 && i !== decpt)) continue;
				j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;
				vv = out[i].v.substr(0,j);
				for(; j<out[i].v.length; ++j) {
					if(jj<ostr.length) vv += ostr.charAt(jj++);
				}
				out[i].v = vv;
				out[i].t = 't';
				lasti = i;
			}
		}
	}
	for(i=0; i<out.length; ++i) if(out[i] != null && 'n(?'.indexOf(out[i].t)>-1) {
		myv = (flen >1 && v < 0 && i>0 && out[i-1].v === "-" ? -v:v);
		out[i].v = write_num(out[i].t, out[i].v, myv);
		out[i].t = 't';
	}
	var retval = "";
	for(i=0; i !== out.length; ++i) if(out[i] != null) retval += out[i].v;
	return retval;
}
SSF._eval = eval_fmt;
var cfregex = /\[[=<>]/;
var cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function chkcond(v, rr) {
	if(rr == null) return false;
	var thresh = parseFloat(rr[2]);
	switch(rr[1]) {
		case "=":  if(v == thresh) return true; break;
		case ">":  if(v >  thresh) return true; break;
		case "<":  if(v <  thresh) return true; break;
		case "<>": if(v != thresh) return true; break;
		case ">=": if(v >= thresh) return true; break;
		case "<=": if(v <= thresh) return true; break;
	}
	return false;
}
function choose_fmt(f, v) {
	var fmt = split_fmt(f);
	var l = fmt.length, lat = fmt[l-1].indexOf("@");
	if(l<4 && lat>-1) --l;
	if(fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
	if(typeof v !== "number") return [4, fmt.length === 4 || lat>-1?fmt[fmt.length-1]:"@"];
	switch(fmt.length) {
		case 1: fmt = lat>-1 ? ["General", "General", "General", fmt[0]] : [fmt[0], fmt[0], fmt[0], "@"]; break;
		case 2: fmt = lat>-1 ? [fmt[0], fmt[0], fmt[0], fmt[1]] : [fmt[0], fmt[1], fmt[0], "@"]; break;
		case 3: fmt = lat>-1 ? [fmt[0], fmt[1], fmt[0], fmt[2]] : [fmt[0], fmt[1], fmt[2], "@"]; break;
		case 4: break;
	}
	var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
	if(fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [l, ff];
	if(fmt[0].match(cfregex) != null || fmt[1].match(cfregex) != null) {
		var m1 = fmt[0].match(cfregex2);
		var m2 = fmt[1].match(cfregex2);
		return chkcond(v, m1) ? [l, fmt[0]] : chkcond(v, m2) ? [l, fmt[1]] : [l, fmt[m1 != null && m2 != null ? 2 : 1]];
	}
	return [l, ff];
}
function format(fmt,v,o) {
	if(o == null) o = {};
	var sfmt = "";
	switch(typeof fmt) {
		case "string":
			if(fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
			else sfmt = fmt;
			break;
		case "number":
			if(fmt == 14 && o.dateNF) sfmt = o.dateNF;
			else sfmt = (o.table != null ? (o.table) : table_fmt)[fmt];
			break;
	}
	if(isgeneral(sfmt,0)) return general_fmt(v, o);
	if(v instanceof Date) v = datenum_local(v, o.date1904);
	var f = choose_fmt(sfmt, v);
	if(isgeneral(f[1])) return general_fmt(v, o);
	if(v === true) v = "TRUE"; else if(v === false) v = "FALSE";
	else if(v === "" || v == null) return "";
	return eval_fmt(f[1], v, o, f[0]);
}
function load_entry(fmt, idx) {
	if(typeof idx != 'number') {
		idx = +idx || -1;
for(var i = 0; i < 0x0188; ++i) {
if(table_fmt[i] == undefined) { if(idx < 0) idx = i; continue; }
			if(table_fmt[i] == fmt) { idx = i; break; }
		}
if(idx < 0) idx = 0x187;
	}
table_fmt[idx] = fmt;
	return idx;
}
SSF.load = load_entry;
SSF._table = table_fmt;
SSF.get_table = function get_table() { return table_fmt; };
SSF.load_table = function load_table(tbl) {
	for(var i=0; i!=0x0188; ++i)
		if(tbl[i] !== undefined) load_entry(tbl[i], i);
};
SSF.init_table = init_table;
SSF.format = format;
};
make_ssf(SSF);
/* map from xlml named formats to SSF TODO: localize */
var XLMLFormatMap/*{[string]:string}*/ = ({
	"General Number": "General",
	"General Date": SSF._table[22],
	"Long Date": "dddd, mmmm dd, yyyy",
	"Medium Date": SSF._table[15],
	"Short Date": SSF._table[14],
	"Long Time": SSF._table[19],
	"Medium Time": SSF._table[18],
	"Short Time": SSF._table[20],
	"Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	"Fixed": SSF._table[2],
	"Standard": SSF._table[4],
	"Percent": SSF._table[10],
	"Scientific": SSF._table[11],
	"Yes/No": '"Yes";"Yes";"No";@',
	"True/False": '"True";"True";"False";@',
	"On/Off": '"Yes";"Yes";"No";@'
});

var SSFImplicit/*{[number]:string}*/ = ({
	"5": '"$"#,##0_);\\("$"#,##0\\)',
	"6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
	"7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
	"8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	"23": 'General', "24": 'General', "25": 'General', "26": 'General',
	"27": 'm/d/yy', "28": 'm/d/yy', "29": 'm/d/yy', "30": 'm/d/yy', "31": 'm/d/yy',
	"32": 'h:mm:ss', "33": 'h:mm:ss', "34": 'h:mm:ss', "35": 'h:mm:ss',
	"36": 'm/d/yy',
	"41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
	"42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
	"43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
	"44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
	"50": 'm/d/yy', "51": 'm/d/yy', "52": 'm/d/yy', "53": 'm/d/yy', "54": 'm/d/yy',
	"55": 'm/d/yy', "56": 'm/d/yy', "57": 'm/d/yy', "58": 'm/d/yy',
	"59": '0',
	"60": '0.00',
	"61": '#,##0',
	"62": '#,##0.00',
	"63": '"$"#,##0_);\\("$"#,##0\\)',
	"64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
	"65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
	"66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	"67": '0%',
	"68": '0.00%',
	"69": '# ?/?',
	"70": '# ??/??',
	"71": 'm/d/yy',
	"72": 'm/d/yy',
	"73": 'd-mmm-yy',
	"74": 'd-mmm',
	"75": 'mmm-yy',
	"76": 'h:mm',
	"77": 'h:mm:ss',
	"78": 'm/d/yy h:mm',
	"79": 'mm:ss',
	"80": '[h]:mm:ss',
	"81": 'mmss.0'
});

/* dateNF parse TODO: move to SSF */
var dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function dateNF_regex(dateNF) {
	var fmt = typeof dateNF == "number" ? SSF._table[dateNF] : dateNF;
	fmt = fmt.replace(dateNFregex, "(\\d+)");
	return new RegExp("^" + fmt + "$");
}
function dateNF_fix(str, dateNF, match) {
	var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
	(dateNF.match(dateNFregex)||[]).forEach(function(n, i) {
		var v = parseInt(match[i+1], 10);
		switch(n.toLowerCase().charAt(0)) {
			case 'y': Y = v; break; case 'd': d = v; break;
			case 'h': H = v; break; case 's': S = v; break;
			case 'm': if(H >= 0) M = v; else m = v; break;
		}
	});
	if(S >= 0 && M == -1 && m >= 0) { M = m; m = -1; }
	var datestr = (("" + (Y>=0?Y: new Date().getFullYear())).slice(-4) + "-" + ("00" + (m>=1?m:1)).slice(-2) + "-" + ("00" + (d>=1?d:1)).slice(-2));
	if(datestr.length == 7) datestr = "0" + datestr;
	if(datestr.length == 8) datestr = "20" + datestr;
	var timestr = (("00" + (H>=0?H:0)).slice(-2) + ":" + ("00" + (M>=0?M:0)).slice(-2) + ":" + ("00" + (S>=0?S:0)).slice(-2));
	if(H == -1 && M == -1 && S == -1) return datestr;
	if(Y == -1 && m == -1 && d == -1) return timestr;
	return datestr + "T" + timestr;
}

var DO_NOT_EXPORT_CFB = true;
/* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*jshint eqnull:true */
/*exported CFB */
/*global module, require:false, process:false, Buffer:false, Uint8Array:false, Uint16Array:false */

/* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*exported CRC32 */
var CRC32;
(function (factory) {
	/*jshint ignore:start */
	/*eslint-disable */
	factory(CRC32 = {});
	/*eslint-enable */
	/*jshint ignore:end */
}(function(CRC32) {
CRC32.version = '1.2.0';
/* see perf/crc32table.js */
/*global Int32Array */
function signed_crc_table() {
	var c = 0, table = new Array(256);

	for(var n =0; n != 256; ++n){
		c = n;
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		table[n] = c;
	}

	return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
}

var T = signed_crc_table();
function crc32_bstr(bstr, seed) {
	var C = seed ^ -1, L = bstr.length - 1;
	for(var i = 0; i < L;) {
		C = (C>>>8) ^ T[(C^bstr.charCodeAt(i++))&0xFF];
		C = (C>>>8) ^ T[(C^bstr.charCodeAt(i++))&0xFF];
	}
	if(i === L) C = (C>>>8) ^ T[(C ^ bstr.charCodeAt(i))&0xFF];
	return C ^ -1;
}

function crc32_buf(buf, seed) {
	if(buf.length > 10000) return crc32_buf_8(buf, seed);
	var C = seed ^ -1, L = buf.length - 3;
	for(var i = 0; i < L;) {
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
	}
	while(i < L+3) C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
	return C ^ -1;
}

function crc32_buf_8(buf, seed) {
	var C = seed ^ -1, L = buf.length - 7;
	for(var i = 0; i < L;) {
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
	}
	while(i < L+7) C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
	return C ^ -1;
}

function crc32_str(str, seed) {
	var C = seed ^ -1;
	for(var i = 0, L=str.length, c, d; i < L;) {
		c = str.charCodeAt(i++);
		if(c < 0x80) {
			C = (C>>>8) ^ T[(C ^ c)&0xFF];
		} else if(c < 0x800) {
			C = (C>>>8) ^ T[(C ^ (192|((c>>6)&31)))&0xFF];
			C = (C>>>8) ^ T[(C ^ (128|(c&63)))&0xFF];
		} else if(c >= 0xD800 && c < 0xE000) {
			c = (c&1023)+64; d = str.charCodeAt(i++)&1023;
			C = (C>>>8) ^ T[(C ^ (240|((c>>8)&7)))&0xFF];
			C = (C>>>8) ^ T[(C ^ (128|((c>>2)&63)))&0xFF];
			C = (C>>>8) ^ T[(C ^ (128|((d>>6)&15)|((c&3)<<4)))&0xFF];
			C = (C>>>8) ^ T[(C ^ (128|(d&63)))&0xFF];
		} else {
			C = (C>>>8) ^ T[(C ^ (224|((c>>12)&15)))&0xFF];
			C = (C>>>8) ^ T[(C ^ (128|((c>>6)&63)))&0xFF];
			C = (C>>>8) ^ T[(C ^ (128|(c&63)))&0xFF];
		}
	}
	return C ^ -1;
}
CRC32.table = T;
CRC32.bstr = crc32_bstr;
CRC32.buf = crc32_buf;
CRC32.str = crc32_str;
}));
/* [MS-CFB] v20171201 */
var CFB = (function _CFB(){
var exports = {};
exports.version = '1.1.2';
/* [MS-CFB] 2.6.4 */
function namecmp(l, r) {
	var L = l.split("/"), R = r.split("/");
	for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i) {
		if((c = L[i].length - R[i].length)) return c;
		if(L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
	}
	return L.length - R.length;
}
function dirname(p) {
	if(p.charAt(p.length - 1) == "/") return (p.slice(0,-1).indexOf("/") === -1) ? p : dirname(p.slice(0, -1));
	var c = p.lastIndexOf("/");
	return (c === -1) ? p : p.slice(0, c+1);
}

function filename(p) {
	if(p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
	var c = p.lastIndexOf("/");
	return (c === -1) ? p : p.slice(c+1);
}
/* -------------------------------------------------------------------------- */
/* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/

/* write JS date to buf as a DOS date */
function write_dos_date(buf, date) {
	if(typeof date === "string") date = new Date(date);
	var hms = date.getHours();
	hms = hms << 6 | date.getMinutes();
	hms = hms << 5 | (date.getSeconds()>>>1);
	buf.write_shift(2, hms);
	var ymd = (date.getFullYear() - 1980);
	ymd = ymd << 4 | (date.getMonth()+1);
	ymd = ymd << 5 | date.getDate();
	buf.write_shift(2, ymd);
}

/* read four bytes from buf and interpret as a DOS date */
function parse_dos_date(buf) {
	var hms = buf.read_shift(2) & 0xFFFF;
	var ymd = buf.read_shift(2) & 0xFFFF;
	var val = new Date();
	var d = ymd & 0x1F; ymd >>>= 5;
	var m = ymd & 0x0F; ymd >>>= 4;
	val.setMilliseconds(0);
	val.setFullYear(ymd + 1980);
	val.setMonth(m-1);
	val.setDate(d);
	var S = hms & 0x1F; hms >>>= 5;
	var M = hms & 0x3F; hms >>>= 6;
	val.setHours(hms);
	val.setMinutes(M);
	val.setSeconds(S<<1);
	return val;
}
function parse_extra_field(blob) {
	prep_blob(blob, 0);
	var o = {};
	var flags = 0;
	while(blob.l <= blob.length - 4) {
		var type = blob.read_shift(2);
		var sz = blob.read_shift(2), tgt = blob.l + sz;
		var p = {};
		switch(type) {
			/* UNIX-style Timestamps */
			case 0x5455: {
				flags = blob.read_shift(1);
				if(flags & 1) p.mtime = blob.read_shift(4);
				/* for some reason, CD flag corresponds to LFH */
				if(sz > 5) {
					if(flags & 2) p.atime = blob.read_shift(4);
					if(flags & 4) p.ctime = blob.read_shift(4);
				}
				if(p.mtime) p.mt = new Date(p.mtime*1000);
			}
			break;
		}
		blob.l = tgt;
		o[type] = p;
	}
	return o;
}
var fs;
function get_fs() { return fs || (fs = __webpack_require__(521)); }
function parse(file, options) {
if(file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
if(file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
var mver = 3;
var ssz = 512;
var nmfs = 0; // number of mini FAT sectors
var difat_sec_cnt = 0;
var dir_start = 0;
var minifat_start = 0;
var difat_start = 0;

var fat_addrs = []; // locations of FAT sectors

/* [MS-CFB] 2.2 Compound File Header */
var blob = file.slice(0,512);
prep_blob(blob, 0);

/* major version */
var mv = check_get_mver(blob);
mver = mv[0];
switch(mver) {
	case 3: ssz = 512; break; case 4: ssz = 4096; break;
	case 0: if(mv[1] == 0) return parse_zip(file, options);
	/* falls through */
	default: throw new Error("Major Version: Expected 3 or 4 saw " + mver);
}

/* reprocess header */
if(ssz !== 512) { blob = file.slice(0,ssz); prep_blob(blob, 28 /* blob.l */); }
/* Save header for final object */
var header = file.slice(0,ssz);

check_shifts(blob, mver);

// Number of Directory Sectors
var dir_cnt = blob.read_shift(4, 'i');
if(mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);

// Number of FAT Sectors
blob.l += 4;

// First Directory Sector Location
dir_start = blob.read_shift(4, 'i');

// Transaction Signature
blob.l += 4;

// Mini Stream Cutoff Size
blob.chk('00100000', 'Mini Stream Cutoff Size: ');

// First Mini FAT Sector Location
minifat_start = blob.read_shift(4, 'i');

// Number of Mini FAT Sectors
nmfs = blob.read_shift(4, 'i');

// First DIFAT sector location
difat_start = blob.read_shift(4, 'i');

// Number of DIFAT Sectors
difat_sec_cnt = blob.read_shift(4, 'i');

// Grab FAT Sector Locations
for(var q = -1, j = 0; j < 109; ++j) { /* 109 = (512 - blob.l)>>>2; */
	q = blob.read_shift(4, 'i');
	if(q<0) break;
	fat_addrs[j] = q;
}

/** Break the file up into sectors */
var sectors = sectorify(file, ssz);

sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);

/** Chains */
var sector_list = make_sector_list(sectors, dir_start, fat_addrs, ssz);

sector_list[dir_start].name = "!Directory";
if(nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
sector_list[fat_addrs[0]].name = "!FAT";
sector_list.fat_addrs = fat_addrs;
sector_list.ssz = ssz;

/* [MS-CFB] 2.6.1 Compound File Directory Entry */
var files = {}, Paths = [], FileIndex = [], FullPaths = [];
read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);

build_full_paths(FileIndex, FullPaths, Paths);
Paths.shift();

var o = {
	FileIndex: FileIndex,
	FullPaths: FullPaths
};

// $FlowIgnore
if(options && options.raw) o.raw = {header: header, sectors: sectors};
return o;
} // parse

/* [MS-CFB] 2.2 Compound File Header -- read up to major version */
function check_get_mver(blob) {
	if(blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [0, 0];
	// header signature 8
	blob.chk(HEADER_SIGNATURE, 'Header Signature: ');

	// clsid 16
	//blob.chk(HEADER_CLSID, 'CLSID: ');
	blob.l += 16;

	// minor version 2
	var mver = blob.read_shift(2, 'u');

	return [blob.read_shift(2,'u'), mver];
}
function check_shifts(blob, mver) {
	var shift = 0x09;

	// Byte Order
	//blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
	blob.l += 2;

	// Sector Shift
	switch((shift = blob.read_shift(2))) {
		case 0x09: if(mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift); break;
		case 0x0c: if(mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift); break;
		default: throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
	}

	// Mini Sector Shift
	blob.chk('0600', 'Mini Sector Shift: ');

	// Reserved
	blob.chk('000000000000', 'Reserved: ');
}

/** Break the file up into sectors */
function sectorify(file, ssz) {
	var nsectors = Math.ceil(file.length/ssz)-1;
	var sectors = [];
	for(var i=1; i < nsectors; ++i) sectors[i-1] = file.slice(i*ssz,(i+1)*ssz);
	sectors[nsectors-1] = file.slice(nsectors*ssz);
	return sectors;
}

/* [MS-CFB] 2.6.4 Red-Black Tree */
function build_full_paths(FI, FP, Paths) {
	var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
	var dad = [], q = [];

	for(; i < pl; ++i) { dad[i]=q[i]=i; FP[i]=Paths[i]; }

	for(; j < q.length; ++j) {
		i = q[j];
		L = FI[i].L; R = FI[i].R; C = FI[i].C;
		if(dad[i] === i) {
			if(L !== -1 /*NOSTREAM*/ && dad[L] !== L) dad[i] = dad[L];
			if(R !== -1 && dad[R] !== R) dad[i] = dad[R];
		}
		if(C !== -1 /*NOSTREAM*/) dad[C] = i;
		if(L !== -1 && i != dad[i]) { dad[L] = dad[i]; if(q.lastIndexOf(L) < j) q.push(L); }
		if(R !== -1 && i != dad[i]) { dad[R] = dad[i]; if(q.lastIndexOf(R) < j) q.push(R); }
	}
	for(i=1; i < pl; ++i) if(dad[i] === i) {
		if(R !== -1 /*NOSTREAM*/ && dad[R] !== R) dad[i] = dad[R];
		else if(L !== -1 && dad[L] !== L) dad[i] = dad[L];
	}

	for(i=1; i < pl; ++i) {
		if(FI[i].type === 0 /* unknown */) continue;
		j = i;
		if(j != dad[j]) do {
			j = dad[j];
			FP[i] = FP[j] + "/" + FP[i];
		} while (j !== 0 && -1 !== dad[j] && j != dad[j]);
		dad[i] = -1;
	}

	FP[0] += "/";
	for(i=1; i < pl; ++i) {
		if(FI[i].type !== 2 /* stream */) FP[i] += "/";
	}
}

function get_mfat_entry(entry, payload, mini) {
	var start = entry.start, size = entry.size;
	//return (payload.slice(start*MSSZ, start*MSSZ + size));
	var o = [];
	var idx = start;
	while(mini && size > 0 && idx >= 0) {
		o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
		size -= MSSZ;
		idx = __readInt32LE(mini, idx * 4);
	}
	if(o.length === 0) return (new_buf(0));
	return (bconcat(o).slice(0, entry.size));
}

/** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */
function sleuth_fat(idx, cnt, sectors, ssz, fat_addrs) {
	var q = ENDOFCHAIN;
	if(idx === ENDOFCHAIN) {
		if(cnt !== 0) throw new Error("DIFAT chain shorter than expected");
	} else if(idx !== -1 /*FREESECT*/) {
		var sector = sectors[idx], m = (ssz>>>2)-1;
		if(!sector) return;
		for(var i = 0; i < m; ++i) {
			if((q = __readInt32LE(sector,i*4)) === ENDOFCHAIN) break;
			fat_addrs.push(q);
		}
		sleuth_fat(__readInt32LE(sector,ssz-4),cnt - 1, sectors, ssz, fat_addrs);
	}
}

/** Follow the linked list of sectors for a given starting point */
function get_sector_list(sectors, start, fat_addrs, ssz, chkd) {
	var buf = [], buf_chain = [];
	if(!chkd) chkd = [];
	var modulus = ssz - 1, j = 0, jj = 0;
	for(j=start; j>=0;) {
		chkd[j] = true;
		buf[buf.length] = j;
		buf_chain.push(sectors[j]);
		var addr = fat_addrs[Math.floor(j*4/ssz)];
		jj = ((j*4) & modulus);
		if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
		if(!sectors[addr]) break;
		j = __readInt32LE(sectors[addr], jj);
	}
	return {nodes: buf, data:__toBuffer([buf_chain])};
}

/** Chase down the sector linked lists */
function make_sector_list(sectors, dir_start, fat_addrs, ssz) {
	var sl = sectors.length, sector_list = ([]);
	var chkd = [], buf = [], buf_chain = [];
	var modulus = ssz - 1, i=0, j=0, k=0, jj=0;
	for(i=0; i < sl; ++i) {
		buf = ([]);
		k = (i + dir_start); if(k >= sl) k-=sl;
		if(chkd[k]) continue;
		buf_chain = [];
		for(j=k; j>=0;) {
			chkd[j] = true;
			buf[buf.length] = j;
			buf_chain.push(sectors[j]);
			var addr = fat_addrs[Math.floor(j*4/ssz)];
			jj = ((j*4) & modulus);
			if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
			if(!sectors[addr]) break;
			j = __readInt32LE(sectors[addr], jj);
		}
		sector_list[k] = ({nodes: buf, data:__toBuffer([buf_chain])});
	}
	return sector_list;
}

/* [MS-CFB] 2.6.1 Compound File Directory Entry */
function read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, mini) {
	var minifat_store = 0, pl = (Paths.length?2:0);
	var sector = sector_list[dir_start].data;
	var i = 0, namelen = 0, name;
	for(; i < sector.length; i+= 128) {
		var blob = sector.slice(i, i+128);
		prep_blob(blob, 64);
		namelen = blob.read_shift(2);
		name = __utf16le(blob,0,namelen-pl);
		Paths.push(name);
		var o = ({
			name:  name,
			type:  blob.read_shift(1),
			color: blob.read_shift(1),
			L:     blob.read_shift(4, 'i'),
			R:     blob.read_shift(4, 'i'),
			C:     blob.read_shift(4, 'i'),
			clsid: blob.read_shift(16),
			state: blob.read_shift(4, 'i'),
			start: 0,
			size: 0
		});
		var ctime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
		if(ctime !== 0) o.ct = read_date(blob, blob.l-8);
		var mtime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
		if(mtime !== 0) o.mt = read_date(blob, blob.l-8);
		o.start = blob.read_shift(4, 'i');
		o.size = blob.read_shift(4, 'i');
		if(o.size < 0 && o.start < 0) { o.size = o.type = 0; o.start = ENDOFCHAIN; o.name = ""; }
		if(o.type === 5) { /* root */
			minifat_store = o.start;
			if(nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
			/*minifat_size = o.size;*/
		} else if(o.size >= 4096 /* MSCSZ */) {
			o.storage = 'fat';
			if(sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
			sector_list[o.start].name = o.name;
			o.content = (sector_list[o.start].data.slice(0,o.size));
		} else {
			o.storage = 'minifat';
			if(o.size < 0) o.size = 0;
			else if(minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) {
				o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini]||{}).data);
			}
		}
		if(o.content) prep_blob(o.content, 0);
		files[name] = o;
		FileIndex.push(o);
	}
}

function read_date(blob, offset) {
	return new Date(( ( (__readUInt32LE(blob,offset+4)/1e7)*Math.pow(2,32)+__readUInt32LE(blob,offset)/1e7 ) - 11644473600)*1000);
}

function read_file(filename, options) {
	get_fs();
	return parse(fs.readFileSync(filename), options);
}

function read(blob, options) {
	switch(options && options.type || "base64") {
		case "file": return read_file(blob, options);
		case "base64": return parse(s2a(Base64.decode(blob)), options);
		case "binary": return parse(s2a(blob), options);
	}
	return parse(blob, options);
}

function init_cfb(cfb, opts) {
	var o = opts || {}, root = o.root || "Root Entry";
	if(!cfb.FullPaths) cfb.FullPaths = [];
	if(!cfb.FileIndex) cfb.FileIndex = [];
	if(cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
	if(cfb.FullPaths.length === 0) {
		cfb.FullPaths[0] = root + "/";
		cfb.FileIndex[0] = ({ name: root, type: 5 });
	}
	if(o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
	seed_cfb(cfb);
}
function seed_cfb(cfb) {
	var nm = "\u0001Sh33tJ5";
	if(CFB.find(cfb, "/" + nm)) return;
	var p = new_buf(4); p[0] = 55; p[1] = p[3] = 50; p[2] = 54;
	cfb.FileIndex.push(({ name: nm, type: 2, content:p, size:4, L:69, R:69, C:69 }));
	cfb.FullPaths.push(cfb.FullPaths[0] + nm);
	rebuild_cfb(cfb);
}
function rebuild_cfb(cfb, f) {
	init_cfb(cfb);
	var gc = false, s = false;
	for(var i = cfb.FullPaths.length - 1; i >= 0; --i) {
		var _file = cfb.FileIndex[i];
		switch(_file.type) {
			case 0:
				if(s) gc = true;
				else { cfb.FileIndex.pop(); cfb.FullPaths.pop(); }
				break;
			case 1: case 2: case 5:
				s = true;
				if(isNaN(_file.R * _file.L * _file.C)) gc = true;
				if(_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
				break;
			default: gc = true; break;
		}
	}
	if(!gc && !f) return;

	var now = new Date(1987, 1, 19), j = 0;
	var data = [];
	for(i = 0; i < cfb.FullPaths.length; ++i) {
		if(cfb.FileIndex[i].type === 0) continue;
		data.push([cfb.FullPaths[i], cfb.FileIndex[i]]);
	}
	for(i = 0; i < data.length; ++i) {
		var dad = dirname(data[i][0]);
		s = false;
		for(j = 0; j < data.length; ++j) if(data[j][0] === dad) s = true;
		if(!s) data.push([dad, ({
			name: filename(dad).replace("/",""),
			type: 1,
			clsid: HEADER_CLSID,
			ct: now, mt: now,
			content: null
		})]);
	}

	data.sort(function(x,y) { return namecmp(x[0], y[0]); });
	cfb.FullPaths = []; cfb.FileIndex = [];
	for(i = 0; i < data.length; ++i) { cfb.FullPaths[i] = data[i][0]; cfb.FileIndex[i] = data[i][1]; }
	for(i = 0; i < data.length; ++i) {
		var elt = cfb.FileIndex[i];
		var nm = cfb.FullPaths[i];

		elt.name =  filename(nm).replace("/","");
		elt.L = elt.R = elt.C = -(elt.color = 1);
		elt.size = elt.content ? elt.content.length : 0;
		elt.start = 0;
		elt.clsid = (elt.clsid || HEADER_CLSID);
		if(i === 0) {
			elt.C = data.length > 1 ? 1 : -1;
			elt.size = 0;
			elt.type = 5;
		} else if(nm.slice(-1) == "/") {
			for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==nm) break;
			elt.C = j >= data.length ? -1 : j;
			for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==dirname(nm)) break;
			elt.R = j >= data.length ? -1 : j;
			elt.type = 1;
		} else {
			if(dirname(cfb.FullPaths[i+1]||"") == dirname(nm)) elt.R = i + 1;
			elt.type = 2;
		}
	}

}

function _write(cfb, options) {
	var _opts = options || {};
	rebuild_cfb(cfb);
	if(_opts.fileType == 'zip') return write_zip(cfb, _opts);
	var L = (function(cfb){
		var mini_size = 0, fat_size = 0;
		for(var i = 0; i < cfb.FileIndex.length; ++i) {
			var file = cfb.FileIndex[i];
			if(!file.content) continue;
var flen = file.content.length;
			if(flen > 0){
				if(flen < 0x1000) mini_size += (flen + 0x3F) >> 6;
				else fat_size += (flen + 0x01FF) >> 9;
			}
		}
		var dir_cnt = (cfb.FullPaths.length +3) >> 2;
		var mini_cnt = (mini_size + 7) >> 3;
		var mfat_cnt = (mini_size + 0x7F) >> 7;
		var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
		var fat_cnt = (fat_base + 0x7F) >> 7;
		var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
		while(((fat_base + fat_cnt + difat_cnt + 0x7F) >> 7) > fat_cnt) difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
		var L =  [1, difat_cnt, fat_cnt, mfat_cnt, dir_cnt, fat_size, mini_size, 0];
		cfb.FileIndex[0].size = mini_size << 6;
		L[7] = (cfb.FileIndex[0].start=L[0]+L[1]+L[2]+L[3]+L[4]+L[5])+((L[6]+7) >> 3);
		return L;
	})(cfb);
	var o = new_buf(L[7] << 9);
	var i = 0, T = 0;
	{
		for(i = 0; i < 8; ++i) o.write_shift(1, HEADER_SIG[i]);
		for(i = 0; i < 8; ++i) o.write_shift(2, 0);
		o.write_shift(2, 0x003E);
		o.write_shift(2, 0x0003);
		o.write_shift(2, 0xFFFE);
		o.write_shift(2, 0x0009);
		o.write_shift(2, 0x0006);
		for(i = 0; i < 3; ++i) o.write_shift(2, 0);
		o.write_shift(4, 0);
		o.write_shift(4, L[2]);
		o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
		o.write_shift(4, 0);
		o.write_shift(4, 1<<12);
		o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1: ENDOFCHAIN);
		o.write_shift(4, L[3]);
		o.write_shift(-4, L[1] ? L[0] - 1: ENDOFCHAIN);
		o.write_shift(4, L[1]);
		for(i = 0; i < 109; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
	}
	if(L[1]) {
		for(T = 0; T < L[1]; ++T) {
			for(; i < 236 + T * 127; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
			o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
		}
	}
	var chainit = function(w) {
		for(T += w; i<T-1; ++i) o.write_shift(-4, i+1);
		if(w) { ++i; o.write_shift(-4, ENDOFCHAIN); }
	};
	T = i = 0;
	for(T+=L[1]; i<T; ++i) o.write_shift(-4, consts.DIFSECT);
	for(T+=L[2]; i<T; ++i) o.write_shift(-4, consts.FATSECT);
	chainit(L[3]);
	chainit(L[4]);
	var j = 0, flen = 0;
	var file = cfb.FileIndex[0];
	for(; j < cfb.FileIndex.length; ++j) {
		file = cfb.FileIndex[j];
		if(!file.content) continue;
flen = file.content.length;
		if(flen < 0x1000) continue;
		file.start = T;
		chainit((flen + 0x01FF) >> 9);
	}
	chainit((L[6] + 7) >> 3);
	while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
	T = i = 0;
	for(j = 0; j < cfb.FileIndex.length; ++j) {
		file = cfb.FileIndex[j];
		if(!file.content) continue;
flen = file.content.length;
		if(!flen || flen >= 0x1000) continue;
		file.start = T;
		chainit((flen + 0x3F) >> 6);
	}
	while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
	for(i = 0; i < L[4]<<2; ++i) {
		var nm = cfb.FullPaths[i];
		if(!nm || nm.length === 0) {
			for(j = 0; j < 17; ++j) o.write_shift(4, 0);
			for(j = 0; j < 3; ++j) o.write_shift(4, -1);
			for(j = 0; j < 12; ++j) o.write_shift(4, 0);
			continue;
		}
		file = cfb.FileIndex[i];
		if(i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
		var _nm = (i === 0 && _opts.root) || file.name;
		flen = 2*(_nm.length+1);
		o.write_shift(64, _nm, "utf16le");
		o.write_shift(2, flen);
		o.write_shift(1, file.type);
		o.write_shift(1, file.color);
		o.write_shift(-4, file.L);
		o.write_shift(-4, file.R);
		o.write_shift(-4, file.C);
		if(!file.clsid) for(j = 0; j < 4; ++j) o.write_shift(4, 0);
		else o.write_shift(16, file.clsid, "hex");
		o.write_shift(4, file.state || 0);
		o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(4, file.start);
		o.write_shift(4, file.size); o.write_shift(4, 0);
	}
	for(i = 1; i < cfb.FileIndex.length; ++i) {
		file = cfb.FileIndex[i];
if(file.size >= 0x1000) {
			o.l = (file.start+1) << 9;
			for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
			for(; j & 0x1FF; ++j) o.write_shift(1, 0);
		}
	}
	for(i = 1; i < cfb.FileIndex.length; ++i) {
		file = cfb.FileIndex[i];
if(file.size > 0 && file.size < 0x1000) {
			for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
			for(; j & 0x3F; ++j) o.write_shift(1, 0);
		}
	}
	while(o.l < o.length) o.write_shift(1, 0);
	return o;
}
/* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */
function find(cfb, path) {
	var UCFullPaths = cfb.FullPaths.map(function(x) { return x.toUpperCase(); });
	var UCPaths = UCFullPaths.map(function(x) { var y = x.split("/"); return y[y.length - (x.slice(-1) == "/" ? 2 : 1)]; });
	var k = false;
	if(path.charCodeAt(0) === 47 /* "/" */) { k = true; path = UCFullPaths[0].slice(0, -1) + path; }
	else k = path.indexOf("/") !== -1;
	var UCPath = path.toUpperCase();
	var w = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
	if(w !== -1) return cfb.FileIndex[w];

	var m = !UCPath.match(chr1);
	UCPath = UCPath.replace(chr0,'');
	if(m) UCPath = UCPath.replace(chr1,'!');
	for(w = 0; w < UCFullPaths.length; ++w) {
		if((m ? UCFullPaths[w].replace(chr1,'!') : UCFullPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
		if((m ? UCPaths[w].replace(chr1,'!') : UCPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
	}
	return null;
}
/** CFB Constants */
var MSSZ = 64; /* Mini Sector Size = 1<<6 */
//var MSCSZ = 4096; /* Mini Stream Cutoff Size */
/* 2.1 Compound File Sector Numbers and Types */
var ENDOFCHAIN = -2;
/* 2.2 Compound File Header */
var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
var HEADER_SIG = [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1];
var HEADER_CLSID = '00000000000000000000000000000000';
var consts = {
	/* 2.1 Compund File Sector Numbers and Types */
	MAXREGSECT: -6,
	DIFSECT: -4,
	FATSECT: -3,
	ENDOFCHAIN: ENDOFCHAIN,
	FREESECT: -1,
	/* 2.2 Compound File Header */
	HEADER_SIGNATURE: HEADER_SIGNATURE,
	HEADER_MINOR_VERSION: '3e00',
	MAXREGSID: -6,
	NOSTREAM: -1,
	HEADER_CLSID: HEADER_CLSID,
	/* 2.6.1 Compound File Directory Entry */
	EntryTypes: ['unknown','storage','stream','lockbytes','property','root']
};

function write_file(cfb, filename, options) {
	get_fs();
	var o = _write(cfb, options);
fs.writeFileSync(filename, o);
}

function a2s(o) {
	var out = new Array(o.length);
	for(var i = 0; i < o.length; ++i) out[i] = String.fromCharCode(o[i]);
	return out.join("");
}

function write(cfb, options) {
	var o = _write(cfb, options);
	switch(options && options.type) {
		case "file": get_fs(); fs.writeFileSync(options.filename, (o)); return o;
		case "binary": return a2s(o);
		case "base64": return Base64.encode(a2s(o));
	}
	return o;
}
/* node < 8.1 zlib does not expose bytesRead, so default to pure JS */
var _zlib;
function use_zlib(zlib) { try {
	var InflateRaw = zlib.InflateRaw;
	var InflRaw = new InflateRaw();
	InflRaw._processChunk(new Uint8Array([3, 0]), InflRaw._finishFlushFlag);
	if(InflRaw.bytesRead) _zlib = zlib;
	else throw new Error("zlib does not expose bytesRead");
} catch(e) {console.error("cannot use native zlib: " + (e.message || e)); } }

function _inflateRawSync(payload, usz) {
	if(!_zlib) return _inflate(payload, usz);
	var InflateRaw = _zlib.InflateRaw;
	var InflRaw = new InflateRaw();
	var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
	payload.l += InflRaw.bytesRead;
	return out;
}

function _deflateRawSync(payload) {
	return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
}
var CLEN_ORDER = [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];

/*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */
var LEN_LN = [   3,   4,   5,   6,   7,   8,   9,  10,  11,  13 , 15,  17,  19,  23,  27,  31,  35,  43,  51,  59,  67,  83,  99, 115, 131, 163, 195, 227, 258 ];

/*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */
var DST_LN = [  1,  2,  3,  4,  5,  7,  9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577 ];

function bit_swap_8(n) { var t = (((((n<<1)|(n<<11)) & 0x22110) | (((n<<5)|(n<<15)) & 0x88440))); return ((t>>16) | (t>>8) |t)&0xFF; }

var use_typed_arrays = typeof Uint8Array !== 'undefined';

var bitswap8 = use_typed_arrays ? new Uint8Array(1<<8) : [];
for(var q = 0; q < (1<<8); ++q) bitswap8[q] = bit_swap_8(q);

function bit_swap_n(n, b) {
	var rev = bitswap8[n & 0xFF];
	if(b <= 8) return rev >>> (8-b);
	rev = (rev << 8) | bitswap8[(n>>8)&0xFF];
	if(b <= 16) return rev >>> (16-b);
	rev = (rev << 8) | bitswap8[(n>>16)&0xFF];
	return rev >>> (24-b);
}

/* helpers for unaligned bit reads */
function read_bits_2(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 6 ? 0 : buf[h+1]<<8))>>>w)& 0x03; }
function read_bits_3(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 5 ? 0 : buf[h+1]<<8))>>>w)& 0x07; }
function read_bits_4(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 4 ? 0 : buf[h+1]<<8))>>>w)& 0x0F; }
function read_bits_5(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 3 ? 0 : buf[h+1]<<8))>>>w)& 0x1F; }
function read_bits_7(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 1 ? 0 : buf[h+1]<<8))>>>w)& 0x7F; }

/* works up to n = 3 * 8 + 1 = 25 */
function read_bits_n(buf, bl, n) {
	var w = (bl&7), h = (bl>>>3), f = ((1<<n)-1);
	var v = buf[h] >>> w;
	if(n < 8 - w) return v & f;
	v |= buf[h+1]<<(8-w);
	if(n < 16 - w) return v & f;
	v |= buf[h+2]<<(16-w);
	if(n < 24 - w) return v & f;
	v |= buf[h+3]<<(24-w);
	return v & f;
}

/* until ArrayBuffer#realloc is a thing, fake a realloc */
function realloc(b, sz) {
	var L = b.length, M = 2*L > sz ? 2*L : sz + 5, i = 0;
	if(L >= sz) return b;
	if(has_buf) {
		var o = new_unsafe_buf(M);
		// $FlowIgnore
		if(b.copy) b.copy(o);
		else for(; i < b.length; ++i) o[i] = b[i];
		return o;
	} else if(use_typed_arrays) {
		var a = new Uint8Array(M);
		if(a.set) a.set(b);
		else for(; i < b.length; ++i) a[i] = b[i];
		return a;
	}
	b.length = M;
	return b;
}

/* zero-filled arrays for older browsers */
function zero_fill_array(n) {
	var o = new Array(n);
	for(var i = 0; i < n; ++i) o[i] = 0;
	return o;
}var _deflate = (function() {
var _deflateRaw = (function() {
	return function deflateRaw(data, out) {
		var boff = 0;
		while(boff < data.length) {
			var L = Math.min(0xFFFF, data.length - boff);
			var h = boff + L == data.length;
			/* TODO: this is only type 0 stored */
			out.write_shift(1, +h);
			out.write_shift(2, L);
			out.write_shift(2, (~L) & 0xFFFF);
			while(L-- > 0) out[out.l++] = data[boff++];
		}
		return out.l;
	};
})();

return function(data) {
	var buf = new_buf(50+Math.floor(data.length*1.1));
	var off = _deflateRaw(data, buf);
	return buf.slice(0, off);
};
})();
/* modified inflate function also moves original read head */

/* build tree (used for literals and lengths) */
function build_tree(clens, cmap, MAX) {
	var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;

	var bl_count  = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
	for(i = 0; i < 32; ++i) bl_count[i] = 0;

	for(i = L; i < MAX; ++i) clens[i] = 0;
	L = clens.length;

	var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []

	/* build code tree */
	for(i = 0; i < L; ++i) {
		bl_count[(w = clens[i])]++;
		if(maxlen < w) maxlen = w;
		ctree[i] = 0;
	}
	bl_count[0] = 0;
	for(i = 1; i <= maxlen; ++i) bl_count[i+16] = (ccode = (ccode + bl_count[i-1])<<1);
	for(i = 0; i < L; ++i) {
		ccode = clens[i];
		if(ccode != 0) ctree[i] = bl_count[ccode+16]++;
	}

	/* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */
	var cleni = 0;
	for(i = 0; i < L; ++i) {
		cleni = clens[i];
		if(cleni != 0) {
			ccode = bit_swap_n(ctree[i], maxlen)>>(maxlen-cleni);
			for(j = (1<<(maxlen + 4 - cleni)) - 1; j>=0; --j)
				cmap[ccode|(j<<cleni)] = (cleni&15) | (i<<4);
		}
	}
	return maxlen;
}

var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
var fix_dmap = use_typed_arrays ? new Uint16Array(32)  : zero_fill_array(32);
if(!use_typed_arrays) {
	for(var i = 0; i < 512; ++i) fix_lmap[i] = 0;
	for(i = 0; i < 32; ++i) fix_dmap[i] = 0;
}
(function() {
	var dlens = [];
	var i = 0;
	for(;i<32; i++) dlens.push(5);
	build_tree(dlens, fix_dmap, 32);

	var clens = [];
	i = 0;
	for(; i<=143; i++) clens.push(8);
	for(; i<=255; i++) clens.push(9);
	for(; i<=279; i++) clens.push(7);
	for(; i<=287; i++) clens.push(8);
	build_tree(clens, fix_lmap, 288);
})();

var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
var dyn_cmap = use_typed_arrays ? new Uint16Array(128)   : zero_fill_array(128);
var dyn_len_1 = 1, dyn_len_2 = 1;

/* 5.5.3 Expanding Huffman Codes */
function dyn(data, boff) {
	/* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */
	var _HLIT = read_bits_5(data, boff) + 257; boff += 5;
	var _HDIST = read_bits_5(data, boff) + 1; boff += 5;
	var _HCLEN = read_bits_4(data, boff) + 4; boff += 4;
	var w = 0;

	/* grab and store code lengths */
	var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
	var ctree = [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ];
	var maxlen = 1;
	var bl_count =  use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
	var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
	var L = clens.length; /* 19 */
	for(var i = 0; i < _HCLEN; ++i) {
		clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
		if(maxlen < w) maxlen = w;
		bl_count[w]++;
		boff += 3;
	}

	/* build code tree */
	var ccode = 0;
	bl_count[0] = 0;
	for(i = 1; i <= maxlen; ++i) next_code[i] = ccode = (ccode + bl_count[i-1])<<1;
	for(i = 0; i < L; ++i) if((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
	/* cmap[7 bits from stream] = (off&7) + (lit<<3) */
	var cleni = 0;
	for(i = 0; i < L; ++i) {
		cleni = clens[i];
		if(cleni != 0) {
			ccode = bitswap8[ctree[i]]>>(8-cleni);
			for(var j = (1<<(7-cleni))-1; j>=0; --j) dyn_cmap[ccode|(j<<cleni)] = (cleni&7) | (i<<3);
		}
	}

	/* read literal and dist codes at once */
	var hcodes = [];
	maxlen = 1;
	for(; hcodes.length < _HLIT + _HDIST;) {
		ccode = dyn_cmap[read_bits_7(data, boff)];
		boff += ccode & 7;
		switch((ccode >>>= 3)) {
			case 16:
				w = 3 + read_bits_2(data, boff); boff += 2;
				ccode = hcodes[hcodes.length - 1];
				while(w-- > 0) hcodes.push(ccode);
				break;
			case 17:
				w = 3 + read_bits_3(data, boff); boff += 3;
				while(w-- > 0) hcodes.push(0);
				break;
			case 18:
				w = 11 + read_bits_7(data, boff); boff += 7;
				while(w -- > 0) hcodes.push(0);
				break;
			default:
				hcodes.push(ccode);
				if(maxlen < ccode) maxlen = ccode;
				break;
		}
	}

	/* build literal / length trees */
	var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
	for(i = _HLIT; i < 286; ++i) h1[i] = 0;
	for(i = _HDIST; i < 30; ++i) h2[i] = 0;
	dyn_len_1 = build_tree(h1, dyn_lmap, 286);
	dyn_len_2 = build_tree(h2, dyn_dmap, 30);
	return boff;
}

/* return [ data, bytesRead ] */
function inflate(data, usz) {
	/* shortcircuit for empty buffer [0x03, 0x00] */
	if(data[0] == 3 && !(data[1] & 0x3)) { return [new_raw_buf(usz), 2]; }

	/* bit offset */
	var boff = 0;

	/* header includes final bit and type bits */
	var header = 0;

	var outbuf = new_unsafe_buf(usz ? usz : (1<<18));
	var woff = 0;
	var OL = outbuf.length>>>0;
	var max_len_1 = 0, max_len_2 = 0;

	while((header&1) == 0) {
		header = read_bits_3(data, boff); boff += 3;
		if((header >>> 1) == 0) {
			/* Stored block */
			if(boff & 7) boff += 8 - (boff&7);
			/* 2 bytes sz, 2 bytes bit inverse */
			var sz = data[boff>>>3] | data[(boff>>>3)+1]<<8;
			boff += 32;
			/* push sz bytes */
			if(!usz && OL < woff + sz) { outbuf = realloc(outbuf, woff + sz); OL = outbuf.length; }
			if(typeof data.copy === 'function') {
				// $FlowIgnore
				data.copy(outbuf, woff, boff>>>3, (boff>>>3)+sz);
				woff += sz; boff += 8*sz;
			} else while(sz-- > 0) { outbuf[woff++] = data[boff>>>3]; boff += 8; }
			continue;
		} else if((header >>> 1) == 1) {
			/* Fixed Huffman */
			max_len_1 = 9; max_len_2 = 5;
		} else {
			/* Dynamic Huffman */
			boff = dyn(data, boff);
			max_len_1 = dyn_len_1; max_len_2 = dyn_len_2;
		}
		if(!usz && (OL < woff + 32767)) { outbuf = realloc(outbuf, woff + 32767); OL = outbuf.length; }
		for(;;) { // while(true) is apparently out of vogue in modern JS circles
			/* ingest code and move read head */
			var bits = read_bits_n(data, boff, max_len_1);
			var code = (header>>>1) == 1 ? fix_lmap[bits] : dyn_lmap[bits];
			boff += code & 15; code >>>= 4;
			/* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */
			if(((code>>>8)&0xFF) === 0) outbuf[woff++] = code;
			else if(code == 256) break;
			else {
				code -= 257;
				var len_eb = (code < 8) ? 0 : ((code-4)>>2); if(len_eb > 5) len_eb = 0;
				var tgt = woff + LEN_LN[code];
				/* length extra bits */
				if(len_eb > 0) {
					tgt += read_bits_n(data, boff, len_eb);
					boff += len_eb;
				}

				/* dist code */
				bits = read_bits_n(data, boff, max_len_2);
				code = (header>>>1) == 1 ? fix_dmap[bits] : dyn_dmap[bits];
				boff += code & 15; code >>>= 4;
				var dst_eb = (code < 4 ? 0 : (code-2)>>1);
				var dst = DST_LN[code];
				/* dist extra bits */
				if(dst_eb > 0) {
					dst += read_bits_n(data, boff, dst_eb);
					boff += dst_eb;
				}

				/* in the common case, manual byte copy is faster than TA set / Buffer copy */
				if(!usz && OL < tgt) { outbuf = realloc(outbuf, tgt); OL = outbuf.length; }
				while(woff < tgt) { outbuf[woff] = outbuf[woff - dst]; ++woff; }
			}
		}
	}
	return [usz ? outbuf : outbuf.slice(0, woff), (boff+7)>>>3];
}

function _inflate(payload, usz) {
	var data = payload.slice(payload.l||0);
	var out = inflate(data, usz);
	payload.l += out[1];
	return out[0];
}

function warn_or_throw(wrn, msg) {
	if(wrn) { if(typeof console !== 'undefined') console.error(msg); }
	else throw new Error(msg);
}

function parse_zip(file, options) {
	var blob = file;
	prep_blob(blob, 0);

	var FileIndex = [], FullPaths = [];
	var o = {
		FileIndex: FileIndex,
		FullPaths: FullPaths
	};
	init_cfb(o, { root: options.root });

	/* find end of central directory, start just after signature */
	var i = blob.length - 4;
	while((blob[i] != 0x50 || blob[i+1] != 0x4b || blob[i+2] != 0x05 || blob[i+3] != 0x06) && i >= 0) --i;
	blob.l = i + 4;

	/* parse end of central directory */
	blob.l += 4;
	var fcnt = blob.read_shift(2);
	blob.l += 6;
	var start_cd = blob.read_shift(4);

	/* parse central directory */
	blob.l = start_cd;

	for(i = 0; i < fcnt; ++i) {
		/* trust local file header instead of CD entry */
		blob.l += 20;
		var csz = blob.read_shift(4);
		var usz = blob.read_shift(4);
		var namelen = blob.read_shift(2);
		var efsz = blob.read_shift(2);
		var fcsz = blob.read_shift(2);
		blob.l += 8;
		var offset = blob.read_shift(4);
		var EF = parse_extra_field(blob.slice(blob.l+namelen, blob.l+namelen+efsz));
		blob.l += namelen + efsz + fcsz;

		var L = blob.l;
		blob.l = offset + 4;
		parse_local_file(blob, csz, usz, o, EF);
		blob.l = L;
	}

	return o;
}


/* head starts just after local file header signature */
function parse_local_file(blob, csz, usz, o, EF) {
	/* [local file header] */
	blob.l += 2;
	var flags = blob.read_shift(2);
	var meth = blob.read_shift(2);
	var date = parse_dos_date(blob);

	if(flags & 0x2041) throw new Error("Unsupported ZIP encryption");
	var crc32 = blob.read_shift(4);
	var _csz = blob.read_shift(4);
	var _usz = blob.read_shift(4);

	var namelen = blob.read_shift(2);
	var efsz = blob.read_shift(2);

	// TODO: flags & (1<<11) // UTF8
	var name = ""; for(var i = 0; i < namelen; ++i) name += String.fromCharCode(blob[blob.l++]);
	if(efsz) {
		var ef = parse_extra_field(blob.slice(blob.l, blob.l + efsz));
		if((ef[0x5455]||{}).mt) date = ef[0x5455].mt;
		if(((EF||{})[0x5455]||{}).mt) date = EF[0x5455].mt;
	}
	blob.l += efsz;

	/* [encryption header] */

	/* [file data] */
	var data = blob.slice(blob.l, blob.l + _csz);
	switch(meth) {
		case 8: data = _inflateRawSync(blob, _usz); break;
		case 0: break;
		default: throw new Error("Unsupported ZIP Compression method " + meth);
	}

	/* [data descriptor] */
	var wrn = false;
	if(flags & 8) {
		crc32 = blob.read_shift(4);
		if(crc32 == 0x08074b50) { crc32 = blob.read_shift(4); wrn = true; }
		_csz = blob.read_shift(4);
		_usz = blob.read_shift(4);
	}

	if(_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
	if(_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
	var _crc32 = CRC32.buf(data, 0);
	if(crc32 != _crc32) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
	cfb_add(o, name, data, {unsafe: true, mt: date});
}
function write_zip(cfb, options) {
	var _opts = options || {};
	var out = [], cdirs = [];
	var o = new_buf(1);
	var method = (_opts.compression ? 8 : 0), flags = 0;
	var desc = false;
	if(desc) flags |= 8;
	var i = 0, j = 0;

	var start_cd = 0, fcnt = 0;
	var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
	var crcs = [];
	var sz_cd = 0;

	for(i = 1; i < cfb.FullPaths.length; ++i) {
		fp = cfb.FullPaths[i].slice(root.length); fi = cfb.FileIndex[i];
		if(!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
		var start = start_cd;

		/* TODO: CP437 filename */
		var namebuf = new_buf(fp.length);
		for(j = 0; j < fp.length; ++j) namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
		namebuf = namebuf.slice(0, namebuf.l);
		crcs[fcnt] = CRC32.buf(fi.content, 0);

		var outbuf = fi.content;
		if(method == 8) outbuf = _deflateRawSync(outbuf);

		/* local file header */
		o = new_buf(30);
		o.write_shift(4, 0x04034b50);
		o.write_shift(2, 20);
		o.write_shift(2, flags);
		o.write_shift(2, method);
		/* TODO: last mod file time/date */
		if(fi.mt) write_dos_date(o, fi.mt);
		else o.write_shift(4, 0);
		o.write_shift(-4, (flags & 8) ? 0 : crcs[fcnt]);
		o.write_shift(4,  (flags & 8) ? 0 : outbuf.length);
		o.write_shift(4,  (flags & 8) ? 0 : fi.content.length);
		o.write_shift(2, namebuf.length);
		o.write_shift(2, 0);

		start_cd += o.length;
		out.push(o);
		start_cd += namebuf.length;
		out.push(namebuf);

		/* TODO: encryption header ? */
		start_cd += outbuf.length;
		out.push(outbuf);

		/* data descriptor */
		if(flags & 8) {
			o = new_buf(12);
			o.write_shift(-4, crcs[fcnt]);
			o.write_shift(4, outbuf.length);
			o.write_shift(4, fi.content.length);
			start_cd += o.l;
			out.push(o);
		}

		/* central directory */
		o = new_buf(46);
		o.write_shift(4, 0x02014b50);
		o.write_shift(2, 0);
		o.write_shift(2, 20);
		o.write_shift(2, flags);
		o.write_shift(2, method);
		o.write_shift(4, 0); /* TODO: last mod file time/date */
		o.write_shift(-4, crcs[fcnt]);

		o.write_shift(4, outbuf.length);
		o.write_shift(4, fi.content.length);
		o.write_shift(2, namebuf.length);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(4, 0);
		o.write_shift(4, start);

		sz_cd += o.l;
		cdirs.push(o);
		sz_cd += namebuf.length;
		cdirs.push(namebuf);
		++fcnt;
	}

	/* end of central directory */
	o = new_buf(22);
	o.write_shift(4, 0x06054b50);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, fcnt);
	o.write_shift(2, fcnt);
	o.write_shift(4, sz_cd);
	o.write_shift(4, start_cd);
	o.write_shift(2, 0);

	return bconcat(([bconcat((out)), bconcat(cdirs), o]));
}
function cfb_new(opts) {
	var o = ({});
	init_cfb(o, opts);
	return o;
}

function cfb_add(cfb, name, content, opts) {
	var unsafe = opts && opts.unsafe;
	if(!unsafe) init_cfb(cfb);
	var file = !unsafe && CFB.find(cfb, name);
	if(!file) {
		var fpath = cfb.FullPaths[0];
		if(name.slice(0, fpath.length) == fpath) fpath = name;
		else {
			if(fpath.slice(-1) != "/") fpath += "/";
			fpath = (fpath + name).replace("//","/");
		}
		file = ({name: filename(name), type: 2});
		cfb.FileIndex.push(file);
		cfb.FullPaths.push(fpath);
		if(!unsafe) CFB.utils.cfb_gc(cfb);
	}
file.content = (content);
	file.size = content ? content.length : 0;
	if(opts) {
		if(opts.CLSID) file.clsid = opts.CLSID;
		if(opts.mt) file.mt = opts.mt;
		if(opts.ct) file.ct = opts.ct;
	}
	return file;
}

function cfb_del(cfb, name) {
	init_cfb(cfb);
	var file = CFB.find(cfb, name);
	if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
		cfb.FileIndex.splice(j, 1);
		cfb.FullPaths.splice(j, 1);
		return true;
	}
	return false;
}

function cfb_mov(cfb, old_name, new_name) {
	init_cfb(cfb);
	var file = CFB.find(cfb, old_name);
	if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
		cfb.FileIndex[j].name = filename(new_name);
		cfb.FullPaths[j] = new_name;
		return true;
	}
	return false;
}

function cfb_gc(cfb) { rebuild_cfb(cfb, true); }

exports.find = find;
exports.read = read;
exports.parse = parse;
exports.write = write;
exports.writeFile = write_file;
exports.utils = {
	cfb_new: cfb_new,
	cfb_add: cfb_add,
	cfb_del: cfb_del,
	cfb_mov: cfb_mov,
	cfb_gc: cfb_gc,
	ReadShift: ReadShift,
	CheckField: CheckField,
	prep_blob: prep_blob,
	bconcat: bconcat,
	use_zlib: use_zlib,
	_deflateRaw: _deflate,
	_inflateRaw: _inflate,
	consts: consts
};

return exports;
})();

if("function" !== 'undefined' && typeof module !== 'undefined' && typeof DO_NOT_EXPORT_CFB === 'undefined') { module.exports = CFB; }
var _fs;
if(true) try { _fs = __webpack_require__(521); } catch(e) {}

/* normalize data for blob ctor */
function blobify(data) {
	if(typeof data === "string") return s2ab(data);
	if(Array.isArray(data)) return a2u(data);
	return data;
}
/* write or download file */
function write_dl(fname, payload, enc) {
	/*global IE_SaveFile, Blob, navigator, saveAs, URL, document, File, chrome */
	if(typeof _fs !== 'undefined' && _fs.writeFileSync) return enc ? _fs.writeFileSync(fname, payload, enc) : _fs.writeFileSync(fname, payload);
	var data = (enc == "utf8") ? utf8write(payload) : payload;
if(typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
	if(typeof Blob !== 'undefined') {
		var blob = new Blob([blobify(data)], {type:"application/octet-stream"});
if(typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
if(typeof saveAs !== 'undefined') return saveAs(blob, fname);
		if(typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
			var url = URL.createObjectURL(blob);
if(typeof chrome === 'object' && typeof (chrome.downloads||{}).download == "function") {
				if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
				return chrome.downloads.download({ url: url, filename: fname, saveAs: true});
			}
			var a = document.createElement("a");
			if(a.download != null) {
a.download = fname; a.href = url; document.body.appendChild(a); a.click();
document.body.removeChild(a);
				if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
				return url;
			}
		}
	}
	// $FlowIgnore
	if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
		// $FlowIgnore
		var out = File(fname); out.open("w"); out.encoding = "binary";
		if(Array.isArray(payload)) payload = a2s(payload);
		out.write(payload); out.close(); return payload;
	} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
	throw new Error("cannot save file " + fname);
}

/* read binary data from file */
function read_binary(path) {
	if(typeof _fs !== 'undefined') return _fs.readFileSync(path);
	// $FlowIgnore
	if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
		// $FlowIgnore
		var infile = File(path); infile.open("r"); infile.encoding = "binary";
		var data = infile.read(); infile.close();
		return data;
	} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
	throw new Error("Cannot access file " + path);
}
function keys(o) {
	var ks = Object.keys(o), o2 = [];
	for(var i = 0; i < ks.length; ++i) if(o.hasOwnProperty(ks[i])) o2.push(ks[i]);
	return o2;
}

function evert_key(obj, key) {
	var o = ([]), K = keys(obj);
	for(var i = 0; i !== K.length; ++i) if(o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
	return o;
}

function evert(obj) {
	var o = ([]), K = keys(obj);
	for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = K[i];
	return o;
}

function evert_num(obj) {
	var o = ([]), K = keys(obj);
	for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = parseInt(K[i],10);
	return o;
}

function evert_arr(obj) {
	var o = ([]), K = keys(obj);
	for(var i = 0; i !== K.length; ++i) {
		if(o[obj[K[i]]] == null) o[obj[K[i]]] = [];
		o[obj[K[i]]].push(K[i]);
	}
	return o;
}

var basedate = new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
var dnthresh = basedate.getTime() + (new Date().getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
function datenum(v, date1904) {
	var epoch = v.getTime();
	if(date1904) epoch -= 1462*24*60*60*1000;
	return (epoch - dnthresh) / (24 * 60 * 60 * 1000);
}
function numdate(v) {
	var out = new Date();
	out.setTime(v * 24 * 60 * 60 * 1000 + dnthresh);
	return out;
}

/* ISO 8601 Duration */
function parse_isodur(s) {
	var sec = 0, mt = 0, time = false;
	var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
	if(!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
	for(var i = 1; i != m.length; ++i) {
		if(!m[i]) continue;
		mt = 1;
		if(i > 3) time = true;
		switch(m[i].slice(m[i].length-1)) {
			case 'Y':
				throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length-1));
			case 'D': mt *= 24;
				/* falls through */
			case 'H': mt *= 60;
				/* falls through */
			case 'M':
				if(!time) throw new Error("Unsupported ISO Duration Field: M");
				else mt *= 60;
				/* falls through */
			case 'S': break;
		}
		sec += mt * parseInt(m[i], 10);
	}
	return sec;
}

var good_pd_date = new Date('2017-02-19T19:06:09.000Z');
if(isNaN(good_pd_date.getFullYear())) good_pd_date = new Date('2/19/17');
var good_pd = good_pd_date.getFullYear() == 2017;
/* parses a date as a local date */
function parseDate(str, fixdate) {
	var d = new Date(str);
	if(good_pd) {
if(fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60 * 1000);
		else if(fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
		return d;
	}
	if(str instanceof Date) return str;
	if(good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
		var s = d.getFullYear();
		if(str.indexOf("" + s) > -1) return d;
		d.setFullYear(d.getFullYear() + 100); return d;
	}
	var n = str.match(/\d+/g)||["2017","2","19","0","0","0"];
	var out = new Date(+n[0], +n[1] - 1, +n[2], (+n[3]||0), (+n[4]||0), (+n[5]||0));
	if(str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60 * 1000);
	return out;
}

function cc2str(arr) {
	var o = "";
	for(var i = 0; i != arr.length; ++i) o += String.fromCharCode(arr[i]);
	return o;
}

function dup(o) {
	if(typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
	if(typeof o != 'object' || o == null) return o;
	if(o instanceof Date) return new Date(o.getTime());
	var out = {};
	for(var k in o) if(o.hasOwnProperty(k)) out[k] = dup(o[k]);
	return out;
}

function fill(c,l) { var o = ""; while(o.length < l) o+=c; return o; }

/* TODO: stress test */
function fuzzynum(s) {
	var v = Number(s);
	if(!isNaN(v)) return v;
	var wt = 1;
	var ss = s.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g, function() { wt *= 100; return "";});
	if(!isNaN(v = Number(ss))) return v / wt;
	ss = ss.replace(/[(](.*)[)]/,function($$, $1) { wt = -wt; return $1;});
	if(!isNaN(v = Number(ss))) return v / wt;
	return v;
}
function fuzzydate(s) {
	var o = new Date(s), n = new Date(NaN);
	var y = o.getYear(), m = o.getMonth(), d = o.getDate();
	if(isNaN(d)) return n;
	if(y < 0 || y > 8099) return n;
	if((m > 0 || d > 1) && y != 101) return o;
	if(s.toLowerCase().match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) return o;
	if(s.match(/[^-0-9:,\/\\]/)) return n;
	return o;
}

var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
function split_regex(str, re, def) {
	if(safe_split_regex || typeof re == "string") return str.split(re);
	var p = str.split(re), o = [p[0]];
	for(var i = 1; i < p.length; ++i) { o.push(def); o.push(p[i]); }
	return o;
}
function getdatastr(data) {
	if(!data) return null;
	if(data.data) return debom(data.data);
	if(data.asNodeBuffer && has_buf) return debom(data.asNodeBuffer().toString('binary'));
	if(data.asBinary) return debom(data.asBinary());
	if(data._data && data._data.getContent) return debom(cc2str(Array.prototype.slice.call(data._data.getContent(),0)));
	return null;
}

function getdatabin(data) {
	if(!data) return null;
	if(data.data) return char_codes(data.data);
	if(data.asNodeBuffer && has_buf) return data.asNodeBuffer();
	if(data._data && data._data.getContent) {
		var o = data._data.getContent();
		if(typeof o == "string") return char_codes(o);
		return Array.prototype.slice.call(o);
	}
	return null;
}

function getdata(data) { return (data && data.name.slice(-4) === ".bin") ? getdatabin(data) : getdatastr(data); }

/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */
/* OASIS does not comment on filename case sensitivity */
function safegetzipfile(zip, file) {
	var k = keys(zip.files);
	var f = file.toLowerCase(), g = f.replace(/\//g,'\\');
	for(var i=0; i<k.length; ++i) {
		var n = k[i].toLowerCase();
		if(f == n || g == n) return zip.files[k[i]];
	}
	return null;
}

function getzipfile(zip, file) {
	var o = safegetzipfile(zip, file);
	if(o == null) throw new Error("Cannot find file " + file + " in zip");
	return o;
}

function getzipdata(zip, file, safe) {
	if(!safe) return getdata(getzipfile(zip, file));
	if(!file) return null;
	try { return getzipdata(zip, file); } catch(e) { return null; }
}

function getzipstr(zip, file, safe) {
	if(!safe) return getdatastr(getzipfile(zip, file));
	if(!file) return null;
	try { return getzipstr(zip, file); } catch(e) { return null; }
}

function zipentries(zip) {
	var k = keys(zip.files), o = [];
	for(var i = 0; i < k.length; ++i) if(k[i].slice(-1) != '/') o.push(k[i]);
	return o.sort();
}

var jszip;
/*global JSZipSync:true */
if(typeof JSZipSync !== 'undefined') jszip = JSZipSync;
if(true) {
	if(typeof module !== 'undefined' && module.exports) {
		if(typeof jszip === 'undefined') jszip = __webpack_require__(1463);
	}
}

function resolve_path(path, base) {
	var result = base.split('/');
	if(base.slice(-1) != "/") result.pop(); // folder path
	var target = path.split('/');
	while (target.length !== 0) {
		var step = target.shift();
		if (step === '..') result.pop();
		else if (step !== '.') result.push(step);
	}
	return result.join('/');
}
var XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
var attregexg=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
var tagregex=/<[\/\?]?[a-zA-Z0-9:]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s?[\/\?]?>/g;
if(!(XML_HEADER.match(tagregex))) tagregex = /<[^>]*>/g;
var nsregex=/<\w*:/, nsregex2 = /<(\/?)\w+:/;
function parsexmltag(tag, skip_root) {
	var z = ({});
	var eq = 0, c = 0;
	for(; eq !== tag.length; ++eq) if((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
	if(!skip_root) z[0] = tag.slice(0, eq);
	if(eq === tag.length) return z;
	var m = tag.match(attregexg), j=0, v="", i=0, q="", cc="", quot = 1;
	if(m) for(i = 0; i != m.length; ++i) {
		cc = m[i];
		for(c=0; c != cc.length; ++c) if(cc.charCodeAt(c) === 61) break;
		q = cc.slice(0,c).trim();
		while(cc.charCodeAt(c+1) == 32) ++c;
		quot = ((eq=cc.charCodeAt(c+1)) == 34 || eq == 39) ? 1 : 0;
		v = cc.slice(c+1+quot, cc.length-quot);
		for(j=0;j!=q.length;++j) if(q.charCodeAt(j) === 58) break;
		if(j===q.length) {
			if(q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
			z[q] = v;
			z[q.toLowerCase()] = v;
		}
		else {
			var k = (j===5 && q.slice(0,5)==="xmlns"?"xmlns":"")+q.slice(j+1);
			if(z[k] && q.slice(j-3,j) == "ext") continue; // from ods
			z[k] = v;
			z[k.toLowerCase()] = v;
		}
	}
	return z;
}
function strip_ns(x) { return x.replace(nsregex2, "<$1"); }

var encodings = {
	'&quot;': '"',
	'&apos;': "'",
	'&gt;': '>',
	'&lt;': '<',
	'&amp;': '&'
};
var rencoding = evert(encodings);
//var rencstr = "&<>'\"".split("");

// TODO: CP remap (need to read file version to determine OS)
var unescapexml = (function() {
	/* 22.4.2.4 bstr (Basic String) */
	var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/g, coderegex = /_x([\da-fA-F]{4})_/g;
	return function unescapexml(text) {
		var s = text + '', i = s.indexOf("<![CDATA[");
		if(i == -1) return s.replace(encregex, function($$, $1) { return encodings[$$]||String.fromCharCode(parseInt($1,$$.indexOf("x")>-1?16:10))||$$; }).replace(coderegex,function(m,c) {return String.fromCharCode(parseInt(c,16));});
		var j = s.indexOf("]]>");
		return unescapexml(s.slice(0, i)) + s.slice(i+9,j) + unescapexml(s.slice(j+3));
	};
})();

var decregex=/[&<>'"]/g, charegex = /[\u0000-\u0008\u000b-\u001f]/g;
function escapexml(text){
	var s = text + '';
	return s.replace(decregex, function(y) { return rencoding[y]; }).replace(charegex,function(s) { return "_x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + "_";});
}
function escapexmltag(text){ return escapexml(text).replace(/ /g,"_x0020_"); }

var htmlcharegex = /[\u0000-\u001f]/g;
function escapehtml(text){
	var s = text + '';
	return s.replace(decregex, function(y) { return rencoding[y]; }).replace(/\n/g, "<br/>").replace(htmlcharegex,function(s) { return "&#x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + ";"; });
}

function escapexlml(text){
	var s = text + '';
	return s.replace(decregex, function(y) { return rencoding[y]; }).replace(htmlcharegex,function(s) { return "&#x" + (s.charCodeAt(0).toString(16)).toUpperCase() + ";"; });
}

/* TODO: handle codepages */
var xlml_fixstr = (function() {
	var entregex = /&#(\d+);/g;
	function entrepl($$,$1) { return String.fromCharCode(parseInt($1,10)); }
	return function xlml_fixstr(str) { return str.replace(entregex,entrepl); };
})();
var xlml_unfixstr = (function() {
	return function xlml_unfixstr(str) { return str.replace(/(\r\n|[\r\n])/g,"\&#10;"); };
})();

function parsexmlbool(value) {
	switch(value) {
		case 1: case true: case '1': case 'true': case 'TRUE': return true;
		/* case '0': case 'false': case 'FALSE':*/
		default: return false;
	}
}

var utf8read = function utf8reada(orig) {
	var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
	while (i < orig.length) {
		c = orig.charCodeAt(i++);
		if (c < 128) { out += String.fromCharCode(c); continue; }
		d = orig.charCodeAt(i++);
		if (c>191 && c<224) { f = ((c & 31) << 6); f |= (d & 63); out += String.fromCharCode(f); continue; }
		e = orig.charCodeAt(i++);
		if (c < 240) { out += String.fromCharCode(((c & 15) << 12) | ((d & 63) << 6) | (e & 63)); continue; }
		f = orig.charCodeAt(i++);
		w = (((c & 7) << 18) | ((d & 63) << 12) | ((e & 63) << 6) | (f & 63))-65536;
		out += String.fromCharCode(0xD800 + ((w>>>10)&1023));
		out += String.fromCharCode(0xDC00 + (w&1023));
	}
	return out;
};

var utf8write = function(orig) {
	var out = [], i = 0, c = 0, d = 0;
	while(i < orig.length) {
		c = orig.charCodeAt(i++);
		switch(true) {
			case c < 128: out.push(String.fromCharCode(c)); break;
			case c < 2048:
				out.push(String.fromCharCode(192 + (c >> 6)));
				out.push(String.fromCharCode(128 + (c & 63)));
				break;
			case c >= 55296 && c < 57344:
				c -= 55296; d = orig.charCodeAt(i++) - 56320 + (c<<10);
				out.push(String.fromCharCode(240 + ((d >>18) & 7)));
				out.push(String.fromCharCode(144 + ((d >>12) & 63)));
				out.push(String.fromCharCode(128 + ((d >> 6) & 63)));
				out.push(String.fromCharCode(128 + (d & 63)));
				break;
			default:
				out.push(String.fromCharCode(224 + (c >> 12)));
				out.push(String.fromCharCode(128 + ((c >> 6) & 63)));
				out.push(String.fromCharCode(128 + (c & 63)));
		}
	}
	return out.join("");
};

if(has_buf) {
	var utf8readb = function utf8readb(data) {
		var out = Buffer.alloc(2*data.length), w, i, j = 1, k = 0, ww=0, c;
		for(i = 0; i < data.length; i+=j) {
			j = 1;
			if((c=data.charCodeAt(i)) < 128) w = c;
			else if(c < 224) { w = (c&31)*64+(data.charCodeAt(i+1)&63); j=2; }
			else if(c < 240) { w=(c&15)*4096+(data.charCodeAt(i+1)&63)*64+(data.charCodeAt(i+2)&63); j=3; }
			else { j = 4;
				w = (c & 7)*262144+(data.charCodeAt(i+1)&63)*4096+(data.charCodeAt(i+2)&63)*64+(data.charCodeAt(i+3)&63);
				w -= 65536; ww = 0xD800 + ((w>>>10)&1023); w = 0xDC00 + (w&1023);
			}
			if(ww !== 0) { out[k++] = ww&255; out[k++] = ww>>>8; ww = 0; }
			out[k++] = w%256; out[k++] = w>>>8;
		}
		return out.slice(0,k).toString('ucs2');
	};
	var corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
	if(utf8read(corpus) == utf8readb(corpus)) utf8read = utf8readb;
	// $FlowIgnore
	var utf8readc = function utf8readc(data) { return Buffer_from(data, 'binary').toString('utf8'); };
	if(utf8read(corpus) == utf8readc(corpus)) utf8read = utf8readc;

	// $FlowIgnore
	utf8write = function(data) { return Buffer_from(data, 'utf8').toString("binary"); };
}

// matches <foo>...</foo> extracts content
var matchtag = (function() {
	var mtcache = ({});
	return function matchtag(f,g) {
		var t = f+"|"+(g||"");
		if(mtcache[t]) return mtcache[t];
		return (mtcache[t] = new RegExp('<(?:\\w+:)?'+f+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+f+'>',((g||""))));
	};
})();

var htmldecode = (function() {
	var entities = [
		['nbsp', ' '], ['middot', '·'],
		['quot', '"'], ['apos', "'"], ['gt',   '>'], ['lt',   '<'], ['amp',  '&']
	].map(function(x) { return [new RegExp('&' + x[0] + ';', "g"), x[1]]; });
	return function htmldecode(str) {
		var o = str.replace(/^[\t\n\r ]+/, "").replace(/[\t\n\r ]+$/,"").replace(/[\t\n\r ]+/g, " ").replace(/<\s*[bB][rR]\s*\/?>/g,"\n").replace(/<[^>]*>/g,"");
		for(var i = 0; i < entities.length; ++i) o = o.replace(entities[i][0], entities[i][1]);
		return o;
	};
})();

var vtregex = (function(){ var vt_cache = {};
	return function vt_regex(bt) {
		if(vt_cache[bt] !== undefined) return vt_cache[bt];
		return (vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", 'g') );
};})();
var vtvregex = /<\/?(?:vt:)?variant>/g, vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
function parseVector(data, opts) {
	var h = parsexmltag(data);

	var matches = data.match(vtregex(h.baseType))||[];
	var res = [];
	if(matches.length != h.size) {
		if(opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
		return res;
	}
	matches.forEach(function(x) {
		var v = x.replace(vtvregex,"").match(vtmregex);
		if(v) res.push({v:utf8read(v[2]), t:v[1]});
	});
	return res;
}

var wtregex = /(^\s|\s$|\n)/;
function writetag(f,g) { return '<' + f + (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f + '>'; }

function wxt_helper(h) { return keys(h).map(function(k) { return " " + k + '="' + h[k] + '"';}).join(""); }
function writextag(f,g,h) { return '<' + f + ((h != null) ? wxt_helper(h) : "") + ((g != null) ? (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';}

function write_w3cdtf(d, t) { try { return d.toISOString().replace(/\.\d*/,""); } catch(e) { if(t) throw e; } return ""; }

function write_vt(s) {
	switch(typeof s) {
		case 'string': return writextag('vt:lpwstr', s);
		case 'number': return writextag((s|0)==s?'vt:i4':'vt:r8', String(s));
		case 'boolean': return writextag('vt:bool',s?'true':'false');
	}
	if(s instanceof Date) return writextag('vt:filetime', write_w3cdtf(s));
	throw new Error("Unable to serialize " + s);
}

var XMLNS = ({
	'dc': 'http://purl.org/dc/elements/1.1/',
	'dcterms': 'http://purl.org/dc/terms/',
	'dcmitype': 'http://purl.org/dc/dcmitype/',
	'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
	'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
	'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
	'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
	'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
	'xsd': 'http://www.w3.org/2001/XMLSchema'
});

XMLNS.main = [
	'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
	'http://purl.oclc.org/ooxml/spreadsheetml/main',
	'http://schemas.microsoft.com/office/excel/2006/main',
	'http://schemas.microsoft.com/office/excel/2006/2'
];

var XLMLNS = ({
	'o':    'urn:schemas-microsoft-com:office:office',
	'x':    'urn:schemas-microsoft-com:office:excel',
	'ss':   'urn:schemas-microsoft-com:office:spreadsheet',
	'dt':   'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
	'mv':   'http://macVmlSchemaUri',
	'v':    'urn:schemas-microsoft-com:vml',
	'html': 'http://www.w3.org/TR/REC-html40'
});
function read_double_le(b, idx) {
	var s = 1 - 2 * (b[idx + 7] >>> 7);
	var e = ((b[idx + 7] & 0x7f) << 4) + ((b[idx + 6] >>> 4) & 0x0f);
	var m = (b[idx+6]&0x0f);
	for(var i = 5; i >= 0; --i) m = m * 256 + b[idx + i];
	if(e == 0x7ff) return m == 0 ? (s * Infinity) : NaN;
	if(e == 0) e = -1022;
	else { e -= 1023; m += Math.pow(2,52); }
	return s * Math.pow(2, e - 52) * m;
}

function write_double_le(b, v, idx) {
	var bs = ((((v < 0) || (1/v == -Infinity)) ? 1 : 0) << 7), e = 0, m = 0;
	var av = bs ? (-v) : v;
	if(!isFinite(av)) { e = 0x7ff; m = isNaN(v) ? 0x6969 : 0; }
	else if(av == 0) e = m = 0;
	else {
		e = Math.floor(Math.log(av) / Math.LN2);
		m = av * Math.pow(2, 52 - e);
		if((e <= -1023) && (!isFinite(m) || (m < Math.pow(2,52)))) { e = -1022; }
		else { m -= Math.pow(2,52); e+=1023; }
	}
	for(var i = 0; i <= 5; ++i, m/=256) b[idx + i] = m & 0xff;
	b[idx + 6] = ((e & 0x0f) << 4) | (m & 0xf);
	b[idx + 7] = (e >> 4) | bs;
}

var __toBuffer = function(bufs) { var x=[],w=10240; for(var i=0;i<bufs[0].length;++i) if(bufs[0][i]) for(var j=0,L=bufs[0][i].length;j<L;j+=w) x.push.apply(x, bufs[0][i].slice(j,j+w)); return x; };
var ___toBuffer = __toBuffer;
var __utf16le = function(b,s,e) { var ss=[]; for(var i=s; i<e; i+=2) ss.push(String.fromCharCode(__readUInt16LE(b,i))); return ss.join("").replace(chr0,''); };
var ___utf16le = __utf16le;
var __hexlify = function(b,s,l) { var ss=[]; for(var i=s; i<s+l; ++i) ss.push(("0" + b[i].toString(16)).slice(-2)); return ss.join(""); };
var ___hexlify = __hexlify;
var __utf8 = function(b,s,e) { var ss=[]; for(var i=s; i<e; i++) ss.push(String.fromCharCode(__readUInt8(b,i))); return ss.join(""); };
var ___utf8 = __utf8;
var __lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
var ___lpstr = __lpstr;
var __cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
var ___cpstr = __cpstr;
var __lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
var ___lpwstr = __lpwstr;
var __lpp4, ___lpp4;
__lpp4 = ___lpp4 = function lpp4_(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf16le(b, i+4,i+4+len) : "";};
var __8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len) : "";};
var ___8lpp4 = __8lpp4;
var __double, ___double;
__double = ___double = function(b, idx) { return read_double_le(b, idx);};
var is_buf = function is_buf_a(a) { return Array.isArray(a); };

if(has_buf) {
	__utf16le = function(b,s,e) { if(!Buffer.isBuffer(b)) return ___utf16le(b,s,e); return b.toString('utf16le',s,e).replace(chr0,'')/*.replace(chr1,'!')*/; };
	__hexlify = function(b,s,l) { return Buffer.isBuffer(b) ? b.toString('hex',s,s+l) : ___hexlify(b,s,l); };
	__lpstr = function lpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
	__cpstr = function cpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___cpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
	__lpwstr = function lpwstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpwstr(b, i); var len = 2*b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len-1);};
	__lpp4 = function lpp4_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len);};
	__8lpp4 = function lpp4_8b(b, i) { if(!Buffer.isBuffer(b)) return ___8lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf8',i+4,i+4+len);};
	__utf8 = function utf8_b(b, s, e) { return (Buffer.isBuffer(b)) ? b.toString('utf8',s,e) : ___utf8(b,s,e); };
	__toBuffer = function(bufs) { return (bufs[0].length > 0 && Buffer.isBuffer(bufs[0][0])) ? Buffer.concat(bufs[0]) : ___toBuffer(bufs);};
	bconcat = function(bufs) { return Buffer.isBuffer(bufs[0]) ? Buffer.concat(bufs) : [].concat.apply([], bufs); };
	__double = function double_(b, i) { if(Buffer.isBuffer(b)) return b.readDoubleLE(i); return ___double(b,i); };
	is_buf = function is_buf_b(a) { return Buffer.isBuffer(a) || Array.isArray(a); };
}

/* from js-xls */
if(typeof cptable !== 'undefined') {
	__utf16le = function(b,s,e) { return cptable.utils.decode(1200, b.slice(s,e)).replace(chr0, ''); };
	__utf8 = function(b,s,e) { return cptable.utils.decode(65001, b.slice(s,e)); };
	__lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(current_ansi, b.slice(i+4, i+4+len-1)) : "";};
	__cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(current_codepage, b.slice(i+4, i+4+len-1)) : "";};
	__lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(1200, b.slice(i+4,i+4+len-1)) : "";};
	__lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(1200, b.slice(i+4,i+4+len)) : "";};
	__8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(65001, b.slice(i+4,i+4+len)) : "";};
}

var __readUInt8 = function(b, idx) { return b[idx]; };
var __readUInt16LE = function(b, idx) { return (b[idx+1]*(1<<8))+b[idx]; };
var __readInt16LE = function(b, idx) { var u = (b[idx+1]*(1<<8))+b[idx]; return (u < 0x8000) ? u : ((0xffff - u + 1) * -1); };
var __readUInt32LE = function(b, idx) { return b[idx+3]*(1<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx]; };
var __readInt32LE = function(b, idx) { return (b[idx+3]<<24)|(b[idx+2]<<16)|(b[idx+1]<<8)|b[idx]; };
var __readInt32BE = function(b, idx) { return (b[idx]<<24)|(b[idx+1]<<16)|(b[idx+2]<<8)|b[idx+3]; };

function ReadShift(size, t) {
	var o="", oI, oR, oo=[], w, vv, i, loc;
	switch(t) {
		case 'dbcs':
			loc = this.l;
			if(has_buf && Buffer.isBuffer(this)) o = this.slice(this.l, this.l+2*size).toString("utf16le");
			else for(i = 0; i < size; ++i) { o+=String.fromCharCode(__readUInt16LE(this, loc)); loc+=2; }
			size *= 2;
			break;

		case 'utf8': o = __utf8(this, this.l, this.l + size); break;
		case 'utf16le': size *= 2; o = __utf16le(this, this.l, this.l + size); break;

		case 'wstr':
			if(typeof cptable !== 'undefined') o = cptable.utils.decode(current_codepage, this.slice(this.l, this.l+2*size));
			else return ReadShift.call(this, size, 'dbcs');
			size = 2 * size; break;

		/* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */
		case 'lpstr-ansi': o = __lpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
		case 'lpstr-cp': o = __cpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
		/* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */
		case 'lpwstr': o = __lpwstr(this, this.l); size = 4 + 2 * __readUInt32LE(this, this.l); break;
		/* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */
		case 'lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __lpp4(this, this.l); if(size & 0x02) size += 2; break;
		/* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */
		case '8lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __8lpp4(this, this.l); if(size & 0x03) size += 4 - (size & 0x03); break;

		case 'cstr': size = 0; o = "";
			while((w=__readUInt8(this, this.l + size++))!==0) oo.push(_getchar(w));
			o = oo.join(""); break;
		case '_wstr': size = 0; o = "";
			while((w=__readUInt16LE(this,this.l +size))!==0){oo.push(_getchar(w));size+=2;}
			size+=2; o = oo.join(""); break;

		/* sbcs and dbcs support continue records in the SST way TODO codepages */
		case 'dbcs-cont': o = ""; loc = this.l;
			for(i = 0; i < size; ++i) {
				if(this.lens && this.lens.indexOf(loc) !== -1) {
					w = __readUInt8(this, loc);
					this.l = loc + 1;
					vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
					return oo.join("") + vv;
				}
				oo.push(_getchar(__readUInt16LE(this, loc)));
				loc+=2;
			} o = oo.join(""); size *= 2; break;

		case 'cpstr':
			if(typeof cptable !== 'undefined') {
				o = cptable.utils.decode(current_codepage, this.slice(this.l, this.l + size));
				break;
			}
		/* falls through */
		case 'sbcs-cont': o = ""; loc = this.l;
			for(i = 0; i != size; ++i) {
				if(this.lens && this.lens.indexOf(loc) !== -1) {
					w = __readUInt8(this, loc);
					this.l = loc + 1;
					vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
					return oo.join("") + vv;
				}
				oo.push(_getchar(__readUInt8(this, loc)));
				loc+=1;
			} o = oo.join(""); break;

		default:
	switch(size) {
		case 1: oI = __readUInt8(this, this.l); this.l++; return oI;
		case 2: oI = (t === 'i' ? __readInt16LE : __readUInt16LE)(this, this.l); this.l += 2; return oI;
		case 4: case -4:
			if(t === 'i' || ((this[this.l+3] & 0x80)===0)) { oI = ((size > 0) ? __readInt32LE : __readInt32BE)(this, this.l); this.l += 4; return oI; }
			else { oR = __readUInt32LE(this, this.l); this.l += 4; } return oR;
		case 8: case -8:
			if(t === 'f') {
				if(size == 8) oR = __double(this, this.l);
				else oR = __double([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]], 0);
				this.l += 8; return oR;
			} else size = 8;
		/* falls through */
		case 16: o = __hexlify(this, this.l, size); break;
	}}
	this.l+=size; return o;
}

var __writeUInt32LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); b[idx+2] = ((val >>> 16) & 0xFF); b[idx+3] = ((val >>> 24) & 0xFF); };
var __writeInt32LE  = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >> 8) & 0xFF); b[idx+2] = ((val >> 16) & 0xFF); b[idx+3] = ((val >> 24) & 0xFF); };
var __writeUInt16LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); };

function WriteShift(t, val, f) {
	var size = 0, i = 0;
	if(f === 'dbcs') {
for(i = 0; i != val.length; ++i) __writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
		size = 2 * val.length;
	} else if(f === 'sbcs') {
		/* TODO: codepage */
val = val.replace(/[^\x00-\x7F]/g, "_");
for(i = 0; i != val.length; ++i) this[this.l + i] = (val.charCodeAt(i) & 0xFF);
		size = val.length;
	} else if(f === 'hex') {
		for(; i < t; ++i) {
this[this.l++] = (parseInt(val.slice(2*i, 2*i+2), 16)||0);
		} return this;
	} else if(f === 'utf16le') {
var end = Math.min(this.l + t, this.length);
			for(i = 0; i < Math.min(val.length, t); ++i) {
				var cc = val.charCodeAt(i);
				this[this.l++] = (cc & 0xff);
				this[this.l++] = (cc >> 8);
			}
			while(this.l < end) this[this.l++] = 0;
			return this;
	} else  switch(t) {
		case  1: size = 1; this[this.l] = val&0xFF; break;
		case  2: size = 2; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; break;
		case  3: size = 3; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; val >>>= 8; this[this.l+2] = val&0xFF; break;
		case  4: size = 4; __writeUInt32LE(this, val, this.l); break;
		case  8: size = 8; if(f === 'f') { write_double_le(this, val, this.l); break; }
		/* falls through */
		case 16: break;
		case -4: size = 4; __writeInt32LE(this, val, this.l); break;
	}
	this.l += size; return this;
}

function CheckField(hexstr, fld) {
	var m = __hexlify(this,this.l,hexstr.length>>1);
	if(m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
	this.l += hexstr.length>>1;
}

function prep_blob(blob, pos) {
	blob.l = pos;
	blob.read_shift = ReadShift;
	blob.chk = CheckField;
	blob.write_shift = WriteShift;
}

function parsenoop(blob, length) { blob.l += length; }

function new_buf(sz) {
	var o = new_raw_buf(sz);
	prep_blob(o, 0);
	return o;
}

/* [MS-XLSB] 2.1.4 Record */
function recordhopper(data, cb, opts) {
	if(!data) return;
	var tmpbyte, cntbyte, length;
	prep_blob(data, data.l || 0);
	var L = data.length, RT = 0, tgt = 0;
	while(data.l < L) {
		RT = data.read_shift(1);
		if(RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F)<<7);
		var R = XLSBRecordEnum[RT] || XLSBRecordEnum[0xFFFF];
		tmpbyte = data.read_shift(1);
		length = tmpbyte & 0x7F;
		for(cntbyte = 1; cntbyte <4 && (tmpbyte & 0x80); ++cntbyte) length += ((tmpbyte = data.read_shift(1)) & 0x7F)<<(7*cntbyte);
		tgt = data.l + length;
		var d = (R.f||parsenoop)(data, length, opts);
		data.l = tgt;
		if(cb(d, R.n, RT)) return;
	}
}

/* control buffer usage for fixed-length buffers */
function buf_array() {
	var bufs = [], blksz = has_buf ? 256 : 2048;
	var newblk = function ba_newblk(sz) {
		var o = (new_buf(sz));
		prep_blob(o, 0);
		return o;
	};

	var curbuf = newblk(blksz);

	var endbuf = function ba_endbuf() {
		if(!curbuf) return;
		if(curbuf.length > curbuf.l) { curbuf = curbuf.slice(0, curbuf.l); curbuf.l = curbuf.length; }
		if(curbuf.length > 0) bufs.push(curbuf);
		curbuf = null;
	};

	var next = function ba_next(sz) {
		if(curbuf && (sz < (curbuf.length - curbuf.l))) return curbuf;
		endbuf();
		return (curbuf = newblk(Math.max(sz+1, blksz)));
	};

	var end = function ba_end() {
		endbuf();
		return __toBuffer([bufs]);
	};

	var push = function ba_push(buf) { endbuf(); curbuf = buf; if(curbuf.l == null) curbuf.l = curbuf.length; next(blksz); };

	return ({ next:next, push:push, end:end, _bufs:bufs });
}

function write_record(ba, type, payload, length) {
	var t = +XLSBRE[type], l;
	if(isNaN(t)) return; // TODO: throw something here?
	if(!length) length = XLSBRecordEnum[t].p || (payload||[]).length || 0;
	l = 1 + (t >= 0x80 ? 1 : 0) + 1/* + length*/;
	if(length >= 0x80) ++l; if(length >= 0x4000) ++l; if(length >= 0x200000) ++l;
	var o = ba.next(l);
	if(t <= 0x7F) o.write_shift(1, t);
	else {
		o.write_shift(1, (t & 0x7F) + 0x80);
		o.write_shift(1, (t >> 7));
	}
	for(var i = 0; i != 4; ++i) {
		if(length >= 0x80) { o.write_shift(1, (length & 0x7F)+0x80); length >>= 7; }
		else { o.write_shift(1, length); break; }
	}
	if(length > 0 && is_buf(payload)) ba.push(payload);
}
/* XLS ranges enforced */
function shift_cell_xls(cell, tgt, opts) {
	var out = dup(cell);
	if(tgt.s) {
		if(out.cRel) out.c += tgt.s.c;
		if(out.rRel) out.r += tgt.s.r;
	} else {
		if(out.cRel) out.c += tgt.c;
		if(out.rRel) out.r += tgt.r;
	}
	if(!opts || opts.biff < 12) {
		while(out.c >= 0x100) out.c -= 0x100;
		while(out.r >= 0x10000) out.r -= 0x10000;
	}
	return out;
}

function shift_range_xls(cell, range, opts) {
	var out = dup(cell);
	out.s = shift_cell_xls(out.s, range.s, opts);
	out.e = shift_cell_xls(out.e, range.s, opts);
	return out;
}

function encode_cell_xls(c, biff) {
	if(c.cRel && c.c < 0) { c = dup(c); c.c += (biff > 8) ? 0x4000 : 0x100; }
	if(c.rRel && c.r < 0) { c = dup(c); c.r += (biff > 8) ? 0x100000 : ((biff > 5) ? 0x10000 : 0x4000); }
	var s = encode_cell(c);
	if(c.cRel === 0) s = fix_col(s);
	if(c.rRel === 0) s = fix_row(s);
	return s;
}

function encode_range_xls(r, opts) {
	if(r.s.r == 0 && !r.s.rRel) {
		if(r.e.r == (opts.biff >= 12 ? 0xFFFFF : (opts.biff >= 8 ? 0x10000 : 0x4000)) && !r.e.rRel) {
			return (r.s.cRel ? "" : "$") + encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + encode_col(r.e.c);
		}
	}
	if(r.s.c == 0 && !r.s.cRel) {
		if(r.e.c == (opts.biff >= 12 ? 0xFFFF : 0xFF) && !r.e.cRel) {
			return (r.s.rRel ? "" : "$") + encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + encode_row(r.e.r);
		}
	}
	return encode_cell_xls(r.s, opts.biff) + ":" + encode_cell_xls(r.e, opts.biff);
}
var OFFCRYPTO = {};

var make_offcrypto = function(O, _crypto) {
	var crypto;
	if(typeof _crypto !== 'undefined') crypto = _crypto;
	else if(true) {
		try { crypto = __webpack_require__(1465); }
		catch(e) { crypto = null; }
	}

	O.rc4 = function(key, data) {
		var S = new Array(256);
		var c = 0, i = 0, j = 0, t = 0;
		for(i = 0; i != 256; ++i) S[i] = i;
		for(i = 0; i != 256; ++i) {
			j = (j + S[i] + (key[i%key.length]).charCodeAt(0))&255;
			t = S[i]; S[i] = S[j]; S[j] = t;
		}
		// $FlowIgnore
		i = j = 0; var out = Buffer(data.length);
		for(c = 0; c != data.length; ++c) {
			i = (i + 1)&255;
			j = (j + S[i])%256;
			t = S[i]; S[i] = S[j]; S[j] = t;
			out[c] = (data[c] ^ S[(S[i]+S[j])&255]);
		}
		return out;
	};

	O.md5 = function(hex) {
		if(!crypto) throw new Error("Unsupported crypto");
		return crypto.createHash('md5').update(hex).digest('hex');
	};
};
/*global crypto:true */
make_offcrypto(OFFCRYPTO, typeof crypto !== "undefined" ? crypto : undefined);

function decode_row(rowstr) { return parseInt(unfix_row(rowstr),10) - 1; }
function encode_row(row) { return "" + (row + 1); }
function fix_row(cstr) { return cstr.replace(/([A-Z]|^)(\d+)$/,"$1$$$2"); }
function unfix_row(cstr) { return cstr.replace(/\$(\d+)$/,"$1"); }

function decode_col(colstr) { var c = unfix_col(colstr), d = 0, i = 0; for(; i !== c.length; ++i) d = 26*d + c.charCodeAt(i) - 64; return d - 1; }
function encode_col(col) { var s=""; for(++col; col; col=Math.floor((col-1)/26)) s = String.fromCharCode(((col-1)%26) + 65) + s; return s; }
function fix_col(cstr) { return cstr.replace(/^([A-Z])/,"$$$1"); }
function unfix_col(cstr) { return cstr.replace(/^\$([A-Z])/,"$1"); }

function split_cell(cstr) { return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(","); }
function decode_cell(cstr) { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
function encode_cell(cell) { return encode_col(cell.c) + encode_row(cell.r); }
function decode_range(range) { var x =range.split(":").map(decode_cell); return {s:x[0],e:x[x.length-1]}; }
function encode_range(cs,ce) {
	if(typeof ce === 'undefined' || typeof ce === 'number') {
return encode_range(cs.s, cs.e);
	}
if(typeof cs !== 'string') cs = encode_cell((cs));
	if(typeof ce !== 'string') ce = encode_cell((ce));
return cs == ce ? cs : cs + ":" + ce;
}

function safe_decode_range(range) {
	var o = {s:{c:0,r:0},e:{c:0,r:0}};
	var idx = 0, i = 0, cc = 0;
	var len = range.length;
	for(idx = 0; i < len; ++i) {
		if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
		idx = 26*idx + cc;
	}
	o.s.c = --idx;

	for(idx = 0; i < len; ++i) {
		if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
		idx = 10*idx + cc;
	}
	o.s.r = --idx;

	if(i === len || range.charCodeAt(++i) === 58) { o.e.c=o.s.c; o.e.r=o.s.r; return o; }

	for(idx = 0; i != len; ++i) {
		if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
		idx = 26*idx + cc;
	}
	o.e.c = --idx;

	for(idx = 0; i != len; ++i) {
		if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
		idx = 10*idx + cc;
	}
	o.e.r = --idx;
	return o;
}

function safe_format_cell(cell, v) {
	var q = (cell.t == 'd' && v instanceof Date);
	if(cell.z != null) try { return (cell.w = SSF.format(cell.z, q ? datenum(v) : v)); } catch(e) { }
	try { return (cell.w = SSF.format((cell.XF||{}).numFmtId||(q ? 14 : 0),  q ? datenum(v) : v)); } catch(e) { return ''+v; }
}

function format_cell(cell, v, o) {
	if(cell == null || cell.t == null || cell.t == 'z') return "";
	if(cell.w !== undefined) return cell.w;
	if(cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
	if(v == undefined) return safe_format_cell(cell, cell.v);
	return safe_format_cell(cell, v);
}

function sheet_to_workbook(sheet, opts) {
	var n = opts && opts.sheet ? opts.sheet : "Sheet1";
	var sheets = {}; sheets[n] = sheet;
	return { SheetNames: [n], Sheets: sheets };
}

function sheet_add_aoa(_ws, data, opts) {
	var o = opts || {};
	var dense = _ws ? Array.isArray(_ws) : o.dense;
	if(DENSE != null && dense == null) dense = DENSE;
	var ws = _ws || (dense ? ([]) : ({}));
	var _R = 0, _C = 0;
	if(ws && o.origin != null) {
		if(typeof o.origin == 'number') _R = o.origin;
		else {
			var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
			_R = _origin.r; _C = _origin.c;
		}
	}
	var range = ({s: {c:10000000, r:10000000}, e: {c:0, r:0}});
	if(ws['!ref']) {
		var _range = safe_decode_range(ws['!ref']);
		range.s.c = _range.s.c;
		range.s.r = _range.s.r;
		range.e.c = Math.max(range.e.c, _range.e.c);
		range.e.r = Math.max(range.e.r, _range.e.r);
		if(_R == -1) range.e.r = _R = _range.e.r + 1;
	}
	for(var R = 0; R != data.length; ++R) {
		if(!data[R]) continue;
		if(!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
		for(var C = 0; C != data[R].length; ++C) {
			if(typeof data[R][C] === 'undefined') continue;
			var cell = ({v: data[R][C] });
			var __R = _R + R, __C = _C + C;
			if(range.s.r > __R) range.s.r = __R;
			if(range.s.c > __C) range.s.c = __C;
			if(range.e.r < __R) range.e.r = __R;
			if(range.e.c < __C) range.e.c = __C;
			if(data[R][C] && typeof data[R][C] === 'object' && !Array.isArray(data[R][C]) && !(data[R][C] instanceof Date)) cell = data[R][C];
			else {
				if(Array.isArray(cell.v)) { cell.f = data[R][C][1]; cell.v = cell.v[0]; }
				if(cell.v === null) { if(cell.f) cell.t = 'n'; else if(!o.sheetStubs) continue; else cell.t = 'z'; }
				else if(typeof cell.v === 'number') cell.t = 'n';
				else if(typeof cell.v === 'boolean') cell.t = 'b';
				else if(cell.v instanceof Date) {
					cell.z = o.dateNF || SSF._table[14];
					if(o.cellDates) { cell.t = 'd'; cell.w = SSF.format(cell.z, datenum(cell.v)); }
					else { cell.t = 'n'; cell.v = datenum(cell.v); cell.w = SSF.format(cell.z, cell.v); }
				}
				else cell.t = 's';
			}
			if(dense) {
				if(!ws[__R]) ws[__R] = [];
				ws[__R][__C] = cell;
			} else {
				var cell_ref = encode_cell(({c:__C,r:__R}));
				ws[cell_ref] = cell;
			}
		}
	}
	if(range.s.c < 10000000) ws['!ref'] = encode_range(range);
	return ws;
}
function aoa_to_sheet(data, opts) { return sheet_add_aoa(null, data, opts); }

function write_UInt32LE(x, o) {
	if(!o) o = new_buf(4);
	o.write_shift(4, x);
	return o;
}

/* [MS-XLSB] 2.5.168 */
function parse_XLWideString(data) {
	var cchCharacters = data.read_shift(4);
	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function write_XLWideString(data, o) {
	var _null = false; if(o == null) { _null = true; o = new_buf(4+2*data.length); }
	o.write_shift(4, data.length);
	if(data.length > 0) o.write_shift(0, data, 'dbcs');
	return _null ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.5.143 */
function parse_StrRun(data) {
	return { ich: data.read_shift(2), ifnt: data.read_shift(2) };
}
function write_StrRun(run, o) {
	if(!o) o = new_buf(4);
	o.write_shift(2, run.ich || 0);
	o.write_shift(2, run.ifnt || 0);
	return o;
}

/* [MS-XLSB] 2.5.121 */
function parse_RichStr(data, length) {
	var start = data.l;
	var flags = data.read_shift(1);
	var str = parse_XLWideString(data);
	var rgsStrRun = [];
	var z = ({ t: str, h: str });
	if((flags & 1) !== 0) { /* fRichStr */
		/* TODO: formatted string */
		var dwSizeStrRun = data.read_shift(4);
		for(var i = 0; i != dwSizeStrRun; ++i) rgsStrRun.push(parse_StrRun(data));
		z.r = rgsStrRun;
	}
	else z.r = [{ich:0, ifnt:0}];
	//if((flags & 2) !== 0) { /* fExtStr */
	//	/* TODO: phonetic string */
	//}
	data.l = start + length;
	return z;
}
function write_RichStr(str, o) {
	/* TODO: formatted string */
	var _null = false; if(o == null) { _null = true; o = new_buf(15+4*str.t.length); }
	o.write_shift(1,0);
	write_XLWideString(str.t, o);
	return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */
var parse_BrtCommentText = parse_RichStr;
function write_BrtCommentText(str, o) {
	/* TODO: formatted string */
	var _null = false; if(o == null) { _null = true; o = new_buf(23+4*str.t.length); }
	o.write_shift(1,1);
	write_XLWideString(str.t, o);
	o.write_shift(4,1);
	write_StrRun({ich:0,ifnt:0}, o);
	return _null ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.5.9 */
function parse_XLSBCell(data) {
	var col = data.read_shift(4);
	var iStyleRef = data.read_shift(2);
	iStyleRef += data.read_shift(1) <<16;
	data.l++; //var fPhShow = data.read_shift(1);
	return { c:col, iStyleRef: iStyleRef };
}
function write_XLSBCell(cell, o) {
	if(o == null) o = new_buf(8);
	o.write_shift(-4, cell.c);
	o.write_shift(3, cell.iStyleRef || cell.s);
	o.write_shift(1, 0); /* fPhShow */
	return o;
}


/* [MS-XLSB] 2.5.21 */
var parse_XLSBCodeName = parse_XLWideString;
var write_XLSBCodeName = write_XLWideString;

/* [MS-XLSB] 2.5.166 */
function parse_XLNullableWideString(data) {
	var cchCharacters = data.read_shift(4);
	return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function write_XLNullableWideString(data, o) {
	var _null = false; if(o == null) { _null = true; o = new_buf(127); }
	o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
	if(data.length > 0) o.write_shift(0, data, 'dbcs');
	return _null ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.5.165 */
var parse_XLNameWideString = parse_XLWideString;
//var write_XLNameWideString = write_XLWideString;

/* [MS-XLSB] 2.5.114 */
var parse_RelID = parse_XLNullableWideString;
var write_RelID = write_XLNullableWideString;


/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */
function parse_RkNumber(data) {
	var b = data.slice(data.l, data.l+4);
	var fX100 = (b[0] & 1), fInt = (b[0] & 2);
	data.l+=4;
	b[0] &= 0xFC; // b[0] &= ~3;
	var RK = fInt === 0 ? __double([0,0,0,0,b[0],b[1],b[2],b[3]],0) : __readInt32LE(b,0)>>2;
	return fX100 ? (RK/100) : RK;
}
function write_RkNumber(data, o) {
	if(o == null) o = new_buf(4);
	var fX100 = 0, fInt = 0, d100 = data * 100;
	if((data == (data | 0)) && (data >= -(1<<29)) && (data < (1 << 29))) { fInt = 1; }
	else if((d100 == (d100 | 0)) && (d100 >= -(1<<29)) && (d100 < (1 << 29))) { fInt = 1; fX100 = 1; }
	if(fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
	else throw new Error("unsupported RkNumber " + data); // TODO
}


/* [MS-XLSB] 2.5.117 RfX */
function parse_RfX(data ) {
	var cell = ({s: {}, e: {}});
	cell.s.r = data.read_shift(4);
	cell.e.r = data.read_shift(4);
	cell.s.c = data.read_shift(4);
	cell.e.c = data.read_shift(4);
	return cell;
}
function write_RfX(r, o) {
	if(!o) o = new_buf(16);
	o.write_shift(4, r.s.r);
	o.write_shift(4, r.e.r);
	o.write_shift(4, r.s.c);
	o.write_shift(4, r.e.c);
	return o;
}

/* [MS-XLSB] 2.5.153 UncheckedRfX */
var parse_UncheckedRfX = parse_RfX;
var write_UncheckedRfX = write_RfX;

/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */
/* TODO: error checking, NaN and Infinity values are not valid Xnum */
function parse_Xnum(data) { return data.read_shift(8, 'f'); }
function write_Xnum(data, o) { return (o || new_buf(8)).write_shift(8, data, 'f'); }

/* [MS-XLSB] 2.5.97.2 */
var BErr = {
0x00: "#NULL!",
0x07: "#DIV/0!",
0x0F: "#VALUE!",
0x17: "#REF!",
0x1D: "#NAME?",
0x24: "#NUM!",
0x2A: "#N/A",
0x2B: "#GETTING_DATA",
0xFF: "#WTF?"
};
var RBErr = evert_num(BErr);

/* [MS-XLSB] 2.4.324 BrtColor */
function parse_BrtColor(data) {
	var out = {};
	var d = data.read_shift(1);

	//var fValidRGB = d & 1;
	var xColorType = d >>> 1;

	var index = data.read_shift(1);
	var nTS = data.read_shift(2, 'i');
	var bR = data.read_shift(1);
	var bG = data.read_shift(1);
	var bB = data.read_shift(1);
	data.l++; //var bAlpha = data.read_shift(1);

	switch(xColorType) {
		case 0: out.auto = 1; break;
		case 1:
			out.index = index;
			var icv = XLSIcv[index];
			/* automatic pseudo index 81 */
			if(icv) out.rgb = rgb2Hex(icv);
			break;
		case 2:
			/* if(!fValidRGB) throw new Error("invalid"); */
			out.rgb = rgb2Hex([bR, bG, bB]);
			break;
		case 3: out.theme = index; break;
	}
	if(nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;

	return out;
}
function write_BrtColor(color, o) {
	if(!o) o = new_buf(8);
	if(!color||color.auto) { o.write_shift(4, 0); o.write_shift(4, 0); return o; }
	if(color.index) {
		o.write_shift(1, 0x02);
		o.write_shift(1, color.index);
	} else if(color.theme) {
		o.write_shift(1, 0x06);
		o.write_shift(1, color.theme);
	} else {
		o.write_shift(1, 0x05);
		o.write_shift(1, 0);
	}
	var nTS = color.tint || 0;
	if(nTS > 0) nTS *= 32767;
	else if(nTS < 0) nTS *= 32768;
	o.write_shift(2, nTS);
	if(!color.rgb) {
		o.write_shift(2, 0);
		o.write_shift(1, 0);
		o.write_shift(1, 0);
	} else {
		var rgb = (color.rgb || 'FFFFFF');
		o.write_shift(1, parseInt(rgb.slice(0,2),16));
		o.write_shift(1, parseInt(rgb.slice(2,4),16));
		o.write_shift(1, parseInt(rgb.slice(4,6),16));
		o.write_shift(1, 0xFF);
	}
	return o;
}

/* [MS-XLSB] 2.5.52 */
function parse_FontFlags(data) {
	var d = data.read_shift(1);
	data.l++;
	var out = {
		/* fBold: d & 0x01 */
		fItalic: d & 0x02,
		/* fUnderline: d & 0x04 */
		fStrikeout: d & 0x08,
		fOutline: d & 0x10,
		fShadow: d & 0x20,
		fCondense: d & 0x40,
		fExtend: d & 0x80
	};
	return out;
}
function write_FontFlags(font, o) {
	if(!o) o = new_buf(2);
	var grbit =
		(font.italic   ? 0x02 : 0) |
		(font.strike   ? 0x08 : 0) |
		(font.outline  ? 0x10 : 0) |
		(font.shadow   ? 0x20 : 0) |
		(font.condense ? 0x40 : 0) |
		(font.extend   ? 0x80 : 0);
	o.write_shift(1, grbit);
	o.write_shift(1, 0);
	return o;
}

/* [MS-OLEDS] 2.3.1 and 2.3.2 */
function parse_ClipboardFormatOrString(o, w) {
	// $FlowIgnore
	var ClipFmt = {2:"BITMAP",3:"METAFILEPICT",8:"DIB",14:"ENHMETAFILE"};
	var m = o.read_shift(4);
	switch(m) {
		case 0x00000000: return "";
		case 0xffffffff: case 0xfffffffe: return ClipFmt[o.read_shift(4)]||"";
	}
	if(m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
	o.l -= 4;
	return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
}
function parse_ClipboardFormatOrAnsiString(o) { return parse_ClipboardFormatOrString(o, 1); }
function parse_ClipboardFormatOrUnicodeString(o) { return parse_ClipboardFormatOrString(o, 2); }

/* [MS-OLEPS] 2.2 PropertyType */
//var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var VT_I2       = 0x0002;
var VT_I4       = 0x0003;
//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var VT_BOOL     = 0x000B;
var VT_VARIANT  = 0x000C;
//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var VT_UI4      = 0x0013;
//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
var VT_LPSTR    = 0x001E;
//var VT_LPWSTR   = 0x001F;
var VT_FILETIME = 0x0040;
var VT_BLOB     = 0x0041;
//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var VT_CF       = 0x0047;
//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
var VT_VECTOR   = 0x1000;
//var VT_ARRAY    = 0x2000;

var VT_STRING   = 0x0050; // 2.3.3.1.11 VtString
var VT_USTR     = 0x0051; // 2.3.3.1.12 VtUnalignedString
var VT_CUSTOM   = [VT_STRING, VT_USTR];

/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */
var DocSummaryPIDDSI = {
0x01: { n: 'CodePage', t: VT_I2 },
0x02: { n: 'Category', t: VT_STRING },
0x03: { n: 'PresentationFormat', t: VT_STRING },
0x04: { n: 'ByteCount', t: VT_I4 },
0x05: { n: 'LineCount', t: VT_I4 },
0x06: { n: 'ParagraphCount', t: VT_I4 },
0x07: { n: 'SlideCount', t: VT_I4 },
0x08: { n: 'NoteCount', t: VT_I4 },
0x09: { n: 'HiddenCount', t: VT_I4 },
0x0a: { n: 'MultimediaClipCount', t: VT_I4 },
0x0b: { n: 'ScaleCrop', t: VT_BOOL },
0x0c: { n: 'HeadingPairs', t: VT_VECTOR | VT_VARIANT },
0x0d: { n: 'TitlesOfParts', t: VT_VECTOR | VT_LPSTR },
0x0e: { n: 'Manager', t: VT_STRING },
0x0f: { n: 'Company', t: VT_STRING },
0x10: { n: 'LinksUpToDate', t: VT_BOOL },
0x11: { n: 'CharacterCount', t: VT_I4 },
0x13: { n: 'SharedDoc', t: VT_BOOL },
0x16: { n: 'HyperlinksChanged', t: VT_BOOL },
0x17: { n: 'AppVersion', t: VT_I4, p: 'version' },
0x18: { n: 'DigSig', t: VT_BLOB },
0x1A: { n: 'ContentType', t: VT_STRING },
0x1B: { n: 'ContentStatus', t: VT_STRING },
0x1C: { n: 'Language', t: VT_STRING },
0x1D: { n: 'Version', t: VT_STRING },
0xFF: {}
};

/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */
var SummaryPIDSI = {
0x01: { n: 'CodePage', t: VT_I2 },
0x02: { n: 'Title', t: VT_STRING },
0x03: { n: 'Subject', t: VT_STRING },
0x04: { n: 'Author', t: VT_STRING },
0x05: { n: 'Keywords', t: VT_STRING },
0x06: { n: 'Comments', t: VT_STRING },
0x07: { n: 'Template', t: VT_STRING },
0x08: { n: 'LastAuthor', t: VT_STRING },
0x09: { n: 'RevNumber', t: VT_STRING },
0x0A: { n: 'EditTime', t: VT_FILETIME },
0x0B: { n: 'LastPrinted', t: VT_FILETIME },
0x0C: { n: 'CreatedDate', t: VT_FILETIME },
0x0D: { n: 'ModifiedDate', t: VT_FILETIME },
0x0E: { n: 'PageCount', t: VT_I4 },
0x0F: { n: 'WordCount', t: VT_I4 },
0x10: { n: 'CharCount', t: VT_I4 },
0x11: { n: 'Thumbnail', t: VT_CF },
0x12: { n: 'Application', t: VT_STRING },
0x13: { n: 'DocSecurity', t: VT_I4 },
0xFF: {}
};

/* [MS-OLEPS] 2.18 */
var SpecialProperties = {
0x80000000: { n: 'Locale', t: VT_UI4 },
0x80000003: { n: 'Behavior', t: VT_UI4 },
0x72627262: {}
};

(function() {
	for(var y in SpecialProperties) if(SpecialProperties.hasOwnProperty(y))
	DocSummaryPIDDSI[y] = SummaryPIDSI[y] = SpecialProperties[y];
})();

var DocSummaryRE = evert_key(DocSummaryPIDDSI, "n");
var SummaryRE = evert_key(SummaryPIDSI, "n");

/* [MS-XLS] 2.4.63 Country/Region codes */
var CountryEnum = {
0x0001: "US", // United States
0x0002: "CA", // Canada
0x0003: "", // Latin America (except Brazil)
0x0007: "RU", // Russia
0x0014: "EG", // Egypt
0x001E: "GR", // Greece
0x001F: "NL", // Netherlands
0x0020: "BE", // Belgium
0x0021: "FR", // France
0x0022: "ES", // Spain
0x0024: "HU", // Hungary
0x0027: "IT", // Italy
0x0029: "CH", // Switzerland
0x002B: "AT", // Austria
0x002C: "GB", // United Kingdom
0x002D: "DK", // Denmark
0x002E: "SE", // Sweden
0x002F: "NO", // Norway
0x0030: "PL", // Poland
0x0031: "DE", // Germany
0x0034: "MX", // Mexico
0x0037: "BR", // Brazil
0x003d: "AU", // Australia
0x0040: "NZ", // New Zealand
0x0042: "TH", // Thailand
0x0051: "JP", // Japan
0x0052: "KR", // Korea
0x0054: "VN", // Viet Nam
0x0056: "CN", // China
0x005A: "TR", // Turkey
0x0069: "JS", // Ramastan
0x00D5: "DZ", // Algeria
0x00D8: "MA", // Morocco
0x00DA: "LY", // Libya
0x015F: "PT", // Portugal
0x0162: "IS", // Iceland
0x0166: "FI", // Finland
0x01A4: "CZ", // Czech Republic
0x0376: "TW", // Taiwan
0x03C1: "LB", // Lebanon
0x03C2: "JO", // Jordan
0x03C3: "SY", // Syria
0x03C4: "IQ", // Iraq
0x03C5: "KW", // Kuwait
0x03C6: "SA", // Saudi Arabia
0x03CB: "AE", // United Arab Emirates
0x03CC: "IL", // Israel
0x03CE: "QA", // Qatar
0x03D5: "IR", // Iran
0xFFFF: "US"  // United States
};

/* [MS-XLS] 2.5.127 */
var XLSFillPattern = [
	null,
	'solid',
	'mediumGray',
	'darkGray',
	'lightGray',
	'darkHorizontal',
	'darkVertical',
	'darkDown',
	'darkUp',
	'darkGrid',
	'darkTrellis',
	'lightHorizontal',
	'lightVertical',
	'lightDown',
	'lightUp',
	'lightGrid',
	'lightTrellis',
	'gray125',
	'gray0625'
];

function rgbify(arr) { return arr.map(function(x) { return [(x>>16)&255,(x>>8)&255,x&255]; }); }

/* [MS-XLS] 2.5.161 */
/* [MS-XLSB] 2.5.75 Icv */
var XLSIcv = rgbify([
	/* Color Constants */
	0x000000,
	0xFFFFFF,
	0xFF0000,
	0x00FF00,
	0x0000FF,
	0xFFFF00,
	0xFF00FF,
	0x00FFFF,

	/* Overridable Defaults */
	0x000000,
	0xFFFFFF,
	0xFF0000,
	0x00FF00,
	0x0000FF,
	0xFFFF00,
	0xFF00FF,
	0x00FFFF,

	0x800000,
	0x008000,
	0x000080,
	0x808000,
	0x800080,
	0x008080,
	0xC0C0C0,
	0x808080,
	0x9999FF,
	0x993366,
	0xFFFFCC,
	0xCCFFFF,
	0x660066,
	0xFF8080,
	0x0066CC,
	0xCCCCFF,

	0x000080,
	0xFF00FF,
	0xFFFF00,
	0x00FFFF,
	0x800080,
	0x800000,
	0x008080,
	0x0000FF,
	0x00CCFF,
	0xCCFFFF,
	0xCCFFCC,
	0xFFFF99,
	0x99CCFF,
	0xFF99CC,
	0xCC99FF,
	0xFFCC99,

	0x3366FF,
	0x33CCCC,
	0x99CC00,
	0xFFCC00,
	0xFF9900,
	0xFF6600,
	0x666699,
	0x969696,
	0x003366,
	0x339966,
	0x003300,
	0x333300,
	0x993300,
	0x993366,
	0x333399,
	0x333333,

	/* Other entries to appease BIFF8/12 */
	0xFFFFFF, /* 0x40 icvForeground ?? */
	0x000000, /* 0x41 icvBackground ?? */
	0x000000, /* 0x42 icvFrame ?? */
	0x000000, /* 0x43 icv3D ?? */
	0x000000, /* 0x44 icv3DText ?? */
	0x000000, /* 0x45 icv3DHilite ?? */
	0x000000, /* 0x46 icv3DShadow ?? */
	0x000000, /* 0x47 icvHilite ?? */
	0x000000, /* 0x48 icvCtlText ?? */
	0x000000, /* 0x49 icvCtlScrl ?? */
	0x000000, /* 0x4A icvCtlInv ?? */
	0x000000, /* 0x4B icvCtlBody ?? */
	0x000000, /* 0x4C icvCtlFrame ?? */
	0x000000, /* 0x4D icvCtlFore ?? */
	0x000000, /* 0x4E icvCtlBack ?? */
	0x000000, /* 0x4F icvCtlNeutral */
	0x000000, /* 0x50 icvInfoBk ?? */
	0x000000 /* 0x51 icvInfoText ?? */
]);

/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */
/* 12.3 Part Summary <SpreadsheetML> */
/* 14.2 Part Summary <DrawingML> */
/* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */
var ct2type/*{[string]:string}*/ = ({
	/* Workbook */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",

	/* Worksheet */
	"application/vnd.ms-excel.binIndexWs": "TODO", /* Binary Index */

	/* Macrosheet */
	"application/vnd.ms-excel.intlmacrosheet": "TODO",
	"application/vnd.ms-excel.binIndexMs": "TODO", /* Binary Index */

	/* File Properties */
	"application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
	"application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
	"application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",

	/* Custom Data Properties */
	"application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",

	/* PivotTable */
	"application/vnd.ms-excel.pivotTable": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",

	/* Chart Colors */
	"application/vnd.ms-office.chartcolorstyle+xml": "TODO",

	/* Chart Style */
	"application/vnd.ms-office.chartstyle+xml": "TODO",

	/* Calculation Chain */
	"application/vnd.ms-excel.calcChain": "calcchains",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",

	/* Printer Settings */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",

	/* ActiveX */
	"application/vnd.ms-office.activeX": "TODO",
	"application/vnd.ms-office.activeX+xml": "TODO",

	/* Custom Toolbars */
	"application/vnd.ms-excel.attachedToolbars": "TODO",

	/* External Data Connections */
	"application/vnd.ms-excel.connections": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",

	/* External Links */
	"application/vnd.ms-excel.externalLink": "links",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",

	/* Metadata */
	"application/vnd.ms-excel.sheetMetadata": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "TODO",

	/* PivotCache */
	"application/vnd.ms-excel.pivotCacheDefinition": "TODO",
	"application/vnd.ms-excel.pivotCacheRecords": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",

	/* Query Table */
	"application/vnd.ms-excel.queryTable": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",

	/* Shared Workbook */
	"application/vnd.ms-excel.userNames": "TODO",
	"application/vnd.ms-excel.revisionHeaders": "TODO",
	"application/vnd.ms-excel.revisionLog": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",

	/* Single Cell Table */
	"application/vnd.ms-excel.tableSingleCells": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",

	/* Slicer */
	"application/vnd.ms-excel.slicer": "TODO",
	"application/vnd.ms-excel.slicerCache": "TODO",
	"application/vnd.ms-excel.slicer+xml": "TODO",
	"application/vnd.ms-excel.slicerCache+xml": "TODO",

	/* Sort Map */
	"application/vnd.ms-excel.wsSortMap": "TODO",

	/* Table */
	"application/vnd.ms-excel.table": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",

	/* Themes */
	"application/vnd.openxmlformats-officedocument.theme+xml": "themes",

	/* Theme Override */
	"application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",

	/* Timeline */
	"application/vnd.ms-excel.Timeline+xml": "TODO", /* verify */
	"application/vnd.ms-excel.TimelineCache+xml": "TODO", /* verify */

	/* VBA */
	"application/vnd.ms-office.vbaProject": "vba",
	"application/vnd.ms-office.vbaProjectSignature": "vba",

	/* Volatile Dependencies */
	"application/vnd.ms-office.volatileDependencies": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",

	/* Control Properties */
	"application/vnd.ms-excel.controlproperties+xml": "TODO",

	/* Data Model */
	"application/vnd.openxmlformats-officedocument.model+data": "TODO",

	/* Survey */
	"application/vnd.ms-excel.Survey+xml": "TODO",

	/* Drawing */
	"application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
	"application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",

	/* VML */
	"application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",

	"application/vnd.openxmlformats-package.relationships+xml": "rels",
	"application/vnd.openxmlformats-officedocument.oleObject": "TODO",

	/* Image */
	"image/png": "TODO",

	"sheet": "js"
});

var CT_LIST = (function(){
	var o = {
		workbooks: {
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
			xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
			xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
			xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
			xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
		},
		strs: { /* Shared Strings */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
			xlsb: "application/vnd.ms-excel.sharedStrings"
		},
		comments: { /* Comments */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
			xlsb: "application/vnd.ms-excel.comments"
		},
		sheets: { /* Worksheet */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
			xlsb: "application/vnd.ms-excel.worksheet"
		},
		charts: { /* Chartsheet */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
			xlsb: "application/vnd.ms-excel.chartsheet"
		},
		dialogs: { /* Dialogsheet */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
			xlsb: "application/vnd.ms-excel.dialogsheet"
		},
		macros: { /* Macrosheet (Excel 4.0 Macros) */
			xlsx: "application/vnd.ms-excel.macrosheet+xml",
			xlsb: "application/vnd.ms-excel.macrosheet"
		},
		styles: { /* Styles */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
			xlsb: "application/vnd.ms-excel.styles"
		}
	};
	keys(o).forEach(function(k) { ["xlsm", "xlam"].forEach(function(v) { if(!o[k][v]) o[k][v] = o[k].xlsx; }); });
	keys(o).forEach(function(k){ keys(o[k]).forEach(function(v) { ct2type[o[k][v]] = k; }); });
	return o;
})();

var type2ct/*{[string]:Array<string>}*/ = evert_arr(ct2type);

XMLNS.CT = 'http://schemas.openxmlformats.org/package/2006/content-types';

function new_ct() {
	return ({
		workbooks:[], sheets:[], charts:[], dialogs:[], macros:[],
		rels:[], strs:[], comments:[], links:[],
		coreprops:[], extprops:[], custprops:[], themes:[], styles:[],
		calcchains:[], vba: [], drawings: [],
		TODO:[], xmlns: "" });
}

function parse_ct(data) {
	var ct = new_ct();
	if(!data || !data.match) return ct;
	var ctext = {};
	(data.match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(y[0].replace(nsregex,"<")) {
			case '<?xml': break;
			case '<Types': ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/)||["",""])[1] ]; break;
			case '<Default': ctext[y.Extension] = y.ContentType; break;
			case '<Override':
				if(ct[ct2type[y.ContentType]] !== undefined) ct[ct2type[y.ContentType]].push(y.PartName);
				break;
		}
	});
	if(ct.xmlns !== XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
	ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
	ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
	ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
	ct.defaults = ctext;
	delete ct.calcchains;
	return ct;
}

var CTYPE_XML_ROOT = writextag('Types', null, {
	'xmlns': XMLNS.CT,
	'xmlns:xsd': XMLNS.xsd,
	'xmlns:xsi': XMLNS.xsi
});

var CTYPE_DEFAULTS = [
	['xml', 'application/xml'],
	['bin', 'application/vnd.ms-excel.sheet.binary.macroEnabled.main'],
	['vml', 'application/vnd.openxmlformats-officedocument.vmlDrawing'],
	/* from test files */
	['bmp', 'image/bmp'],
	['png', 'image/png'],
	['gif', 'image/gif'],
	['emf', 'image/x-emf'],
	['wmf', 'image/x-wmf'],
	['jpg', 'image/jpeg'], ['jpeg', 'image/jpeg'],
	['tif', 'image/tiff'], ['tiff', 'image/tiff'],
	['pdf', 'application/pdf'],
	['rels', type2ct.rels[0]]
].map(function(x) {
	return writextag('Default', null, {'Extension':x[0], 'ContentType': x[1]});
});

function write_ct(ct, opts) {
	var o = [], v;
	o[o.length] = (XML_HEADER);
	o[o.length] = (CTYPE_XML_ROOT);
	o = o.concat(CTYPE_DEFAULTS);
	var f1 = function(w) {
		if(ct[w] && ct[w].length > 0) {
			v = ct[w][0];
			o[o.length] = (writextag('Override', null, {
				'PartName': (v[0] == '/' ? "":"/") + v,
				'ContentType': CT_LIST[w][opts.bookType || 'xlsx']
			}));
		}
	};
	var f2 = function(w) {
		(ct[w]||[]).forEach(function(v) {
			o[o.length] = (writextag('Override', null, {
				'PartName': (v[0] == '/' ? "":"/") + v,
				'ContentType': CT_LIST[w][opts.bookType || 'xlsx']
			}));
		});
	};
	var f3 = function(t) {
		(ct[t]||[]).forEach(function(v) {
			o[o.length] = (writextag('Override', null, {
				'PartName': (v[0] == '/' ? "":"/") + v,
				'ContentType': type2ct[t][0]
			}));
		});
	};
	f1('workbooks');
	f2('sheets');
	f2('charts');
	f3('themes');
	['strs', 'styles'].forEach(f1);
	['coreprops', 'extprops', 'custprops'].forEach(f3);
	f3('vba');
	f3('comments');
	f3('drawings');
	if(o.length>2){ o[o.length] = ('</Types>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* 9.3 Relationships */
var RELS = ({
	WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
	SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
	HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
	VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
	VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
});

/* 9.3.3 Representing Relationships */
function get_rels_path(file) {
	var n = file.lastIndexOf("/");
	return file.slice(0,n+1) + '_rels/' + file.slice(n+1) + ".rels";
}

function parse_rels(data, currentFilePath) {
	if (!data) return data;
	if (currentFilePath.charAt(0) !== '/') {
		currentFilePath = '/'+currentFilePath;
	}
	var rels = {};
	var hash = {};

	(data.match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		/* 9.3.2.2 OPC_Relationships */
		if (y[0] === '<Relationship') {
			var rel = {}; rel.Type = y.Type; rel.Target = y.Target; rel.Id = y.Id; rel.TargetMode = y.TargetMode;
			var canonictarget = y.TargetMode === 'External' ? y.Target : resolve_path(y.Target, currentFilePath);
			rels[canonictarget] = rel;
			hash[y.Id] = rel;
		}
	});
	rels["!id"] = hash;
	return rels;
}

XMLNS.RELS = 'http://schemas.openxmlformats.org/package/2006/relationships';

var RELS_ROOT = writextag('Relationships', null, {
	//'xmlns:ns0': XMLNS.RELS,
	'xmlns': XMLNS.RELS
});

/* TODO */
function write_rels(rels) {
	var o = [XML_HEADER, RELS_ROOT];
	keys(rels['!id']).forEach(function(rid) {
		o[o.length] = (writextag('Relationship', null, rels['!id'][rid]));
	});
	if(o.length>2){ o[o.length] = ('</Relationships>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}

function add_rels(rels, rId, f, type, relobj) {
	if(!relobj) relobj = {};
	if(!rels['!id']) rels['!id'] = {};
	if(rId < 0) for(rId = 1; rels['!id']['rId' + rId]; ++rId){/* empty */}
	relobj.Id = 'rId' + rId;
	relobj.Type = type;
	relobj.Target = f;
	if(relobj.Type == RELS.HLINK) relobj.TargetMode = "External";
	if(rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
	rels['!id'][relobj.Id] = relobj;
	rels[('/' + relobj.Target).replace("//","/")] = relobj;
	return rId;
}
/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */
/* Part 3 Section 4 Manifest File */
var CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function parse_manifest(d, opts) {
	var str = xlml_normalize(d);
	var Rn;
	var FEtag;
	while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
		case 'manifest': break; // 4.2 <manifest:manifest>
		case 'file-entry': // 4.3 <manifest:file-entry>
			FEtag = parsexmltag(Rn[0], false);
			if(FEtag.path == '/' && FEtag.type !== CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
			break;
		case 'encryption-data': // 4.4 <manifest:encryption-data>
		case 'algorithm': // 4.5 <manifest:algorithm>
		case 'start-key-generation': // 4.6 <manifest:start-key-generation>
		case 'key-derivation': // 4.7 <manifest:key-derivation>
			throw new Error("Unsupported ODS Encryption");
		default: if(opts && opts.WTF) throw Rn;
	}
}

function write_manifest(manifest) {
	var o = [XML_HEADER];
	o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
	o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
	for(var i = 0; i < manifest.length; ++i) o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
	o.push('</manifest:manifest>');
	return o.join("");
}

/* Part 3 Section 6 Metadata Manifest File */
function write_rdf_type(file, res, tag) {
	return [
		'  <rdf:Description rdf:about="' + file + '">\n',
		'    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + '#' + res + '"/>\n',
		'  </rdf:Description>\n'
	].join("");
}
function write_rdf_has(base, file) {
	return [
		'  <rdf:Description rdf:about="' + base + '">\n',
		'    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
		'  </rdf:Description>\n'
	].join("");
}
function write_rdf(rdf) {
	var o = [XML_HEADER];
	o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
	for(var i = 0; i != rdf.length; ++i) {
		o.push(write_rdf_type(rdf[i][0], rdf[i][1]));
		o.push(write_rdf_has("",rdf[i][0]));
	}
	o.push(write_rdf_type("","Document", "pkg"));
	o.push('</rdf:RDF>');
	return o.join("");
}
/* TODO: pull properties */
var write_meta_ods = (function() {
	var payload = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet' + 'JS ' + XLSX.version + '</meta:generator></office:meta></office:document-meta>';
	return function wmo() {
		return payload;
	};
})();

/* ECMA-376 Part II 11.1 Core Properties Part */
/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
var CORE_PROPS = [
	["cp:category", "Category"],
	["cp:contentStatus", "ContentStatus"],
	["cp:keywords", "Keywords"],
	["cp:lastModifiedBy", "LastAuthor"],
	["cp:lastPrinted", "LastPrinted"],
	["cp:revision", "RevNumber"],
	["cp:version", "Version"],
	["dc:creator", "Author"],
	["dc:description", "Comments"],
	["dc:identifier", "Identifier"],
	["dc:language", "Language"],
	["dc:subject", "Subject"],
	["dc:title", "Title"],
	["dcterms:created", "CreatedDate", 'date'],
	["dcterms:modified", "ModifiedDate", 'date']
];

XMLNS.CORE_PROPS = "http://schemas.openxmlformats.org/package/2006/metadata/core-properties";
RELS.CORE_PROPS  = 'http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties';

var CORE_PROPS_REGEX = (function() {
	var r = new Array(CORE_PROPS.length);
	for(var i = 0; i < CORE_PROPS.length; ++i) {
		var f = CORE_PROPS[i];
		var g = "(?:"+ f[0].slice(0,f[0].indexOf(":")) +":)"+ f[0].slice(f[0].indexOf(":")+1);
		r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)<\/" + g + ">");
	}
	return r;
})();

function parse_core_props(data) {
	var p = {};
	data = utf8read(data);

	for(var i = 0; i < CORE_PROPS.length; ++i) {
		var f = CORE_PROPS[i], cur = data.match(CORE_PROPS_REGEX[i]);
		if(cur != null && cur.length > 0) p[f[1]] = cur[1];
		if(f[2] === 'date' && p[f[1]]) p[f[1]] = parseDate(p[f[1]]);
	}

	return p;
}

var CORE_PROPS_XML_ROOT = writextag('cp:coreProperties', null, {
	//'xmlns': XMLNS.CORE_PROPS,
	'xmlns:cp': XMLNS.CORE_PROPS,
	'xmlns:dc': XMLNS.dc,
	'xmlns:dcterms': XMLNS.dcterms,
	'xmlns:dcmitype': XMLNS.dcmitype,
	'xmlns:xsi': XMLNS.xsi
});

function cp_doit(f, g, h, o, p) {
	if(p[f] != null || g == null || g === "") return;
	p[f] = g;
	o[o.length] = (h ? writextag(f,g,h) : writetag(f,g));
}

function write_core_props(cp, _opts) {
	var opts = _opts || {};
	var o = [XML_HEADER, CORE_PROPS_XML_ROOT], p = {};
	if(!cp && !opts.Props) return o.join("");

	if(cp) {
		if(cp.CreatedDate != null) cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : write_w3cdtf(cp.CreatedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
		if(cp.ModifiedDate != null) cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : write_w3cdtf(cp.ModifiedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
	}

	for(var i = 0; i != CORE_PROPS.length; ++i) {
		var f = CORE_PROPS[i];
		var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
		if(v === true) v = "1";
		else if(v === false) v = "0";
		else if(typeof v == "number") v = String(v);
		if(v != null) cp_doit(f[0], v, null, o, p);
	}
	if(o.length>2){ o[o.length] = ('</cp:coreProperties>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* 15.2.12.3 Extended File Properties Part */
/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
var EXT_PROPS = [
	["Application", "Application", "string"],
	["AppVersion", "AppVersion", "string"],
	["Company", "Company", "string"],
	["DocSecurity", "DocSecurity", "string"],
	["Manager", "Manager", "string"],
	["HyperlinksChanged", "HyperlinksChanged", "bool"],
	["SharedDoc", "SharedDoc", "bool"],
	["LinksUpToDate", "LinksUpToDate", "bool"],
	["ScaleCrop", "ScaleCrop", "bool"],
	["HeadingPairs", "HeadingPairs", "raw"],
	["TitlesOfParts", "TitlesOfParts", "raw"]
];

XMLNS.EXT_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties";
RELS.EXT_PROPS  = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties';

var PseudoPropsPairs = [
	"Worksheets",  "SheetNames",
	"NamedRanges", "DefinedNames",
	"Chartsheets", "ChartNames"
];
function load_props_pairs(HP, TOP, props, opts) {
	var v = [];
	if(typeof HP == "string") v = parseVector(HP, opts);
	else for(var j = 0; j < HP.length; ++j) v = v.concat(HP[j].map(function(hp) { return {v:hp}; }));
	var parts = (typeof TOP == "string") ? parseVector(TOP, opts).map(function (x) { return x.v; }) : TOP;
	var idx = 0, len = 0;
	if(parts.length > 0) for(var i = 0; i !== v.length; i += 2) {
		len = +(v[i+1].v);
		switch(v[i].v) {
			case "Worksheets":
			case "工作表":
			case "Листы":
			case "أوراق العمل":
			case "ワークシート":
			case "גליונות עבודה":
			case "Arbeitsblätter":
			case "Çalışma Sayfaları":
			case "Feuilles de calcul":
			case "Fogli di lavoro":
			case "Folhas de cálculo":
			case "Planilhas":
			case "Regneark":
			case "Werkbladen":
				props.Worksheets = len;
				props.SheetNames = parts.slice(idx, idx + len);
				break;

			case "Named Ranges":
			case "名前付き一覧":
			case "Benannte Bereiche":
			case "Navngivne områder":
				props.NamedRanges = len;
				props.DefinedNames = parts.slice(idx, idx + len);
				break;

			case "Charts":
			case "Diagramme":
				props.Chartsheets = len;
				props.ChartNames = parts.slice(idx, idx + len);
				break;
		}
		idx += len;
	}
}

function parse_ext_props(data, p, opts) {
	var q = {}; if(!p) p = {};
	data = utf8read(data);

	EXT_PROPS.forEach(function(f) {
		switch(f[2]) {
			case "string": p[f[1]] = (data.match(matchtag(f[0]))||[])[1]; break;
			case "bool": p[f[1]] = (data.match(matchtag(f[0]))||[])[1] === "true"; break;
			case "raw":
				var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)<\/" + f[0] + ">"));
				if(cur && cur.length > 0) q[f[1]] = cur[1];
				break;
		}
	});

	if(q.HeadingPairs && q.TitlesOfParts) load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);

	return p;
}

var EXT_PROPS_XML_ROOT = writextag('Properties', null, {
	'xmlns': XMLNS.EXT_PROPS,
	'xmlns:vt': XMLNS.vt
});

function write_ext_props(cp) {
	var o = [], W = writextag;
	if(!cp) cp = {};
	cp.Application = "SheetJS";
	o[o.length] = (XML_HEADER);
	o[o.length] = (EXT_PROPS_XML_ROOT);

	EXT_PROPS.forEach(function(f) {
		if(cp[f[1]] === undefined) return;
		var v;
		switch(f[2]) {
			case 'string': v = String(cp[f[1]]); break;
			case 'bool': v = cp[f[1]] ? 'true' : 'false'; break;
		}
		if(v !== undefined) o[o.length] = (W(f[0], v));
	});

	/* TODO: HeadingPairs, TitlesOfParts */
	o[o.length] = (W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>')+W('vt:variant', W('vt:i4', String(cp.Worksheets))), {size:2, baseType:"variant"})));
	o[o.length] = (W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) { return "<vt:lpstr>" + escapexml(s) + "</vt:lpstr>"; }).join(""), {size: cp.Worksheets, baseType:"lpstr"})));
	if(o.length>2){ o[o.length] = ('</Properties>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* 15.2.12.2 Custom File Properties Part */
XMLNS.CUST_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties";
RELS.CUST_PROPS  = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties';

var custregex = /<[^>]+>[^<]*/g;
function parse_cust_props(data, opts) {
	var p = {}, name = "";
	var m = data.match(custregex);
	if(m) for(var i = 0; i != m.length; ++i) {
		var x = m[i], y = parsexmltag(x);
		switch(y[0]) {
			case '<?xml': break;
			case '<Properties': break;
			case '<property': name = y.name; break;
			case '</property>': name = null; break;
			default: if (x.indexOf('<vt:') === 0) {
				var toks = x.split('>');
				var type = toks[0].slice(4), text = toks[1];
				/* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */
				switch(type) {
					case 'lpstr': case 'bstr': case 'lpwstr':
						p[name] = unescapexml(text);
						break;
					case 'bool':
						p[name] = parsexmlbool(text);
						break;
					case 'i1': case 'i2': case 'i4': case 'i8': case 'int': case 'uint':
						p[name] = parseInt(text, 10);
						break;
					case 'r4': case 'r8': case 'decimal':
						p[name] = parseFloat(text);
						break;
					case 'filetime': case 'date':
						p[name] = parseDate(text);
						break;
					case 'cy': case 'error':
						p[name] = unescapexml(text);
						break;
					default:
						if(type.slice(-1) == '/') break;
						if(opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
				}
			} else if(x.slice(0,2) === "</") {/* empty */
			} else if(opts.WTF) throw new Error(x);
		}
	}
	return p;
}

var CUST_PROPS_XML_ROOT = writextag('Properties', null, {
	'xmlns': XMLNS.CUST_PROPS,
	'xmlns:vt': XMLNS.vt
});

function write_cust_props(cp) {
	var o = [XML_HEADER, CUST_PROPS_XML_ROOT];
	if(!cp) return o.join("");
	var pid = 1;
	keys(cp).forEach(function custprop(k) { ++pid;
		o[o.length] = (writextag('property', write_vt(cp[k]), {
			'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
			'pid': pid,
			'name': k
		}));
	});
	if(o.length>2){ o[o.length] = '</Properties>'; o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* Common Name -> XLML Name */
var XLMLDocPropsMap = {
	Title: 'Title',
	Subject: 'Subject',
	Author: 'Author',
	Keywords: 'Keywords',
	Comments: 'Description',
	LastAuthor: 'LastAuthor',
	RevNumber: 'Revision',
	Application: 'AppName',
	/* TotalTime: 'TotalTime', */
	LastPrinted: 'LastPrinted',
	CreatedDate: 'Created',
	ModifiedDate: 'LastSaved',
	/* Pages */
	/* Words */
	/* Characters */
	Category: 'Category',
	/* PresentationFormat */
	Manager: 'Manager',
	Company: 'Company',
	/* Guid */
	/* HyperlinkBase */
	/* Bytes */
	/* Lines */
	/* Paragraphs */
	/* CharactersWithSpaces */
	AppVersion: 'Version',

	ContentStatus: 'ContentStatus', /* NOTE: missing from schema */
	Identifier: 'Identifier', /* NOTE: missing from schema */
	Language: 'Language' /* NOTE: missing from schema */
};
var evert_XLMLDPM = evert(XLMLDocPropsMap);

function xlml_set_prop(Props, tag, val) {
	tag = evert_XLMLDPM[tag] || tag;
	Props[tag] = val;
}

function xlml_write_docprops(Props, opts) {
	var o = [];
	keys(XLMLDocPropsMap).map(function(m) {
		for(var i = 0; i < CORE_PROPS.length; ++i) if(CORE_PROPS[i][1] == m) return CORE_PROPS[i];
		for(i = 0; i < EXT_PROPS.length; ++i) if(EXT_PROPS[i][1] == m) return EXT_PROPS[i];
		throw m;
	}).forEach(function(p) {
		if(Props[p[1]] == null) return;
		var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
		switch(p[2]) {
			case 'date': m = new Date(m).toISOString().replace(/\.\d*Z/,"Z"); break;
		}
		if(typeof m == 'number') m = String(m);
		else if(m === true || m === false) { m = m ? "1" : "0"; }
		else if(m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/,"");
		o.push(writetag(XLMLDocPropsMap[p[1]] || p[1], m));
	});
	return writextag('DocumentProperties', o.join(""), {xmlns:XLMLNS.o });
}
function xlml_write_custprops(Props, Custprops) {
	var BLACKLIST = ["Worksheets","SheetNames"];
	var T = 'CustomDocumentProperties';
	var o = [];
	if(Props) keys(Props).forEach(function(k) {
if(!Props.hasOwnProperty(k)) return;
		for(var i = 0; i < CORE_PROPS.length; ++i) if(k == CORE_PROPS[i][1]) return;
		for(i = 0; i < EXT_PROPS.length; ++i) if(k == EXT_PROPS[i][1]) return;
		for(i = 0; i < BLACKLIST.length; ++i) if(k == BLACKLIST[i]) return;

		var m = Props[k];
		var t = "string";
		if(typeof m == 'number') { t = "float"; m = String(m); }
		else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
		else m = String(m);
		o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
	});
	if(Custprops) keys(Custprops).forEach(function(k) {
if(!Custprops.hasOwnProperty(k)) return;
		if(Props && Props.hasOwnProperty(k)) return;
		var m = Custprops[k];
		var t = "string";
		if(typeof m == 'number') { t = "float"; m = String(m); }
		else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
		else if(m instanceof Date) { t = "dateTime.tz"; m = m.toISOString(); }
		else m = String(m);
		o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
	});
	return '<' + T + ' xmlns="' + XLMLNS.o + '">' + o.join("") + '</' + T + '>';
}
/* [MS-DTYP] 2.3.3 FILETIME */
/* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */
/* [MS-OLEPS] 2.8 FILETIME (Packet Version) */
function parse_FILETIME(blob) {
	var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
	return new Date(((dwHighDateTime/1e7*Math.pow(2,32) + dwLowDateTime/1e7) - 11644473600)*1000).toISOString().replace(/\.000/,"");
}
function write_FILETIME(time) {
	var date = (typeof time == "string") ? new Date(Date.parse(time)) : time;
	var t = date.getTime() / 1000 + 11644473600;
	var l = t % Math.pow(2,32), h = (t - l) / Math.pow(2,32);
	l *= 1e7; h *= 1e7;
	var w = (l / Math.pow(2,32)) | 0;
	if(w > 0) { l = l % Math.pow(2,32); h += w; }
	var o = new_buf(8); o.write_shift(4, l); o.write_shift(4, h); return o;
}

/* [MS-OSHARED] 2.3.3.1.4 Lpstr */
function parse_lpstr(blob, type, pad) {
	var start = blob.l;
	var str = blob.read_shift(0, 'lpstr-cp');
	if(pad) while((blob.l - start) & 3) ++blob.l;
	return str;
}

/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */
function parse_lpwstr(blob, type, pad) {
	var str = blob.read_shift(0, 'lpwstr');
	if(pad) blob.l += (4 - ((str.length+1) & 3)) & 3;
	return str;
}


/* [MS-OSHARED] 2.3.3.1.11 VtString */
/* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */
function parse_VtStringBase(blob, stringType, pad) {
	if(stringType === 0x1F /*VT_LPWSTR*/) return parse_lpwstr(blob);
	return parse_lpstr(blob, stringType, pad);
}

function parse_VtString(blob, t, pad) { return parse_VtStringBase(blob, t, pad === false ? 0: 4); }
function parse_VtUnalignedString(blob, t) { if(!t) throw new Error("VtUnalignedString must have positive length"); return parse_VtStringBase(blob, t, 0); }

/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */
function parse_VtVecUnalignedLpstrValue(blob) {
	var length = blob.read_shift(4);
	var ret = [];
	for(var i = 0; i != length; ++i) ret[i] = blob.read_shift(0, 'lpstr-cp').replace(chr0,'');
	return ret;
}

/* [MS-OSHARED] 2.3.3.1.10 VtVecUnalignedLpstr */
function parse_VtVecUnalignedLpstr(blob) {
	return parse_VtVecUnalignedLpstrValue(blob);
}

/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */
function parse_VtHeadingPair(blob) {
	var headingString = parse_TypedPropertyValue(blob, VT_USTR);
	var headerParts = parse_TypedPropertyValue(blob, VT_I4);
	return [headingString, headerParts];
}

/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */
function parse_VtVecHeadingPairValue(blob) {
	var cElements = blob.read_shift(4);
	var out = [];
	for(var i = 0; i != cElements / 2; ++i) out.push(parse_VtHeadingPair(blob));
	return out;
}

/* [MS-OSHARED] 2.3.3.1.15 VtVecHeadingPair */
function parse_VtVecHeadingPair(blob) {
	// NOTE: When invoked, wType & padding were already consumed
	return parse_VtVecHeadingPairValue(blob);
}

/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */
function parse_dictionary(blob,CodePage) {
	var cnt = blob.read_shift(4);
	var dict = ({});
	for(var j = 0; j != cnt; ++j) {
		var pid = blob.read_shift(4);
		var len = blob.read_shift(4);
		dict[pid] = blob.read_shift(len, (CodePage === 0x4B0 ?'utf16le':'utf8')).replace(chr0,'').replace(chr1,'!');
		if(CodePage === 0x4B0 && (len % 2)) blob.l += 2;
	}
	if(blob.l & 3) blob.l = (blob.l>>2+1)<<2;
	return dict;
}

/* [MS-OLEPS] 2.9 BLOB */
function parse_BLOB(blob) {
	var size = blob.read_shift(4);
	var bytes = blob.slice(blob.l,blob.l+size);
	blob.l += size;
	if((size & 3) > 0) blob.l += (4 - (size & 3)) & 3;
	return bytes;
}

/* [MS-OLEPS] 2.11 ClipboardData */
function parse_ClipboardData(blob) {
	// TODO
	var o = {};
	o.Size = blob.read_shift(4);
	//o.Format = blob.read_shift(4);
	blob.l += o.Size + 3 - (o.Size - 1) % 4;
	return o;
}

/* [MS-OLEPS] 2.15 TypedPropertyValue */
function parse_TypedPropertyValue(blob, type, _opts) {
	var t = blob.read_shift(2), ret, opts = _opts||{};
	blob.l += 2;
	if(type !== VT_VARIANT)
	if(t !== type && VT_CUSTOM.indexOf(type)===-1) throw new Error('Expected type ' + type + ' saw ' + t);
	switch(type === VT_VARIANT ? t : type) {
		case 0x02 /*VT_I2*/: ret = blob.read_shift(2, 'i'); if(!opts.raw) blob.l += 2; return ret;
		case 0x03 /*VT_I4*/: ret = blob.read_shift(4, 'i'); return ret;
		case 0x0B /*VT_BOOL*/: return blob.read_shift(4) !== 0x0;
		case 0x13 /*VT_UI4*/: ret = blob.read_shift(4); return ret;
		case 0x1E /*VT_LPSTR*/: return parse_lpstr(blob, t, 4).replace(chr0,'');
		case 0x1F /*VT_LPWSTR*/: return parse_lpwstr(blob);
		case 0x40 /*VT_FILETIME*/: return parse_FILETIME(blob);
		case 0x41 /*VT_BLOB*/: return parse_BLOB(blob);
		case 0x47 /*VT_CF*/: return parse_ClipboardData(blob);
		case 0x50 /*VT_STRING*/: return parse_VtString(blob, t, !opts.raw).replace(chr0,'');
		case 0x51 /*VT_USTR*/: return parse_VtUnalignedString(blob, t/*, 4*/).replace(chr0,'');
		case 0x100C /*VT_VECTOR|VT_VARIANT*/: return parse_VtVecHeadingPair(blob);
		case 0x101E /*VT_LPSTR*/: return parse_VtVecUnalignedLpstr(blob);
		default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
	}
}
function write_TypedPropertyValue(type, value) {
	var o = new_buf(4), p = new_buf(4);
	o.write_shift(4, type == 0x50 ? 0x1F : type);
	switch(type) {
		case 0x03 /*VT_I4*/: p.write_shift(-4, value); break;
		case 0x05 /*VT_I4*/: p = new_buf(8); p.write_shift(8, value, 'f'); break;
		case 0x0B /*VT_BOOL*/: p.write_shift(4, value ? 0x01 : 0x00); break;
		case 0x40 /*VT_FILETIME*/:  p = write_FILETIME(value); break;
		case 0x1F /*VT_LPWSTR*/:
		case 0x50 /*VT_STRING*/:
p = new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
			p.write_shift(4, value.length + 1);
			p.write_shift(0, value, "dbcs");
			while(p.l != p.length) p.write_shift(1, 0);
			break;
		default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
	}
	return bconcat([o, p]);
}

/* [MS-OLEPS] 2.20 PropertySet */
function parse_PropertySet(blob, PIDSI) {
	var start_addr = blob.l;
	var size = blob.read_shift(4);
	var NumProps = blob.read_shift(4);
	var Props = [], i = 0;
	var CodePage = 0;
	var Dictionary = -1, DictObj = ({});
	for(i = 0; i != NumProps; ++i) {
		var PropID = blob.read_shift(4);
		var Offset = blob.read_shift(4);
		Props[i] = [PropID, Offset + start_addr];
	}
	Props.sort(function(x,y) { return x[1] - y[1]; });
	var PropH = {};
	for(i = 0; i != NumProps; ++i) {
		if(blob.l !== Props[i][1]) {
			var fail = true;
			if(i>0 && PIDSI) switch(PIDSI[Props[i-1][0]].t) {
				case 0x02 /*VT_I2*/: if(blob.l+2 === Props[i][1]) { blob.l+=2; fail = false; } break;
				case 0x50 /*VT_STRING*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
				case 0x100C /*VT_VECTOR|VT_VARIANT*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
			}
			if((!PIDSI||i==0) && blob.l <= Props[i][1]) { fail=false; blob.l = Props[i][1]; }
			if(fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
		}
		if(PIDSI) {
			var piddsi = PIDSI[Props[i][0]];
			PropH[piddsi.n] = parse_TypedPropertyValue(blob, piddsi.t, {raw:true});
			if(piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
			if(piddsi.n == "CodePage") switch(PropH[piddsi.n]) {
				case 0: PropH[piddsi.n] = 1252;
					/* falls through */
				case 874:
				case 932:
				case 936:
				case 949:
				case 950:
				case 1250:
				case 1251:
				case 1253:
				case 1254:
				case 1255:
				case 1256:
				case 1257:
				case 1258:
				case 10000:
				case 1200:
				case 1201:
				case 1252:
				case 65000: case -536:
				case 65001: case -535:
					set_cp(CodePage = (PropH[piddsi.n]>>>0) & 0xFFFF); break;
				default: throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
			}
		} else {
			if(Props[i][0] === 0x1) {
				CodePage = PropH.CodePage = (parse_TypedPropertyValue(blob, VT_I2));
				set_cp(CodePage);
				if(Dictionary !== -1) {
					var oldpos = blob.l;
					blob.l = Props[Dictionary][1];
					DictObj = parse_dictionary(blob,CodePage);
					blob.l = oldpos;
				}
			} else if(Props[i][0] === 0) {
				if(CodePage === 0) { Dictionary = i; blob.l = Props[i+1][1]; continue; }
				DictObj = parse_dictionary(blob,CodePage);
			} else {
				var name = DictObj[Props[i][0]];
				var val;
				/* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */
				switch(blob[blob.l]) {
					case 0x41 /*VT_BLOB*/: blob.l += 4; val = parse_BLOB(blob); break;
					case 0x1E /*VT_LPSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
					case 0x1F /*VT_LPWSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
					case 0x03 /*VT_I4*/: blob.l += 4; val = blob.read_shift(4, 'i'); break;
					case 0x13 /*VT_UI4*/: blob.l += 4; val = blob.read_shift(4); break;
					case 0x05 /*VT_R8*/: blob.l += 4; val = blob.read_shift(8, 'f'); break;
					case 0x0B /*VT_BOOL*/: blob.l += 4; val = parsebool(blob, 4); break;
					case 0x40 /*VT_FILETIME*/: blob.l += 4; val = parseDate(parse_FILETIME(blob)); break;
					default: throw new Error("unparsed value: " + blob[blob.l]);
				}
				PropH[name] = val;
			}
		}
	}
	blob.l = start_addr + size; /* step ahead to skip padding */
	return PropH;
}
var XLSPSSkip = [ "CodePage", "Thumbnail", "_PID_LINKBASE", "_PID_HLINKS", "SystemIdentifier", "FMTID" ].concat(PseudoPropsPairs);
function guess_property_type(val) {
	switch(typeof val) {
		case "boolean": return 0x0B;
		case "number": return ((val|0)==val) ? 0x03 : 0x05;
		case "string": return 0x1F;
		case "object": if(val instanceof Date) return 0x40; break;
	}
	return -1;
}
function write_PropertySet(entries, RE, PIDSI) {
	var hdr = new_buf(8), piao = [], prop = [];
	var sz = 8, i = 0;

	var pr = new_buf(8), pio = new_buf(8);
	pr.write_shift(4, 0x0002);
	pr.write_shift(4, 0x04B0);
	pio.write_shift(4, 0x0001);
	prop.push(pr); piao.push(pio);
	sz += 8 + pr.length;

	if(!RE) {
		pio = new_buf(8);
		pio.write_shift(4, 0);
		piao.unshift(pio);

		var bufs = [new_buf(4)];
		bufs[0].write_shift(4, entries.length);
		for(i = 0; i < entries.length; ++i) {
			var value = entries[i][0];
			pr = new_buf(4 + 4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
			pr.write_shift(4, i+2);
			pr.write_shift(4, value.length + 1);
			pr.write_shift(0, value, "dbcs");
			while(pr.l != pr.length) pr.write_shift(1, 0);
			bufs.push(pr);
		}
		pr = bconcat(bufs);
		prop.unshift(pr);
		sz += 8 + pr.length;
	}

	for(i = 0; i < entries.length; ++i) {
		if(RE && !RE[entries[i][0]]) continue;
		if(XLSPSSkip.indexOf(entries[i][0]) > -1) continue;
		if(entries[i][1] == null) continue;

		var val = entries[i][1], idx = 0;
		if(RE) {
			idx = +RE[entries[i][0]];
			var pinfo = (PIDSI)[idx];
			if(pinfo.p == "version" && typeof val == "string") {
var arr = val.split(".");
				val = ((+arr[0])<<16) + ((+arr[1])||0);
			}
			pr = write_TypedPropertyValue(pinfo.t, val);
		} else {
			var T = guess_property_type(val);
			if(T == -1) { T = 0x1F; val = String(val); }
			pr = write_TypedPropertyValue(T, val);
		}
		prop.push(pr);

		pio = new_buf(8);
		pio.write_shift(4, !RE ? 2+i : idx);
		piao.push(pio);

		sz += 8 + pr.length;
	}

	var w = 8 * (prop.length + 1);
	for(i = 0; i < prop.length; ++i) { piao[i].write_shift(4, w); w += prop[i].length; }
	hdr.write_shift(4, sz);
	hdr.write_shift(4, prop.length);
	return bconcat([hdr].concat(piao).concat(prop));
}

/* [MS-OLEPS] 2.21 PropertySetStream */
function parse_PropertySetStream(file, PIDSI, clsid) {
	var blob = file.content;
	if(!blob) return ({});
	prep_blob(blob, 0);

	var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
	blob.chk('feff', 'Byte Order: ');

	/*var vers = */blob.read_shift(2); // TODO: check version
	var SystemIdentifier = blob.read_shift(4);
	var CLSID = blob.read_shift(16);
	if(CLSID !== CFB.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
	NumSets = blob.read_shift(4);
	if(NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
	FMTID0 = blob.read_shift(16); Offset0 = blob.read_shift(4);

	if(NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
	else if(NumSets === 2) { FMTID1 = blob.read_shift(16); Offset1 = blob.read_shift(4); }
	var PSet0 = parse_PropertySet(blob, PIDSI);

	var rval = ({ SystemIdentifier: SystemIdentifier });
	for(var y in PSet0) rval[y] = PSet0[y];
	//rval.blob = blob;
	rval.FMTID = FMTID0;
	//rval.PSet0 = PSet0;
	if(NumSets === 1) return rval;
	if(Offset1 - blob.l == 2) blob.l += 2;
	if(blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
	var PSet1;
	try { PSet1 = parse_PropertySet(blob, null); } catch(e) {/* empty */}
	for(y in PSet1) rval[y] = PSet1[y];
	rval.FMTID = [FMTID0, FMTID1]; // TODO: verify FMTID0/1
	return rval;
}
function write_PropertySetStream(entries, clsid, RE, PIDSI, entries2, clsid2) {
	var hdr = new_buf(entries2 ? 68 : 48);
	var bufs = [hdr];
	hdr.write_shift(2, 0xFFFE);
	hdr.write_shift(2, 0x0000); /* TODO: type 1 props */
	hdr.write_shift(4, 0x32363237);
	hdr.write_shift(16, CFB.utils.consts.HEADER_CLSID, "hex");
	hdr.write_shift(4, (entries2 ? 2 : 1));
	hdr.write_shift(16, clsid, "hex");
	hdr.write_shift(4, (entries2 ? 68 : 48));
	var ps0 = write_PropertySet(entries, RE, PIDSI);
	bufs.push(ps0);

	if(entries2) {
		var ps1 = write_PropertySet(entries2, null, null);
		hdr.write_shift(16, clsid2, "hex");
		hdr.write_shift(4, 68 + ps0.length);
		bufs.push(ps1);
	}
	return bconcat(bufs);
}

function parsenoop2(blob, length) { blob.read_shift(length); return null; }
function writezeroes(n, o) { if(!o) o=new_buf(n); for(var j=0; j<n; ++j) o.write_shift(1, 0); return o; }

function parslurp(blob, length, cb) {
	var arr = [], target = blob.l + length;
	while(blob.l < target) arr.push(cb(blob, target - blob.l));
	if(target !== blob.l) throw new Error("Slurp error");
	return arr;
}

function parsebool(blob, length) { return blob.read_shift(length) === 0x1; }
function writebool(v, o) { if(!o) o=new_buf(2); o.write_shift(2, +!!v); return o; }

function parseuint16(blob) { return blob.read_shift(2, 'u'); }
function writeuint16(v, o) { if(!o) o=new_buf(2); o.write_shift(2, v); return o; }
function parseuint16a(blob, length) { return parslurp(blob,length,parseuint16);}

/* --- 2.5 Structures --- */

/* [MS-XLS] 2.5.10 Bes (boolean or error) */
function parse_Bes(blob) {
	var v = blob.read_shift(1), t = blob.read_shift(1);
	return t === 0x01 ? v : v === 0x01;
}
function write_Bes(v, t, o) {
	if(!o) o = new_buf(2);
	o.write_shift(1, +v);
	o.write_shift(1, ((t == 'e') ? 1 : 0));
	return o;
}

/* [MS-XLS] 2.5.240 ShortXLUnicodeString */
function parse_ShortXLUnicodeString(blob, length, opts) {
	var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
	var encoding = 'sbcs-cont';
	var cp = current_codepage;
	if(opts && opts.biff >= 8) current_codepage = 1200;
	if(!opts || opts.biff == 8 ) {
		var fHighByte = blob.read_shift(1);
		if(fHighByte) { encoding = 'dbcs-cont'; }
	} else if(opts.biff == 12) {
		encoding = 'wstr';
	}
	if(opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
	var o = cch ? blob.read_shift(cch, encoding) : "";
	current_codepage = cp;
	return o;
}

/* 2.5.293 XLUnicodeRichExtendedString */
function parse_XLUnicodeRichExtendedString(blob) {
	var cp = current_codepage;
	current_codepage = 1200;
	var cch = blob.read_shift(2), flags = blob.read_shift(1);
	var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
	var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
	var cRun = 0, cbExtRst;
	var z = {};
	if(fRichSt) cRun = blob.read_shift(2);
	if(fExtSt) cbExtRst = blob.read_shift(4);
	var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
	var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
	if(fRichSt) blob.l += 4 * cRun; //TODO: parse this
	if(fExtSt) blob.l += cbExtRst; //TODO: parse this
	z.t = msg;
	if(!fRichSt) { z.raw = "<t>" + z.t + "</t>"; z.r = z.t; }
	current_codepage = cp;
	return z;
}

/* 2.5.296 XLUnicodeStringNoCch */
function parse_XLUnicodeStringNoCch(blob, cch, opts) {
	var retval;
	if(opts) {
		if(opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
		if(opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
	}
	var fHighByte = blob.read_shift(1);
	if(fHighByte===0) { retval = blob.read_shift(cch, 'sbcs-cont'); }
	else { retval = blob.read_shift(cch, 'dbcs-cont'); }
	return retval;
}

/* 2.5.294 XLUnicodeString */
function parse_XLUnicodeString(blob, length, opts) {
	var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	if(cch === 0) { blob.l++; return ""; }
	return parse_XLUnicodeStringNoCch(blob, cch, opts);
}
/* BIFF5 override */
function parse_XLUnicodeString2(blob, length, opts) {
	if(opts.biff > 5) return parse_XLUnicodeString(blob, length, opts);
	var cch = blob.read_shift(1);
	if(cch === 0) { blob.l++; return ""; }
	return blob.read_shift(cch, (opts.biff <= 4 || !blob.lens ) ? 'cpstr' : 'sbcs-cont');
}
/* TODO: BIFF5 and lower, codepage awareness */
function write_XLUnicodeString(str, opts, o) {
	if(!o) o = new_buf(3 + 2 * str.length);
	o.write_shift(2, str.length);
	o.write_shift(1, 1);
	o.write_shift(31, str, 'utf16le');
	return o;
}

/* [MS-XLS] 2.5.61 ControlInfo */
function parse_ControlInfo(blob) {
	var flags = blob.read_shift(1);
	blob.l++;
	var accel = blob.read_shift(2);
	blob.l += 2;
	return [flags, accel];
}

/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */
function parse_URLMoniker(blob) {
	var len = blob.read_shift(4), start = blob.l;
	var extra = false;
	if(len > 24) {
		/* look ahead */
		blob.l += len - 24;
		if(blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
		blob.l = start;
	}
	var url = blob.read_shift((extra?len-24:len)>>1, 'utf16le').replace(chr0,"");
	if(extra) blob.l += 24;
	return url;
}

/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */
function parse_FileMoniker(blob) {
	blob.l += 2; //var cAnti = blob.read_shift(2);
	var ansiPath = blob.read_shift(0, 'lpstr-ansi');
	blob.l += 2; //var endServer = blob.read_shift(2);
	if(blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
	var sz = blob.read_shift(4);
	if(sz === 0) return ansiPath.replace(/\\/g,"/");
	var bytes = blob.read_shift(4);
	if(blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
	var unicodePath = blob.read_shift(bytes>>1, 'utf16le').replace(chr0,"");
	return unicodePath;
}

/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */
function parse_HyperlinkMoniker(blob, length) {
	var clsid = blob.read_shift(16); length -= 16;
	switch(clsid) {
		case "e0c9ea79f9bace118c8200aa004ba90b": return parse_URLMoniker(blob, length);
		case "0303000000000000c000000000000046": return parse_FileMoniker(blob, length);
		default: throw new Error("Unsupported Moniker " + clsid);
	}
}

/* [MS-OSHARED] 2.3.7.9 HyperlinkString */
function parse_HyperlinkString(blob) {
	var len = blob.read_shift(4);
	var o = len > 0 ? blob.read_shift(len, 'utf16le').replace(chr0, "") : "";
	return o;
}

/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */
function parse_Hyperlink(blob, length) {
	var end = blob.l + length;
	var sVer = blob.read_shift(4);
	if(sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
	var flags = blob.read_shift(2);
	blob.l += 2;
	var displayName, targetFrameName, moniker, oleMoniker, Loc="", guid, fileTime;
	if(flags & 0x0010) displayName = parse_HyperlinkString(blob, end - blob.l);
	if(flags & 0x0080) targetFrameName = parse_HyperlinkString(blob, end - blob.l);
	if((flags & 0x0101) === 0x0101) moniker = parse_HyperlinkString(blob, end - blob.l);
	if((flags & 0x0101) === 0x0001) oleMoniker = parse_HyperlinkMoniker(blob, end - blob.l);
	if(flags & 0x0008) Loc = parse_HyperlinkString(blob, end - blob.l);
	if(flags & 0x0020) guid = blob.read_shift(16);
	if(flags & 0x0040) fileTime = parse_FILETIME(blob/*, 8*/);
	blob.l = end;
	var target = targetFrameName||moniker||oleMoniker||"";
	if(target && Loc) target+="#"+Loc;
	if(!target) target = "#" + Loc;
	var out = ({Target:target});
	if(guid) out.guid = guid;
	if(fileTime) out.time = fileTime;
	if(displayName) out.Tooltip = displayName;
	return out;
}
function write_Hyperlink(hl) {
	var out = new_buf(512), i = 0;
	var Target = hl.Target;
	var F = Target.indexOf("#") > -1 ? 0x1f : 0x17;
	switch(Target.charAt(0)) { case "#": F=0x1c; break; case ".": F&=~2; break; }
	out.write_shift(4,2); out.write_shift(4, F);
	var data = [8,6815827,6619237,4849780,83]; for(i = 0; i < data.length; ++i) out.write_shift(4, data[i]);
	if(F == 0x1C) {
		Target = Target.slice(1);
		out.write_shift(4, Target.length + 1);
		for(i = 0; i < Target.length; ++i) out.write_shift(2, Target.charCodeAt(i));
		out.write_shift(2, 0);
	} else if(F & 0x02) {
		data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
		for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
		out.write_shift(4, 2*(Target.length + 1));
		for(i = 0; i < Target.length; ++i) out.write_shift(2, Target.charCodeAt(i));
		out.write_shift(2, 0);
	} else {
		data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
		for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
		var P = 0;
		while(Target.slice(P*3,P*3+3)=="../"||Target.slice(P*3,P*3+3)=="..\\") ++P;
		out.write_shift(2, P);
		out.write_shift(4, Target.length + 1);
		for(i = 0; i < Target.length; ++i) out.write_shift(1, Target.charCodeAt(i) & 0xFF);
		out.write_shift(1, 0);
		out.write_shift(2, 0xFFFF);
		out.write_shift(2, 0xDEAD);
		for(i = 0; i < 6; ++i) out.write_shift(4, 0);
	}
	return out.slice(0, out.l);
}

/* 2.5.178 LongRGBA */
function parse_LongRGBA(blob) { var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1); return [r,g,b,a]; }

/* 2.5.177 LongRGB */
function parse_LongRGB(blob, length) { var x = parse_LongRGBA(blob, length); x[3] = 0; return x; }


/* [MS-XLS] 2.5.19 */
function parse_XLSCell(blob) {
	var rw = blob.read_shift(2); // 0-indexed
	var col = blob.read_shift(2);
	var ixfe = blob.read_shift(2);
	return ({r:rw, c:col, ixfe:ixfe});
}
function write_XLSCell(R, C, ixfe, o) {
	if(!o) o = new_buf(6);
	o.write_shift(2, R);
	o.write_shift(2, C);
	o.write_shift(2, ixfe||0);
	return o;
}

/* [MS-XLS] 2.5.134 */
function parse_frtHeader(blob) {
	var rt = blob.read_shift(2);
	var flags = blob.read_shift(2); // TODO: parse these flags
	blob.l += 8;
	return {type: rt, flags: flags};
}



function parse_OptXLUnicodeString(blob, length, opts) { return length === 0 ? "" : parse_XLUnicodeString2(blob, length, opts); }

/* [MS-XLS] 2.5.344 */
function parse_XTI(blob, length, opts) {
	var w = opts.biff > 8 ? 4 : 2;
	var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w,'i'), itabLast = blob.read_shift(w,'i');
	return [iSupBook, itabFirst, itabLast];
}

/* [MS-XLS] 2.5.218 */
function parse_RkRec(blob) {
	var ixfe = blob.read_shift(2);
	var RK = parse_RkNumber(blob);
	return [ixfe, RK];
}

/* [MS-XLS] 2.5.1 */
function parse_AddinUdf(blob, length, opts) {
	blob.l += 4; length -= 4;
	var l = blob.l + length;
	var udfName = parse_ShortXLUnicodeString(blob, length, opts);
	var cb = blob.read_shift(2);
	l -= blob.l;
	if(cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
	blob.l += cb;
	return udfName;
}

/* [MS-XLS] 2.5.209 TODO: Check sizes */
function parse_Ref8U(blob) {
	var rwFirst = blob.read_shift(2);
	var rwLast = blob.read_shift(2);
	var colFirst = blob.read_shift(2);
	var colLast = blob.read_shift(2);
	return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
}
function write_Ref8U(r, o) {
	if(!o) o = new_buf(8);
	o.write_shift(2, r.s.r);
	o.write_shift(2, r.e.r);
	o.write_shift(2, r.s.c);
	o.write_shift(2, r.e.c);
	return o;
}

/* [MS-XLS] 2.5.211 */
function parse_RefU(blob) {
	var rwFirst = blob.read_shift(2);
	var rwLast = blob.read_shift(2);
	var colFirst = blob.read_shift(1);
	var colLast = blob.read_shift(1);
	return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
}

/* [MS-XLS] 2.5.207 */
var parse_Ref = parse_RefU;

/* [MS-XLS] 2.5.143 */
function parse_FtCmo(blob) {
	blob.l += 4;
	var ot = blob.read_shift(2);
	var id = blob.read_shift(2);
	var flags = blob.read_shift(2);
	blob.l+=12;
	return [id, ot, flags];
}

/* [MS-XLS] 2.5.149 */
function parse_FtNts(blob) {
	var out = {};
	blob.l += 4;
	blob.l += 16; // GUID TODO
	out.fSharedNote = blob.read_shift(2);
	blob.l += 4;
	return out;
}

/* [MS-XLS] 2.5.142 */
function parse_FtCf(blob) {
	var out = {};
	blob.l += 4;
	blob.cf = blob.read_shift(2);
	return out;
}

/* [MS-XLS] 2.5.140 - 2.5.154 and friends */
function parse_FtSkip(blob) { blob.l += 2; blob.l += blob.read_shift(2); }
var FtTab = {
0x00: parse_FtSkip,      /* FtEnd */
0x04: parse_FtSkip,      /* FtMacro */
0x05: parse_FtSkip,      /* FtButton */
0x06: parse_FtSkip,      /* FtGmo */
0x07: parse_FtCf,        /* FtCf */
0x08: parse_FtSkip,      /* FtPioGrbit */
0x09: parse_FtSkip,      /* FtPictFmla */
0x0A: parse_FtSkip,      /* FtCbls */
0x0B: parse_FtSkip,      /* FtRbo */
0x0C: parse_FtSkip,      /* FtSbs */
0x0D: parse_FtNts,       /* FtNts */
0x0E: parse_FtSkip,      /* FtSbsFmla */
0x0F: parse_FtSkip,      /* FtGboData */
0x10: parse_FtSkip,      /* FtEdoData */
0x11: parse_FtSkip,      /* FtRboData */
0x12: parse_FtSkip,      /* FtCblsData */
0x13: parse_FtSkip,      /* FtLbsData */
0x14: parse_FtSkip,      /* FtCblsFmla */
0x15: parse_FtCmo
};
function parse_FtArray(blob, length) {
	var tgt = blob.l + length;
	var fts = [];
	while(blob.l < tgt) {
		var ft = blob.read_shift(2);
		blob.l-=2;
		try {
			fts.push(FtTab[ft](blob, tgt - blob.l));
		} catch(e) { blob.l = tgt; return fts; }
	}
	if(blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
	return fts;
}

/* --- 2.4 Records --- */

/* [MS-XLS] 2.4.21 */
function parse_BOF(blob, length) {
	var o = {BIFFVer:0, dt:0};
	o.BIFFVer = blob.read_shift(2); length -= 2;
	if(length >= 2) { o.dt = blob.read_shift(2); blob.l -= 2; }
	switch(o.BIFFVer) {
		case 0x0600: /* BIFF8 */
		case 0x0500: /* BIFF5 */
		case 0x0400: /* BIFF4 */
		case 0x0300: /* BIFF3 */
		case 0x0200: /* BIFF2 */
		case 0x0002: case 0x0007: /* BIFF2 */
			break;
		default: if(length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
	}

	blob.read_shift(length);
	return o;
}
function write_BOF(wb, t, o) {
	var h = 0x0600, w = 16;
	switch(o.bookType) {
		case 'biff8': break;
		case 'biff5': h = 0x0500; w = 8; break;
		case 'biff4': h = 0x0004; w = 6; break;
		case 'biff3': h = 0x0003; w = 6; break;
		case 'biff2': h = 0x0002; w = 4; break;
		case 'xla': break;
		default: throw new Error("unsupported BIFF version");
	}
	var out = new_buf(w);
	out.write_shift(2, h);
	out.write_shift(2, t);
	if(w > 4) out.write_shift(2, 0x7262);
	if(w > 6) out.write_shift(2, 0x07CD);
	if(w > 8) {
		out.write_shift(2, 0xC009);
		out.write_shift(2, 0x0001);
		out.write_shift(2, 0x0706);
		out.write_shift(2, 0x0000);
	}
	return out;
}


/* [MS-XLS] 2.4.146 */
function parse_InterfaceHdr(blob, length) {
	if(length === 0) return 0x04b0;
	if((blob.read_shift(2))!==0x04b0){/* empty */}
	return 0x04b0;
}


/* [MS-XLS] 2.4.349 */
function parse_WriteAccess(blob, length, opts) {
	if(opts.enc) { blob.l += length; return ""; }
	var l = blob.l;
	// TODO: make sure XLUnicodeString doesnt overrun
	var UserName = parse_XLUnicodeString2(blob, 0, opts);
	blob.read_shift(length + l - blob.l);
	return UserName;
}
function write_WriteAccess(s, opts) {
	var b8 = !opts || opts.biff == 8;
	var o = new_buf(b8 ? 112 : 54);
	o.write_shift(opts.biff == 8 ? 2 : 1, 7);
	if(b8) o.write_shift(1, 0);
	o.write_shift(4, 0x33336853);
	o.write_shift(4, (0x00534A74 | (b8 ? 0 : 0x20000000)));
	while(o.l < o.length) o.write_shift(1, (b8 ? 0 : 32));
	return o;
}

/* [MS-XLS] 2.4.351 */
function parse_WsBool(blob, length, opts) {
	var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
	return { fDialog: flags & 0x10 };
}

/* [MS-XLS] 2.4.28 */
function parse_BoundSheet8(blob, length, opts) {
	var pos = blob.read_shift(4);
	var hidden = blob.read_shift(1) & 0x03;
	var dt = blob.read_shift(1);
	switch(dt) {
		case 0: dt = 'Worksheet'; break;
		case 1: dt = 'Macrosheet'; break;
		case 2: dt = 'Chartsheet'; break;
		case 6: dt = 'VBAModule'; break;
	}
	var name = parse_ShortXLUnicodeString(blob, 0, opts);
	if(name.length === 0) name = "Sheet1";
	return { pos:pos, hs:hidden, dt:dt, name:name };
}
function write_BoundSheet8(data, opts) {
	var w = (!opts || opts.biff >= 8 ? 2 : 1);
	var o = new_buf(8 + w * data.name.length);
	o.write_shift(4, data.pos);
	o.write_shift(1, data.hs || 0);
	o.write_shift(1, data.dt);
	o.write_shift(1, data.name.length);
	if(opts.biff >= 8) o.write_shift(1, 1);
	o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
	var out = o.slice(0, o.l);
	out.l = o.l; return out;
}

/* [MS-XLS] 2.4.265 TODO */
function parse_SST(blob, length) {
	var end = blob.l + length;
	var cnt = blob.read_shift(4);
	var ucnt = blob.read_shift(4);
	var strs = ([]);
	for(var i = 0; i != ucnt && blob.l < end; ++i) {
		strs.push(parse_XLUnicodeRichExtendedString(blob));
	}
	strs.Count = cnt; strs.Unique = ucnt;
	return strs;
}

/* [MS-XLS] 2.4.107 */
function parse_ExtSST(blob, length) {
	var extsst = {};
	extsst.dsst = blob.read_shift(2);
	blob.l += length-2;
	return extsst;
}


/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */
function parse_Row(blob) {
	var z = ({});
	z.r = blob.read_shift(2);
	z.c = blob.read_shift(2);
	z.cnt = blob.read_shift(2) - z.c;
	var miyRw = blob.read_shift(2);
	blob.l += 4; // reserved(2), unused(2)
	var flags = blob.read_shift(1); // various flags
	blob.l += 3; // reserved(8), ixfe(12), flags(4)
	if(flags & 0x07) z.level = flags & 0x07;
	// collapsed: flags & 0x10
	if(flags & 0x20) z.hidden = true;
	if(flags & 0x40) z.hpt = miyRw / 20;
	return z;
}


/* [MS-XLS] 2.4.125 */
function parse_ForceFullCalculation(blob) {
	var header = parse_frtHeader(blob);
	if(header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
	var fullcalc = blob.read_shift(4);
	return fullcalc !== 0x0;
}





/* [MS-XLS] 2.4.215 rt */
function parse_RecalcId(blob) {
	blob.read_shift(2);
	return blob.read_shift(4);
}

/* [MS-XLS] 2.4.87 */
function parse_DefaultRowHeight(blob, length, opts) {
	var f = 0;
	if(!(opts && opts.biff == 2)) {
		f = blob.read_shift(2);
	}
	var miyRw = blob.read_shift(2);
	if((opts && opts.biff == 2)) {
		f = 1 - (miyRw >> 15); miyRw &= 0x7fff;
	}
	var fl = {Unsynced:f&1,DyZero:(f&2)>>1,ExAsc:(f&4)>>2,ExDsc:(f&8)>>3};
	return [fl, miyRw];
}

/* [MS-XLS] 2.4.345 TODO */
function parse_Window1(blob) {
	var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
	var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
	var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
	return { Pos: [xWn, yWn], Dim: [dxWn, dyWn], Flags: flags, CurTab: iTabCur,
		FirstTab: iTabFirst, Selected: ctabSel, TabRatio: wTabRatio };
}
function write_Window1() {
	var o = new_buf(18);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 0x7260);
	o.write_shift(2, 0x44c0);
	o.write_shift(2, 0x38);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 1);
	o.write_shift(2, 0x01f4);
	return o;
}
/* [MS-XLS] 2.4.346 TODO */
function parse_Window2(blob, length, opts) {
	if(opts && opts.biff >= 2 && opts.biff < 8) return {};
	var f = blob.read_shift(2);
	return { RTL: f & 0x40 };
}
function write_Window2(view) {
	var o = new_buf(18), f = 0x6b6;
	if(view && view.RTL) f |= 0x40;
	o.write_shift(2, f);
	o.write_shift(4, 0);
	o.write_shift(4, 64);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	return o;
}

/* [MS-XLS] 2.4.122 TODO */
function parse_Font(blob, length, opts) {
	var o = {
		dyHeight: blob.read_shift(2),
		fl: blob.read_shift(2)
	};
	switch((opts && opts.biff) || 8) {
		case 2: break;
		case 3: case 4: blob.l += 2; break;
		default: blob.l += 10; break;
	}
	o.name = parse_ShortXLUnicodeString(blob, 0, opts);
	return o;
}
function write_Font(data, opts) {
	var name = data.name || "Arial";
	var b5 = (opts && (opts.biff == 5)), w = (b5 ? (15 + name.length) : (16 + 2 * name.length));
	var o = new_buf(w);
	o.write_shift(2, (data.sz || 12) * 20);
	o.write_shift(4, 0);
	o.write_shift(2, 400);
	o.write_shift(4, 0);
	o.write_shift(2, 0);
	o.write_shift(1, name.length);
	if(!b5) o.write_shift(1, 1);
	o.write_shift((b5 ? 1 : 2) * name.length, name, (b5 ? "sbcs" : "utf16le"));
	return o;
}

/* [MS-XLS] 2.4.149 */
function parse_LabelSst(blob) {
	var cell = parse_XLSCell(blob);
	cell.isst = blob.read_shift(4);
	return cell;
}

/* [MS-XLS] 2.4.148 */
function parse_Label(blob, length, opts) {
	var target = blob.l + length;
	var cell = parse_XLSCell(blob, 6);
	if(opts.biff == 2) blob.l++;
	var str = parse_XLUnicodeString(blob, target - blob.l, opts);
	cell.val = str;
	return cell;
}
function write_Label(R, C, v, os, opts) {
	var b8 = !opts || opts.biff == 8;
	var o = new_buf(6 + 2 + (+b8) + (1 + b8) * v.length);
	write_XLSCell(R, C, os, o);
	o.write_shift(2, v.length);
	if(b8) o.write_shift(1, 1);
	o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
	return o;
}


/* [MS-XLS] 2.4.126 Number Formats */
function parse_Format(blob, length, opts) {
	var numFmtId = blob.read_shift(2);
	var fmtstr = parse_XLUnicodeString2(blob, 0, opts);
	return [numFmtId, fmtstr];
}
function write_Format(i, f, opts, o) {
	var b5 = (opts && (opts.biff == 5));
	if(!o) o = new_buf(b5 ? (3 + f.length) : (5 + 2 * f.length));
	o.write_shift(2, i);
	o.write_shift((b5 ? 1 : 2), f.length);
	if(!b5) o.write_shift(1, 1);
	o.write_shift((b5 ? 1 : 2) * f.length, f, (b5 ? 'sbcs' : 'utf16le'));
	var out = (o.length > o.l) ? o.slice(0, o.l) : o;
	if(out.l == null) out.l = out.length;
	return out;
}
var parse_BIFF2Format = parse_XLUnicodeString2;

/* [MS-XLS] 2.4.90 */
function parse_Dimensions(blob, length, opts) {
	var end = blob.l + length;
	var w = opts.biff == 8 || !opts.biff ? 4 : 2;
	var r = blob.read_shift(w), R = blob.read_shift(w);
	var c = blob.read_shift(2), C = blob.read_shift(2);
	blob.l = end;
	return {s: {r:r, c:c}, e: {r:R, c:C}};
}
function write_Dimensions(range, opts) {
	var w = opts.biff == 8 || !opts.biff ? 4 : 2;
	var o = new_buf(2*w + 6);
	o.write_shift(w, range.s.r);
	o.write_shift(w, range.e.r + 1);
	o.write_shift(2, range.s.c);
	o.write_shift(2, range.e.c + 1);
	o.write_shift(2, 0);
	return o;
}

/* [MS-XLS] 2.4.220 */
function parse_RK(blob) {
	var rw = blob.read_shift(2), col = blob.read_shift(2);
	var rkrec = parse_RkRec(blob);
	return {r:rw, c:col, ixfe:rkrec[0], rknum:rkrec[1]};
}

/* [MS-XLS] 2.4.175 */
function parse_MulRk(blob, length) {
	var target = blob.l + length - 2;
	var rw = blob.read_shift(2), col = blob.read_shift(2);
	var rkrecs = [];
	while(blob.l < target) rkrecs.push(parse_RkRec(blob));
	if(blob.l !== target) throw new Error("MulRK read error");
	var lastcol = blob.read_shift(2);
	if(rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
	return {r:rw, c:col, C:lastcol, rkrec:rkrecs};
}
/* [MS-XLS] 2.4.174 */
function parse_MulBlank(blob, length) {
	var target = blob.l + length - 2;
	var rw = blob.read_shift(2), col = blob.read_shift(2);
	var ixfes = [];
	while(blob.l < target) ixfes.push(blob.read_shift(2));
	if(blob.l !== target) throw new Error("MulBlank read error");
	var lastcol = blob.read_shift(2);
	if(ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
	return {r:rw, c:col, C:lastcol, ixfe:ixfes};
}

/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */
function parse_CellStyleXF(blob, length, style, opts) {
	var o = {};
	var a = blob.read_shift(4), b = blob.read_shift(4);
	var c = blob.read_shift(4), d = blob.read_shift(2);
	o.patternType = XLSFillPattern[c >> 26];

	if(!opts.cellStyles) return o;
	o.alc = a & 0x07;
	o.fWrap = (a >> 3) & 0x01;
	o.alcV = (a >> 4) & 0x07;
	o.fJustLast = (a >> 7) & 0x01;
	o.trot = (a >> 8) & 0xFF;
	o.cIndent = (a >> 16) & 0x0F;
	o.fShrinkToFit = (a >> 20) & 0x01;
	o.iReadOrder = (a >> 22) & 0x02;
	o.fAtrNum = (a >> 26) & 0x01;
	o.fAtrFnt = (a >> 27) & 0x01;
	o.fAtrAlc = (a >> 28) & 0x01;
	o.fAtrBdr = (a >> 29) & 0x01;
	o.fAtrPat = (a >> 30) & 0x01;
	o.fAtrProt = (a >> 31) & 0x01;

	o.dgLeft = b & 0x0F;
	o.dgRight = (b >> 4) & 0x0F;
	o.dgTop = (b >> 8) & 0x0F;
	o.dgBottom = (b >> 12) & 0x0F;
	o.icvLeft = (b >> 16) & 0x7F;
	o.icvRight = (b >> 23) & 0x7F;
	o.grbitDiag = (b >> 30) & 0x03;

	o.icvTop = c & 0x7F;
	o.icvBottom = (c >> 7) & 0x7F;
	o.icvDiag = (c >> 14) & 0x7F;
	o.dgDiag = (c >> 21) & 0x0F;

	o.icvFore = d & 0x7F;
	o.icvBack = (d >> 7) & 0x7F;
	o.fsxButton = (d >> 14) & 0x01;
	return o;
}
//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}

/* [MS-XLS] 2.4.353 TODO: actually do this right */
function parse_XF(blob, length, opts) {
	var o = {};
	o.ifnt = blob.read_shift(2); o.numFmtId = blob.read_shift(2); o.flags = blob.read_shift(2);
	o.fStyle = (o.flags >> 2) & 0x01;
	length -= 6;
	o.data = parse_CellStyleXF(blob, length, o.fStyle, opts);
	return o;
}
function write_XF(data, ixfeP, opts, o) {
	var b5 = (opts && (opts.biff == 5));
	if(!o) o = new_buf(b5 ? 16 : 20);
	o.write_shift(2, 0);
	if(data.style) {
		o.write_shift(2, (data.numFmtId||0));
		o.write_shift(2, 0xFFF4);
	} else {
		o.write_shift(2, (data.numFmtId||0));
		o.write_shift(2, (ixfeP<<4));
	}
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	if(!b5) o.write_shift(4, 0);
	o.write_shift(2, 0);
	return o;
}

/* [MS-XLS] 2.4.134 */
function parse_Guts(blob) {
	blob.l += 4;
	var out = [blob.read_shift(2), blob.read_shift(2)];
	if(out[0] !== 0) out[0]--;
	if(out[1] !== 0) out[1]--;
	if(out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
	return out;
}
function write_Guts(guts) {
	var o = new_buf(8);
	o.write_shift(4, 0);
	o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
	o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
	return o;
}

/* [MS-XLS] 2.4.24 */
function parse_BoolErr(blob, length, opts) {
	var cell = parse_XLSCell(blob, 6);
	if(opts.biff == 2) ++blob.l;
	var val = parse_Bes(blob, 2);
	cell.val = val;
	cell.t = (val === true || val === false) ? 'b' : 'e';
	return cell;
}
function write_BoolErr(R, C, v, os, opts, t) {
	var o = new_buf(8);
	write_XLSCell(R, C, os, o);
	write_Bes(v, t, o);
	return o;
}

/* [MS-XLS] 2.4.180 Number */
function parse_Number(blob) {
	var cell = parse_XLSCell(blob, 6);
	var xnum = parse_Xnum(blob, 8);
	cell.val = xnum;
	return cell;
}
function write_Number(R, C, v, os) {
	var o = new_buf(14);
	write_XLSCell(R, C, os, o);
	write_Xnum(v, o);
	return o;
}

var parse_XLHeaderFooter = parse_OptXLUnicodeString; // TODO: parse 2.4.136

/* [MS-XLS] 2.4.271 */
function parse_SupBook(blob, length, opts) {
	var end = blob.l + length;
	var ctab = blob.read_shift(2);
	var cch = blob.read_shift(2);
	opts.sbcch = cch;
	if(cch == 0x0401 || cch == 0x3A01) return [cch, ctab];
	if(cch < 0x01 || cch >0xff) throw new Error("Unexpected SupBook type: "+cch);
	var virtPath = parse_XLUnicodeStringNoCch(blob, cch);
	/* TODO: 2.5.277 Virtual Path */
	var rgst = [];
	while(end > blob.l) rgst.push(parse_XLUnicodeString(blob));
	return [cch, ctab, virtPath, rgst];
}

/* [MS-XLS] 2.4.105 TODO */
function parse_ExternName(blob, length, opts) {
	var flags = blob.read_shift(2);
	var body;
	var o = ({
		fBuiltIn: flags & 0x01,
		fWantAdvise: (flags >>> 1) & 0x01,
		fWantPict: (flags >>> 2) & 0x01,
		fOle: (flags >>> 3) & 0x01,
		fOleLink: (flags >>> 4) & 0x01,
		cf: (flags >>> 5) & 0x3FF,
		fIcon: flags >>> 15 & 0x01
	});
	if(opts.sbcch === 0x3A01) body = parse_AddinUdf(blob, length-2, opts);
	//else throw new Error("unsupported SupBook cch: " + opts.sbcch);
	o.body = body || blob.read_shift(length-2);
	if(typeof body === "string") o.Name = body;
	return o;
}

/* [MS-XLS] 2.4.150 TODO */
var XLSLblBuiltIn = [
	"_xlnm.Consolidate_Area",
	"_xlnm.Auto_Open",
	"_xlnm.Auto_Close",
	"_xlnm.Extract",
	"_xlnm.Database",
	"_xlnm.Criteria",
	"_xlnm.Print_Area",
	"_xlnm.Print_Titles",
	"_xlnm.Recorder",
	"_xlnm.Data_Form",
	"_xlnm.Auto_Activate",
	"_xlnm.Auto_Deactivate",
	"_xlnm.Sheet_Title",
	"_xlnm._FilterDatabase"
];
function parse_Lbl(blob, length, opts) {
	var target = blob.l + length;
	var flags = blob.read_shift(2);
	var chKey = blob.read_shift(1);
	var cch = blob.read_shift(1);
	var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	var itab = 0;
	if(!opts || opts.biff >= 5) {
		if(opts.biff != 5) blob.l += 2;
		itab = blob.read_shift(2);
		if(opts.biff == 5) blob.l += 2;
		blob.l += 4;
	}
	var name = parse_XLUnicodeStringNoCch(blob, cch, opts);
	if(flags & 0x20) name = XLSLblBuiltIn[name.charCodeAt(0)];
	var npflen = target - blob.l; if(opts && opts.biff == 2) --npflen;
	var rgce = target == blob.l || cce === 0 ? [] : parse_NameParsedFormula(blob, npflen, opts, cce);
	return {
		chKey: chKey,
		Name: name,
		itab: itab,
		rgce: rgce
	};
}

/* [MS-XLS] 2.4.106 TODO: verify filename encoding */
function parse_ExternSheet(blob, length, opts) {
	if(opts.biff < 8) return parse_BIFF5ExternSheet(blob, length, opts);
	var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
	while(len-- !== 0) o.push(parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
		// [iSupBook, itabFirst, itabLast];
	if(blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
	return o;
}
function parse_BIFF5ExternSheet(blob, length, opts) {
	if(blob[blob.l + 1] == 0x03) blob[blob.l]++;
	var o = parse_ShortXLUnicodeString(blob, length, opts);
	return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
}

/* [MS-XLS] 2.4.176 TODO: check older biff */
function parse_NameCmt(blob, length, opts) {
	if(opts.biff < 8) { blob.l += length; return; }
	var cchName = blob.read_shift(2);
	var cchComment = blob.read_shift(2);
	var name = parse_XLUnicodeStringNoCch(blob, cchName, opts);
	var comment = parse_XLUnicodeStringNoCch(blob, cchComment, opts);
	return [name, comment];
}

/* [MS-XLS] 2.4.260 */
function parse_ShrFmla(blob, length, opts) {
	var ref = parse_RefU(blob, 6);
	blob.l++;
	var cUse = blob.read_shift(1);
	length -= 8;
	return [parse_SharedParsedFormula(blob, length, opts), cUse, ref];
}

/* [MS-XLS] 2.4.4 TODO */
function parse_Array(blob, length, opts) {
	var ref = parse_Ref(blob, 6);
	/* TODO: fAlwaysCalc */
	switch(opts.biff) {
		case 2: blob.l ++; length -= 7; break;
		case 3: case 4: blob.l += 2; length -= 8; break;
		default: blob.l += 6; length -= 12;
	}
	return [ref, parse_ArrayParsedFormula(blob, length, opts, ref)];
}

/* [MS-XLS] 2.4.173 */
function parse_MTRSettings(blob) {
	var fMTREnabled = blob.read_shift(4) !== 0x00;
	var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
	var cUserThreadCount = blob.read_shift(4);
	return [fMTREnabled, fUserSetThreadCount, cUserThreadCount];
}

/* [MS-XLS] 2.5.186 TODO: BIFF5 */
function parse_NoteSh(blob, length, opts) {
	if(opts.biff < 8) return;
	var row = blob.read_shift(2), col = blob.read_shift(2);
	var flags = blob.read_shift(2), idObj = blob.read_shift(2);
	var stAuthor = parse_XLUnicodeString2(blob, 0, opts);
	if(opts.biff < 8) blob.read_shift(1);
	return [{r:row,c:col}, stAuthor, idObj, flags];
}

/* [MS-XLS] 2.4.179 */
function parse_Note(blob, length, opts) {
	/* TODO: Support revisions */
	return parse_NoteSh(blob, length, opts);
}

/* [MS-XLS] 2.4.168 */
function parse_MergeCells(blob, length) {
	var merges = [];
	var cmcs = blob.read_shift(2);
	while (cmcs--) merges.push(parse_Ref8U(blob,length));
	return merges;
}
function write_MergeCells(merges) {
	var o = new_buf(2 + merges.length * 8);
	o.write_shift(2, merges.length);
	for(var i = 0; i < merges.length; ++i) write_Ref8U(merges[i], o);
	return o;
}

/* [MS-XLS] 2.4.181 TODO: parse all the things! */
function parse_Obj(blob, length, opts) {
	if(opts && opts.biff < 8) return parse_BIFF5Obj(blob, length, opts);
	var cmo = parse_FtCmo(blob, 22); // id, ot, flags
	var fts = parse_FtArray(blob, length-22, cmo[1]);
	return { cmo: cmo, ft:fts };
}
/* from older spec */
var parse_BIFF5OT = [];
parse_BIFF5OT[0x08] = function(blob, length) {
	var tgt = blob.l + length;
	blob.l += 10; // todo
	var cf = blob.read_shift(2);
	blob.l += 4;
	blob.l += 2; //var cbPictFmla = blob.read_shift(2);
	blob.l += 2;
	blob.l += 2; //var grbit = blob.read_shift(2);
	blob.l += 4;
	var cchName = blob.read_shift(1);
	blob.l += cchName; // TODO: stName
	blob.l = tgt; // TODO: fmla
	return { fmt:cf };
};

function parse_BIFF5Obj(blob, length, opts) {
	blob.l += 4; //var cnt = blob.read_shift(4);
	var ot = blob.read_shift(2);
	var id = blob.read_shift(2);
	var grbit = blob.read_shift(2);
	blob.l += 2; //var colL = blob.read_shift(2);
	blob.l += 2; //var dxL = blob.read_shift(2);
	blob.l += 2; //var rwT = blob.read_shift(2);
	blob.l += 2; //var dyT = blob.read_shift(2);
	blob.l += 2; //var colR = blob.read_shift(2);
	blob.l += 2; //var dxR = blob.read_shift(2);
	blob.l += 2; //var rwB = blob.read_shift(2);
	blob.l += 2; //var dyB = blob.read_shift(2);
	blob.l += 2; //var cbMacro = blob.read_shift(2);
	blob.l += 6;
	length -= 36;
	var fts = [];
	fts.push((parse_BIFF5OT[ot]||parsenoop)(blob, length, opts));
	return { cmo: [id, ot, grbit], ft:fts };
}

/* [MS-XLS] 2.4.329 TODO: parse properly */
function parse_TxO(blob, length, opts) {
	var s = blob.l;
	var texts = "";
try {
	blob.l += 4;
	var ot = (opts.lastobj||{cmo:[0,0]}).cmo[1];
	var controlInfo; // eslint-disable-line no-unused-vars
	if([0,5,7,11,12,14].indexOf(ot) == -1) blob.l += 6;
	else controlInfo = parse_ControlInfo(blob, 6, opts);
	var cchText = blob.read_shift(2);
	/*var cbRuns = */blob.read_shift(2);
	/*var ifntEmpty = */parseuint16(blob, 2);
	var len = blob.read_shift(2);
	blob.l += len;
	//var fmla = parse_ObjFmla(blob, s + length - blob.l);

	for(var i = 1; i < blob.lens.length-1; ++i) {
		if(blob.l-s != blob.lens[i]) throw new Error("TxO: bad continue record");
		var hdr = blob[blob.l];
		var t = parse_XLUnicodeStringNoCch(blob, blob.lens[i+1]-blob.lens[i]-1);
		texts += t;
		if(texts.length >= (hdr ? cchText : 2*cchText)) break;
	}
	if(texts.length !== cchText && texts.length !== cchText*2) {
		throw new Error("cchText: " + cchText + " != " + texts.length);
	}

	blob.l = s + length;
	/* [MS-XLS] 2.5.272 TxORuns */
//	var rgTxoRuns = [];
//	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
//	var cchText2 = blob.read_shift(2);
//	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
//	blob.l += 6;
//	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
	return { t: texts };
} catch(e) { blob.l = s + length; return { t: texts }; }
}

/* [MS-XLS] 2.4.140 */
function parse_HLink(blob, length) {
	var ref = parse_Ref8U(blob, 8);
	blob.l += 16; /* CLSID */
	var hlink = parse_Hyperlink(blob, length-24);
	return [ref, hlink];
}
function write_HLink(hl) {
	var O = new_buf(24);
	var ref = decode_cell(hl[0]);
	O.write_shift(2, ref.r); O.write_shift(2, ref.r);
	O.write_shift(2, ref.c); O.write_shift(2, ref.c);
	var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
	for(var i = 0; i < 16; ++i) O.write_shift(1, parseInt(clsid[i], 16));
	return bconcat([O, write_Hyperlink(hl[1])]);
}


/* [MS-XLS] 2.4.141 */
function parse_HLinkTooltip(blob, length) {
	blob.read_shift(2);
	var ref = parse_Ref8U(blob, 8);
	var wzTooltip = blob.read_shift((length-10)/2, 'dbcs-cont');
	wzTooltip = wzTooltip.replace(chr0,"");
	return [ref, wzTooltip];
}
function write_HLinkTooltip(hl) {
	var TT = hl[1].Tooltip;
	var O = new_buf(10 + 2 * (TT.length + 1));
	O.write_shift(2, 0x0800);
	var ref = decode_cell(hl[0]);
	O.write_shift(2, ref.r); O.write_shift(2, ref.r);
	O.write_shift(2, ref.c); O.write_shift(2, ref.c);
	for(var i = 0; i < TT.length; ++i) O.write_shift(2, TT.charCodeAt(i));
	O.write_shift(2, 0);
	return O;
}

/* [MS-XLS] 2.4.63 */
function parse_Country(blob) {
	var o = [0,0], d;
	d = blob.read_shift(2); o[0] = CountryEnum[d] || d;
	d = blob.read_shift(2); o[1] = CountryEnum[d] || d;
	return o;
}
function write_Country(o) {
	if(!o) o = new_buf(4);
	o.write_shift(2, 0x01);
	o.write_shift(2, 0x01);
	return o;
}

/* [MS-XLS] 2.4.50 ClrtClient */
function parse_ClrtClient(blob) {
	var ccv = blob.read_shift(2);
	var o = [];
	while(ccv-->0) o.push(parse_LongRGB(blob, 8));
	return o;
}

/* [MS-XLS] 2.4.188 */
function parse_Palette(blob) {
	var ccv = blob.read_shift(2);
	var o = [];
	while(ccv-->0) o.push(parse_LongRGB(blob, 8));
	return o;
}

/* [MS-XLS] 2.4.354 */
function parse_XFCRC(blob) {
	blob.l += 2;
	var o = {cxfs:0, crc:0};
	o.cxfs = blob.read_shift(2);
	o.crc = blob.read_shift(4);
	return o;
}

/* [MS-XLS] 2.4.53 TODO: parse flags */
/* [MS-XLSB] 2.4.323 TODO: parse flags */
function parse_ColInfo(blob, length, opts) {
	if(!opts.cellStyles) return parsenoop(blob, length);
	var w = opts && opts.biff >= 12 ? 4 : 2;
	var colFirst = blob.read_shift(w);
	var colLast = blob.read_shift(w);
	var coldx = blob.read_shift(w);
	var ixfe = blob.read_shift(w);
	var flags = blob.read_shift(2);
	if(w == 2) blob.l += 2;
	return {s:colFirst, e:colLast, w:coldx, ixfe:ixfe, flags:flags};
}

/* [MS-XLS] 2.4.257 */
function parse_Setup(blob, length) {
	var o = {};
	if(length < 32) return o;
	blob.l += 16;
	o.header = parse_Xnum(blob, 8);
	o.footer = parse_Xnum(blob, 8);
	blob.l += 2;
	return o;
}

/* [MS-XLS] 2.4.261 */
function parse_ShtProps(blob, length, opts) {
	var def = {area:false};
	if(opts.biff != 5) { blob.l += length; return def; }
	var d = blob.read_shift(1); blob.l += 3;
	if((d & 0x10)) def.area = true;
	return def;
}

/* [MS-XLS] 2.4.241 */
function write_RRTabId(n) {
	var out = new_buf(2 * n);
	for(var i = 0; i < n; ++i) out.write_shift(2, i+1);
	return out;
}

var parse_Blank = parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */
var parse_Scl = parseuint16a; /* [MS-XLS] 2.4.247 num, den */
var parse_String = parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */

/* --- Specific to versions before BIFF8 --- */
function parse_ImData(blob) {
	var cf = blob.read_shift(2);
	var env = blob.read_shift(2);
	var lcb = blob.read_shift(4);
	var o = {fmt:cf, env:env, len:lcb, data:blob.slice(blob.l,blob.l+lcb)};
	blob.l += lcb;
	return o;
}

/* BIFF2_??? where ??? is the name from [XLS] */
function parse_BIFF2STR(blob, length, opts) {
	var cell = parse_XLSCell(blob, 6);
	++blob.l;
	var str = parse_XLUnicodeString2(blob, length-7, opts);
	cell.t = 'str';
	cell.val = str;
	return cell;
}

function parse_BIFF2NUM(blob) {
	var cell = parse_XLSCell(blob, 6);
	++blob.l;
	var num = parse_Xnum(blob, 8);
	cell.t = 'n';
	cell.val = num;
	return cell;
}
function write_BIFF2NUM(r, c, val) {
	var out = new_buf(15);
	write_BIFF2Cell(out, r, c);
	out.write_shift(8, val, 'f');
	return out;
}

function parse_BIFF2INT(blob) {
	var cell = parse_XLSCell(blob, 6);
	++blob.l;
	var num = blob.read_shift(2);
	cell.t = 'n';
	cell.val = num;
	return cell;
}
function write_BIFF2INT(r, c, val) {
	var out = new_buf(9);
	write_BIFF2Cell(out, r, c);
	out.write_shift(2, val);
	return out;
}

function parse_BIFF2STRING(blob) {
	var cch = blob.read_shift(1);
	if(cch === 0) { blob.l++; return ""; }
	return blob.read_shift(cch, 'sbcs-cont');
}

/* TODO: convert to BIFF8 font struct */
function parse_BIFF2FONTXTRA(blob, length) {
	blob.l += 6; // unknown
	blob.l += 2; // font weight "bls"
	blob.l += 1; // charset
	blob.l += 3; // unknown
	blob.l += 1; // font family
	blob.l += length - 13;
}

/* TODO: parse rich text runs */
function parse_RString(blob, length, opts) {
	var end = blob.l + length;
	var cell = parse_XLSCell(blob, 6);
	var cch = blob.read_shift(2);
	var str = parse_XLUnicodeStringNoCch(blob, cch, opts);
	blob.l = end;
	cell.t = 'str';
	cell.val = str;
	return cell;
}
/* from js-harb (C) 2014-present  SheetJS */
var DBF = (function() {
var dbf_codepage_map = {
	/* Code Pages Supported by Visual FoxPro */
0x01:   437,           0x02:   850,
0x03:  1252,           0x04: 10000,
0x64:   852,           0x65:   866,
0x66:   865,           0x67:   861,
0x68:   895,           0x69:   620,
0x6A:   737,           0x6B:   857,
0x78:   950,           0x79:   949,
0x7A:   936,           0x7B:   932,
0x7C:   874,           0x7D:  1255,
0x7E:  1256,           0x96: 10007,
0x97: 10029,           0x98: 10006,
0xC8:  1250,           0xC9:  1251,
0xCA:  1254,           0xCB:  1253,

	/* shapefile DBF extension */
0x00: 20127,           0x08:   865,
0x09:   437,           0x0A:   850,
0x0B:   437,           0x0D:   437,
0x0E:   850,           0x0F:   437,
0x10:   850,           0x11:   437,
0x12:   850,           0x13:   932,
0x14:   850,           0x15:   437,
0x16:   850,           0x17:   865,
0x18:   437,           0x19:   437,
0x1A:   850,           0x1B:   437,
0x1C:   863,           0x1D:   850,
0x1F:   852,           0x22:   852,
0x23:   852,           0x24:   860,
0x25:   850,           0x26:   866,
0x37:   850,           0x40:   852,
0x4D:   936,           0x4E:   949,
0x4F:   950,           0x50:   874,
0x57:  1252,           0x58:  1252,
0x59:  1252,

0xFF: 16969
};
var dbf_reverse_map = evert({
0x01:   437,           0x02:   850,
0x03:  1252,           0x04: 10000,
0x64:   852,           0x65:   866,
0x66:   865,           0x67:   861,
0x68:   895,           0x69:   620,
0x6A:   737,           0x6B:   857,
0x78:   950,           0x79:   949,
0x7A:   936,           0x7B:   932,
0x7C:   874,           0x7D:  1255,
0x7E:  1256,           0x96: 10007,
0x97: 10029,           0x98: 10006,
0xC8:  1250,           0xC9:  1251,
0xCA:  1254,           0xCB:  1253,
0x00: 20127
});
/* TODO: find an actual specification */
function dbf_to_aoa(buf, opts) {
	var out = [];
	/* TODO: browser based */
	var d = (new_raw_buf(1));
	switch(opts.type) {
		case 'base64': d = s2a(Base64.decode(buf)); break;
		case 'binary': d = s2a(buf); break;
		case 'buffer':
		case 'array': d = buf; break;
	}
	prep_blob(d, 0);
	/* header */
	var ft = d.read_shift(1);
	var memo = false;
	var vfp = false, l7 = false;
	switch(ft) {
		case 0x02: case 0x03: break;
		case 0x30: vfp = true; memo = true; break;
		case 0x31: vfp = true; break;
		case 0x83: memo = true; break;
		case 0x8B: memo = true; break;
		case 0x8C: memo = true; l7 = true; break;
		case 0xF5: memo = true; break;
		default: throw new Error("DBF Unsupported Version: " + ft.toString(16));
	}
	var /*filedate = new Date(),*/ nrow = 0, fpos = 0;
	if(ft == 0x02) nrow = d.read_shift(2);
	/*filedate = new Date(d.read_shift(1) + 1900, d.read_shift(1) - 1, d.read_shift(1));*/d.l += 3;
	if(ft != 0x02) nrow = d.read_shift(4);
	if(ft != 0x02) fpos = d.read_shift(2);
	var rlen = d.read_shift(2);

	var /*flags = 0,*/ current_cp = 1252;
	if(ft != 0x02) {
	d.l+=16;
	/*flags = */d.read_shift(1);
	//if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));

	/* codepage present in FoxPro */
	if(d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
	d.l+=1;

	d.l+=2;
	}
	if(l7) d.l += 36;
var fields = [], field = ({});
	var hend = fpos - 10 - (vfp ? 264 : 0), ww = l7 ? 32 : 11;
	while(ft == 0x02 ? d.l < d.length && d[d.l] != 0x0d: d.l < hend) {
		field = ({});
		field.name = cptable.utils.decode(current_cp, d.slice(d.l, d.l+ww)).replace(/[\u0000\r\n].*$/g,"");
		d.l += ww;
		field.type = String.fromCharCode(d.read_shift(1));
		if(ft != 0x02 && !l7) field.offset = d.read_shift(4);
		field.len = d.read_shift(1);
		if(ft == 0x02) field.offset = d.read_shift(2);
		field.dec = d.read_shift(1);
		if(field.name.length) fields.push(field);
		if(ft != 0x02) d.l += l7 ? 13 : 14;
		switch(field.type) {
			case 'B': // VFP Double
				if((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
				break;
			case 'G': // General
			case 'P': // Picture
				if(opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
				break;
			case 'C': // character
			case 'D': // date
			case 'F': // floating point
			case 'I': // long
			case 'L': // boolean
			case 'M': // memo
			case 'N': // number
			case 'O': // double
			case 'T': // datetime
			case 'Y': // currency
			case '0': // VFP _NullFlags
			case '@': // timestamp
			case '+': // autoincrement
				break;
			default: throw new Error('Unknown Field Type: ' + field.type);
		}
	}
	if(d[d.l] !== 0x0D) d.l = fpos-1;
	else if(ft == 0x02) d.l = 0x209;
	if(ft != 0x02) {
		if(d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
		d.l = fpos;
	}
	/* data */
	var R = 0, C = 0;
	out[0] = [];
	for(C = 0; C != fields.length; ++C) out[0][C] = fields[C].name;
	while(nrow-- > 0) {
		if(d[d.l] === 0x2A) { d.l+=rlen; continue; }
		++d.l;
		out[++R] = []; C = 0;
		for(C = 0; C != fields.length; ++C) {
			var dd = d.slice(d.l, d.l+fields[C].len); d.l+=fields[C].len;
			prep_blob(dd, 0);
			var s = cptable.utils.decode(current_cp, dd);
			switch(fields[C].type) {
				case 'C':
					out[R][C] = cptable.utils.decode(current_cp, dd);
					out[R][C] = out[R][C].trim();
					break;
				case 'D':
					if(s.length === 8) out[R][C] = new Date(+s.slice(0,4), +s.slice(4,6)-1, +s.slice(6,8));
					else out[R][C] = s;
					break;
				case 'F': out[R][C] = parseFloat(s.trim()); break;
				case '+': case 'I': out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i'); break;
				case 'L': switch(s.toUpperCase()) {
					case 'Y': case 'T': out[R][C] = true; break;
					case 'N': case 'F': out[R][C] = false; break;
					case ' ': case '?': out[R][C] = false; break; /* NOTE: technically uninitialized */
					default: throw new Error("DBF Unrecognized L:|" + s + "|");
					} break;
				case 'M': /* TODO: handle memo files */
					if(!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
					out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10): dd.read_shift(4));
					break;
				case 'N': out[R][C] = +s.replace(/\u0000/g,"").trim(); break;
				case '@': out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400); break;
				case 'T': out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4)); break;
				case 'Y': out[R][C] = dd.read_shift(4,'i')/1e4; break;
				case 'O': out[R][C] = -dd.read_shift(-8, 'f'); break;
				case 'B': if(vfp && fields[C].len == 8) { out[R][C] = dd.read_shift(8,'f'); break; }
					/* falls through */
				case 'G': case 'P': dd.l += fields[C].len; break;
				case '0':
					if(fields[C].name === '_NullFlags') break;
					/* falls through */
				default: throw new Error("DBF Unsupported data type " + fields[C].type);
			}
		}
	}
	if(ft != 0x02) if(d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l-1) + " of " + d.length + " " + d[d.l-1].toString(16));
	if(opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
	return out;
}

function dbf_to_sheet(buf, opts) {
	var o = opts || {};
	if(!o.dateNF) o.dateNF = "yyyymmdd";
	return aoa_to_sheet(dbf_to_aoa(buf, o), o);
}

function dbf_to_workbook(buf, opts) {
	try { return sheet_to_workbook(dbf_to_sheet(buf, opts), opts); }
	catch(e) { if(opts && opts.WTF) throw e; }
	return ({SheetNames:[],Sheets:{}});
}

var _RLEN = { 'B': 8, 'C': 250, 'L': 1, 'D': 8, '?': 0, '': 0 };
function sheet_to_dbf(ws, opts) {
	var o = opts || {};
	if(+o.codepage >= 0) set_cp(+o.codepage);
	if(o.type == "string") throw new Error("Cannot write DBF to JS string");
	var ba = buf_array();
	var aoa = sheet_to_json(ws, {header:1, raw:true, cellDates:true});
	var headers = aoa[0], data = aoa.slice(1);
	var i = 0, j = 0, hcnt = 0, rlen = 1;
	for(i = 0; i < headers.length; ++i) {
		if(i == null) continue;
		++hcnt;
		if(typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
		if(typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + (typeof headers[i]) + "|");
		if(headers.indexOf(headers[i]) !== i) for(j=0; j<1024;++j)
			if(headers.indexOf(headers[i] + "_" + j) == -1) { headers[i] += "_" + j; break; }
	}
	var range = safe_decode_range(ws['!ref']);
	var coltypes = [];
	for(i = 0; i <= range.e.c - range.s.c; ++i) {
		var col = [];
		for(j=0; j < data.length; ++j) {
			if(data[j][i] != null) col.push(data[j][i]);
		}
		if(col.length == 0 || headers[i] == null) { coltypes[i] = '?'; continue; }
		var guess = '', _guess = '';
		for(j = 0; j < col.length; ++j) {
			switch(typeof col[j]) {
				/* TODO: check if L2 compat is desired */
				case 'number': _guess = 'B'; break;
				case 'string': _guess = 'C'; break;
				case 'boolean': _guess = 'L'; break;
				case 'object': _guess = col[j] instanceof Date ? 'D' : 'C'; break;
				default: _guess = 'C';
			}
			guess = guess && guess != _guess ? 'C' : _guess;
			if(guess == 'C') break;
		}
		rlen += _RLEN[guess] || 0;
		coltypes[i] = guess;
	}

	var h = ba.next(32);
	h.write_shift(4, 0x13021130);
	h.write_shift(4, data.length);
	h.write_shift(2, 296 + 32 * hcnt);
	h.write_shift(2, rlen);
	for(i=0; i < 4; ++i) h.write_shift(4, 0);
	h.write_shift(4, 0x00000000 | ((+dbf_reverse_map[current_ansi] || 0x03)<<8));

	for(i = 0, j = 0; i < headers.length; ++i) {
		if(headers[i] == null) continue;
		var hf = ba.next(32);
		var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
		hf.write_shift(1, _f, "sbcs");
		hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
		hf.write_shift(4, j);
		hf.write_shift(1, _RLEN[coltypes[i]] || 0);
		hf.write_shift(1, 0);
		hf.write_shift(1, 0x02);
		hf.write_shift(4, 0);
		hf.write_shift(1, 0);
		hf.write_shift(4, 0);
		hf.write_shift(4, 0);
		j += _RLEN[coltypes[i]] || 0;
	}

	var hb = ba.next(264);
	hb.write_shift(4, 0x0000000D);
	for(i=0; i < 65;++i) hb.write_shift(4, 0x00000000);
	for(i=0; i < data.length; ++i) {
		var rout = ba.next(rlen);
		rout.write_shift(1, 0);
		for(j=0; j<headers.length; ++j) {
			if(headers[j] == null) continue;
			switch(coltypes[j]) {
				case 'L': rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46); break;
				case 'B': rout.write_shift(8, data[i][j]||0, 'f'); break;
				case 'D':
					if(!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
					else {
						rout.write_shift(4, ("0000"+data[i][j].getFullYear()).slice(-4), "sbcs");
						rout.write_shift(2, ("00"+(data[i][j].getMonth()+1)).slice(-2), "sbcs");
						rout.write_shift(2, ("00"+data[i][j].getDate()).slice(-2), "sbcs");
					} break;
				case 'C':
					var _s = String(data[i][j]||"");
					rout.write_shift(1, _s, "sbcs");
					for(hcnt=0; hcnt < 250-_s.length; ++hcnt) rout.write_shift(1, 0x20); break;
			}
		}
		// data
	}
	ba.next(1).write_shift(1, 0x1A);
	return ba.end();
}
	return {
		to_workbook: dbf_to_workbook,
		to_sheet: dbf_to_sheet,
		from_sheet: sheet_to_dbf
	};
})();

var SYLK = (function() {
	/* TODO: stress test sequences */
	var sylk_escapes = {
		AA:'À', BA:'Á', CA:'Â', DA:195, HA:'Ä', JA:197,
		AE:'È', BE:'É', CE:'Ê',         HE:'Ë',
		AI:'Ì', BI:'Í', CI:'Î',         HI:'Ï',
		AO:'Ò', BO:'Ó', CO:'Ô', DO:213, HO:'Ö',
		AU:'Ù', BU:'Ú', CU:'Û',         HU:'Ü',
		Aa:'à', Ba:'á', Ca:'â', Da:227, Ha:'ä', Ja:229,
		Ae:'è', Be:'é', Ce:'ê',         He:'ë',
		Ai:'ì', Bi:'í', Ci:'î',         Hi:'ï',
		Ao:'ò', Bo:'ó', Co:'ô', Do:245, Ho:'ö',
		Au:'ù', Bu:'ú', Cu:'û',         Hu:'ü',
		KC:'Ç', Kc:'ç', q:'æ',  z:'œ',  a:'Æ',  j:'Œ',
		DN:209, Dn:241, Hy:255,
		S:169,  c:170,  R:174,  0:176,  1:177,  2:178,  3:179,  B:180,  5:181,
		6:182,  7:183,  Q:185,  k:186,  b:208,  i:216,  l:222,  s:240,  y:248,
		"!":161, '"':162, "#":163, "(":164, "%":165, "'":167, "H ":168,
		"+":171, ";":187, "<":188, "=":189, ">":190, "?":191, "{":223
	};
	var sylk_char_regex = new RegExp("\u001BN(" + keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g,"\\$1") + "|\\|)", "gm");
	var sylk_char_fn = function(_, $1){ var o = sylk_escapes[$1]; return typeof o == "number" ? _getansi(o) : o; };
	var decode_sylk_char = function($$, $1, $2) { var newcc = (($1.charCodeAt(0) - 0x20)<<4) | ($2.charCodeAt(0) - 0x30); return newcc == 59 ? $$ : _getansi(newcc); };
	sylk_escapes["|"] = 254;
	/* TODO: find an actual specification */
	function sylk_to_aoa(d, opts) {
		switch(opts.type) {
			case 'base64': return sylk_to_aoa_str(Base64.decode(d), opts);
			case 'binary': return sylk_to_aoa_str(d, opts);
			case 'buffer': return sylk_to_aoa_str(d.toString('binary'), opts);
			case 'array': return sylk_to_aoa_str(cc2str(d), opts);
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	function sylk_to_aoa_str(str, opts) {
		var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr = [];
		var formats = [];
		var next_cell_format = null;
		var sht = {}, rowinfo = [], colinfo = [], cw = [];
		var Mval = 0, j;
		if(+opts.codepage >= 0) set_cp(+opts.codepage);
		for (; ri !== records.length; ++ri) {
			Mval = 0;
			var rstr=records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
			var record=rstr.replace(/;;/g, "\u0000").split(";").map(function(x) { return x.replace(/\u0000/g, ";"); });
			var RT=record[0], val;
			if(rstr.length > 0) switch(RT) {
			case 'ID': break; /* header */
			case 'E': break; /* EOF */
			case 'B': break; /* dimensions */
			case 'O': break; /* options? */
			case 'P':
				if(record[1].charAt(0) == 'P')
					formats.push(rstr.slice(3).replace(/;;/g, ";"));
				break;
			case 'C':
			var C_seen_K = false, C_seen_X = false;
			for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
				case 'X': C = parseInt(record[rj].slice(1))-1; C_seen_X = true; break;
				case 'Y':
					R = parseInt(record[rj].slice(1))-1; if(!C_seen_X) C = 0;
					for(j = arr.length; j <= R; ++j) arr[j] = [];
					break;
				case 'K':
					val = record[rj].slice(1);
					if(val.charAt(0) === '"') val = val.slice(1,val.length - 1);
					else if(val === 'TRUE') val = true;
					else if(val === 'FALSE') val = false;
					else if(!isNaN(fuzzynum(val))) {
						val = fuzzynum(val);
						if(next_cell_format !== null && SSF.is_date(next_cell_format)) val = numdate(val);
					} else if(!isNaN(fuzzydate(val).getDate())) {
						val = parseDate(val);
					}
					if(typeof cptable !== 'undefined' && typeof val == "string" && ((opts||{}).type != "string") && (opts||{}).codepage) val = cptable.utils.decode(opts.codepage, val);
					C_seen_K = true;
					break;
				case 'E':
					var formula = rc_to_a1(record[rj].slice(1), {r:R,c:C});
					arr[R][C] = [arr[R][C], formula];
					break;
				default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
			}
			if(C_seen_K) { arr[R][C] = val; next_cell_format = null; }
			break;
			case 'F':
			var F_seen = 0;
			for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
				case 'X': C = parseInt(record[rj].slice(1))-1; ++F_seen; break;
				case 'Y':
					R = parseInt(record[rj].slice(1))-1; /*C = 0;*/
					for(j = arr.length; j <= R; ++j) arr[j] = [];
					break;
				case 'M': Mval = parseInt(record[rj].slice(1)) / 20; break;
				case 'F': break; /* ??? */
				case 'G': break; /* hide grid */
				case 'P':
					next_cell_format = formats[parseInt(record[rj].slice(1))];
					break;
				case 'S': break; /* cell style */
				case 'D': break; /* column */
				case 'N': break; /* font */
				case 'W':
					cw = record[rj].slice(1).split(" ");
					for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j) {
						Mval = parseInt(cw[2], 10);
						colinfo[j-1] = Mval === 0 ? {hidden:true}: {wch:Mval}; process_col(colinfo[j-1]);
					} break;
				case 'C': /* default column format */
					C = parseInt(record[rj].slice(1))-1;
					if(!colinfo[C]) colinfo[C] = {};
					break;
				case 'R': /* row properties */
					R = parseInt(record[rj].slice(1))-1;
					if(!rowinfo[R]) rowinfo[R] = {};
					if(Mval > 0) { rowinfo[R].hpt = Mval; rowinfo[R].hpx = pt2px(Mval); }
					else if(Mval === 0) rowinfo[R].hidden = true;
					break;
				default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
			}
			if(F_seen < 1) next_cell_format = null; break;
			default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
			}
		}
		if(rowinfo.length > 0) sht['!rows'] = rowinfo;
		if(colinfo.length > 0) sht['!cols'] = colinfo;
		if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
		return [arr, sht];
	}

	function sylk_to_sheet(d, opts) {
		var aoasht = sylk_to_aoa(d, opts);
		var aoa = aoasht[0], ws = aoasht[1];
		var o = aoa_to_sheet(aoa, opts);
		keys(ws).forEach(function(k) { o[k] = ws[k]; });
		return o;
	}

	function sylk_to_workbook(d, opts) { return sheet_to_workbook(sylk_to_sheet(d, opts), opts); }

	function write_ws_cell_sylk(cell, ws, R, C) {
		var o = "C;Y" + (R+1) + ";X" + (C+1) + ";K";
		switch(cell.t) {
			case 'n':
				o += (cell.v||0);
				if(cell.f && !cell.F) o += ";E" + a1_to_rc(cell.f, {r:R, c:C}); break;
			case 'b': o += cell.v ? "TRUE" : "FALSE"; break;
			case 'e': o += cell.w || cell.v; break;
			case 'd': o += '"' + (cell.w || cell.v) + '"'; break;
			case 's': o += '"' + cell.v.replace(/"/g,"") + '"'; break;
		}
		return o;
	}

	function write_ws_cols_sylk(out, cols) {
		cols.forEach(function(col, i) {
			var rec = "F;W" + (i+1) + " " + (i+1) + " ";
			if(col.hidden) rec += "0";
			else {
				if(typeof col.width == 'number') col.wpx = width2px(col.width);
				if(typeof col.wpx == 'number') col.wch = px2char(col.wpx);
				if(typeof col.wch == 'number') rec += Math.round(col.wch);
			}
			if(rec.charAt(rec.length - 1) != " ") out.push(rec);
		});
	}

	function write_ws_rows_sylk(out, rows) {
		rows.forEach(function(row, i) {
			var rec = "F;";
			if(row.hidden) rec += "M0;";
			else if(row.hpt) rec += "M" + 20 * row.hpt + ";";
			else if(row.hpx) rec += "M" + 20 * px2pt(row.hpx) + ";";
			if(rec.length > 2) out.push(rec + "R" + (i+1));
		});
	}

	function sheet_to_sylk(ws, opts) {
		var preamble = ["ID;PWXL;N;E"], o = [];
		var r = safe_decode_range(ws['!ref']), cell;
		var dense = Array.isArray(ws);
		var RS = "\r\n";

		preamble.push("P;PGeneral");
		preamble.push("F;P0;DG0G8;M255");
		if(ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
		if(ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);

		preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [r.s.c,r.s.r,r.e.c,r.e.r].join(" "));
		for(var R = r.s.r; R <= r.e.r; ++R) {
			for(var C = r.s.c; C <= r.e.c; ++C) {
				var coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C]: ws[coord];
				if(!cell || (cell.v == null && (!cell.f || cell.F))) continue;
				o.push(write_ws_cell_sylk(cell, ws, R, C, opts));
			}
		}
		return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
	}

	return {
		to_workbook: sylk_to_workbook,
		to_sheet: sylk_to_sheet,
		from_sheet: sheet_to_sylk
	};
})();

var DIF = (function() {
	function dif_to_aoa(d, opts) {
		switch(opts.type) {
			case 'base64': return dif_to_aoa_str(Base64.decode(d), opts);
			case 'binary': return dif_to_aoa_str(d, opts);
			case 'buffer': return dif_to_aoa_str(d.toString('binary'), opts);
			case 'array': return dif_to_aoa_str(cc2str(d), opts);
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	function dif_to_aoa_str(str, opts) {
		var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
		for (; ri !== records.length; ++ri) {
			if (records[ri].trim() === 'BOT') { arr[++R] = []; C = 0; continue; }
			if (R < 0) continue;
			var metadata = records[ri].trim().split(",");
			var type = metadata[0], value = metadata[1];
			++ri;
			var data = records[ri].trim();
			switch (+type) {
				case -1:
					if (data === 'BOT') { arr[++R] = []; C = 0; continue; }
					else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
					break;
				case 0:
					if(data === 'TRUE') arr[R][C] = true;
					else if(data === 'FALSE') arr[R][C] = false;
					else if(!isNaN(fuzzynum(value))) arr[R][C] = fuzzynum(value);
					else if(!isNaN(fuzzydate(value).getDate())) arr[R][C] = parseDate(value);
					else arr[R][C] = value;
					++C; break;
				case 1:
					data = data.slice(1,data.length-1);
					arr[R][C++] = data !== '' ? data : null;
					break;
			}
			if (data === 'EOD') break;
		}
		if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
		return arr;
	}

	function dif_to_sheet(str, opts) { return aoa_to_sheet(dif_to_aoa(str, opts), opts); }
	function dif_to_workbook(str, opts) { return sheet_to_workbook(dif_to_sheet(str, opts), opts); }

	var sheet_to_dif = (function() {
		var push_field = function pf(o, topic, v, n, s) {
			o.push(topic);
			o.push(v + "," + n);
			o.push('"' + s.replace(/"/g,'""') + '"');
		};
		var push_value = function po(o, type, v, s) {
			o.push(type + "," + v);
			o.push(type == 1 ? '"' + s.replace(/"/g,'""') + '"' : s);
		};
		return function sheet_to_dif(ws) {
			var o = [];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			push_field(o, "TABLE", 0, 1, "sheetjs");
			push_field(o, "VECTORS", 0, r.e.r - r.s.r + 1,"");
			push_field(o, "TUPLES", 0, r.e.c - r.s.c + 1,"");
			push_field(o, "DATA", 0, 0,"");
			for(var R = r.s.r; R <= r.e.r; ++R) {
				push_value(o, -1, 0, "BOT");
				for(var C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C] : ws[coord];
					if(!cell) { push_value(o, 1, 0, ""); continue;}
					switch(cell.t) {
						case 'n':
							var val = DIF_XL ? cell.w : cell.v;
							if(!val && cell.v != null) val = cell.v;
							if(val == null) {
								if(DIF_XL && cell.f && !cell.F) push_value(o, 1, 0, "=" + cell.f);
								else push_value(o, 1, 0, "");
							}
							else push_value(o, 0, val, "V");
							break;
						case 'b':
							push_value(o, 0, cell.v ? 1 : 0, cell.v ? "TRUE" : "FALSE");
							break;
						case 's':
							push_value(o, 1, 0, (!DIF_XL || isNaN(cell.v)) ? cell.v : '="' + cell.v + '"');
							break;
						case 'd':
							if(!cell.w) cell.w = SSF.format(cell.z || SSF._table[14], datenum(parseDate(cell.v)));
							if(DIF_XL) push_value(o, 0, cell.w, "V");
							else push_value(o, 1, 0, cell.w);
							break;
						default: push_value(o, 1, 0, "");
					}
				}
			}
			push_value(o, -1, 0, "EOD");
			var RS = "\r\n";
			var oo = o.join(RS);
			//while((oo.length & 0x7F) != 0) oo += "\0";
			return oo;
		};
	})();
	return {
		to_workbook: dif_to_workbook,
		to_sheet: dif_to_sheet,
		from_sheet: sheet_to_dif
	};
})();

var ETH = (function() {
	function decode(s) { return s.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n"); }
	function encode(s) { return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g,"\\n"); }

	function eth_to_aoa(str, opts) {
		var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
		for (; ri !== records.length; ++ri) {
			var record = records[ri].trim().split(":");
			if(record[0] !== 'cell') continue;
			var addr = decode_cell(record[1]);
			if(arr.length <= addr.r) for(R = arr.length; R <= addr.r; ++R) if(!arr[R]) arr[R] = [];
			R = addr.r; C = addr.c;
			switch(record[2]) {
				case 't': arr[R][C] = decode(record[3]); break;
				case 'v': arr[R][C] = +record[3]; break;
				case 'vtf': var _f = record[record.length - 1];
					/* falls through */
				case 'vtc':
					switch(record[3]) {
						case 'nl': arr[R][C] = +record[4] ? true : false; break;
						default: arr[R][C] = +record[4]; break;
					}
					if(record[2] == 'vtf') arr[R][C] = [arr[R][C], _f];
			}
		}
		if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
		return arr;
	}

	function eth_to_sheet(d, opts) { return aoa_to_sheet(eth_to_aoa(d, opts), opts); }
	function eth_to_workbook(d, opts) { return sheet_to_workbook(eth_to_sheet(d, opts), opts); }

	var header = [
		"socialcalc:version:1.5",
		"MIME-Version: 1.0",
		"Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
	].join("\n");

	var sep = [
		"--SocialCalcSpreadsheetControlSave",
		"Content-type: text/plain; charset=UTF-8"
	].join("\n") + "\n";

	/* TODO: the other parts */
	var meta = [
		"# SocialCalc Spreadsheet Control Save",
		"part:sheet"
	].join("\n");

	var end = "--SocialCalcSpreadsheetControlSave--";

	function sheet_to_eth_data(ws) {
		if(!ws || !ws['!ref']) return "";
		var o = [], oo = [], cell, coord = "";
		var r = decode_range(ws['!ref']);
		var dense = Array.isArray(ws);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			for(var C = r.s.c; C <= r.e.c; ++C) {
				coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C] : ws[coord];
				if(!cell || cell.v == null || cell.t === 'z') continue;
				oo = ["cell", coord, 't'];
				switch(cell.t) {
					case 's': case 'str': oo.push(encode(cell.v)); break;
					case 'n':
						if(!cell.f) { oo[2]='v'; oo[3]=cell.v; }
						else { oo[2]='vtf'; oo[3]='n'; oo[4]=cell.v; oo[5]=encode(cell.f); }
						break;
					case 'b':
						oo[2] = 'vt'+(cell.f?'f':'c'); oo[3]='nl'; oo[4]=cell.v?"1":"0";
						oo[5] = encode(cell.f||(cell.v?'TRUE':'FALSE'));
						break;
					case 'd':
						var t = datenum(parseDate(cell.v));
						oo[2] = 'vtc'; oo[3] = 'nd'; oo[4] = ""+t;
						oo[5] = cell.w || SSF.format(cell.z || SSF._table[14], t);
						break;
					case 'e': continue;
				}
				o.push(oo.join(":"));
			}
		}
		o.push("sheet:c:" + (r.e.c-r.s.c+1) + ":r:" + (r.e.r-r.s.r+1) + ":tvf:1");
		o.push("valueformat:1:text-wiki");
		//o.push("copiedfrom:" + ws['!ref']); // clipboard only
		return o.join("\n");
	}

	function sheet_to_eth(ws) {
		return [header, sep, meta, sep, sheet_to_eth_data(ws), end].join("\n");
		// return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
	}

	return {
		to_workbook: eth_to_workbook,
		to_sheet: eth_to_sheet,
		from_sheet: sheet_to_eth
	};
})();

var PRN = (function() {
	function set_text_arr(data, arr, R, C, o) {
		if(o.raw) arr[R][C] = data;
		else if(data === 'TRUE') arr[R][C] = true;
		else if(data === 'FALSE') arr[R][C] = false;
		else if(data === ""){/* empty */}
		else if(!isNaN(fuzzynum(data))) arr[R][C] = fuzzynum(data);
		else if(!isNaN(fuzzydate(data).getDate())) arr[R][C] = parseDate(data);
		else arr[R][C] = data;
	}

	function prn_to_aoa_str(f, opts) {
		var o = opts || {};
		var arr = ([]);
		if(!f || f.length === 0) return arr;
		var lines = f.split(/[\r\n]/);
		var L = lines.length - 1;
		while(L >= 0 && lines[L].length === 0) --L;
		var start = 10, idx = 0;
		var R = 0;
		for(; R <= L; ++R) {
			idx = lines[R].indexOf(" ");
			if(idx == -1) idx = lines[R].length; else idx++;
			start = Math.max(start, idx);
		}
		for(R = 0; R <= L; ++R) {
			arr[R] = [];
			/* TODO: confirm that widths are always 10 */
			var C = 0;
			set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
			for(C = 1; C <= (lines[R].length - start)/10 + 1; ++C)
				set_text_arr(lines[R].slice(start+(C-1)*10,start+C*10).trim(),arr,R,C,o);
		}
		if(o.sheetRows) arr = arr.slice(0, o.sheetRows);
		return arr;
	}

	// List of accepted CSV separators
	var guess_seps = {
0x2C: ',',
0x09: "\t",
0x3B: ';'
	};

	// CSV separator weights to be used in case of equal numbers
	var guess_sep_weights = {
0x2C: 3,
0x09: 2,
0x3B: 1
	};

	function guess_sep(str) {
		var cnt = {}, instr = false, end = 0, cc = 0;
		for(;end < str.length;++end) {
			if((cc=str.charCodeAt(end)) == 0x22) instr = !instr;
			else if(!instr && cc in guess_seps) cnt[cc] = (cnt[cc]||0)+1;
		}

		cc = [];
		for(end in cnt) if ( cnt.hasOwnProperty(end) ) {
			cc.push([ cnt[end], end ]);
		}

		if ( !cc.length ) {
			cnt = guess_sep_weights;
			for(end in cnt) if ( cnt.hasOwnProperty(end) ) {
				cc.push([ cnt[end], end ]);
			}
		}

		cc.sort(function(a, b) { return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]]; });

		return guess_seps[cc.pop()[1]];
	}

	function dsv_to_sheet_str(str, opts) {
		var o = opts || {};
		var sep = "";
		if(DENSE != null && o.dense == null) o.dense = DENSE;
		var ws = o.dense ? ([]) : ({});
		var range = ({s: {c:0, r:0}, e: {c:0, r:0}});

		if(str.slice(0,4) == "sep=" && str.charCodeAt(5) == 10) { sep = str.charAt(4); str = str.slice(6); }
		else sep = guess_sep(str.slice(0,1024));
		var R = 0, C = 0, v = 0;
		var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc=0;
		str = str.replace(/\r\n/mg, "\n");
		var _re = o.dateNF != null ? dateNF_regex(o.dateNF) : null;
		function finish_cell() {
			var s = str.slice(start, end);
			var cell = ({});
			if(s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1,-1).replace(/""/g,'"');
			if(s.length === 0) cell.t = 'z';
			else if(o.raw) { cell.t = 's'; cell.v = s; }
			else if(s.trim().length === 0) { cell.t = 's'; cell.v = s; }
			else if(s.charCodeAt(0) == 0x3D) {
				if(s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) { cell.t = 's'; cell.v = s.slice(2,-1).replace(/""/g,'"'); }
				else if(fuzzyfmla(s)) { cell.t = 'n'; cell.f = s.slice(1); }
				else { cell.t = 's'; cell.v = s; } }
			else if(s == "TRUE") { cell.t = 'b'; cell.v = true; }
			else if(s == "FALSE") { cell.t = 'b'; cell.v = false; }
			else if(!isNaN(v = fuzzynum(s))) { cell.t = 'n'; if(o.cellText !== false) cell.w = s; cell.v = v; }
			else if(!isNaN(fuzzydate(s).getDate()) || _re && s.match(_re)) {
				cell.z = o.dateNF || SSF._table[14];
				var k = 0;
				if(_re && s.match(_re)){ s=dateNF_fix(s, o.dateNF, (s.match(_re)||[])); k=1; }
				if(o.cellDates) { cell.t = 'd'; cell.v = parseDate(s, k); }
				else { cell.t = 'n'; cell.v = datenum(parseDate(s, k)); }
				if(o.cellText !== false) cell.w = SSF.format(cell.z, cell.v instanceof Date ? datenum(cell.v):cell.v);
				if(!o.cellNF) delete cell.z;
			} else {
				cell.t = 's';
				cell.v = s;
			}
			if(cell.t == 'z'){}
			else if(o.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = cell; }
			else ws[encode_cell({c:C,r:R})] = cell;
			start = end+1;
			if(range.e.c < C) range.e.c = C;
			if(range.e.r < R) range.e.r = R;
			if(cc == sepcc) ++C; else { C = 0; ++R; if(o.sheetRows && o.sheetRows <= R) return true; }
		}
		outer: for(;end < str.length;++end) switch((cc=str.charCodeAt(end))) {
			case 0x22: instr = !instr; break;
			case sepcc: case 0x0a: case 0x0d: if(!instr && finish_cell()) break outer; break;
			default: break;
		}
		if(end - start > 0) finish_cell();

		ws['!ref'] = encode_range(range);
		return ws;
	}

	function prn_to_sheet_str(str, opts) {
		if(str.slice(0,4) == "sep=") return dsv_to_sheet_str(str, opts);
		if(str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
		return aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
	}

	function prn_to_sheet(d, opts) {
		var str = "", bytes = opts.type == 'string' ? [0,0,0,0] : firstbyte(d, opts);
		switch(opts.type) {
			case 'base64': str = Base64.decode(d); break;
			case 'binary': str = d; break;
			case 'buffer':
				if(opts.codepage == 65001) str = d.toString('utf8');
				else if(opts.codepage && typeof cptable !== 'undefined') str = cptable.utils.decode(opts.codepage, d);
				else str = d.toString('binary');
				break;
			case 'array': str = cc2str(d); break;
			case 'string': str = d; break;
			default: throw new Error("Unrecognized type " + opts.type);
		}
		if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str.slice(3));
		else if((opts.type == 'binary') && typeof cptable !== 'undefined' && opts.codepage)  str = cptable.utils.decode(opts.codepage, cptable.utils.encode(1252,str));
		if(str.slice(0,19) == "socialcalc:version:") return ETH.to_sheet(opts.type == 'string' ? str : utf8read(str), opts);
		return prn_to_sheet_str(str, opts);
	}

	function prn_to_workbook(d, opts) { return sheet_to_workbook(prn_to_sheet(d, opts), opts); }

	function sheet_to_prn(ws) {
		var o = [];
		var r = safe_decode_range(ws['!ref']), cell;
		var dense = Array.isArray(ws);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			var oo = [];
			for(var C = r.s.c; C <= r.e.c; ++C) {
				var coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C] : ws[coord];
				if(!cell || cell.v == null) { oo.push("          "); continue; }
				var w = (cell.w || (format_cell(cell), cell.w) || "").slice(0,10);
				while(w.length < 10) w += " ";
				oo.push(w + (C === 0 ? " " : ""));
			}
			o.push(oo.join(""));
		}
		return o.join("\n");
	}

	return {
		to_workbook: prn_to_workbook,
		to_sheet: prn_to_sheet,
		from_sheet: sheet_to_prn
	};
})();

/* Excel defaults to SYLK but warns if data is not valid */
function read_wb_ID(d, opts) {
	var o = opts || {}, OLD_WTF = !!o.WTF; o.WTF = true;
	try {
		var out = SYLK.to_workbook(d, o);
		o.WTF = OLD_WTF;
		return out;
	} catch(e) {
		o.WTF = OLD_WTF;
		if(!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
		return PRN.to_workbook(d, opts);
	}
}

var WK_ = (function() {
	function lotushopper(data, cb, opts) {
		if(!data) return;
		prep_blob(data, data.l || 0);
		var Enum = opts.Enum || WK1Enum;
		while(data.l < data.length) {
			var RT = data.read_shift(2);
			var R = Enum[RT] || Enum[0xFF];
			var length = data.read_shift(2);
			var tgt = data.l + length;
			var d = (R.f||parsenoop)(data, length, opts);
			data.l = tgt;
			if(cb(d, R.n, RT)) return;
		}
	}

	function lotus_to_workbook(d, opts) {
		switch(opts.type) {
			case 'base64': return lotus_to_workbook_buf(s2a(Base64.decode(d)), opts);
			case 'binary': return lotus_to_workbook_buf(s2a(d), opts);
			case 'buffer':
			case 'array': return lotus_to_workbook_buf(d, opts);
		}
		throw "Unsupported type " + opts.type;
	}

	function lotus_to_workbook_buf(d, opts) {
		if(!d) return d;
		var o = opts || {};
		if(DENSE != null && o.dense == null) o.dense = DENSE;
		var s = ((o.dense ? [] : {})), n = "Sheet1", sidx = 0;
		var sheets = {}, snames = [n];

		var refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
		var sheetRows = o.sheetRows || 0;

		if(d[2] == 0x02) o.Enum = WK1Enum;
		else if(d[2] == 0x1a) o.Enum = WK3Enum;
		else if(d[2] == 0x0e) { o.Enum = WK3Enum; o.qpro = true; d.l = 0; }
		else throw new Error("Unrecognized LOTUS BOF " + d[2]);
		lotushopper(d, function(val, Rn, RT) {
			if(d[2] == 0x02) switch(RT) {
				case 0x00:
					o.vers = val;
					if(val >= 0x1000) o.qpro = true;
					break;
				case 0x06: refguess = val; break; /* RANGE */
				case 0x0F: /* LABEL */
					if(!o.qpro) val[1].v = val[1].v.slice(1);
					/* falls through */
				case 0x0D: /* INTEGER */
				case 0x0E: /* NUMBER */
				case 0x10: /* FORMULA */
				case 0x33: /* STRING */
					/* TODO: actual translation of the format code */
					if(RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
						val[1].z = o.dateNF || SSF._table[14];
						if(o.cellDates) { val[1].t = 'd'; val[1].v = numdate(val[1].v); }
					}
					if(o.dense) {
						if(!s[val[0].r]) s[val[0].r] = [];
						s[val[0].r][val[0].c] = val[1];
					} else s[encode_cell(val[0])] = val[1];
					break;
			} else switch(RT) {
				case 0x16: /* LABEL16 */
					val[1].v = val[1].v.slice(1);
					/* falls through */
				case 0x17: /* NUMBER17 */
				case 0x18: /* NUMBER18 */
				case 0x19: /* FORMULA19 */
				case 0x25: /* NUMBER25 */
				case 0x27: /* NUMBER27 */
				case 0x28: /* FORMULA28 */
					if(val[3] > sidx) {
						s["!ref"] = encode_range(refguess);
						sheets[n] = s;
						s = (o.dense ? [] : {});
						refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
						sidx = val[3]; n = "Sheet" + (sidx + 1);
						snames.push(n);
					}
					if(sheetRows > 0 && val[0].r >= sheetRows) break;
					if(o.dense) {
						if(!s[val[0].r]) s[val[0].r] = [];
						s[val[0].r][val[0].c] = val[1];
					} else s[encode_cell(val[0])] = val[1];
					if(refguess.e.c < val[0].c) refguess.e.c = val[0].c;
					if(refguess.e.r < val[0].r) refguess.e.r = val[0].r;
					break;
				default: break;
			}
		}, o);

		s["!ref"] = encode_range(refguess);
		sheets[n] = s;
		return { SheetNames: snames, Sheets:sheets };
	}

	function parse_RANGE(blob) {
		var o = {s:{c:0,r:0},e:{c:0,r:0}};
		o.s.c = blob.read_shift(2);
		o.s.r = blob.read_shift(2);
		o.e.c = blob.read_shift(2);
		o.e.r = blob.read_shift(2);
		if(o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
		return o;
	}

	function parse_cell(blob, length, opts) {
		var o = [{c:0,r:0}, {t:'n',v:0}, 0];
		if(opts.qpro && opts.vers != 0x5120) {
			o[0].c = blob.read_shift(1);
			blob.l++;
			o[0].r = blob.read_shift(2);
			blob.l+=2;
		} else {
			o[2] = blob.read_shift(1);
			o[0].c = blob.read_shift(2); o[0].r = blob.read_shift(2);
		}
		return o;
	}

	function parse_LABEL(blob, length, opts) {
		var tgt = blob.l + length;
		var o = parse_cell(blob, length, opts);
		o[1].t = 's';
		if(opts.vers == 0x5120) {
			blob.l++;
			var len = blob.read_shift(1);
			o[1].v = blob.read_shift(len, 'utf8');
			return o;
		}
		if(opts.qpro) blob.l++;
		o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
		return o;
	}

	function parse_INTEGER(blob, length, opts) {
		var o = parse_cell(blob, length, opts);
		o[1].v = blob.read_shift(2, 'i');
		return o;
	}

	function parse_NUMBER(blob, length, opts) {
		var o = parse_cell(blob, length, opts);
		o[1].v = blob.read_shift(8, 'f');
		return o;
	}

	function parse_FORMULA(blob, length, opts) {
		var tgt = blob.l + length;
		var o = parse_cell(blob, length, opts);
		/* TODO: formula */
		o[1].v = blob.read_shift(8, 'f');
		if(opts.qpro) blob.l = tgt;
		else {
			var flen = blob.read_shift(2);
			blob.l += flen;
		}
		return o;
	}

	function parse_cell_3(blob) {
		var o = [{c:0,r:0}, {t:'n',v:0}, 0];
		o[0].r = blob.read_shift(2); o[3] = blob[blob.l++]; o[0].c = blob[blob.l++];
		return o;
	}

	function parse_LABEL_16(blob, length) {
		var o = parse_cell_3(blob, length);
		o[1].t = 's';
		o[1].v = blob.read_shift(length - 4, 'cstr');
		return o;
	}

	function parse_NUMBER_18(blob, length) {
		var o = parse_cell_3(blob, length);
		o[1].v = blob.read_shift(2);
		var v = o[1].v >> 1;
		/* TODO: figure out all of the corner cases */
		if(o[1].v & 0x1) {
			switch(v & 0x07) {
				case 1: v = (v >> 3) * 500; break;
				case 2: v = (v >> 3) / 20; break;
				case 4: v = (v >> 3) / 2000; break;
				case 6: v = (v >> 3) / 16; break;
				case 7: v = (v >> 3) / 64; break;
				default: throw "unknown NUMBER_18 encoding " + (v & 0x07);
			}
		}
		o[1].v = v;
		return o;
	}

	function parse_NUMBER_17(blob, length) {
		var o = parse_cell_3(blob, length);
		var v1 = blob.read_shift(4);
		var v2 = blob.read_shift(4);
		var e = blob.read_shift(2);
		if(e == 0xFFFF) { o[1].v = 0; return o; }
		var s = e & 0x8000; e = (e&0x7FFF) - 16446;
		o[1].v = (s*2 - 1) * ((e > 0 ? (v2 << e) : (v2 >>> -e)) + (e > -32 ? (v1 << (e + 32)) : (v1 >>> -(e + 32))));
		return o;
	}

	function parse_FORMULA_19(blob, length) {
		var o = parse_NUMBER_17(blob, 14);
		blob.l += length - 14; /* TODO: formula */
		return o;
	}

	function parse_NUMBER_25(blob, length) {
		var o = parse_cell_3(blob, length);
		var v1 = blob.read_shift(4);
		o[1].v = v1 >> 6;
		return o;
	}

	function parse_NUMBER_27(blob, length) {
		var o = parse_cell_3(blob, length);
		var v1 = blob.read_shift(8,'f');
		o[1].v = v1;
		return o;
	}

	function parse_FORMULA_28(blob, length) {
		var o = parse_NUMBER_27(blob, 14);
		blob.l += length - 10; /* TODO: formula */
		return o;
	}

	var WK1Enum = {
0x0000: { n:"BOF", f:parseuint16 },
0x0001: { n:"EOF" },
0x0002: { n:"CALCMODE" },
0x0003: { n:"CALCORDER" },
0x0004: { n:"SPLIT" },
0x0005: { n:"SYNC" },
0x0006: { n:"RANGE", f:parse_RANGE },
0x0007: { n:"WINDOW1" },
0x0008: { n:"COLW1" },
0x0009: { n:"WINTWO" },
0x000A: { n:"COLW2" },
0x000B: { n:"NAME" },
0x000C: { n:"BLANK" },
0x000D: { n:"INTEGER", f:parse_INTEGER },
0x000E: { n:"NUMBER", f:parse_NUMBER },
0x000F: { n:"LABEL", f:parse_LABEL },
0x0010: { n:"FORMULA", f:parse_FORMULA },
0x0018: { n:"TABLE" },
0x0019: { n:"ORANGE" },
0x001A: { n:"PRANGE" },
0x001B: { n:"SRANGE" },
0x001C: { n:"FRANGE" },
0x001D: { n:"KRANGE1" },
0x0020: { n:"HRANGE" },
0x0023: { n:"KRANGE2" },
0x0024: { n:"PROTEC" },
0x0025: { n:"FOOTER" },
0x0026: { n:"HEADER" },
0x0027: { n:"SETUP" },
0x0028: { n:"MARGINS" },
0x0029: { n:"LABELFMT" },
0x002A: { n:"TITLES" },
0x002B: { n:"SHEETJS" },
0x002D: { n:"GRAPH" },
0x002E: { n:"NGRAPH" },
0x002F: { n:"CALCCOUNT" },
0x0030: { n:"UNFORMATTED" },
0x0031: { n:"CURSORW12" },
0x0032: { n:"WINDOW" },
0x0033: { n:"STRING", f:parse_LABEL },
0x0037: { n:"PASSWORD" },
0x0038: { n:"LOCKED" },
0x003C: { n:"QUERY" },
0x003D: { n:"QUERYNAME" },
0x003E: { n:"PRINT" },
0x003F: { n:"PRINTNAME" },
0x0040: { n:"GRAPH2" },
0x0041: { n:"GRAPHNAME" },
0x0042: { n:"ZOOM" },
0x0043: { n:"SYMSPLIT" },
0x0044: { n:"NSROWS" },
0x0045: { n:"NSCOLS" },
0x0046: { n:"RULER" },
0x0047: { n:"NNAME" },
0x0048: { n:"ACOMM" },
0x0049: { n:"AMACRO" },
0x004A: { n:"PARSE" },
0x00FF: { n:"", f:parsenoop }
	};

	var WK3Enum = {
0x0000: { n:"BOF" },
0x0001: { n:"EOF" },
0x0003: { n:"??" },
0x0004: { n:"??" },
0x0005: { n:"??" },
0x0006: { n:"??" },
0x0007: { n:"??" },
0x0009: { n:"??" },
0x000a: { n:"??" },
0x000b: { n:"??" },
0x000c: { n:"??" },
0x000e: { n:"??" },
0x000f: { n:"??" },
0x0010: { n:"??" },
0x0011: { n:"??" },
0x0012: { n:"??" },
0x0013: { n:"??" },
0x0015: { n:"??" },
0x0016: { n:"LABEL16", f:parse_LABEL_16},
0x0017: { n:"NUMBER17", f:parse_NUMBER_17 },
0x0018: { n:"NUMBER18", f:parse_NUMBER_18 },
0x0019: { n:"FORMULA19", f:parse_FORMULA_19},
0x001a: { n:"??" },
0x001b: { n:"??" },
0x001c: { n:"??" },
0x001d: { n:"??" },
0x001e: { n:"??" },
0x001f: { n:"??" },
0x0021: { n:"??" },
0x0025: { n:"NUMBER25", f:parse_NUMBER_25 },
0x0027: { n:"NUMBER27", f:parse_NUMBER_27 },
0x0028: { n:"FORMULA28", f:parse_FORMULA_28 },
0x00FF: { n:"", f:parsenoop }
	};
	return {
		to_workbook: lotus_to_workbook
	};
})();
/* Parse a list of <r> tags */
var parse_rs = (function parse_rs_factory() {
	var tregex = matchtag("t"), rpregex = matchtag("rPr"), rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/, nlregex = /\r\n/g;
	/* 18.4.7 rPr CT_RPrElt */
	var parse_rpr = function parse_rpr(rpr, intro, outro) {
		var font = {}, cp = 65001, align = "";
		var pass = false;
		var m = rpr.match(tagregex), i = 0;
		if(m) for(;i!=m.length; ++i) {
			var y = parsexmltag(m[i]);
			switch(y[0].replace(/\w*:/g,"")) {
				/* 18.8.12 condense CT_BooleanProperty */
				/* ** not required . */
				case '<condense': break;
				/* 18.8.17 extend CT_BooleanProperty */
				/* ** not required . */
				case '<extend': break;
				/* 18.8.36 shadow CT_BooleanProperty */
				/* ** not required . */
				case '<shadow':
					if(!y.val) break;
					/* falls through */
				case '<shadow>':
				case '<shadow/>': font.shadow = 1; break;
				case '</shadow>': break;

				/* 18.4.1 charset CT_IntProperty TODO */
				case '<charset':
					if(y.val == '1') break;
					cp = CS2CP[parseInt(y.val, 10)];
					break;

				/* 18.4.2 outline CT_BooleanProperty TODO */
				case '<outline':
					if(!y.val) break;
					/* falls through */
				case '<outline>':
				case '<outline/>': font.outline = 1; break;
				case '</outline>': break;

				/* 18.4.5 rFont CT_FontName */
				case '<rFont': font.name = y.val; break;

				/* 18.4.11 sz CT_FontSize */
				case '<sz': font.sz = y.val; break;

				/* 18.4.10 strike CT_BooleanProperty */
				case '<strike':
					if(!y.val) break;
					/* falls through */
				case '<strike>':
				case '<strike/>': font.strike = 1; break;
				case '</strike>': break;

				/* 18.4.13 u CT_UnderlineProperty */
				case '<u':
					if(!y.val) break;
					switch(y.val) {
						case 'double': font.uval = "double"; break;
						case 'singleAccounting': font.uval = "single-accounting"; break;
						case 'doubleAccounting': font.uval = "double-accounting"; break;
					}
					/* falls through */
				case '<u>':
				case '<u/>': font.u = 1; break;
				case '</u>': break;

				/* 18.8.2 b */
				case '<b':
					if(y.val == '0') break;
					/* falls through */
				case '<b>':
				case '<b/>': font.b = 1; break;
				case '</b>': break;

				/* 18.8.26 i */
				case '<i':
					if(y.val == '0') break;
					/* falls through */
				case '<i>':
				case '<i/>': font.i = 1; break;
				case '</i>': break;

				/* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */
				case '<color':
					if(y.rgb) font.color = y.rgb.slice(2,8);
					break;

				/* 18.8.18 family ST_FontFamily */
				case '<family': font.family = y.val; break;

				/* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */
				case '<vertAlign': align = y.val; break;

				/* 18.8.35 scheme CT_FontScheme TODO */
				case '<scheme': break;

				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default:
					if(y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
			}
		}
		var style = [];

		if(font.u) style.push("text-decoration: underline;");
		if(font.uval) style.push("text-underline-style:" + font.uval + ";");
		if(font.sz) style.push("font-size:" + font.sz + "pt;");
		if(font.outline) style.push("text-effect: outline;");
		if(font.shadow) style.push("text-shadow: auto;");
		intro.push('<span style="' + style.join("") + '">');

		if(font.b) { intro.push("<b>"); outro.push("</b>"); }
		if(font.i) { intro.push("<i>"); outro.push("</i>"); }
		if(font.strike) { intro.push("<s>"); outro.push("</s>"); }

		if(align == "superscript") align = "sup";
		else if(align == "subscript") align = "sub";
		if(align != "") { intro.push("<" + align + ">"); outro.push("</" + align + ">"); }

		outro.push("</span>");
		return cp;
	};

	/* 18.4.4 r CT_RElt */
	function parse_r(r) {
		var terms = [[],"",[]];
		/* 18.4.12 t ST_Xstring */
		var t = r.match(tregex)/*, cp = 65001*/;
		if(!t) return "";
		terms[1] = t[1];

		var rpr = r.match(rpregex);
		if(rpr) /*cp = */parse_rpr(rpr[1], terms[0], terms[2]);

		return terms[0].join("") + terms[1].replace(nlregex,'<br/>') + terms[2].join("");
	}
	return function parse_rs(rs) {
		return rs.replace(rregex,"").split(rend).map(parse_r).join("");
	};
})();

/* 18.4.8 si CT_Rst */
var sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, sirregex = /<(?:\w+:)?r>/;
var sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
function parse_si(x, opts) {
	var html = opts ? opts.cellHTML : true;
	var z = {};
	if(!x) return null;
	//var y;
	/* 18.4.12 t ST_Xstring (Plaintext String) */
	// TODO: is whitespace actually valid here?
	if(x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
		z.t = unescapexml(utf8read(x.slice(x.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""));
		z.r = utf8read(x);
		if(html) z.h = escapehtml(z.t);
	}
	/* 18.4.4 r CT_RElt (Rich Text Run) */
	else if((/*y = */x.match(sirregex))) {
		z.r = utf8read(x);
		z.t = unescapexml(utf8read((x.replace(sirphregex, '').match(sitregex)||[]).join("").replace(tagregex,"")));
		if(html) z.h = parse_rs(z.r);
	}
	/* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */
	/* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */
	return z;
}

/* 18.4 Shared String Table */
var sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
var sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
var sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function parse_sst_xml(data, opts) {
	var s = ([]), ss = "";
	if(!data) return s;
	/* 18.4.9 sst CT_Sst */
	var sst = data.match(sstr0);
	if(sst) {
		ss = sst[2].replace(sstr1,"").split(sstr2);
		for(var i = 0; i != ss.length; ++i) {
			var o = parse_si(ss[i].trim(), opts);
			if(o != null) s[s.length] = o;
		}
		sst = parsexmltag(sst[1]); s.Count = sst.count; s.Unique = sst.uniqueCount;
	}
	return s;
}

RELS.SST = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings";
var straywsregex = /^\s|\s$|[\t\n\r]/;
function write_sst_xml(sst, opts) {
	if(!opts.bookSST) return "";
	var o = [XML_HEADER];
	o[o.length] = (writextag('sst', null, {
		xmlns: XMLNS.main[0],
		count: sst.Count,
		uniqueCount: sst.Unique
	}));
	for(var i = 0; i != sst.length; ++i) { if(sst[i] == null) continue;
		var s = sst[i];
		var sitag = "<si>";
		if(s.r) sitag += s.r;
		else {
			sitag += "<t";
			if(!s.t) s.t = "";
			if(s.t.match(straywsregex)) sitag += ' xml:space="preserve"';
			sitag += ">" + escapexml(s.t) + "</t>";
		}
		sitag += "</si>";
		o[o.length] = (sitag);
	}
	if(o.length>2){ o[o.length] = ('</sst>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.221 BrtBeginSst */
function parse_BrtBeginSst(data) {
	return [data.read_shift(4), data.read_shift(4)];
}

/* [MS-XLSB] 2.1.7.45 Shared Strings */
function parse_sst_bin(data, opts) {
	var s = ([]);
	var pass = false;
	recordhopper(data, function hopper_sst(val, R_n, RT) {
		switch(RT) {
			case 0x009F: /* 'BrtBeginSst' */
				s.Count = val[0]; s.Unique = val[1]; break;
			case 0x0013: /* 'BrtSSTItem' */
				s.push(val); break;
			case 0x00A0: /* 'BrtEndSst' */
				return true;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;

			default:
				if(R_n.indexOf("Begin") > 0){/* empty */}
				else if(R_n.indexOf("End") > 0){/* empty */}
				if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	});
	return s;
}

function write_BrtBeginSst(sst, o) {
	if(!o) o = new_buf(8);
	o.write_shift(4, sst.Count);
	o.write_shift(4, sst.Unique);
	return o;
}

var write_BrtSSTItem = write_RichStr;

function write_sst_bin(sst) {
	var ba = buf_array();
	write_record(ba, "BrtBeginSst", write_BrtBeginSst(sst));
	for(var i = 0; i < sst.length; ++i) write_record(ba, "BrtSSTItem", write_BrtSSTItem(sst[i]));
	/* FRTSST */
	write_record(ba, "BrtEndSst");
	return ba.end();
}
function _JS2ANSI(str) {
	if(typeof cptable !== 'undefined') return cptable.utils.encode(current_ansi, str);
	var o = [], oo = str.split("");
	for(var i = 0; i < oo.length; ++i) o[i] = oo[i].charCodeAt(0);
	return o;
}

/* [MS-OFFCRYPTO] 2.1.4 Version */
function parse_CRYPTOVersion(blob, length) {
	var o = {};
	o.Major = blob.read_shift(2);
	o.Minor = blob.read_shift(2);
if(length >= 4) blob.l += length - 4;
	return o;
}

/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */
function parse_DataSpaceVersionInfo(blob) {
	var o = {};
	o.id = blob.read_shift(0, 'lpp4');
	o.R = parse_CRYPTOVersion(blob, 4);
	o.U = parse_CRYPTOVersion(blob, 4);
	o.W = parse_CRYPTOVersion(blob, 4);
	return o;
}

/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */
function parse_DataSpaceMapEntry(blob) {
	var len = blob.read_shift(4);
	var end = blob.l + len - 4;
	var o = {};
	var cnt = blob.read_shift(4);
	var comps = [];
	/* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */
	while(cnt-- > 0) comps.push({ t: blob.read_shift(4), v: blob.read_shift(0, 'lpp4') });
	o.name = blob.read_shift(0, 'lpp4');
	o.comps = comps;
	if(blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
	return o;
}

/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */
function parse_DataSpaceMap(blob) {
	var o = [];
	blob.l += 4; // must be 0x8
	var cnt = blob.read_shift(4);
	while(cnt-- > 0) o.push(parse_DataSpaceMapEntry(blob));
	return o;
}

/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */
function parse_DataSpaceDefinition(blob) {
	var o = [];
	blob.l += 4; // must be 0x8
	var cnt = blob.read_shift(4);
	while(cnt-- > 0) o.push(blob.read_shift(0, 'lpp4'));
	return o;
}

/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */
function parse_TransformInfoHeader(blob) {
	var o = {};
	/*var len = */blob.read_shift(4);
	blob.l += 4; // must be 0x1
	o.id = blob.read_shift(0, 'lpp4');
	o.name = blob.read_shift(0, 'lpp4');
	o.R = parse_CRYPTOVersion(blob, 4);
	o.U = parse_CRYPTOVersion(blob, 4);
	o.W = parse_CRYPTOVersion(blob, 4);
	return o;
}

function parse_Primary(blob) {
	/* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */
	var hdr = parse_TransformInfoHeader(blob);
	/* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */
	hdr.ename = blob.read_shift(0, '8lpp4');
	hdr.blksz = blob.read_shift(4);
	hdr.cmode = blob.read_shift(4);
	if(blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
	return hdr;
}

/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */
function parse_EncryptionHeader(blob, length) {
	var tgt = blob.l + length;
	var o = {};
	o.Flags = (blob.read_shift(4) & 0x3F);
	blob.l += 4;
	o.AlgID = blob.read_shift(4);
	var valid = false;
	switch(o.AlgID) {
		case 0x660E: case 0x660F: case 0x6610: valid = (o.Flags == 0x24); break;
		case 0x6801: valid = (o.Flags == 0x04); break;
		case 0: valid = (o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24); break;
		default: throw 'Unrecognized encryption algorithm: ' + o.AlgID;
	}
	if(!valid) throw new Error("Encryption Flags/AlgID mismatch");
	o.AlgIDHash = blob.read_shift(4);
	o.KeySize = blob.read_shift(4);
	o.ProviderType = blob.read_shift(4);
	blob.l += 8;
	o.CSPName = blob.read_shift((tgt-blob.l)>>1, 'utf16le');
	blob.l = tgt;
	return o;
}

/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */
function parse_EncryptionVerifier(blob, length) {
	var o = {}, tgt = blob.l + length;
	blob.l += 4; // SaltSize must be 0x10
	o.Salt = blob.slice(blob.l, blob.l+16); blob.l += 16;
	o.Verifier = blob.slice(blob.l, blob.l+16); blob.l += 16;
	/*var sz = */blob.read_shift(4);
	o.VerifierHash = blob.slice(blob.l, tgt); blob.l = tgt;
	return o;
}

/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */
function parse_EncryptionInfo(blob) {
	var vers = parse_CRYPTOVersion(blob);
	switch(vers.Minor) {
		case 0x02: return [vers.Minor, parse_EncInfoStd(blob, vers)];
		case 0x03: return [vers.Minor, parse_EncInfoExt(blob, vers)];
		case 0x04: return [vers.Minor, parse_EncInfoAgl(blob, vers)];
	}
	throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
}

/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */
function parse_EncInfoStd(blob) {
	var flags = blob.read_shift(4);
	if((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
	var sz = blob.read_shift(4);
	//var tgt = blob.l + sz;
	var hdr = parse_EncryptionHeader(blob, sz);
	var verifier = parse_EncryptionVerifier(blob, blob.length - blob.l);
	return { t:"Std", h:hdr, v:verifier };
}
/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */
function parse_EncInfoExt() { throw new Error("File is password-protected: ECMA-376 Extensible"); }
/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */
function parse_EncInfoAgl(blob) {
	var KeyData = ["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];
	blob.l+=4;
	var xml = blob.read_shift(blob.length - blob.l, 'utf8');
	var o = {};
	xml.replace(tagregex, function xml_agile(x) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<?xml': break;
			case '<encryption': case '</encryption>': break;
			case '<keyData': KeyData.forEach(function(k) { o[k] = y[k]; }); break;
			case '<dataIntegrity': o.encryptedHmacKey = y.encryptedHmacKey; o.encryptedHmacValue = y.encryptedHmacValue; break;
			case '<keyEncryptors>': case '<keyEncryptors': o.encs = []; break;
			case '</keyEncryptors>': break;

			case '<keyEncryptor': o.uri = y.uri; break;
			case '</keyEncryptor>': break;
			case '<encryptedKey': o.encs.push(y); break;
			default: throw y[0];
		}
	});
	return o;
}

/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */
function parse_RC4CryptoHeader(blob, length) {
	var o = {};
	var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4); length -= 4;
	if(vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
	if(vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
	o.Flags = blob.read_shift(4); length -= 4;
	var sz = blob.read_shift(4); length -= 4;
	o.EncryptionHeader = parse_EncryptionHeader(blob, sz); length -= sz;
	o.EncryptionVerifier = parse_EncryptionVerifier(blob, length);
	return o;
}
/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */
function parse_RC4Header(blob) {
	var o = {};
	var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4);
	if(vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
	o.Salt = blob.read_shift(16);
	o.EncryptedVerifier = blob.read_shift(16);
	o.EncryptedVerifierHash = blob.read_shift(16);
	return o;
}

/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */
function crypto_CreatePasswordVerifier_Method1(Password) {
	var Verifier = 0x0000, PasswordArray;
	var PasswordDecoded = _JS2ANSI(Password);
	var len = PasswordDecoded.length + 1, i, PasswordByte;
	var Intermediate1, Intermediate2, Intermediate3;
	PasswordArray = new_raw_buf(len);
	PasswordArray[0] = PasswordDecoded.length;
	for(i = 1; i != len; ++i) PasswordArray[i] = PasswordDecoded[i-1];
	for(i = len-1; i >= 0; --i) {
		PasswordByte = PasswordArray[i];
		Intermediate1 = ((Verifier & 0x4000) === 0x0000) ? 0 : 1;
		Intermediate2 = (Verifier << 1) & 0x7FFF;
		Intermediate3 = Intermediate1 | Intermediate2;
		Verifier = Intermediate3 ^ PasswordByte;
	}
	return Verifier ^ 0xCE4B;
}

/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */
var crypto_CreateXorArray_Method1 = (function() {
	var PadArray = [0xBB, 0xFF, 0xFF, 0xBA, 0xFF, 0xFF, 0xB9, 0x80, 0x00, 0xBE, 0x0F, 0x00, 0xBF, 0x0F, 0x00];
	var InitialCode = [0xE1F0, 0x1D0F, 0xCC9C, 0x84C0, 0x110C, 0x0E10, 0xF1CE, 0x313E, 0x1872, 0xE139, 0xD40F, 0x84F9, 0x280C, 0xA96A, 0x4EC3];
	var XorMatrix = [0xAEFC, 0x4DD9, 0x9BB2, 0x2745, 0x4E8A, 0x9D14, 0x2A09, 0x7B61, 0xF6C2, 0xFDA5, 0xEB6B, 0xC6F7, 0x9DCF, 0x2BBF, 0x4563, 0x8AC6, 0x05AD, 0x0B5A, 0x16B4, 0x2D68, 0x5AD0, 0x0375, 0x06EA, 0x0DD4, 0x1BA8, 0x3750, 0x6EA0, 0xDD40, 0xD849, 0xA0B3, 0x5147, 0xA28E, 0x553D, 0xAA7A, 0x44D5, 0x6F45, 0xDE8A, 0xAD35, 0x4A4B, 0x9496, 0x390D, 0x721A, 0xEB23, 0xC667, 0x9CEF, 0x29FF, 0x53FE, 0xA7FC, 0x5FD9, 0x47D3, 0x8FA6, 0x0F6D, 0x1EDA, 0x3DB4, 0x7B68, 0xF6D0, 0xB861, 0x60E3, 0xC1C6, 0x93AD, 0x377B, 0x6EF6, 0xDDEC, 0x45A0, 0x8B40, 0x06A1, 0x0D42, 0x1A84, 0x3508, 0x6A10, 0xAA51, 0x4483, 0x8906, 0x022D, 0x045A, 0x08B4, 0x1168, 0x76B4, 0xED68, 0xCAF1, 0x85C3, 0x1BA7, 0x374E, 0x6E9C, 0x3730, 0x6E60, 0xDCC0, 0xA9A1, 0x4363, 0x86C6, 0x1DAD, 0x3331, 0x6662, 0xCCC4, 0x89A9, 0x0373, 0x06E6, 0x0DCC, 0x1021, 0x2042, 0x4084, 0x8108, 0x1231, 0x2462, 0x48C4];
	var Ror = function(Byte) { return ((Byte/2) | (Byte*128)) & 0xFF; };
	var XorRor = function(byte1, byte2) { return Ror(byte1 ^ byte2); };
	var CreateXorKey_Method1 = function(Password) {
		var XorKey = InitialCode[Password.length - 1];
		var CurrentElement = 0x68;
		for(var i = Password.length-1; i >= 0; --i) {
			var Char = Password[i];
			for(var j = 0; j != 7; ++j) {
				if(Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
				Char *= 2; --CurrentElement;
			}
		}
		return XorKey;
	};
	return function(password) {
		var Password = _JS2ANSI(password);
		var XorKey = CreateXorKey_Method1(Password);
		var Index = Password.length;
		var ObfuscationArray = new_raw_buf(16);
		for(var i = 0; i != 16; ++i) ObfuscationArray[i] = 0x00;
		var Temp, PasswordLastChar, PadIndex;
		if((Index & 1) === 1) {
			Temp = XorKey >> 8;
			ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
			--Index;
			Temp = XorKey & 0xFF;
			PasswordLastChar = Password[Password.length - 1];
			ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
		}
		while(Index > 0) {
			--Index;
			Temp = XorKey >> 8;
			ObfuscationArray[Index] = XorRor(Password[Index], Temp);
			--Index;
			Temp = XorKey & 0xFF;
			ObfuscationArray[Index] = XorRor(Password[Index], Temp);
		}
		Index = 15;
		PadIndex = 15 - Password.length;
		while(PadIndex > 0) {
			Temp = XorKey >> 8;
			ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
			--Index;
			--PadIndex;
			Temp = XorKey & 0xFF;
			ObfuscationArray[Index] = XorRor(Password[Index], Temp);
			--Index;
			--PadIndex;
		}
		return ObfuscationArray;
	};
})();

/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */
var crypto_DecryptData_Method1 = function(password, Data, XorArrayIndex, XorArray, O) {
	/* If XorArray is set, use it; if O is not set, make changes in-place */
	if(!O) O = Data;
	if(!XorArray) XorArray = crypto_CreateXorArray_Method1(password);
	var Index, Value;
	for(Index = 0; Index != Data.length; ++Index) {
		Value = Data[Index];
		Value ^= XorArray[XorArrayIndex];
		Value = ((Value>>5) | (Value<<3)) & 0xFF;
		O[Index] = Value;
		++XorArrayIndex;
	}
	return [O, XorArrayIndex, XorArray];
};

var crypto_MakeXorDecryptor = function(password) {
	var XorArrayIndex = 0, XorArray = crypto_CreateXorArray_Method1(password);
	return function(Data) {
		var O = crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
		XorArrayIndex = O[1];
		return O[0];
	};
};

/* 2.5.343 */
function parse_XORObfuscation(blob, length, opts, out) {
	var o = ({ key: parseuint16(blob), verificationBytes: parseuint16(blob) });
	if(opts.password) o.verifier = crypto_CreatePasswordVerifier_Method1(opts.password);
	out.valid = o.verificationBytes === o.verifier;
	if(out.valid) out.insitu = crypto_MakeXorDecryptor(opts.password);
	return o;
}

/* 2.4.117 */
function parse_FilePassHeader(blob, length, oo) {
	var o = oo || {}; o.Info = blob.read_shift(2); blob.l -= 2;
	if(o.Info === 1) o.Data = parse_RC4Header(blob, length);
	else o.Data = parse_RC4CryptoHeader(blob, length);
	return o;
}
function parse_FilePass(blob, length, opts) {
	var o = ({ Type: opts.biff >= 8 ? blob.read_shift(2) : 0 }); /* wEncryptionType */
	if(o.Type) parse_FilePassHeader(blob, length-2, o);
	else parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
	return o;
}


var RTF = (function() {
	function rtf_to_sheet(d, opts) {
		switch(opts.type) {
			case 'base64': return rtf_to_sheet_str(Base64.decode(d), opts);
			case 'binary': return rtf_to_sheet_str(d, opts);
			case 'buffer': return rtf_to_sheet_str(d.toString('binary'), opts);
			case 'array':  return rtf_to_sheet_str(cc2str(d), opts);
		}
		throw new Error("Unrecognized type " + opts.type);
	}

	function rtf_to_sheet_str(str, opts) {
		var o = opts || {};
		var ws = o.dense ? ([]) : ({});
		var range = ({s: {c:0, r:0}, e: {c:0, r:0}});

		// TODO: parse
		if(!str.match(/\\trowd/)) throw new Error("RTF missing table");

		ws['!ref'] = encode_range(range);
		return ws;
	}

	function rtf_to_workbook(d, opts) { return sheet_to_workbook(rtf_to_sheet(d, opts), opts); }

	/* TODO: this is a stub */
	function sheet_to_rtf(ws) {
		var o = ["{\\rtf1\\ansi"];
		var r = safe_decode_range(ws['!ref']), cell;
		var dense = Array.isArray(ws);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			o.push("\\trowd\\trautofit1");
			for(var C = r.s.c; C <= r.e.c; ++C) o.push("\\cellx" + (C+1));
			o.push("\\pard\\intbl");
			for(C = r.s.c; C <= r.e.c; ++C) {
				var coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C]: ws[coord];
				if(!cell || cell.v == null && (!cell.f || cell.F)) continue;
				o.push(" " + (cell.w || (format_cell(cell), cell.w)));
				o.push("\\cell");
			}
			o.push("\\pard\\intbl\\row");
		}
		return o.join("") + "}";
	}

	return {
		to_workbook: rtf_to_workbook,
		to_sheet: rtf_to_sheet,
		from_sheet: sheet_to_rtf
	};
})();
function hex2RGB(h) {
	var o = h.slice(h[0]==="#"?1:0).slice(0,6);
	return [parseInt(o.slice(0,2),16),parseInt(o.slice(2,4),16),parseInt(o.slice(4,6),16)];
}
function rgb2Hex(rgb) {
	for(var i=0,o=1; i!=3; ++i) o = o*256 + (rgb[i]>255?255:rgb[i]<0?0:rgb[i]);
	return o.toString(16).toUpperCase().slice(1);
}

function rgb2HSL(rgb) {
	var R = rgb[0]/255, G = rgb[1]/255, B=rgb[2]/255;
	var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
	if(C === 0) return [0, 0, R];

	var H6 = 0, S = 0, L2 = (M + m);
	S = C / (L2 > 1 ? 2 - L2 : L2);
	switch(M){
		case R: H6 = ((G - B) / C + 6)%6; break;
		case G: H6 = ((B - R) / C + 2); break;
		case B: H6 = ((R - G) / C + 4); break;
	}
	return [H6 / 6, S, L2 / 2];
}

function hsl2RGB(hsl){
	var H = hsl[0], S = hsl[1], L = hsl[2];
	var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C/2;
	var rgb = [m,m,m], h6 = 6*H;

	var X;
	if(S !== 0) switch(h6|0) {
		case 0: case 6: X = C * h6; rgb[0] += C; rgb[1] += X; break;
		case 1: X = C * (2 - h6);   rgb[0] += X; rgb[1] += C; break;
		case 2: X = C * (h6 - 2);   rgb[1] += C; rgb[2] += X; break;
		case 3: X = C * (4 - h6);   rgb[1] += X; rgb[2] += C; break;
		case 4: X = C * (h6 - 4);   rgb[2] += C; rgb[0] += X; break;
		case 5: X = C * (6 - h6);   rgb[2] += X; rgb[0] += C; break;
	}
	for(var i = 0; i != 3; ++i) rgb[i] = Math.round(rgb[i]*255);
	return rgb;
}

/* 18.8.3 bgColor tint algorithm */
function rgb_tint(hex, tint) {
	if(tint === 0) return hex;
	var hsl = rgb2HSL(hex2RGB(hex));
	if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
	else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
	return rgb2Hex(hsl2RGB(hsl));
}

/* 18.3.1.13 width calculations */
/* [MS-OI29500] 2.1.595 Column Width & Formatting */
var DEF_MDW = 6, MAX_MDW = 15, MIN_MDW = 1, MDW = DEF_MDW;
function width2px(width) { return Math.floor(( width + (Math.round(128/MDW))/256 )* MDW ); }
function px2char(px) { return (Math.floor((px - 5)/MDW * 100 + 0.5))/100; }
function char2width(chr) { return (Math.round((chr * MDW + 5)/MDW*256))/256; }
//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function cycle_width(collw) { return char2width(px2char(width2px(collw))); }
/* XLSX/XLSB/XLS specify width in units of MDW */
function find_mdw_colw(collw) {
	var delta = Math.abs(collw - cycle_width(collw)), _MDW = MDW;
	if(delta > 0.005) for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) if(Math.abs(collw - cycle_width(collw)) <= delta) { delta = Math.abs(collw - cycle_width(collw)); _MDW = MDW; }
	MDW = _MDW;
}
/* XLML specifies width in terms of pixels */
/*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/

function process_col(coll) {
	if(coll.width) {
		coll.wpx = width2px(coll.width);
		coll.wch = px2char(coll.wpx);
		coll.MDW = MDW;
	} else if(coll.wpx) {
		coll.wch = px2char(coll.wpx);
		coll.width = char2width(coll.wch);
		coll.MDW = MDW;
	} else if(typeof coll.wch == 'number') {
		coll.width = char2width(coll.wch);
		coll.wpx = width2px(coll.width);
		coll.MDW = MDW;
	}
	if(coll.customWidth) delete coll.customWidth;
}

var DEF_PPI = 96, PPI = DEF_PPI;
function px2pt(px) { return px * 96 / PPI; }
function pt2px(pt) { return pt * PPI / 96; }

/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */
var XLMLPatternTypeMap = {
	"None": "none",
	"Solid": "solid",
	"Gray50": "mediumGray",
	"Gray75": "darkGray",
	"Gray25": "lightGray",
	"HorzStripe": "darkHorizontal",
	"VertStripe": "darkVertical",
	"ReverseDiagStripe": "darkDown",
	"DiagStripe": "darkUp",
	"DiagCross": "darkGrid",
	"ThickDiagCross": "darkTrellis",
	"ThinHorzStripe": "lightHorizontal",
	"ThinVertStripe": "lightVertical",
	"ThinReverseDiagStripe": "lightDown",
	"ThinHorzCross": "lightGrid"
};

/* 18.8.5 borders CT_Borders */
function parse_borders(t, styles, themes, opts) {
	styles.Borders = [];
	var border = {}/*, sub_border = {}*/;
	var pass = false;
	t[0].match(tagregex).forEach(function(x) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<borders': case '<borders>': case '</borders>': break;

			/* 18.8.4 border CT_Border */
			case '<border': case '<border>': case '<border/>':
				border = {};
				if (y.diagonalUp) { border.diagonalUp = y.diagonalUp; }
				if (y.diagonalDown) { border.diagonalDown = y.diagonalDown; }
				styles.Borders.push(border);
				break;
			case '</border>': break;

			/* note: not in spec, appears to be CT_BorderPr */
			case '<left/>': break;
			case '<left': case '<left>': break;
			case '</left>': break;

			/* note: not in spec, appears to be CT_BorderPr */
			case '<right/>': break;
			case '<right': case '<right>': break;
			case '</right>': break;

			/* 18.8.43 top CT_BorderPr */
			case '<top/>': break;
			case '<top': case '<top>': break;
			case '</top>': break;

			/* 18.8.6 bottom CT_BorderPr */
			case '<bottom/>': break;
			case '<bottom': case '<bottom>': break;
			case '</bottom>': break;

			/* 18.8.13 diagonal CT_BorderPr */
			case '<diagonal': case '<diagonal>': case '<diagonal/>': break;
			case '</diagonal>': break;

			/* 18.8.25 horizontal CT_BorderPr */
			case '<horizontal': case '<horizontal>': case '<horizontal/>': break;
			case '</horizontal>': break;

			/* 18.8.44 vertical CT_BorderPr */
			case '<vertical': case '<vertical>': case '<vertical/>': break;
			case '</vertical>': break;

			/* 18.8.37 start CT_BorderPr */
			case '<start': case '<start>': case '<start/>': break;
			case '</start>': break;

			/* 18.8.16 end CT_BorderPr */
			case '<end': case '<end>': case '<end/>': break;
			case '</end>': break;

			/* 18.8.? color CT_Color */
			case '<color': case '<color>': break;
			case '<color/>': case '</color>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
			}
		}
	});
}

/* 18.8.21 fills CT_Fills */
function parse_fills(t, styles, themes, opts) {
	styles.Fills = [];
	var fill = {};
	var pass = false;
	t[0].match(tagregex).forEach(function(x) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<fills': case '<fills>': case '</fills>': break;

			/* 18.8.20 fill CT_Fill */
			case '<fill>': case '<fill': case '<fill/>':
				fill = {}; styles.Fills.push(fill); break;
			case '</fill>': break;

			/* 18.8.24 gradientFill CT_GradientFill */
			case '<gradientFill>': break;
			case '<gradientFill':
			case '</gradientFill>': styles.Fills.push(fill); fill = {}; break;

			/* 18.8.32 patternFill CT_PatternFill */
			case '<patternFill': case '<patternFill>':
				if(y.patternType) fill.patternType = y.patternType;
				break;
			case '<patternFill/>': case '</patternFill>': break;

			/* 18.8.3 bgColor CT_Color */
			case '<bgColor':
				if(!fill.bgColor) fill.bgColor = {};
				if(y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
				if(y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
				if(y.tint) fill.bgColor.tint = parseFloat(y.tint);
				/* Excel uses ARGB strings */
				if(y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
				break;
			case '<bgColor/>': case '</bgColor>': break;

			/* 18.8.19 fgColor CT_Color */
			case '<fgColor':
				if(!fill.fgColor) fill.fgColor = {};
				if(y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
				if(y.tint) fill.fgColor.tint = parseFloat(y.tint);
				/* Excel uses ARGB strings */
				if(y.rgb) fill.fgColor.rgb = y.rgb.slice(-6);
				break;
			case '<fgColor/>': case '</fgColor>': break;

			/* 18.8.38 stop CT_GradientStop */
			case '<stop': case '<stop/>': break;
			case '</stop>': break;

			/* 18.8.? color CT_Color */
			case '<color': case '<color/>': break;
			case '</color>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
			}
		}
	});
}

/* 18.8.23 fonts CT_Fonts */
function parse_fonts(t, styles, themes, opts) {
	styles.Fonts = [];
	var font = {};
	var pass = false;
	t[0].match(tagregex).forEach(function(x) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<fonts': case '<fonts>': case '</fonts>': break;

			/* 18.8.22 font CT_Font */
			case '<font': case '<font>': break;
			case '</font>': case '<font/>':
				styles.Fonts.push(font);
				font = {};
				break;

			/* 18.8.29 name CT_FontName */
			case '<name': if(y.val) font.name = y.val; break;
			case '<name/>': case '</name>': break;

			/* 18.8.2  b CT_BooleanProperty */
			case '<b': font.bold = y.val ? parsexmlbool(y.val) : 1; break;
			case '<b/>': font.bold = 1; break;

			/* 18.8.26 i CT_BooleanProperty */
			case '<i': font.italic = y.val ? parsexmlbool(y.val) : 1; break;
			case '<i/>': font.italic = 1; break;

			/* 18.4.13 u CT_UnderlineProperty */
			case '<u':
				switch(y.val) {
					case "none": font.underline = 0x00; break;
					case "single": font.underline = 0x01; break;
					case "double": font.underline = 0x02; break;
					case "singleAccounting": font.underline = 0x21; break;
					case "doubleAccounting": font.underline = 0x22; break;
				} break;
			case '<u/>': font.underline = 1; break;

			/* 18.4.10 strike CT_BooleanProperty */
			case '<strike': font.strike = y.val ? parsexmlbool(y.val) : 1; break;
			case '<strike/>': font.strike = 1; break;

			/* 18.4.2  outline CT_BooleanProperty */
			case '<outline': font.outline = y.val ? parsexmlbool(y.val) : 1; break;
			case '<outline/>': font.outline = 1; break;

			/* 18.8.36 shadow CT_BooleanProperty */
			case '<shadow': font.shadow = y.val ? parsexmlbool(y.val) : 1; break;
			case '<shadow/>': font.shadow = 1; break;

			/* 18.8.12 condense CT_BooleanProperty */
			case '<condense': font.condense = y.val ? parsexmlbool(y.val) : 1; break;
			case '<condense/>': font.condense = 1; break;

			/* 18.8.17 extend CT_BooleanProperty */
			case '<extend': font.extend = y.val ? parsexmlbool(y.val) : 1; break;
			case '<extend/>': font.extend = 1; break;

			/* 18.4.11 sz CT_FontSize */
			case '<sz': if(y.val) font.sz = +y.val; break;
			case '<sz/>': case '</sz>': break;

			/* 18.4.14 vertAlign CT_VerticalAlignFontProperty */
			case '<vertAlign': if(y.val) font.vertAlign = y.val; break;
			case '<vertAlign/>': case '</vertAlign>': break;

			/* 18.8.18 family CT_FontFamily */
			case '<family': if(y.val) font.family = parseInt(y.val,10); break;
			case '<family/>': case '</family>': break;

			/* 18.8.35 scheme CT_FontScheme */
			case '<scheme': if(y.val) font.scheme = y.val; break;
			case '<scheme/>': case '</scheme>': break;

			/* 18.4.1 charset CT_IntProperty */
			case '<charset':
				if(y.val == '1') break;
				y.codepage = CS2CP[parseInt(y.val, 10)];
				break;

			/* 18.?.? color CT_Color */
			case '<color':
				if(!font.color) font.color = {};
				if(y.auto) font.color.auto = parsexmlbool(y.auto);

				if(y.rgb) font.color.rgb = y.rgb.slice(-6);
				else if(y.indexed) {
					font.color.index = parseInt(y.indexed, 10);
					var icv = XLSIcv[font.color.index];
					if(font.color.index == 81) icv = XLSIcv[1];
					if(!icv) throw new Error(x);
					font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
				} else if(y.theme) {
					font.color.theme = parseInt(y.theme, 10);
					if(y.tint) font.color.tint = parseFloat(y.tint);
					if(y.theme && themes.themeElements && themes.themeElements.clrScheme) {
						font.color.rgb = rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
					}
				}

				break;
			case '<color/>': case '</color>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
			}
		}
	});
}

/* 18.8.31 numFmts CT_NumFmts */
function parse_numFmts(t, styles, opts) {
	styles.NumberFmt = [];
	var k/*Array<number>*/ = (keys(SSF._table));
	for(var i=0; i < k.length; ++i) styles.NumberFmt[k[i]] = SSF._table[k[i]];
	var m = t[0].match(tagregex);
	if(!m) return;
	for(i=0; i < m.length; ++i) {
		var y = parsexmltag(m[i]);
		switch(strip_ns(y[0])) {
			case '<numFmts': case '</numFmts>': case '<numFmts/>': case '<numFmts>': break;
			case '<numFmt': {
				var f=unescapexml(utf8read(y.formatCode)), j=parseInt(y.numFmtId,10);
				styles.NumberFmt[j] = f;
				if(j>0) {
					if(j > 0x188) {
						for(j = 0x188; j > 0x3c; --j) if(styles.NumberFmt[j] == null) break;
						styles.NumberFmt[j] = f;
					}
					SSF.load(f,j);
				}
			} break;
			case '</numFmt>': break;
			default: if(opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
		}
	}
}

function write_numFmts(NF) {
	var o = ["<numFmts>"];
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
		for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) o[o.length] = (writextag('numFmt',null,{numFmtId:i,formatCode:escapexml(NF[i])}));
	});
	if(o.length === 1) return "";
	o[o.length] = ("</numFmts>");
	o[0] = writextag('numFmts', null, { count:o.length-2 }).replace("/>", ">");
	return o.join("");
}

/* 18.8.10 cellXfs CT_CellXfs */
var cellXF_uint = [ "numFmtId", "fillId", "fontId", "borderId", "xfId" ];
var cellXF_bool = [ "applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix" ];
function parse_cellXfs(t, styles, opts) {
	styles.CellXf = [];
	var xf;
	var pass = false;
	t[0].match(tagregex).forEach(function(x) {
		var y = parsexmltag(x), i = 0;
		switch(strip_ns(y[0])) {
			case '<cellXfs': case '<cellXfs>': case '<cellXfs/>': case '</cellXfs>': break;

			/* 18.8.45 xf CT_Xf */
			case '<xf': case '<xf/>':
				xf = y;
				delete xf[0];
				for(i = 0; i < cellXF_uint.length; ++i) if(xf[cellXF_uint[i]])
					xf[cellXF_uint[i]] = parseInt(xf[cellXF_uint[i]], 10);
				for(i = 0; i < cellXF_bool.length; ++i) if(xf[cellXF_bool[i]])
					xf[cellXF_bool[i]] = parsexmlbool(xf[cellXF_bool[i]]);
				if(xf.numFmtId > 0x188) {
					for(i = 0x188; i > 0x3c; --i) if(styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) { xf.numFmtId = i; break; }
				}
				styles.CellXf.push(xf); break;
			case '</xf>': break;

			/* 18.8.1 alignment CT_CellAlignment */
			case '<alignment': case '<alignment/>':
				var alignment = {};
				if(y.vertical) alignment.vertical = y.vertical;
				if(y.horizontal) alignment.horizontal = y.horizontal;
				if(y.textRotation != null) alignment.textRotation = y.textRotation;
				if(y.indent) alignment.indent = y.indent;
				if(y.wrapText) alignment.wrapText = y.wrapText;
				xf.alignment = alignment;
				break;
			case '</alignment>': break;

			/* 18.8.33 protection CT_CellProtection */
			case '<protection': case '</protection>': case '<protection/>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
			}
		}
	});
}

function write_cellXfs(cellXfs) {
	var o = [];
	o[o.length] = (writextag('cellXfs',null));
	cellXfs.forEach(function(c) { o[o.length] = (writextag('xf', null, c)); });
	o[o.length] = ("</cellXfs>");
	if(o.length === 2) return "";
	o[0] = writextag('cellXfs',null, {count:o.length-2}).replace("/>",">");
	return o.join("");
}

/* 18.8 Styles CT_Stylesheet*/
var parse_sty_xml= (function make_pstyx() {
var numFmtRegex = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;
var cellXfRegex = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;
var fillsRegex = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;
var fontsRegex = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;
var bordersRegex = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;

return function parse_sty_xml(data, themes, opts) {
	var styles = {};
	if(!data) return styles;
	data = data.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
	/* 18.8.39 styleSheet CT_Stylesheet */
	var t;

	/* 18.8.31 numFmts CT_NumFmts ? */
	if((t=data.match(numFmtRegex))) parse_numFmts(t, styles, opts);

	/* 18.8.23 fonts CT_Fonts ? */
	if((t=data.match(fontsRegex))) parse_fonts(t, styles, themes, opts);

	/* 18.8.21 fills CT_Fills ? */
	if((t=data.match(fillsRegex))) parse_fills(t, styles, themes, opts);

	/* 18.8.5  borders CT_Borders ? */
	if((t=data.match(bordersRegex))) parse_borders(t, styles, themes, opts);

	/* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */

	/* 18.8.10 cellXfs CT_CellXfs ? */
	if((t=data.match(cellXfRegex))) parse_cellXfs(t, styles, opts);

	/* 18.8.8  cellStyles CT_CellStyles ? */
	/* 18.8.15 dxfs CT_Dxfs ? */
	/* 18.8.42 tableStyles CT_TableStyles ? */
	/* 18.8.11 colors CT_Colors ? */
	/* 18.2.10 extLst CT_ExtensionList ? */

	return styles;
};
})();

var STYLES_XML_ROOT = writextag('styleSheet', null, {
	'xmlns': XMLNS.main[0],
	'xmlns:vt': XMLNS.vt
});

RELS.STY = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";

function write_sty_xml(wb, opts) {
	var o = [XML_HEADER, STYLES_XML_ROOT], w;
	if(wb.SSF && (w = write_numFmts(wb.SSF)) != null) o[o.length] = w;
	o[o.length] = ('<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>');
	o[o.length] = ('<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>');
	o[o.length] = ('<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>');
	o[o.length] = ('<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>');
	if((w = write_cellXfs(opts.cellXfs))) o[o.length] = (w);
	o[o.length] = ('<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>');
	o[o.length] = ('<dxfs count="0"/>');
	o[o.length] = ('<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>');

	if(o.length>2){ o[o.length] = ('</styleSheet>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.657 BrtFmt */
function parse_BrtFmt(data, length) {
	var numFmtId = data.read_shift(2);
	var stFmtCode = parse_XLWideString(data,length-2);
	return [numFmtId, stFmtCode];
}
function write_BrtFmt(i, f, o) {
	if(!o) o = new_buf(6 + 4 * f.length);
	o.write_shift(2, i);
	write_XLWideString(f, o);
	var out = (o.length > o.l) ? o.slice(0, o.l) : o;
	if(o.l == null) o.l = o.length;
	return out;
}

/* [MS-XLSB] 2.4.659 BrtFont TODO */
function parse_BrtFont(data, length, opts) {
	var out = ({});

	out.sz = data.read_shift(2) / 20;

	var grbit = parse_FontFlags(data, 2, opts);
	if(grbit.fCondense) out.condense = 1;
	if(grbit.fExtend) out.extend = 1;
	if(grbit.fShadow) out.shadow = 1;
	if(grbit.fOutline) out.outline = 1;
	if(grbit.fStrikeout) out.strike = 1;
	if(grbit.fItalic) out.italic = 1;

	var bls = data.read_shift(2);
	if(bls === 0x02BC) out.bold = 1;

	switch(data.read_shift(2)) {
		/* case 0: out.vertAlign = "baseline"; break; */
		case 1: out.vertAlign = "superscript"; break;
		case 2: out.vertAlign = "subscript"; break;
	}

	var underline = data.read_shift(1);
	if(underline != 0) out.underline = underline;

	var family = data.read_shift(1);
	if(family > 0) out.family = family;

	var bCharSet = data.read_shift(1);
	if(bCharSet > 0) out.charset = bCharSet;

	data.l++;
	out.color = parse_BrtColor(data, 8);

	switch(data.read_shift(1)) {
		/* case 0: out.scheme = "none": break; */
		case 1: out.scheme = "major"; break;
		case 2: out.scheme = "minor"; break;
	}

	out.name = parse_XLWideString(data, length - 21);

	return out;
}
function write_BrtFont(font, o) {
	if(!o) o = new_buf(25+4*32);
	o.write_shift(2, font.sz * 20);
	write_FontFlags(font, o);
	o.write_shift(2, font.bold ? 0x02BC : 0x0190);
	var sss = 0;
	if(font.vertAlign == "superscript") sss = 1;
	else if(font.vertAlign == "subscript") sss = 2;
	o.write_shift(2, sss);
	o.write_shift(1, font.underline || 0);
	o.write_shift(1, font.family || 0);
	o.write_shift(1, font.charset || 0);
	o.write_shift(1, 0);
	write_BrtColor(font.color, o);
	var scheme = 0;
	if(font.scheme == "major") scheme = 1;
	if(font.scheme == "minor") scheme = 2;
	o.write_shift(1, scheme);
	write_XLWideString(font.name, o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.650 BrtFill */
var XLSBFillPTNames = [
	"none",
	"solid",
	"mediumGray",
	"darkGray",
	"lightGray",
	"darkHorizontal",
	"darkVertical",
	"darkDown",
	"darkUp",
	"darkGrid",
	"darkTrellis",
	"lightHorizontal",
	"lightVertical",
	"lightDown",
	"lightUp",
	"lightGrid",
	"lightTrellis",
	"gray125",
	"gray0625"
];
var rev_XLSBFillPTNames = (evert(XLSBFillPTNames));
/* TODO: gradient fill representation */
var parse_BrtFill = parsenoop;
function write_BrtFill(fill, o) {
	if(!o) o = new_buf(4*3 + 8*7 + 16*1);
	var fls = rev_XLSBFillPTNames[fill.patternType];
	if(fls == null) fls = 0x28;
	o.write_shift(4, fls);
	var j = 0;
	if(fls != 0x28) {
		/* TODO: custom FG Color */
		write_BrtColor({auto:1}, o);
		/* TODO: custom BG Color */
		write_BrtColor({auto:1}, o);

		for(; j < 12; ++j) o.write_shift(4, 0);
	} else {
		for(; j < 4; ++j) o.write_shift(4, 0);

		for(; j < 12; ++j) o.write_shift(4, 0); /* TODO */
		/* iGradientType */
		/* xnumDegree */
		/* xnumFillToLeft */
		/* xnumFillToRight */
		/* xnumFillToTop */
		/* xnumFillToBottom */
		/* cNumStop */
		/* xfillGradientStop */
	}
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.824 BrtXF */
function parse_BrtXF(data, length) {
	var tgt = data.l + length;
	var ixfeParent = data.read_shift(2);
	var ifmt = data.read_shift(2);
	data.l = tgt;
	return {ixfe:ixfeParent, numFmtId:ifmt };
}
function write_BrtXF(data, ixfeP, o) {
	if(!o) o = new_buf(16);
	o.write_shift(2, ixfeP||0);
	o.write_shift(2, data.numFmtId||0);
	o.write_shift(2, 0); /* iFont */
	o.write_shift(2, 0); /* iFill */
	o.write_shift(2, 0); /* ixBorder */
	o.write_shift(1, 0); /* trot */
	o.write_shift(1, 0); /* indent */
	o.write_shift(1, 0); /* flags */
	o.write_shift(1, 0); /* flags */
	o.write_shift(1, 0); /* xfGrbitAtr */
	o.write_shift(1, 0);
	return o;
}

/* [MS-XLSB] 2.5.4 Blxf TODO */
function write_Blxf(data, o) {
	if(!o) o = new_buf(10);
	o.write_shift(1, 0); /* dg */
	o.write_shift(1, 0);
	o.write_shift(4, 0); /* color */
	o.write_shift(4, 0); /* color */
	return o;
}
/* [MS-XLSB] 2.4.302 BrtBorder TODO */
var parse_BrtBorder = parsenoop;
function write_BrtBorder(border, o) {
	if(!o) o = new_buf(51);
	o.write_shift(1, 0); /* diagonal */
	write_Blxf(null, o); /* top */
	write_Blxf(null, o); /* bottom */
	write_Blxf(null, o); /* left */
	write_Blxf(null, o); /* right */
	write_Blxf(null, o); /* diag */
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.763 BrtStyle TODO */
function write_BrtStyle(style, o) {
	if(!o) o = new_buf(12+4*10);
	o.write_shift(4, style.xfId);
	o.write_shift(2, 1);
	o.write_shift(1, +style.builtinId);
	o.write_shift(1, 0); /* iLevel */
	write_XLNullableWideString(style.name || "", o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */
function write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
	var o = new_buf(4+256*2*4);
	o.write_shift(4, cnt);
	write_XLNullableWideString(defTableStyle, o);
	write_XLNullableWideString(defPivotStyle, o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.1.7.50 Styles */
function parse_sty_bin(data, themes, opts) {
	var styles = {};
	styles.NumberFmt = ([]);
	for(var y in SSF._table) styles.NumberFmt[y] = SSF._table[y];

	styles.CellXf = [];
	styles.Fonts = [];
	var state = [];
	var pass = false;
	recordhopper(data, function hopper_sty(val, R_n, RT) {
		switch(RT) {
			case 0x002C: /* 'BrtFmt' */
				styles.NumberFmt[val[0]] = val[1]; SSF.load(val[1], val[0]);
				break;
			case 0x002B: /* 'BrtFont' */
				styles.Fonts.push(val);
				if(val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) {
					val.color.rgb = rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
				}
				break;
			case 0x0401: /* 'BrtKnownFonts' */ break;
			case 0x002D: /* 'BrtFill' */ break;
			case 0x002E: /* 'BrtBorder' */ break;
			case 0x002F: /* 'BrtXF' */
				if(state[state.length - 1] == "BrtBeginCellXFs") {
					styles.CellXf.push(val);
				}
				break;
			case 0x0030: /* 'BrtStyle' */
			case 0x01FB: /* 'BrtDXF' */
			case 0x023C: /* 'BrtMRUColor' */
			case 0x01DB: /* 'BrtIndexedColor': */
				break;

			case 0x0493: /* 'BrtDXF14' */
			case 0x0836: /* 'BrtDXF15' */
			case 0x046A: /* 'BrtSlicerStyleElement' */
			case 0x0200: /* 'BrtTableStyleElement' */
			case 0x082F: /* 'BrtTimelineStyleElement' */
			case 0x0C00: /* 'BrtUid' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */
				state.push(R_n); break;
			case 0x0026: /* 'BrtACEnd' */
				state.pop(); break;

			default:
				if((R_n||"").indexOf("Begin") > 0) state.push(R_n);
				else if((R_n||"").indexOf("End") > 0) state.pop();
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	});
	return styles;
}

function write_FMTS_bin(ba, NF) {
	if(!NF) return;
	var cnt = 0;
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) ++cnt;
	});

	if(cnt == 0) return;
	write_record(ba, "BrtBeginFmts", write_UInt32LE(cnt));
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_record(ba, "BrtFmt", write_BrtFmt(i, NF[i]));
	});
	write_record(ba, "BrtEndFmts");
}

function write_FONTS_bin(ba) {
	var cnt = 1;

	if(cnt == 0) return;
	write_record(ba, "BrtBeginFonts", write_UInt32LE(cnt));
	write_record(ba, "BrtFont", write_BrtFont({
		sz:12,
		color: {theme:1},
		name: "Calibri",
		family: 2,
		scheme: "minor"
	}));
	/* 1*65491BrtFont [ACFONTS] */
	write_record(ba, "BrtEndFonts");
}

function write_FILLS_bin(ba) {
	var cnt = 2;

	if(cnt == 0) return;
	write_record(ba, "BrtBeginFills", write_UInt32LE(cnt));
	write_record(ba, "BrtFill", write_BrtFill({patternType:"none"}));
	write_record(ba, "BrtFill", write_BrtFill({patternType:"gray125"}));
	/* 1*65431BrtFill */
	write_record(ba, "BrtEndFills");
}

function write_BORDERS_bin(ba) {
	var cnt = 1;

	if(cnt == 0) return;
	write_record(ba, "BrtBeginBorders", write_UInt32LE(cnt));
	write_record(ba, "BrtBorder", write_BrtBorder({}));
	/* 1*65430BrtBorder */
	write_record(ba, "BrtEndBorders");
}

function write_CELLSTYLEXFS_bin(ba) {
	var cnt = 1;
	write_record(ba, "BrtBeginCellStyleXFs", write_UInt32LE(cnt));
	write_record(ba, "BrtXF", write_BrtXF({
		numFmtId:0,
		fontId:0,
		fillId:0,
		borderId:0
	}, 0xFFFF));
	/* 1*65430(BrtXF *FRT) */
	write_record(ba, "BrtEndCellStyleXFs");
}

function write_CELLXFS_bin(ba, data) {
	write_record(ba, "BrtBeginCellXFs", write_UInt32LE(data.length));
	data.forEach(function(c) { write_record(ba, "BrtXF", write_BrtXF(c,0)); });
	/* 1*65430(BrtXF *FRT) */
	write_record(ba, "BrtEndCellXFs");
}

function write_STYLES_bin(ba) {
	var cnt = 1;

	write_record(ba, "BrtBeginStyles", write_UInt32LE(cnt));
	write_record(ba, "BrtStyle", write_BrtStyle({
		xfId:0,
		builtinId:0,
		name:"Normal"
	}));
	/* 1*65430(BrtStyle *FRT) */
	write_record(ba, "BrtEndStyles");
}

function write_DXFS_bin(ba) {
	var cnt = 0;

	write_record(ba, "BrtBeginDXFs", write_UInt32LE(cnt));
	/* *2147483647(BrtDXF *FRT) */
	write_record(ba, "BrtEndDXFs");
}

function write_TABLESTYLES_bin(ba) {
	var cnt = 0;

	write_record(ba, "BrtBeginTableStyles", write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
	/* *TABLESTYLE */
	write_record(ba, "BrtEndTableStyles");
}

function write_COLORPALETTE_bin() {
	return;
	/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */
}

/* [MS-XLSB] 2.1.7.50 Styles */
function write_sty_bin(wb, opts) {
	var ba = buf_array();
	write_record(ba, "BrtBeginStyleSheet");
	write_FMTS_bin(ba, wb.SSF);
	write_FONTS_bin(ba, wb);
	write_FILLS_bin(ba, wb);
	write_BORDERS_bin(ba, wb);
	write_CELLSTYLEXFS_bin(ba, wb);
	write_CELLXFS_bin(ba, opts.cellXfs);
	write_STYLES_bin(ba, wb);
	write_DXFS_bin(ba, wb);
	write_TABLESTYLES_bin(ba, wb);
	write_COLORPALETTE_bin(ba, wb);
	/* FRTSTYLESHEET*/
	write_record(ba, "BrtEndStyleSheet");
	return ba.end();
}
RELS.THEME = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";

/* 20.1.6.2 clrScheme CT_ColorScheme */
function parse_clrScheme(t, themes, opts) {
	themes.themeElements.clrScheme = [];
	var color = {};
	(t[0].match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(y[0]) {
			/* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */
			case '<a:clrScheme': case '</a:clrScheme>': break;

			/* 20.1.2.3.32 srgbClr CT_SRgbColor */
			case '<a:srgbClr':
				color.rgb = y.val; break;

			/* 20.1.2.3.33 sysClr CT_SystemColor */
			case '<a:sysClr':
				color.rgb = y.lastClr; break;

			/* 20.1.4.1.1 accent1 (Accent 1) */
			/* 20.1.4.1.2 accent2 (Accent 2) */
			/* 20.1.4.1.3 accent3 (Accent 3) */
			/* 20.1.4.1.4 accent4 (Accent 4) */
			/* 20.1.4.1.5 accent5 (Accent 5) */
			/* 20.1.4.1.6 accent6 (Accent 6) */
			/* 20.1.4.1.9 dk1 (Dark 1) */
			/* 20.1.4.1.10 dk2 (Dark 2) */
			/* 20.1.4.1.15 folHlink (Followed Hyperlink) */
			/* 20.1.4.1.19 hlink (Hyperlink) */
			/* 20.1.4.1.22 lt1 (Light 1) */
			/* 20.1.4.1.23 lt2 (Light 2) */
			case '<a:dk1>': case '</a:dk1>':
			case '<a:lt1>': case '</a:lt1>':
			case '<a:dk2>': case '</a:dk2>':
			case '<a:lt2>': case '</a:lt2>':
			case '<a:accent1>': case '</a:accent1>':
			case '<a:accent2>': case '</a:accent2>':
			case '<a:accent3>': case '</a:accent3>':
			case '<a:accent4>': case '</a:accent4>':
			case '<a:accent5>': case '</a:accent5>':
			case '<a:accent6>': case '</a:accent6>':
			case '<a:hlink>': case '</a:hlink>':
			case '<a:folHlink>': case '</a:folHlink>':
				if (y[0].charAt(1) === '/') {
					themes.themeElements.clrScheme.push(color);
					color = {};
				} else {
					color.name = y[0].slice(3, y[0].length - 1);
				}
				break;

			default: if(opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
		}
	});
}

/* 20.1.4.1.18 fontScheme CT_FontScheme */
function parse_fontScheme() { }

/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */
function parse_fmtScheme() { }

var clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
var fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
var fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;

/* 20.1.6.10 themeElements CT_BaseStyles */
function parse_themeElements(data, themes, opts) {
	themes.themeElements = {};

	var t;

	[
		/* clrScheme CT_ColorScheme */
		['clrScheme', clrsregex, parse_clrScheme],
		/* fontScheme CT_FontScheme */
		['fontScheme', fntsregex, parse_fontScheme],
		/* fmtScheme CT_StyleMatrix */
		['fmtScheme', fmtsregex, parse_fmtScheme]
	].forEach(function(m) {
		if(!(t=data.match(m[1]))) throw new Error(m[0] + ' not found in themeElements');
		m[2](t, themes, opts);
	});
}

var themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;

/* 14.2.7 Theme Part */
function parse_theme_xml(data, opts) {
	/* 20.1.6.9 theme CT_OfficeStyleSheet */
	if(!data || data.length === 0) return parse_theme_xml(write_theme());

	var t;
	var themes = {};

	/* themeElements CT_BaseStyles */
	if(!(t=data.match(themeltregex))) throw new Error('themeElements not found in theme');
	parse_themeElements(t[0], themes, opts);

	return themes;
}

function write_theme(Themes, opts) {
	if(opts && opts.themeXLSX) return opts.themeXLSX;
	var o = [XML_HEADER];
	o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
	o[o.length] =  '<a:themeElements>';

	o[o.length] =   '<a:clrScheme name="Office">';
	o[o.length] =    '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
	o[o.length] =    '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
	o[o.length] =    '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
	o[o.length] =    '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
	o[o.length] =    '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
	o[o.length] =    '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
	o[o.length] =    '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
	o[o.length] =    '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
	o[o.length] =    '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
	o[o.length] =    '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
	o[o.length] =    '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
	o[o.length] =    '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
	o[o.length] =   '</a:clrScheme>';

	o[o.length] =   '<a:fontScheme name="Office">';
	o[o.length] =    '<a:majorFont>';
	o[o.length] =     '<a:latin typeface="Cambria"/>';
	o[o.length] =     '<a:ea typeface=""/>';
	o[o.length] =     '<a:cs typeface=""/>';
	o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
	o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
	o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
	o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
	o[o.length] =     '<a:font script="Arab" typeface="Times New Roman"/>';
	o[o.length] =     '<a:font script="Hebr" typeface="Times New Roman"/>';
	o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
	o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
	o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
	o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
	o[o.length] =     '<a:font script="Khmr" typeface="MoolBoran"/>';
	o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
	o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
	o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
	o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
	o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
	o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
	o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
	o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
	o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
	o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
	o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
	o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
	o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
	o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
	o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
	o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
	o[o.length] =     '<a:font script="Viet" typeface="Times New Roman"/>';
	o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
	o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
	o[o.length] =    '</a:majorFont>';
	o[o.length] =    '<a:minorFont>';
	o[o.length] =     '<a:latin typeface="Calibri"/>';
	o[o.length] =     '<a:ea typeface=""/>';
	o[o.length] =     '<a:cs typeface=""/>';
	o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
	o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
	o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
	o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
	o[o.length] =     '<a:font script="Arab" typeface="Arial"/>';
	o[o.length] =     '<a:font script="Hebr" typeface="Arial"/>';
	o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
	o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
	o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
	o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
	o[o.length] =     '<a:font script="Khmr" typeface="DaunPenh"/>';
	o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
	o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
	o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
	o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
	o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
	o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
	o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
	o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
	o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
	o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
	o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
	o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
	o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
	o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
	o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
	o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
	o[o.length] =     '<a:font script="Viet" typeface="Arial"/>';
	o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
	o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
	o[o.length] =    '</a:minorFont>';
	o[o.length] =   '</a:fontScheme>';

	o[o.length] =   '<a:fmtScheme name="Office">';
	o[o.length] =    '<a:fillStyleLst>';
	o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:lin ang="16200000" scaled="1"/>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:lin ang="16200000" scaled="0"/>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =    '</a:fillStyleLst>';
	o[o.length] =    '<a:lnStyleLst>';
	o[o.length] =     '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
	o[o.length] =     '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
	o[o.length] =     '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
	o[o.length] =    '</a:lnStyleLst>';
	o[o.length] =    '<a:effectStyleLst>';
	o[o.length] =     '<a:effectStyle>';
	o[o.length] =      '<a:effectLst>';
	o[o.length] =       '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
	o[o.length] =      '</a:effectLst>';
	o[o.length] =     '</a:effectStyle>';
	o[o.length] =     '<a:effectStyle>';
	o[o.length] =      '<a:effectLst>';
	o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
	o[o.length] =      '</a:effectLst>';
	o[o.length] =     '</a:effectStyle>';
	o[o.length] =     '<a:effectStyle>';
	o[o.length] =      '<a:effectLst>';
	o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
	o[o.length] =      '</a:effectLst>';
	o[o.length] =      '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
	o[o.length] =      '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
	o[o.length] =     '</a:effectStyle>';
	o[o.length] =    '</a:effectStyleLst>';
	o[o.length] =    '<a:bgFillStyleLst>';
	o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =    '</a:bgFillStyleLst>';
	o[o.length] =   '</a:fmtScheme>';
	o[o.length] =  '</a:themeElements>';

	o[o.length] =  '<a:objectDefaults>';
	o[o.length] =   '<a:spDef>';
	o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
	o[o.length] =   '</a:spDef>';
	o[o.length] =   '<a:lnDef>';
	o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
	o[o.length] =   '</a:lnDef>';
	o[o.length] =  '</a:objectDefaults>';
	o[o.length] =  '<a:extraClrSchemeLst/>';
	o[o.length] = '</a:theme>';
	return o.join("");
}
/* [MS-XLS] 2.4.326 TODO: payload is a zip file */
function parse_Theme(blob, length, opts) {
	var end = blob.l + length;
	var dwThemeVersion = blob.read_shift(4);
	if(dwThemeVersion === 124226) return;
	if(!opts.cellStyles || !jszip) { blob.l = end; return; }
	var data = blob.slice(blob.l);
	blob.l = end;
	var zip; try { zip = new jszip(data); } catch(e) { return; }
	var themeXML = getzipstr(zip, "theme/theme/theme1.xml", true);
	if(!themeXML) return;
	return parse_theme_xml(themeXML, opts);
}

/* 2.5.49 */
function parse_ColorTheme(blob) { return blob.read_shift(4); }

/* 2.5.155 */
function parse_FullColorExt(blob) {
	var o = {};
	o.xclrType = blob.read_shift(2);
	o.nTintShade = blob.read_shift(2);
	switch(o.xclrType) {
		case 0: blob.l += 4; break;
		case 1: o.xclrValue = parse_IcvXF(blob, 4); break;
		case 2: o.xclrValue = parse_LongRGBA(blob, 4); break;
		case 3: o.xclrValue = parse_ColorTheme(blob, 4); break;
		case 4: blob.l += 4; break;
	}
	blob.l += 8;
	return o;
}

/* 2.5.164 TODO: read 7 bits*/
function parse_IcvXF(blob, length) {
	return parsenoop(blob, length);
}

/* 2.5.280 */
function parse_XFExtGradient(blob, length) {
	return parsenoop(blob, length);
}

/* [MS-XLS] 2.5.108 */
function parse_ExtProp(blob) {
	var extType = blob.read_shift(2);
	var cb = blob.read_shift(2) - 4;
	var o = [extType];
	switch(extType) {
		case 0x04: case 0x05: case 0x07: case 0x08:
		case 0x09: case 0x0A: case 0x0B: case 0x0D:
			o[1] = parse_FullColorExt(blob, cb); break;
		case 0x06: o[1] = parse_XFExtGradient(blob, cb); break;
		case 0x0E: case 0x0F: o[1] = blob.read_shift(cb === 1 ? 1 : 2); break;
		default: throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
	}
	return o;
}

/* 2.4.355 */
function parse_XFExt(blob, length) {
	var end = blob.l + length;
	blob.l += 2;
	var ixfe = blob.read_shift(2);
	blob.l += 2;
	var cexts = blob.read_shift(2);
	var ext = [];
	while(cexts-- > 0) ext.push(parse_ExtProp(blob, end-blob.l));
	return {ixfe:ixfe, ext:ext};
}

/* xf is an XF, see parse_XFExt for xfext */
function update_xfext(xf, xfext) {
	xfext.forEach(function(xfe) {
		switch(xfe[0]) { /* 2.5.108 extPropData */
			case 0x04: break; /* foreground color */
			case 0x05: break; /* background color */
			case 0x06: break; /* gradient fill */
			case 0x07: break; /* top cell border color */
			case 0x08: break; /* bottom cell border color */
			case 0x09: break; /* left cell border color */
			case 0x0a: break; /* right cell border color */
			case 0x0b: break; /* diagonal cell border color */
			case 0x0d: break; /* text color */
			case 0x0e: break; /* font scheme */
			case 0x0f: break; /* indentation level */
		}
	});
}

/* 18.6 Calculation Chain */
function parse_cc_xml(data) {
	var d = [];
	if(!data) return d;
	var i = 1;
	(data.match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(y[0]) {
			case '<?xml': break;
			/* 18.6.2  calcChain CT_CalcChain 1 */
			case '<calcChain': case '<calcChain>': case '</calcChain>': break;
			/* 18.6.1  c CT_CalcCell 1 */
			case '<c': delete y[0]; if(y.i) i = y.i; else y.i = i; d.push(y); break;
		}
	});
	return d;
}

//function write_cc_xml(data, opts) { }

/* [MS-XLSB] 2.6.4.1 */
function parse_BrtCalcChainItem$(data) {
	var out = {};
	out.i = data.read_shift(4);
	var cell = {};
	cell.r = data.read_shift(4);
	cell.c = data.read_shift(4);
	out.r = encode_cell(cell);
	var flags = data.read_shift(1);
	if(flags & 0x2) out.l = '1';
	if(flags & 0x8) out.a = '1';
	return out;
}

/* 18.6 Calculation Chain */
function parse_cc_bin(data, name, opts) {
	var out = [];
	var pass = false;
	recordhopper(data, function hopper_cc(val, R_n, RT) {
		switch(RT) {
			case 0x003F: /* 'BrtCalcChainItem$' */
				out.push(val); break;

			default:
				if((R_n||"").indexOf("Begin") > 0){/* empty */}
				else if((R_n||"").indexOf("End") > 0){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	});
	return out;
}

//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */
function parse_xlink_xml() {
	//var opts = _opts || {};
	//if(opts.WTF) throw "XLSX External Link";
}

/* [MS-XLSB] 2.1.7.25 External Link */
function parse_xlink_bin(data, name, _opts) {
	if(!data) return data;
	var opts = _opts || {};

	var pass = false, end = false;

	recordhopper(data, function xlink_parse(val, R_n, RT) {
		if(end) return;
		switch(RT) {
			case 0x0167: /* 'BrtSupTabs' */
			case 0x016B: /* 'BrtExternTableStart' */
			case 0x016C: /* 'BrtExternTableEnd' */
			case 0x016E: /* 'BrtExternRowHdr' */
			case 0x016F: /* 'BrtExternCellBlank' */
			case 0x0170: /* 'BrtExternCellReal' */
			case 0x0171: /* 'BrtExternCellBool' */
			case 0x0172: /* 'BrtExternCellError' */
			case 0x0173: /* 'BrtExternCellString' */
			case 0x01D8: /* 'BrtExternValueMeta' */
			case 0x0241: /* 'BrtSupNameStart' */
			case 0x0242: /* 'BrtSupNameValueStart' */
			case 0x0243: /* 'BrtSupNameValueEnd' */
			case 0x0244: /* 'BrtSupNameNum' */
			case 0x0245: /* 'BrtSupNameErr' */
			case 0x0246: /* 'BrtSupNameSt' */
			case 0x0247: /* 'BrtSupNameNil' */
			case 0x0248: /* 'BrtSupNameBool' */
			case 0x0249: /* 'BrtSupNameFmla' */
			case 0x024A: /* 'BrtSupNameBits' */
			case 0x024B: /* 'BrtSupNameEnd' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;

			default:
				if((R_n||"").indexOf("Begin") > 0){/* empty */}
				else if((R_n||"").indexOf("End") > 0){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT.toString(16) + " " + R_n);
		}
	}, opts);
}
RELS.IMG = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image";
RELS.DRAW = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing";
/* 20.5 DrawingML - SpreadsheetML Drawing */
function parse_drawing(data, rels) {
	if(!data) return "??";
	/*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/
	var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];

	return rels['!id'][id].Target;
}

/* L.5.5.2 SpreadsheetML Comments + VML Schema */
var _shapeid = 1024;
function write_comments_vml(rId, comments) {
	var csize = [21600, 21600];
	/* L.5.2.1.2 Path Attribute */
	var bbox = ["m0,0l0",csize[1],csize[0],csize[1],csize[0],"0xe"].join(",");
	var o = [
		writextag("xml", null, { 'xmlns:v': XLMLNS.v, 'xmlns:o': XLMLNS.o, 'xmlns:x': XLMLNS.x, 'xmlns:mv': XLMLNS.mv }).replace(/\/>/,">"),
		writextag("o:shapelayout", writextag("o:idmap", null, {'v:ext':"edit", 'data':rId}), {'v:ext':"edit"}),
		writextag("v:shapetype", [
			writextag("v:stroke", null, {joinstyle:"miter"}),
			writextag("v:path", null, {gradientshapeok:"t", 'o:connecttype':"rect"})
		].join(""), {id:"_x0000_t202", 'o:spt':202, coordsize:csize.join(","),path:bbox})
	];
	while(_shapeid < rId * 1000) _shapeid += 1000;

	comments.forEach(function(x) { var c = decode_cell(x[0]);
	o = o.concat([
	'<v:shape' + wxt_helper({
		id:'_x0000_s' + (++_shapeid),
		type:"#_x0000_t202",
		style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : "") ,
		fillcolor:"#ECFAD4",
		strokecolor:"#edeaa1"
	}) + '>',
		writextag('v:fill', writextag("o:fill", null, {type:"gradientUnscaled", 'v:ext':"view"}), {'color2':"#BEFF82", 'angle':"-180", 'type':"gradient"}),
		writextag("v:shadow", null, {on:"t", 'obscured':"t"}),
		writextag("v:path", null, {'o:connecttype':"none"}),
		'<v:textbox><div style="text-align:left"></div></v:textbox>',
		'<x:ClientData ObjectType="Note">',
			'<x:MoveWithCells/>',
			'<x:SizeWithCells/>',
			/* Part 4 19.4.2.3 Anchor (Anchor) */
			writetag('x:Anchor', [c.c, 0, c.r, 0, c.c+3, 100, c.r+5, 100].join(",")),
			writetag('x:AutoFill', "False"),
			writetag('x:Row', String(c.r)),
			writetag('x:Column', String(c.c)),
			x[1].hidden ? '' : '<x:Visible/>',
		'</x:ClientData>',
	'</v:shape>'
	]); });
	o.push('</xml>');
	return o.join("");
}

RELS.CMNT = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments";

function parse_comments(zip, dirComments, sheets, sheetRels, opts) {
	for(var i = 0; i != dirComments.length; ++i) {
		var canonicalpath=dirComments[i];
		var comments=parse_cmnt(getzipdata(zip, canonicalpath.replace(/^\//,''), true), canonicalpath, opts);
		if(!comments || !comments.length) continue;
		// find the sheets targeted by these comments
		var sheetNames = keys(sheets);
		for(var j = 0; j != sheetNames.length; ++j) {
			var sheetName = sheetNames[j];
			var rels = sheetRels[sheetName];
			if(rels) {
				var rel = rels[canonicalpath];
				if(rel) insertCommentsIntoSheet(sheetName, sheets[sheetName], comments);
			}
		}
	}
}

function insertCommentsIntoSheet(sheetName, sheet, comments) {
	var dense = Array.isArray(sheet);
	var cell;
	comments.forEach(function(comment) {
		var r = decode_cell(comment.ref);
		if(dense) {
			if(!sheet[r.r]) sheet[r.r] = [];
			cell = sheet[r.r][r.c];
		} else cell = sheet[comment.ref];
		if (!cell) {
			cell = {};
			if(dense) sheet[r.r][r.c] = cell;
			else sheet[comment.ref] = cell;
			var range = safe_decode_range(sheet["!ref"]||"BDWGO1000001:A1");
			if(range.s.r > r.r) range.s.r = r.r;
			if(range.e.r < r.r) range.e.r = r.r;
			if(range.s.c > r.c) range.s.c = r.c;
			if(range.e.c < r.c) range.e.c = r.c;
			var encoded = encode_range(range);
			if (encoded !== sheet["!ref"]) sheet["!ref"] = encoded;
		}

		if (!cell.c) cell.c = [];
		var o = ({a: comment.author, t: comment.t, r: comment.r});
		if(comment.h) o.h = comment.h;
		cell.c.push(o);
	});
}

/* 18.7 Comments */
function parse_comments_xml(data, opts) {
	/* 18.7.6 CT_Comments */
	if(data.match(/<(?:\w+:)?comments *\/>/)) return [];
	var authors = [];
	var commentList = [];
	var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
	if(authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
		if(x === "" || x.trim() === "") return;
		var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
		if(a) authors.push(a[1]);
	});
	var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
	if(cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
		if(x === "" || x.trim() === "") return;
		var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
		if(!cm) return;
		var y = parsexmltag(cm[0]);
		var comment = ({ author: y.authorId && authors[y.authorId] || "sheetjsghost", ref: y.ref, guid: y.guid });
		var cell = decode_cell(y.ref);
		if(opts.sheetRows && opts.sheetRows <= cell.r) return;
		var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
		var rt = !!textMatch && !!textMatch[1] && parse_si(textMatch[1]) || {r:"",t:"",h:""};
		comment.r = rt.r;
		if(rt.r == "<t></t>") rt.t = rt.h = "";
		comment.t = rt.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");
		if(opts.cellHTML) comment.h = rt.h;
		commentList.push(comment);
	});
	return commentList;
}

var CMNT_XML_ROOT = writextag('comments', null, { 'xmlns': XMLNS.main[0] });
function write_comments_xml(data) {
	var o = [XML_HEADER, CMNT_XML_ROOT];

	var iauthor = [];
	o.push("<authors>");
	data.forEach(function(x) { x[1].forEach(function(w) { var a = escapexml(w.a);
		if(iauthor.indexOf(a) > -1) return;
		iauthor.push(a);
		o.push("<author>" + a + "</author>");
	}); });
	o.push("</authors>");
	o.push("<commentList>");
	data.forEach(function(d) {
		d[1].forEach(function(c) {
			/* 18.7.3 CT_Comment */
			o.push('<comment ref="' + d[0] + '" authorId="' + iauthor.indexOf(escapexml(c.a)) + '"><text>');
			o.push(writetag("t", c.t == null ? "" : escapexml(c.t)));
			o.push('</text></comment>');
		});
	});
	o.push("</commentList>");
	if(o.length>2) { o[o.length] = ('</comments>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.28 BrtBeginComment */
function parse_BrtBeginComment(data) {
	var out = {};
	out.iauthor = data.read_shift(4);
	var rfx = parse_UncheckedRfX(data, 16);
	out.rfx = rfx.s;
	out.ref = encode_cell(rfx.s);
	data.l += 16; /*var guid = parse_GUID(data); */
	return out;
}
function write_BrtBeginComment(data, o) {
	if(o == null) o = new_buf(36);
	o.write_shift(4, data[1].iauthor);
	write_UncheckedRfX((data[0]), o);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	return o;
}

/* [MS-XLSB] 2.4.327 BrtCommentAuthor */
var parse_BrtCommentAuthor = parse_XLWideString;
function write_BrtCommentAuthor(data) { return write_XLWideString(data.slice(0, 54)); }

/* [MS-XLSB] 2.1.7.8 Comments */
function parse_comments_bin(data, opts) {
	var out = [];
	var authors = [];
	var c = {};
	var pass = false;
	recordhopper(data, function hopper_cmnt(val, R_n, RT) {
		switch(RT) {
			case 0x0278: /* 'BrtCommentAuthor' */
				authors.push(val); break;
			case 0x027B: /* 'BrtBeginComment' */
				c = val; break;
			case 0x027D: /* 'BrtCommentText' */
				c.t = val.t; c.h = val.h; c.r = val.r; break;
			case 0x027C: /* 'BrtEndComment' */
				c.author = authors[c.iauthor];
				delete c.iauthor;
				if(opts.sheetRows && opts.sheetRows <= c.rfx.r) break;
				if(!c.t) c.t = "";
				delete c.rfx; out.push(c); break;

			case 0x0C00: /* 'BrtUid' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */ break;
			case 0x0026: /* 'BrtACEnd' */ break;


			default:
				if((R_n||"").indexOf("Begin") > 0){/* empty */}
				else if((R_n||"").indexOf("End") > 0){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	});
	return out;
}

function write_comments_bin(data) {
	var ba = buf_array();
	var iauthor = [];
	write_record(ba, "BrtBeginComments");

	write_record(ba, "BrtBeginCommentAuthors");
	data.forEach(function(comment) {
		comment[1].forEach(function(c) {
			if(iauthor.indexOf(c.a) > -1) return;
			iauthor.push(c.a.slice(0,54));
			write_record(ba, "BrtCommentAuthor", write_BrtCommentAuthor(c.a));
		});
	});
	write_record(ba, "BrtEndCommentAuthors");

	write_record(ba, "BrtBeginCommentList");
	data.forEach(function(comment) {
		comment[1].forEach(function(c) {
			c.iauthor = iauthor.indexOf(c.a);
			var range = {s:decode_cell(comment[0]),e:decode_cell(comment[0])};
			write_record(ba, "BrtBeginComment", write_BrtBeginComment([range, c]));
			if(c.t && c.t.length > 0) write_record(ba, "BrtCommentText", write_BrtCommentText(c));
			write_record(ba, "BrtEndComment");
			delete c.iauthor;
		});
	});
	write_record(ba, "BrtEndCommentList");

	write_record(ba, "BrtEndComments");
	return ba.end();
}
var CT_VBA = "application/vnd.ms-office.vbaProject";
function make_vba_xls(cfb) {
	var newcfb = CFB.utils.cfb_new({root:"R"});
	cfb.FullPaths.forEach(function(p, i) {
		if(p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/)) return;
		var newpath = p.replace(/^[^\/]*/,"R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
		CFB.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
	});
	return CFB.write(newcfb);
}

function fill_vba_xls(cfb, vba) {
	vba.FullPaths.forEach(function(p, i) {
		if(i == 0) return;
		var newpath = p.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
		if(newpath.slice(-1) !== "/") CFB.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
	});
}

var VBAFMTS = [ "xlsb", "xlsm", "xlam", "biff8", "xla" ];

RELS.DS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet";
RELS.MS = "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet";

/* macro and dialog sheet stubs */
function parse_ds_bin() { return {'!type':'dialog'}; }
function parse_ds_xml() { return {'!type':'dialog'}; }
function parse_ms_bin() { return {'!type':'macro'}; }
function parse_ms_xml() { return {'!type':'macro'}; }
/* TODO: it will be useful to parse the function str */
var rc_to_a1 = (function(){
	var rcregex = /(^|[^A-Za-z])R(\[?)(-?\d+|)\]?C(\[?)(-?\d+|)\]?/g;
	var rcbase = ({r:0,c:0});
	function rcfunc($$,$1,$2,$3,$4,$5) {
		var R = $3.length>0?parseInt($3,10)|0:0, C = $5.length>0?parseInt($5,10)|0:0;
		if(C<0 && $4.length === 0) C=0;
		var cRel = false, rRel = false;
		if($4.length > 0 || $5.length == 0) cRel = true; if(cRel) C += rcbase.c; else --C;
		if($2.length > 0 || $3.length == 0) rRel = true; if(rRel) R += rcbase.r; else --R;
		return $1 + (cRel ? "" : "$") + encode_col(C) + (rRel ? "" : "$") + encode_row(R);
	}
	return function rc_to_a1(fstr, base) {
		rcbase = base;
		return fstr.replace(rcregex, rcfunc);
	};
})();

var crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)([1-9]\d{0,5}|10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6])(?![_.\(A-Za-z0-9])/g;
var a1_to_rc =(function(){
	return function a1_to_rc(fstr, base) {
		return fstr.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
			var c = decode_col($3) - ($2 ? 0 : base.c);
			var r = decode_row($5) - ($4 ? 0 : base.r);
			var R = (r == 0 ? "" : !$4 ? "[" + r + "]" : (r+1));
			var C = (c == 0 ? "" : !$2 ? "[" + c + "]" : (c+1));
			return $1 + "R" + R + "C" + C;
		});
	};
})();

/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */
function shift_formula_str(f, delta) {
	return f.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
		return $1+($2=="$" ? $2+$3 : encode_col(decode_col($3)+delta.c))+($4=="$" ? $4+$5 : encode_row(decode_row($5) + delta.r));
	});
}

function shift_formula_xlsx(f, range, cell) {
	var r = decode_range(range), s = r.s, c = decode_cell(cell);
	var delta = {r:c.r - s.r, c:c.c - s.c};
	return shift_formula_str(f, delta);
}

/* TODO: parse formula */
function fuzzyfmla(f) {
	if(f.length == 1) return false;
	return true;
}

function _xlfn(f) {
	return f.replace(/_xlfn\./g,"");
}
function parseread1(blob) { blob.l+=1; return; }

/* [MS-XLS] 2.5.51 */
function parse_ColRelU(blob, length) {
	var c = blob.read_shift(length == 1 ? 1 : 2);
	return [c & 0x3FFF, (c >> 14) & 1, (c >> 15) & 1];
}

/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */
function parse_RgceArea(blob, length, opts) {
	var w = 2;
	if(opts) {
		if(opts.biff >= 2 && opts.biff <= 5) return parse_RgceArea_BIFF2(blob, length, opts);
		else if(opts.biff == 12) w = 4;
	}
	var r=blob.read_shift(w), R=blob.read_shift(w);
	var c=parse_ColRelU(blob, 2);
	var C=parse_ColRelU(blob, 2);
	return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
}
/* BIFF 2-5 encodes flags in the row field */
function parse_RgceArea_BIFF2(blob) {
	var r=parse_ColRelU(blob, 2), R=parse_ColRelU(blob, 2);
	var c=blob.read_shift(1);
	var C=blob.read_shift(1);
	return { s:{r:r[0], c:c, cRel:r[1], rRel:r[2]}, e:{r:R[0], c:C, cRel:R[1], rRel:R[2]} };
}

/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */
function parse_RgceAreaRel(blob, length, opts) {
	if(opts.biff < 8) return parse_RgceArea_BIFF2(blob, length, opts);
	var r=blob.read_shift(opts.biff == 12 ? 4 : 2), R=blob.read_shift(opts.biff == 12 ? 4 : 2);
	var c=parse_ColRelU(blob, 2);
	var C=parse_ColRelU(blob, 2);
	return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
}

/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */
function parse_RgceLoc(blob, length, opts) {
	if(opts && opts.biff >= 2 && opts.biff <= 5) return parse_RgceLoc_BIFF2(blob, length, opts);
	var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
	var c = parse_ColRelU(blob, 2);
	return {r:r, c:c[0], cRel:c[1], rRel:c[2]};
}
function parse_RgceLoc_BIFF2(blob) {
	var r = parse_ColRelU(blob, 2);
	var c = blob.read_shift(1);
	return {r:r[0], c:c, cRel:r[1], rRel:r[2]};
}

/* [MS-XLS] 2.5.198.107, 2.5.47 */
function parse_RgceElfLoc(blob) {
	var r = blob.read_shift(2);
	var c = blob.read_shift(2);
	return {r:r, c:c & 0xFF, fQuoted:!!(c & 0x4000), cRel:c>>15, rRel:c>>15 };
}

/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */
function parse_RgceLocRel(blob, length, opts) {
	var biff = opts && opts.biff ? opts.biff : 8;
	if(biff >= 2 && biff <= 5) return parse_RgceLocRel_BIFF2(blob, length, opts);
	var r = blob.read_shift(biff >= 12 ? 4 : 2);
	var cl = blob.read_shift(2);
	var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
	cl &= 0x3FFF;
	if(rRel == 1) while(r > 0x7FFFF) r -= 0x100000;
	if(cRel == 1) while(cl > 0x1FFF) cl = cl - 0x4000;
	return {r:r,c:cl,cRel:cRel,rRel:rRel};
}
function parse_RgceLocRel_BIFF2(blob) {
	var rl = blob.read_shift(2);
	var c = blob.read_shift(1);
	var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
	rl &= 0x3FFF;
	if(rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
	if(cRel == 1 && c >= 0x80) c = c - 0x100;
	return {r:rl,c:c,cRel:cRel,rRel:rRel};
}

/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */
function parse_PtgArea(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var area = parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
	return [type, area];
}

/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */
function parse_PtgArea3d(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var ixti = blob.read_shift(2, 'i');
	var w = 8;
	if(opts) switch(opts.biff) {
		case 5: blob.l += 12; w = 6; break;
		case 12: w = 12; break;
	}
	var area = parse_RgceArea(blob, w, opts);
	return [type, ixti, area];
}

/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */
function parse_PtgAreaErr(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	blob.l += opts && (opts.biff > 8) ? 12 : (opts.biff < 8 ? 6 : 8);
	return [type];
}
/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */
function parse_PtgAreaErr3d(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var ixti = blob.read_shift(2);
	var w = 8;
	if(opts) switch(opts.biff) {
		case 5: blob.l += 12; w = 6; break;
		case 12: w = 12; break;
	}
	blob.l += w;
	return [type, ixti];
}

/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */
function parse_PtgAreaN(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var area = parse_RgceAreaRel(blob, length - 1, opts);
	return [type, area];
}

/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */
function parse_PtgArray(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
	return [type];
}

/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */
function parse_PtgAttrBaxcel(blob) {
	var bitSemi = blob[blob.l+1] & 0x01; /* 1 = volatile */
	var bitBaxcel = 1;
	blob.l += 4;
	return [bitSemi, bitBaxcel];
}

/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */
function parse_PtgAttrChoose(blob, length, opts) {
	blob.l +=2;
	var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	var o = [];
	/* offset is 1 less than the number of elements */
	for(var i = 0; i <= offset; ++i) o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
	return o;
}

/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */
function parse_PtgAttrGoto(blob, length, opts) {
	var bitGoto = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += 2;
	return [bitGoto, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
}

/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */
function parse_PtgAttrIf(blob, length, opts) {
	var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += 2;
	return [bitIf, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
}

/* [MS-XLSB] 2.5.97.28 */
function parse_PtgAttrIfError(blob) {
	var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += 2;
	return [bitIf, blob.read_shift(2)];
}

/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */
function parse_PtgAttrSemi(blob, length, opts) {
	var bitSemi = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += opts && opts.biff == 2 ? 3 : 4;
	return [bitSemi];
}

/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */
function parse_PtgAttrSpaceType(blob) {
	var type = blob.read_shift(1), cch = blob.read_shift(1);
	return [type, cch];
}

/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */
function parse_PtgAttrSpace(blob) {
	blob.read_shift(2);
	return parse_PtgAttrSpaceType(blob, 2);
}

/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */
function parse_PtgAttrSpaceSemi(blob) {
	blob.read_shift(2);
	return parse_PtgAttrSpaceType(blob, 2);
}

/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */
function parse_PtgRef(blob, length, opts) {
	//var ptg = blob[blob.l] & 0x1F;
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var loc = parse_RgceLoc(blob, 0, opts);
	return [type, loc];
}

/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */
function parse_PtgRefN(blob, length, opts) {
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var loc = parse_RgceLocRel(blob, 0, opts);
	return [type, loc];
}

/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */
function parse_PtgRef3d(blob, length, opts) {
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var ixti = blob.read_shift(2); // XtiIndex
	if(opts && opts.biff == 5) blob.l += 12;
	var loc = parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
	return [type, ixti, loc];
}


/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */
function parse_PtgFunc(blob, length, opts) {
	//var ptg = blob[blob.l] & 0x1F;
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
	return [FtabArgc[iftab], Ftab[iftab], type];
}
/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */
function parse_PtgFuncVar(blob, length, opts) {
	var type = blob[blob.l++];
	var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [(type == 0x58 ? -1 : 0), blob.read_shift(1)]: parsetab(blob);
	return [cparams, (tab[0] === 0 ? Ftab : Cetab)[tab[1]]];
}

function parsetab(blob) {
	return [blob[blob.l+1]>>7, blob.read_shift(2) & 0x7FFF];
}

/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */
function parse_PtgAttrSum(blob, length, opts) {
	blob.l += opts && opts.biff == 2 ? 3 : 4; return;
}

/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */
function parse_PtgExp(blob, length, opts) {
	blob.l++;
	if(opts && opts.biff == 12) return [blob.read_shift(4, 'i'), 0];
	var row = blob.read_shift(2);
	var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	return [row, col];
}

/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */
function parse_PtgErr(blob) { blob.l++; return BErr[blob.read_shift(1)]; }

/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */
function parse_PtgInt(blob) { blob.l++; return blob.read_shift(2); }

/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */
function parse_PtgBool(blob) { blob.l++; return blob.read_shift(1)!==0;}

/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */
function parse_PtgNum(blob) { blob.l++; return parse_Xnum(blob, 8); }

/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */
function parse_PtgStr(blob, length, opts) { blob.l++; return parse_ShortXLUnicodeString(blob, length-1, opts); }

/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */
/* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */
function parse_SerAr(blob, biff) {
	var val = [blob.read_shift(1)];
	if(biff == 12) switch(val[0]) {
		case 0x02: val[0] = 0x04; break; /* SerBool */
		case 0x04: val[0] = 0x10; break; /* SerErr */
		case 0x00: val[0] = 0x01; break; /* SerNum */
		case 0x01: val[0] = 0x02; break; /* SerStr */
	}
	switch(val[0]) {
		case 0x04: /* SerBool -- boolean */
			val[1] = parsebool(blob, 1) ? 'TRUE' : 'FALSE';
			if(biff != 12) blob.l += 7; break;
		case 0x25: /* appears to be an alias */
		case 0x10: /* SerErr -- error */
			val[1] = BErr[blob[blob.l]];
			blob.l += ((biff == 12) ? 4 : 8); break;
		case 0x00: /* SerNil -- honestly, I'm not sure how to reproduce this */
			blob.l += 8; break;
		case 0x01: /* SerNum -- Xnum */
			val[1] = parse_Xnum(blob, 8); break;
		case 0x02: /* SerStr -- XLUnicodeString (<256 chars) */
			val[1] = parse_XLUnicodeString2(blob, 0, {biff:biff > 0 && biff < 8 ? 2 : biff}); break;
		default: throw new Error("Bad SerAr: " + val[0]); /* Unreachable */
	}
	return val;
}

/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */
function parse_PtgExtraMem(blob, cce, opts) {
	var count = blob.read_shift((opts.biff == 12) ? 4 : 2);
	var out = [];
	for(var i = 0; i != count; ++i) out.push(((opts.biff == 12) ? parse_UncheckedRfX : parse_Ref8U)(blob, 8));
	return out;
}

/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */
function parse_PtgExtraArray(blob, length, opts) {
	var rows = 0, cols = 0;
	if(opts.biff == 12) {
		rows = blob.read_shift(4); // DRw
		cols = blob.read_shift(4); // DCol
	} else {
		cols = 1 + blob.read_shift(1); //DColByteU
		rows = 1 + blob.read_shift(2); //DRw
	}
	if(opts.biff >= 2 && opts.biff < 8) { --rows; if(--cols == 0) cols = 0x100; }
	// $FlowIgnore
	for(var i = 0, o = []; i != rows && (o[i] = []); ++i)
		for(var j = 0; j != cols; ++j) o[i][j] = parse_SerAr(blob, opts.biff);
	return o;
}

/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */
function parse_PtgName(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var w = (!opts || (opts.biff >= 8)) ? 4 : 2;
	var nameindex = blob.read_shift(w);
	switch(opts.biff) {
		case 2: blob.l += 5; break;
		case 3: case 4: blob.l += 8; break;
		case 5: blob.l += 12; break;
	}
	return [type, 0, nameindex];
}

/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */
function parse_PtgNameX(blob, length, opts) {
	if(opts.biff == 5) return parse_PtgNameX_BIFF5(blob, length, opts);
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var ixti = blob.read_shift(2); // XtiIndex
	var nameindex = blob.read_shift(4);
	return [type, ixti, nameindex];
}
function parse_PtgNameX_BIFF5(blob) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var ixti = blob.read_shift(2, 'i'); // XtiIndex
	blob.l += 8;
	var nameindex = blob.read_shift(2);
	blob.l += 12;
	return [type, ixti, nameindex];
}

/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */
function parse_PtgMemArea(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	blob.l += (opts && opts.biff == 2 ? 3 : 4);
	var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	return [type, cce];
}

/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */
function parse_PtgMemFunc(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	return [type, cce];
}


/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */
function parse_PtgRefErr(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	blob.l += 4;
	if(opts.biff < 8) blob.l--;
	if(opts.biff == 12) blob.l += 2;
	return [type];
}

/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */
function parse_PtgRefErr3d(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var ixti = blob.read_shift(2);
	var w = 4;
	if(opts) switch(opts.biff) {
		case 5: w = 15; break;
		case 12: w = 6; break;
	}
	blob.l += w;
	return [type, ixti];
}

/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */
var parse_PtgMemErr = parsenoop;
/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */
var parse_PtgMemNoMem = parsenoop;
/* [MS-XLS] 2.5.198.92 */
var parse_PtgTbl = parsenoop;

function parse_PtgElfLoc(blob, length, opts) {
	blob.l += 2;
	return [parse_RgceElfLoc(blob, 4, opts)];
}
function parse_PtgElfNoop(blob) {
	blob.l += 6;
	return [];
}
/* [MS-XLS] 2.5.198.46 */
var parse_PtgElfCol = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.47 */
var parse_PtgElfColS = parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.48 */
var parse_PtgElfColSV = parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.49 */
var parse_PtgElfColV = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.50 */
function parse_PtgElfLel(blob) {
	blob.l += 2;
	return [parseuint16(blob), blob.read_shift(2) & 0x01];
}
/* [MS-XLS] 2.5.198.51 */
var parse_PtgElfRadical = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.52 */
var parse_PtgElfRadicalLel = parse_PtgElfLel;
/* [MS-XLS] 2.5.198.53 */
var parse_PtgElfRadicalS = parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.54 */
var parse_PtgElfRw = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.55 */
var parse_PtgElfRwV = parse_PtgElfLoc;

/* [MS-XLSB] 2.5.97.52 TODO */
var PtgListRT = [
	"Data",
	"All",
	"Headers",
	"??",
	"?Data2",
	"??",
	"?DataHeaders",
	"??",
	"Totals",
	"??",
	"??",
	"??",
	"?DataTotals",
	"??",
	"??",
	"??",
	"?Current"
];
function parse_PtgList(blob) {
	blob.l += 2;
	var ixti = blob.read_shift(2);
	var flags = blob.read_shift(2);
	var idx = blob.read_shift(4);
	var c = blob.read_shift(2);
	var C = blob.read_shift(2);
	var rt = PtgListRT[(flags >> 2) & 0x1F];
	return {ixti: ixti, coltype:(flags&0x3), rt:rt, idx:idx, c:c, C:C};
}
/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */
function parse_PtgSxName(blob) {
	blob.l += 2;
	return [blob.read_shift(4)];
}

/* [XLS] old spec */
function parse_PtgSheet(blob, length, opts) {
	blob.l += 5;
	blob.l += 2;
	blob.l += (opts.biff == 2 ? 1 : 4);
	return ["PTGSHEET"];
}
function parse_PtgEndSheet(blob, length, opts) {
	blob.l += (opts.biff == 2 ? 4 : 5);
	return ["PTGENDSHEET"];
}
function parse_PtgMemAreaN(blob) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var cce = blob.read_shift(2);
	return [type, cce];
}
function parse_PtgMemNoMemN(blob) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var cce = blob.read_shift(2);
	return [type, cce];
}
function parse_PtgAttrNoop(blob) {
	blob.l += 4;
	return [0, 0];
}

/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */
var PtgTypes = {
0x01: { n:'PtgExp', f:parse_PtgExp },
0x02: { n:'PtgTbl', f:parse_PtgTbl },
0x03: { n:'PtgAdd', f:parseread1 },
0x04: { n:'PtgSub', f:parseread1 },
0x05: { n:'PtgMul', f:parseread1 },
0x06: { n:'PtgDiv', f:parseread1 },
0x07: { n:'PtgPower', f:parseread1 },
0x08: { n:'PtgConcat', f:parseread1 },
0x09: { n:'PtgLt', f:parseread1 },
0x0A: { n:'PtgLe', f:parseread1 },
0x0B: { n:'PtgEq', f:parseread1 },
0x0C: { n:'PtgGe', f:parseread1 },
0x0D: { n:'PtgGt', f:parseread1 },
0x0E: { n:'PtgNe', f:parseread1 },
0x0F: { n:'PtgIsect', f:parseread1 },
0x10: { n:'PtgUnion', f:parseread1 },
0x11: { n:'PtgRange', f:parseread1 },
0x12: { n:'PtgUplus', f:parseread1 },
0x13: { n:'PtgUminus', f:parseread1 },
0x14: { n:'PtgPercent', f:parseread1 },
0x15: { n:'PtgParen', f:parseread1 },
0x16: { n:'PtgMissArg', f:parseread1 },
0x17: { n:'PtgStr', f:parse_PtgStr },
0x1A: { n:'PtgSheet', f:parse_PtgSheet },
0x1B: { n:'PtgEndSheet', f:parse_PtgEndSheet },
0x1C: { n:'PtgErr', f:parse_PtgErr },
0x1D: { n:'PtgBool', f:parse_PtgBool },
0x1E: { n:'PtgInt', f:parse_PtgInt },
0x1F: { n:'PtgNum', f:parse_PtgNum },
0x20: { n:'PtgArray', f:parse_PtgArray },
0x21: { n:'PtgFunc', f:parse_PtgFunc },
0x22: { n:'PtgFuncVar', f:parse_PtgFuncVar },
0x23: { n:'PtgName', f:parse_PtgName },
0x24: { n:'PtgRef', f:parse_PtgRef },
0x25: { n:'PtgArea', f:parse_PtgArea },
0x26: { n:'PtgMemArea', f:parse_PtgMemArea },
0x27: { n:'PtgMemErr', f:parse_PtgMemErr },
0x28: { n:'PtgMemNoMem', f:parse_PtgMemNoMem },
0x29: { n:'PtgMemFunc', f:parse_PtgMemFunc },
0x2A: { n:'PtgRefErr', f:parse_PtgRefErr },
0x2B: { n:'PtgAreaErr', f:parse_PtgAreaErr },
0x2C: { n:'PtgRefN', f:parse_PtgRefN },
0x2D: { n:'PtgAreaN', f:parse_PtgAreaN },
0x2E: { n:'PtgMemAreaN', f:parse_PtgMemAreaN },
0x2F: { n:'PtgMemNoMemN', f:parse_PtgMemNoMemN },
0x39: { n:'PtgNameX', f:parse_PtgNameX },
0x3A: { n:'PtgRef3d', f:parse_PtgRef3d },
0x3B: { n:'PtgArea3d', f:parse_PtgArea3d },
0x3C: { n:'PtgRefErr3d', f:parse_PtgRefErr3d },
0x3D: { n:'PtgAreaErr3d', f:parse_PtgAreaErr3d },
0xFF: {}
};
/* These are duplicated in the PtgTypes table */
var PtgDupes = {
0x40: 0x20, 0x60: 0x20,
0x41: 0x21, 0x61: 0x21,
0x42: 0x22, 0x62: 0x22,
0x43: 0x23, 0x63: 0x23,
0x44: 0x24, 0x64: 0x24,
0x45: 0x25, 0x65: 0x25,
0x46: 0x26, 0x66: 0x26,
0x47: 0x27, 0x67: 0x27,
0x48: 0x28, 0x68: 0x28,
0x49: 0x29, 0x69: 0x29,
0x4A: 0x2A, 0x6A: 0x2A,
0x4B: 0x2B, 0x6B: 0x2B,
0x4C: 0x2C, 0x6C: 0x2C,
0x4D: 0x2D, 0x6D: 0x2D,
0x4E: 0x2E, 0x6E: 0x2E,
0x4F: 0x2F, 0x6F: 0x2F,
0x58: 0x22, 0x78: 0x22,
0x59: 0x39, 0x79: 0x39,
0x5A: 0x3A, 0x7A: 0x3A,
0x5B: 0x3B, 0x7B: 0x3B,
0x5C: 0x3C, 0x7C: 0x3C,
0x5D: 0x3D, 0x7D: 0x3D
};
(function(){for(var y in PtgDupes) PtgTypes[y] = PtgTypes[PtgDupes[y]];})();

var Ptg18 = {
0x01: { n:'PtgElfLel', f:parse_PtgElfLel },
0x02: { n:'PtgElfRw', f:parse_PtgElfRw },
0x03: { n:'PtgElfCol', f:parse_PtgElfCol },
0x06: { n:'PtgElfRwV', f:parse_PtgElfRwV },
0x07: { n:'PtgElfColV', f:parse_PtgElfColV },
0x0A: { n:'PtgElfRadical', f:parse_PtgElfRadical },
0x0B: { n:'PtgElfRadicalS', f:parse_PtgElfRadicalS },
0x0D: { n:'PtgElfColS', f:parse_PtgElfColS },
0x0F: { n:'PtgElfColSV', f:parse_PtgElfColSV },
0x10: { n:'PtgElfRadicalLel', f:parse_PtgElfRadicalLel },
0x19: { n:'PtgList', f:parse_PtgList },
0x1D: { n:'PtgSxName', f:parse_PtgSxName },
0xFF: {}
};
var Ptg19 = {
0x00: { n:'PtgAttrNoop', f:parse_PtgAttrNoop },
0x01: { n:'PtgAttrSemi', f:parse_PtgAttrSemi },
0x02: { n:'PtgAttrIf', f:parse_PtgAttrIf },
0x04: { n:'PtgAttrChoose', f:parse_PtgAttrChoose },
0x08: { n:'PtgAttrGoto', f:parse_PtgAttrGoto },
0x10: { n:'PtgAttrSum', f:parse_PtgAttrSum },
0x20: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
0x40: { n:'PtgAttrSpace', f:parse_PtgAttrSpace },
0x41: { n:'PtgAttrSpaceSemi', f:parse_PtgAttrSpaceSemi },
0x80: { n:'PtgAttrIfError', f:parse_PtgAttrIfError },
0xFF: {}
};
Ptg19[0x21] = Ptg19[0x20];

/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */
function parse_RgbExtra(blob, length, rgce, opts) {
	if(opts.biff < 8) return parsenoop(blob, length);
	var target = blob.l + length;
	var o = [];
	for(var i = 0; i !== rgce.length; ++i) {
		switch(rgce[i][0]) {
			case 'PtgArray': /* PtgArray -> PtgExtraArray */
				rgce[i][1] = parse_PtgExtraArray(blob, 0, opts);
				o.push(rgce[i][1]);
				break;
			case 'PtgMemArea': /* PtgMemArea -> PtgExtraMem */
				rgce[i][2] = parse_PtgExtraMem(blob, rgce[i][1], opts);
				o.push(rgce[i][2]);
				break;
			case 'PtgExp': /* PtgExp -> PtgExtraCol */
				if(opts && opts.biff == 12) {
					rgce[i][1][1] = blob.read_shift(4);
					o.push(rgce[i][1]);
				} break;
			case 'PtgList': /* TODO: PtgList -> PtgExtraList */
			case 'PtgElfRadicalS': /* TODO: PtgElfRadicalS -> PtgExtraElf */
			case 'PtgElfColS': /* TODO: PtgElfColS -> PtgExtraElf */
			case 'PtgElfColSV': /* TODO: PtgElfColSV -> PtgExtraElf */
				throw "Unsupported " + rgce[i][0];
			default: break;
		}
	}
	length = target - blob.l;
	/* note: this is technically an error but Excel disregards */
	//if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
	if(length !== 0) o.push(parsenoop(blob, length));
	return o;
}

/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */
function parse_Rgce(blob, length, opts) {
	var target = blob.l + length;
	var R, id, ptgs = [];
	while(target != blob.l) {
		length = target - blob.l;
		id = blob[blob.l];
		R = PtgTypes[id];
		if(id === 0x18 || id === 0x19) R = (id === 0x18 ? Ptg18 : Ptg19)[blob[blob.l + 1]];
		if(!R || !R.f) { /*ptgs.push*/(parsenoop(blob, length)); }
		else { ptgs.push([R.n, R.f(blob, length, opts)]); }
	}
	return ptgs;
}

function stringify_array(f) {
	var o = [];
	for(var i = 0; i < f.length; ++i) {
		var x = f[i], r = [];
		for(var j = 0; j < x.length; ++j) {
			var y = x[j];
			if(y) switch(y[0]) {
				// TODO: handle embedded quotes
				case 0x02:
r.push('"' + y[1].replace(/"/g,'""') + '"'); break;
				default: r.push(y[1]);
			} else r.push("");
		}
		o.push(r.join(","));
	}
	return o.join(";");
}

/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */
var PtgBinOp = {
	PtgAdd: "+",
	PtgConcat: "&",
	PtgDiv: "/",
	PtgEq: "=",
	PtgGe: ">=",
	PtgGt: ">",
	PtgLe: "<=",
	PtgLt: "<",
	PtgMul: "*",
	PtgNe: "<>",
	PtgPower: "^",
	PtgSub: "-"
};
function formula_quote_sheet_name(sname, opts) {
	if(!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
	if(sname.indexOf(" ") > -1) return "'" + sname + "'";
	return sname;
}
function get_ixti_raw(supbooks, ixti, opts) {
	if(!supbooks) return "SH33TJSERR0";
	if(opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
	if(!supbooks.XTI) return "SH33TJSERR6";
	var XTI = supbooks.XTI[ixti];
	if(opts.biff < 8) {
		if(ixti > 10000) ixti-= 65536;
		if(ixti < 0) ixti = -ixti;
		return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
	}
	if(!XTI) return "SH33TJSERR1";
	var o = "";
	if(opts.biff > 8) switch(supbooks[XTI[0]][0]) {
		case 0x0165: /* 'BrtSupSelf' */
			o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
			return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
		case 0x0166: /* 'BrtSupSame' */
			if(opts.SID != null) return supbooks.SheetNames[opts.SID];
			return "SH33TJSSAME" + supbooks[XTI[0]][0];
		case 0x0163: /* 'BrtSupBookSrc' */
			/* falls through */
		default: return "SH33TJSSRC" + supbooks[XTI[0]][0];
	}
	switch(supbooks[XTI[0]][0][0]) {
		case 0x0401:
			o = XTI[1] == -1 ? "#REF" : (supbooks.SheetNames[XTI[1]] || "SH33TJSERR3");
			return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
		case 0x3A01: return supbooks[XTI[0]].slice(1).map(function(name) { return name.Name; }).join(";;"); //return "SH33TJSERR8";
		default:
			if(!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
			o = XTI[1] == -1 ? "#REF" : (supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4");
			return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
	}
}
function get_ixti(supbooks, ixti, opts) {
	return formula_quote_sheet_name(get_ixti_raw(supbooks, ixti, opts), opts);
}
function stringify_formula(formula/*Array<any>*/, range, cell, supbooks, opts) {
	var biff = (opts && opts.biff) || 8;
	var _range = /*range != null ? range :*/ {s:{c:0, r:0},e:{c:0, r:0}};
	var stack = [], e1, e2,  c, ixti=0, nameidx=0, r, sname="";
	if(!formula[0] || !formula[0][0]) return "";
	var last_sp = -1, sp = "";
	for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff) {
		var f = formula[0][ff];
		switch(f[0]) {
			case 'PtgUminus': /* [MS-XLS] 2.5.198.93 */
				stack.push("-" + stack.pop()); break;
			case 'PtgUplus': /* [MS-XLS] 2.5.198.95 */
				stack.push("+" + stack.pop()); break;
			case 'PtgPercent': /* [MS-XLS] 2.5.198.81 */
				stack.push(stack.pop() + "%"); break;

			case 'PtgAdd':    /* [MS-XLS] 2.5.198.26 */
			case 'PtgConcat': /* [MS-XLS] 2.5.198.43 */
			case 'PtgDiv':    /* [MS-XLS] 2.5.198.45 */
			case 'PtgEq':     /* [MS-XLS] 2.5.198.56 */
			case 'PtgGe':     /* [MS-XLS] 2.5.198.64 */
			case 'PtgGt':     /* [MS-XLS] 2.5.198.65 */
			case 'PtgLe':     /* [MS-XLS] 2.5.198.68 */
			case 'PtgLt':     /* [MS-XLS] 2.5.198.69 */
			case 'PtgMul':    /* [MS-XLS] 2.5.198.75 */
			case 'PtgNe':     /* [MS-XLS] 2.5.198.78 */
			case 'PtgPower':  /* [MS-XLS] 2.5.198.82 */
			case 'PtgSub':    /* [MS-XLS] 2.5.198.90 */
				e1 = stack.pop(); e2 = stack.pop();
				if(last_sp >= 0) {
					switch(formula[0][last_sp][1][0]) {
						case 0:
							// $FlowIgnore
							sp = fill(" ", formula[0][last_sp][1][1]); break;
						case 1:
							// $FlowIgnore
							sp = fill("\r", formula[0][last_sp][1][1]); break;
						default:
							sp = "";
							// $FlowIgnore
							if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
					}
					e2 = e2 + sp;
					last_sp = -1;
				}
				stack.push(e2+PtgBinOp[f[0]]+e1);
				break;

			case 'PtgIsect': /* [MS-XLS] 2.5.198.67 */
				e1 = stack.pop(); e2 = stack.pop();
				stack.push(e2+" "+e1);
				break;
			case 'PtgUnion': /* [MS-XLS] 2.5.198.94 */
				e1 = stack.pop(); e2 = stack.pop();
				stack.push(e2+","+e1);
				break;
			case 'PtgRange': /* [MS-XLS] 2.5.198.83 */
				e1 = stack.pop(); e2 = stack.pop();
				stack.push(e2+":"+e1);
				break;

			case 'PtgAttrChoose': /* [MS-XLS] 2.5.198.34 */
				break;
			case 'PtgAttrGoto': /* [MS-XLS] 2.5.198.35 */
				break;
			case 'PtgAttrIf': /* [MS-XLS] 2.5.198.36 */
				break;
			case 'PtgAttrIfError': /* [MS-XLSB] 2.5.97.28 */
				break;


			case 'PtgRef': /* [MS-XLS] 2.5.198.84 */
c = shift_cell_xls((f[1][1]), _range, opts);
				stack.push(encode_cell_xls(c, biff));
				break;
			case 'PtgRefN': /* [MS-XLS] 2.5.198.88 */
c = cell ? shift_cell_xls((f[1][1]), cell, opts) : (f[1][1]);
				stack.push(encode_cell_xls(c, biff));
				break;
			case 'PtgRef3d': /* [MS-XLS] 2.5.198.85 */
ixti = f[1][1]; c = shift_cell_xls((f[1][2]), _range, opts);
				sname = get_ixti(supbooks, ixti, opts);
				var w = sname; /* IE9 fails on defined names */ // eslint-disable-line no-unused-vars
				stack.push(sname + "!" + encode_cell_xls(c, biff));
				break;

			case 'PtgFunc': /* [MS-XLS] 2.5.198.62 */
			case 'PtgFuncVar': /* [MS-XLS] 2.5.198.63 */
				/* f[1] = [argc, func, type] */
				var argc = (f[1][0]), func = (f[1][1]);
				if(!argc) argc = 0;
				argc &= 0x7F;
				var args = argc == 0 ? [] : stack.slice(-argc);
				stack.length -= argc;
				if(func === 'User') func = args.shift();
				stack.push(func + "(" + args.join(",") + ")");
				break;

			case 'PtgBool': /* [MS-XLS] 2.5.198.42 */
				stack.push(f[1] ? "TRUE" : "FALSE"); break;
			case 'PtgInt': /* [MS-XLS] 2.5.198.66 */
				stack.push(f[1]); break;
			case 'PtgNum': /* [MS-XLS] 2.5.198.79 TODO: precision? */
				stack.push(String(f[1])); break;
			case 'PtgStr': /* [MS-XLS] 2.5.198.89 */
				// $FlowIgnore
				stack.push('"' + f[1].replace(/"/g, '""') + '"'); break;
			case 'PtgErr': /* [MS-XLS] 2.5.198.57 */
				stack.push(f[1]); break;
			case 'PtgAreaN': /* [MS-XLS] 2.5.198.31 TODO */
r = shift_range_xls(f[1][1], cell ? {s:cell} : _range, opts);
				stack.push(encode_range_xls((r), opts));
				break;
			case 'PtgArea': /* [MS-XLS] 2.5.198.27 TODO: fixed points */
r = shift_range_xls(f[1][1], _range, opts);
				stack.push(encode_range_xls((r), opts));
				break;
			case 'PtgArea3d': /* [MS-XLS] 2.5.198.28 TODO */
ixti = f[1][1]; r = f[1][2];
				sname = get_ixti(supbooks, ixti, opts);
				stack.push(sname + "!" + encode_range_xls((r), opts));
				break;
			case 'PtgAttrSum': /* [MS-XLS] 2.5.198.41 */
				stack.push("SUM(" + stack.pop() + ")");
				break;

			case 'PtgAttrBaxcel': /* [MS-XLS] 2.5.198.33 */
			case 'PtgAttrSemi': /* [MS-XLS] 2.5.198.37 */
				break;

			case 'PtgName': /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */
				/* f[1] = type, 0, nameindex */
				nameidx = (f[1][2]);
				var lbl = (supbooks.names||[])[nameidx-1] || (supbooks[0]||[])[nameidx];
				var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
				if(name in XLSXFutureFunctions) name = XLSXFutureFunctions[name];
				stack.push(name);
				break;

			case 'PtgNameX': /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */
				/* f[1] = type, ixti, nameindex */
				var bookidx = (f[1][1]); nameidx = (f[1][2]); var externbook;
				/* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */
				if(opts.biff <= 5) {
					if(bookidx < 0) bookidx = -bookidx;
					if(supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
				} else {
					var o = "";
					if(((supbooks[bookidx]||[])[0]||[])[0] == 0x3A01){/* empty */}
					else if(((supbooks[bookidx]||[])[0]||[])[0] == 0x0401){
						if(supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) {
							o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab-1] + "!";
						}
					}
					else o = supbooks.SheetNames[nameidx-1]+ "!";
					if(supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
					else if(supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
					else {
						var ixtidata = get_ixti_raw(supbooks, bookidx, opts).split(";;");
						if(ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
						else o += "SH33TJSERRX";
					}
					stack.push(o);
					break;
				}
				if(!externbook) externbook = {Name: "SH33TJSERRY"};
				stack.push(externbook.Name);
				break;

			case 'PtgParen': /* [MS-XLS] 2.5.198.80 */
				var lp = '(', rp = ')';
				if(last_sp >= 0) {
					sp = "";
					switch(formula[0][last_sp][1][0]) {
						// $FlowIgnore
						case 2: lp = fill(" ", formula[0][last_sp][1][1]) + lp; break;
						// $FlowIgnore
						case 3: lp = fill("\r", formula[0][last_sp][1][1]) + lp; break;
						// $FlowIgnore
						case 4: rp = fill(" ", formula[0][last_sp][1][1]) + rp; break;
						// $FlowIgnore
						case 5: rp = fill("\r", formula[0][last_sp][1][1]) + rp; break;
						default:
							// $FlowIgnore
							if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
					}
					last_sp = -1;
				}
				stack.push(lp + stack.pop() + rp); break;

			case 'PtgRefErr': /* [MS-XLS] 2.5.198.86 */
				stack.push('#REF!'); break;

			case 'PtgRefErr3d': /* [MS-XLS] 2.5.198.87 */
				stack.push('#REF!'); break;

			case 'PtgExp': /* [MS-XLS] 2.5.198.58 TODO */
				c = {c:(f[1][1]),r:(f[1][0])};
				var q = ({c: cell.c, r:cell.r});
				if(supbooks.sharedf[encode_cell(c)]) {
					var parsedf = (supbooks.sharedf[encode_cell(c)]);
					stack.push(stringify_formula(parsedf, _range, q, supbooks, opts));
				}
				else {
					var fnd = false;
					for(e1=0;e1!=supbooks.arrayf.length; ++e1) {
						/* TODO: should be something like range_has */
						e2 = supbooks.arrayf[e1];
						if(c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
						if(c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
						stack.push(stringify_formula(e2[1], _range, q, supbooks, opts));
						fnd = true;
						break;
					}
					if(!fnd) stack.push(f[1]);
				}
				break;

			case 'PtgArray': /* [MS-XLS] 2.5.198.32 TODO */
				stack.push("{" + stringify_array(f[1]) + "}");
				break;

			case 'PtgMemArea': /* [MS-XLS] 2.5.198.70 TODO: confirm this is a non-display */
				//stack.push("(" + f[2].map(encode_range).join(",") + ")");
				break;

			case 'PtgAttrSpace': /* [MS-XLS] 2.5.198.38 */
			case 'PtgAttrSpaceSemi': /* [MS-XLS] 2.5.198.39 */
				last_sp = ff;
				break;

			case 'PtgTbl': /* [MS-XLS] 2.5.198.92 TODO */
				break;

			case 'PtgMemErr': /* [MS-XLS] 2.5.198.71 */
				break;

			case 'PtgMissArg': /* [MS-XLS] 2.5.198.74 */
				stack.push("");
				break;

			case 'PtgAreaErr': /* [MS-XLS] 2.5.198.29 */
				stack.push("#REF!"); break;

			case 'PtgAreaErr3d': /* [MS-XLS] 2.5.198.30 */
				stack.push("#REF!"); break;

			case 'PtgList': /* [MS-XLSB] 2.5.97.52 */
				// $FlowIgnore
				stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
				break;

			case 'PtgMemAreaN':
			case 'PtgMemNoMemN':
			case 'PtgAttrNoop':
			case 'PtgSheet':
			case 'PtgEndSheet':
				break;

			case 'PtgMemFunc': /* [MS-XLS] 2.5.198.72 TODO */
				break;
			case 'PtgMemNoMem': /* [MS-XLS] 2.5.198.73 TODO */
				break;

			case 'PtgElfCol': /* [MS-XLS] 2.5.198.46 */
			case 'PtgElfColS': /* [MS-XLS] 2.5.198.47 */
			case 'PtgElfColSV': /* [MS-XLS] 2.5.198.48 */
			case 'PtgElfColV': /* [MS-XLS] 2.5.198.49 */
			case 'PtgElfLel': /* [MS-XLS] 2.5.198.50 */
			case 'PtgElfRadical': /* [MS-XLS] 2.5.198.51 */
			case 'PtgElfRadicalLel': /* [MS-XLS] 2.5.198.52 */
			case 'PtgElfRadicalS': /* [MS-XLS] 2.5.198.53 */
			case 'PtgElfRw': /* [MS-XLS] 2.5.198.54 */
			case 'PtgElfRwV': /* [MS-XLS] 2.5.198.55 */
				throw new Error("Unsupported ELFs");

			case 'PtgSxName': /* [MS-XLS] 2.5.198.91 TODO -- find a test case */
				throw new Error('Unrecognized Formula Token: ' + String(f));
			default: throw new Error('Unrecognized Formula Token: ' + String(f));
		}
		var PtgNonDisp = ['PtgAttrSpace', 'PtgAttrSpaceSemi', 'PtgAttrGoto'];
		if(opts.biff != 3) if(last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
			f = formula[0][last_sp];
			var _left = true;
			switch(f[1][0]) {
				/* note: some bad XLSB files omit the PtgParen */
				case 4: _left = false;
				/* falls through */
				case 0:
					// $FlowIgnore
					sp = fill(" ", f[1][1]); break;
				case 5: _left = false;
				/* falls through */
				case 1:
					// $FlowIgnore
					sp = fill("\r", f[1][1]); break;
				default:
					sp = "";
					// $FlowIgnore
					if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
			}
			stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
			last_sp = -1;
		}
	}
	if(stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
	return stack[0];
}

/* [MS-XLS] 2.5.198.1 TODO */
function parse_ArrayParsedFormula(blob, length, opts) {
	var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
	var rgcb, cce = blob.read_shift(len); // length of rgce
	if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
	var rgce = parse_Rgce(blob, cce, opts);
	if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
	blob.l = target;
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.198.3 TODO */
function parse_XLSCellParsedFormula(blob, length, opts) {
	var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
	var rgcb, cce = blob.read_shift(len); // length of rgce
	if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
	var rgce = parse_Rgce(blob, cce, opts);
	if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
	blob.l = target;
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.198.21 */
function parse_NameParsedFormula(blob, length, opts, cce) {
	var target = blob.l + length;
	var rgce = parse_Rgce(blob, cce, opts);
	var rgcb;
	if(target !== blob.l) rgcb = parse_RgbExtra(blob, target - blob.l, rgce, opts);
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.198.118 TODO */
function parse_SharedParsedFormula(blob, length, opts) {
	var target = blob.l + length;
	var rgcb, cce = blob.read_shift(2); // length of rgce
	var rgce = parse_Rgce(blob, cce, opts);
	if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
	if(length !== cce + 2) rgcb = parse_RgbExtra(blob, target - cce - 2, rgce, opts);
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */
function parse_FormulaValue(blob) {
	var b;
	if(__readUInt16LE(blob,blob.l + 6) !== 0xFFFF) return [parse_Xnum(blob),'n'];
	switch(blob[blob.l]) {
		case 0x00: blob.l += 8; return ["String", 's'];
		case 0x01: b = blob[blob.l+2] === 0x1; blob.l += 8; return [b,'b'];
		case 0x02: b = blob[blob.l+2]; blob.l += 8; return [b,'e'];
		case 0x03: blob.l += 8; return ["",'s'];
	}
	return [];
}

/* [MS-XLS] 2.4.127 TODO */
function parse_Formula(blob, length, opts) {
	var end = blob.l + length;
	var cell = parse_XLSCell(blob, 6);
	if(opts.biff == 2) ++blob.l;
	var val = parse_FormulaValue(blob,8);
	var flags = blob.read_shift(1);
	if(opts.biff != 2) {
		blob.read_shift(1);
		if(opts.biff >= 5) {
			/*var chn = */blob.read_shift(4);
		}
	}
	var cbf = parse_XLSCellParsedFormula(blob, end - blob.l, opts);
	return {cell:cell, val:val[0], formula:cbf, shared: (flags >> 3) & 1, tt:val[1]};
}

/* XLSB Parsed Formula records have the same shape */
function parse_XLSBParsedFormula(data, length, opts) {
	var cce = data.read_shift(4);
	var rgce = parse_Rgce(data, cce, opts);
	var cb = data.read_shift(4);
	var rgcb = cb > 0 ? parse_RgbExtra(data, cb, rgce, opts) : null;
	return [rgce, rgcb];
}

/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */
var parse_XLSBArrayParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.4 CellParsedFormula */
var parse_XLSBCellParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */
var parse_XLSBNameParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */
var parse_XLSBSharedParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLS] 2.5.198.4 */
var Cetab = {
0x0000: 'BEEP',
0x0001: 'OPEN',
0x0002: 'OPEN.LINKS',
0x0003: 'CLOSE.ALL',
0x0004: 'SAVE',
0x0005: 'SAVE.AS',
0x0006: 'FILE.DELETE',
0x0007: 'PAGE.SETUP',
0x0008: 'PRINT',
0x0009: 'PRINTER.SETUP',
0x000A: 'QUIT',
0x000B: 'NEW.WINDOW',
0x000C: 'ARRANGE.ALL',
0x000D: 'WINDOW.SIZE',
0x000E: 'WINDOW.MOVE',
0x000F: 'FULL',
0x0010: 'CLOSE',
0x0011: 'RUN',
0x0016: 'SET.PRINT.AREA',
0x0017: 'SET.PRINT.TITLES',
0x0018: 'SET.PAGE.BREAK',
0x0019: 'REMOVE.PAGE.BREAK',
0x001A: 'FONT',
0x001B: 'DISPLAY',
0x001C: 'PROTECT.DOCUMENT',
0x001D: 'PRECISION',
0x001E: 'A1.R1C1',
0x001F: 'CALCULATE.NOW',
0x0020: 'CALCULATION',
0x0022: 'DATA.FIND',
0x0023: 'EXTRACT',
0x0024: 'DATA.DELETE',
0x0025: 'SET.DATABASE',
0x0026: 'SET.CRITERIA',
0x0027: 'SORT',
0x0028: 'DATA.SERIES',
0x0029: 'TABLE',
0x002A: 'FORMAT.NUMBER',
0x002B: 'ALIGNMENT',
0x002C: 'STYLE',
0x002D: 'BORDER',
0x002E: 'CELL.PROTECTION',
0x002F: 'COLUMN.WIDTH',
0x0030: 'UNDO',
0x0031: 'CUT',
0x0032: 'COPY',
0x0033: 'PASTE',
0x0034: 'CLEAR',
0x0035: 'PASTE.SPECIAL',
0x0036: 'EDIT.DELETE',
0x0037: 'INSERT',
0x0038: 'FILL.RIGHT',
0x0039: 'FILL.DOWN',
0x003D: 'DEFINE.NAME',
0x003E: 'CREATE.NAMES',
0x003F: 'FORMULA.GOTO',
0x0040: 'FORMULA.FIND',
0x0041: 'SELECT.LAST.CELL',
0x0042: 'SHOW.ACTIVE.CELL',
0x0043: 'GALLERY.AREA',
0x0044: 'GALLERY.BAR',
0x0045: 'GALLERY.COLUMN',
0x0046: 'GALLERY.LINE',
0x0047: 'GALLERY.PIE',
0x0048: 'GALLERY.SCATTER',
0x0049: 'COMBINATION',
0x004A: 'PREFERRED',
0x004B: 'ADD.OVERLAY',
0x004C: 'GRIDLINES',
0x004D: 'SET.PREFERRED',
0x004E: 'AXES',
0x004F: 'LEGEND',
0x0050: 'ATTACH.TEXT',
0x0051: 'ADD.ARROW',
0x0052: 'SELECT.CHART',
0x0053: 'SELECT.PLOT.AREA',
0x0054: 'PATTERNS',
0x0055: 'MAIN.CHART',
0x0056: 'OVERLAY',
0x0057: 'SCALE',
0x0058: 'FORMAT.LEGEND',
0x0059: 'FORMAT.TEXT',
0x005A: 'EDIT.REPEAT',
0x005B: 'PARSE',
0x005C: 'JUSTIFY',
0x005D: 'HIDE',
0x005E: 'UNHIDE',
0x005F: 'WORKSPACE',
0x0060: 'FORMULA',
0x0061: 'FORMULA.FILL',
0x0062: 'FORMULA.ARRAY',
0x0063: 'DATA.FIND.NEXT',
0x0064: 'DATA.FIND.PREV',
0x0065: 'FORMULA.FIND.NEXT',
0x0066: 'FORMULA.FIND.PREV',
0x0067: 'ACTIVATE',
0x0068: 'ACTIVATE.NEXT',
0x0069: 'ACTIVATE.PREV',
0x006A: 'UNLOCKED.NEXT',
0x006B: 'UNLOCKED.PREV',
0x006C: 'COPY.PICTURE',
0x006D: 'SELECT',
0x006E: 'DELETE.NAME',
0x006F: 'DELETE.FORMAT',
0x0070: 'VLINE',
0x0071: 'HLINE',
0x0072: 'VPAGE',
0x0073: 'HPAGE',
0x0074: 'VSCROLL',
0x0075: 'HSCROLL',
0x0076: 'ALERT',
0x0077: 'NEW',
0x0078: 'CANCEL.COPY',
0x0079: 'SHOW.CLIPBOARD',
0x007A: 'MESSAGE',
0x007C: 'PASTE.LINK',
0x007D: 'APP.ACTIVATE',
0x007E: 'DELETE.ARROW',
0x007F: 'ROW.HEIGHT',
0x0080: 'FORMAT.MOVE',
0x0081: 'FORMAT.SIZE',
0x0082: 'FORMULA.REPLACE',
0x0083: 'SEND.KEYS',
0x0084: 'SELECT.SPECIAL',
0x0085: 'APPLY.NAMES',
0x0086: 'REPLACE.FONT',
0x0087: 'FREEZE.PANES',
0x0088: 'SHOW.INFO',
0x0089: 'SPLIT',
0x008A: 'ON.WINDOW',
0x008B: 'ON.DATA',
0x008C: 'DISABLE.INPUT',
0x008E: 'OUTLINE',
0x008F: 'LIST.NAMES',
0x0090: 'FILE.CLOSE',
0x0091: 'SAVE.WORKBOOK',
0x0092: 'DATA.FORM',
0x0093: 'COPY.CHART',
0x0094: 'ON.TIME',
0x0095: 'WAIT',
0x0096: 'FORMAT.FONT',
0x0097: 'FILL.UP',
0x0098: 'FILL.LEFT',
0x0099: 'DELETE.OVERLAY',
0x009B: 'SHORT.MENUS',
0x009F: 'SET.UPDATE.STATUS',
0x00A1: 'COLOR.PALETTE',
0x00A2: 'DELETE.STYLE',
0x00A3: 'WINDOW.RESTORE',
0x00A4: 'WINDOW.MAXIMIZE',
0x00A6: 'CHANGE.LINK',
0x00A7: 'CALCULATE.DOCUMENT',
0x00A8: 'ON.KEY',
0x00A9: 'APP.RESTORE',
0x00AA: 'APP.MOVE',
0x00AB: 'APP.SIZE',
0x00AC: 'APP.MINIMIZE',
0x00AD: 'APP.MAXIMIZE',
0x00AE: 'BRING.TO.FRONT',
0x00AF: 'SEND.TO.BACK',
0x00B9: 'MAIN.CHART.TYPE',
0x00BA: 'OVERLAY.CHART.TYPE',
0x00BB: 'SELECT.END',
0x00BC: 'OPEN.MAIL',
0x00BD: 'SEND.MAIL',
0x00BE: 'STANDARD.FONT',
0x00BF: 'CONSOLIDATE',
0x00C0: 'SORT.SPECIAL',
0x00C1: 'GALLERY.3D.AREA',
0x00C2: 'GALLERY.3D.COLUMN',
0x00C3: 'GALLERY.3D.LINE',
0x00C4: 'GALLERY.3D.PIE',
0x00C5: 'VIEW.3D',
0x00C6: 'GOAL.SEEK',
0x00C7: 'WORKGROUP',
0x00C8: 'FILL.GROUP',
0x00C9: 'UPDATE.LINK',
0x00CA: 'PROMOTE',
0x00CB: 'DEMOTE',
0x00CC: 'SHOW.DETAIL',
0x00CE: 'UNGROUP',
0x00CF: 'OBJECT.PROPERTIES',
0x00D0: 'SAVE.NEW.OBJECT',
0x00D1: 'SHARE',
0x00D2: 'SHARE.NAME',
0x00D3: 'DUPLICATE',
0x00D4: 'APPLY.STYLE',
0x00D5: 'ASSIGN.TO.OBJECT',
0x00D6: 'OBJECT.PROTECTION',
0x00D7: 'HIDE.OBJECT',
0x00D8: 'SET.EXTRACT',
0x00D9: 'CREATE.PUBLISHER',
0x00DA: 'SUBSCRIBE.TO',
0x00DB: 'ATTRIBUTES',
0x00DC: 'SHOW.TOOLBAR',
0x00DE: 'PRINT.PREVIEW',
0x00DF: 'EDIT.COLOR',
0x00E0: 'SHOW.LEVELS',
0x00E1: 'FORMAT.MAIN',
0x00E2: 'FORMAT.OVERLAY',
0x00E3: 'ON.RECALC',
0x00E4: 'EDIT.SERIES',
0x00E5: 'DEFINE.STYLE',
0x00F0: 'LINE.PRINT',
0x00F3: 'ENTER.DATA',
0x00F9: 'GALLERY.RADAR',
0x00FA: 'MERGE.STYLES',
0x00FB: 'EDITION.OPTIONS',
0x00FC: 'PASTE.PICTURE',
0x00FD: 'PASTE.PICTURE.LINK',
0x00FE: 'SPELLING',
0x0100: 'ZOOM',
0x0103: 'INSERT.OBJECT',
0x0104: 'WINDOW.MINIMIZE',
0x0109: 'SOUND.NOTE',
0x010A: 'SOUND.PLAY',
0x010B: 'FORMAT.SHAPE',
0x010C: 'EXTEND.POLYGON',
0x010D: 'FORMAT.AUTO',
0x0110: 'GALLERY.3D.BAR',
0x0111: 'GALLERY.3D.SURFACE',
0x0112: 'FILL.AUTO',
0x0114: 'CUSTOMIZE.TOOLBAR',
0x0115: 'ADD.TOOL',
0x0116: 'EDIT.OBJECT',
0x0117: 'ON.DOUBLECLICK',
0x0118: 'ON.ENTRY',
0x0119: 'WORKBOOK.ADD',
0x011A: 'WORKBOOK.MOVE',
0x011B: 'WORKBOOK.COPY',
0x011C: 'WORKBOOK.OPTIONS',
0x011D: 'SAVE.WORKSPACE',
0x0120: 'CHART.WIZARD',
0x0121: 'DELETE.TOOL',
0x0122: 'MOVE.TOOL',
0x0123: 'WORKBOOK.SELECT',
0x0124: 'WORKBOOK.ACTIVATE',
0x0125: 'ASSIGN.TO.TOOL',
0x0127: 'COPY.TOOL',
0x0128: 'RESET.TOOL',
0x0129: 'CONSTRAIN.NUMERIC',
0x012A: 'PASTE.TOOL',
0x012E: 'WORKBOOK.NEW',
0x0131: 'SCENARIO.CELLS',
0x0132: 'SCENARIO.DELETE',
0x0133: 'SCENARIO.ADD',
0x0134: 'SCENARIO.EDIT',
0x0135: 'SCENARIO.SHOW',
0x0136: 'SCENARIO.SHOW.NEXT',
0x0137: 'SCENARIO.SUMMARY',
0x0138: 'PIVOT.TABLE.WIZARD',
0x0139: 'PIVOT.FIELD.PROPERTIES',
0x013A: 'PIVOT.FIELD',
0x013B: 'PIVOT.ITEM',
0x013C: 'PIVOT.ADD.FIELDS',
0x013E: 'OPTIONS.CALCULATION',
0x013F: 'OPTIONS.EDIT',
0x0140: 'OPTIONS.VIEW',
0x0141: 'ADDIN.MANAGER',
0x0142: 'MENU.EDITOR',
0x0143: 'ATTACH.TOOLBARS',
0x0144: 'VBAActivate',
0x0145: 'OPTIONS.CHART',
0x0148: 'VBA.INSERT.FILE',
0x014A: 'VBA.PROCEDURE.DEFINITION',
0x0150: 'ROUTING.SLIP',
0x0152: 'ROUTE.DOCUMENT',
0x0153: 'MAIL.LOGON',
0x0156: 'INSERT.PICTURE',
0x0157: 'EDIT.TOOL',
0x0158: 'GALLERY.DOUGHNUT',
0x015E: 'CHART.TREND',
0x0160: 'PIVOT.ITEM.PROPERTIES',
0x0162: 'WORKBOOK.INSERT',
0x0163: 'OPTIONS.TRANSITION',
0x0164: 'OPTIONS.GENERAL',
0x0172: 'FILTER.ADVANCED',
0x0175: 'MAIL.ADD.MAILER',
0x0176: 'MAIL.DELETE.MAILER',
0x0177: 'MAIL.REPLY',
0x0178: 'MAIL.REPLY.ALL',
0x0179: 'MAIL.FORWARD',
0x017A: 'MAIL.NEXT.LETTER',
0x017B: 'DATA.LABEL',
0x017C: 'INSERT.TITLE',
0x017D: 'FONT.PROPERTIES',
0x017E: 'MACRO.OPTIONS',
0x017F: 'WORKBOOK.HIDE',
0x0180: 'WORKBOOK.UNHIDE',
0x0181: 'WORKBOOK.DELETE',
0x0182: 'WORKBOOK.NAME',
0x0184: 'GALLERY.CUSTOM',
0x0186: 'ADD.CHART.AUTOFORMAT',
0x0187: 'DELETE.CHART.AUTOFORMAT',
0x0188: 'CHART.ADD.DATA',
0x0189: 'AUTO.OUTLINE',
0x018A: 'TAB.ORDER',
0x018B: 'SHOW.DIALOG',
0x018C: 'SELECT.ALL',
0x018D: 'UNGROUP.SHEETS',
0x018E: 'SUBTOTAL.CREATE',
0x018F: 'SUBTOTAL.REMOVE',
0x0190: 'RENAME.OBJECT',
0x019C: 'WORKBOOK.SCROLL',
0x019D: 'WORKBOOK.NEXT',
0x019E: 'WORKBOOK.PREV',
0x019F: 'WORKBOOK.TAB.SPLIT',
0x01A0: 'FULL.SCREEN',
0x01A1: 'WORKBOOK.PROTECT',
0x01A4: 'SCROLLBAR.PROPERTIES',
0x01A5: 'PIVOT.SHOW.PAGES',
0x01A6: 'TEXT.TO.COLUMNS',
0x01A7: 'FORMAT.CHARTTYPE',
0x01A8: 'LINK.FORMAT',
0x01A9: 'TRACER.DISPLAY',
0x01AE: 'TRACER.NAVIGATE',
0x01AF: 'TRACER.CLEAR',
0x01B0: 'TRACER.ERROR',
0x01B1: 'PIVOT.FIELD.GROUP',
0x01B2: 'PIVOT.FIELD.UNGROUP',
0x01B3: 'CHECKBOX.PROPERTIES',
0x01B4: 'LABEL.PROPERTIES',
0x01B5: 'LISTBOX.PROPERTIES',
0x01B6: 'EDITBOX.PROPERTIES',
0x01B7: 'PIVOT.REFRESH',
0x01B8: 'LINK.COMBO',
0x01B9: 'OPEN.TEXT',
0x01BA: 'HIDE.DIALOG',
0x01BB: 'SET.DIALOG.FOCUS',
0x01BC: 'ENABLE.OBJECT',
0x01BD: 'PUSHBUTTON.PROPERTIES',
0x01BE: 'SET.DIALOG.DEFAULT',
0x01BF: 'FILTER',
0x01C0: 'FILTER.SHOW.ALL',
0x01C1: 'CLEAR.OUTLINE',
0x01C2: 'FUNCTION.WIZARD',
0x01C3: 'ADD.LIST.ITEM',
0x01C4: 'SET.LIST.ITEM',
0x01C5: 'REMOVE.LIST.ITEM',
0x01C6: 'SELECT.LIST.ITEM',
0x01C7: 'SET.CONTROL.VALUE',
0x01C8: 'SAVE.COPY.AS',
0x01CA: 'OPTIONS.LISTS.ADD',
0x01CB: 'OPTIONS.LISTS.DELETE',
0x01CC: 'SERIES.AXES',
0x01CD: 'SERIES.X',
0x01CE: 'SERIES.Y',
0x01CF: 'ERRORBAR.X',
0x01D0: 'ERRORBAR.Y',
0x01D1: 'FORMAT.CHART',
0x01D2: 'SERIES.ORDER',
0x01D3: 'MAIL.LOGOFF',
0x01D4: 'CLEAR.ROUTING.SLIP',
0x01D5: 'APP.ACTIVATE.MICROSOFT',
0x01D6: 'MAIL.EDIT.MAILER',
0x01D7: 'ON.SHEET',
0x01D8: 'STANDARD.WIDTH',
0x01D9: 'SCENARIO.MERGE',
0x01DA: 'SUMMARY.INFO',
0x01DB: 'FIND.FILE',
0x01DC: 'ACTIVE.CELL.FONT',
0x01DD: 'ENABLE.TIPWIZARD',
0x01DE: 'VBA.MAKE.ADDIN',
0x01E0: 'INSERTDATATABLE',
0x01E1: 'WORKGROUP.OPTIONS',
0x01E2: 'MAIL.SEND.MAILER',
0x01E5: 'AUTOCORRECT',
0x01E9: 'POST.DOCUMENT',
0x01EB: 'PICKLIST',
0x01ED: 'VIEW.SHOW',
0x01EE: 'VIEW.DEFINE',
0x01EF: 'VIEW.DELETE',
0x01FD: 'SHEET.BACKGROUND',
0x01FE: 'INSERT.MAP.OBJECT',
0x01FF: 'OPTIONS.MENONO',
0x0205: 'MSOCHECKS',
0x0206: 'NORMAL',
0x0207: 'LAYOUT',
0x0208: 'RM.PRINT.AREA',
0x0209: 'CLEAR.PRINT.AREA',
0x020A: 'ADD.PRINT.AREA',
0x020B: 'MOVE.BRK',
0x0221: 'HIDECURR.NOTE',
0x0222: 'HIDEALL.NOTES',
0x0223: 'DELETE.NOTE',
0x0224: 'TRAVERSE.NOTES',
0x0225: 'ACTIVATE.NOTES',
0x026C: 'PROTECT.REVISIONS',
0x026D: 'UNPROTECT.REVISIONS',
0x0287: 'OPTIONS.ME',
0x028D: 'WEB.PUBLISH',
0x029B: 'NEWWEBQUERY',
0x02A1: 'PIVOT.TABLE.CHART',
0x02F1: 'OPTIONS.SAVE',
0x02F3: 'OPTIONS.SPELL',
0x0328: 'HIDEALL.INKANNOTS'
};

/* [MS-XLS] 2.5.198.17 */
/* [MS-XLSB] 2.5.97.10 */
var Ftab = {
0x0000: 'COUNT',
0x0001: 'IF',
0x0002: 'ISNA',
0x0003: 'ISERROR',
0x0004: 'SUM',
0x0005: 'AVERAGE',
0x0006: 'MIN',
0x0007: 'MAX',
0x0008: 'ROW',
0x0009: 'COLUMN',
0x000A: 'NA',
0x000B: 'NPV',
0x000C: 'STDEV',
0x000D: 'DOLLAR',
0x000E: 'FIXED',
0x000F: 'SIN',
0x0010: 'COS',
0x0011: 'TAN',
0x0012: 'ATAN',
0x0013: 'PI',
0x0014: 'SQRT',
0x0015: 'EXP',
0x0016: 'LN',
0x0017: 'LOG10',
0x0018: 'ABS',
0x0019: 'INT',
0x001A: 'SIGN',
0x001B: 'ROUND',
0x001C: 'LOOKUP',
0x001D: 'INDEX',
0x001E: 'REPT',
0x001F: 'MID',
0x0020: 'LEN',
0x0021: 'VALUE',
0x0022: 'TRUE',
0x0023: 'FALSE',
0x0024: 'AND',
0x0025: 'OR',
0x0026: 'NOT',
0x0027: 'MOD',
0x0028: 'DCOUNT',
0x0029: 'DSUM',
0x002A: 'DAVERAGE',
0x002B: 'DMIN',
0x002C: 'DMAX',
0x002D: 'DSTDEV',
0x002E: 'VAR',
0x002F: 'DVAR',
0x0030: 'TEXT',
0x0031: 'LINEST',
0x0032: 'TREND',
0x0033: 'LOGEST',
0x0034: 'GROWTH',
0x0035: 'GOTO',
0x0036: 'HALT',
0x0037: 'RETURN',
0x0038: 'PV',
0x0039: 'FV',
0x003A: 'NPER',
0x003B: 'PMT',
0x003C: 'RATE',
0x003D: 'MIRR',
0x003E: 'IRR',
0x003F: 'RAND',
0x0040: 'MATCH',
0x0041: 'DATE',
0x0042: 'TIME',
0x0043: 'DAY',
0x0044: 'MONTH',
0x0045: 'YEAR',
0x0046: 'WEEKDAY',
0x0047: 'HOUR',
0x0048: 'MINUTE',
0x0049: 'SECOND',
0x004A: 'NOW',
0x004B: 'AREAS',
0x004C: 'ROWS',
0x004D: 'COLUMNS',
0x004E: 'OFFSET',
0x004F: 'ABSREF',
0x0050: 'RELREF',
0x0051: 'ARGUMENT',
0x0052: 'SEARCH',
0x0053: 'TRANSPOSE',
0x0054: 'ERROR',
0x0055: 'STEP',
0x0056: 'TYPE',
0x0057: 'ECHO',
0x0058: 'SET.NAME',
0x0059: 'CALLER',
0x005A: 'DEREF',
0x005B: 'WINDOWS',
0x005C: 'SERIES',
0x005D: 'DOCUMENTS',
0x005E: 'ACTIVE.CELL',
0x005F: 'SELECTION',
0x0060: 'RESULT',
0x0061: 'ATAN2',
0x0062: 'ASIN',
0x0063: 'ACOS',
0x0064: 'CHOOSE',
0x0065: 'HLOOKUP',
0x0066: 'VLOOKUP',
0x0067: 'LINKS',
0x0068: 'INPUT',
0x0069: 'ISREF',
0x006A: 'GET.FORMULA',
0x006B: 'GET.NAME',
0x006C: 'SET.VALUE',
0x006D: 'LOG',
0x006E: 'EXEC',
0x006F: 'CHAR',
0x0070: 'LOWER',
0x0071: 'UPPER',
0x0072: 'PROPER',
0x0073: 'LEFT',
0x0074: 'RIGHT',
0x0075: 'EXACT',
0x0076: 'TRIM',
0x0077: 'REPLACE',
0x0078: 'SUBSTITUTE',
0x0079: 'CODE',
0x007A: 'NAMES',
0x007B: 'DIRECTORY',
0x007C: 'FIND',
0x007D: 'CELL',
0x007E: 'ISERR',
0x007F: 'ISTEXT',
0x0080: 'ISNUMBER',
0x0081: 'ISBLANK',
0x0082: 'T',
0x0083: 'N',
0x0084: 'FOPEN',
0x0085: 'FCLOSE',
0x0086: 'FSIZE',
0x0087: 'FREADLN',
0x0088: 'FREAD',
0x0089: 'FWRITELN',
0x008A: 'FWRITE',
0x008B: 'FPOS',
0x008C: 'DATEVALUE',
0x008D: 'TIMEVALUE',
0x008E: 'SLN',
0x008F: 'SYD',
0x0090: 'DDB',
0x0091: 'GET.DEF',
0x0092: 'REFTEXT',
0x0093: 'TEXTREF',
0x0094: 'INDIRECT',
0x0095: 'REGISTER',
0x0096: 'CALL',
0x0097: 'ADD.BAR',
0x0098: 'ADD.MENU',
0x0099: 'ADD.COMMAND',
0x009A: 'ENABLE.COMMAND',
0x009B: 'CHECK.COMMAND',
0x009C: 'RENAME.COMMAND',
0x009D: 'SHOW.BAR',
0x009E: 'DELETE.MENU',
0x009F: 'DELETE.COMMAND',
0x00A0: 'GET.CHART.ITEM',
0x00A1: 'DIALOG.BOX',
0x00A2: 'CLEAN',
0x00A3: 'MDETERM',
0x00A4: 'MINVERSE',
0x00A5: 'MMULT',
0x00A6: 'FILES',
0x00A7: 'IPMT',
0x00A8: 'PPMT',
0x00A9: 'COUNTA',
0x00AA: 'CANCEL.KEY',
0x00AB: 'FOR',
0x00AC: 'WHILE',
0x00AD: 'BREAK',
0x00AE: 'NEXT',
0x00AF: 'INITIATE',
0x00B0: 'REQUEST',
0x00B1: 'POKE',
0x00B2: 'EXECUTE',
0x00B3: 'TERMINATE',
0x00B4: 'RESTART',
0x00B5: 'HELP',
0x00B6: 'GET.BAR',
0x00B7: 'PRODUCT',
0x00B8: 'FACT',
0x00B9: 'GET.CELL',
0x00BA: 'GET.WORKSPACE',
0x00BB: 'GET.WINDOW',
0x00BC: 'GET.DOCUMENT',
0x00BD: 'DPRODUCT',
0x00BE: 'ISNONTEXT',
0x00BF: 'GET.NOTE',
0x00C0: 'NOTE',
0x00C1: 'STDEVP',
0x00C2: 'VARP',
0x00C3: 'DSTDEVP',
0x00C4: 'DVARP',
0x00C5: 'TRUNC',
0x00C6: 'ISLOGICAL',
0x00C7: 'DCOUNTA',
0x00C8: 'DELETE.BAR',
0x00C9: 'UNREGISTER',
0x00CC: 'USDOLLAR',
0x00CD: 'FINDB',
0x00CE: 'SEARCHB',
0x00CF: 'REPLACEB',
0x00D0: 'LEFTB',
0x00D1: 'RIGHTB',
0x00D2: 'MIDB',
0x00D3: 'LENB',
0x00D4: 'ROUNDUP',
0x00D5: 'ROUNDDOWN',
0x00D6: 'ASC',
0x00D7: 'DBCS',
0x00D8: 'RANK',
0x00DB: 'ADDRESS',
0x00DC: 'DAYS360',
0x00DD: 'TODAY',
0x00DE: 'VDB',
0x00DF: 'ELSE',
0x00E0: 'ELSE.IF',
0x00E1: 'END.IF',
0x00E2: 'FOR.CELL',
0x00E3: 'MEDIAN',
0x00E4: 'SUMPRODUCT',
0x00E5: 'SINH',
0x00E6: 'COSH',
0x00E7: 'TANH',
0x00E8: 'ASINH',
0x00E9: 'ACOSH',
0x00EA: 'ATANH',
0x00EB: 'DGET',
0x00EC: 'CREATE.OBJECT',
0x00ED: 'VOLATILE',
0x00EE: 'LAST.ERROR',
0x00EF: 'CUSTOM.UNDO',
0x00F0: 'CUSTOM.REPEAT',
0x00F1: 'FORMULA.CONVERT',
0x00F2: 'GET.LINK.INFO',
0x00F3: 'TEXT.BOX',
0x00F4: 'INFO',
0x00F5: 'GROUP',
0x00F6: 'GET.OBJECT',
0x00F7: 'DB',
0x00F8: 'PAUSE',
0x00FB: 'RESUME',
0x00FC: 'FREQUENCY',
0x00FD: 'ADD.TOOLBAR',
0x00FE: 'DELETE.TOOLBAR',
0x00FF: 'User',
0x0100: 'RESET.TOOLBAR',
0x0101: 'EVALUATE',
0x0102: 'GET.TOOLBAR',
0x0103: 'GET.TOOL',
0x0104: 'SPELLING.CHECK',
0x0105: 'ERROR.TYPE',
0x0106: 'APP.TITLE',
0x0107: 'WINDOW.TITLE',
0x0108: 'SAVE.TOOLBAR',
0x0109: 'ENABLE.TOOL',
0x010A: 'PRESS.TOOL',
0x010B: 'REGISTER.ID',
0x010C: 'GET.WORKBOOK',
0x010D: 'AVEDEV',
0x010E: 'BETADIST',
0x010F: 'GAMMALN',
0x0110: 'BETAINV',
0x0111: 'BINOMDIST',
0x0112: 'CHIDIST',
0x0113: 'CHIINV',
0x0114: 'COMBIN',
0x0115: 'CONFIDENCE',
0x0116: 'CRITBINOM',
0x0117: 'EVEN',
0x0118: 'EXPONDIST',
0x0119: 'FDIST',
0x011A: 'FINV',
0x011B: 'FISHER',
0x011C: 'FISHERINV',
0x011D: 'FLOOR',
0x011E: 'GAMMADIST',
0x011F: 'GAMMAINV',
0x0120: 'CEILING',
0x0121: 'HYPGEOMDIST',
0x0122: 'LOGNORMDIST',
0x0123: 'LOGINV',
0x0124: 'NEGBINOMDIST',
0x0125: 'NORMDIST',
0x0126: 'NORMSDIST',
0x0127: 'NORMINV',
0x0128: 'NORMSINV',
0x0129: 'STANDARDIZE',
0x012A: 'ODD',
0x012B: 'PERMUT',
0x012C: 'POISSON',
0x012D: 'TDIST',
0x012E: 'WEIBULL',
0x012F: 'SUMXMY2',
0x0130: 'SUMX2MY2',
0x0131: 'SUMX2PY2',
0x0132: 'CHITEST',
0x0133: 'CORREL',
0x0134: 'COVAR',
0x0135: 'FORECAST',
0x0136: 'FTEST',
0x0137: 'INTERCEPT',
0x0138: 'PEARSON',
0x0139: 'RSQ',
0x013A: 'STEYX',
0x013B: 'SLOPE',
0x013C: 'TTEST',
0x013D: 'PROB',
0x013E: 'DEVSQ',
0x013F: 'GEOMEAN',
0x0140: 'HARMEAN',
0x0141: 'SUMSQ',
0x0142: 'KURT',
0x0143: 'SKEW',
0x0144: 'ZTEST',
0x0145: 'LARGE',
0x0146: 'SMALL',
0x0147: 'QUARTILE',
0x0148: 'PERCENTILE',
0x0149: 'PERCENTRANK',
0x014A: 'MODE',
0x014B: 'TRIMMEAN',
0x014C: 'TINV',
0x014E: 'MOVIE.COMMAND',
0x014F: 'GET.MOVIE',
0x0150: 'CONCATENATE',
0x0151: 'POWER',
0x0152: 'PIVOT.ADD.DATA',
0x0153: 'GET.PIVOT.TABLE',
0x0154: 'GET.PIVOT.FIELD',
0x0155: 'GET.PIVOT.ITEM',
0x0156: 'RADIANS',
0x0157: 'DEGREES',
0x0158: 'SUBTOTAL',
0x0159: 'SUMIF',
0x015A: 'COUNTIF',
0x015B: 'COUNTBLANK',
0x015C: 'SCENARIO.GET',
0x015D: 'OPTIONS.LISTS.GET',
0x015E: 'ISPMT',
0x015F: 'DATEDIF',
0x0160: 'DATESTRING',
0x0161: 'NUMBERSTRING',
0x0162: 'ROMAN',
0x0163: 'OPEN.DIALOG',
0x0164: 'SAVE.DIALOG',
0x0165: 'VIEW.GET',
0x0166: 'GETPIVOTDATA',
0x0167: 'HYPERLINK',
0x0168: 'PHONETIC',
0x0169: 'AVERAGEA',
0x016A: 'MAXA',
0x016B: 'MINA',
0x016C: 'STDEVPA',
0x016D: 'VARPA',
0x016E: 'STDEVA',
0x016F: 'VARA',
0x0170: 'BAHTTEXT',
0x0171: 'THAIDAYOFWEEK',
0x0172: 'THAIDIGIT',
0x0173: 'THAIMONTHOFYEAR',
0x0174: 'THAINUMSOUND',
0x0175: 'THAINUMSTRING',
0x0176: 'THAISTRINGLENGTH',
0x0177: 'ISTHAIDIGIT',
0x0178: 'ROUNDBAHTDOWN',
0x0179: 'ROUNDBAHTUP',
0x017A: 'THAIYEAR',
0x017B: 'RTD',

0x017C: 'CUBEVALUE',
0x017D: 'CUBEMEMBER',
0x017E: 'CUBEMEMBERPROPERTY',
0x017F: 'CUBERANKEDMEMBER',
0x0180: 'HEX2BIN',
0x0181: 'HEX2DEC',
0x0182: 'HEX2OCT',
0x0183: 'DEC2BIN',
0x0184: 'DEC2HEX',
0x0185: 'DEC2OCT',
0x0186: 'OCT2BIN',
0x0187: 'OCT2HEX',
0x0188: 'OCT2DEC',
0x0189: 'BIN2DEC',
0x018A: 'BIN2OCT',
0x018B: 'BIN2HEX',
0x018C: 'IMSUB',
0x018D: 'IMDIV',
0x018E: 'IMPOWER',
0x018F: 'IMABS',
0x0190: 'IMSQRT',
0x0191: 'IMLN',
0x0192: 'IMLOG2',
0x0193: 'IMLOG10',
0x0194: 'IMSIN',
0x0195: 'IMCOS',
0x0196: 'IMEXP',
0x0197: 'IMARGUMENT',
0x0198: 'IMCONJUGATE',
0x0199: 'IMAGINARY',
0x019A: 'IMREAL',
0x019B: 'COMPLEX',
0x019C: 'IMSUM',
0x019D: 'IMPRODUCT',
0x019E: 'SERIESSUM',
0x019F: 'FACTDOUBLE',
0x01A0: 'SQRTPI',
0x01A1: 'QUOTIENT',
0x01A2: 'DELTA',
0x01A3: 'GESTEP',
0x01A4: 'ISEVEN',
0x01A5: 'ISODD',
0x01A6: 'MROUND',
0x01A7: 'ERF',
0x01A8: 'ERFC',
0x01A9: 'BESSELJ',
0x01AA: 'BESSELK',
0x01AB: 'BESSELY',
0x01AC: 'BESSELI',
0x01AD: 'XIRR',
0x01AE: 'XNPV',
0x01AF: 'PRICEMAT',
0x01B0: 'YIELDMAT',
0x01B1: 'INTRATE',
0x01B2: 'RECEIVED',
0x01B3: 'DISC',
0x01B4: 'PRICEDISC',
0x01B5: 'YIELDDISC',
0x01B6: 'TBILLEQ',
0x01B7: 'TBILLPRICE',
0x01B8: 'TBILLYIELD',
0x01B9: 'PRICE',
0x01BA: 'YIELD',
0x01BB: 'DOLLARDE',
0x01BC: 'DOLLARFR',
0x01BD: 'NOMINAL',
0x01BE: 'EFFECT',
0x01BF: 'CUMPRINC',
0x01C0: 'CUMIPMT',
0x01C1: 'EDATE',
0x01C2: 'EOMONTH',
0x01C3: 'YEARFRAC',
0x01C4: 'COUPDAYBS',
0x01C5: 'COUPDAYS',
0x01C6: 'COUPDAYSNC',
0x01C7: 'COUPNCD',
0x01C8: 'COUPNUM',
0x01C9: 'COUPPCD',
0x01CA: 'DURATION',
0x01CB: 'MDURATION',
0x01CC: 'ODDLPRICE',
0x01CD: 'ODDLYIELD',
0x01CE: 'ODDFPRICE',
0x01CF: 'ODDFYIELD',
0x01D0: 'RANDBETWEEN',
0x01D1: 'WEEKNUM',
0x01D2: 'AMORDEGRC',
0x01D3: 'AMORLINC',
0x01D4: 'CONVERT',
0x02D4: 'SHEETJS',
0x01D5: 'ACCRINT',
0x01D6: 'ACCRINTM',
0x01D7: 'WORKDAY',
0x01D8: 'NETWORKDAYS',
0x01D9: 'GCD',
0x01DA: 'MULTINOMIAL',
0x01DB: 'LCM',
0x01DC: 'FVSCHEDULE',
0x01DD: 'CUBEKPIMEMBER',
0x01DE: 'CUBESET',
0x01DF: 'CUBESETCOUNT',
0x01E0: 'IFERROR',
0x01E1: 'COUNTIFS',
0x01E2: 'SUMIFS',
0x01E3: 'AVERAGEIF',
0x01E4: 'AVERAGEIFS'
};
var FtabArgc = {
0x0002: 1, /* ISNA */
0x0003: 1, /* ISERROR */
0x000A: 0, /* NA */
0x000F: 1, /* SIN */
0x0010: 1, /* COS */
0x0011: 1, /* TAN */
0x0012: 1, /* ATAN */
0x0013: 0, /* PI */
0x0014: 1, /* SQRT */
0x0015: 1, /* EXP */
0x0016: 1, /* LN */
0x0017: 1, /* LOG10 */
0x0018: 1, /* ABS */
0x0019: 1, /* INT */
0x001A: 1, /* SIGN */
0x001B: 2, /* ROUND */
0x001E: 2, /* REPT */
0x001F: 3, /* MID */
0x0020: 1, /* LEN */
0x0021: 1, /* VALUE */
0x0022: 0, /* TRUE */
0x0023: 0, /* FALSE */
0x0026: 1, /* NOT */
0x0027: 2, /* MOD */
0x0028: 3, /* DCOUNT */
0x0029: 3, /* DSUM */
0x002A: 3, /* DAVERAGE */
0x002B: 3, /* DMIN */
0x002C: 3, /* DMAX */
0x002D: 3, /* DSTDEV */
0x002F: 3, /* DVAR */
0x0030: 2, /* TEXT */
0x0035: 1, /* GOTO */
0x003D: 3, /* MIRR */
0x003F: 0, /* RAND */
0x0041: 3, /* DATE */
0x0042: 3, /* TIME */
0x0043: 1, /* DAY */
0x0044: 1, /* MONTH */
0x0045: 1, /* YEAR */
0x0046: 1, /* WEEKDAY */
0x0047: 1, /* HOUR */
0x0048: 1, /* MINUTE */
0x0049: 1, /* SECOND */
0x004A: 0, /* NOW */
0x004B: 1, /* AREAS */
0x004C: 1, /* ROWS */
0x004D: 1, /* COLUMNS */
0x004F: 2, /* ABSREF */
0x0050: 2, /* RELREF */
0x0053: 1, /* TRANSPOSE */
0x0055: 0, /* STEP */
0x0056: 1, /* TYPE */
0x0059: 0, /* CALLER */
0x005A: 1, /* DEREF */
0x005E: 0, /* ACTIVE.CELL */
0x005F: 0, /* SELECTION */
0x0061: 2, /* ATAN2 */
0x0062: 1, /* ASIN */
0x0063: 1, /* ACOS */
0x0065: 3, /* HLOOKUP */
0x0066: 3, /* VLOOKUP */
0x0069: 1, /* ISREF */
0x006A: 1, /* GET.FORMULA */
0x006C: 2, /* SET.VALUE */
0x006F: 1, /* CHAR */
0x0070: 1, /* LOWER */
0x0071: 1, /* UPPER */
0x0072: 1, /* PROPER */
0x0075: 2, /* EXACT */
0x0076: 1, /* TRIM */
0x0077: 4, /* REPLACE */
0x0079: 1, /* CODE */
0x007E: 1, /* ISERR */
0x007F: 1, /* ISTEXT */
0x0080: 1, /* ISNUMBER */
0x0081: 1, /* ISBLANK */
0x0082: 1, /* T */
0x0083: 1, /* N */
0x0085: 1, /* FCLOSE */
0x0086: 1, /* FSIZE */
0x0087: 1, /* FREADLN */
0x0088: 2, /* FREAD */
0x0089: 2, /* FWRITELN */
0x008A: 2, /* FWRITE */
0x008C: 1, /* DATEVALUE */
0x008D: 1, /* TIMEVALUE */
0x008E: 3, /* SLN */
0x008F: 4, /* SYD */
0x0090: 4, /* DDB */
0x00A1: 1, /* DIALOG.BOX */
0x00A2: 1, /* CLEAN */
0x00A3: 1, /* MDETERM */
0x00A4: 1, /* MINVERSE */
0x00A5: 2, /* MMULT */
0x00AC: 1, /* WHILE */
0x00AF: 2, /* INITIATE */
0x00B0: 2, /* REQUEST */
0x00B1: 3, /* POKE */
0x00B2: 2, /* EXECUTE */
0x00B3: 1, /* TERMINATE */
0x00B8: 1, /* FACT */
0x00BA: 1, /* GET.WORKSPACE */
0x00BD: 3, /* DPRODUCT */
0x00BE: 1, /* ISNONTEXT */
0x00C3: 3, /* DSTDEVP */
0x00C4: 3, /* DVARP */
0x00C5: 1, /* TRUNC */
0x00C6: 1, /* ISLOGICAL */
0x00C7: 3, /* DCOUNTA */
0x00C9: 1, /* UNREGISTER */
0x00CF: 4, /* REPLACEB */
0x00D2: 3, /* MIDB */
0x00D3: 1, /* LENB */
0x00D4: 2, /* ROUNDUP */
0x00D5: 2, /* ROUNDDOWN */
0x00D6: 1, /* ASC */
0x00D7: 1, /* DBCS */
0x00E1: 0, /* END.IF */
0x00E5: 1, /* SINH */
0x00E6: 1, /* COSH */
0x00E7: 1, /* TANH */
0x00E8: 1, /* ASINH */
0x00E9: 1, /* ACOSH */
0x00EA: 1, /* ATANH */
0x00EB: 3, /* DGET */
0x00F4: 1, /* INFO */
0x00F7: 4, /* DB */
0x00FC: 2, /* FREQUENCY */
0x0101: 1, /* EVALUATE */
0x0105: 1, /* ERROR.TYPE */
0x010F: 1, /* GAMMALN */
0x0111: 4, /* BINOMDIST */
0x0112: 2, /* CHIDIST */
0x0113: 2, /* CHIINV */
0x0114: 2, /* COMBIN */
0x0115: 3, /* CONFIDENCE */
0x0116: 3, /* CRITBINOM */
0x0117: 1, /* EVEN */
0x0118: 3, /* EXPONDIST */
0x0119: 3, /* FDIST */
0x011A: 3, /* FINV */
0x011B: 1, /* FISHER */
0x011C: 1, /* FISHERINV */
0x011D: 2, /* FLOOR */
0x011E: 4, /* GAMMADIST */
0x011F: 3, /* GAMMAINV */
0x0120: 2, /* CEILING */
0x0121: 4, /* HYPGEOMDIST */
0x0122: 3, /* LOGNORMDIST */
0x0123: 3, /* LOGINV */
0x0124: 3, /* NEGBINOMDIST */
0x0125: 4, /* NORMDIST */
0x0126: 1, /* NORMSDIST */
0x0127: 3, /* NORMINV */
0x0128: 1, /* NORMSINV */
0x0129: 3, /* STANDARDIZE */
0x012A: 1, /* ODD */
0x012B: 2, /* PERMUT */
0x012C: 3, /* POISSON */
0x012D: 3, /* TDIST */
0x012E: 4, /* WEIBULL */
0x012F: 2, /* SUMXMY2 */
0x0130: 2, /* SUMX2MY2 */
0x0131: 2, /* SUMX2PY2 */
0x0132: 2, /* CHITEST */
0x0133: 2, /* CORREL */
0x0134: 2, /* COVAR */
0x0135: 3, /* FORECAST */
0x0136: 2, /* FTEST */
0x0137: 2, /* INTERCEPT */
0x0138: 2, /* PEARSON */
0x0139: 2, /* RSQ */
0x013A: 2, /* STEYX */
0x013B: 2, /* SLOPE */
0x013C: 4, /* TTEST */
0x0145: 2, /* LARGE */
0x0146: 2, /* SMALL */
0x0147: 2, /* QUARTILE */
0x0148: 2, /* PERCENTILE */
0x014B: 2, /* TRIMMEAN */
0x014C: 2, /* TINV */
0x0151: 2, /* POWER */
0x0156: 1, /* RADIANS */
0x0157: 1, /* DEGREES */
0x015A: 2, /* COUNTIF */
0x015B: 1, /* COUNTBLANK */
0x015E: 4, /* ISPMT */
0x015F: 3, /* DATEDIF */
0x0160: 1, /* DATESTRING */
0x0161: 2, /* NUMBERSTRING */
0x0168: 1, /* PHONETIC */
0x0170: 1, /* BAHTTEXT */
0x0171: 1, /* THAIDAYOFWEEK */
0x0172: 1, /* THAIDIGIT */
0x0173: 1, /* THAIMONTHOFYEAR */
0x0174: 1, /* THAINUMSOUND */
0x0175: 1, /* THAINUMSTRING */
0x0176: 1, /* THAISTRINGLENGTH */
0x0177: 1, /* ISTHAIDIGIT */
0x0178: 1, /* ROUNDBAHTDOWN */
0x0179: 1, /* ROUNDBAHTUP */
0x017A: 1, /* THAIYEAR */
0x017E: 3, /* CUBEMEMBERPROPERTY */
0x0181: 1, /* HEX2DEC */
0x0188: 1, /* OCT2DEC */
0x0189: 1, /* BIN2DEC */
0x018C: 2, /* IMSUB */
0x018D: 2, /* IMDIV */
0x018E: 2, /* IMPOWER */
0x018F: 1, /* IMABS */
0x0190: 1, /* IMSQRT */
0x0191: 1, /* IMLN */
0x0192: 1, /* IMLOG2 */
0x0193: 1, /* IMLOG10 */
0x0194: 1, /* IMSIN */
0x0195: 1, /* IMCOS */
0x0196: 1, /* IMEXP */
0x0197: 1, /* IMARGUMENT */
0x0198: 1, /* IMCONJUGATE */
0x0199: 1, /* IMAGINARY */
0x019A: 1, /* IMREAL */
0x019E: 4, /* SERIESSUM */
0x019F: 1, /* FACTDOUBLE */
0x01A0: 1, /* SQRTPI */
0x01A1: 2, /* QUOTIENT */
0x01A4: 1, /* ISEVEN */
0x01A5: 1, /* ISODD */
0x01A6: 2, /* MROUND */
0x01A8: 1, /* ERFC */
0x01A9: 2, /* BESSELJ */
0x01AA: 2, /* BESSELK */
0x01AB: 2, /* BESSELY */
0x01AC: 2, /* BESSELI */
0x01AE: 3, /* XNPV */
0x01B6: 3, /* TBILLEQ */
0x01B7: 3, /* TBILLPRICE */
0x01B8: 3, /* TBILLYIELD */
0x01BB: 2, /* DOLLARDE */
0x01BC: 2, /* DOLLARFR */
0x01BD: 2, /* NOMINAL */
0x01BE: 2, /* EFFECT */
0x01BF: 6, /* CUMPRINC */
0x01C0: 6, /* CUMIPMT */
0x01C1: 2, /* EDATE */
0x01C2: 2, /* EOMONTH */
0x01D0: 2, /* RANDBETWEEN */
0x01D4: 3, /* CONVERT */
0x01DC: 2, /* FVSCHEDULE */
0x01DF: 1, /* CUBESETCOUNT */
0x01E0: 2, /* IFERROR */
0xFFFF: 0
};
/* [MS-XLSX] 2.2.3 Functions */
/* [MS-XLSB] 2.5.97.10 Ftab */
var XLSXFutureFunctions = {
	"_xlfn.ACOT": "ACOT",
	"_xlfn.ACOTH": "ACOTH",
	"_xlfn.AGGREGATE": "AGGREGATE",
	"_xlfn.ARABIC": "ARABIC",
	"_xlfn.AVERAGEIF": "AVERAGEIF",
	"_xlfn.AVERAGEIFS": "AVERAGEIFS",
	"_xlfn.BASE": "BASE",
	"_xlfn.BETA.DIST": "BETA.DIST",
	"_xlfn.BETA.INV": "BETA.INV",
	"_xlfn.BINOM.DIST": "BINOM.DIST",
	"_xlfn.BINOM.DIST.RANGE": "BINOM.DIST.RANGE",
	"_xlfn.BINOM.INV": "BINOM.INV",
	"_xlfn.BITAND": "BITAND",
	"_xlfn.BITLSHIFT": "BITLSHIFT",
	"_xlfn.BITOR": "BITOR",
	"_xlfn.BITRSHIFT": "BITRSHIFT",
	"_xlfn.BITXOR": "BITXOR",
	"_xlfn.CEILING.MATH": "CEILING.MATH",
	"_xlfn.CEILING.PRECISE": "CEILING.PRECISE",
	"_xlfn.CHISQ.DIST": "CHISQ.DIST",
	"_xlfn.CHISQ.DIST.RT": "CHISQ.DIST.RT",
	"_xlfn.CHISQ.INV": "CHISQ.INV",
	"_xlfn.CHISQ.INV.RT": "CHISQ.INV.RT",
	"_xlfn.CHISQ.TEST": "CHISQ.TEST",
	"_xlfn.COMBINA": "COMBINA",
	"_xlfn.CONCAT": "CONCAT",
	"_xlfn.CONFIDENCE.NORM": "CONFIDENCE.NORM",
	"_xlfn.CONFIDENCE.T": "CONFIDENCE.T",
	"_xlfn.COT": "COT",
	"_xlfn.COTH": "COTH",
	"_xlfn.COUNTIFS": "COUNTIFS",
	"_xlfn.COVARIANCE.P": "COVARIANCE.P",
	"_xlfn.COVARIANCE.S": "COVARIANCE.S",
	"_xlfn.CSC": "CSC",
	"_xlfn.CSCH": "CSCH",
	"_xlfn.DAYS": "DAYS",
	"_xlfn.DECIMAL": "DECIMAL",
	"_xlfn.ECMA.CEILING": "ECMA.CEILING",
	"_xlfn.ERF.PRECISE": "ERF.PRECISE",
	"_xlfn.ERFC.PRECISE": "ERFC.PRECISE",
	"_xlfn.EXPON.DIST": "EXPON.DIST",
	"_xlfn.F.DIST": "F.DIST",
	"_xlfn.F.DIST.RT": "F.DIST.RT",
	"_xlfn.F.INV": "F.INV",
	"_xlfn.F.INV.RT": "F.INV.RT",
	"_xlfn.F.TEST": "F.TEST",
	"_xlfn.FILTERXML": "FILTERXML",
	"_xlfn.FLOOR.MATH": "FLOOR.MATH",
	"_xlfn.FLOOR.PRECISE": "FLOOR.PRECISE",
	"_xlfn.FORECAST.ETS": "FORECAST.ETS",
	"_xlfn.FORECAST.ETS.CONFINT": "FORECAST.ETS.CONFINT",
	"_xlfn.FORECAST.ETS.SEASONALITY": "FORECAST.ETS.SEASONALITY",
	"_xlfn.FORECAST.ETS.STAT": "FORECAST.ETS.STAT",
	"_xlfn.FORECAST.LINEAR": "FORECAST.LINEAR",
	"_xlfn.FORMULATEXT": "FORMULATEXT",
	"_xlfn.GAMMA": "GAMMA",
	"_xlfn.GAMMA.DIST": "GAMMA.DIST",
	"_xlfn.GAMMA.INV": "GAMMA.INV",
	"_xlfn.GAMMALN.PRECISE": "GAMMALN.PRECISE",
	"_xlfn.GAUSS": "GAUSS",
	"_xlfn.HYPGEOM.DIST": "HYPGEOM.DIST",
	"_xlfn.IFERROR": "IFERROR",
	"_xlfn.IFNA": "IFNA",
	"_xlfn.IFS": "IFS",
	"_xlfn.IMCOSH": "IMCOSH",
	"_xlfn.IMCOT": "IMCOT",
	"_xlfn.IMCSC": "IMCSC",
	"_xlfn.IMCSCH": "IMCSCH",
	"_xlfn.IMSEC": "IMSEC",
	"_xlfn.IMSECH": "IMSECH",
	"_xlfn.IMSINH": "IMSINH",
	"_xlfn.IMTAN": "IMTAN",
	"_xlfn.ISFORMULA": "ISFORMULA",
	"_xlfn.ISO.CEILING": "ISO.CEILING",
	"_xlfn.ISOWEEKNUM": "ISOWEEKNUM",
	"_xlfn.LOGNORM.DIST": "LOGNORM.DIST",
	"_xlfn.LOGNORM.INV": "LOGNORM.INV",
	"_xlfn.MAXIFS": "MAXIFS",
	"_xlfn.MINIFS": "MINIFS",
	"_xlfn.MODE.MULT": "MODE.MULT",
	"_xlfn.MODE.SNGL": "MODE.SNGL",
	"_xlfn.MUNIT": "MUNIT",
	"_xlfn.NEGBINOM.DIST": "NEGBINOM.DIST",
	"_xlfn.NETWORKDAYS.INTL": "NETWORKDAYS.INTL",
	"_xlfn.NIGBINOM": "NIGBINOM",
	"_xlfn.NORM.DIST": "NORM.DIST",
	"_xlfn.NORM.INV": "NORM.INV",
	"_xlfn.NORM.S.DIST": "NORM.S.DIST",
	"_xlfn.NORM.S.INV": "NORM.S.INV",
	"_xlfn.NUMBERVALUE": "NUMBERVALUE",
	"_xlfn.PDURATION": "PDURATION",
	"_xlfn.PERCENTILE.EXC": "PERCENTILE.EXC",
	"_xlfn.PERCENTILE.INC": "PERCENTILE.INC",
	"_xlfn.PERCENTRANK.EXC": "PERCENTRANK.EXC",
	"_xlfn.PERCENTRANK.INC": "PERCENTRANK.INC",
	"_xlfn.PERMUTATIONA": "PERMUTATIONA",
	"_xlfn.PHI": "PHI",
	"_xlfn.POISSON.DIST": "POISSON.DIST",
	"_xlfn.QUARTILE.EXC": "QUARTILE.EXC",
	"_xlfn.QUARTILE.INC": "QUARTILE.INC",
	"_xlfn.QUERYSTRING": "QUERYSTRING",
	"_xlfn.RANK.AVG": "RANK.AVG",
	"_xlfn.RANK.EQ": "RANK.EQ",
	"_xlfn.RRI": "RRI",
	"_xlfn.SEC": "SEC",
	"_xlfn.SECH": "SECH",
	"_xlfn.SHEET": "SHEET",
	"_xlfn.SHEETS": "SHEETS",
	"_xlfn.SKEW.P": "SKEW.P",
	"_xlfn.STDEV.P": "STDEV.P",
	"_xlfn.STDEV.S": "STDEV.S",
	"_xlfn.SUMIFS": "SUMIFS",
	"_xlfn.SWITCH": "SWITCH",
	"_xlfn.T.DIST": "T.DIST",
	"_xlfn.T.DIST.2T": "T.DIST.2T",
	"_xlfn.T.DIST.RT": "T.DIST.RT",
	"_xlfn.T.INV": "T.INV",
	"_xlfn.T.INV.2T": "T.INV.2T",
	"_xlfn.T.TEST": "T.TEST",
	"_xlfn.TEXTJOIN": "TEXTJOIN",
	"_xlfn.UNICHAR": "UNICHAR",
	"_xlfn.UNICODE": "UNICODE",
	"_xlfn.VAR.P": "VAR.P",
	"_xlfn.VAR.S": "VAR.S",
	"_xlfn.WEBSERVICE": "WEBSERVICE",
	"_xlfn.WEIBULL.DIST": "WEIBULL.DIST",
	"_xlfn.WORKDAY.INTL": "WORKDAY.INTL",
	"_xlfn.XOR": "XOR",
	"_xlfn.Z.TEST": "Z.TEST"
};

/* Part 3 TODO: actually parse formulae */
function ods_to_csf_formula(f) {
	if(f.slice(0,3) == "of:") f = f.slice(3);
	/* 5.2 Basic Expressions */
	if(f.charCodeAt(0) == 61) {
		f = f.slice(1);
		if(f.charCodeAt(0) == 61) f = f.slice(1);
	}
	f = f.replace(/COM\.MICROSOFT\./g, "");
	/* Part 3 Section 5.8 References */
	f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) { return $1.replace(/\./g,""); });
	/* TODO: something other than this */
	f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
	return f.replace(/[;~]/g,",").replace(/\|/g,";");
}

function csf_to_ods_formula(f) {
	var o = "of:=" + f.replace(crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g,":");
	/* TODO: something other than this */
	return o.replace(/;/g, "|").replace(/,/g,";");
}

function ods_to_csf_3D(r) {
	var a = r.split(":");
	var s = a[0].split(".")[0];
	return [s, a[0].split(".")[1] + (a.length > 1 ? (":" + (a[1].split(".")[1] || a[1].split(".")[0])) : "")];
}

function csf_to_ods_3D(r) {
	return r.replace(/\./,"!");
}

var strs = {}; // shared strings
var _ssfopts = {}; // spreadsheet formatting options

RELS.WS = [
	"http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
	"http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
];

/*global Map */
var browser_has_Map = typeof Map !== 'undefined';

function get_sst_id(sst, str, rev) {
	var i = 0, len = sst.length;
	if(rev) {
		if(browser_has_Map ? rev.has(str) : rev.hasOwnProperty(str)) {
			var revarr = browser_has_Map ? rev.get(str) : rev[str];
			for(; i < revarr.length; ++i) {
				if(sst[revarr[i]].t === str) { sst.Count ++; return revarr[i]; }
			}
		}
	} else for(; i < len; ++i) {
		if(sst[i].t === str) { sst.Count ++; return i; }
	}
	sst[len] = ({t:str}); sst.Count ++; sst.Unique ++;
	if(rev) {
		if(browser_has_Map) {
			if(!rev.has(str)) rev.set(str, []);
			rev.get(str).push(len);
		} else {
			if(!rev.hasOwnProperty(str)) rev[str] = [];
			rev[str].push(len);
		}
	}
	return len;
}

function col_obj_w(C, col) {
	var p = ({min:C+1,max:C+1});
	/* wch (chars), wpx (pixels) */
	var wch = -1;
	if(col.MDW) MDW = col.MDW;
	if(col.width != null) p.customWidth = 1;
	else if(col.wpx != null) wch = px2char(col.wpx);
	else if(col.wch != null) wch = col.wch;
	if(wch > -1) { p.width = char2width(wch); p.customWidth = 1; }
	else if(col.width != null) p.width = col.width;
	if(col.hidden) p.hidden = true;
	return p;
}

function default_margins(margins, mode) {
	if(!margins) return;
	var defs = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
	if(mode == 'xlml') defs = [1, 1, 1, 1, 0.5, 0.5];
	if(margins.left   == null) margins.left   = defs[0];
	if(margins.right  == null) margins.right  = defs[1];
	if(margins.top    == null) margins.top    = defs[2];
	if(margins.bottom == null) margins.bottom = defs[3];
	if(margins.header == null) margins.header = defs[4];
	if(margins.footer == null) margins.footer = defs[5];
}

function get_cell_style(styles, cell, opts) {
	var z = opts.revssf[cell.z != null ? cell.z : "General"];
	var i = 0x3c, len = styles.length;
	if(z == null && opts.ssf) {
		for(; i < 0x188; ++i) if(opts.ssf[i] == null) {
			SSF.load(cell.z, i);
			// $FlowIgnore
			opts.ssf[i] = cell.z;
			opts.revssf[cell.z] = z = i;
			break;
		}
	}
	for(i = 0; i != len; ++i) if(styles[i].numFmtId === z) return i;
	styles[len] = {
		numFmtId:z,
		fontId:0,
		fillId:0,
		borderId:0,
		xfId:0,
		applyNumberFormat:1
	};
	return len;
}

function safe_format(p, fmtid, fillid, opts, themes, styles) {
	if(p.t === 'z') return;
	if(p.t === 'd' && typeof p.v === 'string') p.v = parseDate(p.v);
	try {
		if(opts.cellNF) p.z = SSF._table[fmtid];
	} catch(e) { if(opts.WTF) throw e; }
	if(!opts || opts.cellText !== false) try {
		if(SSF._table[fmtid] == null) SSF.load(SSFImplicit[fmtid] || "General", fmtid);
		if(p.t === 'e') p.w = p.w || BErr[p.v];
		else if(fmtid === 0) {
			if(p.t === 'n') {
				if((p.v|0) === p.v) p.w = SSF._general_int(p.v);
				else p.w = SSF._general_num(p.v);
			}
			else if(p.t === 'd') {
				var dd = datenum(p.v);
				if((dd|0) === dd) p.w = SSF._general_int(dd);
				else p.w = SSF._general_num(dd);
			}
			else if(p.v === undefined) return "";
			else p.w = SSF._general(p.v,_ssfopts);
		}
		else if(p.t === 'd') p.w = SSF.format(fmtid,datenum(p.v),_ssfopts);
		else p.w = SSF.format(fmtid,p.v,_ssfopts);
	} catch(e) { if(opts.WTF) throw e; }
	if(!opts.cellStyles) return;
	if(fillid != null) try {
		p.s = styles.Fills[fillid];
		if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
			p.s.fgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
			if(opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
		}
		if (p.s.bgColor && p.s.bgColor.theme) {
			p.s.bgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
			if(opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
		}
	} catch(e) { if(opts.WTF && styles.Fills) throw e; }
}

function check_ws(ws, sname, i) {
	if(ws && ws['!ref']) {
		var range = safe_decode_range(ws['!ref']);
		if(range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
	}
}
function parse_ws_xml_dim(ws, s) {
	var d = safe_decode_range(s);
	if(d.s.r<=d.e.r && d.s.c<=d.e.c && d.s.r>=0 && d.s.c>=0) ws["!ref"] = encode_range(d);
}
var mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
var sheetdataregex = /<(?:\w+:)?sheetData>([\s\S]*)<\/(?:\w+:)?sheetData>/;
var hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
var dimregex = /"(\w*:\w*)"/;
var colregex = /<(?:\w:)?col\b[^>]*[\/]?>/g;
var afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
var marginregex= /<(?:\w:)?pageMargins[^>]*\/>/g;
var sheetprregex = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;
var svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
/* 18.3 Worksheets */
function parse_ws_xml(data, opts, idx, rels, wb, themes, styles) {
	if(!data) return data;
	if(DENSE != null && opts.dense == null) opts.dense = DENSE;

	/* 18.3.1.99 worksheet CT_Worksheet */
	var s = opts.dense ? ([]) : ({});
	var refguess = ({s: {r:2000000, c:2000000}, e: {r:0, c:0} });

	var data1 = "", data2 = "";
	var mtch = data.match(sheetdataregex);
	if(mtch) {
		data1 = data.slice(0, mtch.index);
		data2 = data.slice(mtch.index + mtch[0].length);
	} else data1 = data2 = data;

	/* 18.3.1.82 sheetPr CT_SheetPr */
	var sheetPr = data1.match(sheetprregex);
	if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);

	/* 18.3.1.35 dimension CT_SheetDimension */
	// $FlowIgnore
	var ridx = (data1.match(/<(?:\w*:)?dimension/)||{index:-1}).index;
	if(ridx > 0) {
		var ref = data1.slice(ridx,ridx+50).match(dimregex);
		if(ref) parse_ws_xml_dim(s, ref[1]);
	}

	/* 18.3.1.88 sheetViews CT_SheetViews */
	var svs = data1.match(svsregex);
	if(svs && svs[1]) parse_ws_xml_sheetviews(svs[1], wb);

	/* 18.3.1.17 cols CT_Cols */
	var columns = [];
	if(opts.cellStyles) {
		/* 18.3.1.13 col CT_Col */
		var cols = data1.match(colregex);
		if(cols) parse_ws_xml_cols(columns, cols);
	}

	/* 18.3.1.80 sheetData CT_SheetData ? */
	if(mtch) parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);

	/* 18.3.1.2  autoFilter CT_AutoFilter */
	var afilter = data2.match(afregex);
	if(afilter) s['!autofilter'] = parse_ws_xml_autofilter(afilter[0]);

	/* 18.3.1.55 mergeCells CT_MergeCells */
	var merges = [];
	var _merge = data2.match(mergecregex);
	if(_merge) for(ridx = 0; ridx != _merge.length; ++ridx)
		merges[ridx] = safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"")+1));

	/* 18.3.1.48 hyperlinks CT_Hyperlinks */
	var hlink = data2.match(hlinkregex);
	if(hlink) parse_ws_xml_hlinks(s, hlink, rels);

	/* 18.3.1.62 pageMargins CT_PageMargins */
	var margins = data2.match(marginregex);
	if(margins) s['!margins'] = parse_ws_xml_margins(parsexmltag(margins[0]));

	if(!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = encode_range(refguess);
	if(opts.sheetRows > 0 && s["!ref"]) {
		var tmpref = safe_decode_range(s["!ref"]);
		if(opts.sheetRows <= +tmpref.e.r) {
			tmpref.e.r = opts.sheetRows - 1;
			if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
			if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
			if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
			if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
			s["!fullref"] = s["!ref"];
			s["!ref"] = encode_range(tmpref);
		}
	}
	if(columns.length > 0) s["!cols"] = columns;
	if(merges.length > 0) s["!merges"] = merges;
	return s;
}

function write_ws_xml_merges(merges) {
	if(merges.length === 0) return "";
	var o = '<mergeCells count="' + merges.length + '">';
	for(var i = 0; i != merges.length; ++i) o += '<mergeCell ref="' + encode_range(merges[i]) + '"/>';
	return o + '</mergeCells>';
}

/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */
function parse_ws_xml_sheetpr(sheetPr, s, wb, idx) {
	var data = parsexmltag(sheetPr);
	if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
	if(data.codeName) wb.Sheets[idx].CodeName = data.codeName;
}

/* 18.3.1.85 sheetProtection CT_SheetProtection */
function write_ws_xml_protection(sp) {
	// algorithmName, hashValue, saltValue, spinCountpassword
	var o = ({sheet:1});
	var deffalse = ["objects", "scenarios", "selectLockedCells", "selectUnlockedCells"];
	var deftrue = [
		"formatColumns", "formatRows", "formatCells",
		"insertColumns", "insertRows", "insertHyperlinks",
		"deleteColumns", "deleteRows",
		"sort", "autoFilter", "pivotTables"
	];
	deffalse.forEach(function(n) { if(sp[n] != null && sp[n]) o[n] = "1"; });
	deftrue.forEach(function(n) { if(sp[n] != null && !sp[n]) o[n] = "0"; });
	/* TODO: algorithm */
	if(sp.password) o.password = crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
	return writextag('sheetProtection', null, o);
}

function parse_ws_xml_hlinks(s, data, rels) {
	var dense = Array.isArray(s);
	for(var i = 0; i != data.length; ++i) {
		var val = parsexmltag(utf8read(data[i]), true);
		if(!val.ref) return;
		var rel = ((rels || {})['!id']||[])[val.id];
		if(rel) {
			val.Target = rel.Target;
			if(val.location) val.Target += "#"+val.location;
		} else {
			val.Target = "#" + val.location;
			rel = {Target: val.Target, TargetMode: 'Internal'};
		}
		val.Rel = rel;
		if(val.tooltip) { val.Tooltip = val.tooltip; delete val.tooltip; }
		var rng = safe_decode_range(val.ref);
		for(var R=rng.s.r;R<=rng.e.r;++R) for(var C=rng.s.c;C<=rng.e.c;++C) {
			var addr = encode_cell({c:C,r:R});
			if(dense) {
				if(!s[R]) s[R] = [];
				if(!s[R][C]) s[R][C] = {t:"z",v:undefined};
				s[R][C].l = val;
			} else {
				if(!s[addr]) s[addr] = {t:"z",v:undefined};
				s[addr].l = val;
			}
		}
	}
}

function parse_ws_xml_margins(margin) {
	var o = {};
	["left", "right", "top", "bottom", "header", "footer"].forEach(function(k) {
		if(margin[k]) o[k] = parseFloat(margin[k]);
	});
	return o;
}
function write_ws_xml_margins(margin) {
	default_margins(margin);
	return writextag('pageMargins', null, margin);
}

function parse_ws_xml_cols(columns, cols) {
	var seencol = false;
	for(var coli = 0; coli != cols.length; ++coli) {
		var coll = parsexmltag(cols[coli], true);
		if(coll.hidden) coll.hidden = parsexmlbool(coll.hidden);
		var colm=parseInt(coll.min, 10)-1, colM=parseInt(coll.max,10)-1;
		delete coll.min; delete coll.max; coll.width = +coll.width;
		if(!seencol && coll.width) { seencol = true; find_mdw_colw(coll.width); }
		process_col(coll);
		while(colm <= colM) columns[colm++] = dup(coll);
	}
}

function write_ws_xml_cols(ws, cols) {
	var o = ["<cols>"], col;
	for(var i = 0; i != cols.length; ++i) {
		if(!(col = cols[i])) continue;
		o[o.length] = (writextag('col', null, col_obj_w(i, col)));
	}
	o[o.length] = "</cols>";
	return o.join("");
}

function parse_ws_xml_autofilter(data) {
	var o = { ref: (data.match(/ref="([^"]*)"/)||[])[1]};
	return o;
}
function write_ws_xml_autofilter(data, ws, wb, idx) {
	var ref = typeof data.ref == "string" ? data.ref : encode_range(data.ref);
	if(!wb.Workbook) wb.Workbook = {};
	if(!wb.Workbook.Names) wb.Workbook.Names = [];
	var names = wb.Workbook.Names;
	var range = decode_range(ref);
	if(range.s.r == range.e.r) { range.e.r = decode_range(ws["!ref"]).e.r; ref = encode_range(range); }
	for(var i = 0; i < names.length; ++i) {
		var name = names[i];
		if(name.Name != '_xlnm._FilterDatabase') continue;
		if(name.Sheet != idx) continue;
		name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref; break;
	}
	if(i == names.length) names.push({ Name: '_xlnm._FilterDatabase', Sheet: idx, Ref: "'" + wb.SheetNames[idx] + "'!" + ref  });
	return writextag("autoFilter", null, {ref:ref});
}

/* 18.3.1.88 sheetViews CT_SheetViews */
/* 18.3.1.87 sheetView CT_SheetView */
var sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/>/;
function parse_ws_xml_sheetviews(data, wb) {
	(data.match(sviewregex)||[]).forEach(function(r) {
		var tag = parsexmltag(r);
		if(parsexmlbool(tag.rightToLeft)) {
			if(!wb.Views) wb.Views = [{}];
			if(!wb.Views[0]) wb.Views[0] = {};
			wb.Views[0].RTL = true;
		}
	});
}
function write_ws_xml_sheetviews(ws, opts, idx, wb) {
	var sview = {workbookViewId:"0"};
	// $FlowIgnore
	if( (((wb||{}).Workbook||{}).Views||[])[0] ) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
	return writextag("sheetViews", writextag("sheetView", null, sview), {});
}

function write_ws_xml_cell(cell, ref, ws, opts) {
	if(cell.v === undefined && cell.f === undefined || cell.t === 'z') return "";
	var vv = "";
	var oldt = cell.t, oldv = cell.v;
	switch(cell.t) {
		case 'b': vv = cell.v ? "1" : "0"; break;
		case 'n': vv = ''+cell.v; break;
		case 'e': vv = BErr[cell.v]; break;
		case 'd':
			if(opts.cellDates) vv = parseDate(cell.v, -1).toISOString();
			else {
				cell = dup(cell);
				cell.t = 'n';
				vv = ''+(cell.v = datenum(parseDate(cell.v)));
			}
			if(typeof cell.z === 'undefined') cell.z = SSF._table[14];
			break;
		default: vv = cell.v; break;
	}
	var v = writetag('v', escapexml(vv)), o = ({r:ref});
	/* TODO: cell style */
	var os = get_cell_style(opts.cellXfs, cell, opts);
	if(os !== 0) o.s = os;
	switch(cell.t) {
		case 'n': break;
		case 'd': o.t = "d"; break;
		case 'b': o.t = "b"; break;
		case 'e': o.t = "e"; break;
		default: if(cell.v == null) { delete cell.t; break; }
			if(opts.bookSST) {
				v = writetag('v', ''+get_sst_id(opts.Strings, cell.v, opts.revStrings));
				o.t = "s"; break;
			}
			o.t = "str"; break;
	}
	if(cell.t != oldt) { cell.t = oldt; cell.v = oldv; }
	if(cell.f) {
		var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {t:"array", ref:cell.F} : null;
		v = writextag('f', escapexml(cell.f), ff) + (cell.v != null ? v : "");
	}
	if(cell.l) ws['!links'].push([ref, cell.l]);
	if(cell.c) ws['!comments'].push([ref, cell.c]);
	return writextag('c', v, o);
}

var parse_ws_xml_data = (function() {
	var cellregex = /<(?:\w+:)?c[ >]/, rowregex = /<\/(?:\w+:)?row>/;
	var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
	var refregex = /ref=["']([^"']*)["']/;
	var match_v = matchtag("v"), match_f = matchtag("f");

return function parse_ws_xml_data(sdata, s, opts, guess, themes, styles) {
	var ri = 0, x = "", cells = [], cref = [], idx=0, i=0, cc=0, d="", p;
	var tag, tagr = 0, tagc = 0;
	var sstr, ftag;
	var fmtid = 0, fillid = 0;
	var do_format = Array.isArray(styles.CellXf), cf;
	var arrayf = [];
	var sharedf = [];
	var dense = Array.isArray(s);
	var rows = [], rowobj = {}, rowrite = false;
	for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt) {
		x = marr[mt].trim();
		var xlen = x.length;
		if(xlen === 0) continue;

		/* 18.3.1.73 row CT_Row */
		for(ri = 0; ri < xlen; ++ri) if(x.charCodeAt(ri) === 62) break; ++ri;
		tag = parsexmltag(x.slice(0,ri), true);
		tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
		if(opts.sheetRows && opts.sheetRows < tagr) continue;
		if(guess.s.r > tagr - 1) guess.s.r = tagr - 1;
		if(guess.e.r < tagr - 1) guess.e.r = tagr - 1;

		if(opts && opts.cellStyles) {
			rowobj = {}; rowrite = false;
			if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
			if(tag.hidden == "1") { rowrite = true; rowobj.hidden = true; }
			if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
			if(rowrite) rows[tagr-1] = rowobj;
		}

		/* 18.3.1.4 c CT_Cell */
		cells = x.slice(ri).split(cellregex);
		for(ri = 0; ri != cells.length; ++ri) {
			x = cells[ri].trim();
			if(x.length === 0) continue;
			cref = x.match(rregex); idx = ri; i=0; cc=0;
			x = "<c " + (x.slice(0,1)=="<"?">":"") + x;
			if(cref != null && cref.length === 2) {
				idx = 0; d=cref[1];
				for(i=0; i != d.length; ++i) {
					if((cc=d.charCodeAt(i)-64) < 1 || cc > 26) break;
					idx = 26*idx + cc;
				}
				--idx;
				tagc = idx;
			} else ++tagc;
			for(i = 0; i != x.length; ++i) if(x.charCodeAt(i) === 62) break; ++i;
			tag = parsexmltag(x.slice(0,i), true);
			if(!tag.r) tag.r = encode_cell({r:tagr-1, c:tagc});
			d = x.slice(i);
			p = ({t:""});

			if((cref=d.match(match_v))!= null && cref[1] !== '') p.v=unescapexml(cref[1]);
			if(opts.cellFormula) {
				if((cref=d.match(match_f))!= null && cref[1] !== '') {
					/* TODO: match against XLSXFutureFunctions */
					p.f=_xlfn(unescapexml(utf8read(cref[1])));
					if(cref[0].indexOf('t="array"') > -1) {
						p.F = (d.match(refregex)||[])[1];
						if(p.F.indexOf(":") > -1) arrayf.push([safe_decode_range(p.F), p.F]);
					} else if(cref[0].indexOf('t="shared"') > -1) {
						// TODO: parse formula
						ftag = parsexmltag(cref[0]);
						sharedf[parseInt(ftag.si, 10)] = [ftag, _xlfn(unescapexml(utf8read(cref[1]))), tag.r];
					}
				} else if((cref=d.match(/<f[^>]*\/>/))) {
					ftag = parsexmltag(cref[0]);
					if(sharedf[ftag.si]) p.f = shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2]/*[0].ref*/, tag.r);
				}
				/* TODO: factor out contains logic */
				var _tag = decode_cell(tag.r);
				for(i = 0; i < arrayf.length; ++i)
					if(_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r)
						if(_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c)
							p.F = arrayf[i][1];
			}

			if(tag.t == null && p.v === undefined) {
				if(p.f || p.F) {
					p.v = 0; p.t = "n";
				} else if(!opts.sheetStubs) continue;
				else p.t = "z";
			}
			else p.t = tag.t || "n";
			if(guess.s.c > tagc) guess.s.c = tagc;
			if(guess.e.c < tagc) guess.e.c = tagc;
			/* 18.18.11 t ST_CellType */
			switch(p.t) {
				case 'n':
					if(p.v == "" || p.v == null) {
						if(!opts.sheetStubs) continue;
						p.t = 'z';
					} else p.v = parseFloat(p.v);
					break;
				case 's':
					if(typeof p.v == 'undefined') {
						if(!opts.sheetStubs) continue;
						p.t = 'z';
					} else {
						sstr = strs[parseInt(p.v, 10)];
						p.v = sstr.t;
						p.r = sstr.r;
						if(opts.cellHTML) p.h = sstr.h;
					}
					break;
				case 'str':
					p.t = "s";
					p.v = (p.v!=null) ? utf8read(p.v) : '';
					if(opts.cellHTML) p.h = escapehtml(p.v);
					break;
				case 'inlineStr':
					cref = d.match(isregex);
					p.t = 's';
					if(cref != null && (sstr = parse_si(cref[1]))) p.v = sstr.t; else p.v = "";
					break;
				case 'b': p.v = parsexmlbool(p.v); break;
				case 'd':
					if(opts.cellDates) p.v = parseDate(p.v, 1);
					else { p.v = datenum(parseDate(p.v, 1)); p.t = 'n'; }
					break;
				/* error string in .w, number in .v */
				case 'e':
					if(!opts || opts.cellText !== false) p.w = p.v;
					p.v = RBErr[p.v]; break;
			}
			/* formatting */
			fmtid = fillid = 0;
			if(do_format && tag.s !== undefined) {
				cf = styles.CellXf[tag.s];
				if(cf != null) {
					if(cf.numFmtId != null) fmtid = cf.numFmtId;
					if(opts.cellStyles) {
						if(cf.fillId != null) fillid = cf.fillId;
					}
				}
			}
			safe_format(p, fmtid, fillid, opts, themes, styles);
			if(opts.cellDates && do_format && p.t == 'n' && SSF.is_date(SSF._table[fmtid])) { p.t = 'd'; p.v = numdate(p.v); }
			if(dense) {
				var _r = decode_cell(tag.r);
				if(!s[_r.r]) s[_r.r] = [];
				s[_r.r][_r.c] = p;
			} else s[tag.r] = p;
		}
	}
	if(rows.length > 0) s['!rows'] = rows;
}; })();

function write_ws_xml_data(ws, opts, idx, wb) {
	var o = [], r = [], range = safe_decode_range(ws['!ref']), cell="", ref, rr = "", cols = [], R=0, C=0, rows = ws['!rows'];
	var dense = Array.isArray(ws);
	var params = ({r:rr}), row, height = -1;
	for(C = range.s.c; C <= range.e.c; ++C) cols[C] = encode_col(C);
	for(R = range.s.r; R <= range.e.r; ++R) {
		r = [];
		rr = encode_row(R);
		for(C = range.s.c; C <= range.e.c; ++C) {
			ref = cols[C] + rr;
			var _cell = dense ? (ws[R]||[])[C]: ws[ref];
			if(_cell === undefined) continue;
			if((cell = write_ws_xml_cell(_cell, ref, ws, opts, idx, wb)) != null) r.push(cell);
		}
		if(r.length > 0 || (rows && rows[R])) {
			params = ({r:rr});
			if(rows && rows[R]) {
				row = rows[R];
				if(row.hidden) params.hidden = 1;
				height = -1;
				if(row.hpx) height = px2pt(row.hpx);
				else if(row.hpt) height = row.hpt;
				if(height > -1) { params.ht = height; params.customHeight = 1; }
				if(row.level) { params.outlineLevel = row.level; }
			}
			o[o.length] = (writextag('row', r.join(""), params));
		}
	}
	if(rows) for(; R < rows.length; ++R) {
		if(rows && rows[R]) {
			params = ({r:R+1});
			row = rows[R];
			if(row.hidden) params.hidden = 1;
			height = -1;
			if (row.hpx) height = px2pt(row.hpx);
			else if (row.hpt) height = row.hpt;
			if (height > -1) { params.ht = height; params.customHeight = 1; }
			if (row.level) { params.outlineLevel = row.level; }
			o[o.length] = (writextag('row', "", params));
		}
	}
	return o.join("");
}

var WS_XML_ROOT = writextag('worksheet', null, {
	'xmlns': XMLNS.main[0],
	'xmlns:r': XMLNS.r
});

function write_ws_xml(idx, opts, wb, rels) {
	var o = [XML_HEADER, WS_XML_ROOT];
	var s = wb.SheetNames[idx], sidx = 0, rdata = "";
	var ws = wb.Sheets[s];
	if(ws == null) ws = {};
	var ref = ws['!ref'] || 'A1';
	var range = safe_decode_range(ref);
	if(range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
		if(opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
		range.e.c = Math.min(range.e.c, 0x3FFF);
		range.e.r = Math.min(range.e.c, 0xFFFFF);
		ref = encode_range(range);
	}
	if(!rels) rels = {};
	ws['!comments'] = [];
	ws['!drawing'] = [];

	if(opts.bookType !== 'xlsx' && wb.vbaraw) {
		var cname = wb.SheetNames[idx];
		try { if(wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname; } catch(e) {}
		o[o.length] = (writextag('sheetPr', null, {'codeName': escapexml(cname)}));
	}

	o[o.length] = (writextag('dimension', null, {'ref': ref}));

	o[o.length] = write_ws_xml_sheetviews(ws, opts, idx, wb);

	/* TODO: store in WB, process styles */
	if(opts.sheetFormat) o[o.length] = (writextag('sheetFormatPr', null, {
		defaultRowHeight:opts.sheetFormat.defaultRowHeight||'16',
		baseColWidth:opts.sheetFormat.baseColWidth||'10',
		outlineLevelRow:opts.sheetFormat.outlineLevelRow||'7'
	}));

	if(ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = (write_ws_xml_cols(ws, ws['!cols']));

	o[sidx = o.length] = '<sheetData/>';
	ws['!links'] = [];
	if(ws['!ref'] != null) {
		rdata = write_ws_xml_data(ws, opts, idx, wb, rels);
		if(rdata.length > 0) o[o.length] = (rdata);
	}
	if(o.length>sidx+1) { o[o.length] = ('</sheetData>'); o[sidx]=o[sidx].replace("/>",">"); }

	/* sheetCalcPr */

	if(ws['!protect'] != null) o[o.length] = write_ws_xml_protection(ws['!protect']);

	/* protectedRanges */
	/* scenarios */

	if(ws['!autofilter'] != null) o[o.length] = write_ws_xml_autofilter(ws['!autofilter'], ws, wb, idx);

	/* sortState */
	/* dataConsolidate */
	/* customSheetViews */

	if(ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = (write_ws_xml_merges(ws['!merges']));

	/* phoneticPr */
	/* conditionalFormatting */
	/* dataValidations */

	var relc = -1, rel, rId = -1;
	if(ws['!links'].length > 0) {
		o[o.length] = "<hyperlinks>";
		ws['!links'].forEach(function(l) {
			if(!l[1].Target) return;
			rel = ({"ref":l[0]});
			if(l[1].Target.charAt(0) != "#") {
				rId = add_rels(rels, -1, escapexml(l[1].Target).replace(/#.*$/, ""), RELS.HLINK);
				rel["r:id"] = "rId"+rId;
			}
			if((relc = l[1].Target.indexOf("#")) > -1) rel.location = escapexml(l[1].Target.slice(relc+1));
			if(l[1].Tooltip) rel.tooltip = escapexml(l[1].Tooltip);
			o[o.length] = writextag("hyperlink",null,rel);
		});
		o[o.length] = "</hyperlinks>";
	}
	delete ws['!links'];

	/* printOptions */
	if (ws['!margins'] != null) o[o.length] =  write_ws_xml_margins(ws['!margins']);
	/* pageSetup */

	//var hfidx = o.length;
	o[o.length] = "";

	/* rowBreaks */
	/* colBreaks */
	/* customProperties */
	/* cellWatches */

	if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) o[o.length] = writetag("ignoredErrors", writextag("ignoredError", null, {numberStoredAsText:1, sqref:ref}));

	/* smartTags */

	if(ws['!drawing'].length > 0) {
		rId = add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
		o[o.length] = writextag("drawing", null, {"r:id":"rId" + rId});
	}
	else delete ws['!drawing'];

	if(ws['!comments'].length > 0) {
		rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
		o[o.length] = writextag("legacyDrawing", null, {"r:id":"rId" + rId});
		ws['!legacy'] = rId;
	}

	/* drawingHF */
	/* picture */
	/* oleObjects */
	/* controls */
	/* webPublishItems */
	/* tableParts */
	/* extList */

	if(o.length>2) { o[o.length] = ('</worksheet>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}

/* [MS-XLSB] 2.4.726 BrtRowHdr */
function parse_BrtRowHdr(data, length) {
	var z = ({});
	var tgt = data.l + length;
	z.r = data.read_shift(4);
	data.l += 4; // TODO: ixfe
	var miyRw = data.read_shift(2);
	data.l += 1; // TODO: top/bot padding
	var flags = data.read_shift(1);
	data.l = tgt;
	if(flags & 0x07) z.level = flags & 0x07;
	if(flags & 0x10) z.hidden = true;
	if(flags & 0x20) z.hpt = miyRw / 20;
	return z;
}
function write_BrtRowHdr(R, range, ws) {
	var o = new_buf(17+8*16);
	var row = (ws['!rows']||[])[R]||{};
	o.write_shift(4, R);

	o.write_shift(4, 0); /* TODO: ixfe */

	var miyRw = 0x0140;
	if(row.hpx) miyRw = px2pt(row.hpx) * 20;
	else if(row.hpt) miyRw = row.hpt * 20;
	o.write_shift(2, miyRw);

	o.write_shift(1, 0); /* top/bot padding */

	var flags = 0x0;
	if(row.level) flags |= row.level;
	if(row.hidden) flags |= 0x10;
	if(row.hpx || row.hpt) flags |= 0x20;
	o.write_shift(1, flags);

	o.write_shift(1, 0); /* phonetic guide */

	/* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */
	var ncolspan = 0, lcs = o.l;
	o.l += 4;

	var caddr = {r:R, c:0};
	for(var i = 0; i < 16; ++i) {
		if((range.s.c > ((i+1) << 10)) || (range.e.c < (i << 10))) continue;
		var first = -1, last = -1;
		for(var j = (i<<10); j < ((i+1)<<10); ++j) {
			caddr.c = j;
			var cell = Array.isArray(ws) ? (ws[caddr.r]||[])[caddr.c] : ws[encode_cell(caddr)];
			if(cell) { if(first < 0) first = j; last = j; }
		}
		if(first < 0) continue;
		++ncolspan;
		o.write_shift(4, first);
		o.write_shift(4, last);
	}

	var l = o.l;
	o.l = lcs;
	o.write_shift(4, ncolspan);
	o.l = l;

	return o.length > o.l ? o.slice(0, o.l) : o;
}
function write_row_header(ba, ws, range, R) {
	var o = write_BrtRowHdr(R, range, ws);
	if((o.length > 17) || (ws['!rows']||[])[R]) write_record(ba, 'BrtRowHdr', o);
}

/* [MS-XLSB] 2.4.820 BrtWsDim */
var parse_BrtWsDim = parse_UncheckedRfX;
var write_BrtWsDim = write_UncheckedRfX;

/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */
function parse_BrtWsFmtInfo() {
}
//function write_BrtWsFmtInfo(ws, o) { }

/* [MS-XLSB] 2.4.823 BrtWsProp */
function parse_BrtWsProp(data, length) {
	var z = {};
	/* TODO: pull flags */
	data.l += 19;
	z.name = parse_XLSBCodeName(data, length - 19);
	return z;
}
function write_BrtWsProp(str, o) {
	if(o == null) o = new_buf(84+4*str.length);
	for(var i = 0; i < 3; ++i) o.write_shift(1,0);
	write_BrtColor({auto:1}, o);
	o.write_shift(-4,-1);
	o.write_shift(-4,-1);
	write_XLSBCodeName(str, o);
	return o.slice(0, o.l);
}

/* [MS-XLSB] 2.4.306 BrtCellBlank */
function parse_BrtCellBlank(data) {
	var cell = parse_XLSBCell(data);
	return [cell];
}
function write_BrtCellBlank(cell, ncell, o) {
	if(o == null) o = new_buf(8);
	return write_XLSBCell(ncell, o);
}


/* [MS-XLSB] 2.4.307 BrtCellBool */
function parse_BrtCellBool(data) {
	var cell = parse_XLSBCell(data);
	var fBool = data.read_shift(1);
	return [cell, fBool, 'b'];
}
function write_BrtCellBool(cell, ncell, o) {
	if(o == null) o = new_buf(9);
	write_XLSBCell(ncell, o);
	o.write_shift(1, cell.v ? 1 : 0);
	return o;
}

/* [MS-XLSB] 2.4.308 BrtCellError */
function parse_BrtCellError(data) {
	var cell = parse_XLSBCell(data);
	var bError = data.read_shift(1);
	return [cell, bError, 'e'];
}

/* [MS-XLSB] 2.4.311 BrtCellIsst */
function parse_BrtCellIsst(data) {
	var cell = parse_XLSBCell(data);
	var isst = data.read_shift(4);
	return [cell, isst, 's'];
}
function write_BrtCellIsst(cell, ncell, o) {
	if(o == null) o = new_buf(12);
	write_XLSBCell(ncell, o);
	o.write_shift(4, ncell.v);
	return o;
}

/* [MS-XLSB] 2.4.313 BrtCellReal */
function parse_BrtCellReal(data) {
	var cell = parse_XLSBCell(data);
	var value = parse_Xnum(data);
	return [cell, value, 'n'];
}
function write_BrtCellReal(cell, ncell, o) {
	if(o == null) o = new_buf(16);
	write_XLSBCell(ncell, o);
	write_Xnum(cell.v, o);
	return o;
}

/* [MS-XLSB] 2.4.314 BrtCellRk */
function parse_BrtCellRk(data) {
	var cell = parse_XLSBCell(data);
	var value = parse_RkNumber(data);
	return [cell, value, 'n'];
}
function write_BrtCellRk(cell, ncell, o) {
	if(o == null) o = new_buf(12);
	write_XLSBCell(ncell, o);
	write_RkNumber(cell.v, o);
	return o;
}


/* [MS-XLSB] 2.4.317 BrtCellSt */
function parse_BrtCellSt(data) {
	var cell = parse_XLSBCell(data);
	var value = parse_XLWideString(data);
	return [cell, value, 'str'];
}
function write_BrtCellSt(cell, ncell, o) {
	if(o == null) o = new_buf(12 + 4 * cell.v.length);
	write_XLSBCell(ncell, o);
	write_XLWideString(cell.v, o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.653 BrtFmlaBool */
function parse_BrtFmlaBool(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = data.read_shift(1);
	var o = [cell, value, 'b'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.654 BrtFmlaError */
function parse_BrtFmlaError(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = data.read_shift(1);
	var o = [cell, value, 'e'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.655 BrtFmlaNum */
function parse_BrtFmlaNum(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = parse_Xnum(data);
	var o = [cell, value, 'n'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.656 BrtFmlaString */
function parse_BrtFmlaString(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = parse_XLWideString(data);
	var o = [cell, value, 'str'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.682 BrtMergeCell */
var parse_BrtMergeCell = parse_UncheckedRfX;
var write_BrtMergeCell = write_UncheckedRfX;
/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */
function write_BrtBeginMergeCells(cnt, o) {
	if(o == null) o = new_buf(4);
	o.write_shift(4, cnt);
	return o;
}

/* [MS-XLSB] 2.4.662 BrtHLink */
function parse_BrtHLink(data, length) {
	var end = data.l + length;
	var rfx = parse_UncheckedRfX(data, 16);
	var relId = parse_XLNullableWideString(data);
	var loc = parse_XLWideString(data);
	var tooltip = parse_XLWideString(data);
	var display = parse_XLWideString(data);
	data.l = end;
	var o = ({rfx:rfx, relId:relId, loc:loc, display:display});
	if(tooltip) o.Tooltip = tooltip;
	return o;
}
function write_BrtHLink(l, rId) {
	var o = new_buf(50+4*(l[1].Target.length + (l[1].Tooltip || "").length));
	write_UncheckedRfX({s:decode_cell(l[0]), e:decode_cell(l[0])}, o);
	write_RelID("rId" + rId, o);
	var locidx = l[1].Target.indexOf("#");
	var loc = locidx == -1 ? "" : l[1].Target.slice(locidx+1);
	write_XLWideString(loc || "", o);
	write_XLWideString(l[1].Tooltip || "", o);
	write_XLWideString("", o);
	return o.slice(0, o.l);
}

/* [MS-XLSB] 2.4.6 BrtArrFmla */
function parse_BrtArrFmla(data, length, opts) {
	var end = data.l + length;
	var rfx = parse_RfX(data, 16);
	var fAlwaysCalc = data.read_shift(1);
	var o = [rfx]; o[2] = fAlwaysCalc;
	if(opts.cellFormula) {
		var formula = parse_XLSBArrayParsedFormula(data, end - data.l, opts);
		o[1] = formula;
	} else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.750 BrtShrFmla */
function parse_BrtShrFmla(data, length, opts) {
	var end = data.l + length;
	var rfx = parse_UncheckedRfX(data, 16);
	var o = [rfx];
	if(opts.cellFormula) {
		var formula = parse_XLSBSharedParsedFormula(data, end - data.l, opts);
		o[1] = formula;
		data.l = end;
	} else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.323 BrtColInfo */
/* TODO: once XLS ColInfo is set, combine the functions */
function write_BrtColInfo(C, col, o) {
	if(o == null) o = new_buf(18);
	var p = col_obj_w(C, col);
	o.write_shift(-4, C);
	o.write_shift(-4, C);
	o.write_shift(4, (p.width || 10) * 256);
	o.write_shift(4, 0/*ixfe*/); // style
	var flags = 0;
	if(col.hidden) flags |= 0x01;
	if(typeof p.width == 'number') flags |= 0x02;
	o.write_shift(1, flags); // bit flag
	o.write_shift(1, 0); // bit flag
	return o;
}

/* [MS-XLSB] 2.4.678 BrtMargins */
var BrtMarginKeys = ["left","right","top","bottom","header","footer"];
function parse_BrtMargins(data) {
	var margins = ({});
	BrtMarginKeys.forEach(function(k) { margins[k] = parse_Xnum(data, 8); });
	return margins;
}
function write_BrtMargins(margins, o) {
	if(o == null) o = new_buf(6*8);
	default_margins(margins);
	BrtMarginKeys.forEach(function(k) { write_Xnum((margins)[k], o); });
	return o;
}

/* [MS-XLSB] 2.4.299 BrtBeginWsView */
function parse_BrtBeginWsView(data) {
	var f = data.read_shift(2);
	data.l += 28;
	return { RTL: f & 0x20 };
}
function write_BrtBeginWsView(ws, Workbook, o) {
	if(o == null) o = new_buf(30);
	var f = 0x39c;
	if((((Workbook||{}).Views||[])[0]||{}).RTL) f |= 0x20;
	o.write_shift(2, f); // bit flag
	o.write_shift(4, 0);
	o.write_shift(4, 0); // view first row
	o.write_shift(4, 0); // view first col
	o.write_shift(1, 0); // gridline color ICV
	o.write_shift(1, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 100); // zoom scale
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(4, 0); // workbook view id
	return o;
}

/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */
function write_BrtCellIgnoreEC(ref) {
	var o = new_buf(24);
	o.write_shift(4, 4);
	o.write_shift(4, 1);
	write_UncheckedRfX(ref, o);
	return o;
}

/* [MS-XLSB] 2.4.748 BrtSheetProtection */
function write_BrtSheetProtection(sp, o) {
	if(o == null) o = new_buf(16*4+2);
	o.write_shift(2, sp.password ? crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
	o.write_shift(4, 1); // this record should not be written if no protection
	[
		["objects",             false], // fObjects
		["scenarios",           false], // fScenarios
		["formatCells",          true], // fFormatCells
		["formatColumns",        true], // fFormatColumns
		["formatRows",           true], // fFormatRows
		["insertColumns",        true], // fInsertColumns
		["insertRows",           true], // fInsertRows
		["insertHyperlinks",     true], // fInsertHyperlinks
		["deleteColumns",        true], // fDeleteColumns
		["deleteRows",           true], // fDeleteRows
		["selectLockedCells",   false], // fSelLockedCells
		["sort",                 true], // fSort
		["autoFilter",           true], // fAutoFilter
		["pivotTables",          true], // fPivotTables
		["selectUnlockedCells", false]  // fSelUnlockedCells
	].forEach(function(n) {
if(n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
		else      o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
	});
	return o;
}

/* [MS-XLSB] 2.1.7.61 Worksheet */
function parse_ws_bin(data, _opts, idx, rels, wb, themes, styles) {
	if(!data) return data;
	var opts = _opts || {};
	if(!rels) rels = {'!id':{}};
	if(DENSE != null && opts.dense == null) opts.dense = DENSE;
	var s = (opts.dense ? [] : {});

	var ref;
	var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };

	var pass = false, end = false;
	var row, p, cf, R, C, addr, sstr, rr, cell;
	var merges = [];
	opts.biff = 12;
	opts['!row'] = 0;

	var ai = 0, af = false;

	var arrayf = [];
	var sharedf = {};
	var supbooks = opts.supbooks || wb.supbooks || ([[]]);
	supbooks.sharedf = sharedf;
	supbooks.arrayf = arrayf;
	supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) { return x.name; });
	if(!opts.supbooks) {
		opts.supbooks = supbooks;
		if(wb.Names) for(var i = 0; i < wb.Names.length; ++i) supbooks[0][i+1] = wb.Names[i];
	}

	var colinfo = [], rowinfo = [];
	var seencol = false;

	recordhopper(data, function ws_parse(val, R_n, RT) {
		if(end) return;
		switch(RT) {
			case 0x0094: /* 'BrtWsDim' */
				ref = val; break;
			case 0x0000: /* 'BrtRowHdr' */
				row = val;
				if(opts.sheetRows && opts.sheetRows <= row.r) end=true;
				rr = encode_row(R = row.r);
				opts['!row'] = row.r;
				if(val.hidden || val.hpt || val.level != null) {
					if(val.hpt) val.hpx = pt2px(val.hpt);
					rowinfo[val.r] = val;
				}
				break;

			case 0x0002: /* 'BrtCellRk' */
			case 0x0003: /* 'BrtCellError' */
			case 0x0004: /* 'BrtCellBool' */
			case 0x0005: /* 'BrtCellReal' */
			case 0x0006: /* 'BrtCellSt' */
			case 0x0007: /* 'BrtCellIsst' */
			case 0x0008: /* 'BrtFmlaString' */
			case 0x0009: /* 'BrtFmlaNum' */
			case 0x000A: /* 'BrtFmlaBool' */
			case 0x000B: /* 'BrtFmlaError' */
				p = ({t:val[2]});
				switch(val[2]) {
					case 'n': p.v = val[1]; break;
					case 's': sstr = strs[val[1]]; p.v = sstr.t; p.r = sstr.r; break;
					case 'b': p.v = val[1] ? true : false; break;
					case 'e': p.v = val[1]; if(opts.cellText !== false) p.w = BErr[p.v]; break;
					case 'str': p.t = 's'; p.v = val[1]; break;
				}
				if((cf = styles.CellXf[val[0].iStyleRef])) safe_format(p,cf.numFmtId,null,opts, themes, styles);
				C = val[0].c;
				if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
				else s[encode_col(C) + rr] = p;
				if(opts.cellFormula) {
					af = false;
					for(ai = 0; ai < arrayf.length; ++ai) {
						var aii = arrayf[ai];
						if(row.r >= aii[0].s.r && row.r <= aii[0].e.r)
							if(C >= aii[0].s.c && C <= aii[0].e.c) {
								p.F = encode_range(aii[0]); af = true;
							}
					}
					if(!af && val.length > 3) p.f = val[3];
				}
				if(refguess.s.r > row.r) refguess.s.r = row.r;
				if(refguess.s.c > C) refguess.s.c = C;
				if(refguess.e.r < row.r) refguess.e.r = row.r;
				if(refguess.e.c < C) refguess.e.c = C;
				if(opts.cellDates && cf && p.t == 'n' && SSF.is_date(SSF._table[cf.numFmtId])) {
					var _d = SSF.parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
				}
				break;

			case 0x0001: /* 'BrtCellBlank' */
				if(!opts.sheetStubs || pass) break;
				p = ({t:'z',v:undefined});
				C = val[0].c;
				if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
				else s[encode_col(C) + rr] = p;
				if(refguess.s.r > row.r) refguess.s.r = row.r;
				if(refguess.s.c > C) refguess.s.c = C;
				if(refguess.e.r < row.r) refguess.e.r = row.r;
				if(refguess.e.c < C) refguess.e.c = C;
				break;

			case 0x00B0: /* 'BrtMergeCell' */
				merges.push(val); break;

			case 0x01EE: /* 'BrtHLink' */
				var rel = rels['!id'][val.relId];
				if(rel) {
					val.Target = rel.Target;
					if(val.loc) val.Target += "#"+val.loc;
					val.Rel = rel;
				} else if(val.relId == '') {
					val.Target = "#" + val.loc;
				}
				for(R=val.rfx.s.r;R<=val.rfx.e.r;++R) for(C=val.rfx.s.c;C<=val.rfx.e.c;++C) {
					if(opts.dense) {
						if(!s[R]) s[R] = [];
						if(!s[R][C]) s[R][C] = {t:'z',v:undefined};
						s[R][C].l = val;
					} else {
						addr = encode_cell({c:C,r:R});
						if(!s[addr]) s[addr] = {t:'z',v:undefined};
						s[addr].l = val;
					}
				}
				break;

			case 0x01AA: /* 'BrtArrFmla' */
				if(!opts.cellFormula) break;
				arrayf.push(val);
				cell = ((opts.dense ? s[R][C] : s[encode_col(C) + rr]));
				cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
				cell.F = encode_range(val[0]);
				break;
			case 0x01AB: /* 'BrtShrFmla' */
				if(!opts.cellFormula) break;
				sharedf[encode_cell(val[0].s)] = val[1];
				cell = (opts.dense ? s[R][C] : s[encode_col(C) + rr]);
				cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
				break;

			/* identical to 'ColInfo' in XLS */
			case 0x003C: /* 'BrtColInfo' */
				if(!opts.cellStyles) break;
				while(val.e >= val.s) {
					colinfo[val.e--] = { width: val.w/256, hidden: !!(val.flags & 0x01) };
					if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
					process_col(colinfo[val.e+1]);
				}
				break;

			case 0x00A1: /* 'BrtBeginAFilter' */
				s['!autofilter'] = { ref:encode_range(val) };
				break;

			case 0x01DC: /* 'BrtMargins' */
				s['!margins'] = val;
				break;

			case 0x0093: /* 'BrtWsProp' */
				if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
				if(val.name) wb.Sheets[idx].CodeName = val.name;
				break;

			case 0x0089: /* 'BrtBeginWsView' */
				if(!wb.Views) wb.Views = [{}];
				if(!wb.Views[0]) wb.Views[0] = {};
				if(val.RTL) wb.Views[0].RTL = true;
				break;

			case 0x01E5: /* 'BrtWsFmtInfo' */
				break;
			case 0x00AF: /* 'BrtAFilterDateGroupItem' */
			case 0x0284: /* 'BrtActiveX' */
			case 0x0271: /* 'BrtBigName' */
			case 0x0232: /* 'BrtBkHim' */
			case 0x018C: /* 'BrtBrk' */
			case 0x0458: /* 'BrtCFIcon' */
			case 0x047A: /* 'BrtCFRuleExt' */
			case 0x01D7: /* 'BrtCFVO' */
			case 0x041A: /* 'BrtCFVO14' */
			case 0x0289: /* 'BrtCellIgnoreEC' */
			case 0x0451: /* 'BrtCellIgnoreEC14' */
			case 0x0031: /* 'BrtCellMeta' */
			case 0x024D: /* 'BrtCellSmartTagProperty' */
			case 0x025F: /* 'BrtCellWatch' */
			case 0x0234: /* 'BrtColor' */
			case 0x041F: /* 'BrtColor14' */
			case 0x00A8: /* 'BrtColorFilter' */
			case 0x00AE: /* 'BrtCustomFilter' */
			case 0x049C: /* 'BrtCustomFilter14' */
			case 0x01F3: /* 'BrtDRef' */
			case 0x0040: /* 'BrtDVal' */
			case 0x041D: /* 'BrtDVal14' */
			case 0x0226: /* 'BrtDrawing' */
			case 0x00AB: /* 'BrtDynamicFilter' */
			case 0x00A7: /* 'BrtFilter' */
			case 0x0499: /* 'BrtFilter14' */
			case 0x00A9: /* 'BrtIconFilter' */
			case 0x049D: /* 'BrtIconFilter14' */
			case 0x0227: /* 'BrtLegacyDrawing' */
			case 0x0228: /* 'BrtLegacyDrawingHF' */
			case 0x0295: /* 'BrtListPart' */
			case 0x027F: /* 'BrtOleObject' */
			case 0x01DE: /* 'BrtPageSetup' */
			case 0x0097: /* 'BrtPane' */
			case 0x0219: /* 'BrtPhoneticInfo' */
			case 0x01DD: /* 'BrtPrintOptions' */
			case 0x0218: /* 'BrtRangeProtection' */
			case 0x044F: /* 'BrtRangeProtection14' */
			case 0x02A8: /* 'BrtRangeProtectionIso' */
			case 0x0450: /* 'BrtRangeProtectionIso14' */
			case 0x0400: /* 'BrtRwDescent' */
			case 0x0098: /* 'BrtSel' */
			case 0x0297: /* 'BrtSheetCalcProp' */
			case 0x0217: /* 'BrtSheetProtection' */
			case 0x02A6: /* 'BrtSheetProtectionIso' */
			case 0x01F8: /* 'BrtSlc' */
			case 0x0413: /* 'BrtSparkline' */
			case 0x01AC: /* 'BrtTable' */
			case 0x00AA: /* 'BrtTop10Filter' */
			case 0x0C00: /* 'BrtUid' */
			case 0x0032: /* 'BrtValueMeta' */
			case 0x0816: /* 'BrtWebExtension' */
			case 0x0415: /* 'BrtWsFmtInfoEx14' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */ break;
			case 0x0026: /* 'BrtACEnd' */ break;

			default:
				if((R_n||"").indexOf("Begin") > 0){/* empty */}
				else if((R_n||"").indexOf("End") > 0){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	}, opts);

	delete opts.supbooks;
	delete opts['!row'];

	if(!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = encode_range(ref || refguess);
	if(opts.sheetRows && s["!ref"]) {
		var tmpref = safe_decode_range(s["!ref"]);
		if(opts.sheetRows <= +tmpref.e.r) {
			tmpref.e.r = opts.sheetRows - 1;
			if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
			if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
			if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
			if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
			s["!fullref"] = s["!ref"];
			s["!ref"] = encode_range(tmpref);
		}
	}
	if(merges.length > 0) s["!merges"] = merges;
	if(colinfo.length > 0) s["!cols"] = colinfo;
	if(rowinfo.length > 0) s["!rows"] = rowinfo;
	return s;
}

/* TODO: something useful -- this is a stub */
function write_ws_bin_cell(ba, cell, R, C, opts, ws) {
	if(cell.v === undefined) return "";
	var vv = "";
	switch(cell.t) {
		case 'b': vv = cell.v ? "1" : "0"; break;
		case 'd': // no BrtCellDate :(
			cell = dup(cell);
			cell.z = cell.z || SSF._table[14];
			cell.v = datenum(parseDate(cell.v)); cell.t = 'n';
			break;
		/* falls through */
		case 'n': case 'e': vv = ''+cell.v; break;
		default: vv = cell.v; break;
	}
	var o = ({r:R, c:C});
	/* TODO: cell style */
	o.s = get_cell_style(opts.cellXfs, cell, opts);
	if(cell.l) ws['!links'].push([encode_cell(o), cell.l]);
	if(cell.c) ws['!comments'].push([encode_cell(o), cell.c]);
	switch(cell.t) {
		case 's': case 'str':
			if(opts.bookSST) {
				vv = get_sst_id(opts.Strings, (cell.v), opts.revStrings);
				o.t = "s"; o.v = vv;
				write_record(ba, "BrtCellIsst", write_BrtCellIsst(cell, o));
			} else {
				o.t = "str";
				write_record(ba, "BrtCellSt", write_BrtCellSt(cell, o));
			}
			return;
		case 'n':
			/* TODO: determine threshold for Real vs RK */
			if(cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) write_record(ba, "BrtCellRk", write_BrtCellRk(cell, o));
			else write_record(ba, "BrtCellReal", write_BrtCellReal(cell, o));
			return;
		case 'b':
			o.t = "b";
			write_record(ba, "BrtCellBool", write_BrtCellBool(cell, o));
			return;
		case 'e': /* TODO: error */ o.t = "e"; break;
	}
	write_record(ba, "BrtCellBlank", write_BrtCellBlank(cell, o));
}

function write_CELLTABLE(ba, ws, idx, opts) {
	var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
	write_record(ba, 'BrtBeginSheetData');
	var dense = Array.isArray(ws);
	var cap = range.e.r;
	if(ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
	for(var R = range.s.r; R <= cap; ++R) {
		rr = encode_row(R);
		/* [ACCELLTABLE] */
		/* BrtRowHdr */
		write_row_header(ba, ws, range, R);
		if(R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C) {
			/* *16384CELL */
			if(R === range.s.r) cols[C] = encode_col(C);
			ref = cols[C] + rr;
			var cell = dense ? (ws[R]||[])[C] : ws[ref];
			if(!cell) continue;
			/* write cell */
			write_ws_bin_cell(ba, cell, R, C, opts, ws);
		}
	}
	write_record(ba, 'BrtEndSheetData');
}

function write_MERGECELLS(ba, ws) {
	if(!ws || !ws['!merges']) return;
	write_record(ba, 'BrtBeginMergeCells', write_BrtBeginMergeCells(ws['!merges'].length));
	ws['!merges'].forEach(function(m) { write_record(ba, 'BrtMergeCell', write_BrtMergeCell(m)); });
	write_record(ba, 'BrtEndMergeCells');
}

function write_COLINFOS(ba, ws) {
	if(!ws || !ws['!cols']) return;
	write_record(ba, 'BrtBeginColInfos');
	ws['!cols'].forEach(function(m, i) { if(m) write_record(ba, 'BrtColInfo', write_BrtColInfo(i, m)); });
	write_record(ba, 'BrtEndColInfos');
}

function write_IGNOREECS(ba, ws) {
	if(!ws || !ws['!ref']) return;
	write_record(ba, 'BrtBeginCellIgnoreECs');
	write_record(ba, 'BrtCellIgnoreEC', write_BrtCellIgnoreEC(safe_decode_range(ws['!ref'])));
	write_record(ba, 'BrtEndCellIgnoreECs');
}

function write_HLINKS(ba, ws, rels) {
	/* *BrtHLink */
	ws['!links'].forEach(function(l) {
		if(!l[1].Target) return;
		var rId = add_rels(rels, -1, l[1].Target.replace(/#.*$/, ""), RELS.HLINK);
		write_record(ba, "BrtHLink", write_BrtHLink(l, rId));
	});
	delete ws['!links'];
}
function write_LEGACYDRAWING(ba, ws, idx, rels) {
	/* [BrtLegacyDrawing] */
	if(ws['!comments'].length > 0) {
		var rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
		write_record(ba, "BrtLegacyDrawing", write_RelID("rId" + rId));
		ws['!legacy'] = rId;
	}
}

function write_AUTOFILTER(ba, ws) {
	if(!ws['!autofilter']) return;
	write_record(ba, "BrtBeginAFilter", write_UncheckedRfX(safe_decode_range(ws['!autofilter'].ref)));
	/* *FILTERCOLUMN */
	/* [SORTSTATE] */
	/* BrtEndAFilter */
	write_record(ba, "BrtEndAFilter");
}

function write_WSVIEWS2(ba, ws, Workbook) {
	write_record(ba, "BrtBeginWsViews");
	{ /* 1*WSVIEW2 */
		/* [ACUID] */
		write_record(ba, "BrtBeginWsView", write_BrtBeginWsView(ws, Workbook));
		/* [BrtPane] */
		/* *4BrtSel */
		/* *4SXSELECT */
		/* *FRT */
		write_record(ba, "BrtEndWsView");
	}
	/* *FRT */
	write_record(ba, "BrtEndWsViews");
}

function write_WSFMTINFO() {
	/* [ACWSFMTINFO] */
	//write_record(ba, "BrtWsFmtInfo", write_BrtWsFmtInfo(ws));
}

function write_SHEETPROTECT(ba, ws) {
	if(!ws['!protect']) return;
	/* [BrtSheetProtectionIso] */
	write_record(ba, "BrtSheetProtection", write_BrtSheetProtection(ws['!protect']));
}

function write_ws_bin(idx, opts, wb, rels) {
	var ba = buf_array();
	var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
	var c = s; try { if(wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c; } catch(e) {}
	var r = safe_decode_range(ws['!ref'] || "A1");
	if(r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
		if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
		r.e.c = Math.min(r.e.c, 0x3FFF);
		r.e.r = Math.min(r.e.c, 0xFFFFF);
	}
	ws['!links'] = [];
	/* passed back to write_zip and removed there */
	ws['!comments'] = [];
	write_record(ba, "BrtBeginSheet");
	if(wb.vbaraw) write_record(ba, "BrtWsProp", write_BrtWsProp(c));
	write_record(ba, "BrtWsDim", write_BrtWsDim(r));
	write_WSVIEWS2(ba, ws, wb.Workbook);
	write_WSFMTINFO(ba, ws);
	write_COLINFOS(ba, ws, idx, opts, wb);
	write_CELLTABLE(ba, ws, idx, opts, wb);
	/* [BrtSheetCalcProp] */
	write_SHEETPROTECT(ba, ws);
	/* *([BrtRangeProtectionIso] BrtRangeProtection) */
	/* [SCENMAN] */
	write_AUTOFILTER(ba, ws);
	/* [SORTSTATE] */
	/* [DCON] */
	/* [USERSHVIEWS] */
	write_MERGECELLS(ba, ws);
	/* [BrtPhoneticInfo] */
	/* *CONDITIONALFORMATTING */
	/* [DVALS] */
	write_HLINKS(ba, ws, rels);
	/* [BrtPrintOptions] */
	if(ws['!margins']) write_record(ba, "BrtMargins", write_BrtMargins(ws['!margins']));
	/* [BrtPageSetup] */
	/* [HEADERFOOTER] */
	/* [RWBRK] */
	/* [COLBRK] */
	/* *BrtBigName */
	/* [CELLWATCHES] */
	if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) write_IGNOREECS(ba, ws);
	/* [SMARTTAGS] */
	/* [BrtDrawing] */
	write_LEGACYDRAWING(ba, ws, idx, rels);
	/* [BrtLegacyDrawingHF] */
	/* [BrtBkHim] */
	/* [OLEOBJECTS] */
	/* [ACTIVEXCONTROLS] */
	/* [WEBPUBITEMS] */
	/* [LISTPARTS] */
	/* FRTWORKSHEET */
	write_record(ba, "BrtEndSheet");
	return ba.end();
}
function parse_numCache(data) {
	var col = [];

	/* 21.2.2.150 pt CT_NumVal */
	(data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg)||[]).forEach(function(pt) {
		var q = pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
		if(!q) return;
		col[+q[1]] = +q[2];
	});

	/* 21.2.2.71 formatCode CT_Xstring */
	var nf = unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["","General"])[1]);

	return [col, nf];
}

/* 21.2 DrawingML - Charts */
function parse_chart(data, name, opts, rels, wb, csheet) {
	var cs = ((csheet || {"!type":"chart"}));
	if(!data) return csheet;
	/* 21.2.2.27 chart CT_Chart */

	var C = 0, R = 0, col = "A";
	var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };

	/* 21.2.2.120 numCache CT_NumData */
	(data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(nc) {
		var cache = parse_numCache(nc);
		refguess.s.r = refguess.s.c = 0;
		refguess.e.c = C;
		col = encode_col(C);
		cache[0].forEach(function(n,i) {
			cs[col + encode_row(i)] = {t:'n', v:n, z:cache[1] };
			R = i;
		});
		if(refguess.e.r < R) refguess.e.r = R;
		++C;
	});
	if(C > 0) cs["!ref"] = encode_range(refguess);
	return cs;
}
RELS.CS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet";

var CS_XML_ROOT = writextag('chartsheet', null, {
	'xmlns': XMLNS.main[0],
	'xmlns:r': XMLNS.r
});

/* 18.3 Worksheets also covers Chartsheets */
function parse_cs_xml(data, opts, idx, rels, wb) {
	if(!data) return data;
	/* 18.3.1.12 chartsheet CT_ChartSheet */
	if(!rels) rels = {'!id':{}};
	var s = {'!type':"chart", '!chart':null, '!rel':""};
	var m;

	/* 18.3.1.83 sheetPr CT_ChartsheetPr */
	var sheetPr = data.match(sheetprregex);
	if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);

	/* 18.3.1.36 drawing CT_Drawing */
	if((m = data.match(/drawing r:id="(.*?)"/))) s['!rel'] = m[1];

	if(rels['!id'][s['!rel']]) s['!chart'] = rels['!id'][s['!rel']];
	return s;
}
function write_cs_xml(idx, opts, wb, rels) {
	var o = [XML_HEADER, CS_XML_ROOT];
	o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
	add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
	if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}

/* [MS-XLSB] 2.4.331 BrtCsProp */
function parse_BrtCsProp(data, length) {
	data.l += 10;
	var name = parse_XLWideString(data, length - 10);
	return { name: name };
}

/* [MS-XLSB] 2.1.7.7 Chart Sheet */
function parse_cs_bin(data, opts, idx, rels, wb) {
	if(!data) return data;
	if(!rels) rels = {'!id':{}};
	var s = {'!type':"chart", '!chart':null, '!rel':""};
	var state = [];
	var pass = false;
	recordhopper(data, function cs_parse(val, R_n, RT) {
		switch(RT) {

			case 0x0226: /* 'BrtDrawing' */
				s['!rel'] = val; break;

			case 0x028B: /* 'BrtCsProp' */
				if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
				if(val.name) wb.Sheets[idx].CodeName = val.name;
				break;

			case 0x0232: /* 'BrtBkHim' */
			case 0x028C: /* 'BrtCsPageSetup' */
			case 0x029D: /* 'BrtCsProtection' */
			case 0x02A7: /* 'BrtCsProtectionIso' */
			case 0x0227: /* 'BrtLegacyDrawing' */
			case 0x0228: /* 'BrtLegacyDrawingHF' */
			case 0x01DC: /* 'BrtMargins' */
			case 0x0C00: /* 'BrtUid' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */
				state.push(R_n); break;
			case 0x0026: /* 'BrtACEnd' */
				state.pop(); break;

			default:
				if((R_n||"").indexOf("Begin") > 0) state.push(R_n);
				else if((R_n||"").indexOf("End") > 0) state.pop();
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	}, opts);

	if(rels['!id'][s['!rel']]) s['!chart'] = rels['!id'][s['!rel']];
	return s;
}
function write_cs_bin() {
	var ba = buf_array();
	write_record(ba, "BrtBeginSheet");
	/* [BrtCsProp] */
	/* CSVIEWS */
	/* [[BrtCsProtectionIso] BrtCsProtection] */
	/* [USERCSVIEWS] */
	/* [BrtMargins] */
	/* [BrtCsPageSetup] */
	/* [HEADERFOOTER] */
	/* BrtDrawing */
	/* [BrtLegacyDrawing] */
	/* [BrtLegacyDrawingHF] */
	/* [BrtBkHim] */
	/* [WEBPUBITEMS] */
	/* FRTCHARTSHEET */
	write_record(ba, "BrtEndSheet");
	return ba.end();
}
/* 18.2.28 (CT_WorkbookProtection) Defaults */
var WBPropsDef = [
	['allowRefreshQuery',           false, "bool"],
	['autoCompressPictures',        true,  "bool"],
	['backupFile',                  false, "bool"],
	['checkCompatibility',          false, "bool"],
	['CodeName',                    ''],
	['date1904',                    false, "bool"],
	['defaultThemeVersion',         0,      "int"],
	['filterPrivacy',               false, "bool"],
	['hidePivotFieldList',          false, "bool"],
	['promptedSolutions',           false, "bool"],
	['publishItems',                false, "bool"],
	['refreshAllConnections',       false, "bool"],
	['saveExternalLinkValues',      true,  "bool"],
	['showBorderUnselectedTables',  true,  "bool"],
	['showInkAnnotation',           true,  "bool"],
	['showObjects',                 'all'],
	['showPivotChartFilter',        false, "bool"],
	['updateLinks', 'userSet']
];

/* 18.2.30 (CT_BookView) Defaults */
var WBViewDef = [
	['activeTab',                   0,      "int"],
	['autoFilterDateGrouping',      true,  "bool"],
	['firstSheet',                  0,      "int"],
	['minimized',                   false, "bool"],
	['showHorizontalScroll',        true,  "bool"],
	['showSheetTabs',               true,  "bool"],
	['showVerticalScroll',          true,  "bool"],
	['tabRatio',                    600,    "int"],
	['visibility',                  'visible']
	//window{Height,Width}, {x,y}Window
];

/* 18.2.19 (CT_Sheet) Defaults */
var SheetDef = [
	//['state', 'visible']
];

/* 18.2.2  (CT_CalcPr) Defaults */
var CalcPrDef = [
	['calcCompleted', 'true'],
	['calcMode', 'auto'],
	['calcOnSave', 'true'],
	['concurrentCalc', 'true'],
	['fullCalcOnLoad', 'false'],
	['fullPrecision', 'true'],
	['iterate', 'false'],
	['iterateCount', '100'],
	['iterateDelta', '0.001'],
	['refMode', 'A1']
];

/* 18.2.3 (CT_CustomWorkbookView) Defaults */
/*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/

function push_defaults_array(target, defaults) {
	for(var j = 0; j != target.length; ++j) { var w = target[j];
		for(var i=0; i != defaults.length; ++i) { var z = defaults[i];
			if(w[z[0]] == null) w[z[0]] = z[1];
			else switch(z[2]) {
			case "bool": if(typeof w[z[0]] == "string") w[z[0]] = parsexmlbool(w[z[0]]); break;
			case "int": if(typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10); break;
			}
		}
	}
}
function push_defaults(target, defaults) {
	for(var i = 0; i != defaults.length; ++i) { var z = defaults[i];
		if(target[z[0]] == null) target[z[0]] = z[1];
		else switch(z[2]) {
			case "bool": if(typeof target[z[0]] == "string") target[z[0]] = parsexmlbool(target[z[0]]); break;
			case "int": if(typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10); break;
		}
	}
}

function parse_wb_defaults(wb) {
	push_defaults(wb.WBProps, WBPropsDef);
	push_defaults(wb.CalcPr, CalcPrDef);

	push_defaults_array(wb.WBView, WBViewDef);
	push_defaults_array(wb.Sheets, SheetDef);

	_ssfopts.date1904 = parsexmlbool(wb.WBProps.date1904);
}

function safe1904(wb) {
	/* TODO: store date1904 somewhere else */
	if(!wb.Workbook) return "false";
	if(!wb.Workbook.WBProps) return "false";
	return parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
}

var badchars = "][*?\/\\".split("");
function check_ws_name(n, safe) {
	if(n.length > 31) { if(safe) return false; throw new Error("Sheet names cannot exceed 31 chars"); }
	var _good = true;
	badchars.forEach(function(c) {
		if(n.indexOf(c) == -1) return;
		if(!safe) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
		_good = false;
	});
	return _good;
}
function check_wb_names(N, S, codes) {
	N.forEach(function(n,i) {
		check_ws_name(n);
		for(var j = 0; j < i; ++j) if(n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
		if(codes) {
			var cn = (S && S[i] && S[i].CodeName) || n;
			if(cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
		}
	});
}
function check_wb(wb) {
	if(!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
	if(!wb.SheetNames.length) throw new Error("Workbook is empty");
	var Sheets = (wb.Workbook && wb.Workbook.Sheets) || [];
	check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
	for(var i = 0; i < wb.SheetNames.length; ++i) check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
	/* TODO: validate workbook */
}
/* 18.2 Workbook */
var wbnsregex = /<\w+:workbook/;
function parse_wb_xml(data, opts) {
	if(!data) throw new Error("Could not find file");
	var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, Names:[], xmlns: "" };
	var pass = false, xmlns = "xmlns";
	var dname = {}, dnstart = 0;
	data.replace(tagregex, function xml_wb(x, idx) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<?xml': break;

			/* 18.2.27 workbook CT_Workbook 1 */
			case '<workbook':
				if(x.match(wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
				wb.xmlns = y[xmlns];
				break;
			case '</workbook>': break;

			/* 18.2.13 fileVersion CT_FileVersion ? */
			case '<fileVersion': delete y[0]; wb.AppVersion = y; break;
			case '<fileVersion/>': case '</fileVersion>': break;

			/* 18.2.12 fileSharing CT_FileSharing ? */
			case '<fileSharing': case '<fileSharing/>': break;

			/* 18.2.28 workbookPr CT_WorkbookPr ? */
			case '<workbookPr':
			case '<workbookPr/>':
				WBPropsDef.forEach(function(w) {
					if(y[w[0]] == null) return;
					switch(w[2]) {
						case "bool": wb.WBProps[w[0]] = parsexmlbool(y[w[0]]); break;
						case "int": wb.WBProps[w[0]] = parseInt(y[w[0]], 10); break;
						default: wb.WBProps[w[0]] = y[w[0]];
					}
				});
				if(y.codeName) wb.WBProps.CodeName = y.codeName;
				break;
			case '</workbookPr>': break;

			/* 18.2.29 workbookProtection CT_WorkbookProtection ? */
			case '<workbookProtection': break;
			case '<workbookProtection/>': break;

			/* 18.2.1  bookViews CT_BookViews ? */
			case '<bookViews': case '<bookViews>': case '</bookViews>': break;
			/* 18.2.30   workbookView CT_BookView + */
			case '<workbookView': case '<workbookView/>': delete y[0]; wb.WBView.push(y); break;
			case '</workbookView>': break;

			/* 18.2.20 sheets CT_Sheets 1 */
			case '<sheets': case '<sheets>': case '</sheets>': break; // aggregate sheet
			/* 18.2.19   sheet CT_Sheet + */
			case '<sheet':
				switch(y.state) {
					case "hidden": y.Hidden = 1; break;
					case "veryHidden": y.Hidden = 2; break;
					default: y.Hidden = 0;
				}
				delete y.state;
				y.name = unescapexml(utf8read(y.name));
				delete y[0]; wb.Sheets.push(y); break;
			case '</sheet>': break;

			/* 18.2.15 functionGroups CT_FunctionGroups ? */
			case '<functionGroups': case '<functionGroups/>': break;
			/* 18.2.14   functionGroup CT_FunctionGroup + */
			case '<functionGroup': break;

			/* 18.2.9  externalReferences CT_ExternalReferences ? */
			case '<externalReferences': case '</externalReferences>': case '<externalReferences>': break;
			/* 18.2.8    externalReference CT_ExternalReference + */
			case '<externalReference': break;

			/* 18.2.6  definedNames CT_DefinedNames ? */
			case '<definedNames/>': break;
			case '<definedNames>': case '<definedNames': pass=true; break;
			case '</definedNames>': pass=false; break;
			/* 18.2.5    definedName CT_DefinedName + */
			case '<definedName': {
				dname = {};
				dname.Name = utf8read(y.name);
				if(y.comment) dname.Comment = y.comment;
				if(y.localSheetId) dname.Sheet = +y.localSheetId;
				if(parsexmlbool(y.hidden||"0")) dname.Hidden = true;
				dnstart = idx + x.length;
			}	break;
			case '</definedName>': {
				dname.Ref = unescapexml(utf8read(data.slice(dnstart, idx)));
				wb.Names.push(dname);
			} break;
			case '<definedName/>': break;

			/* 18.2.2  calcPr CT_CalcPr ? */
			case '<calcPr': delete y[0]; wb.CalcPr = y; break;
			case '<calcPr/>': delete y[0]; wb.CalcPr = y; break;
			case '</calcPr>': break;

			/* 18.2.16 oleSize CT_OleSize ? (ref required) */
			case '<oleSize': break;

			/* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */
			case '<customWorkbookViews>': case '</customWorkbookViews>': case '<customWorkbookViews': break;
			/* 18.2.3    customWorkbookView CT_CustomWorkbookView + */
			case '<customWorkbookView': case '</customWorkbookView>': break;

			/* 18.2.18 pivotCaches CT_PivotCaches ? */
			case '<pivotCaches>': case '</pivotCaches>': case '<pivotCaches': break;
			/* 18.2.17 pivotCache CT_PivotCache ? */
			case '<pivotCache': break;

			/* 18.2.21 smartTagPr CT_SmartTagPr ? */
			case '<smartTagPr': case '<smartTagPr/>': break;

			/* 18.2.23 smartTagTypes CT_SmartTagTypes ? */
			case '<smartTagTypes': case '<smartTagTypes>': case '</smartTagTypes>': break;
			/* 18.2.22   smartTagType CT_SmartTagType ? */
			case '<smartTagType': break;

			/* 18.2.24 webPublishing CT_WebPublishing ? */
			case '<webPublishing': case '<webPublishing/>': break;

			/* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */
			case '<fileRecoveryPr': case '<fileRecoveryPr/>': break;

			/* 18.2.26 webPublishObjects CT_WebPublishObjects ? */
			case '<webPublishObjects>': case '<webPublishObjects': case '</webPublishObjects>': break;
			/* 18.2.25 webPublishObject CT_WebPublishObject ? */
			case '<webPublishObject': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
			/* 18.2.7    ext CT_Extension + */
			case '<ext': pass=true; break; //TODO: check with versions of excel
			case '</ext>': pass=false; break;

			/* Others */
			case '<ArchID': break;
			case '<AlternateContent':
			case '<AlternateContent>': pass=true; break;
			case '</AlternateContent>': pass=false; break;

			/* TODO */
			case '<revisionPtr': break;

			default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
		}
		return x;
	});
	if(XMLNS.main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);

	parse_wb_defaults(wb);

	return wb;
}

var WB_XML_ROOT = writextag('workbook', null, {
	'xmlns': XMLNS.main[0],
	//'xmlns:mx': XMLNS.mx,
	//'xmlns:s': XMLNS.main[0],
	'xmlns:r': XMLNS.r
});

function write_wb_xml(wb) {
	var o = [XML_HEADER];
	o[o.length] = WB_XML_ROOT;

	var write_names = (wb.Workbook && (wb.Workbook.Names||[]).length > 0);

	/* fileVersion */
	/* fileSharing */

	var workbookPr = ({codeName:"ThisWorkbook"});
	if(wb.Workbook && wb.Workbook.WBProps) {
		WBPropsDef.forEach(function(x) {
if((wb.Workbook.WBProps[x[0]]) == null) return;
			if((wb.Workbook.WBProps[x[0]]) == x[1]) return;
			workbookPr[x[0]] = (wb.Workbook.WBProps[x[0]]);
		});
if(wb.Workbook.WBProps.CodeName) { workbookPr.codeName = wb.Workbook.WBProps.CodeName; delete workbookPr.CodeName; }
	}
	o[o.length] = (writextag('workbookPr', null, workbookPr));

	/* workbookProtection */

	var sheets = wb.Workbook && wb.Workbook.Sheets || [];
	var i = 0;

	/* bookViews */

	o[o.length] = "<sheets>";
	for(i = 0; i != wb.SheetNames.length; ++i) {
		var sht = ({name:escapexml(wb.SheetNames[i].slice(0,31))});
		sht.sheetId = ""+(i+1);
		sht["r:id"] = "rId"+(i+1);
		if(sheets[i]) switch(sheets[i].Hidden) {
			case 1: sht.state = "hidden"; break;
			case 2: sht.state = "veryHidden"; break;
		}
		o[o.length] = (writextag('sheet',null,sht));
	}
	o[o.length] = "</sheets>";

	/* functionGroups */
	/* externalReferences */

	if(write_names) {
		o[o.length] = "<definedNames>";
		if(wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
			var d = {name:n.Name};
			if(n.Comment) d.comment = n.Comment;
			if(n.Sheet != null) d.localSheetId = ""+n.Sheet;
			if(n.Hidden) d.hidden = "1";
			if(!n.Ref) return;
			o[o.length] = writextag('definedName', String(n.Ref).replace(/</g, "&lt;").replace(/>/g, "&gt;"), d);
		});
		o[o.length] = "</definedNames>";
	}

	/* calcPr */
	/* oleSize */
	/* customWorkbookViews */
	/* pivotCaches */
	/* smartTagPr */
	/* smartTagTypes */
	/* webPublishing */
	/* fileRecoveryPr */
	/* webPublishObjects */
	/* extLst */

	if(o.length>2){ o[o.length] = '</workbook>'; o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.304 BrtBundleSh */
function parse_BrtBundleSh(data, length) {
	var z = {};
	z.Hidden = data.read_shift(4); //hsState ST_SheetState
	z.iTabID = data.read_shift(4);
	z.strRelID = parse_RelID(data,length-8);
	z.name = parse_XLWideString(data);
	return z;
}
function write_BrtBundleSh(data, o) {
	if(!o) o = new_buf(127);
	o.write_shift(4, data.Hidden);
	o.write_shift(4, data.iTabID);
	write_RelID(data.strRelID, o);
	write_XLWideString(data.name.slice(0,31), o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.815 BrtWbProp */
function parse_BrtWbProp(data, length) {
	var o = ({});
	var flags = data.read_shift(4);
	o.defaultThemeVersion = data.read_shift(4);
	var strName = (length > 8) ? parse_XLWideString(data) : "";
	if(strName.length > 0) o.CodeName = strName;
	o.autoCompressPictures = !!(flags & 0x10000);
	o.backupFile = !!(flags & 0x40);
	o.checkCompatibility = !!(flags & 0x1000);
	o.date1904 = !!(flags & 0x01);
	o.filterPrivacy = !!(flags & 0x08);
	o.hidePivotFieldList = !!(flags & 0x400);
	o.promptedSolutions = !!(flags & 0x10);
	o.publishItems = !!(flags & 0x800);
	o.refreshAllConnections = !!(flags & 0x40000);
	o.saveExternalLinkValues = !!(flags & 0x80);
	o.showBorderUnselectedTables = !!(flags & 0x04);
	o.showInkAnnotation = !!(flags & 0x20);
	o.showObjects = ["all", "placeholders", "none"][(flags >> 13) & 0x03];
	o.showPivotChartFilter = !!(flags & 0x8000);
	o.updateLinks = ["userSet", "never", "always"][(flags >> 8) & 0x03];
	return o;
}
function write_BrtWbProp(data, o) {
	if(!o) o = new_buf(72);
	var flags = 0;
	if(data) {
		/* TODO: mirror parse_BrtWbProp fields */
		if(data.filterPrivacy) flags |= 0x08;
	}
	o.write_shift(4, flags);
	o.write_shift(4, 0);
	write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
	return o.slice(0, o.l);
}

function parse_BrtFRTArchID$(data, length) {
	var o = {};
	data.read_shift(4);
	o.ArchID = data.read_shift(4);
	data.l += length - 8;
	return o;
}

/* [MS-XLSB] 2.4.687 BrtName */
function parse_BrtName(data, length, opts) {
	var end = data.l + length;
	data.l += 4; //var flags = data.read_shift(4);
	data.l += 1; //var chKey = data.read_shift(1);
	var itab = data.read_shift(4);
	var name = parse_XLNameWideString(data);
	var formula = parse_XLSBNameParsedFormula(data, 0, opts);
	var comment = parse_XLNullableWideString(data);
	//if(0 /* fProc */) {
		// unusedstring1: XLNullableWideString
		// description: XLNullableWideString
		// helpTopic: XLNullableWideString
		// unusedstring2: XLNullableWideString
	//}
	data.l = end;
	var out = ({Name:name, Ptg:formula});
	if(itab < 0xFFFFFFF) out.Sheet = itab;
	if(comment) out.Comment = comment;
	return out;
}

/* [MS-XLSB] 2.1.7.61 Workbook */
function parse_wb_bin(data, opts) {
	var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, xmlns: "" };
	var state = [];
	var pass = false;

	if(!opts) opts = {};
	opts.biff = 12;

	var Names = [];
	var supbooks = ([[]]);
	supbooks.SheetNames = [];
	supbooks.XTI = [];

	recordhopper(data, function hopper_wb(val, R_n, RT) {
		switch(RT) {
			case 0x009C: /* 'BrtBundleSh' */
				supbooks.SheetNames.push(val.name);
				wb.Sheets.push(val); break;

			case 0x0099: /* 'BrtWbProp' */
				wb.WBProps = val; break;

			case 0x0027: /* 'BrtName' */
				if(val.Sheet != null) opts.SID = val.Sheet;
				val.Ref = stringify_formula(val.Ptg, null, null, supbooks, opts);
				delete opts.SID;
				delete val.Ptg;
				Names.push(val);
				break;
			case 0x040C: /* 'BrtNameExt' */ break;

			case 0x0165: /* 'BrtSupSelf' */
			case 0x0166: /* 'BrtSupSame' */
			case 0x0163: /* 'BrtSupBookSrc' */
			case 0x029B: /* 'BrtSupAddin' */
				if(!supbooks[0].length) supbooks[0] = [RT, val];
				else supbooks.push([RT, val]);
				supbooks[supbooks.length - 1].XTI = [];
				break;
			case 0x016A: /* 'BrtExternSheet' */
				if(supbooks.length === 0) { supbooks[0] = []; supbooks[0].XTI = []; }
				supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
				supbooks.XTI = supbooks.XTI.concat(val);
				break;
			case 0x0169: /* 'BrtPlaceholderName' */
				break;

			/* case 'BrtModelTimeGroupingCalcCol' */
			case 0x0C00: /* 'BrtUid' */
			case 0x0C01: /* 'BrtRevisionPtr' */
			case 0x0817: /* 'BrtAbsPath15' */
			case 0x0216: /* 'BrtBookProtection' */
			case 0x02A5: /* 'BrtBookProtectionIso' */
			case 0x009E: /* 'BrtBookView' */
			case 0x009D: /* 'BrtCalcProp' */
			case 0x0262: /* 'BrtCrashRecErr' */
			case 0x0802: /* 'BrtDecoupledPivotCacheID' */
			case 0x009B: /* 'BrtFileRecover' */
			case 0x0224: /* 'BrtFileSharing' */
			case 0x02A4: /* 'BrtFileSharingIso' */
			case 0x0080: /* 'BrtFileVersion' */
			case 0x0299: /* 'BrtFnGroup' */
			case 0x0850: /* 'BrtModelRelationship' */
			case 0x084D: /* 'BrtModelTable' */
			case 0x0225: /* 'BrtOleSize' */
			case 0x0805: /* 'BrtPivotTableRef' */
			case 0x0254: /* 'BrtSmartTagType' */
			case 0x081C: /* 'BrtTableSlicerCacheID' */
			case 0x081B: /* 'BrtTableSlicerCacheIDs' */
			case 0x0822: /* 'BrtTimelineCachePivotCacheID' */
			case 0x018D: /* 'BrtUserBookView' */
			case 0x009A: /* 'BrtWbFactoid' */
			case 0x045D: /* 'BrtWbProp14' */
			case 0x0229: /* 'BrtWebOpt' */
			case 0x082B: /* 'BrtWorkBookPr15' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				state.push(R_n); pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				state.pop(); pass = false; break;
			case 0x0025: /* 'BrtACBegin' */
				state.push(R_n); pass = true; break;
			case 0x0026: /* 'BrtACEnd' */
				state.pop(); pass = false; break;

			case 0x0010: /* 'BrtFRTArchID$' */ break;

			default:
				if((R_n||"").indexOf("Begin") > 0){/* empty */}
				else if((R_n||"").indexOf("End") > 0){/* empty */}
				else if(!pass || (opts.WTF && state[state.length-1] != "BrtACBegin" && state[state.length-1] != "BrtFRTBegin")) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	}, opts);

	parse_wb_defaults(wb);

	// $FlowIgnore
	wb.Names = Names;

	(wb).supbooks = supbooks;
	return wb;
}

function write_BUNDLESHS(ba, wb) {
	write_record(ba, "BrtBeginBundleShs");
	for(var idx = 0; idx != wb.SheetNames.length; ++idx) {
		var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
		var d = { Hidden: viz, iTabID: idx+1, strRelID: 'rId' + (idx+1), name: wb.SheetNames[idx] };
		write_record(ba, "BrtBundleSh", write_BrtBundleSh(d));
	}
	write_record(ba, "BrtEndBundleShs");
}

/* [MS-XLSB] 2.4.649 BrtFileVersion */
function write_BrtFileVersion(data, o) {
	if(!o) o = new_buf(127);
	for(var i = 0; i != 4; ++i) o.write_shift(4, 0);
	write_XLWideString("SheetJS", o);
	write_XLWideString(XLSX.version, o);
	write_XLWideString(XLSX.version, o);
	write_XLWideString("7262", o);
	o.length = o.l;
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.301 BrtBookView */
function write_BrtBookView(idx, o) {
	if(!o) o = new_buf(29);
	o.write_shift(-4, 0);
	o.write_shift(-4, 460);
	o.write_shift(4,  28800);
	o.write_shift(4,  17600);
	o.write_shift(4,  500);
	o.write_shift(4,  idx);
	o.write_shift(4,  idx);
	var flags = 0x78;
	o.write_shift(1,  flags);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

function write_BOOKVIEWS(ba, wb) {
	/* required if hidden tab appears before visible tab */
	if(!wb.Workbook || !wb.Workbook.Sheets) return;
	var sheets = wb.Workbook.Sheets;
	var i = 0, vistab = -1, hidden = -1;
	for(; i < sheets.length; ++i) {
		if(!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
		else if(sheets[i].Hidden == 1 && hidden == -1) hidden = i;
	}
	if(hidden > vistab) return;
	write_record(ba, "BrtBeginBookViews");
	write_record(ba, "BrtBookView", write_BrtBookView(vistab));
	/* 1*(BrtBookView *FRT) */
	write_record(ba, "BrtEndBookViews");
}

/* [MS-XLSB] 2.4.305 BrtCalcProp */
/*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/

/* [MS-XLSB] 2.4.646 BrtFileRecover */
/*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/

/* [MS-XLSB] 2.1.7.61 Workbook */
function write_wb_bin(wb, opts) {
	var ba = buf_array();
	write_record(ba, "BrtBeginBook");
	write_record(ba, "BrtFileVersion", write_BrtFileVersion());
	/* [[BrtFileSharingIso] BrtFileSharing] */
	write_record(ba, "BrtWbProp", write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
	/* [ACABSPATH] */
	/* [[BrtBookProtectionIso] BrtBookProtection] */
	write_BOOKVIEWS(ba, wb, opts);
	write_BUNDLESHS(ba, wb, opts);
	/* [FNGROUP] */
	/* [EXTERNALS] */
	/* *BrtName */
	/* write_record(ba, "BrtCalcProp", write_BrtCalcProp()); */
	/* [BrtOleSize] */
	/* *(BrtUserBookView *FRT) */
	/* [PIVOTCACHEIDS] */
	/* [BrtWbFactoid] */
	/* [SMARTTAGTYPES] */
	/* [BrtWebOpt] */
	/* write_record(ba, "BrtFileRecover", write_BrtFileRecover()); */
	/* [WEBPUBITEMS] */
	/* [CRERRS] */
	/* FRTWORKBOOK */
	write_record(ba, "BrtEndBook");

	return ba.end();
}
function parse_wb(data, name, opts) {
	if(name.slice(-4)===".bin") return parse_wb_bin((data), opts);
	return parse_wb_xml((data), opts);
}

function parse_ws(data, name, idx, opts, rels, wb, themes, styles) {
	if(name.slice(-4)===".bin") return parse_ws_bin((data), opts, idx, rels, wb, themes, styles);
	return parse_ws_xml((data), opts, idx, rels, wb, themes, styles);
}

function parse_cs(data, name, idx, opts, rels, wb, themes, styles) {
	if(name.slice(-4)===".bin") return parse_cs_bin((data), opts, idx, rels, wb, themes, styles);
	return parse_cs_xml((data), opts, idx, rels, wb, themes, styles);
}

function parse_ms(data, name, idx, opts, rels, wb, themes, styles) {
	if(name.slice(-4)===".bin") return parse_ms_bin((data), opts, idx, rels, wb, themes, styles);
	return parse_ms_xml((data), opts, idx, rels, wb, themes, styles);
}

function parse_ds(data, name, idx, opts, rels, wb, themes, styles) {
	if(name.slice(-4)===".bin") return parse_ds_bin((data), opts, idx, rels, wb, themes, styles);
	return parse_ds_xml((data), opts, idx, rels, wb, themes, styles);
}

function parse_sty(data, name, themes, opts) {
	if(name.slice(-4)===".bin") return parse_sty_bin((data), themes, opts);
	return parse_sty_xml((data), themes, opts);
}

function parse_theme(data, name, opts) {
	return parse_theme_xml(data, opts);
}

function parse_sst(data, name, opts) {
	if(name.slice(-4)===".bin") return parse_sst_bin((data), opts);
	return parse_sst_xml((data), opts);
}

function parse_cmnt(data, name, opts) {
	if(name.slice(-4)===".bin") return parse_comments_bin((data), opts);
	return parse_comments_xml((data), opts);
}

function parse_cc(data, name, opts) {
	if(name.slice(-4)===".bin") return parse_cc_bin((data), name, opts);
	return parse_cc_xml((data), name, opts);
}

function parse_xlink(data, name, opts) {
	if(name.slice(-4)===".bin") return parse_xlink_bin((data), name, opts);
	return parse_xlink_xml((data), name, opts);
}

function write_wb(wb, name, opts) {
	return (name.slice(-4)===".bin" ? write_wb_bin : write_wb_xml)(wb, opts);
}

function write_ws(data, name, opts, wb, rels) {
	return (name.slice(-4)===".bin" ? write_ws_bin : write_ws_xml)(data, opts, wb, rels);
}

// eslint-disable-next-line no-unused-vars
function write_cs(data, name, opts, wb, rels) {
	return (name.slice(-4)===".bin" ? write_cs_bin : write_cs_xml)(data, opts, wb, rels);
}

function write_sty(data, name, opts) {
	return (name.slice(-4)===".bin" ? write_sty_bin : write_sty_xml)(data, opts);
}

function write_sst(data, name, opts) {
	return (name.slice(-4)===".bin" ? write_sst_bin : write_sst_xml)(data, opts);
}

function write_cmnt(data, name, opts) {
	return (name.slice(-4)===".bin" ? write_comments_bin : write_comments_xml)(data, opts);
}
/*
function write_cc(data, name:string, opts) {
	return (name.slice(-4)===".bin" ? write_cc_bin : write_cc_xml)(data, opts);
}
*/
var attregexg2=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
var attregex2=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
var _chr = function(c) { return String.fromCharCode(c); };
function xlml_parsexmltag(tag, skip_root) {
	var words = tag.split(/\s+/);
	var z = ([]); if(!skip_root) z[0] = words[0];
	if(words.length === 1) return z;
	var m = tag.match(attregexg2), y, j, w, i;
	if(m) for(i = 0; i != m.length; ++i) {
		y = m[i].match(attregex2);
if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
		else {
			if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
			else w = y[1].slice(j+1);
			z[w] = y[2].slice(1,y[2].length-1);
		}
	}
	return z;
}
function xlml_parsexmltagobj(tag) {
	var words = tag.split(/\s+/);
	var z = {};
	if(words.length === 1) return z;
	var m = tag.match(attregexg2), y, j, w, i;
	if(m) for(i = 0; i != m.length; ++i) {
		y = m[i].match(attregex2);
if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
		else {
			if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
			else w = y[1].slice(j+1);
			z[w] = y[2].slice(1,y[2].length-1);
		}
	}
	return z;
}

// ----

function xlml_format(format, value) {
	var fmt = XLMLFormatMap[format] || unescapexml(format);
	if(fmt === "General") return SSF._general(value);
	return SSF.format(fmt, value);
}

function xlml_set_custprop(Custprops, key, cp, val) {
	var oval = val;
	switch((cp[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]) {
		case "boolean": oval = parsexmlbool(val); break;
		case "i2": case "int": oval = parseInt(val, 10); break;
		case "r4": case "float": oval = parseFloat(val); break;
		case "date": case "dateTime.tz": oval = parseDate(val); break;
		case "i8": case "string": case "fixed": case "uuid": case "bin.base64": break;
		default: throw new Error("bad custprop:" + cp[0]);
	}
	Custprops[unescapexml(key)] = oval;
}

function safe_format_xlml(cell, nf, o) {
	if(cell.t === 'z') return;
	if(!o || o.cellText !== false) try {
		if(cell.t === 'e') { cell.w = cell.w || BErr[cell.v]; }
		else if(nf === "General") {
			if(cell.t === 'n') {
				if((cell.v|0) === cell.v) cell.w = SSF._general_int(cell.v);
				else cell.w = SSF._general_num(cell.v);
			}
			else cell.w = SSF._general(cell.v);
		}
		else cell.w = xlml_format(nf||"General", cell.v);
	} catch(e) { if(o.WTF) throw e; }
	try {
		var z = XLMLFormatMap[nf]||nf||"General";
		if(o.cellNF) cell.z = z;
		if(o.cellDates && cell.t == 'n' && SSF.is_date(z)) {
			var _d = SSF.parse_date_code(cell.v); if(_d) { cell.t = 'd'; cell.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
		}
	} catch(e) { if(o.WTF) throw e; }
}

function process_style_xlml(styles, stag, opts) {
	if(opts.cellStyles) {
		if(stag.Interior) {
			var I = stag.Interior;
			if(I.Pattern) I.patternType = XLMLPatternTypeMap[I.Pattern] || I.Pattern;
		}
	}
	styles[stag.ID] = stag;
}

/* TODO: there must exist some form of OSP-blessed spec */
function parse_xlml_data(xml, ss, data, cell, base, styles, csty, row, arrayf, o) {
	var nf = "General", sid = cell.StyleID, S = {}; o = o || {};
	var interiors = [];
	var i = 0;
	if(sid === undefined && row) sid = row.StyleID;
	if(sid === undefined && csty) sid = csty.StyleID;
	while(styles[sid] !== undefined) {
		if(styles[sid].nf) nf = styles[sid].nf;
		if(styles[sid].Interior) interiors.push(styles[sid].Interior);
		if(!styles[sid].Parent) break;
		sid = styles[sid].Parent;
	}
	switch(data.Type) {
		case 'Boolean':
			cell.t = 'b';
			cell.v = parsexmlbool(xml);
			break;
		case 'String':
			cell.t = 's'; cell.r = xlml_fixstr(unescapexml(xml));
			cell.v = xml.indexOf("<") > -1 ? unescapexml(ss) : cell.r;
			break;
		case 'DateTime':
			if(xml.slice(-1) != "Z") xml += "Z";
			cell.v = (parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
			if(cell.v !== cell.v) cell.v = unescapexml(xml);
			else if(cell.v<60) cell.v = cell.v -1;
			if(!nf || nf == "General") nf = "yyyy-mm-dd";
			/* falls through */
		case 'Number':
			if(cell.v === undefined) cell.v=+xml;
			if(!cell.t) cell.t = 'n';
			break;
		case 'Error': cell.t = 'e'; cell.v = RBErr[xml]; if(o.cellText !== false) cell.w = xml; break;
		default: cell.t = 's'; cell.v = xlml_fixstr(ss||xml); break;
	}
	safe_format_xlml(cell, nf, o);
	if(o.cellFormula !== false) {
		if(cell.Formula) {
			var fstr = unescapexml(cell.Formula);
			/* strictly speaking, the leading = is required but some writers omit */
			if(fstr.charCodeAt(0) == 61 /* = */) fstr = fstr.slice(1);
			cell.f = rc_to_a1(fstr, base);
			delete cell.Formula;
			if(cell.ArrayRange == "RC") cell.F = rc_to_a1("RC:RC", base);
			else if(cell.ArrayRange) {
				cell.F = rc_to_a1(cell.ArrayRange, base);
				arrayf.push([safe_decode_range(cell.F), cell.F]);
			}
		} else {
			for(i = 0; i < arrayf.length; ++i)
				if(base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r)
					if(base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c)
						cell.F = arrayf[i][1];
		}
	}
	if(o.cellStyles) {
		interiors.forEach(function(x) {
			if(!S.patternType && x.patternType) S.patternType = x.patternType;
		});
		cell.s = S;
	}
	if(cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
}

function xlml_clean_comment(comment) {
	comment.t = comment.v || "";
	comment.t = comment.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");
	comment.v = comment.w = comment.ixfe = undefined;
}

function xlml_normalize(d) {
	if(has_buf && Buffer.isBuffer(d)) return d.toString('utf8');
	if(typeof d === 'string') return d;
	/* duktape */
	if(typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return utf8read(a2s(ab2a(d)));
	throw new Error("Bad input format: expected Buffer or string");
}

/* TODO: Everything */
/* UOS uses CJK in tags */
var xlmlregex = /<(\/?)([^\s?>!\/:]*:|)([^\s?>:\/]+)[^>]*>/mg;
//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
function parse_xlml_xml(d, _opts) {
	var opts = _opts || {};
	make_ssf(SSF);
	var str = debom(xlml_normalize(d));
	if(opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
		if(typeof cptable !== 'undefined') str = cptable.utils.decode(65001, char_codes(str));
		else str = utf8read(str);
	}
	var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
	if(opening.indexOf("<?xml") == -1) ["html", "table", "head", "meta", "script", "style", "div"].forEach(function(tag) { if(opening.indexOf("<" + tag) >= 0) ishtml = true; });
	if(ishtml) return HTML_.to_workbook(str, opts);
	var Rn;
	var state = [], tmp;
	if(DENSE != null && opts.dense == null) opts.dense = DENSE;
	var sheets = {}, sheetnames = [], cursheet = (opts.dense ? [] : {}), sheetname = "";
	var table = {}, cell = ({}), row = {};// eslint-disable-line no-unused-vars
	var dtag = xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
	var c = 0, r = 0;
	var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
	var styles = {}, stag = {};
	var ss = "", fidx = 0;
	var merges = [];
	var Props = {}, Custprops = {}, pidx = 0, cp = [];
	var comments = [], comment = ({});
	var cstys = [], csty, seencol = false;
	var arrayf = [];
	var rowinfo = [], rowobj = {}, cc = 0, rr = 0;
	var Workbook = ({ Sheets:[], WBProps:{date1904:false} }), wsprops = {};
	xlmlregex.lastIndex = 0;
	str = str.replace(/<!--([\s\S]*?)-->/mg,"");
	while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
		case 'Data':
			if(state[state.length-1][1]) break;
			if(Rn[1]==='/') parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length-1][0]=="Comment"?comment:cell, {c:c,r:r}, styles, cstys[c], row, arrayf, opts);
			else { ss = ""; dtag = xlml_parsexmltag(Rn[0]); didx = Rn.index + Rn[0].length; }
			break;
		case 'Cell':
			if(Rn[1]==='/'){
				if(comments.length > 0) cell.c = comments;
				if((!opts.sheetRows || opts.sheetRows > r) && cell.v !== undefined) {
					if(opts.dense) {
						if(!cursheet[r]) cursheet[r] = [];
						cursheet[r][c] = cell;
					} else cursheet[encode_col(c) + encode_row(r)] = cell;
				}
				if(cell.HRef) {
					cell.l = ({Target:cell.HRef});
					if(cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
					delete cell.HRef; delete cell.HRefScreenTip;
				}
				if(cell.MergeAcross || cell.MergeDown) {
					cc = c + (parseInt(cell.MergeAcross,10)|0);
					rr = r + (parseInt(cell.MergeDown,10)|0);
					merges.push({s:{c:c,r:r},e:{c:cc,r:rr}});
				}
				if(!opts.sheetStubs) { if(cell.MergeAcross) c = cc + 1; else ++c; }
				else if(cell.MergeAcross || cell.MergeDown) {
for(var cma = c; cma <= cc; ++cma) {
						for(var cmd = r; cmd <= rr; ++cmd) {
							if(cma > c || cmd > r) {
								if(opts.dense) {
									if(!cursheet[cmd]) cursheet[cmd] = [];
									cursheet[cmd][cma] = {t:'z'};
								} else cursheet[encode_col(cma) + encode_row(cmd)] = {t:'z'};
							}
						}
					}
					c = cc + 1;
				}
				else ++c;
			} else {
				cell = xlml_parsexmltagobj(Rn[0]);
				if(cell.Index) c = +cell.Index - 1;
				if(c < refguess.s.c) refguess.s.c = c;
				if(c > refguess.e.c) refguess.e.c = c;
				if(Rn[0].slice(-2) === "/>") ++c;
				comments = [];
			}
			break;
		case 'Row':
			if(Rn[1]==='/' || Rn[0].slice(-2) === "/>") {
				if(r < refguess.s.r) refguess.s.r = r;
				if(r > refguess.e.r) refguess.e.r = r;
				if(Rn[0].slice(-2) === "/>") {
					row = xlml_parsexmltag(Rn[0]);
					if(row.Index) r = +row.Index - 1;
				}
				c = 0; ++r;
			} else {
				row = xlml_parsexmltag(Rn[0]);
				if(row.Index) r = +row.Index - 1;
				rowobj = {};
				if(row.AutoFitHeight == "0" || row.Height) {
					rowobj.hpx = parseInt(row.Height, 10); rowobj.hpt = px2pt(rowobj.hpx);
					rowinfo[r] = rowobj;
				}
				if(row.Hidden == "1") { rowobj.hidden = true; rowinfo[r] = rowobj; }
			}
			break;
		case 'Worksheet': /* TODO: read range from FullRows/FullColumns */
			if(Rn[1]==='/'){
				if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
				sheetnames.push(sheetname);
				if(refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
					cursheet["!ref"] = encode_range(refguess);
					if(opts.sheetRows && opts.sheetRows <= refguess.e.r) {
						cursheet["!fullref"] = cursheet["!ref"];
						refguess.e.r = opts.sheetRows - 1;
						cursheet["!ref"] = encode_range(refguess);
					}
				}
				if(merges.length) cursheet["!merges"] = merges;
				if(cstys.length > 0) cursheet["!cols"] = cstys;
				if(rowinfo.length > 0) cursheet["!rows"] = rowinfo;
				sheets[sheetname] = cursheet;
			} else {
				refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
				r = c = 0;
				state.push([Rn[3], false]);
				tmp = xlml_parsexmltag(Rn[0]);
				sheetname = unescapexml(tmp.Name);
				cursheet = (opts.dense ? [] : {});
				merges = [];
				arrayf = [];
				rowinfo = [];
				wsprops = {name:sheetname, Hidden:0};
				Workbook.Sheets.push(wsprops);
			}
			break;
		case 'Table':
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else if(Rn[0].slice(-2) == "/>") break;
			else {
				table = xlml_parsexmltag(Rn[0]);
				state.push([Rn[3], false]);
				cstys = []; seencol = false;
			}
			break;

		case 'Style':
			if(Rn[1]==='/') process_style_xlml(styles, stag, opts);
			else stag = xlml_parsexmltag(Rn[0]);
			break;

		case 'NumberFormat':
			stag.nf = unescapexml(xlml_parsexmltag(Rn[0]).Format || "General");
			if(XLMLFormatMap[stag.nf]) stag.nf = XLMLFormatMap[stag.nf];
			for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx) if(SSF._table[ssfidx] == stag.nf) break;
			if(ssfidx == 0x188) for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx) if(SSF._table[ssfidx] == null) { SSF.load(stag.nf, ssfidx); break; }
			break;

		case 'Column':
			if(state[state.length-1][0] !== 'Table') break;
			csty = xlml_parsexmltag(Rn[0]);
			if(csty.Hidden) { csty.hidden = true; delete csty.Hidden; }
			if(csty.Width) csty.wpx = parseInt(csty.Width, 10);
			if(!seencol && csty.wpx > 10) {
				seencol = true; MDW = DEF_MDW; //find_mdw_wpx(csty.wpx);
				for(var _col = 0; _col < cstys.length; ++_col) if(cstys[_col]) process_col(cstys[_col]);
			}
			if(seencol) process_col(csty);
			cstys[(csty.Index-1||cstys.length)] = csty;
			for(var i = 0; i < +csty.Span; ++i) cstys[cstys.length] = dup(csty);
			break;

		case 'NamedRange':
			if(!Workbook.Names) Workbook.Names = [];
			var _NamedRange = parsexmltag(Rn[0]);
			var _DefinedName = ({
				Name: _NamedRange.Name,
				Ref: rc_to_a1(_NamedRange.RefersTo.slice(1), {r:0, c:0})
			});
			if(Workbook.Sheets.length>0) _DefinedName.Sheet=Workbook.Sheets.length-1;
Workbook.Names.push(_DefinedName);
			break;

		case 'NamedCell': break;
		case 'B': break;
		case 'I': break;
		case 'U': break;
		case 'S': break;
		case 'Sub': break;
		case 'Sup': break;
		case 'Span': break;
		case 'Border': break;
		case 'Alignment': break;
		case 'Borders': break;
		case 'Font':
			if(Rn[0].slice(-2) === "/>") break;
			else if(Rn[1]==="/") ss += str.slice(fidx, Rn.index);
			else fidx = Rn.index + Rn[0].length;
			break;
		case 'Interior':
			if(!opts.cellStyles) break;
			stag.Interior = xlml_parsexmltag(Rn[0]);
			break;
		case 'Protection': break;

		case 'Author':
		case 'Title':
		case 'Description':
		case 'Created':
		case 'Keywords':
		case 'Subject':
		case 'Category':
		case 'Company':
		case 'LastAuthor':
		case 'LastSaved':
		case 'LastPrinted':
		case 'Version':
		case 'Revision':
		case 'TotalTime':
		case 'HyperlinkBase':
		case 'Manager':
		case 'ContentStatus':
		case 'Identifier':
		case 'Language':
		case 'AppName':
			if(Rn[0].slice(-2) === "/>") break;
			else if(Rn[1]==="/") xlml_set_prop(Props, Rn[3], str.slice(pidx, Rn.index));
			else pidx = Rn.index + Rn[0].length;
			break;
		case 'Paragraphs': break;

		case 'Styles':
		case 'Workbook':
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else state.push([Rn[3], false]);
			break;

		case 'Comment':
			if(Rn[1]==='/'){
				if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
				xlml_clean_comment(comment);
				comments.push(comment);
			} else {
				state.push([Rn[3], false]);
				tmp = xlml_parsexmltag(Rn[0]);
				comment = ({a:tmp.Author});
			}
			break;

		case 'AutoFilter':
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
				var AutoFilter = xlml_parsexmltag(Rn[0]);
				cursheet['!autofilter'] = { ref:rc_to_a1(AutoFilter.Range).replace(/\$/g,"") };
				state.push([Rn[3], true]);
			}
			break;

		case 'Name': break;

		case 'ComponentOptions':
		case 'DocumentProperties':
		case 'CustomDocumentProperties':
		case 'OfficeDocumentSettings':
		case 'PivotTable':
		case 'PivotCache':
		case 'Names':
		case 'MapInfo':
		case 'PageBreaks':
		case 'QueryTable':
		case 'DataValidation':
		case 'Sorting':
		case 'Schema':
		case 'data':
		case 'ConditionalFormatting':
		case 'SmartTagType':
		case 'SmartTags':
		case 'ExcelWorkbook':
		case 'WorkbookOptions':
		case 'WorksheetOptions':
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
			break;

		default:
			/* FODS file root is <office:document> */
			if(state.length == 0 && Rn[3] == "document") return parse_fods(str, opts);
			/* UOS file root is <uof:UOF> */
			if(state.length == 0 && Rn[3] == "UOF") return parse_fods(str, opts);

			var seen = true;
			switch(state[state.length-1][0]) {
				/* OfficeDocumentSettings */
				case 'OfficeDocumentSettings': switch(Rn[3]) {
					case 'AllowPNG': break;
					case 'RemovePersonalInformation': break;
					case 'DownloadComponents': break;
					case 'LocationOfComponents': break;
					case 'Colors': break;
					case 'Color': break;
					case 'Index': break;
					case 'RGB': break;
					case 'PixelsPerInch': break; // TODO: set PPI
					case 'TargetScreenSize': break;
					case 'ReadOnlyRecommended': break;
					default: seen = false;
				} break;

				/* ComponentOptions */
				case 'ComponentOptions': switch(Rn[3]) {
					case 'Toolbar': break;
					case 'HideOfficeLogo': break;
					case 'SpreadsheetAutoFit': break;
					case 'Label': break;
					case 'Caption': break;
					case 'MaxHeight': break;
					case 'MaxWidth': break;
					case 'NextSheetNumber': break;
					default: seen = false;
				} break;

				/* ExcelWorkbook */
				case 'ExcelWorkbook': switch(Rn[3]) {
					case 'Date1904':
Workbook.WBProps.date1904 = true;
						break;
					case 'WindowHeight': break;
					case 'WindowWidth': break;
					case 'WindowTopX': break;
					case 'WindowTopY': break;
					case 'TabRatio': break;
					case 'ProtectStructure': break;
					case 'ProtectWindows': break;
					case 'ActiveSheet': break;
					case 'DisplayInkNotes': break;
					case 'FirstVisibleSheet': break;
					case 'SupBook': break;
					case 'SheetName': break;
					case 'SheetIndex': break;
					case 'SheetIndexFirst': break;
					case 'SheetIndexLast': break;
					case 'Dll': break;
					case 'AcceptLabelsInFormulas': break;
					case 'DoNotSaveLinkValues': break;
					case 'Iteration': break;
					case 'MaxIterations': break;
					case 'MaxChange': break;
					case 'Path': break;
					case 'Xct': break;
					case 'Count': break;
					case 'SelectedSheets': break;
					case 'Calculation': break;
					case 'Uncalced': break;
					case 'StartupPrompt': break;
					case 'Crn': break;
					case 'ExternName': break;
					case 'Formula': break;
					case 'ColFirst': break;
					case 'ColLast': break;
					case 'WantAdvise': break;
					case 'Boolean': break;
					case 'Error': break;
					case 'Text': break;
					case 'OLE': break;
					case 'NoAutoRecover': break;
					case 'PublishObjects': break;
					case 'DoNotCalculateBeforeSave': break;
					case 'Number': break;
					case 'RefModeR1C1': break;
					case 'EmbedSaveSmartTags': break;
					default: seen = false;
				} break;

				/* WorkbookOptions */
				case 'WorkbookOptions': switch(Rn[3]) {
					case 'OWCVersion': break;
					case 'Height': break;
					case 'Width': break;
					default: seen = false;
				} break;

				/* WorksheetOptions */
				case 'WorksheetOptions': switch(Rn[3]) {
					case 'Visible':
						if(Rn[0].slice(-2) === "/>"){/* empty */}
						else if(Rn[1]==="/") switch(str.slice(pidx, Rn.index)) {
							case "SheetHidden": wsprops.Hidden = 1; break;
							case "SheetVeryHidden": wsprops.Hidden = 2; break;
						}
						else pidx = Rn.index + Rn[0].length;
						break;
					case 'Header':
						if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
						cursheet['!margins'].header = parsexmltag(Rn[0]).Margin;
						break;
					case 'Footer':
						if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
						cursheet['!margins'].footer = parsexmltag(Rn[0]).Margin;
						break;
					case 'PageMargins':
						var pagemargins = parsexmltag(Rn[0]);
						if(!cursheet['!margins']) default_margins(cursheet['!margins']={},'xlml');
						if(pagemargins.Top) cursheet['!margins'].top = pagemargins.Top;
						if(pagemargins.Left) cursheet['!margins'].left = pagemargins.Left;
						if(pagemargins.Right) cursheet['!margins'].right = pagemargins.Right;
						if(pagemargins.Bottom) cursheet['!margins'].bottom = pagemargins.Bottom;
						break;
					case 'DisplayRightToLeft':
						if(!Workbook.Views) Workbook.Views = [];
						if(!Workbook.Views[0]) Workbook.Views[0] = {};
						Workbook.Views[0].RTL = true;
						break;

					case 'Unsynced': break;
					case 'Print': break;
					case 'Panes': break;
					case 'Scale': break;
					case 'Pane': break;
					case 'Number': break;
					case 'Layout': break;
					case 'PageSetup': break;
					case 'Selected': break;
					case 'ProtectObjects': break;
					case 'EnableSelection': break;
					case 'ProtectScenarios': break;
					case 'ValidPrinterInfo': break;
					case 'HorizontalResolution': break;
					case 'VerticalResolution': break;
					case 'NumberofCopies': break;
					case 'ActiveRow': break;
					case 'ActiveCol': break;
					case 'ActivePane': break;
					case 'TopRowVisible': break;
					case 'TopRowBottomPane': break;
					case 'LeftColumnVisible': break;
					case 'LeftColumnRightPane': break;
					case 'FitToPage': break;
					case 'RangeSelection': break;
					case 'PaperSizeIndex': break;
					case 'PageLayoutZoom': break;
					case 'PageBreakZoom': break;
					case 'FilterOn': break;
					case 'DoNotDisplayGridlines': break;
					case 'SplitHorizontal': break;
					case 'SplitVertical': break;
					case 'FreezePanes': break;
					case 'FrozenNoSplit': break;
					case 'FitWidth': break;
					case 'FitHeight': break;
					case 'CommentsLayout': break;
					case 'Zoom': break;
					case 'LeftToRight': break;
					case 'Gridlines': break;
					case 'AllowSort': break;
					case 'AllowFilter': break;
					case 'AllowInsertRows': break;
					case 'AllowDeleteRows': break;
					case 'AllowInsertCols': break;
					case 'AllowDeleteCols': break;
					case 'AllowInsertHyperlinks': break;
					case 'AllowFormatCells': break;
					case 'AllowSizeCols': break;
					case 'AllowSizeRows': break;
					case 'NoSummaryRowsBelowDetail': break;
					case 'TabColorIndex': break;
					case 'DoNotDisplayHeadings': break;
					case 'ShowPageLayoutZoom': break;
					case 'NoSummaryColumnsRightDetail': break;
					case 'BlackAndWhite': break;
					case 'DoNotDisplayZeros': break;
					case 'DisplayPageBreak': break;
					case 'RowColHeadings': break;
					case 'DoNotDisplayOutline': break;
					case 'NoOrientation': break;
					case 'AllowUsePivotTables': break;
					case 'ZeroHeight': break;
					case 'ViewableRange': break;
					case 'Selection': break;
					case 'ProtectContents': break;
					default: seen = false;
				} break;

				/* PivotTable */
				case 'PivotTable': case 'PivotCache': switch(Rn[3]) {
					case 'ImmediateItemsOnDrop': break;
					case 'ShowPageMultipleItemLabel': break;
					case 'CompactRowIndent': break;
					case 'Location': break;
					case 'PivotField': break;
					case 'Orientation': break;
					case 'LayoutForm': break;
					case 'LayoutSubtotalLocation': break;
					case 'LayoutCompactRow': break;
					case 'Position': break;
					case 'PivotItem': break;
					case 'DataType': break;
					case 'DataField': break;
					case 'SourceName': break;
					case 'ParentField': break;
					case 'PTLineItems': break;
					case 'PTLineItem': break;
					case 'CountOfSameItems': break;
					case 'Item': break;
					case 'ItemType': break;
					case 'PTSource': break;
					case 'CacheIndex': break;
					case 'ConsolidationReference': break;
					case 'FileName': break;
					case 'Reference': break;
					case 'NoColumnGrand': break;
					case 'NoRowGrand': break;
					case 'BlankLineAfterItems': break;
					case 'Hidden': break;
					case 'Subtotal': break;
					case 'BaseField': break;
					case 'MapChildItems': break;
					case 'Function': break;
					case 'RefreshOnFileOpen': break;
					case 'PrintSetTitles': break;
					case 'MergeLabels': break;
					case 'DefaultVersion': break;
					case 'RefreshName': break;
					case 'RefreshDate': break;
					case 'RefreshDateCopy': break;
					case 'VersionLastRefresh': break;
					case 'VersionLastUpdate': break;
					case 'VersionUpdateableMin': break;
					case 'VersionRefreshableMin': break;
					case 'Calculation': break;
					default: seen = false;
				} break;

				/* PageBreaks */
				case 'PageBreaks': switch(Rn[3]) {
					case 'ColBreaks': break;
					case 'ColBreak': break;
					case 'RowBreaks': break;
					case 'RowBreak': break;
					case 'ColStart': break;
					case 'ColEnd': break;
					case 'RowEnd': break;
					default: seen = false;
				} break;

				/* AutoFilter */
				case 'AutoFilter': switch(Rn[3]) {
					case 'AutoFilterColumn': break;
					case 'AutoFilterCondition': break;
					case 'AutoFilterAnd': break;
					case 'AutoFilterOr': break;
					default: seen = false;
				} break;

				/* QueryTable */
				case 'QueryTable': switch(Rn[3]) {
					case 'Id': break;
					case 'AutoFormatFont': break;
					case 'AutoFormatPattern': break;
					case 'QuerySource': break;
					case 'QueryType': break;
					case 'EnableRedirections': break;
					case 'RefreshedInXl9': break;
					case 'URLString': break;
					case 'HTMLTables': break;
					case 'Connection': break;
					case 'CommandText': break;
					case 'RefreshInfo': break;
					case 'NoTitles': break;
					case 'NextId': break;
					case 'ColumnInfo': break;
					case 'OverwriteCells': break;
					case 'DoNotPromptForFile': break;
					case 'TextWizardSettings': break;
					case 'Source': break;
					case 'Number': break;
					case 'Decimal': break;
					case 'ThousandSeparator': break;
					case 'TrailingMinusNumbers': break;
					case 'FormatSettings': break;
					case 'FieldType': break;
					case 'Delimiters': break;
					case 'Tab': break;
					case 'Comma': break;
					case 'AutoFormatName': break;
					case 'VersionLastEdit': break;
					case 'VersionLastRefresh': break;
					default: seen = false;
				} break;

				case 'Sorting':
				case 'ConditionalFormatting':
				case 'DataValidation':
				switch(Rn[3]) {
					case 'Range': break;
					case 'Type': break;
					case 'Min': break;
					case 'Max': break;
					case 'Sort': break;
					case 'Descending': break;
					case 'Order': break;
					case 'CaseSensitive': break;
					case 'Value': break;
					case 'ErrorStyle': break;
					case 'ErrorMessage': break;
					case 'ErrorTitle': break;
					case 'CellRangeList': break;
					case 'InputMessage': break;
					case 'InputTitle': break;
					case 'ComboHide': break;
					case 'InputHide': break;
					case 'Condition': break;
					case 'Qualifier': break;
					case 'UseBlank': break;
					case 'Value1': break;
					case 'Value2': break;
					case 'Format': break;
					default: seen = false;
				} break;

				/* MapInfo (schema) */
				case 'MapInfo': case 'Schema': case 'data': switch(Rn[3]) {
					case 'Map': break;
					case 'Entry': break;
					case 'Range': break;
					case 'XPath': break;
					case 'Field': break;
					case 'XSDType': break;
					case 'FilterOn': break;
					case 'Aggregate': break;
					case 'ElementType': break;
					case 'AttributeType': break;
				/* These are from xsd (XML Schema Definition) */
					case 'schema':
					case 'element':
					case 'complexType':
					case 'datatype':
					case 'all':
					case 'attribute':
					case 'extends': break;

					case 'row': break;
					default: seen = false;
				} break;

				/* SmartTags (can be anything) */
				case 'SmartTags': break;

				default: seen = false; break;
			}
			if(seen) break;
			/* CustomDocumentProperties */
			if(!state[state.length-1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
			if(state[state.length-1][0]==='CustomDocumentProperties') {
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") xlml_set_custprop(Custprops, Rn[3], cp, str.slice(pidx, Rn.index));
				else { cp = Rn; pidx = Rn.index + Rn[0].length; }
				break;
			}
			if(opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
	}
	var out = ({});
	if(!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
	out.SheetNames = sheetnames;
	out.Workbook = Workbook;
	out.SSF = SSF.get_table();
	out.Props = Props;
	out.Custprops = Custprops;
	return out;
}

function parse_xlml(data, opts) {
	fix_read_opts(opts=opts||{});
	switch(opts.type||"base64") {
		case "base64": return parse_xlml_xml(Base64.decode(data), opts);
		case "binary": case "buffer": case "file": return parse_xlml_xml(data, opts);
		case "array": return parse_xlml_xml(a2s(data), opts);
	}
}

/* TODO */
function write_props_xlml(wb, opts) {
	var o = [];
	/* DocumentProperties */
	if(wb.Props) o.push(xlml_write_docprops(wb.Props, opts));
	/* CustomDocumentProperties */
	if(wb.Custprops) o.push(xlml_write_custprops(wb.Props, wb.Custprops, opts));
	return o.join("");
}
/* TODO */
function write_wb_xlml() {
	/* OfficeDocumentSettings */
	/* ExcelWorkbook */
	return "";
}
/* TODO */
function write_sty_xlml(wb, opts) {
	/* Styles */
	var styles = ['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];
	opts.cellXfs.forEach(function(xf, id) {
		var payload = [];
		payload.push(writextag('NumberFormat', null, {"ss:Format": escapexml(SSF._table[xf.numFmtId])}));
		styles.push(writextag('Style', payload.join(""), {"ss:ID": "s" + (21+id)}));
	});
	return writextag("Styles", styles.join(""));
}
function write_name_xlml(n) { return writextag("NamedRange", null, {"ss:Name": n.Name, "ss:RefersTo":"=" + a1_to_rc(n.Ref, {r:0,c:0})}); }
function write_names_xlml(wb) {
	if(!((wb||{}).Workbook||{}).Names) return "";
var names = wb.Workbook.Names;
	var out = [];
	for(var i = 0; i < names.length; ++i) {
		var n = names[i];
		if(n.Sheet != null) continue;
		if(n.Name.match(/^_xlfn\./)) continue;
		out.push(write_name_xlml(n));
	}
	return writextag("Names", out.join(""));
}
function write_ws_xlml_names(ws, opts, idx, wb) {
	if(!ws) return "";
	if(!((wb||{}).Workbook||{}).Names) return "";
var names = wb.Workbook.Names;
	var out = [];
	for(var i = 0; i < names.length; ++i) {
		var n = names[i];
		if(n.Sheet != idx) continue;
		/*switch(n.Name) {
			case "_": continue;
		}*/
		if(n.Name.match(/^_xlfn\./)) continue;
		out.push(write_name_xlml(n));
	}
	return out.join("");
}
/* WorksheetOptions */
function write_ws_xlml_wsopts(ws, opts, idx, wb) {
	if(!ws) return "";
	var o = [];
	/* NOTE: spec technically allows any order, but stick with implied order */

	/* FitToPage */
	/* DoNotDisplayColHeaders */
	/* DoNotDisplayRowHeaders */
	/* ViewableRange */
	/* Selection */
	/* GridlineColor */
	/* Name */
	/* ExcelWorksheetType */
	/* IntlMacro */
	/* Unsynced */
	/* Selected */
	/* CodeName */

	if(ws['!margins']) {
		o.push("<PageSetup>");
		if(ws['!margins'].header) o.push(writextag("Header", null, {'x:Margin':ws['!margins'].header}));
		if(ws['!margins'].footer) o.push(writextag("Footer", null, {'x:Margin':ws['!margins'].footer}));
		o.push(writextag("PageMargins", null, {
			'x:Bottom': ws['!margins'].bottom || "0.75",
			'x:Left': ws['!margins'].left || "0.7",
			'x:Right': ws['!margins'].right || "0.7",
			'x:Top': ws['!margins'].top || "0.75"
		}));
		o.push("</PageSetup>");
	}

	/* PageSetup */
	/* DisplayPageBreak */
	/* TransitionExpressionEvaluation */
	/* TransitionFormulaEntry */
	/* Print */
	/* Zoom */
	/* PageLayoutZoom */
	/* PageBreakZoom */
	/* ShowPageBreakZoom */
	/* DefaultRowHeight */
	/* DefaultColumnWidth */
	/* StandardWidth */

	if(wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
		/* Visible */
		if(wb.Workbook.Sheets[idx].Hidden) o.push(writextag("Visible", (wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden"), {}));
		else {
			/* Selected */
			for(var i = 0; i < idx; ++i) if(wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
			if(i == idx) o.push("<Selected/>");
		}
	}

	/* LeftColumnVisible */

	if(((((wb||{}).Workbook||{}).Views||[])[0]||{}).RTL) o.push("<DisplayRightToLeft/>");

	/* GridlineColorIndex */
	/* DisplayFormulas */
	/* DoNotDisplayGridlines */
	/* DoNotDisplayHeadings */
	/* DoNotDisplayOutline */
	/* ApplyAutomaticOutlineStyles */
	/* NoSummaryRowsBelowDetail */
	/* NoSummaryColumnsRightDetail */
	/* DoNotDisplayZeros */
	/* ActiveRow */
	/* ActiveColumn */
	/* FilterOn */
	/* RangeSelection */
	/* TopRowVisible */
	/* TopRowBottomPane */
	/* LeftColumnRightPane */
	/* ActivePane */
	/* SplitHorizontal */
	/* SplitVertical */
	/* FreezePanes */
	/* FrozenNoSplit */
	/* TabColorIndex */
	/* Panes */

	/* NOTE: Password not supported in XLML Format */
	if(ws['!protect']) {
		o.push(writetag("ProtectContents", "True"));
		if(ws['!protect'].objects) o.push(writetag("ProtectObjects", "True"));
		if(ws['!protect'].scenarios) o.push(writetag("ProtectScenarios", "True"));
		if(ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push(writetag("EnableSelection", "NoSelection"));
		else if(ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push(writetag("EnableSelection", "UnlockedCells"));
	[
		[ "formatCells", "AllowFormatCells" ],
		[ "formatColumns", "AllowSizeCols" ],
		[ "formatRows", "AllowSizeRows" ],
		[ "insertColumns", "AllowInsertCols" ],
		[ "insertRows", "AllowInsertRows" ],
		[ "insertHyperlinks", "AllowInsertHyperlinks" ],
		[ "deleteColumns", "AllowDeleteCols" ],
		[ "deleteRows", "AllowDeleteRows" ],
		[ "sort", "AllowSort" ],
		[ "autoFilter", "AllowFilter" ],
		[ "pivotTables", "AllowUsePivotTables" ]
	].forEach(function(x) { if(ws['!protect'][x[0]]) o.push("<"+x[1]+"/>"); });
	}

	if(o.length == 0) return "";
	return writextag("WorksheetOptions", o.join(""), {xmlns:XLMLNS.x});
}
function write_ws_xlml_comment(comments) {
	return comments.map(function(c) {
		// TODO: formatted text
		var t = xlml_unfixstr(c.t||"");
		var d =writextag("ss:Data", t, {"xmlns":"http://www.w3.org/TR/REC-html40"});
		return writextag("Comment", d, {"ss:Author":c.a});
	}).join("");
}
function write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr){
	if(!cell || (cell.v == undefined && cell.f == undefined)) return "";

	var attr = {};
	if(cell.f) attr["ss:Formula"] = "=" + escapexml(a1_to_rc(cell.f, addr));
	if(cell.F && cell.F.slice(0, ref.length) == ref) {
		var end = decode_cell(cell.F.slice(ref.length + 1));
		attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
	}

	if(cell.l && cell.l.Target) {
		attr["ss:HRef"] = escapexml(cell.l.Target);
		if(cell.l.Tooltip) attr["x:HRefScreenTip"] = escapexml(cell.l.Tooltip);
	}

	if(ws['!merges']) {
		var marr = ws['!merges'];
		for(var mi = 0; mi != marr.length; ++mi) {
			if(marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
			if(marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
			if(marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
		}
	}

	var t = "", p = "";
	switch(cell.t) {
		case 'z': return "";
		case 'n': t = 'Number'; p = String(cell.v); break;
		case 'b': t = 'Boolean'; p = (cell.v ? "1" : "0"); break;
		case 'e': t = 'Error'; p = BErr[cell.v]; break;
		case 'd': t = 'DateTime'; p = new Date(cell.v).toISOString(); if(cell.z == null) cell.z = cell.z || SSF._table[14]; break;
		case 's': t = 'String'; p = escapexlml(cell.v||""); break;
	}
	/* TODO: cell style */
	var os = get_cell_style(opts.cellXfs, cell, opts);
	attr["ss:StyleID"] = "s" + (21+os);
	attr["ss:Index"] = addr.c + 1;
	var _v = (cell.v != null ? p : "");
	var m = '<Data ss:Type="' + t + '">' + _v + '</Data>';

	if((cell.c||[]).length > 0) m += write_ws_xlml_comment(cell.c);

	return writextag("Cell", m, attr);
}
function write_ws_xlml_row(R, row) {
	var o = '<Row ss:Index="' + (R+1) + '"';
	if(row) {
		if(row.hpt && !row.hpx) row.hpx = pt2px(row.hpt);
		if(row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
		if(row.hidden) o += ' ss:Hidden="1"';
	}
	return o + '>';
}
/* TODO */
function write_ws_xlml_table(ws, opts, idx, wb) {
	if(!ws['!ref']) return "";
	var range = safe_decode_range(ws['!ref']);
	var marr = ws['!merges'] || [], mi = 0;
	var o = [];
	if(ws['!cols']) ws['!cols'].forEach(function(n, i) {
		process_col(n);
		var w = !!n.width;
		var p = col_obj_w(i, n);
		var k = {"ss:Index":i+1};
		if(w) k['ss:Width'] = width2px(p.width);
		if(n.hidden) k['ss:Hidden']="1";
		o.push(writextag("Column",null,k));
	});
	var dense = Array.isArray(ws);
	for(var R = range.s.r; R <= range.e.r; ++R) {
		var row = [write_ws_xlml_row(R, (ws['!rows']||[])[R])];
		for(var C = range.s.c; C <= range.e.c; ++C) {
			var skip = false;
			for(mi = 0; mi != marr.length; ++mi) {
				if(marr[mi].s.c > C) continue;
				if(marr[mi].s.r > R) continue;
				if(marr[mi].e.c < C) continue;
				if(marr[mi].e.r < R) continue;
				if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
				break;
			}
			if(skip) continue;
			var addr = {r:R,c:C};
			var ref = encode_cell(addr), cell = dense ? (ws[R]||[])[C] : ws[ref];
			row.push(write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
		}
		row.push("</Row>");
		if(row.length > 2) o.push(row.join(""));
	}
	return o.join("");
}
function write_ws_xlml(idx, opts, wb) {
	var o = [];
	var s = wb.SheetNames[idx];
	var ws = wb.Sheets[s];

	var t = ws ? write_ws_xlml_names(ws, opts, idx, wb) : "";
	if(t.length > 0) o.push("<Names>" + t + "</Names>");

	/* Table */
	t = ws ? write_ws_xlml_table(ws, opts, idx, wb) : "";
	if(t.length > 0) o.push("<Table>" + t + "</Table>");

	/* WorksheetOptions */
	o.push(write_ws_xlml_wsopts(ws, opts, idx, wb));

	return o.join("");
}
function write_xlml(wb, opts) {
	if(!opts) opts = {};
	if(!wb.SSF) wb.SSF = SSF.get_table();
	if(wb.SSF) {
		make_ssf(SSF); SSF.load_table(wb.SSF);
		// $FlowIgnore
		opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
		opts.ssf = wb.SSF;
		opts.cellXfs = [];
		get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
	}
	var d = [];
	d.push(write_props_xlml(wb, opts));
	d.push(write_wb_xlml(wb, opts));
	d.push("");
	d.push("");
	for(var i = 0; i < wb.SheetNames.length; ++i)
		d.push(writextag("Worksheet", write_ws_xlml(i, opts, wb), {"ss:Name":escapexml(wb.SheetNames[i])}));
	d[2] = write_sty_xlml(wb, opts);
	d[3] = write_names_xlml(wb, opts);
	return XML_HEADER + writextag("Workbook", d.join(""), {
		'xmlns':      XLMLNS.ss,
		'xmlns:o':    XLMLNS.o,
		'xmlns:x':    XLMLNS.x,
		'xmlns:ss':   XLMLNS.ss,
		'xmlns:dt':   XLMLNS.dt,
		'xmlns:html': XLMLNS.html
	});
}
/* [MS-OLEDS] 2.3.8 CompObjStream */
function parse_compobj(obj) {
	var v = {};
	var o = obj.content;
/* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */
	o.l = 28;

	v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
	v.AnsiClipboardFormat = parse_ClipboardFormatOrAnsiString(o);

	if(o.length - o.l <= 4) return v;

	var m = o.read_shift(4);
	if(m == 0 || m > 40) return v;
	o.l-=4; v.Reserved1 = o.read_shift(0, "lpstr-ansi");

	if(o.length - o.l <= 4) return v;
	m = o.read_shift(4);
	if(m !== 0x71b239f4) return v;
	v.UnicodeClipboardFormat = parse_ClipboardFormatOrUnicodeString(o);

	m = o.read_shift(4);
	if(m == 0 || m > 40) return v;
	o.l-=4; v.Reserved2 = o.read_shift(0, "lpwstr");
}

/*
	Continue logic for:
	- 2.4.58 Continue
	- 2.4.59 ContinueBigName
	- 2.4.60 ContinueFrt
	- 2.4.61 ContinueFrt11
	- 2.4.62 ContinueFrt12
*/
function slurp(R, blob, length, opts) {
	var l = length;
	var bufs = [];
	var d = blob.slice(blob.l,blob.l+l);
	if(opts && opts.enc && opts.enc.insitu) switch(R.n) {
	case 'BOF': case 'FilePass': case 'FileLock': case 'InterfaceHdr': case 'RRDInfo': case 'RRDHead': case 'UsrExcl': break;
	default:
		if(d.length === 0) break;
		opts.enc.insitu(d);
	}
	bufs.push(d);
	blob.l += l;
	var next = (XLSRecordEnum[__readUInt16LE(blob,blob.l)]);
	var start = 0;
	while(next != null && next.n.slice(0,8) === 'Continue') {
		l = __readUInt16LE(blob,blob.l+2);
		start = blob.l + 4;
		if(next.n == 'ContinueFrt') start += 4;
		else if(next.n.slice(0,11) == 'ContinueFrt') start += 12;
		bufs.push(blob.slice(start,blob.l+4+l));
		blob.l += 4+l;
		next = (XLSRecordEnum[__readUInt16LE(blob, blob.l)]);
	}
	var b = (bconcat(bufs));
	prep_blob(b, 0);
	var ll = 0; b.lens = [];
	for(var j = 0; j < bufs.length; ++j) { b.lens.push(ll); ll += bufs[j].length; }
	return R.f(b, b.length, opts);
}

function safe_format_xf(p, opts, date1904) {
	if(p.t === 'z') return;
	if(!p.XF) return;
	var fmtid = 0;
	try {
		fmtid = p.z || p.XF.numFmtId || 0;
		if(opts.cellNF) p.z = SSF._table[fmtid];
	} catch(e) { if(opts.WTF) throw e; }
	if(!opts || opts.cellText !== false) try {
		if(p.t === 'e') { p.w = p.w || BErr[p.v]; }
		else if(fmtid === 0 || fmtid == "General") {
			if(p.t === 'n') {
				if((p.v|0) === p.v) p.w = SSF._general_int(p.v);
				else p.w = SSF._general_num(p.v);
			}
			else p.w = SSF._general(p.v);
		}
		else p.w = SSF.format(fmtid,p.v, {date1904:!!date1904});
	} catch(e) { if(opts.WTF) throw e; }
	if(opts.cellDates && fmtid && p.t == 'n' && SSF.is_date(SSF._table[fmtid] || String(fmtid))) {
		var _d = SSF.parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
	}
}

function make_cell(val, ixfe, t) {
	return ({v:val, ixfe:ixfe, t:t});
}

// 2.3.2
function parse_workbook(blob, options) {
	var wb = ({opts:{}});
	var Sheets = {};
	if(DENSE != null && options.dense == null) options.dense = DENSE;
	var out = ((options.dense ? [] : {}));
	var Directory = {};
	var range = ({});
	var last_formula = null;
	var sst = ([]);
	var cur_sheet = "";
	var Preamble = {};
	var lastcell, last_cell = "", cc, cmnt, rngC, rngR;
	var sharedf = {};
	var arrayf = [];
	var temp_val;
	var country;
	var cell_valid = true;
	var XFs = []; /* XF records */
	var palette = [];
	var Workbook = ({ Sheets:[], WBProps:{date1904:false}, Views:[{}] }), wsprops = {};
	var get_rgb = function getrgb(icv) {
		if(icv < 8) return XLSIcv[icv];
		if(icv < 64) return palette[icv-8] || XLSIcv[icv];
		return XLSIcv[icv];
	};
	var process_cell_style = function pcs(cell, line, options) {
		var xfd = line.XF.data;
		if(!xfd || !xfd.patternType || !options || !options.cellStyles) return;
		line.s = ({});
		line.s.patternType = xfd.patternType;
		var t;
		if((t = rgb2Hex(get_rgb(xfd.icvFore)))) { line.s.fgColor = {rgb:t}; }
		if((t = rgb2Hex(get_rgb(xfd.icvBack)))) { line.s.bgColor = {rgb:t}; }
	};
	var addcell = function addcell(cell, line, options) {
		if(file_depth > 1) return;
		if(options.sheetRows && cell.r >= options.sheetRows) cell_valid = false;
		if(!cell_valid) return;
		if(options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
		delete line.ixfe; delete line.XF;
		lastcell = cell;
		last_cell = encode_cell(cell);
		if(!range || !range.s || !range.e) range = {s:{r:0,c:0},e:{r:0,c:0}};
		if(cell.r < range.s.r) range.s.r = cell.r;
		if(cell.c < range.s.c) range.s.c = cell.c;
		if(cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
		if(cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
		if(options.cellFormula && line.f) {
			for(var afi = 0; afi < arrayf.length; ++afi) {
				if(arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
				if(arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
				line.F = encode_range(arrayf[afi][0]);
				if(arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
				if(line.f) line.f = "" + stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
				break;
			}
		}
		{
			if(options.dense) {
				if(!out[cell.r]) out[cell.r] = [];
				out[cell.r][cell.c] = line;
			} else out[last_cell] = line;
		}
	};
	var opts = ({
		enc: false, // encrypted
		sbcch: 0, // cch in the preceding SupBook
		snames: [], // sheetnames
		sharedf: sharedf, // shared formulae by address
		arrayf: arrayf, // array formulae array
		rrtabid: [], // RRTabId
		lastuser: "", // Last User from WriteAccess
		biff: 8, // BIFF version
		codepage: 0, // CP from CodePage record
		winlocked: 0, // fLockWn from WinProtect
		cellStyles: !!options && !!options.cellStyles,
		WTF: !!options && !!options.wtf
	});
	if(options.password) opts.password = options.password;
	var themes;
	var merges = [];
	var objects = [];
	var colinfo = [], rowinfo = [];
	// eslint-disable-next-line no-unused-vars
	var defwidth = 0, defheight = 0; // twips / MDW respectively
	var seencol = false;
	var supbooks = ([]); // 1-indexed, will hold extern names
	supbooks.SheetNames = opts.snames;
	supbooks.sharedf = opts.sharedf;
	supbooks.arrayf = opts.arrayf;
	supbooks.names = [];
	supbooks.XTI = [];
	var last_Rn = '';
	var file_depth = 0; /* TODO: make a real stack */
	var BIFF2Fmt = 0, BIFF2FmtTable = [];
	var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */
	var last_lbl;

	/* explicit override for some broken writers */
	opts.codepage = 1200;
	set_cp(1200);
	var seen_codepage = false;
	while(blob.l < blob.length - 1) {
		var s = blob.l;
		var RecordType = blob.read_shift(2);
		if(RecordType === 0 && last_Rn === 'EOF') break;
		var length = (blob.l === blob.length ? 0 : blob.read_shift(2));
		var R = XLSRecordEnum[RecordType];
		//console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
		//if(!R) console.log(blob.slice(blob.l, blob.l + length));
		if(R && R.f) {
			if(options.bookSheets) {
				if(last_Rn === 'BoundSheet8' && R.n !== 'BoundSheet8') break;
			}
			last_Rn = R.n;
			if(R.r === 2 || R.r == 12) {
				var rt = blob.read_shift(2); length -= 2;
				if(!opts.enc && rt !== RecordType && (((rt&0xFF)<<8)|(rt>>8)) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
				if(R.r == 12){ blob.l += 10; length -= 10; } // skip FRT
			}
			//console.error(R,blob.l,length,blob.length);
			var val;
			if(R.n === 'EOF') val = R.f(blob, length, opts);
			else val = slurp(R, blob, length, opts);
			var Rn = R.n;
			if(file_depth == 0 && Rn != 'BOF') continue;
			/* nested switch statements to workaround V8 128 limit */
			switch(Rn) {
				/* Workbook Options */
				case 'Date1904':
wb.opts.Date1904 = Workbook.WBProps.date1904 = val; break;
				case 'WriteProtect': wb.opts.WriteProtect = true; break;
				case 'FilePass':
					if(!opts.enc) blob.l = 0;
					opts.enc = val;
					if(!options.password) throw new Error("File is password-protected");
					if(val.valid == null) throw new Error("Encryption scheme unsupported");
					if(!val.valid) throw new Error("Password is incorrect");
					break;
				case 'WriteAccess': opts.lastuser = val; break;
				case 'FileSharing': break; //TODO
				case 'CodePage':
					/* overrides based on test cases */
					switch(val) {
						case 0x5212: val =  1200; break;
						case 0x8000: val = 10000; break;
						case 0x8001: val =  1252; break;
					}
					set_cp(opts.codepage = val);
					seen_codepage = true;
					break;
				case 'RRTabId': opts.rrtabid = val; break;
				case 'WinProtect': opts.winlocked = val; break;
				case 'Template': break; // TODO
				case 'BookBool': break; // TODO
				case 'UsesELFs': break;
				case 'MTRSettings': break;
				case 'RefreshAll':
				case 'CalcCount':
				case 'CalcDelta':
				case 'CalcIter':
				case 'CalcMode':
				case 'CalcPrecision':
				case 'CalcSaveRecalc':
					wb.opts[Rn] = val; break;
				case 'CalcRefMode': opts.CalcRefMode = val; break; // TODO: implement R1C1
				case 'Uncalced': break;
				case 'ForceFullCalculation': wb.opts.FullCalc = val; break;
				case 'WsBool':
					if(val.fDialog) out["!type"] = "dialog";
					break; // TODO
				case 'XF':
					XFs.push(val); break;
				case 'ExtSST': break; // TODO
				case 'BookExt': break; // TODO
				case 'RichTextStream': break;
				case 'BkHim': break;

				case 'SupBook':
					supbooks.push([val]);
					supbooks[supbooks.length-1].XTI = [];
					break;
				case 'ExternName':
					supbooks[supbooks.length-1].push(val);
					break;
				case 'Index': break; // TODO
				case 'Lbl':
					last_lbl = ({
						Name: val.Name,
						Ref: stringify_formula(val.rgce,range,null,supbooks,opts)
					});
					if(val.itab > 0) last_lbl.Sheet = val.itab - 1;
					supbooks.names.push(last_lbl);
					if(!supbooks[0]) { supbooks[0] = []; supbooks[0].XTI = []; }
					supbooks[supbooks.length-1].push(val);
					if(val.Name == "_xlnm._FilterDatabase" && val.itab > 0)
						if(val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == 'PtgArea3d')
							FilterDatabases[val.itab - 1] = { ref: encode_range(val.rgce[0][0][1][2]) };
					break;
				case 'ExternCount': opts.ExternCount = val; break;
				case 'ExternSheet':
					if(supbooks.length == 0) { supbooks[0] = []; supbooks[0].XTI = []; }
					supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val); supbooks.XTI = supbooks.XTI.concat(val); break;
				case 'NameCmt':
					/* TODO: search for correct name */
					if(opts.biff < 8) break;
					if(last_lbl != null) last_lbl.Comment = val[1];
					break;

				case 'Protect': out["!protect"] = val; break; /* for sheet or book */
				case 'Password': if(val !== 0 && opts.WTF) console.error("Password verifier: " + val); break;
				case 'Prot4Rev': case 'Prot4RevPass': break; /*TODO: Revision Control*/

				case 'BoundSheet8': {
					Directory[val.pos] = val;
					opts.snames.push(val.name);
				} break;
				case 'EOF': {
					if(--file_depth) break;
					if(range.e) {
						if(range.e.r > 0 && range.e.c > 0) {
							range.e.r--; range.e.c--;
							out["!ref"] = encode_range(range);
							if(options.sheetRows && options.sheetRows <= range.e.r) {
								var tmpri = range.e.r;
								range.e.r = options.sheetRows - 1;
								out["!fullref"] = out["!ref"];
								out["!ref"] = encode_range(range);
								range.e.r = tmpri;
							}
							range.e.r++; range.e.c++;
						}
						if(merges.length > 0) out["!merges"] = merges;
						if(objects.length > 0) out["!objects"] = objects;
						if(colinfo.length > 0) out["!cols"] = colinfo;
						if(rowinfo.length > 0) out["!rows"] = rowinfo;
						Workbook.Sheets.push(wsprops);
					}
					if(cur_sheet === "") Preamble = out; else Sheets[cur_sheet] = out;
					out = ((options.dense ? [] : {}));
				} break;
				case 'BOF': {
					if(opts.biff === 8) opts.biff = {
0x0009:2,
0x0209:3,
0x0409:4
					}[RecordType] || {
0x0200:2,
0x0300:3,
0x0400:4,
0x0500:5,
0x0600:8,
0x0002:2,
0x0007:2
					}[val.BIFFVer] || 8;
					if(opts.biff == 8 && val.BIFFVer == 0 && val.dt == 16) opts.biff = 2;
					if(file_depth++) break;
					cell_valid = true;
					out = ((options.dense ? [] : {}));

					if(opts.biff < 8 && !seen_codepage) { seen_codepage = true; set_cp(opts.codepage = options.codepage || 1252); }
					if(opts.biff < 5) {
						if(cur_sheet === "") cur_sheet = "Sheet1";
						range = {s:{r:0,c:0},e:{r:0,c:0}};
						/* fake BoundSheet8 */
						var fakebs8 = {pos: blob.l - length, name:cur_sheet};
						Directory[fakebs8.pos] = fakebs8;
						opts.snames.push(cur_sheet);
					}
					else cur_sheet = (Directory[s] || {name:""}).name;
					if(val.dt == 0x20) out["!type"] = "chart";
					if(val.dt == 0x40) out["!type"] = "macro";
					merges = [];
					objects = [];
					opts.arrayf = arrayf = [];
					colinfo = []; rowinfo = [];
					defwidth = defheight = 0;
					seencol = false;
					wsprops = {Hidden:(Directory[s]||{hs:0}).hs, name:cur_sheet };
				} break;

				case 'Number': case 'BIFF2NUM': case 'BIFF2INT': {
					if(out["!type"] == "chart") if(options.dense ? (out[val.r]||[])[val.c]: out[encode_cell({c:val.c, r:val.r})]) ++val.c;
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe]||{}, v:val.val, t:'n'});
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 'BoolErr': {
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.val, t:val.t});
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 'RK': {
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.rknum, t:'n'});
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 'MulRk': {
					for(var j = val.c; j <= val.C; ++j) {
						var ixfe = val.rkrec[j-val.c][0];
						temp_val= ({ixfe:ixfe, XF:XFs[ixfe], v:val.rkrec[j-val.c][1], t:'n'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:j, r:val.r}, temp_val, options);
					}
				} break;
				case 'Formula': {
					if(val.val == 'String') { last_formula = val; break; }
					temp_val = make_cell(val.val, val.cell.ixfe, val.tt);
					temp_val.XF = XFs[temp_val.ixfe];
					if(options.cellFormula) {
						var _f = val.formula;
						if(_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
							var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
							var _fe = encode_cell({r:_fr, c:_fc});
							if(sharedf[_fe]) temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
							else temp_val.F = ((options.dense ? (out[_fr]||[])[_fc]: out[_fe]) || {}).F;
						} else temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
					}
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell(val.cell, temp_val, options);
					last_formula = val;
				} break;
				case 'String': {
					if(last_formula) { /* technically always true */
						last_formula.val = val;
						temp_val = make_cell(val, last_formula.cell.ixfe, 's');
						temp_val.XF = XFs[temp_val.ixfe];
						if(options.cellFormula) {
							temp_val.f = ""+stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
						}
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell(last_formula.cell, temp_val, options);
						last_formula = null;
					} else throw new Error("String record expects Formula");
				} break;
				case 'Array': {
					arrayf.push(val);
					var _arraystart = encode_cell(val[0].s);
					cc = options.dense ? (out[val[0].s.r]||[])[val[0].s.c] : out[_arraystart];
					if(options.cellFormula && cc) {
						if(!last_formula) break; /* technically unreachable */
						if(!_arraystart || !cc) break;
						cc.f = ""+stringify_formula(val[1], range, val[0], supbooks, opts);
						cc.F = encode_range(val[0]);
					}
				} break;
				case 'ShrFmla': {
					if(!cell_valid) break;
					if(!options.cellFormula) break;
					if(last_cell) {
						/* TODO: capture range */
						if(!last_formula) break; /* technically unreachable */
						sharedf[encode_cell(last_formula.cell)]= val[0];
						cc = options.dense ? (out[last_formula.cell.r]||[])[last_formula.cell.c] : out[encode_cell(last_formula.cell)];
						(cc||{}).f = ""+stringify_formula(val[0], range, lastcell, supbooks, opts);
					}
				} break;
				case 'LabelSst':
					temp_val=make_cell(sst[val.isst].t, val.ixfe, 's');
					temp_val.XF = XFs[temp_val.ixfe];
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
					break;
				case 'Blank': if(options.sheetStubs) {
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], t:'z'});
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 'MulBlank': if(options.sheetStubs) {
					for(var _j = val.c; _j <= val.C; ++_j) {
						var _ixfe = val.ixfe[_j-val.c];
						temp_val= ({ixfe:_ixfe, XF:XFs[_ixfe], t:'z'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:_j, r:val.r}, temp_val, options);
					}
				} break;
				case 'RString':
				case 'Label': case 'BIFF2STR':
					temp_val=make_cell(val.val, val.ixfe, 's');
					temp_val.XF = XFs[temp_val.ixfe];
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
					break;

				case 'Dimensions': {
					if(file_depth === 1) range = val; /* TODO: stack */
				} break;
				case 'SST': {
					sst = val;
				} break;
				case 'Format': { /* val = [id, fmt] */
					if(opts.biff == 4) {
						BIFF2FmtTable[BIFF2Fmt++] = val[1];
						for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx) if(SSF._table[b4idx] == val[1]) break;
						if(b4idx >= 163) SSF.load(val[1], BIFF2Fmt + 163);
					}
					else SSF.load(val[1], val[0]);
				} break;
				case 'BIFF2FORMAT': {
					BIFF2FmtTable[BIFF2Fmt++] = val;
					for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx) if(SSF._table[b2idx] == val) break;
					if(b2idx >= 163) SSF.load(val, BIFF2Fmt + 163);
				} break;

				case 'MergeCells': merges = merges.concat(val); break;

				case 'Obj': objects[val.cmo[0]] = opts.lastobj = val; break;
				case 'TxO': opts.lastobj.TxO = val; break;
				case 'ImData': opts.lastobj.ImData = val; break;

				case 'HLink': {
					for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
						for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
							cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
							if(cc) cc.l = val[1];
						}
				} break;
				case 'HLinkTooltip': {
					for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
						for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
							cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
							if(cc && cc.l) cc.l.Tooltip = val[1];
							}
				} break;

				/* Comments */
				case 'Note': {
					if(opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */
					cc = options.dense ? (out[val[0].r]||[])[val[0].c] : out[encode_cell(val[0])];
					var noteobj = objects[val[2]];
					if(!cc) {
						if(options.dense) {
							if(!out[val[0].r]) out[val[0].r] = [];
							cc = out[val[0].r][val[0].c] = {t:"z"};
						} else {
							cc = out[encode_cell(val[0])] = {t:"z"};
						}
						range.e.r = Math.max(range.e.r, val[0].r);
						range.s.r = Math.min(range.s.r, val[0].r);
						range.e.c = Math.max(range.e.c, val[0].c);
						range.s.c = Math.min(range.s.c, val[0].c);
					}
					if(!cc.c) cc.c = [];
					cmnt = {a:val[1],t:noteobj.TxO.t};
					cc.c.push(cmnt);
				} break;

				default: switch(R.n) { /* nested */
				case 'ClrtClient': break;
				case 'XFExt': update_xfext(XFs[val.ixfe], val.ext); break;

				case 'DefColWidth': defwidth = val; break;
				case 'DefaultRowHeight': defheight = val[1]; break; // TODO: flags

				case 'ColInfo': {
					if(!opts.cellStyles) break;
					while(val.e >= val.s) {
						colinfo[val.e--] = { width: val.w/256 };
						if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
						process_col(colinfo[val.e+1]);
					}
				} break;
				case 'Row': {
					var rowobj = {};
					if(val.level != null) { rowinfo[val.r] = rowobj; rowobj.level = val.level; }
					if(val.hidden) { rowinfo[val.r] = rowobj; rowobj.hidden = true; }
					if(val.hpt) {
						rowinfo[val.r] = rowobj;
						rowobj.hpt = val.hpt; rowobj.hpx = pt2px(val.hpt);
					}
				} break;

				case 'LeftMargin':
				case 'RightMargin':
				case 'TopMargin':
				case 'BottomMargin':
					if(!out['!margins']) default_margins(out['!margins'] = {});
					out['!margins'][Rn.slice(0,-6).toLowerCase()] = val;
					break;

				case 'Setup': // TODO
					if(!out['!margins']) default_margins(out['!margins'] = {});
					out['!margins'].header = val.header;
					out['!margins'].footer = val.footer;
					break;

				case 'Window2': // TODO
					// $FlowIgnore
					if(val.RTL) Workbook.Views[0].RTL = true;
					break;

				case 'Header': break; // TODO
				case 'Footer': break; // TODO
				case 'HCenter': break; // TODO
				case 'VCenter': break; // TODO
				case 'Pls': break; // TODO
				case 'GCW': break;
				case 'LHRecord': break;
				case 'DBCell': break; // TODO
				case 'EntExU2': break; // TODO
				case 'SxView': break; // TODO
				case 'Sxvd': break; // TODO
				case 'SXVI': break; // TODO
				case 'SXVDEx': break; // TODO
				case 'SxIvd': break; // TODO
				case 'SXString': break; // TODO
				case 'Sync': break;
				case 'Addin': break;
				case 'SXDI': break; // TODO
				case 'SXLI': break; // TODO
				case 'SXEx': break; // TODO
				case 'QsiSXTag': break; // TODO
				case 'Selection': break;
				case 'Feat': break;
				case 'FeatHdr': case 'FeatHdr11': break;
				case 'Feature11': case 'Feature12': case 'List12': break;
				case 'Country': country = val; break;
				case 'RecalcId': break;
				case 'DxGCol': break; // TODO: htmlify
				case 'Fbi': case 'Fbi2': case 'GelFrame': break;
				case 'Font': break; // TODO
				case 'XFCRC': break; // TODO
				case 'Style': break; // TODO
				case 'StyleExt': break; // TODO
				case 'Palette': palette = val; break;
				case 'Theme': themes = val; break;
				/* Protection */
				case 'ScenarioProtect': break;
				case 'ObjProtect': break;

				/* Conditional Formatting */
				case 'CondFmt12': break;

				/* Table */
				case 'Table': break; // TODO
				case 'TableStyles': break; // TODO
				case 'TableStyle': break; // TODO
				case 'TableStyleElement': break; // TODO

				/* PivotTable */
				case 'SXStreamID': break; // TODO
				case 'SXVS': break; // TODO
				case 'DConRef': break; // TODO
				case 'SXAddl': break; // TODO
				case 'DConBin': break; // TODO
				case 'DConName': break; // TODO
				case 'SXPI': break; // TODO
				case 'SxFormat': break; // TODO
				case 'SxSelect': break; // TODO
				case 'SxRule': break; // TODO
				case 'SxFilt': break; // TODO
				case 'SxItm': break; // TODO
				case 'SxDXF': break; // TODO

				/* Scenario Manager */
				case 'ScenMan': break;

				/* Data Consolidation */
				case 'DCon': break;

				/* Watched Cell */
				case 'CellWatch': break;

				/* Print Settings */
				case 'PrintRowCol': break;
				case 'PrintGrid': break;
				case 'PrintSize': break;

				case 'XCT': break;
				case 'CRN': break;

				case 'Scl': {
					//console.log("Zoom Level:", val[0]/val[1],val);
				} break;
				case 'SheetExt': {
					/* empty */
				} break;
				case 'SheetExtOptional': {
					/* empty */
				} break;

				/* VBA */
				case 'ObNoMacros': {
					/* empty */
				} break;
				case 'ObProj': {
					/* empty */
				} break;
				case 'CodeName': {
if(!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
					else wsprops.CodeName = val || wsprops.name;
				} break;
				case 'GUIDTypeLib': {
					/* empty */
				} break;

				case 'WOpt': break; // TODO: WTF?
				case 'PhoneticInfo': break;

				case 'OleObjectSize': break;

				/* Differential Formatting */
				case 'DXF': case 'DXFN': case 'DXFN12': case 'DXFN12List': case 'DXFN12NoCB': break;

				/* Data Validation */
				case 'Dv': case 'DVal': break;

				/* Data Series */
				case 'BRAI': case 'Series': case 'SeriesText': break;

				/* Data Connection */
				case 'DConn': break;
				case 'DbOrParamQry': break;
				case 'DBQueryExt': break;

				case 'OleDbConn': break;
				case 'ExtString': break;

				/* Formatting */
				case 'IFmtRecord': break;
				case 'CondFmt': case 'CF': case 'CF12': case 'CFEx': break;

				/* Explicitly Ignored */
				case 'Excel9File': break;
				case 'Units': break;
				case 'InterfaceHdr': case 'Mms': case 'InterfaceEnd': case 'DSF': break;
				case 'BuiltInFnGroupCount': /* 2.4.30 0x0E or 0x10 but excel 2011 generates 0x11? */ break;
				/* View Stuff */
				case 'Window1': case 'HideObj': case 'GridSet': case 'Guts':
				case 'UserBView': case 'UserSViewBegin': case 'UserSViewEnd':
				case 'Pane': break;
				default: switch(R.n) { /* nested */
				/* Chart */
				case 'Dat':
				case 'Begin': case 'End':
				case 'StartBlock': case 'EndBlock':
				case 'Frame': case 'Area':
				case 'Axis': case 'AxisLine': case 'Tick': break;
				case 'AxesUsed':
				case 'CrtLayout12': case 'CrtLayout12A': case 'CrtLink': case 'CrtLine': case 'CrtMlFrt': case 'CrtMlFrtContinue': break;
				case 'LineFormat': case 'AreaFormat':
				case 'Chart': case 'Chart3d': case 'Chart3DBarShape': case 'ChartFormat': case 'ChartFrtInfo': break;
				case 'PlotArea': case 'PlotGrowth': break;
				case 'SeriesList': case 'SerParent': case 'SerAuxTrend': break;
				case 'DataFormat': case 'SerToCrt': case 'FontX': break;
				case 'CatSerRange': case 'AxcExt': case 'SerFmt': break;
				case 'ShtProps': break;
				case 'DefaultText': case 'Text': case 'CatLab': break;
				case 'DataLabExtContents': break;
				case 'Legend': case 'LegendException': break;
				case 'Pie': case 'Scatter': break;
				case 'PieFormat': case 'MarkerFormat': break;
				case 'StartObject': case 'EndObject': break;
				case 'AlRuns': case 'ObjectLink': break;
				case 'SIIndex': break;
				case 'AttachedLabel': case 'YMult': break;

				/* Chart Group */
				case 'Line': case 'Bar': break;
				case 'Surf': break;

				/* Axis Group */
				case 'AxisParent': break;
				case 'Pos': break;
				case 'ValueRange': break;

				/* Pivot Chart */
				case 'SXViewEx9': break; // TODO
				case 'SXViewLink': break;
				case 'PivotChartBits': break;
				case 'SBaseRef': break;
				case 'TextPropsStream': break;

				/* Chart Misc */
				case 'LnExt': break;
				case 'MkrExt': break;
				case 'CrtCoopt': break;

				/* Query Table */
				case 'Qsi': case 'Qsif': case 'Qsir': case 'QsiSXTag': break;
				case 'TxtQry': break;

				/* Filter */
				case 'FilterMode': break;
				case 'AutoFilter': case 'AutoFilterInfo': break;
				case 'AutoFilter12': break;
				case 'DropDownObjIds': break;
				case 'Sort': break;
				case 'SortData': break;

				/* Drawing */
				case 'ShapePropsStream': break;
				case 'MsoDrawing': case 'MsoDrawingGroup': case 'MsoDrawingSelection': break;
				/* Pub Stuff */
				case 'WebPub': case 'AutoWebPub': break;

				/* Print Stuff */
				case 'HeaderFooter': case 'HFPicture': case 'PLV':
				case 'HorizontalPageBreaks': case 'VerticalPageBreaks': break;
				/* Behavioral */
				case 'Backup': case 'CompressPictures': case 'Compat12': break;

				/* Should not Happen */
				case 'Continue': case 'ContinueFrt12': break;

				/* Future Records */
				case 'FrtFontList': case 'FrtWrapper': break;

				default: switch(R.n) { /* nested */
				/* BIFF5 records */
				case 'TabIdConf': case 'Radar': case 'RadarArea': case 'DropBar': case 'Intl': case 'CoordList': case 'SerAuxErrBar': break;

				/* BIFF2-4 records */
				case 'BIFF2FONTCLR': case 'BIFF2FMTCNT': case 'BIFF2FONTXTRA': break;
				case 'BIFF2XF': case 'BIFF3XF': case 'BIFF4XF': break;
				case 'BIFF4FMTCNT': case 'BIFF2ROW': case 'BIFF2WINDOW2': break;

				/* Miscellaneous */
				case 'SCENARIO': case 'DConBin': case 'PicF': case 'DataLabExt':
				case 'Lel': case 'BopPop': case 'BopPopCustom': case 'RealTimeData':
				case 'Name': break;
				case 'LHNGraph': case 'FnGroupName': case 'AddMenu': case 'LPr': break;
				case 'ListObj': case 'ListField': break;
				case 'RRSort': break;
				case 'BigName': break;
				case 'ToolbarHdr': case 'ToolbarEnd': break;
				case 'DDEObjName': break;
				case 'FRTArchId$': break;
				default: if(options.WTF) throw 'Unrecognized Record ' + R.n;
			}}}}
		} else blob.l += length;
	}
	wb.SheetNames=keys(Directory).sort(function(a,b) { return Number(a) - Number(b); }).map(function(x){return Directory[x].name;});
	if(!options.bookSheets) wb.Sheets=Sheets;
	if(wb.Sheets) FilterDatabases.forEach(function(r,i) { wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r; });
	wb.Preamble=Preamble;
	wb.Strings = sst;
	wb.SSF = SSF.get_table();
	if(opts.enc) wb.Encryption = opts.enc;
	if(themes) wb.Themes = themes;
	wb.Metadata = {};
	if(country !== undefined) wb.Metadata.Country = country;
	if(supbooks.names.length > 0) Workbook.Names = supbooks.names;
	wb.Workbook = Workbook;
	return wb;
}

/* TODO: split props*/
var PSCLSID = {
	SI: "e0859ff2f94f6810ab9108002b27b3d9",
	DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
	UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function parse_xls_props(cfb, props, o) {
	/* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */
	var DSI = CFB.find(cfb, '!DocumentSummaryInformation');
	if(DSI && DSI.size > 0) try {
		var DocSummary = parse_PropertySetStream(DSI, DocSummaryPIDDSI, PSCLSID.DSI);
		for(var d in DocSummary) props[d] = DocSummary[d];
	} catch(e) {if(o.WTF) throw e;/* empty */}

	/* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/
	var SI = CFB.find(cfb, '!SummaryInformation');
	if(SI && SI.size > 0) try {
		var Summary = parse_PropertySetStream(SI, SummaryPIDSI, PSCLSID.SI);
		for(var s in Summary) if(props[s] == null) props[s] = Summary[s];
	} catch(e) {if(o.WTF) throw e;/* empty */}

	if(props.HeadingPairs && props.TitlesOfParts) {
		load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
		delete props.HeadingPairs; delete props.TitlesOfParts;
	}
}
function write_xls_props(wb, cfb) {
	var DSEntries = [], SEntries = [], CEntries = [];
	var i = 0, Keys;
	if(wb.Props) {
		Keys = keys(wb.Props);
		// $FlowIgnore
		for(i = 0; i < Keys.length; ++i) (DocSummaryRE.hasOwnProperty(Keys[i]) ? DSEntries : SummaryRE.hasOwnProperty(Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Props[Keys[i]]]);
	}
	if(wb.Custprops) {
		Keys = keys(wb.Custprops);
		// $FlowIgnore
		for(i = 0; i < Keys.length; ++i) if(!(wb.Props||{}).hasOwnProperty(Keys[i])) (DocSummaryRE.hasOwnProperty(Keys[i]) ? DSEntries : SummaryRE.hasOwnProperty(Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Custprops[Keys[i]]]);
	}
	var CEntries2 = [];
	for(i = 0; i < CEntries.length; ++i) {
		if(XLSPSSkip.indexOf(CEntries[i][0]) > -1) continue;
		if(CEntries[i][1] == null) continue;
		CEntries2.push(CEntries[i]);
	}
	if(SEntries.length) CFB.utils.cfb_add(cfb, "/\u0005SummaryInformation", write_PropertySetStream(SEntries, PSCLSID.SI, SummaryRE, SummaryPIDSI));
	if(DSEntries.length || CEntries2.length) CFB.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", write_PropertySetStream(DSEntries, PSCLSID.DSI, DocSummaryRE, DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, PSCLSID.UDI));
}

function parse_xlscfb(cfb, options) {
if(!options) options = {};
fix_read_opts(options);
reset_cp();
if(options.codepage) set_ansi(options.codepage);
var CompObj, WB;
if(cfb.FullPaths) {
	if(CFB.find(cfb, '/encryption')) throw new Error("File is password-protected");
	CompObj = CFB.find(cfb, '!CompObj');
	WB = CFB.find(cfb, '/Workbook') || CFB.find(cfb, '/Book');
} else {
	switch(options.type) {
		case 'base64': cfb = s2a(Base64.decode(cfb)); break;
		case 'binary': cfb = s2a(cfb); break;
		case 'buffer': break;
		case 'array': if(!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb); break;
	}
	prep_blob(cfb, 0);
	WB = ({content: cfb});
}
var WorkbookP;

var _data;
if(CompObj) parse_compobj(CompObj);
if(options.bookProps && !options.bookSheets) WorkbookP = ({});
else {
	var T = has_buf ? 'buffer' : 'array';
	if(WB && WB.content) WorkbookP = parse_workbook(WB.content, options);
	/* Quattro Pro 7-8 */
	else if((_data=CFB.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
	/* Quattro Pro 9 */
	else if((_data=CFB.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
	else throw new Error("Cannot find Workbook stream");
	if(options.bookVBA && cfb.FullPaths && CFB.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = make_vba_xls(cfb);
}

var props = {};
if(cfb.FullPaths) parse_xls_props(cfb, props, options);

WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */
if(options.bookFiles) WorkbookP.cfb = cfb;
/*WorkbookP.CompObjP = CompObjP; // TODO: storage? */
return WorkbookP;
}


function write_xlscfb(wb, opts) {
	var o = opts || {};
	var cfb = CFB.utils.cfb_new({root:"R"});
	var wbpath = "/Workbook";
	switch(o.bookType || "xls") {
		case "xls": o.bookType = "biff8";
		/* falls through */
		case "xla": if(!o.bookType) o.bookType = "xla";
		/* falls through */
		case "biff8": wbpath = "/Workbook"; o.biff = 8; break;
		case "biff5": wbpath = "/Book"; o.biff = 5; break;
		default: throw new Error("invalid type " + o.bookType + " for XLS CFB");
	}
	CFB.utils.cfb_add(cfb, wbpath, write_biff_buf(wb, o));
	if(o.biff == 8 && (wb.Props || wb.Custprops)) write_xls_props(wb, cfb);
	// TODO: SI, DSI, CO
	if(o.biff == 8 && wb.vbaraw) fill_vba_xls(cfb, CFB.read(wb.vbaraw, {type: typeof wb.vbaraw == "string" ? "binary" : "buffer"}));
	return cfb;
}
/* [MS-XLSB] 2.3 Record Enumeration */
var XLSBRecordEnum = {
0x0000: { n:"BrtRowHdr", f:parse_BrtRowHdr },
0x0001: { n:"BrtCellBlank", f:parse_BrtCellBlank },
0x0002: { n:"BrtCellRk", f:parse_BrtCellRk },
0x0003: { n:"BrtCellError", f:parse_BrtCellError },
0x0004: { n:"BrtCellBool", f:parse_BrtCellBool },
0x0005: { n:"BrtCellReal", f:parse_BrtCellReal },
0x0006: { n:"BrtCellSt", f:parse_BrtCellSt },
0x0007: { n:"BrtCellIsst", f:parse_BrtCellIsst },
0x0008: { n:"BrtFmlaString", f:parse_BrtFmlaString },
0x0009: { n:"BrtFmlaNum", f:parse_BrtFmlaNum },
0x000A: { n:"BrtFmlaBool", f:parse_BrtFmlaBool },
0x000B: { n:"BrtFmlaError", f:parse_BrtFmlaError },
0x0010: { n:"BrtFRTArchID$", f:parse_BrtFRTArchID$ },
0x0013: { n:"BrtSSTItem", f:parse_RichStr },
0x0014: { n:"BrtPCDIMissing" },
0x0015: { n:"BrtPCDINumber" },
0x0016: { n:"BrtPCDIBoolean" },
0x0017: { n:"BrtPCDIError" },
0x0018: { n:"BrtPCDIString" },
0x0019: { n:"BrtPCDIDatetime" },
0x001A: { n:"BrtPCDIIndex" },
0x001B: { n:"BrtPCDIAMissing" },
0x001C: { n:"BrtPCDIANumber" },
0x001D: { n:"BrtPCDIABoolean" },
0x001E: { n:"BrtPCDIAError" },
0x001F: { n:"BrtPCDIAString" },
0x0020: { n:"BrtPCDIADatetime" },
0x0021: { n:"BrtPCRRecord" },
0x0022: { n:"BrtPCRRecordDt" },
0x0023: { n:"BrtFRTBegin" },
0x0024: { n:"BrtFRTEnd" },
0x0025: { n:"BrtACBegin" },
0x0026: { n:"BrtACEnd" },
0x0027: { n:"BrtName", f:parse_BrtName },
0x0028: { n:"BrtIndexRowBlock" },
0x002A: { n:"BrtIndexBlock" },
0x002B: { n:"BrtFont", f:parse_BrtFont },
0x002C: { n:"BrtFmt", f:parse_BrtFmt },
0x002D: { n:"BrtFill", f:parse_BrtFill },
0x002E: { n:"BrtBorder", f:parse_BrtBorder },
0x002F: { n:"BrtXF", f:parse_BrtXF },
0x0030: { n:"BrtStyle" },
0x0031: { n:"BrtCellMeta" },
0x0032: { n:"BrtValueMeta" },
0x0033: { n:"BrtMdb" },
0x0034: { n:"BrtBeginFmd" },
0x0035: { n:"BrtEndFmd" },
0x0036: { n:"BrtBeginMdx" },
0x0037: { n:"BrtEndMdx" },
0x0038: { n:"BrtBeginMdxTuple" },
0x0039: { n:"BrtEndMdxTuple" },
0x003A: { n:"BrtMdxMbrIstr" },
0x003B: { n:"BrtStr" },
0x003C: { n:"BrtColInfo", f:parse_ColInfo },
0x003E: { n:"BrtCellRString" },
0x003F: { n:"BrtCalcChainItem$", f:parse_BrtCalcChainItem$ },
0x0040: { n:"BrtDVal" },
0x0041: { n:"BrtSxvcellNum" },
0x0042: { n:"BrtSxvcellStr" },
0x0043: { n:"BrtSxvcellBool" },
0x0044: { n:"BrtSxvcellErr" },
0x0045: { n:"BrtSxvcellDate" },
0x0046: { n:"BrtSxvcellNil" },
0x0080: { n:"BrtFileVersion" },
0x0081: { n:"BrtBeginSheet" },
0x0082: { n:"BrtEndSheet" },
0x0083: { n:"BrtBeginBook", f:parsenoop, p:0 },
0x0084: { n:"BrtEndBook" },
0x0085: { n:"BrtBeginWsViews" },
0x0086: { n:"BrtEndWsViews" },
0x0087: { n:"BrtBeginBookViews" },
0x0088: { n:"BrtEndBookViews" },
0x0089: { n:"BrtBeginWsView", f:parse_BrtBeginWsView },
0x008A: { n:"BrtEndWsView" },
0x008B: { n:"BrtBeginCsViews" },
0x008C: { n:"BrtEndCsViews" },
0x008D: { n:"BrtBeginCsView" },
0x008E: { n:"BrtEndCsView" },
0x008F: { n:"BrtBeginBundleShs" },
0x0090: { n:"BrtEndBundleShs" },
0x0091: { n:"BrtBeginSheetData" },
0x0092: { n:"BrtEndSheetData" },
0x0093: { n:"BrtWsProp", f:parse_BrtWsProp },
0x0094: { n:"BrtWsDim", f:parse_BrtWsDim, p:16 },
0x0097: { n:"BrtPane" },
0x0098: { n:"BrtSel" },
0x0099: { n:"BrtWbProp", f:parse_BrtWbProp },
0x009A: { n:"BrtWbFactoid" },
0x009B: { n:"BrtFileRecover" },
0x009C: { n:"BrtBundleSh", f:parse_BrtBundleSh },
0x009D: { n:"BrtCalcProp" },
0x009E: { n:"BrtBookView" },
0x009F: { n:"BrtBeginSst", f:parse_BrtBeginSst },
0x00A0: { n:"BrtEndSst" },
0x00A1: { n:"BrtBeginAFilter", f:parse_UncheckedRfX },
0x00A2: { n:"BrtEndAFilter" },
0x00A3: { n:"BrtBeginFilterColumn" },
0x00A4: { n:"BrtEndFilterColumn" },
0x00A5: { n:"BrtBeginFilters" },
0x00A6: { n:"BrtEndFilters" },
0x00A7: { n:"BrtFilter" },
0x00A8: { n:"BrtColorFilter" },
0x00A9: { n:"BrtIconFilter" },
0x00AA: { n:"BrtTop10Filter" },
0x00AB: { n:"BrtDynamicFilter" },
0x00AC: { n:"BrtBeginCustomFilters" },
0x00AD: { n:"BrtEndCustomFilters" },
0x00AE: { n:"BrtCustomFilter" },
0x00AF: { n:"BrtAFilterDateGroupItem" },
0x00B0: { n:"BrtMergeCell", f:parse_BrtMergeCell },
0x00B1: { n:"BrtBeginMergeCells" },
0x00B2: { n:"BrtEndMergeCells" },
0x00B3: { n:"BrtBeginPivotCacheDef" },
0x00B4: { n:"BrtEndPivotCacheDef" },
0x00B5: { n:"BrtBeginPCDFields" },
0x00B6: { n:"BrtEndPCDFields" },
0x00B7: { n:"BrtBeginPCDField" },
0x00B8: { n:"BrtEndPCDField" },
0x00B9: { n:"BrtBeginPCDSource" },
0x00BA: { n:"BrtEndPCDSource" },
0x00BB: { n:"BrtBeginPCDSRange" },
0x00BC: { n:"BrtEndPCDSRange" },
0x00BD: { n:"BrtBeginPCDFAtbl" },
0x00BE: { n:"BrtEndPCDFAtbl" },
0x00BF: { n:"BrtBeginPCDIRun" },
0x00C0: { n:"BrtEndPCDIRun" },
0x00C1: { n:"BrtBeginPivotCacheRecords" },
0x00C2: { n:"BrtEndPivotCacheRecords" },
0x00C3: { n:"BrtBeginPCDHierarchies" },
0x00C4: { n:"BrtEndPCDHierarchies" },
0x00C5: { n:"BrtBeginPCDHierarchy" },
0x00C6: { n:"BrtEndPCDHierarchy" },
0x00C7: { n:"BrtBeginPCDHFieldsUsage" },
0x00C8: { n:"BrtEndPCDHFieldsUsage" },
0x00C9: { n:"BrtBeginExtConnection" },
0x00CA: { n:"BrtEndExtConnection" },
0x00CB: { n:"BrtBeginECDbProps" },
0x00CC: { n:"BrtEndECDbProps" },
0x00CD: { n:"BrtBeginECOlapProps" },
0x00CE: { n:"BrtEndECOlapProps" },
0x00CF: { n:"BrtBeginPCDSConsol" },
0x00D0: { n:"BrtEndPCDSConsol" },
0x00D1: { n:"BrtBeginPCDSCPages" },
0x00D2: { n:"BrtEndPCDSCPages" },
0x00D3: { n:"BrtBeginPCDSCPage" },
0x00D4: { n:"BrtEndPCDSCPage" },
0x00D5: { n:"BrtBeginPCDSCPItem" },
0x00D6: { n:"BrtEndPCDSCPItem" },
0x00D7: { n:"BrtBeginPCDSCSets" },
0x00D8: { n:"BrtEndPCDSCSets" },
0x00D9: { n:"BrtBeginPCDSCSet" },
0x00DA: { n:"BrtEndPCDSCSet" },
0x00DB: { n:"BrtBeginPCDFGroup" },
0x00DC: { n:"BrtEndPCDFGroup" },
0x00DD: { n:"BrtBeginPCDFGItems" },
0x00DE: { n:"BrtEndPCDFGItems" },
0x00DF: { n:"BrtBeginPCDFGRange" },
0x00E0: { n:"BrtEndPCDFGRange" },
0x00E1: { n:"BrtBeginPCDFGDiscrete" },
0x00E2: { n:"BrtEndPCDFGDiscrete" },
0x00E3: { n:"BrtBeginPCDSDTupleCache" },
0x00E4: { n:"BrtEndPCDSDTupleCache" },
0x00E5: { n:"BrtBeginPCDSDTCEntries" },
0x00E6: { n:"BrtEndPCDSDTCEntries" },
0x00E7: { n:"BrtBeginPCDSDTCEMembers" },
0x00E8: { n:"BrtEndPCDSDTCEMembers" },
0x00E9: { n:"BrtBeginPCDSDTCEMember" },
0x00EA: { n:"BrtEndPCDSDTCEMember" },
0x00EB: { n:"BrtBeginPCDSDTCQueries" },
0x00EC: { n:"BrtEndPCDSDTCQueries" },
0x00ED: { n:"BrtBeginPCDSDTCQuery" },
0x00EE: { n:"BrtEndPCDSDTCQuery" },
0x00EF: { n:"BrtBeginPCDSDTCSets" },
0x00F0: { n:"BrtEndPCDSDTCSets" },
0x00F1: { n:"BrtBeginPCDSDTCSet" },
0x00F2: { n:"BrtEndPCDSDTCSet" },
0x00F3: { n:"BrtBeginPCDCalcItems" },
0x00F4: { n:"BrtEndPCDCalcItems" },
0x00F5: { n:"BrtBeginPCDCalcItem" },
0x00F6: { n:"BrtEndPCDCalcItem" },
0x00F7: { n:"BrtBeginPRule" },
0x00F8: { n:"BrtEndPRule" },
0x00F9: { n:"BrtBeginPRFilters" },
0x00FA: { n:"BrtEndPRFilters" },
0x00FB: { n:"BrtBeginPRFilter" },
0x00FC: { n:"BrtEndPRFilter" },
0x00FD: { n:"BrtBeginPNames" },
0x00FE: { n:"BrtEndPNames" },
0x00FF: { n:"BrtBeginPName" },
0x0100: { n:"BrtEndPName" },
0x0101: { n:"BrtBeginPNPairs" },
0x0102: { n:"BrtEndPNPairs" },
0x0103: { n:"BrtBeginPNPair" },
0x0104: { n:"BrtEndPNPair" },
0x0105: { n:"BrtBeginECWebProps" },
0x0106: { n:"BrtEndECWebProps" },
0x0107: { n:"BrtBeginEcWpTables" },
0x0108: { n:"BrtEndECWPTables" },
0x0109: { n:"BrtBeginECParams" },
0x010A: { n:"BrtEndECParams" },
0x010B: { n:"BrtBeginECParam" },
0x010C: { n:"BrtEndECParam" },
0x010D: { n:"BrtBeginPCDKPIs" },
0x010E: { n:"BrtEndPCDKPIs" },
0x010F: { n:"BrtBeginPCDKPI" },
0x0110: { n:"BrtEndPCDKPI" },
0x0111: { n:"BrtBeginDims" },
0x0112: { n:"BrtEndDims" },
0x0113: { n:"BrtBeginDim" },
0x0114: { n:"BrtEndDim" },
0x0115: { n:"BrtIndexPartEnd" },
0x0116: { n:"BrtBeginStyleSheet" },
0x0117: { n:"BrtEndStyleSheet" },
0x0118: { n:"BrtBeginSXView" },
0x0119: { n:"BrtEndSXVI" },
0x011A: { n:"BrtBeginSXVI" },
0x011B: { n:"BrtBeginSXVIs" },
0x011C: { n:"BrtEndSXVIs" },
0x011D: { n:"BrtBeginSXVD" },
0x011E: { n:"BrtEndSXVD" },
0x011F: { n:"BrtBeginSXVDs" },
0x0120: { n:"BrtEndSXVDs" },
0x0121: { n:"BrtBeginSXPI" },
0x0122: { n:"BrtEndSXPI" },
0x0123: { n:"BrtBeginSXPIs" },
0x0124: { n:"BrtEndSXPIs" },
0x0125: { n:"BrtBeginSXDI" },
0x0126: { n:"BrtEndSXDI" },
0x0127: { n:"BrtBeginSXDIs" },
0x0128: { n:"BrtEndSXDIs" },
0x0129: { n:"BrtBeginSXLI" },
0x012A: { n:"BrtEndSXLI" },
0x012B: { n:"BrtBeginSXLIRws" },
0x012C: { n:"BrtEndSXLIRws" },
0x012D: { n:"BrtBeginSXLICols" },
0x012E: { n:"BrtEndSXLICols" },
0x012F: { n:"BrtBeginSXFormat" },
0x0130: { n:"BrtEndSXFormat" },
0x0131: { n:"BrtBeginSXFormats" },
0x0132: { n:"BrtEndSxFormats" },
0x0133: { n:"BrtBeginSxSelect" },
0x0134: { n:"BrtEndSxSelect" },
0x0135: { n:"BrtBeginISXVDRws" },
0x0136: { n:"BrtEndISXVDRws" },
0x0137: { n:"BrtBeginISXVDCols" },
0x0138: { n:"BrtEndISXVDCols" },
0x0139: { n:"BrtEndSXLocation" },
0x013A: { n:"BrtBeginSXLocation" },
0x013B: { n:"BrtEndSXView" },
0x013C: { n:"BrtBeginSXTHs" },
0x013D: { n:"BrtEndSXTHs" },
0x013E: { n:"BrtBeginSXTH" },
0x013F: { n:"BrtEndSXTH" },
0x0140: { n:"BrtBeginISXTHRws" },
0x0141: { n:"BrtEndISXTHRws" },
0x0142: { n:"BrtBeginISXTHCols" },
0x0143: { n:"BrtEndISXTHCols" },
0x0144: { n:"BrtBeginSXTDMPS" },
0x0145: { n:"BrtEndSXTDMPs" },
0x0146: { n:"BrtBeginSXTDMP" },
0x0147: { n:"BrtEndSXTDMP" },
0x0148: { n:"BrtBeginSXTHItems" },
0x0149: { n:"BrtEndSXTHItems" },
0x014A: { n:"BrtBeginSXTHItem" },
0x014B: { n:"BrtEndSXTHItem" },
0x014C: { n:"BrtBeginMetadata" },
0x014D: { n:"BrtEndMetadata" },
0x014E: { n:"BrtBeginEsmdtinfo" },
0x014F: { n:"BrtMdtinfo" },
0x0150: { n:"BrtEndEsmdtinfo" },
0x0151: { n:"BrtBeginEsmdb" },
0x0152: { n:"BrtEndEsmdb" },
0x0153: { n:"BrtBeginEsfmd" },
0x0154: { n:"BrtEndEsfmd" },
0x0155: { n:"BrtBeginSingleCells" },
0x0156: { n:"BrtEndSingleCells" },
0x0157: { n:"BrtBeginList" },
0x0158: { n:"BrtEndList" },
0x0159: { n:"BrtBeginListCols" },
0x015A: { n:"BrtEndListCols" },
0x015B: { n:"BrtBeginListCol" },
0x015C: { n:"BrtEndListCol" },
0x015D: { n:"BrtBeginListXmlCPr" },
0x015E: { n:"BrtEndListXmlCPr" },
0x015F: { n:"BrtListCCFmla" },
0x0160: { n:"BrtListTrFmla" },
0x0161: { n:"BrtBeginExternals" },
0x0162: { n:"BrtEndExternals" },
0x0163: { n:"BrtSupBookSrc", f:parse_RelID},
0x0165: { n:"BrtSupSelf" },
0x0166: { n:"BrtSupSame" },
0x0167: { n:"BrtSupTabs" },
0x0168: { n:"BrtBeginSupBook" },
0x0169: { n:"BrtPlaceholderName" },
0x016A: { n:"BrtExternSheet", f:parse_ExternSheet },
0x016B: { n:"BrtExternTableStart" },
0x016C: { n:"BrtExternTableEnd" },
0x016E: { n:"BrtExternRowHdr" },
0x016F: { n:"BrtExternCellBlank" },
0x0170: { n:"BrtExternCellReal" },
0x0171: { n:"BrtExternCellBool" },
0x0172: { n:"BrtExternCellError" },
0x0173: { n:"BrtExternCellString" },
0x0174: { n:"BrtBeginEsmdx" },
0x0175: { n:"BrtEndEsmdx" },
0x0176: { n:"BrtBeginMdxSet" },
0x0177: { n:"BrtEndMdxSet" },
0x0178: { n:"BrtBeginMdxMbrProp" },
0x0179: { n:"BrtEndMdxMbrProp" },
0x017A: { n:"BrtBeginMdxKPI" },
0x017B: { n:"BrtEndMdxKPI" },
0x017C: { n:"BrtBeginEsstr" },
0x017D: { n:"BrtEndEsstr" },
0x017E: { n:"BrtBeginPRFItem" },
0x017F: { n:"BrtEndPRFItem" },
0x0180: { n:"BrtBeginPivotCacheIDs" },
0x0181: { n:"BrtEndPivotCacheIDs" },
0x0182: { n:"BrtBeginPivotCacheID" },
0x0183: { n:"BrtEndPivotCacheID" },
0x0184: { n:"BrtBeginISXVIs" },
0x0185: { n:"BrtEndISXVIs" },
0x0186: { n:"BrtBeginColInfos" },
0x0187: { n:"BrtEndColInfos" },
0x0188: { n:"BrtBeginRwBrk" },
0x0189: { n:"BrtEndRwBrk" },
0x018A: { n:"BrtBeginColBrk" },
0x018B: { n:"BrtEndColBrk" },
0x018C: { n:"BrtBrk" },
0x018D: { n:"BrtUserBookView" },
0x018E: { n:"BrtInfo" },
0x018F: { n:"BrtCUsr" },
0x0190: { n:"BrtUsr" },
0x0191: { n:"BrtBeginUsers" },
0x0193: { n:"BrtEOF" },
0x0194: { n:"BrtUCR" },
0x0195: { n:"BrtRRInsDel" },
0x0196: { n:"BrtRREndInsDel" },
0x0197: { n:"BrtRRMove" },
0x0198: { n:"BrtRREndMove" },
0x0199: { n:"BrtRRChgCell" },
0x019A: { n:"BrtRREndChgCell" },
0x019B: { n:"BrtRRHeader" },
0x019C: { n:"BrtRRUserView" },
0x019D: { n:"BrtRRRenSheet" },
0x019E: { n:"BrtRRInsertSh" },
0x019F: { n:"BrtRRDefName" },
0x01A0: { n:"BrtRRNote" },
0x01A1: { n:"BrtRRConflict" },
0x01A2: { n:"BrtRRTQSIF" },
0x01A3: { n:"BrtRRFormat" },
0x01A4: { n:"BrtRREndFormat" },
0x01A5: { n:"BrtRRAutoFmt" },
0x01A6: { n:"BrtBeginUserShViews" },
0x01A7: { n:"BrtBeginUserShView" },
0x01A8: { n:"BrtEndUserShView" },
0x01A9: { n:"BrtEndUserShViews" },
0x01AA: { n:"BrtArrFmla", f:parse_BrtArrFmla },
0x01AB: { n:"BrtShrFmla", f:parse_BrtShrFmla },
0x01AC: { n:"BrtTable" },
0x01AD: { n:"BrtBeginExtConnections" },
0x01AE: { n:"BrtEndExtConnections" },
0x01AF: { n:"BrtBeginPCDCalcMems" },
0x01B0: { n:"BrtEndPCDCalcMems" },
0x01B1: { n:"BrtBeginPCDCalcMem" },
0x01B2: { n:"BrtEndPCDCalcMem" },
0x01B3: { n:"BrtBeginPCDHGLevels" },
0x01B4: { n:"BrtEndPCDHGLevels" },
0x01B5: { n:"BrtBeginPCDHGLevel" },
0x01B6: { n:"BrtEndPCDHGLevel" },
0x01B7: { n:"BrtBeginPCDHGLGroups" },
0x01B8: { n:"BrtEndPCDHGLGroups" },
0x01B9: { n:"BrtBeginPCDHGLGroup" },
0x01BA: { n:"BrtEndPCDHGLGroup" },
0x01BB: { n:"BrtBeginPCDHGLGMembers" },
0x01BC: { n:"BrtEndPCDHGLGMembers" },
0x01BD: { n:"BrtBeginPCDHGLGMember" },
0x01BE: { n:"BrtEndPCDHGLGMember" },
0x01BF: { n:"BrtBeginQSI" },
0x01C0: { n:"BrtEndQSI" },
0x01C1: { n:"BrtBeginQSIR" },
0x01C2: { n:"BrtEndQSIR" },
0x01C3: { n:"BrtBeginDeletedNames" },
0x01C4: { n:"BrtEndDeletedNames" },
0x01C5: { n:"BrtBeginDeletedName" },
0x01C6: { n:"BrtEndDeletedName" },
0x01C7: { n:"BrtBeginQSIFs" },
0x01C8: { n:"BrtEndQSIFs" },
0x01C9: { n:"BrtBeginQSIF" },
0x01CA: { n:"BrtEndQSIF" },
0x01CB: { n:"BrtBeginAutoSortScope" },
0x01CC: { n:"BrtEndAutoSortScope" },
0x01CD: { n:"BrtBeginConditionalFormatting" },
0x01CE: { n:"BrtEndConditionalFormatting" },
0x01CF: { n:"BrtBeginCFRule" },
0x01D0: { n:"BrtEndCFRule" },
0x01D1: { n:"BrtBeginIconSet" },
0x01D2: { n:"BrtEndIconSet" },
0x01D3: { n:"BrtBeginDatabar" },
0x01D4: { n:"BrtEndDatabar" },
0x01D5: { n:"BrtBeginColorScale" },
0x01D6: { n:"BrtEndColorScale" },
0x01D7: { n:"BrtCFVO" },
0x01D8: { n:"BrtExternValueMeta" },
0x01D9: { n:"BrtBeginColorPalette" },
0x01DA: { n:"BrtEndColorPalette" },
0x01DB: { n:"BrtIndexedColor" },
0x01DC: { n:"BrtMargins", f:parse_BrtMargins },
0x01DD: { n:"BrtPrintOptions" },
0x01DE: { n:"BrtPageSetup" },
0x01DF: { n:"BrtBeginHeaderFooter" },
0x01E0: { n:"BrtEndHeaderFooter" },
0x01E1: { n:"BrtBeginSXCrtFormat" },
0x01E2: { n:"BrtEndSXCrtFormat" },
0x01E3: { n:"BrtBeginSXCrtFormats" },
0x01E4: { n:"BrtEndSXCrtFormats" },
0x01E5: { n:"BrtWsFmtInfo", f:parse_BrtWsFmtInfo },
0x01E6: { n:"BrtBeginMgs" },
0x01E7: { n:"BrtEndMGs" },
0x01E8: { n:"BrtBeginMGMaps" },
0x01E9: { n:"BrtEndMGMaps" },
0x01EA: { n:"BrtBeginMG" },
0x01EB: { n:"BrtEndMG" },
0x01EC: { n:"BrtBeginMap" },
0x01ED: { n:"BrtEndMap" },
0x01EE: { n:"BrtHLink", f:parse_BrtHLink },
0x01EF: { n:"BrtBeginDCon" },
0x01F0: { n:"BrtEndDCon" },
0x01F1: { n:"BrtBeginDRefs" },
0x01F2: { n:"BrtEndDRefs" },
0x01F3: { n:"BrtDRef" },
0x01F4: { n:"BrtBeginScenMan" },
0x01F5: { n:"BrtEndScenMan" },
0x01F6: { n:"BrtBeginSct" },
0x01F7: { n:"BrtEndSct" },
0x01F8: { n:"BrtSlc" },
0x01F9: { n:"BrtBeginDXFs" },
0x01FA: { n:"BrtEndDXFs" },
0x01FB: { n:"BrtDXF" },
0x01FC: { n:"BrtBeginTableStyles" },
0x01FD: { n:"BrtEndTableStyles" },
0x01FE: { n:"BrtBeginTableStyle" },
0x01FF: { n:"BrtEndTableStyle" },
0x0200: { n:"BrtTableStyleElement" },
0x0201: { n:"BrtTableStyleClient" },
0x0202: { n:"BrtBeginVolDeps" },
0x0203: { n:"BrtEndVolDeps" },
0x0204: { n:"BrtBeginVolType" },
0x0205: { n:"BrtEndVolType" },
0x0206: { n:"BrtBeginVolMain" },
0x0207: { n:"BrtEndVolMain" },
0x0208: { n:"BrtBeginVolTopic" },
0x0209: { n:"BrtEndVolTopic" },
0x020A: { n:"BrtVolSubtopic" },
0x020B: { n:"BrtVolRef" },
0x020C: { n:"BrtVolNum" },
0x020D: { n:"BrtVolErr" },
0x020E: { n:"BrtVolStr" },
0x020F: { n:"BrtVolBool" },
0x0210: { n:"BrtBeginCalcChain$" },
0x0211: { n:"BrtEndCalcChain$" },
0x0212: { n:"BrtBeginSortState" },
0x0213: { n:"BrtEndSortState" },
0x0214: { n:"BrtBeginSortCond" },
0x0215: { n:"BrtEndSortCond" },
0x0216: { n:"BrtBookProtection" },
0x0217: { n:"BrtSheetProtection" },
0x0218: { n:"BrtRangeProtection" },
0x0219: { n:"BrtPhoneticInfo" },
0x021A: { n:"BrtBeginECTxtWiz" },
0x021B: { n:"BrtEndECTxtWiz" },
0x021C: { n:"BrtBeginECTWFldInfoLst" },
0x021D: { n:"BrtEndECTWFldInfoLst" },
0x021E: { n:"BrtBeginECTwFldInfo" },
0x0224: { n:"BrtFileSharing" },
0x0225: { n:"BrtOleSize" },
0x0226: { n:"BrtDrawing", f:parse_RelID },
0x0227: { n:"BrtLegacyDrawing" },
0x0228: { n:"BrtLegacyDrawingHF" },
0x0229: { n:"BrtWebOpt" },
0x022A: { n:"BrtBeginWebPubItems" },
0x022B: { n:"BrtEndWebPubItems" },
0x022C: { n:"BrtBeginWebPubItem" },
0x022D: { n:"BrtEndWebPubItem" },
0x022E: { n:"BrtBeginSXCondFmt" },
0x022F: { n:"BrtEndSXCondFmt" },
0x0230: { n:"BrtBeginSXCondFmts" },
0x0231: { n:"BrtEndSXCondFmts" },
0x0232: { n:"BrtBkHim" },
0x0234: { n:"BrtColor" },
0x0235: { n:"BrtBeginIndexedColors" },
0x0236: { n:"BrtEndIndexedColors" },
0x0239: { n:"BrtBeginMRUColors" },
0x023A: { n:"BrtEndMRUColors" },
0x023C: { n:"BrtMRUColor" },
0x023D: { n:"BrtBeginDVals" },
0x023E: { n:"BrtEndDVals" },
0x0241: { n:"BrtSupNameStart" },
0x0242: { n:"BrtSupNameValueStart" },
0x0243: { n:"BrtSupNameValueEnd" },
0x0244: { n:"BrtSupNameNum" },
0x0245: { n:"BrtSupNameErr" },
0x0246: { n:"BrtSupNameSt" },
0x0247: { n:"BrtSupNameNil" },
0x0248: { n:"BrtSupNameBool" },
0x0249: { n:"BrtSupNameFmla" },
0x024A: { n:"BrtSupNameBits" },
0x024B: { n:"BrtSupNameEnd" },
0x024C: { n:"BrtEndSupBook" },
0x024D: { n:"BrtCellSmartTagProperty" },
0x024E: { n:"BrtBeginCellSmartTag" },
0x024F: { n:"BrtEndCellSmartTag" },
0x0250: { n:"BrtBeginCellSmartTags" },
0x0251: { n:"BrtEndCellSmartTags" },
0x0252: { n:"BrtBeginSmartTags" },
0x0253: { n:"BrtEndSmartTags" },
0x0254: { n:"BrtSmartTagType" },
0x0255: { n:"BrtBeginSmartTagTypes" },
0x0256: { n:"BrtEndSmartTagTypes" },
0x0257: { n:"BrtBeginSXFilters" },
0x0258: { n:"BrtEndSXFilters" },
0x0259: { n:"BrtBeginSXFILTER" },
0x025A: { n:"BrtEndSXFilter" },
0x025B: { n:"BrtBeginFills" },
0x025C: { n:"BrtEndFills" },
0x025D: { n:"BrtBeginCellWatches" },
0x025E: { n:"BrtEndCellWatches" },
0x025F: { n:"BrtCellWatch" },
0x0260: { n:"BrtBeginCRErrs" },
0x0261: { n:"BrtEndCRErrs" },
0x0262: { n:"BrtCrashRecErr" },
0x0263: { n:"BrtBeginFonts" },
0x0264: { n:"BrtEndFonts" },
0x0265: { n:"BrtBeginBorders" },
0x0266: { n:"BrtEndBorders" },
0x0267: { n:"BrtBeginFmts" },
0x0268: { n:"BrtEndFmts" },
0x0269: { n:"BrtBeginCellXFs" },
0x026A: { n:"BrtEndCellXFs" },
0x026B: { n:"BrtBeginStyles" },
0x026C: { n:"BrtEndStyles" },
0x0271: { n:"BrtBigName" },
0x0272: { n:"BrtBeginCellStyleXFs" },
0x0273: { n:"BrtEndCellStyleXFs" },
0x0274: { n:"BrtBeginComments" },
0x0275: { n:"BrtEndComments" },
0x0276: { n:"BrtBeginCommentAuthors" },
0x0277: { n:"BrtEndCommentAuthors" },
0x0278: { n:"BrtCommentAuthor", f:parse_BrtCommentAuthor },
0x0279: { n:"BrtBeginCommentList" },
0x027A: { n:"BrtEndCommentList" },
0x027B: { n:"BrtBeginComment", f:parse_BrtBeginComment},
0x027C: { n:"BrtEndComment" },
0x027D: { n:"BrtCommentText", f:parse_BrtCommentText },
0x027E: { n:"BrtBeginOleObjects" },
0x027F: { n:"BrtOleObject" },
0x0280: { n:"BrtEndOleObjects" },
0x0281: { n:"BrtBeginSxrules" },
0x0282: { n:"BrtEndSxRules" },
0x0283: { n:"BrtBeginActiveXControls" },
0x0284: { n:"BrtActiveX" },
0x0285: { n:"BrtEndActiveXControls" },
0x0286: { n:"BrtBeginPCDSDTCEMembersSortBy" },
0x0288: { n:"BrtBeginCellIgnoreECs" },
0x0289: { n:"BrtCellIgnoreEC" },
0x028A: { n:"BrtEndCellIgnoreECs" },
0x028B: { n:"BrtCsProp", f:parse_BrtCsProp },
0x028C: { n:"BrtCsPageSetup" },
0x028D: { n:"BrtBeginUserCsViews" },
0x028E: { n:"BrtEndUserCsViews" },
0x028F: { n:"BrtBeginUserCsView" },
0x0290: { n:"BrtEndUserCsView" },
0x0291: { n:"BrtBeginPcdSFCIEntries" },
0x0292: { n:"BrtEndPCDSFCIEntries" },
0x0293: { n:"BrtPCDSFCIEntry" },
0x0294: { n:"BrtBeginListParts" },
0x0295: { n:"BrtListPart" },
0x0296: { n:"BrtEndListParts" },
0x0297: { n:"BrtSheetCalcProp" },
0x0298: { n:"BrtBeginFnGroup" },
0x0299: { n:"BrtFnGroup" },
0x029A: { n:"BrtEndFnGroup" },
0x029B: { n:"BrtSupAddin" },
0x029C: { n:"BrtSXTDMPOrder" },
0x029D: { n:"BrtCsProtection" },
0x029F: { n:"BrtBeginWsSortMap" },
0x02A0: { n:"BrtEndWsSortMap" },
0x02A1: { n:"BrtBeginRRSort" },
0x02A2: { n:"BrtEndRRSort" },
0x02A3: { n:"BrtRRSortItem" },
0x02A4: { n:"BrtFileSharingIso" },
0x02A5: { n:"BrtBookProtectionIso" },
0x02A6: { n:"BrtSheetProtectionIso" },
0x02A7: { n:"BrtCsProtectionIso" },
0x02A8: { n:"BrtRangeProtectionIso" },
0x0400: { n:"BrtRwDescent" },
0x0401: { n:"BrtKnownFonts" },
0x0402: { n:"BrtBeginSXTupleSet" },
0x0403: { n:"BrtEndSXTupleSet" },
0x0404: { n:"BrtBeginSXTupleSetHeader" },
0x0405: { n:"BrtEndSXTupleSetHeader" },
0x0406: { n:"BrtSXTupleSetHeaderItem" },
0x0407: { n:"BrtBeginSXTupleSetData" },
0x0408: { n:"BrtEndSXTupleSetData" },
0x0409: { n:"BrtBeginSXTupleSetRow" },
0x040A: { n:"BrtEndSXTupleSetRow" },
0x040B: { n:"BrtSXTupleSetRowItem" },
0x040C: { n:"BrtNameExt" },
0x040D: { n:"BrtPCDH14" },
0x040E: { n:"BrtBeginPCDCalcMem14" },
0x040F: { n:"BrtEndPCDCalcMem14" },
0x0410: { n:"BrtSXTH14" },
0x0411: { n:"BrtBeginSparklineGroup" },
0x0412: { n:"BrtEndSparklineGroup" },
0x0413: { n:"BrtSparkline" },
0x0414: { n:"BrtSXDI14" },
0x0415: { n:"BrtWsFmtInfoEx14" },
0x0416: { n:"BrtBeginConditionalFormatting14" },
0x0417: { n:"BrtEndConditionalFormatting14" },
0x0418: { n:"BrtBeginCFRule14" },
0x0419: { n:"BrtEndCFRule14" },
0x041A: { n:"BrtCFVO14" },
0x041B: { n:"BrtBeginDatabar14" },
0x041C: { n:"BrtBeginIconSet14" },
0x041D: { n:"BrtDVal14" },
0x041E: { n:"BrtBeginDVals14" },
0x041F: { n:"BrtColor14" },
0x0420: { n:"BrtBeginSparklines" },
0x0421: { n:"BrtEndSparklines" },
0x0422: { n:"BrtBeginSparklineGroups" },
0x0423: { n:"BrtEndSparklineGroups" },
0x0425: { n:"BrtSXVD14" },
0x0426: { n:"BrtBeginSXView14" },
0x0427: { n:"BrtEndSXView14" },
0x0428: { n:"BrtBeginSXView16" },
0x0429: { n:"BrtEndSXView16" },
0x042A: { n:"BrtBeginPCD14" },
0x042B: { n:"BrtEndPCD14" },
0x042C: { n:"BrtBeginExtConn14" },
0x042D: { n:"BrtEndExtConn14" },
0x042E: { n:"BrtBeginSlicerCacheIDs" },
0x042F: { n:"BrtEndSlicerCacheIDs" },
0x0430: { n:"BrtBeginSlicerCacheID" },
0x0431: { n:"BrtEndSlicerCacheID" },
0x0433: { n:"BrtBeginSlicerCache" },
0x0434: { n:"BrtEndSlicerCache" },
0x0435: { n:"BrtBeginSlicerCacheDef" },
0x0436: { n:"BrtEndSlicerCacheDef" },
0x0437: { n:"BrtBeginSlicersEx" },
0x0438: { n:"BrtEndSlicersEx" },
0x0439: { n:"BrtBeginSlicerEx" },
0x043A: { n:"BrtEndSlicerEx" },
0x043B: { n:"BrtBeginSlicer" },
0x043C: { n:"BrtEndSlicer" },
0x043D: { n:"BrtSlicerCachePivotTables" },
0x043E: { n:"BrtBeginSlicerCacheOlapImpl" },
0x043F: { n:"BrtEndSlicerCacheOlapImpl" },
0x0440: { n:"BrtBeginSlicerCacheLevelsData" },
0x0441: { n:"BrtEndSlicerCacheLevelsData" },
0x0442: { n:"BrtBeginSlicerCacheLevelData" },
0x0443: { n:"BrtEndSlicerCacheLevelData" },
0x0444: { n:"BrtBeginSlicerCacheSiRanges" },
0x0445: { n:"BrtEndSlicerCacheSiRanges" },
0x0446: { n:"BrtBeginSlicerCacheSiRange" },
0x0447: { n:"BrtEndSlicerCacheSiRange" },
0x0448: { n:"BrtSlicerCacheOlapItem" },
0x0449: { n:"BrtBeginSlicerCacheSelections" },
0x044A: { n:"BrtSlicerCacheSelection" },
0x044B: { n:"BrtEndSlicerCacheSelections" },
0x044C: { n:"BrtBeginSlicerCacheNative" },
0x044D: { n:"BrtEndSlicerCacheNative" },
0x044E: { n:"BrtSlicerCacheNativeItem" },
0x044F: { n:"BrtRangeProtection14" },
0x0450: { n:"BrtRangeProtectionIso14" },
0x0451: { n:"BrtCellIgnoreEC14" },
0x0457: { n:"BrtList14" },
0x0458: { n:"BrtCFIcon" },
0x0459: { n:"BrtBeginSlicerCachesPivotCacheIDs" },
0x045A: { n:"BrtEndSlicerCachesPivotCacheIDs" },
0x045B: { n:"BrtBeginSlicers" },
0x045C: { n:"BrtEndSlicers" },
0x045D: { n:"BrtWbProp14" },
0x045E: { n:"BrtBeginSXEdit" },
0x045F: { n:"BrtEndSXEdit" },
0x0460: { n:"BrtBeginSXEdits" },
0x0461: { n:"BrtEndSXEdits" },
0x0462: { n:"BrtBeginSXChange" },
0x0463: { n:"BrtEndSXChange" },
0x0464: { n:"BrtBeginSXChanges" },
0x0465: { n:"BrtEndSXChanges" },
0x0466: { n:"BrtSXTupleItems" },
0x0468: { n:"BrtBeginSlicerStyle" },
0x0469: { n:"BrtEndSlicerStyle" },
0x046A: { n:"BrtSlicerStyleElement" },
0x046B: { n:"BrtBeginStyleSheetExt14" },
0x046C: { n:"BrtEndStyleSheetExt14" },
0x046D: { n:"BrtBeginSlicerCachesPivotCacheID" },
0x046E: { n:"BrtEndSlicerCachesPivotCacheID" },
0x046F: { n:"BrtBeginConditionalFormattings" },
0x0470: { n:"BrtEndConditionalFormattings" },
0x0471: { n:"BrtBeginPCDCalcMemExt" },
0x0472: { n:"BrtEndPCDCalcMemExt" },
0x0473: { n:"BrtBeginPCDCalcMemsExt" },
0x0474: { n:"BrtEndPCDCalcMemsExt" },
0x0475: { n:"BrtPCDField14" },
0x0476: { n:"BrtBeginSlicerStyles" },
0x0477: { n:"BrtEndSlicerStyles" },
0x0478: { n:"BrtBeginSlicerStyleElements" },
0x0479: { n:"BrtEndSlicerStyleElements" },
0x047A: { n:"BrtCFRuleExt" },
0x047B: { n:"BrtBeginSXCondFmt14" },
0x047C: { n:"BrtEndSXCondFmt14" },
0x047D: { n:"BrtBeginSXCondFmts14" },
0x047E: { n:"BrtEndSXCondFmts14" },
0x0480: { n:"BrtBeginSortCond14" },
0x0481: { n:"BrtEndSortCond14" },
0x0482: { n:"BrtEndDVals14" },
0x0483: { n:"BrtEndIconSet14" },
0x0484: { n:"BrtEndDatabar14" },
0x0485: { n:"BrtBeginColorScale14" },
0x0486: { n:"BrtEndColorScale14" },
0x0487: { n:"BrtBeginSxrules14" },
0x0488: { n:"BrtEndSxrules14" },
0x0489: { n:"BrtBeginPRule14" },
0x048A: { n:"BrtEndPRule14" },
0x048B: { n:"BrtBeginPRFilters14" },
0x048C: { n:"BrtEndPRFilters14" },
0x048D: { n:"BrtBeginPRFilter14" },
0x048E: { n:"BrtEndPRFilter14" },
0x048F: { n:"BrtBeginPRFItem14" },
0x0490: { n:"BrtEndPRFItem14" },
0x0491: { n:"BrtBeginCellIgnoreECs14" },
0x0492: { n:"BrtEndCellIgnoreECs14" },
0x0493: { n:"BrtDxf14" },
0x0494: { n:"BrtBeginDxF14s" },
0x0495: { n:"BrtEndDxf14s" },
0x0499: { n:"BrtFilter14" },
0x049A: { n:"BrtBeginCustomFilters14" },
0x049C: { n:"BrtCustomFilter14" },
0x049D: { n:"BrtIconFilter14" },
0x049E: { n:"BrtPivotCacheConnectionName" },
0x0800: { n:"BrtBeginDecoupledPivotCacheIDs" },
0x0801: { n:"BrtEndDecoupledPivotCacheIDs" },
0x0802: { n:"BrtDecoupledPivotCacheID" },
0x0803: { n:"BrtBeginPivotTableRefs" },
0x0804: { n:"BrtEndPivotTableRefs" },
0x0805: { n:"BrtPivotTableRef" },
0x0806: { n:"BrtSlicerCacheBookPivotTables" },
0x0807: { n:"BrtBeginSxvcells" },
0x0808: { n:"BrtEndSxvcells" },
0x0809: { n:"BrtBeginSxRow" },
0x080A: { n:"BrtEndSxRow" },
0x080C: { n:"BrtPcdCalcMem15" },
0x0813: { n:"BrtQsi15" },
0x0814: { n:"BrtBeginWebExtensions" },
0x0815: { n:"BrtEndWebExtensions" },
0x0816: { n:"BrtWebExtension" },
0x0817: { n:"BrtAbsPath15" },
0x0818: { n:"BrtBeginPivotTableUISettings" },
0x0819: { n:"BrtEndPivotTableUISettings" },
0x081B: { n:"BrtTableSlicerCacheIDs" },
0x081C: { n:"BrtTableSlicerCacheID" },
0x081D: { n:"BrtBeginTableSlicerCache" },
0x081E: { n:"BrtEndTableSlicerCache" },
0x081F: { n:"BrtSxFilter15" },
0x0820: { n:"BrtBeginTimelineCachePivotCacheIDs" },
0x0821: { n:"BrtEndTimelineCachePivotCacheIDs" },
0x0822: { n:"BrtTimelineCachePivotCacheID" },
0x0823: { n:"BrtBeginTimelineCacheIDs" },
0x0824: { n:"BrtEndTimelineCacheIDs" },
0x0825: { n:"BrtBeginTimelineCacheID" },
0x0826: { n:"BrtEndTimelineCacheID" },
0x0827: { n:"BrtBeginTimelinesEx" },
0x0828: { n:"BrtEndTimelinesEx" },
0x0829: { n:"BrtBeginTimelineEx" },
0x082A: { n:"BrtEndTimelineEx" },
0x082B: { n:"BrtWorkBookPr15" },
0x082C: { n:"BrtPCDH15" },
0x082D: { n:"BrtBeginTimelineStyle" },
0x082E: { n:"BrtEndTimelineStyle" },
0x082F: { n:"BrtTimelineStyleElement" },
0x0830: { n:"BrtBeginTimelineStylesheetExt15" },
0x0831: { n:"BrtEndTimelineStylesheetExt15" },
0x0832: { n:"BrtBeginTimelineStyles" },
0x0833: { n:"BrtEndTimelineStyles" },
0x0834: { n:"BrtBeginTimelineStyleElements" },
0x0835: { n:"BrtEndTimelineStyleElements" },
0x0836: { n:"BrtDxf15" },
0x0837: { n:"BrtBeginDxfs15" },
0x0838: { n:"brtEndDxfs15" },
0x0839: { n:"BrtSlicerCacheHideItemsWithNoData" },
0x083A: { n:"BrtBeginItemUniqueNames" },
0x083B: { n:"BrtEndItemUniqueNames" },
0x083C: { n:"BrtItemUniqueName" },
0x083D: { n:"BrtBeginExtConn15" },
0x083E: { n:"BrtEndExtConn15" },
0x083F: { n:"BrtBeginOledbPr15" },
0x0840: { n:"BrtEndOledbPr15" },
0x0841: { n:"BrtBeginDataFeedPr15" },
0x0842: { n:"BrtEndDataFeedPr15" },
0x0843: { n:"BrtTextPr15" },
0x0844: { n:"BrtRangePr15" },
0x0845: { n:"BrtDbCommand15" },
0x0846: { n:"BrtBeginDbTables15" },
0x0847: { n:"BrtEndDbTables15" },
0x0848: { n:"BrtDbTable15" },
0x0849: { n:"BrtBeginDataModel" },
0x084A: { n:"BrtEndDataModel" },
0x084B: { n:"BrtBeginModelTables" },
0x084C: { n:"BrtEndModelTables" },
0x084D: { n:"BrtModelTable" },
0x084E: { n:"BrtBeginModelRelationships" },
0x084F: { n:"BrtEndModelRelationships" },
0x0850: { n:"BrtModelRelationship" },
0x0851: { n:"BrtBeginECTxtWiz15" },
0x0852: { n:"BrtEndECTxtWiz15" },
0x0853: { n:"BrtBeginECTWFldInfoLst15" },
0x0854: { n:"BrtEndECTWFldInfoLst15" },
0x0855: { n:"BrtBeginECTWFldInfo15" },
0x0856: { n:"BrtFieldListActiveItem" },
0x0857: { n:"BrtPivotCacheIdVersion" },
0x0858: { n:"BrtSXDI15" },
0x0859: { n:"BrtBeginModelTimeGroupings" },
0x085A: { n:"BrtEndModelTimeGroupings" },
0x085B: { n:"BrtBeginModelTimeGrouping" },
0x085C: { n:"BrtEndModelTimeGrouping" },
0x085D: { n:"BrtModelTimeGroupingCalcCol" },
0x0C00: { n:"BrtUid" },
0x0C01: { n:"BrtRevisionPtr" },
0x13e7: { n:"BrtBeginCalcFeatures" },
0x13e8: { n:"BrtEndCalcFeatures" },
0x13e9: { n:"BrtCalcFeature" },
0xFFFF: { n:"" }
};

var XLSBRE = evert_key(XLSBRecordEnum, 'n');

/* [MS-XLS] 2.3 Record Enumeration */
var XLSRecordEnum = {
0x0003: { n:"BIFF2NUM", f:parse_BIFF2NUM },
0x0004: { n:"BIFF2STR", f:parse_BIFF2STR },
0x0006: { n:"Formula", f:parse_Formula },
0x0009: { n:'BOF', f:parse_BOF },
0x000a: { n:'EOF', f:parsenoop2 },
0x000c: { n:"CalcCount", f:parseuint16 },
0x000d: { n:"CalcMode", f:parseuint16 },
0x000e: { n:"CalcPrecision", f:parsebool },
0x000f: { n:"CalcRefMode", f:parsebool },
0x0010: { n:"CalcDelta", f:parse_Xnum },
0x0011: { n:"CalcIter", f:parsebool },
0x0012: { n:"Protect", f:parsebool },
0x0013: { n:"Password", f:parseuint16 },
0x0014: { n:"Header", f:parse_XLHeaderFooter },
0x0015: { n:"Footer", f:parse_XLHeaderFooter },
0x0017: { n:"ExternSheet", f:parse_ExternSheet },
0x0018: { n:"Lbl", f:parse_Lbl },
0x0019: { n:"WinProtect", f:parsebool },
0x001a: { n:"VerticalPageBreaks" },
0x001b: { n:"HorizontalPageBreaks" },
0x001c: { n:"Note", f:parse_Note },
0x001d: { n:"Selection" },
0x0022: { n:"Date1904", f:parsebool },
0x0023: { n:"ExternName", f:parse_ExternName },
0x0026: { n:"LeftMargin", f:parse_Xnum },
0x0027: { n:"RightMargin", f:parse_Xnum },
0x0028: { n:"TopMargin", f:parse_Xnum },
0x0029: { n:"BottomMargin", f:parse_Xnum },
0x002a: { n:"PrintRowCol", f:parsebool },
0x002b: { n:"PrintGrid", f:parsebool },
0x002f: { n:"FilePass", f:parse_FilePass },
0x0031: { n:"Font", f:parse_Font },
0x0033: { n:"PrintSize", f:parseuint16 },
0x003c: { n:"Continue" },
0x003d: { n:"Window1", f:parse_Window1 },
0x0040: { n:"Backup", f:parsebool },
0x0041: { n:"Pane" },
0x0042: { n:'CodePage', f:parseuint16 },
0x004d: { n:"Pls" },
0x0050: { n:"DCon" },
0x0051: { n:"DConRef" },
0x0052: { n:"DConName" },
0x0055: { n:"DefColWidth", f:parseuint16 },
0x0059: { n:"XCT" },
0x005a: { n:"CRN" },
0x005b: { n:"FileSharing" },
0x005c: { n:'WriteAccess', f:parse_WriteAccess },
0x005d: { n:"Obj", f:parse_Obj },
0x005e: { n:"Uncalced" },
0x005f: { n:"CalcSaveRecalc", f:parsebool },
0x0060: { n:"Template" },
0x0061: { n:"Intl" },
0x0063: { n:"ObjProtect", f:parsebool },
0x007d: { n:"ColInfo", f:parse_ColInfo },
0x0080: { n:"Guts", f:parse_Guts },
0x0081: { n:"WsBool", f:parse_WsBool },
0x0082: { n:"GridSet", f:parseuint16 },
0x0083: { n:"HCenter", f:parsebool },
0x0084: { n:"VCenter", f:parsebool },
0x0085: { n:'BoundSheet8', f:parse_BoundSheet8 },
0x0086: { n:"WriteProtect" },
0x008c: { n:"Country", f:parse_Country },
0x008d: { n:"HideObj", f:parseuint16 },
0x0090: { n:"Sort" },
0x0092: { n:"Palette", f:parse_Palette },
0x0097: { n:"Sync" },
0x0098: { n:"LPr" },
0x0099: { n:"DxGCol" },
0x009a: { n:"FnGroupName" },
0x009b: { n:"FilterMode" },
0x009c: { n:"BuiltInFnGroupCount", f:parseuint16 },
0x009d: { n:"AutoFilterInfo" },
0x009e: { n:"AutoFilter" },
0x00a0: { n:"Scl", f:parse_Scl },
0x00a1: { n:"Setup", f:parse_Setup },
0x00ae: { n:"ScenMan" },
0x00af: { n:"SCENARIO" },
0x00b0: { n:"SxView" },
0x00b1: { n:"Sxvd" },
0x00b2: { n:"SXVI" },
0x00b4: { n:"SxIvd" },
0x00b5: { n:"SXLI" },
0x00b6: { n:"SXPI" },
0x00b8: { n:"DocRoute" },
0x00b9: { n:"RecipName" },
0x00bd: { n:"MulRk", f:parse_MulRk },
0x00be: { n:"MulBlank", f:parse_MulBlank },
0x00c1: { n:'Mms', f:parsenoop2 },
0x00c5: { n:"SXDI" },
0x00c6: { n:"SXDB" },
0x00c7: { n:"SXFDB" },
0x00c8: { n:"SXDBB" },
0x00c9: { n:"SXNum" },
0x00ca: { n:"SxBool", f:parsebool },
0x00cb: { n:"SxErr" },
0x00cc: { n:"SXInt" },
0x00cd: { n:"SXString" },
0x00ce: { n:"SXDtr" },
0x00cf: { n:"SxNil" },
0x00d0: { n:"SXTbl" },
0x00d1: { n:"SXTBRGIITM" },
0x00d2: { n:"SxTbpg" },
0x00d3: { n:"ObProj" },
0x00d5: { n:"SXStreamID" },
0x00d7: { n:"DBCell" },
0x00d8: { n:"SXRng" },
0x00d9: { n:"SxIsxoper" },
0x00da: { n:"BookBool", f:parseuint16 },
0x00dc: { n:"DbOrParamQry" },
0x00dd: { n:"ScenarioProtect", f:parsebool },
0x00de: { n:"OleObjectSize" },
0x00e0: { n:"XF", f:parse_XF },
0x00e1: { n:'InterfaceHdr', f:parse_InterfaceHdr },
0x00e2: { n:'InterfaceEnd', f:parsenoop2 },
0x00e3: { n:"SXVS" },
0x00e5: { n:"MergeCells", f:parse_MergeCells },
0x00e9: { n:"BkHim" },
0x00eb: { n:"MsoDrawingGroup" },
0x00ec: { n:"MsoDrawing" },
0x00ed: { n:"MsoDrawingSelection" },
0x00ef: { n:"PhoneticInfo" },
0x00f0: { n:"SxRule" },
0x00f1: { n:"SXEx" },
0x00f2: { n:"SxFilt" },
0x00f4: { n:"SxDXF" },
0x00f5: { n:"SxItm" },
0x00f6: { n:"SxName" },
0x00f7: { n:"SxSelect" },
0x00f8: { n:"SXPair" },
0x00f9: { n:"SxFmla" },
0x00fb: { n:"SxFormat" },
0x00fc: { n:"SST", f:parse_SST },
0x00fd: { n:"LabelSst", f:parse_LabelSst },
0x00ff: { n:"ExtSST", f:parse_ExtSST },
0x0100: { n:"SXVDEx" },
0x0103: { n:"SXFormula" },
0x0122: { n:"SXDBEx" },
0x0137: { n:"RRDInsDel" },
0x0138: { n:"RRDHead" },
0x013b: { n:"RRDChgCell" },
0x013d: { n:"RRTabId", f:parseuint16a },
0x013e: { n:"RRDRenSheet" },
0x013f: { n:"RRSort" },
0x0140: { n:"RRDMove" },
0x014a: { n:"RRFormat" },
0x014b: { n:"RRAutoFmt" },
0x014d: { n:"RRInsertSh" },
0x014e: { n:"RRDMoveBegin" },
0x014f: { n:"RRDMoveEnd" },
0x0150: { n:"RRDInsDelBegin" },
0x0151: { n:"RRDInsDelEnd" },
0x0152: { n:"RRDConflict" },
0x0153: { n:"RRDDefName" },
0x0154: { n:"RRDRstEtxp" },
0x015f: { n:"LRng" },
0x0160: { n:"UsesELFs", f:parsebool },
0x0161: { n:"DSF", f:parsenoop2 },
0x0191: { n:"CUsr" },
0x0192: { n:"CbUsr" },
0x0193: { n:"UsrInfo" },
0x0194: { n:"UsrExcl" },
0x0195: { n:"FileLock" },
0x0196: { n:"RRDInfo" },
0x0197: { n:"BCUsrs" },
0x0198: { n:"UsrChk" },
0x01a9: { n:"UserBView" },
0x01aa: { n:"UserSViewBegin" },
0x01ab: { n:"UserSViewEnd" },
0x01ac: { n:"RRDUserView" },
0x01ad: { n:"Qsi" },
0x01ae: { n:"SupBook", f:parse_SupBook },
0x01af: { n:"Prot4Rev", f:parsebool },
0x01b0: { n:"CondFmt" },
0x01b1: { n:"CF" },
0x01b2: { n:"DVal" },
0x01b5: { n:"DConBin" },
0x01b6: { n:"TxO", f:parse_TxO },
0x01b7: { n:"RefreshAll", f:parsebool },
0x01b8: { n:"HLink", f:parse_HLink },
0x01b9: { n:"Lel" },
0x01ba: { n:"CodeName", f:parse_XLUnicodeString },
0x01bb: { n:"SXFDBType" },
0x01bc: { n:"Prot4RevPass", f:parseuint16 },
0x01bd: { n:"ObNoMacros" },
0x01be: { n:"Dv" },
0x01c0: { n:"Excel9File", f:parsenoop2 },
0x01c1: { n:"RecalcId", f:parse_RecalcId, r:2},
0x01c2: { n:"EntExU2", f:parsenoop2 },
0x0200: { n:"Dimensions", f:parse_Dimensions },
0x0201: { n:"Blank", f:parse_Blank },
0x0203: { n:"Number", f:parse_Number },
0x0204: { n:"Label", f:parse_Label },
0x0205: { n:"BoolErr", f:parse_BoolErr },
0x0206: { n:"Formula", f:parse_Formula },
0x0207: { n:"String", f:parse_String },
0x0208: { n:'Row', f:parse_Row },
0x020b: { n:"Index" },
0x0221: { n:"Array", f:parse_Array },
0x0225: { n:"DefaultRowHeight", f:parse_DefaultRowHeight },
0x0236: { n:"Table" },
0x023e: { n:"Window2", f:parse_Window2 },
0x027e: { n:"RK", f:parse_RK },
0x0293: { n:"Style" },
0x0406: { n:"Formula", f:parse_Formula },
0x0418: { n:"BigName" },
0x041e: { n:"Format", f:parse_Format },
0x043c: { n:"ContinueBigName" },
0x04bc: { n:"ShrFmla", f:parse_ShrFmla },
0x0800: { n:"HLinkTooltip", f:parse_HLinkTooltip },
0x0801: { n:"WebPub" },
0x0802: { n:"QsiSXTag" },
0x0803: { n:"DBQueryExt" },
0x0804: { n:"ExtString" },
0x0805: { n:"TxtQry" },
0x0806: { n:"Qsir" },
0x0807: { n:"Qsif" },
0x0808: { n:"RRDTQSIF" },
0x0809: { n:'BOF', f:parse_BOF },
0x080a: { n:"OleDbConn" },
0x080b: { n:"WOpt" },
0x080c: { n:"SXViewEx" },
0x080d: { n:"SXTH" },
0x080e: { n:"SXPIEx" },
0x080f: { n:"SXVDTEx" },
0x0810: { n:"SXViewEx9" },
0x0812: { n:"ContinueFrt" },
0x0813: { n:"RealTimeData" },
0x0850: { n:"ChartFrtInfo" },
0x0851: { n:"FrtWrapper" },
0x0852: { n:"StartBlock" },
0x0853: { n:"EndBlock" },
0x0854: { n:"StartObject" },
0x0855: { n:"EndObject" },
0x0856: { n:"CatLab" },
0x0857: { n:"YMult" },
0x0858: { n:"SXViewLink" },
0x0859: { n:"PivotChartBits" },
0x085a: { n:"FrtFontList" },
0x0862: { n:"SheetExt" },
0x0863: { n:"BookExt", r:12},
0x0864: { n:"SXAddl" },
0x0865: { n:"CrErr" },
0x0866: { n:"HFPicture" },
0x0867: { n:'FeatHdr', f:parsenoop2 },
0x0868: { n:"Feat" },
0x086a: { n:"DataLabExt" },
0x086b: { n:"DataLabExtContents" },
0x086c: { n:"CellWatch" },
0x0871: { n:"FeatHdr11" },
0x0872: { n:"Feature11" },
0x0874: { n:"DropDownObjIds" },
0x0875: { n:"ContinueFrt11" },
0x0876: { n:"DConn" },
0x0877: { n:"List12" },
0x0878: { n:"Feature12" },
0x0879: { n:"CondFmt12" },
0x087a: { n:"CF12" },
0x087b: { n:"CFEx" },
0x087c: { n:"XFCRC", f:parse_XFCRC, r:12 },
0x087d: { n:"XFExt", f:parse_XFExt, r:12 },
0x087e: { n:"AutoFilter12" },
0x087f: { n:"ContinueFrt12" },
0x0884: { n:"MDTInfo" },
0x0885: { n:"MDXStr" },
0x0886: { n:"MDXTuple" },
0x0887: { n:"MDXSet" },
0x0888: { n:"MDXProp" },
0x0889: { n:"MDXKPI" },
0x088a: { n:"MDB" },
0x088b: { n:"PLV" },
0x088c: { n:"Compat12", f:parsebool, r:12 },
0x088d: { n:"DXF" },
0x088e: { n:"TableStyles", r:12 },
0x088f: { n:"TableStyle" },
0x0890: { n:"TableStyleElement" },
0x0892: { n:"StyleExt" },
0x0893: { n:"NamePublish" },
0x0894: { n:"NameCmt", f:parse_NameCmt, r:12 },
0x0895: { n:"SortData" },
0x0896: { n:"Theme", f:parse_Theme, r:12 },
0x0897: { n:"GUIDTypeLib" },
0x0898: { n:"FnGrp12" },
0x0899: { n:"NameFnGrp12" },
0x089a: { n:"MTRSettings", f:parse_MTRSettings, r:12 },
0x089b: { n:"CompressPictures", f:parsenoop2 },
0x089c: { n:"HeaderFooter" },
0x089d: { n:"CrtLayout12" },
0x089e: { n:"CrtMlFrt" },
0x089f: { n:"CrtMlFrtContinue" },
0x08a3: { n:"ForceFullCalculation", f:parse_ForceFullCalculation },
0x08a4: { n:"ShapePropsStream" },
0x08a5: { n:"TextPropsStream" },
0x08a6: { n:"RichTextStream" },
0x08a7: { n:"CrtLayout12A" },
0x1001: { n:"Units" },
0x1002: { n:"Chart" },
0x1003: { n:"Series" },
0x1006: { n:"DataFormat" },
0x1007: { n:"LineFormat" },
0x1009: { n:"MarkerFormat" },
0x100a: { n:"AreaFormat" },
0x100b: { n:"PieFormat" },
0x100c: { n:"AttachedLabel" },
0x100d: { n:"SeriesText" },
0x1014: { n:"ChartFormat" },
0x1015: { n:"Legend" },
0x1016: { n:"SeriesList" },
0x1017: { n:"Bar" },
0x1018: { n:"Line" },
0x1019: { n:"Pie" },
0x101a: { n:"Area" },
0x101b: { n:"Scatter" },
0x101c: { n:"CrtLine" },
0x101d: { n:"Axis" },
0x101e: { n:"Tick" },
0x101f: { n:"ValueRange" },
0x1020: { n:"CatSerRange" },
0x1021: { n:"AxisLine" },
0x1022: { n:"CrtLink" },
0x1024: { n:"DefaultText" },
0x1025: { n:"Text" },
0x1026: { n:"FontX", f:parseuint16 },
0x1027: { n:"ObjectLink" },
0x1032: { n:"Frame" },
0x1033: { n:"Begin" },
0x1034: { n:"End" },
0x1035: { n:"PlotArea" },
0x103a: { n:"Chart3d" },
0x103c: { n:"PicF" },
0x103d: { n:"DropBar" },
0x103e: { n:"Radar" },
0x103f: { n:"Surf" },
0x1040: { n:"RadarArea" },
0x1041: { n:"AxisParent" },
0x1043: { n:"LegendException" },
0x1044: { n:"ShtProps", f:parse_ShtProps },
0x1045: { n:"SerToCrt" },
0x1046: { n:"AxesUsed" },
0x1048: { n:"SBaseRef" },
0x104a: { n:"SerParent" },
0x104b: { n:"SerAuxTrend" },
0x104e: { n:"IFmtRecord" },
0x104f: { n:"Pos" },
0x1050: { n:"AlRuns" },
0x1051: { n:"BRAI" },
0x105b: { n:"SerAuxErrBar" },
0x105c: { n:"ClrtClient", f:parse_ClrtClient },
0x105d: { n:"SerFmt" },
0x105f: { n:"Chart3DBarShape" },
0x1060: { n:"Fbi" },
0x1061: { n:"BopPop" },
0x1062: { n:"AxcExt" },
0x1063: { n:"Dat" },
0x1064: { n:"PlotGrowth" },
0x1065: { n:"SIIndex" },
0x1066: { n:"GelFrame" },
0x1067: { n:"BopPopCustom" },
0x1068: { n:"Fbi2" },

0x0000: { n:"Dimensions", f:parse_Dimensions },
0x0002: { n:"BIFF2INT", f:parse_BIFF2INT },
0x0005: { n:"BoolErr", f:parse_BoolErr },
0x0007: { n:"String", f:parse_BIFF2STRING },
0x0008: { n:"BIFF2ROW" },
0x000b: { n:"Index" },
0x0016: { n:"ExternCount", f:parseuint16 },
0x001e: { n:"BIFF2FORMAT", f:parse_BIFF2Format },
0x001f: { n:"BIFF2FMTCNT" }, /* 16-bit cnt of BIFF2FORMAT records */
0x0020: { n:"BIFF2COLINFO" },
0x0021: { n:"Array", f:parse_Array },
0x0025: { n:"DefaultRowHeight", f:parse_DefaultRowHeight },
0x0032: { n:"BIFF2FONTXTRA", f:parse_BIFF2FONTXTRA },
0x0034: { n:"DDEObjName" },
0x003e: { n:"BIFF2WINDOW2" },
0x0043: { n:"BIFF2XF" },
0x0045: { n:"BIFF2FONTCLR" },
0x0056: { n:"BIFF4FMTCNT" }, /* 16-bit cnt, similar to BIFF2 */
0x007e: { n:"RK" }, /* Not necessarily same as 0x027e */
0x007f: { n:"ImData", f:parse_ImData },
0x0087: { n:"Addin" },
0x0088: { n:"Edg" },
0x0089: { n:"Pub" },
0x0091: { n:"Sub" },
0x0094: { n:"LHRecord" },
0x0095: { n:"LHNGraph" },
0x0096: { n:"Sound" },
0x00a9: { n:"CoordList" },
0x00ab: { n:"GCW" },
0x00bc: { n:"ShrFmla" }, /* Not necessarily same as 0x04bc */
0x00bf: { n:"ToolbarHdr" },
0x00c0: { n:"ToolbarEnd" },
0x00c2: { n:"AddMenu" },
0x00c3: { n:"DelMenu" },
0x00d6: { n:"RString", f:parse_RString },
0x00df: { n:"UDDesc" },
0x00ea: { n:"TabIdConf" },
0x0162: { n:"XL5Modify" },
0x01a5: { n:"FileSharing2" },
0x0209: { n:'BOF', f:parse_BOF },
0x0218: { n:"Lbl", f:parse_Lbl },
0x0223: { n:"ExternName", f:parse_ExternName },
0x0231: { n:"Font" },
0x0243: { n:"BIFF3XF" },
0x0409: { n:'BOF', f:parse_BOF },
0x0443: { n:"BIFF4XF" },
0x086d: { n:"FeatInfo" },
0x0873: { n:"FeatInfo11" },
0x0881: { n:"SXAddl12" },
0x08c0: { n:"AutoWebPub" },
0x08c1: { n:"ListObj" },
0x08c2: { n:"ListField" },
0x08c3: { n:"ListDV" },
0x08c4: { n:"ListCondFmt" },
0x08c5: { n:"ListCF" },
0x08c6: { n:"FMQry" },
0x08c7: { n:"FMSQry" },
0x08c8: { n:"PLV" },
0x08c9: { n:"LnExt" },
0x08ca: { n:"MkrExt" },
0x08cb: { n:"CrtCoopt" },
0x08d6: { n:"FRTArchId$", r:12 },

0x7262: {}
};

var XLSRE = evert_key(XLSRecordEnum, 'n');
function write_biff_rec(ba, type, payload, length) {
	var t = +type || +XLSRE[type];
	if(isNaN(t)) return;
	var len = length || (payload||[]).length || 0;
	var o = ba.next(4);
	o.write_shift(2, t);
	o.write_shift(2, len);
	if(len > 0 && is_buf(payload)) ba.push(payload);
}

function write_BIFF2Cell(out, r, c) {
	if(!out) out = new_buf(7);
	out.write_shift(2, r);
	out.write_shift(2, c);
	out.write_shift(2, 0);
	out.write_shift(1, 0);
	return out;
}

function write_BIFF2BERR(r, c, val, t) {
	var out = new_buf(9);
	write_BIFF2Cell(out, r, c);
	if(t == 'e') { out.write_shift(1, val); out.write_shift(1, 1); }
	else { out.write_shift(1, val?1:0); out.write_shift(1, 0); }
	return out;
}

/* TODO: codepage, large strings */
function write_BIFF2LABEL(r, c, val) {
	var out = new_buf(8 + 2*val.length);
	write_BIFF2Cell(out, r, c);
	out.write_shift(1, val.length);
	out.write_shift(val.length, val, 'sbcs');
	return out.l < out.length ? out.slice(0, out.l) : out;
}

function write_ws_biff2_cell(ba, cell, R, C) {
	if(cell.v != null) switch(cell.t) {
		case 'd': case 'n':
			var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
			if((v == (v|0)) && (v >= 0) && (v < 65536))
				write_biff_rec(ba, 0x0002, write_BIFF2INT(R, C, v));
			else
				write_biff_rec(ba, 0x0003, write_BIFF2NUM(R,C, v));
			return;
		case 'b': case 'e': write_biff_rec(ba, 0x0005, write_BIFF2BERR(R, C, cell.v, cell.t)); return;
		/* TODO: codepage, sst */
		case 's': case 'str':
			write_biff_rec(ba, 0x0004, write_BIFF2LABEL(R, C, cell.v));
			return;
	}
	write_biff_rec(ba, 0x0001, write_BIFF2Cell(null, R, C));
}

function write_ws_biff2(ba, ws, idx, opts) {
	var dense = Array.isArray(ws);
	var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
	if(range.e.c > 0xFF || range.e.r > 0x3FFF) {
		if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
		range.e.c = Math.min(range.e.c, 0xFF);
		range.e.r = Math.min(range.e.c, 0x3FFF);
		ref = encode_range(range);
	}
	for(var R = range.s.r; R <= range.e.r; ++R) {
		rr = encode_row(R);
		for(var C = range.s.c; C <= range.e.c; ++C) {
			if(R === range.s.r) cols[C] = encode_col(C);
			ref = cols[C] + rr;
			var cell = dense ? (ws[R]||[])[C] : ws[ref];
			if(!cell) continue;
			/* write cell */
			write_ws_biff2_cell(ba, cell, R, C, opts);
		}
	}
}

/* Based on test files */
function write_biff2_buf(wb, opts) {
	var o = opts || {};
	if(DENSE != null && o.dense == null) o.dense = DENSE;
	var ba = buf_array();
	var idx = 0;
	for(var i=0;i<wb.SheetNames.length;++i) if(wb.SheetNames[i] == o.sheet) idx=i;
	if(idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
	write_biff_rec(ba, 0x0009, write_BOF(wb, 0x10, o));
	/* ... */
	write_ws_biff2(ba, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
	/* ... */
	write_biff_rec(ba, 0x000A);
	return ba.end();
}

function write_FONTS_biff8(ba, data, opts) {
	write_biff_rec(ba, "Font", write_Font({
		sz:12,
		color: {theme:1},
		name: "Arial",
		family: 2,
		scheme: "minor"
	}, opts));
}


function write_FMTS_biff8(ba, NF, opts) {
	if(!NF) return;
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_biff_rec(ba, "Format", write_Format(i, NF[i], opts));
	});
}

function write_FEAT(ba, ws) {
	/* [MS-XLS] 2.4.112 */
	var o = new_buf(19);
	o.write_shift(4, 0x867); o.write_shift(4, 0); o.write_shift(4, 0);
	o.write_shift(2, 3); o.write_shift(1, 1); o.write_shift(4, 0);
	write_biff_rec(ba, "FeatHdr", o);
	/* [MS-XLS] 2.4.111 */
	o = new_buf(39);
	o.write_shift(4, 0x868); o.write_shift(4, 0); o.write_shift(4, 0);
	o.write_shift(2, 3); o.write_shift(1, 0); o.write_shift(4, 0);
	o.write_shift(2, 1); o.write_shift(4, 4); o.write_shift(2, 0);
	write_Ref8U(safe_decode_range(ws['!ref']||"A1"), o);
	o.write_shift(4, 4);
	write_biff_rec(ba, "Feat", o);
}

function write_CELLXFS_biff8(ba, opts) {
	for(var i = 0; i < 16; ++i) write_biff_rec(ba, "XF", write_XF({numFmtId:0, style:true}, 0, opts));
	opts.cellXfs.forEach(function(c) {
		write_biff_rec(ba, "XF", write_XF(c, 0, opts));
	});
}

function write_ws_biff8_hlinks(ba, ws) {
	for(var R=0; R<ws['!links'].length; ++R) {
		var HL = ws['!links'][R];
		write_biff_rec(ba, "HLink", write_HLink(HL));
		if(HL[1].Tooltip) write_biff_rec(ba, "HLinkTooltip", write_HLinkTooltip(HL));
	}
	delete ws['!links'];
}

function write_ws_biff8_cell(ba, cell, R, C, opts) {
	var os = 16 + get_cell_style(opts.cellXfs, cell, opts);
	if(cell.v != null) switch(cell.t) {
		case 'd': case 'n':
			var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
			/* TODO: emit RK as appropriate */
			write_biff_rec(ba, "Number", write_Number(R, C, v, os, opts));
			return;
		case 'b': case 'e': write_biff_rec(ba, 0x0205, write_BoolErr(R, C, cell.v, os, opts, cell.t)); return;
		/* TODO: codepage, sst */
		case 's': case 'str':
			write_biff_rec(ba, "Label", write_Label(R, C, cell.v, os, opts));
			return;
	}
	write_biff_rec(ba, "Blank", write_XLSCell(R, C, os));
}

/* [MS-XLS] 2.1.7.20.5 */
function write_ws_biff8(idx, opts, wb) {
	var ba = buf_array();
	var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
	var _WB = ((wb||{}).Workbook||{});
	var _sheet = ((_WB.Sheets||[])[idx]||{});
	var dense = Array.isArray(ws);
	var b8 = opts.biff == 8;
	var ref, rr = "", cols = [];
	var range = safe_decode_range(ws['!ref'] || "A1");
	var MAX_ROWS = b8 ? 65536 : 16384;
	if(range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
		if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
		range.e.c = Math.min(range.e.c, 0xFF);
		range.e.r = Math.min(range.e.c, MAX_ROWS-1);
	}

	write_biff_rec(ba, 0x0809, write_BOF(wb, 0x10, opts));
	/* ... */
	write_biff_rec(ba, "CalcMode", writeuint16(1));
	write_biff_rec(ba, "CalcCount", writeuint16(100));
	write_biff_rec(ba, "CalcRefMode", writebool(true));
	write_biff_rec(ba, "CalcIter", writebool(false));
	write_biff_rec(ba, "CalcDelta", write_Xnum(0.001));
	write_biff_rec(ba, "CalcSaveRecalc", writebool(true));
	write_biff_rec(ba, "PrintRowCol", writebool(false));
	write_biff_rec(ba, "PrintGrid", writebool(false));
	write_biff_rec(ba, "GridSet", writeuint16(1));
	write_biff_rec(ba, "Guts", write_Guts([0,0]));
	/* ... */
	write_biff_rec(ba, "HCenter", writebool(false));
	write_biff_rec(ba, "VCenter", writebool(false));
	/* ... */
	write_biff_rec(ba, 0x200, write_Dimensions(range, opts));
	/* ... */

	if(b8) ws['!links'] = [];
	for(var R = range.s.r; R <= range.e.r; ++R) {
		rr = encode_row(R);
		for(var C = range.s.c; C <= range.e.c; ++C) {
			if(R === range.s.r) cols[C] = encode_col(C);
			ref = cols[C] + rr;
			var cell = dense ? (ws[R]||[])[C] : ws[ref];
			if(!cell) continue;
			/* write cell */
			write_ws_biff8_cell(ba, cell, R, C, opts);
			if(b8 && cell.l) ws['!links'].push([ref, cell.l]);
		}
	}
	var cname = _sheet.CodeName || _sheet.name || s;
	/* ... */
	if(b8 && _WB.Views) write_biff_rec(ba, "Window2", write_Window2(_WB.Views[0]));
	/* ... */
	if(b8 && (ws['!merges']||[]).length) write_biff_rec(ba, "MergeCells", write_MergeCells(ws['!merges']));
	/* ... */
	if(b8) write_ws_biff8_hlinks(ba, ws);
	/* ... */
	write_biff_rec(ba, "CodeName", write_XLUnicodeString(cname, opts));
	/* ... */
	if(b8) write_FEAT(ba, ws);
	/* ... */
	write_biff_rec(ba, "EOF");
	return ba.end();
}

/* [MS-XLS] 2.1.7.20.3 */
function write_biff8_global(wb, bufs, opts) {
	var A = buf_array();
	var _WB = ((wb||{}).Workbook||{});
	var _sheets = (_WB.Sheets||[]);
	var _wb = _WB.WBProps||{};
	var b8 = opts.biff == 8, b5 = opts.biff == 5;
	write_biff_rec(A, 0x0809, write_BOF(wb, 0x05, opts));
	if(opts.bookType == "xla") write_biff_rec(A, "Addin");
	write_biff_rec(A, "InterfaceHdr", b8 ? writeuint16(0x04b0) : null);
	write_biff_rec(A, "Mms", writezeroes(2));
	if(b5) write_biff_rec(A, "ToolbarHdr");
	if(b5) write_biff_rec(A, "ToolbarEnd");
	write_biff_rec(A, "InterfaceEnd");
	write_biff_rec(A, "WriteAccess", write_WriteAccess("SheetJS", opts));
	write_biff_rec(A, "CodePage", writeuint16(b8 ? 0x04b0 : 0x04E4));
	if(b8) write_biff_rec(A, "DSF", writeuint16(0));
	if(b8) write_biff_rec(A, "Excel9File");
	write_biff_rec(A, "RRTabId", write_RRTabId(wb.SheetNames.length));
	if(b8 && wb.vbaraw) {
		write_biff_rec(A, "ObProj");
		var cname = _wb.CodeName || "ThisWorkbook";
		write_biff_rec(A, "CodeName", write_XLUnicodeString(cname, opts));
	}
	write_biff_rec(A, "BuiltInFnGroupCount", writeuint16(0x11));
	write_biff_rec(A, "WinProtect", writebool(false));
	write_biff_rec(A, "Protect", writebool(false));
	write_biff_rec(A, "Password", writeuint16(0));
	if(b8) write_biff_rec(A, "Prot4Rev", writebool(false));
	if(b8) write_biff_rec(A, "Prot4RevPass", writeuint16(0));
	write_biff_rec(A, "Window1", write_Window1(opts));
	write_biff_rec(A, "Backup", writebool(false));
	write_biff_rec(A, "HideObj", writeuint16(0));
	write_biff_rec(A, "Date1904", writebool(safe1904(wb)=="true"));
	write_biff_rec(A, "CalcPrecision", writebool(true));
	if(b8) write_biff_rec(A, "RefreshAll", writebool(false));
	write_biff_rec(A, "BookBool", writeuint16(0));
	/* ... */
	write_FONTS_biff8(A, wb, opts);
	write_FMTS_biff8(A, wb.SSF, opts);
	write_CELLXFS_biff8(A, opts);
	/* ... */
	if(b8) write_biff_rec(A, "UsesELFs", writebool(false));
	var a = A.end();

	var C = buf_array();
	if(b8) write_biff_rec(C, "Country", write_Country());
	/* BIFF8: [SST *Continue] ExtSST */
	write_biff_rec(C, "EOF");
	var c = C.end();

	var B = buf_array();
	var blen = 0, j = 0;
	for(j = 0; j < wb.SheetNames.length; ++j) blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
	var start = a.length + blen + c.length;
	for(j = 0; j < wb.SheetNames.length; ++j) {
		var _sheet = _sheets[j] || ({});
		write_biff_rec(B, "BoundSheet8", write_BoundSheet8({pos:start, hs:_sheet.Hidden||0, dt:0, name:wb.SheetNames[j]}, opts));
		start += bufs[j].length;
	}
	/* 1*BoundSheet8 */
	var b = B.end();
	if(blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);

	var out = [];
	if(a.length) out.push(a);
	if(b.length) out.push(b);
	if(c.length) out.push(c);
	return __toBuffer([out]);
}

/* [MS-XLS] 2.1.7.20 Workbook Stream */
function write_biff8_buf(wb, opts) {
	var o = opts || {};
	var bufs = [];

	if(wb && !wb.SSF) {
		wb.SSF = SSF.get_table();
	}
	if(wb && wb.SSF) {
		make_ssf(SSF); SSF.load_table(wb.SSF);
		// $FlowIgnore
		o.revssf = evert_num(wb.SSF); o.revssf[wb.SSF[65535]] = 0;
		o.ssf = wb.SSF;
	}
	o.cellXfs = [];
	o.Strings = []; o.Strings.Count = 0; o.Strings.Unique = 0;
	get_cell_style(o.cellXfs, {}, {revssf:{"General":0}});

	for(var i = 0; i < wb.SheetNames.length; ++i) bufs[bufs.length] = write_ws_biff8(i, o, wb);
	bufs.unshift(write_biff8_global(wb, bufs, o));
	return __toBuffer([bufs]);
}

function write_biff_buf(wb, opts) {
	var o = opts || {};
	switch(o.biff || 2) {
		case 8: case 5: return write_biff8_buf(wb, opts);
		case 4: case 3: case 2: return write_biff2_buf(wb, opts);
	}
	throw new Error("invalid type " + o.bookType + " for BIFF");
}
/* note: browser DOM element cannot see mso- style attrs, must parse */
var HTML_ = (function() {
	function html_to_sheet(str, _opts) {
		var opts = _opts || {};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var ws = opts.dense ? ([]) : ({});
		var mtch = str.match(/<table/i);
		if(!mtch) throw new Error("Invalid HTML: could not find <table>");
		var mtch2 = str.match(/<\/table/i);
		var i = mtch.index, j = mtch2 && mtch2.index || str.length;
		var rows = split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
		var R = -1, C = 0, RS = 0, CS = 0;
		var range = {s:{r:10000000, c:10000000},e:{r:0,c:0}};
		var merges = [];
		for(i = 0; i < rows.length; ++i) {
			var row = rows[i].trim();
			var hd = row.slice(0,3).toLowerCase();
			if(hd == "<tr") { ++R; if(opts.sheetRows && opts.sheetRows <= R) { --R; break; } C = 0; continue; }
			if(hd != "<td" && hd != "<th") continue;
			var cells = row.split(/<\/t[dh]>/i);
			for(j = 0; j < cells.length; ++j) {
				var cell = cells[j].trim();
				if(!cell.match(/<t[dh]/i)) continue;
				var m = cell, cc = 0;
				/* TODO: parse styles etc */
				while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1) m = m.slice(cc+1);
				var tag = parsexmltag(cell.slice(0, cell.indexOf(">")));
				CS = tag.colspan ? +tag.colspan : 1;
				if((RS = +tag.rowspan)>1 || CS>1) merges.push({s:{r:R,c:C},e:{r:R + (RS||1) - 1, c:C + CS - 1}});
				var _t = tag.t || "";
				/* TODO: generate stub cells */
				if(!m.length) { C += CS; continue; }
				m = htmldecode(m);
				if(range.s.r > R) range.s.r = R; if(range.e.r < R) range.e.r = R;
				if(range.s.c > C) range.s.c = C; if(range.e.c < C) range.e.c = C;
				if(!m.length) continue;
				var o = {t:'s', v:m};
				if(opts.raw || !m.trim().length || _t == 's'){}
				else if(m === 'TRUE') o = {t:'b', v:true};
				else if(m === 'FALSE') o = {t:'b', v:false};
				else if(!isNaN(fuzzynum(m))) o = {t:'n', v:fuzzynum(m)};
				else if(!isNaN(fuzzydate(m).getDate())) {
					o = ({t:'d', v:parseDate(m)});
					if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
					o.z = opts.dateNF || SSF._table[14];
				}
				if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = o; }
				else ws[encode_cell({r:R, c:C})] = o;
				C += CS;
			}
		}
		ws['!ref'] = encode_range(range);
		return ws;
	}
	function html_to_book(str, opts) {
		return sheet_to_workbook(html_to_sheet(str, opts), opts);
	}
	function make_html_row(ws, r, R, o) {
		var M = (ws['!merges'] ||[]);
		var oo = [];
		for(var C = r.s.c; C <= r.e.c; ++C) {
			var RS = 0, CS = 0;
			for(var j = 0; j < M.length; ++j) {
				if(M[j].s.r > R || M[j].s.c > C) continue;
				if(M[j].e.r < R || M[j].e.c < C) continue;
				if(M[j].s.r < R || M[j].s.c < C) { RS = -1; break; }
				RS = M[j].e.r - M[j].s.r + 1; CS = M[j].e.c - M[j].s.c + 1; break;
			}
			if(RS < 0) continue;
			var coord = encode_cell({r:R,c:C});
			var cell = o.dense ? (ws[R]||[])[C] : ws[coord];
			var sp = {};
			if(RS > 1) sp.rowspan = RS;
			if(CS > 1) sp.colspan = CS;
			/* TODO: html entities */
			var w = (cell && cell.v != null) && (cell.h || escapehtml(cell.w || (format_cell(cell), cell.w) || "")) || "";
			sp.t = cell && cell.t || 'z';
			if(o.editable) w = '<span contenteditable="true">' + w + '</span>';
			sp.id = "sjs-" + coord;
			oo.push(writextag('td', w, sp));
		}
		var preamble = "<tr>";
		return preamble + oo.join("") + "</tr>";
	}
	function make_html_preamble(ws, R, o) {
		var out = [];
		return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
	}
	var _BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
	var _END = '</body></html>';
	function sheet_to_html(ws, opts/*, wb:?Workbook*/) {
		var o = opts || {};
		var header = o.header != null ? o.header : _BEGIN;
		var footer = o.footer != null ? o.footer : _END;
		var out = [header];
		var r = decode_range(ws['!ref']);
		o.dense = Array.isArray(ws);
		out.push(make_html_preamble(ws, r, o));
		for(var R = r.s.r; R <= r.e.r; ++R) out.push(make_html_row(ws, r, R, o));
		out.push("</table>" + footer);
		return out.join("");
	}

	return {
		to_workbook: html_to_book,
		to_sheet: html_to_sheet,
		_row: make_html_row,
		BEGIN: _BEGIN,
		END: _END,
		_preamble: make_html_preamble,
		from_sheet: sheet_to_html
	};
})();

function parse_dom_table(table, _opts) {
	var opts = _opts || {};
	if(DENSE != null) opts.dense = DENSE;
	var ws = opts.dense ? ([]) : ({});
	var rows = table.getElementsByTagName('tr');
	var sheetRows = opts.sheetRows || 10000000;
	var range = {s:{r:0,c:0},e:{r:0,c:0}};
	var merges = [], midx = 0;
	var rowinfo = [];
	var _R = 0, R = 0, _C, C, RS, CS;
	for(; _R < rows.length && R < sheetRows; ++_R) {
		var row = rows[_R];
		if (is_dom_element_hidden(row)) {
			if (opts.display) continue;
			rowinfo[R] = {hidden: true};
		}
		var elts = (row.children);
		for(_C = C = 0; _C < elts.length; ++_C) {
			var elt = elts[_C];
			if (opts.display && is_dom_element_hidden(elt)) continue;
			var v = htmldecode(elt.innerHTML);
			for(midx = 0; midx < merges.length; ++midx) {
				var m = merges[midx];
				if(m.s.c == C && m.s.r <= R && R <= m.e.r) { C = m.e.c+1; midx = -1; }
			}
			/* TODO: figure out how to extract nonstandard mso- style */
			CS = +elt.getAttribute("colspan") || 1;
			if((RS = +elt.getAttribute("rowspan"))>0 || CS>1) merges.push({s:{r:R,c:C},e:{r:R + (RS||1) - 1, c:C + CS - 1}});
			var o = {t:'s', v:v};
			var _t = elt.getAttribute("t") || "";
			if(v != null) {
				if(v.length == 0) o.t = _t || 'z';
				else if(opts.raw || v.trim().length == 0 || _t == "s"){}
				else if(v === 'TRUE') o = {t:'b', v:true};
				else if(v === 'FALSE') o = {t:'b', v:false};
				else if(!isNaN(fuzzynum(v))) o = {t:'n', v:fuzzynum(v)};
				else if(!isNaN(fuzzydate(v).getDate())) {
					o = ({t:'d', v:parseDate(v)});
					if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
					o.z = opts.dateNF || SSF._table[14];
				}
			}
			if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = o; }
			else ws[encode_cell({c:C, r:R})] = o;
			if(range.e.c < C) range.e.c = C;
			C += CS;
		}
		++R;
	}
	if(merges.length) ws['!merges'] = merges;
	if(rowinfo.length) ws['!rows'] = rowinfo;
	range.e.r = R - 1;
	ws['!ref'] = encode_range(range);
	if(R >= sheetRows) ws['!fullref'] = encode_range((range.e.r = rows.length-_R+R-1,range)); // We can count the real number of rows to parse but we don't to improve the performance
	return ws;
}

function table_to_book(table, opts) {
	return sheet_to_workbook(parse_dom_table(table, opts), opts);
}

function is_dom_element_hidden(element) {
	var display = '';
	var get_computed_style = get_get_computed_style_function(element);
	if(get_computed_style) display = get_computed_style(element).getPropertyValue('display');
	if(!display) display = element.style.display; // Fallback for cases when getComputedStyle is not available (e.g. an old browser or some Node.js environments) or doesn't work (e.g. if the element is not inserted to a document)
	return display === 'none';
}

/* global getComputedStyle */
function get_get_computed_style_function(element) {
	// The proper getComputedStyle implementation is the one defined in the element window
	if(element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
	// If it is not available, try to get one from the global namespace
	if(typeof getComputedStyle === 'function') return getComputedStyle;
	return null;
}
/* OpenDocument */
var parse_content_xml = (function() {

	var parse_text_p = function(text) {
		/* 6.1.2 White Space Characters */
		var fixed = text
			.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ")
			.replace(/<text:s\/>/g," ")
			.replace(/<text:s text:c="(\d+)"\/>/g, function($$,$1) { return Array(parseInt($1,10)+1).join(" "); })
			.replace(/<text:tab[^>]*\/>/g,"\t")
			.replace(/<text:line-break\/>/g,"\n");
		var v = unescapexml(fixed.replace(/<[^>]*>/g,""));

		return [v];
	};

	var number_formats = {
		/* ods name: [short ssf fmt, long ssf fmt] */
		day:           ["d",   "dd"],
		month:         ["m",   "mm"],
		year:          ["y",   "yy"],
		hours:         ["h",   "hh"],
		minutes:       ["m",   "mm"],
		seconds:       ["s",   "ss"],
		"am-pm":       ["A/P", "AM/PM"],
		"day-of-week": ["ddd", "dddd"],
		era:           ["e",   "ee"],
		/* there is no native representation of LO "Q" format */
		quarter:       ["\\Qm", "m\\\"th quarter\""]
	};

	return function pcx(d, _opts) {
		var opts = _opts || {};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var str = xlml_normalize(d);
		var state = [], tmp;
		var tag;
		var NFtag = {name:""}, NF = "", pidx = 0;
		var sheetag;
		var rowtag;
		var Sheets = {}, SheetNames = [];
		var ws = opts.dense ? ([]) : ({});
		var Rn, q;
		var ctag = ({value:""});
		var textp = "", textpidx = 0, textptag;
		var textR = [];
		var R = -1, C = -1, range = {s: {r:1000000,c:10000000}, e: {r:0, c:0}};
		var row_ol = 0;
		var number_format_map = {};
		var merges = [], mrange = {}, mR = 0, mC = 0;
		var rowinfo = [], rowpeat = 1, colpeat = 1;
		var arrayf = [];
		var WB = {Names:[]};
		var atag = ({});
		var _Ref = ["", ""];
		var comments = [], comment = ({});
		var creator = "", creatoridx = 0;
		var isstub = false, intable = false;
		var i = 0;
		xlmlregex.lastIndex = 0;
		str = str.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
		while((Rn = xlmlregex.exec(str))) switch((Rn[3]=Rn[3].replace(/_.*$/,""))) {

			case 'table': case '工作表': // 9.1.2 <table:table>
				if(Rn[1]==='/') {
					if(range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = encode_range(range);
					if(opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
						ws['!fullref'] = ws['!ref'];
						range.e.r = opts.sheetRows - 1;
						ws['!ref'] = encode_range(range);
					}
					if(merges.length) ws['!merges'] = merges;
					if(rowinfo.length) ws["!rows"] = rowinfo;
					sheetag.name = sheetag['名称'] || sheetag.name;
					if(typeof JSON !== 'undefined') JSON.stringify(sheetag);
					SheetNames.push(sheetag.name);
					Sheets[sheetag.name] = ws;
					intable = false;
				}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
					sheetag = parsexmltag(Rn[0], false);
					R = C = -1;
					range.s.r = range.s.c = 10000000; range.e.r = range.e.c = 0;
					ws = opts.dense ? ([]) : ({}); merges = [];
					rowinfo = [];
					intable = true;
				}
				break;

			case 'table-row-group': // 9.1.9 <table:table-row-group>
				if(Rn[1] === "/") --row_ol; else ++row_ol;
				break;
			case 'table-row': case '行': // 9.1.3 <table:table-row>
				if(Rn[1] === '/') { R+=rowpeat; rowpeat = 1; break; }
				rowtag = parsexmltag(Rn[0], false);
				if(rowtag['行号']) R = rowtag['行号'] - 1; else if(R == -1) R = 0;
				rowpeat = +rowtag['number-rows-repeated'] || 1;
				/* TODO: remove magic */
				if(rowpeat < 10) for(i = 0; i < rowpeat; ++i) if(row_ol > 0) rowinfo[R + i] = {level: row_ol};
				C = -1; break;
			case 'covered-table-cell': // 9.1.5 <table:covered-table-cell>
				if(Rn[1] !== '/') ++C;
				if(opts.sheetStubs) {
					if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = {t:'z'}; }
					else ws[encode_cell({r:R,c:C})] = {t:'z'};
				}
				textp = ""; textR = [];
				break; /* stub */
			case 'table-cell': case '数据':
				if(Rn[0].charAt(Rn[0].length-2) === '/') {
					++C;
					ctag = parsexmltag(Rn[0], false);
					colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
					q = ({t:'z', v:null});
					if(ctag.formula && opts.cellFormula != false) q.f = ods_to_csf_formula(unescapexml(ctag.formula));
					if((ctag['数据类型'] || ctag['value-type']) == "string") {
						q.t = "s"; q.v = unescapexml(ctag['string-value'] || "");
						if(opts.dense) {
							if(!ws[R]) ws[R] = [];
							ws[R][C] = q;
						} else {
							ws[encode_cell({r:R,c:C})] = q;
						}
					}
					C+= colpeat-1;
				} else if(Rn[1]!=='/') {
					++C;
					colpeat = 1;
					var rptR = rowpeat ? R + rowpeat - 1 : R;
					if(C > range.e.c) range.e.c = C;
					if(C < range.s.c) range.s.c = C;
					if(R < range.s.r) range.s.r = R;
					if(rptR > range.e.r) range.e.r = rptR;
					ctag = parsexmltag(Rn[0], false);
					comments = []; comment = ({});
					q = ({t:ctag['数据类型'] || ctag['value-type'], v:null});
					if(opts.cellFormula) {
						if(ctag.formula) ctag.formula = unescapexml(ctag.formula);
						if(ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
							mR = parseInt(ctag['number-matrix-rows-spanned'],10) || 0;
							mC = parseInt(ctag['number-matrix-columns-spanned'],10) || 0;
							mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
							q.F = encode_range(mrange);
							arrayf.push([mrange, q.F]);
						}
						if(ctag.formula) q.f = ods_to_csf_formula(ctag.formula);
						else for(i = 0; i < arrayf.length; ++i)
							if(R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r)
								if(C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c)
									q.F = arrayf[i][1];
					}
					if(ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
						mR = parseInt(ctag['number-rows-spanned'],10) || 0;
						mC = parseInt(ctag['number-columns-spanned'],10) || 0;
						mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
						merges.push(mrange);
					}

					/* 19.675.2 table:number-columns-repeated */
					if(ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);

					/* 19.385 office:value-type */
					switch(q.t) {
						case 'boolean': q.t = 'b'; q.v = parsexmlbool(ctag['boolean-value']); break;
						case 'float': q.t = 'n'; q.v = parseFloat(ctag.value); break;
						case 'percentage': q.t = 'n'; q.v = parseFloat(ctag.value); break;
						case 'currency': q.t = 'n'; q.v = parseFloat(ctag.value); break;
						case 'date': q.t = 'd'; q.v = parseDate(ctag['date-value']);
							if(!opts.cellDates) { q.t = 'n'; q.v = datenum(q.v); }
							q.z = 'm/d/yy'; break;
						case 'time': q.t = 'n'; q.v = parse_isodur(ctag['time-value'])/86400; break;
						case 'number': q.t = 'n'; q.v = parseFloat(ctag['数据数值']); break;
						default:
							if(q.t === 'string' || q.t === 'text' || !q.t) {
								q.t = 's';
								if(ctag['string-value'] != null) { textp = unescapexml(ctag['string-value']); textR = []; }
							} else throw new Error('Unsupported value type ' + q.t);
					}
				} else {
					isstub = false;
					if(q.t === 's') {
						q.v = textp || '';
						if(textR.length) q.R = textR;
						isstub = textpidx == 0;
					}
					if(atag.Target) q.l = atag;
					if(comments.length > 0) { q.c = comments; comments = []; }
					if(textp && opts.cellText !== false) q.w = textp;
					if(!isstub || opts.sheetStubs) {
						if(!(opts.sheetRows && opts.sheetRows <= R)) {
							for(var rpt = 0; rpt < rowpeat; ++rpt) {
								colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
								if(opts.dense) {
									if(!ws[R + rpt]) ws[R + rpt] = [];
									ws[R + rpt][C] = rpt == 0 ? q : dup(q);
									while(--colpeat > 0) ws[R + rpt][C + colpeat] = dup(q);
								} else {
									ws[encode_cell({r:R + rpt,c:C})] = q;
									while(--colpeat > 0) ws[encode_cell({r:R + rpt,c:C + colpeat})] = dup(q);
								}
								if(range.e.c <= C) range.e.c = C;
							}
						}
					}
					colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
					C += colpeat-1; colpeat = 0;
					q = {};
					textp = ""; textR = [];
				}
				atag = ({});
				break; // 9.1.4 <table:table-cell>

			/* pure state */
			case 'document': // TODO: <office:document> is the root for FODS
			case 'document-content': case '电子表格文档': // 3.1.3.2 <office:document-content>
			case 'spreadsheet': case '主体': // 3.7 <office:spreadsheet>
			case 'scripts': // 3.12 <office:scripts>
			case 'styles': // TODO <office:styles>
			case 'font-face-decls': // 3.14 <office:font-face-decls>
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				break;

			case 'annotation': // 14.1 <office:annotation>
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
					comment.t = textp;
					if(textR.length) comment.R = textR;
					comment.a = creator;
					comments.push(comment);
				}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') {state.push([Rn[3], false]);}
				creator = ""; creatoridx = 0;
				textp = ""; textpidx = 0; textR = [];
				break;

			case 'creator': // 4.3.2.7 <dc:creator>
				if(Rn[1]==='/') { creator = str.slice(creatoridx,Rn.index); }
				else creatoridx = Rn.index + Rn[0].length;
				break;

			/* ignore state */
			case 'meta': case '元数据': // TODO: <office:meta> <uof:元数据> FODS/UOF
			case 'settings': // TODO: <office:settings>
			case 'config-item-set': // TODO: <office:config-item-set>
			case 'config-item-map-indexed': // TODO: <office:config-item-map-indexed>
			case 'config-item-map-entry': // TODO: <office:config-item-map-entry>
			case 'config-item-map-named': // TODO: <office:config-item-map-entry>
			case 'shapes': // 9.2.8 <table:shapes>
			case 'frame': // 10.4.2 <draw:frame>
			case 'text-box': // 10.4.3 <draw:text-box>
			case 'image': // 10.4.4 <draw:image>
			case 'data-pilot-tables': // 9.6.2 <table:data-pilot-tables>
			case 'list-style': // 16.30 <text:list-style>
			case 'form': // 13.13 <form:form>
			case 'dde-links': // 9.8 <table:dde-links>
			case 'event-listeners': // TODO
			case 'chart': // TODO
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], false]);
				textp = ""; textpidx = 0; textR = [];
				break;

			case 'scientific-number': // TODO: <number:scientific-number>
				break;
			case 'currency-symbol': // TODO: <number:currency-symbol>
				break;
			case 'currency-style': // TODO: <number:currency-style>
				break;
			case 'number-style': // 16.27.2 <number:number-style>
			case 'percentage-style': // 16.27.9 <number:percentage-style>
			case 'date-style': // 16.27.10 <number:date-style>
			case 'time-style': // 16.27.18 <number:time-style>
				if(Rn[1]==='/'){
					number_format_map[NFtag.name] = NF;
					if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
				} else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
					NF = "";
					NFtag = parsexmltag(Rn[0], false);
					state.push([Rn[3], true]);
				} break;

			case 'script': break; // 3.13 <office:script>
			case 'libraries': break; // TODO: <ooo:libraries>
			case 'automatic-styles': break; // 3.15.3 <office:automatic-styles>
			case 'master-styles': break; // TODO: <office:master-styles>

			case 'default-style': // TODO: <style:default-style>
			case 'page-layout': break; // TODO: <style:page-layout>
			case 'style': // 16.2 <style:style>
				break;
			case 'map': break; // 16.3 <style:map>
			case 'font-face': break; // 16.21 <style:font-face>

			case 'paragraph-properties': break; // 17.6 <style:paragraph-properties>
			case 'table-properties': break; // 17.15 <style:table-properties>
			case 'table-column-properties': break; // 17.16 <style:table-column-properties>
			case 'table-row-properties': break; // 17.17 <style:table-row-properties>
			case 'table-cell-properties': break; // 17.18 <style:table-cell-properties>

			case 'number': // 16.27.3 <number:number>
				switch(state[state.length-1][0]) {
					case 'time-style':
					case 'date-style':
						tag = parsexmltag(Rn[0], false);
						NF += number_formats[Rn[3]][tag.style==='long'?1:0]; break;
				} break;

			case 'fraction': break; // TODO 16.27.6 <number:fraction>

			case 'day': // 16.27.11 <number:day>
			case 'month': // 16.27.12 <number:month>
			case 'year': // 16.27.13 <number:year>
			case 'era': // 16.27.14 <number:era>
			case 'day-of-week': // 16.27.15 <number:day-of-week>
			case 'week-of-year': // 16.27.16 <number:week-of-year>
			case 'quarter': // 16.27.17 <number:quarter>
			case 'hours': // 16.27.19 <number:hours>
			case 'minutes': // 16.27.20 <number:minutes>
			case 'seconds': // 16.27.21 <number:seconds>
			case 'am-pm': // 16.27.22 <number:am-pm>
				switch(state[state.length-1][0]) {
					case 'time-style':
					case 'date-style':
						tag = parsexmltag(Rn[0], false);
						NF += number_formats[Rn[3]][tag.style==='long'?1:0]; break;
				} break;

			case 'boolean-style': break; // 16.27.23 <number:boolean-style>
			case 'boolean': break; // 16.27.24 <number:boolean>
			case 'text-style': break; // 16.27.25 <number:text-style>
			case 'text': // 16.27.26 <number:text>
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") switch(state[state.length-1][0]) {
					case 'number-style':
					case 'date-style':
					case 'time-style':
						NF += str.slice(pidx, Rn.index);
						break;
				}
				else pidx = Rn.index + Rn[0].length;
				break;

			case 'named-range': // 9.4.12 <table:named-range>
				tag = parsexmltag(Rn[0], false);
				_Ref = ods_to_csf_3D(tag['cell-range-address']);
				var nrange = ({Name:tag.name, Ref:_Ref[0] + '!' + _Ref[1]});
				if(intable) nrange.Sheet = SheetNames.length;
				WB.Names.push(nrange);
				break;

			case 'text-content': break; // 16.27.27 <number:text-content>
			case 'text-properties': break; // 16.27.27 <style:text-properties>
			case 'embedded-text': break; // 16.27.4 <number:embedded-text>

			case 'body': case '电子表格': break; // 3.3 16.9.6 19.726.3

			case 'forms': break; // 12.25.2 13.2
			case 'table-column': break; // 9.1.6 <table:table-column>
			case 'table-header-rows': break; // 9.1.7 <table:table-header-rows>
			case 'table-rows': break; // 9.1.12 <table:table-rows>
			/* TODO: outline levels */
			case 'table-column-group': break; // 9.1.10 <table:table-column-group>
			case 'table-header-columns': break; // 9.1.11 <table:table-header-columns>
			case 'table-columns': break; // 9.1.12 <table:table-columns>

			case 'null-date': break; // 9.4.2 <table:null-date> TODO: date1904

			case 'graphic-properties': break; // 17.21 <style:graphic-properties>
			case 'calculation-settings': break; // 9.4.1 <table:calculation-settings>
			case 'named-expressions': break; // 9.4.11 <table:named-expressions>
			case 'label-range': break; // 9.4.9 <table:label-range>
			case 'label-ranges': break; // 9.4.10 <table:label-ranges>
			case 'named-expression': break; // 9.4.13 <table:named-expression>
			case 'sort': break; // 9.4.19 <table:sort>
			case 'sort-by': break; // 9.4.20 <table:sort-by>
			case 'sort-groups': break; // 9.4.22 <table:sort-groups>

			case 'tab': break; // 6.1.4 <text:tab>
			case 'line-break': break; // 6.1.5 <text:line-break>
			case 'span': break; // 6.1.7 <text:span>
			case 'p': case '文本串': // 5.1.3 <text:p>
				if(Rn[1]==='/' && (!ctag || !ctag['string-value'])) {
					var ptp = parse_text_p(str.slice(textpidx,Rn.index), textptag);
					textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
				} else { textptag = parsexmltag(Rn[0], false); textpidx = Rn.index + Rn[0].length; }
				break; // <text:p>
			case 's': break; // <text:s>

			case 'database-range': // 9.4.15 <table:database-range>
				if(Rn[1]==='/') break;
				try {
					_Ref = ods_to_csf_3D(parsexmltag(Rn[0])['target-range-address']);
					Sheets[_Ref[0]]['!autofilter'] = { ref:_Ref[1] };
				} catch(e) {/* empty */}
				break;

			case 'date': break; // <*:date>

			case 'object': break; // 10.4.6.2 <draw:object>
			case 'title': case '标题': break; // <*:title> OR <uof:标题>
			case 'desc': break; // <*:desc>
			case 'binary-data': break; // 10.4.5 TODO: b64 blob

			/* 9.2 Advanced Tables */
			case 'table-source': break; // 9.2.6
			case 'scenario': break; // 9.2.6

			case 'iteration': break; // 9.4.3 <table:iteration>
			case 'content-validations': break; // 9.4.4 <table:
			case 'content-validation': break; // 9.4.5 <table:
			case 'help-message': break; // 9.4.6 <table:
			case 'error-message': break; // 9.4.7 <table:
			case 'database-ranges': break; // 9.4.14 <table:database-ranges>
			case 'filter': break; // 9.5.2 <table:filter>
			case 'filter-and': break; // 9.5.3 <table:filter-and>
			case 'filter-or': break; // 9.5.4 <table:filter-or>
			case 'filter-condition': break; // 9.5.5 <table:filter-condition>

			case 'list-level-style-bullet': break; // 16.31 <text:
			case 'list-level-style-number': break; // 16.32 <text:
			case 'list-level-properties': break; // 17.19 <style:

			/* 7.3 Document Fields */
			case 'sender-firstname': // 7.3.6.2
			case 'sender-lastname': // 7.3.6.3
			case 'sender-initials': // 7.3.6.4
			case 'sender-title': // 7.3.6.5
			case 'sender-position': // 7.3.6.6
			case 'sender-email': // 7.3.6.7
			case 'sender-phone-private': // 7.3.6.8
			case 'sender-fax': // 7.3.6.9
			case 'sender-company': // 7.3.6.10
			case 'sender-phone-work': // 7.3.6.11
			case 'sender-street': // 7.3.6.12
			case 'sender-city': // 7.3.6.13
			case 'sender-postal-code': // 7.3.6.14
			case 'sender-country': // 7.3.6.15
			case 'sender-state-or-province': // 7.3.6.16
			case 'author-name': // 7.3.7.1
			case 'author-initials': // 7.3.7.2
			case 'chapter': // 7.3.8
			case 'file-name': // 7.3.9
			case 'template-name': // 7.3.9
			case 'sheet-name': // 7.3.9
				break;

			case 'event-listener':
				break;
			/* TODO: FODS Properties */
			case 'initial-creator':
			case 'creation-date':
			case 'print-date':
			case 'generator':
			case 'document-statistic':
			case 'user-defined':
			case 'editing-duration':
			case 'editing-cycles':
				break;

			/* TODO: FODS Config */
			case 'config-item':
				break;

			/* TODO: style tokens */
			case 'page-number': break; // TODO <text:page-number>
			case 'page-count': break; // TODO <text:page-count>
			case 'time': break; // TODO <text:time>

			/* 9.3 Advanced Table Cells */
			case 'cell-range-source': break; // 9.3.1 <table:
			case 'detective': break; // 9.3.2 <table:
			case 'operation': break; // 9.3.3 <table:
			case 'highlighted-range': break; // 9.3.4 <table:

			/* 9.6 Data Pilot Tables <table: */
			case 'data-pilot-table': // 9.6.3
			case 'source-cell-range': // 9.6.5
			case 'source-service': // 9.6.6
			case 'data-pilot-field': // 9.6.7
			case 'data-pilot-level': // 9.6.8
			case 'data-pilot-subtotals': // 9.6.9
			case 'data-pilot-subtotal': // 9.6.10
			case 'data-pilot-members': // 9.6.11
			case 'data-pilot-member': // 9.6.12
			case 'data-pilot-display-info': // 9.6.13
			case 'data-pilot-sort-info': // 9.6.14
			case 'data-pilot-layout-info': // 9.6.15
			case 'data-pilot-field-reference': // 9.6.16
			case 'data-pilot-groups': // 9.6.17
			case 'data-pilot-group': // 9.6.18
			case 'data-pilot-group-member': // 9.6.19
				break;

			/* 10.3 Drawing Shapes */
			case 'rect': // 10.3.2
				break;

			/* 14.6 DDE Connections */
			case 'dde-connection-decls': // 14.6.2 <text:
			case 'dde-connection-decl': // 14.6.3 <text:
			case 'dde-link': // 14.6.4 <table:
			case 'dde-source': // 14.6.5 <office:
				break;

			case 'properties': break; // 13.7 <form:properties>
			case 'property': break; // 13.8 <form:property>

			case 'a': // 6.1.8 hyperlink
				if(Rn[1]!== '/') {
					atag = parsexmltag(Rn[0], false);
					if(!atag.href) break;
					atag.Target = atag.href; delete atag.href;
					if(atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
						_Ref = ods_to_csf_3D(atag.Target.slice(1));
						atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
					}
				}
				break;

			/* non-standard */
			case 'table-protection': break;
			case 'data-pilot-grand-total': break; // <table:
			case 'office-document-common-attrs': break; // bare
			default: switch(Rn[2]) {
				case 'dc:':       // TODO: properties
				case 'calcext:':  // ignore undocumented extensions
				case 'loext:':    // ignore undocumented extensions
				case 'ooo:':      // ignore undocumented extensions
				case 'chartooo:': // ignore undocumented extensions
				case 'draw:':     // TODO: drawing
				case 'style:':    // TODO: styles
				case 'chart:':    // TODO: charts
				case 'form:':     // TODO: forms
				case 'uof:':      // TODO: uof
				case '表:':       // TODO: uof
				case '字:':       // TODO: uof
					break;
				default: if(opts.WTF) throw new Error(Rn);
			}
		}
		var out = ({
			Sheets: Sheets,
			SheetNames: SheetNames,
			Workbook: WB
		});
		if(opts.bookSheets) delete out.Sheets;
		return out;
	};
})();

function parse_ods(zip, opts) {
	opts = opts || ({});
	var ods = !!safegetzipfile(zip, 'objectdata');
	if(ods) parse_manifest(getzipdata(zip, 'META-INF/manifest.xml'), opts);
	var content = getzipstr(zip, 'content.xml');
	if(!content) throw new Error("Missing content.xml in " + (ods ? "ODS" : "UOF")+ " file");
	var wb = parse_content_xml(ods ? content : utf8read(content), opts);
	if(safegetzipfile(zip, 'meta.xml')) wb.Props = parse_core_props(getzipdata(zip, 'meta.xml'));
	return wb;
}
function parse_fods(data, opts) {
	return parse_content_xml(data, opts);
}

/* OpenDocument */
var write_styles_ods = (function() {
	var payload = '<office:document-styles ' + wxt_helper({
		'xmlns:office':   "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
		'xmlns:table':    "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
		'xmlns:style':    "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
		'xmlns:text':     "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
		'xmlns:draw':     "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
		'xmlns:fo':       "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
		'xmlns:xlink':    "http://www.w3.org/1999/xlink",
		'xmlns:dc':       "http://purl.org/dc/elements/1.1/",
		'xmlns:number':   "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
		'xmlns:svg':      "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
		'xmlns:of':       "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
		'office:version': "1.2"
	}) + '></office:document-styles>';
	return function wso() {
		return XML_HEADER + payload;
	};
})();
var write_content_ods = (function() {
	/* 6.1.2 White Space Characters */
	var write_text_p = function(text) {
		return escapexml(text)
			.replace(/  +/g, function($$){return '<text:s text:c="'+$$.length+'"/>';})
			.replace(/\t/g, "<text:tab/>")
			.replace(/\n/g, "<text:line-break/>")
			.replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
	};

	var null_cell_xml = '          <table:table-cell />\n';
	var covered_cell_xml = '          <table:covered-table-cell/>\n';
	var write_ws = function(ws, wb, i) {
		/* Section 9 Tables */
		var o = [];
		o.push('      <table:table table:name="' + escapexml(wb.SheetNames[i]) + '">\n');
		var R=0,C=0, range = decode_range(ws['!ref']);
		var marr = ws['!merges'] || [], mi = 0;
		var dense = Array.isArray(ws);
		for(R = 0; R < range.s.r; ++R) o.push('        <table:table-row></table:table-row>\n');
		for(; R <= range.e.r; ++R) {
			o.push('        <table:table-row>\n');
			for(C=0; C < range.s.c; ++C) o.push(null_cell_xml);
			for(; C <= range.e.c; ++C) {
				var skip = false, ct = {}, textp = "";
				for(mi = 0; mi != marr.length; ++mi) {
					if(marr[mi].s.c > C) continue;
					if(marr[mi].s.r > R) continue;
					if(marr[mi].e.c < C) continue;
					if(marr[mi].e.r < R) continue;
					if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
					ct['table:number-columns-spanned'] = (marr[mi].e.c - marr[mi].s.c + 1);
					ct['table:number-rows-spanned'] =    (marr[mi].e.r - marr[mi].s.r + 1);
					break;
				}
				if(skip) { o.push(covered_cell_xml); continue; }
				var ref = encode_cell({r:R, c:C}), cell = dense ? (ws[R]||[])[C]: ws[ref];
				if(cell && cell.f) {
					ct['table:formula'] = escapexml(csf_to_ods_formula(cell.f));
					if(cell.F) {
						if(cell.F.slice(0, ref.length) == ref) {
							var _Fref = decode_range(cell.F);
							ct['table:number-matrix-columns-spanned'] = (_Fref.e.c - _Fref.s.c + 1);
							ct['table:number-matrix-rows-spanned'] =    (_Fref.e.r - _Fref.s.r + 1);
						}
					}
				}
				if(!cell) { o.push(null_cell_xml); continue; }
				switch(cell.t) {
					case 'b':
						textp = (cell.v ? 'TRUE' : 'FALSE');
						ct['office:value-type'] = "boolean";
						ct['office:boolean-value'] = (cell.v ? 'true' : 'false');
						break;
					case 'n':
						textp = (cell.w||String(cell.v||0));
						ct['office:value-type'] = "float";
						ct['office:value'] = (cell.v||0);
						break;
					case 's': case 'str':
						textp = cell.v;
						ct['office:value-type'] = "string";
						break;
					case 'd':
						textp = (cell.w||(parseDate(cell.v).toISOString()));
						ct['office:value-type'] = "date";
						ct['office:date-value'] = (parseDate(cell.v).toISOString());
						ct['table:style-name'] = "ce1";
						break;
					//case 'e':
					default: o.push(null_cell_xml); continue;
				}
				var text_p = write_text_p(textp);
				if(cell.l && cell.l.Target) {
					var _tgt = cell.l.Target; _tgt = _tgt.charAt(0) == "#" ? "#" + csf_to_ods_3D(_tgt.slice(1)) : _tgt;
					text_p = writextag('text:a', text_p, {'xlink:href': _tgt});
				}
				o.push('          ' + writextag('table:table-cell', writextag('text:p', text_p, {}), ct) + '\n');
			}
			o.push('        </table:table-row>\n');
		}
		o.push('      </table:table>\n');
		return o.join("");
	};

	var write_automatic_styles_ods = function(o) {
		o.push(' <office:automatic-styles>\n');
		o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
		o.push('   <number:month number:style="long"/>\n');
		o.push('   <number:text>/</number:text>\n');
		o.push('   <number:day number:style="long"/>\n');
		o.push('   <number:text>/</number:text>\n');
		o.push('   <number:year/>\n');
		o.push('  </number:date-style>\n');
		o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
		o.push(' </office:automatic-styles>\n');
	};

	return function wcx(wb, opts) {
		var o = [XML_HEADER];
		/* 3.1.3.2 */
		var attr = wxt_helper({
			'xmlns:office':       "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
			'xmlns:table':        "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
			'xmlns:style':        "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
			'xmlns:text':         "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
			'xmlns:draw':         "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
			'xmlns:fo':           "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
			'xmlns:xlink':        "http://www.w3.org/1999/xlink",
			'xmlns:dc':           "http://purl.org/dc/elements/1.1/",
			'xmlns:meta':         "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
			'xmlns:number':       "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
			'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
			'xmlns:svg':          "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
			'xmlns:chart':        "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
			'xmlns:dr3d':         "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
			'xmlns:math':         "http://www.w3.org/1998/Math/MathML",
			'xmlns:form':         "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
			'xmlns:script':       "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
			'xmlns:ooo':          "http://openoffice.org/2004/office",
			'xmlns:ooow':         "http://openoffice.org/2004/writer",
			'xmlns:oooc':         "http://openoffice.org/2004/calc",
			'xmlns:dom':          "http://www.w3.org/2001/xml-events",
			'xmlns:xforms':       "http://www.w3.org/2002/xforms",
			'xmlns:xsd':          "http://www.w3.org/2001/XMLSchema",
			'xmlns:xsi':          "http://www.w3.org/2001/XMLSchema-instance",
			'xmlns:sheet':        "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
			'xmlns:rpt':          "http://openoffice.org/2005/report",
			'xmlns:of':           "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
			'xmlns:xhtml':        "http://www.w3.org/1999/xhtml",
			'xmlns:grddl':        "http://www.w3.org/2003/g/data-view#",
			'xmlns:tableooo':     "http://openoffice.org/2009/table",
			'xmlns:drawooo':      "http://openoffice.org/2010/draw",
			'xmlns:calcext':      "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
			'xmlns:loext':        "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
			'xmlns:field':        "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
			'xmlns:formx':        "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
			'xmlns:css3t':        "http://www.w3.org/TR/css3-text/",
			'office:version':     "1.2"
		});

		var fods = wxt_helper({
			'xmlns:config':    "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
			'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
		});

		if(opts.bookType == "fods") o.push('<office:document' + attr + fods + '>\n');
		else o.push('<office:document-content' + attr  + '>\n');
		write_automatic_styles_ods(o);
		o.push('  <office:body>\n');
		o.push('    <office:spreadsheet>\n');
		for(var i = 0; i != wb.SheetNames.length; ++i) o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts));
		o.push('    </office:spreadsheet>\n');
		o.push('  </office:body>\n');
		if(opts.bookType == "fods") o.push('</office:document>');
		else o.push('</office:document-content>');
		return o.join("");
	};
})();

function write_ods(wb, opts) {
	if(opts.bookType == "fods") return write_content_ods(wb, opts);

var zip = new jszip();
	var f = "";

	var manifest = [];
	var rdf = [];

	/* Part 3 Section 3.3 MIME Media Type */
	f = "mimetype";
	zip.file(f, "application/vnd.oasis.opendocument.spreadsheet");

	/* Part 1 Section 2.2 Documents */
	f = "content.xml";
	zip.file(f, write_content_ods(wb, opts));
	manifest.push([f, "text/xml"]);
	rdf.push([f, "ContentFile"]);

	/* TODO: these are hard-coded styles to satiate excel */
	f = "styles.xml";
	zip.file(f, write_styles_ods(wb, opts));
	manifest.push([f, "text/xml"]);
	rdf.push([f, "StylesFile"]);

	/* TODO: this is hard-coded to satiate excel */
	f = "meta.xml";
	zip.file(f, write_meta_ods());
	manifest.push([f, "text/xml"]);
	rdf.push([f, "MetadataFile"]);

	/* Part 3 Section 6 Metadata Manifest File */
	f = "manifest.rdf";
	zip.file(f, write_rdf(rdf/*, opts*/));
	manifest.push([f, "application/rdf+xml"]);

	/* Part 3 Section 4 Manifest File */
	f = "META-INF/manifest.xml";
	zip.file(f, write_manifest(manifest/*, opts*/));

	return zip;
}

function write_sheet_index(wb, sheet) {
	if(!sheet) return 0;
	var idx = wb.SheetNames.indexOf(sheet);
	if(idx == -1) throw new Error("Sheet not found: " + sheet);
	return idx;
}

function write_obj_str(factory) {
	return function write_str(wb, o) {
		var idx = write_sheet_index(wb, o.sheet);
		return factory.from_sheet(wb.Sheets[wb.SheetNames[idx]], o, wb);
	};
}

var write_htm_str = write_obj_str(HTML_);
var write_csv_str = write_obj_str({from_sheet:sheet_to_csv});
var write_slk_str = write_obj_str(SYLK);
var write_dif_str = write_obj_str(DIF);
var write_prn_str = write_obj_str(PRN);
var write_rtf_str = write_obj_str(RTF);
var write_txt_str = write_obj_str({from_sheet:sheet_to_txt});
var write_dbf_buf = write_obj_str(DBF);
var write_eth_str = write_obj_str(ETH);

function fix_opts_func(defaults) {
	return function fix_opts(opts) {
		for(var i = 0; i != defaults.length; ++i) {
			var d = defaults[i];
			if(opts[d[0]] === undefined) opts[d[0]] = d[1];
			if(d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
		}
	};
}

var fix_read_opts = fix_opts_func([
	['cellNF', false], /* emit cell number format string as .z */
	['cellHTML', true], /* emit html string as .h */
	['cellFormula', true], /* emit formulae as .f */
	['cellStyles', false], /* emits style/theme as .s */
	['cellText', true], /* emit formatted text as .w */
	['cellDates', false], /* emit date cells with type `d` */

	['sheetStubs', false], /* emit empty cells */
	['sheetRows', 0, 'n'], /* read n rows (0 = read all rows) */

	['bookDeps', false], /* parse calculation chains */
	['bookSheets', false], /* only try to get sheet names (no Sheets) */
	['bookProps', false], /* only try to get properties (no Sheets) */
	['bookFiles', false], /* include raw file structure (keys, files, cfb) */
	['bookVBA', false], /* include vba raw data (vbaraw) */

	['password',''], /* password */
	['WTF', false] /* WTF mode (throws errors) */
]);


var fix_write_opts = fix_opts_func([
	['cellDates', false], /* write date cells with type `d` */

	['bookSST', false], /* Generate Shared String Table */

	['bookType', 'xlsx'], /* Type of workbook (xlsx/m/b) */

	['compression', false], /* Use file compression */

	['WTF', false] /* WTF mode (throws errors) */
]);
function get_sheet_type(n) {
	if(RELS.WS.indexOf(n) > -1) return "sheet";
	if(RELS.CS && n == RELS.CS) return "chart";
	if(RELS.DS && n == RELS.DS) return "dialog";
	if(RELS.MS && n == RELS.MS) return "macro";
	return (n && n.length) ? n : "sheet";
}
function safe_parse_wbrels(wbrels, sheets) {
	if(!wbrels) return 0;
	try {
		wbrels = sheets.map(function pwbr(w) { if(!w.id) w.id = w.strRelID; return [w.name, wbrels['!id'][w.id].Target, get_sheet_type(wbrels['!id'][w.id].Type)]; });
	} catch(e) { return null; }
	return !wbrels || wbrels.length === 0 ? null : wbrels;
}

function safe_parse_sheet(zip, path, relsPath, sheet, idx, sheetRels, sheets, stype, opts, wb, themes, styles) {
	try {
		sheetRels[sheet]=parse_rels(getzipstr(zip, relsPath, true), path);
		var data = getzipdata(zip, path);
		var _ws;
		switch(stype) {
			case 'sheet':  _ws = parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
			case 'chart':  _ws = parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
				if(!_ws || !_ws['!chart']) break;
				var dfile = resolve_path(_ws['!chart'].Target, path);
				var drelsp = get_rels_path(dfile);
				var draw = parse_drawing(getzipstr(zip, dfile, true), parse_rels(getzipstr(zip, drelsp, true), dfile));
				var chartp = resolve_path(draw, dfile);
				var crelsp = get_rels_path(chartp);
				_ws = parse_chart(getzipstr(zip, chartp, true), chartp, opts, parse_rels(getzipstr(zip, crelsp, true), chartp), wb, _ws);
				break;
			case 'macro':  _ws = parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
			case 'dialog': _ws = parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
		}
		sheets[sheet] = _ws;
	} catch(e) { if(opts.WTF) throw e; }
}

function strip_front_slash(x) { return x.charAt(0) == '/' ? x.slice(1) : x; }

function parse_zip(zip, opts) {
	make_ssf(SSF);
	opts = opts || {};
	fix_read_opts(opts);

	/* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */
	if(safegetzipfile(zip, 'META-INF/manifest.xml')) return parse_ods(zip, opts);
	/* UOC */
	if(safegetzipfile(zip, 'objectdata.xml')) return parse_ods(zip, opts);
	/* Numbers */
	if(safegetzipfile(zip, 'Index/Document.iwa')) throw new Error('Unsupported NUMBERS file');

	var entries = zipentries(zip);
	var dir = parse_ct((getzipstr(zip, '[Content_Types].xml')));
	var xlsb = false;
	var sheets, binname;
	if(dir.workbooks.length === 0) {
		binname = "xl/workbook.xml";
		if(getzipdata(zip,binname, true)) dir.workbooks.push(binname);
	}
	if(dir.workbooks.length === 0) {
		binname = "xl/workbook.bin";
		if(!getzipdata(zip,binname,true)) throw new Error("Could not find workbook");
		dir.workbooks.push(binname);
		xlsb = true;
	}
	if(dir.workbooks[0].slice(-3) == "bin") xlsb = true;

	var themes = ({});
	var styles = ({});
	if(!opts.bookSheets && !opts.bookProps) {
		strs = [];
		if(dir.sst) try { strs=parse_sst(getzipdata(zip, strip_front_slash(dir.sst)), dir.sst, opts); } catch(e) { if(opts.WTF) throw e; }

		if(opts.cellStyles && dir.themes.length) themes = parse_theme(getzipstr(zip, dir.themes[0].replace(/^\//,''), true)||"",dir.themes[0], opts);

		if(dir.style) styles = parse_sty(getzipdata(zip, strip_front_slash(dir.style)), dir.style, themes, opts);
	}

	/*var externbooks = */dir.links.map(function(link) {
		return parse_xlink(getzipdata(zip, strip_front_slash(link)), link, opts);
	});

	var wb = parse_wb(getzipdata(zip, strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);

	var props = {}, propdata = "";

	if(dir.coreprops.length) {
		propdata = getzipdata(zip, strip_front_slash(dir.coreprops[0]), true);
		if(propdata) props = parse_core_props(propdata);
		if(dir.extprops.length !== 0) {
			propdata = getzipdata(zip, strip_front_slash(dir.extprops[0]), true);
			if(propdata) parse_ext_props(propdata, props, opts);
		}
	}

	var custprops = {};
	if(!opts.bookSheets || opts.bookProps) {
		if (dir.custprops.length !== 0) {
			propdata = getzipstr(zip, strip_front_slash(dir.custprops[0]), true);
			if(propdata) custprops = parse_cust_props(propdata, opts);
		}
	}

	var out = ({});
	if(opts.bookSheets || opts.bookProps) {
		if(wb.Sheets) sheets = wb.Sheets.map(function pluck(x){ return x.name; });
		else if(props.Worksheets && props.SheetNames.length > 0) sheets=props.SheetNames;
		if(opts.bookProps) { out.Props = props; out.Custprops = custprops; }
		if(opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
		if(opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
	}
	sheets = {};

	var deps = {};
	if(opts.bookDeps && dir.calcchain) deps=parse_cc(getzipdata(zip, strip_front_slash(dir.calcchain)),dir.calcchain,opts);

	var i=0;
	var sheetRels = ({});
	var path, relsPath;

	{
		var wbsheets = wb.Sheets;
		props.Worksheets = wbsheets.length;
		props.SheetNames = [];
		for(var j = 0; j != wbsheets.length; ++j) {
			props.SheetNames[j] = wbsheets[j].name;
		}
	}

	var wbext = xlsb ? "bin" : "xml";
	var wbrelsi = dir.workbooks[0].lastIndexOf("/");
	var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi+1) + "_rels/" + dir.workbooks[0].slice(wbrelsi+1) + ".rels").replace(/^\//,"");
	if(!safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
	var wbrels = parse_rels(getzipstr(zip, wbrelsfile, true), wbrelsfile);
	if(wbrels) wbrels = safe_parse_wbrels(wbrels, wb.Sheets);

	/* Numbers iOS hack */
	var nmode = (getzipdata(zip,"xl/worksheets/sheet.xml",true))?1:0;
	for(i = 0; i != props.Worksheets; ++i) {
		var stype = "sheet";
		if(wbrels && wbrels[i]) {
			path = 'xl/' + (wbrels[i][1]).replace(/[\/]?xl\//, "");
			if(!safegetzipfile(zip, path)) path = wbrels[i][1];
			if(!safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/.*$/,"") + wbrels[i][1];
			stype = wbrels[i][2];
		} else {
			path = 'xl/worksheets/sheet'+(i+1-nmode)+"." + wbext;
			path = path.replace(/sheet0\./,"sheet.");
		}
		relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
		safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
	}

	if(dir.comments) parse_comments(zip, dir.comments, sheets, sheetRels, opts);

	out = ({
		Directory: dir,
		Workbook: wb,
		Props: props,
		Custprops: custprops,
		Deps: deps,
		Sheets: sheets,
		SheetNames: props.SheetNames,
		Strings: strs,
		Styles: styles,
		Themes: themes,
		SSF: SSF.get_table()
	});
	if(opts.bookFiles) {
		out.keys = entries;
		out.files = zip.files;
	}
	if(opts.bookVBA) {
		if(dir.vba.length > 0) out.vbaraw = getzipdata(zip,strip_front_slash(dir.vba[0]),true);
		else if(dir.defaults && dir.defaults.bin === CT_VBA) out.vbaraw = getzipdata(zip, 'xl/vbaProject.bin',true);
	}
	return out;
}

/* [MS-OFFCRYPTO] 2.1.1 */
function parse_xlsxcfb(cfb, _opts) {
	var opts = _opts || {};
	var f = 'Workbook', data = CFB.find(cfb, f);
	try {
	f = '/!DataSpaces/Version';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	/*var version = */parse_DataSpaceVersionInfo(data.content);

	/* 2.3.4.1 */
	f = '/!DataSpaces/DataSpaceMap';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	var dsm = parse_DataSpaceMap(data.content);
	if(dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage")
		throw new Error("ECMA-376 Encrypted file bad " + f);

	/* 2.3.4.2 */
	f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	var seds = parse_DataSpaceDefinition(data.content);
	if(seds.length != 1 || seds[0] != "StrongEncryptionTransform")
		throw new Error("ECMA-376 Encrypted file bad " + f);

	/* 2.3.4.3 */
	f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	/*var hdr = */parse_Primary(data.content);
	} catch(e) {}

	f = '/EncryptionInfo';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	var einfo = parse_EncryptionInfo(data.content);

	/* 2.3.4.4 */
	f = '/EncryptedPackage';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);

/*global decrypt_agile */
if(einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
/*global decrypt_std76 */
if(einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
	throw new Error("File is password-protected");
}

function write_zip(wb, opts) {
	_shapeid = 1024;
	if(opts.bookType == "ods") return write_ods(wb, opts);
	if(wb && !wb.SSF) {
		wb.SSF = SSF.get_table();
	}
	if(wb && wb.SSF) {
		make_ssf(SSF); SSF.load_table(wb.SSF);
		// $FlowIgnore
		opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
		opts.ssf = wb.SSF;
	}
	opts.rels = {}; opts.wbrels = {};
	opts.Strings = []; opts.Strings.Count = 0; opts.Strings.Unique = 0;
	if(browser_has_Map) opts.revStrings = new Map();
	else { opts.revStrings = {}; opts.revStrings.foo = []; delete opts.revStrings.foo; }
	var wbext = opts.bookType == "xlsb" ? "bin" : "xml";
	var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
	var ct = new_ct();
	fix_write_opts(opts = opts || {});
var zip = new jszip();
	var f = "", rId = 0;

	opts.cellXfs = [];
	get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});

	if(!wb.Props) wb.Props = {};

	f = "docProps/core.xml";
	zip.file(f, write_core_props(wb.Props, opts));
	ct.coreprops.push(f);
	add_rels(opts.rels, 2, f, RELS.CORE_PROPS);

f = "docProps/app.xml";
	if(wb.Props && wb.Props.SheetNames){/* empty */}
	else if(!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
	else {
		var _sn = [];
		for(var _i = 0; _i < wb.SheetNames.length; ++_i)
			if((wb.Workbook.Sheets[_i]||{}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
		wb.Props.SheetNames = _sn;
	}
	wb.Props.Worksheets = wb.Props.SheetNames.length;
	zip.file(f, write_ext_props(wb.Props, opts));
	ct.extprops.push(f);
	add_rels(opts.rels, 3, f, RELS.EXT_PROPS);

	if(wb.Custprops !== wb.Props && keys(wb.Custprops||{}).length > 0) {
		f = "docProps/custom.xml";
		zip.file(f, write_cust_props(wb.Custprops, opts));
		ct.custprops.push(f);
		add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
	}

	for(rId=1;rId <= wb.SheetNames.length; ++rId) {
		var wsrels = {'!id':{}};
		var ws = wb.Sheets[wb.SheetNames[rId-1]];
		var _type = (ws || {})["!type"] || "sheet";
		switch(_type) {
		case "chart": /*
			f = "xl/chartsheets/sheet" + rId + "." + wbext;
			zip.file(f, write_cs(rId-1, f, opts, wb, wsrels));
			ct.charts.push(f);
			add_rels(wsrels, -1, "chartsheets/sheet" + rId + "." + wbext, RELS.CS);
			break; */
			/* falls through */
		default:
			f = "xl/worksheets/sheet" + rId + "." + wbext;
			zip.file(f, write_ws(rId-1, f, opts, wb, wsrels));
			ct.sheets.push(f);
			add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
		}

		if(ws) {
			var comments = ws['!comments'];
			var need_vml = false;
			if(comments && comments.length > 0) {
				var cf = "xl/comments" + rId + "." + wbext;
				zip.file(cf, write_cmnt(comments, cf, opts));
				ct.comments.push(cf);
				add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
				need_vml = true;
			}
			if(ws['!legacy']) {
				if(need_vml) zip.file("xl/drawings/vmlDrawing" + (rId) + ".vml", write_comments_vml(rId, ws['!comments']));
			}
			delete ws['!comments'];
			delete ws['!legacy'];
		}

		if(wsrels['!id'].rId1) zip.file(get_rels_path(f), write_rels(wsrels));
	}

	if(opts.Strings != null && opts.Strings.length > 0) {
		f = "xl/sharedStrings." + wbext;
		zip.file(f, write_sst(opts.Strings, f, opts));
		ct.strs.push(f);
		add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
	}

	f = "xl/workbook." + wbext;
	zip.file(f, write_wb(wb, f, opts));
	ct.workbooks.push(f);
	add_rels(opts.rels, 1, f, RELS.WB);

	/* TODO: something more intelligent with themes */

	f = "xl/theme/theme1.xml";
	zip.file(f, write_theme(wb.Themes, opts));
	ct.themes.push(f);
	add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);

	/* TODO: something more intelligent with styles */

	f = "xl/styles." + wbext;
	zip.file(f, write_sty(wb, f, opts));
	ct.styles.push(f);
	add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);

	if(wb.vbaraw && vbafmt) {
		f = "xl/vbaProject.bin";
		zip.file(f, wb.vbaraw);
		ct.vba.push(f);
		add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
	}

	zip.file("[Content_Types].xml", write_ct(ct, opts));
	zip.file('_rels/.rels', write_rels(opts.rels));
	zip.file('xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));

	delete opts.revssf; delete opts.ssf;
	return zip;
}
function firstbyte(f,o) {
	var x = "";
	switch((o||{}).type || "base64") {
		case 'buffer': return [f[0], f[1], f[2], f[3]];
		case 'base64': x = Base64.decode(f.slice(0,24)); break;
		case 'binary': x = f; break;
		case 'array':  return [f[0], f[1], f[2], f[3]];
		default: throw new Error("Unrecognized type " + (o && o.type || "undefined"));
	}
	return [x.charCodeAt(0), x.charCodeAt(1), x.charCodeAt(2), x.charCodeAt(3)];
}

function read_cfb(cfb, opts) {
	if(CFB.find(cfb, "EncryptedPackage")) return parse_xlsxcfb(cfb, opts);
	return parse_xlscfb(cfb, opts);
}

function read_zip(data, opts) {
var zip, d = data;
	var o = opts||{};
	if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
	switch(o.type) {
		case "base64": zip = new jszip(d, { base64:true }); break;
		case "binary": case "array": zip = new jszip(d, { base64:false }); break;
		case "buffer": zip = new jszip(d); break;
		default: throw new Error("Unrecognized type " + o.type);
	}
	return parse_zip(zip, o);
}

function read_plaintext(data, o) {
	var i = 0;
	main: while(i < data.length) switch(data.charCodeAt(i)) {
		case 0x0A: case 0x0D: case 0x20: ++i; break;
		case 0x3C: return parse_xlml(data.slice(i),o);
		default: break main;
	}
	return PRN.to_workbook(data, o);
}

function read_plaintext_raw(data, o) {
	var str = "", bytes = firstbyte(data, o);
	switch(o.type) {
		case 'base64': str = Base64.decode(data); break;
		case 'binary': str = data; break;
		case 'buffer': str = data.toString('binary'); break;
		case 'array': str = cc2str(data); break;
		default: throw new Error("Unrecognized type " + o.type);
	}
	if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str);
	return read_plaintext(str, o);
}

function read_utf16(data, o) {
	var d = data;
	if(o.type == 'base64') d = Base64.decode(d);
	d = cptable.utils.decode(1200, d.slice(2), 'str');
	o.type = "binary";
	return read_plaintext(d, o);
}

function bstrify(data) {
	return !data.match(/[^\x00-\x7F]/) ? data : utf8write(data);
}

function read_prn(data, d, o, str) {
	if(str) { o.type = "string"; return PRN.to_workbook(data, o); }
	return PRN.to_workbook(d, o);
}

function readSync(data, opts) {
	reset_cp();
	if(typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return readSync(new Uint8Array(data), opts);
	var d = data, n = [0,0,0,0], str = false;
	var o = opts||{};
	_ssfopts = {};
	if(o.dateNF) _ssfopts.dateNF = o.dateNF;
	if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
	if(o.type == "file") { o.type = has_buf ? "buffer" : "binary"; d = read_binary(data); }
	if(o.type == "string") { str = true; o.type = "binary"; o.codepage = 65001; d = bstrify(data); }
	if(o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
		// $FlowIgnore
		var ab=new ArrayBuffer(3), vu=new Uint8Array(ab); vu.foo="bar";
		// $FlowIgnore
		if(!vu.foo) {o=dup(o); o.type='array'; return readSync(ab2a(d), o);}
	}
	switch((n = firstbyte(d, o))[0]) {
		case 0xD0: return read_cfb(CFB.read(d, o), o);
		case 0x09: return parse_xlscfb(d, o);
		case 0x3C: return parse_xlml(d, o);
		case 0x49: if(n[1] === 0x44) return read_wb_ID(d, o); break;
		case 0x54: if(n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return DIF.to_workbook(d, o); break;
		case 0x50: return (n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09) ? read_zip(d, o) : read_prn(data, d, o, str);
		case 0xEF: return n[3] === 0x3C ? parse_xlml(d, o) : read_prn(data, d, o, str);
		case 0xFF: if(n[1] === 0xFE) { return read_utf16(d, o); } break;
		case 0x00: if(n[1] === 0x00 && n[2] >= 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o); break;
		case 0x03: case 0x83: case 0x8B: case 0x8C: return DBF.to_workbook(d, o);
		case 0x7B: if(n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return RTF.to_workbook(d, o); break;
		case 0x0A: case 0x0D: case 0x20: return read_plaintext_raw(d, o);
	}
	if(n[2] <= 12 && n[3] <= 31) return DBF.to_workbook(d, o);
	return read_prn(data, d, o, str);
}

function readFileSync(filename, opts) {
	var o = opts||{}; o.type = 'file';
	return readSync(filename, o);
}
function write_cfb_ctr(cfb, o) {
	switch(o.type) {
		case "base64": case "binary": break;
		case "buffer": case "array": o.type = ""; break;
		case "file": return write_dl(o.file, CFB.write(cfb, {type:has_buf ? 'buffer' : ""}));
		case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
		default: throw new Error("Unrecognized type " + o.type);
	}
	return CFB.write(cfb, o);
}

/*global encrypt_agile */
function write_zip_type(wb, opts) {
	var o = opts||{};
	var z = write_zip(wb, o);
	var oopts = {};
	if(o.compression) oopts.compression = 'DEFLATE';
	if(o.password) oopts.type = has_buf ? "nodebuffer" : "string";
	else switch(o.type) {
		case "base64": oopts.type = "base64"; break;
		case "binary": oopts.type = "string"; break;
		case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
		case "buffer":
		case "file": oopts.type = has_buf ? "nodebuffer" : "string"; break;
		default: throw new Error("Unrecognized type " + o.type);
	}
	var out = z.generate(oopts);
	if(o.password && typeof encrypt_agile !== 'undefined') return write_cfb_ctr(encrypt_agile(out, o.password), o);
	if(o.type === "file") return write_dl(o.file, out);
	return o.type == "string" ? utf8read(out) : out;
}

function write_cfb_type(wb, opts) {
	var o = opts||{};
	var cfb = write_xlscfb(wb, o);
	return write_cfb_ctr(cfb, o);
}

function write_string_type(out, opts, bom) {
	if(!bom) bom = "";
	var o = bom + out;
	switch(opts.type) {
		case "base64": return Base64.encode(utf8write(o));
		case "binary": return utf8write(o);
		case "string": return out;
		case "file": return write_dl(opts.file, o, 'utf8');
		case "buffer": {
			// $FlowIgnore
			if(has_buf) return Buffer_from(o, 'utf8');
			else return write_string_type(o, {type:'binary'}).split("").map(function(c) { return c.charCodeAt(0); });
		}
	}
	throw new Error("Unrecognized type " + opts.type);
}

function write_stxt_type(out, opts) {
	switch(opts.type) {
		case "base64": return Base64.encode(out);
		case "binary": return out;
		case "string": return out; /* override in sheet_to_txt */
		case "file": return write_dl(opts.file, out, 'binary');
		case "buffer": {
			// $FlowIgnore
			if(has_buf) return Buffer_from(out, 'binary');
			else return out.split("").map(function(c) { return c.charCodeAt(0); });
		}
	}
	throw new Error("Unrecognized type " + opts.type);
}

/* TODO: test consistency */
function write_binary_type(out, opts) {
	switch(opts.type) {
		case "string":
		case "base64":
		case "binary":
			var bstr = "";
			// $FlowIgnore
			for(var i = 0; i < out.length; ++i) bstr += String.fromCharCode(out[i]);
			return opts.type == 'base64' ? Base64.encode(bstr) : opts.type == 'string' ? utf8read(bstr) : bstr;
		case "file": return write_dl(opts.file, out);
		case "buffer": return out;
		default: throw new Error("Unrecognized type " + opts.type);
	}
}

function writeSync(wb, opts) {
	check_wb(wb);
	var o = opts||{};
	if(o.type == "array") { o.type = "binary"; var out = (writeSync(wb, o)); o.type = "array"; return s2ab(out); }
	switch(o.bookType || 'xlsb') {
		case 'xml':
		case 'xlml': return write_string_type(write_xlml(wb, o), o);
		case 'slk':
		case 'sylk': return write_string_type(write_slk_str(wb, o), o);
		case 'htm':
		case 'html': return write_string_type(write_htm_str(wb, o), o);
		case 'txt': return write_stxt_type(write_txt_str(wb, o), o);
		case 'csv': return write_string_type(write_csv_str(wb, o), o, "\ufeff");
		case 'dif': return write_string_type(write_dif_str(wb, o), o);
		case 'dbf': return write_binary_type(write_dbf_buf(wb, o), o);
		case 'prn': return write_string_type(write_prn_str(wb, o), o);
		case 'rtf': return write_string_type(write_rtf_str(wb, o), o);
		case 'eth': return write_string_type(write_eth_str(wb, o), o);
		case 'fods': return write_string_type(write_ods(wb, o), o);
		case 'biff2': if(!o.biff) o.biff = 2; /* falls through */
		case 'biff3': if(!o.biff) o.biff = 3; /* falls through */
		case 'biff4': if(!o.biff) o.biff = 4; return write_binary_type(write_biff_buf(wb, o), o);
		case 'biff5': if(!o.biff) o.biff = 5; /* falls through */
		case 'biff8':
		case 'xla':
		case 'xls': if(!o.biff) o.biff = 8; return write_cfb_type(wb, o);
		case 'xlsx':
		case 'xlsm':
		case 'xlam':
		case 'xlsb':
		case 'ods': return write_zip_type(wb, o);
		default: throw new Error ("Unrecognized bookType |" + o.bookType + "|");
	}
}

function resolve_book_type(o) {
	if(o.bookType) return;
	var _BT = {
		"xls": "biff8",
		"htm": "html",
		"slk": "sylk",
		"socialcalc": "eth",
		"Sh33tJS": "WTF"
	};
	var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
	if(ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
	o.bookType = _BT[o.bookType] || o.bookType;
}

function writeFileSync(wb, filename, opts) {
	var o = opts||{}; o.type = 'file';
	o.file = filename;
	resolve_book_type(o);
	return writeSync(wb, o);
}

function writeFileAsync(filename, wb, opts, cb) {
	var o = opts||{}; o.type = 'file';
	o.file = filename;
	resolve_book_type(o);
	o.type = 'buffer';
	var _cb = cb; if(!(_cb instanceof Function)) _cb = (opts);
	return _fs.writeFile(filename, writeSync(wb, o), _cb);
}
function make_json_row(sheet, r, R, cols, header, hdr, dense, o) {
	var rr = encode_row(R);
	var defval = o.defval, raw = o.raw || !o.hasOwnProperty("raw");
	var isempty = true;
	var row = (header === 1) ? [] : {};
	if(header !== 1) {
		if(Object.defineProperty) try { Object.defineProperty(row, '__rowNum__', {value:R, enumerable:false}); } catch(e) { row.__rowNum__ = R; }
		else row.__rowNum__ = R;
	}
	if(!dense || sheet[R]) for (var C = r.s.c; C <= r.e.c; ++C) {
		var val = dense ? sheet[R][C] : sheet[cols[C] + rr];
		if(val === undefined || val.t === undefined) {
			if(defval === undefined) continue;
			if(hdr[C] != null) { row[hdr[C]] = defval; }
			continue;
		}
		var v = val.v;
		switch(val.t){
			case 'z': if(v == null) break; continue;
			case 'e': v = void 0; break;
			case 's': case 'd': case 'b': case 'n': break;
			default: throw new Error('unrecognized type ' + val.t);
		}
		if(hdr[C] != null) {
			if(v == null) {
				if(defval !== undefined) row[hdr[C]] = defval;
				else if(raw && v === null) row[hdr[C]] = null;
				else continue;
			} else {
				row[hdr[C]] = raw ? v : format_cell(val,v,o);
			}
			if(v != null) isempty = false;
		}
	}
	return { row: row, isempty: isempty };
}


function sheet_to_json(sheet, opts) {
	if(sheet == null || sheet["!ref"] == null) return [];
	var val = {t:'n',v:0}, header = 0, offset = 1, hdr = [], v=0, vv="";
	var r = {s:{r:0,c:0},e:{r:0,c:0}};
	var o = opts || {};
	var range = o.range != null ? o.range : sheet["!ref"];
	if(o.header === 1) header = 1;
	else if(o.header === "A") header = 2;
	else if(Array.isArray(o.header)) header = 3;
	switch(typeof range) {
		case 'string': r = safe_decode_range(range); break;
		case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
		default: r = range;
	}
	if(header > 0) offset = 0;
	var rr = encode_row(r.s.r);
	var cols = [];
	var out = [];
	var outi = 0, counter = 0;
	var dense = Array.isArray(sheet);
	var R = r.s.r, C = 0, CC = 0;
	if(dense && !sheet[R]) sheet[R] = [];
	for(C = r.s.c; C <= r.e.c; ++C) {
		cols[C] = encode_col(C);
		val = dense ? sheet[R][C] : sheet[cols[C] + rr];
		switch(header) {
			case 1: hdr[C] = C - r.s.c; break;
			case 2: hdr[C] = cols[C]; break;
			case 3: hdr[C] = o.header[C - r.s.c]; break;
			default:
				if(val == null) val = {w: "__EMPTY", t: "s"};
				vv = v = format_cell(val, null, o);
				counter = 0;
				for(CC = 0; CC < hdr.length; ++CC) if(hdr[CC] == vv) vv = v + "_" + (++counter);
				hdr[C] = vv;
		}
	}
	for (R = r.s.r + offset; R <= r.e.r; ++R) {
		var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
		if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
	}
	out.length = outi;
	return out;
}

var qreg = /"/g;
function make_csv_row(sheet, r, R, cols, fs, rs, FS, o) {
	var isempty = true;
	var row = [], txt = "", rr = encode_row(R);
	for(var C = r.s.c; C <= r.e.c; ++C) {
		if (!cols[C]) continue;
		var val = o.dense ? (sheet[R]||[])[C]: sheet[cols[C] + rr];
		if(val == null) txt = "";
		else if(val.v != null) {
			isempty = false;
			txt = ''+format_cell(val, null, o);
			for(var i = 0, cc = 0; i !== txt.length; ++i) if((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34) {txt = "\"" + txt.replace(qreg, '""') + "\""; break; }
			if(txt == "ID") txt = '"ID"';
		} else if(val.f != null && !val.F) {
			isempty = false;
			txt = '=' + val.f; if(txt.indexOf(",") >= 0) txt = '"' + txt.replace(qreg, '""') + '"';
		} else txt = "";
		/* NOTE: Excel CSV does not support array formulae */
		row.push(txt);
	}
	if(o.blankrows === false && isempty) return null;
	return row.join(FS);
}

function sheet_to_csv(sheet, opts) {
	var out = [];
	var o = opts == null ? {} : opts;
	if(sheet == null || sheet["!ref"] == null) return "";
	var r = safe_decode_range(sheet["!ref"]);
	var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
	var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
	var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
	var row = "", cols = [];
	o.dense = Array.isArray(sheet);
	var colinfo = o.skipHidden && sheet["!cols"] || [];
	var rowinfo = o.skipHidden && sheet["!rows"] || [];
	for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
	for(var R = r.s.r; R <= r.e.r; ++R) {
		if ((rowinfo[R]||{}).hidden) continue;
		row = make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
		if(row == null) { continue; }
		if(o.strip) row = row.replace(endregex,"");
		out.push(row + RS);
	}
	delete o.dense;
	return out.join("");
}

function sheet_to_txt(sheet, opts) {
	if(!opts) opts = {}; opts.FS = "\t"; opts.RS = "\n";
	var s = sheet_to_csv(sheet, opts);
	if(typeof cptable == 'undefined' || opts.type == 'string') return s;
	var o = cptable.utils.encode(1200, s, 'str');
	return String.fromCharCode(255) + String.fromCharCode(254) + o;
}

function sheet_to_formulae(sheet) {
	var y = "", x, val="";
	if(sheet == null || sheet["!ref"] == null) return [];
	var r = safe_decode_range(sheet['!ref']), rr = "", cols = [], C;
	var cmds = [];
	var dense = Array.isArray(sheet);
	for(C = r.s.c; C <= r.e.c; ++C) cols[C] = encode_col(C);
	for(var R = r.s.r; R <= r.e.r; ++R) {
		rr = encode_row(R);
		for(C = r.s.c; C <= r.e.c; ++C) {
			y = cols[C] + rr;
			x = dense ? (sheet[R]||[])[C] : sheet[y];
			val = "";
			if(x === undefined) continue;
			else if(x.F != null) {
				y = x.F;
				if(!x.f) continue;
				val = x.f;
				if(y.indexOf(":") == -1) y = y + ":" + y;
			}
			if(x.f != null) val = x.f;
			else if(x.t == 'z') continue;
			else if(x.t == 'n' && x.v != null) val = "" + x.v;
			else if(x.t == 'b') val = x.v ? "TRUE" : "FALSE";
			else if(x.w !== undefined) val = "'" + x.w;
			else if(x.v === undefined) continue;
			else if(x.t == 's') val = "'" + x.v;
			else val = ""+x.v;
			cmds[cmds.length] = y + "=" + val;
		}
	}
	return cmds;
}

function sheet_add_json(_ws, js, opts) {
	var o = opts || {};
	var offset = +!o.skipHeader;
	var ws = _ws || ({});
	var _R = 0, _C = 0;
	if(ws && o.origin != null) {
		if(typeof o.origin == 'number') _R = o.origin;
		else {
			var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
			_R = _origin.r; _C = _origin.c;
		}
	}
	var cell;
	var range = ({s: {c:0, r:0}, e: {c:_C, r:_R + js.length - 1 + offset}});
	if(ws['!ref']) {
		var _range = safe_decode_range(ws['!ref']);
		range.e.c = Math.max(range.e.c, _range.e.c);
		range.e.r = Math.max(range.e.r, _range.e.r);
		if(_R == -1) { _R = range.e.r + 1; range.e.r = _R + js.length - 1 + offset; }
	}
	var hdr = o.header || [], C = 0;

	js.forEach(function (JS, R) {
		keys(JS).forEach(function(k) {
			if((C=hdr.indexOf(k)) == -1) hdr[C=hdr.length] = k;
			var v = JS[k];
			var t = 'z';
			var z = "";
			if(v && typeof v === 'object' && !(v instanceof Date)){
				ws[encode_cell({c:_C + C,r:_R + R + offset})] = v;
			} else {
				if(typeof v == 'number') t = 'n';
				else if(typeof v == 'boolean') t = 'b';
				else if(typeof v == 'string') t = 's';
				else if(v instanceof Date) {
					t = 'd';
					if(!o.cellDates) { t = 'n'; v = datenum(v); }
					z = o.dateNF || SSF._table[14];
				}
				ws[encode_cell({c:_C + C,r:_R + R + offset})] = cell = ({t:t, v:v});
				if(z) cell.z = z;
			}
		});
	});
	range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
	var __R = encode_row(_R);
	if(offset) for(C = 0; C < hdr.length; ++C) ws[encode_col(C + _C) + __R] = {t:'s', v:hdr[C]};
	ws['!ref'] = encode_range(range);
	return ws;
}
function json_to_sheet(js, opts) { return sheet_add_json(null, js, opts); }

var utils = {
	encode_col: encode_col,
	encode_row: encode_row,
	encode_cell: encode_cell,
	encode_range: encode_range,
	decode_col: decode_col,
	decode_row: decode_row,
	split_cell: split_cell,
	decode_cell: decode_cell,
	decode_range: decode_range,
	format_cell: format_cell,
	get_formulae: sheet_to_formulae,
	make_csv: sheet_to_csv,
	make_json: sheet_to_json,
	make_formulae: sheet_to_formulae,
	sheet_add_aoa: sheet_add_aoa,
	sheet_add_json: sheet_add_json,
	aoa_to_sheet: aoa_to_sheet,
	json_to_sheet: json_to_sheet,
	table_to_sheet: parse_dom_table,
	table_to_book: table_to_book,
	sheet_to_csv: sheet_to_csv,
	sheet_to_txt: sheet_to_txt,
	sheet_to_json: sheet_to_json,
	sheet_to_html: HTML_.from_sheet,
	sheet_to_dif: DIF.from_sheet,
	sheet_to_slk: SYLK.from_sheet,
	sheet_to_eth: ETH.from_sheet,
	sheet_to_formulae: sheet_to_formulae,
	sheet_to_row_object_array: sheet_to_json
};

(function(utils) {
utils.consts = utils.consts || {};
function add_consts(R/*Array<any>*/) { R.forEach(function(a){ utils.consts[a[0]] = a[1]; }); }

function get_default(x, y, z) { return x[y] != null ? x[y] : (x[y] = z); }

/* get cell, creating a stub if necessary */
function ws_get_cell_stub(ws, R, C) {
	/* A1 cell address */
	if(typeof R == "string") return ws[R] || (ws[R] = {t:'z'});
	/* cell address object */
	if(typeof R != "number") return ws_get_cell_stub(ws, encode_cell(R));
	/* R and C are 0-based indices */
	return ws_get_cell_stub(ws, encode_cell({r:R,c:C||0}));
}

/* find sheet index for given name / validate index */
function wb_sheet_idx(wb, sh) {
	if(typeof sh == "number") {
		if(sh >= 0 && wb.SheetNames.length > sh) return sh;
		throw new Error("Cannot find sheet # " + sh);
	} else if(typeof sh == "string") {
		var idx = wb.SheetNames.indexOf(sh);
		if(idx > -1) return idx;
		throw new Error("Cannot find sheet name |" + sh + "|");
	} else throw new Error("Cannot find sheet |" + sh + "|");
}

/* simple blank workbook object */
utils.book_new = function() {
	return { SheetNames: [], Sheets: {} };
};

/* add a worksheet to the end of a given workbook */
utils.book_append_sheet = function(wb, ws, name) {
	if(!name) for(var i = 1; i <= 0xFFFF; ++i) if(wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
	if(!name) throw new Error("Too many worksheets");
	check_ws_name(name);
	if(wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");

	wb.SheetNames.push(name);
	wb.Sheets[name] = ws;
};

/* set sheet visibility (visible/hidden/very hidden) */
utils.book_set_sheet_visibility = function(wb, sh, vis) {
	get_default(wb,"Workbook",{});
	get_default(wb.Workbook,"Sheets",[]);

	var idx = wb_sheet_idx(wb, sh);
	// $FlowIgnore
	get_default(wb.Workbook.Sheets,idx, {});

	switch(vis) {
		case 0: case 1: case 2: break;
		default: throw new Error("Bad sheet visibility setting " + vis);
	}
	// $FlowIgnore
	wb.Workbook.Sheets[idx].Hidden = vis;
};
add_consts([
	["SHEET_VISIBLE", 0],
	["SHEET_HIDDEN", 1],
	["SHEET_VERY_HIDDEN", 2]
]);

/* set number format */
utils.cell_set_number_format = function(cell, fmt) {
	cell.z = fmt;
	return cell;
};

/* set cell hyperlink */
utils.cell_set_hyperlink = function(cell, target, tooltip) {
	if(!target) {
		delete cell.l;
	} else {
		cell.l = ({ Target: target });
		if(tooltip) cell.l.Tooltip = tooltip;
	}
	return cell;
};
utils.cell_set_internal_link = function(cell, range, tooltip) { return utils.cell_set_hyperlink(cell, "#" + range, tooltip); };

/* add to cell comments */
utils.cell_add_comment = function(cell, text, author) {
	if(!cell.c) cell.c = [];
	cell.c.push({t:text, a:author||"SheetJS"});
};

/* set array formula and flush related cells */
utils.sheet_set_array_formula = function(ws, range, formula) {
	var rng = typeof range != "string" ? range : safe_decode_range(range);
	var rngstr = typeof range == "string" ? range : encode_range(range);
	for(var R = rng.s.r; R <= rng.e.r; ++R) for(var C = rng.s.c; C <= rng.e.c; ++C) {
		var cell = ws_get_cell_stub(ws, R, C);
		cell.t = 'n';
		cell.F = rngstr;
		delete cell.v;
		if(R == rng.s.r && C == rng.s.c) cell.f = formula;
	}
	return ws;
};

return utils;
})(utils);

if(has_buf && "function" != 'undefined') (function() {
	var Readable = __webpack_require__(1466).Readable;

	var write_csv_stream = function(sheet, opts) {
		var stream = Readable();
		var o = opts == null ? {} : opts;
		if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
		var r = safe_decode_range(sheet["!ref"]);
		var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
		var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
		var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
		var row = "", cols = [];
		o.dense = Array.isArray(sheet);
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
		var R = r.s.r;
		var BOM = false;
		stream._read = function() {
			if(!BOM) { BOM = true; return stream.push("\uFEFF"); }
			while(R <= r.e.r) {
				++R;
				if ((rowinfo[R-1]||{}).hidden) continue;
				row = make_csv_row(sheet, r, R-1, cols, fs, rs, FS, o);
				if(row != null) {
					if(o.strip) row = row.replace(endregex,"");
					stream.push(row + RS);
					break;
				}
			}
			if(R > r.e.r) return stream.push(null);
		};
		return stream;
	};

	var write_html_stream = function(ws, opts) {
		var stream = Readable();

		var o = opts || {};
		var header = o.header != null ? o.header : HTML_.BEGIN;
		var footer = o.footer != null ? o.footer : HTML_.END;
		stream.push(header);
		var r = decode_range(ws['!ref']);
		o.dense = Array.isArray(ws);
		stream.push(HTML_._preamble(ws, r, o));
		var R = r.s.r;
		var end = false;
		stream._read = function() {
			if(R > r.e.r) {
				if(!end) { end = true; stream.push("</table>" + footer); }
				return stream.push(null);
			}
			while(R <= r.e.r) {
				stream.push(HTML_._row(ws, r, R, o));
				++R;
				break;
			}
		};
		return stream;
	};

	var write_json_stream = function(sheet, opts) {
		var stream = Readable({objectMode:true});

		if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
		var val = {t:'n',v:0}, header = 0, offset = 1, hdr = [], v=0, vv="";
		var r = {s:{r:0,c:0},e:{r:0,c:0}};
		var o = opts || {};
		var range = o.range != null ? o.range : sheet["!ref"];
		if(o.header === 1) header = 1;
		else if(o.header === "A") header = 2;
		else if(Array.isArray(o.header)) header = 3;
		switch(typeof range) {
			case 'string': r = safe_decode_range(range); break;
			case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
			default: r = range;
		}
		if(header > 0) offset = 0;
		var rr = encode_row(r.s.r);
		var cols = [];
		var counter = 0;
		var dense = Array.isArray(sheet);
		var R = r.s.r, C = 0, CC = 0;
		if(dense && !sheet[R]) sheet[R] = [];
		for(C = r.s.c; C <= r.e.c; ++C) {
			cols[C] = encode_col(C);
			val = dense ? sheet[R][C] : sheet[cols[C] + rr];
			switch(header) {
				case 1: hdr[C] = C - r.s.c; break;
				case 2: hdr[C] = cols[C]; break;
				case 3: hdr[C] = o.header[C - r.s.c]; break;
				default:
					if(val == null) val = {w: "__EMPTY", t: "s"};
					vv = v = format_cell(val, null, o);
					counter = 0;
					for(CC = 0; CC < hdr.length; ++CC) if(hdr[CC] == vv) vv = v + "_" + (++counter);
					hdr[C] = vv;
			}
		}
		R = r.s.r + offset;
		stream._read = function() {
			if(R > r.e.r) return stream.push(null);
			while(R <= r.e.r) {
				//if ((rowinfo[R-1]||{}).hidden) continue;
				var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
				++R;
				if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
					stream.push(row.row);
					break;
				}
			}
		};
		return stream;
	};

	XLSX.stream = {
		to_json: write_json_stream,
		to_html: write_html_stream,
		to_csv: write_csv_stream
	};
})();

XLSX.parse_xlscfb = parse_xlscfb;
XLSX.parse_ods = parse_ods;
XLSX.parse_fods = parse_fods;
XLSX.write_ods = write_ods;
XLSX.parse_zip = parse_zip;
XLSX.read = readSync; //xlsread
XLSX.readFile = readFileSync; //readFile
XLSX.readFileSync = readFileSync;
XLSX.write = writeSync;
XLSX.writeFile = writeFileSync;
XLSX.writeFileSync = writeFileSync;
XLSX.writeFileAsync = writeFileAsync;
XLSX.utils = utils;
XLSX.SSF = SSF;
XLSX.CFB = CFB;
}
/*global define */
if(true) make_xlsx_lib(exports);
else if(typeof module !== 'undefined' && module.exports) make_xlsx_lib(module.exports);
else if(typeof define === 'function' && define.amd) define('xlsx', function() { if(!XLSX.version) make_xlsx_lib(XLSX); return XLSX; });
else make_xlsx_lib(XLSX);
/*exported XLS, ODS */
var XLS = XLSX, ODS = XLSX;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22), __webpack_require__(155).Buffer, __webpack_require__(156)))

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/* cpexcel.js (C) 2013-present SheetJS -- http://sheetjs.com */
/*jshint -W100 */
var cptable = {version:"1.14.0"};
cptable[437] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[620] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàąçêëèïîćÄĄĘęłôöĆûùŚÖÜ¢Ł¥śƒŹŻóÓńŃźż¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[737] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[850] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[852] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[857] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[861] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[865] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[866] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[874] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[895] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ČüéďäĎŤčěĚĹÍľǪÄÁÉžŽôöÓůÚýÖÜŠĽÝŘťáíóúňŇŮÔšřŕŔ¼§«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[932] = (function(){ var d = [], e = {}, D = [], j;
D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ��������������������������������".split("");
for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
D[129] = "����������������������������������������������������������������　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×�÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓�����������∈∋⊆⊇⊂⊃∪∩��������∧∨￢⇒⇔∀∃�����������∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬�������Å‰♯♭♪†‡¶����◯���".split("");
for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
D[130] = "�������������������������������������������������������������������������������０１２３４５６７８９�������ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ�������ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ����ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん��������������".split("");
for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
D[131] = "����������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミ�ムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ��������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�����������������������������������������".split("");
for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
D[132] = "����������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмн�опрстуфхцчшщъыьэюя�������������─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂�����������������������������������������������������������������".split("");
for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
D[135] = "����������������������������������������������������������������①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡��������㍻�〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪���������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
D[136] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭���".split("");
for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
D[137] = "����������������������������������������������������������������院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円�園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改���".split("");
for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
D[138] = "����������������������������������������������������������������魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫�橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄���".split("");
for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
D[139] = "����������������������������������������������������������������機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救�朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈���".split("");
for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
D[140] = "����������������������������������������������������������������掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨�劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向���".split("");
for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
D[141] = "����������������������������������������������������������������后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降�項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷���".split("");
for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
D[142] = "����������������������������������������������������������������察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止�死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周���".split("");
for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
D[143] = "����������������������������������������������������������������宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳�準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾���".split("");
for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
D[144] = "����������������������������������������������������������������拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨�逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線���".split("");
for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
D[145] = "����������������������������������������������������������������繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻�操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只���".split("");
for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
D[146] = "����������������������������������������������������������������叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄�逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓���".split("");
for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
D[147] = "����������������������������������������������������������������邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬�凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入���".split("");
for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
D[148] = "����������������������������������������������������������������如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅�楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美���".split("");
for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
D[149] = "����������������������������������������������������������������鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷�斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋���".split("");
for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
D[150] = "����������������������������������������������������������������法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆�摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒���".split("");
for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
D[151] = "����������������������������������������������������������������諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲�沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯���".split("");
for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
D[152] = "����������������������������������������������������������������蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕��������������������������������������������弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲���".split("");
for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
D[153] = "����������������������������������������������������������������僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭�凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨���".split("");
for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
D[154] = "����������������������������������������������������������������咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸�噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩���".split("");
for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
D[155] = "����������������������������������������������������������������奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀�它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏���".split("");
for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
D[156] = "����������������������������������������������������������������廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠�怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛���".split("");
for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
D[157] = "����������������������������������������������������������������戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫�捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼���".split("");
for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
D[158] = "����������������������������������������������������������������曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎�梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣���".split("");
for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
D[159] = "����������������������������������������������������������������檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯�麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌���".split("");
for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
D[224] = "����������������������������������������������������������������漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝�烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱���".split("");
for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
D[225] = "����������������������������������������������������������������瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿�痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬���".split("");
for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
D[226] = "����������������������������������������������������������������磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰�窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆���".split("");
for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
D[227] = "����������������������������������������������������������������紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷�縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋���".split("");
for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
D[228] = "����������������������������������������������������������������隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤�艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈���".split("");
for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
D[229] = "����������������������������������������������������������������蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬�蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞���".split("");
for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
D[230] = "����������������������������������������������������������������襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧�諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊���".split("");
for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
D[231] = "����������������������������������������������������������������蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜�轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮���".split("");
for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
D[232] = "����������������������������������������������������������������錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙�閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰���".split("");
for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
D[233] = "����������������������������������������������������������������顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃�騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈���".split("");
for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
D[234] = "����������������������������������������������������������������鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯�黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙�������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
D[237] = "����������������������������������������������������������������纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏�塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱���".split("");
for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
D[238] = "����������������������������������������������������������������犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙�蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑��ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ￢￤＇＂���".split("");
for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
D[250] = "����������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊�兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯���".split("");
for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
D[251] = "����������������������������������������������������������������涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神�祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙���".split("");
for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
D[252] = "����������������������������������������������������������������髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑������������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
return {"enc": e, "dec": d }; })();
cptable[936] = (function(){ var d = [], e = {}, D = [], j;
D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
D[129] = "����������������������������������������������������������������丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪乫乬乭乮乯乲乴乵乶乷乸乹乺乻乼乽乿亀亁亂亃亄亅亇亊�亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂伃伄伅伆伇伈伋伌伒伓伔伕伖伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾伿佀佁佂佄佅佇佈佉佊佋佌佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢�".split("");
for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
D[130] = "����������������������������������������������������������������侤侫侭侰侱侲侳侴侶侷侸侹侺侻侼侽侾俀俁係俆俇俈俉俋俌俍俒俓俔俕俖俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿倀倁倂倃倄倅倆倇倈倉倊�個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯倰倱倲倳倴倵倶倷倸倹倻倽倿偀偁偂偄偅偆偉偊偋偍偐偑偒偓偔偖偗偘偙偛偝偞偟偠偡偢偣偤偦偧偨偩偪偫偭偮偯偰偱偲偳側偵偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎傏傐傑傒傓傔傕傖傗傘備傚傛傜傝傞傟傠傡傢傤傦傪傫傭傮傯傰傱傳傴債傶傷傸傹傼�".split("");
for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
D[131] = "����������������������������������������������������������������傽傾傿僀僁僂僃僄僅僆僇僈僉僊僋僌働僎僐僑僒僓僔僕僗僘僙僛僜僝僞僟僠僡僢僣僤僥僨僩僪僫僯僰僱僲僴僶僷僸價僺僼僽僾僿儀儁儂儃億儅儈�儉儊儌儍儎儏儐儑儓儔儕儖儗儘儙儚儛儜儝儞償儠儢儣儤儥儦儧儨儩優儫儬儭儮儯儰儱儲儳儴儵儶儷儸儹儺儻儼儽儾兂兇兊兌兎兏児兒兓兗兘兙兛兝兞兟兠兡兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦冧冨冩冪冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒凓凔凕凖凗�".split("");
for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
D[132] = "����������������������������������������������������������������凘凙凚凜凞凟凢凣凥処凧凨凩凪凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄剅剆則剈剉剋剎剏剒剓剕剗剘�剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳剴創剶剷剸剹剺剻剼剾劀劃劄劅劆劇劉劊劋劌劍劎劏劑劒劔劕劖劗劘劙劚劜劤劥劦劧劮劯劰労劵劶劷劸効劺劻劼劽勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務勚勛勜勝勞勠勡勢勣勥勦勧勨勩勪勫勬勭勮勯勱勲勳勴勵勶勷勸勻勼勽匁匂匃匄匇匉匊匋匌匎�".split("");
for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
D[133] = "����������������������������������������������������������������匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯匰匱匲匳匴匵匶匷匸匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏�厐厑厒厓厔厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯厰厱厲厳厴厵厷厸厹厺厼厽厾叀參叄叅叆叇収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝呞呟呠呡呣呥呧呩呪呫呬呭呮呯呰呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡�".split("");
for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
D[134] = "����������������������������������������������������������������咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠員哢哣哤哫哬哯哰哱哴哵哶哷哸哹哻哾唀唂唃唄唅唈唊唋唌唍唎唒唓唕唖唗唘唙唚唜唝唞唟唡唥唦�唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋啌啍啎問啑啒啓啔啗啘啙啚啛啝啞啟啠啢啣啨啩啫啯啰啱啲啳啴啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠喡喢喣喤喥喦喨喩喪喫喬喭單喯喰喲喴営喸喺喼喿嗀嗁嗂嗃嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗嗘嗙嗚嗛嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸嗹嗺嗻嗼嗿嘂嘃嘄嘅�".split("");
for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
D[135] = "����������������������������������������������������������������嘆嘇嘊嘋嘍嘐嘑嘒嘓嘔嘕嘖嘗嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀噁噂噃噄噅噆噇噈噉噊噋噏噐噑噒噓噕噖噚噛噝噞噟噠噡�噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽噾噿嚀嚁嚂嚃嚄嚇嚈嚉嚊嚋嚌嚍嚐嚑嚒嚔嚕嚖嚗嚘嚙嚚嚛嚜嚝嚞嚟嚠嚡嚢嚤嚥嚦嚧嚨嚩嚪嚫嚬嚭嚮嚰嚱嚲嚳嚴嚵嚶嚸嚹嚺嚻嚽嚾嚿囀囁囂囃囄囅囆囇囈囉囋囌囍囎囏囐囑囒囓囕囖囘囙囜団囥囦囧囨囩囪囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國圌圍圎圏圐圑�".split("");
for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
D[136] = "����������������������������������������������������������������園圓圔圕圖圗團圙圚圛圝圞圠圡圢圤圥圦圧圫圱圲圴圵圶圷圸圼圽圿坁坃坄坅坆坈坉坋坒坓坔坕坖坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀�垁垇垈垉垊垍垎垏垐垑垔垕垖垗垘垙垚垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹垺垻垼垽垾垿埀埁埄埅埆埇埈埉埊埌埍埐埑埓埖埗埛埜埞埡埢埣埥埦埧埨埩埪埫埬埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥堦堧堨堩堫堬堭堮堯報堲堳場堶堷堸堹堺堻堼堽�".split("");
for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
D[137] = "����������������������������������������������������������������堾堿塀塁塂塃塅塆塇塈塉塊塋塎塏塐塒塓塕塖塗塙塚塛塜塝塟塠塡塢塣塤塦塧塨塩塪塭塮塯塰塱塲塳塴塵塶塷塸塹塺塻塼塽塿墂墄墆墇墈墊墋墌�墍墎墏墐墑墔墕墖増墘墛墜墝墠墡墢墣墤墥墦墧墪墫墬墭墮墯墰墱墲墳墴墵墶墷墸墹墺墻墽墾墿壀壂壃壄壆壇壈壉壊壋壌壍壎壏壐壒壓壔壖壗壘壙壚壛壜壝壞壟壠壡壢壣壥壦壧壨壩壪壭壯壱売壴壵壷壸壺壻壼壽壾壿夀夁夃夅夆夈変夊夋夌夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻�".split("");
for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
D[138] = "����������������������������������������������������������������夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛奜奝奞奟奡奣奤奦奧奨奩奪奫奬奭奮奯奰奱奲奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦�妧妬妭妰妱妳妴妵妶妷妸妺妼妽妿姀姁姂姃姄姅姇姈姉姌姍姎姏姕姖姙姛姞姟姠姡姢姤姦姧姩姪姫姭姮姯姰姱姲姳姴姵姶姷姸姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪娫娬娭娮娯娰娳娵娷娸娹娺娻娽娾娿婁婂婃婄婅婇婈婋婌婍婎婏婐婑婒婓婔婖婗婘婙婛婜婝婞婟婠�".split("");
for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
D[139] = "����������������������������������������������������������������婡婣婤婥婦婨婩婫婬婭婮婯婰婱婲婳婸婹婻婼婽婾媀媁媂媃媄媅媆媇媈媉媊媋媌媍媎媏媐媑媓媔媕媖媗媘媙媜媝媞媟媠媡媢媣媤媥媦媧媨媩媫媬�媭媮媯媰媱媴媶媷媹媺媻媼媽媿嫀嫃嫄嫅嫆嫇嫈嫊嫋嫍嫎嫏嫐嫑嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬嫭嫮嫯嫰嫲嫳嫴嫵嫶嫷嫸嫹嫺嫻嫼嫽嫾嫿嬀嬁嬂嬃嬄嬅嬆嬇嬈嬊嬋嬌嬍嬎嬏嬐嬑嬒嬓嬔嬕嬘嬙嬚嬛嬜嬝嬞嬟嬠嬡嬢嬣嬤嬥嬦嬧嬨嬩嬪嬫嬬嬭嬮嬯嬰嬱嬳嬵嬶嬸嬹嬺嬻嬼嬽嬾嬿孁孂孃孄孅孆孇�".split("");
for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
D[140] = "����������������������������������������������������������������孈孉孊孋孌孍孎孏孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏�寑寔寕寖寗寘寙寚寛寜寠寢寣實寧審寪寫寬寭寯寱寲寳寴寵寶寷寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧屨屩屪屫屬屭屰屲屳屴屵屶屷屸屻屼屽屾岀岃岄岅岆岇岉岊岋岎岏岒岓岕岝岞岟岠岡岤岥岦岧岨�".split("");
for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
D[141] = "����������������������������������������������������������������岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅峆峇峈峉峊峌峍峎峏峐峑峓峔峕峖峗峘峚峛峜峝峞峟峠峢峣峧峩峫峬峮峯峱峲峳峴峵島峷峸峹峺峼峽峾峿崀�崁崄崅崈崉崊崋崌崍崏崐崑崒崓崕崗崘崙崚崜崝崟崠崡崢崣崥崨崪崫崬崯崰崱崲崳崵崶崷崸崹崺崻崼崿嵀嵁嵂嵃嵄嵅嵆嵈嵉嵍嵎嵏嵐嵑嵒嵓嵔嵕嵖嵗嵙嵚嵜嵞嵟嵠嵡嵢嵣嵤嵥嵦嵧嵨嵪嵭嵮嵰嵱嵲嵳嵵嵶嵷嵸嵹嵺嵻嵼嵽嵾嵿嶀嶁嶃嶄嶅嶆嶇嶈嶉嶊嶋嶌嶍嶎嶏嶐嶑嶒嶓嶔嶕嶖嶗嶘嶚嶛嶜嶞嶟嶠�".split("");
for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
D[142] = "����������������������������������������������������������������嶡嶢嶣嶤嶥嶦嶧嶨嶩嶪嶫嶬嶭嶮嶯嶰嶱嶲嶳嶴嶵嶶嶸嶹嶺嶻嶼嶽嶾嶿巀巁巂巃巄巆巇巈巉巊巋巌巎巏巐巑巒巓巔巕巖巗巘巙巚巜巟巠巣巤巪巬巭�巰巵巶巸巹巺巻巼巿帀帄帇帉帊帋帍帎帒帓帗帞帟帠帡帢帣帤帥帨帩帪師帬帯帰帲帳帴帵帶帹帺帾帿幀幁幃幆幇幈幉幊幋幍幎幏幐幑幒幓幖幗幘幙幚幜幝幟幠幣幤幥幦幧幨幩幪幫幬幭幮幯幰幱幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨庩庪庫庬庮庯庰庱庲庴庺庻庼庽庿廀廁廂廃廄廅�".split("");
for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
D[143] = "����������������������������������������������������������������廆廇廈廋廌廍廎廏廐廔廕廗廘廙廚廜廝廞廟廠廡廢廣廤廥廦廧廩廫廬廭廮廯廰廱廲廳廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤�弨弫弬弮弰弲弳弴張弶強弸弻弽弾弿彁彂彃彄彅彆彇彈彉彊彋彌彍彎彏彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢徣徤徥徦徧復徫徬徯徰徱徲徳徴徶徸徹徺徻徾徿忀忁忂忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇�".split("");
for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
D[144] = "����������������������������������������������������������������怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰怱怲怳怴怶怷怸怹怺怽怾恀恄恅恆恇恈恉恊恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀�悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽悾悿惀惁惂惃惄惇惈惉惌惍惎惏惐惒惓惔惖惗惙惛惞惡惢惣惤惥惪惱惲惵惷惸惻惼惽惾惿愂愃愄愅愇愊愋愌愐愑愒愓愔愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬愭愮愯愰愱愲愳愴愵愶愷愸愹愺愻愼愽愾慀慁慂慃慄慅慆�".split("");
for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
D[145] = "����������������������������������������������������������������慇慉態慍慏慐慒慓慔慖慗慘慙慚慛慜慞慟慠慡慣慤慥慦慩慪慫慬慭慮慯慱慲慳慴慶慸慹慺慻慼慽慾慿憀憁憂憃憄憅憆憇憈憉憊憌憍憏憐憑憒憓憕�憖憗憘憙憚憛憜憞憟憠憡憢憣憤憥憦憪憫憭憮憯憰憱憲憳憴憵憶憸憹憺憻憼憽憿懀懁懃懄懅懆懇應懌懍懎懏懐懓懕懖懗懘懙懚懛懜懝懞懟懠懡懢懣懤懥懧懨懩懪懫懬懭懮懯懰懱懲懳懴懶懷懸懹懺懻懼懽懾戀戁戂戃戄戅戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸戹戺戻戼扂扄扅扆扊�".split("");
for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
D[146] = "����������������������������������������������������������������扏扐払扖扗扙扚扜扝扞扟扠扡扢扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋抌抍抎抏抐抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁�拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳挴挵挶挷挸挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖捗捘捙捚捛捜捝捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙掚掛掜掝掞掟採掤掦掫掯掱掲掵掶掹掻掽掿揀�".split("");
for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
D[147] = "����������������������������������������������������������������揁揂揃揅揇揈揊揋揌揑揓揔揕揗揘揙揚換揜揝揟揢揤揥揦揧揨揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆搇搈搉搊損搎搑搒搕搖搗搘搙搚搝搟搢搣搤�搥搧搨搩搫搮搯搰搱搲搳搵搶搷搸搹搻搼搾摀摂摃摉摋摌摍摎摏摐摑摓摕摖摗摙摚摛摜摝摟摠摡摢摣摤摥摦摨摪摫摬摮摯摰摱摲摳摴摵摶摷摻摼摽摾摿撀撁撃撆撈撉撊撋撌撍撎撏撐撓撔撗撘撚撛撜撝撟撠撡撢撣撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆擇擈擉擊擋擌擏擑擓擔擕擖擙據�".split("");
for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
D[148] = "����������������������������������������������������������������擛擜擝擟擠擡擣擥擧擨擩擪擫擬擭擮擯擰擱擲擳擴擵擶擷擸擹擺擻擼擽擾擿攁攂攃攄攅攆攇攈攊攋攌攍攎攏攐攑攓攔攕攖攗攙攚攛攜攝攞攟攠攡�攢攣攤攦攧攨攩攪攬攭攰攱攲攳攷攺攼攽敀敁敂敃敄敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數敹敺敻敼敽敾敿斀斁斂斃斄斅斆斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱斲斳斴斵斶斷斸斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘旙旚旛旜旝旞旟旡旣旤旪旫�".split("");
for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
D[149] = "����������������������������������������������������������������旲旳旴旵旸旹旻旼旽旾旿昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷昸昹昺昻昽昿晀時晄晅晆晇晈晉晊晍晎晐晑晘�晙晛晜晝晞晠晢晣晥晧晩晪晫晬晭晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘暙暚暛暜暞暟暠暡暢暣暤暥暦暩暪暫暬暭暯暰暱暲暳暵暶暷暸暺暻暼暽暿曀曁曂曃曄曅曆曇曈曉曊曋曌曍曎曏曐曑曒曓曔曕曖曗曘曚曞曟曠曡曢曣曤曥曧曨曪曫曬曭曮曯曱曵曶書曺曻曽朁朂會�".split("");
for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
D[150] = "����������������������������������������������������������������朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠朡朢朣朤朥朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗杘杙杚杛杝杢杣杤杦杧杫杬杮東杴杶�杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹枺枻枼枽枾枿柀柂柅柆柇柈柉柊柋柌柍柎柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵柶柷柸柹柺査柼柾栁栂栃栄栆栍栐栒栔栕栘栙栚栛栜栞栟栠栢栣栤栥栦栧栨栫栬栭栮栯栰栱栴栵栶栺栻栿桇桋桍桏桒桖桗桘桙桚桛�".split("");
for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
D[151] = "����������������������������������������������������������������桜桝桞桟桪桬桭桮桯桰桱桲桳桵桸桹桺桻桼桽桾桿梀梂梄梇梈梉梊梋梌梍梎梐梑梒梔梕梖梘梙梚梛梜條梞梟梠梡梣梤梥梩梪梫梬梮梱梲梴梶梷梸�梹梺梻梼梽梾梿棁棃棄棅棆棇棈棊棌棎棏棐棑棓棔棖棗棙棛棜棝棞棟棡棢棤棥棦棧棨棩棪棫棬棭棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆椇椈椉椊椌椏椑椓椔椕椖椗椘椙椚椛検椝椞椡椢椣椥椦椧椨椩椪椫椬椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃楄楅楆楇楈楉楊楋楌楍楎楏楐楑楒楓楕楖楘楙楛楜楟�".split("");
for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
D[152] = "����������������������������������������������������������������楡楢楤楥楧楨楩楪楬業楯楰楲楳楴極楶楺楻楽楾楿榁榃榅榊榋榌榎榏榐榑榒榓榖榗榙榚榝榞榟榠榡榢榣榤榥榦榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽�榾榿槀槂槃槄槅槆槇槈槉構槍槏槑槒槓槕槖槗様槙槚槜槝槞槡槢槣槤槥槦槧槨槩槪槫槬槮槯槰槱槳槴槵槶槷槸槹槺槻槼槾樀樁樂樃樄樅樆樇樈樉樋樌樍樎樏樐樑樒樓樔樕樖標樚樛樜樝樞樠樢樣樤樥樦樧権樫樬樭樮樰樲樳樴樶樷樸樹樺樻樼樿橀橁橂橃橅橆橈橉橊橋橌橍橎橏橑橒橓橔橕橖橗橚�".split("");
for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
D[153] = "����������������������������������������������������������������橜橝橞機橠橢橣橤橦橧橨橩橪橫橬橭橮橯橰橲橳橴橵橶橷橸橺橻橽橾橿檁檂檃檅檆檇檈檉檊檋檌檍檏檒檓檔檕檖檘檙檚檛檜檝檞檟檡檢檣檤檥檦�檧檨檪檭檮檯檰檱檲檳檴檵檶檷檸檹檺檻檼檽檾檿櫀櫁櫂櫃櫄櫅櫆櫇櫈櫉櫊櫋櫌櫍櫎櫏櫐櫑櫒櫓櫔櫕櫖櫗櫘櫙櫚櫛櫜櫝櫞櫟櫠櫡櫢櫣櫤櫥櫦櫧櫨櫩櫪櫫櫬櫭櫮櫯櫰櫱櫲櫳櫴櫵櫶櫷櫸櫹櫺櫻櫼櫽櫾櫿欀欁欂欃欄欅欆欇欈欉權欋欌欍欎欏欐欑欒欓欔欕欖欗欘欙欚欛欜欝欞欟欥欦欨欩欪欫欬欭欮�".split("");
for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
D[154] = "����������������������������������������������������������������欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍歎歏歐歑歒歓歔歕歖歗歘歚歛歜歝歞歟歠歡歨歩歫歬歭歮歯歰歱歲歳歴歵歶歷歸歺歽歾歿殀殅殈�殌殎殏殐殑殔殕殗殘殙殜殝殞殟殠殢殣殤殥殦殧殨殩殫殬殭殮殯殰殱殲殶殸殹殺殻殼殽殾毀毃毄毆毇毈毉毊毌毎毐毑毘毚毜毝毞毟毠毢毣毤毥毦毧毨毩毬毭毮毰毱毲毴毶毷毸毺毻毼毾毿氀氁氂氃氄氈氉氊氋氌氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋汌汍汎汏汑汒汓汖汘�".split("");
for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
D[155] = "����������������������������������������������������������������汙汚汢汣汥汦汧汫汬汭汮汯汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘�泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟洠洡洢洣洤洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽浾浿涀涁涃涄涆涇涊涋涍涏涐涒涖涗涘涙涚涜涢涥涬涭涰涱涳涴涶涷涹涺涻涼涽涾淁淂淃淈淉淊�".split("");
for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
D[156] = "����������������������������������������������������������������淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽淾淿渀渁渂渃渄渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵�渶渷渹渻渼渽渾渿湀湁湂湅湆湇湈湉湊湋湌湏湐湑湒湕湗湙湚湜湝湞湠湡湢湣湤湥湦湧湨湩湪湬湭湯湰湱湲湳湴湵湶湷湸湹湺湻湼湽満溁溂溄溇溈溊溋溌溍溎溑溒溓溔溕準溗溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪滫滬滭滮滯�".split("");
for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
D[157] = "����������������������������������������������������������������滰滱滲滳滵滶滷滸滺滻滼滽滾滿漀漁漃漄漅漇漈漊漋漌漍漎漐漑漒漖漗漘漙漚漛漜漝漞漟漡漢漣漥漦漧漨漬漮漰漲漴漵漷漸漹漺漻漼漽漿潀潁潂�潃潄潅潈潉潊潌潎潏潐潑潒潓潔潕潖潗潙潚潛潝潟潠潡潣潤潥潧潨潩潪潫潬潯潰潱潳潵潶潷潹潻潽潾潿澀澁澂澃澅澆澇澊澋澏澐澑澒澓澔澕澖澗澘澙澚澛澝澞澟澠澢澣澤澥澦澨澩澪澫澬澭澮澯澰澱澲澴澵澷澸澺澻澼澽澾澿濁濃濄濅濆濇濈濊濋濌濍濎濏濐濓濔濕濖濗濘濙濚濛濜濝濟濢濣濤濥�".split("");
for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
D[158] = "����������������������������������������������������������������濦濧濨濩濪濫濬濭濰濱濲濳濴濵濶濷濸濹濺濻濼濽濾濿瀀瀁瀂瀃瀄瀅瀆瀇瀈瀉瀊瀋瀌瀍瀎瀏瀐瀒瀓瀔瀕瀖瀗瀘瀙瀜瀝瀞瀟瀠瀡瀢瀤瀥瀦瀧瀨瀩瀪�瀫瀬瀭瀮瀯瀰瀱瀲瀳瀴瀶瀷瀸瀺瀻瀼瀽瀾瀿灀灁灂灃灄灅灆灇灈灉灊灋灍灎灐灑灒灓灔灕灖灗灘灙灚灛灜灝灟灠灡灢灣灤灥灦灧灨灩灪灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞炟炠炡炢炣炤炥炦炧炨炩炪炰炲炴炵炶為炾炿烄烅烆烇烉烋烌烍烎烏烐烑烒烓烔烕烖烗烚�".split("");
for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
D[159] = "����������������������������������������������������������������烜烝烞烠烡烢烣烥烪烮烰烱烲烳烴烵烶烸烺烻烼烾烿焀焁焂焃焄焅焆焇焈焋焌焍焎焏焑焒焔焗焛焜焝焞焟焠無焢焣焤焥焧焨焩焪焫焬焭焮焲焳焴�焵焷焸焹焺焻焼焽焾焿煀煁煂煃煄煆煇煈煉煋煍煏煐煑煒煓煔煕煖煗煘煙煚煛煝煟煠煡煢煣煥煩煪煫煬煭煯煰煱煴煵煶煷煹煻煼煾煿熀熁熂熃熅熆熇熈熉熋熌熍熎熐熑熒熓熕熖熗熚熛熜熝熞熡熢熣熤熥熦熧熩熪熫熭熮熯熰熱熲熴熶熷熸熺熻熼熽熾熿燀燁燂燄燅燆燇燈燉燊燋燌燍燏燐燑燒燓�".split("");
for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
D[160] = "����������������������������������������������������������������燖燗燘燙燚燛燜燝燞營燡燢燣燤燦燨燩燪燫燬燭燯燰燱燲燳燴燵燶燷燸燺燻燼燽燾燿爀爁爂爃爄爅爇爈爉爊爋爌爍爎爏爐爑爒爓爔爕爖爗爘爙爚�爛爜爞爟爠爡爢爣爤爥爦爧爩爫爭爮爯爲爳爴爺爼爾牀牁牂牃牄牅牆牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅犆犇犈犉犌犎犐犑犓犔犕犖犗犘犙犚犛犜犝犞犠犡犢犣犤犥犦犧犨犩犪犫犮犱犲犳犵犺犻犼犽犾犿狀狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛�".split("");
for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
D[162] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������︵︶︹︺︿﹀︽︾﹁﹂﹃﹄��︻︼︷︸︱�︳︴����������".split("");
for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
D[168] = "����������������������������������������������������������������ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╪╫╬╭╮╯╰╱╲╳▁▂▃▄▅▆▇�█▉▊▋▌▍▎▏▓▔▕▼▽◢◣◤◥☉⊕〒〝〞�����������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ�ńň�ɡ����ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
D[169] = "����������������������������������������������������������������〡〢〣〤〥〦〧〨〩㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤�℡㈱�‐���ー゛゜ヽヾ〆ゝゞ﹉﹊﹋﹌﹍﹎﹏﹐﹑﹒﹔﹕﹖﹗﹙﹚﹛﹜﹝﹞﹟﹠﹡�﹢﹣﹤﹥﹦﹨﹩﹪﹫�������������〇�������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
D[170] = "����������������������������������������������������������������狜狝狟狢狣狤狥狦狧狪狫狵狶狹狽狾狿猀猂猄猅猆猇猈猉猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀獁獂獃獄獅獆獇獈�獉獊獋獌獎獏獑獓獔獕獖獘獙獚獛獜獝獞獟獡獢獣獤獥獦獧獨獩獪獫獮獰獱�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
D[171] = "����������������������������������������������������������������獲獳獴獵獶獷獸獹獺獻獼獽獿玀玁玂玃玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣玤玥玦玧玨玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃珄珅珆珇�珋珌珎珒珓珔珕珖珗珘珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳珴珵珶珷�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
D[172] = "����������������������������������������������������������������珸珹珺珻珼珽現珿琀琁琂琄琇琈琋琌琍琎琑琒琓琔琕琖琗琘琙琜琝琞琟琠琡琣琤琧琩琫琭琯琱琲琷琸琹琺琻琽琾琿瑀瑂瑃瑄瑅瑆瑇瑈瑉瑊瑋瑌瑍�瑎瑏瑐瑑瑒瑓瑔瑖瑘瑝瑠瑡瑢瑣瑤瑥瑦瑧瑨瑩瑪瑫瑬瑮瑯瑱瑲瑳瑴瑵瑸瑹瑺�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
D[173] = "����������������������������������������������������������������瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑璒璓璔璕璖璗璘璙璚璛璝璟璠璡璢璣璤璥璦璪璫璬璭璮璯環璱璲璳璴璵璶璷璸璹璻璼璽璾璿瓀瓁瓂瓃瓄瓅瓆瓇�瓈瓉瓊瓋瓌瓍瓎瓏瓐瓑瓓瓔瓕瓖瓗瓘瓙瓚瓛瓝瓟瓡瓥瓧瓨瓩瓪瓫瓬瓭瓰瓱瓲�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
D[174] = "����������������������������������������������������������������瓳瓵瓸瓹瓺瓻瓼瓽瓾甀甁甂甃甅甆甇甈甉甊甋甌甎甐甒甔甕甖甗甛甝甞甠甡產産甤甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘�畝畞畟畠畡畢畣畤畧畨畩畫畬畭畮畯異畱畳畵當畷畺畻畼畽畾疀疁疂疄疅疇�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
D[175] = "����������������������������������������������������������������疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦疧疨疩疪疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇�瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
D[176] = "����������������������������������������������������������������癅癆癇癈癉癊癋癎癏癐癑癒癓癕癗癘癙癚癛癝癟癠癡癢癤癥癦癧癨癩癪癬癭癮癰癱癲癳癴癵癶癷癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛�皜皝皞皟皠皡皢皣皥皦皧皨皩皪皫皬皭皯皰皳皵皶皷皸皹皺皻皼皽皾盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
D[177] = "����������������������������������������������������������������盄盇盉盋盌盓盕盙盚盜盝盞盠盡盢監盤盦盧盨盩盪盫盬盭盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎眏眐眑眒眓眔眕眖眗眘眛眜眝眞眡眣眤眥眧眪眫�眬眮眰眱眲眳眴眹眻眽眾眿睂睄睅睆睈睉睊睋睌睍睎睏睒睓睔睕睖睗睘睙睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
D[178] = "����������������������������������������������������������������睝睞睟睠睤睧睩睪睭睮睯睰睱睲睳睴睵睶睷睸睺睻睼瞁瞂瞃瞆瞇瞈瞉瞊瞋瞏瞐瞓瞔瞕瞖瞗瞘瞙瞚瞛瞜瞝瞞瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶瞷瞸瞹瞺�瞼瞾矀矁矂矃矄矅矆矇矈矉矊矋矌矎矏矐矑矒矓矔矕矖矘矙矚矝矞矟矠矡矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
D[179] = "����������������������������������������������������������������矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃砄砅砆砇砈砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚�硛硜硞硟硠硡硢硣硤硥硦硧硨硩硯硰硱硲硳硴硵硶硸硹硺硻硽硾硿碀碁碂碃场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
D[180] = "����������������������������������������������������������������碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨碩碪碫碬碭碮碯碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚磛磜磝磞磟磠磡磢磣�磤磥磦磧磩磪磫磭磮磯磰磱磳磵磶磸磹磻磼磽磾磿礀礂礃礄礆礇礈礉礊礋礌础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
D[181] = "����������������������������������������������������������������礍礎礏礐礑礒礔礕礖礗礘礙礚礛礜礝礟礠礡礢礣礥礦礧礨礩礪礫礬礭礮礯礰礱礲礳礵礶礷礸礹礽礿祂祃祄祅祇祊祋祌祍祎祏祐祑祒祔祕祘祙祡祣�祤祦祩祪祫祬祮祰祱祲祳祴祵祶祹祻祼祽祾祿禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
D[182] = "����������������������������������������������������������������禓禔禕禖禗禘禙禛禜禝禞禟禠禡禢禣禤禥禦禨禩禪禫禬禭禮禯禰禱禲禴禵禶禷禸禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙秚秛秜秝秞秠秡秢秥秨秪�秬秮秱秲秳秴秵秶秷秹秺秼秾秿稁稄稅稇稈稉稊稌稏稐稑稒稓稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
D[183] = "����������������������������������������������������������������稝稟稡稢稤稥稦稧稨稩稪稫稬稭種稯稰稱稲稴稵稶稸稺稾穀穁穂穃穄穅穇穈穉穊穋穌積穎穏穐穒穓穔穕穖穘穙穚穛穜穝穞穟穠穡穢穣穤穥穦穧穨�穩穪穫穬穭穮穯穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
D[184] = "����������������������������������������������������������������窣窤窧窩窪窫窮窯窰窱窲窴窵窶窷窸窹窺窻窼窽窾竀竁竂竃竄竅竆竇竈竉竊竌竍竎竏竐竑竒竓竔竕竗竘竚竛竜竝竡竢竤竧竨竩竪竫竬竮竰竱竲竳�竴竵競竷竸竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
D[185] = "����������������������������������������������������������������笯笰笲笴笵笶笷笹笻笽笿筀筁筂筃筄筆筈筊筍筎筓筕筗筙筜筞筟筡筣筤筥筦筧筨筩筪筫筬筭筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆箇箈箉箊箋箌箎箏�箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹箺箻箼箽箾箿節篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
D[186] = "����������������������������������������������������������������篅篈築篊篋篍篎篏篐篒篔篕篖篗篘篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲篳篴篵篶篸篹篺篻篽篿簀簁簂簃簄簅簆簈簉簊簍簎簐簑簒簓簔簕簗簘簙�簚簛簜簝簞簠簡簢簣簤簥簨簩簫簬簭簮簯簰簱簲簳簴簵簶簷簹簺簻簼簽簾籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
D[187] = "����������������������������������������������������������������籃籄籅籆籇籈籉籊籋籌籎籏籐籑籒籓籔籕籖籗籘籙籚籛籜籝籞籟籠籡籢籣籤籥籦籧籨籩籪籫籬籭籮籯籰籱籲籵籶籷籸籹籺籾籿粀粁粂粃粄粅粆粇�粈粊粋粌粍粎粏粐粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴粵粶粷粸粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
D[188] = "����������������������������������������������������������������粿糀糂糃糄糆糉糋糎糏糐糑糒糓糔糘糚糛糝糞糡糢糣糤糥糦糧糩糪糫糬糭糮糰糱糲糳糴糵糶糷糹糺糼糽糾糿紀紁紂紃約紅紆紇紈紉紋紌納紎紏紐�紑紒紓純紕紖紗紘紙級紛紜紝紞紟紡紣紤紥紦紨紩紪紬紭紮細紱紲紳紴紵紶肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
D[189] = "����������������������������������������������������������������紷紸紹紺紻紼紽紾紿絀絁終絃組絅絆絇絈絉絊絋経絍絎絏結絑絒絓絔絕絖絗絘絙絚絛絜絝絞絟絠絡絢絣絤絥給絧絨絩絪絫絬絭絯絰統絲絳絴絵絶�絸絹絺絻絼絽絾絿綀綁綂綃綄綅綆綇綈綉綊綋綌綍綎綏綐綑綒經綔綕綖綗綘健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
D[190] = "����������������������������������������������������������������継続綛綜綝綞綟綠綡綢綣綤綥綧綨綩綪綫綬維綯綰綱網綳綴綵綶綷綸綹綺綻綼綽綾綿緀緁緂緃緄緅緆緇緈緉緊緋緌緍緎総緐緑緒緓緔緕緖緗緘緙�線緛緜緝緞緟締緡緢緣緤緥緦緧編緩緪緫緬緭緮緯緰緱緲緳練緵緶緷緸緹緺尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
D[191] = "����������������������������������������������������������������緻緼緽緾緿縀縁縂縃縄縅縆縇縈縉縊縋縌縍縎縏縐縑縒縓縔縕縖縗縘縙縚縛縜縝縞縟縠縡縢縣縤縥縦縧縨縩縪縫縬縭縮縯縰縱縲縳縴縵縶縷縸縹�縺縼總績縿繀繂繃繄繅繆繈繉繊繋繌繍繎繏繐繑繒繓織繕繖繗繘繙繚繛繜繝俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
D[192] = "����������������������������������������������������������������繞繟繠繡繢繣繤繥繦繧繨繩繪繫繬繭繮繯繰繱繲繳繴繵繶繷繸繹繺繻繼繽繾繿纀纁纃纄纅纆纇纈纉纊纋續纍纎纏纐纑纒纓纔纕纖纗纘纙纚纜纝纞�纮纴纻纼绖绤绬绹缊缐缞缷缹缻缼缽缾缿罀罁罃罆罇罈罉罊罋罌罍罎罏罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
D[193] = "����������������������������������������������������������������罖罙罛罜罝罞罠罣罤罥罦罧罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂羃羄羅羆羇羈羉羋羍羏羐羑羒羓羕羖羗羘羙羛羜羠羢羣羥羦羨義羪羫羬羭羮羱�羳羴羵羶羷羺羻羾翀翂翃翄翆翇翈翉翋翍翏翐翑習翓翖翗翙翚翛翜翝翞翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
D[194] = "����������������������������������������������������������������翤翧翨翪翫翬翭翯翲翴翵翶翷翸翹翺翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫耬耭耮耯耰耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗�聙聛聜聝聞聟聠聡聢聣聤聥聦聧聨聫聬聭聮聯聰聲聳聴聵聶職聸聹聺聻聼聽隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
D[195] = "����������������������������������������������������������������聾肁肂肅肈肊肍肎肏肐肑肒肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇胈胉胊胋胏胐胑胒胓胔胕胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋�脌脕脗脙脛脜脝脟脠脡脢脣脤脥脦脧脨脩脪脫脭脮脰脳脴脵脷脹脺脻脼脽脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
D[196] = "����������������������������������������������������������������腀腁腂腃腄腅腇腉腍腎腏腒腖腗腘腛腜腝腞腟腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃膄膅膆膇膉膋膌膍膎膐膒膓膔膕膖膗膙膚膞膟膠膡膢膤膥�膧膩膫膬膭膮膯膰膱膲膴膵膶膷膸膹膼膽膾膿臄臅臇臈臉臋臍臎臏臐臑臒臓摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
D[197] = "����������������������������������������������������������������臔臕臖臗臘臙臚臛臜臝臞臟臠臡臢臤臥臦臨臩臫臮臯臰臱臲臵臶臷臸臹臺臽臿舃與興舉舊舋舎舏舑舓舕舖舗舘舙舚舝舠舤舥舦舧舩舮舲舺舼舽舿�艀艁艂艃艅艆艈艊艌艍艎艐艑艒艓艔艕艖艗艙艛艜艝艞艠艡艢艣艤艥艦艧艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
D[198] = "����������������������������������������������������������������艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸�苺苼苽苾苿茀茊茋茍茐茒茓茖茘茙茝茞茟茠茡茢茣茤茥茦茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
D[199] = "����������������������������������������������������������������茾茿荁荂荄荅荈荊荋荌荍荎荓荕荖荗荘荙荝荢荰荱荲荳荴荵荶荹荺荾荿莀莁莂莃莄莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡莢莣莤莥莦莧莬莭莮�莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
D[200] = "����������������������������������������������������������������菮華菳菴菵菶菷菺菻菼菾菿萀萂萅萇萈萉萊萐萒萓萔萕萖萗萙萚萛萞萟萠萡萢萣萩萪萫萬萭萮萯萰萲萳萴萵萶萷萹萺萻萾萿葀葁葂葃葄葅葇葈葉�葊葋葌葍葎葏葐葒葓葔葕葖葘葝葞葟葠葢葤葥葦葧葨葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
D[201] = "����������������������������������������������������������������葽葾葿蒀蒁蒃蒄蒅蒆蒊蒍蒏蒐蒑蒒蒓蒔蒕蒖蒘蒚蒛蒝蒞蒟蒠蒢蒣蒤蒥蒦蒧蒨蒩蒪蒫蒬蒭蒮蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗�蓘蓙蓚蓛蓜蓞蓡蓢蓤蓧蓨蓩蓪蓫蓭蓮蓯蓱蓲蓳蓴蓵蓶蓷蓸蓹蓺蓻蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
D[202] = "����������������������������������������������������������������蔃蔄蔅蔆蔇蔈蔉蔊蔋蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢蔣蔤蔥蔦蔧蔨蔩蔪蔭蔮蔯蔰蔱蔲蔳蔴蔵蔶蔾蔿蕀蕁蕂蕄蕅蕆蕇蕋蕌蕍蕎蕏蕐蕑蕒蕓蕔蕕�蕗蕘蕚蕛蕜蕝蕟蕠蕡蕢蕣蕥蕦蕧蕩蕪蕫蕬蕭蕮蕯蕰蕱蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
D[203] = "����������������������������������������������������������������薂薃薆薈薉薊薋薌薍薎薐薑薒薓薔薕薖薗薘薙薚薝薞薟薠薡薢薣薥薦薧薩薫薬薭薱薲薳薴薵薶薸薺薻薼薽薾薿藀藂藃藄藅藆藇藈藊藋藌藍藎藑藒�藔藖藗藘藙藚藛藝藞藟藠藡藢藣藥藦藧藨藪藫藬藭藮藯藰藱藲藳藴藵藶藷藸恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
D[204] = "����������������������������������������������������������������藹藺藼藽藾蘀蘁蘂蘃蘄蘆蘇蘈蘉蘊蘋蘌蘍蘎蘏蘐蘒蘓蘔蘕蘗蘘蘙蘚蘛蘜蘝蘞蘟蘠蘡蘢蘣蘤蘥蘦蘨蘪蘫蘬蘭蘮蘯蘰蘱蘲蘳蘴蘵蘶蘷蘹蘺蘻蘽蘾蘿虀�虁虂虃虄虅虆虇虈虉虊虋虌虒虓處虖虗虘虙虛虜虝號虠虡虣虤虥虦虧虨虩虪獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
D[205] = "����������������������������������������������������������������虭虯虰虲虳虴虵虶虷虸蚃蚄蚅蚆蚇蚈蚉蚎蚏蚐蚑蚒蚔蚖蚗蚘蚙蚚蚛蚞蚟蚠蚡蚢蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻蚼蚽蚾蚿蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜�蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
D[206] = "����������������������������������������������������������������蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀蝁蝂蝃蝄蝅蝆蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚蝛蝜蝝蝞蝟蝡蝢蝦蝧蝨蝩蝪蝫蝬蝭蝯蝱蝲蝳蝵�蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎螏螐螑螒螔螕螖螘螙螚螛螜螝螞螠螡螢螣螤巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
D[207] = "����������������������������������������������������������������螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁蟂蟃蟄蟅蟇蟈蟉蟌蟍蟎蟏蟐蟔蟕蟖蟗蟘蟙蟚蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯蟰蟱蟲蟳蟴蟵蟶蟷蟸�蟺蟻蟼蟽蟿蠀蠁蠂蠄蠅蠆蠇蠈蠉蠋蠌蠍蠎蠏蠐蠑蠒蠔蠗蠘蠙蠚蠜蠝蠞蠟蠠蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
D[208] = "����������������������������������������������������������������蠤蠥蠦蠧蠨蠩蠪蠫蠬蠭蠮蠯蠰蠱蠳蠴蠵蠶蠷蠸蠺蠻蠽蠾蠿衁衂衃衆衇衈衉衊衋衎衏衐衑衒術衕衖衘衚衛衜衝衞衟衠衦衧衪衭衯衱衳衴衵衶衸衹衺�衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗袘袙袚袛袝袞袟袠袡袣袥袦袧袨袩袪小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
D[209] = "����������������������������������������������������������������袬袮袯袰袲袳袴袵袶袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚裛補裝裞裠裡裦裧裩裪裫裬裭裮裯裲裵裶裷裺裻製裿褀褁褃褄褅褆複褈�褉褋褌褍褎褏褑褔褕褖褗褘褜褝褞褟褠褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
D[210] = "����������������������������������������������������������������褸褹褺褻褼褽褾褿襀襂襃襅襆襇襈襉襊襋襌襍襎襏襐襑襒襓襔襕襖襗襘襙襚襛襜襝襠襡襢襣襤襥襧襨襩襪襫襬襭襮襯襰襱襲襳襴襵襶襷襸襹襺襼�襽襾覀覂覄覅覇覈覉覊見覌覍覎規覐覑覒覓覔覕視覗覘覙覚覛覜覝覞覟覠覡摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
D[211] = "����������������������������������������������������������������覢覣覤覥覦覧覨覩親覫覬覭覮覯覰覱覲観覴覵覶覷覸覹覺覻覼覽覾覿觀觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴觵觶觷觸觹觺�觻觼觽觾觿訁訂訃訄訅訆計訉訊訋訌訍討訏訐訑訒訓訔訕訖託記訙訚訛訜訝印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
D[212] = "����������������������������������������������������������������訞訟訠訡訢訣訤訥訦訧訨訩訪訫訬設訮訯訰許訲訳訴訵訶訷訸訹診註証訽訿詀詁詂詃詄詅詆詇詉詊詋詌詍詎詏詐詑詒詓詔評詖詗詘詙詚詛詜詝詞�詟詠詡詢詣詤詥試詧詨詩詪詫詬詭詮詯詰話該詳詴詵詶詷詸詺詻詼詽詾詿誀浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
D[213] = "����������������������������������������������������������������誁誂誃誄誅誆誇誈誋誌認誎誏誐誑誒誔誕誖誗誘誙誚誛誜誝語誟誠誡誢誣誤誥誦誧誨誩說誫説読誮誯誰誱課誳誴誵誶誷誸誹誺誻誼誽誾調諀諁諂�諃諄諅諆談諈諉諊請諌諍諎諏諐諑諒諓諔諕論諗諘諙諚諛諜諝諞諟諠諡諢諣铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
D[214] = "����������������������������������������������������������������諤諥諦諧諨諩諪諫諬諭諮諯諰諱諲諳諴諵諶諷諸諹諺諻諼諽諾諿謀謁謂謃謄謅謆謈謉謊謋謌謍謎謏謐謑謒謓謔謕謖謗謘謙謚講謜謝謞謟謠謡謢謣�謤謥謧謨謩謪謫謬謭謮謯謰謱謲謳謴謵謶謷謸謹謺謻謼謽謾謿譀譁譂譃譄譅帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
D[215] = "����������������������������������������������������������������譆譇譈證譊譋譌譍譎譏譐譑譒譓譔譕譖譗識譙譚譛譜譝譞譟譠譡譢譣譤譥譧譨譩譪譫譭譮譯議譱譲譳譴譵譶護譸譹譺譻譼譽譾譿讀讁讂讃讄讅讆�讇讈讉變讋讌讍讎讏讐讑讒讓讔讕讖讗讘讙讚讛讜讝讞讟讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
D[216] = "����������������������������������������������������������������谸谹谺谻谼谽谾谿豀豂豃豄豅豈豊豋豍豎豏豐豑豒豓豔豖豗豘豙豛豜豝豞豟豠豣豤豥豦豧豨豩豬豭豮豯豰豱豲豴豵豶豷豻豼豽豾豿貀貁貃貄貆貇�貈貋貍貎貏貐貑貒貓貕貖貗貙貚貛貜貝貞貟負財貢貣貤貥貦貧貨販貪貫責貭亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
D[217] = "����������������������������������������������������������������貮貯貰貱貲貳貴貵貶買貸貹貺費貼貽貾貿賀賁賂賃賄賅賆資賈賉賊賋賌賍賎賏賐賑賒賓賔賕賖賗賘賙賚賛賜賝賞賟賠賡賢賣賤賥賦賧賨賩質賫賬�賭賮賯賰賱賲賳賴賵賶賷賸賹賺賻購賽賾賿贀贁贂贃贄贅贆贇贈贉贊贋贌贍佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
D[218] = "����������������������������������������������������������������贎贏贐贑贒贓贔贕贖贗贘贙贚贛贜贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸赹赺赻赼赽赾赿趀趂趃趆趇趈趉趌趍趎趏趐趒趓趕趖趗趘趙趚趛趜趝趞趠趡�趢趤趥趦趧趨趩趪趫趬趭趮趯趰趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
D[219] = "����������������������������������������������������������������跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾跿踀踁踂踃踄踆踇踈踋踍踎踐踑踒踓踕踖踗踘踙踚踛踜踠踡踤踥踦踧踨踫踭踰踲踳踴踶踷踸踻踼踾�踿蹃蹅蹆蹌蹍蹎蹏蹐蹓蹔蹕蹖蹗蹘蹚蹛蹜蹝蹞蹟蹠蹡蹢蹣蹤蹥蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
D[220] = "����������������������������������������������������������������蹳蹵蹷蹸蹹蹺蹻蹽蹾躀躂躃躄躆躈躉躊躋躌躍躎躑躒躓躕躖躗躘躙躚躛躝躟躠躡躢躣躤躥躦躧躨躩躪躭躮躰躱躳躴躵躶躷躸躹躻躼躽躾躿軀軁軂�軃軄軅軆軇軈軉車軋軌軍軏軐軑軒軓軔軕軖軗軘軙軚軛軜軝軞軟軠軡転軣軤堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
D[221] = "����������������������������������������������������������������軥軦軧軨軩軪軫軬軭軮軯軰軱軲軳軴軵軶軷軸軹軺軻軼軽軾軿輀輁輂較輄輅輆輇輈載輊輋輌輍輎輏輐輑輒輓輔輕輖輗輘輙輚輛輜輝輞輟輠輡輢輣�輤輥輦輧輨輩輪輫輬輭輮輯輰輱輲輳輴輵輶輷輸輹輺輻輼輽輾輿轀轁轂轃轄荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
D[222] = "����������������������������������������������������������������轅轆轇轈轉轊轋轌轍轎轏轐轑轒轓轔轕轖轗轘轙轚轛轜轝轞轟轠轡轢轣轤轥轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆�迉迊迋迌迍迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
D[223] = "����������������������������������������������������������������這逜連逤逥逧逨逩逪逫逬逰週進逳逴逷逹逺逽逿遀遃遅遆遈遉遊運遌過達違遖遙遚遜遝遞遟遠遡遤遦遧適遪遫遬遯遰遱遲遳遶遷選遹遺遻遼遾邁�還邅邆邇邉邊邌邍邎邏邐邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
D[224] = "����������������������������������������������������������������郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅鄆鄇鄈鄉鄊鄋鄌鄍鄎鄏鄐鄑鄒鄓鄔鄕鄖鄗鄘鄚鄛鄜�鄝鄟鄠鄡鄤鄥鄦鄧鄨鄩鄪鄫鄬鄭鄮鄰鄲鄳鄴鄵鄶鄷鄸鄺鄻鄼鄽鄾鄿酀酁酂酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
D[225] = "����������������������������������������������������������������酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀醁醂醃醄醆醈醊醎醏醓醔醕醖醗醘醙醜醝醞醟醠醡醤醥醦醧醨醩醫醬醰醱醲醳醶醷醸醹醻�醼醽醾醿釀釁釂釃釄釅釆釈釋釐釒釓釔釕釖釗釘釙釚釛針釞釟釠釡釢釣釤釥帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
D[226] = "����������������������������������������������������������������釦釧釨釩釪釫釬釭釮釯釰釱釲釳釴釵釶釷釸釹釺釻釼釽釾釿鈀鈁鈂鈃鈄鈅鈆鈇鈈鈉鈊鈋鈌鈍鈎鈏鈐鈑鈒鈓鈔鈕鈖鈗鈘鈙鈚鈛鈜鈝鈞鈟鈠鈡鈢鈣鈤�鈥鈦鈧鈨鈩鈪鈫鈬鈭鈮鈯鈰鈱鈲鈳鈴鈵鈶鈷鈸鈹鈺鈻鈼鈽鈾鈿鉀鉁鉂鉃鉄鉅狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
D[227] = "����������������������������������������������������������������鉆鉇鉈鉉鉊鉋鉌鉍鉎鉏鉐鉑鉒鉓鉔鉕鉖鉗鉘鉙鉚鉛鉜鉝鉞鉟鉠鉡鉢鉣鉤鉥鉦鉧鉨鉩鉪鉫鉬鉭鉮鉯鉰鉱鉲鉳鉵鉶鉷鉸鉹鉺鉻鉼鉽鉾鉿銀銁銂銃銄銅�銆銇銈銉銊銋銌銍銏銐銑銒銓銔銕銖銗銘銙銚銛銜銝銞銟銠銡銢銣銤銥銦銧恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
D[228] = "����������������������������������������������������������������銨銩銪銫銬銭銯銰銱銲銳銴銵銶銷銸銹銺銻銼銽銾銿鋀鋁鋂鋃鋄鋅鋆鋇鋉鋊鋋鋌鋍鋎鋏鋐鋑鋒鋓鋔鋕鋖鋗鋘鋙鋚鋛鋜鋝鋞鋟鋠鋡鋢鋣鋤鋥鋦鋧鋨�鋩鋪鋫鋬鋭鋮鋯鋰鋱鋲鋳鋴鋵鋶鋷鋸鋹鋺鋻鋼鋽鋾鋿錀錁錂錃錄錅錆錇錈錉洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
D[229] = "����������������������������������������������������������������錊錋錌錍錎錏錐錑錒錓錔錕錖錗錘錙錚錛錜錝錞錟錠錡錢錣錤錥錦錧錨錩錪錫錬錭錮錯錰錱録錳錴錵錶錷錸錹錺錻錼錽錿鍀鍁鍂鍃鍄鍅鍆鍇鍈鍉�鍊鍋鍌鍍鍎鍏鍐鍑鍒鍓鍔鍕鍖鍗鍘鍙鍚鍛鍜鍝鍞鍟鍠鍡鍢鍣鍤鍥鍦鍧鍨鍩鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
D[230] = "����������������������������������������������������������������鍬鍭鍮鍯鍰鍱鍲鍳鍴鍵鍶鍷鍸鍹鍺鍻鍼鍽鍾鍿鎀鎁鎂鎃鎄鎅鎆鎇鎈鎉鎊鎋鎌鎍鎎鎐鎑鎒鎓鎔鎕鎖鎗鎘鎙鎚鎛鎜鎝鎞鎟鎠鎡鎢鎣鎤鎥鎦鎧鎨鎩鎪鎫�鎬鎭鎮鎯鎰鎱鎲鎳鎴鎵鎶鎷鎸鎹鎺鎻鎼鎽鎾鎿鏀鏁鏂鏃鏄鏅鏆鏇鏈鏉鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
D[231] = "����������������������������������������������������������������鏎鏏鏐鏑鏒鏓鏔鏕鏗鏘鏙鏚鏛鏜鏝鏞鏟鏠鏡鏢鏣鏤鏥鏦鏧鏨鏩鏪鏫鏬鏭鏮鏯鏰鏱鏲鏳鏴鏵鏶鏷鏸鏹鏺鏻鏼鏽鏾鏿鐀鐁鐂鐃鐄鐅鐆鐇鐈鐉鐊鐋鐌鐍�鐎鐏鐐鐑鐒鐓鐔鐕鐖鐗鐘鐙鐚鐛鐜鐝鐞鐟鐠鐡鐢鐣鐤鐥鐦鐧鐨鐩鐪鐫鐬鐭鐮纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
D[232] = "����������������������������������������������������������������鐯鐰鐱鐲鐳鐴鐵鐶鐷鐸鐹鐺鐻鐼鐽鐿鑀鑁鑂鑃鑄鑅鑆鑇鑈鑉鑊鑋鑌鑍鑎鑏鑐鑑鑒鑓鑔鑕鑖鑗鑘鑙鑚鑛鑜鑝鑞鑟鑠鑡鑢鑣鑤鑥鑦鑧鑨鑩鑪鑬鑭鑮鑯�鑰鑱鑲鑳鑴鑵鑶鑷鑸鑹鑺鑻鑼鑽鑾鑿钀钁钂钃钄钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
D[233] = "����������������������������������������������������������������锧锳锽镃镈镋镕镚镠镮镴镵長镸镹镺镻镼镽镾門閁閂閃閄閅閆閇閈閉閊開閌閍閎閏閐閑閒間閔閕閖閗閘閙閚閛閜閝閞閟閠閡関閣閤閥閦閧閨閩閪�閫閬閭閮閯閰閱閲閳閴閵閶閷閸閹閺閻閼閽閾閿闀闁闂闃闄闅闆闇闈闉闊闋椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
D[234] = "����������������������������������������������������������������闌闍闎闏闐闑闒闓闔闕闖闗闘闙闚闛關闝闞闟闠闡闢闣闤闥闦闧闬闿阇阓阘阛阞阠阣阤阥阦阧阨阩阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗�陘陙陚陜陝陞陠陣陥陦陫陭陮陯陰陱陳陸陹険陻陼陽陾陿隀隁隂隃隄隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
D[235] = "����������������������������������������������������������������隌階隑隒隓隕隖隚際隝隞隟隠隡隢隣隤隥隦隨隩險隫隬隭隮隯隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖雗雘雙雚雛雜雝雞雟雡離難雤雥雦雧雫�雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗霘霙霚霛霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
D[236] = "����������������������������������������������������������������霡霢霣霤霥霦霧霨霩霫霬霮霯霱霳霴霵霶霷霺霻霼霽霿靀靁靂靃靄靅靆靇靈靉靊靋靌靍靎靏靐靑靔靕靗靘靚靜靝靟靣靤靦靧靨靪靫靬靭靮靯靰靱�靲靵靷靸靹靺靻靽靾靿鞀鞁鞂鞃鞄鞆鞇鞈鞉鞊鞌鞎鞏鞐鞓鞕鞖鞗鞙鞚鞛鞜鞝臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
D[237] = "����������������������������������������������������������������鞞鞟鞡鞢鞤鞥鞦鞧鞨鞩鞪鞬鞮鞰鞱鞳鞵鞶鞷鞸鞹鞺鞻鞼鞽鞾鞿韀韁韂韃韄韅韆韇韈韉韊韋韌韍韎韏韐韑韒韓韔韕韖韗韘韙韚韛韜韝韞韟韠韡韢韣�韤韥韨韮韯韰韱韲韴韷韸韹韺韻韼韽韾響頀頁頂頃頄項順頇須頉頊頋頌頍頎怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
D[238] = "����������������������������������������������������������������頏預頑頒頓頔頕頖頗領頙頚頛頜頝頞頟頠頡頢頣頤頥頦頧頨頩頪頫頬頭頮頯頰頱頲頳頴頵頶頷頸頹頺頻頼頽頾頿顀顁顂顃顄顅顆顇顈顉顊顋題額�顎顏顐顑顒顓顔顕顖顗願顙顚顛顜顝類顟顠顡顢顣顤顥顦顧顨顩顪顫顬顭顮睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
D[239] = "����������������������������������������������������������������顯顰顱顲顳顴颋颎颒颕颙颣風颩颪颫颬颭颮颯颰颱颲颳颴颵颶颷颸颹颺颻颼颽颾颿飀飁飂飃飄飅飆飇飈飉飊飋飌飍飏飐飔飖飗飛飜飝飠飡飢飣飤�飥飦飩飪飫飬飭飮飯飰飱飲飳飴飵飶飷飸飹飺飻飼飽飾飿餀餁餂餃餄餅餆餇铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
D[240] = "����������������������������������������������������������������餈餉養餋餌餎餏餑餒餓餔餕餖餗餘餙餚餛餜餝餞餟餠餡餢餣餤餥餦餧館餩餪餫餬餭餯餰餱餲餳餴餵餶餷餸餹餺餻餼餽餾餿饀饁饂饃饄饅饆饇饈饉�饊饋饌饍饎饏饐饑饒饓饖饗饘饙饚饛饜饝饞饟饠饡饢饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
D[241] = "����������������������������������������������������������������馌馎馚馛馜馝馞馟馠馡馢馣馤馦馧馩馪馫馬馭馮馯馰馱馲馳馴馵馶馷馸馹馺馻馼馽馾馿駀駁駂駃駄駅駆駇駈駉駊駋駌駍駎駏駐駑駒駓駔駕駖駗駘�駙駚駛駜駝駞駟駠駡駢駣駤駥駦駧駨駩駪駫駬駭駮駯駰駱駲駳駴駵駶駷駸駹瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
D[242] = "����������������������������������������������������������������駺駻駼駽駾駿騀騁騂騃騄騅騆騇騈騉騊騋騌騍騎騏騐騑騒験騔騕騖騗騘騙騚騛騜騝騞騟騠騡騢騣騤騥騦騧騨騩騪騫騬騭騮騯騰騱騲騳騴騵騶騷騸�騹騺騻騼騽騾騿驀驁驂驃驄驅驆驇驈驉驊驋驌驍驎驏驐驑驒驓驔驕驖驗驘驙颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
D[243] = "����������������������������������������������������������������驚驛驜驝驞驟驠驡驢驣驤驥驦驧驨驩驪驫驲骃骉骍骎骔骕骙骦骩骪骫骬骭骮骯骲骳骴骵骹骻骽骾骿髃髄髆髇髈髉髊髍髎髏髐髒體髕髖髗髙髚髛髜�髝髞髠髢髣髤髥髧髨髩髪髬髮髰髱髲髳髴髵髶髷髸髺髼髽髾髿鬀鬁鬂鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
D[244] = "����������������������������������������������������������������鬇鬉鬊鬋鬌鬍鬎鬐鬑鬒鬔鬕鬖鬗鬘鬙鬚鬛鬜鬝鬞鬠鬡鬢鬤鬥鬦鬧鬨鬩鬪鬫鬬鬭鬮鬰鬱鬳鬴鬵鬶鬷鬸鬹鬺鬽鬾鬿魀魆魊魋魌魎魐魒魓魕魖魗魘魙魚�魛魜魝魞魟魠魡魢魣魤魥魦魧魨魩魪魫魬魭魮魯魰魱魲魳魴魵魶魷魸魹魺魻簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
D[245] = "����������������������������������������������������������������魼魽魾魿鮀鮁鮂鮃鮄鮅鮆鮇鮈鮉鮊鮋鮌鮍鮎鮏鮐鮑鮒鮓鮔鮕鮖鮗鮘鮙鮚鮛鮜鮝鮞鮟鮠鮡鮢鮣鮤鮥鮦鮧鮨鮩鮪鮫鮬鮭鮮鮯鮰鮱鮲鮳鮴鮵鮶鮷鮸鮹鮺�鮻鮼鮽鮾鮿鯀鯁鯂鯃鯄鯅鯆鯇鯈鯉鯊鯋鯌鯍鯎鯏鯐鯑鯒鯓鯔鯕鯖鯗鯘鯙鯚鯛酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
D[246] = "����������������������������������������������������������������鯜鯝鯞鯟鯠鯡鯢鯣鯤鯥鯦鯧鯨鯩鯪鯫鯬鯭鯮鯯鯰鯱鯲鯳鯴鯵鯶鯷鯸鯹鯺鯻鯼鯽鯾鯿鰀鰁鰂鰃鰄鰅鰆鰇鰈鰉鰊鰋鰌鰍鰎鰏鰐鰑鰒鰓鰔鰕鰖鰗鰘鰙鰚�鰛鰜鰝鰞鰟鰠鰡鰢鰣鰤鰥鰦鰧鰨鰩鰪鰫鰬鰭鰮鰯鰰鰱鰲鰳鰴鰵鰶鰷鰸鰹鰺鰻觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
D[247] = "����������������������������������������������������������������鰼鰽鰾鰿鱀鱁鱂鱃鱄鱅鱆鱇鱈鱉鱊鱋鱌鱍鱎鱏鱐鱑鱒鱓鱔鱕鱖鱗鱘鱙鱚鱛鱜鱝鱞鱟鱠鱡鱢鱣鱤鱥鱦鱧鱨鱩鱪鱫鱬鱭鱮鱯鱰鱱鱲鱳鱴鱵鱶鱷鱸鱹鱺�鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾鲿鳀鳁鳂鳈鳉鳑鳒鳚鳛鳠鳡鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
D[248] = "����������������������������������������������������������������鳣鳤鳥鳦鳧鳨鳩鳪鳫鳬鳭鳮鳯鳰鳱鳲鳳鳴鳵鳶鳷鳸鳹鳺鳻鳼鳽鳾鳿鴀鴁鴂鴃鴄鴅鴆鴇鴈鴉鴊鴋鴌鴍鴎鴏鴐鴑鴒鴓鴔鴕鴖鴗鴘鴙鴚鴛鴜鴝鴞鴟鴠鴡�鴢鴣鴤鴥鴦鴧鴨鴩鴪鴫鴬鴭鴮鴯鴰鴱鴲鴳鴴鴵鴶鴷鴸鴹鴺鴻鴼鴽鴾鴿鵀鵁鵂�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
D[249] = "����������������������������������������������������������������鵃鵄鵅鵆鵇鵈鵉鵊鵋鵌鵍鵎鵏鵐鵑鵒鵓鵔鵕鵖鵗鵘鵙鵚鵛鵜鵝鵞鵟鵠鵡鵢鵣鵤鵥鵦鵧鵨鵩鵪鵫鵬鵭鵮鵯鵰鵱鵲鵳鵴鵵鵶鵷鵸鵹鵺鵻鵼鵽鵾鵿鶀鶁�鶂鶃鶄鶅鶆鶇鶈鶉鶊鶋鶌鶍鶎鶏鶐鶑鶒鶓鶔鶕鶖鶗鶘鶙鶚鶛鶜鶝鶞鶟鶠鶡鶢�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
D[250] = "����������������������������������������������������������������鶣鶤鶥鶦鶧鶨鶩鶪鶫鶬鶭鶮鶯鶰鶱鶲鶳鶴鶵鶶鶷鶸鶹鶺鶻鶼鶽鶾鶿鷀鷁鷂鷃鷄鷅鷆鷇鷈鷉鷊鷋鷌鷍鷎鷏鷐鷑鷒鷓鷔鷕鷖鷗鷘鷙鷚鷛鷜鷝鷞鷟鷠鷡�鷢鷣鷤鷥鷦鷧鷨鷩鷪鷫鷬鷭鷮鷯鷰鷱鷲鷳鷴鷵鷶鷷鷸鷹鷺鷻鷼鷽鷾鷿鸀鸁鸂�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
D[251] = "����������������������������������������������������������������鸃鸄鸅鸆鸇鸈鸉鸊鸋鸌鸍鸎鸏鸐鸑鸒鸓鸔鸕鸖鸗鸘鸙鸚鸛鸜鸝鸞鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴鹵鹶鹷鹸鹹鹺鹻鹼鹽麀�麁麃麄麅麆麉麊麌麍麎麏麐麑麔麕麖麗麘麙麚麛麜麞麠麡麢麣麤麥麧麨麩麪�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
D[252] = "����������������������������������������������������������������麫麬麭麮麯麰麱麲麳麵麶麷麹麺麼麿黀黁黂黃黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰黱黲黳黴黵黶黷黸黺黽黿鼀鼁鼂鼃鼄鼅�鼆鼇鼈鼉鼊鼌鼏鼑鼒鼔鼕鼖鼘鼚鼛鼜鼝鼞鼟鼡鼣鼤鼥鼦鼧鼨鼩鼪鼫鼭鼮鼰鼱�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
D[253] = "����������������������������������������������������������������鼲鼳鼴鼵鼶鼸鼺鼼鼿齀齁齂齃齅齆齇齈齉齊齋齌齍齎齏齒齓齔齕齖齗齘齙齚齛齜齝齞齟齠齡齢齣齤齥齦齧齨齩齪齫齬齭齮齯齰齱齲齳齴齵齶齷齸�齹齺齻齼齽齾龁龂龍龎龏龐龑龒龓龔龕龖龗龘龜龝龞龡龢龣龤龥郎凉秊裏隣�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
D[254] = "����������������������������������������������������������������兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩��������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[254].length; ++j) if(D[254][j].charCodeAt(0) !== 0xFFFD) { e[D[254][j]] = 65024 + j; d[65024 + j] = D[254][j];}
return {"enc": e, "dec": d }; })();
cptable[949] = (function(){ var d = [], e = {}, D = [], j;
D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
D[129] = "�����������������������������������������������������������������갂갃갅갆갋갌갍갎갏갘갞갟갡갢갣갥갦갧갨갩갪갫갮갲갳갴������갵갶갷갺갻갽갾갿걁걂걃걄걅걆걇걈걉걊걌걎걏걐걑걒걓걕������걖걗걙걚걛걝걞걟걠걡걢걣걤걥걦걧걨걩걪걫걬걭걮걯걲걳걵걶걹걻걼걽걾걿겂겇겈겍겎겏겑겒겓겕겖겗겘겙겚겛겞겢겣겤겥겦겧겫겭겮겱겲겳겴겵겶겷겺겾겿곀곂곃곅곆곇곉곊곋곍곎곏곐곑곒곓곔곖곘곙곚곛곜곝곞곟곢곣곥곦곩곫곭곮곲곴곷곸곹곺곻곾곿괁괂괃괅괇괈괉괊괋괎괐괒괓�".split("");
for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
D[130] = "�����������������������������������������������������������������괔괕괖괗괙괚괛괝괞괟괡괢괣괤괥괦괧괨괪괫괮괯괰괱괲괳������괶괷괹괺괻괽괾괿굀굁굂굃굆굈굊굋굌굍굎굏굑굒굓굕굖굗������굙굚굛굜굝굞굟굠굢굤굥굦굧굨굩굪굫굮굯굱굲굷굸굹굺굾궀궃궄궅궆궇궊궋궍궎궏궑궒궓궔궕궖궗궘궙궚궛궞궟궠궡궢궣궥궦궧궨궩궪궫궬궭궮궯궰궱궲궳궴궵궶궸궹궺궻궼궽궾궿귂귃귅귆귇귉귊귋귌귍귎귏귒귔귕귖귗귘귙귚귛귝귞귟귡귢귣귥귦귧귨귩귪귫귬귭귮귯귰귱귲귳귴귵귶귷�".split("");
for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
D[131] = "�����������������������������������������������������������������귺귻귽귾긂긃긄긅긆긇긊긌긎긏긐긑긒긓긕긖긗긘긙긚긛긜������긝긞긟긠긡긢긣긤긥긦긧긨긩긪긫긬긭긮긯긲긳긵긶긹긻긼������긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗깘깙깚깛깞깢깣깤깦깧깪깫깭깮깯깱깲깳깴깵깶깷깺깾깿꺀꺁꺂꺃꺆꺇꺈꺉꺊꺋꺍꺎꺏꺐꺑꺒꺓꺔꺕꺖꺗꺘꺙꺚꺛꺜꺝꺞꺟꺠꺡꺢꺣꺤꺥꺦꺧꺨꺩꺪꺫꺬꺭꺮꺯꺰꺱꺲꺳꺴꺵꺶꺷꺸꺹꺺꺻꺿껁껂껃껅껆껇껈껉껊껋껎껒껓껔껕껖껗껚껛껝껞껟껠껡껢껣껤껥�".split("");
for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
D[132] = "�����������������������������������������������������������������껦껧껩껪껬껮껯껰껱껲껳껵껶껷껹껺껻껽껾껿꼀꼁꼂꼃꼄꼅������꼆꼉꼊꼋꼌꼎꼏꼑꼒꼓꼔꼕꼖꼗꼘꼙꼚꼛꼜꼝꼞꼟꼠꼡꼢꼣������꼤꼥꼦꼧꼨꼩꼪꼫꼮꼯꼱꼳꼵꼶꼷꼸꼹꼺꼻꼾꽀꽄꽅꽆꽇꽊꽋꽌꽍꽎꽏꽑꽒꽓꽔꽕꽖꽗꽘꽙꽚꽛꽞꽟꽠꽡꽢꽣꽦꽧꽨꽩꽪꽫꽬꽭꽮꽯꽰꽱꽲꽳꽴꽵꽶꽷꽸꽺꽻꽼꽽꽾꽿꾁꾂꾃꾅꾆꾇꾉꾊꾋꾌꾍꾎꾏꾒꾓꾔꾖꾗꾘꾙꾚꾛꾝꾞꾟꾠꾡꾢꾣꾤꾥꾦꾧꾨꾩꾪꾫꾬꾭꾮꾯꾰꾱꾲꾳꾴꾵꾶꾷꾺꾻꾽꾾�".split("");
for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
D[133] = "�����������������������������������������������������������������꾿꿁꿂꿃꿄꿅꿆꿊꿌꿏꿐꿑꿒꿓꿕꿖꿗꿘꿙꿚꿛꿝꿞꿟꿠꿡������꿢꿣꿤꿥꿦꿧꿪꿫꿬꿭꿮꿯꿲꿳꿵꿶꿷꿹꿺꿻꿼꿽꿾꿿뀂뀃������뀅뀆뀇뀈뀉뀊뀋뀍뀎뀏뀑뀒뀓뀕뀖뀗뀘뀙뀚뀛뀞뀟뀠뀡뀢뀣뀤뀥뀦뀧뀩뀪뀫뀬뀭뀮뀯뀰뀱뀲뀳뀴뀵뀶뀷뀸뀹뀺뀻뀼뀽뀾뀿끀끁끂끃끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞끟끠끡끢끣끤끥끦끧끨끩끪끫끬끭끮끯끰끱끲끳끴끵끶끷끸끹끺끻끾끿낁낂낃낅낆낇낈낉낊낋낎낐낒낓낔낕낖낗낛낝낞낣낤�".split("");
for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
D[134] = "�����������������������������������������������������������������낥낦낧낪낰낲낶낷낹낺낻낽낾낿냀냁냂냃냆냊냋냌냍냎냏냒������냓냕냖냗냙냚냛냜냝냞냟냡냢냣냤냦냧냨냩냪냫냬냭냮냯냰������냱냲냳냴냵냶냷냸냹냺냻냼냽냾냿넀넁넂넃넄넅넆넇넊넍넎넏넑넔넕넖넗넚넞넟넠넡넢넦넧넩넪넫넭넮넯넰넱넲넳넶넺넻넼넽넾넿녂녃녅녆녇녉녊녋녌녍녎녏녒녓녖녗녙녚녛녝녞녟녡녢녣녤녥녦녧녨녩녪녫녬녭녮녯녰녱녲녳녴녵녶녷녺녻녽녾녿놁놃놄놅놆놇놊놌놎놏놐놑놕놖놗놙놚놛놝�".split("");
for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
D[135] = "�����������������������������������������������������������������놞놟놠놡놢놣놤놥놦놧놩놪놫놬놭놮놯놰놱놲놳놴놵놶놷놸������놹놺놻놼놽놾놿뇀뇁뇂뇃뇄뇅뇆뇇뇈뇉뇊뇋뇍뇎뇏뇑뇒뇓뇕������뇖뇗뇘뇙뇚뇛뇞뇠뇡뇢뇣뇤뇥뇦뇧뇪뇫뇭뇮뇯뇱뇲뇳뇴뇵뇶뇷뇸뇺뇼뇾뇿눀눁눂눃눆눇눉눊눍눎눏눐눑눒눓눖눘눚눛눜눝눞눟눡눢눣눤눥눦눧눨눩눪눫눬눭눮눯눰눱눲눳눵눶눷눸눹눺눻눽눾눿뉀뉁뉂뉃뉄뉅뉆뉇뉈뉉뉊뉋뉌뉍뉎뉏뉐뉑뉒뉓뉔뉕뉖뉗뉙뉚뉛뉝뉞뉟뉡뉢뉣뉤뉥뉦뉧뉪뉫뉬뉭뉮�".split("");
for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
D[136] = "�����������������������������������������������������������������뉯뉰뉱뉲뉳뉶뉷뉸뉹뉺뉻뉽뉾뉿늀늁늂늃늆늇늈늊늋늌늍늎������늏늒늓늕늖늗늛늜늝늞늟늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷������늸늹늺늻늼늽늾늿닀닁닂닃닄닅닆닇닊닋닍닎닏닑닓닔닕닖닗닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉댊댋댌댍댎댏댒댖댗댘댙댚댛댝댞댟댠댡댢댣댤댥댦댧댨댩댪댫댬댭댮댯댰댱댲댳댴댵댶댷댸댹댺댻댼댽댾댿덀덁덂덃덄덅덆덇덈덉덊덋덌덍덎덏덐덑덒덓덗덙덚덝덠덡덢덣�".split("");
for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
D[137] = "�����������������������������������������������������������������덦덨덪덬덭덯덲덳덵덶덷덹덺덻덼덽덾덿뎂뎆뎇뎈뎉뎊뎋뎍������뎎뎏뎑뎒뎓뎕뎖뎗뎘뎙뎚뎛뎜뎝뎞뎟뎢뎣뎤뎥뎦뎧뎩뎪뎫뎭������뎮뎯뎰뎱뎲뎳뎴뎵뎶뎷뎸뎹뎺뎻뎼뎽뎾뎿돀돁돂돃돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩돪돫돬돭돮돯돰돱돲돳돴돵돶돷돸돹돺돻돽돾돿됀됁됂됃됄됅됆됇됈됉됊됋됌됍됎됏됑됒됓됔됕됖됗됙됚됛됝됞됟됡됢됣됤됥됦됧됪됬됭됮됯됰됱됲됳됵됶됷됸됹됺됻됼됽됾됿둀둁둂둃둄�".split("");
for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
D[138] = "�����������������������������������������������������������������둅둆둇둈둉둊둋둌둍둎둏둒둓둕둖둗둙둚둛둜둝둞둟둢둤둦������둧둨둩둪둫둭둮둯둰둱둲둳둴둵둶둷둸둹둺둻둼둽둾둿뒁뒂������뒃뒄뒅뒆뒇뒉뒊뒋뒌뒍뒎뒏뒐뒑뒒뒓뒔뒕뒖뒗뒘뒙뒚뒛뒜뒞뒟뒠뒡뒢뒣뒥뒦뒧뒩뒪뒫뒭뒮뒯뒰뒱뒲뒳뒴뒶뒸뒺뒻뒼뒽뒾뒿듁듂듃듅듆듇듉듊듋듌듍듎듏듑듒듓듔듖듗듘듙듚듛듞듟듡듢듥듧듨듩듪듫듮듰듲듳듴듵듶듷듹듺듻듼듽듾듿딀딁딂딃딄딅딆딇딈딉딊딋딌딍딎딏딐딑딒딓딖딗딙딚딝�".split("");
for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
D[139] = "�����������������������������������������������������������������딞딟딠딡딢딣딦딫딬딭딮딯딲딳딵딶딷딹딺딻딼딽딾딿땂땆������땇땈땉땊땎땏땑땒땓땕땖땗땘땙땚땛땞땢땣땤땥땦땧땨땩땪������땫땬땭땮땯땰땱땲땳땴땵땶땷땸땹땺땻땼땽땾땿떀떁떂떃떄떅떆떇떈떉떊떋떌떍떎떏떐떑떒떓떔떕떖떗떘떙떚떛떜떝떞떟떢떣떥떦떧떩떬떭떮떯떲떶떷떸떹떺떾떿뗁뗂뗃뗅뗆뗇뗈뗉뗊뗋뗎뗒뗓뗔뗕뗖뗗뗙뗚뗛뗜뗝뗞뗟뗠뗡뗢뗣뗤뗥뗦뗧뗨뗩뗪뗫뗭뗮뗯뗰뗱뗲뗳뗴뗵뗶뗷뗸뗹뗺뗻뗼뗽뗾뗿�".split("");
for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
D[140] = "�����������������������������������������������������������������똀똁똂똃똄똅똆똇똈똉똊똋똌똍똎똏똒똓똕똖똗똙똚똛똜똝������똞똟똠똡똢똣똤똦똧똨똩똪똫똭똮똯똰똱똲똳똵똶똷똸똹똺������똻똼똽똾똿뙀뙁뙂뙃뙄뙅뙆뙇뙉뙊뙋뙌뙍뙎뙏뙐뙑뙒뙓뙔뙕뙖뙗뙘뙙뙚뙛뙜뙝뙞뙟뙠뙡뙢뙣뙥뙦뙧뙩뙪뙫뙬뙭뙮뙯뙰뙱뙲뙳뙴뙵뙶뙷뙸뙹뙺뙻뙼뙽뙾뙿뚀뚁뚂뚃뚄뚅뚆뚇뚈뚉뚊뚋뚌뚍뚎뚏뚐뚑뚒뚓뚔뚕뚖뚗뚘뚙뚚뚛뚞뚟뚡뚢뚣뚥뚦뚧뚨뚩뚪뚭뚮뚯뚰뚲뚳뚴뚵뚶뚷뚸뚹뚺뚻뚼뚽뚾뚿뛀뛁뛂�".split("");
for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
D[141] = "�����������������������������������������������������������������뛃뛄뛅뛆뛇뛈뛉뛊뛋뛌뛍뛎뛏뛐뛑뛒뛓뛕뛖뛗뛘뛙뛚뛛뛜뛝������뛞뛟뛠뛡뛢뛣뛤뛥뛦뛧뛨뛩뛪뛫뛬뛭뛮뛯뛱뛲뛳뛵뛶뛷뛹뛺������뛻뛼뛽뛾뛿뜂뜃뜄뜆뜇뜈뜉뜊뜋뜌뜍뜎뜏뜐뜑뜒뜓뜔뜕뜖뜗뜘뜙뜚뜛뜜뜝뜞뜟뜠뜡뜢뜣뜤뜥뜦뜧뜪뜫뜭뜮뜱뜲뜳뜴뜵뜶뜷뜺뜼뜽뜾뜿띀띁띂띃띅띆띇띉띊띋띍띎띏띐띑띒띓띖띗띘띙띚띛띜띝띞띟띡띢띣띥띦띧띩띪띫띬띭띮띯띲띴띶띷띸띹띺띻띾띿랁랂랃랅랆랇랈랉랊랋랎랓랔랕랚랛랝랞�".split("");
for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
D[142] = "�����������������������������������������������������������������랟랡랢랣랤랥랦랧랪랮랯랰랱랲랳랶랷랹랺랻랼랽랾랿럀럁������럂럃럄럅럆럈럊럋럌럍럎럏럐럑럒럓럔럕럖럗럘럙럚럛럜럝������럞럟럠럡럢럣럤럥럦럧럨럩럪럫럮럯럱럲럳럵럶럷럸럹럺럻럾렂렃렄렅렆렊렋렍렎렏렑렒렓렔렕렖렗렚렜렞렟렠렡렢렣렦렧렩렪렫렭렮렯렰렱렲렳렶렺렻렼렽렾렿롁롂롃롅롆롇롈롉롊롋롌롍롎롏롐롒롔롕롖롗롘롙롚롛롞롟롡롢롣롥롦롧롨롩롪롫롮롰롲롳롴롵롶롷롹롺롻롽롾롿뢀뢁뢂뢃뢄�".split("");
for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
D[143] = "�����������������������������������������������������������������뢅뢆뢇뢈뢉뢊뢋뢌뢎뢏뢐뢑뢒뢓뢔뢕뢖뢗뢘뢙뢚뢛뢜뢝뢞뢟������뢠뢡뢢뢣뢤뢥뢦뢧뢩뢪뢫뢬뢭뢮뢯뢱뢲뢳뢵뢶뢷뢹뢺뢻뢼뢽������뢾뢿룂룄룆룇룈룉룊룋룍룎룏룑룒룓룕룖룗룘룙룚룛룜룞룠룢룣룤룥룦룧룪룫룭룮룯룱룲룳룴룵룶룷룺룼룾룿뤀뤁뤂뤃뤅뤆뤇뤈뤉뤊뤋뤌뤍뤎뤏뤐뤑뤒뤓뤔뤕뤖뤗뤙뤚뤛뤜뤝뤞뤟뤡뤢뤣뤤뤥뤦뤧뤨뤩뤪뤫뤬뤭뤮뤯뤰뤱뤲뤳뤴뤵뤶뤷뤸뤹뤺뤻뤾뤿륁륂륃륅륆륇륈륉륊륋륍륎륐륒륓륔륕륖륗�".split("");
for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
D[144] = "�����������������������������������������������������������������륚륛륝륞륟륡륢륣륤륥륦륧륪륬륮륯륰륱륲륳륶륷륹륺륻륽������륾륿릀릁릂릃릆릈릋릌릏릐릑릒릓릔릕릖릗릘릙릚릛릜릝릞������릟릠릡릢릣릤릥릦릧릨릩릪릫릮릯릱릲릳릵릶릷릸릹릺릻릾맀맂맃맄맅맆맇맊맋맍맓맔맕맖맗맚맜맟맠맢맦맧맩맪맫맭맮맯맰맱맲맳맶맻맼맽맾맿먂먃먄먅먆먇먉먊먋먌먍먎먏먐먑먒먓먔먖먗먘먙먚먛먜먝먞먟먠먡먢먣먤먥먦먧먨먩먪먫먬먭먮먯먰먱먲먳먴먵먶먷먺먻먽먾먿멁멃멄멅멆�".split("");
for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
D[145] = "�����������������������������������������������������������������멇멊멌멏멐멑멒멖멗멙멚멛멝멞멟멠멡멢멣멦멪멫멬멭멮멯������멲멳멵멶멷멹멺멻멼멽멾멿몀몁몂몆몈몉몊몋몍몎몏몐몑몒������몓몔몕몖몗몘몙몚몛몜몝몞몟몠몡몢몣몤몥몦몧몪몭몮몯몱몳몴몵몶몷몺몼몾몿뫀뫁뫂뫃뫅뫆뫇뫉뫊뫋뫌뫍뫎뫏뫐뫑뫒뫓뫔뫕뫖뫗뫚뫛뫜뫝뫞뫟뫠뫡뫢뫣뫤뫥뫦뫧뫨뫩뫪뫫뫬뫭뫮뫯뫰뫱뫲뫳뫴뫵뫶뫷뫸뫹뫺뫻뫽뫾뫿묁묂묃묅묆묇묈묉묊묋묌묎묐묒묓묔묕묖묗묙묚묛묝묞묟묡묢묣묤묥묦묧�".split("");
for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
D[146] = "�����������������������������������������������������������������묨묪묬묭묮묯묰묱묲묳묷묹묺묿뭀뭁뭂뭃뭆뭈뭊뭋뭌뭎뭑뭒������뭓뭕뭖뭗뭙뭚뭛뭜뭝뭞뭟뭠뭢뭤뭥뭦뭧뭨뭩뭪뭫뭭뭮뭯뭰뭱������뭲뭳뭴뭵뭶뭷뭸뭹뭺뭻뭼뭽뭾뭿뮀뮁뮂뮃뮄뮅뮆뮇뮉뮊뮋뮍뮎뮏뮑뮒뮓뮔뮕뮖뮗뮘뮙뮚뮛뮜뮝뮞뮟뮠뮡뮢뮣뮥뮦뮧뮩뮪뮫뮭뮮뮯뮰뮱뮲뮳뮵뮶뮸뮹뮺뮻뮼뮽뮾뮿믁믂믃믅믆믇믉믊믋믌믍믎믏믑믒믔믕믖믗믘믙믚믛믜믝믞믟믠믡믢믣믤믥믦믧믨믩믪믫믬믭믮믯믰믱믲믳믴믵믶믷믺믻믽믾밁�".split("");
for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
D[147] = "�����������������������������������������������������������������밃밄밅밆밇밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵������밶밷밹밺밻밼밽밾밿뱂뱆뱇뱈뱊뱋뱎뱏뱑뱒뱓뱔뱕뱖뱗뱘뱙������뱚뱛뱜뱞뱟뱠뱡뱢뱣뱤뱥뱦뱧뱨뱩뱪뱫뱬뱭뱮뱯뱰뱱뱲뱳뱴뱵뱶뱷뱸뱹뱺뱻뱼뱽뱾뱿벀벁벂벃벆벇벉벊벍벏벐벑벒벓벖벘벛벜벝벞벟벢벣벥벦벩벪벫벬벭벮벯벲벶벷벸벹벺벻벾벿볁볂볃볅볆볇볈볉볊볋볌볎볒볓볔볖볗볙볚볛볝볞볟볠볡볢볣볤볥볦볧볨볩볪볫볬볭볮볯볰볱볲볳볷볹볺볻볽�".split("");
for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
D[148] = "�����������������������������������������������������������������볾볿봀봁봂봃봆봈봊봋봌봍봎봏봑봒봓봕봖봗봘봙봚봛봜봝������봞봟봠봡봢봣봥봦봧봨봩봪봫봭봮봯봰봱봲봳봴봵봶봷봸봹������봺봻봼봽봾봿뵁뵂뵃뵄뵅뵆뵇뵊뵋뵍뵎뵏뵑뵒뵓뵔뵕뵖뵗뵚뵛뵜뵝뵞뵟뵠뵡뵢뵣뵥뵦뵧뵩뵪뵫뵬뵭뵮뵯뵰뵱뵲뵳뵴뵵뵶뵷뵸뵹뵺뵻뵼뵽뵾뵿붂붃붅붆붋붌붍붎붏붒붔붖붗붘붛붝붞붟붠붡붢붣붥붦붧붨붩붪붫붬붭붮붯붱붲붳붴붵붶붷붹붺붻붼붽붾붿뷀뷁뷂뷃뷄뷅뷆뷇뷈뷉뷊뷋뷌뷍뷎뷏뷐뷑�".split("");
for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
D[149] = "�����������������������������������������������������������������뷒뷓뷖뷗뷙뷚뷛뷝뷞뷟뷠뷡뷢뷣뷤뷥뷦뷧뷨뷪뷫뷬뷭뷮뷯뷱������뷲뷳뷵뷶뷷뷹뷺뷻뷼뷽뷾뷿븁븂븄븆븇븈븉븊븋븎븏븑븒븓������븕븖븗븘븙븚븛븞븠븡븢븣븤븥븦븧븨븩븪븫븬븭븮븯븰븱븲븳븴븵븶븷븸븹븺븻븼븽븾븿빀빁빂빃빆빇빉빊빋빍빏빐빑빒빓빖빘빜빝빞빟빢빣빥빦빧빩빫빬빭빮빯빲빶빷빸빹빺빾빿뺁뺂뺃뺅뺆뺇뺈뺉뺊뺋뺎뺒뺓뺔뺕뺖뺗뺚뺛뺜뺝뺞뺟뺠뺡뺢뺣뺤뺥뺦뺧뺩뺪뺫뺬뺭뺮뺯뺰뺱뺲뺳뺴뺵뺶뺷�".split("");
for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
D[150] = "�����������������������������������������������������������������뺸뺹뺺뺻뺼뺽뺾뺿뻀뻁뻂뻃뻄뻅뻆뻇뻈뻉뻊뻋뻌뻍뻎뻏뻒뻓������뻕뻖뻙뻚뻛뻜뻝뻞뻟뻡뻢뻦뻧뻨뻩뻪뻫뻭뻮뻯뻰뻱뻲뻳뻴뻵������뻶뻷뻸뻹뻺뻻뻼뻽뻾뻿뼀뼂뼃뼄뼅뼆뼇뼊뼋뼌뼍뼎뼏뼐뼑뼒뼓뼔뼕뼖뼗뼚뼞뼟뼠뼡뼢뼣뼤뼥뼦뼧뼨뼩뼪뼫뼬뼭뼮뼯뼰뼱뼲뼳뼴뼵뼶뼷뼸뼹뼺뼻뼼뼽뼾뼿뽂뽃뽅뽆뽇뽉뽊뽋뽌뽍뽎뽏뽒뽓뽔뽖뽗뽘뽙뽚뽛뽜뽝뽞뽟뽠뽡뽢뽣뽤뽥뽦뽧뽨뽩뽪뽫뽬뽭뽮뽯뽰뽱뽲뽳뽴뽵뽶뽷뽸뽹뽺뽻뽼뽽뽾뽿뾀뾁뾂�".split("");
for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
D[151] = "�����������������������������������������������������������������뾃뾄뾅뾆뾇뾈뾉뾊뾋뾌뾍뾎뾏뾐뾑뾒뾓뾕뾖뾗뾘뾙뾚뾛뾜뾝������뾞뾟뾠뾡뾢뾣뾤뾥뾦뾧뾨뾩뾪뾫뾬뾭뾮뾯뾱뾲뾳뾴뾵뾶뾷뾸������뾹뾺뾻뾼뾽뾾뾿뿀뿁뿂뿃뿄뿆뿇뿈뿉뿊뿋뿎뿏뿑뿒뿓뿕뿖뿗뿘뿙뿚뿛뿝뿞뿠뿢뿣뿤뿥뿦뿧뿨뿩뿪뿫뿬뿭뿮뿯뿰뿱뿲뿳뿴뿵뿶뿷뿸뿹뿺뿻뿼뿽뿾뿿쀀쀁쀂쀃쀄쀅쀆쀇쀈쀉쀊쀋쀌쀍쀎쀏쀐쀑쀒쀓쀔쀕쀖쀗쀘쀙쀚쀛쀜쀝쀞쀟쀠쀡쀢쀣쀤쀥쀦쀧쀨쀩쀪쀫쀬쀭쀮쀯쀰쀱쀲쀳쀴쀵쀶쀷쀸쀹쀺쀻쀽쀾쀿�".split("");
for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
D[152] = "�����������������������������������������������������������������쁀쁁쁂쁃쁄쁅쁆쁇쁈쁉쁊쁋쁌쁍쁎쁏쁐쁒쁓쁔쁕쁖쁗쁙쁚쁛������쁝쁞쁟쁡쁢쁣쁤쁥쁦쁧쁪쁫쁬쁭쁮쁯쁰쁱쁲쁳쁴쁵쁶쁷쁸쁹������쁺쁻쁼쁽쁾쁿삀삁삂삃삄삅삆삇삈삉삊삋삌삍삎삏삒삓삕삖삗삙삚삛삜삝삞삟삢삤삦삧삨삩삪삫삮삱삲삷삸삹삺삻삾샂샃샄샆샇샊샋샍샎샏샑샒샓샔샕샖샗샚샞샟샠샡샢샣샦샧샩샪샫샭샮샯샰샱샲샳샶샸샺샻샼샽샾샿섁섂섃섅섆섇섉섊섋섌섍섎섏섑섒섓섔섖섗섘섙섚섛섡섢섥섨섩섪섫섮�".split("");
for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
D[153] = "�����������������������������������������������������������������섲섳섴섵섷섺섻섽섾섿셁셂셃셄셅셆셇셊셎셏셐셑셒셓셖셗������셙셚셛셝셞셟셠셡셢셣셦셪셫셬셭셮셯셱셲셳셵셶셷셹셺셻������셼셽셾셿솀솁솂솃솄솆솇솈솉솊솋솏솑솒솓솕솗솘솙솚솛솞솠솢솣솤솦솧솪솫솭솮솯솱솲솳솴솵솶솷솸솹솺솻솼솾솿쇀쇁쇂쇃쇅쇆쇇쇉쇊쇋쇍쇎쇏쇐쇑쇒쇓쇕쇖쇙쇚쇛쇜쇝쇞쇟쇡쇢쇣쇥쇦쇧쇩쇪쇫쇬쇭쇮쇯쇲쇴쇵쇶쇷쇸쇹쇺쇻쇾쇿숁숂숃숅숆숇숈숉숊숋숎숐숒숓숔숕숖숗숚숛숝숞숡숢숣�".split("");
for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
D[154] = "�����������������������������������������������������������������숤숥숦숧숪숬숮숰숳숵숶숷숸숹숺숻숼숽숾숿쉀쉁쉂쉃쉄쉅������쉆쉇쉉쉊쉋쉌쉍쉎쉏쉒쉓쉕쉖쉗쉙쉚쉛쉜쉝쉞쉟쉡쉢쉣쉤쉦������쉧쉨쉩쉪쉫쉮쉯쉱쉲쉳쉵쉶쉷쉸쉹쉺쉻쉾슀슂슃슄슅슆슇슊슋슌슍슎슏슑슒슓슔슕슖슗슙슚슜슞슟슠슡슢슣슦슧슩슪슫슮슯슰슱슲슳슶슸슺슻슼슽슾슿싀싁싂싃싄싅싆싇싈싉싊싋싌싍싎싏싐싑싒싓싔싕싖싗싘싙싚싛싞싟싡싢싥싦싧싨싩싪싮싰싲싳싴싵싷싺싽싾싿쌁쌂쌃쌄쌅쌆쌇쌊쌋쌎쌏�".split("");
for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
D[155] = "�����������������������������������������������������������������쌐쌑쌒쌖쌗쌙쌚쌛쌝쌞쌟쌠쌡쌢쌣쌦쌧쌪쌫쌬쌭쌮쌯쌰쌱쌲������쌳쌴쌵쌶쌷쌸쌹쌺쌻쌼쌽쌾쌿썀썁썂썃썄썆썇썈썉썊썋썌썍������썎썏썐썑썒썓썔썕썖썗썘썙썚썛썜썝썞썟썠썡썢썣썤썥썦썧썪썫썭썮썯썱썳썴썵썶썷썺썻썾썿쎀쎁쎂쎃쎅쎆쎇쎉쎊쎋쎍쎎쎏쎐쎑쎒쎓쎔쎕쎖쎗쎘쎙쎚쎛쎜쎝쎞쎟쎠쎡쎢쎣쎤쎥쎦쎧쎨쎩쎪쎫쎬쎭쎮쎯쎰쎱쎲쎳쎴쎵쎶쎷쎸쎹쎺쎻쎼쎽쎾쎿쏁쏂쏃쏄쏅쏆쏇쏈쏉쏊쏋쏌쏍쏎쏏쏐쏑쏒쏓쏔쏕쏖쏗쏚�".split("");
for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
D[156] = "�����������������������������������������������������������������쏛쏝쏞쏡쏣쏤쏥쏦쏧쏪쏫쏬쏮쏯쏰쏱쏲쏳쏶쏷쏹쏺쏻쏼쏽쏾������쏿쐀쐁쐂쐃쐄쐅쐆쐇쐉쐊쐋쐌쐍쐎쐏쐑쐒쐓쐔쐕쐖쐗쐘쐙쐚������쐛쐜쐝쐞쐟쐠쐡쐢쐣쐥쐦쐧쐨쐩쐪쐫쐭쐮쐯쐱쐲쐳쐵쐶쐷쐸쐹쐺쐻쐾쐿쑀쑁쑂쑃쑄쑅쑆쑇쑉쑊쑋쑌쑍쑎쑏쑐쑑쑒쑓쑔쑕쑖쑗쑘쑙쑚쑛쑜쑝쑞쑟쑠쑡쑢쑣쑦쑧쑩쑪쑫쑭쑮쑯쑰쑱쑲쑳쑶쑷쑸쑺쑻쑼쑽쑾쑿쒁쒂쒃쒄쒅쒆쒇쒈쒉쒊쒋쒌쒍쒎쒏쒐쒑쒒쒓쒕쒖쒗쒘쒙쒚쒛쒝쒞쒟쒠쒡쒢쒣쒤쒥쒦쒧쒨쒩�".split("");
for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
D[157] = "�����������������������������������������������������������������쒪쒫쒬쒭쒮쒯쒰쒱쒲쒳쒴쒵쒶쒷쒹쒺쒻쒽쒾쒿쓀쓁쓂쓃쓄쓅������쓆쓇쓈쓉쓊쓋쓌쓍쓎쓏쓐쓑쓒쓓쓔쓕쓖쓗쓘쓙쓚쓛쓜쓝쓞쓟������쓠쓡쓢쓣쓤쓥쓦쓧쓨쓪쓫쓬쓭쓮쓯쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂씃씄씅씆씇씈씉씊씋씍씎씏씑씒씓씕씖씗씘씙씚씛씝씞씟씠씡씢씣씤씥씦씧씪씫씭씮씯씱씲씳씴씵씶씷씺씼씾씿앀앁앂앃앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩앪앫앬앭앮앯앲앶앷앸앹앺앻앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔�".split("");
for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
D[158] = "�����������������������������������������������������������������얖얙얚얛얝얞얟얡얢얣얤얥얦얧얨얪얫얬얭얮얯얰얱얲얳얶������얷얺얿엀엁엂엃엋엍엏엒엓엕엖엗엙엚엛엜엝엞엟엢엤엦엧������엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑옒옓옔옕옖옗옚옝옞옟옠옡옢옣옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉왊왋왌왍왎왏왒왖왗왘왙왚왛왞왟왡왢왣왤왥왦왧왨왩왪왫왭왮왰왲왳왴왵왶왷왺왻왽왾왿욁욂욃욄욅욆욇욊욌욎욏욐욑욒욓욖욗욙욚욛욝욞욟욠욡욢욣욦�".split("");
for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
D[159] = "�����������������������������������������������������������������욨욪욫욬욭욮욯욲욳욵욶욷욻욼욽욾욿웂웄웆웇웈웉웊웋웎������웏웑웒웓웕웖웗웘웙웚웛웞웟웢웣웤웥웦웧웪웫웭웮웯웱웲������웳웴웵웶웷웺웻웼웾웿윀윁윂윃윆윇윉윊윋윍윎윏윐윑윒윓윖윘윚윛윜윝윞윟윢윣윥윦윧윩윪윫윬윭윮윯윲윴윶윸윹윺윻윾윿읁읂읃읅읆읇읈읉읋읎읐읙읚읛읝읞읟읡읢읣읤읥읦읧읩읪읬읭읮읯읰읱읲읳읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛잜잝잞잟잢잧잨잩잪잫잮잯잱잲잳잵잶잷�".split("");
for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
D[160] = "�����������������������������������������������������������������잸잹잺잻잾쟂쟃쟄쟅쟆쟇쟊쟋쟍쟏쟑쟒쟓쟔쟕쟖쟗쟙쟚쟛쟜������쟞쟟쟠쟡쟢쟣쟥쟦쟧쟩쟪쟫쟭쟮쟯쟰쟱쟲쟳쟴쟵쟶쟷쟸쟹쟺������쟻쟼쟽쟾쟿젂젃젅젆젇젉젋젌젍젎젏젒젔젗젘젙젚젛젞젟젡젢젣젥젦젧젨젩젪젫젮젰젲젳젴젵젶젷젹젺젻젽젾젿졁졂졃졄졅졆졇졊졋졎졏졐졑졒졓졕졖졗졘졙졚졛졜졝졞졟졠졡졢졣졤졥졦졧졨졩졪졫졬졭졮졯졲졳졵졶졷졹졻졼졽졾졿좂좄좈좉좊좎좏좐좑좒좓좕좖좗좘좙좚좛좜좞좠좢좣좤�".split("");
for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
D[161] = "�����������������������������������������������������������������좥좦좧좩좪좫좬좭좮좯좰좱좲좳좴좵좶좷좸좹좺좻좾좿죀죁������죂죃죅죆죇죉죊죋죍죎죏죐죑죒죓죖죘죚죛죜죝죞죟죢죣죥������죦죧죨죩죪죫죬죭죮죯죰죱죲죳죴죶죷죸죹죺죻죾죿줁줂줃줇줈줉줊줋줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈〉《》「」『』【】±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢�".split("");
for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
D[162] = "�����������������������������������������������������������������줐줒줓줔줕줖줗줙줚줛줜줝줞줟줠줡줢줣줤줥줦줧줨줩줪줫������줭줮줯줰줱줲줳줵줶줷줸줹줺줻줼줽줾줿쥀쥁쥂쥃쥄쥅쥆쥇������쥈쥉쥊쥋쥌쥍쥎쥏쥒쥓쥕쥖쥗쥙쥚쥛쥜쥝쥞쥟쥢쥤쥥쥦쥧쥨쥩쥪쥫쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®������������������������".split("");
for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
D[163] = "�����������������������������������������������������������������쥱쥲쥳쥵쥶쥷쥸쥹쥺쥻쥽쥾쥿즀즁즂즃즄즅즆즇즊즋즍즎즏������즑즒즓즔즕즖즗즚즜즞즟즠즡즢즣즤즥즦즧즨즩즪즫즬즭즮������즯즰즱즲즳즴즵즶즷즸즹즺즻즼즽즾즿짂짃짅짆짉짋짌짍짎짏짒짔짗짘짛！＂＃＄％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［￦］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
D[164] = "�����������������������������������������������������������������짞짟짡짣짥짦짨짩짪짫짮짲짳짴짵짶짷짺짻짽짾짿쨁쨂쨃쨄������쨅쨆쨇쨊쨎쨏쨐쨑쨒쨓쨕쨖쨗쨙쨚쨛쨜쨝쨞쨟쨠쨡쨢쨣쨤쨥������쨦쨧쨨쨪쨫쨬쨭쨮쨯쨰쨱쨲쨳쨴쨵쨶쨷쨸쨹쨺쨻쨼쨽쨾쨿쩀쩁쩂쩃쩄쩅쩆ㄱㄲㄳㄴㄵㄶㄷㄸㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅃㅄㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣㅤㅥㅦㅧㅨㅩㅪㅫㅬㅭㅮㅯㅰㅱㅲㅳㅴㅵㅶㅷㅸㅹㅺㅻㅼㅽㅾㅿㆀㆁㆂㆃㆄㆅㆆㆇㆈㆉㆊㆋㆌㆍㆎ�".split("");
for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
D[165] = "�����������������������������������������������������������������쩇쩈쩉쩊쩋쩎쩏쩑쩒쩓쩕쩖쩗쩘쩙쩚쩛쩞쩢쩣쩤쩥쩦쩧쩩쩪������쩫쩬쩭쩮쩯쩰쩱쩲쩳쩴쩵쩶쩷쩸쩹쩺쩻쩼쩾쩿쪀쪁쪂쪃쪅쪆������쪇쪈쪉쪊쪋쪌쪍쪎쪏쪐쪑쪒쪓쪔쪕쪖쪗쪙쪚쪛쪜쪝쪞쪟쪠쪡쪢쪣쪤쪥쪦쪧ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ�����ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������".split("");
for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
D[166] = "�����������������������������������������������������������������쪨쪩쪪쪫쪬쪭쪮쪯쪰쪱쪲쪳쪴쪵쪶쪷쪸쪹쪺쪻쪾쪿쫁쫂쫃쫅������쫆쫇쫈쫉쫊쫋쫎쫐쫒쫔쫕쫖쫗쫚쫛쫜쫝쫞쫟쫡쫢쫣쫤쫥쫦쫧������쫨쫩쫪쫫쫭쫮쫯쫰쫱쫲쫳쫵쫶쫷쫸쫹쫺쫻쫼쫽쫾쫿쬀쬁쬂쬃쬄쬅쬆쬇쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃╄╅╆╇╈╉╊���������������������������".split("");
for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
D[167] = "�����������������������������������������������������������������쬋쬌쬍쬎쬏쬑쬒쬓쬕쬖쬗쬙쬚쬛쬜쬝쬞쬟쬢쬣쬤쬥쬦쬧쬨쬩������쬪쬫쬬쬭쬮쬯쬰쬱쬲쬳쬴쬵쬶쬷쬸쬹쬺쬻쬼쬽쬾쬿쭀쭂쭃쭄������쭅쭆쭇쭊쭋쭍쭎쭏쭑쭒쭓쭔쭕쭖쭗쭚쭛쭜쭞쭟쭠쭡쭢쭣쭥쭦쭧쭨쭩쭪쭫쭬㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙㎚㎛㎜㎝㎞㎟㎠㎡㎢㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰㎱㎲㎳㎴㎵㎶㎷㎸㎹㎀㎁㎂㎃㎄㎺㎻㎼㎽㎾㎿㎐㎑㎒㎓㎔Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆����������������".split("");
for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
D[168] = "�����������������������������������������������������������������쭭쭮쭯쭰쭱쭲쭳쭴쭵쭶쭷쭺쭻쭼쭽쭾쭿쮀쮁쮂쮃쮄쮅쮆쮇쮈������쮉쮊쮋쮌쮍쮎쮏쮐쮑쮒쮓쮔쮕쮖쮗쮘쮙쮚쮛쮝쮞쮟쮠쮡쮢쮣������쮤쮥쮦쮧쮨쮩쮪쮫쮬쮭쮮쮯쮰쮱쮲쮳쮴쮵쮶쮷쮹쮺쮻쮼쮽쮾쮿쯀쯁쯂쯃쯄ÆÐªĦ�Ĳ�ĿŁØŒºÞŦŊ�㉠㉡㉢㉣㉤㉥㉦㉧㉨㉩㉪㉫㉬㉭㉮㉯㉰㉱㉲㉳㉴㉵㉶㉷㉸㉹㉺㉻ⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮½⅓⅔¼¾⅛⅜⅝⅞�".split("");
for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
D[169] = "�����������������������������������������������������������������쯅쯆쯇쯈쯉쯊쯋쯌쯍쯎쯏쯐쯑쯒쯓쯕쯖쯗쯘쯙쯚쯛쯜쯝쯞쯟������쯠쯡쯢쯣쯥쯦쯨쯪쯫쯬쯭쯮쯯쯰쯱쯲쯳쯴쯵쯶쯷쯸쯹쯺쯻쯼������쯽쯾쯿찀찁찂찃찄찅찆찇찈찉찊찋찎찏찑찒찓찕찖찗찘찙찚찛찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀㈁㈂㈃㈄㈅㈆㈇㈈㈉㈊㈋㈌㈍㈎㈏㈐㈑㈒㈓㈔㈕㈖㈗㈘㈙㈚㈛⒜⒝⒞⒟⒠⒡⒢⒣⒤⒥⒦⒧⒨⒩⒪⒫⒬⒭⒮⒯⒰⒱⒲⒳⒴⒵⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂¹²³⁴ⁿ₁₂₃₄�".split("");
for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
D[170] = "�����������������������������������������������������������������찥찦찪찫찭찯찱찲찳찴찵찶찷찺찿챀챁챂챃챆챇챉챊챋챍챎������챏챐챑챒챓챖챚챛챜챝챞챟챡챢챣챥챧챩챪챫챬챭챮챯챱챲������챳챴챶챷챸챹챺챻챼챽챾챿첀첁첂첃첄첅첆첇첈첉첊첋첌첍첎첏첐첑첒첓ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
D[171] = "�����������������������������������������������������������������첔첕첖첗첚첛첝첞첟첡첢첣첤첥첦첧첪첮첯첰첱첲첳첶첷첹������첺첻첽첾첿쳀쳁쳂쳃쳆쳈쳊쳋쳌쳍쳎쳏쳑쳒쳓쳕쳖쳗쳘쳙쳚������쳛쳜쳝쳞쳟쳠쳡쳢쳣쳥쳦쳧쳨쳩쳪쳫쳭쳮쳯쳱쳲쳳쳴쳵쳶쳷쳸쳹쳺쳻쳼쳽ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
D[172] = "�����������������������������������������������������������������쳾쳿촀촂촃촄촅촆촇촊촋촍촎촏촑촒촓촔촕촖촗촚촜촞촟촠������촡촢촣촥촦촧촩촪촫촭촮촯촰촱촲촳촴촵촶촷촸촺촻촼촽촾������촿쵀쵁쵂쵃쵄쵅쵆쵇쵈쵉쵊쵋쵌쵍쵎쵏쵐쵑쵒쵓쵔쵕쵖쵗쵘쵙쵚쵛쵝쵞쵟АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
D[173] = "�����������������������������������������������������������������쵡쵢쵣쵥쵦쵧쵨쵩쵪쵫쵮쵰쵲쵳쵴쵵쵶쵷쵹쵺쵻쵼쵽쵾쵿춀������춁춂춃춄춅춆춇춉춊춋춌춍춎춏춐춑춒춓춖춗춙춚춛춝춞춟������춠춡춢춣춦춨춪춫춬춭춮춯춱춲춳춴춵춶춷춸춹춺춻춼춽춾춿췀췁췂췃췅�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
D[174] = "�����������������������������������������������������������������췆췇췈췉췊췋췍췎췏췑췒췓췔췕췖췗췘췙췚췛췜췝췞췟췠췡������췢췣췤췥췦췧췩췪췫췭췮췯췱췲췳췴췵췶췷췺췼췾췿츀츁츂������츃츅츆츇츉츊츋츍츎츏츐츑츒츓츕츖츗츘츚츛츜츝츞츟츢츣츥츦츧츩츪츫�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
D[175] = "�����������������������������������������������������������������츬츭츮츯츲츴츶츷츸츹츺츻츼츽츾츿칀칁칂칃칄칅칆칇칈칉������칊칋칌칍칎칏칐칑칒칓칔칕칖칗칚칛칝칞칢칣칤칥칦칧칪칬������칮칯칰칱칲칳칶칷칹칺칻칽칾칿캀캁캂캃캆캈캊캋캌캍캎캏캒캓캕캖캗캙�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
D[176] = "�����������������������������������������������������������������캚캛캜캝캞캟캢캦캧캨캩캪캫캮캯캰캱캲캳캴캵캶캷캸캹캺������캻캼캽캾캿컀컂컃컄컅컆컇컈컉컊컋컌컍컎컏컐컑컒컓컔컕������컖컗컘컙컚컛컜컝컞컟컠컡컢컣컦컧컩컪컭컮컯컰컱컲컳컶컺컻컼컽컾컿가각간갇갈갉갊감갑값갓갔강갖갗같갚갛개객갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆�".split("");
for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
D[177] = "�����������������������������������������������������������������켂켃켅켆켇켉켊켋켌켍켎켏켒켔켖켗켘켙켚켛켝켞켟켡켢켣������켥켦켧켨켩켪켫켮켲켳켴켵켶켷켹켺켻켼켽켾켿콀콁콂콃콄������콅콆콇콈콉콊콋콌콍콎콏콐콑콒콓콖콗콙콚콛콝콞콟콠콡콢콣콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸�".split("");
for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
D[178] = "�����������������������������������������������������������������콭콮콯콲콳콵콶콷콹콺콻콼콽콾콿쾁쾂쾃쾄쾆쾇쾈쾉쾊쾋쾍������쾎쾏쾐쾑쾒쾓쾔쾕쾖쾗쾘쾙쾚쾛쾜쾝쾞쾟쾠쾢쾣쾤쾥쾦쾧쾩������쾪쾫쾬쾭쾮쾯쾱쾲쾳쾴쾵쾶쾷쾸쾹쾺쾻쾼쾽쾾쾿쿀쿁쿂쿃쿅쿆쿇쿈쿉쿊쿋깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙�".split("");
for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
D[179] = "�����������������������������������������������������������������쿌쿍쿎쿏쿐쿑쿒쿓쿔쿕쿖쿗쿘쿙쿚쿛쿜쿝쿞쿟쿢쿣쿥쿦쿧쿩������쿪쿫쿬쿭쿮쿯쿲쿴쿶쿷쿸쿹쿺쿻쿽쿾쿿퀁퀂퀃퀅퀆퀇퀈퀉퀊������퀋퀌퀍퀎퀏퀐퀒퀓퀔퀕퀖퀗퀙퀚퀛퀜퀝퀞퀟퀠퀡퀢퀣퀤퀥퀦퀧퀨퀩퀪퀫퀬끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫났낭낮낯낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝�".split("");
for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
D[180] = "�����������������������������������������������������������������퀮퀯퀰퀱퀲퀳퀶퀷퀹퀺퀻퀽퀾퀿큀큁큂큃큆큈큊큋큌큍큎큏������큑큒큓큕큖큗큙큚큛큜큝큞큟큡큢큣큤큥큦큧큨큩큪큫큮큯������큱큲큳큵큶큷큸큹큺큻큾큿킀킂킃킄킅킆킇킈킉킊킋킌킍킎킏킐킑킒킓킔뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫달닭닮닯닳담답닷닸당닺닻닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥�".split("");
for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
D[181] = "�����������������������������������������������������������������킕킖킗킘킙킚킛킜킝킞킟킠킡킢킣킦킧킩킪킫킭킮킯킰킱킲������킳킶킸킺킻킼킽킾킿탂탃탅탆탇탊탋탌탍탎탏탒탖탗탘탙탚������탛탞탟탡탢탣탥탦탧탨탩탪탫탮탲탳탴탵탶탷탹탺탻탼탽탾탿턀턁턂턃턄덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸�".split("");
for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
D[182] = "�����������������������������������������������������������������턅턆턇턈턉턊턋턌턎턏턐턑턒턓턔턕턖턗턘턙턚턛턜턝턞턟������턠턡턢턣턤턥턦턧턨턩턪턫턬턭턮턯턲턳턵턶턷턹턻턼턽턾������턿텂텆텇텈텉텊텋텎텏텑텒텓텕텖텗텘텙텚텛텞텠텢텣텤텥텦텧텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗�".split("");
for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
D[183] = "�����������������������������������������������������������������텮텯텰텱텲텳텴텵텶텷텸텹텺텻텽텾텿톀톁톂톃톅톆톇톉톊������톋톌톍톎톏톐톑톒톓톔톕톖톗톘톙톚톛톜톝톞톟톢톣톥톦톧������톩톪톫톬톭톮톯톲톴톶톷톸톹톻톽톾톿퇁퇂퇃퇄퇅퇆퇇퇈퇉퇊퇋퇌퇍퇎퇏래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩�".split("");
for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
D[184] = "�����������������������������������������������������������������퇐퇑퇒퇓퇔퇕퇖퇗퇙퇚퇛퇜퇝퇞퇟퇠퇡퇢퇣퇤퇥퇦퇧퇨퇩퇪������퇫퇬퇭퇮퇯퇰퇱퇲퇳퇵퇶퇷퇹퇺퇻퇼퇽퇾퇿툀툁툂툃툄툅툆������툈툊툋툌툍툎툏툑툒툓툔툕툖툗툘툙툚툛툜툝툞툟툠툡툢툣툤툥툦툧툨툩륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많맏말맑맒맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼�".split("");
for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
D[185] = "�����������������������������������������������������������������툪툫툮툯툱툲툳툵툶툷툸툹툺툻툾퉀퉂퉃퉄퉅퉆퉇퉉퉊퉋퉌������퉍퉎퉏퉐퉑퉒퉓퉔퉕퉖퉗퉘퉙퉚퉛퉝퉞퉟퉠퉡퉢퉣퉥퉦퉧퉨������퉩퉪퉫퉬퉭퉮퉯퉰퉱퉲퉳퉴퉵퉶퉷퉸퉹퉺퉻퉼퉽퉾퉿튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바박밖밗반받발밝밞밟밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗�".split("");
for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
D[186] = "�����������������������������������������������������������������튍튎튏튒튓튔튖튗튘튙튚튛튝튞튟튡튢튣튥튦튧튨튩튪튫튭������튮튯튰튲튳튴튵튶튷튺튻튽튾틁틃틄틅틆틇틊틌틍틎틏틐틑������틒틓틕틖틗틙틚틛틝틞틟틠틡틢틣틦틧틨틩틪틫틬틭틮틯틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤�".split("");
for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
D[187] = "�����������������������������������������������������������������틻틼틽틾틿팂팄팆팇팈팉팊팋팏팑팒팓팕팗팘팙팚팛팞팢팣������팤팦팧팪팫팭팮팯팱팲팳팴팵팶팷팺팾팿퍀퍁퍂퍃퍆퍇퍈퍉������퍊퍋퍌퍍퍎퍏퍐퍑퍒퍓퍔퍕퍖퍗퍘퍙퍚퍛퍜퍝퍞퍟퍠퍡퍢퍣퍤퍥퍦퍧퍨퍩빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤�".split("");
for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
D[188] = "�����������������������������������������������������������������퍪퍫퍬퍭퍮퍯퍰퍱퍲퍳퍴퍵퍶퍷퍸퍹퍺퍻퍾퍿펁펂펃펅펆펇������펈펉펊펋펎펒펓펔펕펖펗펚펛펝펞펟펡펢펣펤펥펦펧펪펬펮������펯펰펱펲펳펵펶펷펹펺펻펽펾펿폀폁폂폃폆폇폊폋폌폍폎폏폑폒폓폔폕폖샥샨샬샴샵샷샹섀섄섈섐섕서석섞섟선섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭�".split("");
for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
D[189] = "�����������������������������������������������������������������폗폙폚폛폜폝폞폟폠폢폤폥폦폧폨폩폪폫폮폯폱폲폳폵폶폷������폸폹폺폻폾퐀퐂퐃퐄퐅퐆퐇퐉퐊퐋퐌퐍퐎퐏퐐퐑퐒퐓퐔퐕퐖������퐗퐘퐙퐚퐛퐜퐞퐟퐠퐡퐢퐣퐤퐥퐦퐧퐨퐩퐪퐫퐬퐭퐮퐯퐰퐱퐲퐳퐴퐵퐶퐷숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰�".split("");
for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
D[190] = "�����������������������������������������������������������������퐸퐹퐺퐻퐼퐽퐾퐿푁푂푃푅푆푇푈푉푊푋푌푍푎푏푐푑푒푓������푔푕푖푗푘푙푚푛푝푞푟푡푢푣푥푦푧푨푩푪푫푬푮푰푱푲������푳푴푵푶푷푺푻푽푾풁풃풄풅풆풇풊풌풎풏풐풑풒풓풕풖풗풘풙풚풛풜풝쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄업없엇었엉엊엌엎�".split("");
for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
D[191] = "�����������������������������������������������������������������풞풟풠풡풢풣풤풥풦풧풨풪풫풬풭풮풯풰풱풲풳풴풵풶풷풸������풹풺풻풼풽풾풿퓀퓁퓂퓃퓄퓅퓆퓇퓈퓉퓊퓋퓍퓎퓏퓑퓒퓓퓕������퓖퓗퓘퓙퓚퓛퓝퓞퓠퓡퓢퓣퓤퓥퓦퓧퓩퓪퓫퓭퓮퓯퓱퓲퓳퓴퓵퓶퓷퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염엽엾엿였영옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨�".split("");
for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
D[192] = "�����������������������������������������������������������������퓾퓿픀픁픂픃픅픆픇픉픊픋픍픎픏픐픑픒픓픖픘픙픚픛픜픝������픞픟픠픡픢픣픤픥픦픧픨픩픪픫픬픭픮픯픰픱픲픳픴픵픶픷������픸픹픺픻픾픿핁핂핃핅핆핇핈핉핊핋핎핐핒핓핔핕핖핗핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응읒읓읔읕읖읗의읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊�".split("");
for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
D[193] = "�����������������������������������������������������������������핤핦핧핪핬핮핯핰핱핲핳핶핷핹핺핻핽핾핿햀햁햂햃햆햊햋������햌햍햎햏햑햒햓햔햕햖햗햘햙햚햛햜햝햞햟햠햡햢햣햤햦햧������햨햩햪햫햬햭햮햯햰햱햲햳햴햵햶햷햸햹햺햻햼햽햾햿헀헁헂헃헄헅헆헇점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓�".split("");
for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
D[194] = "�����������������������������������������������������������������헊헋헍헎헏헑헓헔헕헖헗헚헜헞헟헠헡헢헣헦헧헩헪헫헭헮������헯헰헱헲헳헶헸헺헻헼헽헾헿혂혃혅혆혇혉혊혋혌혍혎혏혒������혖혗혘혙혚혛혝혞혟혡혢혣혥혦혧혨혩혪혫혬혮혯혰혱혲혳혴혵혶혷혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻�".split("");
for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
D[195] = "�����������������������������������������������������������������혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝홞홟홠홡������홢홣홤홥홦홨홪홫홬홭홮홯홲홳홵홶홷홸홹홺홻홼홽홾홿횀������횁횂횄횆횇횈횉횊횋횎횏횑횒횓횕횖횗횘횙횚횛횜횞횠횢횣횤횥횦횧횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층�".split("");
for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
D[196] = "�����������������������������������������������������������������횫횭횮횯횱횲횳횴횵횶횷횸횺횼횽횾횿훀훁훂훃훆훇훉훊훋������훍훎훏훐훒훓훕훖훘훚훛훜훝훞훟훡훢훣훥훦훧훩훪훫훬훭������훮훯훱훲훳훴훶훷훸훹훺훻훾훿휁휂휃휅휆휇휈휉휊휋휌휍휎휏휐휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼�".split("");
for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
D[197] = "�����������������������������������������������������������������휕휖휗휚휛휝휞휟휡휢휣휤휥휦휧휪휬휮휯휰휱휲휳휶휷휹������휺휻휽휾휿흀흁흂흃흅흆흈흊흋흌흍흎흏흒흓흕흚흛흜흝흞������흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵흶흷흸흹흺흻흾흿힀힂힃힄힅힆힇힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜�".split("");
for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
D[198] = "�����������������������������������������������������������������힍힎힏힑힒힓힔힕힖힗힚힜힞힟힠힡힢힣������������������������������������������������������������������������������퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁�".split("");
for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠�".split("");
for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝�".split("");
for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕�".split("");
for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢�".split("");
for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械�".split("");
for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜�".split("");
for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾�".split("");
for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴�".split("");
for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣�".split("");
for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩羅蘿螺裸邏那樂洛烙珞落諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉�".split("");
for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������納臘蠟衲囊娘廊朗浪狼郎乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧老蘆虜路露駑魯鷺碌祿綠菉錄鹿論壟弄濃籠聾膿農惱牢磊腦賂雷尿壘屢樓淚漏累縷陋嫩訥杻紐勒肋凜凌稜綾能菱陵尼泥匿溺多茶�".split("");
for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃�".split("");
for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅�".split("");
for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣�".split("");
for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼�".split("");
for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬�".split("");
for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅�".split("");
for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文�".split("");
for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑�".split("");
for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖�".split("");
for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦�".split("");
for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥�".split("");
for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索�".split("");
for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署�".split("");
for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬�".split("");
for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁�".split("");
for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧�".split("");
for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁�".split("");
for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額�".split("");
for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬�".split("");
for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒�".split("");
for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳�".split("");
for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療�".split("");
for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓�".split("");
for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜�".split("");
for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼�".split("");
for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄�".split("");
for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長�".split("");
for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱�".split("");
for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖�".split("");
for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫�".split("");
for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只�".split("");
for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯�".split("");
for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策�".split("");
for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢�".split("");
for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃�".split("");
for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託�".split("");
for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑�".split("");
for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
D[248] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃�".split("");
for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
D[249] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航�".split("");
for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
D[250] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型�".split("");
for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
D[251] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵�".split("");
for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
D[252] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆�".split("");
for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
D[253] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰�".split("");
for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
return {"enc": e, "dec": d }; })();
cptable[950] = (function(){ var d = [], e = {}, D = [], j;
D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
D[161] = "����������������������������������������������������������������　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚����������������������������������﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢﹣﹤﹥﹦～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／�".split("");
for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
D[162] = "����������������������������������������������������������������＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁▂▃▄▅▆▇█▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭����������������������������������╮╰╯═╞╪╡◢◣◥◤╱╲╳０１２３４５６７８９ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ〡〢〣〤〥〦〧〨〩十卄卅ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖ�".split("");
for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
D[163] = "����������������������������������������������������������������ｗｘｙｚΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏ����������������������������������ㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ˙ˉˊˇˋ���������������������������������€������������������������������".split("");
for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
D[164] = "����������������������������������������������������������������一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才����������������������������������丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙�".split("");
for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
D[165] = "����������������������������������������������������������������世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外����������������������������������央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全�".split("");
for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
D[166] = "����������������������������������������������������������������共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年����������������������������������式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣�".split("");
for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
D[167] = "����������������������������������������������������������������作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍����������������������������������均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠�".split("");
for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
D[168] = "����������������������������������������������������������������杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒����������������������������������芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵�".split("");
for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
D[169] = "����������������������������������������������������������������咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居����������������������������������屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊�".split("");
for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
D[170] = "����������������������������������������������������������������昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠����������������������������������炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附�".split("");
for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
D[171] = "����������������������������������������������������������������陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品����������������������������������哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷�".split("");
for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
D[172] = "����������������������������������������������������������������拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗����������������������������������活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄�".split("");
for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
D[173] = "����������������������������������������������������������������耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥����������������������������������迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪�".split("");
for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
D[174] = "����������������������������������������������������������������哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙����������������������������������恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓�".split("");
for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
D[175] = "����������������������������������������������������������������浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷����������������������������������砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃�".split("");
for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
D[176] = "����������������������������������������������������������������虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡����������������������������������陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀�".split("");
for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
D[177] = "����������������������������������������������������������������娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽����������������������������������情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺�".split("");
for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
D[178] = "����������������������������������������������������������������毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶����������������������������������瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼�".split("");
for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
D[179] = "����������������������������������������������������������������莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途����������������������������������部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠�".split("");
for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
D[180] = "����������������������������������������������������������������婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍����������������������������������插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋�".split("");
for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
D[181] = "����������������������������������������������������������������溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘����������������������������������窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁�".split("");
for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
D[182] = "����������������������������������������������������������������詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑����������������������������������間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼�".split("");
for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
D[183] = "����������������������������������������������������������������媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業����������������������������������楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督�".split("");
for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
D[184] = "����������������������������������������������������������������睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫����������������������������������腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊�".split("");
for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
D[185] = "����������������������������������������������������������������辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴����������������������������������飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇�".split("");
for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
D[186] = "����������������������������������������������������������������愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢����������������������������������滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬�".split("");
for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
D[187] = "����������������������������������������������������������������罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤����������������������������������說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜�".split("");
for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
D[188] = "����������������������������������������������������������������劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂����������������������������������慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃�".split("");
for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
D[189] = "����������������������������������������������������������������瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯����������������������������������翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞�".split("");
for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
D[190] = "����������������������������������������������������������������輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉����������������������������������鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡�".split("");
for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
D[191] = "����������������������������������������������������������������濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊����������������������������������縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚�".split("");
for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
D[192] = "����������������������������������������������������������������錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇����������������������������������嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬�".split("");
for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
D[193] = "����������������������������������������������������������������瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪����������������������������������薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁�".split("");
for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
D[194] = "����������������������������������������������������������������駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘����������������������������������癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦�".split("");
for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
D[195] = "����������������������������������������������������������������鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸����������������������������������獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類�".split("");
for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
D[196] = "����������������������������������������������������������������願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼����������������������������������纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴�".split("");
for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
D[197] = "����������������������������������������������������������������護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬����������������������������������禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒�".split("");
for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
D[198] = "����������������������������������������������������������������讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲���������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
D[201] = "����������������������������������������������������������������乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕����������������������������������氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋�".split("");
for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
D[202] = "����������������������������������������������������������������汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘����������������������������������吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇�".split("");
for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
D[203] = "����������������������������������������������������������������杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓����������������������������������芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢�".split("");
for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
D[204] = "����������������������������������������������������������������坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋����������������������������������怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲�".split("");
for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
D[205] = "����������������������������������������������������������������泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺����������������������������������矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏�".split("");
for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
D[206] = "����������������������������������������������������������������哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛����������������������������������峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺�".split("");
for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
D[207] = "����������������������������������������������������������������柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂����������������������������������洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀�".split("");
for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
D[208] = "����������������������������������������������������������������穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪����������������������������������苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱�".split("");
for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
D[209] = "����������������������������������������������������������������唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧����������������������������������恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤�".split("");
for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
D[210] = "����������������������������������������������������������������毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸����������������������������������牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐�".split("");
for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
D[211] = "����������������������������������������������������������������笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢����������������������������������荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐�".split("");
for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
D[212] = "����������������������������������������������������������������酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅����������������������������������唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏�".split("");
for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
D[213] = "����������������������������������������������������������������崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟����������������������������������捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉�".split("");
for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
D[214] = "����������������������������������������������������������������淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏����������������������������������痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟�".split("");
for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
D[215] = "����������������������������������������������������������������耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷����������������������������������蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪�".split("");
for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
D[216] = "����������������������������������������������������������������釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷����������������������������������堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔�".split("");
for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
D[217] = "����������������������������������������������������������������惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒����������������������������������晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞�".split("");
for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
D[218] = "����������������������������������������������������������������湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖����������������������������������琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥�".split("");
for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
D[219] = "����������������������������������������������������������������罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳����������������������������������菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺�".split("");
for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
D[220] = "����������������������������������������������������������������軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈����������������������������������隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆�".split("");
for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
D[221] = "����������������������������������������������������������������媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤����������������������������������搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼�".split("");
for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
D[222] = "����������������������������������������������������������������毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓����������������������������������煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓�".split("");
for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
D[223] = "����������������������������������������������������������������稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯����������������������������������腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤�".split("");
for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
D[224] = "����������������������������������������������������������������觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿����������������������������������遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠�".split("");
for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
D[225] = "����������������������������������������������������������������凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠����������������������������������寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉�".split("");
for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
D[226] = "����������������������������������������������������������������榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊����������������������������������漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓�".split("");
for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
D[227] = "����������������������������������������������������������������禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞����������������������������������耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻�".split("");
for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
D[228] = "����������������������������������������������������������������裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍����������������������������������銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘�".split("");
for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
D[229] = "����������������������������������������������������������������噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉����������������������������������憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒�".split("");
for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
D[230] = "����������������������������������������������������������������澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙����������������������������������獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟�".split("");
for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
D[231] = "����������������������������������������������������������������膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢����������������������������������蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧�".split("");
for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
D[232] = "����������������������������������������������������������������踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓����������������������������������銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮�".split("");
for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
D[233] = "����������������������������������������������������������������噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺����������������������������������憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸�".split("");
for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
D[234] = "����������������������������������������������������������������澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙����������������������������������瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘�".split("");
for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
D[235] = "����������������������������������������������������������������蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠����������������������������������諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌�".split("");
for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
D[236] = "����������������������������������������������������������������錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕����������������������������������魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎�".split("");
for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
D[237] = "����������������������������������������������������������������檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶����������������������������������瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞�".split("");
for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
D[238] = "����������������������������������������������������������������蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞����������������������������������謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜�".split("");
for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
D[239] = "����������������������������������������������������������������鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰����������������������������������鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶�".split("");
for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
D[240] = "����������������������������������������������������������������璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒����������������������������������臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧�".split("");
for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
D[241] = "����������������������������������������������������������������蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪����������������������������������鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰�".split("");
for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
D[242] = "����������������������������������������������������������������徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛����������������������������������礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕�".split("");
for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
D[243] = "����������������������������������������������������������������譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦����������������������������������鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲�".split("");
for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
D[244] = "����������������������������������������������������������������嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩����������������������������������禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿�".split("");
for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
D[245] = "����������������������������������������������������������������鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛����������������������������������鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥�".split("");
for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
D[246] = "����������������������������������������������������������������蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺����������������������������������騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚�".split("");
for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
D[247] = "����������������������������������������������������������������糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊����������������������������������驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾�".split("");
for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
D[248] = "����������������������������������������������������������������讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏����������������������������������齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚�".split("");
for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
D[249] = "����������������������������������������������������������������纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊����������������������������������龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓�".split("");
for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
return {"enc": e, "dec": d }; })();
cptable[1250] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1251] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1252] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1253] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1254] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1255] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹ�ֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1256] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1257] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1258] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10000] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10006] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10007] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10008] = (function(){ var d = [], e = {}, D = [], j;
D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。・ˉˇ¨〃々―～�…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
D[162] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������������������������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω���������������������������������������".split("");
for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
D[168] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüê����������ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
D[169] = "��������������������������������������������������������������������������������������������������������������������������������������������������������������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
D[176] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
D[177] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
D[178] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
D[179] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
D[180] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
D[181] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
D[182] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
D[183] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
D[184] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
D[185] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
D[186] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
D[187] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
D[188] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
D[189] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
D[190] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
D[191] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
D[192] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
D[193] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
D[194] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
D[195] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
D[196] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
D[197] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
D[198] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
D[201] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
return {"enc": e, "dec": d }; })();
cptable[10029] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10079] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10081] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
// eslint-disable-next-line no-undef
if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = cptable;
/* cputils.js (C) 2013-present SheetJS -- http://sheetjs.com */
/* vim: set ft=javascript: */
/*jshint newcap: false */
(function(root, factory) {
  /*jshint ignore:start */
  /*eslint-disable */
  "use strict";
  if(typeof cptable === "undefined") {
    if(true){
      var cpt = cptable;
      if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = factory(cpt);
      else root.cptable = factory(cpt);
    } else throw new Error("cptable not found");
  } else cptable = factory(cptable);
  /*eslint-enable */
  /*jshint ignore:end */
}(this, function(cpt){
  "use strict";
  /*global module, Buffer */
  var magic = {
    "1200":"utf16le",
    "1201":"utf16be",
    "12000":"utf32le",
    "12001":"utf32be",
    "16969":"utf64le",
    "20127":"ascii",
    "65000":"utf7",
    "65001":"utf8"
  };

  var sbcs_cache = [874,1250,1251,1252,1253,1254,1255,1256,10000];
  var dbcs_cache = [932,936,949,950];
  var magic_cache = [65001];
  var magic_decode = {};
  var magic_encode = {};
  var cpdcache = {};
  var cpecache = {};

  var sfcc = function sfcc(x) { return String.fromCharCode(x); };
  var cca = function cca(x) { return x.charCodeAt(0); };

  var has_buf = (typeof Buffer !== 'undefined');
  var Buffer_from = function(){};
  if(has_buf) {
    var nbfs = !Buffer.from;
    if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
    Buffer_from = nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
    // $FlowIgnore
    if(!Buffer.allocUnsafe) Buffer.allocUnsafe = function(n) { return new Buffer(n); };

    var mdl = 1024, mdb = Buffer.allocUnsafe(mdl);
    var make_EE = function make_EE(E){
      var EE = Buffer.allocUnsafe(65536);
      for(var i = 0; i < 65536;++i) EE[i] = 0;
      var keys = Object.keys(E), len = keys.length;
      for(var ee = 0, e = keys[ee]; ee < len; ++ee) {
        if(!(e = keys[ee])) continue;
        EE[e.charCodeAt(0)] = E[e];
      }
      return EE;
    };
    var sbcs_encode = function make_sbcs_encode(cp) {
      var EE = make_EE(cpt[cp].enc);
      return function sbcs_e(data, ofmt) {
        var len = data.length;
        var out, i=0, j=0, D=0, w=0;
        if(typeof data === 'string') {
          out = Buffer.allocUnsafe(len);
          for(i = 0; i < len; ++i) out[i] = EE[data.charCodeAt(i)];
        } else if(Buffer.isBuffer(data)) {
          out = Buffer.allocUnsafe(2*len);
          j = 0;
          for(i = 0; i < len; ++i) {
            D = data[i];
            if(D < 128) out[j++] = EE[D];
            else if(D < 224) { out[j++] = EE[((D&31)<<6)+(data[i+1]&63)]; ++i; }
            else if(D < 240) { out[j++] = EE[((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63)]; i+=2; }
            else {
              w = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3;
              if(w < 65536) out[j++] = EE[w];
              else { w -= 65536; out[j++] = EE[0xD800 + ((w>>10)&1023)]; out[j++] = EE[0xDC00 + (w&1023)]; }
            }
          }
          out = out.slice(0,j);
        } else {
          out = Buffer.allocUnsafe(len);
          for(i = 0; i < len; ++i) out[i] = EE[data[i].charCodeAt(0)];
        }
        if(!ofmt || ofmt === 'buf') return out;
        if(ofmt !== 'arr') return out.toString('binary');
        return [].slice.call(out);
      };
    };
    var sbcs_decode = function make_sbcs_decode(cp) {
      var D = cpt[cp].dec;
      var DD = Buffer.allocUnsafe(131072), d=0, c="";
      for(d=0;d<D.length;++d) {
        if(!(c=D[d])) continue;
        var w = c.charCodeAt(0);
        DD[2*d] = w&255; DD[2*d+1] = w>>8;
      }
      return function sbcs_d(data) {
        var len = data.length, i=0, j=0;
        if(2 * len > mdl) { mdl = 2 * len; mdb = Buffer.allocUnsafe(mdl); }
        if(Buffer.isBuffer(data)) {
          for(i = 0; i < len; i++) {
            j = 2*data[i];
            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
          }
        } else if(typeof data === "string") {
          for(i = 0; i < len; i++) {
            j = 2*data.charCodeAt(i);
            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
          }
        } else {
          for(i = 0; i < len; i++) {
            j = 2*data[i];
            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
          }
        }
        return mdb.slice(0, 2 * len).toString('ucs2');
      };
    };
    var dbcs_encode = function make_dbcs_encode(cp) {
      var E = cpt[cp].enc;
      var EE = Buffer.allocUnsafe(131072);
      for(var i = 0; i < 131072; ++i) EE[i] = 0;
      var keys = Object.keys(E);
      for(var ee = 0, e = keys[ee]; ee < keys.length; ++ee) {
        if(!(e = keys[ee])) continue;
        var f = e.charCodeAt(0);
        EE[2*f] = E[e] & 255; EE[2*f+1] = E[e]>>8;
      }
      return function dbcs_e(data, ofmt) {
        var len = data.length, out = Buffer.allocUnsafe(2*len), i=0, j=0, jj=0, k=0, D=0;
        if(typeof data === 'string') {
          for(i = k = 0; i < len; ++i) {
            j = data.charCodeAt(i)*2;
            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
          }
          out = out.slice(0,k);
        } else if(Buffer.isBuffer(data)) {
          for(i = k = 0; i < len; ++i) {
            D = data[i];
            if(D < 128) j = D;
            else if(D < 224) { j = ((D&31)<<6)+(data[i+1]&63); ++i; }
            else if(D < 240) { j = ((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63); i+=2; }
            else { j = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3; }
            if(j<65536) { j*=2; out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j]; }
            else { jj = j-65536;
              j=2*(0xD800 + ((jj>>10)&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
              j=2*(0xDC00 + (jj&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
            }
          }
          out = out.slice(0,k);
        } else {
          for(i = k = 0; i < len; i++) {
            j = data[i].charCodeAt(0)*2;
            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
          }
        }
        if(!ofmt || ofmt === 'buf') return out;
        if(ofmt !== 'arr') return out.toString('binary');
        return [].slice.call(out);
      };
    };
    var dbcs_decode = function make_dbcs_decode(cp) {
      var D = cpt[cp].dec;
      var DD = Buffer.allocUnsafe(131072), d=0, c, w=0, j=0, i=0;
      for(i = 0; i < 65536; ++i) { DD[2*i] = 0xFF; DD[2*i+1] = 0xFD;}
      for(d = 0; d < D.length; ++d) {
        if(!(c=D[d])) continue;
        w = c.charCodeAt(0);
        j = 2*d;
        DD[j] = w&255; DD[j+1] = w>>8;
      }
      return function dbcs_d(data) {
        var len = data.length, out = Buffer.allocUnsafe(2*len), i=0, j=0, k=0;
        if(Buffer.isBuffer(data)) {
          for(i = 0; i < len; i++) {
            j = 2*data[i];
            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
            out[k++] = DD[j]; out[k++] = DD[j+1];
          }
        } else if(typeof data === "string") {
          for(i = 0; i < len; i++) {
            j = 2*data.charCodeAt(i);
            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data.charCodeAt(i)<<8)+data.charCodeAt(i+1)); ++i; }
            out[k++] = DD[j]; out[k++] = DD[j+1];
          }
        } else {
          for(i = 0; i < len; i++) {
            j = 2*data[i];
            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
            out[k++] = DD[j]; out[k++] = DD[j+1];
          }
        }
        return out.slice(0,k).toString('ucs2');
      };
    };
    magic_decode[65001] = function utf8_d(data) {
      if(typeof data === "string") return utf8_d(data.split("").map(cca));
      var len = data.length, w = 0, ww = 0;
      if(4 * len > mdl) { mdl = 4 * len; mdb = Buffer.allocUnsafe(mdl); }
      var i = 0;
      if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
      for(var j = 1, k = 0, D = 0; i < len; i+=j) {
        j = 1; D = data[i];
        if(D < 128) w = D;
        else if(D < 224) { w=(D&31)*64+(data[i+1]&63); j=2; }
        else if(D < 240) { w=((D&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
        else { w=(D&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
        if(w < 65536) { mdb[k++] = w&255; mdb[k++] = w>>8; }
        else {
          w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
          mdb[k++] = ww&255; mdb[k++] = ww>>>8; mdb[k++] = w&255; mdb[k++] = (w>>>8)&255;
        }
      }
      return mdb.slice(0,k).toString('ucs2');
    };
    magic_encode[65001] = function utf8_e(data, ofmt) {
      if(has_buf && Buffer.isBuffer(data)) {
        if(!ofmt || ofmt === 'buf') return data;
        if(ofmt !== 'arr') return data.toString('binary');
        return [].slice.call(data);
      }
      var len = data.length, w = 0, ww = 0, j = 0;
      var direct = typeof data === "string";
      if(4 * len > mdl) { mdl = 4 * len; mdb = Buffer.allocUnsafe(mdl); }
      for(var i = 0; i < len; ++i) {
        w = direct ? data.charCodeAt(i) : data[i].charCodeAt(0);
        if(w <= 0x007F) mdb[j++] = w;
        else if(w <= 0x07FF) {
          mdb[j++] = 192 + (w >> 6);
          mdb[j++] = 128 + (w&63);
        } else if(w >= 0xD800 && w <= 0xDFFF) {
          w -= 0xD800; ++i;
          ww = (direct ? data.charCodeAt(i) : data[i].charCodeAt(0)) - 0xDC00 + (w << 10);
          mdb[j++] = 240 + ((ww>>>18) & 0x07);
          mdb[j++] = 144 + ((ww>>>12) & 0x3F);
          mdb[j++] = 128 + ((ww>>>6) & 0x3F);
          mdb[j++] = 128 + (ww & 0x3F);
        } else {
          mdb[j++] = 224 + (w >> 12);
          mdb[j++] = 128 + ((w >> 6)&63);
          mdb[j++] = 128 + (w&63);
        }
      }
      if(!ofmt || ofmt === 'buf') return mdb.slice(0,j);
      if(ofmt !== 'arr') return mdb.slice(0,j).toString('binary');
      return [].slice.call(mdb, 0, j);
    };
  }

  var encache = function encache() {
    if(has_buf) {
      if(cpdcache[sbcs_cache[0]]) return;
      var i=0, s=0;
      for(i = 0; i < sbcs_cache.length; ++i) {
        s = sbcs_cache[i];
        if(cpt[s]) {
          cpdcache[s] = sbcs_decode(s);
          cpecache[s] = sbcs_encode(s);
        }
      }
      for(i = 0; i < dbcs_cache.length; ++i) {
        s = dbcs_cache[i];
        if(cpt[s]) {
          cpdcache[s] = dbcs_decode(s);
          cpecache[s] = dbcs_encode(s);
        }
      }
      for(i = 0; i < magic_cache.length; ++i) {
        s = magic_cache[i];
        if(magic_decode[s]) cpdcache[s] = magic_decode[s];
        if(magic_encode[s]) cpecache[s] = magic_encode[s];
      }
    }
  };
  var null_enc = function(data, ofmt) { void ofmt; return ""; };
  var cp_decache = function cp_decache(cp) { delete cpdcache[cp]; delete cpecache[cp]; };
  var decache = function decache() {
    if(has_buf) {
      if(!cpdcache[sbcs_cache[0]]) return;
      sbcs_cache.forEach(cp_decache);
      dbcs_cache.forEach(cp_decache);
      magic_cache.forEach(cp_decache);
    }
    last_enc = null_enc; last_cp = 0;
  };
  var cache = {
    encache: encache,
    decache: decache,
    sbcs: sbcs_cache,
    dbcs: dbcs_cache
  };

  encache();

  var BM = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var SetD = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'(),-./:?";
  var last_enc = null_enc, last_cp = 0;
  var encode = function encode(cp, data, ofmt) {
    if(cp === last_cp && last_enc) { return last_enc(data, ofmt); }
    if(cpecache[cp]) { last_enc = cpecache[last_cp=cp]; return last_enc(data, ofmt); }
    if(has_buf && Buffer.isBuffer(data)) data = data.toString('utf8');
    var len = data.length;
    var out = has_buf ? Buffer.allocUnsafe(4*len) : [], w=0, i=0, j = 0, ww=0;
    var C = cpt[cp], E, M = "";
    var isstr = typeof data === 'string';
    if(C && (E=C.enc)) for(i = 0; i < len; ++i, ++j) {
      w = E[isstr? data.charAt(i) : data[i]];
      if(w > 255) {
        out[j] = w>>8;
        out[++j] = w&255;
      } else out[j] = w&255;
    }
    else if((M=magic[cp])) switch(M) {
      case "utf8":
        if(has_buf && isstr) { out = Buffer_from(data, M); j = out.length; break; }
        for(i = 0; i < len; ++i, ++j) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          if(w <= 0x007F) out[j] = w;
          else if(w <= 0x07FF) {
            out[j]   = 192 + (w >> 6);
            out[++j] = 128 + (w&63);
          } else if(w >= 0xD800 && w <= 0xDFFF) {
            w -= 0xD800;
            ww = (isstr ? data.charCodeAt(++i) : data[++i].charCodeAt(0)) - 0xDC00 + (w << 10);
            out[j]   = 240 + ((ww>>>18) & 0x07);
            out[++j] = 144 + ((ww>>>12) & 0x3F);
            out[++j] = 128 + ((ww>>>6) & 0x3F);
            out[++j] = 128 + (ww & 0x3F);
          } else {
            out[j]   = 224 + (w >> 12);
            out[++j] = 128 + ((w >> 6)&63);
            out[++j] = 128 + (w&63);
          }
        }
        break;
      case "ascii":
        if(has_buf && typeof data === "string") { out = Buffer_from(data, M); j = out.length; break; }
        for(i = 0; i < len; ++i, ++j) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          if(w <= 0x007F) out[j] = w;
          else throw new Error("bad ascii " + w);
        }
        break;
      case "utf16le":
        if(has_buf && typeof data === "string") { out = Buffer_from(data, M); j = out.length; break; }
        for(i = 0; i < len; ++i) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          out[j++] = w&255;
          out[j++] = w>>8;
        }
        break;
      case "utf16be":
        for(i = 0; i < len; ++i) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          out[j++] = w>>8;
          out[j++] = w&255;
        }
        break;
      case "utf32le":
        for(i = 0; i < len; ++i) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
          out[j++] = w&255; w >>= 8;
          out[j++] = w&255; w >>= 8;
          out[j++] = w&255; w >>= 8;
          out[j++] = w&255;
        }
        break;
      case "utf32be":
        for(i = 0; i < len; ++i) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
          out[j+3] = w&255; w >>= 8;
          out[j+2] = w&255; w >>= 8;
          out[j+1] = w&255; w >>= 8;
          out[j] = w&255;
          j+=4;
        }
        break;
      case "utf7":
        for(i = 0; i < len; i++) {
          var c = isstr ? data.charAt(i) : data[i].charAt(0);
          if(c === "+") { out[j++] = 0x2b; out[j++] = 0x2d; continue; }
          if(SetD.indexOf(c) > -1) { out[j++] = c.charCodeAt(0); continue; }
          var tt = encode(1201, c);
          out[j++] = 0x2b;
          out[j++] = BM.charCodeAt(tt[0]>>2);
          out[j++] = BM.charCodeAt(((tt[0]&0x03)<<4) + ((tt[1]||0)>>4));
          out[j++] = BM.charCodeAt(((tt[1]&0x0F)<<2) + ((tt[2]||0)>>6));
          out[j++] = 0x2d;
        }
        break;
      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
    }
    else throw new Error("Unrecognized CP: " + cp);
    out = out.slice(0,j);
    if(!has_buf) return (ofmt == 'str') ? (out).map(sfcc).join("") : out;
    if(!ofmt || ofmt === 'buf') return out;
    if(ofmt !== 'arr') return out.toString('binary');
    return [].slice.call(out);
  };
  var decode = function decode(cp, data) {
    var F; if((F=cpdcache[cp])) return F(data);
    if(typeof data === "string") return decode(cp, data.split("").map(cca));
    var len = data.length, out = new Array(len), s="", w=0, i=0, j=1, k=0, ww=0;
    var C = cpt[cp], D, M="";
    if(C && (D=C.dec)) {
      for(i = 0; i < len; i+=j) {
        j = 2;
        s = D[(data[i]<<8)+ data[i+1]];
        if(!s) {
          j = 1;
          s = D[data[i]];
        }
        if(!s) throw new Error('Unrecognized code: ' + data[i] + ' ' + data[i+j-1] + ' ' + i + ' ' + j + ' ' + D[data[i]]);
        out[k++] = s;
      }
    }
    else if((M=magic[cp])) switch(M) {
      case "utf8":
        if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
        for(; i < len; i+=j) {
          j = 1;
          if(data[i] < 128) w = data[i];
          else if(data[i] < 224) { w=(data[i]&31)*64+(data[i+1]&63); j=2; }
          else if(data[i] < 240) { w=((data[i]&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
          else { w=(data[i]&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
          if(w < 65536) { out[k++] = String.fromCharCode(w); }
          else {
            w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
            out[k++] = String.fromCharCode(ww); out[k++] = String.fromCharCode(w);
          }
        }
        break;
      case "ascii":
        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
        for(i = 0; i < len; i++) out[i] = String.fromCharCode(data[i]);
        k = len; break;
      case "utf16le":
        if(len >= 2 && data[0] == 0xFF) if(data[1] == 0xFE) i = 2;
        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
        j = 2;
        for(; i+1 < len; i+=j) {
          out[k++] = String.fromCharCode((data[i+1]<<8) + data[i]);
        }
        break;
      case "utf16be":
        if(len >= 2 && data[0] == 0xFE) if(data[1] == 0xFF) i = 2;
        j = 2;
        for(; i+1 < len; i+=j) {
          out[k++] = String.fromCharCode((data[i]<<8) + data[i+1]);
        }
        break;
      case "utf32le":
        if(len >= 4 && data[0] == 0xFF) if(data[1] == 0xFE && data[2] === 0 && data[3] === 0) i = 4;
        j = 4;
        for(; i < len; i+=j) {
          w = (data[i+3]<<24) + (data[i+2]<<16) + (data[i+1]<<8) + (data[i]);
          if(w > 0xFFFF) {
            w -= 0x10000;
            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
          }
          else out[k++] = String.fromCharCode(w);
        }
        break;
      case "utf32be":
        if(len >= 4 && data[3] == 0xFF) if(data[2] == 0xFE && data[1] === 0 && data[0] === 0) i = 4;
        j = 4;
        for(; i < len; i+=j) {
          w = (data[i]<<24) + (data[i+1]<<16) + (data[i+2]<<8) + (data[i+3]);
          if(w > 0xFFFF) {
            w -= 0x10000;
            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
          }
          else out[k++] = String.fromCharCode(w);
        }
        break;
      case "utf7":
        if(len >= 4 && data[0] == 0x2B && data[1] == 0x2F && data[2] == 0x76) {
          if(len >= 5 && data[3] == 0x38 && data[4] == 0x2D) i = 5;
          else if(data[3] == 0x38 || data[3] == 0x39 || data[3] == 0x2B || data[3] == 0x2F) i = 4;
        }
        for(; i < len; i+=j) {
          if(data[i] !== 0x2b) { j=1; out[k++] = String.fromCharCode(data[i]); continue; }
          j=1;
          if(data[i+1] === 0x2d) { j = 2; out[k++] = "+"; continue; }
          // eslint-disable-next-line no-useless-escape
          while(String.fromCharCode(data[i+j]).match(/[A-Za-z0-9+\/]/)) j++;
          var dash = 0;
          if(data[i+j] === 0x2d) { ++j; dash=1; }
          var tt = [];
          var o64 = "";
          var c1=0, c2=0, c3=0;
          var e1=0, e2=0, e3=0, e4=0;
          for(var l = 1; l < j - dash;) {
            e1 = BM.indexOf(String.fromCharCode(data[i+l++]));
            e2 = BM.indexOf(String.fromCharCode(data[i+l++]));
            c1 = e1 << 2 | e2 >> 4;
            tt.push(c1);
            e3 = BM.indexOf(String.fromCharCode(data[i+l++]));
            if(e3 === -1) break;
            c2 = (e2 & 15) << 4 | e3 >> 2;
            tt.push(c2);
            e4 = BM.indexOf(String.fromCharCode(data[i+l++]));
            if(e4 === -1) break;
            c3 = (e3 & 3) << 6 | e4;
            if(e4 < 64) tt.push(c3);
          }
          o64 = decode(1201, tt);
          for(l = 0; l < o64.length; ++l) out[k++] = o64.charAt(l);
        }
        break;
      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
    }
    else throw new Error("Unrecognized CP: " + cp);
    return out.slice(0,k).join("");
  };
  var hascp = function hascp(cp) { return !!(cpt[cp] || magic[cp]); };
  cpt.utils = { decode: decode, encode: encode, hascp: hascp, magic: magic, cache:cache };
  return cpt;
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(155).Buffer))

/***/ }),
/* 521 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_csvexport__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'trx-report',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default.a },
  data: function data() {
    return {
      from: null,
      to: null,
      error: {
        show: false,
        message: '',
        empty: []
      },
      selectedReports: {
        trxSummary: false,
        trxDetailed: false,
        trxByCreditCard: false
      },
      reportStatus: {
        trxSummary: '',
        trxDetailed: '',
        trxByCreditCard: ''
      },
      pdf: {
        code: '',
        class: '',
        title: '',
        date: '',
        table: {
          label: [],
          data: {},
          extra: {},
          total: {}
        },
        maxRecordPerPage: 40,
        list: [],
        current: '',
        loading: false
      },
      orientation: [],
      nonCompletedChecked: true,
      purchasedChecked: true,
      canceledChecked: true,
      pdfChecked: true,
      csvChecked: false,
      formatError: false,
      csv: {
        label: [],
        data: [],
        list: [],
        total: {}
      },
      isIOS: navigator.userAgent.match(/(iPad|iPhone|iPod)/g)
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.reports.rsvpReport.show;
    },
    highlightedDates: function highlightedDates() {
      var self = this;
      var result = { to: null, from: null };

      if (self.from !== null) {
        result.from = self.from;
      }
      if (self.to !== null) {
        result.to = self.to;
      }
      return result;
    },
    totalPage: function totalPage() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.pdf.table.data).length;
    },
    isTrxSummary: function isTrxSummary() {
      return this.pdf.code === 'trxSummary' && this.totalPage;
    },
    isTrxDetailed: function isTrxDetailed() {
      return this.pdf.code === 'trxDetailed' && this.totalPage;
    },
    isTrxByCreditCard: function isTrxByCreditCard() {
      return this.pdf.code === 'trxByCreditCard' && this.totalPage;
    }
  },
  methods: {
    isValid: function isValid() {
      var self = this;
      self.error.show = false;
      self.error.empty = [];
      if (self.from === null || self.to === null) {
        self.error.show = true;
        self.error.message = 'Please specify the Start and End dates.';
        return false;
      }

      var from = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.from);
      var to = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.to);

      if (from.isAfter(to)) {
        self.error.show = true;
        self.error.message = 'End date must be after Start date.';
        return false;
      }

      self.formatError = false;
      if (!self.pdfChecked && !self.csvChecked) {
        self.error.show = true;
        self.error.message = 'Please select which file format.';
        self.formatError = true;
        return false;
      }

      if (!self.selectedReports.trxSummary && !self.selectedReports.trxDetailed && !self.selectedReports.trxByCreditCard) {
        self.error.show = true;
        self.error.message = 'Please select at least one report type.';
        return false;
      }

      return true;
    },
    getNewDoc: function getNewDoc() {
      var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
      });
      doc.setFont('helvetica');
      return doc;
    },
    startProcess: function startProcess() {
      if (!this.isValid()) {
        return;
      }

      this.pdf.list = [];
      this.csv.list = [];
      for (var report in this.selectedReports) {
        if (this.selectedReports[report]) {
          this.reportStatus[report] = 'on-queue';
          this.pdf.list.push(report);
          this.csv.list.push(report);
        }
      }

      this.pdf.loading = true;
      this.generateReport();
    },
    generateReport: function generateReport() {
      var isCsv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if ((!this.pdf.list.length && this.pdfChecked || !this.pdfChecked) && (!this.csv.list.length && this.csvChecked || !this.csvChecked)) {
        this.pdf.loading = false;
        return;
      }

      if (isCsv) {
        console.log('Processing:', this.csv.list[0]);
        this.getDataReports(this.csv.list[0]);
      } else {
        console.log('Processing:', this.pdf.list[0]);
        this.getDataReports(this.pdf.list[0]);
      }
    },
    getDataReports: function getDataReports(type) {
      var self = this;
      self.reportStatus[type] = 'loading';
      var orientationMax = self.orientation;
      self.pdf.maxRecordPerPage = orientationMax.indexOf(type) > -1 ? 25 : 40;
      self.$sdk.get(self.apiParams(type).url, self.apiParams(type).data, function (r) {
        if (r.error) {
          self.reportStatus[type] = 'has-error';
          return;
        }

        self.setPdfLabel(type);
        self.pdf.table.data = {};
        self.pdf.table.extra = {};
        self.pdf.table.total = {};
        self.csv.data = [];
        self.csv.total = {};

        if (r.list.length > 0) {
          self.buildPdfData(type, r.list);
        } else {
          self.error.show = true;
          self.error.empty.push(self.reportLabel(type));
          self.reportStatus[type] = 'has-error';
          self.pdf.list.shift();
          self.csv.list.shift();
          self.generateReport();
        }
      });
    },
    apiParams: function apiParams(type) {
      /*
        -----   Refference   -----
        trxSummary          NEW
        trxDetailed          NEW
        trxByCreditCard		  report 14
      */

      var url = '';
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.to);
      var data = {
        token: this.$store.state.session.sessionToken,
        since: start.format('YYYY-MM-DD'),
        until: end.format('YYYY-MM-DD'),
        originals: this.nonCompletedChecked ? 1 : 0,
        tiptrx: this.purchasedChecked ? 1 : 0,
        cancelfeetrx: this.canceledChecked ? 1 : 0
      };

      switch (type) {
        case 'trxSummary':
          url = '/reports/trx/daily';
          break;
        case 'trxDetailed':
          url = '/reports/trx/list';
          break;
        case 'trxByCreditCard':
          url = '/reports/cards';
          break;
      }

      return { url: url, data: data };
    },
    setPdfLabel: function setPdfLabel(type) {
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.to);
      var dateRange = start.format('MM/DD/YYYY') + ' - ' + end.format('MM/DD/YYYY');

      this.pdf.code = type;
      if (type === 'trxSummary') {
        this.pdf.class = 'trx-summary';
        this.pdf.title = 'Opoli Transaction Summary';
        this.pdf.date = 'By Charged Date (' + dateRange + ')';
        this.pdf.table.label = ['Charged Date', 'TRX <br/>Count', 'Charged </br>TRX Count', 'Charged Amount', 'Refunded <br/>TRX Count', 'Refunded Amount', 'Net Total'];
      }

      if (type === 'trxDetailed') {
        this.pdf.class = 'trx-detailed';
        this.pdf.title = 'Opoli Transaction Detailed';
        this.pdf.date = 'By Charged Date (' + dateRange + ')';
        this.pdf.table.label = ['Charged Date', 'Customer', 'Card Owner', 'RSVP ID', 'Invoice ID', 'TRX Type', 'Charged <br/>Amount', 'Refunded <br/> Amount'];
      }

      if (type === 'trxByCreditCard') {
        this.pdf.class = 'trx-creditcard';
        this.pdf.title = 'Opoli Transaction By Credit Card Type';
        this.pdf.date = 'By Charged Date (' + dateRange + ')';
        this.pdf.table.label = ['', 'Total count', 'Charged', 'Refunded'];
      }
    },
    buildPdfData: function buildPdfData(type, pdfData) {
      var self = this;
      var groupCount = 0;
      var page = 1;

      // trxSummary / trxDetailed
      var totalRsvp = 0;
      var totalTrxCount = 0;
      // let totalPurchaseCount = 0
      // let totalAdditionalCount = 0
      var totalChargedTrxCount = 0;
      var totalCharged = 0;
      var totalRefundTrxCount = 0;
      var totalRefund = 0;
      var totalNet = 0;

      // trxByCreditCard
      // let totalCredits = 0
      var totalCanceled = 0;

      pdfData.forEach(function (data, index) {
        if (!self.pdf.table.data['page' + page]) {
          self.pdf.table.data['page' + page] = [];
        }

        self.pdf.table.data['page' + page].push(self.buildTableData(type, data));
        if (self.csvChecked) {
          self.csv.data.push(self.buildCsvData(type, data));
        }
        groupCount++;

        if (type === 'trxSummary') {
          totalRsvp += data.rsvp;
          totalTrxCount += data.trx;
          // totalPurchaseCount += data.purchase
          // totalAdditionalCount += data.extra
          totalChargedTrxCount += parseFloat(data.charged);
          totalCharged += parseFloat(data.chargedAmount);
          totalRefundTrxCount += parseFloat(data.refund);
          totalRefund += parseFloat(data.refundAmount);
          totalNet += parseFloat(data.chargedAmount) - parseFloat(data.refundAmount);
        }
        if (type === 'trxDetailed') {
          var charged = data.trxType !== 'Refund' ? parseFloat(data.chargedAmount) : 0;
          var refund = data.trxType === 'Refund' ? parseFloat(data.chargedAmount) : 0;
          totalCharged += charged;
          totalRefund += refund;
        }
        if (type === 'trxByCreditCard') {
          totalRsvp += data.trx;
          totalCharged += data.charged;
          // totalCredits += data.promo
          totalCanceled += data.return;
        }

        if ((index + 1) % self.pdf.maxRecordPerPage === 0 && pdfData.length !== index + 1) {
          page++;
        }
      });

      self.pdf.table.total.record = pdfData.length;
      if (type === 'trxSummary') {
        self.pdf.table.total.rsvp = self.covertNumber(totalRsvp);
        self.pdf.table.total.trx = self.covertNumber(totalTrxCount);
        self.pdf.table.total.chargedTrx = self.covertNumber(totalChargedTrxCount);
        // self.pdf.table.total.purchase = self.covertNumber(totalPurchaseCount)
        // self.pdf.table.total.additional = self.covertNumber(totalAdditionalCount)
        self.pdf.table.total.charged = self.covertNumber(totalCharged.toFixed(2));
        self.pdf.table.total.refundTrx = self.covertNumber(totalRefundTrxCount);
        self.pdf.table.total.refund = self.covertNumber(totalRefund.toFixed(2));
        self.pdf.table.total.net = self.covertNumber(totalNet.toFixed(2));
      }
      if (type === 'trxDetailed') {
        self.pdf.table.total.charged = self.covertNumber(totalCharged.toFixed(2));
        self.pdf.table.total.refund = self.covertNumber(totalRefund.toFixed(2));
      }
      if (type === 'trxByCreditCard') {
        self.pdf.table.total.rsvp = self.covertNumber(totalRsvp);
        self.pdf.table.total.charged = self.covertNumber(totalCharged.toFixed(2));
        // self.pdf.table.total.credits = self.covertNumber(totalCredits.toFixed(2))
        self.pdf.table.total.canceled = self.covertNumber(totalCanceled.toFixed(2));
      }

      if (self.pdfChecked) {
        self.processDownloads('pdf', { type: type, page: page });
      } else {
        self.processDownloads('csv', { type: type });
      }
      // self.processPdf(type, page)
    },
    buildTableData: function buildTableData(type, data) {
      var self = this;
      if (type === 'trxSummary') {
        var netTotal = parseFloat(data.chargedAmount) - parseFloat(data.refundAmount);
        return {
          date: __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.date, 'YYYY-MM-DD').format('MM/DD/YYYY'),
          trxCount: self.covertNumber(data.trx),
          chargedTrxCount: self.covertNumber(data.charged),
          chargedAmount: self.covertNumber(parseFloat(data.chargedAmount).toFixed(2)),
          refundTrxCount: self.covertNumber(data.refund),
          refundAmount: self.covertNumber(parseFloat(data.refundAmount).toFixed(2)),
          netTotal: self.covertNumber(parseFloat(netTotal).toFixed(2))
          // rsvpCount: self.covertNumber(data.rsvp),
          // purchaseCount: self.covertNumber(data.purchase),
          // additionalCount: self.covertNumber(data.extra),
          // totalCharges: self.covertNumber(parseFloat(data.amount).toFixed(2))
        };
      }

      if (type === 'trxDetailed') {
        // let trxType = data.type === 'cancelFee' ? 'cancel fee' : data.type
        var charged = data.trxType !== 'Refund' ? self.covertNumber(parseFloat(data.chargedAmount).toFixed(2)) : '-';
        var refund = data.trxType === 'Refund' ? self.covertNumber(parseFloat(data.chargedAmount).toFixed(2)) : '-';
        return {
          date: __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.created, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY  HH:mm'),
          customer: data.customer,
          cardOwner: data.cardOwner,
          rsvpId: data.rsvpId,
          invoiceId: data.invoiceID,
          transactionType: data.trxType,
          // transactionType: trxType,
          chargedAmount: charged,
          refundAmount: refund
        };
      }

      if (type === 'trxByCreditCard') {
        return {
          name: data.type,
          rsvp: self.covertNumber(data.trx),
          charged: '$' + self.covertNumber(data.charged.toFixed(2)),
          // credits: '$' + self.covertNumber(data.promo.toFixed(2)),
          canceled: '$' + self.covertNumber(data.return.toFixed(2))
        };
      }
    },
    fileName: function fileName(type, format) {
      var timestamp = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.from).format('YYYYMMDD') + '_' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.to).format('YYYYMMDD');
      switch (type) {
        case 'trxSummary':
          return 'trxsummary_' + timestamp + '.' + format;
        case 'trxDetailed':
          return 'trxdetailed_' + timestamp + '.' + format;
        case 'trxByCreditCard':
          return 'trxbycreditcard_' + timestamp + '.' + format;
      }
    },
    currentPage: function currentPage(page) {
      return page.substring(4);
    },
    processPdf: function processPdf(type, page) {
      var self = this;
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.to);
      var pageAsyncs = [];
      var landscapeReports = self.orientation;
      var orientation = landscapeReports.indexOf(type) > -1 ? 'l' : 'p';
      var pdf = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a({ orientation: orientation, unit: 'mm', format: 'a4' });

      window.scrollTo(500, 0);
      document.body.style.overflow = 'hidden';

      setTimeout(function () {
        if (self.isIOS) page = page + 1;

        var _loop = function _loop(i) {
          // self.pdf.current = 'page' + (i + 1)
          pageAsyncs.push(__WEBPACK_IMPORTED_MODULE_4_html2canvas___default()(document.getElementsByClassName('page' + (i + 1))[0], {
            scale: "1"
          }).then(function (canvas) {
            var imgData = canvas.toDataURL('image/png', 1.0);
            pdf.addImage(imgData, 'PNG', 0, 0);
            if (i + 1 !== page) {
              pdf.addPage();
            }
          }).catch(function (e) {
            self.reportStatus[type] = 'has-error';
            self.pdf.list.shift();
            document.body.style.overflow = 'auto';
            self.processDownloads('csv', { type: type });
            console.warn(e);
          }));
        };

        for (var i = 0; i < page; i++) {
          _loop(i);
        }

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(pageAsyncs).then(function () {
          var timestamp = start.format('YYYYMMDD') + '_' + end.format('YYYYMMDD');
          pdf.save(self.fileName(type, 'pdf'));
          self.reportStatus[type] = 'success';
          self.pdf.list.shift();
          document.body.style.overflow = 'auto';
          self.processDownloads('csv', { type: type });
        });
      }, 500);
    },
    covertNumber: function covertNumber(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    resetSelectedStatus: function resetSelectedStatus() {
      this.selectedReports = { trxSummary: false, trxDetailed: false, trxByCreditCard: false };
    },
    resetReportStatus: function resetReportStatus() {
      this.error.show = false;
      this.error.empty = [];
      this.reportStatus = { trxSummary: '', trxDetailed: '', trxByCreditCard: '' };
    },
    reportLabel: function reportLabel(type) {
      switch (type) {
        case 'trxSummary':
          return 'Transaction Summary';
        case 'trxDetailed':
          return 'Transaction Detailed';
        case 'trxByCreditCard':
          return 'Transaction by Credit Card Type';
      }
    },
    buildCsvData: function buildCsvData(type, data) {
      var column = [];
      this.pdf.table.label.forEach(function (i) {
        column.push(i.replace('<br/>', ''));
      });
      this.csv.label = column;

      var csvData = {};
      var pdfData = this.buildTableData(type, data);

      var i = 0;
      for (var key in pdfData) {
        csvData[column[i]] = pdfData[key];
        i++;
      }
      return csvData;
    },
    processDownloads: function processDownloads(action, data) {
      if (action === 'pdf' && this.pdfChecked) {
        this.processPdf(data.type, data.page);
      } else if (action === 'csv' && this.csvChecked) {
        this.processCsv(data.type);
      } else {
        this.generateReport();
      }
    },
    processCsv: function processCsv(type) {
      var exporter = __WEBPACK_IMPORTED_MODULE_6_csvexport___default.a.create({
        filename: this.fileName(type, 'csv'),
        columns: this.csv.label
      });

      // add total
      this.csv.data.push(this.buildCsvTotal(type));

      exporter.downloadCsv(this.csv.data);
      this.reportStatus[type] = 'success';
      this.csv.list.shift();

      this.generateReport(true);
    },
    buildCsvTotal: function buildCsvTotal(type) {
      var csvData = {};
      var totalData = this.pdf.table.total;

      if (type === 'trxSummary') {
        csvData[this.csv.label[0]] = 'Total';
        csvData[this.csv.label[1]] = totalData.trx;
        csvData[this.csv.label[2]] = totalData.chargedTrx;
        csvData[this.csv.label[3]] = totalData.charged;
        csvData[this.csv.label[4]] = totalData.refundTrx;
        csvData[this.csv.label[5]] = totalData.refund;
        csvData[this.csv.label[6]] = totalData.net;
      }

      if (type === 'trxDetailed') {
        csvData[this.csv.label[0]] = '';
        csvData[this.csv.label[1]] = '';
        csvData[this.csv.label[2]] = '';
        csvData[this.csv.label[3]] = '';
        csvData[this.csv.label[4]] = '';
        csvData[this.csv.label[5]] = totalData.record;
        csvData[this.csv.label[6]] = totalData.charged;
        csvData[this.csv.label[7]] = totalData.refund;
      }

      if (type === 'trxByCreditCard') {
        csvData[this.csv.label[0]] = 'Totals';
        csvData[this.csv.label[1]] = totalData.rsvp;
        csvData[this.csv.label[2]] = totalData.charged;
        csvData[this.csv.label[3]] = totalData.canceled;
      }

      return csvData;
      // this.pdf.table.total
    },
    formatCheck: function formatCheck() {
      this.error.show = false;
      this.formatError = false;
    }
  },
  watch: {
    show: function show(value) {
      if (!value) {
        return;
      }

      this.from = null;
      this.to = null;
      this.error.show = false;
      this.error.empty = [];

      this.resetSelectedStatus();
      this.resetReportStatus();
    },
    from: function from(value) {
      this.resetReportStatus();
    },
    to: function to(value) {
      this.resetReportStatus();
    },
    'selectedReports.trxSummary': function selectedReportsTrxSummary(value) {
      this.resetReportStatus();
    },
    'selectedReports.trxDetailed': function selectedReportsTrxDetailed(value) {
      this.resetReportStatus();
    },
    'selectedReports.trxByCreditCard': function selectedReportsTrxByCreditCard(value) {
      this.resetReportStatus();
    }
  }
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jspdf__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_html2canvas__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_csvexport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_api_featureToggle__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'specialize-report',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker___default.a },
  data: function data() {
    return {
      from: null,
      to: null,
      error: {
        show: false,
        message: '',
        empty: []
      },
      selectedReports: {
        payout: false,
        serviceTypeBrand: false,
        cancellationReport: false,
        driverPaymentBonus: false,
        insurance: false,
        insuranceMonthly: false,
        portalFee: false
      },
      reportStatus: {
        payout: '',
        serviceTypeBrand: '',
        cancellationReport: '',
        driverPaymentBonus: '',
        insurance: '',
        insuranceMonthly: '',
        portalFee: ''
      },
      pdf: {
        code: '',
        class: '',
        title: '',
        date: '',
        table: {
          label: [],
          data: {},
          extra: {},
          total: {}
        },
        maxRecordPerPage: 40,
        list: [],
        current: '',
        loading: false
      },
      orientation: ['payout', 'serviceTypeBrand', 'cancellationReport', 'driverPaymentBonus', 'insurance', 'insuranceMonthly'],
      pdfChecked: true,
      csvChecked: false,
      selectedServiceBrand: 'bookingTime',
      selectedCancellationType: 'all',
      formatError: false,
      csv: {
        label: [],
        data: [],
        list: [],
        total: {}
      },
      searchAdmin: '',
      searchAdminId: '',
      searchAdminDelay: '',
      showSearchAdminList: false,
      insuranceEmail: '',
      miles: '',
      insuranceModal: {
        show: false,
        message: ''
      },
      isIOS: navigator.userAgent.match(/(iPad|iPhone|iPod)/g),
      selectedBrand: ''
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.reports.rsvpReport.show;
    },
    highlightedDates: function highlightedDates() {
      var self = this;
      var result = { to: null, from: null };

      if (self.from !== null) {
        result.from = self.from;
      }
      if (self.to !== null) {
        result.to = self.to;
      }
      return result;
    },
    totalPage: function totalPage() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.pdf.table.data).length;
    },
    isPayout: function isPayout() {
      return this.pdf.code === 'payout' && this.totalPage;
    },
    isServiceTypeBrand: function isServiceTypeBrand() {
      return this.pdf.code === 'serviceTypeBrand' && this.totalPage;
    },
    admins: function admins() {
      var _this = this;

      return this.$store.state.reservationNotes.admins.filter(function (x) {
        return x.name.toLowerCase().includes(_this.searchAdmin.toLowerCase());
      });
    },
    isDriverPaymentBonus: function isDriverPaymentBonus() {
      return this.pdf.code === 'driverPaymentBonus' && this.totalPage;
    },
    isInsurance: function isInsurance() {
      return this.pdf.code === 'insurance' && this.totalPage;
    },
    isPortalFee: function isPortalFee() {
      return this.pdf.code === 'portalFee' && this.totalPage;
    },
    brands: function brands() {
      return this.$store.state.brands;
    }
  },
  methods: {
    isValid: function isValid() {
      var self = this;
      self.error.show = false;
      self.error.empty = [];
      if (self.from === null || self.to === null) {
        self.error.show = true;
        self.error.message = 'Please specify the Start and End dates.';
        return false;
      }

      var from = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(self.from);
      var to = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(self.to);

      if (from.isAfter(to)) {
        self.error.show = true;
        self.error.message = 'End date must be after Start date.';
        return false;
      }

      self.formatError = false;
      if (!self.pdfChecked && !self.csvChecked) {
        self.error.show = true;
        self.error.message = 'Please select which file format.';
        self.formatError = true;
        return false;
      }

      if (!self.selectedReports.payout && !self.selectedReports.serviceTypeBrand && !self.selectedReports.cancellationReport && !self.selectedReports.driverPaymentBonus && !self.selectedReports.insurance && !self.selectedReports.insuranceMonthly && !self.selectedReports.portalFee) {
        self.error.show = true;
        self.error.message = 'Please select at least one report type.';
        return false;
      }

      if (self.selectedReports.cancellationReport && self.pdfChecked) {
        self.error.show = true;
        self.error.message = 'Only CSV format is allowed for Cancellation Report.';
        return false;
      }

      if (self.selectedReports.cancellationReport && self.selectedCancellationType === '_admin' && !self.searchAdminId) {
        self.error.show = true;
        self.error.message = 'Please select an admin.';
        return false;
      }

      if (self.selectedReports.insurance && to.diff(from, 'days') > 1) {
        self.error.show = true;
        self.error.message = 'Max 1 day for Insurance Report (Daily)';
        return false;
      }

      if (self.selectedReports.insuranceMonthly && self.pdfChecked) {
        self.error.show = true;
        self.error.message = 'Only CSV format is allowed for Insurance Report (Monthly).';
        return false;
      }
      if (self.selectedReports.insuranceMonthly && !self.insuranceEmail) {
        self.error.show = true;
        self.error.message = 'Please enter an email.';
        return false;
      }

      return true;
    },
    getNewDoc: function getNewDoc() {
      var doc = new __WEBPACK_IMPORTED_MODULE_2_jspdf___default.a({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
      });
      doc.setFont('helvetica');
      return doc;
    },
    startProcess: function startProcess() {
      if (!this.isValid()) {
        return;
      }

      this.pdf.list = [];
      this.csv.list = [];
      for (var report in this.selectedReports) {
        if (this.selectedReports[report]) {
          this.reportStatus[report] = 'on-queue';
          this.pdf.list.push(report);
          this.csv.list.push(report);
        }
      }

      this.pdf.loading = true;
      this.generateReport();
    },
    generateReport: function generateReport() {
      var isCsv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if ((!this.pdf.list.length && this.pdfChecked || !this.pdfChecked) && (!this.csv.list.length && this.csvChecked || !this.csvChecked)) {
        this.pdf.loading = false;
        return;
      }

      if (isCsv) {
        console.log('Processing:', this.csv.list[0]);
        this.getDataReports(this.csv.list[0]);
      } else {
        console.log('Processing:', this.pdf.list[0]);
        this.getDataReports(this.pdf.list[0]);
      }
    },
    getDataReports: function getDataReports(type) {
      var self = this;
      self.reportStatus[type] = 'loading';
      var orientationMax = self.orientation;
      self.pdf.maxRecordPerPage = orientationMax.indexOf(type) > -1 ? 25 : 40;
      if (type === 'insurance') self.pdf.maxRecordPerPage = 14;
      self.$sdk.get(self.apiParams(type).url, self.apiParams(type).data, function (r) {
        // console.log('---', r)
        // return
        if (r.error) {
          self.reportStatus[type] = 'has-error';
          return;
        }

        if (type === 'insuranceMonthly') {
          self.insuranceModal = {
            show: true,
            message: '<b>Insurance Report (Monthly)</b> is being processed... Please check your email.'
          };
          self.pdf.list.shift();
          self.csv.list.shift();
          self.generateReport();
          return;
        }

        self.setPdfLabel(type);
        self.pdf.table.data = {};
        self.pdf.table.extra = {};
        self.pdf.table.total = {};
        self.csv.data = [];
        self.csv.total = {};

        if (r.list.length > 0) {
          self.buildPdfData(type, r.list);
        } else {
          self.error.show = true;
          self.error.empty.push(self.reportLabel(type));
          self.reportStatus[type] = 'has-error';
          self.pdf.list.shift();
          self.csv.list.shift();
          self.generateReport();
        }
      });
    },
    apiParams: function apiParams(type) {
      var url = '';
      var start = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.to);
      var data = {
        token: this.$store.state.session.sessionToken,
        since: start.format('YYYY-MM-DD'),
        until: end.format('YYYY-MM-DD')
      };

      switch (type) {
        case 'payout':
          url = '/reports/payout';
          break;
        case 'serviceTypeBrand':
          url = '/reports/services/branded';
          data.filter = this.selectedServiceBrand;
          break;
        case 'cancellationReport':
          url = '/reports/rsvp/canceled';
          data.cancelSource = this.selectedCancellationType;
          if (this.selectedCancellationType === '_admin') {
            data.cancelSource = 'admin';
            data.adminId = this.searchAdminId;
          }
          if (this.selectedCancellationType === 'goRes') {
            data.consumerId = 219990;
          }
          break;
        case 'driverPaymentBonus':
          url = '/reports/rsvp/bonus';
          break;
        case 'insurance':
          url = '/reports/insurance';
          data.since = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default.a.tz(start.format('MM/DD/YYYY 00:00'), 'MM/DD/YYYY HH:mm', 'America/Los_Angeles').unix();
          data.until = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default.a.tz(end.format('MM/DD/YYYY 00:00'), 'MM/DD/YYYY HH:mm', 'America/Los_Angeles').unix();
          break;
        case 'insuranceMonthly':
          url = '/reports/insurance/async';
          data.email = this.insuranceEmail;
          data.since = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default.a.tz(start.format('MM/DD/YYYY 00:00'), 'MM/DD/YYYY HH:mm', 'America/Los_Angeles').unix();
          data.until = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default.a.tz(end.format('MM/DD/YYYY 00:00'), 'MM/DD/YYYY HH:mm', 'America/Los_Angeles').unix();
          if (this.miles) {
            data.miles = this.miles;
          }
          break;
        case 'portalFee':
          url = '/reports/portalfee';
          data.brandId = this.selectedBrand;
          break;
      }
      return { url: url, data: data };
    },
    setPdfLabel: function setPdfLabel(type) {
      var start = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.to);
      var dateRange = start.format('MM/DD/YYYY') + ' - ' + end.format('MM/DD/YYYY');

      this.pdf.code = type;
      if (type === 'payout') {
        this.pdf.class = 'report-payout';
        this.pdf.title = 'Opoli Reports - Payout';
        this.pdf.date = 'Driver Payouts and Fees for ' + dateRange;
        var riderFeeLabel = this.$settings.get('TravelInsuranceLabel') || 'Rider Fee';
        riderFeeLabel = riderFeeLabel.replace(' ', ' <br/>');
        this.pdf.table.label = ['Company', 'Driver <br/>Count', 'RSVP <br/>Count',
        // 'Total <br/>PAX', 'Avg <br/>PAX', 
        'Fare', riderFeeLabel, 'Airport <br/>Fee', 'Total <br/>Fare', 'Avg <br/>Fare',
        // 'Average <br/>Fare PP', 'Charged',
        'Driver <br/>Payment', 'Payment %', 'Pickup <br/>Fee', 'Fuel <br/>Surcharge', 'Tips', 'Bonus', 'Cancel <br/>Fee', 'Total <br/>Payout', 'Payout %'];
      }

      if (type === 'serviceTypeBrand') {
        this.pdf.class = 'service-brand';
        this.pdf.title = 'Reservations By Service Type';
        // this.pdf.date = 'By Booking Date (' + dateRange + ')'
        this.pdf.table.label = ['Service Type', 'RSVP <br/>Count', 'ASAP', 'Web <br/>Bookings', 'Admin', 'Consumer <br/>App', 'Go Res', 'Total <br/>PAX', 'Avg <br/>PAX', 'Total Fare', 'Avg <br/>Fare', 'Avg <br/>Fare PP'];

        switch (this.selectedServiceBrand) {
          case 'bookingTime':
            this.pdf.date = 'By Booking Date (' + dateRange + ')';
            break;
          case 'completeTime':
            this.pdf.date = 'By Completion Date (' + dateRange + ')';
            break;
          case 'cancelTime':
            this.pdf.date = 'By Cancellation Date (' + dateRange + ')';
            break;
          case 'pickupTime':
            this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')';
            break;
        }
      }

      if (type === 'cancellationReport') {
        this.pdf.class = 'cancellation-rsvp';
        this.pdf.title = 'Cancelled Reservations';
        this.pdf.table.label = ['RSVP ID', 'Brand', 'Customer <br/>Name', 'Service', 'Fare', 'Cancelled <br/>Date', 'Cancelled <br/>By', 'Consumer Notes', 'Reason', 'Comments'];
      }

      if (type === 'driverPaymentBonus') {
        this.pdf.class = 'driver-payment-bonus';
        this.pdf.title = 'Variance Report for Driver Payment';
        this.pdf.table.label = ['RSVP ID', 'Brand', 'Service', 'Driver Name', 'Base <br/>Fare', 'Driver <br/>Payment', 'Variance <br/>Credit', 'Variance <br/>Credit %', 'Total Driver <br/>Payment', 'Updated <br/>By', 'Updated <br/>On'];
      }

      if (type === 'insurance') {
        this.pdf.class = 'insurance';
        this.pdf.title = 'Insurance Report (Reservations completed by drivers)';
        this.pdf.date = dateRange;
        this.pdf.table.label = ['RSVP ID', /*'Event ID',*/'Driver ID', 'Type', 'Start', 'End', 'Distance', 'Pickup', 'Dropoff', 'On Duty', 'OTW', 'On Board', /*'No Show',*/'Complete'];
      }

      if (type === 'portalFee') {
        this.pdf.class = 'portal-fee';
        this.pdf.title = 'Portal Fee Report';
        this.pdf.date = dateRange;
        this.pdf.table.label = ['Brand', 'RSVP <br/>ID', 'Total Fare', 'Portal Fee'];
      }
    },
    buildPdfData: function buildPdfData(type, pdfData) {
      var self = this;
      var groupCount = 0;
      var page = 1;

      // payout
      var totalDrivers = 0;
      var totalRsvp = 0;
      var totalPickupFee = 0;
      var totalTips = 0;
      var totalBonus = 0;
      var totalCancelFee = 0;
      var totalPax = 0;
      var totalAvgPax = 0;
      var totalFare = 0;
      var totalFareSum = 0;
      var totalAvgFare = 0;
      var totalTravelInsurance = 0;
      var totalAirportFee = 0;
      var totalGasFee = 0;
      var totalPayment = 0;
      var totalBidAmount = 0;
      var totalPaymentPercentage = 0;
      var totalAvgFarePP = 0;
      var totalDriverPayment = 0;
      var totalDriverPercentage = 0;
      var totalPortalFee = 0;

      // serviceTypeBrand
      var totalGo = 0;
      var serviceTypeBrand = {
        total: {},
        data: {}

        // driverPaymentBonus
      };var totalAvgBonus = 0;
      var totalDriverPaymentComputed = 0;

      // insurance
      var totalP1 = 0;
      var totalP2 = 0;
      var totalP3 = 0;
      var uniqueRSVP = [];

      pdfData.forEach(function (data, index) {
        if (!self.pdf.table.data['page' + page]) {
          self.pdf.table.data['page' + page] = [];
        }

        if (type !== 'serviceTypeBrand') {
          self.pdf.table.data['page' + page].push(self.buildTableData(type, data));
        }
        if (self.csvChecked) {
          self.csv.data.push(self.buildCsvData(type, data));
        }
        groupCount++;

        if (type === 'payout') {
          totalDrivers += data.drivers;
          totalRsvp += data.rsvp;
          // totalPax += data.paxSum
          // totalAvgPax += parseFloat(data.paxAvg)
          totalFare += data.bidAmount;
          totalTravelInsurance += parseFloat(data.travelInsurance || 0);
          totalAirportFee += parseFloat(data.airportFee || 0);
          totalFareSum += data.fareSum;
          totalAvgFare += parseFloat(data.fareAvg);
          totalDriverPayment += parseFloat(data.payment + data.bonus + data.gasFee + data.pickupFee + data.tips - data.cancelFee);
          totalPayment += data.payment;
          totalBidAmount += data.bidAmount;
          totalPickupFee += data.pickupFee;
          totalGasFee += data.gasFee;
          totalTips += data.tips;
          totalBonus += data.bonus;
          totalCancelFee += data.cancelFee;
          totalPaymentPercentage += parseFloat(data.paymentPercent || 0);
          totalDriverPercentage += parseFloat(data.percent);
        }

        if (type === 'serviceTypeBrand') {
          data.services.forEach(function (dat) {
            if (!serviceTypeBrand.data[data.name]) {
              serviceTypeBrand.data[data.name] = {};
            }
            var brandCode = '';
            // if (dat.serviceId > 5) {
            //   console.log('data.name', data.name)
            //   brandCode = CONFIG.brands.filter(x => x.name.toLowerCase() === data.name.toLowerCase())[0]
            //   brandCode = '[' + brandCode.code.toUpperCase() + '] '
            // }
            var name = brandCode + dat.name;
            serviceTypeBrand.data[data.name][name] = {
              name: name,
              rsvp: self.covertNumber(parseFloat(dat.rsvp)),
              asap: self.covertNumber(parseFloat(dat.asap)),
              web: self.covertNumber(parseFloat(dat.web)),
              admin: self.covertNumber(parseFloat(dat.admin)),
              app: self.covertNumber(parseFloat(dat.app)),
              go: self.covertNumber(parseFloat(dat.go)),
              paxSum: self.covertNumber(parseFloat(dat.paxSum)),
              paxAvg: self.covertNumber(parseFloat(dat.paxAvg).toFixed(2)),
              fareSum: self.covertNumber(parseFloat(dat.fareSum).toFixed(2)),
              fareAvg: self.covertNumber(parseFloat(dat.fareAvg).toFixed(2)),
              farePP: self.covertNumber(parseFloat(dat.farePP).toFixed(2))
            };

            if (!serviceTypeBrand.total[data.name]) {
              serviceTypeBrand.total[data.name] = {
                rsvp: 0, asap: 0, web: 0, admin: 0, app: 0, go: 0,
                paxSum: 0, paxAvg: 0, fareSum: 0, fareAvg: 0, farePP: 0
              };
            }
            serviceTypeBrand.total[data.name].rsvp += dat.rsvp;
            serviceTypeBrand.total[data.name].asap += dat.asap;
            serviceTypeBrand.total[data.name].web += dat.web;
            serviceTypeBrand.total[data.name].admin += dat.admin;
            serviceTypeBrand.total[data.name].app += dat.app;
            serviceTypeBrand.total[data.name].go += dat.go;
            serviceTypeBrand.total[data.name].paxSum += dat.paxSum;
            serviceTypeBrand.total[data.name].paxAvg += parseFloat(dat.paxAvg);
            serviceTypeBrand.total[data.name].fareSum += parseFloat(dat.fareSum);
            serviceTypeBrand.total[data.name].fareAvg += parseFloat(dat.fareAvg);
            serviceTypeBrand.total[data.name].farePP += parseFloat(dat.farePP);
          });

          var compPaxAvg = serviceTypeBrand.total[data.name].paxSum / serviceTypeBrand.total[data.name].rsvp;
          var compFareAvg = serviceTypeBrand.total[data.name].fareSum / serviceTypeBrand.total[data.name].rsvp;
          var compFarePPAvg = serviceTypeBrand.total[data.name].fareSum / serviceTypeBrand.total[data.name].paxSum;

          serviceTypeBrand.total[data.name].paxAvg = self.covertNumber(compPaxAvg.toFixed(2));
          serviceTypeBrand.total[data.name].fareSum = self.covertNumber(parseFloat(serviceTypeBrand.total[data.name].fareSum).toFixed(2));
          serviceTypeBrand.total[data.name].fareAvg = self.covertNumber(compFareAvg.toFixed(2));
          serviceTypeBrand.total[data.name].farePP = self.covertNumber(compFarePPAvg.toFixed(2));
        }

        if (type === 'cancellationReport') {
          totalFare += parseFloat(data.fare);
        }

        if (type === 'driverPaymentBonus') {
          totalRsvp++;
          totalFare += parseFloat(data.baseFare);
          totalDriverPayment += parseFloat(data.driverPayment);
          totalBonus += parseFloat(data.bonusAmount);
          // totalAvgBonus += parseFloat(data.bonusAmount / data.baseFare)
          totalDriverPaymentComputed += parseFloat(data.driverPayment + data.bonusAmount);
        }

        if (type === 'insurance' && data.driverId !== 0) {
          if (data[2] == 'P1') totalP1 += data[6];
          if (data[2] == 'P2') totalP2 += data[6];
          if (data[2] == 'P3') totalP3 += data[6];

          if (uniqueRSVP.indexOf(data[5]) == -1) uniqueRSVP.push(data[5]);
        }

        if (type === 'portalFee') {
          totalRsvp++;
          if (data.overridePrice > 0) totalFare += parseFloat(data.overridePrice);else {
            var tmpTotal = parseFloat(data.baseFare) + parseFloat(data.airportFee) + parseFloat(data.gasFee) + parseFloat(data.pickupFee) + parseFloat(data.tipAmount) + parseFloat(data.travelInsurance);
            totalFare += parseFloat(tmpTotal.toFixed(2));
          }
          totalPortalFee += parseFloat(data.portalFee);
        }

        if ((index + 1) % self.pdf.maxRecordPerPage === 0 && pdfData.length !== index + 1) {
          page++;
        }
      });

      self.pdf.table.total.record = pdfData.length;
      if (type === 'payout') {
        self.pdf.table.total.drivers = self.covertNumber(totalDrivers);
        self.pdf.table.total.rsvp = self.covertNumber(totalRsvp);
        // self.pdf.table.total.charged = self.covertNumber(totalCharged.toFixed(2))
        self.pdf.table.total.pickupFee = self.covertNumber(totalPickupFee.toFixed(2));
        self.pdf.table.total.gasFee = self.covertNumber(totalGasFee.toFixed(2));
        self.pdf.table.total.tips = self.covertNumber(totalTips.toFixed(2));
        self.pdf.table.total.bonus = self.covertNumber(totalBonus.toFixed(2));
        self.pdf.table.total.cancelFee = self.covertNumber(totalCancelFee.toFixed(2));
        // self.pdf.table.total.pax = self.covertNumber(totalPax)
        // self.pdf.table.total.avgPax = self.covertNumber((totalPax / totalRsvp).toFixed(2))
        self.pdf.table.total.fare = self.covertNumber(totalFare.toFixed(2));
        self.pdf.table.total.travelInsurance = self.covertNumber(totalTravelInsurance.toFixed(2));
        self.pdf.table.total.airportFee = self.covertNumber(totalAirportFee.toFixed(2));
        self.pdf.table.total.fareSum = self.covertNumber(totalFareSum.toFixed(2));
        self.pdf.table.total.avgFare = self.covertNumber((totalFareSum / totalRsvp).toFixed(2));
        self.pdf.table.total.payment = self.covertNumber(totalPayment.toFixed(2));
        var paymentPercent = totalPayment / totalFareSum * 100;
        self.pdf.table.total.paymentPercent = self.covertNumber(paymentPercent.toFixed(2));
        // self.pdf.table.total.avgFarePP = self.covertNumber(totalAvgFarePP.toFixed(2))

        var averagePercentage = totalDriverPercentage / pdfData.length;
        self.pdf.table.total.extraFee = self.covertNumber(totalDriverPayment.toFixed(2));
        self.pdf.table.total.percent = self.covertNumber((totalDriverPayment / totalFareSum * 100).toFixed(2));
      }
      if (type === 'serviceTypeBrand') {
        self.pdf.table.total = serviceTypeBrand.total;

        // let counter = 0
        self.pdf.table.serviceTypeBrandData = {};
        for (var data in serviceTypeBrand.data) {
          if (!self.pdf.table.serviceTypeBrandData['page' + page]) {
            self.pdf.table.serviceTypeBrandData['page' + page] = {};
          }
          self.pdf.table.serviceTypeBrandData['page' + page][data] = serviceTypeBrand.data[data];
          // counter++

          // if (counter % 2 === 0) {
          //   counter = 0
          // }
          page++;
        }
        page = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(self.pdf.table.serviceTypeBrandData).length;
      }
      if (type === 'cancellationReport') {
        self.pdf.table.total.fare = self.covertNumber(totalFare.toFixed(2));
      }
      if (type === 'driverPaymentBonus') {
        self.pdf.table.total.baseFare = self.covertNumber(totalFare.toFixed(2));
        self.pdf.table.total.driverPayment = self.covertNumber(totalDriverPayment.toFixed(2));
        self.pdf.table.total.bonus = self.covertNumber(totalBonus.toFixed(2));
        totalAvgBonus = totalBonus / totalFare * 100;
        self.pdf.table.total.avgBonus = self.covertNumber(totalAvgBonus.toFixed(2));
        self.pdf.table.total.totalDriverPayment = self.covertNumber(totalDriverPaymentComputed.toFixed(2));
      }
      if (type === 'insurance') {
        self.pdf.table.total.p1 = self.covertNumber(totalP1.toFixed(2));
        self.pdf.table.total.p2 = self.covertNumber(totalP2.toFixed(2));
        self.pdf.table.total.p3 = self.covertNumber(totalP3.toFixed(2));
        self.pdf.table.total.overAll = self.covertNumber((totalP1 + totalP2 + totalP3).toFixed(2));
        self.pdf.table.total.rsvp = uniqueRSVP.length;
      }
      if (type === 'portalFee') {
        self.pdf.table.total.rsvp = self.covertNumber(totalRsvp);
        self.pdf.table.total.fare = self.covertNumber(totalFare.toFixed(2));
        self.pdf.table.total.portalFee = self.covertNumber(totalPortalFee.toFixed(2));
      }

      if (self.pdfChecked) {
        self.processDownloads('pdf', { type: type, page: page });
      } else {
        self.processDownloads('csv', { type: type });
      }
    },
    buildTableData: function buildTableData(type, data) {
      var self = this;
      if (type === 'payout') {
        var driverPayment = data.payment + data.bonus + data.pickupFee + data.tips - data.cancelFee;
        driverPayment += data.gasFee;
        return {
          company: data.name,
          driverCount: self.covertNumber(data.drivers),
          rsvpCount: self.covertNumber(data.rsvp),
          // totalPax: self.covertNumber(data.paxSum),
          // avgPax: self.covertNumber(parseFloat(data.paxAvg).toFixed(2)),
          fare: self.covertNumber(parseFloat(data.bidAmount).toFixed(2)),
          travelInsurance: self.covertNumber(parseFloat(data.travelInsurance || 0).toFixed(2)),
          airportFee: self.covertNumber(parseFloat(data.airportFee || 0).toFixed(2)),
          totalFare: self.covertNumber(parseFloat(data.fareSum).toFixed(2)),
          avgFare: self.covertNumber(parseFloat(data.fareAvg).toFixed(2)),
          // avgFarePP: self.covertNumber(parseFloat(data.farePP).toFixed(2)),
          // charged: self.covertNumber(parseFloat(data.charged).toFixed(2)),
          payment: self.covertNumber(parseFloat(data.payment).toFixed(2)),
          paymentPercent: self.covertNumber(parseFloat(data.paymentPercent || 0).toFixed(2)),
          pickupFee: self.covertNumber(parseFloat(data.pickupFee).toFixed(2)),
          gasFee: self.covertNumber(parseFloat(data.gasFee).toFixed(2)),
          tips: self.covertNumber(parseFloat(data.tips).toFixed(2)),
          bonus: self.covertNumber(parseFloat(data.bonus).toFixed(2)),
          cancelFee: self.covertNumber(parseFloat(data.cancelFee).toFixed(2)),
          driverPayment: self.covertNumber(parseFloat(driverPayment).toFixed(2)),
          driverPercent: self.covertNumber(parseFloat(data.percent || 0).toFixed(2))
        };
      }
      if (type === 'cancellationReport') {
        var index = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.findIndex(function (x) {
          return x.id === data.brandId;
        });
        var cancelBy = 'SYSTEM';
        var comments = data.comments;
        if (data.cancelAdminId) {
          cancelBy = self.admins.filter(function (x) {
            return x.id === data.cancelAdminId;
          })[0].name;
        } else if (data.cancelFrom) {
          if (data.cancelFrom === 'consumer') {
            cancelBy = 'SELF';
          } else if (data.cancelFrom === 'provider') {
            cancelBy = 'DRIVER';
          }
        }
        if (data.isAsap === 1 && (data.cancelAdminId || data.cancelFrom === 'provider')) {
          comments = 'asap release';
        }
        if (self.selectedCancellationType === 'consumer') {
          cancelBy = 'SELF';
        }

        if (comments) {
          comments = comments.replace(/<[^>]*>/g, '');
        }

        return {
          rsvpId: data.ID,
          brand: index === -1 ? 'ERROR' : {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[index].code.toUpperCase(),
          customerName: data.name,
          service: data.serviceTypeLabel,
          fare: self.covertNumber(parseFloat(data.fare).toFixed(2)),
          cancelledDate: __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(data.cancelTime, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_6__modules_api_featureToggle__["a" /* default */].timeFormat(self, false)),
          cancelledBy: cancelBy,
          consumerNotes: data.consNotes,
          reason: data.paxReason !== null ? data.paxReason : '',
          comments: comments
        };
      }
      if (type === 'driverPaymentBonus') {
        var _index = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.findIndex(function (x) {
          return x.id === data.brandId;
        });
        var updatedBy = 'SYSTEM';
        if (data.bonusAdmin) {
          updatedBy = self.admins.filter(function (x) {
            return x.id === data.bonusAdmin;
          })[0].name;
        }

        return {
          rsvpId: data.ID,
          brand: _index === -1 ? 'ERROR' : {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[_index].code.toUpperCase(),
          service: data.serviceTypeLabel,
          driverName: data.driverName,
          baseFare: self.covertNumber(parseFloat(data.baseFare).toFixed(2)),
          driverPayment: self.covertNumber(parseFloat(data.driverPayment).toFixed(2)),
          bonus: self.covertNumber(parseFloat(data.bonusAmount).toFixed(2)),
          avgBonus: self.covertNumber(parseFloat(data.bonusAmount / data.baseFare * 100).toFixed(2)),
          totalDriverPayment: self.covertNumber(parseFloat(data.bonusAmount + data.driverPayment).toFixed(2)),
          updatedBy: updatedBy,
          updatedOn: __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(data.bonusTime, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_6__modules_api_featureToggle__["a" /* default */].timeFormat(self, false))
        };
      }
      if (type === 'insurance') {
        return {
          rsvpId: data[5],
          // eventId: data[0],
          driverId: data[1],
          type: data[2],
          start: __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default.a.tz(data[3], 'YYYY-MM-DD@HH:mm', 'GMT').tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm'),
          end: __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default.a.tz(data[4], 'YYYY-MM-DD@HH:mm', 'GMT').tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm'),
          distance: data[6],
          pickup: data[7],
          dropoff: data[8],
          onDuty: data[9] ? __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default.a.tz(data[9], 'YYYY-MM-DD@HH:mm', 'GMT').tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm') : '',
          otw: data[10] ? __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default.a.tz(data[10], 'YYYY-MM-DD@HH:mm', 'GMT').tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm') : '',
          onBoard: data[11] ? __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default.a.tz(data[11], 'YYYY-MM-DD@HH:mm', 'GMT').tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm') : '',
          // noShow: data[12] ? moment(data[12], 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false)) : '',
          complete: data[13] ? __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default.a.tz(data[13], 'YYYY-MM-DD@HH:mm', 'GMT').tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm') : ''
          // offDuty: data[14] ? moment(data[14], 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false)) : ''
        };
      }
      if (type === 'portalFee') {
        var baseFare = parseFloat(data.baseFare) + parseFloat(data.airportFee) + parseFloat(data.gasFee) + parseFloat(data.pickupFee) + parseFloat(data.tipAmount) + parseFloat(data.travelInsurance);
        baseFare = parseFloat(baseFare.toFixed(2));
        if (data.overridePrice > 0) baseFare = data.overridePrice;
        return {
          brand: data.brand,
          rsvpID: data.ID,
          baseFare: baseFare,
          portalFee: data.portalFee
        };
      }
    },
    fileName: function fileName(type, format) {
      var timestamp = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.from).format('YYYYMMDD') + '_' + __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.to).format('YYYYMMDD');
      switch (type) {
        case 'payout':
          return 'reportspayout_' + timestamp + '.' + format;
        case 'serviceTypeBrand':
          return 'servicetypebrand_' + timestamp + '.' + format;
        case 'cancellationReport':
          return 'cancelledreport_' + timestamp + '.' + format;
        case 'driverPaymentBonus':
          return 'variance_driverpaymentbonus_' + timestamp + '.' + format;
        case 'insurance':
          return 'insurancereport_' + timestamp + '.' + format;
        case 'portalFee':
          return 'portalfee_' + timestamp + '.' + format;
      }
    },
    currentPage: function currentPage(page) {
      return page.substring(4);
    },
    processPdf: function processPdf(type, page) {
      var self = this;
      var start = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(self.from);
      var end = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(self.to);
      var pageAsyncs = [];
      var landscapeReports = self.orientation;
      var orientation = landscapeReports.indexOf(type) > -1 ? 'l' : 'p';
      var pdf = new __WEBPACK_IMPORTED_MODULE_2_jspdf___default.a({ orientation: orientation, unit: 'mm', format: 'a4' });

      window.scrollTo(500, 0);
      document.body.style.overflow = 'hidden';

      setTimeout(function () {
        // for (let i = 0; i < page; i++) {
        //   console.log('i -', i + 1)
        //   pageAsyncs.push(html2canvas(document.getElementsByClassName('page' + (i + 1))[0], {
        //     scale: "1"
        //   }).then(canvas => {
        //     let imgData = canvas.toDataURL('image/jpeg', 1.0)
        //     pdf.addImage(imgData, 'JPEG', 0, 0)
        //     if (i + 1 <= page) {
        //       console.log('add page', i + 1)
        //       pdf.addPage()
        //     }
        //   }).catch(e => {
        //     self.reportStatus[type] = 'has-error'
        //     self.pdf.list.shift()
        //     document.body.style.overflow = 'auto'
        //     self.processDownloads('csv', {type: type})
        //     console.warn(e)
        //   }))
        // }

        var i = 0;
        var buildPdfPages = function buildPdfPages(i) {
          if (i + 1 > page) {
            downloadPdfPages();
            return;
          }
          pageAsyncs.push(__WEBPACK_IMPORTED_MODULE_3_html2canvas___default()(document.getElementsByClassName('page' + (i + 1))[0], {
            scale: "1"
          }).then(function (canvas) {
            var imgData = canvas.toDataURL('image/jpeg', 1.0);
            pdf.addImage(imgData, 'JPEG', 0, 0);
            if (i + 1 <= page) {
              pdf.addPage();
              buildPdfPages(i + 1);
            }
          }).catch(function (e) {
            self.reportStatus[type] = 'has-error';
            self.pdf.list.shift();
            document.body.style.overflow = 'auto';
            self.processDownloads('csv', { type: type });
            console.warn(e);
          }));
        };
        buildPdfPages(0);

        var downloadPdfPages = function downloadPdfPages() {
          pdf.save(self.fileName(type, 'pdf'));
          self.reportStatus[type] = 'success';
          self.pdf.list.shift();
          document.body.style.overflow = 'auto';
          self.processDownloads('csv', { type: type });
        };

        // Promise.all(pageAsyncs).then(() => {
        //   let timestamp = start.format('YYYYMMDD') + '_' + end.format('YYYYMMDD')
        //   pdf.save(self.fileName(type, 'pdf'))
        //   self.reportStatus[type] = 'success'
        //   self.pdf.list.shift()
        //   document.body.style.overflow = 'auto'
        //   self.processDownloads('csv', {type: type})
        // })
      }, 500);
    },
    covertNumber: function covertNumber(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    resetSelectedStatus: function resetSelectedStatus() {
      this.selectedReports = {
        payout: false,
        serviceTypeBrand: false,
        cancellationReport: false,
        driverPaymentBonus: false,
        insurance: false,
        insuranceMonthly: false,
        portalFee: false
      };
    },
    resetReportStatus: function resetReportStatus() {
      this.error.show = false;
      this.error.empty = [];
      this.reportStatus = {
        payout: '',
        serviceTypeBrand: '',
        cancellationReport: '',
        driverPaymentBonus: '',
        portalFee: ''
      };
    },
    reportLabel: function reportLabel(type) {
      switch (type) {
        case 'payout':
          return 'Payout Report';
        case 'serviceTypeBrand':
          return 'Reservation by Service Type (Per Brand)';
        case 'cancellationReport':
          return 'Cancellation Report';
        case 'driverPaymentBonus':
          return 'Variance Report for Driver Payment';
        case 'insurance':
          return 'Insurance Report (Daily)';
        case 'insuranceMonthly':
          return 'Insurance Report (Monthly)';
        case 'portalFee':
          return 'Portal Fee';
      }
    },
    buildCsvData: function buildCsvData(type, data) {
      var column = [];
      this.pdf.table.label.forEach(function (i) {
        column.push(i.replace('<br/>', ''));
      });
      this.csv.label = column;

      var csvData = {};
      var pdfData = this.buildTableData(type, data);

      var i = 0;
      for (var key in pdfData) {
        csvData[column[i]] = pdfData[key];
        i++;
      }
      return csvData;
    },
    processDownloads: function processDownloads(action, data) {
      if (action === 'pdf' && this.pdfChecked) {
        this.processPdf(data.type, data.page);
      } else if (action === 'csv' && this.csvChecked) {
        this.processCsv(data.type);
      } else {
        this.generateReport();
      }
    },
    processCsv: function processCsv(type) {
      var exporter = __WEBPACK_IMPORTED_MODULE_5_csvexport___default.a.create({
        filename: this.fileName(type, 'csv'),
        columns: this.csv.label
      });

      // add total
      this.csv.data.push(this.buildCsvTotal(type));

      exporter.downloadCsv(this.csv.data);
      this.reportStatus[type] = 'success';
      this.csv.list.shift();

      this.generateReport(true);
    },
    buildCsvTotal: function buildCsvTotal(type) {
      var csvData = {};
      var totalData = this.pdf.table.total;

      if (type === 'payout') {
        csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')';
        csvData[this.csv.label[1]] = totalData.drivers;
        csvData[this.csv.label[2]] = totalData.rsvp;
        // csvData[this.csv.label[3]] = totalData.pax
        // csvData[this.csv.label[4]] = totalData.avgPax
        csvData[this.csv.label[3]] = totalData.fare;
        csvData[this.csv.label[4]] = totalData.travelInsurance;
        csvData[this.csv.label[5]] = totalData.airportFee;
        csvData[this.csv.label[6]] = totalData.fareSum;
        csvData[this.csv.label[7]] = totalData.avgFare;
        csvData[this.csv.label[8]] = totalData.payment;
        csvData[this.csv.label[9]] = totalData.paymentPercent;
        csvData[this.csv.label[10]] = totalData.pickupFee;
        csvData[this.csv.label[11]] = totalData.gasFee;
        csvData[this.csv.label[12]] = totalData.tips;
        csvData[this.csv.label[13]] = totalData.bonus;
        csvData[this.csv.label[14]] = totalData.cancelFee;
        csvData[this.csv.label[15]] = totalData.extraFee;
        csvData[this.csv.label[16]] = totalData.percent;
      }

      if (type === 'cancellationReport') {
        csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')';
        csvData[this.csv.label[1]] = '';
        csvData[this.csv.label[2]] = '';
        csvData[this.csv.label[3]] = '';
        csvData[this.csv.label[4]] = totalData.fare;
        csvData[this.csv.label[5]] = '';
        csvData[this.csv.label[6]] = '';
        csvData[this.csv.label[7]] = '';
        csvData[this.csv.label[8]] = '';
        csvData[this.csv.label[9]] = '';
      }

      if (type === 'driverPaymentBonus') {
        csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')';
        csvData[this.csv.label[1]] = '';
        csvData[this.csv.label[2]] = '';
        csvData[this.csv.label[3]] = '';
        csvData[this.csv.label[4]] = totalData.baseFare;
        csvData[this.csv.label[5]] = totalData.driverPayment;
        csvData[this.csv.label[6]] = totalData.bonus;
        csvData[this.csv.label[7]] = totalData.avgBonus;
        csvData[this.csv.label[8]] = totalData.totalDriverPayment;
        csvData[this.csv.label[9]] = '';
        csvData[this.csv.label[10]] = '';
      }

      if (type === 'insurance') {
        csvData[this.csv.label[0]] = 'Total';
        csvData[this.csv.label[1]] = 'RSVP: ' + totalData.rsvp;
        csvData[this.csv.label[2]] = 'P1: ' + totalData.p1;
        csvData[this.csv.label[3]] = 'P2: ' + totalData.p2;
        csvData[this.csv.label[4]] = 'P3: ' + totalData.p3;
        csvData[this.csv.label[5]] = 'Grand Total: ' + totalData.overAll;
      }

      return csvData;
    },
    formatCheck: function formatCheck() {
      this.error.show = false;
      this.formatError = false;
    },
    selectAdmin: function selectAdmin(admin) {
      this.searchAdmin = admin.name;
      this.searchAdminId = admin.id;
      this.showSearchAdminList = false;
    },
    adminSearchFocus: function adminSearchFocus() {
      this.showSearchAdminList = true;
      if (this.searchAdminDelay) {
        clearTimeout(this.searchAdminDelay);
      }
    },
    adminSearchBlur: function adminSearchBlur() {
      var _this2 = this;

      if (this.searchAdminDelay) {
        clearTimeout(this.searchAdminDelay);
      }
      this.searchAdminDelay = setTimeout(function () {
        _this2.showSearchAdminList = false;
      }, 500);
    },
    isNumber: function isNumber(evt) {
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
        return;
      }
      return true;
    }
  },
  watch: {
    show: function show(value) {
      if (!value) {
        return;
      }

      this.from = null;
      this.to = null;
      this.error.show = false;
      this.error.empty = [];

      this.resetSelectedStatus();
      this.resetReportStatus();
    },
    from: function from(value) {
      this.resetReportStatus();
    },
    to: function to(value) {
      this.resetReportStatus();
    },
    'selectedReports.payout': function selectedReportsPayout(value) {
      this.resetReportStatus();
    },
    'selectedReports.serviceTypeBrand': function selectedReportsServiceTypeBrand(value) {
      this.resetReportStatus();
    },
    'selectedReports.cancellationReport': function selectedReportsCancellationReport(value) {
      this.resetReportStatus();
    },
    'selectedReports.driverPaymentBonus': function selectedReportsDriverPaymentBonus(value) {
      this.resetReportStatus();
    },
    'selectedReports.insurance': function selectedReportsInsurance(value) {
      this.resetReportStatus();
    },
    'selectedReports.portalFee': function selectedReportsPortalFee(value) {
      this.resetReportStatus();
    }
  }
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_csvexport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_api_featureToggle__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'specialize-report',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default.a },
  data: function data() {
    return {
      env: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.Env,
      goResID: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.goResUserId,
      selectedUser: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.goResUserId,
      dbUsers: [
        // {id: 3597, name: 'Flip Flip'},
        // {id: 219990, name: 'GO Reservations'},
        // {id: 376128, name: 'Koi Ride'},
        // {id: 262132, name: 'Cares Act'},
        // {id: 262133, name: 'Great Plates'},
        // {id: 281780, name: 'Cares Act 2'},
        // {id: 300034, name: 'Micro Transit Jw Marriot Corporate'},
        // {id: 285033, name: 'Beverly Hilton'},
        // {id: 266672, name: 'District Attorney - Los Angeles'},
        // {id: 270861, name: 'District Attorney San Bernardino'},
        // {id: 270870, name: 'District Attorney Long Beach'},
        // {id: 270876, name: 'District Attorney Pasadena-Alhambra'},
        // {id: 270878, name: 'District Attorney Compton'},
        // {id: 270880, name: 'District Attorney Inglewood'},
        // {id: 270881, name: 'District Attorney Lancaster'},
        // {id: 270882, name: 'District Attorney LAX'},
        // {id: 270883, name: 'District Attorney LAX Branch'},
        // {id: 270884, name: 'District Attorney Martinez'},
        // {id: 270886, name: 'District Attorney Norwalk'},
        // {id: 270887, name: 'District Attorney Pas.Juvenile'},
        // {id: 270888, name: 'District Attorney Pomona'},
        // {id: 270890, name: 'District Attorney San Fernando'},
        // {id: 270892, name: 'District Attorney Torrance'},
        // {id: 270893, name: 'District Attorney Van Nuys'},
        // {id: 278711, name: 'District Attorney Witness Assistance'},
        // {id: 270894, name: 'District Attorney WLA'},
        // {id: 270895, name: 'District Attorney Malibu'},
        // {id: 275267, name: 'University of Southern California'}
      ],
      from: null,
      to: null,
      error: {
        show: false,
        message: '',
        empty: []
      },
      selectedReports: {
        directBill: true
        // payout: false,
        // serviceTypeBrand: false,
        // cancellationReport: false,
        // driverPaymentBonus: false
      },
      reportStatus: {
        directBill: ''
        // payout: '',
        // serviceTypeBrand: '',
        // cancellationReport: '',
        // driverPaymentBonus: ''
      },
      pdf: {
        code: '',
        class: '',
        title: '',
        date: '',
        table: {
          label: [],
          data: {},
          extra: {},
          total: {}
        },
        maxRecordPerPage: 40,
        list: [],
        current: '',
        loading: false
      },
      orientation: ['directBill', 'payout', 'serviceTypeBrand', 'cancellationReport', 'driverPaymentBonus'],
      pdfChecked: true,
      csvChecked: false,
      selectedServiceBrand: 'bookingTime',
      selectedCancellationType: 'all',
      formatError: false,
      csv: {
        label: [],
        data: [],
        list: [],
        total: {}
      },
      searchAdmin: '',
      searchAdminId: '',
      searchAdminDelay: '',
      showSearchAdminList: false,
      isIOS: navigator.userAgent.match(/(iPad|iPhone|iPod)/g),
      corpLoading: false
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.reports.rsvpReport.show;
    },
    highlightedDates: function highlightedDates() {
      var self = this;
      var result = { to: null, from: null };

      if (self.from !== null) {
        result.from = self.from;
      }
      if (self.to !== null) {
        result.to = self.to;
      }
      return result;
    },
    totalPage: function totalPage() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.pdf.table.data).length;
    },
    totalPageCompleted: function totalPageCompleted() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.pdf.table.data.completed).length;
    },
    totalPageNoShow: function totalPageNoShow() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.pdf.table.data.noshow).length;
    },
    isDirectBill: function isDirectBill() {
      return this.pdf.code === 'directBill' && this.totalPage;
    },
    isPayout: function isPayout() {
      return this.pdf.code === 'payout' && this.totalPage;
    },
    isServiceTypeBrand: function isServiceTypeBrand() {
      return this.pdf.code === 'serviceTypeBrand' && this.totalPage;
    },
    admins: function admins() {
      var _this = this;

      return this.$store.state.reservationNotes.admins.filter(function (x) {
        return x.name.toLowerCase().includes(_this.searchAdmin.toLowerCase());
      });
    },
    isDriverPaymentBonus: function isDriverPaymentBonus() {
      return this.pdf.code === 'driverPaymentBonus' && this.totalPage;
    }
  },
  methods: {
    isValid: function isValid() {
      var self = this;
      self.error.show = false;
      self.error.empty = [];
      if (self.from === null || self.to === null) {
        self.error.show = true;
        self.error.message = 'Please specify the Start and End dates.';
        return false;
      }

      var from = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.from);
      var to = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.to);

      if (from.isAfter(to)) {
        self.error.show = true;
        self.error.message = 'End date must be after Start date.';
        return false;
      }

      self.formatError = false;
      if (!self.pdfChecked && !self.csvChecked) {
        self.error.show = true;
        self.error.message = 'Please select which file format.';
        self.formatError = true;
        return false;
      }

      if (!self.selectedReports.directBill && !self.selectedReports.payout && !self.selectedReports.serviceTypeBrand && !self.selectedReports.cancellationReport && !self.selectedReports.driverPaymentBonus) {
        self.error.show = true;
        self.error.message = 'Please select at least one report type.';
        return false;
      }

      if (self.selectedReports.cancellationReport && self.pdfChecked) {
        self.error.show = true;
        self.error.message = 'Only CSV format is allowed for Cancellation Report.';
        return false;
      }

      if (self.selectedReports.cancellationReport && self.selectedCancellationType === '_admin' && !self.searchAdminId) {
        self.error.show = true;
        self.error.message = 'Please select an admin.';
        return false;
      }

      return true;
    },
    getNewDoc: function getNewDoc() {
      var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
      });
      doc.setFont('helvetica');
      return doc;
    },
    startProcess: function startProcess() {
      if (!this.isValid()) {
        return;
      }

      this.pdf.list = [];
      this.csv.list = [];
      for (var report in this.selectedReports) {
        if (this.selectedReports[report]) {
          this.reportStatus[report] = 'on-queue';
          this.pdf.list.push(report);
          this.csv.list.push(report);
        }
      }

      this.pdf.loading = true;
      this.generateReport();
    },
    generateReport: function generateReport() {
      var isCsv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if ((!this.pdf.list.length && this.pdfChecked || !this.pdfChecked) && (!this.csv.list.length && this.csvChecked || !this.csvChecked)) {
        this.pdf.loading = false;
        return;
      }

      if (isCsv) {
        console.log('Processing:', this.csv.list[0]);
        this.getDataReports(this.csv.list[0]);
      } else {
        console.log('Processing:', this.pdf.list[0]);
        this.getDataReports(this.pdf.list[0]);
      }
    },
    getDataReports: function getDataReports(type) {
      var self = this;
      self.reportStatus[type] = 'loading';
      var orientationMax = self.orientation;
      self.pdf.maxRecordPerPage = orientationMax.indexOf(type) > -1 ? 22 : 35;
      self.$sdk.get(self.apiParams(type).url, self.apiParams(type).data, function (r) {
        // console.log('---', r)
        // return
        if (r.error) {
          self.reportStatus[type] = 'has-error';
          return;
        }

        self.setPdfLabel(type);
        self.pdf.table.data = {};
        self.pdf.table.extra = {};
        self.pdf.table.total = {};
        self.csv.data = [];
        self.csv.total = {};

        if (r.list.length > 0) {
          self.buildPdfData(type, r.list);
        } else {
          self.error.show = true;
          self.error.empty.push(self.reportLabel(type));
          self.reportStatus[type] = 'has-error';
          self.pdf.list.shift();
          self.csv.list.shift();
          self.generateReport();
        }
      });
    },
    apiParams: function apiParams(type) {
      var url = '';
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.to);
      var data = {
        token: this.$store.state.session.sessionToken,
        since: start.format('YYYY-MM-DD'),
        until: end.format('YYYY-MM-DD')
      };

      switch (type) {
        case 'directBill':
          url = '/reports/directbill';
          data.consumerId = this.selectedUser;
          break;
        case 'payout':
          url = '/reports/payout';
          break;
        case 'serviceTypeBrand':
          url = '/reports/services/branded';
          data.filter = this.selectedServiceBrand;
          break;
        case 'cancellationReport':
          url = '/reports/rsvp/canceled';
          data.cancelSource = this.selectedCancellationType;
          if (this.selectedCancellationType === '_admin') {
            data.cancelSource = 'admin';
            data.adminId = this.searchAdminId;
          }
          break;
        case 'driverPaymentBonus':
          url = '/reports/rsvp/bonus';
          break;
      }
      return { url: url, data: data };
    },
    setPdfLabel: function setPdfLabel(type) {
      var _this2 = this;

      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.to);
      var dateRange = start.format('MM/DD/YYYY') + ' - ' + end.format('MM/DD/YYYY');

      this.pdf.code = type;
      if (type === 'directBill') {
        this.pdf.class = 'report-direct-bill';
        var user = this.dbUsers.find(function (x) {
          return x.id === _this2.selectedUser;
        });
        var uname = user ? user.name : '';
        if (this.selectedUser == 219990) uname = 'Go Reservations';
        this.pdf.title = uname + ' - Direct Bill';
        this.pdf.date = dateRange;
        this.pdf.table.label = ['ID', 'Status', 'Pickup Time', 'Completed Time', 'Fare', 'Source', 'Consumer Notes'];
        this.pdf.table.labelCsv = [];
        this.pdf.table.labelCsv = ['ID', 'Status', 'Pickup Time', 'Completed Time', 'Fare', 'Source', 'Guest Name', 'Guest Mobile', 'Consumer Notes'];
      }

      if (type === 'payout') {
        this.pdf.class = 'report-payout';
        this.pdf.title = 'Opoli Reports - Payout';
        this.pdf.date = 'Driver Payouts and Fees for ' + dateRange;
        var riderFeeLabel = this.$settings.get('TravelInsuranceLabel') || 'Rider Fee';
        riderFeeLabel = riderFeeLabel.replace(' ', ' <br/>');
        this.pdf.table.label = ['Company', 'Driver <br/>Count', 'RSVP <br/>Count', 'Total <br/>PAX', 'Avg <br/>PAX', 'Fare', riderFeeLabel, 'Airport <br/>Fee', 'Total <br/>Fare', 'Avg <br/>Fare',
        // 'Average <br/>Fare PP', 'Charged',
        'Driver <br/>Payment', 'Payment %', 'Pickup <br/>Fee', 'Tips', 'Bonus', 'Cancel <br/>Fee', 'Total <br/>Payout', 'Payout %'];
      }

      if (type === 'serviceTypeBrand') {
        this.pdf.class = 'service-brand';
        this.pdf.title = 'Reservations By Service Type';
        // this.pdf.date = 'By Booking Date (' + dateRange + ')'
        this.pdf.table.label = ['Service Type', 'RSVP <br/>Count', 'ASAP', 'Web <br/>Bookings', 'Admin', 'Consumer <br/>App', 'Go Res', 'Total <br/>PAX', 'Avg <br/>PAX', 'Total Fare', 'Avg <br/>Fare', 'Avg <br/>Fare PP'];

        switch (this.selectedServiceBrand) {
          case 'bookingTime':
            this.pdf.date = 'By Booking Date (' + dateRange + ')';
            break;
          case 'completeTime':
            this.pdf.date = 'By Completion Date (' + dateRange + ')';
            break;
          case 'cancelTime':
            this.pdf.date = 'By Cancellation Date (' + dateRange + ')';
            break;
          case 'pickupTime':
            this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')';
            break;
        }
      }

      if (type === 'cancellationReport') {
        this.pdf.class = 'cancellation-rsvp';
        this.pdf.title = 'Cancelled Reservations';
        this.pdf.table.label = ['RSVP ID', 'Brand', 'Customer <br/>Name', 'Service', 'Fare', 'Cancelled <br/>Date', 'Cancelled <br/>By', 'Reason', 'Comments'];
      }

      if (type === 'driverPaymentBonus') {
        this.pdf.class = 'driver-payment-bonus';
        this.pdf.title = 'Variance Report for Driver Payment';
        this.pdf.table.label = ['RSVP ID', 'Brand', 'Service', 'Driver Name', 'Base <br/>Fare', 'Driver <br/>Payment', 'Variance <br/>Credit', 'Variance <br/>Credit %', 'Total Driver <br/>Payment', 'Updated <br/>By', 'Updated <br/>On'];
      }
    },
    buildPdfData: function buildPdfData(type, pdfData) {
      var self = this;
      var groupCount = 0;
      var page = 1;

      // directBill
      var totalFareCompleted = 0;
      var totalFareNoShow = 0;
      var totalCompleted = 0;
      var totalNoShow = 0;
      var pageCompleted = 1;
      var pageNoShow = 1;

      // payout
      var totalDrivers = 0;
      var totalRsvp = 0;
      var totalPickupFee = 0;
      var totalTips = 0;
      var totalBonus = 0;
      var totalCancelFee = 0;
      var totalPax = 0;
      var totalAvgPax = 0;
      var totalFare = 0;
      var totalFareSum = 0;
      var totalAvgFare = 0;
      var totalTravelInsurance = 0;
      var totalAirportFee = 0;
      var totalPayment = 0;
      var totalBidAmount = 0;
      var totalPaymentPercentage = 0;
      var totalAvgFarePP = 0;
      var totalDriverPayment = 0;
      var totalDriverPercentage = 0;

      // serviceTypeBrand
      var totalGo = 0;
      var serviceTypeBrand = {
        total: {},
        data: {}

        // driverPaymentBonus
      };var totalAvgBonus = 0;
      var totalDriverPaymentComputed = 0;

      if (type === 'directBill') {
        pdfData.forEach(function (data, index) {
          if (!self.pdf.table.data.completed) {
            self.pdf.table.data.completed = {};
          }
          if (!self.pdf.table.data.noshow) {
            self.pdf.table.data.noshow = {};
          }
          if (!self.pdf.table.data.completed['page' + pageCompleted]) {
            self.pdf.table.data.completed['page' + pageCompleted] = [];
          }
          if (!self.pdf.table.data.noshow['page' + pageNoShow]) {
            self.pdf.table.data.noshow['page' + pageNoShow] = [];
          }

          if (['CHARGE', 'NOSHOW'].indexOf(data.reservationState) === -1) {
            return;
          }

          var status = data.reservationState === 'CHARGE' ? 'completed' : 'noshow';
          var tempPage = data.reservationState === 'CHARGE' ? pageCompleted : pageNoShow;
          self.pdf.table.data[status]['page' + tempPage].push(self.buildTableData(type, data));

          if (self.csvChecked) {
            self.csv.data.push(self.buildCsvDataDirectBill(data));
          }

          if (data.reservationState === 'CHARGE') {
            totalFareCompleted += data.fareAmount;
            totalCompleted++;
          } else {
            totalFareNoShow += data.fareAmount;
            totalNoShow++;
          }

          if ((index + 1) % self.pdf.maxRecordPerPage === 0 && pdfData.length !== index + 1) {
            if (data.reservationState === 'CHARGE') {
              pageCompleted++;
            } else {
              pageNoShow++;
            }
          }
        });
      } else {
        pdfData.forEach(function (data, index) {
          if (!self.pdf.table.data['page' + page]) {
            self.pdf.table.data['page' + page] = [];
          }

          if (type !== 'serviceTypeBrand') {
            self.pdf.table.data['page' + page].push(self.buildTableData(type, data));
          }
          if (self.csvChecked) {
            if (type === 'directBill') {
              self.csv.data.push(self.buildCsvDataDirectBill(data));
            } else {
              self.csv.data.push(self.buildCsvData(type, data));
            }
          }
          groupCount++;

          if (type === 'payout') {
            totalDrivers += data.drivers;
            totalRsvp += data.rsvp;
            totalPax += data.paxSum;
            totalAvgPax += parseFloat(data.paxAvg);
            totalFare += data.bidAmount;
            totalTravelInsurance += parseFloat(data.travelInsurance || 0);
            totalAirportFee += parseFloat(data.airportFee || 0);
            totalFareSum += data.fareSum;
            totalAvgFare += parseFloat(data.fareAvg);
            totalDriverPayment += parseFloat(data.payment + data.bonus + data.pickupFee + data.tips - data.cancelFee);
            totalPayment += data.payment;
            totalBidAmount += data.bidAmount;
            totalPickupFee += data.pickupFee;
            totalTips += data.tips;
            totalBonus += data.bonus;
            totalCancelFee += data.cancelFee;
            totalPaymentPercentage += parseFloat(data.paymentPercent || 0);
            totalDriverPercentage += parseFloat(data.percent);
          }

          if (type === 'serviceTypeBrand') {
            data.services.forEach(function (dat) {
              if (!serviceTypeBrand.data[data.name]) {
                serviceTypeBrand.data[data.name] = {};
              }
              var brandCode = '';
              var name = brandCode + dat.name;
              serviceTypeBrand.data[data.name][name] = {
                name: name,
                rsvp: self.covertNumber(parseFloat(dat.rsvp)),
                asap: self.covertNumber(parseFloat(dat.asap)),
                web: self.covertNumber(parseFloat(dat.web)),
                admin: self.covertNumber(parseFloat(dat.admin)),
                app: self.covertNumber(parseFloat(dat.app)),
                go: self.covertNumber(parseFloat(dat.go)),
                paxSum: self.covertNumber(parseFloat(dat.paxSum)),
                paxAvg: self.covertNumber(parseFloat(dat.paxAvg).toFixed(2)),
                fareSum: self.covertNumber(parseFloat(dat.fareSum).toFixed(2)),
                fareAvg: self.covertNumber(parseFloat(dat.fareAvg).toFixed(2)),
                farePP: self.covertNumber(parseFloat(dat.farePP).toFixed(2))
              };

              if (!serviceTypeBrand.total[data.name]) {
                serviceTypeBrand.total[data.name] = {
                  rsvp: 0, asap: 0, web: 0, admin: 0, app: 0, go: 0,
                  paxSum: 0, paxAvg: 0, fareSum: 0, fareAvg: 0, farePP: 0
                };
              }
              serviceTypeBrand.total[data.name].rsvp += dat.rsvp;
              serviceTypeBrand.total[data.name].asap += dat.asap;
              serviceTypeBrand.total[data.name].web += dat.web;
              serviceTypeBrand.total[data.name].admin += dat.admin;
              serviceTypeBrand.total[data.name].app += dat.app;
              serviceTypeBrand.total[data.name].go += dat.go;
              serviceTypeBrand.total[data.name].paxSum += dat.paxSum;
              serviceTypeBrand.total[data.name].paxAvg += parseFloat(dat.paxAvg);
              serviceTypeBrand.total[data.name].fareSum += parseFloat(dat.fareSum);
              serviceTypeBrand.total[data.name].fareAvg += parseFloat(dat.fareAvg);
              serviceTypeBrand.total[data.name].farePP += parseFloat(dat.farePP);
            });

            var compPaxAvg = serviceTypeBrand.total[data.name].paxSum / serviceTypeBrand.total[data.name].rsvp;
            var compFareAvg = serviceTypeBrand.total[data.name].fareSum / serviceTypeBrand.total[data.name].rsvp;
            var compFarePPAvg = serviceTypeBrand.total[data.name].fareSum / serviceTypeBrand.total[data.name].paxSum;

            serviceTypeBrand.total[data.name].paxAvg = self.covertNumber(compPaxAvg.toFixed(2));
            serviceTypeBrand.total[data.name].fareSum = self.covertNumber(parseFloat(serviceTypeBrand.total[data.name].fareSum).toFixed(2));
            serviceTypeBrand.total[data.name].fareAvg = self.covertNumber(compFareAvg.toFixed(2));
            serviceTypeBrand.total[data.name].farePP = self.covertNumber(compFarePPAvg.toFixed(2));
          }

          if (type === 'cancellationReport') {
            totalFare += parseFloat(data.fare);
          }

          if (type === 'driverPaymentBonus') {
            totalRsvp++;
            totalFare += parseFloat(data.baseFare);
            totalDriverPayment += parseFloat(data.driverPayment);
            totalBonus += parseFloat(data.bonusAmount);
            // totalAvgBonus += parseFloat(data.bonusAmount / data.baseFare)
            totalDriverPaymentComputed += parseFloat(data.driverPayment + data.bonusAmount);
          }

          if ((index + 1) % self.pdf.maxRecordPerPage === 0 && pdfData.length !== index + 1) {
            page++;
          }
        });
      }

      self.pdf.table.total.record = pdfData.length;
      if (type === 'directBill') {
        self.pdf.table.total.totalCompleted = totalCompleted;
        self.pdf.table.total.totalNoShow = totalNoShow;
        self.pdf.table.total.fareCompleted = self.covertNumber(totalFareCompleted.toFixed(2));
        self.pdf.table.total.fareNoShow = self.covertNumber(totalFareNoShow.toFixed(2));
      }
      if (type === 'payout') {
        self.pdf.table.total.drivers = self.covertNumber(totalDrivers);
        self.pdf.table.total.rsvp = self.covertNumber(totalRsvp);
        // self.pdf.table.total.charged = self.covertNumber(totalCharged.toFixed(2))
        self.pdf.table.total.pickupFee = self.covertNumber(totalPickupFee.toFixed(2));
        self.pdf.table.total.tips = self.covertNumber(totalTips.toFixed(2));
        self.pdf.table.total.bonus = self.covertNumber(totalBonus.toFixed(2));
        self.pdf.table.total.cancelFee = self.covertNumber(totalCancelFee.toFixed(2));
        self.pdf.table.total.pax = self.covertNumber(totalPax);
        self.pdf.table.total.avgPax = self.covertNumber((totalPax / totalRsvp).toFixed(2));
        self.pdf.table.total.fare = self.covertNumber(totalFare.toFixed(2));
        self.pdf.table.total.travelInsurance = self.covertNumber(totalTravelInsurance.toFixed(2));
        self.pdf.table.total.airportFee = self.covertNumber(totalAirportFee.toFixed(2));
        self.pdf.table.total.fareSum = self.covertNumber(totalFareSum.toFixed(2));
        self.pdf.table.total.avgFare = self.covertNumber((totalFareSum / totalRsvp).toFixed(2));
        self.pdf.table.total.payment = self.covertNumber(totalPayment.toFixed(2));
        var paymentPercent = totalPayment / totalFareSum * 100;
        self.pdf.table.total.paymentPercent = self.covertNumber(paymentPercent.toFixed(2));
        // self.pdf.table.total.avgFarePP = self.covertNumber(totalAvgFarePP.toFixed(2))

        var averagePercentage = totalDriverPercentage / pdfData.length;
        self.pdf.table.total.extraFee = self.covertNumber(totalDriverPayment.toFixed(2));
        self.pdf.table.total.percent = self.covertNumber((totalDriverPayment / totalFareSum * 100).toFixed(2));
      }
      if (type === 'serviceTypeBrand') {
        self.pdf.table.total = serviceTypeBrand.total;

        // let counter = 0
        self.pdf.table.serviceTypeBrandData = {};
        for (var data in serviceTypeBrand.data) {
          if (!self.pdf.table.serviceTypeBrandData['page' + page]) {
            self.pdf.table.serviceTypeBrandData['page' + page] = {};
          }
          self.pdf.table.serviceTypeBrandData['page' + page][data] = serviceTypeBrand.data[data];
          // counter++

          // if (counter % 2 === 0) {
          //   counter = 0
          // }
          page++;
        }
        page = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(self.pdf.table.serviceTypeBrandData).length;
      }
      if (type === 'cancellationReport') {
        self.pdf.table.total.fare = self.covertNumber(totalFare.toFixed(2));
      }
      if (type === 'driverPaymentBonus') {
        self.pdf.table.total.baseFare = self.covertNumber(totalFare.toFixed(2));
        self.pdf.table.total.driverPayment = self.covertNumber(totalDriverPayment.toFixed(2));
        self.pdf.table.total.bonus = self.covertNumber(totalBonus.toFixed(2));
        totalAvgBonus = totalBonus / totalFare * 100;
        self.pdf.table.total.avgBonus = self.covertNumber(totalAvgBonus.toFixed(2));
        self.pdf.table.total.totalDriverPayment = self.covertNumber(totalDriverPaymentComputed.toFixed(2));
      }

      if (self.pdfChecked) {
        if (type === 'directBill') {
          page = pageCompleted + pageNoShow;
        }
        self.processDownloads('pdf', { type: type, page: page });
      } else {
        self.processDownloads('csv', { type: type });
      }
    },
    buildTableData: function buildTableData(type, data) {
      var self = this;
      if (type === 'directBill') {
        return {
          id: data.ID,
          status: data.reservationState === 'NOSHOW' ? data.reservationState : 'COMPLETED',
          pickupTime: __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.pickupTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mm'),
          completedTime: __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.completedTime, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY HH:mm'),
          fare: self.covertNumber(parseFloat(data.fareAmount || 0).toFixed(2)),
          source: data.deviceType === 'ww' ? 'web' : data.deviceType,
          consumerNotes: data.consumerNotes || ''
        };
      }
      if (type === 'payout') {
        var driverPayment = data.payment + data.bonus + data.pickupFee + data.tips - data.cancelFee;
        return {
          company: data.name,
          driverCount: self.covertNumber(data.drivers),
          rsvpCount: self.covertNumber(data.rsvp),
          totalPax: self.covertNumber(data.paxSum),
          avgPax: self.covertNumber(parseFloat(data.paxAvg).toFixed(2)),
          fare: self.covertNumber(parseFloat(data.bidAmount).toFixed(2)),
          travelInsurance: self.covertNumber(parseFloat(data.travelInsurance || 0).toFixed(2)),
          airportFee: self.covertNumber(parseFloat(data.airportFee || 0).toFixed(2)),
          totalFare: self.covertNumber(parseFloat(data.fareSum).toFixed(2)),
          avgFare: self.covertNumber(parseFloat(data.fareAvg).toFixed(2)),
          // avgFarePP: self.covertNumber(parseFloat(data.farePP).toFixed(2)),
          // charged: self.covertNumber(parseFloat(data.charged).toFixed(2)),
          payment: self.covertNumber(parseFloat(data.payment).toFixed(2)),
          paymentPercent: self.covertNumber(parseFloat(data.paymentPercent || 0).toFixed(2)),
          pickupFee: self.covertNumber(parseFloat(data.pickupFee).toFixed(2)),
          tips: self.covertNumber(parseFloat(data.tips).toFixed(2)),
          bonus: self.covertNumber(parseFloat(data.bonus).toFixed(2)),
          cancelFee: self.covertNumber(parseFloat(data.cancelFee).toFixed(2)),
          driverPayment: self.covertNumber(parseFloat(driverPayment).toFixed(2)),
          driverPercent: self.covertNumber(parseFloat(data.percent).toFixed(2))
        };
      }
      if (type === 'cancellationReport') {
        var index = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.findIndex(function (x) {
          return x.id === data.brandId;
        });
        var cancelBy = 'SYSTEM';
        var comments = data.comments;
        if (data.cancelAdminId) {
          cancelBy = self.admins.filter(function (x) {
            return x.id === data.cancelAdminId;
          })[0].name;
        } else if (data.cancelFrom) {
          if (data.cancelFrom === 'consumer') {
            cancelBy = 'SELF';
          } else if (data.cancelFrom === 'provider') {
            cancelBy = 'DRIVER';
          }
        }
        if (data.isAsap === 1 && (data.cancelAdminId || data.cancelFrom === 'provider')) {
          comments = 'asap release';
        }
        if (self.selectedCancellationType === 'consumer') {
          cancelBy = 'SELF';
        }

        if (comments) {
          comments = comments.replace(/<[^>]*>/g, '');
        }

        return {
          rsvpId: data.ID,
          brand: index === -1 ? 'ERROR' : {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[index].code.toUpperCase(),
          customerName: data.name,
          service: data.serviceTypeLabel,
          fare: self.covertNumber(parseFloat(data.fare).toFixed(2)),
          cancelledDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.cancelTime, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_7__modules_api_featureToggle__["a" /* default */].timeFormat(self, false)),
          cancelledBy: cancelBy,
          reason: data.paxReason !== null ? data.paxReason : '',
          comments: comments
        };
      }
      if (type === 'driverPaymentBonus') {
        var _index = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.findIndex(function (x) {
          return x.id === data.brandId;
        });
        var updatedBy = 'SYSTEM';
        if (data.bonusAdmin) {
          updatedBy = self.admins.filter(function (x) {
            return x.id === data.bonusAdmin;
          })[0].name;
        }

        return {
          rsvpId: data.ID,
          brand: _index === -1 ? 'ERROR' : {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[_index].code.toUpperCase(),
          service: data.serviceTypeLabel,
          driverName: data.driverName,
          baseFare: self.covertNumber(parseFloat(data.baseFare).toFixed(2)),
          driverPayment: self.covertNumber(parseFloat(data.driverPayment).toFixed(2)),
          bonus: self.covertNumber(parseFloat(data.bonusAmount).toFixed(2)),
          avgBonus: self.covertNumber(parseFloat(data.bonusAmount / data.baseFare * 100).toFixed(2)),
          totalDriverPayment: self.covertNumber(parseFloat(data.bonusAmount + data.driverPayment).toFixed(2)),
          updatedBy: updatedBy,
          updatedOn: __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.bonusTime, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_7__modules_api_featureToggle__["a" /* default */].timeFormat(self, false))
        };
      }
    },
    fileName: function fileName(type, format) {
      var timestamp = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.from).format('YYYYMMDD') + '_' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.to).format('YYYYMMDD');
      switch (type) {
        case 'directBill':
          return 'reportsdirectbill_' + timestamp + '.' + format;
        case 'payout':
          return 'reportspayout_' + timestamp + '.' + format;
        case 'serviceTypeBrand':
          return 'servicetypebrand_' + timestamp + '.' + format;
        case 'cancellationReport':
          return 'cancelledreport_' + timestamp + '.' + format;
        case 'driverPaymentBonus':
          return 'variance_driverpaymentbonus_' + timestamp + '.' + format;
      }
    },
    currentPage: function currentPage(page) {
      return page.substring(4);
    },
    processPdf: function processPdf(type, page) {
      var self = this;
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.to);
      var pageAsyncs = [];
      var landscapeReports = self.orientation;
      var orientation = landscapeReports.indexOf(type) > -1 ? 'l' : 'p';
      var pdf = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a({ orientation: orientation, unit: 'mm', format: 'a4' });

      window.scrollTo(500, 0);
      document.body.style.overflow = 'hidden';

      setTimeout(function () {
        var _loop = function _loop(i) {
          // self.pdf.current = 'page' + (i + 1)
          pageAsyncs.push(__WEBPACK_IMPORTED_MODULE_4_html2canvas___default()(document.getElementsByClassName('page' + (i + 1))[0], {
            scale: "1"
          }).then(function (canvas) {
            var imgData = canvas.toDataURL('image/png', 1.0);
            pdf.addImage(imgData, 'PNG', 0, 0);
            if (i + 1 !== page) {
              pdf.addPage();
            }
          }).catch(function (e) {
            self.reportStatus[type] = 'has-error';
            self.pdf.list.shift();
            document.body.style.overflow = 'auto';
            self.processDownloads('csv', { type: type });
            console.warn(e);
          }));
        };

        for (var i = 0; i < page; i++) {
          _loop(i);
        }

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(pageAsyncs).then(function () {
          var timestamp = start.format('YYYYMMDD') + '_' + end.format('YYYYMMDD');
          pdf.save(self.fileName(type, 'pdf'));
          self.reportStatus[type] = 'success';
          self.pdf.list.shift();
          document.body.style.overflow = 'auto';
          self.processDownloads('csv', { type: type });
        });
      }, 500);
    },
    covertNumber: function covertNumber(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    resetSelectedStatus: function resetSelectedStatus() {
      this.selectedReports = {
        directBill: true,
        payout: false,
        serviceTypeBrand: false,
        cancellationReport: false,
        driverPaymentBonus: false
      };
    },
    resetReportStatus: function resetReportStatus() {
      this.error.show = false;
      this.error.empty = [];
      this.reportStatus = {
        directBill: '',
        payout: '',
        serviceTypeBrand: '',
        cancellationReport: '',
        driverPaymentBonus: ''
      };
    },
    reportLabel: function reportLabel(type) {
      switch (type) {
        case 'directBill':
          return 'Direct Bill Report';
        case 'payout':
          return 'Payout Report';
        case 'serviceTypeBrand':
          return 'Reservation by Service Type (Per Brand)';
        case 'cancellationReport':
          return 'Cancellation Report';
        case 'driverPaymentBonus':
          return 'Variance Report for Driver Payment';
      }
    },
    buildCsvData: function buildCsvData(type, data) {
      var column = [];
      this.pdf.table.label.forEach(function (i) {
        column.push(i.replace('<br/>', ''));
      });
      this.csv.label = column;

      var csvData = {};
      var pdfData = this.buildTableData(type, data);

      var i = 0;
      for (var key in pdfData) {
        csvData[column[i]] = pdfData[key];
        i++;
      }
      return csvData;
    },
    buildCsvDataDirectBill: function buildCsvDataDirectBill(data) {
      var column = [];
      this.pdf.table.labelCsv.forEach(function (i) {
        column.push(i.replace('<br/>', ''));
      });
      this.csv.label = column;
      var csvData = {};
      var pdfData = {
        id: data.ID,
        status: data.reservationState === 'NOSHOW' ? data.reservationState : 'COMPLETED',
        pickupTime: __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.pickupTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mm'),
        completedTime: __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.completedTime, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY HH:mm'),
        fare: this.covertNumber(parseFloat(data.fareAmount || 0).toFixed(2)),
        source: data.deviceType === 'ww' ? 'web' : data.deviceType,
        guestName: (data.guestFname || '') + ' ' + (data.guestLname || ''),
        guestPhone: data.guestPhone,
        consumerNotes: data.consumerNotes || ''
      };

      var i = 0;
      for (var key in pdfData) {
        csvData[column[i]] = pdfData[key];
        i++;
      }
      return csvData;
    },
    processDownloads: function processDownloads(action, data) {
      if (action === 'pdf' && this.pdfChecked) {
        this.processPdf(data.type, data.page);
      } else if (action === 'csv' && this.csvChecked) {
        this.processCsv(data.type);
      } else {
        this.generateReport();
      }
    },
    processCsv: function processCsv(type) {
      var exporter = __WEBPACK_IMPORTED_MODULE_6_csvexport___default.a.create({
        filename: this.fileName(type, 'csv'),
        columns: this.csv.label
      });

      // add total
      var completed = [];
      var noshow = [];
      this.csv.data.forEach(function (dat) {
        if (dat.Status === 'COMPLETED') {
          completed.push(dat);
        } else {
          noshow.push(dat);
        }
      });
      this.csv.data = [].concat(completed, noshow);

      exporter.downloadCsv(this.csv.data);
      this.reportStatus[type] = 'success';
      this.csv.list.shift();

      this.generateReport(true);
    },
    buildCsvTotal: function buildCsvTotal(type) {
      var csvData = {};
      var totalData = this.pdf.table.total;

      if (type === 'directBill') {
        // csvData[this.csv.label[0]] = 'Total (' + (totalData.totalCompleted + totalData.totalNoShow) + ')'
        csvData[this.csv.label[0]] = '';
        csvData[this.csv.label[1]] = '';
        csvData[this.csv.label[2]] = '';
        csvData[this.csv.label[3]] = '';
        // csvData[this.csv.label[4]] = '$' + (parseFloat(totalData.fareCompleted.replace(/,/g,'')) + parseFloat(totalData.fareNoShow)).toFixed(2)
        csvData[this.csv.label[4]] = '';
        csvData[this.csv.label[5]] = '';
        csvData[this.csv.label[6]] = '';
      }

      if (type === 'payout') {
        csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')';
        csvData[this.csv.label[1]] = totalData.drivers;
        csvData[this.csv.label[2]] = totalData.rsvp;
        csvData[this.csv.label[3]] = totalData.pax;
        csvData[this.csv.label[4]] = totalData.avgPax;
        csvData[this.csv.label[5]] = totalData.fare;
        csvData[this.csv.label[6]] = totalData.travelInsurance;
        csvData[this.csv.label[7]] = totalData.airportFee;
        csvData[this.csv.label[8]] = totalData.fareSum;
        csvData[this.csv.label[9]] = totalData.avgFare;
        csvData[this.csv.label[10]] = totalData.payment;
        csvData[this.csv.label[11]] = totalData.paymentPercent;
        csvData[this.csv.label[12]] = totalData.pickupFee;
        csvData[this.csv.label[13]] = totalData.tips;
        csvData[this.csv.label[14]] = totalData.bonus;
        csvData[this.csv.label[15]] = totalData.cancelFee;
        csvData[this.csv.label[16]] = totalData.extraFee;
        csvData[this.csv.label[17]] = totalData.percent;
      }

      if (type === 'cancellationReport') {
        csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')';
        csvData[this.csv.label[1]] = '';
        csvData[this.csv.label[2]] = '';
        csvData[this.csv.label[3]] = '';
        csvData[this.csv.label[4]] = totalData.fare;
        csvData[this.csv.label[5]] = '';
        csvData[this.csv.label[6]] = '';
        csvData[this.csv.label[7]] = '';
        csvData[this.csv.label[8]] = '';
      }

      if (type === 'driverPaymentBonus') {
        csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')';
        csvData[this.csv.label[1]] = '';
        csvData[this.csv.label[2]] = '';
        csvData[this.csv.label[3]] = '';
        csvData[this.csv.label[4]] = totalData.baseFare;
        csvData[this.csv.label[5]] = totalData.driverPayment;
        csvData[this.csv.label[6]] = totalData.bonus;
        csvData[this.csv.label[7]] = totalData.avgBonus;
        csvData[this.csv.label[8]] = totalData.totalDriverPayment;
        csvData[this.csv.label[9]] = '';
        csvData[this.csv.label[10]] = '';
      }

      return csvData;
    },
    formatCheck: function formatCheck() {
      this.error.show = false;
      this.formatError = false;
    },
    selectAdmin: function selectAdmin(admin) {
      this.searchAdmin = admin.name;
      this.searchAdminId = admin.id;
      this.showSearchAdminList = false;
    },
    adminSearchFocus: function adminSearchFocus() {
      this.showSearchAdminList = true;
      if (this.searchAdminDelay) {
        clearTimeout(this.searchAdminDelay);
      }
    },
    adminSearchBlur: function adminSearchBlur() {
      var _this3 = this;

      if (this.searchAdminDelay) {
        clearTimeout(this.searchAdminDelay);
      }
      this.searchAdminDelay = setTimeout(function () {
        _this3.showSearchAdminList = false;
      }, 500);
    },
    getCorporates: function getCorporates() {
      var self = this;
      self.corpLoading = true;
      self.$sdk.get('/admin/corporateprofile', {
        token: self.$store.state.session.sessionToken,
        pageNum: 1,
        pageSize: 999
      }, function (r) {
        self.corpLoading = false;
        r.list.forEach(function (corp) {
          if (corp.active == 1) {
            self.dbUsers.push({
              id: corp.custContactID,
              name: corp.name
            });
          }
        });

        if (self.dbUsers.length) {
          self.dbUsers.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
            if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
            return 0;
          });
        }
      });
    }
  },
  watch: {
    show: function show(value) {
      if (!value) {
        return;
      }

      this.from = null;
      this.to = null;
      this.error.show = false;
      this.error.empty = [];

      this.resetSelectedStatus();
      this.resetReportStatus();
    },
    from: function from(value) {
      this.resetReportStatus();
    },
    to: function to(value) {
      this.resetReportStatus();
    },
    'selectedReports.directBill': function selectedReportsDirectBill(value) {
      this.resetReportStatus();
    },
    'selectedReports.payout': function selectedReportsPayout(value) {
      this.resetReportStatus();
    },
    'selectedReports.serviceTypeBrand': function selectedReportsServiceTypeBrand(value) {
      this.resetReportStatus();
    },
    'selectedReports.cancellationReport': function selectedReportsCancellationReport(value) {
      this.resetReportStatus();
    },
    'selectedReports.driverPaymentBonus': function selectedReportsDriverPaymentBonus(value) {
      this.resetReportStatus();
    }
  },
  mounted: function mounted() {
    var self = this;
    setTimeout(function () {
      self.getCorporates();
    }, 1500);
  }
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_csvexport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_api_featureToggle__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'specialize-report',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default.a },
  data: function data() {
    return {
      from: null,
      to: null,
      error: {
        show: false,
        message: '',
        empty: []
      },
      selectedReports: {
        payout: true
      },
      reportStatus: {
        payout: ''
      },
      pdf: {
        code: '',
        class: '',
        title: '',
        date: '',
        table: {
          label: [],
          data: {},
          extra: {},
          total: {}
        },
        maxRecordPerPage: 40,
        list: [],
        current: '',
        loading: false
      },
      orientation: ['payout', 'cancellationReport', 'driverPaymentBonus', 'mileage'],
      pdfChecked: true,
      csvChecked: false,
      formatError: false,
      csv: {
        label: [],
        data: [],
        list: [],
        total: {}
      },
      searchAdmin: '',
      searchAdminId: '',
      searchAdminDelay: '',
      showSearchAdminList: false,
      weeks: [],
      selectedWeek: '',
      isIOS: navigator.userAgent.match(/(iPad|iPhone|iPod)/g)
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.reports.rsvpReport.show;
    },
    highlightedDates: function highlightedDates() {
      var self = this;
      var result = { to: null, from: null };
      if (self.from !== null) {
        result.from = self.from;
      }
      if (self.to !== null) {
        result.to = self.to;
      }
      return result;
    },
    totalPage: function totalPage() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.pdf.table.data).length;
    },
    isPayout: function isPayout() {
      return this.pdf.code === 'payout' && this.totalPage;
    },
    admins: function admins() {
      var _this = this;

      return this.$store.state.reservationNotes.admins.filter(function (x) {
        return x.name.toLowerCase().includes(_this.searchAdmin.toLowerCase());
      });
    }
  },
  methods: {
    isValid: function isValid() {
      var self = this;
      self.error.show = false;
      self.error.empty = [];
      // if (self.from === null || self.to === null) {
      //   self.error.show = true
      //   self.error.message = 'Please specify the Start and End dates.'
      //   return false
      // }
      var from = self.selectedWeek.start;
      var to = self.selectedWeek.end;
      if (from.isAfter(to)) {
        self.error.show = true;
        self.error.message = 'End date must be after Start date.';
        return false;
      }
      self.formatError = false;
      if (!self.pdfChecked && !self.csvChecked) {
        self.error.show = true;
        self.error.message = 'Please select which file format.';
        self.formatError = true;
        return false;
      }
      if (!self.selectedReports.payout) {
        self.error.show = true;
        self.error.message = 'Please select at least one report type.';
        return false;
      }
      return true;
    },
    getNewDoc: function getNewDoc() {
      var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
      });
      doc.setFont('helvetica');
      return doc;
    },
    startProcess: function startProcess() {
      if (!this.isValid()) {
        return;
      }
      this.pdf.list = [];
      this.csv.list = [];
      for (var report in this.selectedReports) {
        if (this.selectedReports[report]) {
          this.reportStatus[report] = 'on-queue';
          this.pdf.list.push(report);
          this.csv.list.push(report);
        }
      }
      this.pdf.loading = true;
      this.generateReport();
    },
    generateReport: function generateReport() {
      var isCsv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if ((!this.pdf.list.length && this.pdfChecked || !this.pdfChecked) && (!this.csv.list.length && this.csvChecked || !this.csvChecked)) {
        this.pdf.loading = false;
        return;
      }
      if (isCsv) {
        console.log('Processing:', this.csv.list[0]);
        this.getDataReports(this.csv.list[0]);
      } else {
        console.log('Processing:', this.pdf.list[0]);
        this.getDataReports(this.pdf.list[0]);
      }
    },
    getDataReports: function getDataReports(type) {
      var self = this;
      self.reportStatus[type] = 'loading';
      var orientationMax = self.orientation;
      self.pdf.maxRecordPerPage = orientationMax.indexOf(type) > -1 ? 25 : 40;
      self.$sdk.get(self.apiParams(type).url, self.apiParams(type).data, function (r) {
        // console.log('---', r)
        // return
        if (r.error) {
          self.reportStatus[type] = 'has-error';
          return;
        }
        self.setPdfLabel(type);
        self.pdf.table.data = {};
        self.pdf.table.extra = {};
        self.pdf.table.total = {};
        self.csv.data = [];
        self.csv.total = {};
        if (r.list.length > 0) {
          self.buildPdfData(type, r.list);
        } else {
          self.error.show = true;
          self.error.empty.push(self.reportLabel(type));
          self.reportStatus[type] = 'has-error';
          self.pdf.list.shift();
          self.csv.list.shift();
          self.generateReport();
        }
      });
    },
    apiParams: function apiParams(type) {
      var url = '';
      var start = this.selectedWeek.start;
      var end = this.selectedWeek.end;
      var data = {
        token: this.$store.state.session.sessionToken,
        since: start.format('YYYY-MM-DD'),
        until: end.format('YYYY-MM-DD')
      };
      switch (type) {
        case 'payout':
          url = '/reports/payout';
          break;
      }
      return { url: url, data: data };
    },
    setPdfLabel: function setPdfLabel(type) {
      var start = this.selectedWeek.start;
      var end = this.selectedWeek.end;
      var dateRange = start.format('MM/DD/YYYY') + ' - ' + end.format('MM/DD/YYYY');
      this.pdf.code = type;
      if (type === 'payout') {
        this.pdf.class = 'report-payout';
        this.pdf.title = 'Opoli Reports - Payout';
        this.pdf.date = 'Driver Payouts and Fees for ' + dateRange;
        // let riderFeeLabel = this.$settings.get('TravelInsuranceLabel') || 'Rider Fee'
        var riderFeeLabel = 'Service Fee';
        riderFeeLabel = riderFeeLabel.replace(' ', ' <br/>');
        this.pdf.table.label = ['Company', 'Provider <br/>ID', 'RSVP <br/>Count',
        //'Total <br/>PAX', 'Avg <br/>PAX', 
        'Fare', riderFeeLabel, 'Airport <br/>Fee', 'Total <br/>Fare', 'Avg <br/>Fare',
        // 'Average <br/>Fare PP', 'Charged',
        'Driver <br/>Payment', 'Payment %', 'Pickup <br/>Fee', 'Fuel <br/>Surcharge', 'Tips', 'Bonus', 'Cancel <br/>Fee', 'Total <br/>Payout', 'Payout %'];
      }
    },
    buildPdfData: function buildPdfData(type, pdfData) {
      var self = this;
      var groupCount = 0;
      var page = 1;
      // payout
      var totalDrivers = 0;
      var totalRsvp = 0;
      var totalPickupFee = 0;
      var totalTips = 0;
      var totalBonus = 0;
      var totalCancelFee = 0;
      var totalGasFee = 0;
      // let totalPax = 0
      // let totalAvgPax = 0
      var totalFare = 0;
      var totalFareSum = 0;
      var totalAvgFare = 0;
      var totalTravelInsurance = 0;
      var totalAirportFee = 0;
      var totalPayment = 0;
      var totalBidAmount = 0;
      var totalPaymentPercentage = 0;
      var totalAvgFarePP = 0;
      var totalDriverPaymentOld = 0;
      var totalDriverPayment = 0;
      var totalDriverPercentage = 0;
      pdfData.forEach(function (data, index) {
        if (!self.pdf.table.data['page' + page]) {
          self.pdf.table.data['page' + page] = [];
        }
        self.pdf.table.data['page' + page].push(self.buildTableData(type, data));
        if (self.csvChecked) {
          self.csv.data.push(self.buildCsvData(type, data));
        }
        groupCount++;
        if (type === 'payout') {
          totalDrivers += data.drivers;
          totalRsvp += data.rsvp;
          totalGasFee += data.gasFee;
          // totalPax += data.paxSum
          // totalAvgPax += parseFloat(data.paxAvg)
          totalFare += data.bidAmount;
          totalTravelInsurance += parseFloat(data.travelInsurance || 0);
          totalAirportFee += parseFloat(data.airportFee || 0);
          totalFareSum += data.fareSum;
          totalAvgFare += parseFloat(data.fareAvg);
          totalDriverPaymentOld += parseFloat(data.payment + data.bonus + data.pickupFee + data.tips - data.cancelFee);

          totalDriverPayment += data.payoutStatus ? parseFloat(data.finalPayout) : data.total;
          totalDriverPayment += data.gasFee;

          totalPayment += data.payment;
          totalBidAmount += data.bidAmount;
          totalPickupFee += data.pickupFee;
          totalTips += data.tips;
          totalBonus += data.bonus;
          totalCancelFee += data.cancelFee;
          totalPaymentPercentage += parseFloat(data.paymentPercent || 0);
          totalDriverPercentage += parseFloat(data.percent);
        }
        if ((index + 1) % self.pdf.maxRecordPerPage === 0 && pdfData.length !== index + 1) {
          page++;
        }
      });
      self.pdf.table.total.record = pdfData.length;
      if (type === 'payout') {
        self.pdf.table.total.drivers = self.covertNumber(totalDrivers);
        self.pdf.table.total.rsvp = self.covertNumber(totalRsvp);
        // self.pdf.table.total.charged = self.covertNumber(totalCharged.toFixed(2))
        self.pdf.table.total.pickupFee = self.covertNumber(totalPickupFee.toFixed(2));
        self.pdf.table.total.tips = self.covertNumber(totalTips.toFixed(2));
        self.pdf.table.total.bonus = self.covertNumber(totalBonus.toFixed(2));
        self.pdf.table.total.cancelFee = self.covertNumber(totalCancelFee.toFixed(2));
        self.pdf.table.total.gasFee = self.covertNumber(totalGasFee.toFixed(2));
        // self.pdf.table.total.pax = self.covertNumber(totalPax)
        // self.pdf.table.total.avgPax = self.covertNumber((totalPax / totalRsvp).toFixed(2))
        self.pdf.table.total.fare = self.covertNumber(totalFare.toFixed(2));
        self.pdf.table.total.travelInsurance = self.covertNumber(totalTravelInsurance.toFixed(2));
        self.pdf.table.total.airportFee = self.covertNumber(totalAirportFee.toFixed(2));
        self.pdf.table.total.fareSum = self.covertNumber(totalFareSum.toFixed(2));
        self.pdf.table.total.avgFare = self.covertNumber((totalFareSum / totalRsvp).toFixed(2));
        self.pdf.table.total.payment = self.covertNumber(totalPayment.toFixed(2));
        var paymentPercent = totalPayment / totalFareSum * 100;
        self.pdf.table.total.paymentPercent = self.covertNumber(paymentPercent.toFixed(2));
        // self.pdf.table.total.avgFarePP = self.covertNumber(totalAvgFarePP.toFixed(2))
        var averagePercentage = totalDriverPercentage / pdfData.length;
        self.pdf.table.total.extraFee = self.covertNumber(totalDriverPayment.toFixed(2));
        self.pdf.table.total.percent = self.covertNumber((totalDriverPaymentOld / totalFareSum * 100).toFixed(2));
      }
      if (self.pdfChecked) {
        self.processDownloads('pdf', { type: type, page: page });
      } else {
        self.processDownloads('csv', { type: type });
      }
    },
    buildTableData: function buildTableData(type, data) {
      var self = this;
      if (type === 'payout') {
        // let driverPayment = (data.payment + data.bonus + data.pickupFee + data.tips) - data.cancelFee
        var driverPayment = data.payoutStatus ? data.finalPayout : data.total;
        driverPayment += data.gasFee;
        return {
          company: data.name,
          driverCount: self.covertNumber(data.drivers),
          rsvpCount: self.covertNumber(data.rsvp),
          // totalPax: self.covertNumber(data.paxSum),
          // avgPax: self.covertNumber(parseFloat(data.paxAvg).toFixed(2)),
          fare: self.covertNumber(parseFloat(data.bidAmount).toFixed(2)),
          travelInsurance: self.covertNumber(parseFloat(data.travelInsurance || 0).toFixed(2)),
          airportFee: self.covertNumber(parseFloat(data.airportFee || 0).toFixed(2)),
          totalFare: self.covertNumber(parseFloat(data.fareSum).toFixed(2)),
          avgFare: self.covertNumber(parseFloat(data.fareAvg).toFixed(2)),
          // avgFarePP: self.covertNumber(parseFloat(data.farePP).toFixed(2)),
          // charged: self.covertNumber(parseFloat(data.charged).toFixed(2)),
          payment: self.covertNumber(parseFloat(data.payment).toFixed(2)),
          paymentPercent: self.covertNumber(parseFloat(data.paymentPercent || 0).toFixed(2)),
          pickupFee: self.covertNumber(parseFloat(data.pickupFee).toFixed(2)),
          gasFee: self.covertNumber(parseFloat(data.gasFee).toFixed(2)),
          tips: self.covertNumber(parseFloat(data.tips).toFixed(2)),
          bonus: self.covertNumber(parseFloat(data.bonus).toFixed(2)),
          cancelFee: self.covertNumber(parseFloat(data.cancelFee).toFixed(2)),
          driverPayment: self.covertNumber(parseFloat(driverPayment).toFixed(2)),
          driverPercent: self.covertNumber(parseFloat(data.paymentPercent || 0).toFixed(2))
        };
      }
    },
    fileName: function fileName(type, format) {
      var timestamp = this.selectedWeek.start.format('YYYYMMDD') + '_' + this.selectedWeek.end.format('YYYYMMDD');
      switch (type) {
        case 'payout':
          return 'reportspayout_' + timestamp + '.' + format;
      }
    },
    currentPage: function currentPage(page) {
      return page.substring(4);
    },
    processPdf: function processPdf(type, page) {
      var self = this;
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.to);
      var pageAsyncs = [];
      var landscapeReports = self.orientation;
      var orientation = landscapeReports.indexOf(type) > -1 ? 'l' : 'p';
      var pdf = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a({ orientation: orientation, unit: 'mm', format: 'a4' });

      window.scrollTo(500, 0);
      document.body.style.overflow = 'hidden';

      setTimeout(function () {
        if (self.isIOS) page = page + 1;

        var _loop = function _loop(i) {
          // self.pdf.current = 'page' + (i + 1)
          pageAsyncs.push(__WEBPACK_IMPORTED_MODULE_4_html2canvas___default()(document.getElementsByClassName('page' + (i + 1))[0], {
            scale: "1"
          }).then(function (canvas) {
            var imgData = canvas.toDataURL('image/jpeg', 1.0);
            pdf.addImage(imgData, 'JPEG', 0, 0);
            if (i + 1 !== page) {
              pdf.addPage();
            }
          }).catch(function (e) {
            self.reportStatus[type] = 'has-error';
            self.pdf.list.shift();
            document.body.style.overflow = 'auto';
            self.processDownloads('csv', { type: type });
            console.warn(e);
          }));
        };

        for (var i = 0; i < page; i++) {
          _loop(i);
        }
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(pageAsyncs).then(function () {
          var timestamp = start.format('YYYYMMDD') + '_' + end.format('YYYYMMDD');
          pdf.save(self.fileName(type, 'pdf'));
          self.reportStatus[type] = 'success';
          self.pdf.list.shift();
          document.body.style.overflow = 'auto';
          self.processDownloads('csv', { type: type });
        });
      }, 500);
    },
    covertNumber: function covertNumber(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    resetSelectedStatus: function resetSelectedStatus() {
      this.selectedReports = {
        payout: false
      };
    },
    resetReportStatus: function resetReportStatus() {
      this.error.show = false;
      this.error.empty = [];
      this.reportStatus = {
        payout: ''
      };
    },
    reportLabel: function reportLabel(type) {
      switch (type) {
        case 'payout':
          return 'Payout Report';
      }
    },
    buildCsvData: function buildCsvData(type, data) {
      var column = [];
      this.pdf.table.label.forEach(function (i) {
        column.push(i.replace('<br/>', ''));
      });
      this.csv.label = column;
      var csvData = {};
      var pdfData = this.buildTableData(type, data);
      var i = 0;
      for (var key in pdfData) {
        csvData[column[i]] = pdfData[key];
        i++;
      }
      return csvData;
    },
    processDownloads: function processDownloads(action, data) {
      if (action === 'pdf' && this.pdfChecked) {
        this.processPdf(data.type, data.page);
      } else if (action === 'csv' && this.csvChecked) {
        this.processCsv(data.type);
      } else {
        this.generateReport();
      }
    },
    processCsv: function processCsv(type) {
      var exporter = __WEBPACK_IMPORTED_MODULE_6_csvexport___default.a.create({
        filename: this.fileName(type, 'csv'),
        columns: this.csv.label
      });
      // add total
      this.csv.data.push(this.buildCsvTotal(type));
      exporter.downloadCsv(this.csv.data);
      this.reportStatus[type] = 'success';
      this.csv.list.shift();
      this.generateReport(true);
    },
    buildCsvTotal: function buildCsvTotal(type) {
      var csvData = {};
      var totalData = this.pdf.table.total;
      if (type === 'payout') {
        csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')';
        csvData[this.csv.label[1]] = totalData.drivers;
        csvData[this.csv.label[2]] = totalData.rsvp;
        // csvData[this.csv.label[3]] = totalData.pax
        // csvData[this.csv.label[4]] = totalData.avgPax
        csvData[this.csv.label[3]] = totalData.fare;
        csvData[this.csv.label[4]] = totalData.travelInsurance;
        csvData[this.csv.label[5]] = totalData.airportFee;
        csvData[this.csv.label[6]] = totalData.fareSum;
        csvData[this.csv.label[7]] = totalData.avgFare;
        csvData[this.csv.label[8]] = totalData.payment;
        csvData[this.csv.label[9]] = totalData.paymentPercent;
        csvData[this.csv.label[10]] = totalData.pickupFee;
        csvData[this.csv.label[11]] = totalData.gasFee;
        csvData[this.csv.label[12]] = totalData.tips;
        csvData[this.csv.label[13]] = totalData.bonus;
        csvData[this.csv.label[14]] = totalData.cancelFee;
        csvData[this.csv.label[15]] = totalData.extraFee;
        csvData[this.csv.label[16]] = totalData.percent;
      }
      if (type === 'cancellationReport') {
        csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')';
        csvData[this.csv.label[1]] = '';
        csvData[this.csv.label[2]] = '';
        csvData[this.csv.label[3]] = '';
        csvData[this.csv.label[4]] = totalData.fare;
        csvData[this.csv.label[5]] = '';
        csvData[this.csv.label[6]] = '';
        csvData[this.csv.label[7]] = '';
        csvData[this.csv.label[8]] = '';
      }
      if (type === 'driverPaymentBonus') {
        csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')';
        csvData[this.csv.label[1]] = '';
        csvData[this.csv.label[2]] = '';
        csvData[this.csv.label[3]] = '';
        csvData[this.csv.label[4]] = totalData.baseFare;
        csvData[this.csv.label[5]] = totalData.driverPayment;
        csvData[this.csv.label[6]] = totalData.bonus;
        csvData[this.csv.label[7]] = totalData.avgBonus;
        csvData[this.csv.label[8]] = totalData.totalDriverPayment;
        csvData[this.csv.label[9]] = '';
        csvData[this.csv.label[10]] = '';
      }
      if (type === 'mileage') {
        csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')';
        csvData[this.csv.label[1]] = '';
        csvData[this.csv.label[2]] = '';
        csvData[this.csv.label[3]] = '';
        csvData[this.csv.label[4]] = '';
        csvData[this.csv.label[5]] = totalData.rsvp;
        csvData[this.csv.label[6]] = totalData.mileage;
        csvData[this.csv.label[7]] = '';
      }
      return csvData;
    },
    formatCheck: function formatCheck() {
      this.error.show = false;
      this.formatError = false;
    },
    selectAdmin: function selectAdmin(admin) {
      this.searchAdmin = admin.name;
      this.searchAdminId = admin.id;
      this.showSearchAdminList = false;
    },
    adminSearchFocus: function adminSearchFocus() {
      this.showSearchAdminList = true;
      if (this.searchAdminDelay) {
        clearTimeout(this.searchAdminDelay);
      }
    },
    adminSearchBlur: function adminSearchBlur() {
      var _this2 = this;

      if (this.searchAdminDelay) {
        clearTimeout(this.searchAdminDelay);
      }
      this.searchAdminDelay = setTimeout(function () {
        _this2.showSearchAdminList = false;
      }, 500);
    }
  },
  watch: {
    show: function show(value) {
      if (!value) {
        return;
      }
      this.from = null;
      this.to = null;
      this.error.show = false;
      this.error.empty = [];
      this.resetSelectedStatus();
      this.resetReportStatus();
    },
    from: function from(value) {
      this.resetReportStatus();
    },
    to: function to(value) {
      this.resetReportStatus();
    },
    'selectedReports.payout': function selectedReportsPayout(value) {
      this.resetReportStatus();
    }
  },
  mounted: function mounted() {
    var self = this;
    var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf('isoweek');
    var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(start).endOf('isoweek');
    self.weeks = [];
    self.weeks.push({
      start: start,
      end: end
    });
    self.selectedWeek = self.weeks[0];
    var current = __WEBPACK_IMPORTED_MODULE_2_moment___default()(start).startOf('isoweek');
    for (var i = 0; i < 7; i++) {
      var startWeek = __WEBPACK_IMPORTED_MODULE_2_moment___default()(current).subtract(1, 'd').startOf('isoweek');
      var endWeek = __WEBPACK_IMPORTED_MODULE_2_moment___default()(startWeek).endOf('isoweek');
      current = __WEBPACK_IMPORTED_MODULE_2_moment___default()(startWeek);
      self.weeks.push({
        start: startWeek,
        end: endWeek
      });
    }
  }
});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_featureToggle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_xlsx__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx_populate_browser_xlsx_populate__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx_populate_browser_xlsx_populate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_xlsx_populate_browser_xlsx_populate__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'specialize-report',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a },
  data: function data() {
    return {
      from: null,
      error: {
        show: false,
        message: '',
        empty: []
      },
      selectedReports: {
        assigned: true
      },
      reportStatus: {
        assigned: ''
      },
      loading: false,
      queue: [],
      assignedData: {
        list: {
          1: [],
          2: [],
          3: [],
          4: [],
          5: [],
          6: [],
          7: []
        },
        loaded: 0
      },
      font: 'Calibri'
    };
  },

  computed: {},
  methods: {
    reportLabel: function reportLabel(type) {
      switch (type) {
        case 'assigned':
          return 'Assigned Report';
      }
    },
    generate: function generate() {
      if (!this.isValid()) {
        return;
      }

      for (var report in this.selectedReports) {
        if (this.selectedReports[report]) {
          this.reportStatus[report] = 'on-queue';
          this.queue.push(report);
        }
      }

      this.loading = true;
      this.process();
    },
    isValid: function isValid() {
      var self = this;
      self.error.show = false;
      self.error.empty = [];
      if (self.from === null || self.to === null) {
        self.error.show = true;
        self.error.message = 'Please specify the date.';
        return false;
      }

      var from = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(self.from);

      if (!self.selectedReports.assigned) {
        self.error.show = true;
        self.error.message = 'Please select at least one report type.';
        return false;
      }

      return true;
    },
    process: function process() {
      if (!this.queue.length) {
        this.loading = false;
        return;
      }
      this.reportStatus[this.queue[0]] = 'loading';

      if (this.queue[0] === 'assigned') {
        this.assignedData.loaded = 0;
        this.assignedData.list = {
          1: [],
          2: [],
          3: [],
          4: [],
          5: [],
          6: [],
          7: []
        };
        this.getAssignedData();
        return;
      }
    },
    getAssignedData: function getAssignedData() {
      var self = this;
      if (self.assignedData.loaded == 7) {
        self.buildAssignedData();
        return;
      }
      self.$sdk.get('/reports/assigned/' + (self.assignedData.loaded + 1), {
        token: this.$store.state.session.sessionToken,
        since: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(self.from).format('X')
      }, function (r) {
        if (!r.error) {
          self.assignedData.loaded += 1;
          self.assignedData.list[self.assignedData.loaded] = r.data;

          self.getAssignedData();
        } else {
          self.reportStatus.assigned = 'has-error';
          self.queue.shift();
          self.process();
          return;
        }
      });
    },
    buildAssignedData: function buildAssignedData() {
      var self = this;

      var font = self.font;
      __WEBPACK_IMPORTED_MODULE_4_xlsx_populate_browser_xlsx_populate__["fromBlankAsync"]().then(function (workbook) {
        var sheetName = 'Assigned Reports';
        workbook.addSheet(sheetName);
        workbook.sheet(sheetName).cell('A1').style({ fontSize: 22, fontFamily: font, bold: true, italic: true, verticalAlignment: 'center' }).value('OPOLI Reports');
        workbook.sheet(sheetName).range('A1:B1').merged(true);

        workbook.sheet(sheetName).cell('A2').style({ fontSize: 16, fontFamily: font, bold: true, fontColor: '666666', verticalAlignment: 'center' }).value('Date: ' + __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(self.from).format('MM-DD-YYYY'));
        workbook.sheet(sheetName).range('A2:B2').merged(true);

        // Total Reservation
        workbook.sheet(sheetName).cell('A5').style({ fontSize: 14, fontFamily: font, bold: true, fontColor: '434343', verticalAlignment: 'center' }).value('Total Reservations');
        workbook.sheet(sheetName).range('A5:B5').merged(true);
        workbook.sheet(sheetName).row('5').height(20);

        workbook.sheet(sheetName).cell('A6').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Service Name');

        workbook.sheet(sheetName).cell('B6').style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('RSVP');

        var currentRow = 7;
        var total1 = 0;
        if (self.assignedData.list[1].length) {
          self.assignedData.list[1].forEach(function (data) {
            workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black' }).value(data.serviceName);
            workbook.sheet(sheetName).cell('B' + currentRow).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black' }).value(data.value);
            total1 += data.value;
            currentRow++;
          });
          workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin' }).value('Total');
          workbook.sheet(sheetName).cell('B' + currentRow).style({ fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin' }).value(total1);
          workbook.sheet(sheetName).row(currentRow).height(18);
        } else {
          workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 9, fontFamily: font, italic: true, fontColor: '777777', bold: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'thin', borderColor: 'black' }).value('No reservation found.');
          workbook.sheet(sheetName).range('A' + currentRow + ':B' + currentRow).merged(true);
          workbook.sheet(sheetName).row(currentRow).height(25);
        }
        currentRow += 3;

        // Assigned Reservations BEFORE 10AM
        workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 14, fontFamily: font, bold: true, fontColor: '434343', verticalAlignment: 'center' }).value('Assigned Reservations BEFORE 10AM');
        workbook.sheet(sheetName).range('A' + currentRow + ':B' + currentRow).merged(true);
        workbook.sheet(sheetName).row(currentRow).height(20);
        currentRow++;

        workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Service Name');

        workbook.sheet(sheetName).cell('B' + currentRow).style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('RSVP');
        currentRow++;

        var total2 = 0;
        if (self.assignedData.list[2].length) {
          self.assignedData.list[2].forEach(function (data) {
            workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black' }).value(data.serviceName);
            workbook.sheet(sheetName).cell('B' + currentRow).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black' }).value(data.value);
            total2 += data.value;
            currentRow++;
          });
          workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin' }).value('Assigned');
          workbook.sheet(sheetName).cell('B' + currentRow).style({ fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin' }).value(total2);
          workbook.sheet(sheetName).row(currentRow).height(18);
        } else {
          workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 9, fontFamily: font, italic: true, fontColor: '777777', bold: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'thin', borderColor: 'black' }).value('No assigned reservation found.');
          workbook.sheet(sheetName).range('A' + currentRow + ':B' + currentRow).merged(true);
          workbook.sheet(sheetName).row(currentRow).height(25);
        }
        currentRow += 3;

        // Assigned Reservations AFTER 10AM
        workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 14, fontFamily: font, bold: true, fontColor: '434343', verticalAlignment: 'center' }).value('Assigned Reservations AFTER 10AM');
        workbook.sheet(sheetName).range('A' + currentRow + ':B' + currentRow).merged(true);
        workbook.sheet(sheetName).row(currentRow).height(20);
        currentRow++;

        workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Service Name');

        workbook.sheet(sheetName).cell('B' + currentRow).style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('RSVP');
        currentRow++;

        var total3 = 0;
        if (self.assignedData.list[3].length) {
          self.assignedData.list[3].forEach(function (data) {
            workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black' }).value(data.serviceName);
            workbook.sheet(sheetName).cell('B' + currentRow).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black' }).value(data.value);
            total3 += data.value;
            currentRow++;
          });
          workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin' }).value('Assigned');
          workbook.sheet(sheetName).cell('B' + currentRow).style({ fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin' }).value(total3);
          workbook.sheet(sheetName).row(currentRow).height(18);
        } else {
          workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 9, fontFamily: font, italic: true, fontColor: '777777', bold: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'thin', borderColor: 'black' }).value('No assigned reservation found.');
          workbook.sheet(sheetName).range('A' + currentRow + ':B' + currentRow).merged(true);
          workbook.sheet(sheetName).row(currentRow).height(25);
        }
        currentRow += 3;

        // Not assigned Reservations BEFORE 10AM
        workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 14, fontFamily: font, bold: true, fontColor: '434343', verticalAlignment: 'center' }).value('Not assigned Reservations BEFORE 10AM');
        workbook.sheet(sheetName).range('A' + currentRow + ':B' + currentRow).merged(true);
        workbook.sheet(sheetName).row(currentRow).height(20);
        currentRow++;

        workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Service Name');

        workbook.sheet(sheetName).cell('B' + currentRow).style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('RSVP');
        currentRow++;

        var total4 = 0;
        if (self.assignedData.list[4].length) {
          self.assignedData.list[4].forEach(function (data) {
            workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black' }).value(data.serviceName);
            workbook.sheet(sheetName).cell('B' + currentRow).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black' }).value(data.value);
            total4 += data.value;
            currentRow++;
          });
          workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin' }).value('Not assigned');
          workbook.sheet(sheetName).cell('B' + currentRow).style({ fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin' }).value(total4);
          workbook.sheet(sheetName).row(currentRow).height(18);
        } else {
          workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 9, fontFamily: font, italic: true, fontColor: '777777', bold: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'thin', borderColor: 'black' }).value('No reservation found.');
          workbook.sheet(sheetName).range('A' + currentRow + ':B' + currentRow).merged(true);
          workbook.sheet(sheetName).row(currentRow).height(25);
        }
        currentRow += 3;

        // Not assigned Reservations AFTER 10AM
        workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 14, fontFamily: font, bold: true, fontColor: '434343', verticalAlignment: 'center' }).value('Not assigned Reservations AFTER 10AM');
        workbook.sheet(sheetName).range('A' + currentRow + ':B' + currentRow).merged(true);
        workbook.sheet(sheetName).row(currentRow).height(20);
        currentRow++;

        workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Service Name');

        workbook.sheet(sheetName).cell('B' + currentRow).style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('RSVP');
        currentRow++;

        var total5 = 0;
        if (self.assignedData.list[5].length) {
          self.assignedData.list[5].forEach(function (data) {
            workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black' }).value(data.serviceName);
            workbook.sheet(sheetName).cell('B' + currentRow).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black' }).value(data.value);
            total5 += data.value;
            currentRow++;
          });
          workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin' }).value('Not assigned');
          workbook.sheet(sheetName).cell('B' + currentRow).style({ fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin' }).value(total5);
          workbook.sheet(sheetName).row(currentRow).height(18);
        } else {
          workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 9, fontFamily: font, italic: true, fontColor: '777777', bold: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'thin', borderColor: 'black' }).value('No reservation found.');
          workbook.sheet(sheetName).range('A' + currentRow + ':B' + currentRow).merged(true);
          workbook.sheet(sheetName).row(currentRow).height(25);
        }
        currentRow += 3;

        // Available Drivers BEFORE 10AM
        workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 14, fontFamily: font, bold: true, fontColor: '434343', verticalAlignment: 'center' }).value('Available Drivers BEFORE 10AM');
        workbook.sheet(sheetName).range('A' + currentRow + ':C' + currentRow).merged(true);
        workbook.sheet(sheetName).row(currentRow).height(20);
        currentRow++;

        workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Service Name');

        workbook.sheet(sheetName).cell('B' + currentRow).style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Drivers');

        workbook.sheet(sheetName).cell('C' + currentRow).style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('List');
        currentRow++;

        var total6 = 0;
        if (self.assignedData.list[6].length) {
          self.assignedData.list[6].forEach(function (data) {
            workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black' }).value(data.serviceName);
            workbook.sheet(sheetName).cell('B' + currentRow).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center' }).value(data.driversAvailable);
            workbook.sheet(sheetName).cell('C' + currentRow).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black' }).value(data.drivers.join(", "));
            total6 += data.driversAvailable;
            currentRow++;
          });
          workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin' }).value('Available Drivers');
          workbook.sheet(sheetName).cell('B' + currentRow).style({ fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin' }).value(total6);
          workbook.sheet(sheetName).cell('C' + currentRow).style({ fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin' }).value('');
          workbook.sheet(sheetName).row(currentRow).height(18);
        } else {
          workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 9, fontFamily: font, italic: true, fontColor: '777777', bold: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'thin', borderColor: 'black' }).value('No driver found.');
          workbook.sheet(sheetName).range('A' + currentRow + ':C' + currentRow).merged(true);
          workbook.sheet(sheetName).row(currentRow).height(25);
        }
        currentRow += 3;

        // Available Drivers AFTER 10AM
        workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 14, fontFamily: font, bold: true, fontColor: '434343', verticalAlignment: 'center' }).value('Available Drivers AFTER 10AM');
        workbook.sheet(sheetName).range('A' + currentRow + ':C' + currentRow).merged(true);
        workbook.sheet(sheetName).row(currentRow).height(20);
        currentRow++;

        workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Service Name');

        workbook.sheet(sheetName).cell('B' + currentRow).style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('Drivers');

        workbook.sheet(sheetName).cell('C' + currentRow).style({ fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black' }).value('List');
        currentRow++;

        var total7 = 0;
        if (self.assignedData.list[7].length) {
          self.assignedData.list[7].forEach(function (data) {
            workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black' }).value(data.serviceName);
            workbook.sheet(sheetName).cell('B' + currentRow).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center' }).value(data.driversAvailable);
            workbook.sheet(sheetName).cell('C' + currentRow).style({ fontSize: 9, fontFamily: font, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black' }).value(data.drivers.join(", "));
            total7 += data.driversAvailable;
            currentRow++;
          });
          workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin' }).value('Available Drivers');
          workbook.sheet(sheetName).cell('B' + currentRow).style({ fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin' }).value(total7);
          workbook.sheet(sheetName).cell('C' + currentRow).style({ fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin' }).value('');
          workbook.sheet(sheetName).row(currentRow).height(18);
        } else {
          workbook.sheet(sheetName).cell('A' + currentRow).style({ fontSize: 9, fontFamily: font, italic: true, fontColor: '777777', bold: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'thin', borderColor: 'black' }).value('No driver found.');
          workbook.sheet(sheetName).range('A' + currentRow + ':C' + currentRow).merged(true);
          workbook.sheet(sheetName).row(currentRow).height(25);
        }
        currentRow += 3;

        workbook.sheet(sheetName).row('1').height(25);
        workbook.sheet(sheetName).row('2').height(20);
        workbook.sheet(sheetName).column('A').width(25);
        workbook.sheet(sheetName).column('B').width(25);
        workbook.sheet(sheetName).column('C').width(50);

        self.save(workbook);
      });
    },
    save: function save(workbook) {
      var self = this;
      var from = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(self.from);
      var filename = 'Opoli Assigned Report - ' + from.format('MM-DD-YYYY') + '.xlsx';

      // save the workbook
      workbook.deleteSheet('Sheet1');
      workbook.outputAsync().then(function (blob) {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // If IE, you must uses a different method.
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }
        self.queue.shift();
        self.process();
      });
    }
  },
  watch: {}
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_csvexport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_api_featureToggle__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mtech-report',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default.a },
  data: function data() {
    return {
      dateType: 'all',
      from: null,
      to: null,
      error: {
        show: false,
        message: '',
        empty: []
      },
      selectedReports: {
        mtech: true
      },
      reportStatus: {
        mtech: ''
      },
      pdf: {
        code: '',
        class: '',
        title: '',
        date: '',
        table: {
          label: [],
          data: {},
          extra: {},
          total: {}
        },
        maxRecordPerPage: 40,
        list: [],
        current: '',
        loading: false
      },
      orientation: ['mtech'],
      pdfChecked: true,
      csvChecked: false,
      formatError: false,
      csv: {
        label: [],
        data: [],
        list: [],
        total: {}
      },
      searchAdmin: '',
      searchAdminId: '',
      searchAdminDelay: '',
      showSearchAdminList: false,
      weeks: [],
      selectedWeek: '',
      isIOS: navigator.userAgent.match(/(iPad|iPhone|iPod)/g)
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.reports.rsvpReport.show;
    },
    highlightedDates: function highlightedDates() {
      var self = this;
      var result = { to: null, from: null };
      if (self.from !== null) {
        result.from = self.from;
      }
      if (self.to !== null) {
        result.to = self.to;
      }
      return result;
    },
    totalPage: function totalPage() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.pdf.table.data).length;
    },
    isMtech: function isMtech() {
      return this.pdf.code === 'mtech' && this.totalPage;
    },
    admins: function admins() {
      var _this = this;

      return this.$store.state.reservationNotes.admins.filter(function (x) {
        return x.name.toLowerCase().includes(_this.searchAdmin.toLowerCase());
      });
    }
  },
  methods: {
    isValid: function isValid() {
      var self = this;
      self.error.show = false;
      self.error.empty = [];
      if (self.from === null || self.to === null) {
        self.error.show = true;
        self.error.message = 'Please specify the Start and End dates.';
        return false;
      }
      self.formatError = false;
      if (!self.pdfChecked && !self.csvChecked) {
        self.error.show = true;
        self.error.message = 'Please select which file format.';
        self.formatError = true;
        return false;
      }
      if (!self.selectedReports.mtech) {
        self.error.show = true;
        self.error.message = 'Please select at least one report type.';
        return false;
      }
      return true;
    },
    getNewDoc: function getNewDoc() {
      var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
      });
      doc.setFont('helvetica');
      return doc;
    },
    startProcess: function startProcess() {
      if (!this.isValid()) {
        return;
      }
      this.pdf.list = [];
      this.csv.list = [];
      for (var report in this.selectedReports) {
        if (this.selectedReports[report]) {
          this.reportStatus[report] = 'on-queue';
          this.pdf.list.push(report);
          this.csv.list.push(report);
        }
      }
      this.pdf.loading = true;
      this.generateReport();
    },
    generateReport: function generateReport() {
      var isCsv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if ((!this.pdf.list.length && this.pdfChecked || !this.pdfChecked) && (!this.csv.list.length && this.csvChecked || !this.csvChecked)) {
        this.pdf.loading = false;
        return;
      }
      if (isCsv) {
        console.log('Processing:', this.csv.list[0]);
        this.getDataReports(this.csv.list[0]);
      } else {
        console.log('Processing:', this.pdf.list[0]);
        this.getDataReports(this.pdf.list[0]);
      }
    },
    getDataReports: function getDataReports(type) {
      var self = this;
      self.reportStatus[type] = 'loading';
      var orientationMax = self.orientation;
      self.pdf.maxRecordPerPage = orientationMax.indexOf(type) > -1 ? 25 : 40;
      self.$sdk.get(self.apiParams(type).url, self.apiParams(type).data, function (r) {
        // console.log('---', r)
        // return
        if (r.error) {
          self.reportStatus[type] = 'has-error';
          return;
        }
        self.setPdfLabel(type);
        self.pdf.table.data = {};
        self.pdf.table.extra = {};
        self.pdf.table.total = {};
        self.csv.data = [];
        self.csv.total = {};
        if (r.list.length > 0) {
          self.buildPdfData(type, r.list);
        } else {
          self.error.show = true;
          self.error.empty.push(self.reportLabel(type));
          self.reportStatus[type] = 'has-error';
          self.pdf.list.shift();
          self.csv.list.shift();
          self.generateReport();
        }
      });
    },
    apiParams: function apiParams(type) {
      var url = '';
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.to);
      var data = {
        token: this.$store.state.session.sessionToken,
        since: start.format('YYYY-MM-DD'),
        until: end.format('YYYY-MM-DD')
        // switch (type) {
        //   case 'mtech':
        //     url = '/reports/mtech/list'
        //     break
        // }
      };url = this.dateType == 'all' ? '/reports/mtech' : '/reports/mtech/completed';
      // data.filter = this.dateType
      return { url: url, data: data };
    },
    setPdfLabel: function setPdfLabel(type) {
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.to);
      var dateRange = start.format('MM/DD/YYYY') + ' - ' + end.format('MM/DD/YYYY');
      this.pdf.code = type;
      if (type === 'mtech') {
        this.pdf.class = 'report-mtech';
        this.pdf.title = 'Opoli Reports - Mtech';
        var label = this.dateType == 'all' ? 'All Bookings' : 'Completed';
        this.pdf.date = label + ' (' + dateRange + ')';
        this.pdf.table.label = ['ID', 'Date Created', 'Source', 'Pickup Date', 'Geofence', 'Service Type', 'Original <br/>Amount', 'Charged <br/>Amount'];
      }
    },
    buildPdfData: function buildPdfData(type, pdfData) {
      var self = this;
      var groupCount = 0;
      var page = 1;
      // mtech
      var totalOrigAmount = 0;
      var totalChargeAmount = 0;

      pdfData.forEach(function (data, index) {
        if (!self.pdf.table.data['page' + page]) {
          self.pdf.table.data['page' + page] = [];
        }
        self.pdf.table.data['page' + page].push(self.buildTableData(type, data));
        if (self.csvChecked) {
          self.csv.data.push(self.buildCsvData(type, data));
        }
        groupCount++;
        if (type === 'mtech') {
          totalOrigAmount += parseFloat(data.quotedAmount || 0);
          totalChargeAmount += parseFloat(data.chargedAmount || 0);
        }
        if ((index + 1) % self.pdf.maxRecordPerPage === 0 && pdfData.length !== index + 1) {
          page++;
        }
      });
      self.pdf.table.total.record = pdfData.length;
      if (type === 'mtech') {
        self.pdf.table.total.rsvp = self.covertNumber(pdfData.length);
        self.pdf.table.total.origAmount = self.covertNumber(totalOrigAmount.toFixed(2));
        self.pdf.table.total.chargeAmount = self.covertNumber(totalChargeAmount.toFixed(2));
      }
      if (self.pdfChecked) {
        self.processDownloads('pdf', { type: type, page: page });
      } else {
        self.processDownloads('csv', { type: type });
      }
    },
    buildTableData: function buildTableData(type, data) {
      var self = this;
      if (type === 'mtech') {
        return {
          id: data.rsvpId,
          created: __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.created, 'X').format('MM/DD/YYYY hh:mmA'),
          source: self.sourceLabel(data.deviceType),
          pickupDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.pickupTime, 'X').format('MM/DD/YYYY hh:mmA'),
          geofence: data.geofence,
          serviceType: data.mtechProduct,
          origAmount: self.covertNumber(parseFloat(data.quotedAmount || 0).toFixed(2)),
          chargeAmount: self.covertNumber(parseFloat(data.chargedAmount || 0).toFixed(2))
        };
      }
    },
    sourceLabel: function sourceLabel(x) {
      switch (x) {
        case 'ios':
          return 'CA';
        case 'android':
          return 'CA';
        case 'admin':
          return 'Admin';
        case 'CSR':
          return 'CSR';
        default:
          return 'Web';
      }
    },
    fileName: function fileName(type, format) {
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.to);
      var timestamp = start.format('YYYYMMDD') + '_' + end.format('YYYYMMDD');
      switch (type) {
        case 'mtech':
          return 'reportsMTECH_' + timestamp + '.' + format;
      }
    },
    currentPage: function currentPage(page) {
      return page.substring(4);
    },
    processPdf: function processPdf(type, page) {
      var self = this;
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.to);
      var pageAsyncs = [];
      var landscapeReports = self.orientation;
      var orientation = landscapeReports.indexOf(type) > -1 ? 'l' : 'p';
      var pdf = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a({ orientation: orientation, unit: 'mm', format: 'a4' });
      window.scrollTo(500, 0);
      document.body.style.overflow = 'hidden';

      setTimeout(function () {
        if (self.isIOS) page = page + 1;

        var _loop = function _loop(i) {
          // self.pdf.current = 'page' + (i + 1)
          pageAsyncs.push(__WEBPACK_IMPORTED_MODULE_4_html2canvas___default()(document.getElementsByClassName('page' + (i + 1))[0], {
            scale: "1"
          }).then(function (canvas) {
            var imgData = canvas.toDataURL('image/jpeg', 1.0);
            pdf.addImage(imgData, 'JPEG', 0, 0);
            if (i + 1 !== page) {
              pdf.addPage();
            }
          }).catch(function (e) {
            self.reportStatus[type] = 'has-error';
            self.pdf.list.shift();
            document.body.style.overflow = 'auto';
            self.processDownloads('csv', { type: type });
            console.warn(e);
          }));
        };

        for (var i = 0; i < page; i++) {
          _loop(i);
        }
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(pageAsyncs).then(function () {
          // let timestamp = start.format('YYYYMMDD') + '_' + end.format('YYYYMMDD')
          pdf.save(self.fileName(type, 'pdf'));
          self.reportStatus[type] = 'success';
          self.pdf.list.shift();
          document.body.style.overflow = 'auto';
          self.processDownloads('csv', { type: type });
        });
      }, 500);
    },
    covertNumber: function covertNumber(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    resetSelectedStatus: function resetSelectedStatus() {
      this.selectedReports = {
        mtech: false
      };
    },
    resetReportStatus: function resetReportStatus() {
      this.error.show = false;
      this.error.empty = [];
      this.reportStatus = {
        mtech: ''
      };
    },
    reportLabel: function reportLabel(type) {
      switch (type) {
        case 'mtech':
          return 'MTech Report';
      }
    },
    buildCsvData: function buildCsvData(type, data) {
      var column = [];
      this.pdf.table.label.forEach(function (i) {
        column.push(i.replace('<br/>', ''));
      });
      this.csv.label = column;
      var csvData = {};
      var pdfData = this.buildTableData(type, data);
      var i = 0;
      for (var key in pdfData) {
        csvData[column[i]] = pdfData[key];
        i++;
      }
      return csvData;
    },
    processDownloads: function processDownloads(action, data) {
      if (action === 'pdf' && this.pdfChecked) {
        this.processPdf(data.type, data.page);
      } else if (action === 'csv' && this.csvChecked) {
        this.processCsv(data.type);
      } else {
        this.generateReport();
      }
    },
    processCsv: function processCsv(type) {
      var exporter = __WEBPACK_IMPORTED_MODULE_6_csvexport___default.a.create({
        filename: this.fileName(type, 'csv'),
        columns: this.csv.label
      });
      // add total
      this.csv.data.push(this.buildCsvTotal(type));
      exporter.downloadCsv(this.csv.data);
      this.reportStatus[type] = 'success';
      this.csv.list.shift();
      this.generateReport(true);
    },
    buildCsvTotal: function buildCsvTotal(type) {
      var csvData = {};
      var totalData = this.pdf.table.total;
      if (type === 'mtech') {
        csvData[this.csv.label[0]] = 'Total (' + totalData.rsvp + ')';
        csvData[this.csv.label[1]] = '';
        csvData[this.csv.label[2]] = '';
        csvData[this.csv.label[3]] = '';
        csvData[this.csv.label[4]] = '';
        csvData[this.csv.label[5]] = '';
        csvData[this.csv.label[6]] = '$' + totalData.origAmount;
        csvData[this.csv.label[7]] = '$' + totalData.chargeAmount;
      }
      return csvData;
    },
    formatCheck: function formatCheck() {
      this.error.show = false;
      this.formatError = false;
    }
  },
  watch: {
    show: function show(value) {
      if (!value) {
        return;
      }
      this.from = null;
      this.to = null;
      this.error.show = false;
      this.error.empty = [];
      this.resetSelectedStatus();
      this.resetReportStatus();
    },
    from: function from(value) {
      this.resetReportStatus();
    },
    to: function to(value) {
      this.resetReportStatus();
    },
    'selectedReports.mtech': function selectedReportsMtech(value) {
      this.resetReportStatus();
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_csvexport__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'daily-rsvp-report',
  props: ['modal'],
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default.a },
  data: function data() {
    return {
      loading: false,
      date: null,
      pdfChecked: true,
      csvChecked: false,
      error: {
        msg: '',
        format: ''
      },
      pdf: {
        list: [],
        total: {}
      },
      csv: {
        label: [],
        data: [],
        list: [],
        total: {},
        summaryWeeklyLabel: [],
        terminalLabel: []
      },
      isIOS: navigator.userAgent.match(/(iPad|iPhone|iPod)/g)
    };
  },

  computed: {},
  methods: {
    generate: function generate() {
      var _this = this;

      var self = this;
      if (self.loading) return;

      self.error.msg = '';
      var hasError = false;
      if (!self.date) {
        self.error.msg = 'Please select a date.';
        hasError = true;
      }
      if (!self.pdfChecked && !self.csvChecked) {
        if (self.error.msg) self.error.msg += '<br/>';
        self.error.msg += 'Please select which file format.';
        hasError = true;
      }
      if (hasError) return;

      self.loading = true;
      var date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date);
      self.$sdk.get('/reports/brands/date', {
        token: this.$store.state.session.sessionToken,
        date: date.format('YYYY-MM-DD'),
        since: date.startOf('isoWeek').format('YYYY-MM-DD'),
        until: date.endOf('isoWeek').format('YYYY-MM-DD')
      }, function (res) {
        self.loading = false;
        if (!res.brands.length) {
          self.error.msg = 'Empty Result.';
          return;
        }

        var totalDailyRsvp = 0;
        var totalDailyAmount = 0;
        var totalWeeklyRsvp = 0;
        var totalWeeklyAmount = 0;
        var totalAvgFare = 0;

        _this.pdf.list = [];
        _this.pdf.total = {};
        res.brands.forEach(function (brand) {
          totalDailyRsvp += brand.dailyRsvp;
          totalDailyAmount += brand.dailyTotal;
          totalWeeklyRsvp += brand.weeklyRsvp;
          totalWeeklyAmount += brand.weeklyTotal;
          totalAvgFare += brand.avgFare;

          _this.pdf.list.push({
            brand: brand.brandName,
            dailyRsvp: _this.covertNumber(brand.dailyRsvp),
            dailyTotal: _this.covertNumber(brand.dailyTotal.toFixed(2)),
            dailyGoal: _this.goal(brand.brandId, 'daily'),
            weeklyRsvp: _this.covertNumber(brand.weeklyRsvp),
            weeklyTotal: _this.covertNumber(brand.weeklyTotal.toFixed(2)),
            weeklyGoal: _this.goal(brand.brandId, 'weekly'),
            avgFare: _this.covertNumber(brand.avgFare.toFixed(2))
          });
        });

        _this.pdf.total = {
          totalDailyRsvp: _this.covertNumber(totalDailyRsvp),
          totalDailyAmount: _this.covertNumber(totalDailyAmount.toFixed(2)),
          totalWeeklyRsvp: _this.covertNumber(totalWeeklyRsvp),
          totalWeeklyAmount: _this.covertNumber(totalWeeklyAmount.toFixed(2)),
          totalAvgFare: _this.covertNumber((totalAvgFare / 7).toFixed(2))
        };

        if (self.pdfChecked) {
          self.processPdf();
        } else {
          self.processCsv();
        }
      });
    },
    covertNumber: function covertNumber(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    goal: function goal(id, type) {
      var index = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.findIndex(function (x) {
        return x.id === id;
      });
      if (index == -1) return '--';
      var brand = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[index].code;
      switch (brand) {
        case 'op':
          return type === 'daily' ? 30 : 210;
        case 'gs':
          return type === 'daily' ? 30 : 210;
        case 'pts':
          return type === 'daily' ? 300 : 2100;
        case 's2l':
          return type === 'daily' ? 100 : 700;
        default:
          return type === 'daily' ? '--' : '--';
      }
    },
    processPdf: function processPdf() {
      var self = this;
      var date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.date);
      var pageAsyncs = [];
      // let landscapeReports = self.orientation
      // let orientation = landscapeReports.indexOf(type) > -1 ? 'l' : 'p'
      var orientation = 'l';
      var pdf = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a({ orientation: orientation, unit: 'mm', format: 'a4' });

      window.scrollTo(500, 0);
      document.body.style.overflow = 'hidden';

      setTimeout(function () {
        pageAsyncs.push(__WEBPACK_IMPORTED_MODULE_4_html2canvas___default()(document.getElementsByClassName('page-daily')[0], {
          scale: "1"
        }).then(function (canvas) {
          var imgData = canvas.toDataURL('image/jpeg', 0.9);
          pdf.addImage(imgData, 'JPEG', 0, 0);
        }).catch(function (e) {
          self.error.msg = 'Something went wrong generating pdf.';
          document.body.style.overflow = 'auto';
          console.warn(e);
        }));
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(pageAsyncs).then(function () {
          var timestamp = date.format('YYYYMMDD');
          pdf.save('daily-rsvp-report_' + timestamp + '.pdf');
          document.body.style.overflow = 'auto';
          self.processCsv();
        });
      }, 2000);
    },
    processCsv: function processCsv() {
      if (!this.csvChecked) return;
      var timestamp = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).format('YYYYMMDD');
      var exporter = __WEBPACK_IMPORTED_MODULE_5_csvexport___default.a.create({
        filename: 'daily-rsvp-report_' + timestamp + '.csv',
        columns: ['Brand', 'Daily Rsvp', 'Daily Goal', 'Total Amount Daily', 'Weekly Rsvp', 'Weekly Goal', 'Total Amount Weekly', 'Avg Fare']
      });

      var data = [];
      this.pdf.list.forEach(function (x) {
        data.push({
          'Brand': x.brand,
          'Daily Rsvp': x.dailyRsvp,
          'Daily Goal': x.dailyGoal,
          'Total Amount Daily': x.dailyTotal,
          'Weekly Rsvp': x.weeklyRsvp,
          'Weekly Goal': x.weeklyGoal,
          'Total Amount Weekly': x.weeklyTotal,
          'Avg Fare': x.avgFare
        });
      });
      data.push({
        'Brand': 'Total',
        'Daily Rsvp': this.pdf.total.totalDailyRsvp,
        'Daily Goal': '',
        'Total Amount Daily': this.pdf.total.totalDailyAmount,
        'Weekly Rsvp': this.pdf.total.totalWeeklyRsvp,
        'Weekly Goal': '',
        'Total Amount Weekly': this.pdf.total.totalWeeklyAmount,
        'Avg Fare': this.pdf.total.totalAvgFare
      });

      // add total
      exporter.downloadCsv(data);
    },
    closeModal: function closeModal() {
      if (this.loading) return;
      this.$emit('closeDailyRsvp');
    },
    dateFormat: function dateFormat(x) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(x).format('MM/DD/YYYY');
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_csvexport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_api_featureToggle__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'block-report',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default.a },
  data: function data() {
    return {
      blockSort: 'rsvp',
      isMixed: false,
      from: null,
      to: null,
      error: {
        show: false,
        message: '',
        empty: []
      },
      selectedReports: {
        block: true
      },
      reportStatus: {
        block: ''
      },
      pdf: {
        code: '',
        class: '',
        title: '',
        date: '',
        table: {
          label: [],
          data: {},
          extra: {},
          total: {}
        },
        maxRecordPerPage: 40,
        list: [],
        current: '',
        loading: false
      },
      orientation: ['block'],
      pdfChecked: true,
      csvChecked: false,
      formatError: false,
      csv: {
        label: [],
        data: [],
        list: [],
        total: {}
      },
      searchAdmin: '',
      searchAdminId: '',
      searchAdminDelay: '',
      showSearchAdminList: false,
      weeks: [],
      selectedWeek: '',
      isIOS: navigator.userAgent.match(/(iPad|iPhone|iPod)/g)
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.reports.rsvpReport.show;
    },
    highlightedDates: function highlightedDates() {
      var self = this;
      var result = { to: null, from: null };
      if (self.from !== null) {
        result.from = self.from;
      }
      if (self.to !== null) {
        result.to = self.to;
      }
      return result;
    },
    totalPage: function totalPage() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.pdf.table.data).length;
    }
  },
  methods: {
    isValid: function isValid() {
      var self = this;
      self.error.show = false;
      self.error.empty = [];
      if (self.from === null || self.to === null) {
        self.error.show = true;
        self.error.message = 'Please specify the Start and End dates.';
        return false;
      }
      self.formatError = false;
      if (!self.pdfChecked && !self.csvChecked) {
        self.error.show = true;
        self.error.message = 'Please select which file format.';
        self.formatError = true;
        return false;
      }
      if (!self.selectedReports.block) {
        self.error.show = true;
        self.error.message = 'Please select at least one report type.';
        return false;
      }
      return true;
    },
    getNewDoc: function getNewDoc() {
      var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
      });
      doc.setFont('helvetica');
      return doc;
    },
    startProcess: function startProcess() {
      if (!this.isValid()) {
        return;
      }
      this.pdf.list = [];
      this.csv.list = [];
      for (var report in this.selectedReports) {
        if (this.selectedReports[report]) {
          this.reportStatus[report] = 'on-queue';
          this.pdf.list.push(report);
          this.csv.list.push(report);
        }
      }
      this.pdf.loading = true;
      this.generateReport();
    },
    generateReport: function generateReport() {
      var isCsv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if ((!this.pdf.list.length && this.pdfChecked || !this.pdfChecked) && (!this.csv.list.length && this.csvChecked || !this.csvChecked)) {
        this.pdf.loading = false;
        return;
      }
      if (isCsv) {
        console.log('Processing:', this.csv.list[0]);
        this.getDataReports(this.csv.list[0]);
      } else {
        console.log('Processing:', this.pdf.list[0]);
        this.getDataReports(this.pdf.list[0]);
      }
    },
    getDataReports: function getDataReports(type) {
      var self = this;
      self.reportStatus[type] = 'loading';
      var orientationMax = self.orientation;
      self.pdf.maxRecordPerPage = orientationMax.indexOf(type) > -1 ? 25 : 40;
      self.$sdk.get(self.apiParams(type).url, self.apiParams(type).data, function (r) {
        // console.log('---', r)
        // return
        if (r.error) {
          self.reportStatus[type] = 'has-error';
          return;
        }
        self.setPdfLabel(type);
        self.pdf.table.data = {};
        self.pdf.table.extra = {};
        self.pdf.table.total = {};
        self.csv.data = [];
        self.csv.total = {};
        if (r.list.length > 0) {
          self.buildPdfData(type, r.list);
        } else {
          self.error.show = true;
          self.error.empty.push(self.reportLabel(type));
          self.reportStatus[type] = 'has-error';
          self.pdf.list.shift();
          self.csv.list.shift();
          self.generateReport();
        }
      });
    },
    apiParams: function apiParams(type) {
      var url = '';
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.to);
      var data = {
        token: this.$store.state.session.sessionToken,
        since: start.format('YYYY-MM-DD'),
        until: end.format('YYYY-MM-DD')
      };
      switch (type) {
        case 'block':
          url = '/reports/block/summary';
          data.sort = this.blockSort;
          // data.mixed = this.isMixed ? 1 : 0
          break;
      }
      return { url: url, data: data };
    },
    setPdfLabel: function setPdfLabel(type) {
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.to);
      var dateRange = start.format('MM/DD/YYYY') + ' - ' + end.format('MM/DD/YYYY');
      this.pdf.code = type;
      if (type === 'block') {
        this.pdf.class = 'report-block';
        this.pdf.title = 'Opoli Block Reports';
        this.pdf.date = '(' + dateRange + ')';
        this.pdf.table.label = ['Prov ID', 'Prov Name', 'Sector #', 'RUN ID', 'RSVP ID', 'Accepted/Not Accepted <br/>(Y/N)', 'Time in queue (mm:ss)', 'Service <br/>Type', 'Date'];
      }
    },
    buildPdfData: function buildPdfData(type, pdfData) {
      var self = this;
      var page = 1;
      // block
      // let totalRsvpCount = 0
      var runList = [];
      var totalRunCount = 0;

      pdfData.forEach(function (data, index) {
        if (!self.pdf.table.data['page' + page]) {
          self.pdf.table.data['page' + page] = [];
        }
        self.pdf.table.data['page' + page].push(self.buildTableData(type, data));
        if (type === 'block' && data.type === 'run' && runList.indexOf(data.runId) == -1) {
          runList.push(data.runId);
          totalRunCount++;
        }
        if (self.csvChecked) {
          self.csv.data.push(self.buildCsvData(type, data));
        }
        if ((index + 1) % self.pdf.maxRecordPerPage === 0 && pdfData.length !== index + 1) {
          page++;
        }
      });
      // self.pdf.table.total.record = pdfData.length
      if (type === 'block') {
        self.pdf.table.total.rsvp = self.covertNumber(pdfData.length);
        self.pdf.table.total.run = self.covertNumber(totalRunCount);
      }
      if (self.pdfChecked) {
        self.processDownloads('pdf', { type: type, page: page });
      } else {
        self.processDownloads('csv', { type: type });
      }
    },
    buildTableData: function buildTableData(type, data) {
      var self = this;
      if (type === 'block') {
        return {
          provId: data.providerId || '',
          provName: data.providerName || '',
          sectorId: data.sectorId,
          runId: data.runId,
          rsvpId: data.rsvpId || data.rsvpIds,
          accepted: data.isAccepted,
          timeQueue: data.timeInQueue,
          service: data.serviceLabel,
          date: __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.firstPickup, 'X').format('MM/DD/YYYY hh:mmA')
        };
      }
    },
    sourceLabel: function sourceLabel(x) {
      switch (x) {
        case 'ios':
          return 'CA';
        case 'android':
          return 'CA';
        case 'admin':
          return 'Admin';
        case 'CSR':
          return 'CSR';
        default:
          return 'Web';
      }
    },
    fileName: function fileName(type, format) {
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.to);
      var timestamp = start.format('YYYYMMDD') + '_' + end.format('YYYYMMDD');
      switch (type) {
        case 'block':
          return 'reportsBLOCK_' + timestamp + '.' + format;
      }
    },
    currentPage: function currentPage(page) {
      return page.substring(4);
    },
    processPdf: function processPdf(type, page) {
      var self = this;
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.to);
      var pageAsyncs = [];
      var landscapeReports = self.orientation;
      var orientation = landscapeReports.indexOf(type) > -1 ? 'l' : 'p';
      var pdf = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a({ orientation: orientation, unit: 'mm', format: 'a4' });
      window.scrollTo(500, 0);
      document.body.style.overflow = 'hidden';
      setTimeout(function () {
        if (self.isIOS) page = page + 1;

        var _loop = function _loop(i) {
          // self.pdf.current = 'page' + (i + 1)
          pageAsyncs.push(__WEBPACK_IMPORTED_MODULE_4_html2canvas___default()(document.getElementsByClassName('page' + (i + 1))[0], {
            scale: "1"
          }).then(function (canvas) {
            var imgData = canvas.toDataURL('image/jpeg', 1.0);
            pdf.addImage(imgData, 'JPEG', 0, 0);
            if (i + 1 !== page) {
              pdf.addPage();
            }
          }).catch(function (e) {
            self.reportStatus[type] = 'has-error';
            self.pdf.list.shift();
            document.body.style.overflow = 'auto';
            self.processDownloads('csv', { type: type });
            console.warn(e);
          }));
        };

        for (var i = 0; i < page; i++) {
          _loop(i);
        }
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(pageAsyncs).then(function () {
          var timestamp = start.format('YYYYMMDD') + '_' + end.format('YYYYMMDD');
          pdf.save(self.fileName(type, 'pdf'));
          self.reportStatus[type] = 'success';
          self.pdf.list.shift();
          document.body.style.overflow = 'auto';
          self.processDownloads('csv', { type: type });
        });
      }, 500);
    },
    covertNumber: function covertNumber(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    resetSelectedStatus: function resetSelectedStatus() {
      this.selectedReports = {
        block: false
      };
    },
    resetReportStatus: function resetReportStatus() {
      this.error.show = false;
      this.error.empty = [];
      this.reportStatus = {
        block: ''
      };
    },
    reportLabel: function reportLabel(type) {
      switch (type) {
        case 'block':
          return 'Block Report';
      }
    },
    buildCsvData: function buildCsvData(type, data) {
      var column = [];
      this.pdf.table.label.forEach(function (i) {
        column.push(i.replace('<br/>', ''));
      });
      this.csv.label = column;
      var csvData = {};
      var pdfData = this.buildTableData(type, data);
      var i = 0;
      for (var key in pdfData) {
        csvData[column[i]] = pdfData[key];
        i++;
      }
      return csvData;
    },
    processDownloads: function processDownloads(action, data) {
      if (action === 'pdf' && this.pdfChecked) {
        this.processPdf(data.type, data.page);
      } else if (action === 'csv' && this.csvChecked) {
        this.processCsv(data.type);
      } else {
        this.generateReport();
      }
    },
    processCsv: function processCsv(type) {
      var exporter = __WEBPACK_IMPORTED_MODULE_6_csvexport___default.a.create({
        filename: this.fileName(type, 'csv'),
        columns: this.csv.label
      });
      // add total
      this.csv.data.push(this.buildCsvTotal(type));
      console.log('!!', this.csv.data);
      exporter.downloadCsv(this.csv.data);
      this.reportStatus[type] = 'success';
      this.csv.list.shift();
      this.generateReport(true);
    },
    buildCsvTotal: function buildCsvTotal(type) {
      var csvData = {};
      var totalData = this.pdf.table.total;
      if (type === 'block') {
        csvData[this.csv.label[0]] = '';
        csvData[this.csv.label[1]] = '';
        csvData[this.csv.label[2]] = '';
        csvData[this.csv.label[3]] = 'Total RUN (' + totalData.run + ')';
        csvData[this.csv.label[4]] = 'Total RSVP (' + totalData.rsvp + ')';
        csvData[this.csv.label[5]] = '';
        csvData[this.csv.label[6]] = '';
        csvData[this.csv.label[7]] = '';
        csvData[this.csv.label[8]] = '';
      }
      return csvData;
    },
    formatCheck: function formatCheck() {
      this.error.show = false;
      this.formatError = false;
    }
  },
  watch: {
    show: function show(value) {
      if (!value) {
        return;
      }
      this.from = null;
      this.to = null;
      this.error.show = false;
      this.error.empty = [];
      this.resetSelectedStatus();
      this.resetReportStatus();
    },
    from: function from(value) {
      this.resetReportStatus();
    },
    to: function to(value) {
      this.resetReportStatus();
    },
    'selectedReports.block': function selectedReportsBlock(value) {
      this.resetReportStatus();
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_csvexport__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */





// import featureToggle from '@/modules/api/featureToggle'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'specialize-report',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default.a },
  data: function data() {
    return {
      from: null,
      to: null,
      error: {
        show: false,
        message: '',
        empty: []
      },
      selectedReports: {
        completedRsvp: false,
        eventLogs: false
      },
      reportStatus: {
        completedRsvp: '',
        eventLogs: ''
      },
      pdf: {
        code: '',
        class: '',
        title: '',
        date: '',
        table: {
          label: [],
          data: {},
          extra: {},
          total: {}
        },
        maxRecordPerPage: 40,
        list: [],
        current: '',
        loading: false
      },
      orientation: ['eventLogs', 'completedRsvp'],
      pdfChecked: true,
      csvChecked: false,
      formatError: false,
      csv: {
        label: [],
        data: [],
        list: [],
        total: {}
      },
      completeRsvpAirport: 0,
      completeRsvpBrands: [2, 4, 5],
      eventLogsAirport: 0,
      geoTracking: {
        list: [],
        loading: false
      },
      isIOS: navigator.userAgent.match(/(iPad|iPhone|iPod)/g)
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.reports.rsvpReport.show;
    },
    highlightedDates: function highlightedDates() {
      var self = this;
      var result = { to: null, from: null };
      if (self.from !== null) {
        result.from = self.from;
      }
      if (self.to !== null) {
        result.to = self.to;
      }
      return result;
    },
    totalPage: function totalPage() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.pdf.table.data).length;
    },
    airports: function airports() {
      return this.$store.state.airports.list;
    },
    brands: function brands() {
      return this.$store.state.brands;
    },
    isPayout: function isPayout() {
      return this.pdf.code === 'payout' && this.totalPage;
    }
  },
  methods: {
    isValid: function isValid() {
      var self = this;
      self.error.show = false;
      self.error.empty = [];
      if (self.from === null || self.to === null) {
        self.error.show = true;
        self.error.message = 'Please specify the Start and End dates.';
        return false;
      }

      var from = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.from);
      var to = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.to);

      if (from.isAfter(to)) {
        self.error.show = true;
        self.error.message = 'End date must be after Start date.';
        return false;
      }
      self.formatError = false;
      if (!self.pdfChecked && !self.csvChecked) {
        self.error.show = true;
        self.error.message = 'Please select which file format.';
        self.formatError = true;
        return false;
      }
      if (!self.selectedReports.completedRsvp && !self.selectedReports.eventLogs) {
        self.error.show = true;
        self.error.message = 'Please select at least one report type.';
        return false;
      }

      if (self.selectedReports.completedRsvp && self.completeRsvpAirport === 0) {
        self.error.show = true;
        self.error.message = 'Please select an airport.';
        return false;
      }
      if (self.selectedReports.completedRsvp && !self.completeRsvpBrands.length) {
        self.error.show = true;
        self.error.message = 'Please select atleast 1 brand.';
        return false;
      }

      if (self.selectedReports.eventLogs && self.eventLogsAirport === 0) {
        self.error.show = true;
        self.error.message = 'Please select a service area.';
        return false;
      }

      return true;
    },
    getNewDoc: function getNewDoc() {
      var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
      });
      doc.setFont('helvetica');
      return doc;
    },
    startProcess: function startProcess() {
      if (!this.isValid()) {
        return;
      }
      this.pdf.list = [];
      this.csv.list = [];
      for (var report in this.selectedReports) {
        if (this.selectedReports[report]) {
          this.reportStatus[report] = 'on-queue';
          this.pdf.list.push(report);
          this.csv.list.push(report);
        }
      }
      this.pdf.loading = true;
      this.generateReport();
    },
    generateReport: function generateReport() {
      var isCsv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if ((!this.pdf.list.length && this.pdfChecked || !this.pdfChecked) && (!this.csv.list.length && this.csvChecked || !this.csvChecked)) {
        this.pdf.loading = false;
        return;
      }
      if (isCsv) {
        console.log('Processing:', this.csv.list[0]);
        this.getDataReports(this.csv.list[0]);
      } else {
        console.log('Processing:', this.pdf.list[0]);
        this.getDataReports(this.pdf.list[0]);
      }
    },
    getDataReports: function getDataReports(type) {
      var self = this;
      self.reportStatus[type] = 'loading';
      var orientationMax = self.orientation;
      self.pdf.maxRecordPerPage = orientationMax.indexOf(type) > -1 ? 25 : 40;
      self.$sdk.get(self.apiParams(type).url, self.apiParams(type).data, function (r) {
        // console.log('---', r)
        // return
        if (r.error) {
          self.reportStatus[type] = 'has-error';
          return;
        }
        self.setPdfLabel(type);
        self.pdf.table.data = {};
        self.pdf.table.extra = {};
        self.pdf.table.total = {};
        self.csv.data = [];
        self.csv.total = {};
        if (r.list.length > 0) {
          self.buildPdfData(type, r.list);
        } else {
          self.error.show = true;
          self.error.empty.push(self.reportLabel(type));
          self.reportStatus[type] = 'has-error';
          self.pdf.list.shift();
          self.csv.list.shift();
          self.generateReport();
        }
      });
    },
    apiParams: function apiParams(type) {
      var url = '';
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.to);
      var data = {
        token: this.$store.state.session.sessionToken,
        since: start.format('YYYY-MM-DD'),
        until: end.format('YYYY-MM-DD')
      };
      switch (type) {
        case 'completedRsvp':
          url = '/reports/tnc/rsvp';
          data.geofenceId = this.completeRsvpAirport;
          data.brandIds = this.completeRsvpBrands;
          break;
        case 'eventLogs':
          url = '/reports/tnc/log';
          data.geofenceId = this.eventLogsAirport;
          break;
      }
      return { url: url, data: data };
    },
    setPdfLabel: function setPdfLabel(type) {
      var _this = this;

      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.to);
      var dateRange = start.format('MM/DD/YYYY') + ' - ' + end.format('MM/DD/YYYY');
      this.pdf.code = type;
      if (type === 'completedRsvp') {
        this.pdf.class = 'report-completed';
        var i = this.airports.findIndex(function (x) {
          return x.geofenceId === _this.completeRsvpAirport;
        });
        this.pdf.title = 'Opoli Reports - Completed Reservations (' + this.airports[i].airportCode + ' Airport)';
        this.pdf.date = dateRange;
        this.pdf.table.label = ['Brand', 'RSVP ID', 'Completed Date', 'Distance (miles)', 'ETA (sec)', 'Driver', 'Pickup Geofence', 'Dropoff Geofence'];
      }
      if (type === 'eventLogs') {
        this.pdf.class = 'report-completed';
        this.pdf.title = 'Opoli Reports - Real time Event Logs';
        this.pdf.date = dateRange;
        this.pdf.table.label = ['RSVP ID', 'Geofence', 'UID', 'Driver ID', 'License Plate', 'TNC ID', 'Date', 'Type', 'Ride Count'];
      }
    },
    buildPdfData: function buildPdfData(type, pdfData) {
      var self = this;
      // let groupCount = 0
      var page = 1;
      // payout
      // let totalDrivers = 0
      // let totalRsvp = 0
      // let totalPickupFee = 0
      // let totalTips = 0
      // let totalBonus = 0
      // let totalCancelFee = 0
      // let totalGasFee = 0
      // let totalFare = 0
      // let totalFareSum = 0
      // let totalAvgFare = 0
      // let totalTravelInsurance = 0
      // let totalAirportFee = 0
      // let totalPayment = 0
      // let totalBidAmount = 0
      // let totalPaymentPercentage = 0
      // let totalAvgFarePP = 0
      // let totalDriverPaymentOld = 0
      // let totalDriverPayment = 0
      // let totalDriverPercentage = 0
      pdfData.forEach(function (data, index) {
        if (!self.pdf.table.data['page' + page]) {
          self.pdf.table.data['page' + page] = [];
        }
        self.pdf.table.data['page' + page].push(self.buildTableData(type, data));
        if (self.csvChecked) {
          self.csv.data.push(self.buildCsvData(type, data));
        }
        // groupCount++
        if (type === 'completedRsvp') {
          // totalDrivers += data.drivers
          // totalRsvp += data.rsvp
          // totalGasFee += data.gasFee
          // totalFare += data.bidAmount
          // totalTravelInsurance += parseFloat(data.travelInsurance || 0)
          // totalAirportFee += parseFloat(data.airportFee || 0)
          // totalFareSum += data.fareSum
          // totalAvgFare += parseFloat(data.fareAvg)
          // totalDriverPaymentOld += parseFloat((data.payment + data.bonus + data.pickupFee + data.tips) - data.cancelFee)
          // totalDriverPayment += data.payoutStatus ? parseFloat(data.finalPayout) : data.total
          // totalDriverPayment += data.gasFee
          // totalPayment += data.payment
          // totalBidAmount += data.bidAmount
          // totalPickupFee += data.pickupFee
          // totalTips += data.tips
          // totalBonus += data.bonus
          // totalCancelFee += data.cancelFee
          // totalPaymentPercentage += parseFloat(data.paymentPercent || 0)
          // totalDriverPercentage += parseFloat(data.percent)
        }
        if ((index + 1) % self.pdf.maxRecordPerPage === 0 && pdfData.length !== index + 1) {
          page++;
        }
      });
      self.pdf.table.total.record = pdfData.length;
      if (type === 'completedRsvp') {
        // self.pdf.table.total.drivers = self.covertNumber(totalDrivers)
        // self.pdf.table.total.rsvp = self.covertNumber(totalRsvp)
        // self.pdf.table.total.pickupFee = self.covertNumber(totalPickupFee.toFixed(2))
        // self.pdf.table.total.tips = self.covertNumber(totalTips.toFixed(2))
        // self.pdf.table.total.bonus = self.covertNumber(totalBonus.toFixed(2))
        // self.pdf.table.total.cancelFee = self.covertNumber(totalCancelFee.toFixed(2))
        // self.pdf.table.total.gasFee = self.covertNumber(totalGasFee.toFixed(2))
        // self.pdf.table.total.fare = self.covertNumber(totalFare.toFixed(2))
        // self.pdf.table.total.travelInsurance = self.covertNumber(totalTravelInsurance.toFixed(2))
        // self.pdf.table.total.airportFee = self.covertNumber(totalAirportFee.toFixed(2))
        // self.pdf.table.total.fareSum = self.covertNumber(totalFareSum.toFixed(2))
        // self.pdf.table.total.avgFare = self.covertNumber((totalFareSum / totalRsvp).toFixed(2))
        // self.pdf.table.total.payment = self.covertNumber(totalPayment.toFixed(2))
        // let paymentPercent = (totalPayment / totalFareSum) * 100
        // self.pdf.table.total.paymentPercent = self.covertNumber(paymentPercent.toFixed(2))
        // let averagePercentage = totalDriverPercentage / pdfData.length
        // self.pdf.table.total.extraFee = self.covertNumber(totalDriverPayment.toFixed(2))
        // self.pdf.table.total.percent = self.covertNumber(((totalDriverPaymentOld / totalFareSum) * 100).toFixed(2))
      }
      if (self.pdfChecked) {
        self.processDownloads('pdf', { type: type, page: page });
      } else {
        self.processDownloads('csv', { type: type });
      }
    },
    buildTableData: function buildTableData(type, data) {
      // let self = this
      if (type === 'completedRsvp') {
        return {
          brand: data.brand.name,
          id: data.rsvpId,
          complete: __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.complete, 'YYYY-MM-DD@hh:mm').format('MM/DD/YYYY hh:mmA'),
          distance: data.distance,
          eta: data.etaInSec,
          driver: data.driver.name,
          pickupGeofence: data.pickupGeofence.name,
          dropoffGeofence: data.dropoffGeofence.name
        };
      }
      if (type === 'eventLogs') {
        return {
          rsvpId: data.rsvpId || '--',
          geofence: data.geofence_id,
          uid: data.uid,
          driverId: data.driverId,
          licensePlate: data.license_plate,
          tncId: data.tnc_id,
          date: __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(data.timestamp, 'YYYY-MM-DD@hh:mm').tz('America/Los_Angeles').format('MM/DD/YYYY hh:mmA'),
          type: data.txn_type,
          rideCount: data.ride_count
        };
      }
    },
    fileName: function fileName(type, format) {
      var timestamp = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.from).format('YYYYMMDD') + '_' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.to).format('YYYYMMDD');
      switch (type) {
        case 'completedRsvp':
          return 'reports-Completed-RSVP_' + timestamp + '.' + format;
        case 'eventLogs':
          return 'reports-Event-Logs_' + timestamp + '.' + format;
      }
    },
    currentPage: function currentPage(page) {
      return page.substring(4);
    },
    processPdf: function processPdf(type, page) {
      var self = this;
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.from);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.to);
      var pageAsyncs = [];
      var landscapeReports = self.orientation;
      var orientation = landscapeReports.indexOf(type) > -1 ? 'l' : 'p';
      var pdf = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a({ orientation: orientation, unit: 'mm', format: 'a4' });

      window.scrollTo(500, 0);
      document.body.style.overflow = 'hidden';

      setTimeout(function () {
        if (self.isIOS) page = page + 1;

        var _loop = function _loop(i) {
          // self.pdf.current = 'page' + (i + 1)
          pageAsyncs.push(__WEBPACK_IMPORTED_MODULE_4_html2canvas___default()(document.getElementsByClassName('page' + (i + 1))[0], {
            scale: "1"
          }).then(function (canvas) {
            var imgData = canvas.toDataURL('image/jpeg', 1.0);
            pdf.addImage(imgData, 'JPEG', 0, 0);
            if (i + 1 !== page) {
              pdf.addPage();
            }
          }).catch(function (e) {
            self.reportStatus[type] = 'has-error';
            self.pdf.list.shift();
            document.body.style.overflow = 'auto';
            self.processDownloads('csv', { type: type });
            console.warn(e);
          }));
        };

        for (var i = 0; i < page; i++) {
          _loop(i);
        }
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(pageAsyncs).then(function () {
          var timestamp = start.format('YYYYMMDD') + '_' + end.format('YYYYMMDD');
          pdf.save(self.fileName(type, 'pdf'));
          self.reportStatus[type] = 'success';
          self.pdf.list.shift();
          document.body.style.overflow = 'auto';
          self.processDownloads('csv', { type: type });
        });
      }, 500);
    },
    covertNumber: function covertNumber(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    resetSelectedStatus: function resetSelectedStatus() {
      this.selectedReports = {
        completedRsvp: false,
        eventLogs: false
      };
    },
    resetReportStatus: function resetReportStatus() {
      this.error.show = false;
      this.error.empty = [];
      this.reportStatus = {
        completedRsvp: '',
        eventLogs: ''
      };
    },
    reportLabel: function reportLabel(type) {
      switch (type) {
        case 'completedRsvp':
          return 'Completed Reservations';
        case 'eventLogs':
          return 'Real-time Event Logs';
      }
    },
    buildCsvData: function buildCsvData(type, data) {
      var column = [];
      this.pdf.table.label.forEach(function (i) {
        column.push(i.replace('<br/>', ''));
      });
      this.csv.label = column;
      var csvData = {};
      var pdfData = this.buildTableData(type, data);
      var i = 0;
      for (var key in pdfData) {
        csvData[column[i]] = pdfData[key];
        i++;
      }
      return csvData;
    },
    processDownloads: function processDownloads(action, data) {
      if (action === 'pdf' && this.pdfChecked) {
        this.processPdf(data.type, data.page);
      } else if (action === 'csv' && this.csvChecked) {
        this.processCsv(data.type);
      } else {
        this.generateReport();
      }
    },
    processCsv: function processCsv(type) {
      var exporter = __WEBPACK_IMPORTED_MODULE_6_csvexport___default.a.create({
        filename: this.fileName(type, 'csv'),
        columns: this.csv.label
      });
      // add total
      this.csv.data.push(this.buildCsvTotal(type));
      exporter.downloadCsv(this.csv.data);
      this.reportStatus[type] = 'success';
      this.csv.list.shift();
      this.generateReport(true);
    },
    buildCsvTotal: function buildCsvTotal(type) {
      var csvData = {};
      // let totalData = this.pdf.table.total
      if (type === 'completedRsvp') {
        // csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')'
        // csvData[this.csv.label[1]] = totalData.drivers
        // csvData[this.csv.label[2]] = totalData.rsvp
        // csvData[this.csv.label[3]] = totalData.fare
        // csvData[this.csv.label[4]] = totalData.travelInsurance
        // csvData[this.csv.label[5]] = totalData.airportFee
        // csvData[this.csv.label[6]] = totalData.fareSum
        // csvData[this.csv.label[7]] = totalData.avgFare
        // csvData[this.csv.label[8]] = totalData.payment
        // csvData[this.csv.label[9]] = totalData.paymentPercent
        // csvData[this.csv.label[10]] = totalData.pickupFee
        // csvData[this.csv.label[11]] = totalData.gasFee
        // csvData[this.csv.label[12]] = totalData.tips
        // csvData[this.csv.label[13]] = totalData.bonus
        // csvData[this.csv.label[14]] = totalData.cancelFee
        // csvData[this.csv.label[15]] = totalData.extraFee
        // csvData[this.csv.label[16]] = totalData.percent
      }
      if (type === 'eventLogs') {
        // csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')'
        // csvData[this.csv.label[1]] = ''
        // csvData[this.csv.label[2]] = ''
        // csvData[this.csv.label[3]] = ''
        // csvData[this.csv.label[4]] = totalData.fare
        // csvData[this.csv.label[5]] = ''
        // csvData[this.csv.label[6]] = ''
        // csvData[this.csv.label[7]] = ''
        // csvData[this.csv.label[8]] = ''
      }
      return csvData;
    },
    formatCheck: function formatCheck() {
      this.error.show = false;
      this.formatError = false;
    },
    getGeoTrackingList: function getGeoTrackingList() {
      var self = this;
      self.geoTracking.loading = true;
      self.$sdk.get('/geofences/tracking', {
        token: self.$store.state.session.sessionToken,
        status: 'active',
        type: 'servicearea',
        orderAsc: 1,
        order: 'priority'
      }, function (r) {
        self.geoTracking.loading = false;
        if (!r.error) {
          self.geoTracking.list = [];
          r.list.forEach(function (g) {
            self.geoTracking.list.push({
              id: g.id,
              name: g.name
            });
          });
        }
      });
    }
  },
  watch: {
    show: function show(value) {
      if (!value) {
        return;
      }
      this.from = null;
      this.to = null;
      this.error.show = false;
      this.error.empty = [];
      this.resetSelectedStatus();
      this.resetReportStatus();
    },
    from: function from(value) {
      this.resetReportStatus();
    },
    to: function to(value) {
      this.resetReportStatus();
    },
    'selectedReports.completedRsvp': function selectedReportsCompletedRsvp() {
      this.resetReportStatus();
    },
    'selectedReports.eventLogs': function selectedReportsEventLogs() {
      this.resetReportStatus();
    }
  },
  mounted: function mounted() {
    this.getGeoTrackingList();
  }
});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_csvexport__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */

// import jsPDF from 'jspdf'
// import html2canvas from 'html2canvas'


// import featureToggle from '@/modules/api/featureToggle'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'active-driver-report',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default.a },
  data: function data() {
    return {
      from: null,
      to: null,
      driverType: 'tnc',
      error: {
        show: false,
        message: '',
        empty: []
      },
      selectedReports: {
        activeDrivers: true
      },
      reportStatus: {
        activeDrivers: ''
      },
      csv: {
        title: '',
        date: '',
        label: [],
        data: [],
        list: [],
        total: {},
        loading: false
      }
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.reports.rsvpReport.show;
    },
    highlightedDates: function highlightedDates() {
      var self = this;
      var result = { to: null, from: null };
      if (self.from !== null) {
        result.from = self.from;
      }
      if (self.to !== null) {
        result.to = self.to;
      }
      return result;
    }
  },
  methods: {
    isValid: function isValid() {
      var self = this;
      self.error.show = false;
      self.error.empty = [];
      if (self.from === null || self.to === null) {
        self.error.show = true;
        self.error.message = 'Please specify the Start and End dates.';
        return false;
      }

      var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.to);
      if (end.diff(start, 'days') > 30) {
        self.error.show = true;
        self.error.message = 'Cannot generate report more than 31 days.';
        return false;
      }

      if (!self.selectedReports.activeDrivers) {
        self.error.show = true;
        self.error.message = 'Please select at least one report type.';
        return false;
      }
      return true;
    },
    startProcess: function startProcess() {
      if (!this.isValid()) {
        return;
      }
      this.csv.list = [];
      for (var report in this.selectedReports) {
        if (this.selectedReports[report]) {
          this.reportStatus[report] = 'on-queue';
          this.csv.list.push(report);
        }
      }
      this.csv.loading = true;
      this.generateReport();
    },
    generateReport: function generateReport() {
      if (!this.csv.list.length) {
        this.csv.loading = false;
        return;
      }
      console.log('Processing:', this.csv.list[0]);
      this.getDataReports(this.csv.list[0]);
    },
    getDataReports: function getDataReports(type) {
      var self = this;
      self.reportStatus[type] = 'loading';
      self.$sdk.get(self.apiParams(type).url, self.apiParams(type).data, function (r) {
        // console.log('---', r)
        // return
        if (r.error) {
          self.reportStatus[type] = 'has-error';
          return;
        }
        self.setPdfLabel(type);
        // self.pdf.table.data = {}
        // self.pdf.table.extra = {}
        // self.pdf.table.total = {}
        self.csv.data = [];
        self.csv.total = {};
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(r.list).length > 0) {
          self.buildData(type, r.list);
        } else {
          self.error.show = true;
          self.error.empty.push(self.reportLabel(type));
          self.reportStatus[type] = 'has-error';
          self.csv.list.shift();
          self.generateReport();
        }
      });
    },
    apiParams: function apiParams(type) {
      var url = '';
      var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.to);
      var data = {
        token: this.$store.state.session.sessionToken,
        since: start.format('YYYY-MM-DD'),
        until: end.format('YYYY-MM-DD')
      };
      switch (type) {
        case 'activeDrivers':
          url = '/reports/activedrivers';
          data.licenseType = this.driverType;
          break;
      }
      return { url: url, data: data };
    },
    setPdfLabel: function setPdfLabel(type) {
      var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.to);
      var dateRange = start.format('MM/DD/YYYY') + ' - ' + end.format('MM/DD/YYYY');
      if (type === 'activeDrivers') {
        this.csv.title = 'Opoli Active Drivers Reports';
        this.csv.date = '(' + dateRange + ')';
        this.csv.label = ['ID', 'Vehicle Number', 'Email', 'Name', 'Availability', 'License'];

        end.add(1, 'days');
        for (var m = __WEBPACK_IMPORTED_MODULE_1_moment___default()(start); m.isBefore(end); m.add(1, 'days')) {
          this.csv.label.push(m.format('MM-DD-YYYY'));
        }
        this.csv.label.push('RSVP Completed');
        this.csv.label.push('RSVP No Show');
        this.csv.label.push('Driver Payment');
      }
    },
    buildData: function buildData(type, csvData) {
      var self = this;
      var totalPayment = 0;
      var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.to);
      end.add(1, 'days');

      for (var i in csvData) {
        var driverData = {
          ID: csvData[i].driverId,
          'Vehicle Number': csvData[i].driverNum,
          Email: csvData[i].email,
          Name: csvData[i].name,
          Availability: csvData[i].preferredTime,
          License: self.driverType
        };
        for (var m = __WEBPACK_IMPORTED_MODULE_1_moment___default()(start); m.isBefore(end); m.add(1, 'days')) {
          driverData[m.format('MM-DD-YYYY')] = csvData[i].days[m.format('YYYY-MM-DD')] || 0;
        }
        driverData['RSVP Completed'] = csvData[i].completed;
        driverData['RSVP No Show'] = csvData[i].noshow;
        driverData['Driver Payment'] = csvData[i].payout.toFixed(2);
        totalPayment += parseFloat(csvData[i].payout.toFixed(2)) || 0;
        self.csv.data.push(driverData);
      }
      self.csv.data.sort(function (a, b) {
        return a['RSVP Completed'] > b['RSVP Completed'] ? -1 : b['RSVP Completed'] > a['RSVP Completed'] ? 1 : 0;
      });
      self.csv.total.drivers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(csvData).length;
      self.csv.total.payment = totalPayment.toFixed(2);
      self.processCsv(type);
    },
    fileName: function fileName(type, format) {
      var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.to);
      var timestamp = start.format('YYYYMMDD') + '_' + end.format('YYYYMMDD');
      switch (type) {
        case 'activeDrivers':
          return 'reports-ActiveDrivers_' + timestamp + '.' + format;
      }
    },
    resetSelectedStatus: function resetSelectedStatus() {
      this.selectedReports = {
        activeDrivers: false
      };
    },
    resetReportStatus: function resetReportStatus() {
      this.error.show = false;
      this.error.empty = [];
      this.reportStatus = {
        activeDrivers: ''
      };
    },
    reportLabel: function reportLabel(type) {
      switch (type) {
        case 'activeDrivers':
          return 'Active Drivers Report';
      }
    },
    processDownloads: function processDownloads(action, data) {
      if (action === 'pdf' && this.pdfChecked) {
        this.processPdf(data.type, data.page);
      } else if (action === 'csv' && this.csvChecked) {
        this.processCsv(data.type);
      } else {
        this.generateReport();
      }
    },
    processCsv: function processCsv(type) {
      var exporter = __WEBPACK_IMPORTED_MODULE_3_csvexport___default.a.create({
        filename: this.fileName(type, 'csv'),
        columns: this.csv.label
      });
      // add total
      this.csv.data.push({});
      this.csv.data.push(this.buildCsvTotal(type));
      exporter.downloadCsv(this.csv.data);
      this.reportStatus[type] = 'success';
      this.csv.list.shift();
      this.generateReport(true);
    },
    buildCsvTotal: function buildCsvTotal(type) {
      var csvData = {};
      if (type === 'activeDrivers') {
        csvData[this.csv.label[0]] = '';
        csvData[this.csv.label[1]] = 'Total Drivers (' + this.csv.total.drivers + ')';
        csvData[this.csv.label[2]] = 'Total Driver Payment (' + this.csv.total.payment + ')';
        csvData[this.csv.label[3]] = '';
        csvData[this.csv.label[4]] = '';
        csvData[this.csv.label[5]] = '';
        csvData[this.csv.label[6]] = '';
        csvData[this.csv.label[7]] = '';
        csvData[this.csv.label[8]] = '';
      }
      return csvData;
    },
    formatCheck: function formatCheck() {
      this.error.show = false;
      this.formatError = false;
    }
  },
  watch: {
    show: function show(value) {
      if (!value) {
        return;
      }
      this.from = null;
      this.to = null;
      this.error.show = false;
      this.error.empty = [];
      this.resetSelectedStatus();
      this.resetReportStatus();
    },
    from: function from(value) {
      this.resetReportStatus();
    },
    to: function to(value) {
      this.resetReportStatus();
    },
    'selectedReports.activeDrivers': function selectedReportsActiveDrivers(value) {
      this.resetReportStatus();
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jspdf__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_html2canvas__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_csvexport__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */





// import featureToggle from '@/modules/api/featureToggle'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'driverCount-report',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default.a },
  data: function data() {
    return {
      from: null,
      to: null,
      error: {
        show: false,
        message: '',
        empty: []
      },
      selectedReports: {
        driverCount: true
      },
      reportStatus: {
        driverCount: ''
      },
      pdf: {
        code: '',
        class: '',
        title: '',
        date: '',
        table: {
          label: [],
          data: {},
          extra: {},
          total: {}
        },
        maxRecordPerPage: 40,
        list: [],
        current: '',
        loading: false
      },
      orientation: [],
      pdfChecked: true,
      csvChecked: false,
      formatError: false,
      csv: {
        label: [],
        data: [],
        list: [],
        total: {}
      },
      isIOS: navigator.userAgent.match(/(iPad|iPhone|iPod)/g)
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.reports.rsvpReport.show;
    },
    highlightedDates: function highlightedDates() {
      var self = this;
      var result = { to: null, from: null };
      if (self.from !== null) {
        result.from = self.from;
      }
      if (self.to !== null) {
        result.to = self.to;
      }
      return result;
    },
    totalPage: function totalPage() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.pdf.table.data).length;
    }
  },
  methods: {
    isValid: function isValid() {
      var self = this;
      self.error.show = false;
      self.error.empty = [];
      self.formatError = false;
      if (!self.pdfChecked && !self.csvChecked) {
        self.error.show = true;
        self.error.message = 'Please select which file format.';
        self.formatError = true;
        return false;
      }
      if (!self.selectedReports.driverCount) {
        self.error.show = true;
        self.error.message = 'Please select at least one report type.';
        return false;
      }
      return true;
    },
    getNewDoc: function getNewDoc() {
      var doc = new __WEBPACK_IMPORTED_MODULE_4_jspdf___default.a({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
      });
      doc.setFont('helvetica');
      return doc;
    },
    startProcess: function startProcess() {
      if (!this.isValid()) {
        return;
      }
      this.pdf.list = [];
      this.csv.list = [];
      for (var report in this.selectedReports) {
        if (this.selectedReports[report]) {
          this.reportStatus[report] = 'on-queue';
          this.pdf.list.push(report);
          this.csv.list.push(report);
        }
      }
      this.pdf.loading = true;
      this.generateReport();
    },
    generateReport: function generateReport() {
      var isCsv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if ((!this.pdf.list.length && this.pdfChecked || !this.pdfChecked) && (!this.csv.list.length && this.csvChecked || !this.csvChecked)) {
        this.pdf.loading = false;
        return;
      }
      if (isCsv) {
        console.log('Processing:', this.csv.list[0]);
        this.getDataReports(this.csv.list[0]);
      } else {
        console.log('Processing:', this.pdf.list[0]);
        this.getDataReports(this.pdf.list[0]);
      }
    },
    getDataReports: function getDataReports(type) {
      var self = this;
      self.reportStatus[type] = 'loading';
      var orientationMax = self.orientation;
      self.pdf.maxRecordPerPage = orientationMax.indexOf(type) > -1 ? 25 : 40;
      self.$sdk.get(self.apiParams(type).url, self.apiParams(type).data, function (r) {
        // console.log('---', r)
        // return
        if (r.error) {
          self.reportStatus[type] = 'has-error';
          return;
        }
        self.setPdfLabel(type);
        self.pdf.table.data = {};
        self.pdf.table.extra = {};
        self.pdf.table.total = {};
        self.csv.data = [];
        self.csv.total = {};
        if (r.list.length > 0) {
          self.buildPdfData(type, r.list);
        } else {
          self.error.show = true;
          self.error.empty.push(self.reportLabel(type));
          self.reportStatus[type] = 'has-error';
          self.pdf.list.shift();
          self.csv.list.shift();
          self.generateReport();
        }
      });
    },
    apiParams: function apiParams(type) {
      var url = '';
      var data = {
        token: this.$store.state.session.sessionToken
      };
      switch (type) {
        case 'driverCount':
          url = '/reports/vehicletype';
          break;
      }
      return { url: url, data: data };
    },
    setPdfLabel: function setPdfLabel(type) {
      var start = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.to);
      var dateRange = start.format('MM/DD/YYYY') + ' - ' + end.format('MM/DD/YYYY');
      this.pdf.code = type;
      if (type === 'driverCount') {
        this.pdf.class = 'report-drivercount';
        this.pdf.title = 'Opoli Driver Count Reports';
        this.pdf.table.label = ['Vehicle Type', 'TNC', 'TCP', 'Total'];
      }
    },
    buildPdfData: function buildPdfData(type, pdfData) {
      var self = this;
      var page = 1;

      if (type === 'driverCount') {
        self.buildDriverCountData(type, pdfData);
      } else {
        pdfData.forEach(function (data, index) {
          if (!self.pdf.table.data['page' + page]) {
            self.pdf.table.data['page' + page] = [];
          }
          self.pdf.table.data['page' + page].push(self.buildTableData(type, data));
          if (self.csvChecked) {
            self.csv.data.push(self.buildCsvData(type, data));
          }
          if ((index + 1) % self.pdf.maxRecordPerPage === 0 && pdfData.length !== index + 1) {
            page++;
          }
        });
        if (self.pdfChecked) {
          self.processDownloads('pdf', { type: type, page: page });
        } else {
          self.processDownloads('csv', { type: type });
        }
      }
    },
    buildDriverCountData: function buildDriverCountData(type, pdfData) {
      var self = this;
      var list = ['Sedan', 'Mini SUV', 'Minivan', 'Black Car', 'Black SUV', 'Limousine', 'Tesla 3', 'Tesla Y', 'Tesla S', 'Tesla X'];
      if (!self.pdf.table.data['page1']) {
        self.pdf.table.data['page1'] = [];
      }
      list.forEach(function (vehicle) {
        var match = pdfData.find(function (x) {
          return x.name === vehicle;
        });
        var tmpData = {
          name: vehicle,
          tnc: 0,
          tcp: 0,
          total: 0
        };
        if (match) {
          tmpData.tnc = parseInt(match.tnc);
          tmpData.tcp = parseInt(match.tcp);
          tmpData.total = tmpData.tnc + tmpData.tcp;
        }
        self.pdf.table.data['page1'].push(tmpData);
        if (self.csvChecked) {
          self.csv.data.push({
            'Vehicle Type': tmpData.name,
            'TNC': tmpData.tnc,
            'TCP': tmpData.tcp,
            'Total': tmpData.total
          });
        }
      });
      if (self.csvChecked) {
        var column = [];
        self.pdf.table.label.forEach(function (x) {
          column.push(x);
        });
        self.csv.label = column;
      }

      setTimeout(function () {
        if (self.pdfChecked) {
          self.processDownloads('pdf', { type: type, page: 1 });
        } else {
          self.processDownloads('csv', { type: type });
        }
      }, 1500);
    },
    buildTableData: function buildTableData(type, data) {
      if (type === 'driverCount') {
        return {
          vehicleType: data.providerId || '',
          tnc: data.providerName || 0,
          tcp: data.providerName || 0,
          total: data.providerName || 0
        };
      }
    },
    sourceLabel: function sourceLabel(x) {
      switch (x) {
        case 'ios':
          return 'CA';
        case 'android':
          return 'CA';
        case 'admin':
          return 'Admin';
        case 'CSR':
          return 'CSR';
        default:
          return 'Web';
      }
    },
    fileName: function fileName(type, format) {
      switch (type) {
        case 'driverCount':
          return 'reports-DriverCount.' + format;
      }
    },
    currentPage: function currentPage(page) {
      return page.substring(4);
    },
    processPdf: function processPdf(type, page) {
      var self = this;
      var start = __WEBPACK_IMPORTED_MODULE_3_moment___default()(self.from);
      var end = __WEBPACK_IMPORTED_MODULE_3_moment___default()(self.to);
      var pageAsyncs = [];
      var landscapeReports = self.orientation;
      var orientation = landscapeReports.indexOf(type) > -1 ? 'l' : 'p';
      var pdf = new __WEBPACK_IMPORTED_MODULE_4_jspdf___default.a({ orientation: orientation, unit: 'mm', format: 'a4' });
      window.scrollTo(500, 0);
      document.body.style.overflow = 'hidden';
      setTimeout(function () {
        if (self.isIOS) page = page + 1;

        var _loop = function _loop(i) {
          // self.pdf.current = 'page' + (i + 1)
          pageAsyncs.push(__WEBPACK_IMPORTED_MODULE_5_html2canvas___default()(document.getElementsByClassName('page' + (i + 1))[0], {
            scale: "1"
          }).then(function (canvas) {
            var imgData = canvas.toDataURL('image/jpeg', 1.0);
            pdf.addImage(imgData, 'JPEG', 0, 0);
            if (i + 1 !== page) {
              pdf.addPage();
            }
          }).catch(function (e) {
            self.reportStatus[type] = 'has-error';
            self.pdf.list.shift();
            document.body.style.overflow = 'auto';
            self.processDownloads('csv', { type: type });
            console.warn(e);
          }));
        };

        for (var i = 0; i < page; i++) {
          _loop(i);
        }
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(pageAsyncs).then(function () {
          var timestamp = start.format('YYYYMMDD') + '_' + end.format('YYYYMMDD');
          pdf.save(self.fileName(type, 'pdf'));
          self.reportStatus[type] = 'success';
          self.pdf.list.shift();
          document.body.style.overflow = 'auto';
          self.processDownloads('csv', { type: type });
        });
      }, 500);
    },
    covertNumber: function covertNumber(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    resetSelectedStatus: function resetSelectedStatus() {
      this.selectedReports = {
        driverCount: false
      };
    },
    resetReportStatus: function resetReportStatus() {
      this.error.show = false;
      this.error.empty = [];
      this.reportStatus = {
        driverCount: ''
      };
    },
    reportLabel: function reportLabel(type) {
      switch (type) {
        case 'driverCount':
          return 'Driver Count Report';
      }
    },
    buildCsvData: function buildCsvData(type, data) {
      var column = [];
      this.pdf.table.label.forEach(function (i) {
        column.push(i.replace(' ', ''));
      });
      this.csv.label = column;
      var csvData = {};
      var pdfData = this.buildTableData(type, data);
      var i = 0;
      for (var key in pdfData) {
        csvData[column[i]] = pdfData[key];
        i++;
      }
      return csvData;
    },
    processDownloads: function processDownloads(action, data) {
      if (action === 'pdf' && this.pdfChecked) {
        this.processPdf(data.type, data.page);
      } else if (action === 'csv' && this.csvChecked) {
        this.processCsv(data.type);
      } else {
        this.generateReport();
      }
    },
    processCsv: function processCsv(type) {
      var exporter = __WEBPACK_IMPORTED_MODULE_7_csvexport___default.a.create({
        filename: this.fileName(type, 'csv'),
        columns: this.csv.label
      });
      // add total
      if (type !== 'driverCount') {
        this.csv.data.push(this.buildCsvTotal(type));
      }
      this.csv.data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.csv.data));
      console.log('@@', JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.csv.data)));
      exporter.downloadCsv(this.csv.data);
      this.reportStatus[type] = 'success';
      this.csv.list.shift();
      this.generateReport(true);
    },
    buildCsvTotal: function buildCsvTotal(type) {
      var csvData = {};
      var totalData = this.pdf.table.total;
      if (type === 'driverCount') {
        csvData[this.csv.label[0]] = '';
        csvData[this.csv.label[1]] = '';
        csvData[this.csv.label[2]] = '';
        csvData[this.csv.label[3]] = '';
      }
      return csvData;
    },
    formatCheck: function formatCheck() {
      this.error.show = false;
      this.formatError = false;
    }
  },
  watch: {
    show: function show(value) {
      if (!value) {
        return;
      }
      // this.from = null
      // this.to = null
      this.error.show = false;
      this.error.empty = [];
      this.resetSelectedStatus();
      this.resetReportStatus();
    },

    // from (value) { this.resetReportStatus() },
    // to (value) { this.resetReportStatus() },
    'selectedReports.driverCount': function selectedReportsDriverCount(value) {
      this.resetReportStatus();
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jspdf__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_html2canvas__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_csvexport__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'trx-report',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_8_vuejs_datepicker___default.a },
  data: function data() {
    return {
      from: null,
      to: null,
      error: {
        show: false,
        message: '',
        empty: []
      },
      selectedReports: {
        lyftReport: true
      },
      reportStatus: {
        lyftReport: ''
      },
      pdf: {
        code: '',
        class: '',
        title: '',
        date: '',
        table: {
          label: [],
          data: {},
          extra: {},
          total: {}
        },
        maxRecordPerPage: 40,
        list: [],
        current: '',
        loading: false
      },
      orientation: ['lyftReport'],
      nonCompletedChecked: true,
      purchasedChecked: true,
      canceledChecked: true,
      pdfChecked: true,
      csvChecked: false,
      formatError: false,
      csv: {
        label: [],
        data: [],
        list: [],
        total: {}
      },
      isIOS: navigator.userAgent.match(/(iPad|iPhone|iPod)/g),
      totals: {
        lyft: {
          ptsOnly: 0,
          pts: 0,
          lyft: 0
        },
        farmout: {
          ptsOnly: 0,
          pts: 0,
          lyft: 0
        },
        manual: {
          ptsOnly: 0,
          pts: 0,
          lyft: 0
        }
      }
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.reports.rsvpReport.show;
    },
    highlightedDates: function highlightedDates() {
      var self = this;
      var result = { to: null, from: null };

      if (self.from !== null) {
        result.from = self.from;
      }
      if (self.to !== null) {
        result.to = self.to;
      }
      return result;
    },
    totalPage: function totalPage() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.pdf.table.data).length;
    },
    isLyftReport: function isLyftReport() {
      return this.pdf.code === 'lyftReport' && this.totalPage;
    }
  },
  methods: {
    isValid: function isValid() {
      var self = this;
      self.error.show = false;
      self.error.empty = [];
      if (self.from === null || self.to === null) {
        self.error.show = true;
        self.error.message = 'Please specify the Start and End dates.';
        return false;
      }

      var from = __WEBPACK_IMPORTED_MODULE_5_moment___default()(self.from);
      var to = __WEBPACK_IMPORTED_MODULE_5_moment___default()(self.to);

      if (from.isAfter(to)) {
        self.error.show = true;
        self.error.message = 'End date must be after Start date.';
        return false;
      }

      self.formatError = false;
      if (!self.pdfChecked && !self.csvChecked) {
        self.error.show = true;
        self.error.message = 'Please select which file format.';
        self.formatError = true;
        return false;
      }

      if (!self.selectedReports.lyftReport) {
        self.error.show = true;
        self.error.message = 'Please select at least one report type.';
        return false;
      }

      return true;
    },
    getNewDoc: function getNewDoc() {
      var doc = new __WEBPACK_IMPORTED_MODULE_6_jspdf___default.a({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
      });
      doc.setFont('helvetica');
      return doc;
    },
    startProcess: function startProcess() {
      if (!this.isValid()) {
        return;
      }

      this.pdf.list = [];
      this.csv.list = [];
      for (var report in this.selectedReports) {
        if (this.selectedReports[report]) {
          this.reportStatus[report] = 'on-queue';
          this.pdf.list.push(report);
          this.csv.list.push(report);
        }
      }

      this.totals = {
        lyft: {
          ptsOnly: 0,
          pts: 0,
          lyft: 0
        },
        farmout: {
          ptsOnly: 0,
          pts: 0,
          lyft: 0
        },
        manual: {
          ptsOnly: 0,
          pts: 0,
          lyft: 0
        }
      };

      this.pdf.loading = true;
      this.generateReport();
    },
    generateReport: function generateReport() {
      var isCsv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if ((!this.pdf.list.length && this.pdfChecked || !this.pdfChecked) && (!this.csv.list.length && this.csvChecked || !this.csvChecked)) {
        this.pdf.loading = false;
        return;
      }

      if (isCsv) {
        console.log('Processing:', this.csv.list[0]);
        this.getDataReports(this.csv.list[0]);
      } else {
        console.log('Processing:', this.pdf.list[0]);
        this.getDataReports(this.pdf.list[0]);
      }
    },
    getDataReports: function getDataReports(type) {
      var self = this;
      self.reportStatus[type] = 'loading';
      var orientationMax = self.orientation;
      self.pdf.maxRecordPerPage = orientationMax.indexOf(type) > -1 ? 25 : 40;
      self.$sdk.get(self.apiParams(type).url, self.apiParams(type).data, function (r) {
        if (r.error) {
          self.reportStatus[type] = 'has-error';
          return;
        }

        self.setPdfLabel(type);
        self.pdf.table.data = {};
        self.pdf.table.extra = {};
        self.pdf.table.total = {};
        self.csv.data = [];
        self.csv.total = {};

        if (r.list.length > 0) {
          self.buildPdfData(type, r.list);
        } else {
          self.error.show = true;
          self.error.empty.push(self.reportLabel(type));
          self.reportStatus[type] = 'has-error';
          self.pdf.list.shift();
          self.csv.list.shift();
          self.generateReport();
        }
      });
    },
    apiParams: function apiParams(type) {
      /*
        -----   Refference   -----
        lyftReport          NEW
      */

      var url = '';
      var start = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.to);
      var data = {
        token: this.$store.state.session.sessionToken,
        since: start.format('YYYY-MM-DD'),
        until: end.format('YYYY-MM-DD')
      };

      switch (type) {
        case 'lyftReport':
          url = '/reports/lyft/summary';
          break;
      }

      return { url: url, data: data };
    },
    setPdfLabel: function setPdfLabel(type) {
      var start = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.from);
      var end = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.to);
      var dateRange = start.format('MM/DD/YYYY') + ' - ' + end.format('MM/DD/YYYY');

      this.pdf.code = type;
      if (type === 'lyftReport') {
        this.pdf.class = 'trx-summary';
        this.pdf.title = 'Lyft Report';
        this.pdf.date = dateRange;
        this.pdf.table.label = ['Pickup Date/Time', 'RSVP ID', 'Type', 'Brand', 'Amount', 'Lyft Price', 'Pickup', 'Dropoff', 'Source'];
      }
    },
    buildPdfData: function buildPdfData(type, pdfData) {
      var self = this;
      var groupCount = 0;
      var page = 1;

      // lyftReport
      var totalRsvp = 0;
      var totalAmount = 0;
      var totalLyftPrice = 0;
      var totalAmountLyft = 0;
      var totalAmountFarmout = 0;
      var totalAmountManual = 0;
      var totalDeviceType = {};
      var totalType = {};
      var totalBrand = {};

      totalRsvp = pdfData.length;

      if (type === 'lyftReport') {
        pdfData.sort(function (a, b) {
          return a.pickupTime - b.pickupTime;
        });
      }

      pdfData.forEach(function (data, index) {
        if (!self.pdf.table.data['page' + page]) {
          self.pdf.table.data['page' + page] = [];
        }

        self.pdf.table.data['page' + page].push(self.buildTableData(type, data));
        if (self.csvChecked) {
          self.csv.data.push(self.buildCsvData(type, data));
        }
        groupCount++;

        if (type === 'lyftReport') {
          data.amount = parseFloat(data.amount);
          if (!totalDeviceType[data.type]) totalDeviceType[data.type] = {};
          if (!totalDeviceType[data.type][data.deviceType]) totalDeviceType[data.type][data.deviceType] = 0;
          totalDeviceType[data.type][data.deviceType]++;

          if (!totalType[data.type]) totalType[data.type] = 0;
          totalType[data.type]++;

          if (data.type === 'lyft') {
            totalAmountLyft += parseFloat(data.amount.toFixed(2));
            if (!data.lyftPrice) {
              self.totals.lyft.ptsOnly += parseFloat(data.amount.toFixed(2));
            } else {
              self.totals.lyft.pts += parseFloat(data.amount.toFixed(2));
              self.totals.lyft.lyft += parseFloat(data.lyftPrice.toFixed(2));
            }
            self.totals.lyft.ptsOnly = parseFloat(self.totals.lyft.ptsOnly.toFixed(2));
            self.totals.lyft.pts = parseFloat(self.totals.lyft.pts.toFixed(2));
            self.totals.lyft.lyft = parseFloat(self.totals.lyft.lyft.toFixed(2));
          }
          if (data.type === 'farmout') {
            totalAmountFarmout += parseFloat(data.amount.toFixed(2));
            if (!data.lyftPrice) {
              self.totals.farmout.ptsOnly += parseFloat(data.amount.toFixed(2));
            } else {
              self.totals.farmout.pts += parseFloat(data.amount.toFixed(2));
              self.totals.farmout.lyft += parseFloat(data.lyftPrice.toFixed(2));
            }
            self.totals.farmout.ptsOnly = parseFloat(self.totals.farmout.ptsOnly.toFixed(2));
            self.totals.farmout.pts = parseFloat(self.totals.farmout.pts.toFixed(2));
            self.totals.farmout.lyft = parseFloat(self.totals.farmout.lyft.toFixed(2));
          }
          if (data.type === 'manual') {
            totalAmountManual += parseFloat(data.amount.toFixed(2));
            if (!data.lyftPrice) {
              self.totals.manual.ptsOnly += parseFloat(data.amount.toFixed(2));
            } else {
              self.totals.manual.pts += parseFloat(data.amount.toFixed(2));
              self.totals.manual.lyft += parseFloat(data.lyftPrice.toFixed(2));
            }
            self.totals.manual.ptsOnly = parseFloat(self.totals.manual.ptsOnly.toFixed(2));
            self.totals.manual.pts = parseFloat(self.totals.manual.pts.toFixed(2));
            self.totals.manual.lyft = parseFloat(self.totals.manual.lyft.toFixed(2));
          }

          if (!totalBrand[data.type]) totalBrand[data.type] = {};
          if (!totalBrand[data.type][self.brandName(data.brandId)]) totalBrand[data.type][self.brandName(data.brandId)] = 0;
          totalBrand[data.type][self.brandName(data.brandId)]++;

          if (data.amount) totalAmount += parseFloat(data.amount.toFixed(2));
          if (data.lyftPrice) totalLyftPrice += parseFloat(data.lyftPrice.toFixed(2));
        }

        if ((index + 1) % self.pdf.maxRecordPerPage === 0 && pdfData.length !== index + 1) {
          page++;
        }
      });

      self.pdf.table.total.record = pdfData.length;
      if (type === 'lyftReport') {
        self.pdf.table.total.rsvp = self.covertNumber(totalRsvp);
        self.pdf.table.total.type = totalType;
        self.pdf.table.total.deviceType = totalDeviceType;
        self.pdf.table.total.brand = totalBrand;
        self.pdf.table.total.amount = parseFloat(totalAmount.toFixed(2));
        self.pdf.table.total.lyftPrice = parseFloat(totalLyftPrice.toFixed(2));
        self.pdf.table.total.amountLyft = parseFloat(totalAmountLyft.toFixed(2));
        self.pdf.table.total.amountFarmout = parseFloat(totalAmountFarmout.toFixed(2));
        self.pdf.table.total.amountManual = parseFloat(totalAmountManual.toFixed(2));
      }

      if (self.pdfChecked) {
        self.processDownloads('pdf', { type: type, page: page });
      } else {
        self.processDownloads('csv', { type: type });
      }
      // self.processPdf(type, page)
    },
    buildTableData: function buildTableData(type, data) {
      var self = this;
      if (type === 'lyftReport') {
        // let netTotal = parseFloat(data.chargedAmount) - parseFloat(data.refundAmount)
        data.amount = parseFloat(data.amount);
        return {
          date: __WEBPACK_IMPORTED_MODULE_5_moment___default()(data.pickupTime, 'X').format('MM/DD/YYYY hh:mmA'),
          rsvpId: data.rsvpId,
          type: data.type,
          brand: self.brandName(data.brandId),
          amount: data.amount ? parseFloat(data.amount.toFixed(2)) : 0,
          lyftPrice: data.lyftPrice ? parseFloat(data.lyftPrice.toFixed(2)) : 'N/A',
          pickup: data.pickup,
          dropoff: data.dropoff,
          source: self.sourceLabel(data.deviceType)
          // rideId: data.rideId
        };
      }
    },
    fileName: function fileName(type, format) {
      var timestamp = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.from).format('YYYYMMDD') + '_' + __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.to).format('YYYYMMDD');
      switch (type) {
        case 'lyftReport':
          return 'lyftReport_' + timestamp + '.' + format;
      }
    },
    currentPage: function currentPage(page) {
      return page.substring(4);
    },
    processPdf: function processPdf(type, page) {
      var self = this;
      var start = __WEBPACK_IMPORTED_MODULE_5_moment___default()(self.from);
      var end = __WEBPACK_IMPORTED_MODULE_5_moment___default()(self.to);
      var pageAsyncs = [];
      var landscapeReports = self.orientation;
      var orientation = landscapeReports.indexOf(type) > -1 ? 'l' : 'p';
      var pdf = new __WEBPACK_IMPORTED_MODULE_6_jspdf___default.a({ orientation: orientation, unit: 'mm', format: 'a4' });

      window.scrollTo(500, 0);
      document.body.style.overflow = 'hidden';

      if (type === 'lyftReport') {
        page++;
      }

      setTimeout(function () {
        // if (self.isIOS) page = page + 1
        // for (let i = 0; i < page; i++) {
        //   // self.pdf.current = 'page' + (i + 1)
        //   pageAsyncs.push(html2canvas(document.getElementsByClassName('page' + (i + 1))[0], {
        //     scale: "1"
        //   }).then(canvas => {
        //     let imgData = canvas.toDataURL('image/png', 1.0)
        //     pdf.addImage(imgData, 'PNG', 0, 0)
        //     if (i + 1 !== page) { pdf.addPage() }
        //   }).catch(e => {
        //     self.reportStatus[type] = 'has-error'
        //     self.pdf.list.shift()
        //     document.body.style.overflow = 'auto'
        //     self.processDownloads('csv', {type: type})
        //     console.warn(e)
        //   }))
        // }

        var i = 0;
        var buildPdfPages = function buildPdfPages(i) {
          if (i + 1 > page) {
            downloadPdfPages();
            return;
          }
          pageAsyncs.push(__WEBPACK_IMPORTED_MODULE_7_html2canvas___default()(document.getElementsByClassName('page' + (i + 1))[0], {
            scale: "1"
          }).then(function (canvas) {
            var imgData = canvas.toDataURL('image/jpeg', 1.0);
            pdf.addImage(imgData, 'JPEG', 0, 0);
            if (i + 1 <= page) {
              pdf.addPage();
              buildPdfPages(i + 1);
            }
          }).catch(function (e) {
            self.reportStatus[type] = 'has-error';
            self.pdf.list.shift();
            document.body.style.overflow = 'auto';
            self.processDownloads('csv', { type: type });
            console.warn(e);
          }));
        };
        buildPdfPages(0);

        var downloadPdfPages = function downloadPdfPages() {
          pdf.save(self.fileName(type, 'pdf'));
          self.reportStatus[type] = 'success';
          self.pdf.list.shift();
          document.body.style.overflow = 'auto';
          self.processDownloads('csv', { type: type });
        };

        // Promise.all(pageAsyncs).then(() => {
        //   let timestamp = start.format('YYYYMMDD') + '_' + end.format('YYYYMMDD')
        //   pdf.save(self.fileName(type, 'pdf'))
        //   self.reportStatus[type] = 'success'
        //   self.pdf.list.shift()
        //   document.body.style.overflow = 'auto'
        //   self.processDownloads('csv', {type: type})
        // })
      }, 500);
    },
    covertNumber: function covertNumber(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    resetSelectedStatus: function resetSelectedStatus() {
      this.selectedReports = { lyftReport: false };
    },
    resetReportStatus: function resetReportStatus() {
      this.error.show = false;
      this.error.empty = [];
      this.reportStatus = { lyftReport: '' };
    },
    reportLabel: function reportLabel(type) {
      switch (type) {
        case 'lyftReport':
          return 'Lyft Report';
      }
    },
    buildCsvData: function buildCsvData(type, data) {
      var column = [];
      this.pdf.table.label.forEach(function (i) {
        column.push(i.replace('<br/>', ''));
      });
      this.csv.label = column;

      var csvData = {};
      var pdfData = this.buildTableData(type, data);

      var i = 0;
      for (var key in pdfData) {
        csvData[column[i]] = pdfData[key];
        i++;
      }
      return csvData;
    },
    processDownloads: function processDownloads(action, data) {
      if (action === 'pdf' && this.pdfChecked) {
        this.processPdf(data.type, data.page);
      } else if (action === 'csv' && this.csvChecked) {
        this.processCsv(data.type);
      } else {
        this.generateReport();
      }
    },
    processCsv: function processCsv(type) {
      var exporter = __WEBPACK_IMPORTED_MODULE_9_csvexport___default.a.create({
        filename: this.fileName(type, 'csv'),
        columns: this.csv.label
      });

      // add total
      if (type === 'lyftReport') {
        var _csv$data;

        (_csv$data = this.csv.data).push.apply(_csv$data, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.buildCsvTotal(type)));
      } else {
        this.csv.data.push(this.buildCsvTotal(type));
      }

      exporter.downloadCsv(this.csv.data);
      this.reportStatus[type] = 'success';
      this.csv.list.shift();

      this.generateReport(true);
    },
    buildCsvTotal: function buildCsvTotal(type) {
      var self = this;
      var csvData = {};
      var totalData = this.pdf.table.total;

      if (type === 'lyftReport') {
        csvData = [];

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(totalData.type)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

            var key = _ref2[0];
            var value = _ref2[1];

            var i = 0;
            var row = {};
            csvData.push({});
            row[this.csv.label[i]] = key + ' (' + value + ')';
            var tmpAmount = {};
            if (key === 'lyft') {
              // row[this.csv.label[1]] = `Total Lyft Amount: $${totalData.amountLyft}`
              row[this.csv.label[1]] = 'Primetime Total: $' + (self.totals.lyft.pts + self.totals.lyft.ptsOnly).toFixed(2);
              row[this.csv.label[2]] = 'Lyft Total: $' + self.totals.lyft.lyft;
              row[this.csv.label[3]] = 'Margin: $' + (self.totals.lyft.pts + self.totals.lyft.ptsOnly - self.totals.lyft.lyft).toFixed(2);
              csvData.push(row);
              row = {};
            }
            if (key === 'farmout') {
              // row[this.csv.label[1]] = `Total Farm out Amount: $${totalData.amountFarmout}`
              row[this.csv.label[1]] = 'Primetime Total: $' + (self.totals.farmout.pts + self.totals.farmout.ptsOnly).toFixed(2);
              row[this.csv.label[2]] = 'Lyft Total: $' + self.totals.farmout.lyft;
              row[this.csv.label[3]] = 'Margin: $' + (self.totals.farmout.pts + self.totals.farmout.ptsOnly - self.totals.farmout.lyft).toFixed(2);
              csvData.push(row);
              row = {};
            }
            if (key === 'manual') {
              // row[this.csv.label[1]] = `Total Manual Amount: $${totalData.amountManual}`
              row[this.csv.label[1]] = 'Primetime Total: $' + (self.totals.manual.pts + self.totals.manual.ptsOnly).toFixed(2);
              row[this.csv.label[2]] = 'Lyft Total: $' + self.totals.manual.lyft;
              row[this.csv.label[3]] = 'Margin: $' + (self.totals.manual.pts + self.totals.manual.ptsOnly - self.totals.manual.lyft).toFixed(2);
              csvData.push(row);
              row = {};
            }
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(totalData.deviceType[key])), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _ref3 = _step2.value;

                var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

                var key2 = _ref4[0];
                var value2 = _ref4[1];

                i++;
                row[this.csv.label[i]] = key2 + ': ' + value2;
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            csvData.push(row);

            var brandX = 1;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(totalData.brand[key])), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var _ref5 = _step3.value;

                var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);

                var key3 = _ref6[0];
                var value3 = _ref6[1];

                var brandRow = {};
                brandRow[this.csv.label[0]] = '';
                brandRow[this.csv.label[1]] = key3 + ' (' + value3 + ')';
                csvData.push(brandRow);
                brandX++;
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var csvRow1 = {};
        csvRow1[this.csv.label[0]] = 'Total (' + totalData.rsvp + ')';
        csvRow1[this.csv.label[1]] = 'Primetime Total $' + totalData.amount;
        csvRow1[this.csv.label[2]] = 'Lyft Total -$' + totalData.lyftPrice;
        csvRow1[this.csv.label[3]] = 'Total Margin $' + (parseFloat(totalData.amount) - parseFloat(totalData.lyftPrice)).toFixed(2);
        csvData.push(csvRow1);
      }

      return csvData;
      // this.pdf.table.total
    },
    formatCheck: function formatCheck() {
      this.error.show = false;
      this.formatError = false;
    },
    brandName: function brandName(brandId) {
      var i = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.findIndex(function (x) {
        return x.id === brandId;
      });
      if (i === -1) {
        return brandId;
      }

      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[i].name;
    },
    sourceLabel: function sourceLabel(x) {
      if (x === 'ww') return 'web';
      return x;
    }
  },
  watch: {
    show: function show(value) {
      if (!value) {
        return;
      }

      this.from = null;
      this.to = null;
      this.error.show = false;
      this.error.empty = [];

      this.resetSelectedStatus();
      this.resetReportStatus();
    },
    from: function from(value) {
      this.resetReportStatus();
    },
    to: function to(value) {
      this.resetReportStatus();
    },
    'selectedReports.lyftReport': function selectedReportsLyftReport(value) {
      this.resetReportStatus();
    }
  }
});

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'import-rsvp',
  data: function data() {
    return {
      brand: '',
      brandLoading: false,
      serviceMapping: '',
      serviceMappingValues: [],
      source: '',
      uploading: false,
      fileUrl: '',
      fileError: '',
      buttonLabel: 'Submit',
      rsvps: {
        list: [],
        processing: []
      },
      processing: false,
      processCount: 1,
      rsvpStatus: {
        success: [1, 2, 3],
        onGoing: [5, 7, 8],
        failed: [4, 6]
      },
      rsvpErrors: [],
      validation: {
        brand: ''
      },
      submitLoading: false,
      processLoading: false,
      forceStop: false
    };
  },

  computed: {
    brands: function brands() {
      return this.$store.state.brands.list;
    },
    isStaging: function isStaging() {
      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.Env !== 'production';
    }
  },
  methods: {
    getBrands: function getBrands() {
      var self = this;
      self.brandLoading = true;
      self.$sdk.get('/import/mappings', { token: self.$store.state.session.sessionToken }, function (res) {
        self.brandLoading = false;
        if (res.error) {
          return;
        }

        if (res.list.length) {
          self.serviceMappingValues = res.list;
          // self.$store.commit('brands/setList', res)
        }
      }, '2.0');
    },
    upload: function upload() {
      var self = this;
      if (self.validate() || self.uploading) {
        return;
      }

      self.buttonLabel = 'Uploading CSV...';
      self.uploading = true;

      var file = self.$refs.uploadInput.files[0];
      var fd = new FormData();
      fd.append('pic', file);

      self.fileUrl = '';
      self.$http.post({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.mediaHost + '/api/upload', fd, {
        header: { 'Content-Type': 'multipart/form-data' }
      }).then(function (res) {
        this.uploading = false;
        if (!res.body.success) {
          self.buttonLabel = 'Submit';
          // self.$store.commit('provider/showUploadError', true)
        } else {
          self.buttonLabel = 'Processing reservations...';
          self.fileUrl = res.body.data.url;
          self.submitData();
        }
      }, function (res) {
        console.log('error', res);
        // self.$store.commit('provider/showUploadError', true)
      });
    },
    validate: function validate() {
      var self = this;
      var hasError = false;
      // for (let field in self.validation) {
      //   self.validation[field] = ''
      //   if (self[field] === '') {
      //     self.validation[field] = 'This field cannot be empty.'
      //     hasError = true
      //   }
      // }

      if (!self.$refs.uploadInput.files.length) {
        this.fileError = 'Missing CSV file.';
        hasError = true;
      }

      return hasError;
    },
    submitData: function submitData() {
      var self = this;
      if (self.submitLoading || self.processLoading) {
        return;
      }
      self.submitLoading = true;
      self.rsvpStatus = { success: [], onGoing: [], failed: [] };
      self.processCount = 1;

      if (!self.serviceMapping) {
        self.brand = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.Env === 'production' ? 2 : 8;
      } else if (self.serviceMapping === 'qa-test') {
        self.brand = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.Env === 'production' ? 4 : 12;
      } else {
        var serviceIndex = self.serviceMappingValues.findIndex(function (x) {
          return x.key === self.serviceMapping;
        });
        console.log(serviceIndex, self.serviceMapping);
        self.brand = self.serviceMappingValues[serviceIndex].brandId;
      }

      self.$sdk.post('/import', {
        token: self.$store.state.session.sessionToken,
        csvUrl: self.fileUrl,
        brandId: self.brand,
        source: self.source,
        serviceMapping: self.serviceMapping
      }, function (res) {
        console.log('-', res);
        self.submitLoading = false;
        self.rsvps = {
          list: [],
          processing: []
        };
        if (!res.error) {
          if (res.list.length) {
            res.list.forEach(function (data) {
              self.rsvps.list.push({
                id: data.id,
                data: data.data
              });
              self.rsvps.processing.push(data.id);
            });
            setTimeout(function () {
              self.processLoading = true;
              self.beginCreateRsvp();
            }, 600);
          }
        } else {
          self.buttonLabel = 'Submit';
        }
      }, '2.0');
    },
    beginCreateRsvp: function beginCreateRsvp() {
      var self = this;
      if (!self.rsvps.processing.length || self.forceStop) {
        self.processLoading = false;
        self.processing = false;
        self.buttonLabel = 'Submit';

        if (self.forceStop) {
          self.forceStop = false;
        }
        return;
      }
      self.processing = true;

      var loopCount = self.rsvps.processing.length <= self.processCount ? self.rsvps.processing.length : self.processCount;
      for (var x = 0; x < loopCount; x++) {
        if (self.rsvps.processing.length) {
          self.createRsvp(self.rsvps.processing[0], false);
          self.rsvps.processing.shift();
          self.processCount--;
        }
      }

      // setTimeout(function () {
      //   self.beginCreateRsvp()
      // }, 300)
    },
    createRsvp: function createRsvp(id, isManual) {
      var self = this;

      var failedIndex = self.rsvpStatus.failed.indexOf(id);
      if (failedIndex > -1) {
        self.rsvpStatus.failed.splice(failedIndex, 1);
      }
      self.rsvpStatus.onGoing.push(id);

      self.$sdk.post('/import/' + id, { token: self.$store.state.session.sessionToken }, function (res) {
        var onGoingIndex = self.rsvpStatus.onGoing.indexOf(id);
        if (onGoingIndex > -1) {
          self.rsvpStatus.onGoing.splice(onGoingIndex, 1);
        }

        if (!res.error) {
          self.rsvpStatus.success.push(id);
          var rsvpIndex = self.rsvps.list.findIndex(function (x) {
            return x.id === id;
          });
          if (rsvpIndex > -1) {
            self.rsvps.list[rsvpIndex].rsvpId = res.reservationId;
          }
        } else {
          var debug = '';
          if (res.error.message === 'Request is not valid') {
            debug = 'Invalid fields: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(res.error.fields).join(', ');
          } else if (res.error.debug && typeof res.error.debug === 'string') {
            debug = res.error.debug;
          }
          self.rsvpErrors.push({
            id: id,
            msg: res.error.message,
            debug: debug
          });
          self.rsvpStatus.failed.push(id);
        }

        if (!isManual) {
          self.processCount++;
          self.beginCreateRsvp();
        }
      }, '2.0');
    },
    errorMessage: function errorMessage(id) {
      var index = this.rsvpErrors.findIndex(function (x) {
        return x.id === id;
      });
      return index > -1 ? this.rsvpErrors[index] : { msg: '', debug: '' };
    },
    pauseProcess: function pauseProcess() {
      this.forceStop = true;
      this.processing = false;
    }
  },
  mounted: function mounted() {
    this.getBrands();
  }
});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Services__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Logs__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PricingSettings__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CharterPricing__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Rental__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_api_pricing_service_area__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_api_brands__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_api_pricing_service_types__ = __webpack_require__(110);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */
// import moment from 'moment'









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pricing',
  components: { Services: __WEBPACK_IMPORTED_MODULE_1__Services__["a" /* default */], Logs: __WEBPACK_IMPORTED_MODULE_2__Logs__["a" /* default */], PricingSettings: __WEBPACK_IMPORTED_MODULE_3__PricingSettings__["a" /* default */], CharterPricing: __WEBPACK_IMPORTED_MODULE_4__CharterPricing__["a" /* default */], Rental: __WEBPACK_IMPORTED_MODULE_5__Rental__["a" /* default */] },
  data: function data() {
    return {
      searchInput: '',
      activeServiceArea: '',
      activeTab: 0,
      brandLoading: false,
      transitionRightPanel: false,
      global: {
        modal: false,
        selectedServiceArea: [],
        saving: false,
        status: '',
        message: '',
        extra: ''
      },
      responseModal: {
        show: false,
        status: '',
        message: '',
        extra: ''
      },
      priceSettingsShow: true,
      isMobileClickable: false,
      brand: {
        color: '',
        name: ''
      },
      isMobile: false,
      isMTechPricing: false
      // selectedBrand: this.$plugins.storage.getBrandInPricing() || CONFIG.default.brandId
    };
  },

  computed: {
    pricing: function pricing() {
      return this.$store.state.pricing;
    },
    isClickable: function isClickable() {
      return this.pricing.serviceTypes.isClickable;
    },
    brands: function brands() {
      return this.$store.state.brands.list;
    },

    selectedBrand: {
      get: function get() {
        return this.$store.state.pricing.brandId;
      },
      set: function set(value) {
        this.transitionRightPanel = false;
        this.activeServiceArea = '';
        this.$plugins.storage.setBrandInPricing(value);
        this.$store.commit('pricing/setBrandId', value);
        this.getServiceAreaList();
        this.getServiceTypes();
        this.$store.commit('pricing/setLogsData', { show: false });
      }
    },
    serviceArea: function serviceArea() {
      var self = this;
      return this.$store.state.pricing.serviceArea.list.filter(function (serviceArea) {
        var name = serviceArea.name.toLowerCase();
        return name.search(self.searchInput.toLowerCase()) > -1;
      });
    },
    completeServiceArea: function completeServiceArea() {
      return this.pricing.serviceArea.list;
    },
    loading: function loading() {
      return this.pricing.serviceArea.isLoading;
    },
    serviceTypeLoading: function serviceTypeLoading() {
      return this.pricing.serviceTypes.isLoading;
    },

    currentPage: {
      get: function get() {
        return this.$store.state.pricing.serviceArea.currentPage;
      },
      set: function set(value) {
        this.$store.commit('pricing/setUserCurrentPage', parseInt(value));
        this.loadList();
      }
    },
    isLastPage: function isLastPage() {
      var pricing = this.$store.state.pricing.serviceArea;
      return pricing.currentPage * pricing.perPage >= pricing.maxList;
    },
    totalPage: function totalPage() {
      var pricing = this.$store.state.pricing.serviceArea;
      return Math.ceil(pricing.maxList / pricing.perPage);
    },
    promoShow: function promoShow() {
      return this.pricing.promo.show;
    },
    saving: function saving() {
      return this.pricing.saving;
    },
    _selectedServiceArea: function _selectedServiceArea() {
      return this.pricing.serviceArea.activeId;
    },
    isServiceNonGlobal: function isServiceNonGlobal() {
      return this._selectedServiceArea !== 0 && this.activeTab === 0;
    },
    logs: function logs() {
      return this.pricing.logs;
    },
    logsIcon: function logsIcon() {
      return !this.logs.show ? 'fa fa-clipboard-list fa-2x' : 'fas fa-times fa-2x';
    }
  },
  methods: {
    // getBrand (e) {
    // let id = e.target.value
    // this.transitionRightPanel = false
    // this.activeServiceArea = ''
    // this.$plugins.storage.setBrandInPricing(id)
    // this.$store.commit('pricing/setBrandId', id)
    // this.getServiceAreaList()
    // this.getServiceTypes()
    // },
    mobileShowTab: function mobileShowTab(tab) {
      if (this.activeTab === tab || tab == 4) {
        this.isMobileClickable = false;
        this.activeServiceArea = '';
        this.$store.commit('pricing/setServiceAreaActiveId', '');
        this.transitionRightPanel = false;
      }
      this.activeTab = tab;
    },
    getBrandsList: function getBrandsList() {
      var self = this;
      if (self.$store.state.brands.list.length) {
        self.getServiceAreaList();
        return;
      }

      self.brandLoading = true;
      __WEBPACK_IMPORTED_MODULE_7__modules_api_brands__["a" /* default */].getBrands(self, function (res) {
        self.brandLoading = false;
        self.getServiceAreaList();
      });
    },
    getServiceAreaList: function getServiceAreaList() {
      var self = this;
      if (self.loading) {
        return;
      }

      self.$store.commit('pricing/setServiceAreaIsLoading', true);
      self.$store.commit('pricing/clearServiceAreaList');
      __WEBPACK_IMPORTED_MODULE_6__modules_api_pricing_service_area__["a" /* default */].getList(self, function (res) {
        self.$store.commit('pricing/setServiceAreaIsLoading', false);
        self.getServiceTypes();
      });
    },
    getServiceTypes: function getServiceTypes() {
      var self = this;
      if (self.serviceTypeLoading) {
        return;
      }

      self.$store.commit('pricing/setServiceTypesIsloading', true);
      __WEBPACK_IMPORTED_MODULE_8__modules_api_pricing_service_types__["a" /* default */].getAllService(self, function (r) {
        self.$store.commit('pricing/setServiceTypesIsloading', false);
      });
    },
    prev: function prev() {
      if (this.currentPage === 1) {
        return;
      }
      this.$store.commit('pricing/setServiceAreaCurrentPage', this.$store.state.pricing.serviceArea.currentPage - 1);
      this.getServiceAreaList();
    },
    next: function next() {
      if (this.isLastPage) {
        return;
      }
      this.$store.commit('pricing/setServiceAreaCurrentPage', this.$store.state.pricing.serviceArea.currentPage + 1);
      this.getServiceAreaList();
    },
    selectServiceArea: function selectServiceArea(id) {
      var _this = this;

      var self = this;
      self.brand.name = id.name;
      self.brand.color = id.color;
      if (id != 0) id = id.id;
      self.isMobileClickable = true;
      self.activeServiceArea = id;
      self.transitionRightPanel = false;
      self.$store.commit('pricing/setServiceAreaActiveId', id);

      self.isMTechPricing = false;
      self.$store.commit('pricing/setLogsData', { current: id });
      if (id === 0) {
        __WEBPACK_IMPORTED_MODULE_6__modules_api_pricing_service_area__["a" /* default */].setGlobalData(self, function (res) {
          var tmpPickupTypes = [];
          var pickupTypes = _this.$store.state.pricing.serviceTypes.list.filter(function (x) {
            return x.brandId === _this.selectedBrand && !x.isCharter && x.brandEnabled;
          });
          if (pickupTypes) {
            pickupTypes.forEach(function (pt) {
              tmpPickupTypes.push({
                id: pt.id,
                name: pt.code,
                pickupTypes: pt.pickupTypes
              });
            });
          }

          var tmpPickupTypesCharter = [];
          var pickupTypesCharter = _this.$store.state.pricing.serviceTypes.list.filter(function (x) {
            return x.brandId === _this.selectedBrand && x.isCharter && x.brandEnabled;
          });
          if (pickupTypesCharter) {
            pickupTypesCharter.forEach(function (pt) {
              tmpPickupTypesCharter.push({
                id: pt.id,
                name: pt.code,
                pickupTypes: pt.pickupTypes
              });
            });
          }

          self.$store.commit('pricing/setGlobalData', {
            pickupTypes: tmpPickupTypes,
            pickupTypesCharter: tmpPickupTypesCharter
          });

          self.$nextTick().then(function () {
            self.transitionRightPanel = true;
            // self.activeTab = 1
            self.$forceUpdate();
          });
        });
      } else {
        self.activeTab = 0;
        var serviceArea = self.$store.state.pricing.serviceArea.list.find(function (x) {
          return x.id == id;
        });
        if (serviceArea.isMTechPricing) {
          self.isMTechPricing = true;
          self.transitionRightPanel = false;
          return;
        }
        __WEBPACK_IMPORTED_MODULE_6__modules_api_pricing_service_area__["a" /* default */].getServiceAreaData(self, id, function (res) {
          var origData = [];
          res.list.forEach(function (service) {
            origData.push({
              id: service.serviceType.id,
              enabled: self.cleanCopy(service.enabled),
              asap: self.cleanCopy(service.asap),
              charter: self.cleanCopy(service.charter),
              flight: self.cleanCopy(service.flight),
              future: self.cleanCopy(service.future),
              pickupTypes: self.cleanCopy(service.pickupTypes),
              rental: self.cleanCopy(service.rental)
            });
          });
          self.$store.commit('pricing/setOriginalData', origData);
          self.transitionRightPanel = true;
        });
      }
    },
    cleanCopy: function cleanCopy(x) {
      return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(x));
    },
    save: function save() {
      if (this.saving) {
        return;
      }

      if (this.activeServiceArea === 0) {
        this.global.modal = true;
        return;
      }

      if (this.activeTab === 1) {
        if (this.$refs.asapPriceSettings.save()) {
          this.$refs.asapPriceSettings.save();
        }
      }

      if (this.activeTab === 2) {
        if (this.$refs.priceSettings.save()) {
          this.$refs.priceSettings.save();
        }
      }

      if (this.activeTab === 3) {
        if (this.$refs.charterSettings.save()) {
          this.$refs.priceSettings.save();
        }
      }

      if (this.activeTab === 4) {
        if (this.$refs.rental.save()) {
          this.$refs.rental.save();
        }
      }
    },
    response: function response(data) {
      this.responseModal = data;
    },
    closeResponseModal: function closeResponseModal() {
      var _this2 = this;

      var self = this;
      this.responseModal.show = false;
      setTimeout(function () {
        _this2.responseModal = {
          show: false,
          status: '',
          message: '',
          extra: ''
        };
      }, 500);
    },
    updateGlobal: function updateGlobal() {
      var self = this;
      if (self.global.saving) {
        return;
      }

      self.global.message = '';
      if (this.global.selectedServiceArea.length < 1) {
        self.global.message = 'Please select which service area you would like to apply your changes.';
        return;
      }

      self.global.saving = true;
      if (self.activeTab === 0) {
        __WEBPACK_IMPORTED_MODULE_8__modules_api_pricing_service_types__["a" /* default */].setGlobalServiceEnable(self, this.global.selectedServiceArea, function (res) {
          self.global.saving = false;
          if (res.error) {
            self.global.status = 'error';
            self.global.message = 'Oops! Something went wrong...';
            self.global.extra = res.error.message;
            return;
          }

          self.global.status = 'success';
          self.global.message = 'Successfully updated service area(s)!';
          self.$store.commit('pricing/resetEnableList');
        });
      } else {
        var data = {
          type: self.activeTab === 1 ? 'asap' : 'future',
          serviceArea: self.global.selectedServiceArea
        };
        if (self.activeTab === 3) data.type = 'charter';
        if (self.activeTab === 4) data.type = 'rental';

        __WEBPACK_IMPORTED_MODULE_8__modules_api_pricing_service_types__["a" /* default */].setGlobalPriceSettings(self, data, function (res) {
          self.global.saving = false;
          if (res.error) {
            self.global.status = 'error';
            self.global.message = 'Oops! Something went wrong...';
            self.global.extra = res.error.message;
            return;
          }

          self.global.status = 'success';
          self.global.message = 'Successfully updated service area(s)!';
        });
      }
    },
    closeGlobalModal: function closeGlobalModal() {
      if (this.global.saving) {
        return;
      }
      this.global.status = '';
      this.global.message = '';
      this.global.extra = '';
      this.global.modal = false;
    },
    toggleSelectAll: function toggleSelectAll() {
      if (this.global.selectedServiceArea.length !== this.completeServiceArea.length) {
        var tempId = [];
        this.completeServiceArea.forEach(function (serviceArea) {
          tempId.push(serviceArea.id);
        });
        this.global.selectedServiceArea = tempId;
      } else {
        this.global.selectedServiceArea = [];
      }
    },
    reRender: function reRender() {
      var self = this;
      self.priceSettingsShow = false;
      self.$nextTick().then(function () {
        self.priceSettingsShow = true;
      });
    },
    setScreenSize: function setScreenSize() {
      var self = this;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        self.isMobile = true;
      } else {
        self.isMobile = false;
      }
    },
    toggleLogsPanel: function toggleLogsPanel() {
      this.$store.commit('pricing/setLogsData', { show: !this.logs.show });
      if (this.logs.show) {
        if (this.$refs.logs) this.$refs.logs.getLogs();
      }
    }
  },
  watch: {
    'logs.current': function logsCurrent(val) {
      if (!val) this.$store.commit('pricing/setLogsData', { show: false });
    }
    // _selectedServiceArea: function (val) {
    //   if (val === 0) { this.activeTab = 1 }
    // }
  },
  mounted: function mounted() {
    if (!this.selectedBrand) {
      var brandId = this.$plugins.storage.getBrandInPricing() || {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.default.brandId;
      this.$store.commit('pricing/setBrandId', parseInt(brandId));
    }
    this.getBrandsList();
    this.setScreenSize();
  }
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_pricing_service_area__ = __webpack_require__(158);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import moment from 'moment'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'services',
  props: ['isMobile'],
  data: function data() {
    return {
      enabledLoading: []
    };
  },

  computed: {
    selectedBrand: function selectedBrand() {
      return this.$store.state.pricing.brandId;
    },
    selectedServiceArea: function selectedServiceArea() {
      return this.$store.state.pricing.serviceArea.activeId;
    },
    services: function services() {
      var _this = this;

      return this.$store.state.pricing.serviceTypes.list.filter(function (x) {
        return x.brandId === _this.selectedBrand && !x.isCharter && !x.isRental;
      });
    },
    charterServices: function charterServices() {
      var _this2 = this;

      return this.$store.state.pricing.serviceTypes.list.filter(function (x) {
        return x.brandId === _this2.selectedBrand && x.isCharter;
      });
    },
    enableList: function enableList() {
      return this.$store.state.pricing.serviceTypes.enableList;
    },
    disableList: function disableList() {
      return this.$store.state.pricing.serviceTypes.disableList;
    },
    rentalServices: function rentalServices() {
      var _this3 = this;

      return this.$store.state.pricing.serviceTypes.list.filter(function (x) {
        return x.brandId === _this3.selectedBrand && x.isRental;
      });
    }
  },
  methods: {
    toggleEnable: function toggleEnable(id, enable) {
      var self = this;
      if (self.enabledLoading.indexOf(id) > -1) {
        return;
      }

      self.enabledLoading.push(id);
      __WEBPACK_IMPORTED_MODULE_0__modules_api_pricing_service_area__["a" /* default */].toggleEnable(self, {
        serviceAreaId: self.selectedServiceArea,
        id: id,
        enable: !enable
      }, function (res) {
        var index = self.enabledLoading.indexOf(id);
        self.enabledLoading.splice(index, 1);
        self.$nextTick().then(function () {
          self.$forceUpdate();
          self.$emit('change');
        });
        self.pricingTabEnable();
      });
    },
    pricingTabEnable: function pricingTabEnable() {
      var _this4 = this;

      if (this.selectedServiceArea === 0) {
        this.$store.commit('pricing/setServiceTypesIsClickable', true);
      } else {
        var serviceTypes = this.$store.state.pricing.serviceTypes.list.filter(function (x) {
          return x.brandId === _this4.selectedBrand && x.brandEnabled;
        });
        var value = serviceTypes.map(function (x) {
          return x.enabled;
        }).some(function (x) {
          return x === true;
        });
        this.$store.commit('pricing/setServiceTypesIsClickable', value);
      }
    },
    toggleEnableList: function toggleEnableList(id) {
      this.$store.commit('pricing/updateEnableList', id);
    },
    toggleDisableList: function toggleDisableList(id) {
      this.$store.commit('pricing/updateDisableList', id);
    },
    resetActionList: function resetActionList() {
      this.$store.commit('pricing/resetEnableList');
    }
  },
  watch: {
    selectedBrand: function selectedBrand(value) {
      this.resetActionList();
    },
    selectedServiceArea: function selectedServiceArea(value) {
      this.resetActionList();
    }
  },
  mounted: function mounted() {
    this.pricingTabEnable();
  }
});

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1540), __esModule: true };

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(33).f;
var create = __webpack_require__(123);
var redefineAll = __webpack_require__(149);
var ctx = __webpack_require__(43);
var anInstance = __webpack_require__(147);
var forOf = __webpack_require__(93);
var $iterDefine = __webpack_require__(122);
var step = __webpack_require__(364);
var setSpecies = __webpack_require__(430);
var DESCRIPTORS = __webpack_require__(29);
var fastKey = __webpack_require__(145).fastKey;
var validate = __webpack_require__(159);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(18);
var $export = __webpack_require__(15);
var meta = __webpack_require__(145);
var fails = __webpack_require__(53);
var hide = __webpack_require__(44);
var redefineAll = __webpack_require__(149);
var forOf = __webpack_require__(93);
var anInstance = __webpack_require__(147);
var isObject = __webpack_require__(36);
var setToStringTag = __webpack_require__(82);
var dP = __webpack_require__(33).f;
var each = __webpack_require__(1542)(0);
var DESCRIPTORS = __webpack_require__(29);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(101);
var from = __webpack_require__(1546);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(15);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(15);
var aFunction = __webpack_require__(76);
var ctx = __webpack_require__(43);
var forOf = __webpack_require__(93);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_featureToggle__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'logs',
  computed: {
    pricing: function pricing() {
      return this.$store.state.pricing;
    },
    logs: function logs() {
      return this.pricing.logs;
    },
    serviceArea: function serviceArea() {
      return this.pricing.serviceArea;
    },
    _current: function _current() {
      return this.logs.current;
    }
  },
  methods: {
    getLogs: function getLogs() {
      var self = this;
      if (self.logs.loading || !self.serviceArea.activeId) return;

      self.$store.commit('pricing/setLogsData', { loading: true });
      self.$sdk.get('/servicearea/' + self.serviceArea.activeId + '/logs', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.$store.commit('pricing/setLogsData', { loading: false });
        if (r.error) {
          alert('something went wrong:', r.error.message);
          return;
        }
        var logs = [];
        var dateFormat = 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__modules_api_featureToggle__["a" /* default */].timeFormat(self, true);
        r.list.forEach(function (log) {
          logs.push({
            type: log.type,
            admin: {
              id: log.adminId,
              email: log.adminEmail
            },
            date: __WEBPACK_IMPORTED_MODULE_0_moment___default()(log.created, 'X').tz('America/Los_Angeles').format(dateFormat),
            serviceTypeId: log.serviceTypeId,
            fields: log.updates,
            open: false
          });
        });
        self.$store.commit('pricing/setLogsData', { list: logs });
      }, '2.0');
    },
    actionLabel: function actionLabel(x) {
      if (x === 'geofence_update') return 'Geofence Update';
      if (x === 'service_pricing') return 'Service Pricing';
      if (x === 'service_pickuptype') return 'Service Pickup Type';
    },
    relabel: function relabel(x) {
      if (x === 'pickupType') return 'Pickup Type';
      if (x === 'pickupFee') return 'Pickup Fee';
      if (x === 'airportFee') return 'Airport Fee';
      if (x === 'gasFee') return 'Gas Fee';
      if (x === 'discountAmount') return 'Discount Amount';
      if (x === 'charterFare') return 'Charter - Base Rate';
      if (x === 'minuteRate') return 'Per Minute Rate';
      if (x === 'provCharterBase') return 'Prov Base Fee';
      if (x === 'provCharterRate') return 'Prov Per Minute Rate';
      if (x === 'provCharterDiscount') return 'Prov Discount Rate';
      if (x === 'rentFare') return 'Rent Fare';
      if (x === 'rentRate') return 'Hourly Rent Rate';
      if (x === 'rentRateDaily') return 'Daily Rent Rate';
      if (x === 'rentRateWeekend') return 'Weekend Rent Rate';
      return x;
    }
  },
  watch: {
    _current: function _current(val) {
      if (val && this.logs.show) this.getLogs();
    }
  }
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_autonumeric__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_autonumeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_autonumeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Promo__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_api_pricing_service_types__ = __webpack_require__(110);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pricing-settings',
  components: { VueAutonumeric: __WEBPACK_IMPORTED_MODULE_2_vue_autonumeric___default.a, DatePicker: __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker___default.a, Promo: __WEBPACK_IMPORTED_MODULE_4__Promo__["a" /* default */] },
  props: ['type', 'isMobile'],
  data: function data() {
    return {
      showAirportFee: false,
      dollar: {
        currencySymbol: '$ ',
        currencySymbolPlacement: 'p',
        minimumValue: '0',
        maximumValue: '200.00'
      },
      dollar2: {
        currencySymbol: '$ ',
        currencySymbolPlacement: 'p',
        minimumValue: '0',
        maximumValue: '10000.00'
      },
      dollar10: {
        currencySymbol: '$ ',
        currencySymbolPlacement: 'p',
        minimumValue: '0',
        maximumValue: '9.99'
      },
      percent: {
        currencySymbol: ' %',
        currencySymbolPlacement: 's',
        minimumValue: '0',
        maximumValue: '100'
      },
      passenger: {
        minimumValue: '0',
        maximumValue: '9',
        decimalPlaces: 0
      },
      oneHundred: {
        minimumValue: '0',
        maximumValue: '100'
      },
      luggage: {
        minimumValue: '0',
        maximumValue: '18',
        decimalPlaces: 0
      },
      error: {
        pickupTypes: ''
      },
      promos: {
        loading: false,
        list: []
      },
      holidays: [true, false, false, false, false, false, false, false, false, false]
    };
  },

  computed: {
    travelInsuranceLabel: function travelInsuranceLabel() {
      return this.$settings.get('TravelInsuranceLabel');
    },
    selectedBrand: function selectedBrand() {
      return this.$store.state.pricing.brandId;
    },
    selectedServiceArea: function selectedServiceArea() {
      return this.$store.state.pricing.serviceArea.activeId;
    },
    services: function services() {
      var _this = this;

      return this.$store.state.pricing.serviceTypes.list.filter(function (x) {
        return x.brandId === _this.selectedBrand && x.brandEnabled && x.enabled && !x.isCharter && !x.isRental;
      });
    },
    promoRefreshID: function promoRefreshID() {
      return this.$store.state.pricing.promo.refreshID;
    },

    discountStart: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var discountStart = this.type === 'asap' ? serviceArea.asapDiscountStart : serviceArea.discountStart;
        if (!discountStart) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(discountStart, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        if (this.type === 'asap') {
          this.$store.commit('pricing/setAsapDiscountStart', __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD'));
        } else {
          this.$store.commit('pricing/setDiscountStart', __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD'));
        }
      }
    },
    discountEnd: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var discountEnd = this.type === 'asap' ? serviceArea.asapDiscountEnd : serviceArea.discountEnd;
        if (!discountEnd) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(discountEnd, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        if (this.type === 'asap') {
          this.$store.commit('pricing/setAsapDiscountEnd', __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD'));
        } else {
          this.$store.commit('pricing/setDiscountEnd', __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD'));
        }
      }
    },
    holidayDate: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var holidayDate = this.type === 'asap' ? serviceArea.asapHolidayDate : serviceArea.holidayDate;
        if (!holidayDate) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(holidayDate, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        if (this.type === 'asap') {
          this.$store.commit('pricing/setAsapHolidayDate', __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD'));
        } else {
          this.$store.commit('pricing/setHolidayDate', __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD'));
        }
      }
    },
    holidayDate2: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var holidayDate = this.type === 'asap' ? serviceArea.asapHolidayDate2 : serviceArea.holidayDate2;
        if (!holidayDate) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(holidayDate, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setHolidayData', {
          index: 2,
          type: this.type,
          value: value ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD') : null
        });
      }
    },
    holidayDate3: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var holidayDate = this.type === 'asap' ? serviceArea.asapHolidayDate3 : serviceArea.holidayDate3;
        if (!holidayDate) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(holidayDate, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setHolidayData', {
          index: 3,
          type: this.type,
          value: value ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD') : null
        });
      }
    },
    holidayDate4: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var holidayDate = this.type === 'asap' ? serviceArea.asapHolidayDate4 : serviceArea.holidayDate4;
        if (!holidayDate) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(holidayDate, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setHolidayData', {
          index: 4,
          type: this.type,
          value: value ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD') : null
        });
      }
    },
    holidayDate5: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var holidayDate = this.type === 'asap' ? serviceArea.asapHolidayDate5 : serviceArea.holidayDate5;
        if (!holidayDate) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(holidayDate, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setHolidayData', {
          index: 5,
          type: this.type,
          value: value ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD') : null
        });
      }
    },
    holidayDate6: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var holidayDate = this.type === 'asap' ? serviceArea.asapHolidayDate6 : serviceArea.holidayDate6;
        if (!holidayDate) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(holidayDate, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setHolidayData', {
          index: 6,
          type: this.type,
          value: value ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD') : null
        });
      }
    },
    holidayDate7: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var holidayDate = this.type === 'asap' ? serviceArea.asapHolidayDate7 : serviceArea.holidayDate7;
        if (!holidayDate) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(holidayDate, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setHolidayData', {
          index: 7,
          type: this.type,
          value: value ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD') : null
        });
      }
    },
    holidayDate8: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var holidayDate = this.type === 'asap' ? serviceArea.asapHolidayDate8 : serviceArea.holidayDate8;
        if (!holidayDate) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(holidayDate, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setHolidayData', {
          index: 8,
          type: this.type,
          value: value ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD') : null
        });
      }
    },
    holidayDate9: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var holidayDate = this.type === 'asap' ? serviceArea.asapHolidayDate9 : serviceArea.holidayDate9;
        if (!holidayDate) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(holidayDate, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setHolidayData', {
          index: 9,
          type: this.type,
          value: value ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD') : null
        });
      }
    },
    holidayDate10: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var holidayDate = this.type === 'asap' ? serviceArea.asapHolidayDate10 : serviceArea.holidayDate10;
        if (!holidayDate) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(holidayDate, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setHolidayData', {
          index: 10,
          type: this.type,
          value: value ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD') : null
        });
      }
    },
    minDate: function minDate() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()().toDate();
    },
    discountEndMin: function discountEndMin() {
      var date = new Date();
      if (this.discountStart) {
        date = this.discountStart;
      }
      return date;
    },
    saving: function saving() {
      return this.$store.state.pricing.saving;
    },

    dcTypeWidget: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var type = this.type === 'asap' ? serviceArea.asapDiscountWidget : serviceArea.discountWidget;
        return type;
      },
      set: function set(value) {
        this.$store.commit('pricing/setDcType', {
          field: this.type === 'asap' ? 'asapDiscountWidget' : 'discountWidget',
          value: value
        });
      }
    },
    dcTypeAdmin: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var type = this.type === 'asap' ? serviceArea.asapDiscountAdmin : serviceArea.discountAdmin;
        return type;
      },
      set: function set(value) {
        this.$store.commit('pricing/setDcType', {
          field: this.type === 'asap' ? 'asapDiscountAdmin' : 'discountAdmin',
          value: value
        });
      }
    },
    dcTypeApp: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var type = this.type === 'asap' ? serviceArea.asapDiscountApp : serviceArea.discountApp;
        return type;
      },
      set: function set(value) {
        this.$store.commit('pricing/setDcType', {
          field: this.type === 'asap' ? 'asapDiscountApp' : 'discountApp',
          value: value
        });
      }
    },
    dcTypeCsr: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var type = this.type === 'asap' ? serviceArea.asapDiscountCSR : serviceArea.discountCSR;
        return type;
      },
      set: function set(value) {
        this.$store.commit('pricing/setDcType', {
          field: this.type === 'asap' ? 'asapDiscountCSR' : 'discountCSR',
          value: value
        });
      }
    },
    pickupTypesGlobal: function pickupTypesGlobal() {
      return this.$store.state.pricing.global.pickupTypes;
    },
    isD2D: function isD2D() {
      var _this2 = this;

      var conf = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.find(function (x) {
        return x.id === _this2.$store.state.pricing.brandId;
      });
      if (conf) return conf.code === 'd2d';
      return false;
    }
  },
  methods: {
    showService: function showService(data) {
      return this.selectedServiceArea === 0 && data.brandEnabled || data.enabled && data.brandEnabled;
    },
    updateValue: function updateValue(index, field) {
      this.$store.commit('pricing/updateServiceTypeField', {
        id: this.services[index].id,
        field: field,
        type: this.type,
        value: this.services[index][this.type][field]
      });
    },
    togglePickupType: function togglePickupType(index, type, field) {
      var self = this;
      if (self.saving || this.selectedServiceArea === 0 && field === 'enabled') {
        return;
      }

      var pickupType = self.services[index].pickupTypes[type];
      if (!pickupType) {
        self.$store.commit('pricing/updateServiceTypePickupType', {
          id: this.services[index].id,
          type: type,
          field: 'name',
          value: type
        });
      }
      var value = pickupType[field];
      if (field === 'enabled') {
        value = !value;
      }
      self.$store.commit('pricing/updateServiceTypePickupType', {
        id: this.services[index].id,
        type: type,
        field: field,
        value: value
      });
      self.$nextTick().then(function () {
        self.$forceUpdate();
      });
    },
    toggleAirportFee: function toggleAirportFee() {
      var self = this;
      if (!self.selectedServiceArea) {
        self.showAirportFee = true;
        return;
      }
      self.showAirportFee = false;
      self.$sdk.get('/geofences/' + self.selectedServiceArea + '/airport', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          return;
        }
        if (r.airports.length > 0) {
          self.showAirportFee = true;
        }
      });
    },
    loadPromos: function loadPromos() {
      var self = this;
      self.promos.loading = true;
      self.promos.list = [];
      self.$sdk.get('/geofences/' + self.selectedServiceArea + '/promos', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.promos.loading = false;
        if (r.error) {
          return;
        }
        self.promos.list = r.list;
      });
    },
    removePromo: function removePromo(index) {
      var self = this;
      var promo = self.promos.list[index];
      var promos = [];
      for (var i = 0; i < self.promos.list.length; i++) {
        if (i === index) {
          continue;
        }
        promos.push(self.promos.list[i]);
      }
      self.promos.list = promos;
      self.$sdk.delete('/geofences/' + self.selectedServiceArea + '/promos/' + promo.id, {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        console.log('PROMO REMOVED', r);
      });
    },
    showPromoForm: function showPromoForm() {
      this.$store.commit('pricing/setGeofencePromoShow', true);
      this.$store.commit('pricing/setGeofencePromoList', this.promos.list);
    },
    save: function save() {
      var self = this;

      self.error.pickupTypes = '';
      if (self.type !== 'asap') {
        self.services.forEach(function (service) {
          var unchecked = true;
          for (var index in service.pickupTypes) {
            if (service.pickupTypes[index].enabled) {
              unchecked = false;
            }
          }
          if (unchecked) {
            self.error.pickupTypes = 'Must select atleast one pickup type per service.';
          }
        });
      }

      if (this.saving || !!self.error.pickupTypes) {
        return;
      }

      self.$store.commit('pricing/setSaving', true);
      __WEBPACK_IMPORTED_MODULE_5__modules_api_pricing_service_types__["a" /* default */].setPriceSettings(self, this.type, function (res) {
        self.$store.commit('pricing/setSaving', false);
        var response = {
          show: true,
          status: 'success',
          message: 'Successfully updated pricing data!',
          extra: ''
        };
        if (res.error) {
          response.status = 'error';
          response.message = 'Oops! Something went wrong...';
          response.extra = res.error.message;
        }
        self.$emit('response', response);

        var origData = [];
        res.list.forEach(function (service) {
          origData.push({
            id: service.serviceType.id,
            enabled: self.cleanCopy(service.enabled),
            asap: self.cleanCopy(service.asap),
            charter: self.cleanCopy(service.charter),
            flight: self.cleanCopy(service.flight),
            future: self.cleanCopy(service.future),
            pickupTypes: self.cleanCopy(service.pickupTypes),
            rental: self.cleanCopy(service.rental)
          });
        });
        self.$store.commit('pricing/setOriginalData', origData);
      });
    },
    cleanCopy: function cleanCopy(x) {
      return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(x));
    },
    addHoliday: function addHoliday() {
      var index = this.holidays.lastIndexOf(true);
      this.holidays[index + 1] = true;
      this.$forceUpdate();
    },
    clearDate: function clearDate(index) {
      var _this3 = this;

      var tempVal = [];
      var lastIndex = this.holidays.lastIndexOf(true);

      if (lastIndex == index) {
        this.holidays[index] = false;
        this.$forceUpdate();
        return;
      }

      for (var x = index; x < 10; x++) {
        if (this['holidayDate' + (x + 1)]) {
          tempVal.push({
            index: x,
            val: this['holidayDate' + (x + 1)]
          });
        }
      }
      tempVal.forEach(function (temp) {
        _this3['holidayDate' + temp.index] = temp.val;
        _this3['holidayDate' + (temp.index + 1)] = null;
        _this3.holidays[temp.index - 1] = true;
        _this3.holidays[temp.index] = false;
      });
    },
    toggleGlobalPickupType: function toggleGlobalPickupType(i, type) {
      var tmp = this.pickupTypesGlobal[i].pickupTypes[type].enabled;
      if (tmp === false || tmp === true) tmp = !tmp;
      if (tmp === '') tmp = true;
      this.$store.commit('pricing/updateGlobalPickupTypeData', {
        index: i,
        type: type,
        field: 'enabled',
        value: tmp
      });
    },
    toggleGlobalPickupTypeFee: function toggleGlobalPickupTypeFee(i, type) {
      // console.log(i, type) // DO nothing
    }
  },
  watch: {
    promoRefreshID: function promoRefreshID(value) {
      if (value !== this.selectedServiceArea) {
        return;
      }
      this.loadPromos();
    }
  },
  mounted: function mounted() {
    this.$store.commit('pricing/setDiscountStart', '');
    this.$store.commit('pricing/setDiscountEnd', '');
    this.$store.commit('pricing/setHolidayDate', '');
    this.$store.commit('pricing/setAsapDiscountStart', '');
    this.$store.commit('pricing/setAsapDiscountEnd', '');
    this.$store.commit('pricing/setAsapHolidayDate', '');

    if (this.$store.state.pricing.serviceArea.activeId !== 0) {
      if (this.services && this.services[0] && this.services[0].discountStart) {
        this.$store.commit('pricing/setDiscountStart', this.services[0].discountStart);
      }
      if (this.services && this.services[0] && this.services[0].discountEnd) {
        this.$store.commit('pricing/setDiscountEnd', this.services[0].discountEnd);
      }
      if (this.services && this.services[0] && this.services[0].holidayDate) {
        this.$store.commit('pricing/setHolidayDate', this.services[0].holidayDate);
      }

      if (this.services && this.services[0] && this.services[0].asapDiscountStart) {
        this.$store.commit('pricing/setAsapDiscountStart', this.services[0].asapDiscountStart);
      }
      if (this.services && this.services[0] && this.services[0].asapDiscountEnd) {
        this.$store.commit('pricing/setAsapDiscountEnd', this.services[0].asapDiscountEnd);
      }
      if (this.services && this.services[0] && this.services[0].asapHolidayDate) {
        this.$store.commit('pricing/setAsapHolidayDate', this.services[0].asapHolidayDate);
      }

      if (this.services && this.services[0]) {
        this.$store.commit('pricing/setDcType', {
          field: 'discountWidget',
          value: this.services[0].discountWidget
        });
        this.$store.commit('pricing/setDcType', {
          field: 'discountAdmin',
          value: this.services[0].discountAdmin
        });
        this.$store.commit('pricing/setDcType', {
          field: 'discountApp',
          value: this.services[0].discountApp
        });
        this.$store.commit('pricing/setDcType', {
          field: 'discountCSR',
          value: this.services[0].discountCSR
        });
        this.$store.commit('pricing/setDcType', {
          field: 'asapDiscountWidget',
          value: this.services[0].asapDiscountWidget
        });
        this.$store.commit('pricing/setDcType', {
          field: 'asapDiscountAdmin',
          value: this.services[0].asapDiscountAdmin
        });
        this.$store.commit('pricing/setDcType', {
          field: 'asapDiscountApp',
          value: this.services[0].asapDiscountApp
        });
        this.$store.commit('pricing/setDcType', {
          field: 'asapDiscountCSR',
          value: this.services[0].asapDiscountCSR
        });
      }
    } else {
      this.$store.commit('pricing/setDcType', { field: 'discountWidget', value: true });
      this.$store.commit('pricing/setDcType', { field: 'discountAdmin', value: true });
      this.$store.commit('pricing/setDcType', { field: 'discountApp', value: true });
      this.$store.commit('pricing/setDcType', { field: 'discountCSR', value: true });
      this.$store.commit('pricing/setDcType', { field: 'asapDiscountWidget', value: true });
      this.$store.commit('pricing/setDcType', { field: 'asapDiscountAdmin', value: true });
      this.$store.commit('pricing/setDcType', { field: 'asapDiscountApp', value: true });
      this.$store.commit('pricing/setDcType', { field: 'asapDiscountCSR', value: true });
    }

    this.holidays = [true, false, false, false, false, false, false, false, false, false];
    if (this.selectedServiceArea !== 0) {
      for (var i = 1; i < 10; i++) {
        this.$store.commit('pricing/setHolidayData', {
          type: 'asap',
          index: i + 1,
          value: this.services[0]['asapHolidayDate' + (i + 1)]
        });
        this.$store.commit('pricing/setHolidayData', {
          type: 'future',
          index: i + 1,
          value: this.services[0]['holidayDate' + (i + 1)]
        });
        this.holidays[i] = false;
        if (this.type === 'asap' && this.services[0]['asapHolidayDate' + (i + 1)] || this.type === 'future' && this.services[0]['holidayDate' + (i + 1)]) {
          this.holidays[i] = true;
        }
      }
    }

    this.loadPromos();
    this.toggleAirportFee();
  }
});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_autonumeric__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_autonumeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_autonumeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_services__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'promo',
  components: { VueAutonumeric: __WEBPACK_IMPORTED_MODULE_0_vue_autonumeric___default.a },
  data: function data() {
    return {
      dollar: {
        currencySymbol: '$ ',
        currencySymbolPlacement: 'p',
        minimumValue: '0',
        maximumValue: '99.99',
        emptyInputBehavior: 'zero'
      },
      promoForm: {
        saving: false,
        serviceType: '',
        promoType: '',
        flatRate: 0,
        baseRate: 0,
        mileageRate: 0,
        secondPaxFee: 0,
        addPaxFee: 0,
        error: {
          show: false,
          message: ''
        }
      }
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.pricing.promo.show;
    },
    activeGeofenceId: function activeGeofenceId() {
      return this.$store.state.pricing.serviceArea.activeId;
    },
    selectedBrand: function selectedBrand() {
      return this.$store.state.pricing.brandId;
    },
    services: function services() {
      var _this = this;

      return this.$store.state.pricing.serviceTypes.list.filter(function (x) {
        return x.brandId === _this.selectedBrand && x.brandEnabled && x.enabled;
      });
    },
    promoList: function promoList() {
      return this.$store.state.pricing.promo.list;
    }
  },
  methods: {
    hideForm: function hideForm() {
      this.$store.commit('pricing/setGeofencePromoShow', false);
    },
    addPromo: function addPromo() {
      var self = this;
      var services = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.serviceId;
      var promoList = self.promoList;
      for (var prop in services) {
        if (!services.hasOwnProperty(prop)) {
          continue;
        }

        if (prop !== self.promoForm.serviceType) {
          continue;
        }

        for (var i = 0; i < promoList.length; i++) {
          if (services[prop] === promoList[i].serviceId) {
            self.promoForm.error = {
              show: true,
              message: 'Only one promotion is allowed per service type.'
            };
            return;
          }
        }
      }
      self.promoForm.error.show = false;
      if (self.promoForm.serviceType === '') {
        self.promoForm.error = {
          show: true,
          message: 'Please select a SERVICE TYPE.'
        };
        return;
      }
      if (self.promoForm.promoType === '') {
        self.promoForm.error = {
          show: true,
          message: 'Please select a PROMOTION TYPE.'
        };
        return;
      }
      self.promoForm.saving = true;
      var request = {
        token: self.$store.state.session.sessionToken,
        serviceId: self.promoForm.serviceType,
        type: self.promoForm.promoType,
        flatRate: self.promoForm.flatRate,
        flat2ndPAXFee: self.promoForm.secondPaxFee,
        flatAddPAXFee: self.promoForm.addPaxFee,
        discountBaseRate: self.promoForm.baseRate,
        discountMileageRate: self.promoForm.mileageRate,
        discount2ndPAXFee: self.promoForm.secondPaxFee,
        discountAddPAXFee: self.promoForm.addPaxFee
      };

      self.$sdk.post('/geofences/' + self.activeGeofenceId + '/promos', request, function (r) {
        self.promoForm.saving = false;
        if (r.error) {
          return;
        }
        self.hideForm();
        self.$store.commit('pricing/setGeofencePromoRefreshID', self.activeGeofenceId);
      });
    },
    serviceLabel: function serviceLabel(code) {
      return __WEBPACK_IMPORTED_MODULE_1__modules_api_services__["a" /* default */].getServiceName(code);
    }
  },
  watch: {
    show: function show(value) {
      if (!value) {
        return;
      }
      this.promoForm = {
        saving: false,
        serviceType: '',
        promoType: '',
        flatRate: 0,
        baseRate: 0,
        mileageRate: 0,
        secondPaxFee: 0,
        addPaxFee: 0,
        error: {
          show: false,
          message: ''
        }
      };
    }
  }
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_autonumeric__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_autonumeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_autonumeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Promo__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_api_pricing_service_types__ = __webpack_require__(110);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'charter-pricing',
  components: { VueAutonumeric: __WEBPACK_IMPORTED_MODULE_2_vue_autonumeric___default.a, DatePicker: __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker___default.a, Promo: __WEBPACK_IMPORTED_MODULE_4__Promo__["a" /* default */] },
  props: ['type', 'isMobile'],
  data: function data() {
    return {
      showAirportFee: false,
      dollar: {
        currencySymbol: '$ ',
        currencySymbolPlacement: 'p',
        minimumValue: '0',
        maximumValue: '200.00'
      },
      dollar2: {
        currencySymbol: '$ ',
        currencySymbolPlacement: 'p',
        minimumValue: '0',
        maximumValue: '1000.00'
      },
      percent: {
        currencySymbol: ' %',
        currencySymbolPlacement: 's',
        minimumValue: '0',
        maximumValue: '100'
      },
      passenger: {
        minimumValue: '0',
        maximumValue: '9',
        decimalPlaces: 0
      },
      oneHundred: {
        minimumValue: '0',
        maximumValue: '100'
      },
      luggage: {
        minimumValue: '0',
        maximumValue: '18',
        decimalPlaces: 0
      },
      error: {
        pickupTypes: ''
      },
      promos: {
        loading: false,
        list: []
      },
      holidays: [true, false, false, false, false, false, false, false, false, false]
    };
  },

  computed: {
    travelInsuranceLabel: function travelInsuranceLabel() {
      return this.$settings.get('TravelInsuranceLabel');
    },
    selectedBrand: function selectedBrand() {
      return this.$store.state.pricing.brandId;
    },
    selectedServiceArea: function selectedServiceArea() {
      return this.$store.state.pricing.serviceArea.activeId;
    },
    services: function services() {
      var _this = this;

      return this.$store.state.pricing.serviceTypes.list.filter(function (x) {
        return x.brandId === _this.selectedBrand && x.brandEnabled && x.enabled && x.isCharter;
      });
    },
    promoRefreshID: function promoRefreshID() {
      return this.$store.state.pricing.promo.refreshID;
    },

    discountStart: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var discountStart = serviceArea.charterDiscountStart;
        if (!discountStart) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(discountStart, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setServiceAreaCharterData', {
          charterDiscountStart: __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD')
        });
      }
    },
    discountEnd: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var discountEnd = serviceArea.charterDiscountEnd;
        if (!discountEnd) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(discountEnd, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setServiceAreaCharterData', {
          charterDiscountEnd: __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD')
        });
      }
    },
    holidayDate: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var holidayDate = serviceArea.charterHolidayDate;
        if (!holidayDate) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(holidayDate, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setServiceAreaCharterData', {
          charterHolidayDate: __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD')
        });
      }
    },
    holidayDate2: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var holidayDate = serviceArea.charterHolidayDate2;
        if (!holidayDate) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(holidayDate, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setCharterHolidayData', {
          index: 2,
          value: value ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD') : null
        });
      }
    },
    holidayDate3: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var holidayDate = serviceArea.charterHolidayDate3;
        if (!holidayDate) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(holidayDate, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setCharterHolidayData', {
          index: 3,
          value: value ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD') : null
        });
      }
    },
    holidayDate4: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var holidayDate = serviceArea.charterHolidayDate4;
        if (!holidayDate) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(holidayDate, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setCharterHolidayData', {
          index: 4,
          value: value ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD') : null
        });
      }
    },
    holidayDate5: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var holidayDate = serviceArea.charterHolidayDate5;
        if (!holidayDate) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(holidayDate, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setCharterHolidayData', {
          index: 5,
          value: value ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD') : null
        });
      }
    },
    holidayDate6: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var holidayDate = serviceArea.charterHolidayDate6;
        if (!holidayDate) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(holidayDate, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setCharterHolidayData', {
          index: 6,
          value: value ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD') : null
        });
      }
    },
    holidayDate7: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var holidayDate = serviceArea.charterHolidayDate7;
        if (!holidayDate) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(holidayDate, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setCharterHolidayData', {
          index: 7,
          value: value ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD') : null
        });
      }
    },
    holidayDate8: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var holidayDate = serviceArea.charterHolidayDate8;
        if (!holidayDate) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(holidayDate, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setCharterHolidayData', {
          index: 8,
          value: value ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD') : null
        });
      }
    },
    holidayDate9: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var holidayDate = serviceArea.charterHolidayDate9;
        if (!holidayDate) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(holidayDate, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setCharterHolidayData', {
          index: 9,
          value: value ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD') : null
        });
      }
    },
    holidayDate10: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var holidayDate = serviceArea.charterHolidayDate10;
        if (!holidayDate) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(holidayDate, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setCharterHolidayData', {
          index: 10,
          value: value ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD') : null
        });
      }
    },
    minDate: function minDate() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()().toDate();
    },
    discountEndMin: function discountEndMin() {
      var date = new Date();
      if (this.discountStart) {
        date = this.discountStart;
      }
      return date;
    },
    saving: function saving() {
      return this.$store.state.pricing.saving;
    },
    pickupTypesGlobal: function pickupTypesGlobal() {
      return this.$store.state.pricing.global.pickupTypesCharter;
    }
  },
  methods: {
    showService: function showService(data) {
      return this.selectedServiceArea === 0 && data.brandEnabled || data.enabled && data.brandEnabled;
    },
    updateValue: function updateValue(index, field) {
      this.$store.commit('pricing/updateServiceTypeField', {
        id: this.services[index].id,
        field: field,
        type: 'future',
        value: this.services[index].future[field]
      });
    },
    togglePickupType: function togglePickupType(index, type, field) {
      var self = this;
      if (self.saving || this.selectedServiceArea === 0 && field === 'enabled') {
        return;
      }

      var pickupType = self.services[index].pickupTypes[type];
      if (!pickupType) {
        self.$store.commit('pricing/updateServiceTypePickupType', {
          id: this.services[index].id,
          type: type,
          field: 'name',
          value: type
        });
      }
      var value = pickupType[field];
      if (field === 'enabled') {
        value = !value;
      }
      self.$store.commit('pricing/updateServiceTypePickupType', {
        id: this.services[index].id,
        type: type,
        field: field,
        value: value
      });
      // if (pickupType) {
      // }
      self.$nextTick().then(function () {
        self.$forceUpdate();
      });
    },
    toggleAirportFee: function toggleAirportFee() {
      var self = this;
      if (!self.selectedServiceArea) {
        self.showAirportFee = true;
        return;
      }
      self.showAirportFee = false;
      self.$sdk.get('/geofences/' + self.selectedServiceArea + '/airport', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          return;
        }
        if (r.airports.length > 0) {
          self.showAirportFee = true;
        }
      });
    },
    loadPromos: function loadPromos() {
      var self = this;
      self.promos.loading = true;
      self.promos.list = [];
      self.$sdk.get('/geofences/' + self.selectedServiceArea + '/promos', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.promos.loading = false;
        if (r.error) {
          return;
        }
        self.promos.list = r.list;
      });
    },
    removePromo: function removePromo(index) {
      var self = this;
      var promo = self.promos.list[index];
      var promos = [];
      for (var i = 0; i < self.promos.list.length; i++) {
        if (i === index) {
          continue;
        }
        promos.push(self.promos.list[i]);
      }
      self.promos.list = promos;
      self.$sdk.delete('/geofences/' + self.selectedServiceArea + '/promos/' + promo.id, {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        console.log('PROMO REMOVED', r);
      });
    },
    showPromoForm: function showPromoForm() {
      this.$store.commit('pricing/setGeofencePromoShow', true);
      this.$store.commit('pricing/setGeofencePromoList', this.promos.list);
    },
    save: function save() {
      var self = this;

      self.error.pickupTypes = '';
      self.services.forEach(function (service) {
        var unchecked = true;
        for (var index in service.pickupTypes) {
          if (service.pickupTypes[index].enabled) {
            unchecked = false;
          }
        }
        if (unchecked) {
          self.error.pickupTypes = 'Must select atleast one pickup type per service.';
        }
      });

      if (this.saving || !!self.error.pickupTypes) {
        return;
      }

      self.$store.commit('pricing/setSaving', true);
      __WEBPACK_IMPORTED_MODULE_5__modules_api_pricing_service_types__["a" /* default */].setPriceSettings(self, 'charter', function (res) {
        self.$store.commit('pricing/setSaving', false);
        var response = {
          show: true,
          status: 'success',
          message: 'Successfully updated pricing data!',
          extra: ''
        };
        if (res.error) {
          response.status = 'error';
          response.message = 'Oops! Something went wrong...';
          response.extra = res.error.message;
        }
        self.$emit('response', response);

        var origData = [];
        res.list.forEach(function (service) {
          origData.push({
            id: service.serviceType.id,
            enabled: self.cleanCopy(service.enabled),
            asap: self.cleanCopy(service.asap),
            charter: self.cleanCopy(service.charter),
            flight: self.cleanCopy(service.flight),
            future: self.cleanCopy(service.future),
            pickupTypes: self.cleanCopy(service.pickupTypes),
            rental: self.cleanCopy(service.rental)
          });
        });
        self.$store.commit('pricing/setOriginalData', origData);
      });
    },
    cleanCopy: function cleanCopy(x) {
      return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(x));
    },
    addHoliday: function addHoliday() {
      var index = this.holidays.lastIndexOf(true);
      this.holidays[index + 1] = true;
      this.$forceUpdate();
    },
    clearDate: function clearDate(index) {
      var _this2 = this;

      var tempVal = [];
      var lastIndex = this.holidays.lastIndexOf(true);

      if (lastIndex == index) {
        this.holidays[index] = false;
        this.$forceUpdate();
        return;
      }

      for (var x = index; x < 10; x++) {
        if (this['holidayDate' + (x + 1)]) {
          tempVal.push({
            index: x,
            val: this['holidayDate' + (x + 1)]
          });
        }
      }
      tempVal.forEach(function (temp) {
        _this2['holidayDate' + temp.index] = temp.val;
        _this2['holidayDate' + (temp.index + 1)] = null;
        _this2.holidays[temp.index - 1] = true;
        _this2.holidays[temp.index] = false;
      });
    },
    toggleGlobalPickupType: function toggleGlobalPickupType(i, type) {
      var tmp = this.pickupTypesGlobal[i].pickupTypes[type].enabled;
      if (tmp === false || tmp === true) tmp = !tmp;
      if (tmp === '') tmp = true;
      this.$store.commit('pricing/updateGlobalPickupTypeCharterData', {
        index: i,
        type: type,
        field: 'enabled',
        value: tmp
      });
    },
    toggleGlobalPickupTypeFee: function toggleGlobalPickupTypeFee(i, type) {
      // console.log(i, type) // DO nothing
    }
  },
  watch: {
    promoRefreshID: function promoRefreshID(value) {
      if (value !== this.selectedServiceArea) {
        return;
      }
      this.loadPromos();
    }
  },
  mounted: function mounted() {
    this.$store.commit('pricing/setServiceAreaCharterData', {
      charterDiscountStart: '',
      charterDiscountEnd: '',
      charterHolidayDate: ''
    });

    if (this.$store.state.pricing.serviceArea.activeId !== 0) {
      if (this.services && this.services[0] && this.services[0].discountStart) {
        this.$store.commit('pricing/setServiceAreaCharterData', { charterDiscountStart: this.services[0].discountStart });
      }
      if (this.services && this.services[0] && this.services[0].discountEnd) {
        this.$store.commit('pricing/setServiceAreaCharterData', { charterDiscountEnd: this.services[0].discountEnd });
      }
      if (this.services && this.services[0] && this.services[0].holidayDate) {
        this.$store.commit('pricing/setServiceAreaCharterData', { charterHolidayDate: this.services[0].holidayDate });
      }
    }

    this.holidays = [true, false, false, false, false, false, false, false, false, false];
    if (this.services[0]) {
      for (var i = 1; i < 10; i++) {
        this.$store.commit('pricing/setCharterHolidayData', {
          index: i + 1,
          value: this.services[0]['holidayDate' + (i + 1)]
        });
        if (this.services[0]['holidayDate' + (i + 1)]) {
          this.holidays[i] = true;
        }
      }
    }

    this.loadPromos();
    this.toggleAirportFee();
  }
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_autonumeric__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_autonumeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_autonumeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Promo__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_api_pricing_service_types__ = __webpack_require__(110);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'charter-pricing',
  components: { VueAutonumeric: __WEBPACK_IMPORTED_MODULE_2_vue_autonumeric___default.a, DatePicker: __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker___default.a, Promo: __WEBPACK_IMPORTED_MODULE_4__Promo__["a" /* default */] },
  props: ['type', 'isMobile'],
  data: function data() {
    return {
      showAirportFee: false,
      dollar: {
        currencySymbol: '$ ',
        currencySymbolPlacement: 'p',
        minimumValue: '0',
        maximumValue: '200.00',
        decimalPlaces: 2
      },
      dollar6deci: {
        currencySymbol: '$ ',
        currencySymbolPlacement: 'p',
        minimumValue: '0',
        maximumValue: '200.000000',
        decimalPlaces: 6
      },
      percent: {
        currencySymbol: ' %',
        currencySymbolPlacement: 's',
        minimumValue: '0',
        maximumValue: '100'
      },
      error: {
        pickupTypes: ''
      }
    };
  },

  computed: {
    travelInsuranceLabel: function travelInsuranceLabel() {
      return this.$settings.get('TravelInsuranceLabel');
    },
    selectedBrand: function selectedBrand() {
      return this.$store.state.pricing.brandId;
    },
    selectedServiceArea: function selectedServiceArea() {
      return this.$store.state.pricing.serviceArea.activeId;
    },
    services: function services() {
      var _this = this;

      return this.$store.state.pricing.serviceTypes.list.filter(function (x) {
        return x.brandId === _this.selectedBrand && x.brandEnabled && x.enabled && x.isRental;
      });
    },

    discountStart: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var discountStart = serviceArea.charterDiscountStart;
        if (!discountStart) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(discountStart, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setServiceAreaCharterData', {
          charterDiscountStart: __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD')
        });
      }
    },
    discountEnd: {
      get: function get() {
        var serviceArea = this.$store.state.pricing.serviceArea;
        var discountEnd = serviceArea.charterDiscountEnd;
        if (!discountEnd) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(discountEnd, 'YYYY-MM-DD').toDate();
      },
      set: function set(value) {
        this.$store.commit('pricing/setServiceAreaCharterData', {
          charterDiscountEnd: __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD')
        });
      }
    },
    minDate: function minDate() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()().toDate();
    },
    discountEndMin: function discountEndMin() {
      var date = new Date();
      if (this.discountStart) {
        date = this.discountStart;
      }
      return date;
    },
    saving: function saving() {
      return this.$store.state.pricing.saving;
    }
  },
  methods: {
    showService: function showService(data) {
      return this.selectedServiceArea === 0 && data.brandEnabled || data.enabled && data.brandEnabled;
    },
    updateValue: function updateValue(index, field) {
      this.$store.commit('pricing/updateServiceTypeField', {
        id: this.services[index].id,
        field: field,
        type: 'future',
        value: this.services[index].future[field]
      });
    },
    removePromo: function removePromo(index) {
      var self = this;
      var promo = self.promos.list[index];
      var promos = [];
      for (var i = 0; i < self.promos.list.length; i++) {
        if (i === index) {
          continue;
        }
        promos.push(self.promos.list[i]);
      }
      self.promos.list = promos;
      self.$sdk.delete('/geofences/' + self.selectedServiceArea + '/promos/' + promo.id, {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        console.log('PROMO REMOVED', r);
      });
    },
    save: function save() {
      var self = this;
      if (this.saving) {
        return;
      }

      self.$store.commit('pricing/setSaving', true);
      __WEBPACK_IMPORTED_MODULE_5__modules_api_pricing_service_types__["a" /* default */].setPriceSettings(self, 'rental', function (res) {
        self.$store.commit('pricing/setSaving', false);
        var response = {
          show: true,
          status: 'success',
          message: 'Successfully updated pricing data!',
          extra: ''
        };
        if (res.error) {
          response.status = 'error';
          response.message = 'Oops! Something went wrong...';
          response.extra = res.error.message;
        }
        self.$emit('response', response);

        var origData = [];
        res.list.forEach(function (service) {
          origData.push({
            id: service.serviceType.id,
            enabled: self.cleanCopy(service.enabled),
            asap: self.cleanCopy(service.asap),
            charter: self.cleanCopy(service.charter),
            flight: self.cleanCopy(service.flight),
            future: self.cleanCopy(service.future),
            pickupTypes: self.cleanCopy(service.pickupTypes),
            rental: self.cleanCopy(service.rental)
          });
        });
        self.$store.commit('pricing/setOriginalData', origData);
      });
    },
    cleanCopy: function cleanCopy(x) {
      return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(x));
    }
  },
  watch: {},
  mounted: function mounted() {}
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Preview__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_brands__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ServiceDetails__ = __webpack_require__(1590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_api_services__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_api_pricing_service_area__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_api_provider_list__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EnableDrivers__ = __webpack_require__(1594);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */
// import moment from 'moment'









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'services',
  components: { preview: __WEBPACK_IMPORTED_MODULE_1__Preview__["a" /* default */], draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a, serviceDetails: __WEBPACK_IMPORTED_MODULE_4__ServiceDetails__["a" /* default */], enableDrivers: __WEBPACK_IMPORTED_MODULE_8__EnableDrivers__["a" /* default */] },
  data: function data() {
    return {
      selectedBrand: this.$plugins.storage.getServiceBrand() || {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.default.brandId,
      serviceList: [],
      tempServiceList: [],
      activeService: '',
      serviceLoading: false,
      drag: false,
      enabledLoading: {},
      addService: false,
      transitionRightPanel: false,
      responseModal: {
        show: false,
        status: '',
        message: '',
        extra: ''
      },
      cloneModal: {
        show: false,
        brand: '',
        status: '',
        message: '',
        extra: ''
      },
      driverModal: {
        show: false
      },
      enableDriverModal: {
        show: false,
        status: '',
        message: ''
      },
      selectOnload: '',
      renderPreview: true,
      serviceAreaList: [],
      serviceAreaLoading: false,
      isMobile: false
    };
  },

  computed: {
    brands: function brands() {
      return this.$store.state.brands.list;
    },
    services: function services() {
      var _this = this;

      return this.$store.state.services.list.filter(function (x) {
        return x.brandId === parseInt(_this.selectedBrand);
      });
    },
    dragOptions: function dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      };
    },
    saving: function saving() {
      return this.$store.state.services.saving;
    },
    currentDetailsId: function currentDetailsId() {
      return this.$store.state.services.details.id;
    },
    currentServiceLabel: function currentServiceLabel() {
      return this.$store.state.services.details.name;
    },
    _brandId: function _brandId() {
      return this.$route.params.brandId;
    },
    _serviceId: function _serviceId() {
      return this.$route.params.serviceId;
    }
  },
  methods: {
    setScreenSize: function setScreenSize() {
      var self = this;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        self.isMobile = true;
      } else {
        self.isMobile = false;
      }
    },
    cancelSelect: function cancelSelect() {
      var id = '';
      var self = this;
      self.activeService = id;
      self.transitionRightPanel = false;
    },
    getBrandsList: function getBrandsList() {
      var self = this;
      if (self.$store.state.brands.list.length) {
        return;
      }

      self.serviceLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__modules_api_brands__["a" /* default */].getBrands(self, function (res) {
        self.serviceLoading = false;
      });
    },
    changeBrand: function changeBrand() {
      var self = this;
      self.serviceLoading = true;
      self.activeService = '';
      self.transitionRightPanel = false;
      self.serviceAreaList = [];
      self.$plugins.storage.setServiceBrand(self.selectedBrand);
      self.$store.commit('services/setBrandId', self.selectedBrand);
      self.$store.commit('services/removeNewService');

      setTimeout(function () {
        self.serviceLoading = false;
      }, 300);
    },
    getServices: function getServices() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_5__modules_api_services__["a" /* default */].getAllService(self, function (r) {
        if (!r.error) {
          if (self.selectOnload) {
            self.$nextTick().then(function () {
              self.$forceUpdate();
              self.loadDetails(self.selectOnload);
              self.selectOnload = '';
            });
          } else {
            self.serviceLoading = false;
          }
        }
      });
    },
    initAddService: function initAddService() {
      var index = this.services.findIndex(function (x) {
        return x.id === 0;
      });
      if (index === -1) {
        this.activeService = '';
        this.$store.commit('services/addService', {
          id: 0,
          brandId: parseInt(this.selectedBrand),
          enable: false,
          label: 'New Service',
          code: 'new_service',
          color: '',
          allowTNC: true,
          allowTCP: false,
          isShared: false,
          poolP2P: false,
          poolFromAirport: false,
          poolToAirport: false,
          useShifts: false,
          optinAllow: false,
          optinPercent: 0,
          isRental: false,
          image: '',
          imageOff: '',
          name: 'New Service',
          maxPassengers: 1,
          maxLuggages: 1,
          excerptWeb: '',
          descriptionWeb: '',
          advantageWeb: '',
          stops: '',
          category: '',
          excerptApp: '',
          descriptionApp: '',
          slogan: '',
          defaultTip: 0,
          unavailableTimes: []
        });
        this.loadDetails(0);
      } else {
        this.loadDetails(0);
      }
    },
    positionChange: function positionChange() {
      this.serviceLoading = true;
      this.tempServiceList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.serviceList));
      this.updatePosition();
    },
    updatePosition: function updatePosition() {
      var self = this;
      if (self.tempServiceList.length) {
        var service = self.serviceList[self.tempServiceList.length - 1];
        __WEBPACK_IMPORTED_MODULE_5__modules_api_services__["a" /* default */].updatePosition(self, {
          id: service.id,
          priority: self.tempServiceList.length
        }, function (res) {
          self.tempServiceList.pop();
          self.updatePosition();
        });
      } else {
        // self.serviceLoading = false
        self.getServices();
      }
    },
    toggleServiceEnable: function toggleServiceEnable(id, enable) {
      var self = this;
      if (self.enabledLoading['a' + id] || self.serviceAreaLoading) {
        return;
      }
      self.enabledLoading['a' + id] = true;

      __WEBPACK_IMPORTED_MODULE_5__modules_api_services__["a" /* default */].toggleServiceEnable(self, {
        id: id,
        enabled: !enable
      }, function (res) {
        if (enable) {
          if (!self.serviceAreaList.length) {
            self.getAllServiceArea(id);
          } else {
            self.disabledOnAllServiceArea(id);
          }
          return;
        }
        self.enabledLoading['a' + id] = false;
        if (!res.error) {
          self.$forceUpdate();
          self.$nextTick().then(function () {
            self.$forceUpdate();
            self.serviceList = self.services;
          });
        }
      });
    },
    getAllServiceArea: function getAllServiceArea(id) {
      var self = this;
      self.serviceAreaLoading = true;
      self.$sdk.get('/servicearea', {
        token: self.$store.state.session.sessionToken,
        brandId: self.selectedBrand,
        status: 'active',
        order: 'priority',
        orderAsc: 1,
        pageNum: 1,
        pageSize: 9999
      }, function (res) {
        self.serviceAreaLoading = false;
        if (!res.error) {
          res.list.forEach(function (servicearea) {
            self.serviceAreaList.push(servicearea.id);
          });
          self.disabledOnAllServiceArea(id);
        }
      }, '2.0');
    },
    disabledOnAllServiceArea: function disabledOnAllServiceArea(id) {
      var self = this;
      if (self.serviceAreaList.length) {
        self.serviceAreaLoading = true;
        self.$sdk.post('/servicearea/' + self.serviceAreaList[0] + '/pricing', {
          token: self.$store.state.session.sessionToken,
          services: [{
            serviceTypeId: id,
            enabled: false
          }]
        }, function (res) {
          self.serviceAreaLoading = false;
          self.enabledLoading['a' + id] = false;
          if (res.error) {
            console.log('ERROR');
            return;
          }
          // self.serviceAreaList.shift()
          // if (self.serviceAreaList.length) {
          //   // self.disabledOnAllServiceArea(id)
          // } else {
          //   self.enabledLoading['a' + id] = false
          // }
        }, '2.0');
      }
    },
    loadDetails: function loadDetails(id) {
      var self = this;
      self.activeService = id;
      self.transitionRightPanel = false;
      var index = self.services.findIndex(function (x) {
        return x.id === id;
      });
      self.$store.commit('services/setDetails', this.services[index]);
      self.$store.commit('services/setServiceUnavailableData', {
        asap: this.services[index].unavailableTimeAsap,
        future: this.services[index].unavailableTimeFuture,
        p2p: this.services[index].unavailableTimP2p,
        fromAirport: this.services[index].unavailableTimFromAirport,
        toAirport: this.services[index].unavailableTimToAirport,
        startTime: this.services[index].unavailableTimeStart,
        endTime: this.services[index].unavailableTimeEnd
      });

      setTimeout(function () {
        if (self.$refs.serviceDetails.clearErrors()) {
          self.$refs.serviceDetails.clearErrors();
        }
        self.transitionRightPanel = true;
      }, 200);
    },
    showPreview: function showPreview() {
      this.$store.commit('services/setPreview', true);
    },
    selectColor: function selectColor() {
      this.color = this.colors.hex ? this.colors.hex.substring(1, this.colors.hex.length) : '000000';
      this.showColor = false;
    },
    save: function save() {
      var isNewService = this.$store.state.services.details.id === 0;
      if (isNewService) {
        if (this.$refs.serviceDetails.save()) {
          this.$refs.serviceDetails.save();
        }
      } else {
        if (this.$refs.serviceDetails.update()) {
          this.$refs.serviceDetails.update();
        }
      }
    },
    response: function response(data) {
      this.responseModal = data;
    },
    closeResponseModal: function closeResponseModal() {
      var self = this;
      this.responseModal.show = false;
      setTimeout(function () {
        self.responseModal = {
          show: false,
          status: '',
          message: '',
          extra: ''
        };
      }, 500);
    },
    revalidate: function revalidate() {
      if (this.$refs.serviceDetails.revalidate()) {
        this.$refs.serviceDetails.revalidate();
      }
    },
    showCloneModal: function showCloneModal() {
      this.cloneModal.show = true;
    },
    clone: function clone() {
      if (this.$refs.serviceDetails.clone(this.cloneModal.brand)) {
        this.$refs.serviceDetails.clone(this.cloneModal.brand);
      }
    },
    cloneResponse: function cloneResponse(data) {
      this.cloneModal = data;
    },
    closeCloneModal: function closeCloneModal() {
      this.cloneModal = {
        show: false,
        brand: '',
        status: '',
        message: '',
        extra: ''
      };
    },
    reRenderPreview: function reRenderPreview() {
      var self = this;
      self.renderPreview = false;
      self.$nextTick().then(function () {
        self.renderPreview = true;
      });
    },
    openDriverModal: function openDriverModal() {
      var self = this;
      self.closeResponseModal();
      self.driverModal.show = true;
      self.$store.commit('services/resetUsers');
      self.$store.commit('services/setUserCurrentPage', 1);
      self.$store.commit('services/setUserIsLoading', true);
      __WEBPACK_IMPORTED_MODULE_7__modules_api_provider_list__["a" /* default */].getList(self, {}, function (res) {
        self.$store.commit('services/setUserIsLoading', false);
        __WEBPACK_IMPORTED_MODULE_5__modules_api_services__["a" /* default */].getEnabledDrivers(self, {}, function (res) {});
      });
    },
    closeDriverModal: function closeDriverModal() {
      this.driverModal = {
        show: false
      };
    },
    showEnableDriverModal: function showEnableDriverModal(data) {
      this.enableDriverModal = data;
    },
    closeEnableDriverModal: function closeEnableDriverModal() {
      var self = this;
      self.enableDriverModal = {
        show: false,
        status: '',
        message: ''
      };
      self.closeDriverModal();
    }
  },
  watch: {
    _brandId: function _brandId(val) {
      this.$store.commit('services/setBrandId', parseInt(val));
    },
    services: function services(val) {
      this.serviceList = val;
    },
    _serviceId: function _serviceId(val) {
      this.selectOnload = parseInt(val);
    }
  },
  mounted: function mounted() {
    this.selectedBrand = this.$plugins.storage.getServiceBrand() || {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.default.brandId;
    if (this.$route.params.brandId) {
      this.selectedBrand = parseInt(this._brandId);
      this.$store.commit('services/setBrandId', this.selectedBrand);
    } else {
      this.$store.commit('services/setBrandId', parseInt(this.selectedBrand));
    }
    if (this.$route.params.serviceId) {
      this.selectOnload = parseInt(this._serviceId);
    }

    this.getBrandsList();
    this.getServices();
    this.setScreenSize();
  }
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PreviewWeb__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreviewMobile__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PreviewConsumer__ = __webpack_require__(1585);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import moment from 'moment'




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'preview',
  components: { previewWeb: __WEBPACK_IMPORTED_MODULE_0__PreviewWeb__["a" /* default */], previewMobile: __WEBPACK_IMPORTED_MODULE_1__PreviewMobile__["a" /* default */], previewConsumer: __WEBPACK_IMPORTED_MODULE_2__PreviewConsumer__["a" /* default */] },
  data: function data() {
    return {};
  },

  computed: {
    preview: function preview() {
      return this.$store.state.services.preview;
    },
    details: function details() {
      return this.$store.state.services.details;
    }
  },
  methods: {
    close: function close() {
      this.$store.commit('services/setPreview', false);
    }
  }
});

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'preview-web',
  props: ['details'],
  data: function data() {
    return {
      showDescription: false
    };
  },

  methods: {
    upDownstairs: function upDownstairs() {
      return this.details.allowTNC ? 'UPSTAIRS' : 'DOWNSTAIRS';
    }
  },
  watch: {}
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'preview-mobile',
  props: ['details'],
  computed: {
    licenseType: function licenseType() {
      console.log(this.$store.state.services.details);
    }
  },
  data: function data() {
    return {
      showDescription: false
    };
  },

  methods: {
    upDownstairs: function upDownstairs() {
      return this.details.allowTNC ? 'UPSTAIRS' : 'DOWNSTAIRS';
    }
  },
  watch: {}
});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['details'],
  name: 'preview-consumer'
});

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_services__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_color__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_autonumeric__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_autonumeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_autonumeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
// import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'



var minuteNow = parseInt(__WEBPACK_IMPORTED_MODULE_1_moment___default()().format('m'));
minuteNow = minuteNow % 5;
minuteNow = minuteNow > 0 ? 5 - minuteNow : 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'service-details',
  components: { 'photoshop-picker': __WEBPACK_IMPORTED_MODULE_2_vue_color__["Photoshop"], /*VueCtkDateTimePicker,*/VueAutonumeric: __WEBPACK_IMPORTED_MODULE_3_vue_autonumeric___default.a, datepicker: __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker___default.a },
  data: function data() {
    return {
      colors: '',
      licenseType: '',
      allowedTime: false,
      // timeStart: moment().add(minuteNow, 'minutes').format('HH:mm'),
      // timeEnd: moment().add(minuteNow + 5, 'minutes').format('HH:mm'),
      timeStart: '',
      timeEnd: '',
      timeOptions: {
        format: 'HH:mm',
        formatted: 'HH:mm',
        onlyTime: true,
        color: '#0D79F2',
        minuteInterval: '5',
        label: 'Select time',
        id: 'TimePicker',
        noLabel: true
      },
      showColor: false,
      sharedRideEnable: false,
      subscription: false,
      hourlyRate: false,
      imgUrl: '',
      imgOffUrl: '',
      uploadingImg: false,
      uploadingImgOff: false,
      temp: {
        id: '',
        imgUrl: '',
        imgOffUrl: ''
      },
      passenger: {
        minimumValue: '1',
        maximumValue: '100',
        decimalPlaces: 0
      },
      luggage: {
        minimumValue: '0',
        maximumValue: '100',
        decimalPlaces: 0
      },
      errors: {
        label: '',
        code: '',
        color: '',
        licenseType: '',
        imgUrl: '',
        imgOffUrl: '',
        name: '',
        maxPassengers: '',
        maxLuggages: '',
        excerptWeb: '',
        descriptionWeb: '',
        category: '',
        excerptApp: '',
        descriptionApp: '',
        slogan: '',
        defaultTip: ''
      },
      today: __WEBPACK_IMPORTED_MODULE_1_moment___default()(),
      disabledDate: '',
      serviceUnavailability: {
        p2p: false,
        fromAirport: false,
        toAirport: false,
        startTime: 0,
        endTime: 0
      },
      moreImages: {
        loading: false,
        uploads: []
      }
    };
  },

  computed: {
    services: function services() {
      return this.$store.state.services;
    },
    details: function details() {
      return this.services.details;
    },
    saving: function saving() {
      return this.services.saving;
    },
    disabledDates: function disabledDates() {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(this.today.subtract(1, 'months').format('YYYY'), this.today.format('MM'), this.today.format('DD'))
        };
      }

      return {
        to: new Date(this.today.format('YYYY'), this.today.subtract(1, 'months').format('MM'), this.today.format('DD'))
      };
    },
    unavailableTimes: function unavailableTimes() {
      return this.details.unavailableTimes;
    },
    moreImgs: function moreImgs() {
      return this.details.images;
    },
    serviceUnavailable: function serviceUnavailable() {
      return this.services.serviceUnavailable;
    }
  },
  methods: {
    selectColor: function selectColor() {
      var color = this.colors.hex ? this.colors.hex.substring(1, this.colors.hex.length) : '000000';
      this.$store.commit('services/setDetailsData', {
        field: 'color',
        value: '#' + color
      });
      this.showColor = false;
    },
    triggerClickUpload: function triggerClickUpload(ref) {
      if (this.saving) {
        return;
      }
      this.$refs[ref].click();
    },
    uploadImg: function uploadImg(e, target) {
      if (!e.target.files.length) {
        return;
      }
      // this.uploadingImg = true
      this['uploading' + target] = true;

      var self = this;
      var file = e.target.files[0];
      var fd = new FormData();
      fd.append('pic', file);

      self.$http.post({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.mediaHost + '/api/upload', fd, {
        header: { 'Content-Type': 'multipart/form-data' }
      }).then(function (res) {
        self['uploading' + target] = false;
        if (!res.body.success) {
          // self.$store.commit('provider/showUploadError', true)
        } else {
          if (target === 'ImgOff') {
            self.imgOffUrl = res.body.data.url;
            self.$store.commit('services/setDetailsData', {
              field: 'imageOff',
              value: res.body.data.url
            });
            self.resetInputFile('uploadImgOff');
          } else {
            self.imgUrl = res.body.data.url;
            self.$store.commit('services/setDetailsData', {
              field: 'image',
              value: res.body.data.url
            });
            self.resetInputFile('uploadImg');
          }
        }
      }, function (res) {
        console.log('error', res);
        // self.$store.commit('provider/showUploadError', true)
      });
    },
    resetInputFile: function resetInputFile(ref) {
      this.$refs[ref].type = 'text';
      this.$refs[ref].type = 'file';
    },
    validate: function validate() {
      var _this = this;

      var noError = true;
      var requireFields = ['label', 'code', 'color', 'name', 'excerptWeb', 'descriptionWeb', 'excerptApp', 'descriptionApp', 'slogan', 'category'];

      this.errors = {
        label: '',
        code: '',
        color: '',
        licenseType: '',
        imgUrl: '',
        imgOffUrl: '',
        name: '',
        maxPassengers: '',
        maxLuggages: '',
        excerptWeb: '',
        descriptionWeb: '',
        category: '',
        excerptApp: '',
        descriptionApp: '',
        slogan: '',
        defaultTip: ''
      };

      requireFields.forEach(function (field) {
        if (_this.details[field].trim() === '') {
          _this.errors[field] = 'This field cannot be empty.';
          noError = false;
        }
      });

      if (this.details.defaultTip < 0) {
        this.errors.defaultTip = 'Value cannot be less than zero';
      }

      // if (!this.licenseType) {
      //   noError = false
      //   this.errors.licenseType = 'Must select license type'
      // }
      if (!this.details.allowTNC && !this.details.allowTCP && !this.details.allowPSC) {
        noError = false;
        this.errors.licenseType = 'Must select atleast 1 license type';
      }

      if (this.imgUrl.trim() === '') {
        noError = false;
        this.errors.imgUrl = 'Please provide an image for this service';
      }
      if (this.imgOffUrl.trim() === '') {
        noError = false;
        this.errors.imgOffUrl = 'Please provide an image for this service';
      }

      return noError;
    },
    save: function save() {
      var self = this;
      if (!this.validate() || this.saving) {
        return;
      }

      self.$store.commit('services/setSaving', true);
      __WEBPACK_IMPORTED_MODULE_0__modules_api_services__["a" /* default */].addService(self, function (res) {
        self.$store.commit('services/setSaving', false);
        var response = {
          show: true,
          status: 'success',
          message: 'Successfully created a service!',
          extra: ''
        };
        if (res.error) {
          response.status = 'error';
          response.message = 'Oops! Something went wrong...';
          response.extra = res.error.message;
        }
        self.$emit('response', response);
      });
    },
    update: function update() {
      var self = this;
      if (!this.validate() || this.saving) {
        return;
      }

      self.$store.commit('services/setSaving', true);
      __WEBPACK_IMPORTED_MODULE_0__modules_api_services__["a" /* default */].updateService(self, self.details, function (res) {
        self.$store.commit('services/setSaving', false);
        var response = {
          show: true,
          status: 'success',
          message: 'Successfully updated!',
          extra: ''
        };
        if (res.error) {
          response.status = 'error';
          response.message = 'Oops! Something went wrong...';
          response.extra = res.error.message;
        }
        self.$emit('response', response);
      });
    },
    revalidate: function revalidate() {
      if (this.validate()) {
        this.$emit('revalidate');
      }
    },
    clone: function clone(brandId) {
      var self = this;
      if (!this.validate() || this.saving) {
        return;
      }

      self.$store.commit('services/setSaving', true);
      __WEBPACK_IMPORTED_MODULE_0__modules_api_services__["a" /* default */].cloneService(self, brandId, function (res) {
        self.$store.commit('services/setSaving', false);
        var response = {
          show: true,
          brand: brandId,
          status: 'success',
          message: 'Clone Success!',
          extra: ''
        };
        if (res.error) {
          response.status = 'error';
          response.message = 'Oops! Something went wrong...';
          response.extra = res.error.message;
        }
        self.$emit('clone', response);
      });
    },
    clearErrors: function clearErrors() {
      this.errors = {
        label: '',
        code: '',
        color: '',
        licenseType: '',
        imgUrl: '',
        imgOffUrl: '',
        name: '',
        maxPassengers: '',
        maxLuggages: '',
        excerptWeb: '',
        descriptionWeb: '',
        category: '',
        excerptApp: '',
        descriptionApp: '',
        slogan: ''
      };
    },
    isNumber: function isNumber(evt) {
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode === 46) {
        return true;
      }
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
        return;
      }
      return true;
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('MM/DD/YYYY');
    },
    addDisabledDate: function addDisabledDate() {
      if (!this.disabledDate) return;

      var newVal = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.disabledDate).format('MM/DD/YYYY');
      if (this.unavailableTimes.indexOf(newVal) === -1) {
        this.$store.commit('services/addUnavailableTimes', newVal);
        this.disabledDate = '';
      }
    },
    removeDisabledDate: function removeDisabledDate(x) {
      this.$store.commit('services/removeUnavailableTimes', x);
    },
    uploadMoreStart: function uploadMoreStart(e) {
      if (!e.target.files.length || this.moreImages.loading) return;

      var self = this;
      for (var i = 0; i < e.target.files.length; i++) {
        self.moreImages.uploads.push(e.target.files[i]);
      }
      self.moreImages.loading = true;
      self.processUploadMore();
    },
    processUploadMore: function processUploadMore() {
      var self = this;
      if (!self.moreImages.uploads.length) {
        self.moreImages.loading = false;
        return;
      }

      var fd = new FormData();
      fd.append('pic', self.moreImages.uploads[0]);

      self.$http.post({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.mediaHost + '/api/upload', fd, {
        header: { 'Content-Type': 'multipart/form-data' }
      }).then(function (res) {
        self.moreImages.uploads.shift();
        if (!res.body.success) {} else {
          self.$store.commit('services/addMoreImgs', res.body.data.url);
        }
        self.processUploadMore();
      }, function (res) {
        console.log('error', res);
        self.moreImages.uploads.shift();
        self.processUploadMore();
      });
    },
    removeMoreImg: function removeMoreImg(x) {
      this.$store.commit('services/removeMoreImgs', x);
    },
    leadingZero: function leadingZero(x) {
      return x < 10 ? '0' + x : x;
    }
  },
  watch: {
    details: function details(value) {
      if (value) {
        if (value.id !== this.temp.id) {
          this.temp = {
            id: value.id,
            imgUrl: value.image,
            imgOffUrl: value.imageOff
          };
          this.imgUrl = value.image;
          this.imgOffUrl = value.imageOff;
        }
        this.colors = { hex: value.color };
        this.resetInputFile('moreImages');

        // if (value.allowTNC) {
        //   this.licenseType = 'TNC'
        // } else if (value.allowTCP) {
        //   this.licenseType = 'TCP'
        // } else if (value.allowPSC) {
        //   this.licenseType = 'PSC'
        // }
      }
    },
    licenseType: function licenseType(value) {
      // if (value) {
      //   this.$store.commit('services/setDetailsData', {field: 'allowTNC', value: false})
      //   this.$store.commit('services/setDetailsData', {field: 'allowTCP', value: false})
      //   this.$store.commit('services/setDetailsData', {field: 'allowPSC', value: false})

      //   this.$store.commit('services/setDetailsData', {field: 'allow' + value, value: true})
      //   this.$emit('fieldChange')
      // }
    },

    'details.isShared': function detailsIsShared(val) {
      if (val) {
        this.details.optinAllow = false;
      }
    },
    'details.isCharter': function detailsIsCharter(val) {
      if (val) {
        this.details.isShared = false;
        this.details.optinAllow = false;
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_provider_list__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_services__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'enable-drivers',
  data: function data() {
    return {
      searchInput: '',
      blurDelay: ''
    };
  },

  computed: {
    checked: {
      get: function get() {
        return this.$store.state.services.checked;
      },
      set: function set(value) {
        this.$store.commit('services/setCheck', value);
      }
    },
    enabledDrivers: function enabledDrivers() {
      return this.$store.state.services.enabledDrivers;
    },
    drivers: function drivers() {
      return this.$store.state.services.users.list;
    },

    perPage: {
      get: function get() {
        return this.$store.state.services.users.perPage;
      },
      set: function set(value) {
        this.$store.commit('services/setUserPerPage', parseInt(value));
        this.$store.commit('services/setUserCurrentPage', 1);
        this.getList();
      }
    },
    pageData: function pageData() {
      var tableData = this.$store.state.services.users;
      var start = tableData.currentPage * tableData.perPage - (tableData.perPage - 1);
      var end = tableData.currentPage * tableData.perPage;
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      };
    },
    loading: function loading() {
      return this.$store.state.services.users.isLoading;
    },

    currentPage: {
      get: function get() {
        return this.$store.state.services.users.currentPage;
      },
      set: function set(value) {
        this.$store.commit('services/setUserCurrentPage', parseInt(value));
        this.getList();
      }
    },
    currentOrder: function currentOrder() {
      var prov = this.$store.state.services.users;
      return { field: prov.order, asc: prov.orderAsc };
    },
    isLastPage: function isLastPage() {
      var prov = this.$store.state.services.users;
      return prov.currentPage * prov.perPage >= prov.maxList;
    },
    totalPage: function totalPage() {
      var prov = this.$store.state.services.users;
      return Math.ceil(prov.maxList / prov.perPage);
    },

    statusTable: {
      get: function get() {
        return this.$store.state.services.users.status;
      },
      set: function set(value) {
        this.$store.commit('services/setUserStatus', value);
        this.refreshTable();
      }
    },
    type: {
      get: function get() {
        return this.$store.state.services.users.type;
      },
      set: function set(value) {
        this.$store.commit('services/setUserType', value);
        this.refreshTable();
      }
    }
  },
  methods: {
    checkedDriver: function checkedDriver(id) {
      if (this.enabledDrivers.length < 0) {
        return;
      }
      return this.enabledDrivers.filter(function (x) {
        return x === id;
      }).length > 0;
    },
    search: function search() {
      this.$store.commit('services/setUserSearch', this.searchInput);
      this.refreshTable();
    },
    blurSearch: function blurSearch() {
      var self = this;
      if (self.$store.state.services.users.search === self.searchInput.trim()) {
        return;
      }

      self.blurDelay = setTimeout(function () {
        self.search();
      }, 500);
    },
    getList: function getList() {
      var self = this;
      if (self.loading) {
        return;
      }

      self.$store.commit('services/resetUsers');
      self.$store.commit('services/setUserIsLoading', true);
      __WEBPACK_IMPORTED_MODULE_0__modules_api_provider_list__["a" /* default */].getList(self, {}, function (res) {
        self.$store.commit('services/setUserIsLoading', false);
        var listedDrivers = self.drivers.map(function (x) {
          return x.id;
        });
        if (listedDrivers.every(function (x) {
          return self.enabledDrivers.includes(x);
        })) {
          self.checked = true;
        } else {
          self.checked = false;
        }
      });
    },
    selectDriver: function selectDriver(id) {
      var self = this;
      if (!self.enabledDrivers.includes(id)) {
        self.enabledDrivers.push(id);
      } else {
        self.enabledDrivers.splice(self.enabledDrivers.indexOf(id), 1);
        self.checked = false;
      }

      if (self.enabledDrivers.length === 0) {
        self.checked = false;
      }
      var drivers = self.drivers.map(function (x) {
        return x.id;
      });
      if (drivers.every(function (id) {
        return self.enabledDrivers.includes(id);
      })) {
        self.checked = true;
      }
    },
    closeDriverModal: function closeDriverModal() {
      this.clearSearch();
      this.$emit('clicked');
    },
    prev: function prev() {
      if (this.currentPage === 1) {
        return;
      }
      this.$store.commit('services/setUserCurrentPage', this.$store.state.services.users.currentPage - 1);
      this.getList();
    },
    next: function next() {
      if (this.isLastPage) {
        return;
      }
      this.$store.commit('services/setUserCurrentPage', this.$store.state.services.users.currentPage + 1);
      this.getList();
    },
    clearSearch: function clearSearch() {
      if (this.blurDelay) {
        clearTimeout(this.blurDelay);
      }
      if (this.loading) {
        return;
      }
      this.searchInput = '';
      this.$store.commit('services/setUserSearch', this.searchInput);
      this.refreshTable();
    },
    refreshTable: function refreshTable() {
      var self = this;
      if (self.loading) {
        return;
      }

      self.$store.commit('services/setUserIsLoading', true);
      self.$store.commit('services/resetUsers');
      self.$store.commit('services/setUserCurrentPage', 1);

      __WEBPACK_IMPORTED_MODULE_0__modules_api_provider_list__["a" /* default */].getList(self, {}, function (res) {
        self.$store.commit('services/setUserIsLoading', false);
        var listedDrivers = self.drivers.map(function (x) {
          return x.id;
        });
        if (listedDrivers.every(function (x) {
          return self.enabledDrivers.includes(x);
        })) {
          self.checked = true;
        } else {
          self.checked = false;
        }
      });
    },
    selectAll: function selectAll() {
      var self = this;
      self.checked = !self.checked;
      var checkedDrivers = self.enabledDrivers;
      if (self.checked) {
        self.drivers.forEach(function (x) {
          if (!checkedDrivers.includes(x.id)) {
            checkedDrivers.push(x.id);
          }
        });
      } else {
        self.drivers.forEach(function (x) {
          checkedDrivers.splice(self.enabledDrivers.indexOf(x.id), 1);
        });
      }
      self.$store.commit('services/setEnabledDrivers', checkedDrivers);
    },
    save: function save() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1__modules_api_services__["a" /* default */].updateEnabledDrivers(self, {}, function (res) {
        var response = {
          show: true,
          status: 'success',
          message: 'Enabled Success!',
          extra: ''
        };
        if (res.error) {
          response.status = 'error';
          response.message = 'Oops! Something went wrong...';
          response.extra = res.error.message;
        }
        self.$emit('enableModal', response);
      });
    }
  },
  mounted: function mounted() {
    // let self = this
    // self.$store.commit('services/setUserCurrentPage', 1)
  }
});

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GeofenceList__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GeofenceMap2__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GeofenceCreate__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GeofencePriority__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GeofencePromoPrices__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_api_services__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modal__ = __webpack_require__(1648);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import GeofenceMap from './GeofenceMap'







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'geofences',
  components: { GeofenceList: __WEBPACK_IMPORTED_MODULE_0__GeofenceList__["a" /* default */], GeofenceMap2: __WEBPACK_IMPORTED_MODULE_1__GeofenceMap2__["a" /* default */], GeofenceCreate: __WEBPACK_IMPORTED_MODULE_2__GeofenceCreate__["a" /* default */], GeofencePriority: __WEBPACK_IMPORTED_MODULE_3__GeofencePriority__["a" /* default */], GeofencePromoPrices: __WEBPACK_IMPORTED_MODULE_4__GeofencePromoPrices__["a" /* default */], Modal: __WEBPACK_IMPORTED_MODULE_6__Modal__["a" /* default */] },
  data: function data() {
    return {
      showMapMobile: false
    };
  },

  methods: {
    getBrands: function getBrands() {
      var self = this;
      if (!self.$store.state.brands.list.length) {
        // self.serviceLoading = true
        self.$sdk.get('/brand', {}, function (res) {
          if (res.error) {
            return;
          }

          if (res.length) {
            self.$store.commit('brands/setList', res);
            if (!self.$store.state.services.list.length) {
              self.getServices();
              return;
            }
            // self.serviceLoading = false
          }
        });
      } else {
        self.getServices();
      }
    },
    getServices: function getServices() {
      var self = this;
      // self.serviceLoading = true
      __WEBPACK_IMPORTED_MODULE_5__modules_api_services__["a" /* default */].getAllService(self, function (r) {
        // self.serviceLoading = false
      });
    }
  },
  mounted: function mounted() {
    this.getBrands();
  }
});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GeofenceFields__ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GeofenceFilters__ = __webpack_require__(1625);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'geofence-list',
  components: { GeofenceFields: __WEBPACK_IMPORTED_MODULE_0__GeofenceFields__["a" /* default */], GeofenceFilters: __WEBPACK_IMPORTED_MODULE_1__GeofenceFilters__["a" /* default */] },
  data: function data() {
    return {
      loadOtherData: []
    };
  },

  computed: {
    geofences: function geofences() {
      return this.$store.state.geofences.geofences.items;
    },
    isLoading: function isLoading() {
      return this.$store.state.geofences.geofences.loading;
    },

    polygons: {
      get: function get() {
        var result = [];
        var polygons = this.$store.state.geofences.map.polygons;

        for (var i = 0; i < polygons.length; i++) {
          result.push(polygons[i].id);
        }

        return result;
      },
      set: function set(values) {
        var self = this;

        var result = [];
        for (var i = 0; i < self.geofences.length; i++) {
          var geofence = self.geofences[i];

          for (var j = 0; j < values.length; j++) {
            var value = values[j];
            if (geofence.id !== value) {
              continue;
            }

            var color = geofence.overlayColor || geofence.color;
            result.push({
              id: geofence.id,
              points: geofence.polygon,
              color: '#' + color.toUpperCase()
            });
          }
        }
        self.$store.commit('geofences/setPolygon', result);
      }
    },
    filterType: function filterType() {
      return this.$store.state.geofences.filters.type;
    }
  },
  methods: {
    formatGeofenceType: function formatGeofenceType(type) {
      if (type === 'servicearea') {
        return 'SERVICE AREA GEOFENCE';
      }
      return type.toUpperCase() + ' GEOFENCE';
    },
    toggleForm: function toggleForm(index, id) {
      var self = this;
      self.geofences[index].showForm = !self.geofences[index].showForm;

      if (self.geofences[index].showForm) {
        if (self.$refs['geofenceField' + index][0].getInfo()) {
          self.$refs['geofenceField' + index][0].getInfo();
        }
      }

      if (self.filterType === 'airport') {
        self.loadOtherData[index] = self.geofences[index].showForm;
      }
    }
  },
  watch: {
    geofences: function geofences(value) {
      this.loadOtherData = [];
    }
  }
});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GeofenceFieldsAirport__ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GeofenceFieldsRestricted__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GeofenceFieldsServiceArea__ = __webpack_require__(1616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GeofenceFieldsStaging__ = __webpack_require__(1620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_color__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_csvexport__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */
var request = __webpack_require__(13);







var exporter = __WEBPACK_IMPORTED_MODULE_5_csvexport___default.a.create({
  filename: 'export.csv',
  columns: ['Airline Name', 'Terminal', 'Airline Code']
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'geofence-fields',
  props: ['geofence', 'loadOtherData'],
  components: {
    GeofenceFieldsAirport: __WEBPACK_IMPORTED_MODULE_0__GeofenceFieldsAirport__["a" /* default */], GeofenceFieldsRestricted: __WEBPACK_IMPORTED_MODULE_1__GeofenceFieldsRestricted__["a" /* default */], GeofenceFieldsServiceArea: __WEBPACK_IMPORTED_MODULE_2__GeofenceFieldsServiceArea__["a" /* default */],
    GeofenceFieldsStaging: __WEBPACK_IMPORTED_MODULE_3__GeofenceFieldsStaging__["a" /* default */], 'photoshop-picker': __WEBPACK_IMPORTED_MODULE_4_vue_color__["Photoshop"]
  },
  data: function data() {
    return {
      airportAssocioation: '',
      airportAssocioationLoading: false,
      loading: false,
      message: '',
      success: false,
      upload: {
        kml: {
          loading: false,
          message: '',
          success: false
        },
        csv: {
          loading: false,
          message: '',
          success: false
        },
        target: '',
        action: ''
      },
      navigationAddressObject: '',
      navigationAddress: '',
      navigationAddressLoading: false,
      lastNaviationAddress: '',
      tmpLastNavAddress: '',
      centerpoint: '',
      lastCenterpoint: '',
      // autocomplete: new google.maps.places.AutocompleteService(), // eslint-disable-line no-undef
      // geocoder: new google.maps.Geocoder(), // eslint-disable-line no-undef
      queryToken: null,
      suggestions: [],
      showSuggestion: false,
      clickOutDelay: '',
      overlayColor: '',
      showOverlayColor: false,
      error: {
        navigationAddress: ''
      },
      formError: {
        show: false,
        items: []
      },
      isP2P: false,
      uploading: {
        tnc: false,
        tcp: false
      },
      manualCoords: ''
    };
  },

  computed: {
    geofenceStatus: function geofenceStatus() {
      return this.$store.state.geofences.filters.status;
    },
    geofenceType: function geofenceType() {
      return this.$store.state.geofences.filters.type;
    }
  },
  methods: {
    getInfo: function getInfo() {
      this.getNavigationAdress();
      if (this.geofence.type !== 'airport') {
        this.getAirportAssocation();
      }
    },
    getNavigationAdress: function getNavigationAdress() {
      var self = this;
      if (self.navigationAddressLoading) {
        return;
      }

      self.navigationAddressLoading = true;
      self.$sdk.get('/geofences/' + self.geofence.id, {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.navigationAddressLoading = false;
        if (r.error) {
          return;
        }

        self.tmpLastNavAddress = r.location;
        var loc = r.location;
        self.navigationAddress = loc.addressLine1;
        if (!!loc.addressLine2) {
          self.navigationAddress += ' ' + loc.addressLine2;
        }
        self.navigationAddress += ', ' + loc.city + ', ' + loc.state + ' ' + loc.zipCode;

        self.lastNaviationAddress = self.navigationAddress;
        self.lastCenterpoint = loc.lat + ',' + loc.lng;
        self.manualCoords = r.lat + ', ' + r.lng;
      });
    },
    getAirportAssocation: function getAirportAssocation() {
      var self = this;
      if (self.airportAssocioationLoading) {
        return;
      }

      self.airportAssocioationLoading = true;
      self.$sdk.get('/geofences/' + self.geofence.id + '/airport', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.airportAssocioationLoading = false;
        if (r.error) {
          console.log(r.error);
          return;
        }

        self.airportAssocioation = r.airports[0] ? r.airports[0].name : 'none';
        self.isP2P = r.airports.length <= 0;
        self.$store.commit('geofences/setGeofenceIsP2P', {
          id: self.geofence.id,
          value: r.airports.length <= 0
        });
      });
    },
    toggleOverlayColor: function toggleOverlayColor() {
      this.showOverlayColor = !this.showOverlayColor;
      if (this.overlayColorDelay) {
        clearTimeout(this.overlayColorDelay);
      }
    },
    selectColor: function selectColor() {
      this.geofence.overlayColor = this.overlayColor.hex.substring(1, this.overlayColor.hex.length);
      this.showOverlayColor = false;
    },
    query: function query() {
      var self = this;

      var queryText = self.navigationAddress;
      if (queryText === '') {
        self.queryToken = null;
        self.suggestions = [];
        self.showSuggestion = false;
        return;
      }

      // self.generateQueryToken()

      self.showSuggestion = true;
      var restrictedTypes = ['locality', 'postalCodePoint', 'administrativeArea', 'chainQuery', 'categoryQuery'];

      var url = 'https://autosuggest.search.hereapi.com/v1/autosuggest?at={AT}&q={SEARCH}&apiKey={API_KEY}&lang=en-US';
      url = url.replace('{AT}', encodeURIComponent(33.942791 + ',' + -118.410042)).replace('{SEARCH}', queryText).replace('{API_KEY}', {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key);
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err || body.items.length === 0) {
          self.suggestions = [{
            icon: 'fa-exclamation-triangle',
            title: 'Sorry',
            subtitle: 'We coudn\'t locate "' + queryText + '"'
          }];
          return;
        }

        var result = [];
        body.items.forEach(function (prediction) {
          if (restrictedTypes.indexOf(prediction.resultType) === -1) {
            var subtitle = prediction.address.label;
            result.push({
              id: prediction.id,
              title: prediction.title,
              subtitle: subtitle,
              icon: 'fa-map-marker'
            });
          }
        });

        self.suggestions = result.slice(0, 5);
      });
    },
    clickOut: function clickOut() {
      var self = this;
      self.clickOutDelay = setTimeout(function () {
        self.centerpoint = self.lastCenterpoint;
        if (self.navigationAddress !== self.lastNaviationAddress) {
          self.centerpoint = '';
          self.manualCoords = '';
        }
        self.showSuggestion = false;
      }, 300);
    },
    selectLocation: function selectLocation(index) {
      var self = this;
      var place = self.suggestions[index];
      self.queryToken = null;

      clearTimeout(self.clickOutDelay);
      self.showSuggestion = false;

      var url = 'https://lookup.search.hereapi.com/v1/lookup?source=sharing&id={LOCATION_ID}&locationattributes=tz&apiKey={API_KEY}&lang=en-US';
      url = url.replace('{LOCATION_ID}', place.id).replace('{API_KEY}', {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key);
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) {
          console.log('geocode ERROR', results, status);
          self.loading = false;
          return;
        }

        var result = body;
        var lat = result.position.lat;
        var lng = result.position.lng;
        self.centerpoint = lat + ', ' + lng;
        self.manualCoords = lat + ', ' + lng;

        var navigationAddressObject = {
          title: result.title,
          address1: result.address.street || result.title,
          address2: result.address.houseNumber || result.address.district,
          city: result.address.city,
          state: result.address.state,
          zip: result.address.postalCode,
          country: result.address.countryCode,
          lat: lat,
          lng: lng
        };

        self.geofence.addressLine1 = self.navigationAddressObject.address1;
        self.geofence.addressLine2 = self.navigationAddressObject.address2;
        self.geofence.city = self.navigationAddressObject.city;
        self.geofence.state = self.navigationAddressObject.state;
        self.geofence.zipCode = self.navigationAddressObject.zip;
        self.geofence.lat = self.navigationAddressObject.lat;
        self.geofence.lng = self.navigationAddressObject.lng;

        self.navigationAddressObject = navigationAddressObject;
        self.navigationAddress = self.navigationAddressObject.title;
        self.lastNaviationAddress = self.navigationAddress;
        self.lastCenterpoint = self.centerpoint;
      });
    },
    toggleEnabled: function toggleEnabled() {
      var self = this;
      var url = self.$store.state.geofences.filters.status === 'active' ? '/deactivate' : '/activate';

      var isActivate = !self.geofence.enabled;
      if (isActivate && !self.isGeofenceValid()) {
        return;
      }

      self.loading = true;
      self.message = '';

      setTimeout(function () {
        self.scrollToLoading();
      }, 200);

      self.$sdk.post('/geofences/' + self.geofence.id + url, {
        token: self.$store.state.session.sessionToken
      }, function (res) {
        setTimeout(function () {
          self.loading = false;
        }, 2000);
        if (res.error) {
          self.message = res.error.msg;
          self.success = false;
          return;
        }

        self.message = self.geofence.enabled ? 'Geofence Deactivated!' : 'Geofence Activated!';
        self.success = true;
        self.$store.commit('geofences/setRefreshList', true);
      });
    },
    toggleArchived: function toggleArchived() {
      var self = this;
      var url = self.geofenceStatus === 'archived' ? '/unarchive' : '/archive';

      var isActivate = !self.geofence.enabled;
      if (isActivate && !self.isGeofenceValid()) {
        return;
      }

      if (self.loading) {
        return true;
      }

      self.loading = true;
      self.message = '';

      setTimeout(function () {
        self.scrollToLoading();
      }, 200);

      self.$sdk.post('/geofences/' + self.geofence.id + url, {
        token: self.$store.state.session.sessionToken
      }, function (res) {
        setTimeout(function () {
          self.loading = false;
        }, 2000);
        if (res.error) {
          self.message = res.error.msg;
          self.success = false;
          return;
        }

        self.message = self.geofence.enabled ? 'Geofence Unarchived!' : 'Geofence Archived!';
        self.success = true;
        self.$store.commit('geofences/setRefreshList', true);
      });
    },
    save: function save() {
      var _this = this;

      var self = this;
      if (self.loading) {
        return true;
      }

      // validation
      if (!self.isGeofenceValid()) {
        return;
      }

      var data = self.geofence;
      data.token = self.$store.state.session.sessionToken;
      if (self.geofence.type === 'airport') {
        data.airportPickupInstructions = self.geofence.pickupInstructions.instructions;
      }

      if (data.stagingLots) {
        delete data.stagingLots;
      }
      if (data.restrictedAreas) {
        delete data.restrictedAreas;
      }
      if (data.serviceAreas) {
        delete data.serviceAreas;
      }

      data.token = self.$store.state.session.sessionToken;
      self.loading = true;
      self.message = '';

      setTimeout(function () {
        self.scrollToLoading();
      }, 200);

      data.location = {
        address1: self.tmpLastNavAddress.addressLine1,
        address2: self.tmpLastNavAddress.addressLine2,
        city: self.tmpLastNavAddress.city,
        state: self.tmpLastNavAddress.state,
        zip: self.tmpLastNavAddress.zipCode,
        lat: self.tmpLastNavAddress.lat,
        lng: self.tmpLastNavAddress.lng
      };
      if (self.navigationAddressObject) {
        data.location = {
          address1: self.navigationAddressObject.address1,
          address2: self.navigationAddressObject.address2,
          city: self.navigationAddressObject.city,
          state: self.navigationAddressObject.state,
          zip: self.navigationAddressObject.zip,
          lat: self.navigationAddressObject.lat,
          lng: self.navigationAddressObject.lng
        };
      }
      data.centerPoint = data.lat + ', ' + data.lng;
      if (!data.lat && self.tmpLastNavAddress && self.tmpLastNavAddress.lat) data.centerPoint = self.tmpLastNavAddress.lat + ', ' + self.tmpLastNavAddress.lng;
      if (self.manualCoords) data.centerPoint = self.manualCoords;

      self.$sdk.post('/geofences/' + self.geofence.id, data, function (res) {
        if (res.error) {
          self.loading = false;
          self.formError.items.push(res.error.message);
          self.formError.show = true;
          return;
        }

        if (self.geofence.type === 'staging' || self.geofence.type === 'restricted') {
          var services = _this.$store.state.services.list.filter(function (x) {
            return x.brandId && x.enabled;
          });
          var saveServices = [];
          services.forEach(function (service) {
            saveServices.push({
              serviceTypeId: service.id,
              enabled: data.serviceTypeIds.indexOf(service.id) > -1
            });
          });
          self.$sdk.post('/servicearea/' + self.geofence.id + '/pricing', {
            token: self.$store.state.session.sessionToken,
            services: saveServices
          }, function (res) {
            if (res.error) {
              self.loading = false;
              self.formError.items.push(res.error.message);
              self.formError.show = true;
              return;
            }

            self.message = 'Save successfully!';
            self.success = true;
            setTimeout(function () {
              self.loading = false;
            }, 2000);
          }, '2.0');
        } else {
          self.message = 'Save successfully!';
          self.success = true;
          setTimeout(function () {
            self.loading = false;
          }, 2000);
        }
      });
    },
    closeModal: function closeModal() {
      self.loading = false;
      self.message = '';
    },
    scrollToLoading: function scrollToLoading() {
      var elmnt = document.getElementById('scrollHere');
      elmnt.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    triggerCSVUpload: function triggerCSVUpload() {
      this.upload.target = 'csv';
      this.upload.action = 'upload';
      this.$refs.csvUpload.click();
    },
    triggerKMLUpload: function triggerKMLUpload() {
      this.upload.target = 'kml';
      this.upload.action = 'upload';
      this.$refs.kmlUpload.click();
    },
    downloadCSV: function downloadCSV() {
      var self = this;
      self.upload.target = 'csv';
      this.upload.action = 'download';
      self.upload.csv.loading = true;
      self.$sdk.get('/geofences/' + self.geofence.id + '/airlines', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.upload[self.upload.target].loading = false;
        if (r.error) {
          self.formError.items.push(res.error.message);
          self.formError.show = true;
          return;
        }

        var airlines = [];
        for (var i in r.list) {
          airlines.push({
            'Airline Name': r.list[i].name,
            'Terminal': r.list[i].terminalInfo,
            'Airline Code': r.list[i].code
          });
        }
        self.upload[self.upload.target].message = '';
        self.upload[self.upload.target].success = true;
        exporter.downloadCsv(airlines);
      });
    },
    uploadKML: function uploadKML() {
      this.formError = {
        show: false,
        items: []
      };
      if (!this.$refs.kmlUpload.files.length) {
        this.save();
        return;
      }

      var self = this;
      var file = self.$refs.kmlUpload.files[0];
      var fd = new FormData();
      fd.append('pic', file);

      self.upload[self.upload.target].loading = true;
      self.upload[self.upload.target].message = '';

      self.$http.post({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.mediaHost + '/api/upload', fd, {
        header: { 'Content-Type': 'multipart/form-data' }
      }).then(function (res) {
        if (!res.body.success) {
          self.loading = false;
          self.upload[self.upload.target].message = 'Upload fail. Please try again.';
          self.upload[self.upload.target].success = false;
          self.upload[self.upload.target].loading = false;
          return;
        }

        self.updateKML(res.body.data.url);
      }, function (res) {
        console.log('error', res);
      });
    },
    uploadFile: function uploadFile(e) {
      if (!e.target.files.length) {
        return;
      }

      var self = this;
      var file = e.target.files[0];
      var fd = new FormData();
      fd.append('pic', file);

      self.upload[self.upload.target].loading = true;
      self.upload[self.upload.target].message = '';

      self.$http.post({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.mediaHost + '/api/upload', fd, {
        header: { 'Content-Type': 'multipart/form-data' }
      }).then(function (res) {
        if (!res.body.success) {
          self.upload[self.upload.target].message = 'Upload fail. Please try again.';
          self.upload[self.upload.target].success = false;
          self.upload[self.upload.target].loading = false;
          return;
        }

        if (self.upload.target === 'kml') {
          self.updateKML(res.body.data.url);
        }
        if (self.upload.target === 'csv') {
          self.updateAirlineCSV(res.body.data.url);
        }
      }, function (res) {
        console.log('error', res);
      });
    },
    updateKML: function updateKML(url) {
      var self = this;
      self.$sdk.post('/geofences/' + self.geofence.id + '/polygon', {
        token: self.$store.state.session.sessionToken,
        kmlUrl: url,
        lat: self.geofence.lat,
        lng: self.geofence.lng
      }, function (r) {
        self.upload[self.upload.target].loading = false;
        if (r.error) {
          self.loading = false;
          self.formError.items.push(r.error.message);
          self.formError.show = true;
          return;
        }

        self.geofence.kmlFile = url;
        self.upload[self.upload.target].message = 'KML update success.';
        self.upload[self.upload.target].success = true;

        self.save();
      });
    },
    updateAirlineCSV: function updateAirlineCSV(url) {
      var self = this;
      self.$sdk.post('/airports/' + self.geofence.id + '/airlines', {
        token: self.$store.state.session.sessionToken,
        csvUrl: url
      }, function (r) {
        self.upload[self.upload.target].loading = false;
        if (r.error) {
          self.upload[self.upload.target].message = r.error.message;
          self.upload[self.upload.target].success = false;
          return;
        }

        self.upload[self.upload.target].message = 'Airline CSV update success.';
        self.upload[self.upload.target].success = true;
      });
    },
    isGeofenceValid: function isGeofenceValid() {
      var self = this;
      var hasError = false;
      self.formError = {
        show: false,
        items: []

        // service area validation
      };if (self.geofence.type === 'servicearea') {
        // check service rate settings
        if (!self.isP2P && self.geofence.SharedAirportFee === null || self.geofence.SharedMileageRate === null || self.geofence.SharedFare === null || self.geofence.SharedMileageThreshold === null || self.geofence.SharedFlat2ndPAXFee === null || self.geofence.SharedFlatAddPAXFee === null || self.geofence.SharedPassengerMileageRate === null || self.geofence.SharedMaxLuggage === null || self.geofence.SharedDiscount === null || self.geofence.SharedRoundtrip === null || !self.isP2P && self.geofence.OpoliAirportFee === null || self.geofence.OpoliMileageRate === null || self.geofence.OpoliFare === null || self.geofence.OpoliMileageThreshold === null || self.geofence.OpoliFlat2ndPAXFee === null || self.geofence.OpoliFlatAddPAXFee === null || self.geofence.OpoliPassengerMileageRate === null || self.geofence.OpoliMaxLuggage === null || self.geofence.OpoliDiscount === null || self.geofence.OpoliRoundtrip === null || !self.isP2P && self.geofence.BlackAirportFee === null || self.geofence.BlackMileageRate === null || self.geofence.BlackFare === null || self.geofence.BlackMileageThreshold === null || self.geofence.BlackFlat2ndPAXFee === null || self.geofence.BlackFlatAddPAXFee === null || self.geofence.BlackPassengerMileageRate === null || self.geofence.BlackMaxLuggage === null || self.geofence.BlackDiscount === null || self.geofence.BlackRoundtrip === null || !self.isP2P && self.geofence.SUVAirportFee === null || self.geofence.SUVMileageRate === null || self.geofence.SUVFare === null || self.geofence.SUVMileageThreshold === null || self.geofence.SUVFlat2ndPAXFee === null || self.geofence.SUVFlatAddPAXFee === null || self.geofence.SUVPassengerMileageRate === null || self.geofence.SUVMaxLuggage === null || self.geofence.SUVDiscount === null || self.geofence.SUVRoundtrip === null || !self.isP2P && self.geofence.PrivateShuttleAirportFee === null || self.geofence.PrivateShuttleMileageRate === null || self.geofence.PrivateShuttleFare === null || self.geofence.PrivateShuttleMileageThreshold === null || self.geofence.PrivateShuttleFlat2ndPAXFee === null || self.geofence.PrivateShuttleFlatAddPAXFee === null || self.geofence.PrivateShuttlePassengerMileageRate === null || self.geofence.PrivateShuttleMaxLuggage === null || self.geofence.PrivateShuttleDiscount === null || self.geofence.PrivateShuttleRoundtrip === null) {
          hasError = true;
          self.formError.items.push('Empty fields are not allowed for SERVICE RATE SETTINGS.');
        }

        if (self.geofence.SharedProviderMileageRate === null || self.geofence.SharedProviderBaseFee === null || self.geofence.SharedMileageThreshold === null || self.geofence.SharedProviderFlat2ndPAXFee === null || self.geofence.SharedProviderFlatAddPAXFee === null || self.geofence.SharedProviderDiscount === null || self.geofence.OpoliProviderMileageRate === null || self.geofence.OpoliProviderBaseFee === null || self.geofence.OpoliMileageThreshold === null || self.geofence.OpoliProviderFlat2ndPAXFee === null || self.geofence.OpoliProviderFlatAddPAXFee === null || self.geofence.OpoliProviderDiscount === null || self.geofence.BlackProviderMileageRate === null || self.geofence.BlackProviderBaseFee === null || self.geofence.BlackMileageThreshold === null || self.geofence.BlackProviderFlat2ndPAXFee === null || self.geofence.BlackProviderFlatAddPAXFee === null || self.geofence.BlackProviderDiscount === null || self.geofence.SUVProviderMileageRate === null || self.geofence.SUVProviderBaseFee === null || self.geofence.SUVMileageThreshold === null || self.geofence.SUVProviderFlat2ndPAXFee === null || self.geofence.SUVProviderFlatAddPAXFee === null || self.geofence.SUVProviderDiscount === null || self.geofence.PrivateShuttleProviderMileageRate === null || self.geofence.PrivateShuttleProviderBaseFee === null || self.geofence.PrivateShuttleMileageThreshold === null || self.geofence.PrivateShuttleProviderFlat2ndPAXFee === null || self.geofence.PrivateShuttleProviderFlatAddPAXFee === null || self.geofence.PrivateShuttleProviderDiscount === null) {
          hasError = true;
          self.formError.items.push('Empty fields are not allowed for PROVIDER RATE SETTINGS.');
        }

        // check service types
        var services = self.geofence.services;
        for (var prop in services) {
          if (!services.hasOwnProperty(prop)) {
            continue;
          }
          var service = services[prop];
          if (!service.curbside && !service.meetAndGreet) {
            hasError = true;
            self.formError.items.push('All selected SERVICE TYPES should have at least 1 pickup type.');
            break;
          }
        }
        // Check License Types
        if (!self.geofence.allowTNC && !self.geofence.allowTCP) {
          hasError = true;
          self.formError.items.push('Please select at least 1 LICENSE TYPE.');
        }
      }

      if (!self.geofence.name) {
        hasError = true;
        self.formError.items.push('Geofence Name cannot be empty.');
      }
      if (self.geofence.type === 'airport' && !self.geofence.airportCode) {
        hasError = true;
        self.formError.items.push('Airport Code cannot be empty.');
      }
      if (!self.navigationAddress) {
        hasError = true;
        self.formError.items.push('Navigation Address cannot be empty.');
      }

      // KML file check
      if (self.geofence.kmlFile === null || self.geofence.kmlFile === '') {
        hasError = true;
        self.formError.items.push('This Geofence requires a KML FILE.');
      }

      if (hasError) {
        self.formError.show = true;
        return false;
      }
      return true;
    },
    clone: function clone(id) {
      this.$store.commit('geofences/setShowCreateGeofence', true);
      this.$store.commit('geofences/setCloneGeofence', id);
    },
    uploadingPickupInstruction: function uploadingPickupInstruction(data) {
      this.uploading[data.type] = data.value;
    }
  }
});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_geofences_airport__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'geofence-fields-airport',
  props: ['geofence', 'loadOtherData'],
  components: { draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a },
  data: function data() {
    return {
      subgeofencesLoading: false,
      stagingLots: [],
      restrictedAreas: [],
      serviceAreas: [],
      selected: {
        stagingLots: '',
        restrictedAreas: '',
        serviceAreas: ''
      },
      dragOptions: {
        stagingLots: { disabled: false },
        restrictedAreas: { disabled: false },
        serviceAreas: { disabled: false }
      },
      deleteConfirm: {},
      searched: {
        stagingLots: false,
        restrictedAreas: false,
        serviceAreas: false
      },
      uploadMsg: {
        tnc: '',
        tcp: ''
      }
    };
  },

  computed: {
    geofences: function geofences() {
      return this.$store.state.geofences.geofences.items;
    },
    activeLoading: function activeLoading() {
      return this.$store.state.geofences.geofences.active.loading;
    }
  },
  methods: {
    updateField: function updateField(field) {
      this.$store.commit('geofences/setGeofenceField', {
        id: this.geofence.id,
        field: field,
        value: this.geofence[field] ? 1 : 0
      });
    },
    updateFieldValue: function updateFieldValue(field) {
      this.$store.commit('geofences/setGeofenceField', {
        id: this.geofence.id,
        field: field,
        value: this.geofence[field]
      });
    },
    getActiveGeofences: function getActiveGeofences() {
      var self = this;
      var active = self.$store.state.geofences.geofences.active;

      if (self.activeLoading) {
        return;
      }

      var request = {
        token: self.$store.state.session.sessionToken,
        pageSize: 100,
        status: 'active'
      };

      if (!self.searched.stagingLots) {
        request.type = 'staging';
      } else if (!self.searched.restrictedAreas) {
        request.type = 'restricted';
      } else if (!self.searched.serviceAreas) {
        request.type = 'servicearea';
      }

      self.$store.commit('geofences/setGeofenceActiveLoading', true);
      if (request.type === 'servicearea') {
        self.$sdk.get('/servicearea', {
          token: self.$store.state.session.sessionToken,
          brandId: -2
        }, function (r) {
          self.$store.commit('geofences/setGeofenceActiveLoading', false);
          if (r.error) {
            return;
          }

          var result = [];
          for (var i = 0; i < r.list.length; i++) {
            var item = r.list[i];
            item['showForm'] = false;
            if (!r.list[i].airportAssoc) {
              result.push(item);
            }
          }

          var field = 'stagingLots';
          if (request.type === 'restricted') {
            field = 'restrictedAreas';
          }
          if (request.type === 'servicearea') {
            field = 'serviceAreas';
          }

          // sort alphabetically
          result.sort(function (a, b) {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          });
          self.$store.commit('geofences/setGeofenceActive', {
            field: field,
            value: result
          });

          self.searched[field] = true;

          self.getActiveGeofences();
        }, '2.0');
      } else if (request.type) {
        self.$sdk.get('/geofences/search', request, function (r) {
          self.$store.commit('geofences/setGeofenceActiveLoading', false);
          if (r.error) {
            return;
          }

          var result = [];
          for (var i = 0; i < r.list.length; i++) {
            var item = r.list[i];
            item['showForm'] = false;
            if (!r.list[i].airportAssoc) {
              result.push(item);
            }
          }

          var field = 'stagingLots';
          if (request.type === 'restricted') {
            field = 'restrictedAreas';
          }
          if (request.type === 'servicearea') {
            field = 'serviceAreas';
          }

          // sort alphabetically
          result.sort(function (a, b) {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          });
          self.$store.commit('geofences/setGeofenceActive', {
            field: field,
            value: result
          });

          self.searched[field] = true;

          self.getActiveGeofences();
        });
      }
    },
    activeGeofenceList: function activeGeofenceList(field) {
      var activeGeofences = this.$store.state.geofences.geofences.active;

      var filtered = activeGeofences[field];
      this[field].forEach(function (data) {
        filtered = filtered.filter(function (activeGeo) {
          return activeGeo.id !== data.id;
        });
      });

      return filtered || [];
    },
    sorted: function sorted(field) {
      var self = this;
      self.dragOptions[field].disabled = true;
      self.$store.commit('geofences/setAirportSubgeofence', {
        id: self.geofence.id,
        field: field,
        value: self[field]
      });

      var priority = {};
      var i = 1;
      self[field].forEach(function (geo) {
        priority[geo.id] = i;
        i++;
      });

      __WEBPACK_IMPORTED_MODULE_0__modules_api_geofences_airport__["a" /* default */].updateSubGeofence(self, {
        id: self.geofence.id,
        priority: priority
      }, function (res) {
        self.dragOptions[field].disabled = false;
      });
    },
    addSubGeofence: function addSubGeofence(field) {
      var self = this;
      self.dragOptions[field].disabled = true;

      __WEBPACK_IMPORTED_MODULE_0__modules_api_geofences_airport__["a" /* default */].addSubGeofence(self, {
        id: self.geofence.id,
        subID: self.selected[field],
        priority: self[field].length + 1
      }, function (res) {
        self.dragOptions[field].disabled = false;
        if (!res.error) {
          var index = self.activeGeofenceList(field).findIndex(function (x) {
            return x.id === self.selected[field];
          });
          var selectedGeo = self.activeGeofenceList(field)[index];
          self[field].push({
            id: selectedGeo.id,
            name: selectedGeo.name
          });
          self.$store.commit('geofences/setAirportSubgeofence', {
            id: self.geofence.id,
            field: field,
            value: self[field]
          });
        }
      });
    },
    toggleConfirm: function toggleConfirm(id, field) {
      var self = this;
      if (self.dragOptions[field].disabled) {
        return;
      }

      if (!self.deleteConfirm['a' + id]) {
        self.deleteConfirm['a' + id] = false;
      }
      self.deleteConfirm['a' + id] = !self.deleteConfirm['a' + id];

      // Rerender trick
      var backup = self.deleteConfirm;
      self.deleteConfirm = {};
      self.$nextTick(function () {
        self.deleteConfirm = backup;
      });
    },
    deleteSubGeofence: function deleteSubGeofence(id, field) {
      var self = this;
      if (self.dragOptions[field].disabled) {
        return;
      }

      self.dragOptions[field].disabled = true;
      __WEBPACK_IMPORTED_MODULE_0__modules_api_geofences_airport__["a" /* default */].removeSubGeofence(self, {
        id: self.geofence.id,
        subID: id
      }, function (res) {
        self.dragOptions[field].disabled = false;
        if (!res.error) {
          var index = self[field].findIndex(function (x) {
            return x.id === id;
          });
          self[field].splice(index, 1);
          self.$store.commit('geofences/setAirportSubgeofence', {
            id: self.geofence.id,
            field: field,
            value: self[field]
          });

          self.selected[field] = '';
        }
      });
    },
    stripScripts: function stripScripts(data) {
      var div = document.createElement('div');
      div.innerHTML = data;
      var scripts = div.getElementsByTagName('script');
      var i = scripts.length;
      while (i--) {
        scripts[i].parentNode.removeChild(scripts[i]);
      }
      return div.innerHTML;
    },
    upload: function upload(target) {
      var self = this;
      var _target = target === 'imageTNC' ? 'tnc' : 'tcp';

      if (!self.$refs[target].files.length || self.geofence.uploading[_target]) {
        return;
      }

      self.geofence.uploading[_target] = true;
      self.$emit('uploading', {
        type: _target,
        value: true
      });

      self.uploadMsg[_target] = '';

      var file = self.$refs[target].files[0];
      var fd = new FormData();
      fd.append('pic', file);

      self.$http.post({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.mediaHost + '/api/upload', fd, {
        header: { 'Content-Type': 'multipart/form-data' }
      }).then(function (res) {
        self.geofence.uploading[_target] = false;
        self.$emit('uploading', {
          type: _target,
          value: false
        });

        if (!res.body.success) {
          self.uploadMsg[_target] = 'Upload fail. Please try again.';
          return;
        }

        // geofence.airportPickupImageTNC
        if (_target === 'tnc') {
          self.geofence.airportPickupImageTNC = res.body.data.url;
        } else {
          self.geofence.airportPickupImageTCP = res.body.data.url;
        }
      }, function (res) {
        console.log('error', res);
      });
    },
    openPreview: function openPreview() {
      var self = this;
      var url = location.href + '/preview';

      self.$store.commit('geofences/setPreview', {
        title: self.geofence.airportPickupTitle,
        tnc: {
          text: self.geofence.airportPickupInstructionsTNC,
          img: self.geofence.airportPickupImageTNC
        },
        tcp: {
          text: self.geofence.airportPickupInstructionsTCP,
          img: self.geofence.airportPickupImageTCP
        }
      });

      var popup = window.open(url, 'instructionPreview', 'location=0,width=1020,height=' + window.outerHeight);
      popup.focus();
      popup.onload = function () {
        self.$store.commit('geofences/setPreview', {
          title: self.geofence.airportPickupTitle,
          tnc: {
            text: self.geofence.airportPickupInstructionsTNC,
            img: self.geofence.airportPickupImageTNC
          },
          tcp: {
            text: self.geofence.airportPickupInstructionsTCP,
            img: self.geofence.airportPickupImageTCP
          }
        });
      };
    }
  },
  watch: {
    loadOtherData: function loadOtherData(value) {
      var _this = this;

      var self = this;
      var index = self.geofences.findIndex(function (x) {
        return x.id === _this.geofence.id;
      });

      if (index > -1 && !self.geofences[index].stagingLots) {
        self.subgeofencesLoading = true;
        __WEBPACK_IMPORTED_MODULE_0__modules_api_geofences_airport__["a" /* default */].getSubgeofences(self, self.geofence.id, function (res) {
          if (!res.error) {
            // set StagingLots Data
            res.staging.forEach(function (data) {
              self.stagingLots.push({
                id: data.id,
                name: data.name
              });
            });

            // set RestrictedAreas Data
            res.restricted.forEach(function (data) {
              self.restrictedAreas.push({
                id: data.id,
                name: data.name
              });
            });

            // set RestrictedAreas Data
            res.servicearea.forEach(function (data) {
              self.serviceAreas.push({
                id: data.id,
                name: data.name
              });
            });
          }
          self.subgeofencesLoading = false;
          self.getActiveGeofences();
        });
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_services__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import stagingGeofenceAPI from '@/modules/api/geofences/staging'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'geofence-fields-restricted',
  props: ['geofence'],
  data: function data() {
    return {
      checkService: {
        shared: false,
        opoli: false,
        black: false,
        suv: false,
        shuttle: false
      }
    };
  },

  methods: {
    updateField: function updateField(field) {
      this.$store.commit('geofences/setGeofenceField', {
        id: this.geofence.id,
        field: field,
        value: this.geofence[field] ? 1 : 0
      });
    },
    serviceLabel: function serviceLabel(code) {
      return __WEBPACK_IMPORTED_MODULE_0__modules_api_services__["a" /* default */].getServiceName(code);
    }
  },
  watch: {
    geofence: function geofence(value) {
      if (value) {
        if (!value.services) {
          this.checkService.shared = false;
          this.checkService.opoli = false;
          this.checkService.black = false;
          this.checkService.suv = false;
          this.checkService.shuttle = false;
        } else {
          this.checkService.shared = value.services.shared ? value.services.shared.allowed : false;
          this.checkService.opoli = value.services.opoli ? value.services.opoli.allowed : false;
          this.checkService.black = value.services.black ? value.services.black.allowed : false;
          this.checkService.suv = value.services.suv ? value.services.suv.allowed : false;
          this.checkService.shuttle = value.services.shuttle ? value.services.shuttle.allowed : false;
        }
      }
    },
    'checkService.shared': function checkServiceShared(value) {
      this.geofence.services.shared.allowed = value;
    },
    'checkService.opoli': function checkServiceOpoli(value) {
      this.geofence.services.opoli.allowed = value;
    },
    'checkService.black': function checkServiceBlack(value) {
      this.geofence.services.black.allowed = value;
    },
    'checkService.suv': function checkServiceSuv(value) {
      this.geofence.services.suv.allowed = value;
    },
    'checkService.shuttle': function checkServiceShuttle(value) {
      this.geofence.services.shuttle.allowed = value;
    }
  },
  mounted: function mounted() {
    if (this.geofence.services) {
      this.checkService.shared = this.geofence.services.shared ? this.geofence.services.shared.allowed : false;
      this.checkService.opoli = this.geofence.services.opoli ? this.geofence.services.opoli.allowed : false;
      this.checkService.black = this.geofence.services.black ? this.geofence.services.black.allowed : false;
      this.checkService.suv = this.geofence.services.suv ? this.geofence.services.suv.allowed : false;
      this.checkService.shuttle = this.geofence.services.shuttle ? this.geofence.services.shuttle.allowed : false;
    }
  }
});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_datepicker__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_autonumeric__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_autonumeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_autonumeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_services__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'geofence-fields-servicearea',
  props: ['geofence'],
  components: { DatePicker: __WEBPACK_IMPORTED_MODULE_1_vue2_datepicker___default.a, VueAutonumeric: __WEBPACK_IMPORTED_MODULE_2_vue_autonumeric___default.a },
  data: function data() {
    return {
      dollar: {
        currencySymbol: '$ ',
        currencySymbolPlacement: 'p',
        minimumValue: '0',
        maximumValue: '99.99'
      },
      percent: {
        currencySymbol: ' %',
        currencySymbolPlacement: 's',
        minimumValue: '0',
        maximumValue: '100'
      },
      passenger: {
        minimumValue: '0',
        maximumValue: '9',
        decimalPlaces: 0
      },
      oneHundred: {
        minimumValue: '0',
        maximumValue: '100'
      },
      luggage: {
        minimumValue: '0',
        maximumValue: '18',
        decimalPlaces: 0
      },
      promos: {
        loading: false,
        list: []
      }
    };
  },

  computed: {
    saveGlobalBtn: function saveGlobalBtn() {
      return this.$store.state.geofences.services.saveBtn;
    },
    isP2P: function isP2P() {
      var self = this;
      var geofences = self.$store.state.geofences.geofences.items;
      var index = geofences.findIndex(function (x) {
        return x.id === self.geofence.id;
      });
      if (index < 0) {
        return false;
      }
      return geofences[index].isP2P;
    },

    holidayDate: {
      get: function get() {
        var self = this;
        if (!self.geofence) {
          return null;
        }

        var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.geofence.holidayDate, 'YYYY-MM-DD');
        return date.toDate();
      },
      set: function set(value) {
        var self = this;
        var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value);
        self.geofence.holidayDate = date.format('YYYY-MM-DD');
        self.$store.commit('geofences/setGeofenceField', {
          id: self.geofence.id,
          field: 'holidayDate',
          value: self.geofence.holidayDate
        });
      }
    },
    discountStart: {
      get: function get() {
        var self = this;
        if (!self.geofence) {
          return null;
        }
        var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.geofence.promotionStartDate, 'YYYY-MM-DD HH:mm:ss Z');
        return date.toDate();
      },
      set: function set(value) {
        var self = this;
        var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value);
        self.geofence.promotionStartDate = date.format('YYYY-MM-DD HH:mm:ss Z');
        self.$store.commit('geofences/setGeofenceField', {
          id: self.geofence.id,
          field: 'promotionStartDate',
          value: self.geofence.promotionStartDate
        });
      }
    },
    discountEnd: {
      get: function get() {
        var self = this;
        if (!self.geofence) {
          return null;
        }
        var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.geofence.promotionEndDate, 'YYYY-MM-DD HH:mm:ss Z');
        return date.toDate();
      },
      set: function set(value) {
        console.log(value);
        var self = this;
        var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value);
        self.geofence.promotionEndDate = date.format('YYYY-MM-DD HH:mm:ss Z');
        self.$store.commit('geofences/setGeofenceField', {
          id: self.geofence.id,
          field: 'promotionEndDate',
          value: self.geofence.promotionEndDate
        });
      }
    },
    promoRefreshID: function promoRefreshID() {
      return this.$store.state.geofences.promo.refreshID;
    }
  },
  methods: {
    changeDate: function changeDate() {
      var self = this;
      self.$store.commit('geofences/setSaveBtn', false);
    },
    openModal: function openModal() {
      var self = this;
      self.$store.commit('geofences/setShowServiceAreaModal', true);
      self.$store.commit('geofences/setStartDatePromo', self.geofence.promotionStartDate);
      self.$store.commit('geofences/setEndDatePromo', self.geofence.promotionEndDate);
      self.$store.commit('geofences/setServiceAreaID', self.geofence.id);
    },
    loadPromos: function loadPromos() {
      var self = this;
      self.promos.loading = true;
      self.promos.list = [];
      self.$sdk.get('/geofences/' + self.geofence.id + '/promos', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.promos.loading = false;
        if (r.error) {
          return;
        }
        self.promos.list = r.list;
      });
    },
    showPromoForm: function showPromoForm() {
      this.$store.commit('geofences/setGeofencePromoShow', true);
      this.$store.commit('geofences/setGeofencePromo', this.geofence);
      this.$store.commit('geofences/setGeofencePromoList', this.promos.list);
    },
    removePromo: function removePromo(index) {
      var self = this;
      var promo = self.promos.list[index];
      var promos = [];
      for (var i = 0; i < self.promos.list.length; i++) {
        if (i === index) {
          continue;
        }
        promos.push(self.promos.list[i]);
      }
      self.promos.list = promos;
      self.$sdk.delete('/geofences/' + self.geofence.id + '/promos/' + promo.id, {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        console.log('PROMO REMOVED', r);
      });
    },
    updateRsvpType: function updateRsvpType(field) {
      this.$store.commit('geofences/setGeofenceField', {
        id: this.geofence.id,
        field: field,
        value: this.geofence[field] ? 1 : 0
      });
      var fieldName = 'resTypeFuture';
      if (field === 'allowASAP') {
        fieldName = 'resTypeASAP';
      }
      this.$store.commit('geofences/setGeofenceField', {
        id: this.geofence.id,
        field: fieldName,
        value: this.geofence[field] ? 1 : 0
      });
    },
    updateBooleanField: function updateBooleanField(field) {
      this.$store.commit('geofences/setGeofenceField', {
        id: this.geofence.id,
        field: field,
        value: this.geofence[field] ? 1 : 0
      });
    },
    updatePricing: function updatePricing(field) {
      this.$store.commit('geofences/setGeofencePricing', {
        id: this.geofence.id,
        field: field,
        value: this.geofence.pricing[field]
      });
    },
    updateDriverPay: function updateDriverPay(field) {
      var value = this.geofence.driverPay[field];
      if (field === 'SharedProviderBonus') {
        value = this.geofence.sharedBonusPerMile;
      }
      this.$store.commit('geofences/setGeofenceDriverPay', {
        id: this.geofence.id,
        field: field,
        value: value
      });
    },
    updateServiceType: function updateServiceType(serviceType, field) {
      this.$store.commit('geofences/setGeofenceServiceType', {
        id: this.geofence.id,
        field: field,
        serviceType: serviceType,
        value: this.geofence.services[serviceType][field]
      });
    },
    serviceName: function serviceName(id) {
      var services = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.serviceId;
      for (var prop in services) {
        if (!services.hasOwnProperty(prop)) {
          continue;
        }

        if (services[prop] !== id) {
          continue;
        }

        return this.serviceLabel(prop);
      }
    },
    serviceLabel: function serviceLabel(code) {
      return __WEBPACK_IMPORTED_MODULE_3__modules_api_services__["a" /* default */].getServiceName(code);
    }
  },
  watch: {
    promoRefreshID: function promoRefreshID(value) {
      if (value !== this.geofence.id) {
        return;
      }
      this.loadPromos();
    }
  },
  mounted: function mounted() {
    // this.loadPromos()
  }
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_services__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import stagingGeofenceAPI from '@/modules/api/geofences/staging'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'geofence-fields-staging',
  props: ['geofence'],
  data: function data() {
    return {
      checkService: {
        shared: false,
        opoli: false,
        black: false,
        suv: false,
        shuttle: false
      },
      serviceLoading: false
    };
  },

  computed: {
    brands: function brands() {
      return this.$store.state.brands.list;
    },
    accountType: function accountType() {
      return this.$store.state.provider.accountType.type;
    }
  },
  methods: {
    serviceList: function serviceList(brandId) {
      return this.$store.state.services.list.filter(function (x) {
        return x.brandId === brandId && x.enabled;
      });
    },
    updateField: function updateField(field) {
      this.$store.commit('geofences/setGeofenceField', {
        id: this.geofence.id,
        field: field,
        value: this.geofence[field] ? 1 : 0
      });
    },
    serviceLabel: function serviceLabel(code) {
      return __WEBPACK_IMPORTED_MODULE_0__modules_api_services__["a" /* default */].getServiceName(code);
    },
    addServiceID: function addServiceID(id) {
      var self = this;
      if (typeof this.geofence.serviceTypeIds === "boolean" || this.geofence.serviceTypeIds === null) {
        self.geofence.serviceTypeIds = [id];
      }
    }
  },
  watch: {
    geofence: function geofence(value) {
      if (value) {
        if (!value.services) {
          this.checkService.shared = false;
          this.checkService.opoli = false;
          this.checkService.black = false;
          this.checkService.suv = false;
          this.checkService.shuttle = false;
        } else {
          this.checkService.shared = value.services.shared ? value.services.shared.allowed : false;
          this.checkService.opoli = value.services.opoli ? value.services.opoli.allowed : false;
          this.checkService.black = value.services.black ? value.services.black.allowed : false;
          this.checkService.suv = value.services.suv ? value.services.suv.allowed : false;
          this.checkService.shuttle = value.services.shuttle ? value.services.shuttle.allowed : false;
        }
      }
    },
    'checkService.shared': function checkServiceShared(value) {
      this.geofence.services.shared.allowed = value;
    },
    'checkService.opoli': function checkServiceOpoli(value) {
      this.geofence.services.opoli.allowed = value;
    },
    'checkService.black': function checkServiceBlack(value) {
      this.geofence.services.black.allowed = value;
    },
    'checkService.suv': function checkServiceSuv(value) {
      this.geofence.services.suv.allowed = value;
    },
    'checkService.shuttle': function checkServiceShuttle(value) {
      this.geofence.services.shuttle.allowed = value;
    }
  },
  mounted: function mounted() {
    if (this.geofence.services) {
      this.checkService.shared = this.geofence.services.shared ? this.geofence.services.shared.allowed : false;
      this.checkService.opoli = this.geofence.services.opoli ? this.geofence.services.opoli.allowed : false;
      this.checkService.black = this.geofence.services.black ? this.geofence.services.black.allowed : false;
      this.checkService.suv = this.geofence.services.suv ? this.geofence.services.suv.allowed : false;
      this.checkService.shuttle = this.geofence.services.shuttle ? this.geofence.services.shuttle.allowed : false;
    }
  }
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_brands__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'geofence-filters',
  data: function data() {
    return {
      pageNum: 1,
      pageSize: 20,
      pageTotal: 1,
      isBrand: true,
      isOpenFilter: false
      // geofenceType: this.$plugins.storage.getGeofenceByType() || 'airport',
      // geofenceStatus: this.$plugins.storage.getGeofenceByStatus() || 'active',
      // geofenceBrand: this.$plugins.storage.getGeofenceByBrand() || ''
    };
  },

  computed: {
    brands: function brands() {
      return this.$store.state.brands.list;
    },

    // geofenceSearch: {
    //   get () { return this.$store.state.geofences.filters.search },
    //   set (value) { this.$store.commit('geofences/setFilterSearch', value) }
    // },
    geofenceBrand: {
      get: function get() {
        return this.$store.state.geofences.filters.brands;
      },
      set: function set(value) {
        this.$store.commit('geofences/setFilterBrands', value);
      }
    },
    geofenceStatus: {
      get: function get() {
        return this.$store.state.geofences.filters.status;
      },
      set: function set(value) {
        this.$store.commit('geofences/setFilterStatus', value);
      }
    },
    geofenceType: {
      get: function get() {
        return this.$store.state.geofences.filters.type;
      },
      set: function set(value) {
        this.$store.commit('geofences/setFilterType', value);
      }
    },
    _refreshList: function _refreshList() {
      return this.$store.state.geofences.refreshList;
    },
    _priority: function _priority() {
      return this.$store.state.geofences.priority.success;
    }
  },
  methods: {
    applyFilters: function applyFilters(refresh) {
      var self = this;
      self.isOpenFilter = false;
      if (self.geofenceType || self.geofenceStatus || self.geofenceBrand) {
        self.$plugins.storage.setGeofenceByType(self.geofenceType);
        self.$plugins.storage.setGeofenceByStatus(self.geofenceStatus);
        self.$plugins.storage.setGeofenceByBrand(self.geofenceBrand);
      }
      var request = {
        token: self.$store.state.session.sessionToken,
        status: self.geofenceStatus,
        pageNum: self.pageNum,
        pageSize: self.pageSize,
        order: 'priority'
      };

      if (refresh) {
        request.pageNum = 1;
      }

      self.$store.commit('geofences/setGeofenceLoading', true);

      if (self.geofenceType === 'servicearea') {
        self.isBrand = false;
        request["brandId"] = -1;
        if (self.geofenceBrand) {
          request["brandId"] = self.geofenceBrand;
        }
        self.$sdk.get('/servicearea', request, function (r) {
          self.$store.commit('geofences/setGeofenceLoading', false);
          if (r.error) {
            // SHOW ERROR
            return;
          }

          var result = [];
          for (var i = 0; i < r.list.length; i++) {
            var item = r.list[i];
            item['showForm'] = false;
            item['isP2P'] = false;
            item['type'] = 'servicearea';

            result.push(item);
          }
          self.$store.commit('geofences/setGeofenceItems', result);

          self.pageNum = r.paging.pageNum;
          var totalPages = Math.ceil(r.paging.totalItems / self.pageSize);
          self.pageTotal = totalPages;
        }, '2.0');
      } else {
        if (self.geofenceType === 'tracking') {
          self.isBrand = false;
          if (self.geofenceBrand) {
            request["brandId"] = self.geofenceBrand;
          }
        } else {
          self.isBrand = true;
          self.geofenceBrand = '';
        }
        this.$plugins.storage.setGeofenceByBrand('');
        request['type'] = self.geofenceType;
        self.$sdk.get('/geofences/search', request, function (r) {
          self.$store.commit('geofences/setGeofenceLoading', false);
          if (r.error) {
            // SHOW ERROR
            return;
          }

          var result = [];
          for (var i = 0; i < r.list.length; i++) {
            var item = r.list[i];
            item['showForm'] = false;
            item['isP2P'] = false;
            if (item.pricing.SharedAirportFee === null) {
              item.pricing.SharedAirportFee = 0;
            }
            if (item.pricing.OpoliAirportFee === null) {
              item.pricing.OpoliAirportFee = 0;
            }
            if (item.pricing.BlackAirportFee === null) {
              item.pricing.BlackAirportFee = 0;
            }
            if (item.pricing.SUVAirportFee === null) {
              item.pricing.SUVAirportFee = 0;
            }
            if (item.pricing.PrivateShuttleAirportFee === null) {
              item.pricing.PrivateShuttleAirportFee = 0;
            }

            if (typeof item.services === 'undefined' || item.services === null) {
              item['services'] = {
                shared: {
                  allowed: false,
                  curbside: false,
                  meetAndGreet: false,
                  pickupFee: 0
                },
                opoli: {
                  allowed: false,
                  curbside: false,
                  meetAndGreet: false,
                  pickupFee: 0
                },
                black: {
                  allowed: false,
                  curbside: false,
                  meetAndGreet: false,
                  pickupFee: 0
                },
                suv: {
                  allowed: false,
                  curbside: false,
                  meetAndGreet: false,
                  pickupFee: 0
                },
                shuttle: {
                  allowed: false,
                  curbside: false,
                  meetAndGreet: false,
                  pickupFee: 0
                }
              };
            }

            if (self.geofenceType === 'airport') {
              item.uploading = { tnc: false, tcp: false };
              item.formalName = item.formalName || '';
              item.airportPickupTitle = item.pickupInstructions.title || '';
              item.airportPickupInstructionsTNC = item.pickupInstructions.tncText || '';
              item.airportPickupInstructionsTCP = item.pickupInstructions.tcpText || '';
              item.airportPickupImageTNC = item.pickupInstructions.tncImage || '';
              item.airportPickupImageTCP = item.pickupInstructions.tcpImage || '';
              item.airportPickupUpstairs = item.pickupInstructions.upstairsLabel || '';
              item.airportPickupDownstairs = item.pickupInstructions.downstairsLabel || '';
            }

            result.push(item);
          }

          self.$store.commit('geofences/setGeofenceItems', result);

          self.pageNum = r.paging.pageNum;
          var totalPages = Math.ceil(r.paging.totalItems / self.pageSize);
          self.pageTotal = totalPages;
        });
      }
    },
    showCreateForm: function showCreateForm() {
      this.$store.commit('geofences/setShowCreateGeofence', true);
    },
    prioritizeGeofences: function prioritizeGeofences() {
      this.$store.commit('geofences/setShowGeofencePriority', true);
    },
    getBrandsList: function getBrandsList() {
      var self = this;
      self.$store.commit('brands/setLoading', true);
      __WEBPACK_IMPORTED_MODULE_0__modules_api_brands__["a" /* default */].getBrands(self, function (res) {
        self.$store.commit('brands/setLoading', false);
      });
    },
    showFilter: function showFilter() {
      console.log('test');
    }
  },
  watch: {
    _refreshList: function _refreshList(value) {
      if (value) {
        this.$store.commit('geofences/setRefreshList', false);
        this.applyFilters(true);
      }
    },
    _priority: function _priority(value) {
      if (value) {
        this.$store.commit('geofences/setPrioritySuccess', false);
        this.applyFilters(false);
      }
    }
  },
  mounted: function mounted() {
    if (this.$plugins.storage.getGeofenceByBrand()) {
      this.$store.commit('geofences/setFilterBrands', this.$plugins.storage.getGeofenceByBrand());
    }
    if (this.$plugins.storage.getGeofenceByStatus()) {
      this.$store.commit('geofences/setFilterStatus', this.$plugins.storage.getGeofenceByStatus());
    }
    if (this.$plugins.storage.getGeofenceByType()) {
      this.$store.commit('geofences/setFilterType', this.$plugins.storage.getGeofenceByType());
    }

    this.applyFilters(true);
    this.getBrandsList();
  }
});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__values_map_settings__ = __webpack_require__(51);



//
//
//
//
//
//

/* global CONFIG */
var request = __webpack_require__(13);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'geofence-map2',
  data: function data() {
    return {
      hereMaps: {
        map: {},
        platform: {},
        router: {},
        geocoder: {},
        directions: [],
        ui: {}
      },
      activeKml: [],
      test: {
        ctaPoints: [],
        ctaPath: [{ lat: 33.9518361293, lng: -118.396441488 }, { lat: 33.9404376198, lng: -118.396411306 }, { lat: 33.9428921859, lng: -118.397526938 }, { lat: 33.9418275284, lng: -118.408275099 }, { lat: 33.9453275395, lng: -118.408771137 }, { lat: 33.9464253806, lng: -118.40013021 }, { lat: 33.9485216947, lng: -118.400136515 }],
        assignPoints: [],
        assignPath: [{ lat: 33.9529341402, lng: -118.394014116 }, { lat: 33.95272417, lng: -118.379971643 }, { lat: 33.9473246781, lng: -118.379965937 }, { lat: 33.9473150916, lng: -118.390095323 }, { lat: 33.9487758219, lng: -118.390136649 }, { lat: 33.9487983271, lng: -118.393977504 }]
      },
      mapOptions: __WEBPACK_IMPORTED_MODULE_3__values_map_settings__["a" /* default */],
      center: { lat: 33.942791, lng: -118.410042 },
      points: [],
      setCenterTime: ''
    };
  },

  computed: {
    polygons: function polygons() {
      return this.$store.state.geofences.map.polygons;
    }
  },
  watch: {
    polygons: function polygons(value) {
      var self = this;
      var kmlGroup = new window.H.map.Group();

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var object = _step.value;

          self.hereMaps.map.removeObject(object);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (value) {
        var firstPolyon = true;
        value.forEach(function (val) {
          var geofences = self.$store.state.geofences.geofences.items;
          var index = geofences.findIndex(function (x) {
            return x.id === val.id;
          });
          var reader = new window.H.data.kml.Reader(geofences[index].kmlFile);
          reader.parse();

          reader.addEventListener('statechange', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
            var objects;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (this.getState() === window.H.data.AbstractReader.State.READY) {
                      objects = reader.getParsedObjects();

                      if (objects[0] instanceof H.map.Group) {
                        objects = objects[0];
                      }

                      objects.forEach(function (obj, i, group) {
                        if (obj instanceof H.map.Polygon) {
                          obj.setStyle({
                            strokeColor: val.color,
                            fillColor: self.hexaToDeci(val.color),
                            lineWidth: 2
                          });
                          obj.id = val.id;
                          kmlGroup.addObject(obj);

                          if (firstPolyon) {
                            self.hereMaps.map.getViewModel().setLookAtData({
                              bounds: obj.getBoundingBox()
                            });
                          }
                        }
                      }, true, this);

                      firstPolyon = false;
                    }

                  case 1:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, this);
          })));

          self.hereMaps.map.addObject(kmlGroup);
          var layer = reader.getLayer();
          self.hereMaps.map.addLayer(layer);
        });
        // self.setCenter()
      }
    }
  },
  methods: {
    logCTA: function logCTA(e) {
      this.test.ctaPoints.push({
        lat: e.latLng.lat(),
        lng: e.latLng.lng()
      });
      console.log('CTA', e);
    },
    logAssignment: function logAssignment(e) {
      this.test.assignPoints.push({
        lat: e.latLng.lat(),
        lng: e.latLng.lng()
      });
      console.log('CTA', e);
    },
    logMe: function logMe(e) {
      this.points.push({
        lat: e.latLng.lat(),
        lng: e.latLng.lng()
      });
      console.log(e);
    },
    hexaToDeci: function hexaToDeci(val) {
      var hex = val.replace('#', '').match(/.{1,2}/g);
      return 'rgba(' + parseInt(hex[0], 16) + ',' + parseInt(hex[1], 16) + ',' + parseInt(hex[2], 16) + ', .4)';
    },
    setCenter: function setCenter() {
      var self = this;
      var group = new window.H.map.Group();
      if (!self.polygons.length) {
        return;
      }

      var geofences = self.$store.state.geofences.geofences.items;
      var index = geofences.findIndex(function (x) {
        return x.id === self.polygons[0].id;
      });

      if (index > -1) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var object = _step2.value;

            if (object.id === 'groupBound') {
              self.hereMaps.map.removeObject(object);
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        var groupObject = new window.H.map.Circle(new window.H.geo.Point(geofences[index].lat, geofences[index].lng), 5000, {
          style: {
            fillColor: 'rgba(0, 0, 0, 0)',
            strokeColor: 'rgba(0, 0, 0, 0)'
          }
        });

        group.addObjects([groupObject]);
        group.id = 'groupBound';
        self.hereMaps.map.addObject(group);

        self.hereMaps.map.getViewModel().setLookAtData({
          bounds: group.getBoundingBox()
        });
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    var mapContainer = document.getElementById('mapHere');
    self.hereMaps.platform = new window.H.service.Platform({
      apikey: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key
    });

    var defaultLayers = self.hereMaps.platform.createDefaultLayers();
    self.hereMaps.map = new window.H.Map(mapContainer, defaultLayers.vector.normal.map, {
      center: self.center,
      zoom: 13,
      pixelRatio: window.devicePixelRatio || 1
    });

    /* eslint-disable no-unused-vars */
    var behavior = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(self.hereMaps.map));
    /* eslint-enable no-unused-vars */
    self.hereMaps.ui = window.H.ui.UI.createDefault(self.hereMaps.map, defaultLayers);

    window.addEventListener('resize', function () {
      return self.hereMaps.map.getViewPort().resize();
    });
  }
});

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1633);


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(32);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_color__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_geofences_airport__ = __webpack_require__(161);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */
var request = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'geofence-create',
  components: { 'photoshop-picker': __WEBPACK_IMPORTED_MODULE_1_vue_color__["Photoshop"] },
  data: function data() {
    var _ref;

    return _ref = {
      geofenceName: '',
      geofenceID: '',
      navigationAddressObject: '',
      navigationAddress: '',
      lastNaviationAddress: '',
      centerpoint: '',
      lastCenterpoint: '',
      // autocomplete: new google.maps.places.AutocompleteService(), // eslint-disable-line no-undef
      // geocoder: new google.maps.Geocoder(), // eslint-disable-line no-undef
      queryToken: null,
      suggestions: [],
      showSuggestion: false,
      clickOutDelay: ''
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'centerpoint', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'type', 'airport'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'airportCode', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'overlayColor', '000000'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'error', {
      geofenceName: '',
      // geofenceID: '',
      navigationAddress: '',
      airportCode: ''
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'loading', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'showSuccess', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'geofenceBrand', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'formName', 'Create'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'kmlFile', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'isClone', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'airportAssoc', {
      loading: false,
      id: '',
      count: 0
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'triggerRefreshCounter', 0), _ref;
  },

  computed: {
    brands: function brands() {
      return this.$store.state.brands.list;
    },
    showCreateGeofence: function showCreateGeofence() {
      return this.$store.state.geofences.showCreateGeofence;
    },
    cloneFormId: function cloneFormId() {
      return this.$store.state.geofences.cloneId;
    }
  },
  methods: {
    close: function close() {
      if (this.loading) {
        return;
      }

      this.$store.commit('geofences/setShowCreateGeofence', false);
      this.$store.commit('geofences/setCloneGeofence', 0);
      this.geofenceName = '';
      this.geofenceID = '';
      this.navigationAddress = '';
      this.type = 'airport';
      this.airportCode = '';
      this.overlayColor = '';
      this.centerpoint = '';
      this.geofenceBrand = '';
      this.formName = 'Create';
      this.showSuccess = false;
    },
    query: function query() {
      var self = this;

      var queryText = self.navigationAddress;
      if (queryText === '') {
        self.queryToken = null;
        self.suggestions = [];
        self.showSuggestion = false;
        return;
      }

      // self.generateQueryToken()

      self.showSuggestion = true;
      var restrictedTypes = ['locality', 'postalCodePoint', 'administrativeArea', 'chainQuery', 'categoryQuery'];

      var url = 'https://autosuggest.search.hereapi.com/v1/autosuggest?at={AT}&q={SEARCH}&apiKey={API_KEY}&lang=en-US';
      url = url.replace('{AT}', encodeURIComponent(33.942791 + ',' + -118.410042)).replace('{SEARCH}', queryText).replace('{API_KEY}', {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key);
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err || body.items.length === 0) {
          self.suggestions = [{
            icon: 'fa-exclamation-triangle',
            title: 'Sorry',
            subtitle: 'We coudn\'t locate "' + queryText + '"'
          }];
          return;
        }

        var result = [];
        body.items.forEach(function (prediction) {
          if (restrictedTypes.indexOf(prediction.resultType) === -1) {
            var subtitle = prediction.address.label;
            result.push({
              id: prediction.id,
              title: prediction.title,
              subtitle: subtitle,
              icon: 'fa-map-marker'
            });
          }
        });

        self.suggestions = result.slice(0, 5);
      });
    },
    clickOut: function clickOut() {
      var self = this;
      self.clickOutDelay = setTimeout(function () {
        self.centerpoint = self.lastCenterpoint;
        if (self.navigationAddress !== self.lastNaviationAddress) {
          self.centerpoint = '';
        }
        self.showSuggestion = false;
      }, 300);
    },
    selectLocation: function selectLocation(index) {
      var self = this;
      var place = self.suggestions[index];
      self.queryToken = null;

      clearTimeout(self.clickOutDelay);
      self.showSuggestion = false;

      var url = 'https://lookup.search.hereapi.com/v1/lookup?source=sharing&id={LOCATION_ID}&locationattributes=tz&apiKey={API_KEY}&lang=en-US';
      url = url.replace('{LOCATION_ID}', place.id).replace('{API_KEY}', {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key);
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) {
          console.log('geocode ERROR', results, status);
          self.loading = false;
          return;
        }

        var result = body;
        var lat = result.position.lat;
        var lng = result.position.lng;
        self.centerpoint = lat + ', ' + lng;

        var navigationAddressObject = {
          title: result.title,
          address1: result.address.street || result.title,
          address2: result.address.houseNumber || result.address.district,
          city: result.address.city,
          state: result.address.state,
          zip: result.address.postalCode,
          country: result.address.countryCode,
          lat: lat,
          lng: lng
        };

        self.navigationAddressObject = navigationAddressObject;
        self.navigationAddress = self.navigationAddressObject.title;
        self.lastNaviationAddress = self.navigationAddress;
        self.lastCenterpoint = self.centerpoint;
      });
    },
    changeType: function changeType() {
      if (this.type !== 'airport') {
        this.airportCode = '';
      }
      if (this.type !== 'servicearea') {
        this.geofenceBrand = '';
      }
    },
    createGeofence: function createGeofence() {
      var self = this;

      if (self.loading) {
        return;
      }

      // Validation
      self.error = {
        geofenceName: '',
        // geofenceID: '',
        navigationAddress: '',
        airportCode: ''
      };
      var hasError = false;
      for (var field in self.error) {
        if (self[field] === '' && field === 'airportCode') {
          if (self.type === 'airport') {
            self.error[field] = 'This field cannot be empty.';
            hasError = true;
          }
        } else if (self[field] === '') {
          self.error[field] = 'This field cannot be empty.';
          hasError = true;
        }
      }
      if (self.centerpoint === '') {
        self.error.navigationAddress = 'Invalid address.';
        hasError = true;
      }

      if (hasError) {
        return;
      }

      self.loading = true;
      var request = {
        token: self.$store.state.session.sessionToken,
        name: self.geofenceName,
        description: self.geofenceName,
        overlayColor: self.overlayColor.hex ? self.overlayColor.hex.substring(1, self.overlayColor.hex.length) : self.overlayColor,
        centerPoint: self.centerpoint,
        type: self.type,
        airportCode: self.airportCode || null,
        kmlFile: self.kmlFile,
        location: self.navigationAddressObject
      };

      var newGoefenceID = '';
      if (self.type !== 'servicearea') {
        self.$sdk.post('/geofences', request, function (r) {
          self.loading = false;
          if (r.error) {
            return;
          }
          // self.showSuccess = true
          self.refreshTable();
        });
      } else {
        request["brandId"] = self.geofenceBrand;
        self.$sdk.post('/servicearea', request, function (r) {
          if (r.error) {
            return;
          }
          self.triggerRefreshCounter = 0;

          if (self.cloneFormId && self.cloneFormId > 0) {
            newGoefenceID = r.id;
            if (self.airportAssoc.id) {
              __WEBPACK_IMPORTED_MODULE_2__modules_api_geofences_airport__["a" /* default */].addSubGeofence(self, {
                id: self.airportAssoc.id,
                subID: newGoefenceID,
                priority: 9999
              }, function (r2) {
                if (!r2.error) {}
              });
            }

            var latLng = self.centerpoint.split(', ');
            self.$sdk.post('/geofences/' + newGoefenceID + '/polygon', {
              token: self.$store.state.session.sessionToken,
              kmlUrl: self.kmlFile,
              lat: parseFloat(latLng[0]),
              lng: parseFloat(latLng[1])
            }, function (r3) {
              self.loading = false;
              self.triggerRefreshCounter++;
              self.triggerRefresh();
            });

            var geofenceList = self.$store.state.geofences.geofences.items;
            var index = geofenceList.findIndex(function (x) {
              return x.id === self.cloneFormId;
            });
            if (index > -1) {
              self.$sdk.post('/geofences/' + newGoefenceID, {
                token: self.$store.state.session.sessionToken,
                resTypeASAP: geofenceList[index].allowASAP,
                resTypeFuture: geofenceList[index].allowFuture,
                trackEntryExit: geofenceList[index].trackEntryExit,
                showInAppBanner: geofenceList[index].showInAppBanner,
                pushNotificationToProvUponEntry: geofenceList[index].pushNotificationToProvUponEntry
              }, function (r3) {
                console.log('r3', r3);
                self.triggerRefreshCounter++;
                self.triggerRefresh();
              });
            }
          } else {
            self.loading = false;
            self.refreshTable();
          }
        }, '2.0');
      }
    },
    triggerRefresh: function triggerRefresh() {
      if (this.triggerRefreshCounter >= 2) {
        this.refreshTable();
      }
    },
    refreshTable: function refreshTable() {
      this.$store.commit('geofences/setRefreshList', true);
      this.close();
    }
  },
  watch: {
    showCreateGeofence: function showCreateGeofence(value) {
      if (!value) {
        this.kmlFile = '';
        this.isClone = true;
        this.airportAssocId = {
          loading: false,
          id: '',
          count: 0
        };
      }
    },
    cloneFormId: function cloneFormId(value) {
      if (value > 0) {
        var self = this;
        var geofences = this.$store.state.geofences.geofences.items;
        var index = geofences.findIndex(function (x) {
          return x.id === value;
        });

        var clone = geofences[index];
        self.geofenceName = clone.name;
        self.navigationAddress = clone.addressLine1 + ' ' + clone.addressLine2 + ', ' + clone.city + ', ' + clone.state + ' ' + clone.zipCode;
        self.type = 'servicearea';
        self.overlayColor = clone.color;
        self.formName = 'Clone';
        self.centerpoint = clone.lat + ', ' + clone.lng;
        self.navigationAddressObject = {
          title: self.navigationAddress,
          address1: clone.addressLine1,
          address2: clone.addressLine2,
          city: clone.city,
          state: clone.state,
          zip: clone.zipCode,
          lat: clone.lat,
          lng: clone.lng
        };
        self.kmlFile = clone.kmlFile;
        self.isClone = true;

        self.airportAssoc.loading = true;
        self.$sdk.get('/geofences/' + value + '/airport', {
          token: self.$store.state.session.sessionToken
        }, function (res) {
          self.airportAssoc.loading = false;
          if (!res.error) {
            if (res.airports.length) {
              self.airportAssoc.id = res.airports[0].id;
            }
          }
        });
        // airports/12/subgeofences/242
      }
    }
  }
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuedraggable__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'geofence-priority',
  components: { draggable: __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default.a },
  data: function data() {
    return {
      loading: true,
      geofences: [],
      saving: false
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.geofences.priority.show;
    },
    geofenceType: function geofenceType() {
      return this.$store.state.geofences.filters.type;
    },
    geofenceBrand: function geofenceBrand() {
      return this.$store.state.geofences.filters.brands;
    },
    useOldQuatation: function useOldQuatation() {
      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation;
    }
  },
  methods: {
    save: function save() {
      var self = this;
      var geofences = {};
      var indexStart = 0;
      if (self.geofenceType === 'servicearea' && !self.useOldQuatation && self.geofenceBrand > 0) {
        indexStart = parseInt(self.geofenceBrand) * 1000;
      }

      for (var i = 0; i < self.geofences.length; i++) {
        geofences[self.geofences[i].id] = i + indexStart;
      }
      self.saving = true;

      self.$sdk.post('/geofences/priority', {
        token: self.$store.state.session.sessionToken,
        geofences: geofences
      }, function (r) {
        self.saving = false;
        self.close();
        if (r.error) {
          console.log('ERROR', r);
          return;
        }
        self.$store.commit('geofences/setPrioritySuccess', true);
      });
    },
    close: function close() {
      this.$store.commit('geofences/setShowGeofencePriority', false);
    },
    loadGeofences: function loadGeofences() {
      var self = this;
      self.loading = true;
      self.geofence = [];

      var request = {
        token: self.$store.state.session.sessionToken,
        status: 'active',
        type: self.geofenceType,
        pageNum: 1,
        pageSize: -1,
        order: 'priority'
      };

      if (self.geofenceType === 'servicearea') {
        delete request.type;
        request.brandId = self.geofenceBrand || -1;
        request.pageSize = 9999;
        self.$sdk.get('/servicearea', request, function (r) {
          self.loading = false;
          if (r.error) {
            self.$store.commit('geofences/setShowGeofencePriority', false);
            return;
          }

          self.geofences = r.list;
        }, '2.0');
      } else {
        self.$sdk.get('/geofences/search', request, function (r) {
          self.loading = false;
          if (r.error) {
            self.$store.commit('geofences/setShowGeofencePriority', false);
            return;
          }

          self.geofences = r.list;
        });
      }
    }
  },
  watch: {
    show: function show(value) {
      var self = this;
      self.saving = false;
      if (!value) {
        self.loading = false;
        self.geofences = [];
        return;
      }

      self.loadGeofences();
    }
  }
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_autonumeric__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_autonumeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_autonumeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_services__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'promo-pricing',
  components: { VueAutonumeric: __WEBPACK_IMPORTED_MODULE_0_vue_autonumeric___default.a },
  data: function data() {
    return {
      dollar: {
        currencySymbol: '$ ',
        currencySymbolPlacement: 'p',
        minimumValue: '0',
        maximumValue: '99.99',
        emptyInputBehavior: 'zero'
      },
      promoForm: {
        saving: false,
        serviceType: '',
        promoType: '',
        flatRate: 0,
        baseRate: 0,
        mileageRate: 0,
        secondPaxFee: 0,
        addPaxFee: 0,
        error: {
          show: false,
          message: ''
        }
      }
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.geofences.promo.show;
    },
    geofence: function geofence() {
      return this.$store.state.geofences.promo.geofence;
    },
    promoList: function promoList() {
      return this.$store.state.geofences.promo.list;
    }
  },
  methods: {
    hideForm: function hideForm() {
      this.$store.commit('geofences/setGeofencePromoShow', false);
    },
    addPromo: function addPromo() {
      var self = this;
      var services = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.serviceId;
      var promoList = self.promoList;
      for (var prop in services) {
        if (!services.hasOwnProperty(prop)) {
          continue;
        }

        if (prop !== self.promoForm.serviceType) {
          continue;
        }

        for (var i = 0; i < promoList.length; i++) {
          if (services[prop] === promoList[i].serviceId) {
            self.promoForm.error = {
              show: true,
              message: 'Only one promotion is allowed per service type.'
            };
            return;
          }
        }
      }
      self.promoForm.error.show = false;
      if (self.promoForm.serviceType === '') {
        self.promoForm.error = {
          show: true,
          message: 'Please select a SERVICE TYPE.'
        };
        return;
      }
      if (self.promoForm.promoType === '') {
        self.promoForm.error = {
          show: true,
          message: 'Please select a PROMOTION TYPE.'
        };
        return;
      }
      self.promoForm.saving = true;
      var request = {
        token: self.$store.state.session.sessionToken,
        serviceId: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.serviceId[self.promoForm.serviceType],
        type: self.promoForm.promoType,
        flatRate: self.promoForm.flatRate,
        flat2ndPAXFee: self.promoForm.secondPaxFee,
        flatAddPAXFee: self.promoForm.addPaxFee,
        discountBaseRate: self.promoForm.baseRate,
        discountMileageRate: self.promoForm.mileageRate,
        discount2ndPAXFee: self.promoForm.secondPaxFee,
        discountAddPAXFee: self.promoForm.addPaxFee
      };

      self.$sdk.post('/geofences/' + self.geofence.id + '/promos', request, function (r) {
        self.promoForm.saving = false;
        if (r.error) {
          return;
        }
        self.hideForm();
        self.$store.commit('geofences/setGeofencePromoRefreshID', self.geofence.id);
      });
    },
    serviceLabel: function serviceLabel(code) {
      return __WEBPACK_IMPORTED_MODULE_1__modules_api_services__["a" /* default */].getServiceName(code);
    }
  },
  watch: {
    show: function show(value) {
      if (!value) {
        return;
      }
      this.promoForm = {
        saving: false,
        serviceType: '',
        promoType: '',
        flatRate: 0,
        baseRate: 0,
        mileageRate: 0,
        secondPaxFee: 0,
        addPaxFee: 0,
        error: {
          show: false,
          message: ''
        }
      };
    }
  }
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: true,
      geofences: [],
      services: [],
      geofenceType: 'servicearea'
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.geofences.services.show;
    },
    startDate: function startDate() {
      return this.$store.state.geofences.services.startDate;
    },
    endDate: function endDate() {
      return this.$store.state.geofences.services.endDate;
    },
    serviceID: function serviceID() {
      return this.$store.state.geofences.services.id;
    }
  },
  methods: {
    closeModal: function closeModal() {
      var self = this;
      self.services = [];
      self.$store.commit('geofences/setShowServiceAreaModal', false);
    },
    savePromo: function savePromo() {
      var self = this;
      self.$sdk.post('/geofences/discount', {
        token: self.$store.state.session.sessionToken,
        geofenceId: self.services,
        promotionStartDate: self.$store.state.geofences.services.startDate,
        promotionEndDate: self.$store.state.geofences.services.endDate
      }, function (r) {
        if (r.error) {
          console.log('ERROR', r);
          return;
        }
        // self.applyFilters(true)
        self.$store.commit('geofences/setRefreshList', true);
        self.closeModal();
        self.$store.commit('geofences/setSaveBtn', true);
      });
    },
    loadGeofences: function loadGeofences() {
      var self = this;
      self.loading = true;
      self.geofence = [];

      var request = {
        token: self.$store.state.session.sessionToken,
        status: 'active',
        type: 'servicearea',
        pageNum: 1,
        pageSize: -1,
        order: 'priority'
      };

      self.$sdk.get('/geofences/search', request, function (r) {
        self.loading = false;
        if (r.error) {
          console.log("error");
          self.$store.commit('geofences/setShowGeofencePriority', false);
          return;
        }

        self.geofences = r.list;
      });
    },
    applyFilters: function applyFilters(refresh) {
      var self = this;
      var request = {
        token: self.$store.state.session.sessionToken,
        status: self.geofenceStatus,
        pageNum: self.pageNum,
        pageSize: self.pageSize,
        order: 'priority'
      };
      if (refresh) {
        request.pageNum = 1;
      }
      if (self.geofenceType !== '') {
        request['type'] = self.geofenceType;
      }
      self.$store.commit('geofences/setGeofenceLoading', true);
      self.$sdk.get('/geofences/search', request, function (r) {
        self.$store.commit('geofences/setGeofenceLoading', false);
        if (r.error) {
          // SHOW ERROR
          return;
        }

        var result = [];
        for (var i = 0; i < r.list.length; i++) {
          var item = r.list[i];
          item['showForm'] = false;
          item['isP2P'] = false;
          if (item.pricing.SharedAirportFee === null) {
            item.pricing.SharedAirportFee = 0;
          }
          if (item.pricing.OpoliAirportFee === null) {
            item.pricing.OpoliAirportFee = 0;
          }
          if (item.pricing.BlackAirportFee === null) {
            item.pricing.BlackAirportFee = 0;
          }
          if (item.pricing.SUVAirportFee === null) {
            item.pricing.SUVAirportFee = 0;
          }
          if (item.pricing.PrivateShuttleAirportFee === null) {
            item.pricing.PrivateShuttleAirportFee = 0;
          }

          if (typeof item.services === 'undefined' || item.services === null) {
            item['services'] = {
              shared: {
                allowed: false,
                curbside: false,
                meetAndGreet: false,
                pickupFee: 0
              },
              opoli: {
                allowed: false,
                curbside: false,
                meetAndGreet: false,
                pickupFee: 0
              },
              black: {
                allowed: false,
                curbside: false,
                meetAndGreet: false,
                pickupFee: 0
              },
              suv: {
                allowed: false,
                curbside: false,
                meetAndGreet: false,
                pickupFee: 0
              },
              shuttle: {
                allowed: false,
                curbside: false,
                meetAndGreet: false,
                pickupFee: 0
              }
            };
          }
          result.push(item);
        }
        self.$store.commit('geofences/setGeofenceItems', result);

        self.pageNum = r.paging.pageNum;
        var totalPages = Math.floor(r.paging.totalItems / self.pageSize) + (r.paging.totalItems % self.pageSize > 1 ? 1 : 0);
        self.pageTotal = totalPages;
      });
    }
  },
  watch: {
    show: function show(value) {
      var self = this;
      if (!value) {
        self.geofences = [];
        return;
      }
      if (!self.services.length) {
        self.services.push(self.$store.state.geofences.services.id);
      }
      self.loadGeofences();
    }
  }

});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_geofences_airport__ = __webpack_require__(161);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'geofence-instruction-preview',
  data: function data() {
    return {};
  },

  computed: {
    preview: function preview() {
      return this.$store.state.geofences.preview;
    }
  },
  methods: {
    // updateField (field) {
    // }
  },
  watch: {
    preview: function preview(value) {
      console.log('watch', value);
    }
  },
  mounted: function mounted() {
    console.log('!', this.preview);
  }
});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccountDetails__ = __webpack_require__(1660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DriverPayouts__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shifts__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShiftForm__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Reviews__ = __webpack_require__(1680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Notes__ = __webpack_require__(1685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Payouts__ = __webpack_require__(1690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PayoutForm__ = __webpack_require__(1694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DocHistory__ = __webpack_require__(1698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Services__ = __webpack_require__(1702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Reservations__ = __webpack_require__(1706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App_NotificationModal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__App_SMSModal__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Logs__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_api_provider_user_info__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Partials_LoadingModal__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_cropperjs__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_cropperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_cropperjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_api_provider_reservations__ = __webpack_require__(584);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */



// import statistics from './Statistics'

















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'provider',
  components: {
    accountDetails: __WEBPACK_IMPORTED_MODULE_1__AccountDetails__["a" /* default */], driverPayouts: __WEBPACK_IMPORTED_MODULE_2__DriverPayouts__["a" /* default */], driverShifts: __WEBPACK_IMPORTED_MODULE_3__Shifts__["a" /* default */], shiftForm: __WEBPACK_IMPORTED_MODULE_4__ShiftForm__["a" /* default */], reviews: __WEBPACK_IMPORTED_MODULE_5__Reviews__["a" /* default */], notes: __WEBPACK_IMPORTED_MODULE_6__Notes__["a" /* default */],
    reservations: __WEBPACK_IMPORTED_MODULE_11__Reservations__["a" /* default */], loadingModal: __WEBPACK_IMPORTED_MODULE_16__components_Partials_LoadingModal__["a" /* default */], notificationModal: __WEBPACK_IMPORTED_MODULE_12__App_NotificationModal__["a" /* default */], smsModal: __WEBPACK_IMPORTED_MODULE_13__App_SMSModal__["a" /* default */], services: __WEBPACK_IMPORTED_MODULE_10__Services__["a" /* default */], payouts: __WEBPACK_IMPORTED_MODULE_7__Payouts__["a" /* default */],
    payoutForm: __WEBPACK_IMPORTED_MODULE_8__PayoutForm__["a" /* default */], docHistory: __WEBPACK_IMPORTED_MODULE_9__DocHistory__["a" /* default */], logs: __WEBPACK_IMPORTED_MODULE_14__Logs__["a" /* default */]
  },
  data: function data() {
    return {
      activeTab: {
        left: 0,
        right: 0
      },
      loading: false,
      showActiveModal: false,
      statusLoading: false,
      canvasUrl: '',
      previewUrl: '',
      basicInfoImg: '',
      vehicleInfoImg: '',
      showUploadPreview: false,
      uploadLoading: false,
      showOptions: false,
      showOptionsDelay: '',
      isTnc: false,
      licenseType: '',
      showBreakdownModal: false,
      breakdownError: '',
      showLogs: false,
      logDate: 'all',
      showRecords: false,
      nextDriverId: ''
    };
  },

  computed: {
    provId: function provId() {
      return this.$route.params.id;
    },
    isActive: function isActive() {
      return this.$store.state.provider.active;
    },
    basicInfo: function basicInfo() {
      return this.$store.state.provider.basicInfo;
    },
    providerData: function providerData() {
      var basicInfo = this.$store.state.provider.basicInfo;
      return {
        firstName: basicInfo.firstName,
        lastName: basicInfo.lastName,
        mobile: basicInfo.mobile
      };
    },
    isMax: function isMax() {
      return this.$store.state.provider.isMax;
    },
    providerName: function providerName() {
      return this.providerData.firstName + ' ' + this.providerData.lastName;
    },
    formHasError: function formHasError() {
      return this.$store.state.provider.formHasError;
    },
    formLoading: function formLoading() {
      return this.$store.state.provider.formLoading;
    },
    formResult: function formResult() {
      return this.$store.state.provider.formSave;
    },
    showUpload: function showUpload() {
      return this.$store.state.provider.upload.show;
    },
    showUploadError: function showUploadError() {
      return this.$store.state.provider.upload.error;
    },
    hasUpcoming: function hasUpcoming() {
      return this.$store.state.provider.upcoming.length > 0;
    },
    hasHistory: function hasHistory() {
      return this.$store.state.provider.history.length > 0;
    },
    totalDriverPayment: function totalDriverPayment() {
      var totalDriverPayment = this.$store.state.provider.totalDriverPayment;
      return {
        upcoming: totalDriverPayment.upcoming.total,
        upcomingLoading: totalDriverPayment.upcoming.loading,
        history: totalDriverPayment.history.total,
        historyLoading: totalDriverPayment.history.loading
      };
    },
    activeTable: function activeTable() {
      return this.activeTab.right === 1 ? 'history' : 'upcoming';
    },
    breakdownList: function breakdownList() {
      return this.$store.state.provider.breakdown;
    },
    useOldQuatation: function useOldQuatation() {
      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation;
    },
    serviceSave: function serviceSave() {
      return this.$store.state.provider.serviceSave;
    },
    editEnabled: function editEnabled() {
      return this.$store.state.session.user.access.hasOwnProperty('PageAdminProviderEdit');
    },
    logsIcon: function logsIcon() {
      return !this.showLogs ? 'fa fa-clipboard-list fa-2x' : 'fas fa-times fa-2x';
    },
    logsLoading: function logsLoading() {
      return this.$store.state.provider.logs.loading;
    },
    quickRes: function quickRes() {
      return this.$store.state.provider.quickRes;
    },

    driverId: {
      get: function get() {
        return this.$store.state.provider.driverId;
      },
      set: function set(x) {
        this.$store.commit('provider/setDriverId', x);
      }
    },
    driverIdLoading: {
      get: function get() {
        return this.$store.state.provider.driverIdLoading;
      },
      set: function set(x) {
        this.$store.commit('provider/setDriverIdLoading', x);
      }
    },
    created: function created() {
      return this.$store.state.provider.created;
    }
  },
  methods: {
    init: function init() {
      var self = this;
      self.loading = true;

      if (!self.editEnabled) {
        // self.activeTab.left = 2
      }
      __WEBPACK_IMPORTED_MODULE_15__modules_api_provider_user_info__["a" /* default */].getProviderData(self, self.$route.params.id, function (res) {
        if (res.error) {
          self.$router.push({ name: 'MissingPage' });
          return;
        }

        self.nextDriverId = '';
        if (!res.driverNum) {
          self.getNextDriverNum();
        }

        self.isTnc = res.providerAccountType === 'tnc';
        self.licenseType = res.providerAccountType;

        if (self.editEnabled && self.$refs.accountDetails.validateAll()) {
          self.$refs.accountDetails.validateAll();
        }

        if (self.editEnabled && self.$refs.services.getCheckedServices()) {
          self.$refs.services.getCheckedServices();
        }

        // if (self.$refs.shifts.initialize()) {
        //   self.$refs.shifts.initialize()
        // }

        self.loading = false;
        if (window.location.href.indexOf('?payouts') > -1) {
          self.activeTab.right = 2;
        }
      });
    },
    switchTab: function switchTab(tab, index) {
      this.activeTab[tab] = index;
    },
    onScrollLeftPanel: function onScrollLeftPanel(event) {
      var self = this;
      var scrollAndView = event.target.scrollTop + event.target.offsetHeight;
      if (event.target.scrollHeight - scrollAndView < 150) {
        if (self.activeTab.left === 3 && self.$refs.reviews.getReviews()) {
          self.$refs.reviews.getReviews();
          // } else if (self.activeTab.left === 4 && self.$refs.notes.getNotes()) {
          //   self.$refs.notes.getNotes()
        }
      }
    },
    onScrollRsvp: function onScrollRsvp(event) {
      var self = this;
      var type = self.activeTab.right ? 'history' : 'upcoming';
      var isMax = self.$store.state.provider.isMax[type];
      if (isMax) {
        return;
      }

      var scrollAndView = event.target.scrollTop + event.target.offsetHeight;
      if (event.target.scrollHeight - scrollAndView < 150) {
        if (self.$refs[type].getReservations()) {
          self.$refs[type].getReservations();
        }
      }
    },
    call: function call(user) {
      var self = this;
      self.showOptions = false;
      self.$plugins.phone.startCall(self, {
        phone: user.mobile,
        name: user.firstName + ' ' + user.lastName
      });
    },
    toggleProvActive: function toggleProvActive() {
      var self = this;
      self.statusLoading = true;
      __WEBPACK_IMPORTED_MODULE_15__modules_api_provider_user_info__["a" /* default */].updateProviderStatus(self, {
        id: self.$route.params.id,
        isActive: !this.isActive
      }, function (res) {
        self.statusLoading = false;
        self.showActiveModal = false;
        self.$store.commit('provider/setActive', !self.isActive);
        if (self.$refs.logs.reload()) {
          self.$refs.logs.reload();
        }
      });
    },
    AddNotes: function AddNotes() {
      this.$store.commit('reservationNotes/show', {
        driverId: this.$route.params.id,
        isProv: true
      });
    },
    triggerSave: function triggerSave() {
      if (this.$refs.accountDetails.save()) {
        this.$refs.accountDetails.save();
      }
    },
    closeFormResult: function closeFormResult() {
      this.$store.commit('provider/setFormSavingDone', false);

      if (this.formResult.message.indexOf('successfully updated') > -1) {
        location.reload();
      }

      this.$store.commit('provider/setFormSaveMessage', '');
    },
    setImage: function setImage(e) {
      var _this = this;

      var self = this;
      var file = e.target.files[0];

      if (!file.type.includes('image/')) {
        alert('Please select an image file');
        return;
      }

      if (typeof FileReader === 'function') {
        var reader = new FileReader();

        reader.onload = function (event) {
          _this.canvasUrl = event.target.result;
          // rebuild cropperjs with the updated source
          _this.$refs.cropper.replace(event.target.result);
          self.showUploadPreview = true;
          setTimeout(function () {
            self.previewUrl = self.$refs.cropper.getCroppedCanvas().toDataURL();
          }, 50);
        };
        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    cropImage: function cropImage() {
      var self = this;
      self.$refs.cropper.getCroppedCanvas({ width: 500, height: 500 }).toBlob(function (blob) {
        var ref = self.$store.state.provider.upload.ref;
        var fd = new FormData();
        fd.append('pic', blob, 'test.jpg');

        self.uploadLoading = true;
        self.$http.post({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.mediaHost + '/api/upload', fd, {
          header: { 'Content-Type': 'multipart/form-data' }
        }).then(function (res) {
          console.log('success', res);
          self.uploadLoading = false;
          self.closeUploadForm();
          if (!res.body.success) {
            self.$store.commit('provider/showUploadError', true);
            return;
          }
          self[ref + 'Img'] = res.body.data.url;
        }, function (res) {
          console.log('error', res);
          self.uploadLoading = false;
          self.closeUploadForm();
          self.$store.commit('provider/showUploadError', true);
        });
      }, 'image/jpeg', 0.8);
    },
    updateCropPreview: function updateCropPreview() {
      this.previewUrl = this.$refs.cropper.getCroppedCanvas().toDataURL();
    },
    closeUploadForm: function closeUploadForm() {
      if (this.uploadLoading) {
        return;
      }

      this.$refs.cropper.destroy();
      this.showUploadPreview = false;
      this.previewUrl = '';
      this.$refs.fileInput.value = '';

      this.$store.commit('provider/showCropper', {
        show: false,
        ref: ''
      });
    },
    closeUploadError: function closeUploadError() {
      this.$store.commit('provider/showUploadError', false);
    },
    toFixed: function toFixed(value) {
      return parseFloat(value).toFixed(2);
    },
    hideOptions: function hideOptions() {
      var self = this;
      self.showOptionsDelay = setTimeout(function () {
        self.showOptions = false;
      }, 1500);
    },
    clearOptionDelay: function clearOptionDelay() {
      if (this.showOptionsDelay) {
        clearTimeout(this.showOptionsDelay);
      }
    },
    sendSMS: function sendSMS() {
      this.showOptions = false;
      if (this.$refs.sms.showSMSForm()) {
        this.$refs.sms.showSMSForm();
      }
    },
    showNotif: function showNotif() {
      this.showOptions = false;
      if (this.$refs.notif.showNotifForm()) {
        this.$refs.notif.showNotifForm();
      }
    },
    printPlacard: function printPlacard() {
      var license = this.$store.state.provider.vehicleInfo.licensePlate;
      window.open('#/provider/' + this.provId + '/print-placard?license=' + license, 'targetWindow', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=528,height=842');
    },
    showBreakdown: function showBreakdown() {
      var self = this;
      var params = {
        id: self.provId,
        type: self.activeTab.right === 1 ? 'history' : 'upcoming'
      };

      self.loading = true;
      self.breakdownError = '';
      if (params.type === 'history') {
        self.$store.commit('provider/setProviderBreakdown', { value: [], type: 'deductions' });
        self.$store.commit('provider/setProviderBreakdown', { value: [], type: 'history' });
        __WEBPACK_IMPORTED_MODULE_18__modules_api_provider_reservations__["a" /* default */].getDeductions(self, params, function (res) {
          if (res.error) {
            self.loading = false;
            self.breakdownError = res.error.message;
            self.showBreakdownModal = true;
            return;
          }

          __WEBPACK_IMPORTED_MODULE_18__modules_api_provider_reservations__["a" /* default */].getAllRsvp(self, params, function (res2) {
            if (res2.error) {
              self.loading = false;
              self.breakdownError = res.error.message;
              self.showBreakdownModal = true;
              return;
            }

            self.$store.state.provider.breakdown.deductions.forEach(function (data) {
              self.$store.commit('provider/addProviderBreakdown', {
                type: 'history',
                value: data
              });
            });

            self.showBreakdownModal = true;
            self.loading = false;
          });
        });
      } else {
        self.$store.commit('provider/setProviderBreakdown', { value: [], type: 'upcoming' });
        __WEBPACK_IMPORTED_MODULE_18__modules_api_provider_reservations__["a" /* default */].getAllRsvp(self, params, function (res2) {
          if (res2.error) {
            self.loading = false;
            self.breakdownError = res.error.message;
            self.showBreakdownModal = true;
            return;
          }

          self.showBreakdownModal = true;
          self.loading = false;
        });
      }
    },
    totalBreakdown: function totalBreakdown(field) {
      var type = this.activeTab.right === 1 ? 'history' : 'upcoming';
      var list = this.$store.state.provider.breakdown[type];

      var total = 0;
      list.forEach(function (item) {
        total += item[field];
      });
      return total;
    },
    totalOverall: function totalOverall() {
      var total = this.totalBreakdown('amount') + this.totalBreakdown('pickupFee') + this.totalBreakdown('bonusAmount') + this.totalBreakdown('tip') + this.totalBreakdown('releaseBonus') + this.totalBreakdown('gasFee');
      total = total - this.totalBreakdown('deductions');
      return this.toFixed(total);
    },
    saveServices: function saveServices() {
      if (this.$refs.services.save()) {
        this.$refs.services.save();
      }
    },
    closeServiceModal: function closeServiceModal() {
      var self = this;
      self.$store.commit('provider/serviceSaveModal', false);
      setTimeout(function () {
        self.$store.commit('provider/serviceSaveSuccess', {
          success: false,
          message: ''
        });
      }, 500);
    },
    confirmModal: function confirmModal() {
      if (!this.editEnabled) {
        return;
      }
      this.showActiveModal = true;
    },
    toggleLogs: function toggleLogs() {
      this.showLogs = !this.showLogs;
    },
    toggleQuickRes: function toggleQuickRes() {
      var self = this;
      if (self.quickRes.loading) {
        return;
      }
      self.$store.commit('provider/setQuickResData', { loading: true });
      if (self.quickRes.enable) {
        self.$sdk.delete('/provider/' + self.provId + '/quickres', {
          token: self.$store.state.session.sessionToken
        }, function (res) {
          self.$store.commit('provider/setQuickResData', { loading: false });
          if (!res.error) {
            self.$store.commit('provider/setQuickResData', {
              modal: false,
              enable: false
            });
          }
        });
      } else {
        self.$sdk.post('/provider/' + self.provId + '/quickres', {
          token: self.$store.state.session.sessionToken
        }, function (res) {
          self.$store.commit('provider/setQuickResData', { loading: false });
          if (!res.error) {
            self.$store.commit('provider/setQuickResData', {
              modal: false,
              enable: true
            });
          }
        });
      }
    },
    closeQuickResModal: function closeQuickResModal() {
      if (this.quickRes.loading) {
        return;
      }
      self.$store.commit('provider/setQuickResData', { modal: false });
    },
    getNextDriverNum: function getNextDriverNum() {
      var self = this;
      if (self.driverIdLoading) {
        return;
      }
      self.driverIdLoading = true;
      self.$sdk.get('/provider/nextNum', {
        token: self.$store.state.session.sessionToken
      }, function (res) {
        self.driverIdLoading = false;
        if (!res.error) {
          self.driverId = res.next;
          self.nextDriverId = res.next;
          return;
        }
      });
    },
    dlProfile: function dlProfile() {
      var brand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ptrs';

      window.open('?brand=' + brand + '#/provider/' + this.provId + '/download', 'targetWindow', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=1122');
    },
    isBefore2026: function isBefore2026(x) {
      var year = __WEBPACK_IMPORTED_MODULE_0_moment___default()(x, 'MM/DD/YYYY').format('YYYY');
      year = parseInt(year);
      return year < 2026;
    }
  },
  watch: {
    provId: function provId(value) {
      this.nextDriverId = '';
      this.init();
      this.showLogs = false;
      this.logDate = 'all';
    },
    logDate: function logDate(value) {
      // if (this.$refs.logs.dateToggle(value)) {
      //   this.$refs.logs.dateToggle(value)
      // }
    }
  },
  mounted: function mounted() {
    this.init();

    if (this.$refs.upcoming.init()) {
      this.$refs.upcoming.init();
    }
  }
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_us__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_us___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_us__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ResetPassword__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_api_services__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_api_provider_user_info__ = __webpack_require__(61);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */







var phoneUtil = __webpack_require__(50).PhoneNumberUtil.getInstance();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'account-details',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default.a, resetPassword: __WEBPACK_IMPORTED_MODULE_4__ResetPassword__["a" /* default */] },
  props: ['basicInfoImg', 'vehicleInfoImg', 'nextDrvrId'],
  data: function data() {
    var _vehicleInfo;

    return {
      contentShow: {
        basicInfo: false,
        vehicleInfo: false,
        accountType: false,
        businessInfo: false,
        documentation: false,
        eligibility: false,
        agreements: false
      },
      countries: __webpack_require__(45).countries,
      services: {
        shared: false,
        opoli: false,
        black: false,
        suv: false,
        shuttle: false
      },
      validation: {
        services: '',
        basicInfo: {
          firstName: '',
          lastName: '',
          deviceOS: '',
          deviceModel: '',
          language: '',
          email: '',
          mobile: '',
          phoneNumber: '',
          countryCode: '',
          birthday: '',
          img: ''
        },
        vehicleInfo: (_vehicleInfo = {
          manufacturer: '',
          model: '',
          year: '',
          type: '',
          licensePlate: '',
          capacity: '',
          boxCapacity: '',
          door: ''
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_vehicleInfo, 'capacity', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_vehicleInfo, 'boxCapacity', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_vehicleInfo, 'identificationNumber', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_vehicleInfo, 'wheelchair', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_vehicleInfo, 'serviceDog', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_vehicleInfo, 'img', ''), _vehicleInfo),
        accountType: {
          type: ''
        },
        businessInfo: {
          name: '',
          type: '',
          ssnImg: '',
          ssn: '',
          einImg: '',
          ein: '',
          address: '',
          address2: '',
          city: '',
          country: '',
          state: '',
          zip: '',
          w9fileImg: ''
        },
        documentation: {
          insuranceCompany: '',
          insurancePolicy: '',
          insuranceExp: '',
          insuranceImg: '',
          cityLicense: '',
          cityLicenseExp: '',
          cityLicenseImg: '',
          tcpPermit: '',
          tcpPermitExp: '',
          tcpPermitImg: '',
          airportPermit: '',
          airportPermitExp: '',
          airportPermitImg: '',
          driversLicense: '',
          driversLicenseExp: '',
          driversLicenseImg: '',
          vehicleInspection: '',
          vehicleInspectionExp: '',
          vehicleInspectionImg: '',
          drivingRecordExp: '',
          drivingRecordImg: '',
          vehicleRegistrationExp: '',
          vehicleRegistrationImg: ''
        },
        eligibility: {
          convicted: '',
          conviction: '',
          ownVehicle: '',
          modifiedVehicle: '',
          driversLicense: ''
        }
      },
      activeFileInput: '',
      fileLoading: {
        ssnImg: false,
        einImg: false,
        insuranceImg: false,
        cityLicenseImg: false,
        tcpPermitImg: false,
        airportPermitImg: false,
        driversLicenseImg: false,
        vehicleInspectionImg: false,
        drivingRecordImg: false,
        w9fileImg: false,
        vehicleRegistrationImg: false
      },
      isDisplayCountryCode: true,
      enableTCPDocToTNC: false,
      ssnOriginal: '',
      ssnImgOriginal: '',
      einOriginal: '',
      einImgOriginal: '',
      nextDriverId: '',
      driverIdError: '',
      driverIdSuccess: false,
      driverIdDelay: ''
    };
  },

  computed: {
    provId: function provId() {
      return this.$route.params.id;
    },
    quickRes: function quickRes() {
      return this.$store.state.provider.quickRes;
    },

    backgroundSubmitted: {
      get: function get() {
        return this.$store.state.provider.backgroundSubmitted;
      },
      set: function set(newValue) {
        this.$store.state.provider.backgroundSubmitted = newValue;
      }
    },
    backgroundPassed: {
      get: function get() {
        return this.$store.state.provider.backgroundPassed;
      },
      set: function set(newValue) {
        this.$store.state.provider.backgroundPassed = newValue;
      }
    },
    isTestAcct: {
      get: function get() {
        return this.$store.state.provider.isTestAcct;
      },
      set: function set(newValue) {
        this.$store.state.provider.isTestAcct = newValue;
      }
    },
    maxDailyRsvpIsCustom: {
      get: function get() {
        return this.$store.state.provider.maxDailyRsvpIsCustom;
      },
      set: function set(newValue) {
        this.$store.state.provider.maxDailyRsvpIsCustom = newValue;
      }
    },
    maxDailyRsvp: {
      get: function get() {
        return this.$store.state.provider.maxDailyRsvp;
      },
      set: function set(newValue) {
        this.$store.state.provider.maxDailyRsvp = newValue;
      }
    },
    servicesData: function servicesData() {
      return this.$store.state.provider.services;
    },
    basicInfo: function basicInfo() {
      return this.$store.state.provider.basicInfo;
    },
    vehicleInfo: function vehicleInfo() {
      return this.$store.state.provider.vehicleInfo;
    },
    accountType: function accountType() {
      return this.$store.state.provider.accountType;
    },
    businessInfo: function businessInfo() {
      return this.$store.state.provider.businessInfo;
    },
    documentation: function documentation() {
      return this.$store.state.provider.documentation;
    },
    eligibility: function eligibility() {
      return this.$store.state.provider.eligibility;
    },
    signture: function signture() {
      return this.$store.state.provider.signature;
    },
    states: function states() {
      var states = [];
      for (var key in __WEBPACK_IMPORTED_MODULE_1_us___default.a.states) {
        if (__WEBPACK_IMPORTED_MODULE_1_us___default.a.states.hasOwnProperty(key)) {
          states.push({
            value: key,
            label: __WEBPACK_IMPORTED_MODULE_1_us___default.a.states[key].name
          });
        }
      }
      return states;
    },
    aggreementsLink: function aggreementsLink() {
      return {
        conductRules: '<a href="https://www.primetimerideshare.com/driver-conduct-rules" target="_blank">https://www.primetimerideshare.com/driver-conduct-rules</a>',
        terms: '<a href="https://www.primetimerideshare.com/terms" target="_blank">https://www.primetimerideshare.com/terms</a>',
        privacy: '<a href="https://www.primetimerideshare.com/privacy-policy" target="_blank">https://www.primetimerideshare.com/privacy-policy</a>'
      };
    },
    basicInfoLoading: function basicInfoLoading() {
      return this.$store.state.provider.upload.basicInfoLoading;
    },
    vehicleInfoLoading: function vehicleInfoLoading() {
      return this.$store.state.provider.upload.vehicleInfoLoading;
    },
    servicesLoading: function servicesLoading() {
      return this.$store.state.services.servicesLoading;
    },
    useOldQuatation: function useOldQuatation() {
      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation;
    },
    editEnabled: function editEnabled() {
      return this.$store.state.session.user.access.hasOwnProperty('PageAdminProviderEdit');
    },
    callingCode: function callingCode() {
      if (this.isDisplayCountryCode) {
        this.$store.commit('countryCode/setCallingCode', this.basicInfo.countryCode);
        if (this.$store.state.countryCode.callingCode > 0) {
          this.isDisplayCountryCode = false;
        }
      }
      return this.$store.state.countryCode.callingCode;
    },
    isDoorToDoorEnabled: function isDoorToDoorEnabled() {
      return this.$store.state.provider.isDoorToDoorEnabled;
    },

    driverId: {
      get: function get() {
        return this.$store.state.provider.driverId;
      },
      set: function set(x) {
        this.$store.commit('provider/setDriverId', x);
      }
    },
    driverIdLoading: {
      get: function get() {
        return this.$store.state.provider.driverIdLoading;
      },
      set: function set(x) {
        this.$store.commit('provider/setDriverIdLoading', x);
      }
    },
    driverNumEnabled: function driverNumEnabled() {
      return this.$store.state.session.user.access.hasOwnProperty('PageAdminProviderNum');
    },
    created: function created() {
      return this.$store.state.provider.created;
    },
    ptrsDriverAgreeUTC: function ptrsDriverAgreeUTC() {
      return this.$store.state.provider.ptrsDriverAgreeUTC;
    }
  },
  methods: {
    selectCountry: function selectCountry() {
      this.$store.commit('countryCode/setCountryModal', true);
    },
    updateAccountType: function updateAccountType(value) {
      this.$store.commit('provider/setAccountType', value);
      this.validateAll();
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('MM/DD/YYYY');
    },
    isPdfFile: function isPdfFile(file) {
      return file && file.indexOf('.pdf') > -1;
    },
    imgUploadButton: function imgUploadButton(value) {
      var _class = value === '' || value === null ? 'error' : 'warning';
      var label = value === '' || value === null ? 'Upload Image' : 'Change Image';
      var form = value === '' || value === null ? 'Upload Form' : 'Change Form';

      return {
        class: _class,
        label: label,
        form: form
      };
    },
    save: function save() {
      var self = this;
      if (self.validateAll()) {
        // save Data
        self.$store.commit('provider/setFormLoading', true);
        __WEBPACK_IMPORTED_MODULE_6__modules_api_provider_user_info__["a" /* default */].updateProvider(self, self.buildData(), function (res) {
          self.$store.commit('provider/setFormLoading', false);

          self.$store.commit('provider/setFormSavingDone', true);
          self.$store.commit('provider/setFormSaveMessage', self.$t('provider.formSuccessful'));
          if (res.error) {
            self.$store.commit('provider/setFormSaveMessage', res.error.message);
          }
        });
      }
    },
    validateAll: function validateAll() {
      var self = this;
      var noError = true;
      var errorMsg = {
        empty: self.$t('provider.emptyField'),
        email: self.$t('provider.invalidEmail'),
        emptyServices: self.$t('provider.emptyServices')
      };
      var isTcp = self.accountType.type === 'tcp';

      var serviceCount = 0;
      for (var key in self.services) {
        if (!self.services[key]) {
          serviceCount++;
        }
      }
      self.validation.services = '';
      if (self.useOldQuatation) {
        if (serviceCount === 5) {
          self.validation.services = errorMsg.emptyServices;
          // noError = false
        }
      }

      var emailFormat = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
      for (var _key in self.basicInfo) {
        self.validation.basicInfo[_key] = '';
        if (_key === 'email' && !emailFormat.test(self.basicInfo[_key])) {
          self.validation.basicInfo[_key] = errorMsg.email;
          // noError = false
        }
        if (self.basicInfo[_key] === '' || self.basicInfo[_key] === null) {
          self.validation.basicInfo[_key] = errorMsg.empty;
          // noError = false
        }
      }

      var vehicleNoneRequiredField = ['wheelchair', 'serviceDog'];
      if (!self.isDoorToDoorEnabled) {
        vehicleNoneRequiredField.push('boxCapacity');
      }

      for (var _key2 in self.vehicleInfo) {
        self.validation.vehicleInfo[_key2] = '';
        if (vehicleNoneRequiredField.indexOf(_key2) > -1) {
          continue;
        }

        if (self.vehicleInfo[_key2] === '' || self.vehicleInfo[_key2] === null) {
          self.validation.vehicleInfo[_key2] = errorMsg.empty;
          // noError = false
        }
      }

      if (isTcp || (self.accountType.type === 'tnc' || self.accountType.type === 'psc') && self.enableTCPDocToTNC) {
        var businessNoneRequiredField = ['address2'];
        for (var _key3 in self.businessInfo) {
          self.validation.businessInfo[_key3] = '';
          if (_key3 === 'state' && self.businessInfo.country !== 'United States' || businessNoneRequiredField.indexOf(_key3) > -1) {
            continue;
          }

          // if ((self.businessInfo.type === 'Sole Proprietorship' && key === 'ein') ||
          if (self.businessInfo.type !== 'Sole Proprietorship' && _key3 === 'ssn') {
            continue;
          }

          if (self.businessInfo[_key3] === '' || self.businessInfo[_key3] === null) {
            self.validation.businessInfo[_key3] = errorMsg.empty;
            // noError = false
          }
        }
      }

      var docuNoneRequiredField = ['insuranceCompany', 'vehicleInspection', 'vehicleInspectionExp', 'vehicleInspectionImg', 'drivingRecordExp', 'drivingRecordImg'];
      var tncNoneRequiredField = ['cityLicense', 'cityLicenseExp', 'cityLicenseImg', 'tcpPermit', 'tcpPermitExp', 'tcpPermitImg', 'airportPermit', 'airportPermitExp', 'airportPermitImg'];
      if ((self.accountType.type === 'tnc' || self.accountType.type === 'psc') && self.enableTCPDocToTNC) {
        tncNoneRequiredField.shift();
      }
      for (var _key4 in self.documentation) {
        self.validation.documentation[_key4] = '';
        if (docuNoneRequiredField.indexOf(_key4) > -1 || !isTcp && tncNoneRequiredField.indexOf(_key4) > -1) {
          continue;
        }

        if (self.documentation[_key4] === '' || self.documentation[_key4] === null) {
          self.validation.documentation[_key4] = errorMsg.empty;
          // noError = false
        }
      }
      // self.$store.commit('provider/setFormHasError', !noError)
      return noError;
    },
    fieldValidate: function fieldValidate(parent, child) {
      var self = this;
      if (self[parent][child] !== '') {
        this.validation[parent][child] = '';
      } else {
        this.validation[parent][child] = self.$t('provider.emptyField');
      }

      self.saveButtonStatusCheck();
    },
    buildData: function buildData() {
      var _vehicle;

      var self = this;
      var basicInfo = this.basicInfo;
      var vehicleInfo = this.vehicleInfo;
      var accountType = this.accountType;
      var businessInfo = this.businessInfo;
      var documentation = this.documentation;
      var eligibility = this.eligibility;

      var vehicleInspectionExp = '';
      var drivingRecordExp = '';
      var vehicleRegistrationExp = '';
      if (documentation.vehicleInspectionExp !== null && documentation.vehicleInspectionExp !== '') {
        vehicleInspectionExp = __WEBPACK_IMPORTED_MODULE_2_moment___default()(documentation.vehicleInspectionExp, 'MM/DD/YYYY').format('YYYY-MM-DD');
      }
      if (documentation.drivingRecordExp !== null && documentation.drivingRecordExp !== '') {
        drivingRecordExp = __WEBPACK_IMPORTED_MODULE_2_moment___default()(documentation.drivingRecordExp, 'MM/DD/YYYY').format('YYYY-MM-DD');
      }
      if (documentation.vehicleRegistrationExp !== null && documentation.vehicleRegistrationExp !== '') {
        vehicleRegistrationExp = __WEBPACK_IMPORTED_MODULE_2_moment___default()(documentation.vehicleRegistrationExp, 'MM/DD/YYYY').format('YYYY-MM-DD');
      }

      var services = [];
      for (var index in self.services) {
        if (self.services[index]) {
          services.push(index);
        }
      }

      var saveData = {
        id: this.$store.state.provider.id,
        firstName: basicInfo.firstName,
        lastName: basicInfo.lastName,
        email: basicInfo.email,
        model: basicInfo.deviceModel,
        OS: basicInfo.deviceOS,
        services: services,
        language: basicInfo.language.toLowerCase(),
        backgroundCheckPassed: this.backgroundPassed ? 1 : 0,
        backgroundCheckSubmitted: this.backgroundSubmitted ? 1 : 0,
        isTestAcct: this.isTestAcct ? 1 : 0,
        maxDailyRSVP: this.maxDailyRsvpIsCustom === '1' ? this.maxDailyRsvp : 0,
        dateOfBirth: __WEBPACK_IMPORTED_MODULE_2_moment___default()(basicInfo.birthday, 'MM/DD/YYYY').format('YYYY-MM-DD'),
        avatarUrl: basicInfo.img,
        // mobile: basicInfo.mobile,
        phoneNumber: basicInfo.phoneNumber,
        countryCode: this.$store.state.countryCode.callingCode, // basicInfo.countryCode
        businessName: businessInfo.name,
        businessType: businessInfo.type,
        // businessSSN: businessInfo.ssn,
        // businessSSNUrl: businessInfo.ssnImg,
        // businessEIN: businessInfo.ein,
        // businessEINUrl: businessInfo.einImg,
        address: businessInfo.address1,
        address2: businessInfo.address2,
        city: businessInfo.city,
        country: businessInfo.country,
        state: businessInfo.state,
        zip: businessInfo.zip,
        w9fileUrl: businessInfo.w9fileImg,
        vehicle: (_vehicle = {
          manufactured: __WEBPACK_IMPORTED_MODULE_2_moment___default()(vehicleInfo.year, 'YYYY').format('YYYY'),
          seatCapacity: vehicleInfo.capacity,
          boxCapacity: vehicleInfo.boxCapacity,
          numberOfDoor: vehicleInfo.door
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_vehicle, 'boxCapacity', vehicleInfo.boxCapacity), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_vehicle, 'manufacturer', vehicleInfo.manufacturer), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_vehicle, 'model', vehicleInfo.model), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_vehicle, 'idNumber', vehicleInfo.identificationNumber), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_vehicle, 'licensePlate', vehicleInfo.licensePlate), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_vehicle, 'photoUrl', vehicleInfo.img), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_vehicle, 'wheelChairLift', vehicleInfo.wheelchair), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_vehicle, 'serviceDock', vehicleInfo.serviceDog), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_vehicle, 'type', vehicleInfo.type), _vehicle),
        type: accountType.type,
        documents: {
          insurance: {
            company: documentation.insuranceCompany,
            policyNumber: documentation.insurancePolicy,
            policyExpire: __WEBPACK_IMPORTED_MODULE_2_moment___default()(documentation.insuranceExp, 'MM/DD/YYYY').format('YYYY-MM-DD'),
            policyFilename: documentation.insuranceImg
          },
          driverLicense: {
            number: documentation.driversLicense,
            expire: __WEBPACK_IMPORTED_MODULE_2_moment___default()(documentation.driversLicenseExp, 'MM/DD/YYYY').format('YYYY-MM-DD'),
            filename: documentation.driversLicenseImg
          },
          cityLicense: {
            number: documentation.cityLicense,
            expire: __WEBPACK_IMPORTED_MODULE_2_moment___default()(documentation.cityLicenseExp, 'MM/DD/YYYY').format('YYYY-MM-DD'),
            filename: documentation.cityLicenseImg
          },
          tcpPermit: {
            number: documentation.tcpPermit,
            expire: __WEBPACK_IMPORTED_MODULE_2_moment___default()(documentation.tcpPermitExp, 'MM/DD/YYYY').format('YYYY-MM-DD'),
            filename: documentation.tcpPermitImg
          },
          airportPermit: {
            number: documentation.airportPermit,
            expire: __WEBPACK_IMPORTED_MODULE_2_moment___default()(documentation.airportPermitExp, 'MM/DD/YYYY').format('YYYY-MM-DD'),
            filename: documentation.airportPermitImg
          },
          safetyInspection: {
            by: documentation.vehicleInspection,
            expire: vehicleInspectionExp,
            filename: documentation.vehicleInspectionImg
          },
          drivingRecord: {
            expire: drivingRecordExp,
            filename: documentation.drivingRecordImg
          },
          vehicleRegistration: {
            expire: vehicleRegistrationExp,
            filename: documentation.vehicleRegistrationImg
          }
        },
        eligibility: {
          CrimeProblems: eligibility.convicted,
          DrivingProblems: eligibility.conviction,
          OwnVehicle: eligibility.ownVehicle,
          ModifiedVehicle: eligibility.modifiedVehicle,
          Tcp: eligibility.driversLicense
        }
      };

      if (self.ssnOriginal !== businessInfo.ssn) {
        saveData.businessSSN = businessInfo.ssn;
      }
      if (self.ssnImgOriginal !== businessInfo.ssnImg) {
        saveData.businessSSNUrl = businessInfo.ssnImg;
      }
      if (self.einOriginal !== businessInfo.ein) {
        saveData.businessEIN = businessInfo.ein;
      }
      if (self.einImgOriginal !== businessInfo.einImg) {
        saveData.businessEINUrl = businessInfo.einImg;
      }

      return saveData;
    },
    saveButtonStatusCheck: function saveButtonStatusCheck() {
      var self = this;
      // let isTcp = self.accountType.type === 'tcp'
      var overAllError = false;

      // if (self.validation.services !== '') {
      //   overAllError = true
      // }

      // for (let key in self.validation.basicInfo) {
      //   if (self.validation.basicInfo[key] !== '') {
      //     overAllError = true
      //   }
      // }
      // for (let key in self.validation.vehicleInfo) {
      //   if (key === 'boxCapacity' && !self.isDoorToDoorEnabled) { continue }
      //   if (self.validation.vehicleInfo[key] !== '') {
      //     overAllError = true
      //   }
      // }
      // if (isTcp) {
      //   for (let key in self.validation.businessInfo) {
      //     if (self.validation.businessInfo[key] !== '') {
      //       overAllError = true
      //     }
      //   }
      // }
      // let docuNoneRequiredField = [
      //   'insuranceCompany',
      //   'vehicleInspection', 'vehicleInspectionExp', 'vehicleInspectionImg',
      //   'drivingRecordExp', 'drivingRecordImg'
      // ]
      // let tncNoneRequiredField = [
      //   'cityLicense', 'cityLicenseExp', 'cityLicenseImg',
      //   'tcpPermit', 'tcpPermitExp', 'tcpPermitImg',
      //   'airportPermit', 'airportPermitExp', 'airportPermitImg'
      // ]
      // if ((self.accountType.type === 'tnc' || self.accountType.type === 'psc') && self.enableTCPDocToTNC) {
      //   tncNoneRequiredField.shift()
      // }
      // for (let key in self.validation.documentation) {
      //   if (docuNoneRequiredField.indexOf(key) > -1 ||
      //     (!isTcp && tncNoneRequiredField.indexOf(key) > -1)
      //   ) {
      //     continue
      //   }

      //   if (self.validation.documentation[key] !== '') {
      //     overAllError = true
      //   }
      // }

      for (var file in self.fileLoading) {
        if (self.fileLoading[file]) {
          overAllError = true;
        }
      }

      self.$store.commit('provider/setFormHasError', overAllError);
    },
    showResetPassword: function showResetPassword() {
      if (this.$refs.resetPassword.showResetPassword()) {
        this.$refs.resetPassword.showResetPassword();
      }
    },
    triggerCropUpload: function triggerCropUpload(ref) {
      this.$store.commit('provider/showCropper', {
        show: true,
        ref: ref
      });
    },
    triggerUploadInput: function triggerUploadInput(ref) {
      this.activeFileInput = ref;
      this.$refs[ref].click();
    },
    uploadImg: function uploadImg(e) {
      var self = this;
      var file = e.target.files[0];

      if (!file) {
        return;
      }

      var activeFileInput = self.activeFileInput;
      var fd = new FormData();
      fd.append('pic', file);

      self.fileLoading[activeFileInput] = true;
      self.$http.post({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.mediaHost + '/api/upload', fd, {
        header: { 'Content-Type': 'multipart/form-data' }
      }).then(function (res) {
        console.log('success', res);
        self.fileLoading[activeFileInput] = false;
        if (!res.body.success) {
          self.$store.commit('provider/showUploadError', true);
          return;
        }
        if (['ssnImg', 'einImg', 'w9fileImg'].indexOf(activeFileInput) > -1) {
          this.validation.businessInfo[activeFileInput] = '';
          self.businessInfo[activeFileInput] = res.body.data.url;
        } else {
          this.validation.documentation[activeFileInput] = '';
          self.documentation[activeFileInput] = res.body.data.url;
        }
      }, function (res) {
        console.log('error', res);
        self.fileLoading[activeFileInput] = false;
        self.$store.commit('provider/showUploadError', true);
      });
    },
    serviceSelect: function serviceSelect() {
      var self = this;
      var serviceCount = 0;
      for (var key in self.services) {
        if (!self.services[key]) {
          serviceCount++;
        }
      }

      self.validation.services = self.$t('provider.emptyServices');
      if (serviceCount !== 5) {
        self.validation.services = '';
      }
    },
    serviceLabel: function serviceLabel(code) {
      return __WEBPACK_IMPORTED_MODULE_5__modules_api_services__["a" /* default */].getServiceName(code);
    },
    isNumber: function isNumber(evt) {
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
        return;
      }
      return true;
    },
    focusChangeCheck: function focusChangeCheck(target) {
      if (target === 'ssn' && this.ssnOriginal === this.businessInfo.ssn) {
        this.businessInfo.ssn = '';
      }
      if (target === 'ein' && this.einOriginal === this.businessInfo.ein) {
        this.businessInfo.ein = '';
      }
    },
    changeCheck: function changeCheck(target) {
      if (target === 'ssn' && this.businessInfo.ssn === '') {
        this.businessInfo.ssn = this.ssnOriginal;
      }
      if (target === 'ein' && this.businessInfo.ein === '') {
        this.businessInfo.ein = this.einOriginal;
      }
    },
    confirmQuickRes: function confirmQuickRes() {
      if (!this.editEnabled) {
        return;
      }
      this.$store.commit('provider/setQuickResData', { modal: true });
    },
    saveDriverId: function saveDriverId() {
      var self = this;
      if (self.driverIdLoading) {
        return;
      }
      if (self.driverIdDelay) {
        clearTimeout(self.driverIdDelay);
      }
      self.driverIdError = '';
      if (!self.driverId) {
        self.driverIdError = 'Please input driver id.';
        return;
      }
      if (parseInt(self.driverId) < 310) {
        self.driverIdError = 'Using below 310 is not allowed.';
        return;
      }
      self.driverIdLoading = true;
      self.$sdk.post('/provider/' + self.provId, {
        token: self.$store.state.session.sessionToken,
        driverNum: self.nextDriverId
      }, function (res) {
        self.driverIdLoading = false;
        if (res.error) {
          self.driverIdError = res.error.code === 'ER_DUP_ENTRY' ? 'Driver ID already exist.' : res.error.message;
          return;
        }

        self.nextDriverId = '';
        self.driverIdSuccess = true;
        self.driverIdDelay = setTimeout(function () {
          self.driverIdSuccess = false;
        }, 2000);
      });
    },
    createdDate: function createdDate(x) {
      if (!x) return x;
      if (this.isBefore2026(x)) return '01/01/2026';
      return x;
    },
    isBefore2026: function isBefore2026(x) {
      var year = __WEBPACK_IMPORTED_MODULE_2_moment___default()(x, 'MM/DD/YYYY').format('YYYY');
      year = parseInt(year);
      return year < 2026;
    }
  },
  watch: {
    provId: function provId() {
      if (this.driverIdDelay) {
        clearTimeout(this.driverIdDelay);
      }
    },
    servicesData: function servicesData(value) {
      this.services = {
        shared: value.includes('shared'),
        opoli: value.includes('opoli'),
        black: value.includes('black'),
        suv: value.includes('suv'),
        shuttle: value.includes('shuttle')
      };
    },
    basicInfo: function basicInfo(value) {
      this.contentShow = {
        basicInfo: true,
        vehicleInfo: true,
        accountType: true,
        businessInfo: true,
        documentation: true,
        eligibility: true,
        agreements: true
      };
      this.validateAll();
    },
    basicInfoImg: function basicInfoImg(value) {
      if (value !== '') {
        this.basicInfo.img = value;
        this.validation.basicInfo.img = '';
      }
    },
    vehicleInfoImg: function vehicleInfoImg(value) {
      if (value !== '') {
        this.vehicleInfo.img = value;
        this.validation.vehicleInfo.img = '';
      }
    },
    businessInfo: function businessInfo() {
      this.ssnOriginal = this.businessInfo.ssn;
      this.ssnImgOriginal = this.businessInfo.ssnImg;
      this.einOriginal = this.businessInfo.ein;
      this.einImgOriginal = this.businessInfo.einImg;
    },
    isDoorToDoorEnabled: function isDoorToDoorEnabled() {
      this.saveButtonStatusCheck();
    },
    nextDrvrId: function nextDrvrId(x) {
      this.nextDriverId = x;
    }
  },
  mounted: function mounted() {
    var self = this;
    if (!self.$store.state.services.list.length) {
      self.$store.commit('services/setServiceLoading', true);
      __WEBPACK_IMPORTED_MODULE_5__modules_api_services__["a" /* default */].getAllService(self, function (r) {
        self.$store.commit('services/setServiceLoading', false);
      });
    }

    this.nextDriverId = this.nextDrvrId;

    self.enableTCPDocToTNC = self.$settings.get('EnableTCPDocToTNC') === 1;
    setTimeout(function () {
      self.enableTCPDocToTNC = self.$settings.get('EnableTCPDocToTNC') === 1;
    }, 500);
  }
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_provider_user_info__ = __webpack_require__(61);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reset-password',
  props: ['show'],
  data: function data() {
    return {
      showForm: false,
      showMessage: false,
      message: '',
      resetSuccess: false,
      password: {
        value: '',
        hasError: false,
        message: ''
      },
      repassword: {
        value: '',
        hasError: false,
        message: ''
      },
      passwordLoading: {
        email: false,
        manual: false
      }
    };
  },

  computed: {},
  methods: {
    showResetPassword: function showResetPassword() {
      if (this.showMessage && !this.showForm) {
        this.showMessage = false;
      } else {
        this.showForm = !this.showForm;
      }
    },
    emailResetPassword: function emailResetPassword() {
      var self = this;
      self.passwordLoading.email = true;
      __WEBPACK_IMPORTED_MODULE_0__modules_api_provider_user_info__["a" /* default */].emailPassword(self, self.$store.state.provider.id, function (res) {
        self.passwordLoading.email = false;
        self.showForm = false;
        self.showMessage = true;
        self.message = self.$t('provider.passwordSent');
        self.resetSuccess = true;

        if (res.error) {
          self.message = res.error.message;
          self.resetSuccess = false;
          return;
        }

        setTimeout(function () {
          self.showMessage = false;
        }, 5000);
      });
    },
    resetPassword: function resetPassword() {
      var self = this;
      self.password.hasError = false;
      self.password.message = '';
      self.repassword.hasError = false;
      self.repassword.message = '';

      if (self.password.value !== self.repassword.value) {
        self.password.hasError = true;
        self.repassword.hasError = true;
        self.password.message = self.$t('provider.passwordNotMatch');
      }

      if (self.password.value === '') {
        self.password.hasError = true;
        self.password.message = self.$t('provider.emptyField');
      }

      if (self.repassword.value === '') {
        self.repassword.hasError = true;
        self.repassword.message = self.$t('provider.emptyField');
      }

      if (!self.password.hasError && !self.repassword.hasError) {
        var data = {
          id: self.$store.state.provider.id,
          password: self.password.value
        };

        self.passwordLoading.manual = true;
        __WEBPACK_IMPORTED_MODULE_0__modules_api_provider_user_info__["a" /* default */].updatePassword(self, data, function (res) {
          self.passwordLoading.manual = false;
          self.showForm = false;
          self.showMessage = true;
          self.resetSuccess = true;
          self.message = self.$t('provider.passwordSuccess');

          if (res.error) {
            self.resetSuccess = false;
            self.message = res.error.message;
          }
        });
      }
    }
  }
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'driver-payouts',
  props: ['provId'],
  data: function data() {
    return {
      account: null,
      externalAccounts: null
    };
  },

  methods: {
    init: function init() {
      var self = this;
      self.$sdk.get('/provider/' + self.provId + '/account', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          self.account = null;
          self.externalAccount = null;
          return;
        }
        self.account = r.account;
        self.externalAccounts = r.externalAccounts;
      });
    }
  },
  watch: {
    provId: function provId(value) {
      this.init();
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'driver-shifts',
  props: ['active'],
  components: { DatePicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a },
  data: function data() {
    return {
      startDate: null,
      endDate: null,
      days: [],
      driverShifts: [],
      homeSector: null,
      loaded: ''
    };
  },

  computed: {
    provId: function provId() {
      return this.$route.params.id;
    },
    startDateDisabledDates: function startDateDisabledDates() {
      if (this.startDate === null) {
        return {
          to: new Date(1980, 0, 1)
        };
      }
      return {
        from: this.endDate
      };
    },
    endDateDisabledDates: function endDateDisabledDates() {
      if (this.startDate === null) {
        return {
          to: new Date(1980, 0, 1)
        };
      }
      return {
        to: this.startDate
      };
    },
    isShiftFormSaved: function isShiftFormSaved() {
      return this.$store.state.provider.shiftForm.save;
    },
    homeSectorId: function homeSectorId() {
      return this.$store.state.provider.basicInfo.homeSectorId;
    },

    // editEnabled () { return this.$store.state.session.user.access.hasOwnProperty('PageAdminProviderEdit') }
    editEnabled: function editEnabled() {
      return true;
    }
  },
  methods: {
    initialize: function initialize() {
      var self = this;
      var start = __WEBPACK_IMPORTED_MODULE_0_moment___default()(__WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM/DD/YYYY') + ' 00:00:00AM', 'MM/DD/YYYY hh:mm:ssA');
      var end = __WEBPACK_IMPORTED_MODULE_0_moment___default()(__WEBPACK_IMPORTED_MODULE_0_moment___default()().add(6, 'days').format('MM/DD/YYYY') + ' 11:59:59PM', 'MM/DD/YYYY hh:mm:ssA');

      if (self.startDate === null && self.endDate === null) {
        self.startDate = start.toDate();
        self.endDate = end.toDate();
      } else {
        start = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.startDate);
        end = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.endDate);
      }
      end = __WEBPACK_IMPORTED_MODULE_0_moment___default()(end.format('MM/DD/YYYY') + ' 11:59:59PM', 'MM/DD/YYYY hh:mm:ssA');

      self.days = [];
      for (var m = __WEBPACK_IMPORTED_MODULE_0_moment___default()(start); m.diff(end, 'days') <= 0; m.add(1, 'days')) {
        if (m.isAfter(end)) {
          break;
        }
        self.days.push(__WEBPACK_IMPORTED_MODULE_0_moment___default()(m));
      }

      self.$sdk.get('/shifts', {
        token: self.$store.state.session.sessionToken,
        driverId: self.$route.params.id,
        since: __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.startDate).unix(),
        until: __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.endDate).unix()
      }, function (r) {
        if (r.error) {
          return;
        }
        self.processDriverShifts(r.list);
      });
    },
    processDriverShifts: function processDriverShifts(shifts) {
      var self = this;
      self.driverShifts = [];

      for (var _i = 0; _i < shifts.length; _i++) {
        var shift = shifts[_i];

        var start = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(shift.startTimestamp);
        var end = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(shift.endTimestamp);
        var duration = Math.round((shift.endTimestamp - shift.startTimestamp) / 60 / 60);
        var isBugDate = false;
        if (end.diff(start, 'days') > 2) {
          end = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(shift.startTimestamp).add(12, 'hours');
          duration = Math.round((end.format('X') - shift.startTimestamp) / 60 / 60);
          isBugDate = true;
        }
        var position = self.buildShiftPosition(start, duration);
        var endsNextDay = false;

        // check if it shift crosses multiple days
        var startDayStr = start.format('MM/DD/YYYY');
        var endDayStr = end.format('MM/DD/YYYY');
        if (startDayStr !== endDayStr) {
          var tempEnd = __WEBPACK_IMPORTED_MODULE_0_moment___default()(endDayStr + ' 12:00AM', 'MM/DD/YYYY hh:mmA');
          var tempDuration = tempEnd.diff(start, 'hours');
          position = self.buildShiftPosition(start, tempDuration);
          endsNextDay = true;

          var duration2 = end.diff(tempEnd, 'hours');
          var position2 = self.buildShiftPosition(tempEnd, duration2);

          if (!isBugDate) {
            self.driverShifts.push({
              id: shift.id,
              driverId: shift.driverId,
              start: start,
              end: end,
              duration: duration,
              dayIndex: self.findDayIndex(start),
              startHour: parseInt(start.format('HH')),
              startMinute: parseInt(start.format('mm')),
              shiftPosition: position2,
              homeSectorId: shift.driverHomeSectorId,
              homeSectorName: shift.driverHomeSectorName,
              homeSubsectorId: shift.drivertHomeSubsectorId,
              homeSubsectorName: shift.drivertHomeSubsectorName,
              workSectorId: shift.driverWorkSectorId,
              workSectorName: shift.driverWorkSectorName,
              workSubsectorId: shift.driverWorkSubsectorId,
              workSubsectorName: shift.driverWorkSubsectorName,
              confirmed: shift.driverConfirmed,
              startsPrevDay: true,
              endsNextDay: false
            });
          }
        }
        if (!isBugDate) {
          self.driverShifts.push({
            id: shift.id,
            driverId: shift.driverId,
            start: start,
            end: end,
            duration: duration,
            dayIndex: self.findDayIndex(start),
            startHour: parseInt(start.format('HH')),
            startMinute: parseInt(start.format('mm')),
            shiftPosition: position,
            homeSectorId: shift.driverHomeSectorId,
            homeSectorName: shift.driverHomeSectorName,
            homeSubsectorId: shift.drivertHomeSubsectorId,
            homeSubsectorName: shift.drivertHomeSubsectorName,
            workSectorId: shift.driverWorkSectorId,
            workSectorName: shift.driverWorkSectorName,
            workSubsectorId: shift.driverWorkSubsectorId,
            workSubsectorName: shift.driverWorkSubsectorName,
            confirmed: shift.driverConfirmed,
            startsPrevDay: false,
            endsNextDay: endsNextDay
          });
        }

        // clone dates to fix Over end time
        if (isBugDate && __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(shift.endTimestamp).diff(start, 'days') > 2) {
          var days = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.endDate).diff(__WEBPACK_IMPORTED_MODULE_0_moment___default()(self.startDate), 'days');
          var maxDays = __WEBPACK_IMPORTED_MODULE_0_moment___default()(shift.endTimestamp, 'X').diff(__WEBPACK_IMPORTED_MODULE_0_moment___default()(self.startDate), 'days');
          if (days > maxDays) days = maxDays;else if (maxDays > days) days++;

          for (var _i = 0; _i < days; _i++) {
            var startTime = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(shift.startTimestamp);
            var endTime = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(shift.startTimestamp).add(12, 'hours');
            start = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.startDate).add(_i, 'days').hour(startTime.format('HH')).minute(startTime.format('mm'));
            end = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.startDate).add(_i + 1, 'days').hour(endTime.format('HH')).minute(endTime.format('mm'));
            // duration = Math.round((end.format('X') - shift.startTimestamp) / 60 / 60)
            duration = 12;
            position = self.buildShiftPosition(start, duration);
            endsNextDay = false;
            startDayStr = start.format('MM/DD/YYYY');
            endDayStr = end.format('MM/DD/YYYY');

            // if (startDayStr !== endDayStr) {
            //   let tempEnd = moment(endDayStr + ' 12:00AM', 'MM/DD/YYYY hh:mmA')
            //   let tempDuration = tempEnd.diff(start, 'hours')
            //   position = self.buildShiftPosition(start, tempDuration)
            //   endsNextDay = true

            //   let duration2 = end.diff(tempEnd, 'hours')
            //   let position2 = self.buildShiftPosition(tempEnd, duration2)

            //   self.driverShifts.push({
            //     id: shift.id,
            //     driverId: shift.driverId,
            //     start: start,
            //     end: end,
            //     duration: duration,
            //     dayIndex: self.findDayIndex(start),
            //     startHour: parseInt(start.format('HH')),
            //     startMinute: parseInt(start.format('mm')),
            //     shiftPosition: position2,
            //     homeSectorId: shift.driverHomeSectorId,
            //     homeSectorName: shift.driverHomeSectorName,
            //     homeSubsectorId: shift.drivertHomeSubsectorId,
            //     homeSubsectorName: shift.drivertHomeSubsectorName,
            //     workSectorId: shift.driverWorkSectorId,
            //     workSectorName: shift.driverWorkSectorName,
            //     workSubsectorId: shift.driverWorkSubsectorId,
            //     workSubsectorName: shift.driverWorkSubsectorName,
            //     confirmed: shift.driverConfirmed,
            //     startsPrevDay: true,
            //     endsNextDay: false
            //   })
            // }
            self.driverShifts.push({
              id: shift.id,
              driverId: shift.driverId,
              start: start,
              end: end,
              duration: duration,
              dayIndex: self.findDayIndex(start),
              startHour: parseInt(start.format('HH')),
              startMinute: parseInt(start.format('mm')),
              shiftPosition: position,
              homeSectorId: shift.driverHomeSectorId,
              homeSectorName: shift.driverHomeSectorName,
              homeSubsectorId: shift.drivertHomeSubsectorId,
              homeSubsectorName: shift.drivertHomeSubsectorName,
              workSectorId: shift.driverWorkSectorId,
              workSectorName: shift.driverWorkSectorName,
              workSubsectorId: shift.driverWorkSubsectorId,
              workSubsectorName: shift.driverWorkSubsectorName,
              confirmed: shift.driverConfirmed,
              startsPrevDay: false,
              endsNextDay: endsNextDay
            });
          }
        }
      }
    },
    buildShiftPosition: function buildShiftPosition(shiftStart, duration) {
      var self = this;
      var format = 'MM/DD/YYYY';

      var dayStart = null;
      for (var i = 0; i < self.days.length; i++) {
        var day = self.days[i];
        if (day.format(format) === shiftStart.format(format)) {
          dayStart = i;
          break;
        }
      }

      var hour = parseInt(shiftStart.format('HH')) - 1;
      var minute = parseInt(shiftStart.format('mm'));

      var result = {
        top: 30 + dayStart * 74 + 'px',
        left: 60 + hour * 60 + minute + 'px',
        width: duration * 60 + 'px'
      };
      return result;
    },
    findDayIndex: function findDayIndex(shiftStart) {
      var self = this;
      var format = 'MM/DD/YYYY';

      for (var i = 0; i < self.days.length; i++) {
        var day = self.days[i];
        if (day.format(format) === shiftStart.format(format)) {
          return i + 1;
        }
      }
    },
    filterShifts: function filterShifts() {
      var _this = this;

      var self = this;
      setTimeout(function () {
        _this.initialize();
      }, 250);
    },
    openHomeSector: function openHomeSector() {
      var self = this;
      if (!self.editEnabled) {
        return;
      }
      var homeSectorId = -1;
      if (self.homeSectorId !== null) {
        homeSectorId = self.homeSectorId;
      }
      self.$store.commit('provider/setShiftFormSelectedSector', homeSectorId);
      self.$store.commit('provider/setShiftFormTitle', 'Select the Home Sector');
      self.$store.commit('provider/setShiftFormForHomeSector', true);
      self.$store.commit('provider/setShiftFormShow', true);
    },
    addNewShift: function addNewShift(day, hour, ampm) {
      var self = this;
      if (!self.editEnabled) {
        return;
      }
      var selectedSector = -1;
      if (self.homeSectorId !== null) {
        selectedSector = self.homeSectorId;
      }
      self.$store.commit('provider/setShiftFormSelectedSector', selectedSector);
      self.$store.commit('provider/setShiftFormSelectedSubsector', -1);
      self.$store.commit('provider/setShiftFormShiftId', null);
      self.$store.commit('provider/setShiftFormShiftDuration', 1);
      if (day === null || hour === null || ampm === null) {

        var now = __WEBPACK_IMPORTED_MODULE_0_moment___default()();
        var _hour = parseInt(now.format('hh'));
        var minute = parseInt(now.format('mm'));
        minute = Math.ceil(minute / 5) * 5;
        if (minute > 55) {
          _hour = _hour + 1;
          minute = 0;
        }
        if (_hour > 12) {
          _hour = 1;
        }
        self.$store.commit('provider/setShiftFormShiftDay', now.toDate());
        self.$store.commit('provider/setShiftFormTimeHour', _hour);
        self.$store.commit('provider/setShiftFormTimeMinute', minute);
        self.$store.commit('provider/setShiftFormTimeAmPm', now.format('A'));
      } else {
        self.$store.commit('provider/setShiftFormShiftDay', day.toDate());
        self.$store.commit('provider/setShiftFormTimeHour', hour);
        self.$store.commit('provider/setShiftFormTimeMinute', 0);
        self.$store.commit('provider/setShiftFormTimeAmPm', ampm);
      }

      self.$store.commit('provider/setShiftFormTitle', 'Creating Availability');
      self.$store.commit('provider/setShiftFormIsEdit', false);
      self.$store.commit('provider/setShiftFormSave', false);
      self.$store.commit('provider/setShiftFormForHomeSector', false);
      self.$store.commit('provider/setShiftFormShow', true);
    },
    editShift: function editShift(driverShift) {
      var self = this;
      if (!self.editEnabled) {
        return;
      }
      self.$store.commit('provider/setShiftFormSelectedSector', driverShift.workSectorId);
      self.$store.commit('provider/setShiftFormSelectedSubsector', driverShift.workSubsectorId);
      self.$store.commit('provider/setShiftFormShiftId', driverShift.id);
      self.$store.commit('provider/setShiftFormShiftDuration', driverShift.duration);

      self.$store.commit('provider/setShiftFormShiftDay', driverShift.start.toDate());
      self.$store.commit('provider/setShiftFormTimeHour', parseInt(driverShift.start.format('hh')));
      self.$store.commit('provider/setShiftFormTimeMinute', parseInt(driverShift.start.format('mm')));
      self.$store.commit('provider/setShiftFormTimeAmPm', driverShift.start.format('A'));

      var title = 'Editing ' + driverShift.start.format('MM/DD/YYYY hh:mmA') + ' - ' + driverShift.end.format('hh:mmA') + ' availability';
      self.$store.commit('provider/setShiftFormTitle', title);
      self.$store.commit('provider/setShiftFormIsEdit', true);
      self.$store.commit('provider/setShiftFormSave', false);
      self.$store.commit('provider/setShiftFormForHomeSector', false);
      self.$store.commit('provider/setShiftFormShow', true);
    },
    populateHomeSector: function populateHomeSector() {
      var self = this;
      var homeSectorId = self.$store.state.provider.basicInfo.homeSectorId;
      if (homeSectorId === null) {
        self.homeSector = null;
        return;
      }
      var sectors = self.$store.state.provider.shiftForm.sectors;
      for (var i = 0; i < sectors.length; i++) {
        var sector = sectors[i];
        if (sector.ID === homeSectorId) {
          self.homeSector = sector.name;
          return;
        }
      }
      self.homeSector = null;
    },
    dateFormat: function dateFormat(val) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(val).format('MM/DD/YYYY');
    }
  },
  watch: {
    provId: function provId(value) {
      this.populateHomeSector();
      if (this.active && this.loaded !== value) {
        this.loaded = this.provId;
        this.initialize();
      }
    },
    homeSectorId: function homeSectorId(value) {
      if (value === null) {
        return;
      }
      this.populateHomeSector();
    },
    isShiftFormSaved: function isShiftFormSaved(value) {
      if (!value) {
        return;
      }
      this.filterShifts();
    },
    active: function active(val) {
      if (val && this.loaded !== this.provId) {
        this.loaded = this.provId;
        this.initialize();
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    // self.initialize()

    self.$store.commit('provider/setShiftFormSectors', []);
    self.$sdk.get('/sectors', {
      token: self.$store.state.session.sessionToken,
      pageSize: 50
    }, function (r) {
      if (r.error) {
        return;
      }
      self.$store.commit('provider/setShiftFormSelectedSector', -1);
      self.$store.commit('provider/setShiftFormSectors', r.list);
      self.populateHomeSector();
    });
  }
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shift-form',
  components: { DatePicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a },
  data: function data() {
    return {
      calendarDisabled: {
        to: null
      },
      durationRange: 12,
      error: {
        show: false,
        message: 'This is an error message.'
      },
      saving: false,
      deleting: false,
      timeSelected: -1
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.provider.shiftForm.show;
    },
    forHomeSector: function forHomeSector() {
      return this.$store.state.provider.shiftForm.forHomeSector;
    },
    title: function title() {
      return this.$store.state.provider.shiftForm.title;
    },
    isEdit: function isEdit() {
      return this.$store.state.provider.shiftForm.isEdit;
    },
    timeHour: function timeHour() {
      var hour = this.$store.state.provider.shiftForm.timeHour;
      if (hour < 10) {
        hour = '0' + hour;
      }
      return '' + hour;
    },
    timeMinute: function timeMinute() {
      var minute = this.$store.state.provider.shiftForm.timeMinute;
      if (minute < 10) {
        minute = '0' + minute;
      }
      return '' + minute;
    },

    shiftDay: {
      get: function get() {
        return this.$store.state.provider.shiftForm.shiftDay;
      },
      set: function set(value) {
        this.$store.commit('provider/setShiftFormShiftDay', value);
      }
    },
    timeAmPm: function timeAmPm() {
      return this.$store.state.provider.shiftForm.timeAmPm;
    },

    shiftDuration: {
      get: function get() {
        return this.$store.state.provider.shiftForm.shiftDuration;
      },
      set: function set(value) {
        this.$store.commit('provider/setShiftFormShiftDuration', value);
      }
    },
    sectors: function sectors() {
      return this.$store.state.provider.shiftForm.sectors;
    },

    selectedSector: {
      get: function get() {
        return this.$store.state.provider.shiftForm.selectedSector;
      },
      set: function set(value) {
        this.$store.commit('provider/setShiftFormSelectedSector', value);
      }
    },
    subsectors: function subsectors() {
      return this.$store.state.provider.shiftForm.subsectors;
    },

    selectedSubsector: {
      get: function get() {
        return this.$store.state.provider.shiftForm.selectedSubsector;
      },
      set: function set(value) {
        this.$store.commit('provider/setShiftFormSelectedSubsector', value);
      }
    }
  },
  methods: {
    saveHomeSector: function saveHomeSector() {
      var self = this;

      self.error.show = false;
      self.error.message = '';
      if (self.selectedSector === -1) {
        self.error.show = true;
        self.error.message = 'Please choose a sector.';
        return;
      }
      self.saving = true;

      var provId = self.$store.state.provider.id;
      self.$sdk.post('/provider/' + provId, {
        token: self.$store.state.session.sessionToken,
        homeSectorId: self.selectedSector
      }, function (r) {
        self.saving = false;
        self.$store.commit('provider/setHomeSectorId', self.selectedSector);
        self.$store.commit('provider/setShiftFormShow', false);
        self.$store.commit('provider/setShiftFormSave', false);
      });
    },
    save: function save() {
      var self = this;
      if (!self.isValid()) {
        return;
      }
      self.saving = true;

      var day = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.shiftDay).format('MM/DD/YYYY');
      var hour = '';
      var minute = '';
      var ampm = '';
      var shiftStart = '';
      var shiftEnd = '';
      var format = 'MM/DD/YYYY hh:mm A';
      if (self.timeSelected == 'custom') {
        hour = self.timeHour;
        minute = self.timeMinute;
        ampm = self.timeAmPm;
        shiftStart = __WEBPACK_IMPORTED_MODULE_0_moment___default()(day + ' ' + hour + ':' + minute + ' ' + ampm, format);
        shiftEnd = __WEBPACK_IMPORTED_MODULE_0_moment___default()(day + ' ' + hour + ':' + minute + ' ' + ampm, format).add(self.shiftDuration, 'hours');
      } else {
        var startTime = '03:00 AM';
        var shiftDuration = 11;
        if (self.timeSelected === '1pm') {
          startTime = '01:00 PM';
          shiftDuration = 9;
        } else if (self.timeSelected === '8pm') {
          startTime = '08:00 PM';
          shiftDuration = 8;
        } else if (self.timeSelected === 'AM') {
          startTime = '12:00 AM';
          shiftDuration = 12;
        } else if (self.timeSelected === 'PM') {
          startTime = '12:00 PM';
          shiftDuration = 12;
        }
        shiftStart = __WEBPACK_IMPORTED_MODULE_0_moment___default()(day + ' ' + startTime, format);
        shiftEnd = __WEBPACK_IMPORTED_MODULE_0_moment___default()(day + ' ' + startTime, format).add(shiftDuration, 'hours');
      }

      var request = {
        token: self.$store.state.session.sessionToken,
        driverId: self.$store.state.provider.id,
        driverHomeSectorId: null,
        driverHomeSubsectorId: null,
        driverWorkSectorId: self.selectedSector,
        driverWorkSubsectorId: null,
        startTimestamp: shiftStart.unix(),
        endTimestamp: shiftEnd.unix(),
        driverConfirmed: 0
      };

      var url = '/shifts';
      if (self.isEdit) {
        url = '/shifts/' + self.$store.state.provider.shiftForm.shiftId;
        console.log('EDITING', url);
      }

      self.$sdk.post(url, request, function (r) {
        self.saving = false;
        if (r.error) {
          self.error.show = true;
          self.error.message = r.error.message;
          return;
        }
        self.$store.commit('provider/setShiftFormShow', false);
        self.$store.commit('provider/setShiftFormSave', true);
      });
    },
    deleteShift: function deleteShift() {
      var self = this;
      self.deleting = true;

      self.$sdk.delete('/shifts/' + self.$store.state.provider.shiftForm.shiftId, {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.deleting = false;
        if (r.error) {
          self.error.show = true;
          self.error.message = r.error.message;
          return;
        }
        self.$store.commit('provider/setShiftFormShow', false);
        self.$store.commit('provider/setShiftFormSave', true);
      });
    },
    isValid: function isValid() {
      var self = this;
      var day = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.shiftDay).format('MM/DD/YYYY');
      var format = 'MM/DD/YYYY hh:mm A';
      var shiftStart = '';
      if (self.timeSelected == 'custom') {
        var hour = self.timeHour;
        var minute = self.timeMinute;
        var ampm = self.timeAmPm;
        shiftStart = __WEBPACK_IMPORTED_MODULE_0_moment___default()(day + ' ' + hour + ':' + minute + ' ' + ampm, format);
      } else {
        var timeSelected = '04:00 AM';
        if (self.timeSelected === '2pm') {
          timeSelected = '02:00 PM';
        } else if (self.timeSelected === '8pm') {
          timeSelected = '08:00 PM';
        }
        shiftStart = __WEBPACK_IMPORTED_MODULE_0_moment___default()(day + ' ' + timeSelected, format);
      }

      var now = __WEBPACK_IMPORTED_MODULE_0_moment___default()();
      if (self.timeSelected == -1) {
        self.error.show = true;
        self.error.message = 'Please select which time you start.';
        return false;
      }
      if (shiftStart.isBefore(now)) {
        self.error.show = true;
        self.error.message = 'A shift should start in the future.';
        return false;
      }

      if (self.selectedSector === -1) {
        self.error.show = true;
        self.error.message = 'Please choose a sector.';
        return false;
      }

      /*
      if (self.selectedSubsector === -1) {
        self.error.show = true
        self.error.message = 'Please choose a subsector.'
        return false
      }
      */

      self.error.show = false;
      return true;
    },
    hideForm: function hideForm() {
      if (this.saving) {
        return;
      }
      this.$store.commit('provider/setShiftFormShow', false);
    },
    setAmPm: function setAmPm() {
      var value = 'AM';
      if (this.timeAmPm === 'AM') {
        value = 'PM';
      }
      this.$store.commit('provider/setShiftFormTimeAmPm', value);
    },
    setHour: function setHour(add) {
      var self = this;
      var hour = this.$store.state.provider.shiftForm.timeHour;

      if (add) {
        var _value = hour + 1;
        if (hour === 12) {
          _value = 1;
        }
        self.$store.commit('provider/setShiftFormTimeHour', _value);
        return;
      }

      var value = hour - 1;
      if (hour === 1) {
        value = 12;
      }
      self.$store.commit('provider/setShiftFormTimeHour', value);
      return;
    },
    setMinute: function setMinute(add) {
      var self = this;
      var minute = this.$store.state.provider.shiftForm.timeMinute;

      if (add) {
        var _value2 = minute + 5;
        if (minute === 55) {
          _value2 = 0;
        }
        self.$store.commit('provider/setShiftFormTimeMinute', _value2);
        return;
      }

      var value = minute - 5;
      if (minute === 0) {
        value = 55;
      }
      self.$store.commit('provider/setShiftFormTimeMinute', value);
      return;
    },
    getSubsectors: function getSubsectors(reset) {
      var self = this;
      if (reset) {
        self.$store.commit('provider/setShiftFormSelectedSubsector', -1);
      }
      self.$store.commit('provider/setShiftFormSubsectors', []);
      self.$sdk.get('/sectors/' + self.selectedSector + '/subsectors', {
        token: self.$store.state.session.sessionToken,
        polygon: 1
      }, function (r) {
        if (r.error) {
          return;
        }
        self.$store.commit('provider/setShiftFormSubsectors', r.list);
      });
    }
  },
  watch: {
    show: function show(value) {
      if (!value) {
        this.timeSelected = -1;
        return;
      }
      this.error.show = false;
      if (this.selectedSector !== -1) {
        this.getSubsectors(false);
      }
    }
  }
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_provider_reviews__ = __webpack_require__(1683);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reviews',
  props: ['active'],
  data: function data() {
    return {
      statsLoading: false,
      loading: false,
      loaded: ''
    };
  },

  computed: {
    provId: function provId() {
      return this.$route.params.id;
    },
    stats: function stats() {
      var provider = this.$store.state.provider;
      return {
        average: provider.averageReviews.toString().substring(0, 3),
        fiveStar: provider.fiveStarReviews,
        total: provider.totalReviews
      };
    },
    reviews: function reviews() {
      return this.$store.state.provider.reviews;
    },
    isMax: function isMax() {
      return this.$store.state.provider.reviewMax;
    }
  },
  methods: {
    init: function init() {
      var self = this;
      self.$store.commit('provider/resetReviews');
      self.$store.commit('provider/setReviewMax', false);
      self.$store.commit('provider/setReviewPage', 0);

      self.getReviews();

      self.statsLoading = true;
      self.$store.commit('provider/resetStatsReviews');
      __WEBPACK_IMPORTED_MODULE_0__modules_api_provider_reviews__["a" /* default */].getReviewStats(self, self.$route.params.id, function (res) {
        self.statsLoading = false;
      });
    },
    getReviews: function getReviews() {
      var self = this;
      if (self.isMax || self.loading) {
        return;
      }

      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__modules_api_provider_reviews__["a" /* default */].getProviderReviews(self, self.provId, function (res) {
        self.loading = false;
      });
    }
  },
  watch: {
    provId: function provId(value) {
      if (this.active && this.loaded !== value) {
        this.loaded = this.provId;
        this.init();
      }
    },
    active: function active(val) {
      if (val && this.loaded !== this.provId) {
        this.loaded = this.provId;
        this.init();
      }
    }
  },
  mounted: function mounted() {
    // this.init()
  }
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_provider_notes__ = __webpack_require__(1688);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notes',
  props: ['active'],
  data: function data() {
    return {
      loading: false,
      deleteLoading: false,
      deleteMessage: '',
      notesType: 'notes',
      loaded: '',
      endOfResult: false
    };
  },

  computed: {
    provId: function provId() {
      return this.$route.params.id;
    },
    notes: function notes() {
      var notesList = this.$store.state.provider.notes.list;
      if (this.notesType === 'notes') {
        return notesList.filter(function (x) {
          return x.status !== 'availability';
        });
      }
      return notesList.filter(function (x) {
        return x.status === 'availability';
      });
    },
    notesAvailability: function notesAvailability() {
      return this.$store.state.provider.notes.list.filter(function (x) {
        return x.status === 'availability';
      });
    },
    isMax: function isMax() {
      return this.$store.state.provider.notes.isMax;
    },
    adminId: function adminId() {
      return this.$store.state.session.user.id;
    },
    noteDeleteId: function noteDeleteId() {
      return this.$store.state.provider.notes.noteDeleteId;
    }
  },
  methods: {
    init: function init() {
      var self = this;

      self.$store.commit('provider/resetNotes');
      self.$store.commit('provider/setNotesIsMax', false);
      self.$store.commit('provider/setNotesPage', 0);

      self.getNotes();
    },
    getNotes: function getNotes() {
      var self = this;
      if (self.isMax || self.loading) {
        return;
      }

      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__modules_api_provider_notes__["a" /* default */].getNotes(self, self.provId, function (res) {
        self.loading = false;
        if (res.list.length < self.$store.state.provider.notes.pageSize) self.endOfResult = true;
      });
    },
    editNote: function editNote(value) {
      this.$store.commit('reservationNotes/show', {
        noteId: value.id,
        notes: value.message,
        noteStatus: value.status,
        isProv: true
      });
    },
    deleteNote: function deleteNote(value) {
      this.$store.commit('provider/setNoteDeleteId', value.id);
    },
    hideDelete: function hideDelete() {
      this.$store.commit('provider/setNoteDeleteId', 0);
    },
    deleteConfirm: function deleteConfirm(noteId) {
      var self = this;
      self.deleteLoading = true;
      self.deleteMessage = '';
      __WEBPACK_IMPORTED_MODULE_0__modules_api_provider_notes__["a" /* default */].deleteNote(self, noteId, function (res) {
        if (res.error) {
          self.deleteMessage = res.error.msg;
        }
        self.deleteLoading = false;
      });
    }
  },
  watch: {
    provId: function provId(value) {
      this.endOfResult = false;
      if (this.active && this.loaded !== value) {
        this.loaded = this.provId;
        this.init();
      }
    },
    active: function active(val) {
      if (val && this.loaded !== this.provId) {
        this.loaded = this.provId;
        this.init();
      }
    }
  },
  mounted: function mounted() {
    // this.init()
  }
});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_csvexport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_provider_payouts__ = __webpack_require__(162);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'payouts',
  props: ['active'],
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a },
  data: function data() {
    return {
      downloading: false,
      filter: {
        weeks: [],
        selectedWeek: { isCustom: false }
      },
      payoutAccount: null,
      loadingTransactions: false,
      transactions: null,
      removingTransaction: false,
      batch: {
        loading: false,
        item: null,
        updating: false,
        debit: 0,
        credit: 0
      },
      loaded: '',
      customVal: {
        start: new Date(),
        end: new Date(),
        isCustom: true
      },
      startDate: '',
      endDate: '',
      validation: {
        startDate: '',
        endDate: ''
      },
      dlVia: 'pdf',
      dlModal: false
    };
  },

  computed: {
    provId: function provId() {
      return this.$route.params.id;
    },
    hasPermission: function hasPermission() {
      return typeof this.$store.state.session.user.access.PageAdminDriverBatchModifications !== 'undefined';
    },
    isCurrentBatch: function isCurrentBatch() {
      if (this.filter.selectedWeek === null || this.filter.weeks.length <= 0 || this.filter.selectedWeek.isCustom) {
        return false;
      }
      return this.filter.selectedWeek.start.isSame(this.filter.weeks[0].start);
    },
    refreshTrx: function refreshTrx() {
      return this.$store.state.provider.payoutForm.refresh;
    }
  },
  methods: {
    init: function init() {
      var self = this;
      var start = __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('isoweek');
      var end = __WEBPACK_IMPORTED_MODULE_0_moment___default()(start).endOf('isoweek');
      self.filter.weeks = [];
      self.filter.weeks.push({
        start: start,
        end: end
      });
      self.filter.selectedWeek = self.filter.weeks[0];
      var current = __WEBPACK_IMPORTED_MODULE_0_moment___default()(start).startOf('isoweek');
      for (var i = 0; i < 7; i++) {
        var startWeek = __WEBPACK_IMPORTED_MODULE_0_moment___default()(current).subtract(1, 'd').startOf('isoweek');
        var endWeek = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startWeek).endOf('isoweek');
        current = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startWeek);

        self.filter.weeks.push({
          start: startWeek,
          end: endWeek
        });
      }
      self.initTransactions();
      __WEBPACK_IMPORTED_MODULE_3__modules_api_provider_payouts__["a" /* default */].getAccount(self, self.provId, function (r) {
        if (r.error) {
          self.payoutAccount = null;
          return;
        }
        if (r.account === null) {
          self.payoutAccount = null;
          return;
        }
        self.payoutAccount = {
          id: r.account.id,
          execRideUrl: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.Stripe.accountURL + r.account.executiveRideStripeAccountId,
          firstClassUrl: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.Stripe.accountURL + r.account.firstClassTransportationStripeAccountId,
          rejected: r.account.rejected === 1,
          deleted: r.account.deleted === 1,
          payoutMethods: r.externalAccounts,
          defaultPayoutMethod: r.externalAccounts.length > 0 ? r.externalAccounts.find(function (e) {
            return e.default === 1;
          }) : null
        };
      });
    },
    initBatch: function initBatch() {
      var self = this;
      self.batch.loading = true;
      self.batch.item = null;
      var since = '';
      var until = '';
      if (self.filter.selectedWeek.isCustom) {
        since = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.startDate).format('YYYY-MM-DD');
        until = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.endDate).format('YYYY-MM-DD');
      } else {
        since = self.filter.selectedWeek.start.format('YYYY-MM-DD');
        until = self.filter.selectedWeek.end.format('YYYY-MM-DD');
      }
      __WEBPACK_IMPORTED_MODULE_3__modules_api_provider_payouts__["a" /* default */].getProviderBatch(self, {
        token: self.$store.state.session.sessionToken,
        contactId: self.provId,
        since: since,
        until: until
      }, function (r) {
        self.batch.loading = false;
        if (r.error) {
          return;
        }

        if (r.list.length <= 0) {
          self.batch.item = null;
          return;
        }
        self.batch.item = r.list[0];
      });
    },
    initTransactions: function initTransactions() {
      var self = this;
      var since = '';
      var until = '';
      if (self.filter.selectedWeek.isCustom) {
        if (!self.startDate || !self.endDate) return;
        since = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.startDate).format('YYYY-MM-DD');
        until = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.endDate).format('YYYY-MM-DD');
      } else {
        self.validation.startDate = '';
        self.startDate = '';
        self.endDate = '';
        since = self.filter.selectedWeek.start.format('YYYY-MM-DD');
        until = self.filter.selectedWeek.end.format('YYYY-MM-DD');
      }

      self.initBatch();
      self.loadingTransactions = true;
      __WEBPACK_IMPORTED_MODULE_3__modules_api_provider_payouts__["a" /* default */].getTransactions(self, {
        token: self.$store.state.session.sessionToken,
        contactId: self.provId,
        deleted: 0,
        since: since,
        until: until,
        order: 'created',
        orderAsc: 0
      }, function (r) {
        self.loadingTransactions = false;
        self.$store.commit('provider/setPayoutFormRefresh', false);
        if (r.error) {
          self.transactions = null;
          return;
        }
        self.transactions = self.processTransactions(r.list);
      });
    },
    processTransactions: function processTransactions(transactions) {
      var result = [];
      var self = this;
      self.batch.credit = 0;
      self.batch.debit = 0;
      for (var i = 0; i < transactions.length; i++) {
        var trx = transactions[i];
        var created = __WEBPACK_IMPORTED_MODULE_0_moment___default()(trx.created.substring(0, 10) + ' ' + trx.created.substring(11, 19), 'YYYY-MM-DD HH:mm:ss');
        trx.created = created.format('MM/DD/YYYY hh:mm A');
        trx['origDescription'] = trx.description;
        var descriptionIndex = -1;
        if (trx.reservationId !== null) {
          descriptionIndex = trx.description.indexOf('Reservation');
        }
        if (trx.packageId !== null) {
          descriptionIndex = trx.description.indexOf('Package');
        }
        if (descriptionIndex >= 0) {
          trx.description = trx.description.substring(0, descriptionIndex);
        }

        if (trx.type === 'credit') {
          self.batch.credit += trx.amount;
        } else {
          self.batch.debit += trx.amount;
        }

        trx['showRemove'] = false;
        result.push(trx);
      }
      return result;
    },
    toggleRemovePrompt: function toggleRemovePrompt(index) {
      var self = this;
      self.transactions[index].showRemove = !self.transactions[index].showRemove;
    },
    removeTransaction: function removeTransaction(index) {
      var self = this;
      var trx = self.transactions[index];
      self.removingTransaction = true;
      __WEBPACK_IMPORTED_MODULE_3__modules_api_provider_payouts__["a" /* default */].updateTransaction(self, trx.id, {
        token: self.$store.state.session.sessionToken,
        type: trx.type,
        transactionType: trx.transactionType,
        deleted: 1
      }, function (r) {
        self.transactions[index].showRemove = false;
        self.removingTransaction = false;
        if (r.error) {
          return;
        }
        self.initTransactions();
      });
    },
    showPayoutForm: function showPayoutForm(trx) {
      if (trx === null) {
        this.$store.commit('provider/setPayoutFormNew');
      } else {
        this.$store.commit('provider/setPayoutFormForm', {
          id: trx.id,
          type: trx.type,
          transactionType: trx.transactionType,
          amount: trx.amount,
          description: trx.origDescription,
          notes: trx.notes,
          reservationId: trx.reservationId,
          packageId: trx.packageId
        });
      }
      this.$store.commit('provider/setPayoutFormShow', true);
    },
    showNotes: function showNotes(trx) {
      var self = this;
      self.$store.commit('provider/setPayoutNotes', {
        show: true,
        note: trx.notes
      });
    },
    markAsPaid: function markAsPaid(batch) {
      var self = this;
      self.batch.updating = true;
      __WEBPACK_IMPORTED_MODULE_3__modules_api_provider_payouts__["a" /* default */].updateBatch(self, batch.id, {
        token: self.$store.state.session.sessionToken,
        payoutStatus: 'paid'
      }, function (r) {
        self.batch.updating = false;
        if (r.error) {
          return;
        }
        batch.payoutStatus = 'paid';
        self.batch.item = batch;
      });
      console.log('PAID', batch);
    },
    printReciept: function printReciept() {
      var self = this;
      self.downloading = true;
      var since = '';
      var until = '';
      if (self.filter.selectedWeek.isCustom) {
        since = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.startDate);
        until = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.endDate);
      } else {
        since = self.filter.selectedWeek.start;
        until = self.filter.selectedWeek.end;
      }
      self.$sdk.download('/provider/transaction/print', {
        token: self.$store.state.session.sessionToken,
        contactId: self.provId,
        deleted: 0,
        since: since.format('YYYY-MM-DD'),
        until: until.format('YYYY-MM-DD'),
        order: 'created',
        orderAsc: 0
      }, function (data) {
        self.downloading = false;
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = data;
        a.download = since.format('MMDDYY') + ' - ' + until.format('MMDDYY') + '.pdf';
        a.click();
        window.URL.revokeObjectURL(data);
        document.body.removeChild(a);
      }, '2.0');
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('MM/DD/YYYY');
    },
    changeDateRange: function changeDateRange() {
      if (!this.startDate || !this.endDate) return;
      this.validation.startDate = '';
      var start = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.startDate);
      var end = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.endDate);
      if (end.diff(start, 'days') < 0) {
        this.validation.startDate = 'Invalid date range.';
        return;
      }
      this.initTransactions();
    },
    formatDate: function formatDate(x) {
      if (!x) return '';
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(x).format('MMM DD');
    },
    initDownload: function initDownload() {
      if (this.dlVia == 'pdf') this.printReciept();else this.printCsv();
      this.dlModal = false;
    },
    printCsv: function printCsv() {
      var since = '';
      var until = '';
      if (this.filter.selectedWeek.isCustom) {
        since = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.startDate);
        until = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.endDate);
      } else {
        since = this.filter.selectedWeek.start;
        until = this.filter.selectedWeek.end;
      }

      var exporter = __WEBPACK_IMPORTED_MODULE_2_csvexport___default.a.create({
        filename: since.format('MMDDYY') + ' - ' + until.format('MMDDYY') + '.csv',
        columns: ['Date', 'Transaction', 'Amount']
      });
      var data = [];
      var provData = this.$store.state.provider;

      data.push({
        Date: provData.businessInfo.name,
        Transaction: '',
        Amount: 'INVOICE'
      });
      data.push({
        Date: provData.homeAdress.address,
        Transaction: '',
        Amount: since.format('MM/DD/YYYY') + ' - ' + until.format('MM/DD/YYYY')
      });
      data.push({
        Date: provData.homeAdress.city + ', ' + provData.homeAdress.state + ' ' + provData.homeAdress.zip,
        Transaction: '',
        Amount: ''
      });
      data.push({ Date: '', Transaction: '', Amount: '' });
      data.push({ Date: '', Transaction: '', Amount: '' });

      var credit = 0;
      var debit = 0;
      this.transactions.forEach(function (trx) {
        if (trx.type === 'credit') credit += trx.amount;else debit += trx.amount;
        data.push({
          Date: __WEBPACK_IMPORTED_MODULE_0_moment___default()(trx.created, 'MM/DD/YYYY hh:mm A').format('MMM DD, YYYY H:mm A'),
          Transaction: trx.origDescription,
          Amount: '$' + trx.amount
        });
      });
      data.push({ Date: '', Transaction: '', Amount: '' });
      data.push({ Date: '', Transaction: 'Credit:', Amount: '$' + credit });
      data.push({ Date: '', Transaction: 'Debit:', Amount: '-($' + debit + ')' });
      data.push({ Date: '', Transaction: 'Total:', Amount: '$' + (credit - debit) });
      exporter.downloadCsv(data);
    }
  },
  watch: {
    provId: function provId(value) {
      if (this.active && this.loaded !== value) {
        this.loaded = this.provId;
        this.init();
      }
    },
    refreshTrx: function refreshTrx(value) {
      if (!value) {
        return;
      }
      this.init();
    },
    active: function active(val) {
      if (val && this.loaded !== this.provId) {
        this.loaded = this.provId;
        this.init();
      }
    }
  },
  mounted: function mounted() {
    // this.init()
  }
});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_provider_payouts__ = __webpack_require__(162);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'payout-form',
  props: ['provId'],
  data: function data() {
    return {
      saving: false,
      error: {
        show: false,
        message: ''
      },
      rsvpValid: null,
      packageValid: null
    };
  },

  computed: {
    notes: function notes() {
      return this.$store.state.provider.payoutNotes;
    },
    show: function show() {
      return this.$store.state.provider.payoutForm.show;
    },
    trxId: function trxId() {
      return this.$store.state.provider.payoutForm.form.id;
    },

    trxType: {
      get: function get() {
        return this.$store.state.provider.payoutForm.form.type;
      },
      set: function set(value) {
        this.$store.commit('provider/setPayoutFormType', value);
      }
    },
    trxTransactionType: {
      get: function get() {
        return this.$store.state.provider.payoutForm.form.transactionType;
      },
      set: function set(value) {
        this.$store.commit('provider/setPayoutFormTransactionType', value);
      }
    },
    trxAmount: {
      get: function get() {
        return this.$store.state.provider.payoutForm.form.amount;
      },
      set: function set(value) {
        this.$store.commit('provider/setPayoutFormAmount', value);
      }
    },
    trxDescription: {
      get: function get() {
        return this.$store.state.provider.payoutForm.form.description;
      },
      set: function set(value) {
        this.$store.commit('provider/setPayoutFormDescription', value);
      }
    },
    trxNotes: {
      get: function get() {
        return this.$store.state.provider.payoutForm.form.notes;
      },
      set: function set(value) {
        this.$store.commit('provider/setPayoutFormNotes', value);
      }
    },
    trxReservationId: {
      get: function get() {
        return this.$store.state.provider.payoutForm.form.reservationId;
      },
      set: function set(value) {
        this.$store.commit('provider/setPayoutFormReservationId', value);
      }
    },
    trxPackageId: {
      get: function get() {
        return this.$store.state.provider.payoutForm.form.packageId;
      },
      set: function set(value) {
        this.$store.commit('provider/setPayoutFormPackageId', value);
      }
    }
  },
  methods: {
    validatePackage: function validatePackage() {
      var self = this;
      if (self.trxPackageId === null || self.trxPackageId === '') {
        self.packageValid = {
          validating: false,
          isValid: true
        };
        return;
      }

      self.packageValid = {
        validating: true,
        isValid: false
      };
      self.$sdk.get('/admin/package/' + self.trxPackageId, {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        console.log(r);
        self.packageValid.validating = false;
        if (r.error) {
          self.packageValid.isValid = false;
          return;
        }
        self.packageValid.isValid = true;
      });
    },
    validateRsvp: function validateRsvp() {
      var self = this;
      if (self.trxReservationId === null || self.trxReservationId === '') {
        self.rsvpValid = {
          validating: false,
          isValid: true
        };
        return;
      }

      self.rsvpValid = {
        validating: true,
        isValid: false
      };
      self.$sdk.get('/admin/rsvp/' + self.trxReservationId, {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.rsvpValid.validating = false;
        if (r.error) {
          self.rsvpValid.isValid = false;
          return;
        }
        self.rsvpValid.isValid = true;
      });
    },
    isValid: function isValid() {
      var self = this;
      self.error.show = false;
      self.error.message = '';
      if (self.trxAmount <= 0) {
        self.error.show = true;
        self.error.message = 'Amount must be greater than 0.';
        return false;
      }

      if (self.trxDescription === null || self.trxDescription === '') {
        self.error.show = true;
        self.error.message = 'Description is required.';
        return false;
      }

      if (self.rsvpValid !== null && !self.rsvpValid.isValid) {
        self.error.show = true;
        self.error.message = 'Reservation ' + self.trxReservationId + ' does not exist.';
        return false;
      }

      if (self.packageValid !== null && !self.packageValid.isValid) {
        self.error.show = true;
        self.error.message = 'Package ' + self.trxPackageId + ' does not exist.';
        return false;
      }

      return true;
    },
    hidePayoutForm: function hidePayoutForm() {
      this.$store.commit('provider/setPayoutFormShow', false);
    },
    save: function save() {
      var self = this;
      if (!self.isValid()) {
        return;
      }
      self.saving = true;
      var request = {
        token: self.$store.state.session.sessionToken,
        type: self.trxType,
        transactionType: self.trxTransactionType,
        amount: self.trxAmount,
        description: self.trxDescription,
        notes: self.trxNotes === '' ? null : self.trxNotes,
        reservationId: self.trxReservationId === '' ? null : self.trxReservationId,
        packageId: self.trxPackageId === '' ? null : self.trxPackageId
      };

      var callback = function callback(r) {
        self.saving = false;
        self.$store.commit('provider/setPayoutFormRefresh', true);
        self.hidePayoutForm();
      };
      if (self.trxId === null) {
        __WEBPACK_IMPORTED_MODULE_0__modules_api_provider_payouts__["a" /* default */].createTransaction(self, self.provId, request, callback);
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0__modules_api_provider_payouts__["a" /* default */].updateTransaction(self, self.trxId, request, callback);
    },
    closeNotes: function closeNotes() {
      var self = this;
      self.$store.commit('provider/setPayoutNotes', {
        show: false,
        note: ''
      });
    }
  },
  watch: {
    show: function show(value) {
      if (!value) {
        return;
      }

      self.rsvpValid = null;
    }
  }
});

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Partials_LoadingAnimation_Ellipsis__ = __webpack_require__(38);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'doc-history',
  props: ['active'],
  data: function data() {
    return {
      loading: false,
      history: {},
      open: [],
      loaded: ''
    };
  },

  components: { EllipsisLoader: __WEBPACK_IMPORTED_MODULE_1__components_Partials_LoadingAnimation_Ellipsis__["a" /* default */] },
  computed: {
    provId: function provId() {
      return this.$route.params.id;
    }
  },
  methods: {
    init: function init() {
      var self = this;
      if (self.loading) {
        return;
      }
      self.history = {};
      self.open = [];

      self.loading = true;
      self.$sdk.get('/provider/' + this.provId + '/dochistory', {
        token: this.$store.state.session.sessionToken
      }, function (res) {
        self.loading = false;
        if (!res.error) {
          res.list.forEach(function (data) {
            if (!self.history[data.document] && data.file) {
              self.history[data.document] = [];
              self.open.push(data.document);
            }

            if (data.file) {
              self.history[data.document].push(data);
            }
          });

          // Rearrange object
          var tempObj = {};
          if (self.history['Insurance Policy']) {
            tempObj['Insurance Policy'] = self.history['Insurance Policy'];
          }
          if (self.history['City License']) {
            tempObj['City License'] = self.history['City License'];
          }
          if (self.history['TCP Permit']) {
            tempObj['TCP Permit'] = self.history['TCP Permit'];
          }
          if (self.history['Airport Permit']) {
            tempObj['Airport Permit'] = self.history['Airport Permit'];
          }
          if (self.history['Driver\'s License']) {
            tempObj['Driver\'s License'] = self.history['Driver\'s License'];
          }
          if (self.history['Vehicle Safety Inspection']) {
            tempObj['Vehicle Safety Inspection'] = self.history['Vehicle Safety Inspection'];
          }
          if (self.history['Driving Record']) {
            tempObj['Driving Record'] = self.history['Driving Record'];
          }
          if (self.history['W-9']) {
            tempObj['W-9'] = self.history['W-9'];
          }
          if (self.history['SSN']) {
            tempObj['SSN'] = self.history['SSN'];
          }
          if (self.history['Vehicle Registration']) {
            tempObj['Vehicle Registration'] = self.history['Vehicle Registration'];
          }
          if (self.history['Background Check']) {
            tempObj['Background Check'] = self.history['Background Check'];
          }
          self.history = tempObj;

          self.$nextTick().then(function () {
            self.$forceUpdate();
          });
          // self.history = res.list
        }
      });
    },
    toggle: function toggle(id) {
      if (this.open.indexOf(id) > -1) {
        this.open.splice(this.open.indexOf(id), 1);
      } else {
        this.open.push(id);
      }
    },
    formatDate: function formatDate(val) {
      return val ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(val, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY hh:mm:ss A') : '';
    },
    renameDocument: function renameDocument(x) {
      switch (x) {
        case 'Driving Record':
          return 'Background Check';
        default:
          return x;
      }
    }
  },
  watch: {
    provId: function provId(value) {
      if (this.active && this.loaded !== value) {
        this.loaded = this.provId;
        this.init();
      }
    },
    active: function active(val) {
      if (val && this.loaded !== this.provId) {
        this.loaded = this.provId;
        this.init();
      }
    }
  },
  mounted: function mounted() {
    // this.init()
  }
});

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_services__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_provider_user_info__ = __webpack_require__(61);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'services',
  props: ['_licenseType'],
  data: function data() {
    return {
      dataLoading: false,
      selectedService: [],
      licenseType: '',
      collapsed: [],
      loading: false,
      original: []
    };
  },

  computed: {
    brands: function brands() {
      return this.$store.state.brands.list;
    },
    accountType: function accountType() {
      return this.$store.state.provider.accountType.type;
    },
    serviceSaving: function serviceSaving() {
      return this.$store.state.provider.serviceSave.loading;
    },
    editEnabled: function editEnabled() {
      return this.$store.state.session.user.access.hasOwnProperty('PageAdminProviderEdit');
    }
  },
  methods: {
    getBrands: function getBrands() {
      var self = this;
      if (!self.$store.state.brands.list.length) {
        self.dataLoading = true;
        self.$sdk.get('/brand', {}, function (res) {
          if (res.error) {
            return;
          }

          if (res.length) {
            self.$store.commit('brands/setList', res);
            if (!self.$store.state.services.list.length) {
              self.getServices();
              return;
            }
            self.dataLoading = false;
          }
        });
      } else {
        self.getServices();
      }
    },
    getServices: function getServices() {
      var self = this;
      self.dataLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__modules_api_services__["a" /* default */].getAllService(self, function (r) {
        self.dataLoading = false;
      });
    },
    getCheckedServices: function getCheckedServices() {
      var self = this;
      self.selectedService = [];
      self.$sdk.get('/provider/' + self.$route.params.id + '/services', {
        token: self.$store.state.session.sessionToken,
        order: 'priority'
      }, function (res) {
        if (!res.error) {
          self.original = [];
          res.list.forEach(function (service) {
            self.original.push(service);
            if (service.enabled && self.selectedService.indexOf(service.service.id) === -1) {
              self.selectedService.push(service.service.id);
              if (service.service.id === {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.serviceId.doorToDoor) {
                self.$store.commit('provider/setIsDoorToDoorEnabled', true);
              }
            }
          });
        }
      }, '2.0');
    },
    serviceList: function serviceList(brandId) {
      if (this.licenseType === 'tnc') {
        return this.$store.state.services.list.filter(function (x) {
          return x.brandId === brandId && x.allowTNC;
        });
      }
      if (this.licenseType === 'tcp') {
        return this.$store.state.services.list.filter(function (x) {
          return x.brandId === brandId && x.allowTCP;
        });
      }
      if (this.licenseType === 'psc') {
        return this.$store.state.services.list.filter(function (x) {
          return x.brandId === brandId && x.allowPSC;
        });
      }
      return [];
    },
    toggleBrand: function toggleBrand(id) {
      if (this.collapsed.indexOf(id) > -1) {
        var index = this.collapsed.indexOf(id);
        this.collapsed.splice(index, 1);
      } else {
        this.collapsed.push(id);
      }
    },
    toggleService: function toggleService(serviceId) {
      if (!this.editEnabled) {
        return;
      }
      if (this.selectedService.indexOf(serviceId) > -1) {
        var index = this.selectedService.indexOf(serviceId);
        this.selectedService.splice(index, 1);
        if (serviceId === {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.serviceId.doorToDoor) {
          this.$store.commit('provider/setIsDoorToDoorEnabled', false);
        }
      } else {
        this.selectedService.push(serviceId);
        if (serviceId === {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.serviceId.doorToDoor) {
          this.$store.commit('provider/setIsDoorToDoorEnabled', true);
        }
      }
    },
    save: function save() {
      var _this = this;

      var self = this;
      var services = [];

      if (self.serviceSaving) {
        return;
      }

      self.brands.forEach(function (brand) {
        var serviceList = [];
        if (_this.licenseType === 'tnc') {
          serviceList = _this.$store.state.services.list.filter(function (x) {
            return x.brandId === brand.id && x.allowTNC;
          });
        } else if (_this.licenseType === 'tcp') {
          serviceList = _this.$store.state.services.list.filter(function (x) {
            return x.brandId === brand.id && x.allowTCP;
          });
        } else if (_this.licenseType === 'psc') {
          serviceList = _this.$store.state.services.list.filter(function (x) {
            return x.brandId === brand.id && x.allowPSC;
          });
        }
        serviceList.forEach(function (service) {
          var index = self.original.findIndex(function (x) {
            return x.service.id === service.id;
          });
          if (index > -1 && self.original[index].enabled !== self.selectedService.indexOf(service.id) > -1) {
            services.push({
              id: service.id,
              enabled: self.selectedService.indexOf(service.id) > -1
            });
          }
        });
      });

      self.$store.commit('provider/setServiceSaveLoading', true);
      __WEBPACK_IMPORTED_MODULE_1__modules_api_provider_user_info__["a" /* default */].updateProviderServices(self, {
        id: self.$route.params.id,
        services: services
      }, function (res) {
        self.$store.commit('provider/setServiceSaveLoading', false);
        self.$store.commit('provider/serviceSaveModal', true);

        var response = {
          success: true,
          message: ''
        };
        if (res.error) {
          response = {
            success: false,
            message: res.error.message
          };
        }

        if (!res.error) {
          services.forEach(function (service) {
            var index = self.original.findIndex(function (x) {
              return x.service.id === service.id;
            });
            self.original[index].enabled = service.enabled;
          });
          if (!services.length) {
            response.message = 'No changes to provider service types.';
          }
        }
        self.$store.commit('provider/serviceSaveSuccess', response);
      });
    }
  },
  watch: {
    '_licenseType': function _licenseType(value) {
      this.licenseType = value;
    }
  },
  mounted: function mounted() {
    this.getBrands();
    this.getCheckedServices();
  }
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Partials_LoadingAnimation_Ellipsis__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_api_services__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_api_provider_reservations__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_csvexport__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reservations',
  props: ['type', 'active'],
  components: { EllipsisLoader: __WEBPACK_IMPORTED_MODULE_3__components_Partials_LoadingAnimation_Ellipsis__["a" /* default */], datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default.a },
  data: function data() {
    return {
      loading: false,
      from: '',
      to: '',
      loaded: '',
      isMobile: false,
      total: {
        driverPayment: 0,
        fare: 0
      }
    };
  },

  computed: {
    provId: function provId() {
      return this.$route.params.id;
    },
    reservations: function reservations() {
      return this.$store.state.provider[this.type];
    },
    useOldQuatation: function useOldQuatation() {
      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation;
    }
  },
  methods: {
    init: function init() {
      if (this.active && this.loaded === this.provId) {
        return;
      }
      this.loaded = this.provId;
      var self = this;
      self.from = __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(2, 'month').format('MM/DD/YYYY');
      if (self.type === 'history') {
        self.from = __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(7, 'days').format('MM/DD/YYYY');
      }
      self.to = __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('MM/DD/YYYY');
      self.$store.commit('provider/setFromTo', {
        type: self.type,
        from: self.from,
        to: self.to
      });

      self.$store.commit('provider/resetRsvp', self.type);
      self.$store.commit('provider/setCurrentPage', {
        type: self.type,
        page: 0
      });
      self.$store.commit('provider/setIsMax', {
        type: self.type,
        isMax: false
      });

      self.getReservations(true);
    },
    getReservations: function getReservations(refreshList) {
      var self = this;
      if (self.loading) {
        return;
      }

      if (refreshList) {
        self.$store.commit('provider/resetRsvp', self.type);
        self.$store.commit('provider/setIsMax', {
          type: self.type,
          isMax: false
        });
        self.$store.commit('provider/setCurrentPage', {
          type: self.type,
          page: 0
        });
        if (self.type === 'history') {
          self.$store.commit('provider/setTotalDriverPaymentLoading', {
            type: self.type,
            value: true
          });

          var totalPaymentData = {
            id: self.provId,
            type: self.type,
            since: __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.from, 'MM/DD/YYYY').format('YYYY-MM-DD'),
            until: __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.to, 'MM/DD/YYYY').add(1, 'days').format('YYYY-MM-DD')
          };
          __WEBPACK_IMPORTED_MODULE_5__modules_api_provider_reservations__["a" /* default */].getTotalPayment(self, totalPaymentData, function (res) {
            self.$store.commit('provider/setTotalDriverPaymentLoading', {
              type: self.type,
              value: false
            });
          });
        }
      }

      var params = {
        id: self.provId,
        type: self.type
      };

      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_5__modules_api_provider_reservations__["a" /* default */].getRsvp(self, params, function (res) {
        self.loading = false;
      });
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('MM/DD/YYYY');
    },
    updateFrom: function updateFrom() {
      this.$store.commit('provider/setFromTo', {
        type: this.type,
        from: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.from).format('MM/DD/YYYY'),
        to: this.to
      });

      this.getReservations(true);
    },
    updateTo: function updateTo() {
      this.$store.commit('provider/setFromTo', {
        type: this.type,
        from: this.from,
        to: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.to).format('MM/DD/YYYY')
      });

      this.getReservations(true);
    },
    serviceLabel: function serviceLabel(code) {
      return __WEBPACK_IMPORTED_MODULE_4__modules_api_services__["a" /* default */].getServiceName(code);
    },
    toFixed: function toFixed(value) {
      return parseFloat(value).toFixed(2);
    },
    setScreenSize: function setScreenSize() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    exportComplete: function exportComplete() {
      var self = this;
      self.$store.commit('global/setLoaderData', { show: true, message: 'Loading please wait...' });

      self.total = {
        driverPayment: 0,
        fare: 0
      };

      var from = this.from ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.from).format('YYYY-MM-DD') : __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD');
      var to = this.to ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.to).add(1, 'days').format('YYYY-MM-DD') : __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(1, 'days').format('YYYY-MM-DD');
      self.$sdk.get('/provider/' + self.provId + '/rsvp/history', {
        token: self.$store.state.session.sessionToken,
        pickupSince: from,
        pickupUntil: to,
        pageNum: 1,
        pageSize: 99999
      }, function (res) {
        if (res.error) {
          self.$store.commit('global/setLoaderData', { show: false, message: '' });
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          });
          return;
        }

        if (!res.list.length) {
          self.$store.commit('global/setLoaderData', { show: false, message: '' });
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'Empty Result.'
          });
          return;
        }

        var tmpData = [];
        var rsvpIds = [];
        res.list.forEach(function (rsvp) {
          tmpData.push(rsvp.type === 'rsvp' ? self.buildRsvp(rsvp.data) : self.buildPkg(rsvp.data));
          if (rsvp.type === 'rsvp') {
            rsvpIds.push(rsvp.data.ID);
          }
        });
        self.getSectorData(tmpData, rsvpIds);
      });
    },
    buildRsvp: function buildRsvp(data) {
      var pickup = data.pickupLocation.geofenceType === 'airport' ? data.pickupLocation.geofenceName : data.pickupLocation.title;
      var dropoff = data.dropoffLocation.geofenceType === 'airport' ? data.dropoffLocation.geofenceName : data.dropoffLocation.title;

      var customer = data.consumer.firstName + ' ' + data.consumer.lastName;
      if (data.guest.firstName) {
        customer = data.guest.firstName + ' ' + data.guest.lastName;
      }

      var flight = 'N/A';
      if (data.airline) {
        flight = data.airline + ' ' + data.flightNumber;
      }
      if (!data.airline && data.dropoffAirline) {
        flight = data.dropoffAirline + ' ' + data.dropoffFlightNumber;
      }

      var payment = data.payment;
      var driverPayment = payment.amount + data.gasFee + payment.bonus + payment.tip + payment.pickupFee;
      var fare = payment.fare + payment.airportFee + payment.bonus + payment.gasFee + payment.pickupFee + payment.tip + payment.travelInsurance - (payment.credits || 0);

      this.total.driverPayment += driverPayment;
      this.total.fare += fare;
      return {
        'ID': data.ID,
        'Pickup Date': __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.pickupDate, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
        'Pickup': pickup,
        'Pickup Sector': '',
        'Dropoff': dropoff,
        'Dropoff Sector': '',
        'Service': data.serviceType.code,
        'Customer': customer,
        'PAX / Luggage': data.passengers + ' / ' + data.luggage,
        'Flight': flight,
        'Driver Payment': parseFloat(driverPayment.toFixed(2)),
        'Fare': parseFloat(fare.toFixed(2))
      };
    },
    buildPkg: function buildPkg(data) {
      var customer = data.rsvp[0].consumer.firstName + ' ' + data.rsvp[0].consumer.lastName;
      if (data.rsvp[0].guest.firstName) {
        customer = data.rsvp[0].guest.firstName + ' ' + data.rsvp[0].guest.lastName;
      }
      var luggage = 0;
      var gasFee = 0;
      var tip = 0;
      for (var i = 0; i < data.rsvp.length; i++) {
        luggage = luggage + data.rsvp[i].luggage;
        gasFee += data.rsvp[i].gasFee;
        tip += data.rsvp[i].payment.tip;
      }
      var index = data.rsvp.findIndex(function (x) {
        return x.ID === data.stops[data.stops.length - 1].reservationID;
      });

      if (data.rsvp.length === 0) {
        return false;
      }

      var pkgData = {
        'ID': 'PKG ' + data.package.id,
        'Pickup Date': __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.package.pickupTime, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY hh:mmA'),
        'Pickup': data.package.firstPickup,
        'Pickup Sector': '',
        'Dropoff': data.rsvp[index].dropoffLocation.city,
        'Dropoff Sector': '',
        'Service': 'shared',
        'Customer': customer,
        'PAX / Luggage': data.package.pax + ' / ' + data.luggage,
        'Flight': 'N/A',
        'Driver Payment': data.package.paidForProvider + gasFee + tip,
        'Amount': 0
      };
      if (!{"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation) {
        pkgData.serviceType = {
          label: data.rsvp[0].serviceType.label,
          color: data.rsvp[0].serviceType.color
        };
      }
      return pkgData;
    },
    getSectorData: function getSectorData(data, rsvpIds) {
      var self = this;
      self.$sdk.post('/sectors/rsvp', {
        token: self.$store.state.session.sessionToken,
        rsvpIds: rsvpIds
      }, function (res) {
        if (res.error) {
          self.$store.commit('global/setLoaderData', { show: false, message: '' });
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          });
          return;
        }

        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(res.rsvp).length) {
          for (var i = 0; i < data.length; i++) {
            data[i]['Pickup Sector'] = res.rsvp[data[i].ID] && res.rsvp[data[i].ID].pickup ? res.rsvp[data[i].ID].pickup.name : 'N/A';
            data[i]['Dropoff Sector'] = res.rsvp[data[i].ID] && res.rsvp[data[i].ID].dropoff ? res.rsvp[data[i].ID].dropoff.name : 'N/A';
          }
        }

        data.push({
          'ID': 'TOTAL',
          'Pickup Date': '',
          'Pickup': '',
          'Pickup Sector': '',
          'Dropoff': '',
          'Dropoff Sector': '',
          'Service': '',
          'Customer': '',
          'PAX / Luggage': '',
          'Flight': '',
          'Driver Payment': parseFloat(self.total.driverPayment.toFixed(2)),
          'Fare': parseFloat(self.total.fare.toFixed(2))
        });

        var from = self.from ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.from).format('YYYY-MM-DD') : __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD');
        var to = self.to ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.to).format('YYYY-MM-DD') : __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD');
        var exporter = __WEBPACK_IMPORTED_MODULE_6_csvexport___default.a.create({
          filename: 'prov' + self.provId + '_' + from + '_' + to + '.csv',
          columns: ['ID', 'Pickup Date', 'Pickup', 'Pickup Sector', 'Dropoff', 'Dropoff Sector', 'Service', 'Customer', 'PAX / Luggage', 'Flight', 'Driver Payment', 'Fare']
        });
        exporter.downloadCsv(data);
        self.$store.commit('global/setLoaderData', { show: false, message: '' });
      });
    }
  },
  watch: {
    provId: function provId(value) {
      if (this.active && this.loaded !== value) {
        this.init();
      }
    },
    active: function active(val) {
      if (val && this.loaded !== this.provId) {
        this.init();
      }
    }
  },
  mounted: function mounted() {
    // this.init()
    this.setScreenSize();
  }
});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__featureToggle__ = __webpack_require__(5);
/* global CONFIG */



/* harmony default export */ __webpack_exports__["a"] = ({
  getRsvp: function getRsvp(VueApp, param, callback) {
    var self = this;
    var provider = VueApp.$store.state.provider;
    var pageSize = provider.rsvpPerPage;
    var page = provider.currentPage[param.type];
    var pickupSince = __WEBPACK_IMPORTED_MODULE_0_moment___default()(provider.fromTo[param.type + 'From'], 'MM/DD/YYYY');
    var pickupUntil = __WEBPACK_IMPORTED_MODULE_0_moment___default()(provider.fromTo[param.type + 'To'], 'MM/DD/YYYY').add(1, 'days');

    VueApp.$sdk.get('/provider/' + param.id + '/rsvp/' + param.type, {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: pageSize,
      pageNum: page + 1,
      pickupSince: pickupSince.format('YYYY-MM-DD'),
      pickupUntil: pickupUntil.format('YYYY-MM-DD')
    }, function (res) {
      if (!res.error) {
        VueApp.$store.commit('provider/setCurrentPage', {
          type: param.type,
          page: page + 1
        });

        if (res.list.length < pageSize) {
          VueApp.$store.commit('provider/setIsMax', {
            type: param.type,
            isMax: true
          });
        }

        var gasFee = 0;
        var tip = 0;
        if (res.list.length) {
          // let newTotalDriverPayment = 0
          for (var i = 0; i < res.list.length; i++) {
            var buildData = res.list[i].type === 'rsvp' ? self.buildRsvpData(VueApp, res.list[i].data) : self.buildPkgData(VueApp, res.list[i].data);

            // newTotalDriverPayment += buildData.amountPaid
            if (buildData !== false) {
              VueApp.$store.commit('provider/addRsvp', {
                type: param.type,
                rsvp: buildData
              });
            }
            if (res.list[i].type === 'rsvp') {
              gasFee += res.list[i].data.gasFee;
              tip += res.list[i].data.payment.tip;
            } else {
              res.list[i].data.rsvp.forEach(function (rsvp) {
                gasFee += rsvp.gasFee;
                tip += rsvp.payment.tip;
              });
            }
          }

          if (param.type === 'upcoming') {
            VueApp.$store.commit('provider/setTotalDriverPayment', {
              type: param.type,
              value: res.summary.payment + tip + gasFee
            });
          }
        }
      }
      callback(res);
    });
  },
  getTotalPayment: function getTotalPayment(VueApp, param, callback) {
    VueApp.$sdk.get('/provider/' + param.id + '/earnings', {
      token: VueApp.$store.state.session.sessionToken,
      since: param.since,
      until: param.until
    }, function (res) {
      if (!res.error) {
        VueApp.$store.commit('provider/setTotalDriverPayment', {
          type: param.type,
          value: res.fare + res.bonus + res.tip + res.pickupFee + res.gasFee - res.deductions
        });
      }
      callback(res);
    });
  },
  buildRsvpData: function buildRsvpData(VueApp, data) {
    var customer = data.consumer.firstName + ' ' + data.consumer.lastName;
    if (data.guest.firstName) {
      customer = data.guest.firstName + ' ' + data.guest.lastName;
    }
    var flight = 'N/A';
    if (data.airline) {
      flight = data.airline + ' ' + data.flightNumber;
    }
    if (!data.airline && data.dropoffAirline) {
      flight = data.dropoffAirline + ' ' + data.dropoffFlightNumber;
    }
    var payment = data.payment;
    var amount = payment.amount + data.gasFee + payment.bonus + payment.tip + payment.pickupFee;
    var hudsonId = data.externalId;

    var pickup = data.pickupLocation.geofenceType === 'airport' ? data.pickupLocation.geofenceName : data.pickupLocation.title;
    var dropoff = data.dropoffLocation.geofenceType === 'airport' ? data.dropoffLocation.geofenceName : data.dropoffLocation.title;

    var rsvpData = {
      id: data.ID,
      type: 'rsvp',
      pickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.pickupDate, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      pickup: pickup,
      dropoff: dropoff,
      service: data.serviceType.code,
      customer: customer,
      pax: data.passengers,
      luggage: data.luggage,
      flight: flight,
      amountPaid: amount,
      hudsonId: hudsonId,
      isCharter: data.isCharter
    };
    if (!{"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation) {
      rsvpData.serviceType = {
        label: data.serviceType.label,
        color: data.serviceType.color
      };
    }
    return rsvpData;
  },
  buildPkgData: function buildPkgData(VueApp, data) {
    var customer = data.rsvp[0].consumer.firstName + ' ' + data.rsvp[0].consumer.lastName;
    if (data.rsvp[0].guest.firstName) {
      customer = data.rsvp[0].guest.firstName + ' ' + data.rsvp[0].guest.lastName;
    }
    var luggage = 0;
    var gasFee = 0;
    var tip = 0;
    for (var i = 0; i < data.rsvp.length; i++) {
      luggage = luggage + data.rsvp[i].luggage;
      gasFee += data.rsvp[i].gasFee;
      tip += data.rsvp[i].payment.tip;
    }
    var index = data.rsvp.findIndex(function (x) {
      return x.ID === data.stops[data.stops.length - 1].reservationID;
    });

    if (data.rsvp.length === 0) {
      return false;
    }

    var pkgData = {
      id: data.package.id,
      type: 'pkg',
      pickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.package.pickupTime, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      pickup: data.package.firstPickup,
      dropoff: data.rsvp[index].dropoffLocation.city,
      service: 'shared',
      customer: customer,
      pax: data.package.pax,
      luggage: luggage,
      flight: 'N/A',
      amountPaid: data.package.paidForProvider + gasFee + tip
    };
    if (!{"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation) {
      pkgData.serviceType = {
        label: data.rsvp[0].serviceType.label,
        color: data.rsvp[0].serviceType.color
      };
    }
    return pkgData;
  },
  getAllRsvp: function getAllRsvp(VueApp, param, callback) {
    var provider = VueApp.$store.state.provider;
    var pickupSince = __WEBPACK_IMPORTED_MODULE_0_moment___default()(provider.fromTo[param.type + 'From'], 'MM/DD/YYYY');
    var pickupUntil = __WEBPACK_IMPORTED_MODULE_0_moment___default()(provider.fromTo[param.type + 'To'], 'MM/DD/YYYY').add(1, 'days');

    VueApp.$sdk.get('/provider/' + param.id + '/rsvp/' + param.type, {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: 999,
      pageNum: 1,
      pickupSince: pickupSince.format('YYYY-MM-DD'),
      pickupUntil: pickupUntil.format('YYYY-MM-DD')
    }, function (res) {
      if (!res.error) {
        var payments = [];

        var deductions = VueApp.$store.state.provider.breakdown.deductions;

        var _loop = function _loop(i) {
          if (res.list[i].type === 'rsvp') {
            var breakdownObject = {
              amount: res.list[i].data.bonus.basePay,
              gasFee: res.list[i].data.gasFee,
              bonusAmount: res.list[i].data.bonus.amount || 0,
              releaseBonus: res.list[i].data.payment.bonus || 0,
              pickupFee: res.list[i].data.payment.pickupFee || 0,
              tip: res.list[i].data.payment.tip || 0,
              deductions: 0,
              type: 'RSVP',
              id: res.list[i].data.ID
            };
            if (!res.list[i].data.bonus.basePay) {
              breakdownObject.amount = res.list[i].data.payment.amount;
            }
            var deductionIndex = deductions.findIndex(function (x) {
              return x.id === res.list[i].data.ID && x.type === 'RSVP';
            });
            if (deductionIndex > -1) {
              breakdownObject.deductions = deductions[deductionIndex].deductions;
              deductions.splice(deductionIndex, 1);
              VueApp.$store.commit('provider/setProviderBreakdown', {
                value: deductions,
                type: 'deductions'
              });
            }
            VueApp.$store.commit('provider/addProviderBreakdown', {
              type: param.type,
              value: breakdownObject
            });
          } else {
            var _breakdownObject = {
              amount: 0,
              gasFee: 0,
              bonusAmount: 0,
              releaseBonus: 0,
              pickupFee: 0,
              tip: 0,
              deductions: 0,
              type: 'PKG',
              id: res.list[i].data.package.id
            };
            res.list[i].data.rsvp.forEach(function (data) {
              _breakdownObject.pickupFee += parseFloat(data.payment.pickupFee) || 0;
              _breakdownObject.tip += parseFloat(data.payment.tip) || 0;
              _breakdownObject.gasFee += parseFloat(data.gasFee) || 0;
              if (data.bonus.amount) {
                _breakdownObject.bonusAmount += parseFloat(data.bonus.amount) || 0;
              }
              if (data.payment.bonus) {
                _breakdownObject.releaseBonus += parseFloat(data.payment.bonus) || 0;
              }
            });
            _breakdownObject.amount = parseFloat(res.list[i].data.package.paidForProvider) || 0;
            // breakdownObject.bonus = parseFloat(res.list[i].data.package.bonusToProvider) || 0
            var _deductionIndex = deductions.findIndex(function (x) {
              return x.id === res.list[i].data.package.id && x.type === 'PKG';
            });
            if (_deductionIndex > -1) {
              _breakdownObject.deductions = deductions[_deductionIndex].deductions;
              deductions.splice(_deductionIndex, 1);
              VueApp.$store.commit('provider/setProviderBreakdown', {
                value: deductions,
                type: 'deductions'
              });
            }
            VueApp.$store.commit('provider/addProviderBreakdown', {
              type: param.type,
              value: _breakdownObject
            });
          }
        };

        for (var i = 0; i < res.list.length; i++) {
          _loop(i);
        }
        // VueApp.$store.commit('provider/addProviderBreakdown', {
        //   value: payments,
        //   type: param.type
        // })
      }

      callback(res);
    });
  },
  getDeductions: function getDeductions(VueApp, param, callback) {
    var provider = VueApp.$store.state.provider;
    var pickupSince = __WEBPACK_IMPORTED_MODULE_0_moment___default()(provider.fromTo[param.type + 'From'], 'MM/DD/YYYY');
    var pickupUntil = __WEBPACK_IMPORTED_MODULE_0_moment___default()(provider.fromTo[param.type + 'To'], 'MM/DD/YYYY').add(1, 'days');

    VueApp.$sdk.get('/provider/' + param.id + '/deductions', {
      token: VueApp.$store.state.session.sessionToken,
      since: pickupSince.format('YYYY-MM-DD'),
      until: pickupUntil.format('YYYY-MM-DD')
    }, function (res) {
      if (!res.error) {
        var deductions = [];
        res.list.forEach(function (data) {
          deductions.push({
            amount: 0,
            bonusAmount: 0,
            releaseBonus: 0,
            pickupFee: 0,
            tip: 0,
            gasFee: 0,
            type: data.rsvpId ? 'RSVP' : 'PKG',
            id: data.rsvpId || data.packageId,
            deductions: data.cancelFee
          });
        });
        VueApp.$store.commit('provider/setProviderBreakdown', {
          value: deductions,
          type: 'deductions'
        });
      }
      callback(res);
    });
  }
});

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProfileHistory__ = __webpack_require__(1713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActivityHistory__ = __webpack_require__(1717);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'logs',
  components: { ProfileHistory: __WEBPACK_IMPORTED_MODULE_0__ProfileHistory__["a" /* default */], ActivityHistory: __WEBPACK_IMPORTED_MODULE_1__ActivityHistory__["a" /* default */] },
  data: function data() {
    return {
      activeTab: 0,
      profileHistoryDate: 'all',
      activityHistoryDate: 'all'
    };
  },

  computed: {
    provId: function provId() {
      return this.$route.params.id;
    },
    profileHistoryLoading: function profileHistoryLoading() {
      return this.$store.state.provider.logs.profileHistory.loading;
    },
    activityHistoryLoading: function activityHistoryLoading() {
      return this.$store.state.provider.logs.activityHistory.loading;
    }
  },
  methods: {
    onScrollProfile: function onScrollProfile(value) {
      if (this.$refs.profileHistory.onScroll(value)) {
        this.$refs.profileHistory.onScroll(value);
      }
    },
    onScrollActivity: function onScrollActivity(value) {
      if (this.$refs.activityHistory.onScroll(value)) {
        this.$refs.activityHistory.onScroll(value);
      }
    },
    reload: function reload() {
      if (this.$refs.profileHistory.init()) {
        this.$refs.profileHistory.init();
      }
    }
  },
  watch: {
    provId: function provId(value) {
      this.showLogs = false;
      this.profileHistoryDate = 'all';
      this.activityHistoryDate = 'all';
    },
    profileHistoryDate: function profileHistoryDate(value) {
      if (this.$refs.profileHistory.dateToggle(value)) {
        this.$refs.profileHistory.dateToggle(value);
      }
    },
    activityHistoryDate: function activityHistoryDate(value) {
      if (this.$refs.activityHistory.dateToggle(value)) {
        this.$refs.activityHistory.dateToggle(value);
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_services__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profile-history',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default.a },
  data: function data() {
    return {
      heading: {
        admin_edit_provider: 'Admin made an update',
        driver_accept: 'Accepted the reservation',
        driver_noshow: 'Set the reservation as No Show',
        driver_ontheway: 'Set the reservation as On the Way',
        driver_release_attempt: 'Attempted to release the reservation',
        driver_release: 'Released the reservation',
        driver_reject: 'Rejected the reservation',
        driver_arrived: 'Set the reservation as Arrived at Pickup',
        driver_onboard: 'Set the reservation as On Board',
        driver_complete: 'Marked the reservation as Completed',
        resend_email_prov: 'Resend email: Reservation Completed',
        asap_accepted: 'Accepted an ASAP request',
        package_release: 'Released the package',
        package_reject: 'Rejected the package',
        package_accept: 'Accepted the package',
        provider_activate: 'Activated account',
        provider_deactivate: 'Deactivated account',
        provider_services: 'Provider service update'
      },
      showRsvpId: ['driver_accept', 'driver_noshow', 'driver_ontheway', 'driver_release_attempt', 'driver_release', 'driver_reject', 'driver_arrived', 'driver_onboard', 'driver_complete', 'resend_email_prov', 'asap_accepted', 'package_release', 'package_reject', 'package_accept'],
      showPkgId: ['package_release', 'package_reject', 'package_accept'],
      fieldLabel: {
        'profile.backgroundCheckSubmitted': 'Background check submitted',
        'profile.backgroundCheckPassed': 'Background check passed',
        'profile.firstName': 'First Name',
        'profile.lastName': 'Last Name',
        'profile.dateOfBirth': 'Birthday',
        'profile.language': 'Language',
        'profile.email': 'Email',
        'phone': 'Mobile',
        'vehicle.manufacturer': 'Manafacturer',
        'vehicle.type': 'Vehicle Type',
        'vehicle.seatCapacity': 'Capacity',
        'vehicle.boxCapacity': 'Box Capacity',
        'vehicle.numberOfDoor': 'Door',
        'vehicle.licensePlate': 'License Plate',
        'vehicle.idNumber': 'Vehicle Identification Number',
        'vehicle.model': 'Model',
        'vehicle.manufactured': 'Year',
        'vehicle.wheelChair': 'Wheelchair Lift',
        'vehicle.serviceDog': 'Service Dog',
        'profile.licenseType': 'Account Type',
        'profile.businessName': 'Business Name',
        'profile.businessType': 'Type of Business',
        'profile.businessSSN': 'SSN',
        'profile.businessSSNUrl': 'SSN Image',
        'profile.businessEIN': 'EIN',
        'profile.businessEINUrl': 'EIN Image',
        'profile.w9fileUrl': 'W-9 Form',
        'address.address': 'Address',
        'address.address2': 'Address 2',
        'address.city': 'City',
        'address.state': 'State',
        'address.zip': 'Zip',
        'address.country': 'Country'
      },
      showDateRange: false,
      date: {
        from: '',
        to: ''
      },
      error: {
        from: false,
        to: false,
        message: ''
      }
    };
  },

  computed: {
    provId: function provId() {
      return this.$route.params.id;
    },
    logs: function logs() {
      return this.$store.state.provider.logs.profileHistory.list;
    },
    loading: function loading() {
      return this.$store.state.provider.logs.profileHistory.loading;
    },
    reachMax: function reachMax() {
      return this.$store.state.provider.logs.profileHistory.reachMax;
    },
    brands: function brands() {
      return this.$store.state.brands;
    },
    services: function services() {
      return this.$store.state.services;
    }
  },
  methods: {
    init: function init() {
      this.$store.commit('provider/setProfileHistoryField', {
        fields: {
          pageNum: 1,
          list: [],
          since: null,
          until: null,
          reachMax: false
        }
      });
      this.getAdmins();
    },
    getAdmins: function getAdmins() {
      var self = this;
      if (self.$store.state.provider.admin.list.length) return;

      self.$sdk.get('/admin', {
        token: self.$store.state.session.sessionToken,
        pageNum: 1,
        pageSize: 100
      }, function (res) {
        if (!res.error) {
          var list = [];
          res.list.forEach(function (admin) {
            list.push({
              id: admin.id,
              name: admin.firstName + ' ' + admin.lastName,
              email: admin.email
            });
          });
          self.$store.commit('provider/setAdmin', list);
        }
        self.getLogs();
      });
    },
    getLogs: function getLogs() {
      var self = this;
      if (self.loading || self.reachMax) {
        return;
      }

      self.$store.commit('provider/setProfileHistoryField', {
        fields: { loading: true }
      });

      var logsData = this.$store.state.provider.logs.profileHistory;
      var params = {
        token: self.$store.state.session.sessionToken,
        pageNum: logsData.pageNum,
        pageSize: logsData.pageSize,
        order: 'created',
        orderAsc: 0
      };
      if (logsData.since) {
        params.since = __WEBPACK_IMPORTED_MODULE_1_moment___default()(logsData.since, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00:00');
        params.until = __WEBPACK_IMPORTED_MODULE_1_moment___default()(logsData.until, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59:59');
      }

      self.$sdk.get('/provider/' + self.provId + '/logs', params, function (res) {
        self.$store.commit('provider/setProfileHistoryField', {
          fields: { loading: false }
        });

        if (!res.error) {
          if (!res.list.length) {
            self.$store.commit('provider/setProfileHistoryField', {
              fields: { reachMax: true }
            });
            return;
          }

          var actions = {};
          res.list.forEach(function (log) {
            if (!actions[log.action]) {
              actions[log.action] = 0;
            }
            actions[log.action] = actions[log.action] + 1;

            if (['provider_activate', 'provider_deactivate'].indexOf(log.action) > -1) {
              var admins = self.$store.state.provider.admin.list;
              var index = admins.findIndex(function (x) {
                return x.id === log.adminId;
              });
              if (index > -1) {
                log.details = {
                  adminId: admins[index].id,
                  adminName: admins[index].name,
                  adminEmail: admins[index].email
                };
              }
            }

            var tempLog = log;
            tempLog.created = __WEBPACK_IMPORTED_MODULE_1_moment___default()(tempLog.created, 'X').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__["a" /* default */].timeFormat(self, true));
            var showDefault = { show: false };
            self.$store.commit('provider/addProfileHistory', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, log, showDefault));
          });
        }
      });
    },
    title: function title(data) {
      if (data.action === 'driver_accept' && data.details.packageID) {
        return this.heading.package_accept;
      }
      if (data.action === 'edit_provider' && data.contactId == this.provId) {
        return 'Driver made an update';
      }

      return this.heading[data.action] || data.action;
    },
    toFixed: function toFixed(x) {
      return parseFloat(x).toFixed(2);
    },
    onScroll: function onScroll(event) {
      var scrollAndView = event.target.scrollTop + event.target.offsetHeight;
      if (event.target.scrollHeight - scrollAndView < 150) {
        this.loadMore();
      }
    },
    loadMore: function loadMore() {
      var self = this;
      if (self.loading) {
        return;
      }

      self.$store.commit('provider/setProfileHistoryField', {
        fields: { pageNum: self.$store.state.provider.logs.profileHistory.pageNum + 1 }
      });
      self.getLogs();
    },
    dateToggle: function dateToggle(val) {
      this.showDateRange = val === 'custom';
      if (val === 'all') {
        this.$store.commit('provider/setProfileHistoryField', {
          fields: {
            pageNum: 1,
            list: [],
            since: null,
            until: null,
            reachMax: false
          }
        });
        this.getLogs();
      }
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('MM/DD/YYYY');
    },
    changeDate: function changeDate(type) {
      var format = 'MM/DD/YYYY';
      var from = '';
      var to = '';

      if (type === 'from') {
        this.error.from = false;
        from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date.from);
        this.$store.commit('provider/setProfileHistoryField', {
          fields: { since: from.format(format) }
        });
        if (this.date.to) {
          to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date.to, format);
        }
      } else {
        this.error.to = false;
        to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date.to);
        this.$store.commit('provider/setProfileHistoryField', {
          fields: { until: to.format(format) }
        });
        if (this.date.from) {
          from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date.from, format);
        }
      }
    },
    dateApply: function dateApply() {
      if (this.loading) {
        return;
      }

      this.error = {
        from: false,
        to: false,
        message: ''
      };

      if (this.date.from === '' || this.date.to === '') {
        if (this.date.to === '') {
          this.error.to = true;
        }
        if (this.date.from === '') {
          this.error.from = true;
        }
        this.error.message = this.$t('transactions.filter.emptyDate');
        return;
      }

      var from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date.from);
      var to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date.to);
      if (from.format('x') > to.format('x')) {
        this.error.from = true;
        this.error.to = true;
        this.error.message = this.$t('transactions.filter.invalidDateRange');
        return;
      }

      this.$store.commit('provider/setProfileHistoryField', {
        fields: {
          pageNum: 1,
          list: [],
          since: from.format('MM/DD/YYYY'),
          until: to.format('MM/DD/YYYY'),
          reachMax: false
        }
      });
      this.getLogs();
    },
    renameDocument: function renameDocument(x) {
      switch (x) {
        case 'Driving Record':
          return 'Background Check';
        default:
          return x;
      }
    },
    serviceLabel: function serviceLabel(data) {
      if (!this.services.list.length) return '';

      var service = this.services.list.find(function (x) {
        return x.id === data.id;
      });
      return service ? '[' + this.brandCode(service.brandId) + '] ' + service.name + ': <b>' + (data.enabled ? 'Enabled' : 'Disabled') + '</b>' : '';
    },
    brandCode: function brandCode(x) {
      if (!this.brands.list.length) return '';

      var brand = this.brands.list.find(function (a) {
        return a.id === x;
      });
      return brand ? brand.name : '';
    }
  },
  watch: {
    provId: function provId(value) {
      this.init();
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_services__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'activity-history',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default.a },
  data: function data() {
    return {
      heading: {
        admin_edit_provider: 'Admin made an update',
        driver_accept: 'Accepted the reservation',
        driver_noshow: 'Set the reservation as No Show',
        driver_ontheway: 'Set the reservation as On the Way',
        driver_release_attempt: 'Attempted to release the reservation',
        driver_release: 'Released the reservation',
        driver_reject: 'Rejected the reservation',
        driver_arrived: 'Set the reservation as Arrived at Pickup',
        driver_onboard: 'Set the reservation as On Board',
        driver_complete: 'Marked the reservation as Completed',
        resend_email_prov: 'Resend email: Reservation Completed',
        asap_accepted: 'Accepted an ASAP request',
        package_release: 'Released the package',
        package_reject: 'Rejected the package',
        package_accept: 'Accepted the package'
      },
      showRsvpId: ['driver_accept', 'driver_noshow', 'driver_ontheway', 'driver_release_attempt', 'driver_release', 'driver_reject', 'driver_arrived', 'driver_onboard', 'driver_complete', 'resend_email_prov', 'asap_accepted', 'package_release', 'package_reject', 'package_accept'],
      showPkgId: ['package_release', 'package_reject', 'package_accept'],
      fieldLabel: {
        'profile.businessName': 'Business Name',
        'profile.businessType': 'Typo of Business',
        'profile.businessSSN': 'SSN',
        'profile.businessSSNUrl': 'SSN Image',
        'profile.businessEIN': 'EIN',
        'profile.businessEINUrl': 'EIN Image'
      },
      showDateRange: false,
      date: {
        from: '',
        to: ''
      },
      error: {
        from: false,
        to: false,
        message: ''
      }
    };
  },

  computed: {
    provId: function provId() {
      return this.$route.params.id;
    },
    logs: function logs() {
      return this.$store.state.provider.logs.activityHistory.list;
    },
    loading: function loading() {
      return this.$store.state.provider.logs.activityHistory.loading;
    },
    reachMax: function reachMax() {
      return this.$store.state.provider.logs.activityHistory.reachMax;
    }
  },
  methods: {
    getLogs: function getLogs() {
      var self = this;
      if (self.loading || self.reachMax) {
        return;
      }

      self.$store.commit('provider/setActivityHistoryField', {
        fields: { loading: true }
      });

      var logsData = this.$store.state.provider.logs.activityHistory;
      var params = {
        token: self.$store.state.session.sessionToken,
        pageNum: logsData.pageNum,
        pageSize: logsData.pageSize,
        order: 'created',
        orderAsc: 0
      };
      if (logsData.since) {
        params.since = __WEBPACK_IMPORTED_MODULE_1_moment___default()(logsData.since, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00:00');
        params.until = __WEBPACK_IMPORTED_MODULE_1_moment___default()(logsData.until, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59:59');
      }

      self.$sdk.get('/provider/' + self.provId + '/event', params, function (res) {
        self.$store.commit('provider/setActivityHistoryField', {
          fields: { loading: false }
        });

        if (!res.error) {
          if (!res.list.length) {
            self.$store.commit('provider/setActivityHistoryField', {
              fields: { reachMax: true }
            });
            return;
          }

          var actions = {};
          res.list.forEach(function (log) {
            if (!actions[log.action]) {
              actions[log.action] = 0;
            }
            actions[log.action] = actions[log.action] + 1;

            log.created = __WEBPACK_IMPORTED_MODULE_1_moment___default()(log.created, 'X').format('MM/DD/YYYY hh:mm:ss A');
            // let tempLog = log
            // tempLog.created = moment(tempLog.created, 'X').format('MM/DD/YYYY hh:mm:ss A')
            var showDefault = { show: false };
            self.$store.commit('provider/addActivityHistory', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, log, showDefault));
          });
        }
      });
    },
    title: function title(data) {
      if (data.action === 'driver_accept' && data.details.packageID) {
        return this.heading.package_accept;
      }

      return this.heading[data.action] || data.action;
    },
    toFixed: function toFixed(x) {
      return parseFloat(x).toFixed(2);
    },
    onScroll: function onScroll(event) {
      var scrollAndView = event.target.scrollTop + event.target.offsetHeight;
      if (event.target.scrollHeight - scrollAndView < 150) {
        this.loadMore();
      }
    },
    loadMore: function loadMore() {
      var self = this;
      if (self.loading) {
        return;
      }

      self.$store.commit('provider/setActivityHistoryField', {
        fields: { pageNum: self.$store.state.provider.logs.activityHistory.pageNum + 1 }
      });
      self.getLogs();
    },
    dateToggle: function dateToggle(val) {
      this.showDateRange = val === 'custom';
      if (val === 'all') {
        this.$store.commit('provider/setActivityHistoryField', {
          fields: {
            pageNum: 1,
            list: [],
            since: null,
            until: null,
            reachMax: false
          }
        });
        this.getLogs();
      }
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('MM/DD/YYYY');
    },
    changeDate: function changeDate(type) {
      var format = 'MM/DD/YYYY';
      var from = '';
      var to = '';

      if (type === 'from') {
        this.error.from = false;
        from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date.from);
        this.$store.commit('provider/setActivityHistoryField', {
          fields: { since: from.format(format) }
        });
        if (this.date.to) {
          to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date.to, format);
        }
      } else {
        this.error.to = false;
        to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date.to);
        this.$store.commit('provider/setActivityHistoryField', {
          fields: { until: to.format(format) }
        });
        if (this.date.from) {
          from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date.from, format);
        }
      }
    },
    dateApply: function dateApply() {
      if (this.loading) {
        return;
      }

      this.error = {
        from: false,
        to: false,
        message: ''
      };

      if (this.date.from === '' || this.date.to === '') {
        if (this.date.to === '') {
          this.error.to = true;
        }
        if (this.date.from === '') {
          this.error.from = true;
        }
        this.error.message = this.$t('transactions.filter.emptyDate');
        return;
      }

      var from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date.from);
      var to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date.to);
      if (from.format('x') > to.format('x')) {
        this.error.from = true;
        this.error.to = true;
        this.error.message = this.$t('transactions.filter.invalidDateRange');
        return;
      }

      this.$store.commit('provider/setActivityHistoryField', {
        fields: {
          pageNum: 1,
          list: [],
          since: from.format('MM/DD/YYYY'),
          until: to.format('MM/DD/YYYY'),
          reachMax: false
        }
      });
      this.getLogs();
    }
  },
  watch: {
    provId: function provId(value) {
      this.$store.commit('provider/setActivityHistoryField', {
        fields: {
          pageNum: 1,
          list: [],
          since: null,
          until: null,
          reachMax: false
        }
      });
      this.getLogs();
    }
  },
  mounted: function mounted() {
    this.getLogs();
  }
});

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jspdf__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_html2canvas__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_NotificationModal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_SMSModal__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TableFilter__ = __webpack_require__(1726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DriverTable__ = __webpack_require__(1730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NoShiftTable__ = __webpack_require__(1734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_api_featureToggle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_csvexport__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProviderAvailability',
  components: { notificationModal: __WEBPACK_IMPORTED_MODULE_4__App_NotificationModal__["a" /* default */], smsModal: __WEBPACK_IMPORTED_MODULE_5__App_SMSModal__["a" /* default */], tableFilter: __WEBPACK_IMPORTED_MODULE_6__TableFilter__["a" /* default */], driverTable: __WEBPACK_IMPORTED_MODULE_7__DriverTable__["a" /* default */], noShiftTable: __WEBPACK_IMPORTED_MODULE_8__NoShiftTable__["a" /* default */] },
  data: function data() {
    return {
      xport: {
        show: false,
        loading: false,
        pdf: true,
        csv: true,
        data: {},
        csvData: [],
        error: '',
        success: false
      },
      isMobile: false,
      isOpenFilter: true,
      dateToday: __WEBPACK_IMPORTED_MODULE_9_moment___default()().format('MM/DD/YYYY')
    };
  },

  computed: {
    prov: function prov() {
      return this.$store.state.provider;
    },
    checked: function checked() {
      return this.prov.availability.checked;
    },
    totalPage: function totalPage() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.xport.data).length;
    },
    tableFilter: function tableFilter() {
      return this.prov.availability;
    },
    workSector: function workSector() {
      var _this = this;

      var index = this.prov.sectors.list.findIndex(function (x) {
        return x.id === _this.tableFilter.sector;
      });
      return index === -1 ? 'All' : this.prov.sectors.list[index].name || '';
    },
    startDate: function startDate() {
      return __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.tableFilter.since, 'X').format('MM/DD/YYYY hh:mmA');
    },
    endDate: function endDate() {
      return __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.tableFilter.until, 'X').format('MM/DD/YYYY hh:mmA');
    },
    _type: function _type() {
      return this.tableFilter.type ? this.tableFilter.type.toUpperCase() : 'All';
    },
    assigned: function assigned() {
      if (!this.tableFilter.assignedTrips) {
        return 'All';
      }
      return this.tableFilter.assignedTrips === '1' ? 'Assigned' : 'No Assignments';
    }
  },
  methods: {
    showFilter: function showFilter() {
      this.isOpenFilter = !this.isOpenFilter;
      console.log('test');
    },
    setScreenSize: function setScreenSize() {
      var self = this;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        self.isMobile = true;
      } else {
        self.isMobile = false;
      }
    },
    showSenfNotif: function showSenfNotif() {
      if (this.$refs.notif.showNotifForm()) {
        this.$refs.notif.showNotifForm();
      }
    },
    showSendSMS: function showSendSMS() {
      if (this.$refs.sms.showSMSForm()) {
        this.$refs.sms.showSMSForm();
      }
    },
    getBrands: function getBrands() {
      var self = this;
      self.$sdk.get('/brand', {}, function (res) {
        if (res.error) {
          return;
        }
        if (res.length) {
          self.$store.commit('brands/setList', res);
        }
      });
    },
    beginExport: function beginExport() {
      var self = this;
      self.xport.success = false;
      if (self.xport.loading) {
        return;
      }
      if (!self.xport.pdf && !self.xport.csv) {
        self.xport.error = 'Select a file type.';
        return;
      }
      self.xport.error = '';

      self.xport.loading = true;
      var provider = self.$store.state.provider;
      var availability = provider.availability;
      var param = {
        token: self.$store.state.session.sessionToken,
        pageNum: 1,
        pageSize: 9999,
        order: availability.order,
        orderAsc: availability.orderAsc,
        vehicleType: null,
        sectorId: availability.sector,
        since: availability.since,
        until: availability.until
      };

      if (availability.service) {
        switch (availability.service) {
          case 'PAX':
            param.isPax = 1;
            param.isDTD = 0;
            break;
          case 'DTD':
            param.isPax = 0;
            param.isDTD = 1;
            break;
          case 'PAX/DTD':
            param.isPax = 1;
            param.isDTD = 1;
            break;
        }
      }
      if (availability.type) param.licenseType = availability.type;
      if (availability.vehicleType) param.vehicleType = availability.vehicleType;
      if (availability.assignedTrips) param.assignments = availability.assignedTrips;

      self.xport.data = {};
      self.xport.csvData = [];
      self.$sdk.get('/shifts/dashboard', param, function (res) {
        if (res.error) {
          self.xport.loading = false;
          console.log('ERROR', res.error.message);
          self.xport.error = res.error.message;
          return;
        }

        if (!res.list.length) {
          self.xport.loading = false;
          self.xport.error = 'Empty Results.';
          return;
        }

        var i = 1;
        if (res.list.length) {
          res.list.forEach(function (prov) {
            var name = prov.businessName || prov.firstName + ' ' + prov.lastName;
            var availableFrom = '';
            var availableUntil = '';
            if (prov.startTimestamp) {
              availableFrom = __WEBPACK_IMPORTED_MODULE_9_moment___default()(prov.startTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_10__modules_api_featureToggle__["a" /* default */].timeFormat(self, false));
              availableUntil = __WEBPACK_IMPORTED_MODULE_9_moment___default()(prov.endTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_10__modules_api_featureToggle__["a" /* default */].timeFormat(self, false));
            }
            var paxDtd = '';
            if (prov.supportPax) {
              paxDtd = 'PAX';
            }
            if (prov.supportDTD) {
              paxDtd = 'DTD';
            }
            if (prov.supportPax && prov.supportDTD) {
              paxDtd = 'PAX/DTD';
            }
            if (!self.xport.data['page' + i]) {
              self.xport.data['page' + i] = [];
            }

            self.xport.data['page' + i].push({
              id: prov.ID,
              businessName: name,
              type: prov.accountType.toUpperCase() || '',
              homeSector: prov.homeSectorName || '',
              service: paxDtd,
              vehicleType: prov.vehicleType || '',
              availableFrom: availableFrom,
              availableUntil: availableUntil,
              phone: prov.phoneNumber || ''
            });
            self.xport.csvData.push({
              'ID': prov.ID,
              'Business Name': name,
              'Type': prov.accountType.toUpperCase() || '',
              'Home Sector': prov.homeSectorName || '',
              'Service': paxDtd,
              'Vehicle Type': prov.vehicleType || '',
              'Available From': availableFrom,
              'Available Until': availableUntil,
              'Phone': prov.phoneNumber || ''
            });

            if (self.xport.data['page' + i].length >= 25) {
              i++;
            }
          });

          if (self.xport.pdf) {
            self.processPdf(i);
          } else if (self.xport.csv) {
            self.processCsv();
          }
        }
      });
    },
    processPdf: function processPdf(page) {
      var self = this;
      var start = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.tableFilter.since, 'X');
      var end = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.tableFilter.until, 'X');
      var pageAsyncs = [];
      var pdf = new __WEBPACK_IMPORTED_MODULE_2_jspdf___default.a({ orientation: 'l', unit: 'mm', format: 'a4' });

      window.scrollTo(500, 0);
      document.body.style.overflow = 'hidden';

      self.$forceUpdate();
      setTimeout(function () {
        var _loop = function _loop(i) {
          pageAsyncs.push(__WEBPACK_IMPORTED_MODULE_3_html2canvas___default()(document.getElementsByClassName('page' + (i + 1))[0], {
            scale: "1"
          }).then(function (canvas) {
            var imgData = canvas.toDataURL('image/jpeg', 0.9);
            pdf.addImage(imgData, 'JPEG', 0, 0);
            if (i + 1 !== page) {
              pdf.addPage();
            }
          }).catch(function (e) {
            self.xport.loading = false;
            console.log('PDF ERROR:', e);
            document.body.style.overflow = 'auto';
            self.xport.error = e;
          }));
        };

        for (var i = 0; i < page; i++) {
          _loop(i);
        }
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(pageAsyncs).then(function () {
          var timestamp = start.format('YYYYMMDD') + '-' + end.format('YYYYMMDD');
          pdf.save('provider_availability ' + timestamp + '.pdf');
          document.body.style.overflow = 'auto';
          if (self.xport.csv) {
            self.processCsv();
          } else {
            self.xport.loading = false;
            self.xport.success = true;
          }
        });
      }, 1000);
    },
    processCsv: function processCsv() {
      var start = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.tableFilter.since, 'X');
      var end = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.tableFilter.until, 'X');
      var timestamp = start.format('YYYYMMDD') + '-' + end.format('YYYYMMDD');
      var exporter = __WEBPACK_IMPORTED_MODULE_11_csvexport___default.a.create({
        filename: 'provider_availability ' + timestamp + '.csv',
        columns: ['ID', 'Business Name', 'Type', 'Home Sector', 'Service', 'Vehicle Type', 'Available From', 'Available Until', 'Phone']
      });
      exporter.downloadCsv(this.xport.csvData);
      this.xport.loading = false;
      self.xport.success = true;
    },
    closeExport: function closeExport() {
      if (this.xport.loading) {
        return;
      }
      this.xport.show = false;
      this.xport.success = false;
      this.xport.error = '';
    },
    currentPage: function currentPage(page) {
      return page.substring(4);
    }
  },
  mounted: function mounted() {
    this.getBrands();
    this.setScreenSize();
  }
});

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_provider_availability__ = __webpack_require__(590);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import featureToggle from '@/modules/api/featureToggle'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'table-filter',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default.a },
  data: function data() {
    return {
      maxHour: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      dateError: {
        showMsg: false,
        target: ''
      },
      shiftActive: '',
      dfault: {
        startDate: '',
        endDate: ''
      }
    };
  },

  computed: {
    // loading () { return this.$store.state.provider.availability.loading },
    sectors: function sectors() {
      return this.$store.state.provider.sectors.list;
    },

    selectedSector: {
      get: function get() {
        return this.$store.state.provider.availability.sector;
      },
      set: function set(value) {
        this.$store.commit('provider/setAvailabilitySector', value);
        // this.updateTable()
      }
    },
    loading: function loading() {
      return this.$store.state.provider.availability.loading;
    },
    sectorLoading: function sectorLoading() {
      return this.$store.state.provider.sectors.loading;
    },
    startDate: function startDate() {
      var datetime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.$store.state.provider.availability.since, 'X');
      var hourFormat = this.$settings.get('MilitaryTimeBackoffice') === '1' ? 'HH' : 'hh';
      return {
        date: datetime.format('MM/DD/YYYY'),
        hour: datetime.format(hourFormat),
        minute: datetime.format('mm'),
        amPm: datetime.format('A')
      };
    },
    endDate: function endDate() {
      var datetime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.$store.state.provider.availability.until, 'X');
      var hourFormat = this.$settings.get('MilitaryTimeBackoffice') === '1' ? 'HH' : 'hh';
      return {
        date: datetime.format('MM/DD/YYYY'),
        hour: datetime.format(hourFormat),
        minute: datetime.format('mm'),
        amPm: datetime.format('A')
      };
    },
    isMilitaryTime: function isMilitaryTime() {
      var isMilitaryTime = false;
      if (this.$settings.get('MilitaryTimeBackoffice') === '1') {
        isMilitaryTime = this.$settings.get('MilitaryTimeBackoffice') === '1';
      }
      if (isMilitaryTime) {
        this.maxHour = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
      }
      return isMilitaryTime;
    },

    selectedService: {
      get: function get() {
        return this.$store.state.provider.availability.service;
      },
      set: function set(value) {
        this.$store.commit('provider/setAvailabilityService', value);
      }
    },
    selectedType: {
      get: function get() {
        return this.$store.state.provider.availability.type;
      },
      set: function set(value) {
        this.$store.commit('provider/setAvailabilityType', value);
      }
    },
    vehicleType: {
      get: function get() {
        return this.$store.state.provider.availability.vehicleType;
      },
      set: function set(x) {
        this.$store.commit('provider/setAvailabilityData', { vehicleType: x });
      }
    },
    selectedAssigned: {
      get: function get() {
        return this.$store.state.provider.availability.assignedTrips;
      },
      set: function set(value) {
        this.$store.commit('provider/setAvailabilityAssignedTrips', value);
      }
    }
  },
  methods: {
    getSectors: function getSectors() {
      var self = this;
      self.$store.commit('provider/setSectorLoading', true);
      self.$sdk.get('/sectors', {
        token: self.$store.state.session.sessionToken,
        pageSize: 50
      }, function (r) {
        if (r.error) {
          return;
        }
        var sectors = [];
        r.list.forEach(function (sector) {
          sectors.push({
            id: sector.ID,
            name: sector.name
          });
        });
        self.$store.commit('provider/setSectorsList', sectors);
        self.$store.commit('provider/setSectorLoading', false);
      });
    },
    setInitialDate: function setInitialDate() {
      var timeNow = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()();
      var timeFixed = parseInt(timeNow.format('mm')) % 5;
      if (timeFixed > 0) {
        timeNow = timeNow.add(5, 'minutes').subtract(timeFixed, 'minutes');
      }

      // Default date time now until +5 hours
      this.$store.commit('provider/setAvailabilitySince', timeNow.format('X'));
      this.dfault.startDate = timeNow.format('X');
      // this.$store.commit('provider/setAvailabilityUntil', timeNow.add(5, 'hours').format('X'))
      this.$store.commit('provider/setAvailabilityUntil', timeNow.hours(23).minutes(55).format('X'));
      this.dfault.endDate = timeNow.hours(23).minutes(55).format('X');
    },
    leadingZero: function leadingZero(n) {
      return n < 10 ? '0' + n : n;
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(date).format('MM/DD/YYYY');
    },
    changeDate: function changeDate(target) {
      var selectedDate = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this[target + 'Date'].date);
      var selectedTime = this[target + 'Date'].hour + ':' + this[target + 'Date'].minute;
      var timeFormat = 'hh:mm';

      if (!this.isMilitaryTime) {
        selectedTime = selectedTime + this[target + 'Date'].amPm;
        timeFormat = 'HH:mmA';
      }
      selectedDate = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(selectedDate.format('MM/DD/YYYY') + ' ' + selectedTime, 'MM/DD/YYYY ' + timeFormat);

      if (target === 'start') {
        this.$store.commit('provider/setAvailabilitySince', selectedDate.format('X'));
      } else {
        this.$store.commit('provider/setAvailabilityUntil', selectedDate.format('X'));
      }
    },
    updateDate: function updateDate(target) {
      var selectedDate = this[target + 'Date'].date;
      var selectedTime = this[target + 'Date'].hour + ':' + this[target + 'Date'].minute;
      var timeFormat = 'hh:mm';

      if (!this.isMilitaryTime) {
        selectedTime = selectedTime + this[target + 'Date'].amPm;
        timeFormat = 'HH:mmA';
      }
      selectedDate = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(selectedDate + ' ' + selectedTime, 'MM/DD/YYYY ' + timeFormat);

      if (target === 'start') {
        this.$store.commit('provider/setAvailabilitySince', selectedDate.format('X'));
      } else {
        this.$store.commit('provider/setAvailabilityUntil', selectedDate.format('X'));
      }
      this.shiftActive = '';
    },
    updateTable: function updateTable() {
      var self = this;
      var availability = self.$store.state.provider.availability;
      var startDate = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(availability.since, 'X');
      var endDate = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(availability.until, 'X');

      self.dateError.showMsg = false;
      self.dateError.target = '';
      if (endDate.diff(startDate) <= 0) {
        self.dateError.showMsg = true;
        self.dateError.target = 'date';
        if (startDate.format('MM/DD/YYYY') === endDate.format('MM/DD/YYYY')) {
          self.dateError.target = 'time';
        }
        return;
      }

      self.$store.commit('provider/resetAvailabilityList');
      self.$store.commit('provider/setAvailabilityIsLoading', true);
      this.$store.commit('provider/setAvailabilityCurrentPage', 1);
      // self.$store.commit('provider/setAvailabilityNoShiftData', {
      //   list: [],
      //   currentPage: 1,
      //   maxList: 0
      // })
      __WEBPACK_IMPORTED_MODULE_2__modules_api_provider_availability__["a" /* default */].getList(self, function (res) {
        self.$store.commit('provider/setAvailabilityIsLoading', false);
      });
    },
    toggleShift: function toggleShift(x) {
      if (this.sectorLoading || this.loading) return;
      if (this.shiftActive === x) {
        this.shiftActive = '';
        this.$store.commit('provider/setAvailabilitySince', this.dfault.startDate);
        this.$store.commit('provider/setAvailabilityUntil', this.dfault.endDate);
        return;
      }
      this.shiftActive = x;
      if (x === 'AM') {
        var startDate = this.startDate.date;
        var endDate = this.endDate.date;
        this.$store.commit('provider/setAvailabilitySince', __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(startDate + ' 12:00AM', 'MM/DD/YYYY hh:mmA').format('X'));
        this.$store.commit('provider/setAvailabilityUntil', __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(endDate + ' 11:55AM', 'MM/DD/YYYY hh:mmA').format('X'));
      }
      if (x === 'PM') {
        var _startDate = this.startDate.date;
        var _endDate = this.endDate.date;
        this.$store.commit('provider/setAvailabilitySince', __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(_startDate + ' 12:00PM', 'MM/DD/YYYY hh:mmA').format('X'));
        this.$store.commit('provider/setAvailabilityUntil', __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(_endDate + ' 11:55PM', 'MM/DD/YYYY hh:mmA').format('X'));
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    self.getSectors();
    self.setInitialDate();
    setTimeout(function () {
      self.updateTable();
    }, 150);
  }
});

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__featureToggle__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  getList: function getList(VueApp, callback) {
    var self = this;
    var provider = VueApp.$store.state.provider;
    var availability = provider.availability;
    var param = {
      token: VueApp.$store.state.session.sessionToken,
      vehicleType: null,
      pageNum: availability.currentPage,
      pageSize: availability.perPage,
      order: availability.order,
      orderAsc: availability.orderAsc,
      sectorId: availability.sector,
      since: availability.since,
      until: availability.until

      // param.until = moment(availability.until, 'X').add(1, 'hours').format('X')

    };if (availability.service) {
      switch (availability.service) {
        case 'PAX':
          param.isPax = 1;
          param.isDTD = 0;
          break;
        case 'DTD':
          param.isPax = 0;
          param.isDTD = 1;
          break;
        case 'PAX/DTD':
          param.isPax = 1;
          param.isDTD = 1;
          break;
      }
    }

    if (availability.type) param.licenseType = availability.type;
    if (availability.vehicleType) param.vehicleType = availability.vehicleType;
    if (availability.assignedTrips) param.assignments = availability.assignedTrips;

    VueApp.$store.commit('provider/setAvailabilityChecked', []);
    VueApp.$sdk.get('/shifts/dashboard', param, function (res) {
      if (!res.error) {
        VueApp.$store.commit('provider/setAvailabilityMaxList', res.paging.totalItems);

        if (res.list.length) {
          var provs = [];
          res.list.forEach(function (prov) {
            var name = prov.businessName || prov.firstName + ' ' + prov.lastName;
            var availableFrom = '';
            var availableUntil = '';
            if (prov.startTimestamp) {
              var sinceTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(availability.since, 'X').format(__WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false));
              // availableFrom = moment(prov.startTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false))
              availableFrom = __WEBPACK_IMPORTED_MODULE_0_moment___default()(prov.startTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY') + ' ' + sinceTime;
              availableUntil = __WEBPACK_IMPORTED_MODULE_0_moment___default()(prov.endTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false));
            }
            if (prov.rsvpTimestamp) {
              availableFrom = __WEBPACK_IMPORTED_MODULE_0_moment___default()(prov.rsvpTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA');
              availableUntil = __WEBPACK_IMPORTED_MODULE_0_moment___default()(prov.rsvpTimestamp, 'YYYY-MM-DD HH:mm').add(12, 'hours').format('MM/DD/YYYY hh:mmA');
            }
            var paxDtd = '';
            if (prov.supportPax) {
              paxDtd = 'PAX';
            }
            if (prov.supportDTD) {
              paxDtd = 'DTD';
            }
            if (prov.supportPax && prov.supportDTD) {
              paxDtd = 'PAX/DTD';
            }
            provs.push({
              id: prov.ID,
              name: name,
              firstName: prov.firstName,
              lastName: prov.lastName,
              licenseType: prov.accountType,
              homeSector: prov.homeSectorName || '',
              paxDtd: paxDtd,
              vehicleType: prov.vehicleType || '',
              availableFrom: availableFrom,
              availableUntil: availableUntil,
              mobile: prov.phoneNumber || '',
              hasAssignment: !!prov.assignedRsvp
            });
          });

          VueApp.$store.commit('provider/setAvailabilityList', provs);
        }
        self.getNoShift(VueApp, param, callback);
        return;
      }
      callback(res);
    });
  },
  getNoShift: function getNoShift(VueApp, param, callback) {
    var provider = VueApp.$store.state.provider;
    var availability = provider.availability;

    param.since = __WEBPACK_IMPORTED_MODULE_0_moment___default()().set({ hour: 0, minute: 0, second: 0 }).format('X');
    param.until = __WEBPACK_IMPORTED_MODULE_0_moment___default()().set({ hour: 23, minute: 59, second: 59 }).format('X');

    if (availability.noShift.list.length) return callback();

    VueApp.$sdk.get('/shifts/noshift', param, function (res) {
      var noShift = [];
      if (!res.error) {
        if (res.noshift.length) {
          res.noshift.forEach(function (prov) {
            var name = prov.businessName || prov.firstName + ' ' + prov.lastName;
            var paxDtd = '';
            if (prov.supportPax) paxDtd = 'PAX';
            if (prov.supportDTD) paxDtd = 'DTD';
            if (prov.supportPax && prov.supportDTD) paxDtd = 'PAX/DTD';

            noShift.push({
              id: prov.ID,
              name: name || '--',
              firstName: prov.firstName,
              lastName: prov.lastName,
              licenseType: prov.accountType || '',
              homeSector: prov.homeSectorName || '',
              paxDtd: paxDtd,
              vehicleType: prov.vehicleType || '',
              mobile: prov.phoneNumber || ''
            });
          });

          var fieldSort = 'name';
          if (availability.noShift.order === 'license') fieldSort = 'licenseType';
          if (availability.noShift.order === 'sector') fieldSort = 'homeSector';
          if (availability.noShift.order === 'vehicle') fieldSort = 'vehicleType';

          if (availability.noShift.orderAsc == 1) noShift.sort(function (a, b) {
            return a[fieldSort].toLowerCase().localeCompare(b[fieldSort].toLowerCase());
          });else noShift.sort(function (a, b) {
            return b[fieldSort].toLowerCase().localeCompare(a[fieldSort].toLowerCase());
          });
        }
        VueApp.$store.commit('provider/setAvailabilityNoShiftData', {
          maxList: noShift.length,
          list: noShift,
          currentPage: 1
        });
      }

      callback(res);
    });
  }
});

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_featureToggle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_provider_availability__ = __webpack_require__(590);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'driver-table',
  props: ['isMobile'],
  data: function data() {
    return {
      selected: [],
      lastDriver: '',
      modal: {
        tab: 'upcoming',
        trips: [],
        completed: [],
        show: false,
        loading: false
      },
      checkList: [], // RSVP [upcoming] check list
      checkAll: false,
      tmpData: null
    };
  },

  computed: {
    users: function users() {
      return this.$store.state.provider.availability.list;
    },
    loading: function loading() {
      return this.$store.state.provider.availability.loading;
    },
    currentOrder: function currentOrder() {
      var prov = this.$store.state.provider.availability;
      return { field: prov.order, asc: prov.orderAsc };
    },

    perPage: {
      get: function get() {
        return this.$store.state.provider.availability.perPage;
      },
      set: function set(value) {
        this.$store.commit('provider/setAvailabilityPerPage', parseInt(value));
        this.$store.commit('provider/setAvailabilityCurrentPage', 1);
        this.getList();
      }
    },
    pageData: function pageData() {
      var tableData = this.$store.state.provider.availability;
      var start = tableData.currentPage * tableData.perPage - (tableData.perPage - 1);
      var end = tableData.currentPage * tableData.perPage;
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      };
    },

    currentPage: {
      get: function get() {
        return this.$store.state.provider.availability.currentPage;
      },
      set: function set(value) {
        this.$store.commit('provider/setAvailabilityCurrentPage', parseInt(value));
        this.getList();
      }
    },
    isLastPage: function isLastPage() {
      var prov = this.$store.state.provider.availability;
      return prov.currentPage * prov.perPage >= prov.maxList;
    },
    totalPage: function totalPage() {
      var prov = this.$store.state.provider.availability;
      return Math.ceil(prov.maxList / prov.perPage);
    },

    checked: {
      get: function get() {
        return this.$store.state.provider.availability.checked;
      },
      set: function set(value) {
        this.$store.commit('provider/setAvailabilityChecked', value);

        var users = [];
        this.users.forEach(function (user) {
          if (users.indexOf(user.id) === -1) {
            users.push(user.id);
          }
        });
        this.checkAll = users.length === value.length;
      }
    }
  },
  methods: {
    getList: function getList() {
      var self = this;
      if (self.loading) {
        return;
      }

      self.$store.commit('provider/setAvailabilityIsLoading', true);
      __WEBPACK_IMPORTED_MODULE_2__modules_api_provider_availability__["a" /* default */].getList(self, function (res) {
        self.$store.commit('provider/setAvailabilityIsLoading', false);
      });
    },
    sort: function sort(field) {
      if (this.loading) {
        return;
      }
      this.checkAll = false;
      var prov = this.$store.state.provider.availability;
      if (field !== prov.order) {
        this.$store.commit('provider/setAvailabilityOrderAsc', 1);
      } else {
        this.$store.commit('provider/setAvailabilityOrderAsc', prov.orderAsc === 1 ? 0 : 1);
      }
      this.$store.commit('provider/setAvailabilityOrder', field);
      this.$store.commit('provider/setAvailabilityCurrentPage', 1);
      this.getList();
    },
    prev: function prev() {
      if (this.currentPage === 1) {
        return;
      }
      this.$store.commit('provider/setAvailabilityCurrentPage', this.$store.state.provider.availability.currentPage - 1);
      this.getList();
    },
    next: function next() {
      if (this.isLastPage) {
        return;
      }
      this.$store.commit('provider/setAvailabilityCurrentPage', this.$store.state.provider.availability.currentPage + 1);
      this.getList();
    },
    call: function call(user) {
      var self = this;
      self.$plugins.phone.startCall(self, {
        phone: user.mobile,
        name: user.firstName + ' ' + user.lastName
      });
    },
    checkTrips: function checkTrips() {
      var self = this;
      if (!self.checkList.length) {
        return;
      }

      var driverIndex = self.checkList.findIndex(function (x) {
        return x.status === 'loading';
      });
      if (driverIndex < 0) {
        return;
      }
      var id = self.checkList[driverIndex].id;

      var prov = self.$store.state.provider;
      self.$sdk.get('/provider/' + id + '/rsvp/upcoming', {
        token: self.$store.state.session.sessionToken,
        pageSize: 999,
        pageNum: 1,
        pickupSince: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(prov.availability.since, 'X').subtract(1, 'days').format('YYYY-MM-DD'),
        pickupUntil: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(prov.availability.until, 'X').format('YYYY-MM-DD')
      }, function (res) {
        // let index = self.checkList.findIndex(x => x.id === id)
        if (self.checkList[driverIndex]) {
          if (res.error) {
            self.checkList[driverIndex].status = 'error';
          } else {
            self.checkList[driverIndex].status = res.list.length ? 'hasRsvp' : 'empty';
          }
        }
        self.checkTrips();
      });
    },
    showTrips: function showTrips(data) {
      var self = this;
      if (self.modal.loading) {
        return;
      }
      self.lastDriver = data;
      self.modal = {
        show: true,
        loading: true,
        trips: []
      };

      self.tmpData = data;
      var prov = self.$store.state.provider;
      self.$sdk.get('/provider/' + data.id + '/rsvp/upcoming', {
        token: self.$store.state.session.sessionToken,
        pageSize: 100,
        pageNum: 1,
        pickupSince: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(prov.availability.since, 'X').subtract(1, 'days').format('YYYY-MM-DD'),
        pickupUntil: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(prov.availability.until, 'X').format('YYYY-MM-DD')
      }, function (res) {
        // self.modal.loading = false
        if (res.error) {
          console.log('ERROR', res.error);
          return;
        }

        var threshold = self.$settings.get('OfferLimitThreshold') || 150;
        threshold = 1 + parseFloat(threshold) / 100;

        // let start = moment(prov.availability.since, 'X')
        // let end = moment(prov.availability.until, 'X')
        res.list.forEach(function (r) {
          if (r.type === 'package') {
            // let withInRange = false
            // r.data.rsvp.every(x => {
            //   let btt = Math.floor(x.etaInSec * threshold)
            //   if (moment(x.pickupDate, 'YYYY-MM-DD HH:mm:ss ZZ').isBetween(start, end) ||
            //     moment(x.pickupDate, 'YYYY-MM-DD HH:mm:ss ZZ').add(btt, 'seconds').isBetween(start, end)
            //   ) {
            //     withInRange = true
            //     return false
            //   }
            //   return true
            // })

            // if (withInRange) {
            self.modal.trips.push(self.formatPkg(r.data));
            // }
          } else {
            // let btt = Math.floor(r.data.etaInSec * threshold)
            // if (moment(r.data.pickupDate, 'YYYY-MM-DD HH:mm:ss ZZ').isBetween(start, end) ||
            //   moment(r.data.pickupDate, 'YYYY-MM-DD HH:mm:ss ZZ').add(btt, 'seconds').isBetween(start, end)
            // ) {
            self.modal.trips.push(self.formatRsvp(r.data));
            // }
          }
        });
        setTimeout(function () {
          self.getCompletedTrips(data);
        }, 1000);
      });
    },
    formatRsvp: function formatRsvp(data) {
      var pickupDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(data.pickupDate, 'YYYY-MM-DD HH:mm');

      var status = this.buildStatus(data);
      return {
        id: data.ID,
        type: 'rsvp',
        pickupDate: pickupDate.format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__modules_api_featureToggle__["a" /* default */].timeFormat(this, false)),
        dateSort: parseInt(pickupDate.format('X')),
        pickup: data.pickupLocation.title,
        dropoff: data.dropoffLocation.title,
        status: status.class,
        statusLabel: status.label,
        dispatchStatusX: status.dispatchStatusX
      };
    },
    formatPkg: function formatPkg(data) {
      var lastStop = data.rsvp.find(function (x) {
        return x.ID === data.stops[data.stops.length - 1].reservationID;
      });
      var pickupDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(data.package.pickupTime, 'YYYY-MM-DD@HH:mm');

      var status = this.buildStatus(data);
      return {
        id: data.package.id,
        type: 'package',
        pickupDate: pickupDate.format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__modules_api_featureToggle__["a" /* default */].timeFormat(this, false)),
        dateSort: parseInt(pickupDate.format('X')),
        pickup: data.package.firstPickup,
        dropoff: lastStop.dropoffLocation.title,
        status: status.class,
        statusLabel: status.label,
        dispatchStatusX: status.dispatchStatusX
      };
    },
    buildStatus: function buildStatus(data) {
      var status = {
        class: data.status,
        label: data.status
      };
      if (status.label === 'ready' || data.dispatchStatus === 'ready') {
        status.class = 'ready';
        status.label = 'Ready to go';
      }
      if (status.label === 'onboard') status.label = 'On Board';
      if (data.dispatchStatus === 'dispatched') {
        status.class = data.dispatchStatus;
        status.label = data.dispatchStatus;
      }
      if (data.dispatchStatus === 'requires_dispatch') {
        status.class = 'requires-dispatch';
        status.label = 'Requires Dispatch';
      }
      if (data.dispatchStatus === 'autodispatch') {
        status.class = 'auto-dispatch';
        status.label = 'Auto Dispatch';
      }
      var dispatchStatusX = '';
      if (status.class === 'dispatched') {
        var pickupTime = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(data.pickupDate, 'YYYY-MM-DD hh:mm:ss');
        var pickupTime1 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateCriticalMins'), 'minutes').format('X'));
        var pickupTime115 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateWarningMins'), 'minutes').format('X'));
        var currentTime = parseInt(__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().format('X'));
        if (['ontheway', 'arrived'].indexOf(data.status) > -1) dispatchStatusX = 'on-time';else if (pickupTime1 <= currentTime) dispatchStatusX = 'very-late';else if (pickupTime115 <= currentTime) dispatchStatusX = 'late';else if (data.status === 'upcoming') dispatchStatusX = 'accepted';
      }
      return {
        class: status.class,
        label: status.label,
        dispatchStatusX: dispatchStatusX
      };
    },
    toggleCheckAll: function toggleCheckAll() {
      if (this.users.length) {
        var users = [];
        if (this.checkAll) {
          this.users.forEach(function (user) {
            if (users.indexOf(user.id) === -1) {
              users.push(user.id);
            }
          });
        }
        this.$store.commit('provider/setAvailabilityChecked', users);
      }
    },
    getRsvp: function getRsvp(x) {
      this.modal.tab = x;
      this.showTrips(this.lastDriver, x);
    },
    getCompletedTrips: function getCompletedTrips(data) {
      var self = this;

      var prov = self.$store.state.provider;
      self.$sdk.get('/provider/' + data.id + '/rsvp/history', {
        token: self.$store.state.session.sessionToken,
        pageSize: 100,
        pageNum: 1,
        pickupSince: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(prov.availability.since, 'X').subtract(1, 'days').format('YYYY-MM-DD'),
        pickupUntil: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(prov.availability.until, 'X').add(1, 'days').format('YYYY-MM-DD')
      }, function (res) {
        if (res.error) {
          self.modal.loading = false;
          console.log('ERROR', res.error);
          return;
        }
        res.list.forEach(function (r) {
          if (r.type === 'package') {
            self.modal.trips.push(self.formatPkg(r.data));
          } else {
            self.modal.trips.push(self.formatRsvp(r.data));
          }
        });
        setTimeout(function () {
          self.modal.trips.sort(function (b, a) {
            return b.dateSort - a.dateSort;
          });
          self.modal.loading = false;
        }, 200);
      });
    },
    dateCheck: function dateCheck(date) {
      var from = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.tmpData.availableFrom, 'MM/DD/YYYY hh:mmA');
      date = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(date, 'MM/DD/YYYY hh:mmA');
      return from.isSameOrBefore(date);
    }
  },
  watch: {
    users: function users(val) {
      var _this = this;

      this.checkAll = false;
      this.checkList = [];
      val.forEach(function (driver) {
        _this.checkList.push({
          id: driver.id,
          status: 'loading'
        });
      });
      // this.checkTrips()
    }
  }
});

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'driver-table',
  props: ['isMobile'],
  data: function data() {
    return {
      selected: [],
      lastDriver: '',
      modal: {
        tab: 'upcoming',
        trips: [],
        completed: [],
        show: false,
        loading: false
      },
      checkList: [], // RSVP [upcoming] check list
      checkAll: false,
      tmpData: null
    };
  },

  computed: {
    noShift: function noShift() {
      return this.$store.state.provider.availability.noShift;
    },
    users: function users() {
      return this.noShift.list;
    },
    loading: function loading() {
      return this.$store.state.provider.availability.loading;
    },
    currentOrder: function currentOrder() {
      var prov = this.noShift;
      return { field: prov.order, asc: prov.orderAsc };
    },

    perPage: {
      get: function get() {
        return this.noShift.perPage;
      },
      set: function set(value) {
        this.$store.commit('provider/setAvailabilityNoShiftData', {
          perPage: parseInt(value),
          currentPage: 1
        });
        // this.getList()
      }
    },
    pageData: function pageData() {
      var tableData = this.noShift;
      var start = tableData.currentPage * tableData.perPage - (tableData.perPage - 1);
      var end = tableData.currentPage * tableData.perPage;
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      };
    },

    currentPage: {
      get: function get() {
        return this.noShift.currentPage;
      },
      set: function set(value) {
        this.$store.commit('provider/setAvailabilityNoShiftData', { currentPage: parseInt(value) });
        // this.getList()
      }
    },
    isLastPage: function isLastPage() {
      var prov = this.noShift;
      return prov.currentPage * prov.perPage >= prov.maxList;
    },
    totalPage: function totalPage() {
      var prov = this.noShift;
      return Math.ceil(prov.maxList / prov.perPage);
    }
  },
  methods: {
    refreshList: function refreshList() {
      var self = this;
      if (self.loading) {
        return;
      }

      var noShift = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.noShift.list));
      var fieldSort = 'name';
      if (this.noShift.order === 'license') fieldSort = 'licenseType';
      if (this.noShift.order === 'sector') fieldSort = 'homeSector';
      if (this.noShift.order === 'vehicle') fieldSort = 'vehicleType';

      if (this.noShift.orderAsc == 1) noShift.sort(function (a, b) {
        return a[fieldSort].toLowerCase().localeCompare(b[fieldSort].toLowerCase());
      });else noShift.sort(function (a, b) {
        return b[fieldSort].toLowerCase().localeCompare(a[fieldSort].toLowerCase());
      });

      this.$store.commit('provider/setAvailabilityNoShiftData', { list: noShift });
    },
    sort: function sort(field) {
      if (this.loading) {
        return;
      }
      this.checkAll = false;
      var prov = this.noShift;
      var orderAsc = 1;
      if (field === prov.order) orderAsc = prov.orderAsc === 1 ? 0 : 1;

      this.$store.commit('provider/setAvailabilityNoShiftData', {
        orderAsc: orderAsc,
        order: field,
        currentPage: 1
      });
      this.refreshList();
    },
    prev: function prev() {
      if (this.currentPage === 1) {
        return;
      }
      this.$store.commit('provider/setAvailabilityNoShiftData', { currentPage: this.noShift.currentPage - 1 });
      this.refreshList();
    },
    next: function next() {
      if (this.isLastPage) {
        return;
      }
      this.$store.commit('provider/setAvailabilityNoShiftData', { currentPage: this.noShift.currentPage + 1 });
      this.refreshList();
    },
    call: function call(user) {
      var self = this;
      self.$plugins.phone.startCall(self, {
        phone: user.mobile,
        name: user.firstName + ' ' + user.lastName
      });
    },
    toggleCheckAll: function toggleCheckAll() {
      if (this.users.length) {
        var users = [];
        if (this.checkAll) {
          this.users.forEach(function (user) {
            if (users.indexOf(user.id) === -1) {
              users.push(user.id);
            }
          });
        }
        this.$store.commit('provider/setAvailabilityChecked', users);
      }
    },
    showDriver: function showDriver(index) {
      var min = this.noShift.perPage * (this.noShift.currentPage - 1);
      var max = this.noShift.perPage * this.noShift.currentPage - 1;
      return index >= min && index <= max;
    }
  },
  watch: {
    users: function users(val) {
      var _this = this;

      this.checkAll = false;
      this.checkList = [];
      val.forEach(function (driver) {
        _this.checkList.push({
          id: driver.id,
          status: 'loading'
        });
      });
    }
  }
});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emoji_mart_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emoji_mart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_emoji_mart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListFilter__ = __webpack_require__(1742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ListTable__ = __webpack_require__(1746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_api_provider_list__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_api_provider_notifications__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_api_provider_sms__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_csvexport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App_NotificationModal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App_SMSModal__ = __webpack_require__(74);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */











var exporter = __WEBPACK_IMPORTED_MODULE_8_csvexport___default.a.create({
  filename: 'export.csv',
  columns: ['Prov ID', 'Business Name', 'Type', 'Status', 'ADA', 'First Name', 'Last Name', 'Email', 'Mobile', 'Birthday', 'SSN', 'EIN', 'Address1', 'Address2', 'City', 'State', 'Country', 'Zip', 'Language', 'Created Date', 'Last Update', 'Vehicle Type', 'Make', 'Model', 'Year', 'License Plate', 'Seat Capacity', 'VIN', 'Insurance Company Name', 'Insurance Policy #', 'Insurance Exp. Date', 'TCP Permit #', 'TCP Permit Exp. Date', 'City License #', 'City License Exp. Date', 'Airport Permit #', 'Airport Exp. Date', 'Driver\'s License #', 'Driver\'s License Exp. Date', 'Driving Record Exp. Date', 'Safety Inspect', 'Last Login Timestamp', 'BG Check', 'Shared', 'Opoli', 'Black', 'SUV', 'Private Shuttle']
});

var exporterAll = __WEBPACK_IMPORTED_MODULE_8_csvexport___default.a.create({
  filename: 'export.csv',
  columns: ['Prov ID', 'Business Name', 'Type', 'Status', 'Service', 'ADA', 'First Name', 'Last Name', 'Email', 'Mobile', 'Birthday', 'SSN', 'EIN', 'Address1', 'Address2', 'City', 'State', 'Country', 'Zip', 'Language', 'Created Date', 'Last Update', 'Vehicle Type', 'Make', 'Model', 'Year', 'License Plate', 'Seat Capacity', 'VIN', 'Insurance Company Name', 'Insurance Policy #', 'Insurance Exp. Date', 'TCP Permit #', 'TCP Permit Exp. Date', 'City License #', 'City License Exp. Date', 'Airport Permit #', 'Airport Exp. Date', 'Driver\'s License #', 'Driver\'s License Exp. Date', 'Driving Record Exp. Date', 'Safety Inspect', 'Last Login Timestamp', 'BG Check', 'Services']
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'providerList',
  data: function data() {
    return {
      selected: [],
      notification: {
        showForm: false,
        target: 'all',
        targetMessage: '',
        isPushNotif: true,
        isSendEmail: false,
        brand: '',
        brandErrorMsg: '',
        title: '',
        titleError: '',
        message: '',
        messageError: '',
        charCount: 180,
        charExceed: false,
        showEmoji: false,
        file: '',
        fileReady: true,
        uploadedUrl: '',
        fileError: '',
        isAnnouncement: true,
        loading: false,
        errorMsg: '',
        success: false
      },
      sms: {
        showForm: false,
        target: 'all',
        targetMessage: '',
        isPushNotif: true,
        isSendEmail: false,
        brand: '',
        brandErrorMsg: '',
        // title: '',
        titleError: '',
        message: '',
        messageError: '',
        charCount: 180,
        charExceed: false,
        showEmoji: false,
        file: '',
        fileReady: true,
        uploadedUrl: '',
        fileError: '',
        loading: false,
        errorMsg: '',
        success: false
      },
      disableNotifButton: false,
      isMobile: false,
      isOpenFilter: true,
      tempList: {
        tnc: [],
        tcp: [],
        psc: []
      },
      exportLoading: {
        tnc: false,
        tcp: false,
        psc: false
      }
    };
  },

  components: { listFilter: __WEBPACK_IMPORTED_MODULE_3__ListFilter__["a" /* default */], listTable: __WEBPACK_IMPORTED_MODULE_4__ListTable__["a" /* default */], Picker: __WEBPACK_IMPORTED_MODULE_2_emoji_mart_vue__["Picker"], notificationModal: __WEBPACK_IMPORTED_MODULE_9__App_NotificationModal__["a" /* default */], smsModal: __WEBPACK_IMPORTED_MODULE_10__App_SMSModal__["a" /* default */] },
  computed: {
    brands: function brands() {
      return this.$store.state.brands.list;
    },
    users: function users() {
      return this.$store.state.provider.users.list;
    },
    loading: function loading() {
      return this.$store.state.provider.users.isLoading;
    },
    emojiStyle: function emojiStyle() {
      return { 'width': '100%', 'height': '100%' };
    },
    type: function type() {
      return this.$store.state.provider.users.type;
    },
    services: function services() {
      return this.$store.state.services;
    }
  },
  methods: {
    getList: function getList() {
      var self = this;
      if (self.loading) {
        return;
      }

      if (self.$refs.filter.refreshTable()) {
        self.$refs.filter.refreshTable();
      }
    },
    expired: function expired(date) {
      if (!date || date === 'Invalid date') {
        return '';
      }

      var now = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, 'MM/DD/YYYY').diff(now) >= 0 ? '' : 'expired';
    },
    prev: function prev() {
      // if (this.currentPage === 1) { return }
      // this.$store.commit('provider/setUserCurrentPage', this.$store.state.provider.users.currentPage - 1)
      // this.getList()
    },
    next: function next() {
      // if (this.isLastPage) { return }
      // this.$store.commit('provider/setUserCurrentPage', this.$store.state.provider.users.currentPage + 1)
      // this.getList()
    },
    sort: function sort(field) {
      if (this.loading) {
        return;
      }
      var prov = this.$store.state.provider.users;
      if (field !== prov.order) {
        this.$store.commit('provider/setUserOrderAsc', 1);
      } else {
        this.$store.commit('provider/setUserOrderAsc', prov.orderAsc === 1 ? 0 : 1);
      }
      this.$store.commit('provider/setUserOrder', field);
      // this.$store.commit('provider/setUserCurrentPage', 1)
      // this.getList()
    },
    showFilter: function showFilter() {
      this.isOpenFilter = !this.isOpenFilter;
    },
    setScreenSize: function setScreenSize() {
      var self = this;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        self.isMobile = true;
      } else {
        self.isMobile = false;
      }
    },
    showSMSModal: function showSMSModal() {
      var self = this;
      this.sms.showForm = true;
      var provList = this.$store.state.provider.users;
      this.selected = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.tnc.selectedUser), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.tcp.selectedUser), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.psc.selectedUser));

      this.$nextTick(function () {
        if (self.$refs.sms.showSMSForm()) {
          self.$refs.sms.showSMSForm();
        }
      });

      // this.sms.target = selected.length ? 'selected' : 'all'
      // this.sms.targetMessage = ''
      // this.sms.messageError = ''
    },
    closeSMSForm: function closeSMSForm() {
      if (this.sms.showEmoji) {
        this.closeEmoji();
        return;
      }

      if (this.sms.loading) {
        return;
      }
      this.sms.showForm = false;
      this.sms.brandErrorMsg = '';
      this.sms.errorMsg = '';
      this.sms.success = false;
    },
    sendSMS: function sendSMS() {
      var self = this;

      if (self.validateSmsForm()) {
        return;
      }

      // let selectedId = self.sms.target === 'all' ? null : self.selected
      var selectedId = null;
      if (self.sms.target === 'selected') {
        var provList = this.$store.state.provider.users;
        selectedId = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.tnc.selectedUser), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.tcp.selectedUser), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.psc.selectedUser));
      }
      var data = {
        message: self.sms.message,
        contactID: selectedId
      };

      self.sms.brandErrorMsg = '';
      if (self.sms.target === 'all') {
        // if (!self.sms.brand) {
        //   self.sms.brandErrorMsg = self.$t('consumer.list.emptyBrand')
        //   return
        // }
        data.brandId = self.sms.brand;
      }

      self.sms.loading = true;
      __WEBPACK_IMPORTED_MODULE_7__modules_api_provider_sms__["a" /* default */].send(self, data, function (res) {
        self.sms.loading = false;
        self.sms.success = true;
        self.sms.message = '';
        self.sms.uploadedUrl = '';
      });
    },
    validateSmsForm: function validateSmsForm() {
      var hasError = false;
      this.disableNotifButton = false;
      var provList = this.$store.state.provider.users;
      this.sms.targetMessage = '';
      if (this.sms.target === 'selected') {
        var selected = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.tnc.selectedUser), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.tcp.selectedUser), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.psc.selectedUser));
        if (!selected.length) {
          hasError = true;
        }
        this.sms.targetMessage = selected.length === 0 ? this.$t('consumer.list.zeroSelected') : '';
      }

      this.sms.messageError = '';
      if (this.sms.message === '') {
        hasError = true;
        this.sms.messageError = 'This field cannot be empty.';
      }

      return hasError;
    },
    showNotifModal: function showNotifModal() {
      var self = this;
      this.notification.showForm = true;
      var provList = this.$store.state.provider.users;
      this.selected = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.tnc.selectedUser), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.tcp.selectedUser), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.psc.selectedUser));

      this.$nextTick(function () {
        if (self.$refs.notif.showNotifForm()) {
          self.$refs.notif.showNotifForm();
        }
      });
      // this.notification.target = selected.length ? 'selected' : 'all'
      // if (this.notification.target === 'selected') {
      //   this.notification.targetMessage = selected.length === 0 ? this.$t('consumer.list.zeroSelected') : ''
      // }
      // this.notification.titleError = ''
      // this.notification.messageError = ''
    },
    closeNotifForm: function closeNotifForm() {
      if (this.notification.showEmoji) {
        this.closeEmoji();
        return;
      }

      if (this.notification.loading) {
        return;
      }
      this.notification.showForm = false;
      this.notification.brandErrorMsg = '';
      this.notification.errorMsg = '';
      this.notification.success = false;
    },
    closeEmoji: function closeEmoji() {
      if (this.notification.showEmoji) {
        this.notification.showEmoji = false;
      }
    },
    charCountUpdate: function charCountUpdate() {
      this.notification.charCount = 180 - this.notification.message.length;
    },
    checkFileUpload: function checkFileUpload() {
      var self = this;
      if (this.notification.file) {
        var fd = new FormData();
        fd.append('pic', self.notification.file, 'consumer-notif.png');

        self.$http.post({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.mediaHost + '/api/upload', fd, {
          header: { 'Content-Type': 'multipart/form-data' }
        }).then(function (res) {
          if (res.body.success) {
            self.notification.uploadedUrl = res.body.data.url;
            self.submitNotif();
          }
        });
        return;
      }

      self.submitNotif();
    },
    submitNotif: function submitNotif() {
      var self = this;
      // let selectedId = self.notification.target === 'all' ? null : self.selected

      if (self.validateNotifForm()) {
        return;
      }

      var selectedId = null;
      if (self.notification.target === 'selected') {
        var provList = this.$store.state.provider.users;
        selectedId = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.tnc.selectedUser), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.tcp.selectedUser), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.psc.selectedUser));
      }
      var data = {
        title: self.notification.title,
        message: self.notification.message,
        // image: self.notification.uploadedUrl,
        contactID: selectedId,
        announcement: self.notification.isAnnouncement
      };

      self.notification.brandErrorMsg = '';
      if (self.notification.target === 'all') {
        // if (!self.notification.brand) {
        //   self.notification.brandErrorMsg = self.$t('consumer.list.emptyBrand')
        //   return
        // }
        data.brandId = self.notification.brand;
      }

      self.notification.loading = true;
      if (self.notification.isAnnouncement) {
        var announcement = {
          title: self.notification.title,
          message: self.notification.message
        };
        __WEBPACK_IMPORTED_MODULE_6__modules_api_provider_notifications__["a" /* default */].sendAnnouncement(self, announcement, function (res) {
          self.notification.isAnnouncement = false;
        });
      }
      __WEBPACK_IMPORTED_MODULE_6__modules_api_provider_notifications__["a" /* default */].send(self, data, function (res) {
        self.notification.loading = false;
        self.notification.success = true;
        self.notification.title = '';
        self.notification.message = '';
        self.notification.uploadedUrl = '';
        // self.cleanFileInput()
      });
    },
    addEmoji: function addEmoji(emoji) {
      this.notification.showEmoji = false;

      var textarea = this.$refs.notifMsg;
      var cursorPosition = textarea.selectionEnd;
      var start = this.notification.message.substring(0, textarea.selectionStart);
      var end = this.notification.message.substring(textarea.selectionStart);
      var text = start + emoji.native + end;
      this.notification.message = text;
      textarea.focus();
      var self = this;
      this.$nextTick(function () {
        textarea.selectionEnd = cursorPosition + emoji.native.length;
        self.charCountUpdate();
      });
    },
    exportProv: function exportProv(target) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_5__modules_api_provider_list__["a" /* default */].export(self, target, function (res) {
        if (!res.error) {
          exporterAll.downloadCsv(res);
        }
      });
    },
    exportProvAll: function exportProvAll(target) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_5__modules_api_provider_list__["a" /* default */].exportAll(self, target, function (res) {
        if (!res.error) {
          exporterAll.downloadCsv(res);
        }
      });
    },
    exportProvInSeries: function exportProvInSeries(target) {
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      var self = this;
      if (page == 1) {
        self.tempList[target] = [];
      }
      var providers = self.$store.state.provider.users;
      var params = {
        token: self.$store.state.session.sessionToken,
        status: providers.status,
        license: target,
        pageNum: page,
        pageSize: 200,
        paging: 1
      };
      if (providers.serviceFilter === 'PAX') {
        params.isPax = 1;
        params.isDTD = 0;
      }
      if (providers.serviceFilter === 'DTD') {
        params.isPax = 0;
        params.isDTD = 1;
      }
      if (providers.serviceFilter === 'PAX/DTD') {
        params.isPax = 1;
        params.isDTD = 1;
      }
      self.exportLoading[target] = true;
      self.$sdk.get('/provider/export', params, function (res) {
        if (!res.error) {
          if (res.list.length) {
            res.list.forEach(function (value) {
              self.tempList[target].push(self.buildExportAll(value));
            });
          }
          if (page * res.paging.pageSize < res.paging.totalItems) {
            self.exportProvInSeries(target, page + 1);
          } else {
            self.exportLoading[target] = false;
            exporterAll.downloadCsv(self.tempList[target]);
          }
        }
      });
    },
    buildExportAll: function buildExportAll(data) {
      var licenseType = '';
      if (data.licenseType) {
        licenseType = data.licenseType.toUpperCase();
      }

      var bday = '';
      if (data.dateOfBirth) {
        var temp = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.dateOfBirth, 'YYYY-MM-DD HH:mm:ss');
        if (temp.isValid()) {
          bday = temp.format('MM/DD/YYYY');
        }
      }

      var created = '';
      if (data.created) {
        var _temp = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.created, 'YYYY-MM-DD HH:mm:ss');
        if (_temp.isValid()) {
          created = _temp.format('MM/DD/YYYY HH:mm:ss');
        }
      }

      var modified = '';
      if (data.modified) {
        var _temp2 = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.modified, 'YYYY-MM-DD HH:mm:ss');
        if (_temp2.isValid()) {
          modified = _temp2.format('MM/DD/YYYY HH:mm:ss');
        }
      }

      var insurance = '';
      if (data.insurancePolicyExp) {
        var _temp3 = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.insurancePolicyExp, 'YYYY-MM-DD HH:mm:ss');
        if (_temp3.isValid()) {
          insurance = _temp3.format('MM/DD/YYYY HH:mm:ss');
        }
      }

      var permit = '';
      if (data.tcpPermitExp) {
        var _temp4 = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.tcpPermitExp, 'YYYY-MM-DD HH:mm:ss');
        if (_temp4.isValid()) {
          permit = _temp4.format('MM/DD/YYYY HH:mm:ss');
        }
      }

      var cityLicense = '';
      if (data.cityLicenseExp) {
        var _temp5 = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.cityLicenseExp, 'YYYY-MM-DD HH:mm:ss');
        if (_temp5.isValid()) {
          cityLicense = _temp5.format('MM/DD/YYYY HH:mm:ss');
        }
      }

      var airport = '';
      if (data.airportPermitExp) {
        var _temp6 = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.airportPermitExp, 'YYYY-MM-DD HH:mm:ss');
        if (_temp6.isValid()) {
          airport = _temp6.format('MM/DD/YYYY HH:mm:ss');
        }
      }

      var license = '';
      if (data.driverLicenseExp) {
        var _temp7 = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.driverLicenseExp, 'YYYY-MM-DD HH:mm:ss');
        if (_temp7.isValid()) {
          license = _temp7.format('MM/DD/YYYY HH:mm:ss');
        }
      }

      var drivingRecordExp = '';
      if (data.drivingRecordExp) {
        var _temp8 = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.drivingRecordExp, 'YYYY-MM-DD HH:mm:ss');
        if (_temp8.isValid()) {
          drivingRecordExp = _temp8.format('MM/DD/YYYY HH:mm:ss');
        }
      }

      var safetyInspect = '';
      if (data.vehicleSafetyInspectionByExp) {
        var _temp9 = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.vehicleSafetyInspectionByExp, 'YYYY-MM-DD HH:mm:ss');
        if (_temp9.isValid()) {
          safetyInspect = _temp9.format('MM/DD/YYYY HH:mm:ss');
        }
      }

      var lastLogin = '--';
      if (data.lastDuty) {
        // let temp = moment(data.lastLogin, 'YYYY-MM-DD HH:mm:ss')
        var _temp10 = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.lastDuty, 'YYYY-MM-DD HH:mm:ss');
        if (_temp10.isValid()) {
          lastLogin = _temp10.format('MM/DD/YYYY HH:mm:ss');
        }
      }

      var service = '';
      if (data.isPax) {
        service = 'PAX';
      }
      if (data.isDTD) {
        service = 'DTD';
      }
      if (data.isPax && data.isDTD) {
        service = 'PAX/DTD';
      }

      return {
        'Prov ID': data.ID,
        'Business Name': data.businessName || '',
        'Type': licenseType,
        'Status': data.duty || 'a',
        'Service': service,
        'ADA': data.wheelChairLift ? 'YES' : 'NO',
        'First Name': data.firstName,
        'Last Name': data.lastName,
        'Email': data.email,
        'Mobile': data.phoneNumber,
        'Birthday': bday,
        'SSN': data.businessSSN || '',
        'EIN': data.businessEIN || '',
        'Address1': data.addressLine1 || '',
        'Address2': data.addressLine2 || '',
        'City': data.city,
        'State': data.state,
        'Country': data.country,
        'Zip': data.zipCode,
        'Language': data.language || 'english',
        'Created Date': created,
        'Last Update': modified,
        'Vehicle Type': data.vehicleType || '',
        'Make': data.make || '',
        'Model': data.model || '',
        'Year': data.makeYear || '',
        'License Plate': data.licensePlate || '',
        'Seat Capacity': data.seatCapacity,
        'VIN': data.vehicleIdNumber || '',
        'Insurance Company Name': data.insuranceCompany || '',
        'Insurance Policy #': data.insurancePolicyNumber || '',
        'Insurance Exp. Date': insurance,
        'TCP Permit #': data.tcpPermitNumber || '',
        'TCP Permit Exp. Date': permit,
        'City License #': data.cityLicenseNumber || '',
        'City License Exp. Date': cityLicense,
        'Airport Permit #': data.airportPermitNumber || '',
        'Airport Exp. Date': airport,
        'Driver\'s License #': data.driverLicenseNumber || '',
        'Driver\'s License Exp. Date': license,
        'Driving Record Exp. Date': drivingRecordExp,
        'Safety Inspect': safetyInspect,
        'Last Login Timestamp': lastLogin,
        'BG Check': data.backgroundCheckPassed !== 0,
        'Services': data.serviceTypeNames || ''
        // 'Shared': shared,
        // 'Opoli': opoli,
        // 'Black': black,
        // 'SUV': suv,
        // 'Private Shuttle': shuttle
      };
    },
    validateNotifForm: function validateNotifForm() {
      var hasError = false;
      this.disableNotifButton = false;
      var provList = this.$store.state.provider.users;

      this.notification.targetMessage = '';
      if (this.notification.target === 'selected') {
        var selected = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.tnc.selectedUser), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.tcp.selectedUser), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.psc.selectedUser));
        if (!selected.length) {
          hasError = true;
        }
        this.notification.targetMessage = selected.length === 0 ? this.$t('consumer.list.zeroSelected') : '';
      }

      this.notification.titleError = '';
      if (this.notification.title === '') {
        hasError = true;
        this.notification.titleError = 'This field cannot be empty.';
      }

      this.notification.messageError = '';
      if (this.notification.message === '') {
        hasError = true;
        this.notification.messageError = 'This field cannot be empty.';
      }

      return hasError;
    }
  },
  watch: {
    loading: function loading(value) {
      this.selected = [];
    },

    // selected (value) { this.$store.commit('provider/setUserSelected', value) },
    'notification.target': function notificationTarget(value) {
      this.disableNotifButton = false;
      var provList = this.$store.state.provider.users;

      this.notification.targetMessage = '';
      if (value === 'selected') {
        var selected = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.tnc.selectedUser), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.tcp.selectedUser), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.psc.selectedUser));
        // this.disableNotifButton = selected.length === 0
        this.notification.targetMessage = selected.length === 0 ? this.$t('consumer.list.zeroSelected') : '';
      }
    },
    'services.serviceLoading': function servicesServiceLoading(value) {
      if (!value) {
        // this.getList()
      }
    }
  },
  mounted: function mounted() {
    var self = this;

    self.setScreenSize();
    self.$store.commit('provider/setUserCurrentPage', { target: 'tnc', value: 1 });
    self.$store.commit('provider/setUserCurrentPage', { target: 'tcp', value: 1 });
    self.$store.commit('provider/setUserCurrentPage', { target: 'psc', value: 1 });
    self.getList(); // load service list first

    if (self.$store.state.brands.list.length === 0) {
      self.$store.commit('brands/setLoading', true);
      self.$sdk.get('/brand', {}, function (res) {
        self.$store.commit('brands/setLoading', false);
        var brands = [];
        res.forEach(function (data) {
          brands.push({ id: data.id, name: data.name });
        });
        self.$store.commit('brands/setList', brands);
      });
    }
  }
});

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_provider_list__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_services__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_csvexport__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */




var PNF = __webpack_require__(50).PhoneNumberFormat;
var phoneUtil = __webpack_require__(50).PhoneNumberUtil.getInstance();

var exporter = __WEBPACK_IMPORTED_MODULE_3_csvexport___default.a.create({
  filename: 'export.csv',
  columns: ['Prov ID', 'Business Name', 'Type', 'Status', 'First Name', 'Last Name', 'Email', 'Mobile', 'Birthday', 'Address1', 'Address2', 'City', 'State', 'Country', 'Zip', 'Language', 'Created', 'Last Update', 'Vehicle Type', 'Make', 'Model', 'Year', 'License Plate', 'Seat Capacity', 'VIN', 'Insurance Company Name', 'Insurance Policy #', 'Insurance Exp. Date', 'TCP Permit #', 'TCP Permit Exp. Date', 'City License #', 'City License Exp. Date', 'Airport Permit #', 'Airport Exp. Date', 'Driver\'s License #', 'Driver\'s License Exp. Date', 'Driving Record Exp. Date', 'Safety Inspect', 'Last Login Timestamp', 'BG Check', 'Shared', 'Opoli', 'Black', 'SUV', 'Private Shuttle']
});

var exporterAll = __WEBPACK_IMPORTED_MODULE_3_csvexport___default.a.create({
  filename: 'export.csv',
  columns: ['Prov ID', 'Business Name', 'Type', 'Status', 'First Name', 'Last Name', 'Email', 'Mobile', 'Birthday', 'Address1', 'Address2', 'City', 'State', 'Country', 'Zip', 'Language', 'Created', 'Last Update', 'Vehicle Type', 'Make', 'Model', 'Year', 'License Plate', 'Seat Capacity', 'VIN', 'Insurance Company Name', 'Insurance Policy #', 'Insurance Exp. Date', 'TCP Permit #', 'TCP Permit Exp. Date', 'City License #', 'City License Exp. Date', 'Airport Permit #', 'Airport Exp. Date', 'Driver\'s License #', 'Driver\'s License Exp. Date', 'Driving Record Exp. Date', 'Safety Inspect', 'Last Login Timestamp', 'BG Check', 'Services']
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'list-filter',
  props: ['isOpen', 'isMobile'],
  data: function data() {
    return {
      searchInput: '',
      blurDelay: '',
      status: 'activate',
      selected: [],
      queedTables: [],
      serviceTypes: {}
    };
  },

  // components: {Picker},
  computed: {
    brands: function brands() {
      return this.$store.state.brands.list;
    },

    type: {
      get: function get() {
        return this.$store.state.provider.users.type;
      },
      set: function set(value) {
        this.$store.commit('provider/setUserType', value);
        this.refreshTable();
      }
    },
    statusTable: {
      get: function get() {
        return this.$store.state.provider.users.status;
      },
      set: function set(value) {
        this.$store.commit('provider/setUserStatus', value);
        this.refreshTable();
      }
    },
    serviceFilter: {
      get: function get() {
        return this.$store.state.provider.users.serviceFilter;
      },
      set: function set(value) {
        this.$store.commit('provider/setUserServiceFilter', value);
        this.refreshTable();
      }
    },
    serviceType: {
      get: function get() {
        return this.$store.state.provider.users.serviceType;
      },
      set: function set(value) {
        this.$store.commit('provider/setUserServiceType', value);
        this.refreshTable();
      }
    },
    loading: function loading() {
      return this.$store.state.provider.users.isLoading;
    },
    services: function services() {
      return this.$store.state.services;
    }
  },
  methods: {
    refreshTable: function refreshTable() {
      var self = this;
      if (self.loading) {
        return;
      }

      self.queedTables = [];
      if (self.type === 'all') {
        self.queedTables = ['tnc', 'tcp', 'psc'];
        // self.$store.commit('provider/setUserIsLoading', {target: 'tnc', value: true})
        // self.$store.commit('provider/resetUsers', 'tnc')
        // self.$store.commit('provider/setUserCurrentPage', {target: 'tnc', value: 1})
        // ApiProviderList.getList2(self, self.createParams('tnc'), res => {
        //   self.$store.commit('provider/setUserIsLoading', {target: 'tnc', value: false})
        // })

        // self.$store.commit('provider/setUserIsLoading', {target: 'tcp', value: true})
        // self.$store.commit('provider/resetUsers', 'tcp')
        // self.$store.commit('provider/setUserCurrentPage', {target: 'tcp', value: 1})
        // ApiProviderList.getList2(self, self.createParams('tcp'), res => {
        //   self.$store.commit('provider/setUserIsLoading', {target: 'tcp', value: false})
        // })

        // self.$store.commit('provider/setUserIsLoading', {target: 'psc', value: true})
        // self.$store.commit('provider/resetUsers', 'psc')
        // self.$store.commit('provider/setUserCurrentPage', {target: 'psc', value: 1})
        // ApiProviderList.getList2(self, self.createParams('psc'), res => {
        //   self.$store.commit('provider/setUserIsLoading', {target: 'psc', value: false})
        // })
      } else {
        self.queedTables = [self.type];
        // self.$store.commit('provider/setUserIsLoading', {target: self.type, value: true})
        // self.$store.commit('provider/resetUsers', self.type)
        // self.$store.commit('provider/setUserCurrentPage', {target: self.type, value: 1})
        // ApiProviderList.getList2(self, self.createParams(self.type), res => {
        //   self.$store.commit('provider/setUserIsLoading', {target: self.type, value: false})
        // })
      }
      self.loadTables();
    },
    loadTables: function loadTables() {
      var self = this;
      if (!self.queedTables.length) {
        return;
      }

      self.$store.commit('provider/setUserIsLoading', { target: self.queedTables[0], value: true });
      self.$store.commit('provider/resetUsers', self.queedTables[0]);
      self.$store.commit('provider/setUserCurrentPage', { target: self.queedTables[0], value: 1 });
      __WEBPACK_IMPORTED_MODULE_1__modules_api_provider_list__["a" /* default */].getList2(self, self.createParams(self.queedTables[0]), function (res) {
        self.$store.commit('provider/setUserIsLoading', { target: self.queedTables[0], value: false });
        self.queedTables.shift();
        self.loadTables();
      });
    },
    createParams: function createParams(target) {
      var params = {
        target: target,
        status: this.statusTable,
        type: target
      };
      if (this.serviceFilter === 'PAX') {
        params.isPax = 1;
        params.isDTD = 0;
      }
      if (this.serviceFilter === 'DTD') {
        params.isPax = 0;
        params.isDTD = 1;
      }
      if (this.serviceFilter === 'PAX/DTD') {
        params.isPax = 1;
        params.isDTD = 1;
      }
      return params;
    },
    search: function search() {
      this.$store.commit('provider/setUserSearch', this.searchInput);
      this.refreshTable();
    },
    blurSearch: function blurSearch() {
      var self = this;
      if (self.$store.state.provider.users.search === self.searchInput.trim()) {
        return;
      }

      self.blurDelay = setTimeout(function () {
        self.search();
      }, 500);
    },
    clearSearch: function clearSearch() {
      if (this.blurDelay) {
        clearTimeout(this.blurDelay);
      }
      if (this.loading) {
        return;
      }

      this.searchInput = '';
      this.$store.commit('provider/setUserSearch', this.searchInput);
      this.refreshTable();
    },
    updateStatus: function updateStatus() {
      var provList = this.$store.state.provider.users;
      this.selected = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.tnc.selectedUser), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.tcp.selectedUser), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(provList.psc.selectedUser));
      if (provList.tnc.selectedUser.length) {
        this.$store.commit('provider/setUserIsLoading', { target: 'tnc', value: true });
      }
      if (provList.tcp.selectedUser.length) {
        this.$store.commit('provider/setUserIsLoading', { target: 'tcp', value: true });
      }
      if (provList.psc.selectedUser.length) {
        this.$store.commit('provider/setUserIsLoading', { target: 'psc', value: true });
      }
      this.processUpdateStatus(this.selected[0]);
    },
    processUpdateStatus: function processUpdateStatus(id) {
      var self = this;

      var provList = this.$store.state.provider.users;
      if (self.status === 'archive') {
        __WEBPACK_IMPORTED_MODULE_1__modules_api_provider_list__["a" /* default */].archiveUser(self, id, function (res) {
          self.selected.shift();
          if (!self.selected.length) {
            if (provList.tnc.selectedUser.length) {
              self.$store.commit('provider/setUserIsLoading', { target: 'tnc', value: false });
            }
            if (provList.tcp.selectedUser.length) {
              self.$store.commit('provider/setUserIsLoading', { target: 'tcp', value: false });
            }
            if (provList.psc.selectedUser.length) {
              self.$store.commit('provider/setUserIsLoading', { target: 'psc', value: false });
            }
            self.refreshTable();
          } else {
            self.processUpdateStatus(self.selected[0]);
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__modules_api_provider_list__["a" /* default */].updateStatus(self, {
          id: id,
          isActive: self.status === 'activate'
        }, function (res) {
          self.selected.shift();
          if (!self.selected.length) {
            if (provList.tnc.selectedUser.length) {
              self.$store.commit('provider/setUserIsLoading', { target: 'tnc', value: false });
            }
            if (provList.tcp.selectedUser.length) {
              self.$store.commit('provider/setUserIsLoading', { target: 'tcp', value: false });
            }
            if (provList.psc.selectedUser.length) {
              self.$store.commit('provider/setUserIsLoading', { target: 'psc', value: false });
            }
            self.refreshTable();
          } else {
            self.processUpdateStatus(self.selected[0]);
          }
        });
      }
    },
    exportProv: function exportProv() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1__modules_api_provider_list__["a" /* default */].export(self, {}, function (res) {
        if (!res.error) {
          exporter.downloadCsv(res);
        }
      });
    },
    exportProvAll: function exportProvAll() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1__modules_api_provider_list__["a" /* default */].exportAll(self, {}, function (res) {
        if (!res.error) {
          exporterAll.downloadCsv(res);
        }
      });
    },
    getServices: function getServices() {
      var self = this;
      self.$store.commit('services/setServiceLoading', true);
      __WEBPACK_IMPORTED_MODULE_2__modules_api_services__["a" /* default */].getAllService(self, function (r) {
        self.$store.commit('services/setServiceLoading', false);
        self.setServices();
      });
    },
    setServices: function setServices() {
      var self = this;
      self.services.list.forEach(function (service) {
        var brand = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.find(function (x) {
          return x.id == service.brandId && service.enabled;
        });
        if (!brand) return;
        if (!self.serviceTypes[brand.name]) self.serviceTypes[brand.name] = [];
        self.serviceTypes[brand.name].push(service);
      });
      self.$forceUpdate();
    }
  },
  mounted: function mounted() {
    // if (!this.services.list.length) {
    //   this.getServices()
    // } else {
    //   this.setServices()
    // }
  }
});

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_provider_list__ = __webpack_require__(97);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'list-table',
  props: ['target'],
  data: function data() {
    return {
      selected: [],
      isMobile: false
    };
  },

  computed: {
    users: function users() {
      return this.$store.state.provider.users[this.target].list;
    },

    selectAll: {
      get: function get() {
        return this.selected.length === this.users.length && this.selected.length > 0;
      },
      set: function set(value) {
        var selected = [];
        if (value) {
          this.users.forEach(function (user) {
            selected.push(user.id);
          });
        }
        this.selected = selected;
        this.$store.commit('provider/setUserSelected', {
          target: this.target,
          value: selected
        });
      }
    },
    loading: function loading() {
      return this.$store.state.provider.users[this.target].loading;
    },
    currentOrder: function currentOrder() {
      var prov = this.$store.state.provider.users[this.target];
      return { field: prov.order, asc: prov.orderAsc };
    },

    statusTable: {
      get: function get() {
        return this.$store.state.provider.users.status;
      },
      set: function set(value) {
        this.$store.commit('provider/setUserStatus', value);
        this.refreshTable();
      }
    },
    serviceFilter: function serviceFilter() {
      return this.$store.state.provider.users.serviceFilter;
    },

    perPage: {
      get: function get() {
        return this.$store.state.provider.users[this.target].perPage;
      },
      set: function set(value) {
        this.$store.commit('provider/setUserPerPage', {
          target: this.target,
          value: parseInt(value)
        });
        this.$store.commit('provider/setUserCurrentPage', {
          target: this.target,
          value: 1
        });
        this.getList();
      }
    },
    pageData: function pageData() {
      var tableData = this.$store.state.provider.users[this.target];
      var start = tableData.currentPage * tableData.perPage - (tableData.perPage - 1);
      var end = tableData.currentPage * tableData.perPage;
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      };
    },

    currentPage: {
      get: function get() {
        return this.$store.state.provider.users[this.target].currentPage;
      },
      set: function set(value) {
        this.$store.commit('provider/setUserCurrentPage', {
          target: this.target,
          value: parseInt(value)
        });
        this.getList();
      }
    },
    isLastPage: function isLastPage() {
      var prov = this.$store.state.provider.users[this.target];
      return prov.currentPage * prov.perPage >= prov.maxList;
    },
    totalPage: function totalPage() {
      var prov = this.$store.state.provider.users[this.target];
      return Math.ceil(prov.maxList / prov.perPage);
    }
  },
  methods: {
    getList: function getList() {
      var self = this;
      if (self.loading) {
        return;
      }

      self.$store.commit('provider/resetUsers', self.target);
      self.$store.commit('provider/setUserIsLoading', {
        target: self.target,
        value: true
      });
      __WEBPACK_IMPORTED_MODULE_0__modules_api_provider_list__["a" /* default */].getList2(self, self.createParams(this.target), function (res) {
        self.$store.commit('provider/setUserIsLoading', {
          target: self.target,
          value: false
        });
      });
    },
    createParams: function createParams(target) {
      var params = {
        target: target,
        status: this.statusTable,
        type: target
      };
      if (this.serviceFilter === 'PAX') {
        params.isPax = 1;
        params.isDTD = 0;
      }
      if (this.serviceFilter === 'DTD') {
        params.isPax = 0;
        params.isDTD = 1;
      }
      if (this.serviceFilter === 'PAX/DTD') {
        params.isPax = 1;
        params.isDTD = 1;
      }
      return params;
    },
    sort: function sort(field) {
      if (this.loading) {
        return;
      }
      var prov = this.$store.state.provider.users[this.target];
      if (field !== prov.order) {
        this.$store.commit('provider/setUserOrderAsc', {
          target: this.target,
          value: 1
        });
      } else {
        this.$store.commit('provider/setUserOrderAsc', {
          target: this.target,
          value: prov.orderAsc === 1 ? 0 : 1
        });
      }
      this.$store.commit('provider/setUserOrder', {
        target: this.target,
        value: field
      });
      this.$store.commit('provider/setUserCurrentPage', {
        target: this.target,
        value: 1
      });
      this.getList();
    },
    prev: function prev() {
      if (this.currentPage === 1) {
        return;
      }
      this.$store.commit('provider/setUserCurrentPage', {
        target: this.target,
        value: this.$store.state.provider.users[this.target].currentPage - 1
      });
      this.getList();
    },
    next: function next() {
      if (this.isLastPage) {
        return;
      }
      this.$store.commit('provider/setUserCurrentPage', {
        target: this.target,
        value: this.$store.state.provider.users[this.target].currentPage + 1
      });
      this.getList();
    },
    setScreenSize: function setScreenSize() {
      var self = this;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        self.isMobile = true;
      } else {
        self.isMobile = false;
      }
    },
    statusLabel: function statusLabel(x) {
      if (x === 'onduty') return 'On Duty';else return 'Off Duty';
    }
  },
  mounted: function mounted() {
    this.setScreenSize();
  },

  watch: {
    loading: function loading(value) {
      this.selected = [];
    },
    selected: function selected(value) {
      this.$store.commit('provider/setUserSelected', {
        target: this.target,
        value: value
      });
    }
  }
});

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DeductionDelete__ = __webpack_require__(1754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DeductionForm__ = __webpack_require__(1758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DeductionList__ = __webpack_require__(1762);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'driver-deductions',
  components: { DeductionDelete: __WEBPACK_IMPORTED_MODULE_0__DeductionDelete__["a" /* default */], DeductionForm: __WEBPACK_IMPORTED_MODULE_1__DeductionForm__["a" /* default */], DeductionList: __WEBPACK_IMPORTED_MODULE_2__DeductionList__["a" /* default */] },
  data: function data() {
    return {
      isMobile: false
    };
  },
  mounted: function mounted() {
    var self = this;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      self.isMobile = true;
    } else {
      self.isMobile = false;
    }
  }
});

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'deduction-delete',
  data: function data() {
    return {
      deleting: false,
      error: {
        show: false,
        message: 'Please select a valid value'
      }
    };
  },

  computed: {
    item: function item() {
      return this.$store.state.providerDeductions.deductionDelete.item;
    },
    show: function show() {
      return this.$store.state.providerDeductions.deductionDelete.show;
    }
  },
  methods: {
    close: function close() {
      this.$store.commit('providerDeductions/setDeductionDeleteShow', false);
      this.$store.commit('providerDeductions/setDeductionDeleteItem', null);
    },
    submitDelete: function submitDelete() {
      var self = this;
      self.deleting = true;
      self.$sdk.delete('/admin/providerdeduction/' + self.item.id, {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.deleting = false;
        if (r.error) {
          self.error = {
            show: true,
            message: r.error.message
          };
          return;
        }
        self.close();
        self.$store.commit('providerDeductions/setDeductionListReload', true);
      });
    }
  }
});

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'deduction-form',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a },
  data: function data() {
    return {
      submitLoading: false,
      error: {
        show: false,
        message: 'Please select a valid value'
      }
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.providerDeductions.deductionForm.show;
    },
    interval: function interval() {
      return this.$store.state.providerDeductions.deductionForm.interval;
    },
    weeklyAnchor: function weeklyAnchor() {
      return this.$store.state.providerDeductions.deductionForm.weeklyAnchor;
    },
    monthlyAnchor: function monthlyAnchor() {
      return this.$store.state.providerDeductions.deductionForm.monthlyAnchor;
    },
    id: function id() {
      return this.$store.state.providerDeductions.deductionForm.id;
    },

    name: {
      get: function get() {
        return this.$store.state.providerDeductions.deductionForm.name;
      },
      set: function set(value) {
        this.$store.commit('providerDeductions/setDeductionFormName', value);
      }
    },
    description: {
      get: function get() {
        return this.$store.state.providerDeductions.deductionForm.description;
      },
      set: function set(value) {
        this.$store.commit('providerDeductions/setDeductionFormDescription', value);
      }
    },
    amount: {
      get: function get() {
        return this.$store.state.providerDeductions.deductionForm.amount;
      },
      set: function set(value) {
        this.$store.commit('providerDeductions/setDeductionFormAmount', value);
      }
    },
    effectiveStart: {
      get: function get() {
        if (this.$store.state.providerDeductions.deductionForm.effectiveStart === null) {
          return null;
        }
        return this.$store.state.providerDeductions.deductionForm.effectiveStart.toDate();
      },
      set: function set(value) {
        var temp = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value);
        var startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(temp.format('YYYY-MM-DD') + ' 00:00:00', 'YYYY-MM-DD HH:mm:ss');
        this.$store.commit('providerDeductions/setDeductionFormEffectiveStart', startDate);
      }
    },
    effectiveEnd: {
      get: function get() {
        if (this.$store.state.providerDeductions.deductionForm.effectiveEnd === null) {
          return null;
        }
        return this.$store.state.providerDeductions.deductionForm.effectiveEnd.toDate();
      },
      set: function set(value) {
        var temp = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value);
        var endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(temp.format('YYYY-MM-DD') + ' 23:59:59', 'YYYY-MM-DD HH:mm:ss');
        this.$store.commit('providerDeductions/setDeductionFormEffectiveEnd', endDate);
      }
    },
    enabled: {
      get: function get() {
        return this.$store.state.providerDeductions.deductionForm.enabled;
      },
      set: function set(value) {
        this.$store.commit('providerDeductions/setDeductionFormEnabled', value);
      }
    },
    selectedInterval: {
      get: function get() {
        return this.$store.state.providerDeductions.deductionForm.selectedInterval;
      },
      set: function set(value) {
        this.$store.commit('providerDeductions/setDeductionFormSelectedInterval', value);
      }
    },
    selectedWeeklyAnchor: {
      get: function get() {
        return this.$store.state.providerDeductions.deductionForm.selectedWeeklyAnchor;
      },
      set: function set(value) {
        this.$store.commit('providerDeductions/setDeductionFormSelectedWeeklyAnchor', value);
      }
    },
    selectedMonthlyAnchor: {
      get: function get() {
        return this.$store.state.providerDeductions.deductionForm.selectedMonthlyAnchor;
      },
      set: function set(value) {
        this.$store.commit('providerDeductions/setDeductionFormSelectedMonthlyAnchor', value);
      }
    },
    applyTNC: {
      get: function get() {
        return this.$store.state.providerDeductions.deductionForm.applyTNC;
      },
      set: function set(value) {
        this.$store.commit('providerDeductions/setDeductionFormApplyTNC', value);
      }
    },
    applyTCP: {
      get: function get() {
        return this.$store.state.providerDeductions.deductionForm.applyTCP;
      },
      set: function set(value) {
        this.$store.commit('providerDeductions/setDeductionFormApplyTCP', value);
      }
    },
    applyPSC: {
      get: function get() {
        return this.$store.state.providerDeductions.deductionForm.applyPSC;
      },
      set: function set(value) {
        this.$store.commit('providerDeductions/setDeductionFormApplyPSC', value);
      }
    }
  },
  methods: {
    close: function close() {
      this.$store.commit('providerDeductions/setDeductionFormShow', false);
    },
    ucFirst: function ucFirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    daySuffix: function daySuffix(i) {
      var j = i % 10;
      var k = i % 100;
      if (j == 1 && k != 11) {
        return i + "st";
      }
      if (j == 2 && k != 12) {
        return i + "nd";
      }
      if (j == 3 && k != 13) {
        return i + "rd";
      }
      return i + "th";
    },
    isValid: function isValid(form) {
      var self = this;
      self.error = {
        show: false,
        message: ''
      };

      if (form.name === '') {
        self.error = {
          show: true,
          message: '\'Name\' is a required field.'
        };
        return false;
      }

      if (form.description === '') {
        self.error = {
          show: true,
          message: '\'Description\' is a required field.'
        };
        return false;
      }

      if (form.amount === '') {
        self.error = {
          show: true,
          message: '\'Amount\' is a required field.'
        };
        return false;
      }

      if (form.effectiveStart === null) {
        self.error = {
          show: true,
          message: '\'Start Date\' is a required field.'
        };
        return false;
      }

      if (form.effectiveEnd === null) {
        self.error = {
          show: true,
          message: '\'End Date\' is a required field.'
        };
        return false;
      }

      if (form.effectiveEnd.isBefore(form.effectiveStart)) {
        self.error = {
          show: true,
          message: '\'End Date\' must be on or after \'Start Date\'.'
        };
        return false;
      }

      if (form.amount <= 0) {
        self.error = {
          show: true,
          message: '\'Amount\' must be a number greater than 0.'
        };
        return false;
      }

      if (!form.applyTNC && !form.applyTCP && !form.applyPSC) {
        self.error = {
          show: true,
          message: 'Please select at least one applicable license (TNC, TCP or PSC).'
        };
        return false;
      }
      return true;
    },
    submitForm: function submitForm() {
      var self = this;
      var request = {
        token: self.$store.state.session.sessionToken,
        name: self.name,
        description: self.description,
        amount: self.amount,
        effectiveStart: self.effectiveStart === null ? null : __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.effectiveStart),
        effectiveEnd: self.effectiveEnd === null ? null : __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.effectiveEnd),
        enabled: self.enabled,
        interval: self.selectedInterval,
        weeklyAnchor: self.selectedWeeklyAnchor,
        monthlyAnchor: self.selectedMonthlyAnchor,
        applyTNC: self.applyTNC,
        applyTCP: self.applyTCP,
        applyPSC: self.applyPSC
      };
      if (!self.isValid(request)) {
        return;
      }
      request.effectiveStart = request.effectiveStart.format('YYYY-MM-DD HH:mm:ss');
      request.effectiveEnd = request.effectiveEnd.format('YYYY-MM-DD HH:mm:ss');
      if (request.interval === 'weekly') {
        request.monthlyAnchor = null;
      }
      if (request.interval === 'monthly') {
        request.weeklyAnchor = null;
      }

      var url = '/admin/providerdeduction';
      if (self.id !== null) {
        url = url + '/' + self.id;
      }

      self.submitLoading = true;
      self.$sdk.post(url, request, function (r) {
        console.log(r);
        self.submitLoading = false;
        if (r.error) {
          self.error = {
            show: true,
            message: r.error.message
          };
          return;
        }

        self.$store.commit('providerDeductions/setDeductionListReload', true);
        self.$store.commit('providerDeductions/setDeductionFormShow', false);
      });
    }
  }
});

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'deduction-list',
  props: ['isMobile'],
  computed: {
    loading: function loading() {
      return this.$store.state.providerDeductions.deductionList.loading;
    },
    items: function items() {
      return this.$store.state.providerDeductions.deductionList.items;
    },
    reload: function reload() {
      return this.$store.state.providerDeductions.deductionList.reload;
    }
  },
  methods: {
    openForm: function openForm(item) {
      this.$store.commit('providerDeductions/setDeductionFormId', item === null ? null : item.id);
      this.$store.commit('providerDeductions/setDeductionFormName', item === null ? '' : item.name);
      this.$store.commit('providerDeductions/setDeductionFormDescription', item === null ? '' : item.description);
      this.$store.commit('providerDeductions/setDeductionFormAmount', item === null ? 0 : item.amount);
      this.$store.commit('providerDeductions/setDeductionFormEffectiveStart', item === null ? null : item.effectiveStart);
      this.$store.commit('providerDeductions/setDeductionFormEffectiveEnd', item === null ? null : item.effectiveEnd);
      this.$store.commit('providerDeductions/setDeductionFormEnabled', item === null ? false : item.enabled ? true : false);
      this.$store.commit('providerDeductions/setDeductionFormApplyTNC', item === null ? false : item.applyTNC);
      this.$store.commit('providerDeductions/setDeductionFormApplyTCP', item === null ? false : item.applyTCP);
      this.$store.commit('providerDeductions/setDeductionFormApplyPSC', item === null ? false : item.applyPSC);
      this.$store.commit('providerDeductions/setDeductionFormSelectedInterval', item === null ? 'weekly' : item.interval);
      this.$store.commit('providerDeductions/setDeductionFormSelectedWeeklyAnchor', item === null ? 'monday' : item.weeklyAnchor === null ? 'monday' : item.weeklyAnchor);
      this.$store.commit('providerDeductions/setDeductionFormSelectedMonthlyAnchor', item === null ? 1 : item.monthlyAnchor === null ? 1 : item.monthlyAnchor);
      this.$store.commit('providerDeductions/setDeductionFormShow', true);
    },
    getDeductionDetails: function getDeductionDetails(item) {
      var self = this;
      if (item.interval === 'weekly') {
        return 'Deducted weekly every ' + self.ucFirst(item.weeklyAnchor) + '.';
      }
      return 'Deducted every ' + self.daySuffix(item.monthlyAnchor) + ' of the month.';
    },
    ucFirst: function ucFirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    daySuffix: function daySuffix(i) {
      var j = i % 10;
      var k = i % 100;
      if (j == 1 && k != 11) {
        return i + "st";
      }
      if (j == 2 && k != 12) {
        return i + "nd";
      }
      if (j == 3 && k != 13) {
        return i + "rd";
      }
      return i + "th";
    },
    formatItems: function formatItems(items) {
      var results = [];
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var start = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.effectiveStart.substring(0, 10) + ' ' + item.effectiveStart.substring(11, 19), 'YYYY-MM-DD HH:mm:ss');
        var end = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.effectiveEnd.substring(0, 10) + ' ' + item.effectiveEnd.substring(11, 19), 'YYYY-MM-DD HH:mm:ss');
        item.effectiveStart = start;
        item.effectiveEnd = end;
        results.push(item);
      }
      return results;
    },
    loadItems: function loadItems() {
      var self = this;
      self.$store.commit('providerDeductions/setDeductionListLoading', true);
      self.$sdk.get('/admin/providerdeduction', {
        token: self.$store.state.session.sessionToken,
        deleted: 0,
        order: 'created',
        orderAsc: 0
      }, function (r) {
        self.$store.commit('providerDeductions/setDeductionListLoading', false);
        if (r.error) {
          self.$store.commit('providerDeductions/setDeductionListItems', []);
          return;
        }
        self.$store.commit('providerDeductions/setDeductionListItems', self.formatItems(r.list));
        self.$store.commit('providerDeductions/setDeductionListReload', false);
      });
    },
    showDelete: function showDelete(item) {
      this.$store.commit('providerDeductions/setDeductionDeleteShow', true);
      this.$store.commit('providerDeductions/setDeductionDeleteItem', item);
    }
  },
  watch: {
    reload: function reload(value) {
      if (!value) {
        return;
      }
      this.loadItems();
    }
  },
  mounted: function mounted() {
    this.loadItems();
  }
});

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_provider_payouts__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_featureToggle__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'provider-payouts',
  data: function data() {
    return {
      now: __WEBPACK_IMPORTED_MODULE_0_moment___default()(),
      filter: {
        weeks: [],
        selectedWeek: null
      },
      topup: {
        loading: false,
        message: '',
        showSuccess: false
      },
      autodeposit: {
        loading: false,
        message: '',
        showSuccess: false
      },
      er: {
        loading: false,
        pending: 0,
        available: 0,
        reserved: 0
      },
      fct: {
        loading: false,
        pending: 0,
        available: 0,
        reserved: 0
      },
      total: {
        loading: false,
        isOpenBatch: false,
        openBatch: {
          credits: {
            count: [],
            amount: 0
          },
          debits: {
            count: [],
            amount: 0
          }
        },
        check: {
          paid: {
            count: 0,
            amount: 0
          },
          pending: {
            count: 0,
            amount: 0
          },
          in_transit: {
            count: 0,
            amount: 0
          },
          canceled: {
            count: 0,
            amount: 0
          },
          failed: {
            count: 0,
            amount: 0
          }
        },
        er: {
          paid: {
            count: 0,
            amount: 0
          },
          pending: {
            count: 0,
            amount: 0
          },
          in_transit: {
            count: 0,
            amount: 0
          },
          canceled: {
            count: 0,
            amount: 0
          },
          failed: {
            count: 0,
            amount: 0
          }
        },
        fct: {
          paid: {
            count: 0,
            amount: 0
          },
          pending: {
            count: 0,
            amount: 0
          },
          in_transit: {
            count: 0,
            amount: 0
          },
          canceled: {
            count: 0,
            amount: 0
          },
          failed: {
            count: 0,
            amount: 0
          }
        }
      },
      provBatch: {
        date: '',
        data: {},
        filteredData: [],
        show: false,
        loading: false,
        title: '',
        type: ''
      }
    };
  },

  computed: {
    stripeConfig: function stripeConfig() {
      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.Stripe;
    },
    requiredER: function requiredER() {
      var self = this;
      if (self.total.er.pending.amount === 0) {
        return 0;
      }
      if (self.er.available > self.total.er.pending.amount) {
        return 0;
      }

      return self.total.er.pending.amount - self.er.available;
    },
    requiredFCT: function requiredFCT() {
      var self = this;
      if (self.total.fct.pending.amount === 0) {
        return 0;
      }
      if (self.fct.available > self.total.fct.pending.amount) {
        return 0;
      }

      return self.total.fct.pending.amount - self.fct.available;
    }
  },
  methods: {
    init: function init() {
      var self = this;
      var start = __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('isoweek');
      var end = __WEBPACK_IMPORTED_MODULE_0_moment___default()(start).endOf('isoweek');
      self.filter.weeks = [];
      self.filter.weeks.push({
        start: start,
        end: end
      });
      self.filter.selectedWeek = self.filter.weeks[0];
      var current = __WEBPACK_IMPORTED_MODULE_0_moment___default()(start).startOf('isoweek');
      for (var i = 0; i < 7; i++) {
        var startWeek = __WEBPACK_IMPORTED_MODULE_0_moment___default()(current).subtract(1, 'd').startOf('isoweek');
        var endWeek = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startWeek).endOf('isoweek');
        current = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startWeek);

        self.filter.weeks.push({
          start: startWeek,
          end: endWeek
        });
      }
      self.getBalances();
      self.getPayouts();
    },
    refresh: function refresh() {
      this.getBalances();
      this.getPayouts();
    },
    getBalances: function getBalances() {
      var self = this;
      var token = self.$store.state.session.sessionToken;

      self.er = {
        loading: true,
        pending: 0,
        available: 0,
        reserved: 0
      };
      __WEBPACK_IMPORTED_MODULE_1__modules_api_provider_payouts__["a" /* default */].getBalance(self, { token: token, execRide: true }, function (r) {
        self.er.loading = false;
        if (r.error) {
          return;
        }

        var available = 0;
        for (var i = 0; i < r.result.available.length; i++) {
          available += r.result.available[i].amount;
        }
        self.er.available = available / 100;

        var pending = 0;
        for (var _i = 0; _i < r.result.pending.length; _i++) {
          pending += r.result.pending[_i].amount;
        }
        self.er.pending = pending / 100;

        var reserved = 0;
        for (var _i2 = 0; _i2 < r.result.connect_reserved.length; _i2++) {
          reserved += r.result.connect_reserved[_i2].amount;
        }
        self.er.reserved = reserved / 100;
      });

      self.fct = {
        loading: true,
        pending: 0,
        available: 0,
        reserved: 0
      };
      __WEBPACK_IMPORTED_MODULE_1__modules_api_provider_payouts__["a" /* default */].getBalance(self, { token: token, firstClass: true }, function (r) {
        self.fct.loading = false;
        if (r.error) {
          return;
        }

        var available = 0;
        for (var i = 0; i < r.result.available.length; i++) {
          available += r.result.available[i].amount;
        }
        self.fct.available = available / 100;

        var pending = 0;
        for (var _i3 = 0; _i3 < r.result.pending.length; _i3++) {
          pending += r.result.pending[_i3].amount;
        }
        self.fct.pending = pending / 100;

        var reserved = 0;
        for (var _i4 = 0; _i4 < r.result.connect_reserved.length; _i4++) {
          reserved += r.result.connect_reserved[_i4].amount;
        }
        self.fct.reserved = reserved / 100;
      });
    },
    getPayouts: function getPayouts() {
      var self = this;

      self.total.loading = true;
      self.total.check = {
        paid: { count: 0, amount: 0 },
        pending: { count: 0, amount: 0 },
        in_transit: { count: 0, amount: 0 },
        canceled: { count: 0, amount: 0 },
        failed: { count: 0, amount: 0 }
      };
      self.total.er = {
        paid: { count: 0, amount: 0 },
        pending: { count: 0, amount: 0 },
        in_transit: { count: 0, amount: 0 },
        canceled: { count: 0, amount: 0 },
        failed: { count: 0, amount: 0 }
      };
      self.total.fct = {
        paid: { count: 0, amount: 0 },
        pending: { count: 0, amount: 0 },
        in_transit: { count: 0, amount: 0 },
        canceled: { count: 0, amount: 0 },
        failed: { count: 0, amount: 0 }
      };
      if (self.filter.selectedWeek.start.isSame(self.filter.weeks[0].start)) {
        self.total.isOpenBatch = true;
        self.getTransactions();
        return;
      }

      self.total.isOpenBatch = false;
      __WEBPACK_IMPORTED_MODULE_1__modules_api_provider_payouts__["a" /* default */].getTotal(self, {
        token: self.$store.state.session.sessionToken,
        since: self.filter.selectedWeek.start.format('YYYY-MM-DD'),
        until: self.filter.selectedWeek.end.format('YYYY-MM-DD')
      }, function (r) {
        self.total.loading = false;
        if (r.error) {
          return;
        }
        self.total.check = r.check;
        self.total.er = r.execRide;
        self.total.fct = r.firstClass;
      });
    },
    getTransactions: function getTransactions() {
      var self = this;
      self.total.openBatch = {
        credits: {
          count: [],
          amount: 0
        },
        debits: {
          count: [],
          amount: 0
        }
      };
      __WEBPACK_IMPORTED_MODULE_1__modules_api_provider_payouts__["a" /* default */].getTransactions(self, {
        token: self.$store.state.session.sessionToken,
        since: self.filter.selectedWeek.start.format('YYYY-MM-DD'),
        until: self.filter.selectedWeek.end.format('YYYY-MM-DD'),
        deleted: 0,
        payoutBatchId: null
      }, function (r) {
        self.total.loading = false;
        if (r.error) {
          return;
        }
        for (var i = 0; i < r.list.length; i++) {
          var item = r.list[i];
          if (item.type === 'debit') {
            if (self.total.openBatch.debits.count.indexOf(item.contactId) < 0) {
              self.total.openBatch.debits.count.push(item.contactId);
            }
            self.total.openBatch.debits.amount += item.amount;
            continue;
          }
          if (self.total.openBatch.credits.count.indexOf(item.contactId) < 0) {
            self.total.openBatch.credits.count.push(item.contactId);
          }
          self.total.openBatch.credits.amount += item.amount;
        }
      });
    },
    createTopup: function createTopup(isExecRide) {
      var self = this;
      var request = {
        token: self.$store.state.session.sessionToken,
        amount: 0,
        currency: 'usd',
        description: 'Top-up for driver payout.',
        metadata: {
          batchStart: self.filter.selectedWeek.start.format('MM/DD/YYYY'),
          batchEnd: self.filter.selectedWeek.end.format('MM/DD/YYYY')
        },
        statementDescriptor: 'Stripe Top-up'
      };
      var amount = 0;

      if (isExecRide) {
        amount = parseInt(parseFloat((self.requiredER * 100).toFixed(2)), 10);
        console.log(self.requiredER);
        request['execRide'] = true;
      } else {
        amount = parseInt(parseFloat((self.requiredFCT * 100).toFixed(2)), 10);
        request['firstClass'] = true;
      }

      if (amount <= 0) {
        return;
      }
      request.amount = amount;
      self.topup.showSuccess = false;
      self.topup.loading = true;
      self.topup.message = 'Sending funds to ' + (isExecRide ? 'Executive Ride...' : 'First Class Transportation...');
      __WEBPACK_IMPORTED_MODULE_1__modules_api_provider_payouts__["a" /* default */].createTopup(self, request, function (r) {
        console.log(r);
        self.topup.loading = false;
        self.topup.message = '';
        if (r.error) {
          // show error message
          return;
        }

        self.topup.showSuccess = true;
        self.refresh();
      });
    },
    startAutodeposit: function startAutodeposit(execRide) {
      var self = this;

      self.autodeposit.showSuccess = false;
      self.autodeposit.loading = true;
      self.autodeposit.message = 'Sending payment to driver accounts...';

      var ids = self.total.fct.pending.ids;
      if (execRide) {
        ids = self.total.er.pending.ids;
      }

      __WEBPACK_IMPORTED_MODULE_1__modules_api_provider_payouts__["a" /* default */].startAutodeposit(self, {
        token: self.$store.state.session.sessionToken,
        execRide: execRide,
        ids: ids
      }, function (r) {
        console.log(r);
        self.autodeposit.showSuccess = true;
        self.autodeposit.loading = false;
        self.autodeposit.message = '';
        if (r.error) {
          return;
        }
        self.refresh();
      });
    },
    showProviders: function showProviders(data, title, type) {
      var self = this;
      var since = self.filter.selectedWeek.start.format('YYYY-MM-DD');
      var until = self.filter.selectedWeek.end.format('YYYY-MM-DD');

      self.provBatch.show = true;
      self.provBatch.loading = true;
      self.provBatch.filteredData = [];
      self.provBatch.title = title;
      self.provBatch.type = type;

      if (self.provBatch.date === since + '--' + until) {
        self.getProviderInfo(data);
        return;
      }

      __WEBPACK_IMPORTED_MODULE_1__modules_api_provider_payouts__["a" /* default */].getProviderBatch(self, {
        token: self.$store.state.session.sessionToken,
        since: since,
        until: until
      }, function (r) {
        if (!r.error) {
          self.provBatch.date = since + '--' + until;
          self.provBatch.data = r.list;

          self.getProviderInfo(data);
        }
      });
    },
    getProviderInfo: function getProviderInfo(data) {
      var self = this;
      var provIDs = [];

      data.ids.forEach(function (id) {
        provIDs.push(self.provBatch.data.find(function (x) {
          return x.id === id;
        }).contactId);
      });

      self.$sdk.get('/provider', {
        token: self.$store.state.session.sessionToken,
        ids: provIDs
      }, function (r) {
        self.provBatch.loading = false;
        r.list.forEach(function (prov) {
          var phone = prov.phone;
          self.provBatch.filteredData.push({
            id: prov.ID,
            name: prov.firstName + ' ' + prov.lastName,
            lastLogin: __WEBPACK_IMPORTED_MODULE_0_moment___default()(prov.lastLogin, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_2__modules_api_featureToggle__["a" /* default */].timeFormat(self, false)),
            email: prov.email,
            phone: prov.countryCode + '' + prov.phone,
            licenseType: prov.providerAccountType
          });
        });
      });
    }
  },
  mounted: function mounted() {
    this.init();
    if (!this.$store.state.session.user.access.hasOwnProperty('PageAdminDriverBatchModifications')) {
      this.$router.push('/thispagedoesnotexist');
      return;
    }
  }
});

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */

var request = __webpack_require__(13);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'provider-print-placard',
  components: {},
  data: function data() {
    return {
      // frontUrl: 'https://stage-opoli-uploads.s3.us-west-2.amazonaws.com/dc5df0cc-060c-4540-b070-f54e7207aecf.png',
      // backUrl: 'https://stage-opoli-uploads.s3.us-west-2.amazonaws.com/efa120d1-f4cd-4152-a1a8-e2ecfbde8840.png',
      // frontUrl: 'https://staging-backoffice.s3.us-west-2.amazonaws.com/staging/front-old.png', // OPOLI
      // backUrl: 'https://staging-backoffice.s3.us-west-2.amazonaws.com/staging/back.png', // OPOLI
      frontUrl: 'https://prod-opoli-app.s3.us-west-2.amazonaws.com/email/placard-front.png', // PTS RS
      backUrl: 'https://prod-opoli-app.s3.us-west-2.amazonaws.com/email/placard-back.png', // PTS RS
      qrUrl: '',
      qrLoading: false,
      issueDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM/DD/YYYY'),
      issueActive: false,
      license: '',
      driverID: '',
      driverActive: false
    };
  },

  computed: {
    provId: function provId() {
      return this.$route.params.id;
    }
  },
  methods: {
    generateQR: function generateQR() {
      var self = this;
      var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.issueDate, 'MM/DD/YYYY').format('YYYYMMDD');
      var code = 'TNC;PrimeTimeRideshare;34171;LSO-009455;' + self.license + ';' + self.driverID + ';' + date;

      self.qrLoading = true;
      request.get({
        url: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.mediaHost + '/api/qr?text=' + code,
        json: true
      }, function (err, res, body) {
        self.qrLoading = false;
        if (err) {
          console.log(err);
          return;
        }
        self.qrUrl = body.image;
      });
    },
    showIssueInput: function showIssueInput() {
      var self = this;
      self.issueActive = true;
      self.$nextTick(function () {
        self.$refs.issueInput.focus();
      });
    },
    issueUpdate: function issueUpdate() {
      this.issueActive = false;
      this.generateQR();
    },
    showDriverInput: function showDriverInput() {
      var self = this;
      self.driverActive = true;
      self.$nextTick(function () {
        self.$refs.driverInput.focus();
      });
    },
    driverUpdate: function driverUpdate() {
      this.driverActive = false;
      this.generateQR();
    }
  },
  mounted: function mounted() {
    this.driverID = this.$route.params.id;
    if (this.$route.query) {
      this.license = this.$route.query.license;
    }
    this.generateQR();

    // document.getElementsByClassName("phone-app").style.display = 'none'
  }
});

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__values_map_pin__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_api_reservations__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_api_reservation_details_dispatch__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_api_reservation_details_add__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_api_location__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Edit__ = __webpack_require__(1778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__BasicInformation__ = __webpack_require__(1795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Transactions__ = __webpack_require__(1801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SystemLogs__ = __webpack_require__(1805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DispatchLogs__ = __webpack_require__(1809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Notes__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Partials_LoadingModal__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_api_featureToggle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_api_driver_release__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Dispatch_ReadyToGoModal__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ActionLogs__ = __webpack_require__(1817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_api_services__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__AsapModal__ = __webpack_require__(1824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__App_NotificationModal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__App_SMSModal__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__App_CancelUpcomingModal__ = __webpack_require__(1828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__modules_api_currency__ = __webpack_require__(165);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */

// import mapSettings from '@/values/map-settings'




// import ApiRsvpEdit from '@/modules/api/reservation-details/edit'




















var request = __webpack_require__(13);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reservation-details',
  components: {
    basicInformation: __WEBPACK_IMPORTED_MODULE_11__BasicInformation__["a" /* default */], editReservation: __WEBPACK_IMPORTED_MODULE_10__Edit__["a" /* default */], transactions: __WEBPACK_IMPORTED_MODULE_12__Transactions__["a" /* default */], notes: __WEBPACK_IMPORTED_MODULE_15__Notes__["a" /* default */],
    systemLogs: __WEBPACK_IMPORTED_MODULE_13__SystemLogs__["a" /* default */], loadingModal: __WEBPACK_IMPORTED_MODULE_16__Partials_LoadingModal__["a" /* default */], ReadyToGoModal: __WEBPACK_IMPORTED_MODULE_19__components_Dispatch_ReadyToGoModal__["a" /* default */], actionLogs: __WEBPACK_IMPORTED_MODULE_20__ActionLogs__["a" /* default */], AsapModal: __WEBPACK_IMPORTED_MODULE_22__AsapModal__["a" /* default */], dispatchLogs: __WEBPACK_IMPORTED_MODULE_14__DispatchLogs__["a" /* default */],
    notificationModal: __WEBPACK_IMPORTED_MODULE_23__App_NotificationModal__["a" /* default */], smsModal: __WEBPACK_IMPORTED_MODULE_24__App_SMSModal__["a" /* default */], cancelUpcomingModal: __WEBPACK_IMPORTED_MODULE_25__App_CancelUpcomingModal__["a" /* default */]
  },
  data: function data() {
    return {
      hereMaps: {
        map: {},
        platform: {},
        router: {},
        geocoder: {},
        directions: [],
        ui: {}
      },
      center: { lat: 33.942791, lng: -118.410042 }, // LAX coords
      rsvpInMap: null,
      driverInMap: null,
      mapLoader: {
        show: false,
        label: ''
      },
      infoWindows: [],
      activeTab: {
        left: 0,
        right: 0
      },
      loading: false,
      loadingMsg: 'Loading',
      flightStatusLoading: false,
      flightStatusError: false,
      releasingDriver: false,
      releaseSuccess: false,
      editEnabled: false,
      lastSeleted: '',
      release: {
        loading: false,
        showContent: false,
        fee: 0,
        charge: 1,
        error: {
          show: false,
          message: ''
        }
      },
      users: {
        input: '',
        list: [],
        loading: false,
        pageNum: 1,
        pageSize: 10
      },
      corporate: {
        input: '',
        list: [],
        loading: false,
        pageNum: 1,
        pageSize: 10
      },
      extraPins: [],
      extraPinsPath: [],
      completedPath: [],
      cancelData: [],
      showRightPanel: true,
      showIconLog: true,
      renderFix: true,
      isAsapRsvp: false,
      timerDelay: '',
      dispatchStatusX: '',
      customEmailRecipient: '',
      customEmailFieldError: '',
      customEmailLoading: false,
      noRelog: false,
      showMapMobile: false,
      lastRsvpId: '',
      mtechData: {
        id: '',
        loading: false
      },
      xcurrency: __WEBPACK_IMPORTED_MODULE_26__modules_api_currency__["a" /* default */],
      overrideModal: {
        show: false,
        value: ''
      }
    };
  },

  computed: {
    dispatches: function dispatches() {
      return this.$store.state.rsvpDetails.dispatchLogs.length;
    },
    rsvpId: function rsvpId() {
      return this.$route.params.id;
    },
    driverId: function driverId() {
      return this.$store.state.rsvpDetails.basicInfo.driverInfo.id;
    },
    rsvpStatus: function rsvpStatus() {
      var rsvpDetails = this.$store.state.rsvpDetails.basicInfo.tripInfo;
      var trx = this.$store.state.rsvpDetails.transactionList;
      var status = {
        class: rsvpDetails.status,
        label: rsvpDetails.status
      };
      if (status.label === 'ready' || rsvpDetails.bidStatus === 'ready') {
        status.class = 'ready';
        status.label = 'Ready to go';
      }
      if (status.label === 'onboard') {
        status.label = 'On Board';
      }
      if (rsvpDetails.bidStatus === 'dispatched') {
        status = {
          class: rsvpDetails.bidStatus,
          label: rsvpDetails.bidStatus
        };
      }
      if (rsvpDetails.bidStatus === 'requires_dispatch') {
        status = {
          class: 'requires-dispatch',
          label: 'Requires Dispatch'
        };
      }
      if (rsvpDetails.bidStatus === 'autodispatch') {
        status = {
          class: 'auto-dispatch',
          label: 'Auto Dispatch'
        };
      }
      if (rsvpDetails.status === 'complete') {
        status = {
          class: 'complete',
          label: 'completed'
        };
      }
      if (rsvpDetails.status === 'canceled') {
        status = {
          class: rsvpDetails.status,
          label: rsvpDetails.status
        };
        if (trx.length && trx[0].transactionType === 'CONVERT_CREDIT' && trx[0].notes !== 'RECLAIMED') {
          this.editEnabled = false;
          status = {
            class: 'open-credit',
            label: 'Open Credit'
          };
        }
      }
      return status;
    },
    rsvpDetails: function rsvpDetails() {
      return this.$store.state.rsvpDetails.basicInfo;
    },
    showBreakdownPayment: function showBreakdownPayment() {
      return this.$store.state.rsvpDetails.showPaymentBreakdown;
    },
    showFlightStatus: function showFlightStatus() {
      return this.$store.state.rsvpDetails.showFlightStatus;
    },
    driverPaymentBreakdown: function driverPaymentBreakdown() {
      var tripInfo = this.$store.state.rsvpDetails.basicInfo.tripInfo;
      var fare = tripInfo.driverPayment;
      if (parseFloat(tripInfo.overridePayment) > 0) {
        fare = tripInfo.overridePayment;
      }
      if (parseFloat(tripInfo.paymentBonus) > 0) {
        fare = tripInfo.basePay;
      }
      return {
        fare: this.toFixed(fare),
        bonus: this.toFixed(tripInfo.driverBonus),
        tip: this.toFixed(tripInfo.tip),
        gasFee: this.toFixed(tripInfo.gasFee),
        pickupFee: this.toFixed(tripInfo.pickupFee),
        paymentBonus: this.toFixed(tripInfo.paymentBonus)
      };
    },
    isPackage: function isPackage() {
      return this.$store.state.rsvpDetails.basicInfo.tripInfo.packageId || false;
    },
    showCancelButton: function showCancelButton() {
      var rsvpDetails = this.$store.state.rsvpDetails.basicInfo.tripInfo;
      if (this.lyft.show) {
        if (['dispatched', 'onboard'].indexOf(rsvpDetails.bidStatus) > -1) return true;
      }
      return rsvpDetails.bidStatus !== 'dispatched' && this.rsvpStatus.class !== 'complete' && this.rsvpStatus.class !== 'canceled' && this.rsvpStatus.class !== 'open-credit';
    },
    flightStatus: function flightStatus() {
      return this.$store.state.rsvpDetails.flightStatus;
    },
    showButtons: function showButtons() {
      return ['canceled', 'open-credit'].indexOf(this.rsvpStatus.class) === -1 || ['canceled', 'open-credit'].indexOf(this.rsvpStatus.class) > -1 && this.activeTab.left === 2;
    },
    sendEmail: function sendEmail() {
      return this.$store.state.rsvpDetails.sendEmail;
    },
    sendNoShow: function sendNoShow() {
      return this.$store.state.rsvpDetails.sendNoShow;
    },
    showReleaseModal: function showReleaseModal() {
      return this.$store.state.rsvpDetails.showReleaseModal;
    },
    rsvpAction: function rsvpAction() {
      return this.$store.state.rsvpDetails.rsvpAction;
    },
    rsvpEditLocation: function rsvpEditLocation() {
      var rsvpEdit = this.$store.state.rsvpDetails.edit.details;
      return {
        id: rsvpEdit.tripInfo.id,
        pickup: rsvpEdit.tripInfo.pickup,
        dropoff: rsvpEdit.tripInfo.dropoff
      };
    },
    rsvpEditSubmit: function rsvpEditSubmit() {
      return this.$store.state.rsvpDetails.edit.showUpdateReturn;
    },
    rsvpEditIsSaving: function rsvpEditIsSaving() {
      return this.$store.state.rsvpDetails.edit.isSaving;
    },
    isAirportPickup: function isAirportPickup() {
      return this.$store.state.rsvpDetails.edit.details.tripInfo.isAirportPickup;
    },
    isAirportDropoff: function isAirportDropoff() {
      var tripInfo = this.$store.state.rsvpDetails.basicInfo.tripInfo;
      return tripInfo.isAirportDropoff && !tripInfo.isAirportPickup;
    },
    suggestedTimeShow: function suggestedTimeShow() {
      return this.$store.state.rsvpDetails.edit.suggestedTime.show;
    },
    _airline: function _airline() {
      return this.$store.state.rsvpDetails.edit.details.tripInfo.airline;
    },
    _flightNo: function _flightNo() {
      return this.$store.state.rsvpDetails.edit.details.tripInfo.flightNo;
    },
    _pickupDate: function _pickupDate() {
      return this.$store.state.rsvpDetails.edit.details.tripInfo.pickupDate;
    },
    _selectedService: function _selectedService() {
      return this.$store.state.rsvpDetails.edit.selectedService;
    },
    isNewRsvp: function isNewRsvp() {
      if (this.$store.state.rsvpDetails.isAdd) {
        this.showIconLog = false;
      }
      return this.$store.state.rsvpDetails.isAdd;
    },
    showSelectUser: function showSelectUser() {
      return this.$store.state.rsvpDetails.showSelectUser;
    },
    showSelectCorporate: function showSelectCorporate() {
      return this.$store.state.rsvpDetails.showSelectCorporate;
    },
    createRsvpLoading: function createRsvpLoading() {
      return this.$store.state.rsvpDetails.addLoading;
    },
    showAsapModal: function showAsapModal() {
      return this.$store.state.rsvpDetails.asap.show;
    },
    asapEnable: function asapEnable() {
      return this.$store.state.rsvpDetails.asap.enable;
    },
    asapLoading: function asapLoading() {
      return this.$store.state.rsvpDetails.asap.loading;
    },
    asapNoDriver: function asapNoDriver() {
      return this.$store.state.rsvpDetails.asap.noDriver;
    },
    asapDriverInfoLoading: function asapDriverInfoLoading() {
      return this.$store.state.rsvpDetails.asap.driverInfoLoading;
    },
    asapDriverInfo: function asapDriverInfo() {
      return this.$store.state.rsvpDetails.asap.driverInfo;
    },
    createError: function createError() {
      return this.$store.state.rsvpDetails.submitError;
    },
    showRTGButton: function showRTGButton() {
      return ['upcoming', 'Requires Dispatch', 'dispatched'].indexOf(this.rsvpStatus.label) > -1 && !this.isPackage && this.rsvpDetails.tripInfo.pickup.geofenceType === 'airport';
    },
    editAccess: function editAccess() {
      return this.$store.state.session.user.access.hasOwnProperty('PageAdminRSVPEdit');
    },
    noteAccess: function noteAccess() {
      return this.$store.state.session.user.access.hasOwnProperty('PageAdminNotes');
    },
    hasOngoingCall: function hasOngoingCall() {
      return this.$store.state.phone.ongoing;
    },
    iconToggleRightPanel: function iconToggleRightPanel() {
      return this.showRightPanel ? 'fa fa-clipboard-list fa-2x' : 'fas fa-times fa-2x';
    },
    servicesLoading: function servicesLoading() {
      return this.$store.state.services.servicesLoading;
    },
    dispatchStatus: function dispatchStatus() {
      if (this.rsvpStatus.class === 'dispatched') {
        if (['ontheway', 'arrived'].indexOf(this.rsvpDetails.tripInfo.status) > -1) {
          return 'on-time';
        }

        var pickupTime = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.rsvpDetails.tripInfo.pickupDate, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_17__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
        var pickupTime1 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateCriticalMins'), 'minutes').format('X'));
        var pickupTime115 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateWarningMins'), 'minutes').format('X'));
        var currentTime = parseInt(__WEBPACK_IMPORTED_MODULE_4_moment___default()().format('X'));
        if (pickupTime1 <= currentTime) {
          return 'very-late';
        }
        if (pickupTime115 <= currentTime) {
          return 'late';
        }
        if (this.rsvpDetails.tripInfo.status === 'upcoming') {
          return 'accepted';
        }
      }
      return '';
    },
    emailRecipientModal: function emailRecipientModal() {
      return this.$store.state.rsvpDetails.emailRecipient;
    },
    extraStops: function extraStops() {
      return this.$store.state.rsvpDetails.edit.details.tripInfo.extraStops;
    },
    extraStops2: function extraStops2() {
      return this.$store.state.rsvpDetails.extraStops;
    },
    totalExtraStops: function totalExtraStops() {
      return 10;
    },
    _updateMap: function _updateMap() {
      return this.$store.state.rsvpDetails.updateMap;
    },
    isTerminal: function isTerminal() {
      return this.$store.state.rsvpDetails.isTerminal;
    },
    tripInfo: function tripInfo() {
      return this.$store.state.rsvpDetails.basicInfo.tripInfo;
    },
    optin: function optin() {
      return this.$store.state.rsvpDetails.optin;
    },

    optinModal: {
      get: function get() {
        return this.optin.showModal;
      },
      set: function set(x) {
        this.$store.commit('rsvpDetails/setOptinData', { showModal: x });
      }
    },
    hasRSVPControl: function hasRSVPControl() {
      return this.$store.state.session.user.access.hasOwnProperty('PageAdminRsvpControl');
    },
    currency: function currency() {
      return this.$store.state.rsvpDetails.currency;
    },
    useLocalCurrency: function useLocalCurrency() {
      return this.$store.state.rsvpDetails.useLocalCurrency;
    },
    trackLink: function trackLink() {
      var _this = this;

      var brand = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.find(function (x) {
        return x.id == _this.tripInfo.brandId;
      });
      return brand.url + '?id=' + this.rsvpId + '&fname=' + encodeURI(this.rsvpDetails.customerInfo.firstName) + '&lname=' + encodeURI(this.rsvpDetails.customerInfo.lastName) + '#/search-track-direct';
    },
    lyft: function lyft() {
      return this.$store.state.rsvpDetails.lyft;
    },
    lyftStore: function lyftStore() {
      return this.$store.state.lyft;
    },
    allowOverridePayment: function allowOverridePayment() {
      return this.$store.state.session.user.access.hasOwnProperty('ForceDriverPaymentOverride') && ({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.lyftServiceIds.indexOf(this.tripInfo.serviceTypeId) > -1 || this.lyft.show || {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.Env === 'production' && [272203, 263021].indexOf(this.rsvpDetails.driverInfo.id) > -1 || {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.Env !== 'production' && [5116].indexOf(this.rsvpDetails.driverInfo.id) > -1);
    },
    totalDriverPayment: function totalDriverPayment() {
      var tripInfo = this.$store.state.rsvpDetails.basicInfo.tripInfo;
      var driverPayment = tripInfo.driverPayment;
      if (parseFloat(tripInfo.overridePayment) > 0) {
        driverPayment = tripInfo.overridePayment;
      }
      return this.toFixed(driverPayment + tripInfo.driverBonus + tripInfo.tip + tripInfo.pickupFee + tripInfo.gasFee);
    }
  },
  methods: {
    sendSMS: function sendSMS() {
      if (this.$refs.sms.showSMSForm()) {
        this.$refs.sms.showSMSForm();
      }
    },
    showNotif: function showNotif() {
      if (this.$refs.notif.showNotifForm()) {
        this.$refs.notif.showNotifForm();
      }
    },
    init: function init() {
      var self = this;
      self.driverInMap = null;
      self.infoWindows = [];
      self.extraPins = [];
      self.extraPinsPath = [];
      self.completedPath = [];
      self.cancelData = [];
      self.editEnabled = false;
      self.loading = true;
      self.$store.commit('rsvpDetails/resetBasicInfo');

      if (self.$refs.HPickup.editMode(false)) {
        self.$refs.HPickup.editMode(false);
      }
      if (self.$refs.HDropoff.editMode(false)) {
        self.$refs.HDropoff.editMode(false);
      }

      __WEBPACK_IMPORTED_MODULE_6__modules_api_reservations__["a" /* default */].getRsvpData(self, self.$route.params.id, function (res) {
        self.isAsapRsvp = res.isAsap;
        if (res.error) {
          self.loading = false;
          self.$router.push({ name: 'MissingPage' });
          return;
        }

        if (res.hasExtraStop) {
          self.getExtraStops(res);
          return;
        }

        self.loading = false;
        self.getAirportList();
        self.mtechData.id = '';
        if (res.isMTech) self.getMtechData();
        self.getLyftServices();
        // self.getLyftData()
        setTimeout(function () {
          self.showPinLocation(res);
        }, 600);
      });
    },
    getExtraStops: function getExtraStops(resData) {
      var self = this;

      self.$sdk.get('/admin/rsvp/' + self.rsvpId + '/extrastops', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.loading = false;
        var pins = resData;
        if (!r.error) {
          if (r.list.length) {
            pins.extraStops = [];
          }
          r.list.forEach(function (stop) {
            stop.id = stop.stopIndex;
            pins.extraStops.push(stop);
          });
          self.$store.commit('rsvpDetails/setExtraStops', pins.extraStops);
        }
        self.getAirportList();
        setTimeout(function () {
          self.showPinLocation(pins);
        }, 600);
      });
    },
    toggleRightPanel: function toggleRightPanel() {
      this.showRightPanel = !this.showRightPanel;
      if (!this.showRightPanel && this.lastRsvpId !== this.rsvpId) {
        this.lastRsvpId = this.rsvpId;
        if (this.$refs.actionLogs.init()) {
          this.$refs.actionLogs.init();
        }
      }
    },
    switchTab: function switchTab(tab, index) {
      if (tab === 'left' && this.editEnabled && (index === 1 || index === 2)) {
        return;
      }
      this.activeTab[tab] = index;
    },
    closeBreakdown: function closeBreakdown() {
      this.$store.commit('rsvpDetails/setShowPaymentBreakdown', false);
    },
    closeFlightStatus: function closeFlightStatus() {
      this.$store.commit('rsvpDetails/setShowFlightStatus', false);
    },
    getLatLng: function getLatLng(location) {
      return {
        lat: parseFloat(location.lat),
        lng: parseFloat(location.lng)
      };
    },
    updateFlightStatus: function updateFlightStatus() {
      var self = this;

      var rsvpDetails = self.$store.state.rsvpDetails;
      var flightStatus = rsvpDetails.flightStatus.status;
      var flightManual = rsvpDetails.flightManual;
      if (flightStatus === '' || flightStatus === null || flightManual) {
        self.$store.commit('rsvpDetails/setFlightManual', true);
        self.$store.commit('rsvpDetails/setFlightStatus', {
          status: 'Scheduled',
          // departureAirport: res.departure.airportName + ' (' + res.departure.airportCode + ')',
          departureAirport: 'N/A',
          arrivalAirport: 'N/A',
          arrivalTime: 'N/A'
        });
        return;
      }

      if (self.flightStatusLoading) {
        return;
      }
      self.flightStatusLoading = true;
      self.flightStatusError = false;

      var tripInfo = rsvpDetails.basicInfo.tripInfo;
      var pickupTime = __WEBPACK_IMPORTED_MODULE_4_moment___default()(tripInfo.pickupDate, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_17__modules_api_featureToggle__["a" /* default */].timeFormat(self, false));
      __WEBPACK_IMPORTED_MODULE_6__modules_api_reservations__["a" /* default */].getFlightStatus(self, {
        flightCode: tripInfo.airlineCode + tripInfo.flightNo,
        date: pickupTime.format('YYYY-MM-DD'),
        time: pickupTime.format('HH:mm:ss'),
        isDeparture: this.$store.state.rsvpDetails.basicInfo.tripInfo.isAirportPickup ? '0' : '1',
        airportCode: self.$store.state.rsvpDetails.basicInfo.tripInfo.airportCode
      }, function (res) {
        self.flightStatusLoading = false;
        if (res.error) {
          self.flightStatusError = true;
        }
      });
    },
    toFixed: function toFixed(value) {
      return parseFloat(value).toFixed(2);
    },
    AddNotes: function AddNotes() {
      this.$store.commit('reservationNotes/show', {
        rsvpId: this.$route.params.id
      });
    },
    closeEmailResult: function closeEmailResult() {
      this.$store.commit('rsvpDetails/setSendEmail', {
        show: false,
        message: ''
      });
      if (!this.noRelog) {
        window.location.reload();
      }
      this.noRelog = false;
      return;
    },
    closeNoShowResult: function closeNoShowResult() {
      var forceHide = this.$store.state.rsvpDetails.sendNoShow.forceHide;
      if (forceHide) {
        location.reload();
        return;
      }

      this.$store.commit('rsvpDetails/setSendNoShow', {
        showModal: false,
        loading: false,
        showMsg: false,
        message: '',
        forceHide: forceHide
      });
    },
    closeActionModal: function closeActionModal() {
      this.$store.commit('rsvpDetails/setRsvpAction', {
        show: false,
        message: ''
      });
    },
    closeEditSubmit: function closeEditSubmit() {
      if (this.rsvpEditSubmit.status === 'success') {
        window.location.reload();
        return;
      }

      this.$store.commit('rsvpDetails/setShowUpdateReturn', {
        show: false,
        message: '',
        status: ''
      });
    },
    cancelRsvp: function cancelRsvp() {
      if (this.rsvpDetails.tripInfo.d2dId) {
        this.$router.push('/flight/' + this.rsvpDetails.tripInfo.d2dId);
        return;
      }
      this.$store.commit('reservationNotes/setNotesModalData', {
        isLyftService: this.rsvpDetails.tripInfo.serviceType.label.toLowerCase() === 'lyft'
      });
      this.$store.commit('reservationNotes/show', {
        rsvpId: this.$route.params.id,
        action: this.$settings.config.RideCreditOffer ? 'convertCredit' : 'cancel'
      });
    },
    markAsComplete: function markAsComplete() {
      var self = this;
      if (!self.hasRSVPControl) return;

      self.$store.commit('reservationNotes/show', {
        show: true,
        rsvpId: self.rsvpId,
        isPackage: false,
        forComplete: true,
        fromRsvpDetails: true
      });
    },
    releaseDriver: function releaseDriver() {
      var self = this;
      self.releasingDriver = true;
      self.releaseSuccess = false;

      self.$sdk.delete('/admin/rsvp/' + self.rsvpId + '/driver', {
        token: self.$store.state.session.sessionToken,
        charge: self.release.charge
      }, function (r) {
        if (r.error) {
          self.releasingDriver = true;
          self.releaseSuccess = false;
          self.$store.commit('rsvpDetails/hideReleaseConfirmation');
          return;
        }
        self.init();
        self.releaseSuccess = true;
        setTimeout(function () {
          window.location.reload();
          // self.releasingDriver = false
          // self.$store.commit('rsvpDetails/hideReleaseConfirmation')
        }, 2000);
      });
    },
    toggleEdit: function toggleEdit() {
      var self = this;
      self.editEnabled = !self.editEnabled;
      self.showIconLog = !self.showIconLog;

      if (self.$refs.HPickup.editMode(!self.editEnabled)) {
        self.$refs.HPickup.editMode(!self.editEnabled);
      }
      if (self.$refs.HDropoff.editMode(!self.editEnabled)) {
        self.$refs.HDropoff.editMode(!self.editEnabled);
      }

      if (self.editEnabled) {
        var basicInfo = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.$store.state.rsvpDetails.basicInfo));
        if (basicInfo.tripInfo.pickup.title.indexOf('Apt/Gate') > -1) {
          basicInfo.tripInfo.aptGate = basicInfo.tripInfo.pickup.title.split(' Apt/Gate: ')[1];
          basicInfo.tripInfo.pickup.title = basicInfo.tripInfo.pickup.title.split(' Apt/Gate: ')[0];
        }

        if (self.$store.state.rsvpDetails.extraStops) {
          if (self.$store.state.rsvpDetails.extraStops.length) {
            basicInfo.tripInfo.extraStops = [];
            self.$store.state.rsvpDetails.extraStops.forEach(function (stop) {
              basicInfo.tripInfo.extraStops.push(stop);
            });
          }
        }

        self.$store.commit('rsvpDetails/setEditData', basicInfo);
        var tripInfo = this.$store.state.rsvpDetails.basicInfo.tripInfo;
        if (tripInfo.isCharter) {
          self.$store.commit('rsvpDetails/setCharterData', {
            enabled: true,
            pickup: tripInfo.pickup,
            startDate: tripInfo.pickupDate,
            endDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()(tripInfo.pickupDate, 'MM/DD/YYYY hh:mmA').add(tripInfo.eta, 'seconds').format('MM/DD/YYYY hh:mmA')
          });
        }

        self.$store.commit('rsvpDetails/setTimezoneLoading', true);
        __WEBPACK_IMPORTED_MODULE_9__modules_api_location__["a" /* default */].getTimezone(self, {
          lat: tripInfo.pickup.lat,
          lng: tripInfo.pickup.lng
        }, function (res) {
          // TODO: on error
          self.$store.commit('rsvpDetails/setTimezoneLoading', false);
          self.$store.commit('rsvpDetails/setTimezone', res);
        });

        if (self.$store.state.brands.list.length === 0) {
          self.$store.commit('brands/setLoading', true);
          // self.$store.commit('rsvpDetails/setBrandsLoading', true)
          self.$sdk.get('/brand', {}, function (res) {
            self.$store.commit('brands/setLoading', false);
            // self.$store.commit('rsvpDetails/setBrandsLoading', false)
            var brands = [];
            res.forEach(function (data) {
              brands.push({
                id: data.id,
                name: data.name
              });
            });
            self.$store.commit('brands/setList', brands);
            // self.$store.commit('rsvpDetails/setBrandsList', brands)
          });
        }

        self.$store.commit('rsvpDetails/setEditCurrency', {
          code: self.currency.currency,
          symbol: self.currency.symbol,
          value: self.currency.currencyRate
        });

        self.switchTab('left', 0);
        if (self.$refs.edit.init()) {
          self.$refs.edit.init();
        }

        setTimeout(function () {
          var mapData = {
            ID: tripInfo.id,
            pickupLocation: tripInfo.pickup,
            dropoffLocation: tripInfo.dropoff
          };
          self.showPinLocation(mapData);
          self.setCenter();
        }, 650);
      } else {
        setTimeout(function () {
          self.setCenter();
        }, 670);
      }
    },
    editRsvpSave: function editRsvpSave() {
      if (this.isNewRsvp) {
        if (this.$refs.edit.createRsvp()) {
          this.$refs.edit.createRsvp();
        }
        return;
      }

      if (this.$refs.edit.save()) {
        this.$refs.edit.save();
      }
    },
    getAirportList: function getAirportList() {
      var self = this;
      if (self.$store.state.airports.list.length > 0) {
        return;
      }

      self.$store.commit('airports/setLoading', true);
      self.$sdk.get('/airports', {}, function (res) {
        // TODO: if getting airports fail do something ...

        self.$store.commit('airports/setLoading', false);
        var list = [];
        res.list.forEach(function (data) {
          var add1 = data.addressLine2 === null ? data.addressLine1 : data.addressLine2;
          var add2 = data.addressLine2 === null ? '' : data.addressLine1;
          var title = add2 + ' ' + add1 + ', ' + data.city + ', ' + data.state + ' ' + data.zipCode;
          if (data.enabled) {
            list.push({
              geofenceId: data.id,
              geofenceType: 'airport',
              address1: add1,
              address2: add2,
              city: data.city,
              lat: data.lat,
              lng: data.lng,
              state: data.state,
              title: data.name || title,
              zip: data.zipCode,
              description: data.description,
              airportCode: data.airportCode,
              locationId: data.locationId
            });
          }
        });
        self.$store.commit('airports/setList', list);
      });
    },
    noShowMessage: function noShowMessage() {
      var basicInfo = this.$store.state.rsvpDetails.basicInfo;
      // let consumer = basicInfo.customerInfo
      // let provider = basicInfo.driverInfo
      var msg = this.$t('rsvpDetails.noShow.bodyConsumer');
      if (basicInfo.driverInfo.firstName) {
        msg = msg + ' ' + this.$t('rsvpDetails.noShow.bodyProvider', {
          fee: basicInfo.tripInfo.packageId ? this.$settings.config.ChainNoShowFee : this.$settings.config.ExclusiveNoShowFee
        });
      }
      msg = msg + ' ' + this.$t('rsvpDetails.noShow.bodyConfirm');

      return msg;
    },
    applyNoShow: function applyNoShow() {
      var self = this;
      self.$store.commit('rsvpDetails/setSendNoShow', {
        showModal: true,
        loading: true,
        show: false,
        message: '',
        forceHide: false
      });
      __WEBPACK_IMPORTED_MODULE_6__modules_api_reservations__["a" /* default */].sendNoShow(self, self.$store.state.rsvpDetails.rsvpId, function (res) {
        self.$store.commit('rsvpDetails/setSendNoShow', {
          showModal: true,
          loading: false,
          show: true,
          message: self.$t('rsvpDetails.noShowSent'),
          forceHide: true
        });

        if (res.error) {
          self.$store.commit('rsvpDetails/setSendNoShow', {
            showModal: true,
            loading: false,
            show: true,
            message: res.error.message,
            forceHide: false
          });
        }
      });
    },
    closeSuggestedTime: function closeSuggestedTime() {
      this.$store.commit('rsvpDetails/setSuggestedTimeShow', false);
    },
    checkSuggestedTime: function checkSuggestedTime() {
      if (!this.editEnabled) {
        return;
      }

      var edit = this.$store.state.rsvpDetails.edit;
      var rsvp = edit.details.tripInfo;

      if (rsvp.airline && rsvp.flightNo && edit.lastFlightNo && rsvp.flightNo === edit.lastFlightNo && rsvp.pickupDate && this.suggestedTime() && rsvp.pickupDate !== this.suggestedTime() && this._selectedService) {
        this.$store.commit('rsvpDetails/setSuggestedTimeShow', true);
      }
    },
    applySuggestedTime: function applySuggestedTime() {
      this.$store.commit('rsvpDetails/setPickupDate', this.suggestedTime());
      if (this.$refs.edit.updatePickupDate()) {
        this.$refs.edit.updatePickupDate();
      }
      this.closeSuggestedTime();
    },
    suggestedTime: function suggestedTime() {
      var edit = this.$store.state.rsvpDetails.edit;
      var rsvp = edit.details.tripInfo;
      if (!edit.suggestedTime.time) {
        return '';
      }

      var date = __WEBPACK_IMPORTED_MODULE_4_moment___default()(edit.suggestedTime.time, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_17__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
      if (rsvp.isAirportPickup) {
        var delay = edit.suggestedTime.isDomestic ? 'ArrivalDomesticDelay' : 'ArrivalInternationalDelay';
        date.add(this.$settings.get(delay), 'minutes');
      } else if (rsvp.isAirportDropoff) {
        var _delay = edit.suggestedTime.isDomestic ? 'DepartureDomesticBuffer' : 'DepartureInternationalBuffer';
        var eta = Math.ceil(rsvp.eta / 60);
        var btt = Math.ceil(eta * 1.15);
        if (this._selectedService === 'shared') {
          btt = Math.ceil(eta * (1 + this.$settings.get('OfferLimitThreshold') / 100));
          btt = btt - btt % 5 + 5;
        }
        var timeDelay = Math.ceil(parseFloat(this.$settings.get(_delay)));
        date.subtract(timeDelay + btt, 'minutes');
        date.subtract(parseInt(date.format('mm')) % 5, 'minutes');
      }

      return !date.isBefore(__WEBPACK_IMPORTED_MODULE_4_moment___default()().add(this.$settings.get('AdminTimeBuffer'), 'minutes')) ? date.format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_17__modules_api_featureToggle__["a" /* default */].timeFormat(this, false)) : '';
      // return this.$store.state.rsvpDetails.edit.suggestedTime.time
    },
    initNewRsvp: function initNewRsvp() {
      var self = this;

      if (self.$refs.HPickup.editMode(true)) {
        self.$refs.HPickup.editMode(true);
      }
      if (self.$refs.HDropoff.editMode(true)) {
        self.$refs.HDropoff.editMode(true);
      }

      self.editEnabled = true;
      if (self.$store.state.brands.list.length === 0) {
        self.$store.commit('brands/setLoading', true);

        self.$sdk.get('/brand', {}, function (res) {
          self.$store.commit('brands/setLoading', false);
          var brands = [];
          res.forEach(function (data) {
            brands.push({
              id: data.id,
              name: data.name
            });
          });
          self.$store.commit('brands/setList', brands);
        });
      }

      self.getAirportList();
      self.switchTab('left', 0);
      self.getCurrencyList();
    },
    closeShowSelectUser: function closeShowSelectUser() {
      this.$store.commit('rsvpDetails/setShowSelectUser', false);
    },
    closeShowSelectCorporate: function closeShowSelectCorporate() {
      this.$store.commit('rsvpDetails/setShowSelectCorporate', false);
    },
    searchUser: function searchUser() {
      var self = this;
      self.users.pageNum = 1;
      self.users.list = [];
      self.getUser();
    },
    getUser: function getUser() {
      var self = this;
      if (self.users.loading) {
        return;
      }

      self.users.loading = true;
      self.$sdk.get('/consumer', {
        token: self.$store.state.session.sessionToken,
        search: self.users.input,
        pageNum: self.users.pageNum,
        pageSize: 5
      }, function (res) {
        self.users.loading = false;
        if (!res.error) {
          if (res.list.length) {
            var users = [];
            res.list.forEach(function (user) {
              users.push({
                id: user.ID,
                firstName: user.firstName,
                lastName: user.lastName,
                email: user.email,
                mobile: user.phone,
                countryCode: user.countryCode,
                isD2d: user.d2d,
                nationalNumber: user.nationalNumber
              });
            });
            self.users.list = users;
          }
        }
      });
    },
    selectUser: function selectUser(index) {
      var users = this.users.list;
      this.$store.commit('rsvpDetails/setCustomerInfo', {
        id: users[index].id,
        firstName: users[index].firstName,
        lastName: users[index].lastName,
        email: users[index].email,
        mobile: users[index].mobile,
        countryCode: users[index].countryCode,
        nationalNumber: users[index].nationalNumber
      });

      this.$store.commit('rsvpDetails/setIsCorporate', false);
      this.getUserCards(this.users.list[index].id);
      this.closeShowSelectUser();

      if (this.$refs.edit.resetPaymentMethod()) {
        this.$refs.edit.resetPaymentMethod();
      }
    },
    getUserCards: function getUserCards(id) {
      var self = this;
      if (self.$store.state.rsvpDetails.userCard.loading) {
        return;
      }

      self.$store.commit('rsvpDetails/setUserCardLoading', true);
      __WEBPACK_IMPORTED_MODULE_8__modules_api_reservation_details_add__["a" /* default */].getCards(self, id, function (res) {
        self.$store.commit('rsvpDetails/setUserCardLoading', false);
      });
    },
    searchCorporate: function searchCorporate() {
      this.corporate.pageNum = 1;
      this.corporate.list = [];
      this.getCorporate();
    },
    getCorporate: function getCorporate() {
      var self = this;
      if (self.corporate.loading) {
        return;
      }

      self.corporate.loading = true;
      self.$sdk.get('/admin/corporateprofile', {
        token: self.$store.state.session.sessionToken,
        search: self.corporate.input,
        pageNum: self.corporate.pageNum,
        pageSize: self.corporate.pageSize
      }, function (res) {
        self.corporate.loading = false;
        if (!res.error) {
          if (res.list.length) {
            var users = [];
            res.list.forEach(function (user) {
              var displayMobile = user.contactPhone;
              if (displayMobile.indexOf('+') === -1) displayMobile = '+' + displayMobile;
              users.push({
                id: user.id,
                consId: user.customer.ID,
                firstName: user.name,
                lastName: '',
                email: user.contactEmail,
                mobile: user.contactPhone,
                countryCode: '',
                displayMobile: displayMobile,
                active: user.active
              });
            });
            self.corporate.list = users;
          }
        }
      });
    },
    selectCorporate: function selectCorporate(index) {
      var mobile = this.corporate.list[index].mobile;
      if (mobile.indexOf('+') > -1) mobile = mobile.substring(1);
      var countryCode = this.corporate.list[index].countryCode;
      if (countryCode.indexOf('+') > -1) countryCode = countryCode.substring(1);
      if (!this.corporate.list[index].active) return;
      this.$store.commit('rsvpDetails/setCustomerInfo', {
        id: this.corporate.list[index].id,
        firstName: this.corporate.list[index].firstName,
        lastName: this.corporate.list[index].lastName,
        email: this.corporate.list[index].email,
        mobile: mobile,
        countryCode: countryCode,
        consId: this.corporate.list[index].consId,
        active: this.corporate.list[index].active
      });

      this.$store.commit('rsvpDetails/setIsCorporate', true);
      this.getUserCards(this.corporate.list[index].consId);
      this.closeShowSelectCorporate();

      if (this.$refs.edit.resetPaymentMethod()) {
        this.$refs.edit.resetPaymentMethod();
      }
    },
    cancelAsap: function cancelAsap() {
      var self = this;
      self.$sdk.delete('/admin/rsvp/asap', {
        token: self.$store.state.session.sessionToken,
        brandId: self.asapBrandId,
        bidID: self.asapBidId,
        serviceType: self.asapService
      }, function (r) {
        self.$store.commit('rsvpDetails/asapReset');
      });
    },
    asapChangeService: function asapChangeService() {
      this.$store.commit('rsvpDetails/asapReset');
    },
    asapTryAgain: function asapTryAgain() {
      var self = this;
      if (self.$refs.edit.getDriver()) {
        self.$store.commit('rsvpDetails/setAsapLoading', true);
        self.$refs.edit.getDriver();
      }
    },
    closeDoneAsap: function closeDoneAsap() {
      window.location.reload();
    },
    closeCreateError: function closeCreateError() {
      this.$store.commit('rsvpDetails/setSubmitError', { show: false, message: '' });
    },
    showRTG: function showRTG(id) {
      this.$store.commit('dispatch/setReadyToGoID', id);
      this.$store.commit('dispatch/setReadyToGoShow', true);
    },
    computeHeading: function computeHeading(orig, dest) {
      var y = Math.sin(dest.lng - orig.lng) * Math.cos(dest.lat);
      var x = Math.cos(orig.lat) * Math.sin(dest.lat) - Math.sin(orig.lat) * Math.cos(dest.lat) * Math.cos(dest.lng - orig.lng);
      var brng = Math.atan2(y, x) * 180 / Math.PI;
      return Math.round(360 - (brng + 360) % 360);
    },
    extraPinIcon: function extraPinIcon(type) {
      return __WEBPACK_IMPORTED_MODULE_5__values_map_pin__["a" /* default */][type];
    },
    call: function call() {
      var self = this;
      var user = self.rsvpDetails.driverInfo;
      self.$plugins.phone.startCall(self, {
        phone: user.mobile,
        name: user.firstName + ' ' + user.lastName
      });
    },
    initMap: function initMap() {
      var self = this;
      var mapContainer = document.getElementById('mapHere');
      self.hereMaps.platform = new window.H.service.Platform({
        apikey: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key
      });

      var defaultLayers = self.hereMaps.platform.createDefaultLayers();
      self.hereMaps.map = new window.H.Map(mapContainer, defaultLayers.vector.normal.map, {
        center: self.center,
        zoom: 13,
        pixelRatio: window.devicePixelRatio || 1
      });

      /* eslint-disable no-unused-vars */
      var behavior = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(self.hereMaps.map));
      /* eslint-enable no-unused-vars */
      self.hereMaps.ui = window.H.ui.UI.createDefault(self.hereMaps.map, defaultLayers);
      window.addEventListener('resize', function () {
        return self.hereMaps.map.getViewPort().resize();
      });
    },
    showPinLocation: function showPinLocation(data) {
      var self = this;
      self.mapLoader.show = true;
      self.mapLoader.label = 'LOADING RSVP...';

      if (typeof data.dropoffLocation === 'undefined' || typeof data.pickupLocation === 'undefined') {
        self.mapLoader.show = false;
        return;
      }

      // Pickup/Dropoff icon
      var marker = '<svg height="25" width="25" style="overflow: unset" viewBox="0 0 50 50">' + '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' + 'stroke-width="{STROKE_WIDTH}" /></svg>';

      // Add Pickup Pin
      if (data.pickupLocation) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var object = _step.value;

            if (object.id === 'pickup-pin') {
              self.hereMaps.map.removeObject(object);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        self.hereMaps.ui.getBubbles().forEach(function (bub) {
          if (bub.id === 'pickup-info') {
            self.hereMaps.ui.removeBubble(bub);
          }
        });
        var pickupMarker = marker.replace('{D}', __WEBPACK_IMPORTED_MODULE_5__values_map_pin__["a" /* default */].pickup.path).replace('{FILL}', __WEBPACK_IMPORTED_MODULE_5__values_map_pin__["a" /* default */].pickup.fillColor).replace('{STROKE}', __WEBPACK_IMPORTED_MODULE_5__values_map_pin__["a" /* default */].pickup.strokeColor).replace('{STROKE_WIDTH}', __WEBPACK_IMPORTED_MODULE_5__values_map_pin__["a" /* default */].pickup.strokeWeight);
        var pickupIcon = new window.H.map.DomIcon(pickupMarker);
        var pickupCoords = { lat: data.pickupLocation.lat, lng: data.pickupLocation.lng };
        var pickupPin = new window.H.map.DomMarker(pickupCoords, { icon: pickupIcon });
        pickupPin.id = 'pickup-pin';

        self.infoWindows.push({
          lat: data.pickupLocation.lat,
          lng: data.pickupLocation.lng,
          type: 'pickup',
          opened: false
        });

        self.hereMaps.ui.getBubbles().forEach(function (bub) {
          if (bub.id === 'pickup-info') {
            self.hereMaps.ui.removeBubble(bub);
          }
        });
        if (!self.editEnabled) {
          var infoWindow = document.getElementById('HPickup');
          var pickupBubble = new window.H.ui.InfoBubble(pickupCoords, { content: infoWindow });
          pickupBubble.id = 'pickup-info';
          self.hereMaps.ui.addBubble(pickupBubble);
          self.hereMaps.ui.getBubbles().forEach(function (bub) {
            if (bub.id === 'pickup-info') {
              bub.addClass('pickup-info');
            }
          });
          pickupPin.addEventListener('tap', function (evt) {
            pickupBubble.open();
          }, false);
        }
        self.hereMaps.map.addObject(pickupPin);
      }

      // Add ExtraStop Pin
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _object = _step2.value;

          if (_object.id === 'extraStop-pin') {
            self.hereMaps.map.removeObject(_object);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      self.hereMaps.ui.getBubbles().forEach(function (bub) {
        if (bub.id === 'extraStop-info') {
          self.hereMaps.ui.removeBubble(bub);
        }
      });
      if (data.extraStops) {
        data.extraStops.forEach(function (stop, index) {
          var extraStopMarker = marker.replace('{D}', __WEBPACK_IMPORTED_MODULE_5__values_map_pin__["a" /* default */].stop.path).replace('{FILL}', __WEBPACK_IMPORTED_MODULE_5__values_map_pin__["a" /* default */].stop.fillColor).replace('{STROKE}', __WEBPACK_IMPORTED_MODULE_5__values_map_pin__["a" /* default */].stop.strokeColor).replace('{STROKE_WIDTH}', __WEBPACK_IMPORTED_MODULE_5__values_map_pin__["a" /* default */].stop.strokeWeight);
          var extraStopIcon = new window.H.map.DomIcon(extraStopMarker);
          var extraStopCoords = { lat: stop.lat, lng: stop.lng };
          var extraStopPin = new window.H.map.DomMarker(extraStopCoords, { icon: extraStopIcon });
          extraStopPin.id = 'extraStop-pin';

          self.infoWindows.push({
            lat: stop.lat,
            lng: stop.lng,
            type: 'extraStop',
            opened: false
          });

          self.hereMaps.ui.getBubbles().forEach(function (bub) {
            if (bub.id === 'extraStop-info') {
              self.hereMaps.ui.removeBubble(bub);
            }
          });
          if (!self.editEnabled) {
            var _infoWindow = document.getElementById('HExtraStop' + index);
            var extraStopBubble = new window.H.ui.InfoBubble(extraStopCoords, { content: _infoWindow });
            extraStopBubble.id = 'extraStop-info';
            self.hereMaps.ui.addBubble(extraStopBubble);
            self.hereMaps.ui.getBubbles().forEach(function (bub) {
              if (bub.id === 'extraStop-info') {
                bub.addClass('extraStop-info');
              }
            });
            extraStopPin.addEventListener('tap', function (evt) {
              extraStopBubble.open();
            }, false);
          }
          self.hereMaps.map.addObject(extraStopPin);
        });
      }

      // Add Dropoff Pin
      if (data.dropoffLocation && !self.tripInfo.isCharter) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _object2 = _step3.value;

            if (_object2.id === 'dropoff-pin') {
              self.hereMaps.map.removeObject(_object2);
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        self.hereMaps.ui.getBubbles().forEach(function (bub) {
          if (bub.id === 'dropoff-info') {
            self.hereMaps.ui.removeBubble(bub);
          }
        });
        var dropoffMarker = marker.replace('{D}', __WEBPACK_IMPORTED_MODULE_5__values_map_pin__["a" /* default */].dropoff.path).replace('{FILL}', __WEBPACK_IMPORTED_MODULE_5__values_map_pin__["a" /* default */].dropoff.fillColor).replace('{STROKE}', __WEBPACK_IMPORTED_MODULE_5__values_map_pin__["a" /* default */].dropoff.strokeColor).replace('{STROKE_WIDTH}', __WEBPACK_IMPORTED_MODULE_5__values_map_pin__["a" /* default */].dropoff.strokeWeight);
        var dropoffIcon = new window.H.map.DomIcon(dropoffMarker);
        var dropoffCoords = { lat: data.dropoffLocation.lat, lng: data.dropoffLocation.lng };
        var dropoffPin = new window.H.map.DomMarker(dropoffCoords, { icon: dropoffIcon });
        dropoffPin.id = 'dropoff-pin';

        self.hereMaps.ui.getBubbles().forEach(function (bub) {
          if (bub.id === 'dropoff-info') {
            self.hereMaps.ui.removeBubble(bub);
          }
        });
        if (!self.editEnabled) {
          var infoWindow2 = document.getElementById('HDropoff');
          var dropoffBubble = new window.H.ui.InfoBubble(dropoffCoords, { content: infoWindow2 });
          dropoffBubble.id = 'dropoff-info';
          self.hereMaps.ui.addBubble(dropoffBubble);
          self.hereMaps.ui.getBubbles().forEach(function (bub) {
            if (bub.id === 'dropoff-info') {
              bub.addClass('dropoff-info');
            }
          });
          dropoffPin.addEventListener('tap', function (evt) {
            dropoffBubble.open();
          }, false);
        }
        self.hereMaps.map.addObject(dropoffPin);
        self.infoWindows.push({
          lat: data.dropoffLocation.lat,
          lng: data.dropoffLocation.lng,
          type: 'dropoff',
          opened: false
        });
        self.infoWindows.push({
          lat: 0,
          lng: 0,
          opened: false
        });
      }

      if (data.pickupLocation && data.dropoffLocation) {
        var extra = { type: 'rsvpRoute' };
        if (data.extraStops) {
          extra.stops = [];
          data.extraStops.forEach(function (stop) {
            extra.stops.push(stop);
          });
        }
        self.calculateRoute(data.pickupLocation, data.dropoffLocation, extra);
      }
    },
    addMarker: function addMarker(data, type) {
      var self = this;
      if (type === 'car') {
        if (['canceled', 'complete'].indexOf(self.rsvpDetails.tripInfo.status) > -1) {
          // remove current
          return;
        }
        var marker = '<div class="here-pin car"><img src="{CAR_URL}" style="transform: rotate({DEGREE}deg)"/></div>';
        var carMarker = marker.replace('{CAR_URL}', 'https://mobile-consumer-app.s3-us-west-2.amazonaws.com/maps/car.png').replace('{DEGREE}', data.heading);
        var pickupIcon = new window.H.map.DomIcon(carMarker);
        var coords = { lat: data.lat, lng: data.lng };
        var pin = new window.H.map.DomMarker(coords, { icon: pickupIcon });

        // Added delay bec. i keep getting old data of infoWindows
        setTimeout(function () {
          var infoIndex = self.infoWindows.findIndex(function (x) {
            return x.type === 'vehicle';
          });
          var eta = '';
          if (self.infoWindows[infoIndex].eta) {
            eta = ', ' + self.infoWindows[infoIndex].eta + ' minutes away';
          }
          var data = {
            driverInfo: self.rsvpDetails.driverInfo,
            driverPhoto: self.rsvpDetails.driverInfo.photo,
            driverUrl: '/#/provider/' + self.rsvpDetails.driverInfo.id,
            driverName: self.rsvpDetails.driverInfo.firstName + ' ' + self.rsvpDetails.driverInfo.lastName,
            distance: self.infoWindows[infoIndex].distance + ' miles',
            eta: eta,
            vehiclePhoto: self.rsvpDetails.driverInfo.vehiclePhoto,
            model: self.rsvpDetails.driverInfo.make + ' ' + self.rsvpDetails.driverInfo.model,
            license: self.rsvpDetails.driverInfo.licensePlate,
            call: self.$t('dispatch.driverCall', { driverName: self.rsvpDetails.driverInfo.firstName })
          };
          if (self.$refs.HCar.update(data)) {
            self.$refs.HCar.update(data);
          }
          var infoWindow = document.getElementById('HCar');
          var carBubble = new window.H.ui.InfoBubble(coords, { content: infoWindow });
          carBubble.id = 'car-info';
          self.hereMaps.ui.addBubble(carBubble);
          pin.addEventListener('tap', function (evt) {
            carBubble.open();
          }, false);
          self.hereMaps.map.addObject(pin);
          self.hereMaps.ui.getBubbles().forEach(function (bub) {
            if (bub.id === 'car-info') {
              bub.addClass('car-info');
            }
          });
        }, 1500);
      }
      if (type === 'extra') {
        var _marker = '<svg height="25" width="25" style="overflow: unset" viewBox="0 0 50 50">' + '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' + 'stroke-width="{STROKE_WIDTH}" /></svg>';
        var _carMarker = _marker.replace('{D}', __WEBPACK_IMPORTED_MODULE_5__values_map_pin__["a" /* default */][data.status].path).replace('{FILL}', __WEBPACK_IMPORTED_MODULE_5__values_map_pin__["a" /* default */][data.status].fillColor).replace('{STROKE}', __WEBPACK_IMPORTED_MODULE_5__values_map_pin__["a" /* default */][data.status].strokeColor).replace('{STROKE_WIDTH}', __WEBPACK_IMPORTED_MODULE_5__values_map_pin__["a" /* default */][data.status].strokeWeight);
        var carIcon = new window.H.map.DomIcon(_carMarker);
        var _coords = { lat: data.lat, lng: data.lng };
        var extraPin = new window.H.map.DomMarker(_coords, { icon: carIcon });
        extraPin.id = data.status;
        var infoWindow = '<div class="here-info-window extra">\n          <div><label>{LABEL}: </label><span>{VALUE}</span></div>\n          {ONBOARD}\n        </div>';
        var label = '';
        if (data.status === 'ontheway') {
          label = 'On The Way';
        }
        if (data.status === 'arrived') {
          label = 'Arrived';
        }
        if (data.status === 'completed') {
          label = 'Completed';
        }
        var onboard = '';
        if (self.rsvpDetails.tripInfo.onboard && data.status === 'arrived') {
          onboard = '<div><label>On Board: </label><span>' + self.rsvpDetails.tripInfo.onboard + '</span></div>';
        }
        infoWindow = infoWindow.replace('{LABEL}', label).replace('{VALUE}', data.created).replace('{ONBOARD}', onboard);
        var extraBubble = new window.H.ui.InfoBubble(_coords, {
          content: infoWindow
        });
        extraBubble.id = 'extra-info';
        self.hereMaps.ui.addBubble(extraBubble);
        self.hereMaps.ui.getBubbles().forEach(function (bub) {
          if (bub.id === 'extra-info') {
            bub.addClass('extra-info');
          }
        });
        extraPin.addEventListener('tap', function (evt) {
          extraBubble.open();
        }, false);
        if (!data.opened) {
          extraBubble.close();
        }
        self.hereMaps.map.addObject(extraPin);
      }
    },
    calculateRoute: function calculateRoute(origin, destination, extraData) {
      var self = this;

      if (extraData.type === 'rsvpRoute') {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var object = _step4.value;

            if (object.id === 'rsvpRoute') {
              self.hereMaps.map.removeObject(object);
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }

      if (extraData.stops && extraData.stops.length) {
        var url = 'https://router.hereapi.com/v8/routes?apiKey={API_KEY}&origin={ORIGIN}&destination={DESTINATION}&transportMode=car&return=polyline,summary';
        url = url.replace('{ORIGIN}', origin.lat + ',' + origin.lng).replace('{DESTINATION}', destination.lat + ',' + destination.lng).replace('{API_KEY}', {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key);
        extraData.stops.forEach(function (stop) {
          url += '&via=' + stop.lat + ',' + stop.lng;
        });
        request.get({
          url: url,
          json: true
        }, function (err, res, body) {
          if (err) {
            self.onCalculateError(err);
            return;
          }
          if (!body.routes.length) return;
          if (body.routes.length) {
            body.routes[0].sections.forEach(function (route) {
              self.addRouteShapeToMap(route, extraData);
            });
          }
        });
        return;
      }
      var router = self.hereMaps.platform.getRoutingService(null, 8);
      var routeRequestParams = {
        routingMode: 'fast',
        transportMode: 'car',
        origin: origin.lat + ',' + origin.lng,
        destination: destination.lat + ',' + destination.lng,
        return: 'polyline,turnByTurnActions,actions,instructions,travelSummary'
      };
      router.calculateRoute(routeRequestParams, self.onCalculateSuccess.bind(null, extraData), self.onCalculateError);
    },
    onCalculateSuccess: function onCalculateSuccess(extraData, result) {
      if (result.routes.length) {
        var route = result.routes[0].sections[0];
        if (extraData.type === 'driverRoute') {
          if (this.$refs.HCar) {
            this.$refs.HCar.updateField({
              field: 'distance',
              value: Math.ceil(route.travelSummary.length / 1609) + ' miles'
            });
          }
        }
        this.addRouteShapeToMap(route, extraData);
      }
    },
    onCalculateError: function onCalculateError(data) {
      console.error('ROUTING ERROR--', data);
    },
    addRouteShapeToMap: function addRouteShapeToMap(route, extraData) {
      var self = this;

      var strokeColor = '#333333';
      if (extraData.type === 'driverRoute') {
        strokeColor = '#0D79F2';
      }
      if (extraData.type === 'extraRoute') {
        strokeColor = '#e57511';
      }
      if (extraData.type === 'completedRoute') {
        strokeColor = '#26D97A';
      }

      var linestring = window.H.geo.LineString.fromFlexiblePolyline(route.polyline);
      var polyline = new window.H.map.Polyline(linestring, {
        style: {
          lineWidth: 3,
          strokeColor: strokeColor
        }
      });
      polyline.id = extraData.type;

      this.hereMaps.map.addObject(polyline);
      this.hereMaps.map.getViewModel().setLookAtData({
        bounds: polyline.getBoundingBox()
      });

      this.setCenter();
    },
    setCenter: function setCenter() {
      var self = this;
      var group = new window.H.map.Group();

      // remove duplicate pin bound
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var object = _step5.value;

          if (object.id === 'driverRoute' || object.id === 'groupBound' || object.icon && object.icon.c && object.icon.c.id === 'H_car_icon') {
            self.hereMaps.map.removeObject(object);
          }
        }

        // Create object with radius for better bounds
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var groupObject = [];
      var editRsvpDetails = this.$store.state.rsvpDetails.edit.details.tripInfo;
      if (self.editEnabled && editRsvpDetails.pickup.lat) {
        groupObject.push(new window.H.map.Circle(new window.H.geo.Point(editRsvpDetails.pickup.lat, editRsvpDetails.pickup.lng), 3500, {
          style: {
            fillColor: 'rgba(0, 0, 0, 0)',
            strokeColor: 'rgba(0, 0, 0, 0)'
          }
        }));
      } else if (self.rsvpDetails.tripInfo.pickup.lat) {
        groupObject.push(new window.H.map.Circle(new window.H.geo.Point(self.rsvpDetails.tripInfo.pickup.lat, self.rsvpDetails.tripInfo.pickup.lng), 3500, {
          style: {
            fillColor: 'rgba(0, 0, 0, 0)',
            strokeColor: 'rgba(0, 0, 0, 0)'
          }
        }));
      }
      if (self.editEnabled) {
        if (editRsvpDetails.extraStops) {
          if (editRsvpDetails.extraStops.length) {
            editRsvpDetails.extraStops.forEach(function (stop) {
              if (stop.lat && stop.lng) {
                groupObject.push(new window.H.map.Circle(new window.H.geo.Point(stop.lat, stop.lng), 3500, {
                  style: {
                    fillColor: 'rgba(0, 0, 0, 0)',
                    strokeColor: 'rgba(0, 0, 0, 0)'
                  }
                }));
              }
            });
          }
        }
      } else {
        if (self.$store.state.rsvpDetails.extraStops && self.$store.state.rsvpDetails.extraStops.length) {
          self.$store.state.rsvpDetails.extraStops.forEach(function (stop) {
            if (stop.lat && stop.lng) {
              groupObject.push(new window.H.map.Circle(new window.H.geo.Point(stop.lat, stop.lng), 3500, {
                style: {
                  fillColor: 'rgba(0, 0, 0, 0)',
                  strokeColor: 'rgba(0, 0, 0, 0)'
                }
              }));
            }
          });
        }
      }
      if (self.editEnabled && editRsvpDetails.dropoff.lat) {
        groupObject.push(new window.H.map.Circle(new window.H.geo.Point(editRsvpDetails.dropoff.lat, editRsvpDetails.dropoff.lng), 3500, {
          style: {
            fillColor: 'rgba(0, 0, 0, 0)',
            strokeColor: 'rgba(0, 0, 0, 0)'
          }
        }));
      } else if (self.rsvpDetails.tripInfo.dropoff.lat) {
        groupObject.push(new window.H.map.Circle(new window.H.geo.Point(self.rsvpDetails.tripInfo.dropoff.lat, self.rsvpDetails.tripInfo.dropoff.lng), 3500, {
          style: {
            fillColor: 'rgba(0, 0, 0, 0)',
            strokeColor: 'rgba(0, 0, 0, 0)'
          }
        }));
      }

      // Add to group for bounds correction
      if (groupObject.length) {
        group.addObjects(groupObject);
        group.id = 'groupBound';
        self.hereMaps.map.addObject(group);

        self.hereMaps.map.getViewModel().setLookAtData({
          bounds: group.getBoundingBox()
        });
        self.mapLoader.show = false;
      }
    },
    saveNotes: function saveNotes(id) {
      if (this.$refs.edit.saveNotes(id)) {
        this.$refs.edit.saveNotes(id);
      }
    },
    dispatchStatusChecker: function dispatchStatusChecker() {
      if (this.rsvpStatus.class === 'dispatched') {
        if (['ontheway', 'arrived'].indexOf(this.rsvpDetails.tripInfo.status) > -1) {
          this.dispatchStatusX = 'on-time';
          return;
        }

        var pickupTime = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.rsvpDetails.tripInfo.pickupDate, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_17__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
        var pickupTime1 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateCriticalMins'), 'minutes').format('X'));
        var pickupTime115 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateWarningMins'), 'minutes').format('X'));
        var currentTime = parseInt(__WEBPACK_IMPORTED_MODULE_4_moment___default()().format('X'));
        if (pickupTime1 <= currentTime) {
          this.dispatchStatusX = 'very-late';
          return;
        }
        if (pickupTime115 <= currentTime) {
          this.dispatchStatusX = 'late';
          return;
        }
        if (this.rsvpDetails.tripInfo.status === 'upcoming') {
          this.dispatchStatusX = 'accepted';
          return;
        }
      }
    },
    runTimer: function runTimer() {
      var self = this;
      var rsvp = self.rsvpDetails.tripInfo;
      var pickupTime = __WEBPACK_IMPORTED_MODULE_4_moment___default()(rsvp.pickupDate, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_17__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
      var currentTime = parseInt(__WEBPACK_IMPORTED_MODULE_4_moment___default()().format('X'));

      if (self.rsvpStatus.class === 'dispatched') {
        var pickupTime1 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateCriticalMins'), 'minutes').format('X'));
        var pickupTime115 = parseInt(pickupTime.clone().subtract(this.$settings.get('DispatchLateWarningMins'), 'minutes').format('X'));
        if (pickupTime1 <= currentTime || pickupTime115 <= currentTime) {
          self.$nextTick(function () {
            self.dispatchStatusChecker();
          });
        }
      }

      if (self.timerDelay) {
        clearTimeout(self.timerDelay);
      }
      self.timerDelay = setTimeout(function () {
        self.runTimer();
      }, 5000);
    },
    closeEmailRecipientModal: function closeEmailRecipientModal() {
      if (this.customEmailLoading) {
        return;
      }
      this.customEmailRecipient = '';
      this.$store.commit('rsvpDetails/setEmailRecipientField', {
        field: 'show',
        value: false
      });
    },
    emailRecipientSelect: function emailRecipientSelect(target) {
      this.$store.commit('rsvpDetails/setEmailRecipientField', {
        field: 'selected',
        value: target
      });
    },
    updateCustomEmailRecipient: function updateCustomEmailRecipient() {
      if (this.emailRecipientModal.selected === 'custom') {
        this.$store.commit('rsvpDetails/setEmailRecipientField', {
          field: 'email',
          value: this.customEmailRecipient
        });
      }
    },
    submitEmailRecipient: function submitEmailRecipient() {
      if (this.customEmailLoading) {
        return;
      }
      var self = this;
      if (self.emailRecipientModal.selected === 'custom') {
        if (!self.customEmailRecipient) {
          self.customEmailFieldError = 'This field cannot be empty.';
          return;
        }
        var emailFormat = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
        if (!emailFormat.test(self.customEmailRecipient)) {
          self.customEmailFieldError = 'Invalid email format.';
          return;
        }
      }

      self.customEmailLoading = true;
      self.$sdk.post('/admin/rsvp/' + self.$store.state.rsvpDetails.rsvpId + '/email', {
        token: self.$store.state.session.sessionToken,
        email: self.emailRecipientModal.email
      }, function (res) {
        self.customEmailFieldError = '';
        self.customEmailLoading = false;
        self.$store.commit('rsvpDetails/setEmailRecipientField', {
          field: 'show',
          value: false
        });

        self.noRelog = true;
        if (res.error) {
          self.$store.commit('rsvpDetails/setSendEmail', {
            show: true,
            message: res.error.message
          });
        } else {
          self.$store.commit('rsvpDetails/setSendEmail', {
            show: true,
            message: self.$t('rsvpDetails.emailSent')
          });
        }
      });
    },
    optinServiceConvert: function optinServiceConvert(x) {
      var self = this;
      var msg = 'Converting back to exclusive service.';
      var url = '/admin/rsvp/' + self.rsvpId + '/optin/exclusive';
      if (x === 'exclusive') {
        msg = 'Converting to shared service.';
        url = '/admin/rsvp/' + self.rsvpId + '/optin/shared';
      }

      self.optinModal = false;
      self.$store.commit('global/setLoaderData', {
        show: true,
        message: msg
      });
      self.$sdk.post(url, { token: self.$store.state.session.sessionToken }, function (r) {
        self.$store.commit('global/setLoaderData', { show: false });
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          return;
        }
        location.reload();
      });
    },
    getMtechData: function getMtechData() {
      var self = this;

      self.mtechData.loading = true;
      self.$sdk.get('/admin/rsvp/' + self.rsvpId + '/mtech', {
        token: self.$store.state.session.sessionToken
      }, function (res) {
        self.mtechData.loading = false;
        if (!res.error) {
          self.mtechData.id = res.mtechId;
        }
      }, '1.1');
    },
    applyCurrency: function applyCurrency(x) {
      x = parseFloat(x);
      x = x * this.currency.currencyRate;
      // return `${this.currency.symbol}${x.toFixed(2)}`
      return __WEBPACK_IMPORTED_MODULE_26__modules_api_currency__["a" /* default */].format({
        code: this.currency.currency,
        val: x.toFixed(2)
      });
    },
    getCurrencyList: function getCurrencyList() {
      var self = this;
      self.$store.commit('global/setLoaderData', { show: true, message: '' });

      __WEBPACK_IMPORTED_MODULE_6__modules_api_reservations__["a" /* default */].getCurrencyList(self, function () {
        self.$store.commit('global/setLoaderData', { show: false, message: '' });
        self.$store.commit('rsvpDetails/setEditCurrency', {
          code: 'USD',
          symbol: '$',
          value: 1
        });
        if (self.$refs.edit.initNewRsvp()) {
          self.$refs.edit.initNewRsvp();
        }
      }, {});
    },
    getLyftServices: function getLyftServices() {
      var self = this;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(self.lyftStore.services).length) {
        self.getLyftData();
        return;
      }
      self.$sdk.get('/service/lyft', {}, function (r) {
        if (!r.error) {
          self.$store.commit('lyft/setLyftData', { services: r });
        }
        self.getLyftData();
      }, '2.0');
    },
    getLyftData: function getLyftData() {
      var self = this;
      self.$store.commit('rsvpDetails/setLyftData', { show: false });
      self.$sdk.get('/admin/rsvp/' + self.rsvpId + '/lyft', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error || !r.rideId) return;
        if (!r.lyft) {
          self.$store.commit('rsvpDetails/setLyftData', {
            show: true,
            date: '',
            rideId: r.rideId || '',
            rideType: r.rideType || '',
            driver: {}
          });
          return;
        }

        self.$store.commit('rsvpDetails/setLyftData', {
          show: true,
          date: r.lyft && r.lyft.createdUTC ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(r.lyft.createdUTC).format('MM/DD/YYYY hh:mmA') : '',
          rideId: r.rideId || r.lyft.rideId,
          rideType: r.rideType || r.lyft.rideType,
          driver: r.lyft && r.lyft.driver && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(r.lyft.driver).length ? r.lyft.driver : {},
          routeUrl: r.lyft && r.lyft.route_url ? r.lyft.route_url : ''
        });
      }, '1.1');
    },
    showOverrideModal: function showOverrideModal() {
      this.closeBreakdown();
      this.overrideModal.show = true;
    },
    backToPaymentBreakdown: function backToPaymentBreakdown() {
      this.$store.commit('rsvpDetails/setShowPaymentBreakdown', value);
      this.overrideModal.show = false;
      this.overrideModal.value = '';
    },
    submitDriverPaymentOverride: function submitDriverPaymentOverride() {
      var self = this;
      if (self.overrideModal.value === '') {
        self.$store.commit('global/setAlertData', {
          show: true,
          message: 'Price override cannot be empty.'
        });
        return;
      }
      self.$store.commit('global/setLoaderData', { show: true });
      self.overrideModal.show = false;
      self.$sdk.get('/utils/dp', {
        rsvpId: self.rsvpId,
        amount: self.overrideModal.value
      }, function (r) {
        if (r.error) {
          self.$store.commit('global/setLoaderData', { show: false });
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          self.overrideModal.show = true;
          return;
        }
        window.location.reload();
      }, '');
    }
  },
  watch: {
    editEnabled: function editEnabled(val) {
      var self = this;
      if (!val) {
        self.showIconLog = true;
      }

      setTimeout(function () {
        self.hereMaps.map.getViewPort().resize();
      }, 600);
    },
    showReleaseModal: function showReleaseModal(val) {
      if (!val) {
        return;
      }

      var self = this;
      if (self.release.loading) {
        return;
      }

      self.release.loading = true;
      self.release.showContent = false;
      self.release.error.show = false;
      self.release.charge = 1;

      __WEBPACK_IMPORTED_MODULE_18__modules_api_driver_release__["a" /* default */].getReleaseFee(self, {
        id: self.rsvpId,
        type: 'rsvp'
      }, function (r) {
        self.release.loading = false;

        if (r.error) {
          self.release.error.show = true;
          self.release.error.message = r.error.message;
          return;
        }

        self.release.fee = parseFloat(r.Charge);
        if (self.release.fee === 0) {
          self.release.charge = 0;
        }
        self.release.showContent = true;
      });
    },
    showFlightStatus: function showFlightStatus(value) {
      if (!value) {
        return;
      }
      this.updateFlightStatus();
    },
    rsvpId: function rsvpId(value) {
      var self = this;
      this.$store.commit('rsvpDetails/setSuggestedTime', '');
      this.$store.commit('rsvpDetails/setCharterData', { enabled: false });
      this.mtechData.id = '';
      if (value !== 'new') {
        this.$store.commit('rsvpDetails/setIsAdd', false);
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var object = _step6.value;

            self.hereMaps.map.removeObject(object);
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }

        self.hereMaps.ui.getBubbles().forEach(function (bub) {
          self.hereMaps.ui.removeBubble(bub);
        });
        this.init();

        if (!this.showRightPanel && this.lastRsvpId != value) {
          this.lastRsvpId = value;
          if (this.$refs.actionLogs.init()) {
            this.$refs.actionLogs.init();
          }
        }
      } else {
        window.location.reload();
        this.$store.commit('rsvpDetails/setIsAdd', true);
        // this.initNewRsvp()
      }
    },
    rsvpAction: function rsvpAction(value) {
      if (value.show) {
        this.init();
        if (this.$refs.notes.init()) {
          this.$refs.notes.init();
        }
        if (this.$refs.transactions.init()) {
          this.$refs.transactions.init();
        }
      }
    },
    rsvpEditLocation: function rsvpEditLocation(value) {
      var self = this;
      if (self.editEnabled) {
        var mapData = {
          ID: value.id,
          pickupLocation: value.pickup,
          dropoffLocation: value.dropoff
        };
        if (self.extraStops) {
          if (self.extraStops.length) {
            mapData.extraStops = [];
            self.extraStops.forEach(function (stop) {
              mapData.extraStops.push(stop);
            });
          }
        }
        self.showPinLocation(mapData);
        // self.setCenter()
      }
    },
    suggestedTime: function suggestedTime(value) {
      this.checkSuggestedTime();
    },
    _flightNo: function _flightNo(value) {
      this.checkSuggestedTime();
    },
    _selectedService: function _selectedService(value) {
      var currentSelected = value === 'shared';
      if (this.lastSeleted !== currentSelected) {
        this.lastSeleted = currentSelected;
        this.checkSuggestedTime();
      }
    },
    rtgSuccess: function rtgSuccess(value) {
      if (value) {
        this.$store.commit('dispatch/setReadyToGoSuccess', false);
        location.reload();
      }
    },
    rsvpDetails: function rsvpDetails(value) {
      var self = this;

      // Render fix
      self.renderFix = false;
      self.$nextTick(function () {
        self.renderFix = true;
        self.dispatchStatusChecker();
      });

      self.hereMaps.ui.getBubbles().forEach(function (bub) {
        self.hereMaps.ui.removeBubble(bub);
      });

      if (value && value.tripInfo.id !== '') {
        var tripInfo = value.tripInfo;
        var session = self.$store.state.session;

        var destination = { lat: tripInfo.pickup.lat, lng: tripInfo.pickup.lng, target: 'pickup' };
        if (tripInfo.status === 'onboard') {
          destination = { lat: tripInfo.dropoff.lat, lng: tripInfo.dropoff.lng, target: 'dropoff' };
        }

        var dateFormat = 'MM/DD/YYYY hh:mmA';
        dateFormat = self.$settings.get('MilitaryTimeBackoffice') === '1' ? 'MM/DD/YYYY HH:mm' : 'MM/DD/YYYY hh:mmA';

        if (tripInfo.bidStatus === 'dispatched' && ['upcoming', 'ontheway', 'arrived'].indexOf(tripInfo.status) > -1 || ['onboard', 'complete'].indexOf(tripInfo.status) > -1) {
          self.$sdk.get('/provider/' + value.driverInfo.id + '/tracks', { token: session.sessionToken }, function (res) {
            if (!res.error && res.list.length) {
              self.driverInMap = { lat: res.list[0].lat, lng: res.list[0].lng };
              if (self.infoWindows[2]) {
                self.infoWindows.splice(2, 1);
              }
              self.infoWindows.push({
                lat: res.list[0].lat,
                lng: res.list[0].lng,
                type: 'vehicle',
                opened: true,
                distance: 0
              });

              var heading = null;
              if (res.list[0].heading !== null) {
                heading = parseInt(res.list[0].heading);
              }
              if (isNaN(heading) || heading < 0 || heading > 359) {
                if (self.rsvpStatus !== 'ONBOARD' && self.driverInMap && self.rsvpInMap && self.rsvpInMap.pickup) {
                  heading = self.computeHeading(self.driverInMap, self.rsvpInMap.pickup);
                } else if (self.driverInMap && self.rsvpInMap && self.rsvpInMap.dropoff) {
                  heading = self.computeHeading(self.driverInMap, self.rsvpInMap.dropoff);
                }
              }
              self.calculateRoute(self.driverInMap, destination, { type: 'driverRoute', pathOnly: false, etaOnly: false });
              res.list[0].heading = heading - 90;
              self.addMarker(res.list[0], 'car');

              if (self.infoWindows[2]) {
                self.infoWindows[2].lat = res.list[0].lat;
                self.infoWindows[2].lng = res.list[0].lng;
                self.infoWindows[2].type = 'vehicle';
              }

              if (['canceled', 'complete'].indexOf(tripInfo.status) > -1) {
                self.infoWindows.splice(2, 1);
              }
            }
          });
        }

        if (tripInfo.bidStatus === 'dispatched' && ['ontheway', 'arrived'].indexOf(tripInfo.status) > -1 || ['onboard', 'complete'].indexOf(tripInfo.status) > -1) {
          self.$sdk.get('/admin/rsvp/' + self.rsvpId + '/locations', { token: session.sessionToken }, function (res) {
            if (!res.error && res.list.length) {
              self.extraPins = [];
              res.list.forEach(function (data) {
                data.created = __WEBPACK_IMPORTED_MODULE_4_moment___default()(data.created, 'YYYY-MM-DD@HH:mm:ss').format(dateFormat);
                data.opened = false;
                if (data.status !== 'onboard') {
                  if (data.lat !== 0 && data.lng !== 0) {
                    self.extraPins.push(data);
                  }
                }
              });
              var tmpPins = [];
              if (tripInfo.status === 'ontheway') {
                var otwIndex = res.list.findIndex(function (x) {
                  return x.status === 'ontheway';
                });
                tmpPins.push(res.list[otwIndex]);
              }
              if (tripInfo.status === 'arrived') {
                var _otwIndex = res.list.findIndex(function (x) {
                  return x.status === 'ontheway';
                });
                var arrivedIndex = res.list.findIndex(function (x) {
                  return x.status === 'arrived';
                });
                tmpPins.push(res.list[_otwIndex]);
                tmpPins.push(res.list[arrivedIndex]);
              }
              if (tripInfo.status === 'onboard') {
                var _otwIndex2 = res.list.findIndex(function (x) {
                  return x.status === 'ontheway';
                });
                var _arrivedIndex = res.list.findIndex(function (x) {
                  return x.status === 'arrived';
                });
                tmpPins.push(res.list[_otwIndex2]);
                tmpPins.push(res.list[_arrivedIndex]);
              }
              if (tripInfo.status === 'complete') {
                tmpPins = self.extraPins;
              }
              self.extraPins = tmpPins;

              var heading = null;
              if (res.list[0].heading !== null) {
                heading = parseInt(res.list[0].heading);
              }
              if (isNaN(heading) || heading < 0 || heading > 359) {
                if (self.rsvpStatus !== 'ONBOARD') {
                  heading = self.computeHeading(self.driverInMap, self.rsvpInMap.pickup);
                } else {
                  heading = self.computeHeading(self.driverInMap, self.rsvpInMap.dropoff);
                }
              }

              var showEta = ['arrived', 'complete'].indexOf(tripInfo.status) === -1;
              // let createdDate = moment(res.list[0].created, 'YYYY-MM-DD@HH:mm:ss')
              var createdDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(res.list[0].created, 'MM/DD/YYYY hh:mmA');

              if (tripInfo.status === 'onboard') {
                // self.infoWindows[0].arrived = createdDate.format(dateFormat)
              } else if (tripInfo.status === 'complete') {
                // self.infoWindows[0].arrived = moment(res.list[1].created, 'YYYY-MM-DD@HH:mm:ss').format(dateFormat)
                // self.infoWindows[0].completed = createdDate.format(dateFormat)
                self.driverInMap = null;
              }

              if (res.list.length > 1) {
                var onthewayIndex = res.list.findIndex(function (x) {
                  return x.status === 'ontheway';
                });
                var _arrivedIndex2 = res.list.findIndex(function (x) {
                  return x.status === 'arrived';
                });
                if (onthewayIndex !== -1 && _arrivedIndex2 !== -1 && tripInfo.status !== 'ontheway' && res.list[onthewayIndex].lat && res.list[onthewayIndex].lng && res.list[_arrivedIndex2].lat && res.list[_arrivedIndex2].lng) {
                  self.calculateRoute({ lat: res.list[onthewayIndex].lat, lng: res.list[onthewayIndex].lng }, { lat: res.list[_arrivedIndex2].lat, lng: res.list[_arrivedIndex2].lng }, { type: 'extraRoute', pathOnly: true, etaOnly: false });
                }
                var completedIndex = res.list.findIndex(function (x) {
                  return x.status === 'completed';
                });
                if (completedIndex !== -1 && res.list[_arrivedIndex2].lat && res.list[_arrivedIndex2].lng && res.list[completedIndex].lat && res.list[completedIndex].lng) {
                  self.calculateRoute({ lat: res.list[_arrivedIndex2].lat, lng: res.list[_arrivedIndex2].lng }, { lat: res.list[completedIndex].lat, lng: res.list[completedIndex].lng }, { type: 'completedRoute', pathOnly: true, etaOnly: false });
                }
              }

              if (['canceled', 'complete'].indexOf(tripInfo.status) > -1) {
                self.infoWindows.splice(2, 1);
              }

              if (self.extraPins.length) {
                self.extraPins[self.extraPins.length - 1].opened = true;
              }

              self.extraPins.forEach(function (pin) {
                self.addMarker(pin, 'extra');
              });
            }
          });
        }

        if (tripInfo.status === 'canceled') {
          self.$sdk.get('/admin/rsvp/' + self.rsvpId + '/locations', { token: session.sessionToken }, function (res) {
            if (!res.error && res.list.length) {
              self.extraPins = [];
              res.list.forEach(function (data) {
                var statusLabel = '';
                if (data.status === 'ontheway') {
                  statusLabel = 'PROVIDER On the way';
                }
                if (data.status === 'arrived') {
                  statusLabel = 'PROVIDER Arrived';
                }
                if (data.status === 'onboard') {
                  statusLabel = 'CONSUMER On Board';
                }

                self.cancelData.push({
                  status: data.status,
                  label: statusLabel,
                  date: __WEBPACK_IMPORTED_MODULE_4_moment___default()(data.created, 'YYYY-MM-DD@HH:mm:ss').format(dateFormat)
                });

                data.created = __WEBPACK_IMPORTED_MODULE_4_moment___default()(data.created, 'YYYY-MM-DD@HH:mm:ss').format(dateFormat);
                data.opened = false;
                if (data.status !== 'onboard') {
                  if (data.lat !== 0 && data.lng !== 0) {
                    self.extraPins.push(data);
                  }
                }
              });
              if (self.extraPins.length) {
                self.extraPins[self.extraPins.length - 1].opened = true;
              }
            }
          });
        }
      }
    },
    'emailRecipientModal.selected': function emailRecipientModalSelected(val) {
      var email = val === 'custom' ? this.customEmailRecipient : this.rsvpDetails.customerInfo.email;
      this.$store.commit('rsvpDetails/setEmailRecipientField', {
        field: 'email',
        value: email
      });
    },
    _updateMap: function _updateMap(val) {
      var self = this;
      if (val) {
        self.$store.commit('rsvpDetails/setUpdateMap', false);
        var mapData = {
          ID: self.rsvpEditLocation.id,
          pickupLocation: self.rsvpEditLocation.pickup,
          dropoffLocation: self.rsvpEditLocation.dropoff
        };
        if (self.extraStops) {
          if (self.extraStops.length) {
            mapData.extraStops = [];
            self.extraStops.forEach(function (stop) {
              mapData.extraStops.push(stop);
            });
          }
        }
        self.showPinLocation(mapData);
      }
    },
    totalDriverPayment: function totalDriverPayment(x) {
      this.overrideModal.value = x;
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].component('here-info-bubble-car', {
      template: '<div class="here-info-window car">\n        <div class="left">\n          <img :src="driverPhoto" />\n          <a :href="driverUrl" target="_blank"><span>{{driverName}}</span></a>\n          <span class="sub-text">{{distance}}{{eta}}</span>\n        </div>\n        <div class="right"><img :src="vehiclePhoto" /><span class="model">{{model}}</span>\n        <span class="sub-text">{{license}}</span></div>\n        <a :class="{\'button cta xsmall success block\':true, \'disabled\':hasOngoingCall}" @click="callDriver"><i class="fas fa-phone"></i>\n        <span>{{call}}</span></a>\n      </div>',
      data: function data() {
        return {
          driverInfo: '',
          driverPhoto: '',
          driverUrl: '',
          driverName: '',
          distance: '',
          eta: '',
          vehiclePhoto: '',
          model: '',
          license: '',
          call: ''
        };
      },

      computed: {
        hasOngoingCall: function hasOngoingCall() {
          return this.$store.state.phone.ongoing;
        }
      },
      methods: {
        update: function update(data) {
          this.driverInfo = data.driverInfo;
          this.driverPhoto = data.driverPhoto;
          this.driverUrl = data.driverUrl;
          this.driverName = data.driverName;
          // this.distance = data.distance
          this.eta = data.eta;
          this.vehiclePhoto = data.vehiclePhoto;
          this.model = data.model;
          this.license = data.license;
          this.call = data.call;
        },
        updateField: function updateField(data) {
          this[data.field] = data.value;
        },
        callDriver: function callDriver() {
          var self = this;
          self.$plugins.phone.startCall(self, {
            phone: self.driverInfo.mobile,
            name: self.driverInfo.firstName + ' ' + self.driverInfo.lastName
          });
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].component('here-info-bubble-pickup', {
      template: '<div class="here-info-window pickup">\n        <div class="location">\n          <span v-if="onEdit">{{ rsvpDetails.edit.details.tripInfo.pickup.title }}</span>\n          <span v-else>{{ rsvpDetails.basicInfo.tripInfo.pickup.title }}</span>\n        </div>\n        <div class="eta" v-if="infoWindow.eta && [\'canceled\', \'complete\'].indexOf(rsvpDetails.basicInfo.tripInfo.status) === -1">\n          <label>ETA:</label>\n          <b>{{ infoWindow.eta }}</b>\n        </div>\n      </div>',
      data: function data() {
        return {
          infoWindow: {},
          onEdit: false
        };
      },

      computed: {
        rsvpDetails: function rsvpDetails() {
          return this.$store.state.rsvpDetails;
        }
      },
      methods: {
        update: function update(data) {
          this.infoWindow = data;
        },
        editMode: function editMode(val) {
          this.onEdit = val;
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].component('here-info-bubble-dropoff', {
      template: '<div class="here-info-window dropoff">\n        <div class="location">\n          <span v-if="onEdit">{{ rsvpDetails.edit.details.tripInfo.dropoff.title }}</span>\n          <span v-else>{{ rsvpDetails.basicInfo.tripInfo.dropoff.title }}</span>\n        </div>\n        <div class="eta" v-if="infoWindow.eta && [\'canceled\', \'complete\'].indexOf(rsvpDetails.tripInfo.status) === -1">\n          <label>ETA:</label>\n          <b>{{ infoWindow.eta }}</b>\n        </div>\n      </div>',
      data: function data() {
        return {
          infoWindow: {},
          onEdit: false
        };
      },

      computed: {
        rsvpDetails: function rsvpDetails() {
          return this.$store.state.rsvpDetails;
        }
      },
      methods: {
        update: function update(data) {
          this.infoWindow = data;
        },
        editMode: function editMode(val) {
          this.onEdit = val;
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].component('here-info-bubble-extra-stop', {
      template: '<div class="here-info-window pickup">\n        <div class="location">\n          <span v-if="onEdit">\n            <span v-if="rsvpDetails.edit.details.tripInfo.extraStops && rsvpDetails.edit.details.tripInfo.extraStops.length">\n              {{ extraStopAddress(rsvpDetails.edit.details.tripInfo.extraStops[index]) }}\n            </span>\n          </span>\n          <span v-else>{{ extraStopAddress(rsvpDetails.extraStops[index]) }}</span>\n        </div>\n      </div>',
      props: ['onEdit', 'index'],
      data: function data() {
        return {
          infoWindow: {}
          // onEdit: false
        };
      },

      computed: {
        rsvpDetails: function rsvpDetails() {
          return this.$store.state.rsvpDetails;
        }
      },
      methods: {
        update: function update(data) {
          this.infoWindow = data;
        },
        editMode: function editMode(val) {
          this.onEdit = val;
        },
        extraStopAddress: function extraStopAddress(x) {
          return x ? x.address2 + ' ' + x.address1 + ', ' + x.city + ', ' + x.state + ' ' + x.zipCode : '';
        }
      }
    });
  },
  mounted: function mounted() {
    if (this.$route.params.id !== 'new') {
      this.$store.commit('rsvpDetails/setIsAdd', false);
      this.init();
    } else {
      if (!this.$store.state.session.user.access.hasOwnProperty('PageAdminRSVPAdd')) {
        this.$router.push('/thispagedoesnotexist');
        return;
      }

      this.$store.commit('rsvpDetails/setIsAdd', true);
      this.initNewRsvp();
    }
    this.initMap();

    var self = this;
    self.$store.commit('rsvpDetails/resetDispatchLogs');
    __WEBPACK_IMPORTED_MODULE_7__modules_api_reservation_details_dispatch__["a" /* default */].getDispatchLogs(self, self.$route.params.id, function (res) {});
    if (self.$store.state.settings.sharedAllowedTime.start === '') {
      request.get({
        url: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.Gateway.url + '/appsettings',
        json: true
      }, function (err, res, body) {
        self.$store.commit('settings/setAdminTimeBuffer', parseInt(body.AdminTimeBuffer));
        var minDurationServiceId = [];
        if (body.CharterMinServiceTypeIds) {
          minDurationServiceId = body.CharterMinServiceTypeIds.replaceAll(' ', '').split(',');
          minDurationServiceId = minDurationServiceId.filter(function (x) {
            return x;
          });
        }
        self.$store.commit('settings/setSettings', {
          optinAllowedTime: {
            start: body.OptinAirportStart,
            end: body.OptinAirportEnd
          },
          charterMaxDura: body.CharterMaxDuration,
          charterMinDuration: body.CharterMinDuration,
          charterMnDurationServiceId: minDurationServiceId
        });
        self.$store.commit('settings/setSharedAllowedTime', {
          start: body.AirportStart,
          end: body.AirportEnd
        });
        self.$store.commit('routing/setBeThereTimeThreshold', 1 + parseFloat(body.OfferLimitThreshold) / 100);
      });
    }

    if (!self.$store.state.services.list.length) {
      self.$store.commit('services/setServiceLoading', true);
      __WEBPACK_IMPORTED_MODULE_21__modules_api_services__["a" /* default */].getAllService(self, function (r) {
        self.$store.commit('services/setServiceLoading', false);
      });
    }

    this.runTimer();
  }
});

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__featureToggle__ = __webpack_require__(5);




/* harmony default export */ __webpack_exports__["a"] = ({
  getDispatchLogs: function getDispatchLogs(VueApp, rsvpId, callback) {
    VueApp.$sdk.get('/admin/rsvp/' + rsvpId + '/logs/autodispatch', {
      token: VueApp.$store.state.session.sessionToken

    }, function (res) {
      if (!res.error) {
        var dispatchLog = [];
        var basicInfo = {};
        res.list.forEach(function (data) {
          basicInfo = {
            created: __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.created, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm:ss A'),
            driver: data.driver,
            status: data.status,
            message: data.message
          };
          dispatchLog.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, basicInfo));
        });

        VueApp.$store.commit('rsvpDetails/setDispatchLogs', dispatchLog);
      }
      callback(res);
    });
  }
});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__location__ = __webpack_require__(164);
// import moment from 'moment'


/* harmony default export */ __webpack_exports__["a"] = ({
  createRsvp: function createRsvp(VueApp, params, callback) {
    var self = this;
    if (params.lyft) {
      __WEBPACK_IMPORTED_MODULE_0__location__["a" /* default */].getTimezone(self, {
        lat: params.legs[0].pickup.lat,
        lng: params.legs[0].pickup.lng
      }, function (res) {
        params.legs[0].pickupTimezone = res;
        self._createRsvp(VueApp, params, callback);
      });
      return;
    }
    self._createRsvp(VueApp, params, callback);
  },
  _createRsvp: function _createRsvp(VueApp, params, callback) {
    VueApp.$sdk.post('/admin/rsvp/new', params, function (res) {
      callback(res);
    });
  },
  getSequestId: function getSequestId(VueApp, params, callback) {
    VueApp.$sdk.post('/admin/rsvp/asap', params, function (res) {
      callback(res);
    });
  },
  getDriver: function getDriver(VueApp, params, callback) {
    VueApp.$sdk.post('/reservations/sequence/', params, function (res) {
      callback(res);
    });
  },
  getCards: function getCards(VueApp, id, callback) {
    VueApp.$sdk.get('/consumer/' + id + '/cards', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      callback(res);
      if (res.list.length) {
        var cards = [];
        res.list.forEach(function (data) {
          cards.push({
            id: data.ID,
            name: data.title + ' ****-' + data.cardNumber.substr(-4)
          });
        });
        VueApp.$store.commit('rsvpDetails/setUserCardList', cards);
      } else {
        VueApp.$store.commit('rsvpDetails/setUserCardList', []);
      }
    });
  }
});

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_us__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_us___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_us__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Partials_LocationInput__ = __webpack_require__(1781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Partials_FlightInput__ = __webpack_require__(1785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_api_services__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_api_payment__ = __webpack_require__(1789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_api_reservation_details_edit__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_api_reservation_details_add__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_api_location__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_api_featureToggle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data_currency_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data_currency_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__data_currency_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_api_currency__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__StripeForm__ = __webpack_require__(1790);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */

// import Tribute from 'tributejs'














var countryData = __webpack_require__(90);

var phoneUtil = __webpack_require__(50).PhoneNumberUtil.getInstance();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'edit-rsvp',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default.a, location: __WEBPACK_IMPORTED_MODULE_7__Partials_LocationInput__["a" /* default */], flight: __WEBPACK_IMPORTED_MODULE_8__Partials_FlightInput__["a" /* default */], stripeForm: __WEBPACK_IMPORTED_MODULE_17__StripeForm__["a" /* default */] },
  data: function data() {
    return {
      isMobile: false,
      isDesktop: false,
      isCustomPickupLocation: true,
      customPickupLocation: '',
      customPickupForceValid: true,
      pickupAirportId: 0,
      isCustomDropoffLocation: true,
      customDropoffLocation: '',
      customDropoffForceValid: true,
      dropoffAirportId: 0,
      wheelchairEnabled: false,
      serviceDogEnabled: false,
      waivePayments: false,
      priceOverrideEnabled: false,
      priceOverride: '',
      driverOverrideEnabled: false,
      driverOverride: '',
      paymentBonusEnabled: false,
      paymentBonus: '',
      bookingForSomeone: false,
      quoteDelay: '',
      selectedService: '',
      disableAllService: false,
      airlineLoading: false,
      isMeetAndGreet: false,
      forceMeetandGreet: false,
      today: __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(),
      forceDisableCurbside: false,
      validation: {
        pickupLocation: '',
        pickupAirport: '',
        dropoffLocation: '',
        dropoffAirport: '',
        pickupTime: '',
        airline: '',
        flight: '',
        guestFirstName: '',
        guestLastName: '',
        service: '',
        tip: '',
        priceOverride: '',
        driverOverride: '',
        paymentBonus: '',
        userSelected: '',
        creditCard: '',
        userFirstName: '',
        userLastName: '',
        userEmail: '',
        userMobile: '',
        userCardOwner: '',
        userCreditCard: '',
        userCardExp: '',
        userCvv: '',
        userAddress: '',
        userCity: '',
        userState: '',
        userZip: '',
        userCountry: '',
        userNotes: '',
        userNotesStatus: ''
      },
      maxHour: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      pickupAsap: false,
      showSelectUser: false,
      countries: __webpack_require__(45).countries,
      createUser: {
        show: false,
        newCard: false,
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        paymentMethod: 'newCard',
        cardOwner: '',
        creditCard: '',
        cardExp: '',
        cvv: '',
        address: '',
        city: '',
        state: '..',
        zip: '',
        country: '',
        notes: '',
        notesMaxChar: 500,
        noteStatus: '',
        selectedCard: ''
      },
      currentGeofence: '',
      driverOverrideValidation: {
        pickupAirport: true,
        dropoffAirport: true,
        selectedService: true,
        pickup: true,
        dropoff: true,
        servicePickup: true,
        serviceDropoff: true,
        selectAirportPickup: true,
        selectAirportDropoff: true
      },
      sendEmailReminder: false,
      bookingType: 'mileage',
      charterValidation: {
        startDate: '',
        endDate: ''
      },
      timezoneInfo: {
        pickup: '',
        tz: ''
      },
      currencySymbol: __WEBPACK_IMPORTED_MODULE_15__data_currency_js___default.a,
      tipIntnl: '',
      priceOverrideIntnl: '',
      xcurrency: __WEBPACK_IMPORTED_MODULE_16__modules_api_currency__["a" /* default */],
      d2dUser: {
        birthday: '',
        passport: '',
        address: '',
        city: '',
        zip: '',
        country: '',
        loading: false
      },
      d2dValidation: {
        birthday: '',
        address: '',
        city: '',
        zip: '',
        country: ''
      },
      countryList: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(countryData)
    };
  },

  computed: {
    rsvpId: function rsvpId() {
      return this.$route.params.id;
    },
    travelInsuranceLabel: function travelInsuranceLabel() {
      return this.$settings.get('TravelInsuranceLabel') || 'Rider Fee';
    },
    brands: function brands() {
      return this.$store.state.brands.list;
    },
    brandsLoading: function brandsLoading() {
      return this.$store.state.brands.loading;
    },
    _edit: function _edit() {
      return this.$store.state.rsvpDetails.edit;
    },
    editData: function editData() {
      return this.$store.state.rsvpDetails.edit.details;
    },
    tripInfo: function tripInfo() {
      return this.editData.tripInfo;
    },
    customerInfo: function customerInfo() {
      return this.editData.customerInfo;
    },
    guestInfo: function guestInfo() {
      return this.editData.guestInfo;
    },
    pickupExtra: function pickupExtra() {
      return {
        field: 'pickup',
        disabled: !this.isCustomPickupLocation || this.waivePayments,
        brandId: this.editData.tripInfo.brandId,
        error: this.validation.pickupLocation
      };
    },
    dropoffExtra: function dropoffExtra() {
      return {
        field: 'dropoff',
        disabled: !this.isCustomDropoffLocation || this.waivePayments,
        brandId: this.editData.tripInfo.brandId,
        error: this.validation.dropoffLocation
      };
    },
    airlinesExtra: function airlinesExtra() {
      var geofenceId = this.tripInfo.pickup.geofenceId;
      if (this.tripInfo.pickup.geofenceType !== 'airport' && this.tripInfo.dropoff.geofenceType === 'airport') {
        geofenceId = this.tripInfo.dropoff.geofenceId;
      }
      return {
        gid: 'g' + geofenceId,
        loading: this.airlineLoading,
        error: this.validation.airline
      };
    },
    flightExtra: function flightExtra() {
      return {
        loading: this.airlineLoading,
        error: this.validation.flight
      };
    },
    pickupDate: function pickupDate() {
      var datetime = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.editData.tripInfo.pickupDate, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_14__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
      var hourFormat = this.$settings.get('MilitaryTimeBackoffice') === '1' ? 'HH' : 'hh';
      return {
        date: datetime.format('MM/DD/YYYY'),
        hour: datetime.format(hourFormat),
        minute: datetime.format('mm'),
        amPm: datetime.format('A')
      };
    },
    disabledDate: function disabledDate() {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(this.today.subtract(1, 'months').format('YYYY'), this.today.format('MM'), this.today.format('DD'))
        };
      }

      return {
        to: new Date(this.today.format('YYYY'), this.today.subtract(1, 'months').format('MM'), this.today.format('DD'))
      };
    },
    creditCard: function creditCard() {
      return this.customerInfo.creditCard === '' || this.customerInfo.creditCard === null ? 'N/A' : '**** ' + this.customerInfo.creditCard;
    },
    cardIcon: function cardIcon() {
      return __WEBPACK_IMPORTED_MODULE_10__modules_api_payment__["a" /* default */].cardIcon(this.customerInfo.cardTitle);
    },
    airportPickup: function airportPickup() {
      return this.tripInfo.isAirportPickup;
    },
    airportDropoff: function airportDropoff() {
      return this.tripInfo.isAirportDropoff;
    },
    airportList: function airportList() {
      return this.$store.state.airports.list;
    },
    serviceLoading: function serviceLoading() {
      return this.$store.state.rsvpDetails.edit.serviceLoading;
    },
    servicePrices: function servicePrices() {
      return this.$store.state.rsvpDetails.edit.services;
    },
    maxPax: function maxPax() {
      var servicePrices = this.servicePrices;
      if (!this.useOldQuatation) {
        var pax = {};
        for (var service in servicePrices) {
          var code = servicePrices[service].code;
          if (code) {
            pax[code] = false;
            if (this.tripInfo.passenger > servicePrices[service].maxPassengers) {
              pax[code] = true;
              if (this.selectedService === code) {
                this.selectedService = '';
              }
            }
          }
        }
        return pax;
      } else {
        var _pax = {
          shared: false,
          opoli: false,
          black: false,
          suv: false,
          shuttle: false
        };
        var services = ['shared', 'opoli', 'black', 'suv', 'shuttle'];
        for (var i = 0; i < 5; i++) {
          if (this.tripInfo.passenger > servicePrices[services[i]].maxPassengers) {
            _pax[services[i]] = true;
            if (this.selectedService === services[i]) {
              this.selectedService = '';
            }
          }
        }
        return _pax;
      }
    },
    maxLuggage: function maxLuggage() {
      var servicePrices = this.servicePrices;
      if (!this.useOldQuatation) {
        var luggage = {};
        for (var service in servicePrices) {
          var code = servicePrices[service].code;
          if (code) {
            luggage[code] = false;
            if (this.tripInfo.luggage > servicePrices[service].maxLuggage) {
              luggage[code] = true;
              if (this.selectedService === code) {
                this.selectedService = '';
              }
            }
          }
        }
        return luggage;
      } else {
        var _luggage = {
          shared: false,
          opoli: false,
          black: false,
          suv: false,
          shuttle: false
        };
        var services = ['shared', 'opoli', 'black', 'suv', 'shuttle'];
        for (var i = 0; i < 5; i++) {
          if (this.tripInfo.luggage > servicePrices[services[i]].maxLuggage) {
            _luggage[services[i]] = true;
            if (this.selectedService === services[i]) {
              this.selectedService = '';
            }
          }
        }
        return _luggage;
      }
    },
    pickupTypeData: function pickupTypeData() {
      if (!this.selectedService || !this.servicePrices[this.selectedService]) {
        return {
          curbside: false,
          meetAndGreet: false,
          pickupFee: 0
        };
      }

      var data = this.servicePrices[this.selectedService];

      if (data.curbside && !data.meetAndGreet || data.curbside && !this.isMeetAndGreet && data.meetAndGreet) {
        this.isMeetAndGreet = false;
      }

      if (this.pickupAsap) {
        return {
          curbside: true,
          meetAndGreet: false,
          pickupFee: 0
        };
      }

      this.forceMeetandGreet = false;
      var mobileNo = this.createUser.show ? this.createUser.mobile : this.customerInfo.mobile;
      if (mobileNo) {
        var isUS = true;
        if (this.customerInfo.countryCode) {
          if (this.customerInfo.countryCode !== 1) {
            isUS = false;
          }
        } else {
          try {
            var mobile = phoneUtil.parse('+' + mobileNo);
            if (mobile['values_']['1'] !== 1) {
              isUS = false;
              // this.forceDisableCurbside = true
              if (this.createUser.show && this.callingCode == 1) isUS = true;
            } else {
              this.forceDisableCurbside = false;
            }
          } catch (err) {
            if (mobileNo.length > 3) {
              console.log('Phone error', err, this.customerInfo);
            }
            isUS = false;
            if (this.createUser.show && this.callingCode == 1) isUS = true;
          }
        }

        if (!isUS) {
          this.isMeetAndGreet = true;
          this.forceMeetandGreet = true;

          var serviceCode = this.$store.state.rsvpDetails.edit.selectedService;
          var services = this.$store.state.rsvpDetails.edit.services;
          if (serviceCode && services[serviceCode].licenseType === 'tnc' || services[serviceCode].name.indexOf('Private Van') > -1) {
            this.isMeetAndGreet = false;
            this.forceMeetandGreet = false;
            return {
              curbside: true,
              meetAndGreet: false,
              pickupFee: 0
            };
          } else if (serviceCode && services[serviceCode].licenseType === 'tcp') {
            return {
              curbside: false,
              meetAndGreet: true,
              pickupFee: 0
            };
          }
        } else {
          return {
            curbside: data.curbside,
            meetAndGreet: data.meetAndGreet,
            pickupFee: data.pickupFee
          };
        }
      }

      return this.servicePrices[this.selectedService];
    },
    hasPickupType: function hasPickupType() {
      return this.pickupTypeData.curbside || this.pickupTypeData.meetAndGreet;
    },
    showCurbside: function showCurbside() {
      return !this.forceDisableCurbside && this.pickupTypeData.curbside;
      // return !this.forceDisableCurbside && this.pickupTypeData.curbside &&
      //   (!this.pickupTypeData.meetAndGreet || (this.pickupTypeData.meetAndGreet && this.pickupTypeData.pickupFee !== 0))
    },
    paymentSummaryData: function paymentSummaryData() {
      var fare = 0;
      var mng = 0;
      var tip = parseFloat(this.tripInfo.tip);
      var pax = this.tripInfo.passenger || 1;
      var travelInsurance = 0;
      var portalFee = 0;
      if (!this.servicePrices[this.selectedService]) {
        return {
          fare: 0,
          travelInsurance: 0,
          meetAndGreet: 0,
          airportFee: 0,
          gasFee: 0,
          portalFee: 0,
          tip: 0,
          credits: 0,
          total: 0,
          totalIntnl: 0
        };
      }
      if (!!this.selectedService && this.servicePrices[this.selectedService].prices) {
        fare = parseFloat(this.servicePrices[this.selectedService].prices[pax - 1].price);
        mng = this.servicePrices[this.selectedService].pickupFee || this.$t('rsvpDetails.edit.complimentary');
      }

      var gasFee = 0;
      if (this.selectedService !== '') {
        travelInsurance = this.servicePrices[this.selectedService].travelInsurance;
        gasFee = this.servicePrices[this.selectedService].gasFee || 0;
        if (this.servicePrices[this.selectedService].portalFee) {
          portalFee = this.servicePrices[this.selectedService].portalFee;
          if (this.servicePrices[this.selectedService].portalFeeType === '%') {
            portalFee = parseFloat((fare * (this.servicePrices[this.selectedService].portalFee / 100)).toFixed(2));
          }
        }
      }

      if (!this.isNewRsvp) {
        var oldData = this.$store.state.rsvpDetails.basicInfo.tripInfo;
        var tripInfo = this.tripInfo;
        var oldExtraStops = this.$store.state.rsvpDetails.extraStops;
        var newExtraStops = this.$store.state.rsvpDetails.edit.details.tripInfo.extraStops;
        var hasExtraStopChanges = false;
        if (oldExtraStops.length) {
          if (oldExtraStops.length !== newExtraStops.length) {
            hasExtraStopChanges = true;
          } else {
            oldExtraStops.forEach(function (stop, index) {
              if (stop.lat !== newExtraStops[index].lat || stop.lng !== newExtraStops[index].lng) {
                hasExtraStopChanges = true;
              }
            });
          }
        } else if (newExtraStops && newExtraStops.length) {
          hasExtraStopChanges = true;
        }
        if ((this.constructAdress(oldData.pickup) === this.constructAdress(tripInfo.pickup) || oldData.pickup.geofenceType === 'airport' && tripInfo.pickup.geofenceType === 'airport' && oldData.pickup.geofenceId === tripInfo.pickup.geofenceId) && (this.constructAdress(oldData.dropoff) === this.constructAdress(tripInfo.dropoff) || oldData.dropoff.geofenceType === 'airport' && tripInfo.dropoff.geofenceType === 'airport' && oldData.dropoff.geofenceId === tripInfo.dropoff.geofenceId) && oldData.pickupDate.substring(0, 10) === tripInfo.pickupDate.substring(0, 10) && oldData.passenger === tripInfo.passenger && oldData.serviceCode === this.selectedService && !hasExtraStopChanges && !this.charter.enabled || this.charter.enabled && (this.constructAdress(oldData.pickup) === this.constructAdress(tripInfo.pickup) || oldData.pickup.geofenceType === 'airport' && oldData.pickup.geofenceId === tripInfo.pickup.geofenceId) && oldData.pickupDate === this.charter.startDate && __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.charter.startDate, 'MM/DD/YYYY hh:mmA').add(oldData.eta, 'seconds').format('MM/DD/YYYY hh:mmA') === this.charter.endDate || this.waivePayments) {
          fare = oldData.fare;
          travelInsurance = oldData.travelInsurance;
          gasFee = oldData.gasFee;
          portalFee = oldData.portalFee;
        }
      } else {
        tip = parseFloat(this.editData.tripInfo.tip) || 0;
      }

      // let pickupDate = moment(this.pickupDate.date, 'MM/DD/YYYY')
      // if (this.holidayData.date === pickupDate.format('YYYY-MM-DD')) {
      //   fare = this.holidayPricing({
      //     code: this.selectedService,
      //     price: parseInt(this.servicePrices[this.selectedService].prices[pax - 1].original)
      //   })
      // }

      var isUS = true;
      var mobileNo = this.createUser.show ? this.createUser.mobile : this.customerInfo.mobile;
      if (this.customerInfo.countryCode) {
        if (this.customerInfo.countryCode !== 1) {
          isUS = false;
        }
      } else if (mobileNo) {
        try {
          var mobile = phoneUtil.parse('+' + mobileNo, '');
          if (mobile['values_']['1'] !== 1) {
            isUS = false;
            if (this.createUser.show && this.callingCode == 1) isUS = true;
          }
        } catch (err) {
          if (mobileNo.length > 3) {
            console.log('Phone error', err, this.customerInfo);
          }
          isUS = false;
          if (this.createUser.show && this.callingCode == 1) isUS = true;
        }
      }
      if (!isUS) {
        mng = 0;

        var serviceCode = this.$store.state.rsvpDetails.edit.selectedService;
        var services = this.$store.state.rsvpDetails.edit.services;
        if (this.selectedService && this.servicePrices[this.selectedService].licenseType === 'tnc' || this.servicePrices[this.selectedService].name.indexOf('Private Van') > -1) {
          this.isMeetAndGreet = false;
        } else if (serviceCode && services[serviceCode].licenseType === 'tcp') {
          this.isMeetAndGreet = true;
        }
      }

      if (this.pickupAsap) {
        this.isMeetAndGreet = false;
      }

      if (this.priceOverrideEnabled && !!this.priceOverride) {
        if (!this.tripInfo.optinShared || !this.tripInfo.optinShared.isOptinShared) {
          fare = parseFloat(this.priceOverride);
          mng = 0;
        }
        if (this.servicePrices[this.selectedService].portalFee && this.servicePrices[this.selectedService].portalFeeType === '%') {
          portalFee = parseFloat((fare * (this.servicePrices[this.selectedService].portalFee / 100)).toFixed(2));
        }
      }

      var airportFee = 0;
      if (this.selectedService !== '') {
        airportFee = this.servicePrices[this.selectedService].airportFee;
      }

      var total = fare + tip + airportFee + travelInsurance + gasFee + portalFee;
      if (mng !== this.$t('rsvpDetails.edit.complimentary') && this.isMeetAndGreet && this.airportPickup) {
        total = total + mng;
      }
      total = total - (this.tripInfo.credits || 0);
      total = total < 0 ? 0 : total;

      var totalIntnl = 0;
      if (this.currencyCode !== 'USD') {
        // totalIntnl = total - tip
        totalIntnl += parseFloat((airportFee * this.currency.value).toFixed(2));
        totalIntnl += parseFloat((travelInsurance * this.currency.value).toFixed(2));
        totalIntnl += parseFloat(((gasFee || 0) * this.currency.value).toFixed(2));
        totalIntnl += parseFloat((portalFee * this.currency.value).toFixed(2));
        if (mng !== this.$t('rsvpDetails.edit.complimentary') && this.isMeetAndGreet && this.airportPickup) {
          totalIntnl += parseFloat((mng * this.currency.value).toFixed(2));
        }
        if (this.priceOverrideEnabled && !!this.priceOverride) {
          totalIntnl += parseFloat(this.priceOverrideIntnl || 0);
        } else {
          totalIntnl += fare * this.currency.value;
        }
        totalIntnl += parseFloat(this.tipIntnl || 0);
        totalIntnl -= this.tripInfo.credits * this.currency.value;
        // totalIntnl = (totalIntnl * this.currency.value)
      }

      return {
        fare: fare,
        travelInsurance: travelInsurance,
        meetAndGreet: mng,
        airportFee: airportFee,
        gasFee: gasFee,
        portalFee: portalFee,
        tip: this.tripInfo.tip || 0,
        credits: this.tripInfo.credits || 0,
        total: total || 0,
        totalIntnl: totalIntnl
      };
    },
    paymentBonusComputation: function paymentBonusComputation() {
      var bonusLimitPercent = this.$settings.get('ProviderPaymentBonusLimit');
      var limitAmount = 0;
      var fare = this.paymentSummaryData.fare;
      var basePay = this.tripInfo.basePay != 0 ? this.tripInfo.basePay : this.tripInfo.driverPayment;
      var original = basePay + this.tripInfo.driverBonus;
      var updated = original;

      if (this.paymentBonusEnabled) {
        var bonus = parseFloat(this.paymentBonus) || 0;
        updated = updated + bonus;
      }

      limitAmount = bonusLimitPercent / 100 * fare;
      return {
        bonusLimitPercent: bonusLimitPercent,
        limitAmount: limitAmount,
        original: original,
        updated: parseFloat(updated).toFixed(2)
      };
    },
    holidayData: function holidayData() {
      return this.$store.state.rsvpDetails.edit.holiday;
    },
    isMilitaryTime: function isMilitaryTime() {
      if (this.$settings.get('MilitaryTimeBackoffice') === '1') {
        this.maxHour = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
      }
      return this.$settings.get('MilitaryTimeBackoffice') === '1';
    },
    isNewRsvp: function isNewRsvp() {
      return this.$store.state.rsvpDetails.isAdd;
    },

    passenger: {
      get: function get() {
        return this.tripInfo.passenger || 1;
      },
      set: function set(value) {
        this.$store.commit('rsvpDetails/setPassenger', value);
        if (this.originalPax !== value) {
          this.paymentBonusEnabled = false;
          this.paymentBonus = 0;
        }
        if (this.mtech.enabled && this.selectedService) {
          if (value > this.mtech.services[this.selectedService].maxPaxVal) {
            this.selectedService = '';
          }
        }
      }
    },
    luggage: {
      get: function get() {
        return this.tripInfo.luggage || 1;
      },
      set: function set(value) {
        this.$store.commit('rsvpDetails/setLuggage', value);
        if (this.mtech.enabled && this.selectedService) {
          if (value > this.mtech.services[this.selectedService].maxLuggageVal) {
            this.selectedService = '';
          }
        }
      }
    },
    states: function states() {
      var states = [];
      for (var key in __WEBPACK_IMPORTED_MODULE_4_us___default.a.states) {
        if (__WEBPACK_IMPORTED_MODULE_4_us___default.a.states.hasOwnProperty(key)) {
          states.push({
            value: key,
            label: __WEBPACK_IMPORTED_MODULE_4_us___default.a.states[key].name
          });
        }
      }
      return states;
    },
    noteCounter: function noteCounter() {
      var count = this.createUser.notesMaxChar - this.createUser.notes.length;
      return count < 0 ? 0 : count;
    },
    userCardLoading: function userCardLoading() {
      return this.$store.state.rsvpDetails.userCard.loading;
    },
    userCardlist: function userCardlist() {
      return this.$store.state.rsvpDetails.userCard.list;
    },
    asapBidId: function asapBidId() {
      return this.$store.state.rsvpDetails.asap.bidId;
    },
    priceOverrideAccess: function priceOverrideAccess() {
      return this.$store.state.session.user.access.hasOwnProperty('PageAdminPriceOverride');
    },
    overrideAccess: function overrideAccess() {
      return this.$store.state.session.user.access.hasOwnProperty('PageAdminOverride');
    },
    hasWaivePaymentAccess: function hasWaivePaymentAccess() {
      return this.$store.state.session.user.access.hasOwnProperty('PageAdminRSVPWaivePayments');
    },
    useOldQuatation: function useOldQuatation() {
      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation;
    },
    isCorporate: function isCorporate() {
      return this.$store.state.rsvpDetails.isCorporate;
    },
    isFreshDeliveries: function isFreshDeliveries() {
      var _this = this;

      if (this.editData.tripInfo && this.editData.tripInfo.brandId) {
        return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.find(function (x) {
          return x.id === _this.editData.tripInfo.brandId;
        }) && {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.find(function (x) {
          return x.id === _this.editData.tripInfo.brandId;
        }).code === 'fd';
      }
      return false;
    },
    extraStops: function extraStops() {
      return this.tripInfo.extraStops;
    },
    enableCharterBooking: function enableCharterBooking() {
      var _this2 = this;

      var enabledBrands = [];
      if (this.$settings.get('CharterEnabledBrands')) enabledBrands = this.$settings.get('CharterEnabledBrands').split(',');
      return enabledBrands.findIndex(function (x) {
        return x == _this2.editData.tripInfo.brandId;
      }) > -1;
    },
    charter: function charter() {
      return this.$store.state.rsvpDetails.charter;
    },
    startDate: function startDate() {
      var datetime = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.charter.startDate, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_14__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
      var hourFormat = this.$settings.get('MilitaryTimeBackoffice') === '1' ? 'HH' : 'hh';
      return {
        date: datetime.format('MM/DD/YYYY'),
        hour: datetime.format(hourFormat),
        minute: datetime.format('mm'),
        amPm: datetime.format('A')
      };
    },
    endDate: function endDate() {
      var datetime = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.charter.endDate, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_14__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
      var hourFormat = this.$settings.get('MilitaryTimeBackoffice') === '1' ? 'HH' : 'hh';
      return {
        date: datetime.format('MM/DD/YYYY'),
        hour: datetime.format(hourFormat),
        minute: datetime.format('mm'),
        amPm: datetime.format('A')
      };
    },
    optin: function optin() {
      return this.$store.state.rsvpDetails.optin;
    },

    optinEnabled: {
      get: function get() {
        return this.optin.enabled;
      },
      set: function set(x) {
        this.$store.commit('rsvpDetails/setOptinData', { enabled: x });
      }
    },
    settings: function settings() {
      return this.$store.state.settings;
    },
    charterMaxDura: function charterMaxDura() {
      return this.$store.state.settings.charterMaxDura;
    },
    mtech: function mtech() {
      return this.$store.state.rsvpDetails.mtech;
    },
    flightDate: function flightDate() {
      var adminTimeBuffer = this.$store.state.settings.adminTimeBuffer;
      var datetime = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()().add(adminTimeBuffer, 'minutes');
      if (this.mtech.flightDate) {
        datetime = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.mtech.flightDate, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_14__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
      }
      var hourFormat = this.$settings.get('MilitaryTimeBackoffice') === '1' ? 'HH' : 'hh';
      return {
        date: datetime.format('MM/DD/YYYY'),
        hour: datetime.format(hourFormat),
        minute: datetime.format('mm'),
        amPm: datetime.format('A')
      };
    },
    paymentSummaryMtech: function paymentSummaryMtech() {
      var fare = 0;
      var tax = 0;
      var gratuity = 0;
      var discount = 0;
      var tip = parseFloat(this.tripInfo.tip);
      var pax = this.tripInfo.passenger || 1;

      if (!this.selectedService) {
        return {
          fare: 0,
          tax: 0,
          discount: 0,
          tip: 0,
          credits: 0,
          total: 0
        };
      }

      var service = this.mtech.services[this.selectedService];
      service.price.breakdown.forEach(function (breakdown) {
        if (breakdown.description.toLowerCase() == 'base rate') {
          fare = parseFloat(breakdown.amount + service.price.addMarkup);
        }
        if (breakdown.description.toLowerCase() == 'tax & fees') {
          tax = parseFloat(breakdown.amount);
        }
        if (breakdown.description.toLowerCase() == 'service gratuity') {
          gratuity = parseFloat(breakdown.amount);
        }
        if (breakdown.description.toLowerCase() == 'discount') {
          discount = parseFloat(breakdown.amount);
        }
      });
      // if (service) {
      //   fare = parseFloat(service.price.breakdown[0].amount + service.price.addMarkup)
      //   tax = parseFloat(service.price.breakdown[1].amount || 0)
      //   if (service.price.breakdown.length === 3) {
      //     discount = parseFloat(service.price.breakdown[2].amount || 0)
      //   }
      // }

      tip = parseFloat(this.editData.tripInfo.tip) || 0;

      var total = fare + tip + tax + gratuity + discount;
      total = total - (this.tripInfo.credits || 0);
      total = total < 0 ? 0 : total;

      return {
        fare: fare,
        tax: tax,
        gratuity: gratuity,
        discount: discount,
        tip: this.tripInfo.tip || 0,
        credits: this.tripInfo.credits || 0,
        total: total || 0
      };
    },

    isDomestic: {
      get: function get() {
        return this.mtech.isDomestic;
      },
      set: function set(x) {
        this.$store.commit('rsvpDetails/setMtechData', { isDomestic: x });
      }
    },
    callingCode: function callingCode() {
      return this.$store.state.countryCode.callingCode;
    },
    currency: function currency() {
      return this.$store.state.rsvpDetails.edit.currency;
    },
    currencyList: function currencyList() {
      return this.$store.state.currency.list;
    },

    currencyCode: {
      get: function get() {
        return this.currency.code;
      },
      set: function set(x) {
        this.$store.commit('rsvpDetails/setEditCurrency', {
          code: x,
          symbol: __WEBPACK_IMPORTED_MODULE_15__data_currency_js___default.a[x],
          value: this.currencyList[x]
        });
      }
    },
    isD2D: function isD2D() {
      var _this3 = this;

      if (this.editData.tripInfo && this.editData.tripInfo.brandId) {
        return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.find(function (x) {
          return x.id === _this3.editData.tripInfo.brandId;
        }) && {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.find(function (x) {
          return x.id === _this3.editData.tripInfo.brandId;
        }).code === 'd2d';
      }
      return false;
    },
    stripeStore: function stripeStore() {
      return this.$store.state.rsvpDetails.stripe;
    },
    convenienceFee: function convenienceFee() {
      return this.paymentSummaryData.fare ? parseFloat((this.paymentSummaryData.fare * .1).toFixed(2)) : 0;
    }
  },
  methods: {
    init: function init() {
      var self = this;
      self.cleanValidation();
      self.getAirlineList();
      self.$store.commit('rsvpDetails/setOptinData', {
        enabled: false,
        shared: []
      });
      if (!self.isNewRsvp && self.tripInfo.optinShared.isOptinShared) {
        self.$store.commit('rsvpDetails/setOptinData', { enabled: true });
      }
      self.priceOverrideIntnl = 0;
      if (self.tripInfo.overridePrice) {
        self.priceOverrideIntnl = self.$store.state.rsvpDetails.currency.amount;
      }
      self.tipIntnl = 0;
      if (this.$store.state.rsvpDetails.currency.currency !== 'USD') {
        self.tipIntnl = this.$store.state.rsvpDetails.currency.tipAmount;
      }
      self.$nextTick(function () {
        self.getQuote();
      });
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(date).format('MM/DD/YYYY');
    },
    leadingZero: function leadingZero(n) {
      return n < 10 ? '0' + n : n;
    },
    toFixed: function toFixed(n) {
      return parseFloat(n).toFixed(2);
    },
    price: function price(data) {
      if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(data).length || !this.chkCharterMinDuration(data.code)) {
        return { value: 'N/A', hasDiscount: false, original: 0 };
      }

      if (!this.isNewRsvp) {
        var oldData = this.$store.state.rsvpDetails.basicInfo.tripInfo;
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).length === 0 || typeof data === 'undefined' || typeof oldData.pickup.title === 'undefined') {
          return {
            value: this.applyCurrency(0),
            hasDiscount: false,
            original: this.applyCurrency(0)
          };
        }
      }

      var pax = this.passenger;
      if (pax > __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data.prices).length || this.disableAllService) {
        return {
          value: 'N/A',
          hasDiscount: false,
          original: 0
        };
      }

      if (this.priceOverrideEnabled && !!this.priceOverride) {
        if (!this.tripInfo.optinShared || !this.tripInfo.optinShared.isOptinShared) {
          return {
            value: '' + this.currency.symbol + this.priceOverrideIntnl,
            hasDiscount: false,
            original: this.applyCurrency(this.priceOverride)
          };
        }
      }

      var price = data.prices[pax - 1].price;
      var tripInfo = this.tripInfo;

      if (!this.isNewRsvp) {
        var rsvpDetails = this.$store.state.rsvpDetails;
        var _oldData = rsvpDetails.basicInfo.tripInfo;
        var oldExtraStops = rsvpDetails.extraStops;
        var newExtraStops = rsvpDetails.edit.details.tripInfo.extraStops;
        var hasExtraStopChanges = false;
        if (oldExtraStops.length) {
          if (oldExtraStops.length !== newExtraStops.length) {
            hasExtraStopChanges = true;
          } else {
            oldExtraStops.forEach(function (stop, index) {
              if (stop.lat !== newExtraStops[index].lat || stop.lng !== newExtraStops[index].lng) {
                hasExtraStopChanges = true;
              }
            });
          }
        } else if (newExtraStops && newExtraStops.length) {
          hasExtraStopChanges = true;
        }
        if ((this.constructAdress(_oldData.pickup) === this.constructAdress(tripInfo.pickup) || _oldData.pickup.geofenceType === 'airport' && _oldData.pickup.geofenceId === tripInfo.pickup.geofenceId) && (this.constructAdress(_oldData.dropoff) === this.constructAdress(tripInfo.dropoff) || _oldData.dropoff.geofenceType === 'airport' && _oldData.dropoff.geofenceId === tripInfo.dropoff.geofenceId) && _oldData.pickupDate.substring(0, 10) === tripInfo.pickupDate.substring(0, 10) && _oldData.passenger === tripInfo.passenger && _oldData.serviceCode === data.code && !hasExtraStopChanges && !this.charter.enabled || this.charter.enabled && (this.constructAdress(_oldData.pickup) === this.constructAdress(tripInfo.pickup) || _oldData.pickup.geofenceType === 'airport' && _oldData.pickup.geofenceId === tripInfo.pickup.geofenceId) && _oldData.pickupDate === this.charter.startDate && __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.charter.startDate, 'MM/DD/YYYY hh:mmA').add(_oldData.eta, 'seconds').format('MM/DD/YYYY hh:mmA') === this.charter.endDate || this.waivePayments) {
          price = _oldData.fare;
        }
      }

      var isHoliday = false;
      var pickupDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.pickupDate.date, 'MM/DD/YYYY');
      if (this.holidayData.date === pickupDate.format('YYYY-MM-DD') && !this.waivePayments) {
        isHoliday = true;
        price = this.holidayPricing({
          code: data.code,
          price: data.prices[pax - 1].original
        });
      }

      return {
        value: this.applyCurrency(this.toFixed(price)),
        hasDiscount: data.prices[pax - 1].price !== data.prices[pax - 1].original && !isHoliday,
        original: this.applyCurrency(data.prices[pax - 1].original)
      };
    },
    holidayPricing: function holidayPricing(data) {
      data.price = parseInt(data.price);
      var currency = this.holidayData[data.code].currency;
      var value = parseInt(this.holidayData[data.code].value);

      if (currency === '$') {
        data.price += value;
      } else {
        data.price += data.price * (value / 100);
      }

      return data.price;
    },
    constructAdress: function constructAdress(addr) {
      if (!addr) {
        return '';
      }
      return addr.address2 + addr.address1 + addr.city + addr.state + addr.zip;
    },
    call: function call(user) {
      var self = this;
      var phone = '' + user.countryCode + (user.nationalNumber || user.mobile);
      self.$plugins.phone.startCall(self, {
        phone: parseInt(phone),
        name: user.firstName + ' ' + user.lastName
      });
    },
    getAirlineList: function getAirlineList() {
      var self = this;

      var pickup = self.tripInfo.pickup;
      var dropoff = self.tripInfo.dropoff;
      var airlines = self.$store.state.airlines;
      var geofenceId = pickup.geofenceId;
      if (pickup.geofenceType !== 'airport' && dropoff.geofenceType === 'airport') {
        geofenceId = dropoff.geofenceId;
      }
      if (this.charter.enabled) {
        geofenceId = this.charter.airportGeoId;
      }
      if (airlines['g' + geofenceId] || typeof pickup.geofenceType === 'undefined' && dropoff.geofenceType !== 'airport' && !self.charter.enabled || pickup.geofenceType !== 'airport' && dropoff.geofenceType !== 'airport' && !self.charter.enabled || !self.airportPickup && self.charter.enabled) {
        return;
      }

      if (self.airlineLoading || !geofenceId) {
        return;
      }
      self.airlineLoading = true;

      var sdkUrl = '/geofences/' + geofenceId + '/airlines';
      self.$sdk.get(sdkUrl, {}, function (res) {
        self.airlineLoading = false;
        if (!res.error) {
          var _airlines = [];
          res.list.forEach(function (data) {
            _airlines.push({
              code: data.code,
              name: data.name,
              label: '(' + data.code + ') ' + data.name
            });
          });
          self.$store.commit('airlines/addAirlines', {
            id: 'g' + geofenceId,
            list: _airlines
          });
        }
      });
    },
    selectAirportPickup: function selectAirportPickup(selected) {
      if (selected === 0) {
        return;
      }
      var self = this;
      var geofenceId = typeof selected === 'number' ? selected : parseInt(selected.target.value);
      var index = self.airportList.findIndex(function (x) {
        return x.geofenceId === geofenceId;
      });
      self.$store.commit('rsvpDetails/setPickup', self.airportList[index]);
      self.$store.commit('rsvpDetails/setIsAirportPickup', true);
      self.$store.commit('rsvpDetails/setAirportCode', self.airportList[index].airportCode);
      self.getAirlineList();

      self.$store.commit('rsvpDetails/setTimezoneLoading', true);
      __WEBPACK_IMPORTED_MODULE_13__modules_api_location__["a" /* default */].getTimezone(self, {
        lat: self.tripInfo.pickup.lat,
        lng: self.tripInfo.pickup.lng
      }, function (res) {
        self.timezoneInfo = {
          pickup: self.tripInfo.pickup.title,
          tz: res
        };
        self.$store.commit('rsvpDetails/setTimezoneLoading', false);
        self.$store.commit('rsvpDetails/setTimezone', res);
      });

      if (self.quoteDelay) {
        clearTimeout(self.quoteDelay);
      }
      self.quoteDelay = setTimeout(function () {
        self.getQuote();
      }, 800);

      // if (this.$store.state.rsvpDetails.basicInfo.tripInfo.pickup.geofenceId != selected.target.value) {
      if (this.$store.state.rsvpDetails.basicInfo.tripInfo.pickup.geofenceId != geofenceId) {
        this.driverOverrideValidation.selectAirportPickup = false;
      } else {
        this.driverOverrideValidation.selectAirportPickup = true;
      }
      this.clearDriverPayment();
    },
    selectAirportDropoff: function selectAirportDropoff(selected) {
      if (selected === 0) {
        return;
      }
      var self = this;
      var geofenceId = typeof selected === 'number' ? selected : parseInt(selected.target.value);
      var index = self.airportList.findIndex(function (x) {
        return x.geofenceId === geofenceId;
      });
      this.$store.commit('rsvpDetails/setDropoff', self.airportList[index]);
      self.$store.commit('rsvpDetails/setIsAirportDropoff', true);
      if (!self.airportPickup && self.airportDropoff) {
        self.$store.commit('rsvpDetails/setAirportCode', self.airportList[index].airportCode);
        self.getAirlineList();
      }

      if (self.quoteDelay) {
        clearTimeout(self.quoteDelay);
      }
      self.quoteDelay = setTimeout(function () {
        self.getQuote();
      }, 800);

      if (this.$store.state.rsvpDetails.basicInfo.tripInfo.dropoff.geofenceId != selected) {
        this.driverOverrideValidation.selectAirportDropoff = false;
      } else {
        this.driverOverrideValidation.selectAirportDropoff = true;
      }
      this.clearDriverPayment();
    },
    serviceDisable: function serviceDisable(index, service) {
      if (this.charter.enabled && service.code) {
        if (!this.chkCharterMinDuration(service.code)) return true;
      }

      if (this.serviceAvailability(service).enabled ? this.serviceAvailability(service).eligible ? false : true : false) {
        if (this.serviceAvailability(service).code === this.selectedService) {
          this.selectedService = '';
        }
      }
      var nowPlusBuffer = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()().add(service.bufferTime, 'minutes');
      var pickupDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.tripInfo.pickupDate, 'MM/DD/YYYY hh:mmA');
      var serviceUnavailable = service.serviceUnavailableTime;
      return this.serviceLoading || this.maxPax[index] || this.maxLuggage[index] || !this.sharedAllowedTime(index) || this.disableAllService || this.serviceAvailability(service).enabled ? this.serviceAvailability(service).eligible ? false : true : false || this.extraStops && this.extraStops.length > 0 && service.isShared || service.bufferTime && pickupDate.isBefore(nowPlusBuffer);
    },
    chkCharterMinDuration: function chkCharterMinDuration(service) {
      if (!this.charter.enabled) return true;
      var selectedService = service.replace('a', '');
      var minDuration = this.settings.charterMinDuration;
      var minDurationServiceId = this.settings.charterMnDurationServiceId;
      var startDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.charter.startDate, 'MM/DD/YYYY hh:mmA');
      var endDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.charter.endDate, 'MM/DD/YYYY hh:mmA');
      if (!this.charter.startDate || !this.charter.endDate || minDurationServiceId.indexOf(selectedService) > -1 && endDate.diff(startDate, 'minutes') < minDuration) return false; // Time duration within charter-min-duration settings
      return true; // NO ISSUE
    },
    serviceAvailability: function serviceAvailability(service) {
      var availability = service.availability;
      if (typeof availability === 'undefined' || availability === null) {
        return {
          enabled: false,
          eligible: false
        };
      }
      return {
        enabled: availability.enabled,
        eligible: availability.eligible > 0 ? true : false,
        unavailable: availability.enabled && availability.eligible === 0 && !!!availability.suggest.before && !!!availability.suggest.after,
        before: availability.suggest.before ? __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(availability.suggest.before, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY h:mmA') : '',
        after: availability.suggest.after ? __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(availability.suggest.after, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY h:mmA') : '',
        code: service.code
      };
    },
    sharedAllowedTime: function sharedAllowedTime(service) {
      var sharedAllow = true;
      if (this.editData.tripInfo.isAirportPickup && !this.isFreshDeliveries) {
        var selectedTime = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.editData.tripInfo.pickupDate, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_14__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
        selectedTime = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(selectedTime.format(__WEBPACK_IMPORTED_MODULE_14__modules_api_featureToggle__["a" /* default */].timeFormat(this, false)), __WEBPACK_IMPORTED_MODULE_14__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
        if (this.pickupAsap) {
          selectedTime = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()();
        }
        var settings = this.settings;
        var allowTimeStart = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(settings.sharedAllowedTime.start, 'hh:mmA');
        var allowTimeEnd = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(settings.sharedAllowedTime.end, 'hh:mmA');
        if (!this.useOldQuatation) {
          if (this.$store.state.rsvpDetails.edit.services[service] && this.$store.state.rsvpDetails.edit.services[service].isShared && !selectedTime.isBetween(allowTimeStart, allowTimeEnd)) {
            sharedAllow = false;
            if (this.selectedService === service) {
              this.selectedService = '';
            }
          }
        } else {
          if (service === 'shared' && !selectedTime.isBetween(allowTimeStart, allowTimeEnd)) {
            sharedAllow = false;
            if (this.selectedService === service) {
              this.selectedService = '';
            }
          }
        }
      }

      return sharedAllow;
    },
    serviceDetails: function serviceDetails(index) {
      if (!this.useOldQuatation) {
        var _service = this.servicePrices[index];
        return {
          code: _service.code,
          label: _service.name
        };
      } else {
        switch (index) {
          case 'shared':
            return { code: 'shared', label: __WEBPACK_IMPORTED_MODULE_9__modules_api_services__["a" /* default */].getServiceName(index) };
          case 'opoli':
            return { code: 'opoli', label: __WEBPACK_IMPORTED_MODULE_9__modules_api_services__["a" /* default */].getServiceName(index) };
          case 'black':
            return { code: 'black', label: __WEBPACK_IMPORTED_MODULE_9__modules_api_services__["a" /* default */].getServiceName(index) };
          case 'SUV':
            return { code: 'suv', label: __WEBPACK_IMPORTED_MODULE_9__modules_api_services__["a" /* default */].getServiceName(index) };
          case 'suv':
            return { code: 'suv', label: __WEBPACK_IMPORTED_MODULE_9__modules_api_services__["a" /* default */].getServiceName(index) };
          case 'shuttle':
            return { code: 'shuttle', label: __WEBPACK_IMPORTED_MODULE_9__modules_api_services__["a" /* default */].getServiceName(index) };
          default:
            return { code: '', label: '...' };
        }
      }
    },
    selectService: function selectService(code, service) {
      if (!this.sharedAllowedTime(code) || this.serviceDisable(code, service) || service.unavailableService) {
        return;
      }
      this.selectedService = code;
      // if (this.pickupTypeData.curbside && (!this.pickupTypeData.meetAndGreet ||
      //   (this.pickupTypeData.meetAndGreet && this.pickupTypeData.pickupFee === 0))
      // ) {
      //   this.isMeetAndGreet = true
      // }

      var mobileNo = this.createUser.show ? this.createUser.mobile : this.customerInfo.mobile;
      if (mobileNo) {
        var data = this.servicePrices[this.selectedService];
        this.forceDisableCurbside = false;

        if (data.curbside && data.meetAndGreet) {
          if (this.customerInfo.countryCode) {
            if (this.customerInfo.countryCode !== 1) {
              this.forceDisableCurbside = true;
              this.isMeetAndGreet = true;
            }
          } else {
            try {
              var mobile = phoneUtil.parse('+' + mobileNo, '');
              this.forceDisableCurbside = false;
              if (mobile['values_']['1'] !== 1) {
                this.forceDisableCurbside = true;
                this.isMeetAndGreet = true;
              }
            } catch (err) {
              if (mobileNo.length > 3) {
                console.log('Phone error', err, this.customerInfo);
              }
              this.forceDisableCurbside = true;
              this.isMeetAndGreet = true;
            }
          }
        }
      }

      if (this.pickupAsap) {
        this.forceDisableCurbside = false;
        this.isMeetAndGreet = false;
      }

      if (this.paymentBonusEnabled) {
        this.paymentBonusEnabled = false;
        this.paymentBonus = 0;
      }

      //code
      if (this.selectedService != this.$store.state.rsvpDetails.basicInfo.tripInfo.serviceType) {
        this.driverOverrideValidation.selectedService = false;
      } else {
        this.driverOverrideValidation.selectedService = true;
      }
      this.clearDriverPayment();

      this.$store.commit('rsvpDetails/setOptinData', { enabled: false });
    },
    locationNewValue: function locationNewValue(data) {
      var self = this;
      var field = data.field.charAt(0).toUpperCase() + data.field.slice(1);
      this['custom' + field + 'ForceValid'] = data.keyInput !== '';

      if (data.field === 'pickup' && data.keyInput === '') {
        this.customPickupLocation = '';
      } else if (data.field === 'dropoff' && data.keyInput === '') {
        this.customDropoffLocation = '';
      }

      if (!!data.keyInput === false) {
        return;
      }
      if (self.quoteDelay) {
        clearTimeout(self.quoteDelay);
      }

      if (this.charter.enabled) {
        if (!this.charter.startDate || !this.charter.endDate) {
          return;
        }
      }

      if (data.field === 'pickup' && !this._edit.timezoneLoading && this.timezoneInfo.pickup !== this.tripInfo.pickup.title) {
        self.getTimezoneFirst();
      } else {
        self.quoteDelay = setTimeout(function () {
          if (!{"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation) {
            self.selectedService = '';
          }
          self.getQuote();
        }, 500);
      }

      //code
      if (data.field === 'pickup' && data.keyInput != this.$store.state.rsvpDetails.basicInfo.tripInfo.pickup.title) {
        this.driverOverrideValidation.pickup = false;
        this.paymentBonusEnabled = false;
        this.paymentBonus = 0;
      } else {
        this.driverOverrideValidation.pickup = true;
      }
      if (data.field === 'dropoff' && data.keyInput != this.$store.state.rsvpDetails.basicInfo.tripInfo.dropoff.title) {
        this.driverOverrideValidation.dropoff = false;
        this.paymentBonusEnabled = false;
        this.paymentBonus = 0;
      } else {
        this.driverOverrideValidation.dropoff = true;
      }
      this.clearDriverPayment();
    },
    pickupAsapToggle: function pickupAsapToggle() {
      this.pickupAsap = !this.pickupAsap;
      this.getQuote();
    },
    getQuote: function getQuote() {
      var useMtechPickupDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var self = this;
      var asap = this.pickupAsap;

      var rsvpEdit = self.$store.state.rsvpDetails.edit;
      if (rsvpEdit.serviceLoading || self.isNewRsvp && (!self.tripInfo.pickup || !self.tripInfo.dropoff && !self.charter.enabled)) {
        return;
      }

      if (self.charter.enabled) {
        var startDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(self.charter.startDate, 'MM/DD/YYYY hh:mmA');
        var endDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(self.charter.endDate, 'MM/DD/YYYY hh:mmA');
        var hasError = false;
        var adminTimeBuffer = this.$store.state.settings.adminTimeBuffer;
        self.charterValidation.startDate = '';
        self.charterValidation.endDate = '';
        if (startDate.diff(__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()().add(adminTimeBuffer, 'minutes')) <= 0) {
          self.charterValidation.startDate = this.$t('rsvpDetails.edit.adminTimeBufferError', { min: adminTimeBuffer });
          hasError = true;
        }
        if (startDate.diff(endDate, 'minutes') > 0) {
          self.charterValidation.endDate = 'End date must be later than start date.';
          hasError = true;
        }
        if (hasError) {
          return;
        }
      }

      var pickupdate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()();
      var pickuptime = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()();
      if (self.pickupDate.date && self.pickupDate.date !== 'Invalid date' && !self.pickupAsap) {
        pickupdate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(self.pickupDate.date, 'MM/DD/YYYY');
        pickuptime = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(self.pickupDate.hour + ':' + self.pickupDate.minute + ' ' + self.pickupDate.amPm, "h:mm A");
      }

      var quoteData = {};
      quoteData = {
        brandId: self.tripInfo.brandId,
        pickupDate: pickupdate.format('YYYY-MM-DD'),
        pickup: self.tripInfo.pickup,
        dropoff: self.tripInfo.dropoff,
        asap: asap,
        pickupTime: pickuptime.format("HH:mm:ss")
      };

      if (self.extraStops) {
        if (self.extraStops.length) {
          quoteData.extraStops = [];
          self.extraStops.forEach(function (stop) {
            quoteData.extraStops.push({
              lat: stop.lat,
              lng: stop.lng
            });
          });
        }
      }

      self.$store.commit('rsvpDetails/setServiceLoading', true);
      if (self.charter.enabled) {
        var _startDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(self.charter.startDate, 'MM/DD/YYYY hh:mmA');
        var _endDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(self.charter.endDate, 'MM/DD/YYYY hh:mmA');
        var duration = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.duration(_endDate.diff(_startDate));
        quoteData = {
          brandId: self.tripInfo.brandId,
          pickupDate: _startDate.format('YYYY-MM-DD'),
          etaInSec: duration.asSeconds(),
          pickup: self.tripInfo.pickup,
          isCharter: true
        };
      }

      __WEBPACK_IMPORTED_MODULE_11__modules_api_reservation_details_edit__["a" /* default */].getQuote2(self, quoteData, function (res) {
        if (!self.$store.state.rsvpDetails.edit.selectedService) self.selectedService = '';
        self.$store.commit('rsvpDetails/setServiceLoading', false);
        self.disableAllService = false;
        self.validation.service = '';

        if (res.error) {
          self.disableAllService = true;
          self.selectedService = '';
          self.validation.service = self.$t('rsvpDetails.edit.serviceRestrictions');
          return;
        }

        if (self.mtech.enabled && self.extraStops && self.extraStops.length) {
          self.selectedService = '';
          self.validation.service = self.$t('rsvpDetails.edit.serviceRestrictions');
        }

        var pickup = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, self.tripInfo.pickup);
        var dropoff = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, self.tripInfo.dropoff);
        if (self.charter.enabled) {
          pickup.geofenceId = res.geofence.id;
          pickup.geofenceType = res.airport && res.airport.id ? 'airport' : res.geofence.type;
          pickup.geofenceName = res.geofence.name;
          self.$store.commit('rsvpDetails/setPickupGeofence', {
            id: pickup.geofenceId,
            name: pickup.geofenceName,
            type: pickup.geofenceType
          });
          self.$store.commit('rsvpDetails/setCharterData', {
            airportGeoId: res.airport && res.airport.id ? res.airport.id : ''
          });
          self.$store.commit('rsvpDetails/setPickup', pickup);
          self.$store.commit('rsvpDetails/setIsAirportPickup', res.airport && res.airport.id);
        } else {
          if (res.lyft) {
            pickup.geofenceId = '';
            pickup.geofenceType = '';
            pickup.geofenceName = '';
          } else {
            pickup.geofenceId = res.geofences.pickup.id;
            pickup.geofenceType = res.geofences.pickup.type;
            pickup.geofenceName = res.geofences.pickup.description;
            self.$store.commit('rsvpDetails/setPickupGeofence', {
              id: res.geofences.pickup.id,
              name: res.geofences.pickup.description,
              type: res.geofences.pickup.type
            });
            dropoff.geofenceId = res.geofences.dropoff.id;
            dropoff.geofenceType = res.geofences.dropoff.type;
            dropoff.geofenceName = res.geofences.dropoff.description;
            self.$store.commit('rsvpDetails/setDropoffGeofence', {
              id: res.geofences.dropoff.id,
              name: res.geofences.dropoff.description,
              type: res.geofences.dropoff.type
            });
          }
          self.$store.commit('rsvpDetails/setPickup', pickup);
          self.$store.commit('rsvpDetails/setDropoff', dropoff);

          if (!res.lyft) {
            self.$store.commit('rsvpDetails/setIsAirportPickup', res.geofences.pickup.type === 'airport');
            self.$store.commit('rsvpDetails/setIsAirportDropoff', res.geofences.dropoff.type === 'airport');
          }
        }

        if (res.lyft) {
          self.currentGeofence = '';
        } else {
          self.currentGeofence = res.geofence ? res.geofence.name : res.geofences.servicearea.name;
        }
        // if (res.geofences.pickup.type === 'servicearea') {
        // } else if (res.geofences.dropoff.type === 'servicearea') {
        //   self.currentGeofence = res.geofences.dropoff.description
        // }

        if (useMtechPickupDate && self.mtech.enabled && res.mtech && res.mtech.services.length) {
          var pickupDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(res.mtech.services[0].pickupTimes[0].unix, 'X');
          if (self.selectedService) {
            pickupDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(self.mtech.services[self.selectedService].pickupTimes[0].unix, 'X');
          }
          self.$store.commit('rsvpDetails/setPickupDate', pickupDate.tz(self._edit.timezone).format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_14__modules_api_featureToggle__["a" /* default */].timeFormat(self, false)));
        }

        if (self.mtech.enabled && self.selectedService) {
          self.getQuoteMtechService();
        }
      });

      if (!this._edit.timezoneLoading && this.timezoneInfo.pickup !== this.tripInfo.pickup.title) {
        self.$store.commit('rsvpDetails/setTimezoneLoading', true);
        __WEBPACK_IMPORTED_MODULE_13__modules_api_location__["a" /* default */].getTimezone(self, {
          lat: self.tripInfo.pickup.lat,
          lng: self.tripInfo.pickup.lng
        }, function (res) {
          self.timezoneInfo = {
            pickup: self.tripInfo.pickup.title,
            tz: res
          };
          self.$store.commit('rsvpDetails/setTimezoneLoading', false);
          self.$store.commit('rsvpDetails/setTimezone', res);
        });
      }
    },
    changeDate: function changeDate() {
      var self = this;
      self.pickupDate.date = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(self.pickupDate.date).format('MM/DD/YYYY');
      self.updatePickupDate();
      setTimeout(function () {
        self.getQuote();
      }, 20);
    },
    updatePickupDate: function updatePickupDate() {
      var _this4 = this;

      var pickupDate = this.pickupDate.date + ' ' + this.pickupDate.hour + ':' + this.pickupDate.minute + '' + this.pickupDate.amPm;
      if (this.$settings.get('MilitaryTimeBackoffice') === '1') {
        pickupDate = this.pickupDate.date + ' ' + this.pickupDate.hour + ':' + this.pickupDate.minute;
      }
      this.$store.commit('rsvpDetails/setPickupDate', pickupDate);
      this.sharedAllowedTime(this.selectedService);
      setTimeout(function () {
        _this4.getQuote();
      }, 20);
    },
    priceOverrideToggle: function priceOverrideToggle() {
      var self = this;
      if (!self.priceOverrideAccess) {
        return;
      }
      self.priceOverrideEnabled = !self.priceOverrideEnabled;
      self.$nextTick(function () {
        return self.$refs.priceOverride.focus();
      });
    },
    driverOverrideToggle: function driverOverrideToggle() {
      var self = this;
      self.driverOverrideEnabled = !self.driverOverrideEnabled;
      if (self.driverOverrideEnabled) {
        self.$store.commit('rsvpDetails/setTip', 0);
      }
      self.$nextTick(function () {
        return self.$refs.driverOverride.focus();
      });
    },
    paymentBonusToggle: function paymentBonusToggle() {
      var self = this;
      if (!self.overrideAccess) {
        return;
      }
      self.paymentBonusEnabled = !self.paymentBonusEnabled;
      if (self.paymentBonusEnabled == false) {
        self.$store.commit('rsvpDetails/setpaymentBonus', 0);
        self.paymentBonus = 0;
      }
      self.$nextTick(function () {
        return self.$refs.paymentBonus.focus();
      });
    },
    save: function save() {
      var self = this;

      if (!self.validateFields()) {
        return;
      }

      var newData = self.buildData();
      var oldData = this.$store.state.rsvpDetails.basicInfo.tripInfo;
      var oldTotalAmount = oldData.tip + oldData.fare + oldData.pickupFee + oldData.airportFee + oldData.travelInsurance + oldData.gasFee + (oldData.portalFee || 0) - oldData.credits;
      oldTotalAmount = oldTotalAmount < 0 ? 0 : oldTotalAmount;
      if (oldTotalAmount % 1 > 0) {
        oldTotalAmount = parseFloat(oldTotalAmount.toFixed(2));
      }

      if (newData.payment.total !== oldTotalAmount && newData.payment.total > 0 && !self.waivePayments) {
        var xOldAmount = self.applyCurrency(self.toFixed(oldTotalAmount));
        var origCurrency = this.$store.state.rsvpDetails.currency;
        var xNewAmount = self.applyCurrency(self.toFixed(newData.payment.total));
        if (self.currencyCode !== 'USD') {
          xOldAmount = origCurrency.airportFee + origCurrency.amount + origCurrency.gasFee + origCurrency.pickupFee + origCurrency.tipAmount + origCurrency.travelInsurance - origCurrency.credit;
          // xOldAmount = `${origCurrency.symbol}${xOldAmount}`
          xOldAmount = self.xcurrency.format({
            code: self.currency.code,
            val: self.toFixed(xOldAmount)
          });
          xNewAmount = self.xcurrency.format({
            code: self.currency.code,
            val: self.toFixed(self.paymentSummaryData.totalIntnl)
          });
        }
        var lowHigh = newData.payment.total > oldTotalAmount ? 'higher' : 'lower';
        var label = '<div class="text-left">' + this.$t('rsvpDetails.edit.priceChange') + '</div>';
        label += '<div class="price-difference">' + this.$t('rsvpDetails.edit.totalFareChange');
        label += '<span>' + xOldAmount + '</span>';
        label += '<i class="fas fa-angle-right"></i>';
        label += '<span class="' + lowHigh + '">' + xNewAmount + '</span>';
        label += '</div>';
        self.$store.commit('reservationNotes/show', {
          rsvpId: self.tripInfo.id,
          action: 'editRsvp',
          label: label,
          actionData: newData
        });
      } else {
        self.$store.commit('rsvpDetails/setIsSaving', true);
        __WEBPACK_IMPORTED_MODULE_11__modules_api_reservation_details_edit__["a" /* default */].updateRsvp(self, newData, function (res) {
          self.$store.commit('rsvpDetails/setIsSaving', false);

          var status = 'success';
          var msg = self.$t('rsvpDetails.edit.updateSuccessMsg', { id: newData.rsvpId });
          if (res.error) {
            msg = res.error.message;
            if (res.error.code === 'GATE402001') {
              msg = 'Unable to update this reservation. Payment information cannot be processed.';
            }
            status = 'error';
          }
          self.$store.commit('rsvpDetails/setShowUpdateReturn', {
            show: true,
            message: msg,
            status: status
          });
        });
      }
    },
    buildData: function buildData() {
      var pickup = this.tripInfo.pickup;
      var dropoff = this.tripInfo.dropoff;
      var timezone = this.$store.state.rsvpDetails.edit.timezone;
      var pickupDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(this.tripInfo.pickupDate, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_14__modules_api_featureToggle__["a" /* default */].timeFormat(this, false), timezone);
      var selectedService = this.servicePrices[this.selectedService];
      var servicePrice = selectedService.prices[this.tripInfo.passenger - 1];
      var fare = parseFloat(servicePrice.price);
      var travelInsurance = selectedService.travelInsurance || 0;
      var gasFee = selectedService.gasFee || 0;
      var portalFee = 0;
      if (__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.tripInfo.pickupDate, 'MM/DD/YYYY').format('YYYY-MM-DD') === this.holidayData.date) {
        fare = parseInt(this.holidayPricing({
          code: selectedService.code,
          price: servicePrice.original
        }));
      }

      if (selectedService.portalFee) {
        portalFee = selectedService.portalFee;
        if (selectedService.portalFeeType === '%') portalFee = parseFloat((fare * (selectedService.portalFee / 100)).toFixed(2));
      }

      var originalRsvpData = this.$store.state.rsvpDetails.basicInfo.tripInfo;
      var oldExtraStops = this.$store.state.rsvpDetails.extraStops;
      var newExtraStops = this.tripInfo.extraStops;
      var hasExtraStopChanges = false;
      if (oldExtraStops.length) {
        if (oldExtraStops.length !== newExtraStops.length) {
          hasExtraStopChanges = true;
        } else {
          oldExtraStops.forEach(function (stop, index) {
            if (stop.lat !== newExtraStops[index].lat || stop.lng !== newExtraStops[index].lng) {
              hasExtraStopChanges = true;
            }
          });
        }
      } else if (newExtraStops.length) {
        hasExtraStopChanges = true;
      }
      if (originalRsvpData.pickupDate.substring(0, 10) === this.tripInfo.pickupDate.substring(0, 10) && (this.constructAdress(originalRsvpData.pickup) === this.constructAdress(this.tripInfo.pickup) || originalRsvpData.pickup.geofenceType === 'airport' && this.tripInfo.pickup.geofenceType === 'airport' && originalRsvpData.pickup.geofenceId === this.tripInfo.pickup.geofenceId) && (this.constructAdress(originalRsvpData.dropoff) === this.constructAdress(this.tripInfo.dropoff) || originalRsvpData.dropoff.geofenceType === 'airport' && this.tripInfo.dropoff.geofenceType === 'airport' && originalRsvpData.dropoff.geofenceId === this.tripInfo.dropoff.geofenceId) &&
      // this.constructAdress(originalRsvpData.pickup) === this.constructAdress(this.tripInfo.pickup) &&
      // this.constructAdress(originalRsvpData.dropoff) === this.constructAdress(this.tripInfo.dropoff) &&
      originalRsvpData.passenger === this.tripInfo.passenger && originalRsvpData.serviceCode === this.selectedService && !hasExtraStopChanges && !this.charter.enabled || this.charter.enabled && (this.constructAdress(originalRsvpData.pickup) === this.constructAdress(this.tripInfo.pickup) || originalRsvpData.pickup.geofenceType === 'airport' && originalRsvpData.pickup.geofenceId === this.tripInfo.pickup.geofenceId) && originalRsvpData.pickupDate === this.charter.startDate && __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.charter.startDate, 'MM/DD/YYYY hh:mmA').add(originalRsvpData.eta, 'seconds').format('MM/DD/YYYY hh:mmA') === this.charter.endDate || this.waivePayments) {
        fare = parseFloat(originalRsvpData.fare);
        travelInsurance = originalRsvpData.travelInsurance;
        gasFee = originalRsvpData.gasFee;
        portalFee = originalRsvpData.portalFee;
      }
      var pickupType = '';
      var pickupFee = 0;
      var flightName = '';
      var flightNumber = '';
      var dropoffFlightName = '';
      var dropoffFlightNumber = '';
      if (this.tripInfo.isAirportPickup) {
        pickupType = this.isMeetAndGreet ? 'MeetAndGreet' : 'Curbside';
        pickupFee = this.isMeetAndGreet ? selectedService.pickupFee : 0;
        flightName = this.tripInfo.airline;
        flightNumber = this.tripInfo.flightNo;
      } else if (this.editData.tripInfo.aptGate !== '') {
        pickup.title += ' Apt/Gate: ' + this.editData.tripInfo.aptGate;
        if (pickup.address2.indexOf(' Apt/Gate: ') > -1) {
          pickup.address2 = pickup.address2.split(' Apt/Gate: ')[0] + ' Apt/Gate: ' + this.editData.tripInfo.aptGate;
        } else {
          pickup.address2 += ' Apt/Gate: ' + this.editData.tripInfo.aptGate;
        }
      }
      if (!this.tripInfo.isAirportPickup && this.tripInfo.isAirportDropoff) {
        dropoffFlightName = this.tripInfo.airline;
        dropoffFlightNumber = this.tripInfo.flightNo;
      }
      if (this.editData.tripInfo.aptGateDropoff !== '') {
        dropoff.title += ' Apt/Gate: ' + this.editData.tripInfo.aptGateDropoff;
        if (dropoff.address2.indexOf(' Apt/Gate: ') > -1) {
          dropoff.address2 = pickup.address2.split(' Apt/Gate: ')[0] + ' Apt/Gate: ' + this.editData.tripInfo.aptGateDropoff;
        } else {
          dropoff.address2 += ' Apt/Gate: ' + this.editData.tripInfo.aptGateDropoff;
        }
      }

      var airportFee = selectedService.airportFee;

      var priceOverride = 0;
      if (this.priceOverrideEnabled && !this.waivePayments) {
        priceOverride = this.priceOverride;
        fare = parseFloat(this.priceOverride);
        pickupFee = 0;
        // portalFee = 0
        if (selectedService.portalFee && selectedService.portalFeeType === '%') {
          portalFee = parseFloat((fare * (selectedService.portalFee / 100)).toFixed(2));
        }
      }
      var driverOverride = 0;
      if (this.driverOverrideEnabled && this.paymentBonusEnabled) {
        driverOverride = this.driverOverride;
      }

      var paymentBonus = 0;
      if (this.paymentBonusEnabled) {
        paymentBonus = this.paymentBonus;
      }

      var tip = this.tripInfo.tip || 0;
      var credits = this.tripInfo.credits;
      var totalAmount = airportFee + gasFee + portalFee + travelInsurance + parseFloat(tip) + fare + parseInt(pickupFee) - parseInt(credits);
      totalAmount = totalAmount < 0 ? 0 : totalAmount;
      if (totalAmount % 1 > 0) {
        totalAmount = parseFloat(totalAmount.toFixed(2));
      }

      var brandId = this.tripInfo.brandId;
      var index = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands).findIndex(function (x) {
        return x.id === brandId;
      });
      var isHudson = index > -1 && {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[index].code === 'pts';

      var cardId = this.customerInfo.creditCardId;
      if (this.createUser.paymentMethod === 'directBilling') {
        cardId = null;
      }
      var payload = {
        rsvpId: this.tripInfo.id,
        token: this.$store.state.session.sessionToken,
        brandId: this.tripInfo.brandId,
        guest: {
          firstName: this.guestInfo.firstName,
          lastName: this.guestInfo.lastName,
          mobile: this.guestInfo.mobile,
          countryCode: ''
        },
        legs: [{
          pickup: pickup,
          dropoff: this.tripInfo.dropoff,
          pickupTime: pickupDate.format('X'),
          passengers: this.tripInfo.passenger,
          luggage: this.tripInfo.luggage,
          amount: fare,
          originalPrice: servicePrice.original,
          flightNumber: flightNumber,
          flightName: flightName,
          dropoffFlightName: dropoffFlightName,
          dropoffFlightNumber: dropoffFlightNumber,
          asap: this.tripInfo.isAsap,
          etaInSec: this.tripInfo.eta,
          serviceTypeId: selectedService.id,
          serviceType: selectedService.code,
          pickupType: pickupType,
          pickupFee: pickupFee,
          distance: this.tripInfo.distance,
          notes: this.tripInfo.notes,
          airportFee: airportFee,
          gasFee: gasFee,
          travelInsurance: travelInsurance,
          extraStops: [],
          isCharter: this.charter.enabled,
          optinShared: null,
          portalFee: portalFee
        }, null],
        payment: {
          cardID: cardId,
          tip: tip,
          total: totalAmount,
          fare: fare,
          pickupFee: pickupFee,
          promo: credits,
          driverBonus: paymentBonus
        },
        wheelchair: this.wheelchairEnabled,
        serviceDog: this.serviceDogEnabled,
        source: 'A',
        deviceType: 'admin',
        overridePrice: priceOverride,
        overridePayment: driverOverride,
        hudson: isHudson,
        noEmail: !this.sendEmailReminder
        // if (payload.guest.mobile) {
        //   payload.guest.mobile = `+${this.callingCode}${this.guestInfo.mobile}`
        //   payload.guest.countryCode = this.callingCode
        //   payload.guest.nationalNumber = this.guestInfo.mobile
        // }
      };if (!{"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation && selectedService.id > 5) {
        delete payload.legs[0].serviceType;
      }
      var self = this;
      if (self.extraStops && self.extraStops.length && !this.charter.enabled) {
        payload.legs[0].extraStops = [];
        self.extraStops.forEach(function (stop) {
          payload.legs[0].extraStops.push({
            address1: stop.address1,
            address2: stop.address2,
            city: stop.city,
            state: stop.state,
            zip: stop.zip,
            lat: stop.lat,
            lng: stop.lng,
            title: stop.title
          });
        });
      }

      if (this.charter.enabled) {
        var startDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.charter.startDate, 'MM/DD/YYYY hh:mmA');
        var endDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.charter.endDate, 'MM/DD/YYYY hh:mmA');
        payload.isCharter = true;
        payload.legs[0].pickupTime = startDate.format('X');
        payload.legs[0].etaInSec = endDate.diff(startDate, 'seconds');
        payload.legs[0].airportGeofenceId = this.airportPickup ? this.charter.airportGeoId : null;
        delete payload.legs[0].dropoff;
        // delete payload.legs[0].passengers
        // delete payload.legs[0].luggage
        delete payload.legs[0].distance;
        delete payload.legs[0].dropoffFlightName;
        delete payload.legs[0].dropoffFlightNumber;
        delete payload.legs[0].travelInsurance;
      }

      if (this.optin.enabled) {
        payload.legs[0].optinShared = {
          serviceTypeId: selectedService.id,
          amount: parseFloat(this.optinSharedPrice().toFixed(2))
        };
      }

      if (this.currency.code !== 'USD') {
        payload.legs[0].currency = {
          code: this.currency.code,
          exchangeRate: this.currency.value,
          amount: this.applyCurrency(fare, false),
          tipAmount: this.tipIntnl,
          pickupFee: this.applyCurrency(pickupFee, false),
          airportFee: this.applyCurrency(airportFee, false),
          gasFee: this.applyCurrency(gasFee, false),
          travelInsurance: this.applyCurrency(travelInsurance, false)
        };
        if (this.priceOverrideEnabled) {
          payload.legs[0].currency.amount = this.priceOverrideIntnl;
        }
        if (this.currency.code === 'JPY') {
          payload.legs[0].currency.amount = parseFloat(__WEBPACK_IMPORTED_MODULE_16__modules_api_currency__["a" /* default */].format({ code: 'JPY', val: payload.legs[0].currency.amount }, false).replaceAll(',', ''));
          payload.legs[0].currency.tipAmount = parseFloat(__WEBPACK_IMPORTED_MODULE_16__modules_api_currency__["a" /* default */].format({ code: 'JPY', val: payload.legs[0].currency.tipAmount }, false).replaceAll(',', ''));
          payload.legs[0].currency.pickupFee = parseFloat(__WEBPACK_IMPORTED_MODULE_16__modules_api_currency__["a" /* default */].format({ code: 'JPY', val: payload.legs[0].currency.pickupFee }, false).replaceAll(',', ''));
          payload.legs[0].currency.airportFee = parseFloat(__WEBPACK_IMPORTED_MODULE_16__modules_api_currency__["a" /* default */].format({ code: 'JPY', val: payload.legs[0].currency.airportFee }, false).replaceAll(',', ''));
          payload.legs[0].currency.gasFee = parseFloat(__WEBPACK_IMPORTED_MODULE_16__modules_api_currency__["a" /* default */].format({ code: 'JPY', val: payload.legs[0].currency.gasFee }, false).replaceAll(',', ''));
          payload.legs[0].currency.travelInsurance = parseFloat(__WEBPACK_IMPORTED_MODULE_16__modules_api_currency__["a" /* default */].format({ code: 'JPY', val: payload.legs[0].currency.travelInsurance }, false).replaceAll(',', ''));
        }
      }

      if (this.waivePayments) payload.freeChange = true;

      return payload;
    },
    validateFields: function validateFields() {
      var _this5 = this;

      var noError = true;
      this.cleanValidation();

      if (this.isCustomPickupLocation && !this.customPickupForceValid) {
        this.validation.pickupLocation = this.$t('rsvpDetails.edit.emptyField');
        noError = false;
      }
      if (!this.isCustomPickupLocation && this.pickupAirportId === 0) {
        this.validation.pickupAirport = this.$t('rsvpDetails.edit.selectError');
        noError = false;
      }
      if (this.isCustomDropoffLocation && !this.customDropoffForceValid && !this.charter.enabled) {
        this.validation.dropoffLocation = this.$t('rsvpDetails.edit.emptyField');
        noError = false;
      }
      if (!this.isCustomDropoffLocation && this.dropoffAirportId === 0 && !this.charter.enabled) {
        this.validation.dropoffLocation = this.$t('rsvpDetails.edit.selectError');
        noError = false;
      }
      var dateObj = this.charter.enabled ? this.startDate : this.pickupDate;
      var selectedDate = dateObj.date + ' ' + dateObj.hour + ':' + dateObj.minute + dateObj.amPm;
      var selectedDateFormat = 'MM/DD/YYYY hh:mmA';
      if (this.$settings.get('MilitaryTimeBackoffice') === '1') {
        selectedDate = dateObj.date + ' ' + dateObj.hour + ':' + dateObj.minute;
        selectedDateFormat = 'MM/DD/YYYY HH:mm';
      }
      var adminTimeBuffer = this.$store.state.settings.adminTimeBuffer;
      var timezone = this.$store.state.rsvpDetails.edit.timezone;
      if (__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(selectedDate, selectedDateFormat, timezone).format('x') < __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()().add(adminTimeBuffer, 'minutes').format('x') && !this.pickupAsap) {
        if (this.charter.enabled) {
          this.charterValidation.startDate = this.$t('rsvpDetails.edit.adminTimeBufferError', { min: adminTimeBuffer });
        } else {
          this.validation.pickupTime = this.$t('rsvpDetails.edit.adminTimeBufferError', { min: adminTimeBuffer });
        }
        noError = false;
      }
      if (!this.isFreshDeliveries && !this.$store.state.rsvpDetails.lyft.enabled) {
        if ((this.airportPickup || {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.featureToggle.requiredDropoffAirport && this.airportDropoff) && (!this.editData.tripInfo.airline || this.editData.tripInfo.airline.trim() === '') && !this.pickupAsap) {
          this.validation.airline = this.$t('rsvpDetails.edit.emptyField');
          noError = false;
        }
        if ((this.airportPickup || {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.featureToggle.requiredDropoffAirport && this.airportDropoff) && (!this.editData.tripInfo.flightNo || this.editData.tripInfo.flightNo.trim() === '') && !this.pickupAsap) {
          this.validation.flight = this.$t('rsvpDetails.edit.emptyField');
          noError = false;
        }
      }
      if ((this.bookingForSomeone || this.isCorporate) && this.editData.guestInfo.firstName.trim() === '') {
        this.validation.guestFirstName = this.$t('rsvpDetails.edit.emptyField');
        noError = false;
      }
      if ((this.bookingForSomeone || this.isCorporate) && this.editData.guestInfo.lastName.trim() === '') {
        this.validation.guestLastName = this.$t('rsvpDetails.edit.emptyField');
        noError = false;
      }
      if (this.isCorporate && this.editData.guestInfo.mobile.trim() === '') {
        this.validation.guestMobile = this.$t('rsvpDetails.edit.emptyField');
        noError = false;
      }
      if (!this.selectedService) {
        this.validation.service = this.$t('rsvpDetails.edit.selectService');
        if (this.disableAllService) {
          this.validation.service = this.$t('rsvpDetails.edit.serviceRestrictions');
        }
        noError = false;
      }
      if (this.priceOverrideEnabled && this.priceOverride.toString().trim() === '') {
        this.validation.priceOverride = this.$t('rsvpDetails.edit.emptyField');
        noError = false;
      }
      if (this.priceOverrideEnabled && parseFloat(this.priceOverride) <= 0) {
        this.validation.priceOverride = this.$t('rsvpDetails.edit.zeroValue');
        noError = false;
      }
      if (this.driverOverrideEnabled && this.driverOverride.toString().trim() === '') {
        this.validation.driverOverride = this.$t('rsvpDetails.edit.emptyField');
        noError = false;
      }
      if (this.driverOverrideEnabled && parseFloat(this.driverOverride) <= 0) {
        this.validation.driverOverride = this.$t('rsvpDetails.edit.zeroValue');
        noError = false;
      }
      var fare = parseFloat(this.paymentBonusComputation.limitAmount).toFixed(2);
      if (this.paymentBonusEnabled && parseFloat(this.paymentBonus) > this.paymentBonusComputation.limitAmount) {
        this.validation.paymentBonus = this.$t('rsvpDetails.edit.beyondLimit', { fare: fare });
        noError = false;
      }

      if (this.paymentBonusEnabled && !!parseFloat(this.paymentBonus) === false) {
        this.validation.paymentBonus = 'Not a number.';
        noError = false;
      }

      if (this.paymentBonusEnabled && parseFloat(this.paymentBonus) <= 0) {
        this.validation.paymentBonus = 'Value cannot be less than or equal to zero';
        noError = false;
      }

      if (this.isNewRsvp) {
        if (!this.customerInfo.firstName && !this.createUser.show) {
          this.validation.userSelected = 'No target customer.';
          noError = false;
        }
        if (!this.createUser.notes && this.createUser.paymentMethod === 'otherMeans') {
          this.validation.userNotes = this.$t('rsvpDetails.edit.emptyField');
          noError = false;
        }
        if (!this.createUser.noteStatus && this.createUser.paymentMethod === 'otherMeans') {
          this.validation.userNotesStatus = 'Please select note status';
          noError = false;
        }
        if (this.createUser.paymentMethod === 'newCard') {
          if (this.isD2D) {
            if (!this.stripeStore.cardOwner || !this.stripeStore.address || !this.stripeStore.userCity || !this.stripeStore.userZip || this.stripeStore.userState == '..' || this.stripeStore.userState == '..' && !this.stripeStore.userCountry) {
              noError = false;
            }
          } else {
            if (!this.createUser.cardOwner) {
              this.validation.userCardOwner = this.$t('rsvpDetails.edit.emptyField');
              noError = false;
            }
            if (!this.createUser.creditCard) {
              this.validation.userCreditCard = this.$t('rsvpDetails.edit.emptyField');
              noError = false;
            }
            if (!this.createUser.cardExp) {
              this.validation.userCardExp = this.$t('rsvpDetails.edit.emptyField');
              noError = false;
            }
            if (!this.createUser.cvv) {
              this.validation.userCvv = this.$t('rsvpDetails.edit.emptyField');
              noError = false;
            }
            if (!this.createUser.address) {
              this.validation.userAddress = this.$t('rsvpDetails.edit.emptyField');
              noError = false;
            }
            if (!this.createUser.city) {
              this.validation.userCity = this.$t('rsvpDetails.edit.emptyField');
              noError = false;
            }
            if (this.createUser.country === '' && !this.createUser.state) {
              this.validation.userCountry = this.$t('rsvpDetails.edit.emptyField');
              noError = false;
            }
            if (this.createUser.state === '..') {
              this.validation.userState = this.$t('rsvpDetails.edit.emptyField');
              noError = false;
            }
          }
        }
        // if (!this.createUser.zip && this.createUser.paymentMethod === 'newCard') {
        //  this.validation.userZip = this.$t('rsvpDetails.edit.emptyField')
        //  noError = false
        // }
        if (this.customerInfo.firstName && this.createUser.selectedCard === '' && this.createUser.paymentMethod === 'oldCard') {
          this.validation.creditCard = this.$t('rsvpDetails.edit.emptyField');
          noError = false;
        }
        if (!this.isD2D) {
          if (this.createUser.show && !this.createUser.firstName) {
            this.validation.userFirstName = this.$t('rsvpDetails.edit.emptyField');
            noError = false;
          }
          if (this.createUser.show && !this.createUser.lastName) {
            this.validation.userLastName = this.$t('rsvpDetails.edit.emptyField');
            noError = false;
          }
          if (this.createUser.show && !this.createUser.email) {
            this.validation.userEmail = this.$t('rsvpDetails.edit.emptyField');
            noError = false;
          }
          if (this.createUser.show && !this.createUser.mobile) {
            this.validation.userMobile = this.$t('rsvpDetails.edit.emptyField');
            noError = false;
          }
          if (this.createUser.show && this.createUser.paymentMethod === 'newCard' && !this.createUser.cardOwner) {
            this.validation.userCardOwner = this.$t('rsvpDetails.edit.emptyField');
            noError = false;
          }
          if (this.createUser.show && this.createUser.paymentMethod === 'newCard' && !this.createUser.creditCard) {
            this.validation.userCreditCard = this.$t('rsvpDetails.edit.emptyField');
            noError = false;
          }
          if (this.createUser.show && this.createUser.paymentMethod === 'newCard' && !this.createUser.cardExp) {
            this.validation.userCardExp = this.$t('rsvpDetails.edit.emptyField');
            noError = false;
          }
          if (this.createUser.show && this.createUser.paymentMethod === 'newCard' && !this.createUser.cvv) {
            this.validation.userCvv = this.$t('rsvpDetails.edit.emptyField');
            noError = false;
          }
          if (this.createUser.show && this.createUser.paymentMethod === 'newCard' && !this.createUser.address) {
            this.validation.userAddress = this.$t('rsvpDetails.edit.emptyField');
            noError = false;
          }
          if (this.createUser.show && this.createUser.paymentMethod === 'newCard' && !this.createUser.city) {
            this.validation.userCity = this.$t('rsvpDetails.edit.emptyField');
            noError = false;
          }
        }
        // if (this.createUser.show && this.createUser.paymentMethod === 'newCard' && !this.createUser.state) {
        //   this.validation.userState = this.$t('rsvpDetails.edit.emptyField')
        //   noError = false
        // }
        // if (this.createUser.show && this.createUser.paymentMethod === 'newCard' && !this.createUser.zip) {
        //   this.validation.userZip = this.$t('rsvpDetails.edit.emptyField')
        //   noError = false
        // }
        if (this.createUser.show && !this.createUser.paymentMethod === 'newCard' && !this.createUser.notes) {
          this.validation.userNotes = this.$t('rsvpDetails.edit.emptyField');
          noError = false;
        }
        if (this.createUser.show && !this.createUser.paymentMethod === 'newCard' && !this.createUser.noteStatus) {
          this.validation.userNotesStatus = this.$t('rsvpDetails.edit.emptyField');
          noError = false;
        }

        if (this.isD2D && this.createUser.show) {
          var _self = this;
          var fields = ['birthday', 'address', 'city', 'zip', 'country'];
          fields.forEach(function (x) {
            if (!_self.d2dUser[x]) {
              _self.d2dValidation[x] = _self.$t('rsvpDetails.edit.emptyField');
              noError = false;
            }
          });
        }
      }

      var self = this;
      if (this.extraStops && !this.charter.enabled) {
        if (this.extraStops.length) {
          this.extraStops.forEach(function (stop) {
            if (!stop.lat || !stop.lng) {
              self.$store.commit('rsvpDetails/setExtraStopData', {
                id: stop.id,
                fields: { error: _this5.$t('rsvpDetails.edit.emptyField') }
              });
              noError = false;
            }
          });
        }
      }

      if (this.charter.enabled) {
        var startDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(self.charter.startDate, 'MM/DD/YYYY hh:mmA');
        var endDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(self.charter.endDate, 'MM/DD/YYYY hh:mmA');
        if (startDate.diff(endDate, 'minutes') > 0) {
          noError = false;
        }
        if (endDate.diff(startDate, 'minutes') > this.charterMaxDura) {
          noError = false;
        }
        if (self.charter.startDate === self.charter.endDate) {
          noError = false;
        }
      }

      return noError;
    },
    cleanValidation: function cleanValidation() {
      this.validation = {
        pickupLocation: '',
        pickupAirport: '',
        dropoffLocation: '',
        dropoffAirport: '',
        pickupTime: '',
        airline: '',
        flight: '',
        guestFirstName: '',
        guestLastName: '',
        service: '',
        tip: '',
        priceOverride: '',
        driverOverride: '',
        paymentBonus: '',
        userSelected: '',
        creditCard: '',
        userFirstName: '',
        userLastName: '',
        userEmail: '',
        userMobile: '',
        userCardOwner: '',
        userCreditCard: '',
        userCardExp: '',
        userCvv: '',
        userAddress: '',
        userCity: '',
        userState: '',
        userZip: '',
        userNotes: '',
        userNotesStatus: ''
      }, this.d2dValidation = {
        birthday: '',
        address: '',
        city: '',
        zip: '',
        country: ''
      };
      this.driverOverrideValidation = {
        pickupAirport: true,
        dropoffAirport: true,
        selectedService: true,
        pickup: true,
        dropoff: true,
        servicePickup: true,
        serviceDropoff: true,
        selectAirportPickup: true,
        selectAirportDropoff: true
      };
    },
    showFlightInput: function showFlightInput() {
      return this.tripInfo.isAirportDropoff || this.tripInfo.isAirportPickup;
    },
    initNewRsvp: function initNewRsvp() {
      var self = this;
      self.cleanValidation();

      var timeNow = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()();
      var timeFixed = parseInt(timeNow.format('mm')) % 5;
      if (timeFixed > 0) {
        timeNow = timeNow.add(5, 'minutes').subtract(timeFixed, 'minutes');
      }
      timeNow = timeNow.add(this.$settings.get('AdminTimeBuffer'), 'minutes');
      var timeFormat = this.$settings.get('MilitaryTimeBackoffice') === '1' ? 'MM/DD/YYYY HH:mm' : 'MM/DD/YYYY hh:mmA';
      this.$store.commit('rsvpDetails/setPickupDate', timeNow.format(timeFormat));
      this.$store.commit('rsvpDetails/setMtechData', { flightDate: timeNow.format(timeFormat) });
      this.$store.commit('rsvpDetails/setCharterData', {
        startDate: timeNow.format(timeFormat)
        // endDate: timeNow.add(self.charterMaxDura, 'minutes').format(timeFormat)
      });
    },
    initCreateUser: function initCreateUser() {
      this.createUser.show = true;

      this.$store.commit('rsvpDetails/setCustomerInfo', {
        id: '',
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        countryCode: ''
      });
      this.$store.commit('rsvpDetails/setIsCorporate', false);
    },
    isNumber: function isNumber(evt) {
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
        return;
      }
      return true;
    },
    formatExpCC: function formatExpCC() {
      var cardExp = this.createUser.cardExp;
      if (cardExp.length === 2 && !isNaN(cardExp)) {
        this.createUser.cardExp = cardExp + '/';
      }
    },
    charCountChecker: function charCountChecker(event) {
      if (this.createUser.notes.length > this.createUser.notesMaxChar) {
        this.createUser.notes = this.createUser.notes.substring(0, this.createUser.notesMaxChar);
        event.preventDefault();
        return;
      }
    },
    createRsvp: function createRsvp() {
      var self = this;
      if (!self.validateFields() || self.$store.state.rsvpDetails.addLoading) {
        return;
      }

      if (self.isD2D && this.createUser.paymentMethod === 'newCard') {
        if (this.createUser.show) {
          this.createD2Duser();
          return;
        }
        self.$store.commit('global/setLoaderData', { show: true });
        this.d2dStripeSetup(this.customerInfo.id);
        return;
      }
      self.$store.commit('global/setLoaderData', { show: false });

      if (this.pickupAsap && !this.charter.enabled) {
        // self.$store.commit('rsvpDetails/setAsapShow', true)
        // self.asapSubmit()
        self.$store.commit('rsvpDetails/setAsapData', self.buildCreateRsvpData());
        self.$store.commit('rsvpDetails/setAsapModal', true);
      } else {
        self.$store.commit('rsvpDetails/setAddLoading', true);
        __WEBPACK_IMPORTED_MODULE_12__modules_api_reservation_details_add__["a" /* default */].createRsvp(self, self.buildCreateRsvpData(), function (res) {
          self.$store.commit('rsvpDetails/setAddLoading', false);
          if (res.error) {
            self.$store.commit('rsvpDetails/setSubmitError', {
              show: true,
              message: res.error.message
            });
            return;
          }
          self.saveNotes(res.reservationId[0]);

          var user = self.$store.state.session.user;
          var userFullName = user.firstName + ' ' + user.lastName;
          var userEmail = user.email;
          self.$sdk.post('/admin/rsvp/' + res.reservationId[0] + '/notes', {
            token: self.$store.state.session.sessionToken,
            message: 'This RSVP was created by admin  ' + userFullName + ' (' + userEmail + ')',
            status: 'resolved',
            action: 'rsvp_add'
          }, function (r) {
            setTimeout(function () {
              self.$store.commit('rsvpDetails/setIsAdd', false);
              window.location = '/#/reservation/' + res.reservationId[0];
            }, 2000);
          });
        });
      }
    },

    // asapSubmit () {
    //   let self = this
    //   let data = self.buildCreateRsvpData()

    //   self.$store.commit('rsvpDetails/setAsapLoading', true)
    //   self.$store.commit('rsvpDetails/setFoundDriver', false)
    //   self.$store.commit('rsvpDetails/setNoDriver', false)

    //   ApiRsvpAdd.getSequestId(self, self.buildCreateRsvpData(), function (r) {
    //     if (r.error) {
    //       self.$store.commit('rsvpDetails/setNoDriver', true)
    //       self.$store.commit('rsvpDetails/setAsapLoading', false)
    //       return
    //     }

    //     self.$store.commit('rsvpDetails/setAsapBidId', r.bidId)
    //     self.getDriver()
    //   })
    // },
    // getDriver () {
    //   let self = this
    //   let sequenceID = self.$store.state.rsvpDetails.asap.bidId

    //   if (!sequenceID) {
    //     self.asapSubmit()
    //     return
    //   }

    //   self.$store.commit('rsvpDetails/setNoDriver', false)
    //   self.$sdk.get('/reservations/sequence/' + sequenceID, {}, r => {
    //     if (r.error) {
    //       self.$store.commit('rsvpDetails/setNoDriver', true)
    //       return
    //     }

    //     self.$store.commit('rsvpDetails/setAsapBidId', r.bidId)

    //     if (r.status === 'searching' || r.status === 'fail') {
    //       setTimeout(function () {
    //         self.getDriver()
    //       }, 1000)
    //       return
    //     }

    //     if (r.status === 'rejected') {
    //       self.$store.commit('rsvpDetails/setNoDriver', true)
    //       return
    //     }

    //     self.$store.commit('rsvpDetails/setFoundDriver', true)
    //     self.$store.commit('rsvpDetails/setDriverInfoLoading', true)
    //     self.saveNotes(r.rsvpId)
    //     self.$sdk.get('/admin/rsvp/' + r.rsvpId, {
    //       token: self.$store.state.session.sessionToken
    //     }, res => {
    //       self.$store.commit('rsvpDetails/setDriverInfoLoading', false)
    //       self.$store.commit('rsvpDetails/setDriverInfo', {
    //         fullName: r.provider.firstName + ' ' + r.provider.lastName,
    //         email: r.provider.email,
    //         rating: r.provider.rating,
    //         profilePic: r.provider.avatarUrl,
    //         vehiclePick: r.vehicle.photo,
    //         model: r.vehicle.model,
    //         plate: r.vehicle.plate
    //       })

    //     })

    //     let userFullName = self.createUser.firstName + ' ' + self.createUser.lastName
    //     let userEmail = self.createUser.email
    //     if (self.customerInfo.firstName) {
    //       userFullName = self.customerInfo.firstName + ' ' + self.customerInfo.lastName
    //       userEmail = self.customerInfo.email
    //     }
    //     self.$sdk.post('/admin/rsvp/' + r.rsvpId + '/notes', {
    //       token: self.$store.state.session.sessionToken,
    //       message: 'This RSVP was created by admin  ' + userFullName + ' (' + userEmail + ')',
    //       status: 'resolved',
    //       action: 'rsvp_add'
    //     }, res => {

    //     })
    //   })
    // },
    buildCreateRsvpData: function buildCreateRsvpData() {
      var _this6 = this;

      var pickup = this.tripInfo.pickup;
      var timezone = this.$store.state.rsvpDetails.edit.timezone;
      var pickupDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(this.tripInfo.pickupDate, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_14__modules_api_featureToggle__["a" /* default */].timeFormat(this, false), timezone);
      var selectedService = this.servicePrices[this.selectedService];
      var servicePrice = selectedService && selectedService.prices ? selectedService.prices[this.passenger - 1] : 0;
      var fare = parseFloat(servicePrice.price || 0);
      var pickupType = '';
      var pickupFee = 0;
      var flightName = '';
      var flightNumber = '';
      var dropoffFlightName = '';
      var dropoffFlightNumber = '';
      if (this.tripInfo.isAirportPickup) {
        pickupType = this.isMeetAndGreet ? 'MeetAndGreet' : 'Curbside';
        pickupFee = this.isMeetAndGreet ? selectedService.pickupFee : 0;
        flightName = this.tripInfo.airline;
        flightNumber = this.tripInfo.flightNo;
      } else if (this.editData.tripInfo.aptGate !== '') {
        pickup.title += ' Apt/Gate: ' + this.editData.tripInfo.aptGate;
        if (pickup.address2.indexOf(' Apt/Gate: ') > -1) {
          pickup.address2 = pickup.address2.split(' Apt/Gate: ')[0] + ' Apt/Gate: ' + this.editData.tripInfo.aptGate;
        } else {
          pickup.address2 += ' Apt/Gate: ' + this.editData.tripInfo.aptGate;
        }
      }
      if (!this.tripInfo.isAirportPickup && this.tripInfo.isAirportDropoff) {
        dropoffFlightName = this.tripInfo.airline;
        dropoffFlightNumber = this.tripInfo.flightNo;
      }

      var airportFee = selectedService ? selectedService.airportFee : 0;
      var gasFee = selectedService ? selectedService.gasFee : 0;
      if (!gasFee) gasFee = 0;
      var travelInsurance = selectedService ? selectedService.travelInsurance : 0;
      var portalFee = this.paymentSummaryData.portalFee;
      var priceOverride = 0;
      if (this.priceOverrideEnabled) {
        priceOverride = this.priceOverride;
        fare = parseFloat(this.priceOverride);
        pickupFee = 0;
        // portalFee = 0
      }
      var driverOverride = 0;
      if (this.driverOverrideEnabled) {
        driverOverride = this.driverOverride;
      }

      var paymentBonus = 0;
      if (this.paymentBonus) {
        paymentBonus = this.paymentBonus;
      }

      var tip = this.tripInfo.tip || 0;
      var credits = this.tripInfo.credits || 0;
      var totalAmount = airportFee + travelInsurance + gasFee + portalFee + parseFloat(tip) + fare + parseInt(pickupFee) - parseInt(credits);
      totalAmount = totalAmount < 0 ? 0 : totalAmount;

      var payload = {
        token: this.$store.state.session.sessionToken,
        brandId: this.tripInfo.brandId,
        guest: {
          firstName: this.guestInfo.firstName,
          lastName: this.guestInfo.lastName,
          mobile: this.guestInfo.mobile,
          countryCode: ''
        },
        legs: [{
          pickup: pickup,
          dropoff: this.tripInfo.dropoff,
          pickupTime: pickupDate.format('X'),
          passengers: this.passenger,
          luggage: this.luggage,
          amount: fare,
          originalPrice: servicePrice.original,
          flightNumber: flightNumber,
          flightName: flightName,
          dropoffFlightName: dropoffFlightName,
          dropoffFlightNumber: dropoffFlightNumber,
          asap: false,
          etaInSec: this.tripInfo.eta,
          serviceTypeId: selectedService ? selectedService.id : 0,
          pickupType: pickupType,
          pickupFee: pickupFee,
          distance: this.tripInfo.distance,
          notes: this.tripInfo.notes,
          airportFee: airportFee,
          travelInsurance: travelInsurance,
          gasFee: gasFee,
          optinShared: null,
          portalFee: portalFee
        }, null],
        payment: {
          // cardID: this.customerInfo.creditCardId,
          tip: tip,
          total: totalAmount,
          fare: fare,
          pickupFee: pickupFee,
          promo: credits
        },
        wheelchair: this.wheelchairEnabled,
        serviceDog: this.serviceDogEnabled,
        source: 'A',
        deviceType: 'admin',
        overridePrice: priceOverride,
        overridePayment: driverOverride,
        hudson: true
      };

      if (this.$store.state.rsvpDetails.lyft.enabled) {
        delete payload.legs[0].pickup.geofenceId;
        delete payload.legs[0].pickup.geofenceType;
        delete payload.legs[0].pickup.geofenceName;
        delete payload.legs[0].dropoff.geofenceId;
        delete payload.legs[0].dropoff.geofenceType;
        delete payload.legs[0].dropoff.geofenceName;
        delete payload.legs[0].serviceTypeId;
        var lyftServices = this._edit.services[this._edit.selectedService];
        payload.legs[0].lyft = {
          ride_type: lyftServices.ride_type,
          cost_token: lyftServices.cost_token,
          driver_availability_token: lyftServices.driver_availability_token || ''
        };
        payload.lyft = true;
        payload.source = 'C';
      }

      if ({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.find(function (x) {
        return x.id === _this6.editData.tripInfo.brandId;
      }).code === 'd2d') {
        payload.d2dPayment = 1;
      }
      // if (payload.guest.mobile) {
      //   payload.guest.mobile = `+${this.callingCode}${this.guestInfo.mobile}`
      //   payload.guest.countryCode = this.callingCode
      //   payload.guest.nationalNumber = this.guestInfo.mobile
      // }
      if (this.useOldQuatation) {
        payload.legs[0].serviceType = selectedService.code;
      }

      if (this.customerInfo.id) {
        payload.consumerId = this.customerInfo.id;
      } else if (this.createUser.firstName) {
        // let mobileNumber = phoneUtil.parse(this.createUser.mobile, "")
        var countryCode = this.callingCode;
        var nationalNumber = this.createUser.mobile;
        payload.consumer = {
          firstName: this.createUser.firstName,
          lastName: this.createUser.lastName,
          // phone: this.createUser.mobile,
          phone: '+' + countryCode + nationalNumber,
          email: this.createUser.email,
          wheelchair: this.wheelchairEnabled,
          serviceDog: this.serviceDogEnabled,
          countryCode: countryCode,
          nationalNumber: nationalNumber
        };
      }

      if (this.isCorporate) {
        payload.consumerId = this.customerInfo.corpConsId;
      }
      if (this.customerInfo.firstName && this.createUser.selectedCard === 'new' || this.createUser.paymentMethod === 'newCard') {
        payload.payment.card = {
          title: 'mastercard',
          number: this.createUser.creditCard,
          expiration: this.createUser.cardExp,
          name: this.createUser.cardOwner,
          cvv: this.createUser.cvv,
          billingAddress: this.createUser.address,
          billingCity: this.createUser.city,
          billingState: this.createUser.state,
          billingCountry: this.createUser.country,
          billingZip: this.createUser.zip
        };
      } else if (this.createUser.paymentMethod === 'otherMeans' || this.createUser.paymentMethod === 'directBilling') {
        payload.payment.cardID = null;
      } else if (this.createUser.paymentMethod === 'oldCard') {
        payload.payment.cardID = this.userCardlist[this.createUser.selectedCard].id;
      }

      if (this.pickupAsap) {
        payload.legs[0].asap = true;
        payload.legs[0].pickupTime = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()().unix();
      }

      if (this.extraStops) {
        if (this.extraStops.length) {
          payload.legs[0].extraStops = [];
          this.extraStops.forEach(function (stop) {
            payload.legs[0].extraStops.push({
              address1: stop.address1,
              address2: stop.address2,
              city: stop.city,
              state: stop.state,
              zip: stop.zip,
              lat: stop.lat,
              lng: stop.lng,
              title: stop.title
            });
          });
        }
      }

      if (this.charter.enabled) {
        var startDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.charter.startDate, 'MM/DD/YYYY hh:mmA');
        var endDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.charter.endDate, 'MM/DD/YYYY hh:mmA');
        payload.isCharter = true;
        payload.legs[0].pickupTime = startDate.format('X');
        payload.legs[0].etaInSec = endDate.diff(startDate, 'seconds');
        payload.legs[0].airportGeofenceId = this.airportPickup ? this.charter.airportGeoId : null;
        delete payload.legs[0].dropoff;
        // delete payload.legs[0].passengers
        // delete payload.legs[0].luggage
        delete payload.legs[0].distance;
        delete payload.legs[0].dropoffFlightName;
        delete payload.legs[0].dropoffFlightNumber;
        delete payload.legs[0].travelInsurance;
      }

      if (this.optin.enabled) {
        payload.legs[0].optinShared = {
          serviceTypeId: selectedService.id,
          amount: parseFloat(this.optinSharedPrice().toFixed(2))
        };
      }

      if (this.mtech.enabled) {
        payload.legs[0].serviceTypeId = null;
        payload.legs[0].serviceType = this.selectedService;
        // payload.legs[0].mtechServiceType = this.selectedService
        payload.legs[0].mtechServiceType = this.mtech.services[this.selectedService].product;
        payload.legs[0].pickupType = 'Curbside';
        payload.legs[0].pickupFee = 0;
        payload.legs[0].flightTime = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(this.mtech.flightDate, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_14__modules_api_featureToggle__["a" /* default */].timeFormat(this, false), timezone).format('X');
        payload.legs[0].flightAirline = this.tripInfo.airlineCode;
        payload.legs[0].flightDomestic = this.mtech.isDomestic;
        // if (this.mtech.services[this.selectedService].pickupTimes.length) {
        //   payload.legs[0].pickupTime = this.mtech.services[this.selectedService].pickupTimes[0].unix
        // }

        payload.legs[0].mtechPrice = this.mtech.services[this.selectedService].price.amount.toFixed(2);
        var breakdown = this.mtech.services[this.selectedService].price.breakdown;
        var priceBeforeCredits = this.mtech.services[this.selectedService].price.amount + this.mtech.services[this.selectedService].price.addMarkup;
        payload.legs[0].amount = parseFloat(priceBeforeCredits.toFixed(2));
        payload.legs[0].originalPrice = priceBeforeCredits.toFixed(2);
        var total = this.mtech.services[this.selectedService].price.amount + this.mtech.services[this.selectedService].price.addMarkup;
        payload.payment.total = total + parseFloat(tip) - parseInt(credits);
        payload.payment.fare = total + parseFloat(tip) - parseInt(credits);
        payload.quoteId = this.mtech.quoteId;
        payload.isMTech = this.mtech.enabled;
      }

      if (this.currency.code !== 'USD') {
        payload.legs[0].currency = {
          code: this.currency.code,
          exchangeRate: this.currency.value,
          amount: this.applyCurrency(fare, false),
          tipAmount: this.tipIntnl,
          pickupFee: this.applyCurrency(pickupFee, false),
          airportFee: this.applyCurrency(airportFee, false),
          gasFee: this.applyCurrency(gasFee, false),
          travelInsurance: this.applyCurrency(travelInsurance, false)
        };
        if (this.priceOverrideEnabled) {
          payload.legs[0].currency.amount = this.priceOverrideIntnl;
        }
        if (this.currency.code === 'JPY') {
          payload.legs[0].currency.amount = parseFloat(__WEBPACK_IMPORTED_MODULE_16__modules_api_currency__["a" /* default */].format({ code: 'JPY', val: payload.legs[0].currency.amount }, false).replaceAll(',', ''));
          payload.legs[0].currency.tipAmount = parseFloat(__WEBPACK_IMPORTED_MODULE_16__modules_api_currency__["a" /* default */].format({ code: 'JPY', val: payload.legs[0].currency.tipAmount }, false).replaceAll(',', ''));
          payload.legs[0].currency.pickupFee = parseFloat(__WEBPACK_IMPORTED_MODULE_16__modules_api_currency__["a" /* default */].format({ code: 'JPY', val: payload.legs[0].currency.pickupFee }, false).replaceAll(',', ''));
          payload.legs[0].currency.airportFee = parseFloat(__WEBPACK_IMPORTED_MODULE_16__modules_api_currency__["a" /* default */].format({ code: 'JPY', val: payload.legs[0].currency.airportFee }, false).replaceAll(',', ''));
          payload.legs[0].currency.gasFee = parseFloat(__WEBPACK_IMPORTED_MODULE_16__modules_api_currency__["a" /* default */].format({ code: 'JPY', val: payload.legs[0].currency.gasFee }, false).replaceAll(',', ''));
          payload.legs[0].currency.travelInsurance = parseFloat(__WEBPACK_IMPORTED_MODULE_16__modules_api_currency__["a" /* default */].format({ code: 'JPY', val: payload.legs[0].currency.travelInsurance }, false).replaceAll(',', ''));
        }
      }

      return payload;
    },
    removeSelectedService: function removeSelectedService() {
      this.selectService('', '');
    },
    saveNotes: function saveNotes(rsvpId) {
      var self = this;
      if (self.createUser.paymentMethod === 'otherMeans') {
        self.$sdk.post('/admin/rsvp/' + rsvpId + '/notes', {
          token: self.$store.state.session.sessionToken,
          message: self.createUser.notes,
          status: self.createUser.noteStatus,
          action: 'rsvp_add'
        }, function (res) {
          console.log('res NOTES', res);
        });
      }
    },

    //code
    clearDriverPayment: function clearDriverPayment() {
      if (this.driverOverrideValidation.pickupAirport && this.driverOverrideValidation.dropoffAirport && this.driverOverrideValidation.servicePickup && this.driverOverrideValidation.serviceDropoff && this.driverOverrideValidation.selectedService && this.driverOverrideValidation.pickup && this.driverOverrideValidation.dropoff && this.driverOverrideValidation.selectAirportPickup && this.driverOverrideValidation.selectAirportDropoff && this.$store.state.rsvpDetails.basicInfo.tripInfo.overridePayment > 0) {
        this.driverOverrideEnabled = true;
        this.driverOverride = this.$store.state.rsvpDetails.basicInfo.tripInfo.overridePayment;
        // this.paymentBonusEnabled = true
        // this.paymentBonus = this.$store.state.rsvpDetails.basicInfo.tripInfo.paymentBonus
      } else {
        this.driverOverrideEnabled = false;
        this.driverOverride = 0;
        // this.paymentBonusEnabled = false
        // this.paymentBonus = 0
      }
    },
    setScreenSize: function setScreenSize() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isDesktop = false;
        this.isMobile = true;
      } else {
        this.isDesktop = true;
        this.isMobile = false;
      }
    },
    resetPaymentMethod: function resetPaymentMethod() {
      this.createUser.paymentMethod = '';
      if (this.isCorporate) {
        this.createUser.paymentMethod = 'directBilling';
      }
    },
    setDefaultTip: function setDefaultTip() {
      if (!this.isNewRsvp || this.$store.state.rsvpDetails.isManualTip) {
        return;
      }

      var serviceData = this.servicePrices[this.selectedService];
      if (!this.selectedService || !serviceData || this.serviceDisable(this.selectedService, serviceData)) {
        this.$store.commit('rsvpDetails/setTip', 0);
        return;
      }

      var tip = serviceData.defaultTip;
      var prices = serviceData.prices;
      tip = tip / 100;
      var pax = this.tripInfo.passenger || 1;
      this.$store.commit('rsvpDetails/setTip', this.toFixed(prices[pax - 1].price * tip));
    },
    forceManualTip: function forceManualTip() {
      this.$store.commit('rsvpDetails/setIsManualTip', true);
    },
    addExtraStop: function addExtraStop() {
      this.$store.commit('rsvpDetails/addExtraStop', {
        id: __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()().format('x'),
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        title: '',
        lat: '',
        lng: '',
        error: ''
      });
    },
    removeExtraStop: function removeExtraStop() {
      var getQuote = false;
      if (this.tripInfo.extraStops.length && this.tripInfo.extraStops[0].lat && this.tripInfo.extraStops[0].lng) {
        getQuote = true;
      }
      this.$store.commit('rsvpDetails/removeExtraStop');
      if (getQuote) {
        this.getQuote();
      }
    },
    extraData: function extraData(data) {
      return {
        id: data.id,
        field: 'extraStop',
        disabled: this.waivePayments,
        brandId: this.editData.tripInfo.brandId,
        error: data.error
      };
    },
    locationNewStop: function locationNewStop() {
      var self = this;
      if (self.quoteDelay) {
        clearTimeout(self.quoteDelay);
      }
      self.quoteDelay = setTimeout(function () {
        if (!{"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation) {
          self.selectedService = '';
        }
        self.getQuote();
      }, 500);
      this.clearDriverPayment();
    },
    changeCharterDate: function changeCharterDate(field) {
      var self = this;
      self[field].date = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(self[field].date).format('MM/DD/YYYY');
      self.updateCharterTime(field);
    },
    updateCharterTime: function updateCharterTime(field) {
      var self = this;
      var _date = this[field].date + ' ' + this[field].hour + ':' + this[field].minute + '' + this[field].amPm;
      if (this.$settings.get('MilitaryTimeBackoffice') === '1') {
        _date = this[field].date + ' ' + this[field].hour + ':' + this[field].minute;
      }
      var obj = {};
      obj[field] = _date;
      this.$store.commit('rsvpDetails/setCharterData', obj);
      // this.sharedAllowedTime(this.selectedService)

      if (self.charter.startDate && self.charter.endDate) {
        var startDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(self.charter.startDate, 'MM/DD/YYYY hh:mmA');
        var endDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(self.charter.endDate, 'MM/DD/YYYY hh:mmA');
        if (startDate.diff(endDate, 'minutes') > 0) {
          self.charterValidation.endDate = 'End date must be later than start date.';
          return;
        }
        if (endDate.diff(startDate, 'minutes') > self.charterMaxDura) {
          var time = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.duration(self.charterMaxDura, 'minutes').humanize({ h: Infinity });
          self.charterValidation.endDate = 'Max duration for charter booking is ' + time + '.';
          return;
        }
        if (self.charter.startDate === self.charter.endDate) {
          self.charterValidation.startDate = 'Invalid date range.';
          self.charterValidation.endDate = 'Invalid date range.';
          return;
        }

        var selectedService = self.selectedService.replace('a', '');
        var minDurationServiceId = self.settings.charterMnDurationServiceId;
        if (selectedService && minDurationServiceId.indexOf(selectedService) > -1) {
          if (endDate.diff(startDate, 'minutes') < self.settings.charterMinDuration) {
            var _time = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.duration(self.settings.charterMinDuration, 'minutes').humanize({ h: Infinity });
            self.charterValidation.endDate = 'Minimum duration for this particular service is ' + _time + '.';
            return;
          }
        }
      }
      setTimeout(function () {
        self.getQuote();
      }, 20);
    },
    optinSharedAllowedTime: function optinSharedAllowedTime() {
      if (!this.editData.tripInfo.isAirportPickup) return true;

      var settings = this.$store.state.settings;
      if (settings.optinAllowedTime.start === settings.optinAllowedTime.end) return false;

      var allowTimeStart = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(settings.optinAllowedTime.start, 'hh:mmA');
      var allowTimeEnd = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(settings.optinAllowedTime.end, 'hh:mmA');

      var selectedTime = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.editData.tripInfo.pickupDate, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_14__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
      selectedTime = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(selectedTime.format(__WEBPACK_IMPORTED_MODULE_14__modules_api_featureToggle__["a" /* default */].timeFormat(this, false)), __WEBPACK_IMPORTED_MODULE_14__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));

      if (parseInt(selectedTime.format('X')) >= parseInt(allowTimeStart.format('X')) && parseInt(selectedTime.format('X')) <= parseInt(allowTimeEnd.format('X'))) {
        return true;
      } else {
        this.$store.commit('rsvpDetails/setOptinData', { enabled: false });
        return false;
      }
    },
    optinSharedPrice: function optinSharedPrice() {
      var origPrice = this._edit.services[this._edit.selectedService].prices[(this.tripInfo.passenger || 1) - 1].price;
      var percent = this._edit.services[this._edit.selectedService].optinPercent / 100;
      percent = parseFloat((1 - percent).toFixed(2));
      return origPrice * percent;
    },
    optinRefundPrice: function optinRefundPrice() {
      var origPrice = this._edit.services[this._edit.selectedService].prices[(this.tripInfo.passenger || 1) - 1].price;
      return parseFloat((origPrice - this.optinSharedPrice()).toFixed(2));
    },
    getTimezoneFirst: function getTimezoneFirst() {
      var self = this;
      self.$store.commit('rsvpDetails/setTimezoneLoading', true);
      __WEBPACK_IMPORTED_MODULE_13__modules_api_location__["a" /* default */].getTimezone(self, {
        lat: self.tripInfo.pickup.lat,
        lng: self.tripInfo.pickup.lng
      }, function (res) {
        self.timezoneInfo = {
          pickup: self.tripInfo.pickup.title,
          tz: res
        };
        self.$store.commit('rsvpDetails/setTimezoneLoading', false);
        self.$store.commit('rsvpDetails/setTimezone', res);

        self.quoteDelay = setTimeout(function () {
          if (!{"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation) {
            self.selectedService = '';
          }
          self.getQuote();
        }, 500);
      });
    },
    changeFlightDate: function changeFlightDate() {
      var self = this;
      self.flightDate.date = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(self.flightDate.date).format('MM/DD/YYYY');
      self.updateFlightDate();
      // if (
      //   self.flightDate.date && self.flightDate.hour && self.flightDate.minute &&
      //   ((this.$settings.get('MilitaryTimeBackoffice') == '0' && this.flightDate.amPm) || this.$settings.get('MilitaryTimeBackoffice') == '1')
      // ) {
      //   setTimeout(() => {
      //     self.getQuote()
      //   }, 20)
      // }
    },
    updateFlightDate: function updateFlightDate() {
      var _this7 = this;

      var flightDate = this.flightDate.date + ' ' + this.flightDate.hour + ':' + this.flightDate.minute + '' + this.flightDate.amPm;
      if (this.$settings.get('MilitaryTimeBackoffice') === '1') {
        flightDate = this.flightDate.date + ' ' + this.flightDate.hour + ':' + this.flightDate.minute;
      }
      this.$store.commit('rsvpDetails/setMtechData', { flightDate: flightDate });
      setTimeout(function () {
        _this7.getQuote(true);
      }, 20);
    },
    selectMtechService: function selectMtechService(service) {
      if (this.passenger > service.maxPaxVal || this.luggage > service.maxLuggageVal) return;

      this.selectedService = service.code;
      this.isMeetAndGreet = false;

      this.paymentBonusEnabled = false;
      this.paymentBonus = 0;

      this.$store.commit('rsvpDetails/setOptinData', { enabled: false });
      this.getQuoteMtechService();
    },
    getQuoteMtechService: function getQuoteMtechService() {
      var self = this;

      var rsvpEdit = self.$store.state.rsvpDetails.edit;
      if (rsvpEdit.serviceLoading) {
        return;
      }

      var pickupdate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()();
      var pickuptime = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()();
      if (self.pickupDate.date && self.pickupDate.date !== 'Invalid date' && !self.pickupAsap) {
        pickupdate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(self.pickupDate.date, 'MM/DD/YYYY');
        pickuptime = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(self.pickupDate.hour + ':' + self.pickupDate.minute + ' ' + self.pickupDate.amPm, "hh:mm A");
      }

      var quoteData = {};
      quoteData = {
        brandId: self.tripInfo.brandId,
        pickupDate: pickupdate.format('YYYY-MM-DD'),
        pickup: self.tripInfo.pickup,
        dropoff: self.tripInfo.dropoff,
        asap: false,
        isAdmin: true,
        order: 'priority',
        pickupTime: pickuptime.format("HH:mm:ss"),
        mtechServiceType: self.selectedService
      };
      var tripInfo = rsvpEdit.details.tripInfo;
      quoteData.pickup.text = tripInfo.pickup.title;
      quoteData.dropoff.text = tripInfo.dropoff.title;
      quoteData.passengers = tripInfo.passenger || 1;
      if (self.mtech.flightDate) {
        quoteData.pickupTimestamp = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(self.mtech.flightDate, 'MM/DD/YYYY hh:mmA', rsvpEdit.timezone).format('X');
      } else {
        quoteData.pickupTimestamp = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(quoteData.pickupDate + ' ' + quoteData.pickupTime, 'YYYY-MM-DD HH:mm', rsvpEdit.timezone).format('X');
      }

      self.$store.commit('rsvpDetails/setServiceLoading', true);
      var timeNow = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()();
      self.$sdk.post('/quotation', quoteData, function (res) {
        self.sendQuoteTime(timeNow, __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(), res.quoteId);
        self.$store.commit('rsvpDetails/setServiceLoading', false);
        if (!res.error) {
          self.$store.commit('rsvpDetails/setMtechData', { quoteId: res.quoteId });
          if (res.mtech.services.length) {
            var mtech = res.mtech;
            var mtechStore = self.$store.state.rsvpDetails.mtech;
            var service = res.mtech.services[0];
            var price = service.price;

            var hasDiscount = false;
            var discountVal = 0;
            var totalBeforeDc = 0;
            var baseFare = price.amount;
            service.price.breakdown.forEach(function (x) {
              if (x.description === 'Base rate') {
                baseFare = x.amount;
              }
              if (x.description === 'Discount') {
                hasDiscount = true;
                discountVal = x.amount;
              }
              if (x.amount > 0) {
                totalBeforeDc += x.amount;
              }
            });

            var addMarkup = 0;
            if (mtech.markup.value) {
              addMarkup = mtechStore.markup.value;
              if (mtech.markup.type === '%') {
                addMarkup = baseFare * (mtech.markup.value / 100);
              }
              addMarkup = parseFloat(addMarkup.toFixed(2));
            }

            self.$store.commit('rsvpDetails/setMtechNewPricing', {
              code: self.selectedService,
              val: {
                baseFare: baseFare,
                amount: price.amount,
                addMarkup: addMarkup,
                breakdown: price.breakdown,
                hasDiscount: hasDiscount,
                discountVal: Math.abs(discountVal),
                totalBeforeDc: totalBeforeDc
              }
            });
          }
        }
      }, '2.0');
    },
    rechkServiceBuffer: function rechkServiceBuffer() {
      if (!this.selectedService) return;
      var service = this._edit.services[this.selectedService];
      var nowPlusBuffer = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()();
      if (service && service.bufferTime) nowPlusBuffer = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()().add(service.bufferTime, 'minutes');
      var pickupDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.tripInfo.pickupDate, 'MM/DD/YYYY hh:mmA');
      if (pickupDate.isBefore(nowPlusBuffer)) {
        this.selectedService = '';
      }
    },
    sendQuoteTime: function sendQuoteTime(start, end, quoteId) {
      var store = this.$store.state;
      var duration = end.diff(start, 'milliseconds') / 1000;
      this.$sdk.opt('/quotation/time', {
        token: store.session.sessionToken,
        brandId: this.tripInfo.brandId,
        quotationId: quoteId,
        responseTime: duration,
        deviceType: 'admin'
      }, function (res) {
        if (res.error) console.log('ERROR quotation time');
      });
    },
    selectCountry: function selectCountry() {
      this.$store.commit('countryCode/setCountryModal', true);
    },
    applyCurrency: function applyCurrency(x) {
      var useSymbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      x = parseFloat(x);
      x = x * this.currency.value;
      // return useSymbol ? `${this.currency.symbol}${x.toFixed(2)}` : x.toFixed(2)
      if (!useSymbol) return x.toFixed(2);
      return __WEBPACK_IMPORTED_MODULE_16__modules_api_currency__["a" /* default */].format({
        code: this.currency.code,
        val: x.toFixed(2)
      }, useSymbol);
    },
    changeBrand: function changeBrand() {
      this.bookingType = 'mileage';
      this.getQuote();
    },
    setLocations: function setLocations(tripInfo) {
      var getQuote = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.customPickupLocation = { title: '' };
      this.customDropoffLocation = { title: '' };

      this.isCustomPickupLocation = true;
      this.isCustomDropoffLocation = true;
      tripInfo.pickup.address2 = tripInfo.pickup.address2.split(' Apt/Gate:')[0];
      tripInfo.pickup.title = tripInfo.pickup.title.split(' Apt/Gate:')[0];
      tripInfo.dropoff.address2 = tripInfo.dropoff.address2.split(' Apt/Gate:')[0];
      tripInfo.dropoff.title = tripInfo.dropoff.title.split(' Apt/Gate:')[0];
      var self = this;
      self.$nextTick(function () {
        self.customPickupLocation = tripInfo.pickup;
        self.customDropoffLocation = tripInfo.dropoff;
        if (getQuote) self.getQuote();
      });
    },
    cleanCountryName: function cleanCountryName(val) {
      var val2 = val.slice(0, val.indexOf(" ("));
      return val.indexOf(" (") === -1 ? val : val2;
    },
    generatePassword: function generatePassword() {
      var result = '';
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for (var i = 0; i < 8; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    createD2Duser: function createD2Duser() {
      var _self$$sdk$post;

      var self = this;
      if (self.d2dUser.loading) return;
      self.d2dUser.loading = true;

      self.$store.commit('global/setLoaderData', { show: true });

      var countryCode = this.callingCode;
      var nationalNumber = this.createUser.mobile;
      var bday = new Date(this.d2dUser.birthday);
      var passwrd = self.generatePassword();
      self.$sdk.post('/consumer', (_self$$sdk$post = {
        token: self.$store.state.session.sessionToken,
        email: self.createUser.email,
        password: passwrd,
        device: 'DEVICE-' + __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()().format('x') + '-' + self.generatePassword(),
        firstName: self.createUser.firstName,
        lastName: self.createUser.lastName,
        phone: '+' + countryCode + nationalNumber,
        countryCode: countryCode,
        nationalNumber: nationalNumber
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_self$$sdk$post, 'email', self.createUser.email), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_self$$sdk$post, 'wheelchair', self.wheelchairEnabled), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_self$$sdk$post, 'serviceDog', self.serviceDogEnabled), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_self$$sdk$post, 'brandId', self.tripInfo.brandId), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_self$$sdk$post, 'dateOfBirth', __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(bday).format('YYYY-MM-DD')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_self$$sdk$post, 'userCountry', self.d2dUser.country), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_self$$sdk$post, 'passportNum', self.d2dUser.passport || ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_self$$sdk$post, 'd2d', true), _self$$sdk$post), function (r) {
        self.d2dUser.loading = false;
        if (r.error) {
          self.$store.commit('global/setLoaderData', { show: false });
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          return;
        }

        self.createUser.show = false;
        self.$store.commit('rsvpDetails/setCustomerInfo', {
          id: r.ID,
          firstName: r.firstName,
          lastName: r.lastName,
          email: r.email,
          mobile: r.phone,
          countryCode: self.callingCode,
          nationalNumber: self.createUser.mobile
        });

        self.$store.commit('rsvpDetails/setIsCorporate', false);
        self.resetPaymentMethod();
        self.firstD2DLogin({
          id: r.ID,
          email: self.createUser.email,
          password: passwrd
        });
        // self.d2dStripeSetup(r.ID)
      }, '1.1');
    },
    firstD2DLogin: function firstD2DLogin(user) {
      var self = this;
      self.$sdk.post('/auth/login', {
        d2d: 1,
        device: 'DEVICE-' + __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()().format('x') + '-' + self.generatePassword(),
        deviceType: 'admin',
        email: user.email,
        password: user.password
      }, function (r) {
        self.d2dStripeSetup(user.id);
      });
    },
    d2dStripeSetup: function d2dStripeSetup(id) {
      var self = this;
      self.$sdk.post('/consumer/' + id + '/cards/setup', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          self.$store.commit('global/setLoaderData', { show: false });
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          return;
        }

        if (self.$refs.stripeForm) self.$refs.stripeForm.submitStripe(id, r.client_secret);
      }, '1.1');
    },
    setNewD2DCard: function setNewD2DCard() {
      this.createUser.paymentMethod = 'oldCard';
      this.createUser.selectedCard = 0;

      this.createRsvp();
    }
  },
  watch: {
    editData: function editData(value) {
      this.selectedService = value.tripInfo.serviceCode;
      // this.isCustomPickupLocation = true
      // this.isCustomDropoffLocation = true
      // value.tripInfo.pickup.address2 = value.tripInfo.pickup.address2.split(' Apt/Gate:')[0]
      // value.tripInfo.pickup.title = value.tripInfo.pickup.title.split(' Apt/Gate:')[0]
      // this.customPickupLocation = value.tripInfo.pickup
      // value.tripInfo.dropoff.address2 = value.tripInfo.dropoff.address2.split(' Apt/Gate:')[0]
      // value.tripInfo.dropoff.title = value.tripInfo.dropoff.title.split(' Apt/Gate:')[0]
      // this.customDropoffLocation = value.tripInfo.dropoff
      this.setLocations(value.tripInfo);
      this.isMeetAndGreet = value.tripInfo.meetAndGreet;

      if (value.tripInfo.pickup.geofenceType === 'airport') {
        this.customPickupLocation = '';
        this.isCustomPickupLocation = false;
        this.pickupAirportId = value.tripInfo.pickup.geofenceId;
      }
      if (value.tripInfo.dropoff.geofenceType === 'airport') {
        this.customDropoffLocation = '';
        this.isCustomDropoffLocation = false;
        this.dropoffAirportId = value.tripInfo.dropoff.geofenceId;
      }
      if (value.tripInfo.isCharter) {
        this.bookingType = 'charter';
      }
      this.waivePayments = false;
    },
    tripInfo: function tripInfo(value) {
      this.wheelchairEnabled = value.wheelchair;
      this.serviceDogEnabled = value.serviceDog;
      if (value.meetAndGreet) {
        this.isMeetAndGreet = true;
      }

      this.priceOverrideEnabled = false;
      this.priceOverride = '';
      if (value.overridePrice) {
        this.priceOverride = value.overridePrice;
        this.priceOverrideEnabled = true;
      }

      this.driverOverrideEnabled = false;
      this.driverOverride = '';
      if (value.overridePayment) {
        this.driverOverrideEnabled = true;
        this.driverOverride = value.overridePayment;
      }

      this.paymentBonusEnabled = false;
      this.paymentBonus = 0;
      if (value.paymentBonus) {
        this.paymentBonusEnabled = true;
        this.paymentBonus = value.paymentBonus;
      }
    },
    guestInfo: function guestInfo(value) {
      this.bookingForSomeone = false;
      if (value.firstName) {
        this.bookingForSomeone = true;
      }
    },
    isCustomPickupLocation: function isCustomPickupLocation(value) {
      if (this.$store.state.rsvpDetails.basicInfo.tripInfo.pickup.geofenceType === 'airport' && value) {
        this.driverOverrideValidation.pickupAirport = false;
      } else if (this.$store.state.rsvpDetails.basicInfo.tripInfo.pickup.geofenceType === 'airport') {
        this.driverOverrideValidation.pickupAirport = true;
      }
      if (this.$store.state.rsvpDetails.basicInfo.tripInfo.pickup.geofenceType === 'servicearea' && !value) {
        this.driverOverrideValidation.servicePickup = false;
      } else if (this.$store.state.rsvpDetails.basicInfo.tripInfo.pickup.geofenceType === 'servicearea') {
        this.driverOverrideValidation.servicePickup = true;
      }
      this.clearDriverPayment();

      if (!value) {
        this.validation.pickupLocation = '';
        this.selectAirportPickup(this.pickupAirportId);
      } else {
        if (this.$refs.customPickupLoc.clickOut()) {
          this.$refs.customPickupLoc.clickOut();
        }
      }
    },
    isCustomDropoffLocation: function isCustomDropoffLocation(value) {
      if (this.$store.state.rsvpDetails.basicInfo.tripInfo.dropoff.geofenceType === 'airport' && value) {
        this.driverOverrideValidation.dropoffAirport = false;
      } else if (this.$store.state.rsvpDetails.basicInfo.tripInfo.dropoff.geofenceType === 'airport') {
        this.driverOverrideValidation.dropoffAirport = true;
      }
      if (this.$store.state.rsvpDetails.basicInfo.tripInfo.dropoff.geofenceType === 'servicearea' && !value) {
        this.driverOverrideValidation.serviceDropoff = false;
      } else if (this.$store.state.rsvpDetails.basicInfo.tripInfo.dropoff.geofenceType === 'servicearea') {
        this.driverOverrideValidation.serviceDropoff = true;
      }
      // this.clearDriverPayment()

      if (!value) {
        this.validation.dropoffLocation = '';
        this.selectAirportDropoff(this.dropoffAirportId);
      } else {
        if (this.$refs.customDropoffLoc.clickOut()) {
          this.$refs.customDropoffLoc.clickOut();
        }
      }
    },
    airportPickup: function airportPickup(value) {
      if (value) {
        this.getAirlineList();
      }
    },
    airportDropoff: function airportDropoff(value) {
      if (value && !this.airportPickup) {
        this.getAirlineList();
      }
    },
    bookingForSomeone: function bookingForSomeone(value) {
      if (!value) {
        this.editData.guestInfo.firstName = '';
        this.editData.guestInfo.lastName = '';
        this.editData.guestInfo.mobile = '';
      }
    },
    selectedService: function selectedService(value) {
      this.$store.commit('rsvpDetails/setSelectedService', value);
      this.setDefaultTip();
    },
    'customerInfo.firstName': function customerInfoFirstName(value) {
      if (value) {
        if (!this.isCorporate) {
          this.createUser.paymentMethod = 'newCard';
        }
      }
    },
    pickupAsap: function pickupAsap(value) {
      this.$store.commit('rsvpDetails/setAsapEnable', value);
    },
    passenger: function passenger(value) {
      this.setDefaultTip();
      if (this.mtech.enabled) {
        this.getQuote();
      }
    },
    bookingType: function bookingType(val) {
      this.$store.commit('rsvpDetails/setCharterData', { enabled: val === 'charter' });
      this.pickupAsap = false;
      if (val === 'charter') {
        this.passenger = 1;
        this.optinEnabled = false;
      }
    },
    extraStops: function extraStops(val) {
      if (val.length) {
        this.optinEnabled = false;
      }
    },

    'tripInfo.pickupDate': function tripInfoPickupDate() {
      this.rechkServiceBuffer();
    },
    tipIntnl: function tipIntnl(val) {
      if (this.currencyCode === 'USD') return;
      this.editData.tripInfo.tip = parseFloat((parseFloat(val) / this.currency.value).toFixed(2));
    },
    priceOverrideIntnl: function priceOverrideIntnl(val) {
      this.priceOverride = parseFloat((parseFloat(val) / this.currency.value).toFixed(2));
    },
    waivePayments: function waivePayments(val) {
      if (val) {
        this.setLocations(this.$store.state.rsvpDetails.basicInfo.tripInfo, true);
      }
    }
  },
  mounted: function mounted() {
    this.setScreenSize();
    this.originalPax = this.passenger;
  },
  created: function created() {
    window.addEventListener("resize", this.setScreenSize);
  },
  destroyed: function destroyed() {
    window.removeEventListener("resize", this.setScreenSize);
  }
});

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */
var request = __webpack_require__(13);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'location-input',
  props: ['value', 'extra'],
  data: function data() {
    return {
      initData: '',
      keyInput: '',
      // autocomplete: new google.maps.places.AutocompleteService(), // eslint-disable-line no-undef
      // geocoder: new google.maps.Geocoder(), // eslint-disable-line no-undef
      queryToken: null,
      suggestions: [],
      showSuggestion: false,
      loading: false,
      clickOutDelay: '',
      lastSelected: {}
    };
  },

  computed: {},
  methods: {
    query: function query() {
      var self = this;

      var queryText = self.keyInput;
      if (queryText === '') {
        self.queryToken = null;
        self.suggestions = [];
        self.showSuggestion = false;
        return;
      }

      // self.generateQueryToken()

      self.showSuggestion = true;
      var restrictedTypes = ['locality', 'postalCodePoint', 'administrativeArea', 'chainQuery', 'categoryQuery'];

      var url = 'https://autosuggest.search.hereapi.com/v1/autosuggest?at={AT}&q={SEARCH}&apiKey={API_KEY}&lang=en-US';
      url = url.replace('{AT}', encodeURIComponent(33.942791 + ',' + -118.410042)).replace('{SEARCH}', queryText).replace('{API_KEY}', {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key);
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err || body.items.length === 0) {
          self.suggestions = [{
            icon: 'fa-exclamation-triangle',
            title: 'Sorry',
            subtitle: 'We coudn\'t locate "' + queryText + '"'
          }];
          return;
        }

        var result = [];
        body.items.forEach(function (prediction) {
          if (restrictedTypes.indexOf(prediction.resultType) === -1) {
            var subtitle = prediction.address.label;
            result.push({
              id: prediction.id,
              title: prediction.title,
              subtitle: subtitle,
              icon: 'fa-map-marker'
            });
          }
        });

        self.suggestions = result.slice(0, 5);
      });
    },
    selectLocation: function selectLocation(index) {
      var self = this;
      var place = self.suggestions[index];
      self.queryToken = null;

      clearTimeout(this.clickOutDelay);
      self.showSuggestion = false;
      self.loading = true;

      var url = 'https://lookup.search.hereapi.com/v1/lookup?source=sharing&id={LOCATION_ID}&locationattributes=tz&apiKey={API_KEY}&lang=en-US';
      url = url.replace('{LOCATION_ID}', place.id).replace('{API_KEY}', {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key);
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) {
          console.log('geocode ERROR', results, status);
          self.loading = false;
          return;
        }

        var result = body;
        var lat = result.position.lat;
        var lng = result.position.lng;
        var finalResult = {
          title: result.title,
          address1: result.address.street || result.title,
          address2: result.address.houseNumber || result.address.district,
          city: result.address.city,
          state: result.address.state,
          zip: result.address.postalCode,
          country: result.address.countryCode,
          lat: lat,
          lng: lng
        };

        self.keyInput = finalResult.title;
        self.lastSelected = finalResult;

        if (self.extra.field === 'extraStop') {
          self.$store.commit('rsvpDetails/setExtraStopData', {
            id: self.extra.id,
            fields: finalResult
          });
          self.loading = false;
          self.$emit('change', {
            field: self.extra.field,
            keyInput: self.keyInput
          });
          return;
        } else {
          var locationType = self.extra.field.charAt(0).toUpperCase() + self.extra.field.substr(1);
          self.$store.commit('rsvpDetails/set' + locationType, finalResult);

          var data = {
            lat: finalResult.lat,
            lng: finalResult.lng,
            brandId: self.extra.brandId
          };
          self.$sdk.get('/geofences/', data, function (res) {
            self.loading = false;
            if (!res.error) {
              if (res.list.length <= 0) {
                self.$emit('change', {
                  field: self.extra.field,
                  keyInput: self.keyInput
                });
                return;
              }

              var _result = res.list[0];
              self.$store.commit('rsvpDetails/setAirportCode', '');

              if (_result.type === 'airport') {
                self.$store.commit('rsvpDetails/setAirportCode', _result.airportCode);

                if (self.extra.field === 'pickup') {
                  self.$store.commit('rsvpDetails/setIsAirportPickup', _result.type === 'airport');
                } else {
                  self.$store.commit('rsvpDetails/setIsAirportDropoff', _result.type === 'airport');
                }
              }

              self.$emit('change', {
                field: self.extra.field,
                keyInput: self.keyInput
              });
            }
          });
        }
      });
    },
    clickOut: function clickOut() {
      var self = this;
      self.clickOutDelay = setTimeout(function () {
        self.$emit('change', {
          field: self.extra.field,
          keyInput: self.keyInput
        });
        self.showSuggestion = false;
      }, 200);
    },
    extraStopAddress: function extraStopAddress(x) {
      return x && x.lat && x.lng ? x.address2 + ' ' + x.address1 + ', ' + x.city + ', ' + x.state + ' ' + x.zipCode : '';
    }
  },
  watch: {
    value: function value(_value) {
      this.keyInput = _value.title;
      if (this.extra.field === 'extraStop') {
        this.keyInput = this.extraStopAddress(_value);
      }
      this.initData = _value.title;
    },
    extra: function extra(value) {
      if (!value.disabled && value.field !== 'extraStop') {
        var locationType = this.extra.field.charAt(0).toUpperCase() + this.extra.field.substr(1);
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.lastSelected).length) {
          this.$store.commit('rsvpDetails/set' + locationType, this.lastSelected);
        }
      }
    }
  },
  mounted: function mounted() {
    if (this.extra.field === 'extraStop') {
      this.keyInput = this.extraStopAddress(this.value);
    }
  }
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_featureToggle__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */


// import ApiLocation from '../../modules/api/location'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'flight-input',
  props: ['value', 'type', 'extra', 'airlineLoading'],
  data: function data() {
    return {
      keyInput: '',
      suggestions: [],
      showSuggestion: false,
      selectFromList: false,
      loading: false
    };
  },

  computed: {
    charter: function charter() {
      return this.$store.state.rsvpDetails.charter;
    },
    airlineList: function airlineList() {
      if (this.type === 'airlines') {
        var gid = this.charter.enabled ? 'g' + this.charter.airportGeoId : this.extra.gid;
        this.suggestions = this.$store.state.airlines.list[gid];
        return this.$store.state.airlines.list[gid];
      }
    },
    editData: function editData() {
      return this.$store.state.rsvpDetails.edit.details;
    },
    isD2D: function isD2D() {
      var _this = this;

      var conf = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.find(function (x) {
        return x.id === _this.editData.tripInfo.brandId;
      });
      if (conf) return conf.code === 'd2d';
      return false;
    }
  },
  methods: {
    getFlightList: function getFlightList() {
      var self = this;
      var rsvpDetails = self.$store.state.rsvpDetails;
      var original = rsvpDetails.basicInfo.tripInfo;
      var current = rsvpDetails.edit.details.tripInfo;

      // if ((original.pickupDate !== current.pickupDate ||
      //   original.airline !== current.airline) || self.suggestions.length <= 0
      // ) {
      var airportCode = current.airportCode;
      var airlineCode = current.airlineCode;
      var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(current.pickupDate, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__modules_api_featureToggle__["a" /* default */].timeFormat(self, false));
      var sdkUrl = '';

      if (!airlineCode) {
        var geofenceId = current.pickup.geofenceId;
        if (current.pickup.geofenceType !== 'airport' && current.dropoff.geofenceType === 'airport') {
          geofenceId = current.dropoff.geofenceId;
        }
        var index = self.$store.state.airlines.list['g' + geofenceId].findIndex(function (x) {
          return x.name === current.airline;
        });
        if (index > -1) {
          airlineCode = self.$store.state.airlines.list['g' + geofenceId][index].code;
        }
      }
      // if (current.isAirportDropoff && !current.isAirportPickup) {
      //   date = date.add(3, 'hours')
      // }

      if (airlineCode === null || airlineCode === '') {
        sdkUrl = '/availability/flights?airport=' + airportCode + '&date=' + date.format('YYYY-MM-DD') + '&time=' + date.format('HH:mm:ss');
      } else {
        sdkUrl = '/availability/flights?airport=' + airportCode + '&airline=' + airlineCode + '&date=' + date.format('YYYY-MM-DD') + '&time=' + date.format('HH:mm');
      }
      if (current.isAirportPickup) {
        sdkUrl += '&departure=0';
      } else if (current.isAirportDropoff) {
        sdkUrl += '&departure=1';
      }

      if (self.loading) {
        return;
      }
      self.loading = true;
      self.$sdk.get(sdkUrl, {}, function (res) {
        self.loading = false;
        if (res.list) {
          var flights = [];
          res.list.forEach(function (data) {
            var from = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.tz(data.departure.time.unix, 'X', data.departure.time.timezone).format('MM/DD hh:mmA');
            var to = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.tz(data.arrival.time.unix, 'X', data.arrival.time.timezone).format('MM/DD hh:mmA');
            var flightData = {
              code: data.flight.number,
              name: data.airline.code + ' ' + data.flight.number + ' ' + data.departure.airportCode + '-' + data.arrival.airportCode,
              label: data.airline.code + ' ' + data.flight.number + ' - ' + data.airline.name,
              fromTo: data.departure.airportCode + ' (' + from + ') <i class="fas fa-chevron-right m-X-5"></i> ' + data.arrival.airportCode + ' (' + to + ')',
              // + data.departure.airportCode + '-' + data.arrival.airportCode,
              isDomestic: data.isDomestic === 1
            };
            if (current.isAirportPickup) {
              flightData.time = __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.arrival.time.unix, 'X', data.departure.time.timezone).format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__modules_api_featureToggle__["a" /* default */].timeFormat(self, false));
            } else if (current.isAirportDropoff) {
              flightData.time = __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.departure.time.unix, 'X', data.departure.time.timezone).format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__modules_api_featureToggle__["a" /* default */].timeFormat(self, false));
            }

            flights.push(flightData);
          });

          self.$store.commit('airlines/addFlights', flights);
          self.suggestions = flights;
          self.showSuggestion = true;
          self.selectFromList = false;
        }
        self.$nextTick(function () {
          return self.$refs.flight.focus();
        });
      });
      // } else {
      //   self.loading = false
      // }
    },
    filterAirlines: function filterAirlines() {
      var self = this;
      var regex = new RegExp('^' + self.keyInput, 'i');
      var result = [];
      var gid = self.charter.enabled ? 'g' + self.charter.airportGeoId : self.extra.gid;
      var list = self.$store.state.airlines.list[gid];

      for (var i = 0; i < list.length; i++) {
        if (!regex.test(list[i].name)) {
          continue;
        }
        result.push(list[i]);
      }
      self.suggestions = result;
      self.showSuggestion = true;
      self.selectFromList = false;
    },
    filterFlights: function filterFlights() {
      var self = this;
      var regex = new RegExp('^' + self.keyInput, 'i');
      var result = [];
      var list = self.$store.state.airlines.flights;

      if (list.length < 0) {
        return;
      } // Manual

      for (var i = 0; i < list.length; i++) {
        if (!regex.test(list[i].code)) {
          continue;
        }
        result.push(list[i]);
      }
      self.suggestions = result;
    },
    clickOut: function clickOut() {
      var self = this;
      setTimeout(function () {
        if (self.keyInput.trim() === '') {
          if (self.type === 'airlines') {
            self.$store.commit('rsvpDetails/setAirline', { airline: '', airlineCode: '' });
          } else {
            self.$store.commit('rsvpDetails/setFlightNo', '');
          }
        } else if (!self.selectFromList) {
          if (self.type === 'airlines') {
            var index = self.airlineList.findIndex(function (x) {
              return x.name === self.keyInput;
            });
            if (index > -1) {
              self.$store.commit('rsvpDetails/setAirline', {
                airline: self.airlineList[index].name,
                airlineCode: self.airlineList[index].code
              });
            } else {
              self.$store.commit('rsvpDetails/setAirline', {
                airline: self.keyInput,
                airlineCode: 'DD'
              });
            }
          } else {
            self.$store.commit('rsvpDetails/setFlightNo', self.keyInput);
            self.$store.commit('rsvpDetails/setLastFlightNo', '');
          }
        }

        self.showSuggestion = false;
        self.selectFromList = false;
      }, 100);
    },
    selectItem: function selectItem(item) {
      var self = this;
      if (self.airlineLoading) return;

      if (self.type === 'airlines') {
        self.keyInput = item.name;
        self.$store.commit('rsvpDetails/setFlightNo', '');
        self.$store.commit('rsvpDetails/setAirline', {
          airline: item.name,
          airlineCode: item.code
        });
      } else {
        self.keyInput = item.code;
        self.$store.commit('rsvpDetails/setFlightNo', item.code);
        self.$store.commit('rsvpDetails/setLastFlightNo', item.code);
      }

      var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.time, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__modules_api_featureToggle__["a" /* default */].timeFormat(self, false));
      date = date.add(5 - date.format('mm') % 5, 'minutes').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__modules_api_featureToggle__["a" /* default */].timeFormat(self, false));
      self.$store.commit('rsvpDetails/setSuggestedTime', date);
      self.$store.commit('rsvpDetails/setSuggestedTimeIsDomestic', item.isDomestic);

      self.selectFromList = true;
    },
    flightChange: function flightChange() {
      this.$store.commit('rsvpDetails/setLastFlightNo', this.keyInput);
    }
  },
  watch: {
    value: function value(_value) {
      if (!this.$store.state.rsvpDetails.isAdd) {
        this.keyInput = _value;
      }
    }
  }
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_us__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_us___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_us__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stripe-payment-form',
  data: function data() {
    return {
      stripe: null,
      cardElement: null,
      validation: {
        cardOwner: '',
        address: '',
        userCity: '',
        userState: '',
        userZip: '',
        userCountry: ''
      },
      isMobile: false,
      isDesktop: false,
      countries: __webpack_require__(45).countries
    };
  },

  computed: {
    states: function states() {
      var states = [];
      for (var key in __WEBPACK_IMPORTED_MODULE_0_us___default.a.states) {
        if (__WEBPACK_IMPORTED_MODULE_0_us___default.a.states.hasOwnProperty(key)) {
          states.push({
            value: key,
            label: __WEBPACK_IMPORTED_MODULE_0_us___default.a.states[key].name
          });
        }
      }
      return states;
    },
    edit: function edit() {
      return this.$store.state.rsvpDetails.edit.details;
    },
    stripeStore: function stripeStore() {
      return this.$store.state.rsvpDetails.stripe;
    },

    cardOwner: {
      get: function get() {
        return this.stripeStore.cardOwner;
      },
      set: function set(x) {
        this.$store.commit('rsvpDetails/setStripeData', { cardOwner: x });
      }
    },
    address: {
      get: function get() {
        return this.stripeStore.address;
      },
      set: function set(x) {
        this.$store.commit('rsvpDetails/setStripeData', { address: x });
      }
    },
    userCity: {
      get: function get() {
        return this.stripeStore.userCity;
      },
      set: function set(x) {
        this.$store.commit('rsvpDetails/setStripeData', { userCity: x });
      }
    },
    userState: {
      get: function get() {
        return this.stripeStore.userState;
      },
      set: function set(x) {
        this.$store.commit('rsvpDetails/setStripeData', { userState: x });
        if (x) this.$store.commit('rsvpDetails/setStripeData', { userCountry: '' });
      }
    },
    userZip: {
      get: function get() {
        return this.stripeStore.userZip;
      },
      set: function set(x) {
        this.$store.commit('rsvpDetails/setStripeData', { userZip: x });
      }
    },
    userCountry: {
      get: function get() {
        return this.stripeStore.userCountry;
      },
      set: function set(x) {
        this.$store.commit('rsvpDetails/setStripeData', { userCountry: x });
      }
    }
  },
  methods: {
    setScreenSize: function setScreenSize() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isDesktop = false;
        this.isMobile = true;
      } else {
        this.isDesktop = true;
        this.isMobile = false;
      }
    },
    validate: function validate() {
      this.validation = {
        cardOwner: '',
        address: '',
        userCity: '',
        userState: '',
        userZip: '',
        userCountry: ''
      };

      var hasError = false;
      if (!this.cardOwner) {
        this.validation.userCardOwner = this.$t('rsvpDetails.edit.emptyField');
        hasError = true;
      }
      if (!this.address) {
        this.validation.userAddress = this.$t('rsvpDetails.edit.emptyField');
        hasError = true;
      }
      if (!this.userCity) {
        this.validation.userCity = this.$t('rsvpDetails.edit.emptyField');
        hasError = true;
      }
      if (this.userState === '..') {
        this.validation.userState = this.$t('rsvpDetails.edit.emptyField');
        hasError = true;
      }
      if (this.userCountry === '' && !this.userState) {
        this.validation.userCountry = this.$t('rsvpDetails.edit.emptyField');
        hasError = true;
      }

      if (hasError) retturn;
    },
    submitStripe: function submitStripe(id, client_secret) {
      var self = this;
      self.stripe.confirmCardSetup(client_secret, {
        payment_method: {
          card: self.cardElement,
          billing_details: {
            name: self.cardOwner,
            address: {
              city: self.userCity,
              country: self.userCountry || 'US',
              line1: self.address,
              state: self.userState
            }
          }
        }
      }).then(function (result) {
        if (result.error) {
          self.$store.commit('global/setLoaderData', { show: false });
          self.$store.commit('global/setAlertData', {
            show: true,
            message: result.error.message
          });
          return;
        }
        self.addCard(id, result);
      });
    },
    addCard: function addCard(id, result) {
      var self = this;
      self.$sdk.post('/consumer/' + id + '/cards/token', {
        token: self.$store.state.session.sessionToken,
        paymentMethodId: result.setupIntent.payment_method
      }, function (r) {
        if (r.error) {
          self.$store.commit('global/setLoaderData', { show: false });
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          return;
        }
        var cards = [];
        r.cards.forEach(function (data) {
          cards.push({
            id: data.ID,
            name: data.title + ' ****-' + data.cardNumber.substr(-4)
          });
        });
        self.$store.commit('rsvpDetails/setUserCardList', cards);
        self.$emit('cardAdded');

        // let card = r.cards[0]
        // self.$store.commit('setSelectedCard', {
        //   id: card.ID,
        //   type: card.title,
        //   number: card.cardNumber,
        //   exp: card.cardExpires,
        //   className: self.parseCardClass(card)
        // })
        // if (self.bookingType === 'flight') {
        //   self.$emit('done')
        //   // self.$root.$router.push('review-summary')
        // } else {
        //   self.$root.$router.push('review')
        // }
      }, '1.1');
    }
  },
  mounted: function mounted() {
    this.stripe = Stripe({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.Stripe.publishableKey); // eslint-disable-line
    var elements = this.stripe.elements({
      fonts: [{ cssSrc: 'https://fonts.googleapis.com/css2?family=Questrial&display=swap' }]
    });
    this.cardElement = elements.create('card');
    this.cardElement.mount('#card-element');

    this.setScreenSize();
  }
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_browser_request__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_browser_request___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_browser_request__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_reservations__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_plugins_common__ = __webpack_require__(1798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_api_currency__ = __webpack_require__(165);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'basic-information',
  data: function data() {
    return {
      contentShow: {
        tripInfo: false,
        otherInfo: false,
        customerInfo: false,
        guestInfo: false,
        businessInfo: false,
        driverInfo: false,
        lyft: true
      },
      flightLoading: false,
      emailLoading: false,
      tripRemindLoading: false,
      showOptions: false,
      showOptionsDelay: '',
      isTncService: false,
      xcurrency: __WEBPACK_IMPORTED_MODULE_6__modules_api_currency__["a" /* default */]
    };
  },

  computed: {
    rsvpId: function rsvpId() {
      return this.$route.params.id;
    },
    isCorporate: function isCorporate() {
      return this.$store.state.rsvpDetails.basicInfo.businessInfo.id;
    },
    travelInsuranceLabel: function travelInsuranceLabel() {
      return this.$settings.get('TravelInsuranceLabel');
    },
    tripInfo: function tripInfo() {
      return this.$store.state.rsvpDetails.basicInfo.tripInfo;
    },
    customerInfo: function customerInfo() {
      return this.$store.state.rsvpDetails.basicInfo.customerInfo;
    },
    guestInfo: function guestInfo() {
      return this.$store.state.rsvpDetails.basicInfo.guestInfo;
    },
    driverInfo: function driverInfo() {
      return this.$store.state.rsvpDetails.basicInfo.driverInfo;
    },
    businessInfo: function businessInfo() {
      return this.$store.state.rsvpDetails.basicInfo.businessInfo;
    },
    otherInfo: function otherInfo() {
      return this.$store.state.rsvpDetails.basicInfo.otherInfo;
    },
    flightInfo: function flightInfo() {
      if (!this.tripInfo.airline || this.tripInfo.airline === null) {
        return 'N/A';
      }
      return this.tripInfo.airline + ' ' + (this.tripInfo.flightNo || '');
    },
    customerName: function customerName() {
      return this.customerInfo.firstName + ' ' + this.customerInfo.lastName;
    },
    guestName: function guestName() {
      var firstName = this.guestInfo.firstName || '';
      var lastName = this.guestInfo.lastName || '';
      if (!firstName && !lastName) return '--';
      return firstName + ' ' + lastName;
    },
    driverName: function driverName() {
      return this.driverInfo.firstName + ' ' + this.driverInfo.lastName;
    },
    noGuest: function noGuest() {
      return (this.guestInfo.firstName === '' || this.guestInfo.firstName === null) && (this.guestInfo.lastName === '' || this.guestInfo.lastName === null) && (this.guestInfo.mobile === '' || this.guestInfo.mobile === null);
    },
    noDriver: function noDriver() {
      return this.driverInfo.id === '' || this.driverInfo.id === null;
    },
    totalDriverPayment: function totalDriverPayment() {
      var tripInfo = this.$store.state.rsvpDetails.basicInfo.tripInfo;
      var driverPayment = tripInfo.driverPayment;
      if (parseFloat(tripInfo.overridePayment) > 0) {
        driverPayment = tripInfo.overridePayment;
      }
      return this.toFixed(driverPayment + tripInfo.driverBonus + tripInfo.tip + tripInfo.pickupFee + tripInfo.gasFee);
    },
    isDispatch: function isDispatch() {
      return this.$store.state.rsvpDetails.basicInfo.tripInfo.bidStatus === 'dispatched';
    },
    rsvpStatus: function rsvpStatus() {
      return this.$store.state.rsvpDetails.basicInfo.tripInfo.status;
    },
    showReleaseButton: function showReleaseButton() {
      return this.rsvpStatus !== 'canceled' && this.rsvpStatus !== 'complete';
    },
    showConfirmEmail: function showConfirmEmail() {
      return this.rsvpStatus !== 'canceled' && this.rsvpStatus !== 'complete';
    },
    flightStatus: function flightStatus() {
      var flight = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$store.state.rsvpDetails.flightStatus);
      if (flight.status === '' || flight.status === null) {
        flight.status = 'Scheduled';
      }
      return this.translateFlightStatus(flight.status);
    },
    removeAddGuest: function removeAddGuest() {
      var rsvpDetails = this.$store.state.rsvpDetails.basicInfo.tripInfo;
      return rsvpDetails.status === 'canceled' || rsvpDetails.status === 'complete' || rsvpDetails.bidStatus === 'dispatched';
    },
    statusDone: function statusDone() {
      var rsvpDetails = this.$store.state.rsvpDetails.basicInfo.tripInfo;
      return rsvpDetails.status === 'canceled' || rsvpDetails.status === 'complete';
    },
    isTerminal: function isTerminal() {
      return this.$store.state.rsvpDetails.isTerminal;
    },
    creditCard: function creditCard() {
      if (this.isCorporate) {
        if (__WEBPACK_IMPORTED_MODULE_5__modules_plugins_common__["a" /* default */].isFDBrand(this.tripInfo.brandId)) return 'Direct Bill';
        if (this.isTerminal) return 'Terminal';
        return this.customerInfo.creditCard === '' || this.customerInfo.creditCard === null ? 'Direct Bill' : '**** ' + this.customerInfo.creditCard;
      }
      if (this.isTerminal) {
        return 'Terminal';
      }
      if (this.customerInfo.id === {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.goResUserId) {
        return 'Direct Bill';
      }
      return this.customerInfo.creditCard === '' || this.customerInfo.creditCard === null ? 'N/A' : '**** ' + this.customerInfo.creditCard;
    },
    totalFare: function totalFare() {
      var total = this.tripInfo.tip + this.tripInfo.fare + this.tripInfo.pickupFee + this.tripInfo.gasFee + this.tripInfo.travelInsurance + this.tripInfo.portalFee - this.tripInfo.credits;
      if (this.tripInfo.airportFee !== null && this.tripInfo.airportFee > 0) {
        total = total + this.tripInfo.airportFee;
      }
      return total < 0 ? 0 : total;
    },
    noShow: function noShow() {
      return this.$store.state.rsvpDetails.sendNoShow;
    },
    useOldQuatation: function useOldQuatation() {
      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation;
    },
    hideReminderButton: function hideReminderButton() {
      var rsvpDetails = this.$store.state.rsvpDetails.basicInfo.tripInfo;
      return rsvpDetails.status === 'canceled' || rsvpDetails.status === 'complete' || rsvpDetails.reservationState === 'NOSHOW';
    },
    extraStops: function extraStops() {
      return this.$store.state.rsvpDetails.extraStops;
    },
    services: function services() {
      return this.$store.state.services;
    },
    optin: function optin() {
      return this.$store.state.rsvpDetails.optin;
    },

    optinModal: {
      get: function get() {
        return this.optin.showModal;
      },
      set: function set(x) {
        this.$store.commit('rsvpDetails/setOptinData', { showModal: x });
      }
    },
    totalFareOptin: function totalFareOptin() {
      var total = this.tripInfo.tip + this.tripInfo.optinShared.shared.amount + this.tripInfo.pickupFee + this.tripInfo.gasFee + this.tripInfo.travelInsurance - this.tripInfo.credits;
      if (this.tripInfo.airportFee !== null && this.tripInfo.airportFee > 0) {
        total = total + this.tripInfo.airportFee;
      }
      return total < 0 ? 0 : total;
    },
    hasRSVPControl: function hasRSVPControl() {
      return this.$store.state.session.user.access.hasOwnProperty('PageAdminRsvpControl');
    },
    mtech: function mtech() {
      return this.$store.state.rsvpDetails.mtech;
    },
    isD2d: function isD2d() {
      return this.d2dId;
    },
    currency: function currency() {
      return this.$store.state.rsvpDetails.currency;
    },

    useLocalCurrency: {
      get: function get() {
        return this.$store.state.rsvpDetails.useLocalCurrency;
      },
      set: function set(x) {
        this.$store.commit('rsvpDetails/setLocalCurrency', x);
      }
    },
    totalFareIntl: function totalFareIntl() {
      var total = parseFloat(this.currency.amount) + parseFloat(this.currency.pickupFee) + parseFloat(this.currency.tipAmount) + parseFloat(this.currency.gasFee) + parseFloat(this.currency.travelInsurance) - parseFloat(this.currency.credit);
      if (this.tripInfo.airportFee !== null && this.tripInfo.airportFee > 0) {
        total += parseFloat(this.currency.airportFee);
      }
      return __WEBPACK_IMPORTED_MODULE_6__modules_api_currency__["a" /* default */].format({
        code: this.currency.currency,
        val: total.toFixed(2)
      });
    },
    totalFareOptinIntl: function totalFareOptinIntl() {
      var total = this.applyCurrency(this.tripInfo.optinShared.shared.amount, false) + parseFloat(this.currency.pickupFee) + parseFloat(this.currency.tipAmount) + parseFloat(this.currency.gasFee) + parseFloat(this.currency.travelInsurance) - parseFloat(this.currency.credit);
      if (this.tripInfo.airportFee !== null && this.tripInfo.airportFee > 0) {
        total += parseFloat(this.currency.airportFee);
      }
      return __WEBPACK_IMPORTED_MODULE_6__modules_api_currency__["a" /* default */].format({
        code: this.currency.currency,
        val: total.toFixed(2)
      });
    },
    totalDriverPaymentIntl: function totalDriverPaymentIntl() {
      var tripInfo = this.$store.state.rsvpDetails.basicInfo.tripInfo;
      var driverPayment = tripInfo.driverPayment;
      if (parseFloat(tripInfo.overridePayment) > 0) {
        driverPayment = tripInfo.overridePayment;
      }
      driverPayment = this.applyCurrency(driverPayment, false);
      var total = driverPayment + this.applyCurrency(tripInfo.driverBonus, false) + this.currency.tipAmount + this.currency.pickupFee + this.currency.gasFee;
      return __WEBPACK_IMPORTED_MODULE_6__modules_api_currency__["a" /* default */].format({
        code: this.currency.currency,
        val: total.toFixed(2)
      });
    },
    lyft: function lyft() {
      return this.$store.state.rsvpDetails.lyft;
    },
    lyftStore: function lyftStore() {
      return this.$store.state.lyft;
    },
    convenienceFeeIntl: function convenienceFeeIntl() {
      return __WEBPACK_IMPORTED_MODULE_6__modules_api_currency__["a" /* default */].format({
        code: this.currency.currency,
        val: this.tripInfo.portalFee.toFixed(2)
      });
    }
  },
  methods: {
    setShowPaymentBreakdown: function setShowPaymentBreakdown(value) {
      this.$store.commit('rsvpDetails/setShowPaymentBreakdown', value);
    },
    call: function call(user) {
      var self = this;
      self.showOptions = false;
      var phone = '' + user.phone.countryCode + user.phone.number;
      self.$plugins.phone.startCall(self, {
        phone: parseInt(phone),
        name: user.firstName + ' ' + user.lastName
      });
    },
    getFlightStatus: function getFlightStatus(labelOnly) {
      var self = this;
      if (self.flightLoading) {
        return;
      }
      self.flightLoading = true;
      var pickupDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.tripInfo.pickupDate, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__["a" /* default */].timeFormat(self, false));
      var isDeparture = this.tripInfo.isAirportPickup ? '0' : '1';
      __WEBPACK_IMPORTED_MODULE_3__modules_api_reservations__["a" /* default */].getFlightStatus(self, {
        flightCode: self.tripInfo.airlineCode + self.tripInfo.flightNo,
        date: pickupDate.format('YYYY-MM-DD'),
        time: pickupDate.format('HH:mm:ss'),
        isDeparture: isDeparture,
        airportCode: self.tripInfo.airportCode
      }, function (res) {
        self.flightLoading = false;
      });
    },
    showFlightStatus: function showFlightStatus() {
      this.$store.commit('rsvpDetails/setShowFlightStatus', true);
    },
    toFixed: function toFixed(value) {
      return parseFloat(value).toFixed(2);
    },
    translateFlightStatus: function translateFlightStatus(status) {
      switch (status) {
        case 'Scheduled':
          return { label: 'On Time', class: 'ontime' };
        case 'Proposed':
          return { label: 'On Time', class: 'ontime' };
        case 'OutGate':
          return { label: 'On Time', class: 'ontime' };
        case 'InAir':
          return { label: 'On Air', class: 'onair' };
        case 'Landed':
          return { label: 'Arrived', class: 'arrived' };
        case 'InGate':
          return { label: 'Arrived', class: 'arrived' };
        case 'Arrived':
          return { label: 'Arrived', class: 'arrived' };
        case 'Expected':
          return { label: 'On Time', class: 'ontime' };
        case 'NoTakeOffInfo':
          return { label: 'On Time', class: 'ontime' };
        case 'Delayed':
          return { label: 'Delayed', class: 'delayed' };
        case 'Cancelled':
          return { label: 'Cancelled', class: 'cancelled' };
        case 'Unknown':
          return { label: 'On Time', class: 'ontime' };
        case 'PastFlight':
          return { label: 'Arrived', class: 'arrived' };
        case 'Original':
          return { label: 'On Time', class: 'ontime' };
      }
      return { label: 'On Time', class: 'ontime' };
    },
    sendEmail: function sendEmail() {
      var title = 'Send Confirmation Email';
      if (this.rsvpStatus === 'complete') {
        title = 'Send Receipt Email';
      }
      if (this.rsvpStatus === 'canceled') {
        title = 'Send Cancellation Email';
      }
      if (this.tripInfo.reservationState === 'NOSHOW') {
        title = 'Send No Show Email';
      }
      this.$store.commit('rsvpDetails/setEmailRecipientField', {
        field: 'title',
        value: title
      });
      this.$store.commit('rsvpDetails/setEmailRecipientField', {
        field: 'show',
        value: true
      });
      // let self = this
      // self.emailLoading = true
      // ApiRsvp.sendEmail(self, self.$store.state.rsvpDetails.rsvpId, function (res) {
      //   self.emailLoading = false
      //   self.$store.commit('rsvpDetails/setSendEmail', {
      //     show: true,
      //     message: self.$t('rsvpDetails.emailSent')
      //   })

      //   if (res.error) {
      //     self.$store.commit('rsvpDetails/setSendEmail', {
      //       show: true,
      //       message: res.error.message
      //     })
      //   }
      // })
    },
    sendNoShow: function sendNoShow() {
      if (!this.hasRSVPControl) return;

      this.$store.commit('rsvpDetails/setSendNoShow', {
        showModal: true,
        loading: false,
        showMsg: false,
        message: '',
        forceHide: this.$store.state.rsvpDetails.sendNoShow.forceHide
      });
    },
    sendTripReminder: function sendTripReminder() {
      var self = this;
      self.tripRemindLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__modules_api_reservations__["a" /* default */].sendTripReminder(self, self.$store.state.rsvpDetails.rsvpId, function (res) {
        self.tripRemindLoading = false;
        self.$store.commit('rsvpDetails/setSendEmail', {
          show: true,
          message: self.$t('rsvpDetails.emailSent')
        });

        if (res.error) {
          self.$store.commit('rsvpDetails/setSendEmail', {
            show: true,
            message: res.error.message
          });
        }
      });
    },
    hideOptions: function hideOptions() {
      var self = this;
      self.showOptionsDelay = setTimeout(function () {
        self.showOptions = false;
      }, 1500);
    },
    clearOptionDelay: function clearOptionDelay() {
      if (this.showOptionsDelay) {
        clearTimeout(this.showOptionsDelay);
      }
    },
    sendSMS: function sendSMS() {
      this.showOptions = false;
      this.$parent.sendSMS();
    },
    showNotif: function showNotif() {
      this.showOptions = false;
      this.$parent.showNotif();
    },
    extraStopAddress: function extraStopAddress(x) {
      return x.address2 + ' ' + x.address1 + ', ' + x.city + ', ' + x.state + ' ' + x.zipCode;
    },
    computeEndDate: function computeEndDate(x) {
      var endDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(x.pickupDate, 'MM/DD/YYYY hh:mmA').add(x.eta, 'seconds');
      return endDate.format('MM/DD/YYYY hh:mmA');
    },
    checkTncService: function checkTncService() {
      var _this = this;

      this.isTncService = false;
      if (!this.services.list.length || !this.tripInfo.serviceTypeId) return;
      var service = this.services.list.find(function (x) {
        return x.id === _this.tripInfo.serviceTypeId;
      });
      if (service && service.allowTNC) {
        this.isTncService = true;
      }
    },
    applyCurrency: function applyCurrency(x) {
      var useSymbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      x = parseFloat(x);
      x = x * this.currency.currencyRate;
      return useSymbol ? '' + this.currency.symbol + x.toFixed(2) : parseFloat(x.toFixed(2));
    },
    displayPhone: function displayPhone(data) {
      var phone = '';
      if (data) phone = data.countryCode + ' ' + data.number;
      if (data && !phone.includes('+')) phone = '+' + phone;
      return phone;
    },
    lyftServiceLabel: function lyftServiceLabel(x) {
      return this.lyftStore.services[x] ? this.lyftStore.services[x].name : x;
    }
  },
  watch: {
    tripInfo: function tripInfo(value) {
      this.contentShow.tripInfo = true;
      if (value.airlineCode !== '' && value.airlineCode !== null && this.rsvpStatus !== 'complete' && this.rsvpStatus !== 'canceled') {
        this.getFlightStatus(true);
      }
    },
    businessInfo: function businessInfo() {
      this.contentShow.businessInfo = true;
    },
    customerInfo: function customerInfo() {
      this.contentShow.customerInfo = true;
    },
    guestInfo: function guestInfo() {
      this.contentShow.guestInfo = true;
    },
    driverInfo: function driverInfo() {
      this.contentShow.driverInfo = true;
    },
    otherInfo: function otherInfo() {
      this.contentShow.otherInfo = true;
    },
    'services.serviceLoading': function servicesServiceLoading(val) {
      if (val) {
        this.checkTncService();
      }
    },
    'tripInfo.serviceTypeId': function tripInfoServiceTypeId(val) {
      if (val) {
        this.checkTncService();
      }
    },
    'lyft.show': function lyftShow(val) {
      this.contentShow.lyft = val;
    }
  }
});

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_reservations__ = __webpack_require__(111);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'transactions',
  props: ['rsvpId'],
  data: function data() {
    return {
      loading: false
    };
  },

  computed: {
    transactions: function transactions() {
      return this.$store.state.rsvpDetails.transactionList;
    },
    currency: function currency() {
      return this.$store.state.rsvpDetails.currency;
    },
    useLocalCurrency: function useLocalCurrency() {
      return false;
    }
  },
  methods: {
    init: function init() {
      var self = this;
      self.loading = true;
      self.$store.commit('rsvpDetails/resetTransactionList');
      __WEBPACK_IMPORTED_MODULE_0__modules_api_reservations__["a" /* default */].getTransactionByRsvpId(self, self.rsvpId, function (res) {
        self.loading = false;
      });
    },
    relabel: function relabel(trx) {
      if (trx.statusLabel !== 'Credit Conversion') {
        return trx.statusLabel;
      }
      return 'Open Credit';
    },
    checkReclaimed: function checkReclaimed(trx) {
      if (trx.transactionType !== 'CONVERT_CREDIT ') {
        return '';
      }

      if (trx.transactionType === 'CONVERT_CREDIT ' && trx.notes === 'RECLAIMED') {
        return 'RECLAIMED';
      }
    },
    applyCurrency: function applyCurrency(x) {
      x = x.substring(x.indexOf('$') + 1);
      x = parseFloat(x);
      x = x * this.currency.currencyRate;
      return '' + this.currency.symbol + x.toFixed(2);
    }
  },
  watch: {
    rsvpId: function rsvpId(value) {
      this.init();
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'system-logs',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_reservation_details_dispatch__ = __webpack_require__(603);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dispatch-logs',
  props: ['rsvpId'],
  data: function data() {
    return {
      loading: false
    };
  },

  computed: {
    dispatches: function dispatches() {
      return this.$store.state.rsvpDetails.dispatchLogs;
    }
  },
  methods: {
    init: function init() {
      var self = this;
      self.loading = true;
      self.$store.commit('rsvpDetails/resetDispatchLogs');
      __WEBPACK_IMPORTED_MODULE_0__modules_api_reservation_details_dispatch__["a" /* default */].getDispatchLogs(self, self.rsvpId, function (res) {
        self.loading = false;
      });
    }
  },
  watch: {
    rsvpId: function rsvpId(value) {
      this.init();
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_reservations__ = __webpack_require__(111);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notes',
  props: ['rsvpId'],
  data: function data() {
    return {
      loading: false,
      deleteLoading: false,
      deleteMessage: ''
    };
  },

  computed: {
    notes: function notes() {
      return this.$store.state.rsvpDetails.notes.list;
    },
    adminId: function adminId() {
      return this.$store.state.session.user.id;
    },
    noteDeleteId: function noteDeleteId() {
      return this.$store.state.rsvpDetails.notes.noteDeleteId;
    }
  },
  methods: {
    init: function init() {
      var self = this;
      self.loading = true;
      self.$store.commit('rsvpDetails/resetNotes');
      __WEBPACK_IMPORTED_MODULE_0__modules_api_reservations__["a" /* default */].getNotesByRsvpId(self, self.rsvpId, function (res) {
        self.loading = false;
      });
    },
    editNote: function editNote(value) {
      this.$store.commit('reservationNotes/show', {
        noteId: value.id,
        notes: value.message,
        noteStatus: value.status
      });
    },
    deleteNote: function deleteNote(value) {
      this.$store.commit('rsvpDetails/setNoteDeleteId', value.id);
      this.deleteMessage = '';
    },
    hideDelete: function hideDelete() {
      this.$store.commit('rsvpDetails/setNoteDeleteId', 0);
    },
    deleteConfirm: function deleteConfirm(noteId) {
      var self = this;
      self.deleteLoading = true;
      self.deleteMessage = '';
      __WEBPACK_IMPORTED_MODULE_0__modules_api_reservations__["a" /* default */].deleteNote(self, noteId, function (res) {
        if (res.error) {
          self.deleteMessage = res.error.msg;
        }
        self.deleteLoading = false;
      });
    }
  },
  watch: {
    rsvpId: function rsvpId(value) {
      this.init();
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getReleaseFee: function getReleaseFee(VueApp, param, callback) {
    VueApp.$sdk.get('/admin/' + param.type + '/' + param.id + '/unassign', {
      token: VueApp.$store.state.session.sessionToken
    }, function (r) {
      callback(r);
    });
  }
});

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_reservation_details_action__ = __webpack_require__(1822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_services__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */
var request = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'action-logs',
  props: ['rsvpId'],
  data: function data() {
    return {
      loading: false,
      quickResUserId: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.quickResUserId,
      searchedCoords: []
    };
  },

  computed: {
    _rsvpId: function _rsvpId() {
      return this.$route.params.id;
    },
    actions: function actions() {
      return this.$store.state.rsvpDetails.actionLogs;
    },
    rsvpAction: function rsvpAction() {
      return this.$store.state.rsvpDetails.rsvpAction;
    }
  },
  methods: {
    init: function init() {
      var self = this;
      self.loading = true;
      self.$store.commit('rsvpDetails/resetActionLogs');
      self.$forceUpdate();
      __WEBPACK_IMPORTED_MODULE_1__modules_api_reservation_details_action__["a" /* default */].getActionLogs(self, self._rsvpId, function (res) {
        self.$forceUpdate();
        self.loading = false;
      });
    },
    dateSplit: function dateSplit(data) {
      var date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(data, 'MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__["a" /* default */].timeFormat(this, true));
      return {
        date: date.format('MM/DD/YYYY'),
        time: date.format(__WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__["a" /* default */].timeFormat(this, true))
      };
    },
    checkLogToShow: function checkLogToShow(data) {
      switch (data.action) {
        case "assign_success":
          return false;
        case "cron_dispatch":
          return false;
        default:
          return true;
      }
    },
    displayAction: function displayAction(data) {
      switch (data.action) {
        //actions from system
        case "notify_cons_pickup":
          return '<b>System sent notification for pickup</b>';
        case "notify_cons_pickup_result":
          return '<b>System sent notification for pickup Info</b>';
        case "notify_dispatch":
          return '<b>System sent notification for dispatch</b>';

        //payment actions
        case "refund_fail":
        case "fee_fail":
        case "cancel_fail":
          return '<b>' + data.details.message + '</b>';
        case "refund_success":
          return '<b>Successfully refunded a transaction</b>';

        //consumer actions
        case "pay_fail":
          return '<b>Customer made a payment but failed</b>';
        case "consumer_cancel":
          return '<b>Customer cancelled the reservation</b>';
        case "consumer_release":
          return '<b>Customer released the driver</b>';
        case "cons_mark_rtg":
          return '<b>Customer marked the reservation ready to go</b>';
        case "consumer_convert":
          return '<b>Customer set this reservation to Open Credit</b>';

        //provider actions
        case "driver_accept":
          return '<b>Driver accepted the reservation</b>';
        case "driver_release":
          return '<b>Driver released the reservation</b>';
        case "driver_release_attempt":
          return '<b>Driver attempted to release the reservation</b>';
        case "driver_onboard":
          return '<b>Driver marked the passenger on-board</b>';
        case "driver_ontheway":
          return '<b>Driver has started the trip</b>';
        case "driver_arrived":
          return '<b>Driver has arrived at the pickup location</b>';
        case "driver_arrivestop":
          return '<b>Driver has arrived at the extra stop location</b>';
        case "driver_noshow":
          return '<b>Driver marked the reservation as no-show</b>';
        case "driver_noshow":
          return '<b>Driver marked the reservation as no-show</b>';
        case "driver_complete":
          return '<b>Driver marked the reservation as completed</b>';
        case "driver_complete_attempt":
          return '<b>Driver attempted to complete the reservation</b>';
        case "driver_reject":
          return '<b>Driver declined the reservation request</b>';
        case "reject_schedule":
          return '<b>Driver declined a schedule request</b>';
        case "asap_booking":
          return '<b>Driver accepted the ASAP request</b>';
        case "asap_accepted":
          return '<b>Driver accepted the ASAP request</b>';
        case "driver_onboard_attempt":
          return '<b>Driver attempted to marked the passenger on-board</b>';
        case "driver_onboard_error":
          return '<b>Error trying to mark onboard</b>';

        // mtech
        case "mtech_error":
          return '<b>Mtech Error</b>';

        // lyft
        case "lyft_quote":
          return '<b>Lyft Quote</b>';
        case "lyft_create":
          return '<b>Created a ride with Lyft</b>';
        case "lyft_status":
          return '<span>Lyft Status:</span> <b style="margin-left: 5px">' + this.lyftStatus(data.details.status) + '</b>';
        case "lyft_cancel":
          return '<span>Lyft:</span> <b> Sent cancellation request</b>';
        case "lyft_receipt_ready":
          return '<span>Lyft:</span> <b>Ride Ended</b>';
        case "lyft_cancel_fee_error":
          return '<span>Lyft:</span> <b>Issue while charging cancellation fee</b>';
        case "auth_leave_uncaptured":
          return '<b>Intentionally not capturing Auth Trx</b>';
        case "cancel_fee_no_card":
          return '<b>Cancellation fee uncharged</b>';
        case "lyft_no_cancel_fees":
          return '<b>No Lyft cancellation fee</b>';
        case "lyft_tip_ok":
          return '<b>Lyft Tip OK</b>';
        case "lyft_tip_err":
          return '<b>Lyft Tip Error</b>';
        case "lyft_error":
          return '<b>Lyft Error</b>';

        case "trx_fail":
          return '<b>Transaction Failed</b>';
        case "driver_payment_force_override":
          return '<b>Driver Payment Force Override</b>';
        case "driver_valid_check":
          return '<b>Driver Valid Check</b>';
        case "overwork_check_result":
          return '<b>Overwork Check Result</b>';
        case "overwork_check_skip":
          return '<b>Overwork Check Skip</b>';
        case "rating":
          return '<b>Rating</b>';

        //admin actions
        case "assign_attempt":
          return '<b>Admin assigned the reservation to the driver</b>';
        case "assign_success":
          return '<b>Reservation has been successfully assigned</b>';
        case "mark_complete":
          return '<b>Admin marked the reservation as completed</b>';
        case "mark_complete_attempt":
          return '<b>Admin tried to mark the reservation as complete</b>';
        case "sent_provider":
          return '<b>Admin sent the reservation to the driver</b>';
        case "sent_asap":
          return '<b>Admin sent the reservation as ASAP</b>';
        case "auto_dispatch":
          return '<b>Admin triggered auto dispatch</b>';
        case "move_pool":
          return '<b>Admin moved the reservation to the pool</b>';
        case "remove_pool":
          return '<b>Admin removed the reservation from the pool</b>';
        case "cancel_rsvp":
          return '<b>Admin cancelled the reservation</b>';
        case "refund":
          return '<b>Admin issued a full refund</b>';
        case "refund_partial":
          return '<b>Admin issued a partial refund</b>';
        case "remove_noshow_payout":
          return '<b>Admin removed the no-show payout</b>';
        case "issue_credit":
          return '<b>Admin issued additional credits to the customer</b>';
        case "add_charge":
          return '<b>Admin made additional charges to the customer</b>';
        case "admin_noshow":
          return '<b>Admin marked the reservation as no-show</b>';
        case "send_schedule":
          return '<b>Admin sent the reservation to a driver as part of a schedule</b>';
        case "admin_mark_rtg":
          return '<b>Admin marked the reservation ready to go</b>';
        case "release_driver":
          return '<b>Admin released the driver</b>';
        case "admin_convert":
          return '<b>Admin set this reservation to Open Credit</b>';
        case "run_assign_attempt":
          return '<b>Admin assigned the run to the driver</b>';
        case "run_assign_success":
          return '<b>Run has been successfully assigned</b>';
        case "run_sent_provider":
          return data.admin ? '<b>Admin sent the run to the driver</b>' : '<b>System sent the run to the driver</b>';
        case "run_accepted":
          return '<b>Driver accepted the run</b>';
        case "run_declined":
          return '<b>Driver declined the run request</b>';
        case "optin_shared":
          return '<b>Reservation converted to a shared service.</b>';
        case "optin_exclusive":
          return '<b>Reservation converted to exclusive.</b>';
        case "static_mark_rtg":
          return '<b>Marked reservation as Ready To Go on a kiosk</b>';
        case "manual_rsvp_reminder":
          return '<b>Manually triggered trip reminder.</b>';
        case "run_create":
          return data.admin ? '<b>Admin created a run</b>' : '<b>System created a run</b>';

        case "edit_rsvp":
          if (data.admin) return '<b>Admin made an update</b>';
          return '<b>Customer made an update</b>';

        case "create_rsvp":
          if (data.admin) return '<b>Admin created the reservation</b>';
          return data.consumer && data.consumer.id === {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.quickResUserId ? '<b>Driver created the reservation</b>' : '<b>Customer created the reservation</b>';

        case "update_fail":
          if (data.admin) return '<b>Admin made an update but failed</b>';
          return '<b>Customer made an update but failed</b>';

        case "refund_converted":
          if (data.admin) return '<b>Admin converted the reservation into ride credits</b>';
          return '<b>Customer converted the reservation into ride credits</b>';

        case "credit_reclaimed":
          if (data.admin) return '<b>Admin reclaimed the converted credits and refunded the charges</b>';
          return '<b>Customer reclaimed the converted credits and refunded the charges</b>';

        case "resend_email":
        case "resend_email_cons":
        case "resend_email_prov":
          var userType = 'Admin';
          if (!data.admin) {
            if (!data.provider) userType = 'Customer';else userType = 'Driver';
          }
          switch (data.details.email.template) {
            case "rsvp/admincancel":
            case "rsvp/canceled":
              return '<b>' + userType + ' resent the cancellation email</b>';
            case "rsvp/confirmation":
            case "rsvp/roundtrip":
              return '<b>' + userType + ' resent the confirmation email</b>';
            case "rsvp/completed":
              return '<b>' + userType + ' resent the receipt email</b>';
            case "rsvp/refunded":
              return '<b>' + userType + ' resent the refund email</b>';
          }
        default:
          return '<b>' + data.action + '</b>';
      }
    },
    displayLog: function displayLog(data, i) {
      var self = this;
      var createdTime = self.dateSplit(data.created).date + ' ' + self.dateSplit(data.created).time;
      var admin = data.admin ? '<br/><div>Admin ID: <b>' + data.admin.id + '</b></div><div>Admin Name: <b>' + data.admin.name + '</b></div> <div>Admin Email: <b>' + data.admin.email + '</b></div>' : '';
      var provider = data.provider ? '<br/><div>Driver ID: <b><a href="/#/provider/' + data.provider.id + '" target="_blank">' + data.provider.id + '</a></b></div><div>Driver Name: <b>' + data.provider.name + '</b></div> <div>Driver Email: <b>' + data.provider.email + '</b></div>' : '';
      var consumer = data.consumer ? '<br/><div>Customer ID: <b><a href="/#/consumer/' + data.consumer.id + '" target="_blank">' + data.consumer.id + '</a></b></div><div>Customer Name: <b>' + data.consumer.name + '</b></div> <div>Customer Email: <b>' + data.consumer.email + '</b></div>' : '';
      if (data.consumer && data.consumer.id === {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.quickResUserId) {
        consumer = '';
      }
      var recipient = data.recipient ? '<br/><div>Recipient ID: <b><a href="/#/provider/' + data.recipient.id + '" target="_blank">' + data.recipient.id + '</a></b></div><div>Recipient Name: <b>' + data.recipient.name + '</b></div> <div>Recipient Email: <b>' + data.recipient.email + '</b></div>' : '';
      // let coordinates = data.details.coords ? `<div>Location: <i>lat: </i><b>${data.details.coords.lat} </b> <i>lng: </i><b>${data.details.coords.lng}</b><a href="https://www.google.com/maps/search/${data.details.coords.lat},${data.details.coords.lng}" target="_blank"><i class="fa fa-map-marker m-L-5"></i></a></div>` : ''
      // let driverCoords = data.details.driverCoords ? `<div>Location: <i>lat: </i><b>${data.details.driverCoords.lat} </b> <i>lng: </i><b>${data.details.driverCoords.lng}</b><a href="https://www.google.com/maps/search/${data.details.driverCoords.lat},${data.details.driverCoords.lng}" target="_blank"><i class="fa fa-map-marker m-L-5"></i></a></div>` : ''
      var coordinates = data.details.coords ? '<div class="coords">Location: <i class="fas fa-spinner fa-spin fa-fw slow-spin"></i><span></span></div>' : '';
      var driverCoords = data.details.driverCoords ? '<div class="coords">Location: <i class="fas fa-spinner fa-spin fa-fw slow-spin"></i><span></span></div>' : '';
      var amount = data.details.amount ? '<div>Amount: <b>$' + data.details.amount + '</b></div>' : '';
      var creditAmount = data.details.amount ? '<div>Amount: <b>-$' + Math.abs(data.details.amount) + '</b></div>' : '';
      var ipAddress = data.details.ip ? '<div>IP Address: <b>' + data.details.ip + '</b></div>' : '';
      if (data.consumer && data.consumer.id === {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.quickResUserId) {
        ipAddress = '';
      }
      var driverInfo = data.details.driverInfo ? '<br/><div>Driver ID: <b><a href="/#/provider/' + data.details.driverInfo.id + '" target="_blank">' + data.details.driverInfo.id + '</a></b></div><div>Driver Name: <b>' + data.details.driverInfo.name + '</b></div> <div>Driver Email: <b>' + data.details.driverInfo.email + '</b></div>' : '';
      // let releaseNote = data.details.params.charge ? '<div>Admin chose to charge the driver</div>' : '<div>Admin chose to release the driver for free</div>'
      var fields = [];

      var hasCoords = ['driver_accept', 'driver_ontheway', 'driver_onboard', 'driver_arrived', 'driver_arrivestop', 'driver_noshow', 'driver_complete', 'driver_reject', 'asap_booking', 'asap_accepted', 'reject_schedule', 'driver_release'];
      if (hasCoords.indexOf(data.action) > -1 && data.collapsed && data) {
        self.coordsLookup(data.details.coords || data.details.driverCoords, i);
      }

      var runsLog = ['run_assign_attempt', 'run_assign_success', 'run_sent_provider', 'run_accepted', 'run_declined'];
      var RSVPs = '';
      if (runsLog.indexOf(data.action) > -1) {
        provider = '<br/><div>Driver ID: <b><a href="/#/provider/' + data.details.driverID + '" target="_blank">' + data.details.driverID + '</a></b></div><div>Driver Name: <b>' + data.details.driverName + '</b></div>';
        RSVPs = '<br/><div>RSVPs within run: ';
        var temp_rsvp = [];
        data.details.rsvpIds.forEach(function (rsvp) {
          temp_rsvp.push('<b><a href="/#/reservation/' + rsvp + '" target="_blank">' + rsvp + '</a></b>');
        });
        RSVPs = RSVPs + temp_rsvp.join(', ');
      }
      if (data.action === 'run_create') {
        var _temp_rsvp = [];
        data.details.rsvpIds.forEach(function (rsvp) {
          _temp_rsvp.push('<b><a href="/#/reservation/' + rsvp + '" target="_blank">' + rsvp + '</a></b>');
        });
        RSVPs = '\n          <br/><div>RUN ID: <b>' + data.details.runId + '</b></div>\n          <div>RSVPs within run: ' + _temp_rsvp.join(', ') + '</div>\n        ';
      }

      switch (data.action) {
        default:
          return consumer;
        case "edit_rsvp":
          data.fields.forEach(function (log) {
            if (log.field === 'payment.cardID') {
              return;
            }
            if (log.field === 'waive_payment') {
              fields.push('<div style="background: #a51a1a;color: #fff;line-height: 1;padding: 3px 8px;border-radius: 3px;letter-spacing: .6px;border: 1px solid #600606;display:inline-block;margin-top:20px"><b>Waived Payment</b></div><br/>');
            }
            if (self.checkField(log).show) {
              fields.push('<br/><div><b>' + self.labelFormat(log.field) + '</b></div><div>' + self.valueFormat(log.field, log.old) + ' <i class="fas fa-chevron-right"></i> <b>' + self.valueFormat(log.field, log.new) + '</b></div>');
            }
          });
          return !consumer.length ? admin + ipAddress + fields.join('') : consumer + ipAddress + fields.join('');

        case "create_rsvp":
          return !consumer.length ? admin + ipAddress : consumer + ipAddress;

        case "refund_converted":
          return !consumer.length ? admin + ipAddress : consumer + ipAddress;
        case "credit_reclaimed":
          return !consumer.length ? admin + creditAmount + ipAddress : consumer + creditAmount + ipAddress;

        case "update_fail":
          return !consumer.length ? admin + '<div>Cause: <b>' + data.details.message + '<b/></div>' : consumer + '<div>Cause: <b>' + data.details.message + '<b/></div>';

        case "notify_cons_pickup_result":
          return 'Email: <b>' + (data.details.email || '') + '</b><div>SMS: <b>' + data.details.sms + '</b></div>';

        //payment
        case "refund_fail":
        case "fee_fail":
        case "cancel_fail":
          return data.details.error.message;
        case "refund_success":
          return data.details.message;

        //consumer
        case "pay_fail":
          return consumer;
        case "cons_mark_rtg":
          return consumer;
        case "consumer_cancel":
          return consumer + '\n            <div>Cancellation Fee: <b>$' + data.details.cancellationFee + '</b></div>\n            <div>Cancellation Reason: <b>' + data.details.cancellationReason + '</b></div>\n          ';
        case "resend_email_cons":
          return consumer + '<div>Subject: <b>' + data.details.email.subject + '</b></div> <div>Message: <b>' + data.details.email.template + '</b></div>';
        case "consumer_release":
          return consumer + driverInfo;
        case "consumer_convert":
          var consCancelReason = data.details.cancellationReason;
          consCancelReason ? consCancelReason : consCancelReason = 'Unspecified';
          return consumer + '\n            <div>Cancellation Fee: <b>$0</b></div>\n            <div>Cancellation Reason: <b>' + consCancelReason + '</b></div>\n          ';

        //driver
        case "driver_accept":
          return provider + coordinates;
        case "driver_ontheway":
          return provider + coordinates;
        case "driver_onboard":
          return provider + coordinates;
        case "driver_arrived":
          return provider + driverCoords;
        case "driver_arrivestop":
          return provider + driverCoords;
        case "driver_noshow":
          return provider + coordinates;
        case "driver_complete":
          var error = data.details && data.details.error ? '<i class="float-mt">' + data.details.error + '</i><br/>' : '';
          return error + ' ' + provider + ' ' + coordinates;
        case "driver_complete_attempt":
          return data.details && data.details.error ? '<i class="float-mt">' + data.details.error + '</i>' : '';
        case "driver_reject":
          return provider + coordinates;
        case "asap_booking":
          return provider + coordinates;
        case "asap_accepted":
          return provider + driverCoords;
        case "reject_schedule":
          return provider + coordinates;
        case "driver_release":
          return provider + coordinates + '<div>Release Fee: <b>$' + data.details.fee.Charge + '</b></div>';
        case "resend_email_prov":
          return provider + '<div>Subject: <b>' + data.details.email.subject + '</b></div> <div>Message: <b>' + data.details.email.template + '</b></div>';
        case "driver_onboard_error":
          return '<div>' + (data.details.err || '') + '</div>';

        // mtech error
        case "mtech_error":
          return '<div>' + data.details.error + '</div>';

        // lyft
        case "auth_leave_uncaptured":
          return '<div>' + data.details.message + '</div>';
        case "cancel_fee_no_card":
          return '<div>' + data.details.message + '</div>';
        case "lyft_no_cancel_fees":
          return '<div>' + data.details.message + '</div>';
        case "lyft_tip_err":
          return '<div>' + (data.details.err || '') + '</div>';
        case "lyft_error":
          var extraMsg = data.details.response ? JSON.parse(data.details.response) : '';
          if (extraMsg) extraMsg = extraMsg.error.error_description;
          return '<div>' + (data.details.error + '.<br/>' || '') + ' ' + (extraMsg || '') + '</div>';

        case "trx_fail":
          return '<div>' + data.details.error.message + '</div>';
        case "driver_payment_force_override":
          return '\n          <div>Original Payment: <b>$' + data.details.paidForProvider + '</b></div>\n          <div>Original Override: <b>$' + data.details.overridePayment + '</b></div>\n          <div>New Override: <b>$' + data.details.newValue + '</b></div>\n        ';
        case "driver_valid_check":
          return '\n          <div>Max Work mins: <b>' + data.details.maxWorkMins + '</b></div>\n          <div style="padding-bottom: 7px">Violation Max Work: <b>' + data.details.violateMaxWork + '</b></div>\n          <div>Min Rest mins: <b>' + data.details.minRestMins + '</b></div>\n          <div>Violation Min Rest: <b>' + data.details.violateMinRest + '</b></div>\n        ';
        case "overwork_check_result":
          {
            var violateMaxWork = data.details.violateMaxWork != null ? '<div style="padding-bottom: 7px">Violation Max Work: <b>' + data.details.violateMaxWork + '</b></div>' : '';
            var violateMinRest = data.details.violateMinRest != null ? '<div style="padding-bottom: 7px">Violation Min Rest: <b>' + data.details.violateMinRest + '</b></div>' : '';
            return '\n            <div>Max Work mins: <b>' + data.details.maxWorkMins + '</b></div>\n            ' + violateMaxWork + '\n            <div>Min Rest mins: <b>' + data.details.minRestMins + '</b></div>\n            ' + violateMinRest + '\n            <div>Trips: <b>' + data.details.displayTrips + '</b></div>\n          ';
          }
        case "overwork_check_skip":
          return data.details.displayMsg;
        case "rating":
          return '\n          <div>Rating: <b>' + data.details.rating + '</b></div>\n          <div>Review: <b>' + data.details.review + '</b></div>\n          <div>Tip: <b>$' + data.details.tip + '</b></div>\n        ';

        //admin
        case "assign_attempt":
          return admin + recipient;
        case "assign_success":
          return admin + recipient;
        case "sent_provider":
          return admin + recipient;
        case "sent_asap":
          return admin + recipient;
        case "auto_dispatch":
          return admin;
        case "move_pool":
          return admin;
        case "remove_pool":
          return admin;
        case "admin_noshow":
          return admin;
        case "admin_mark_rtg":
          return admin;
        case "resend_email":
          return admin + '<div>Subject: <b>' + data.details.email.subject + '</b></div> <div>Message: <b>' + data.details.email.template + '</b></div>';
        case "mark_complete":
          var note = '';
          if (data.details.error) note = data.details.error;
          if (data.details.params && data.details.params.notes) note = data.details.params.notes;
          return admin + '<div>Note: <b>' + note + '</b></div>';
        case "mark_complete_attempt":
          var note2 = '';
          if (data.details.error) note2 = data.details.error;
          if (data.details.params && data.details.params.notes) note2 = data.details.params.notes;
          return admin + ' ' + (note2 ? '<div>Note: <b>' + note2 + '</b></div>' : '');
        case "cancel_rsvp":
          return admin + '\n            <div>Cancellation Fee: <b>$' + data.details.messaging.CancellationFee + '</b></div>\n            <div>Cancellation Reason: <b>' + data.details.cancellationReason + '</b></div>\n            <div>Note: <b>' + data.details.notes + '</b></div>\n          ';
        case "release_driver":
          var releaseNote = data.opted ? '<br/><div>Admin opted to charge release fee from the driver</div>' : '<br/><div>Admin did not opt to charge release fee from the driver</div>';
          return admin + driverInfo + releaseNote;
        case "refund":
          return admin + '<div>Cancel: <b>' + data.details.cancel + '</b></div> <div>Charge Fee: <b>' + data.details.chargeFees + '</b></div>';
        case "refund_partial":
          return admin + amount;
        case "remove_noshow_payout":
          return admin + '<div style="margin-top:3px;letter-spacing: .5px">' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.details) + '</div>';
        case "issue_credit":
          return admin + amount;
        case "add_charge":
          return admin + amount;
        case "send_schedule":
          return admin + recipient + '<div>Schedule ID: <b>' + data.details.scheduleId + '</b></div> <div>RSVP ID: <b>' + data.details.contents.rsvp + '</b></div> <div>Package ID: <b>' + data.details.contents.pkg + '</b></div>';
        case "admin_convert":
          var adminCancelReason = data.details.cancellationReason;
          adminCancelReason ? adminCancelReason : adminCancelReason = 'Unspecified';
          return admin + '<div>Cancellation Fee: <b>$0</b></div>' + '<div>Cancellation Reason: <b>' + adminCancelReason + '</b></div>' + '<div>Note: <b>' + data.details.notes + '</b></div>';
        case "run_assign_attempt":
          return admin + provider + RSVPs;
        case "run_assign_success":
          return admin + provider + RSVPs;
        case "run_sent_provider":
          return admin + provider + RSVPs;
        case "run_accepted":
          return admin + provider + RSVPs;
        case "run_declined":
          return admin + provider + RSVPs;
        case "run_create":
          return data.admin ? admin + RSVPs : RSVPs;
      }
    },
    checkField: function checkField(data) {
      var exception = ['pickup.address1', 'pickup.address2', 'pickup.lat', 'pickup.lng', 'pickup.geofenceId', 'pickup.city', 'pickup.zip', 'pickup.state', 'pickup.country', 'dropoff.address1', 'dropoff.address2', 'dropoff.lat', 'dropoff.lng', 'dropoff.geofenceId', 'dropoff.city', 'dropoff.zip', 'dropoff.state', 'dropoff.country', 'ada.wheelchair', 'ada.serviceDog', 'waive_payment'];

      var show = !exception.includes(data.field);
      if (data.field === 'pickup.address2' && (data.old && data.old.indexOf('Apt/Gate') > -1 || data.new && data.new.indexOf('Apt/Gate') > -1) && data.old !== data.new) {
        show = true;
      }
      return { show: show };
    },
    labelFormat: function labelFormat(field) {
      switch (field) {
        default:
          return field.replace(/^\w/, function (c) {
            return c.toUpperCase();
          });
        case 'pickup.title':
          return 'Pickup';
        case 'pickup.address2':
          return 'Apt/Gate';
        case 'dropoff.title':
          return 'Dropoff';
        case 'pickupTime':
          return 'Pickup Time';
        case 'passengers':
          return 'Passenger';
        case 'luggage':
          return 'Luggage';
        case 'overridePayment':
          return 'Driver Payment Override';
        case 'driverBonus':
          return 'Driver Payment Bonus';
        case 'overridePrice':
          return 'Price Override';
        case 'payment.tip':
          return 'Tip';
        case 'payment.promo':
          return 'Promo';
        case 'notes':
          return 'Note to Driver';
        case 'serviceTypeId':
          return 'Service';
        case 'amount':
          return 'Fare';
        case 'wheelChairLift':
          return 'Wheelchair';
        case 'serviceDog':
          return 'Service Dog';
        case 'payment.cardID':
          return 'Payment Card';
        case 'deviceType':
          return 'Device Used';
        case 'flightNumber':
          return 'Flight Number (Arrival)';
        case 'flightName':
          return 'Airline (Arrival)';
        case 'dropoffFlightNumber':
          return 'Flight Number (Departure)';
        case 'dropoffFlightName':
          return 'Airline (Departure)';
        case 'pickupType':
          return 'Pickup Type';
        case 'guestFname':
          return 'Guest First Name';
        case 'guestLname':
          return 'Guest Last Name';
        case 'guestPhone':
          return 'Guest Phone';
        case 'etaInSec':
          return 'Duration';
        case 'optinShared':
          return 'Opt-in Shared';
        case 'portalFee':
          return 'Portal Fee';
        case 'travelInsurance':
          return 'Rider Fee';
        case 'airportFee':
          return 'Airport Fee';
        case 'gasFee':
          return 'Gas Fee';
      }
    },
    valueFormat: function valueFormat(field, value) {
      if (!value && field != 'optinShared') {
        return 'none';
      }
      if (['pickup.address2'].includes(field)) {
        return value.split('Apt/Gate: ')[1];
      }
      if (['pickupTime'].includes(field)) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value, 'YYYY-MM-DD ' + __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__["a" /* default */].timeFormat(this, true)).format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
      }
      var dollarFields = ['amount', 'payment.tip', 'overridePrice', 'overridePayment', 'driverBonus', 'airportFee', 'travelInsurance', 'gasFee', 'portalFee'];
      if (dollarFields.includes(field)) return '$' + parseFloat(value).toFixed(2);

      if (['serviceDog', 'wheelChairLift'].includes(field)) {
        return value ? 'Checked' : 'Unchecked';
      }
      if (['serviceTypeId'].includes(field)) {
        if (value > 5) {
          var service = __WEBPACK_IMPORTED_MODULE_3__modules_api_services__["a" /* default */].getServiceData(this, value);
          return '<span class="__service-label" style="background:' + service.color + '">' + service.label + '</span>';
        }
        var label = '';
        switch (value) {
          case 1:
            label = 'shared';
            break;
          case 2:
            label = 'opoli';
            break;
          case 3:
            label = 'black';
            break;
          case 4:
            label = 'suv';
            break;
          case 5:
            label = 'shuttle';
            break;
        }
        return '<span class="__service-label ' + label + '">' + __WEBPACK_IMPORTED_MODULE_3__modules_api_services__["a" /* default */].getServiceName(label) + '</span>';
      }
      if (field == 'optinShared') {
        return value == 1 ? 'Enabled' : 'Disabled';
      }
      return value;
    },
    fieldClass: function fieldClass(field) {
      if (['pickup.title', 'dropoff.title', 'notes'].includes(field)) {
        return 'no-arrow';
      }
      return '';
    },
    coordsLookup: function coordsLookup(data, i) {
      if (!data) return;
      var self = this;
      // if looked-up already -- just display previous return
      var searchedIndex = self.searchedCoords.findIndex(function (x) {
        return x.coords === data.lat + ',' + data.lng;
      });
      if (searchedIndex > -1) {
        document.querySelector('#log' + i + ' .action-display .fa-spinner').style.display = "none";
        document.querySelector('#log' + i + ' .action-display .coords span').innerHTML = self.searchedCoords[searchedIndex].addr;
        return;
      }
      // let url = 'https://discover.search.hereapi.com/v1/discover?at={AT}&q={SEARCH}&apiKey={API_KEY}'
      var url = 'https://revgeocode.search.hereapi.com/v1/revgeocode?at={AT}&apiKey={API_KEY}&show=tz';
      url = url.replace('{AT}', encodeURIComponent(data.lat + ',' + data.lng)).replace('{SEARCH}', 'location').replace('{API_KEY}', {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key);
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        var location = '';
        if (err || !body.items || body.items.length === 0) {
          // eslint-disable-line no-undef
          location = '<i>lat: </i><b>' + data.lat + ' </b> <i>lng: </i><b>' + data.lng + '</b><a href="https://www.google.com/maps/search/' + data.lat + ',' + data.lng + '" target="_blank"><i class="fa fa-map-marker m-L-5"></i></a>';
        }
        if (body.items.length) {
          // location = `<b>${body.items[0].address.city}, ${body.items[0].address.stateCode || body.items[0].address.state} ${body.items[0].address.postalCode}</b>`
          location = '\n            <b style="margin-right:4px;">' + body.items[0].address.label + '</b>\n            <a href="https://www.google.com/maps/search/' + data.lat + ',' + data.lng + '" target="_blank">\n              <i class="fas fa-link"></i>\n            </a>\n          ';
          self.searchedCoords.push({
            coords: data.lat + ',' + data.lng,
            addr: location
          });
        }
        document.querySelector('#log' + i + ' .action-display .fa-spinner').style.display = "none";
        document.querySelector('#log' + i + ' .action-display .coords span').innerHTML = location;
      });
    },
    lyftStatus: function lyftStatus(x) {
      if (!x) return '';
      if (x === 'pickedUp') return 'Picked Up';
      if (x === 'droppedOff') return 'Dropped Off';
      return x.charAt(0).toUpperCase() + x.slice(1);
    }
  },
  watch: {
    // rsvpId: function (value) {
    //   this.init()
    // },
    rsvpAction: function rsvpAction(value) {
      if (value.show) {
        this.init();
      }
    }
  },
  mounted: function mounted() {
    // this.init()
  }
});

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'asap-modal',
  data: function data() {
    return {
      loading: false,
      msg: '',
      bidId: '',
      statusDelay: ''
    };
  },

  computed: {
    rsvpEdit: function rsvpEdit() {
      return this.$store.state.rsvpDetails.edit;
    },
    asap: function asap() {
      return this.$store.state.rsvpDetails.asapRequest;
    },

    show: {
      get: function get() {
        return this.asap.show;
      },
      set: function set(x) {
        this.$store.commit('rsvpDetails/setAsapModal', x);
      }
    },
    asapData: function asapData() {
      return this.asap.data;
    }
  },
  methods: {
    startAsap: function startAsap() {
      var self = this;
      console.log('startAsap', 1);
      if (self.loading) return;
      console.log('startAsap', 2);
      self.loading = true;
      self.msg = 'Processing booking. . .';
      var param = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.asapData));
      param.consumerId = self.rsvpEdit.details.customerInfo.id;
      param.lyft = param.legs[0].lyft;
      param.source = 'C';

      console.log('param', param);
      self.$sdk.post('/bid/lyft/create', param, function (r) {
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          self.loading = false;
          self.show = false;
          return;
        }
        self.bidId = r.bid.bidId;
        self.msg = 'Searching for nearby drivers. . .';
        self.getLyftStatus(r);
      }, '2.0');
    },
    getLyftStatus: function getLyftStatus(data) {
      var self = this;
      if (self.statusDelay) clearTimeout(self.statusDelay);
      self.$sdk.post('/bid/lyft/status', {
        token: self.$store.state.session.sessionToken,
        bidId: data.bid.bidId
      }, function (r) {
        if (self.statusDelay) clearTimeout(self.statusDelay);

        if (r.status === 'canceled') {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'No Driver found. Please try again later.'
          });
          self.loading = false;
          self.show = false;
          return;
        }

        if ((r.rsvpId || r.status === 'accepted') && r.lyft.driver) {
          self.loading = false;
          self.show = false;
          self.$store.commit('rsvpDetails/setIsAdd', false);
          window.location = '/#/reservation/' + r.rsvpId;
          return;
        }
        self.statusDelay = setTimeout(function () {
          self.getLyftStatus(data);
        }, 5000);
      }, '2.0');
    }
  },
  watch: {
    show: function show(val) {
      var self = this;
      if (val) {
        // self.error.show = false
        // self.error.message = ''
        console.log('show');
        self.startAsap();
      }
    }
  }
});

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cancel-upcoming-modal',
  data: function data() {
    return {
      selected: [],
      success: [],
      fail: [],
      cancellationFee: 0,
      showResults: false
    };
  },

  computed: {
    rsvpId: function rsvpId() {
      return this.$route.params.id;
    },
    cancelUpcoming: function cancelUpcoming() {
      return this.$store.state.cancelUpcoming;
    },
    show: function show() {
      return this.cancelUpcoming.show;
    },
    msg: function msg() {
      return this.cancelUpcoming.msg;
    },
    rsvps: function rsvps() {
      return this.cancelUpcoming.rsvps;
    },
    data: function data() {
      return this.cancelUpcoming.data;
    },
    isRefund: function isRefund() {
      return this.data.refundAsCredits;
    }
  },
  methods: {
    close: function close() {
      this.$store.commit('cancelUpcoming/setCancelData', { show: false });
      this.selected = [];
      this.success = [];
      this.fail = [];
      this.$store.commit('cancelUpcoming/setCancelData', { rsvps: [] });
      window.location.reload();
    },
    initRsvpCxl: function initRsvpCxl() {
      if (!this.selected.length) return;
      this.$store.commit('global/setLoaderData', { show: true, message: '' });
      this.getFee(this.selected[0]);
      // this.cancel(this.selected[0])
    },
    getFee: function getFee(id) {
      var self = this;
      self.$sdk.get('/admin/rsvp/' + id + '/fee', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          return;
        }
        self.cancellationFee = parseFloat(r.amount);
        self.cancel(id);
      });
    },
    cancel: function cancel(id) {
      var self = this;
      var chargeFees = self.cancellationFee > 0 ? self.data.cancelFee : 0;

      self.$sdk.delete('/admin/rsvp/' + id, {
        token: self.$store.state.session.sessionToken,
        notes: self.data.notes,
        noteStatus: self.data.noteStatus,
        chargeFees: chargeFees,
        reason: self.data.reason,
        refundAsCredits: self.data.refundAsCredits
      }, function (r) {
        if (r.error) {
          // self.$store.commit('global/setAlertData', {
          //   show: true,
          //   message: r.error.message
          // })
          self.fail.push(id);
          self.selected.shift();
          if (self.selected.length) self.getFee(self.selected[0]);else {
            self.$store.commit('global/setLoaderData', { show: false });
            self.showResults = true;
          }
          return;
        }
        self.success.push(id);
        self.selected.shift();
        if (self.selected.length) self.getFee(self.selected[0]);else {
          self.$store.commit('global/setLoaderData', { show: false });
          self.showResults = true;
        }
      });
    }
  },
  watch: {
    rsvpId: function rsvpId(val) {
      this.close();
    }
  }
});

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RefundCreditModal__ = __webpack_require__(1836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Filters__ = __webpack_require__(1842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__List__ = __webpack_require__(1846);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'transactions',
  components: { RefundCreditModal: __WEBPACK_IMPORTED_MODULE_1__RefundCreditModal__["a" /* default */], TransactionsFilter: __WEBPACK_IMPORTED_MODULE_2__Filters__["a" /* default */], TransactionsList: __WEBPACK_IMPORTED_MODULE_3__List__["a" /* default */] },
  data: function data() {
    return {
      isMobile: false,
      isDesktop: false
    };
  },

  computed: {
    stats: function stats() {
      return this.$store.state.transactions.stats;
    },
    filter: function filter() {
      return this.$store.state.transactions.filter;
    },
    managerUrl: function managerUrl() {
      return 'http://manager.opoli.com/rsvp/' + __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.filter.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD') + '/' + __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.filter.dateTo, 'MM/DD/YYYY').add(1, 'days').format('YYYY-MM-DD');
    },
    isLoading: function isLoading() {
      return this.$store.state.transactions.loading;
    },
    isListEmpty: function isListEmpty() {
      return this.$store.state.transactions.list.length;
    }
  },
  methods: {
    toFixed: function toFixed(value) {
      return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    scrollToTop: function scrollToTop() {
      var elmnt = document.getElementById('top');
      elmnt.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    newRsvp: function newRsvp() {
      window.location.href = '#/reservation/new';
    },
    setScreenSize: function setScreenSize() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isDesktop = false;
        this.isMobile = true;
      } else {
        this.isDesktop = true;
        this.isMobile = false;
      }
    },
    exportTrx: function exportTrx() {
      this.$refs.filter.exportTrx();
    }
  },
  mounted: function mounted() {
    this.setScreenSize();
  },
  created: function created() {
    window.addEventListener("resize", this.setScreenSize);
  },
  destroyed: function destroyed() {
    window.removeEventListener("resize", this.setScreenSize);
  }
});

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tributejs__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tributejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tributejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_reservation_details_edit__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_featureToggle__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reservation-notes-modal',
  data: function data() {
    return {
      noteError: false,
      isSubmitting: false,
      cancelFee: '0',
      showComplete: false
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.refundCredit.show;
    },
    notes: function notes() {
      return this.$store.state.refundCredit.notes;
    }
  },
  methods: {
    populate: function populate() {
      var self = this;
      var value = self.$refs.noteTextArea.innerHTML;
      self.noteError = false;
      if (value.length > 500) {
        self.$refs.noteTextArea.innerHTML = self.$store.state.reservationNotes.notes;
        return;
      }
      self.$store.commit('refundCredit/setNotes', value);
    },
    close: function close() {
      if (this.isSubmitting) {
        return;
      }
      this.$store.commit('refundCredit/show', false);
    },
    submit: function submit() {}
  }
});

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_transactions__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_brands__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_csvexport__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */






var exporter = __WEBPACK_IMPORTED_MODULE_4_csvexport___default.a.create({
  filename: "export.csv",
  columns: ['Date', 'Booking Time', 'Pickup Time', 'Service Area', 'Prov ID', 'Prov License', 'Company', 'RSVP ID', 'Invoice ID', 'Service Type', 'First Name', 'Last Name', 'Credit Card', 'Email', 'Mobile', 'Source', 'Final Offer', 'Charge Amount', 'Refunded Amount', 'Promo Used', 'Driver Payment', 'Bonus', 'Cancel Fees', 'Status', 'Pickup Location', 'Dropoff Location']
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'transactions-filter',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a },
  props: ['isMobile'],
  data: function data() {
    return {
      searchInput: '',
      blurDelay: '',
      hasError: {
        searchMsg: '',
        from: false,
        to: false,
        fromToMsg: ''
      },
      refreshLoading: false
    };
  },

  computed: {
    status: {
      get: function get() {
        return this.$store.state.transactions.filter.status;
      },
      set: function set(value) {
        this.$store.commit('transactions/setStatus', value);
        if ((this.date.from === '' || this.date.to === '') && this.dateType !== 'all') {
          this.hasError.from = this.date.from === '';
          this.hasError.to = this.date.to === '';
          return;
        }
        this.getTrasactions(false);
      }
    },
    dateType: {
      get: function get() {
        return this.$store.state.transactions.filter.date;
      },
      set: function set(value) {
        this.$store.commit('transactions/setDate', value);

        var from = '';
        var to = value === 'all' ? '' : __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().format('MM/DD/YYYY');
        if (value === 'withinDay') {
          from = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().format('MM/DD/YYYY');
        }
        if (value === 'monthToDate') {
          from = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().format('MM') + '/1/' + __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().format('YYYY'), 'MM/DD/YYYY').format('MM/DD/YYYY');
        }
        if (value === 'lastMonth') {
          var lastMonth = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().subtract(1, 'months');
          from = lastMonth.format('MM/01/YYYY');
          to = lastMonth.endOf('month').format('MM/DD/YYYY');
        }
        if (value === 'lastWeek') {
          var subtractDays = 0;
          var currentDate = parseInt(__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().format('E'));
          if (currentDate !== 7) {
            subtractDays = currentDate;
          }

          from = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().subtract(subtractDays + 6, 'days').format('MM/DD/YYYY');
          to = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().subtract(subtractDays, 'days').format('MM/DD/YYYY');
        }
        if (value === 'last2Week') {
          var _subtractDays = 0;
          var _currentDate = parseInt(__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().format('E'));
          if (_currentDate !== 7) {
            _subtractDays = _currentDate;
          }
          from = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().subtract(_subtractDays + 13, 'days').format('MM/DD/YYYY');
          to = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().subtract(_subtractDays, 'days').format('MM/DD/YYYY');
        }
        if (value === 'last30Days') {
          from = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().subtract(30, 'days').format('MM/DD/YYYY');
        }
        if (value === 'last60Days') {
          from = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().subtract(60, 'days').format('MM/DD/YYYY');
        }
        if (value === 'last90Days') {
          from = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().subtract(90, 'days').format('MM/DD/YYYY');
        }

        if (value !== 'custom') {
          this.hasError = { searchMsg: '', from: false, to: false, fromToMsg: '' };
          this.$store.commit('transactions/setDateFrom', from);
          this.$store.commit('transactions/setDateTo', to);

          if (value === 'all' && this.searchInput === '') {
            this.hasError.searchMsg = this.$t('transactions.filter.searchEmpty');
            var self = this;
            self.$nextTick(function () {
              self.$refs.search.focus();
            });
            return;
          }

          this.getTrasactions(true);
        }
      }
    },
    date: function date() {
      var filter = this.$store.state.transactions.filter;
      return {
        from: filter.dateFrom,
        to: filter.dateTo
      };
    },
    isLoading: function isLoading() {
      return this.$store.state.transactions.loading;
    },
    isListEmpty: function isListEmpty() {
      return this.$store.state.transactions.list.length;
    },
    brands: function brands() {
      return this.$store.state.brands;
    },

    brand: {
      get: function get() {
        return this.$store.state.transactions.filter.brand;
      },
      set: function set(x) {
        this.$store.commit('transactions/setBrand', x);
        this.getTrasactions(true);
      }
    }
  },
  methods: {
    search: function search() {
      this.searchInput = this.searchInput.trim();
      this.$store.commit('transactions/setSearch', this.searchInput);

      if (this.searchInput === '' && this.dateType === 'all') {
        this.hasError.searchMsg = this.$t('transactions.filter.searchEmpty');
        return;
      }
      this.hasError.searchMsg = '';

      if ((this.date.from === '' || this.date.to === '') && this.dateType !== 'all') {
        this.hasError.from = this.date.from === '';
        this.hasError.to = this.date.to === '';
        return;
      }

      if (this.searchInput !== '') {
        this.$store.commit('transactions/setDate', 'all');
        this.$store.commit('transactions/setDateFrom', '');
        this.$store.commit('transactions/setDateTo', '');
      }
      this.getTrasactions(false);
    },
    blurSearch: function blurSearch() {
      var self = this;
      if (self.$store.state.transactions.filter.search === self.searchInput.trim()) {
        return;
      }

      self.blurDelay = setTimeout(function () {
        self.search();
      }, 500);
    },
    clearSearch: function clearSearch() {
      if (this.blurDelay) {
        clearTimeout(this.blurDelay);
      }

      if (this.isLoading) {
        return;
      }

      this.searchInput = '';
      this.$store.commit('transactions/setSearch', this.searchInput);
      this.dateType = 'withinDay';
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(date).format('MM/DD/YYYY');
    },
    changeDate: function changeDate(type) {
      this.$store.commit('transactions/setDate', 'custom');

      var format = 'MM/DD/YYYY';
      var from = '';
      var to = '';

      if (type === 'from') {
        this.hasError.from = false;
        from = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.date.from);
        this.$store.commit('transactions/setDateFrom', from.format(format));
        if (this.date.to) {
          to = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.date.to, format);
        }
      } else {
        this.hasError.to = false;
        to = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.date.to);
        this.$store.commit('transactions/setDateTo', to.format(format));
        if (this.date.from) {
          from = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.date.from, format);
        }
      }

      this.hasError = { searchMsg: '', from: false, to: false, fromToMsg: '' };

      if (this.date.from === '' || this.date.to === '') {
        if (type === 'from') {
          this.hasError.to = true;
        } else {
          this.hasError.from = true;
        }
        this.hasError.fromToMsg = this.$t('transactions.filter.emptyDate');
        return;
      }
      if (from.format('x') > to.format('x')) {
        this.hasError.from = true;
        this.hasError.to = true;
        this.hasError.fromToMsg = this.$t('transactions.filter.invalidDateRange');
        return;
      }
      this.getTrasactions(true);
    },
    getTrasactions: function getTrasactions(refreshStats) {
      var self = this;

      if (!!self.hasError.fromToMsg || !!self.hasError.searchMsg || self.isLoading) {
        return;
      }

      self.$store.commit('transactions/setCurrentPage', 0);
      self.$store.commit('transactions/setLoading', true);
      if (!self.searchInput && refreshStats) {
        self.$store.commit('transactions/setStatsLoading', true);
      }

      __WEBPACK_IMPORTED_MODULE_2__modules_api_transactions__["a" /* default */].getTrasactions(self, { isNext: true }, function (res) {
        self.$store.commit('transactions/setLoading', false);
        if (self.refreshLoading) {
          self.refreshLoading = false;
        }
        if (!res.error) {
          if (!self.searchInput && refreshStats) {
            self.$store.commit('transactions/setStatsLoading', false);
            self.$store.commit('transactions/setStats', {
              gross: res.stats.revenue,
              credits: res.stats.credits
            });
          }
        }
      });
    },
    refresh: function refresh() {
      this.refreshLoading = true;
      this.getTrasactions(true);
    },
    exportTrx: function exportTrx() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__modules_api_transactions__["a" /* default */].exportTransactions(self, {}, function (res) {
        if (!res.error) {
          console.log(res);
          exporter.downloadCsv(res);
        }
      });
    },
    isNumber: function isNumber(evt) {
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
        return;
      }
      return true;
    },
    getBrands: function getBrands() {
      var self = this;
      if (self.brands.list.length) return;
      self.$store.commit('brands/setLoading', true);
      __WEBPACK_IMPORTED_MODULE_3__modules_api_brands__["a" /* default */].getBrands(self, function (res) {
        self.$store.commit('brands/setLoading', false);
      });
    },
    brandLabel: function brandLabel(dat) {
      var i = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.findIndex(function (x) {
        return x.id === dat.id;
      });
      if (i == -1) return '(' + {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[0].trxCode.toUpperCase() + ') ' + dat.name;
      return '(' + {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[i].trxCode.toUpperCase() + ') ' + dat.name;
    }
  },
  mounted: function mounted() {
    var self = this;

    self.$store.commit('transactions/resetFilters');
    self.getBrands();

    var today = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()();
    self.$store.commit('transactions/setDateFrom', today.format('MM/DD/YYYY'));
    self.$store.commit('transactions/setDateTo', today.format('MM/DD/YYYY'));
  }
});

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(6);
/* global CONFIG */



/* harmony default export */ __webpack_exports__["a"] = ({
  getTrasactions: function getTrasactions(VueApp, data, callback) {
    var self = this;

    var trx = VueApp.$store.state.transactions;
    var pageSize = trx.perPage;
    var page = trx.currentPage;
    if (data.isNext) {
      page++;
    } else {
      page--;
    }

    var filter = trx.filter;
    var since = __WEBPACK_IMPORTED_MODULE_0_moment___default()(filter.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00');
    var until = __WEBPACK_IMPORTED_MODULE_0_moment___default()(filter.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59');
    if (filter.date === 'all') {
      since = '2010-01-01 00:00';
      until = __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(10, 'years').format('YYYY-MM-DD 23:59');
    }

    var param = {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: pageSize,
      pageNum: page,
      order: trx.sort.column,
      orderAsc: trx.sort.isDesc ? 0 : 1,
      since: since,
      until: until,
      search: filter.search,
      status: filter.status
    };
    if (filter.brand) param.brandId = filter.brand;

    VueApp.$sdk.get('/transaction', param, function (res) {
      if (!res.error) {
        VueApp.$store.commit('transactions/setTotal', res.paging.totalItems);
        VueApp.$store.commit('transactions/setCurrentPage', page);

        var _trx = [];
        if (res.list.length) {
          res.list.forEach(function (value) {
            if (value.packageId) {
              _trx.push(self.buildPackage(value));
            } else {
              _trx.push(self.buildRsvp(value));
            }
          });
        }
        VueApp.$store.commit('transactions/setTransactions', _trx);
      }
      callback(res);
    });
  },
  refreshTransaction: function refreshTransaction(VueApp, data, callback) {
    var self = this;

    var trx = VueApp.$store.state.transactions;
    var pageSize = trx.perPage;
    var page = trx.currentPage;

    var filter = trx.filter;
    var since = __WEBPACK_IMPORTED_MODULE_0_moment___default()(filter.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00');
    var until = __WEBPACK_IMPORTED_MODULE_0_moment___default()(filter.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59');
    if (filter.date === 'all') {
      since = '2010-01-01 00:00';
      until = __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(10, 'years').format('YYYY-MM-DD 23:59');
    }

    VueApp.$sdk.get('/transaction', {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: pageSize,
      pageNum: page,
      order: trx.sort.column,
      orderAsc: trx.sort.isDesc ? 0 : 1,
      since: since,
      until: until,
      search: filter.search,
      status: filter.status
    }, function (res) {
      if (!res.error) {
        VueApp.$store.commit('transactions/setTotal', res.paging.totalItems);
        VueApp.$store.commit('transactions/setCurrentPage', page);

        var _trx2 = [];
        if (res.list.length) {
          res.list.forEach(function (value) {
            if (value.packageId) {
              _trx2.push(self.buildPackage(value));
            } else {
              _trx2.push(self.buildRsvp(value));
            }
          });
        }
        VueApp.$store.commit('transactions/setTransactions', _trx2);
      }
      callback(res);
    });
  },
  exportTransactions: function exportTransactions(VueApp, data, callback) {
    var self = this;

    var trx = VueApp.$store.state.transactions;
    var pageSize = trx.perPage;
    var page = trx.currentPage;

    var filter = trx.filter;
    var since = __WEBPACK_IMPORTED_MODULE_0_moment___default()(filter.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00');
    var until = __WEBPACK_IMPORTED_MODULE_0_moment___default()(filter.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59');
    if (filter.date === 'all') {
      since = '2010-01-01 00:00';
      until = __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(10, 'years').format('YYYY-MM-DD 23:59');
    }

    VueApp.$sdk.get('/transaction', {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: pageSize,
      pageNum: page,
      order: trx.sort.column,
      orderAsc: trx.sort.isDesc ? 0 : 1,
      since: since,
      until: until,
      search: filter.search,
      status: filter.status,
      export: true
    }, function (res) {
      if (!res.error) {
        var _trx3 = [];
        if (res.list.length) {
          res.list.forEach(function (value) {
            _trx3.push(self.buildExport(value));
          });
        }
        callback(_trx3);
      } else {
        callback(res);
      }
    });
  },
  buildRsvp: function buildRsvp(data) {
    var payment = data.payment;
    var creditCard = payment.cancelFee ? 'N/A' : data.cardNumber;
    if (data.isTerminal) {
      creditCard = 'Terminal';
    }
    var source = this.buildSource(data.deviceType);

    var trxData = {
      date: __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm:ss'),
      serviceArea: data.geofence.name,
      company: data.provider.businessName || '',
      providerId: data.provider.id,
      eventId: data.eventId || '',
      brandId: data.brandId,
      rsvpId: data.rsvpId || '000',
      id: data.id,
      pickupDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.pickupTime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm'),
      pickup: data.pickupLocation,
      dropoff: data.dropoffLocation,
      passenger: data.passengers,
      luggage: data.luggage,
      type: data.isAsap ? 'asap' : 'rsvp',
      serviceCode: data.serviceCode,
      serviceLabel: __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].getServiceName(data.serviceCode),
      consumerId: data.consumer.id,
      firstName: data.consumer.firstName,
      lastName: data.consumer.lastName,
      email: data.consumer.email,
      mobile: data.consumer.phone,
      creditCard: creditCard,
      source: source,
      finalOffer: payment.offer || 0,
      chargedAmount: payment.charged || 0,
      bonus: payment.bonus || 0,
      promo: payment.credit || 0,
      cancelFee: payment.cancelFee || 0,
      bidAmount: payment.bidAmount,
      status: data.status,
      hasSubTransactionId: data.hasSubTransactionId,
      isReservationRefunded: data.isReservationRefunded,
      completed: data.completed,
      refundedAmount: data.refundedAmount,
      reservationState: data.reservationState,
      paymentURL: data.paymentURL,
      notes: data.notes,
      hasExtraStop: data.hasExtraStop,
      isCharter: data.isCharter
    };

    if (!{"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation) {
      trxData.serviceType = {
        label: data.serviceType ? data.serviceType.label : '',
        color: data.serviceType ? data.serviceType.color : ''
      };
    }

    return trxData;
  },
  buildPackage: function buildPackage(data) {
    var payment = data.payment;
    var source = this.buildSource(data.deviceType);

    var trxData = {
      date: __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm:ss'),
      serviceArea: data.geofence.name,
      company: data.provider.businessName || '',
      providerId: data.provider.id,
      eventId: data.eventId || '',
      pkgId: data.packageId,
      id: data.id,
      pickupDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.pickupTime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm'),
      pickup: data.pickupLocation,
      dropoff: data.dropoffLocation,
      passenger: data.passengers,
      luggage: data.luggage,
      type: data.isAsap ? 'asap' : 'rsvp',
      serviceCode: data.serviceCode,
      serviceLabel: __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].getServiceName(data.serviceCode),
      consumerId: data.consumer.id,
      firstName: data.consumer.firstName,
      lastName: data.consumer.lastName,
      email: data.consumer.email,
      mobile: data.consumer.phone,
      creditCard: data.cardNumber,
      source: source,
      finalOffer: payment.offer || 0,
      chargedAmount: payment.charged || 0,
      bonus: payment.bonus || 0,
      promo: payment.credit || 0,
      cancelFee: payment.cancelFee || 0,
      bidAmount: payment.bidAmount,
      status: data.status,
      hasSubTransactionId: data.hasSubTransactionId,
      isReservationRefunded: data.isReservationRefunded,
      completed: data.completed,
      refundedAmount: data.refundedAmount,
      reservationState: data.reservationState,
      paymentURL: data.paymentURL,
      notes: data.notes,
      transactionType: data.transactionType
    };

    if (!{"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation) {
      if (data.serviceType) {
        trxData.serviceType = {
          label: data.serviceType.label,
          color: data.serviceType.color
        };
      } else {
        trxData.serviceType = {
          label: __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].getServiceName('shared'),
          color: '#555'
        };
      }
    }

    return trxData;
  },
  buildSource: function buildSource(value) {
    switch (value) {
      case 'ww':
        return 'Web';
      case 'admin':
        return 'Admin';
      case 'android':
        return 'Android App';
      case 'ios':
        return 'iOS App';
      case 'provider':
        return 'Provider';
      default:
        return value;
    }

    return '';
  },
  buildExport: function buildExport(data) {
    var rsvpId = this.convertBrand(data.brandId) + data.rsvpId;
    var serviceType = __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].getServiceName(data.serviceCode);
    var payment = data.payment;
    var creditCard = payment.cancelFee ? 'N/A' : data.cardNumber;
    var source = this.buildSource(data.deviceType);
    var provLicense = data.provider.accountType || '';

    if (data.packageId) {
      rsvpId = data.packageId;
      serviceType = __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].getServiceName('shared');
      source = 'PKG';
    }

    var trxData = {
      Date: __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY'),
      'Booking Time': __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('HH:mm:ss'),
      'Pickup Time': __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.pickupTime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm'),
      'Service Area': data.geofence.name,
      'Prov ID': data.provider.id,
      'Prov License': provLicense.toUpperCase(),
      'Company': data.provider.businessName,
      'RSVP ID': rsvpId,
      'Invoice ID': data.eventId,
      'Service Type': serviceType,
      'First Name': data.consumer.firstName,
      'Last Name': data.consumer.lastName,
      'Credit Card': creditCard,
      'Email': data.consumer.email,
      'Mobile': data.consumer.phone,
      'Source': source,
      'Final Offer': payment.offer || 0,
      'Charge Amount': payment.charged || 0,
      'Refunded Amount': -Math.abs(data.refundedAmount) || 0,
      'Promo Used': payment.credit || 0,
      'Driver Payment': payment.driverPay || 0,
      'Bonus': payment.bonus || 0,
      'Cancel Fees': payment.cancelFee || 0,
      'Status': data.status,
      'Pickup Location': data.pickupLocation,
      'Dropoff Location': data.dropoffLocation
    };

    if (!{"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation) {
      if (data.packageId) {
        trxData['Service Type'] = __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].getServiceName('shared');
      } else {
        trxData['Service Type'] = data.serviceType.label;
      }
    }

    return trxData;
  },
  convertBrand: function convertBrand(id) {
    var index = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.findIndex(function (x) {
      return x.id === id;
    });
    if (!id || index === -1) {
      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[0].code.toUpperCase();
    }

    return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[index].code.toUpperCase();
  }
});

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_transactions__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_transactions_refund__ = __webpack_require__(1849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_services__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'transactions-list',
  props: ['isMobile'],
  data: function data() {
    return {
      tableHeader: [{ code: 'created', label: this.$t('transactions.list.date') }, { code: '', label: this.$t('transactions.list.serviceArea') }, { code: '', label: this.$t('transactions.list.company') }, { code: 'rsvpId', label: this.$t('transactions.list.rsvpId') }, { code: 'eventId', label: this.$t('transactions.list.invoiceId') }, { code: 'isAsap', label: this.$t('transactions.list.type') }, { code: 'serviceTypeId', label: this.$t('transactions.list.service') }, { code: '', label: this.$t('transactions.list.customerName') }, { code: '', label: this.$t('transactions.list.email') }, { code: '', label: this.$t('transactions.list.mobile') }, { code: '', label: this.$t('transactions.list.creditCard') }, { code: '', label: this.$t('transactions.list.source') }, { code: '', label: this.$t('transactions.list.finalOffer') }, { code: '', label: this.$t('transactions.list.chargedAmount') }, { code: '', label: this.$t('transactions.list.bonus') }, { code: '', label: this.$t('transactions.list.promoUsed') }, { code: '', label: this.$t('transactions.list.cancelFee') }, { code: '', label: this.$t('transactions.list.status') }],
      sort: {
        active: 'created',
        isDesc: true
      },
      hoverRsvpInfo: '',
      refundTarget: '',
      refundLoading: false,
      trxErrorModal: false,
      cxlConvert: {
        show: false,
        loading: false,
        data: '',
        error: false,
        message: ''
      },
      processRefund: {
        show: false,
        loading: false,
        data: '',
        error: false,
        message: ''
      },
      seeMore: {
        show: false,
        id: null
      },
      extraStops: []
    };
  },

  computed: {
    sharedService: function sharedService() {
      return __WEBPACK_IMPORTED_MODULE_3__modules_api_services__["a" /* default */].getServiceName('shared');
    },
    transactions: function transactions() {
      return this.$store.state.transactions.list;
    },

    perPage: {
      get: function get() {
        return this.$store.state.transactions.perPage;
      },
      set: function set(value) {
        this.$store.commit('transactions/setCurrentPage', 0);
        this.$store.commit('transactions/setPerPage', value);
        this.getTrasactions('next', false);
      }
    },
    page: {
      get: function get() {
        return this.$store.state.transactions.currentPage;
      },
      set: function set(value) {
        this.$store.commit('transactions/setCurrentPage', value - 1);
        this.getTrasactions('next', false);
      }
    },
    totalPage: function totalPage() {
      return Math.ceil(this.$store.state.transactions.total / this.perPage);
    },
    pagingDisable: function pagingDisable() {
      return {
        prev: this.isLoading || this.page === 1 || this.totalPage === 0,
        select: this.isLoading || this.totalPage === 0,
        next: this.isLoading || this.page >= this.totalPage || this.totalPage === 0
      };
    },
    displayingData: function displayingData() {
      var trx = this.$store.state.transactions;
      var max = trx.currentPage * trx.perPage;
      if (max > trx.total) {
        max = trx.total;
      }
      return {
        min: trx.currentPage * trx.perPage - (trx.perPage - 1),
        max: max,
        total: trx.total
      };
    },
    isLoading: function isLoading() {
      return this.$store.state.transactions.loading;
    },
    isFilterValid: function isFilterValid() {
      var filter = this.$store.state.transactions.filter;
      var format = 'MM/DD/YYYY';
      return !!filter.search && filter.date === 'all' || !!filter.dateFrom && !!filter.dateTo && __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(filter.dateFrom, format).format('x') <= __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(filter.dateTo, format).format('x');
    },
    searchInput: function searchInput() {
      return this.$store.state.transactions.filter.search;
    },
    _refreshList: function _refreshList() {
      return this.$store.state.transactions.refreshList;
    },
    refundAccess: function refundAccess() {
      return this.$store.state.session.user.access.hasOwnProperty('PageAdminRefund');
    },
    useOldQuatation: function useOldQuatation() {
      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation;
    }
  },
  methods: {
    sortTable: function sortTable(code) {
      if (!code) {
        return;
      }

      if (this.sort.active === code) {
        this.sort.isDesc = !this.sort.isDesc;
      } else {
        this.sort.isDesc = true;
      }

      this.sort.active = code;
      this.$store.commit('transactions/setSortColumn', code);
      this.$store.commit('transactions/setSortIsDesc', this.sort.isDesc);
      this.$store.commit('transactions/setCurrentPage', 0);
      this.getTrasactions('next', false);
    },
    getTrasactions: function getTrasactions(prevNext, updateStats) {
      var self = this;

      if (this.isLoading) {
        return;
      }

      if (!self.isFilterValid) {
        this.$emit('scrollToTop');
        return;
      }

      self.$store.commit('transactions/setLoading', true);
      if (updateStats && !self.searchInput) {
        self.$store.commit('transactions/setStatsLoading', true);
      }
      __WEBPACK_IMPORTED_MODULE_1__modules_api_transactions__["a" /* default */].getTrasactions(self, { isNext: prevNext === 'next' }, function (res) {
        self.$store.commit('transactions/setLoading', false);
        if (!res.error) {
          if (updateStats && !self.searchInput) {
            self.$store.commit('transactions/setStatsLoading', false);
            self.$store.commit('transactions/setStats', {
              gross: res.stats.revenue,
              credits: res.stats.credits
            });
          }
        }
      });
    },
    resetTransactions: function resetTransactions() {
      this.$store.commit('transactions/setTransactions', []);
      this.$store.commit('transactions/setSortColumn', 'created');
      this.$store.commit('transactions/setSortIsDesc', true);
      this.$store.commit('transactions/setCurrentPage', 0);
      this.$store.commit('transactions/setPerPage', 20);
      this.$store.commit('transactions/setTotal', 0);
    },
    refreshTransaction: function refreshTransaction() {
      var self = this;

      if (this.isLoading) {
        return;
      }

      self.$store.commit('transactions/setLoading', true);
      self.$store.commit('transactions/setStatsLoading', true);

      __WEBPACK_IMPORTED_MODULE_1__modules_api_transactions__["a" /* default */].refreshTransaction(self, {}, function (res) {
        self.$store.commit('transactions/setLoading', false);
        self.$store.commit('transactions/setRefreshList', false);

        if (!res.error) {
          self.$store.commit('transactions/setStatsLoading', false);
          self.$store.commit('transactions/setStats', {
            gross: res.stats.revenue,
            credits: res.stats.credits
          });
        }
      });
    },
    convertBrand: function convertBrand(id) {
      var index = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.findIndex(function (x) {
        return x.id === id;
      });
      if (!id || index === -1) {
        return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[0].trxCode.toUpperCase();
      }

      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[index].trxCode.toUpperCase();
    },
    rsvpMouseover: function rsvpMouseover(id) {
      this.hoverRsvpInfo = id;
    },
    call: function call(user) {
      var self = this;
      self.$plugins.phone.startCall(self, {
        phone: user.mobile,
        name: user.firstName + ' ' + user.lastName
      });
    },
    toFixed: function toFixed(value) {
      if (value && value < 0) {
        return '-$' + Math.abs(parseFloat(value)).toFixed(2);
      }
      return '$' + parseFloat(value).toFixed(2);
    },
    hideRefundIcon: function hideRefundIcon(data) {
      var allowedStatus = ['Declined', 'Cancelled Prov', 'Cancelled Cons', 'Cancelled Admin', 'Cancelled Charge', 'Cancelled', 'Unrefunded Cancel', 'Edited Refund', 'Edited', 'Partial Refund', 'Full Refund', 'Failed', 'Pending Refund', 'Credit Conversion'];

      var isFullRefunded = '';
      if (data.refundedAmount) {
        if (data.status === 'Promo') {
          isFullRefunded = data.refundedAmount == data.credit;
        } else {
          isFullRefunded = data.refundedAmount == data.bidAmount;
        }
      }

      var rsvpStateDisallow = data.reservationState !== 'NOSHOW' && data.reservationState !== 'CANCELED';

      if (data.status && data.status !== 'Completed' && data.completed) return true;

      return data.pkgId || allowedStatus.indexOf(data.status) > -1 || data.status !== 'Completed' && data.hasSubTransactionId || data.status === 'Authorized' && (data.completed || isFullRefunded) || (data.isReservationRefunded && rsvpStateDisallow || isFullRefunded) && data.status === 'Promo';
    },
    checkCancellationFee: function checkCancellationFee(trx) {
      var self = this;
      if (self.refundLoading) {
        return;
      }

      if (!trx.creditCard || trx.creditCard === 'N/A') {
        self.trxErrorModal = true;
        return;
      }

      if (trx.status === 'Completed' && trx.note !== 'TIP_TRANSACTION') {
        var disable = [];
        if (parseFloat(trx.refundedAmount) > 0) {
          disable.push('full');
        }
        if (parseFloat(trx.refundedAmount) >= parseFloat(trx.chargedAmount)) {
          disable.push('partial');
          disable.push('credit');
        }
        self.$store.commit('reservationNotes/show', {
          rsvpId: trx.rsvpId,
          action: 'partialRefund',
          actionData: {
            title: self.$t('rsvpNotes.title.refund'),
            id: trx.id,
            disable: disable,
            status: trx.status
          }
        });
        return;
      }

      var title = trx.status === 'No Show' ? self.$t('rsvpNotes.title.noShowRefund') : self.$t('rsvpNotes.title.confirmRefund');
      var noCancellationFee = ['Additional Purchase', 'Refund'];
      if (noCancellationFee.indexOf(trx.status) > -1) {
        self.$store.commit('reservationNotes/show', {
          rsvpId: trx.rsvpId,
          action: 'fullRefund',
          actionData: {
            title: title,
            id: trx.id,
            amount: 0,
            status: trx.status
          }
        });
        return;
      }

      console.log(trx);
      self.refundLoading = true;
      self.refundTarget = trx.id;
      __WEBPACK_IMPORTED_MODULE_2__modules_api_transactions_refund__["a" /* default */].getRefundFee(self, trx.id, function (res) {
        self.refundLoading = false;
        self.refundTarget = '';
        self.$store.commit('reservationNotes/show', {
          rsvpId: trx.rsvpId,
          action: 'fullRefund',
          actionData: {
            title: title,
            id: trx.id,
            amount: parseFloat(res.amount).toFixed(2)
          }
        });
      });
    },
    refundCreditModal: function refundCreditModal(trx) {
      var showModal = trx.notes === 'NOT_PROCESSED' && trx.status === 'Pending Refund';
      return showModal;
    },
    refundCredit: function refundCredit() {
      var self = this;
      self.$store.commit('refundCredit/show', true);
    },
    showProcessRefundModal: function showProcessRefundModal(trx) {
      this.processRefund.show = true;
      this.processRefund.data = trx;
    },
    processRefundExec: function processRefundExec() {
      var self = this;
      var trx = self.processRefund.data;
      if (self.refundLoading || self.processRefund.loading) {
        return;
      }
      self.processRefund.loading = true;
      self.refundLoading = true;
      self.refundTarget = trx.id;
      self.$sdk.post('/transaction/' + trx.id + '/markprocessed', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.processRefund.show = false;
        self.processRefund.loading = false;
        self.refundLoading = false;
        self.refundTarget = '';
        self.refreshTransaction();
      });
    },
    showConvertCreditModal: function showConvertCreditModal(trx) {
      this.cxlConvert.show = true;
      this.cxlConvert.data = trx;
    },
    convertCredit: function convertCredit() {
      var self = this;
      var trx = self.cxlConvert.data;
      if (self.refundLoading || self.cxlConvert.loading) {
        return;
      }

      self.cxlConvert.loading = true;
      self.refundLoading = true;
      self.refundTarget = trx.id;
      self.$sdk.post('/transaction/' + trx.id + '/deconvert', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.cxlConvert.show = false;
        self.cxlConvert.loading = false;
        self.refundLoading = false;
        self.refundTarget = '';

        if (r.error) {
          self.cxlConvert.error = true;
          self.cxlConvert.message = r.error.message;
          if (r.error.message === 'Not enough credits') {
            self.cxlConvert.message = 'Not enough credits are left in the consumer account. Some could have been used in other reservations.';
          }
          return;
        }
        self.refreshTransaction();
      });
    },
    relabel: function relabel(trx) {
      if (trx.status !== 'Credit Conversion') {
        return trx.status;
      }
      return 'Open Credit';
    },
    checkReclaimed: function checkReclaimed(trx) {
      if (trx.transactionType !== 'CONVERT_CREDIT ') {
        return '';
      }

      if (trx.transactionType === 'CONVERT_CREDIT ' && trx.notes === 'RECLAIMED') {
        return 'RECLAIMED';
      }
    },
    showToolTip: function showToolTip(index, data) {
      this.hoverRsvpInfo = index;
      if (data.hasExtraStop) {
        this.getExtraStops(data.rsvpId);
      }
    },
    getExtraStops: function getExtraStops(id) {
      var self = this;

      if (self.extraStops[id]) {
        return;
      }

      self.extraStops[id] = 'loading';
      self.$sdk.get('/admin/rsvp/' + id + '/extrastops', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error || !r.list.length) {
          self.extraStops[id] = 'none';
        } else {
          r.list.forEach(function (stop, index) {
            if (!index) {
              self.extraStops[id] = '';
            } else {
              self.extraStops[id] += '<br/>';
            }
            self.extraStops[id] += stop.address2 + ' ' + stop.address1 + ', ' + stop.city + ', ' + stop.state + ' ' + stop.zipCode;
          });
        }
        self.$forceUpdate();
      });
    }
  },
  watch: {
    _refreshList: function _refreshList(value) {
      if (value) {
        this.refreshTransaction();
      }
    }
  },
  mounted: function mounted() {
    var self = this;

    self.resetTransactions();
    self.getTrasactions('next', true);
  }
});

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__values_map_settings__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__values_map_pin__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_package__ = __webpack_require__(1855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_api_driver_release__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_timers__ = __webpack_require__(1856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_NotificationModal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_SMSModal__ = __webpack_require__(74);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */
var request = __webpack_require__(13);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'package-details',
  components: { notificationModal: __WEBPACK_IMPORTED_MODULE_6__App_NotificationModal__["a" /* default */], smsModal: __WEBPACK_IMPORTED_MODULE_7__App_SMSModal__["a" /* default */] },
  data: function data() {
    return {
      hereMaps: {
        map: {},
        platform: {},
        router: {},
        geocoder: {},
        directions: [],
        ui: {}
      },
      mapOptions: __WEBPACK_IMPORTED_MODULE_1__values_map_settings__["a" /* default */],
      pickupPin: __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */].pickup,
      dropoffPin: __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */].dropoff,
      center: { lat: 33.942791, lng: -118.410042 }, // LAX
      isLoading: false,
      packageRoute: [],
      showPaymentBreakdown: false,
      release: {
        show: false,
        loading: false,
        processing: false,
        showContent: false,
        fee: 0,
        charge: 1,
        success: false,
        error: {
          show: false,
          message: ''
        }
      },
      refreshLoading: false,
      refreshPkg: {
        show: false,
        message: '',
        error: false,
        loading: false,
        success: false
      },
      driverLocation: {
        lat: '',
        lng: ''
      },
      driverDestination: {
        lat: '',
        lng: ''
      },
      trackDriverDelay: '',
      showOptions: false,
      showOptionsDelay: '',
      showMapMobile: false
    };
  },

  computed: {
    packageID: function packageID() {
      return this.$route.params.id;
    },
    package: function _package() {
      return this.$store.state.packageDetails.package;
    }
  },
  methods: {
    loadPackage: function loadPackage(showLoading) {
      var self = this;
      if (showLoading) {
        self.isLoading = true;
      }

      __WEBPACK_IMPORTED_MODULE_3__modules_api_package__["a" /* default */].getPackage(self, self.packageID, function (r) {
        self.isLoading = false;
        self.refreshLoading = false;
        if (r.error) {
          self.$router.push({ name: 'MissingPage' });
          return;
        }

        self.$store.commit('packageDetails/setPackage', r);
        if (!showLoading) {
          self.refreshPkg.success = true;
          Object(__WEBPACK_IMPORTED_MODULE_5_timers__["setTimeout"])(function () {
            self.refreshPkg.success = false;
          }, 3000);
        }
      });
    },
    routePackage: function routePackage() {
      var self = this;

      var waypoints = self.package.route.slice(0, self.package.route.length);
      var routes = [];
      waypoints.forEach(function (location) {
        // Pickup/Dropoff icon
        var marker = '<svg height="25" width="25" style="overflow: initial" viewBox="0 0 50 50">' + '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' + 'stroke-width="{STROKE_WIDTH}" /></svg>';

        var pickupDropoff = location.isPickup ? 'pickup' : 'dropoff';

        marker = marker.replace('{D}', __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */][pickupDropoff].path).replace('{STROKE}', __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */][pickupDropoff].strokeColor).replace('{STROKE_WIDTH}', __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */][pickupDropoff].strokeWeight);
        // .replace('{FILL}', mapPins[pickupDropoff].fillColor)
        if (!location.isPickup && location.status === 'complete') {
          marker = marker.replace('{FILL}', __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */].pickup.fillColor);
        } else {
          marker = marker.replace('{FILL}', __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */][pickupDropoff].fillColor);
        }
        var icon = new window.H.map.DomIcon(marker);
        var coords = { lat: location.lat, lng: location.lng };
        var pin = new window.H.map.DomMarker(coords, { icon: icon });

        // if (!location.isPickup) {
        var content = '<div class="here-info-window-content package-detail">\n            <label>RSVP ID:</label>\n            <a class="value" href="/#/reservation/{RSVPID}" target="_blank">{RSVPID}</a>\n            <label>GUEST NAME:</label>\n            <span class="value">{GUEST}</span>\n            <label>LOCATION:</label>\n            <span class="value">{LOCATION}</span>\n          </div>';
        content = content.replace(/{RSVPID}/gi, location.rsvpID).replace('{GUEST}', location.guestName).replace('{LOCATION}', location.address2 + ' ' + location.address1 + ', ' + location.city);
        pin.id = 'marker';
        pin.lat = location.lat;
        pin.lng = location.lng;
        var bubble = new window.H.ui.InfoBubble(coords, { content: content });
        bubble.addClass('package-detail-iw');
        bubble.close();
        self.hereMaps.ui.addBubble(bubble);
        pin.addEventListener('tap', function (evt) {
          bubble.open();
        }, false);
        // }

        self.hereMaps.map.addObject(pin);

        routes.push(coords);
      });
      self.setRoute(routes, false);
      self.trackDriver();
    },
    setRoute: function setRoute(routes, isDriverTrack) {
      var self = this;

      var url = 'https://router.hereapi.com/v8/routes?apiKey={API_KEY}&transportMode=car&return=polyline,summary';
      url = url.replace('{API_KEY}', {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key);
      routes.forEach(function (coords, index) {
        if (index == 0) {
          url += '&origin=' + coords.lat + ',' + coords.lng;
        } else if (index == routes.length - 1) {
          url += '&destination=' + coords.lat + ',' + coords.lng;
        } else {
          url += '&via=' + coords.lat + ',' + coords.lng;
        }
      });

      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) {
          self.onCalculateError(err);
          return;
        }
        self.onCalculateSuccess(isDriverTrack, body);
      });
    },
    onCalculateSuccess: function onCalculateSuccess(isDriverTrack, result) {
      if (!result.routes.length) return;
      var route = result.routes[0].sections;
      if (isDriverTrack) {
        this.setTrackDriverPin(route);
        return;
      }
      this.addRouteShapeToMap(route, isDriverTrack);
    },
    onCalculateError: function onCalculateError(data) {
      console.error('ROUTING ERROR', data);
    },
    addRouteShapeToMap: function addRouteShapeToMap(routes, isDriverTrack) {
      var self = this;
      routes.forEach(function (route, index) {
        var linestring = window.H.geo.LineString.fromFlexiblePolyline(route.polyline);
        var polyline = new window.H.map.Polyline(linestring, {
          style: {
            lineWidth: 5,
            strokeColor: isDriverTrack ? 'rgba(13, 121, 242, 0.6)' : 'rgba(25, 25, 25, 0.7)'
          }
        });
        polyline.id = 'rsvpRoute' + index;
        self.hereMaps.map.addObject(polyline);
      });
      self.setCenter();
    },
    setCenter: function setCenter() {
      var self = this;
      var group = new window.H.map.Group();

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var object = _step.value;

          if (object.id === 'groupBound') {
            self.hereMaps.map.removeObject(object);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var groupObject = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _object = _step2.value;

          if (_object.id.indexOf('marker') > -1) {
            groupObject.push(new window.H.map.Circle(new window.H.geo.Point(_object.lat, _object.lng), 5000, { style: { fillColor: 'rgba(0, 0, 0, 0)', strokeColor: 'rgba(0, 0, 0, 0)' } }));
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (groupObject.length) {
        group.addObjects(groupObject);
        group.id = 'groupBound';
        self.hereMaps.map.addObject(group);

        self.hereMaps.map.getViewModel().setLookAtData({
          bounds: group.getBoundingBox()
        });
      }
    },
    getAddress: function getAddress(location) {
      if (location.geofenceType === 'airport' && location.geofenceName !== '') {
        var result = location.geofenceName;
        if (location.terminal && location.terminal !== '' && location.terminal !== 'undefined') {
          result += ' - Terminal ' + location.terminal;
        }
        return result;
      }
      return location.title;

      // let address = ''
      // if (location.address2 && location.address2 !== '' && location.address2 !== 'undefined') {
      //   address = address + location.address2 + ' '
      // }
      // if (location.address1) {
      //   address = address + location.address1 + ', '
      // }
      // if (location.city) {
      //   address = address + location.city + ' '
      // }
      // if (location.state) {
      //   address = address + location.state + ' '
      // }
      // if (location.zip) {
      //   address = address + location.zip
      // }

      // return address
    },
    getDriverPayment: function getDriverPayment(breakdown) {
      return breakdown.base + breakdown.bonus + breakdown.tip + breakdown.pickupFee + breakdown.gasFee;
    },
    showBreakdown: function showBreakdown(value) {
      this.showPaymentBreakdown = value;
    },
    showReleaseModal: function showReleaseModal() {
      var self = this;
      self.release.show = true;
      self.release.processing = false;
      self.release.success = false;

      if (self.release.loading) {
        return;
      }

      self.release.loading = true;
      self.release.showContent = false;
      self.release.error.show = false;
      self.release.charge = 1;

      __WEBPACK_IMPORTED_MODULE_4__modules_api_driver_release__["a" /* default */].getReleaseFee(self, {
        id: self.packageID,
        type: 'package'
      }, function (r) {
        self.release.loading = false;

        if (r.error) {
          self.release.error.show = true;
          self.release.error.message = r.error.message;
          return;
        }

        self.release.fee = parseFloat(r.Charge);
        if (self.release.fee === 0) {
          self.release.charge = 0;
        }
        self.release.showContent = true;
      });
    },
    releaseDriver: function releaseDriver() {
      var self = this;
      self.release.processing = true;
      self.release.success = false;
      self.release.loading = true;

      self.$sdk.delete('/admin/package/' + self.packageID + '/driver', {
        token: self.$store.state.session.sessionToken,
        charge: self.release.charge
      }, function (r) {
        self.release.loading = false;
        if (r.error) {
          console.log(r);
          self.release.error.show = true;
          self.release.error.message = r.error.message;
          return;
        }
        self.release.success = true;
        Object(__WEBPACK_IMPORTED_MODULE_5_timers__["setTimeout"])(function () {
          window.location.reload();
        }, 2000);
      });
    },
    closeRelease: function closeRelease() {
      this.release.show = false;
      if (!this.release.error.show) {
        window.location.reload();
      }
    },
    refreshTransaction: function refreshTransaction() {
      var self = this;
      self.$sdk.post('/admin/package/' + self.packageID + '/refresh', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          self.refreshPkg.message = r.error.message;
          self.refreshPkg.error = true;
          self.refreshPkg.show = true;
        } else {
          self.loadPackage(false);
        }
      });
    },
    refresh: function refresh() {
      this.refreshLoading = true;
      this.refreshTransaction();
    },
    isCompleted: function isCompleted() {
      var lastId = this.package.route[this.package.route.length - 1].rsvpID;
      var lastStop = this.package.rsvps.find(function (x) {
        return x.id === lastId;
      });
      return lastStop.completed;
    },
    trackDriver: function trackDriver() {
      var self = this;

      var stops = [];
      self.package.route.forEach(function (route) {
        if (!route.isPickup) {
          stops.push(route.rsvpID);
        }
      });

      var rsvp = '';
      stops.every(function (stop, index) {
        rsvp = self.package.rsvps.find(function (x) {
          return x.id === stop && ['ontheway', 'arrived', 'onboard'].indexOf(x.rsvpStatus) > -1;
        });
        return !rsvp ? true : false;
      });

      if (self.trackDriverDelay) {
        clearTimeout(self.trackDriverDelay);
      }

      if (rsvp) {
        self.$sdk.get('/provider/' + rsvp.driver.id + '/tracks', { token: self.$store.state.session.sessionToken }, function (res) {
          if (!res.error && res.list.length) {
            self.driverLocation = {
              lat: res.list[0].lat,
              lng: res.list[0].lng
            };
            self.driverDestination = {
              lat: rsvp.dropoff.lat,
              lng: rsvp.dropoff.lng
            };
            self.setRoute([self.driverLocation, self.driverDestination], true);
          }
        });
      } else {
        self.trackRemoveDriver();
      }
    },
    computeHeading: function computeHeading(orig, dest) {
      var y = Math.sin(dest.lng - orig.lng) * Math.cos(dest.lat);
      var x = Math.cos(orig.lat) * Math.sin(dest.lat) - Math.sin(orig.lat) * Math.cos(dest.lat) * Math.cos(dest.lng - orig.lng);

      var brng = Math.atan2(y, x) * 180 / Math.PI;
      return Math.round(360 - (brng + 360) % 360);
    },
    setTrackDriverPin: function setTrackDriverPin(data) {
      var self = this;
      self.trackRemoveDriver();

      // let marker = `<div class="rotator">
      //   <div class='here-marker car-icon' style="transform: rotate({HEADING}) translate(50%, 22px)"></div>
      // </div>`
      var marker = '\n        <svg height="25" width="25" style="overflow: overlay; top: -12px; left: -12px;" viewBox="0 0 50 50">\n          <path d="{D}" fill="{FILL}"stroke="{STROKE}" stroke-width="{STROKE_WIDTH}" />\n        </svg>';
      marker = marker.replace('{D}', __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */].car.path).replace('{FILL}', __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */].car.fillColor).replace('{STROKE}', __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */].car.strokeColor).replace('{STROKE_WIDTH}', __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */].car.strokeWeight);

      var heading = self.computeHeading(self.driverLocation, self.driverDestination);
      marker = marker.replace('{HEADING}', heading + 'deg');
      var icon = new window.H.map.DomIcon(marker);
      var pin = new window.H.map.DomMarker(self.driverLocation, { icon: icon });
      pin.id = 'driverPin';
      pin.lat = self.driverLocation.lat;
      pin.lng = self.driverLocation.lng;

      // let content = `<div class="here-info-window-content package-detail car">
      //   <label>ETA to next dropoff</label>
      //   <span class="value">{ETA}</span>
      // </div>`
      var content = '\n        <div class="info-container">\n          <div class="driver-info"><img src="{DRIVER_PHOTO}"/><a href="{DRIVER_URL}" target="_blank">{DRIVER_NAME}</a></div>\n          <div class="vehicle-info"><img src="{VEHICLE_PHOTO}"/><strong>{VEHICLE_NAME}</strong><span>{VEHICLE_NUMBER}</span></div>\n          <div class="eta-to-dropoff"><label>ETA to next dropoff</label><span class="value">{ETA}</span></div>\n          <a id="DriverCall_{DRIVER_ID}" class="call-button button cta xsmall success block" href="javascript:;" @click="testMethod">CALL {DRIVER_FNAME}</a>\n        </div>\n      ';
      var driver = self.package.driver;
      content = content.replace('{DRIVER_PHOTO}', driver.photoUrl).replace('{DRIVER_URL}', '/#/provider/' + driver.id).replace('{DRIVER_ID}', driver.id).replace('{DRIVER_NAME}', driver.firstName + ' ' + driver.lastName).replace('{VEHICLE_PHOTO}', driver.vehicle.photoUrl).replace('{VEHICLE_NAME}', driver.vehicle.name).replace('{VEHICLE_NUMBER}', driver.vehicle.licensePlate).replace('{DRIVER_FNAME}', driver.firstName);
      var travelTime = 0;
      data.forEach(function (dat) {
        travelTime += dat.travelSummary.duration;
      });
      if (travelTime > 60) {
        content = content.replace('{ETA}', Math.ceil(travelTime / 60) + ' minute(s)');
      } else {
        content = content.replace('{ETA}', travelTime + ' second(s)');
      }
      var bubble = new window.H.ui.InfoBubble(self.driverLocation, { content: content });
      bubble.addClass('H_driver-info');
      bubble.id = 'driverBubble';
      bubble.open();
      self.hereMaps.ui.addBubble(bubble);
      pin.addEventListener('tap', function (evt) {
        bubble.open();
      }, false);
      self.hereMaps.map.addObject(pin);

      Object(__WEBPACK_IMPORTED_MODULE_5_timers__["setTimeout"])(function () {
        var elem = document.getElementById('DriverCall_' + driver.id);
        elem.addEventListener('click', function (evt) {
          self.callDriver(driver);
        });
      }, 500);

      self.trackDriverDelay = Object(__WEBPACK_IMPORTED_MODULE_5_timers__["setTimeout"])(function () {
        self.trackDriver();
      }, 15000);
    },
    trackRemoveDriver: function trackRemoveDriver() {
      var self = this;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var object = _step3.value;

          if (object.id === 'driverPin') {
            self.hereMaps.map.removeObject(object);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      self.hereMaps.ui.getBubbles().forEach(function (bub) {
        if (bub.id === 'driverBubble') {
          self.hereMaps.ui.removeBubble(bub);
        }
      });
    },
    callDriver: function callDriver(driver) {
      var self = this;
      self.$plugins.phone.startCall(self, {
        phone: driver.phone,
        name: driver.firstName + ' ' + driver.lastName
      });
    },
    call: function call(user) {
      var self = this;
      self.showOptions = false;
      self.$plugins.phone.startCall(self, {
        phone: user.mobile,
        name: user.firstName + ' ' + user.lastName
      });
    },
    hideOptions: function hideOptions() {
      var self = this;
      self.showOptionsDelay = Object(__WEBPACK_IMPORTED_MODULE_5_timers__["setTimeout"])(function () {
        self.showOptions = false;
      }, 3500);
    },
    clearOptionDelay: function clearOptionDelay() {
      var self = this;
      if (self.showOptionsDelay) {
        clearTimeout(self.showOptionsDelay);
      }
    },
    sendSMS: function sendSMS() {
      this.showOptions = false;
      if (this.$refs.sms.showSMSForm()) {
        this.$refs.sms.showSMSForm();
      }
    },
    showNotif: function showNotif() {
      this.showOptions = false;
      if (this.$refs.notif.showNotifForm()) {
        this.$refs.notif.showNotifForm();
      }
    }
  },
  watch: {
    package: function _package(value) {
      if (value === null) {
        return;
      }
      if (value.route === null) {
        return;
      }
      this.routePackage();
    },
    packageID: function packageID(value) {
      var self = this;
      if (self.trackDriverDelay) {
        clearTimeout(self.trackDriverDelay);
      }
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var object = _step4.value;

          self.hereMaps.map.removeObject(object);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      self.hereMaps.ui.getBubbles().forEach(function (bub) {
        self.hereMaps.ui.removeBubble(bub);
      });
      self.loadPackage(true);
    },
    showOptions: function showOptions(value) {
      var self = this;
      if (value) {
        self.hideOptions();
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    var mapContainer = document.getElementById('mapHere');
    self.hereMaps.platform = new window.H.service.Platform({ apikey: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key });

    var defaultLayers = self.hereMaps.platform.createDefaultLayers();
    self.hereMaps.map = new window.H.Map(mapContainer, defaultLayers.vector.normal.map, {
      center: self.center,
      zoom: 13,
      pixelRatio: window.devicePixelRatio || 1
    });
    /* eslint-disable no-unused-vars */
    var behavior = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(self.hereMaps.map));
    /* eslint-enable no-unused-vars */
    self.hereMaps.ui = window.H.ui.UI.createDefault(self.hereMaps.map, defaultLayers);

    self.loadPackage(true);
  }
});

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Filter__ = __webpack_require__(1862);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'flights',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a, listFilter: __WEBPACK_IMPORTED_MODULE_2__Filter__["a" /* default */] },
  data: function data() {
    return {
      search: '',
      date: {
        from: '',
        to: ''
      },
      error: {
        from: false,
        to: false,
        message: ''
      },
      showCxlConfirm: false,
      selectedId: ''
    };
  },

  computed: {
    flights: function flights() {
      return this.$store.state.flights;
    },

    loading: {
      get: function get() {
        return this.flights.loading;
      },
      set: function set(x) {
        this.$store.commit('flights/setListData', { loading: x });
      }
    },
    perPage: {
      get: function get() {
        return this.flights.perPage;
      },
      set: function set(x) {
        this.$store.commit('flights/setListData', {
          perPage: parseInt(x),
          currentPage: 1
        });
        this.getFlights();
      }
    },
    pageData: function pageData() {
      var tableData = this.flights;
      var start = tableData.currentPage * tableData.perPage - (tableData.perPage - 1);
      var end = tableData.currentPage * tableData.perPage;
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      };
    },

    currentPage: {
      get: function get() {
        return this.flights.currentPage;
      },
      set: function set(x) {
        this.$store.commit('flights/setListData', { currentPage: parseInt(x) });
        this.getFlights();
      }
    },
    isLastPage: function isLastPage() {
      return this.flights.currentPage * this.flights.perPage >= this.flights.maxList;
    },
    totalPage: function totalPage() {
      return Math.ceil(this.flights.maxList / this.flights.perPage);
    },
    enableSearchGlobal: function enableSearchGlobal() {
      return this.$store.state.searchGlobal.enable;
    }
  },
  methods: {
    getFlights: function getFlights() {
      if (this.$refs.listFilter) this.$refs.listFilter.getFlights();
    },
    showConfirm: function showConfirm(id) {
      this.selectedId = id;
      this.showCxlConfirm = true;
    },
    cxlFLight: function cxlFLight() {
      var _this = this;

      var self = this;
      self.showCxlConfirm = false;
      self.$store.commit('global/setLoaderData', { show: true, message: '' });
      try {
        self.$sdk.post2({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.d2dGateway + '/admin/d2d/cancel', {
          token: self.$store.state.session.sessionToken,
          d2dId: this.selectedId
        }, function (res) {
          self.$store.commit('global/setLoaderData', { show: false, message: '' });
          if (res.error) {
            _this.$store.commit('global/setAlertData', {
              show: true,
              message: res.error.message
            });
            return;
          }
          self.getFlights();
        });
      } catch (err) {
        self.$store.commit('global/setLoaderData', { show: false, message: '' });
        self.$store.commit('global/setAlertData', {
          show: true,
          message: err
        });
      }
    },
    prev: function prev() {
      if (this.currentPage === 1) {
        return;
      }
      this.$store.commit('flights/setListData', { currentPage: this.currentPage - 1 });
      this.getFlights();
    },
    next: function next() {
      if (this.isLastPage) {
        return;
      }
      this.$store.commit('flights/setListData', { currentPage: this.currentPage + 1 });
      this.getFlights();
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'filter',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a },
  data: function data() {
    return {
      search: '',
      booking: {
        from: '',
        to: ''
      },
      travel: {
        from: '',
        to: ''
      },
      status: '',
      error: {
        booking: {
          from: '',
          to: ''
        },
        travel: {
          from: '',
          to: ''
        },
        message: {
          bookingDate: '',
          travelDate: ''
        }
      }
    };
  },

  computed: {
    flights: function flights() {
      return this.$store.state.flights;
    },

    loading: {
      get: function get() {
        return this.flights.loading;
      },
      set: function set(x) {
        this.$store.commit('flights/setListData', { loading: x });
      }
    }
  },
  methods: {
    getFlights: function getFlights() {
      var _this = this;

      var self = this;
      if (self.loading || self.error.message.bookingDate || self.error.message.travelDate) return;
      self.loading = true;

      var param = {
        token: self.$store.state.session.sessionToken,
        pageNum: self.flights.currentPage,
        pageSize: self.flights.perPage,
        order: 'createTime',
        desc: true,
        paging: 1
      };

      if (self.search) param.search = self.search;
      if (self.status) param.status = self.status;

      if (self.booking.from && self.booking.to) {
        var from = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(self.booking.from);
        from = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(from.format('MM/DD/YYYY') + ' 00:00AM', 'MM/DD/YYYY hh:mmA').format('X');
        var to = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(self.booking.to);
        to = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(to.format('MM/DD/YYYY') + ' 23:59PM', 'MM/DD/YYYY hh:mmA').format('X');

        param.bookedSince = from;
        param.bookedUntil = to;
      }
      if (self.travel.from && self.travel.to) {
        var _from = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(self.travel.from);
        _from = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(_from.format('MM/DD/YYYY') + ' 00:00AM', 'MM/DD/YYYY hh:mmA').format('X');
        var _to = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(self.travel.to);
        _to = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(_to.format('MM/DD/YYYY') + ' 23:59PM', 'MM/DD/YYYY hh:mmA').format('X');

        param.pickupSince = _from;
        param.pickupUntil = _to;
      }

      self.$sdk.post2({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.d2dGateway + '/admin/d2d/get', param, function (res) {
        var total = 0;
        if (res.paging && res.paging.total) total = res.paging.total;
        _this.$store.commit('flights/setListData', { maxList: total });

        if (res.error) {
          self.$store.commit('flights/setListData', { list: [] });
          self.loading = false;
          return;
        }

        var list = [];
        res.list.forEach(function (f) {
          var origin = {
            airportCode: f.originAirportCode,
            airportName: f.originAirportName
          };
          var destination = {
            airportCode: f.destAirportCode,
            airportName: f.destAirportName
          };
          var paxName = '--';
          if (f.paxFirstName || f.paxLastName) paxName = f.paxFirstName + ' ' + f.paxLastName;
          list.push({
            id: f.id,
            bookingId: f.bookingId,
            created: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(f.createdUTC, 'X').format('MM/DD/YYYY hh:mmA'),
            origin: origin,
            destination: destination,
            status: f.status,
            paxName: paxName,
            rsvp1: f.rsvpId1,
            rsvp2: f.rsvpId2,
            isRefundable: f.isRefundable
          });
        });
        self.$store.commit('flights/setListData', { list: list });
        self.loading = false;
      });
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(date).format('MM/DD/YYYY');
    },
    changeDate: function changeDate(type) {
      var format = 'MM/DD/YYYY';
      var from = '';
      var to = '';

      // Moment Setup
      if (type === 'from') {
        from = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.booking.from);
        if (this.booking.to) {
          to = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.booking.to);
        }
      } else if (type === 'to') {
        to = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.booking.to);
        if (this.booking.from) {
          from = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.booking.from);
        }
      } else if (type === 'travelFrom') {
        from = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.travel.from);
        if (this.travel.to) {
          to = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.travel.to);
        }
      } else {
        to = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.travel.to);
        if (this.travel.from) {
          from = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.travel.from);
        }
      }

      // Validation
      if (['from', 'to'].indexOf(type) > -1) {
        this.error.message.bookingDate = '';
        if (this.booking.from === '' && this.booking.to === '') {
          this.error.booking.from = false;
          this.error.booking.to = false;
          return;
        }
        if (this.booking.from === '' || this.booking.to === '') {
          if (type === 'from') {
            this.error.booking.to = true;
          } else {
            this.error.booking.from = true;
          }
          this.error.message.bookingDate = this.$t('transactions.filter.emptyDate');
          return;
        }
        if (from && to && from.format('x') > to.format('x')) {
          this.error.booking.from = true;
          this.error.booking.to = true;
          this.error.message.bookingDate = this.$t('transactions.filter.invalidDateRange');
          return;
        }
        this.error.booking.from = false;
        this.error.booking.to = false;
      } else if (['travelFrom', 'travelTo'].indexOf(type) > -1) {
        this.error.message.travelDate = '';
        if (this.travel.from === '' && this.travel.to === '') {
          this.error.travel.from = false;
          this.error.travel.to = false;
          return;
        }
        if (this.travel.from === '' || this.travel.to === '') {
          if (type === 'travelFrom') {
            this.error.travel.to = true;
          } else {
            this.error.travel.from = true;
          }
          this.error.message.travelDate = this.$t('transactions.filter.emptyDate');
          return;
        }
        if (from && to && from.format('x') > to.format('x')) {
          this.error.travel.from = true;
          this.error.travel.to = true;
          this.error.message.travelDate = this.$t('transactions.filter.invalidDateRange');
          return;
        }
        this.error.travel.from = false;
        this.error.travel.to = false;
      }
      // this.getFlights()
    },
    next: function next() {},
    prev: function prev() {}
  },
  mounted: function mounted() {
    this.getFlights();
  }
});

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__details__ = __webpack_require__(1870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__trx__ = __webpack_require__(1878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_airport_code_tz_js__ = __webpack_require__(1882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_airport_code_tz_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__data_airport_code_tz_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'flight-details',
  components: { fdetails: __WEBPACK_IMPORTED_MODULE_1__details__["a" /* default */], trx: __WEBPACK_IMPORTED_MODULE_2__trx__["a" /* default */] },
  data: function data() {
    return {
      doneAllLoading: false,
      rsvpQueue: [],
      returnTripLoaded: false,
      activeTab: 'info'
    };
  },

  computed: {
    id: function id() {
      return this.$route.params.id;
    },
    flightDetails: function flightDetails() {
      return this.$store.state.flightDetails.details;
    },
    flightId: function flightId() {
      if (!this.flightDetails.roundtripId) return this.id;
      return parseInt(this.id) > this.flightDetails.roundtripId ? this.flightDetails.roundtripId + ' - ' + this.id : this.id + ' - ' + this.flightDetails.roundtripId;
    }
  },
  methods: {
    getAirportList: function getAirportList() {
      var self = this;
      if (self.$store.state.airports.list.length > 0) {
        self.init();
        return;
      }

      self.$store.commit('airports/setLoading', true);
      self.$store.commit('global/setLoaderData', { show: true, message: '' });
      self.$sdk.get('/airports', {}, function (res) {
        self.$store.commit('airports/setLoading', false);
        var list = [];
        res.list.forEach(function (data) {
          var add1 = data.addressLine2 === null ? data.addressLine1 : data.addressLine2;
          var add2 = data.addressLine2 === null ? '' : data.addressLine1;
          var title = add2 + ' ' + add1 + ', ' + data.city + ', ' + data.state + ' ' + data.zipCode;
          if (data.enabled) {
            list.push({
              geofenceId: data.id,
              geofenceType: 'airport',
              address1: add1,
              address2: add2,
              city: data.city,
              lat: data.lat,
              lng: data.lng,
              state: data.state,
              title: data.name || title,
              zip: data.zipCode,
              description: data.description,
              airportCode: data.airportCode,
              locationId: data.locationId
            });
          }
        });
        self.$store.commit('airports/setList', list);
        self.init();
      });
    },
    init: function init() {
      var self = this;
      self.$store.commit('global/setLoaderData', { show: true, message: '' });
      self.doneAllLoading = false;
      self.$sdk.post2({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.d2dGateway + '/admin/d2d/get', {
        token: self.$store.state.session.sessionToken,
        id: self.id,
        raw: true
      }, function (res) {
        if (res.error || res.list && !res.list.length) {
          self.$store.commit('global/setLoaderData', { show: false, message: '' });
          self.overAllLoading = false;
          self.$router.push({ name: 'MissingPage' });
          return;
        }

        var tmp = res.list[0];
        var data = {
          bookingId: tmp.bookingId,
          bookedDate: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(tmp.createdUTC, 'X').format('MM/DD/YYYY hh:mmA'),
          airlinePNR: tmp.pnr,
          roundtripId: tmp.roundTripId,
          flights: {
            oneway: [],
            return: []
          },
          pax: [],
          airFareTotal: tmp.fareFlightTotal,
          status: tmp.status,
          isRefundable: tmp.isRefundable
        };
        var flightDetails = tmp.priceData.UpdateFareQuote.FareQuoteDetails.JourneyList.FlightDetails.Details;
        flightDetails[0].forEach(function (f) {
          data.flights.oneway.push({
            // airlinePNR: f.AirlinePNR,
            flightName: f.OperatorName,
            flightCode: f.OperatorCode,
            flightNo: f.FlightNumber,
            duration: f.Duration,
            origin: {
              code: f.Origin.AirportCode,
              name: f.Origin.AirportName,
              date: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(f.Origin.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
              dateLA: self.convertToLATimezone(f.Origin)
            },
            destination: {
              code: f.Destination.AirportCode,
              name: f.Destination.AirportName,
              date: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(f.Destination.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
              dateLA: self.convertToLATimezone(f.Destination)
            }
          });
        });

        if (tmp.roundTripId && flightDetails[1]) {
          flightDetails[1].forEach(function (f) {
            data.flights.return.push({
              // airlinePNR: f.AirlinePNR,
              flightName: f.OperatorName,
              flightCode: f.OperatorCode,
              flightNo: f.FlightNumber,
              duration: f.Duration,
              origin: {
                code: f.Origin.AirportCode,
                name: f.Origin.AirportName,
                date: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(f.Origin.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
                dateLA: self.convertToLATimezone(f.Origin)
              },
              destination: {
                code: f.Destination.AirportCode,
                name: f.Destination.AirportName,
                date: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(f.Destination.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
                dateLA: self.convertToLATimezone(f.Destination)
              }
            });
          });
        }

        data.isPending = false;
        if (tmp.commitData) {
          tmp.commitData.CommitBooking.BookingDetails.PassengerDetails.forEach(function (p) {
            data.pax.push({
              firstName: p.FirstName,
              lastName: p.LastName,
              ticketId: p.TicketId,
              ticketNo: p.TicketNumber
            });
          });
        } else {
          data.isPending = true;
        }
        self.$store.commit('flightDetails/setFlightDetails', { details: data });

        var isFirstLeg = true;
        if (tmp.roundTripId && tmp.id > tmp.roundTripId) isFirstLeg = false;
        if (tmp.rsvpId1) {
          self.rsvpQueue.push({
            rsvp: isFirstLeg ? 'rsvp1' : 'rsvp3',
            id: tmp.rsvpId1
          });
        }
        if (tmp.rsvpId2) {
          self.rsvpQueue.push({
            rsvp: isFirstLeg ? 'rsvp2' : 'rsvp4',
            id: tmp.rsvpId2
          });
        }
        self.getRsvpData();
      });
    },
    getRsvpData: function getRsvpData() {
      var self = this;
      if (!self.rsvpQueue.length || self.rsvpQueue[0] && !self.rsvpQueue[0].id) {
        if (self.flightDetails.roundtripId && !self.returnTripLoaded) {
          self.getReturnRSVP();
          return;
        }
        self.doneAllLoading = true;
        self.$store.commit('global/setLoaderData', { show: false, message: '' });
        if (self.activeTab === 'trx') {
          if (self.$refs.trx.getTrx()) {
            self.$refs.trx.getTrx();
          }
        }
        setTimeout(function () {
          if (self.$refs.fDetails.initMap()) {
            self.$refs.fDetails.initMap();
          }
        }, 250);
        return;
      }

      self.$sdk.get('/admin/rsvp/' + self.rsvpQueue[0].id, {
        token: self.$store.state.session.sessionToken
      }, function (res) {
        if (res.error) {
          console.log('error rsvp data');
          self.rsvpQueue.shift();
          self.getRsvpData();
          return;
        }
        var tmp = {};
        var total = parseFloat(res.payment.total || 0) + (res.travelInsurance || 0) + (res.gasFee || 0) + (res.airportFee || 0);
        tmp[self.rsvpQueue[0].rsvp] = {
          id: res.ID,
          service: res.serviceType.name,
          pickup: res.pickupLocation,
          dropoff: res.dropoffLocation,
          pickupDate: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(res.pickupDate, 'YYYY-MM-DD HH:mm:ss Z').tz(res.pickupTimezone).format('MM/DD/YYYY hh:mmA'),
          pickupDateLA: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(res.pickupDate, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
          payment: total.toFixed(2),
          status: res.status
        };
        self.$store.commit('flightDetails/setFlightDetails', tmp);
        self.rsvpQueue.shift();
        self.getRsvpData();
      });
    },
    getReturnRSVP: function getReturnRSVP() {
      var self = this;
      // self.overAllLoading = false
      self.$sdk.post2({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.d2dGateway + '/admin/d2d/get', {
        token: self.$store.state.session.sessionToken,
        id: self.flightDetails.roundtripId
      }, function (res) {
        if (res.error || res.list && !res.list.length) {
          self.$store.commit('global/setLoaderData', { show: false, message: '' });
          self.overAllLoading = false;
          self.$router.push({ name: 'MissingPage' });
          return;
        }
        var tmp = res.list[0];
        var isFirstLeg = true;
        if (tmp.roundTripId && self.flightDetails.roundtripId > tmp.roundTripId) isFirstLeg = false;
        self.rsvpQueue.push({
          rsvp: isFirstLeg ? 'rsvp1' : 'rsvp3',
          id: tmp.rsvpId1
        });
        self.rsvpQueue.push({
          rsvp: isFirstLeg ? 'rsvp2' : 'rsvp4',
          id: tmp.rsvpId2
        });
        self.returnTripLoaded = true;
        self.getRsvpData();
      });
    },
    switchTab: function switchTab(x) {
      this.activeTab = x;
      if (x === 'trx' && this.$refs.trx) {
        this.$refs.trx.getTrx();
      }
    },
    convertToLATimezone: function convertToLATimezone(data) {
      if (__WEBPACK_IMPORTED_MODULE_3__data_airport_code_tz_js___default.a[data.AirportCode] && __WEBPACK_IMPORTED_MODULE_3__data_airport_code_tz_js___default.a[data.AirportCode] === 'America/Los_Angeles') return __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(data.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA');

      if (__WEBPACK_IMPORTED_MODULE_3__data_airport_code_tz_js___default.a[data.AirportCode]) {
        var tmpDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default.a.tz(data.DateTime, 'YYYY-MM-DD HH:mm', __WEBPACK_IMPORTED_MODULE_3__data_airport_code_tz_js___default.a[data.AirportCode]);
        return tmpDate.tz('America/Los_Angeles').format('MM/DD/YYYY hh:mmA');
      }
      return 'AIRPORT tz not found';
      // return moment(data.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
    }
  },
  watch: {
    id: function id() {
      var _this = this;

      this.doneAllLoading = false;
      this.rsvpQueue = [];
      this.returnTripLoaded = false;
      this.$store.commit('flightDetails/setFlightDetails', { details: {} });
      this.$nextTick(function () {
        _this.init();
      });
    }
  },
  mounted: function mounted() {
    this.getAirportList();
  }
});

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fmap__ = __webpack_require__(1873);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */
// import moment from 'moment-timezone'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'flight-details',
  components: { fmap: __WEBPACK_IMPORTED_MODULE_1__fmap__["a" /* default */] },
  props: ['doneAllLoading'],
  data: function data() {
    return {
      showCxlConfirm: false,
      cancelAllGround: true,
      notifyUser: true,
      rsvpAction: {
        show: false,
        confirm: false,
        data: {},
        type: '',
        target: '',
        cxlFee: 0,
        charge: 1
      },
      flightAction: {
        cxlFee: {
          flight: 0,
          rsvp1: 0,
          rsvp2: 0,
          rsvp3: 0,
          rsvp4: 0,
          total: 0
        },
        charge: 1,
        lastId: 0
      }
    };
  },

  computed: {
    id: function id() {
      return this.$route.params.id;
    },
    flight: function flight() {
      return this.$store.state.flightDetails;
    },
    details: function details() {
      return this.flight.details;
    },
    hasReturnTrip: function hasReturnTrip() {
      return this.details.roundtripId;
    },
    rsvp1: function rsvp1() {
      return this.flight.rsvp1;
    },
    rsvp2: function rsvp2() {
      return this.flight.rsvp2;
    },
    rsvp3: function rsvp3() {
      return this.flight.rsvp3;
    },
    rsvp4: function rsvp4() {
      return this.flight.rsvp4;
    },
    totalPayment: function totalPayment() {
      var air = this.details.airFareTotal;
      var land = 0;
      if (this.hasRsvp(this.rsvp1)) land += parseFloat(this.rsvp1.payment);
      if (this.hasRsvp(this.rsvp2)) land += parseFloat(this.rsvp2.payment);
      if (this.hasReturnTrip) {
        if (this.hasRsvp(this.rsvp3)) land += parseFloat(this.rsvp3.payment);
        if (this.hasRsvp(this.rsvp4)) land += parseFloat(this.rsvp4.payment);
      }
      // parseFloat(this.rsvp1.payment) + parseFloat(this.rsvp2.payment)
      // if (this.hasReturnTrip) land = land * 2
      return air + land;
    },
    currentFlightFee: function currentFlightFee() {
      var total = this.flightAction.cxlFee.total;
      if (this.rsvp1.status !== 'upcoming') total = total - parseFloat(this.flightAction.cxlFee.rsvp1);
      if (this.rsvp2.status !== 'upcoming') total = total - parseFloat(this.flightAction.cxlFee.rsvp2);
      if (this.hasReturnTrip) {
        if (this.rsvp3.status !== 'upcoming') total = total - parseFloat(this.flightAction.cxlFee.rsvp3);
        if (this.rsvp4.status !== 'upcoming') total = total - parseFloat(this.flightAction.cxlFee.rsvp4);
      }
      return parseFloat(total.toFixed(2));
    },
    isPending: function isPending() {
      return this.details.isPending;
    }
  },
  methods: {
    initMap: function initMap() {
      if (this.$refs.refmap.initPoints()) {
        this.$refs.refmap.initPoints();
      }
    },
    priceFormat: function priceFormat(data) {
      return parseFloat(data).toLocaleString('en-US', { minimumFractionDigits: 2 });
    },
    shortenLoc: function shortenLoc(data) {
      if (!data) return '';
      if (data.geofenceType === 'airport') return data.airportCode;
      return data.city + ', ' + data.state;
    },
    sendEmail: function sendEmail() {
      var self = this;
      self.$store.commit('global/setLoaderData', { show: true, message: '' });
      try {
        self.$sdk.post2({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.d2dGateway + '/admin/d2d/email', {
          token: self.$store.state.session.sessionToken,
          d2dId: self.id
        }, function (res) {
          self.$store.commit('global/setLoaderData', { show: false, message: '' });
          if (res.error) {
            self.$store.commit('global/setAlertData', {
              show: true,
              message: res.error.message
            });
            return;
          }
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'Email sent.'
          });
        });
      } catch (err) {
        self.$store.commit('global/setLoaderData', { show: false, message: '' });
        self.$store.commit('global/setAlertData', {
          show: true,
          message: err
        });
      }
    },
    getCancelFee: function getCancelFee(forRsvp, dat) {
      var self = this;
      self.$store.commit('global/setLoaderData', { show: true, message: '' });
      self.$sdk.post2({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.d2dGateway + '/admin/d2d/cancelfee', {
        token: self.$store.state.session.sessionToken,
        d2dId: self.id
      }, function (res) {
        self.$store.commit('global/setLoaderData', { show: false, message: '' });
        if (res.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          });
          return;
        }
        self.flightAction.lastId = self.id;
        self.flightAction.cxlFee.total = res.amount ? parseFloat(res.amount.toFixed(2)) : 0;
        self.flightAction.cxlFee.flight = res.flight ? parseFloat(res.flight.toFixed(2)) : 0;
        self.flightAction.cxlFee.rsvp1 = res.rsvp[self.rsvp1.id] ? parseFloat(res.rsvp[self.rsvp1.id].toFixed(2)) : 0;
        self.flightAction.cxlFee.rsvp2 = res.rsvp[self.rsvp2.id] ? parseFloat(res.rsvp[self.rsvp2.id].toFixed(2)) : 0;
        if (self.hasReturnTrip) {
          self.flightAction.cxlFee.rsvp3 = res.rsvp[self.rsvp3.id] ? parseFloat(res.rsvp[self.rsvp3.id].toFixed(2)) : 0;
          self.flightAction.cxlFee.rsvp4 = res.rsvp[self.rsvp4.id] ? parseFloat(res.rsvp[self.rsvp4.id].toFixed(2)) : 0;
        }
        if (forRsvp) {
          self.rsvpAction.show = true;
          self.rsvpAction.confirm = false;
          self.rsvpAction.data = dat.data;
          self.rsvpAction.target = dat.target;
          return;
        }
        self.showCxlConfirm = true;
      });
    },
    cxlFLight: function cxlFLight() {
      var self = this;
      self.showCxlConfirm = false;
      self.$store.commit('global/setLoaderData', { show: true, message: '' });
      try {
        var param = {
          token: self.$store.state.session.sessionToken,
          d2dId: self.id,
          cancelGround: self.cancelAllGround,
          email: self.notifyUser,
          refundAmount: self.totalPayment
        };
        if (self.flightAction.charge == 1) {
          var cxlFee = self.flightAction.cxlFee.total;
          if (self.rsvp1.status !== 'upcoming') cxlFee = cxlFee - parseFloat(self.flightAction.cxlFee.rsvp1);
          if (self.rsvp2.status !== 'upcoming') cxlFee = cxlFee - parseFloat(self.flightAction.cxlFee.rsvp2);
          if (self.hasReturnTrip) {
            if (self.rsvp3.status !== 'upcoming') cxlFee = cxlFee - parseFloat(self.flightAction.cxlFee.rsvp3);
            if (self.rsvp4.status !== 'upcoming') cxlFee = cxlFee - parseFloat(self.flightAction.cxlFee.rsvp4);
          }
          param.refundAmount = parseFloat((self.totalPayment - cxlFee).toFixed(2));
        }
        self.$sdk.post2({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.d2dGateway + '/admin/d2d/cancel', param, function (res) {
          self.$store.commit('global/setLoaderData', { show: false, message: '' });
          if (res.error) {
            self.$store.commit('global/setAlertData', {
              show: true,
              message: res.error.message
            });
            return;
          }
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'Flight #' + self.id + ' has been cancelled.'
          });
          self.$router.push('/flights');
        });
      } catch (err) {
        self.$store.commit('global/setLoaderData', { show: false, message: '' });
        self.$store.commit('global/setAlertData', { show: true, message: err });
      }
    },
    showOptions: function showOptions(data, target) {
      if (this.flightAction.lastId !== this.id) {
        this.getCancelFee(true, { data: data, target: target });
        return;
      }
      this.rsvpAction.show = true;
      this.rsvpAction.confirm = false;
      this.rsvpAction.data = data;
      this.rsvpAction.target = target;
    },
    showConfirm: function showConfirm(type) {
      this.rsvpAction.type = type;
      if (type === 'cancel') {
        if (this.rsvpAction.data.status !== 'upcoming') return;
        this.rsvpAction.confirm = true;
      }
      if (type === 'refund') {
        this.getCxlFee(this.rsvpAction.data.id);
      }
    },
    proccessAction: function proccessAction(id) {
      if (this.rsvpAction.type === 'cancel') this.cancelRsvp(id);
      if (this.rsvpAction.type === 'refund') this.refundRsvp(id);
    },
    cancelRsvp: function cancelRsvp(rsvpId) {
      var self = this;
      self.rsvpAction.show = false;
      self.$store.commit('global/setLoaderData', { show: true, message: '' });
      var amount = parseFloat(self[self.rsvpAction.target].payment);
      if (self.rsvpAction.charge == 1) {
        amount = amount - self.flightAction.cxlFee[self.rsvpAction.target];
      }
      self.$sdk.post2({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.d2dGateway + '/admin/d2d/rsvp/cancel', {
        token: self.$store.state.session.sessionToken,
        d2dId: self.id,
        rsvpId: rsvpId,
        amount: amount,
        order: 'createTime',
        desc: true
      }, function (res) {
        self.$store.commit('global/setLoaderData', { show: false, message: '' });
        if (res.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          });
          return;
        }
        self.$store.commit('global/setAlertData', {
          show: true,
          message: 'Succesfully canceled RSVP ' + rsvpId + '.'
        });
        self.$store.commit('flightDetails/updateRsvpStatus', {
          target: self.rsvpAction.target,
          val: 'canceled'
        });
      });
    },
    getCxlFee: function getCxlFee(rsvpId) {
      var self = this;
      self.rsvpAction.show = false;
      self.$store.commit('global/setLoaderData', { show: true, message: '' });
      self.$sdk.get('/admin/rsvp/' + rsvpId + '/fee', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.$store.commit('global/setLoaderData', { show: false, message: '' });
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          });
          return;
        }
        self.rsvpAction.show = true;
        self.rsvpAction.confirm = true;
        self.rsvpAction.cxlFee = parseFloat(r.amount);
      });
    },
    refundRsvp: function refundRsvp(rsvpId) {
      var self = this;
      self.rsvpAction.show = false;
      self.$store.commit('global/setLoaderData', { show: true, message: '' });
      var data = {
        token: self.$store.state.session.sessionToken,
        d2dId: self.id,
        rsvpId: rsvpId
      };
      if (self.rsvpAction.charge == 1) {
        data.amount = parseFloat(self[self.rsvpAction.target].payment) - self.rsvpAction.cxlFee;
      }
      self.$sdk.post2({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.d2dGateway + '/admin/d2d/rsvp/refund', data, function (res) {
        self.$store.commit('global/setLoaderData', { show: false, message: '' });
        if (res.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          });
          return;
        }
        self.$store.commit('global/setAlertData', {
          show: true,
          message: 'Succesfully refunded RSVP ' + rsvpId + '.'
        });
      });
    },
    hasRsvp: function hasRsvp(x) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(x).length;
    }
  },
  watch: {},
  mounted: function mounted() {}
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__values_map_pin__ = __webpack_require__(52);


//
//
//
//
//
//

/* global CONFIG */
// import moment from 'moment-timezone'

// import allAirports from '@/values/airports'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fmap',
  data: function data() {
    return {
      hereMaps: {
        map: {},
        platform: {},
        router: {},
        geocoder: {},
        directions: [],
        ui: {}
      },
      center: { lat: 33.942791, lng: -118.410042 }, // LAX coords
      routesQueue: []
    };
  },

  computed: {
    id: function id() {
      return this.$route.params.id;
    },
    flight: function flight() {
      return this.$store.state.flightDetails;
    },
    details: function details() {
      return this.flight.details;
    },
    rsvp1: function rsvp1() {
      return this.flight.rsvp1;
    },
    rsvp2: function rsvp2() {
      return this.flight.rsvp2;
    },
    airports: function airports() {
      return this.$store.state.airports.list;
    }
  },
  methods: {
    initMap: function initMap() {
      var self = this;
      var mapContainer = document.getElementById('mapHere');
      self.hereMaps.platform = new window.H.service.Platform({
        apikey: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key
      });

      var defaultLayers = self.hereMaps.platform.createDefaultLayers();
      self.hereMaps.map = new window.H.Map(mapContainer, defaultLayers.vector.normal.map, {
        center: self.center,
        zoom: 3,
        pixelRatio: window.devicePixelRatio || 1
      });

      /* eslint-disable no-unused-vars */
      var behavior = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(self.hereMaps.map));
      /* eslint-enable no-unused-vars */
      self.hereMaps.ui = window.H.ui.UI.createDefault(self.hereMaps.map, defaultLayers);
      window.addEventListener('resize', function () {
        return self.hereMaps.map.getViewPort().resize();
      });
    },
    initPoints: function initPoints() {
      var self = this;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var object = _step.value;

          // if (object.id === 'pickup-pin') { self.hereMaps.map.removeObject(object) }
          self.hereMaps.map.removeObject(object);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var marker = '<svg height="25" width="25" style="overflow: unset" viewBox="0 0 50 50">' + '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' + 'stroke-width="{STROKE_WIDTH}" /></svg>';

      if (self.hasRsvp(self.rsvp1)) {
        var pickupMarker = marker.replace('{D}', __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */].pickup.path).replace('{FILL}', __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */].pickup.fillColor).replace('{STROKE}', __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */].pickup.strokeColor).replace('{STROKE_WIDTH}', __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */].pickup.strokeWeight);
        var pickupIcon = new window.H.map.DomIcon(pickupMarker);
        var pickupCoords = { lat: self.rsvp1.pickup.lat, lng: self.rsvp1.pickup.lng };
        var pickupPin = new window.H.map.DomMarker(pickupCoords, { icon: pickupIcon });
        pickupPin.id = 'pickup-pin';
        self.hereMaps.map.addObject(pickupPin);
      }

      self.details.flights.oneway.forEach(function (flight, i) {
        var marker = '<svg height="25" width="25" style="overflow: unset" viewBox="0 0 50 50">' + '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' + 'stroke-width="{STROKE_WIDTH}" /></svg>';
        var pickupMarker = marker.replace('{D}', __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */].pickup.path).replace('{FILL}', '#3898ca').replace('{STROKE}', __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */].pickup.strokeColor).replace('{STROKE_WIDTH}', __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */].pickup.strokeWeight);
        var pickupIcon = new window.H.map.DomIcon(pickupMarker);

        var index = self.airports.findIndex(function (x) {
          return x.airportCode === flight.origin.code;
        });
        if (index > -1) {
          var loc = self.airports[index];
          var _pickupCoords = { lat: loc.lat, lng: loc.lng };
          var _pickupPin = new window.H.map.DomMarker(_pickupCoords, { icon: pickupIcon });
          _pickupPin.id = 'pickup-pin';
          self.hereMaps.map.addObject(_pickupPin);
        }
        // let index2 = allAirports.findIndex(x => x.iata_code === flight.origin.code)
        // if (index === -1 && index2 > -1) {
        //   let loc = allAirports[index2]
        //   let pickupCoords = {lat: loc._geoloc.lat, lng: loc._geoloc.lng}
        //   let pickupPin = new window.H.map.DomMarker(
        //     pickupCoords,
        //     {icon: pickupIcon}
        //   )
        //   pickupPin.id = 'pickup-pin'
        //   self.hereMaps.map.addObject(pickupPin)
        // }

        if (i === self.details.flights.oneway.length - 1) {
          var index3 = self.airports.findIndex(function (x) {
            return x.airportCode === flight.destination.code;
          });
          if (index3 > -1) {
            var _loc = self.airports[index3];
            var _pickupIcon = new window.H.map.DomIcon(pickupMarker);
            var _pickupCoords2 = { lat: _loc.lat, lng: _loc.lng };
            var _pickupPin2 = new window.H.map.DomMarker(_pickupCoords2, { icon: _pickupIcon });
            _pickupPin2.id = 'pickup-pin';
            self.hereMaps.map.addObject(_pickupPin2);
          }
          // let index4 = allAirports.findIndex(x => x.iata_code === flight.destination.code)
          // if (index3 === -1 && index4 > -1) {
          //   let loc = allAirports[index4]
          //   let pickupCoords = {lat: loc._geoloc.lat, lng: loc._geoloc.lng}
          //   let pickupPin = new window.H.map.DomMarker(
          //     pickupCoords,
          //     {icon: pickupIcon}
          //   )
          //   pickupPin.id = 'pickup-pin'
          //   self.hereMaps.map.addObject(pickupPin)
          // }
        }
      });

      if (self.hasRsvp(self.rsvp2)) {
        var dropoffMarker = marker.replace('{D}', __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */].pickup.path).replace('{FILL}', __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */].dropoff.fillColor).replace('{STROKE}', __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */].dropoff.strokeColor).replace('{STROKE_WIDTH}', __WEBPACK_IMPORTED_MODULE_2__values_map_pin__["a" /* default */].dropoff.strokeWeight);
        var dropoffIcon = new window.H.map.DomIcon(dropoffMarker);
        var dropoffCoords = { lat: self.rsvp2.dropoff.lat, lng: self.rsvp2.dropoff.lng };
        var dropoffPin = new window.H.map.DomMarker(dropoffCoords, { icon: dropoffIcon });
        // dropoffPin.id = 'pickup-pin'
        self.hereMaps.map.addObject(dropoffPin);
      }

      self.routesQueue = [];
      var pickupAirport = {};
      var index = self.airports.findIndex(function (x) {
        return x.airportCode === self.details.flights.oneway[0].origin.code;
      });
      if (index > -1) pickupAirport = self.airports[index];
      if (self.hasRsvp(self.rsvp1)) {
        self.routesQueue.push({
          origin: {
            lat: self.rsvp1.pickup.lat,
            lng: self.rsvp1.pickup.lng
          },
          destination: {
            lat: pickupAirport.lat,
            lng: pickupAirport.lng
          },
          mode: 'car'
        });
      }

      self.details.flights.oneway.forEach(function (flight) {
        var origin = {};
        var hasError = false;
        var oIndex = self.airports.findIndex(function (x) {
          return x.airportCode === flight.origin.code;
        });
        if (oIndex > -1) origin = self.airports[oIndex];else {
          // let i = allAirports.findIndex(x => x.iata_code === flight.origin.code)
          // if (oIndex === -1 && i > -1) {
          //   let loc = allAirports[i]
          //   origin = loc._geoloc
          // } else{
          hasError = true;
          // }
        }

        var destination = {};
        var dIndex = self.airports.findIndex(function (x) {
          return x.airportCode === flight.destination.code;
        });
        if (dIndex > -1) destination = self.airports[dIndex];else {
          // let i = allAirports.findIndex(x => x.iata_code === flight.destination.code)
          // if (dIndex === -1 && i > -1) {
          //   let loc = allAirports[i]
          //   destination = loc._geoloc
          // } else{
          hasError = true;
          // }
        }

        if (!hasError) {
          self.routesQueue.push({
            origin: {
              lat: origin.lat,
              lng: origin.lng
            },
            destination: {
              lat: destination.lat,
              lng: destination.lng
            },
            mode: 'flight'
          });
        }
      });

      var dropoffAirport = {};
      var index2 = self.airports.findIndex(function (x) {
        return x.airportCode === self.details.flights.oneway[self.details.flights.oneway.length - 1].destination.code;
      });
      if (index2 > -1) dropoffAirport = self.airports[index2];
      if (self.hasRsvp(self.rsvp2)) {
        self.routesQueue.push({
          origin: {
            lat: dropoffAirport.lat,
            lng: dropoffAirport.lng
          },
          destination: {
            lat: self.rsvp2.dropoff.lat,
            lng: self.rsvp2.dropoff.lng
          },
          mode: 'car'
        });
      }

      self.setRoute();
    },
    setRoute: function setRoute() {
      if (!this.routesQueue.length) {
        this.centerMap();
        return;
      }

      var data = this.routesQueue[0];
      if (data.mode === 'car') this.setCarRoute(data);else this.setFlightRoute(data);
    },
    setCarRoute: function setCarRoute(data) {
      var router = this.hereMaps.platform.getRoutingService(null, 8);
      var routeRequestParams = {
        routingMode: 'fast',
        transportMode: 'car',
        origin: data.origin.lat + ',' + data.origin.lng,
        destination: data.destination.lat + ',' + data.destination.lng,
        return: 'polyline,turnByTurnActions,actions,instructions,travelSummary'
      };
      router.calculateRoute(routeRequestParams, this.onCalculateSuccess, this.onCalculateError);
    },
    onCalculateSuccess: function onCalculateSuccess(result) {
      var route = result.routes[0].sections[0];

      var strokeColor = '#333333';
      var linestring = window.H.geo.LineString.fromFlexiblePolyline(route.polyline);
      var polyline = new window.H.map.Polyline(linestring, {
        style: {
          lineWidth: 3,
          strokeColor: strokeColor
        }
      });
      // polyline.id = extraData.type

      this.hereMaps.map.addObject(polyline);
      this.hereMaps.map.getViewModel().setLookAtData({
        bounds: polyline.getBoundingBox()
      });

      this.routesQueue.shift();
      this.setRoute();
    },
    onCalculateError: function onCalculateError(data) {
      console.error('ROUTING ERROR--', data);
    },
    setFlightRoute: function setFlightRoute(data) {
      var lineString = new window.H.geo.LineString();
      lineString.pushPoint({ lat: data.origin.lat, lng: data.origin.lng });
      lineString.pushPoint({ lat: data.destination.lat, lng: data.destination.lng });
      var polyline = new window.H.map.Polyline(lineString, {
        style: { lineWidth: 4 }
      });
      this.hereMaps.map.addObject(polyline);
      this.hereMaps.map.getViewModel().setLookAtData({
        bounds: polyline.getBoundingBox()
      });

      this.routesQueue.shift();
      this.setRoute();
    },
    centerMap: function centerMap() {
      var self = this;
      var group = new window.H.map.Group();

      // Create object with radius for better bounds
      var groupObject = [];
      if (self.hasRsvp(self.rsvp1)) {
        groupObject.push(new window.H.map.Circle(new window.H.geo.Point(self.rsvp1.pickup.lat, self.rsvp1.pickup.lng), 7000, {
          style: {
            fillColor: 'rgba(0, 0, 0, 0)',
            strokeColor: 'rgba(0, 0, 0, 0)'
          }
        }));
      } else {
        var airport = {};
        var index = self.airports.findIndex(function (x) {
          return x.airportCode === self.details.flights.oneway[0].origin.code;
        });
        if (index > -1) {
          airport = self.airports[index];
          groupObject.push(new window.H.map.Circle(new window.H.geo.Point(airport.lat, airport.lng), 7000, {
            style: {
              fillColor: 'rgba(0, 0, 0, 0)',
              strokeColor: 'rgba(0, 0, 0, 0)'
            }
          }));
        }
      }

      if (self.hasRsvp(self.rsvp2)) {
        groupObject.push(new window.H.map.Circle(new window.H.geo.Point(self.rsvp2.dropoff.lat, self.rsvp2.dropoff.lng), 7000, {
          style: {
            fillColor: 'rgba(0, 0, 0, 0)',
            strokeColor: 'rgba(0, 0, 0, 0)'
          }
        }));
      } else {
        var _airport = {};
        var _index = self.airports.findIndex(function (x) {
          return x.airportCode === self.details.flights.oneway[self.details.flights.oneway.length - 1].destination.code;
        });
        if (_index > -1) {
          _airport = self.airports[_index];
          groupObject.push(new window.H.map.Circle(new window.H.geo.Point(_airport.lat, _airport.lng), 7000, {
            style: {
              fillColor: 'rgba(0, 0, 0, 0)',
              strokeColor: 'rgba(0, 0, 0, 0)'
            }
          }));
        }
      }

      // if (!self.hasRsvp(self.rsvp1) && !self.hasRsvp(self.rsvp2)) {
      //   groupObject.push(new window.H.map.Circle(
      //     new window.H.geo.Point(self.rsvp1.pickup.lat, self.rsvp1.pickup.lng),
      //     7000,
      //     {
      //       style: {
      //         fillColor: 'rgba(0, 0, 0, 0)',
      //         strokeColor: 'rgba(0, 0, 0, 0)'
      //       }
      //     }
      //   ))
      // }

      // Add to group for bounds correction
      if (groupObject.length) {
        group.addObjects(groupObject);
        group.id = 'groupBound';
        self.hereMaps.map.addObject(group);

        self.hereMaps.map.getViewModel().setLookAtData({
          bounds: group.getBoundingBox()
        });
      }
    },
    hasRsvp: function hasRsvp(x) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(x).length;
    }
  },
  mounted: function mounted() {
    this.initMap();
  }
});

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'trx',
  data: function data() {
    return {
      lastID: '',
      loading: false,
      error: {
        show: false,
        msg: ''
      }
    };
  },

  computed: {
    id: function id() {
      return this.$route.params.id;
    },
    trx: function trx() {
      return this.$store.state.flightDetails.trx.list;
    }
  },
  methods: {
    getTrx: function getTrx() {
      var self = this;
      if (self.loading || self.id === self.lastID) return;

      self.loading = true;
      self.$sdk.post2({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.d2dGateway + '/admin/d2d/transaction', {
        token: self.$store.state.session.sessionToken,
        d2dId: parseInt(self.id),
        pageSize: 30,
        order: 'createTime',
        desc: true,
        pageNum: 1
      }, function (res) {
        if (res.error) {
          self.$store.commit('flightDetails/setTrxData', { list: [] });
          self.error = {
            show: true,
            msg: res.error.message
          };
          self.loading = false;
          return;
        }

        self.lastID = self.id;
        var trx = [];
        res.list.forEach(function (t) {
          trx.push({
            id: t.id,
            created: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(t.createdUTC).format('MM/DD/YYYY hh:mmA'),
            amount: t.amount / 100,
            stripeChargeId: t.stripeChargeId,
            status: t.status,
            trxType: t.trxType,
            url: t.stripeChargeId ? '' + {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.Stripe.paymentURL + t.stripeChargeId : ''
          });
        });
        self.$store.commit('flightDetails/setTrxData', { list: trx });
        self.loading = false;
      });
    },
    priceFormat: function priceFormat(data) {
      return parseFloat(data).toLocaleString('en-US', { minimumFractionDigits: 2 });
    }
  },
  watch: {},
  mounted: function mounted() {}
});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Partials_LocationInputNEW__ = __webpack_require__(1887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */

// import fdetails from './details'



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'flight-details',
  components: { location: __WEBPACK_IMPORTED_MODULE_1__Partials_LocationInputNEW__["a" /* default */], datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default.a },
  data: function data() {
    return {
      locationExtra: {
        brandId: 10,
        disabled: false
      },
      today: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(),
      error: {
        pickup: '',
        dropoff: '',
        pickupDate: '',
        pickupDateReturn: ''
      }
    };
  },

  computed: {
    airports: function airports() {
      return this.$store.state.airports.list;
    },
    flights: function flights() {
      return this.$store.state.flights;
    },
    create: function create() {
      return this.flights.create;
    },
    pickup: function pickup() {
      return this.create.pickup;
    },
    dropoff: function dropoff() {
      return this.create.dropoff;
    },

    pickupDate: {
      get: function get() {
        return this.create.pickupDate;
      },
      set: function set(x) {
        this.$store.commit('flights/setCreateData', { pickupDate: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(x).format('MM/DD/YYYY') });
      }
    },
    pickupDateReturn: {
      get: function get() {
        return this.create.pickupDateReturn;
      },
      set: function set(x) {
        this.$store.commit('flights/setCreateData', { pickupDateReturn: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(x).format('MM/DD/YYYY') });
      }
    },
    disabledDate: function disabledDate() {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(this.today.subtract(1, 'months').format('YYYY'), this.today.format('MM'), this.today.format('DD'))
        };
      }

      return {
        to: new Date(this.today.format('YYYY'), this.today.subtract(1, 'months').format('MM'), this.today.format('DD'))
      };
    },

    isReturnTrip: {
      get: function get() {
        return this.create.isReturnTrip;
      },
      set: function set(x) {
        this.$store.commit('flights/setCreateData', { isReturnTrip: x });
      }
    }
  },
  methods: {
    getAirportList: function getAirportList() {
      var self = this;
      if (self.airports.length) return;

      self.$store.commit('global/setLoaderData', { show: true, message: '' });
      self.$sdk.get('/airports', {}, function (r) {
        var list = [];
        if (!r.error) {
          r.list.forEach(function (data) {
            var add1 = data.addressLine2 === null ? data.addressLine1 : data.addressLine2;
            var add2 = data.addressLine2 === null ? '' : data.addressLine1;
            var title = add2 + ' ' + add1 + ', ' + data.city + ', ' + data.state + ' ' + data.zipCode;
            if (data.enabled) {
              list.push({
                geofenceId: data.id,
                geofenceType: 'airport',
                address1: add1,
                address2: add2,
                city: data.city,
                lat: data.lat,
                lng: data.lng,
                state: data.state,
                title: data.name || title,
                zip: data.zipCode,
                description: data.description,
                airportCode: data.airportCode,
                locationId: data.locationId
              });
            }
          });
        }
        self.$store.commit('airports/setList', list);
        self.$store.commit('global/setLoaderData', { show: false, message: '' });
      });
    },
    locationUpdate: function locationUpdate(val, field) {
      console.log('#locationUpdate', val, field);
      var tmp = {};
      tmp[field] = val;
      this.$store.commit('flights/setCreateData', tmp);
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(date).format('MM/DD/YYYY');
    },
    departureUpdate: function departureUpdate(val) {
      console.log('#changeFlightDate', val);
    },
    processFlights: function processFlights() {
      this.error = {
        pickup: '',
        dropoff: '',
        pickupDate: '',
        pickupDateReturn: ''
      };
      var hasError = false;
      var emptyField = 'This field cannot be empty.';
      if (!this.pickup.title) {
        hasError = true;
        this.error.pickup = emptyField;
      }
      if (!this.dropoff.title) {
        hasError = true;
        this.error.dropoff = emptyField;
      }
      if (!this.pickupDate) {
        hasError = true;
        this.error.pickupDate = emptyField;
      }
      if (this.isReturnTrip && !this.pickupDateReturn) {
        hasError = true;
        this.error.pickupDateReturn = emptyField;
      }
      var startDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.pickupDate, 'MM/DD/YYYY');
      var endDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.pickupDateReturn, 'MM/DD/YYYY');

      if (this.pickupDate && this.pickupDateReturn && startDate.diff(endDate, 'minutes') > 0) {
        this.error.pickupDate = 'End date must be later than start date.';
        this.error.pickupDateReturn = ' ';
        hasError = true;
      }

      if (hasError) {
        console.log('has error');
        return;
      }
      console.log('PASSED');
    },
    getFlights: function getFlights() {}
  },
  watch: {},
  mounted: function mounted() {
    var i = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.findIndex(function (x) {
      return x.code === 'd2d';
    });
    if (i > -1) this.locationExtra.brandId = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[i].id;

    this.getAirportList();

    // this.today = moment().add(this.d2dTimeBuffer, 'minutes')
    // this.selectedDate = moment().add(this.d2dTimeBuffer, 'minutes').format('MM/DD/YYYY')
    // this.returnDate = moment().add(this.d2dTimeBuffer, 'minutes').add(3, 'days').format('MM/DD/YYYY')
  }
});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */
var request = __webpack_require__(13);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'location-input',
  props: ['value', 'extra', 'checkGeo', 'error'],
  data: function data() {
    return {
      keyInput: '',
      queryToken: null,
      suggestions: [],
      showSuggestion: false,
      loading: false,
      clickOutDelay: '',
      lastSelected: {}
    };
  },

  computed: {},
  methods: {
    query: function query() {
      var self = this;

      var queryText = self.keyInput;
      if (queryText === '') {
        self.queryToken = null;
        self.suggestions = [];
        self.showSuggestion = false;
        return;
      }

      self.showSuggestion = true;
      var restrictedTypes = ['locality', 'postalCodePoint', 'administrativeArea', 'chainQuery', 'categoryQuery'];

      var url = 'https://autosuggest.search.hereapi.com/v1/autosuggest?at={AT}&q={SEARCH}&apiKey={API_KEY}&lang=en-US';
      url = url.replace('{AT}', encodeURIComponent(33.942791 + ',' + -118.410042)).replace('{SEARCH}', queryText).replace('{API_KEY}', {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key);
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err || body.items.length === 0) {
          self.suggestions = [{
            icon: 'fa-exclamation-triangle',
            title: 'Sorry',
            subtitle: 'We coudn\'t locate "' + queryText + '"'
          }];
          return;
        }

        var result = [];
        body.items.forEach(function (prediction) {
          if (restrictedTypes.indexOf(prediction.resultType) === -1) {
            var subtitle = prediction.address.label;
            result.push({
              id: prediction.id,
              title: prediction.title,
              subtitle: subtitle,
              icon: 'fa-map-marker'
            });
          }
        });

        self.suggestions = result.slice(0, 5);
      });
    },
    selectLocation: function selectLocation(index) {
      var self = this;
      var place = self.suggestions[index];
      self.queryToken = null;

      clearTimeout(this.clickOutDelay);
      self.showSuggestion = false;
      self.loading = true;

      var url = 'https://lookup.search.hereapi.com/v1/lookup?source=sharing&id={LOCATION_ID}&locationattributes=tz&apiKey={API_KEY}&lang=en-US';
      url = url.replace('{LOCATION_ID}', place.id).replace('{API_KEY}', {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key);
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) {
          console.log('geocode ERROR', results, status);
          self.loading = false;
          return;
        }

        var result = body;
        var lat = result.position.lat;
        var lng = result.position.lng;
        var finalResult = {
          title: result.title,
          address1: result.address.street || result.title,
          address2: result.address.houseNumber || result.address.district,
          city: result.address.city,
          state: result.address.state,
          zip: result.address.postalCode,
          country: result.address.countryCode,
          lat: lat,
          lng: lng
        };

        self.keyInput = finalResult.title;
        self.lastSelected = finalResult;

        if (self.checkGeo) {
          self.$sdk.get('/geofences/', {
            lat: finalResult.lat,
            lng: finalResult.lng,
            brandId: self.extra.brandId
          }, function (res) {
            self.loading = false;
            if (!res.error) {
              if (res.list.length <= 0) return;

              var _result = res.list[0];
              self.$store.commit('rsvpDetails/setAirportCode', '');

              if (_result.type === 'airport') {
                self.$store.commit('rsvpDetails/setAirportCode', _result.airportCode);

                if (self.extra.field === 'pickup') {
                  self.$store.commit('rsvpDetails/setIsAirportPickup', _result.type === 'airport');
                } else {
                  self.$store.commit('rsvpDetails/setIsAirportDropoff', _result.type === 'airport');
                }
              }

              self.$emit('change', {
                field: self.extra.field,
                keyInput: self.keyInput
              });
            }
          });
        } else {
          self.$emit('change', finalResult);
          self.loading = false;
        }
      });
    },
    clickOut: function clickOut() {
      var self = this;
      self.clickOutDelay = setTimeout(function () {
        self.showSuggestion = false;
      }, 200);
    }
  },
  watch: {
    value: function value(val) {
      this.keyInput = val;
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AdsTable__ = __webpack_require__(1895);
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'marketing-ads',
  components: { AdsTable: __WEBPACK_IMPORTED_MODULE_0__AdsTable__["a" /* default */] }
});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ads-table',
  data: function data() {
    return {
      items: [],
      isMobile: false,
      isLoading: false
    };
  },

  methods: {
    getAds: function getAds() {
      var self = this;
      self.isLoading = true;
      self.items = [];
      self.$sdk.get('/ads', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.isLoading = false;
        if (r.error) {
          // show error
          return;
        }
        for (var i = 0; i < r.list.length; i++) {
          self.items.push(self.formatAd(r.list[i]));
        }
      });
    },
    formatAd: function formatAd(data) {
      var isMilitaryTime = this.$settings.get('MilitaryTime') === '1';
      var start = data.startDate.substr(0, 10) + ' 00:01 AM';
      var end = data.endDate.substr(0, 10) + ' 11:59 PM';
      if (isMilitaryTime) {
        start = data.startDate.substr(0, 10) + ' 00:01';
        end = data.endDate.substr(0, 10) + ' 23:59';
      }

      data.startDateStr = start;
      data.endDateStr = end;
      data.saving = false;
      data.deleting = false;
      return data;
    },
    publish: function publish(ad, index) {
      var self = this;
      ad.token = self.$store.state.session.sessionToken;
      ad.saving = true;
      if (ad.published === 1) {
        ad.published = 0;
      } else {
        ad.published = 1;
      }
      self.$sdk.post('/ads/' + ad.ID, ad, function (r) {
        ad.saving = false;
        if (r.error) {
          return;
        }
      });
    },
    remove: function remove(ad, index) {
      var self = this;
      ad.deleting = true;
      self.$sdk.delete('/ads/' + ad.ID, {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        console.log(r);
        ad.deleting = false;
        if (r.error) {
          return;
        }
        self.items.splice(index, 1);
      });
    },
    setScreenSize: function setScreenSize() {
      var self = this;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || document.documentElement.clientWidth < 431) {
        self.isMobile = true;
      } else {
        self.isMobile = false;
      }
    }
  },
  mounted: function mounted() {
    this.getAds();
    this.setScreenSize();
  }
});

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConsumerAdPreview__ = __webpack_require__(1903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WebAdPreview__ = __webpack_require__(1907);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'consumer-ad-details',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a, ConsumerAdPreview: __WEBPACK_IMPORTED_MODULE_2__ConsumerAdPreview__["a" /* default */], WebAdPreview: __WEBPACK_IMPORTED_MODULE_3__WebAdPreview__["a" /* default */] },
  data: function data() {
    return {
      uploading: {
        excerpt: false,
        main: false
      },
      error: {
        show: false,
        message: ''
      },
      saving: false,
      loading: false,
      done: false,
      success: false
    };
  },

  computed: {
    adId: function adId() {
      return this.$route.params.id;
    },
    original: function original() {
      return this.$store.state.ads.adItem.original;
    },
    brands: function brands() {
      return this.$store.state.brands.list;
    },

    tooltipImage: {
      get: function get() {
        return this.$store.state.ads.adItem.edited.tooltipImage;
      },
      set: function set(value) {
        this.$store.commit('ads/setEditedTooltipImage', value);
      }
    },
    tooltipTitle: {
      get: function get() {
        return this.$store.state.ads.adItem.edited.tooltipTitle;
      },
      set: function set(value) {
        this.$store.commit('ads/setEditedTooltipTitle', value);
      }
    },
    tooltipDescription: {
      get: function get() {
        return this.$store.state.ads.adItem.edited.tooltipDescription;
      },
      set: function set(value) {
        this.$store.commit('ads/setEditedTooltipDescription', value);
      }
    },
    mainImage: {
      get: function get() {
        return this.$store.state.ads.adItem.edited.mainImage;
      },
      set: function set(value) {
        this.$store.commit('ads/setEditedMainImage', value);
      }
    },
    mainHeader: {
      get: function get() {
        return this.$store.state.ads.adItem.edited.mainHeader;
      },
      set: function set(value) {
        this.$store.commit('ads/setEditedMainHeader', value);
      }
    },
    mainTitle: {
      get: function get() {
        return this.$store.state.ads.adItem.edited.mainTitle;
      },
      set: function set(value) {
        this.$store.commit('ads/setEditedMainTitle', value);
      }
    },
    mainBody: {
      get: function get() {
        return this.$store.state.ads.adItem.edited.mainBody;
      },
      set: function set(value) {
        this.$store.commit('ads/setEditedMainBody', value);
      }
    },
    ctaText: {
      get: function get() {
        return this.$store.state.ads.adItem.edited.ctaText;
      },
      set: function set(value) {
        this.$store.commit('ads/setEditedCtaText', value);
      }
    },
    ctaLink: {
      get: function get() {
        return this.$store.state.ads.adItem.edited.ctaLink;
      },
      set: function set(value) {
        this.$store.commit('ads/setEditedCtaLink', value);
      }
    },
    brandId: {
      get: function get() {
        return this.$store.state.ads.adItem.edited.brandId;
      },
      set: function set(value) {
        this.$store.commit('ads/setEditedBrandId', value);
      }
    },
    startDate: {
      get: function get() {
        return this.$store.state.ads.adItem.edited.startDate.toDate();
      },
      set: function set(value) {
        this.$store.commit('ads/setEditedStartDate', __WEBPACK_IMPORTED_MODULE_0_moment___default()(value));
      }
    },
    endDate: {
      get: function get() {
        return this.$store.state.ads.adItem.edited.endDate.toDate();
      },
      set: function set(value) {
        this.$store.commit('ads/setEditedEndDate', __WEBPACK_IMPORTED_MODULE_0_moment___default()(value));
      }
    },
    adType: {
      get: function get() {
        return this.$store.state.ads.adItem.edited.type;
      },
      set: function set(value) {
        this.$store.commit('ads/setEditedType', value);
      }
    }
  },
  methods: {
    getAd: function getAd() {
      var self = this;
      self.$sdk.get('/brand', {}, function (res) {
        self.$store.commit('brands/setLoading', false);
        // self.$store.commit('rsvpDetails/setBrandsLoading', false)
        var brands = [];
        res.forEach(function (data) {
          brands.push({
            id: data.id,
            name: data.name
          });
        });
        self.$store.commit('brands/setList', brands);
        if (self.adId === 'new') {
          console.log('new ad');
          var newAd = {
            ID: -1,
            brandId: -1,
            ctaLink: '',
            ctaText: '',
            mainBody: '',
            mainHeader: '',
            mainTitle: '',
            mainImage: '/assets/img/empty.png',
            tooltipTitle: '',
            tooltipDescription: '',
            tooltipImage: '/assets/img/empty.png',
            startDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(),
            endDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(),
            published: 0,
            type: ''
          };
          self.$store.commit('ads/setOriginalAdItem', newAd);
          self.$store.commit('ads/setEditedAdItem', newAd);
          return;
        }
        self.$sdk.get('/ads/' + self.adId, {
          token: self.$store.state.session.sessionToken
        }, function (r) {
          if (r.error) {
            // show error
            return;
          }
          var startDateStr = r.startDate.substr(0, 10) + ' 00:01';
          var endDateStr = r.endDate.substr(0, 10) + ' 23:59';
          r.startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDateStr, 'YYYY-MM-DD HH:mm');
          r.endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(endDateStr, 'YYYY-MM-DD HH:mm');
          self.$store.commit('ads/setOriginalAdItem', r);
          self.$store.commit('ads/setEditedAdItem', r);
        });
      });
    },
    uploadImage: function uploadImage(e, isExcerpt) {
      var self = this;

      var file = e.target.files[0];
      var fd = new FormData();
      fd.append('pic', file);

      if (isExcerpt) {
        self.uploading.excerpt = true;
      } else {
        self.uploading.main = true;
      }
      self.$http.post({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.mediaHost + '/api/upload', fd, {
        header: { 'Content-Type': 'multipart/form-data' }
      }).then(function (res) {
        var imageUrl = res.body.data.url;
        if (isExcerpt) {
          self.$store.commit('ads/setEditedTooltipImage', imageUrl);
        } else {
          self.$store.commit('ads/setEditedMainImage', imageUrl);
        }
        self.uploading.excerpt = false;
        self.uploading.main = false;
      }, function (res) {
        console.log('error ad image upload', res);
        self.uploading.excerpt = false;
        self.uploading.main = false;
      });
    },
    isValid: function isValid() {
      var self = this;
      if (self.tooltipImage === '' || self.tooltipImage === '/assets/img/empty.png') {
        self.error.show = true;
        self.error.message = 'Excerpt Image is required.';
        return false;
      }
      if (self.mainImage === '' || self.mainImage === '/assets/img/empty.png') {
        self.error.show = true;
        self.error.message = 'Content Image is required.';
        return false;
      }
      if (self.tooltipTitle === '') {
        self.error.show = true;
        self.error.message = 'Excerpt Title is required.';
        return false;
      }
      if (self.tooltipDescription === '') {
        self.error.show = true;
        self.error.message = 'Excerpt Message is required.';
        return false;
      }
      if (self.mainHeader === '') {
        self.error.show = true;
        self.error.message = 'Page Title is required.';
        return false;
      }
      if (self.mainTitle === '') {
        self.error.show = true;
        self.error.message = 'Content Title is required.';
        return false;
      }
      if (self.mainBody === '') {
        self.error.show = true;
        self.error.message = 'Content Body is required.';
        return false;
      }
      if (self.ctaText === '') {
        self.error.show = true;
        self.error.message = 'CTA Text is required.';
        return false;
      }
      if (self.adType === '') {
        self.error.show = true;
        self.error.message = 'Ad Type is required.';
        return false;
      }
      if (self.brandId === -1) {
        self.error.show = true;
        self.error.message = 'Brand is required.';
        return false;
      }
      var startDate = self.$store.state.ads.adItem.edited.startDate;
      var endDate = self.$store.state.ads.adItem.edited.endDate;
      if (endDate.isBefore(startDate)) {
        self.error.show = true;
        self.error.message = 'End Date must be after Start Date.';
        return false;
      }
      self.error.show = false;
      self.error.message = '';
      return true;
    },
    save: function save() {
      var self = this;
      if (!self.isValid()) {
        return;
      }
      // 2018-08-08 00:01:00
      var startDate = self.$store.state.ads.adItem.edited.startDate.format('YYYY-MM-DD') + ' 00:01:00';
      var endDate = self.$store.state.ads.adItem.edited.endDate.format('YYYY-MM-DD') + ' 23:59:00';

      var request = {
        token: self.$store.state.session.sessionToken,
        type: self.adType,
        brandId: self.brandId,
        tooltipImage: self.tooltipImage,
        tooltipTitle: self.tooltipTitle,
        tooltipDescription: self.tooltipDescription,
        mainHeader: self.mainHeader,
        mainImage: self.mainImage,
        mainTitle: self.mainTitle,
        mainBody: self.mainBody,
        ctaText: self.ctaText,
        ctaLink: self.ctaLink,
        published: 0,
        startDate: startDate,
        endDate: endDate
      };
      var url = '/ads';
      if (self.adId !== 'new') {
        url = '/ads/' + self.adId;
      }
      self.loading = true;
      self.done = false;
      self.success = false;
      self.$sdk.post(url, request, function (r) {
        self.done = true;
        if (r.error) {
          self.success = false;
          setTimeout(function () {
            self.loading = false;
          }, 1500);
          return;
        }
        self.success = true;
        setTimeout(function () {
          self.$router.push('/ads');
        }, 1500);
      });
    }
  },
  watch: {
    adId: function adId(value) {
      this.getAd();
    }
  },
  mounted: function mounted() {
    this.getAd();
  }
});

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'consumer-ad-preview',
  computed: {
    ad: function ad() {
      return this.$store.state.ads.adItem.edited;
    }
  }
});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'web-ad-preview',
  computed: {
    ad: function ad() {
      return this.$store.state.ads.adItem.edited;
    }
  }
});

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FilterTable__ = __webpack_require__(1915);
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'filters',
  components: { FilterTable: __WEBPACK_IMPORTED_MODULE_0__FilterTable__["a" /* default */] },
  methods: {
    getFilters: function getFilters() {
      console.log('filter table GET');
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$sdk.get('/admin/filters', {
      token: self.$store.state.session.sessionToken
    }, function (r) {
      console.log('FILTERS', r);
      if (r.error) {
        return;
      }
      self.$store.commit('filters/setFilterTable', r.list);
    });
  }
});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Partials_LoadingModal__ = __webpack_require__(49);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'filter-table',
  components: { LoadingModal: __WEBPACK_IMPORTED_MODULE_0__Partials_LoadingModal__["a" /* default */] },
  data: function data() {
    return {
      deleteFilter: {
        show: false,
        id: null,
        name: null,
        deleting: false
      },
      isMobile: false
    };
  },

  computed: {
    items: function items() {
      return this.$store.state.filters.filterTable;
    }
  },
  methods: {
    capitalize: function capitalize(text) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
    getItemsToDisplay: function getItemsToDisplay(items) {
      var result = {
        items: [],
        more: null
      };

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (item.name) {
          result.items.push(item.name);
        } else {
          if (item.name === null) {
            result.items.push('');
          } else {
            result.items.push(this.capitalize(item));
          }
        }

        if (i > 3) {
          break;
        }
      }

      if (items.length > 5) {
        result.more = '+ ' + (items.length - 5) + ' more';
      }

      return result;
    },
    confirmDelete: function confirmDelete(id, name) {
      var self = this;
      self.deleteFilter.show = true;
      self.deleteFilter.id = id;
      self.deleteFilter.name = name;
    },
    executeDelete: function executeDelete() {
      var self = this;
      self.deleteFilter.deleting = true;
      self.deleteFilter.show = false;
      self.$sdk.delete('/admin/filters/' + self.deleteFilter.id, {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          return;
        }
        window.location.reload();
      });
    },
    setScreenSize: function setScreenSize() {
      var self = this;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        self.isMobile = true;
      } else {
        self.isMobile = false;
      }
    }
  },
  mounted: function mounted() {
    this.setScreenSize();
  }
});

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Partials_LoadingModal__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_brands__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_services__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'filter-details',
  components: { LoadingModal: __WEBPACK_IMPORTED_MODULE_1__Partials_LoadingModal__["a" /* default */] },
  data: function data() {
    return {
      fetchingFilter: false,
      savingFilter: false,
      filter: null,
      editedFilter: null,
      serviceAreas: [],
      stagingLots: [],
      formErrors: {
        name: false,
        beforePickupMins: false,
        afterPickupMins: false,
        tripDirection: false,
        rsvpStatus: false,
        bidSource: false,
        serviceTypes: false,
        ada: false,
        serviceAreas: false
      },
      brandLoading: false,
      selectedService: []
    };
  },

  computed: {
    filterId: function filterId() {
      return this.$route.params.id;
    },
    brands: function brands() {
      return this.$store.state.brands.list;
    },

    checkedAllTripDirection: {
      get: function get() {
        var self = this;
        if (self.editedFilter === null) {
          return false;
        }
        if (self.editedFilter.tripDirection.length === 4) {
          return true;
        }

        var result = [];
        for (var i = 0; i < self.editedFilter.tripDirection.length; i++) {
          var item = self.editedFilter.tripDirection[i];
          if (item === 'all') {
            continue;
          }
          result.push(item);
        }
        self.editedFilter.tripDirection = result;
        return false;
      },
      set: function set(value) {
        var self = this;
        if (value) {
          self.editedFilter.tripDirection = ['all', 'p2p', 'in', 'out'];
        } else {
          self.editedFilter.tripDirection = [];
        }
      }
    },
    checkedAllRsvpStatus: {
      get: function get() {
        var self = this;
        if (self.editedFilter === null) {
          return false;
        }
        if (self.editedFilter.rsvpStatus.length === 13) {
          return true;
        }

        var result = [];
        for (var i = 0; i < self.editedFilter.rsvpStatus.length; i++) {
          var item = self.editedFilter.rsvpStatus[i];
          if (item === 'all') {
            continue;
          }
          result.push(item);
        }
        console.log('TEST', result);
        self.editedFilter.rsvpStatus = result;
        return false;
      },
      set: function set(value) {
        var self = this;
        if (value) {
          self.editedFilter.rsvpStatus = ['all', 'upcoming', 'auto-dispatch', 'ready', 'require-dispatch', 'driver-response', 'dispatched', 'onboard', 'completed', 'cancelled', 'packaged', 'un-packaged', 'none'];
        } else {
          self.editedFilter.rsvpStatus = [];
        }
      }
    }
  },
  methods: {
    init: function init() {
      var self = this;
      self.initGeofences();
      if (self.filterId === 'new') {
        self.filter = {
          name: '',
          beforePickupMins: 0,
          afterPickupMins: 0,
          tripDirection: [],
          rsvpStatus: [],
          geofenceIds: [],
          stagingLotIds: [],
          ada: [],
          defaultPickupAddress: '',
          defaultPickupType: 'address',
          defaultGeofenceId: null,
          bidSource: [],
          serviceTypes: [],
          packageStatus: null
        };
        self.editedFilter = {
          name: '',
          beforePickupMins: 0,
          afterPickupMins: 0,
          tripDirection: [],
          rsvpStatus: [],
          geofenceIds: [],
          stagingLotIds: [],
          ada: [],
          defaultPickupAddress: '',
          defaultPickupType: 'address',
          defaultGeofenceId: null,
          bidSource: [],
          serviceTypes: [],
          packageStatus: null
        };
        return;
      }

      self.fetchingFilter = true;

      self.$sdk.get('/admin/filters/' + self.filterId, {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.fetchingFilter = false;
        console.log('FILTER', r);
        if (r.error) {
          // TODO: show error message
          return;
        }

        self.filter = r;
        self.editedFilter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, r);
      });
    },
    initGeofences: function initGeofences() {
      var self = this;
      self.$sdk.get('/geofences', {}, function (r) {
        console.log('GEOFENCES', r);
        if (r.error || r.list.length <= 0) {
          return;
        }
        self.serviceAreas = [];
        var serviceAreas = r.list.filter(function (x) {
          return x.type === 'servicearea';
        });
        serviceAreas.forEach(function (data) {
          self.serviceAreas.push({
            brand: '',
            id: data.id,
            name: data.name
          });
        });

        self.stagingLots = [];
        var stagingLots = r.list.filter(function (x) {
          return x.type === 'staging';
        });
        stagingLots.forEach(function (data) {
          self.stagingLots.push({
            id: data.id,
            name: data.name
          });
        });

        var request = {
          token: self.$store.state.session.sessionToken,
          status: 'active',
          pageNum: 1,
          pageSize: 9999,
          order: 'priority',
          brandId: -2
        };
        self.$sdk.get('/servicearea', request, function (r2) {
          r2.list.forEach(function (data) {
            if (data.brandId) {
              self.serviceAreas.push({
                brand: data.brandId,
                id: data.id,
                name: data.name
              });
            }
          });
        }, '2.0');
      });
    },
    getServiceTypes: function getServiceTypes() {
      var serviceId = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.serviceId;
      var result = [];

      for (var prop in serviceId) {
        if (!serviceId.hasOwnProperty(prop)) {
          return;
        }

        var serviceName = prop.charAt(0).toUpperCase() + prop.slice(1);
        if (prop === 'shared') {
          serviceName = 'Shared Ride';
        } else if (prop === 'opoli') {
          serviceName = 'Direct Non-Stop';
        } else if (prop === 'black') {
          serviceName = 'Sedan';
        } else if (prop === 'suv') {
          serviceName = 'SUV';
        } else {
          serviceName = 'Private Van';
        }
        result.push({
          name: serviceName,
          id: serviceId[prop]
        });
      }
      return result;
    },
    serviceList: function serviceList(brandId) {
      var serviceList = this.$store.state.services.list.filter(function (x) {
        return x.brandId === brandId && x.enabled;
      });
      return serviceList;
    },
    unbrandedServicearea: function unbrandedServicearea() {
      return this.serviceAreas.filter(function (x) {
        return x.brand === '';
      });
    },
    brandedServicearea: function brandedServicearea(brandId) {
      return this.serviceAreas.filter(function (x) {
        return x.brand === brandId;
      });
    },
    save: function save() {
      var self = this;
      self.formErrors = {
        name: false,
        beforePickupMins: false,
        afterPickupMins: false,
        tripDirection: false,
        rsvpStatus: false,
        bidSource: false,
        serviceTypes: false,
        ada: false,
        serviceAreas: false
      };
      if (self.editedFilter.name === '') {
        self.formErrors.name = true;
        return;
      }
      if (self.editedFilter.beforePickupMins <= 0) {
        self.formErrors.beforePickupMins = true;
        return;
      }
      if (self.editedFilter.afterPickupMins <= 0) {
        self.formErrors.afterPickupMins = true;
        return;
      }
      if (self.editedFilter.tripDirection.length <= 0) {
        self.formErrors.tripDirection = true;
        return;
      }
      if (self.editedFilter.rsvpStatus.length <= 0) {
        self.formErrors.rsvpStatus = true;
        return;
      }
      if (self.editedFilter.bidSource.length <= 0) {
        self.formErrors.bidSource = true;
        return;
      }
      if (self.editedFilter.serviceTypes.length <= 0) {
        self.formErrors.serviceTypes = true;
        return;
      }
      if (self.editedFilter.ada.length <= 0) {
        self.formErrors.ada = true;
        return;
      }
      if (self.editedFilter.geofenceIds.length <= 0) {
        self.formErrors.serviceAreas = true;
        return;
      }

      self.savingFilter = true;

      var request = self.editedFilter;
      request['token'] = self.$store.state.session.sessionToken;
      if (self.filterId === 'new') {
        self.$sdk.post('/admin/filters', request, function (r) {
          console.log('NEW', r);
          if (r.error) {
            return;
          }
          self.$router.push({ name: 'Filters' });
        });
        return;
      }

      self.$sdk.post('/admin/filters/' + self.filterId, request, function (r) {
        console.log('EDIT', r);
        if (r.error) {
          return;
        }
        window.location.reload();
      });
    }
  },
  watch: {
    filterId: function filterId(value) {
      this.init();
    }
  },
  mounted: function mounted() {
    var self = this;
    self.init();

    if (!self.$store.state.brands.list.length) {
      self.brandLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__modules_api_brands__["a" /* default */].getBrands(self, function (res) {
        self.brandLoading = false;
      });
    }

    if (!self.$store.state.services.list.length) {
      self.$store.commit('services/setServiceLoading', true);
      __WEBPACK_IMPORTED_MODULE_3__modules_api_services__["a" /* default */].getAllService(self, function (r) {
        self.$store.commit('services/setServiceLoading', false);
      });
    }
  }
});

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__settings_config_index__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SettingsGroup__ = __webpack_require__(1971);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'settings',
  components: { SettingsGroup: __WEBPACK_IMPORTED_MODULE_1__SettingsGroup__["a" /* default */] },
  data: function data() {
    return {
      saving: false,
      success: false
    };
  },

  methods: {
    getGroup: function getGroup(index) {
      var object = __WEBPACK_IMPORTED_MODULE_0__settings_config_index__["a" /* default */][index];
      var result = [];
      for (var property in object) {
        if (!object.hasOwnProperty(property)) {
          continue;
        }
        result.push({
          key: property,
          object: object[property]
        });
      }
      return result;
    },
    getKeys: function getKeys(object) {
      var result = [];
      for (var property in object) {
        if (!object.hasOwnProperty(property)) {
          continue;
        }
        result.push(property);
      }
      return result;
    },
    save: function save() {
      var self = this;

      self.saving = true;
      self.success = false;
      self.$sdk.post('/settings', {
        token: self.$store.state.session.sessionToken,
        settings: self.buildRequest()
      }, function (r) {
        self.saving = false;
        console.log(r);
        if (r.error) {
          return;
        }
        self.success = true;
        setTimeout(function () {
          self.success = false;
        }, 2000);
      });
    },
    buildRequest: function buildRequest() {
      var self = this;
      var config = self.$store.state.settingsPage.configuration;

      var result = {};
      for (var key in config) {
        if (!config.hasOwnProperty(key)) {
          continue;
        }
        result[key] = config[key].value;
      }

      return result;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$sdk.get('/settings', {}, function (r) {
      if (r.error) {
        console.log('ERROR', r);
        return;
      }
      self.$store.commit('settingsPage/setConfiguration', r);
    });
  }
});

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__industry_settings__ = __webpack_require__(1927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__provider_cancellation_fees__ = __webpack_require__(1928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__provider_payment_bonus__ = __webpack_require__(1929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__provider_availability_settings__ = __webpack_require__(1930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__provider_profile_settings__ = __webpack_require__(1931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asap_availability__ = __webpack_require__(1932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__exclusive_ride_settings__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__provider_arrival_completed_proximity__ = __webpack_require__(1934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__time_delay_settings__ = __webpack_require__(1935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__referral_code_settings__ = __webpack_require__(1936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__offer_settings__ = __webpack_require__(1937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__version_settings__ = __webpack_require__(1938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__staging_lot_settings__ = __webpack_require__(1939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__auto_dispatch__ = __webpack_require__(1940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__auto_package_runs__ = __webpack_require__(1941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__auto_dispatch_runs__ = __webpack_require__(1942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__kiosk_app_settings__ = __webpack_require__(1943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__auto_package_settings__ = __webpack_require__(1944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__shared_time_availability__ = __webpack_require__(1945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__airport_suggested_pickup_time__ = __webpack_require__(1946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__driver_bad_rating_notification__ = __webpack_require__(1947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__dispatch_notification_settings__ = __webpack_require__(1948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__dispatch_settings__ = __webpack_require__(1949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__rsvp_pool_settings__ = __webpack_require__(1950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__rsvp_optin_settings__ = __webpack_require__(1951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__transportation_timeout_settings__ = __webpack_require__(1952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__hotel_timeout_settings__ = __webpack_require__(1953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__offer_limits__ = __webpack_require__(1954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__url_settings__ = __webpack_require__(1955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__geofence_universal_settings__ = __webpack_require__(1956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__website_rsvp_form__ = __webpack_require__(1957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__reservation_settings__ = __webpack_require__(1958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__cancellation_fees__ = __webpack_require__(1959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__consumer_clients__ = __webpack_require__(1960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__military_time__ = __webpack_require__(1961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__fraud_detection__ = __webpack_require__(1962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pickuptime_offsets__ = __webpack_require__(1963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__corporate_profile__ = __webpack_require__(1964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__mtech_settings__ = __webpack_require__(1965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__provider_work_limit__ = __webpack_require__(1966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__tight_route__ = __webpack_require__(1967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__d2d_settings__ = __webpack_require__(1968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__lyft_settings__ = __webpack_require__(1969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__rental__ = __webpack_require__(1970);














































var col1 = {
  // IndustrySettings,
  ProviderCancellationFees: __WEBPACK_IMPORTED_MODULE_1__provider_cancellation_fees__["a" /* default */],
  ProviderPaymentBonus: __WEBPACK_IMPORTED_MODULE_2__provider_payment_bonus__["a" /* default */],
  ProviderAvailabilitySettings: __WEBPACK_IMPORTED_MODULE_3__provider_availability_settings__["a" /* default */],
  ProviderProfileSettings: __WEBPACK_IMPORTED_MODULE_4__provider_profile_settings__["a" /* default */],
  AsapAvailabilitySettings: __WEBPACK_IMPORTED_MODULE_5__asap_availability__["a" /* default */],
  ExclusiveRideSettings: __WEBPACK_IMPORTED_MODULE_6__exclusive_ride_settings__["a" /* default */],
  ProviderArrivalCompletedProximity: __WEBPACK_IMPORTED_MODULE_7__provider_arrival_completed_proximity__["a" /* default */],
  TimeDelaySettings: __WEBPACK_IMPORTED_MODULE_8__time_delay_settings__["a" /* default */],
  ReferralCodeSettings: __WEBPACK_IMPORTED_MODULE_9__referral_code_settings__["a" /* default */],
  OfferSettings: __WEBPACK_IMPORTED_MODULE_10__offer_settings__["a" /* default */],
  VersionSettings: __WEBPACK_IMPORTED_MODULE_11__version_settings__["a" /* default */],
  StagingLotSettings: __WEBPACK_IMPORTED_MODULE_12__staging_lot_settings__["a" /* default */],
  AutoDispatch: __WEBPACK_IMPORTED_MODULE_13__auto_dispatch__["a" /* default */],
  AutoDispatchRuns: __WEBPACK_IMPORTED_MODULE_15__auto_dispatch_runs__["a" /* default */],
  AutoPackageRuns: __WEBPACK_IMPORTED_MODULE_14__auto_package_runs__["a" /* default */],
  AutoPackageSettings: __WEBPACK_IMPORTED_MODULE_17__auto_package_settings__["a" /* default */],
  ProviderWorkLimit: __WEBPACK_IMPORTED_MODULE_39__provider_work_limit__["a" /* default */],
  TightRoute: __WEBPACK_IMPORTED_MODULE_40__tight_route__["a" /* default */],
  KioskAppSettings: __WEBPACK_IMPORTED_MODULE_16__kiosk_app_settings__["a" /* default */],
  SharedTimeAvailability: __WEBPACK_IMPORTED_MODULE_18__shared_time_availability__["a" /* default */],
  AirportSuggestedPickupTime: __WEBPACK_IMPORTED_MODULE_19__airport_suggested_pickup_time__["a" /* default */],
  DriverBadRatingNotification: __WEBPACK_IMPORTED_MODULE_20__driver_bad_rating_notification__["a" /* default */],
  DispatchNotificationSettings: __WEBPACK_IMPORTED_MODULE_21__dispatch_notification_settings__["a" /* default */],
  DispatchSettings: __WEBPACK_IMPORTED_MODULE_22__dispatch_settings__["a" /* default */],
  MtechSettings: __WEBPACK_IMPORTED_MODULE_38__mtech_settings__["a" /* default */],
  Rental: __WEBPACK_IMPORTED_MODULE_43__rental__["a" /* default */],
  LyftSettings: __WEBPACK_IMPORTED_MODULE_42__lyft_settings__["a" /* default */]
};

var col2 = {
  RsvpPoolSettings: __WEBPACK_IMPORTED_MODULE_23__rsvp_pool_settings__["a" /* default */],
  RsvpOptinSettings: __WEBPACK_IMPORTED_MODULE_24__rsvp_optin_settings__["a" /* default */],
  TransportationTimeoutSettings: __WEBPACK_IMPORTED_MODULE_25__transportation_timeout_settings__["a" /* default */],
  HotelTimeoutSettings: __WEBPACK_IMPORTED_MODULE_26__hotel_timeout_settings__["a" /* default */],
  OfferLimits: __WEBPACK_IMPORTED_MODULE_27__offer_limits__["a" /* default */],
  URLSettings: __WEBPACK_IMPORTED_MODULE_28__url_settings__["a" /* default */],
  GeofenceUniversalSettings: __WEBPACK_IMPORTED_MODULE_29__geofence_universal_settings__["a" /* default */],
  WebsiteRSVPForm: __WEBPACK_IMPORTED_MODULE_30__website_rsvp_form__["a" /* default */],
  ReservationSettings: __WEBPACK_IMPORTED_MODULE_31__reservation_settings__["a" /* default */],
  CancellationFees: __WEBPACK_IMPORTED_MODULE_32__cancellation_fees__["a" /* default */],
  ConsumerClients: __WEBPACK_IMPORTED_MODULE_33__consumer_clients__["a" /* default */],
  MilitaryTime: __WEBPACK_IMPORTED_MODULE_34__military_time__["a" /* default */],
  FraudDetection: __WEBPACK_IMPORTED_MODULE_35__fraud_detection__["a" /* default */],
  PickupTimeOffsets: __WEBPACK_IMPORTED_MODULE_36__pickuptime_offsets__["a" /* default */],
  CorporateProfile: __WEBPACK_IMPORTED_MODULE_37__corporate_profile__["a" /* default */],
  D2DSettings: __WEBPACK_IMPORTED_MODULE_41__d2d_settings__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ([col1, col2]);

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__settings_config_index__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controls_Dropdown__ = __webpack_require__(1974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__controls_InputInteger__ = __webpack_require__(1978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__controls_InputString__ = __webpack_require__(1982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__controls_RadioBoolean__ = __webpack_require__(1986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__controls_PickupTimeOffsets__ = __webpack_require__(1990);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'settings-group',
  props: ['groupKey', 'groupTitle', 'itemKeys', 'column'],
  components: { Dropdown: __WEBPACK_IMPORTED_MODULE_1__controls_Dropdown__["a" /* default */], InputString: __WEBPACK_IMPORTED_MODULE_3__controls_InputString__["a" /* default */], InputInteger: __WEBPACK_IMPORTED_MODULE_2__controls_InputInteger__["a" /* default */], RadioBoolean: __WEBPACK_IMPORTED_MODULE_4__controls_RadioBoolean__["a" /* default */], PickupTimeOffsets: __WEBPACK_IMPORTED_MODULE_5__controls_PickupTimeOffsets__["a" /* default */] },
  methods: {
    getConfig: function getConfig(key) {
      return __WEBPACK_IMPORTED_MODULE_0__settings_config_index__["a" /* default */][this.column][this.groupKey].items[key];
    }
  }
});

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dropdown',
  props: ['settingKey', 'values'],
  computed: {
    dropdownValue: {
      get: function get() {
        var configuration = this.$store.state.settingsPage.configuration;
        if (this.settingKey in configuration) {
          var result = configuration[this.settingKey].value;
          return configuration[this.settingKey].value;
        }
        return '';
      },
      set: function set(value) {
        var item = {
          key: this.settingKey,
          value: value
        };
        this.$store.commit('settingsPage/setConfigurationItem', item);
      }
    }
  }
});

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'input-integer',
  props: ['settingKey', 'unit', 'extra', 'removeMT'],
  computed: {
    integerValue: {
      get: function get() {
        var configuration = this.$store.state.settingsPage.configuration;
        if (this.settingKey in configuration) {
          return configuration[this.settingKey].value;
        }
        return '';
      },
      set: function set(value) {
        var item = {
          key: this.settingKey,
          value: value
        };
        this.$store.commit('settingsPage/setConfigurationItem', item);
      }
    }
  }
});

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'input-string',
  props: ['settingKey', 'unit'],
  computed: {
    stringValue: {
      get: function get() {
        var configuration = this.$store.state.settingsPage.configuration;
        if (this.settingKey in configuration) {
          return configuration[this.settingKey].value;
        }
        return '';
      },
      set: function set(value) {
        var item = {
          key: this.settingKey,
          value: value
        };
        this.$store.commit('settingsPage/setConfigurationItem', item);
      }
    }
  }
});

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio-boolean',
  props: ['settingKey'],
  computed: {
    booleanValue: {
      get: function get() {
        var configuration = this.$store.state.settingsPage.configuration;
        if (this.settingKey in configuration) {
          var result = configuration[this.settingKey].value;
          return configuration[this.settingKey].value;
        }
        return 0;
      },
      set: function set(value) {
        var item = {
          key: this.settingKey,
          value: value
        };
        this.$store.commit('settingsPage/setConfigurationItem', item);
      }
    }
  }
});

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pickuptime-offsets',
  props: ['settingKey'],
  data: function data() {
    return {
      items: [],
      showFieldModal: false,
      fieldItem: {
        dayOfWeek: 0,
        timeFromHH: '00',
        timeFromMM: '00',
        timeToHH: '00',
        timeToMM: '00',
        offset: 0
      },
      indexToEdit: -1
    };
  },

  computed: {
    stringValue: function stringValue() {
      var configuration = this.$store.state.settingsPage.configuration;
      if (this.settingKey in configuration) {
        return configuration[this.settingKey].value;
      }
      return '';
    }
  },
  methods: {
    edit: function edit(index) {
      var self = this;
      if (index < 0) {
        self.fieldItem = {
          dayOfWeek: 0,
          timeFromHH: '00',
          timeFromMM: '00',
          timeToHH: '00',
          timeToMM: '00',
          offset: 0
        };
      } else {
        var item = self.items[index];
        var timeFrom = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.timeFrom, 'HHmm');
        var timeTo = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.timeTo, 'HHmm');
        self.fieldItem = {
          dayOfWeek: item.dayOfWeek,
          timeFromHH: timeFrom.format('HH'),
          timeFromMM: timeFrom.format('mm'),
          timeToHH: timeTo.format('HH'),
          timeToMM: timeTo.format('mm'),
          offset: parseInt(item.offset)
        };
      }
      self.indexToEdit = index;
      self.showFieldModal = true;
    },
    remove: function remove(index) {
      var self = this;
      if (index >= 0) {
        self.items.splice(index, 1);
      }
      self.writeToStore();
    },
    save: function save() {
      var self = this;

      var item = '' + self.fieldItem.dayOfWeek;
      item += self.fieldItem.timeFromHH;
      item += self.fieldItem.timeFromMM;
      item += self.fieldItem.timeToHH;
      item += self.fieldItem.timeToMM;
      item += self.fieldItem.offset;
      var configItem = {
        dayOfWeek: parseInt(item.charAt(0)),
        timeFrom: item.substring(1, 5),
        timeTo: item.substring(5, 9),
        offset: item.substring(9),
        dayString: __WEBPACK_IMPORTED_MODULE_0_moment___default()(parseInt(item.charAt(0)), 'd').format('ddd'),
        timeFromString: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.substring(1, 5), 'HHmm').format('hh:mmA'),
        timeToString: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.substring(5, 9), 'HHmm').format('hh:mmA')
      };
      if (self.indexToEdit >= 0) {
        self.items[self.indexToEdit] = configItem;
      } else {
        self.items.push(configItem);
      }

      self.writeToStore();
      self.showFieldModal = false;
    },
    writeToStore: function writeToStore() {
      var self = this;
      var result = '';
      for (var i = 0; i < self.items.length; i++) {
        var item = self.items[i];
        result += item.dayOfWeek;
        result += item.timeFrom;
        result += item.timeTo;
        result += item.offset;
        if (i < self.items.length - 1) {
          result += ',';
        }
      }

      var configItem = {
        key: self.settingKey,
        value: result
      };
      self.$store.commit('settingsPage/setConfigurationItem', configItem);
    }
  },
  watch: {
    stringValue: function stringValue(value) {
      var self = this;
      if (value === '') {
        self.items = [];
        return;
      }

      self.items = [];
      var stringItems = value.split(',');
      for (var i = 0; i < stringItems.length; i++) {
        var item = stringItems[i].trim();
        if (item === '') {
          continue;
        }

        self.items.push({
          dayOfWeek: parseInt(item.charAt(0)),
          timeFrom: item.substring(1, 5),
          timeTo: item.substring(5, 9),
          offset: item.substring(9),
          dayString: __WEBPACK_IMPORTED_MODULE_0_moment___default()(parseInt(item.charAt(0)), 'd').format('ddd'),
          timeFromString: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.substring(1, 5), 'HHmm').format('hh:mmA'),
          timeToString: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.substring(5, 9), 'HHmm').format('hh:mmA')
        });
      }
    }
  }
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map__ = __webpack_require__(1999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map2__ = __webpack_require__(2003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShiftForm__ = __webpack_require__(2011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SectorList__ = __webpack_require__(2015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_api_services__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'coverage',
  components: { CoverageMap: __WEBPACK_IMPORTED_MODULE_0__Map__["a" /* default */], CoverageMap2: __WEBPACK_IMPORTED_MODULE_1__Map2__["a" /* default */], CoverageShiftForm: __WEBPACK_IMPORTED_MODULE_2__ShiftForm__["a" /* default */], SectorList: __WEBPACK_IMPORTED_MODULE_3__SectorList__["a" /* default */] },
  // components: { CoverageMap, CoverageShiftForm, SectorList },
  mounted: function mounted() {
    var self = this;

    var services = self.$store.state.services;
    if (!services.list.length && !services.serviceLoading) {
      self.$store.commit('services/setServiceLoading', true);
      __WEBPACK_IMPORTED_MODULE_4__modules_api_services__["a" /* default */].getAllService(self, function (r) {
        self.$store.commit('services/setServiceLoading', false);
      });
    }
  }
});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__values_map_settings__ = __webpack_require__(51);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'coverage-map',
  data: function data() {
    return {
      mapOptions: __WEBPACK_IMPORTED_MODULE_1__values_map_settings__["a" /* default */],
      center: { lat: 33.942791, lng: -118.410042 }, // LAX
      map: {
        labelBackground: {
          url: '',
          anchor: {
            x: 135,
            y: 20
          },
          scaledSize: {
            width: 270,
            height: 40
          }
        },
        poiPin: {
          url: 'https://s3-us-west-2.amazonaws.com/mobile-consumer-app/maps/pins/poi.png',
          anchor: {
            x: 15,
            y: 15
          },
          scaledSize: {
            width: 30,
            height: 30
          }
        }
      },
      path: {
        base: [],
        animated: [],
        animationID: null
      },
      drivers: {
        sector: [],
        nearby: []
      },
      noDrivers: false,
      infoWindows: {
        pickup: false,
        dropoff: false
      },
      rsvpInfo: {
        pickupTime: null,
        dropoffTime: null,
        distanceInMiles: null
      },
      stopsInfo: [],
      modal: {
        show: false,
        loading: false,
        loadingMessage: '',
        success: false,
        doneMessage: ''
      }
    };
  },

  computed: {
    rsvp: function rsvp() {
      return this.$store.state.coverage.map.rsvp;
    },
    showPolygons: function showPolygons() {
      return this.$store.state.coverage.map.showPolygons;
    },
    sectorItems: function sectorItems() {
      var result = [];
      var sectors = this.$store.state.coverage.sectors.items;
      for (var i = 0; i < sectors.length; i++) {
        result.push(sectors[i]);
      }
      return result;
    },
    hasUntrackedDrivers: function hasUntrackedDrivers() {
      var self = this;
      for (var i = 0; i < self.drivers.sector.length; i++) {
        var driver = self.drivers.sector[i];
        if (driver.location === null) {
          return true;
        }
      }

      return false;
    },
    hasAvailableDrivers: function hasAvailableDrivers() {
      var self = this;
      for (var i = 0; i < self.drivers.sector.length; i++) {
        var driver = self.drivers.sector[i];
        if (driver.shiftStart !== null && driver.shiftEnd !== null) {
          return true;
        }
      }

      return false;
    },
    coverageGap: function coverageGap() {
      return this.$store.state.coverage.map.gap;
    }
  },
  methods: {
    createShift: function createShift(driver) {
      this.$store.commit('coverage/setCoverageShiftFormDriver', driver);
      this.$store.commit('coverage/setCoverageShiftFormGap', this.coverageGap);
      this.$store.commit('coverage/setCoverageShiftFormSector', this.$store.state.coverage.map.sector);
      this.$store.commit('coverage/setCoverageShiftFormShow', true);
    },
    sendToDriver: function sendToDriver(driver) {
      var self = this;
      if (!self.rsvp.isPackage) {
        self.modal = {
          show: true,
          loading: true,
          loadingMessage: 'Sending Reservation ' + self.rsvp.ID + ' to ' + driver.firstName + '...',
          success: false,
          doneMessage: ''
        };
      } else {
        self.modal = {
          show: true,
          loading: true,
          loadingMessage: 'Sending Package ' + self.rsvp.package.id + ' to ' + driver.firstName + '...',
          success: false,
          doneMessage: ''
        };
      }

      var url = '';
      if (!self.rsvp.isPackage) {
        url = '/admin/rsvp/' + self.rsvp.ID + '/send';
      } else {
        url = '/admin/package/' + self.rsvp.package.id + '/send';
      }

      self.$sdk.post(url, {
        token: self.$store.state.session.sessionToken,
        provId: driver.driverId
      }, function (r) {
        if (r.error) {
          self.modal.loading = false;
          self.modal.success = false;
          self.modal.doneMessage = 'Oops! Something went wrong. Please try again later.';
        } else {
          self.modal.loading = false;
          self.modal.success = true;
          var message = '';
          if (!self.rsvp.isPackage) {
            message = 'Sent Reservation ' + self.rsvp.ID + ' to ' + driver.firstName + '.';
          } else {
            message = 'Sent Package ' + self.rsvp.package.id + ' to ' + driver.firstName + '.';
          }
          self.modal.doneMessage = message;
        }
        setTimeout(function () {
          self.modal.show = false;
        }, 1000);
      });
    },
    assignToDriver: function assignToDriver(driver) {
      var self = this;
      if (!self.rsvp.isPackage) {
        self.modal = {
          show: true,
          loading: true,
          loadingMessage: 'Assigning Reservation ' + self.rsvp.ID + ' to ' + driver.firstName + '...',
          success: false,
          doneMessage: ''
        };
      } else {
        self.modal = {
          show: true,
          loading: true,
          loadingMessage: 'Assigning Package ' + self.rsvp.package.id + ' to ' + driver.firstName + '...',
          success: false,
          doneMessage: ''
        };
      }

      var request = null;
      if (!self.rsvp.isPackage) {
        request = {
          token: self.$store.state.session.sessionToken,
          rsvpId: self.rsvp.ID
        };
      } else {
        request = {
          token: self.$store.state.session.sessionToken,
          packageId: self.rsvp.package.id
        };
      }

      self.$sdk.post('/provider/' + driver.driverId + '/assign', request, function (r) {
        if (r.error) {
          self.modal.loading = false;
          self.modal.success = false;
          self.modal.doneMessage = 'Oops! Something went wrong. Please try again later.';
        } else {
          self.modal.loading = false;
          self.modal.success = true;
          var message = '';
          if (!self.rsvp.isPackage) {
            message = 'Assigned Reservation ' + self.rsvp.ID + ' to ' + driver.firstName + '.';
          } else {
            message = 'Assigned Package ' + self.rsvp.package.id + ' to ' + driver.firstName + '.';
          }
          self.modal.doneMessage = message;
          self.$store.commit('coverage/setCoverageSectorsRefresh', true);

          self.$store.commit('coverage/setCoverageMapShowPolygons', true);
          self.$store.commit('coverage/setCoverageMapRsvp', null);
        }
        setTimeout(function () {
          self.modal.show = false;
        }, 1000);
      });
    },
    getCenter: function getCenter(sector) {
      if (sector.centerPointLat !== null && sector.centerPointLng !== null) {
        return {
          lat: sector.centerPointLat,
          lng: sector.centerPointLng
        };
      }
      var points = sector.polygon;
      var bounds = new google.maps.LatLngBounds(); // eslint-disable-line no-undef

      for (var i = 0; i < points.length; i++) {
        var point = points[i];
        bounds.extend(new google.maps.LatLng( // eslint-disable-line no-undef
        point.lat, point.lng));
      }

      var result = bounds.getCenter();
      return result;
    },
    centerSector: function centerSector(sector, index) {
      var self = this;
      self.$store.commit('coverage/resetCoverageSectorPolygonOption');
      self.$store.commit('coverage/setCoverageSectorPolygonOption', {
        id: sector.ID,
        polygonOptions: {
          zIndex: 2,
          strokeWeight: 5,
          fillOpacity: 0.75
        }
      });
      self.setBounds(sector.polygon);

      if (!self.sectorItems[index].showPanel) {
        self.$store.commit('coverage/setCoverageSectorsPanelShow', index);
        self.$store.commit('coverage/setCoverageSectorScrollElement', sector.identifier);
      }
    },
    setBounds: function setBounds(points) {
      var self = this;

      var bounds = new google.maps.LatLngBounds(); // eslint-disable-line no-undef

      for (var i = 0; i < points.length; i++) {
        var point = points[i];
        bounds.extend(new google.maps.LatLng( // eslint-disable-line no-undef
        point.lat, point.lng));
      }
      self.$refs.CoverageMap.$mapObject.fitBounds(bounds);
    },
    getRoute: function getRoute(request, callback) {
      var direction = new google.maps.DirectionsService(); // eslint-disable-line no-undef
      direction.route(request, function (response, status) {
        if (status !== google.maps.DirectionsStatus.OK) {
          // eslint-disable-line no-undef
          return;
        }
        callback(response);
      });
    },
    resetCenter: function resetCenter() {
      var self = this;

      var points = [];
      for (var i = 0; i < self.sectorItems.length; i++) {
        if (self.sectorItems[i].polygon === null) {
          continue;
        }
        points = points.concat(self.sectorItems[i].polygon);
      }

      if (points.length === 0) {
        self.$refs.CoverageMap.$mapObject.panTo({ lat: 33.942791, lng: -118.410042 });
        return;
      }

      self.setBounds(points);
    },
    findDriverIndexInList: function findDriverIndexInList(id, list) {
      var result = null;
      for (var i = 0; i < list.length; i++) {
        if (id === list[i].driverId) {
          return i;
        }
      }
      return result;
    },
    findDrivers: function findDrivers(forShift) {
      var self = this;

      var pickupTime = null;
      if (self.rsvp !== null) {
        if (!self.rsvp.isPackage) {
          pickupTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.rsvp.pickupDate, 'YYYY-MM-DD HH:mm:ss Z');
        } else {
          pickupTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.rsvp.package.localPickupTime, 'YYYY-MM-DD HH:mm:ss Z');
        }
      }
      var sector = self.$store.state.coverage.map.sector;
      var gap = self.$store.state.coverage.map.gap;

      var drivers = [];
      self.drivers.sector = [];
      self.noDrivers = false;
      // home base drivers
      for (var i = 0; i < sector.homebaseDrivers.length; i++) {
        var driver = sector.homebaseDrivers[i];
        if (driver.services.indexOf(self.rsvp.serviceTypeId) < 0) {
          continue;
        }
        drivers.push({
          driverId: driver.driverId,
          name: driver.firstName + ' ' + driver.lastName,
          phone: driver.phoneNumber,
          email: driver.email,
          isHomeBase: true,
          packageId: null,
          rsvpId: null,
          pickupTime: null,
          shiftStart: null,
          shiftEnd: null,
          location: null,
          photo: null,
          services: driver.services
        });
      }
      // working drivers
      for (var _i = 0; _i < sector.workDrivers.length; _i++) {
        var _driver = sector.workDrivers[_i];
        if (_driver.services.indexOf(self.rsvp.serviceTypeId) < 0) {
          continue;
        }
        var index = self.findDriverIndexInList(_driver.driverId, drivers);
        if (index === null) {
          drivers.push({
            driverId: _driver.driverId,
            name: _driver.firstName + ' ' + _driver.lastName,
            phone: null,
            email: null,
            isHomeBase: false,
            packageId: null,
            rsvpId: null,
            pickupTime: null,
            shiftStart: _driver.shiftStart,
            shiftEnd: _driver.shiftEnd,
            location: null,
            photo: null,
            services: _driver.services
          });
        } else {
          var start = _driver.shiftStart.unix();
          var end = _driver.shiftEnd.unix();
          if (self.rsvp !== null) {
            if (drivers[index].shiftStart === null && drivers[index].shiftEnd === null) {
              var puTime = pickupTime.unix();
              if (puTime >= start && puTime <= end) {
                drivers[index].shiftStart = _driver.shiftStart;
                drivers[index].shiftEnd = _driver.shiftEnd;
              }
            }
          }

          if (gap !== null) {
            var gapStart = gap.start.unix();

            if (gapStart >= start && gapStart <= end) {
              drivers[index].shiftStart = _driver.shiftStart;
              drivers[index].shiftEnd = _driver.shiftEnd;
            }
          }
        }
      }

      // dropoff drivers
      for (var _i2 = 0; _i2 < sector.driverDropoff.length; _i2++) {
        var _driver2 = sector.driverDropoff[_i2];
        if (_driver2.services.indexOf(self.rsvp.serviceTypeId) < 0) {
          continue;
        }
        var _index = self.findDriverIndexInList(_driver2.driverId, drivers);

        var dropoffTime = _driver2.dropoffTime;
        if (_index === null) {
          var insertDriver = false;
          if (self.rsvp !== null) {
            var _puTime = pickupTime.unix();
            if (Math.abs(_puTime - dropoffTime) <= 3600) {
              // clearing time within the hour
              insertDriver = true;
            }
          }

          if (gap !== null) {
            var _gapStart = gap.start.unix();
            var gapEnd = gap.end.unix();

            if (dropoffTime >= _gapStart && dropoffTime <= gapEnd) {
              insertDriver = true;
            }
          }

          if (insertDriver) {
            drivers.push({
              driverId: _driver2.driverId,
              name: _driver2.firstName + ' ' + _driver2.lastName,
              phone: null,
              email: null,
              isHomeBase: false,
              packageId: _driver2.packageID,
              rsvpId: _driver2.rsvpId,
              pickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(_driver2.pickupTime),
              dropoffTime: __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(_driver2.dropoffTime),
              shiftStart: null,
              shiftEnd: null,
              location: null,
              photo: null,
              services: _driver2.services
            });
          }
        } else {
          if (self.rsvp !== null) {
            var _puTime2 = pickupTime.unix();
            if (Math.abs(_puTime2 - dropoffTime) <= 3600) {
              // clearing time within the hour
              drivers[_index].packageId = _driver2.packageID;
              drivers[_index].rsvpId = _driver2.rsvpId;
              drivers[_index].pickupTime = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(_driver2.pickupTime);
              drivers[_index]['dropoffTime'] = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(_driver2.dropoffTime);
            }
          }

          if (gap !== null) {
            var _gapStart2 = gap.start.unix();
            var _gapEnd = gap.end.unix();

            if (dropoffTime >= _gapStart2 && dropoffTime <= _gapEnd) {
              drivers[_index].packageId = _driver2.packageID;
              drivers[_index].rsvpId = _driver2.rsvpId;
              drivers[_index].pickupTime = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(_driver2.pickupTime);
              drivers[_index]['dropoffTime'] = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(_driver2.dropoffTime);
            }
          }
        }
      }

      var ids = [];
      for (var _i3 = 0; _i3 < drivers.length; _i3++) {
        ids.push(drivers[_i3].driverId);
      }
      self.$sdk.get('/provider', {
        token: self.$store.state.session.sessionToken,
        ids: ids
      }, function (r) {
        if (r.error) {
          // show error
        } else {
          for (var _i4 = 0; _i4 < r.list.length; _i4++) {
            var _driver3 = r.list[_i4];
            var _index2 = self.findDriverIndexInList(_driver3.ID, drivers);
            if (_index2 === null) {
              continue;
            }

            drivers[_index2].phone = '' + _driver3.phone;
            drivers[_index2].email = _driver3.email;
            drivers[_index2].photo = _driver3.avatarUrl;
            drivers[_index2]['vehicle'] = _driver3.vehicle;
            drivers[_index2]['firstName'] = _driver3.firstName;
            drivers[_index2]['lastName'] = _driver3.lastName;
            if (_driver3.tracks !== null) {
              var heading = parseInt(_driver3.tracks.heading);

              if (isNaN(heading) || heading < 0 || heading > 359) {
                if (self.rsvp !== null) {
                  var location = null;
                  if (!self.rsvp.isPackage) {
                    location = self.rsvp.pickupLocation;
                  } else {
                    location = self.rsvp.stops[0];
                  }
                  heading = self.computeHeading(_driver3.tracks, location);
                } else {
                  heading = Math.floor(Math.random() * Math.floor(360));
                }
              }
              drivers[_index2].location = {
                lat: _driver3.tracks.lat,
                lng: _driver3.tracks.lng,
                heading: heading,
                pin: self.renderDriverPin(heading),
                showInfo: false
              };
            }
          }
        }

        self.drivers.sector = drivers;
        self.noDrivers = false;

        if (drivers.length <= 0) {
          self.noDrivers = true;
        }
        self.centerDrivers();

        if (forShift) {}
      });
    },
    centerDrivers: function centerDrivers() {
      var self = this;
      var points = [];

      for (var i = 0; i < self.drivers.sector.length; i++) {
        var driver = self.drivers.sector[i];
        if (driver.location === null) {
          continue;
        }
        points.push({
          lat: driver.location.lat,
          lng: driver.location.lng
        });
      }

      if (points.length <= 0) {
        return;
      }
      self.setBounds(points);
    },
    renderDriverPin: function renderDriverPin(heading) {
      return {
        url: 'https://s3-us-west-2.amazonaws.com/mobile-consumer-app/maps/car-sprite.png',
        origin: new google.maps.Point(heading * 60, 0), // eslint-disable-line no-undef
        anchor: {
          x: 30,
          y: 30
        },
        size: {
          width: 60,
          height: 60
        }
      };
    },
    computeHeading: function computeHeading(orig, dest) {
      var y = Math.sin(dest.lng - orig.lng) * Math.cos(dest.lat);
      var x = Math.cos(orig.lat) * Math.sin(dest.lat) - Math.sin(orig.lat) * Math.cos(dest.lat) * Math.cos(dest.lng - orig.lng);

      var brng = Math.atan2(y, x) * 180 / Math.PI;
      return Math.round(360 - (brng + 360) % 360);
    },
    toggleDriverInfo: function toggleDriverInfo(index) {
      this.drivers.sector[index].location.showInfo = !this.drivers.sector[index].location.showInfo;
    },
    closeDriverInfo: function closeDriverInfo(index) {
      this.drivers.sector[index].location.showInfo = false;
    },
    callDriver: function callDriver(driver) {
      var self = this;
      self.$plugins.phone.startCall(self, {
        phone: driver.phone,
        name: driver.firstName + ' ' + driver.lastName
      });
    },
    toggleStopsInfo: function toggleStopsInfo(index) {
      this.stopsInfo[index] = !this.stopsInfo[index];
    }
  },
  watch: {
    sectorItems: function sectorItems(value) {
      this.resetCenter();
    },
    coverageGap: function coverageGap(value) {
      var self = this;
      if (value === null) {
        self.infoWindows.pickup = false;
        self.infoWindows.dropoff = false;
        self.drivers.sector = [];
        self.noDrivers = false;
        self.drivers.nearby = [];
        self.resetCenter();
        return;
      }
      self.findDrivers(true);
    },
    rsvp: function rsvp(value) {
      var self = this;
      self.path.base = [];
      self.path.animated = [];
      if (self.path.animationID !== null) {
        clearInterval(self.path.animationID);
        self.path.animationID = null;
      }
      if (value === null) {
        self.stopsInfo = [];
        self.infoWindows.pickup = false;
        self.infoWindows.dropoff = false;
        self.drivers.sector = [];
        self.noDrivers = false;
        self.drivers.nearby = [];
        self.resetCenter();
        return;
      }

      self.findDrivers(false);
      self.infoWindows.pickup = true;
      self.infoWindows.dropoff = true;

      var request = null;
      if (!value.isPackage) {
        request = {
          origin: {
            lat: value.pickupLocation.lat,
            lng: value.pickupLocation.lng
          },
          destination: {
            lat: value.dropoffLocation.lat,
            lng: value.dropoffLocation.lng
          },
          travelMode: google.maps.TravelMode.DRIVING // eslint-disable-line no-undef
        };
      } else {
        var waypoints = value.stops.slice(0, value.stops.length);

        request = {
          origin: waypoints.shift(),
          destination: waypoints.pop(),
          travelMode: google.maps.TravelMode.DRIVING // eslint-disable-line no-undef
        };

        var stopovers = [];
        for (var i = 0; i < waypoints.length; i++) {
          stopovers.push({
            location: { lat: waypoints[i].lat, lng: waypoints[i].lng },
            stopover: false
          });
        }

        if (stopovers.length > 0) {
          request['waypoints'] = stopovers;
        }

        self.stopsInfo = [];
        for (var _i5 = 0; _i5 < value.stops.length; _i5++) {
          self.stopsInfo.push(true);
        }
      }

      self.rsvpInfo.pickupTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value.pickupDate, 'YYYY-MM-DD HH:mm:ss Z');

      self.getRoute(request, function (response) {
        var legs = response.routes[0].legs;
        var polylinePath = [];
        var bounds = [];
        var meters = 0;
        var seconds = 0;
        for (var j = 0; j < legs.length; j++) {
          var steps = legs[j].steps;
          meters = meters + legs[j].distance.value;
          seconds = seconds + legs[j].duration.value;

          for (var k = 0; k < steps.length; k++) {
            var paths = steps[k].path;
            for (var l = 0; l < paths.length; l++) {
              bounds.push({
                lat: paths[l].lat(),
                lng: paths[l].lng()
              });
              polylinePath.push(paths[l]);
            }
          }
        }
        self.rsvpInfo.dropoffTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value.pickupDate, 'YYYY-MM-DD HH:mm:ss Z').add(seconds, 'seconds');
        self.rsvpInfo.distanceInMiles = meters * 0.000621371;
        self.path.base = polylinePath;
        self.setBounds(bounds);

        var size = polylinePath.length;
        var itemsPerFrame = Math.floor(size / 30);
        var restartAt = itemsPerFrame * 30;
        var start = 0;
        var end = itemsPerFrame - 1;
        var startSplice = false;
        self.path.animationID = setInterval(function () {
          if (end >= restartAt) {
            if (!startSplice && self.path.animated.length < size) {
              // add remaining
              self.path.animated = polylinePath.slice(0);
              startSplice = true;
              return;
            }

            if (self.path.animated.length > 0) {
              self.path.animated.splice(0, itemsPerFrame);
              return;
            }

            start = 0;
            end = itemsPerFrame - 1;
            startSplice = false;
            self.path.animated = [];
            return;
          }
          var itemsToAdd = polylinePath.slice(start, end);
          for (var _i6 = 0; _i6 < itemsToAdd.length; _i6++) {
            self.path.animated.push(itemsToAdd[_i6]);
          }
          start = end + 1;
          end = start + itemsPerFrame;
        }, 33);
      });
    }
  }
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DriverModal__ = __webpack_require__(2006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__values_map_settings__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__values_map_pin__ = __webpack_require__(52);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */
var request = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'coverage-map',
  data: function data() {
    return {
      mapOptions: __WEBPACK_IMPORTED_MODULE_5__values_map_settings__["a" /* default */],
      center: { lat: 33.942791, lng: -118.410042 }, // LAX
      map: {
        labelBackground: {
          url: '',
          anchor: {
            x: 135,
            y: 20
          },
          scaledSize: {
            width: 270,
            height: 40
          }
        },
        poiPin: {
          url: 'https://s3-us-west-2.amazonaws.com/mobile-consumer-app/maps/pins/poi.png',
          anchor: {
            x: 15,
            y: 15
          },
          scaledSize: {
            width: 30,
            height: 30
          }
        }
      },
      path: {
        base: [],
        animated: [],
        animationID: null
      },
      drivers: {
        sector: [],
        nearby: []
      },
      noDrivers: false,
      infoWindows: {
        pickup: false,
        dropoff: false
      },
      rsvpInfo: {
        pickupTime: null,
        dropoffTime: null,
        distanceInMiles: null
      },
      stopsInfo: [],
      modal: {
        show: false,
        loading: false,
        loadingMessage: '',
        success: false,
        doneMessage: ''
      },
      hereMaps: {
        map: {},
        platform: {},
        router: {},
        geocoder: {},
        directions: [],
        ui: {}
      },
      isRsvp: false
    };
  },

  components: { driverModal: __WEBPACK_IMPORTED_MODULE_4__DriverModal__["a" /* default */] },
  computed: {
    rsvp: function rsvp() {
      return this.$store.state.coverage.map.rsvp;
    },
    showPolygons: function showPolygons() {
      return this.$store.state.coverage.map.showPolygons;
    },
    sectorItems: function sectorItems() {
      var result = [];
      var sectors = this.$store.state.coverage.sectors.items;
      for (var i = 0; i < sectors.length; i++) {
        result.push(sectors[i]);
      }
      return result;
    },
    hasUntrackedDrivers: function hasUntrackedDrivers() {
      var self = this;
      for (var i = 0; i < self.drivers.sector.length; i++) {
        var driver = self.drivers.sector[i];
        if (driver.location === null) {
          return true;
        }
      }

      return false;
    },
    hasAvailableDrivers: function hasAvailableDrivers() {
      var self = this;
      for (var i = 0; i < self.drivers.sector.length; i++) {
        var driver = self.drivers.sector[i];
        if (driver.shiftStart !== null && driver.shiftEnd !== null) {
          return true;
        }
      }

      return false;
    },
    coverageGap: function coverageGap() {
      return this.$store.state.coverage.map.gap;
    },
    kmlInMap: function kmlInMap() {
      return this.$store.state.coverage.map.kml;
    },
    kmlsInMap: function kmlsInMap() {
      return this.$store.state.coverage.map.kmls;
    },
    _triggerWatch: function _triggerWatch() {
      return this.$store.state.coverage.trigger.watch;
    }
  },
  methods: {
    createShift: function createShift(driver) {
      this.$store.commit('coverage/setCoverageShiftFormDriver', driver);
      this.$store.commit('coverage/setCoverageShiftFormGap', this.coverageGap);
      this.$store.commit('coverage/setCoverageShiftFormSector', this.$store.state.coverage.map.sector);
      this.$store.commit('coverage/setCoverageShiftFormShow', true);
    },
    sendToDriver: function sendToDriver(driver) {
      var self = this;
      if (!self.rsvp.isPackage) {
        self.modal = {
          show: true,
          loading: true,
          loadingMessage: 'Sending Reservation ' + self.rsvp.ID + ' to ' + driver.firstName + '...',
          success: false,
          doneMessage: ''
        };
      } else {
        self.modal = {
          show: true,
          loading: true,
          loadingMessage: 'Sending Package ' + self.rsvp.package.id + ' to ' + driver.firstName + '...',
          success: false,
          doneMessage: ''
        };
      }

      var url = '';
      if (!self.rsvp.isPackage) {
        url = '/admin/rsvp/' + self.rsvp.ID + '/send';
      } else {
        url = '/admin/package/' + self.rsvp.package.id + '/send';
      }

      self.$sdk.post(url, {
        token: self.$store.state.session.sessionToken,
        provId: driver.driverId
      }, function (r) {
        if (r.error) {
          self.modal.loading = false;
          self.modal.success = false;
          self.modal.doneMessage = 'Oops! Something went wrong. Please try again later.';
          if (r.error.message) {
            self.modal.doneMessage = r.error.message;
          }
        } else {
          self.modal.loading = false;
          self.modal.success = true;
          var message = '';
          if (!self.rsvp.isPackage) {
            message = 'Sent Reservation ' + self.rsvp.ID + ' to ' + driver.firstName + '.';
          } else {
            message = 'Sent Package ' + self.rsvp.package.id + ' to ' + driver.firstName + '.';
          }
          self.modal.doneMessage = message;
        }
        setTimeout(function () {
          self.modal.show = false;
        }, 1000);
      });
    },
    assignToDriver: function assignToDriver(driver) {
      var self = this;
      if (!self.rsvp.isPackage) {
        self.modal = {
          show: true,
          loading: true,
          loadingMessage: 'Assigning Reservation ' + self.rsvp.ID + ' to ' + driver.firstName + '...',
          success: false,
          doneMessage: ''
        };
      } else {
        self.modal = {
          show: true,
          loading: true,
          loadingMessage: 'Assigning Package ' + self.rsvp.package.id + ' to ' + driver.firstName + '...',
          success: false,
          doneMessage: ''
        };
      }

      var request = null;
      if (!self.rsvp.isPackage) {
        request = {
          token: self.$store.state.session.sessionToken,
          rsvpId: self.rsvp.ID
        };
      } else {
        request = {
          token: self.$store.state.session.sessionToken,
          packageId: self.rsvp.package.id
        };
      }

      self.$sdk.post('/provider/' + driver.driverId + '/assign', request, function (r) {
        if (r.error) {
          self.modal.loading = false;
          self.modal.success = false;
          self.modal.doneMessage = 'Oops! Something went wrong. Please try again later.';
          if (r.error.message) {
            self.modal.doneMessage = r.error.message;
          }
        } else {
          self.modal.loading = false;
          self.modal.success = true;
          var message = '';
          if (!self.rsvp.isPackage) {
            message = 'Assigned Reservation ' + self.rsvp.ID + ' to ' + driver.firstName + '.';
          } else {
            message = 'Assigned Package ' + self.rsvp.package.id + ' to ' + driver.firstName + '.';
          }
          self.modal.doneMessage = message;
          self.$store.commit('coverage/setCoverageSectorsRefresh', true);

          self.$store.commit('coverage/setCoverageMapShowPolygons', true);
          self.$store.commit('coverage/setCoverageMapRsvp', null);
        }
        setTimeout(function () {
          self.modal.show = false;
        }, 1000);
      });
    },
    getCenter: function getCenter(sector) {
      if (sector.centerPointLat !== null && sector.centerPointLng !== null) {
        return {
          lat: sector.centerPointLat,
          lng: sector.centerPointLng
        };
      }
      var points = sector.polygon;
      var bounds = new google.maps.LatLngBounds(); // eslint-disable-line no-undef

      for (var i = 0; i < points.length; i++) {
        var point = points[i];
        bounds.extend(new google.maps.LatLng( // eslint-disable-line no-undef
        point.lat, point.lng));
      }

      var result = bounds.getCenter();
      return result;
    },
    centerSector: function centerSector(sector, index) {
      var self = this;
      self.$store.commit('coverage/resetCoverageSectorPolygonOption');
      self.$store.commit('coverage/setCoverageSectorPolygonOption', {
        id: sector.ID,
        polygonOptions: {
          zIndex: 2,
          strokeWeight: 5,
          fillOpacity: 0.75
        }
      });
      self.setBounds(sector.polygon);

      if (!self.sectorItems[index].showPanel) {
        self.$store.commit('coverage/setCoverageSectorsPanelShow', index);
        self.$store.commit('coverage/setCoverageSectorScrollElement', sector.identifier);
      }
    },
    setBounds: function setBounds(points) {
      var self = this;

      var bounds = new google.maps.LatLngBounds(); // eslint-disable-line no-undef

      for (var i = 0; i < points.length; i++) {
        var point = points[i];
        bounds.extend(new google.maps.LatLng( // eslint-disable-line no-undef
        point.lat, point.lng));
      }
      self.$refs.CoverageMap.$mapObject.fitBounds(bounds);
    },
    getRoute: function getRoute(request, callback) {
      var direction = new google.maps.DirectionsService(); // eslint-disable-line no-undef
      direction.route(request, function (response, status) {
        if (status !== google.maps.DirectionsStatus.OK) {
          // eslint-disable-line no-undef
          return;
        }
        callback(response);
      });
    },
    resetCenter: function resetCenter() {
      var self = this;

      var points = [];
      for (var i = 0; i < self.sectorItems.length; i++) {
        if (self.sectorItems[i].polygon === null) {
          continue;
        }
        points = points.concat(self.sectorItems[i].polygon);
      }

      if (points.length === 0) {
        self.$refs.CoverageMap.$mapObject.panTo({ lat: 33.942791, lng: -118.410042 });
        return;
      }

      self.setBounds(points);
    },
    findDriverIndexInList: function findDriverIndexInList(id, list) {
      var result = null;
      for (var i = 0; i < list.length; i++) {
        if (id === list[i].driverId) {
          return i;
        }
      }
      return result;
    },
    findDrivers: function findDrivers() {
      var self = this;

      var pickupTime = null;
      if (self.rsvp !== null) {
        if (!self.rsvp.isPackage) {
          pickupTime = __WEBPACK_IMPORTED_MODULE_3_moment___default()(self.rsvp.pickupDate, 'YYYY-MM-DD HH:mm:ss Z');
        } else {
          pickupTime = __WEBPACK_IMPORTED_MODULE_3_moment___default()(self.rsvp.package.localPickupTime, 'YYYY-MM-DD HH:mm:ss Z');
        }
      }
      var sector = self.$store.state.coverage.map.sector;
      var gap = self.$store.state.coverage.map.gap;

      var drivers = [];
      self.drivers.sector = [];
      self.noDrivers = false;
      // home base drivers
      for (var i = 0; i < sector.homebaseDrivers.length; i++) {
        var driver = sector.homebaseDrivers[i];
        if (driver.services.indexOf(self.rsvp.serviceTypeId) < 0) {
          continue;
        }
        drivers.push({
          driverId: driver.driverId,
          name: driver.firstName + ' ' + driver.lastName,
          phone: driver.phoneNumber,
          email: driver.email,
          isHomeBase: true,
          packageId: null,
          rsvpId: null,
          pickupTime: null,
          shiftStart: null,
          shiftEnd: null,
          location: null,
          photo: null,
          services: driver.services
        });
      }
      // working drivers
      for (var _i = 0; _i < sector.workDrivers.length; _i++) {
        var _driver = sector.workDrivers[_i];
        if (_driver.services.indexOf(self.rsvp.serviceTypeId) < 0) {
          continue;
        }
        var index = self.findDriverIndexInList(_driver.driverId, drivers);
        if (index === null) {
          drivers.push({
            driverId: _driver.driverId,
            name: _driver.firstName + ' ' + _driver.lastName,
            phone: null,
            email: null,
            isHomeBase: false,
            packageId: null,
            rsvpId: null,
            pickupTime: null,
            shiftStart: _driver.shiftStart,
            shiftEnd: _driver.shiftEnd,
            location: null,
            photo: null,
            services: _driver.services
          });
        } else {
          var start = _driver.shiftStart.unix();
          var end = _driver.shiftEnd.unix();
          if (self.rsvp !== null) {
            if (drivers[index].shiftStart === null && drivers[index].shiftEnd === null) {
              var puTime = pickupTime.unix();
              if (puTime >= start && puTime <= end) {
                drivers[index].shiftStart = _driver.shiftStart;
                drivers[index].shiftEnd = _driver.shiftEnd;
              }
            }
          }

          if (gap !== null) {
            var gapStart = gap.start.unix();

            if (gapStart >= start && gapStart <= end) {
              drivers[index].shiftStart = _driver.shiftStart;
              drivers[index].shiftEnd = _driver.shiftEnd;
            }
          }
        }
      }

      // dropoff drivers
      for (var _i2 = 0; _i2 < sector.driverDropoff.length; _i2++) {
        var _driver2 = sector.driverDropoff[_i2];
        if (_driver2.services.indexOf(self.rsvp.serviceTypeId) < 0) {
          continue;
        }
        var _index = self.findDriverIndexInList(_driver2.driverId, drivers);

        var dropoffTime = _driver2.dropoffTime;
        if (_index === null) {
          var insertDriver = false;
          if (self.rsvp !== null) {
            var _puTime = pickupTime.unix();
            if (Math.abs(_puTime - dropoffTime) <= 3600) {
              // clearing time within the hour
              insertDriver = true;
            }
          }

          if (gap !== null) {
            var _gapStart = gap.start.unix();
            var gapEnd = gap.end.unix();

            if (dropoffTime >= _gapStart && dropoffTime <= gapEnd) {
              insertDriver = true;
            }
          }

          if (insertDriver) {
            drivers.push({
              driverId: _driver2.driverId,
              name: _driver2.firstName + ' ' + _driver2.lastName,
              phone: null,
              email: null,
              isHomeBase: false,
              packageId: _driver2.packageID,
              rsvpId: _driver2.rsvpId,
              pickupTime: __WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix(_driver2.pickupTime),
              dropoffTime: __WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix(_driver2.dropoffTime),
              shiftStart: null,
              shiftEnd: null,
              location: null,
              photo: null,
              services: _driver2.services
            });
          }
        } else {
          if (self.rsvp !== null) {
            var _puTime2 = pickupTime.unix();
            if (Math.abs(_puTime2 - dropoffTime) <= 3600) {
              // clearing time within the hour
              drivers[_index].packageId = _driver2.packageID;
              drivers[_index].rsvpId = _driver2.rsvpId;
              drivers[_index].pickupTime = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix(_driver2.pickupTime);
              drivers[_index]['dropoffTime'] = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix(_driver2.dropoffTime);
            }
          }

          if (gap !== null) {
            var _gapStart2 = gap.start.unix();
            var _gapEnd = gap.end.unix();

            if (dropoffTime >= _gapStart2 && dropoffTime <= _gapEnd) {
              drivers[_index].packageId = _driver2.packageID;
              drivers[_index].rsvpId = _driver2.rsvpId;
              drivers[_index].pickupTime = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix(_driver2.pickupTime);
              drivers[_index]['dropoffTime'] = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix(_driver2.dropoffTime);
            }
          }
        }
      }

      var ids = [];
      for (var _i3 = 0; _i3 < drivers.length; _i3++) {
        ids.push(drivers[_i3].driverId);
      }
      self.$sdk.get('/provider', {
        token: self.$store.state.session.sessionToken,
        ids: ids
      }, function (r) {
        if (r.error) {
          // show error
        } else {
          for (var _i4 = 0; _i4 < r.list.length; _i4++) {
            var _driver3 = r.list[_i4];
            var _index2 = self.findDriverIndexInList(_driver3.ID, drivers);
            if (_index2 === null) {
              continue;
            }

            drivers[_index2].phone = '' + _driver3.phone;
            drivers[_index2].email = _driver3.email;
            drivers[_index2].photo = _driver3.avatarUrl;
            drivers[_index2]['vehicle'] = _driver3.vehicle;
            drivers[_index2]['firstName'] = _driver3.firstName;
            drivers[_index2]['lastName'] = _driver3.lastName;
            if (_driver3.tracks !== null) {
              var heading = parseInt(_driver3.tracks.heading);

              if (isNaN(heading) || heading < 0 || heading > 359) {
                if (self.rsvp !== null) {
                  var location = null;
                  if (!self.rsvp.isPackage) {
                    location = self.rsvp.pickupLocation;
                  } else {
                    location = self.rsvp.stops[0];
                  }
                  heading = self.computeHeading(_driver3.tracks, location);
                } else {
                  heading = Math.floor(Math.random() * Math.floor(360));
                }
              }
              drivers[_index2].location = {
                lat: _driver3.tracks.lat,
                lng: _driver3.tracks.lng,
                heading: heading,
                // pin: self.renderDriverPin(heading),
                showInfo: false
              };
            }
          }
        }

        self.drivers.sector = drivers;
        self.noDrivers = false;

        if (drivers.length <= 0) {
          self.noDrivers = true;
          return;
        }

        self.addDriversToMap();
        // self.centerDrivers()
      });
    },
    centerDrivers: function centerDrivers() {
      var self = this;
      var points = [];

      for (var i = 0; i < self.drivers.sector.length; i++) {
        var driver = self.drivers.sector[i];
        if (driver.location === null) {
          continue;
        }
        points.push({
          lat: driver.location.lat,
          lng: driver.location.lng
        });
      }

      if (points.length <= 0) {
        return;
      }
      self.setBounds(points);
    },
    renderDriverPin: function renderDriverPin(heading) {
      return {
        url: 'https://s3-us-west-2.amazonaws.com/mobile-consumer-app/maps/car-sprite.png',
        origin: new google.maps.Point(heading * 60, 0), // eslint-disable-line no-undef
        anchor: {
          x: 30,
          y: 30
        },
        size: {
          width: 60,
          height: 60
        }
      };
    },
    computeHeading: function computeHeading(orig, dest) {
      var y = Math.sin(dest.lng - orig.lng) * Math.cos(dest.lat);
      var x = Math.cos(orig.lat) * Math.sin(dest.lat) - Math.sin(orig.lat) * Math.cos(dest.lat) * Math.cos(dest.lng - orig.lng);

      var brng = Math.atan2(y, x) * 180 / Math.PI;
      return Math.round(360 - (brng + 360) % 360);
    },
    toggleDriverInfo: function toggleDriverInfo(index) {
      this.drivers.sector[index].location.showInfo = !this.drivers.sector[index].location.showInfo;
    },
    closeDriverInfo: function closeDriverInfo(index) {
      this.drivers.sector[index].location.showInfo = false;
    },
    callDriver: function callDriver(driver) {
      var self = this;
      self.$plugins.phone.startCall(self, {
        phone: driver.phone,
        name: driver.firstName + ' ' + driver.lastName
      });
    },
    toggleStopsInfo: function toggleStopsInfo(index) {
      this.stopsInfo[index] = !this.stopsInfo[index];
    },
    placePolygon: function placePolygon(value) {
      var self = this;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var object = _step.value;

          self.hereMaps.map.removeObject(object);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (value) {
        var group = new window.H.map.Group();
        var groupObject = [];

        value.forEach(function (val) {
          var reader = new window.H.data.kml.Reader(val.kmlFile);
          reader.parse();

          reader.addEventListener('statechange', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
            var objects;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (this.getState() === window.H.data.AbstractReader.State.READY) {
                      objects = reader.getParsedObjects();

                      if (objects[0] instanceof H.map.Group) {
                        objects = objects[0];
                      }

                      objects.forEach(function (obj, i, group) {
                        if (obj instanceof H.map.Polygon && !obj.id) {
                          obj.setStyle({
                            strokeColor: val.overlayColor,
                            fillColor: self.hexaToDeci(val.overlayColor),
                            lineWidth: 2
                          });
                          obj.id = val.id;
                          groupObject.push(obj);
                        }
                      }, true, this);
                    }

                  case 1:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, this);
          })));

          if (groupObject.length) {
            group.addObjects(groupObject);
            group.id = 'groupBound';
            self.hereMaps.map.addObject(kmlGroup);
            self.hereMaps.map.getViewModel().setLookAtData({
              bounds: kmlGroup.getBoundingBox()
            });
          }

          var layer = reader.getLayer();
          self.hereMaps.map.addLayer(layer);
        });
        // self.setCenter()
      }
    },
    hexaToDeci: function hexaToDeci(val) {
      var hex = val.replace('#', '').match(/.{1,2}/g);
      return 'rgba(' + parseInt(hex[0], 16) + ',' + parseInt(hex[1], 16) + ',' + parseInt(hex[2], 16) + ', .4)';
    },
    addMarkerToMap: function addMarkerToMap(data, type) {
      var self = this;

      var marker = '<svg height="25" width="25" style="overflow: unset" viewBox="0 0 50 50">' + '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' + 'stroke-width="{STROKE_WIDTH}" /></svg>';
      marker = marker.replace('{D}', __WEBPACK_IMPORTED_MODULE_6__values_map_pin__["a" /* default */][type].path).replace('{FILL}', __WEBPACK_IMPORTED_MODULE_6__values_map_pin__["a" /* default */][type].fillColor).replace('{STROKE}', __WEBPACK_IMPORTED_MODULE_6__values_map_pin__["a" /* default */][type].strokeColor).replace('{STROKE_WIDTH}', __WEBPACK_IMPORTED_MODULE_6__values_map_pin__["a" /* default */][type].strokeWeight);

      var icon = new window.H.map.DomIcon(marker);
      var coords = { lat: data.lat, lng: data.lng };
      var pin = new window.H.map.DomMarker(coords, { icon: icon });
      pin.id = 'marker';
      pin.lat = coords.lat;
      pin.lng = coords.lng;
      self.hereMaps.map.addObject(pin);
    },
    addInfowWindow: function addInfowWindow(data, type) {
      var self = this;
      var content = '<div class="here-info-window-content coverage rsvp">\n        <label>PICKUP TIME:</label>\n        <span class="value">{PICKUPTIME}</span>\n      </div>';
      if (type === 'pickup') {
        content = content.replace('{PICKUPTIME}', __WEBPACK_IMPORTED_MODULE_3_moment___default()(data.pickupDate, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'));
      } else if (type === 'dropoff') {
        content = '<div class="here-info-window-content coverage rsvp">{DROPOFFTIME}{DISTANCE}</div>';
        if (data.dropoffTime) {
          var dropoffTime = __WEBPACK_IMPORTED_MODULE_3_moment___default()(data.dropoffTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mmA');
          content = content.replace('{DROPOFFTIME}', '<div class="label-value">\n            <label>EST DROPOFF TIME</label>\n            <span class="value"> ' + dropoffTime + ' </span>\n          </div>');
        } else {
          content = content.replace('{DROPOFFTIME}', '');
        }

        if (data.distance) {
          var distance = Math.round(data.distance * .001 * 0.6214) + ' miles';
          content = content.replace('{DISTANCE}', '<div class="label-value">\n            <label>TRAVEL DISTANCE</label>\n            <span class="value"> ' + distance + ' </span>\n          </div>');
        } else {
          content = content.replace('{DISTANCE}', '');
        }
      }

      var bubble = new window.H.ui.InfoBubble(data, { content: content });
      bubble.id = type + data.id;
      self.hereMaps.ui.addBubble(bubble);
      bubble.addEventListener('tap', function (evt) {
        bubble.open();
      }, false);
    },
    addPathToMap: function addPathToMap(origin, destination) {
      var _this = this;

      var self = this;
      var router = self.hereMaps.platform.getRoutingService(null, 8);
      var routeRequestParams = {
        routingMode: 'fast',
        transportMode: 'car',
        origin: origin.lat + ',' + origin.lng,
        destination: destination.lat + ',' + destination.lng,
        return: 'polyline,turnByTurnActions,actions,instructions,travelSummary'
      };

      router.calculateRoute(routeRequestParams, function (success) {
        if (success.routes.length) {
          var route = success.routes[0].sections[0];
          var linestring = window.H.geo.LineString.fromFlexiblePolyline(route.polyline);
          var polyline = new window.H.map.Polyline(linestring, {
            style: {
              lineWidth: 4,
              strokeColor: 'rgba(25, 25, 25, 0.7)'
            }
          });
          polyline.id = 'route';
          _this.hereMaps.map.addObject(polyline);
          _this.hereMaps.map.getViewModel().setLookAtData({
            bounds: polyline.getBoundingBox()
          });

          if (self.isRsvp) {
            self.addInfowWindow({
              id: self.rsvp.ID,
              lat: destination.lat,
              lng: destination.lng,
              dropoffTime: __WEBPACK_IMPORTED_MODULE_3_moment___default()(self.rsvp.pickupDate, 'YYYY-MM-DD HH:mm').add(route.travelSummary.duration, 'seconds').format('YYYY-MM-DD HH:mm'),
              distance: route.travelSummary.length
            }, 'dropoff');
          }
        }

        // this.setCenter()
      }, function (error) {
        console.log('ROUTE ERROR:', error);
      });
    },
    addPkgPathToMap: function addPkgPathToMap() {
      var self = this;

      var url = 'https://router.hereapi.com/v8/routes?apiKey={API_KEY}&transportMode=car&return=polyline,summary';
      url = url.replace('{API_KEY}', {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key);
      self.rsvp.stops.forEach(function (coords, index) {
        if (index == 0) {
          url += '&origin=' + coords.lat + ',' + coords.lng;
        } else if (index == self.rsvp.stops.length - 1) {
          url += '&destination=' + coords.lat + ',' + coords.lng;
        } else {
          url += '&via=' + coords.lat + ',' + coords.lng;
        }
      });
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        var _this2 = this;

        if (err) {
          console.log('ROUTE ERROR:', err);
          return;
        }

        if (!body.routes.length) return;
        var routes = body.routes[0].sections;
        routes.forEach(function (route, index) {
          var linestring = window.H.geo.LineString.fromFlexiblePolyline(route.polyline);
          var polyline = new window.H.map.Polyline(linestring, {
            style: {
              lineWidth: 4,
              strokeColor: 'rgba(25, 25, 25, 0.7)'
            }
          });
          polyline.id = 'route' + index;
          _this2.hereMaps.map.addObject(polyline);
        });
      });
    },
    addDriversToMap: function addDriversToMap() {
      var self = this;

      self.drivers.sector.forEach(function (driver) {
        if (driver.location && driver.location.lat && driver.location.lng) {
          var marker = '<div class="rotator">\n            <div class=\'here-marker car-icon\' style="transform: rotate({HEADING})"></div>\n          </div>';
          var destination = self.rsvp.isPackage ? self.rsvp.stops[0] : self.rsvp.pickupLocation;
          var heading = self.computeHeading(driver.location, destination);
          marker = marker.replace('{HEADING}', heading + 'deg');

          var coords = { lat: driver.location.lat, lng: driver.location.lng };
          var infoWindow = document.getElementById('HCar');
          var carBubble = new window.H.ui.InfoBubble(coords, { content: infoWindow });
          carBubble.id = 'car-info' + driver.driverId;
          self.hereMaps.ui.addBubble(carBubble);
          carBubble.close();

          var icon = new window.H.map.DomIcon(marker, {
            onAttach: function onAttach(cloned, icon2, marker) {
              cloned.addEventListener('click', function (evt) {
                if (self.$refs.HCar.update(driver)) {
                  self.$refs.HCar.update(driver);
                }
                carBubble.open();
              });
            },
            onDetach: function onDetach(cloned, icon, marker) {
              cloned.removeEventListener('click', function (evt) {});
            }
          });

          var pin = new window.H.map.DomMarker(coords, { icon: icon });
          pin.id = 'nearbyDrivers' + driver.driverId;
          pin.lat = coords.lat;
          pin.lng = coords.lng;
          self.hereMaps.map.addObject(pin);
        }
      });
    },
    addKmlToMap: function addKmlToMap(id) {
      var self = this;

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var object = _step2.value;

          self.hereMaps.map.removeObject(object);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      self.hereMaps.ui.getBubbles().forEach(function (bub) {
        bub.close();
      });
      self.hereMaps.ui.removeBubble(self.hereMaps.ui.getBubbles());
      self.hereMaps.map.removeObjects(self.hereMaps.map.getObjects());

      var index = self.sectorItems.findIndex(function (x) {
        return x.ID === id;
      });
      if (!id || index === -1) {
        return;
      }
      var sectorData = self.sectorItems[index];
      var kmlGroup = new window.H.map.Group();
      var reader = new window.H.data.kml.Reader(sectorData.kmlFile);
      reader.parse();

      reader.addEventListener('statechange', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var objects;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.getState() === window.H.data.AbstractReader.State.READY) {
                  objects = reader.getParsedObjects();

                  if (objects[0] instanceof H.map.Group) {
                    objects = objects[0];
                  }

                  objects.forEach(function (obj, i, group) {
                    if (obj instanceof H.map.Polygon && !obj.id) {
                      obj.setStyle({
                        strokeColor: sectorData.overlayColor,
                        fillColor: self.hexaToDeci(sectorData.overlayColor),
                        lineWidth: 2
                      });
                      obj.id = sectorData.ID;
                      kmlGroup.addObject(obj);

                      self.hereMaps.map.getViewModel().setLookAtData({
                        bounds: obj.getBoundingBox()
                      });
                    }
                  }, true, this);
                }

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      })));

      self.hereMaps.map.addObject(kmlGroup);
      // let layer = reader.getLayer()
      // self.hereMaps.map.addLayer(layer)
    },
    addKmlToMap2: function addKmlToMap2(kmls) {
      var self = this;

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var object = _step3.value;

          if (kmls.indexOf(object.id) == -1) {
            self.hereMaps.map.removeObject(object);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (!kmls.length) return;

      kmls.forEach(function (kml) {
        if (self.hereMaps.map.getObjects().findIndex(function (x) {
          return x.id == kml;
        }) > -1) return;
        var index = self.sectorItems.findIndex(function (x) {
          return x.ID === kml;
        });
        var sectorData = self.sectorItems[index];
        var kmlGroup = new window.H.map.Group();
        var reader = new window.H.data.kml.Reader(sectorData.kmlFile);
        reader.parse();

        reader.addEventListener('statechange', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
          var objects;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (this.getState() === window.H.data.AbstractReader.State.READY) {
                    objects = reader.getParsedObjects();

                    if (objects[0] instanceof H.map.Group) {
                      objects = objects[0];
                    }

                    objects.forEach(function (obj, i, group) {
                      if (obj instanceof H.map.Polygon && !obj.id) {
                        obj.setStyle({
                          strokeColor: sectorData.overlayColor,
                          fillColor: self.hexaToDeci(sectorData.overlayColor),
                          lineWidth: 2
                        });
                        kmlGroup.addObject(obj);

                        self.hereMaps.map.getViewModel().setLookAtData({
                          bounds: obj.getBoundingBox()
                        });
                      }
                    }, true, this);
                    kmlGroup.id = sectorData.ID;
                  }

                case 1:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        })));
        self.hereMaps.map.addObject(kmlGroup);
      });
    }
  },
  watch: {
    sectorItems: function sectorItems(value) {
      // this.resetCenter()
      // this.placePolygon(value)
    },
    coverageGap: function coverageGap(value) {
      var self = this;
      if (value === null) {
        self.infoWindows.pickup = false;
        self.infoWindows.dropoff = false;
        self.drivers.sector = [];
        self.noDrivers = false;
        self.drivers.nearby = [];
        self.resetCenter();
        return;
      }
      self.findDrivers();
    },
    rsvp: function rsvp(value) {
      var self = this;

      self.hereMaps.ui.getBubbles().forEach(function (bub) {
        bub.close();
      });
      self.hereMaps.ui.removeBubble(self.hereMaps.ui.getBubbles());
      self.hereMaps.map.removeObjects(self.hereMaps.map.getObjects());

      self.isRsvp = true;
      if (value === null) {
        self.isRsvp = false;
        // RESET MAP TO CENTER OR SOMETHING
        return;
      }

      if (value.isPackage) {
        value.stops.forEach(function (stop) {
          self.addMarkerToMap(stop, stop.isPickup ? 'pickup' : 'dropoff');
        });
        self.addPkgPathToMap();
      } else {
        var pickupCoords = {
          lat: value.pickupLocation.lat,
          lng: value.pickupLocation.lng
        };
        self.addMarkerToMap(pickupCoords, 'pickup');
        self.addInfowWindow({
          id: value.ID,
          pickupDate: value.pickupDate,
          lat: pickupCoords.lat,
          lng: pickupCoords.lng
        }, 'pickup');

        var dropoffCoords = {
          lat: value.dropoffLocation.lat,
          lng: value.dropoffLocation.lng
        };
        self.addMarkerToMap(dropoffCoords, 'dropoff');
        self.addPathToMap(value.pickupLocation, value.dropoffLocation);
      }

      self.findDrivers();
    },
    kmlInMap: function kmlInMap(value) {
      // this.addKmlToMap(value)
    },
    kmlsInMap: function kmlsInMap(value) {
      this.addKmlToMap2(value);
    },
    _triggerWatch: function _triggerWatch(value) {
      if (value) {
        this.$store.commit('coverage/setTriggerWatch', false);
        var trigger = this.$store.state.coverage.trigger;

        if (trigger.action === 'sendToDriver') {
          this.sendToDriver(trigger.data);
        }
        if (trigger.action === 'assignToDriver') {
          this.assignToDriver(trigger.data);
        }
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    var mapContainer = document.getElementById('mapHere');
    self.hereMaps.platform = new window.H.service.Platform({
      apikey: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key
    });

    var defaultLayers = self.hereMaps.platform.createDefaultLayers();
    self.hereMaps.map = new window.H.Map(mapContainer, defaultLayers.vector.normal.map, {
      center: self.center,
      zoom: 13,
      pixelRatio: window.devicePixelRatio || 1
    });

    /* eslint-disable no-unused-vars */
    var behavior = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(self.hereMaps.map));
    /* eslint-enable no-unused-vars */
    self.hereMaps.ui = window.H.ui.UI.createDefault(self.hereMaps.map, defaultLayers);

    window.addEventListener('resize', function () {
      return self.hereMaps.map.getViewPort().resize();
    });
  }
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'driver-modal',
  data: function data() {
    return {
      driver: {
        rsvpId: '',
        photo: '',
        driverId: '',
        name: '',
        email: '',
        phone: '',
        dropoffTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(),
        firstName: '',
        isHomeBase: '',
        vehicle: {
          photoUrl: '',
          manufacturer: '',
          model: '',
          licensePlate: ''
        },
        shiftStart: __WEBPACK_IMPORTED_MODULE_0_moment___default()(),
        shiftEnd: __WEBPACK_IMPORTED_MODULE_0_moment___default()()
      }
    };
  },

  computed: {
    rsvp: function rsvp() {
      return this.$store.state.coverage.map.rsvp;
    },
    hasOngoingCall: function hasOngoingCall() {
      return this.$store.state.phone.ongoing;
    },
    coverageGap: function coverageGap() {
      return this.$store.state.coverage.map.gap;
    }
  },
  methods: {
    update: function update(data) {
      this.driver = data;
    },
    callDriver: function callDriver(driver) {
      var self = this;
      self.$plugins.phone.startCall(self, {
        phone: driver.phone,
        name: driver.firstName + ' ' + driver.lastName
      });
    },
    sendToDriver: function sendToDriver(driver) {
      this.$store.commit('coverage/setTriggerAction', 'sendToDriver');
      this.$store.commit('coverage/setTriggerData', driver);
      this.$store.commit('coverage/setTriggerWatch', true);
    },
    assignToDriver: function assignToDriver(driver) {
      this.$store.commit('coverage/setTriggerAction', 'assignToDriver');
      this.$store.commit('coverage/setTriggerData', driver);
      this.$store.commit('coverage/setTriggerWatch', true);
    },
    createShift: function createShift(driver) {
      this.$store.commit('coverage/setCoverageShiftFormDriver', driver);
      this.$store.commit('coverage/setCoverageShiftFormGap', this.coverageGap);
      this.$store.commit('coverage/setCoverageShiftFormSector', this.$store.state.coverage.map.sector);
      this.$store.commit('coverage/setCoverageShiftFormShow', true);
    }
  }
});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'coverage-shift-form',
  data: function data() {
    return {
      timeHour: 1,
      timeMinute: 0,
      timeAmPm: 'AM',
      durationRange: 12,
      shiftDuration: 10,
      submitting: false,
      done: false,
      success: false,
      errorMessage: 'Oops. Something went wrong. Please try again later.'
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.coverage.shiftForm.show;
    },
    driver: function driver() {
      return this.$store.state.coverage.shiftForm.driver;
    },
    gap: function gap() {
      return this.$store.state.coverage.shiftForm.gap;
    },
    sector: function sector() {
      return this.$store.state.coverage.shiftForm.sector;
    }
  },
  methods: {
    sendShift: function sendShift() {
      var self = this;

      var dayStr = self.gap.start.format('MM/DD/YYYY');
      var timeHour = self.timeHour < 10 ? '0' + self.timeHour : '' + self.timeHour;
      var timeMinute = self.timeMinute < 10 ? '0' + self.timeMinute : '' + self.timeMinute;
      var timeAmPm = self.timeAmPm;
      var startStr = dayStr + ' ' + timeHour + ':' + timeMinute + ':00' + timeAmPm;
      var shiftStart = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startStr, 'MM/DD/YYYY hh:mm:ssA');
      var shiftEnd = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startStr, 'MM/DD/YYYY hh:mm:ssA').add(self.shiftDuration, 'hours');

      var request = {
        token: self.$store.state.session.sessionToken,
        driverId: self.driver.driverId,
        driverHomeSectorId: null,
        driverHomeSubsectorId: null,
        driverWorkSectorId: self.sector.ID,
        driverWorkSubsectorId: null,
        startTimestamp: shiftStart.unix(),
        endTimestamp: shiftEnd.unix(),
        driverConfirmed: 0
      };

      self.submitting = true;
      self.done = false;
      self.success = false;

      self.$sdk.post('/shifts', request, function (r) {
        self.done = true;

        if (r.error) {
          self.success = false;
          self.errorMessage = r.error.message;
        } else {
          self.success = true;
        }

        setTimeout(function () {
          self.close();
        }, 1000);
      });
    },
    close: function close() {
      this.$store.commit('coverage/setCoverageShiftFormShow', false);
      this.$store.commit('coverage/setCoverageShiftFormDriver', null);
      this.$store.commit('coverage/setCoverageShiftFormGap', null);
      this.$store.commit('coverage/setCoverageShiftFormSector', null);
    },
    setAmPm: function setAmPm() {
      var value = 'AM';
      if (this.timeAmPm === 'AM') {
        value = 'PM';
      }
      this.timeAmPm = value;
    },
    setHour: function setHour(add) {
      var self = this;
      var hour = self.timeHour;

      if (add) {
        var _value = hour + 1;
        if (hour === 12) {
          _value = 1;
        }
        self.timeHour = _value;
        return;
      }

      var value = hour - 1;
      if (hour === 1) {
        value = 12;
      }
      self.timeHour = value;
    },
    setMinute: function setMinute(add) {
      var self = this;
      var minute = self.timeMinute;

      if (add) {
        var _value2 = minute + 5;
        if (minute === 55) {
          _value2 = 0;
        }
        self.timeMinute = _value2;
        return;
      }

      var value = minute - 5;
      if (minute === 0) {
        value = 55;
      }
      self.timeMinute = value;
    }
  },
  watch: {
    gap: function gap(value) {
      if (value === null) {
        return;
      }

      var self = this;
      self.submitting = false;
      self.done = false;
      self.success = false;
      self.timeHour = parseInt(self.gap.start.format('hh'));
      self.timeMinute = parseInt(self.gap.start.format('mm'));
      self.timeAmPm = self.gap.start.format('A');
    }
  }
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_scrollto__ = __webpack_require__(2018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Calendar__ = __webpack_require__(2019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__report_generator__ = __webpack_require__(2023);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sector-list',
  components: { DatePicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a, CoverageCalendar: __WEBPACK_IMPORTED_MODULE_3__Calendar__["a" /* default */] },
  data: function data() {
    return {
      sectorName: '',
      generatingReport: false,
      openSector: []
    };
  },

  computed: {
    sectorItems: function sectorItems() {
      return this.$store.state.coverage.sectors.items;
    },
    sectorLoading: function sectorLoading() {
      return this.$store.state.coverage.sectors.loading;
    },

    filterSearch: {
      get: function get() {
        return this.$store.state.coverage.filters.search;
      },
      set: function set(value) {
        this.$store.commit('coverage/setCoverageFilterSearch', value);
      }
    },
    filterStartDate: {
      get: function get() {
        return this.$store.state.coverage.filters.startDate;
      },
      set: function set(value) {
        this.$store.commit('coverage/setCoverageFilterStartDate', value);
        var endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value);
        var format = 'MM/DD/YYYY hh:mm:ssA';
        var end = __WEBPACK_IMPORTED_MODULE_0_moment___default()(endDate.format('MM/DD/YYYY') + ' 11:59:59PM', format);
        this.$store.commit('coverage/setCoverageFilterEndDate', end.toDate());
      }
    },
    filterEndDate: {
      get: function get() {
        return this.$store.state.coverage.filters.endDate;
      },
      set: function set(value) {
        this.$store.commit('coverage/setCoverageFilterEndDate', value);
      }
    },
    filterBtnDisabled: function filterBtnDisabled() {
      var sectors = this.sectorItems;
      for (var i = 0; i < sectors.length; i++) {
        if (sectors[i].issueState === 'loading') {
          return true;
        }
      }
      return false;
    },
    refreshData: function refreshData() {
      return this.$store.state.coverage.sectors.refresh;
    },
    scrollSector: function scrollSector() {
      return this.$store.state.coverage.sectors.scrollElement;
    }
  },
  methods: {
    togglePanel: function togglePanel(index) {
      this.$store.commit('coverage/setCoverageSectorsPanelShow', index);

      if (this.$refs['coverageCalendar' + index][0].triggerShowCalendarInfo()) {
        this.$refs['coverageCalendar' + index][0].triggerShowCalendarInfo();
      }

      var sectorID = this.sectorItems[index].ID;
      if (this.openSector.indexOf(sectorID) === -1) {
        this.openSector.push(sectorID);
        this.$store.commit('coverage/setCoverageMapKml', sectorID);
        this.$store.commit('coverage/addKml', sectorID);
      } else {
        var _index = this.openSector.indexOf(sectorID);
        this.openSector.splice(_index, 1);
        this.$store.commit('coverage/removeKml', sectorID);
      }
    },
    setSectorName: function setSectorName() {
      var self = this;
      if (self.filterSelectedSector === -1) {
        self.sectorName = '';
        return;
      }

      for (var i = 0; i < self.filterSectors.length; i++) {
        var sector = self.filterSectors[i];
        if (sector.ID !== self.filterSelectedSector) {
          continue;
        }
        self.sectorName = sector.name;
        break;
      }
    },
    filterSectors: function filterSectors(refresh) {
      var self = this;
      self.$store.commit('coverage/setCoverageSectorsLoading', true);
      self.$sdk.get('/sectors', {
        token: self.$store.state.session.sessionToken,
        polygon: 1,
        pageSize: 50
      }, function (r) {
        self.$store.commit('coverage/setCoverageSectorsLoading', false);
        self.$store.commit('coverage/setCoverageReportSectors', []);
        if (r.error) {
          return;
        }
        // self.setSectorName()
        var sectors = [];
        for (var i = 0; i < r.list.length; i++) {
          var sector = r.list[i];
          sector['showPanel'] = false;
          sector['issueState'] = 'loading';
          sector['unassigned'] = [];
          sector['shiftGaps'] = [];
          sector['polygonOptions'] = {
            zIndex: 0,
            strokeWeight: 2,
            fillOpacity: 0.25
          };
          sector['bodyHeight'] = 0;
          sectors.push(sector);
        }
        self.$store.commit('coverage/setCoverageSectors', sectors);
        if (refresh) {
          setTimeout(function () {
            self.$store.commit('coverage/setCoverageFilterStartDate', __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.filterStartDate).toDate());
            self.$store.commit('coverage/setCoverageSectorsRefresh', false);
          }, 500);
        }
      });
    },
    generateReport: function generateReport() {
      var self = this;
      self.generatingReport = true;
      __WEBPACK_IMPORTED_MODULE_4__report_generator__["a" /* default */].generateReport(self, function () {
        self.generatingReport = false;
      });
    }
  },
  watch: {
    refreshData: function refreshData(value) {
      if (!value) {
        return;
      }
      this.filterSectors(true);
    },
    scrollSector: function scrollSector(value) {
      if (value === null) {
        return;
      }
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_2_vue_scrollto___default.a.scrollTo('#' + value, 250, {
          container: '#SectorListContainer',
          easing: 'ease-in',
          offset: -100,
          force: true,
          cancelable: true,
          onStart: function onStart(element) {
            // scrolling started
          },
          onDone: function onDone(element) {
            // scrolling is done
          },
          onCancel: function onCancel() {
            // scrolling has been interrupted
          },
          x: false,
          y: true
        });
      }, 500);
    }
  },
  mounted: function mounted() {
    var self = this;
    var now = __WEBPACK_IMPORTED_MODULE_0_moment___default()();
    var format = 'MM/DD/YYYY hh:mm:ssA';
    var start = __WEBPACK_IMPORTED_MODULE_0_moment___default()(now.format('MM/DD/YYYY') + ' 00:00:00AM', format);
    var end = __WEBPACK_IMPORTED_MODULE_0_moment___default()(now.format('MM/DD/YYYY') + ' 11:59:59PM', format); // moment().add(13, 'days')
    self.$store.commit('coverage/setCoverageFilterStartDate', start.toDate());
    self.$store.commit('coverage/setCoverageFilterEndDate', end.toDate());
    self.$store.commit('coverage/setCoverageMapShowPolygons', true);
    self.filterSectors();
  }
});

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'coverage-calendar',
  props: ['sector'],
  data: function data() {
    return {
      months: {},
      shownInfo: null,
      initializingCalendar: true,
      disabledButtons: false,
      servicesSorted: {}
    };
  },

  computed: {
    startDate: function startDate() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.$store.state.coverage.filters.startDate);
    },
    endDate: function endDate() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.$store.state.coverage.filters.endDate);
    },
    selectedSector: function selectedSector() {
      return this.$store.state.coverage.filters.selectedSector;
    },
    services: function services() {
      return this.$store.state.services.list;
    },
    serviceLoading: function serviceLoading() {
      return this.$store.state.services.serviceLoading;
    }
  },
  methods: {
    getServiceCode: function getServiceCode(id) {
      var services = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.serviceId;

      for (var prop in services) {
        if (!services.hasOwnProperty(prop)) {
          return;
        }

        if (services[prop] !== id) {
          continue;
        }
        return prop;
      }
    },
    getServiceLabel: function getServiceLabel(id) {
      var services = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.serviceId;

      for (var prop in services) {
        if (!services.hasOwnProperty(prop)) {
          return;
        }

        if (services[prop] !== id) {
          continue;
        }

        if (prop === 'shared') {
          return 'Shared Ride';
        } else if (prop === 'opoli') {
          return 'Direct Non-Stop';
        } else if (prop === 'black') {
          return 'Sedan';
        } else if (prop === 'suv') {
          return 'SUV';
        }
        return 'Private Van';
      }
    },
    getOpenCount: function getOpenCount(id) {
      var self = this;
      var result = 0;
      for (var i = 0; i < self.shownInfo.availableRsvp.length; i++) {
        var rsvp = self.shownInfo.availableRsvp[i];
        if (rsvp.serviceTypeId === id) {
          result++;
        }
      }
      return result;
    },
    getAvailableCount: function getAvailableCount(id) {
      var self = this;
      var result = 0;
      for (var i = 0; i < self.shownInfo.workDrivers.length; i++) {
        var driver = self.shownInfo.workDrivers[i];
        if (driver.services.indexOf(id) >= 0) {
          result++;
        }
      }

      return result;
    },
    findRsvpDrivers: function findRsvpDrivers(rsvp) {
      var self = this;
      self.disabledButtons = true;
      self.$store.commit('coverage/setCoverageMapShowPolygons', false);

      var url = '/admin/rsvp/' + rsvp.rsvpId;
      if (rsvp.packageID !== null) {
        url = '/admin/package/' + rsvp.packageID;
      }

      self.$sdk.get(url, {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.disabledButtons = false;
        if (r.error) {
          self.$store.commit('coverage/setCoverageMapRsvp', null);
          return;
        }
        if (r.package) {
          r.isPackage = true;
          // process stops
          var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(r.package.localPickupTime, 'YYYY-MM-DD HH:mm:ss Z');

          for (var i = 0; i < r.stops.length; i++) {
            var etaStopTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(start).add(r.stops[i].eta, 'seconds');
            r.stops[i]['etaTime'] = etaStopTime;
          }
        } else {
          r.isPackage = false;
          r.stops = [];
        }
        r['serviceTypeId'] = rsvp.serviceTypeId;
        self.$store.commit('coverage/setCoverageMapRsvp', r);
        self.$store.commit('coverage/setCoverageMapGap', null);
        self.$store.commit('coverage/setCoverageMapSector', self.sector);
      });
    },
    findCoverageDrivers: function findCoverageDrivers(gap) {
      var self = this;

      self.$store.commit('coverage/setCoverageMapShowPolygons', false);
      self.$store.commit('coverage/setCoverageMapRsvp', null);
      self.$store.commit('coverage/setCoverageMapGap', gap);
      self.$store.commit('coverage/setCoverageMapSector', self.sector);
    },
    initialize: function initialize() {
      var self = this;
      self.sector['workDrivers'] = [];
      self.sector['homeDrivers'] = [];
      self.sector['homebaseDrivers'] = [];
      self.sector['driverDropoff'] = [];
      self.sector['assignedRsvp'] = [];
      self.sector['availableRsvp'] = [];
      self.sector['shiftGaps'] = [];

      self.shownInfo = null;

      self.getCoverageInfo(self.sector.ID);
      // self.findSectorIssues(self.sector.ID)

      self.sortServicesByPriority();
    },
    sortServicesByPriority: function sortServicesByPriority() {
      var self = this;
      var services = self.services;

      function CustomSort(a, b) {
        var service1 = a['brandId'];
        var service2 = b['brandId'];
        if (service1 - service2 != 0) {
          return service1 - service2;
        } else {
          if (a.priority < b.priority) return -1;
          if (a.priority > b.priority) return 1;
          return 0;
        }
      }

      self.servicesSorted = services.sort(CustomSort);
    },
    initializeCalendar: function initializeCalendar() {
      var self = this;
      var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.startDate);
      var end = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.endDate);

      // self.log()

      self.months = {};
      while (end > start || start.format('M') === end.format('M')) {
        self.months[start.format('MMMM YYYY')] = {
          month: start.format('MM'),
          monthName: start.format('MMMM'),
          monthYear: start.format('YYYY'),
          days: []
        };
        start.add(1, 'month');
      }

      start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.startDate);
      end = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.endDate);

      for (var m = __WEBPACK_IMPORTED_MODULE_1_moment___default()(start); m.diff(end, 'days') <= 0; m.add(1, 'days')) {
        var monthKey = m.format('MMMM YYYY');
        var coverage = self.getCoverage(__WEBPACK_IMPORTED_MODULE_1_moment___default()(m));
        var dateObject = __WEBPACK_IMPORTED_MODULE_1_moment___default()(m);
        if (dateObject.isAfter(end)) {
          continue;
        }
        var day = {
          shiftGaps: coverage.shiftGaps,
          workDrivers: coverage.workDrivers,
          homeDrivers: coverage.homeDrivers,
          assignedRsvp: coverage.assignedRsvp,
          availableRsvp: coverage.availableRsvp,
          date: dateObject,
          show: false
        };
        self.months[monthKey].days.push(day);
      }

      for (var key in self.months) {
        if (!self.months.hasOwnProperty(key)) {
          continue;
        }
        var month = self.months[key];

        if (month.days.length <= 0) {
          continue;
        }

        var itemsToInsert = [];

        if (month.days[0].date.format('dddd') === 'Monday') {
          itemsToInsert.push(null);
        } else if (month.days[0].date.format('dddd') === 'Tuesday') {
          itemsToInsert.push(null);
          itemsToInsert.push(null);
        } else if (month.days[0].date.format('dddd') === 'Wednesday') {
          itemsToInsert.push(null);
          itemsToInsert.push(null);
          itemsToInsert.push(null);
        } else if (month.days[0].date.format('dddd') === 'Thursday') {
          itemsToInsert.push(null);
          itemsToInsert.push(null);
          itemsToInsert.push(null);
          itemsToInsert.push(null);
        } else if (month.days[0].date.format('dddd') === 'Friday') {
          itemsToInsert.push(null);
          itemsToInsert.push(null);
          itemsToInsert.push(null);
          itemsToInsert.push(null);
          itemsToInsert.push(null);
        } else if (month.days[0].date.format('dddd') === 'Saturday') {
          itemsToInsert.push(null);
          itemsToInsert.push(null);
          itemsToInsert.push(null);
          itemsToInsert.push(null);
          itemsToInsert.push(null);
          itemsToInsert.push(null);
        }

        for (var i = 0; i < itemsToInsert.length; i++) {
          self.months[key].days.unshift(itemsToInsert[i]);
        }
      }
      self.initializingCalendar = false;
      setTimeout(function () {
        self.$store.commit('coverage/addCoverageReportSector', {
          name: self.sector.name,
          id: self.sector.ID,
          data: self.months
        });
      }, 500);
    },
    getCoverageInfo: function getCoverageInfo(sectorId) {
      var self = this;
      var startMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.$store.state.coverage.filters.startDate);
      var endMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(self.$store.state.coverage.filters.endDate);

      self.$sdk.get('/sectors/' + sectorId + '/coverage', {
        token: self.$store.state.session.sessionToken,
        start: startMoment.format('YYYY-MM-DD'),
        end: endMoment.format('YYYY-MM-DD')
      }, function (r) {
        if (r.error) {
          setTimeout(function () {
            self.$store.commit('coverage/setCoverageSectorsIssueState', {
              id: sectorId,
              hasIssues: false,
              shiftGaps: [],
              unassigned: []
            });
          }, 500);
          self.sector.issueState = 'ok';
          self.sector.workDrivers = [];
          self.sector.homeDrivers = [];
          self.sector.homebaseDrivers = [];
          self.sector.driverDropoff = [];
          self.sector.assignedRsvp = [];
          self.sector.availableRsvp = [];
          self.sector.shiftGaps = [];
        } else {
          var shiftGaps = self.processShiftGaps(r.shiftGaps);
          setTimeout(function () {
            self.$store.commit('coverage/setCoverageSectorsIssueState', {
              id: sectorId,
              hasIssues: r.rsvpAvailable.length > 0, // (shiftGaps.length > 0 || r.rsvpAvailable.length > 0),
              shiftGaps: shiftGaps,
              unassigned: r.rsvpAvailable
            });
          }, 500);
          self.sector.issueState = r.rsvpAvailable.length > 0 ? 'has-issues' : 'ok';
          // (r.shiftGaps.length > 0 || r.rsvpAvailable.length > 0) ? 'has-issues' : 'ok'
          self.sector.workDrivers = r.driverWork;
          self.sector.homeDrivers = r.driverHome;
          self.sector.homebaseDrivers = r.profileHome;
          self.sector.driverDropoff = r.driverDropoff;
          self.sector.assignedRsvp = r.rsvpAssigned;
          self.sector.availableRsvp = r.rsvpAvailable;
          self.sector.shiftGaps = shiftGaps;
        }
        self.initializeCalendar();
      });
    },
    processShiftGaps: function processShiftGaps(gaps) {
      var now = __WEBPACK_IMPORTED_MODULE_1_moment___default()().unix();
      var result = [];

      for (var i = 0; i < gaps.length; i++) {
        var gap = gaps[i];
        if (gap.end < now) {
          continue;
        }

        if (gap.start < now) {
          var start = now;
          result.push({
            start: start,
            end: gap.end
          });
          continue;
        }

        result.push({
          start: gap.start,
          end: gap.end
        });
      }
      return result;
    },
    getCoverage: function getCoverage(date) {
      var self = this;
      var sector = self.sector;
      var result = {
        workDrivers: [],
        homeDrivers: [],
        assignedRsvp: [],
        availableRsvp: [],
        shiftGaps: []
      };
      var dateStr = date.format('MM/DD/YYYY');
      var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(dateStr + ' 00:00:00AM', 'MM/DD/YYYY hh:mm:ssA').unix();
      var end = __WEBPACK_IMPORTED_MODULE_1_moment___default()(dateStr + ' 11:59:59PM', 'MM/DD/YYYY hh:mm:ssA').unix();

      // work drivers
      for (var i = 0; i < sector.workDrivers.length; i++) {
        var driver = sector.workDrivers[i];

        if (driver.shiftStart >= start && driver.shiftStart <= end || driver.shiftEnd >= start && driver.shiftEnd <= end) {
          driver.shiftStart = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(driver.shiftStart);
          driver.shiftEnd = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(driver.shiftEnd);
          result.workDrivers.push(driver);
        }
      }

      // home drivers
      for (var _i = 0; _i < sector.homeDrivers.length; _i++) {
        var _driver = sector.homeDrivers[_i];

        if (_driver.shiftStart >= start && _driver.shiftStart <= end || _driver.shiftEnd >= start && _driver.shiftEnd <= end) {
          _driver.shiftStart = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(_driver.shiftStart);
          _driver.shiftEnd = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(_driver.shiftEnd);
          result.homeDrivers.push(_driver);
        }
      }

      // assigned rsvp
      for (var _i2 = 0; _i2 < sector.assignedRsvp.length; _i2++) {
        var rsvp = sector.assignedRsvp[_i2];

        if (rsvp.packageID !== null) {
          if (rsvp.firstPickup >= start && rsvp.firstPickup <= end) {
            rsvp.firstPickup = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(rsvp.firstPickup);
            rsvp.pickupTime = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(rsvp.pickupTime);
            result.assignedRsvp.push(rsvp);
          }
        } else {
          if (rsvp.pickupTime >= start && rsvp.pickupTime <= end) {
            rsvp.pickupTime = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(rsvp.pickupTime);
            result.assignedRsvp.push(rsvp);
          }
        }
      }

      // available rsvp
      for (var _i3 = 0; _i3 < sector.availableRsvp.length; _i3++) {
        var _rsvp = sector.availableRsvp[_i3];

        if (_rsvp.packageID !== null) {
          if (_rsvp.firstPickup >= start && _rsvp.firstPickup <= end) {
            _rsvp.firstPickup = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(_rsvp.firstPickup);
            _rsvp.pickupTime = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(_rsvp.pickupTime);
            result.availableRsvp.push(_rsvp);
          }
        } else {
          if (_rsvp.pickupTime >= start && _rsvp.pickupTime <= end) {
            _rsvp.pickupTime = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(_rsvp.pickupTime);
            result.availableRsvp.push(_rsvp);
          }
        }
      }

      // shift gaps
      var log = false;
      if (dateStr === '05/16/2019' && sector.ID === 10) {
        // console.log('LOG')
        log = false;
      }
      for (var _i4 = 0; _i4 < sector.shiftGaps.length; _i4++) {
        var startGap = sector.shiftGaps[_i4].start;
        var endGap = sector.shiftGaps[_i4].end;

        if (start > endGap || end < startGap) {
          continue;
        }

        if (log) {
          console.log('GAP: ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(startGap).format('MM/DD hh:mm:ss A') + ' - ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(endGap).format('MM/DD hh:mm:ss A'));
        }
        // if startGap and endGap falls within the day...
        if (startGap >= start && startGap <= end && endGap >= start && endGap <= end) {
          result.shiftGaps.push({
            start: __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(startGap),
            end: __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(endGap)
          });
          if (log) {
            console.log('1: ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(startGap).format('hh:mmA') + ' - ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(endGap).format('hh:mmA'));
          }
        } else if (start >= startGap && start <= endGap && end >= startGap && end <= endGap) {
          // entire day falls within the gap
          result.shiftGaps.push({
            start: __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(start),
            end: __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(end)
          });
          if (log) {
            console.log('2: ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(start).format('hh:mmA') + ' - ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(end).format('hh:mmA'));
          }
        } else if (start >= startGap && start < endGap) {
          result.shiftGaps.push({
            start: __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(start),
            end: __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(endGap)
          });
          if (log) {
            console.log('3: ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(start).format('hh:mmA') + ' - ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(endGap).format('hh:mmA'));
          }
        } else if (end >= startGap && end <= endGap) {
          result.shiftGaps.push({
            start: __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(startGap),
            end: __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(end)
          });
          if (log) {
            console.log('4: ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(startGap).format('hh:mmA') + ' - ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(end).format('hh:mmA'));
          }
        }
      }
      return result;
    },
    closeCalendarInfo: function closeCalendarInfo() {
      this.shownInfo = null;
      this.$store.commit('coverage/setCoverageMapShowPolygons', true);
      this.$store.commit('coverage/resetCoverageSectorBodyHeight', {
        id: this.sector.ID,
        bodyHeight: 'auto'
      });
    },
    showCalendarInfo: function showCalendarInfo(day) {
      if (day.availableRsvp.length <= 0 && day.shiftGaps.length <= 0) {
        // return
      }
      this.shownInfo = day;
      var multiplier = 0;
      // multiplier += day.shiftGaps.length
      if (day.workDrivers.length <= 0) {
        multiplier += 1;
      }
      multiplier += day.availableRsvp.length;
      multiplier += day.workDrivers.length;
      multiplier += day.assignedRsvp.length;
      if (day.availableRsvp.length <= 0 && day.assignedRsvp.length <= 0) {
        multiplier += 1;
      }
      if (day.shiftGaps.length <= 0 && day.workDrivers.length <= 0) {
        multiplier += 1;
      }
      this.$store.commit('coverage/resetCoverageSectorBodyHeight', {
        id: this.sector.ID,
        bodyHeight: 300 + 114 + 52.66 * multiplier + 'px'
      });
    },
    log: function log() {
      var self = this;
      var format = 'MM/DD/YYYY hh:mm:ssA';
      var sector = self.sector;
      var shiftGaps = sector.shiftGaps;
      console.log(sector.name, sector);

      // log shiftGaps
      console.log('- shift_gaps', shiftGaps);
      for (var i = 0; i < sector.shiftGaps.length; i++) {
        var start = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(sector.shiftGaps[i].start);
        var end = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(sector.shiftGaps[i].end);
        console.log('-- ' + start.format(format) + ' - ' + end.format(format));
      }
      console.log('- shift_gaps', sector.shiftGaps.length);

      // log rsvp available
      console.log('- rsvp available', sector.availableRsvp);
      for (var _i5 = 0; _i5 < sector.availableRsvp.length; _i5++) {
        console.log('-- ', sector.availableRsvp[_i5]);
      }
      console.log('- rsvp available', sector.availableRsvp.length);
    },
    getBrandCode: function getBrandCode(id) {
      var index = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.findIndex(function (x) {
        return x.id === id;
      });
      if (index === -1) {
        return '';
      }

      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[index].code.toUpperCase();
    },
    triggerShowCalendarInfo: function triggerShowCalendarInfo() {
      var monthData = this.months[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.months)[0]];
      var daysData = '';
      for (var index in monthData['days']) {
        if (monthData['days'][index]) {
          this.showCalendarInfo(monthData['days'][index]);
          return;
        }
      }
    }
  },
  watch: {
    startDate: function startDate(value) {
      this.initialize();
    },
    endDate: function endDate(value) {
      // this.initialize()
    },
    selectedSector: function selectedSector(value) {
      if (value === -1) {
        return;
      }
      this.initialize();
    }
  },
  mounted: function mounted() {
    var self = this;
    setTimeout(function () {
      self.initialize();
    }, 500);
  }
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dropzone__ = __webpack_require__(2029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TncReservationsControl__ = __webpack_require__(2037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResultsModal__ = __webpack_require__(2041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RoutingModal__ = __webpack_require__(2045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Map__ = __webpack_require__(2049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TncReservations__ = __webpack_require__(2053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UnroutedReservations__ = __webpack_require__(2061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DriverTnc__ = __webpack_require__(2069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DriverTcp__ = __webpack_require__(2073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DriverOutbound__ = __webpack_require__(2077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DriverInbound__ = __webpack_require__(2081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DriverControls__ = __webpack_require__(2085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ReadyToGoModal__ = __webpack_require__(2089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__NotesModal__ = __webpack_require__(2093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Partials_LoadingAnimation_Ellipsis__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_api_laxit_drivers__ = __webpack_require__(2099);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dispatch-laxit',
  components: { TncReservations: __WEBPACK_IMPORTED_MODULE_5__TncReservations__["a" /* default */], UnroutedReservations: __WEBPACK_IMPORTED_MODULE_6__UnroutedReservations__["a" /* default */], LaxitMap: __WEBPACK_IMPORTED_MODULE_4__Map__["a" /* default */], Dropzone: __WEBPACK_IMPORTED_MODULE_0__Dropzone__["a" /* default */], TncReservationsControl: __WEBPACK_IMPORTED_MODULE_1__TncReservationsControl__["a" /* default */], ResultsModal: __WEBPACK_IMPORTED_MODULE_2__ResultsModal__["a" /* default */], RoutingModal: __WEBPACK_IMPORTED_MODULE_3__RoutingModal__["a" /* default */], EllipsisLoader: __WEBPACK_IMPORTED_MODULE_14__components_Partials_LoadingAnimation_Ellipsis__["a" /* default */], DriverTnc: __WEBPACK_IMPORTED_MODULE_7__DriverTnc__["a" /* default */], DriverTcp: __WEBPACK_IMPORTED_MODULE_8__DriverTcp__["a" /* default */], DriverOutbound: __WEBPACK_IMPORTED_MODULE_9__DriverOutbound__["a" /* default */], DriverInbound: __WEBPACK_IMPORTED_MODULE_10__DriverInbound__["a" /* default */], DriverControls: __WEBPACK_IMPORTED_MODULE_11__DriverControls__["a" /* default */], ReadyToGoModal: __WEBPACK_IMPORTED_MODULE_12__ReadyToGoModal__["a" /* default */], NotesModal: __WEBPACK_IMPORTED_MODULE_13__NotesModal__["a" /* default */] },
  data: function data() {
    return {
      searchInput: '',
      activeTabIndex: 0,
      isMobile: false,
      showMapMobile: false
    };
  },

  computed: {
    tncLoading: function tncLoading() {
      return this.$store.state.laxit.tncReservations.isLoading;
    },
    tncList: function tncList() {
      return this.$store.state.laxit.tncReservations.list;
    },
    unroutedLoading: function unroutedLoading() {
      return this.$store.state.laxit.unroutedReservations.isLoading;
    },
    unroutedList: function unroutedList() {
      return this.$store.state.laxit.unroutedReservations.list;
    },
    _rtgSuccess: function _rtgSuccess() {
      return this.$store.state.laxit.readyToGo.success;
    },
    _dropzoneSaveSuccess: function _dropzoneSaveSuccess() {
      return this.$store.state.laxit.dropzone.saveSuccess;
    }
  },
  methods: {
    search: function search(e) {
      if (e.keyCode === 13) {
        this.$store.commit('laxit/setTncReservationsSearch', this.searchInput);
        this.refresh('tncReservations');

        this.$store.commit('laxit/setUnroutedReservationsSearch', this.searchInput);
        this.refresh('unrouted');
      }
    },
    onScrollPackage: function onScrollPackage(event) {
      var scrollAndView = event.target.scrollTop + event.target.offsetHeight;
      if (event.target.scrollHeight - scrollAndView < 150) {
        if (this.$refs.tncReservations.loadMore()) {
          this.$refs.routingPkgTable.loadMore();
        }
      }
    },
    onScrollUnpackage: function onScrollUnpackage(event) {
      var scrollAndView = event.target.scrollTop + event.target.offsetHeight;
      if (event.target.scrollHeight - scrollAndView < 150) {
        if (this.$refs.unrouted.loadMore()) {
          this.$refs.unrouted.loadMore();
        }
      }
    },
    getOndutyDrivers: function getOndutyDrivers() {
      var self = this;
      var laxit = self.$store.state.laxit.onDuty;

      if (laxit.loading) {
        return;
      }

      self.$store.commit('laxit/setOnDutyLoading', true);
      __WEBPACK_IMPORTED_MODULE_15__modules_api_laxit_drivers__["a" /* default */].getOnDutyDrivers(self, function (res) {
        self.$store.commit('laxit/setOnDutyLoading', false);
      });
    },
    refresh: function refresh(target) {
      if (target === 'tncReservations') {
        if (this.tncLoading) {
          return;
        }
        this.$store.commit('laxit/setTncReservationsCurrentPage', 1);
        this.$store.commit('laxit/resetTncReservationsList');
      } else {
        if (this.unroutedLoading) {
          return;
        }
        this.$store.commit('laxit/setUnroutedReservationsCurrentPage', 1);
        this.$store.commit('laxit/resetUnroutedReservationsList');
      }

      if (this.$refs[target].getList()) {
        this.$refs[target].getList();
      }
    },
    setScreenSize: function setScreenSize() {
      var self = this;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        self.isMobile = true;
      } else {
        self.isMobile = false;
      }
    }
  },
  watch: {
    _rtgSuccess: function _rtgSuccess(val) {
      var target = this.$store.state.laxit.readyToGo.table;
      if (val && target) {
        if (target === 'tncReservations') {
          this.$store.commit('laxit/resetTncReservationsList');
          if (this.$refs.tncReservations.getList()) {
            this.$refs.tncReservations.getList();
          }
        } else {
          this.$store.commit('laxit/resetUnroutedReservationsList');
          if (this.$refs.unrouted.getList()) {
            this.$refs.unrouted.getList();
          }
        }
      }
    },
    _dropzoneSaveSuccess: function _dropzoneSaveSuccess(val) {
      var self = this;
      if (val) {
        self.refresh('tncReservations');
        self.refresh('unrouted');
        setTimeout(function () {
          self.$store.commit('laxit/setDropzoneSaveSuccess', false);
        }, 1000);
      }
    }
  },
  mounted: function mounted() {
    this.setScreenSize();
    this.getOndutyDrivers();
  }
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DropzoneControls__ = __webpack_require__(2032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Partials_LoadingAnimation_MapMarker__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_api_featureToggle__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dropzone',
  components: { Draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a, DropzoneControls: __WEBPACK_IMPORTED_MODULE_3__DropzoneControls__["a" /* default */], LoaderMapMarker: __WEBPACK_IMPORTED_MODULE_4__components_Partials_LoadingAnimation_MapMarker__["a" /* default */] },
  data: function data() {
    return {
      overDropZone: false
    };
  },

  computed: {
    items: {
      get: function get() {
        return this.$store.state.laxit.dropzone.items.filter(function (x) {
          return x.mapOnly === false;
        });
      },
      set: function set(value) {
        // a rsvp dropoff should not occur before pickup
        var stops = value;

        var _loop = function _loop(i) {
          var rsvpID = stops[i].reservationID;
          var rsvps = stops.filter(function (stop) {
            return stop.reservationID === rsvpID;
          });
          if (rsvps.length < 2) {
            return {
              v: void 0
            };
          }
          if (!rsvps[0].isPickup) {
            return {
              v: void 0
            };
          }
        };

        for (var i = 0; i < stops.length; i++) {
          var _ret = _loop(i);

          if ((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
        }
        this.$store.commit('laxit/setDropzoneItems', value);
      }
    },
    showDropzone: function showDropzone() {
      return this.$store.state.laxit.dropzone.show;
    },
    checkRouteLoading: function checkRouteLoading() {
      return this.$store.state.laxit.dropzone.checkRoute;
    }
  },
  methods: {
    handleDrop: function handleDrop(data) {
      var self = this;
      var items = self.items;
      console.log(data);
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (data.type === 'package') {
          if (item.packageID === data.id) {
            return;
          }
        } else {
          if (item.reservationID === data.id) {
            return;
          }
        }
      }
      self.removeMapOnlyItems();
      self.$store.commit('laxit/addDropzoneItem', data);
      if (data.type === 'package' && data.driver && data.driver !== null) {
        self.$store.commit('laxit/addDropzoneDriver', {
          packageID: data.id,
          driver: data.driver
        });
      }
    },
    computeEta: function computeEta(stop) {
      var self = this;
      var firstStop = self.items[0];
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(firstStop.pickupTime, 'MM/DD/YYYY hh:mmA').add(stop.eta, 'seconds').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_5__modules_api_featureToggle__["a" /* default */].timeFormat(self, false));
    },
    computeMaxEta: function computeMaxEta(stop) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(stop.originalPickupTime, 'MM/DD/YYYY hh:mmA').add(stop.maxDuration, 'seconds').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_5__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
    },
    computeOriginalBTT: function computeOriginalBTT(stop) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(stop.originalPickupTime, 'MM/DD/YYYY hh:mmA').add(stop.originalBTT, 'seconds').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_5__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
    },
    showWarning: function showWarning(stop) {
      var self = this;
      var firstStop = self.items[0];
      var eta = __WEBPACK_IMPORTED_MODULE_1_moment___default()(firstStop.pickupTime, 'MM/DD/YYYY hh:mmA').add(stop.eta, 'seconds');
      var target = __WEBPACK_IMPORTED_MODULE_1_moment___default()(stop.originalPickupTime, 'MM/DD/YYYY hh:mmA').add(stop.originalBTT, 'seconds');
      if (stop.isPickup) {
        target = __WEBPACK_IMPORTED_MODULE_1_moment___default()(stop.pickupTime, 'MM/DD/YYYY hh:mmA');
      }
      return eta.isAfter(target);
    },
    hasIssues: function hasIssues(stop) {
      var self = this;
      var firstStop = self.items[0];
      var eta = __WEBPACK_IMPORTED_MODULE_1_moment___default()(firstStop.pickupTime, 'MM/DD/YYYY hh:mmA').add(stop.eta, 'seconds');
      var target = __WEBPACK_IMPORTED_MODULE_1_moment___default()(stop.originalPickupTime, 'MM/DD/YYYY hh:mmA').add(stop.originalBTT, 'seconds');
      if (stop.isPickup) {
        target = __WEBPACK_IMPORTED_MODULE_1_moment___default()(stop.originalPickupTime, 'MM/DD/YYYY hh:mmA');
      }
      if (eta.isAfter(target)) {
        return 'Will arrive ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(target.diff(eta)).humanize() + ' after the ' + (stop.isPickup ? 'Orginal Pickup Time.' : 'Be There Time.');
      }
      return 'Will arrive ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(target.diff(eta)).humanize() + ' before the ' + (stop.isPickup ? 'Original Pickup Time.' : 'Be There Time.');
    },
    getAddress: function getAddress(location) {
      if (location.geofenceType === 'airport' && location.geofenceName !== '') {
        var result = location.geofenceName;
        if (location.terminal && location.terminal !== '' && location.terminal !== 'undefined') {
          result += ' - Terminal ' + location.terminal;
        }
        return result;
      }
      return location.title;

      // let address = ''
      // if (location.address2 && location.address2 !== '' && location.address2 !== 'undefined') {
      //   address = address + location.address2 + ' '
      // }
      // if (location.address1) {
      //   address = address + location.address1 + ', '
      // }
      // if (location.city) {
      //   address = address + location.city + ' '
      // }
      // if (location.state) {
      //   address = address + location.state + ' '
      // }
      // if (location.zip) {
      //   address = address + location.zip
      // }

      // return address
    },
    removeFromMap: function removeFromMap(item) {
      var self = this;
      self.$store.commit('laxit/removeDropzoneItem', item);

      // remove dropzone driver
      self.removeDriver(item.packageID);
    },
    removeDriver: function removeDriver(packageID) {
      if (packageID === null) {
        return;
      }

      var self = this;
      var stops = self.$store.state.laxit.dropzone.items;
      if (stops.filter(function (stop) {
        return stop.packageID === packageID;
      }).length > 0) {
        return;
      }

      var drivers = self.$store.state.laxit.dropzone.drivers;
      var remainingDrivers = drivers.filter(function (item) {
        return item.packageID !== packageID;
      });
      self.$store.commit('laxit/setDropzoneDrivers', remainingDrivers);
    },
    removeMapOnlyItems: function removeMapOnlyItems() {
      if (this.$store.state.laxit.tncReservations.viewingInMap) {
        this.$store.commit('laxit/clearDropzone');
        this.$store.commit('laxit/setViewingInMap', false);
      }
    }
  }
});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dropzone-controls',
  computed: {
    items: function items() {
      return this.$store.state.laxit.dropzone.items.filter(function (x) {
        return x.mapOnly === false;
      });
    }
  },
  methods: {
    removeDuplicates: function removeDuplicates(items) {
      return items.filter(function (item, index, self) {
        return index === self.findIndex(function (p) {
          return p.reservationID === item.reservationID && p.reservationID === item.reservationID;
        });
      });
    },
    clearMap: function clearMap() {
      this.$store.commit('laxit/clearDropzone');
    },
    optimizeRoute: function optimizeRoute() {
      var self = this;
      var items = self.removeDuplicates(self.items);
      var rsvpIDs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(items, function (item) {
        return item.reservationID;
      });

      self.$store.commit('laxit/setCheckRouteLoading', true);
      self.$sdk.post('/admin/package/route', {
        token: self.$store.state.session.sessionToken,
        rsvpId: rsvpIDs
      }, function (r) {
        self.$store.commit('laxit/setCheckRouteLoading', false);
        if (r.error) {
          console.log(r);
          // SHOW error message
          return;
        }

        var packageRoute = r.BODY.PackageRoute[0].Passenger;

        var stops = [];

        var _loop = function _loop(i) {
          var isPickup = packageRoute[i].IsPickup[0] === '1';
          var rsvp = self.items.filter(function (item) {
            return item.reservationID === parseInt(packageRoute[i].ResID[0]) && item.isPickup === isPickup;
          })[0];

          stops.push({
            eta: parseInt(packageRoute[i].ETA[0]),
            maxDuration: parseInt(packageRoute[i].BTT[0]),
            originalBTT: rsvp.originalBTT,
            inOrder: i + 1,
            isPickup: isPickup,
            location: rsvp.location,
            luggage: rsvp.luggage,
            passengers: rsvp.passengers,
            reservationID: rsvp.reservationID,
            pickupTime: rsvp.pickupTime,
            originalPickupTime: rsvp.originalPickupTime,
            packageID: rsvp.packageID,
            status: rsvp.status
          });
        };

        for (var i = 0; i < packageRoute.length; i++) {
          _loop(i);
        }

        self.$store.commit('laxit/setDropzoneItems', stops);
      });
    },
    savePackage: function savePackage() {
      var self = this;
      self.$store.commit('laxit/showRoutingModal');

      var message = 'Are you sure you want to save this package?';
      var action = 'SAVE_PACKAGE';
      if (self.$store.state.laxit.dropzone.drivers.length === 1) {
        var driver = self.$store.state.laxit.dropzone.drivers[0].driver;
        message = 'Do you want to keep the assignment of this package to ' + '<a href="/#/provider/' + driver.ID + '" target="_blank">' + driver.firstName + ' ' + driver.lastName + '</a>?';
        action = 'SAVE_PACKAGE_KEEP_DRIVER';
      }
      if (self.$store.state.laxit.dropzone.drivers.length > 1) {
        message = 'Please select one driver to assign the package to:';
        action = 'SAVE_PACKAGE_MULTIPLE_DRIVERS';
      }
      self.$store.commit('laxit/setConfirmationModal', {
        show: true,
        title: 'Confirm Package',
        message: message,
        action: action
      });
    }
  }
});

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tnc-reservations-control',
  data: function data() {
    return {
      disableBreakPkg: false
    };
  },

  computed: {
    checkPkgs: function checkPkgs() {
      return this.$store.state.laxit.tncReservations.checked;
    }
  },
  methods: {
    isValid: function isValid(title, message) {
      var self = this;
      var checkedPackages = self.$store.state.laxit.tncReservations.checked;
      if (checkedPackages.length <= 0 || checkedPackages.length > 1) {
        self.$store.commit('laxit/showRoutingModal');
        self.$store.commit('laxit/setRoutingValidationModal', {
          show: true,
          title: title,
          message: message
        });
        return false;
      }
      return true;
    },
    moveToPool: function moveToPool() {
      var self = this;
      if (!self.isValid('You missed something', 'Please select only 1 reservation/package to move to the pool.')) {
        return;
      }

      var tncReservations = self.$store.state.laxit.tncReservations;
      var checkedId = tncReservations.checked[0];
      var index = tncReservations.list.findIndex(function (x) {
        return x.id === checkedId;
      });
      var checkedData = tncReservations.list[index];
      var url = checkedData.type === 'rsvp' ? '/admin/rsvp/' : '/admin/package/';

      self.$store.commit('laxit/showRoutingModal');
      var type = checkedData.type === 'rsvp' ? 'reservation' : 'package';
      self.$store.commit('laxit/setRoutingAjaxModal', {
        show: true,
        loading: true,
        success: false,
        message: 'Moving ' + type + ' to pool...'
      });
      self.$sdk.post(url + checkedId + '/pool', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        var success = true;
        var message = 'Successfully moved ' + type + ' ' + checkedId + ' to the pool.';
        if (r.error) {
          console.log(r);
          success = false;
          message = 'Oops. Something went wrong. Please try again later.';
        } else {
          self.$store.commit('laxit/setTncReservationsChecked', []);
        }
        self.$store.commit('laxit/setRoutingAjaxModal', {
          show: true,
          loading: false,
          success: success,
          message: message
        });

        setTimeout(function () {
          self.$store.commit('laxit/hideRoutingModal');
        }, 1000);
      });
    },
    removeFromPool: function removeFromPool() {
      var self = this;
      if (!self.isValid('You missed something', 'Please select only 1 reservation/package to remove from the pool.')) {
        return;
      }

      var checkedPackages = self.$store.state.laxit.tncReservations.checked;

      var tncReservations = self.$store.state.laxit.tncReservations;
      var checkedId = tncReservations.checked[0];
      var index = tncReservations.list.findIndex(function (x) {
        return x.id === checkedId;
      });
      var checkedData = tncReservations.list[index];
      var url = checkedData.type === 'rsvp' ? '/admin/rsvp/' : '/admin/package/';

      self.$store.commit('laxit/showRoutingModal');
      var type = checkedData.type === 'rsvp' ? 'reservation' : 'package';
      self.$store.commit('laxit/setRoutingAjaxModal', {
        show: true,
        loading: true,
        success: false,
        message: 'Removing to ' + type + ' ' + checkedId + ' pool...'
      });
      self.$sdk.delete(url + checkedId + '/pool', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        var success = true;
        var message = 'Successfully removed ' + type + ' ' + checkedId + ' from the pool.';
        if (r.error) {
          console.log(r);
          success = false;
          message = 'Oops. Something went wrong. Please try again later.';
        } else {
          self.$store.commit('laxit/setTncReservationsChecked', []);
        }
        self.$store.commit('laxit/setRoutingAjaxModal', {
          show: true,
          loading: false,
          success: success,
          message: message
        });

        setTimeout(function () {
          self.$store.commit('laxit/hideRoutingModal');
        }, 1000);
      });
    },
    breakPackage: function breakPackage() {
      var self = this;
      var tncReservations = self.$store.state.laxit.tncReservations;
      var checkedId = tncReservations.checked[0];
      var index = tncReservations.list.findIndex(function (x) {
        return x.id === checkedId;
      });
      var checkedData = tncReservations.list[index];

      if (checkedData.type === 'rsvp') {
        self.$store.commit('laxit/showRoutingModal');
        self.$store.commit('laxit/setRoutingValidationModal', {
          show: true,
          title: 'Oops',
          message: 'Please select only package to break.'
        });
        return;
      }

      if (!self.isValid('You missed something', 'Please select only 1 package to break.')) {
        return;
      }

      self.$store.commit('laxit/showRoutingModal');
      self.$store.commit('laxit/setRoutingAjaxModal', {
        show: true,
        loading: true,
        success: false,
        message: 'Breaking package ' + checkedId + '...'
      });
      self.$sdk.delete('/admin/package/' + checkedId, {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        var success = true;
        var message = 'Successfully broken package ' + checkedId + '.';
        if (r.error) {
          console.log(r);
          success = false;
          message = 'Oops. Something went wrong. Please try again later.';
        }
        self.$store.commit('laxit/setRoutingAjaxModal', {
          show: true,
          loading: false,
          success: success,
          message: message
        });

        if (success) {
          // self.$store.commit('laxit/removePackageItem', checkedId)
          self.$store.commit('laxit/removeTncReservationsChecked');
        }

        setTimeout(function () {
          self.$store.commit('laxit/hideRoutingModal');
        }, 1000);
      });
    },
    markAsComplete: function markAsComplete() {
      var self = this;

      var tncReservations = self.$store.state.laxit.tncReservations;
      var checkedId = tncReservations.checked[0];
      var index = tncReservations.list.findIndex(function (x) {
        return x.id === checkedId;
      });
      var checkedData = tncReservations.list[index];

      // let rsvps = self.$store.state.laxit.tncReservations.checked
      if (!self.isValid('Oops. You missed something.', 'Please select only 1 reservation/package to mark as complete.')) {
        return;
      }

      if (!self.canMarkAsComplete(checkedData)) {
        self.$store.commit('laxit/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You cannot mark as complete Cancelled or Completed reservations/packages.'
        });
        return;
      }

      // let rsvp = rsvps[0]

      self.$store.commit('reservationNotes/show', {
        show: true,
        rsvpId: checkedData.id,
        isPackage: checkedData.type !== 'rsvp',
        forComplete: true
      });
      return;
    },
    canMarkAsComplete: function canMarkAsComplete(items) {
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (item.status === 'complete' || item.status === 'completed' || item.status === 'canceled') {
          return false;
        }
      }
      return true;
    }
  },
  watch: {
    checkPkgs: function checkPkgs(value) {
      var _this = this;

      var pkgs = this.$store.state.laxit.tncReservations.list;
      this.disableBreakPkg = false;

      var _loop = function _loop(index) {
        var pkgIndex = pkgs.findIndex(function (x) {
          return x.id === value[index];
        });
        if (pkgs[pkgIndex].driver && pkgs[pkgIndex].driver.ID) {
          _this.disableBreakPkg = true;
        }
      };

      for (var index in value) {
        _loop(index);
      }
    }
  }
});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'results-modal',
  computed: {
    validationModal: function validationModal() {
      return this.$store.state.laxit.validationModal;
    },
    actionModal: function actionModal() {
      return this.$store.state.laxit.actionModal;
    }
  },
  methods: {
    close: function close() {
      this.$store.commit('laxit/closeValidationModal');
    }
  },
  mounted: function mounted() {
    var self = this;
    document.addEventListener('keydown', function (e) {
      if (self.validationModal.show && e.keyCode == 27) {
        self.$store.commit('laxit/closeValidationModal');
      }
    });
  }
});

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'routing-modal',
  computed: {
    modal: function modal() {
      return this.$store.state.laxit.routingModal;
    },
    hasMultipleDrivers: function hasMultipleDrivers() {
      return this.$store.state.laxit.dropzone.drivers.length > 1;
    },
    dropzoneDrivers: function dropzoneDrivers() {
      return this.$store.state.laxit.dropzone.drivers;
    }
  },
  methods: {
    close: function close() {
      if (this.$store.state.laxit.routingModal.ajax.show) {
        return;
      }
      this.$store.commit('laxit/hideRoutingModal');
    },
    confirmAction: function confirmAction() {
      var self = this;
      var action = self.modal.confirmation.action;
      if (action === 'SAVE_PACKAGE') {
        self.savePackage(null);
        return;
      }
      if (action === 'SAVE_PACKAGE_KEEP_DRIVER') {
        // There's only one driver
        var driver = self.$store.state.laxit.dropzone.drivers[0].driver;
        self.savePackage(driver.ID);
        return;
      }
    },
    closeAction: function closeAction() {
      var self = this;
      var action = self.modal.confirmation.action;
      if (action === 'SAVE_PACKAGE_KEEP_DRIVER') {
        self.savePackage(null);
        return;
      }
      if (this.$store.state.laxit.routingModal.ajax.show) {
        return;
      }
      this.$store.commit('laxit/hideRoutingModal');
    },
    savePackage: function savePackage(provId) {
      var self = this;
      var stops = self.$store.state.laxit.dropzone.items;

      self.$store.commit('laxit/resetConfirmationModal');
      self.$store.commit('laxit/setRoutingAjaxModal', {
        show: true,
        loading: true,
        success: false,
        message: 'Saving package...'
      });

      var request = {
        token: self.$store.state.session.sessionToken,
        provId: provId,
        items: []
      };
      for (var i = 0; i < stops.length; i++) {
        request.items.push({
          rsvpId: stops[i].reservationID,
          pickup: stops[i].isPickup,
          eta: stops[i].eta,
          maxDuration: stops[i].maxDuration
        });
      }

      self.$sdk.post('/admin/package/save', request, function (r) {
        var success = true;
        var message = 'Successfully saved package!';
        if (r.error) {
          console.log(r);
          success = false;
          message = 'Oops. Something went wrong. Please try again later.';
        }

        self.$store.commit('laxit/setRoutingAjaxModal', {
          show: true,
          loading: false,
          success: success,
          message: message
        });

        if (success) {
          self.$store.commit('laxit/clearDropzone');
          self.$store.commit('laxit/setDropzoneSaveSuccess', true);
        }

        setTimeout(function () {
          self.$store.commit('laxit/hideRoutingModal');
        }, 1000);
      });
    }
  }
});

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__values_map_settings__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__values_map_pin__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__ = __webpack_require__(5);

//
//
//
//
//
//

/* global CONFIG */





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'laxit-map',
  data: function data() {
    return {
      hereMaps: {
        map: {},
        platform: {},
        router: {},
        geocoder: {},
        directions: [],
        ui: {}
      },
      mapOptions: __WEBPACK_IMPORTED_MODULE_2__values_map_settings__["a" /* default */],
      pickupPin: __WEBPACK_IMPORTED_MODULE_3__values_map_pin__["a" /* default */].pickup,
      dropoffPin: __WEBPACK_IMPORTED_MODULE_3__values_map_pin__["a" /* default */].dropoff,
      mapPins: [],
      infoWindows: [],
      route: [],
      routes: [],
      center: { lat: 33.942791, lng: -118.410042 }
    };
  },

  computed: {
    items: function items() {
      return this.$store.state.laxit.dropzone.items;
    }
  },
  watch: {
    items: function items(value) {
      var self = this;

      self.hereMaps.ui.getBubbles().forEach(function (bub) {
        bub.close();
      });
      self.hereMaps.ui.removeBubble(self.hereMaps.ui.getBubbles());
      self.hereMaps.map.removeObjects(self.hereMaps.map.getObjects());

      if (value.length <= 0) {
        self.route = [];
        self.routes = [];
        self.mapPins = [];
        self.infoWindows = [];
        return;
      }

      setTimeout(function () {
        self.setMapPins();
      }, 400);
    }
  },
  methods: {
    closeInfoWindow: function closeInfoWindow(index) {
      var self = this;
      self.infoWindows[index].opened = false;
    },
    openInfoWindow: function openInfoWindow(index) {
      var self = this;
      self.infoWindows[index].opened = true;
    },
    computeEta: function computeEta(pin) {
      var self = this;
      var firstStop = self.items[0];
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(firstStop.pickupTime, 'MM/DD/YYYY hh:mmA').add(pin.eta, 'seconds').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__["a" /* default */].timeFormat(self, false));
    },
    computeMaxEta: function computeMaxEta(pin) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(pin.pickupTime, 'MM/DD/YYYY hh:mmA').add(pin.maxDuration, 'seconds').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
    },
    computeOriginalBTT: function computeOriginalBTT(pin) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(pin.originalPickupTime, 'MM/DD/YYYY hh:mmA').add(pin.originalBTT, 'seconds').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_4__modules_api_featureToggle__["a" /* default */].timeFormat(this, false));
    },
    setMapPins: function setMapPins() {
      var self = this;
      self.mapPins = [];
      self.infoWindows = [];

      self.items.forEach(function (item, i) {
        self.mapPins.push({
          lat: item.location.lat,
          lng: item.location.lng,
          isPickup: item.isPickup,
          reservationID: item.reservationID,
          packageID: item.packageID,
          pickupTime: item.pickupTime,
          originalPickupTime: item.originalPickupTime,
          originalBTT: item.originalBTT,
          eta: item.eta,
          maxDuration: item.maxDuration,
          opened: true
        });
        self.infoWindows.push(self.mapPins[i]);

        var content = '<div class="here-info-window-content routing">' + '<div class="stop-id"><span class="index {IS_PICKUP}">{INDEX}</span>' + '<span>ID: </span><a href="/#/reservation/{RSVP_ID}" target="_blank">{RSVP_ID}</a>' + '{IF_PKG}</div>{IF_PICKUP}</div>';
        content = content.replace('{INDEX}', i + 1).split('{RSVP_ID}').join(item.reservationID).replace('{IS_PICKUP}', item.isPickup ? 'pickup' : '');

        var ifPkg = '';
        if (item.packageID !== null) {
          ifPkg = '<a href="/#/package/' + item.packageID + '" target="_blank">' + item.packageID + '</a>';
        }
        content = content.replace('{IF_PKG}', ifPkg);

        var ifPickup = '';
        if (item.isPickup) {
          ifPickup = '<div class="stop-put">PUT: <span class="value">' + item.originalPickupTime + '</span></div>';
        }
        if (i > 0) {
          ifPickup = ifPickup + '<div class="stop-eta">ETA: <span class="value">' + self.computeEta(item) + '</span></div>';
        }
        if (i > 0 && !item.isPickup) {
          ifPickup = ifPickup + '<div class="stop-btt">BTT: <span class="value">' + self.computeOriginalBTT(item) + '</span></div>';
        }
        content = content.replace('{IF_PICKUP}', ifPickup);

        // Pickup/Dropoff icon
        var marker = '<svg height="25" width="25" style="overflow: unset" viewBox="0 0 50 50">' + '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' + 'stroke-width="{STROKE_WIDTH}" /></svg>';

        var pickupDropoff = item.isPickup ? 'pickup' : 'dropoff';

        marker = marker.replace('{D}', __WEBPACK_IMPORTED_MODULE_3__values_map_pin__["a" /* default */][pickupDropoff].path).replace('{FILL}', __WEBPACK_IMPORTED_MODULE_3__values_map_pin__["a" /* default */][pickupDropoff].fillColor).replace('{STROKE}', __WEBPACK_IMPORTED_MODULE_3__values_map_pin__["a" /* default */][pickupDropoff].strokeColor).replace('{STROKE_WIDTH}', __WEBPACK_IMPORTED_MODULE_3__values_map_pin__["a" /* default */][pickupDropoff].strokeWeight);
        var icon = new window.H.map.DomIcon(marker);
        var coords = { lat: item.location.lat, lng: item.location.lng };
        var pin = new window.H.map.DomMarker(coords, { icon: icon });
        pin.id = 'marker' + i;
        pin.lat = item.location.lat;
        pin.lng = item.location.lng;
        var bubble = new window.H.ui.InfoBubble(coords, { content: content });
        bubble.id = (item.isPickup ? 'pickup' : 'dropoff') + item.reservationID;
        self.hereMaps.ui.addBubble(bubble);
        bubble.addEventListener('tap', function (evt) {
          bubble.open();
        }, false);
        self.hereMaps.map.addObject(pin);
      });

      self.setRoute();
    },
    setRoute: function setRoute() {
      var self = this;
      // self.setMapPins()
      // self.setCenter()

      self.routes = [];
      var duration = 0;
      for (var i = 0; i < self.items.length - 1; i++) {
        var leg = self.items[i];
        var nextLeg = self.items[i + 1];

        self.calculateRoute(leg, nextLeg);
      }
    },
    calculateRoute: function calculateRoute(origin, destination) {
      var self = this;
      var router = self.hereMaps.platform.getRoutingService(null, 8);
      var routeRequestParams = {
        routingMode: 'fast',
        transportMode: 'car',
        origin: origin.location.lat + ',' + origin.location.lng,
        destination: destination.location.lat + ',' + destination.location.lng,
        return: 'polyline,turnByTurnActions,actions,instructions,travelSummary'
      };

      router.calculateRoute(routeRequestParams, self.onCalculateSuccess.bind(null, destination), self.onCalculateError);
    },
    onCalculateSuccess: function onCalculateSuccess(nextLeg, result) {
      if (!result.routes.length) return;
      var route = result.routes[0].sections[0];
      this.$store.commit('laxit/updateDropzoneEta', {
        leg: nextLeg, eta: route.travelSummary.baseDuration
      });
      this.addRouteShapeToMap(route);
    },
    onCalculateError: function onCalculateError(data) {
      console.error('ROUTING ERROR', data);
    },
    addRouteShapeToMap: function addRouteShapeToMap(route) {
      // let lineString = new window.H.geo.LineString()
      // let routeShape = route.shape
      // let polyline = ''

      // routeShape.forEach(function (point) {
      //   let parts = point.split(',');
      //   lineString.pushLatLngAlt(parts[0], parts[1]);
      // })

      // polyline = new window.H.map.Polyline(lineString, {
      //   style: {
      //     lineWidth: 4,
      //     strokeColor: 'rgba(25, 25, 25, 0.7)'
      //   }
      // })
      var linestring = window.H.geo.LineString.fromFlexiblePolyline(route.polyline);
      var polyline = new window.H.map.Polyline(linestring, {
        style: {
          lineWidth: 4,
          strokeColor: 'rgba(25, 25, 25, 0.7)'
        }
      });
      polyline.id = 'rsvpRoute';

      this.hereMaps.map.addObject(polyline);
      this.hereMaps.map.getViewModel().setLookAtData({
        bounds: polyline.getBoundingBox()
      });

      this.setCenter();
    },
    setCenter: function setCenter() {
      var self = this;
      var group = new window.H.map.Group();
      var circles = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(self.hereMaps.map.getObjects()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var object = _step.value;

          if (object.id && object.id.indexOf('marker') > -1) {
            var circle = new window.H.map.Circle(new window.H.geo.Point(object.lat, object.lng), 15000, { style: { fillColor: 'rgba(0, 0, 0, 0)', strokeColor: 'rgba(0, 0, 0, 0)' } });
            circles.push(circle);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      group.addObjects(circles);
      group.id = 'groupBound';
      self.hereMaps.map.addObject(group);
      self.hereMaps.map.getViewModel().setLookAtData({
        bounds: group.getBoundingBox()
      });
    }
  },
  mounted: function mounted() {
    var self = this;
    var mapContainer = document.getElementById('mapHere2');
    self.hereMaps.platform = new window.H.service.Platform({ apikey: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.hereApi.key });

    var defaultLayers = self.hereMaps.platform.createDefaultLayers();
    self.hereMaps.map = new window.H.Map(mapContainer, defaultLayers.vector.normal.map, {
      center: self.center,
      zoom: 13,
      pixelRatio: window.devicePixelRatio || 1
    });

    /* eslint-disable no-unused-vars */
    var behavior = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(self.hereMaps.map));
    /* eslint-enable no-unused-vars */
    self.hereMaps.ui = window.H.ui.UI.createDefault(self.hereMaps.map, defaultLayers);
  }
});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_laxit_reservations__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TncReservationsRow__ = __webpack_require__(2056);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tnc-reservations',
  components: { TncReservationsRow: __WEBPACK_IMPORTED_MODULE_1__TncReservationsRow__["a" /* default */] },
  props: ['isMobile'],
  data: function data() {
    return {
      checkAll: false
    };
  },

  computed: {
    loading: function loading() {
      return this.$store.state.laxit.tncReservations.isLoading;
    },
    currentOrder: function currentOrder() {
      var laxit = this.$store.state.laxit.tncReservations;
      return { field: laxit.order, asc: laxit.orderAsc };
    },
    items: function items() {
      return this.$store.state.laxit.tncReservations.list;
    },
    checkedPackages: function checkedPackages() {
      return this.$store.state.laxit.tncReservations.checked;
    },
    inMap: function inMap() {
      var self = this;
      var mapItems = self.$store.state.laxit.dropzone.items;
      var item = mapItems.filter(function (mapItem) {
        return mapItem.packageID === self.opPackage.id;
      });
      return item.length > 0;
    },
    isLastPage: function isLastPage() {
      var tncReservations = this.$store.state.laxit.tncReservations;
      return tncReservations.currentPage * tncReservations.perPage >= tncReservations.maxList;
    }
  },
  methods: {
    getList: function getList() {
      var self = this;
      if (self.loading) {
        return;
      }

      self.$store.commit('laxit/setTncReservationsIsLoading', true);
      __WEBPACK_IMPORTED_MODULE_0__modules_api_laxit_reservations__["a" /* default */].getPackages(self, function (res) {
        self.$store.commit('laxit/setTncReservationsIsLoading', false);
      });
    },
    sort: function sort(field) {
      if (this.loading) {
        return;
      }
      var laxit = this.$store.state.laxit.tncReservations;
      if (field !== laxit.order) {
        this.$store.commit('laxit/setTncReservationsOrderAsc', 1);
      } else {
        this.$store.commit('laxit/setTncReservationsOrderAsc', laxit.orderAsc === 1 ? 0 : 1);
      }
      this.$store.commit('laxit/setTncReservationsOrder', field);
      this.$store.commit('laxit/setTncReservationsCurrentPage', 1);
      this.$store.commit('laxit/resetTncReservationsList');
      this.getList();
    },
    loadMore: function loadMore() {
      if (this.isLastPage || this.loading) {
        return;
      }
      this.$store.commit('laxit/setTncReservationsCurrentPage', this.$store.state.laxit.tncReservations.currentPage + 1);
      this.getList();
    },
    toggleAll: function toggleAll() {
      var id = [];
      if (!this.checkAll) {
        var tncReservations = this.$store.state.laxit.tncReservations;
        tncReservations.list.forEach(function (item) {
          id.push(item.id);
        });
      }
      this.$store.commit('laxit/setTncReservationsChecked', id);
    }
  },
  watch: {
    checkedPackages: function checkedPackages(val) {
      this.checkAll = val.length === this.items.length;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$store.commit('laxit/resetTncReservationsList');
    self.getList();
  }
});

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Partials_SVG_ServiceDog__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Partials_SVG_Wheelchair__ = __webpack_require__(96);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tnc-reservations-row',
  data: function data() {
    return {
      hereMaps: {
        platform: {}
      },
      etaPopup: {
        show: false,
        loading: false,
        label: ''
      }
    };
  },

  props: ['opPackage', 'isMobile'],
  components: { SvgDog: __WEBPACK_IMPORTED_MODULE_1__components_Partials_SVG_ServiceDog__["a" /* default */], SvgWheelchair: __WEBPACK_IMPORTED_MODULE_2__components_Partials_SVG_Wheelchair__["a" /* default */] },
  computed: {
    inMap: function inMap() {
      var self = this;
      var mapItems = self.$store.state.laxit.dropzone.items;
      var item = '';
      if (self.opPackage.type === 'rsvp') {
        item = mapItems.filter(function (mapItem) {
          return mapItem.reservationID === self.opPackage.id && mapItem.packageID === null;
        });
      } else {
        item = mapItems.filter(function (mapItem) {
          return mapItem.packageID === self.opPackage.id;
        });
      }
      return item.length > 0;
    },

    checkedPackages: {
      get: function get() {
        return this.$store.state.laxit.tncReservations.checked;
      },
      set: function set(value) {
        this.$store.commit('laxit/setUnroutedReservationsChecked', []);
        this.$store.commit('laxit/setTncReservationsChecked', value);
      }
    }
  },
  methods: {
    dragstart: function dragstart() {
      if (this.opPackage.type !== 'rsvp') {
        this.$store.commit('laxit/setDropzoneShow', true);
      }
    },
    toggleInMap: function toggleInMap() {
      var self = this;
      if (self.inMap) {
        self.$store.commit('laxit/removeDropzoneItems', self.opPackage);
        if (self.opPackage.driver !== null) {
          self.$store.commit('laxit/removeDropzoneDriver', {
            packageID: self.opPackage.id,
            driver: self.opPackage.driver
          });
        }
        return;
      }

      var isRsvp = self.opPackage.type === 'rsvp';
      var dropzone = self.$store.state.laxit.dropzone;
      if (isRsvp || dropzone.items[0] && dropzone.items[0].mapOnly) {
        self.$store.commit('laxit/clearDropzone');
      }

      self.$store.commit('laxit/setViewingInMap', isRsvp);

      // let temp = {...self.opPackage, mapOnly: isRsvp}
      self.opPackage.legs.forEach(function (leg, index) {
        self.opPackage.legs[index].mapOnly = isRsvp;
      });
      // console.log('temp', temp)
      self.$store.commit('laxit/addDropzoneItem', self.opPackage);
      if (self.opPackage.driver !== null) {
        self.$store.commit('laxit/addDropzoneDriver', {
          packageID: self.opPackage.id,
          driver: self.opPackage.driver
        });
      }
    },
    getAddress: function getAddress(location) {
      if (location.geofenceType === 'airport' && location.geofenceName !== '') {
        var result = location.geofenceName;
        if (location.terminal && location.terminal !== '' && location.terminal !== 'undefined') {
          result += ' - Terminal ' + location.terminal;
        }
        return result;
      }
      return location.title;

      // let address = ''
      // if (location.address2 && location.address2 !== '' && location.address2 !== 'undefined') {
      //   address = address + location.address2 + ' '
      // }
      // if (location.address1) {
      //   address = address + location.address1 + ', '
      // }
      // if (location.city) {
      //   address = address + location.city + ' '
      // }
      // if (location.state) {
      //   address = address + location.state + ' '
      // }
      // if (location.zip) {
      //   address = address + location.zip
      // }

      // return address
    },
    callPhone: function callPhone(info) {
      var self = this;
      self.$plugins.phone.startCall(self, {
        phone: info.phone,
        name: info.firstName + ' ' + info.lastName
      });
    },
    showEtaPopup: function showEtaPopup(e) {
      var self = this;
      self.etaPopup.show = true;
      if (self.opPackage.driver === null) {
        self.etaPopup.loading = false;
        self.etaPopup.label = 'Cannot find the driver.';
        return;
      }
      self.etaPopup.loading = true;
      self.etaPopup.label = '';

      self.$sdk.get('/provider/' + self.opPackage.driver.ID + '/tracks', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          self.etaPopup.loading = false;
          self.etaPopup.label = 'Cannot find the driver.';
          return;
        }

        if (r.list.length <= 0) {
          self.etaPopup.loading = false;
          self.etaPopup.label = 'Cannot find the driver.';
          return;
        }
        var location = r.list[0];
        var waypoints = [];
        waypoints.push(location);

        var legs = self.opPackage.legs;
        for (var i = 0; i < legs.length; i++) {
          var leg = legs[i];

          if (!leg.isPickup && leg.status === 'ONTHEWAY') {
            waypoints.push({
              lat: leg.location.lat,
              lng: leg.location.lng
            });
            continue;
          }

          if (!leg.isPickup && (leg.status === 'ONBOARD' || leg.status === 'ONTHEWAY')) {
            waypoints.push({
              lat: leg.location.lat,
              lng: leg.location.lng
            });
            continue;
          }
        }

        // let request = {
        //   origin: waypoints.shift(),
        //   destination: waypoints.pop(),
        //   travelMode: google.maps.TravelMode.DRIVING // eslint-disable-line no-undef
        // }

        var stopovers = [];
        for (var _i = 0; _i < waypoints.length; _i++) {
          stopovers.push({
            location: { lat: waypoints[_i].lat, lng: waypoints[_i].lng },
            stopover: false
          });
        }

        // if (stopovers.length > 0) {
        //   request.waypoints = stopovers
        // }

        var origin = [].concat(waypoints).shift();
        var destination = [].concat(waypoints).pop();
        self.calculateRoute(origin, destination);
        // let direction = new google.maps.DirectionsService() // eslint-disable-line no-undef
        // direction.route(request, (response, status) => {
        //   self.etaPopup.loading = false
        //   if (status !== google.maps.DirectionsStatus.OK) { // eslint-disable-line no-undef
        //     self.etaPopup.label = 'Cannot find the driver.'
        //     return
        //   }

        //   let legs = response.routes[0].legs
        //   let duration = 0
        //   for (let j = 0; j < legs.length; j++) {
        //     duration = duration + legs[j].duration.value
        //   }
        //   let eta = moment().add(duration, 'seconds')
        //   let format = 'MM/DD/YYYY hh:mm A'
        //   if (self.$settings.get('MilitaryTimeBackoffice') === '1') {
        //     format = 'MM/DD/YYYY HH:mm'
        //   }
        //   self.etaPopup.label = 'ETA: ' + eta.format(format)
        // })
      });
    },
    calculateRoute: function calculateRoute(origin, destination) {
      var self = this;
      var router = self.hereMaps.platform.getRoutingService(null, 8);
      var routeRequestParams = {
        routingMode: 'fast',
        transportMode: 'car',
        origin: origin.lat + ',' + origin.lng,
        destination: destination.lat + ',' + destination.lng,
        return: 'polyline,turnByTurnActions,actions,instructions,travelSummary'
      };

      router.calculateRoute(routeRequestParams, self.onCalculateSuccess, self.onCalculateError);
    },
    onCalculateSuccess: function onCalculateSuccess(result) {
      var self = this;
      self.etaPopup.loading = false;
      if (!result.routes.length) return;
      var route = result.routes[0].sections[0];

      var eta = __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(route.travelSummary.duration, 'seconds');
      var format = 'MM/DD/YYYY hh:mm A';
      if (self.$settings.get('MilitaryTimeBackoffice') === '1') {
        format = 'MM/DD/YYYY HH:mm';
      }
      self.etaPopup.label = 'ETA: ' + eta.format(format);
    },
    onCalculateError: function onCalculateError(data) {
      this.etaPopup.loading = false;
      this.etaPopup.label = 'Cannot find the driver.';
      this.error('ROUTING ERROR', data);
    },
    hideEtaPopup: function hideEtaPopup() {
      var self = this;
      self.etaPopup.show = false;
      self.etaPopup.loading = false;
      self.etaPopup.label = '';
    },
    showRTG: function showRTG(id) {
      this.$store.commit('laxit/setReadyToGoID', id);
      this.$store.commit('laxit/setReadyToGoShow', true);
      this.$store.commit('laxit/setReadyToGoSuccess', false);
      this.$store.commit('laxit/setReadyToGoTable', 'tncReservations');
    },
    showNotes: function showNotes(notes) {
      this.$store.commit('laxit/setNotesMessage', notes);
      this.$store.commit('laxit/setNotesShow', true);
    }
  },
  mounted: function mounted() {
    // this.hereMaps.platform = new window.H.service.Platform({apikey: CONFIG.hereApi.key})
    // let defaultLayers = this.hereMaps.platform.createDefaultLayers()
  }
});

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_laxit_reservations__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UnroutedReservationsRow__ = __webpack_require__(2064);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'unrouted-reservations',
  components: { UnroutedReservationsRow: __WEBPACK_IMPORTED_MODULE_2__UnroutedReservationsRow__["a" /* default */] },
  props: ['isMobile'],
  data: function data() {
    return {};
  },

  computed: {
    loading: function loading() {
      return this.$store.state.laxit.unroutedReservations.isLoading;
    },
    currentOrder: function currentOrder() {
      var laxit = this.$store.state.laxit.unroutedReservations;
      return { field: laxit.order, asc: laxit.orderAsc };
    },
    items: function items() {
      return this.$store.state.laxit.unroutedReservations.list;
    },
    checkedPackages: function checkedPackages() {
      return this.$store.state.laxit.unroutedReservations.checked;
    },
    inMap: function inMap() {
      var self = this;
      var mapItems = self.$store.state.laxit.dropzone.items;
      var item = mapItems.filter(function (mapItem) {
        return mapItem.packageID === self.opPackage.id;
      });
      return item.length > 0;
    },
    isLastPage: function isLastPage() {
      var unroutedReservations = this.$store.state.laxit.unroutedReservations;
      return unroutedReservations.currentPage * unroutedReservations.perPage >= unroutedReservations.maxList;
    }
  },
  methods: {
    getList: function getList() {
      var self = this;
      if (self.loading) {
        return;
      }

      self.$store.commit('laxit/setUnroutedReservationsIsLoading', true);
      __WEBPACK_IMPORTED_MODULE_1__modules_api_laxit_reservations__["a" /* default */].getUnrouted(self, function (res) {
        self.$store.commit('laxit/setUnroutedReservationsIsLoading', false);
      });
    },
    sort: function sort(field) {
      if (this.loading) {
        return;
      }
      var laxit = this.$store.state.laxit.unroutedReservations;
      if (field !== laxit.order) {
        this.$store.commit('laxit/setUnroutedReservationsOrderAsc', 1);
      } else {
        this.$store.commit('laxit/setUnroutedReservationsOrderAsc', laxit.orderAsc === 1 ? 0 : 1);
      }
      this.$store.commit('laxit/setUnroutedReservationsOrder', field);
      this.$store.commit('laxit/setUnroutedReservationsCurrentPage', 1);
      this.$store.commit('laxit/resetUnroutedReservationsList');
      this.getList();
    },
    loadMore: function loadMore() {
      if (this.isLastPage || this.loading) {
        return;
      }
      this.$store.commit('laxit/setUnroutedReservationsCurrentPage', this.$store.state.laxit.unroutedReservations.currentPage + 1);
      this.getList();
    },
    addMapOnlyData: function addMapOnlyData(rsvp) {
      rsvp.legs[0] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rsvp.legs[0], { mapOnly: false });
      rsvp.legs[1] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rsvp.legs[1], { mapOnly: false });
      return rsvp;
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$store.commit('laxit/resetUnroutedReservationsList');
    self.getList();
  }
});

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_flight_info__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Partials_SVG_ServiceDog__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Partials_SVG_Wheelchair__ = __webpack_require__(96);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reservation-row',
  props: ['rsvp', 'isMobile'],
  components: { SvgDog: __WEBPACK_IMPORTED_MODULE_2__components_Partials_SVG_ServiceDog__["a" /* default */], SvgWheelchair: __WEBPACK_IMPORTED_MODULE_3__components_Partials_SVG_Wheelchair__["a" /* default */] },
  data: function data() {
    return {
      flightStatus: null
    };
  },

  computed: {
    inMap: function inMap() {
      var self = this;
      var mapItems = self.$store.state.laxit.dropzone.items;
      var item = mapItems.filter(function (mapItem) {
        return mapItem.reservationID === self.rsvp.id && mapItem.packageID === null;
      });
      return item.length > 0;
    },

    checkedReservations: {
      get: function get() {
        return this.$store.state.laxit.unroutedReservations.checked;
      },
      set: function set(value) {
        this.$store.commit('laxit/setTncReservationsChecked', []);
        this.$store.commit('laxit/setUnroutedReservationsChecked', value);
      }
    }
  },
  methods: {
    getAddress: function getAddress(location) {
      if (location.geofenceType === 'airport' && location.geofenceName !== '') {
        var result = location.geofenceName;
        if (location.terminal && location.terminal !== '' && location.terminal !== 'undefined') {
          result += ' - Terminal ' + location.terminal;
        }
        return result;
      }
      return location.title;

      // let address = ''
      // if (location.city) {
      //   address = address + location.city + ' '
      // }
      // if (location.zip) {
      //   address = address + location.zip
      // }

      // return address
    },
    showFlightInfo: function showFlightInfo() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1__modules_api_flight_info__["a" /* default */].loadFlightInfo(self, self.rsvp, function (r) {
        if (r.error) {
          self.flightStatus = { label: 'On Time', class: 'ontime' };
          return;
        }
        self.flightStatus = self.translateFlightStatus(r.status);
      });
    },
    getFlightStatus: function getFlightStatus() {
      var self = this;
      if (self.rsvp.airlineCode === null || self.rsvp.statusClass === 'complete' || self.rsvp.statusClass === 'completed' || self.rsvp.statusClass === 'canceled') {
        self.flightStatus = null;
        return;
      }
      var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.rsvp.pickupTime, 'MM/DD/YYYY hh:mm A');
      var airlineDate = encodeURIComponent(date.format('YYYY-MM-DD'));
      var airlineTime = encodeURIComponent(date.format('HH:mm:ss'));
      var flightNumber = self.rsvp.flightNumber || self.rsvp.dropoffFlightNumber;
      var isDeparture = '&departure=0';
      if ((self.rsvp.airline === null || self.rsvp.airline === '') && self.rsvp.dropoffAirline !== null && self.rsvp.dropoffAirline !== '') {
        isDeparture = '&departure=1';
      }
      var url = '/availability/flights/' + self.rsvp.airlineCode + flightNumber + '?date=' + airlineDate + '&time=' + airlineTime + '&airport=' + self.rsvp.airportCode + isDeparture;
      self.$sdk.get(url, {}, function (r) {
        if (r.error) {
          self.flightStatus = { label: 'On Time', class: 'ontime' };
          return;
        }
        self.flightStatus = self.translateFlightStatus(r.status);
      });
    },
    translateFlightStatus: function translateFlightStatus(status) {
      switch (status) {
        case 'Scheduled':
          return { label: 'On Time', class: 'ontime' };
        case 'Proposed':
          return { label: 'On Time', class: 'ontime' };
        case 'OutGate':
          return { label: 'On Time', class: 'ontime' };
        case 'InAir':
          return { label: 'On Air', class: 'onair' };
        case 'Landed':
          return { label: 'Arrived', class: 'arrived' };
        case 'InGate':
          return { label: 'Arrived', class: 'arrived' };
        case 'Expected':
          return { label: 'On Time', class: 'ontime' };
        case 'NoTakeOffInfo':
          return { label: 'On Time', class: 'ontime' };
        case 'Delayed':
          return { label: 'Delayed', class: 'delayed' };
        case 'Cancelled':
          return { label: 'Cancelled', class: 'cancelled' };
        case 'Unknown':
          return { label: 'On Time', class: 'ontime' };
        case 'PastFlight':
          return { label: 'Arrived', class: 'arrived' };
        case 'Original':
          return { label: 'On Time', class: 'ontime' };
      }
      return { label: 'On Time', class: 'ontime' };
    },
    toggleInMap: function toggleInMap() {
      var self = this;
      if (self.inMap) {
        self.$store.commit('laxit/removeDropzoneItems', self.rsvp);
        return;
      }
      self.removeMapOnlyItems();
      self.$store.commit('laxit/addDropzoneItem', self.rsvp);
    },
    callPhone: function callPhone(info) {
      var self = this;
      self.$plugins.phone.startCall(self, {
        phone: info.phone,
        name: info.firstName + ' ' + info.lastName
      });
    },
    showRTG: function showRTG(id) {
      this.$store.commit('laxit/setReadyToGoID', id);
      this.$store.commit('laxit/setReadyToGoShow', true);
      this.$store.commit('laxit/setReadyToGoSuccess', false);
      this.$store.commit('laxit/setReadyToGoTable', 'unrouted');
    },
    acceptedRTGStatus: function acceptedRTGStatus(status) {
      return ['UPCOMING', 'REQUIRES DISPATCH', 'DISPATCHED'].indexOf(status) > -1;
    },
    removeMapOnlyItems: function removeMapOnlyItems() {
      if (this.$store.state.laxit.tncReservations.viewingInMap) {
        this.$store.commit('laxit/clearDropzone');
        this.$store.commit('laxit/setViewingInMap', false);
      }
    }
  },
  watch: {
    rsvp: function rsvp(value) {
      // this.getFlightStatus()
    }
  },
  mounted: function mounted() {
    // let self = this
    // self.getFlightStatus()
  }
});

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_services__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */

var merge = __webpack_require__(667);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "driver-tnc",
  data: function data() {
    return {
      staging: {
        selected: -1,
        loading: false,
        list: [],
        error: false
      },
      drivers: null,
      driversDisplayed: null,
      refreshing: false,
      driversPerLicense: []
    };
  },

  computed: {
    selectedDriver: {
      get: function get() {
        return this.$store.state.laxit.selectedDriver;
      },
      set: function set(value) {
        this.$store.commit('laxit/setSelectedDriver', value);
      }
    },
    stagingType: {
      get: function get() {
        return this.$store.state.laxit.driverTNC.stagingType;
      },
      set: function set(value) {
        this.staging.error = false;
        this.$store.commit('laxit/setDriverTNCstagingType', value);
        this.getList();
      }
    },
    stagingLists: function stagingLists() {
      var obj = this.$store.state.laxit.stagingLists;
      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj);
      var sorted = {};
      keys.sort(function (a, b) {
        return obj[a].priority - obj[b].priority;
      });
      for (var i in keys) {
        sorted[i] = obj[keys[i]];
      }
      return sorted;
    }
  },
  methods: {
    checkLicense: function checkLicense(drivers) {
      if (drivers.length > 0) {
        for (var i = 0; i < drivers.length; i++) {
          if (drivers[i].provider.providerAccountType == 'tnc') {
            return true;
          }
        }
      } else {
        return false;
      }
    },
    generateDrivers: function generateDrivers(items) {
      var self = this;
      self.drivers = {};
      self.driversDisplayed = null;

      var _loop = function _loop(i) {
        var item = items[i];
        if (items[i].serviceTypeId <= 5) {
          return 'continue';
        }

        if (!self.drivers.hasOwnProperty(item.geofenceId)) {
          self.drivers[item.geofenceId] = {
            shared: [],
            opoli: [],
            black: [],
            suv: [],
            shuttle: []
          };
        }

        if (!self.drivers[item.geofenceId][item.serviceCode]) {
          self.drivers[item.geofenceId][item.serviceCode] = [];
        }
        if (self.drivers[item.geofenceId][item.serviceCode].findIndex(function (x) {
          return x.provider.ID === item.provider.ID;
        }) === -1) {
          self.drivers[item.geofenceId][item.serviceCode].push(item);
        }
      };

      for (var i = 0; i < items.length; i++) {
        var _ret = _loop(i);

        if (_ret === 'continue') continue;
      }
    },
    getList: function getList() {
      var self = this;
      self.staging.loading = true;
      self.staging.list = [];
      self.staging.error = false;
      self.drivers = null;
      self.driversDisplayed = null;
      self.driversPerLicense = [];
      self.$sdk.get('/airports/' + {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.default.laxAirportId + '/staging', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.$store.commit('laxit/setDriverStagingLists', r.staging);
        self.staging.loading = false;
        if (r.error) {
          self.staging.error = true;
          return;
        }
        if (r.queue.length <= 0) {
          self.staging.error = true;
        }
        self.staging.list = r.staging;

        for (var i = 0; i < r.queue.length; i++) {
          if (!r.queue[i].serviceCode) {
            r.queue[i].serviceCode = self.getServiceName(r.queue[i].serviceTypeId);
          }
          if (r.queue[i].provider.providerAccountType === 'tnc') {
            self.driversPerLicense.push(r.queue[i]);
          }
        }

        if (self.driversPerLicense.length <= 0) {
          self.staging.error = true;
        }

        self.generateDrivers(self.driversPerLicense);
        if (self.stagingType === 'all') {
          var obj = self.drivers;
          var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj);
          var sorted = {};
          keys.sort(function (a, b) {
            var index = '';
            for (var _i in obj[a]) {
              if (obj[a][_i].length > 0) {
                index = _i;
                break;
              }
            }
            var index2 = '';
            for (var _i2 in obj[b]) {
              if (obj[b][_i2].length > 0) {
                index2 = _i2;
                break;
              }
            }
            return obj[a][index][0].geofencePriority - obj[b][index2][0].geofencePriority;
          });
          for (var _i3 in keys) {
            sorted[_i3] = obj[keys[_i3]];
          }
          var driversList = {};
          var driverArray = [];
          for (var driver in sorted) {
            driverArray.push(sorted[driver]);
          }
          if (driverArray.length > 1) {
            driversList = merge.apply(undefined, driverArray);
            self.driversDisplayed = driversList;
          } else {
            self.driversDisplayed = driverArray[0];
          }
        } else {
          if (!!self.drivers[self.stagingType]) {
            self.driversDisplayed = self.drivers[self.stagingType];
          } else {
            self.staging.error = true;
          }
        }
      });
    },
    getServiceName: function getServiceName(id) {
      var service = this.$store.state.services.list.filter(function (x) {
        return x.id === id;
      });
      var brand = '';
      if (service.length) {
        brand = '[' + {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.filter(function (x) {
          return x.id === service[0].brandId;
        })[0].code.toUpperCase() + '] ';
      }
      return service.length ? brand + service[0].name : 'Cannot find service data...';
    }
  },
  mounted: function mounted() {
    var self = this;
    self.getList();
    if (!self.$store.state.services.list.length) {
      self.$store.commit('services/setServiceLoading', true);
      __WEBPACK_IMPORTED_MODULE_1__modules_api_services__["a" /* default */].getAllService(self, function (r) {
        self.$store.commit('services/setServiceLoading', false);
      });
    }
  }
});

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return target.propertyIsEnumerable(symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_api_services__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */

var merge = __webpack_require__(667);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "driver-tcp",
  data: function data() {
    return {
      staging: {
        selected: -1,
        loading: false,
        list: [],
        error: false
      },
      drivers: null,
      driversDisplayed: null,
      refreshing: false,
      driversPerLicense: []
    };
  },

  computed: {
    selectedDriver: {
      get: function get() {
        return this.$store.state.laxit.selectedDriver;
      },
      set: function set(value) {
        this.$store.commit('laxit/setSelectedDriver', value);
      }
    },
    stagingType: {
      get: function get() {
        return this.$store.state.laxit.driverTCP.stagingType;
      },
      set: function set(value) {
        this.staging.error = false;
        this.$store.commit('laxit/setDriverTCPstagingType', value);
        this.getList();
      }
    },
    stagingLists: function stagingLists() {
      var obj = this.$store.state.laxit.stagingLists;
      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj);
      var sorted = {};
      keys.sort(function (a, b) {
        return obj[a].priority - obj[b].priority;
      });
      for (var i in keys) {
        sorted[i] = obj[keys[i]];
      }
      return sorted;
    }
  },
  methods: {
    checkLicense: function checkLicense(drivers) {
      if (drivers.length > 0) {
        for (var i = 0; i < drivers.length; i++) {
          if (drivers[i].provider.providerAccountType == 'tcp') {
            return true;
          }
        }
      } else {
        return false;
      }
    },
    generateDrivers: function generateDrivers(items) {
      var self = this;
      self.drivers = {};
      self.driversDisplayed = null;

      var _loop = function _loop(i) {
        var item = items[i];
        if (items[i].serviceTypeId <= 5) {
          return 'continue';
        }

        if (!self.drivers.hasOwnProperty(item.geofenceId)) {
          self.drivers[item.geofenceId] = {
            shared: [],
            opoli: [],
            black: [],
            suv: [],
            shuttle: []
          };
        }

        if (!self.drivers[item.geofenceId][item.serviceCode]) {
          self.drivers[item.geofenceId][item.serviceCode] = [];
        }
        if (self.drivers[item.geofenceId][item.serviceCode].findIndex(function (x) {
          return x.provider.ID === item.provider.ID;
        }) === -1) {
          self.drivers[item.geofenceId][item.serviceCode].push(item);
        }
      };

      for (var i = 0; i < items.length; i++) {
        var _ret = _loop(i);

        if (_ret === 'continue') continue;
      }
    },
    getList: function getList() {
      var self = this;
      self.staging.loading = true;
      self.staging.list = [];
      self.staging.error = false;
      self.drivers = null;
      self.driversDisplayed = null;
      self.driversPerLicense = [];
      self.$sdk.get('/airports/' + {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.default.laxAirportId + '/staging', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.staging.loading = false;
        if (r.error) {
          self.staging.error = true;
          return;
        }
        if (r.queue.length <= 0) {
          self.staging.error = true;
        }
        self.staging.list = r.staging;

        for (var i = 0; i < r.queue.length; i++) {
          if (!r.queue[i].serviceCode) {
            r.queue[i].serviceCode = self.getServiceName(r.queue[i].serviceTypeId);
          }
          if (r.queue[i].provider.providerAccountType == 'tcp') {
            self.driversPerLicense.push(r.queue[i]);
          }
        }

        if (self.driversPerLicense.length <= 0) {
          self.staging.error = true;
        }

        self.generateDrivers(self.driversPerLicense);
        if (self.stagingType === 'all') {
          var obj = self.drivers;
          var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj);
          var sorted = {};
          keys.sort(function (a, b) {
            var index = '';
            for (var _i in obj[a]) {
              if (obj[a][_i].length > 0) {
                index = _i;
                break;
              }
            }
            var index2 = '';
            for (var _i2 in obj[b]) {
              if (obj[b][_i2].length > 0) {
                index2 = _i2;
                break;
              }
            }
            return obj[a][index][0].geofencePriority - obj[b][index2][0].geofencePriority;
          });
          for (var _i3 in keys) {
            sorted[_i3] = obj[keys[_i3]];
          }
          var driversList = {};
          var driverArray = [];
          for (var driver in sorted) {
            driverArray.push(sorted[driver]);
          }
          if (driverArray.length > 1) {
            driversList = merge.apply(undefined, driverArray);
            self.driversDisplayed = driversList;
          } else {
            self.driversDisplayed = driverArray[0];
          }
        } else {
          if (!!self.drivers[self.stagingType]) {
            self.driversDisplayed = self.drivers[self.stagingType];
          } else {
            self.staging.error = true;
          }
        }
      });
    },
    getServiceName: function getServiceName(id) {
      var service = this.$store.state.services.list.filter(function (x) {
        return x.id === id;
      });
      var brand = '';
      if (service.length) {
        brand = '[' + {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.filter(function (x) {
          return x.id === service[0].brandId;
        })[0].code.toUpperCase() + '] ';
      }
      return service.length ? brand + service[0].name : 'Cannot find service data...';
    }
  },
  mounted: function mounted() {
    var self = this;
    self.getList();
  }
});

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_laxit_reservations__ = __webpack_require__(112);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "driver-outbound",
  data: function data() {
    return {
      driverOutbound: {
        loading: true,
        error: false
      }
    };
  },

  computed: {
    loading: function loading() {
      return this.$store.state.laxit.driverOutbound.isLoading;
    },
    drivers: function drivers() {
      return this.$store.state.laxit.driverOutbound.list;
    },

    selectedDriver: {
      get: function get() {
        return this.$store.state.laxit.selectedDriver;
      },
      set: function set(value) {
        this.$store.commit('laxit/setSelectedDriver', value);
      }
    },
    licenseType: {
      get: function get() {
        return this.$store.state.laxit.driverOutbound.licenseType;
      },
      set: function set(value) {
        this.driverOutbound.error = false;
        this.$store.commit('laxit/resetDriverOutboundList');
        this.$store.commit('laxit/setDriverOutboundLicenseType', value);
        this.getList();
      }
    },
    isLastPage: function isLastPage() {
      var driverOutbound = this.$store.state.laxit.driverOutbound;
      return driverOutbound.currentPage * driverOutbound.perPage >= driverOutbound.maxList;
    }
  },
  methods: {
    getList: function getList() {
      var self = this;
      self.driverOutbound.error = false;
      self.driverOutbound.loading = true;
      var isAllPackage = [];
      if (self.loading) {
        return;
      }

      self.$store.commit('laxit/setDriverOutboundIsLoading', true);
      __WEBPACK_IMPORTED_MODULE_0__modules_api_laxit_reservations__["a" /* default */].getOutbound(self, function (res) {
        self.$store.commit('laxit/setDriverOutboundIsLoading', false);
        if (res.error || res.list.length <= 0 || res.list.length == isAllPackage.length) {
          self.driverOutbound.error = true;
          self.driverOutbound.loading = false;
          return;
        }
        for (var i = 0; i < res.list.length; i++) {
          if (res.list[i].type == 'package') {
            isAllPackage.push(res.list[i].type);
          }
        }

        self.driverOutbound.loading = false;
      });
    },
    refreshList: function refreshList() {
      this.$store.commit('laxit/resetDriverOutboundList');
      this.$store.commit('laxit/setDriverOutboundCurrentPage', 1);
      this.getList();
    },
    loadMoreDrivers: function loadMoreDrivers(event) {
      var scrollAndView = event.target.scrollTop + event.target.offsetHeight;
      if (event.target.scrollHeight - scrollAndView < 150) {
        if (this.isLastPage || this.loading) {
          return;
        }
        this.$store.commit('laxit/setDriverOutboundCurrentPage', this.$store.state.laxit.driverOutbound.currentPage + 1);
        this.getList();
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$store.commit('laxit/resetDriverOutboundList');
    self.getList();
  }
});

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_api_laxit_reservations__ = __webpack_require__(112);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "driver-inbound",
  data: function data() {
    return {
      driverInbound: {
        loading: true,
        error: false
      }
    };
  },

  computed: {
    loading: function loading() {
      return this.$store.state.laxit.driverInbound.isLoading;
    },
    drivers: function drivers() {
      return this.$store.state.laxit.driverInbound.list;
    },

    selectedDriver: {
      get: function get() {
        return this.$store.state.laxit.selectedDriver;
      },
      set: function set(value) {
        this.$store.commit('laxit/setSelectedDriver', value);
      }
    },
    licenseType: {
      get: function get() {
        return this.$store.state.laxit.driverInbound.licenseType;
      },
      set: function set(value) {
        this.driverInbound.error = false;
        this.$store.commit('laxit/resetdriverInboundList');
        this.$store.commit('laxit/setdriverInboundLicenseType', value);
        this.getList();
      }
    },
    isLastPage: function isLastPage() {
      var driverInbound = this.$store.state.laxit.driverInbound;
      return driverInbound.currentPage * driverInbound.perPage >= driverInbound.maxList;
    }
  },
  methods: {
    getList: function getList() {
      var self = this;
      self.driverInbound.error = false;
      self.driverInbound.loading = true;
      var isAllPackage = [];
      if (self.loading) {
        return;
      }

      self.$store.commit('laxit/setdriverInboundIsLoading', true);
      __WEBPACK_IMPORTED_MODULE_0__modules_api_laxit_reservations__["a" /* default */].getInbound(self, function (res) {
        self.$store.commit('laxit/setdriverInboundIsLoading', false);
        if (res.error || res.list.length <= 0 || res.list.length == isAllPackage.length) {
          self.driverInbound.error = true;
          self.driverInbound.loading = false;
          return;
        }
        for (var i = 0; i < res.list.length; i++) {
          if (res.list[i].type == 'package') {
            isAllPackage.push(res.list[i].type);
          }
        }

        self.driverInbound.loading = false;
      });
    },
    refreshList: function refreshList() {
      this.$store.commit('laxit/resetdriverInboundList');
      this.$store.commit('laxit/setdriverInboundCurrentPage', 1);
      this.getList();
    },
    loadMoreDrivers: function loadMoreDrivers(event) {
      var scrollAndView = event.target.scrollTop + event.target.offsetHeight;
      if (event.target.scrollHeight - scrollAndView < 150) {
        if (this.isLastPage || this.loading) {
          return;
        }
        this.$store.commit('laxit/setdriverInboundCurrentPage', this.$store.state.laxit.driverInbound.currentPage + 1);
        this.getList();
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$store.commit('laxit/resetdriverInboundList');
    self.getList();
  }
});

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'driver-controls',
  data: function data() {
    return {
      scheduleTimer: '',
      runningSchedule: false,
      backup: [],
      modal: {
        show: false,
        option: 'default',
        custom: 60
      }
    };
  },

  computed: {
    // currentDispatchTab () { return this.$store.state.dispatch.currentTable },
    currentDispatchTab: function currentDispatchTab() {
      return 0;
    },
    scheduleLoading: function scheduleLoading() {
      return this.$store.state.dispatch.schedule.loading;
    }
  },
  methods: {
    isOnDuty: function isOnDuty(driverId) {
      var self = this;
      var onDutyDrivers = self.$store.state.laxit.onDuty.list;
      return onDutyDrivers.filter(function (onDuty) {
        return onDuty.id === driverId;
      }).length === 1;
    },
    isStatusValid: function isStatusValid(items) {
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (item.status === 'complete' || item.status === 'completed' || item.status === 'canceled' || item.status === 'onboard' || item.status === 'dispatched') {
          return false;
        }
      }
      return true;
    },
    sendToDriver: function sendToDriver() {
      var self = this;
      this.modal.show = false;

      var tncReservations = self.$store.state.laxit.tncReservations;
      var checked = tncReservations.checked;
      var driverId = self.$store.state.laxit.selectedDriver;
      driverId = driverId.split('-')[0];

      // let laxit = self.$store.state.laxit
      // let tncReservations = laxit.tncReservations
      // let rsvps = laxit.tncReservations.checked
      // if (laxit.unroutedReservations.checked.length) {
      //   rsvps = laxit.unroutedReservations.checked
      // }
      // let checked = tncReservations.checked
      // let driverId = self.$store.state.laxit.selectedDriver

      if (driverId === null || checked.length <= 0 || checked.length > 1) {
        self.$store.commit('laxit/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 driver and only 1 reservation/package to proceed.'
        });
        return;
      }

      // if (!self.isOnDuty(driverId)) {
      //   self.$store.commit('laxit/showValidationModal', {
      //     title: 'Oops. You missed something.',
      //     message: 'You can only send reservations/pacakges to on-duty drivers.'
      //   })
      //   return
      // }

      var index = tncReservations.list.findIndex(function (x) {
        return x.id === checked[0];
      });
      var selected = tncReservations.list[index];

      if (!self.isStatusValid(selected)) {
        self.$store.commit('laxit/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You can only send Upcoming, Requires Dispatch and Ready to Go reservations/packages to drivers.'
        });
        return;
      }

      var url = selected.type === 'rsvp' ? '/admin/rsvp/' : '/admin/package/';
      self.$store.commit('laxit/showActionModal', 'Sending' + (selected.type === 'rsvp' ? ' reservation ' : ' package ') + 'to driver...');

      var customRequestTimeout = self.$settings.get('ASAPRequestTimeout');
      if (self.modal.option === 'custom') customRequestTimeout = self.modal.custom;
      self.$sdk.post(url + selected.id + '/send', {
        token: self.$store.state.session.sessionToken,
        provId: driverId,
        customRequestTimeout: customRequestTimeout
      }, function (r) {
        if (r.error) {
          self.$store.commit('laxit/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong. Try again later.'
          });
        } else {
          self.$store.commit('laxit/setTncReservationsChecked', []);
          self.$store.commit('laxit/removeUnroutedReservation');
          // self.$store.commit('dispatch/setSelectedDriver', null) // TODO
          self.$store.commit('laxit/completeActionModal', {
            success: true,
            message: 'Successfully sent reservation.'
          });
        }

        setTimeout(function () {
          self.$store.commit('laxit/closeActionModal');
        }, 3000);
      });
    },
    sendAsSchedule: function sendAsSchedule() {
      var self = this;
      var laxit = self.$store.state.laxit;
      var routing = self.$store.state.routing;

      var rsvps = [];
      var pkgs = [];
      var driverId = laxit.selectedDriver;
      driverId = driverId.split('-')[0];
      var notAllowed = false;

      // Dispatch table
      if (self.currentDispatchTab === 0) {
        if (laxit.tncReservations.checked.length) {
          dispatch.checkedReservations.forEach(function (data) {
            if (['upcoming', 'requires-dispatch'].indexOf(data.status) < 0) {
              notAllowed = true;
              return false;
            }
            if (data.isPackage) {
              pkgs.push(data.id);
            } else {
              rsvps.push(data.id);
            }
          });
        }
      }

      // Routing table - Packages
      if (self.currentDispatchTab === 1) {
        pkgs = routing.packages.checkedForDispatch;
        routing.packages.items.forEach(function (data) {
          if (pkgs.indexOf(data.id) > -1 && ['upcoming', 'requires-dispatch'].indexOf(data.statusClass) < 0) {
            notAllowed = true;
          }
        });
      }

      // Routing table - Unpackages
      if (self.currentDispatchTab === 2) {
        rsvps = routing.reservations.checked;
        routing.reservations.items.forEach(function (data) {
          if (rsvps.indexOf(data.id) > -1 && ['upcoming', 'requires-dispatch'].indexOf(data.statusClass) < 0) {
            notAllowed = true;
          }
        });
      }

      if (notAllowed) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Not Allowed',
          message: 'Only UPCOMING and REQUIRES DISPATCH reservations/packages are allowed to be schedule.'
        });
        return;
      }

      var totalSelected = rsvps.length + pkgs.length;
      if (driverId === null || totalSelected <= 1) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 driver and at least 2 reservations/packages to proceed.'
        });
        return;
      }

      self.scheduleTimer = '';
      self.runningSchedule = false;
      self.$store.commit('dispatch/setScheduleAccepted', false);
      self.$store.commit('dispatch/setScheduleShow', true);
      self.$store.commit('dispatch/setScheduleLoading', true);
      self.$store.commit('dispatch/setScheduleLoadingMsg', 'Setting schedule. Please wait...');

      self.$store.commit('dispatch/setScheduleRsvp', rsvps);
      self.$store.commit('dispatch/setSchedulePkg', pkgs);
      var driverList = 'onDuty';
      if (self.$store.state.dispatch.driverListTabIndex === 1) {
        driverList = 'staging';
      }
      if (self.$store.state.dispatch.driverListTabIndex === 2) {
        driverList = 'offDuty';
      }
      var driverIndex = self.$store.state.dispatch[driverList].drivers.findIndex(function (x) {
        return x.id === driverId;
      });
      var driver = self.$store.state.dispatch[driverList].drivers[driverIndex];
      self.$store.commit('dispatch/setScheduleDriverData', {
        id: driverId,
        name: driver.firstName + ' ' + driver.lastName
      });

      self.backup = [];
      self.backup = self.$store.state.dispatch.rsvpInTable;

      dispatch.checkedReservations.forEach(function (data) {
        self.$store.commit('dispatch/removeRsvpInTable', data);
      });

      self.$sdk.post('/admin/schedule/', {
        token: self.$store.state.session.sessionToken,
        provID: driverId,
        reservationIDs: rsvps,
        packageIDs: pkgs
      }, function (r) {
        self.$store.commit('dispatch/setScheduleLoading', false);
        if (r.error) {
          // self.$store.commit('dispatch/setScheduleShow', false)
          // self.$store.commit('dispatch/showValidationModal', {
          //   title: 'Oops. Something went wrong.',
          //   message: r.error.message
          // })

          self.$store.commit('dispatch/setScheduleError', r.error.message);
          self.$store.commit('dispatch/setRsvpInTable', self.backup);
          return;
        }

        self.runningSchedule = true;
        self.scheduleTimer = setTimeout(function () {
          self.runningSchedule = false;
          if (!self.$store.state.dispatch.schedule.accepted) {
            self.$store.commit('dispatch/setScheduleShow', false);
            // self.$store.commit('dispatch/showValidationModal', {
            //   title: 'Failed',
            //   message: 'The Driver seems to be busy at the moment. Try again later.'
            // })

            self.$store.commit('dispatch/showDispatchAcceptNotification', {
              show: true,
              accept: false,
              isPackage: false,
              id: null,
              driverId: null,
              driverName: '',
              isSendAsSchedule: true,
              sendAsScheduleError: 'The Driver seems to be busy at the moment. Try again later.',
              runsDeclined: false
            });
          }
        }, 180000); // 3 mins
        self.getSchedule(r);
      });
    },
    getSchedule: function getSchedule(data) {
      var self = this;
      self.$store.commit('dispatch/setScheduleLoading', true);
      self.$store.commit('dispatch/setScheduleLoadingMsg', 'Pending Driver. Please wait...');
      self.$store.commit('dispatch/setScheduleShow', false); // Hide Modal Early

      self.$sdk.get('/admin/schedule/' + data.id, {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          self.$store.commit('dispatch/setScheduleShow', false);
          self.$store.commit('dispatch/showValidationModal', {
            title: 'Oops. Something went wrong.',
            message: r.error.message
          });

          self.runningSchedule = false;
          if (self.scheduleTimer) {
            clearTimeout(self.scheduleTimer);
          }
          return;
        }

        var scheduleStore = self.$store.state.dispatch.schedule;
        if (r.status === 'pending') {
          if (self.runningSchedule) {
            setTimeout(function () {
              self.getSchedule(data);
            }, 5000);
          }
        } else if (r.status === 'accepted') {
          self.runningSchedule = false;
          if (self.scheduleTimer) {
            clearTimeout(self.scheduleTimer);
          }
          self.$store.commit('dispatch/setScheduleLoading', false);
          self.$store.commit('dispatch/setScheduleAccepted', true);

          self.$store.commit('dispatch/showDispatchAcceptNotification', {
            show: true,
            accept: true,
            isPackage: false,
            id: null,
            driverId: scheduleStore.driverData.id,
            driverName: scheduleStore.driverData.name,
            isSendAsSchedule: true,
            sendAsScheduleError: '',
            runsDeclined: false
          });
        } else if (r.status === 'rejected') {
          self.runningSchedule = false;
          if (self.scheduleTimer) {
            clearTimeout(self.scheduleTimer);
          }
          self.$store.commit('dispatch/setScheduleShow', false);
          self.$store.commit('dispatch/setScheduleLoading', false);

          // self.$store.commit('dispatch/showValidationModal', {
          //   title: 'Rejected',
          //   message: 'Schedule reservation/package was rejected by the driver'
          // })

          self.$store.commit('dispatch/showDispatchAcceptNotification', {
            show: true,
            accept: false,
            isPackage: false,
            id: null,
            driverId: scheduleStore.driverData.id,
            driverName: scheduleStore.driverData.name,
            isSendAsSchedule: true,
            sendAsScheduleError: '',
            runsDeclined: false
          });
        }
      });
    },
    sendAsAsap: function sendAsAsap() {
      var self = this;
      var tncReservations = self.$store.state.laxit.tncReservations;
      var checked = tncReservations.checked;
      var driverId = self.$store.state.laxit.selectedDriver;
      driverId = driverId.split('-')[0];

      if (driverId === null || checked.length <= 0 || checked.length > 1) {
        self.$store.commit('laxit/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 driver and only 1 reservation to proceed.'
        });
        return false;
      }

      // if (!self.isOnDuty(driverId)) {
      //   self.$store.commit('laxit/showValidationModal', {
      //     title: 'Oops. You missed something.',
      //     message: 'You can only send reservations to on-duty drivers.'
      //   })
      //   return
      // }

      var index = tncReservations.list.findIndex(function (x) {
        return x.id === checked[0];
      });
      var selected = tncReservations.list[index];

      if (!self.isStatusValid(selected)) {
        self.$store.commit('laxit/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You can only send Upcoming, Requires Dispatch and Ready to Go reservations/packages to drivers.'
        });
        return;
      }
      var url = selected.type === 'rsvp' ? '/admin/rsvp/' : '/admin/package/';
      self.$store.commit('laxit/showActionModal', 'Sending' + (selected.type === 'rsvp' ? ' reservation ' : ' package ') + 'to driver as asap...');

      self.$sdk.post(url + selected.id + '/asap', {
        token: self.$store.state.session.sessionToken,
        provId: driverId
      }, function (r) {
        if (r.error) {
          self.$store.commit('laxit/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong. Try again later.'
          });
        } else {
          self.$store.commit('laxit/removeTncReservationsChecked');
          self.$store.commit('laxit/setSelectedDriver', null);
          self.$store.commit('laxit/completeActionModal', {
            success: true,
            message: 'Successfully sent reservation as asap.'
          });
        }

        setTimeout(function () {
          self.$store.commit('laxit/closeActionModal');
        }, 3000);
      });
    },
    assignToDriver: function assignToDriver() {
      var self = this;
      var tncReservations = self.$store.state.laxit.tncReservations;
      var checked = tncReservations.checked;
      var driverId = self.$store.state.laxit.selectedDriver;
      driverId = driverId.split('-')[0];

      // let rsvps = self.$store.state.laxit.checkedReservations
      // if (self.$store.state.routing.packages.checkedForDispatch.length > 0) {
      //   rsvps = []
      //   rsvps.push({
      //     isPackage: true,
      //     id: self.$store.state.routing.packages.checkedForDispatch[0]
      //   })
      // }
      // let driverId = self.$store.state.dispatch.selectedDriver

      if (driverId === null || checked.length === 0 || checked.length > 1) {
        self.$store.commit('laxit/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 driver and at least 1 reservation or package to proceed.'
        });
        return false;
      }
      // if (!self.isOnDuty(driverId)) {
      //   self.$store.commit('dispatch/showValidationModal', {
      //     title: 'Oops. You missed something.',
      //     message: 'You can only assign reservations and/or packages to on-duty drivers.'
      //   })
      //   return
      // }

      var index = tncReservations.list.findIndex(function (x) {
        return x.id === checked[0];
      });
      var selected = tncReservations.list[index];

      if (!self.isStatusValid(selected)) {
        self.$store.commit('laxit/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You can only assign Upcoming, Requires Dispatch and Ready to Go reservations/packages to drivers.'
        });
        return;
      }

      var requests = self.getAssignRequest(selected);
      if (requests.length <= 0) {
        return;
      }

      self.$store.commit('laxit/showActionModal', 'Assigning items to driver...');
      self.$sdk.post('/provider/' + driverId + '/assign', requests[0], function (r) {
        if (requests.length > 1) {
          self.$sdk.post('/provider/' + driverId + '/assign', requests[1], function (r) {
            if (r.results && Array.isArray(r.results) && r.results.length > 0 && r.results[0].error) {
              var error = r.results[0].error;
              self.$store.commit('laxit/completeActionModal', {
                success: false,
                message: error.message ? error.message : 'Something went wrong.'
              });
            } else {
              self.$store.commit('laxit/completeActionModal', {
                success: true,
                message: 'Successfully assigned items to driver.'
              });
            }
            setTimeout(function () {
              self.$store.commit('laxit/closeActionModal');
            }, 3000);
          });
        } else {
          if (r.results && Array.isArray(r.results) && r.results.length > 0 && r.results[0].error) {
            var error = r.results[0].error;
            console.log(r);
            self.$store.commit('laxit/completeActionModal', {
              success: false,
              message: error.message ? error.message : 'Something went wrong.'
            });
          } else {
            self.$store.commit('laxit/completeActionModal', {
              success: true,
              message: 'Successfully assigned items to driver.'
            });
          }
          setTimeout(function () {
            self.$store.commit('laxit/closeActionModal');
          }, 3000);
        }
      });
    },
    getAssignRequest: function getAssignRequest(items) {
      var self = this;

      var rsvpIds = [];
      var packageIds = [];
      if (items.type === 'package') {
        packageIds.push(items.id);
      } else {
        rsvpIds.push(items.id);
      }

      var token = self.$store.state.session.sessionToken;

      var results = [];
      if (rsvpIds.length > 0) {
        results.push({
          token: token,
          rsvpId: rsvpIds
        });
      }
      if (packageIds.length > 0) {
        results.push({
          token: token,
          packageId: packageIds
        });
      }
      return results;
    },
    close: function close() {
      this.modal.show = false;
    }
  }
});

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ready-to-go-modal',
  data: function data() {
    return {
      error: '',
      success: false
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.laxit.readyToGo.show;
    },
    loading: function loading() {
      return this.$store.state.laxit.readyToGo.loading;
    },
    rsvpID: function rsvpID() {
      return this.$store.state.laxit.readyToGo.id;
    },
    rtgSuccess: function rtgSuccess() {
      return this.$store.state.laxit.readyToGo.success;
    }
  },
  methods: {
    close: function close() {
      if (this.loading) {
        return;
      }
      this.error = '';
      this.success = false;
      this.$store.commit('laxit/setReadyToGoID', 0);
      this.$store.commit('laxit/setReadyToGoShow', false);

      if (this.rtgSuccess && this.$route.name === 'RsvpDetails') {
        this.$store.commit('laxit/setReadyToGoSuccess', false);
        location.reload();
      }
    },
    confirm: function confirm() {
      var self = this;
      if (self.loading) {
        return;
      }
      self.$store.commit('laxit/setReadyToGoLoading', true);

      self.$sdk.post('/admin/rsvp/' + this.rsvpID + '/ready', {
        token: self.$store.state.session.sessionToken
      }, function (res) {
        self.$store.commit('laxit/setReadyToGoLoading', false);
        if (res.error) {
          self.error = res.error.message;
          return;
        }

        self.success = true;
        self.$store.commit('laxit/setReadyToGoSuccess', true);
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notes-modal',
  data: function data() {
    return {
      error: '',
      success: false
    };
  },

  computed: {
    show: function show() {
      return this.$store.state.laxit.notes.show;
    },
    message: function message() {
      if (Array.isArray(this.$store.state.laxit.notes.message)) {
        var rsvp = this.$store.state.laxit.notes.message;
        var message = rsvp.map(function (item) {
          return '<div class="message"><a href=\'/#/reservation/' + item.rsvpID + '\' target="_blank">' + item.rsvpID + '</a>: ' + item.notes + '</div>';
        });
        return message.join("\n");
      } else {
        return '<label class="message">' + this.$store.state.laxit.notes.message + '</label>';
      }
    },
    loading: function loading() {
      return this.$store.state.laxit.notes.loading;
    },
    rtgSuccess: function rtgSuccess() {
      return this.$store.state.laxit.notes.success;
    }
  },
  methods: {
    close: function close() {
      if (this.loading) {
        return;
      }
      this.error = '';
      this.success = false;
      this.$store.commit('laxit/setNotesMessage', '');
      this.$store.commit('laxit/setNotesShow', false);

      // if (this.rtgSuccess && this.$route.name === 'RsvpDetails') {
      //   this.$store.commit('dispatch/setReadyToGoSuccess', false)
      //   location.reload()
      // }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TableFilter__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ExclusiveList__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RunsList__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Map__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Dropzone__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Routing_RoutingModal__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Dispatch_DispatchModal__ = __webpack_require__(107);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'runs-page',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a, TableFilter: __WEBPACK_IMPORTED_MODULE_2__TableFilter__["a" /* default */], ExclusiveTable: __WEBPACK_IMPORTED_MODULE_3__ExclusiveList__["a" /* default */], RunsTable: __WEBPACK_IMPORTED_MODULE_4__RunsList__["a" /* default */], RunsMap: __WEBPACK_IMPORTED_MODULE_5__Map__["a" /* default */], DropZone: __WEBPACK_IMPORTED_MODULE_6__Dropzone__["a" /* default */], RoutingModal: __WEBPACK_IMPORTED_MODULE_7__Routing_RoutingModal__["a" /* default */], DispatchModal: __WEBPACK_IMPORTED_MODULE_8__Dispatch_DispatchModal__["a" /* default */] },
  data: function data() {
    return {
      tabIndex: 2,
      showMapMobile: false,
      sinceCal: '',
      untilCal: '',
      showCal: {
        since: false,
        until: false
      }
    };
  },

  computed: {
    route: function route() {
      return this.$route.name;
    },
    runs: function runs() {
      return this.$store.state.runs;
    },
    lastSync: function lastSync() {
      return this.$store.state.dispatch.lastSync;
    },
    since: function since() {
      var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.runs.since, 'MM/DD/YYYY hh:mmA');
      return date.format('MMM DD hh:mmA');
    },
    until: function until() {
      var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.runs.until, 'MM/DD/YYYY hh:mmA');
      return date.format('MMM DD hh:mmA');
    }
  },
  methods: {
    total: function total() {
      switch (this.tabIndex) {
        case 0:
          return this.$store.state.dispatch.totalItem;
        case 1:
          return this.$store.state.routing.totalItem.pkg;
        case 2:
          return this.$store.state.routing.totalItem.rsvp;
        case 3:
          return this.$store.state.runs.list.length;
      }
      return 0;
    },
    moveToPool: function moveToPool() {
      var self = this;

      if (!self.runs.selected) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 run item to proceed.'
        });
        return;
      }

      self.$store.commit('dispatch/showActionModal', 'Moving run to pool...');
      self.startMoveToPool();
    },
    startMoveToPool: function startMoveToPool() {
      var self = this;

      self.$sdk.post('/runs/pool/move', {
        runId: [self.runs.selected],
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong.'
          });
          setTimeout(function () {
            self.$store.commit('dispatch/closeActionModal');
          }, 3000);
          return;
        }
        self.$store.commit('dispatch/completeActionModal', {
          success: true,
          message: 'Successfully move run to pool.'
        });
        setTimeout(function () {
          self.$store.commit('dispatch/closeActionModal');
        }, 2500);
      }, '2.0');
    },
    removeFromPool: function removeFromPool() {
      var self = this;

      if (!self.runs.selected) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 run item to proceed.'
        });
        return;
      }

      self.$store.commit('dispatch/showActionModal', 'Moving run to pool...');
      self.startRemoveFromPool();
    },
    startRemoveFromPool: function startRemoveFromPool() {
      var self = this;

      self.$sdk.post('/runs/pool/remove', {
        runId: [self.runs.selected],
        token: self.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong.'
          });
          setTimeout(function () {
            self.$store.commit('dispatch/closeActionModal');
          }, 3000);
          return;
        }
        self.$store.commit('dispatch/completeActionModal', {
          success: true,
          message: 'Successfully remove run from pool.'
        });
        setTimeout(function () {
          self.$store.commit('dispatch/closeActionModal');
        }, 2500);
      }, '2.0');
    },
    triggerFilter: function triggerFilter() {
      if (this.$refs.tableFilter) this.$refs.tableFilter.showFilter();
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date, 'MM/DD/YYYY').format('MM/DD/YYYY');
    },
    toggleCal: function toggleCal(type) {
      var self = this;
      if (self.runs.exclusive.loading || self.runs.loading) return;
      self.showCal[type] = !self.showCal[type];
      if (type === 'since') self.showCal.until = false;
      if (type === 'until') self.showCal.since = false;
    },
    changeDate: function changeDate(x, type) {
      var self = this;
      var tmp = {
        since: __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.runs.since, 'MM/DD/YYYY hh:mmA'),
        until: __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.runs.until, 'MM/DD/YYYY hh:mmA')
      };
      tmp[type] = __WEBPACK_IMPORTED_MODULE_0_moment___default()(x);

      if (parseInt(tmp.since.format('D')) >= parseInt(tmp.until.format('D'))) {
        tmp[type === 'since' ? 'until' : 'since'] = tmp[type].clone();
      }

      tmp.since = tmp.since.format('MM/DD/YYYY') + ' 00:00AM';
      tmp.until = tmp.until.format('MM/DD/YYYY') + ' 11:59PM';
      self.$store.commit('runs/setRunsDetails', tmp);
      self.showCal[type] = false;
      if (this.$refs.tableFilter) this.$refs.tableFilter.loadList();
    },
    closeDropdown: function closeDropdown(event) {
      if (this.showCal.since || this.showCal.until) {
        this.showCal.since = false;
        this.showCal.until = false;
      }
    }
  },
  mounted: function mounted() {
    if (!this.runs.since) this.sinceCal = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM/DD/YYYY');
    if (!this.runs.until) this.untilCal = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM/DD/YYYY');
  }
});

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import moment from 'moment'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'admin-logs',
  data: function data() {
    return {
      loading: false,
      logs: [],
      beautify: [],
      errorMsg: ''
    };
  },

  computed: {},
  methods: {
    getLogs: function getLogs() {
      var self = this;

      self.loading = true;
      self.$sdk.get('/runs/autodispatch/logs', {
        token: self.$store.state.session.sessionToken
      }, function (res) {
        self.loading = false;
        if (res.error) {
          self.errorMsg = res.error.message;
          return;
        }
        self.logs = res.list;
      }, '2.0');
    },
    toggleView: function toggleView(id) {
      var index = this.beautify.indexOf(id);
      if (index > -1) this.beautify.splice(index, 1);else this.beautify.push(id);
    }
  },
  mounted: function mounted() {
    this.getLogs();
  }
});

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import moment from 'moment'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'admin-logs',
  data: function data() {
    return {
      loading: false,
      logs: [],
      beautify: [],
      beautifyError: [],
      beautifySendPayload: [],
      errorMsg: ''
    };
  },

  computed: {},
  methods: {
    getLogs: function getLogs() {
      var self = this;

      self.loading = true;
      self.$sdk.get('/runs/autodispatch/events', {
        token: self.$store.state.session.sessionToken
      }, function (res) {
        self.loading = false;
        if (res.error) {
          self.errorMsg = res.error.message;
          return;
        }
        self.logs = res.list;
      }, '2.0');
    },
    toggleView: function toggleView(id, field) {
      var index = this[field].indexOf(id);
      if (index > -1) this[field].splice(index, 1);else this[field].push(id);
    }
  },
  mounted: function mounted() {
    this.getLogs();
  }
});

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List__ = __webpack_require__(2116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddModal__ = __webpack_require__(2120);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'settings',
  components: { list: __WEBPACK_IMPORTED_MODULE_1__List__["a" /* default */], addModal: __WEBPACK_IMPORTED_MODULE_2__AddModal__["a" /* default */] },
  data: function data() {
    return {
      searchKey: '',
      addModal: {
        show: false
      }
    };
  },

  computed: {
    discountCodes: function discountCodes() {
      return this.$store.state.discountCodes;
    },

    loading: {
      get: function get() {
        return this.discountCodes.loading;
      },
      set: function set(x) {
        this.$store.commit('discountCodes/setListData', { loading: x });
      }
    },
    perPage: {
      get: function get() {
        return this.discountCodes.perPage;
      },
      set: function set(value) {
        this.$store.commit('discountCodes/setListData', {
          perPage: value,
          currentPage: 1
        });
        this.search();
      }
    },
    pageData: function pageData() {
      var tableData = this.discountCodes;
      var start = tableData.currentPage * tableData.perPage - (tableData.perPage - 1);
      var end = tableData.currentPage * tableData.perPage;
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      };
    },

    currentPage: {
      get: function get() {
        return this.discountCodes.currentPage;
      },
      set: function set(value) {
        this.$store.commit('discountCodes/setListData', { currentPage: parseInt(value) });
        this.search();
      }
    },
    isLastPage: function isLastPage() {
      return this.discountCodes.currentPage * this.discountCodes.perPage >= this.discountCodes.maxList;
    },
    totalPage: function totalPage() {
      return Math.ceil(this.discountCodes.maxList / this.discountCodes.perPage);
    }
  },
  methods: {
    showCreateModal: function showCreateModal() {
      if (this.$refs.addModal) {
        this.$refs.addModal.showModal();
      }
    },
    search: function search() {
      var self = this;
      if (self.loading) return;

      self.loading = true;
      self.$sdk.get('/discountcode', {
        token: self.$store.state.session.sessionToken,
        order: self.discountCodes.order,
        orderAsc: self.discountCodes.orderAsc,
        search: self.searchKey,
        pageSize: 999
      }, function (res) {
        self.loading = false;
        if (res.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          });
          return;
        }
        var list = [];
        res.list.forEach(function (data) {
          list.push({
            id: data.id,
            code: data.code,
            amount: data.type === '%' ? '' + data.amount + data.type : '' + data.type + data.amount.toFixed(2),
            created: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(data.created, 'X').format('MM/DD/YYYY hh:mmA'),
            start: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(data.start, 'X').format('MM/DD/YYYY hh:mmA'),
            end: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(data.end, 'X').format('MM/DD/YYYY hh:mmA'),
            enabled: data.isWidget,
            appEnabled: data.isApp
          });
        });
        self.$store.commit('discountCodes/setListData', { list: list });
      });
    },
    clearSearch: function clearSearch() {
      this.searchKey = '';
      this.search();
    },
    blurSearch: function blurSearch() {},
    next: function next() {},
    prev: function prev() {}
  },
  mounted: function mounted() {
    this.search();
  }
});

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_csvexport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var exporter = __WEBPACK_IMPORTED_MODULE_0_csvexport___default.a.create({
  filename: 'discount-code-export.csv',
  columns: ['RSVP ID', 'Created', 'Discount Amount']
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'discount-code-list',
  data: function data() {
    return {
      widgetLoading: [],
      appLoading: [],
      exportLoading: []
    };
  },

  computed: {
    discountCodes: function discountCodes() {
      return this.$store.state.discountCodes;
    },
    currentOrder: function currentOrder() {
      var dc = this.discountCodes;
      return { field: dc.order, asc: dc.orderAsc };
    },

    loading: {
      get: function get() {
        return this.discountCodes.loading;
      },
      set: function set(x) {
        this.$store.commit('discountCodes/setListData', { loading: x });
      }
    }
  },
  methods: {
    sort: function sort(field) {
      var self = this;
      if (self.loading) {
        return;
      }
      if (field !== self.discountCodes.order) {
        self.$store.commit('discountCodes/setListData', { orderAsc: 1 });
      } else {
        self.$store.commit('discountCodes/setListData', { orderAsc: self.discountCodes.orderAsc === 1 ? '' : 1 });
      }
      self.$store.commit('discountCodes/setListData', { order: field });

      self.$emit('search');
    },
    update: function update(id, val, type) {
      var self = this;
      if (self[type + 'Loading'].indexOf(id) > -1) return;
      self[type + 'Loading'].push(id);

      var param = { token: self.$store.state.session.sessionToken };
      param[type === 'app' ? 'isApp' : 'isWidget'] = val;
      self.$sdk.post('/discountcode/' + id, param, function (res) {
        self[type + 'Loading'].splice(self[type + 'Loading'].indexOf(id), 1);

        if (res.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          });
          return;
        }

        if (res.success) {
          var field = {};
          field[type === 'app' ? 'appEnabled' : 'enabled'] = val;
          self.$store.commit('discountCodes/updateListData', {
            id: id,
            fields: field
          });
        }
      });
    },
    exportDC: function exportDC(dc) {
      var self = this;
      if (self.exportLoading.indexOf(dc.id) > -1) return;
      self.exportLoading.push(dc.id);

      self.$sdk.get('/discountcode/' + dc.id + '/usage', {
        token: self.$store.state.session.sessionToken
      }, function (res) {
        var i = self.exportLoading.indexOf(dc.id);
        if (i > -1) self.exportLoading.splice(i, 1);

        if (res.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          });
          return;
        }
        if (!res.list.length) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: '<b>' + dc.code + '</b> Empty data.'
          });
          return;
        }

        var list = [];
        res.list.forEach(function (data) {
          list.push({
            'RSVP ID': data.rsvpId,
            'Created': __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(data.created, 'X').format('MM/DD/YYYY hh:mmA'),
            'Discount Amount': '$' + data.discountAmount.toFixed(2)
          });
        });
        exporter.downloadCsv(list);
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'discount-code-add',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a },
  props: ['isMobile'],
  data: function data() {
    return {
      show: false,
      code: '',
      desc: '',
      type: '$',
      amount: '',
      startDate: '',
      startDateHour: '',
      startDateMinute: '',
      endDate: '',
      endDateHour: '',
      endDateMinute: '',
      enabled: true,
      maxUse: '10',
      newUsers: '1',
      reedemOnce: '1',
      isWidget: 1,
      isApp: 1,
      errorMsg: {
        code: '',
        desc: '',
        amount: '',
        startDate: '',
        startDateHour: '',
        startDateMinute: '',
        endDate: '',
        endDateHour: '',
        endDateMinute: '',
        maxUse: ''
      },
      errorReturn: '',
      today: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(),
      loading: false
    };
  },

  computed: {
    startDateDisabled: function startDateDisabled() {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(this.today.subtract(1, 'months').format('YYYY'), this.today.format('MM'), this.today.format('DD'))
        };
      }

      return {
        to: new Date(this.today.format('YYYY'), this.today.subtract(1, 'months').format('MM'), this.today.format('DD'))
      };
    },
    endDateDisabled: function endDateDisabled() {
      var date = this.startDate ? __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.startDate).add(1, 'days') : __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()();
      if (date.format('MM') === '01') {
        return {
          to: new Date(date.subtract(1, 'months').format('YYYY'), date.format('MM'), date.format('DD'))
        };
      }

      return {
        to: new Date(date.format('YYYY'), date.subtract(1, 'months').format('MM'), date.format('DD'))
      };
    }
  },
  methods: {
    showModal: function showModal() {
      this.show = true;
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(date).format('MM/DD/YYYY');
    },
    changeDate: function changeDate(field) {
      this[field] = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this[field]).format('MM/DD/YYYY');
    },
    save: function save() {
      var self = this;
      if (self.loading) {
        return;
      }

      if (self.validate()) {
        self.loading = true;
        this.$store.commit('global/setLoaderData', { show: true, message: '' });
        var startDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(self.startDate);
        startDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(startDate.format('MM/DD/YYYY ') + self.startDateHour + ':' + self.startDateMinute);
        var endDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(self.endDate);
        endDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(endDate.format('MM/DD/YYYY ') + self.endDateHour + ':' + self.endDateMinute);

        self.$sdk.post('/discountcode', {
          token: self.$store.state.session.sessionToken,
          code: self.code,
          type: self.type,
          amount: self.amount,
          startUTC: startDate.format('X'),
          endUTC: endDate.format('X'),
          enabled: self.enabled,
          description: self.desc,
          maxUse: self.maxUse,
          isWidget: self.isWidget == '1',
          isApp: self.isApp == '1',
          oncePerUser: self.reedemOnce == '1',
          newUsersOnly: self.newUsers == '1'
        }, function (res) {
          self.loading = false;
          self.$store.commit('global/setLoaderData', { show: false, message: '' });
          if (res.error) {
            self.$store.commit('global/setAlertData', {
              show: true,
              message: res.error.message
            });
            return;
          }

          self.show = false;
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'Successfully created a Discount Code.'
          });
          self.$emit('refresh');
        });
      }
    },
    validate: function validate() {
      this.resetErrorMsg();
      var hasError = false;

      console.log('~', this.maxUse);
      for (var field in this.errorMsg) {
        if (this[field] === '') {
          this.errorMsg[field] = 'This field cannot be empty.';
          hasError = true;
        }
        if (this[field] && field === 'maxUse' && parseInt(this.maxUse) < 1) {
          this.errorMsg[field] = 'Must be atleast 1.';
          hasError = true;
        }
      }

      return !hasError;
    },
    resetErrorMsg: function resetErrorMsg() {
      this.errorMsg = {
        code: '',
        amount: '',
        startDate: '',
        startDateHour: '',
        startDateMinute: '',
        endDate: '',
        endDateHour: '',
        endDateMinute: '',
        maxUse: ''
      };
    },
    clearForm: function clearForm() {
      this.code = '';
      this.type = '$';
      this.amount = '';
      this.startDate = '';
      this.startDateHour = '';
      this.startDateMinute = '';
      this.endDate = '';
      this.endDateHour = '';
      this.endDateMinute = '';
      this.enabled = true;
    },
    scrollToTop: function scrollToTop() {
      var elmnt = document.getElementById('addPromo');
      elmnt.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    leadingZero: function leadingZero(x) {
      return x < 10 ? '0' + x : x;
    },
    removeEventSpaces: function removeEventSpaces(e) {
      e.preventDefault();
      var left = e.target.value.substring(0, e.target.selectionStart);
      var right = e.target.value.substring(e.target.selectionEnd, e.target.value.length);
      var pasted = (e.dataTransfer || e.clipboardData).getData('text').replace(/ /g, '');
      e.target.value = left + pasted + right;
    },
    onlyNumber: function onlyNumber($event) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RsvpList__ = __webpack_require__(2128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_csvexport__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var exporter = __WEBPACK_IMPORTED_MODULE_3_csvexport___default.a.create({
  filename: 'discount-code-export.csv',
  columns: ['RSVP ID', 'Created', 'Discount Amount']
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'discount-code-view',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a, RsvpList: __WEBPACK_IMPORTED_MODULE_2__RsvpList__["a" /* default */] },
  data: function data() {
    return {
      code: '',
      desc: '',
      type: '',
      amount: '',
      created: '',
      startDate: '',
      startHr: '',
      startMin: '',
      endDate: '',
      endHr: '',
      endMin: '',
      // enabled: '',
      maxUse: '',
      newUsers: '',
      reedemOnce: '',
      isWidget: false,
      isApp: false,
      error: {
        code: '',
        amount: '',
        startDate: '',
        startHr: '',
        startMin: '',
        endDate: '',
        endHr: '',
        endMin: '',
        maxUse: ''
      },
      today: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(),
      exportLoading: false,
      showRecords: false
    };
  },

  computed: {
    id: function id() {
      return this.$route.params.id;
    },
    discountCodes: function discountCodes() {
      return this.$store.state.discountCodes;
    },
    view: function view() {
      return this.discountCodes.view;
    },
    startDateDisabled: function startDateDisabled() {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(this.today.subtract(1, 'months').format('YYYY'), this.today.format('MM'), this.today.format('DD'))
        };
      }

      return {
        to: new Date(this.today.format('YYYY'), this.today.subtract(1, 'months').format('MM'), this.today.format('DD'))
      };
    },
    endDateDisabled: function endDateDisabled() {
      var date = this.startDate ? __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.startDate).add(1, 'days') : __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()();
      if (date.format('MM') === '01') {
        return {
          to: new Date(date.subtract(1, 'months').format('YYYY'), date.format('MM'), date.format('DD'))
        };
      }

      return {
        to: new Date(date.format('YYYY'), date.subtract(1, 'months').format('MM'), date.format('DD'))
      };
    }
  },
  methods: {
    getDetails: function getDetails() {
      var _this = this;

      var self = this;

      this.$store.commit('global/setLoaderData', { show: true, message: '' });
      self.$sdk.get('/discountcode/' + self.id, {
        token: self.$store.state.session.sessionToken
      }, function (res) {
        _this.$store.commit('global/setLoaderData', { show: false, message: '' });
        if (res.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          });
          self.$router.push('/discount-codes');
          return;
        }

        self.code = res.code;
        self.desc = res.description;
        self.type = res.type;
        self.amount = res.amount;
        self.created = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(res.created, 'X').format('MM/DD/YYYY hh:mmA');
        var startDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(res.start, 'X');
        self.startDate = startDate.format('MM/DD/YYYY');
        self.startHr = startDate.format('HH');
        self.startMin = startDate.format('mm');
        var endDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(res.end, 'X');
        self.endDate = endDate.format('MM/DD/YYYY');
        self.endHr = endDate.format('HH');
        self.endMin = endDate.format('mm');
        // self.enabled = res.isWidget
        self.maxUse = res.maxUse;
        self.newUsers = res.newUsersOnly ? '1' : '0';
        self.reedemOnce = res.oncePerUser ? '1' : '0';
        self.isWidget = res.isWidget;
        self.isApp = res.isApp;
      });
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(date).format('MM/DD/YYYY');
    },
    changeDate: function changeDate(field) {
      this[field] = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this[field]).format('MM/DD/YYYY');
    },
    leadingZero: function leadingZero(x) {
      return x < 10 ? '0' + x : x;
    },
    update: function update() {
      var self = this;

      var start = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(self.startDate + ' ' + self.startHr + ':' + self.startMin, 'MM/DD/YYYY HH:mm').format('X');
      var end = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(self.endDate + ' ' + self.endHr + ':' + self.endMin, 'MM/DD/YYYY HH:mm').format('X');
      self.$store.commit('global/setLoaderData', { show: true, message: '' });
      var data = {
        token: self.$store.state.session.sessionToken,
        start: start,
        end: end,
        isWidget: self.isWidget,
        isApp: self.isApp,
        description: self.desc,
        maxUse: self.maxUse,
        oncePerUser: self.reedemOnce == '1',
        newUsersOnly: self.newUsers == '1'
      };
      if (self.view.list.length == 0) {
        data.amount = self.amount;
        data.type = self.type;
      }
      self.$sdk.post('/discountcode/' + self.id, data, function (res) {
        self.$store.commit('global/setLoaderData', { show: false, message: '' });
        if (res.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          });
          return;
        }
        self.$store.commit('global/setAlertData', {
          show: true,
          message: 'Success! Discount code was updated!'
        });
      });
    },
    exportDC: function exportDC() {
      var self = this;
      if (self.exportLoading) return;
      self.exportLoading = true;

      self.$sdk.get('/discountcode/' + self.id + '/usage', {
        token: self.$store.state.session.sessionToken
      }, function (res) {
        self.exportLoading = false;

        if (res.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          });
          return;
        }
        if (!res.list.length) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: '<b>' + self.code + '</b> Empty data.'
          });
          return;
        }

        var list = [];
        res.list.forEach(function (data) {
          list.push({
            'RSVP ID': data.rsvpId,
            'Created': __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(data.created, 'X').format('MM/DD/YYYY hh:mmA'),
            'Discount Amount': '$' + data.discountAmount.toFixed(2)
          });
        });
        exporter.downloadCsv(list);
      });
    }
  },
  mounted: function mounted() {
    this.getDetails();
    // if (this.$refs.rsvpList) {
    //   this.$refs.rsvpList.getList()
    // }
  }
});

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'discount-code-list',
  data: function data() {
    return {
      // loading: false,
      list: []
      // currentPage: 1,
      // perPage: 20
    };
  },

  computed: {
    id: function id() {
      return this.$route.params.id;
    },
    discountCodes: function discountCodes() {
      return this.$store.state.discountCodes;
    },
    view: function view() {
      return this.discountCodes.view;
    }
    // pageData () {
    //   let tableData = this.$store.state.promo.view
    //   let start = (this.currentPage * this.perPage) - (this.perPage - 1)
    //   let end = this.currentPage * this.perPage
    //   return {
    //     start: start < 1 ? 1 : start,
    //     end: end > tableData.maxList ? tableData.maxList : end,
    //     max: tableData.maxList
    //   }
    // },

  },
  methods: {
    getList: function getList() {
      var self = this;
      if (self.view.loading) return;

      self.view.loading = true;
      self.$sdk.get('/discountcode/' + self.id + '/usage', {
        token: self.$store.state.session.sessionToken
      }, function (res) {
        self.view.loading = false;
        if (res.error) {
          self.list = [];
          return;
        }
        self.list = [];
        res.list.forEach(function (rsvp) {
          self.list.push({
            rsvpId: rsvp.rsvpId,
            created: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(rsvp.created, 'X').format('MM/DD/YYYY hh:mmA'),
            amount: rsvp.discountAmount.toFixed(2),
            type: rsvp.useType
          });
        });
        self.$store.commit('discountCodes/setViewData', { list: self.list });
      });
    }
  },
  mounted: function mounted() {
    this.getList();
  }
});

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'admin-quotation-summary',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a },
  data: function data() {
    return {
      start: '',
      end: '',
      loading: false,
      validation: {
        start: '',
        end: ''
      },
      list: []
    };
  },

  computed: {
    disabledDate: function disabledDate() {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(this.today.subtract(1, 'months').format('YYYY'), this.today.format('MM'), this.today.format('DD'))
        };
      }

      return {
        to: new Date(this.today.format('YYYY'), this.today.subtract(1, 'months').format('MM'), this.today.format('DD'))
      };
    }
  },
  methods: {
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('MM/DD/YYYY');
    },
    getSummary: function getSummary() {
      var self = this;

      var start = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.start, 'MM/DD/YYYY').set('hour', 0).set('minute', 0);
      var end = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.end, 'MM/DD/YYYY').set('hour', 23).set('minute', 59);
      self.validation.start = '';
      if (end.diff(start, 'days') < 0) {
        self.validation.start = 'Cannot be greater than end date.';
        return;
      }

      self.loading = true;
      self.$sdk.opt('/quotation/summary', {
        token: self.$store.state.session.sessionToken,
        startUnix: start.format('x'),
        endUnix: end.format('x')
      }, function (res) {
        self.loading = false;
        var list = [];
        if (!res.error) {
          res.segments.forEach(function (data) {
            list.push({
              date: __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.date, 'YYYY-MM-DD').format('MM/DD/YYYY'),
              count: data.requestCount,
              time: data.avgResponseTime
            });
          });
        }
        self.list = list;
      });
    }
  },
  mounted: function mounted() {
    this.start = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(7, 'days').format('MM/DD/YYYY');
    this.end = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM/DD/YYYY');
    this.getSummary();
  }
});

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jspdf__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_provider_user_info__ = __webpack_require__(61);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'download-profile',
  data: function data() {
    return {
      noPhotoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png',
      created: ''
    };
  },

  computed: {
    id: function id() {
      return this.$route.params.id;
    },
    provider: function provider() {
      return this.$store.state.provider;
    },
    isActive: function isActive() {
      return this.provider.active;
    },
    basicInfo: function basicInfo() {
      return this.provider.basicInfo;
    },
    vehicleInfo: function vehicleInfo() {
      return this.provider.vehicleInfo;
    },
    accountType: function accountType() {
      return this.provider.accountType;
    },
    businessInfo: function businessInfo() {
      return this.provider.businessInfo;
    },
    documentation: function documentation() {
      return this.provider.documentation;
    },
    eligibility: function eligibility() {
      return this.provider.eligibility;
    },
    signature: function signature() {
      return this.provider.signature;
    },

    driverId: {
      get: function get() {
        return this.$store.state.provider.driverId;
      },
      set: function set(x) {
        this.$store.commit('provider/setDriverId', x);
      }
    },
    aggreementsLink: function aggreementsLink() {
      if (this.getVariable('brand') === 'op') {
        return {
          conductRules: '<a href="https://opoli.com/driver/conduct-rules/" target="_blank">https://opoli.com/driver/conduct-rules/</a>',
          terms: '<a href="https://opoli.com/terms" target="_blank">https://opoli.com/terms</a>',
          privacy: '<a href="https://opoli.com/privacy" target="_blank">https://opoli.com/privacy</a>'
        };
      }
      return {
        conductRules: '<a href="https://www.primetimerideshare.com/driver-conduct-rules" target="_blank">https://www.primetimerideshare.com/driver-conduct-rules</a>',
        terms: '<a href="https://www.primetimerideshare.com/terms" target="_blank">https://www.primetimerideshare.com/terms</a>',
        privacy: '<a href="https://www.primetimerideshare.com/privacy-policy" target="_blank">https://www.primetimerideshare.com/privacy-policy</a>'
      };
    },
    _created: function _created() {
      return this.$store.state.provider.created;
    }
  },
  methods: {
    init: function init() {
      var self = this;
      self.$store.commit('global/setLoaderData', { show: true, message: '' });

      __WEBPACK_IMPORTED_MODULE_3__modules_api_provider_user_info__["a" /* default */].getProviderData(self, self.id, function (res) {
        if (res.error) {
          self.$store.commit('global/setLoaderData', { show: false, message: '' });
          self.$router.push({ name: 'MissingPage' });
          return;
        }
        document.title = self.basicInfo.firstName + ' ' + self.basicInfo.lastName;

        if (!res.driverNum) {
          self.getNextDriverNum();
          return;
        }
        // if (self.getVariable('brand') === 'op') self.created = self._created
        self.created = self._created;
        if (self.getVariable('brand') === 'ptrs') {
          if (self.isBefore2026(self._created)) self.created = '01/01/2026';
        }
        self.$store.commit('global/setLoaderData', { show: false, message: '' });
      });
    },
    getNextDriverNum: function getNextDriverNum() {
      var self = this;
      self.$sdk.get('/provider/nextNum', {
        token: self.$store.state.session.sessionToken
      }, function (res) {
        self.$store.commit('global/setLoaderData', { show: false, message: '' });
        if (!res.error) {
          self.driverId = res.next;
          self.nextDriverId = res.next;
          return;
        }
      });
    },
    getVariable: function getVariable(url) {
      var query = window.location.search.substring(1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (pair[0] === url) {
          return pair[1];
        }
      }
      return false;
    },
    isBefore2026: function isBefore2026(x) {
      var year = __WEBPACK_IMPORTED_MODULE_0_moment___default()(x, 'MM/DD/YYYY').format('YYYY');
      year = parseInt(year);
      return year < 2026;
    }
  },
  watch: {
    provId: function provId() {
      this.init();
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generate__ = __webpack_require__(2144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__confirm__ = __webpack_require__(2148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_csvexport__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_csvexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_csvexport__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'admin-airtag',
  components: { generate: __WEBPACK_IMPORTED_MODULE_1__generate__["a" /* default */], confirm: __WEBPACK_IMPORTED_MODULE_2__confirm__["a" /* default */] },
  data: function data() {
    return {
      list: [],
      selected: [],
      action: '',
      total: 0,
      emailed: 0,
      redeem: 0,
      fulfilled: 0,
      voided: 0
    };
  },

  computed: {
    disabledDate: function disabledDate() {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(this.today.subtract(1, 'months').format('YYYY'), this.today.format('MM'), this.today.format('DD'))
        };
      }

      return {
        to: new Date(this.today.format('YYYY'), this.today.subtract(1, 'months').format('MM'), this.today.format('DD'))
      };
    }
  },
  methods: {
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('MM/DD/YYYY');
    },
    getList: function getList() {
      var exportCsv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var self = this;

      self.$store.commit('global/setLoaderData', { show: true, message: '' });
      self.$sdk.get('/promo/airtag/list', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.$store.commit('global/setLoaderData', { show: false, message: '' });
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          self.list = [];
          return;
        }

        var tmp = [];
        var emailed = 0;
        var redeem = 0;
        var fulfilled = 0;
        var voided = 0;

        var tmpExport = [];
        r.list.forEach(function (x) {
          if (x.emailUTC) emailed++;
          if (x.redeemUTC) redeem++;
          if (x.fulfillUTC) fulfilled++;
          if (x.voided) voided++;

          var addr = '';
          if (x.custAddress1) addr = x.custAddress1 + ', ' + x.custCity + ', ' + x.custState + ', ' + x.custZip;

          var rsvp = [];
          if (x.rsvpId1) rsvp.push(x.rsvpId1);
          if (x.rsvpId2) rsvp.push(x.rsvpId2);
          tmp.push({
            id: x.id,
            code: x.code,
            name: x.custName,
            phone: x.custPhone,
            address: addr,
            rsvp: rsvp,
            fulfill: !x.fulfillUTC ? '--' : __WEBPACK_IMPORTED_MODULE_0_moment___default()(x.fulfillUTC).format('MM/DD/YYYY hh:mmA'),
            voided: x.voided
          });

          if (exportCsv) {
            tmpExport.push({
              'Code': x.code,
              'Name': x.custName,
              'Phone': x.custPhone,
              'Mailing Address': addr,
              'RSVP': rsvp.join(', '),
              'Fulfill': !x.fulfillUTC ? '--' : __WEBPACK_IMPORTED_MODULE_0_moment___default()(x.fulfillUTC).format('MM/DD/YYYY hh:mmA'),
              'Is Voided': x.voided ? 'Yes' : 'No'
            });
          }
        });
        self.list = tmp;

        self.total = r.list.length;
        self.emailed = emailed;
        self.redeem = redeem;
        self.fulfilled = fulfilled;
        self.voided = voided;

        if (exportCsv) {
          tmpExport.push({
            'Code': '',
            'Name': '',
            'Phone': '',
            'Mailing Address': '',
            'RSVP': '',
            'Fulfill': '',
            'Is Voided': ''
          });
          tmpExport.push({
            'Code': 'Total',
            'Name': r.list.length,
            'Phone': '',
            'Mailing Address': '',
            'RSVP': '',
            'Fulfill': '',
            'Is Voided': ''
          });
          tmpExport.push({
            'Code': 'Emailed',
            'Name': emailed,
            'Phone': '',
            'Mailing Address': '',
            'RSVP': '',
            'Fulfill': '',
            'Is Voided': ''
          });
          tmpExport.push({
            'Code': 'Redeem',
            'Name': redeem,
            'Phone': '',
            'Mailing Address': '',
            'RSVP': '',
            'Fulfill': '',
            'Is Voided': ''
          });
          tmpExport.push({
            'Code': 'Fulfilled',
            'Name': fulfilled,
            'Phone': '',
            'Mailing Address': '',
            'RSVP': '',
            'Fulfill': '',
            'Is Voided': ''
          });
          tmpExport.push({
            'Code': 'Voided',
            'Name': voided,
            'Phone': '',
            'Mailing Address': '',
            'RSVP': '',
            'Fulfill': '',
            'Is Voided': ''
          });
          var exporter = __WEBPACK_IMPORTED_MODULE_3_csvexport___default.a.create({
            filename: 'airtag-report.csv',
            columns: ['Code', 'Name', 'Phone', 'Mailing Address', 'RSVP', 'Fulfill', 'Is Voided']
          });
          exporter.downloadCsv(tmpExport);
        }
      });
    },
    showGenerateModal: function showGenerateModal() {
      if (this.$refs.generate) this.$refs.generate.showModal();
    },
    confirm: function confirm(x) {
      if (!this.selected.length) {
        this.$store.commit('global/setAlertData', {
          show: true,
          message: 'No items selected.'
        });
        return;
      }

      this.action = x;
      if (this.$refs.confirm) this.$refs.confirm.showModal();
    },
    proceed: function proceed() {
      if (this.action === 'void') this.void();
      if (this.action === 'fulfill') this.fulfill();
    },
    void: function _void() {
      var self = this;

      if (!self.selected.length) {
        self.$store.commit('global/setLoaderData', { show: false, message: '' });
        self.getList();
        return;
      }

      self.$store.commit('global/setLoaderData', { show: true, message: '' });
      self.$sdk.post('/promo/airtag/void', {
        token: self.$store.state.session.sessionToken,
        id: self.selected[0]
      }, function (r) {
        if (r.error) {
          self.$store.commit('global/setLoaderData', { show: false, message: '' });
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          self.getList();
          return;
        }

        self.selected.shift();
        self.void();
      });
    },
    fulfill: function fulfill() {
      var self = this;

      if (!self.selected.length) {
        self.$store.commit('global/setLoaderData', { show: false, message: '' });
        self.getList();
        return;
      }

      self.$store.commit('global/setLoaderData', { show: true, message: '' });
      self.$sdk.post('/promo/airtag/fulfill', {
        token: self.$store.state.session.sessionToken,
        id: self.selected[0]
      }, function (r) {
        if (r.error) {
          self.$store.commit('global/setLoaderData', { show: false, message: '' });
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          self.getList();
          return;
        }

        self.selected.shift();
        self.fulfill();
      });
    }
  },
  mounted: function mounted() {
    this.getList();
  }
});

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'alert',
  data: function data() {
    return {
      show: false,
      brandId: 4,
      count: 5
    };
  },

  methods: {
    showModal: function showModal() {
      this.show = true;
    },
    isNumber: function isNumber(evt) {
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
        return;
      }
      return true;
    },
    generate: function generate() {
      var self = this;

      if (parseFloat(self.count) < 1 || !self.count) {
        self.$store.commit('global/setAlertData', {
          show: true,
          message: 'Invalid generate amount'
        });
        return;
      }

      self.show = false;
      self.$store.commit('global/setLoaderData', { show: true, message: '' });
      self.$sdk.post('/promo/airtag/generate', {
        token: self.$store.state.session.sessionToken,
        brandId: self.brandId,
        num: parseInt(self.count)
      }, function (r) {
        self.$store.commit('global/setLoaderData', { show: false, message: '' });
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          return;
        }
        self.$emit('refreshList');
      });
    }
  },
  mounted: function mounted() {
    if ({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.Env !== 'production') this.brandId = 12;
  }
});

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'alert',
  props: ['action'],
  data: function data() {
    return {
      show: false
    };
  },

  methods: {
    showModal: function showModal() {
      this.show = true;
    },
    confirm: function confirm() {
      this.show = false;
      this.$emit('proceed');
    }
  }
});

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateModal__ = __webpack_require__(2156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfirmUpload__ = __webpack_require__(2160);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* // global CONFIG */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'insurance',
  components: {
    CreateModal: __WEBPACK_IMPORTED_MODULE_1__CreateModal__["a" /* default */],
    ConfirmUpload: __WEBPACK_IMPORTED_MODULE_2__ConfirmUpload__["a" /* default */]
  },
  data: function data() {
    return {
      target: 0
    };
  },

  computed: {
    insurance: function insurance() {
      return this.$store.state.insurance;
    }
  },
  methods: {
    showCreate: function showCreate() {
      this.$store.commit('insurance/setListData', { showCreate: true });
    },
    getList: function getList() {
      var self = this;
      self.$store.commit('global/setLoaderData', { show: true });
      self.$sdk.post('/insurance/list', {
        token: self.$store.state.session.sessionToken
      }, function (r) {
        self.$store.commit('global/setLoaderData', { show: false });
        if (r.error) {
          self.$store.commit('insurance/setListData', { list: [] });
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          return;
        }
        self.$store.commit('insurance/setListData', { list: r.list });
      }, '2.0');
    },
    formatdate: function formatdate(x) {
      var withTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!x) return '--';
      var format = !withTime ? 'MM/DD/YYYY' : 'MM/DD/YY hh:mmA';
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(x, 'X').format(format);
    },
    confirmUpload: function confirmUpload(id) {
      this.target = id;
      this.$store.commit('insurance/setListData', { showConfirm: true });
    }
  },
  mounted: function mounted() {
    var access = this.$store.state.session.user.access;
    if (!access.hasOwnProperty('PageAdminInsurance')) {
      this.$router.push({ name: 'MissingPage' });
      return;
    }
    this.getList();
  }
});

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'insurance-create-modal',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a },
  data: function data() {
    return {
      start: '',
      end: '',
      validation: {
        start: '',
        end: ''
      },
      miles: 0,
      whitelist: ''
    };
  },

  computed: {
    insurance: function insurance() {
      return this.$store.state.insurance;
    }
  },
  methods: {
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('MM/DD/YYYY');
    },
    create: function create() {
      var self = this;

      var start = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.start, 'MM/DD/YYYY').set('hour', 0).set('minute', 0);
      var end = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.end, 'MM/DD/YYYY').set('hour', 23).set('minute', 59).set('second', 59);
      var hasError = false;
      self.validation = { start: '', end: '' };
      if (!self.start) {
        hasError = true;
        self.validation.start = 'this field is required.';
      }
      if (!self.end) {
        hasError = true;
        self.validation.end = 'this field is required.';
      }
      if (self.start && self.end && end.diff(start, 'days') < 0) {
        hasError = true;
        self.validation.start = 'Cannot be greater than end date.';
      }

      if (hasError) return;
      self.$store.commit('global/setLoaderData', { show: true });
      self.$sdk.post('/insurance/create', {
        token: self.$store.state.session.sessionToken,
        startUTC: start.format('X'),
        endUTC: end.format('X'),
        milesPerDay: self.miles,
        whitelist: self.whitelist
      }, function (r) {
        self.$store.commit('global/setLoaderData', { show: false });
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          return;
        }
        self.$store.commit('global/setAlertData', {
          show: true,
          message: 'Report Created Successfully!<br/>Report ID: <b>' + r.id + '</b>'
        });
        self.resetFields();
        self.$emit('refreshList');
        self.$store.commit('insurance/setListData', { showCreate: false });
      }, '2.0');
    },
    resetFields: function resetFields() {
      this.start = '';
      this.end = '';
      this.miles = 0;
      this.whitelist = '';
    },
    cancel: function cancel() {
      this.$store.commit('insurance/setListData', { showCreate: false });
    }
  },
  watch: {
    show: function show(x) {}
  },
  mounted: function mounted() {}
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'insurance-create-modal',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a },
  props: ['id'],
  data: function data() {
    return {
      start: '',
      end: '',
      validation: {
        start: '',
        end: ''
      },
      miles: 0,
      whitelist: ''
    };
  },

  computed: {
    insurance: function insurance() {
      return this.$store.state.insurance;
    }
  },
  methods: {
    upload: function upload() {
      var self = this;
      self.$store.commit('global/setLoaderData', { show: true });
      self.$sdk.post('/insurance/upload', {
        token: self.$store.state.session.sessionToken,
        id: self.id
      }, function (r) {
        self.$store.commit('global/setLoaderData', { show: false });
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          return;
        }
        self.$emit('refreshList');
        self.$store.commit('insurance/setListData', { showConfirm: false });
      }, '2.0');
    },
    cancel: function cancel() {
      this.$store.commit('insurance/setListData', { showConfirm: false });
    }
  },
  watch: {
    show: function show(x) {}
  },
  mounted: function mounted() {}
});

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commands__ = __webpack_require__(2168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__failed__ = __webpack_require__(2172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rsvp__ = __webpack_require__(2176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__asap__ = __webpack_require__(2180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(2190);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'admin-code',
  components: { commands: __WEBPACK_IMPORTED_MODULE_0__commands__["a" /* default */], failed: __WEBPACK_IMPORTED_MODULE_1__failed__["a" /* default */], rsvp: __WEBPACK_IMPORTED_MODULE_2__rsvp__["a" /* default */], asap: __WEBPACK_IMPORTED_MODULE_3__asap__["a" /* default */], services: __WEBPACK_IMPORTED_MODULE_4__services__["a" /* default */] },
  data: function data() {
    return {
      tab: 'command'
    };
  },

  computed: {},
  methods: {},
  watch: {
    tab: function tab(x) {
      if (x !== 'command') {
        if (this.$refs[x]) this.$refs[x].checkLoaded();
      }
    }
  },
  mounted: function mounted() {
    var access = this.$store.state.session.user.access;
    if (!access.hasOwnProperty('PageAdminCode')) this.$router.push({ name: 'MissingPage' });
    // console.log('222', access.hasOwnProperty('PageAdminCode'))
  }
});

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'commands',
  data: function data() {
    return {
      env: 'production',
      show: false,
      selectedCommand: null,
      commands: [{ value: 'consumerId', text: 'Consumer ID' }, { value: 'removeCB', text: 'Remove CB' }, { value: 'forceNoShow', text: 'Force No Show' }, { value: 'forceComplete', text: 'Force Complete' }, { value: 'forceCancel', text: 'Force Cancel' }, { value: 'removeMG', text: 'Remove M&G' }, { value: 'resetRSVP', text: 'Reset RSVP' }, { value: 'undoNoShow', text: 'Undo No Show' }, { value: 'undoComplete', text: 'Undo Complete' }, { value: 'driverPayment', text: 'Driver Payment' }, { value: 'privateVan', text: 'Private Van' }, { value: 'notFailed', text: 'Not Failed' }],
      confirmTarget: '',
      consumer: {
        email: '',
        level: 1
      },
      removeCBRsvpID: '',
      forceNoShowRsvpID: '',
      forceCompleteRsvpID: '',
      forceCancelRsvpID: '',
      removeMNGRsvpID: '',
      resetRsvpID: '',
      undoNoShowRsvpID: '',
      undoCompleteRsvpID: '',
      driverPayment: {
        rsvpId: '',
        amount: ''
      },
      privateVanRsvpID: '',
      notFailedRsvpID: '',
      error: {
        consumerEmail: '',
        removeCBRsvpID: '',
        forceNoShowRsvpID: '',
        forceCompleteRsvpID: '',
        forceCancelRsvpID: '',
        removeMNGRsvpID: '',
        resetRsvpID: '',
        undoNoShowRsvpID: '',
        undoCompleteRsvpID: '',
        driverPaymentRsvpID: '',
        driverPaymentAmount: '',
        privateVanRsvpID: '',
        notFailedRsvpID: ''
      }
    };
  },

  computed: {},
  methods: {
    confirm: function confirm(x) {
      this.confirmTarget = x;
      this.show = true;
    },
    btnTrigger: function btnTrigger() {
      var self = this;
      self.show = false;
      self.$store.commit('global/setLoaderData', { show: true });

      if (self.confirmTarget === 'Create Reservation') {
        var param = {
          "token": "USER-811b6ae3-5ab6-4bdf-a956-71b7efbb2624",
          "brandId": 8,
          "guest": null,
          "legs": [{ "pickup": { "address1": "Disneyland Drive", "address2": "1313", "city": "Anaheim", "state": "CA", "zip": "92802", "lat": "33.8120918", "lng": "-117.91897419999998", "title": "1313 Disneyland Dr, Anaheim, CA 92802, USA", "geofenceId": 294 }, "dropoff": { "address1": "1", "address2": "World Way", "city": "Los Angeles", "state": "CA", "zip": "", "lat": "33.9415889", "lng": "-118.40852999999998", "title": "1 World Way, Los Angeles, CA 90045", "geofenceId": 12 }, "pickupTime": "1746303900", "passengers": 1, "luggage": 1, "amount": 75.99, "originalPrice": 75.99, "airportFee": 5, "gasFee": 1.73, "flightNumber": "", "flightName": "", "dropoffFlightName": "American (terminal 5)", "dropoffFlightNumber": "2024", "asap": false, "etaInSec": 3476, "serviceTypeId": 39, "pickupType": "", "pickupFee": 0, "distance": 34.564393926192, "notes": "", "travelInsurance": 5.18, "tip": 0 }, null],
          "payment": { "cardID": 1023, "tip": 0, "total": "87.90", "fare": "87.90", "pickupFee": 0, "promo": 0 },
          "wheelchair": 0,
          "serviceDog": 0,
          "source": "C",
          "deviceType": "ww",
          "hudson": false
        };
        param.legs[0].pickupTime = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().add(1, 'hour').format('X');
        self.$sdk.post('/reservations', param, function (r) {
          self.$store.commit('global/setLoaderData', { show: false });
          if (r.error) {
            self.$store.commit('global/setAlertData', {
              show: true,
              message: r.error.message
            });
            return;
          }
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'RES CREATED! <b><a target="_blank" href="/#/reservation/' + r.reservationId[0] + '">' + r.reservationId[0] + '</a></b>'
          });
        });
        return;
      }

      var url = '/utils/flushhosts';
      if (self.confirmTarget === 'Unstuck DB') url = '/utils/unstuck';
      self.$sdk.get(url, {}, function (r) {
        self.$store.commit('global/setLoaderData', { show: false });
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          return;
        }
        self.$store.commit('global/setAlertData', {
          show: true,
          message: '<b>' + self.confirmTarget + '</b> SUCCESS!'
        });
      }, '');
    },
    submitAction: function submitAction(x) {
      var self = this;
      var param = {};
      var url = '';
      if (x === 'Consumer ID') {
        url = '/utils/consid';
        param = { email: self.consumer.email, level: self.consumer.level || 1 };
        self.error.consumerEmail = '';
        if (!param.email) {
          self.error.consumerEmail = 'error';
          return;
        }
      }
      if (x === 'Remove CB') {
        url = '/utils/removecb';
        param = { rsvpId: self.removeCBRsvpID };
        self.error.removeCBRsvpID = '';
        if (!param.rsvpId) {
          self.error.removeCBRsvpID = 'error';
          return;
        }
      }
      if (x === 'Force No Show') {
        url = '/utils/forcenoshow';
        param = { rsvpId: self.forceNoShowRsvpID };
        self.error.forceNoShowRsvpID = '';
        if (!param.rsvpId) {
          self.error.forceNoShowRsvpID = 'error';
          return;
        }
      }
      if (x === 'Force Complete') {
        url = '/utils/forcecomplete';
        param = { rsvpId: self.forceCompleteRsvpID };
        self.error.forceCompleteRsvpID = '';
        if (!param.rsvpId) {
          self.error.forceCompleteRsvpID = 'error';
          return;
        }
      }
      if (x === 'Force Cancel') {
        url = '/utils/forcecancel';
        param = { rsvpId: self.forceCancelRsvpID };
        self.error.forceCancelRsvpID = '';
        if (!param.rsvpId) {
          self.error.forceCancelRsvpID = 'error';
          return;
        }
      }
      if (x === 'Remove M&G') {
        url = '/utils/removemng';
        param = { rsvpId: self.removeMNGRsvpID };
        self.error.removeMNGRsvpID = '';
        if (!param.rsvpId) {
          self.error.removeMNGRsvpID = 'error';
          return;
        }
      }
      if (x === 'Reset RSVP') {
        url = '/utils/resetrsvp';
        param = { rsvpId: self.resetRsvpID };
        self.error.resetRsvpID = '';
        if (!param.rsvpId) {
          self.error.resetRsvpID = 'error';
          return;
        }
      }
      if (x === 'Undo Complete') {
        url = '/utils/undocomplete';
        param = { rsvpId: self.undoCompleteRsvpID };
        self.error.undoCompleteRsvpID = '';
        if (!param.rsvpId) {
          self.error.undoCompleteRsvpID = 'error';
          return;
        }
      }
      if (x === 'Driver Payment') {
        url = '/utils/dp';
        param = { rsvpId: self.driverPayment.rsvpId, amount: self.driverPayment.amount };
        self.error.driverPaymentRsvpID = '';
        self.error.driverPaymentAmount = '';
        if (!param.rsvpId) self.error.driverPaymentRsvpID = 'error';
        if (!param.amount) self.error.driverPaymentAmount = 'error';
        if (!param.rsvpId || !param.amount) return;
      }
      if (x === 'Private Van') {
        url = '/utils/pv';
        param = { rsvpId: self.privateVanRsvpID };
        self.error.privateVanRsvpID = '';
        if (!param.rsvpId) {
          self.error.privateVanRsvpID = 'error';
          return;
        }
      }
      if (x === 'Not Failed') {
        url = '/utils/pv';
        param = { rsvpId: self.notFailedRsvpID };
        self.error.notFailedRsvpID = '';
        if (!param.rsvpId) {
          self.error.notFailedRsvpID = 'error';
          return;
        }
      }

      self.$store.commit('global/setLoaderData', { show: true });
      self.$sdk.get(url, param, function (r) {
        self.$store.commit('global/setLoaderData', { show: false });
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          return;
        }
        var msg = '<b>' + x + '</b> SUCCESS!';
        if (x === 'Consumer ID' && r.results) {
          if (r.results.length) {
            r.results.forEach(function (con) {
              msg += '<br/>- ' + con.ID + ' ' + con.email;
            });
          } else {
            msg += '<br/>- <i>EMPTY RESULT</i>';
          }
        }
        self.$store.commit('global/setAlertData', {
          show: true,
          message: msg
        });
      }, '');
    }
  },
  watch: {},
  mounted: function mounted() {
    this.env = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.Env;
  }
});

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'failed',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a },
  data: function data() {
    return {
      triggerOnLoad: false,
      start: '',
      end: '',
      validation: {
        start: '',
        end: ''
      },
      list: []
    };
  },

  computed: {},
  methods: {
    checkLoaded: function checkLoaded() {
      if (!this.triggerOnLoad) {
        this.triggerOnLoad = true;
        this.getFailedList();
      }
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('MM/DD/YYYY');
    },
    getFailedList: function getFailedList() {
      var self = this;

      var start = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.start, 'MM/DD/YYYY').set('hour', 0).set('minute', 0);
      var end = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.end, 'MM/DD/YYYY').set('hour', 23).set('minute', 59);
      self.validation.start = '';
      if (end.diff(start, 'days') < 0) {
        self.validation.start = 'Cannot be greater than end date.';
        return;
      }

      self.$store.commit('global/setLoaderData', { show: true });
      self.$sdk.get('/utils/listfailed', {
        start: start.format('YYYY-MM-DD'),
        end: end.format('YYYY-MM-DD')
      }, function (r) {
        self.$store.commit('global/setLoaderData', { show: false });
        self.list = r.list;
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
        }
      }, '');
    },
    stripLink: function stripLink(x) {
      var url = 'https://dashboard.stripe.com/customers/';
      if ({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.Env !== 'production') url = 'https://dashboard.stripe.com/test/customers/';
      return '' + url + x;
    }
  },
  mounted: function mounted() {
    this.start = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM/DD/YYYY');
    this.end = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM/DD/YYYY');
  }
});

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_brands__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rsvp',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a },
  data: function data() {
    return {
      triggerOnLoad: false,
      start: '',
      end: '',
      validation: {
        start: '',
        end: ''
      },
      list: [],
      stats: {
        auth: 0,
        canceled: 0,
        charged: 0,
        failed: 0,
        noshow: 0
      },
      summary: {
        all: 0,
        card: 0,
        notCanceled: 0
      }
    };
  },

  computed: {
    brands: function brands() {
      return this.$store.state.brands.list;
    }
  },
  methods: {
    checkLoaded: function checkLoaded() {
      if (!this.triggerOnLoad) {
        this.triggerOnLoad = true;
        this.getRsvpList();
      }
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('MM/DD/YYYY');
    },
    getRsvpList: function getRsvpList() {
      var self = this;

      var start = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.start, 'MM/DD/YYYY').set('hour', 0).set('minute', 0);
      var end = __WEBPACK_IMPORTED_MODULE_0_moment___default()(self.end, 'MM/DD/YYYY').set('hour', 23).set('minute', 59);
      self.validation.start = '';
      if (end.diff(start, 'days') < 0) {
        self.validation.start = 'Cannot be greater than end date.';
        return;
      }

      if (!self.brands.length) {
        self.getBrands();
        return;
      }

      self.$store.commit('global/setLoaderData', { show: true });
      self.$sdk.get('/utils/listrsvp', {
        start: start.format('YYYY-MM-DD'),
        end: end.format('YYYY-MM-DD')
      }, function (r) {
        self.$store.commit('global/setLoaderData', { show: false });
        self.list = [];
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          return;
        }
        if (r.brands) {
          for (var key in r.brands) {
            for (var key2 in r.brands[key]) {
              self.list.push({
                brand: self.getBrandName(key),
                service: r.brands[key][key2].name,
                count: r.brands[key][key2].count
              });
            }
          }
        }
        if (r.statuses) {
          self.stats = {
            auth: r.statuses.AUTH,
            canceled: r.statuses.CANCELED,
            charged: r.statuses.CHARGE,
            failed: r.statuses.FAILED,
            noshow: r.statuses.NOSHOW
          };
        }
        if (r.summary) {
          self.summary = {
            all: r.summary.all,
            card: r.summary.card,
            notCanceled: r.summary.notCanceled
          };
        }
      }, '');
    },
    getBrands: function getBrands() {
      var self = this;
      self.$store.commit('global/setLoaderData', { show: true });
      __WEBPACK_IMPORTED_MODULE_2__modules_api_brands__["a" /* default */].getBrands(self, function (r) {
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          self.$store.commit('global/setLoaderData', { show: false });
          return;
        }
        self.getRsvpList();
      });
    },
    getBrandName: function getBrandName(x) {
      var brand = this.brands.find(function (b) {
        return b.id == x;
      });
      return brand.name;
    }
  },
  mounted: function mounted() {
    this.start = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM/DD/YYYY');
    this.end = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM/DD/YYYY');
  }
});

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__ = __webpack_require__(2183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_api_services__ = __webpack_require__(6);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global CONFIG */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'asap',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default.a },
  data: function data() {
    return {
      triggerOnLoad: false,
      start: '',
      end: '',
      validation: {
        start: '',
        end: ''
      },
      list: [],
      showGroup: [],
      stats: {
        attempts: 0,
        cons: 0,
        rsvpId: 0,
        success: 0,
        canceled: 0,
        failedAttempts: 0
      },
      total: {
        amount: 0
      }
    };
  },

  computed: {
    services: function services() {
      return this.$store.state.services.list;
    }
  },
  methods: {
    checkLoaded: function checkLoaded() {
      if (!this.triggerOnLoad) {
        this.triggerOnLoad = true;
        this.getServices();
        // this.getASAPList()
      }
    },
    calendarFormat: function calendarFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).format('MM/DD/YYYY');
    },
    getServices: function getServices() {
      var self = this;
      if (self.services.length) {
        self.getASAPList();
        return;
      }

      self.$store.commit('global/setLoaderData', { show: true });
      __WEBPACK_IMPORTED_MODULE_6__modules_api_services__["a" /* default */].getAllService(self, function (r) {
        self.getASAPList();
      });
    },
    getASAPList: function getASAPList() {
      var self = this;

      var start = __WEBPACK_IMPORTED_MODULE_4_moment___default()(self.start, 'MM/DD/YYYY').set('hour', 0).set('minute', 0);
      var end = __WEBPACK_IMPORTED_MODULE_4_moment___default()(self.end, 'MM/DD/YYYY').set('hour', 23).set('minute', 59);
      self.validation.start = '';
      if (end.diff(start, 'days') < 0) {
        self.validation.start = 'Cannot be greater than end date.';
        return;
      }

      // Reset
      self.showGroup = [];
      self.stats = {
        attempts: 0,
        cons: 0,
        rsvpId: 0,
        success: 0,
        canceled: 0,
        failedAttempts: 0
      };
      self.total = {
        amount: 0
      };

      self.$store.commit('global/setLoaderData', { show: true });
      self.$sdk.get('/utils/listasap2', {
        start: start.format('YYYY-MM-DD'),
        end: end.format('YYYY-MM-DD')
      }, function (r) {
        self.$store.commit('global/setLoaderData', { show: false });
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
        }
        if (!r.list.length) {
          self.list = [];
          return;
        }

        var grouped = r.list.reduce(function (map, obj) {
          var key = obj.consId;
          if (!map.has(key)) map.set(key, []);
          map.get(key).push(obj);
          return map;
        }, new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a());

        var result = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(grouped.values()).flatMap(function (group) {
          return group.sort(function (a, b) {
            return b.custBid - a.custBid;
          }).map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, {
              isGroupMember: index > 0, // true for all except first item
              hasMultipleItems: group.length > 1
            });
          });
        });

        result.forEach(function (data) {
          if (data.isGroupMember) return;
          self.stats.cons += 1;
        });

        var tmpRsvp = [];
        r.list.forEach(function (x) {
          if (x.rsvpId) tmpRsvp.push(x.rsvpId);
          if (x.rsvpId && !x.canceled) {
            self.stats.success += 1;
            self.total.amount += parseFloat(x.amount.toFixed(2));
          } else if (x.canceled) self.stats.canceled += 1;else if (!x.canceled && x.lyftError) self.stats.failedAttempts += 1;else self.stats.failedAttempts += 1;
        });

        self.stats.attempts = r.list.length;
        self.stats.rsvpId = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(tmpRsvp).size;
        self.list = result; // USE THIS FOR GROUP CONSUMER
        // self.list = r.list // USE THIS TO UNGROUP CONSUMER
      }, '');
    },
    formatDate: function formatDate(x, convertToLA) {
      var format = 'MMM DD, YYYY hh:mmA';
      if (convertToLA) return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(x, 'YYYY-MM-DD@hh:mm:ss').tz('America/Los_Angeles').format(format);
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(x, 'YYYY-MM-DD@hh:mm:ss', 'America/Los_Angeles').format(format);
    },
    stripLink: function stripLink(x) {
      var url = 'https://dashboard.stripe.com/payments/';
      if ({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.Env !== 'production') url = 'https://dashboard.stripe.com/test/payments/';
      return '' + url + x;
    },
    toggleGroup: function toggleGroup(x) {
      if (this.showGroup.indexOf(x) == -1) this.showGroup.push(x);else this.showGroup.splice(this.showGroup.indexOf(x), 1);
    },
    deviceLabel: function deviceLabel(x) {
      if (!x) return '--';
      if (x === 'ww') return 'Web';
      return x;
    },
    brandLabel: function brandLabel(id) {
      var brand = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.find(function (x) {
        return x.id === id;
      });
      if (brand) return brand.name;
      return id;
    },
    serviceTypeLabel: function serviceTypeLabel(id) {
      var stagingLyft = [280, 281, 281, 281, 281];
      var prodLyft = [201, 208, 215, 218, 216, 207, 203, 212, 206, 210, 217, 209, 205, 213, 211, 202, 204, 214];
      var lyftIDs = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.Env === "production" ? prodLyft : stagingLyft;
      if (lyftIDs.indexOf(id) > -1) return 'Lyft';

      var service = this.services.find(function (x) {
        return x.id === id;
      });
      if (service) return service.label;

      return id;
    }
  },
  mounted: function mounted() {
    // this.start = moment().subtract(7, 'days').format('MM/DD/YYYY')
    this.start = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('MM/DD/YYYY');
    this.end = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('MM/DD/YYYY');
  }
});

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'failed',
  data: function data() {
    return {
      triggerOnLoad: false,
      holotnc: {},
      rsp: {},
      svAction: {
        list: false,
        listHolo: false,
        show: false,
        action: '',
        target: ''
      },
      raw: {
        rsp: {
          field: '',
          msg: ''
        },
        holotnc: {
          field: '',
          msg: ''
        }
      },
      db: {
        main: [],
        slave1: [],
        slave2: [],
        slave3: []
      }
    };
  },

  computed: {},
  methods: {
    checkLoaded: function checkLoaded() {
      if (!this.triggerOnLoad) {
        this.triggerOnLoad = true;
        this.getServiceList();
        this.getDBStatus();
      }
    },
    getServiceList: function getServiceList() {
      var self = this;

      self.$store.commit('global/setLoaderData', { show: true });
      self.holotnc = {};
      self.rsp = {};
      self.$sdk.get('utils/check', {}, function (r) {
        self.$store.commit('global/setLoaderData', { show: false });
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          return;
        }
        self.holotnc = r.holotnc;
        self.rsp = r.rsp;
        // self.checkHoloStatus()
      }, '');
    },
    checkHoloStatus: function checkHoloStatus() {
      var self = this;

      self.$sdk.get('utils/services', {}, function (r) {
        self.$store.commit('global/setLoaderData', { show: false });
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          return;
        }
        self.holotnc = r.holotnc;
        // self.rsp = r.rsp
      }, '');
    },
    statusCheck: function statusCheck(data, field) {
      if (field === 'error') return data.error ? 'red' : 'green';else {
        if (!data.db) return 'black';
        if (data.db[field]) return data.db[field].startsWith('8') ? 'green' : 'red';
        if (!data.db[field]) return 'black';
      }
    },
    toggleRaw: function toggleRaw(field, msg, type) {
      if (this.raw[type].field === field) {
        this.raw[type].field = '';
        this.raw[type].msg = '';
        return;
      }
      this.raw[type].field = field;
      this.raw[type].msg = msg;
    },
    getDBStatus: function getDBStatus() {
      var self = this;

      self.db = {
        main: [],
        slave1: [],
        slave2: [],
        slave3: []
      };
      self.$store.commit('global/setLoaderData', { show: true });
      self.$sdk.get('utils/dbstats', {}, function (r) {
        self.$store.commit('global/setLoaderData', { show: false });
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          });
          return;
        }

        self.db = {
          main: r.main || [],
          slave1: r.slave1 || [],
          slave2: r.slave2 || [],
          slave3: r.slave3 || []
        };
      }, '');
    },
    confirm: function confirm(x, type) {
      this.svAction.action = x;
      this.svAction.target = type;
      this.svAction.show = true;
      this.svAction.list = false;
      this.svAction.listHolo = false;
    },
    btnTrigger: function btnTrigger() {
      this.svAction.show = false;
      if (this.svAction.action === 'Flush Hosts') this.flushHost(this.svAction.target);
      if (this.svAction.action === 'Unstuck DB') this.unstuckDB(this.svAction.target);
    },
    flushHost: function flushHost(x) {
      var self = this;
      if (x === 'rsp') {
        self.$sdk.get('/utils/flushhosts', {}, function (r) {
          self.$store.commit('global/setLoaderData', { show: false });
          if (r.error) {
            self.$store.commit('global/setAlertData', {
              show: true,
              message: r.error.message
            });
            return;
          }
          self.$store.commit('global/setAlertData', {
            show: true,
            message: '<b>' + self.svAction.action + '</b> SUCCESS!'
          });
        }, '');
      }
      if (x === 'holotnc') {
        self.$store.commit('global/setLoaderData', { show: true });
        self.$sdk.get2('https://hl-tnc-api.ridesharepro.com/utils/flushhosts', {
          role: 'api',
          cmd: 'system.flush'
        }, function (r) {
          self.$store.commit('global/setLoaderData', { show: false });
          if (r.error) {
            self.$store.commit('global/setAlertData', {
              show: true,
              message: r.error.message
            });
            return;
          }
          self.$store.commit('global/setAlertData', {
            show: true,
            message: '<b>' + self.svAction.action + '</b> SUCCESS!'
          });
        });
      }
    },
    unstuckDB: function unstuckDB(x) {
      var self = this;
      if (x === 'rsp') {
        self.$sdk.get('/utils/unstuck', {}, function (r) {
          self.$store.commit('global/setLoaderData', { show: false });
          if (r.error) {
            self.$store.commit('global/setAlertData', {
              show: true,
              message: r.error.message
            });
            return;
          }
          self.$store.commit('global/setAlertData', {
            show: true,
            message: '<b>' + self.svAction.action + '</b> SUCCESS!'
          });
        }, '');
      }
      if (x === 'holotnc') {
        self.$store.commit('global/setLoaderData', { show: true });
        self.$sdk.get2('https://hl-tnc-api.ridesharepro.com/utils/unstuck', {}, function (r) {
          self.$store.commit('global/setLoaderData', { show: false });
          if (r.error) {
            self.$store.commit('global/setAlertData', {
              show: true,
              message: r.error.message
            });
            return;
          }
          self.$store.commit('global/setAlertData', {
            show: true,
            message: '<b>' + self.svAction.action + '</b> SUCCESS!'
          });
        });
      }
    }
  }
});

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_App__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_gateway_sdk__ = __webpack_require__(2195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_plugins__ = __webpack_require__(2202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_resource__ = __webpack_require__(2212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_drag_drop__ = __webpack_require__(2214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_drag_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_drag_drop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lang__ = __webpack_require__(2215);

/* global CONFIG */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


// import * as VueGoogleMaps from 'vue2-google-maps'











console.log('APP CONFIG', {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: CONFIG.googleApiKey,
//     libraries: 'places' // This is required if you use the Autocomplete plugin
//     // OR: libraries: 'places,drawing'
//     // OR: libraries: 'places,drawing,visualization'
//     // (as you require)
//   }
// })

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_drag_drop___default.a);

// Vue.use(OpoliGatewaySDK, CONFIG.Gateway)
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__modules_gateway_sdk__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.Gateway, { optimizationHost: {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.optimizationHost }));
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7__modules_plugins__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]);
var path = window.location.pathname;
var language = 'en';
if (path !== '/' && path.length > 3) {
  language = path.substring(1, 3);
}
var i18n = new __WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]({
  locale: language, // set locale
  messages: __WEBPACK_IMPORTED_MODULE_10__lang__["a" /* default */] // set locale messages
});

// Create the directive
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('click-outside', {
  bind: function bind(el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // Check if click was outside the element and its children
      if (!(el === event.target || el.contains(event.target))) {
        // Call the provided method
        vnode.context[binding.expression](event);
      }
    };
    document.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: function unbind(el) {
    document.removeEventListener('click', el.clickOutsideEvent);
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  i18n: i18n,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__components_App__["a" /* default */] }
});

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(698);
module.exports = __webpack_require__(12).Object.assign;


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(15);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(699) });


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(29);
var getKeys = __webpack_require__(64);
var gOPS = __webpack_require__(121);
var pIE = __webpack_require__(80);
var toObject = __webpack_require__(65);
var IObject = __webpack_require__(115);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(53)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(55);
var toLength = __webpack_require__(98);
var toAbsoluteIndex = __webpack_require__(701);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(117);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * vue-i18n v7.8.1 
 * (c) 2018 kazuya kawaguchi
 * Released under the MIT License.
 */
/*  */

/**
 * utilites
 */

function warn (msg, err) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-i18n] ' + msg);
    /* istanbul ignore if */
    if (err) {
      console.warn(err.stack);
    }
  }
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

var toString = Object.prototype.toString;
var OBJECT_STRING = '[object Object]';
function isPlainObject (obj) {
  return toString.call(obj) === OBJECT_STRING
}

function isNull (val) {
  return val === null || val === undefined
}

function parseArgs () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  var locale = null;
  var params = null;
  if (args.length === 1) {
    if (isObject(args[0]) || Array.isArray(args[0])) {
      params = args[0];
    } else if (typeof args[0] === 'string') {
      locale = args[0];
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
      locale = args[0];
    }
    /* istanbul ignore if */
    if (isObject(args[1]) || Array.isArray(args[1])) {
      params = args[1];
    }
  }

  return { locale: locale, params: params }
}

function getOldChoiceIndexFixed (choice) {
  return choice
    ? choice > 1
      ? 1
      : 0
    : 1
}

function getChoiceIndex (choice, choicesLength) {
  choice = Math.abs(choice);

  if (choicesLength === 2) { return getOldChoiceIndexFixed(choice) }

  return choice ? Math.min(choice, 2) : 0
}

function fetchChoice (message, choice) {
  /* istanbul ignore if */
  if (!message && typeof message !== 'string') { return null }
  var choices = message.split('|');

  choice = getChoiceIndex(choice, choices.length);
  if (!choices[choice]) { return message }
  return choices[choice].trim()
}

function looseClone (obj) {
  return JSON.parse(JSON.stringify(obj))
}

function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

function merge (target) {
  var arguments$1 = arguments;

  var output = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments$1[i];
    if (source !== undefined && source !== null) {
      var key = (void 0);
      for (key in source) {
        if (hasOwn(source, key)) {
          if (isObject(source[key])) {
            output[key] = merge(output[key], source[key]);
          } else {
            output[key] = source[key];
          }
        }
      }
    }
  }
  return output
}

function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

var canUseDateTimeFormat =
  typeof Intl !== 'undefined' && typeof Intl.DateTimeFormat !== 'undefined';

var canUseNumberFormat =
  typeof Intl !== 'undefined' && typeof Intl.NumberFormat !== 'undefined';

/*  */

function extend (Vue) {
  // $FlowFixMe
  Object.defineProperty(Vue.prototype, '$t', {
    get: function get () {
      var this$1 = this;

      return function (key) {
        var values = [], len = arguments.length - 1;
        while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

        var i18n = this$1.$i18n;
        return i18n._t.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this$1 ].concat( values ))
      }
    }
  });
  // $FlowFixMe
  Object.defineProperty(Vue.prototype, '$tc', {
    get: function get () {
      var this$1 = this;

      return function (key, choice) {
        var values = [], len = arguments.length - 2;
        while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];

        var i18n = this$1.$i18n;
        return i18n._tc.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this$1, choice ].concat( values ))
      }
    }
  });
  // $FlowFixMe
  Object.defineProperty(Vue.prototype, '$te', {
    get: function get () {
      var this$1 = this;

      return function (key, locale) {
        var i18n = this$1.$i18n;
        return i18n._te(key, i18n.locale, i18n._getMessages(), locale)
      }
    }
  });
  // $FlowFixMe
  Object.defineProperty(Vue.prototype, '$d', {
    get: function get () {
      var this$1 = this;

      return function (value) {
        var ref;

        var args = [], len = arguments.length - 1;
        while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
        return (ref = this$1.$i18n).d.apply(ref, [ value ].concat( args ))
      }
    }
  });
  // $FlowFixMe
  Object.defineProperty(Vue.prototype, '$n', {
    get: function get () {
      var this$1 = this;

      return function (value) {
        var ref;

        var args = [], len = arguments.length - 1;
        while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
        return (ref = this$1.$i18n).n.apply(ref, [ value ].concat( args ))
      }
    }
  });
}

/*  */

var mixin = {
  beforeCreate: function beforeCreate () {
    var options = this.$options;
    options.i18n = options.i18n || (options.__i18n ? {} : null);

    if (options.i18n) {
      if (options.i18n instanceof VueI18n) {
        // init locale messages via custom blocks
        if (options.__i18n) {
          try {
            var localeMessages = {};
            options.__i18n.forEach(function (resource) {
              localeMessages = merge(localeMessages, JSON.parse(resource));
            });
            Object.keys(localeMessages).forEach(function (locale) {
              options.i18n.mergeLocaleMessage(locale, localeMessages[locale]);
            });
          } catch (e) {
            if (false) {
              warn("Cannot parse locale messages via custom blocks.", e);
            }
          }
        }
        this._i18n = options.i18n;
        this._i18nWatcher = this._i18n.watchI18nData();
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      } else if (isPlainObject(options.i18n)) {
        // component local i18n
        if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
          options.i18n.root = this.$root.$i18n;
          options.i18n.formatter = this.$root.$i18n.formatter;
          options.i18n.fallbackLocale = this.$root.$i18n.fallbackLocale;
          options.i18n.silentTranslationWarn = this.$root.$i18n.silentTranslationWarn;
        }

        // init locale messages via custom blocks
        if (options.__i18n) {
          try {
            var localeMessages$1 = {};
            options.__i18n.forEach(function (resource) {
              localeMessages$1 = merge(localeMessages$1, JSON.parse(resource));
            });
            options.i18n.messages = localeMessages$1;
          } catch (e) {
            if (false) {
              warn("Cannot parse locale messages via custom blocks.", e);
            }
          }
        }

        this._i18n = new VueI18n(options.i18n);
        this._i18nWatcher = this._i18n.watchI18nData();
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;

        if (options.i18n.sync === undefined || !!options.i18n.sync) {
          this._localeWatcher = this.$i18n.watchLocale();
        }
      } else {
        if (false) {
          warn("Cannot be interpreted 'i18n' option.");
        }
      }
    } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
      // root i18n
      this._i18n = this.$root.$i18n;
      this._i18n.subscribeDataChanging(this);
      this._subscribing = true;
    } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
      // parent i18n
      this._i18n = options.parent.$i18n;
      this._i18n.subscribeDataChanging(this);
      this._subscribing = true;
    }
  },

  beforeDestroy: function beforeDestroy () {
    if (!this._i18n) { return }

    if (this._subscribing) {
      this._i18n.unsubscribeDataChanging(this);
      delete this._subscribing;
    }

    if (this._i18nWatcher) {
      this._i18nWatcher();
      delete this._i18nWatcher;
    }

    if (this._localeWatcher) {
      this._localeWatcher();
      delete this._localeWatcher;
    }

    this._i18n = null;
  }
}

/*  */

var component = {
  name: 'i18n',
  functional: true,
  props: {
    tag: {
      type: String,
      default: 'span'
    },
    path: {
      type: String,
      required: true
    },
    locale: {
      type: String
    },
    places: {
      type: [Array, Object]
    }
  },
  render: function render (h, ref) {
    var props = ref.props;
    var data = ref.data;
    var children = ref.children;
    var parent = ref.parent;

    var i18n = parent.$i18n;

    children = (children || []).filter(function (child) {
      return child.tag || (child.text = child.text.trim())
    });

    if (!i18n) {
      if (false) {
        warn('Cannot find VueI18n instance!');
      }
      return children
    }

    var path = props.path;
    var locale = props.locale;

    var params = {};
    var places = props.places || {};

    var hasPlaces = Array.isArray(places)
      ? places.length > 0
      : Object.keys(places).length > 0;

    var everyPlace = children.every(function (child) {
      if (child.data && child.data.attrs) {
        var place = child.data.attrs.place;
        return (typeof place !== 'undefined') && place !== ''
      }
    });

    if (hasPlaces && children.length > 0 && !everyPlace) {
      warn('If places prop is set, all child elements must have place prop set.');
    }

    if (Array.isArray(places)) {
      places.forEach(function (el, i) {
        params[i] = el;
      });
    } else {
      Object.keys(places).forEach(function (key) {
        params[key] = places[key];
      });
    }

    children.forEach(function (child, i) {
      var key = everyPlace
        ? ("" + (child.data.attrs.place))
        : ("" + i);
      params[key] = child;
    });

    return h(props.tag, data, i18n.i(path, locale, params))
  }
}

/*  */

function bind (el, binding, vnode) {
  if (!assert(el, vnode)) { return }

  t(el, binding, vnode);
}

function update (el, binding, vnode, oldVNode) {
  if (!assert(el, vnode)) { return }

  if (localeEqual(el, vnode) && looseEqual(binding.value, binding.oldValue)) { return }

  t(el, binding, vnode);
}

function unbind (el, binding, vnode, oldVNode) {
  if (!assert(el, vnode)) { return }

  el.textContent = '';
  el._vt = undefined;
  delete el['_vt'];
  el._locale = undefined;
  delete el['_locale'];
}

function assert (el, vnode) {
  var vm = vnode.context;
  if (!vm) {
    warn('not exist Vue instance in VNode context');
    return false
  }

  if (!vm.$i18n) {
    warn('not exist VueI18n instance in Vue instance');
    return false
  }

  return true
}

function localeEqual (el, vnode) {
  var vm = vnode.context;
  return el._locale === vm.$i18n.locale
}

function t (el, binding, vnode) {
  var ref$1, ref$2;

  var value = binding.value;

  var ref = parseValue(value);
  var path = ref.path;
  var locale = ref.locale;
  var args = ref.args;
  var choice = ref.choice;
  if (!path && !locale && !args) {
    warn('not support value type');
    return
  }

  if (!path) {
    warn('required `path` in v-t directive');
    return
  }

  var vm = vnode.context;
  if (choice) {
    el._vt = el.textContent = (ref$1 = vm.$i18n).tc.apply(ref$1, [ path, choice ].concat( makeParams(locale, args) ));
  } else {
    el._vt = el.textContent = (ref$2 = vm.$i18n).t.apply(ref$2, [ path ].concat( makeParams(locale, args) ));
  }
  el._locale = vm.$i18n.locale;
}

function parseValue (value) {
  var path;
  var locale;
  var args;
  var choice;

  if (typeof value === 'string') {
    path = value;
  } else if (isPlainObject(value)) {
    path = value.path;
    locale = value.locale;
    args = value.args;
    choice = value.choice;
  }

  return { path: path, locale: locale, args: args, choice: choice }
}

function makeParams (locale, args) {
  var params = [];

  locale && params.push(locale);
  if (args && (Array.isArray(args) || isPlainObject(args))) {
    params.push(args);
  }

  return params
}

var Vue;

function install (_Vue) {
  Vue = _Vue;

  var version = (Vue.version && Number(Vue.version.split('.')[0])) || -1;
  /* istanbul ignore if */
  if (false) {
    warn('already installed.');
    return
  }
  install.installed = true;

  /* istanbul ignore if */
  if (false) {
    warn(("vue-i18n (" + (install.version) + ") need to use Vue 2.0 or later (Vue: " + (Vue.version) + ")."));
    return
  }

  Object.defineProperty(Vue.prototype, '$i18n', {
    get: function get () { return this._i18n }
  });

  extend(Vue);
  Vue.mixin(mixin);
  Vue.directive('t', { bind: bind, update: update, unbind: unbind });
  Vue.component(component.name, component);

  // use object-based merge strategy
  var strats = Vue.config.optionMergeStrategies;
  strats.i18n = strats.methods;
}

/*  */

var BaseFormatter = function BaseFormatter () {
  this._caches = Object.create(null);
};

BaseFormatter.prototype.interpolate = function interpolate (message, values) {
  if (!values) {
    return [message]
  }
  var tokens = this._caches[message];
  if (!tokens) {
    tokens = parse(message);
    this._caches[message] = tokens;
  }
  return compile(tokens, values)
};



var RE_TOKEN_LIST_VALUE = /^(\d)+/;
var RE_TOKEN_NAMED_VALUE = /^(\w)+/;

function parse (format) {
  var tokens = [];
  var position = 0;

  var text = '';
  while (position < format.length) {
    var char = format[position++];
    if (char === '{') {
      if (text) {
        tokens.push({ type: 'text', value: text });
      }

      text = '';
      var sub = '';
      char = format[position++];
      while (char !== '}') {
        sub += char;
        char = format[position++];
      }

      var type = RE_TOKEN_LIST_VALUE.test(sub)
        ? 'list'
        : RE_TOKEN_NAMED_VALUE.test(sub)
          ? 'named'
          : 'unknown';
      tokens.push({ value: sub, type: type });
    } else if (char === '%') {
      // when found rails i18n syntax, skip text capture
      if (format[(position)] !== '{') {
        text += char;
      }
    } else {
      text += char;
    }
  }

  text && tokens.push({ type: 'text', value: text });

  return tokens
}

function compile (tokens, values) {
  var compiled = [];
  var index = 0;

  var mode = Array.isArray(values)
    ? 'list'
    : isObject(values)
      ? 'named'
      : 'unknown';
  if (mode === 'unknown') { return compiled }

  while (index < tokens.length) {
    var token = tokens[index];
    switch (token.type) {
      case 'text':
        compiled.push(token.value);
        break
      case 'list':
        compiled.push(values[parseInt(token.value, 10)]);
        break
      case 'named':
        if (mode === 'named') {
          compiled.push((values)[token.value]);
        } else {
          if (false) {
            warn(("Type of token '" + (token.type) + "' and format of value '" + mode + "' don't match!"));
          }
        }
        break
      case 'unknown':
        if (false) {
          warn("Detect 'unknown' type of token!");
        }
        break
    }
    index++;
  }

  return compiled
}

/*  */

/**
 *  Path paerser
 *  - Inspired:
 *    Vue.js Path parser
 */

// actions
var APPEND = 0;
var PUSH = 1;
var INC_SUB_PATH_DEPTH = 2;
var PUSH_SUB_PATH = 3;

// states
var BEFORE_PATH = 0;
var IN_PATH = 1;
var BEFORE_IDENT = 2;
var IN_IDENT = 3;
var IN_SUB_PATH = 4;
var IN_SINGLE_QUOTE = 5;
var IN_DOUBLE_QUOTE = 6;
var AFTER_PATH = 7;
var ERROR = 8;

var pathStateMachine = [];

pathStateMachine[BEFORE_PATH] = {
  'ws': [BEFORE_PATH],
  'ident': [IN_IDENT, APPEND],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[IN_PATH] = {
  'ws': [IN_PATH],
  '.': [BEFORE_IDENT],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[BEFORE_IDENT] = {
  'ws': [BEFORE_IDENT],
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND]
};

pathStateMachine[IN_IDENT] = {
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND],
  'ws': [IN_PATH, PUSH],
  '.': [BEFORE_IDENT, PUSH],
  '[': [IN_SUB_PATH, PUSH],
  'eof': [AFTER_PATH, PUSH]
};

pathStateMachine[IN_SUB_PATH] = {
  "'": [IN_SINGLE_QUOTE, APPEND],
  '"': [IN_DOUBLE_QUOTE, APPEND],
  '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
  ']': [IN_PATH, PUSH_SUB_PATH],
  'eof': ERROR,
  'else': [IN_SUB_PATH, APPEND]
};

pathStateMachine[IN_SINGLE_QUOTE] = {
  "'": [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_SINGLE_QUOTE, APPEND]
};

pathStateMachine[IN_DOUBLE_QUOTE] = {
  '"': [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_DOUBLE_QUOTE, APPEND]
};

/**
 * Check if an expression is a literal value.
 */

var literalValueRE = /^\s?(true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral (exp) {
  return literalValueRE.test(exp)
}

/**
 * Strip quotes from a string
 */

function stripQuotes (str) {
  var a = str.charCodeAt(0);
  var b = str.charCodeAt(str.length - 1);
  return a === b && (a === 0x22 || a === 0x27)
    ? str.slice(1, -1)
    : str
}

/**
 * Determine the type of a character in a keypath.
 */

function getPathCharType (ch) {
  if (ch === undefined || ch === null) { return 'eof' }

  var code = ch.charCodeAt(0);

  switch (code) {
    case 0x5B: // [
    case 0x5D: // ]
    case 0x2E: // .
    case 0x22: // "
    case 0x27: // '
    case 0x30: // 0
      return ch

    case 0x5F: // _
    case 0x24: // $
    case 0x2D: // -
      return 'ident'

    case 0x20: // Space
    case 0x09: // Tab
    case 0x0A: // Newline
    case 0x0D: // Return
    case 0xA0:  // No-break space
    case 0xFEFF:  // Byte Order Mark
    case 0x2028:  // Line Separator
    case 0x2029:  // Paragraph Separator
      return 'ws'
  }

  // a-z, A-Z
  if ((code >= 0x61 && code <= 0x7A) || (code >= 0x41 && code <= 0x5A)) {
    return 'ident'
  }

  // 1-9
  if (code >= 0x31 && code <= 0x39) { return 'number' }

  return 'else'
}

/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */

function formatSubPath (path) {
  var trimmed = path.trim();
  // invalid leading 0
  if (path.charAt(0) === '0' && isNaN(path)) { return false }

  return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed
}

/**
 * Parse a string path into an array of segments
 */

function parse$1 (path) {
  var keys = [];
  var index = -1;
  var mode = BEFORE_PATH;
  var subPathDepth = 0;
  var c;
  var key;
  var newChar;
  var type;
  var transition;
  var action;
  var typeMap;
  var actions = [];

  actions[PUSH] = function () {
    if (key !== undefined) {
      keys.push(key);
      key = undefined;
    }
  };

  actions[APPEND] = function () {
    if (key === undefined) {
      key = newChar;
    } else {
      key += newChar;
    }
  };

  actions[INC_SUB_PATH_DEPTH] = function () {
    actions[APPEND]();
    subPathDepth++;
  };

  actions[PUSH_SUB_PATH] = function () {
    if (subPathDepth > 0) {
      subPathDepth--;
      mode = IN_SUB_PATH;
      actions[APPEND]();
    } else {
      subPathDepth = 0;
      key = formatSubPath(key);
      if (key === false) {
        return false
      } else {
        actions[PUSH]();
      }
    }
  };

  function maybeUnescapeQuote () {
    var nextChar = path[index + 1];
    if ((mode === IN_SINGLE_QUOTE && nextChar === "'") ||
      (mode === IN_DOUBLE_QUOTE && nextChar === '"')) {
      index++;
      newChar = '\\' + nextChar;
      actions[APPEND]();
      return true
    }
  }

  while (mode !== null) {
    index++;
    c = path[index];

    if (c === '\\' && maybeUnescapeQuote()) {
      continue
    }

    type = getPathCharType(c);
    typeMap = pathStateMachine[mode];
    transition = typeMap[type] || typeMap['else'] || ERROR;

    if (transition === ERROR) {
      return // parse error
    }

    mode = transition[0];
    action = actions[transition[1]];
    if (action) {
      newChar = transition[2];
      newChar = newChar === undefined
        ? c
        : newChar;
      if (action() === false) {
        return
      }
    }

    if (mode === AFTER_PATH) {
      return keys
    }
  }
}





function empty (target) {
  /* istanbul ignore else */
  if (Array.isArray(target)) {
    return target.length === 0
  } else {
    return false
  }
}

var I18nPath = function I18nPath () {
  this._cache = Object.create(null);
};

/**
 * External parse that check for a cache hit first
 */
I18nPath.prototype.parsePath = function parsePath (path) {
  var hit = this._cache[path];
  if (!hit) {
    hit = parse$1(path);
    if (hit) {
      this._cache[path] = hit;
    }
  }
  return hit || []
};

/**
 * Get path value from path string
 */
I18nPath.prototype.getPathValue = function getPathValue (obj, path) {
  if (!isObject(obj)) { return null }

  var paths = this.parsePath(path);
  if (empty(paths)) {
    return null
  } else {
    var length = paths.length;
    var ret = null;
    var last = obj;
    var i = 0;
    while (i < length) {
      var value = last[paths[i]];
      if (value === undefined) {
        last = null;
        break
      }
      last = value;
      i++;
    }

    ret = last;
    return ret
  }
};

/*  */



var numberFormatKeys = [
  'style',
  'currency',
  'currencyDisplay',
  'useGrouping',
  'minimumIntegerDigits',
  'minimumFractionDigits',
  'maximumFractionDigits',
  'minimumSignificantDigits',
  'maximumSignificantDigits',
  'localeMatcher',
  'formatMatcher'
];

var VueI18n = function VueI18n (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #290
  /* istanbul ignore if */
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  var locale = options.locale || 'en-US';
  var fallbackLocale = options.fallbackLocale || 'en-US';
  var messages = options.messages || {};
  var dateTimeFormats = options.dateTimeFormats || {};
  var numberFormats = options.numberFormats || {};

  this._vm = null;
  this._formatter = options.formatter || new BaseFormatter();
  this._missing = options.missing || null;
  this._root = options.root || null;
  this._sync = options.sync === undefined ? true : !!options.sync;
  this._fallbackRoot = options.fallbackRoot === undefined
    ? true
    : !!options.fallbackRoot;
  this._silentTranslationWarn = options.silentTranslationWarn === undefined
    ? false
    : !!options.silentTranslationWarn;
  this._dateTimeFormatters = {};
  this._numberFormatters = {};
  this._path = new I18nPath();
  this._dataListeners = [];

  this._exist = function (message, key) {
    if (!message || !key) { return false }
    return !isNull(this$1._path.getPathValue(message, key))
  };

  this._initVM({
    locale: locale,
    fallbackLocale: fallbackLocale,
    messages: messages,
    dateTimeFormats: dateTimeFormats,
    numberFormats: numberFormats
  });
};

var prototypeAccessors = { vm: { configurable: true },messages: { configurable: true },dateTimeFormats: { configurable: true },numberFormats: { configurable: true },locale: { configurable: true },fallbackLocale: { configurable: true },missing: { configurable: true },formatter: { configurable: true },silentTranslationWarn: { configurable: true } };

VueI18n.prototype._initVM = function _initVM (data) {
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  this._vm = new Vue({ data: data });
  Vue.config.silent = silent;
};

VueI18n.prototype.subscribeDataChanging = function subscribeDataChanging (vm) {
  this._dataListeners.push(vm);
};

VueI18n.prototype.unsubscribeDataChanging = function unsubscribeDataChanging (vm) {
  remove(this._dataListeners, vm);
};

VueI18n.prototype.watchI18nData = function watchI18nData () {
  var self = this;
  return this._vm.$watch('$data', function () {
    var i = self._dataListeners.length;
    while (i--) {
      Vue.nextTick(function () {
        self._dataListeners[i] && self._dataListeners[i].$forceUpdate();
      });
    }
  }, { deep: true })
};

VueI18n.prototype.watchLocale = function watchLocale () {
  /* istanbul ignore if */
  if (!this._sync || !this._root) { return null }
  var target = this._vm;
  return this._root.vm.$watch('locale', function (val) {
    target.$set(target, 'locale', val);
    target.$forceUpdate();
  }, { immediate: true })
};

prototypeAccessors.vm.get = function () { return this._vm };

prototypeAccessors.messages.get = function () { return looseClone(this._getMessages()) };
prototypeAccessors.dateTimeFormats.get = function () { return looseClone(this._getDateTimeFormats()) };
prototypeAccessors.numberFormats.get = function () { return looseClone(this._getNumberFormats()) };

prototypeAccessors.locale.get = function () { return this._vm.locale };
prototypeAccessors.locale.set = function (locale) {
  this._vm.$set(this._vm, 'locale', locale);
};

prototypeAccessors.fallbackLocale.get = function () { return this._vm.fallbackLocale };
prototypeAccessors.fallbackLocale.set = function (locale) {
  this._vm.$set(this._vm, 'fallbackLocale', locale);
};

prototypeAccessors.missing.get = function () { return this._missing };
prototypeAccessors.missing.set = function (handler) { this._missing = handler; };

prototypeAccessors.formatter.get = function () { return this._formatter };
prototypeAccessors.formatter.set = function (formatter) { this._formatter = formatter; };

prototypeAccessors.silentTranslationWarn.get = function () { return this._silentTranslationWarn };
prototypeAccessors.silentTranslationWarn.set = function (silent) { this._silentTranslationWarn = silent; };

VueI18n.prototype._getMessages = function _getMessages () { return this._vm.messages };
VueI18n.prototype._getDateTimeFormats = function _getDateTimeFormats () { return this._vm.dateTimeFormats };
VueI18n.prototype._getNumberFormats = function _getNumberFormats () { return this._vm.numberFormats };

VueI18n.prototype._warnDefault = function _warnDefault (locale, key, result, vm, values) {
  if (!isNull(result)) { return result }
  if (this._missing) {
    var missingRet = this._missing.apply(null, [locale, key, vm, values]);
    if (typeof missingRet === 'string') {
      return missingRet
    }
  } else {
    if (false) {
      warn(
        "Cannot translate the value of keypath '" + key + "'. " +
        'Use the value of keypath as default.'
      );
    }
  }
  return key
};

VueI18n.prototype._isFallbackRoot = function _isFallbackRoot (val) {
  return !val && !isNull(this._root) && this._fallbackRoot
};

VueI18n.prototype._interpolate = function _interpolate (
  locale,
  message,
  key,
  host,
  interpolateMode,
  values
) {
  if (!message) { return null }

  var pathRet = this._path.getPathValue(message, key);
  if (Array.isArray(pathRet) || isPlainObject(pathRet)) { return pathRet }

  var ret;
  if (isNull(pathRet)) {
    /* istanbul ignore else */
    if (isPlainObject(message)) {
      ret = message[key];
      if (typeof ret !== 'string') {
        if (false) {
          warn(("Value of key '" + key + "' is not a string!"));
        }
        return null
      }
    } else {
      return null
    }
  } else {
    /* istanbul ignore else */
    if (typeof pathRet === 'string') {
      ret = pathRet;
    } else {
      if (false) {
        warn(("Value of key '" + key + "' is not a string!"));
      }
      return null
    }
  }

  // Check for the existance of links within the translated string
  if (ret.indexOf('@:') >= 0) {
    ret = this._link(locale, message, ret, host, interpolateMode, values);
  }

  return this._render(ret, interpolateMode, values)
};

VueI18n.prototype._link = function _link (
  locale,
  message,
  str,
  host,
  interpolateMode,
  values
) {
    var this$1 = this;

  var ret = str;

  // Match all the links within the local
  // We are going to replace each of
  // them with its translation
  var matches = ret.match(/(@:[\w\-_|.]+)/g);
  for (var idx in matches) {
    // ie compatible: filter custom array
    // prototype method
    if (!matches.hasOwnProperty(idx)) {
      continue
    }
    var link = matches[idx];
    // Remove the leading @:
    var linkPlaceholder = link.substr(2);
    // Translate the link
    var translated = this$1._interpolate(
      locale, message, linkPlaceholder, host,
      interpolateMode === 'raw' ? 'string' : interpolateMode,
      interpolateMode === 'raw' ? undefined : values
    );

    if (this$1._isFallbackRoot(translated)) {
      if (false) {
        warn(("Fall back to translate the link placeholder '" + linkPlaceholder + "' with root locale."));
      }
      /* istanbul ignore if */
      if (!this$1._root) { throw Error('unexpected error') }
      var root = this$1._root;
      translated = root._translate(
        root._getMessages(), root.locale, root.fallbackLocale,
        linkPlaceholder, host, interpolateMode, values
      );
    }
    translated = this$1._warnDefault(
      locale, linkPlaceholder, translated, host,
      Array.isArray(values) ? values : [values]
    );

    // Replace the link with the translated
    ret = !translated ? ret : ret.replace(link, translated);
  }

  return ret
};

VueI18n.prototype._render = function _render (message, interpolateMode, values) {
  var ret = this._formatter.interpolate(message, values);
  // if interpolateMode is **not** 'string' ('row'),
  // return the compiled data (e.g. ['foo', VNode, 'bar']) with formatter
  return interpolateMode === 'string' ? ret.join('') : ret
};

VueI18n.prototype._translate = function _translate (
  messages,
  locale,
  fallback,
  key,
  host,
  interpolateMode,
  args
) {
  var res =
    this._interpolate(locale, messages[locale], key, host, interpolateMode, args);
  if (!isNull(res)) { return res }

  res = this._interpolate(fallback, messages[fallback], key, host, interpolateMode, args);
  if (!isNull(res)) {
    if (false) {
      warn(("Fall back to translate the keypath '" + key + "' with '" + fallback + "' locale."));
    }
    return res
  } else {
    return null
  }
};

VueI18n.prototype._t = function _t (key, _locale, messages, host) {
    var ref;

    var values = [], len = arguments.length - 4;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 4 ];
  if (!key) { return '' }

  var parsedArgs = parseArgs.apply(void 0, values);
  var locale = parsedArgs.locale || _locale;

  var ret = this._translate(
    messages, locale, this.fallbackLocale, key,
    host, 'string', parsedArgs.params
  );
  if (this._isFallbackRoot(ret)) {
    if (false) {
      warn(("Fall back to translate the keypath '" + key + "' with root locale."));
    }
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return (ref = this._root).t.apply(ref, [ key ].concat( values ))
  } else {
    return this._warnDefault(locale, key, ret, host, values)
  }
};

VueI18n.prototype.t = function t (key) {
    var ref;

    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];
  return (ref = this)._t.apply(ref, [ key, this.locale, this._getMessages(), null ].concat( values ))
};

VueI18n.prototype._i = function _i (key, locale, messages, host, values) {
  var ret =
    this._translate(messages, locale, this.fallbackLocale, key, host, 'raw', values);
  if (this._isFallbackRoot(ret)) {
    if (false) {
      warn(("Fall back to interpolate the keypath '" + key + "' with root locale."));
    }
    if (!this._root) { throw Error('unexpected error') }
    return this._root.i(key, locale, values)
  } else {
    return this._warnDefault(locale, key, ret, host, [values])
  }
};

VueI18n.prototype.i = function i (key, locale, values) {
  /* istanbul ignore if */
  if (!key) { return '' }

  if (typeof locale !== 'string') {
    locale = this.locale;
  }

  return this._i(key, locale, this._getMessages(), null, values)
};

VueI18n.prototype._tc = function _tc (
  key,
  _locale,
  messages,
  host,
  choice
) {
    var ref;

    var values = [], len = arguments.length - 5;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 5 ];
  if (!key) { return '' }
  if (choice === undefined) {
    choice = 1;
  }
  return fetchChoice((ref = this)._t.apply(ref, [ key, _locale, messages, host ].concat( values )), choice)
};

VueI18n.prototype.tc = function tc (key, choice) {
    var ref;

    var values = [], len = arguments.length - 2;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];
  return (ref = this)._tc.apply(ref, [ key, this.locale, this._getMessages(), null, choice ].concat( values ))
};

VueI18n.prototype._te = function _te (key, locale, messages) {
    var args = [], len = arguments.length - 3;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 3 ];

  var _locale = parseArgs.apply(void 0, args).locale || locale;
  return this._exist(messages[_locale], key)
};

VueI18n.prototype.te = function te (key, locale) {
  return this._te(key, this.locale, this._getMessages(), locale)
};

VueI18n.prototype.getLocaleMessage = function getLocaleMessage (locale) {
  return looseClone(this._vm.messages[locale] || {})
};

VueI18n.prototype.setLocaleMessage = function setLocaleMessage (locale, message) {
  this._vm.$set(this._vm.messages, locale, message);
};

VueI18n.prototype.mergeLocaleMessage = function mergeLocaleMessage (locale, message) {
  this._vm.$set(this._vm.messages, locale, Vue.util.extend(this._vm.messages[locale] || {}, message));
};

VueI18n.prototype.getDateTimeFormat = function getDateTimeFormat (locale) {
  return looseClone(this._vm.dateTimeFormats[locale] || {})
};

VueI18n.prototype.setDateTimeFormat = function setDateTimeFormat (locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, format);
};

VueI18n.prototype.mergeDateTimeFormat = function mergeDateTimeFormat (locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, Vue.util.extend(this._vm.dateTimeFormats[locale] || {}, format));
};

VueI18n.prototype._localizeDateTime = function _localizeDateTime (
  value,
  locale,
  fallback,
  dateTimeFormats,
  key
) {
  var _locale = locale;
  var formats = dateTimeFormats[_locale];

  // fallback locale
  if (isNull(formats) || isNull(formats[key])) {
    if (false) {
      warn(("Fall back to '" + fallback + "' datetime formats from '" + locale + " datetime formats."));
    }
    _locale = fallback;
    formats = dateTimeFormats[_locale];
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];
    var id = _locale + "__" + key;
    var formatter = this._dateTimeFormatters[id];
    if (!formatter) {
      formatter = this._dateTimeFormatters[id] = new Intl.DateTimeFormat(_locale, format);
    }
    return formatter.format(value)
  }
};

VueI18n.prototype._d = function _d (value, locale, key) {
  /* istanbul ignore if */
  if (false) {
    warn('Cannot format a Date value due to not supported Intl.DateTimeFormat.');
    return ''
  }

  if (!key) {
    return new Intl.DateTimeFormat(locale).format(value)
  }

  var ret =
    this._localizeDateTime(value, locale, this.fallbackLocale, this._getDateTimeFormats(), key);
  if (this._isFallbackRoot(ret)) {
    if (false) {
      warn(("Fall back to datetime localization of root: key '" + key + "' ."));
    }
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.d(value, key, locale)
  } else {
    return ret || ''
  }
};

VueI18n.prototype.d = function d (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;

  if (args.length === 1) {
    if (typeof args[0] === 'string') {
      key = args[0];
    } else if (isObject(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
      key = args[0];
    }
    if (typeof args[1] === 'string') {
      locale = args[1];
    }
  }

  return this._d(value, locale, key)
};

VueI18n.prototype.getNumberFormat = function getNumberFormat (locale) {
  return looseClone(this._vm.numberFormats[locale] || {})
};

VueI18n.prototype.setNumberFormat = function setNumberFormat (locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, format);
};

VueI18n.prototype.mergeNumberFormat = function mergeNumberFormat (locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, Vue.util.extend(this._vm.numberFormats[locale] || {}, format));
};

VueI18n.prototype._localizeNumber = function _localizeNumber (
  value,
  locale,
  fallback,
  numberFormats,
  key,
  options
) {
  var _locale = locale;
  var formats = numberFormats[_locale];

  // fallback locale
  if (isNull(formats) || isNull(formats[key])) {
    if (false) {
      warn(("Fall back to '" + fallback + "' number formats from '" + locale + " number formats."));
    }
    _locale = fallback;
    formats = numberFormats[_locale];
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];

    var formatter;
    if (options) {
      // If options specified - create one time number formatter
      formatter = new Intl.NumberFormat(_locale, Object.assign({}, format, options));
    } else {
      var id = _locale + "__" + key;
      formatter = this._numberFormatters[id];
      if (!formatter) {
        formatter = this._numberFormatters[id] = new Intl.NumberFormat(_locale, format);
      }
    }
    return formatter.format(value)
  }
};

VueI18n.prototype._n = function _n (value, locale, key, options) {
  /* istanbul ignore if */
  if (false) {
    warn('Cannot format a Number value due to not supported Intl.NumberFormat.');
    return ''
  }

  if (!key) {
    var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
    return nf.format(value)
  }

  var ret =
    this._localizeNumber(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
  if (this._isFallbackRoot(ret)) {
    if (false) {
      warn(("Fall back to number localization of root: key '" + key + "' ."));
    }
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.n(value, Object.assign({}, { key: key, locale: locale }, options))
  } else {
    return ret || ''
  }
};

VueI18n.prototype.n = function n (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;
  var options = null;

  if (args.length === 1) {
    if (typeof args[0] === 'string') {
      key = args[0];
    } else if (isObject(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }

      // Filter out number format options only
      options = Object.keys(args[0]).reduce(function (acc, key) {
          var obj;

        if (numberFormatKeys.includes(key)) {
          return Object.assign({}, acc, ( obj = {}, obj[key] = args[0][key], obj ))
        }
        return acc
      }, null);
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
      key = args[0];
    }
    if (typeof args[1] === 'string') {
      locale = args[1];
    }
  }

  return this._n(value, locale, key, options)
};

Object.defineProperties( VueI18n.prototype, prototypeAccessors );

VueI18n.availabilities = {
  dateTimeFormat: canUseDateTimeFormat,
  numberFormat: canUseNumberFormat
};
VueI18n.install = install;
VueI18n.version = '7.8.1';

/* harmony default export */ __webpack_exports__["a"] = (VueI18n);


/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(168);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a06042b8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(864);
function injectStyle (ssrContext) {
  __webpack_require__(704)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a06042b8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(705);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("33e4459a", content, true, {});

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\nbody {\n  background-color: #F4F8F9;\n  font-family: 'Open Sans', sans-serif;\n}\na,\na:visited,\na:active {\n  color: #0D79F2;\n}\ntextarea,\ninput {\n  display: block;\n  outline: none;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 10px;\n  border: 0;\n  width: 100%;\n  border-radius: 3px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  margin-top: 15px;\n  line-height: inherit;\n}\ntextarea::-webkit-input-placeholder,\n  input::-webkit-input-placeholder {\n    color: rgba(0, 0, 0, 0.25);\n}\ntextarea::-moz-placeholder,\n  input::-moz-placeholder {\n    color: rgba(0, 0, 0, 0.25);\n}\ntextarea::-ms-input-placeholder,\n  input::-ms-input-placeholder {\n    color: rgba(0, 0, 0, 0.25);\n}\ntextarea::placeholder,\n  input::placeholder {\n    color: rgba(0, 0, 0, 0.25);\n}\ntextarea:focus,\n  input:focus {\n    border-color: rgba(0, 0, 0, 0.25);\n}\n.card {\n  background-color: #fff;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n  border-top: 1px solid rgba(0, 0, 0, 0.15);\n}\n.button, button {\n  display: inline-block;\n  outline: 0;\n  border: 0;\n  margin-top: 0;\n  text-decoration: none;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border-radius: 5px;\n  -webkit-transition: all 200ms;\n  transition: all 200ms;\n  position: relative;\n  text-align: center;\n  cursor: pointer;\n  color: #fff !important;\n  background-color: #0D79F2;\n  line-height: 16px;\n  font-size: 16px;\n  padding: 12px 17px 13px;\n}\n.button.disabled, button.disabled {\n    pointer-events: none;\n    cursor: not-allowed;\n    opacity: 0.7;\n}\n.button:hover, button:hover {\n    background-color: #0b66cb;\n}\n.button:active, button:active {\n    color: #fff;\n    background-color: #0a5cb8;\n}\n.button.cta, button.cta {\n    border-bottom-color: #084991;\n}\n.button.cta:hover, button.cta:hover {\n      background-color: #2586f3;\n}\n.button.cta:active, button.cta:active {\n      background-color: #0D79F2;\n}\n.button.xlarge, button.xlarge {\n    line-height: 20px;\n    font-size: 20px;\n    padding: 16px 21px 17px;\n}\n.button.large, button.large {\n    line-height: 18px;\n    font-size: 18px;\n    padding: 14px 19px 15px;\n}\n.button.small, button.small {\n    line-height: 14px;\n    font-size: 14px;\n    padding: 10px 15px 11px;\n}\n.button.xsmall, button.xsmall {\n    line-height: 12px;\n    font-size: 12px;\n    padding: 8px 13px 9px;\n}\n.button.success, button.success {\n    color: #fff !important;\n    background-color: #26D97A;\n}\n.button.success:hover, button.success:hover {\n      background-color: #20b666;\n}\n.button.success:active, button.success:active {\n      color: #fff;\n      background-color: #1da55d;\n}\n.button.success.cta, button.success.cta {\n      border-bottom-color: #178249;\n}\n.button.success.cta:hover, button.success.cta:hover {\n        background-color: #3cdd87;\n}\n.button.success.cta:active, button.success.cta:active {\n        background-color: #26D97A;\n}\n.button.error, button.error {\n    color: #fff !important;\n    background-color: #F20D0D;\n}\n.button.error:hover, button.error:hover {\n      background-color: #cb0b0b;\n}\n.button.error:active, button.error:active {\n      color: #fff;\n      background-color: #b80a0a;\n}\n.button.error.cta, button.error.cta {\n      border-bottom-color: #910808;\n}\n.button.error.cta:hover, button.error.cta:hover {\n        background-color: #f32525;\n}\n.button.error.cta:active, button.error.cta:active {\n        background-color: #F20D0D;\n}\n.button.warning, button.warning {\n    color: #fff !important;\n    background-color: #F25E0D;\n}\n.button.warning:hover, button.warning:hover {\n      background-color: #cb4f0b;\n}\n.button.warning:active, button.warning:active {\n      color: #fff;\n      background-color: #b8470a;\n}\n.button.warning.cta, button.warning.cta {\n      border-bottom-color: #913808;\n}\n.button.warning.cta:hover, button.warning.cta:hover {\n        background-color: #f36e25;\n}\n.button.warning.cta:active, button.warning.cta:active {\n        background-color: #F25E0D;\n}\n.button.secondary, button.secondary {\n    color: #fff !important;\n    background-color: #CCCCCC;\n    color: #666 !important;\n}\n.button.secondary:hover, button.secondary:hover {\n      background-color: #b8b8b8;\n}\n.button.secondary:active, button.secondary:active {\n      color: #fff;\n      background-color: #adadad;\n}\n.button.secondary.cta, button.secondary.cta {\n      border-bottom-color: #999999;\n}\n.button.secondary.cta:hover, button.secondary.cta:hover {\n        background-color: #d9d9d9;\n}\n.button.secondary.cta:active, button.secondary.cta:active {\n        background-color: #CCCCCC;\n}\n.button.lyft, button.lyft {\n    color: #fff !important;\n    background-color: #eb21b8;\n}\n.button.lyft:hover, button.lyft:hover {\n      background-color: #d013a1;\n}\n.button.lyft:active, button.lyft:active {\n      color: #fff;\n      background-color: #be1192;\n}\n.button.lyft.cta, button.lyft.cta {\n      border-bottom-color: #980e75;\n}\n.button.lyft.cta:hover, button.lyft.cta:hover {\n        background-color: #ed38bf;\n}\n.button.lyft.cta:active, button.lyft.cta:active {\n        background-color: #eb21b8;\n}\n.button.cta, button.cta {\n    font-weight: 700;\n    border-bottom-width: 4px;\n    border-bottom-style: solid;\n    text-transform: uppercase;\n}\n.button.block, button.block {\n    width: 100%;\n    text-align: center;\n}\n.here-pin.car {\n  width: 60px;\n  height: 60px;\n}\n.here-pin.car img {\n    position: relative;\n    top: -30px;\n    left: -30px;\n}\n.H_ib.car-info {\n  margin-left: 90px;\n}\n.H_ib.car-info .H_ib_tail {\n    margin-left: -217px;\n}\n.here-info-window.car {\n  width: 420px;\n  text-align: center;\n  line-height: 1;\n  font-family: Roboto, Arial, sans-serif;\n  padding: 15px 0 5px;\n}\n.here-info-window.car img {\n    width: 70px;\n    height: 70px;\n    background-color: #ddd;\n    margin: 0 auto;\n    border-radius: 70px;\n    -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.5);\n            box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.5);\n    border: 1px solid rgba(0, 0, 0, 0.25);\n}\n.here-info-window.car .sub-text {\n    font-size: 12px;\n    color: #777;\n    word-spacing: 2px;\n    font-weight: 500;\n}\n.here-info-window.car .left {\n    width: 50%;\n    display: inline-block;\n    vertical-align: top;\n}\n.here-info-window.car .left a {\n      display: block;\n      margin-top: 5px;\n      font-size: 14px;\n      font-weight: 700;\n      text-transform: uppercase;\n}\n.here-info-window.car .right {\n    width: 49%;\n    display: inline-block;\n    vertical-align: top;\n}\n.here-info-window.car .right .model {\n      display: block;\n      margin-top: 5px;\n      font-size: 14px;\n      font-weight: 700;\n      text-transform: uppercase;\n}\n.here-info-window.car .button {\n    margin-top: 15px;\n}\n.here-info-window.pickup, .here-info-window.dropoff {\n  width: 280px;\n  font-size: 12px;\n  margin-left: 3px;\n}\n.here-info-window.pickup .location, .here-info-window.dropoff .location {\n    line-height: 1.6;\n}\n.here-info-window.pickup .eta, .here-info-window.dropoff .eta {\n    border-top: 1px solid #eaeaea;\n}\n.here-info-window.extra {\n  width: 210px;\n  font-family: Roboto, Arial, sans-serif;\n  font-size: 13px;\n  line-height: 1.4;\n}\n.here-info-window.extra label {\n    color: #999;\n}\n.here-info-window.extra span {\n    color: #555;\n    font-weight: 600;\n}\n.H_driver-info .H_ib_body {\n  right: -85px;\n}\n.H_driver-info .H_ib_tail {\n  display: none;\n}\n.H_driver-info .info-container {\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 500;\n  width: 380px;\n  position: relative;\n}\n.H_driver-info .info-container .upcoming-rsvp {\n    text-align: center;\n    font-size: 13px;\n    margin: 0 10px 10px;\n    position: relative;\n    top: 5px;\n}\n.H_driver-info .info-container .driver-info {\n    width: 170px;\n    float: left;\n    margin-left: 20px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n.H_driver-info .info-container .driver-info > * {\n      display: block;\n      text-align: center;\n}\n.H_driver-info .info-container .driver-info a {\n      text-transform: uppercase;\n      font-weight: 700;\n}\n.H_driver-info .info-container .driver-info span {\n      line-height: 1;\n      font-size: 12px;\n      margin-bottom: 10px;\n      color: #555;\n}\n.H_driver-info .info-container .vehicle-info {\n    width: 170px;\n    float: left;\n    margin-left: 20px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n.H_driver-info .info-container .vehicle-info > * {\n      display: block;\n      text-align: center;\n}\n.H_driver-info .info-container .vehicle-info strong {\n      text-transform: uppercase;\n      font-weight: 700;\n}\n.H_driver-info .info-container .vehicle-info span {\n      line-height: 1;\n      font-size: 12px;\n      margin-bottom: 10px;\n      color: #555;\n}\n.H_driver-info .info-container .eta-to-dropoff {\n    margin: 0 20px 10px;\n    text-align: center;\n}\n.H_driver-info .info-container .eta-to-dropoff label {\n      color: #999;\n      font-size: 13px;\n}\n.H_driver-info .info-container .eta-to-dropoff span {\n      display: inline-block;\n      margin-left: 10px;\n      font-weight: 900;\n}\n.H_driver-info .info-container .call-button {\n    margin: 0 20px 5px;\n    width: 360px;\n    display: none;\n}\n.H_driver-info .info-container img {\n    width: 100px;\n    height: 100px;\n    margin: 0 auto 10px;\n    border-radius: 100px;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);\n}\n.H_driver-info .info-container .prvNxt {\n    position: absolute;\n    top: 80px;\n    font-size: 21px;\n    color: #939393;\n    cursor: pointer;\n}\n.H_driver-info .info-container .prvNxt.prev {\n      left: 0;\n}\n.H_driver-info .info-container .prvNxt.next {\n      right: -20px;\n}\n.H_driver-info .info-container .prvNxt.disabled {\n      opacity: .3;\n      cursor: default;\n}\n.H_ctl.H_el.H_zoom.H_grp, .H_ctl.H_el.H_scalebar, .H_ctl.H_el {\n  display: none;\n}\n.H_copyright {\n  display: none;\n}\n.H_logo {\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  margin: -5px 0 0 10px !important;\n}\n.hide-logo .H_logo {\n  position: absolute !important;\n  right: 15px !important;\n}\n.here-marker.car-icon {\n  background-image: url(\"https://s3-us-west-2.amazonaws.com/mobile-consumer-app/maps/car-sprite.png\");\n  width: 60px;\n  height: 60px;\n}\n.poi-marker {\n  position: absolute;\n  top: -9px;\n  left: -9px;\n  width: 18px;\n  height: 18px;\n  background-color: #333;\n}\n.poi-marker:after {\n    content: '';\n    position: absolute;\n    top: 6px;\n    left: 6px;\n    width: 6px;\n    height: 6px;\n    background-color: #fff;\n    border-radius: 50px;\n}\n.poi-marker.pickup {\n    border-radius: 50px;\n}\n.poi-marker.dropoff {\n    border-radius: 3px;\n}\n.poi-marker.extra-stop {\n    border-radius: 6px;\n}\n.poi-marker.terminal {\n    border-radius: 50px;\n    background-color: #333;\n}\n.global-modal {\n  display: table;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 999;\n  background-color: rgba(0, 0, 0, 0.6);\n}\n.global-modal-content {\n  display: table-cell;\n  vertical-align: middle;\n}\n.fade-enter-active, .fade-leave-active {\n  -webkit-transition: opacity 250ms;\n  transition: opacity 250ms;\n}\n.fade-enter, .fade-leave-to {\n  opacity: 0;\n}\n.lr2-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.05s ease;\n  transition: all 0.05s ease;\n}\n.lr2-modal .lr2-box {\n    background: #fff;\n    padding: 20px;\n    border-radius: 6px;\n    -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n    text-align: center;\n    min-width: 200px;\n    -webkit-transition: all 0.1s ease;\n    transition: all 0.1s ease;\n}\n.lr2-modal.hide {\n    z-index: -1;\n    opacity: 0;\n}\n.lr2-modal.hide .lr2-box {\n      -webkit-transform: scale(90%) translateY(30px);\n              transform: scale(90%) translateY(30px);\n}\n.rc-1 {\n  width: 35px !important;\n}\n.rc-2 {\n  width: 30px !important;\n}\n.rc-3 {\n  width: 30px !important;\n}\n.rc-4 {\n  width: 55px !important;\n}\n.rc-5 {\n  width: 90px !important;\n}\n.rc-6 {\n  width: 90px !important;\n}\n.rc-7 {\n  width: 160px !important;\n}\n.rc-8 {\n  width: 160px !important;\n}\n.rc-9 {\n  width: 100px !important;\n  padding: 0 !important;\n}\n.rc-10 {\n  width: 75px !important;\n}\n.rc-11 {\n  width: 65px !important;\n}\n.rc-12 {\n  width: 75px !important;\n}\n.rc-13 {\n  width: 70px !important;\n}\n.rc-14 {\n  width: 65px !important;\n}\n.rc-15 {\n  width: 30px !important;\n  padding: 0 !important;\n}\n.rc-16 {\n  width: 70px !important;\n}\n.rc-17 {\n  width: 44px !important;\n}\n.rc-18 {\n  width: 42px !important;\n}\n.rc-19 {\n  width: 80px !important;\n}\n.iti-flag {\n  background-image: url(\"https://s3-us-west-2.amazonaws.com/mobile-consumer-app/flags.png\");\n  margin-right: 3px;\n}\n@media only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx) {\n.iti-flag {\n    background-image: url(\"https://s3-us-west-2.amazonaws.com/mobile-consumer-app/flags@2x.png\");\n    margin-right: 3px;\n}\n}\n.iti-flag {\n  width: 20px;\n}\n.iti-flag.be {\n  width: 18px;\n}\n.iti-flag.ch {\n  width: 15px;\n}\n.iti-flag.mc {\n  width: 19px;\n}\n.iti-flag.ne {\n  width: 18px;\n}\n.iti-flag.np {\n  width: 13px;\n}\n.iti-flag.va {\n  width: 15px;\n}\n@media only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx) {\n.iti-flag {\n    background-size: 5630px 15px;\n}\n}\n.iti-flag.ac {\n  height: 10px;\n  background-position: 0px 0px;\n}\n.iti-flag.ad {\n  height: 14px;\n  background-position: -22px 0px;\n}\n.iti-flag.ae {\n  height: 10px;\n  background-position: -44px 0px;\n}\n.iti-flag.af {\n  height: 14px;\n  background-position: -66px 0px;\n}\n.iti-flag.ag {\n  height: 14px;\n  background-position: -88px 0px;\n}\n.iti-flag.ai {\n  height: 10px;\n  background-position: -110px 0px;\n}\n.iti-flag.al {\n  height: 15px;\n  background-position: -132px 0px;\n}\n.iti-flag.am {\n  height: 10px;\n  background-position: -154px 0px;\n}\n.iti-flag.ao {\n  height: 14px;\n  background-position: -176px 0px;\n}\n.iti-flag.aq {\n  height: 14px;\n  background-position: -198px 0px;\n}\n.iti-flag.ar {\n  height: 13px;\n  background-position: -220px 0px;\n}\n.iti-flag.as {\n  height: 10px;\n  background-position: -242px 0px;\n}\n.iti-flag.at {\n  height: 14px;\n  background-position: -264px 0px;\n}\n.iti-flag.au {\n  height: 10px;\n  background-position: -286px 0px;\n}\n.iti-flag.aw {\n  height: 14px;\n  background-position: -308px 0px;\n}\n.iti-flag.ax {\n  height: 13px;\n  background-position: -330px 0px;\n}\n.iti-flag.az {\n  height: 10px;\n  background-position: -352px 0px;\n}\n.iti-flag.ba {\n  height: 10px;\n  background-position: -374px 0px;\n}\n.iti-flag.bb {\n  height: 14px;\n  background-position: -396px 0px;\n}\n.iti-flag.bd {\n  height: 12px;\n  background-position: -418px 0px;\n}\n.iti-flag.be {\n  height: 15px;\n  background-position: -440px 0px;\n}\n.iti-flag.bf {\n  height: 14px;\n  background-position: -460px 0px;\n}\n.iti-flag.bg {\n  height: 12px;\n  background-position: -482px 0px;\n}\n.iti-flag.bh {\n  height: 12px;\n  background-position: -504px 0px;\n}\n.iti-flag.bi {\n  height: 12px;\n  background-position: -526px 0px;\n}\n.iti-flag.bj {\n  height: 14px;\n  background-position: -548px 0px;\n}\n.iti-flag.bl {\n  height: 14px;\n  background-position: -570px 0px;\n}\n.iti-flag.bm {\n  height: 10px;\n  background-position: -592px 0px;\n}\n.iti-flag.bn {\n  height: 10px;\n  background-position: -614px 0px;\n}\n.iti-flag.bo {\n  height: 14px;\n  background-position: -636px 0px;\n}\n.iti-flag.bq {\n  height: 14px;\n  background-position: -658px 0px;\n}\n.iti-flag.br {\n  height: 14px;\n  background-position: -680px 0px;\n}\n.iti-flag.bs {\n  height: 10px;\n  background-position: -702px 0px;\n}\n.iti-flag.bt {\n  height: 14px;\n  background-position: -724px 0px;\n}\n.iti-flag.bv {\n  height: 15px;\n  background-position: -746px 0px;\n}\n.iti-flag.bw {\n  height: 14px;\n  background-position: -768px 0px;\n}\n.iti-flag.by {\n  height: 10px;\n  background-position: -790px 0px;\n}\n.iti-flag.bz {\n  height: 14px;\n  background-position: -812px 0px;\n}\n.iti-flag.ca {\n  height: 10px;\n  background-position: -834px 0px;\n}\n.iti-flag.cc {\n  height: 10px;\n  background-position: -856px 0px;\n}\n.iti-flag.cd {\n  height: 15px;\n  background-position: -878px 0px;\n}\n.iti-flag.cf {\n  height: 14px;\n  background-position: -900px 0px;\n}\n.iti-flag.cg {\n  height: 14px;\n  background-position: -922px 0px;\n}\n.iti-flag.ch {\n  height: 15px;\n  background-position: -944px 0px;\n}\n.iti-flag.ci {\n  height: 14px;\n  background-position: -961px 0px;\n}\n.iti-flag.ck {\n  height: 10px;\n  background-position: -983px 0px;\n}\n.iti-flag.cl {\n  height: 14px;\n  background-position: -1005px 0px;\n}\n.iti-flag.cm {\n  height: 14px;\n  background-position: -1027px 0px;\n}\n.iti-flag.cn {\n  height: 14px;\n  background-position: -1049px 0px;\n}\n.iti-flag.co {\n  height: 14px;\n  background-position: -1071px 0px;\n}\n.iti-flag.cp {\n  height: 14px;\n  background-position: -1093px 0px;\n}\n.iti-flag.cr {\n  height: 12px;\n  background-position: -1115px 0px;\n}\n.iti-flag.cu {\n  height: 10px;\n  background-position: -1137px 0px;\n}\n.iti-flag.cv {\n  height: 12px;\n  background-position: -1159px 0px;\n}\n.iti-flag.cw {\n  height: 14px;\n  background-position: -1181px 0px;\n}\n.iti-flag.cx {\n  height: 10px;\n  background-position: -1203px 0px;\n}\n.iti-flag.cy {\n  height: 13px;\n  background-position: -1225px 0px;\n}\n.iti-flag.cz {\n  height: 14px;\n  background-position: -1247px 0px;\n}\n.iti-flag.de {\n  height: 12px;\n  background-position: -1269px 0px;\n}\n.iti-flag.dg {\n  height: 10px;\n  background-position: -1291px 0px;\n}\n.iti-flag.dj {\n  height: 14px;\n  background-position: -1313px 0px;\n}\n.iti-flag.dk {\n  height: 15px;\n  background-position: -1335px 0px;\n}\n.iti-flag.dm {\n  height: 10px;\n  background-position: -1357px 0px;\n}\n.iti-flag.do {\n  height: 13px;\n  background-position: -1379px 0px;\n}\n.iti-flag.dz {\n  height: 14px;\n  background-position: -1401px 0px;\n}\n.iti-flag.ea {\n  height: 14px;\n  background-position: -1423px 0px;\n}\n.iti-flag.ec {\n  height: 14px;\n  background-position: -1445px 0px;\n}\n.iti-flag.ee {\n  height: 13px;\n  background-position: -1467px 0px;\n}\n.iti-flag.eg {\n  height: 14px;\n  background-position: -1489px 0px;\n}\n.iti-flag.eh {\n  height: 10px;\n  background-position: -1511px 0px;\n}\n.iti-flag.er {\n  height: 10px;\n  background-position: -1533px 0px;\n}\n.iti-flag.es {\n  height: 14px;\n  background-position: -1555px 0px;\n}\n.iti-flag.et {\n  height: 10px;\n  background-position: -1577px 0px;\n}\n.iti-flag.eu {\n  height: 14px;\n  background-position: -1599px 0px;\n}\n.iti-flag.fi {\n  height: 12px;\n  background-position: -1621px 0px;\n}\n.iti-flag.fj {\n  height: 10px;\n  background-position: -1643px 0px;\n}\n.iti-flag.fk {\n  height: 10px;\n  background-position: -1665px 0px;\n}\n.iti-flag.fm {\n  height: 11px;\n  background-position: -1687px 0px;\n}\n.iti-flag.fo {\n  height: 15px;\n  background-position: -1709px 0px;\n}\n.iti-flag.fr {\n  height: 14px;\n  background-position: -1731px 0px;\n}\n.iti-flag.ga {\n  height: 15px;\n  background-position: -1753px 0px;\n}\n.iti-flag.gb {\n  height: 10px;\n  background-position: -1775px 0px;\n}\n.iti-flag.gd {\n  height: 12px;\n  background-position: -1797px 0px;\n}\n.iti-flag.ge {\n  height: 14px;\n  background-position: -1819px 0px;\n}\n.iti-flag.gf {\n  height: 14px;\n  background-position: -1841px 0px;\n}\n.iti-flag.gg {\n  height: 14px;\n  background-position: -1863px 0px;\n}\n.iti-flag.gh {\n  height: 14px;\n  background-position: -1885px 0px;\n}\n.iti-flag.gi {\n  height: 10px;\n  background-position: -1907px 0px;\n}\n.iti-flag.gl {\n  height: 14px;\n  background-position: -1929px 0px;\n}\n.iti-flag.gm {\n  height: 14px;\n  background-position: -1951px 0px;\n}\n.iti-flag.gn {\n  height: 14px;\n  background-position: -1973px 0px;\n}\n.iti-flag.gp {\n  height: 14px;\n  background-position: -1995px 0px;\n}\n.iti-flag.gq {\n  height: 14px;\n  background-position: -2017px 0px;\n}\n.iti-flag.gr {\n  height: 14px;\n  background-position: -2039px 0px;\n}\n.iti-flag.gs {\n  height: 10px;\n  background-position: -2061px 0px;\n}\n.iti-flag.gt {\n  height: 13px;\n  background-position: -2083px 0px;\n}\n.iti-flag.gu {\n  height: 11px;\n  background-position: -2105px 0px;\n}\n.iti-flag.gw {\n  height: 10px;\n  background-position: -2127px 0px;\n}\n.iti-flag.gy {\n  height: 12px;\n  background-position: -2149px 0px;\n}\n.iti-flag.hk {\n  height: 14px;\n  background-position: -2171px 0px;\n}\n.iti-flag.hm {\n  height: 10px;\n  background-position: -2193px 0px;\n}\n.iti-flag.hn {\n  height: 10px;\n  background-position: -2215px 0px;\n}\n.iti-flag.hr {\n  height: 10px;\n  background-position: -2237px 0px;\n}\n.iti-flag.ht {\n  height: 12px;\n  background-position: -2259px 0px;\n}\n.iti-flag.hu {\n  height: 10px;\n  background-position: -2281px 0px;\n}\n.iti-flag.ic {\n  height: 14px;\n  background-position: -2303px 0px;\n}\n.iti-flag.id {\n  height: 14px;\n  background-position: -2325px 0px;\n}\n.iti-flag.ie {\n  height: 10px;\n  background-position: -2347px 0px;\n}\n.iti-flag.il {\n  height: 15px;\n  background-position: -2369px 0px;\n}\n.iti-flag.im {\n  height: 10px;\n  background-position: -2391px 0px;\n}\n.iti-flag.in {\n  height: 14px;\n  background-position: -2413px 0px;\n}\n.iti-flag.io {\n  height: 10px;\n  background-position: -2435px 0px;\n}\n.iti-flag.iq {\n  height: 14px;\n  background-position: -2457px 0px;\n}\n.iti-flag.ir {\n  height: 12px;\n  background-position: -2479px 0px;\n}\n.iti-flag.is {\n  height: 15px;\n  background-position: -2501px 0px;\n}\n.iti-flag.it {\n  height: 14px;\n  background-position: -2523px 0px;\n}\n.iti-flag.je {\n  height: 12px;\n  background-position: -2545px 0px;\n}\n.iti-flag.jm {\n  height: 10px;\n  background-position: -2567px 0px;\n}\n.iti-flag.jo {\n  height: 10px;\n  background-position: -2589px 0px;\n}\n.iti-flag.jp {\n  height: 14px;\n  background-position: -2611px 0px;\n}\n.iti-flag.ke {\n  height: 14px;\n  background-position: -2633px 0px;\n}\n.iti-flag.kg {\n  height: 12px;\n  background-position: -2655px 0px;\n}\n.iti-flag.kh {\n  height: 13px;\n  background-position: -2677px 0px;\n}\n.iti-flag.ki {\n  height: 10px;\n  background-position: -2699px 0px;\n}\n.iti-flag.km {\n  height: 12px;\n  background-position: -2721px 0px;\n}\n.iti-flag.kn {\n  height: 14px;\n  background-position: -2743px 0px;\n}\n.iti-flag.kp {\n  height: 10px;\n  background-position: -2765px 0px;\n}\n.iti-flag.kr {\n  height: 14px;\n  background-position: -2787px 0px;\n}\n.iti-flag.kw {\n  height: 10px;\n  background-position: -2809px 0px;\n}\n.iti-flag.ky {\n  height: 10px;\n  background-position: -2831px 0px;\n}\n.iti-flag.kz {\n  height: 10px;\n  background-position: -2853px 0px;\n}\n.iti-flag.la {\n  height: 14px;\n  background-position: -2875px 0px;\n}\n.iti-flag.lb {\n  height: 14px;\n  background-position: -2897px 0px;\n}\n.iti-flag.lc {\n  height: 10px;\n  background-position: -2919px 0px;\n}\n.iti-flag.li {\n  height: 12px;\n  background-position: -2941px 0px;\n}\n.iti-flag.lk {\n  height: 10px;\n  background-position: -2963px 0px;\n}\n.iti-flag.lr {\n  height: 11px;\n  background-position: -2985px 0px;\n}\n.iti-flag.ls {\n  height: 14px;\n  background-position: -3007px 0px;\n}\n.iti-flag.lt {\n  height: 12px;\n  background-position: -3029px 0px;\n}\n.iti-flag.lu {\n  height: 12px;\n  background-position: -3051px 0px;\n}\n.iti-flag.lv {\n  height: 10px;\n  background-position: -3073px 0px;\n}\n.iti-flag.ly {\n  height: 10px;\n  background-position: -3095px 0px;\n}\n.iti-flag.ma {\n  height: 14px;\n  background-position: -3117px 0px;\n}\n.iti-flag.mc {\n  height: 15px;\n  background-position: -3139px 0px;\n}\n.iti-flag.md {\n  height: 10px;\n  background-position: -3160px 0px;\n}\n.iti-flag.me {\n  height: 10px;\n  background-position: -3182px 0px;\n}\n.iti-flag.mf {\n  height: 14px;\n  background-position: -3204px 0px;\n}\n.iti-flag.mg {\n  height: 14px;\n  background-position: -3226px 0px;\n}\n.iti-flag.mh {\n  height: 11px;\n  background-position: -3248px 0px;\n}\n.iti-flag.mk {\n  height: 10px;\n  background-position: -3270px 0px;\n}\n.iti-flag.ml {\n  height: 14px;\n  background-position: -3292px 0px;\n}\n.iti-flag.mm {\n  height: 14px;\n  background-position: -3314px 0px;\n}\n.iti-flag.mn {\n  height: 10px;\n  background-position: -3336px 0px;\n}\n.iti-flag.mo {\n  height: 14px;\n  background-position: -3358px 0px;\n}\n.iti-flag.mp {\n  height: 10px;\n  background-position: -3380px 0px;\n}\n.iti-flag.mq {\n  height: 14px;\n  background-position: -3402px 0px;\n}\n.iti-flag.mr {\n  height: 14px;\n  background-position: -3424px 0px;\n}\n.iti-flag.ms {\n  height: 10px;\n  background-position: -3446px 0px;\n}\n.iti-flag.mt {\n  height: 14px;\n  background-position: -3468px 0px;\n}\n.iti-flag.mu {\n  height: 14px;\n  background-position: -3490px 0px;\n}\n.iti-flag.mv {\n  height: 14px;\n  background-position: -3512px 0px;\n}\n.iti-flag.mw {\n  height: 14px;\n  background-position: -3534px 0px;\n}\n.iti-flag.mx {\n  height: 12px;\n  background-position: -3556px 0px;\n}\n.iti-flag.my {\n  height: 10px;\n  background-position: -3578px 0px;\n}\n.iti-flag.mz {\n  height: 14px;\n  background-position: -3600px 0px;\n}\n.iti-flag.na {\n  height: 14px;\n  background-position: -3622px 0px;\n}\n.iti-flag.nc {\n  height: 10px;\n  background-position: -3644px 0px;\n}\n.iti-flag.ne {\n  height: 15px;\n  background-position: -3666px 0px;\n}\n.iti-flag.nf {\n  height: 10px;\n  background-position: -3686px 0px;\n}\n.iti-flag.ng {\n  height: 10px;\n  background-position: -3708px 0px;\n}\n.iti-flag.ni {\n  height: 12px;\n  background-position: -3730px 0px;\n}\n.iti-flag.nl {\n  height: 14px;\n  background-position: -3752px 0px;\n}\n.iti-flag.no {\n  height: 15px;\n  background-position: -3774px 0px;\n}\n.iti-flag.np {\n  height: 15px;\n  background-position: -3796px 0px;\n}\n.iti-flag.nr {\n  height: 10px;\n  background-position: -3811px 0px;\n}\n.iti-flag.nu {\n  height: 10px;\n  background-position: -3833px 0px;\n}\n.iti-flag.nz {\n  height: 10px;\n  background-position: -3855px 0px;\n}\n.iti-flag.om {\n  height: 10px;\n  background-position: -3877px 0px;\n}\n.iti-flag.pa {\n  height: 14px;\n  background-position: -3899px 0px;\n}\n.iti-flag.pe {\n  height: 14px;\n  background-position: -3921px 0px;\n}\n.iti-flag.pf {\n  height: 14px;\n  background-position: -3943px 0px;\n}\n.iti-flag.pg {\n  height: 15px;\n  background-position: -3965px 0px;\n}\n.iti-flag.ph {\n  height: 10px;\n  background-position: -3987px 0px;\n}\n.iti-flag.pk {\n  height: 14px;\n  background-position: -4009px 0px;\n}\n.iti-flag.pl {\n  height: 13px;\n  background-position: -4031px 0px;\n}\n.iti-flag.pm {\n  height: 14px;\n  background-position: -4053px 0px;\n}\n.iti-flag.pn {\n  height: 10px;\n  background-position: -4075px 0px;\n}\n.iti-flag.pr {\n  height: 14px;\n  background-position: -4097px 0px;\n}\n.iti-flag.ps {\n  height: 10px;\n  background-position: -4119px 0px;\n}\n.iti-flag.pt {\n  height: 14px;\n  background-position: -4141px 0px;\n}\n.iti-flag.pw {\n  height: 13px;\n  background-position: -4163px 0px;\n}\n.iti-flag.py {\n  height: 11px;\n  background-position: -4185px 0px;\n}\n.iti-flag.qa {\n  height: 8px;\n  background-position: -4207px 0px;\n}\n.iti-flag.re {\n  height: 14px;\n  background-position: -4229px 0px;\n}\n.iti-flag.ro {\n  height: 14px;\n  background-position: -4251px 0px;\n}\n.iti-flag.rs {\n  height: 14px;\n  background-position: -4273px 0px;\n}\n.iti-flag.ru {\n  height: 14px;\n  background-position: -4295px 0px;\n}\n.iti-flag.rw {\n  height: 14px;\n  background-position: -4317px 0px;\n}\n.iti-flag.sa {\n  height: 14px;\n  background-position: -4339px 0px;\n}\n.iti-flag.sb {\n  height: 10px;\n  background-position: -4361px 0px;\n}\n.iti-flag.sc {\n  height: 10px;\n  background-position: -4383px 0px;\n}\n.iti-flag.sd {\n  height: 10px;\n  background-position: -4405px 0px;\n}\n.iti-flag.se {\n  height: 13px;\n  background-position: -4427px 0px;\n}\n.iti-flag.sg {\n  height: 14px;\n  background-position: -4449px 0px;\n}\n.iti-flag.sh {\n  height: 10px;\n  background-position: -4471px 0px;\n}\n.iti-flag.si {\n  height: 10px;\n  background-position: -4493px 0px;\n}\n.iti-flag.sj {\n  height: 15px;\n  background-position: -4515px 0px;\n}\n.iti-flag.sk {\n  height: 14px;\n  background-position: -4537px 0px;\n}\n.iti-flag.sl {\n  height: 14px;\n  background-position: -4559px 0px;\n}\n.iti-flag.sm {\n  height: 15px;\n  background-position: -4581px 0px;\n}\n.iti-flag.sn {\n  height: 14px;\n  background-position: -4603px 0px;\n}\n.iti-flag.so {\n  height: 14px;\n  background-position: -4625px 0px;\n}\n.iti-flag.sr {\n  height: 14px;\n  background-position: -4647px 0px;\n}\n.iti-flag.ss {\n  height: 10px;\n  background-position: -4669px 0px;\n}\n.iti-flag.st {\n  height: 10px;\n  background-position: -4691px 0px;\n}\n.iti-flag.sv {\n  height: 12px;\n  background-position: -4713px 0px;\n}\n.iti-flag.sx {\n  height: 14px;\n  background-position: -4735px 0px;\n}\n.iti-flag.sy {\n  height: 14px;\n  background-position: -4757px 0px;\n}\n.iti-flag.sz {\n  height: 14px;\n  background-position: -4779px 0px;\n}\n.iti-flag.ta {\n  height: 10px;\n  background-position: -4801px 0px;\n}\n.iti-flag.tc {\n  height: 10px;\n  background-position: -4823px 0px;\n}\n.iti-flag.td {\n  height: 14px;\n  background-position: -4845px 0px;\n}\n.iti-flag.tf {\n  height: 14px;\n  background-position: -4867px 0px;\n}\n.iti-flag.tg {\n  height: 13px;\n  background-position: -4889px 0px;\n}\n.iti-flag.th {\n  height: 14px;\n  background-position: -4911px 0px;\n}\n.iti-flag.tj {\n  height: 10px;\n  background-position: -4933px 0px;\n}\n.iti-flag.tk {\n  height: 10px;\n  background-position: -4955px 0px;\n}\n.iti-flag.tl {\n  height: 10px;\n  background-position: -4977px 0px;\n}\n.iti-flag.tm {\n  height: 14px;\n  background-position: -4999px 0px;\n}\n.iti-flag.tn {\n  height: 14px;\n  background-position: -5021px 0px;\n}\n.iti-flag.to {\n  height: 10px;\n  background-position: -5043px 0px;\n}\n.iti-flag.tr {\n  height: 14px;\n  background-position: -5065px 0px;\n}\n.iti-flag.tt {\n  height: 12px;\n  background-position: -5087px 0px;\n}\n.iti-flag.tv {\n  height: 10px;\n  background-position: -5109px 0px;\n}\n.iti-flag.tw {\n  height: 14px;\n  background-position: -5131px 0px;\n}\n.iti-flag.tz {\n  height: 14px;\n  background-position: -5153px 0px;\n}\n.iti-flag.ua {\n  height: 14px;\n  background-position: -5175px 0px;\n}\n.iti-flag.ug {\n  height: 14px;\n  background-position: -5197px 0px;\n}\n.iti-flag.um {\n  height: 11px;\n  background-position: -5219px 0px;\n}\n.iti-flag.us {\n  height: 11px;\n  background-position: -5241px 0px;\n}\n.iti-flag.uy {\n  height: 14px;\n  background-position: -5263px 0px;\n}\n.iti-flag.uz {\n  height: 10px;\n  background-position: -5285px 0px;\n}\n.iti-flag.va {\n  height: 15px;\n  background-position: -5307px 0px;\n}\n.iti-flag.vc {\n  height: 14px;\n  background-position: -5324px 0px;\n}\n.iti-flag.ve {\n  height: 14px;\n  background-position: -5346px 0px;\n}\n.iti-flag.vg {\n  height: 10px;\n  background-position: -5368px 0px;\n}\n.iti-flag.vi {\n  height: 14px;\n  background-position: -5390px 0px;\n}\n.iti-flag.vn {\n  height: 14px;\n  background-position: -5412px 0px;\n}\n.iti-flag.vu {\n  height: 12px;\n  background-position: -5434px 0px;\n}\n.iti-flag.wf {\n  height: 14px;\n  background-position: -5456px 0px;\n}\n.iti-flag.ws {\n  height: 10px;\n  background-position: -5478px 0px;\n}\n.iti-flag.xk {\n  height: 15px;\n  background-position: -5500px 0px;\n}\n.iti-flag.ye {\n  height: 14px;\n  background-position: -5522px 0px;\n}\n.iti-flag.yt {\n  height: 14px;\n  background-position: -5544px 0px;\n}\n.iti-flag.za {\n  height: 14px;\n  background-position: -5566px 0px;\n}\n.iti-flag.zm {\n  height: 14px;\n  background-position: -5588px 0px;\n}\n.iti-flag.zw {\n  height: 10px;\n  background-position: -5610px 0px;\n}\n.iti-flag {\n  width: 20px;\n  height: 15px;\n  -webkit-box-shadow: 0px 0px 1px 0px #888;\n          box-shadow: 0px 0px 1px 0px #888;\n  background-color: #DBDBDB;\n  background-position: 20px 0;\n}\n.iti-flag.np {\n  background-color: transparent;\n}\n.atwho-view {\n  bottom: auto;\n  top: 30px;\n  font-size: 14px;\n  border-radius: 3px;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n}\n.tribute-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: auto;\n  max-height: 300px;\n  max-width: 500px;\n  overflow: auto;\n  display: block;\n  z-index: 999999;\n}\n.tribute-container ul {\n  margin: 0;\n  margin-top: 2px;\n  padding: 0;\n  list-style: none;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-bottom: 0;\n  border-radius: 3px;\n  font-size: 14px;\n  background: #fff;\n}\n.tribute-container li {\n  padding: 5px 5px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n  cursor: pointer;\n}\n.tribute-container li.highlight, .tribute-container li:hover {\n  background: #eee;\n}\n.tribute-container li span {\n  font-weight: bold;\n}\n.tribute-container li.no-match {\n  cursor: default;\n}\n.tribute-container .menu-highlighted {\n  font-weight: bold;\n}\n.mention, .atwho-inserted {\n  color: #0D79F2;\n  font-weight: 700;\n}\n.vdp-datepicker.datepicker.left-side .vdp-datepicker__calendar {\n  right: 0;\n}\n.vdp-datepicker.datepicker input {\n  margin-top: 0 !important;\n}\n.vdp-datepicker.datepicker.has-error input {\n  border-color: #f20d0d !important;\n}\n.vdp-datepicker.datepicker.inline input {\n  border-color: #767676;\n}\n.vdp-datepicker.datepicker .vdp-datepicker__calendar-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 21px;\n  color: #ccc;\n}\n.vdp-datepicker.datepicker input:disabled {\n  background: #eee;\n}\n.vdp-datepicker.datepicker.custom-pa-availability input {\n  padding: 5px 10px;\n}\n.vdp-datepicker.datepicker input {\n  margin: 5px 0 0 !important;\n  border: 1px solid rgba(0, 0, 0, 0.15) !important;\n}\n.datepicker-empty {\n  border: 1px solid #f33a27 !important;\n}\n.datepicker.small input {\n  height: 35px;\n}\n.vdp-datepicker.geofence-datepicker input {\n  margin-top: 0 !important;\n  margin: 0 auto;\n  width: 121px;\n  padding: 5px;\n  font-size: 13px;\n}\n.mx-datepicker.cons-datepicker {\n  width: 100% !important;\n}\n.mx-datepicker.cons-datepicker .mx-input-wrapper {\n    width: 100% !important;\n}\n.mx-datepicker.cons-datepicker .mx-input {\n    margin: 5px 0 0;\n    color: #333;\n    display: block;\n    outline: none;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    padding: 10px;\n    border: 0;\n    width: 100%;\n    border-radius: 3px;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    line-height: 1.5;\n    font-size: 16px;\n    height: auto;\n    font-family: \"Open Sans\", sans-serif;\n}\n.mx-datepicker.cons-datepicker .mx-input-append {\n    display: none;\n}\n.overlayColor {\n  width: 100% !important;\n}\n.overlayColor .vc-ps-saturation-wrap, .overlayColor .vc-ps-hue-wrap {\n    height: 200px;\n}\n.overlayColor .vc-ps-actions .vc-ps-ac-btn {\n    display: none;\n}\n.overlayColor .vc-input__input {\n    margin-top: 5px;\n}\n.servicearea-date-input {\n  width: 150px !important;\n  margin-top: 0 !important;\n  padding: 5px !important;\n  font-size: 13px !important;\n}\n.sectorfilter-dateinput {\n  margin-top: 0 !important;\n  font-size: 14px !important;\n  padding: 7px 7px !important;\n}\n.sectorfilter-calendar {\n  font-size: 14px !important;\n  right: 0;\n}\n.drivershift-dateinput {\n  margin-top: 0 !important;\n  font-size: 14px !important;\n  padding: 7px 7px !important;\n}\n.drivershift-calendar {\n  font-size: 14px !important;\n}\n.mx-input-wrapper {\n  width: 150px !important;\n}\n.mx-calendar-icon {\n  height: auto !important;\n}\n.date-input-block .mx-input-wrapper,\n.date-input-block .servicearea-date-input {\n  width: 100% !important;\n}\n#TimePicker .field-clear-button, input#TimePicker {\n  margin-top: 0;\n}\n.time-picker-column .active .time-picker-column-item-text {\n  color: #fff;\n}\n.time-picker-column .time-picker-column-item-text {\n  color: #333;\n}\n.datetimepicker .datepicker-button {\n  width: 100%;\n  background: #0d79f2 !important;\n}\n.datetimepicker .datepicker-button:hover {\n    background: #0556b0 !important;\n}\n.datetimepicker .datepicker-button span {\n    display: none;\n}\n.datetimepicker .datepicker-button svg {\n    fill: #fff !important;\n}\n.rtl-dp .vdp-datepicker__calendar {\n  right: 0;\n}\n.rtl-dp .dtp {\n  padding: 5px 8px;\n}\n.H_ib {\n  left: -90.85%;\n  top: -25px;\n}\n.H_ib_content {\n  margin: 10px 28px 10px 10px;\n}\n.H_ib_tail {\n  margin: -10px 0 0 -125px;\n}\n.here-info-window-content {\n  width: 250px;\n  font-size: 13px;\n  text-align: center;\n  line-height: 1.4;\n  font-family: Roboto, Arial, sans-serif;\n}\n.here-info-window-content .value {\n    font-weight: 600;\n}\n.H_ib.package-detail-iw {\n  margin-left: -28px;\n}\n.H_ib.package-detail-iw .here-info-window-content {\n    text-align: left;\n}\n.H_ib.package-detail-iw .here-info-window-content label {\n      color: #51a2fd;\n      font-size: 11px;\n      display: block;\n}\n.H_ib.package-detail-iw .here-info-window-content .value {\n      margin-bottom: 5px;\n      display: inline-block;\n}\n.H_ib.package-detail-iw .H_ib_tail {\n    margin: -10px 0 0 -113px;\n}\n.routing-map .H_ib_tail {\n  margin: -10px 0 0 -95px;\n}\n.routing-map .here-info-window-content.routing {\n  text-align: left;\n  width: 165px;\n}\n.routing-map .here-info-window-content.routing .stop-id {\n    border-bottom: 1px solid #ccc;\n    padding: 0 0 7px 0;\n    margin-bottom: 10px;\n}\n.routing-map .here-info-window-content.routing .stop-id .index {\n      display: inline-block;\n      width: 16px;\n      height: 16px;\n      line-height: 16px;\n      text-align: center;\n      border-radius: 100%;\n      background-color: #F20D0D;\n      margin-right: 5px;\n      color: #fff;\n      font-weight: 700;\n}\n.routing-map .here-info-window-content.routing .stop-id .index.pickup {\n        background-color: #26D97A;\n}\n.here-info-window-content.coverage.rsvp {\n  text-align: left;\n}\n.here-info-window-content.coverage.rsvp .label-value {\n    margin-bottom: 7px;\n}\n.here-info-window-content.coverage.rsvp label {\n    color: #51a2fd;\n    font-size: 11px;\n    display: block;\n}\n.top-calendar.vdp-datepicker__calendar {\n  bottom: 100%;\n}\n.vdp-datepicker.datepicker.fl-filter input {\n  padding: 0 27px 0 10px;\n  line-height: 38px;\n  height: 38px;\n  max-width: 155px;\n}\n.vdp-datepicker.datepicker.fl-filter .vdp-datepicker__clear-button {\n  position: absolute;\n  right: 5px;\n  top: 0;\n  line-height: 38px;\n  height: 38px;\n  width: 20px;\n  text-align: center;\n  font-size: 24px;\n  font-style: normal;\n  color: #ef4e4e;\n}\n.m-T-0 {\n  margin-top: 0;\n}\n.m-L-5 {\n  margin-left: 5px;\n}\n.m-X-5 {\n  margin-left: 5px;\n  margin-right: 5px;\n}\n.d-flex {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.justify-center {\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n}\n.justify-space-between {\n  -webkit-box-pack: justify !important;\n      -ms-flex-pack: justify !important;\n          justify-content: space-between !important;\n}\n.justify-space-around {\n  -ms-flex-pack: distribute !important;\n      justify-content: space-around !important;\n}\n.justify-end {\n  -webkit-box-pack: end !important;\n      -ms-flex-pack: end !important;\n          justify-content: flex-end !important;\n}\n.align-start {\n  -webkit-box-align: start !important;\n      -ms-flex-align: start !important;\n          align-items: flex-start !important;\n}\n.align-center {\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n}\n.align-stretch {\n  -webkit-box-align: stretch !important;\n      -ms-flex-align: stretch !important;\n          align-items: stretch !important;\n}\n.flex-column {\n  -webkit-box-orient: vertical !important;\n  -webkit-box-direction: normal !important;\n      -ms-flex-direction: column !important;\n          flex-direction: column !important;\n}\n.route-container {\n  margin-left: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.route-container.side-menu {\n    margin-left: 250px;\n}\n.slide-enter-active, .slide-leave-active {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.slide-enter, .slide-leave-to {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/App/index.vue"],"names":[],"mappings":";AACA;EACE,0BAA0B;EAC1B,qCAAqC;CACtC;AACD;;;EAGE,eAAe;CAChB;AACD;;EAEE,eAAe;EACf,cAAc;EACd,+BAA+B;UACvB,uBAAuB;EAC/B,cAAc;EACd,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;CACtB;AACD;;IAEI,2BAA2B;CAC9B;AACD;;IAEI,2BAA2B;CAC9B;AACD;;IAEI,2BAA2B;CAC9B;AACD;;IAEI,2BAA2B;CAC9B;AACD;;IAEI,kCAAkC;CACrC;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kDAAkD;UAC1C,0CAA0C;EAClD,0CAA0C;CAC3C;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,cAAc;EACd,sBAAsB;EACtB,+BAA+B;UACvB,uBAAuB;EAC/B,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;CACzB;AACD;IACI,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;CAChB;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,YAAY;IACZ,0BAA0B;CAC7B;AACD;IACI,6BAA6B;CAChC;AACD;MACM,0BAA0B;CAC/B;AACD;MACM,0BAA0B;CAC/B;AACD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;CAC3B;AACD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;CAC3B;AACD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;CAC3B;AACD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;CACzB;AACD;IACI,uBAAuB;IACvB,0BAA0B;CAC7B;AACD;MACM,0BAA0B;CAC/B;AACD;MACM,YAAY;MACZ,0BAA0B;CAC/B;AACD;MACM,6BAA6B;CAClC;AACD;QACQ,0BAA0B;CACjC;AACD;QACQ,0BAA0B;CACjC;AACD;IACI,uBAAuB;IACvB,0BAA0B;CAC7B;AACD;MACM,0BAA0B;CAC/B;AACD;MACM,YAAY;MACZ,0BAA0B;CAC/B;AACD;MACM,6BAA6B;CAClC;AACD;QACQ,0BAA0B;CACjC;AACD;QACQ,0BAA0B;CACjC;AACD;IACI,uBAAuB;IACvB,0BAA0B;CAC7B;AACD;MACM,0BAA0B;CAC/B;AACD;MACM,YAAY;MACZ,0BAA0B;CAC/B;AACD;MACM,6BAA6B;CAClC;AACD;QACQ,0BAA0B;CACjC;AACD;QACQ,0BAA0B;CACjC;AACD;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;CAC1B;AACD;MACM,0BAA0B;CAC/B;AACD;MACM,YAAY;MACZ,0BAA0B;CAC/B;AACD;MACM,6BAA6B;CAClC;AACD;QACQ,0BAA0B;CACjC;AACD;QACQ,0BAA0B;CACjC;AACD;IACI,uBAAuB;IACvB,0BAA0B;CAC7B;AACD;MACM,0BAA0B;CAC/B;AACD;MACM,YAAY;MACZ,0BAA0B;CAC/B;AACD;MACM,6BAA6B;CAClC;AACD;QACQ,0BAA0B;CACjC;AACD;QACQ,0BAA0B;CACjC;AACD;IACI,iBAAiB;IACjB,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;CAC7B;AACD;IACI,YAAY;IACZ,mBAAmB;CACtB;AACD;EACE,YAAY;EACZ,aAAa;CACd;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;CACf;AACD;EACE,kBAAkB;CACnB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uCAAuC;EACvC,oBAAoB;CACrB;AACD;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,oBAAoB;IACpB,qDAAqD;YAC7C,6CAA6C;IACrD,sCAAsC;CACzC;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;CACpB;AACD;IACI,WAAW;IACX,sBAAsB;IACtB,oBAAoB;CACvB;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,gBAAgB;MAChB,iBAAiB;MACjB,0BAA0B;CAC/B;AACD;IACI,WAAW;IACX,sBAAsB;IACtB,oBAAoB;CACvB;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,gBAAgB;MAChB,iBAAiB;MACjB,0BAA0B;CAC/B;AACD;IACI,iBAAiB;CACpB;AACD;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;CAClB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,8BAA8B;CACjC;AACD;EACE,aAAa;EACb,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;CAClB;AACD;IACI,YAAY;CACf;AACD;IACI,YAAY;IACZ,iBAAiB;CACpB;AACD;EACE,aAAa;CACd;AACD;EACE,cAAc;CACf;AACD;EACE,qCAAqC;EACrC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;CACZ;AACD;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;CACvB;AACD;MACM,eAAe;MACf,mBAAmB;CACxB;AACD;MACM,0BAA0B;MAC1B,iBAAiB;CACtB;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,YAAY;CACjB;AACD;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;CACvB;AACD;MACM,eAAe;MACf,mBAAmB;CACxB;AACD;MACM,0BAA0B;MAC1B,iBAAiB;CACtB;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,YAAY;CACjB;AACD;IACI,oBAAoB;IACpB,mBAAmB;CACtB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;MACM,sBAAsB;MACtB,kBAAkB;MAClB,iBAAiB;CACtB;AACD;IACI,mBAAmB;IACnB,aAAa;IACb,cAAc;CACjB;AACD;IACI,aAAa;IACb,cAAc;IACd,oBAAoB;IACpB,qBAAqB;IACrB,iDAAiD;YACzC,yCAAyC;CACpD;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,gBAAgB;CACnB;AACD;MACM,QAAQ;CACb;AACD;MACM,aAAa;CAClB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;EACE,cAAc;CACf;AACD;EACE,cAAc;CACf;AACD;EACE,iCAAiC;UACzB,yBAAyB;EACjC,iCAAiC;CAClC;AACD;EACE,8BAA8B;EAC9B,uBAAuB;CACxB;AACD;EACE,oGAAoG;EACpG,YAAY;EACZ,aAAa;CACd;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;CACxB;AACD;IACI,YAAY;IACZ,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,oBAAoB;IACpB,uBAAuB;CAC1B;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,aAAa;EACb,qCAAqC;CACtC;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,WAAW;CACZ;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oCAAoC;MAChC,iCAAiC;UAC7B,mCAAmC;EAC3C,qCAAqC;MACjC,kCAAkC;UAC9B,+BAA+B;EACvC,mCAAmC;EACnC,2BAA2B;CAC5B;AACD;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,mDAAmD;YAC3C,2CAA2C;IACnD,mBAAmB;IACnB,iBAAiB;IACjB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;IACI,YAAY;IACZ,WAAW;CACd;AACD;MACM,+CAA+C;cACvC,uCAAuC;CACpD;AACD;EACE,uBAAuB;CACxB;AACD;EACE,uBAAuB;CACxB;AACD;EACE,uBAAuB;CACxB;AACD;EACE,uBAAuB;CACxB;AACD;EACE,uBAAuB;CACxB;AACD;EACE,uBAAuB;CACxB;AACD;EACE,wBAAwB;CACzB;AACD;EACE,wBAAwB;CACzB;AACD;EACE,wBAAwB;EACxB,sBAAsB;CACvB;AACD;EACE,uBAAuB;CACxB;AACD;EACE,uBAAuB;CACxB;AACD;EACE,uBAAuB;CACxB;AACD;EACE,uBAAuB;CACxB;AACD;EACE,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,sBAAsB;CACvB;AACD;EACE,uBAAuB;CACxB;AACD;EACE,uBAAuB;CACxB;AACD;EACE,uBAAuB;CACxB;AACD;EACE,uBAAuB;CACxB;AACD;EACE,0FAA0F;EAC1F,kBAAkB;CACnB;AACD;AACA;IACI,6FAA6F;IAC7F,kBAAkB;CACrB;CACA;AACD;EACE,YAAY;CACb;AACD;EACE,YAAY;CACb;AACD;EACE,YAAY;CACb;AACD;EACE,YAAY;CACb;AACD;EACE,YAAY;CACb;AACD;EACE,YAAY;CACb;AACD;EACE,YAAY;CACb;AACD;AACA;IACI,6BAA6B;CAChC;CACA;AACD;EACE,aAAa;EACb,6BAA6B;CAC9B;AACD;EACE,aAAa;EACb,+BAA+B;CAChC;AACD;EACE,aAAa;EACb,+BAA+B;CAChC;AACD;EACE,aAAa;EACb,+BAA+B;CAChC;AACD;EACE,aAAa;EACb,+BAA+B;CAChC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,YAAY;EACZ,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;EACE,YAAY;EACZ,aAAa;EACb,yCAAyC;UACjC,iCAAiC;EACzC,0BAA0B;EAC1B,4BAA4B;CAC7B;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;CACtC;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;CACjB;AACD;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,gBAAgB;CACjB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,eAAe;EACf,iBAAiB;CAClB;AACD;EACE,SAAS;CACV;AACD;EACE,yBAAyB;CAC1B;AACD;EACE,iCAAiC;CAClC;AACD;EACE,sBAAsB;CACvB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,YAAY;CACb;AACD;EACE,iBAAiB;CAClB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,2BAA2B;EAC3B,iDAAiD;CAClD;AACD;EACE,qCAAqC;CACtC;AACD;EACE,aAAa;CACd;AACD;EACE,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,aAAa;EACb,gBAAgB;CACjB;AACD;EACE,uBAAuB;CACxB;AACD;IACI,uBAAuB;CAC1B;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,+BAA+B;IAC/B,uBAAuB;IACvB,cAAc;IACd,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,sCAAsC;IACtC,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,qCAAqC;CACxC;AACD;IACI,cAAc;CACjB;AACD;EACE,uBAAuB;CACxB;AACD;IACI,cAAc;CACjB;AACD;IACI,cAAc;CACjB;AACD;IACI,gBAAgB;CACnB;AACD;EACE,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;CAC5B;AACD;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;CAC7B;AACD;EACE,2BAA2B;EAC3B,SAAS;CACV;AACD;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;CAC7B;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,wBAAwB;CACzB;AACD;EACE,wBAAwB;CACzB;AACD;;EAEE,uBAAuB;CACxB;AACD;EACE,cAAc;CACf;AACD;EACE,YAAY;CACb;AACD;EACE,YAAY;CACb;AACD;EACE,YAAY;EACZ,+BAA+B;CAChC;AACD;IACI,+BAA+B;CAClC;AACD;IACI,cAAc;CACjB;AACD;IACI,sBAAsB;CACzB;AACD;EACE,SAAS;CACV;AACD;EACE,iBAAiB;CAClB;AACD;EACE,cAAc;EACd,WAAW;CACZ;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,yBAAyB;CAC1B;AACD;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,uCAAuC;CACxC;AACD;IACI,iBAAiB;CACpB;AACD;EACE,mBAAmB;CACpB;AACD;IACI,iBAAiB;CACpB;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,eAAe;CACpB;AACD;MACM,mBAAmB;MACnB,sBAAsB;CAC3B;AACD;IACI,yBAAyB;CAC5B;AACD;EACE,wBAAwB;CACzB;AACD;EACE,iBAAiB;EACjB,aAAa;CACd;AACD;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;CACvB;AACD;MACM,sBAAsB;MACtB,YAAY;MACZ,aAAa;MACb,kBAAkB;MAClB,mBAAmB;MACnB,oBAAoB;MACpB,0BAA0B;MAC1B,kBAAkB;MAClB,YAAY;MACZ,iBAAiB;CACtB;AACD;QACQ,0BAA0B;CACjC;AACD;EACE,iBAAiB;CAClB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;CAClB;AACD;EACE,aAAa;CACd;AACD;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;CAClB;AACD;EACE,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;CAChB;AACD;EACE,cAAc;CACf;AACD;EACE,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,kBAAkB;CACnB;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;EACE,oCAAoC;MAChC,iCAAiC;UAC7B,mCAAmC;CAC5C;AACD;EACE,qCAAqC;MACjC,kCAAkC;UAC9B,0CAA0C;CACnD;AACD;EACE,qCAAqC;MACjC,yCAAyC;CAC9C;AACD;EACE,iCAAiC;MAC7B,8BAA8B;UAC1B,qCAAqC;CAC9C;AACD;EACE,oCAAoC;MAChC,iCAAiC;UAC7B,mCAAmC;CAC5C;AACD;EACE,qCAAqC;MACjC,kCAAkC;UAC9B,+BAA+B;CACxC;AACD;EACE,sCAAsC;MAClC,mCAAmC;UAC/B,gCAAgC;CACzC;AACD;EACE,wCAAwC;EACxC,yCAAyC;MACrC,sCAAsC;UAClC,kCAAkC;CAC3C;AACD;EACE,eAAe;EACf,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,mBAAmB;CACtB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ","file":"index.vue","sourcesContent":["\nbody {\n  background-color: #F4F8F9;\n  font-family: 'Open Sans', sans-serif;\n}\na,\na:visited,\na:active {\n  color: #0D79F2;\n}\ntextarea,\ninput {\n  display: block;\n  outline: none;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 10px;\n  border: 0;\n  width: 100%;\n  border-radius: 3px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  margin-top: 15px;\n  line-height: inherit;\n}\ntextarea::-webkit-input-placeholder,\n  input::-webkit-input-placeholder {\n    color: rgba(0, 0, 0, 0.25);\n}\ntextarea::-moz-placeholder,\n  input::-moz-placeholder {\n    color: rgba(0, 0, 0, 0.25);\n}\ntextarea::-ms-input-placeholder,\n  input::-ms-input-placeholder {\n    color: rgba(0, 0, 0, 0.25);\n}\ntextarea::placeholder,\n  input::placeholder {\n    color: rgba(0, 0, 0, 0.25);\n}\ntextarea:focus,\n  input:focus {\n    border-color: rgba(0, 0, 0, 0.25);\n}\n.card {\n  background-color: #fff;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n  border-top: 1px solid rgba(0, 0, 0, 0.15);\n}\n.button, button {\n  display: inline-block;\n  outline: 0;\n  border: 0;\n  margin-top: 0;\n  text-decoration: none;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border-radius: 5px;\n  -webkit-transition: all 200ms;\n  transition: all 200ms;\n  position: relative;\n  text-align: center;\n  cursor: pointer;\n  color: #fff !important;\n  background-color: #0D79F2;\n  line-height: 16px;\n  font-size: 16px;\n  padding: 12px 17px 13px;\n}\n.button.disabled, button.disabled {\n    pointer-events: none;\n    cursor: not-allowed;\n    opacity: 0.7;\n}\n.button:hover, button:hover {\n    background-color: #0b66cb;\n}\n.button:active, button:active {\n    color: #fff;\n    background-color: #0a5cb8;\n}\n.button.cta, button.cta {\n    border-bottom-color: #084991;\n}\n.button.cta:hover, button.cta:hover {\n      background-color: #2586f3;\n}\n.button.cta:active, button.cta:active {\n      background-color: #0D79F2;\n}\n.button.xlarge, button.xlarge {\n    line-height: 20px;\n    font-size: 20px;\n    padding: 16px 21px 17px;\n}\n.button.large, button.large {\n    line-height: 18px;\n    font-size: 18px;\n    padding: 14px 19px 15px;\n}\n.button.small, button.small {\n    line-height: 14px;\n    font-size: 14px;\n    padding: 10px 15px 11px;\n}\n.button.xsmall, button.xsmall {\n    line-height: 12px;\n    font-size: 12px;\n    padding: 8px 13px 9px;\n}\n.button.success, button.success {\n    color: #fff !important;\n    background-color: #26D97A;\n}\n.button.success:hover, button.success:hover {\n      background-color: #20b666;\n}\n.button.success:active, button.success:active {\n      color: #fff;\n      background-color: #1da55d;\n}\n.button.success.cta, button.success.cta {\n      border-bottom-color: #178249;\n}\n.button.success.cta:hover, button.success.cta:hover {\n        background-color: #3cdd87;\n}\n.button.success.cta:active, button.success.cta:active {\n        background-color: #26D97A;\n}\n.button.error, button.error {\n    color: #fff !important;\n    background-color: #F20D0D;\n}\n.button.error:hover, button.error:hover {\n      background-color: #cb0b0b;\n}\n.button.error:active, button.error:active {\n      color: #fff;\n      background-color: #b80a0a;\n}\n.button.error.cta, button.error.cta {\n      border-bottom-color: #910808;\n}\n.button.error.cta:hover, button.error.cta:hover {\n        background-color: #f32525;\n}\n.button.error.cta:active, button.error.cta:active {\n        background-color: #F20D0D;\n}\n.button.warning, button.warning {\n    color: #fff !important;\n    background-color: #F25E0D;\n}\n.button.warning:hover, button.warning:hover {\n      background-color: #cb4f0b;\n}\n.button.warning:active, button.warning:active {\n      color: #fff;\n      background-color: #b8470a;\n}\n.button.warning.cta, button.warning.cta {\n      border-bottom-color: #913808;\n}\n.button.warning.cta:hover, button.warning.cta:hover {\n        background-color: #f36e25;\n}\n.button.warning.cta:active, button.warning.cta:active {\n        background-color: #F25E0D;\n}\n.button.secondary, button.secondary {\n    color: #fff !important;\n    background-color: #CCCCCC;\n    color: #666 !important;\n}\n.button.secondary:hover, button.secondary:hover {\n      background-color: #b8b8b8;\n}\n.button.secondary:active, button.secondary:active {\n      color: #fff;\n      background-color: #adadad;\n}\n.button.secondary.cta, button.secondary.cta {\n      border-bottom-color: #999999;\n}\n.button.secondary.cta:hover, button.secondary.cta:hover {\n        background-color: #d9d9d9;\n}\n.button.secondary.cta:active, button.secondary.cta:active {\n        background-color: #CCCCCC;\n}\n.button.lyft, button.lyft {\n    color: #fff !important;\n    background-color: #eb21b8;\n}\n.button.lyft:hover, button.lyft:hover {\n      background-color: #d013a1;\n}\n.button.lyft:active, button.lyft:active {\n      color: #fff;\n      background-color: #be1192;\n}\n.button.lyft.cta, button.lyft.cta {\n      border-bottom-color: #980e75;\n}\n.button.lyft.cta:hover, button.lyft.cta:hover {\n        background-color: #ed38bf;\n}\n.button.lyft.cta:active, button.lyft.cta:active {\n        background-color: #eb21b8;\n}\n.button.cta, button.cta {\n    font-weight: 700;\n    border-bottom-width: 4px;\n    border-bottom-style: solid;\n    text-transform: uppercase;\n}\n.button.block, button.block {\n    width: 100%;\n    text-align: center;\n}\n.here-pin.car {\n  width: 60px;\n  height: 60px;\n}\n.here-pin.car img {\n    position: relative;\n    top: -30px;\n    left: -30px;\n}\n.H_ib.car-info {\n  margin-left: 90px;\n}\n.H_ib.car-info .H_ib_tail {\n    margin-left: -217px;\n}\n.here-info-window.car {\n  width: 420px;\n  text-align: center;\n  line-height: 1;\n  font-family: Roboto, Arial, sans-serif;\n  padding: 15px 0 5px;\n}\n.here-info-window.car img {\n    width: 70px;\n    height: 70px;\n    background-color: #ddd;\n    margin: 0 auto;\n    border-radius: 70px;\n    -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.5);\n            box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.5);\n    border: 1px solid rgba(0, 0, 0, 0.25);\n}\n.here-info-window.car .sub-text {\n    font-size: 12px;\n    color: #777;\n    word-spacing: 2px;\n    font-weight: 500;\n}\n.here-info-window.car .left {\n    width: 50%;\n    display: inline-block;\n    vertical-align: top;\n}\n.here-info-window.car .left a {\n      display: block;\n      margin-top: 5px;\n      font-size: 14px;\n      font-weight: 700;\n      text-transform: uppercase;\n}\n.here-info-window.car .right {\n    width: 49%;\n    display: inline-block;\n    vertical-align: top;\n}\n.here-info-window.car .right .model {\n      display: block;\n      margin-top: 5px;\n      font-size: 14px;\n      font-weight: 700;\n      text-transform: uppercase;\n}\n.here-info-window.car .button {\n    margin-top: 15px;\n}\n.here-info-window.pickup, .here-info-window.dropoff {\n  width: 280px;\n  font-size: 12px;\n  margin-left: 3px;\n}\n.here-info-window.pickup .location, .here-info-window.dropoff .location {\n    line-height: 1.6;\n}\n.here-info-window.pickup .eta, .here-info-window.dropoff .eta {\n    border-top: 1px solid #eaeaea;\n}\n.here-info-window.extra {\n  width: 210px;\n  font-family: Roboto, Arial, sans-serif;\n  font-size: 13px;\n  line-height: 1.4;\n}\n.here-info-window.extra label {\n    color: #999;\n}\n.here-info-window.extra span {\n    color: #555;\n    font-weight: 600;\n}\n.H_driver-info .H_ib_body {\n  right: -85px;\n}\n.H_driver-info .H_ib_tail {\n  display: none;\n}\n.H_driver-info .info-container {\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 500;\n  width: 380px;\n  position: relative;\n}\n.H_driver-info .info-container .upcoming-rsvp {\n    text-align: center;\n    font-size: 13px;\n    margin: 0 10px 10px;\n    position: relative;\n    top: 5px;\n}\n.H_driver-info .info-container .driver-info {\n    width: 170px;\n    float: left;\n    margin-left: 20px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n.H_driver-info .info-container .driver-info > * {\n      display: block;\n      text-align: center;\n}\n.H_driver-info .info-container .driver-info a {\n      text-transform: uppercase;\n      font-weight: 700;\n}\n.H_driver-info .info-container .driver-info span {\n      line-height: 1;\n      font-size: 12px;\n      margin-bottom: 10px;\n      color: #555;\n}\n.H_driver-info .info-container .vehicle-info {\n    width: 170px;\n    float: left;\n    margin-left: 20px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n.H_driver-info .info-container .vehicle-info > * {\n      display: block;\n      text-align: center;\n}\n.H_driver-info .info-container .vehicle-info strong {\n      text-transform: uppercase;\n      font-weight: 700;\n}\n.H_driver-info .info-container .vehicle-info span {\n      line-height: 1;\n      font-size: 12px;\n      margin-bottom: 10px;\n      color: #555;\n}\n.H_driver-info .info-container .eta-to-dropoff {\n    margin: 0 20px 10px;\n    text-align: center;\n}\n.H_driver-info .info-container .eta-to-dropoff label {\n      color: #999;\n      font-size: 13px;\n}\n.H_driver-info .info-container .eta-to-dropoff span {\n      display: inline-block;\n      margin-left: 10px;\n      font-weight: 900;\n}\n.H_driver-info .info-container .call-button {\n    margin: 0 20px 5px;\n    width: 360px;\n    display: none;\n}\n.H_driver-info .info-container img {\n    width: 100px;\n    height: 100px;\n    margin: 0 auto 10px;\n    border-radius: 100px;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);\n}\n.H_driver-info .info-container .prvNxt {\n    position: absolute;\n    top: 80px;\n    font-size: 21px;\n    color: #939393;\n    cursor: pointer;\n}\n.H_driver-info .info-container .prvNxt.prev {\n      left: 0;\n}\n.H_driver-info .info-container .prvNxt.next {\n      right: -20px;\n}\n.H_driver-info .info-container .prvNxt.disabled {\n      opacity: .3;\n      cursor: default;\n}\n.H_ctl.H_el.H_zoom.H_grp, .H_ctl.H_el.H_scalebar, .H_ctl.H_el {\n  display: none;\n}\n.H_copyright {\n  display: none;\n}\n.H_logo {\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  margin: -5px 0 0 10px !important;\n}\n.hide-logo .H_logo {\n  position: absolute !important;\n  right: 15px !important;\n}\n.here-marker.car-icon {\n  background-image: url(\"https://s3-us-west-2.amazonaws.com/mobile-consumer-app/maps/car-sprite.png\");\n  width: 60px;\n  height: 60px;\n}\n.poi-marker {\n  position: absolute;\n  top: -9px;\n  left: -9px;\n  width: 18px;\n  height: 18px;\n  background-color: #333;\n}\n.poi-marker:after {\n    content: '';\n    position: absolute;\n    top: 6px;\n    left: 6px;\n    width: 6px;\n    height: 6px;\n    background-color: #fff;\n    border-radius: 50px;\n}\n.poi-marker.pickup {\n    border-radius: 50px;\n}\n.poi-marker.dropoff {\n    border-radius: 3px;\n}\n.poi-marker.extra-stop {\n    border-radius: 6px;\n}\n.poi-marker.terminal {\n    border-radius: 50px;\n    background-color: #333;\n}\n.global-modal {\n  display: table;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 999;\n  background-color: rgba(0, 0, 0, 0.6);\n}\n.global-modal-content {\n  display: table-cell;\n  vertical-align: middle;\n}\n.fade-enter-active, .fade-leave-active {\n  -webkit-transition: opacity 250ms;\n  transition: opacity 250ms;\n}\n.fade-enter, .fade-leave-to {\n  opacity: 0;\n}\n.lr2-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.05s ease;\n  transition: all 0.05s ease;\n}\n.lr2-modal .lr2-box {\n    background: #fff;\n    padding: 20px;\n    border-radius: 6px;\n    -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n    text-align: center;\n    min-width: 200px;\n    -webkit-transition: all 0.1s ease;\n    transition: all 0.1s ease;\n}\n.lr2-modal.hide {\n    z-index: -1;\n    opacity: 0;\n}\n.lr2-modal.hide .lr2-box {\n      -webkit-transform: scale(90%) translateY(30px);\n              transform: scale(90%) translateY(30px);\n}\n.rc-1 {\n  width: 35px !important;\n}\n.rc-2 {\n  width: 30px !important;\n}\n.rc-3 {\n  width: 30px !important;\n}\n.rc-4 {\n  width: 55px !important;\n}\n.rc-5 {\n  width: 90px !important;\n}\n.rc-6 {\n  width: 90px !important;\n}\n.rc-7 {\n  width: 160px !important;\n}\n.rc-8 {\n  width: 160px !important;\n}\n.rc-9 {\n  width: 100px !important;\n  padding: 0 !important;\n}\n.rc-10 {\n  width: 75px !important;\n}\n.rc-11 {\n  width: 65px !important;\n}\n.rc-12 {\n  width: 75px !important;\n}\n.rc-13 {\n  width: 70px !important;\n}\n.rc-14 {\n  width: 65px !important;\n}\n.rc-15 {\n  width: 30px !important;\n  padding: 0 !important;\n}\n.rc-16 {\n  width: 70px !important;\n}\n.rc-17 {\n  width: 44px !important;\n}\n.rc-18 {\n  width: 42px !important;\n}\n.rc-19 {\n  width: 80px !important;\n}\n.iti-flag {\n  background-image: url(\"https://s3-us-west-2.amazonaws.com/mobile-consumer-app/flags.png\");\n  margin-right: 3px;\n}\n@media only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx) {\n.iti-flag {\n    background-image: url(\"https://s3-us-west-2.amazonaws.com/mobile-consumer-app/flags@2x.png\");\n    margin-right: 3px;\n}\n}\n.iti-flag {\n  width: 20px;\n}\n.iti-flag.be {\n  width: 18px;\n}\n.iti-flag.ch {\n  width: 15px;\n}\n.iti-flag.mc {\n  width: 19px;\n}\n.iti-flag.ne {\n  width: 18px;\n}\n.iti-flag.np {\n  width: 13px;\n}\n.iti-flag.va {\n  width: 15px;\n}\n@media only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx) {\n.iti-flag {\n    background-size: 5630px 15px;\n}\n}\n.iti-flag.ac {\n  height: 10px;\n  background-position: 0px 0px;\n}\n.iti-flag.ad {\n  height: 14px;\n  background-position: -22px 0px;\n}\n.iti-flag.ae {\n  height: 10px;\n  background-position: -44px 0px;\n}\n.iti-flag.af {\n  height: 14px;\n  background-position: -66px 0px;\n}\n.iti-flag.ag {\n  height: 14px;\n  background-position: -88px 0px;\n}\n.iti-flag.ai {\n  height: 10px;\n  background-position: -110px 0px;\n}\n.iti-flag.al {\n  height: 15px;\n  background-position: -132px 0px;\n}\n.iti-flag.am {\n  height: 10px;\n  background-position: -154px 0px;\n}\n.iti-flag.ao {\n  height: 14px;\n  background-position: -176px 0px;\n}\n.iti-flag.aq {\n  height: 14px;\n  background-position: -198px 0px;\n}\n.iti-flag.ar {\n  height: 13px;\n  background-position: -220px 0px;\n}\n.iti-flag.as {\n  height: 10px;\n  background-position: -242px 0px;\n}\n.iti-flag.at {\n  height: 14px;\n  background-position: -264px 0px;\n}\n.iti-flag.au {\n  height: 10px;\n  background-position: -286px 0px;\n}\n.iti-flag.aw {\n  height: 14px;\n  background-position: -308px 0px;\n}\n.iti-flag.ax {\n  height: 13px;\n  background-position: -330px 0px;\n}\n.iti-flag.az {\n  height: 10px;\n  background-position: -352px 0px;\n}\n.iti-flag.ba {\n  height: 10px;\n  background-position: -374px 0px;\n}\n.iti-flag.bb {\n  height: 14px;\n  background-position: -396px 0px;\n}\n.iti-flag.bd {\n  height: 12px;\n  background-position: -418px 0px;\n}\n.iti-flag.be {\n  height: 15px;\n  background-position: -440px 0px;\n}\n.iti-flag.bf {\n  height: 14px;\n  background-position: -460px 0px;\n}\n.iti-flag.bg {\n  height: 12px;\n  background-position: -482px 0px;\n}\n.iti-flag.bh {\n  height: 12px;\n  background-position: -504px 0px;\n}\n.iti-flag.bi {\n  height: 12px;\n  background-position: -526px 0px;\n}\n.iti-flag.bj {\n  height: 14px;\n  background-position: -548px 0px;\n}\n.iti-flag.bl {\n  height: 14px;\n  background-position: -570px 0px;\n}\n.iti-flag.bm {\n  height: 10px;\n  background-position: -592px 0px;\n}\n.iti-flag.bn {\n  height: 10px;\n  background-position: -614px 0px;\n}\n.iti-flag.bo {\n  height: 14px;\n  background-position: -636px 0px;\n}\n.iti-flag.bq {\n  height: 14px;\n  background-position: -658px 0px;\n}\n.iti-flag.br {\n  height: 14px;\n  background-position: -680px 0px;\n}\n.iti-flag.bs {\n  height: 10px;\n  background-position: -702px 0px;\n}\n.iti-flag.bt {\n  height: 14px;\n  background-position: -724px 0px;\n}\n.iti-flag.bv {\n  height: 15px;\n  background-position: -746px 0px;\n}\n.iti-flag.bw {\n  height: 14px;\n  background-position: -768px 0px;\n}\n.iti-flag.by {\n  height: 10px;\n  background-position: -790px 0px;\n}\n.iti-flag.bz {\n  height: 14px;\n  background-position: -812px 0px;\n}\n.iti-flag.ca {\n  height: 10px;\n  background-position: -834px 0px;\n}\n.iti-flag.cc {\n  height: 10px;\n  background-position: -856px 0px;\n}\n.iti-flag.cd {\n  height: 15px;\n  background-position: -878px 0px;\n}\n.iti-flag.cf {\n  height: 14px;\n  background-position: -900px 0px;\n}\n.iti-flag.cg {\n  height: 14px;\n  background-position: -922px 0px;\n}\n.iti-flag.ch {\n  height: 15px;\n  background-position: -944px 0px;\n}\n.iti-flag.ci {\n  height: 14px;\n  background-position: -961px 0px;\n}\n.iti-flag.ck {\n  height: 10px;\n  background-position: -983px 0px;\n}\n.iti-flag.cl {\n  height: 14px;\n  background-position: -1005px 0px;\n}\n.iti-flag.cm {\n  height: 14px;\n  background-position: -1027px 0px;\n}\n.iti-flag.cn {\n  height: 14px;\n  background-position: -1049px 0px;\n}\n.iti-flag.co {\n  height: 14px;\n  background-position: -1071px 0px;\n}\n.iti-flag.cp {\n  height: 14px;\n  background-position: -1093px 0px;\n}\n.iti-flag.cr {\n  height: 12px;\n  background-position: -1115px 0px;\n}\n.iti-flag.cu {\n  height: 10px;\n  background-position: -1137px 0px;\n}\n.iti-flag.cv {\n  height: 12px;\n  background-position: -1159px 0px;\n}\n.iti-flag.cw {\n  height: 14px;\n  background-position: -1181px 0px;\n}\n.iti-flag.cx {\n  height: 10px;\n  background-position: -1203px 0px;\n}\n.iti-flag.cy {\n  height: 13px;\n  background-position: -1225px 0px;\n}\n.iti-flag.cz {\n  height: 14px;\n  background-position: -1247px 0px;\n}\n.iti-flag.de {\n  height: 12px;\n  background-position: -1269px 0px;\n}\n.iti-flag.dg {\n  height: 10px;\n  background-position: -1291px 0px;\n}\n.iti-flag.dj {\n  height: 14px;\n  background-position: -1313px 0px;\n}\n.iti-flag.dk {\n  height: 15px;\n  background-position: -1335px 0px;\n}\n.iti-flag.dm {\n  height: 10px;\n  background-position: -1357px 0px;\n}\n.iti-flag.do {\n  height: 13px;\n  background-position: -1379px 0px;\n}\n.iti-flag.dz {\n  height: 14px;\n  background-position: -1401px 0px;\n}\n.iti-flag.ea {\n  height: 14px;\n  background-position: -1423px 0px;\n}\n.iti-flag.ec {\n  height: 14px;\n  background-position: -1445px 0px;\n}\n.iti-flag.ee {\n  height: 13px;\n  background-position: -1467px 0px;\n}\n.iti-flag.eg {\n  height: 14px;\n  background-position: -1489px 0px;\n}\n.iti-flag.eh {\n  height: 10px;\n  background-position: -1511px 0px;\n}\n.iti-flag.er {\n  height: 10px;\n  background-position: -1533px 0px;\n}\n.iti-flag.es {\n  height: 14px;\n  background-position: -1555px 0px;\n}\n.iti-flag.et {\n  height: 10px;\n  background-position: -1577px 0px;\n}\n.iti-flag.eu {\n  height: 14px;\n  background-position: -1599px 0px;\n}\n.iti-flag.fi {\n  height: 12px;\n  background-position: -1621px 0px;\n}\n.iti-flag.fj {\n  height: 10px;\n  background-position: -1643px 0px;\n}\n.iti-flag.fk {\n  height: 10px;\n  background-position: -1665px 0px;\n}\n.iti-flag.fm {\n  height: 11px;\n  background-position: -1687px 0px;\n}\n.iti-flag.fo {\n  height: 15px;\n  background-position: -1709px 0px;\n}\n.iti-flag.fr {\n  height: 14px;\n  background-position: -1731px 0px;\n}\n.iti-flag.ga {\n  height: 15px;\n  background-position: -1753px 0px;\n}\n.iti-flag.gb {\n  height: 10px;\n  background-position: -1775px 0px;\n}\n.iti-flag.gd {\n  height: 12px;\n  background-position: -1797px 0px;\n}\n.iti-flag.ge {\n  height: 14px;\n  background-position: -1819px 0px;\n}\n.iti-flag.gf {\n  height: 14px;\n  background-position: -1841px 0px;\n}\n.iti-flag.gg {\n  height: 14px;\n  background-position: -1863px 0px;\n}\n.iti-flag.gh {\n  height: 14px;\n  background-position: -1885px 0px;\n}\n.iti-flag.gi {\n  height: 10px;\n  background-position: -1907px 0px;\n}\n.iti-flag.gl {\n  height: 14px;\n  background-position: -1929px 0px;\n}\n.iti-flag.gm {\n  height: 14px;\n  background-position: -1951px 0px;\n}\n.iti-flag.gn {\n  height: 14px;\n  background-position: -1973px 0px;\n}\n.iti-flag.gp {\n  height: 14px;\n  background-position: -1995px 0px;\n}\n.iti-flag.gq {\n  height: 14px;\n  background-position: -2017px 0px;\n}\n.iti-flag.gr {\n  height: 14px;\n  background-position: -2039px 0px;\n}\n.iti-flag.gs {\n  height: 10px;\n  background-position: -2061px 0px;\n}\n.iti-flag.gt {\n  height: 13px;\n  background-position: -2083px 0px;\n}\n.iti-flag.gu {\n  height: 11px;\n  background-position: -2105px 0px;\n}\n.iti-flag.gw {\n  height: 10px;\n  background-position: -2127px 0px;\n}\n.iti-flag.gy {\n  height: 12px;\n  background-position: -2149px 0px;\n}\n.iti-flag.hk {\n  height: 14px;\n  background-position: -2171px 0px;\n}\n.iti-flag.hm {\n  height: 10px;\n  background-position: -2193px 0px;\n}\n.iti-flag.hn {\n  height: 10px;\n  background-position: -2215px 0px;\n}\n.iti-flag.hr {\n  height: 10px;\n  background-position: -2237px 0px;\n}\n.iti-flag.ht {\n  height: 12px;\n  background-position: -2259px 0px;\n}\n.iti-flag.hu {\n  height: 10px;\n  background-position: -2281px 0px;\n}\n.iti-flag.ic {\n  height: 14px;\n  background-position: -2303px 0px;\n}\n.iti-flag.id {\n  height: 14px;\n  background-position: -2325px 0px;\n}\n.iti-flag.ie {\n  height: 10px;\n  background-position: -2347px 0px;\n}\n.iti-flag.il {\n  height: 15px;\n  background-position: -2369px 0px;\n}\n.iti-flag.im {\n  height: 10px;\n  background-position: -2391px 0px;\n}\n.iti-flag.in {\n  height: 14px;\n  background-position: -2413px 0px;\n}\n.iti-flag.io {\n  height: 10px;\n  background-position: -2435px 0px;\n}\n.iti-flag.iq {\n  height: 14px;\n  background-position: -2457px 0px;\n}\n.iti-flag.ir {\n  height: 12px;\n  background-position: -2479px 0px;\n}\n.iti-flag.is {\n  height: 15px;\n  background-position: -2501px 0px;\n}\n.iti-flag.it {\n  height: 14px;\n  background-position: -2523px 0px;\n}\n.iti-flag.je {\n  height: 12px;\n  background-position: -2545px 0px;\n}\n.iti-flag.jm {\n  height: 10px;\n  background-position: -2567px 0px;\n}\n.iti-flag.jo {\n  height: 10px;\n  background-position: -2589px 0px;\n}\n.iti-flag.jp {\n  height: 14px;\n  background-position: -2611px 0px;\n}\n.iti-flag.ke {\n  height: 14px;\n  background-position: -2633px 0px;\n}\n.iti-flag.kg {\n  height: 12px;\n  background-position: -2655px 0px;\n}\n.iti-flag.kh {\n  height: 13px;\n  background-position: -2677px 0px;\n}\n.iti-flag.ki {\n  height: 10px;\n  background-position: -2699px 0px;\n}\n.iti-flag.km {\n  height: 12px;\n  background-position: -2721px 0px;\n}\n.iti-flag.kn {\n  height: 14px;\n  background-position: -2743px 0px;\n}\n.iti-flag.kp {\n  height: 10px;\n  background-position: -2765px 0px;\n}\n.iti-flag.kr {\n  height: 14px;\n  background-position: -2787px 0px;\n}\n.iti-flag.kw {\n  height: 10px;\n  background-position: -2809px 0px;\n}\n.iti-flag.ky {\n  height: 10px;\n  background-position: -2831px 0px;\n}\n.iti-flag.kz {\n  height: 10px;\n  background-position: -2853px 0px;\n}\n.iti-flag.la {\n  height: 14px;\n  background-position: -2875px 0px;\n}\n.iti-flag.lb {\n  height: 14px;\n  background-position: -2897px 0px;\n}\n.iti-flag.lc {\n  height: 10px;\n  background-position: -2919px 0px;\n}\n.iti-flag.li {\n  height: 12px;\n  background-position: -2941px 0px;\n}\n.iti-flag.lk {\n  height: 10px;\n  background-position: -2963px 0px;\n}\n.iti-flag.lr {\n  height: 11px;\n  background-position: -2985px 0px;\n}\n.iti-flag.ls {\n  height: 14px;\n  background-position: -3007px 0px;\n}\n.iti-flag.lt {\n  height: 12px;\n  background-position: -3029px 0px;\n}\n.iti-flag.lu {\n  height: 12px;\n  background-position: -3051px 0px;\n}\n.iti-flag.lv {\n  height: 10px;\n  background-position: -3073px 0px;\n}\n.iti-flag.ly {\n  height: 10px;\n  background-position: -3095px 0px;\n}\n.iti-flag.ma {\n  height: 14px;\n  background-position: -3117px 0px;\n}\n.iti-flag.mc {\n  height: 15px;\n  background-position: -3139px 0px;\n}\n.iti-flag.md {\n  height: 10px;\n  background-position: -3160px 0px;\n}\n.iti-flag.me {\n  height: 10px;\n  background-position: -3182px 0px;\n}\n.iti-flag.mf {\n  height: 14px;\n  background-position: -3204px 0px;\n}\n.iti-flag.mg {\n  height: 14px;\n  background-position: -3226px 0px;\n}\n.iti-flag.mh {\n  height: 11px;\n  background-position: -3248px 0px;\n}\n.iti-flag.mk {\n  height: 10px;\n  background-position: -3270px 0px;\n}\n.iti-flag.ml {\n  height: 14px;\n  background-position: -3292px 0px;\n}\n.iti-flag.mm {\n  height: 14px;\n  background-position: -3314px 0px;\n}\n.iti-flag.mn {\n  height: 10px;\n  background-position: -3336px 0px;\n}\n.iti-flag.mo {\n  height: 14px;\n  background-position: -3358px 0px;\n}\n.iti-flag.mp {\n  height: 10px;\n  background-position: -3380px 0px;\n}\n.iti-flag.mq {\n  height: 14px;\n  background-position: -3402px 0px;\n}\n.iti-flag.mr {\n  height: 14px;\n  background-position: -3424px 0px;\n}\n.iti-flag.ms {\n  height: 10px;\n  background-position: -3446px 0px;\n}\n.iti-flag.mt {\n  height: 14px;\n  background-position: -3468px 0px;\n}\n.iti-flag.mu {\n  height: 14px;\n  background-position: -3490px 0px;\n}\n.iti-flag.mv {\n  height: 14px;\n  background-position: -3512px 0px;\n}\n.iti-flag.mw {\n  height: 14px;\n  background-position: -3534px 0px;\n}\n.iti-flag.mx {\n  height: 12px;\n  background-position: -3556px 0px;\n}\n.iti-flag.my {\n  height: 10px;\n  background-position: -3578px 0px;\n}\n.iti-flag.mz {\n  height: 14px;\n  background-position: -3600px 0px;\n}\n.iti-flag.na {\n  height: 14px;\n  background-position: -3622px 0px;\n}\n.iti-flag.nc {\n  height: 10px;\n  background-position: -3644px 0px;\n}\n.iti-flag.ne {\n  height: 15px;\n  background-position: -3666px 0px;\n}\n.iti-flag.nf {\n  height: 10px;\n  background-position: -3686px 0px;\n}\n.iti-flag.ng {\n  height: 10px;\n  background-position: -3708px 0px;\n}\n.iti-flag.ni {\n  height: 12px;\n  background-position: -3730px 0px;\n}\n.iti-flag.nl {\n  height: 14px;\n  background-position: -3752px 0px;\n}\n.iti-flag.no {\n  height: 15px;\n  background-position: -3774px 0px;\n}\n.iti-flag.np {\n  height: 15px;\n  background-position: -3796px 0px;\n}\n.iti-flag.nr {\n  height: 10px;\n  background-position: -3811px 0px;\n}\n.iti-flag.nu {\n  height: 10px;\n  background-position: -3833px 0px;\n}\n.iti-flag.nz {\n  height: 10px;\n  background-position: -3855px 0px;\n}\n.iti-flag.om {\n  height: 10px;\n  background-position: -3877px 0px;\n}\n.iti-flag.pa {\n  height: 14px;\n  background-position: -3899px 0px;\n}\n.iti-flag.pe {\n  height: 14px;\n  background-position: -3921px 0px;\n}\n.iti-flag.pf {\n  height: 14px;\n  background-position: -3943px 0px;\n}\n.iti-flag.pg {\n  height: 15px;\n  background-position: -3965px 0px;\n}\n.iti-flag.ph {\n  height: 10px;\n  background-position: -3987px 0px;\n}\n.iti-flag.pk {\n  height: 14px;\n  background-position: -4009px 0px;\n}\n.iti-flag.pl {\n  height: 13px;\n  background-position: -4031px 0px;\n}\n.iti-flag.pm {\n  height: 14px;\n  background-position: -4053px 0px;\n}\n.iti-flag.pn {\n  height: 10px;\n  background-position: -4075px 0px;\n}\n.iti-flag.pr {\n  height: 14px;\n  background-position: -4097px 0px;\n}\n.iti-flag.ps {\n  height: 10px;\n  background-position: -4119px 0px;\n}\n.iti-flag.pt {\n  height: 14px;\n  background-position: -4141px 0px;\n}\n.iti-flag.pw {\n  height: 13px;\n  background-position: -4163px 0px;\n}\n.iti-flag.py {\n  height: 11px;\n  background-position: -4185px 0px;\n}\n.iti-flag.qa {\n  height: 8px;\n  background-position: -4207px 0px;\n}\n.iti-flag.re {\n  height: 14px;\n  background-position: -4229px 0px;\n}\n.iti-flag.ro {\n  height: 14px;\n  background-position: -4251px 0px;\n}\n.iti-flag.rs {\n  height: 14px;\n  background-position: -4273px 0px;\n}\n.iti-flag.ru {\n  height: 14px;\n  background-position: -4295px 0px;\n}\n.iti-flag.rw {\n  height: 14px;\n  background-position: -4317px 0px;\n}\n.iti-flag.sa {\n  height: 14px;\n  background-position: -4339px 0px;\n}\n.iti-flag.sb {\n  height: 10px;\n  background-position: -4361px 0px;\n}\n.iti-flag.sc {\n  height: 10px;\n  background-position: -4383px 0px;\n}\n.iti-flag.sd {\n  height: 10px;\n  background-position: -4405px 0px;\n}\n.iti-flag.se {\n  height: 13px;\n  background-position: -4427px 0px;\n}\n.iti-flag.sg {\n  height: 14px;\n  background-position: -4449px 0px;\n}\n.iti-flag.sh {\n  height: 10px;\n  background-position: -4471px 0px;\n}\n.iti-flag.si {\n  height: 10px;\n  background-position: -4493px 0px;\n}\n.iti-flag.sj {\n  height: 15px;\n  background-position: -4515px 0px;\n}\n.iti-flag.sk {\n  height: 14px;\n  background-position: -4537px 0px;\n}\n.iti-flag.sl {\n  height: 14px;\n  background-position: -4559px 0px;\n}\n.iti-flag.sm {\n  height: 15px;\n  background-position: -4581px 0px;\n}\n.iti-flag.sn {\n  height: 14px;\n  background-position: -4603px 0px;\n}\n.iti-flag.so {\n  height: 14px;\n  background-position: -4625px 0px;\n}\n.iti-flag.sr {\n  height: 14px;\n  background-position: -4647px 0px;\n}\n.iti-flag.ss {\n  height: 10px;\n  background-position: -4669px 0px;\n}\n.iti-flag.st {\n  height: 10px;\n  background-position: -4691px 0px;\n}\n.iti-flag.sv {\n  height: 12px;\n  background-position: -4713px 0px;\n}\n.iti-flag.sx {\n  height: 14px;\n  background-position: -4735px 0px;\n}\n.iti-flag.sy {\n  height: 14px;\n  background-position: -4757px 0px;\n}\n.iti-flag.sz {\n  height: 14px;\n  background-position: -4779px 0px;\n}\n.iti-flag.ta {\n  height: 10px;\n  background-position: -4801px 0px;\n}\n.iti-flag.tc {\n  height: 10px;\n  background-position: -4823px 0px;\n}\n.iti-flag.td {\n  height: 14px;\n  background-position: -4845px 0px;\n}\n.iti-flag.tf {\n  height: 14px;\n  background-position: -4867px 0px;\n}\n.iti-flag.tg {\n  height: 13px;\n  background-position: -4889px 0px;\n}\n.iti-flag.th {\n  height: 14px;\n  background-position: -4911px 0px;\n}\n.iti-flag.tj {\n  height: 10px;\n  background-position: -4933px 0px;\n}\n.iti-flag.tk {\n  height: 10px;\n  background-position: -4955px 0px;\n}\n.iti-flag.tl {\n  height: 10px;\n  background-position: -4977px 0px;\n}\n.iti-flag.tm {\n  height: 14px;\n  background-position: -4999px 0px;\n}\n.iti-flag.tn {\n  height: 14px;\n  background-position: -5021px 0px;\n}\n.iti-flag.to {\n  height: 10px;\n  background-position: -5043px 0px;\n}\n.iti-flag.tr {\n  height: 14px;\n  background-position: -5065px 0px;\n}\n.iti-flag.tt {\n  height: 12px;\n  background-position: -5087px 0px;\n}\n.iti-flag.tv {\n  height: 10px;\n  background-position: -5109px 0px;\n}\n.iti-flag.tw {\n  height: 14px;\n  background-position: -5131px 0px;\n}\n.iti-flag.tz {\n  height: 14px;\n  background-position: -5153px 0px;\n}\n.iti-flag.ua {\n  height: 14px;\n  background-position: -5175px 0px;\n}\n.iti-flag.ug {\n  height: 14px;\n  background-position: -5197px 0px;\n}\n.iti-flag.um {\n  height: 11px;\n  background-position: -5219px 0px;\n}\n.iti-flag.us {\n  height: 11px;\n  background-position: -5241px 0px;\n}\n.iti-flag.uy {\n  height: 14px;\n  background-position: -5263px 0px;\n}\n.iti-flag.uz {\n  height: 10px;\n  background-position: -5285px 0px;\n}\n.iti-flag.va {\n  height: 15px;\n  background-position: -5307px 0px;\n}\n.iti-flag.vc {\n  height: 14px;\n  background-position: -5324px 0px;\n}\n.iti-flag.ve {\n  height: 14px;\n  background-position: -5346px 0px;\n}\n.iti-flag.vg {\n  height: 10px;\n  background-position: -5368px 0px;\n}\n.iti-flag.vi {\n  height: 14px;\n  background-position: -5390px 0px;\n}\n.iti-flag.vn {\n  height: 14px;\n  background-position: -5412px 0px;\n}\n.iti-flag.vu {\n  height: 12px;\n  background-position: -5434px 0px;\n}\n.iti-flag.wf {\n  height: 14px;\n  background-position: -5456px 0px;\n}\n.iti-flag.ws {\n  height: 10px;\n  background-position: -5478px 0px;\n}\n.iti-flag.xk {\n  height: 15px;\n  background-position: -5500px 0px;\n}\n.iti-flag.ye {\n  height: 14px;\n  background-position: -5522px 0px;\n}\n.iti-flag.yt {\n  height: 14px;\n  background-position: -5544px 0px;\n}\n.iti-flag.za {\n  height: 14px;\n  background-position: -5566px 0px;\n}\n.iti-flag.zm {\n  height: 14px;\n  background-position: -5588px 0px;\n}\n.iti-flag.zw {\n  height: 10px;\n  background-position: -5610px 0px;\n}\n.iti-flag {\n  width: 20px;\n  height: 15px;\n  -webkit-box-shadow: 0px 0px 1px 0px #888;\n          box-shadow: 0px 0px 1px 0px #888;\n  background-color: #DBDBDB;\n  background-position: 20px 0;\n}\n.iti-flag.np {\n  background-color: transparent;\n}\n.atwho-view {\n  bottom: auto;\n  top: 30px;\n  font-size: 14px;\n  border-radius: 3px;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n}\n.tribute-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: auto;\n  max-height: 300px;\n  max-width: 500px;\n  overflow: auto;\n  display: block;\n  z-index: 999999;\n}\n.tribute-container ul {\n  margin: 0;\n  margin-top: 2px;\n  padding: 0;\n  list-style: none;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-bottom: 0;\n  border-radius: 3px;\n  font-size: 14px;\n  background: #fff;\n}\n.tribute-container li {\n  padding: 5px 5px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n  cursor: pointer;\n}\n.tribute-container li.highlight, .tribute-container li:hover {\n  background: #eee;\n}\n.tribute-container li span {\n  font-weight: bold;\n}\n.tribute-container li.no-match {\n  cursor: default;\n}\n.tribute-container .menu-highlighted {\n  font-weight: bold;\n}\n.mention, .atwho-inserted {\n  color: #0D79F2;\n  font-weight: 700;\n}\n.vdp-datepicker.datepicker.left-side .vdp-datepicker__calendar {\n  right: 0;\n}\n.vdp-datepicker.datepicker input {\n  margin-top: 0 !important;\n}\n.vdp-datepicker.datepicker.has-error input {\n  border-color: #f20d0d !important;\n}\n.vdp-datepicker.datepicker.inline input {\n  border-color: #767676;\n}\n.vdp-datepicker.datepicker .vdp-datepicker__calendar-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 21px;\n  color: #ccc;\n}\n.vdp-datepicker.datepicker input:disabled {\n  background: #eee;\n}\n.vdp-datepicker.datepicker.custom-pa-availability input {\n  padding: 5px 10px;\n}\n.vdp-datepicker.datepicker input {\n  margin: 5px 0 0 !important;\n  border: 1px solid rgba(0, 0, 0, 0.15) !important;\n}\n.datepicker-empty {\n  border: 1px solid #f33a27 !important;\n}\n.datepicker.small input {\n  height: 35px;\n}\n.vdp-datepicker.geofence-datepicker input {\n  margin-top: 0 !important;\n  margin: 0 auto;\n  width: 121px;\n  padding: 5px;\n  font-size: 13px;\n}\n.mx-datepicker.cons-datepicker {\n  width: 100% !important;\n}\n.mx-datepicker.cons-datepicker .mx-input-wrapper {\n    width: 100% !important;\n}\n.mx-datepicker.cons-datepicker .mx-input {\n    margin: 5px 0 0;\n    color: #333;\n    display: block;\n    outline: none;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    padding: 10px;\n    border: 0;\n    width: 100%;\n    border-radius: 3px;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    line-height: 1.5;\n    font-size: 16px;\n    height: auto;\n    font-family: \"Open Sans\", sans-serif;\n}\n.mx-datepicker.cons-datepicker .mx-input-append {\n    display: none;\n}\n.overlayColor {\n  width: 100% !important;\n}\n.overlayColor .vc-ps-saturation-wrap, .overlayColor .vc-ps-hue-wrap {\n    height: 200px;\n}\n.overlayColor .vc-ps-actions .vc-ps-ac-btn {\n    display: none;\n}\n.overlayColor .vc-input__input {\n    margin-top: 5px;\n}\n.servicearea-date-input {\n  width: 150px !important;\n  margin-top: 0 !important;\n  padding: 5px !important;\n  font-size: 13px !important;\n}\n.sectorfilter-dateinput {\n  margin-top: 0 !important;\n  font-size: 14px !important;\n  padding: 7px 7px !important;\n}\n.sectorfilter-calendar {\n  font-size: 14px !important;\n  right: 0;\n}\n.drivershift-dateinput {\n  margin-top: 0 !important;\n  font-size: 14px !important;\n  padding: 7px 7px !important;\n}\n.drivershift-calendar {\n  font-size: 14px !important;\n}\n.mx-input-wrapper {\n  width: 150px !important;\n}\n.mx-calendar-icon {\n  height: auto !important;\n}\n.date-input-block .mx-input-wrapper,\n.date-input-block .servicearea-date-input {\n  width: 100% !important;\n}\n#TimePicker .field-clear-button, input#TimePicker {\n  margin-top: 0;\n}\n.time-picker-column .active .time-picker-column-item-text {\n  color: #fff;\n}\n.time-picker-column .time-picker-column-item-text {\n  color: #333;\n}\n.datetimepicker .datepicker-button {\n  width: 100%;\n  background: #0d79f2 !important;\n}\n.datetimepicker .datepicker-button:hover {\n    background: #0556b0 !important;\n}\n.datetimepicker .datepicker-button span {\n    display: none;\n}\n.datetimepicker .datepicker-button svg {\n    fill: #fff !important;\n}\n.rtl-dp .vdp-datepicker__calendar {\n  right: 0;\n}\n.rtl-dp .dtp {\n  padding: 5px 8px;\n}\n.H_ib {\n  left: -90.85%;\n  top: -25px;\n}\n.H_ib_content {\n  margin: 10px 28px 10px 10px;\n}\n.H_ib_tail {\n  margin: -10px 0 0 -125px;\n}\n.here-info-window-content {\n  width: 250px;\n  font-size: 13px;\n  text-align: center;\n  line-height: 1.4;\n  font-family: Roboto, Arial, sans-serif;\n}\n.here-info-window-content .value {\n    font-weight: 600;\n}\n.H_ib.package-detail-iw {\n  margin-left: -28px;\n}\n.H_ib.package-detail-iw .here-info-window-content {\n    text-align: left;\n}\n.H_ib.package-detail-iw .here-info-window-content label {\n      color: #51a2fd;\n      font-size: 11px;\n      display: block;\n}\n.H_ib.package-detail-iw .here-info-window-content .value {\n      margin-bottom: 5px;\n      display: inline-block;\n}\n.H_ib.package-detail-iw .H_ib_tail {\n    margin: -10px 0 0 -113px;\n}\n.routing-map .H_ib_tail {\n  margin: -10px 0 0 -95px;\n}\n.routing-map .here-info-window-content.routing {\n  text-align: left;\n  width: 165px;\n}\n.routing-map .here-info-window-content.routing .stop-id {\n    border-bottom: 1px solid #ccc;\n    padding: 0 0 7px 0;\n    margin-bottom: 10px;\n}\n.routing-map .here-info-window-content.routing .stop-id .index {\n      display: inline-block;\n      width: 16px;\n      height: 16px;\n      line-height: 16px;\n      text-align: center;\n      border-radius: 100%;\n      background-color: #F20D0D;\n      margin-right: 5px;\n      color: #fff;\n      font-weight: 700;\n}\n.routing-map .here-info-window-content.routing .stop-id .index.pickup {\n        background-color: #26D97A;\n}\n.here-info-window-content.coverage.rsvp {\n  text-align: left;\n}\n.here-info-window-content.coverage.rsvp .label-value {\n    margin-bottom: 7px;\n}\n.here-info-window-content.coverage.rsvp label {\n    color: #51a2fd;\n    font-size: 11px;\n    display: block;\n}\n.top-calendar.vdp-datepicker__calendar {\n  bottom: 100%;\n}\n.vdp-datepicker.datepicker.fl-filter input {\n  padding: 0 27px 0 10px;\n  line-height: 38px;\n  height: 38px;\n  max-width: 155px;\n}\n.vdp-datepicker.datepicker.fl-filter .vdp-datepicker__clear-button {\n  position: absolute;\n  right: 5px;\n  top: 0;\n  line-height: 38px;\n  height: 38px;\n  width: 20px;\n  text-align: center;\n  font-size: 24px;\n  font-style: normal;\n  color: #ef4e4e;\n}\n.m-T-0 {\n  margin-top: 0;\n}\n.m-L-5 {\n  margin-left: 5px;\n}\n.m-X-5 {\n  margin-left: 5px;\n  margin-right: 5px;\n}\n.d-flex {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.justify-center {\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n}\n.justify-space-between {\n  -webkit-box-pack: justify !important;\n      -ms-flex-pack: justify !important;\n          justify-content: space-between !important;\n}\n.justify-space-around {\n  -ms-flex-pack: distribute !important;\n      justify-content: space-around !important;\n}\n.justify-end {\n  -webkit-box-pack: end !important;\n      -ms-flex-pack: end !important;\n          justify-content: flex-end !important;\n}\n.align-start {\n  -webkit-box-align: start !important;\n      -ms-flex-align: start !important;\n          align-items: flex-start !important;\n}\n.align-center {\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n}\n.align-stretch {\n  -webkit-box-align: stretch !important;\n      -ms-flex-align: stretch !important;\n          align-items: stretch !important;\n}\n.flex-column {\n  -webkit-box-orient: vertical !important;\n  -webkit-box-direction: normal !important;\n      -ms-flex-direction: column !important;\n          flex-direction: column !important;\n}\n.route-container {\n  margin-left: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.route-container.side-menu {\n    margin-left: 250px;\n}\n.slide-enter-active, .slide-leave-active {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.slide-enter, .slide-leave-to {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 706 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountryCodeModal_vue__ = __webpack_require__(169);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8583783c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountryCodeModal_vue__ = __webpack_require__(798);
function injectStyle (ssrContext) {
  __webpack_require__(708)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8583783c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountryCodeModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8583783c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountryCodeModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(709);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("34b7fd13", content, true, {});

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.modal[data-v-8583783c] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.modal .bg-overlay[data-v-8583783c] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n.modal .modal-content[data-v-8583783c] {\n    position: absolute;\n    top: 20%;\n    left: 50%;\n    width: 400px;\n    padding: 25px;\n    background: #fff;\n    text-align: center;\n    border-radius: 6px;\n    margin-left: -200px;\n    -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal .modal-content input[data-v-8583783c] {\n      margin-top: 0;\n}\n.modal .modal-content .country-list[data-v-8583783c] {\n      height: 400px;\n      text-align: left;\n      overflow-y: auto;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.modal .modal-content .country-list .country-name[data-v-8583783c] {\n        padding: 10px 15px;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n        border-left: 1px solid rgba(0, 0, 0, 0.1);\n        border-right: 1px solid rgba(0, 0, 0, 0.1);\n}\n.modal .modal-content .country-list .country-name .iti-flag[data-v-8583783c] {\n          display: inline-block;\n}\n.modal .modal-content .country-list .country-name[data-v-8583783c]:hover {\n          background-color: #fff8dc;\n          cursor: pointer;\n}\n.modal.show[data-v-8583783c] {\n    display: block;\n}\n.modal.show .modal-content[data-v-8583783c] {\n      display: block;\n      -webkit-animation: slide-down-data-v-8583783c .3s ease-out;\n      -moz-animation: slide-down-data-v-8583783c .3s ease-out;\n}\n@-webkit-keyframes slide-down-data-v-8583783c {\n0% {\n    opacity: 0;\n    -webkit-transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/App/CountryCodeModal.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,YAAY;CACb;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;CAChB;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,uDAAuD;YAC/C,+CAA+C;IACvD,cAAc;CACjB;AACD;MACM,cAAc;CACnB;AACD;MACM,cAAc;MACd,iBAAiB;MACjB,iBAAiB;MACjB,4CAA4C;CACjD;AACD;QACQ,mBAAmB;QACnB,4CAA4C;QAC5C,0CAA0C;QAC1C,2CAA2C;CAClD;AACD;UACU,sBAAsB;CAC/B;AACD;UACU,0BAA0B;UAC1B,gBAAgB;CACzB;AACD;IACI,eAAe;CAClB;AACD;MACM,eAAe;MACf,2DAA2D;MAC3D,wDAAwD;CAC7D;AACD;AACA;IACI,WAAW;IACX,oCAAoC;CACvC;AACD;IACI,WAAW;IACX,iCAAiC;CACpC;CACA","file":"CountryCodeModal.vue","sourcesContent":["\n.modal[data-v-8583783c] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.modal .bg-overlay[data-v-8583783c] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n.modal .modal-content[data-v-8583783c] {\n    position: absolute;\n    top: 20%;\n    left: 50%;\n    width: 400px;\n    padding: 25px;\n    background: #fff;\n    text-align: center;\n    border-radius: 6px;\n    margin-left: -200px;\n    -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal .modal-content input[data-v-8583783c] {\n      margin-top: 0;\n}\n.modal .modal-content .country-list[data-v-8583783c] {\n      height: 400px;\n      text-align: left;\n      overflow-y: auto;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.modal .modal-content .country-list .country-name[data-v-8583783c] {\n        padding: 10px 15px;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n        border-left: 1px solid rgba(0, 0, 0, 0.1);\n        border-right: 1px solid rgba(0, 0, 0, 0.1);\n}\n.modal .modal-content .country-list .country-name .iti-flag[data-v-8583783c] {\n          display: inline-block;\n}\n.modal .modal-content .country-list .country-name[data-v-8583783c]:hover {\n          background-color: #fff8dc;\n          cursor: pointer;\n}\n.modal.show[data-v-8583783c] {\n    display: block;\n}\n.modal.show .modal-content[data-v-8583783c] {\n      display: block;\n      -webkit-animation: slide-down-data-v-8583783c .3s ease-out;\n      -moz-animation: slide-down-data-v-8583783c .3s ease-out;\n}\n@-webkit-keyframes slide-down-data-v-8583783c {\n0% {\n    opacity: 0;\n    -webkit-transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(56);
__webpack_require__(715);
module.exports = __webpack_require__(12).Array.from;


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(117);
var defined = __webpack_require__(116);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(123);
var descriptor = __webpack_require__(77);
var setToStringTag = __webpack_require__(82);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(44)(IteratorPrototype, __webpack_require__(19)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(33);
var anObject = __webpack_require__(39);
var getKeys = __webpack_require__(64);

module.exports = __webpack_require__(29) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(54);
var toObject = __webpack_require__(65);
var IE_PROTO = __webpack_require__(118)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(43);
var $export = __webpack_require__(15);
var toObject = __webpack_require__(65);
var call = __webpack_require__(172);
var isArrayIter = __webpack_require__(173);
var toLength = __webpack_require__(98);
var createProperty = __webpack_require__(716);
var getIterFn = __webpack_require__(124);

$export($export.S + $export.F * !__webpack_require__(174)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(33);
var createDesc = __webpack_require__(77);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(718);
module.exports = __webpack_require__(12).Object.values;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(15);
var $values = __webpack_require__(175)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_js__ = __webpack_require__(126);
// Default Export
// ==============
// In this module, we mix our bundled exports into the `_` object and export
// the result. This is analogous to setting `module.exports = _` in CommonJS.
// Hence, this module is also the entry point of our UMD bundle and the package
// entry point for CommonJS and AMD users. In other words, this is (the source
// of) the module you are interfacing with when you do any of the following:
//
// ```js
// // CommonJS
// var _ = require('underscore');
//
// // AMD
// define(['underscore'], function(_) {...});
//
// // UMD in the browser
// // _ is available as a global variable
// ```



// Add all of the Underscore functions to the wrapper object.
var _ = Object(__WEBPACK_IMPORTED_MODULE_0__index_js__["mixin"])(__WEBPACK_IMPORTED_MODULE_0__index_js__);
// Legacy Node.js API.
_._ = _;
// Export the Underscore API.
/* harmony default export */ __webpack_exports__["a"] = (_);


/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isNull;
// Is a given value equal to null?
function isNull(obj) {
  return obj === null;
}


/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isElement;
// Is a given value a DOM element?
function isElement(obj) {
  return !!(obj && obj.nodeType === 1);
}


/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(16);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Date'));


/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(16);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('RegExp'));


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(16);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Error'));


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(16);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Object'));


/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isFinite;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(179);



// Is a given object a finite number?
function isFinite(obj) {
  return !Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(obj) && Object(__WEBPACK_IMPORTED_MODULE_0__setup_js__["f" /* _isFinite */])(obj) && !isNaN(parseFloat(obj));
}


/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createSizePropertyCheck_js__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getByteLength_js__ = __webpack_require__(130);



// Internal helper to determine whether we should spend extensive checks against
// `ArrayBuffer` et al.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createSizePropertyCheck_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__getByteLength_js__["a" /* default */]));


/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isEmpty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isString_js__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArguments_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keys_js__ = __webpack_require__(14);






// Is a given array, string, or object empty?
// An "empty" object has no enumerable own-properties.
function isEmpty(obj) {
  if (obj == null) return true;
  // Skip the more expensive `toString`-based type checks if `obj` has no
  // `.length`.
  var length = Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(obj);
  if (typeof length == 'number' && (
    Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(obj) || Object(__WEBPACK_IMPORTED_MODULE_2__isString_js__["a" /* default */])(obj) || Object(__WEBPACK_IMPORTED_MODULE_3__isArguments_js__["a" /* default */])(obj)
  )) return length === 0;
  return Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__keys_js__["a" /* default */])(obj)) === 0;
}


/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isEqual;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getByteLength_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isTypedArray_js__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isFunction_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stringTagBug_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isDataView_js__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__keys_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__has_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__toBufferView_js__ = __webpack_require__(730);











// We use this string twice, so give it a name for minification.
var tagDataView = '[object DataView]';

// Internal recursive comparison function for `_.isEqual`.
function eq(a, b, aStack, bStack) {
  // Identical objects are equal. `0 === -0`, but they aren't identical.
  // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
  if (a === b) return a !== 0 || 1 / a === 1 / b;
  // `null` or `undefined` only equal to itself (strict comparison).
  if (a == null || b == null) return false;
  // `NaN`s are equivalent, but non-reflexive.
  if (a !== a) return b !== b;
  // Exhaust primitive checks
  var type = typeof a;
  if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
  return deepEq(a, b, aStack, bStack);
}

// Internal recursive comparison function for `_.isEqual`.
function deepEq(a, b, aStack, bStack) {
  // Unwrap any wrapped objects.
  if (a instanceof __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */]) a = a._wrapped;
  if (b instanceof __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */]) b = b._wrapped;
  // Compare `[[Class]]` names.
  var className = __WEBPACK_IMPORTED_MODULE_1__setup_js__["t" /* toString */].call(a);
  if (className !== __WEBPACK_IMPORTED_MODULE_1__setup_js__["t" /* toString */].call(b)) return false;
  // Work around a bug in IE 10 - Edge 13.
  if (__WEBPACK_IMPORTED_MODULE_5__stringTagBug_js__["a" /* hasStringTagBug */] && className == '[object Object]' && Object(__WEBPACK_IMPORTED_MODULE_6__isDataView_js__["a" /* default */])(a)) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_6__isDataView_js__["a" /* default */])(b)) return false;
    className = tagDataView;
  }
  switch (className) {
    // These types are compared by value.
    case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
    case '[object String]':
      // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
      // equivalent to `new String("5")`.
      return '' + a === '' + b;
    case '[object Number]':
      // `NaN`s are equivalent, but non-reflexive.
      // Object(NaN) is equivalent to NaN.
      if (+a !== +a) return +b !== +b;
      // An `egal` comparison is performed for other numeric values.
      return +a === 0 ? 1 / +a === 1 / b : +a === +b;
    case '[object Date]':
    case '[object Boolean]':
      // Coerce dates and booleans to numeric primitive values. Dates are compared by their
      // millisecond representations. Note that invalid dates with millisecond representations
      // of `NaN` are not equivalent.
      return +a === +b;
    case '[object Symbol]':
      return __WEBPACK_IMPORTED_MODULE_1__setup_js__["d" /* SymbolProto */].valueOf.call(a) === __WEBPACK_IMPORTED_MODULE_1__setup_js__["d" /* SymbolProto */].valueOf.call(b);
    case '[object ArrayBuffer]':
    case tagDataView:
      // Coerce to typed array so we can fall through.
      return deepEq(Object(__WEBPACK_IMPORTED_MODULE_9__toBufferView_js__["a" /* default */])(a), Object(__WEBPACK_IMPORTED_MODULE_9__toBufferView_js__["a" /* default */])(b), aStack, bStack);
  }

  var areArrays = className === '[object Array]';
  if (!areArrays && Object(__WEBPACK_IMPORTED_MODULE_3__isTypedArray_js__["a" /* default */])(a)) {
      var byteLength = Object(__WEBPACK_IMPORTED_MODULE_2__getByteLength_js__["a" /* default */])(a);
      if (byteLength !== Object(__WEBPACK_IMPORTED_MODULE_2__getByteLength_js__["a" /* default */])(b)) return false;
      if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
      areArrays = true;
  }
  if (!areArrays) {
    if (typeof a != 'object' || typeof b != 'object') return false;

    // Objects with different constructors are not equivalent, but `Object`s or `Array`s
    // from different frames are.
    var aCtor = a.constructor, bCtor = b.constructor;
    if (aCtor !== bCtor && !(Object(__WEBPACK_IMPORTED_MODULE_4__isFunction_js__["a" /* default */])(aCtor) && aCtor instanceof aCtor &&
                             Object(__WEBPACK_IMPORTED_MODULE_4__isFunction_js__["a" /* default */])(bCtor) && bCtor instanceof bCtor)
                        && ('constructor' in a && 'constructor' in b)) {
      return false;
    }
  }
  // Assume equality for cyclic structures. The algorithm for detecting cyclic
  // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

  // Initializing stack of traversed objects.
  // It's done here since we only need them for objects and arrays comparison.
  aStack = aStack || [];
  bStack = bStack || [];
  var length = aStack.length;
  while (length--) {
    // Linear search. Performance is inversely proportional to the number of
    // unique nested structures.
    if (aStack[length] === a) return bStack[length] === b;
  }

  // Add the first object to the stack of traversed objects.
  aStack.push(a);
  bStack.push(b);

  // Recursively compare objects and arrays.
  if (areArrays) {
    // Compare array lengths to determine if a deep comparison is necessary.
    length = a.length;
    if (length !== b.length) return false;
    // Deep compare the contents, ignoring non-numeric properties.
    while (length--) {
      if (!eq(a[length], b[length], aStack, bStack)) return false;
    }
  } else {
    // Deep compare objects.
    var _keys = Object(__WEBPACK_IMPORTED_MODULE_7__keys_js__["a" /* default */])(a), key;
    length = _keys.length;
    // Ensure that both objects contain the same number of properties before comparing deep equality.
    if (Object(__WEBPACK_IMPORTED_MODULE_7__keys_js__["a" /* default */])(b).length !== length) return false;
    while (length--) {
      // Deep compare each member
      key = _keys[length];
      if (!(Object(__WEBPACK_IMPORTED_MODULE_8__has_js__["a" /* default */])(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
    }
  }
  // Remove the first object from the stack of traversed objects.
  aStack.pop();
  bStack.pop();
  return true;
}

// Perform a deep comparison to check if two objects are equal.
function isEqual(a, b) {
  return eq(a, b);
}


/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toBufferView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getByteLength_js__ = __webpack_require__(130);


// Internal function to wrap or shallow-copy an ArrayBuffer,
// typed array or DataView to a new view, reusing the buffer.
function toBufferView(bufferSource) {
  return new Uint8Array(
    bufferSource.buffer || bufferSource,
    bufferSource.byteOffset || 0,
    Object(__WEBPACK_IMPORTED_MODULE_0__getByteLength_js__["a" /* default */])(bufferSource)
  );
}


/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__ = __webpack_require__(131);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__["b" /* isIE11 */] ? Object(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["a" /* ie11fingerprint */])(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["b" /* mapMethods */]) : Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Map'));


/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__ = __webpack_require__(131);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__["b" /* isIE11 */] ? Object(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["a" /* ie11fingerprint */])(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["d" /* weakMapMethods */]) : Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('WeakMap'));


/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__ = __webpack_require__(131);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__["b" /* isIE11 */] ? Object(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["a" /* ie11fingerprint */])(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["c" /* setMethods */]) : Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Set'));


/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(16);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('WeakSet'));


/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pairs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys_js__ = __webpack_require__(14);


// Convert an object into a list of `[key, value]` pairs.
// The opposite of `_.object` with one argument.
function pairs(obj) {
  var _keys = Object(__WEBPACK_IMPORTED_MODULE_0__keys_js__["a" /* default */])(obj);
  var length = _keys.length;
  var pairs = Array(length);
  for (var i = 0; i < length; i++) {
    pairs[i] = [_keys[i], obj[_keys[i]]];
  }
  return pairs;
}


/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extendOwn_js__ = __webpack_require__(133);



// Creates an object that inherits from the given prototype object.
// If additional properties are provided then they will be added to the
// created object.
function create(prototype, props) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(prototype);
  if (props) Object(__WEBPACK_IMPORTED_MODULE_1__extendOwn_js__["a" /* default */])(result, props);
  return result;
}


/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extend_js__ = __webpack_require__(190);




// Create a (shallow-cloned) duplicate of an object.
function clone(obj) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(obj)) return obj;
  return Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(obj) ? obj.slice() : Object(__WEBPACK_IMPORTED_MODULE_2__extend_js__["a" /* default */])({}, obj);
}


/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tap;
// Invokes `interceptor` with the `obj` and then returns `obj`.
// The primary purpose of this method is to "tap into" a method chain, in
// order to perform operations on intermediate results within the chain.
function tap(obj, interceptor) {
  interceptor(obj);
  return obj;
}


/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = has;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__has_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPath_js__ = __webpack_require__(86);



// Shortcut function for checking if an object has a given property directly on
// itself (in other words, not on a prototype). Unlike the internal `has`
// function, this public version can also traverse nested properties.
function has(obj, path) {
  path = Object(__WEBPACK_IMPORTED_MODULE_1__toPath_js__["a" /* default */])(path);
  var length = path.length;
  for (var i = 0; i < length; i++) {
    var key = path[i];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__has_js__["a" /* default */])(obj, key)) return false;
    obj = obj[key];
  }
  return !!length;
}


/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapObject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(14);



// Returns the results of applying the `iteratee` to each element of `obj`.
// In contrast to `_.map` it returns an object.
function mapObject(obj, iteratee, context) {
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(iteratee, context);
  var _keys = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(obj),
      length = _keys.length,
      results = {};
  for (var index = 0; index < length; index++) {
    var currentKey = _keys[index];
    results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
  }
  return results;
}


/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = propertyOf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_js__ = __webpack_require__(193);



// Generates a function for a given object that returns a given property.
function propertyOf(obj) {
  if (obj == null) return __WEBPACK_IMPORTED_MODULE_0__noop_js__["a" /* default */];
  return function(path) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__get_js__["a" /* default */])(obj, path);
  };
}


/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = times;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__optimizeCb_js__ = __webpack_require__(87);


// Run a function **n** times.
function times(n, iteratee, context) {
  var accum = Array(Math.max(0, n));
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__optimizeCb_js__["a" /* default */])(iteratee, context, 1);
  for (var i = 0; i < n; i++) accum[i] = iteratee(i);
  return accum;
}


/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createEscaper_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__escapeMap_js__ = __webpack_require__(200);



// Function for escaping strings to HTML interpolation.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createEscaper_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__escapeMap_js__["a" /* default */]));


/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createEscaper_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unescapeMap_js__ = __webpack_require__(745);



// Function for unescaping strings from HTML interpolation.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createEscaper_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__unescapeMap_js__["a" /* default */]));


/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__invert_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__escapeMap_js__ = __webpack_require__(200);



// Internal list of HTML entities for unescaping.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__invert_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__escapeMap_js__["a" /* default */]));


/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = template;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaults_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__underscore_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templateSettings_js__ = __webpack_require__(201);




// When customizing `_.templateSettings`, if you don't want to define an
// interpolation, evaluation or escaping regex, we need one that is
// guaranteed not to match.
var noMatch = /(.)^/;

// Certain characters need to be escaped so that they can be put into a
// string literal.
var escapes = {
  "'": "'",
  '\\': '\\',
  '\r': 'r',
  '\n': 'n',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

function escapeChar(match) {
  return '\\' + escapes[match];
}

// In order to prevent third-party code injection through
// `_.templateSettings.variable`, we test it against the following regular
// expression. It is intentionally a bit more liberal than just matching valid
// identifiers, but still prevents possible loopholes through defaults or
// destructuring assignment.
var bareIdentifier = /^\s*(\w|\$)+\s*$/;

// JavaScript micro-templating, similar to John Resig's implementation.
// Underscore templating handles arbitrary delimiters, preserves whitespace,
// and correctly escapes quotes within interpolated code.
// NB: `oldSettings` only exists for backwards compatibility.
function template(text, settings, oldSettings) {
  if (!settings && oldSettings) settings = oldSettings;
  settings = Object(__WEBPACK_IMPORTED_MODULE_0__defaults_js__["a" /* default */])({}, settings, __WEBPACK_IMPORTED_MODULE_1__underscore_js__["a" /* default */].templateSettings);

  // Combine delimiters into one regular expression via alternation.
  var matcher = RegExp([
    (settings.escape || noMatch).source,
    (settings.interpolate || noMatch).source,
    (settings.evaluate || noMatch).source
  ].join('|') + '|$', 'g');

  // Compile the template source, escaping string literals appropriately.
  var index = 0;
  var source = "__p+='";
  text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
    source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
    index = offset + match.length;

    if (escape) {
      source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
    } else if (interpolate) {
      source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
    } else if (evaluate) {
      source += "';\n" + evaluate + "\n__p+='";
    }

    // Adobe VMs need the match returned to produce the correct offset.
    return match;
  });
  source += "';\n";

  var argument = settings.variable;
  if (argument) {
    // Insure against third-party code injection. (CVE-2021-23358)
    if (!bareIdentifier.test(argument)) throw new Error(
      'variable is not a bare identifier: ' + argument
    );
  } else {
    // If a variable is not specified, place data values in local scope.
    source = 'with(obj||{}){\n' + source + '}\n';
    argument = 'obj';
  }

  source = "var __t,__p='',__j=Array.prototype.join," +
    "print=function(){__p+=__j.call(arguments,'');};\n" +
    source + 'return __p;\n';

  var render;
  try {
    render = new Function(argument, '_', source);
  } catch (e) {
    e.source = source;
    throw e;
  }

  var template = function(data) {
    return render.call(this, data, __WEBPACK_IMPORTED_MODULE_1__underscore_js__["a" /* default */]);
  };

  // Provide the compiled source as a convenience for precompilation.
  template.source = 'function(' + argument + '){\n' + source + '}';

  return template;
}


/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = result;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPath_js__ = __webpack_require__(86);



// Traverses the children of `obj` along `path`. If a child is a function, it
// is invoked with its parent as context. Returns the value of the final
// child, or `fallback` if any child is undefined.
function result(obj, path, fallback) {
  path = Object(__WEBPACK_IMPORTED_MODULE_1__toPath_js__["a" /* default */])(path);
  var length = path.length;
  if (!length) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(fallback) ? fallback.call(obj) : fallback;
  }
  for (var i = 0; i < length; i++) {
    var prop = obj == null ? void 0 : obj[path[i]];
    if (prop === void 0) {
      prop = fallback;
      i = length; // Ensure we don't continue iterating.
    }
    obj = Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(prop) ? prop.call(obj) : prop;
  }
  return obj;
}


/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uniqueId;
// Generate a unique integer id (unique within the entire client session).
// Useful for temporary DOM ids.
var idCounter = 0;
function uniqueId(prefix) {
  var id = ++idCounter + '';
  return prefix ? prefix + id : id;
}


/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chain;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(24);


// Start chaining a wrapped Underscore object.
function chain(obj) {
  var instance = Object(__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */])(obj);
  instance._chain = true;
  return instance;
}


/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flatten_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bind_js__ = __webpack_require__(203);




// Bind a number of an object's methods to that object. Remaining arguments
// are the method names to be bound. Useful for ensuring that all callbacks
// defined on an object belong to it.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(obj, keys) {
  keys = Object(__WEBPACK_IMPORTED_MODULE_1__flatten_js__["a" /* default */])(keys, false, false);
  var index = keys.length;
  if (index < 1) throw new Error('bindAll must be passed function names');
  while (index--) {
    var key = keys[index];
    obj[key] = Object(__WEBPACK_IMPORTED_MODULE_2__bind_js__["a" /* default */])(obj[key], obj);
  }
  return obj;
}));


/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = memoize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__has_js__ = __webpack_require__(46);


// Memoize an expensive function by storing its results.
function memoize(func, hasher) {
  var memoize = function(key) {
    var cache = memoize.cache;
    var address = '' + (hasher ? hasher.apply(this, arguments) : key);
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__has_js__["a" /* default */])(cache, address)) cache[address] = func.apply(this, arguments);
    return cache[address];
  };
  memoize.cache = {};
  return memoize;
}


/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partial_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__delay_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__underscore_js__ = __webpack_require__(24);




// Defers a function, scheduling it to run after the current call stack has
// cleared.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__partial_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__delay_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__underscore_js__["a" /* default */], 1));


/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__now_js__ = __webpack_require__(137);


// Returns a function, that, when invoked, will only be triggered at most once
// during a given window of time. Normally, the throttled function will run
// as much as it can, without ever going more than once per `wait` duration;
// but if you'd like to disable the execution on the leading edge, pass
// `{leading: false}`. To disable execution on the trailing edge, ditto.
function throttle(func, wait, options) {
  var timeout, context, args, result;
  var previous = 0;
  if (!options) options = {};

  var later = function() {
    previous = options.leading === false ? 0 : Object(__WEBPACK_IMPORTED_MODULE_0__now_js__["a" /* default */])();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };

  var throttled = function() {
    var _now = Object(__WEBPACK_IMPORTED_MODULE_0__now_js__["a" /* default */])();
    if (!previous && options.leading === false) previous = _now;
    var remaining = wait - (_now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = _now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };

  throttled.cancel = function() {
    clearTimeout(timeout);
    previous = 0;
    timeout = context = args = null;
  };

  return throttled;
}


/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__now_js__ = __webpack_require__(137);



// When a sequence of calls of the returned function ends, the argument
// function is triggered. The end of a sequence is defined by the `wait`
// parameter. If `immediate` is passed, the argument function will be
// triggered at the beginning of the sequence instead of at the end.
function debounce(func, wait, immediate) {
  var timeout, previous, args, result, context;

  var later = function() {
    var passed = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])() - previous;
    if (wait > passed) {
      timeout = setTimeout(later, wait - passed);
    } else {
      timeout = null;
      if (!immediate) result = func.apply(context, args);
      // This check is needed because `func` can recursively invoke `debounced`.
      if (!timeout) args = context = null;
    }
  };

  var debounced = Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(_args) {
    context = this;
    args = _args;
    previous = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])();
    if (!timeout) {
      timeout = setTimeout(later, wait);
      if (immediate) result = func.apply(context, args);
    }
    return result;
  });

  debounced.cancel = function() {
    clearTimeout(timeout);
    timeout = args = context = null;
  };

  return debounced;
}


/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partial_js__ = __webpack_require__(103);


// Returns the first function passed as an argument to the second,
// allowing you to adjust arguments, run code before and after, and
// conditionally execute the original function.
function wrap(func, wrapper) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__partial_js__["a" /* default */])(wrapper, func);
}


/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
// Returns a function that is the composition of a list of functions, each
// consuming the return value of the function that follows.
function compose() {
  var args = arguments;
  var start = args.length - 1;
  return function() {
    var i = start;
    var result = args[start].apply(this, arguments);
    while (i--) result = args[i].call(this, result);
    return result;
  };
}


/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = after;
// Returns a function that will only be executed on and after the Nth call.
function after(times, func) {
  return function() {
    if (--times < 1) {
      return func.apply(this, arguments);
    }
  };
}


/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partial_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__before_js__ = __webpack_require__(205);



// Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__partial_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__before_js__["a" /* default */], 2));


/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__findLastIndex_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createIndexFinder_js__ = __webpack_require__(211);



// Return the position of the last occurrence of an item in an array,
// or -1 if the item is not included in the array.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createIndexFinder_js__["a" /* default */])(-1, __WEBPACK_IMPORTED_MODULE_0__findLastIndex_js__["a" /* default */]));


/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findWhere;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__find_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matcher_js__ = __webpack_require__(102);



// Convenience version of a common use case of `_.find`: getting the first
// object containing specific `key:value` pairs.
function findWhere(obj, attrs) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__find_js__["a" /* default */])(obj, Object(__WEBPACK_IMPORTED_MODULE_1__matcher_js__["a" /* default */])(attrs));
}


/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReduce_js__ = __webpack_require__(213);


// **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReduce_js__["a" /* default */])(1));


/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReduce_js__ = __webpack_require__(213);


// The right-associative version of reduce, also known as `foldr`.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReduce_js__["a" /* default */])(-1));


/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__negate_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cb_js__ = __webpack_require__(21);




// Return all the elements for which a truth test fails.
function reject(obj, predicate, context) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__filter_js__["a" /* default */])(obj, Object(__WEBPACK_IMPORTED_MODULE_1__negate_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__cb_js__["a" /* default */])(predicate)), context);
}


/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = every;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(14);




// Determine whether all of the elements pass a truth test.
function every(obj, predicate, context) {
  predicate = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(predicate, context);
  var _keys = !Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(obj) && Object(__WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */])(obj),
      length = (_keys || obj).length;
  for (var index = 0; index < length; index++) {
    var currentKey = _keys ? _keys[index] : index;
    if (!predicate(obj[currentKey], currentKey, obj)) return false;
  }
  return true;
}


/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = some;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(14);




// Determine if at least one element in the object passes a truth test.
function some(obj, predicate, context) {
  predicate = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(predicate, context);
  var _keys = !Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(obj) && Object(__WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */])(obj),
      length = (_keys || obj).length;
  for (var index = 0; index < length; index++) {
    var currentKey = _keys ? _keys[index] : index;
    if (predicate(obj[currentKey], currentKey, obj)) return true;
  }
  return false;
}


/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__deepGet_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toPath_js__ = __webpack_require__(86);






// Invoke a method (with arguments) on every item in a collection.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(obj, path, args) {
  var contextPath, func;
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(path)) {
    func = path;
  } else {
    path = Object(__WEBPACK_IMPORTED_MODULE_4__toPath_js__["a" /* default */])(path);
    contextPath = path.slice(0, -1);
    path = path[path.length - 1];
  }
  return Object(__WEBPACK_IMPORTED_MODULE_2__map_js__["a" /* default */])(obj, function(context) {
    var method = func;
    if (!method) {
      if (contextPath && contextPath.length) {
        context = Object(__WEBPACK_IMPORTED_MODULE_3__deepGet_js__["a" /* default */])(context, contextPath);
      }
      if (context == null) return void 0;
      method = context[path];
    }
    return method == null ? method : method.apply(context, args);
  });
}));


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = where;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matcher_js__ = __webpack_require__(102);



// Convenience version of a common use case of `_.filter`: selecting only
// objects containing specific `key:value` pairs.
function where(obj, attrs) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__filter_js__["a" /* default */])(obj, Object(__WEBPACK_IMPORTED_MODULE_1__matcher_js__["a" /* default */])(attrs));
}


/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = min;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__values_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cb_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__each_js__ = __webpack_require__(59);





// Return the minimum element (or element-based computation).
function min(obj, iteratee, context) {
  var result = Infinity, lastComputed = Infinity,
      value, computed;
  if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
    obj = Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) ? obj : Object(__WEBPACK_IMPORTED_MODULE_1__values_js__["a" /* default */])(obj);
    for (var i = 0, length = obj.length; i < length; i++) {
      value = obj[i];
      if (value != null && value < result) {
        result = value;
      }
    }
  } else {
    iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__cb_js__["a" /* default */])(iteratee, context);
    Object(__WEBPACK_IMPORTED_MODULE_3__each_js__["a" /* default */])(obj, function(v, index, list) {
      computed = iteratee(v, index, list);
      if (computed < lastComputed || computed === Infinity && result === Infinity) {
        result = v;
        lastComputed = computed;
      }
    });
  }
  return result;
}


/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shuffle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sample_js__ = __webpack_require__(215);


// Shuffle a collection.
function shuffle(obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__sample_js__["a" /* default */])(obj, Infinity);
}


/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sortBy;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pluck_js__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map_js__ = __webpack_require__(69);




// Sort the object's values by a criterion produced by an iteratee.
function sortBy(obj, iteratee, context) {
  var index = 0;
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(iteratee, context);
  return Object(__WEBPACK_IMPORTED_MODULE_1__pluck_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__map_js__["a" /* default */])(obj, function(value, key, list) {
    return {
      value: value,
      index: index++,
      criteria: iteratee(value, key, list)
    };
  }).sort(function(left, right) {
    var a = left.criteria;
    var b = right.criteria;
    if (a !== b) {
      if (a > b || a === void 0) return 1;
      if (a < b || b === void 0) return -1;
    }
    return left.index - right.index;
  }), 'value');
}


/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__group_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__has_js__ = __webpack_require__(46);



// Groups the object's values by a criterion. Pass either a string attribute
// to group by, or a function that returns the criterion.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__group_js__["a" /* default */])(function(result, value, key) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__has_js__["a" /* default */])(result, key)) result[key].push(value); else result[key] = [value];
}));


/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__group_js__ = __webpack_require__(104);


// Indexes the object's values by a criterion, similar to `_.groupBy`, but for
// when you know that your index values will be unique.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__group_js__["a" /* default */])(function(result, value, key) {
  result[key] = value;
}));


/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__group_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__has_js__ = __webpack_require__(46);



// Counts instances of an object that group by a certain criterion. Pass
// either a string attribute to count by, or a function that returns the
// criterion.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__group_js__["a" /* default */])(function(result, value, key) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__has_js__["a" /* default */])(result, key)) result[key]++; else result[key] = 1;
}));


/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__group_js__ = __webpack_require__(104);


// Split a collection into two arrays: one whose elements all pass the given
// truth test, and one whose elements all do not pass the truth test.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__group_js__["a" /* default */])(function(result, value, pass) {
  result[pass ? 0 : 1].push(value);
}, true));


/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = size;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(14);



// Return the number of elements in a collection.
function size(obj) {
  if (obj == null) return 0;
  return Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) ? obj.length : Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(obj).length;
}


/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keyInObj;
// Internal `_.pick` helper function to determine whether `key` is an enumerable
// property name of `obj`.
function keyInObj(value, key, obj) {
  return key in obj;
}


/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__negate_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__map_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flatten_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contains_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pick_js__ = __webpack_require__(217);








// Return a copy of the object without the disallowed properties.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(obj, keys) {
  var iteratee = keys[0], context;
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(iteratee)) {
    iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__negate_js__["a" /* default */])(iteratee);
    if (keys.length > 1) context = keys[1];
  } else {
    keys = Object(__WEBPACK_IMPORTED_MODULE_3__map_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__flatten_js__["a" /* default */])(keys, false, false), String);
    iteratee = function(value, key) {
      return !Object(__WEBPACK_IMPORTED_MODULE_5__contains_js__["a" /* default */])(keys, key);
    };
  }
  return Object(__WEBPACK_IMPORTED_MODULE_6__pick_js__["a" /* default */])(obj, iteratee, context);
}));


/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = first;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__initial_js__ = __webpack_require__(218);


// Get the first element of an array. Passing **n** will return the first N
// values in the array. The **guard** check allows it to work with `_.map`.
function first(array, n, guard) {
  if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
  if (n == null || guard) return array[0];
  return Object(__WEBPACK_IMPORTED_MODULE_0__initial_js__["a" /* default */])(array, array.length - n);
}


/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = last;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rest_js__ = __webpack_require__(219);


// Get the last element of an array. Passing **n** will return the last N
// values in the array.
function last(array, n, guard) {
  if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
  if (n == null || guard) return array[array.length - 1];
  return Object(__WEBPACK_IMPORTED_MODULE_0__rest_js__["a" /* default */])(array, Math.max(0, array.length - n));
}


/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compact;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter_js__ = __webpack_require__(88);


// Trim out all falsy values from an array.
function compact(array) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__filter_js__["a" /* default */])(array, Boolean);
}


/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = flatten;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flatten_js__ = __webpack_require__(68);


// Flatten out an array, either recursively (by default), or up to `depth`.
// Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
function flatten(array, depth) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__flatten_js__["a" /* default */])(array, depth, false);
}


/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__difference_js__ = __webpack_require__(220);



// Return a version of the array that does not contain the specified value(s).
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(array, otherArrays) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__difference_js__["a" /* default */])(array, otherArrays);
}));


/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uniq_js__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flatten_js__ = __webpack_require__(68);




// Produce an array that contains the union: each distinct element from all of
// the passed-in arrays.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(arrays) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__uniq_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__flatten_js__["a" /* default */])(arrays, true, true));
}));


/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = intersection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contains_js__ = __webpack_require__(89);



// Produce an array that contains every item shared between all the
// passed-in arrays.
function intersection(array) {
  var result = [];
  var argsLength = arguments.length;
  for (var i = 0, length = Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(array); i < length; i++) {
    var item = array[i];
    if (Object(__WEBPACK_IMPORTED_MODULE_1__contains_js__["a" /* default */])(result, item)) continue;
    var j;
    for (j = 1; j < argsLength; j++) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__contains_js__["a" /* default */])(arguments[j], item)) break;
    }
    if (j === argsLength) result.push(item);
  }
  return result;
}


/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unzip_js__ = __webpack_require__(222);



// Zip together multiple lists into a single array -- elements that share
// an index go together.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__unzip_js__["a" /* default */]));


/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = object;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(31);


// Converts lists into objects. Pass either a single array of `[key, value]`
// pairs, or two parallel arrays of the same length -- one of keys, and one of
// the corresponding values. Passing by pairs is the reverse of `_.pairs`.
function object(list, values) {
  var result = {};
  for (var i = 0, length = Object(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(list); i < length; i++) {
    if (values) {
      result[list[i]] = values[i];
    } else {
      result[list[i][0]] = list[i][1];
    }
  }
  return result;
}


/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = range;
// Generate an integer Array containing an arithmetic progression. A port of
// the native Python `range()` function. See
// [the Python documentation](https://docs.python.org/library/functions.html#range).
function range(start, stop, step) {
  if (stop == null) {
    stop = start || 0;
    start = 0;
  }
  if (!step) {
    step = stop < start ? -1 : 1;
  }

  var length = Math.max(Math.ceil((stop - start) / step), 0);
  var range = Array(length);

  for (var idx = 0; idx < length; idx++, start += step) {
    range[idx] = start;
  }

  return range;
}


/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chunk;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(11);


// Chunk a single array into multiple arrays, each containing `count` or fewer
// items.
function chunk(array, count) {
  if (count == null || count < 1) return [];
  var result = [];
  var i = 0, length = array.length;
  while (i < length) {
    result.push(__WEBPACK_IMPORTED_MODULE_0__setup_js__["q" /* slice */].call(array, i, i += count));
  }
  return result;
}


/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mixin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__setup_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chainResult_js__ = __webpack_require__(223);






// Add your own custom functions to the Underscore object.
function mixin(obj) {
  Object(__WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__functions_js__["a" /* default */])(obj), function(name) {
    var func = __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */][name] = obj[name];
    __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].prototype[name] = function() {
      var args = [this._wrapped];
      __WEBPACK_IMPORTED_MODULE_3__setup_js__["o" /* push */].apply(args, arguments);
      return Object(__WEBPACK_IMPORTED_MODULE_4__chainResult_js__["a" /* default */])(this, func.apply(__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */], args));
    };
  });
  return __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */];
}


/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setup_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chainResult_js__ = __webpack_require__(223);





// Add all mutator `Array` functions to the wrapper.
Object(__WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */])(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
  var method = __WEBPACK_IMPORTED_MODULE_2__setup_js__["a" /* ArrayProto */][name];
  __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].prototype[name] = function() {
    var obj = this._wrapped;
    if (obj != null) {
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) {
        delete obj[0];
      }
    }
    return Object(__WEBPACK_IMPORTED_MODULE_3__chainResult_js__["a" /* default */])(this, obj);
  };
});

// Add all accessor `Array` functions to the wrapper.
Object(__WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */])(['concat', 'join', 'slice'], function(name) {
  var method = __WEBPACK_IMPORTED_MODULE_2__setup_js__["a" /* ArrayProto */][name];
  __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].prototype[name] = function() {
    var obj = this._wrapped;
    if (obj != null) obj = method.apply(obj, arguments);
    return Object(__WEBPACK_IMPORTED_MODULE_3__chainResult_js__["a" /* default */])(this, obj);
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */]);


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(125);
var regions = __webpack_require__(224);
var continents = {};

continents.asia = {
  name: 'Asia',
  regions: ['centralAsia', 'southernAsia', 'southeastAsia', 'eastAsia', 'westernAsia'],
  countries: _.flatten([
    regions.centralAsia.countries,
    regions.southernAsia.countries,
    regions.southeastAsia.countries,
    regions.eastAsia.countries,
    regions.westernAsia.countries
  ])
  .sort()
};

continents.africa = {
  name: 'Africa',
  regions: ['centralAfrica', 'northAfrica', 'southernAfrica', 'eastAfrica', 'westAfrica'],
  countries: _.flatten([
      regions.centralAfrica.countries,
      regions.northAfrica.countries,
      regions.southernAfrica.countries,
      regions.eastAfrica.countries,
      regions.westAfrica.countries
  ])
  .sort()
};

continents.northAmerica = {
  name: 'North America',
  regions: ['centralAmerica', 'northernAmerica', 'caribbean'],
  countries: _.flatten([
    regions.centralAmerica.countries,
    regions.northernAmerica.countries,
    regions.caribbean.countries
  ])
  .sort()
};

continents.southAmerica = {
  name: 'South America',
  regions: ['southAmerica'],
  countries: _.flatten([
    regions.southAmerica.countries
  ])
  .sort()
}

continents.antartica = {
  name: 'Antartica',
  regions: ['antartica'],
  countries: _.flatten([
    regions.antartica.countries
  ])
  .sort()
}

continents.europe = {
  name: 'Europe',
  regions: ['northernEurope', 'southernEurope', 'easternEurope', 'westernEurope'],
  countries: _.flatten([
    regions.northernEurope.countries,
    regions.southernEurope.countries,
    regions.easternEurope.countries,
    regions.westernEurope.countries
  ])
  .sort()
}

continents.oceania = {
  name: 'Oceania',
  regions: ['australia', 'melanesia', 'micronesia', 'polynesia'],
  countries: _.flatten([
    regions.australia.countries,
    regions.melanesia.countries,
    regions.micronesia.countries,
    regions.polynesia.countries
  ])
  .sort()
};

module.exports = continents;


/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports = [{"alpha2":"AC","alpha3":"","countryCallingCodes":["+247"],"currencies":["USD"],"emoji":"","ioc":"SHP","languages":["eng"],"name":"Ascension Island","status":"reserved"},{"alpha2":"AD","alpha3":"AND","countryCallingCodes":["+376"],"currencies":["EUR"],"emoji":"🇦🇩","ioc":"AND","languages":["cat"],"name":"Andorra","status":"assigned"},{"alpha2":"AE","alpha3":"ARE","countryCallingCodes":["+971"],"currencies":["AED"],"emoji":"🇦🇪","ioc":"UAE","languages":["ara"],"name":"United Arab Emirates","status":"assigned"},{"alpha2":"AF","alpha3":"AFG","countryCallingCodes":["+93"],"currencies":["AFN"],"emoji":"🇦🇫","ioc":"AFG","languages":["pus"],"name":"Afghanistan","status":"assigned"},{"alpha2":"AG","alpha3":"ATG","countryCallingCodes":["+1 268"],"currencies":["XCD"],"emoji":"🇦🇬","ioc":"ANT","languages":["eng"],"name":"Antigua And Barbuda","status":"assigned"},{"alpha2":"AI","alpha3":"AIA","countryCallingCodes":["+1 264"],"currencies":["XCD"],"emoji":"🇦🇮","ioc":"","languages":["eng"],"name":"Anguilla","status":"assigned"},{"alpha2":"AI","alpha3":"AFI","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"French Afar and Issas","status":"deleted"},{"alpha2":"AL","alpha3":"ALB","countryCallingCodes":["+355"],"currencies":["ALL"],"emoji":"🇦🇱","ioc":"ALB","languages":["sqi"],"name":"Albania","status":"assigned"},{"alpha2":"AM","alpha3":"ARM","countryCallingCodes":["+374"],"currencies":["AMD"],"emoji":"🇦🇲","ioc":"ARM","languages":["hye","rus"],"name":"Armenia","status":"assigned"},{"alpha2":"AN","alpha3":"ANT","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Netherlands Antilles","status":"deleted"},{"alpha2":"AO","alpha3":"AGO","countryCallingCodes":["+244"],"currencies":["AOA"],"emoji":"🇦🇴","ioc":"ANG","languages":["por"],"name":"Angola","status":"assigned"},{"alpha2":"AQ","alpha3":"ATA","countryCallingCodes":["+672"],"currencies":[],"emoji":"🇦🇶","ioc":"","languages":[],"name":"Antarctica","status":"assigned"},{"alpha2":"AR","alpha3":"ARG","countryCallingCodes":["+54"],"currencies":["ARS"],"emoji":"🇦🇷","ioc":"ARG","languages":["spa"],"name":"Argentina","status":"assigned"},{"alpha2":"AS","alpha3":"ASM","countryCallingCodes":["+1 684"],"currencies":["USD"],"emoji":"🇦🇸","ioc":"ASA","languages":["eng","smo"],"name":"American Samoa","status":"assigned"},{"alpha2":"AT","alpha3":"AUT","countryCallingCodes":["+43"],"currencies":["EUR"],"emoji":"🇦🇹","ioc":"AUT","languages":["deu"],"name":"Austria","status":"assigned"},{"alpha2":"AU","alpha3":"AUS","countryCallingCodes":["+61"],"currencies":["AUD"],"emoji":"🇦🇺","ioc":"AUS","languages":["eng"],"name":"Australia","status":"assigned"},{"alpha2":"AW","alpha3":"ABW","countryCallingCodes":["+297"],"currencies":["AWG"],"emoji":"🇦🇼","ioc":"ARU","languages":["nld"],"name":"Aruba","status":"assigned"},{"alpha2":"AX","alpha3":"ALA","countryCallingCodes":["+358"],"currencies":["EUR"],"emoji":"🇦🇽","ioc":"","languages":["swe"],"name":"Åland Islands","status":"assigned"},{"alpha2":"AZ","alpha3":"AZE","countryCallingCodes":["+994"],"currencies":["AZN"],"emoji":"🇦🇿","ioc":"AZE","languages":["aze"],"name":"Azerbaijan","status":"assigned"},{"alpha2":"BA","alpha3":"BIH","countryCallingCodes":["+387"],"currencies":["BAM"],"emoji":"🇧🇦","ioc":"BIH","languages":["bos","cre","srp"],"name":"Bosnia & Herzegovina","status":"assigned"},{"alpha2":"BB","alpha3":"BRB","countryCallingCodes":["+1 246"],"currencies":["BBD"],"emoji":"🇧🇧","ioc":"BAR","languages":["eng"],"name":"Barbados","status":"assigned"},{"alpha2":"BD","alpha3":"BGD","countryCallingCodes":["+880"],"currencies":["BDT"],"emoji":"🇧🇩","ioc":"BAN","languages":["ben"],"name":"Bangladesh","status":"assigned"},{"alpha2":"BE","alpha3":"BEL","countryCallingCodes":["+32"],"currencies":["EUR"],"emoji":"🇧🇪","ioc":"BEL","languages":["nld","fra","deu"],"name":"Belgium","status":"assigned"},{"alpha2":"BF","alpha3":"BFA","countryCallingCodes":["+226"],"currencies":["XOF"],"emoji":"🇧🇫","ioc":"BUR","languages":["fra"],"name":"Burkina Faso","status":"assigned"},{"alpha2":"BG","alpha3":"BGR","countryCallingCodes":["+359"],"currencies":["BGN"],"emoji":"🇧🇬","ioc":"BUL","languages":["bul"],"name":"Bulgaria","status":"assigned"},{"alpha2":"BH","alpha3":"BHR","countryCallingCodes":["+973"],"currencies":["BHD"],"emoji":"🇧🇭","ioc":"BRN","languages":["ara"],"name":"Bahrain","status":"assigned"},{"alpha2":"BI","alpha3":"BDI","countryCallingCodes":["+257"],"currencies":["BIF"],"emoji":"🇧🇮","ioc":"BDI","languages":["fra"],"name":"Burundi","status":"assigned"},{"alpha2":"BJ","alpha3":"BEN","countryCallingCodes":["+229"],"currencies":["XOF"],"emoji":"🇧🇯","ioc":"BEN","languages":["fra"],"name":"Benin","status":"assigned"},{"alpha2":"BL","alpha3":"BLM","countryCallingCodes":["+590"],"currencies":["EUR"],"emoji":"🇧🇱","ioc":"","languages":["fra"],"name":"Saint Barthélemy","status":"assigned"},{"alpha2":"BM","alpha3":"BMU","countryCallingCodes":["+1 441"],"currencies":["BMD"],"emoji":"🇧🇲","ioc":"BER","languages":["eng"],"name":"Bermuda","status":"assigned"},{"alpha2":"BN","alpha3":"BRN","countryCallingCodes":["+673"],"currencies":["BND"],"emoji":"🇧🇳","ioc":"BRU","languages":["msa","eng"],"name":"Brunei Darussalam","status":"assigned"},{"alpha2":"BO","alpha3":"BOL","countryCallingCodes":["+591"],"currencies":["BOB","BOV"],"emoji":"🇧🇴","ioc":"BOL","languages":["spa","aym","que"],"name":"Bolivia, Plurinational State Of","status":"assigned"},{"alpha2":"BQ","alpha3":"BES","countryCallingCodes":["+599"],"currencies":["USD"],"emoji":"🇧🇶","ioc":"","languages":["nld"],"name":"Bonaire, Saint Eustatius And Saba","status":"assigned"},{"alpha2":"BQ","alpha3":"ATB","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"British Antarctic Territory","status":"deleted"},{"alpha2":"BR","alpha3":"BRA","countryCallingCodes":["+55"],"currencies":["BRL"],"emoji":"🇧🇷","ioc":"BRA","languages":["por"],"name":"Brazil","status":"assigned"},{"alpha2":"BS","alpha3":"BHS","countryCallingCodes":["+1 242"],"currencies":["BSD"],"emoji":"🇧🇸","ioc":"BAH","languages":["eng"],"name":"Bahamas","status":"assigned"},{"alpha2":"BT","alpha3":"BTN","countryCallingCodes":["+975"],"currencies":["INR","BTN"],"emoji":"🇧🇹","ioc":"BHU","languages":["dzo"],"name":"Bhutan","status":"assigned"},{"alpha2":"BU","alpha3":"BUR","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Burma","status":"deleted"},{"alpha2":"BV","alpha3":"BVT","countryCallingCodes":[],"currencies":["NOK"],"emoji":"🇧🇻","ioc":"","languages":[],"name":"Bouvet Island","status":"assigned"},{"alpha2":"BW","alpha3":"BWA","countryCallingCodes":["+267"],"currencies":["BWP"],"emoji":"🇧🇼","ioc":"BOT","languages":["eng","tsn"],"name":"Botswana","status":"assigned"},{"alpha2":"BY","alpha3":"BLR","countryCallingCodes":["+375"],"currencies":["BYR"],"emoji":"🇧🇾","ioc":"BLR","languages":["bel","rus"],"name":"Belarus","status":"assigned"},{"alpha2":"BY","alpha3":"BYS","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Byelorussian SSR","status":"deleted"},{"alpha2":"BZ","alpha3":"BLZ","countryCallingCodes":["+501"],"currencies":["BZD"],"emoji":"🇧🇿","ioc":"BIZ","languages":["eng"],"name":"Belize","status":"assigned"},{"alpha2":"CA","alpha3":"CAN","countryCallingCodes":["+1"],"currencies":["CAD"],"emoji":"🇨🇦","ioc":"CAN","languages":["eng","fra"],"name":"Canada","status":"assigned"},{"alpha2":"CC","alpha3":"CCK","countryCallingCodes":["+61"],"currencies":["AUD"],"emoji":"🇨🇨","ioc":"","languages":["eng"],"name":"Cocos (Keeling) Islands","status":"assigned"},{"alpha2":"CD","alpha3":"COD","countryCallingCodes":["+243"],"currencies":["CDF"],"emoji":"🇨🇩","ioc":"COD","languages":["fra","lin","kon","swa"],"name":"Democratic Republic Of Congo","status":"assigned"},{"alpha2":"CF","alpha3":"CAF","countryCallingCodes":["+236"],"currencies":["XAF"],"emoji":"🇨🇫","ioc":"CAF","languages":["fra","sag"],"name":"Central African Republic","status":"assigned"},{"alpha2":"CG","alpha3":"COG","countryCallingCodes":["+242"],"currencies":["XAF"],"emoji":"🇨🇬","ioc":"CGO","languages":["fra","lin"],"name":"Republic Of Congo","status":"assigned"},{"alpha2":"CH","alpha3":"CHE","countryCallingCodes":["+41"],"currencies":["CHF","CHE","CHW"],"emoji":"🇨🇭","ioc":"SUI","languages":["deu","fra","ita","roh"],"name":"Switzerland","status":"assigned"},{"alpha2":"CI","alpha3":"CIV","countryCallingCodes":["+225"],"currencies":["XOF"],"emoji":"🇨🇮","ioc":"CIV","languages":["fra"],"name":"Côte d'Ivoire","status":"assigned"},{"alpha2":"CK","alpha3":"COK","countryCallingCodes":["+682"],"currencies":["NZD"],"emoji":"🇨🇰","ioc":"COK","languages":["eng","mri"],"name":"Cook Islands","status":"assigned"},{"alpha2":"CL","alpha3":"CHL","countryCallingCodes":["+56"],"currencies":["CLP","CLF"],"emoji":"🇨🇱","ioc":"CHI","languages":["spa"],"name":"Chile","status":"assigned"},{"alpha2":"CM","alpha3":"CMR","countryCallingCodes":["+237"],"currencies":["XAF"],"emoji":"🇨🇲","ioc":"CMR","languages":["eng","fra"],"name":"Cameroon","status":"assigned"},{"alpha2":"CN","alpha3":"CHN","countryCallingCodes":["+86"],"currencies":["CNY"],"emoji":"🇨🇳","ioc":"CHN","languages":["zho"],"name":"China","status":"assigned"},{"alpha2":"CO","alpha3":"COL","countryCallingCodes":["+57"],"currencies":["COP","COU"],"emoji":"🇨🇴","ioc":"COL","languages":["spa"],"name":"Colombia","status":"assigned"},{"alpha2":"CP","alpha3":"","countryCallingCodes":[],"currencies":["EUR"],"emoji":"","ioc":"","languages":[],"name":"Clipperton Island","status":"reserved"},{"alpha2":"CR","alpha3":"CRI","countryCallingCodes":["+506"],"currencies":["CRC"],"emoji":"🇨🇷","ioc":"CRC","languages":["spa"],"name":"Costa Rica","status":"assigned"},{"alpha2":"CS","alpha3":"CSK","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Czechoslovakia","status":"deleted"},{"alpha2":"CS","alpha3":"SCG","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Serbia and Montenegro","status":"deleted"},{"alpha2":"CT","alpha3":"CTE","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Canton and Enderbury Islands","status":"deleted"},{"alpha2":"CU","alpha3":"CUB","countryCallingCodes":["+53"],"currencies":["CUP","CUC"],"emoji":"🇨🇺","ioc":"CUB","languages":["spa"],"name":"Cuba","status":"assigned"},{"alpha2":"CV","alpha3":"CPV","countryCallingCodes":["+238"],"currencies":["CVE"],"emoji":"🇨🇻","ioc":"CPV","languages":["por"],"name":"Cabo Verde","status":"assigned"},{"alpha2":"CW","alpha3":"CUW","countryCallingCodes":["+599"],"currencies":["ANG"],"emoji":"🇨🇼","ioc":"","languages":["nld"],"name":"Curacao","status":"assigned"},{"alpha2":"CX","alpha3":"CXR","countryCallingCodes":["+61"],"currencies":["AUD"],"emoji":"🇨🇽","ioc":"","languages":["eng"],"name":"Christmas Island","status":"assigned"},{"alpha2":"CY","alpha3":"CYP","countryCallingCodes":["+357"],"currencies":["EUR"],"emoji":"🇨🇾","ioc":"CYP","languages":["ell","tur"],"name":"Cyprus","status":"assigned"},{"alpha2":"CZ","alpha3":"CZE","countryCallingCodes":["+420"],"currencies":["CZK"],"emoji":"🇨🇿","ioc":"CZE","languages":["ces"],"name":"Czech Republic","status":"assigned"},{"alpha2":"DD","alpha3":"DDR","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"German Democratic Republic","status":"deleted"},{"alpha2":"DE","alpha3":"DEU","countryCallingCodes":["+49"],"currencies":["EUR"],"emoji":"🇩🇪","ioc":"GER","languages":["deu"],"name":"Germany","status":"assigned"},{"alpha2":"DG","alpha3":"","countryCallingCodes":[],"currencies":["USD"],"emoji":"","ioc":"","languages":[],"name":"Diego Garcia","status":"reserved"},{"alpha2":"DJ","alpha3":"DJI","countryCallingCodes":["+253"],"currencies":["DJF"],"emoji":"🇩🇯","ioc":"DJI","languages":["ara","fra"],"name":"Djibouti","status":"assigned"},{"alpha2":"DK","alpha3":"DNK","countryCallingCodes":["+45"],"currencies":["DKK"],"emoji":"🇩🇰","ioc":"DEN","languages":["dan"],"name":"Denmark","status":"assigned"},{"alpha2":"DM","alpha3":"DMA","countryCallingCodes":["+1 767"],"currencies":["XCD"],"emoji":"🇩🇲","ioc":"DMA","languages":["eng"],"name":"Dominica","status":"assigned"},{"alpha2":"DO","alpha3":"DOM","countryCallingCodes":["+1 809","+1 829","+1 849"],"currencies":["DOP"],"emoji":"🇩🇴","ioc":"DOM","languages":["spa"],"name":"Dominican Republic","status":"assigned"},{"alpha2":"DY","alpha3":"DHY","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Dahomey","status":"deleted"},{"alpha2":"DZ","alpha3":"DZA","countryCallingCodes":["+213"],"currencies":["DZD"],"emoji":"🇩🇿","ioc":"ALG","languages":["ara"],"name":"Algeria","status":"assigned"},{"alpha2":"EA","alpha3":"","countryCallingCodes":[],"currencies":["EUR"],"emoji":"","ioc":"","languages":[],"name":"Ceuta, Mulilla","status":"reserved"},{"alpha2":"EC","alpha3":"ECU","countryCallingCodes":["+593"],"currencies":["USD"],"emoji":"🇪🇨","ioc":"ECU","languages":["spa","que"],"name":"Ecuador","status":"assigned"},{"alpha2":"EE","alpha3":"EST","countryCallingCodes":["+372"],"currencies":["EUR"],"emoji":"🇪🇪","ioc":"EST","languages":["est"],"name":"Estonia","status":"assigned"},{"alpha2":"EG","alpha3":"EGY","countryCallingCodes":["+20"],"currencies":["EGP"],"emoji":"🇪🇬","ioc":"EGY","languages":["ara"],"name":"Egypt","status":"assigned"},{"alpha2":"EH","alpha3":"ESH","countryCallingCodes":["+212"],"currencies":["MAD"],"emoji":"🇪🇭","ioc":"","languages":[],"name":"Western Sahara","status":"assigned"},{"alpha2":"ER","alpha3":"ERI","countryCallingCodes":["+291"],"currencies":["ERN"],"emoji":"🇪🇷","ioc":"ERI","languages":["eng","ara","tir"],"name":"Eritrea","status":"assigned"},{"alpha2":"ES","alpha3":"ESP","countryCallingCodes":["+34"],"currencies":["EUR"],"emoji":"🇪🇸","ioc":"ESP","languages":["spa"],"name":"Spain","status":"assigned"},{"alpha2":"ET","alpha3":"ETH","countryCallingCodes":["+251"],"currencies":["ETB"],"emoji":"🇪🇹","ioc":"ETH","languages":["amh"],"name":"Ethiopia","status":"assigned"},{"alpha2":"EU","alpha3":"","countryCallingCodes":["+388"],"currencies":["EUR"],"emoji":"🇪🇺","ioc":"","languages":[],"name":"European Union","status":"reserved"},{"alpha2":"FI","alpha3":"FIN","countryCallingCodes":["+358"],"currencies":["EUR"],"emoji":"🇫🇮","ioc":"FIN","languages":["fin","swe"],"name":"Finland","status":"assigned"},{"alpha2":"FJ","alpha3":"FJI","countryCallingCodes":["+679"],"currencies":["FJD"],"emoji":"🇫🇯","ioc":"FIJ","languages":["eng","fij"],"name":"Fiji","status":"assigned"},{"alpha2":"FK","alpha3":"FLK","countryCallingCodes":["+500"],"currencies":["FKP"],"emoji":"🇫🇰","ioc":"","languages":["eng"],"name":"Falkland Islands","status":"assigned"},{"alpha2":"FM","alpha3":"FSM","countryCallingCodes":["+691"],"currencies":["USD"],"emoji":"🇫🇲","ioc":"FSM","languages":["eng"],"name":"Micronesia, Federated States Of","status":"assigned"},{"alpha2":"FO","alpha3":"FRO","countryCallingCodes":["+298"],"currencies":["DKK"],"emoji":"🇫🇴","ioc":"FAI","languages":["fao","dan"],"name":"Faroe Islands","status":"assigned"},{"alpha2":"FQ","alpha3":"ATF","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"French Southern and Antarctic Territories","status":"deleted"},{"alpha2":"FR","alpha3":"FRA","countryCallingCodes":["+33"],"currencies":["EUR"],"emoji":"🇫🇷","ioc":"FRA","languages":["fra"],"name":"France","status":"assigned"},{"alpha2":"FX","alpha3":"","countryCallingCodes":["+241"],"currencies":["EUR"],"emoji":"","ioc":"","languages":["fra"],"name":"France, Metropolitan","status":"reserved"},{"alpha2":"GA","alpha3":"GAB","countryCallingCodes":["+241"],"currencies":["XAF"],"emoji":"🇬🇦","ioc":"GAB","languages":["fra"],"name":"Gabon","status":"assigned"},{"alpha2":"GB","alpha3":"GBR","countryCallingCodes":["+44"],"currencies":["GBP"],"emoji":"🇬🇧","ioc":"GBR","languages":["eng","cor","gle","gla","cym"],"name":"United Kingdom","status":"assigned"},{"alpha2":"GD","alpha3":"GRD","countryCallingCodes":["+473"],"currencies":["XCD"],"emoji":"🇬🇩","ioc":"GRN","languages":["eng"],"name":"Grenada","status":"assigned"},{"alpha2":"GE","alpha3":"GEO","countryCallingCodes":["+995"],"currencies":["GEL"],"emoji":"🇬🇪","ioc":"GEO","languages":["kat"],"name":"Georgia","status":"assigned"},{"alpha2":"GE","alpha3":"GEL","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Gilbert and Ellice Islands","status":"deleted"},{"alpha2":"GF","alpha3":"GUF","countryCallingCodes":["+594"],"currencies":["EUR"],"emoji":"🇬🇫","ioc":"","languages":["fra"],"name":"French Guiana","status":"assigned"},{"alpha2":"GG","alpha3":"GGY","countryCallingCodes":["+44"],"currencies":["GBP"],"emoji":"🇬🇬","ioc":"GCI","languages":["fra"],"name":"Guernsey","status":"assigned"},{"alpha2":"GH","alpha3":"GHA","countryCallingCodes":["+233"],"currencies":["GHS"],"emoji":"🇬🇭","ioc":"GHA","languages":["eng"],"name":"Ghana","status":"assigned"},{"alpha2":"GI","alpha3":"GIB","countryCallingCodes":["+350"],"currencies":["GIP"],"emoji":"🇬🇮","ioc":"","languages":["eng"],"name":"Gibraltar","status":"assigned"},{"alpha2":"GL","alpha3":"GRL","countryCallingCodes":["+299"],"currencies":["DKK"],"emoji":"🇬🇱","ioc":"","languages":["kal"],"name":"Greenland","status":"assigned"},{"alpha2":"GM","alpha3":"GMB","countryCallingCodes":["+220"],"currencies":["GMD"],"emoji":"🇬🇲","ioc":"GAM","languages":["eng"],"name":"Gambia","status":"assigned"},{"alpha2":"GN","alpha3":"GIN","countryCallingCodes":["+224"],"currencies":["GNF"],"emoji":"🇬🇳","ioc":"GUI","languages":["fra"],"name":"Guinea","status":"assigned"},{"alpha2":"GP","alpha3":"GLP","countryCallingCodes":["+590"],"currencies":["EUR"],"emoji":"🇬🇵","ioc":"","languages":["fra"],"name":"Guadeloupe","status":"assigned"},{"alpha2":"GQ","alpha3":"GNQ","countryCallingCodes":["+240"],"currencies":["XAF"],"emoji":"🇬🇶","ioc":"GEQ","languages":["spa","fra","por"],"name":"Equatorial Guinea","status":"assigned"},{"alpha2":"GR","alpha3":"GRC","countryCallingCodes":["+30"],"currencies":["EUR"],"emoji":"🇬🇷","ioc":"GRE","languages":["ell"],"name":"Greece","status":"assigned"},{"alpha2":"GS","alpha3":"SGS","countryCallingCodes":[],"currencies":["GBP"],"emoji":"🇬🇸","ioc":"","languages":["eng"],"name":"South Georgia And The South Sandwich Islands","status":"assigned"},{"alpha2":"GT","alpha3":"GTM","countryCallingCodes":["+502"],"currencies":["GTQ"],"emoji":"🇬🇹","ioc":"GUA","languages":["spa"],"name":"Guatemala","status":"assigned"},{"alpha2":"GU","alpha3":"GUM","countryCallingCodes":["+1 671"],"currencies":["USD"],"emoji":"🇬🇺","ioc":"GUM","languages":["eng"],"name":"Guam","status":"assigned"},{"alpha2":"GW","alpha3":"GNB","countryCallingCodes":["+245"],"currencies":["XOF"],"emoji":"🇬🇼","ioc":"GBS","languages":["por"],"name":"Guinea-bissau","status":"assigned"},{"alpha2":"GY","alpha3":"GUY","countryCallingCodes":["+592"],"currencies":["GYD"],"emoji":"🇬🇾","ioc":"GUY","languages":["eng"],"name":"Guyana","status":"assigned"},{"alpha2":"HK","alpha3":"HKG","countryCallingCodes":["+852"],"currencies":["HKD"],"emoji":"🇭🇰","ioc":"HKG","languages":["zho","eng"],"name":"Hong Kong","status":"assigned"},{"alpha2":"HM","alpha3":"HMD","countryCallingCodes":[],"currencies":["AUD"],"emoji":"🇭🇲","ioc":"","languages":[],"name":"Heard Island And McDonald Islands","status":"assigned"},{"alpha2":"HN","alpha3":"HND","countryCallingCodes":["+504"],"currencies":["HNL"],"emoji":"🇭🇳","ioc":"HON","languages":["spa"],"name":"Honduras","status":"assigned"},{"alpha2":"HR","alpha3":"HRV","countryCallingCodes":["+385"],"currencies":["HRK"],"emoji":"🇭🇷","ioc":"CRO","languages":["hrv"],"name":"Croatia","status":"assigned"},{"alpha2":"HT","alpha3":"HTI","countryCallingCodes":["+509"],"currencies":["HTG","USD"],"emoji":"🇭🇹","ioc":"HAI","languages":["fra","hat"],"name":"Haiti","status":"assigned"},{"alpha2":"HU","alpha3":"HUN","countryCallingCodes":["+36"],"currencies":["HUF"],"emoji":"🇭🇺","ioc":"HUN","languages":["hun"],"name":"Hungary","status":"assigned"},{"alpha2":"HV","alpha3":"HVO","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Upper Volta","status":"deleted"},{"alpha2":"IC","alpha3":"","countryCallingCodes":[],"currencies":["EUR"],"emoji":"","ioc":"","languages":[],"name":"Canary Islands","status":"reserved"},{"alpha2":"ID","alpha3":"IDN","countryCallingCodes":["+62"],"currencies":["IDR"],"emoji":"🇮🇩","ioc":"INA","languages":["ind"],"name":"Indonesia","status":"assigned"},{"alpha2":"IE","alpha3":"IRL","countryCallingCodes":["+353"],"currencies":["EUR"],"emoji":"🇮🇪","ioc":"IRL","languages":["eng","gle"],"name":"Ireland","status":"assigned"},{"alpha2":"IL","alpha3":"ISR","countryCallingCodes":["+972"],"currencies":["ILS"],"emoji":"🇮🇱","ioc":"ISR","languages":["heb","ara","eng"],"name":"Israel","status":"assigned"},{"alpha2":"IM","alpha3":"IMN","countryCallingCodes":["+44"],"currencies":["GBP"],"emoji":"🇮🇲","ioc":"","languages":["eng","glv"],"name":"Isle Of Man","status":"assigned"},{"alpha2":"IN","alpha3":"IND","countryCallingCodes":["+91"],"currencies":["INR"],"emoji":"🇮🇳","ioc":"IND","languages":["eng","hin"],"name":"India","status":"assigned"},{"alpha2":"IO","alpha3":"IOT","countryCallingCodes":["+246"],"currencies":["USD"],"emoji":"🇮🇴","ioc":"","languages":["eng"],"name":"British Indian Ocean Territory","status":"assigned"},{"alpha2":"IQ","alpha3":"IRQ","countryCallingCodes":["+964"],"currencies":["IQD"],"emoji":"🇮🇶","ioc":"IRQ","languages":["ara","kur"],"name":"Iraq","status":"assigned"},{"alpha2":"IR","alpha3":"IRN","countryCallingCodes":["+98"],"currencies":["IRR"],"emoji":"🇮🇷","ioc":"IRI","languages":["fas"],"name":"Iran, Islamic Republic Of","status":"assigned"},{"alpha2":"IS","alpha3":"ISL","countryCallingCodes":["+354"],"currencies":["ISK"],"emoji":"🇮🇸","ioc":"ISL","languages":["isl"],"name":"Iceland","status":"assigned"},{"alpha2":"IT","alpha3":"ITA","countryCallingCodes":["+39"],"currencies":["EUR"],"emoji":"🇮🇹","ioc":"ITA","languages":["ita"],"name":"Italy","status":"assigned"},{"alpha2":"JE","alpha3":"JEY","countryCallingCodes":["+44"],"currencies":["GBP"],"emoji":"🇯🇪","ioc":"JCI","languages":["eng","fra"],"name":"Jersey","status":"assigned"},{"alpha2":"JM","alpha3":"JAM","countryCallingCodes":["+1 876"],"currencies":["JMD"],"emoji":"🇯🇲","ioc":"JAM","languages":["eng"],"name":"Jamaica","status":"assigned"},{"alpha2":"JO","alpha3":"JOR","countryCallingCodes":["+962"],"currencies":["JOD"],"emoji":"🇯🇴","ioc":"JOR","languages":["ara"],"name":"Jordan","status":"assigned"},{"alpha2":"JP","alpha3":"JPN","countryCallingCodes":["+81"],"currencies":["JPY"],"emoji":"🇯🇵","ioc":"JPN","languages":["jpn"],"name":"Japan","status":"assigned"},{"alpha2":"JT","alpha3":"JTN","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Johnston Island","status":"deleted"},{"alpha2":"KE","alpha3":"KEN","countryCallingCodes":["+254"],"currencies":["KES"],"emoji":"🇰🇪","ioc":"KEN","languages":["eng","swa"],"name":"Kenya","status":"assigned"},{"alpha2":"KG","alpha3":"KGZ","countryCallingCodes":["+996"],"currencies":["KGS"],"emoji":"🇰🇬","ioc":"KGZ","languages":["rus"],"name":"Kyrgyzstan","status":"assigned"},{"alpha2":"KH","alpha3":"KHM","countryCallingCodes":["+855"],"currencies":["KHR"],"emoji":"🇰🇭","ioc":"CAM","languages":["khm"],"name":"Cambodia","status":"assigned"},{"alpha2":"KI","alpha3":"KIR","countryCallingCodes":["+686"],"currencies":["AUD"],"emoji":"🇰🇮","ioc":"KIR","languages":["eng"],"name":"Kiribati","status":"assigned"},{"alpha2":"KM","alpha3":"COM","countryCallingCodes":["+269"],"currencies":["KMF"],"emoji":"🇰🇲","ioc":"COM","languages":["ara","fra"],"name":"Comoros","status":"assigned"},{"alpha2":"KN","alpha3":"KNA","countryCallingCodes":["+1 869"],"currencies":["XCD"],"emoji":"🇰🇳","ioc":"SKN","languages":["eng"],"name":"Saint Kitts And Nevis","status":"assigned"},{"alpha2":"KP","alpha3":"PRK","countryCallingCodes":["+850"],"currencies":["KPW"],"emoji":"🇰🇵","ioc":"PRK","languages":["kor"],"name":"Korea, Democratic People's Republic Of","status":"assigned"},{"alpha2":"KR","alpha3":"KOR","countryCallingCodes":["+82"],"currencies":["KRW"],"emoji":"🇰🇷","ioc":"KOR","languages":["kor"],"name":"Korea, Republic Of","status":"assigned"},{"alpha2":"KW","alpha3":"KWT","countryCallingCodes":["+965"],"currencies":["KWD"],"emoji":"🇰🇼","ioc":"KUW","languages":["ara"],"name":"Kuwait","status":"assigned"},{"alpha2":"KY","alpha3":"CYM","countryCallingCodes":["+1 345"],"currencies":["KYD"],"emoji":"🇰🇾","ioc":"CAY","languages":["eng"],"name":"Cayman Islands","status":"assigned"},{"alpha2":"KZ","alpha3":"KAZ","countryCallingCodes":["+7","+7 6","+7 7"],"currencies":["KZT"],"emoji":"🇰🇿","ioc":"KAZ","languages":["kaz","rus"],"name":"Kazakhstan","status":"assigned"},{"alpha2":"LA","alpha3":"LAO","countryCallingCodes":["+856"],"currencies":["LAK"],"emoji":"🇱🇦","ioc":"LAO","languages":["lao"],"name":"Lao People's Democratic Republic","status":"assigned"},{"alpha2":"LB","alpha3":"LBN","countryCallingCodes":["+961"],"currencies":["LBP"],"emoji":"🇱🇧","ioc":"LIB","languages":["ara","hye"],"name":"Lebanon","status":"assigned"},{"alpha2":"LC","alpha3":"LCA","countryCallingCodes":["+1 758"],"currencies":["XCD"],"emoji":"🇱🇨","ioc":"LCA","languages":["eng"],"name":"Saint Lucia","status":"assigned"},{"alpha2":"LI","alpha3":"LIE","countryCallingCodes":["+423"],"currencies":["CHF"],"emoji":"🇱🇮","ioc":"LIE","languages":["deu"],"name":"Liechtenstein","status":"assigned"},{"alpha2":"LK","alpha3":"LKA","countryCallingCodes":["+94"],"currencies":["LKR"],"emoji":"🇱🇰","ioc":"SRI","languages":["sin","tam"],"name":"Sri Lanka","status":"assigned"},{"alpha2":"LR","alpha3":"LBR","countryCallingCodes":["+231"],"currencies":["LRD"],"emoji":"🇱🇷","ioc":"LBR","languages":["eng"],"name":"Liberia","status":"assigned"},{"alpha2":"LS","alpha3":"LSO","countryCallingCodes":["+266"],"currencies":["LSL","ZAR"],"emoji":"🇱🇸","ioc":"LES","languages":["eng","sot"],"name":"Lesotho","status":"assigned"},{"alpha2":"LT","alpha3":"LTU","countryCallingCodes":["+370"],"currencies":["EUR"],"emoji":"🇱🇹","ioc":"LTU","languages":["lit"],"name":"Lithuania","status":"assigned"},{"alpha2":"LU","alpha3":"LUX","countryCallingCodes":["+352"],"currencies":["EUR"],"emoji":"🇱🇺","ioc":"LUX","languages":["fra","deu","ltz"],"name":"Luxembourg","status":"assigned"},{"alpha2":"LV","alpha3":"LVA","countryCallingCodes":["+371"],"currencies":["EUR"],"emoji":"🇱🇻","ioc":"LAT","languages":["lav"],"name":"Latvia","status":"assigned"},{"alpha2":"LY","alpha3":"LBY","countryCallingCodes":["+218"],"currencies":["LYD"],"emoji":"🇱🇾","ioc":"LBA","languages":["ara"],"name":"Libya","status":"assigned"},{"alpha2":"MA","alpha3":"MAR","countryCallingCodes":["+212"],"currencies":["MAD"],"emoji":"🇲🇦","ioc":"MAR","languages":["ara"],"name":"Morocco","status":"assigned"},{"alpha2":"MC","alpha3":"MCO","countryCallingCodes":["+377"],"currencies":["EUR"],"emoji":"🇲🇨","ioc":"MON","languages":["fra"],"name":"Monaco","status":"assigned"},{"alpha2":"MD","alpha3":"MDA","countryCallingCodes":["+373"],"currencies":["MDL"],"emoji":"🇲🇩","ioc":"MDA","languages":["ron"],"name":"Moldova","status":"assigned"},{"alpha2":"ME","alpha3":"MNE","countryCallingCodes":["+382"],"currencies":["EUR"],"emoji":"🇲🇪","ioc":"MNE","languages":["mot"],"name":"Montenegro","status":"assigned"},{"alpha2":"MF","alpha3":"MAF","countryCallingCodes":["+590"],"currencies":["EUR"],"emoji":"🇲🇫","ioc":"","languages":["fra"],"name":"Saint Martin","status":"assigned"},{"alpha2":"MG","alpha3":"MDG","countryCallingCodes":["+261"],"currencies":["MGA"],"emoji":"🇲🇬","ioc":"MAD","languages":["fra","mlg"],"name":"Madagascar","status":"assigned"},{"alpha2":"MH","alpha3":"MHL","countryCallingCodes":["+692"],"currencies":["USD"],"emoji":"🇲🇭","ioc":"MHL","languages":["eng","mah"],"name":"Marshall Islands","status":"assigned"},{"alpha2":"MI","alpha3":"MID","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Midway Islands","status":"deleted"},{"alpha2":"MK","alpha3":"MKD","countryCallingCodes":["+389"],"currencies":["MKD"],"emoji":"🇲🇰","ioc":"MKD","languages":["mkd"],"name":"Macedonia, The Former Yugoslav Republic Of","status":"assigned"},{"alpha2":"ML","alpha3":"MLI","countryCallingCodes":["+223"],"currencies":["XOF"],"emoji":"🇲🇱","ioc":"MLI","languages":["fra"],"name":"Mali","status":"assigned"},{"alpha2":"MM","alpha3":"MMR","countryCallingCodes":["+95"],"currencies":["MMK"],"emoji":"🇲🇲","ioc":"MYA","languages":["mya"],"name":"Myanmar","status":"assigned"},{"alpha2":"MN","alpha3":"MNG","countryCallingCodes":["+976"],"currencies":["MNT"],"emoji":"🇲🇳","ioc":"MGL","languages":["mon"],"name":"Mongolia","status":"assigned"},{"alpha2":"MO","alpha3":"MAC","countryCallingCodes":["+853"],"currencies":["MOP"],"emoji":"🇲🇴","ioc":"MAC","languages":["zho","por"],"name":"Macao","status":"assigned"},{"alpha2":"MP","alpha3":"MNP","countryCallingCodes":["+1 670"],"currencies":["USD"],"emoji":"🇲🇵","ioc":"","languages":["eng"],"name":"Northern Mariana Islands","status":"assigned"},{"alpha2":"MQ","alpha3":"MTQ","countryCallingCodes":["+596"],"currencies":["EUR"],"emoji":"🇲🇶","ioc":"","languages":[],"name":"Martinique","status":"assigned"},{"alpha2":"MR","alpha3":"MRT","countryCallingCodes":["+222"],"currencies":["MRO"],"emoji":"🇲🇷","ioc":"MTN","languages":["ara","fra"],"name":"Mauritania","status":"assigned"},{"alpha2":"MS","alpha3":"MSR","countryCallingCodes":["+1 664"],"currencies":["XCD"],"emoji":"🇲🇸","ioc":"","languages":[],"name":"Montserrat","status":"assigned"},{"alpha2":"MT","alpha3":"MLT","countryCallingCodes":["+356"],"currencies":["EUR"],"emoji":"🇲🇹","ioc":"MLT","languages":["mlt","eng"],"name":"Malta","status":"assigned"},{"alpha2":"MU","alpha3":"MUS","countryCallingCodes":["+230"],"currencies":["MUR"],"emoji":"🇲🇺","ioc":"MRI","languages":["eng","fra"],"name":"Mauritius","status":"assigned"},{"alpha2":"MV","alpha3":"MDV","countryCallingCodes":["+960"],"currencies":["MVR"],"emoji":"🇲🇻","ioc":"MDV","languages":["div"],"name":"Maldives","status":"assigned"},{"alpha2":"MW","alpha3":"MWI","countryCallingCodes":["+265"],"currencies":["MWK"],"emoji":"🇲🇼","ioc":"MAW","languages":["eng","nya"],"name":"Malawi","status":"assigned"},{"alpha2":"MX","alpha3":"MEX","countryCallingCodes":["+52"],"currencies":["MXN","MXV"],"emoji":"🇲🇽","ioc":"MEX","languages":["spa"],"name":"Mexico","status":"assigned"},{"alpha2":"MY","alpha3":"MYS","countryCallingCodes":["+60"],"currencies":["MYR"],"emoji":"🇲🇾","ioc":"MAS","languages":["msa","eng"],"name":"Malaysia","status":"assigned"},{"alpha2":"MZ","alpha3":"MOZ","countryCallingCodes":["+258"],"currencies":["MZN"],"emoji":"🇲🇿","ioc":"MOZ","languages":["por"],"name":"Mozambique","status":"assigned"},{"alpha2":"NA","alpha3":"NAM","countryCallingCodes":["+264"],"currencies":["NAD","ZAR"],"emoji":"🇳🇦","ioc":"NAM","languages":["eng"],"name":"Namibia","status":"assigned"},{"alpha2":"NC","alpha3":"NCL","countryCallingCodes":["+687"],"currencies":["XPF"],"emoji":"🇳🇨","ioc":"","languages":["fra"],"name":"New Caledonia","status":"assigned"},{"alpha2":"NE","alpha3":"NER","countryCallingCodes":["+227"],"currencies":["XOF"],"emoji":"🇳🇪","ioc":"NIG","languages":["fra"],"name":"Niger","status":"assigned"},{"alpha2":"NF","alpha3":"NFK","countryCallingCodes":["+672"],"currencies":["AUD"],"emoji":"🇳🇫","ioc":"","languages":["eng"],"name":"Norfolk Island","status":"assigned"},{"alpha2":"NG","alpha3":"NGA","countryCallingCodes":["+234"],"currencies":["NGN"],"emoji":"🇳🇬","ioc":"NGR","languages":["eng"],"name":"Nigeria","status":"assigned"},{"alpha2":"NH","alpha3":"NHB","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"New Hebrides","status":"deleted"},{"alpha2":"NI","alpha3":"NIC","countryCallingCodes":["+505"],"currencies":["NIO"],"emoji":"🇳🇮","ioc":"NCA","languages":["spa"],"name":"Nicaragua","status":"assigned"},{"alpha2":"NL","alpha3":"NLD","countryCallingCodes":["+31"],"currencies":["EUR"],"emoji":"🇳🇱","ioc":"NED","languages":["nld"],"name":"Netherlands","status":"assigned"},{"alpha2":"NO","alpha3":"NOR","countryCallingCodes":["+47"],"currencies":["NOK"],"emoji":"🇳🇴","ioc":"NOR","languages":["nor"],"name":"Norway","status":"assigned"},{"alpha2":"NP","alpha3":"NPL","countryCallingCodes":["+977"],"currencies":["NPR"],"emoji":"🇳🇵","ioc":"NEP","languages":["nep"],"name":"Nepal","status":"assigned"},{"alpha2":"NQ","alpha3":"ATN","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Dronning Maud Land","status":"deleted"},{"alpha2":"NR","alpha3":"NRU","countryCallingCodes":["+674"],"currencies":["AUD"],"emoji":"🇳🇷","ioc":"NRU","languages":["eng","nau"],"name":"Nauru","status":"assigned"},{"alpha2":"NT","alpha3":"NTZ","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Neutral Zone","status":"deleted"},{"alpha2":"NU","alpha3":"NIU","countryCallingCodes":["+683"],"currencies":["NZD"],"emoji":"🇳🇺","ioc":"","languages":["eng"],"name":"Niue","status":"assigned"},{"alpha2":"NZ","alpha3":"NZL","countryCallingCodes":["+64"],"currencies":["NZD"],"emoji":"🇳🇿","ioc":"NZL","languages":["eng"],"name":"New Zealand","status":"assigned"},{"alpha2":"OM","alpha3":"OMN","countryCallingCodes":["+968"],"currencies":["OMR"],"emoji":"🇴🇲","ioc":"OMA","languages":["ara"],"name":"Oman","status":"assigned"},{"alpha2":"PA","alpha3":"PAN","countryCallingCodes":["+507"],"currencies":["PAB","USD"],"emoji":"🇵🇦","ioc":"PAN","languages":["spa"],"name":"Panama","status":"assigned"},{"alpha2":"PC","alpha3":"PCI","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Pacific Islands, Trust Territory of the","status":"deleted"},{"alpha2":"PE","alpha3":"PER","countryCallingCodes":["+51"],"currencies":["PEN"],"emoji":"🇵🇪","ioc":"PER","languages":["spa","aym","que"],"name":"Peru","status":"assigned"},{"alpha2":"PF","alpha3":"PYF","countryCallingCodes":["+689"],"currencies":["XPF"],"emoji":"🇵🇫","ioc":"","languages":["fra"],"name":"French Polynesia","status":"assigned"},{"alpha2":"PG","alpha3":"PNG","countryCallingCodes":["+675"],"currencies":["PGK"],"emoji":"🇵🇬","ioc":"PNG","languages":["eng"],"name":"Papua New Guinea","status":"assigned"},{"alpha2":"PH","alpha3":"PHL","countryCallingCodes":["+63"],"currencies":["PHP"],"emoji":"🇵🇭","ioc":"PHI","languages":["eng"],"name":"Philippines","status":"assigned"},{"alpha2":"PK","alpha3":"PAK","countryCallingCodes":["+92"],"currencies":["PKR"],"emoji":"🇵🇰","ioc":"PAK","languages":["urd","eng"],"name":"Pakistan","status":"assigned"},{"alpha2":"PL","alpha3":"POL","countryCallingCodes":["+48"],"currencies":["PLN"],"emoji":"🇵🇱","ioc":"POL","languages":["pol"],"name":"Poland","status":"assigned"},{"alpha2":"PM","alpha3":"SPM","countryCallingCodes":["+508"],"currencies":["EUR"],"emoji":"🇵🇲","ioc":"","languages":["eng"],"name":"Saint Pierre And Miquelon","status":"assigned"},{"alpha2":"PN","alpha3":"PCN","countryCallingCodes":["+872"],"currencies":["NZD"],"emoji":"🇵🇳","ioc":"","languages":["eng"],"name":"Pitcairn","status":"assigned"},{"alpha2":"PR","alpha3":"PRI","countryCallingCodes":["+1 787","+1 939"],"currencies":["USD"],"emoji":"🇵🇷","ioc":"PUR","languages":["spa","eng"],"name":"Puerto Rico","status":"assigned"},{"alpha2":"PS","alpha3":"PSE","countryCallingCodes":["+970"],"currencies":["JOD","EGP","ILS"],"emoji":"🇵🇸","ioc":"PLE","languages":["ara"],"name":"Palestinian Territory, Occupied","status":"assigned"},{"alpha2":"PT","alpha3":"PRT","countryCallingCodes":["+351"],"currencies":["EUR"],"emoji":"🇵🇹","ioc":"POR","languages":["por"],"name":"Portugal","status":"assigned"},{"alpha2":"PU","alpha3":"PUS","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"U.S. Miscellaneous Pacific Islands","status":"deleted"},{"alpha2":"PW","alpha3":"PLW","countryCallingCodes":["+680"],"currencies":["USD"],"emoji":"🇵🇼","ioc":"PLW","languages":["eng"],"name":"Palau","status":"assigned"},{"alpha2":"PY","alpha3":"PRY","countryCallingCodes":["+595"],"currencies":["PYG"],"emoji":"🇵🇾","ioc":"PAR","languages":["spa"],"name":"Paraguay","status":"assigned"},{"alpha2":"PZ","alpha3":"PCZ","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Panama Canal Zone","status":"deleted"},{"alpha2":"QA","alpha3":"QAT","countryCallingCodes":["+974"],"currencies":["QAR"],"emoji":"🇶🇦","ioc":"QAT","languages":["ara"],"name":"Qatar","status":"assigned"},{"alpha2":"RE","alpha3":"REU","countryCallingCodes":["+262"],"currencies":["EUR"],"emoji":"🇷🇪","ioc":"","languages":["fra"],"name":"Reunion","status":"assigned"},{"alpha2":"RH","alpha3":"RHO","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Southern Rhodesia","status":"deleted"},{"alpha2":"RO","alpha3":"ROU","countryCallingCodes":["+40"],"currencies":["RON"],"emoji":"🇷🇴","ioc":"ROU","languages":["ron"],"name":"Romania","status":"assigned"},{"alpha2":"RS","alpha3":"SRB","countryCallingCodes":["+381"],"currencies":["RSD"],"emoji":"🇷🇸","ioc":"SRB","languages":["srp"],"name":"Serbia","status":"assigned"},{"alpha2":"RU","alpha3":"RUS","countryCallingCodes":["+7","+7 3","+7 4","+7 8"],"currencies":["RUB"],"emoji":"🇷🇺","ioc":"RUS","languages":["rus"],"name":"Russian Federation","status":"assigned"},{"alpha2":"RW","alpha3":"RWA","countryCallingCodes":["+250"],"currencies":["RWF"],"emoji":"🇷🇼","ioc":"RWA","languages":["eng","fra","kin"],"name":"Rwanda","status":"assigned"},{"alpha2":"SA","alpha3":"SAU","countryCallingCodes":["+966"],"currencies":["SAR"],"emoji":"🇸🇦","ioc":"KSA","languages":["ara"],"name":"Saudi Arabia","status":"assigned"},{"alpha2":"SB","alpha3":"SLB","countryCallingCodes":["+677"],"currencies":["SBD"],"emoji":"🇸🇧","ioc":"SOL","languages":["eng"],"name":"Solomon Islands","status":"assigned"},{"alpha2":"SC","alpha3":"SYC","countryCallingCodes":["+248"],"currencies":["SCR"],"emoji":"🇸🇨","ioc":"SEY","languages":["eng","fra"],"name":"Seychelles","status":"assigned"},{"alpha2":"SD","alpha3":"SDN","countryCallingCodes":["+249"],"currencies":["SDG"],"emoji":"🇸🇩","ioc":"SUD","languages":["ara","eng"],"name":"Sudan","status":"assigned"},{"alpha2":"SE","alpha3":"SWE","countryCallingCodes":["+46"],"currencies":["SEK"],"emoji":"🇸🇪","ioc":"SWE","languages":["swe"],"name":"Sweden","status":"assigned"},{"alpha2":"SG","alpha3":"SGP","countryCallingCodes":["+65"],"currencies":["SGD"],"emoji":"🇸🇬","ioc":"SIN","languages":["eng","zho","msa","tam"],"name":"Singapore","status":"assigned"},{"alpha2":"SH","alpha3":"SHN","countryCallingCodes":["+290"],"currencies":["SHP"],"emoji":"🇸🇭","ioc":"","languages":["eng"],"name":"Saint Helena, Ascension And Tristan Da Cunha","status":"assigned"},{"alpha2":"SI","alpha3":"SVN","countryCallingCodes":["+386"],"currencies":["EUR"],"emoji":"🇸🇮","ioc":"SLO","languages":["slv"],"name":"Slovenia","status":"assigned"},{"alpha2":"SJ","alpha3":"SJM","countryCallingCodes":["+47"],"currencies":["NOK"],"emoji":"🇸🇯","ioc":"","languages":[],"name":"Svalbard And Jan Mayen","status":"assigned"},{"alpha2":"SK","alpha3":"SVK","countryCallingCodes":["+421"],"currencies":["EUR"],"emoji":"🇸🇰","ioc":"SVK","languages":["slk"],"name":"Slovakia","status":"assigned"},{"alpha2":"SK","alpha3":"SKM","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Sikkim","status":"deleted"},{"alpha2":"SL","alpha3":"SLE","countryCallingCodes":["+232"],"currencies":["SLL"],"emoji":"🇸🇱","ioc":"SLE","languages":["eng"],"name":"Sierra Leone","status":"assigned"},{"alpha2":"SM","alpha3":"SMR","countryCallingCodes":["+378"],"currencies":["EUR"],"emoji":"🇸🇲","ioc":"SMR","languages":["ita"],"name":"San Marino","status":"assigned"},{"alpha2":"SN","alpha3":"SEN","countryCallingCodes":["+221"],"currencies":["XOF"],"emoji":"🇸🇳","ioc":"SEN","languages":["fra"],"name":"Senegal","status":"assigned"},{"alpha2":"SO","alpha3":"SOM","countryCallingCodes":["+252"],"currencies":["SOS"],"emoji":"🇸🇴","ioc":"SOM","languages":["som"],"name":"Somalia","status":"assigned"},{"alpha2":"SR","alpha3":"SUR","countryCallingCodes":["+597"],"currencies":["SRD"],"emoji":"🇸🇷","ioc":"SUR","languages":["nld"],"name":"Suriname","status":"assigned"},{"alpha2":"SS","alpha3":"SSD","countryCallingCodes":["+211"],"currencies":["SSP"],"emoji":"🇸🇸","ioc":"SSD","languages":["eng"],"name":"South Sudan","status":"assigned"},{"alpha2":"ST","alpha3":"STP","countryCallingCodes":["+239"],"currencies":["STD"],"emoji":"🇸🇹","ioc":"STP","languages":["por"],"name":"Sao Tome and Principe","status":"assigned"},{"alpha2":"SU","alpha3":"","countryCallingCodes":[],"currencies":["RUB"],"emoji":"","ioc":"","languages":["rus"],"name":"USSR","status":"reserved"},{"alpha2":"SV","alpha3":"SLV","countryCallingCodes":["+503"],"currencies":["USD"],"emoji":"🇸🇻","ioc":"ESA","languages":["spa"],"name":"El Salvador","status":"assigned"},{"alpha2":"SX","alpha3":"SXM","countryCallingCodes":["+1 721"],"currencies":["ANG"],"emoji":"🇸🇽","ioc":"","languages":["nld"],"name":"Sint Maarten","status":"assigned"},{"alpha2":"SY","alpha3":"SYR","countryCallingCodes":["+963"],"currencies":["SYP"],"emoji":"🇸🇾","ioc":"SYR","languages":["ara"],"name":"Syrian Arab Republic","status":"assigned"},{"alpha2":"SZ","alpha3":"SWZ","countryCallingCodes":["+268"],"currencies":["SZL"],"emoji":"🇸🇿","ioc":"SWZ","languages":["eng","ssw"],"name":"Swaziland","status":"assigned"},{"alpha2":"TA","alpha3":"","countryCallingCodes":["+290"],"currencies":["GBP"],"emoji":"","ioc":"","languages":[],"name":"Tristan de Cunha","status":"reserved"},{"alpha2":"TC","alpha3":"TCA","countryCallingCodes":["+1 649"],"currencies":["USD"],"emoji":"🇹🇨","ioc":"","languages":["eng"],"name":"Turks And Caicos Islands","status":"assigned"},{"alpha2":"TD","alpha3":"TCD","countryCallingCodes":["+235"],"currencies":["XAF"],"emoji":"🇹🇩","ioc":"CHA","languages":["ara","fra"],"name":"Chad","status":"assigned"},{"alpha2":"TF","alpha3":"ATF","countryCallingCodes":[],"currencies":["EUR"],"emoji":"🇹🇫","ioc":"","languages":["fra"],"name":"French Southern Territories","status":"assigned"},{"alpha2":"TG","alpha3":"TGO","countryCallingCodes":["+228"],"currencies":["XOF"],"emoji":"🇹🇬","ioc":"TOG","languages":["fra"],"name":"Togo","status":"assigned"},{"alpha2":"TH","alpha3":"THA","countryCallingCodes":["+66"],"currencies":["THB"],"emoji":"🇹🇭","ioc":"THA","languages":["tha"],"name":"Thailand","status":"assigned"},{"alpha2":"TJ","alpha3":"TJK","countryCallingCodes":["+992"],"currencies":["TJS"],"emoji":"🇹🇯","ioc":"TJK","languages":["tgk","rus"],"name":"Tajikistan","status":"assigned"},{"alpha2":"TK","alpha3":"TKL","countryCallingCodes":["+690"],"currencies":["NZD"],"emoji":"🇹🇰","ioc":"","languages":["eng"],"name":"Tokelau","status":"assigned"},{"alpha2":"TL","alpha3":"TLS","countryCallingCodes":["+670"],"currencies":["USD"],"emoji":"🇹🇱","ioc":"TLS","languages":["por"],"name":"Timor-Leste, Democratic Republic of","status":"assigned"},{"alpha2":"TM","alpha3":"TKM","countryCallingCodes":["+993"],"currencies":["TMT"],"emoji":"🇹🇲","ioc":"TKM","languages":["tuk","rus"],"name":"Turkmenistan","status":"assigned"},{"alpha2":"TN","alpha3":"TUN","countryCallingCodes":["+216"],"currencies":["TND"],"emoji":"🇹🇳","ioc":"TUN","languages":["ara"],"name":"Tunisia","status":"assigned"},{"alpha2":"TO","alpha3":"TON","countryCallingCodes":["+676"],"currencies":["TOP"],"emoji":"🇹🇴","ioc":"TGA","languages":["eng"],"name":"Tonga","status":"assigned"},{"alpha2":"TP","alpha3":"TMP","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"East Timor","status":"deleted"},{"alpha2":"TR","alpha3":"TUR","countryCallingCodes":["+90"],"currencies":["TRY"],"emoji":"🇹🇷","ioc":"TUR","languages":["tur"],"name":"Turkey","status":"assigned"},{"alpha2":"TT","alpha3":"TTO","countryCallingCodes":["+1 868"],"currencies":["TTD"],"emoji":"🇹🇹","ioc":"TTO","languages":["eng"],"name":"Trinidad And Tobago","status":"assigned"},{"alpha2":"TV","alpha3":"TUV","countryCallingCodes":["+688"],"currencies":["AUD"],"emoji":"🇹🇻","ioc":"TUV","languages":["eng"],"name":"Tuvalu","status":"assigned"},{"alpha2":"TW","alpha3":"TWN","countryCallingCodes":["+886"],"currencies":["TWD"],"emoji":"🇹🇼","ioc":"TPE","languages":["zho"],"name":"Taiwan","status":"assigned"},{"alpha2":"TZ","alpha3":"TZA","countryCallingCodes":["+255"],"currencies":["TZS"],"emoji":"🇹🇿","ioc":"TAN","languages":["swa","eng"],"name":"Tanzania, United Republic Of","status":"assigned"},{"alpha2":"UA","alpha3":"UKR","countryCallingCodes":["+380"],"currencies":["UAH"],"emoji":"🇺🇦","ioc":"UKR","languages":["ukr","rus"],"name":"Ukraine","status":"assigned"},{"alpha2":"UG","alpha3":"UGA","countryCallingCodes":["+256"],"currencies":["UGX"],"emoji":"🇺🇬","ioc":"UGA","languages":["eng","swa"],"name":"Uganda","status":"assigned"},{"alpha2":"UK","alpha3":"","countryCallingCodes":[],"currencies":["GBP"],"emoji":"","ioc":"","languages":["eng","cor","gle","gla","cym"],"name":"United Kingdom","status":"reserved"},{"alpha2":"UM","alpha3":"UMI","countryCallingCodes":["+1"],"currencies":["USD"],"emoji":"🇺🇲","ioc":"","languages":["eng"],"name":"United States Minor Outlying Islands","status":"assigned"},{"alpha2":"US","alpha3":"USA","countryCallingCodes":["+1"],"currencies":["USD"],"emoji":"🇺🇸","ioc":"USA","languages":["eng"],"name":"United States","status":"assigned"},{"alpha2":"UY","alpha3":"URY","countryCallingCodes":["+598"],"currencies":["UYU","UYI"],"emoji":"🇺🇾","ioc":"URU","languages":["spa"],"name":"Uruguay","status":"assigned"},{"alpha2":"UZ","alpha3":"UZB","countryCallingCodes":["+998"],"currencies":["UZS"],"emoji":"🇺🇿","ioc":"UZB","languages":["uzb","rus"],"name":"Uzbekistan","status":"assigned"},{"alpha2":"VA","alpha3":"VAT","countryCallingCodes":["+379","+39"],"currencies":["EUR"],"emoji":"🇻🇦","ioc":"","languages":["ita"],"name":"Vatican City State","status":"assigned"},{"alpha2":"VC","alpha3":"VCT","countryCallingCodes":["+1 784"],"currencies":["XCD"],"emoji":"🇻🇨","ioc":"VIN","languages":["eng"],"name":"Saint Vincent And The Grenadines","status":"assigned"},{"alpha2":"VD","alpha3":"VDR","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Viet-Nam, Democratic Republic of","status":"deleted"},{"alpha2":"VE","alpha3":"VEN","countryCallingCodes":["+58"],"currencies":["VEF"],"emoji":"🇻🇪","ioc":"VEN","languages":["spa"],"name":"Venezuela, Bolivarian Republic Of","status":"assigned"},{"alpha2":"VG","alpha3":"VGB","countryCallingCodes":["+1 284"],"currencies":["USD"],"emoji":"🇻🇬","ioc":"IVB","languages":["eng"],"name":"Virgin Islands (British)","status":"assigned"},{"alpha2":"VI","alpha3":"VIR","countryCallingCodes":["+1 340"],"currencies":["USD"],"emoji":"🇻🇮","ioc":"ISV","languages":["eng"],"name":"Virgin Islands (US)","status":"assigned"},{"alpha2":"VN","alpha3":"VNM","countryCallingCodes":["+84"],"currencies":["VND"],"emoji":"🇻🇳","ioc":"VIE","languages":["vie"],"name":"Viet Nam","status":"assigned"},{"alpha2":"VU","alpha3":"VUT","countryCallingCodes":["+678"],"currencies":["VUV"],"emoji":"🇻🇺","ioc":"VAN","languages":["bis","eng","fra"],"name":"Vanuatu","status":"assigned"},{"alpha2":"WF","alpha3":"WLF","countryCallingCodes":["+681"],"currencies":["XPF"],"emoji":"🇼🇫","ioc":"","languages":["fra"],"name":"Wallis And Futuna","status":"assigned"},{"alpha2":"WK","alpha3":"WAK","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Wake Island","status":"deleted"},{"alpha2":"WS","alpha3":"WSM","countryCallingCodes":["+685"],"currencies":["WST"],"emoji":"🇼🇸","ioc":"SAM","languages":["eng","smo"],"name":"Samoa","status":"assigned"},{"alpha2":"XK","alpha3":"","countryCallingCodes":["+383"],"currencies":["EUR"],"emoji":"","ioc":"KOS","languages":["sqi","srp","bos","tur","rom"],"name":"Kosovo","status":"user assigned"},{"alpha2":"YD","alpha3":"YMD","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Yemen, Democratic","status":"deleted"},{"alpha2":"YE","alpha3":"YEM","countryCallingCodes":["+967"],"currencies":["YER"],"emoji":"🇾🇪","ioc":"YEM","languages":["ara"],"name":"Yemen","status":"assigned"},{"alpha2":"YT","alpha3":"MYT","countryCallingCodes":["+262"],"currencies":["EUR"],"emoji":"🇾🇹","ioc":"","languages":["fra"],"name":"Mayotte","status":"assigned"},{"alpha2":"YU","alpha3":"YUG","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Yugoslavia","status":"deleted"},{"alpha2":"ZA","alpha3":"ZAF","countryCallingCodes":["+27"],"currencies":["ZAR"],"emoji":"🇿🇦","ioc":"RSA","languages":["afr","eng","nbl","som","tso","ven","xho","zul"],"name":"South Africa","status":"assigned"},{"alpha2":"ZM","alpha3":"ZMB","countryCallingCodes":["+260"],"currencies":["ZMW"],"emoji":"🇿🇲","ioc":"ZAM","languages":["eng"],"name":"Zambia","status":"assigned"},{"alpha2":"ZR","alpha3":"ZAR","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Zaire","status":"deleted"},{"alpha2":"ZW","alpha3":"ZWE","countryCallingCodes":["+263"],"currencies":["USD","ZAR","BWP","GBP","EUR"],"emoji":"🇿🇼","ioc":"ZIM","languages":["eng","sna","nde"],"name":"Zimbabwe","status":"assigned"}]

/***/ }),
/* 793 */
/***/ (function(module, exports) {

module.exports = [{"code":"AED","decimals":2,"name":"United Arab Emirates dirham","number":"784"},{"code":"AFN","decimals":2,"name":"Afghan afghani","number":"971"},{"code":"ALL","decimals":2,"name":"Albanian lek","number":"8"},{"code":"AMD","decimals":2,"name":"Armenian dram","number":"51"},{"code":"ANG","decimals":2,"name":"Netherlands Antillean guilder","number":"532"},{"code":"AOA","decimals":2,"name":"Angolan kwanza","number":"973"},{"code":"ARS","decimals":2,"name":"Argentine peso","number":"32"},{"code":"AUD","decimals":2,"name":"Australian dollar","number":"36"},{"code":"AWG","decimals":2,"name":"Aruban florin","number":"533"},{"code":"AZN","decimals":2,"name":"Azerbaijani manat","number":"944"},{"code":"BAM","decimals":2,"name":"Bosnia and Herzegovina convertible mark","number":"977"},{"code":"BBD","decimals":2,"name":"Barbados dollar","number":"52"},{"code":"BDT","decimals":2,"name":"Bangladeshi taka","number":"50"},{"code":"BGN","decimals":2,"name":"Bulgarian lev","number":"975"},{"code":"BHD","decimals":3,"name":"Bahraini dinar","number":"48"},{"code":"BIF","decimals":0,"name":"Burundian franc","number":"108"},{"code":"BMD","decimals":2,"name":"Bermudian dollar (customarily known as Bermuda dollar)","number":"60"},{"code":"BND","decimals":2,"name":"Brunei dollar","number":"96"},{"code":"BOB","decimals":2,"name":"Boliviano","number":"68"},{"code":"BOV","decimals":2,"name":"Bolivian Mvdol (funds code)","number":"984"},{"code":"BRL","decimals":2,"name":"Brazilian real","number":"986"},{"code":"BSD","decimals":2,"name":"Bahamian dollar","number":"44"},{"code":"BTN","decimals":2,"name":"Bhutanese ngultrum","number":"64"},{"code":"BWP","decimals":2,"name":"Botswana pula","number":"72"},{"code":"BYR","decimals":0,"name":"Belarusian ruble","number":"974"},{"code":"BZD","decimals":2,"name":"Belize dollar","number":"84"},{"code":"CAD","decimals":2,"name":"Canadian dollar","number":"124"},{"code":"CDF","decimals":2,"name":"Congolese franc","number":"976"},{"code":"CHE","decimals":2,"name":"WIR Euro (complementary currency)","number":"947"},{"code":"CHF","decimals":2,"name":"Swiss franc","number":"756"},{"code":"CHW","decimals":2,"name":"WIR Franc (complementary currency)","number":"948"},{"code":"CLF","decimals":0,"name":"Unidad de Fomento (funds code)","number":"990"},{"code":"CLP","decimals":0,"name":"Chilean peso","number":"152"},{"code":"CNY","decimals":2,"name":"Chinese yuan","number":"156"},{"code":"COP","decimals":2,"name":"Colombian peso","number":"170"},{"code":"COU","decimals":2,"name":"Unidad de Valor Real","number":"970"},{"code":"CRC","decimals":2,"name":"Costa Rican colon","number":"188"},{"code":"CUC","decimals":2,"name":"Cuban convertible peso","number":"931"},{"code":"CUP","decimals":2,"name":"Cuban peso","number":"192"},{"code":"CVE","decimals":0,"name":"Cape Verde escudo","number":"132"},{"code":"CZK","decimals":2,"name":"Czech koruna","number":"203"},{"code":"DJF","decimals":0,"name":"Djiboutian franc","number":"262"},{"code":"DKK","decimals":2,"name":"Danish krone","number":"208"},{"code":"DOP","decimals":2,"name":"Dominican peso","number":"214"},{"code":"DZD","decimals":2,"name":"Algerian dinar","number":"12"},{"code":"EGP","decimals":2,"name":"Egyptian pound","number":"818"},{"code":"ERN","decimals":2,"name":"Eritrean nakfa","number":"232"},{"code":"ETB","decimals":2,"name":"Ethiopian birr","number":"230"},{"code":"EUR","decimals":2,"name":"Euro","number":"978"},{"code":"FJD","decimals":2,"name":"Fiji dollar","number":"242"},{"code":"FKP","decimals":2,"name":"Falkland Islands pound","number":"238"},{"code":"GBP","decimals":2,"name":"Pound sterling","number":"826"},{"code":"GEL","decimals":2,"name":"Georgian lari","number":"981"},{"code":"GHS","decimals":2,"name":"Ghanaian cedi","number":"936"},{"code":"GIP","decimals":2,"name":"Gibraltar pound","number":"292"},{"code":"GMD","decimals":2,"name":"Gambian dalasi","number":"270"},{"code":"GNF","decimals":0,"name":"Guinean franc","number":"324"},{"code":"GTQ","decimals":2,"name":"Guatemalan quetzal","number":"320"},{"code":"GYD","decimals":2,"name":"Guyanese dollar","number":"328"},{"code":"HKD","decimals":2,"name":"Hong Kong dollar","number":"344"},{"code":"HNL","decimals":2,"name":"Honduran lempira","number":"340"},{"code":"HRK","decimals":2,"name":"Croatian kuna","number":"191"},{"code":"HTG","decimals":2,"name":"Haitian gourde","number":"332"},{"code":"HUF","decimals":2,"name":"Hungarian forint","number":"348"},{"code":"IDR","decimals":2,"name":"Indonesian rupiah","number":"360"},{"code":"ILS","decimals":2,"name":"Israeli new shekel","number":"376"},{"code":"INR","decimals":2,"name":"Indian rupee","number":"356"},{"code":"IQD","decimals":3,"name":"Iraqi dinar","number":"368"},{"code":"IRR","decimals":0,"name":"Iranian rial","number":"364"},{"code":"ISK","decimals":0,"name":"Icelandic króna","number":"352"},{"code":"JMD","decimals":2,"name":"Jamaican dollar","number":"388"},{"code":"JOD","decimals":3,"name":"Jordanian dinar","number":"400"},{"code":"JPY","decimals":0,"name":"Japanese yen","number":"392"},{"code":"KES","decimals":2,"name":"Kenyan shilling","number":"404"},{"code":"KGS","decimals":2,"name":"Kyrgyzstani som","number":"417"},{"code":"KHR","decimals":2,"name":"Cambodian riel","number":"116"},{"code":"KMF","decimals":0,"name":"Comoro franc","number":"174"},{"code":"KPW","decimals":0,"name":"North Korean won","number":"408"},{"code":"KRW","decimals":0,"name":"South Korean won","number":"410"},{"code":"KWD","decimals":3,"name":"Kuwaiti dinar","number":"414"},{"code":"KYD","decimals":2,"name":"Cayman Islands dollar","number":"136"},{"code":"KZT","decimals":2,"name":"Kazakhstani tenge","number":"398"},{"code":"LAK","decimals":0,"name":"Lao kip","number":"418"},{"code":"LBP","decimals":0,"name":"Lebanese pound","number":"422"},{"code":"LKR","decimals":2,"name":"Sri Lankan rupee","number":"144"},{"code":"LRD","decimals":2,"name":"Liberian dollar","number":"430"},{"code":"LSL","decimals":2,"name":"Lesotho loti","number":"426"},{"code":"LTL","decimals":2,"name":"Lithuanian litas","number":"440"},{"code":"LVL","decimals":2,"name":"Latvian lats","number":"428"},{"code":"LYD","decimals":3,"name":"Libyan dinar","number":"434"},{"code":"MAD","decimals":2,"name":"Moroccan dirham","number":"504"},{"code":"MDL","decimals":2,"name":"Moldovan leu","number":"498"},{"code":"MGA","decimals":0,"name":"Malagasy ariary","number":"969"},{"code":"MKD","decimals":0,"name":"Macedonian denar","number":"807"},{"code":"MMK","decimals":0,"name":"Myanma kyat","number":"104"},{"code":"MNT","decimals":2,"name":"Mongolian tugrik","number":"496"},{"code":"MOP","decimals":2,"name":"Macanese pataca","number":"446"},{"code":"MRO","decimals":0,"name":"Mauritanian ouguiya","number":"478"},{"code":"MUR","decimals":2,"name":"Mauritian rupee","number":"480"},{"code":"MVR","decimals":2,"name":"Maldivian rufiyaa","number":"462"},{"code":"MWK","decimals":2,"name":"Malawian kwacha","number":"454"},{"code":"MXN","decimals":2,"name":"Mexican peso","number":"484"},{"code":"MXV","decimals":2,"name":"Mexican Unidad de Inversion (UDI) (funds code)","number":"979"},{"code":"MYR","decimals":2,"name":"Malaysian ringgit","number":"458"},{"code":"MZN","decimals":2,"name":"Mozambican metical","number":"943"},{"code":"NAD","decimals":2,"name":"Namibian dollar","number":"516"},{"code":"NGN","decimals":2,"name":"Nigerian naira","number":"566"},{"code":"NIO","decimals":2,"name":"Nicaraguan córdoba","number":"558"},{"code":"NOK","decimals":2,"name":"Norwegian krone","number":"578"},{"code":"NPR","decimals":2,"name":"Nepalese rupee","number":"524"},{"code":"NZD","decimals":2,"name":"New Zealand dollar","number":"554"},{"code":"OMR","decimals":3,"name":"Omani rial","number":"512"},{"code":"PAB","decimals":2,"name":"Panamanian balboa","number":"590"},{"code":"PEN","decimals":2,"name":"Peruvian nuevo sol","number":"604"},{"code":"PGK","decimals":2,"name":"Papua New Guinean kina","number":"598"},{"code":"PHP","decimals":2,"name":"Philippine peso","number":"608"},{"code":"PKR","decimals":2,"name":"Pakistani rupee","number":"586"},{"code":"PLN","decimals":2,"name":"Polish złoty","number":"985"},{"code":"PYG","decimals":0,"name":"Paraguayan guaraní","number":"600"},{"code":"QAR","decimals":2,"name":"Qatari riyal","number":"634"},{"code":"RON","decimals":2,"name":"Romanian new leu","number":"946"},{"code":"RSD","decimals":2,"name":"Serbian dinar","number":"941"},{"code":"RUB","decimals":2,"name":"Russian rouble","number":"643"},{"code":"RWF","decimals":0,"name":"Rwandan franc","number":"646"},{"code":"SAR","decimals":2,"name":"Saudi riyal","number":"682"},{"code":"SBD","decimals":2,"name":"Solomon Islands dollar","number":"90"},{"code":"SCR","decimals":2,"name":"Seychelles rupee","number":"690"},{"code":"SDG","decimals":2,"name":"Sudanese pound","number":"938"},{"code":"SEK","decimals":2,"name":"Swedish krona/kronor","number":"752"},{"code":"SGD","decimals":2,"name":"Singapore dollar","number":"702"},{"code":"SHP","decimals":2,"name":"Saint Helena pound","number":"654"},{"code":"SLL","decimals":0,"name":"Sierra Leonean leone","number":"694"},{"code":"SOS","decimals":2,"name":"Somali shilling","number":"706"},{"code":"SRD","decimals":2,"name":"Surinamese dollar","number":"968"},{"code":"SSP","decimals":2,"name":"South Sudanese pound","number":"728"},{"code":"STD","decimals":0,"name":"São Tomé and Príncipe dobra","number":"678"},{"code":"SYP","decimals":2,"name":"Syrian pound","number":"760"},{"code":"SZL","decimals":2,"name":"Swazi lilangeni","number":"748"},{"code":"THB","decimals":2,"name":"Thai baht","number":"764"},{"code":"TJS","decimals":2,"name":"Tajikistani somoni","number":"972"},{"code":"TMT","decimals":2,"name":"Turkmenistani manat","number":"934"},{"code":"TND","decimals":3,"name":"Tunisian dinar","number":"788"},{"code":"TOP","decimals":2,"name":"Tongan paʻanga","number":"776"},{"code":"TRY","decimals":2,"name":"Turkish lira","number":"949"},{"code":"TTD","decimals":2,"name":"Trinidad and Tobago dollar","number":"780"},{"code":"TWD","decimals":2,"name":"New Taiwan dollar","number":"901"},{"code":"TZS","decimals":2,"name":"Tanzanian shilling","number":"834"},{"code":"UAH","decimals":2,"name":"Ukrainian hryvnia","number":"980"},{"code":"UGX","decimals":2,"name":"Ugandan shilling","number":"800"},{"code":"USD","decimals":2,"name":"United States dollar","number":"840"},{"code":"USN","decimals":2,"name":"United States dollar (next day) (funds code)","number":"997"},{"code":"USS","decimals":2,"name":"United States dollar (same day) (funds code) (one source[who?] claims it is no longer used, but it is still on the ISO 4217-MA list)","number":"998"},{"code":"UYI","decimals":0,"name":"Uruguay Peso en Unidades Indexadas (URUIURUI) (funds code)","number":"940"},{"code":"UYU","decimals":2,"name":"Uruguayan peso","number":"858"},{"code":"UZS","decimals":2,"name":"Uzbekistan som","number":"860"},{"code":"VEF","decimals":2,"name":"Venezuelan bolívar fuerte","number":"937"},{"code":"VND","decimals":0,"name":"Vietnamese dong","number":"704"},{"code":"VUV","decimals":0,"name":"Vanuatu vatu","number":"548"},{"code":"WST","decimals":2,"name":"Samoan tala","number":"882"},{"code":"XAF","decimals":0,"name":"CFA franc BEAC","number":"950"},{"code":"XAG","decimals":null,"name":"Silver (one troy ounce)","number":"961"},{"code":"XAU","decimals":null,"name":"Gold (one troy ounce)","number":"959"},{"code":"XBA","decimals":null,"name":"European Composite Unit (EURCO) (bond market unit)","number":"955"},{"code":"XBB","decimals":null,"name":"European Monetary Unit (E.M.U.-6) (bond market unit)","number":"956"},{"code":"XBC","decimals":null,"name":"European Unit of Account 9 (E.U.A.-9) (bond market unit)","number":"957"},{"code":"XBD","decimals":null,"name":"European Unit of Account 17 (E.U.A.-17) (bond market unit)","number":"958"},{"code":"XCD","decimals":2,"name":"East Caribbean dollar","number":"951"},{"code":"XDR","decimals":null,"name":"Special drawing rights","number":"960"},{"code":"XFU","decimals":null,"name":"UIC franc (special settlement currency)","number":"Nil"},{"code":"XOF","decimals":0,"name":"CFA franc BCEAO","number":"952"},{"code":"XPD","decimals":null,"name":"Palladium (one troy ounce)","number":"964"},{"code":"XPF","decimals":0,"name":"CFP franc","number":"953"},{"code":"XPT","decimals":null,"name":"Platinum (one troy ounce)","number":"962"},{"code":"XTS","decimals":null,"name":"Code reserved for testing purposes","number":"963"},{"code":"XXX","decimals":null,"name":"No currency","number":"999"},{"code":"YER","decimals":2,"name":"Yemeni rial","number":"886"},{"code":"ZAR","decimals":2,"name":"South African rand","number":"710"},{"code":"ZMW","decimals":2,"name":"Zambian kwacha","number":"967"}]

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports = [{"alpha2":"aa","alpha3":"aar","bibliographic":"","name":"Afar"},{"alpha2":"ab","alpha3":"abk","bibliographic":"","name":"Abkhazian"},{"alpha2":"","alpha3":"ace","bibliographic":"","name":"Achinese"},{"alpha2":"","alpha3":"ach","bibliographic":"","name":"Acoli"},{"alpha2":"","alpha3":"ada","bibliographic":"","name":"Adangme"},{"alpha2":"","alpha3":"ady","bibliographic":"","name":"Adygei"},{"alpha2":"","alpha3":"ady","bibliographic":"","name":"Adyghe"},{"alpha2":"","alpha3":"afa","bibliographic":"","name":"Afro-Asiatic languages"},{"alpha2":"","alpha3":"afh","bibliographic":"","name":"Afrihili"},{"alpha2":"af","alpha3":"afr","bibliographic":"","name":"Afrikaans"},{"alpha2":"","alpha3":"ain","bibliographic":"","name":"Ainu"},{"alpha2":"ak","alpha3":"aka","bibliographic":"","name":"Akan"},{"alpha2":"","alpha3":"akk","bibliographic":"","name":"Akkadian"},{"alpha2":"","alpha3":"ale","bibliographic":"","name":"Aleut"},{"alpha2":"","alpha3":"alg","bibliographic":"","name":"Algonquian languages"},{"alpha2":"","alpha3":"alt","bibliographic":"","name":"Southern Altai"},{"alpha2":"am","alpha3":"amh","bibliographic":"","name":"Amharic"},{"alpha2":"","alpha3":"ang","bibliographic":"","name":"English, Old (ca.450-1100)"},{"alpha2":"","alpha3":"anp","bibliographic":"","name":"Angika"},{"alpha2":"","alpha3":"apa","bibliographic":"","name":"Apache languages"},{"alpha2":"ar","alpha3":"ara","bibliographic":"","name":"Arabic"},{"alpha2":"","alpha3":"arc","bibliographic":"","name":"Imperial Aramaic (700-300 BCE)"},{"alpha2":"","alpha3":"arc","bibliographic":"","name":"Official Aramaic (700-300 BCE)"},{"alpha2":"an","alpha3":"arg","bibliographic":"","name":"Aragonese"},{"alpha2":"","alpha3":"arn","bibliographic":"","name":"Mapuche"},{"alpha2":"","alpha3":"arn","bibliographic":"","name":"Mapudungun"},{"alpha2":"","alpha3":"arp","bibliographic":"","name":"Arapaho"},{"alpha2":"","alpha3":"art","bibliographic":"","name":"Artificial languages"},{"alpha2":"","alpha3":"arw","bibliographic":"","name":"Arawak"},{"alpha2":"as","alpha3":"asm","bibliographic":"","name":"Assamese"},{"alpha2":"","alpha3":"ast","bibliographic":"","name":"Asturian"},{"alpha2":"","alpha3":"ast","bibliographic":"","name":"Asturleonese"},{"alpha2":"","alpha3":"ast","bibliographic":"","name":"Bable"},{"alpha2":"","alpha3":"ast","bibliographic":"","name":"Leonese"},{"alpha2":"","alpha3":"ath","bibliographic":"","name":"Athapascan languages"},{"alpha2":"","alpha3":"aus","bibliographic":"","name":"Australian languages"},{"alpha2":"av","alpha3":"ava","bibliographic":"","name":"Avaric"},{"alpha2":"ae","alpha3":"ave","bibliographic":"","name":"Avestan"},{"alpha2":"","alpha3":"awa","bibliographic":"","name":"Awadhi"},{"alpha2":"ay","alpha3":"aym","bibliographic":"","name":"Aymara"},{"alpha2":"az","alpha3":"aze","bibliographic":"","name":"Azerbaijani"},{"alpha2":"","alpha3":"bad","bibliographic":"","name":"Banda languages"},{"alpha2":"","alpha3":"bai","bibliographic":"","name":"Bamileke languages"},{"alpha2":"ba","alpha3":"bak","bibliographic":"","name":"Bashkir"},{"alpha2":"","alpha3":"bal","bibliographic":"","name":"Baluchi"},{"alpha2":"bm","alpha3":"bam","bibliographic":"","name":"Bambara"},{"alpha2":"","alpha3":"ban","bibliographic":"","name":"Balinese"},{"alpha2":"","alpha3":"bas","bibliographic":"","name":"Basa"},{"alpha2":"","alpha3":"bat","bibliographic":"","name":"Baltic languages"},{"alpha2":"","alpha3":"bej","bibliographic":"","name":"Bedawiyet"},{"alpha2":"","alpha3":"bej","bibliographic":"","name":"Beja"},{"alpha2":"be","alpha3":"bel","bibliographic":"","name":"Belarusian"},{"alpha2":"","alpha3":"bem","bibliographic":"","name":"Bemba"},{"alpha2":"bn","alpha3":"ben","bibliographic":"","name":"Bengali"},{"alpha2":"","alpha3":"ber","bibliographic":"","name":"Berber languages"},{"alpha2":"","alpha3":"bho","bibliographic":"","name":"Bhojpuri"},{"alpha2":"bh","alpha3":"bih","bibliographic":"","name":"Bihari languages"},{"alpha2":"","alpha3":"bik","bibliographic":"","name":"Bikol"},{"alpha2":"","alpha3":"bin","bibliographic":"","name":"Bini"},{"alpha2":"","alpha3":"bin","bibliographic":"","name":"Edo"},{"alpha2":"bi","alpha3":"bis","bibliographic":"","name":"Bislama"},{"alpha2":"","alpha3":"bla","bibliographic":"","name":"Siksika"},{"alpha2":"","alpha3":"bnt","bibliographic":"","name":"Bantu languages"},{"alpha2":"bo","alpha3":"bod","bibliographic":"tib","name":"Tibetan"},{"alpha2":"bs","alpha3":"bos","bibliographic":"","name":"Bosnian"},{"alpha2":"","alpha3":"bra","bibliographic":"","name":"Braj"},{"alpha2":"br","alpha3":"bre","bibliographic":"","name":"Breton"},{"alpha2":"","alpha3":"btk","bibliographic":"","name":"Batak languages"},{"alpha2":"","alpha3":"bua","bibliographic":"","name":"Buriat"},{"alpha2":"","alpha3":"bug","bibliographic":"","name":"Buginese"},{"alpha2":"bg","alpha3":"bul","bibliographic":"","name":"Bulgarian"},{"alpha2":"","alpha3":"byn","bibliographic":"","name":"Bilin"},{"alpha2":"","alpha3":"byn","bibliographic":"","name":"Blin"},{"alpha2":"","alpha3":"cad","bibliographic":"","name":"Caddo"},{"alpha2":"","alpha3":"cai","bibliographic":"","name":"Central American Indian languages"},{"alpha2":"","alpha3":"car","bibliographic":"","name":"Galibi Carib"},{"alpha2":"ca","alpha3":"cat","bibliographic":"","name":"Catalan"},{"alpha2":"ca","alpha3":"cat","bibliographic":"","name":"Valencian"},{"alpha2":"","alpha3":"cau","bibliographic":"","name":"Caucasian languages"},{"alpha2":"","alpha3":"ceb","bibliographic":"","name":"Cebuano"},{"alpha2":"","alpha3":"cel","bibliographic":"","name":"Celtic languages"},{"alpha2":"cs","alpha3":"ces","bibliographic":"cze","name":"Czech"},{"alpha2":"ch","alpha3":"cha","bibliographic":"","name":"Chamorro"},{"alpha2":"","alpha3":"chb","bibliographic":"","name":"Chibcha"},{"alpha2":"ce","alpha3":"che","bibliographic":"","name":"Chechen"},{"alpha2":"","alpha3":"chg","bibliographic":"","name":"Chagatai"},{"alpha2":"","alpha3":"chk","bibliographic":"","name":"Chuukese"},{"alpha2":"","alpha3":"chm","bibliographic":"","name":"Mari"},{"alpha2":"","alpha3":"chn","bibliographic":"","name":"Chinook jargon"},{"alpha2":"","alpha3":"cho","bibliographic":"","name":"Choctaw"},{"alpha2":"","alpha3":"chp","bibliographic":"","name":"Chipewyan"},{"alpha2":"","alpha3":"chp","bibliographic":"","name":"Dene Suline"},{"alpha2":"","alpha3":"chr","bibliographic":"","name":"Cherokee"},{"alpha2":"cu","alpha3":"chu","bibliographic":"","name":"Church Slavic"},{"alpha2":"cu","alpha3":"chu","bibliographic":"","name":"Church Slavonic"},{"alpha2":"cu","alpha3":"chu","bibliographic":"","name":"Old Bulgarian"},{"alpha2":"cu","alpha3":"chu","bibliographic":"","name":"Old Church Slavonic"},{"alpha2":"cu","alpha3":"chu","bibliographic":"","name":"Old Slavonic"},{"alpha2":"cv","alpha3":"chv","bibliographic":"","name":"Chuvash"},{"alpha2":"","alpha3":"chy","bibliographic":"","name":"Cheyenne"},{"alpha2":"","alpha3":"cmc","bibliographic":"","name":"Chamic languages"},{"alpha2":"","alpha3":"cop","bibliographic":"","name":"Coptic"},{"alpha2":"kw","alpha3":"cor","bibliographic":"","name":"Cornish"},{"alpha2":"co","alpha3":"cos","bibliographic":"","name":"Corsican"},{"alpha2":"","alpha3":"cpe","bibliographic":"","name":"Creoles and pidgins, English based"},{"alpha2":"","alpha3":"cpf","bibliographic":"","name":"Creoles and pidgins, French-based"},{"alpha2":"","alpha3":"cpp","bibliographic":"","name":"Creoles and pidgins, Portuguese-based"},{"alpha2":"cr","alpha3":"cre","bibliographic":"","name":"Cree"},{"alpha2":"","alpha3":"crh","bibliographic":"","name":"Crimean Tatar"},{"alpha2":"","alpha3":"crh","bibliographic":"","name":"Crimean Turkish"},{"alpha2":"","alpha3":"crp","bibliographic":"","name":"Creoles and pidgins"},{"alpha2":"","alpha3":"csb","bibliographic":"","name":"Kashubian"},{"alpha2":"","alpha3":"cus","bibliographic":"","name":"Cushitic languages"},{"alpha2":"cy","alpha3":"cym","bibliographic":"wel","name":"Welsh"},{"alpha2":"","alpha3":"dak","bibliographic":"","name":"Dakota"},{"alpha2":"da","alpha3":"dan","bibliographic":"","name":"Danish"},{"alpha2":"","alpha3":"dar","bibliographic":"","name":"Dargwa"},{"alpha2":"","alpha3":"day","bibliographic":"","name":"Land Dayak languages"},{"alpha2":"","alpha3":"del","bibliographic":"","name":"Delaware"},{"alpha2":"","alpha3":"den","bibliographic":"","name":"Slave (Athapascan)"},{"alpha2":"de","alpha3":"deu","bibliographic":"ger","name":"German"},{"alpha2":"","alpha3":"dgr","bibliographic":"","name":"Dogrib"},{"alpha2":"","alpha3":"din","bibliographic":"","name":"Dinka"},{"alpha2":"dv","alpha3":"div","bibliographic":"","name":"Dhivehi"},{"alpha2":"dv","alpha3":"div","bibliographic":"","name":"Divehi"},{"alpha2":"dv","alpha3":"div","bibliographic":"","name":"Maldivian"},{"alpha2":"","alpha3":"doi","bibliographic":"","name":"Dogri"},{"alpha2":"","alpha3":"dra","bibliographic":"","name":"Dravidian languages"},{"alpha2":"","alpha3":"dsb","bibliographic":"","name":"Lower Sorbian"},{"alpha2":"","alpha3":"dua","bibliographic":"","name":"Duala"},{"alpha2":"","alpha3":"dum","bibliographic":"","name":"Dutch, Middle (ca.1050-1350)"},{"alpha2":"","alpha3":"dyu","bibliographic":"","name":"Dyula"},{"alpha2":"dz","alpha3":"dzo","bibliographic":"","name":"Dzongkha"},{"alpha2":"","alpha3":"efi","bibliographic":"","name":"Efik"},{"alpha2":"","alpha3":"egy","bibliographic":"","name":"Egyptian (Ancient)"},{"alpha2":"","alpha3":"eka","bibliographic":"","name":"Ekajuk"},{"alpha2":"el","alpha3":"ell","bibliographic":"gre","name":"Greek, Modern (1453-)"},{"alpha2":"","alpha3":"elx","bibliographic":"","name":"Elamite"},{"alpha2":"en","alpha3":"eng","bibliographic":"","name":"English"},{"alpha2":"","alpha3":"enm","bibliographic":"","name":"English, Middle (1100-1500)"},{"alpha2":"eo","alpha3":"epo","bibliographic":"","name":"Esperanto"},{"alpha2":"et","alpha3":"est","bibliographic":"","name":"Estonian"},{"alpha2":"eu","alpha3":"eus","bibliographic":"baq","name":"Basque"},{"alpha2":"ee","alpha3":"ewe","bibliographic":"","name":"Ewe"},{"alpha2":"","alpha3":"ewo","bibliographic":"","name":"Ewondo"},{"alpha2":"","alpha3":"fan","bibliographic":"","name":"Fang"},{"alpha2":"fo","alpha3":"fao","bibliographic":"","name":"Faroese"},{"alpha2":"fa","alpha3":"fas","bibliographic":"per","name":"Persian"},{"alpha2":"","alpha3":"fat","bibliographic":"","name":"Fanti"},{"alpha2":"fj","alpha3":"fij","bibliographic":"","name":"Fijian"},{"alpha2":"","alpha3":"fil","bibliographic":"","name":"Filipino"},{"alpha2":"","alpha3":"fil","bibliographic":"","name":"Pilipino"},{"alpha2":"fi","alpha3":"fin","bibliographic":"","name":"Finnish"},{"alpha2":"","alpha3":"fiu","bibliographic":"","name":"Finno-Ugrian languages"},{"alpha2":"","alpha3":"fon","bibliographic":"","name":"Fon"},{"alpha2":"fr","alpha3":"fra","bibliographic":"fre","name":"French"},{"alpha2":"","alpha3":"frm","bibliographic":"","name":"French, Middle (ca.1400-1600)"},{"alpha2":"","alpha3":"fro","bibliographic":"","name":"French, Old (842-ca.1400)"},{"alpha2":"","alpha3":"frr","bibliographic":"","name":"Northern Frisian"},{"alpha2":"","alpha3":"frs","bibliographic":"","name":"Eastern Frisian"},{"alpha2":"fy","alpha3":"fry","bibliographic":"","name":"Western Frisian"},{"alpha2":"ff","alpha3":"ful","bibliographic":"","name":"Fulah"},{"alpha2":"","alpha3":"fur","bibliographic":"","name":"Friulian"},{"alpha2":"","alpha3":"gaa","bibliographic":"","name":"Ga"},{"alpha2":"","alpha3":"gay","bibliographic":"","name":"Gayo"},{"alpha2":"","alpha3":"gba","bibliographic":"","name":"Gbaya"},{"alpha2":"","alpha3":"gem","bibliographic":"","name":"Germanic languages"},{"alpha2":"","alpha3":"gez","bibliographic":"","name":"Geez"},{"alpha2":"","alpha3":"gil","bibliographic":"","name":"Gilbertese"},{"alpha2":"gd","alpha3":"gla","bibliographic":"","name":"Gaelic"},{"alpha2":"gd","alpha3":"gla","bibliographic":"","name":"Scottish Gaelic"},{"alpha2":"ga","alpha3":"gle","bibliographic":"","name":"Irish"},{"alpha2":"gl","alpha3":"glg","bibliographic":"","name":"Galician"},{"alpha2":"gv","alpha3":"glv","bibliographic":"","name":"Manx"},{"alpha2":"","alpha3":"gmh","bibliographic":"","name":"German, Middle High (ca.1050-1500)"},{"alpha2":"","alpha3":"goh","bibliographic":"","name":"German, Old High (ca.750-1050)"},{"alpha2":"","alpha3":"gon","bibliographic":"","name":"Gondi"},{"alpha2":"","alpha3":"gor","bibliographic":"","name":"Gorontalo"},{"alpha2":"","alpha3":"got","bibliographic":"","name":"Gothic"},{"alpha2":"","alpha3":"grb","bibliographic":"","name":"Grebo"},{"alpha2":"","alpha3":"grc","bibliographic":"","name":"Greek, Ancient (to 1453)"},{"alpha2":"gn","alpha3":"grn","bibliographic":"","name":"Guarani"},{"alpha2":"","alpha3":"gsw","bibliographic":"","name":"Alemannic"},{"alpha2":"","alpha3":"gsw","bibliographic":"","name":"Alsatian"},{"alpha2":"","alpha3":"gsw","bibliographic":"","name":"Swiss German"},{"alpha2":"gu","alpha3":"guj","bibliographic":"","name":"Gujarati"},{"alpha2":"","alpha3":"gwi","bibliographic":"","name":"Gwich'in"},{"alpha2":"","alpha3":"hai","bibliographic":"","name":"Haida"},{"alpha2":"ht","alpha3":"hat","bibliographic":"","name":"Haitian"},{"alpha2":"ht","alpha3":"hat","bibliographic":"","name":"Haitian Creole"},{"alpha2":"ha","alpha3":"hau","bibliographic":"","name":"Hausa"},{"alpha2":"","alpha3":"haw","bibliographic":"","name":"Hawaiian"},{"alpha2":"he","alpha3":"heb","bibliographic":"","name":"Hebrew"},{"alpha2":"hz","alpha3":"her","bibliographic":"","name":"Herero"},{"alpha2":"","alpha3":"hil","bibliographic":"","name":"Hiligaynon"},{"alpha2":"","alpha3":"him","bibliographic":"","name":"Himachali languages"},{"alpha2":"","alpha3":"him","bibliographic":"","name":"Western Pahari languages"},{"alpha2":"hi","alpha3":"hin","bibliographic":"","name":"Hindi"},{"alpha2":"","alpha3":"hit","bibliographic":"","name":"Hittite"},{"alpha2":"","alpha3":"hmn","bibliographic":"","name":"Hmong"},{"alpha2":"","alpha3":"hmn","bibliographic":"","name":"Mong"},{"alpha2":"ho","alpha3":"hmo","bibliographic":"","name":"Hiri Motu"},{"alpha2":"hr","alpha3":"hrv","bibliographic":"","name":"Croatian"},{"alpha2":"","alpha3":"hsb","bibliographic":"","name":"Upper Sorbian"},{"alpha2":"hu","alpha3":"hun","bibliographic":"","name":"Hungarian"},{"alpha2":"","alpha3":"hup","bibliographic":"","name":"Hupa"},{"alpha2":"hy","alpha3":"hye","bibliographic":"arm","name":"Armenian"},{"alpha2":"","alpha3":"iba","bibliographic":"","name":"Iban"},{"alpha2":"ig","alpha3":"ibo","bibliographic":"","name":"Igbo"},{"alpha2":"io","alpha3":"ido","bibliographic":"","name":"Ido"},{"alpha2":"ii","alpha3":"iii","bibliographic":"","name":"Nuosu"},{"alpha2":"ii","alpha3":"iii","bibliographic":"","name":"Sichuan Yi"},{"alpha2":"","alpha3":"ijo","bibliographic":"","name":"Ijo languages"},{"alpha2":"iu","alpha3":"iku","bibliographic":"","name":"Inuktitut"},{"alpha2":"ie","alpha3":"ile","bibliographic":"","name":"Interlingue"},{"alpha2":"ie","alpha3":"ile","bibliographic":"","name":"Occidental"},{"alpha2":"","alpha3":"ilo","bibliographic":"","name":"Iloko"},{"alpha2":"ia","alpha3":"ina","bibliographic":"","name":"Interlingua (International Auxiliary Language Association)"},{"alpha2":"","alpha3":"inc","bibliographic":"","name":"Indic languages"},{"alpha2":"id","alpha3":"ind","bibliographic":"","name":"Indonesian"},{"alpha2":"","alpha3":"ine","bibliographic":"","name":"Indo-European languages"},{"alpha2":"","alpha3":"inh","bibliographic":"","name":"Ingush"},{"alpha2":"ik","alpha3":"ipk","bibliographic":"","name":"Inupiaq"},{"alpha2":"","alpha3":"ira","bibliographic":"","name":"Iranian languages"},{"alpha2":"","alpha3":"iro","bibliographic":"","name":"Iroquoian languages"},{"alpha2":"is","alpha3":"isl","bibliographic":"ice","name":"Icelandic"},{"alpha2":"it","alpha3":"ita","bibliographic":"","name":"Italian"},{"alpha2":"jv","alpha3":"jav","bibliographic":"","name":"Javanese"},{"alpha2":"","alpha3":"jbo","bibliographic":"","name":"Lojban"},{"alpha2":"ja","alpha3":"jpn","bibliographic":"","name":"Japanese"},{"alpha2":"","alpha3":"jpr","bibliographic":"","name":"Judeo-Persian"},{"alpha2":"","alpha3":"jrb","bibliographic":"","name":"Judeo-Arabic"},{"alpha2":"","alpha3":"kaa","bibliographic":"","name":"Kara-Kalpak"},{"alpha2":"","alpha3":"kab","bibliographic":"","name":"Kabyle"},{"alpha2":"","alpha3":"kac","bibliographic":"","name":"Jingpho"},{"alpha2":"","alpha3":"kac","bibliographic":"","name":"Kachin"},{"alpha2":"kl","alpha3":"kal","bibliographic":"","name":"Greenlandic"},{"alpha2":"kl","alpha3":"kal","bibliographic":"","name":"Kalaallisut"},{"alpha2":"","alpha3":"kam","bibliographic":"","name":"Kamba"},{"alpha2":"kn","alpha3":"kan","bibliographic":"","name":"Kannada"},{"alpha2":"","alpha3":"kar","bibliographic":"","name":"Karen languages"},{"alpha2":"ks","alpha3":"kas","bibliographic":"","name":"Kashmiri"},{"alpha2":"ka","alpha3":"kat","bibliographic":"geo","name":"Georgian"},{"alpha2":"kr","alpha3":"kau","bibliographic":"","name":"Kanuri"},{"alpha2":"","alpha3":"kaw","bibliographic":"","name":"Kawi"},{"alpha2":"kk","alpha3":"kaz","bibliographic":"","name":"Kazakh"},{"alpha2":"","alpha3":"kbd","bibliographic":"","name":"Kabardian"},{"alpha2":"","alpha3":"kha","bibliographic":"","name":"Khasi"},{"alpha2":"","alpha3":"khi","bibliographic":"","name":"Khoisan languages"},{"alpha2":"km","alpha3":"khm","bibliographic":"","name":"Central Khmer"},{"alpha2":"","alpha3":"kho","bibliographic":"","name":"Khotanese"},{"alpha2":"","alpha3":"kho","bibliographic":"","name":"Sakan"},{"alpha2":"ki","alpha3":"kik","bibliographic":"","name":"Gikuyu"},{"alpha2":"ki","alpha3":"kik","bibliographic":"","name":"Kikuyu"},{"alpha2":"rw","alpha3":"kin","bibliographic":"","name":"Kinyarwanda"},{"alpha2":"ky","alpha3":"kir","bibliographic":"","name":"Kirghiz"},{"alpha2":"ky","alpha3":"kir","bibliographic":"","name":"Kyrgyz"},{"alpha2":"","alpha3":"kmb","bibliographic":"","name":"Kimbundu"},{"alpha2":"","alpha3":"kok","bibliographic":"","name":"Konkani"},{"alpha2":"kv","alpha3":"kom","bibliographic":"","name":"Komi"},{"alpha2":"kg","alpha3":"kon","bibliographic":"","name":"Kongo"},{"alpha2":"ko","alpha3":"kor","bibliographic":"","name":"Korean"},{"alpha2":"","alpha3":"kos","bibliographic":"","name":"Kosraean"},{"alpha2":"","alpha3":"kpe","bibliographic":"","name":"Kpelle"},{"alpha2":"","alpha3":"krc","bibliographic":"","name":"Karachay-Balkar"},{"alpha2":"","alpha3":"krl","bibliographic":"","name":"Karelian"},{"alpha2":"","alpha3":"kro","bibliographic":"","name":"Kru languages"},{"alpha2":"","alpha3":"kru","bibliographic":"","name":"Kurukh"},{"alpha2":"kj","alpha3":"kua","bibliographic":"","name":"Kuanyama"},{"alpha2":"kj","alpha3":"kua","bibliographic":"","name":"Kwanyama"},{"alpha2":"","alpha3":"kum","bibliographic":"","name":"Kumyk"},{"alpha2":"ku","alpha3":"kur","bibliographic":"","name":"Kurdish"},{"alpha2":"","alpha3":"kut","bibliographic":"","name":"Kutenai"},{"alpha2":"","alpha3":"lad","bibliographic":"","name":"Ladino"},{"alpha2":"","alpha3":"lah","bibliographic":"","name":"Lahnda"},{"alpha2":"","alpha3":"lam","bibliographic":"","name":"Lamba"},{"alpha2":"lo","alpha3":"lao","bibliographic":"","name":"Lao"},{"alpha2":"la","alpha3":"lat","bibliographic":"","name":"Latin"},{"alpha2":"lv","alpha3":"lav","bibliographic":"","name":"Latvian"},{"alpha2":"","alpha3":"lez","bibliographic":"","name":"Lezghian"},{"alpha2":"li","alpha3":"lim","bibliographic":"","name":"Limburgan"},{"alpha2":"li","alpha3":"lim","bibliographic":"","name":"Limburger"},{"alpha2":"li","alpha3":"lim","bibliographic":"","name":"Limburgish"},{"alpha2":"ln","alpha3":"lin","bibliographic":"","name":"Lingala"},{"alpha2":"lt","alpha3":"lit","bibliographic":"","name":"Lithuanian"},{"alpha2":"","alpha3":"lol","bibliographic":"","name":"Mongo"},{"alpha2":"","alpha3":"loz","bibliographic":"","name":"Lozi"},{"alpha2":"lb","alpha3":"ltz","bibliographic":"","name":"Letzeburgesch"},{"alpha2":"lb","alpha3":"ltz","bibliographic":"","name":"Luxembourgish"},{"alpha2":"","alpha3":"lua","bibliographic":"","name":"Luba-Lulua"},{"alpha2":"lu","alpha3":"lub","bibliographic":"","name":"Luba-Katanga"},{"alpha2":"lg","alpha3":"lug","bibliographic":"","name":"Ganda"},{"alpha2":"","alpha3":"lui","bibliographic":"","name":"Luiseno"},{"alpha2":"","alpha3":"lun","bibliographic":"","name":"Lunda"},{"alpha2":"","alpha3":"luo","bibliographic":"","name":"Luo (Kenya and Tanzania)"},{"alpha2":"","alpha3":"lus","bibliographic":"","name":"Lushai"},{"alpha2":"","alpha3":"mad","bibliographic":"","name":"Madurese"},{"alpha2":"","alpha3":"mag","bibliographic":"","name":"Magahi"},{"alpha2":"mh","alpha3":"mah","bibliographic":"","name":"Marshallese"},{"alpha2":"","alpha3":"mai","bibliographic":"","name":"Maithili"},{"alpha2":"","alpha3":"mak","bibliographic":"","name":"Makasar"},{"alpha2":"ml","alpha3":"mal","bibliographic":"","name":"Malayalam"},{"alpha2":"","alpha3":"man","bibliographic":"","name":"Mandingo"},{"alpha2":"","alpha3":"map","bibliographic":"","name":"Austronesian languages"},{"alpha2":"mr","alpha3":"mar","bibliographic":"","name":"Marathi"},{"alpha2":"","alpha3":"mas","bibliographic":"","name":"Masai"},{"alpha2":"","alpha3":"mdf","bibliographic":"","name":"Moksha"},{"alpha2":"","alpha3":"mdr","bibliographic":"","name":"Mandar"},{"alpha2":"","alpha3":"men","bibliographic":"","name":"Mende"},{"alpha2":"","alpha3":"mga","bibliographic":"","name":"Irish, Middle (900-1200)"},{"alpha2":"","alpha3":"mic","bibliographic":"","name":"Mi'kmaq"},{"alpha2":"","alpha3":"mic","bibliographic":"","name":"Micmac"},{"alpha2":"","alpha3":"min","bibliographic":"","name":"Minangkabau"},{"alpha2":"","alpha3":"mis","bibliographic":"","name":"Uncoded languages"},{"alpha2":"mk","alpha3":"mkd","bibliographic":"mac","name":"Macedonian"},{"alpha2":"","alpha3":"mkh","bibliographic":"","name":"Mon-Khmer languages"},{"alpha2":"mg","alpha3":"mlg","bibliographic":"","name":"Malagasy"},{"alpha2":"mt","alpha3":"mlt","bibliographic":"","name":"Maltese"},{"alpha2":"","alpha3":"mnc","bibliographic":"","name":"Manchu"},{"alpha2":"","alpha3":"mni","bibliographic":"","name":"Manipuri"},{"alpha2":"","alpha3":"mno","bibliographic":"","name":"Manobo languages"},{"alpha2":"","alpha3":"moh","bibliographic":"","name":"Mohawk"},{"alpha2":"mn","alpha3":"mon","bibliographic":"","name":"Mongolian"},{"alpha2":"","alpha3":"mos","bibliographic":"","name":"Mossi"},{"alpha2":"","alpha3":"mot","bibliographic":"","name":"Montenegrin"},{"alpha2":"mi","alpha3":"mri","bibliographic":"mao","name":"Maori"},{"alpha2":"ms","alpha3":"msa","bibliographic":"may","name":"Malay"},{"alpha2":"","alpha3":"mul","bibliographic":"","name":"Multiple languages"},{"alpha2":"","alpha3":"mun","bibliographic":"","name":"Munda languages"},{"alpha2":"","alpha3":"mus","bibliographic":"","name":"Creek"},{"alpha2":"","alpha3":"mwl","bibliographic":"","name":"Mirandese"},{"alpha2":"","alpha3":"mwr","bibliographic":"","name":"Marwari"},{"alpha2":"my","alpha3":"mya","bibliographic":"bur","name":"Burmese"},{"alpha2":"","alpha3":"myn","bibliographic":"","name":"Mayan languages"},{"alpha2":"","alpha3":"myv","bibliographic":"","name":"Erzya"},{"alpha2":"","alpha3":"nah","bibliographic":"","name":"Nahuatl languages"},{"alpha2":"","alpha3":"nai","bibliographic":"","name":"North American Indian languages"},{"alpha2":"","alpha3":"nap","bibliographic":"","name":"Neapolitan"},{"alpha2":"na","alpha3":"nau","bibliographic":"","name":"Nauru"},{"alpha2":"nv","alpha3":"nav","bibliographic":"","name":"Navaho"},{"alpha2":"nv","alpha3":"nav","bibliographic":"","name":"Navajo"},{"alpha2":"nr","alpha3":"nbl","bibliographic":"","name":"Ndebele, South"},{"alpha2":"nr","alpha3":"nbl","bibliographic":"","name":"South Ndebele"},{"alpha2":"nd","alpha3":"nde","bibliographic":"","name":"Ndebele, North"},{"alpha2":"nd","alpha3":"nde","bibliographic":"","name":"North Ndebele"},{"alpha2":"ng","alpha3":"ndo","bibliographic":"","name":"Ndonga"},{"alpha2":"","alpha3":"nds","bibliographic":"","name":"German, Low"},{"alpha2":"","alpha3":"nds","bibliographic":"","name":"Low German"},{"alpha2":"","alpha3":"nds","bibliographic":"","name":"Low Saxon"},{"alpha2":"","alpha3":"nds","bibliographic":"","name":"Saxon, Low"},{"alpha2":"ne","alpha3":"nep","bibliographic":"","name":"Nepali"},{"alpha2":"","alpha3":"new","bibliographic":"","name":"Nepal Bhasa"},{"alpha2":"","alpha3":"new","bibliographic":"","name":"Newari"},{"alpha2":"","alpha3":"nia","bibliographic":"","name":"Nias"},{"alpha2":"","alpha3":"nic","bibliographic":"","name":"Niger-Kordofanian languages"},{"alpha2":"","alpha3":"niu","bibliographic":"","name":"Niuean"},{"alpha2":"nl","alpha3":"nld","bibliographic":"dut","name":"Dutch"},{"alpha2":"nl","alpha3":"nld","bibliographic":"dut","name":"Flemish"},{"alpha2":"nn","alpha3":"nno","bibliographic":"","name":"Norwegian Nynorsk"},{"alpha2":"nn","alpha3":"nno","bibliographic":"","name":"Nynorsk, Norwegian"},{"alpha2":"nb","alpha3":"nob","bibliographic":"","name":"Bokmål, Norwegian"},{"alpha2":"nb","alpha3":"nob","bibliographic":"","name":"Norwegian Bokmål"},{"alpha2":"","alpha3":"nog","bibliographic":"","name":"Nogai"},{"alpha2":"","alpha3":"non","bibliographic":"","name":"Norse, Old"},{"alpha2":"no","alpha3":"nor","bibliographic":"","name":"Norwegian"},{"alpha2":"","alpha3":"nqo","bibliographic":"","name":"N'Ko"},{"alpha2":"","alpha3":"nso","bibliographic":"","name":"Northern Sotho"},{"alpha2":"","alpha3":"nso","bibliographic":"","name":"Pedi"},{"alpha2":"","alpha3":"nso","bibliographic":"","name":"Sepedi"},{"alpha2":"","alpha3":"nso","bibliographic":"","name":"Sotho, Northern"},{"alpha2":"","alpha3":"nub","bibliographic":"","name":"Nubian languages"},{"alpha2":"","alpha3":"nwc","bibliographic":"","name":"Classical Nepal Bhasa"},{"alpha2":"","alpha3":"nwc","bibliographic":"","name":"Classical Newari"},{"alpha2":"","alpha3":"nwc","bibliographic":"","name":"Old Newari"},{"alpha2":"ny","alpha3":"nya","bibliographic":"","name":"Chewa"},{"alpha2":"ny","alpha3":"nya","bibliographic":"","name":"Chichewa"},{"alpha2":"ny","alpha3":"nya","bibliographic":"","name":"Nyanja"},{"alpha2":"","alpha3":"nym","bibliographic":"","name":"Nyamwezi"},{"alpha2":"","alpha3":"nyn","bibliographic":"","name":"Nyankole"},{"alpha2":"","alpha3":"nyo","bibliographic":"","name":"Nyoro"},{"alpha2":"","alpha3":"nzi","bibliographic":"","name":"Nzima"},{"alpha2":"oc","alpha3":"oci","bibliographic":"","name":"Occitan (post 1500)"},{"alpha2":"oj","alpha3":"oji","bibliographic":"","name":"Ojibwa"},{"alpha2":"or","alpha3":"ori","bibliographic":"","name":"Oriya"},{"alpha2":"om","alpha3":"orm","bibliographic":"","name":"Oromo"},{"alpha2":"","alpha3":"osa","bibliographic":"","name":"Osage"},{"alpha2":"os","alpha3":"oss","bibliographic":"","name":"Ossetian"},{"alpha2":"os","alpha3":"oss","bibliographic":"","name":"Ossetic"},{"alpha2":"","alpha3":"ota","bibliographic":"","name":"Turkish, Ottoman (1500-1928)"},{"alpha2":"","alpha3":"oto","bibliographic":"","name":"Otomian languages"},{"alpha2":"","alpha3":"paa","bibliographic":"","name":"Papuan languages"},{"alpha2":"","alpha3":"pag","bibliographic":"","name":"Pangasinan"},{"alpha2":"","alpha3":"pal","bibliographic":"","name":"Pahlavi"},{"alpha2":"","alpha3":"pam","bibliographic":"","name":"Kapampangan"},{"alpha2":"","alpha3":"pam","bibliographic":"","name":"Pampanga"},{"alpha2":"pa","alpha3":"pan","bibliographic":"","name":"Panjabi"},{"alpha2":"pa","alpha3":"pan","bibliographic":"","name":"Punjabi"},{"alpha2":"","alpha3":"pap","bibliographic":"","name":"Papiamento"},{"alpha2":"","alpha3":"pau","bibliographic":"","name":"Palauan"},{"alpha2":"","alpha3":"peo","bibliographic":"","name":"Persian, Old (ca.600-400 B.C.)"},{"alpha2":"","alpha3":"phi","bibliographic":"","name":"Philippine languages"},{"alpha2":"","alpha3":"phn","bibliographic":"","name":"Phoenician"},{"alpha2":"pi","alpha3":"pli","bibliographic":"","name":"Pali"},{"alpha2":"pl","alpha3":"pol","bibliographic":"","name":"Polish"},{"alpha2":"","alpha3":"pon","bibliographic":"","name":"Pohnpeian"},{"alpha2":"pt","alpha3":"por","bibliographic":"","name":"Portuguese"},{"alpha2":"","alpha3":"pra","bibliographic":"","name":"Prakrit languages"},{"alpha2":"","alpha3":"pro","bibliographic":"","name":"Occitan, Old (to 1500)"},{"alpha2":"","alpha3":"pro","bibliographic":"","name":"Provençal, Old (to 1500)"},{"alpha2":"ps","alpha3":"pus","bibliographic":"","name":"Pashto"},{"alpha2":"ps","alpha3":"pus","bibliographic":"","name":"Pushto"},{"alpha2":"qu","alpha3":"que","bibliographic":"","name":"Quechua"},{"alpha2":"","alpha3":"raj","bibliographic":"","name":"Rajasthani"},{"alpha2":"","alpha3":"rap","bibliographic":"","name":"Rapanui"},{"alpha2":"","alpha3":"rar","bibliographic":"","name":"Cook Islands Maori"},{"alpha2":"","alpha3":"rar","bibliographic":"","name":"Rarotongan"},{"alpha2":"","alpha3":"roa","bibliographic":"","name":"Romance languages"},{"alpha2":"rm","alpha3":"roh","bibliographic":"","name":"Romansh"},{"alpha2":"","alpha3":"rom","bibliographic":"","name":"Romany"},{"alpha2":"ro","alpha3":"ron","bibliographic":"rum","name":"Moldavian"},{"alpha2":"ro","alpha3":"ron","bibliographic":"rum","name":"Romanian"},{"alpha2":"rn","alpha3":"run","bibliographic":"","name":"Rundi"},{"alpha2":"","alpha3":"rup","bibliographic":"","name":"Aromanian"},{"alpha2":"","alpha3":"rup","bibliographic":"","name":"Arumanian"},{"alpha2":"","alpha3":"rup","bibliographic":"","name":"Macedo-Romanian"},{"alpha2":"ru","alpha3":"rus","bibliographic":"","name":"Russian"},{"alpha2":"","alpha3":"sad","bibliographic":"","name":"Sandawe"},{"alpha2":"sg","alpha3":"sag","bibliographic":"","name":"Sango"},{"alpha2":"","alpha3":"sah","bibliographic":"","name":"Yakut"},{"alpha2":"","alpha3":"sai","bibliographic":"","name":"South American Indian languages"},{"alpha2":"","alpha3":"sal","bibliographic":"","name":"Salishan languages"},{"alpha2":"","alpha3":"sam","bibliographic":"","name":"Samaritan Aramaic"},{"alpha2":"sa","alpha3":"san","bibliographic":"","name":"Sanskrit"},{"alpha2":"","alpha3":"sas","bibliographic":"","name":"Sasak"},{"alpha2":"","alpha3":"sat","bibliographic":"","name":"Santali"},{"alpha2":"","alpha3":"scn","bibliographic":"","name":"Sicilian"},{"alpha2":"","alpha3":"sco","bibliographic":"","name":"Scots"},{"alpha2":"","alpha3":"sel","bibliographic":"","name":"Selkup"},{"alpha2":"","alpha3":"sem","bibliographic":"","name":"Semitic languages"},{"alpha2":"","alpha3":"sga","bibliographic":"","name":"Irish, Old (to 900)"},{"alpha2":"","alpha3":"sgn","bibliographic":"","name":"Sign Languages"},{"alpha2":"","alpha3":"shn","bibliographic":"","name":"Shan"},{"alpha2":"","alpha3":"sid","bibliographic":"","name":"Sidamo"},{"alpha2":"si","alpha3":"sin","bibliographic":"","name":"Sinhala"},{"alpha2":"si","alpha3":"sin","bibliographic":"","name":"Sinhalese"},{"alpha2":"","alpha3":"sio","bibliographic":"","name":"Siouan languages"},{"alpha2":"","alpha3":"sit","bibliographic":"","name":"Sino-Tibetan languages"},{"alpha2":"","alpha3":"sla","bibliographic":"","name":"Slavic languages"},{"alpha2":"sk","alpha3":"slk","bibliographic":"slo","name":"Slovak"},{"alpha2":"sl","alpha3":"slv","bibliographic":"","name":"Slovenian"},{"alpha2":"","alpha3":"sma","bibliographic":"","name":"Southern Sami"},{"alpha2":"se","alpha3":"sme","bibliographic":"","name":"Northern Sami"},{"alpha2":"","alpha3":"smi","bibliographic":"","name":"Sami languages"},{"alpha2":"","alpha3":"smj","bibliographic":"","name":"Lule Sami"},{"alpha2":"","alpha3":"smn","bibliographic":"","name":"Inari Sami"},{"alpha2":"sm","alpha3":"smo","bibliographic":"","name":"Samoan"},{"alpha2":"","alpha3":"sms","bibliographic":"","name":"Skolt Sami"},{"alpha2":"sn","alpha3":"sna","bibliographic":"","name":"Shona"},{"alpha2":"sd","alpha3":"snd","bibliographic":"","name":"Sindhi"},{"alpha2":"","alpha3":"snk","bibliographic":"","name":"Soninke"},{"alpha2":"","alpha3":"sog","bibliographic":"","name":"Sogdian"},{"alpha2":"so","alpha3":"som","bibliographic":"","name":"Somali"},{"alpha2":"","alpha3":"son","bibliographic":"","name":"Songhai languages"},{"alpha2":"st","alpha3":"sot","bibliographic":"","name":"Sotho, Southern"},{"alpha2":"es","alpha3":"spa","bibliographic":"","name":"Castilian"},{"alpha2":"es","alpha3":"spa","bibliographic":"","name":"Spanish"},{"alpha2":"sq","alpha3":"sqi","bibliographic":"alb","name":"Albanian"},{"alpha2":"sc","alpha3":"srd","bibliographic":"","name":"Sardinian"},{"alpha2":"","alpha3":"srn","bibliographic":"","name":"Sranan Tongo"},{"alpha2":"sr","alpha3":"srp","bibliographic":"","name":"Serbian"},{"alpha2":"","alpha3":"srr","bibliographic":"","name":"Serer"},{"alpha2":"","alpha3":"ssa","bibliographic":"","name":"Nilo-Saharan languages"},{"alpha2":"ss","alpha3":"ssw","bibliographic":"","name":"Swati"},{"alpha2":"","alpha3":"suk","bibliographic":"","name":"Sukuma"},{"alpha2":"su","alpha3":"sun","bibliographic":"","name":"Sundanese"},{"alpha2":"","alpha3":"sus","bibliographic":"","name":"Susu"},{"alpha2":"","alpha3":"sux","bibliographic":"","name":"Sumerian"},{"alpha2":"sw","alpha3":"swa","bibliographic":"","name":"Swahili"},{"alpha2":"sv","alpha3":"swe","bibliographic":"","name":"Swedish"},{"alpha2":"","alpha3":"syc","bibliographic":"","name":"Classical Syriac"},{"alpha2":"","alpha3":"syr","bibliographic":"","name":"Syriac"},{"alpha2":"ty","alpha3":"tah","bibliographic":"","name":"Tahitian"},{"alpha2":"","alpha3":"tai","bibliographic":"","name":"Tai languages"},{"alpha2":"ta","alpha3":"tam","bibliographic":"","name":"Tamil"},{"alpha2":"tt","alpha3":"tat","bibliographic":"","name":"Tatar"},{"alpha2":"te","alpha3":"tel","bibliographic":"","name":"Telugu"},{"alpha2":"","alpha3":"tem","bibliographic":"","name":"Timne"},{"alpha2":"","alpha3":"ter","bibliographic":"","name":"Tereno"},{"alpha2":"","alpha3":"tet","bibliographic":"","name":"Tetum"},{"alpha2":"tg","alpha3":"tgk","bibliographic":"","name":"Tajik"},{"alpha2":"tl","alpha3":"tgl","bibliographic":"","name":"Tagalog"},{"alpha2":"th","alpha3":"tha","bibliographic":"","name":"Thai"},{"alpha2":"","alpha3":"tig","bibliographic":"","name":"Tigre"},{"alpha2":"ti","alpha3":"tir","bibliographic":"","name":"Tigrinya"},{"alpha2":"","alpha3":"tiv","bibliographic":"","name":"Tiv"},{"alpha2":"","alpha3":"tkl","bibliographic":"","name":"Tokelau"},{"alpha2":"","alpha3":"tlh","bibliographic":"","name":"Klingon"},{"alpha2":"","alpha3":"tlh","bibliographic":"","name":"tlhIngan-Hol"},{"alpha2":"","alpha3":"tli","bibliographic":"","name":"Tlingit"},{"alpha2":"","alpha3":"tmh","bibliographic":"","name":"Tamashek"},{"alpha2":"","alpha3":"tog","bibliographic":"","name":"Tonga (Nyasa)"},{"alpha2":"to","alpha3":"ton","bibliographic":"","name":"Tonga (Tonga Islands)"},{"alpha2":"","alpha3":"tpi","bibliographic":"","name":"Tok Pisin"},{"alpha2":"","alpha3":"tsi","bibliographic":"","name":"Tsimshian"},{"alpha2":"tn","alpha3":"tsn","bibliographic":"","name":"Tswana"},{"alpha2":"ts","alpha3":"tso","bibliographic":"","name":"Tsonga"},{"alpha2":"tk","alpha3":"tuk","bibliographic":"","name":"Turkmen"},{"alpha2":"","alpha3":"tum","bibliographic":"","name":"Tumbuka"},{"alpha2":"","alpha3":"tup","bibliographic":"","name":"Tupi languages"},{"alpha2":"tr","alpha3":"tur","bibliographic":"","name":"Turkish"},{"alpha2":"","alpha3":"tut","bibliographic":"","name":"Altaic languages"},{"alpha2":"","alpha3":"tvl","bibliographic":"","name":"Tuvalu"},{"alpha2":"tw","alpha3":"twi","bibliographic":"","name":"Twi"},{"alpha2":"","alpha3":"tyv","bibliographic":"","name":"Tuvinian"},{"alpha2":"","alpha3":"udm","bibliographic":"","name":"Udmurt"},{"alpha2":"","alpha3":"uga","bibliographic":"","name":"Ugaritic"},{"alpha2":"ug","alpha3":"uig","bibliographic":"","name":"Uighur"},{"alpha2":"ug","alpha3":"uig","bibliographic":"","name":"Uyghur"},{"alpha2":"uk","alpha3":"ukr","bibliographic":"","name":"Ukrainian"},{"alpha2":"","alpha3":"umb","bibliographic":"","name":"Umbundu"},{"alpha2":"","alpha3":"und","bibliographic":"","name":"Undetermined"},{"alpha2":"ur","alpha3":"urd","bibliographic":"","name":"Urdu"},{"alpha2":"uz","alpha3":"uzb","bibliographic":"","name":"Uzbek"},{"alpha2":"","alpha3":"vai","bibliographic":"","name":"Vai"},{"alpha2":"ve","alpha3":"ven","bibliographic":"","name":"Venda"},{"alpha2":"vi","alpha3":"vie","bibliographic":"","name":"Vietnamese"},{"alpha2":"vo","alpha3":"vol","bibliographic":"","name":"Volapük"},{"alpha2":"","alpha3":"vot","bibliographic":"","name":"Votic"},{"alpha2":"","alpha3":"wak","bibliographic":"","name":"Wakashan languages"},{"alpha2":"","alpha3":"wal","bibliographic":"","name":"Wolaitta"},{"alpha2":"","alpha3":"wal","bibliographic":"","name":"Wolaytta"},{"alpha2":"","alpha3":"war","bibliographic":"","name":"Waray"},{"alpha2":"","alpha3":"was","bibliographic":"","name":"Washo"},{"alpha2":"","alpha3":"wen","bibliographic":"","name":"Sorbian languages"},{"alpha2":"wa","alpha3":"wln","bibliographic":"","name":"Walloon"},{"alpha2":"wo","alpha3":"wol","bibliographic":"","name":"Wolof"},{"alpha2":"","alpha3":"xal","bibliographic":"","name":"Kalmyk"},{"alpha2":"","alpha3":"xal","bibliographic":"","name":"Oirat"},{"alpha2":"xh","alpha3":"xho","bibliographic":"","name":"Xhosa"},{"alpha2":"","alpha3":"yao","bibliographic":"","name":"Yao"},{"alpha2":"","alpha3":"yap","bibliographic":"","name":"Yapese"},{"alpha2":"yi","alpha3":"yid","bibliographic":"","name":"Yiddish"},{"alpha2":"yo","alpha3":"yor","bibliographic":"","name":"Yoruba"},{"alpha2":"","alpha3":"ypk","bibliographic":"","name":"Yupik languages"},{"alpha2":"","alpha3":"zap","bibliographic":"","name":"Zapotec"},{"alpha2":"","alpha3":"zbl","bibliographic":"","name":"Bliss"},{"alpha2":"","alpha3":"zbl","bibliographic":"","name":"Blissymbolics"},{"alpha2":"","alpha3":"zbl","bibliographic":"","name":"Blissymbols"},{"alpha2":"","alpha3":"zen","bibliographic":"","name":"Zenaga"},{"alpha2":"","alpha3":"zgh","bibliographic":"","name":"Standard Moroccan Tamazight"},{"alpha2":"za","alpha3":"zha","bibliographic":"","name":"Chuang"},{"alpha2":"za","alpha3":"zha","bibliographic":"","name":"Zhuang"},{"alpha2":"zh","alpha3":"zho","bibliographic":"chi","name":"Chinese"},{"alpha2":"","alpha3":"znd","bibliographic":"","name":"Zande languages"},{"alpha2":"zu","alpha3":"zul","bibliographic":"","name":"Zulu"},{"alpha2":"","alpha3":"zun","bibliographic":"","name":"Zuni"},{"alpha2":"","alpha3":"zxx","bibliographic":"","name":"No linguistic content"},{"alpha2":"","alpha3":"zxx","bibliographic":"","name":"Not applicable"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Dimili"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Dimli"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Kirdki"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Kirmanjki"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Zaza"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Zazaki"}]

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(125);

module.exports = init;

function init(o) {
  return {
    countries: search.bind(null, o.countries),
    currencies: search.bind(null, o.currencies),
    languages: search.bind(null, o.languages)
  };
}

function search(data, query) {
  var q = _.pairs(query);

  return data.filter(function(d) {
    return q.filter(function(v) {
      var prop = d[v[0]];

      if(_.isArray(prop)) return prop.indexOf(v[1]) >= 0;

      return prop == v[1];
    }).length == q.length;
  });
}

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = mapSymbol

var map = __webpack_require__(797)

function mapSymbol(currencyCode) {
  if (map.hasOwnProperty(currencyCode)) {
    return map[currencyCode]
  } else {
    return '?'
  }
}

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports =
{ "ALL": "L"
, "AFN": "؋"
, "ARS": "$"
, "AWG": "ƒ"
, "AUD": "$"
, "AZN": "₼"
, "BSD": "$"
, "BBD": "$"
, "BYR": "p."
, "BZD": "BZ$"
, "BMD": "$"
, "BOB": "Bs."
, "BAM": "KM"
, "BWP": "P"
, "BGN": "лв"
, "BRL": "R$"
, "BND": "$"
, "KHR": "៛"
, "CAD": "$"
, "KYD": "$"
, "CLP": "$"
, "CNY": "¥"
, "COP": "$"
, "CRC": "₡"
, "HRK": "kn"
, "CUP": "₱"
, "CZK": "Kč"
, "DKK": "kr"
, "DOP": "RD$"
, "XCD": "$"
, "EGP": "£"
, "SVC": "$"
, "EEK": "kr"
, "EUR": "€"
, "FKP": "£"
, "FJD": "$"
, "GHC": "¢"
, "GIP": "£"
, "GTQ": "Q"
, "GGP": "£"
, "GYD": "$"
, "HNL": "L"
, "HKD": "$"
, "HUF": "Ft"
, "ISK": "kr"
, "INR": "₹"
, "IDR": "Rp"
, "IRR": "﷼"
, "IMP": "£"
, "ILS": "₪"
, "JMD": "J$"
, "JPY": "¥"
, "JEP": "£"
, "KES": "KSh"
, "KZT": "лв"
, "KPW": "₩"
, "KRW": "₩"
, "KGS": "лв"
, "LAK": "₭"
, "LVL": "Ls"
, "LBP": "£"
, "LRD": "$"
, "LTL": "Lt"
, "MKD": "ден"
, "MYR": "RM"
, "MUR": "₨"
, "MXN": "$"
, "MNT": "₮"
, "MZN": "MT"
, "NAD": "$"
, "NPR": "₨"
, "ANG": "ƒ"
, "NZD": "$"
, "NIO": "C$"
, "NGN": "₦"
, "NOK": "kr"
, "OMR": "﷼"
, "PKR": "₨"
, "PAB": "B/."
, "PYG": "Gs"
, "PEN": "S/."
, "PHP": "₱"
, "PLN": "zł"
, "QAR": "﷼"
, "RON": "lei"
, "RUB": "₽"
, "SHP": "£"
, "SAR": "﷼"
, "RSD": "Дин."
, "SCR": "₨"
, "SGD": "$"
, "SBD": "$"
, "SOS": "S"
, "ZAR": "R"
, "LKR": "₨"
, "SEK": "kr"
, "CHF": "CHF"
, "SRD": "$"
, "SYP": "£"
, "TZS": "TSh"
, "TWD": "NT$"
, "THB": "฿"
, "TTD": "TT$"
, "TRY": ""
, "TRL": "₤"
, "TVD": "$"
, "UGX": "USh"
, "UAH": "₴"
, "GBP": "£"
, "USD": "$"
, "UYU": "$U"
, "UZS": "лв"
, "VEF": "Bs"
, "VND": "₫"
, "YER": "﷼"
, "ZWD": "Z$"
}


/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{'modal':true, 'show':_vm.showModal}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeModal}}),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchString),expression:"searchString"}],attrs:{"type":"text","placeholder":"Search a country..."},domProps:{"value":(_vm.searchString)},on:{"keyup":_vm.filter,"input":function($event){if($event.target.composing){ return; }_vm.searchString=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"country-list"},_vm._l((_vm.countryList),function(country,index){return (country.dialCode)?_c('div',{staticClass:"country-name",on:{"click":function($event){return _vm.selectCountry(index)}}},[_c('div',{class:['iti-flag ' + country.code]}),_vm._v(" "),_c('span',{staticClass:"country-code"},[_vm._v(" "+_vm._s(country.name)+" ")]),_vm._v(" "),(!_vm.countryOnly)?_c('span',{staticClass:"name"},[_vm._v(" (+"+_vm._s(country.dialCode)+") ")]):_vm._e()]):_vm._e()}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlightInformationModal_vue__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60d51f7f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlightInformationModal_vue__ = __webpack_require__(802);
function injectStyle (ssrContext) {
  __webpack_require__(800)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60d51f7f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlightInformationModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60d51f7f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlightInformationModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(801);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("608a1332", content, true, {});

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.flight-modal[data-v-60d51f7f] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.flight-modal.show[data-v-60d51f7f] {\n    top: 0;\n    opacity: 1;\n}\n.flight-modal-container[data-v-60d51f7f] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.flight-modal-content[data-v-60d51f7f] {\n  text-align: center;\n  overflow: hidden;\n}\n.loader[data-v-60d51f7f] {\n  padding: 15px;\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 300px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n}\n.loader i[data-v-60d51f7f] {\n    display: block;\n    color: #0D79F2;\n}\n.loader .title[data-v-60d51f7f] {\n    margin-top: 10px;\n    color: #777;\n    font-weight: 700;\n}\n.flight-info[data-v-60d51f7f] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 300px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n}\n.flight-info .title[data-v-60d51f7f] {\n    background-color: #333;\n    color: #fff;\n    font-weight: 700;\n    padding: 5px;\n}\n.flight-info .label-value[data-v-60d51f7f] {\n    padding: 10px 0;\n    margin: 0 15px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.flight-info .label-value .label[data-v-60d51f7f] {\n      font-size: 10px;\n      font-weight: 700;\n      color: #777;\n}\n.flight-info .label-value .value[data-v-60d51f7f] {\n      font-weight: 700;\n      font-size: 14px;\n}\n.flight-info .close-button[data-v-60d51f7f] {\n    margin: 10px 15px 0;\n    padding: 0 0 10px;\n}\n.flight-info .close-button .button[data-v-60d51f7f] {\n      background-color: #333;\n      font-weight: 700;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/App/FlightInformationModal.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,mBAAmB;EACnB,iBAAiB;CAClB;AACD;EACE,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;CACnD;AACD;IACI,eAAe;IACf,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;CACpB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;CACnD;AACD;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,aAAa;CAChB;AACD;IACI,gBAAgB;IAChB,eAAe;IACf,6CAA6C;CAChD;AACD;MACM,gBAAgB;MAChB,iBAAiB;MACjB,YAAY;CACjB;AACD;MACM,iBAAiB;MACjB,gBAAgB;CACrB;AACD;IACI,oBAAoB;IACpB,kBAAkB;CACrB;AACD;MACM,uBAAuB;MACvB,iBAAiB;CACtB","file":"FlightInformationModal.vue","sourcesContent":["\n.flight-modal[data-v-60d51f7f] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.flight-modal.show[data-v-60d51f7f] {\n    top: 0;\n    opacity: 1;\n}\n.flight-modal-container[data-v-60d51f7f] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.flight-modal-content[data-v-60d51f7f] {\n  text-align: center;\n  overflow: hidden;\n}\n.loader[data-v-60d51f7f] {\n  padding: 15px;\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 300px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n}\n.loader i[data-v-60d51f7f] {\n    display: block;\n    color: #0D79F2;\n}\n.loader .title[data-v-60d51f7f] {\n    margin-top: 10px;\n    color: #777;\n    font-weight: 700;\n}\n.flight-info[data-v-60d51f7f] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 300px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n}\n.flight-info .title[data-v-60d51f7f] {\n    background-color: #333;\n    color: #fff;\n    font-weight: 700;\n    padding: 5px;\n}\n.flight-info .label-value[data-v-60d51f7f] {\n    padding: 10px 0;\n    margin: 0 15px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.flight-info .label-value .label[data-v-60d51f7f] {\n      font-size: 10px;\n      font-weight: 700;\n      color: #777;\n}\n.flight-info .label-value .value[data-v-60d51f7f] {\n      font-weight: 700;\n      font-size: 14px;\n}\n.flight-info .close-button[data-v-60d51f7f] {\n    margin: 10px 15px 0;\n    padding: 0 0 10px;\n}\n.flight-info .close-button .button[data-v-60d51f7f] {\n      background-color: #333;\n      font-weight: 700;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'flight-modal': true, show: _vm.flightInfo.show },on:{"click":_vm.close}},[_c('div',{staticClass:"flight-modal-container"},[_c('div',{staticClass:"flight-modal-content"},[(_vm.flightInfo.loading)?_c('div',{staticClass:"loader",on:{"click":function($event){$event.stopPropagation();}}},[_c('i',{staticClass:"fas fa-circle-notch fa-spin fa-2x"}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Loading flight information...")])]):_c('div',{staticClass:"flight-info",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"title"},[_vm._v("FLIGHT INFORMATION")]),_vm._v(" "),_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v("AIRLINE")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.flightInfo.airline.name)+" ("+_vm._s(_vm.flightInfo.airline.code)+")")])]),_vm._v(" "),_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v("FLIGHT NUMBER")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.flightInfo.flightNumber))])]),_vm._v(" "),_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v("DEPARTURE AIRPORT")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.flightInfo.departure.airportCode !== '')?_c('span',[_vm._v("\n              "+_vm._s(_vm.flightInfo.departure.airportCode)+" - "+_vm._s(_vm.flightInfo.departure.airportName)+"\n            ")]):_c('span',[_vm._v("N/A")])])]),_vm._v(" "),(_vm.flightInfo.type === 'departure')?_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v("DEPARTURE TIME")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.flightInfo.arrival.time !== '')?_c('span',[_vm._v(_vm._s(_vm.flightInfo.arrival.time))]):_c('span',[_vm._v("N/A")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v("ARRIVAL AIRPORT")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.flightInfo.arrival.airportCode !== '')?_c('span',[_vm._v("\n              "+_vm._s(_vm.flightInfo.arrival.airportCode)+" - "+_vm._s(_vm.flightInfo.arrival.airportName)+"\n            ")]):_c('span',[_vm._v("N/A")])])]),_vm._v(" "),(_vm.flightInfo.type !== 'departure')?_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v("ARRIVAL TIME")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.flightInfo.arrival.time !== '')?_c('span',[_vm._v(_vm._s(_vm.flightInfo.arrival.time))]):_c('span',[_vm._v("N/A")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v("STATUS")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.flightInfo.status))])]),_vm._v(" "),_c('div',{staticClass:"close-button"},[_c('a',{staticClass:"button block small",on:{"click":_vm.close}},[_vm._v("CLOSE")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PhoneApp_vue__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0225d3e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PhoneApp_vue__ = __webpack_require__(809);
function injectStyle (ssrContext) {
  __webpack_require__(804)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0225d3e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PhoneApp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0225d3e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PhoneApp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(805);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("7e3087bb", content, true, {});

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.phone-app[data-v-0225d3e0] {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 99;\n  background-color: #444;\n  border-radius: 5px;\n  padding: 15px 15px;\n  color: #fff;\n  -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);\n  text-align: center;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.phone-app.hide[data-v-0225d3e0] {\n    top: -300px;\n}\n.phone-app img[data-v-0225d3e0] {\n    position: absolute;\n    top: 20px;\n    left: calc(50% - 25px);\n    width: 50px;\n    height: 50px;\n    background-color: #ddd;\n    border-radius: 50%;\n}\n.phone-app .status[data-v-0225d3e0] {\n    display: block;\n    font-style: normal;\n    font-size: 10px;\n    font-weight: 700;\n    margin-top: 5px;\n}\n.phone-app .name[data-v-0225d3e0] {\n    font-size: 16px;\n    font-weight: 700;\n    color: #eee;\n}\n.phone-app .phone[data-v-0225d3e0] {\n    font-size: 12px;\n    font-weight: 700;\n    margin-top: 3px;\n    margin-bottom: 10px;\n}\n.phone-app .button[data-v-0225d3e0] {\n    padding: 0;\n    width: 45px;\n    height: 45px;\n    line-height: 45px;\n    border-radius: 50%;\n    text-align: center;\n}\n.phone-app .button i[data-v-0225d3e0] {\n      line-height: inherit;\n}\n.phone-app .button.margin-L[data-v-0225d3e0] {\n      margin-left: 5px;\n}\n.phone-app .button.margin-R[data-v-0225d3e0] {\n      margin-right: 5px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/App/PhoneApp.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,YAAY;CACf;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;CACtB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;CACvB;AACD;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;CACtB;AACD;MACM,qBAAqB;CAC1B;AACD;MACM,iBAAiB;CACtB;AACD;MACM,kBAAkB;CACvB","file":"PhoneApp.vue","sourcesContent":["\n.phone-app[data-v-0225d3e0] {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 99;\n  background-color: #444;\n  border-radius: 5px;\n  padding: 15px 15px;\n  color: #fff;\n  -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);\n  text-align: center;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.phone-app.hide[data-v-0225d3e0] {\n    top: -300px;\n}\n.phone-app img[data-v-0225d3e0] {\n    position: absolute;\n    top: 20px;\n    left: calc(50% - 25px);\n    width: 50px;\n    height: 50px;\n    background-color: #ddd;\n    border-radius: 50%;\n}\n.phone-app .status[data-v-0225d3e0] {\n    display: block;\n    font-style: normal;\n    font-size: 10px;\n    font-weight: 700;\n    margin-top: 5px;\n}\n.phone-app .name[data-v-0225d3e0] {\n    font-size: 16px;\n    font-weight: 700;\n    color: #eee;\n}\n.phone-app .phone[data-v-0225d3e0] {\n    font-size: 12px;\n    font-weight: 700;\n    margin-top: 3px;\n    margin-bottom: 10px;\n}\n.phone-app .button[data-v-0225d3e0] {\n    padding: 0;\n    width: 45px;\n    height: 45px;\n    line-height: 45px;\n    border-radius: 50%;\n    text-align: center;\n}\n.phone-app .button i[data-v-0225d3e0] {\n      line-height: inherit;\n}\n.phone-app .button.margin-L[data-v-0225d3e0] {\n      margin-left: 5px;\n}\n.phone-app .button.margin-R[data-v-0225d3e0] {\n      margin-right: 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(807);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1cf0d402", content, true, {});

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.spinner[data-v-4edaaba8] {\n  width: 60px;\n  height: 60px;\n  position: relative;\n  margin: 0 auto;\n}\n.double-bounce1[data-v-4edaaba8], .double-bounce2[data-v-4edaaba8] {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background-color: #FFF;\n  opacity: 0.6;\n  position: absolute;\n  top: 0;\n  left: 0;\n  -webkit-animation: sk-bounce-data-v-4edaaba8 2.0s infinite ease-in-out;\n  animation: sk-bounce-data-v-4edaaba8 2.0s infinite ease-in-out;\n}\n.double-bounce2[data-v-4edaaba8] {\n  -webkit-animation-delay: -1.0s;\n  animation-delay: -1.0s;\n}\n@-webkit-keyframes sk-bounce-data-v-4edaaba8 {\n0%, 100% {\n    -webkit-transform: scale(0);\n}\n50% {\n    -webkit-transform: scale(1);\n}\n}\n@keyframes sk-bounce-data-v-4edaaba8 {\n0%, 100% {\n    transform: scale(0);\n    -webkit-transform: scale(0);\n}\n50% {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Partials/LoadingAnimation/Pulse.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;CAChB;AACD;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,uEAAuE;EACvE,+DAA+D;CAChE;AACD;EACE,+BAA+B;EAC/B,uBAAuB;CACxB;AACD;AACA;IACI,4BAA4B;CAC/B;AACD;IACI,4BAA4B;CAC/B;CACA;AACD;AACA;IACI,oBAAoB;IACpB,4BAA4B;CAC/B;AACD;IACI,oBAAoB;IACpB,4BAA4B;CAC/B;CACA","file":"Pulse.vue","sourcesContent":["\n.spinner[data-v-4edaaba8] {\n  width: 60px;\n  height: 60px;\n  position: relative;\n  margin: 0 auto;\n}\n.double-bounce1[data-v-4edaaba8], .double-bounce2[data-v-4edaaba8] {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background-color: #FFF;\n  opacity: 0.6;\n  position: absolute;\n  top: 0;\n  left: 0;\n  -webkit-animation: sk-bounce-data-v-4edaaba8 2.0s infinite ease-in-out;\n  animation: sk-bounce-data-v-4edaaba8 2.0s infinite ease-in-out;\n}\n.double-bounce2[data-v-4edaaba8] {\n  -webkit-animation-delay: -1.0s;\n  animation-delay: -1.0s;\n}\n@-webkit-keyframes sk-bounce-data-v-4edaaba8 {\n0%, 100% {\n    -webkit-transform: scale(0);\n}\n50% {\n    -webkit-transform: scale(1);\n}\n}\n@keyframes sk-bounce-data-v-4edaaba8 {\n0%, 100% {\n    transform: scale(0);\n    -webkit-transform: scale(0);\n}\n50% {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"double-bounce1"}),_vm._v(" "),_c('div',{staticClass:"double-bounce2"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.remove)?_c('div',{class:{ 'phone-app': true, hide: !_vm.phoneCall.ongoing }},[_c('pulse-loader'),_vm._v(" "),_c('img',{attrs:{"src":"https://s3.amazonaws.com/37assets/svn/765-default-avatar.png"}}),_vm._v(" "),_c('div',{staticClass:"status"},[_vm._v("CALLING...")]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.phoneCall.name))]),_vm._v(" "),_c('div',{staticClass:"phone"},[_vm._v(_vm._s(_vm.phoneCall.phone))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns"},[_c('a',{staticClass:"button margin-R",attrs:{"href":"javascript:;"},on:{"click":_vm.toggleMute}},[_c('i',{class:{
          'fas fa-fw': true,
          'fa-microphone-slash': _vm.isMute,
          'fa-microphone': !_vm.isMute
        }})])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('a',{staticClass:"button error margin-L",attrs:{"href":"javascript:;"},on:{"click":_vm.endCall}},[_c('i',{staticClass:"fas fa-phone fa-fw fa-rotate-270"})])])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationNotesModal_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e3ba6dc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationNotesModal_vue__ = __webpack_require__(832);
function injectStyle (ssrContext) {
  __webpack_require__(811)
  __webpack_require__(813)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e3ba6dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationNotesModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e3ba6dc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationNotesModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(812);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("e4838fa0", content, true, {});

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.reservation-notes-modal[data-v-0e3ba6dc] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.reservation-notes-modal.show[data-v-0e3ba6dc] {\n    top: 0;\n    opacity: 1;\n}\n.reservation-notes-modal-container[data-v-0e3ba6dc] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.reservation-notes-modal-content[data-v-0e3ba6dc] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  max-height: 100vh;\n  overflow: auto;\n}\n.notes-modal .title[data-v-0e3ba6dc] {\n  color: #fff;\n  background-color: #0D79F2;\n  padding: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.notes-modal .customer-label[data-v-0e3ba6dc] {\n  padding: 15px 15px 5px;\n  font-size: 14px;\n  color: #333;\n}\n.notes-modal label[data-v-0e3ba6dc] {\n  display: block;\n  font-weight: 700;\n  font-size: 14px;\n  color: #555;\n  margin-bottom: 5px;\n}\n.notes-modal .cancel-reason[data-v-0e3ba6dc] {\n  margin-top: 15px;\n}\n.notes-modal .notes[data-v-0e3ba6dc], .notes-modal .cancel-reason[data-v-0e3ba6dc] {\n  text-align: left;\n  padding: 15px;\n}\n.notes-modal .notes textarea[data-v-0e3ba6dc], .notes-modal .notes .textarea[data-v-0e3ba6dc], .notes-modal .cancel-reason textarea[data-v-0e3ba6dc], .notes-modal .cancel-reason .textarea[data-v-0e3ba6dc] {\n    resize: none;\n    display: block;\n    outline: 0;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    width: 100%;\n    border: 1px solid rgba(0, 0, 0, 0.35);\n    height: 100px;\n    font-size: 14px;\n    padding: 10px;\n    line-height: inherit;\n    border-radius: 3px;\n    overflow: auto;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.notes-modal .notes textarea.error[data-v-0e3ba6dc], .notes-modal .notes .textarea.error[data-v-0e3ba6dc], .notes-modal .cancel-reason textarea.error[data-v-0e3ba6dc], .notes-modal .cancel-reason .textarea.error[data-v-0e3ba6dc] {\n      border-color: #F20D0D;\n      border-width: 2px;\n      background-color: rgba(242, 13, 13, 0.03);\n      border-radius: 0;\n      border-top-left-radius: 3px;\n      border-top-right-radius: 3px;\n}\n.notes-modal .notes span[data-v-0e3ba6dc], .notes-modal .cancel-reason span[data-v-0e3ba6dc] {\n    display: block;\n    text-align: right;\n    font-size: 12px;\n    margin-top: 2px;\n    font-weight: 700;\n    color: #777;\n}\n.notes-modal .status[data-v-0e3ba6dc], .notes-modal .cancel-reason[data-v-0e3ba6dc] {\n  text-align: left;\n  padding: 0 15px 15px;\n}\n.notes-modal .status select[data-v-0e3ba6dc], .notes-modal .cancel-reason select[data-v-0e3ba6dc] {\n    display: block;\n    outline: 0;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    border: 1px solid rgba(0, 0, 0, 0.35);\n    font-size: 14px;\n    padding: 10px;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n}\n.notes-modal .controls[data-v-0e3ba6dc] {\n  padding: 0 15px 15px;\n}\n.notes-modal .controls .padding-L[data-v-0e3ba6dc] {\n    padding-left: 7px;\n}\n.notes-modal .controls .padding-R[data-v-0e3ba6dc] {\n    padding-right: 7px;\n}\n.notes-modal .error-message[data-v-0e3ba6dc] {\n  background-color: #F20D0D;\n  color: #fff;\n  font-size: 12px;\n  text-align: center;\n  font-weight: 700;\n  padding: 0 3px;\n  height: 0;\n  overflow: hidden;\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.notes-modal .error-message.show[data-v-0e3ba6dc] {\n    height: 26px;\n    padding: 3px 3px;\n}\n.success-modal[data-v-0e3ba6dc] {\n  padding: 15px 0;\n}\n.success-modal i[data-v-0e3ba6dc] {\n    color: #26D97A;\n    margin-bottom: 10px;\n}\n.success-modal .message[data-v-0e3ba6dc] {\n    font-weight: 700;\n    color: #555;\n}\n.full-refund[data-v-0e3ba6dc] {\n  padding: 10px 20px;\n  font-size: 13px;\n  background: #f7eeb2;\n  border: 1px solid #d0be42;\n  border-radius: 4px;\n  margin: 10px 10px 0;\n  line-height: 140%;\n}\n.full-refund span[data-v-0e3ba6dc] {\n    display: block;\n}\n.full-refund label[data-v-0e3ba6dc] {\n    display: inline-block;\n    margin: 10px 20px 0;\n    cursor: pointer;\n}\n.full-refund label input[data-v-0e3ba6dc] {\n      margin: 0 3px 0 0;\n      width: auto;\n      display: inline-block;\n      vertical-align: -1px;\n}\n.cancel-fee-loader[data-v-0e3ba6dc] {\n  color: #5da3f0;\n  margin-top: 10px;\n}\n.cancellation-fee[data-v-0e3ba6dc] {\n  padding: 10px 20px;\n  font-size: 12.5px;\n  background: #f4c6c6;\n  border: 1px solid #e75e5e;\n  border-radius: 4px;\n  margin: 10px 10px 0;\n  line-height: 140%;\n}\n.cancellation-fee span[data-v-0e3ba6dc] {\n    display: block;\n}\n.cancellation-fee label[data-v-0e3ba6dc] {\n    display: inline-block;\n    margin: 10px 20px 0;\n    cursor: pointer;\n}\n.cancellation-fee label input[data-v-0e3ba6dc] {\n      margin: 0 3px 0 0;\n      width: auto;\n      display: inline-block;\n      vertical-align: -1px;\n}\n.cancellation[data-v-0e3ba6dc] {\n  text-align: left;\n  padding: 20px;\n  padding-bottom: 5px;\n}\n.cancellation label[data-v-0e3ba6dc] {\n    display: table-cell;\n}\n.cancellation label[data-v-0e3ba6dc]:hover {\n      cursor: pointer;\n}\n.cancellation input[data-v-0e3ba6dc] {\n    width: auto !important;\n    display: inline-block;\n}\n.cancellation .reason-select[data-v-0e3ba6dc] {\n    padding: 0 17px;\n}\n.cancellation .reason[data-v-0e3ba6dc] {\n    margin-top: 5px;\n    display: block;\n}\n.partial-refund[data-v-0e3ba6dc] {\n  padding: 10px;\n  text-align: left;\n}\n.partial-refund label[data-v-0e3ba6dc] {\n    line-height: 1;\n}\n.refund-field[data-v-0e3ba6dc] {\n  line-height: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.refund-field select[data-v-0e3ba6dc] {\n    padding: 5px;\n    font-size: 15px;\n    height: 40px;\n    vertical-align: top;\n}\n.refund-field .refund-input[data-v-0e3ba6dc] {\n    vertical-align: top;\n    width: 0;\n    opacity: 0;\n    position: relative;\n    -webkit-transition: all .3s ease-in;\n    transition: all .3s ease-in;\n}\n.refund-field .refund-input i[data-v-0e3ba6dc] {\n      position: absolute;\n      z-index: 2;\n      top: 50%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      left: 5px;\n      color: #ccc;\n}\n.refund-field .refund-input input[data-v-0e3ba6dc] {\n      margin: 0;\n      height: 40px;\n      border-color: #999;\n      padding-left: 22px;\n      position: relative;\n      border-radius: 0 3px 3px 0;\n      z-index: 1;\n}\n.refund-field .refund-input input.has-error[data-v-0e3ba6dc] {\n        border-color: #ff6115;\n}\n.refund-field span.has-error[data-v-0e3ba6dc] {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    padding: 4px 5px;\n    background: #ff6115;\n    color: #fff;\n    font-size: 13px;\n    line-height: 1;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.refund-field.show-input select[data-v-0e3ba6dc] {\n    border-right: none;\n    border-radius: 3px 0 0 3px;\n}\n.refund-field.show-input .refund-input[data-v-0e3ba6dc] {\n    width: 140px;\n    opacity: 1;\n}\n.refund-fail[data-v-0e3ba6dc] {\n  padding: 20px;\n}\n.refund-fail i[data-v-0e3ba6dc] {\n    margin-bottom: 10px;\n}\n.refund-fail i.fa-exclamation-triangle[data-v-0e3ba6dc] {\n      color: #ffc800;\n}\n.refund-fail i.fa-thumbs-up[data-v-0e3ba6dc] {\n      color: #26d97a;\n}\n.refund-fail .message[data-v-0e3ba6dc] {\n    font-size: 15px;\n    margin-bottom: 20px;\n}\n.cancel-error[data-v-0e3ba6dc] {\n  background-color: red;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  text-align: center;\n  padding: 5px;\n}\n.select-error[data-v-0e3ba6dc] {\n  border: 2px solid red !important;\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/App/ReservationNotesModal.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;CAChB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,cAAc;EACd,iBAAiB;EACjB,0BAA0B;CAC3B;AACD;EACE,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;CACb;AACD;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;CACpB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,cAAc;CACf;AACD;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,yBAAyB;OACtB,sBAAsB;YACjB,iBAAiB;IACzB,+BAA+B;YACvB,uBAAuB;IAC/B,YAAY;IACZ,sCAAsC;IACtC,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;MACM,sBAAsB;MACtB,kBAAkB;MAClB,0CAA0C;MAC1C,iBAAiB;MACjB,4BAA4B;MAC5B,6BAA6B;CAClC;AACD;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,iBAAiB;EACjB,qBAAqB;CACtB;AACD;IACI,eAAe;IACf,WAAW;IACX,+BAA+B;YACvB,uBAAuB;IAC/B,sCAAsC;IACtC,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,wDAAwD;IACxD,6BAA6B;IAC7B,+BAA+B;CAClC;AACD;EACE,qBAAqB;CACtB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,mBAAmB;CACtB;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,+BAA+B;EAC/B,gCAAgC;EAChC,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,aAAa;IACb,iBAAiB;CACpB;AACD;EACE,gBAAgB;CACjB;AACD;IACI,eAAe;IACf,oBAAoB;CACvB;AACD;IACI,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;CACnB;AACD;IACI,eAAe;CAClB;AACD;IACI,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;MACM,kBAAkB;MAClB,YAAY;MACZ,sBAAsB;MACtB,qBAAqB;CAC1B;AACD;EACE,eAAe;EACf,iBAAiB;CAClB;AACD;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;CACnB;AACD;IACI,eAAe;CAClB;AACD;IACI,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;MACM,kBAAkB;MAClB,YAAY;MACZ,sBAAsB;MACtB,qBAAqB;CAC1B;AACD;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;CACrB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,gBAAgB;CACrB;AACD;IACI,uBAAuB;IACvB,sBAAsB;CACzB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,eAAe;CAClB;AACD;EACE,cAAc;EACd,iBAAiB;CAClB;AACD;IACI,eAAe;CAClB;AACD;EACE,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;CACpB;AACD;IACI,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,oBAAoB;CACvB;AACD;IACI,oBAAoB;IACpB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,oCAAoC;IACpC,4BAA4B;CAC/B;AACD;MACM,mBAAmB;MACnB,WAAW;MACX,SAAS;MACT,oCAAoC;cAC5B,4BAA4B;MACpC,UAAU;MACV,YAAY;CACjB;AACD;MACM,UAAU;MACV,aAAa;MACb,mBAAmB;MACnB,mBAAmB;MACnB,mBAAmB;MACnB,2BAA2B;MAC3B,WAAW;CAChB;AACD;QACQ,sBAAsB;CAC7B;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;IACI,mBAAmB;IACnB,2BAA2B;CAC9B;AACD;IACI,aAAa;IACb,WAAW;CACd;AACD;EACE,cAAc;CACf;AACD;IACI,oBAAoB;CACvB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;CACd;AACD;EACE,iCAAiC;EACjC,yCAAyC;EACzC,wCAAwC;CACzC","file":"ReservationNotesModal.vue","sourcesContent":["\n.reservation-notes-modal[data-v-0e3ba6dc] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.reservation-notes-modal.show[data-v-0e3ba6dc] {\n    top: 0;\n    opacity: 1;\n}\n.reservation-notes-modal-container[data-v-0e3ba6dc] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.reservation-notes-modal-content[data-v-0e3ba6dc] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  max-height: 100vh;\n  overflow: auto;\n}\n.notes-modal .title[data-v-0e3ba6dc] {\n  color: #fff;\n  background-color: #0D79F2;\n  padding: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.notes-modal .customer-label[data-v-0e3ba6dc] {\n  padding: 15px 15px 5px;\n  font-size: 14px;\n  color: #333;\n}\n.notes-modal label[data-v-0e3ba6dc] {\n  display: block;\n  font-weight: 700;\n  font-size: 14px;\n  color: #555;\n  margin-bottom: 5px;\n}\n.notes-modal .cancel-reason[data-v-0e3ba6dc] {\n  margin-top: 15px;\n}\n.notes-modal .notes[data-v-0e3ba6dc], .notes-modal .cancel-reason[data-v-0e3ba6dc] {\n  text-align: left;\n  padding: 15px;\n}\n.notes-modal .notes textarea[data-v-0e3ba6dc], .notes-modal .notes .textarea[data-v-0e3ba6dc], .notes-modal .cancel-reason textarea[data-v-0e3ba6dc], .notes-modal .cancel-reason .textarea[data-v-0e3ba6dc] {\n    resize: none;\n    display: block;\n    outline: 0;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    width: 100%;\n    border: 1px solid rgba(0, 0, 0, 0.35);\n    height: 100px;\n    font-size: 14px;\n    padding: 10px;\n    line-height: inherit;\n    border-radius: 3px;\n    overflow: auto;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.notes-modal .notes textarea.error[data-v-0e3ba6dc], .notes-modal .notes .textarea.error[data-v-0e3ba6dc], .notes-modal .cancel-reason textarea.error[data-v-0e3ba6dc], .notes-modal .cancel-reason .textarea.error[data-v-0e3ba6dc] {\n      border-color: #F20D0D;\n      border-width: 2px;\n      background-color: rgba(242, 13, 13, 0.03);\n      border-radius: 0;\n      border-top-left-radius: 3px;\n      border-top-right-radius: 3px;\n}\n.notes-modal .notes span[data-v-0e3ba6dc], .notes-modal .cancel-reason span[data-v-0e3ba6dc] {\n    display: block;\n    text-align: right;\n    font-size: 12px;\n    margin-top: 2px;\n    font-weight: 700;\n    color: #777;\n}\n.notes-modal .status[data-v-0e3ba6dc], .notes-modal .cancel-reason[data-v-0e3ba6dc] {\n  text-align: left;\n  padding: 0 15px 15px;\n}\n.notes-modal .status select[data-v-0e3ba6dc], .notes-modal .cancel-reason select[data-v-0e3ba6dc] {\n    display: block;\n    outline: 0;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    border: 1px solid rgba(0, 0, 0, 0.35);\n    font-size: 14px;\n    padding: 10px;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n}\n.notes-modal .controls[data-v-0e3ba6dc] {\n  padding: 0 15px 15px;\n}\n.notes-modal .controls .padding-L[data-v-0e3ba6dc] {\n    padding-left: 7px;\n}\n.notes-modal .controls .padding-R[data-v-0e3ba6dc] {\n    padding-right: 7px;\n}\n.notes-modal .error-message[data-v-0e3ba6dc] {\n  background-color: #F20D0D;\n  color: #fff;\n  font-size: 12px;\n  text-align: center;\n  font-weight: 700;\n  padding: 0 3px;\n  height: 0;\n  overflow: hidden;\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.notes-modal .error-message.show[data-v-0e3ba6dc] {\n    height: 26px;\n    padding: 3px 3px;\n}\n.success-modal[data-v-0e3ba6dc] {\n  padding: 15px 0;\n}\n.success-modal i[data-v-0e3ba6dc] {\n    color: #26D97A;\n    margin-bottom: 10px;\n}\n.success-modal .message[data-v-0e3ba6dc] {\n    font-weight: 700;\n    color: #555;\n}\n.full-refund[data-v-0e3ba6dc] {\n  padding: 10px 20px;\n  font-size: 13px;\n  background: #f7eeb2;\n  border: 1px solid #d0be42;\n  border-radius: 4px;\n  margin: 10px 10px 0;\n  line-height: 140%;\n}\n.full-refund span[data-v-0e3ba6dc] {\n    display: block;\n}\n.full-refund label[data-v-0e3ba6dc] {\n    display: inline-block;\n    margin: 10px 20px 0;\n    cursor: pointer;\n}\n.full-refund label input[data-v-0e3ba6dc] {\n      margin: 0 3px 0 0;\n      width: auto;\n      display: inline-block;\n      vertical-align: -1px;\n}\n.cancel-fee-loader[data-v-0e3ba6dc] {\n  color: #5da3f0;\n  margin-top: 10px;\n}\n.cancellation-fee[data-v-0e3ba6dc] {\n  padding: 10px 20px;\n  font-size: 12.5px;\n  background: #f4c6c6;\n  border: 1px solid #e75e5e;\n  border-radius: 4px;\n  margin: 10px 10px 0;\n  line-height: 140%;\n}\n.cancellation-fee span[data-v-0e3ba6dc] {\n    display: block;\n}\n.cancellation-fee label[data-v-0e3ba6dc] {\n    display: inline-block;\n    margin: 10px 20px 0;\n    cursor: pointer;\n}\n.cancellation-fee label input[data-v-0e3ba6dc] {\n      margin: 0 3px 0 0;\n      width: auto;\n      display: inline-block;\n      vertical-align: -1px;\n}\n.cancellation[data-v-0e3ba6dc] {\n  text-align: left;\n  padding: 20px;\n  padding-bottom: 5px;\n}\n.cancellation label[data-v-0e3ba6dc] {\n    display: table-cell;\n}\n.cancellation label[data-v-0e3ba6dc]:hover {\n      cursor: pointer;\n}\n.cancellation input[data-v-0e3ba6dc] {\n    width: auto !important;\n    display: inline-block;\n}\n.cancellation .reason-select[data-v-0e3ba6dc] {\n    padding: 0 17px;\n}\n.cancellation .reason[data-v-0e3ba6dc] {\n    margin-top: 5px;\n    display: block;\n}\n.partial-refund[data-v-0e3ba6dc] {\n  padding: 10px;\n  text-align: left;\n}\n.partial-refund label[data-v-0e3ba6dc] {\n    line-height: 1;\n}\n.refund-field[data-v-0e3ba6dc] {\n  line-height: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.refund-field select[data-v-0e3ba6dc] {\n    padding: 5px;\n    font-size: 15px;\n    height: 40px;\n    vertical-align: top;\n}\n.refund-field .refund-input[data-v-0e3ba6dc] {\n    vertical-align: top;\n    width: 0;\n    opacity: 0;\n    position: relative;\n    -webkit-transition: all .3s ease-in;\n    transition: all .3s ease-in;\n}\n.refund-field .refund-input i[data-v-0e3ba6dc] {\n      position: absolute;\n      z-index: 2;\n      top: 50%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      left: 5px;\n      color: #ccc;\n}\n.refund-field .refund-input input[data-v-0e3ba6dc] {\n      margin: 0;\n      height: 40px;\n      border-color: #999;\n      padding-left: 22px;\n      position: relative;\n      border-radius: 0 3px 3px 0;\n      z-index: 1;\n}\n.refund-field .refund-input input.has-error[data-v-0e3ba6dc] {\n        border-color: #ff6115;\n}\n.refund-field span.has-error[data-v-0e3ba6dc] {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    padding: 4px 5px;\n    background: #ff6115;\n    color: #fff;\n    font-size: 13px;\n    line-height: 1;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.refund-field.show-input select[data-v-0e3ba6dc] {\n    border-right: none;\n    border-radius: 3px 0 0 3px;\n}\n.refund-field.show-input .refund-input[data-v-0e3ba6dc] {\n    width: 140px;\n    opacity: 1;\n}\n.refund-fail[data-v-0e3ba6dc] {\n  padding: 20px;\n}\n.refund-fail i[data-v-0e3ba6dc] {\n    margin-bottom: 10px;\n}\n.refund-fail i.fa-exclamation-triangle[data-v-0e3ba6dc] {\n      color: #ffc800;\n}\n.refund-fail i.fa-thumbs-up[data-v-0e3ba6dc] {\n      color: #26d97a;\n}\n.refund-fail .message[data-v-0e3ba6dc] {\n    font-size: 15px;\n    margin-bottom: 20px;\n}\n.cancel-error[data-v-0e3ba6dc] {\n  background-color: red;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  text-align: center;\n  padding: 5px;\n}\n.select-error[data-v-0e3ba6dc] {\n  border: 2px solid red !important;\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(814);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("140537c4", content, true, {});

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.notes-custom-label {\n  padding: 15px;\n  font-size: 14px;\n}\n.notes-custom-label .text-left {\n    text-align: left;\n}\n.notes-custom-label .price-difference {\n    margin-top: 10px;\n}\n.notes-custom-label .price-difference span {\n      display: inline-block;\n      margin: 0 10px;\n      font-weight: 600;\n}\n.notes-custom-label .price-difference span.lower {\n        color: #F20D0D;\n}\n.notes-custom-label .price-difference span.higher {\n        color: #26D97A;\n}\n.slide-down-enter-active, .slide-down-leave-active {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter, .slide-down-leave-to {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.reservation-notes-modal.show .notes-modal {\n    height: 100vh;\n    overflow: scroll;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/App/ReservationNotesModal.vue"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,gBAAgB;CACjB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,iBAAiB;CACpB;AACD;MACM,sBAAsB;MACtB,eAAe;MACf,iBAAiB;CACtB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,eAAe;CACtB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;AACA;IACI,cAAc;IACd,iBAAiB;CACpB;CACA","file":"ReservationNotesModal.vue","sourcesContent":["\n.notes-custom-label {\n  padding: 15px;\n  font-size: 14px;\n}\n.notes-custom-label .text-left {\n    text-align: left;\n}\n.notes-custom-label .price-difference {\n    margin-top: 10px;\n}\n.notes-custom-label .price-difference span {\n      display: inline-block;\n      margin: 0 10px;\n      font-weight: 600;\n}\n.notes-custom-label .price-difference span.lower {\n        color: #F20D0D;\n}\n.notes-custom-label .price-difference span.higher {\n        color: #26D97A;\n}\n.slide-down-enter-active, .slide-down-leave-active {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter, .slide-down-leave-to {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.reservation-notes-modal.show .notes-modal {\n    height: 100vh;\n    overflow: scroll;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 229,
	"./af.js": 229,
	"./ar": 230,
	"./ar-dz": 231,
	"./ar-dz.js": 231,
	"./ar-kw": 232,
	"./ar-kw.js": 232,
	"./ar-ly": 233,
	"./ar-ly.js": 233,
	"./ar-ma": 234,
	"./ar-ma.js": 234,
	"./ar-sa": 235,
	"./ar-sa.js": 235,
	"./ar-tn": 236,
	"./ar-tn.js": 236,
	"./ar.js": 230,
	"./az": 237,
	"./az.js": 237,
	"./be": 238,
	"./be.js": 238,
	"./bg": 239,
	"./bg.js": 239,
	"./bm": 240,
	"./bm.js": 240,
	"./bn": 241,
	"./bn-bd": 242,
	"./bn-bd.js": 242,
	"./bn.js": 241,
	"./bo": 243,
	"./bo.js": 243,
	"./br": 244,
	"./br.js": 244,
	"./bs": 245,
	"./bs.js": 245,
	"./ca": 246,
	"./ca.js": 246,
	"./cs": 247,
	"./cs.js": 247,
	"./cv": 248,
	"./cv.js": 248,
	"./cy": 249,
	"./cy.js": 249,
	"./da": 250,
	"./da.js": 250,
	"./de": 251,
	"./de-at": 252,
	"./de-at.js": 252,
	"./de-ch": 253,
	"./de-ch.js": 253,
	"./de.js": 251,
	"./dv": 254,
	"./dv.js": 254,
	"./el": 255,
	"./el.js": 255,
	"./en-au": 256,
	"./en-au.js": 256,
	"./en-ca": 257,
	"./en-ca.js": 257,
	"./en-gb": 258,
	"./en-gb.js": 258,
	"./en-ie": 259,
	"./en-ie.js": 259,
	"./en-il": 260,
	"./en-il.js": 260,
	"./en-in": 261,
	"./en-in.js": 261,
	"./en-nz": 262,
	"./en-nz.js": 262,
	"./en-sg": 263,
	"./en-sg.js": 263,
	"./eo": 264,
	"./eo.js": 264,
	"./es": 265,
	"./es-do": 266,
	"./es-do.js": 266,
	"./es-mx": 267,
	"./es-mx.js": 267,
	"./es-us": 268,
	"./es-us.js": 268,
	"./es.js": 265,
	"./et": 269,
	"./et.js": 269,
	"./eu": 270,
	"./eu.js": 270,
	"./fa": 271,
	"./fa.js": 271,
	"./fi": 272,
	"./fi.js": 272,
	"./fil": 273,
	"./fil.js": 273,
	"./fo": 274,
	"./fo.js": 274,
	"./fr": 275,
	"./fr-ca": 276,
	"./fr-ca.js": 276,
	"./fr-ch": 277,
	"./fr-ch.js": 277,
	"./fr.js": 275,
	"./fy": 278,
	"./fy.js": 278,
	"./ga": 279,
	"./ga.js": 279,
	"./gd": 280,
	"./gd.js": 280,
	"./gl": 281,
	"./gl.js": 281,
	"./gom-deva": 282,
	"./gom-deva.js": 282,
	"./gom-latn": 283,
	"./gom-latn.js": 283,
	"./gu": 284,
	"./gu.js": 284,
	"./he": 285,
	"./he.js": 285,
	"./hi": 286,
	"./hi.js": 286,
	"./hr": 287,
	"./hr.js": 287,
	"./hu": 288,
	"./hu.js": 288,
	"./hy-am": 289,
	"./hy-am.js": 289,
	"./id": 290,
	"./id.js": 290,
	"./is": 291,
	"./is.js": 291,
	"./it": 292,
	"./it-ch": 293,
	"./it-ch.js": 293,
	"./it.js": 292,
	"./ja": 294,
	"./ja.js": 294,
	"./jv": 295,
	"./jv.js": 295,
	"./ka": 296,
	"./ka.js": 296,
	"./kk": 297,
	"./kk.js": 297,
	"./km": 298,
	"./km.js": 298,
	"./kn": 299,
	"./kn.js": 299,
	"./ko": 300,
	"./ko.js": 300,
	"./ku": 301,
	"./ku.js": 301,
	"./ky": 302,
	"./ky.js": 302,
	"./lb": 303,
	"./lb.js": 303,
	"./lo": 304,
	"./lo.js": 304,
	"./lt": 305,
	"./lt.js": 305,
	"./lv": 306,
	"./lv.js": 306,
	"./me": 307,
	"./me.js": 307,
	"./mi": 308,
	"./mi.js": 308,
	"./mk": 309,
	"./mk.js": 309,
	"./ml": 310,
	"./ml.js": 310,
	"./mn": 311,
	"./mn.js": 311,
	"./mr": 312,
	"./mr.js": 312,
	"./ms": 313,
	"./ms-my": 314,
	"./ms-my.js": 314,
	"./ms.js": 313,
	"./mt": 315,
	"./mt.js": 315,
	"./my": 316,
	"./my.js": 316,
	"./nb": 317,
	"./nb.js": 317,
	"./ne": 318,
	"./ne.js": 318,
	"./nl": 319,
	"./nl-be": 320,
	"./nl-be.js": 320,
	"./nl.js": 319,
	"./nn": 321,
	"./nn.js": 321,
	"./oc-lnc": 322,
	"./oc-lnc.js": 322,
	"./pa-in": 323,
	"./pa-in.js": 323,
	"./pl": 324,
	"./pl.js": 324,
	"./pt": 325,
	"./pt-br": 326,
	"./pt-br.js": 326,
	"./pt.js": 325,
	"./ro": 327,
	"./ro.js": 327,
	"./ru": 328,
	"./ru.js": 328,
	"./sd": 329,
	"./sd.js": 329,
	"./se": 330,
	"./se.js": 330,
	"./si": 331,
	"./si.js": 331,
	"./sk": 332,
	"./sk.js": 332,
	"./sl": 333,
	"./sl.js": 333,
	"./sq": 334,
	"./sq.js": 334,
	"./sr": 335,
	"./sr-cyrl": 336,
	"./sr-cyrl.js": 336,
	"./sr.js": 335,
	"./ss": 337,
	"./ss.js": 337,
	"./sv": 338,
	"./sv.js": 338,
	"./sw": 339,
	"./sw.js": 339,
	"./ta": 340,
	"./ta.js": 340,
	"./te": 341,
	"./te.js": 341,
	"./tet": 342,
	"./tet.js": 342,
	"./tg": 343,
	"./tg.js": 343,
	"./th": 344,
	"./th.js": 344,
	"./tk": 345,
	"./tk.js": 345,
	"./tl-ph": 346,
	"./tl-ph.js": 346,
	"./tlh": 347,
	"./tlh.js": 347,
	"./tr": 348,
	"./tr.js": 348,
	"./tzl": 349,
	"./tzl.js": 349,
	"./tzm": 350,
	"./tzm-latn": 351,
	"./tzm-latn.js": 351,
	"./tzm.js": 350,
	"./ug-cn": 352,
	"./ug-cn.js": 352,
	"./uk": 353,
	"./uk.js": 353,
	"./ur": 354,
	"./ur.js": 354,
	"./uz": 355,
	"./uz-latn": 356,
	"./uz-latn.js": 356,
	"./uz.js": 355,
	"./vi": 357,
	"./vi.js": 357,
	"./x-pseudo": 358,
	"./x-pseudo.js": 358,
	"./yo": 359,
	"./yo.js": 359,
	"./zh-cn": 360,
	"./zh-cn.js": 360,
	"./zh-hk": 361,
	"./zh-hk.js": 361,
	"./zh-mo": 362,
	"./zh-mo.js": 362,
	"./zh-tw": 363,
	"./zh-tw.js": 363
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 816;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(818);
module.exports = __webpack_require__(12).Object.keys;


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(65);
var $keys = __webpack_require__(64);

__webpack_require__(819)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(15);
var core = __webpack_require__(12);
var fails = __webpack_require__(53);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(821), __esModule: true };

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(56);
__webpack_require__(70);
module.exports = __webpack_require__(144).f('iterator');


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(823);
var step = __webpack_require__(364);
var Iterators = __webpack_require__(66);
var toIObject = __webpack_require__(55);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(122)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(825), __esModule: true };

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(826);
__webpack_require__(105);
__webpack_require__(830);
__webpack_require__(831);
module.exports = __webpack_require__(12).Symbol;


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(18);
var has = __webpack_require__(54);
var DESCRIPTORS = __webpack_require__(29);
var $export = __webpack_require__(15);
var redefine = __webpack_require__(170);
var META = __webpack_require__(145).KEY;
var $fails = __webpack_require__(53);
var shared = __webpack_require__(119);
var setToStringTag = __webpack_require__(82);
var uid = __webpack_require__(99);
var wks = __webpack_require__(19);
var wksExt = __webpack_require__(144);
var wksDefine = __webpack_require__(146);
var enumKeys = __webpack_require__(827);
var isArray = __webpack_require__(365);
var anObject = __webpack_require__(39);
var isObject = __webpack_require__(36);
var toObject = __webpack_require__(65);
var toIObject = __webpack_require__(55);
var toPrimitive = __webpack_require__(114);
var createDesc = __webpack_require__(77);
var _create = __webpack_require__(123);
var gOPNExt = __webpack_require__(828);
var $GOPD = __webpack_require__(829);
var $GOPS = __webpack_require__(121);
var $DP = __webpack_require__(33);
var $keys = __webpack_require__(64);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(366).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(80).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(79)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(44)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(64);
var gOPS = __webpack_require__(121);
var pIE = __webpack_require__(80);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(55);
var gOPN = __webpack_require__(366).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(80);
var createDesc = __webpack_require__(77);
var toIObject = __webpack_require__(55);
var toPrimitive = __webpack_require__(114);
var has = __webpack_require__(54);
var IE8_DOM_DEFINE = __webpack_require__(166);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(29) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(146)('asyncIterator');


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(146)('observable');


/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'reservation-notes-modal': true, show: _vm.show }},[_c('div',{staticClass:"reservation-notes-modal-container"},[_c('div',{staticClass:"reservation-notes-modal-content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showComplete && !_vm.refundModal.show),expression:"!showComplete && !refundModal.show"}],staticClass:"notes-modal"},[_c('div',{staticClass:"title"},[(_vm.actionData.title)?_c('span',[_vm._v(_vm._s(_vm.actionData.title))]):_c('span',[_vm._v(_vm._s(_vm.$t('rsvpNotes.title.regular')))])]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.cancelFeeLoading),expression:"cancelFeeLoading"}],staticClass:"fa fa-spinner fa-spin fa-fw fa-2x cancel-fee-loader"}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.cancelFeeLoading && _vm.cancellationFee > 0 && _vm.notesAction !== '' && !parseInt(_vm.isConvertCredit)),expression:"!cancelFeeLoading && cancellationFee > 0 && notesAction !== '' && !parseInt(isConvertCredit)"}],staticClass:"cancellation-fee"},[_c('span',[_vm._v("\n               The customer will have to pay a cancellaton fee of "),_c('b',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.cancellationFee)))]),_vm._v(".\n               Do you want to charge the cancellation fee?\n             ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cancelFee),expression:"cancelFee"}],attrs:{"type":"radio","name":"cancelFee","value":"1"},domProps:{"checked":_vm._q(_vm.cancelFee,"1")},on:{"change":function($event){_vm.cancelFee="1"}}}),_vm._v("\n               Yes\n             ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cancelFee),expression:"cancelFee"}],attrs:{"type":"radio","name":"cancelFee","value":"0"},domProps:{"checked":_vm._q(_vm.cancelFee,"0")},on:{"change":function($event){_vm.cancelFee="0"}}}),_vm._v("\n               No\n             ")])])]),_vm._v(" "),(_vm.notesData.isLyftService)?_c('div',{staticClass:"cancellation-fee"},[_vm._v("\n           The customer will have to pay a cancellation fee. "),_c('br'),_vm._v("\n           The final charge is set by Lyft.\n         ")]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.label),expression:"!!label"}],staticClass:"notes-custom-label",domProps:{"innerHTML":_vm._s(_vm.label)}}),_vm._v(" "),(_vm.isFullRefund && _vm.actionData.amount && parseFloat(_vm.actionData.amount) > 0)?_c('div',{staticClass:"full-refund"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('rsvpNotes.payCancellationFee', {amount: '$' + _vm.actionData.amount }))}}),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fullRefundCharge),expression:"fullRefundCharge"}],attrs:{"type":"radio","name":"fullRefund","value":"0"},domProps:{"checked":_vm._q(_vm.fullRefundCharge,"0")},on:{"change":function($event){_vm.fullRefundCharge="0"}}}),_vm._v("\n             "+_vm._s(_vm.$t('rsvpNotes.no'))+"\n           ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fullRefundCharge),expression:"fullRefundCharge"}],attrs:{"type":"radio","name":"fullRefund","value":"1"},domProps:{"checked":_vm._q(_vm.fullRefundCharge,"1")},on:{"change":function($event){_vm.fullRefundCharge="1"}}}),_vm._v("\n             "+_vm._s(_vm.$t('rsvpNotes.yes'))+"\n           ")])]):_vm._e(),_vm._v(" "),(_vm.isPartialRefund)?_c('div',{staticClass:"partial-refund"},[_c('label',[_vm._v(_vm._s(_vm.$t('rsvpNotes.refundType'))+":")]),_vm._v(" "),_c('div',{class:{'refund-field':true, 'show-input':_vm.refundType !== 'full'}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.refundType),expression:"refundType"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.refundType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changeRefundType]}},[_c('option',{attrs:{"value":"full","disabled":_vm.refundDisable.full}},[_vm._v(_vm._s(_vm.$t('rsvpNotes.fullRefund')))]),_vm._v(" "),_c('option',{attrs:{"value":"partial","disabled":_vm.refundDisable.partial}},[_vm._v(_vm._s(_vm.$t('rsvpNotes.partialRefund')))]),_vm._v(" "),_c('option',{attrs:{"value":"credit","disabled":_vm.refundDisable.credit}},[_vm._v(_vm._s(_vm.$t('rsvpNotes.issueCredit')))]),_vm._v(" "),_c('option',{attrs:{"value":"charge","disabled":_vm.refundDisable.charge}},[_vm._v(_vm._s(_vm.$t('rsvpNotes.additionalCharge')))])]),_vm._v(" "),_c('div',{staticClass:"refund-input"},[_c('i',{staticClass:"fas fa-dollar-sign fa-lg "}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.refundAmount),expression:"refundAmount"}],ref:"refundInput",class:{'has-error':!!_vm.refundAmountError},attrs:{"type":"number","step":"any"},domProps:{"value":(_vm.refundAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.refundAmount=$event.target.value}}})]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(!!_vm.refundAmountError)?_c('span',{staticClass:"has-error"},[_vm._v(_vm._s(_vm.refundAmountError))]):_vm._e()])],1)]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.notesAction === 'cancel'),expression:"notesAction === 'cancel'"}],staticClass:"cancel-reason"},[_c('label',[_vm._v("Passenger Reason for Cancellation:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cancellation.selectedReason),expression:"cancellation.selectedReason"}],class:{ 'select-error': _vm.cancellation.selectError },on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.cancellation, "selectedReason", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"-1"}},[_vm._v("Choose one")]),_vm._v(" "),_vm._l((_vm.cancellation.reasons),function(value,index){return _c('option',{domProps:{"value":index}},[_vm._v(_vm._s(value))])})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cancellation.selectError),expression:"cancellation.selectError"}],staticClass:"cancel-error"},[_vm._v("Please select a reason")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cancellation.selectedReason === 11),expression:"cancellation.selectedReason === 11"}]},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.cancellation.customReason),expression:"cancellation.customReason"}],class:{ error: _vm.cancellation.showError },domProps:{"value":(_vm.cancellation.customReason)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cancellation, "customReason", $event.target.value)}}}),_vm._v(" "),_c('div',{class:{ 'error-message': true, show: _vm.cancellation.showError }},[_vm._v("Please provide a reason")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.notesAction === 'convertCredit'),expression:"notesAction === 'convertCredit'"}],staticClass:"cancel-reason cancellation"},[_c('label',[_vm._v("Passenger wants to:")]),_vm._v(" "),_c('div',{staticClass:"optionRefund"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isConvertCredit),expression:"isConvertCredit"}],attrs:{"type":"radio","name":"isConvertCredit","value":"0"},domProps:{"checked":_vm._q(_vm.isConvertCredit,"0")},on:{"change":function($event){_vm.isConvertCredit="0"}}}),_vm._v("\n               Cancel Reservation\n             ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!parseInt(_vm.isConvertCredit)),expression:"!parseInt(isConvertCredit)"}],staticClass:"reason-select"},[_c('label',{staticClass:"reason"},[_vm._v("Passenger Reason for Cancellation:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cancellation.selectedReason),expression:"cancellation.selectedReason"}],class:{ 'select-error': _vm.cancellation.selectError },on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.cancellation, "selectedReason", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"-1"}},[_vm._v("Choose one")]),_vm._v(" "),_vm._l((_vm.cancellation.reasons),function(value,index){return _c('option',{domProps:{"value":index}},[_vm._v(_vm._s(value))])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cancellation.selectError),expression:"cancellation.selectError"}],staticClass:"cancel-error"},[_vm._v("Please select a reason")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cancellation.selectedReason === 11 && !parseInt(_vm.isConvertCredit)),expression:"cancellation.selectedReason === 11 && !parseInt(isConvertCredit)"}],staticClass:"reason-select"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.cancellation.customReason),expression:"cancellation.customReason"}],class:{ error: _vm.cancellation.showError },domProps:{"value":(_vm.cancellation.customReason)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cancellation, "customReason", $event.target.value)}}}),_vm._v(" "),_c('div',{class:{ 'error-message': true, show: _vm.cancellation.showError }},[_vm._v("Please provide a reason")])]),_vm._v(" "),(!_vm.notesData.isLyftService)?_c('div',{staticClass:"optionRefund"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isConvertCredit),expression:"isConvertCredit"}],attrs:{"type":"radio","name":"isConvertCredit","value":"1"},domProps:{"checked":_vm._q(_vm.isConvertCredit,"1")},on:{"change":function($event){_vm.isConvertCredit="1"}}}),_vm._v("\n               Convert to Ride Credits\n             ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"notes"},[_c('label',[_vm._v(_vm._s(_vm.$t('rsvpNotes.notes'))+":")]),_vm._v(" "),_c('div',{ref:"noteTextArea",class:['textarea', {error: _vm.noteError}],on:{"input":_vm.populate}}),_vm._v(" "),_c('div',{class:['error-message', {show: _vm.noteError}]},[_vm._v(_vm._s(_vm.$t('rsvpNotes.emptyNotes')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('rsvpNotes.charLeft', {value : 500 - _vm.notes.length})))])]),_vm._v(" "),_c('div',{staticClass:"status"},[_c('label',[_vm._v(_vm._s(_vm.$t('rsvpNotes.status'))+":")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.noteStatus),expression:"noteStatus"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.noteStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"new"}},[_vm._v(_vm._s(_vm.$t('rsvpNotes.new')))]),_vm._v(" "),_c('option',{attrs:{"value":"investigation"}},[_vm._v(_vm._s(_vm.$t('rsvpNotes.investigation')))]),_vm._v(" "),_c('option',{attrs:{"value":"resolved"}},[_vm._v(_vm._s(_vm.$t('rsvpNotes.resolved')))]),_vm._v(" "),(_vm.notesData.isProv)?_c('option',{attrs:{"value":"availability"}},[_vm._v("AVAILABILITY")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"controls row"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('a',{class:{'button cta warning block small':true, 'disabled':_vm.isSubmitting || _vm.cancelFeeLoading},attrs:{"href":"javascript:;"},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('rsvpNotes.cancel')))])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('a',{class:{ 'button cta success block small': true, disabled: _vm.isSubmitting || _vm.cancelFeeLoading},attrs:{"href":"javascript:;"},on:{"click":_vm.submit}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSubmitting),expression:"isSubmitting"}],staticClass:"fa fa-spinner fa-spin fa-fw"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSubmitting),expression:"!isSubmitting"}]},[_vm._v(_vm._s(_vm.$t('rsvpNotes.confirm')))])])])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showComplete),expression:"showComplete"}],staticClass:"success-modal"},[_c('i',{staticClass:"fas fa-check-circle fa-fw fa-3x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("\n           Success marked\n           "),(_vm.isPackage)?_c('span',[_vm._v("package")]):_c('span',[_vm._v("reservation")]),_vm._v("\n           as complete.\n         ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.refundModal.show),expression:"refundModal.show"}],staticClass:"refund-fail"},[(_vm.refundModal.status === 'error')?_c('i',{staticClass:"fas fa-exclamation-triangle fa-5x"}):_c('i',{staticClass:"far fa-thumbs-up fa-5x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.refundModal.message))]),_vm._v(" "),_c('a',{class:['button cta block small', _vm.refundModal.status === 'error' ? 'warning' : 'success'],on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('rsvpNotes.close')))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenu_vue__ = __webpack_require__(367);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c9ed310_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenu_vue__ = __webpack_require__(840);
function injectStyle (ssrContext) {
  __webpack_require__(834)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c9ed310"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c9ed310_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(835);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4e6470aa", content, true, {});

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "/*!\r\n * Hamburgers\r\n * @description Tasty CSS-animated hamburgers\r\n * @author Jonathan Suh @jonsuh\r\n * @site https://jonsuh.com/hamburgers\r\n * @link https://github.com/jonsuh/hamburgers\r\n */\n.hamburger[data-v-4c9ed310] {\n  font: inherit;\n  display: inline-block;\n  overflow: visible;\n  margin: 0;\n  padding: 15px;\n  cursor: pointer;\n  -webkit-transition-timing-function: linear;\n          transition-timing-function: linear;\n  -webkit-transition-duration: .15s;\n          transition-duration: .15s;\n  -webkit-transition-property: opacity,-webkit-filter;\n  transition-property: opacity,-webkit-filter;\n  transition-property: opacity,filter;\n  transition-property: opacity,filter,-webkit-filter;\n  text-transform: none;\n  color: inherit;\n  border: 0;\n  background-color: transparent;\n}\n.hamburger[data-v-4c9ed310]:hover {\n  opacity: .7;\n}\n.hamburger-box[data-v-4c9ed310] {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 24px;\n}\n.hamburger-inner[data-v-4c9ed310] {\n  top: 50%;\n  display: block;\n  margin-top: -2px;\n}\n.hamburger-inner[data-v-4c9ed310], .hamburger-inner[data-v-4c9ed310]:after, .hamburger-inner[data-v-4c9ed310]:before {\n  position: absolute;\n  width: 40px;\n  height: 4px;\n  -webkit-transition-timing-function: ease;\n          transition-timing-function: ease;\n  -webkit-transition-duration: .15s;\n          transition-duration: .15s;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  border-radius: 4px;\n  background-color: #000;\n}\n.hamburger-inner[data-v-4c9ed310]:after, .hamburger-inner[data-v-4c9ed310]:before {\n  display: block;\n  content: \"\";\n}\n.hamburger-inner[data-v-4c9ed310]:before {\n  top: -10px;\n}\n.hamburger-inner[data-v-4c9ed310]:after {\n  bottom: -10px;\n}\n.hamburger--3dx .hamburger-box[data-v-4c9ed310] {\n  -webkit-perspective: 80px;\n          perspective: 80px;\n}\n.hamburger--3dx .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.hamburger--3dx .hamburger-inner[data-v-4c9ed310]:after, .hamburger--3dx .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n}\n.hamburger--3dx.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: rotateY(180deg);\n          transform: rotateY(180deg);\n  background-color: transparent;\n}\n.hamburger--3dx.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: translate3d(0, 10px, 0) rotate(45deg);\n          transform: translate3d(0, 10px, 0) rotate(45deg);\n}\n.hamburger--3dx.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(0, -10px, 0) rotate(-45deg);\n          transform: translate3d(0, -10px, 0) rotate(-45deg);\n}\n.hamburger--3dx-r .hamburger-box[data-v-4c9ed310] {\n  -webkit-perspective: 80px;\n          perspective: 80px;\n}\n.hamburger--3dx-r .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.hamburger--3dx-r .hamburger-inner[data-v-4c9ed310]:after, .hamburger--3dx-r .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n}\n.hamburger--3dx-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: rotateY(-180deg);\n          transform: rotateY(-180deg);\n  background-color: transparent;\n}\n.hamburger--3dx-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: translate3d(0, 10px, 0) rotate(45deg);\n          transform: translate3d(0, 10px, 0) rotate(45deg);\n}\n.hamburger--3dx-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(0, -10px, 0) rotate(-45deg);\n          transform: translate3d(0, -10px, 0) rotate(-45deg);\n}\n.hamburger--3dy .hamburger-box[data-v-4c9ed310] {\n  -webkit-perspective: 80px;\n          perspective: 80px;\n}\n.hamburger--3dy .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.hamburger--3dy .hamburger-inner[data-v-4c9ed310]:after, .hamburger--3dy .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n}\n.hamburger--3dy.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: rotateX(-180deg);\n          transform: rotateX(-180deg);\n  background-color: transparent;\n}\n.hamburger--3dy.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: translate3d(0, 10px, 0) rotate(45deg);\n          transform: translate3d(0, 10px, 0) rotate(45deg);\n}\n.hamburger--3dy.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(0, -10px, 0) rotate(-45deg);\n          transform: translate3d(0, -10px, 0) rotate(-45deg);\n}\n.hamburger--3dy-r .hamburger-box[data-v-4c9ed310] {\n  -webkit-perspective: 80px;\n          perspective: 80px;\n}\n.hamburger--3dy-r .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.hamburger--3dy-r .hamburger-inner[data-v-4c9ed310]:after, .hamburger--3dy-r .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n}\n.hamburger--3dy-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: rotateX(180deg);\n          transform: rotateX(180deg);\n  background-color: transparent;\n}\n.hamburger--3dy-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: translate3d(0, 10px, 0) rotate(45deg);\n          transform: translate3d(0, 10px, 0) rotate(45deg);\n}\n.hamburger--3dy-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(0, -10px, 0) rotate(-45deg);\n          transform: translate3d(0, -10px, 0) rotate(-45deg);\n}\n.hamburger--3dxy .hamburger-box[data-v-4c9ed310] {\n  -webkit-perspective: 80px;\n          perspective: 80px;\n}\n.hamburger--3dxy .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.hamburger--3dxy .hamburger-inner[data-v-4c9ed310]:after, .hamburger--3dxy .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n}\n.hamburger--3dxy.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: rotateX(180deg) rotateY(180deg);\n          transform: rotateX(180deg) rotateY(180deg);\n  background-color: transparent;\n}\n.hamburger--3dxy.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: translate3d(0, 10px, 0) rotate(45deg);\n          transform: translate3d(0, 10px, 0) rotate(45deg);\n}\n.hamburger--3dxy.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(0, -10px, 0) rotate(-45deg);\n          transform: translate3d(0, -10px, 0) rotate(-45deg);\n}\n.hamburger--3dxy-r .hamburger-box[data-v-4c9ed310] {\n  -webkit-perspective: 80px;\n          perspective: 80px;\n}\n.hamburger--3dxy-r .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.hamburger--3dxy-r .hamburger-inner[data-v-4c9ed310]:after, .hamburger--3dxy-r .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n}\n.hamburger--3dxy-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: rotateX(180deg) rotateY(180deg) rotate(-180deg);\n          transform: rotateX(180deg) rotateY(180deg) rotate(-180deg);\n  background-color: transparent;\n}\n.hamburger--3dxy-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: translate3d(0, 10px, 0) rotate(45deg);\n          transform: translate3d(0, 10px, 0) rotate(45deg);\n}\n.hamburger--3dxy-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(0, -10px, 0) rotate(-45deg);\n          transform: translate3d(0, -10px, 0) rotate(-45deg);\n}\n.hamburger--arrow.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: translate3d(-8px, 0, 0) rotate(-45deg) scaleX(0.7);\n          transform: translate3d(-8px, 0, 0) rotate(-45deg) scaleX(0.7);\n}\n.hamburger--arrow.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(-8px, 0, 0) rotate(45deg) scaleX(0.7);\n          transform: translate3d(-8px, 0, 0) rotate(45deg) scaleX(0.7);\n}\n.hamburger--arrow-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: translate3d(8px, 0, 0) rotate(45deg) scaleX(0.7);\n          transform: translate3d(8px, 0, 0) rotate(45deg) scaleX(0.7);\n}\n.hamburger--arrow-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(8px, 0, 0) rotate(-45deg) scaleX(0.7);\n          transform: translate3d(8px, 0, 0) rotate(-45deg) scaleX(0.7);\n}\n.hamburger--arrowalt .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: top 0.1s ease 0.1s, -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: top 0.1s ease 0.1s, -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: top 0.1s ease 0.1s, transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: top 0.1s ease 0.1s, transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1), -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n.hamburger--arrowalt .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition: bottom 0.1s ease 0.1s, -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: bottom 0.1s ease 0.1s, -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: bottom 0.1s ease 0.1s, transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: bottom 0.1s ease 0.1s, transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1), -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n.hamburger--arrowalt.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top 0.1s ease, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: top 0.1s ease, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: top 0.1s ease, transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: top 0.1s ease, transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  -webkit-transform: translate3d(-8px, -10px, 0) rotate(-45deg) scaleX(0.7);\n          transform: translate3d(-8px, -10px, 0) rotate(-45deg) scaleX(0.7);\n}\n.hamburger--arrowalt.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n  -webkit-transition: bottom 0.1s ease, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: bottom 0.1s ease, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: bottom 0.1s ease, transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: bottom 0.1s ease, transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  -webkit-transform: translate3d(-8px, 10px, 0) rotate(45deg) scaleX(0.7);\n          transform: translate3d(-8px, 10px, 0) rotate(45deg) scaleX(0.7);\n}\n.hamburger--arrowalt-r .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: top 0.1s ease 0.1s, -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: top 0.1s ease 0.1s, -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: top 0.1s ease 0.1s, transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: top 0.1s ease 0.1s, transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1), -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n.hamburger--arrowalt-r .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition: bottom 0.1s ease 0.1s, -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: bottom 0.1s ease 0.1s, -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: bottom 0.1s ease 0.1s, transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: bottom 0.1s ease 0.1s, transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1), -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n.hamburger--arrowalt-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top 0.1s ease, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: top 0.1s ease, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: top 0.1s ease, transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: top 0.1s ease, transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  -webkit-transform: translate3d(8px, -10px, 0) rotate(45deg) scaleX(0.7);\n          transform: translate3d(8px, -10px, 0) rotate(45deg) scaleX(0.7);\n}\n.hamburger--arrowalt-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n  -webkit-transition: bottom 0.1s ease, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: bottom 0.1s ease, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: bottom 0.1s ease, transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: bottom 0.1s ease, transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  -webkit-transform: translate3d(8px, 10px, 0) rotate(-45deg) scaleX(0.7);\n          transform: translate3d(8px, 10px, 0) rotate(-45deg) scaleX(0.7);\n}\n.hamburger--arrowturn.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: rotate(-180deg);\n          transform: rotate(-180deg);\n}\n.hamburger--arrowturn.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: translate3d(8px, 0, 0) rotate(45deg) scaleX(0.7);\n          transform: translate3d(8px, 0, 0) rotate(45deg) scaleX(0.7);\n}\n.hamburger--arrowturn.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(8px, 0, 0) rotate(-45deg) scaleX(0.7);\n          transform: translate3d(8px, 0, 0) rotate(-45deg) scaleX(0.7);\n}\n.hamburger--arrowturn-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: rotate(-180deg);\n          transform: rotate(-180deg);\n}\n.hamburger--arrowturn-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: translate3d(-8px, 0, 0) rotate(-45deg) scaleX(0.7);\n          transform: translate3d(-8px, 0, 0) rotate(-45deg) scaleX(0.7);\n}\n.hamburger--arrowturn-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(-8px, 0, 0) rotate(45deg) scaleX(0.7);\n          transform: translate3d(-8px, 0, 0) rotate(45deg) scaleX(0.7);\n}\n.hamburger--boring .hamburger-inner[data-v-4c9ed310], .hamburger--boring .hamburger-inner[data-v-4c9ed310]:after, .hamburger--boring .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition-property: none;\n  transition-property: none;\n}\n.hamburger--boring.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n}\n.hamburger--boring.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  opacity: 0;\n}\n.hamburger--boring.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n  -webkit-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n}\n.hamburger--collapse .hamburger-inner[data-v-4c9ed310] {\n  top: auto;\n  bottom: 0;\n  -webkit-transition-delay: .13s;\n          transition-delay: .13s;\n  -webkit-transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n          transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  -webkit-transition-duration: .13s;\n          transition-duration: .13s;\n}\n.hamburger--collapse .hamburger-inner[data-v-4c9ed310]:after {\n  top: -20px;\n  -webkit-transition: top 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, opacity 0.1s linear;\n  transition: top 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, opacity 0.1s linear;\n}\n.hamburger--collapse .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: top 0.12s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.12s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.12s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.12s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19), -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n.hamburger--collapse.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: .22s;\n          transition-delay: .22s;\n  -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n          transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  -webkit-transform: translate3d(0, -10px, 0) rotate(-45deg);\n          transform: translate3d(0, -10px, 0) rotate(-45deg);\n}\n.hamburger--collapse.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  top: 0;\n  -webkit-transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0.1s linear 0.22s;\n  transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0.1s linear 0.22s;\n  opacity: 0;\n}\n.hamburger--collapse.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.16s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.25s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.16s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.25s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.16s, transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.25s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.16s, transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.25s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.25s;\n  -webkit-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n}\n.hamburger--collapse-r .hamburger-inner[data-v-4c9ed310] {\n  top: auto;\n  bottom: 0;\n  -webkit-transition-delay: .13s;\n          transition-delay: .13s;\n  -webkit-transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n          transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  -webkit-transition-duration: .13s;\n          transition-duration: .13s;\n}\n.hamburger--collapse-r .hamburger-inner[data-v-4c9ed310]:after {\n  top: -20px;\n  -webkit-transition: top 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, opacity 0.1s linear;\n  transition: top 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, opacity 0.1s linear;\n}\n.hamburger--collapse-r .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: top 0.12s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.12s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.12s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.12s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19), -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n.hamburger--collapse-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: .22s;\n          transition-delay: .22s;\n  -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n          transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  -webkit-transform: translate3d(0, -10px, 0) rotate(45deg);\n          transform: translate3d(0, -10px, 0) rotate(45deg);\n}\n.hamburger--collapse-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  top: 0;\n  -webkit-transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0.1s linear 0.22s;\n  transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0.1s linear 0.22s;\n  opacity: 0;\n}\n.hamburger--collapse-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.16s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.25s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.16s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.25s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.16s, transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.25s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.16s, transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.25s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.25s;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n.hamburger--elastic .hamburger-inner[data-v-4c9ed310] {\n  top: 2px;\n  -webkit-transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\n          transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  -webkit-transition-duration: .275s;\n          transition-duration: .275s;\n}\n.hamburger--elastic .hamburger-inner[data-v-4c9ed310]:before {\n  top: 10px;\n  -webkit-transition: opacity .125s ease .275s;\n  transition: opacity .125s ease .275s;\n}\n.hamburger--elastic .hamburger-inner[data-v-4c9ed310]:after {\n  top: 20px;\n  -webkit-transition: -webkit-transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  transition: -webkit-transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55), -webkit-transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n.hamburger--elastic.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: 75ms;\n          transition-delay: 75ms;\n  -webkit-transform: translate3d(0, 10px, 0) rotate(135deg);\n          transform: translate3d(0, 10px, 0) rotate(135deg);\n}\n.hamburger--elastic.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n  opacity: 0;\n}\n.hamburger--elastic.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition-delay: 75ms;\n          transition-delay: 75ms;\n  -webkit-transform: translate3d(0, -20px, 0) rotate(-270deg);\n          transform: translate3d(0, -20px, 0) rotate(-270deg);\n}\n.hamburger--elastic-r .hamburger-inner[data-v-4c9ed310] {\n  top: 2px;\n  -webkit-transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\n          transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  -webkit-transition-duration: .275s;\n          transition-duration: .275s;\n}\n.hamburger--elastic-r .hamburger-inner[data-v-4c9ed310]:before {\n  top: 10px;\n  -webkit-transition: opacity .125s ease .275s;\n  transition: opacity .125s ease .275s;\n}\n.hamburger--elastic-r .hamburger-inner[data-v-4c9ed310]:after {\n  top: 20px;\n  -webkit-transition: -webkit-transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  transition: -webkit-transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55), -webkit-transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n.hamburger--elastic-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: 75ms;\n          transition-delay: 75ms;\n  -webkit-transform: translate3d(0, 10px, 0) rotate(-135deg);\n          transform: translate3d(0, 10px, 0) rotate(-135deg);\n}\n.hamburger--elastic-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n  opacity: 0;\n}\n.hamburger--elastic-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition-delay: 75ms;\n          transition-delay: 75ms;\n  -webkit-transform: translate3d(0, -20px, 0) rotate(270deg);\n          transform: translate3d(0, -20px, 0) rotate(270deg);\n}\n.hamburger--emphatic[data-v-4c9ed310] {\n  overflow: hidden;\n}\n.hamburger--emphatic .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color .125s ease-in .175s;\n  transition: background-color .125s ease-in .175s;\n}\n.hamburger--emphatic .hamburger-inner[data-v-4c9ed310]:before {\n  left: 0;\n  -webkit-transition: top 0.05s linear 0.125s, left 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n  transition: top 0.05s linear 0.125s, left 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n  transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s linear 0.125s, left 0.125s ease-in 0.175s;\n  transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s linear 0.125s, left 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n}\n.hamburger--emphatic .hamburger-inner[data-v-4c9ed310]:after {\n  top: 10px;\n  right: 0;\n  -webkit-transition: top 0.05s linear 0.125s, right 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n  transition: top 0.05s linear 0.125s, right 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n  transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s linear 0.125s, right 0.125s ease-in 0.175s;\n  transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s linear 0.125s, right 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n}\n.hamburger--emphatic.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n  -webkit-transition-timing-function: ease-out;\n          transition-timing-function: ease-out;\n  background-color: transparent;\n}\n.hamburger--emphatic.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: -80px;\n  left: -80px;\n  -webkit-transition: left 0.125s ease-out, top 0.05s linear 0.125s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: left 0.125s ease-out, top 0.05s linear 0.125s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: left 0.125s ease-out, top 0.05s linear 0.125s, transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: left 0.125s ease-out, top 0.05s linear 0.125s, transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  -webkit-transform: translate3d(80px, 80px, 0) rotate(45deg);\n          transform: translate3d(80px, 80px, 0) rotate(45deg);\n}\n.hamburger--emphatic.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  top: -80px;\n  right: -80px;\n  -webkit-transition: right 0.125s ease-out, top 0.05s linear 0.125s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: right 0.125s ease-out, top 0.05s linear 0.125s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: right 0.125s ease-out, top 0.05s linear 0.125s, transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: right 0.125s ease-out, top 0.05s linear 0.125s, transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  -webkit-transform: translate3d(-80px, 80px, 0) rotate(-45deg);\n          transform: translate3d(-80px, 80px, 0) rotate(-45deg);\n}\n.hamburger--emphatic-r[data-v-4c9ed310] {\n  overflow: hidden;\n}\n.hamburger--emphatic-r .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color .125s ease-in .175s;\n  transition: background-color .125s ease-in .175s;\n}\n.hamburger--emphatic-r .hamburger-inner[data-v-4c9ed310]:before {\n  left: 0;\n  -webkit-transition: top 0.05s linear 0.125s, left 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n  transition: top 0.05s linear 0.125s, left 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n  transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s linear 0.125s, left 0.125s ease-in 0.175s;\n  transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s linear 0.125s, left 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n}\n.hamburger--emphatic-r .hamburger-inner[data-v-4c9ed310]:after {\n  top: 10px;\n  right: 0;\n  -webkit-transition: top 0.05s linear 0.125s, right 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n  transition: top 0.05s linear 0.125s, right 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n  transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s linear 0.125s, right 0.125s ease-in 0.175s;\n  transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s linear 0.125s, right 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n}\n.hamburger--emphatic-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n  -webkit-transition-timing-function: ease-out;\n          transition-timing-function: ease-out;\n  background-color: transparent;\n}\n.hamburger--emphatic-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 80px;\n  left: -80px;\n  -webkit-transition: left 0.125s ease-out, top 0.05s linear 0.125s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: left 0.125s ease-out, top 0.05s linear 0.125s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: left 0.125s ease-out, top 0.05s linear 0.125s, transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: left 0.125s ease-out, top 0.05s linear 0.125s, transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  -webkit-transform: translate3d(80px, -80px, 0) rotate(-45deg);\n          transform: translate3d(80px, -80px, 0) rotate(-45deg);\n}\n.hamburger--emphatic-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  top: 80px;\n  right: -80px;\n  -webkit-transition: right 0.125s ease-out, top 0.05s linear 0.125s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: right 0.125s ease-out, top 0.05s linear 0.125s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: right 0.125s ease-out, top 0.05s linear 0.125s, transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: right 0.125s ease-out, top 0.05s linear 0.125s, transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  -webkit-transform: translate3d(-80px, -80px, 0) rotate(45deg);\n          transform: translate3d(-80px, -80px, 0) rotate(45deg);\n}\n.hamburger--minus .hamburger-inner[data-v-4c9ed310]:after, .hamburger--minus .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: bottom .08s ease-out 0s,top .08s ease-out 0s,opacity 0s linear;\n  transition: bottom .08s ease-out 0s,top .08s ease-out 0s,opacity 0s linear;\n}\n.hamburger--minus.is-active .hamburger-inner[data-v-4c9ed310]:after, .hamburger--minus.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: bottom .08s ease-out,top .08s ease-out,opacity 0s linear .08s;\n  transition: bottom .08s ease-out,top .08s ease-out,opacity 0s linear .08s;\n  opacity: 0;\n}\n.hamburger--minus.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n}\n.hamburger--minus.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n}\n.hamburger--slider .hamburger-inner[data-v-4c9ed310] {\n  top: 2px;\n}\n.hamburger--slider .hamburger-inner[data-v-4c9ed310]:before {\n  top: 10px;\n  -webkit-transition-timing-function: ease;\n          transition-timing-function: ease;\n  -webkit-transition-duration: .15s;\n          transition-duration: .15s;\n  -webkit-transition-property: opacity,-webkit-transform;\n  transition-property: opacity,-webkit-transform;\n  transition-property: transform,opacity;\n  transition-property: transform,opacity,-webkit-transform;\n}\n.hamburger--slider .hamburger-inner[data-v-4c9ed310]:after {\n  top: 20px;\n}\n.hamburger--slider.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: translate3d(0, 10px, 0) rotate(45deg);\n          transform: translate3d(0, 10px, 0) rotate(45deg);\n}\n.hamburger--slider.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: rotate(-45deg) translate3d(-5.71429px, -6px, 0);\n          transform: rotate(-45deg) translate3d(-5.71429px, -6px, 0);\n  opacity: 0;\n}\n.hamburger--slider.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(0, -20px, 0) rotate(-90deg);\n          transform: translate3d(0, -20px, 0) rotate(-90deg);\n}\n.hamburger--slider-r .hamburger-inner[data-v-4c9ed310] {\n  top: 2px;\n}\n.hamburger--slider-r .hamburger-inner[data-v-4c9ed310]:before {\n  top: 10px;\n  -webkit-transition-timing-function: ease;\n          transition-timing-function: ease;\n  -webkit-transition-duration: .15s;\n          transition-duration: .15s;\n  -webkit-transition-property: opacity,-webkit-transform;\n  transition-property: opacity,-webkit-transform;\n  transition-property: transform,opacity;\n  transition-property: transform,opacity,-webkit-transform;\n}\n.hamburger--slider-r .hamburger-inner[data-v-4c9ed310]:after {\n  top: 20px;\n}\n.hamburger--slider-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: translate3d(0, 10px, 0) rotate(-45deg);\n          transform: translate3d(0, 10px, 0) rotate(-45deg);\n}\n.hamburger--slider-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: rotate(45deg) translate3d(5.71429px, -6px, 0);\n          transform: rotate(45deg) translate3d(5.71429px, -6px, 0);\n  opacity: 0;\n}\n.hamburger--slider-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(0, -20px, 0) rotate(90deg);\n          transform: translate3d(0, -20px, 0) rotate(90deg);\n}\n.hamburger--spin .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n          transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  -webkit-transition-duration: .22s;\n          transition-duration: .22s;\n}\n.hamburger--spin .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: top .1s ease-in .25s,opacity .1s ease-in;\n  transition: top .1s ease-in .25s,opacity .1s ease-in;\n}\n.hamburger--spin .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition: bottom 0.1s ease-in 0.25s, -webkit-transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: bottom 0.1s ease-in 0.25s, -webkit-transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19), -webkit-transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n.hamburger--spin.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: .12s;\n          transition-delay: .12s;\n  -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n          transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  -webkit-transform: rotate(225deg);\n          transform: rotate(225deg);\n}\n.hamburger--spin.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top .1s ease-out,opacity .1s ease-out .12s;\n  transition: top .1s ease-out,opacity .1s ease-out .12s;\n  opacity: 0;\n}\n.hamburger--spin.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n  -webkit-transition: bottom 0.1s ease-out, -webkit-transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  transition: bottom 0.1s ease-out, -webkit-transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  transition: bottom 0.1s ease-out, transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  transition: bottom 0.1s ease-out, transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s, -webkit-transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  -webkit-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n}\n.hamburger--spin-r .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n          transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  -webkit-transition-duration: .22s;\n          transition-duration: .22s;\n}\n.hamburger--spin-r .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: top .1s ease-in .25s,opacity .1s ease-in;\n  transition: top .1s ease-in .25s,opacity .1s ease-in;\n}\n.hamburger--spin-r .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition: bottom 0.1s ease-in 0.25s, -webkit-transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: bottom 0.1s ease-in 0.25s, -webkit-transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19), -webkit-transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n.hamburger--spin-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: .12s;\n          transition-delay: .12s;\n  -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n          transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  -webkit-transform: rotate(-225deg);\n          transform: rotate(-225deg);\n}\n.hamburger--spin-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top .1s ease-out,opacity .1s ease-out .12s;\n  transition: top .1s ease-out,opacity .1s ease-out .12s;\n  opacity: 0;\n}\n.hamburger--spin-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n  -webkit-transition: bottom 0.1s ease-out, -webkit-transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  transition: bottom 0.1s ease-out, -webkit-transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  transition: bottom 0.1s ease-out, transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  transition: bottom 0.1s ease-out, transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s, -webkit-transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n.hamburger--spring .hamburger-inner[data-v-4c9ed310] {\n  top: 2px;\n  -webkit-transition: background-color 0s linear .13s;\n  transition: background-color 0s linear .13s;\n}\n.hamburger--spring .hamburger-inner[data-v-4c9ed310]:before {\n  top: 10px;\n  -webkit-transition: top 0.1s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.1s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.1s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.1s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19), -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n.hamburger--spring .hamburger-inner[data-v-4c9ed310]:after {\n  top: 20px;\n  -webkit-transition: top 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19), -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n.hamburger--spring.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: .22s;\n          transition-delay: .22s;\n  background-color: transparent;\n}\n.hamburger--spring.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.15s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.15s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.15s, transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.15s, transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  -webkit-transform: translate3d(0, 10px, 0) rotate(45deg);\n          transform: translate3d(0, 10px, 0) rotate(45deg);\n}\n.hamburger--spring.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  top: 0;\n  -webkit-transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  -webkit-transform: translate3d(0, 10px, 0) rotate(-45deg);\n          transform: translate3d(0, 10px, 0) rotate(-45deg);\n}\n.hamburger--spring-r .hamburger-inner[data-v-4c9ed310] {\n  top: auto;\n  bottom: 0;\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n  -webkit-transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n          transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  -webkit-transition-duration: .13s;\n          transition-duration: .13s;\n}\n.hamburger--spring-r .hamburger-inner[data-v-4c9ed310]:after {\n  top: -20px;\n  -webkit-transition: top 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, opacity 0s linear;\n  transition: top 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, opacity 0s linear;\n}\n.hamburger--spring-r .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: top 0.1s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.1s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.1s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.1s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19), -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n.hamburger--spring-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: .22s;\n          transition-delay: .22s;\n  -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n          transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  -webkit-transform: translate3d(0, -10px, 0) rotate(-45deg);\n          transform: translate3d(0, -10px, 0) rotate(-45deg);\n}\n.hamburger--spring-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  top: 0;\n  -webkit-transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0s linear 0.22s;\n  transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0s linear 0.22s;\n  opacity: 0;\n}\n.hamburger--spring-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.15s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.15s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.15s, transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.15s, transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n.hamburger--stand .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color 0s linear 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.15s;\n  transition: background-color 0s linear 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.15s;\n  transition: transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.15s, background-color 0s linear 75ms;\n  transition: transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.15s, background-color 0s linear 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.15s;\n}\n.hamburger--stand .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: top 75ms ease-in 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: top 75ms ease-in 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: top 75ms ease-in 75ms, transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: top 75ms ease-in 75ms, transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n}\n.hamburger--stand .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition: bottom 75ms ease-in 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: bottom 75ms ease-in 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: bottom 75ms ease-in 75ms, transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: bottom 75ms ease-in 75ms, transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n}\n.hamburger--stand.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color 0s linear 0.15s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n  transition: background-color 0s linear 0.15s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n  transition: transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s, background-color 0s linear 0.15s;\n  transition: transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s, background-color 0s linear 0.15s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n  background-color: transparent;\n}\n.hamburger--stand.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top 75ms ease-out 0.1s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: top 75ms ease-out 0.1s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: top 75ms ease-out 0.1s, transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: top 75ms ease-out 0.1s, transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  -webkit-transform: rotate(-45deg);\n          transform: rotate(-45deg);\n}\n.hamburger--stand.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n  -webkit-transition: bottom 75ms ease-out 0.1s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: bottom 75ms ease-out 0.1s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: bottom 75ms ease-out 0.1s, transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: bottom 75ms ease-out 0.1s, transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n}\n.hamburger--stand-r .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color 0s linear 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.15s;\n  transition: background-color 0s linear 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.15s;\n  transition: transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.15s, background-color 0s linear 75ms;\n  transition: transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.15s, background-color 0s linear 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.15s;\n}\n.hamburger--stand-r .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: top 75ms ease-in 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: top 75ms ease-in 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: top 75ms ease-in 75ms, transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: top 75ms ease-in 75ms, transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n}\n.hamburger--stand-r .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition: bottom 75ms ease-in 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: bottom 75ms ease-in 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: bottom 75ms ease-in 75ms, transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: bottom 75ms ease-in 75ms, transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n}\n.hamburger--stand-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color 0s linear 0.15s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n  transition: background-color 0s linear 0.15s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n  transition: transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s, background-color 0s linear 0.15s;\n  transition: transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s, background-color 0s linear 0.15s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n  -webkit-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n  background-color: transparent;\n}\n.hamburger--stand-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top 75ms ease-out 0.1s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: top 75ms ease-out 0.1s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: top 75ms ease-out 0.1s, transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: top 75ms ease-out 0.1s, transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  -webkit-transform: rotate(-45deg);\n          transform: rotate(-45deg);\n}\n.hamburger--stand-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n  -webkit-transition: bottom 75ms ease-out 0.1s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: bottom 75ms ease-out 0.1s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: bottom 75ms ease-out 0.1s, transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: bottom 75ms ease-out 0.1s, transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n}\n.hamburger--squeeze .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n          transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  -webkit-transition-duration: 75ms;\n          transition-duration: 75ms;\n}\n.hamburger--squeeze .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: top 75ms ease .12s,opacity 75ms ease;\n  transition: top 75ms ease .12s,opacity 75ms ease;\n}\n.hamburger--squeeze .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition: bottom 75ms ease 0.12s, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: bottom 75ms ease 0.12s, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: bottom 75ms ease 0.12s, transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: bottom 75ms ease 0.12s, transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19), -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n.hamburger--squeeze.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: .12s;\n          transition-delay: .12s;\n  -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n          transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n}\n.hamburger--squeeze.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top 75ms ease,opacity 75ms ease .12s;\n  transition: top 75ms ease,opacity 75ms ease .12s;\n  opacity: 0;\n}\n.hamburger--squeeze.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n  -webkit-transition: bottom 75ms ease, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  transition: bottom 75ms ease, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  transition: bottom 75ms ease, transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  transition: bottom 75ms ease, transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  -webkit-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n}\n.hamburger--vortex .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\n          transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\n  -webkit-transition-duration: .2s;\n          transition-duration: .2s;\n}\n.hamburger--vortex .hamburger-inner[data-v-4c9ed310]:after, .hamburger--vortex .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition-delay: .1s;\n          transition-delay: .1s;\n  -webkit-transition-timing-function: linear;\n          transition-timing-function: linear;\n  -webkit-transition-duration: 0s;\n          transition-duration: 0s;\n}\n.hamburger--vortex .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition-property: top,opacity;\n  transition-property: top,opacity;\n}\n.hamburger--vortex .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition-property: bottom,-webkit-transform;\n  transition-property: bottom,-webkit-transform;\n  transition-property: bottom,transform;\n  transition-property: bottom,transform,-webkit-transform;\n}\n.hamburger--vortex.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\n          transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\n  -webkit-transform: rotate(765deg);\n          transform: rotate(765deg);\n}\n.hamburger--vortex.is-active .hamburger-inner[data-v-4c9ed310]:after, .hamburger--vortex.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n}\n.hamburger--vortex.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  opacity: 0;\n}\n.hamburger--vortex.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n.hamburger--vortex-r .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\n          transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\n  -webkit-transition-duration: .2s;\n          transition-duration: .2s;\n}\n.hamburger--vortex-r .hamburger-inner[data-v-4c9ed310]:after, .hamburger--vortex-r .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition-delay: .1s;\n          transition-delay: .1s;\n  -webkit-transition-timing-function: linear;\n          transition-timing-function: linear;\n  -webkit-transition-duration: 0s;\n          transition-duration: 0s;\n}\n.hamburger--vortex-r .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition-property: top,opacity;\n  transition-property: top,opacity;\n}\n.hamburger--vortex-r .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition-property: bottom,-webkit-transform;\n  transition-property: bottom,-webkit-transform;\n  transition-property: bottom,transform;\n  transition-property: bottom,transform,-webkit-transform;\n}\n.hamburger--vortex-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\n          transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\n  -webkit-transform: rotate(-765deg);\n          transform: rotate(-765deg);\n}\n.hamburger--vortex-r.is-active .hamburger-inner[data-v-4c9ed310]:after, .hamburger--vortex-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n}\n.hamburger--vortex-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  opacity: 0;\n}\n.hamburger--vortex-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n  -webkit-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n}\n.side-menu-cover[data-v-4c9ed310] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  -webkit-transition: all 300ms ease;\n  transition: all 300ms ease;\n  opacity: 1;\n}\n.side-menu-cover.hide[data-v-4c9ed310] {\n    top: -100%;\n    opacity: 0;\n}\n.side-menu[data-v-4c9ed310] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 11;\n  width: 250px;\n  height: 100%;\n  background-color: #2A2D33;\n  overflow: auto;\n  -webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.35);\n          box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.35);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.side-menu.hide[data-v-4c9ed310] {\n    left: -255px;\n}\n.side-menu .user img[data-v-4c9ed310] {\n    display: block;\n    width: 80px;\n    height: 80px;\n    margin: 20px auto 10px;\n    border-radius: 50%;\n}\n.side-menu .user .name[data-v-4c9ed310] {\n    text-align: center;\n    font-weight: 700;\n    font-size: 20px;\n    text-align: center;\n    padding: 0 15px;\n    color: #fff;\n}\n.side-menu .user .logout[data-v-4c9ed310] {\n    font-size: 14px;\n    color: #fff;\n    text-align: center;\n}\n.side-menu .user .logout a[data-v-4c9ed310] {\n      font-weight: 700;\n}\n.side-menu .search-toggle[data-v-4c9ed310] {\n    color: #fff;\n    padding: 10px 20px;\n    font-size: 14px;\n    text-align: center;\n    /* Hide default HTML checkbox */\n    /* The slider */\n}\n.side-menu .search-toggle span[data-v-4c9ed310] {\n      margin-right: 10px;\n}\n.side-menu .search-toggle .switch[data-v-4c9ed310] {\n      position: relative;\n      display: inline-block;\n      width: 50px;\n      height: 20px;\n      bottom: -2px;\n}\n.side-menu .search-toggle .switch input[data-v-4c9ed310] {\n      opacity: 0;\n      width: 0;\n      height: 0;\n}\n.side-menu .search-toggle .slider[data-v-4c9ed310] {\n      position: absolute;\n      cursor: pointer;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background-color: #ccc;\n      -webkit-transition: .4s;\n      transition: .4s;\n}\n.side-menu .search-toggle .slider[data-v-4c9ed310]:before {\n      position: absolute;\n      content: \"\";\n      height: 14px;\n      width: 14px;\n      left: 3px;\n      bottom: 3px;\n      background-color: white;\n      -webkit-transition: .4s;\n      transition: .4s;\n}\n.side-menu .search-toggle input:checked + .slider[data-v-4c9ed310] {\n      background-color: #2196F3;\n}\n.side-menu .search-toggle input:focus + .slider[data-v-4c9ed310] {\n      -webkit-box-shadow: 0 0 1px #2196F3;\n              box-shadow: 0 0 1px #2196F3;\n}\n.side-menu .search-toggle input:checked + .slider[data-v-4c9ed310]:before {\n      -webkit-transform: translateX(20px);\n      transform: translateX(20px);\n}\n.side-menu .search-toggle .slider.round[data-v-4c9ed310] {\n      border-radius: 34px;\n}\n.side-menu .search-toggle .slider.round[data-v-4c9ed310]:before {\n      border-radius: 50%;\n}\n.side-menu ul[data-v-4c9ed310] {\n    padding: 0;\n    margin: 0;\n    list-style-type: none;\n    display: block;\n}\n.side-menu ul li[data-v-4c9ed310] {\n      display: block;\n}\n.side-menu ul li a[data-v-4c9ed310] {\n        padding: 10px 20px;\n        display: block;\n        border-bottom: 1px solid #222;\n        border-top: 1px solid #444;\n        color: #eee;\n        text-decoration: none;\n}\n.hamburger[data-v-4c9ed310] {\n  width: 50px;\n  height: 50px;\n  position: fixed;\n  padding: 13px 14px;\n  z-index: 12;\n  top: 0;\n  left: 0;\n  background-color: #57D1B7;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n.hamburger.hide[data-v-4c9ed310] {\n    left: -50px;\n}\n.hamburger[data-v-4c9ed310]:hover {\n    opacity: 1;\n}\n.hamburger .hamburger-inner[data-v-4c9ed310],\n  .hamburger .hamburger-inner[data-v-4c9ed310]:after,\n  .hamburger .hamburger-inner[data-v-4c9ed310]:before {\n    background-color: #fff;\n    width: 20px;\n    height: 3px;\n}\n.hamburger .hamburger-inner[data-v-4c9ed310]:before {\n    top: -6px;\n}\n.hamburger .hamburger-inner[data-v-4c9ed310]:after {\n    bottom: -6px;\n}\n.hamburger.is-active[data-v-4c9ed310] {\n    background-color: #2A2D33;\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0);\n}\n.hamburger.need-notif-perm[data-v-4c9ed310]:before {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    webkit-box-shadow: inset 0 0 0 4px #ec6b24;\n    -webkit-box-shadow: inset 0 0 0 4px #ec6b24;\n            box-shadow: inset 0 0 0 4px #ec6b24;\n    opacity: 0;\n    -webkit-animation: border-pulsate-data-v-4c9ed310 1.2s linear infinite;\n            animation: border-pulsate-data-v-4c9ed310 1.2s linear infinite;\n}\na[data-v-4c9ed310] {\n  cursor: pointer;\n}\na.disabled[data-v-4c9ed310] {\n  pointer-events: none;\n  color: #ddd;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n@-webkit-keyframes border-pulsate-data-v-4c9ed310 {\n0%, 100% {\n    webkit-box-shadow: inset 0 0 0 0 #ec6b24;\n    -webkit-box-shadow: inset 0 0 0 0 #ec6b24;\n            box-shadow: inset 0 0 0 0 #ec6b24;\n    opacity: 0;\n}\n50% {\n    webkit-box-shadow: inset 0 0 0 4px #ec6b24;\n    -webkit-box-shadow: inset 0 0 0 4px #ec6b24;\n            box-shadow: inset 0 0 0 4px #ec6b24;\n    opacity: 1;\n}\n}\n@keyframes border-pulsate-data-v-4c9ed310 {\n0%, 100% {\n    webkit-box-shadow: inset 0 0 0 0 #ec6b24;\n    -webkit-box-shadow: inset 0 0 0 0 #ec6b24;\n            box-shadow: inset 0 0 0 0 #ec6b24;\n    opacity: 0;\n}\n50% {\n    webkit-box-shadow: inset 0 0 0 4px #ec6b24;\n    -webkit-box-shadow: inset 0 0 0 4px #ec6b24;\n            box-shadow: inset 0 0 0 4px #ec6b24;\n    opacity: 1;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/App/SideMenu.vue"],"names":[],"mappings":"AAAA;;;;;;GAMG;AACH;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,2CAA2C;UACnC,mCAAmC;EAC3C,kCAAkC;UAC1B,0BAA0B;EAClC,oDAAoD;EACpD,4CAA4C;EAC5C,oCAAoC;EACpC,mDAAmD;EACnD,qBAAqB;EACrB,eAAe;EACf,UAAU;EACV,8BAA8B;CAC/B;AACD;EACE,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,aAAa;CACd;AACD;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;CAClB;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,yCAAyC;UACjC,iCAAiC;EACzC,kCAAkC;UAC1B,0BAA0B;EAClC,+CAA+C;EAC/C,uCAAuC;EACvC,+BAA+B;EAC/B,kDAAkD;EAClD,mBAAmB;EACnB,uBAAuB;CACxB;AACD;EACE,eAAe;EACf,YAAY;CACb;AACD;EACE,WAAW;CACZ;AACD;EACE,cAAc;CACf;AACD;EACE,0BAA0B;UAClB,kBAAkB;CAC3B;AACD;EACE,gJAAgJ;EAChJ,wIAAwI;EACxI,gIAAgI;EAChI,8LAA8L;CAC/L;AACD;EACE,mFAAmF;EACnF,2EAA2E;EAC3E,mEAAmE;EACnE,mIAAmI;CACpI;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,8BAA8B;CAC/B;AACD;EACE,yDAAyD;UACjD,iDAAiD;CAC1D;AACD;EACE,2DAA2D;UACnD,mDAAmD;CAC5D;AACD;EACE,0BAA0B;UAClB,kBAAkB;CAC3B;AACD;EACE,gJAAgJ;EAChJ,wIAAwI;EACxI,gIAAgI;EAChI,8LAA8L;CAC/L;AACD;EACE,mFAAmF;EACnF,2EAA2E;EAC3E,mEAAmE;EACnE,mIAAmI;CACpI;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,8BAA8B;CAC/B;AACD;EACE,yDAAyD;UACjD,iDAAiD;CAC1D;AACD;EACE,2DAA2D;UACnD,mDAAmD;CAC5D;AACD;EACE,0BAA0B;UAClB,kBAAkB;CAC3B;AACD;EACE,gJAAgJ;EAChJ,wIAAwI;EACxI,gIAAgI;EAChI,8LAA8L;CAC/L;AACD;EACE,mFAAmF;EACnF,2EAA2E;EAC3E,mEAAmE;EACnE,mIAAmI;CACpI;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,8BAA8B;CAC/B;AACD;EACE,yDAAyD;UACjD,iDAAiD;CAC1D;AACD;EACE,2DAA2D;UACnD,mDAAmD;CAC5D;AACD;EACE,0BAA0B;UAClB,kBAAkB;CAC3B;AACD;EACE,gJAAgJ;EAChJ,wIAAwI;EACxI,gIAAgI;EAChI,8LAA8L;CAC/L;AACD;EACE,mFAAmF;EACnF,2EAA2E;EAC3E,mEAAmE;EACnE,mIAAmI;CACpI;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,8BAA8B;CAC/B;AACD;EACE,yDAAyD;UACjD,iDAAiD;CAC1D;AACD;EACE,2DAA2D;UACnD,mDAAmD;CAC5D;AACD;EACE,0BAA0B;UAClB,kBAAkB;CAC3B;AACD;EACE,gJAAgJ;EAChJ,wIAAwI;EACxI,gIAAgI;EAChI,8LAA8L;CAC/L;AACD;EACE,mFAAmF;EACnF,2EAA2E;EAC3E,mEAAmE;EACnE,mIAAmI;CACpI;AACD;EACE,mDAAmD;UAC3C,2CAA2C;EACnD,8BAA8B;CAC/B;AACD;EACE,yDAAyD;UACjD,iDAAiD;CAC1D;AACD;EACE,2DAA2D;UACnD,mDAAmD;CAC5D;AACD;EACE,0BAA0B;UAClB,kBAAkB;CAC3B;AACD;EACE,gJAAgJ;EAChJ,wIAAwI;EACxI,gIAAgI;EAChI,8LAA8L;CAC/L;AACD;EACE,mFAAmF;EACnF,2EAA2E;EAC3E,mEAAmE;EACnE,mIAAmI;CACpI;AACD;EACE,mEAAmE;UAC3D,2DAA2D;EACnE,8BAA8B;CAC/B;AACD;EACE,yDAAyD;UACjD,iDAAiD;CAC1D;AACD;EACE,2DAA2D;UACnD,mDAAmD;CAC5D;AACD;EACE,sEAAsE;UAC9D,8DAA8D;CACvE;AACD;EACE,qEAAqE;UAC7D,6DAA6D;CACtE;AACD;EACE,oEAAoE;UAC5D,4DAA4D;CACrE;AACD;EACE,qEAAqE;UAC7D,6DAA6D;CACtE;AACD;EACE,kGAAkG;EAClG,0FAA0F;EAC1F,kFAAkF;EAClF,6IAA6I;CAC9I;AACD;EACE,qGAAqG;EACrG,6FAA6F;EAC7F,qFAAqF;EACrF,gJAAgJ;CACjJ;AACD;EACE,OAAO;EACP,sGAAsG;EACtG,8FAA8F;EAC9F,sFAAsF;EACtF,0JAA0J;EAC1J,0EAA0E;UAClE,kEAAkE;CAC3E;AACD;EACE,UAAU;EACV,yGAAyG;EACzG,iGAAiG;EACjG,yFAAyF;EACzF,6JAA6J;EAC7J,wEAAwE;UAChE,gEAAgE;CACzE;AACD;EACE,kGAAkG;EAClG,0FAA0F;EAC1F,kFAAkF;EAClF,6IAA6I;CAC9I;AACD;EACE,qGAAqG;EACrG,6FAA6F;EAC7F,qFAAqF;EACrF,gJAAgJ;CACjJ;AACD;EACE,OAAO;EACP,sGAAsG;EACtG,8FAA8F;EAC9F,sFAAsF;EACtF,0JAA0J;EAC1J,wEAAwE;UAChE,gEAAgE;CACzE;AACD;EACE,UAAU;EACV,yGAAyG;EACzG,iGAAiG;EACjG,yFAAyF;EACzF,6JAA6J;EAC7J,wEAAwE;UAChE,gEAAgE;CACzE;AACD;EACE,mCAAmC;UAC3B,2BAA2B;CACpC;AACD;EACE,oEAAoE;UAC5D,4DAA4D;CACrE;AACD;EACE,qEAAqE;UAC7D,6DAA6D;CACtE;AACD;EACE,mCAAmC;UAC3B,2BAA2B;CACpC;AACD;EACE,sEAAsE;UAC9D,8DAA8D;CACvE;AACD;EACE,qEAAqE;UAC7D,6DAA6D;CACtE;AACD;EACE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,iCAAiC;UACzB,yBAAyB;CAClC;AACD;EACE,OAAO;EACP,WAAW;CACZ;AACD;EACE,UAAU;EACV,kCAAkC;UAC1B,0BAA0B;CACnC;AACD;EACE,UAAU;EACV,UAAU;EACV,+BAA+B;UACvB,uBAAuB;EAC/B,2EAA2E;UACnE,mEAAmE;EAC3E,kCAAkC;UAC1B,0BAA0B;CACnC;AACD;EACE,WAAW;EACX,kGAAkG;EAClG,0FAA0F;CAC3F;AACD;EACE,8IAA8I;EAC9I,sIAAsI;EACtI,8HAA8H;EAC9H,8LAA8L;CAC/L;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,wEAAwE;UAChE,gEAAgE;EACxE,2DAA2D;UACnD,mDAAmD;CAC5D;AACD;EACE,OAAO;EACP,mGAAmG;EACnG,2FAA2F;EAC3F,WAAW;CACZ;AACD;EACE,OAAO;EACP,iJAAiJ;EACjJ,yIAAyI;EACzI,iIAAiI;EACjI,oMAAoM;EACpM,kCAAkC;UAC1B,0BAA0B;CACnC;AACD;EACE,UAAU;EACV,UAAU;EACV,+BAA+B;UACvB,uBAAuB;EAC/B,2EAA2E;UACnE,mEAAmE;EAC3E,kCAAkC;UAC1B,0BAA0B;CACnC;AACD;EACE,WAAW;EACX,kGAAkG;EAClG,0FAA0F;CAC3F;AACD;EACE,8IAA8I;EAC9I,sIAAsI;EACtI,8HAA8H;EAC9H,8LAA8L;CAC/L;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,wEAAwE;UAChE,gEAAgE;EACxE,0DAA0D;UAClD,kDAAkD;CAC3D;AACD;EACE,OAAO;EACP,mGAAmG;EACnG,2FAA2F;EAC3F,WAAW;CACZ;AACD;EACE,OAAO;EACP,iJAAiJ;EACjJ,yIAAyI;EACzI,iIAAiI;EACjI,oMAAoM;EACpM,iCAAiC;UACzB,yBAAyB;CAClC;AACD;EACE,SAAS;EACT,2EAA2E;UACnE,mEAAmE;EAC3E,mCAAmC;UAC3B,2BAA2B;CACpC;AACD;EACE,UAAU;EACV,6CAA6C;EAC7C,qCAAqC;CACtC;AACD;EACE,UAAU;EACV,oFAAoF;EACpF,4EAA4E;EAC5E,oEAAoE;EACpE,qIAAqI;CACtI;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,0DAA0D;UAClD,kDAAkD;CAC3D;AACD;EACE,6BAA6B;UACrB,qBAAqB;EAC7B,WAAW;CACZ;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,4DAA4D;UACpD,oDAAoD;CAC7D;AACD;EACE,SAAS;EACT,2EAA2E;UACnE,mEAAmE;EAC3E,mCAAmC;UAC3B,2BAA2B;CACpC;AACD;EACE,UAAU;EACV,6CAA6C;EAC7C,qCAAqC;CACtC;AACD;EACE,UAAU;EACV,oFAAoF;EACpF,4EAA4E;EAC5E,oEAAoE;EACpE,qIAAqI;CACtI;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,2DAA2D;UACnD,mDAAmD;CAC5D;AACD;EACE,6BAA6B;UACrB,qBAAqB;EAC7B,WAAW;CACZ;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,2DAA2D;UACnD,mDAAmD;CAC5D;AACD;EACE,iBAAiB;CAClB;AACD;EACE,yDAAyD;EACzD,iDAAiD;CAClD;AACD;EACE,QAAQ;EACR,uIAAuI;EACvI,+HAA+H;EAC/H,uHAAuH;EACvH,sLAAsL;CACvL;AACD;EACE,UAAU;EACV,SAAS;EACT,wIAAwI;EACxI,gIAAgI;EAChI,wHAAwH;EACxH,uLAAuL;CACxL;AACD;EACE,6BAA6B;UACrB,qBAAqB;EAC7B,6CAA6C;UACrC,qCAAqC;EAC7C,8BAA8B;CAC/B;AACD;EACE,WAAW;EACX,YAAY;EACZ,uIAAuI;EACvI,+HAA+H;EAC/H,uHAAuH;EACvH,4LAA4L;EAC5L,4DAA4D;UACpD,oDAAoD;CAC7D;AACD;EACE,WAAW;EACX,aAAa;EACb,wIAAwI;EACxI,gIAAgI;EAChI,wHAAwH;EACxH,6LAA6L;EAC7L,8DAA8D;UACtD,sDAAsD;CAC/D;AACD;EACE,iBAAiB;CAClB;AACD;EACE,yDAAyD;EACzD,iDAAiD;CAClD;AACD;EACE,QAAQ;EACR,uIAAuI;EACvI,+HAA+H;EAC/H,uHAAuH;EACvH,sLAAsL;CACvL;AACD;EACE,UAAU;EACV,SAAS;EACT,wIAAwI;EACxI,gIAAgI;EAChI,wHAAwH;EACxH,uLAAuL;CACxL;AACD;EACE,6BAA6B;UACrB,qBAAqB;EAC7B,6CAA6C;UACrC,qCAAqC;EAC7C,8BAA8B;CAC/B;AACD;EACE,UAAU;EACV,YAAY;EACZ,uIAAuI;EACvI,+HAA+H;EAC/H,uHAAuH;EACvH,4LAA4L;EAC5L,8DAA8D;UACtD,sDAAsD;CAC/D;AACD;EACE,UAAU;EACV,aAAa;EACb,wIAAwI;EACxI,gIAAgI;EAChI,wHAAwH;EACxH,6LAA6L;EAC7L,8DAA8D;UACtD,sDAAsD;CAC/D;AACD;EACE,mFAAmF;EACnF,2EAA2E;CAC5E;AACD;EACE,kFAAkF;EAClF,0EAA0E;EAC1E,WAAW;CACZ;AACD;EACE,OAAO;CACR;AACD;EACE,UAAU;CACX;AACD;EACE,SAAS;CACV;AACD;EACE,UAAU;EACV,yCAAyC;UACjC,iCAAiC;EACzC,kCAAkC;UAC1B,0BAA0B;EAClC,uDAAuD;EACvD,+CAA+C;EAC/C,uCAAuC;EACvC,yDAAyD;CAC1D;AACD;EACE,UAAU;CACX;AACD;EACE,yDAAyD;UACjD,iDAAiD;CAC1D;AACD;EACE,mEAAmE;UAC3D,2DAA2D;EACnE,WAAW;CACZ;AACD;EACE,2DAA2D;UACnD,mDAAmD;CAC5D;AACD;EACE,SAAS;CACV;AACD;EACE,UAAU;EACV,yCAAyC;UACjC,iCAAiC;EACzC,kCAAkC;UAC1B,0BAA0B;EAClC,uDAAuD;EACvD,+CAA+C;EAC/C,uCAAuC;EACvC,yDAAyD;CAC1D;AACD;EACE,UAAU;CACX;AACD;EACE,0DAA0D;UAClD,kDAAkD;CAC3D;AACD;EACE,iEAAiE;UACzD,yDAAyD;EACjE,WAAW;CACZ;AACD;EACE,0DAA0D;UAClD,kDAAkD;CAC3D;AACD;EACE,2EAA2E;UACnE,mEAAmE;EAC3E,kCAAkC;UAC1B,0BAA0B;CACnC;AACD;EACE,6DAA6D;EAC7D,qDAAqD;CACtD;AACD;EACE,8GAA8G;EAC9G,sGAAsG;EACtG,8FAA8F;EAC9F,8JAA8J;CAC/J;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,wEAAwE;UAChE,gEAAgE;EACxE,kCAAkC;UAC1B,0BAA0B;CACnC;AACD;EACE,OAAO;EACP,+DAA+D;EAC/D,uDAAuD;EACvD,WAAW;CACZ;AACD;EACE,UAAU;EACV,4GAA4G;EAC5G,oGAAoG;EACpG,4FAA4F;EAC5F,+JAA+J;EAC/J,kCAAkC;UAC1B,0BAA0B;CACnC;AACD;EACE,2EAA2E;UACnE,mEAAmE;EAC3E,kCAAkC;UAC1B,0BAA0B;CACnC;AACD;EACE,6DAA6D;EAC7D,qDAAqD;CACtD;AACD;EACE,8GAA8G;EAC9G,sGAAsG;EACtG,8FAA8F;EAC9F,8JAA8J;CAC/J;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,wEAAwE;UAChE,gEAAgE;EACxE,mCAAmC;UAC3B,2BAA2B;CACpC;AACD;EACE,OAAO;EACP,+DAA+D;EAC/D,uDAAuD;EACvD,WAAW;CACZ;AACD;EACE,UAAU;EACV,4GAA4G;EAC5G,oGAAoG;EACpG,4FAA4F;EAC5F,+JAA+J;EAC/J,iCAAiC;UACzB,yBAAyB;CAClC;AACD;EACE,SAAS;EACT,oDAAoD;EACpD,4CAA4C;CAC7C;AACD;EACE,UAAU;EACV,6IAA6I;EAC7I,qIAAqI;EACrI,6HAA6H;EAC7H,6LAA6L;CAC9L;AACD;EACE,UAAU;EACV,6IAA6I;EAC7I,qIAAqI;EACrI,6HAA6H;EAC7H,6LAA6L;CAC9L;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,8BAA8B;CAC/B;AACD;EACE,OAAO;EACP,iJAAiJ;EACjJ,yIAAyI;EACzI,iIAAiI;EACjI,oMAAoM;EACpM,yDAAyD;UACjD,iDAAiD;CAC1D;AACD;EACE,OAAO;EACP,2IAA2I;EAC3I,mIAAmI;EACnI,2HAA2H;EAC3H,8LAA8L;EAC9L,0DAA0D;UAClD,kDAAkD;CAC3D;AACD;EACE,UAAU;EACV,UAAU;EACV,6BAA6B;UACrB,qBAAqB;EAC7B,2EAA2E;UACnE,mEAAmE;EAC3E,kCAAkC;UAC1B,0BAA0B;CACnC;AACD;EACE,WAAW;EACX,gGAAgG;EAChG,wFAAwF;CACzF;AACD;EACE,6IAA6I;EAC7I,qIAAqI;EACrI,6HAA6H;EAC7H,6LAA6L;CAC9L;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,wEAAwE;UAChE,gEAAgE;EACxE,2DAA2D;UACnD,mDAAmD;CAC5D;AACD;EACE,OAAO;EACP,iGAAiG;EACjG,yFAAyF;EACzF,WAAW;CACZ;AACD;EACE,OAAO;EACP,iJAAiJ;EACjJ,yIAAyI;EACzI,iIAAiI;EACjI,oMAAoM;EACpM,iCAAiC;UACzB,yBAAyB;CAClC;AACD;EACE,yHAAyH;EACzH,iHAAiH;EACjH,yGAAyG;EACzG,8KAA8K;CAC/K;AACD;EACE,4GAA4G;EAC5G,oGAAoG;EACpG,4FAA4F;EAC5F,8JAA8J;CAC/J;AACD;EACE,+GAA+G;EAC/G,uGAAuG;EACvG,+FAA+F;EAC/F,iKAAiK;CAClK;AACD;EACE,oHAAoH;EACpH,4GAA4G;EAC5G,oGAAoG;EACpG,mKAAmK;EACnK,iCAAiC;UACzB,yBAAyB;EACjC,8BAA8B;CAC/B;AACD;EACE,OAAO;EACP,6GAA6G;EAC7G,qGAAqG;EACrG,6FAA6F;EAC7F,+JAA+J;EAC/J,kCAAkC;UAC1B,0BAA0B;CACnC;AACD;EACE,UAAU;EACV,gHAAgH;EAChH,wGAAwG;EACxG,gGAAgG;EAChG,kKAAkK;EAClK,iCAAiC;UACzB,yBAAyB;CAClC;AACD;EACE,yHAAyH;EACzH,iHAAiH;EACjH,yGAAyG;EACzG,8KAA8K;CAC/K;AACD;EACE,4GAA4G;EAC5G,oGAAoG;EACpG,4FAA4F;EAC5F,8JAA8J;CAC/J;AACD;EACE,+GAA+G;EAC/G,uGAAuG;EACvG,+FAA+F;EAC/F,iKAAiK;CAClK;AACD;EACE,oHAAoH;EACpH,4GAA4G;EAC5G,oGAAoG;EACpG,mKAAmK;EACnK,kCAAkC;UAC1B,0BAA0B;EAClC,8BAA8B;CAC/B;AACD;EACE,OAAO;EACP,6GAA6G;EAC7G,qGAAqG;EACrG,6FAA6F;EAC7F,+JAA+J;EAC/J,kCAAkC;UAC1B,0BAA0B;CACnC;AACD;EACE,UAAU;EACV,gHAAgH;EAChH,wGAAwG;EACxG,gGAAgG;EAChG,kKAAkK;EAClK,iCAAiC;UACzB,yBAAyB;CAClC;AACD;EACE,2EAA2E;UACnE,mEAAmE;EAC3E,kCAAkC;UAC1B,0BAA0B;CACnC;AACD;EACE,yDAAyD;EACzD,iDAAiD;CAClD;AACD;EACE,0GAA0G;EAC1G,kGAAkG;EAClG,0FAA0F;EAC1F,yJAAyJ;CAC1J;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,wEAAwE;UAChE,gEAAgE;EACxE,iCAAiC;UACzB,yBAAyB;CAClC;AACD;EACE,OAAO;EACP,yDAAyD;EACzD,iDAAiD;EACjD,WAAW;CACZ;AACD;EACE,UAAU;EACV,uGAAuG;EACvG,+FAA+F;EAC/F,uFAAuF;EACvF,yJAAyJ;EACzJ,kCAAkC;UAC1B,0BAA0B;CACnC;AACD;EACE,mEAAmE;UAC3D,2DAA2D;EACnE,iCAAiC;UACzB,yBAAyB;CAClC;AACD;EACE,8BAA8B;UACtB,sBAAsB;EAC9B,2CAA2C;UACnC,mCAAmC;EAC3C,gCAAgC;UACxB,wBAAwB;CACjC;AACD;EACE,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,sDAAsD;EACtD,8CAA8C;EAC9C,sCAAsC;EACtC,wDAAwD;CACzD;AACD;EACE,mEAAmE;UAC3D,2DAA2D;EACnE,kCAAkC;UAC1B,0BAA0B;CACnC;AACD;EACE,6BAA6B;UACrB,qBAAqB;CAC9B;AACD;EACE,OAAO;EACP,WAAW;CACZ;AACD;EACE,UAAU;EACV,iCAAiC;UACzB,yBAAyB;CAClC;AACD;EACE,mEAAmE;UAC3D,2DAA2D;EACnE,iCAAiC;UACzB,yBAAyB;CAClC;AACD;EACE,8BAA8B;UACtB,sBAAsB;EAC9B,2CAA2C;UACnC,mCAAmC;EAC3C,gCAAgC;UACxB,wBAAwB;CACjC;AACD;EACE,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,sDAAsD;EACtD,8CAA8C;EAC9C,sCAAsC;EACtC,wDAAwD;CACzD;AACD;EACE,mEAAmE;UAC3D,2DAA2D;EACnE,mCAAmC;UAC3B,2BAA2B;CACpC;AACD;EACE,6BAA6B;UACrB,qBAAqB;CAC9B;AACD;EACE,OAAO;EACP,WAAW;CACZ;AACD;EACE,UAAU;EACV,kCAAkC;UAC1B,0BAA0B;CACnC;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,mCAAmC;EACnC,2BAA2B;EAC3B,WAAW;CACZ;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,eAAe;EACf,oDAAoD;UAC5C,4CAA4C;EACpD,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,aAAa;CAChB;AACD;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;CACtB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;CACf;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;CACtB;AACD;MACM,iBAAiB;CACtB;AACD;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;CACnB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,mBAAmB;MACnB,sBAAsB;MACtB,YAAY;MACZ,aAAa;MACb,aAAa;CAClB;AACD;MACM,WAAW;MACX,SAAS;MACT,UAAU;CACf;AACD;MACM,mBAAmB;MACnB,gBAAgB;MAChB,OAAO;MACP,QAAQ;MACR,SAAS;MACT,UAAU;MACV,uBAAuB;MACvB,wBAAwB;MACxB,gBAAgB;CACrB;AACD;MACM,mBAAmB;MACnB,YAAY;MACZ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,YAAY;MACZ,wBAAwB;MACxB,wBAAwB;MACxB,gBAAgB;CACrB;AACD;MACM,0BAA0B;CAC/B;AACD;MACM,oCAAoC;cAC5B,4BAA4B;CACzC;AACD;MACM,oCAAoC;MACpC,4BAA4B;CACjC;AACD;MACM,oBAAoB;CACzB;AACD;MACM,mBAAmB;CACxB;AACD;IACI,WAAW;IACX,UAAU;IACV,sBAAsB;IACtB,eAAe;CAClB;AACD;MACM,eAAe;CACpB;AACD;QACQ,mBAAmB;QACnB,eAAe;QACf,8BAA8B;QAC9B,2BAA2B;QAC3B,YAAY;QACZ,sBAAsB;CAC7B;AACD;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,0BAA0B;EAC1B,8BAA8B;EAC9B,sBAAsB;EACtB,kDAAkD;UAC1C,0CAA0C;CACnD;AACD;IACI,YAAY;CACf;AACD;IACI,WAAW;CACd;AACD;;;IAGI,uBAAuB;IACvB,YAAY;IACZ,YAAY;CACf;AACD;IACI,UAAU;CACb;AACD;IACI,aAAa;CAChB;AACD;IACI,0BAA0B;IAC1B,+CAA+C;YACvC,uCAAuC;CAClD;AACD;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,2CAA2C;IAC3C,4CAA4C;YACpC,oCAAoC;IAC5C,WAAW;IACX,uEAAuE;YAC/D,+DAA+D;CAC1E;AACD;EACE,gBAAgB;CACjB;AACD;EACE,qBAAqB;EACrB,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;AACA;IACI,yCAAyC;IACzC,0CAA0C;YAClC,kCAAkC;IAC1C,WAAW;CACd;AACD;IACI,2CAA2C;IAC3C,4CAA4C;YACpC,oCAAoC;IAC5C,WAAW;CACd;CACA;AACD;AACA;IACI,yCAAyC;IACzC,0CAA0C;YAClC,kCAAkC;IAC1C,WAAW;CACd;AACD;IACI,2CAA2C;IAC3C,4CAA4C;YACpC,oCAAoC;IAC5C,WAAW;CACd;CACA","file":"SideMenu.vue","sourcesContent":["/*!\r\n * Hamburgers\r\n * @description Tasty CSS-animated hamburgers\r\n * @author Jonathan Suh @jonsuh\r\n * @site https://jonsuh.com/hamburgers\r\n * @link https://github.com/jonsuh/hamburgers\r\n */\n.hamburger[data-v-4c9ed310] {\n  font: inherit;\n  display: inline-block;\n  overflow: visible;\n  margin: 0;\n  padding: 15px;\n  cursor: pointer;\n  -webkit-transition-timing-function: linear;\n          transition-timing-function: linear;\n  -webkit-transition-duration: .15s;\n          transition-duration: .15s;\n  -webkit-transition-property: opacity,-webkit-filter;\n  transition-property: opacity,-webkit-filter;\n  transition-property: opacity,filter;\n  transition-property: opacity,filter,-webkit-filter;\n  text-transform: none;\n  color: inherit;\n  border: 0;\n  background-color: transparent;\n}\n.hamburger[data-v-4c9ed310]:hover {\n  opacity: .7;\n}\n.hamburger-box[data-v-4c9ed310] {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 24px;\n}\n.hamburger-inner[data-v-4c9ed310] {\n  top: 50%;\n  display: block;\n  margin-top: -2px;\n}\n.hamburger-inner[data-v-4c9ed310], .hamburger-inner[data-v-4c9ed310]:after, .hamburger-inner[data-v-4c9ed310]:before {\n  position: absolute;\n  width: 40px;\n  height: 4px;\n  -webkit-transition-timing-function: ease;\n          transition-timing-function: ease;\n  -webkit-transition-duration: .15s;\n          transition-duration: .15s;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  border-radius: 4px;\n  background-color: #000;\n}\n.hamburger-inner[data-v-4c9ed310]:after, .hamburger-inner[data-v-4c9ed310]:before {\n  display: block;\n  content: \"\";\n}\n.hamburger-inner[data-v-4c9ed310]:before {\n  top: -10px;\n}\n.hamburger-inner[data-v-4c9ed310]:after {\n  bottom: -10px;\n}\n.hamburger--3dx .hamburger-box[data-v-4c9ed310] {\n  -webkit-perspective: 80px;\n          perspective: 80px;\n}\n.hamburger--3dx .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.hamburger--3dx .hamburger-inner[data-v-4c9ed310]:after, .hamburger--3dx .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n}\n.hamburger--3dx.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: rotateY(180deg);\n          transform: rotateY(180deg);\n  background-color: transparent;\n}\n.hamburger--3dx.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: translate3d(0, 10px, 0) rotate(45deg);\n          transform: translate3d(0, 10px, 0) rotate(45deg);\n}\n.hamburger--3dx.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(0, -10px, 0) rotate(-45deg);\n          transform: translate3d(0, -10px, 0) rotate(-45deg);\n}\n.hamburger--3dx-r .hamburger-box[data-v-4c9ed310] {\n  -webkit-perspective: 80px;\n          perspective: 80px;\n}\n.hamburger--3dx-r .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.hamburger--3dx-r .hamburger-inner[data-v-4c9ed310]:after, .hamburger--3dx-r .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n}\n.hamburger--3dx-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: rotateY(-180deg);\n          transform: rotateY(-180deg);\n  background-color: transparent;\n}\n.hamburger--3dx-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: translate3d(0, 10px, 0) rotate(45deg);\n          transform: translate3d(0, 10px, 0) rotate(45deg);\n}\n.hamburger--3dx-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(0, -10px, 0) rotate(-45deg);\n          transform: translate3d(0, -10px, 0) rotate(-45deg);\n}\n.hamburger--3dy .hamburger-box[data-v-4c9ed310] {\n  -webkit-perspective: 80px;\n          perspective: 80px;\n}\n.hamburger--3dy .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.hamburger--3dy .hamburger-inner[data-v-4c9ed310]:after, .hamburger--3dy .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n}\n.hamburger--3dy.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: rotateX(-180deg);\n          transform: rotateX(-180deg);\n  background-color: transparent;\n}\n.hamburger--3dy.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: translate3d(0, 10px, 0) rotate(45deg);\n          transform: translate3d(0, 10px, 0) rotate(45deg);\n}\n.hamburger--3dy.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(0, -10px, 0) rotate(-45deg);\n          transform: translate3d(0, -10px, 0) rotate(-45deg);\n}\n.hamburger--3dy-r .hamburger-box[data-v-4c9ed310] {\n  -webkit-perspective: 80px;\n          perspective: 80px;\n}\n.hamburger--3dy-r .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.hamburger--3dy-r .hamburger-inner[data-v-4c9ed310]:after, .hamburger--3dy-r .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n}\n.hamburger--3dy-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: rotateX(180deg);\n          transform: rotateX(180deg);\n  background-color: transparent;\n}\n.hamburger--3dy-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: translate3d(0, 10px, 0) rotate(45deg);\n          transform: translate3d(0, 10px, 0) rotate(45deg);\n}\n.hamburger--3dy-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(0, -10px, 0) rotate(-45deg);\n          transform: translate3d(0, -10px, 0) rotate(-45deg);\n}\n.hamburger--3dxy .hamburger-box[data-v-4c9ed310] {\n  -webkit-perspective: 80px;\n          perspective: 80px;\n}\n.hamburger--3dxy .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.hamburger--3dxy .hamburger-inner[data-v-4c9ed310]:after, .hamburger--3dxy .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n}\n.hamburger--3dxy.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: rotateX(180deg) rotateY(180deg);\n          transform: rotateX(180deg) rotateY(180deg);\n  background-color: transparent;\n}\n.hamburger--3dxy.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: translate3d(0, 10px, 0) rotate(45deg);\n          transform: translate3d(0, 10px, 0) rotate(45deg);\n}\n.hamburger--3dxy.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(0, -10px, 0) rotate(-45deg);\n          transform: translate3d(0, -10px, 0) rotate(-45deg);\n}\n.hamburger--3dxy-r .hamburger-box[data-v-4c9ed310] {\n  -webkit-perspective: 80px;\n          perspective: 80px;\n}\n.hamburger--3dxy-r .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.hamburger--3dxy-r .hamburger-inner[data-v-4c9ed310]:after, .hamburger--3dxy-r .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n  transition: transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s, -webkit-transform 0s cubic-bezier(0.645, 0.045, 0.355, 1) 0.1s;\n}\n.hamburger--3dxy-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: rotateX(180deg) rotateY(180deg) rotate(-180deg);\n          transform: rotateX(180deg) rotateY(180deg) rotate(-180deg);\n  background-color: transparent;\n}\n.hamburger--3dxy-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: translate3d(0, 10px, 0) rotate(45deg);\n          transform: translate3d(0, 10px, 0) rotate(45deg);\n}\n.hamburger--3dxy-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(0, -10px, 0) rotate(-45deg);\n          transform: translate3d(0, -10px, 0) rotate(-45deg);\n}\n.hamburger--arrow.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: translate3d(-8px, 0, 0) rotate(-45deg) scaleX(0.7);\n          transform: translate3d(-8px, 0, 0) rotate(-45deg) scaleX(0.7);\n}\n.hamburger--arrow.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(-8px, 0, 0) rotate(45deg) scaleX(0.7);\n          transform: translate3d(-8px, 0, 0) rotate(45deg) scaleX(0.7);\n}\n.hamburger--arrow-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: translate3d(8px, 0, 0) rotate(45deg) scaleX(0.7);\n          transform: translate3d(8px, 0, 0) rotate(45deg) scaleX(0.7);\n}\n.hamburger--arrow-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(8px, 0, 0) rotate(-45deg) scaleX(0.7);\n          transform: translate3d(8px, 0, 0) rotate(-45deg) scaleX(0.7);\n}\n.hamburger--arrowalt .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: top 0.1s ease 0.1s, -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: top 0.1s ease 0.1s, -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: top 0.1s ease 0.1s, transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: top 0.1s ease 0.1s, transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1), -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n.hamburger--arrowalt .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition: bottom 0.1s ease 0.1s, -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: bottom 0.1s ease 0.1s, -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: bottom 0.1s ease 0.1s, transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: bottom 0.1s ease 0.1s, transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1), -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n.hamburger--arrowalt.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top 0.1s ease, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: top 0.1s ease, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: top 0.1s ease, transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: top 0.1s ease, transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  -webkit-transform: translate3d(-8px, -10px, 0) rotate(-45deg) scaleX(0.7);\n          transform: translate3d(-8px, -10px, 0) rotate(-45deg) scaleX(0.7);\n}\n.hamburger--arrowalt.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n  -webkit-transition: bottom 0.1s ease, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: bottom 0.1s ease, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: bottom 0.1s ease, transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: bottom 0.1s ease, transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  -webkit-transform: translate3d(-8px, 10px, 0) rotate(45deg) scaleX(0.7);\n          transform: translate3d(-8px, 10px, 0) rotate(45deg) scaleX(0.7);\n}\n.hamburger--arrowalt-r .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: top 0.1s ease 0.1s, -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: top 0.1s ease 0.1s, -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: top 0.1s ease 0.1s, transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: top 0.1s ease 0.1s, transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1), -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n.hamburger--arrowalt-r .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition: bottom 0.1s ease 0.1s, -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: bottom 0.1s ease 0.1s, -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: bottom 0.1s ease 0.1s, transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n  transition: bottom 0.1s ease 0.1s, transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1), -webkit-transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n.hamburger--arrowalt-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top 0.1s ease, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: top 0.1s ease, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: top 0.1s ease, transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: top 0.1s ease, transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  -webkit-transform: translate3d(8px, -10px, 0) rotate(45deg) scaleX(0.7);\n          transform: translate3d(8px, -10px, 0) rotate(45deg) scaleX(0.7);\n}\n.hamburger--arrowalt-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n  -webkit-transition: bottom 0.1s ease, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: bottom 0.1s ease, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: bottom 0.1s ease, transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  transition: bottom 0.1s ease, transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s, -webkit-transform 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.1s;\n  -webkit-transform: translate3d(8px, 10px, 0) rotate(-45deg) scaleX(0.7);\n          transform: translate3d(8px, 10px, 0) rotate(-45deg) scaleX(0.7);\n}\n.hamburger--arrowturn.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: rotate(-180deg);\n          transform: rotate(-180deg);\n}\n.hamburger--arrowturn.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: translate3d(8px, 0, 0) rotate(45deg) scaleX(0.7);\n          transform: translate3d(8px, 0, 0) rotate(45deg) scaleX(0.7);\n}\n.hamburger--arrowturn.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(8px, 0, 0) rotate(-45deg) scaleX(0.7);\n          transform: translate3d(8px, 0, 0) rotate(-45deg) scaleX(0.7);\n}\n.hamburger--arrowturn-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: rotate(-180deg);\n          transform: rotate(-180deg);\n}\n.hamburger--arrowturn-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: translate3d(-8px, 0, 0) rotate(-45deg) scaleX(0.7);\n          transform: translate3d(-8px, 0, 0) rotate(-45deg) scaleX(0.7);\n}\n.hamburger--arrowturn-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(-8px, 0, 0) rotate(45deg) scaleX(0.7);\n          transform: translate3d(-8px, 0, 0) rotate(45deg) scaleX(0.7);\n}\n.hamburger--boring .hamburger-inner[data-v-4c9ed310], .hamburger--boring .hamburger-inner[data-v-4c9ed310]:after, .hamburger--boring .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition-property: none;\n  transition-property: none;\n}\n.hamburger--boring.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n}\n.hamburger--boring.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  opacity: 0;\n}\n.hamburger--boring.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n  -webkit-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n}\n.hamburger--collapse .hamburger-inner[data-v-4c9ed310] {\n  top: auto;\n  bottom: 0;\n  -webkit-transition-delay: .13s;\n          transition-delay: .13s;\n  -webkit-transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n          transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  -webkit-transition-duration: .13s;\n          transition-duration: .13s;\n}\n.hamburger--collapse .hamburger-inner[data-v-4c9ed310]:after {\n  top: -20px;\n  -webkit-transition: top 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, opacity 0.1s linear;\n  transition: top 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, opacity 0.1s linear;\n}\n.hamburger--collapse .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: top 0.12s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.12s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.12s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.12s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19), -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n.hamburger--collapse.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: .22s;\n          transition-delay: .22s;\n  -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n          transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  -webkit-transform: translate3d(0, -10px, 0) rotate(-45deg);\n          transform: translate3d(0, -10px, 0) rotate(-45deg);\n}\n.hamburger--collapse.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  top: 0;\n  -webkit-transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0.1s linear 0.22s;\n  transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0.1s linear 0.22s;\n  opacity: 0;\n}\n.hamburger--collapse.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.16s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.25s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.16s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.25s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.16s, transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.25s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.16s, transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.25s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.25s;\n  -webkit-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n}\n.hamburger--collapse-r .hamburger-inner[data-v-4c9ed310] {\n  top: auto;\n  bottom: 0;\n  -webkit-transition-delay: .13s;\n          transition-delay: .13s;\n  -webkit-transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n          transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  -webkit-transition-duration: .13s;\n          transition-duration: .13s;\n}\n.hamburger--collapse-r .hamburger-inner[data-v-4c9ed310]:after {\n  top: -20px;\n  -webkit-transition: top 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, opacity 0.1s linear;\n  transition: top 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, opacity 0.1s linear;\n}\n.hamburger--collapse-r .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: top 0.12s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.12s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.12s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.12s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19), -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n.hamburger--collapse-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: .22s;\n          transition-delay: .22s;\n  -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n          transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  -webkit-transform: translate3d(0, -10px, 0) rotate(45deg);\n          transform: translate3d(0, -10px, 0) rotate(45deg);\n}\n.hamburger--collapse-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  top: 0;\n  -webkit-transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0.1s linear 0.22s;\n  transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0.1s linear 0.22s;\n  opacity: 0;\n}\n.hamburger--collapse-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.16s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.25s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.16s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.25s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.16s, transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.25s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.16s, transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.25s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.25s;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n.hamburger--elastic .hamburger-inner[data-v-4c9ed310] {\n  top: 2px;\n  -webkit-transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\n          transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  -webkit-transition-duration: .275s;\n          transition-duration: .275s;\n}\n.hamburger--elastic .hamburger-inner[data-v-4c9ed310]:before {\n  top: 10px;\n  -webkit-transition: opacity .125s ease .275s;\n  transition: opacity .125s ease .275s;\n}\n.hamburger--elastic .hamburger-inner[data-v-4c9ed310]:after {\n  top: 20px;\n  -webkit-transition: -webkit-transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  transition: -webkit-transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55), -webkit-transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n.hamburger--elastic.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: 75ms;\n          transition-delay: 75ms;\n  -webkit-transform: translate3d(0, 10px, 0) rotate(135deg);\n          transform: translate3d(0, 10px, 0) rotate(135deg);\n}\n.hamburger--elastic.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n  opacity: 0;\n}\n.hamburger--elastic.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition-delay: 75ms;\n          transition-delay: 75ms;\n  -webkit-transform: translate3d(0, -20px, 0) rotate(-270deg);\n          transform: translate3d(0, -20px, 0) rotate(-270deg);\n}\n.hamburger--elastic-r .hamburger-inner[data-v-4c9ed310] {\n  top: 2px;\n  -webkit-transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\n          transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  -webkit-transition-duration: .275s;\n          transition-duration: .275s;\n}\n.hamburger--elastic-r .hamburger-inner[data-v-4c9ed310]:before {\n  top: 10px;\n  -webkit-transition: opacity .125s ease .275s;\n  transition: opacity .125s ease .275s;\n}\n.hamburger--elastic-r .hamburger-inner[data-v-4c9ed310]:after {\n  top: 20px;\n  -webkit-transition: -webkit-transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  transition: -webkit-transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55), -webkit-transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n.hamburger--elastic-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: 75ms;\n          transition-delay: 75ms;\n  -webkit-transform: translate3d(0, 10px, 0) rotate(-135deg);\n          transform: translate3d(0, 10px, 0) rotate(-135deg);\n}\n.hamburger--elastic-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n  opacity: 0;\n}\n.hamburger--elastic-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition-delay: 75ms;\n          transition-delay: 75ms;\n  -webkit-transform: translate3d(0, -20px, 0) rotate(270deg);\n          transform: translate3d(0, -20px, 0) rotate(270deg);\n}\n.hamburger--emphatic[data-v-4c9ed310] {\n  overflow: hidden;\n}\n.hamburger--emphatic .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color .125s ease-in .175s;\n  transition: background-color .125s ease-in .175s;\n}\n.hamburger--emphatic .hamburger-inner[data-v-4c9ed310]:before {\n  left: 0;\n  -webkit-transition: top 0.05s linear 0.125s, left 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n  transition: top 0.05s linear 0.125s, left 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n  transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s linear 0.125s, left 0.125s ease-in 0.175s;\n  transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s linear 0.125s, left 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n}\n.hamburger--emphatic .hamburger-inner[data-v-4c9ed310]:after {\n  top: 10px;\n  right: 0;\n  -webkit-transition: top 0.05s linear 0.125s, right 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n  transition: top 0.05s linear 0.125s, right 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n  transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s linear 0.125s, right 0.125s ease-in 0.175s;\n  transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s linear 0.125s, right 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n}\n.hamburger--emphatic.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n  -webkit-transition-timing-function: ease-out;\n          transition-timing-function: ease-out;\n  background-color: transparent;\n}\n.hamburger--emphatic.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: -80px;\n  left: -80px;\n  -webkit-transition: left 0.125s ease-out, top 0.05s linear 0.125s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: left 0.125s ease-out, top 0.05s linear 0.125s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: left 0.125s ease-out, top 0.05s linear 0.125s, transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: left 0.125s ease-out, top 0.05s linear 0.125s, transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  -webkit-transform: translate3d(80px, 80px, 0) rotate(45deg);\n          transform: translate3d(80px, 80px, 0) rotate(45deg);\n}\n.hamburger--emphatic.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  top: -80px;\n  right: -80px;\n  -webkit-transition: right 0.125s ease-out, top 0.05s linear 0.125s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: right 0.125s ease-out, top 0.05s linear 0.125s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: right 0.125s ease-out, top 0.05s linear 0.125s, transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: right 0.125s ease-out, top 0.05s linear 0.125s, transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  -webkit-transform: translate3d(-80px, 80px, 0) rotate(-45deg);\n          transform: translate3d(-80px, 80px, 0) rotate(-45deg);\n}\n.hamburger--emphatic-r[data-v-4c9ed310] {\n  overflow: hidden;\n}\n.hamburger--emphatic-r .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color .125s ease-in .175s;\n  transition: background-color .125s ease-in .175s;\n}\n.hamburger--emphatic-r .hamburger-inner[data-v-4c9ed310]:before {\n  left: 0;\n  -webkit-transition: top 0.05s linear 0.125s, left 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n  transition: top 0.05s linear 0.125s, left 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n  transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s linear 0.125s, left 0.125s ease-in 0.175s;\n  transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s linear 0.125s, left 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n}\n.hamburger--emphatic-r .hamburger-inner[data-v-4c9ed310]:after {\n  top: 10px;\n  right: 0;\n  -webkit-transition: top 0.05s linear 0.125s, right 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n  transition: top 0.05s linear 0.125s, right 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n  transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s linear 0.125s, right 0.125s ease-in 0.175s;\n  transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s linear 0.125s, right 0.125s ease-in 0.175s, -webkit-transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335);\n}\n.hamburger--emphatic-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n  -webkit-transition-timing-function: ease-out;\n          transition-timing-function: ease-out;\n  background-color: transparent;\n}\n.hamburger--emphatic-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 80px;\n  left: -80px;\n  -webkit-transition: left 0.125s ease-out, top 0.05s linear 0.125s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: left 0.125s ease-out, top 0.05s linear 0.125s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: left 0.125s ease-out, top 0.05s linear 0.125s, transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: left 0.125s ease-out, top 0.05s linear 0.125s, transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  -webkit-transform: translate3d(80px, -80px, 0) rotate(-45deg);\n          transform: translate3d(80px, -80px, 0) rotate(-45deg);\n}\n.hamburger--emphatic-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  top: 80px;\n  right: -80px;\n  -webkit-transition: right 0.125s ease-out, top 0.05s linear 0.125s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: right 0.125s ease-out, top 0.05s linear 0.125s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: right 0.125s ease-out, top 0.05s linear 0.125s, transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  transition: right 0.125s ease-out, top 0.05s linear 0.125s, transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s, -webkit-transform 0.125s cubic-bezier(0.075, 0.82, 0.165, 1) 0.175s;\n  -webkit-transform: translate3d(-80px, -80px, 0) rotate(45deg);\n          transform: translate3d(-80px, -80px, 0) rotate(45deg);\n}\n.hamburger--minus .hamburger-inner[data-v-4c9ed310]:after, .hamburger--minus .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: bottom .08s ease-out 0s,top .08s ease-out 0s,opacity 0s linear;\n  transition: bottom .08s ease-out 0s,top .08s ease-out 0s,opacity 0s linear;\n}\n.hamburger--minus.is-active .hamburger-inner[data-v-4c9ed310]:after, .hamburger--minus.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: bottom .08s ease-out,top .08s ease-out,opacity 0s linear .08s;\n  transition: bottom .08s ease-out,top .08s ease-out,opacity 0s linear .08s;\n  opacity: 0;\n}\n.hamburger--minus.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n}\n.hamburger--minus.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n}\n.hamburger--slider .hamburger-inner[data-v-4c9ed310] {\n  top: 2px;\n}\n.hamburger--slider .hamburger-inner[data-v-4c9ed310]:before {\n  top: 10px;\n  -webkit-transition-timing-function: ease;\n          transition-timing-function: ease;\n  -webkit-transition-duration: .15s;\n          transition-duration: .15s;\n  -webkit-transition-property: opacity,-webkit-transform;\n  transition-property: opacity,-webkit-transform;\n  transition-property: transform,opacity;\n  transition-property: transform,opacity,-webkit-transform;\n}\n.hamburger--slider .hamburger-inner[data-v-4c9ed310]:after {\n  top: 20px;\n}\n.hamburger--slider.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: translate3d(0, 10px, 0) rotate(45deg);\n          transform: translate3d(0, 10px, 0) rotate(45deg);\n}\n.hamburger--slider.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: rotate(-45deg) translate3d(-5.71429px, -6px, 0);\n          transform: rotate(-45deg) translate3d(-5.71429px, -6px, 0);\n  opacity: 0;\n}\n.hamburger--slider.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(0, -20px, 0) rotate(-90deg);\n          transform: translate3d(0, -20px, 0) rotate(-90deg);\n}\n.hamburger--slider-r .hamburger-inner[data-v-4c9ed310] {\n  top: 2px;\n}\n.hamburger--slider-r .hamburger-inner[data-v-4c9ed310]:before {\n  top: 10px;\n  -webkit-transition-timing-function: ease;\n          transition-timing-function: ease;\n  -webkit-transition-duration: .15s;\n          transition-duration: .15s;\n  -webkit-transition-property: opacity,-webkit-transform;\n  transition-property: opacity,-webkit-transform;\n  transition-property: transform,opacity;\n  transition-property: transform,opacity,-webkit-transform;\n}\n.hamburger--slider-r .hamburger-inner[data-v-4c9ed310]:after {\n  top: 20px;\n}\n.hamburger--slider-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transform: translate3d(0, 10px, 0) rotate(-45deg);\n          transform: translate3d(0, 10px, 0) rotate(-45deg);\n}\n.hamburger--slider-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transform: rotate(45deg) translate3d(5.71429px, -6px, 0);\n          transform: rotate(45deg) translate3d(5.71429px, -6px, 0);\n  opacity: 0;\n}\n.hamburger--slider-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transform: translate3d(0, -20px, 0) rotate(90deg);\n          transform: translate3d(0, -20px, 0) rotate(90deg);\n}\n.hamburger--spin .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n          transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  -webkit-transition-duration: .22s;\n          transition-duration: .22s;\n}\n.hamburger--spin .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: top .1s ease-in .25s,opacity .1s ease-in;\n  transition: top .1s ease-in .25s,opacity .1s ease-in;\n}\n.hamburger--spin .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition: bottom 0.1s ease-in 0.25s, -webkit-transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: bottom 0.1s ease-in 0.25s, -webkit-transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19), -webkit-transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n.hamburger--spin.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: .12s;\n          transition-delay: .12s;\n  -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n          transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  -webkit-transform: rotate(225deg);\n          transform: rotate(225deg);\n}\n.hamburger--spin.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top .1s ease-out,opacity .1s ease-out .12s;\n  transition: top .1s ease-out,opacity .1s ease-out .12s;\n  opacity: 0;\n}\n.hamburger--spin.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n  -webkit-transition: bottom 0.1s ease-out, -webkit-transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  transition: bottom 0.1s ease-out, -webkit-transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  transition: bottom 0.1s ease-out, transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  transition: bottom 0.1s ease-out, transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s, -webkit-transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  -webkit-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n}\n.hamburger--spin-r .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n          transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  -webkit-transition-duration: .22s;\n          transition-duration: .22s;\n}\n.hamburger--spin-r .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: top .1s ease-in .25s,opacity .1s ease-in;\n  transition: top .1s ease-in .25s,opacity .1s ease-in;\n}\n.hamburger--spin-r .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition: bottom 0.1s ease-in 0.25s, -webkit-transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: bottom 0.1s ease-in 0.25s, -webkit-transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19), -webkit-transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n.hamburger--spin-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: .12s;\n          transition-delay: .12s;\n  -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n          transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  -webkit-transform: rotate(-225deg);\n          transform: rotate(-225deg);\n}\n.hamburger--spin-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top .1s ease-out,opacity .1s ease-out .12s;\n  transition: top .1s ease-out,opacity .1s ease-out .12s;\n  opacity: 0;\n}\n.hamburger--spin-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n  -webkit-transition: bottom 0.1s ease-out, -webkit-transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  transition: bottom 0.1s ease-out, -webkit-transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  transition: bottom 0.1s ease-out, transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  transition: bottom 0.1s ease-out, transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s, -webkit-transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n.hamburger--spring .hamburger-inner[data-v-4c9ed310] {\n  top: 2px;\n  -webkit-transition: background-color 0s linear .13s;\n  transition: background-color 0s linear .13s;\n}\n.hamburger--spring .hamburger-inner[data-v-4c9ed310]:before {\n  top: 10px;\n  -webkit-transition: top 0.1s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.1s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.1s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.1s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19), -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n.hamburger--spring .hamburger-inner[data-v-4c9ed310]:after {\n  top: 20px;\n  -webkit-transition: top 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19), -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n.hamburger--spring.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: .22s;\n          transition-delay: .22s;\n  background-color: transparent;\n}\n.hamburger--spring.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.15s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.15s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.15s, transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.15s, transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  -webkit-transform: translate3d(0, 10px, 0) rotate(45deg);\n          transform: translate3d(0, 10px, 0) rotate(45deg);\n}\n.hamburger--spring.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  top: 0;\n  -webkit-transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  -webkit-transform: translate3d(0, 10px, 0) rotate(-45deg);\n          transform: translate3d(0, 10px, 0) rotate(-45deg);\n}\n.hamburger--spring-r .hamburger-inner[data-v-4c9ed310] {\n  top: auto;\n  bottom: 0;\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n  -webkit-transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n          transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  -webkit-transition-duration: .13s;\n          transition-duration: .13s;\n}\n.hamburger--spring-r .hamburger-inner[data-v-4c9ed310]:after {\n  top: -20px;\n  -webkit-transition: top 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, opacity 0s linear;\n  transition: top 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, opacity 0s linear;\n}\n.hamburger--spring-r .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: top 0.1s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.1s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.1s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: top 0.1s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s, transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19), -webkit-transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n.hamburger--spring-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: .22s;\n          transition-delay: .22s;\n  -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n          transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  -webkit-transform: translate3d(0, -10px, 0) rotate(-45deg);\n          transform: translate3d(0, -10px, 0) rotate(-45deg);\n}\n.hamburger--spring-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  top: 0;\n  -webkit-transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0s linear 0.22s;\n  transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0s linear 0.22s;\n  opacity: 0;\n}\n.hamburger--spring-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.15s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.15s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.15s, transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.15s, transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s, -webkit-transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.22s;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n.hamburger--stand .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color 0s linear 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.15s;\n  transition: background-color 0s linear 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.15s;\n  transition: transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.15s, background-color 0s linear 75ms;\n  transition: transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.15s, background-color 0s linear 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.15s;\n}\n.hamburger--stand .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: top 75ms ease-in 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: top 75ms ease-in 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: top 75ms ease-in 75ms, transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: top 75ms ease-in 75ms, transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n}\n.hamburger--stand .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition: bottom 75ms ease-in 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: bottom 75ms ease-in 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: bottom 75ms ease-in 75ms, transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: bottom 75ms ease-in 75ms, transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n}\n.hamburger--stand.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color 0s linear 0.15s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n  transition: background-color 0s linear 0.15s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n  transition: transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s, background-color 0s linear 0.15s;\n  transition: transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s, background-color 0s linear 0.15s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n  background-color: transparent;\n}\n.hamburger--stand.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top 75ms ease-out 0.1s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: top 75ms ease-out 0.1s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: top 75ms ease-out 0.1s, transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: top 75ms ease-out 0.1s, transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  -webkit-transform: rotate(-45deg);\n          transform: rotate(-45deg);\n}\n.hamburger--stand.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n  -webkit-transition: bottom 75ms ease-out 0.1s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: bottom 75ms ease-out 0.1s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: bottom 75ms ease-out 0.1s, transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: bottom 75ms ease-out 0.1s, transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n}\n.hamburger--stand-r .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color 0s linear 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.15s;\n  transition: background-color 0s linear 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.15s;\n  transition: transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.15s, background-color 0s linear 75ms;\n  transition: transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.15s, background-color 0s linear 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.15s;\n}\n.hamburger--stand-r .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: top 75ms ease-in 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: top 75ms ease-in 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: top 75ms ease-in 75ms, transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: top 75ms ease-in 75ms, transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n}\n.hamburger--stand-r .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition: bottom 75ms ease-in 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: bottom 75ms ease-in 75ms, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: bottom 75ms ease-in 75ms, transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n  transition: bottom 75ms ease-in 75ms, transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;\n}\n.hamburger--stand-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition: background-color 0s linear 0.15s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n  transition: background-color 0s linear 0.15s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n  transition: transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s, background-color 0s linear 0.15s;\n  transition: transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s, background-color 0s linear 0.15s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n  -webkit-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n  background-color: transparent;\n}\n.hamburger--stand-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top 75ms ease-out 0.1s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: top 75ms ease-out 0.1s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: top 75ms ease-out 0.1s, transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: top 75ms ease-out 0.1s, transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  -webkit-transform: rotate(-45deg);\n          transform: rotate(-45deg);\n}\n.hamburger--stand-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n  -webkit-transition: bottom 75ms ease-out 0.1s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: bottom 75ms ease-out 0.1s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: bottom 75ms ease-out 0.1s, transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  transition: bottom 75ms ease-out 0.1s, transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.15s;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n}\n.hamburger--squeeze .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n          transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  -webkit-transition-duration: 75ms;\n          transition-duration: 75ms;\n}\n.hamburger--squeeze .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition: top 75ms ease .12s,opacity 75ms ease;\n  transition: top 75ms ease .12s,opacity 75ms ease;\n}\n.hamburger--squeeze .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition: bottom 75ms ease 0.12s, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: bottom 75ms ease 0.12s, -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: bottom 75ms ease 0.12s, transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: bottom 75ms ease 0.12s, transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19), -webkit-transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n.hamburger--squeeze.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-delay: .12s;\n          transition-delay: .12s;\n  -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n          transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n}\n.hamburger--squeeze.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  -webkit-transition: top 75ms ease,opacity 75ms ease .12s;\n  transition: top 75ms ease,opacity 75ms ease .12s;\n  opacity: 0;\n}\n.hamburger--squeeze.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n  -webkit-transition: bottom 75ms ease, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  transition: bottom 75ms ease, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  transition: bottom 75ms ease, transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  transition: bottom 75ms ease, transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s, -webkit-transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n  -webkit-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n}\n.hamburger--vortex .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\n          transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\n  -webkit-transition-duration: .2s;\n          transition-duration: .2s;\n}\n.hamburger--vortex .hamburger-inner[data-v-4c9ed310]:after, .hamburger--vortex .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition-delay: .1s;\n          transition-delay: .1s;\n  -webkit-transition-timing-function: linear;\n          transition-timing-function: linear;\n  -webkit-transition-duration: 0s;\n          transition-duration: 0s;\n}\n.hamburger--vortex .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition-property: top,opacity;\n  transition-property: top,opacity;\n}\n.hamburger--vortex .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition-property: bottom,-webkit-transform;\n  transition-property: bottom,-webkit-transform;\n  transition-property: bottom,transform;\n  transition-property: bottom,transform,-webkit-transform;\n}\n.hamburger--vortex.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\n          transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\n  -webkit-transform: rotate(765deg);\n          transform: rotate(765deg);\n}\n.hamburger--vortex.is-active .hamburger-inner[data-v-4c9ed310]:after, .hamburger--vortex.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n}\n.hamburger--vortex.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  opacity: 0;\n}\n.hamburger--vortex.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n.hamburger--vortex-r .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\n          transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\n  -webkit-transition-duration: .2s;\n          transition-duration: .2s;\n}\n.hamburger--vortex-r .hamburger-inner[data-v-4c9ed310]:after, .hamburger--vortex-r .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition-delay: .1s;\n          transition-delay: .1s;\n  -webkit-transition-timing-function: linear;\n          transition-timing-function: linear;\n  -webkit-transition-duration: 0s;\n          transition-duration: 0s;\n}\n.hamburger--vortex-r .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition-property: top,opacity;\n  transition-property: top,opacity;\n}\n.hamburger--vortex-r .hamburger-inner[data-v-4c9ed310]:after {\n  -webkit-transition-property: bottom,-webkit-transform;\n  transition-property: bottom,-webkit-transform;\n  transition-property: bottom,transform;\n  transition-property: bottom,transform,-webkit-transform;\n}\n.hamburger--vortex-r.is-active .hamburger-inner[data-v-4c9ed310] {\n  -webkit-transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\n          transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\n  -webkit-transform: rotate(-765deg);\n          transform: rotate(-765deg);\n}\n.hamburger--vortex-r.is-active .hamburger-inner[data-v-4c9ed310]:after, .hamburger--vortex-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n}\n.hamburger--vortex-r.is-active .hamburger-inner[data-v-4c9ed310]:before {\n  top: 0;\n  opacity: 0;\n}\n.hamburger--vortex-r.is-active .hamburger-inner[data-v-4c9ed310]:after {\n  bottom: 0;\n  -webkit-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n}\n.side-menu-cover[data-v-4c9ed310] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  -webkit-transition: all 300ms ease;\n  transition: all 300ms ease;\n  opacity: 1;\n}\n.side-menu-cover.hide[data-v-4c9ed310] {\n    top: -100%;\n    opacity: 0;\n}\n.side-menu[data-v-4c9ed310] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 11;\n  width: 250px;\n  height: 100%;\n  background-color: #2A2D33;\n  overflow: auto;\n  -webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.35);\n          box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.35);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.side-menu.hide[data-v-4c9ed310] {\n    left: -255px;\n}\n.side-menu .user img[data-v-4c9ed310] {\n    display: block;\n    width: 80px;\n    height: 80px;\n    margin: 20px auto 10px;\n    border-radius: 50%;\n}\n.side-menu .user .name[data-v-4c9ed310] {\n    text-align: center;\n    font-weight: 700;\n    font-size: 20px;\n    text-align: center;\n    padding: 0 15px;\n    color: #fff;\n}\n.side-menu .user .logout[data-v-4c9ed310] {\n    font-size: 14px;\n    color: #fff;\n    text-align: center;\n}\n.side-menu .user .logout a[data-v-4c9ed310] {\n      font-weight: 700;\n}\n.side-menu .search-toggle[data-v-4c9ed310] {\n    color: #fff;\n    padding: 10px 20px;\n    font-size: 14px;\n    text-align: center;\n    /* Hide default HTML checkbox */\n    /* The slider */\n}\n.side-menu .search-toggle span[data-v-4c9ed310] {\n      margin-right: 10px;\n}\n.side-menu .search-toggle .switch[data-v-4c9ed310] {\n      position: relative;\n      display: inline-block;\n      width: 50px;\n      height: 20px;\n      bottom: -2px;\n}\n.side-menu .search-toggle .switch input[data-v-4c9ed310] {\n      opacity: 0;\n      width: 0;\n      height: 0;\n}\n.side-menu .search-toggle .slider[data-v-4c9ed310] {\n      position: absolute;\n      cursor: pointer;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background-color: #ccc;\n      -webkit-transition: .4s;\n      transition: .4s;\n}\n.side-menu .search-toggle .slider[data-v-4c9ed310]:before {\n      position: absolute;\n      content: \"\";\n      height: 14px;\n      width: 14px;\n      left: 3px;\n      bottom: 3px;\n      background-color: white;\n      -webkit-transition: .4s;\n      transition: .4s;\n}\n.side-menu .search-toggle input:checked + .slider[data-v-4c9ed310] {\n      background-color: #2196F3;\n}\n.side-menu .search-toggle input:focus + .slider[data-v-4c9ed310] {\n      -webkit-box-shadow: 0 0 1px #2196F3;\n              box-shadow: 0 0 1px #2196F3;\n}\n.side-menu .search-toggle input:checked + .slider[data-v-4c9ed310]:before {\n      -webkit-transform: translateX(20px);\n      transform: translateX(20px);\n}\n.side-menu .search-toggle .slider.round[data-v-4c9ed310] {\n      border-radius: 34px;\n}\n.side-menu .search-toggle .slider.round[data-v-4c9ed310]:before {\n      border-radius: 50%;\n}\n.side-menu ul[data-v-4c9ed310] {\n    padding: 0;\n    margin: 0;\n    list-style-type: none;\n    display: block;\n}\n.side-menu ul li[data-v-4c9ed310] {\n      display: block;\n}\n.side-menu ul li a[data-v-4c9ed310] {\n        padding: 10px 20px;\n        display: block;\n        border-bottom: 1px solid #222;\n        border-top: 1px solid #444;\n        color: #eee;\n        text-decoration: none;\n}\n.hamburger[data-v-4c9ed310] {\n  width: 50px;\n  height: 50px;\n  position: fixed;\n  padding: 13px 14px;\n  z-index: 12;\n  top: 0;\n  left: 0;\n  background-color: #57D1B7;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n.hamburger.hide[data-v-4c9ed310] {\n    left: -50px;\n}\n.hamburger[data-v-4c9ed310]:hover {\n    opacity: 1;\n}\n.hamburger .hamburger-inner[data-v-4c9ed310],\n  .hamburger .hamburger-inner[data-v-4c9ed310]:after,\n  .hamburger .hamburger-inner[data-v-4c9ed310]:before {\n    background-color: #fff;\n    width: 20px;\n    height: 3px;\n}\n.hamburger .hamburger-inner[data-v-4c9ed310]:before {\n    top: -6px;\n}\n.hamburger .hamburger-inner[data-v-4c9ed310]:after {\n    bottom: -6px;\n}\n.hamburger.is-active[data-v-4c9ed310] {\n    background-color: #2A2D33;\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0);\n}\n.hamburger.need-notif-perm[data-v-4c9ed310]:before {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    webkit-box-shadow: inset 0 0 0 4px #ec6b24;\n    -webkit-box-shadow: inset 0 0 0 4px #ec6b24;\n            box-shadow: inset 0 0 0 4px #ec6b24;\n    opacity: 0;\n    -webkit-animation: border-pulsate-data-v-4c9ed310 1.2s linear infinite;\n            animation: border-pulsate-data-v-4c9ed310 1.2s linear infinite;\n}\na[data-v-4c9ed310] {\n  cursor: pointer;\n}\na.disabled[data-v-4c9ed310] {\n  pointer-events: none;\n  color: #ddd;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n@-webkit-keyframes border-pulsate-data-v-4c9ed310 {\n0%, 100% {\n    webkit-box-shadow: inset 0 0 0 0 #ec6b24;\n    -webkit-box-shadow: inset 0 0 0 0 #ec6b24;\n            box-shadow: inset 0 0 0 0 #ec6b24;\n    opacity: 0;\n}\n50% {\n    webkit-box-shadow: inset 0 0 0 4px #ec6b24;\n    -webkit-box-shadow: inset 0 0 0 4px #ec6b24;\n            box-shadow: inset 0 0 0 4px #ec6b24;\n    opacity: 1;\n}\n}\n@keyframes border-pulsate-data-v-4c9ed310 {\n0%, 100% {\n    webkit-box-shadow: inset 0 0 0 0 #ec6b24;\n    -webkit-box-shadow: inset 0 0 0 0 #ec6b24;\n            box-shadow: inset 0 0 0 0 #ec6b24;\n    opacity: 0;\n}\n50% {\n    webkit-box-shadow: inset 0 0 0 4px #ec6b24;\n    -webkit-box-shadow: inset 0 0 0 4px #ec6b24;\n            box-shadow: inset 0 0 0 4px #ec6b24;\n    opacity: 1;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationPermission_vue__ = __webpack_require__(368);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0be7c75f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationPermission_vue__ = __webpack_require__(839);
function injectStyle (ssrContext) {
  __webpack_require__(837)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0be7c75f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationPermission_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0be7c75f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationPermission_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(838);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2f097733", content, true, {});

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.notification-permission[data-v-0be7c75f] {\n  display: none;\n  background-color: #F25E0D;\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n  padding: 15px;\n  margin: 25px;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  text-align: center;\n  position: relative;\n}\n.notification-permission.show[data-v-0be7c75f] {\n    display: block;\n}\n.notification-permission span[data-v-0be7c75f] {\n    display: block;\n    margin-bottom: 7px;\n}\n.notification-permission .button[data-v-0be7c75f] {\n    margin-left: 10px;\n    display: block;\n}\n.notification-permission[data-v-0be7c75f]:before {\n    content: '';\n    display: block;\n    position: absolute;\n    border: 2px solid #F25E0D;\n    top: -5px;\n    left: -5px;\n    right: -5px;\n    bottom: -5px;\n    border-radius: 3px;\n    opacity: 0;\n    -webkit-animation: pulsate-data-v-0be7c75f 1s linear infinite forwards;\n            animation: pulsate-data-v-0be7c75f 1s linear infinite forwards;\n}\n@-webkit-keyframes pulsate-data-v-0be7c75f {\n0%, 100% {\n    -webkit-transform: scale(0.95);\n            transform: scale(0.95);\n    opacity: 0;\n}\n65% {\n    -webkit-transform: scale(1.05);\n            transform: scale(1.05);\n    opacity: 1;\n}\n}\n@keyframes pulsate-data-v-0be7c75f {\n0%, 100% {\n    -webkit-transform: scale(0.95);\n            transform: scale(0.95);\n    opacity: 0;\n}\n65% {\n    -webkit-transform: scale(1.05);\n            transform: scale(1.05);\n    opacity: 1;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/App/NotificationPermission.vue"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,iDAAiD;UACzC,yCAAyC;EACjD,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;IACf,mBAAmB;CACtB;AACD;IACI,kBAAkB;IAClB,eAAe;CAClB;AACD;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,0BAA0B;IAC1B,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uEAAuE;YAC/D,+DAA+D;CAC1E;AACD;AACA;IACI,+BAA+B;YACvB,uBAAuB;IAC/B,WAAW;CACd;AACD;IACI,+BAA+B;YACvB,uBAAuB;IAC/B,WAAW;CACd;CACA;AACD;AACA;IACI,+BAA+B;YACvB,uBAAuB;IAC/B,WAAW;CACd;AACD;IACI,+BAA+B;YACvB,uBAAuB;IAC/B,WAAW;CACd;CACA","file":"NotificationPermission.vue","sourcesContent":["\n.notification-permission[data-v-0be7c75f] {\n  display: none;\n  background-color: #F25E0D;\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n  padding: 15px;\n  margin: 25px;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  text-align: center;\n  position: relative;\n}\n.notification-permission.show[data-v-0be7c75f] {\n    display: block;\n}\n.notification-permission span[data-v-0be7c75f] {\n    display: block;\n    margin-bottom: 7px;\n}\n.notification-permission .button[data-v-0be7c75f] {\n    margin-left: 10px;\n    display: block;\n}\n.notification-permission[data-v-0be7c75f]:before {\n    content: '';\n    display: block;\n    position: absolute;\n    border: 2px solid #F25E0D;\n    top: -5px;\n    left: -5px;\n    right: -5px;\n    bottom: -5px;\n    border-radius: 3px;\n    opacity: 0;\n    -webkit-animation: pulsate-data-v-0be7c75f 1s linear infinite forwards;\n            animation: pulsate-data-v-0be7c75f 1s linear infinite forwards;\n}\n@-webkit-keyframes pulsate-data-v-0be7c75f {\n0%, 100% {\n    -webkit-transform: scale(0.95);\n            transform: scale(0.95);\n    opacity: 0;\n}\n65% {\n    -webkit-transform: scale(1.05);\n            transform: scale(1.05);\n    opacity: 1;\n}\n}\n@keyframes pulsate-data-v-0be7c75f {\n0%, 100% {\n    -webkit-transform: scale(0.95);\n            transform: scale(0.95);\n    opacity: 0;\n}\n65% {\n    -webkit-transform: scale(1.05);\n            transform: scale(1.05);\n    opacity: 1;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'notification-permission': true, show: this.$store.state.notificationPermission.show}},[_c('span',[_vm._v("Please enable notification for Backoffice.")]),_vm._v(" "),_c('a',{staticClass:"button",attrs:{"href":"javascript:;"},on:{"click":_vm.showNotificationPermission}},[_vm._v("ENABLE")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"side-menu"}},[_c('div',{class:{hamburger: true, 'hamburger--spin': true,
                      'is-active': _vm.showSideMenu, hide: _vm.hideMenuButton,
                      'need-notif-perm': _vm.showNotifPerm && !_vm.showSideMenu},on:{"click":_vm.toggleMenu}},[_vm._m(0)]),_vm._v(" "),_c('div',{class:{'side-menu': true, hide: !this.$store.state.sideMenu.show}},[_c('div',{staticClass:"user"},[_c('img',{attrs:{"src":_vm.user.photoUrl}}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.user.firstName)+" "+_vm._s(_vm.user.lastName))]),_vm._v(" "),_c('div',{staticClass:"logout"},[_c('span',[_vm._v("Not "+_vm._s(_vm.user.firstName)+"?")]),_vm._v(" "),_c('a',{class:{ disabled: _vm.loggingOut },attrs:{"href":"javascript:;"},on:{"click":_vm.logout}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loggingOut),expression:"!loggingOut"}]},[_vm._v("Logout")]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loggingOut),expression:"loggingOut"}],staticClass:"fas fa-spinner fa-spin fa-fw"})])]),_vm._v(" "),_c('div',{staticClass:"search-toggle"},[_c('span',[_vm._v("Global Search:")]),_vm._v(" "),_c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.enableSearchGlobal},on:{"click":_vm.toggleGlobalSearch}}),_vm._v(" "),_c('span',{staticClass:"slider round"})])])]),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{ name: 'Transactions' }}},[_vm._v(_vm._s(_vm.$t('sideMenu.transactions')))])],1),_vm._v(" "),_c('li',{on:{"click":_vm.createRsvp}},[_c('a',[_vm._v("Create Reservation")])]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'ImportRsvp' }}},[_vm._v("Import Reservation")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'Dispatch' }}},[_vm._v(_vm._s(_vm.$t('sideMenu.dispatch')))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'DispatchLaxit' }}},[_vm._v(_vm._s(_vm.$t('sideMenu.laxit')))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'Runs' }}},[_vm._v("Runs")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'Routing' }}},[_vm._v(_vm._s(_vm.$t('sideMenu.routing')))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'Flights' }}},[_vm._v("Flights")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'Corporate' }}},[_vm._v("Corporate Accounts")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'ConsumerList' }}},[_vm._v(_vm._s(_vm.$t('sideMenu.consumers')))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'ProviderList' }}},[_vm._v(_vm._s(_vm.$t('sideMenu.providers')))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'ProviderAvailability' }}},[_vm._v(_vm._s(_vm.$t('sideMenu.providerAvailability')))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'ProviderDeductions' }}},[_vm._v(_vm._s(_vm.$t('sideMenu.providerDeductions')))])],1),_vm._v(" "),_c('li',[(_vm.payoutsAccess)?_c('router-link',{attrs:{"to":{ name: 'ProviderPayouts' }}},[_vm._v(_vm._s(_vm.$t('sideMenu.providerPayouts')))]):_vm._e()],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'Geofence' }}},[_vm._v(_vm._s(_vm.$t('sideMenu.geofences')))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'Pricing' }}},[_vm._v(_vm._s(_vm.$t('sideMenu.pricing')))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'Services' }}},[_vm._v(_vm._s(_vm.$t('sideMenu.serviceTypes')))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'Reports' }}},[_vm._v(_vm._s(_vm.$t('sideMenu.reports')))])],1),_vm._v(" "),_c('li',[(_vm.insuranceAccess)?_c('router-link',{attrs:{"to":{ name: 'Insurance' }}},[_vm._v("Insurance")]):_vm._e()],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'MarketingAds' }}},[_vm._v(_vm._s(_vm.$t('sideMenu.marketingAds')))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'PromoList' }}},[_vm._v(_vm._s(_vm.$t('sideMenu.promo')))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'Discount Codes' }}},[_vm._v("Discount Codes")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'Brands' }}},[_vm._v(_vm._s(_vm.$t('sideMenu.brands')))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'Filters' }}},[_vm._v(_vm._s(_vm.$t('sideMenu.filters')))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'Admin' }}},[_vm._v(_vm._s(_vm.$t('sideMenu.admin')))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'Settings' }}},[_vm._v(_vm._s(_vm.$t('sideMenu.settings')))])],1)]),_vm._v(" "),_c('notification-permission')],1),_vm._v(" "),_c('div',{class:{'side-menu-cover': true, hide: !this.$store.state.sideMenu.show},on:{"click":_vm.toggleMenu}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger-box"},[_c('div',{staticClass:"hamburger-inner"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SessionLoader_vue__ = __webpack_require__(369);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a59e336_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SessionLoader_vue__ = __webpack_require__(844);
function injectStyle (ssrContext) {
  __webpack_require__(842)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a59e336"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SessionLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a59e336_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SessionLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(843);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("26921808", content, true, {});

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.session-loader[data-v-2a59e336] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.7);\n  z-index: 999;\n  opacity: 1;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.session-loader.hide[data-v-2a59e336] {\n    opacity: 0;\n    top: -100%;\n}\n.loader-content[data-v-2a59e336] {\n  text-align: center;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/App/SessionLoader.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,2CAA2C;EAC3C,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,mBAAmB;CACpB","file":"SessionLoader.vue","sourcesContent":["\n.session-loader[data-v-2a59e336] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.7);\n  z-index: 999;\n  opacity: 1;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.session-loader.hide[data-v-2a59e336] {\n    opacity: 0;\n    top: -100%;\n}\n.loader-content[data-v-2a59e336] {\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 
    'session-loader': true,
    hide: _vm.hideLoader 
  }},[_c('div',{staticClass:"loader-content"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(370);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29868302_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(849);
function injectStyle (ssrContext) {
  __webpack_require__(846)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29868302"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29868302_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(847);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("d0807530", content, true, {});

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.status[data-v-29868302] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-29868302], .status.completed[data-v-29868302] {\n    background: #26D97A;\n}\n.status.canceled[data-v-29868302], .status.cancelled[data-v-29868302], .status.failed[data-v-29868302] {\n    background: #bbb;\n}\n.status.upcoming[data-v-29868302] {\n    background: #f38d56;\n}\n.status.onboard[data-v-29868302] {\n    background: #dc3168;\n}\n.status.ready[data-v-29868302] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-29868302], .status.requires_dispatch[data-v-29868302] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-29868302] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-29868302] {\n    background: #5662f3;\n}\n.flight-status[data-v-29868302] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-29868302] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-29868302] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-29868302] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-29868302] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-29868302] {\n    background-color: #f35656;\n}\n.globalSearchIcon[data-v-29868302] {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  z-index: 13;\n  border-radius: 0;\n  height: 50px;\n  width: 50px;\n  -webkit-box-shadow: -2px -2px 11px 0px #bbb;\n          box-shadow: -2px -2px 11px 0px #bbb;\n  opacity: 0.3;\n}\n.globalSearchIcon[data-v-29868302]:hover {\n    opacity: 1;\n}\n.globalSearchIcon.displaySearch[data-v-29868302] {\n    opacity: 1;\n}\n.container[data-v-29868302] {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  right: 0;\n  left: 0;\n  margin: 0 auto;\n  position: fixed;\n  z-index: 13;\n  padding-top: 10px;\n  -webkit-transition: all 0s ease-in-out;\n  transition: all 0s ease-in-out;\n}\n.container.dark[data-v-29868302] {\n    text-align: center;\n    -webkit-box-pack: normal;\n        -ms-flex-pack: normal;\n            justify-content: normal;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.75);\n    -webkit-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.container.dark .search-field[data-v-29868302] {\n      -webkit-box-shadow: 0px 2px 7px -2px #aaa;\n              box-shadow: 0px 2px 7px -2px #aaa;\n}\n.container .search-box[data-v-29868302] {\n    position: relative;\n}\n.container .search-box h3[data-v-29868302] {\n      color: #fff;\n      text-transform: uppercase;\n      margin-top: 15px;\n      margin-bottom: 5px;\n}\n.container .search-box h3.removeCaps[data-v-29868302] {\n        text-transform: initial;\n}\n.container .search-box .search-field[data-v-29868302] {\n      width: 300px;\n      border-radius: 24px;\n      -webkit-box-shadow: 0px 6px 10px -2px #aaa;\n              box-shadow: 0px 6px 10px -2px #aaa;\n      display: inline-block;\n      margin-top: 0;\n      padding-left: 20px;\n}\n.container .search-box button[data-v-29868302] {\n      display: inline-block;\n      margin-left: -44px;\n      border-radius: 0 24px 24px 0;\n      height: 46px;\n      font-size: 17px;\n}\n.container .search-box .clear-search[data-v-29868302] {\n      position: absolute;\n      top: 0;\n      margin-left: -70px;\n      color: #d92626;\n      cursor: pointer;\n      line-height: 46px;\n}\n.container .search-results[data-v-29868302] {\n    overflow-y: scroll;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    width: 100%;\n    text-align: center;\n}\n.container .search-results ul[data-v-29868302] {\n      width: 650px;\n      margin: auto;\n      padding: 0;\n}\n.container .search-results a[data-v-29868302] {\n      text-decoration: none;\n      color: #222;\n}\n.container .search-results .search-result[data-v-29868302] {\n      display: block;\n      width: 650px;\n      text-align: left;\n      margin: 17px auto;\n      padding: 20px 35px;\n      background-color: #fff;\n      border-radius: 18px;\n      -webkit-box-shadow: 0px 5px 7px -2px #aaa;\n              box-shadow: 0px 5px 7px -2px #aaa;\n}\n.container .search-results .search-result[data-v-29868302]:hover {\n        background-color: #fff8dc;\n        cursor: pointer;\n}\n.container .search-results .search-result .columns[data-v-29868302] {\n        padding: 5px;\n}\n.container .search-results .search-result hr[data-v-29868302] {\n        color: #eee;\n        opacity: 0.2;\n        margin: 10px 0;\n}\n.container .search-results .search-result p[data-v-29868302] {\n        margin: 2px;\n}\n.container .search-results .search-result p i[data-v-29868302] {\n          margin-right: 5px;\n}\n.container .search-results .search-result .rsvp[data-v-29868302] {\n        color: #0d79f2;\n        font-weight: 700;\n        font-size: 14px;\n        padding: 5px;\n}\n.container .search-results .search-result .rsvp .amount[data-v-29868302] {\n          color: #000;\n          float: right;\n          font-size: 20px;\n          font-weight: 800;\n          line-height: 1;\n}\n.container .search-results .search-result .schedule i[data-v-29868302] {\n        color: #F25E0D;\n}\n.container .search-results .search-result .schedule span[data-v-29868302] {\n        font-weight: 800;\n}\n.container .search-results .search-result .pickup i[data-v-29868302] {\n        color: #d92626;\n}\n.container .search-results .search-result .pickup span[data-v-29868302] {\n        font-size: 15px;\n}\n.container .search-results .search-result .dropoff i[data-v-29868302] {\n        color: #26D97A;\n        margin-right: 0;\n}\n.container .search-results .search-result .dropoff span[data-v-29868302] {\n        font-size: 15px;\n}\n.container .search-results .search-result .customer-id i[data-v-29868302] {\n        margin-right: 1px;\n}\n.container .search-results .search-result .customer-id i[data-v-29868302],\n      .container .search-results .search-result .customer-name i[data-v-29868302],\n      .container .search-results .search-result .customer-email i[data-v-29868302] {\n        color: #0d79f2;\n}\n.container .search-results .search-result .customer-id span[data-v-29868302],\n      .container .search-results .search-result .customer-name span[data-v-29868302],\n      .container .search-results .search-result .customer-email span[data-v-29868302] {\n        font-size: 15px;\n}\n.container .search-results[data-v-29868302]::-webkit-scrollbar {\n    width: 0;\n    height: 0;\n}\n.slide-left-enter-active[data-v-29868302], .slide-left-leave-active[data-v-29868302] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-left-enter[data-v-29868302], .slide-left-leave-to[data-v-29868302] {\n  -webkit-transform: translateX(30px);\n          transform: translateX(30px);\n  opacity: 0;\n}\n.infinity-loader[data-v-29868302] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  -webkit-transform-origin: bottom center;\n          transform-origin: bottom center;\n  text-align: center;\n  font-size: 18px;\n  line-height: 40px;\n}\n.mobile.container[data-v-29868302] {\n  z-index: 10;\n}\n.mobile.container .search-box .search-field[data-v-29868302] {\n    width: calc(100vw - 120px);\n}\n.mobile.container .search-results ul[data-v-29868302] {\n    width: 95%;\n}\n.mobile.container .search-results .search-result[data-v-29868302] {\n    width: 100%;\n    padding: 20px;\n}\n.slide-enter-active[data-v-29868302], .slide-leave-active[data-v-29868302] {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.slide-enter[data-v-29868302], .slide-leave-to[data-v-29868302] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.container .search-results .search-result span[data-v-29868302],\n  .container .search-results .search-result i[data-v-29868302] {\n    font-size: 13px;\n}\n.container .search-results .search-result p[data-v-29868302] {\n    margin: 0;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/App/Search.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;CAC3B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,4CAA4C;UACpC,oCAAoC;EAC5C,aAAa;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,+BAA+B;CAChC;AACD;IACI,mBAAmB;IACnB,yBAAyB;QACrB,sBAAsB;YAClB,wBAAwB;IAChC,YAAY;IACZ,aAAa;IACb,sCAAsC;IACtC,yCAAyC;IACzC,iCAAiC;CACpC;AACD;MACM,0CAA0C;cAClC,kCAAkC;CAC/C;AACD;IACI,mBAAmB;CACtB;AACD;MACM,YAAY;MACZ,0BAA0B;MAC1B,iBAAiB;MACjB,mBAAmB;CACxB;AACD;QACQ,wBAAwB;CAC/B;AACD;MACM,aAAa;MACb,oBAAoB;MACpB,2CAA2C;cACnC,mCAAmC;MAC3C,sBAAsB;MACtB,cAAc;MACd,mBAAmB;CACxB;AACD;MACM,sBAAsB;MACtB,mBAAmB;MACnB,6BAA6B;MAC7B,aAAa;MACb,gBAAgB;CACrB;AACD;MACM,mBAAmB;MACnB,OAAO;MACP,mBAAmB;MACnB,eAAe;MACf,gBAAgB;MAChB,kBAAkB;CACvB;AACD;IACI,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;CACtB;AACD;MACM,aAAa;MACb,aAAa;MACb,WAAW;CAChB;AACD;MACM,sBAAsB;MACtB,YAAY;CACjB;AACD;MACM,eAAe;MACf,aAAa;MACb,iBAAiB;MACjB,kBAAkB;MAClB,mBAAmB;MACnB,uBAAuB;MACvB,oBAAoB;MACpB,0CAA0C;cAClC,kCAAkC;CAC/C;AACD;QACQ,0BAA0B;QAC1B,gBAAgB;CACvB;AACD;QACQ,aAAa;CACpB;AACD;QACQ,YAAY;QACZ,aAAa;QACb,eAAe;CACtB;AACD;QACQ,YAAY;CACnB;AACD;UACU,kBAAkB;CAC3B;AACD;QACQ,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,aAAa;CACpB;AACD;UACU,YAAY;UACZ,aAAa;UACb,gBAAgB;UAChB,iBAAiB;UACjB,eAAe;CACxB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,gBAAgB;CACvB;AACD;QACQ,eAAe;QACf,gBAAgB;CACvB;AACD;QACQ,gBAAgB;CACvB;AACD;QACQ,kBAAkB;CACzB;AACD;;;QAGQ,eAAe;CACtB;AACD;;;QAGQ,gBAAgB;CACvB;AACD;IACI,SAAS;IACT,UAAU;CACb;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,wCAAwC;UAChC,gCAAgC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;EACE,YAAY;CACb;AACD;IACI,2BAA2B;CAC9B;AACD;IACI,WAAW;CACd;AACD;IACI,YAAY;IACZ,cAAc;CACjB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ;AACD;AACA;;IAEI,gBAAgB;CACnB;AACD;IACI,UAAU;CACb;CACA","file":"Search.vue","sourcesContent":["\n.status[data-v-29868302] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-29868302], .status.completed[data-v-29868302] {\n    background: #26D97A;\n}\n.status.canceled[data-v-29868302], .status.cancelled[data-v-29868302], .status.failed[data-v-29868302] {\n    background: #bbb;\n}\n.status.upcoming[data-v-29868302] {\n    background: #f38d56;\n}\n.status.onboard[data-v-29868302] {\n    background: #dc3168;\n}\n.status.ready[data-v-29868302] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-29868302], .status.requires_dispatch[data-v-29868302] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-29868302] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-29868302] {\n    background: #5662f3;\n}\n.flight-status[data-v-29868302] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-29868302] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-29868302] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-29868302] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-29868302] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-29868302] {\n    background-color: #f35656;\n}\n.globalSearchIcon[data-v-29868302] {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  z-index: 13;\n  border-radius: 0;\n  height: 50px;\n  width: 50px;\n  -webkit-box-shadow: -2px -2px 11px 0px #bbb;\n          box-shadow: -2px -2px 11px 0px #bbb;\n  opacity: 0.3;\n}\n.globalSearchIcon[data-v-29868302]:hover {\n    opacity: 1;\n}\n.globalSearchIcon.displaySearch[data-v-29868302] {\n    opacity: 1;\n}\n.container[data-v-29868302] {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  right: 0;\n  left: 0;\n  margin: 0 auto;\n  position: fixed;\n  z-index: 13;\n  padding-top: 10px;\n  -webkit-transition: all 0s ease-in-out;\n  transition: all 0s ease-in-out;\n}\n.container.dark[data-v-29868302] {\n    text-align: center;\n    -webkit-box-pack: normal;\n        -ms-flex-pack: normal;\n            justify-content: normal;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.75);\n    -webkit-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.container.dark .search-field[data-v-29868302] {\n      -webkit-box-shadow: 0px 2px 7px -2px #aaa;\n              box-shadow: 0px 2px 7px -2px #aaa;\n}\n.container .search-box[data-v-29868302] {\n    position: relative;\n}\n.container .search-box h3[data-v-29868302] {\n      color: #fff;\n      text-transform: uppercase;\n      margin-top: 15px;\n      margin-bottom: 5px;\n}\n.container .search-box h3.removeCaps[data-v-29868302] {\n        text-transform: initial;\n}\n.container .search-box .search-field[data-v-29868302] {\n      width: 300px;\n      border-radius: 24px;\n      -webkit-box-shadow: 0px 6px 10px -2px #aaa;\n              box-shadow: 0px 6px 10px -2px #aaa;\n      display: inline-block;\n      margin-top: 0;\n      padding-left: 20px;\n}\n.container .search-box button[data-v-29868302] {\n      display: inline-block;\n      margin-left: -44px;\n      border-radius: 0 24px 24px 0;\n      height: 46px;\n      font-size: 17px;\n}\n.container .search-box .clear-search[data-v-29868302] {\n      position: absolute;\n      top: 0;\n      margin-left: -70px;\n      color: #d92626;\n      cursor: pointer;\n      line-height: 46px;\n}\n.container .search-results[data-v-29868302] {\n    overflow-y: scroll;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    width: 100%;\n    text-align: center;\n}\n.container .search-results ul[data-v-29868302] {\n      width: 650px;\n      margin: auto;\n      padding: 0;\n}\n.container .search-results a[data-v-29868302] {\n      text-decoration: none;\n      color: #222;\n}\n.container .search-results .search-result[data-v-29868302] {\n      display: block;\n      width: 650px;\n      text-align: left;\n      margin: 17px auto;\n      padding: 20px 35px;\n      background-color: #fff;\n      border-radius: 18px;\n      -webkit-box-shadow: 0px 5px 7px -2px #aaa;\n              box-shadow: 0px 5px 7px -2px #aaa;\n}\n.container .search-results .search-result[data-v-29868302]:hover {\n        background-color: #fff8dc;\n        cursor: pointer;\n}\n.container .search-results .search-result .columns[data-v-29868302] {\n        padding: 5px;\n}\n.container .search-results .search-result hr[data-v-29868302] {\n        color: #eee;\n        opacity: 0.2;\n        margin: 10px 0;\n}\n.container .search-results .search-result p[data-v-29868302] {\n        margin: 2px;\n}\n.container .search-results .search-result p i[data-v-29868302] {\n          margin-right: 5px;\n}\n.container .search-results .search-result .rsvp[data-v-29868302] {\n        color: #0d79f2;\n        font-weight: 700;\n        font-size: 14px;\n        padding: 5px;\n}\n.container .search-results .search-result .rsvp .amount[data-v-29868302] {\n          color: #000;\n          float: right;\n          font-size: 20px;\n          font-weight: 800;\n          line-height: 1;\n}\n.container .search-results .search-result .schedule i[data-v-29868302] {\n        color: #F25E0D;\n}\n.container .search-results .search-result .schedule span[data-v-29868302] {\n        font-weight: 800;\n}\n.container .search-results .search-result .pickup i[data-v-29868302] {\n        color: #d92626;\n}\n.container .search-results .search-result .pickup span[data-v-29868302] {\n        font-size: 15px;\n}\n.container .search-results .search-result .dropoff i[data-v-29868302] {\n        color: #26D97A;\n        margin-right: 0;\n}\n.container .search-results .search-result .dropoff span[data-v-29868302] {\n        font-size: 15px;\n}\n.container .search-results .search-result .customer-id i[data-v-29868302] {\n        margin-right: 1px;\n}\n.container .search-results .search-result .customer-id i[data-v-29868302],\n      .container .search-results .search-result .customer-name i[data-v-29868302],\n      .container .search-results .search-result .customer-email i[data-v-29868302] {\n        color: #0d79f2;\n}\n.container .search-results .search-result .customer-id span[data-v-29868302],\n      .container .search-results .search-result .customer-name span[data-v-29868302],\n      .container .search-results .search-result .customer-email span[data-v-29868302] {\n        font-size: 15px;\n}\n.container .search-results[data-v-29868302]::-webkit-scrollbar {\n    width: 0;\n    height: 0;\n}\n.slide-left-enter-active[data-v-29868302], .slide-left-leave-active[data-v-29868302] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-left-enter[data-v-29868302], .slide-left-leave-to[data-v-29868302] {\n  -webkit-transform: translateX(30px);\n          transform: translateX(30px);\n  opacity: 0;\n}\n.infinity-loader[data-v-29868302] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  -webkit-transform-origin: bottom center;\n          transform-origin: bottom center;\n  text-align: center;\n  font-size: 18px;\n  line-height: 40px;\n}\n.mobile.container[data-v-29868302] {\n  z-index: 10;\n}\n.mobile.container .search-box .search-field[data-v-29868302] {\n    width: calc(100vw - 120px);\n}\n.mobile.container .search-results ul[data-v-29868302] {\n    width: 95%;\n}\n.mobile.container .search-results .search-result[data-v-29868302] {\n    width: 100%;\n    padding: 20px;\n}\n.slide-enter-active[data-v-29868302], .slide-leave-active[data-v-29868302] {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.slide-enter[data-v-29868302], .slide-leave-to[data-v-29868302] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.container .search-results .search-result span[data-v-29868302],\n  .container .search-results .search-result i[data-v-29868302] {\n    font-size: 13px;\n}\n.container .search-results .search-result p[data-v-29868302] {\n    margin: 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["a"] = ({
  search: function search(VueApp, callback) {
    var self = this;
    var search = VueApp.$store.state.searchGlobal;
    var request = {
      token: VueApp.$store.state.session.sessionToken,
      search: search.searchInput,
      pageNum: search.currentPage,
      pageSize: search.perPage,
      order: 'pickupTime',
      orderAsc: 0
    };
    VueApp.$sdk.get('/reservation', request, function (r) {
      if (!r.error) {
        VueApp.$store.commit('searchGlobal/setSearchGlobalMaxList', r.paging.totalItems);
        for (var i = 0; i < r.list.length; i++) {
          VueApp.$store.commit('searchGlobal/addSearchGlobalList', self.formatSearchResult(r.list[i]));
        }
      }
      callback(r);
    }, '2.0');
  },
  formatSearchResult: function formatSearchResult(item) {
    return {
      rsvpID: item.ID,
      dropoffLocation: item.dropoffLocation.title,
      pickupLocation: item.pickupLocation.title,
      total: parseFloat(item.total).toFixed(2),
      pickupDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.pickupDate, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY'),
      pickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.pickupDate, 'YYYY-MM-DD HH:mm').format('h:mm A'),
      status: item.dispatchStatus,
      customerName: item.consumer.firstName + ' ' + item.consumer.lastName,
      customerID: item.consumer.ID,
      customerEmail: item.consumer.email
    };
  }
});

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"button large",class:{'globalSearchIcon':true, 'displaySearch':_vm.displaySearchContainer},on:{"click":_vm.toggleSearch}},[(_vm.displaySearchContainer)?_c('i',{staticClass:"fas fa-times"}):_c('i',{staticClass:"fas fa-search"})]),_vm._v(" "),_c('transition',{attrs:{"name":"slide"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.displaySearchContainer),expression:"displaySearchContainer"}],class:{'container':true, 'dark':_vm.darkBackground, 'mobile':_vm.isMobile}},[_c('div',{staticClass:"search-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],ref:"search",staticClass:"search-field",attrs:{"type":"text","placeholder":"Search reservations...","disabled":_vm.loading},domProps:{"value":(_vm.searchInput)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.newSearch.apply(null, arguments)},"focus":_vm.focusSearch,"focusout":_vm.removeFocus,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-left"}},[(_vm.searchInput.length > 0)?_c('i',{staticClass:"far fa-times-circle fa-lg clear-search",on:{"click":_vm.clearSearch}}):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"button small",attrs:{"disabled":_vm.loading || !_vm.searchInput.length > 0},on:{"click":_vm.newSearch}},[(!_vm.loading)?_c('i',{staticClass:"fas fa-search"}):_c('i',{staticClass:"fa fa-spinner fa-spin"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.darkBackground),expression:"darkBackground"}],on:{"click":_vm.removeFocus}},[(!_vm.isNewSearch && !_vm.searchResult.length > 0 && !_vm.loading)?_c('h3',{staticClass:"removeCaps"},[_vm._v("You can search by Email, "),_c('br'),_vm._v("Phone Number and Name")]):_vm._e(),_vm._v(" "),(_vm.searchResult.length > 0 && !_vm.loading)?_c('h3',[_vm._v("Search Results")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('h3',[_vm._v("Loading...")]):_vm._e(),_vm._v(" "),(_vm.searchInput.length > 0 && !_vm.searchResult.length > 0 && !_vm.loading && _vm.isNewSearch)?_c('h3',[_vm._v("No Results Found")]):_vm._e()])],1),_vm._v(" "),(_vm.darkBackground)?_c('div',{staticClass:"search-results",on:{"scroll":_vm.loadMore,"click":_vm.removeFocus}},[_c('ul',_vm._l((_vm.searchResult),function(search){return _c('span',{on:{"mousedown":function($event){return _vm.openRSVP(search.rsvpID)}}},[_c('li',{staticClass:"search-result"},[_c('p',{staticClass:"rsvp"},[_c('i',{staticClass:"fas fa-pager"}),_vm._v(" "),_c('span',[_vm._v("RSVP "+_vm._s(search.rsvpID))]),_vm._v(" "),_c('span',{class:['status', search.status]},[_vm._v(_vm._s(_vm.getLabel(search.status)))]),_vm._v(" "),_c('span',{staticClass:"amount"},[_vm._v("$"+_vm._s(search.total))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns medium-6 small-12"},[_c('p',{staticClass:"schedule"},[_c('i',{staticClass:"fas fa-calendar-alt"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(search.pickupDate)+" "+_vm._s(search.pickupTime))])]),_vm._v(" "),_c('p',{staticClass:"pickup"},[_c('i',{staticClass:"fas fa-map-marker-alt"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(search.pickupLocation))])]),_vm._v(" "),_c('p',{staticClass:"dropoff"},[_c('i',{staticClass:"fas fa-location-arrow"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(search.dropoffLocation))])])]),_vm._v(" "),_c('div',{staticClass:"columns medium-6 small-12"},[_c('p',{staticClass:"customer-id"},[_c('i',{staticClass:"fas fa-address-card"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(search.customerID))])]),_vm._v(" "),_c('p',{staticClass:"customer-name"},[_c('i',{staticClass:"fas fa-user"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(search.customerName))])]),_vm._v(" "),_c('p',{staticClass:"customer-email"},[_c('i',{staticClass:"fas fa-envelope"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(search.customerEmail))])])])])])])}),0)]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading && _vm.searchResult.length > 0),expression:"loading && searchResult.length > 0"}],staticClass:"infinity-loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" LOADING...\n          ")])])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__ = __webpack_require__(371);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e95603e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__(853);
function injectStyle (ssrContext) {
  __webpack_require__(851)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e95603e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e95603e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(852);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("b580ae7e", content, true, {});

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.lr-modal[data-v-e95603e2] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-e95603e2] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-e95603e2] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n}\n.fa-spinner[data-v-e95603e2] {\n  color: #6185aa;\n}\n.lr-loader-msg[data-v-e95603e2] {\n  margin-top: 10px;\n  font-weight: 600;\n  color: #45505b;\n  letter-spacing: .5px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/App/Loader.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oCAAoC;MAChC,iCAAiC;UAC7B,mCAAmC;EAC3C,qCAAqC;MACjC,kCAAkC;UAC9B,+BAA+B;EACvC,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;EACnD,mBAAmB;CACpB;AACD;EACE,eAAe;CAChB;AACD;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;CACtB","file":"Loader.vue","sourcesContent":["\n.lr-modal[data-v-e95603e2] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-e95603e2] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-e95603e2] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n}\n.fa-spinner[data-v-e95603e2] {\n  color: #6185aa;\n}\n.lr-loader-msg[data-v-e95603e2] {\n  margin-top: 10px;\n  font-weight: 600;\n  color: #45505b;\n  letter-spacing: .5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['lr-modal', {'hide': !_vm.show}]},[_c('div',{staticClass:"lr-box"},[_c('i',{staticClass:"fas fa-spinner fa-spin fa-2x"}),_vm._v(" "),(!!_vm.message)?_c('div',{staticClass:"lr-loader-msg"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__ = __webpack_require__(372);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b487bea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__ = __webpack_require__(857);
function injectStyle (ssrContext) {
  __webpack_require__(855)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b487bea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b487bea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(856);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("9a2b3028", content, true, {});

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.lr-modal[data-v-9b487bea] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-9b487bea] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-9b487bea] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  min-width: 300px;\n  max-width: 500px;\n}\n.lr-alert-msg[data-v-9b487bea] {\n  margin-bottom: 20px;\n  color: #45505b;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/App/Alert.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oCAAoC;MAChC,iCAAiC;UAC7B,mCAAmC;EAC3C,qCAAqC;MACjC,kCAAkC;UAC9B,+BAA+B;EACvC,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;EACnD,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;CAClB;AACD;EACE,oBAAoB;EACpB,eAAe;CAChB","file":"Alert.vue","sourcesContent":["\n.lr-modal[data-v-9b487bea] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-9b487bea] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-9b487bea] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  min-width: 300px;\n  max-width: 500px;\n}\n.lr-alert-msg[data-v-9b487bea] {\n  margin-bottom: 20px;\n  color: #45505b;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['lr-modal', {'hide': !_vm.show}]},[_c('div',{staticClass:"lr-box"},[_c('div',{staticClass:"lr-alert-msg",domProps:{"innerHTML":_vm._s(_vm.message)}}),_vm._v(" "),_c('a',{staticClass:"button cta small right block",on:{"click":function($event){_vm.show = false}}},[_vm._v("\n      Close\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReasonModal_vue__ = __webpack_require__(373);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdc3615e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReasonModal_vue__ = __webpack_require__(863);
function injectStyle (ssrContext) {
  __webpack_require__(859)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cdc3615e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReasonModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdc3615e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReasonModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(860);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("77100e18", content, true, {});

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.lr-modal[data-v-cdc3615e] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-cdc3615e] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-cdc3615e] {\n  background: #fff;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  width: 600px;\n  max-width: 600px;\n  max-height: calc(100vh - 40px);\n  overflow: hidden;\n}\n.reasons-modal.hide[data-v-cdc3615e] {\n  display: none;\n}\n.lr-top[data-v-cdc3615e] {\n  padding: 20px;\n  max-height: calc(100vh - 120px);\n  overflow: auto;\n  border-bottom: 1px solid #eee;\n  background: #f3f3f3;\n}\n.reason-table[data-v-cdc3615e] {\n  width: 100%;\n  max-width: 600px;\n  border: 1px solid #ccc;\n  background: #fff;\n}\n.reason-table th[data-v-cdc3615e] {\n    background: #fafafa;\n    padding: 4px;\n    border-bottom: 1px solid #ccc;\n}\n.reason-table .driver[data-v-cdc3615e] {\n    text-align: left;\n}\n.reason-table .reason[data-v-cdc3615e] {\n    text-align: right;\n}\n.reason-table tr td[data-v-cdc3615e] {\n    border-bottom: 1px solid #ccc;\n    font-size: 14px;\n}\n.reason-table tr .reason[data-v-cdc3615e] {\n    font-size: 13px;\n    color: #444;\n    font-family: monospace;\n}\n.lr-close[data-v-cdc3615e] {\n  margin: 10px auto;\n  width: 50%;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/App/ReasonModal.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oCAAoC;MAChC,iCAAiC;UAC7B,mCAAmC;EAC3C,qCAAqC;MACjC,kCAAkC;UAC9B,+BAA+B;EACvC,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;EACnD,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,+BAA+B;EAC/B,iBAAiB;CAClB;AACD;EACE,cAAc;CACf;AACD;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,8BAA8B;EAC9B,oBAAoB;CACrB;AACD;EACE,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;CAClB;AACD;IACI,oBAAoB;IACpB,aAAa;IACb,8BAA8B;CACjC;AACD;IACI,iBAAiB;CACpB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,8BAA8B;IAC9B,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;CAC1B;AACD;EACE,kBAAkB;EAClB,WAAW;CACZ","file":"ReasonModal.vue","sourcesContent":["\n.lr-modal[data-v-cdc3615e] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-cdc3615e] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-cdc3615e] {\n  background: #fff;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  width: 600px;\n  max-width: 600px;\n  max-height: calc(100vh - 40px);\n  overflow: hidden;\n}\n.reasons-modal.hide[data-v-cdc3615e] {\n  display: none;\n}\n.lr-top[data-v-cdc3615e] {\n  padding: 20px;\n  max-height: calc(100vh - 120px);\n  overflow: auto;\n  border-bottom: 1px solid #eee;\n  background: #f3f3f3;\n}\n.reason-table[data-v-cdc3615e] {\n  width: 100%;\n  max-width: 600px;\n  border: 1px solid #ccc;\n  background: #fff;\n}\n.reason-table th[data-v-cdc3615e] {\n    background: #fafafa;\n    padding: 4px;\n    border-bottom: 1px solid #ccc;\n}\n.reason-table .driver[data-v-cdc3615e] {\n    text-align: left;\n}\n.reason-table .reason[data-v-cdc3615e] {\n    text-align: right;\n}\n.reason-table tr td[data-v-cdc3615e] {\n    border-bottom: 1px solid #ccc;\n    font-size: 14px;\n}\n.reason-table tr .reason[data-v-cdc3615e] {\n    font-size: 13px;\n    color: #444;\n    font-family: monospace;\n}\n.lr-close[data-v-cdc3615e] {\n  margin: 10px auto;\n  width: 50%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(862);
var $Object = __webpack_require__(12).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(15);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(29), 'Object', { defineProperty: __webpack_require__(33).f });


/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['lr-modal reasons-modal', {'hide': !_vm.queueError.reasonsModal}]},[_c('div',{staticClass:"lr-box"},[_c('div',{staticClass:"lr-top"},[_c('table',{staticClass:"reason-table",attrs:{"cellpadding":"5","cellspacing":"0"}},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.queueError.list),function(qe){return _c('tr',[_c('td',{staticClass:"driver"},[_c('a',{attrs:{"href":'/#/provider/' + qe.id,"target":"_blank"}},[_vm._v(_vm._s(qe.name))])]),_vm._v(" "),_c('td',{staticClass:"reason"},[_vm._v(_vm._s(_vm.reasonLabel(qe.reason)))])])}),0)])]),_vm._v(" "),_c('a',{staticClass:"button cta small right lr-close",on:{"click":_vm.closeReasons}},[_vm._v("Close")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',{staticClass:"driver"},[_vm._v("Driver")]),_vm._v(" "),_c('th',{staticClass:"reason"},[_vm._v("Reason")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('side-menu'),_vm._v(" "),_c('transition',{attrs:{"name":"slide"}},[_c('search',{directives:[{name:"show",rawName:"v-show",value:(_vm.displaySearch),expression:"displaySearch"}]})],1),_vm._v(" "),_c('div',{staticClass:"row expanded route-container"},[_c('div',{staticClass:"small-12 columns"},[_c('router-view')],1)]),_vm._v(" "),_c('session-loader'),_vm._v(" "),_c('phone-app'),_vm._v(" "),_c('reservation-notes-modal'),_vm._v(" "),_c('flight-information-modal'),_vm._v(" "),_c('country-code-modal'),_vm._v(" "),_c('loader'),_vm._v(" "),_c('alert'),_vm._v(" "),_c('reason-modal')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_admin__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_api_dispatch_reservations__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_api_routing_reservations__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Error_AccessDenied__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Error_404__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_App_Login__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_App_PasswordReset__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_App_PasswordResetDriver__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_App_StyleGuide__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_TestUpload__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Admin__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Brands__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Consumer__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Consumer_List__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Corporate__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Corporate_CreateProfile__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Corporate_Invoice__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Corporate_CorporateProfile__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Dispatch__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Dispatch_DispatchMapDetails__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Dispatch_DispatchReservations__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Promo__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Promo_PromoView__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Routing__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Reports__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_ImportRsvp__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Pricing__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Services__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Geofences__ = __webpack_require__(1599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Geofences_InstructionPreview__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Provider__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_ProviderAvailability__ = __webpack_require__(1723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Provider_List__ = __webpack_require__(1739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_ProviderDeductions__ = __webpack_require__(1751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_ProviderPayouts__ = __webpack_require__(1767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_Provider_PrintPlacard__ = __webpack_require__(1771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_RsvpDetails_index2__ = __webpack_require__(1775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_Transactions__ = __webpack_require__(1833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_PackageDetails_index2__ = __webpack_require__(1852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Flights__ = __webpack_require__(1859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_FlightDetails__ = __webpack_require__(1867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_FlightCreate__ = __webpack_require__(1884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_MarketingAds__ = __webpack_require__(1892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_MarketingAds_AdDetails__ = __webpack_require__(1900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_Filters__ = __webpack_require__(1912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_Filters_FilterDetails__ = __webpack_require__(1920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_Settings__ = __webpack_require__(1924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_Coverage__ = __webpack_require__(1996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_Laxit__ = __webpack_require__(2026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_Runs__ = __webpack_require__(2101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_devlogs__ = __webpack_require__(2105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_devlogs_auto_dispatch__ = __webpack_require__(2109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_DiscountCodes__ = __webpack_require__(2113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_DiscountCodes_Details__ = __webpack_require__(2125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_Quotation__ = __webpack_require__(2133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_Provider_DownloadProfile__ = __webpack_require__(2137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_Airtag__ = __webpack_require__(2141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_Insurance__ = __webpack_require__(2153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_AdminCode__ = __webpack_require__(2165);















































// import RsvpDetails from '@/components/RsvpDetails'



// import PackageDetails from '@/components/PackageDetails'




























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_40__components_Transactions__["a" /* default */]
  }, {
    path: '/thispagedoesnotexist',
    name: 'MissingPage',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Error_404__["a" /* default */]
  }, {
    path: '/accessdenied',
    name: 'AccessDenied',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Error_AccessDenied__["a" /* default */]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_8__components_App_Login__["a" /* default */]
  }, {
    path: '/reset',
    name: 'PasswordReset',
    component: __WEBPACK_IMPORTED_MODULE_9__components_App_PasswordReset__["a" /* default */]
  }, {
    path: '/reset-driver',
    name: 'PasswordResetDriver',
    component: __WEBPACK_IMPORTED_MODULE_10__components_App_PasswordResetDriver__["a" /* default */]
  }, {
    path: '/admin',
    name: 'Admin',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Admin__["a" /* default */]
  }, {
    path: '/brands',
    name: 'Brands',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Brands__["a" /* default */]
  }, {
    path: '/consumer/:id',
    name: 'Consumer',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Consumer__["a" /* default */]
  }, {
    path: '/consumers',
    name: 'ConsumerList',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Consumer_List__["a" /* default */]
  }, {
    path: '/corporate',
    name: 'Corporate',
    component: __WEBPACK_IMPORTED_MODULE_17__components_Corporate__["a" /* default */]
  }, {
    path: '/corporate/new',
    name: 'CreateCorporate',
    component: __WEBPACK_IMPORTED_MODULE_18__components_Corporate_CreateProfile__["a" /* default */]
  }, {
    path: '/corporate/:id',
    name: 'CorporateProfile',
    component: __WEBPACK_IMPORTED_MODULE_20__components_Corporate_CorporateProfile__["a" /* default */]
  }, {
    path: '/corporate/:id/invoice/:invoiceId',
    name: 'CorporateInvoice',
    component: __WEBPACK_IMPORTED_MODULE_19__components_Corporate_Invoice__["a" /* default */]
  }, {
    path: '/dispatch',
    name: 'Dispatch',
    component: __WEBPACK_IMPORTED_MODULE_21__components_Dispatch__["a" /* default */]
  }, {
    path: '/dispatch/map',
    name: 'DispatchMapDetails',
    component: __WEBPACK_IMPORTED_MODULE_22__components_Dispatch_DispatchMapDetails__["a" /* default */]
  }, {
    path: '/dispatch/reservations',
    name: 'DispatchReservations',
    component: __WEBPACK_IMPORTED_MODULE_23__components_Dispatch_DispatchReservations__["a" /* default */]
  }, {
    path: '/dispatch/laxit',
    name: 'DispatchLaxit',
    component: __WEBPACK_IMPORTED_MODULE_51__components_Laxit__["a" /* default */]
  }, {
    path: '/promo',
    name: 'PromoList',
    component: __WEBPACK_IMPORTED_MODULE_24__components_Promo__["a" /* default */]
  }, {
    path: '/promo/:id',
    name: 'PromoView',
    component: __WEBPACK_IMPORTED_MODULE_25__components_Promo_PromoView__["a" /* default */]
  }, {
    path: '/routing',
    name: 'Routing',
    component: __WEBPACK_IMPORTED_MODULE_26__components_Routing__["a" /* default */]
  }, {
    path: '/package/:id',
    name: 'PackageDetails',
    component: __WEBPACK_IMPORTED_MODULE_41__components_PackageDetails_index2__["a" /* default */]
  }, {
    path: '/flights',
    name: 'Flights',
    component: __WEBPACK_IMPORTED_MODULE_42__components_Flights__["a" /* default */]
  }, {
    path: '/flight/:id',
    name: 'FlightDetails',
    component: __WEBPACK_IMPORTED_MODULE_43__components_FlightDetails__["a" /* default */]
  }, {
    path: '/flight-book',
    name: 'FlightNew',
    component: __WEBPACK_IMPORTED_MODULE_44__components_FlightCreate__["a" /* default */]
  }, {
    path: '/geofence',
    name: 'Geofence',
    component: __WEBPACK_IMPORTED_MODULE_31__components_Geofences__["a" /* default */]
  }, {
    path: '/geofence/preview',
    name: 'InstructionPreview',
    component: __WEBPACK_IMPORTED_MODULE_32__components_Geofences_InstructionPreview__["a" /* default */]
  }, {
    path: '/provider/:id',
    name: 'Provider',
    component: __WEBPACK_IMPORTED_MODULE_33__components_Provider__["a" /* default */]
  }, {
    path: '/provider/:id/download',
    name: 'DownloadProfile',
    component: __WEBPACK_IMPORTED_MODULE_58__components_Provider_DownloadProfile__["a" /* default */]
  }, {
    path: '/provider-availability',
    name: 'ProviderAvailability',
    component: __WEBPACK_IMPORTED_MODULE_34__components_ProviderAvailability__["a" /* default */]
  }, {
    path: '/provider-payouts',
    name: 'ProviderPayouts',
    component: __WEBPACK_IMPORTED_MODULE_37__components_ProviderPayouts__["a" /* default */]
  }, {
    path: '/provider-deductions',
    name: 'ProviderDeductions',
    component: __WEBPACK_IMPORTED_MODULE_36__components_ProviderDeductions__["a" /* default */]
  }, {
    path: '/provider/:id/print-placard',
    name: 'ProviderPrintPlacard',
    component: __WEBPACK_IMPORTED_MODULE_38__components_Provider_PrintPlacard__["a" /* default */]
  }, {
    path: '/providers',
    name: 'ProviderList',
    component: __WEBPACK_IMPORTED_MODULE_35__components_Provider_List__["a" /* default */]
  }, {
    path: '/reservation/:id',
    name: 'RsvpDetails',
    component: __WEBPACK_IMPORTED_MODULE_39__components_RsvpDetails_index2__["a" /* default */]
  }, {
    path: '/reports',
    name: 'Reports',
    component: __WEBPACK_IMPORTED_MODULE_27__components_Reports__["a" /* default */]
  }, {
    path: '/import-rsvp',
    name: 'ImportRsvp',
    component: __WEBPACK_IMPORTED_MODULE_28__components_ImportRsvp__["a" /* default */]
  }, {
    path: '/transactions',
    name: 'Transactions',
    component: __WEBPACK_IMPORTED_MODULE_40__components_Transactions__["a" /* default */]
  }, {
    path: '/ads',
    name: 'MarketingAds',
    component: __WEBPACK_IMPORTED_MODULE_45__components_MarketingAds__["a" /* default */]
  }, {
    path: '/ads/:id',
    name: 'AdDetails',
    component: __WEBPACK_IMPORTED_MODULE_46__components_MarketingAds_AdDetails__["a" /* default */]
  }, {
    path: '/filters',
    name: 'Filters',
    component: __WEBPACK_IMPORTED_MODULE_47__components_Filters__["a" /* default */]
  }, {
    path: '/filter/:id',
    name: 'FilterDetails',
    component: __WEBPACK_IMPORTED_MODULE_48__components_Filters_FilterDetails__["a" /* default */]
  }, {
    path: '/settings',
    name: 'Settings',
    component: __WEBPACK_IMPORTED_MODULE_49__components_Settings__["a" /* default */]
  }, {
    path: '/coverage',
    name: 'Coverage',
    component: __WEBPACK_IMPORTED_MODULE_50__components_Coverage__["a" /* default */]
  }, {
    path: '/pricing',
    name: 'Pricing',
    component: __WEBPACK_IMPORTED_MODULE_29__components_Pricing__["a" /* default */]
  }, {
    path: '/services',
    name: 'Services',
    component: __WEBPACK_IMPORTED_MODULE_30__components_Services__["a" /* default */]
  }, {
    path: '/services/:brandId/:serviceId',
    name: 'ServicesDetails',
    component: __WEBPACK_IMPORTED_MODULE_30__components_Services__["a" /* default */]
  }, {
    path: '/runs',
    name: 'Runs',
    component: __WEBPACK_IMPORTED_MODULE_52__components_Runs__["a" /* default */]
  }, {
    path: '/discount-codes',
    name: 'Discount Codes',
    component: __WEBPACK_IMPORTED_MODULE_55__components_DiscountCodes__["a" /* default */]
  }, {
    path: '/discount-codes/:id',
    name: 'Discount Codes Details',
    component: __WEBPACK_IMPORTED_MODULE_56__components_DiscountCodes_Details__["a" /* default */]
  }, {
    path: '/airtag',
    name: 'Airtag',
    component: __WEBPACK_IMPORTED_MODULE_59__components_Airtag__["a" /* default */]
  }, {
    path: '/insurance',
    name: 'Insurance',
    component: __WEBPACK_IMPORTED_MODULE_60__components_Insurance__["a" /* default */]
  }, {
    path: '/code',
    name: 'AdminCode',
    component: __WEBPACK_IMPORTED_MODULE_61__components_AdminCode__["a" /* default */]
  }, {
    path: '/xxquotation',
    name: 'Quotation',
    component: __WEBPACK_IMPORTED_MODULE_57__components_Quotation__["a" /* default */]
  }, {
    path: '/xxlogs',
    name: 'Logs',
    component: __WEBPACK_IMPORTED_MODULE_53__components_devlogs__["a" /* default */]
  }, {
    path: '/xxxlogs',
    name: 'AutoDispatchLogs',
    component: __WEBPACK_IMPORTED_MODULE_54__components_devlogs_auto_dispatch__["a" /* default */]
  }, {
    path: '/style-guide',
    name: 'StyleGuide',
    component: __WEBPACK_IMPORTED_MODULE_11__components_App_StyleGuide__["a" /* default */]
  }, {
    path: '/test',
    name: 'test',
    component: __WEBPACK_IMPORTED_MODULE_12__components_TestUpload__["a" /* default */]
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.name === null) {
    next('/thispagedoesnotexist');
    return;
  }
  if (to.name === 'Login') {
    if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.session.user.id !== null) {
      next('/dispatch');
      return;
    }
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('sideMenu/hide');
    next();
    return;
  }

  if (to.name === 'PasswordReset') {
    if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.session.user.id !== null) {
      next('/reset');
      return;
    }
    next();
    return;
  }

  if (to.name === 'PasswordResetDriver') {
    if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.session.user.id !== null) {
      next('/reset-driver');
      return;
    }
    next();
    return;
  }

  if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.session.user.id === null) {
    // check session token
    var sessionToken = router.app.$plugins.storage.getSessionToken();
    if (sessionToken === null) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('sideMenu/hide');
      next('/login');
      return;
    }

    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('session/showLoader');
    router.app.$sdk.get('/admin/auth', {
      token: sessionToken
    }, function (r) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('session/hideLoader');
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('sideMenu/hide');
      if (r.error) {
        router.app.$plugins.storage.removeSessionToken();
        next('/login');
        return;
      }
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('session/setUser', {
        id: r.id,
        firstName: r.firstName,
        lastName: r.lastName,
        phone: r.phone,
        email: r.email,
        photoUrl: r.avatarUrl === null ? 'https://s3-us-west-2.amazonaws.com/staging-backoffice/staging/default-user.jpg' : r.avatarUrl,
        access: r.access.permissions,
        accessLoad: false
      });
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('session/setSessionToken', sessionToken);
      router.app.$plugins.storage.setSessionToken(sessionToken);
      router.app.$plugins.fcm.start(router.app);

      // get RSVP filters
      if (to.name === 'Dispatch') {
        __WEBPACK_IMPORTED_MODULE_4__modules_api_dispatch_reservations__["a" /* default */].initDispatchReservations(router.app);
      }
      if (['Dispatch', 'Routing'].indexOf(to.name) > -1) {
        __WEBPACK_IMPORTED_MODULE_5__modules_api_routing_reservations__["a" /* default */].initRoutingReservations(router.app);
      }
      __WEBPACK_IMPORTED_MODULE_3__modules_api_admin__["a" /* default */].getAdminList(router.app);
      next();
    });

    return;
  }

  if (to.name === 'Dispatch' && !router.app.$store.state.reservation.reservationFilters.length) {
    __WEBPACK_IMPORTED_MODULE_4__modules_api_dispatch_reservations__["a" /* default */].initDispatchReservations(router.app);
  }
  if (['Dispatch', 'Routing'].indexOf(to.name) > -1 && !router.app.$store.state.routing.reservationFilters.length) {
    __WEBPACK_IMPORTED_MODULE_5__modules_api_routing_reservations__["a" /* default */].initRoutingReservations(router.app);
  }

  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('sideMenu/hide');
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
  * vue-router v3.5.3
  * (c) 2021 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (!condition) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
    .replace(encodeReserveRE, encodeReserveReplacer)
    .replace(commaRE, ','); };

function decode (str) {
  try {
    return decodeURIComponent(str)
  } catch (err) {
    if (false) {
      warn(false, ("Error decoding \"" + str + "\". Leaving it intact."));
    }
  }
  return str
}

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    var value = extraQuery[key];
    parsedQuery[key] = Array.isArray(value)
      ? value.map(castQueryParamValue)
      : castQueryParamValue(value);
  }
  return parsedQuery
}

var castQueryParamValue = function (value) { return (value == null || typeof value === 'object' ? value : String(value)); };

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0 ? decode(parts.join('=')) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj
    ? Object.keys(obj)
      .map(function (key) {
        var val = obj[key];

        if (val === undefined) {
          return ''
        }

        if (val === null) {
          return encode(key)
        }

        if (Array.isArray(val)) {
          var result = [];
          val.forEach(function (val2) {
            if (val2 === undefined) {
              return
            }
            if (val2 === null) {
              result.push(encode(key));
            } else {
              result.push(encode(key) + '=' + encode(val2));
            }
          });
          return result.join('&')
        }

        return encode(key) + '=' + encode(val)
      })
      .filter(function (x) { return x.length > 0; })
      .join('&')
    : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b, onlyPath) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') && (onlyPath ||
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query))
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      (onlyPath || (
        a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params))
      )
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a).sort();
  var bKeys = Object.keys(b).sort();
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key, i) {
    var aVal = a[key];
    var bKey = bKeys[i];
    if (bKey !== key) { return false }
    var bVal = b[key];
    // query values can be null and undefined
    if (aVal == null || bVal == null) { return aVal === bVal }
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

function handleRouteEntered (route) {
  for (var i = 0; i < route.matched.length; i++) {
    var record = route.matched[i];
    for (var name in record.instances) {
      var instance = record.instances[name];
      var cbs = record.enteredCbs[name];
      if (!instance || !cbs) { continue }
      delete record.enteredCbs[name];
      for (var i$1 = 0; i$1 < cbs.length; i$1++) {
        if (!instance._isBeingDestroyed) { cbs[i$1](instance); }
      }
    }
  }
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode ? parent.$vnode.data : {};
      if (vnodeData.routerView) {
        depth++;
      }
      if (vnodeData.keepAlive && parent._directInactive && parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      var cachedData = cache[name];
      var cachedComponent = cachedData && cachedData.component;
      if (cachedComponent) {
        // #2301
        // pass props
        if (cachedData.configProps) {
          fillPropsinData(cachedComponent, data, cachedData.route, cachedData.configProps);
        }
        return h(cachedComponent, data, children)
      } else {
        // render previous empty view
        return h()
      }
    }

    var matched = route.matched[depth];
    var component = matched && matched.components[name];

    // render empty node if no matched route or no config component
    if (!matched || !component) {
      cache[name] = null;
      return h()
    }

    // cache component
    cache[name] = { component: component };

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive &&
        vnode.componentInstance &&
        vnode.componentInstance !== matched.instances[name]
      ) {
        matched.instances[name] = vnode.componentInstance;
      }

      // if the route transition has already been confirmed then we weren't
      // able to call the cbs during confirmation as the component was not
      // registered yet, so we call it here.
      handleRouteEntered(route);
    };

    var configProps = matched.props && matched.props[name];
    // save route and configProps in cache
    if (configProps) {
      extend(cache[name], {
        route: route,
        configProps: configProps
      });
      fillPropsinData(component, data, route, configProps);
    }

    return h(component, data, children)
  }
};

function fillPropsinData (component, data, route, configProps) {
  // resolve props
  var propsToPass = data.props = resolveProps(route, configProps);
  if (propsToPass) {
    // clone to prevent mutation
    propsToPass = data.props = extend({}, propsToPass);
    // pass non-declared props as attrs
    var attrs = data.attrs = data.attrs || {};
    for (var key in propsToPass) {
      if (!component.props || !(key in component.props)) {
        attrs[key] = propsToPass[key];
        delete propsToPass[key];
      }
    }
  }
}

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/+/g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  params = params || {};
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    // and fix #3106 so that you can work with location descriptor object having params.pathMatch equal to empty string
    if (typeof params.pathMatch === 'string') { params[0] = params.pathMatch; }

    return filler(params, { pretty: true })
  } catch (e) {
    if (false) {
      // Fix #3072 no warn if `pathMatch` is string
      warn(typeof params.pathMatch === 'string', ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next
  } else if (next.name) {
    next = extend({}, raw);
    var params = next.params;
    if (params && typeof params === 'object') {
      next.params = extend({}, params);
    }
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params$1 = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params$1;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params$1, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var noop = function () {};

var warnedCustomSlot;
var warnedTagProp;
var warnedEventProp;

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    custom: Boolean,
    exact: Boolean,
    exactPath: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    ariaCurrentValue: {
      type: String,
      default: 'page'
    },
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(
      this.to,
      current,
      this.append
    );
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback =
      globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback =
      globalExactActiveClass == null
        ? 'router-link-exact-active'
        : globalExactActiveClass;
    var activeClass =
      this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass =
      this.exactActiveClass == null
        ? exactActiveClassFallback
        : this.exactActiveClass;

    var compareTarget = route.redirectedFrom
      ? createRoute(null, normalizeLocation(route.redirectedFrom), null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget, this.exactPath);
    classes[activeClass] = this.exact || this.exactPath
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var ariaCurrentValue = classes[exactActiveClass] ? this.ariaCurrentValue : null;

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location, noop);
        } else {
          router.push(location, noop);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = { class: classes };

    var scopedSlot =
      !this.$scopedSlots.$hasNormal &&
      this.$scopedSlots.default &&
      this.$scopedSlots.default({
        href: href,
        route: route,
        navigate: handler,
        isActive: classes[activeClass],
        isExactActive: classes[exactActiveClass]
      });

    if (scopedSlot) {
      if (false) {
        !warnedCustomSlot && warn(false, 'In Vue Router 4, the v-slot API will by default wrap its content with an <a> element. Use the custom prop to remove this warning:\n<router-link v-slot="{ navigate, href }" custom></router-link>\n');
        warnedCustomSlot = true;
      }
      if (scopedSlot.length === 1) {
        return scopedSlot[0]
      } else if (scopedSlot.length > 1 || !scopedSlot.length) {
        if (false) {
          warn(
            false,
            ("<router-link> with to=\"" + (this.to) + "\" is trying to use a scoped slot but it didn't provide exactly one child. Wrapping the content with a span element.")
          );
        }
        return scopedSlot.length === 0 ? h() : h('span', {}, scopedSlot)
      }
    }

    if (false) {
      if ('tag' in this.$options.propsData && !warnedTagProp) {
        warn(
          false,
          "<router-link>'s tag prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedTagProp = true;
      }
      if ('event' in this.$options.propsData && !warnedEventProp) {
        warn(
          false,
          "<router-link>'s event prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedEventProp = true;
      }
    }

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href, 'aria-current': ariaCurrentValue };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = (a.data = extend({}, a.data));
        aData.on = aData.on || {};
        // transform existing events in both objects into arrays so we can push later
        for (var event in aData.on) {
          var handler$1 = aData.on[event];
          if (event in on) {
            aData.on[event] = Array.isArray(handler$1) ? handler$1 : [handler$1];
          }
        }
        // append new listeners for router-link
        for (var event$1 in on) {
          if (event$1 in aData.on) {
            // on[event] is always a function
            aData.on[event$1].push(on[event$1]);
          } else {
            aData.on[event$1] = handler;
          }
        }

        var aAttrs = (a.data.attrs = extend({}, a.data.attrs));
        aAttrs.href = href;
        aAttrs['aria-current'] = ariaCurrentValue;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap,
  parentRoute
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route, parentRoute);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  if (false) {
    // warn if routes do not include leading slashes
    var found = pathList
    // check for missing leading slash
      .filter(function (path) { return path && path.charAt(0) !== '*' && path.charAt(0) !== '/'; });

    if (found.length > 0) {
      var pathNames = found.map(function (path) { return ("- " + path); }).join('\n');
      warn(false, ("Non-nested routes must include a leading slash character. Fix the following routes: \n" + pathNames));
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(
        path || name
      )) + " cannot be a " + "string id. Use an actual component instead."
    );

    warn(
      // eslint-disable-next-line no-control-regex
      !/[^\u0000-\u007F]+/.test(path),
      "Route with path \"" + path + "\" contains unencoded characters, make sure " +
        "your path is correctly encoded before passing it to the router. Use " +
        "encodeURI to encode static segments of your path."
    );
  }

  var pathToRegexpOptions =
    route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    alias: route.alias
      ? typeof route.alias === 'string'
        ? [route.alias]
        : route.alias
      : [],
    instances: {},
    enteredCbs: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props:
      route.props == null
        ? {}
        : route.components
          ? route.props
          : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (
        route.name &&
        !route.redirect &&
        route.children.some(function (child) { return /^\/?$/.test(child.path); })
      ) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
            "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
            "the default child route will not be rendered. Remove the name from " +
            "this route and use the name of the default child route for named " +
            "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if (false) {
        warn(
          false,
          ("Found an alias with the same value as the path: \"" + path + "\". You have to remove that alias. It will be ignored in development.")
        );
        // skip in dev to make it work
        continue
      }

      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    }
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
          "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (
  path,
  pathToRegexpOptions
) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(
        !keys[key.name],
        ("Duplicate param keys in route with path: \"" + path + "\"")
      );
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (
  path,
  parent,
  strict
) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function addRoute (parentOrRoute, route) {
    var parent = (typeof parentOrRoute !== 'object') ? nameMap[parentOrRoute] : undefined;
    // $flow-disable-line
    createRouteMap([route || parentOrRoute], pathList, pathMap, nameMap, parent);

    // add aliases of parent
    if (parent && parent.alias.length) {
      createRouteMap(
        // $flow-disable-line route is defined if parent is
        parent.alias.map(function (alias) { return ({ path: alias, children: [route] }); }),
        pathList,
        pathMap,
        nameMap,
        parent
      );
    }
  }

  function getRoutes () {
    return pathList.map(function (path) { return pathMap[path]; })
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
      return _createRoute(record, location, redirectedFrom)
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoute: addRoute,
    getRoutes: getRoutes,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = typeof m[i] === 'string' ? decode(m[i]) : m[i];
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

// use User Timing api (if present) for more accurate key precision
var Time =
  inBrowser && window.performance && window.performance.now
    ? window.performance
    : Date;

function genStateKey () {
  return Time.now().toFixed(3)
}

var _key = genStateKey();

function getStateKey () {
  return _key
}

function setStateKey (key) {
  return (_key = key)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Prevent browser scroll behavior on History popstate
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  // preserve existing history state as it could be overriden by the user
  var stateCopy = extend({}, window.history.state);
  stateCopy.key = getStateKey();
  window.history.replaceState(stateCopy, '', absolutePath);
  window.addEventListener('popstate', handlePopState);
  return function () {
    window.removeEventListener('popstate', handlePopState);
  }
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(
      router,
      to,
      from,
      isPop ? position : null
    );

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll
        .then(function (shouldScroll) {
          scrollToPosition((shouldScroll), position);
        })
        .catch(function (err) {
          if (false) {
            assert(false, err.toString());
          }
        });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function handlePopState (e) {
  saveScrollPosition();
  if (e.state && e.state.key) {
    setStateKey(e.state.key);
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

var hashStartsWithNumberRE = /^#\d/;

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    // getElementById would still fail if the selector contains a more complicated query like #main[data-attr]
    // but at the same time, it doesn't make much sense to select an element with an id and an extra selector
    var el = hashStartsWithNumberRE.test(shouldScroll.selector) // $flow-disable-line
      ? document.getElementById(shouldScroll.selector.slice(1)) // $flow-disable-line
      : document.querySelector(shouldScroll.selector);

    if (el) {
      var offset =
        shouldScroll.offset && typeof shouldScroll.offset === 'object'
          ? shouldScroll.offset
          : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    // $flow-disable-line
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({
        left: position.x,
        top: position.y,
        // $flow-disable-line
        behavior: shouldScroll.behavior
      });
    } else {
      window.scrollTo(position.x, position.y);
    }
  }
}

/*  */

var supportsPushState =
  inBrowser &&
  (function () {
    var ua = window.navigator.userAgent;

    if (
      (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
      ua.indexOf('Mobile Safari') !== -1 &&
      ua.indexOf('Chrome') === -1 &&
      ua.indexOf('Windows Phone') === -1
    ) {
      return false
    }

    return window.history && typeof window.history.pushState === 'function'
  })();

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      // preserve existing history state as it could be overriden by the user
      var stateCopy = extend({}, history.state);
      stateCopy.key = getStateKey();
      history.replaceState(stateCopy, '', url);
    } else {
      history.pushState({ key: setStateKey(genStateKey()) }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

// When changing thing, also edit router.d.ts
var NavigationFailureType = {
  redirected: 2,
  aborted: 4,
  cancelled: 8,
  duplicated: 16
};

function createNavigationRedirectedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.redirected,
    ("Redirected when going from \"" + (from.fullPath) + "\" to \"" + (stringifyRoute(
      to
    )) + "\" via a navigation guard.")
  )
}

function createNavigationDuplicatedError (from, to) {
  var error = createRouterError(
    from,
    to,
    NavigationFailureType.duplicated,
    ("Avoided redundant navigation to current location: \"" + (from.fullPath) + "\".")
  );
  // backwards compatible with the first introduction of Errors
  error.name = 'NavigationDuplicated';
  return error
}

function createNavigationCancelledError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.cancelled,
    ("Navigation cancelled from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" with a new navigation.")
  )
}

function createNavigationAbortedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.aborted,
    ("Navigation aborted from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" via a navigation guard.")
  )
}

function createRouterError (from, to, type, message) {
  var error = new Error(message);
  error._isRouter = true;
  error.from = from;
  error.to = to;
  error.type = type;

  return error
}

var propertiesToLog = ['params', 'query', 'hash'];

function stringifyRoute (to) {
  if (typeof to === 'string') { return to }
  if ('path' in to) { return to.path }
  var location = {};
  propertiesToLog.forEach(function (key) {
    if (key in to) { location[key] = to[key]; }
  });
  return JSON.stringify(location, null, 2)
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function isNavigationFailure (err, errorType) {
  return (
    isError(err) &&
    err._isRouter &&
    (errorType == null || err.type === errorType)
  )
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
  this.listeners = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (
  location,
  onComplete,
  onAbort
) {
    var this$1 = this;

  var route;
  // catch redirect option https://github.com/vuejs/vue-router/issues/3201
  try {
    route = this.router.match(location, this.current);
  } catch (e) {
    this.errorCbs.forEach(function (cb) {
      cb(e);
    });
    // Exception should still be thrown
    throw e
  }
  var prev = this.current;
  this.confirmTransition(
    route,
    function () {
      this$1.updateRoute(route);
      onComplete && onComplete(route);
      this$1.ensureURL();
      this$1.router.afterHooks.forEach(function (hook) {
        hook && hook(route, prev);
      });

      // fire ready cbs once
      if (!this$1.ready) {
        this$1.ready = true;
        this$1.readyCbs.forEach(function (cb) {
          cb(route);
        });
      }
    },
    function (err) {
      if (onAbort) {
        onAbort(err);
      }
      if (err && !this$1.ready) {
        // Initial redirection should not mark the history as ready yet
        // because it's triggered by the redirection instead
        // https://github.com/vuejs/vue-router/issues/3225
        // https://github.com/vuejs/vue-router/issues/3331
        if (!isNavigationFailure(err, NavigationFailureType.redirected) || prev !== START) {
          this$1.ready = true;
          this$1.readyErrorCbs.forEach(function (cb) {
            cb(err);
          });
        }
      }
    }
  );
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  this.pending = route;
  var abort = function (err) {
    // changed after adding errors with
    // https://github.com/vuejs/vue-router/pull/3047 before that change,
    // redirect and aborted navigation would produce an err == null
    if (!isNavigationFailure(err) && isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        if (false) {
          warn(false, 'uncaught error during route navigation:');
        }
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  var lastRouteIndex = route.matched.length - 1;
  var lastCurrentIndex = current.matched.length - 1;
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    lastRouteIndex === lastCurrentIndex &&
    route.matched[lastRouteIndex] === current.matched[lastCurrentIndex]
  ) {
    this.ensureURL();
    if (route.hash) {
      handleScroll(this.router, current, route, false);
    }
    return abort(createNavigationDuplicatedError(current, route))
  }

  var ref = resolveQueue(
    this.current.matched,
    route.matched
  );
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort(createNavigationCancelledError(current, route))
    }
    try {
      hook(route, current, function (to) {
        if (to === false) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(createNavigationAbortedError(current, route));
        } else if (isError(to)) {
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' &&
            (typeof to.path === 'string' || typeof to.name === 'string'))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort(createNavigationRedirectedError(current, route));
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort(createNavigationCancelledError(current, route))
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          handleRouteEntered(route);
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  this.current = route;
  this.cb && this.cb(route);
};

History.prototype.setupListeners = function setupListeners () {
  // Default implementation is empty
};

History.prototype.teardown = function teardown () {
  // clean up event listeners
  // https://github.com/vuejs/vue-router/issues/2341
  this.listeners.forEach(function (cleanupListener) {
    cleanupListener();
  });
  this.listeners = [];

  // reset current history route
  // https://github.com/vuejs/vue-router/issues/3294
  this.current = START;
  this.pending = null;
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated
) {
  return extractGuards(
    activated,
    'beforeRouteEnter',
    function (guard, _, match, key) {
      return bindEnterGuard(guard, match, key)
    }
  )
}

function bindEnterGuard (
  guard,
  match,
  key
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        if (!match.enteredCbs[key]) {
          match.enteredCbs[key] = [];
        }
        match.enteredCbs[key].push(cb);
      }
      next(cb);
    })
  }
}

/*  */

var HTML5History = /*@__PURE__*/(function (History) {
  function HTML5History (router, base) {
    History.call(this, router, base);

    this._startLocation = getLocation(this.base);
  }

  if ( History ) HTML5History.__proto__ = History;
  HTML5History.prototype = Object.create( History && History.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === this$1._startLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    };
    window.addEventListener('popstate', handleRoutingEvent);
    this.listeners.push(function () {
      window.removeEventListener('popstate', handleRoutingEvent);
    });
  };

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  var pathLowerCase = path.toLowerCase();
  var baseLowerCase = base.toLowerCase();
  // base="/a" shouldn't turn path="/app" into "/a/pp"
  // https://github.com/vuejs/vue-router/issues/3555
  // so we ensure the trailing slash in the base
  if (base && ((pathLowerCase === baseLowerCase) ||
    (pathLowerCase.indexOf(cleanPath(baseLowerCase + '/')) === 0))) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = /*@__PURE__*/(function (History) {
  function HashHistory (router, base, fallback) {
    History.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History ) HashHistory.__proto__ = History;
  HashHistory.prototype = Object.create( History && History.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    };
    var eventType = supportsPushState ? 'popstate' : 'hashchange';
    window.addEventListener(
      eventType,
      handleRoutingEvent
    );
    this.listeners.push(function () {
      window.removeEventListener(eventType, handleRoutingEvent);
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        pushHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        replaceHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) { return '' }

  href = href.slice(index + 1);

  return href
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/(function (History) {
  function AbstractHistory (router, base) {
    History.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History ) AbstractHistory.__proto__ = History;
  AbstractHistory.prototype = Object.create( History && History.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
        this$1.index++;
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(
      route,
      function () {
        var prev = this$1.current;
        this$1.index = targetIndex;
        this$1.updateRoute(route);
        this$1.router.afterHooks.forEach(function (hook) {
          hook && hook(route, prev);
        });
      },
      function (err) {
        if (isNavigationFailure(err, NavigationFailureType.duplicated)) {
          this$1.index = targetIndex;
        }
      }
    );
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  if (false) {
    warn(this instanceof VueRouter, "Router must be called with the new operator.");
  }
  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback =
    mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (raw, current, redirectedFrom) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' &&
    assert(
      install.installed,
      "not installed. Make sure to call `Vue.use(VueRouter)` " +
        "before creating root instance."
    );

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1.apps.indexOf(app);
    if (index > -1) { this$1.apps.splice(index, 1); }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1.app === app) { this$1.app = this$1.apps[0] || null; }

    if (!this$1.app) { this$1.history.teardown(); }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History || history instanceof HashHistory) {
    var handleInitialScroll = function (routeOrError) {
      var from = history.current;
      var expectScroll = this$1.options.scrollBehavior;
      var supportsScroll = supportsPushState && expectScroll;

      if (supportsScroll && 'fullPath' in routeOrError) {
        handleScroll(this$1, routeOrError, from, false);
      }
    };
    var setupListeners = function (routeOrError) {
      history.setupListeners();
      handleInitialScroll(routeOrError);
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupListeners,
      setupListeners
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.push(location, resolve, reject);
    })
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.replace(location, resolve, reject);
    })
  } else {
    this.history.replace(location, onComplete, onAbort);
  }
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply(
    [],
    route.matched.map(function (m) {
      return Object.keys(m.components).map(function (key) {
        return m.components[key]
      })
    })
  )
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  current = current || this.history.current;
  var location = normalizeLocation(to, current, append, this);
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.getRoutes = function getRoutes () {
  return this.matcher.getRoutes()
};

VueRouter.prototype.addRoute = function addRoute (parentOrRoute, route) {
  this.matcher.addRoute(parentOrRoute, route);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  if (false) {
    warn(false, 'router.addRoutes() is deprecated and has been removed in Vue Router 4. Use router.addRoute() instead.');
  }
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.5.3';
VueRouter.isNavigationFailure = isNavigationFailure;
VueRouter.NavigationFailureType = NavigationFailureType;
VueRouter.START_LOCATION = START;

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export Store */
/* unused harmony export createLogger */
/* unused harmony export createNamespacedHelpers */
/* unused harmony export install */
/* unused harmony export mapActions */
/* unused harmony export mapGetters */
/* unused harmony export mapMutations */
/* unused harmony export mapState */
/*!
 * vuex v3.6.2
 * (c) 2021 Evan You
 * @license MIT
 */
function applyMixin (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
    ? global
    : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  }, { prepend: true });

  store.subscribeAction(function (action, state) {
    devtoolHook.emit('vuex:action', action, state);
  }, { prepend: true });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find (list, f) {
  return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
function deepCopy (obj, cache) {
  if ( cache === void 0 ) cache = [];

  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  var hit = find(cache, function (c) { return c.original === obj; });
  if (hit) {
    return hit.copy
  }

  var copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy: copy
  });

  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy
}

/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

function partial (fn, arg) {
  return function () {
    return fn(arg)
  }
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.hasChild = function hasChild (key) {
  return key in this._children
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if ((false)) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  var child = parent.getChild(key);

  if (!child) {
    if ((false)) {
      console.warn(
        "[vuex] trying to unregister module '" + key + "', which is " +
        "not registered"
      );
    }
    return
  }

  if (!child.runtime) {
    return
  }

  parent.removeChild(key);
};

ModuleCollection.prototype.isRegistered = function isRegistered (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];

  if (parent) {
    return parent.hasChild(key)
  }

  return false
};

function update (path, targetModule, newModule) {
  if ((false)) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if ((false)) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if ((false)) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();
  this._makeLocalGettersCache = Object.create(null);

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors$1.state.set = function (v) {
  if ((false)) {
    assert(false, "use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if ((false)) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });

  this._subscribers
    .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if ((false)) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  try {
    this._actionSubscribers
      .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
      .filter(function (sub) { return sub.before; })
      .forEach(function (sub) { return sub.before(action, this$1.state); });
  } catch (e) {
    if ((false)) {
      console.warn("[vuex] error in before action subscribers: ");
      console.error(e);
    }
  }

  var result = entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload);

  return new Promise(function (resolve, reject) {
    result.then(function (res) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.after; })
          .forEach(function (sub) { return sub.after(action, this$1.state); });
      } catch (e) {
        if ((false)) {
          console.warn("[vuex] error in after action subscribers: ");
          console.error(e);
        }
      }
      resolve(res);
    }, function (error) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.error; })
          .forEach(function (sub) { return sub.error(action, this$1.state, error); });
      } catch (e) {
        if ((false)) {
          console.warn("[vuex] error in error action subscribers: ");
          console.error(e);
        }
      }
      reject(error);
    });
  })
};

Store.prototype.subscribe = function subscribe (fn, options) {
  return genericSubscribe(fn, this._subscribers, options)
};

Store.prototype.subscribeAction = function subscribeAction (fn, options) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers, options)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if ((false)) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if ((false)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if ((false)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hasModule = function hasModule (path) {
  if (typeof path === 'string') { path = [path]; }

  if ((false)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  return this._modules.isRegistered(path)
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors$1 );

function genericSubscribe (fn, subs, options) {
  if (subs.indexOf(fn) < 0) {
    options && options.prepend
      ? subs.unshift(fn)
      : subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  // reset local getters cache
  store._makeLocalGettersCache = Object.create(null);
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure environment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    if (store._modulesNamespaceMap[namespace] && ("production" !== 'production')) {
      console.error(("[vuex] duplicate namespace " + namespace + " for the namespaced module " + (path.join('/'))));
    }
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      if ((false)) {
        if (moduleName in parentState) {
          console.warn(
            ("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + (path.join('.')) + "\"")
          );
        }
      }
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  if (!store._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store.getters).forEach(function (type) {
      // skip if the target getter is not match this namespace
      if (type.slice(0, splitPos) !== namespace) { return }

      // extract local getter type
      var localType = type.slice(splitPos);

      // Add a port to the getters proxy.
      // Define as getter property because
      // we do not want to evaluate the getters in this time.
      Object.defineProperty(gettersProxy, localType, {
        get: function () { return store.getters[type]; },
        enumerable: true
      });
    });
    store._makeLocalGettersCache[namespace] = gettersProxy;
  }

  return store._makeLocalGettersCache[namespace]
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if ((false)) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if ((false)) {
      assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.reduce(function (state, key) { return state[key]; }, state)
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if ((false)) {
    assert(typeof type === 'string', ("expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if ((false)) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  if (false) {
    console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept another params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  if (false) {
    console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  if (false) {
    console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  if (false) {
    console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap (map) {
  if (!isValidMap(map)) {
    return []
  }
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */
function isValidMap (map) {
  return Array.isArray(map) || isObject(map)
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

// Credits: borrowed code from fcomb/redux-logger

function createLogger (ref) {
  if ( ref === void 0 ) ref = {};
  var collapsed = ref.collapsed; if ( collapsed === void 0 ) collapsed = true;
  var filter = ref.filter; if ( filter === void 0 ) filter = function (mutation, stateBefore, stateAfter) { return true; };
  var transformer = ref.transformer; if ( transformer === void 0 ) transformer = function (state) { return state; };
  var mutationTransformer = ref.mutationTransformer; if ( mutationTransformer === void 0 ) mutationTransformer = function (mut) { return mut; };
  var actionFilter = ref.actionFilter; if ( actionFilter === void 0 ) actionFilter = function (action, state) { return true; };
  var actionTransformer = ref.actionTransformer; if ( actionTransformer === void 0 ) actionTransformer = function (act) { return act; };
  var logMutations = ref.logMutations; if ( logMutations === void 0 ) logMutations = true;
  var logActions = ref.logActions; if ( logActions === void 0 ) logActions = true;
  var logger = ref.logger; if ( logger === void 0 ) logger = console;

  return function (store) {
    var prevState = deepCopy(store.state);

    if (typeof logger === 'undefined') {
      return
    }

    if (logMutations) {
      store.subscribe(function (mutation, state) {
        var nextState = deepCopy(state);

        if (filter(mutation, prevState, nextState)) {
          var formattedTime = getFormattedTime();
          var formattedMutation = mutationTransformer(mutation);
          var message = "mutation " + (mutation.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
          logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
          logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
          endMessage(logger);
        }

        prevState = nextState;
      });
    }

    if (logActions) {
      store.subscribeAction(function (action, state) {
        if (actionFilter(action, state)) {
          var formattedTime = getFormattedTime();
          var formattedAction = actionTransformer(action);
          var message = "action " + (action.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
          endMessage(logger);
        }
      });
    }
  }
}

function startMessage (logger, message, collapsed) {
  var startMessage = collapsed
    ? logger.groupCollapsed
    : logger.group;

  // render
  try {
    startMessage.call(logger, message);
  } catch (e) {
    logger.log(message);
  }
}

function endMessage (logger) {
  try {
    logger.groupEnd();
  } catch (e) {
    logger.log('—— log end ——');
  }
}

function getFormattedTime () {
  var time = new Date();
  return (" @ " + (pad(time.getHours(), 2)) + ":" + (pad(time.getMinutes(), 2)) + ":" + (pad(time.getSeconds(), 2)) + "." + (pad(time.getMilliseconds(), 3)))
}

function repeat (str, times) {
  return (new Array(times + 1)).join(str)
}

function pad (num, maxLength) {
  return repeat('0', maxLength - num.toString().length) + num
}

var index = {
  Store: Store,
  install: install,
  version: '3.6.2',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers,
  createLogger: createLogger
};

/* harmony default export */ __webpack_exports__["a"] = (index);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(22)))

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_SHARING_KEY = 'vuex-mutations-sharer';

exports.default = function (_ref) {
  var predicate = _ref.predicate,
      sharingKey = _ref.sharingKey;
  return function (store) {
    if (typeof window === 'undefined' || !window.localStorage) {
      console.error('[vuex-shared-mutations] localStorage is not available. Disabling plugin');
      return;
    }

    if (typeof predicate !== 'function' && !Array.isArray(predicate)) {
      console.error('[vuex-shared-mutations] Predicate should be either array of mutation names or function. Disabling plugin');
      return;
    }

    try {
      window.localStorage.setItem('vuex-mutations-sharer__test', 'test');
      window.localStorage.removeItem('vuex-mutations-sharer__test');
    } catch (e) {
      console.error('[vuex-shared-mutations] Unable to use setItem on localStorage. Disabling plugin');
      return;
    }

    var committing = false;
    var key = sharingKey || DEFAULT_SHARING_KEY;

    var shouldShare = typeof predicate === 'function' ? predicate : function (mutation) {
      return predicate.indexOf(mutation.type) !== -1;
    };

    store.subscribe(function (mutation, state) {
      if (committing) return;
      if (shouldShare(mutation, state)) {
        try {
          window.localStorage.setItem(key, JSON.stringify(mutation));
          window.localStorage.removeItem(key);
        } catch (e) {
          console.error('[vuex-shared-mutations] Unable to use setItem on localStorage');
          console.error(e);
        }
      }
    });

    window.addEventListener('storage', function (event) {
      if (event.newValue === null) return;
      if (event.key !== key) return;

      try {
        var mutation = JSON.parse(event.newValue);
        committing = true;
        store.commit(mutation.type, mutation.payload);
      } catch (error) {
        console.error('[vuex-shared-mutations] Unable to parse shared mutation data');
        console.error(event.newValue, error);
      } finally {
        committing = false;
      }
    });
  };
};

module.exports = exports['default'];


/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__admin__ = __webpack_require__(870);



/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__admin__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__admin__["a" /* default */].mutations)
});

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    list: [],
    search: "",
    order: "id",
    orderAsc: 1,
    currentPage: 1,
    perPage: 20,
    status: "active",
    loading: false,
    maxList: 0,
    showForm: false,
    edit: {},
    permissions: {},
    reportPermissions: {},
    addSuccess: false,
    accessList: {
      PageAdminDashboard: "Providers Page - View",
      PageAdminProviderEdit: "Providers Page - Edit",
      PageAdminProviderNum: "Providers Page - Vehicle No.",
      PageAdminConsumers: "Consumers Page",
      PageAdminCorporates: "Corporates Page",
      PageAdminTransactions: "Transactions Page",
      PageAdminImport: "Import RSVP",
      PageAdminPromocodes: "Promo Page",
      PageAdminRatings: "Ratings Page",
      PageAdminBids: "Bids Page",
      PageAdminAds: "Ads Page",
      PageAdminFleetReport: "Fleet Page",
      PageAdminLog: "Logs Page",
      PageAdminNotifications: "Notifications Page",
      PageAdminMap: "Map Page",
      PageAdminGeo: "Geofence Page",
      PageAdminPricing: "Pricing Page",
      PageAdminService: "Service Type Page",
      PageAdminSettings: "Settings Page",
      PageAdminStagingLot: "Staging Lot Page",
      PageAdminFilter: "Filter Page",
      PageAdminRSVP: "Reservation Details Page",
      PageAdminRSVPAdd: "Create Reservation",
      PageAdminRSVPEdit: "Edit Reservation",
      PageAdminRSVPWaivePayments: "Waive edit payments",
      PageAdminDispatch: "Dispatch Page",
      PageAdminLaxit: "Laxit Page",
      PageAdminRouting: "Routing Page",
      PageAdminBrands: "Brands Page",
      PageAdminNotes: "Add Notes",
      PageAdminRefund: "Transaction Refund",
      PageAdminPriceOverride: "Price Override",
      PageAdminOverride: "Driver Payment Bonus",
      PageAdminAdmins: "Admin Page",
      PageAdminReports: "Reports",
      PageAdminProviderDeductions: "Provider Deductions",
      PageAdminDriverBatchModifications: "Provider Payouts",
      PageAdminRsvpControl: 'RSVP Control (Complete/No Show)',
      PageAdminCode: 'Admin Code',
      PageAdminInsurance: 'Insurance Page',
      ForceDriverPaymentOverride: 'Force Driver Payment Override'
    },
    reportsList: {
      PageReportsTNCReportForLAWA: 'TNC Report for LAWA',
      PageReportsReservationReports: 'Reservation Reports',
      PageReportsTransactionReports: 'Transaction Reports',
      PageReportsDriverReviews: 'Driver Reviews',
      PageReportsSpecialReports: 'Special Reports',
      PageReportsDirectBill: 'Direct Bill',
      PageReportsPayoutReport: 'Payout Report',
      PageReportsBackendManager: 'Backend Manager',
      PageReportsMTech: 'MTech',
      PageReportsBlockReport: 'Block Report',
      PageReportsTNCReportLongBeach: 'TNC Report - Long Beach',
      PageReportsActiveDrivers: 'Active Drivers',
      PageReportsDriverCount: 'Driver Count',
      PageReportsLyftReport: 'Lyft Report'
    }
  },
  mutations: {
    setList: function setList(state, value) {
      state.list = value;
    },
    updateAdminActive: function updateAdminActive(state, data) {
      var index = state.list.findIndex(function (x) {
        return x.id === data.id;
      });
      if (index > -1) {
        state.list[index].isActive = data.isActive;
      }
    },
    setSearch: function setSearch(state, value) {
      state.search = value;
    },
    setOrder: function setOrder(state, value) {
      state.order = value;
    },
    setOrderAsc: function setOrderAsc(state, value) {
      state.setOrderAsc = value;
    },
    setCurrentPage: function setCurrentPage(state, value) {
      state.currentPage = value;
    },
    setPerPage: function setPerPage(state, value) {
      state.perPage = value;
    },
    setStatus: function setStatus(state, value) {
      state.status = value;
    },
    setLoading: function setLoading(state, value) {
      state.loading = value;
    },
    setMaxList: function setMaxList(state, value) {
      state.maxList = value;
    },
    updatePermission: function updatePermission(state, data) {
      if (data.add) {
        var backup = state.permissions;
        state.permissions = {};

        state.permissions = backup;
        state.permissions[data.field] = "view";
      } else {
        var _backup = state.permissions;
        state.permissions = {};

        state.permissions = _backup;
        if (state.permissions[data.field]) {
          delete state.permissions[data.field];
        }
      }
    },
    setShowForm: function setShowForm(state, value) {
      state.showForm = value;
    },
    setEdit: function setEdit(state, data) {
      state.permissions = {};
      state.permissions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, data.permission);

      state.reportPermissions = {};
      state.reportPermissions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, data.reportPermissions);

      state.edit = data;
    },
    setPermissions: function setPermissions(state, value) {
      state.permissions = value;
    },
    setAddSuccess: function setAddSuccess(state, value) {
      state.addSuccess = value;
    },
    updateReportPermission: function updateReportPermission(state, data) {
      if (data.add) {
        state.reportPermissions[data.field] = "view";
      } else {
        delete state.reportPermissions[data.field];
      }
    }
  }
});

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ad_details__ = __webpack_require__(872);



/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__ad_details__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__ad_details__["a" /* default */].mutations)
});

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    adItem: {
      original: {
        ID: null
      },
      edited: {
        ID: null
      }
    }
  },
  mutations: {
    setOriginalAdItem: function setOriginalAdItem(state, value) {
      state.adItem.original = value;
    },
    setEditedAdItem: function setEditedAdItem(state, value) {
      state.adItem.edited = value;
    },
    setEditedTooltipImage: function setEditedTooltipImage(state, value) {
      state.adItem.edited.tooltipImage = value;
    },
    setEditedTooltipTitle: function setEditedTooltipTitle(state, value) {
      state.adItem.edited.tooltipTitle = value;
    },
    setEditedTooltipDescription: function setEditedTooltipDescription(state, value) {
      state.adItem.edited.tooltipDescription = value;
    },
    setEditedMainImage: function setEditedMainImage(state, value) {
      state.adItem.edited.mainImage = value;
    },
    setEditedMainHeader: function setEditedMainHeader(state, value) {
      state.adItem.edited.mainHeader = value;
    },
    setEditedMainTitle: function setEditedMainTitle(state, value) {
      state.adItem.edited.mainTitle = value;
    },
    setEditedMainBody: function setEditedMainBody(state, value) {
      state.adItem.edited.mainBody = value;
    },
    setEditedCtaText: function setEditedCtaText(state, value) {
      state.adItem.edited.ctaText = value;
    },
    setEditedCtaLink: function setEditedCtaLink(state, value) {
      state.adItem.edited.ctaLink = value;
    },
    setEditedBrandId: function setEditedBrandId(state, value) {
      state.adItem.edited.brandId = value;
    },
    setEditedStartDate: function setEditedStartDate(state, value) {
      state.adItem.edited.startDate = value;
    },
    setEditedEndDate: function setEditedEndDate(state, value) {
      state.adItem.edited.endDate = value;
    },
    setEditedType: function setEditedType(state, value) {
      state.adItem.edited.type = value;
    }
  }
});

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    list: {},
    flights: []
  },
  mutations: {
    addAirlines: function addAirlines(state, value) {
      state.list[value.id] = value.list;
    },
    addFlights: function addFlights(state, value) {
      state.flights = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    list: [],
    loading: false
  },
  mutations: {
    resetList: function resetList(state) {
      state.list = '';
    },
    setList: function setList(state, value) {
      state.list = value;
    },
    setLoading: function setLoading(state, value) {
      state.loading = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    list: [],
    loading: false,
    showBrandForm: false,
    order: 'name',
    orderAsc: 1,
    editBrands: {},
    webform: {
      list: [],
      loading: true,
      show: false,
      edit: {},
      rerender: 0,
      order: 'name',
      orderAsc: 1
    },
    serviceArea: {
      list: [],
      loading: false
    },
    charterEnabled: []
  },
  mutations: {
    setList: function setList(state, value) {
      state.list = value;
    },
    setLoading: function setLoading(state, value) {
      state.loading = value;
    },
    setShowBrandForm: function setShowBrandForm(state, value) {
      state.showBrandForm = value;
    },
    setBrandOrder: function setBrandOrder(state, value) {
      state.order = value;
    },
    setBrandOrderAsc: function setBrandOrderAsc(state, value) {
      state.orderAsc = value;
    },
    setEditBrands: function setEditBrands(state, value) {
      state.editBrands = value;
    },
    setWebformList: function setWebformList(state, value) {
      state.webform.list = value;
    },
    updatedWebform: function updatedWebform(state, data) {
      var index = state.webform.list.findIndex(function (x) {
        return x.id === data.id;
      });
      state.webform.list[index].geofencesIDs = data.geofencesIDs;
    },
    setWebformLoading: function setWebformLoading(state, value) {
      state.webform.loading = value;
    },
    setWebformShow: function setWebformShow(state, value) {
      state.webform.show = value;
    },
    setWebformEdit: function setWebformEdit(state, value) {
      state.webform.edit = value;
    },
    setWebformRerender: function setWebformRerender(state, value) {
      state.webform.rerender = value;
    },
    setServiceAreaList: function setServiceAreaList(state, value) {
      state.serviceArea.list = value;
    },
    seterviceAreaLoading: function seterviceAreaLoading(state, value) {
      state.serviceArea.loading = value;
    },
    setBrandData: function setBrandData(state, data) {
      for (var field in data) {
        state[field] = data[field];
      }
    }
  },
  sharedMutations: []
});

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__credit_cards__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__promo_codes__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ratings__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__referrals__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_info__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transactions__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reservations__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__country_select__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__logs__ = __webpack_require__(886);












var sharedMutations = [];
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_1__credit_cards__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_2__promo_codes__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_3__ratings__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_4__referrals__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_5__users__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_6__user_info__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_7__transactions__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_8__reservations__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_9__country_select__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_10__logs__["a" /* default */].sharedMutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__credit_cards__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_2__promo_codes__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_3__ratings__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_4__referrals__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_5__users__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_6__user_info__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_7__transactions__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_8__reservations__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_9__country_select__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_10__logs__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__credit_cards__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_2__promo_codes__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_3__ratings__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_4__referrals__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_5__users__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_6__user_info__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_7__transactions__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_8__reservations__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_9__country_select__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_10__logs__["a" /* default */].mutations),
  sharedMutations: sharedMutations
});

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    creditCards: {
      list: [],
      isMax: false,
      currentPage: 0,
      perPage: 20
    }
  },
  mutations: {
    resetCards: function resetCards(state) {
      state.creditCards.list = [];
    },
    addCards: function addCards(state, value) {
      state.creditCards.list.push(value);
    },
    setCardsIsMax: function setCardsIsMax(state, value) {
      state.creditCards.isMax = value;
    },
    setCardsCurrentPage: function setCardsCurrentPage(state, value) {
      state.creditCards.currentPage = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    promoCodes: {
      list: [],
      isMax: false,
      currentPage: 0,
      perPage: 20
    }
  },
  mutations: {
    resetPromoCodes: function resetPromoCodes(state) {
      state.promoCodes.list = [];
    },
    addPromoCodes: function addPromoCodes(state, value) {
      state.promoCodes.list.push(value);
    },
    setPromoCodesIsMax: function setPromoCodesIsMax(state, value) {
      state.promoCodes.isMax = value;
    },
    setPromoCodesCurrentPage: function setPromoCodesCurrentPage(state, value) {
      state.promoCodes.currentPage = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    ratings: {
      list: [],
      isMax: false,
      currentPage: 0,
      perPage: 20
    }
  },
  mutations: {
    resetRatings: function resetRatings(state, value) {
      state.ratings.list = [];
    },
    addRatings: function addRatings(state, value) {
      state.ratings.list.push(value);
    },
    setRatingsIsMax: function setRatingsIsMax(state, value) {
      state.ratings.isMax = value;
    },
    setRatingsCurrentPage: function setRatingsCurrentPage(state, value) {
      state.ratings.currentPage = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    referrals: {
      list: [],
      isMax: false,
      currentPage: 0,
      perPage: 20,
      total: 0
    }
  },
  mutations: {
    resetReferrals: function resetReferrals(state) {
      state.referrals.list = [];
    },
    addReferrals: function addReferrals(state, value) {
      state.referrals.list.push(value);
    },
    resetTotalReferrals: function resetTotalReferrals(state) {
      state.referrals.total = 0;
    },
    setTotalReferrals: function setTotalReferrals(state, value) {
      state.referrals.total = value;
    },
    setReferralsIsMax: function setReferralsIsMax(state, value) {
      state.referrals.isMax = value;
    },
    setReferralsCurrentPage: function setReferralsCurrentPage(state, value) {
      state.referrals.currentPage = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    users: {
      list: [],
      currentPage: 1,
      perPage: 20,
      isLoading: false,
      maxList: 0,
      order: 'created',
      orderAsc: 0,
      seach: ''
    }
  },
  mutations: {
    resetUsers: function resetUsers(state) {
      state.users.list = [];
    },
    addUser: function addUser(state, value) {
      state.users.list = value;
    },
    setUserMaxList: function setUserMaxList(state, value) {
      state.users.maxList = value;
    },
    setUserCurrentPage: function setUserCurrentPage(state, value) {
      state.users.currentPage = value;
    },
    setUserPerPage: function setUserPerPage(state, value) {
      state.users.perPage = value;
    },
    setUserOrder: function setUserOrder(state, value) {
      state.users.order = value;
    },
    setUserOrderAsc: function setUserOrderAsc(state, value) {
      state.users.orderAsc = value;
    },
    setUserIsLoading: function setUserIsLoading(state, value) {
      state.users.isLoading = value;
    },
    setUserSearch: function setUserSearch(state, value) {
      state.users.search = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    userInfo: {},
    formHasError: false,
    formLoading: false,
    formSave: {
      isDone: false,
      message: ''
    },
    triggerStatusUpdate: false,
    selectedStatus: 'activate'
  },
  mutations: {
    resetUserInfo: function resetUserInfo(state, value) {
      state.userInfo = {};
      state.formHasError = false;
      state.formLoading = false;
      state.formSave = {
        isDone: false,
        message: ''
      };
    },
    setuserInfo: function setuserInfo(state, value) {
      state.userInfo = value;
    },
    setuserActive: function setuserActive(state, value) {
      state.userInfo.enabled = value;
    },
    setFormHasError: function setFormHasError(state, value) {
      state.formHasError = value;
    },
    setFormLoading: function setFormLoading(state, value) {
      state.formLoading = value;
    },
    setFormSavingDone: function setFormSavingDone(state, value) {
      state.formSave.isDone = value;
    },
    setFormSaveMessage: function setFormSaveMessage(state, value) {
      state.formSave.message = value;
    },
    setTriggerStatusUpdate: function setTriggerStatusUpdate(state, value) {
      state.triggerStatusUpdate = value;
    },
    setSelectedStatus: function setSelectedStatus(state, value) {
      state.selectedStatus = value;
    },
    setuserInfoData: function setuserInfoData(state, data) {
      for (var field in data) {
        state.userInfo[field] = data[field];
      }
    }
  },
  sharedMutations: []
});

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    transactions: {
      list: [],
      isMax: false,
      currentPage: 1,
      perPage: 20,
      maxList: 0,
      search: '',
      status: '',
      date: 'withinDay',
      dateFrom: '',
      dateTo: '',
      sort: {
        order: 'created',
        isDesc: true
      },
      loading: false
    }
  },
  mutations: {
    resetTransactions: function resetTransactions(state) {
      state.transactions.list = [];
    },
    addTransactions: function addTransactions(state, value) {
      state.transactions.list.push(value);
    },
    setTransactionsIsMax: function setTransactionsIsMax(state, value) {
      state.transactions.isMax = value;
    },
    setTransactionsCurrentPage: function setTransactionsCurrentPage(state, value) {
      state.transactions.currentPage = value;
    },

    // setTransactionsFromTo (state, value) {
    //   state.transactions.from = value.from
    //   state.transactions.to = value.to
    // },
    resetFilters: function resetFilters(state, value) {
      state.transactions.search = '';
      state.transactions.status = '';
      state.transactions.date = 'withinDay';
      state.transactions.dateFrom = '';
      state.transactions.dateTo = '';
      state.transactions.loading = false;
    },
    setTrxSearch: function setTrxSearch(state, value) {
      state.transactions.search = value;
    },
    setTrxStatus: function setTrxStatus(state, value) {
      state.transactions.status = value;
    },
    setTrxDate: function setTrxDate(state, value) {
      state.transactions.date = value;
    },
    setTrxDateFrom: function setTrxDateFrom(state, value) {
      state.transactions.dateFrom = value;
    },
    setTrxDateTo: function setTrxDateTo(state, value) {
      state.transactions.dateTo = value;
    },
    setTrxSortColumn: function setTrxSortColumn(state, value) {
      state.transactions.sort.column = value;
    },
    setTrxSortIsDesc: function setTrxSortIsDesc(state, value) {
      state.transactions.sort.isDesc = value;
    },
    setTrxData: function setTrxData(state, data) {
      for (var field in data) {
        state.transactions[field] = data[field];
      }
    }
  },
  sharedMutations: []
});

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    reservations: {
      list: [],
      isMax: false,
      currentPage: 0,
      perPage: 20,
      search: '',
      status: '',
      date: 'last30Days',
      dateFrom: '',
      dateTo: '',
      sort: {
        order: 'created',
        isDesc: true
      },
      loading: false
    }
  },
  mutations: {
    resetReservations: function resetReservations(state) {
      state.reservations.list = [];
    },
    addReservations: function addReservations(state, value) {
      state.reservations.list.push(value);
    },
    setReservationsIsMax: function setReservationsIsMax(state, value) {
      state.reservations.isMax = value;
    },
    setReservationsCurrentPage: function setReservationsCurrentPage(state, value) {
      state.reservations.currentPage = value;
    },

    // setReservationsFromTo (state, value) {
    //   state.reservations.from = value.from
    //   state.reservations.to = value.to
    // },
    resetRsvpFilters: function resetRsvpFilters(state, value) {
      state.reservations.search = '';
      state.reservations.status = '';
      state.reservations.date = 'last30Days';
      state.reservations.dateFrom = '';
      state.reservations.dateTo = '';
      state.reservations.loading = false;
    },
    setRsvpSearch: function setRsvpSearch(state, value) {
      state.reservations.search = value;
    },
    setRsvpStatus: function setRsvpStatus(state, value) {
      state.reservations.status = value;
    },
    setRsvpDate: function setRsvpDate(state, value) {
      state.reservations.date = value;
    },
    setRsvpDateFrom: function setRsvpDateFrom(state, value) {
      state.reservations.dateFrom = value;
    },
    setRsvpDateTo: function setRsvpDateTo(state, value) {
      state.reservations.dateTo = value;
    },
    setRsvpSortColumn: function setRsvpSortColumn(state, value) {
      state.reservations.sort.column = value;
    },
    setRsvpSortIsDesc: function setRsvpSortIsDesc(state, value) {
      state.reservations.sort.isDesc = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    countryName: '',
    countryCode: '',
    callingCode: '',
    countryList: {},
    countryOnly: false,
    countryModal: false
  },
  mutations: {
    setCountryName: function setCountryName(state, countryName) {
      state.countryName = countryName;
    },
    setCountryCode: function setCountryCode(state, countryCode) {
      state.countryCode = countryCode;
    },
    setCallingCode: function setCallingCode(state, callingCode) {
      state.callingCode = callingCode;
    },
    setCountryOnly: function setCountryOnly(state, value) {
      state.countryOnly = value;
    },
    setCountryList: function setCountryList(state, value) {
      state.countryList = value;
    },
    setCountryModal: function setCountryModal(state, value) {
      state.countryModal = value;
    }
  }
});

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    logs: {
      list: [],
      loading: false,
      pageNum: 1,
      pageSize: 20,
      since: null,
      until: null,
      reachMax: false
    }
  },
  mutations: {
    addLogs: function addLogs(state, value) {
      state.logs.list.push(value);
    },
    setLogsField: function setLogsField(state, data) {
      state.logs[data.field] = data.value;
      for (var field in data.fields) {
        state.logs[field] = data.fields[field];
      }
    }
  }
});

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__list__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profile__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__transactions__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__credit_card__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__invoice__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__logs__ = __webpack_require__(893);








var sharedMutations = [];

/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__list__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_2__profile__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_3__transactions__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_4__credit_card__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_5__invoice__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_6__logs__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__list__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_2__profile__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_3__transactions__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_4__credit_card__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_5__invoice__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_6__logs__["a" /* default */].mutations),
  sharedMutations: sharedMutations
});

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    users: {
      list: [],
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      order: 'created',
      orderAsc: 1,
      loading: false,
      search: ''
    }
  },
  mutations: {
    resetUsers: function resetUsers(state) {
      state.users.list = [];
    },
    addUsers: function addUsers(state, value) {
      state.users.list = value;
    },
    setUserMaxList: function setUserMaxList(state, value) {
      state.users.maxList = value;
    },
    setUserCurrentPage: function setUserCurrentPage(state, value) {
      state.users.currentPage = value;
    },
    setUserPerPage: function setUserPerPage(state, value) {
      state.users.perPage = value;
    },
    setUserOrder: function setUserOrder(state, value) {
      state.users.order = value;
    },
    setUserOrderAsc: function setUserOrderAsc(state, value) {
      state.users.orderAsc = value;
    },
    setUserLoading: function setUserLoading(state, value) {
      state.users.loading = value;
    },
    setUserSearch: function setUserSearch(state, value) {
      state.users.search = value;
    },
    updateUserStatus: function updateUserStatus(state, data) {
      var index = state.users.list.findIndex(function (x) {
        return x.id === data.id;
      });
      if (index !== -1) {
        state.users.list[index].active = data.active;
      }
    }
  },
  sharedMutations: []
});

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    profile: {
      loading: false,
      info: {
        id: '',
        consId: '',
        logo: '',
        username: '',
        password: '',
        name: '',
        email: '',
        color: '',
        mobile: '',
        website: '',
        cardOwner: '',
        creditCard: '',
        cardExpiration: '',
        cardCVV: '',
        billingAddress1: '',
        billingAddress2: '',
        billingCity: '',
        billingState: '',
        billingZip: '',
        biilingCountry: 'US',
        stripeUrl: '',
        active: true,
        discountCode: ''
      },
      rsvp: {
        list: [],
        maxList: 0,
        currentPage: 1,
        perPage: 100,
        order: 'created',
        orderAsc: 1,
        loading: false,
        dateFrom: '',
        dateTo: ''
      }
    }
  },
  mutations: {
    setNationalNumber: function setNationalNumber(state, value) {
      state.profile.info.mobile = value;
    },
    setProfileLoading: function setProfileLoading(state, value) {
      state.profile.loading = value;
    },
    resetProfileInfo: function resetProfileInfo(state) {
      state.profile.info = {
        id: '',
        consId: '',
        logo: '',
        username: '',
        password: '',
        name: '',
        email: '',
        color: '',
        mobile: '',
        website: '',
        cardOwner: '',
        creditCard: '',
        cardExpiration: '',
        cardCVV: '',
        billingAddress1: '',
        billingAddress2: '',
        billingCity: '',
        billingState: '',
        billingZip: '',
        biilingCountry: 'US',
        stripeUrl: '',
        active: true
      };
    },
    setProfile: function setProfile(state, value) {
      state.profile.info = value;
    },
    setProfileColor: function setProfileColor(state, value) {
      state.profile.info.color = value;
    },
    setProfileCreditInfo: function setProfileCreditInfo(state, data) {
      state.profile.info.cardOwner = data.cardOwner;
      state.profile.info.creditCard = data.creditCard;
      state.profile.info.cardExpiration = data.cardExpiration;
    },
    resetRsvpList: function resetRsvpList(state) {
      state.profile.rsvp.list = [];
    },
    addRsvp: function addRsvp(state, value) {
      state.profile.rsvp.list = value;
    },
    setRsvpMaxList: function setRsvpMaxList(state, value) {
      state.profile.rsvp.maxList = value;
    },
    setRsvpCurrentPage: function setRsvpCurrentPage(state, value) {
      state.profile.rsvp.currentPage = value;
    },
    setRsvpPerPage: function setRsvpPerPage(state, value) {
      state.profile.rsvp.perPage = value;
    },
    setRsvpOrder: function setRsvpOrder(state, value) {
      state.profile.rsvp.order = value;
    },
    setRsvpOrderAsc: function setRsvpOrderAsc(state, value) {
      state.profile.rsvp.orderAsc = value;
    },
    setRsvpLoading: function setRsvpLoading(state, value) {
      state.profile.rsvp.loading = value;
    },
    setRsvpDate: function setRsvpDate(state, data) {
      state.profile.rsvp[data.field] = data.value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    transactions: {
      list: [],
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      search: '',
      status: '',
      date: 'withinDay',
      dateFrom: '',
      dateTo: '',
      sort: {
        order: 'created',
        isDesc: true
      },
      loading: false
    }
  },
  mutations: {
    resetTransactions: function resetTransactions(state) {
      state.transactions.list = [];
    },
    addTransactions: function addTransactions(state, value) {
      state.transactions.list.push(value);
    },
    resetTrxFilters: function resetTrxFilters(state) {
      state.transactions.search = '';
      state.transactions.status = '';
      state.transactions.date = 'withinDay';
      state.transactions.dateFrom = '';
      state.transactions.dateTo = '';
      state.transactions.loading = false;
    },
    setTrxSearch: function setTrxSearch(state, value) {
      state.transactions.search = value;
    },
    setTrxStatus: function setTrxStatus(state, value) {
      state.transactions.status = value;
    },
    setTrxDate: function setTrxDate(state, value) {
      state.transactions.date = value;
    },
    setTrxDateFrom: function setTrxDateFrom(state, value) {
      state.transactions.dateFrom = value;
    },
    setTrxDateTo: function setTrxDateTo(state, value) {
      state.transactions.dateTo = value;
    },
    setTrxSortColumn: function setTrxSortColumn(state, value) {
      state.transactions.sort.column = value;
    },
    setTrxSortIsDesc: function setTrxSortIsDesc(state, value) {
      state.transactions.sort.isDesc = value;
    },
    setTrxLoading: function setTrxLoading(state, value) {
      state.transactions.loading = value;
    },
    setTrxMaxList: function setTrxMaxList(state, value) {
      state.transactions.maxList = value;
    },
    setTrxCurrentPage: function setTrxCurrentPage(state, value) {
      state.transactions.currentPage = value;
    },
    setTrxPerPage: function setTrxPerPage(state, value) {
      state.transactions.perPage = value;
    },
    setUserOrder: function setUserOrder(state, value) {
      state.transactions.order = value;
    },
    setUserOrderAsc: function setUserOrderAsc(state, value) {
      state.transactions.orderAsc = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    creditCard: {
      owner: '',
      card: '',
      expiration: '',
      cvv: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      country: 'US'
    }
  },
  mutations: {
    setCreditCardData: function setCreditCardData(state, data) {
      state.creditCard[data.field] = data.value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    invoice: {
      list: [],
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      order: 'city',
      orderAsc: 0,

      dateFrom: '',
      dateTo: '',
      dueDate: '',
      formLoading: false
    }
  },
  mutations: {
    resetInvoice: function resetInvoice(state) {
      state.invoice.list = [];
    },
    addInvoices: function addInvoices(state, value) {
      state.invoice.list.push(value);
    },
    setInvoiceMaxList: function setInvoiceMaxList(state, value) {
      state.invoice.maxList = value;
    },
    setInvoiceCurrentPage: function setInvoiceCurrentPage(state, value) {
      state.invoice.currentPage = value;
    },
    setInvoicePerPage: function setInvoicePerPage(state, value) {
      state.invoice.perPage = value;
    },
    setInvoiceOrder: function setInvoiceOrder(state, value) {
      state.invoice.order = value;
    },
    setInvoiceOrderAsc: function setInvoiceOrderAsc(state, value) {
      state.invoice.orderAsc = value;
    },
    setInvoiceDateFrom: function setInvoiceDateFrom(state, value) {
      state.invoice.dateFrom = value;
    },
    setInvoiceDateTo: function setInvoiceDateTo(state, value) {
      state.invoice.dateTo = value;
    },
    setInvoiceDueDate: function setInvoiceDueDate(state, value) {
      state.invoice.dueDate = value;
    },
    setInvoiceFormLoading: function setInvoiceFormLoading(state, value) {
      state.invoice.formLoading = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    logs: {
      list: [],
      order: 'created',
      maxList: 0,
      currentPage: 1,
      perPage: 15,
      orderAsc: 1,
      loading: false
    }
  },
  mutations: {
    resetLogs: function resetLogs(state) {
      state.logs.list = [];
    },
    setLogs: function setLogs(state, value) {
      state.logs.list = value;
    },
    addCorporateLog: function addCorporateLog(state, value) {
      state.logs.list.push(value);
    },
    setLoadingLogs: function setLoadingLogs(state, value) {
      state.logs.loading = value;
    },
    setCorporateLogsCurrentPage: function setCorporateLogsCurrentPage(state, value) {
      state.logs.currentPage = value;
    },
    setCorporateLogsMaxList: function setCorporateLogsMaxList(state, value) {
      state.logs.maxList = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    countryName: 'US',
    countryAlias: 'us',
    callingCode: '1',
    countryList: {},
    countryOnly: false,
    countryModal: false
  },
  mutations: {
    reset: function reset(state) {
      state.countryName = 'US', state.countryAlias = 'us', state.callingCode = '1', state.countryOnly = false, state.countryModal = false;
    },
    setCountryName: function setCountryName(state, countryName) {
      state.countryName = countryName;
    },
    setCountryAlias: function setCountryAlias(state, countryAlias) {
      state.countryAlias = countryAlias;
    },
    setCallingCode: function setCallingCode(state, callingCode) {
      state.callingCode = callingCode;
    },
    setCountryOnly: function setCountryOnly(state, value) {
      state.countryOnly = value;
    },
    setCountryList: function setCountryList(state, value) {
      state.countryList = value;
    },
    setCountryModal: function setCountryModal(state, value) {
      state.countryModal = value;
    }
  }
});

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__coverage_map__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__coverage_report__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__coverage_sectors__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__coverage_shift_form__ = __webpack_require__(899);






/* harmony default export */ __webpack_exports__["a"] = ({
  strict: false,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__coverage_map__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_2__coverage_report__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_3__coverage_sectors__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_4__coverage_shift_form__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__coverage_map__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_2__coverage_report__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_3__coverage_sectors__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_4__coverage_shift_form__["a" /* default */].mutations)
});

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    map: {
      showPolygons: false,
      rsvp: null,
      drivers: [],
      sector: null,
      gap: null,
      kml: 0,
      kmls: []
    },
    trigger: {
      watch: false,
      action: '',
      data: ''
    }
  },
  mutations: {
    setCoverageMapShowPolygons: function setCoverageMapShowPolygons(state, value) {
      state.map.showPolygons = value;
      state.map.sector = null;
      state.map.rsvp = null;
      state.map.gap = null;
    },
    setCoverageMapRsvp: function setCoverageMapRsvp(state, value) {
      state.map.rsvp = value;
    },
    setCoverageMapDrivers: function setCoverageMapDrivers(state, value) {
      state.map.drivers = value;
    },
    setCoverageMapSector: function setCoverageMapSector(state, value) {
      state.map.sector = value;
    },
    setCoverageMapGap: function setCoverageMapGap(state, value) {
      state.map.gap = value;
    },
    setCoverageMapKml: function setCoverageMapKml(state, value) {
      state.map.kml = value;
    },
    setTriggerWatch: function setTriggerWatch(state, value) {
      state.trigger.watch = value;
    },
    setTriggerAction: function setTriggerAction(state, value) {
      state.trigger.action = value;
    },
    setTriggerData: function setTriggerData(state, value) {
      state.trigger.data = value;
    },
    addKml: function addKml(state, id) {
      var i = state.map.kmls.indexOf(id);
      if (i == -1) {
        state.map.kmls.push(id);
      }
    },
    removeKml: function removeKml(state, id) {
      var i = state.map.kmls.indexOf(id);
      if (i > -1) {
        state.map.kmls.splice(i, 1);
      }
    }
  }
});

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    report: {
      sectors: []
    }
  },
  mutations: {
    addCoverageReportSector: function addCoverageReportSector(state, value) {
      state.report.sectors.push(value);
    },
    setCoverageReportSectors: function setCoverageReportSectors(state, value) {
      state.report.sectors = value;
    }
  }
});

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    sectors: {
      loading: false,
      items: [],
      refresh: false,
      scrollElement: null
    },
    filters: {
      search: '',
      startDate: null,
      endDate: null
    }
  },
  mutations: {
    setCoverageSectorsLoading: function setCoverageSectorsLoading(state, value) {
      state.sectors.loading = value;
    },
    setCoverageSectors: function setCoverageSectors(state, value) {
      state.sectors.items = value;
    },
    setCoverageSectorsRefresh: function setCoverageSectorsRefresh(state, value) {
      state.sectors.refresh = value;
    },
    setCoverageSectorScrollElement: function setCoverageSectorScrollElement(state, value) {
      state.sectors.scrollElement = value;
    },
    setCoverageSectorsPanelShow: function setCoverageSectorsPanelShow(state, index) {
      state.sectors.items[index].showPanel = !state.sectors.items[index].showPanel;
      if (state.sectors.items[index].showPanel) {
        state.sectors.items[index].bodyHeight = 'auto';
      } else {
        state.sectors.items[index].bodyHeight = 0;
      }
    },
    setCoverageSectorsIssueState: function setCoverageSectorsIssueState(state, value) {
      var sectors = state.sectors.items;
      var index = -1;
      var i = -1;
      for (i = 0; i < sectors.length; i++) {
        if (value.id !== sectors[i].ID) {
          continue;
        }
        index = i;
        break;
      }

      if (i < 0) {
        return;
      }

      state.sectors.items[i].issueState = value.hasIssues ? 'has-issues' : 'ok';
      state.sectors.items[i].shiftGaps = value.shiftGaps;
      state.sectors.items[i].unassigned = value.unassigned;
    },
    setCoverageSectorPolygonOption: function setCoverageSectorPolygonOption(state, value) {
      var sectors = state.sectors.items;
      var index = -1;
      var i = -1;
      for (i = 0; i < sectors.length; i++) {
        if (value.id !== sectors[i].ID) {
          continue;
        }
        index = i;
        break;
      }

      if (i < 0) {
        return;
      }

      state.sectors.items[i].polygonOptions = value.polygonOptions;
    },
    resetCoverageSectorPolygonOption: function resetCoverageSectorPolygonOption(state) {
      var sectors = state.sectors.items;
      for (var i = 0; i < sectors.length; i++) {
        sectors[i].polygonOptions = {
          zIndex: 0,
          strokeWeight: 2,
          fillOpacity: 0.25
        };
      }
      state.sectors.items = sectors;
    },
    resetCoverageSectorBodyHeight: function resetCoverageSectorBodyHeight(state, value) {
      var sectors = state.sectors.items;
      var index = -1;
      var i = -1;
      for (i = 0; i < sectors.length; i++) {
        if (value.id !== sectors[i].ID) {
          continue;
        }
        index = i;
        break;
      }

      if (i < 0) {
        return;
      }

      state.sectors.items[i].bodyHeight = value.bodyHeight;
    },
    setCoverageFilterSearch: function setCoverageFilterSearch(state, value) {
      state.filters.search = value;
    },
    setCoverageFilterStartDate: function setCoverageFilterStartDate(state, value) {
      state.filters.startDate = value;
    },
    setCoverageFilterEndDate: function setCoverageFilterEndDate(state, value) {
      state.filters.endDate = value;
    }
  }
});

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    shiftForm: {
      show: false,
      driver: null,
      gap: null,
      sector: null
    }
  },
  mutations: {
    setCoverageShiftFormShow: function setCoverageShiftFormShow(state, value) {
      state.shiftForm.show = value;
    },
    setCoverageShiftFormDriver: function setCoverageShiftFormDriver(state, value) {
      state.shiftForm.driver = value;
    },
    setCoverageShiftFormGap: function setCoverageShiftFormGap(state, value) {
      state.shiftForm.gap = value;
    },
    setCoverageShiftFormSector: function setCoverageShiftFormSector(state, value) {
      state.shiftForm.sector = value;
    }
  }
});

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dispatch_reservations__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dispatch_drivers__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dispatch_map__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dispatch_modal__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dispatch_schedule__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dispatch_notification__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__notification_new_booking__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__available_drivers__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__unavailable_drivers__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__quilified_drivers__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lyft__ = __webpack_require__(911);














var sharedMutations = [];
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_1__dispatch_reservations__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_2__dispatch_drivers__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_3__dispatch_map__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_7__notification_new_booking__["a" /* default */].sharedMutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__dispatch_reservations__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_2__dispatch_drivers__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_5__dispatch_schedule__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_3__dispatch_map__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_4__dispatch_modal__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_6__dispatch_notification__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_7__notification_new_booking__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_8__available_drivers__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_9__unavailable_drivers__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_10__quilified_drivers__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_11__lyft__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__dispatch_reservations__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_2__dispatch_drivers__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_5__dispatch_schedule__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_3__dispatch_map__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_4__dispatch_modal__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_6__dispatch_notification__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_7__notification_new_booking__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_8__available_drivers__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_9__unavailable_drivers__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_10__quilified_drivers__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_11__lyft__["a" /* default */].mutations),
  sharedMutations: sharedMutations
});

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    rsvpInTable: [],
    fetching: false,
    noDataFound: false,
    checkedReservations: [],
    rsvpPaging: {
      currentPage: 1,
      pageSize: 20,
      totalPages: 0
    },
    totalItem: 0,
    lastSync: '',
    rsvpSort: {
      order: 'cb.pickupTime',
      asc: true
    },
    readyToGo: {
      show: false,
      id: 0,
      loading: false,
      success: false
    },
    notes: {
      show: false,
      message: '',
      loading: false,
      success: false
    },
    filter: {
      services: []
    }
  },
  mutations: {
    setRsvpInTable: function setRsvpInTable(state, rsvps) {
      state.rsvpInTable = rsvps;
      state.checkedReservations = [];
    },
    pushRsvpInTable: function pushRsvpInTable(state, rsvp) {
      state.rsvpInTable.push(rsvp);
    },
    addRsvpInTable: function addRsvpInTable(state, rsvp) {
      state.rsvpInTable.unshift(rsvp);
    },
    removeRsvpInTable: function removeRsvpInTable(state, rsvp) {
      if (state.rsvpInTable.length <= 0) {
        return;
      }
      var rsvps = state.rsvpInTable;
      state.rsvpInTable = rsvps.filter(function (item) {
        return item.id !== rsvp.id || item.isPackage !== rsvp.isPackage;
      });

      // remove from selected
      var checkedReservations = state.checkedReservations;
      state.checkedReservations = checkedReservations.filter(function (item) {
        return item.id !== rsvp.id || item.isPackage !== rsvp.isPackage;
      });
    },
    setFetching: function setFetching(state, value) {
      state.fetching = value;
    },
    setNoDataFound: function setNoDataFound(state, value) {
      state.noDataFound = value;
    },
    updateCheckedReservations: function updateCheckedReservations(state, value) {
      state.checkedReservations = value;
    },
    clearCheckedRsvps: function clearCheckedRsvps(state) {
      state.checkedReservations = [];
    },


    // Paging state
    setRsvpCurrentPage: function setRsvpCurrentPage(state, value) {
      state.rsvpPaging.currentPage = value;
    },
    setRsvpTotalPages: function setRsvpTotalPages(state, totalItems) {
      state.rsvpPaging.totalPages = Math.ceil(totalItems / state.rsvpPaging.pageSize);
    },
    resetRsvpPaging: function resetRsvpPaging(state) {
      state.rsvpPaging = {
        currentPage: 1,
        pageSize: 20,
        totalPages: 0
      };
    },


    // Sorting
    setRsvpSort: function setRsvpSort(state, value) {
      state.rsvpSort = value;
    },
    setRsvpSortingOrder: function setRsvpSortingOrder(state, value) {
      state.rsvpSort.order = value;
    },
    setRsvpSortingAsc: function setRsvpSortingAsc(state, value) {
      state.rsvpSort.asc = value;
    },
    resetRsvpSorting: function resetRsvpSorting(state) {
      state.rsvpSort = {
        order: 'cb.pickupTime',
        asc: 1
      };
    },
    setReadyToGoShow: function setReadyToGoShow(state, value) {
      state.readyToGo.show = value;
    },
    setReadyToGoID: function setReadyToGoID(state, value) {
      state.readyToGo.id = value;
    },
    setReadyToGoLoading: function setReadyToGoLoading(state, value) {
      state.readyToGo.loading = value;
    },
    setReadyToGoSuccess: function setReadyToGoSuccess(state, value) {
      state.readyToGo.success = value;
    },
    setFilterService: function setFilterService(state, value) {
      state.filter.services = value;
    },
    setNotesShow: function setNotesShow(state, value) {
      state.notes.show = value;
    },
    setNotesMessage: function setNotesMessage(state, value) {
      state.notes.message = value;
    },
    setDispatchTotal: function setDispatchTotal(state, value) {
      state.totalItem = value;
    },
    setLastSync: function setLastSync(state, value) {
      state.lastSync = value;
    },
    setPendingOffer: function setPendingOffer(state, data) {
      var i = state.rsvpInTable.findIndex(function (x) {
        return x.id === data.id;
      });
      if (i > -1) {
        state.rsvpInTable[i].pendingOffer = {
          show: data.show,
          timer: data.timer
        };
      }
    },
    updateRsvpStatus: function updateRsvpStatus(state, data) {
      var i = state.rsvpInTable.findIndex(function (x) {
        return x.id === data.id;
      });
      if (i > -1) {
        state.rsvpInTable[i].status = data.status;
        state.rsvpInTable[i].statusClass = data.statusClass;
        state.rsvpInTable[i].resStatus = data.resStatus;
      }
    }
  },
  sharedMutations: [
    /*
    'dispatch/setRsvpInTable',
    'dispatch/addRsvpInTable',
    'dispatch/removeRsvpInTable',
    'dispatch/setFetching',
    'dispatch/setNoDataFound',
    'dispatch/updateCheckedReservations'
    */
  ]
});

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    onDuty: {
      drivers: [],
      loading: false,
      pageNum: 1,
      pageSize: 20,
      totalPages: 0,
      noDriversFound: false,
      order: 'ID',
      asc: true
    },
    offDuty: {
      drivers: [],
      loading: false,
      pageNum: 1,
      pageSize: 20,
      totalPages: 0,
      noDriversFound: false,
      order: 'ID',
      asc: true
    },
    staging: {
      drivers: [],
      loading: false,
      pageNum: 1,
      pageSize: 20,
      totalPages: 0,
      noDriversFound: false,
      order: 'ID',
      asc: true
    },
    driverListFilters: {
      search: '',
      serviceTypes: ['shared', 'opoli', 'black', 'suv', 'shuttle']
    },
    driverListTabIndex: 0,
    driverInPopup: {
      id: null,
      phone: null,
      email: null,
      firstName: null,
      lastName: null,
      photoUrl: null,
      vehicle: {
        name: null,
        licensePlate: null,
        photoUrl: null
      }
    },
    driverInPopupRoute: {
      path: [],
      distance: null, // in miles
      duration: null // in minutes
    },
    loadingDrivers: false,
    selectedDriver: null,
    serviceCount: {
      shared: 0,
      opoli: 0,
      black: 0,
      suv: 0,
      shuttle: 0
    },
    serviceFilter: {
      show: false,
      loading: false,
      list: []
    },
    totalDrivers: {
      onDuty: 0,
      staging: 0,
      offDuty: 0
    },
    reloadDrivers: false,
    driverPanelOpen: false,
    tabActive: {
      rsvp: 'dispatch',
      driver: 'onDuty'
    },
    noSector: false
  },
  mutations: {
    // OnlineDrivers
    setOnDutyDrivers: function setOnDutyDrivers(state, drivers) {
      state.onDuty.drivers = drivers;
    },
    setOnDutyLoading: function setOnDutyLoading(state, value) {
      state.onDuty.loading = value;
    },
    setOnDutyPageNumber: function setOnDutyPageNumber(state, value) {
      state.onDuty.pageNum = value;
    },
    setOnDutyTotalPages: function setOnDutyTotalPages(state, total) {
      state.onDuty.totalPages = Math.ceil(total / state.onDuty.pageSize);
    },
    addToOnDutyDrivers: function addToOnDutyDrivers(state, driver) {
      state.onDuty.drivers.unshift(driver);
    },
    setOnDutyNoDriversFound: function setOnDutyNoDriversFound(state, value) {
      state.onDuty.noDriversFound = value;
    },
    setOnDutySorting: function setOnDutySorting(state, value) {
      state.onDuty.order = value.order;
      state.onDuty.asc = value.asc;
    },
    removeFromOnDutyDrivers: function removeFromOnDutyDrivers(state, driverId) {
      if (state.onDuty.drivers.length <= 0) {
        state.onDuty.pageNum = 1;
        state.onDuty.totalPages = 0;
        return;
      }
      var drivers = state.onDuty.drivers;
      state.onDuty.drivers = drivers.filter(function (driver) {
        return driver.id !== driverId;
      });
      if (state.onDuty.drivers.length <= 0) {
        state.onDuty.pageNum = 1;
        state.onDuty.totalPages = 0;
      }
    },

    // Offline Drivers
    setOffDutyDrivers: function setOffDutyDrivers(state, drivers) {
      state.offDuty.drivers = drivers;
    },
    setOffDutyLoading: function setOffDutyLoading(state, value) {
      state.offDuty.loading = value;
    },
    setOffDutyPageNumber: function setOffDutyPageNumber(state, value) {
      state.offDuty.pageNum = value;
    },
    setOffDutyTotalPages: function setOffDutyTotalPages(state, total) {
      state.offDuty.totalPages = Math.ceil(total / state.offDuty.pageSize);
    },
    addToOffDutyDrivers: function addToOffDutyDrivers(state, driver) {
      state.offDuty.drivers.unshift(driver);
    },
    setOffDutyNoDriversFound: function setOffDutyNoDriversFound(state, value) {
      state.offDuty.noDriversFound = value;
    },
    setOffDutySorting: function setOffDutySorting(state, value) {
      state.offDuty.order = value.order;
      state.offDuty.asc = value.asc;
    },
    removeFromOffDutyDrivers: function removeFromOffDutyDrivers(state, driverId) {
      if (state.offDuty.drivers.length <= 0) {
        state.offDuty.pageNum = 1;
        state.offDuty.totalPages = 0;
        return;
      }
      var drivers = state.offDuty.drivers;
      state.offDuty.drivers = drivers.filter(function (driver) {
        return driver.id !== driverId;
      });
      if (state.offDuty.drivers.length <= 0) {
        state.offDuty.pageNum = 1;
        state.offDuty.totalPages = 0;
      }
    },


    // Staging Drivers
    setStagingDrivers: function setStagingDrivers(state, drivers) {
      state.staging.drivers = drivers;
      if (state.staging.drivers.length <= 0) {
        state.staging.pageNum = 1;
        state.staging.totalPages = 0;
        state.staging.order = 'ID';
        state.staging.asc = true;
      }
    },
    setStagingLoading: function setStagingLoading(state, value) {
      state.staging.loading = value;
    },
    setStagingPageNumber: function setStagingPageNumber(state, value) {
      state.staging.pageNum = value;
    },
    setStagingTotalPages: function setStagingTotalPages(state, total) {
      state.staging.totalPages = Math.ceil(total / state.staging.pageSize);
    },
    addToStagingDrivers: function addToStagingDrivers(state, driver) {
      state.staging.drivers.unshift(driver);
    },
    setStagingNoDriversFound: function setStagingNoDriversFound(state, value) {
      state.staging.noDriversFound = value;
    },
    setStagingSorting: function setStagingSorting(state, value) {
      state.staging.order = value.order;
      state.staging.asc = value.asc;
    },
    removeFromStagingDrivers: function removeFromStagingDrivers(state, driverId) {
      if (state.staging.drivers.length <= 0) {
        state.staging.pageNum = 1;
        state.staging.totalPages = 0;
        return;
      }
      var drivers = state.staging.drivers;
      state.staging.drivers = drivers.filter(function (driver) {
        return driver.id !== driverId;
      });
      if (state.staging.drivers.length <= 0) {
        state.staging.pageNum = 1;
        state.staging.totalPages = 0;
        state.staging.order = 'ID';
        state.staging.asc = true;
      }
    },
    resetStagingDriver: function resetStagingDriver(state) {
      state.staging = {
        drivers: [],
        loading: false,
        pageNum: 1,
        pageSize: 20,
        totalPages: 0,
        noDriversFound: false,
        order: 'ID',
        asc: true
      };
    },


    // Driver Tab
    setDriverListTabIndex: function setDriverListTabIndex(state, value) {
      state.driverListTabIndex = value;
    },


    // Filters
    setDriverListSearchFilter: function setDriverListSearchFilter(state, value) {
      state.driverListFilters.search = value;
    },
    setDriverListServiceTypeFilter: function setDriverListServiceTypeFilter(state, value) {
      state.driverListFilters.serviceTypes = value;
    },


    // Driver in Map Popup
    showDriverInPopup: function showDriverInPopup(state, driver) {
      state.driverInPopup = driver;
    },
    clearDriverPopup: function clearDriverPopup(state) {
      state.driverInPopup = {
        id: null,
        phone: null,
        email: null,
        firstName: null,
        lastName: null,
        photoUrl: null,
        vehicle: {
          name: null,
          licensePlate: null,
          photoUrl: null
        }
      };
      state.driverInPopupRoute = {
        path: [],
        distance: null,
        duration: null
      };
    },
    setDriverInPopupRoute: function setDriverInPopupRoute(state, value) {
      state.driverInPopupRoute = value;
    },


    // Selected driver via checkbox
    setSelectedDriver: function setSelectedDriver(state, value) {
      state.selectedDriver = value;
    },
    setServiceCount: function setServiceCount(state, value) {
      state.serviceCount = value;
    },
    setServiceFilterShow: function setServiceFilterShow(state, value) {
      state.serviceFilter.show = value;
    },
    setServiceFilterLoading: function setServiceFilterLoading(state, value) {
      state.serviceFilter.loading = value;
    },
    toggleServiceFilterList: function toggleServiceFilterList(state, value) {
      var index = state.serviceFilter.list.indexOf(value);
      if (index > -1) {
        state.serviceFilter.list.splice(index, 1);
      } else {
        state.serviceFilter.list.push(value);
      }
    },
    setDriversTotal: function setDriversTotal(state, data) {
      state.totalDrivers[data.field] = data.value;
    },
    setReloadDrivers: function setReloadDrivers(state, value) {
      state.reloadDrivers = value;
    },
    setDriverPanelOpen: function setDriverPanelOpen(state, value) {
      state.driverPanelOpen = value;
    },
    setTabActiveData: function setTabActiveData(state, data) {
      for (var field in data) {
        state.tabActive[field] = data[field];
      }
    },
    setNoSector: function setNoSector(state, value) {
      state.noSector = value;
    }
  },
  sharedMutations: ['dispatch/setOnDutyDrivers', 'dispatch/setOffDutyDrivers', 'dispatch/showDriverInPopup', 'dispatch/clearDriverPopup', 'dispatch/setDriverInPopupRoute', 'dispatch/setSelectedDriver']
});

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    rsvpInMap: {
      id: null
    },
    driversNearRsvp: [],
    driverIdsInMap: [],
    driversInMap: [],
    loadingRsvpId: null,
    loadingDriverId: null
  },
  mutations: {
    clearMap: function clearMap(state) {
      state.rsvpInMap = null;
      state.driversNearRsvp = [];
      state.driversInMap = [];
      state.driverIdsInMap = [];
    },
    setRsvpInMap: function setRsvpInMap(state, rsvp) {
      state.rsvpInMap = rsvp;
    },
    removeRsvpInMap: function removeRsvpInMap(state) {
      state.rsvpInMap = {
        id: null
      };
      state.driversNearRsvp = [];
    },
    setDriversNearRsvp: function setDriversNearRsvp(state, drivers) {
      state.driversNearRsvp = drivers;
    },
    addDriverInMap: function addDriverInMap(state, driver) {
      state.driverIdsInMap.push(driver.id);
      state.driversInMap.push(driver);
    },
    removeDriverInMap: function removeDriverInMap(state, driver) {
      for (var i = 0; i < state.driversInMap.length; i++) {
        var driverId = state.driversInMap[i].id;
        if (driverId === driver.id) {
          state.driversInMap.splice(i, 1);
          break;
        }
      }

      var index = state.driverIdsInMap.indexOf(driver.id);
      if (index > -1) {
        state.driverIdsInMap.splice(index, 1);
      }
    },
    removeAllDriversInMap: function removeAllDriversInMap(state) {
      state.driversNearRsvp = [];
      state.driverIdsInMap = [];
      state.driversInMap = [];
    },
    setLoadingRsvpId: function setLoadingRsvpId(state, value) {
      state.loadingRsvpId = value;
    },
    setLoadingDriverId: function setLoadingDriverId(state, value) {
      state.loadingDriverId = value;
    }
  },
  sharedMutations: ['dispatch/clearMap', 'dispatch/setRsvpInMap', 'dispatch/removeRsvpInMap', 'dispatch/setDriversNearRsvp', 'dispatch/addDriverInMap', 'dispatch/removeDriverInMap', 'dispatch/setLoadingRsvpId', 'dispatch/setLoadingDriverId']
});

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    validationModal: {
      show: false,
      title: '',
      message: ''
    },
    actionModal: {
      show: false,
      success: false,
      done: false,
      doneMessage: '',
      ongoingMessage: ''
    }
  },
  mutations: {
    // Validation Modal
    showValidationModal: function showValidationModal(state, modal) {
      state.validationModal.show = true;
      state.validationModal.title = modal.title;
      state.validationModal.message = modal.message;
    },
    closeValidationModal: function closeValidationModal(state) {
      state.validationModal.show = false;
    },


    // Action Modal
    showActionModal: function showActionModal(state, message) {
      state.actionModal.show = true;
      state.actionModal.done = false;
      state.actionModal.success = false;
      state.actionModal.ongoingMessage = message;
    },
    completeActionModal: function completeActionModal(state, value) {
      state.actionModal.done = true;
      state.actionModal.success = value.success;
      state.actionModal.doneMessage = value.message;
    },
    closeActionModal: function closeActionModal(state) {
      state.actionModal.show = false;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    schedule: {
      show: false,
      loading: false,
      loadingMsg: '',
      accepted: false,
      rsvp: [],
      pkg: [],
      driverData: {
        id: 0,
        name: ''
      },
      error: ''
    },
    currentTable: 0
  },
  mutations: {
    setScheduleShow: function setScheduleShow(state, value) {
      state.schedule.show = value;
    },
    setScheduleLoading: function setScheduleLoading(state, value) {
      state.schedule.loading = value;
    },
    setScheduleLoadingMsg: function setScheduleLoadingMsg(state, value) {
      state.schedule.loadingMsg = value;
    },
    setScheduleAccepted: function setScheduleAccepted(state, value) {
      state.schedule.accepted = value;
    },
    setScheduleRsvp: function setScheduleRsvp(state, value) {
      state.schedule.rsvp = value;
    },
    setSchedulePkg: function setSchedulePkg(state, value) {
      state.schedule.pkg = value;
    },
    setScheduleDriverData: function setScheduleDriverData(state, value) {
      state.schedule.driverData = value;
    },
    setScheduleError: function setScheduleError(state, value) {
      state.schedule.error = value;
    },
    setCurrentTable: function setCurrentTable(state, value) {
      state.currentTable = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    acceptNotification: {
      show: false,
      accept: false,
      isPackage: false,
      id: null,
      driverId: null,
      driverName: '',
      isSendAsSchedule: false,
      sendAsScheduleError: '',
      runsDeclined: false
    }
  },
  mutations: {
    showDispatchAcceptNotification: function showDispatchAcceptNotification(state, value) {
      state.acceptNotification = value;
    },
    hideDispatchAcceptNotification: function hideDispatchAcceptNotification(state) {
      state.acceptNotification = {
        show: false,
        accept: false,
        isPackage: false,
        id: null,
        driverId: null,
        driverName: '',
        isSendAsSchedule: false,
        sendAsScheduleError: '',
        runsDeclined: false
      };
    }
  },
  sharedMutations: []
});

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    notificationNewBooking: {
      show: false,
      text: null,
      id: null,
      isPackage: null,
      status: null,
      isLoading: false
    }
  },
  mutations: {
    showNotificationNewBooking: function showNotificationNewBooking(state, data) {
      state.notificationNewBooking.show = true;
      state.notificationNewBooking.text = data.text;
      state.notificationNewBooking.status = data.status;
      state.notificationNewBooking.id = data.id;
      state.notificationNewBooking.isPackage = data.isPackage;
      state.notificationNewBooking.isLoading = false;
    },
    hideNotificationNewBooking: function hideNotificationNewBooking(state) {
      state.notificationNewBooking.show = false;
      state.notificationNewBooking.text = null;
      state.notificationNewBooking.status = null;
      state.notificationNewBooking.id = null;
      state.notificationNewBooking.isPackage = null;
      state.notificationNewBooking.isLoading = false;
    },
    loadNewBookingNotification: function loadNewBookingNotification(state) {
      state.notificationNewBooking.isLoading = true;
    }
  },
  sharedMutations: ['dispatch/showNotificationNewBooking', 'dispatch/hideNotificationNewBooking']
});

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    availableDrivers: {
      list: [],
      selected: '',
      loading: false
    }
  },
  mutations: {
    setAvailableDriversData: function setAvailableDriversData(state, data) {
      for (var field in data) {
        state.availableDrivers[field] = data[field];
      }
    }
  }
});

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    unavailableDrivers: {
      list: [],
      selected: '',
      loading: false
    }
  },
  mutations: {
    setUnavailableDriversData: function setUnavailableDriversData(state, data) {
      for (var field in data) {
        state.unavailableDrivers[field] = data[field];
      }
    }
  }
});

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    qualifiedDriver: {
      list: [],
      details: {},
      refresh: false,
      active: false
    }
  },
  mutations: {
    setQualifiedDriversData: function setQualifiedDriversData(state, data) {
      for (var field in data) {
        state.qualifiedDriver[field] = data[field];
      }
    },
    reduceQualifiedDrivers: function reduceQualifiedDrivers(state) {
      state.qualifiedDriver.list.shift();
    }
  }
});

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    lyft: {
      show: false,
      services: [],
      originalFare: 0
    },
    venue: {
      show: false,
      list: [],
      lastCoords: '',
      origPickupData: {},
      selected: {
        service: '',
        zone: '',
        location: ''
      }
    }
  },
  mutations: {
    setLyftData: function setLyftData(state, data) {
      for (var field in data) {
        state.lyft[field] = data[field];
      }
    },
    setLyftServiceData: function setLyftServiceData(state, data) {
      var i = state.lyft.services.findIndex(function (x) {
        return x.name === data.name;
      });
      if (i > -1) {
        state.lyft.services[i] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.lyft.services[i], data.data);
      }
    },
    setVenueData: function setVenueData(state, data) {
      for (var field in data) {
        state.venue[field] = data[field];
      }
    },
    addVenueList: function addVenueList(state, data) {
      state.venue.list.push(data);
    }
  }
});

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filter_details__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter_table__ = __webpack_require__(914);




/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__filter_details__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_2__filter_table__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__filter_details__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_2__filter_table__["a" /* default */].mutations)
});

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    orginalFilter: null,
    editedFilter: null
  },
  mutations: {
    setOriginalFilter: function setOriginalFilter(state, value) {
      state.orginalFilter = value;
    },
    setEditedFilter: function setEditedFilter(state, value) {
      state.editedFilter = value;
    }
  }
});

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    search: null,
    pageSize: 20,
    order: 'id',
    orderAsc: 1,
    currentPage: 1,
    filterTable: []
  },
  mutations: {
    setFilterTable: function setFilterTable(state, value) {
      state.filterTable = value;
    }
  }
});

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    show: false,
    loading: false,
    airline: {
      name: '',
      code: ''
    },
    flightNumber: '',
    departure: {
      airportCode: '',
      airportName: '',
      time: ''
    },
    arrival: {
      airportCode: '',
      airportName: '',
      time: ''
    },
    status: '',
    type: ''
  },
  mutations: {
    show: function show(state) {
      state.show = true;
      state.loading = true;
    },
    hide: function hide(state) {
      state.show = false;
      state.loading = false;
      state.airline = {
        name: '',
        code: ''
      };
      state.flightNumber = '';
      state.departure = {
        airportCode: '',
        airportName: '',
        time: ''
      };
      state.arrival = {
        airportCode: '',
        airportName: '',
        time: ''
      };
      state.status = '';
    },
    setLoading: function setLoading(state, value) {
      state.loading = value;
    },
    setFlightInfo: function setFlightInfo(state, value) {
      state.airline = value.airline;
      state.flightNumber = value.flightNumber;
      state.departure = value.departure;
      state.arrival = value.arrival;
      state.status = value.status;
      state.type = value.type;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__geofence_filters__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__geofence_list__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__geofence_map__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__geofence_priority__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__geofence_promo__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__geofence_servicearea__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__arrival_instruction__ = __webpack_require__(923);









var sharedMutations = [];
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_7__arrival_instruction__["a" /* default */].sharedMutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  strict: false,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__geofence_filters__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_2__geofence_list__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_3__geofence_map__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_4__geofence_priority__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_5__geofence_promo__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_6__geofence_servicearea__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_7__arrival_instruction__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__geofence_filters__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_2__geofence_list__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_3__geofence_map__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_4__geofence_priority__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_5__geofence_promo__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_6__geofence_servicearea__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_7__arrival_instruction__["a" /* default */].mutations),
  sharedMutations: sharedMutations
});

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    filters: {
      search: '',
      type: 'airport',
      status: 'active',
      brands: ''
    },
    showCreateGeofence: false,
    refreshList: false,
    cloneId: 0
  },
  mutations: {
    setFilterSearch: function setFilterSearch(state, value) {
      state.filters.search = value;
    },
    setFilterStatus: function setFilterStatus(state, value) {
      state.filters.status = value;
    },
    setFilterBrands: function setFilterBrands(state, value) {
      state.filters.brands = value;
    },
    setFilterType: function setFilterType(state, value) {
      state.filters.type = value;
    },
    setShowCreateGeofence: function setShowCreateGeofence(state, value) {
      state.showCreateGeofence = value;
    },
    setCloneGeofence: function setCloneGeofence(state, value) {
      state.cloneId = value;
    },
    setRefreshList: function setRefreshList(state, value) {
      state.refreshList = value;
    }
  }
});

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    geofences: {
      items: [],
      active: {
        stagingLots: [],
        restrictedAreas: [],
        serviceAreas: [],
        loading: false
      },
      loading: false
    }
  },
  mutations: {
    setGeofenceItems: function setGeofenceItems(state, value) {
      state.geofences.items = value;
    },
    setGeofencePricing: function setGeofencePricing(state, data) {
      var index = state.geofences.items.findIndex(function (x) {
        return x.id === data.id;
      });
      if (index > -1) {
        state.geofences.items[index][data.field] = data.value;
      }
    },
    setGeofenceDriverPay: function setGeofenceDriverPay(state, data) {
      var index = state.geofences.items.findIndex(function (x) {
        return x.id === data.id;
      });
      if (index > -1) {
        state.geofences.items[index][data.field] = data.value;
      }
    },
    setGeofenceServiceType: function setGeofenceServiceType(state, data) {
      var index = state.geofences.items.findIndex(function (x) {
        return x.id === data.id;
      });
      if (index > -1) {
        state.geofences.items[index].services[data.serviceType][data.field] = data.value;
      }
    },
    setGeofenceField: function setGeofenceField(state, data) {
      var index = state.geofences.items.findIndex(function (x) {
        return x.id === data.id;
      });
      if (index > -1) {
        state.geofences.items[index][data.field] = data.value;
      }
    },
    setAirportSubgeofence: function setAirportSubgeofence(state, data) {
      var index = state.geofences.items.findIndex(function (x) {
        return x.id === data.id;
      });
      if (index > -1) {
        state.geofences.items[index][data.field] = data.value;
      }
    },
    setGeofenceIsP2P: function setGeofenceIsP2P(state, data) {
      var index = state.geofences.items.findIndex(function (x) {
        return x.id === data.id;
      });
      if (index > -1) {
        state.geofences.items[index].isP2P = data.value;
      }
    },
    setGeofenceActive: function setGeofenceActive(state, data) {
      state.geofences.active[data.field] = data.value;
    },
    setGeofenceActiveLoading: function setGeofenceActiveLoading(state, value) {
      state.geofences.active.loading = value;
    },
    setGeofenceLoading: function setGeofenceLoading(state, value) {
      state.geofences.loading = value;
    }
  }
});

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    map: {
      polygons: []
    }
  },
  mutations: {
    setPolygon: function setPolygon(state, value) {
      state.map.polygons = value;
    },
    removePolygon: function removePolygon(state, value) {
      var result = [];

      for (var i = 0; i < state.map.polygons.length; i++) {
        var item = state.map.polygons[i];
        if (item.id === value) {
          continue;
        }
        result.push(item);
      }
      state.map.polygons = result;
    },
    clearPolygons: function clearPolygons(state) {
      state.map.polygons = [];
    }
  }
});

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    priority: {
      show: false,
      success: false
    }
  },
  mutations: {
    setShowGeofencePriority: function setShowGeofencePriority(state, value) {
      state.priority.show = value;
    },
    setPrioritySuccess: function setPrioritySuccess(state, value) {
      state.priority.success = value;
    }
  }
});

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    promo: {
      show: false,
      geofence: null,
      refreshID: null,
      list: []
    }
  },
  mutations: {
    setGeofencePromoShow: function setGeofencePromoShow(state, value) {
      state.promo.show = value;
      state.promo.refreshID = null;
    },
    setGeofencePromo: function setGeofencePromo(state, value) {
      state.promo.geofence = value;
    },
    setGeofencePromoList: function setGeofencePromoList(state, value) {
      state.promo.list = value;
    },
    setGeofencePromoRefreshID: function setGeofencePromoRefreshID(state, value) {
      state.promo.refreshID = value;
    }
  }
});

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    services: {
      show: false,
      startDate: '',
      endDate: '',
      id: '',
      saveBtn: true
    }
  },
  mutations: {
    setShowServiceAreaModal: function setShowServiceAreaModal(state, value) {
      state.services.show = value;
    },
    setStartDatePromo: function setStartDatePromo(state, value) {
      state.services.startDate = value;
    },
    setEndDatePromo: function setEndDatePromo(state, value) {
      state.services.endDate = value;
    },
    setServiceAreaID: function setServiceAreaID(state, value) {
      state.services.id = value;
    },
    setSaveBtn: function setSaveBtn(state, value) {
      state.services.saveBtn = value;
    }
  }
});

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    preview: {
      title: '',
      tnc: {
        text: '',
        img: ''
      },
      tcp: {
        text: '',
        img: ''
      }
    }
  },
  mutations: {
    setPreview: function setPreview(state, data) {
      state.preview.title = data.title;
      state.preview.tnc = data.tnc;
      state.preview.tcp = data.tcp;
    }
  },
  sharedMutations: ['geofences/setPreview']
});

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dropzone__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routing_modal__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__results_modal__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tnc_reservations__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__unrouted_reservations__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driver_inbound__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__driver_outbound__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__driver_tnc_tcp_staging__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__drivers__ = __webpack_require__(933);











var sharedMutations = [];

/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__dropzone__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_2__routing_modal__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_3__results_modal__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_4__tnc_reservations__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_5__unrouted_reservations__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_6__driver_inbound__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_7__driver_outbound__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_8__driver_tnc_tcp_staging__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_9__drivers__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__dropzone__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_2__routing_modal__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_3__results_modal__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_4__tnc_reservations__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_5__unrouted_reservations__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_6__driver_inbound__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_7__driver_outbound__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_8__driver_tnc_tcp_staging__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_9__drivers__["a" /* default */].mutations),
  sharedMutations: sharedMutations
});

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    dropzone: {
      show: false,
      items: [],
      checkRoute: false,
      drivers: [],
      saveSuccess: false
    }
  },
  mutations: {
    setDropzoneShow: function setDropzoneShow(state, value) {
      state.dropzone.show = value;
    },
    setDropzoneItems: function setDropzoneItems(state, value) {
      state.dropzone.items = value;
    },
    addDropzoneItem: function addDropzoneItem(state, value) {
      if (value.type === 'rsvp') {
        state.dropzone.items.push(value.legs[0]);
        state.dropzone.items.push(value.legs[1]);
        return;
      }

      for (var i = 0; i < value.legs.length; i++) {
        state.dropzone.items.push(value.legs[i]);
      }
    },
    updateDropzoneEta: function updateDropzoneEta(state, value) {
      var leg = value.leg;
      var eta = value.eta;
      var index = state.dropzone.items.findIndex(function (item, index, self) {
        return item.reservationID === leg.reservationID && item.packageID === leg.packageID && item.isPickup === leg.isPickup;
      });
      if (index > 0) {
        state.dropzone.items[index].eta = eta;
      }
    },
    removeDropzoneItem: function removeDropzoneItem(state, value) {
      var items = state.dropzone.items;
      state.dropzone.items = items.filter(function (item) {
        return item.reservationID !== value.reservationID;
      });
    },
    removeDropzoneItems: function removeDropzoneItems(state, value) {
      var items = state.dropzone.items;
      if (value.type === 'rsvp') {
        state.dropzone.items = items.filter(function (item) {
          return item.reservationID !== value.id;
        });
        return;
      }
      state.dropzone.items = items.filter(function (item) {
        return item.packageID !== value.id;
      });
    },
    clearDropzone: function clearDropzone(state) {
      state.dropzone.show = false;
      state.dropzone.items = [];
      state.dropzone.checkRoute = false;
      state.dropzone.drivers = [];
    },


    // Loading states
    setCheckRouteLoading: function setCheckRouteLoading(state, value) {
      state.dropzone.checkRoute = value;
    },


    // driver states
    setDropzoneDrivers: function setDropzoneDrivers(state, value) {
      state.dropzone.drivers = value;
    },
    removeDropzoneDrivers: function removeDropzoneDrivers(state) {
      state.dropzone.drivers = [];
    },
    addDropzoneDriver: function addDropzoneDriver(state, value) {
      state.dropzone.drivers.push(value);
    },
    removeDropzoneDriver: function removeDropzoneDriver(state, value) {
      var items = state.dropzone.drivers;
      state.dropzone.drivers = items.filter(function (item) {
        return item.packageID !== value.packageID || item.driver.id !== value.driver.id;
      });
    },
    removeDropzonePackageDriver: function removeDropzonePackageDriver(state, packageID) {
      var items = state.dropzone.drivers;
      state.dropzone.drivers = items.filter(function (item) {
        return item.packageID !== packageID;
      });
    },
    setDropzoneSaveSuccess: function setDropzoneSaveSuccess(state, value) {
      state.dropzone.saveSuccess = value;
    }
  }
});

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    routingModal: {
      show: false,
      validation: {
        show: false,
        title: '',
        message: ''
      },
      ajax: {
        show: false,
        loading: false,
        success: false,
        message: ''
      },
      confirmation: {
        show: false,
        title: '',
        message: '',
        action: null
      }
    }
  },
  mutations: {
    // Modal Container
    showRoutingModal: function showRoutingModal(state) {
      state.routingModal.show = true;
    },
    hideRoutingModal: function hideRoutingModal(state) {
      state.routingModal.show = false;
      state.routingModal.validation = {
        show: false,
        title: '',
        message: ''
      };
      state.routingModal.ajax = {
        show: false,
        loading: false,
        success: false,
        message: ''
      };
      state.routingModal.confirmation = {
        show: false,
        title: '',
        message: '',
        action: null
      };
    },


    // ValidationModal
    setRoutingValidationModal: function setRoutingValidationModal(state, value) {
      state.routingModal.validation = value;
    },


    // Ajax Modal
    setRoutingAjaxModal: function setRoutingAjaxModal(state, value) {
      state.routingModal.ajax = value;
    },


    // Confirmation Modal
    setConfirmationModal: function setConfirmationModal(state, value) {
      state.routingModal.confirmation = value;
    },
    resetConfirmationModal: function resetConfirmationModal(state) {
      state.routingModal.confirmation = {
        show: false,
        title: '',
        message: '',
        action: null
      };
    }
  }
});

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    validationModal: {
      show: false,
      title: '',
      message: ''
    },
    actionModal: {
      show: false,
      success: false,
      done: false,
      doneMessage: '',
      ongoingMessage: ''
    }
  },
  mutations: {
    // Validation Modal
    showValidationModal: function showValidationModal(state, modal) {
      state.validationModal.show = true;
      state.validationModal.title = modal.title;
      state.validationModal.message = modal.message;
    },
    closeValidationModal: function closeValidationModal(state) {
      state.validationModal.show = false;
    },


    // Action Modal
    showActionModal: function showActionModal(state, message) {
      state.actionModal.show = true;
      state.actionModal.done = false;
      state.actionModal.success = false;
      state.actionModal.ongoingMessage = message;
    },
    completeActionModal: function completeActionModal(state, value) {
      state.actionModal.done = true;
      state.actionModal.success = value.success;
      state.actionModal.doneMessage = value.message;
    },
    closeActionModal: function closeActionModal(state) {
      state.actionModal.show = false;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    tncReservations: {
      list: [],
      checked: [],
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      order: 'cb.pickupTime',
      orderAsc: 1,
      type: 'all',
      isLoading: false,
      search: '',
      viewingInMap: false
    },
    readyToGo: {
      show: false,
      id: 0,
      loading: false,
      success: false,
      table: ''
    },
    notes: {
      show: false,
      message: '',
      loading: false,
      success: false
    }
  },
  mutations: {
    resetTncReservationsList: function resetTncReservationsList(state) {
      state.tncReservations.list = [];
    },
    addTncReservation: function addTncReservation(state, value) {
      state.tncReservations.list.push(value);
    },
    setTncReservationsChecked: function setTncReservationsChecked(state, value) {
      state.tncReservations.checked = value;
    },
    removeTncReservationsChecked: function removeTncReservationsChecked(state) {
      if (state.tncReservations.checked.length && state.tncReservations.checked.length === 1) {
        var index = state.tncReservations.list.findIndex(function (x) {
          return x.id === state.tncReservations.checked[0];
        });
        state.tncReservations.list.splice(index, 1);
        state.tncReservations.checked = [];
      }
    },
    setTncReservationsMaxList: function setTncReservationsMaxList(state, value) {
      state.tncReservations.maxList = value;
    },
    setTncReservationsCurrentPage: function setTncReservationsCurrentPage(state, value) {
      state.tncReservations.currentPage = value;
    },
    setTncReservationsPerPage: function setTncReservationsPerPage(state, value) {
      state.tncReservations.perPage = value;
    },
    setTncReservationsOrder: function setTncReservationsOrder(state, value) {
      state.tncReservations.order = value;
    },
    setTncReservationsOrderAsc: function setTncReservationsOrderAsc(state, value) {
      state.tncReservations.orderAsc = value;
    },
    setTncReservationsIsLoading: function setTncReservationsIsLoading(state, value) {
      state.tncReservations.isLoading = value;
    },
    setTncReservationsSearch: function setTncReservationsSearch(state, value) {
      state.tncReservations.search = value;
    },
    setViewingInMap: function setViewingInMap(state, value) {
      state.tncReservations.viewingInMap = value;
    },
    setReadyToGoShow: function setReadyToGoShow(state, value) {
      state.readyToGo.show = value;
    },
    setReadyToGoID: function setReadyToGoID(state, value) {
      state.readyToGo.id = value;
    },
    setReadyToGoLoading: function setReadyToGoLoading(state, value) {
      state.readyToGo.loading = value;
    },
    setReadyToGoSuccess: function setReadyToGoSuccess(state, value) {
      state.readyToGo.success = value;
    },
    setReadyToGoTable: function setReadyToGoTable(state, value) {
      state.readyToGo.table = value;
    },
    setNotesShow: function setNotesShow(state, value) {
      state.notes.show = value;
    },
    setNotesMessage: function setNotesMessage(state, value) {
      state.notes.message = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    unroutedReservations: {
      list: [],
      checked: [],
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      order: 'cb.pickupTime',
      orderAsc: 1,
      type: 'all',
      isLoading: false,
      search: ''
    }
  },
  mutations: {
    resetUnroutedReservationsList: function resetUnroutedReservationsList(state) {
      state.unroutedReservations.list = [];
    },
    addUnroutedReservation: function addUnroutedReservation(state, value) {
      state.unroutedReservations.list.push(value);
    },
    setUnroutedReservationsChecked: function setUnroutedReservationsChecked(state, value) {
      state.unroutedReservations.checked = value;
    },
    removeUnroutedReservation: function removeUnroutedReservation(state) {
      if (state.unroutedReservations.checked.length && state.unroutedReservations.checked.length === 1) {
        var index = state.unroutedReservations.list.findIndex(function (x) {
          return x.id === state.unroutedReservations.checked[0];
        });
        state.unroutedReservations.list.splice(index, 1);
        state.unroutedReservations.checked = [];
      }
    },
    setUnroutedReservationsMaxList: function setUnroutedReservationsMaxList(state, value) {
      state.unroutedReservations.maxList = value;
    },
    setUnroutedReservationsCurrentPage: function setUnroutedReservationsCurrentPage(state, value) {
      state.unroutedReservations.currentPage = value;
    },
    setUnroutedReservationsPerPage: function setUnroutedReservationsPerPage(state, value) {
      state.unroutedReservations.perPage = value;
    },
    setUnroutedReservationsOrder: function setUnroutedReservationsOrder(state, value) {
      state.unroutedReservations.order = value;
    },
    setUnroutedReservationsOrderAsc: function setUnroutedReservationsOrderAsc(state, value) {
      state.unroutedReservations.orderAsc = value;
    },
    setUnroutedReservationsIsLoading: function setUnroutedReservationsIsLoading(state, value) {
      state.unroutedReservations.isLoading = value;
    },
    setUnroutedReservationsSearch: function setUnroutedReservationsSearch(state, value) {
      state.unroutedReservations.search = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    driverInbound: {
      list: [],
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      orderAsc: 1,
      isLoading: false,
      licenseType: 'all'
    }
  },
  mutations: {
    resetdriverInboundList: function resetdriverInboundList(state) {
      state.driverInbound.list = [];
    },
    adddriverInbound: function adddriverInbound(state, value) {
      state.driverInbound.list.push(value);
    },
    setdriverInboundIsLoading: function setdriverInboundIsLoading(state, value) {
      state.driverInbound.isLoading = value;
    },
    setdriverInboundLicenseType: function setdriverInboundLicenseType(state, value) {
      state.driverInbound.licenseType = value;
    },
    setdriverInboundCurrentPage: function setdriverInboundCurrentPage(state, value) {
      state.driverInbound.currentPage = value;
    },
    setdriverInboundMaxList: function setdriverInboundMaxList(state, value) {
      state.driverInbound.maxList = value;
    }
  }
});

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    driverOutbound: {
      list: [],
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      orderAsc: 1,
      isLoading: false,
      licenseType: 'all'
    }
  },
  mutations: {
    resetDriverOutboundList: function resetDriverOutboundList(state) {
      state.driverOutbound.list = [];
    },
    addDriverOutbound: function addDriverOutbound(state, value) {
      state.driverOutbound.list.push(value);
    },
    setDriverOutboundIsLoading: function setDriverOutboundIsLoading(state, value) {
      state.driverOutbound.isLoading = value;
    },
    setDriverOutboundLicenseType: function setDriverOutboundLicenseType(state, value) {
      state.driverOutbound.licenseType = value;
    },
    setDriverOutboundCurrentPage: function setDriverOutboundCurrentPage(state, value) {
      state.driverOutbound.currentPage = value;
    },
    setDriverOutboundMaxList: function setDriverOutboundMaxList(state, value) {
      state.driverOutbound.maxList = value;
    }
  }
});

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    driverTNC: {
      stagingType: 'all'
    },
    driverTCP: {
      stagingType: 'all'
    },
    stagingLists: []
  },
  mutations: {
    setDriverTNCstagingType: function setDriverTNCstagingType(state, value) {
      state.driverTNC.stagingType = value;
    },
    setDriverTCPstagingType: function setDriverTCPstagingType(state, value) {
      state.driverTCP.stagingType = value;
    },
    setDriverStagingLists: function setDriverStagingLists(state, value) {
      state.stagingLists = value;
    }
  }
});

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    selectedDriver: null,
    onDuty: {
      list: [],
      loading: false,
      pageNum: 1,
      pageSize: 20,
      totalPages: 0,
      noDriversFound: false,
      order: 'ID',
      asc: true
    },
    sortTypeTNC: 'priority',
    sortTypeTCP: 'priority'
  },
  mutations: {
    setSelectedDriver: function setSelectedDriver(state, value) {
      state.selectedDriver = value;
    },
    setOnDutyDrivers: function setOnDutyDrivers(state, drivers) {
      state.onDuty.drivers = drivers;
    },
    setOnDutyLoading: function setOnDutyLoading(state, value) {
      state.onDuty.loading = value;
    },
    setOnDutyPageNumber: function setOnDutyPageNumber(state, value) {
      state.onDuty.pageNum = value;
    },
    setOnDutyTotalPages: function setOnDutyTotalPages(state, total) {
      state.onDuty.totalPages = Math.ceil(total / state.onDuty.pageSize);
    },
    addToOnDutyDrivers: function addToOnDutyDrivers(state, driver) {
      state.onDuty.drivers.unshift(driver);
    },
    setOnDutyNoDriversFound: function setOnDutyNoDriversFound(state, value) {
      state.onDuty.noDriversFound = value;
    },
    setOnDutySorting: function setOnDutySorting(state, value) {
      state.onDuty.order = value.order;
      state.onDuty.asc = value.asc;
    },
    removeFromOnDutyDrivers: function removeFromOnDutyDrivers(state, driverId) {
      if (state.onDuty.drivers.length <= 0) {
        state.onDuty.pageNum = 1;
        state.onDuty.totalPages = 0;
        return;
      }
      var drivers = state.onDuty.drivers;
      state.onDuty.drivers = drivers.filter(function (driver) {
        return driver.id !== driverId;
      });
      if (state.onDuty.drivers.length <= 0) {
        state.onDuty.pageNum = 1;
        state.onDuty.totalPages = 0;
      }
    },
    setTNCSortType: function setTNCSortType(state, value) {
      state.sortTypeTNC = value;
    },
    setTCPSortType: function setTCPSortType(state, value) {
      state.sortTypeTCP = value;
    }
  }
});

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    show: false
  },
  mutations: {
    show: function show(state) {
      state.show = true;
    },
    hide: function hide(state) {
      state.show = false;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    package: null
  },
  mutations: {
    setPackage: function setPackage(state, value) {
      state.package = value;
    }
  }
});

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    ongoing: false,
    phone: '',
    name: '',
    isMute: false
  },
  mutations: {
    startCall: function startCall(state, user) {
      state.ongoing = true;
      state.phone = user.phone;
      state.name = user.name;
      state.isMute = false;
    },
    endCall: function endCall(state) {
      state.ongoing = false;
      state.phone = '';
      state.name = '';
      state.isMute = false;
    },
    setMute: function setMute(state, value) {
      state.isMute = value;
    }
  },
  sharedMutations: ['phone/startCall', 'phone/endCall', 'phone/setReady']
});

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__promo__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_area__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_types__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logs__ = __webpack_require__(941);






var sharedMutations = [];

/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__promo__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_2__service_area__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_3__service_types__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_4__logs__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__promo__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_2__service_area__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_3__service_types__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_4__logs__["a" /* default */].mutations),
  sharedMutations: sharedMutations
});

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    promo: {
      show: false,
      refreshID: null,
      list: []
    }
  },
  mutations: {
    setGeofencePromoShow: function setGeofencePromoShow(state, value) {
      state.promo.show = value;
      state.promo.refreshID = null;
    },
    setGeofencePromoList: function setGeofencePromoList(state, value) {
      state.promo.list = value;
    },
    setGeofencePromoRefreshID: function setGeofencePromoRefreshID(state, value) {
      state.promo.refreshID = value;
    }
  }
});

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    brandId: '',
    serviceArea: {
      activeId: 0,
      list: [],
      maxList: 0,
      currentPage: 1,
      perPage: 15,
      orderAsc: 1,
      search: '',
      isLoading: false,
      discountStart: '',
      discountEnd: '',
      discountWidget: false,
      discountAdmin: false,
      discountApp: false,
      discountCSR: false,
      holidayDate: '',
      holidayDate2: '',
      holidayDate3: '',
      holidayDate4: '',
      holidayDate5: '',
      holidayDate6: '',
      holidayDate7: '',
      holidayDate8: '',
      holidayDate9: '',
      holidayDate10: '',
      asapDiscountStart: '',
      asapDiscountEnd: '',
      asapDiscountWidget: false,
      asapDiscountAdmin: false,
      asapDiscountApp: false,
      asapDiscountCSR: false,
      asapHolidayDate: '',
      asapHolidayDate2: '',
      asapHolidayDate3: '',
      asapHolidayDate4: '',
      asapHolidayDate5: '',
      asapHolidayDate6: '',
      asapHolidayDate7: '',
      asapHolidayDate8: '',
      asapHolidayDate9: '',
      asapHolidayDate10: '',
      charterDiscountStart: '',
      charterDiscountEnd: '',
      charterHolidayDate: '',
      charterHolidayDate2: '',
      charterHolidayDate3: '',
      charterHolidayDate4: '',
      charterHolidayDate5: '',
      charterHolidayDate6: '',
      charterHolidayDate7: '',
      charterHolidayDate8: '',
      charterHolidayDate9: '',
      charterHolidayDate10: ''
    }
  },
  mutations: {
    setBrandId: function setBrandId(state, value) {
      state.brandId = value;
    },

    // resetServiceAreas (state) { state.serviceArea.list = [] },
    setServiceAreaActiveId: function setServiceAreaActiveId(state, value) {
      state.serviceArea.activeId = value;
    },
    clearServiceAreaList: function clearServiceAreaList(state) {
      state.serviceArea.list = [];
    },
    setServiceAreaList: function setServiceAreaList(state, value) {
      state.serviceArea.list = value;
    },
    setServiceAreaMaxList: function setServiceAreaMaxList(state, value) {
      state.serviceArea.maxList = value;
    },
    setServiceAreaCurrentPage: function setServiceAreaCurrentPage(state, value) {
      state.serviceArea.currentPage = value;
    },
    setServiceAreaPerPage: function setServiceAreaPerPage(state, value) {
      state.serviceArea.perPage = value;
    },
    setServiceAreaOrderAsc: function setServiceAreaOrderAsc(state, value) {
      state.serviceArea.orderAsc = value;
    },
    setServiceAreaSearch: function setServiceAreaSearch(state, value) {
      state.serviceArea.search = value;
    },
    setServiceAreaIsLoading: function setServiceAreaIsLoading(state, value) {
      state.serviceArea.isLoading = value;
    },
    setDiscountStart: function setDiscountStart(state, value) {
      state.serviceArea.discountStart = value;
    },
    setDiscountEnd: function setDiscountEnd(state, value) {
      state.serviceArea.discountEnd = value;
    },
    setHolidayDate: function setHolidayDate(state, value) {
      state.serviceArea.holidayDate = value;
    },
    setAsapDiscountStart: function setAsapDiscountStart(state, value) {
      state.serviceArea.asapDiscountStart = value;
    },
    setAsapDiscountEnd: function setAsapDiscountEnd(state, value) {
      state.serviceArea.asapDiscountEnd = value;
    },
    setAsapHolidayDate: function setAsapHolidayDate(state, value) {
      state.serviceArea.asapHolidayDate = value;
    },
    setServiceAreaCharterData: function setServiceAreaCharterData(state, data) {
      for (var field in data) {
        state.serviceArea[field] = data[field];
      }
    },
    setHolidayData: function setHolidayData(state, data) {
      var holiday = data.type === 'asap' ? 'asapHolidayDate' : 'holidayDate';
      if (data.index === 1) {
        state.serviceArea['' + holiday] = data.value;
      } else {
        state.serviceArea['' + holiday + data.index] = data.value;
      }
    },
    setCharterHolidayData: function setCharterHolidayData(state, data) {
      if (data.index === 1) {
        state.serviceArea.charterHolidayDate = data.value;
      } else {
        state.serviceArea['charterHolidayDate' + data.index] = data.value;
      }
    },
    setDcType: function setDcType(state, data) {
      state.serviceArea[data.field] = data.value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    saving: false,
    serviceTypes: {
      list: [],
      isLoading: false,
      isClickable: false,
      enableList: [],
      disableList: []
    },
    global: {
      pickupTypes: [],
      pickupTypesCharter: []
    }
  },
  mutations: {
    clearServiceTypes: function clearServiceTypes(state) {
      state.serviceTypes.list = [];
    },
    addServiceTypes: function addServiceTypes(state, value) {
      state.serviceTypes.list.push(value);
    },
    updateServiceTypeData: function updateServiceTypeData(state, data) {
      var index = state.serviceTypes.list.findIndex(function (x) {
        return x.id === data.id;
      });
      if (index > -1) {
        state.serviceTypes.list[index] = data;
      }
    },
    updateServiceTypeField: function updateServiceTypeField(state, data) {
      var index = state.serviceTypes.list.findIndex(function (x) {
        return x.id === data.id;
      });
      if (index > -1) {
        state.serviceTypes.list[index][data.type][data.field] = data.value;
      }
    },
    updateServiceTypeEnable: function updateServiceTypeEnable(state, data) {
      var index = state.serviceTypes.list.findIndex(function (x) {
        return x.id === data.id;
      });
      if (index > -1) {
        state.serviceTypes.list[index][data.field] = data.value;
      }
    },
    updateServiceTypePickupType: function updateServiceTypePickupType(state, data) {
      var index = state.serviceTypes.list.findIndex(function (x) {
        return x.id === data.id;
      });
      if (index > -1) {
        if (!state.serviceTypes.list[index].pickupTypes[data.type]) {
          state.serviceTypes.list[index].pickupTypes[data.type] = {
            name: data.type
          };
        }
        state.serviceTypes.list[index].pickupTypes[data.type][data.field] = data.value;
      }
    },
    setSaving: function setSaving(state, value) {
      state.saving = value;
    },
    setServiceTypesIsloading: function setServiceTypesIsloading(state, value) {
      state.serviceTypes.isLoading = value;
    },
    setServiceTypesIsClickable: function setServiceTypesIsClickable(state, value) {
      state.serviceTypes.isClickable = value;
    },
    updateEnableList: function updateEnableList(state, value) {
      var index = state.serviceTypes.enableList.indexOf(value);
      if (index > -1) {
        state.serviceTypes.enableList.splice(index, 1);
      } else {
        state.serviceTypes.enableList.push(value);
        var disableIndex = state.serviceTypes.disableList.indexOf(value);
        if (disableIndex > -1) {
          state.serviceTypes.disableList.splice(disableIndex, 1);
        }
      }
    },
    updateDisableList: function updateDisableList(state, value) {
      var index = state.serviceTypes.disableList.indexOf(value);
      if (index > -1) {
        state.serviceTypes.disableList.splice(index, 1);
      } else {
        state.serviceTypes.disableList.push(value);
        var enableIndex = state.serviceTypes.enableList.indexOf(value);
        if (enableIndex > -1) {
          state.serviceTypes.enableList.splice(enableIndex, 1);
        }
      }
    },
    resetEnableList: function resetEnableList(state) {
      state.serviceTypes.enableList = [];
      state.serviceTypes.disableList = [];
    },
    setGlobalData: function setGlobalData(state, data) {
      for (var field in data) {
        state.global[field] = data[field];
      }
    },
    updateGlobalPickupTypeData: function updateGlobalPickupTypeData(state, data) {
      state.global.pickupTypes[data.index].pickupTypes[data.type].enabled = data.value;
    },
    updateGlobalPickupTypeCharterData: function updateGlobalPickupTypeCharterData(state, data) {
      state.global.pickupTypesCharter[data.index].pickupTypes[data.type].enabled = data.value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    logs: {
      show: false,
      loading: false,
      current: '',
      list: []
    },
    originalData: []
  },
  mutations: {
    setLogsData: function setLogsData(state, data) {
      for (var field in data) {
        state.logs[field] = data[field];
      }
    },
    setOriginalData: function setOriginalData(state, val) {
      state.originalData = val;
    }
  }
});

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__list__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_list__ = __webpack_require__(944);




var sharedMutations = [];
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_1__list__["a" /* default */].sharedMutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__list__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_2__view_list__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__list__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_2__view_list__["a" /* default */].mutations),
  sharedMutations: sharedMutations
});

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    list: [],
    loading: false,
    search: '',
    currentPage: 1,
    perPage: 20,
    order: 'id',
    orderAsc: 0,
    maxList: 0,
    rerender: false,
    showAdd: false
  },
  mutations: {
    setList: function setList(state, value) {
      state.list = value;
    },
    setLoading: function setLoading(state, value) {
      state.loading = value;
    },
    setSearch: function setSearch(state, value) {
      state.search = value;
    },
    setCurrentPage: function setCurrentPage(state, value) {
      state.currentPage = value;
    },
    setPerPage: function setPerPage(state, value) {
      state.perPage = value;
    },
    setOrder: function setOrder(state, value) {
      state.order = value;
    },
    setOrderAsc: function setOrderAsc(state, value) {
      state.orderAsc = value;
    },
    setMaxList: function setMaxList(state, value) {
      state.maxList = value;
    },
    updateEnable: function updateEnable(state, data) {
      var index = state.list.findIndex(function (x) {
        return x.id === data.id;
      });
      if (index > -1) {
        state.list[index].enabled = data.enable;
      }
    },
    setRerender: function setRerender(state, value) {
      state.rerender = value;
    },
    setShowAdd: function setShowAdd(state, value) {
      state.showAdd = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    view: {
      details: {},
      list: [],
      loading: false,
      currentPage: 1,
      perPage: 20,
      order: 'id',
      orderAsc: 0,
      maxList: 0,
      saving: false
    }
  },
  mutations: {
    setViewDetails: function setViewDetails(state, value) {
      state.view.details = value;
    },
    setViewList: function setViewList(state, value) {
      state.view.list = value;
    },
    setViewLoading: function setViewLoading(state, value) {
      state.view.loading = value;
    },
    setViewCurrentPage: function setViewCurrentPage(state, value) {
      state.view.currentPage = value;
    },
    setViewPerPage: function setViewPerPage(state, value) {
      state.view.perPage = value;
    },
    setViewOrder: function setViewOrder(state, value) {
      state.view.order = value;
    },
    setViewOrderAsc: function setViewOrderAsc(state, value) {
      state.view.orderAsc = value;
    },
    setViewMaxList: function setViewMaxList(state, value) {
      state.view.maxList = value;
    },
    setViewSaving: function setViewSaving(state, value) {
      state.view.saving = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__availability__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__list__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logs__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notes__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__payout_form__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reservations__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reviews__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shift_form__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__user_info__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__admin__ = __webpack_require__(955);












var sharedMutations = [];
// sharedMutations = sharedMutations.concat(availability.sharedMutations)
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_2__list__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_4__notes__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_6__reservations__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_7__reviews__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_9__user_info__["a" /* default */].sharedMutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_10__admin__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_1__availability__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_2__list__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_3__logs__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_4__notes__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_5__payout_form__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_6__reservations__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_7__reviews__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_8__shift_form__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_9__user_info__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_10__admin__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_1__availability__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_2__list__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_3__logs__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_4__notes__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_5__payout_form__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_6__reservations__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_7__reviews__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_8__shift_form__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_9__user_info__["a" /* default */].mutations),
  sharedMutations: sharedMutations
});

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    availability: {
      list: [],
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      order: 'startShift',
      orderAsc: 1,
      loading: false,
      sector: 0,
      since: '',
      until: '',
      type: '',
      vehicleType: '',
      service: '',
      assignedTrips: '',
      checked: [],
      noShift: {
        list: [],
        order: 'name',
        orderAsc: 1,
        perPage: 20,
        currentPage: 1,
        maxList: 0
      }
    },
    sectors: {
      list: [],
      loading: false
    }
  },
  mutations: {
    resetAvailabilityList: function resetAvailabilityList(state) {
      state.availability.list = [];
    },
    setAvailabilityList: function setAvailabilityList(state, value) {
      state.availability.list = value;
    },
    setAvailabilityMaxList: function setAvailabilityMaxList(state, value) {
      state.availability.maxList = value;
    },
    setAvailabilityCurrentPage: function setAvailabilityCurrentPage(state, value) {
      state.availability.currentPage = value;
    },
    setAvailabilityPerPage: function setAvailabilityPerPage(state, value) {
      state.availability.perPage = value;
    },
    setAvailabilityOrder: function setAvailabilityOrder(state, value) {
      state.availability.order = value;
    },
    setAvailabilityOrderAsc: function setAvailabilityOrderAsc(state, value) {
      state.availability.orderAsc = value;
    },
    setAvailabilityIsLoading: function setAvailabilityIsLoading(state, value) {
      state.availability.loading = value;
    },
    setAvailabilitySector: function setAvailabilitySector(state, value) {
      state.availability.sector = value;
    },
    setSectorsList: function setSectorsList(state, value) {
      state.sectors.list = value;
    },
    setSectorLoading: function setSectorLoading(state, value) {
      state.sectors.loading = value;
    },
    setAvailabilitySince: function setAvailabilitySince(state, value) {
      state.availability.since = value;
    },
    setAvailabilityUntil: function setAvailabilityUntil(state, value) {
      state.availability.until = value;
    },
    setAvailabilityType: function setAvailabilityType(state, value) {
      state.availability.type = value;
    },
    setAvailabilityService: function setAvailabilityService(state, value) {
      state.availability.service = value;
    },
    setAvailabilityAssignedTrips: function setAvailabilityAssignedTrips(state, value) {
      state.availability.assignedTrips = value;
    },
    setAvailabilityChecked: function setAvailabilityChecked(state, value) {
      state.availability.checked = value;
    },
    setAvailabilityData: function setAvailabilityData(state, data) {
      for (var field in data) {
        state.availability[field] = data[field];
      }
    },
    setAvailabilityNoShiftData: function setAvailabilityNoShiftData(state, data) {
      for (var field in data) {
        state.availability.noShift[field] = data[field];
      }
    }
  }
});

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    users: {
      list: [],
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      order: 'modified',
      orderAsc: 0,

      type: 'all',
      isLoading: false,
      status: 'activated',
      serviceFilter: '',
      search: '',
      selectedUser: [],
      serviceType: '',

      tnc: {
        list: [],
        maxList: 0,
        currentPage: 1,
        perPage: 20,
        order: 'created',
        orderAsc: 0,
        loading: false,
        selectedUser: []
      },
      tcp: {
        list: [],
        maxList: 0,
        currentPage: 1,
        perPage: 20,
        order: 'created',
        orderAsc: 0,
        loading: false,
        selectedUser: []
      },
      psc: {
        list: [],
        maxList: 0,
        currentPage: 1,
        perPage: 20,
        order: 'created',
        orderAsc: 0,
        loading: false,
        selectedUser: []
      }
    }
  },
  mutations: {
    resetUsers: function resetUsers(state, value) {
      state.users[value].list = [];
    },
    addUser: function addUser(state, value) {
      state.users[value.target].list.push(value);
    },
    setUserMaxList: function setUserMaxList(state, data) {
      state.users[data.target].maxList = data.value;
    },
    setUserCurrentPage: function setUserCurrentPage(state, data) {
      state.users[data.target].currentPage = data.value;
    },
    setUserPerPage: function setUserPerPage(state, data) {
      state.users[data.target].perPage = data.value;
    },
    setUserOrder: function setUserOrder(state, data) {
      state.users[data.target].order = data.value;
    },
    setUserOrderAsc: function setUserOrderAsc(state, data) {
      state.users[data.target].orderAsc = data.value;
    },
    setUserType: function setUserType(state, value) {
      state.users.type = value;
    },
    setUserIsLoading: function setUserIsLoading(state, data) {
      state.users[data.target].loading = data.value;
    },
    setUserStatus: function setUserStatus(state, value) {
      state.users.status = value;
    },
    setUserServiceFilter: function setUserServiceFilter(state, value) {
      state.users.serviceFilter = value;
    },
    setUserSearch: function setUserSearch(state, value) {
      state.users.search = value;
    },
    setUserSelected: function setUserSelected(state, data) {
      state.users[data.target].selectedUser = data.value;
    },
    setUserServiceType: function setUserServiceType(state, value) {
      state.users.serviceType = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    logs: {
      list: [],
      loading: false,
      pageNum: 1,
      pageSize: 20,
      since: null,
      until: null,
      reachMax: false,

      profileHistory: {
        list: [],
        loading: false,
        pageNum: 1,
        pageSize: 20,
        since: null,
        until: null,
        reachMax: false
      },
      activityHistory: {
        list: [],
        loading: false,
        pageNum: 1,
        pageSize: 20,
        since: null,
        until: null,
        reachMax: false
      }
    }
  },
  mutations: {
    addLogs: function addLogs(state, value) {
      state.logs.list.push(value);
    },
    setLogsField: function setLogsField(state, data) {
      state.logs[data.field] = data.value;
      for (var field in data.fields) {
        state.logs[field] = data.fields[field];
      }
    },
    addProfileHistory: function addProfileHistory(state, value) {
      state.logs.profileHistory.list.push(value);
    },
    setProfileHistoryField: function setProfileHistoryField(state, data) {
      state.logs.profileHistory[data.field] = data.value;
      for (var field in data.fields) {
        state.logs.profileHistory[field] = data.fields[field];
      }
    },
    addActivityHistory: function addActivityHistory(state, value) {
      state.logs.activityHistory.list.push(value);
    },
    setActivityHistoryField: function setActivityHistoryField(state, data) {
      state.logs.activityHistory[data.field] = data.value;
      for (var field in data.fields) {
        state.logs.activityHistory[field] = data.fields[field];
      }
    }
  }
});

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    notes: {
      list: [],
      pageNum: 0,
      pageSize: 20,
      isMax: false,
      noteDeleteId: 0
    }
  },
  mutations: {
    resetNotes: function resetNotes(state) {
      state.notes.list = [];
      state.notes.pageNum = 0;
    },
    addNotes: function addNotes(state, value) {
      state.notes.list.push(value);
    },
    setNotesPage: function setNotesPage(state, value) {
      state.notes.pageNum = value;
    },
    setNotesIsMax: function setNotesIsMax(state, value) {
      state.notes.isMax = value;
    },
    addNewNotes: function addNewNotes(state, value) {
      state.notes.list.unshift(value);
    },
    setNoteDeleteId: function setNoteDeleteId(state, value) {
      state.notes.noteDeleteId = value;
    },
    updateNote: function updateNote(state, value) {
      var i = state.notes.list.findIndex(function (x) {
        return x.id === value.id;
      });
      if (i !== -1) {
        state.notes.list[i].message = value.message;
        state.notes.list[i].status = value.status;
      }
    },
    deleteNote: function deleteNote(state, value) {
      var i = state.notes.list.findIndex(function (x) {
        return x.id === value;
      });
      if (i !== -1) {
        state.notes.list.splice(i, 1);
      }
    }
  },
  sharedMutations: []
});

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    payoutForm: {
      show: false,
      form: {
        id: null,
        type: 'credit',
        transactionType: 'other',
        amount: 0,
        description: null,
        notes: null,
        reservationId: null,
        packageId: null
      },
      refresh: false
    },
    payoutNotes: {
      show: false,
      note: ''
    }
  },
  mutations: {
    setPayoutFormShow: function setPayoutFormShow(state, value) {
      state.payoutForm.show = value;
    },
    setPayoutFormNew: function setPayoutFormNew(state) {
      state.payoutForm.form = {
        id: null,
        type: 'credit',
        transactionType: 'other',
        amount: 0,
        description: '',
        notes: '',
        reservationId: null,
        packageId: null
      };
    },
    setPayoutFormForm: function setPayoutFormForm(state, value) {
      state.payoutForm.form = value;
    },
    setPayoutFormId: function setPayoutFormId(state, value) {
      state.payoutForm.form.id = value;
    },
    setPayoutFormType: function setPayoutFormType(state, value) {
      state.payoutForm.form.type = value;
    },
    setPayoutFormTransactionType: function setPayoutFormTransactionType(state, value) {
      state.payoutForm.form.transactionType = value;
    },
    setPayoutFormAmount: function setPayoutFormAmount(state, value) {
      state.payoutForm.form.amount = value;
    },
    setPayoutFormDescription: function setPayoutFormDescription(state, value) {
      state.payoutForm.form.description = value;
    },
    setPayoutFormNotes: function setPayoutFormNotes(state, value) {
      state.payoutForm.form.notes = value;
    },
    setPayoutFormReservationId: function setPayoutFormReservationId(state, value) {
      state.payoutForm.form.reservationId = value;
    },
    setPayoutFormPackageId: function setPayoutFormPackageId(state, value) {
      state.payoutForm.form.packageId = value;
    },
    setPayoutFormRefresh: function setPayoutFormRefresh(state, value) {
      state.payoutForm.refresh = value;
    },
    setPayoutNotes: function setPayoutNotes(state, value) {
      state.payoutNotes = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    upcoming: [],
    history: [],
    isMax: {
      upcoming: false,
      history: false
    },
    currentPage: {
      upcoming: 0,
      history: 0
    },
    fromTo: {
      upcomingTo: '',
      upcomingFrom: '',
      historyTo: '',
      historyFrom: ''
    },
    totalDriverPayment: {
      upcoming: {
        total: 0,
        loading: false
      },
      history: {
        total: 0,
        loading: false
      }
    },
    breakdown: {
      upcoming: [],
      history: [],
      deductions: []
    },
    rsvpPerPage: 20
  },
  mutations: {
    resetRsvp: function resetRsvp(state, value) {
      state[value] = [];
    },
    addRsvp: function addRsvp(state, value) {
      state[value.type].push(value.rsvp);
    },
    setCurrentPage: function setCurrentPage(state, value) {
      state.currentPage[value.type] = value.page;
    },
    setIsMax: function setIsMax(state, value) {
      state.isMax[value.type] = value.isMax;
    },
    setFromTo: function setFromTo(state, value) {
      state.fromTo[value.type + 'From'] = value.from;
      state.fromTo[value.type + 'To'] = value.to;
    },
    setTotalDriverPayment: function setTotalDriverPayment(state, data) {
      state.totalDriverPayment[data.type].total = data.value;
    },
    setTotalDriverPaymentLoading: function setTotalDriverPaymentLoading(state, data) {
      state.totalDriverPayment[data.type].loading = data.value;
    },
    setProviderBreakdown: function setProviderBreakdown(state, data) {
      state.breakdown[data.type] = data.value;
    },
    addProviderBreakdown: function addProviderBreakdown(state, data) {
      state.breakdown[data.type].push(data.value);
    }
  },
  sharedMutations: []
});

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    averageReviews: 0,
    fiveStarReviews: 0,
    totalReviews: 0,
    reviews: [],
    reviewMax: false,
    reviewPage: 0,
    reviewsPerPage: 20
  },
  mutations: {
    resetStatsReviews: function resetStatsReviews(state) {
      state.averageReviews = 0;
      state.fiveStarReviews = 0;
      state.totalReviews = 0;
    },
    setAverageTotalReviews: function setAverageTotalReviews(state, value) {
      state.averageReviews = value.average;
      state.totalReviews = value.total;
    },
    setFiveStarReview: function setFiveStarReview(state, value) {
      state.fiveStarReviews = value;
    },
    resetReviews: function resetReviews(state) {
      state.reviews = [];
    },
    addReviews: function addReviews(state, value) {
      state.reviews.push(value);
    },
    setReviewMax: function setReviewMax(state, value) {
      state.reviewMax = value;
    },
    setReviewPage: function setReviewPage(state, value) {
      state.reviewPage = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    shiftForm: {
      show: false,
      forHomeSector: false,
      title: 'Creating new shift',
      isEdit: false,
      save: false,
      shiftId: null,
      shiftDay: null,
      timeHour: 1,
      timeMinute: 0,
      timeAmPm: 'AM',
      shiftDuration: 1,
      sectors: [],
      selectedSector: -1,
      subsectors: [],
      selectedSubsector: -1
    }
  },
  mutations: {
    setShiftFormShow: function setShiftFormShow(state, value) {
      state.shiftForm.show = value;
    },
    setShiftFormForHomeSector: function setShiftFormForHomeSector(state, value) {
      state.shiftForm.forHomeSector = value;
    },
    setShiftFormTitle: function setShiftFormTitle(state, value) {
      state.shiftForm.title = value;
    },
    setShiftFormIsEdit: function setShiftFormIsEdit(state, value) {
      state.shiftForm.isEdit = value;
    },
    setShiftFormSave: function setShiftFormSave(state, value) {
      state.shiftForm.save = value;
    },
    setShiftFormShiftId: function setShiftFormShiftId(state, value) {
      state.shiftForm.shiftId = value;
    },
    setShiftFormShiftDay: function setShiftFormShiftDay(state, value) {
      state.shiftForm.shiftDay = value;
    },
    setShiftFormTimeHour: function setShiftFormTimeHour(state, value) {
      state.shiftForm.timeHour = value;
    },
    setShiftFormTimeMinute: function setShiftFormTimeMinute(state, value) {
      state.shiftForm.timeMinute = value;
    },
    setShiftFormTimeAmPm: function setShiftFormTimeAmPm(state, value) {
      state.shiftForm.timeAmPm = value;
    },
    setShiftFormShiftDuration: function setShiftFormShiftDuration(state, value) {
      state.shiftForm.shiftDuration = value;
    },
    setShiftFormSectors: function setShiftFormSectors(state, value) {
      state.shiftForm.sectors = value;
    },
    setShiftFormSelectedSector: function setShiftFormSelectedSector(state, value) {
      state.shiftForm.selectedSector = value;
    },
    setShiftFormSubsectors: function setShiftFormSubsectors(state, value) {
      state.shiftForm.subsectors = value;
    },
    setShiftFormSelectedSubsector: function setShiftFormSelectedSubsector(state, value) {
      state.shiftForm.selectedSubsector = value;
    }
  }
});

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    id: '',
    active: false,
    services: [],
    backgroundSubmitted: 0,
    backgroundPassed: 0,
    isTestAcct: false,
    maxDailyRsvpIsCustom: 0,
    maxDailyRsvp: 0,
    created: '',
    ptrsDriverAgreeUTC: '',
    basicInfo: {
      firstName: '',
      lastName: '',
      deviceOS: '',
      deviceModel: '',
      language: '',
      email: '',
      countryCode: '',
      phoneNumber: '',
      mobile: '',
      birthday: '',
      img: '',
      homeSectorId: null
    },
    vehicleInfo: {
      manufacturer: '',
      model: '',
      year: '',
      type: '',
      licensePlate: '',
      capacity: '',
      door: '',
      identificationNumber: '',
      wheelchair: '',
      serviceDog: '',
      img: ''
    },
    accountType: {
      tcpPermit: '',
      type: ''
    },
    businessInfo: {
      name: '',
      type: '',
      address: '',
      address2: '',
      city: '',
      country: '',
      state: '',
      zip: '',
      w9fileImg: ''
    },
    documentation: {
      insuranceCompany: '',
      insurancePolicy: '',
      insuranceExp: '',
      insuranceImg: '',
      cityLicense: '',
      cityLicenseExp: '',
      cityLicenseImg: '',
      tcpPermit: '',
      tcpPermitExp: '',
      tcpPermitImg: '',
      airportPermit: '',
      airportPermitExp: '',
      airportPermitImg: '',
      driversLicense: '',
      driversLicenseExp: '',
      driversLicenseImg: '',
      vehicleInspection: '',
      vehicleInspectionExp: '',
      vehicleInspectionImg: '',
      drivingRecordExp: '',
      drivingRecordImg: ''
    },
    eligibility: {
      convicted: '',
      conviction: '',
      ownVehicle: '',
      modifiedVehicle: '',
      driversLicense: ''
    },
    signature: '',
    homeAdress: '',
    formHasError: false,
    formLoading: false,
    formSave: {
      isDone: false,
      message: ''
    },
    upload: {
      error: false,
      show: false,
      ref: ''
    },
    serviceSave: {
      loading: false,
      modal: false,
      success: false,
      message: ''
    },
    isDoorToDoorEnabled: false,
    quickRes: {
      enable: false,
      loading: false,
      modal: false
    },
    driverId: '',
    driverIdLoading: false
  },
  mutations: {
    resetuserInfo: function resetuserInfo(state) {
      state.active = false;
      state.services = [];
      state.backgroundSubmitted = 0;
      state.backgroundPassed = 0;
      state.isTestAcct = false;
      state.maxDailyRsvpIsCustom = 0;
      state.maxDailyRsvp = 0;
      state.created = '';
      state.ptrsDriverAgreeUTC = '';
      state.basicInfo = {
        firstName: '',
        lastName: '',
        deviceOS: '',
        deviceModal: '',
        language: '',
        email: '',
        countryCode: '',
        phoneNumber: '',
        mobile: '',
        birthday: '',
        img: '',
        homeSectorId: null
      };
      state.vehicleInfo = {
        manufacturer: '',
        model: '',
        year: '',
        type: '',
        licensePlate: '',
        capacity: '',
        door: '',
        identificationNumber: '',
        wheelchair: '',
        serviceDog: '',
        img: ''
      };
      state.accountType = {
        tcpPermit: '',
        type: ''
      };
      state.businessInfo = {
        name: '',
        type: '',
        address: '',
        address2: '',
        city: '',
        country: '',
        state: '',
        zip: '',
        w9fileImg: ''
      };
      state.documentation = {
        insuranceCompany: '',
        insurancePolicy: '',
        insuranceExp: '',
        insuranceImg: '',
        cityLicense: '',
        cityLicenseExp: '',
        cityLicenseImg: '',
        tcpPermit: '',
        tcpPermitExp: '',
        tcpPermitImg: '',
        airportPermit: '',
        airportPermitExp: '',
        airportPermitImg: '',
        driversLicense: '',
        driversLicenseExp: '',
        driversLicenseImg: '',
        vehicleInspection: '',
        vehicleInspectionExp: '',
        vehicleInspectionImg: '',
        drivingRecordExp: '',
        drivingRecordImg: ''
      };
      state.eligibility = {
        convicted: '',
        conviction: '',
        ownVehicle: '',
        modifiedVehicle: '',
        driversLicense: ''
      };
      state.signature = '';
      state.homeAdress = '';
      state.formHasError = false;
      state.formLoading = false;
      state.formSave = {
        isDone: false,
        message: ''
      };
    },
    setUserInfo: function setUserInfo(state, value) {
      state.id = value.id;
      state.active = value.active;
      state.services = value.services;
      state.backgroundSubmitted = value.backgroundSubmitted;
      state.backgroundPassed = value.backgroundPassed;
      state.isTestAcct = value.isTestAcct;
      state.maxDailyRsvpIsCustom = value.maxDailyRsvpIsCustom;
      state.maxDailyRsvp = value.maxDailyRsvp;
      state.created = value.created;
      state.ptrsDriverAgreeUTC = value.ptrsDriverAgreeUTC;
      state.basicInfo = value.basicInfo;
      state.vehicleInfo = value.vehicleInfo;
      state.accountType = value.accountType;
      state.businessInfo = value.businessInfo;
      state.documentation = value.documentation;
      state.eligibility = value.eligibility;
      state.signature = value.signature;
      state.homeAdress = value.homeAdress;
    },
    setHomeSectorId: function setHomeSectorId(state, value) {
      state.basicInfo.homeSectorId = value;
    },
    setActive: function setActive(state, value) {
      state.active = value;
    },
    setAccountType: function setAccountType(state, value) {
      state.accountType.type = value;
    },
    setFormHasError: function setFormHasError(state, value) {
      state.formHasError = value;
    },
    setFormLoading: function setFormLoading(state, value) {
      state.formLoading = value;
    },
    setFormSavingDone: function setFormSavingDone(state, value) {
      state.formSave.isDone = value;
    },
    setFormSaveMessage: function setFormSaveMessage(state, value) {
      state.formSave.message = value;
    },
    showCropper: function showCropper(state, value) {
      state.upload.show = value.show;
      state.upload.ref = value.ref;
    },
    showUploadError: function showUploadError(state, value) {
      state.upload.error = value;
    },
    setServiceSaveLoading: function setServiceSaveLoading(state, value) {
      state.serviceSave.loading = value;
    },
    serviceSaveModal: function serviceSaveModal(state, value) {
      state.serviceSave.modal = value;
    },
    serviceSaveSuccess: function serviceSaveSuccess(state, data) {
      state.serviceSave.success = data.success;
      state.serviceSave.message = data.message;
    },
    setIsDoorToDoorEnabled: function setIsDoorToDoorEnabled(state, value) {
      state.isDoorToDoorEnabled = value;
    },
    setQuickResData: function setQuickResData(state, data) {
      for (var field in data) {
        state.quickRes[field] = data[field];
      }
    },
    setDriverId: function setDriverId(state, value) {
      state.driverId = value;
    },
    setDriverIdLoading: function setDriverIdLoading(state, value) {
      state.driverIdLoading = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    admin: {
      list: []
    }
  },
  mutations: {
    setAdmin: function setAdmin(state, value) {
      state.admin.list = value;
    }
  }
});

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deduction_form__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__deduction_list__ = __webpack_require__(958);




/* harmony default export */ __webpack_exports__["a"] = ({
  strict: false,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__deduction_form__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_2__deduction_list__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__deduction_form__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_2__deduction_list__["a" /* default */].mutations)
});

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    deductionForm: {
      show: false,
      interval: ['weekly', 'monthly'],
      weeklyAnchor: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
      monthlyAnchor: 31,
      id: null,
      name: '',
      description: '',
      amount: 0,
      effectiveStart: null,
      effectiveEnd: null,
      enabled: false,
      selectedInterval: 'weekly',
      selectedWeeklyAnchor: 'monday',
      selectedMonthlyAnchor: 1,
      applyTNC: false,
      applyTCP: false,
      applyPSC: false
    }
  },
  mutations: {
    setDeductionFormShow: function setDeductionFormShow(state, value) {
      state.deductionForm.show = value;
    },
    setDeductionFormId: function setDeductionFormId(state, value) {
      state.deductionForm.id = value;
    },
    setDeductionFormName: function setDeductionFormName(state, value) {
      state.deductionForm.name = value;
    },
    setDeductionFormDescription: function setDeductionFormDescription(state, value) {
      state.deductionForm.description = value;
    },
    setDeductionFormAmount: function setDeductionFormAmount(state, value) {
      state.deductionForm.amount = value;
    },
    setDeductionFormEffectiveStart: function setDeductionFormEffectiveStart(state, value) {
      state.deductionForm.effectiveStart = value;
    },
    setDeductionFormEffectiveEnd: function setDeductionFormEffectiveEnd(state, value) {
      state.deductionForm.effectiveEnd = value;
    },
    setDeductionFormEnabled: function setDeductionFormEnabled(state, value) {
      state.deductionForm.enabled = value;
    },
    setDeductionFormSelectedInterval: function setDeductionFormSelectedInterval(state, value) {
      state.deductionForm.selectedInterval = value;
    },
    setDeductionFormSelectedWeeklyAnchor: function setDeductionFormSelectedWeeklyAnchor(state, value) {
      state.deductionForm.selectedWeeklyAnchor = value;
    },
    setDeductionFormSelectedMonthlyAnchor: function setDeductionFormSelectedMonthlyAnchor(state, value) {
      state.deductionForm.selectedMonthlyAnchor = value;
    },
    setDeductionFormApplyTNC: function setDeductionFormApplyTNC(state, value) {
      state.deductionForm.applyTNC = value;
    },
    setDeductionFormApplyTCP: function setDeductionFormApplyTCP(state, value) {
      state.deductionForm.applyTCP = value;
    },
    setDeductionFormApplyPSC: function setDeductionFormApplyPSC(state, value) {
      state.deductionForm.applyPSC = value;
    }
  }
});

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    deductionList: {
      items: [],
      loading: false,
      reload: false
    },
    deductionDelete: {
      show: false,
      item: null
    }
  },
  mutations: {
    setDeductionListItems: function setDeductionListItems(state, value) {
      state.deductionList.items = value;
    },
    addDeductionListItem: function addDeductionListItem(state, value) {
      state.deductionList.items.push(value);
    },
    setDeductionListLoading: function setDeductionListLoading(state, value) {
      state.deductionList.loading = value;
    },
    setDeductionListReload: function setDeductionListReload(state, value) {
      state.deductionList.reload = value;
    },
    setDeductionDeleteShow: function setDeductionDeleteShow(state, value) {
      state.deductionDelete.show = value;
    },
    setDeductionDeleteItem: function setDeductionDeleteItem(state, value) {
      state.deductionDelete.item = value;
    }
  }
});

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    show: false,
    notes: ''
  },
  mutations: {
    show: function show(state, value) {
      state.show = value;
    },
    setNotes: function setNotes(state, value) {
      state.notes = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reports_rsvp__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reports_tnc__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reports_trx__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reports_specialize__ = __webpack_require__(964);






/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__reports_rsvp__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_2__reports_tnc__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_3__reports_trx__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_4__reports_specialize__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__reports_rsvp__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_2__reports_tnc__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_3__reports_trx__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_4__reports_specialize__["a" /* default */].mutations)
});

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    rsvpReport: {
      show: false
    }
  },
  mutations: {
    setShowRsvpReport: function setShowRsvpReport(state, value) {
      state.rsvpReport.show = value;
    }
  }
});

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    tncReport: {
      show: false
    }
  },
  mutations: {
    showTNCReport: function showTNCReport(state) {
      state.tncReport.show = true;
    },
    hideTNCReport: function hideTNCReport(state) {
      state.tncReport.show = false;
    }
  }
});

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    trxReport: {
      show: false
    }
  },
  mutations: {
    setShowTrxReport: function setShowTrxReport(state, value) {
      state.trxReport.show = value;
    }
  }
});

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    specializeReport: {
      show: false
    },
    directBill: {
      show: false
    },
    driverPayouts: {
      show: false
    }
  },
  mutations: {
    setShowSpecializeReport: function setShowSpecializeReport(state, value) {
      state.specializeReport.show = value;
    },
    setShowDirectBill: function setShowDirectBill(state, value) {
      state.directBill.show = value;
    },
    setDriverPayouts: function setDriverPayouts(state, value) {
      state.driverPayouts.show = value;
    }
  }
});

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reservation_filters__ = __webpack_require__(966);



var sharedMutations = [];

/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__reservation_filters__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__reservation_filters__["a" /* default */].mutations),
  sharedMutations: sharedMutations
});

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    reservationSearch: '',
    reservationFilters: [],
    selectedFilter: '-1',
    date: {
      from: '',
      to: ''
    },
    service: {
      shared: true,
      opoli: true,
      black: true,
      suv: true,
      shuttle: true
    },
    status: {
      upcoming: true,
      ready: true,
      'require-dispatch': true,
      dispatched: true,
      onboard: true,
      completed: true,
      cancelled: true
    }
  },
  mutations: {
    setReservationSearch: function setReservationSearch(state, value) {
      state.reservationSearch = value;
    },
    resetReservationSearch: function resetReservationSearch(state) {
      state.reservationSearch = '';
    },
    setReservationFilters: function setReservationFilters(state, filters) {
      state.reservationFilters = filters;
    },
    setSelectedFilter: function setSelectedFilter(state, value) {
      state.selectedFilter = value;
    },
    setDateFilter: function setDateFilter(state, data) {
      state.date[data.fromTo] = data.value;
    },
    setService: function setService(state, data) {
      state.service[data.service] = data.value;
    },
    setStatus: function setStatus(state, data) {
      state.status[data.status] = data.value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    show: false,
    noteId: null,
    notes: '',
    noteStatus: 'new',
    driverId: null,
    rsvpId: null,
    isPackage: false,
    label: '',
    action: '',
    actionType: '',
    actionData: '{}',
    forComplete: false,
    fromRsvpDetails: false,
    admins: [],
    isProv: false,
    isLyftService: false
  },
  mutations: {
    show: function show(state, value) {
      state.show = true;

      state.noteId = null;
      if (value.noteId) {
        state.noteId = value.noteId;
      }

      state.notes = '';
      if (value.notes) {
        state.notes = value.notes;
      }

      state.noteStatus = 'new';
      if (value.noteStatus) {
        state.noteStatus = value.noteStatus;
      }

      state.driverId = null;
      if (value.driverId) {
        state.driverId = value.driverId;
      }

      state.rsvpId = null;
      if (value.rsvpId) {
        state.rsvpId = value.rsvpId;
      }

      state.isPackage = false;
      if (value.isPackage) {
        state.isPackage = value.isPackage;
      }

      state.action = '';
      if (value.action) {
        state.action = value.action;
      }

      state.actionType = '';
      if (value.actionType) {
        state.actionType = value.actionType;
      }

      state.actionData = '{}';
      if (value.actionData) {
        state.actionData = value.actionData;
      }

      state.forComplete = false;
      if (value.forComplete) {
        state.forComplete = value.forComplete;
      }

      state.fromRsvpDetails = false;
      if (value.fromRsvpDetails) {
        state.fromRsvpDetails = value.fromRsvpDetails;
      }

      state.label = '';
      if (value.label) {
        state.label = value.label;
      }

      state.isProv = false;
      if (value.isProv) {
        state.isProv = value.isProv;
      }
    },
    hide: function hide(state) {
      state.show = false;
      state.noteId = null;
      state.notes = '';
      state.noteStatus = 'new';
      state.driverId = null;
      state.rsvpId = null;
      state.isPackage = false;
      state.actionType = '';
      state.actionData = '{}';
      state.forComplete = false;
      state.fromRsvpDetails = false;
      state.isLyftService = false;
    },
    setNotes: function setNotes(state, value) {
      state.notes = value;
    },
    setNoteStatus: function setNoteStatus(state, value) {
      state.noteStatus = value;
    },
    setAdmins: function setAdmins(state, value) {
      state.admins = value;
    },
    setNotesModalData: function setNotesModalData(state, data) {
      for (var field in data) {
        state[field] = data[field];
      }
    }
  },
  sharedMutations: ['reservationNotes/setAdmins']
});

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routing_dropzone__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routing_filters__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routing_modal__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routing_packages__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routing_reservations__ = __webpack_require__(973);







var sharedMutations = [];

/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__routing_dropzone__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_2__routing_filters__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_3__routing_modal__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_4__routing_packages__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_5__routing_reservations__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__routing_dropzone__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_2__routing_filters__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_3__routing_modal__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_4__routing_packages__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_5__routing_reservations__["a" /* default */].mutations)
});

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    dropzone: {
      show: false,
      items: [],
      checkRoute: false,
      drivers: []
    }
  },
  mutations: {
    setDropzoneShow: function setDropzoneShow(state, value) {
      state.dropzone.show = value;
    },
    setDropzoneItems: function setDropzoneItems(state, value) {
      state.dropzone.items = value;
    },
    addDropzoneItem: function addDropzoneItem(state, value) {
      if (value.type === 'rsvp') {
        state.dropzone.items.push(value.legs[0]); // pickup leg
        state.dropzone.items.push(value.legs[1]); // dropoff leg
        return;
      }

      for (var i = 0; i < value.legs.length; i++) {
        state.dropzone.items.push(value.legs[i]);
      }
    },
    updateDropzoneEta: function updateDropzoneEta(state, value) {
      var leg = value.leg;
      var eta = value.eta;
      var index = state.dropzone.items.findIndex(function (item, index, self) {
        return item.reservationID === leg.reservationID && item.packageID === leg.packageID && item.isPickup === leg.isPickup;
      });
      if (index > 0) {
        state.dropzone.items[index].eta = eta;
      }
    },
    removeDropzoneItem: function removeDropzoneItem(state, value) {
      var items = state.dropzone.items;

      /*
      state.dropzone.items = items.filter(
        item => item.packageID !== value.packageID ||
                item.reservationID !== value.reservationID ||
                item.isPickup !== value.isPickup)
      */

      state.dropzone.items = items.filter(function (item) {
        return item.reservationID !== value.reservationID;
      });
    },
    removeDropzoneItems: function removeDropzoneItems(state, value) {
      var items = state.dropzone.items;
      if (value.type === 'rsvp') {
        state.dropzone.items = items.filter(function (item) {
          return item.reservationID !== value.id;
        });
        return;
      }

      state.dropzone.items = items.filter(function (item) {
        return item.packageID !== value.id;
      });
    },
    clearDropzone: function clearDropzone(state) {
      state.dropzone = {
        show: false,
        items: [],
        checkRoute: false,
        drivers: []
      };
    },


    // Loading states
    setCheckRouteLoading: function setCheckRouteLoading(state, value) {
      state.dropzone.checkRoute = value;
    },


    // driver states
    setDropzoneDrivers: function setDropzoneDrivers(state, value) {
      state.dropzone.drivers = value;
    },
    removeDropzoneDrivers: function removeDropzoneDrivers(state) {
      state.dropzone.drivers = [];
    },
    addDropzoneDriver: function addDropzoneDriver(state, value) {
      state.dropzone.drivers.push(value);
    },
    removeDropzoneDriver: function removeDropzoneDriver(state, value) {
      var items = state.dropzone.drivers;
      state.dropzone.drivers = items.filter(function (item) {
        return item.packageID !== value.packageID || item.driver.id !== value.driver.id;
      });
    },
    removeDropzonePackageDriver: function removeDropzonePackageDriver(state, packageID) {
      var items = state.dropzone.drivers;
      state.dropzone.drivers = items.filter(function (item) {
        return item.packageID !== packageID;
      });
    }
  }
});

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    reservationSearch: '',
    reservationFilters: [],
    selectedFilter: '-1',
    beThereTimeThreshold: 0
  },
  mutations: {
    setReservationSearch: function setReservationSearch(state, value) {
      state.reservationSearch = value;
    },
    resetReservationSearch: function resetReservationSearch(state) {
      state.reservationSearch = '';
    },
    setReservationFilters: function setReservationFilters(state, filters) {
      state.reservationFilters = filters;
    },
    setSelectedFilter: function setSelectedFilter(state, value) {
      state.selectedFilter = value;
    },
    setBeThereTimeThreshold: function setBeThereTimeThreshold(state, value) {
      state.beThereTimeThreshold = value;
    }
  }
});

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    routingModal: {
      show: false,
      validation: {
        show: false,
        title: '',
        message: ''
      },
      ajax: {
        show: false,
        loading: false,
        success: false,
        message: ''
      },
      confirmation: {
        show: false,
        title: '',
        message: '',
        action: null
      }
    }
  },
  mutations: {
    // Modal Container
    showRoutingModal: function showRoutingModal(state) {
      state.routingModal.show = true;
    },
    hideRoutingModal: function hideRoutingModal(state) {
      state.routingModal.show = false;
      state.routingModal.validation = {
        show: false,
        title: '',
        message: ''
      };
      state.routingModal.ajax = {
        show: false,
        loading: false,
        success: false,
        message: ''
      };
      state.routingModal.confirmation = {
        show: false,
        title: '',
        message: '',
        action: null
      };
    },


    // ValidationModal
    setRoutingValidationModal: function setRoutingValidationModal(state, value) {
      state.routingModal.validation = value;
    },


    // Ajax Modal
    setRoutingAjaxModal: function setRoutingAjaxModal(state, value) {
      state.routingModal.ajax = value;
    },


    // Confirmation Modal
    setConfirmationModal: function setConfirmationModal(state, value) {
      state.routingModal.confirmation = value;
    },
    resetConfirmationModal: function resetConfirmationModal(state) {
      state.routingModal.confirmation = {
        show: false,
        title: '',
        message: '',
        action: null
      };
    }
  }
});

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    packages: {
      isLoading: false,
      items: [],
      checked: [],
      checkedForDispatch: [],
      paging: {
        currentPage: 1,
        pageSize: 20,
        totalPages: 0
      },
      sort: {
        order: 'p.pickupTime',
        asc: true
      },
      pickupTimeModal: {
        show: false,
        loading: false,
        success: false,
        message: '',
        id: 0,
        value: ''
      }
    },
    totalItem: {
      pkg: 0,
      rsvp: 0
    }
  },
  mutations: {
    // Packages
    setIsPackagesLoading: function setIsPackagesLoading(state, value) {
      state.packages.isLoading = value;
    },
    setPackageItems: function setPackageItems(state, value) {
      state.packages.items = value;
      state.packages.checked = [];
      state.packages.checkedForDispatch = [];
    },
    addPackage: function addPackage(state, value) {
      state.packages.items.push(value);
    },
    updatePackagePoolStatus: function updatePackagePoolStatus(state, value) {
      var index = state.packages.items.findIndex(function (opPackage) {
        return opPackage.id === value.id;
      });
      state.packages.items[index].inPool = value.inPool;
    },
    removePackageItem: function removePackageItem(state, id) {
      var index = state.packages.items.findIndex(function (opPackage) {
        return opPackage.id === id;
      });
      state.packages.items.splice(index, 1);
    },
    updatePackage: function updatePackage(state, value) {
      var items = state.packages.items;
      var index = items.findIndex(function (item) {
        return item.id === value.id;
      });
      if (index < 0) {
        return;
      }
      items[index] = value;
      state.package.items = items;
    },


    // Checked packages
    updateCheckedPackages: function updateCheckedPackages(state, value) {
      state.packages.checked = value;
    },
    clearCheckedPackages: function clearCheckedPackages(state) {
      state.packages.checked = [];
    },


    // Checked packages for dispatch
    updateCheckedPackagesForDispatch: function updateCheckedPackagesForDispatch(state, value) {
      state.packages.checkedForDispatch = value;
    },
    clearCheckedPackagesForDispatch: function clearCheckedPackagesForDispatch(state) {
      state.packages.checkedForDispatch = [];
    },


    // Paging mutations
    setPackageCurrentPage: function setPackageCurrentPage(state, value) {
      state.packages.paging.currentPage = value;
    },
    setPackageTotalPages: function setPackageTotalPages(state, totalItems) {
      state.packages.paging.totalPages = Math.ceil(totalItems / state.packages.paging.pageSize);
    },
    resetPackagePaging: function resetPackagePaging(state) {
      state.packages.paging = {
        currentPage: 1,
        pageSize: 20,
        totalPages: 0
      };
    },


    // Sorting mutations
    setPackagesSort: function setPackagesSort(state, value) {
      state.packages.sort = value;
    },
    setPickupTimeModal: function setPickupTimeModal(state, data) {
      for (var field in data) {
        state.packages.pickupTimeModal[field] = data[field];
      }
    },
    updatePickupDate: function updatePickupDate(state, data) {
      var index = state.packages.items.findIndex(function (x) {
        return x.id === data.id;
      });
      if (index > -1) {
        state.packages.items[index].pickupTime = data.value;
      }
    },
    setRoutingPkgTotal: function setRoutingPkgTotal(state, value) {
      state.totalItem.pkg = value;
    },
    setRoutingRsvpTotal: function setRoutingRsvpTotal(state, value) {
      state.totalItem.rsvp = value;
    },
    setPendingOffer: function setPendingOffer(state, data) {
      var i = state.packages.items.findIndex(function (x) {
        return x.id === data.id;
      });
      if (i > -1) {
        state.packages.items[i].pendingOffer = {
          show: data.show,
          timer: data.timer
        };
      }
    },
    updateRsvpStatus: function updateRsvpStatus(state, data) {
      var i = state.packages.items.findIndex(function (x) {
        return x.id === data.id;
      });
      if (i > -1) {
        state.packages.items[i].status = data.status;
        state.packages.items[i].statusClass = data.statusClass;
      }
    }
  }
});

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    reservations: {
      isLoading: false,
      items: [],
      checked: [],
      paging: {
        currentPage: 1,
        pageSize: 20,
        totalPages: 0
      },
      sort: {
        order: 'b.pickupTime',
        asc: true
      }
    }
  },
  mutations: {
    // Reservations
    setIsReservationsLoading: function setIsReservationsLoading(state, value) {
      state.reservations.isLoading = value;
    },
    setReservationItems: function setReservationItems(state, value) {
      state.reservations.items = value;
      state.reservations.checked = [];
    },
    pushRsvpItem: function pushRsvpItem(state, value) {
      state.reservations.items.push(value);
    },
    addReservation: function addReservation(state, value) {
      state.reservations.items.push(value);
    },


    // Checked reservations
    updateCheckedReservations: function updateCheckedReservations(state, value) {
      state.reservations.checked = value;
    },
    clearCheckedReservations: function clearCheckedReservations(state) {
      state.reservations.checked = [];
    },


    // Paging mutations
    setReservationsCurrentPage: function setReservationsCurrentPage(state, value) {
      state.reservations.paging.currentPage = value;
    },
    setReservationsTotalPages: function setReservationsTotalPages(state, totalItems) {
      state.reservations.paging.totalPages = Math.ceil(totalItems / state.reservations.paging.pageSize);
    },
    resetReservationsPaging: function resetReservationsPaging(state) {
      state.reservations.paging = {
        currentPage: 1,
        pageSize: 20,
        totalPages: 0
      };
    },


    // Sorting mutations
    setReservationsSort: function setReservationsSort(state, value) {
      state.reservations.sort = value;
    }
  }
});

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__add__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__asap__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__basic_information__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__edit__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__notes__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__transactions__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_logs__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dispatch_logs__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__charter__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__optin__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mtech__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__stripe__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lyft__ = __webpack_require__(987);















var sharedMutations = [];
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_3__basic_information__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_4__edit__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_5__notes__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_6__transactions__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_7__action_logs__["a" /* default */].sharedMutations);
sharedMutations = sharedMutations.concat(__WEBPACK_IMPORTED_MODULE_8__dispatch_logs__["a" /* default */].sharedMutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__add__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_2__asap__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_3__basic_information__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_4__edit__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_5__notes__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_6__transactions__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_7__action_logs__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_8__dispatch_logs__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_9__charter__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_10__optin__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_11__mtech__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_12__stripe__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_13__lyft__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__add__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_2__asap__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_3__basic_information__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_4__edit__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_5__notes__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_6__transactions__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_7__action_logs__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_8__dispatch_logs__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_9__charter__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_10__optin__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_11__mtech__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_12__stripe__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_13__lyft__["a" /* default */].mutations),
  sharedMutations: sharedMutations
});

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    isAdd: false,
    add: {},
    showSelectUser: false,
    userCard: {
      list: [],
      loading: false
    },
    showSelectCorporate: false,
    corporateCard: {
      list: [],
      loading: false
    },
    isCorporate: false,
    addLoading: false,
    asap: {
      enable: false,
      show: false,
      loading: false,
      noDriver: false,
      foundDriver: false,
      driverInfoLoading: false,
      bidId: '',
      driverInfo: {
        fullName: '',
        email: '',
        rating: '',
        profilePic: '',
        vehiclePick: '',
        model: '',
        plate: ''
      }
    },
    submitError: {
      show: false,
      message: ''
    }
  },
  mutations: {
    asapReset: function asapReset(state) {
      state.asap = {
        enable: false,
        show: false,
        loading: false,
        noDriver: false,
        foundDriver: false,
        driverInfoLoading: false,
        bidId: '',
        driverInfo: {
          fullName: '',
          email: '',
          rating: '',
          profilePic: '',
          vehiclePick: '',
          model: '',
          plate: ''
        }
      };
    },
    setIsAdd: function setIsAdd(state, value) {
      state.isAdd = value;
    },
    setShowSelectUser: function setShowSelectUser(state, value) {
      state.showSelectUser = value;
    },
    setUserCardList: function setUserCardList(state, value) {
      state.userCard.list = value;
    },
    setUserCardLoading: function setUserCardLoading(state, value) {
      state.userCard.loading = value;
    },
    setShowSelectCorporate: function setShowSelectCorporate(state, value) {
      state.showSelectCorporate = value;
    },
    setCorporateCardList: function setCorporateCardList(state, value) {
      state.corporateCard.list = value;
    },
    setCorporateCardLoading: function setCorporateCardLoading(state, value) {
      state.corporateCard.loading = value;
    },
    setIsCorporate: function setIsCorporate(state, value) {
      state.isCorporate = value;
    },
    setAddLoading: function setAddLoading(state, value) {
      state.addLoading = value;
    },
    setAsapEnable: function setAsapEnable(state, value) {
      state.asap.enable = value;
    },
    setAsapShow: function setAsapShow(state, value) {
      state.asap.show = value;
    },
    setAsapLoading: function setAsapLoading(state, value) {
      state.asap.loading = value;
    },
    setNoDriver: function setNoDriver(state, value) {
      state.asap.noDriver = value;
    },
    setFoundDriver: function setFoundDriver(state, value) {
      state.asap.foundDriver = value;
    },
    setDriverInfoLoading: function setDriverInfoLoading(state, value) {
      state.asap.driverInfoLoading = value;
    },
    setDriverInfo: function setDriverInfo(state, value) {
      state.asap.driverInfoLoading = value;
    },
    setAsapBidId: function setAsapBidId(state, value) {
      state.asap.bidId = value;
    },
    setSubmitError: function setSubmitError(state, data) {
      state.submitError = {
        show: data.show,
        message: data.message
      };
    }
  },
  sharedMutations: []
});

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    asapRequest: {
      show: false,
      data: '',
      customer: ''
    }
  },
  mutations: {
    setAsapModal: function setAsapModal(state, value) {
      state.asapRequest.show = value;
    },
    setAsapData: function setAsapData(state, value) {
      state.asapRequest.data = value;
    },
    setAsapCustomer: function setAsapCustomer(state, value) {
      state.asapRequest.customer = value;
    }
  }
});

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    rsvpId: '',
    basicInfo: {
      tripInfo: {
        id: '',
        brandId: '',
        brand: '',
        brandColor: '',
        packageId: '',
        bookedThrough: '',
        status: '',
        bidId: '',
        bidStatus: '',
        created: '',
        pickupDate: '',
        fare: '',
        driverPayment: '',
        driverBonus: '',
        paymentBonus: '',
        tip: '',
        airportFee: '',
        pickupFee: '',
        credits: '',
        serviceType: '',
        serviceTypeId: '',
        serviceLabel: '',
        serviceCode: '',
        pickup: '',
        dropoff: '',
        aptGate: '',
        eta: '',
        beThereTime: '',
        distance: '',
        airline: '',
        airlineCode: '',
        flightNo: '',
        passenger: '',
        luggage: '',
        notes: '',
        serviceArea: '',
        wheelchair: '',
        serviceDog: '',
        overridePrice: '',
        overridePayment: '',
        rating: '',
        userReview: '',
        isCharter: false,
        isRental: false,
        optinShared: false
      },
      customerInfo: {
        id: '',
        firstName: '',
        lastName: '',
        creditCard: '',
        cardTitle: '',
        creditCardId: '',
        email: '',
        mobile: ''
      },
      guestInfo: {
        firstname: '',
        lastName: '',
        mobile: ''
      },
      driverInfo: {
        id: '',
        firstName: '',
        lastName: '',
        rating: '',
        driversLicense: '',
        licensePlate: '',
        make: '',
        model: '',
        email: '',
        mobile: '',
        photo: ''
      },
      businessInfo: {
        id: '',
        corporateName: '',
        firstName: '',
        lastName: '',
        mobile: ''
      },
      otherInfo: {
        externalId: '',
        alternatePhone: ''
      }
    },
    showPaymentBreakdown: false,
    flightStatus: {
      status: '',
      departureAirport: '',
      arrivalAirport: '',
      arrivalTime: ''
    },
    flightManual: false,
    showFlightStatus: false,
    sendEmail: {
      show: false,
      message: ''
    },
    sendNoShow: {
      showModal: false,
      loading: false,
      showMsg: false,
      message: '',
      forceHide: false
    },
    showReleaseModal: false,
    rsvpAction: {
      show: false,
      message: ''
    },
    emailRecipient: {
      show: false,
      title: '',
      selected: 'customer',
      email: ''
    },
    extraStops: [],
    isTerminal: false,
    currency: {
      airportFee: 0,
      amount: 0,
      credit: 0,
      currency: 'USD',
      currencyRate: 1,
      gasFee: 0,
      pickupFee: 0,
      tipAmount: 0,
      travelInsurance: 0,
      symbol: '$'
    },
    useLocalCurrency: false
  },
  mutations: {
    resetBasicInfo: function resetBasicInfo(state) {
      state.rsvpId = '';
      state.basicInfo = {
        tripInfo: {
          id: '',
          brandId: '',
          brand: '',
          brandColor: '',
          packageId: '',
          bookedThrough: '',
          status: '',
          bidId: '',
          bidStatus: '',
          created: '',
          pickupDate: '',
          fare: '',
          driverPayment: '',
          driverBonus: '',
          paymentBonus: '',
          tip: '',
          airportFee: '',
          pickupFee: '',
          credits: '',
          serviceType: '',
          serviceTypeId: '',
          serviceLabel: '',
          serviceCode: '',
          pickup: '',
          dropoff: '',
          aptGate: '',
          eta: '',
          beThereTime: '',
          distance: '',
          airline: '',
          airlineCode: '',
          flightNo: '',
          passenger: '',
          luggage: '',
          notes: '',
          serviceArea: '',
          wheelchair: '',
          serviceDog: '',
          overridePrice: '',
          overridePayment: '',
          rating: '',
          userReview: '',
          isCharter: false,
          isRental: false,
          optinShared: false
        },
        customerInfo: {
          id: '',
          firstName: '',
          lastName: '',
          creditCard: '',
          email: '',
          mobile: ''
        },
        guestInfo: {
          firstName: '',
          lastName: '',
          mobile: ''
        },
        driverInfo: {
          id: '',
          firstName: '',
          lastName: '',
          rating: '',
          driversLicense: '',
          licensePlate: '',
          make: '',
          model: '',
          email: '',
          mobile: '',
          photo: ''
        },
        businessInfo: {
          id: '',
          corporateName: '',
          firstName: '',
          lastName: '',
          mobile: ''
        },
        otherInfo: {
          externalId: '',
          alternatePhone: ''
        }
      };
      state.flightStatus = {
        status: '',
        departureAirport: '',
        arrivalAirport: '',
        arrivalTime: ''
      };
      state.flightManual = false;
      state.sendEmail = {
        show: false,
        message: ''
      };
      state.sendNoShow = {
        showModal: false,
        loading: false,
        showMsg: false,
        message: '',
        forceHide: false
      };
      state.extraStops = [];
    },
    setRsvpDetails: function setRsvpDetails(state, value) {
      state.rsvpId = value.rsvpId;
      state.basicInfo = value.basicInfo;
    },
    setShowPaymentBreakdown: function setShowPaymentBreakdown(state, value) {
      state.showPaymentBreakdown = value;
    },
    setFlightStatus: function setFlightStatus(state, value) {
      state.flightStatus = value;
    },
    setShowFlightStatus: function setShowFlightStatus(state, value) {
      state.showFlightStatus = value;
    },
    setFlightManual: function setFlightManual(state, value) {
      state.flightManual = value;
    },
    setSendEmail: function setSendEmail(state, value) {
      state.sendEmail = {
        show: value.show,
        message: value.message
      };
    },
    setSendNoShow: function setSendNoShow(state, value) {
      state.sendNoShow = {
        showModal: value.showModal,
        loading: value.loading,
        showMsg: value.showMsg,
        message: value.message,
        forceHide: value.forceHide
      };
    },
    showReleaseConfirmation: function showReleaseConfirmation(state) {
      state.showReleaseModal = true;
    },
    hideReleaseConfirmation: function hideReleaseConfirmation(state) {
      state.showReleaseModal = false;
    },
    setRsvpAction: function setRsvpAction(state, value) {
      state.rsvpAction = {
        show: value.show,
        message: value.message
      };
    },
    setEmailRecipientField: function setEmailRecipientField(state, data) {
      state.emailRecipient[data.field] = data.value;
    },
    setExtraStops: function setExtraStops(state, value) {
      state.extraStops = value;
    },
    setIsTerminal: function setIsTerminal(state, value) {
      state.isTerminal = value;
    },
    setCurrency: function setCurrency(state, data) {
      for (var field in data) {
        state.currency[field] = data[field];
      }
    },
    setLocalCurrency: function setLocalCurrency(state, val) {
      state.useLocalCurrency = val;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    edit: {
      details: {
        tripInfo: {
          id: '',
          brandId: '',
          brand: '',
          brandColor: '',
          packageId: '',
          bookedThrough: '',
          status: '',
          bidId: '',
          bidStatus: '',
          created: '',
          pickupDate: '',
          fare: '',
          driverPayment: '',
          driverBonus: '',
          paymentBonus: '',
          gasFee: '',
          tip: '',
          pickupFee: '',
          credits: '',
          serviceType: '',
          serviceLabel: '',
          serviceCode: '',
          pickup: '',
          dropoff: '',
          beThereTime: '',
          aptGate: '',
          eta: '',
          distance: '',
          isAsap: false,
          airline: '',
          airlineCode: '',
          airportCode: '',
          isAirportPickup: false,
          isAirportDropoff: false,
          flightNo: '',
          passenger: '',
          luggage: '',
          notes: '',
          serviceArea: '',
          wheelchair: '',
          serviceDog: '',
          overridePrice: '',
          overridePayment: '',
          extraStops: [],
          isCharter: false
        },
        customerInfo: {
          id: '',
          firstName: '',
          lastName: '',
          creditCard: '',
          cardTitle: '',
          creditCardId: '',
          email: '',
          mobile: '',
          corpConsId: ''
        },
        guestInfo: {
          firstName: '',
          lastName: '',
          mobile: ''
        }
      },
      serviceLoading: false,
      selectedService: '',
      services: {
        shared: {},
        opoli: {},
        black: {},
        suv: {},
        shuttle: {}
      },
      holiday: {
        date: '',
        shared: {
          currency: '',
          value: ''
        },
        opoli: {
          currency: '',
          value: ''
        },
        black: {
          currency: '',
          value: ''
        },
        suv: {
          currency: '',
          value: ''
        },
        shuttle: {
          currency: '',
          value: ''
        }
      },
      timezoneLoading: false,
      timezone: 'America/Los_Angeles',
      isSaving: false,
      showUpdateReturn: {
        show: false,
        message: '',
        status: ''
      },
      suggestedTime: {
        show: false,
        time: '',
        isDomestic: ''
      },
      lastFlightNo: '',
      currency: {
        code: 'USD',
        symbol: '$',
        value: 1,
        original: {
          code: 'USD',
          symbol: '$',
          value: 1
        }
      }
    },
    isManualTip: false,
    updateMap: false
  },
  mutations: {
    setEditData: function setEditData(state, value) {
      state.edit.details = value;
    },
    setServiceLoading: function setServiceLoading(state, value) {
      state.edit.serviceLoading = value;
    },
    setSelectedService: function setSelectedService(state, value) {
      state.edit.selectedService = value;
    },
    addService: function addService(state, data) {
      state.edit.services[data.code] = data.value;
    },
    setServices: function setServices(state, value) {
      state.edit.services = value;
    },
    setHoliday: function setHoliday(state, value) {
      state.edit.holiday = value;
    },
    setTimezoneLoading: function setTimezoneLoading(state, value) {
      state.edit.timezoneLoading = value;
    },
    setTimezone: function setTimezone(state, value) {
      state.edit.timezone = value;
    },
    setIsSaving: function setIsSaving(state, value) {
      state.edit.isSaving = value;
    },
    setShowUpdateReturn: function setShowUpdateReturn(state, value) {
      state.edit.showUpdateReturn = value;
    },
    setPickup: function setPickup(state, value) {
      state.edit.details.tripInfo.pickup = value;
    },
    setDropoff: function setDropoff(state, value) {
      state.edit.details.tripInfo.dropoff = value;
    },
    setPickupGeofence: function setPickupGeofence(state, value) {
      if (value.id) {
        state.edit.details.tripInfo.pickup.geofenceId = value.id;
      }
      state.edit.details.tripInfo.pickup.geofenceName = value.name;
      state.edit.details.tripInfo.pickup.geofenceType = value.type;
    },
    setDropoffGeofence: function setDropoffGeofence(state, value) {
      if (value.id) {
        state.edit.details.tripInfo.dropoff.geofenceId = value.id;
      }
      state.edit.details.tripInfo.dropoff.geofenceName = value.name;
      state.edit.details.tripInfo.dropoff.geofenceType = value.type;
    },
    setPickupDate: function setPickupDate(state, value) {
      state.edit.details.tripInfo.pickupDate = value;
    },
    setIsAsap: function setIsAsap(state, value) {
      state.edit.details.tripInfo.isAsap = value;
    },
    setIsAirportPickup: function setIsAirportPickup(state, value) {
      state.edit.details.tripInfo.isAirportPickup = value;
    },
    setIsAirportDropoff: function setIsAirportDropoff(state, value) {
      state.edit.details.tripInfo.isAirportDropoff = value;
    },
    setAirportCode: function setAirportCode(state, value) {
      state.edit.details.tripInfo.airportCode = value;
    },
    setAirline: function setAirline(state, value) {
      state.edit.details.tripInfo.airline = value.airline;
      state.edit.details.tripInfo.airlineCode = value.airlineCode;
    },
    setFlightNo: function setFlightNo(state, value) {
      state.edit.details.tripInfo.flightNo = value;
    },
    setDistanceEta: function setDistanceEta(state, value) {
      state.edit.details.tripInfo.distance = value.distance;
      state.edit.details.tripInfo.eta = value.eta;
    },
    setSuggestedTimeShow: function setSuggestedTimeShow(state, value) {
      state.edit.suggestedTime.show = value;
    },
    setSuggestedTime: function setSuggestedTime(state, value) {
      state.edit.suggestedTime.time = value;
    },
    setSuggestedTimeIsDomestic: function setSuggestedTimeIsDomestic(state, value) {
      state.edit.suggestedTime.isDomestic = value;
    },
    setLastFlightNo: function setLastFlightNo(state, value) {
      state.edit.lastFlightNo = value;
    },
    setPassenger: function setPassenger(state, value) {
      state.edit.details.tripInfo.passenger = value;
    },
    setLuggage: function setLuggage(state, value) {
      state.edit.details.tripInfo.luggage = value;
    },
    setCustomerInfo: function setCustomerInfo(state, data) {
      state.edit.details.customerInfo.id = data.id;
      state.edit.details.customerInfo.firstName = data.firstName;
      state.edit.details.customerInfo.lastName = data.lastName;
      state.edit.details.customerInfo.email = data.email;
      state.edit.details.customerInfo.mobile = data.mobile;
      state.edit.details.customerInfo.countryCode = data.countryCode;
      state.edit.details.customerInfo.nationalNumber = data.nationalNumber;
      state.edit.details.customerInfo.corpConsId = 0;
      if (data.consId) {
        state.edit.details.customerInfo.corpConsId = data.consId;
      }
    },
    setGasFee: function setGasFee(state, value) {
      state.edit.details.tripInfo.gasFee = value;
    },
    setTip: function setTip(state, value) {
      state.edit.details.tripInfo.tip = value;
    },
    setpaymentBonus: function setpaymentBonus(state, value) {
      state.edit.details.tripInfo.paymentBonus = value;
    },
    setIsManualTip: function setIsManualTip(state, value) {
      state.isManualTip = value;
    },

    // setExtraStop (state, data) {
    //   state.edit.details.tripInfo.extraStops = value
    // }
    addExtraStop: function addExtraStop(state, value) {
      state.edit.details.tripInfo.extraStops.push(value);
    },
    setExtraStopData: function setExtraStopData(state, data) {
      var index = state.edit.details.tripInfo.extraStops.findIndex(function (x) {
        return x.id === data.id;
      });
      var hasMapUpdate = false;
      if (index > -1) {
        for (var field in data.fields) {
          state.edit.details.tripInfo.extraStops[index][field] = data.fields[field];
          if (['lat', 'lng'].indexOf(field) > -1) {
            hasMapUpdate = true;
          }
        }
        if (hasMapUpdate) {
          state.updateMap = true;
        }
      }
    },
    removeExtraStop: function removeExtraStop(state) {
      state.edit.details.tripInfo.extraStops = [];
    },
    setUpdateMap: function setUpdateMap(state, value) {
      state.updateMap = value;
    },
    setEditCurrency: function setEditCurrency(state, data) {
      for (var field in data) {
        state.edit.currency[field] = data[field];
      }
    }
  },
  sharedMutations: []
});

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    notes: {
      list: [],
      noteDeleteId: 0
    }
  },
  mutations: {
    resetNotes: function resetNotes(state) {
      state.notes.list = [];
      state.notes.noteDeleteId = 0;
    },
    addNotes: function addNotes(state, value) {
      state.notes.list.push(value);
    },
    addNewNotes: function addNewNotes(state, value) {
      state.notes.list.unshift(value);
    },
    setNoteDeleteId: function setNoteDeleteId(state, value) {
      state.notes.noteDeleteId = value;
    },
    updateNote: function updateNote(state, value) {
      var i = state.notes.list.findIndex(function (x) {
        return x.id === value.id;
      });
      if (i !== -1) {
        state.notes.list[i].message = value.message;
        state.notes.list[i].status = value.status;
      }
    },
    deleteNote: function deleteNote(state, value) {
      var i = state.notes.list.findIndex(function (x) {
        return x.id === value;
      });
      if (i !== -1) {
        state.notes.list.splice(i, 1);
      }
    }
  },
  sharedMutations: []
});

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    transactionList: []
  },
  mutations: {
    resetTransactionList: function resetTransactionList(state) {
      state.transactionList = [];
    },
    addTransaction: function addTransaction(state, value) {
      state.transactionList.push(value);
    }
  },
  sharedMutations: []
});

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    actionLogs: []
  },
  mutations: {
    resetActionLogs: function resetActionLogs(state) {
      state.actionLogs = [];
    },
    setAction: function setAction(state, value) {
      state.actionLogs = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    dispatchLogs: []
  },
  mutations: {
    resetDispatchLogs: function resetDispatchLogs(state) {
      state.dispatchLogs = [];
    },
    setDispatchLogs: function setDispatchLogs(state, value) {
      state.dispatchLogs = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    charter: {
      enabled: false,
      pickup: {},
      startDate: '',
      endDate: '',
      airportGeoId: ''
    }
  },
  mutations: {
    setCharterData: function setCharterData(state, data) {
      for (var field in data) {
        state.charter[field] = data[field];
      }
    }
  }
});

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    optin: {
      enabled: false,
      shared: [],
      showModal: false
    }
  },
  mutations: {
    setOptinData: function setOptinData(state, data) {
      for (var field in data) {
        state.optin[field] = data[field];
      }
    },
    addSharedService: function addSharedService(state, value) {
      state.optin.shared.push(value);
    }
  }
});

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    mtech: {
      enabled: false,
      services: [],
      markup: {
        type: '%',
        value: 0
      },
      flightDate: '',
      isDomestic: true,
      pickupDate: '',
      quoteId: '',
      details: {
        localPickupDate: '',
        timezone: '',
        service: {}
      }
    }
  },
  mutations: {
    setMtechData: function setMtechData(state, data) {
      for (var field in data) {
        state.mtech[field] = data[field];
      }
    },
    setMtechNewPricing: function setMtechNewPricing(state, data) {
      if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.mtech.services).length || !state.mtech.services[data.code]) {
        return;
      }

      state.mtech.services[data.code].price = data.val;
    }
  }
});

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    stripe: {
      cardOwner: '',
      address: '',
      userCity: '',
      userState: '',
      userZip: '',
      userCountry: ''
    }
  },
  mutations: {
    setStripeData: function setStripeData(state, data) {
      for (var field in data) {
        state.stripe[field] = data[field];
      }
    }
  }
});

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    lyft: {
      date: null,
      rideId: null,
      rideType: null,
      driver: {},
      show: false,
      routeUrl: '',
      enabled: false
    }
  },
  mutations: {
    setLyftData: function setLyftData(state, data) {
      for (var field in data) {
        state.lyft[field] = data[field];
      }
    }
  }
});

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    list: [],
    searchInput: '',
    maxList: 0,
    currentPage: 1,
    perPage: 20,
    orderAsc: 1,
    isLoading: false,
    enable: true,
    searchContainer: true
  },
  mutations: {
    resetSearchGlobalList: function resetSearchGlobalList(state) {
      state.list = [];
    },
    resetSearchGlobalInput: function resetSearchGlobalInput(state) {
      state.searchInput = '';
    },
    setSearchGlobalInput: function setSearchGlobalInput(state, value) {
      state.searchInput = value;
    },
    addSearchGlobalList: function addSearchGlobalList(state, value) {
      state.list.push(value);
    },
    setSearchGlobalIsLoading: function setSearchGlobalIsLoading(state, value) {
      state.isLoading = value;
    },
    setSearchGlobalCurrentPage: function setSearchGlobalCurrentPage(state, value) {
      state.currentPage = value;
    },
    setSearchGlobalMaxList: function setSearchGlobalMaxList(state, value) {
      state.maxList = value;
    },
    setSearchGlobalEnable: function setSearchGlobalEnable(state, value) {
      state.enable = value;
    },
    setSearchGlobalContainer: function setSearchGlobalContainer(state, value) {
      state.searchContainer = value;
    }
  }
});

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__details__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__geofence__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__list__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enabled_drivers__ = __webpack_require__(993);






var sharedMutations = [];

/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__details__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_2__geofence__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_3__list__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_4__enabled_drivers__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__details__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_2__geofence__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_3__list__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_4__enabled_drivers__["a" /* default */].mutations),
  sharedMutations: sharedMutations
});

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    preview: false,
    brandId: '',
    details: {
      id: '',
      brandId: '',
      enable: false,
      label: '',
      code: '',
      color: '',
      allowTNC: false,
      allowTCP: false,
      allowPSC: false,
      isShared: false,
      poolP2P: false,
      poolFromAirport: false,
      poolToAirport: false,
      useShifts: false,
      isCharter: false,
      image: '',
      imageOff: '',
      name: '',
      maxPassengers: '',
      maxLuggages: '',
      excerptWeb: '',
      descriptionWeb: '',
      advantageWeb: '',
      stops: '',
      category: '',
      excerptApp: '',
      descriptionApp: '',
      advantageApp: '',
      slogan: '',
      defaultTip: 0,
      unavailableTimes: [],
      images: [],
      bufferAdminMins: '',
      bufferWidgetMins: '',
      bufferAppMins: ''
    },
    serviceUnavailable: {
      p2p: false,
      fromAirport: false,
      toAirport: false,
      startTime: 0,
      endTime: 0
    },
    saving: false
  },
  mutations: {
    setPreview: function setPreview(state, value) {
      state.preview = value;
    },
    setBrandId: function setBrandId(state, value) {
      state.brandId = value;
    },
    setDetails: function setDetails(state, value) {
      state.details = value;
    },
    setDetailsData: function setDetailsData(state, data) {
      state.details[data.field] = data.value;
    },
    setSaving: function setSaving(state, value) {
      state.saving = value;
    },
    addUnavailableTimes: function addUnavailableTimes(state, value) {
      if (state.details.unavailableTimes.indexOf(value) === -1) {
        state.details.unavailableTimes.push(value);
        state.details.unavailableTimes.sort();
      }
    },
    removeUnavailableTimes: function removeUnavailableTimes(state, value) {
      var index = state.details.unavailableTimes.indexOf(value);
      if (index != -1) {
        state.details.unavailableTimes.splice(index, 1);
      }
    },
    addMoreImgs: function addMoreImgs(state, value) {
      state.details.images.push(value);
    },
    removeMoreImgs: function removeMoreImgs(state, value) {
      var index = state.details.images.indexOf(value);
      if (index != -1) {
        state.details.images.splice(index, 1);
      }
    },
    setServiceUnavailableData: function setServiceUnavailableData(state, data) {
      for (var field in data) {
        state.serviceUnavailable[field] = data[field];
      }
    }
    // toggleServiceUnavailableTimes (state, data) {
    //   let index = state.serviceUnavailableTimes.findIndex(x => x.start === data.start && x.end === data.end)
    //   if (index > -1) state.serviceUnavailableTimes.splice(index, 1)
    //   else state.serviceUnavailableTimes.push(data)
    // }

  },
  sharedMutations: []
});

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    geofence: {
      list: [],
      loading: false,
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      order: 'priority',
      // orderAsc: 0,
      search: ''
    }
  },
  mutations: {
    setGeofenceList: function setGeofenceList(state, value) {
      state.geofence.list = value;
    },
    setGeofenceLoading: function setGeofenceLoading(state, value) {
      state.geofence.loading = value;
    },
    setGeofenceMaxList: function setGeofenceMaxList(state, value) {
      state.geofence.maxList = value;
    },
    setGeofenceCurrentPage: function setGeofenceCurrentPage(state, value) {
      state.geofence.currentPage = value;
    },
    setGeofencePerPage: function setGeofencePerPage(state, value) {
      state.geofence.perPage = value;
    },
    setGeofenceOrder: function setGeofenceOrder(state, value) {
      state.geofence.order = value;
    },

    // setGeofenceOrderAsc (state, value) { state.geofence.orderAsc = value },
    setGeofenceSearch: function setGeofenceSearch(state, value) {
      state.geofence.search = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    list: [],
    serviceLoading: false
  },
  mutations: {
    clearService: function clearService(state) {
      state.list = [];
    },
    addService: function addService(state, value) {
      state.list.push(value);
    },
    removeNewService: function removeNewService(state) {
      var index = state.list.findIndex(function (x) {
        return x.id === 0;
      });
      if (index > -1) {
        state.list.splice(index, 1);
      }
    },
    setServiceEnable: function setServiceEnable(state, data) {
      var index = state.list.findIndex(function (x) {
        return x.id === data.id;
      });
      if (index > -1) {
        state.list[index].enabled = data.enabled;
      }
    },
    setServiceId: function setServiceId(state, value) {
      var index = state.list.findIndex(function (x) {
        return x.id === 0;
      });
      if (index > -1) {
        state.list[index].id = value;
      }
    },
    setServiceLoading: function setServiceLoading(state, value) {
      state.serviceLoading = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    users: {
      list: [],
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      order: 'modified',
      orderAsc: 0,
      type: 'all',
      isLoading: false,
      status: 'unarchived',
      search: '',
      selectedUser: []
    },
    checked: false,
    enabledDrivers: [],
    initialData: []
  },
  mutations: {
    setCheck: function setCheck(state, value) {
      state.checked = value;
    },
    setEnabledDrivers: function setEnabledDrivers(state, value) {
      state.enabledDrivers = value;
    },
    setInitialData: function setInitialData(state, value) {
      state.initialData = value;
    },
    resetUsers: function resetUsers(state) {
      state.users.list = [];
    },
    addUser: function addUser(state, value) {
      state.users.list.push(value);
    },
    setUserMaxList: function setUserMaxList(state, value) {
      state.users.maxList = value;
    },
    setUserCurrentPage: function setUserCurrentPage(state, value) {
      state.users.currentPage = value;
    },
    setUserPerPage: function setUserPerPage(state, value) {
      state.users.perPage = value;
    },
    setUserOrder: function setUserOrder(state, value) {
      state.users.order = value;
    },
    setUserOrderAsc: function setUserOrderAsc(state, value) {
      state.users.orderAsc = value;
    },
    setUserType: function setUserType(state, value) {
      state.users.type = value;
    },
    setUserIsLoading: function setUserIsLoading(state, value) {
      state.users.isLoading = value;
    },
    setUserStatus: function setUserStatus(state, value) {
      state.users.status = value;
    },
    setUserSearch: function setUserSearch(state, value) {
      state.users.search = value;
    },
    setUserSelected: function setUserSelected(state, value) {
      state.users.selectedUser = value;
    }
  },
  sharedMutations: []
});

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    showLoader: false,
    user: {
      id: null,
      firstName: null,
      lastName: null,
      phone: null,
      email: null,
      photoUrl: null,
      access: null,
      accessLoading: false
    },
    sessionToken: null,
    notificationToken: null
  },
  mutations: {
    showLoader: function showLoader(state) {
      state.showLoader = true;
    },
    hideLoader: function hideLoader(state) {
      state.showLoader = false;
    },
    setUser: function setUser(state, value) {
      state.user = value;
    },
    setSessionToken: function setSessionToken(state, value) {
      state.sessionToken = value;
    },
    setNotificationToken: function setNotificationToken(state, value) {
      state.notificationToken = value;
    },
    setAccess: function setAccess(state, value) {
      state.user.access = value;
    },
    setAccessLoading: function setAccessLoading(state, value) {
      state.user.accessLoading = value;
    }
  },
  sharedMutations: ['session/setUser', 'session/setAccess', 'session/setSessionToken']
});

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    sharedAllowedTime: {
      start: '',
      end: ''
    },
    optinAllowedTime: {
      start: '',
      end: ''
    },
    adminTimeBuffer: '',
    serviceData: {
      Shared: {
        id: 1,
        label: ''
      },
      Opoli: {
        id: 2,
        label: ''
      },
      Black: {
        id: 3,
        label: ''
      },
      SUV: {
        id: 4,
        label: ''
      },
      'Private Shuttle': {
        id: 5,
        label: ''
      }
    },
    charterMaxDura: 480,
    charterMinDuration: 0,
    charterMnDurationServiceId: []
  },
  mutations: {
    setSharedAllowedTime: function setSharedAllowedTime(state, value) {
      state.sharedAllowedTime = value;
    },
    setAdminTimeBuffer: function setAdminTimeBuffer(state, value) {
      state.adminTimeBuffer = value;
    },
    setServiceData: function setServiceData(state, value) {
      state.serviceData = value;
    },
    setSettings: function setSettings(state, data) {
      for (var field in data) {
        state[field] = data[field];
      }
    }
  },
  sharedMutations: []
});

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    configuration: {}
  },
  mutations: {
    setConfiguration: function setConfiguration(state, value) {
      state.configuration = value;
    },
    setConfigurationItem: function setConfigurationItem(state, item) {
      state.configuration[item.key].value = item.value;
    }
  }
});

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    show: false,
    showMenuButton: true
  },
  mutations: {
    hide: function hide(state) {
      state.show = false;
    },
    show: function show(state) {
      state.show = true;
    },
    hideMenuButton: function hideMenuButton(state) {
      state.showMenuButton = false;
    },
    showMenuButton: function showMenuButton(state) {
      state.showMenuButton = true;
    }
  }
});

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filters__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__list__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stats__ = __webpack_require__(1001);





/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__filters__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_2__list__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_3__stats__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__filters__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_2__list__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_3__stats__["a" /* default */].mutations)
});

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    filter: {
      search: '',
      status: '',
      date: 'withinDay',
      dateFrom: '',
      dateTo: '',
      loading: false,
      brand: ''
    }
  },
  mutations: {
    resetFilters: function resetFilters(state, value) {
      state.filter = {
        search: '',
        status: '',
        date: 'withinDay',
        dateFrom: '',
        dateTo: '',
        loading: false,
        brand: ''
      };
    },
    setSearch: function setSearch(state, value) {
      state.filter.search = value;
    },
    setStatus: function setStatus(state, value) {
      state.filter.status = value;
    },
    setDate: function setDate(state, value) {
      state.filter.date = value;
    },
    setDateFrom: function setDateFrom(state, value) {
      state.filter.dateFrom = value;
    },
    setDateTo: function setDateTo(state, value) {
      state.filter.dateTo = value;
    },
    setBrand: function setBrand(state, value) {
      state.filter.brand = value;
    }
  }
});

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    list: [],
    loading: false,
    currentPage: 0,
    perPage: 20,
    total: 0,
    sort: {
      column: 'created',
      isDesc: true
    },
    refreshList: false
  },
  mutations: {
    setTransactions: function setTransactions(state, value) {
      value.forEach(function (x) {
        x.isCollapsible = false;
      });
      state.list = value;
    },
    setLoading: function setLoading(state, value) {
      state.loading = value;
    },
    setCurrentPage: function setCurrentPage(state, value) {
      state.currentPage = value;
    },
    setPerPage: function setPerPage(state, value) {
      state.perPage = value;
    },
    setTotal: function setTotal(state, value) {
      state.total = value;
    },
    setSortColumn: function setSortColumn(state, value) {
      state.sort.column = value;
    },
    setSortIsDesc: function setSortIsDesc(state, value) {
      state.sort.isDesc = value;
    },
    setRefreshList: function setRefreshList(state, value) {
      state.refreshList = value;
    }
  }
});

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    stats: {
      gross: 0,
      credits: 0,
      loading: false
    }
  },
  mutations: {
    setStats: function setStats(state, data) {
      state.stats.gross = data.gross;
      state.stats.credits = data.credits;
    },
    setStatsLoading: function setStatsLoading(state, value) {
      state.stats.loading = value;
    }
  }
});

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dropzone__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__table__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__exclusive__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__here_maps__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__other__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__drivers__ = __webpack_require__(1008);








/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_6__drivers__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_1__dropzone__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_2__table__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_3__exclusive__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_4__here_maps__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_5__other__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_6__drivers__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_1__dropzone__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_2__table__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_3__exclusive__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_4__here_maps__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_5__other__["a" /* default */].mutations)
});

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    dropzone: {
      show: false,
      items: [],
      checkRoute: false,
      calculatingRun: false,
      associatedRuns: []
    }
  },
  mutations: {
    setDropzoneData: function setDropzoneData(state, data) {
      for (var field in data) {
        state.dropzone[field] = data[field];
      }
    },
    addDropzoneItem: function addDropzoneItem(state, value) {
      value['newPickupTime'] = null;
      value['newEta'] = null;
      state.dropzone.items.push(value);
    },
    removeDropzoneItem: function removeDropzoneItem(state, data) {
      var index = state.dropzone.items.findIndex(function (x) {
        return x.id === data.id;
      });
      if (index > -1) {
        state.dropzone.items.splice(index, 1);
      }
    },
    removeDropzoneItems: function removeDropzoneItems(state, value) {
      var items = state.dropzone.items;
      if (value.type === 'rsvp') {
        state.dropzone.items = items.filter(function (item) {
          return item.id !== value.id;
        });
        return;
      }

      state.dropzone.items = items.filter(function (item) {
        return item.runId !== value.id;
      });
    },
    clearDropzone: function clearDropzone(state) {
      state.dropzone.show = false;
      state.dropzone.items = [];
      state.dropzone.checkRoute = false;
      state.dropzone.drivers = [];
    },
    addAssociatedRuns: function addAssociatedRuns(state, value) {
      var index = state.dropzone.associatedRuns.indexOf(value);
      if (index === -1) {
        state.dropzone.associatedRuns.push(value);
      }
    },
    removeAssociatedRuns: function removeAssociatedRuns(state, value) {
      var index = state.dropzone.associatedRuns.indexOf(value);
      if (index > -1) {
        state.dropzone.associatedRuns.splice(index, 1);
      }
    },
    updateNextInfo: function updateNextInfo(state, data) {
      var index = state.dropzone.items.findIndex(function (x) {
        return x.id === data.id;
      });
      if (index > -1) {
        state.dropzone.items[index].timeToNext = data.timeToNext;
        state.dropzone.items[index].distanceToNext = data.distanceToNext;
      }
    },
    updateDropzoneItem: function updateDropzoneItem(state, data) {
      state.dropzone.items[data.index].newPickupTime = data.pickupTime;
      state.dropzone.items[data.index].newEta = data.eta;
      state.dropzone.items[data.index].timeToNext = data.timeToNext;
      state.dropzone.items[data.index].distanceToNext = data.distanceToNext;
    }
  }
});

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    list: [],
    loading: false,
    search: '',
    since: '',
    until: '',
    selected: null,
    refresh: false,
    breakIds: [],
    blackList: [],
    selectedServices: []
  },
  mutations: {
    setRunsDetails: function setRunsDetails(state, data) {
      for (var field in data) {
        state[field] = data[field];
      }
    },
    removeRunInTable: function removeRunInTable(state, id) {
      var index = state.list.findIndex(function (x) {
        return x.id === id;
      });
      if (index > -1) {
        state.list.splice(index, 1);
      }
    },
    addBlackList: function addBlackList(state, value) {
      state.blackList.push(value);
    },
    removeBlackList: function removeBlackList(state, val) {
      var index = state.blackList.indexOf(val);
      if (val > -1) {
        state.blackList.splice(index, 1);
      }
    }
  }
});

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    exclusive: {
      list: [],
      loading: false,
      selected: []
    }
  },
  mutations: {
    setExclusiveDetails: function setExclusiveDetails(state, data) {
      for (var field in data) {
        state.exclusive[field] = data[field];
      }
    }
  }
});

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    hereMaps: {
      map: {},
      platform: {},
      router: {},
      geocoder: {},
      directions: [],
      ui: {}
    }
  },
  mutations: {
    setHereMapData: function setHereMapData(state, data) {
      for (var field in data) {
        state.hereMaps[field] = data[field];
      }
    }
  }
});

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    other: {
      currentPage: '',
      currentTab: '',
      runsInMap: [],
      sendTimer: {}
    }
  },
  mutations: {
    setOtherData: function setOtherData(state, data) {
      for (var field in data) {
        state.other[field] = data[field];
      }
    },
    setRunsInMap: function setRunsInMap(state, id) {
      var i = state.other.runsInMap.indexOf(id);
      if (i > -1) {
        state.other.runsInMap.splice(i, 1);
      } else {
        state.other.runsInMap.push(id);
      }
    },
    removeRunsInMap: function removeRunsInMap(state, id) {
      var i = state.other.runsInMap.indexOf(id);
      if (id > -1) {
        state.other.runsInMap.splice(i, 1);
      }
    },
    setSendTimer: function setSendTimer(state, data) {
      state.other.sendTimer['a' + data.id] = data.time;
    },
    deleteSendTimer: function deleteSendTimer(state, id) {
      delete state.other.sendTimer['a' + id];
    }
  }
});

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    nearByDrivers: {
      list: [],
      loading: false
    },
    driverInPopup: {
      id: null,
      phone: null,
      email: null,
      firstName: null,
      lastName: null,
      photoUrl: null,
      vehicle: {
        name: null,
        licensePlate: null,
        photoUrl: null
      }
    },
    driverInPopupRoute: {
      path: [],
      distance: null, // in miles
      duration: null // in minutes
    },
    qualifiedDriver: {
      list: [],
      details: {},
      refresh: false,
      active: false
    },
    driverAvailability: {
      lastCheckId: '',
      checkId: '',
      rsvpData: {}
    }
  },
  mutations: {
    setNearByDrivers: function setNearByDrivers(state, data) {
      for (var field in data) {
        state.nearByDrivers[field] = data[field];
      }
    },
    setDriverInPopup: function setDriverInPopup(state, value) {
      state.driverInPopup = value;
    },
    setDriverInPopupRoute: function setDriverInPopupRoute(state, value) {
      state.driverInPopupRoute = value;
    },
    setQualifiedDriversData: function setQualifiedDriversData(state, data) {
      for (var field in data) {
        state.qualifiedDriver[field] = data[field];
      }
    },
    reduceQualifiedDrivers: function reduceQualifiedDrivers(state) {
      state.qualifiedDriver.list.shift();
    },
    setDriverAvailabilityData: function setDriverAvailabilityData(state, data) {
      for (var field in data) {
        state.driverAvailability[field] = data[field];
      }
    }
  }
});

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__list__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_list__ = __webpack_require__(1011);




/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__list__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_2__view_list__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__list__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_2__view_list__["a" /* default */].mutations)
});

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    list: [],
    loading: false,
    search: '',
    currentPage: 1,
    perPage: 20,
    order: 'id',
    orderAsc: '',
    maxList: 0
  },
  mutations: {
    setListData: function setListData(state, data) {
      for (var field in data) {
        state[field] = data[field];
      }
    },
    updateListData: function updateListData(state, data) {
      for (var field in data.fields) {
        var index = state.list.findIndex(function (x) {
          return x.id === data.id;
        });
        state.list[index][field] = data.fields[field];
      }
    }
  },
  sharedMutations: []
});

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    view: {
      list: [],
      loading: false
    }
  },
  mutations: {
    setViewData: function setViewData(state, data) {
      for (var field in data) {
        state.view[field] = data[field];
      }
    }
  },
  sharedMutations: []
});

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alert__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loader__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reasonModal__ = __webpack_require__(1015);





/* harmony default export */ __webpack_exports__["a"] = ({
  strict: false,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__alert__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_2__loader__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_3__reasonModal__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__alert__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_2__loader__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_3__reasonModal__["a" /* default */].mutations)
});

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    alert: {
      show: false,
      message: ''
    }
  },
  mutations: {
    setAlertData: function setAlertData(state, data) {
      for (var field in data) {
        state.alert[field] = data[field];
      }
    }
  }
});

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loader: {
      show: false,
      message: ''
    }
  },
  mutations: {
    setLoaderData: function setLoaderData(state, data) {
      for (var field in data) {
        state.loader[field] = data[field];
      }
    }
  }
});

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    reasons: {
      // show: false,
      // message: '',
      list: [],
      unfiltered: [],
      unqualified: [],
      reasonsModal: false
    }
  },
  mutations: {
    setReasonsData: function setReasonsData(state, data) {
      for (var field in data) {
        state.reasons[field] = data[field];
        if (field === 'list') {
          state.reasons.list.sort(function (a, b) {
            return a.name.localeCompare(b.name);
          });
        }
      }
    },
    addReasonList: function addReasonList(state, data) {
      state.reasons.list.push(data);
      state.reasons.list.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    }
  }
});

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    show: false,
    msg: '',
    rsvps: [],
    type: '',
    data: {
      notes: '',
      noteStatus: '',
      chargeFees: '',
      reason: '',
      refundAsCredits: '',
      cancelFee: ''
    }
  },
  mutations: {
    setCancelData: function setCancelData(state, data) {
      for (var field in data) {
        state[field] = data[field];
      }
    },
    setData: function setData(state, data) {
      for (var field in data) {
        state.data[field] = data[field];
      }
    },
    updateRsvp: function updateRsvp(state, data) {
      var i = state.rsvps.findIndex(function (x) {
        return x.id === data.id;
      });
      if (i > -1) {
        state.rsvps[i].cancellationFee = data.cancellationFee;
      }
    }
  }
});

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__list__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create__ = __webpack_require__(1019);




/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__list__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_2__create__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__list__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_2__create__["a" /* default */].mutations)
});

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    list: [],
    loading: false,
    search: '',
    currentPage: 1,
    perPage: 20,
    order: 'id',
    orderAsc: '',
    maxList: 20
  },
  mutations: {
    setListData: function setListData(state, data) {
      for (var field in data) {
        state[field] = data[field];
      }
    }
  },
  sharedMutations: []
});

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    create: {
      pickup: {},
      dropoff: {},
      pickupDate: '',
      pickupDateReturn: '',
      isReturnTrip: false,
      adult: 1,
      children: 0,
      infants: 0
    }
  },
  mutations: {
    setCreateData: function setCreateData(state, data) {
      for (var field in data) {
        state.create[field] = data[field];
      }
    }
  },
  sharedMutations: []
});

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__details__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__trx__ = __webpack_require__(1022);




/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__details__["a" /* default */].state, __WEBPACK_IMPORTED_MODULE_2__trx__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__details__["a" /* default */].mutations, __WEBPACK_IMPORTED_MODULE_2__trx__["a" /* default */].mutations)
});

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    details: {},
    rsvp1: {},
    rsvp2: {},
    rsvp3: {},
    rsvp4: {},
    trx: {
      list: [],
      id: ''
    }
  },
  mutations: {
    setFlightDetails: function setFlightDetails(state, data) {
      for (var field in data) {
        state[field] = data[field];
      }
    },
    setFlightTrxData: function setFlightTrxData(state, data) {
      for (var field in data) {
        state.trx[field] = data[field];
      }
    },
    updateRsvpStatus: function updateRsvpStatus(state, data) {
      state[data.target].status = data.val;
    }
  }
});

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    trx: {
      list: []
    }
  },
  mutations: {
    setTrxData: function setTrxData(state, data) {
      for (var field in data) {
        state.trx[field] = data[field];
      }
    }
  }
});

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    list: {},
    loading: false,
    // selected: 'USD',
    // symbol: '$',
    // value: 1,
    lastUpdate: ''
  },
  mutations: {
    setCurrencyData: function setCurrencyData(state, data) {
      for (var field in data) {
        state[field] = data[field];
      }
    }
  },
  sharedMutations: []
});

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: {
    services: {}
  },
  mutations: {
    setLyftData: function setLyftData(state, data) {
      for (var field in data) {
        state[field] = data[field];
      }
    }
  }
});

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__list__ = __webpack_require__(1026);



var sharedMutations = [];

/* harmony default export */ __webpack_exports__["a"] = ({
  strict: true,
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__list__["a" /* default */].state),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1__list__["a" /* default */].mutations),
  sharedMutations: sharedMutations
});

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    list: [],
    showCreate: false,
    showConfirm: false
  },
  mutations: {
    setListData: function setListData(state, data) {
      for (var field in data) {
        state[field] = data[field];
      }
    }
  }
});

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccessDenied_vue__ = __webpack_require__(376);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cd35fee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccessDenied_vue__ = __webpack_require__(1030);
function injectStyle (ssrContext) {
  __webpack_require__(1028)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6cd35fee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccessDenied_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cd35fee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccessDenied_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1029);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1605957a", content, true, {});

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.missing-page[data-v-6cd35fee] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #fefefe;\n  text-align: center;\n}\n.missing-page-container[data-v-6cd35fee] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.missing-page-content[data-v-6cd35fee] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.image[data-v-6cd35fee] {\n  margin-bottom: 10px;\n}\n.title[data-v-6cd35fee] {\n  font-size: 36px;\n  font-weight: 700;\n  color: #3F2975;\n  margin-bottom: 15px;\n}\n.content[data-v-6cd35fee] {\n  font-size: 20px;\n  font-weight: 700;\n  color: #555555;\n  margin-bottom: 5px;\n}\n.instructions[data-v-6cd35fee] {\n  color: #555;\n  font-size: 16px;\n}\n.instructions a[data-v-6cd35fee] {\n    color: #3F2975;\n    font-weight: 700;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Error/AccessDenied.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;CACpB;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;CACrB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;CACpB;AACD;EACE,YAAY;EACZ,gBAAgB;CACjB;AACD;IACI,eAAe;IACf,iBAAiB;CACpB","file":"AccessDenied.vue","sourcesContent":["\n.missing-page[data-v-6cd35fee] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #fefefe;\n  text-align: center;\n}\n.missing-page-container[data-v-6cd35fee] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.missing-page-content[data-v-6cd35fee] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.image[data-v-6cd35fee] {\n  margin-bottom: 10px;\n}\n.title[data-v-6cd35fee] {\n  font-size: 36px;\n  font-weight: 700;\n  color: #3F2975;\n  margin-bottom: 15px;\n}\n.content[data-v-6cd35fee] {\n  font-size: 20px;\n  font-weight: 700;\n  color: #555555;\n  margin-bottom: 5px;\n}\n.instructions[data-v-6cd35fee] {\n  color: #555;\n  font-size: 16px;\n}\n.instructions a[data-v-6cd35fee] {\n    color: #3F2975;\n    font-weight: 700;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"missing-page"},[_c('div',{staticClass:"missing-page-container"},[_c('div',{staticClass:"missing-page-content"},[_c('img',{staticClass:"image",attrs:{"src":"https://s3-us-west-2.amazonaws.com/staging-backoffice/staging/404.jpg"}}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("ACCESS DENIED!")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("Sorry, but you don't have permission to access this page.")]),_vm._v(" "),_c('i',{staticClass:"far fa-frown"})]),_vm._v(" "),_c('div',{staticClass:"instructions"},[_vm._v("\n        Why don't you head back to the "),_c('a',{attrs:{"href":"#/"}},[_vm._v("home page")]),_vm._v(".\n      ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__ = __webpack_require__(377);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d9f4ff4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__ = __webpack_require__(1034);
function injectStyle (ssrContext) {
  __webpack_require__(1032)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d9f4ff4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d9f4ff4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1033);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("63078bda", content, true, {});

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.missing-page[data-v-6d9f4ff4] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #fefefe;\n  text-align: center;\n}\n.missing-page-container[data-v-6d9f4ff4] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.missing-page-content[data-v-6d9f4ff4] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.image[data-v-6d9f4ff4] {\n  margin-bottom: 10px;\n}\n.title[data-v-6d9f4ff4] {\n  font-size: 36px;\n  font-weight: 700;\n  color: #3F2975;\n  margin-bottom: 15px;\n}\n.content[data-v-6d9f4ff4] {\n  font-size: 20px;\n  font-weight: 700;\n  color: #555555;\n  margin-bottom: 5px;\n}\n.instructions[data-v-6d9f4ff4] {\n  color: #555;\n  font-size: 16px;\n}\n.instructions a[data-v-6d9f4ff4] {\n    color: #3F2975;\n    font-weight: 700;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Error/404.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;CACpB;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;CACrB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;CACpB;AACD;EACE,YAAY;EACZ,gBAAgB;CACjB;AACD;IACI,eAAe;IACf,iBAAiB;CACpB","file":"404.vue","sourcesContent":["\n.missing-page[data-v-6d9f4ff4] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #fefefe;\n  text-align: center;\n}\n.missing-page-container[data-v-6d9f4ff4] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.missing-page-content[data-v-6d9f4ff4] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.image[data-v-6d9f4ff4] {\n  margin-bottom: 10px;\n}\n.title[data-v-6d9f4ff4] {\n  font-size: 36px;\n  font-weight: 700;\n  color: #3F2975;\n  margin-bottom: 15px;\n}\n.content[data-v-6d9f4ff4] {\n  font-size: 20px;\n  font-weight: 700;\n  color: #555555;\n  margin-bottom: 5px;\n}\n.instructions[data-v-6d9f4ff4] {\n  color: #555;\n  font-size: 16px;\n}\n.instructions a[data-v-6d9f4ff4] {\n    color: #3F2975;\n    font-weight: 700;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"missing-page"},[_c('div',{staticClass:"missing-page-container"},[_c('div',{staticClass:"missing-page-content"},[_c('img',{staticClass:"image",attrs:{"src":"https://s3-us-west-2.amazonaws.com/staging-backoffice/staging/404.jpg"}}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Oh no!")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v("There's nothing here for you.. and you're all alone")]),_vm._v(" "),_c('i',{staticClass:"far fa-frown"})]),_vm._v(" "),_c('div',{staticClass:"instructions"},[_vm._v("\n        Why don't you head back to the "),_c('a',{attrs:{"href":"#/dispatch"}},[_vm._v("home page")]),_vm._v(".\n      ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(378);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a46bcd0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(1038);
function injectStyle (ssrContext) {
  __webpack_require__(1036)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a46bcd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a46bcd0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1037);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0c3f2d18", content, true, {});

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.login-background[data-v-0a46bcd0] {\n  background-color: #292931;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n}\n.login-container[data-v-0a46bcd0] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.login-content[data-v-0a46bcd0] {\n  display: table-cell;\n  vertical-align: middle;\n  position: relative;\n}\n.login-form[data-v-0a46bcd0] {\n  width: 350px;\n  min-height: 310px;\n  margin: 0 auto;\n  background-color: #423142;\n  -webkit-box-shadow: 0 3px 8px rgba(0, 0, 0, 0.5);\n          box-shadow: 0 3px 8px rgba(0, 0, 0, 0.5);\n  border-radius: 3px;\n  padding: 50px 20px 20px;\n  position: relative;\n}\n.login-form .title[data-v-0a46bcd0] {\n    color: #fff;\n    text-align: center;\n    font-size: 20px;\n    font-weight: 700;\n    margin-bottom: 10px;\n}\n.login-form .logo[data-v-0a46bcd0] {\n    width: 120px;\n    height: 120px;\n    left: calc(50% - 60px);\n    display: block;\n    position: absolute;\n    position: absolute;\n    top: -70px;\n    background-color: #423142;\n    border-radius: 100%;\n}\n.login-form img[data-v-0a46bcd0] {\n    width: 100px;\n    height: 100px;\n    margin: 10px;\n    display: block;\n}\n.login-input[data-v-0a46bcd0] {\n  position: relative;\n  margin-bottom: 10px;\n  border: 2px solid #ccc;\n  border-radius: 3px;\n  overflow: hidden;\n}\n.login-input.password[data-v-0a46bcd0] {\n    margin-bottom: 15px;\n}\n.login-input .icon[data-v-0a46bcd0] {\n    background-color: #dedede;\n    border-right: 1px solid #ccc;\n    color: #777;\n    height: 40px;\n    line-height: 40px;\n    text-align: center;\n    width: 40px;\n}\n.login-input .icon i[data-v-0a46bcd0] {\n      line-height: inherit;\n}\n.login-input input[data-v-0a46bcd0] {\n    border: 0;\n    border-radius: 0;\n    border-top-right-radius: 3px;\n    border-bottom-right-radius: 3px;\n    position: absolute;\n    left: 40px;\n    margin-top: 0;\n    padding: 8px 10px;\n    width: 270px;\n    top: 0;\n}\n.error-message[data-v-0a46bcd0] {\n  background-color: #F20D0D;\n  text-align: center;\n  color: #fff;\n  padding: 0px 10px;\n  font-size: 12px;\n  border-radius: 3px;\n  margin-bottom: 0;\n  height: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  overflow: hidden;\n}\n.error-message.show[data-v-0a46bcd0] {\n    height: 28px;\n    padding: 5px 10px;\n    margin-bottom: 10px;\n}\n.forgot-link[data-v-0a46bcd0] {\n  text-align: center;\n  display: block;\n  font-size: 14px;\n  padding: 10px 0 0;\n  color: #dedede;\n  text-decoration: underline;\n  cursor: pointer;\n}\n.forgot-password p[data-v-0a46bcd0] {\n  font-size: 13px;\n  line-height: 140%;\n  color: #eee;\n  text-align: center;\n  margin-bottom: 30px;\n}\n.forgot-password a[data-v-0a46bcd0] {\n  color: #fff;\n  text-decoration: underline;\n  display: block;\n  text-align: center;\n  font-size: 14px;\n  margin: 15px 0;\n  cursor: pointer;\n}\n.forgot-password a.disabled[data-v-0a46bcd0] {\n    opacity: .3;\n    cursor: default;\n}\n.modal[data-v-0a46bcd0] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.modal.show[data-v-0a46bcd0] {\n    top: 0;\n    opacity: 1;\n}\n.modal-container[data-v-0a46bcd0] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.modal-content[data-v-0a46bcd0] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 500px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n  padding: 25px;\n}\n.modal-content label[data-v-0a46bcd0] {\n    font-size: 21px;\n    font-weight: 600;\n    margin-bottom: 20px;\n    display: block;\n}\n.modal-content p[data-v-0a46bcd0] {\n    margin: 0;\n    font-size: 14px;\n    color: #444;\n}\n.modal-content b[data-v-0a46bcd0] {\n    font-size: 15px;\n}\n.modal-content .button[data-v-0a46bcd0] {\n    margin-top: 25px;\n}\n.slide-item[data-v-0a46bcd0] {\n  display: inline-block;\n}\n.slide-enter-active[data-v-0a46bcd0] {\n  -webkit-transition: all .3s linear;\n  transition: all .3s linear;\n}\n.slide-leave-active[data-v-0a46bcd0] {\n  display: none;\n  -webkit-transition: all 0s linear;\n  transition: all 0s linear;\n}\n.slide-enter[data-v-0a46bcd0], .slide-leave-to[data-v-0a46bcd0] {\n  opacity: 0;\n  -webkit-transform: translateY(-20px);\n          transform: translateY(-20px);\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/App/Login.vue"],"names":[],"mappings":";AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,YAAY;CACb;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;CACpB;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,iDAAiD;UACzC,yCAAyC;EACjD,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;CACpB;AACD;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;CACvB;AACD;IACI,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,0BAA0B;IAC1B,oBAAoB;CACvB;AACD;IACI,aAAa;IACb,cAAc;IACd,aAAa;IACb,eAAe;CAClB;AACD;EACE,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;CAClB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;CACf;AACD;MACM,qBAAqB;CAC1B;AACD;IACI,UAAU;IACV,iBAAiB;IACjB,6BAA6B;IAC7B,gCAAgC;IAChC,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,OAAO;CACV;AACD;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;CAClB;AACD;IACI,aAAa;IACb,kBAAkB;IAClB,oBAAoB;CACvB;AACD;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;CACjB;AACD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;CACrB;AACD;EACE,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;CACjB;AACD;IACI,YAAY;IACZ,gBAAgB;CACnB;AACD;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;CACf;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;CAClB;AACD;IACI,UAAU;IACV,gBAAgB;IAChB,YAAY;CACf;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,mCAAmC;EACnC,2BAA2B;CAC5B;AACD;EACE,cAAc;EACd,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,WAAW;EACX,qCAAqC;UAC7B,6BAA6B;CACtC","file":"Login.vue","sourcesContent":["\n.login-background[data-v-0a46bcd0] {\n  background-color: #292931;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n}\n.login-container[data-v-0a46bcd0] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.login-content[data-v-0a46bcd0] {\n  display: table-cell;\n  vertical-align: middle;\n  position: relative;\n}\n.login-form[data-v-0a46bcd0] {\n  width: 350px;\n  min-height: 310px;\n  margin: 0 auto;\n  background-color: #423142;\n  -webkit-box-shadow: 0 3px 8px rgba(0, 0, 0, 0.5);\n          box-shadow: 0 3px 8px rgba(0, 0, 0, 0.5);\n  border-radius: 3px;\n  padding: 50px 20px 20px;\n  position: relative;\n}\n.login-form .title[data-v-0a46bcd0] {\n    color: #fff;\n    text-align: center;\n    font-size: 20px;\n    font-weight: 700;\n    margin-bottom: 10px;\n}\n.login-form .logo[data-v-0a46bcd0] {\n    width: 120px;\n    height: 120px;\n    left: calc(50% - 60px);\n    display: block;\n    position: absolute;\n    position: absolute;\n    top: -70px;\n    background-color: #423142;\n    border-radius: 100%;\n}\n.login-form img[data-v-0a46bcd0] {\n    width: 100px;\n    height: 100px;\n    margin: 10px;\n    display: block;\n}\n.login-input[data-v-0a46bcd0] {\n  position: relative;\n  margin-bottom: 10px;\n  border: 2px solid #ccc;\n  border-radius: 3px;\n  overflow: hidden;\n}\n.login-input.password[data-v-0a46bcd0] {\n    margin-bottom: 15px;\n}\n.login-input .icon[data-v-0a46bcd0] {\n    background-color: #dedede;\n    border-right: 1px solid #ccc;\n    color: #777;\n    height: 40px;\n    line-height: 40px;\n    text-align: center;\n    width: 40px;\n}\n.login-input .icon i[data-v-0a46bcd0] {\n      line-height: inherit;\n}\n.login-input input[data-v-0a46bcd0] {\n    border: 0;\n    border-radius: 0;\n    border-top-right-radius: 3px;\n    border-bottom-right-radius: 3px;\n    position: absolute;\n    left: 40px;\n    margin-top: 0;\n    padding: 8px 10px;\n    width: 270px;\n    top: 0;\n}\n.error-message[data-v-0a46bcd0] {\n  background-color: #F20D0D;\n  text-align: center;\n  color: #fff;\n  padding: 0px 10px;\n  font-size: 12px;\n  border-radius: 3px;\n  margin-bottom: 0;\n  height: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  overflow: hidden;\n}\n.error-message.show[data-v-0a46bcd0] {\n    height: 28px;\n    padding: 5px 10px;\n    margin-bottom: 10px;\n}\n.forgot-link[data-v-0a46bcd0] {\n  text-align: center;\n  display: block;\n  font-size: 14px;\n  padding: 10px 0 0;\n  color: #dedede;\n  text-decoration: underline;\n  cursor: pointer;\n}\n.forgot-password p[data-v-0a46bcd0] {\n  font-size: 13px;\n  line-height: 140%;\n  color: #eee;\n  text-align: center;\n  margin-bottom: 30px;\n}\n.forgot-password a[data-v-0a46bcd0] {\n  color: #fff;\n  text-decoration: underline;\n  display: block;\n  text-align: center;\n  font-size: 14px;\n  margin: 15px 0;\n  cursor: pointer;\n}\n.forgot-password a.disabled[data-v-0a46bcd0] {\n    opacity: .3;\n    cursor: default;\n}\n.modal[data-v-0a46bcd0] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.modal.show[data-v-0a46bcd0] {\n    top: 0;\n    opacity: 1;\n}\n.modal-container[data-v-0a46bcd0] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.modal-content[data-v-0a46bcd0] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 500px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n  padding: 25px;\n}\n.modal-content label[data-v-0a46bcd0] {\n    font-size: 21px;\n    font-weight: 600;\n    margin-bottom: 20px;\n    display: block;\n}\n.modal-content p[data-v-0a46bcd0] {\n    margin: 0;\n    font-size: 14px;\n    color: #444;\n}\n.modal-content b[data-v-0a46bcd0] {\n    font-size: 15px;\n}\n.modal-content .button[data-v-0a46bcd0] {\n    margin-top: 25px;\n}\n.slide-item[data-v-0a46bcd0] {\n  display: inline-block;\n}\n.slide-enter-active[data-v-0a46bcd0] {\n  -webkit-transition: all .3s linear;\n  transition: all .3s linear;\n}\n.slide-leave-active[data-v-0a46bcd0] {\n  display: none;\n  -webkit-transition: all 0s linear;\n  transition: all 0s linear;\n}\n.slide-enter[data-v-0a46bcd0], .slide-leave-to[data-v-0a46bcd0] {\n  opacity: 0;\n  -webkit-transform: translateY(-20px);\n          transform: translateY(-20px);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-background"},[_c('div',{staticClass:"login-container"},[_c('div',{staticClass:"login-content"},[_c('div',{staticClass:"login-form"},[_vm._m(0),_vm._v(" "),_c('transition-group',{attrs:{"name":"slide","tag":"span"}},[(!_vm.forgotPassword.show)?_c('div',{key:"1"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login.apply(null, arguments)}}},[_c('div',{staticClass:"title"},[_vm._v("BACKOFFICE")]),_vm._v(" "),_c('div',{class:{ 'error-message': true, show: _vm.showError }},[_vm._v(_vm._s(_vm.$t('login.errorLogin')))]),_vm._v(" "),_c('div',{staticClass:"login-input"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-at"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"email","placeholder":_vm.$t('login.inputEmail')},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"login-input password"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-key"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","placeholder":_vm.$t('login.inputPassword')},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('button',{class:{
                cta: true, block: true,
                disabled: _vm.loggingIn }},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loggingIn),expression:"loggingIn"}],staticClass:"fas fa-circle-notch fa-spin"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.loginLabel))])])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.forgotPassword.show),expression:"!forgotPassword.show"}],staticClass:"forgot-link",on:{"click":function($event){_vm.forgotPassword.show = true}}},[_vm._v(_vm._s(_vm.$t('login.forgotLink')))])]):_vm._e(),_vm._v(" "),(_vm.forgotPassword.show)?_c('div',{key:"2",staticClass:"forgot-password"},[_c('div',{staticClass:"title"},[_vm._v("Trouble Logging in?")]),_vm._v(" "),_c('p',[_vm._v("Enter your email and we'll send you a recovery link to get back into your account.")]),_vm._v(" "),_c('div',{class:{ 'error-message': true, show: _vm.forgotPassword.showError }},[_vm._v(_vm._s(_vm.forgotPassword.errorMsg))]),_vm._v(" "),_c('div',{staticClass:"login-input"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-at"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"email","placeholder":_vm.$t('login.inputEmail')},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{class:{'button cta block success':true, 'disabled':_vm.forgotPassword.loading},on:{"click":_vm.sendPassword}},[(_vm.forgotPassword.loading)?_c('span',[_c('i',{staticClass:"fas fa-circle-notch fa-spin"}),_vm._v("\n                Loading...\n              ")]):_c('span',[_vm._v("SEND RECOVERY LINK")])]),_vm._v(" "),_c('a',{class:{'disabled':_vm.forgotPassword.loading},on:{"click":_vm.goBack}},[_vm._v("Go Back")])]):_vm._e()])],1)])]),_vm._v(" "),_c('div',{class:{ 'modal':true, 'show':_vm.forgotPassword.success },on:{"click":_vm.close}},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('label',[_vm._v("Reset password link has been sent!")]),_vm._v(" "),_c('p',[_vm._v("We have sent a password reset link to your email address:")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.email))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"button cta small block",on:{"click":_vm.close}},[_vm._v("Close")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"/assets/img/logo.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordReset_vue__ = __webpack_require__(379);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d72f42a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordReset_vue__ = __webpack_require__(1045);
function injectStyle (ssrContext) {
  __webpack_require__(1040)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d72f42a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordReset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d72f42a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordReset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1041);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("bc7953f8", content, true, {});

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.password-reset[data-v-0d72f42a] {\n  background-color: #292931;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n}\n.reset-container[data-v-0d72f42a] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.reset-content[data-v-0d72f42a] {\n  display: table-cell;\n  vertical-align: middle;\n  position: relative;\n}\n.reset-form[data-v-0d72f42a] {\n  width: 350px;\n  margin: 0 auto;\n  background-color: #423142;\n  -webkit-box-shadow: 0 3px 8px rgba(0, 0, 0, 0.5);\n          box-shadow: 0 3px 8px rgba(0, 0, 0, 0.5);\n  border-radius: 3px;\n  padding: 50px 20px 20px;\n  position: relative;\n}\n.reset-form .title[data-v-0d72f42a] {\n    color: #fff;\n    text-align: center;\n    font-size: 20px;\n    font-weight: 700;\n    margin: 10px 0;\n}\n.reset-form .logo[data-v-0d72f42a] {\n    width: 120px;\n    height: 120px;\n    left: calc(50% - 60px);\n    display: block;\n    position: absolute;\n    position: absolute;\n    top: -70px;\n    background-color: #423142;\n    border-radius: 100%;\n}\n.reset-form img[data-v-0d72f42a] {\n    width: 100px;\n    height: 100px;\n    margin: 10px;\n    display: block;\n}\n.reset-form input[readonly][data-v-0d72f42a], .reset-form input.disabled[data-v-0d72f42a] {\n    background: #ddd;\n    color: #777;\n}\n.update-button[data-v-0d72f42a] {\n  margin-top: 15px;\n}\n.error-message[data-v-0d72f42a] {\n  background-color: #F20D0D;\n  text-align: center;\n  color: #fff;\n  padding: 0px 10px;\n  font-size: 12px;\n  border-radius: 3px;\n  margin-bottom: 0;\n  height: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  overflow: hidden;\n}\n.error-message.show[data-v-0d72f42a] {\n    height: 28px;\n    padding: 5px 10px;\n    margin-bottom: 10px;\n}\n.modal[data-v-0d72f42a] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.modal.show[data-v-0d72f42a] {\n    top: 0;\n    opacity: 1;\n}\n.modal-container[data-v-0d72f42a] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.modal-content[data-v-0d72f42a] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 380px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n  padding: 25px;\n}\n.modal-content label[data-v-0d72f42a] {\n    font-size: 21px;\n    font-weight: 600;\n    margin-bottom: 20px;\n    display: block;\n}\n.modal-content p[data-v-0d72f42a] {\n    margin: 0;\n    font-size: 14px;\n    color: #444;\n}\n.modal-content b[data-v-0d72f42a] {\n    font-size: 15px;\n}\n.modal-content .button[data-v-0d72f42a] {\n    margin-top: 25px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/App/PasswordReset.vue"],"names":[],"mappings":";AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,YAAY;CACb;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;CACpB;AACD;EACE,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,iDAAiD;UACzC,yCAAyC;EACjD,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;CACpB;AACD;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,0BAA0B;IAC1B,oBAAoB;CACvB;AACD;IACI,aAAa;IACb,cAAc;IACd,aAAa;IACb,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,iBAAiB;CAClB;AACD;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;CAClB;AACD;IACI,aAAa;IACb,kBAAkB;IAClB,oBAAoB;CACvB;AACD;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;CACf;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;CAClB;AACD;IACI,UAAU;IACV,gBAAgB;IAChB,YAAY;CACf;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;CACpB","file":"PasswordReset.vue","sourcesContent":["\n.password-reset[data-v-0d72f42a] {\n  background-color: #292931;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n}\n.reset-container[data-v-0d72f42a] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.reset-content[data-v-0d72f42a] {\n  display: table-cell;\n  vertical-align: middle;\n  position: relative;\n}\n.reset-form[data-v-0d72f42a] {\n  width: 350px;\n  margin: 0 auto;\n  background-color: #423142;\n  -webkit-box-shadow: 0 3px 8px rgba(0, 0, 0, 0.5);\n          box-shadow: 0 3px 8px rgba(0, 0, 0, 0.5);\n  border-radius: 3px;\n  padding: 50px 20px 20px;\n  position: relative;\n}\n.reset-form .title[data-v-0d72f42a] {\n    color: #fff;\n    text-align: center;\n    font-size: 20px;\n    font-weight: 700;\n    margin: 10px 0;\n}\n.reset-form .logo[data-v-0d72f42a] {\n    width: 120px;\n    height: 120px;\n    left: calc(50% - 60px);\n    display: block;\n    position: absolute;\n    position: absolute;\n    top: -70px;\n    background-color: #423142;\n    border-radius: 100%;\n}\n.reset-form img[data-v-0d72f42a] {\n    width: 100px;\n    height: 100px;\n    margin: 10px;\n    display: block;\n}\n.reset-form input[readonly][data-v-0d72f42a], .reset-form input.disabled[data-v-0d72f42a] {\n    background: #ddd;\n    color: #777;\n}\n.update-button[data-v-0d72f42a] {\n  margin-top: 15px;\n}\n.error-message[data-v-0d72f42a] {\n  background-color: #F20D0D;\n  text-align: center;\n  color: #fff;\n  padding: 0px 10px;\n  font-size: 12px;\n  border-radius: 3px;\n  margin-bottom: 0;\n  height: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  overflow: hidden;\n}\n.error-message.show[data-v-0d72f42a] {\n    height: 28px;\n    padding: 5px 10px;\n    margin-bottom: 10px;\n}\n.modal[data-v-0d72f42a] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.modal.show[data-v-0d72f42a] {\n    top: 0;\n    opacity: 1;\n}\n.modal-container[data-v-0d72f42a] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.modal-content[data-v-0d72f42a] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 380px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n  padding: 25px;\n}\n.modal-content label[data-v-0d72f42a] {\n    font-size: 21px;\n    font-weight: 600;\n    margin-bottom: 20px;\n    display: block;\n}\n.modal-content p[data-v-0d72f42a] {\n    margin: 0;\n    font-size: 14px;\n    color: #444;\n}\n.modal-content b[data-v-0d72f42a] {\n    font-size: 15px;\n}\n.modal-content .button[data-v-0d72f42a] {\n    margin-top: 25px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1043);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("18c848ce", content, true, {});

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.loader-wrap[data-v-51e86dd8] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.loader-wrap .loader-box[data-v-51e86dd8] {\n    position: absolute;\n    top: 45%;\n    left: 50%;\n    width: 400px;\n    padding: 25px;\n    background: #fff;\n    text-align: center;\n    border-radius: 6px;\n    margin-left: -200px;\n    -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.loader-wrap .loader-box .fa-spin[data-v-51e86dd8] {\n      margin-right: 5px;\n      color: #333;\n}\n.loader-wrap .loader-box span[data-v-51e86dd8] {\n      font-weight: 600;\n      color: #443;\n      font-size: 16px;\n}\n.loader-wrap.show[data-v-51e86dd8] {\n    display: block;\n}\n.loader-wrap.show .loader-box[data-v-51e86dd8] {\n      display: block;\n      -webkit-animation: slide-down-data-v-51e86dd8 .3s ease-out;\n      -moz-animation: slide-down-data-v-51e86dd8 .3s ease-out;\n}\n@-webkit-keyframes slide-down-data-v-51e86dd8 {\n0% {\n    opacity: 0;\n    -webkit-transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Partials/LoadingModal.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,YAAY;CACb;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,uDAAuD;YAC/C,+CAA+C;IACvD,cAAc;CACjB;AACD;MACM,kBAAkB;MAClB,YAAY;CACjB;AACD;MACM,iBAAiB;MACjB,YAAY;MACZ,gBAAgB;CACrB;AACD;IACI,eAAe;CAClB;AACD;MACM,eAAe;MACf,2DAA2D;MAC3D,wDAAwD;CAC7D;AACD;AACA;IACI,WAAW;IACX,oCAAoC;CACvC;AACD;IACI,WAAW;IACX,iCAAiC;CACpC;CACA","file":"LoadingModal.vue","sourcesContent":["\n.loader-wrap[data-v-51e86dd8] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.loader-wrap .loader-box[data-v-51e86dd8] {\n    position: absolute;\n    top: 45%;\n    left: 50%;\n    width: 400px;\n    padding: 25px;\n    background: #fff;\n    text-align: center;\n    border-radius: 6px;\n    margin-left: -200px;\n    -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.loader-wrap .loader-box .fa-spin[data-v-51e86dd8] {\n      margin-right: 5px;\n      color: #333;\n}\n.loader-wrap .loader-box span[data-v-51e86dd8] {\n      font-weight: 600;\n      color: #443;\n      font-size: 16px;\n}\n.loader-wrap.show[data-v-51e86dd8] {\n    display: block;\n}\n.loader-wrap.show .loader-box[data-v-51e86dd8] {\n      display: block;\n      -webkit-animation: slide-down-data-v-51e86dd8 .3s ease-out;\n      -moz-animation: slide-down-data-v-51e86dd8 .3s ease-out;\n}\n@-webkit-keyframes slide-down-data-v-51e86dd8 {\n0% {\n    opacity: 0;\n    -webkit-transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'loader-wrap':true, 'show':_vm.showModal}},[_c('div',{staticClass:"loader-box"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.modalMessage))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"password-reset"},[_c('div',{staticClass:"reset-container"},[_c('div',{staticClass:"reset-content"},[_c('div',{staticClass:"reset-form"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("PASSWORD RESET")]),_vm._v(" "),_c('div',{class:{ 'error-message': true, show: _vm.error.show }},[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],class:{'disabled':_vm.formLoading},attrs:{"type":"password","placeholder":"New Password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.repeatPassword),expression:"repeatPassword"}],class:{'disabled':_vm.formLoading},attrs:{"type":"password","placeholder":"Repeat Password"},domProps:{"value":(_vm.repeatPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.repeatPassword=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"button cta success block update-button",on:{"click":_vm.updatePassword}},[(!_vm.formLoading)?_c('span',[_vm._v("Update Password")]):_c('span',[_c('i',{staticClass:"fas fa-circle-notch fa-spin"}),_vm._v("\n            Loading...\n          ")])])])])]),_vm._v(" "),_c('loading-modal',{attrs:{"showModal":_vm.loading,"modalMessage":"Loading..."}}),_vm._v(" "),_c('div',{class:{ 'modal':true, 'show':_vm.showModal },on:{"click":_vm.close}},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('label',[_vm._v("Success!")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"button cta small block",on:{"click":_vm.close}},[_vm._v("Close")])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"/assets/img/logo.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n          Your password has been changed successfully."),_c('br'),_vm._v("\n          You may now use your new password to login.\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordResetDriver_vue__ = __webpack_require__(381);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d7f9468_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordResetDriver_vue__ = __webpack_require__(1049);
function injectStyle (ssrContext) {
  __webpack_require__(1047)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d7f9468"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordResetDriver_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d7f9468_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordResetDriver_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1048);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0be054d0", content, true, {});

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.password-reset[data-v-0d7f9468] {\n  background-color: #292931;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n}\n.reset-container[data-v-0d7f9468] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.reset-content[data-v-0d7f9468] {\n  display: table-cell;\n  vertical-align: middle;\n  position: relative;\n}\n.reset-form[data-v-0d7f9468] {\n  width: 350px;\n  margin: 0 auto;\n  background-color: #423142;\n  -webkit-box-shadow: 0 3px 8px rgba(0, 0, 0, 0.5);\n          box-shadow: 0 3px 8px rgba(0, 0, 0, 0.5);\n  border-radius: 3px;\n  padding: 50px 20px 20px;\n  position: relative;\n}\n.reset-form .title[data-v-0d7f9468] {\n    color: #fff;\n    text-align: center;\n    font-size: 20px;\n    font-weight: 700;\n    margin: 10px 0;\n}\n.reset-form .logo[data-v-0d7f9468] {\n    width: 120px;\n    height: 120px;\n    left: calc(50% - 60px);\n    display: block;\n    position: absolute;\n    position: absolute;\n    top: -70px;\n    background-color: #423142;\n    border-radius: 100%;\n}\n.reset-form img[data-v-0d7f9468] {\n    width: 100px;\n    height: 100px;\n    margin: 10px;\n    display: block;\n}\n.reset-form input[readonly][data-v-0d7f9468], .reset-form input.disabled[data-v-0d7f9468] {\n    background: #ddd;\n    color: #777;\n}\n.update-button[data-v-0d7f9468] {\n  margin-top: 15px;\n}\n.error-message[data-v-0d7f9468] {\n  background-color: #F20D0D;\n  text-align: center;\n  color: #fff;\n  padding: 0px 10px;\n  font-size: 12px;\n  border-radius: 3px;\n  margin-bottom: 0;\n  height: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  overflow: hidden;\n}\n.error-message.show[data-v-0d7f9468] {\n    height: 28px;\n    padding: 5px 10px;\n    margin-bottom: 10px;\n}\n.modal[data-v-0d7f9468] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.modal.show[data-v-0d7f9468] {\n    top: 0;\n    opacity: 1;\n}\n.modal-container[data-v-0d7f9468] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.modal-content[data-v-0d7f9468] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 380px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n  padding: 25px;\n}\n.modal-content label[data-v-0d7f9468] {\n    font-size: 21px;\n    font-weight: 600;\n    margin-bottom: 20px;\n    display: block;\n}\n.modal-content p[data-v-0d7f9468] {\n    margin: 0;\n    font-size: 14px;\n    color: #444;\n}\n.modal-content b[data-v-0d7f9468] {\n    font-size: 15px;\n}\n.modal-content .button[data-v-0d7f9468] {\n    margin-top: 25px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/App/PasswordResetDriver.vue"],"names":[],"mappings":";AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,YAAY;CACb;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;CACpB;AACD;EACE,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,iDAAiD;UACzC,yCAAyC;EACjD,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;CACpB;AACD;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,0BAA0B;IAC1B,oBAAoB;CACvB;AACD;IACI,aAAa;IACb,cAAc;IACd,aAAa;IACb,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,iBAAiB;CAClB;AACD;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;CAClB;AACD;IACI,aAAa;IACb,kBAAkB;IAClB,oBAAoB;CACvB;AACD;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;CACf;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;CAClB;AACD;IACI,UAAU;IACV,gBAAgB;IAChB,YAAY;CACf;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;CACpB","file":"PasswordResetDriver.vue","sourcesContent":["\n.password-reset[data-v-0d7f9468] {\n  background-color: #292931;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n}\n.reset-container[data-v-0d7f9468] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.reset-content[data-v-0d7f9468] {\n  display: table-cell;\n  vertical-align: middle;\n  position: relative;\n}\n.reset-form[data-v-0d7f9468] {\n  width: 350px;\n  margin: 0 auto;\n  background-color: #423142;\n  -webkit-box-shadow: 0 3px 8px rgba(0, 0, 0, 0.5);\n          box-shadow: 0 3px 8px rgba(0, 0, 0, 0.5);\n  border-radius: 3px;\n  padding: 50px 20px 20px;\n  position: relative;\n}\n.reset-form .title[data-v-0d7f9468] {\n    color: #fff;\n    text-align: center;\n    font-size: 20px;\n    font-weight: 700;\n    margin: 10px 0;\n}\n.reset-form .logo[data-v-0d7f9468] {\n    width: 120px;\n    height: 120px;\n    left: calc(50% - 60px);\n    display: block;\n    position: absolute;\n    position: absolute;\n    top: -70px;\n    background-color: #423142;\n    border-radius: 100%;\n}\n.reset-form img[data-v-0d7f9468] {\n    width: 100px;\n    height: 100px;\n    margin: 10px;\n    display: block;\n}\n.reset-form input[readonly][data-v-0d7f9468], .reset-form input.disabled[data-v-0d7f9468] {\n    background: #ddd;\n    color: #777;\n}\n.update-button[data-v-0d7f9468] {\n  margin-top: 15px;\n}\n.error-message[data-v-0d7f9468] {\n  background-color: #F20D0D;\n  text-align: center;\n  color: #fff;\n  padding: 0px 10px;\n  font-size: 12px;\n  border-radius: 3px;\n  margin-bottom: 0;\n  height: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  overflow: hidden;\n}\n.error-message.show[data-v-0d7f9468] {\n    height: 28px;\n    padding: 5px 10px;\n    margin-bottom: 10px;\n}\n.modal[data-v-0d7f9468] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.modal.show[data-v-0d7f9468] {\n    top: 0;\n    opacity: 1;\n}\n.modal-container[data-v-0d7f9468] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.modal-content[data-v-0d7f9468] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 380px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n  padding: 25px;\n}\n.modal-content label[data-v-0d7f9468] {\n    font-size: 21px;\n    font-weight: 600;\n    margin-bottom: 20px;\n    display: block;\n}\n.modal-content p[data-v-0d7f9468] {\n    margin: 0;\n    font-size: 14px;\n    color: #444;\n}\n.modal-content b[data-v-0d7f9468] {\n    font-size: 15px;\n}\n.modal-content .button[data-v-0d7f9468] {\n    margin-top: 25px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"password-reset"},[_c('div',{staticClass:"reset-container"},[_c('div',{staticClass:"reset-content"},[_c('div',{staticClass:"reset-form"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("DRIVER PASSWORD RESET")]),_vm._v(" "),_c('div',{class:{ 'error-message': true, show: _vm.error.show }},[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],class:{'disabled':_vm.formLoading},attrs:{"type":"password","placeholder":"New Password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.repeatPassword),expression:"repeatPassword"}],class:{'disabled':_vm.formLoading},attrs:{"type":"password","placeholder":"Repeat Password"},domProps:{"value":(_vm.repeatPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.repeatPassword=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"button cta success block update-button",on:{"click":_vm.updatePassword}},[(!_vm.formLoading)?_c('span',[_vm._v("Update Password")]):_c('span',[_c('i',{staticClass:"fas fa-circle-notch fa-spin"}),_vm._v("\n            Loading...\n          ")])])])])]),_vm._v(" "),_c('loading-modal',{attrs:{"showModal":_vm.loading,"modalMessage":"Loading..."}}),_vm._v(" "),_c('div',{class:{ 'modal':true, 'show':_vm.showModal },on:{"click":_vm.close}},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('label',[_vm._v("Success!")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"button cta small block",on:{"click":_vm.close}},[_vm._v("Close")])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"/assets/img/logo.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n          Your password has been changed successfully."),_c('br'),_vm._v("\n          You may now use your new password to login.\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StyleGuide_vue__ = __webpack_require__(382);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1d105bc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleGuide_vue__ = __webpack_require__(1053);
function injectStyle (ssrContext) {
  __webpack_require__(1051)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d1d105bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StyleGuide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1d105bc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleGuide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1052);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("245d994c", content, true, {});

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.status[data-v-d1d105bc] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-d1d105bc], .status.completed[data-v-d1d105bc] {\n    background: #26D97A;\n}\n.status.canceled[data-v-d1d105bc], .status.cancelled[data-v-d1d105bc], .status.failed[data-v-d1d105bc] {\n    background: #bbb;\n}\n.status.upcoming[data-v-d1d105bc] {\n    background: #f38d56;\n}\n.status.onboard[data-v-d1d105bc] {\n    background: #dc3168;\n}\n.status.ready[data-v-d1d105bc] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-d1d105bc], .status.requires_dispatch[data-v-d1d105bc] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-d1d105bc] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-d1d105bc] {\n    background: #5662f3;\n}\n.flight-status[data-v-d1d105bc] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-d1d105bc] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-d1d105bc] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-d1d105bc] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-d1d105bc] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-d1d105bc] {\n    background-color: #f35656;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/App/StyleGuide.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;CAC3B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B","file":"StyleGuide.vue","sourcesContent":["\n.status[data-v-d1d105bc] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-d1d105bc], .status.completed[data-v-d1d105bc] {\n    background: #26D97A;\n}\n.status.canceled[data-v-d1d105bc], .status.cancelled[data-v-d1d105bc], .status.failed[data-v-d1d105bc] {\n    background: #bbb;\n}\n.status.upcoming[data-v-d1d105bc] {\n    background: #f38d56;\n}\n.status.onboard[data-v-d1d105bc] {\n    background: #dc3168;\n}\n.status.ready[data-v-d1d105bc] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-d1d105bc], .status.requires_dispatch[data-v-d1d105bc] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-d1d105bc] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-d1d105bc] {\n    background: #5662f3;\n}\n.flight-status[data-v-d1d105bc] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-d1d105bc] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-d1d105bc] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-d1d105bc] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-d1d105bc] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-d1d105bc] {\n    background-color: #f35656;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"style-guide"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('h2',[_vm._v("Buttons")]),_vm._v(" "),_c('p',[_vm._v("\n        Button style for Opoli Backoffice."),_c('br'),_vm._v(" "),_c('a',{staticClass:"button",attrs:{"href":"#"}},[_vm._v("BUTTON")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("class=\"button\"")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-3 columns"},[_c('h3',[_vm._v("Size Modifiers")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"button xlarge",attrs:{"href":"#"}},[_vm._v("BUTTON")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("class=\"button xlarge\"")])]),_vm._v(" "),_c('p',[_c('a',{staticClass:"button large",attrs:{"href":"#"}},[_vm._v("BUTTON")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("class=\"button large\"")])]),_vm._v(" "),_c('p',[_c('a',{staticClass:"button small",attrs:{"href":"#"}},[_vm._v("BUTTON")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("class=\"button small\"")])]),_vm._v(" "),_c('p',[_c('a',{staticClass:"button xsmall",attrs:{"href":"#"}},[_vm._v("BUTTON")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("class=\"button xsmall\"")])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns"},[_c('h3',[_vm._v("Color Modifiers")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"button success",attrs:{"href":"#"}},[_vm._v("BUTTON")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("class=\"button success\"")])]),_vm._v(" "),_c('p',[_c('a',{staticClass:"button error",attrs:{"href":"#"}},[_vm._v("BUTTON")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("class=\"button error\"")])]),_vm._v(" "),_c('p',[_c('a',{staticClass:"button warning",attrs:{"href":"#"}},[_vm._v("BUTTON")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("class=\"button warning\"")])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns"},[_c('h3',[_vm._v("CTA Button")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"button cta",attrs:{"href":"#"}},[_vm._v("BUTTON")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("class=\"button cta\"")])]),_vm._v(" "),_c('p',[_c('a',{staticClass:"button cta success",attrs:{"href":"#"}},[_vm._v("BUTTON")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("class=\"button cta success\"")])]),_vm._v(" "),_c('p',[_c('a',{staticClass:"button cta error",attrs:{"href":"#"}},[_vm._v("BUTTON")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("class=\"button cta error\"")])]),_vm._v(" "),_c('p',[_c('a',{staticClass:"button cta warning",attrs:{"href":"#"}},[_vm._v("BUTTON")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("class=\"button cta warning\"")])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns"},[_c('h3',[_vm._v("Block Button")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"button cta block",attrs:{"href":"#"}},[_vm._v("BUTTON")]),_vm._v(" "),_c('code',[_vm._v("class=\"button cta block\"")])])])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('h2',[_vm._v("Status Labels")]),_vm._v(" "),_c('p',[_vm._v("Label style for Opoli Backoffice."),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-3 columns"},[_c('span',{staticClass:"status complete"},[_vm._v("Completed")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("class=\"status complete\"")])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns"},[_c('span',{staticClass:"status canceled"},[_vm._v("Canceled")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("class=\"status canceled\"")])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns"},[_c('span',{staticClass:"status onboard"},[_vm._v("On board")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("class=\"status onboard\"")])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns"},[_c('span',{staticClass:"status ready"},[_vm._v("Ready to go")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("class=\"status ready\"")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"small-3 columns"},[_c('span',{staticClass:"status upcoming"},[_vm._v("upcoming")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("class=\"status upcoming\"")])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns"},[_c('span',{staticClass:"status dispatched"},[_vm._v("dispatched")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("class=\"status dispatched\"")])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('span',{staticClass:"status requires-dispatch"},[_vm._v("Requires Dispatch")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("class=\"status requires-dispatch\"")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(383);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49b89bd4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1060);
function injectStyle (ssrContext) {
  __webpack_require__(1055)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49b89bd4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49b89bd4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1056);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("b2bf4138", content, true, {});

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.wrapper[data-v-49b89bd4] {\n  width: 600px;\n  margin: 0 auto;\n  background: #fafafa;\n  padding: 20px;\n  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n          box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n  border-radius: 2px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/TestUpload/index.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,+CAA+C;UACvC,uCAAuC;EAC/C,mBAAmB;CACpB","file":"index.vue","sourcesContent":["\n.wrapper[data-v-49b89bd4] {\n  width: 600px;\n  margin: 0 auto;\n  background: #fafafa;\n  padding: 20px;\n  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n          box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n  border-radius: 2px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Cropper.js v1.5.12
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2021-06-12T08:00:17.411Z
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Cropper = factory());
}(this, (function () { 'use strict';

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
  var WINDOW = IS_BROWSER ? window : {};
  var IS_TOUCH_DEVICE = IS_BROWSER && WINDOW.document.documentElement ? 'ontouchstart' in WINDOW.document.documentElement : false;
  var HAS_POINTER_EVENT = IS_BROWSER ? 'PointerEvent' in WINDOW : false;
  var NAMESPACE = 'cropper'; // Actions

  var ACTION_ALL = 'all';
  var ACTION_CROP = 'crop';
  var ACTION_MOVE = 'move';
  var ACTION_ZOOM = 'zoom';
  var ACTION_EAST = 'e';
  var ACTION_WEST = 'w';
  var ACTION_SOUTH = 's';
  var ACTION_NORTH = 'n';
  var ACTION_NORTH_EAST = 'ne';
  var ACTION_NORTH_WEST = 'nw';
  var ACTION_SOUTH_EAST = 'se';
  var ACTION_SOUTH_WEST = 'sw'; // Classes

  var CLASS_CROP = "".concat(NAMESPACE, "-crop");
  var CLASS_DISABLED = "".concat(NAMESPACE, "-disabled");
  var CLASS_HIDDEN = "".concat(NAMESPACE, "-hidden");
  var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
  var CLASS_INVISIBLE = "".concat(NAMESPACE, "-invisible");
  var CLASS_MODAL = "".concat(NAMESPACE, "-modal");
  var CLASS_MOVE = "".concat(NAMESPACE, "-move"); // Data keys

  var DATA_ACTION = "".concat(NAMESPACE, "Action");
  var DATA_PREVIEW = "".concat(NAMESPACE, "Preview"); // Drag modes

  var DRAG_MODE_CROP = 'crop';
  var DRAG_MODE_MOVE = 'move';
  var DRAG_MODE_NONE = 'none'; // Events

  var EVENT_CROP = 'crop';
  var EVENT_CROP_END = 'cropend';
  var EVENT_CROP_MOVE = 'cropmove';
  var EVENT_CROP_START = 'cropstart';
  var EVENT_DBLCLICK = 'dblclick';
  var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? 'touchstart' : 'mousedown';
  var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? 'touchmove' : 'mousemove';
  var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? 'touchend touchcancel' : 'mouseup';
  var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? 'pointerdown' : EVENT_TOUCH_START;
  var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? 'pointermove' : EVENT_TOUCH_MOVE;
  var EVENT_POINTER_UP = HAS_POINTER_EVENT ? 'pointerup pointercancel' : EVENT_TOUCH_END;
  var EVENT_READY = 'ready';
  var EVENT_RESIZE = 'resize';
  var EVENT_WHEEL = 'wheel';
  var EVENT_ZOOM = 'zoom'; // Mime types

  var MIME_TYPE_JPEG = 'image/jpeg'; // RegExps

  var REGEXP_ACTIONS = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/;
  var REGEXP_DATA_URL = /^data:/;
  var REGEXP_DATA_URL_JPEG = /^data:image\/jpeg;base64,/;
  var REGEXP_TAG_NAME = /^img|canvas$/i; // Misc
  // Inspired by the default width and height of a canvas element.

  var MIN_CONTAINER_WIDTH = 200;
  var MIN_CONTAINER_HEIGHT = 100;

  var DEFAULTS = {
    // Define the view mode of the cropper
    viewMode: 0,
    // 0, 1, 2, 3
    // Define the dragging mode of the cropper
    dragMode: DRAG_MODE_CROP,
    // 'crop', 'move' or 'none'
    // Define the initial aspect ratio of the crop box
    initialAspectRatio: NaN,
    // Define the aspect ratio of the crop box
    aspectRatio: NaN,
    // An object with the previous cropping result data
    data: null,
    // A selector for adding extra containers to preview
    preview: '',
    // Re-render the cropper when resize the window
    responsive: true,
    // Restore the cropped area after resize the window
    restore: true,
    // Check if the current image is a cross-origin image
    checkCrossOrigin: true,
    // Check the current image's Exif Orientation information
    checkOrientation: true,
    // Show the black modal
    modal: true,
    // Show the dashed lines for guiding
    guides: true,
    // Show the center indicator for guiding
    center: true,
    // Show the white modal to highlight the crop box
    highlight: true,
    // Show the grid background
    background: true,
    // Enable to crop the image automatically when initialize
    autoCrop: true,
    // Define the percentage of automatic cropping area when initializes
    autoCropArea: 0.8,
    // Enable to move the image
    movable: true,
    // Enable to rotate the image
    rotatable: true,
    // Enable to scale the image
    scalable: true,
    // Enable to zoom the image
    zoomable: true,
    // Enable to zoom the image by dragging touch
    zoomOnTouch: true,
    // Enable to zoom the image by wheeling mouse
    zoomOnWheel: true,
    // Define zoom ratio when zoom the image by wheeling mouse
    wheelZoomRatio: 0.1,
    // Enable to move the crop box
    cropBoxMovable: true,
    // Enable to resize the crop box
    cropBoxResizable: true,
    // Toggle drag mode between "crop" and "move" when click twice on the cropper
    toggleDragModeOnDblclick: true,
    // Size limitation
    minCanvasWidth: 0,
    minCanvasHeight: 0,
    minCropBoxWidth: 0,
    minCropBoxHeight: 0,
    minContainerWidth: MIN_CONTAINER_WIDTH,
    minContainerHeight: MIN_CONTAINER_HEIGHT,
    // Shortcuts of events
    ready: null,
    cropstart: null,
    cropmove: null,
    cropend: null,
    crop: null,
    zoom: null
  };

  var TEMPLATE = '<div class="cropper-container" touch-action="none">' + '<div class="cropper-wrap-box">' + '<div class="cropper-canvas"></div>' + '</div>' + '<div class="cropper-drag-box"></div>' + '<div class="cropper-crop-box">' + '<span class="cropper-view-box"></span>' + '<span class="cropper-dashed dashed-h"></span>' + '<span class="cropper-dashed dashed-v"></span>' + '<span class="cropper-center"></span>' + '<span class="cropper-face"></span>' + '<span class="cropper-line line-e" data-cropper-action="e"></span>' + '<span class="cropper-line line-n" data-cropper-action="n"></span>' + '<span class="cropper-line line-w" data-cropper-action="w"></span>' + '<span class="cropper-line line-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-e" data-cropper-action="e"></span>' + '<span class="cropper-point point-n" data-cropper-action="n"></span>' + '<span class="cropper-point point-w" data-cropper-action="w"></span>' + '<span class="cropper-point point-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-ne" data-cropper-action="ne"></span>' + '<span class="cropper-point point-nw" data-cropper-action="nw"></span>' + '<span class="cropper-point point-sw" data-cropper-action="sw"></span>' + '<span class="cropper-point point-se" data-cropper-action="se"></span>' + '</div>' + '</div>';

  /**
   * Check if the given value is not a number.
   */

  var isNaN = Number.isNaN || WINDOW.isNaN;
  /**
   * Check if the given value is a number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a number, else `false`.
   */

  function isNumber(value) {
    return typeof value === 'number' && !isNaN(value);
  }
  /**
   * Check if the given value is a positive number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
   */

  var isPositiveNumber = function isPositiveNumber(value) {
    return value > 0 && value < Infinity;
  };
  /**
   * Check if the given value is undefined.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is undefined, else `false`.
   */

  function isUndefined(value) {
    return typeof value === 'undefined';
  }
  /**
   * Check if the given value is an object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is an object, else `false`.
   */

  function isObject(value) {
    return _typeof(value) === 'object' && value !== null;
  }
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  /**
   * Check if the given value is a plain object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a plain object, else `false`.
   */

  function isPlainObject(value) {
    if (!isObject(value)) {
      return false;
    }

    try {
      var _constructor = value.constructor;
      var prototype = _constructor.prototype;
      return _constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
    } catch (error) {
      return false;
    }
  }
  /**
   * Check if the given value is a function.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a function, else `false`.
   */

  function isFunction(value) {
    return typeof value === 'function';
  }
  var slice = Array.prototype.slice;
  /**
   * Convert array-like or iterable object to an array.
   * @param {*} value - The value to convert.
   * @returns {Array} Returns a new array.
   */

  function toArray(value) {
    return Array.from ? Array.from(value) : slice.call(value);
  }
  /**
   * Iterate the given data.
   * @param {*} data - The data to iterate.
   * @param {Function} callback - The process function for each element.
   * @returns {*} The original data.
   */

  function forEach(data, callback) {
    if (data && isFunction(callback)) {
      if (Array.isArray(data) || isNumber(data.length)
      /* array-like */
      ) {
          toArray(data).forEach(function (value, key) {
            callback.call(data, value, key, data);
          });
        } else if (isObject(data)) {
        Object.keys(data).forEach(function (key) {
          callback.call(data, data[key], key, data);
        });
      }
    }

    return data;
  }
  /**
   * Extend the given object.
   * @param {*} target - The target object to extend.
   * @param {*} args - The rest objects for merging to the target object.
   * @returns {Object} The extended object.
   */

  var assign = Object.assign || function assign(target) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (isObject(target) && args.length > 0) {
      args.forEach(function (arg) {
        if (isObject(arg)) {
          Object.keys(arg).forEach(function (key) {
            target[key] = arg[key];
          });
        }
      });
    }

    return target;
  };
  var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
  /**
   * Normalize decimal number.
   * Check out {@link https://0.30000000000000004.com/}
   * @param {number} value - The value to normalize.
   * @param {number} [times=100000000000] - The times for normalizing.
   * @returns {number} Returns the normalized number.
   */

  function normalizeDecimalNumber(value) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
    return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
  }
  var REGEXP_SUFFIX = /^width|height|left|top|marginLeft|marginTop$/;
  /**
   * Apply styles to the given element.
   * @param {Element} element - The target element.
   * @param {Object} styles - The styles for applying.
   */

  function setStyle(element, styles) {
    var style = element.style;
    forEach(styles, function (value, property) {
      if (REGEXP_SUFFIX.test(property) && isNumber(value)) {
        value = "".concat(value, "px");
      }

      style[property] = value;
    });
  }
  /**
   * Check if the given element has a special class.
   * @param {Element} element - The element to check.
   * @param {string} value - The class to search.
   * @returns {boolean} Returns `true` if the special class was found.
   */

  function hasClass(element, value) {
    return element.classList ? element.classList.contains(value) : element.className.indexOf(value) > -1;
  }
  /**
   * Add classes to the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be added.
   */

  function addClass(element, value) {
    if (!value) {
      return;
    }

    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        addClass(elem, value);
      });
      return;
    }

    if (element.classList) {
      element.classList.add(value);
      return;
    }

    var className = element.className.trim();

    if (!className) {
      element.className = value;
    } else if (className.indexOf(value) < 0) {
      element.className = "".concat(className, " ").concat(value);
    }
  }
  /**
   * Remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be removed.
   */

  function removeClass(element, value) {
    if (!value) {
      return;
    }

    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        removeClass(elem, value);
      });
      return;
    }

    if (element.classList) {
      element.classList.remove(value);
      return;
    }

    if (element.className.indexOf(value) >= 0) {
      element.className = element.className.replace(value, '');
    }
  }
  /**
   * Add or remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be toggled.
   * @param {boolean} added - Add only.
   */

  function toggleClass(element, value, added) {
    if (!value) {
      return;
    }

    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        toggleClass(elem, value, added);
      });
      return;
    } // IE10-11 doesn't support the second parameter of `classList.toggle`


    if (added) {
      addClass(element, value);
    } else {
      removeClass(element, value);
    }
  }
  var REGEXP_CAMEL_CASE = /([a-z\d])([A-Z])/g;
  /**
   * Transform the given string from camelCase to kebab-case
   * @param {string} value - The value to transform.
   * @returns {string} The transformed value.
   */

  function toParamCase(value) {
    return value.replace(REGEXP_CAMEL_CASE, '$1-$2').toLowerCase();
  }
  /**
   * Get data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to get.
   * @returns {string} The data value.
   */

  function getData(element, name) {
    if (isObject(element[name])) {
      return element[name];
    }

    if (element.dataset) {
      return element.dataset[name];
    }

    return element.getAttribute("data-".concat(toParamCase(name)));
  }
  /**
   * Set data to the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to set.
   * @param {string} data - The data value.
   */

  function setData(element, name, data) {
    if (isObject(data)) {
      element[name] = data;
    } else if (element.dataset) {
      element.dataset[name] = data;
    } else {
      element.setAttribute("data-".concat(toParamCase(name)), data);
    }
  }
  /**
   * Remove data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to remove.
   */

  function removeData(element, name) {
    if (isObject(element[name])) {
      try {
        delete element[name];
      } catch (error) {
        element[name] = undefined;
      }
    } else if (element.dataset) {
      // #128 Safari not allows to delete dataset property
      try {
        delete element.dataset[name];
      } catch (error) {
        element.dataset[name] = undefined;
      }
    } else {
      element.removeAttribute("data-".concat(toParamCase(name)));
    }
  }
  var REGEXP_SPACES = /\s\s*/;

  var onceSupported = function () {
    var supported = false;

    if (IS_BROWSER) {
      var once = false;

      var listener = function listener() {};

      var options = Object.defineProperty({}, 'once', {
        get: function get() {
          supported = true;
          return once;
        },

        /**
         * This setter can fix a `TypeError` in strict mode
         * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
         * @param {boolean} value - The value to set
         */
        set: function set(value) {
          once = value;
        }
      });
      WINDOW.addEventListener('test', listener, options);
      WINDOW.removeEventListener('test', listener, options);
    }

    return supported;
  }();
  /**
   * Remove event listener from the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */


  function removeListener(element, type, listener) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var handler = listener;
    type.trim().split(REGEXP_SPACES).forEach(function (event) {
      if (!onceSupported) {
        var listeners = element.listeners;

        if (listeners && listeners[event] && listeners[event][listener]) {
          handler = listeners[event][listener];
          delete listeners[event][listener];

          if (Object.keys(listeners[event]).length === 0) {
            delete listeners[event];
          }

          if (Object.keys(listeners).length === 0) {
            delete element.listeners;
          }
        }
      }

      element.removeEventListener(event, handler, options);
    });
  }
  /**
   * Add event listener to the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */

  function addListener(element, type, listener) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var _handler = listener;
    type.trim().split(REGEXP_SPACES).forEach(function (event) {
      if (options.once && !onceSupported) {
        var _element$listeners = element.listeners,
            listeners = _element$listeners === void 0 ? {} : _element$listeners;

        _handler = function handler() {
          delete listeners[event][listener];
          element.removeEventListener(event, _handler, options);

          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          listener.apply(element, args);
        };

        if (!listeners[event]) {
          listeners[event] = {};
        }

        if (listeners[event][listener]) {
          element.removeEventListener(event, listeners[event][listener], options);
        }

        listeners[event][listener] = _handler;
        element.listeners = listeners;
      }

      element.addEventListener(event, _handler, options);
    });
  }
  /**
   * Dispatch event on the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Object} data - The additional event data.
   * @returns {boolean} Indicate if the event is default prevented or not.
   */

  function dispatchEvent(element, type, data) {
    var event; // Event and CustomEvent on IE9-11 are global objects, not constructors

    if (isFunction(Event) && isFunction(CustomEvent)) {
      event = new CustomEvent(type, {
        detail: data,
        bubbles: true,
        cancelable: true
      });
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(type, true, true, data);
    }

    return element.dispatchEvent(event);
  }
  /**
   * Get the offset base on the document.
   * @param {Element} element - The target element.
   * @returns {Object} The offset data.
   */

  function getOffset(element) {
    var box = element.getBoundingClientRect();
    return {
      left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
      top: box.top + (window.pageYOffset - document.documentElement.clientTop)
    };
  }
  var location = WINDOW.location;
  var REGEXP_ORIGINS = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
  /**
   * Check if the given URL is a cross origin URL.
   * @param {string} url - The target URL.
   * @returns {boolean} Returns `true` if the given URL is a cross origin URL, else `false`.
   */

  function isCrossOriginURL(url) {
    var parts = url.match(REGEXP_ORIGINS);
    return parts !== null && (parts[1] !== location.protocol || parts[2] !== location.hostname || parts[3] !== location.port);
  }
  /**
   * Add timestamp to the given URL.
   * @param {string} url - The target URL.
   * @returns {string} The result URL.
   */

  function addTimestamp(url) {
    var timestamp = "timestamp=".concat(new Date().getTime());
    return url + (url.indexOf('?') === -1 ? '?' : '&') + timestamp;
  }
  /**
   * Get transforms base on the given object.
   * @param {Object} obj - The target object.
   * @returns {string} A string contains transform values.
   */

  function getTransforms(_ref) {
    var rotate = _ref.rotate,
        scaleX = _ref.scaleX,
        scaleY = _ref.scaleY,
        translateX = _ref.translateX,
        translateY = _ref.translateY;
    var values = [];

    if (isNumber(translateX) && translateX !== 0) {
      values.push("translateX(".concat(translateX, "px)"));
    }

    if (isNumber(translateY) && translateY !== 0) {
      values.push("translateY(".concat(translateY, "px)"));
    } // Rotate should come first before scale to match orientation transform


    if (isNumber(rotate) && rotate !== 0) {
      values.push("rotate(".concat(rotate, "deg)"));
    }

    if (isNumber(scaleX) && scaleX !== 1) {
      values.push("scaleX(".concat(scaleX, ")"));
    }

    if (isNumber(scaleY) && scaleY !== 1) {
      values.push("scaleY(".concat(scaleY, ")"));
    }

    var transform = values.length ? values.join(' ') : 'none';
    return {
      WebkitTransform: transform,
      msTransform: transform,
      transform: transform
    };
  }
  /**
   * Get the max ratio of a group of pointers.
   * @param {string} pointers - The target pointers.
   * @returns {number} The result ratio.
   */

  function getMaxZoomRatio(pointers) {
    var pointers2 = _objectSpread2({}, pointers);

    var maxRatio = 0;
    forEach(pointers, function (pointer, pointerId) {
      delete pointers2[pointerId];
      forEach(pointers2, function (pointer2) {
        var x1 = Math.abs(pointer.startX - pointer2.startX);
        var y1 = Math.abs(pointer.startY - pointer2.startY);
        var x2 = Math.abs(pointer.endX - pointer2.endX);
        var y2 = Math.abs(pointer.endY - pointer2.endY);
        var z1 = Math.sqrt(x1 * x1 + y1 * y1);
        var z2 = Math.sqrt(x2 * x2 + y2 * y2);
        var ratio = (z2 - z1) / z1;

        if (Math.abs(ratio) > Math.abs(maxRatio)) {
          maxRatio = ratio;
        }
      });
    });
    return maxRatio;
  }
  /**
   * Get a pointer from an event object.
   * @param {Object} event - The target event object.
   * @param {boolean} endOnly - Indicates if only returns the end point coordinate or not.
   * @returns {Object} The result pointer contains start and/or end point coordinates.
   */

  function getPointer(_ref2, endOnly) {
    var pageX = _ref2.pageX,
        pageY = _ref2.pageY;
    var end = {
      endX: pageX,
      endY: pageY
    };
    return endOnly ? end : _objectSpread2({
      startX: pageX,
      startY: pageY
    }, end);
  }
  /**
   * Get the center point coordinate of a group of pointers.
   * @param {Object} pointers - The target pointers.
   * @returns {Object} The center point coordinate.
   */

  function getPointersCenter(pointers) {
    var pageX = 0;
    var pageY = 0;
    var count = 0;
    forEach(pointers, function (_ref3) {
      var startX = _ref3.startX,
          startY = _ref3.startY;
      pageX += startX;
      pageY += startY;
      count += 1;
    });
    pageX /= count;
    pageY /= count;
    return {
      pageX: pageX,
      pageY: pageY
    };
  }
  /**
   * Get the max sizes in a rectangle under the given aspect ratio.
   * @param {Object} data - The original sizes.
   * @param {string} [type='contain'] - The adjust type.
   * @returns {Object} The result sizes.
   */

  function getAdjustedSizes(_ref4) // or 'cover'
  {
    var aspectRatio = _ref4.aspectRatio,
        height = _ref4.height,
        width = _ref4.width;
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'contain';
    var isValidWidth = isPositiveNumber(width);
    var isValidHeight = isPositiveNumber(height);

    if (isValidWidth && isValidHeight) {
      var adjustedWidth = height * aspectRatio;

      if (type === 'contain' && adjustedWidth > width || type === 'cover' && adjustedWidth < width) {
        height = width / aspectRatio;
      } else {
        width = height * aspectRatio;
      }
    } else if (isValidWidth) {
      height = width / aspectRatio;
    } else if (isValidHeight) {
      width = height * aspectRatio;
    }

    return {
      width: width,
      height: height
    };
  }
  /**
   * Get the new sizes of a rectangle after rotated.
   * @param {Object} data - The original sizes.
   * @returns {Object} The result sizes.
   */

  function getRotatedSizes(_ref5) {
    var width = _ref5.width,
        height = _ref5.height,
        degree = _ref5.degree;
    degree = Math.abs(degree) % 180;

    if (degree === 90) {
      return {
        width: height,
        height: width
      };
    }

    var arc = degree % 90 * Math.PI / 180;
    var sinArc = Math.sin(arc);
    var cosArc = Math.cos(arc);
    var newWidth = width * cosArc + height * sinArc;
    var newHeight = width * sinArc + height * cosArc;
    return degree > 90 ? {
      width: newHeight,
      height: newWidth
    } : {
      width: newWidth,
      height: newHeight
    };
  }
  /**
   * Get a canvas which drew the given image.
   * @param {HTMLImageElement} image - The image for drawing.
   * @param {Object} imageData - The image data.
   * @param {Object} canvasData - The canvas data.
   * @param {Object} options - The options.
   * @returns {HTMLCanvasElement} The result canvas.
   */

  function getSourceCanvas(image, _ref6, _ref7, _ref8) {
    var imageAspectRatio = _ref6.aspectRatio,
        imageNaturalWidth = _ref6.naturalWidth,
        imageNaturalHeight = _ref6.naturalHeight,
        _ref6$rotate = _ref6.rotate,
        rotate = _ref6$rotate === void 0 ? 0 : _ref6$rotate,
        _ref6$scaleX = _ref6.scaleX,
        scaleX = _ref6$scaleX === void 0 ? 1 : _ref6$scaleX,
        _ref6$scaleY = _ref6.scaleY,
        scaleY = _ref6$scaleY === void 0 ? 1 : _ref6$scaleY;
    var aspectRatio = _ref7.aspectRatio,
        naturalWidth = _ref7.naturalWidth,
        naturalHeight = _ref7.naturalHeight;
    var _ref8$fillColor = _ref8.fillColor,
        fillColor = _ref8$fillColor === void 0 ? 'transparent' : _ref8$fillColor,
        _ref8$imageSmoothingE = _ref8.imageSmoothingEnabled,
        imageSmoothingEnabled = _ref8$imageSmoothingE === void 0 ? true : _ref8$imageSmoothingE,
        _ref8$imageSmoothingQ = _ref8.imageSmoothingQuality,
        imageSmoothingQuality = _ref8$imageSmoothingQ === void 0 ? 'low' : _ref8$imageSmoothingQ,
        _ref8$maxWidth = _ref8.maxWidth,
        maxWidth = _ref8$maxWidth === void 0 ? Infinity : _ref8$maxWidth,
        _ref8$maxHeight = _ref8.maxHeight,
        maxHeight = _ref8$maxHeight === void 0 ? Infinity : _ref8$maxHeight,
        _ref8$minWidth = _ref8.minWidth,
        minWidth = _ref8$minWidth === void 0 ? 0 : _ref8$minWidth,
        _ref8$minHeight = _ref8.minHeight,
        minHeight = _ref8$minHeight === void 0 ? 0 : _ref8$minHeight;
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    var maxSizes = getAdjustedSizes({
      aspectRatio: aspectRatio,
      width: maxWidth,
      height: maxHeight
    });
    var minSizes = getAdjustedSizes({
      aspectRatio: aspectRatio,
      width: minWidth,
      height: minHeight
    }, 'cover');
    var width = Math.min(maxSizes.width, Math.max(minSizes.width, naturalWidth));
    var height = Math.min(maxSizes.height, Math.max(minSizes.height, naturalHeight)); // Note: should always use image's natural sizes for drawing as
    // imageData.naturalWidth === canvasData.naturalHeight when rotate % 180 === 90

    var destMaxSizes = getAdjustedSizes({
      aspectRatio: imageAspectRatio,
      width: maxWidth,
      height: maxHeight
    });
    var destMinSizes = getAdjustedSizes({
      aspectRatio: imageAspectRatio,
      width: minWidth,
      height: minHeight
    }, 'cover');
    var destWidth = Math.min(destMaxSizes.width, Math.max(destMinSizes.width, imageNaturalWidth));
    var destHeight = Math.min(destMaxSizes.height, Math.max(destMinSizes.height, imageNaturalHeight));
    var params = [-destWidth / 2, -destHeight / 2, destWidth, destHeight];
    canvas.width = normalizeDecimalNumber(width);
    canvas.height = normalizeDecimalNumber(height);
    context.fillStyle = fillColor;
    context.fillRect(0, 0, width, height);
    context.save();
    context.translate(width / 2, height / 2);
    context.rotate(rotate * Math.PI / 180);
    context.scale(scaleX, scaleY);
    context.imageSmoothingEnabled = imageSmoothingEnabled;
    context.imageSmoothingQuality = imageSmoothingQuality;
    context.drawImage.apply(context, [image].concat(_toConsumableArray(params.map(function (param) {
      return Math.floor(normalizeDecimalNumber(param));
    }))));
    context.restore();
    return canvas;
  }
  var fromCharCode = String.fromCharCode;
  /**
   * Get string from char code in data view.
   * @param {DataView} dataView - The data view for read.
   * @param {number} start - The start index.
   * @param {number} length - The read length.
   * @returns {string} The read result.
   */

  function getStringFromCharCode(dataView, start, length) {
    var str = '';
    length += start;

    for (var i = start; i < length; i += 1) {
      str += fromCharCode(dataView.getUint8(i));
    }

    return str;
  }
  var REGEXP_DATA_URL_HEAD = /^data:.*,/;
  /**
   * Transform Data URL to array buffer.
   * @param {string} dataURL - The Data URL to transform.
   * @returns {ArrayBuffer} The result array buffer.
   */

  function dataURLToArrayBuffer(dataURL) {
    var base64 = dataURL.replace(REGEXP_DATA_URL_HEAD, '');
    var binary = atob(base64);
    var arrayBuffer = new ArrayBuffer(binary.length);
    var uint8 = new Uint8Array(arrayBuffer);
    forEach(uint8, function (value, i) {
      uint8[i] = binary.charCodeAt(i);
    });
    return arrayBuffer;
  }
  /**
   * Transform array buffer to Data URL.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {string} mimeType - The mime type of the Data URL.
   * @returns {string} The result Data URL.
   */

  function arrayBufferToDataURL(arrayBuffer, mimeType) {
    var chunks = []; // Chunk Typed Array for better performance (#435)

    var chunkSize = 8192;
    var uint8 = new Uint8Array(arrayBuffer);

    while (uint8.length > 0) {
      // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
      // eslint-disable-next-line prefer-spread
      chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
      uint8 = uint8.subarray(chunkSize);
    }

    return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join('')));
  }
  /**
   * Get orientation value from given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {number} The read orientation value.
   */

  function resetAndGetOrientation(arrayBuffer) {
    var dataView = new DataView(arrayBuffer);
    var orientation; // Ignores range error when the image does not have correct Exif information

    try {
      var littleEndian;
      var app1Start;
      var ifdStart; // Only handle JPEG image (start by 0xFFD8)

      if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
        var length = dataView.byteLength;
        var offset = 2;

        while (offset + 1 < length) {
          if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
            app1Start = offset;
            break;
          }

          offset += 1;
        }
      }

      if (app1Start) {
        var exifIDCode = app1Start + 4;
        var tiffOffset = app1Start + 10;

        if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
          var endianness = dataView.getUint16(tiffOffset);
          littleEndian = endianness === 0x4949;

          if (littleEndian || endianness === 0x4D4D
          /* bigEndian */
          ) {
              if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
                var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);

                if (firstIFDOffset >= 0x00000008) {
                  ifdStart = tiffOffset + firstIFDOffset;
                }
              }
            }
        }
      }

      if (ifdStart) {
        var _length = dataView.getUint16(ifdStart, littleEndian);

        var _offset;

        var i;

        for (i = 0; i < _length; i += 1) {
          _offset = ifdStart + i * 12 + 2;

          if (dataView.getUint16(_offset, littleEndian) === 0x0112
          /* Orientation */
          ) {
              // 8 is the offset of the current tag's value
              _offset += 8; // Get the original orientation value

              orientation = dataView.getUint16(_offset, littleEndian); // Override the orientation with its default value

              dataView.setUint16(_offset, 1, littleEndian);
              break;
            }
        }
      }
    } catch (error) {
      orientation = 1;
    }

    return orientation;
  }
  /**
   * Parse Exif Orientation value.
   * @param {number} orientation - The orientation to parse.
   * @returns {Object} The parsed result.
   */

  function parseOrientation(orientation) {
    var rotate = 0;
    var scaleX = 1;
    var scaleY = 1;

    switch (orientation) {
      // Flip horizontal
      case 2:
        scaleX = -1;
        break;
      // Rotate left 180°

      case 3:
        rotate = -180;
        break;
      // Flip vertical

      case 4:
        scaleY = -1;
        break;
      // Flip vertical and rotate right 90°

      case 5:
        rotate = 90;
        scaleY = -1;
        break;
      // Rotate right 90°

      case 6:
        rotate = 90;
        break;
      // Flip horizontal and rotate right 90°

      case 7:
        rotate = 90;
        scaleX = -1;
        break;
      // Rotate left 90°

      case 8:
        rotate = -90;
        break;
    }

    return {
      rotate: rotate,
      scaleX: scaleX,
      scaleY: scaleY
    };
  }

  var render = {
    render: function render() {
      this.initContainer();
      this.initCanvas();
      this.initCropBox();
      this.renderCanvas();

      if (this.cropped) {
        this.renderCropBox();
      }
    },
    initContainer: function initContainer() {
      var element = this.element,
          options = this.options,
          container = this.container,
          cropper = this.cropper;
      var minWidth = Number(options.minContainerWidth);
      var minHeight = Number(options.minContainerHeight);
      addClass(cropper, CLASS_HIDDEN);
      removeClass(element, CLASS_HIDDEN);
      var containerData = {
        width: Math.max(container.offsetWidth, minWidth >= 0 ? minWidth : MIN_CONTAINER_WIDTH),
        height: Math.max(container.offsetHeight, minHeight >= 0 ? minHeight : MIN_CONTAINER_HEIGHT)
      };
      this.containerData = containerData;
      setStyle(cropper, {
        width: containerData.width,
        height: containerData.height
      });
      addClass(element, CLASS_HIDDEN);
      removeClass(cropper, CLASS_HIDDEN);
    },
    // Canvas (image wrapper)
    initCanvas: function initCanvas() {
      var containerData = this.containerData,
          imageData = this.imageData;
      var viewMode = this.options.viewMode;
      var rotated = Math.abs(imageData.rotate) % 180 === 90;
      var naturalWidth = rotated ? imageData.naturalHeight : imageData.naturalWidth;
      var naturalHeight = rotated ? imageData.naturalWidth : imageData.naturalHeight;
      var aspectRatio = naturalWidth / naturalHeight;
      var canvasWidth = containerData.width;
      var canvasHeight = containerData.height;

      if (containerData.height * aspectRatio > containerData.width) {
        if (viewMode === 3) {
          canvasWidth = containerData.height * aspectRatio;
        } else {
          canvasHeight = containerData.width / aspectRatio;
        }
      } else if (viewMode === 3) {
        canvasHeight = containerData.width / aspectRatio;
      } else {
        canvasWidth = containerData.height * aspectRatio;
      }

      var canvasData = {
        aspectRatio: aspectRatio,
        naturalWidth: naturalWidth,
        naturalHeight: naturalHeight,
        width: canvasWidth,
        height: canvasHeight
      };
      this.canvasData = canvasData;
      this.limited = viewMode === 1 || viewMode === 2;
      this.limitCanvas(true, true);
      canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
      canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
      canvasData.left = (containerData.width - canvasData.width) / 2;
      canvasData.top = (containerData.height - canvasData.height) / 2;
      canvasData.oldLeft = canvasData.left;
      canvasData.oldTop = canvasData.top;
      this.initialCanvasData = assign({}, canvasData);
    },
    limitCanvas: function limitCanvas(sizeLimited, positionLimited) {
      var options = this.options,
          containerData = this.containerData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData;
      var viewMode = options.viewMode;
      var aspectRatio = canvasData.aspectRatio;
      var cropped = this.cropped && cropBoxData;

      if (sizeLimited) {
        var minCanvasWidth = Number(options.minCanvasWidth) || 0;
        var minCanvasHeight = Number(options.minCanvasHeight) || 0;

        if (viewMode > 1) {
          minCanvasWidth = Math.max(minCanvasWidth, containerData.width);
          minCanvasHeight = Math.max(minCanvasHeight, containerData.height);

          if (viewMode === 3) {
            if (minCanvasHeight * aspectRatio > minCanvasWidth) {
              minCanvasWidth = minCanvasHeight * aspectRatio;
            } else {
              minCanvasHeight = minCanvasWidth / aspectRatio;
            }
          }
        } else if (viewMode > 0) {
          if (minCanvasWidth) {
            minCanvasWidth = Math.max(minCanvasWidth, cropped ? cropBoxData.width : 0);
          } else if (minCanvasHeight) {
            minCanvasHeight = Math.max(minCanvasHeight, cropped ? cropBoxData.height : 0);
          } else if (cropped) {
            minCanvasWidth = cropBoxData.width;
            minCanvasHeight = cropBoxData.height;

            if (minCanvasHeight * aspectRatio > minCanvasWidth) {
              minCanvasWidth = minCanvasHeight * aspectRatio;
            } else {
              minCanvasHeight = minCanvasWidth / aspectRatio;
            }
          }
        }

        var _getAdjustedSizes = getAdjustedSizes({
          aspectRatio: aspectRatio,
          width: minCanvasWidth,
          height: minCanvasHeight
        });

        minCanvasWidth = _getAdjustedSizes.width;
        minCanvasHeight = _getAdjustedSizes.height;
        canvasData.minWidth = minCanvasWidth;
        canvasData.minHeight = minCanvasHeight;
        canvasData.maxWidth = Infinity;
        canvasData.maxHeight = Infinity;
      }

      if (positionLimited) {
        if (viewMode > (cropped ? 0 : 1)) {
          var newCanvasLeft = containerData.width - canvasData.width;
          var newCanvasTop = containerData.height - canvasData.height;
          canvasData.minLeft = Math.min(0, newCanvasLeft);
          canvasData.minTop = Math.min(0, newCanvasTop);
          canvasData.maxLeft = Math.max(0, newCanvasLeft);
          canvasData.maxTop = Math.max(0, newCanvasTop);

          if (cropped && this.limited) {
            canvasData.minLeft = Math.min(cropBoxData.left, cropBoxData.left + (cropBoxData.width - canvasData.width));
            canvasData.minTop = Math.min(cropBoxData.top, cropBoxData.top + (cropBoxData.height - canvasData.height));
            canvasData.maxLeft = cropBoxData.left;
            canvasData.maxTop = cropBoxData.top;

            if (viewMode === 2) {
              if (canvasData.width >= containerData.width) {
                canvasData.minLeft = Math.min(0, newCanvasLeft);
                canvasData.maxLeft = Math.max(0, newCanvasLeft);
              }

              if (canvasData.height >= containerData.height) {
                canvasData.minTop = Math.min(0, newCanvasTop);
                canvasData.maxTop = Math.max(0, newCanvasTop);
              }
            }
          }
        } else {
          canvasData.minLeft = -canvasData.width;
          canvasData.minTop = -canvasData.height;
          canvasData.maxLeft = containerData.width;
          canvasData.maxTop = containerData.height;
        }
      }
    },
    renderCanvas: function renderCanvas(changed, transformed) {
      var canvasData = this.canvasData,
          imageData = this.imageData;

      if (transformed) {
        var _getRotatedSizes = getRotatedSizes({
          width: imageData.naturalWidth * Math.abs(imageData.scaleX || 1),
          height: imageData.naturalHeight * Math.abs(imageData.scaleY || 1),
          degree: imageData.rotate || 0
        }),
            naturalWidth = _getRotatedSizes.width,
            naturalHeight = _getRotatedSizes.height;

        var width = canvasData.width * (naturalWidth / canvasData.naturalWidth);
        var height = canvasData.height * (naturalHeight / canvasData.naturalHeight);
        canvasData.left -= (width - canvasData.width) / 2;
        canvasData.top -= (height - canvasData.height) / 2;
        canvasData.width = width;
        canvasData.height = height;
        canvasData.aspectRatio = naturalWidth / naturalHeight;
        canvasData.naturalWidth = naturalWidth;
        canvasData.naturalHeight = naturalHeight;
        this.limitCanvas(true, false);
      }

      if (canvasData.width > canvasData.maxWidth || canvasData.width < canvasData.minWidth) {
        canvasData.left = canvasData.oldLeft;
      }

      if (canvasData.height > canvasData.maxHeight || canvasData.height < canvasData.minHeight) {
        canvasData.top = canvasData.oldTop;
      }

      canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
      canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
      this.limitCanvas(false, true);
      canvasData.left = Math.min(Math.max(canvasData.left, canvasData.minLeft), canvasData.maxLeft);
      canvasData.top = Math.min(Math.max(canvasData.top, canvasData.minTop), canvasData.maxTop);
      canvasData.oldLeft = canvasData.left;
      canvasData.oldTop = canvasData.top;
      setStyle(this.canvas, assign({
        width: canvasData.width,
        height: canvasData.height
      }, getTransforms({
        translateX: canvasData.left,
        translateY: canvasData.top
      })));
      this.renderImage(changed);

      if (this.cropped && this.limited) {
        this.limitCropBox(true, true);
      }
    },
    renderImage: function renderImage(changed) {
      var canvasData = this.canvasData,
          imageData = this.imageData;
      var width = imageData.naturalWidth * (canvasData.width / canvasData.naturalWidth);
      var height = imageData.naturalHeight * (canvasData.height / canvasData.naturalHeight);
      assign(imageData, {
        width: width,
        height: height,
        left: (canvasData.width - width) / 2,
        top: (canvasData.height - height) / 2
      });
      setStyle(this.image, assign({
        width: imageData.width,
        height: imageData.height
      }, getTransforms(assign({
        translateX: imageData.left,
        translateY: imageData.top
      }, imageData))));

      if (changed) {
        this.output();
      }
    },
    initCropBox: function initCropBox() {
      var options = this.options,
          canvasData = this.canvasData;
      var aspectRatio = options.aspectRatio || options.initialAspectRatio;
      var autoCropArea = Number(options.autoCropArea) || 0.8;
      var cropBoxData = {
        width: canvasData.width,
        height: canvasData.height
      };

      if (aspectRatio) {
        if (canvasData.height * aspectRatio > canvasData.width) {
          cropBoxData.height = cropBoxData.width / aspectRatio;
        } else {
          cropBoxData.width = cropBoxData.height * aspectRatio;
        }
      }

      this.cropBoxData = cropBoxData;
      this.limitCropBox(true, true); // Initialize auto crop area

      cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
      cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight); // The width/height of auto crop area must large than "minWidth/Height"

      cropBoxData.width = Math.max(cropBoxData.minWidth, cropBoxData.width * autoCropArea);
      cropBoxData.height = Math.max(cropBoxData.minHeight, cropBoxData.height * autoCropArea);
      cropBoxData.left = canvasData.left + (canvasData.width - cropBoxData.width) / 2;
      cropBoxData.top = canvasData.top + (canvasData.height - cropBoxData.height) / 2;
      cropBoxData.oldLeft = cropBoxData.left;
      cropBoxData.oldTop = cropBoxData.top;
      this.initialCropBoxData = assign({}, cropBoxData);
    },
    limitCropBox: function limitCropBox(sizeLimited, positionLimited) {
      var options = this.options,
          containerData = this.containerData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData,
          limited = this.limited;
      var aspectRatio = options.aspectRatio;

      if (sizeLimited) {
        var minCropBoxWidth = Number(options.minCropBoxWidth) || 0;
        var minCropBoxHeight = Number(options.minCropBoxHeight) || 0;
        var maxCropBoxWidth = limited ? Math.min(containerData.width, canvasData.width, canvasData.width + canvasData.left, containerData.width - canvasData.left) : containerData.width;
        var maxCropBoxHeight = limited ? Math.min(containerData.height, canvasData.height, canvasData.height + canvasData.top, containerData.height - canvasData.top) : containerData.height; // The min/maxCropBoxWidth/Height must be less than container's width/height

        minCropBoxWidth = Math.min(minCropBoxWidth, containerData.width);
        minCropBoxHeight = Math.min(minCropBoxHeight, containerData.height);

        if (aspectRatio) {
          if (minCropBoxWidth && minCropBoxHeight) {
            if (minCropBoxHeight * aspectRatio > minCropBoxWidth) {
              minCropBoxHeight = minCropBoxWidth / aspectRatio;
            } else {
              minCropBoxWidth = minCropBoxHeight * aspectRatio;
            }
          } else if (minCropBoxWidth) {
            minCropBoxHeight = minCropBoxWidth / aspectRatio;
          } else if (minCropBoxHeight) {
            minCropBoxWidth = minCropBoxHeight * aspectRatio;
          }

          if (maxCropBoxHeight * aspectRatio > maxCropBoxWidth) {
            maxCropBoxHeight = maxCropBoxWidth / aspectRatio;
          } else {
            maxCropBoxWidth = maxCropBoxHeight * aspectRatio;
          }
        } // The minWidth/Height must be less than maxWidth/Height


        cropBoxData.minWidth = Math.min(minCropBoxWidth, maxCropBoxWidth);
        cropBoxData.minHeight = Math.min(minCropBoxHeight, maxCropBoxHeight);
        cropBoxData.maxWidth = maxCropBoxWidth;
        cropBoxData.maxHeight = maxCropBoxHeight;
      }

      if (positionLimited) {
        if (limited) {
          cropBoxData.minLeft = Math.max(0, canvasData.left);
          cropBoxData.minTop = Math.max(0, canvasData.top);
          cropBoxData.maxLeft = Math.min(containerData.width, canvasData.left + canvasData.width) - cropBoxData.width;
          cropBoxData.maxTop = Math.min(containerData.height, canvasData.top + canvasData.height) - cropBoxData.height;
        } else {
          cropBoxData.minLeft = 0;
          cropBoxData.minTop = 0;
          cropBoxData.maxLeft = containerData.width - cropBoxData.width;
          cropBoxData.maxTop = containerData.height - cropBoxData.height;
        }
      }
    },
    renderCropBox: function renderCropBox() {
      var options = this.options,
          containerData = this.containerData,
          cropBoxData = this.cropBoxData;

      if (cropBoxData.width > cropBoxData.maxWidth || cropBoxData.width < cropBoxData.minWidth) {
        cropBoxData.left = cropBoxData.oldLeft;
      }

      if (cropBoxData.height > cropBoxData.maxHeight || cropBoxData.height < cropBoxData.minHeight) {
        cropBoxData.top = cropBoxData.oldTop;
      }

      cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
      cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
      this.limitCropBox(false, true);
      cropBoxData.left = Math.min(Math.max(cropBoxData.left, cropBoxData.minLeft), cropBoxData.maxLeft);
      cropBoxData.top = Math.min(Math.max(cropBoxData.top, cropBoxData.minTop), cropBoxData.maxTop);
      cropBoxData.oldLeft = cropBoxData.left;
      cropBoxData.oldTop = cropBoxData.top;

      if (options.movable && options.cropBoxMovable) {
        // Turn to move the canvas when the crop box is equal to the container
        setData(this.face, DATA_ACTION, cropBoxData.width >= containerData.width && cropBoxData.height >= containerData.height ? ACTION_MOVE : ACTION_ALL);
      }

      setStyle(this.cropBox, assign({
        width: cropBoxData.width,
        height: cropBoxData.height
      }, getTransforms({
        translateX: cropBoxData.left,
        translateY: cropBoxData.top
      })));

      if (this.cropped && this.limited) {
        this.limitCanvas(true, true);
      }

      if (!this.disabled) {
        this.output();
      }
    },
    output: function output() {
      this.preview();
      dispatchEvent(this.element, EVENT_CROP, this.getData());
    }
  };

  var preview = {
    initPreview: function initPreview() {
      var element = this.element,
          crossOrigin = this.crossOrigin;
      var preview = this.options.preview;
      var url = crossOrigin ? this.crossOriginUrl : this.url;
      var alt = element.alt || 'The image to preview';
      var image = document.createElement('img');

      if (crossOrigin) {
        image.crossOrigin = crossOrigin;
      }

      image.src = url;
      image.alt = alt;
      this.viewBox.appendChild(image);
      this.viewBoxImage = image;

      if (!preview) {
        return;
      }

      var previews = preview;

      if (typeof preview === 'string') {
        previews = element.ownerDocument.querySelectorAll(preview);
      } else if (preview.querySelector) {
        previews = [preview];
      }

      this.previews = previews;
      forEach(previews, function (el) {
        var img = document.createElement('img'); // Save the original size for recover

        setData(el, DATA_PREVIEW, {
          width: el.offsetWidth,
          height: el.offsetHeight,
          html: el.innerHTML
        });

        if (crossOrigin) {
          img.crossOrigin = crossOrigin;
        }

        img.src = url;
        img.alt = alt;
        /**
         * Override img element styles
         * Add `display:block` to avoid margin top issue
         * Add `height:auto` to override `height` attribute on IE8
         * (Occur only when margin-top <= -height)
         */

        img.style.cssText = 'display:block;' + 'width:100%;' + 'height:auto;' + 'min-width:0!important;' + 'min-height:0!important;' + 'max-width:none!important;' + 'max-height:none!important;' + 'image-orientation:0deg!important;"';
        el.innerHTML = '';
        el.appendChild(img);
      });
    },
    resetPreview: function resetPreview() {
      forEach(this.previews, function (element) {
        var data = getData(element, DATA_PREVIEW);
        setStyle(element, {
          width: data.width,
          height: data.height
        });
        element.innerHTML = data.html;
        removeData(element, DATA_PREVIEW);
      });
    },
    preview: function preview() {
      var imageData = this.imageData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData;
      var cropBoxWidth = cropBoxData.width,
          cropBoxHeight = cropBoxData.height;
      var width = imageData.width,
          height = imageData.height;
      var left = cropBoxData.left - canvasData.left - imageData.left;
      var top = cropBoxData.top - canvasData.top - imageData.top;

      if (!this.cropped || this.disabled) {
        return;
      }

      setStyle(this.viewBoxImage, assign({
        width: width,
        height: height
      }, getTransforms(assign({
        translateX: -left,
        translateY: -top
      }, imageData))));
      forEach(this.previews, function (element) {
        var data = getData(element, DATA_PREVIEW);
        var originalWidth = data.width;
        var originalHeight = data.height;
        var newWidth = originalWidth;
        var newHeight = originalHeight;
        var ratio = 1;

        if (cropBoxWidth) {
          ratio = originalWidth / cropBoxWidth;
          newHeight = cropBoxHeight * ratio;
        }

        if (cropBoxHeight && newHeight > originalHeight) {
          ratio = originalHeight / cropBoxHeight;
          newWidth = cropBoxWidth * ratio;
          newHeight = originalHeight;
        }

        setStyle(element, {
          width: newWidth,
          height: newHeight
        });
        setStyle(element.getElementsByTagName('img')[0], assign({
          width: width * ratio,
          height: height * ratio
        }, getTransforms(assign({
          translateX: -left * ratio,
          translateY: -top * ratio
        }, imageData))));
      });
    }
  };

  var events = {
    bind: function bind() {
      var element = this.element,
          options = this.options,
          cropper = this.cropper;

      if (isFunction(options.cropstart)) {
        addListener(element, EVENT_CROP_START, options.cropstart);
      }

      if (isFunction(options.cropmove)) {
        addListener(element, EVENT_CROP_MOVE, options.cropmove);
      }

      if (isFunction(options.cropend)) {
        addListener(element, EVENT_CROP_END, options.cropend);
      }

      if (isFunction(options.crop)) {
        addListener(element, EVENT_CROP, options.crop);
      }

      if (isFunction(options.zoom)) {
        addListener(element, EVENT_ZOOM, options.zoom);
      }

      addListener(cropper, EVENT_POINTER_DOWN, this.onCropStart = this.cropStart.bind(this));

      if (options.zoomable && options.zoomOnWheel) {
        addListener(cropper, EVENT_WHEEL, this.onWheel = this.wheel.bind(this), {
          passive: false,
          capture: true
        });
      }

      if (options.toggleDragModeOnDblclick) {
        addListener(cropper, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
      }

      addListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove = this.cropMove.bind(this));
      addListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd = this.cropEnd.bind(this));

      if (options.responsive) {
        addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
      }
    },
    unbind: function unbind() {
      var element = this.element,
          options = this.options,
          cropper = this.cropper;

      if (isFunction(options.cropstart)) {
        removeListener(element, EVENT_CROP_START, options.cropstart);
      }

      if (isFunction(options.cropmove)) {
        removeListener(element, EVENT_CROP_MOVE, options.cropmove);
      }

      if (isFunction(options.cropend)) {
        removeListener(element, EVENT_CROP_END, options.cropend);
      }

      if (isFunction(options.crop)) {
        removeListener(element, EVENT_CROP, options.crop);
      }

      if (isFunction(options.zoom)) {
        removeListener(element, EVENT_ZOOM, options.zoom);
      }

      removeListener(cropper, EVENT_POINTER_DOWN, this.onCropStart);

      if (options.zoomable && options.zoomOnWheel) {
        removeListener(cropper, EVENT_WHEEL, this.onWheel, {
          passive: false,
          capture: true
        });
      }

      if (options.toggleDragModeOnDblclick) {
        removeListener(cropper, EVENT_DBLCLICK, this.onDblclick);
      }

      removeListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove);
      removeListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd);

      if (options.responsive) {
        removeListener(window, EVENT_RESIZE, this.onResize);
      }
    }
  };

  var handlers = {
    resize: function resize() {
      if (this.disabled) {
        return;
      }

      var options = this.options,
          container = this.container,
          containerData = this.containerData;
      var ratioX = container.offsetWidth / containerData.width;
      var ratioY = container.offsetHeight / containerData.height;
      var ratio = Math.abs(ratioX - 1) > Math.abs(ratioY - 1) ? ratioX : ratioY; // Resize when width changed or height changed

      if (ratio !== 1) {
        var canvasData;
        var cropBoxData;

        if (options.restore) {
          canvasData = this.getCanvasData();
          cropBoxData = this.getCropBoxData();
        }

        this.render();

        if (options.restore) {
          this.setCanvasData(forEach(canvasData, function (n, i) {
            canvasData[i] = n * ratio;
          }));
          this.setCropBoxData(forEach(cropBoxData, function (n, i) {
            cropBoxData[i] = n * ratio;
          }));
        }
      }
    },
    dblclick: function dblclick() {
      if (this.disabled || this.options.dragMode === DRAG_MODE_NONE) {
        return;
      }

      this.setDragMode(hasClass(this.dragBox, CLASS_CROP) ? DRAG_MODE_MOVE : DRAG_MODE_CROP);
    },
    wheel: function wheel(event) {
      var _this = this;

      var ratio = Number(this.options.wheelZoomRatio) || 0.1;
      var delta = 1;

      if (this.disabled) {
        return;
      }

      event.preventDefault(); // Limit wheel speed to prevent zoom too fast (#21)

      if (this.wheeling) {
        return;
      }

      this.wheeling = true;
      setTimeout(function () {
        _this.wheeling = false;
      }, 50);

      if (event.deltaY) {
        delta = event.deltaY > 0 ? 1 : -1;
      } else if (event.wheelDelta) {
        delta = -event.wheelDelta / 120;
      } else if (event.detail) {
        delta = event.detail > 0 ? 1 : -1;
      }

      this.zoom(-delta * ratio, event);
    },
    cropStart: function cropStart(event) {
      var buttons = event.buttons,
          button = event.button;

      if (this.disabled // Handle mouse event and pointer event and ignore touch event
      || (event.type === 'mousedown' || event.type === 'pointerdown' && event.pointerType === 'mouse') && ( // No primary button (Usually the left button)
      isNumber(buttons) && buttons !== 1 || isNumber(button) && button !== 0 // Open context menu
      || event.ctrlKey)) {
        return;
      }

      var options = this.options,
          pointers = this.pointers;
      var action;

      if (event.changedTouches) {
        // Handle touch event
        forEach(event.changedTouches, function (touch) {
          pointers[touch.identifier] = getPointer(touch);
        });
      } else {
        // Handle mouse event and pointer event
        pointers[event.pointerId || 0] = getPointer(event);
      }

      if (Object.keys(pointers).length > 1 && options.zoomable && options.zoomOnTouch) {
        action = ACTION_ZOOM;
      } else {
        action = getData(event.target, DATA_ACTION);
      }

      if (!REGEXP_ACTIONS.test(action)) {
        return;
      }

      if (dispatchEvent(this.element, EVENT_CROP_START, {
        originalEvent: event,
        action: action
      }) === false) {
        return;
      } // This line is required for preventing page zooming in iOS browsers


      event.preventDefault();
      this.action = action;
      this.cropping = false;

      if (action === ACTION_CROP) {
        this.cropping = true;
        addClass(this.dragBox, CLASS_MODAL);
      }
    },
    cropMove: function cropMove(event) {
      var action = this.action;

      if (this.disabled || !action) {
        return;
      }

      var pointers = this.pointers;
      event.preventDefault();

      if (dispatchEvent(this.element, EVENT_CROP_MOVE, {
        originalEvent: event,
        action: action
      }) === false) {
        return;
      }

      if (event.changedTouches) {
        forEach(event.changedTouches, function (touch) {
          // The first parameter should not be undefined (#432)
          assign(pointers[touch.identifier] || {}, getPointer(touch, true));
        });
      } else {
        assign(pointers[event.pointerId || 0] || {}, getPointer(event, true));
      }

      this.change(event);
    },
    cropEnd: function cropEnd(event) {
      if (this.disabled) {
        return;
      }

      var action = this.action,
          pointers = this.pointers;

      if (event.changedTouches) {
        forEach(event.changedTouches, function (touch) {
          delete pointers[touch.identifier];
        });
      } else {
        delete pointers[event.pointerId || 0];
      }

      if (!action) {
        return;
      }

      event.preventDefault();

      if (!Object.keys(pointers).length) {
        this.action = '';
      }

      if (this.cropping) {
        this.cropping = false;
        toggleClass(this.dragBox, CLASS_MODAL, this.cropped && this.options.modal);
      }

      dispatchEvent(this.element, EVENT_CROP_END, {
        originalEvent: event,
        action: action
      });
    }
  };

  var change = {
    change: function change(event) {
      var options = this.options,
          canvasData = this.canvasData,
          containerData = this.containerData,
          cropBoxData = this.cropBoxData,
          pointers = this.pointers;
      var action = this.action;
      var aspectRatio = options.aspectRatio;
      var left = cropBoxData.left,
          top = cropBoxData.top,
          width = cropBoxData.width,
          height = cropBoxData.height;
      var right = left + width;
      var bottom = top + height;
      var minLeft = 0;
      var minTop = 0;
      var maxWidth = containerData.width;
      var maxHeight = containerData.height;
      var renderable = true;
      var offset; // Locking aspect ratio in "free mode" by holding shift key

      if (!aspectRatio && event.shiftKey) {
        aspectRatio = width && height ? width / height : 1;
      }

      if (this.limited) {
        minLeft = cropBoxData.minLeft;
        minTop = cropBoxData.minTop;
        maxWidth = minLeft + Math.min(containerData.width, canvasData.width, canvasData.left + canvasData.width);
        maxHeight = minTop + Math.min(containerData.height, canvasData.height, canvasData.top + canvasData.height);
      }

      var pointer = pointers[Object.keys(pointers)[0]];
      var range = {
        x: pointer.endX - pointer.startX,
        y: pointer.endY - pointer.startY
      };

      var check = function check(side) {
        switch (side) {
          case ACTION_EAST:
            if (right + range.x > maxWidth) {
              range.x = maxWidth - right;
            }

            break;

          case ACTION_WEST:
            if (left + range.x < minLeft) {
              range.x = minLeft - left;
            }

            break;

          case ACTION_NORTH:
            if (top + range.y < minTop) {
              range.y = minTop - top;
            }

            break;

          case ACTION_SOUTH:
            if (bottom + range.y > maxHeight) {
              range.y = maxHeight - bottom;
            }

            break;
        }
      };

      switch (action) {
        // Move crop box
        case ACTION_ALL:
          left += range.x;
          top += range.y;
          break;
        // Resize crop box

        case ACTION_EAST:
          if (range.x >= 0 && (right >= maxWidth || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
            renderable = false;
            break;
          }

          check(ACTION_EAST);
          width += range.x;

          if (width < 0) {
            action = ACTION_WEST;
            width = -width;
            left -= width;
          }

          if (aspectRatio) {
            height = width / aspectRatio;
            top += (cropBoxData.height - height) / 2;
          }

          break;

        case ACTION_NORTH:
          if (range.y <= 0 && (top <= minTop || aspectRatio && (left <= minLeft || right >= maxWidth))) {
            renderable = false;
            break;
          }

          check(ACTION_NORTH);
          height -= range.y;
          top += range.y;

          if (height < 0) {
            action = ACTION_SOUTH;
            height = -height;
            top -= height;
          }

          if (aspectRatio) {
            width = height * aspectRatio;
            left += (cropBoxData.width - width) / 2;
          }

          break;

        case ACTION_WEST:
          if (range.x <= 0 && (left <= minLeft || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
            renderable = false;
            break;
          }

          check(ACTION_WEST);
          width -= range.x;
          left += range.x;

          if (width < 0) {
            action = ACTION_EAST;
            width = -width;
            left -= width;
          }

          if (aspectRatio) {
            height = width / aspectRatio;
            top += (cropBoxData.height - height) / 2;
          }

          break;

        case ACTION_SOUTH:
          if (range.y >= 0 && (bottom >= maxHeight || aspectRatio && (left <= minLeft || right >= maxWidth))) {
            renderable = false;
            break;
          }

          check(ACTION_SOUTH);
          height += range.y;

          if (height < 0) {
            action = ACTION_NORTH;
            height = -height;
            top -= height;
          }

          if (aspectRatio) {
            width = height * aspectRatio;
            left += (cropBoxData.width - width) / 2;
          }

          break;

        case ACTION_NORTH_EAST:
          if (aspectRatio) {
            if (range.y <= 0 && (top <= minTop || right >= maxWidth)) {
              renderable = false;
              break;
            }

            check(ACTION_NORTH);
            height -= range.y;
            top += range.y;
            width = height * aspectRatio;
          } else {
            check(ACTION_NORTH);
            check(ACTION_EAST);

            if (range.x >= 0) {
              if (right < maxWidth) {
                width += range.x;
              } else if (range.y <= 0 && top <= minTop) {
                renderable = false;
              }
            } else {
              width += range.x;
            }

            if (range.y <= 0) {
              if (top > minTop) {
                height -= range.y;
                top += range.y;
              }
            } else {
              height -= range.y;
              top += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_SOUTH_WEST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_NORTH_WEST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_SOUTH_EAST;
            height = -height;
            top -= height;
          }

          break;

        case ACTION_NORTH_WEST:
          if (aspectRatio) {
            if (range.y <= 0 && (top <= minTop || left <= minLeft)) {
              renderable = false;
              break;
            }

            check(ACTION_NORTH);
            height -= range.y;
            top += range.y;
            width = height * aspectRatio;
            left += cropBoxData.width - width;
          } else {
            check(ACTION_NORTH);
            check(ACTION_WEST);

            if (range.x <= 0) {
              if (left > minLeft) {
                width -= range.x;
                left += range.x;
              } else if (range.y <= 0 && top <= minTop) {
                renderable = false;
              }
            } else {
              width -= range.x;
              left += range.x;
            }

            if (range.y <= 0) {
              if (top > minTop) {
                height -= range.y;
                top += range.y;
              }
            } else {
              height -= range.y;
              top += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_SOUTH_EAST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_NORTH_EAST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_SOUTH_WEST;
            height = -height;
            top -= height;
          }

          break;

        case ACTION_SOUTH_WEST:
          if (aspectRatio) {
            if (range.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
              renderable = false;
              break;
            }

            check(ACTION_WEST);
            width -= range.x;
            left += range.x;
            height = width / aspectRatio;
          } else {
            check(ACTION_SOUTH);
            check(ACTION_WEST);

            if (range.x <= 0) {
              if (left > minLeft) {
                width -= range.x;
                left += range.x;
              } else if (range.y >= 0 && bottom >= maxHeight) {
                renderable = false;
              }
            } else {
              width -= range.x;
              left += range.x;
            }

            if (range.y >= 0) {
              if (bottom < maxHeight) {
                height += range.y;
              }
            } else {
              height += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_NORTH_EAST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_SOUTH_EAST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_NORTH_WEST;
            height = -height;
            top -= height;
          }

          break;

        case ACTION_SOUTH_EAST:
          if (aspectRatio) {
            if (range.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
              renderable = false;
              break;
            }

            check(ACTION_EAST);
            width += range.x;
            height = width / aspectRatio;
          } else {
            check(ACTION_SOUTH);
            check(ACTION_EAST);

            if (range.x >= 0) {
              if (right < maxWidth) {
                width += range.x;
              } else if (range.y >= 0 && bottom >= maxHeight) {
                renderable = false;
              }
            } else {
              width += range.x;
            }

            if (range.y >= 0) {
              if (bottom < maxHeight) {
                height += range.y;
              }
            } else {
              height += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_NORTH_WEST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_SOUTH_WEST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_NORTH_EAST;
            height = -height;
            top -= height;
          }

          break;
        // Move canvas

        case ACTION_MOVE:
          this.move(range.x, range.y);
          renderable = false;
          break;
        // Zoom canvas

        case ACTION_ZOOM:
          this.zoom(getMaxZoomRatio(pointers), event);
          renderable = false;
          break;
        // Create crop box

        case ACTION_CROP:
          if (!range.x || !range.y) {
            renderable = false;
            break;
          }

          offset = getOffset(this.cropper);
          left = pointer.startX - offset.left;
          top = pointer.startY - offset.top;
          width = cropBoxData.minWidth;
          height = cropBoxData.minHeight;

          if (range.x > 0) {
            action = range.y > 0 ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST;
          } else if (range.x < 0) {
            left -= width;
            action = range.y > 0 ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST;
          }

          if (range.y < 0) {
            top -= height;
          } // Show the crop box if is hidden


          if (!this.cropped) {
            removeClass(this.cropBox, CLASS_HIDDEN);
            this.cropped = true;

            if (this.limited) {
              this.limitCropBox(true, true);
            }
          }

          break;
      }

      if (renderable) {
        cropBoxData.width = width;
        cropBoxData.height = height;
        cropBoxData.left = left;
        cropBoxData.top = top;
        this.action = action;
        this.renderCropBox();
      } // Override


      forEach(pointers, function (p) {
        p.startX = p.endX;
        p.startY = p.endY;
      });
    }
  };

  var methods = {
    // Show the crop box manually
    crop: function crop() {
      if (this.ready && !this.cropped && !this.disabled) {
        this.cropped = true;
        this.limitCropBox(true, true);

        if (this.options.modal) {
          addClass(this.dragBox, CLASS_MODAL);
        }

        removeClass(this.cropBox, CLASS_HIDDEN);
        this.setCropBoxData(this.initialCropBoxData);
      }

      return this;
    },
    // Reset the image and crop box to their initial states
    reset: function reset() {
      if (this.ready && !this.disabled) {
        this.imageData = assign({}, this.initialImageData);
        this.canvasData = assign({}, this.initialCanvasData);
        this.cropBoxData = assign({}, this.initialCropBoxData);
        this.renderCanvas();

        if (this.cropped) {
          this.renderCropBox();
        }
      }

      return this;
    },
    // Clear the crop box
    clear: function clear() {
      if (this.cropped && !this.disabled) {
        assign(this.cropBoxData, {
          left: 0,
          top: 0,
          width: 0,
          height: 0
        });
        this.cropped = false;
        this.renderCropBox();
        this.limitCanvas(true, true); // Render canvas after crop box rendered

        this.renderCanvas();
        removeClass(this.dragBox, CLASS_MODAL);
        addClass(this.cropBox, CLASS_HIDDEN);
      }

      return this;
    },

    /**
     * Replace the image's src and rebuild the cropper
     * @param {string} url - The new URL.
     * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
     * @returns {Cropper} this
     */
    replace: function replace(url) {
      var hasSameSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!this.disabled && url) {
        if (this.isImg) {
          this.element.src = url;
        }

        if (hasSameSize) {
          this.url = url;
          this.image.src = url;

          if (this.ready) {
            this.viewBoxImage.src = url;
            forEach(this.previews, function (element) {
              element.getElementsByTagName('img')[0].src = url;
            });
          }
        } else {
          if (this.isImg) {
            this.replaced = true;
          }

          this.options.data = null;
          this.uncreate();
          this.load(url);
        }
      }

      return this;
    },
    // Enable (unfreeze) the cropper
    enable: function enable() {
      if (this.ready && this.disabled) {
        this.disabled = false;
        removeClass(this.cropper, CLASS_DISABLED);
      }

      return this;
    },
    // Disable (freeze) the cropper
    disable: function disable() {
      if (this.ready && !this.disabled) {
        this.disabled = true;
        addClass(this.cropper, CLASS_DISABLED);
      }

      return this;
    },

    /**
     * Destroy the cropper and remove the instance from the image
     * @returns {Cropper} this
     */
    destroy: function destroy() {
      var element = this.element;

      if (!element[NAMESPACE]) {
        return this;
      }

      element[NAMESPACE] = undefined;

      if (this.isImg && this.replaced) {
        element.src = this.originalUrl;
      }

      this.uncreate();
      return this;
    },

    /**
     * Move the canvas with relative offsets
     * @param {number} offsetX - The relative offset distance on the x-axis.
     * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
     * @returns {Cropper} this
     */
    move: function move(offsetX) {
      var offsetY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : offsetX;
      var _this$canvasData = this.canvasData,
          left = _this$canvasData.left,
          top = _this$canvasData.top;
      return this.moveTo(isUndefined(offsetX) ? offsetX : left + Number(offsetX), isUndefined(offsetY) ? offsetY : top + Number(offsetY));
    },

    /**
     * Move the canvas to an absolute point
     * @param {number} x - The x-axis coordinate.
     * @param {number} [y=x] - The y-axis coordinate.
     * @returns {Cropper} this
     */
    moveTo: function moveTo(x) {
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
      var canvasData = this.canvasData;
      var changed = false;
      x = Number(x);
      y = Number(y);

      if (this.ready && !this.disabled && this.options.movable) {
        if (isNumber(x)) {
          canvasData.left = x;
          changed = true;
        }

        if (isNumber(y)) {
          canvasData.top = y;
          changed = true;
        }

        if (changed) {
          this.renderCanvas(true);
        }
      }

      return this;
    },

    /**
     * Zoom the canvas with a relative ratio
     * @param {number} ratio - The target ratio.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */
    zoom: function zoom(ratio, _originalEvent) {
      var canvasData = this.canvasData;
      ratio = Number(ratio);

      if (ratio < 0) {
        ratio = 1 / (1 - ratio);
      } else {
        ratio = 1 + ratio;
      }

      return this.zoomTo(canvasData.width * ratio / canvasData.naturalWidth, null, _originalEvent);
    },

    /**
     * Zoom the canvas to an absolute ratio
     * @param {number} ratio - The target ratio.
     * @param {Object} pivot - The zoom pivot point coordinate.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */
    zoomTo: function zoomTo(ratio, pivot, _originalEvent) {
      var options = this.options,
          canvasData = this.canvasData;
      var width = canvasData.width,
          height = canvasData.height,
          naturalWidth = canvasData.naturalWidth,
          naturalHeight = canvasData.naturalHeight;
      ratio = Number(ratio);

      if (ratio >= 0 && this.ready && !this.disabled && options.zoomable) {
        var newWidth = naturalWidth * ratio;
        var newHeight = naturalHeight * ratio;

        if (dispatchEvent(this.element, EVENT_ZOOM, {
          ratio: ratio,
          oldRatio: width / naturalWidth,
          originalEvent: _originalEvent
        }) === false) {
          return this;
        }

        if (_originalEvent) {
          var pointers = this.pointers;
          var offset = getOffset(this.cropper);
          var center = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
            pageX: _originalEvent.pageX,
            pageY: _originalEvent.pageY
          }; // Zoom from the triggering point of the event

          canvasData.left -= (newWidth - width) * ((center.pageX - offset.left - canvasData.left) / width);
          canvasData.top -= (newHeight - height) * ((center.pageY - offset.top - canvasData.top) / height);
        } else if (isPlainObject(pivot) && isNumber(pivot.x) && isNumber(pivot.y)) {
          canvasData.left -= (newWidth - width) * ((pivot.x - canvasData.left) / width);
          canvasData.top -= (newHeight - height) * ((pivot.y - canvasData.top) / height);
        } else {
          // Zoom from the center of the canvas
          canvasData.left -= (newWidth - width) / 2;
          canvasData.top -= (newHeight - height) / 2;
        }

        canvasData.width = newWidth;
        canvasData.height = newHeight;
        this.renderCanvas(true);
      }

      return this;
    },

    /**
     * Rotate the canvas with a relative degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */
    rotate: function rotate(degree) {
      return this.rotateTo((this.imageData.rotate || 0) + Number(degree));
    },

    /**
     * Rotate the canvas to an absolute degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */
    rotateTo: function rotateTo(degree) {
      degree = Number(degree);

      if (isNumber(degree) && this.ready && !this.disabled && this.options.rotatable) {
        this.imageData.rotate = degree % 360;
        this.renderCanvas(true, true);
      }

      return this;
    },

    /**
     * Scale the image on the x-axis.
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @returns {Cropper} this
     */
    scaleX: function scaleX(_scaleX) {
      var scaleY = this.imageData.scaleY;
      return this.scale(_scaleX, isNumber(scaleY) ? scaleY : 1);
    },

    /**
     * Scale the image on the y-axis.
     * @param {number} scaleY - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */
    scaleY: function scaleY(_scaleY) {
      var scaleX = this.imageData.scaleX;
      return this.scale(isNumber(scaleX) ? scaleX : 1, _scaleY);
    },

    /**
     * Scale the image
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */
    scale: function scale(scaleX) {
      var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;
      var imageData = this.imageData;
      var transformed = false;
      scaleX = Number(scaleX);
      scaleY = Number(scaleY);

      if (this.ready && !this.disabled && this.options.scalable) {
        if (isNumber(scaleX)) {
          imageData.scaleX = scaleX;
          transformed = true;
        }

        if (isNumber(scaleY)) {
          imageData.scaleY = scaleY;
          transformed = true;
        }

        if (transformed) {
          this.renderCanvas(true, true);
        }
      }

      return this;
    },

    /**
     * Get the cropped area position and size data (base on the original image)
     * @param {boolean} [rounded=false] - Indicate if round the data values or not.
     * @returns {Object} The result cropped data.
     */
    getData: function getData() {
      var rounded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var options = this.options,
          imageData = this.imageData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData;
      var data;

      if (this.ready && this.cropped) {
        data = {
          x: cropBoxData.left - canvasData.left,
          y: cropBoxData.top - canvasData.top,
          width: cropBoxData.width,
          height: cropBoxData.height
        };
        var ratio = imageData.width / imageData.naturalWidth;
        forEach(data, function (n, i) {
          data[i] = n / ratio;
        });

        if (rounded) {
          // In case rounding off leads to extra 1px in right or bottom border
          // we should round the top-left corner and the dimension (#343).
          var bottom = Math.round(data.y + data.height);
          var right = Math.round(data.x + data.width);
          data.x = Math.round(data.x);
          data.y = Math.round(data.y);
          data.width = right - data.x;
          data.height = bottom - data.y;
        }
      } else {
        data = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }

      if (options.rotatable) {
        data.rotate = imageData.rotate || 0;
      }

      if (options.scalable) {
        data.scaleX = imageData.scaleX || 1;
        data.scaleY = imageData.scaleY || 1;
      }

      return data;
    },

    /**
     * Set the cropped area position and size with new data
     * @param {Object} data - The new data.
     * @returns {Cropper} this
     */
    setData: function setData(data) {
      var options = this.options,
          imageData = this.imageData,
          canvasData = this.canvasData;
      var cropBoxData = {};

      if (this.ready && !this.disabled && isPlainObject(data)) {
        var transformed = false;

        if (options.rotatable) {
          if (isNumber(data.rotate) && data.rotate !== imageData.rotate) {
            imageData.rotate = data.rotate;
            transformed = true;
          }
        }

        if (options.scalable) {
          if (isNumber(data.scaleX) && data.scaleX !== imageData.scaleX) {
            imageData.scaleX = data.scaleX;
            transformed = true;
          }

          if (isNumber(data.scaleY) && data.scaleY !== imageData.scaleY) {
            imageData.scaleY = data.scaleY;
            transformed = true;
          }
        }

        if (transformed) {
          this.renderCanvas(true, true);
        }

        var ratio = imageData.width / imageData.naturalWidth;

        if (isNumber(data.x)) {
          cropBoxData.left = data.x * ratio + canvasData.left;
        }

        if (isNumber(data.y)) {
          cropBoxData.top = data.y * ratio + canvasData.top;
        }

        if (isNumber(data.width)) {
          cropBoxData.width = data.width * ratio;
        }

        if (isNumber(data.height)) {
          cropBoxData.height = data.height * ratio;
        }

        this.setCropBoxData(cropBoxData);
      }

      return this;
    },

    /**
     * Get the container size data.
     * @returns {Object} The result container data.
     */
    getContainerData: function getContainerData() {
      return this.ready ? assign({}, this.containerData) : {};
    },

    /**
     * Get the image position and size data.
     * @returns {Object} The result image data.
     */
    getImageData: function getImageData() {
      return this.sized ? assign({}, this.imageData) : {};
    },

    /**
     * Get the canvas position and size data.
     * @returns {Object} The result canvas data.
     */
    getCanvasData: function getCanvasData() {
      var canvasData = this.canvasData;
      var data = {};

      if (this.ready) {
        forEach(['left', 'top', 'width', 'height', 'naturalWidth', 'naturalHeight'], function (n) {
          data[n] = canvasData[n];
        });
      }

      return data;
    },

    /**
     * Set the canvas position and size with new data.
     * @param {Object} data - The new canvas data.
     * @returns {Cropper} this
     */
    setCanvasData: function setCanvasData(data) {
      var canvasData = this.canvasData;
      var aspectRatio = canvasData.aspectRatio;

      if (this.ready && !this.disabled && isPlainObject(data)) {
        if (isNumber(data.left)) {
          canvasData.left = data.left;
        }

        if (isNumber(data.top)) {
          canvasData.top = data.top;
        }

        if (isNumber(data.width)) {
          canvasData.width = data.width;
          canvasData.height = data.width / aspectRatio;
        } else if (isNumber(data.height)) {
          canvasData.height = data.height;
          canvasData.width = data.height * aspectRatio;
        }

        this.renderCanvas(true);
      }

      return this;
    },

    /**
     * Get the crop box position and size data.
     * @returns {Object} The result crop box data.
     */
    getCropBoxData: function getCropBoxData() {
      var cropBoxData = this.cropBoxData;
      var data;

      if (this.ready && this.cropped) {
        data = {
          left: cropBoxData.left,
          top: cropBoxData.top,
          width: cropBoxData.width,
          height: cropBoxData.height
        };
      }

      return data || {};
    },

    /**
     * Set the crop box position and size with new data.
     * @param {Object} data - The new crop box data.
     * @returns {Cropper} this
     */
    setCropBoxData: function setCropBoxData(data) {
      var cropBoxData = this.cropBoxData;
      var aspectRatio = this.options.aspectRatio;
      var widthChanged;
      var heightChanged;

      if (this.ready && this.cropped && !this.disabled && isPlainObject(data)) {
        if (isNumber(data.left)) {
          cropBoxData.left = data.left;
        }

        if (isNumber(data.top)) {
          cropBoxData.top = data.top;
        }

        if (isNumber(data.width) && data.width !== cropBoxData.width) {
          widthChanged = true;
          cropBoxData.width = data.width;
        }

        if (isNumber(data.height) && data.height !== cropBoxData.height) {
          heightChanged = true;
          cropBoxData.height = data.height;
        }

        if (aspectRatio) {
          if (widthChanged) {
            cropBoxData.height = cropBoxData.width / aspectRatio;
          } else if (heightChanged) {
            cropBoxData.width = cropBoxData.height * aspectRatio;
          }
        }

        this.renderCropBox();
      }

      return this;
    },

    /**
     * Get a canvas drawn the cropped image.
     * @param {Object} [options={}] - The config options.
     * @returns {HTMLCanvasElement} - The result canvas.
     */
    getCroppedCanvas: function getCroppedCanvas() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!this.ready || !window.HTMLCanvasElement) {
        return null;
      }

      var canvasData = this.canvasData;
      var source = getSourceCanvas(this.image, this.imageData, canvasData, options); // Returns the source canvas if it is not cropped.

      if (!this.cropped) {
        return source;
      }

      var _this$getData = this.getData(),
          initialX = _this$getData.x,
          initialY = _this$getData.y,
          initialWidth = _this$getData.width,
          initialHeight = _this$getData.height;

      var ratio = source.width / Math.floor(canvasData.naturalWidth);

      if (ratio !== 1) {
        initialX *= ratio;
        initialY *= ratio;
        initialWidth *= ratio;
        initialHeight *= ratio;
      }

      var aspectRatio = initialWidth / initialHeight;
      var maxSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: options.maxWidth || Infinity,
        height: options.maxHeight || Infinity
      });
      var minSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: options.minWidth || 0,
        height: options.minHeight || 0
      }, 'cover');

      var _getAdjustedSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: options.width || (ratio !== 1 ? source.width : initialWidth),
        height: options.height || (ratio !== 1 ? source.height : initialHeight)
      }),
          width = _getAdjustedSizes.width,
          height = _getAdjustedSizes.height;

      width = Math.min(maxSizes.width, Math.max(minSizes.width, width));
      height = Math.min(maxSizes.height, Math.max(minSizes.height, height));
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = normalizeDecimalNumber(width);
      canvas.height = normalizeDecimalNumber(height);
      context.fillStyle = options.fillColor || 'transparent';
      context.fillRect(0, 0, width, height);
      var _options$imageSmoothi = options.imageSmoothingEnabled,
          imageSmoothingEnabled = _options$imageSmoothi === void 0 ? true : _options$imageSmoothi,
          imageSmoothingQuality = options.imageSmoothingQuality;
      context.imageSmoothingEnabled = imageSmoothingEnabled;

      if (imageSmoothingQuality) {
        context.imageSmoothingQuality = imageSmoothingQuality;
      } // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D.drawImage


      var sourceWidth = source.width;
      var sourceHeight = source.height; // Source canvas parameters

      var srcX = initialX;
      var srcY = initialY;
      var srcWidth;
      var srcHeight; // Destination canvas parameters

      var dstX;
      var dstY;
      var dstWidth;
      var dstHeight;

      if (srcX <= -initialWidth || srcX > sourceWidth) {
        srcX = 0;
        srcWidth = 0;
        dstX = 0;
        dstWidth = 0;
      } else if (srcX <= 0) {
        dstX = -srcX;
        srcX = 0;
        srcWidth = Math.min(sourceWidth, initialWidth + srcX);
        dstWidth = srcWidth;
      } else if (srcX <= sourceWidth) {
        dstX = 0;
        srcWidth = Math.min(initialWidth, sourceWidth - srcX);
        dstWidth = srcWidth;
      }

      if (srcWidth <= 0 || srcY <= -initialHeight || srcY > sourceHeight) {
        srcY = 0;
        srcHeight = 0;
        dstY = 0;
        dstHeight = 0;
      } else if (srcY <= 0) {
        dstY = -srcY;
        srcY = 0;
        srcHeight = Math.min(sourceHeight, initialHeight + srcY);
        dstHeight = srcHeight;
      } else if (srcY <= sourceHeight) {
        dstY = 0;
        srcHeight = Math.min(initialHeight, sourceHeight - srcY);
        dstHeight = srcHeight;
      }

      var params = [srcX, srcY, srcWidth, srcHeight]; // Avoid "IndexSizeError"

      if (dstWidth > 0 && dstHeight > 0) {
        var scale = width / initialWidth;
        params.push(dstX * scale, dstY * scale, dstWidth * scale, dstHeight * scale);
      } // All the numerical parameters should be integer for `drawImage`
      // https://github.com/fengyuanchen/cropper/issues/476


      context.drawImage.apply(context, [source].concat(_toConsumableArray(params.map(function (param) {
        return Math.floor(normalizeDecimalNumber(param));
      }))));
      return canvas;
    },

    /**
     * Change the aspect ratio of the crop box.
     * @param {number} aspectRatio - The new aspect ratio.
     * @returns {Cropper} this
     */
    setAspectRatio: function setAspectRatio(aspectRatio) {
      var options = this.options;

      if (!this.disabled && !isUndefined(aspectRatio)) {
        // 0 -> NaN
        options.aspectRatio = Math.max(0, aspectRatio) || NaN;

        if (this.ready) {
          this.initCropBox();

          if (this.cropped) {
            this.renderCropBox();
          }
        }
      }

      return this;
    },

    /**
     * Change the drag mode.
     * @param {string} mode - The new drag mode.
     * @returns {Cropper} this
     */
    setDragMode: function setDragMode(mode) {
      var options = this.options,
          dragBox = this.dragBox,
          face = this.face;

      if (this.ready && !this.disabled) {
        var croppable = mode === DRAG_MODE_CROP;
        var movable = options.movable && mode === DRAG_MODE_MOVE;
        mode = croppable || movable ? mode : DRAG_MODE_NONE;
        options.dragMode = mode;
        setData(dragBox, DATA_ACTION, mode);
        toggleClass(dragBox, CLASS_CROP, croppable);
        toggleClass(dragBox, CLASS_MOVE, movable);

        if (!options.cropBoxMovable) {
          // Sync drag mode to crop box when it is not movable
          setData(face, DATA_ACTION, mode);
          toggleClass(face, CLASS_CROP, croppable);
          toggleClass(face, CLASS_MOVE, movable);
        }
      }

      return this;
    }
  };

  var AnotherCropper = WINDOW.Cropper;

  var Cropper = /*#__PURE__*/function () {
    /**
     * Create a new Cropper.
     * @param {Element} element - The target element for cropping.
     * @param {Object} [options={}] - The configuration options.
     */
    function Cropper(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, Cropper);

      if (!element || !REGEXP_TAG_NAME.test(element.tagName)) {
        throw new Error('The first argument is required and must be an <img> or <canvas> element.');
      }

      this.element = element;
      this.options = assign({}, DEFAULTS, isPlainObject(options) && options);
      this.cropped = false;
      this.disabled = false;
      this.pointers = {};
      this.ready = false;
      this.reloading = false;
      this.replaced = false;
      this.sized = false;
      this.sizing = false;
      this.init();
    }

    _createClass(Cropper, [{
      key: "init",
      value: function init() {
        var element = this.element;
        var tagName = element.tagName.toLowerCase();
        var url;

        if (element[NAMESPACE]) {
          return;
        }

        element[NAMESPACE] = this;

        if (tagName === 'img') {
          this.isImg = true; // e.g.: "img/picture.jpg"

          url = element.getAttribute('src') || '';
          this.originalUrl = url; // Stop when it's a blank image

          if (!url) {
            return;
          } // e.g.: "https://example.com/img/picture.jpg"


          url = element.src;
        } else if (tagName === 'canvas' && window.HTMLCanvasElement) {
          url = element.toDataURL();
        }

        this.load(url);
      }
    }, {
      key: "load",
      value: function load(url) {
        var _this = this;

        if (!url) {
          return;
        }

        this.url = url;
        this.imageData = {};
        var element = this.element,
            options = this.options;

        if (!options.rotatable && !options.scalable) {
          options.checkOrientation = false;
        } // Only IE10+ supports Typed Arrays


        if (!options.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        } // Detect the mime type of the image directly if it is a Data URL


        if (REGEXP_DATA_URL.test(url)) {
          // Read ArrayBuffer from Data URL of JPEG images directly for better performance
          if (REGEXP_DATA_URL_JPEG.test(url)) {
            this.read(dataURLToArrayBuffer(url));
          } else {
            // Only a JPEG image may contains Exif Orientation information,
            // the rest types of Data URLs are not necessary to check orientation at all.
            this.clone();
          }

          return;
        } // 1. Detect the mime type of the image by a XMLHttpRequest.
        // 2. Load the image as ArrayBuffer for reading orientation if its a JPEG image.


        var xhr = new XMLHttpRequest();
        var clone = this.clone.bind(this);
        this.reloading = true;
        this.xhr = xhr; // 1. Cross origin requests are only supported for protocol schemes:
        // http, https, data, chrome, chrome-extension.
        // 2. Access to XMLHttpRequest from a Data URL will be blocked by CORS policy
        // in some browsers as IE11 and Safari.

        xhr.onabort = clone;
        xhr.onerror = clone;
        xhr.ontimeout = clone;

        xhr.onprogress = function () {
          // Abort the request directly if it not a JPEG image for better performance
          if (xhr.getResponseHeader('content-type') !== MIME_TYPE_JPEG) {
            xhr.abort();
          }
        };

        xhr.onload = function () {
          _this.read(xhr.response);
        };

        xhr.onloadend = function () {
          _this.reloading = false;
          _this.xhr = null;
        }; // Bust cache when there is a "crossOrigin" property to avoid browser cache error


        if (options.checkCrossOrigin && isCrossOriginURL(url) && element.crossOrigin) {
          url = addTimestamp(url);
        } // The third parameter is required for avoiding side-effect (#682)


        xhr.open('GET', url, true);
        xhr.responseType = 'arraybuffer';
        xhr.withCredentials = element.crossOrigin === 'use-credentials';
        xhr.send();
      }
    }, {
      key: "read",
      value: function read(arrayBuffer) {
        var options = this.options,
            imageData = this.imageData; // Reset the orientation value to its default value 1
        // as some iOS browsers will render image with its orientation

        var orientation = resetAndGetOrientation(arrayBuffer);
        var rotate = 0;
        var scaleX = 1;
        var scaleY = 1;

        if (orientation > 1) {
          // Generate a new URL which has the default orientation value
          this.url = arrayBufferToDataURL(arrayBuffer, MIME_TYPE_JPEG);

          var _parseOrientation = parseOrientation(orientation);

          rotate = _parseOrientation.rotate;
          scaleX = _parseOrientation.scaleX;
          scaleY = _parseOrientation.scaleY;
        }

        if (options.rotatable) {
          imageData.rotate = rotate;
        }

        if (options.scalable) {
          imageData.scaleX = scaleX;
          imageData.scaleY = scaleY;
        }

        this.clone();
      }
    }, {
      key: "clone",
      value: function clone() {
        var element = this.element,
            url = this.url;
        var crossOrigin = element.crossOrigin;
        var crossOriginUrl = url;

        if (this.options.checkCrossOrigin && isCrossOriginURL(url)) {
          if (!crossOrigin) {
            crossOrigin = 'anonymous';
          } // Bust cache when there is not a "crossOrigin" property (#519)


          crossOriginUrl = addTimestamp(url);
        }

        this.crossOrigin = crossOrigin;
        this.crossOriginUrl = crossOriginUrl;
        var image = document.createElement('img');

        if (crossOrigin) {
          image.crossOrigin = crossOrigin;
        }

        image.src = crossOriginUrl || url;
        image.alt = element.alt || 'The image to crop';
        this.image = image;
        image.onload = this.start.bind(this);
        image.onerror = this.stop.bind(this);
        addClass(image, CLASS_HIDE);
        element.parentNode.insertBefore(image, element.nextSibling);
      }
    }, {
      key: "start",
      value: function start() {
        var _this2 = this;

        var image = this.image;
        image.onload = null;
        image.onerror = null;
        this.sizing = true; // Match all browsers that use WebKit as the layout engine in iOS devices,
        // such as Safari for iOS, Chrome for iOS, and in-app browsers.

        var isIOSWebKit = WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent);

        var done = function done(naturalWidth, naturalHeight) {
          assign(_this2.imageData, {
            naturalWidth: naturalWidth,
            naturalHeight: naturalHeight,
            aspectRatio: naturalWidth / naturalHeight
          });
          _this2.initialImageData = assign({}, _this2.imageData);
          _this2.sizing = false;
          _this2.sized = true;

          _this2.build();
        }; // Most modern browsers (excepts iOS WebKit)


        if (image.naturalWidth && !isIOSWebKit) {
          done(image.naturalWidth, image.naturalHeight);
          return;
        }

        var sizingImage = document.createElement('img');
        var body = document.body || document.documentElement;
        this.sizingImage = sizingImage;

        sizingImage.onload = function () {
          done(sizingImage.width, sizingImage.height);

          if (!isIOSWebKit) {
            body.removeChild(sizingImage);
          }
        };

        sizingImage.src = image.src; // iOS WebKit will convert the image automatically
        // with its orientation once append it into DOM (#279)

        if (!isIOSWebKit) {
          sizingImage.style.cssText = 'left:0;' + 'max-height:none!important;' + 'max-width:none!important;' + 'min-height:0!important;' + 'min-width:0!important;' + 'opacity:0;' + 'position:absolute;' + 'top:0;' + 'z-index:-1;';
          body.appendChild(sizingImage);
        }
      }
    }, {
      key: "stop",
      value: function stop() {
        var image = this.image;
        image.onload = null;
        image.onerror = null;
        image.parentNode.removeChild(image);
        this.image = null;
      }
    }, {
      key: "build",
      value: function build() {
        if (!this.sized || this.ready) {
          return;
        }

        var element = this.element,
            options = this.options,
            image = this.image; // Create cropper elements

        var container = element.parentNode;
        var template = document.createElement('div');
        template.innerHTML = TEMPLATE;
        var cropper = template.querySelector(".".concat(NAMESPACE, "-container"));
        var canvas = cropper.querySelector(".".concat(NAMESPACE, "-canvas"));
        var dragBox = cropper.querySelector(".".concat(NAMESPACE, "-drag-box"));
        var cropBox = cropper.querySelector(".".concat(NAMESPACE, "-crop-box"));
        var face = cropBox.querySelector(".".concat(NAMESPACE, "-face"));
        this.container = container;
        this.cropper = cropper;
        this.canvas = canvas;
        this.dragBox = dragBox;
        this.cropBox = cropBox;
        this.viewBox = cropper.querySelector(".".concat(NAMESPACE, "-view-box"));
        this.face = face;
        canvas.appendChild(image); // Hide the original image

        addClass(element, CLASS_HIDDEN); // Inserts the cropper after to the current image

        container.insertBefore(cropper, element.nextSibling); // Show the image if is hidden

        if (!this.isImg) {
          removeClass(image, CLASS_HIDE);
        }

        this.initPreview();
        this.bind();
        options.initialAspectRatio = Math.max(0, options.initialAspectRatio) || NaN;
        options.aspectRatio = Math.max(0, options.aspectRatio) || NaN;
        options.viewMode = Math.max(0, Math.min(3, Math.round(options.viewMode))) || 0;
        addClass(cropBox, CLASS_HIDDEN);

        if (!options.guides) {
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-dashed")), CLASS_HIDDEN);
        }

        if (!options.center) {
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-center")), CLASS_HIDDEN);
        }

        if (options.background) {
          addClass(cropper, "".concat(NAMESPACE, "-bg"));
        }

        if (!options.highlight) {
          addClass(face, CLASS_INVISIBLE);
        }

        if (options.cropBoxMovable) {
          addClass(face, CLASS_MOVE);
          setData(face, DATA_ACTION, ACTION_ALL);
        }

        if (!options.cropBoxResizable) {
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-line")), CLASS_HIDDEN);
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-point")), CLASS_HIDDEN);
        }

        this.render();
        this.ready = true;
        this.setDragMode(options.dragMode);

        if (options.autoCrop) {
          this.crop();
        }

        this.setData(options.data);

        if (isFunction(options.ready)) {
          addListener(element, EVENT_READY, options.ready, {
            once: true
          });
        }

        dispatchEvent(element, EVENT_READY);
      }
    }, {
      key: "unbuild",
      value: function unbuild() {
        if (!this.ready) {
          return;
        }

        this.ready = false;
        this.unbind();
        this.resetPreview();
        this.cropper.parentNode.removeChild(this.cropper);
        removeClass(this.element, CLASS_HIDDEN);
      }
    }, {
      key: "uncreate",
      value: function uncreate() {
        if (this.ready) {
          this.unbuild();
          this.ready = false;
          this.cropped = false;
        } else if (this.sizing) {
          this.sizingImage.onload = null;
          this.sizing = false;
          this.sized = false;
        } else if (this.reloading) {
          this.xhr.onabort = null;
          this.xhr.abort();
        } else if (this.image) {
          this.stop();
        }
      }
      /**
       * Get the no conflict cropper class.
       * @returns {Cropper} The cropper class.
       */

    }], [{
      key: "noConflict",
      value: function noConflict() {
        window.Cropper = AnotherCropper;
        return Cropper;
      }
      /**
       * Change the default options.
       * @param {Object} options - The new default options.
       */

    }, {
      key: "setDefaults",
      value: function setDefaults(options) {
        assign(DEFAULTS, isPlainObject(options) && options);
      }
    }]);

    return Cropper;
  }();

  assign(Cropper.prototype, render, preview, events, handlers, change, methods);

  return Cropper;

})));


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1059);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("24204a86", content, true, {});

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "/*!\n * Cropper.js v1.5.12\n * https://fengyuanchen.github.io/cropperjs\n *\n * Copyright 2015-present Chen Fengyuan\n * Released under the MIT license\n *\n * Date: 2021-06-12T08:00:11.623Z\n */\n\n.cropper-container {\n  direction: ltr;\n  font-size: 0;\n  line-height: 0;\n  position: relative;\n  -ms-touch-action: none;\n  touch-action: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.cropper-container img {\n  display: block;\n  height: 100%;\n  image-orientation: 0deg;\n  max-height: none !important;\n  max-width: none !important;\n  min-height: 0 !important;\n  min-width: 0 !important;\n  width: 100%;\n}\n\n.cropper-wrap-box,\n.cropper-canvas,\n.cropper-drag-box,\n.cropper-crop-box,\n.cropper-modal {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.cropper-wrap-box,\n.cropper-canvas {\n  overflow: hidden;\n}\n\n.cropper-drag-box {\n  background-color: #fff;\n  opacity: 0;\n}\n\n.cropper-modal {\n  background-color: #000;\n  opacity: 0.5;\n}\n\n.cropper-view-box {\n  display: block;\n  height: 100%;\n  outline: 1px solid #39f;\n  outline-color: rgba(51, 153, 255, 0.75);\n  overflow: hidden;\n  width: 100%;\n}\n\n.cropper-dashed {\n  border: 0 dashed #eee;\n  display: block;\n  opacity: 0.5;\n  position: absolute;\n}\n\n.cropper-dashed.dashed-h {\n  border-bottom-width: 1px;\n  border-top-width: 1px;\n  height: calc(100% / 3);\n  left: 0;\n  top: calc(100% / 3);\n  width: 100%;\n}\n\n.cropper-dashed.dashed-v {\n  border-left-width: 1px;\n  border-right-width: 1px;\n  height: 100%;\n  left: calc(100% / 3);\n  top: 0;\n  width: calc(100% / 3);\n}\n\n.cropper-center {\n  display: block;\n  height: 0;\n  left: 50%;\n  opacity: 0.75;\n  position: absolute;\n  top: 50%;\n  width: 0;\n}\n\n.cropper-center::before,\n.cropper-center::after {\n  background-color: #eee;\n  content: ' ';\n  display: block;\n  position: absolute;\n}\n\n.cropper-center::before {\n  height: 1px;\n  left: -3px;\n  top: 0;\n  width: 7px;\n}\n\n.cropper-center::after {\n  height: 7px;\n  left: 0;\n  top: -3px;\n  width: 1px;\n}\n\n.cropper-face,\n.cropper-line,\n.cropper-point {\n  display: block;\n  height: 100%;\n  opacity: 0.1;\n  position: absolute;\n  width: 100%;\n}\n\n.cropper-face {\n  background-color: #fff;\n  left: 0;\n  top: 0;\n}\n\n.cropper-line {\n  background-color: #39f;\n}\n\n.cropper-line.line-e {\n  cursor: ew-resize;\n  right: -3px;\n  top: 0;\n  width: 5px;\n}\n\n.cropper-line.line-n {\n  cursor: ns-resize;\n  height: 5px;\n  left: 0;\n  top: -3px;\n}\n\n.cropper-line.line-w {\n  cursor: ew-resize;\n  left: -3px;\n  top: 0;\n  width: 5px;\n}\n\n.cropper-line.line-s {\n  bottom: -3px;\n  cursor: ns-resize;\n  height: 5px;\n  left: 0;\n}\n\n.cropper-point {\n  background-color: #39f;\n  height: 5px;\n  opacity: 0.75;\n  width: 5px;\n}\n\n.cropper-point.point-e {\n  cursor: ew-resize;\n  margin-top: -3px;\n  right: -3px;\n  top: 50%;\n}\n\n.cropper-point.point-n {\n  cursor: ns-resize;\n  left: 50%;\n  margin-left: -3px;\n  top: -3px;\n}\n\n.cropper-point.point-w {\n  cursor: ew-resize;\n  left: -3px;\n  margin-top: -3px;\n  top: 50%;\n}\n\n.cropper-point.point-s {\n  bottom: -3px;\n  cursor: s-resize;\n  left: 50%;\n  margin-left: -3px;\n}\n\n.cropper-point.point-ne {\n  cursor: nesw-resize;\n  right: -3px;\n  top: -3px;\n}\n\n.cropper-point.point-nw {\n  cursor: nwse-resize;\n  left: -3px;\n  top: -3px;\n}\n\n.cropper-point.point-sw {\n  bottom: -3px;\n  cursor: nesw-resize;\n  left: -3px;\n}\n\n.cropper-point.point-se {\n  bottom: -3px;\n  cursor: nwse-resize;\n  height: 20px;\n  opacity: 1;\n  right: -3px;\n  width: 20px;\n}\n\n@media (min-width: 768px) {\n  .cropper-point.point-se {\n    height: 15px;\n    width: 15px;\n  }\n}\n\n@media (min-width: 992px) {\n  .cropper-point.point-se {\n    height: 10px;\n    width: 10px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .cropper-point.point-se {\n    height: 5px;\n    opacity: 0.75;\n    width: 5px;\n  }\n}\n\n.cropper-point.point-se::before {\n  background-color: #39f;\n  bottom: -50%;\n  content: ' ';\n  display: block;\n  height: 200%;\n  opacity: 0;\n  position: absolute;\n  right: -50%;\n  width: 200%;\n}\n\n.cropper-invisible {\n  opacity: 0;\n}\n\n.cropper-bg {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');\n}\n\n.cropper-hide {\n  display: block;\n  height: 0;\n  position: absolute;\n  width: 0;\n}\n\n.cropper-hidden {\n  display: none !important;\n}\n\n.cropper-move {\n  cursor: move;\n}\n\n.cropper-crop {\n  cursor: crosshair;\n}\n\n.cropper-disabled .cropper-drag-box,\n.cropper-disabled .cropper-face,\n.cropper-disabled .cropper-line,\n.cropper-disabled .cropper-point {\n  cursor: not-allowed;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/node_modules/cropperjs/dist/cropper.css"],"names":[],"mappings":"AAAA;;;;;;;;GAQG;;AAEH;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;CACnB;;AAED;EACE,eAAe;EACf,aAAa;EACb,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,YAAY;CACb;;AAED;;;;;EAKE,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,SAAS;EACT,OAAO;CACR;;AAED;;EAEE,iBAAiB;CAClB;;AAED;EACE,uBAAuB;EACvB,WAAW;CACZ;;AAED;EACE,uBAAuB;EACvB,aAAa;CACd;;AAED;EACE,eAAe;EACf,aAAa;EACb,wBAAwB;EACxB,wCAAwC;EACxC,iBAAiB;EACjB,YAAY;CACb;;AAED;EACE,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,mBAAmB;CACpB;;AAED;EACE,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;EACpB,YAAY;CACb;;AAED;EACE,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,qBAAqB;EACrB,OAAO;EACP,sBAAsB;CACvB;;AAED;EACE,eAAe;EACf,UAAU;EACV,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,SAAS;CACV;;AAED;;EAEE,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,mBAAmB;CACpB;;AAED;EACE,YAAY;EACZ,WAAW;EACX,OAAO;EACP,WAAW;CACZ;;AAED;EACE,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,WAAW;CACZ;;AAED;;;EAGE,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,YAAY;CACb;;AAED;EACE,uBAAuB;EACvB,QAAQ;EACR,OAAO;CACR;;AAED;EACE,uBAAuB;CACxB;;AAED;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;CACZ;;AAED;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,UAAU;CACX;;AAED;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,WAAW;CACZ;;AAED;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,QAAQ;CACT;;AAED;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,WAAW;CACZ;;AAED;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,SAAS;CACV;;AAED;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,UAAU;CACX;;AAED;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,SAAS;CACV;;AAED;EACE,aAAa;EACb,iBAAiB;EACjB,UAAU;EACV,kBAAkB;CACnB;;AAED;EACE,oBAAoB;EACpB,YAAY;EACZ,UAAU;CACX;;AAED;EACE,oBAAoB;EACpB,WAAW;EACX,UAAU;CACX;;AAED;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;CACZ;;AAED;EACE,aAAa;EACb,oBAAoB;EACpB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,YAAY;CACb;;AAED;EACE;IACE,aAAa;IACb,YAAY;GACb;CACF;;AAED;EACE;IACE,aAAa;IACb,YAAY;GACb;CACF;;AAED;EACE;IACE,YAAY;IACZ,cAAc;IACd,WAAW;GACZ;CACF;;AAED;EACE,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,eAAe;EACf,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;CACb;;AAED;EACE,WAAW;CACZ;;AAED;EACE,gRAAgR;CACjR;;AAED;EACE,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,SAAS;CACV;;AAED;EACE,yBAAyB;CAC1B;;AAED;EACE,aAAa;CACd;;AAED;EACE,kBAAkB;CACnB;;AAED;;;;EAIE,oBAAoB;CACrB","file":"cropper.css","sourcesContent":["/*!\n * Cropper.js v1.5.12\n * https://fengyuanchen.github.io/cropperjs\n *\n * Copyright 2015-present Chen Fengyuan\n * Released under the MIT license\n *\n * Date: 2021-06-12T08:00:11.623Z\n */\n\n.cropper-container {\n  direction: ltr;\n  font-size: 0;\n  line-height: 0;\n  position: relative;\n  -ms-touch-action: none;\n  touch-action: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.cropper-container img {\n  display: block;\n  height: 100%;\n  image-orientation: 0deg;\n  max-height: none !important;\n  max-width: none !important;\n  min-height: 0 !important;\n  min-width: 0 !important;\n  width: 100%;\n}\n\n.cropper-wrap-box,\n.cropper-canvas,\n.cropper-drag-box,\n.cropper-crop-box,\n.cropper-modal {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.cropper-wrap-box,\n.cropper-canvas {\n  overflow: hidden;\n}\n\n.cropper-drag-box {\n  background-color: #fff;\n  opacity: 0;\n}\n\n.cropper-modal {\n  background-color: #000;\n  opacity: 0.5;\n}\n\n.cropper-view-box {\n  display: block;\n  height: 100%;\n  outline: 1px solid #39f;\n  outline-color: rgba(51, 153, 255, 0.75);\n  overflow: hidden;\n  width: 100%;\n}\n\n.cropper-dashed {\n  border: 0 dashed #eee;\n  display: block;\n  opacity: 0.5;\n  position: absolute;\n}\n\n.cropper-dashed.dashed-h {\n  border-bottom-width: 1px;\n  border-top-width: 1px;\n  height: calc(100% / 3);\n  left: 0;\n  top: calc(100% / 3);\n  width: 100%;\n}\n\n.cropper-dashed.dashed-v {\n  border-left-width: 1px;\n  border-right-width: 1px;\n  height: 100%;\n  left: calc(100% / 3);\n  top: 0;\n  width: calc(100% / 3);\n}\n\n.cropper-center {\n  display: block;\n  height: 0;\n  left: 50%;\n  opacity: 0.75;\n  position: absolute;\n  top: 50%;\n  width: 0;\n}\n\n.cropper-center::before,\n.cropper-center::after {\n  background-color: #eee;\n  content: ' ';\n  display: block;\n  position: absolute;\n}\n\n.cropper-center::before {\n  height: 1px;\n  left: -3px;\n  top: 0;\n  width: 7px;\n}\n\n.cropper-center::after {\n  height: 7px;\n  left: 0;\n  top: -3px;\n  width: 1px;\n}\n\n.cropper-face,\n.cropper-line,\n.cropper-point {\n  display: block;\n  height: 100%;\n  opacity: 0.1;\n  position: absolute;\n  width: 100%;\n}\n\n.cropper-face {\n  background-color: #fff;\n  left: 0;\n  top: 0;\n}\n\n.cropper-line {\n  background-color: #39f;\n}\n\n.cropper-line.line-e {\n  cursor: ew-resize;\n  right: -3px;\n  top: 0;\n  width: 5px;\n}\n\n.cropper-line.line-n {\n  cursor: ns-resize;\n  height: 5px;\n  left: 0;\n  top: -3px;\n}\n\n.cropper-line.line-w {\n  cursor: ew-resize;\n  left: -3px;\n  top: 0;\n  width: 5px;\n}\n\n.cropper-line.line-s {\n  bottom: -3px;\n  cursor: ns-resize;\n  height: 5px;\n  left: 0;\n}\n\n.cropper-point {\n  background-color: #39f;\n  height: 5px;\n  opacity: 0.75;\n  width: 5px;\n}\n\n.cropper-point.point-e {\n  cursor: ew-resize;\n  margin-top: -3px;\n  right: -3px;\n  top: 50%;\n}\n\n.cropper-point.point-n {\n  cursor: ns-resize;\n  left: 50%;\n  margin-left: -3px;\n  top: -3px;\n}\n\n.cropper-point.point-w {\n  cursor: ew-resize;\n  left: -3px;\n  margin-top: -3px;\n  top: 50%;\n}\n\n.cropper-point.point-s {\n  bottom: -3px;\n  cursor: s-resize;\n  left: 50%;\n  margin-left: -3px;\n}\n\n.cropper-point.point-ne {\n  cursor: nesw-resize;\n  right: -3px;\n  top: -3px;\n}\n\n.cropper-point.point-nw {\n  cursor: nwse-resize;\n  left: -3px;\n  top: -3px;\n}\n\n.cropper-point.point-sw {\n  bottom: -3px;\n  cursor: nesw-resize;\n  left: -3px;\n}\n\n.cropper-point.point-se {\n  bottom: -3px;\n  cursor: nwse-resize;\n  height: 20px;\n  opacity: 1;\n  right: -3px;\n  width: 20px;\n}\n\n@media (min-width: 768px) {\n  .cropper-point.point-se {\n    height: 15px;\n    width: 15px;\n  }\n}\n\n@media (min-width: 992px) {\n  .cropper-point.point-se {\n    height: 10px;\n    width: 10px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .cropper-point.point-se {\n    height: 5px;\n    opacity: 0.75;\n    width: 5px;\n  }\n}\n\n.cropper-point.point-se::before {\n  background-color: #39f;\n  bottom: -50%;\n  content: ' ';\n  display: block;\n  height: 200%;\n  opacity: 0;\n  position: absolute;\n  right: -50%;\n  width: 200%;\n}\n\n.cropper-invisible {\n  opacity: 0;\n}\n\n.cropper-bg {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');\n}\n\n.cropper-hide {\n  display: block;\n  height: 0;\n  position: absolute;\n  width: 0;\n}\n\n.cropper-hidden {\n  display: none !important;\n}\n\n.cropper-move {\n  cursor: move;\n}\n\n.cropper-crop {\n  cursor: crosshair;\n}\n\n.cropper-disabled .cropper-drag-box,\n.cropper-disabled .cropper-face,\n.cropper-disabled .cropper-line,\n.cropper-disabled .cropper-point {\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper"},[_c('input',{attrs:{"type":"file"},on:{"change":_vm.setSimpleImage}}),_vm._v(" "),_c('a',{staticClass:"button cta success",on:{"click":_vm.uploadSimple}},[_vm._v("UPLOAD")])]),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('div',{attrs:{"id":"app"}},[_c('h2',{staticStyle:{"margin":"0"}},[_vm._v("Vue CropperJS")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('input',{staticStyle:{"font-size":"1.2em","padding":"10px 0"},attrs:{"type":"file","name":"image","accept":"image/*"},on:{"change":_vm.setImage}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"max-width":"900px","display":"inline-block"}},[_c('vue-cropper',{ref:"cropper",attrs:{"guides":false,"cropBoxResizable":false,"drag-mode":"crop","zoom":_vm.cropImage,"view-mode":2,"checkOrientation":false,"min-container-width":500,"min-container-height":500,"background":true,"src":_vm.imgSrc,"alt":"Source Image","img-style":{ width: '500px', 'height': '500px' },"cropmove":_vm.cropImage}})],1),_vm._v(" "),_c('img',{staticStyle:{"max-width":"500px","max-height":"500px","border":"1px solid gray"},attrs:{"src":_vm.cropImg,"alt":"Cropped Image"}}),_vm._v(" "),_c('br')])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(385);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73294774_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1076);
function injectStyle (ssrContext) {
  __webpack_require__(1062)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73294774"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73294774_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1063);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("37e060e9", content, true, {});

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.heading[data-v-73294774] {\n  margin-left: 50px;\n  padding-left: 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.filter[data-v-73294774] {\n  border-bottom: 1px solid #bbb;\n  background: #fcfcfc;\n  margin-bottom: 10px;\n  border-radius: 2px;\n}\n.filter .row[data-v-73294774] {\n    max-width: 100%;\n}\n.field-label[data-v-73294774] {\n  font-size: 13px;\n  color: #999;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.search-box[data-v-73294774] {\n  display: inline-block;\n  padding: 20px 0 20px 15px;\n  position: relative;\n  width: 100%;\n}\n.search-box .error-msg[data-v-73294774] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: calc(100% - 15px);\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    margin-left: 15px;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: bottom center;\n            transform-origin: bottom center;\n}\n.search[data-v-73294774] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.search .search-input-box[data-v-73294774] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-73294774] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 5px 0 0 5px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-73294774] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-73294774] {\n      position: absolute;\n      top: 0;\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n      line-height: 46px;\n}\n.search button[data-v-73294774] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 5px 5px 0;\n    padding: 0 20px;\n}\n.status[data-v-73294774] {\n  display: inline-block;\n  padding: 20px 0 20px 15px;\n  width: 100%;\n}\n.status.last[data-v-73294774] {\n    padding-right: 10px;\n}\nselect[data-v-73294774] {\n  padding: 10px;\n  height: 46px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-73294774] {\n    background-color: #ebebe4;\n}\n.fix-footer[data-v-73294774] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 50px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-73294774] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-73294774] {\n    max-width: 100px;\n    height: 30px;\n    padding: 5px;\n}\n.fix-footer .per-page[data-v-73294774] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 10px 0;\n}\n.fix-footer .per-page span[data-v-73294774] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-73294774] {\n    text-align: center;\n    line-height: 30px;\n    padding: 10px 0;\n}\n.fix-footer .pagination[data-v-73294774] {\n    text-align: right;\n    padding: 10px 10px;\n}\n.fix-footer .pagination span[data-v-73294774] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-73294774] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-73294774] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-73294774] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-73294774] {\n        opacity: .4;\n        cursor: default;\n}\n.slide-left-enter-active[data-v-73294774], .slide-left-leave-active[data-v-73294774] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-left-enter[data-v-73294774], .slide-left-leave-to[data-v-73294774] {\n  -webkit-transform: translateX(30px);\n          transform: translateX(30px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.fix-footer .row[data-v-73294774] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.fix-footer .per-page[data-v-73294774] {\n    width: auto;\n}\n.fix-footer .per-page select[data-v-73294774] {\n      width: 55px;\n}\n.fix-footer .per-page span[data-v-73294774]:nth-child(3) {\n      display: none;\n}\n.fix-footer .page-data[data-v-73294774] {\n    display: none;\n}\n.fix-footer .pagination[data-v-73294774] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    width: 45%;\n}\n.fix-footer .pagination select[data-v-73294774] {\n      width: 55px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Admin/index.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;CAC3B;AACD;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;CACpB;AACD;IACI,gBAAgB;CACnB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;CACpB;AACD;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;CACb;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,wCAAwC;YAChC,gCAAgC;CAC3C;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;CACb;AACD;IACI,YAAY;IACZ,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,uBAAuB;MACvB,cAAc;MACd,2BAA2B;MAC3B,oBAAoB;CACzB;AACD;QACQ,sBAAsB;CAC7B;AACD;MACM,mBAAmB;MACnB,OAAO;MACP,WAAW;MACX,eAAe;MACf,gBAAgB;MAChB,kBAAkB;CACvB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;CACnB;AACD;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;CACb;AACD;IACI,oBAAoB;CACvB;AACD;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,+BAA+B;CAChC;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;CACb;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;IACjB,aAAa;IACb,aAAa;CAChB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;CACnB;AACD;MACM,sBAAsB;MACtB,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;CACnB;AACD;IACI,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,kBAAkB;CACvB;AACD;MACM,aAAa;MACb,uBAAuB;CAC5B;AACD;MACM,cAAc;MACd,eAAe;MACf,uBAAuB;MACvB,iBAAiB;MACjB,gBAAgB;MAChB,uBAAuB;MACvB,aAAa;CAClB;AACD;QACQ,kBAAkB;CACzB;AACD;QACQ,YAAY;QACZ,gBAAgB;CACvB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;AACA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;IACI,YAAY;CACf;AACD;MACM,YAAY;CACjB;AACD;MACM,cAAc;CACnB;AACD;IACI,cAAc;CACjB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;IAC5B,WAAW;CACd;AACD;MACM,YAAY;CACjB;CACA","file":"index.vue","sourcesContent":["\n.heading[data-v-73294774] {\n  margin-left: 50px;\n  padding-left: 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.filter[data-v-73294774] {\n  border-bottom: 1px solid #bbb;\n  background: #fcfcfc;\n  margin-bottom: 10px;\n  border-radius: 2px;\n}\n.filter .row[data-v-73294774] {\n    max-width: 100%;\n}\n.field-label[data-v-73294774] {\n  font-size: 13px;\n  color: #999;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.search-box[data-v-73294774] {\n  display: inline-block;\n  padding: 20px 0 20px 15px;\n  position: relative;\n  width: 100%;\n}\n.search-box .error-msg[data-v-73294774] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: calc(100% - 15px);\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    margin-left: 15px;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: bottom center;\n            transform-origin: bottom center;\n}\n.search[data-v-73294774] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.search .search-input-box[data-v-73294774] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-73294774] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 5px 0 0 5px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-73294774] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-73294774] {\n      position: absolute;\n      top: 0;\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n      line-height: 46px;\n}\n.search button[data-v-73294774] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 5px 5px 0;\n    padding: 0 20px;\n}\n.status[data-v-73294774] {\n  display: inline-block;\n  padding: 20px 0 20px 15px;\n  width: 100%;\n}\n.status.last[data-v-73294774] {\n    padding-right: 10px;\n}\nselect[data-v-73294774] {\n  padding: 10px;\n  height: 46px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-73294774] {\n    background-color: #ebebe4;\n}\n.fix-footer[data-v-73294774] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 50px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-73294774] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-73294774] {\n    max-width: 100px;\n    height: 30px;\n    padding: 5px;\n}\n.fix-footer .per-page[data-v-73294774] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 10px 0;\n}\n.fix-footer .per-page span[data-v-73294774] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-73294774] {\n    text-align: center;\n    line-height: 30px;\n    padding: 10px 0;\n}\n.fix-footer .pagination[data-v-73294774] {\n    text-align: right;\n    padding: 10px 10px;\n}\n.fix-footer .pagination span[data-v-73294774] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-73294774] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-73294774] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-73294774] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-73294774] {\n        opacity: .4;\n        cursor: default;\n}\n.slide-left-enter-active[data-v-73294774], .slide-left-leave-active[data-v-73294774] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-left-enter[data-v-73294774], .slide-left-leave-to[data-v-73294774] {\n  -webkit-transform: translateX(30px);\n          transform: translateX(30px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.fix-footer .row[data-v-73294774] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.fix-footer .per-page[data-v-73294774] {\n    width: auto;\n}\n.fix-footer .per-page select[data-v-73294774] {\n      width: 55px;\n}\n.fix-footer .per-page span[data-v-73294774]:nth-child(3) {\n      display: none;\n}\n.fix-footer .page-data[data-v-73294774] {\n    display: none;\n}\n.fix-footer .pagination[data-v-73294774] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    width: 45%;\n}\n.fix-footer .pagination select[data-v-73294774] {\n      width: 55px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filter_vue__ = __webpack_require__(386);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1869e632_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Filter_vue__ = __webpack_require__(1067);
function injectStyle (ssrContext) {
  __webpack_require__(1065)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1869e632"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1869e632_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1066);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("ec7fb95c", content, true, {});

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.filter[data-v-1869e632] {\n  border-bottom: 1px solid #bbb;\n  background: #fcfcfc;\n  margin-bottom: 10px;\n  border-radius: 2px;\n}\n.filter .row[data-v-1869e632] {\n    max-width: 100%;\n}\n.field-label[data-v-1869e632] {\n  font-size: 13px;\n  color: #999;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.search-box[data-v-1869e632] {\n  display: inline-block;\n  padding: 10px 0 10px 15px;\n  position: relative;\n  width: 100%;\n}\n.search-box .error-msg[data-v-1869e632] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: calc(100% - 15px);\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    margin-left: 15px;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: bottom center;\n            transform-origin: bottom center;\n}\n.search-box.right[data-v-1869e632] {\n    text-align: right;\n    padding-right: 15px;\n}\n.search-box.export[data-v-1869e632] {\n    padding-left: 0px;\n}\n.search[data-v-1869e632] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.search .search-input-box[data-v-1869e632] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-1869e632] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 5px 0 0 5px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-1869e632] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-1869e632] {\n      position: absolute;\n      top: 0;\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n      line-height: 46px;\n}\n.search button[data-v-1869e632] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 5px 5px 0;\n    padding: 0 20px;\n}\n.status[data-v-1869e632] {\n  display: inline-block;\n  padding: 10px 0 10px 15px;\n  width: 100%;\n}\n.status.last[data-v-1869e632] {\n    padding-right: 10px;\n}\nselect[data-v-1869e632] {\n  padding: 10px;\n  height: 46px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-1869e632] {\n    background-color: #ebebe4;\n}\n.add-btn[data-v-1869e632] {\n  margin-top: 10px;\n}\n.slide-left-enter-active[data-v-1869e632], .slide-left-leave-active[data-v-1869e632] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-left-enter[data-v-1869e632], .slide-left-leave-to[data-v-1869e632] {\n  -webkit-transform: translateX(30px);\n          transform: translateX(30px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.column[data-v-1869e632], .columns[data-v-1869e632] {\n    float: none;\n    width: 50%;\n}\n.row-left[data-v-1869e632],\n  .row-right[data-v-1869e632] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.small-offset-4[data-v-1869e632] {\n    margin-left: unset;\n}\n.add-btn[data-v-1869e632] {\n    margin-top: 0;\n    width: 100%;\n}\n.status[data-v-1869e632] {\n    padding: 10px;\n}\n.search-box.right[data-v-1869e632] {\n    padding-top: 0;\n}\n.filter .row[data-v-1869e632] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Admin/Filter.vue"],"names":[],"mappings":";AACA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;CACpB;AACD;IACI,gBAAgB;CACnB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;CACpB;AACD;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;CACb;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,wCAAwC;YAChC,gCAAgC;CAC3C;AACD;IACI,kBAAkB;IAClB,oBAAoB;CACvB;AACD;IACI,kBAAkB;CACrB;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;CACb;AACD;IACI,YAAY;IACZ,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,uBAAuB;MACvB,cAAc;MACd,2BAA2B;MAC3B,oBAAoB;CACzB;AACD;QACQ,sBAAsB;CAC7B;AACD;MACM,mBAAmB;MACnB,OAAO;MACP,WAAW;MACX,eAAe;MACf,gBAAgB;MAChB,kBAAkB;CACvB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;CACnB;AACD;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;CACb;AACD;IACI,oBAAoB;CACvB;AACD;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,+BAA+B;CAChC;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,iBAAiB;CAClB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;AACA;IACI,YAAY;IACZ,WAAW;CACd;AACD;;IAEI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,cAAc;IACd,YAAY;CACf;AACD;IACI,cAAc;CACjB;AACD;IACI,eAAe;CAClB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,6BAA6B;IAC7B,8BAA8B;QAC1B,2BAA2B;YACvB,uBAAuB;CAClC;CACA","file":"Filter.vue","sourcesContent":["\n.filter[data-v-1869e632] {\n  border-bottom: 1px solid #bbb;\n  background: #fcfcfc;\n  margin-bottom: 10px;\n  border-radius: 2px;\n}\n.filter .row[data-v-1869e632] {\n    max-width: 100%;\n}\n.field-label[data-v-1869e632] {\n  font-size: 13px;\n  color: #999;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.search-box[data-v-1869e632] {\n  display: inline-block;\n  padding: 10px 0 10px 15px;\n  position: relative;\n  width: 100%;\n}\n.search-box .error-msg[data-v-1869e632] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: calc(100% - 15px);\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    margin-left: 15px;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: bottom center;\n            transform-origin: bottom center;\n}\n.search-box.right[data-v-1869e632] {\n    text-align: right;\n    padding-right: 15px;\n}\n.search-box.export[data-v-1869e632] {\n    padding-left: 0px;\n}\n.search[data-v-1869e632] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.search .search-input-box[data-v-1869e632] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-1869e632] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 5px 0 0 5px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-1869e632] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-1869e632] {\n      position: absolute;\n      top: 0;\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n      line-height: 46px;\n}\n.search button[data-v-1869e632] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 5px 5px 0;\n    padding: 0 20px;\n}\n.status[data-v-1869e632] {\n  display: inline-block;\n  padding: 10px 0 10px 15px;\n  width: 100%;\n}\n.status.last[data-v-1869e632] {\n    padding-right: 10px;\n}\nselect[data-v-1869e632] {\n  padding: 10px;\n  height: 46px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-1869e632] {\n    background-color: #ebebe4;\n}\n.add-btn[data-v-1869e632] {\n  margin-top: 10px;\n}\n.slide-left-enter-active[data-v-1869e632], .slide-left-leave-active[data-v-1869e632] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-left-enter[data-v-1869e632], .slide-left-leave-to[data-v-1869e632] {\n  -webkit-transform: translateX(30px);\n          transform: translateX(30px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.column[data-v-1869e632], .columns[data-v-1869e632] {\n    float: none;\n    width: 50%;\n}\n.row-left[data-v-1869e632],\n  .row-right[data-v-1869e632] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.small-offset-4[data-v-1869e632] {\n    margin-left: unset;\n}\n.add-btn[data-v-1869e632] {\n    margin-top: 0;\n    width: 100%;\n}\n.status[data-v-1869e632] {\n    padding: 10px;\n}\n.search-box.right[data-v-1869e632] {\n    padding-top: 0;\n}\n.filter .row[data-v-1869e632] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"row-left"},[_c('div',{staticClass:"small-3 columns end"},[_c('div',{staticClass:"search-box"},[_c('label',{staticClass:"field-label"},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"search"},[_c('div',{staticClass:"search-input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],ref:"search",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.searchInput)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search.apply(null, arguments)},"blur":_vm.blurSearch,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-left"}},[(_vm.searchInput.length > 0)?_c('i',{staticClass:"far fa-times-circle fa-lg",on:{"click":_vm.clearSearch}}):_vm._e()])],1),_vm._v(" "),_c('button',{class:{'button xsmall success':true, 'disabled':_vm.loading},on:{"click":_vm.search}},[_c('i',{staticClass:"fas fa-search fa-lg"})])])])]),_vm._v(" "),_c('div',{staticClass:"small-2 columns end"},[_c('div',{staticClass:"status"},[_c('label',{staticClass:"field-label"},[_vm._v("Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v("All")]),_vm._v(" "),_c('option',{attrs:{"value":"active"}},[_vm._v("Active")]),_vm._v(" "),_c('option',{attrs:{"value":"deactivated"}},[_vm._v("Inactive")])])])])]),_vm._v(" "),_c('div',{staticClass:"row-right"},[_c('div',{staticClass:"small-2 columns small-offset-4"},[_c('div',{staticClass:"search-box right"},[_c('div',{class:{'button cta add-btn':true, 'disabled':_vm.loading},on:{"click":_vm.showForm}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "),_c('span',[_vm._v("Add Admin")])])])]),_vm._v(" "),_c('div',{staticClass:"small-1 columns"},[_c('div',{staticClass:"search-box right export"},[_c('div',{class:{'button cta success add-btn block':true, 'disabled':_vm.exportLoading},on:{"click":_vm.exportAdmin}},[(_vm.exportLoading)?_c('span',[_vm._v("Loading...")]):_c('span',[_vm._v("EXPORT")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminList_vue__ = __webpack_require__(387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a84d2aa4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminList_vue__ = __webpack_require__(1071);
function injectStyle (ssrContext) {
  __webpack_require__(1069)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a84d2aa4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a84d2aa4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1070);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("e75b3ce2", content, true, {});

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\ntable[data-v-a84d2aa4] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-bottom: 60px;\n}\ntable.table-loading[data-v-a84d2aa4] {\n    opacity: .7;\n}\ntable thead[data-v-a84d2aa4] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-a84d2aa4] {\n      padding: 5px;\n      border-right: 1px solid #ccc;\n}\ntable thead th[data-v-a84d2aa4]:last-child {\n        border-right: none;\n}\ntable thead .sortable[data-v-a84d2aa4] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-a84d2aa4] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-a84d2aa4] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr[data-v-a84d2aa4]:hover {\n      background: #e3e7e8 !important;\n}\ntable tbody tr[data-v-a84d2aa4]:nth-of-type(even) {\n      background: #fcfcfc;\n}\ntable tbody tr td[data-v-a84d2aa4] {\n      padding: 5px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n      border-right: 1px solid #ccc;\n}\ntable tbody tr td[data-v-a84d2aa4]:last-child {\n        border-right: none;\n}\ntable tbody tr td.table-block[data-v-a84d2aa4] {\n        position: relative;\n        overflow: hidden;\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-a84d2aa4] {\n          color: #ccc;\n}\ntable .email[data-v-a84d2aa4] {\n    max-width: 150px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\ntable .field[data-v-a84d2aa4] {\n    max-width: 50px;\n}\ntable .fa-check-square[data-v-a84d2aa4] {\n    color: #0fda4e;\n}\ntable .fa-square[data-v-a84d2aa4] {\n    color: #b5cebd;\n}\ntable a[data-v-a84d2aa4], table i[data-v-a84d2aa4] {\n    cursor: pointer;\n}\n.slider[data-v-a84d2aa4] {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 30px;\n  border-radius: 20px;\n  background: #ccc;\n  position: relative;\n  cursor: pointer;\n  -webkit-transition: all .25s ease-in-out;\n  transition: all .25s ease-in-out;\n}\n.slider.disabled[data-v-a84d2aa4] {\n    opacity: .4;\n}\n.slider[data-v-a84d2aa4]:before {\n    content: '';\n    position: absolute;\n    top: 2px;\n    left: 3px;\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    background: #fff;\n    -webkit-transition: all .25s ease-in-out;\n    transition: all .25s ease-in-out;\n    -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n}\n.slider.active[data-v-a84d2aa4] {\n    background: #57d1b7;\n}\n.slider.active[data-v-a84d2aa4]:before {\n      left: 32px;\n}\n.loader[data-v-a84d2aa4] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n}\n.loader div[data-v-a84d2aa4] {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    width: 100%;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n    text-align: center;\n}\n.sticky[data-v-a84d2aa4] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  height: 30px;\n  z-index: 3;\n}\n.op--modal-container[data-v-a84d2aa4] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-a84d2aa4] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-a84d2aa4] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-a84d2aa4] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.delete-box[data-v-a84d2aa4] {\n  width: 400px;\n  background: #fff;\n  margin: 0 auto;\n  padding: 20px;\n  border-radius: 3px;\n  text-align: center;\n  color: #444;\n  font-weight: 600;\n}\n.delete-box i[data-v-a84d2aa4] {\n    color: #36f18e;\n}\n.delete-box span[data-v-a84d2aa4] {\n    display: block;\n    margin: 15px 0 35px;\n}\n.delete-box .button[data-v-a84d2aa4] {\n    min-width: 100px;\n    margin: 0 5px;\n}\n.slide-up-enter-active[data-v-a84d2aa4], .slide-up-leave-active[data-v-a84d2aa4] {\n  -webkit-transition: all .4s ease;\n  transition: all .4s ease;\n}\n.slide-up-enter[data-v-a84d2aa4], .slide-up-leave-to[data-v-a84d2aa4] {\n  -webkit-transform: translateY(15px);\n          transform: translateY(15px);\n  opacity: 0;\n}\n.loading[data-v-a84d2aa4] {\n  text-align: center;\n  color: #aaa;\n}\n@media only screen and (max-width: 430px) {\n.card-holder[data-v-a84d2aa4] {\n    padding-bottom: 50px;\n}\n.cards .card[data-v-a84d2aa4] {\n    border: 1px solid #ccc;\n    margin: 0 25px;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n}\n.cards .card > div[data-v-a84d2aa4] {\n      margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-a84d2aa4] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .card-header .fas[data-v-a84d2aa4] {\n        color: #0D79F2;\n}\n.cards .card .title[data-v-a84d2aa4] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .label[data-v-a84d2aa4] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-a84d2aa4] {\n      margin-right: 10px;\n      font-size: 13px;\n      font-weight: 900;\n}\n.slider[data-v-a84d2aa4] {\n    width: 35px;\n    height: 17px;\n}\n.slider[data-v-a84d2aa4]::before {\n      width: 15px;\n      height: 15px;\n      top: 1px;\n}\n.slider.active[data-v-a84d2aa4]::before {\n      left: 18px;\n}\n.fix-footer .row[data-v-a84d2aa4] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.fix-footer .per-page[data-v-a84d2aa4] {\n    width: auto;\n}\n.fix-footer .per-page select[data-v-a84d2aa4] {\n      width: 55px;\n}\n.fix-footer .per-page span[data-v-a84d2aa4]:nth-child(3) {\n      display: none;\n}\n.fix-footer .page-data[data-v-a84d2aa4] {\n    display: none;\n}\n.fix-footer .pagination[data-v-a84d2aa4] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.fix-footer .pagination select[data-v-a84d2aa4] {\n      width: 55px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Admin/AdminList.vue"],"names":[],"mappings":";AACA;EACE,0BAA0B;EAC1B,YAAY;EACZ,oBAAoB;CACrB;AACD;IACI,YAAY;CACf;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;CAC7B;AACD;MACM,aAAa;MACb,6BAA6B;CAClC;AACD;QACQ,mBAAmB;CAC1B;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,2BAA2B;CAChC;AACD;QACQ,iBAAiB;CACxB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,+BAA+B;CACpC;AACD;MACM,oBAAoB;CACzB;AACD;MACM,aAAa;MACb,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;MACnB,6BAA6B;CAClC;AACD;QACQ,mBAAmB;CAC1B;AACD;QACQ,mBAAmB;QACnB,iBAAiB;QACjB,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;IACxB,oBAAoB;CACvB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,gBAAgB;CACnB;AACD;EACE,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,iCAAiC;CAClC;AACD;IACI,YAAY;CACf;AACD;IACI,YAAY;IACZ,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,yCAAyC;IACzC,iCAAiC;IACjC,oDAAoD;YAC5C,4CAA4C;CACvD;AACD;IACI,oBAAoB;CACvB;AACD;MACM,WAAW;CAChB;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;CACd;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,oCAAoC;YAC5B,4BAA4B;IACpC,mBAAmB;CACtB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,WAAW;CACZ;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;IACf,oBAAoB;CACvB;AACD;IACI,iBAAiB;IACjB,cAAc;CACjB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;EACE,mBAAmB;EACnB,YAAY;CACb;AACD;AACA;IACI,qBAAqB;CACxB;AACD;IACI,uBAAuB;IACvB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,oBAAoB;IACpB,+BAA+B;IAC/B,oBAAoB;CACvB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;QACQ,eAAe;CACtB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;MACM,gBAAgB;MAChB,0BAA0B;MAC1B,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;CACvB;AACD;MACM,mBAAmB;MACnB,gBAAgB;MAChB,iBAAiB;CACtB;AACD;IACI,YAAY;IACZ,aAAa;CAChB;AACD;MACM,YAAY;MACZ,aAAa;MACb,SAAS;CACd;AACD;MACM,WAAW;CAChB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;IACI,YAAY;CACf;AACD;MACM,YAAY;CACjB;AACD;MACM,cAAc;CACnB;AACD;IACI,cAAc;CACjB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;CAC/B;AACD;MACM,YAAY;CACjB;CACA","file":"AdminList.vue","sourcesContent":["\ntable[data-v-a84d2aa4] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-bottom: 60px;\n}\ntable.table-loading[data-v-a84d2aa4] {\n    opacity: .7;\n}\ntable thead[data-v-a84d2aa4] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-a84d2aa4] {\n      padding: 5px;\n      border-right: 1px solid #ccc;\n}\ntable thead th[data-v-a84d2aa4]:last-child {\n        border-right: none;\n}\ntable thead .sortable[data-v-a84d2aa4] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-a84d2aa4] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-a84d2aa4] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr[data-v-a84d2aa4]:hover {\n      background: #e3e7e8 !important;\n}\ntable tbody tr[data-v-a84d2aa4]:nth-of-type(even) {\n      background: #fcfcfc;\n}\ntable tbody tr td[data-v-a84d2aa4] {\n      padding: 5px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n      border-right: 1px solid #ccc;\n}\ntable tbody tr td[data-v-a84d2aa4]:last-child {\n        border-right: none;\n}\ntable tbody tr td.table-block[data-v-a84d2aa4] {\n        position: relative;\n        overflow: hidden;\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-a84d2aa4] {\n          color: #ccc;\n}\ntable .email[data-v-a84d2aa4] {\n    max-width: 150px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\ntable .field[data-v-a84d2aa4] {\n    max-width: 50px;\n}\ntable .fa-check-square[data-v-a84d2aa4] {\n    color: #0fda4e;\n}\ntable .fa-square[data-v-a84d2aa4] {\n    color: #b5cebd;\n}\ntable a[data-v-a84d2aa4], table i[data-v-a84d2aa4] {\n    cursor: pointer;\n}\n.slider[data-v-a84d2aa4] {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 30px;\n  border-radius: 20px;\n  background: #ccc;\n  position: relative;\n  cursor: pointer;\n  -webkit-transition: all .25s ease-in-out;\n  transition: all .25s ease-in-out;\n}\n.slider.disabled[data-v-a84d2aa4] {\n    opacity: .4;\n}\n.slider[data-v-a84d2aa4]:before {\n    content: '';\n    position: absolute;\n    top: 2px;\n    left: 3px;\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    background: #fff;\n    -webkit-transition: all .25s ease-in-out;\n    transition: all .25s ease-in-out;\n    -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n}\n.slider.active[data-v-a84d2aa4] {\n    background: #57d1b7;\n}\n.slider.active[data-v-a84d2aa4]:before {\n      left: 32px;\n}\n.loader[data-v-a84d2aa4] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n}\n.loader div[data-v-a84d2aa4] {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    width: 100%;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n    text-align: center;\n}\n.sticky[data-v-a84d2aa4] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  height: 30px;\n  z-index: 3;\n}\n.op--modal-container[data-v-a84d2aa4] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-a84d2aa4] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-a84d2aa4] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-a84d2aa4] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.delete-box[data-v-a84d2aa4] {\n  width: 400px;\n  background: #fff;\n  margin: 0 auto;\n  padding: 20px;\n  border-radius: 3px;\n  text-align: center;\n  color: #444;\n  font-weight: 600;\n}\n.delete-box i[data-v-a84d2aa4] {\n    color: #36f18e;\n}\n.delete-box span[data-v-a84d2aa4] {\n    display: block;\n    margin: 15px 0 35px;\n}\n.delete-box .button[data-v-a84d2aa4] {\n    min-width: 100px;\n    margin: 0 5px;\n}\n.slide-up-enter-active[data-v-a84d2aa4], .slide-up-leave-active[data-v-a84d2aa4] {\n  -webkit-transition: all .4s ease;\n  transition: all .4s ease;\n}\n.slide-up-enter[data-v-a84d2aa4], .slide-up-leave-to[data-v-a84d2aa4] {\n  -webkit-transform: translateY(15px);\n          transform: translateY(15px);\n  opacity: 0;\n}\n.loading[data-v-a84d2aa4] {\n  text-align: center;\n  color: #aaa;\n}\n@media only screen and (max-width: 430px) {\n.card-holder[data-v-a84d2aa4] {\n    padding-bottom: 50px;\n}\n.cards .card[data-v-a84d2aa4] {\n    border: 1px solid #ccc;\n    margin: 0 25px;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n}\n.cards .card > div[data-v-a84d2aa4] {\n      margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-a84d2aa4] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .card-header .fas[data-v-a84d2aa4] {\n        color: #0D79F2;\n}\n.cards .card .title[data-v-a84d2aa4] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .label[data-v-a84d2aa4] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-a84d2aa4] {\n      margin-right: 10px;\n      font-size: 13px;\n      font-weight: 900;\n}\n.slider[data-v-a84d2aa4] {\n    width: 35px;\n    height: 17px;\n}\n.slider[data-v-a84d2aa4]::before {\n      width: 15px;\n      height: 15px;\n      top: 1px;\n}\n.slider.active[data-v-a84d2aa4]::before {\n      left: 18px;\n}\n.fix-footer .row[data-v-a84d2aa4] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.fix-footer .per-page[data-v-a84d2aa4] {\n    width: auto;\n}\n.fix-footer .per-page select[data-v-a84d2aa4] {\n      width: 55px;\n}\n.fix-footer .per-page span[data-v-a84d2aa4]:nth-child(3) {\n      display: none;\n}\n.fix-footer .page-data[data-v-a84d2aa4] {\n    display: none;\n}\n.fix-footer .pagination[data-v-a84d2aa4] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.fix-footer .pagination select[data-v-a84d2aa4] {\n      width: 55px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.sticky)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile),expression:"!isMobile"}],staticClass:"sticky"},[_c('table',{class:{'table-loading':_vm.loading}},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.admins),function(admin){return (_vm.admins.length)?_c('tr',[_c('td',[_vm._v(_vm._s(admin.firstName + ' ' + admin.lastName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(admin.username))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(admin.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(admin.mobile))]),_vm._v(" "),_c('td',[_c('div',{class:{'slider':true, 'active':admin.isActive, 'disabled':false},on:{"click":function($event){return _vm.updateStatus(admin.id, admin.isActive)}}})]),_vm._v(" "),_c('td',[_c('button',{staticClass:"button cta xsmall",on:{"click":function($event){return _vm.edit(admin.id)}}},[_vm._v("EDIT")])])]):_vm._e()}),0)])]):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('table',{class:{'table-loading':_vm.loading}},[_vm._m(1),_vm._v(" "),_c('tbody',[_vm._l((_vm.admins),function(admin){return (_vm.admins.length)?_c('tr',[_c('td',[_vm._v(_vm._s(admin.firstName + ' ' + admin.lastName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(admin.username))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(admin.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(admin.mobile))]),_vm._v(" "),_c('td',[_c('div',{class:{'slider':true, 'active':admin.isActive, 'disabled':_vm.sliderLoader.indexOf(admin.id) > -1},on:{"click":function($event){return _vm.updateStatus(admin.id, admin.isActive)}}})]),_vm._v(" "),_c('td',[(admin.isActive)?_c('button',{staticClass:"button cta xsmall",on:{"click":function($event){return _vm.edit(admin.id)}}},[_vm._v("EDIT")]):_vm._e()])]):_vm._e()}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading && !_vm.admins.length),expression:"loading && !admins.length"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"27"}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('div',[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n                Loading...\n              ")])])])],1)]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && !_vm.admins.length),expression:"!loading && !admins.length"}]},[_vm._m(2)])],2)]):_c('div',[(_vm.loading && !_vm.admins.length)?_c('div',{staticClass:"loading"},[_vm._m(3)]):_c('div',{staticClass:"card-holder"},_vm._l((_vm.admins),function(admin,i){return _c('div',{key:i,staticClass:"cards"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{class:{'slider':true, 'active':admin.isActive, 'disabled':_vm.sliderLoader.indexOf(admin.id) > -1},on:{"click":function($event){return _vm.updateStatus(admin.id, admin.isActive)}}}),_vm._v(" "),(admin.isActive)?_c('div',{on:{"click":function($event){return _vm.edit(admin.id)}}},[_c('i',{staticClass:"fas fa-user-edit"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Name:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(admin.firstName + ' ' + admin.lastName))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Username:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(admin.username))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Email:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(admin.email))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Mobile:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(admin.mobile))])])])])}),0)]),_vm._v(" "),_c('div',{class:{'op--modal-container':true, 'hide':!_vm.showConfirm},on:{"click":function($event){return _vm.close(false)}}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content"},[_c('div',{staticClass:"delete-box",on:{"click":function($event){$event.stopPropagation();}}},[(_vm.deleteConfirm)?_c('div',[_c('span',[_vm._v("Are you sure you want to delete this admin?")]),_vm._v(" "),_c('div',{class:{'button cta warning':true, 'disabled':_vm.deleteLoading},on:{"click":function($event){return _vm.close(false)}}},[_vm._v("No")]),_vm._v(" "),_c('div',{class:{'button cta':true, 'disabled':_vm.deleteLoading},on:{"click":_vm.confirmDelete}},[_vm._v("Yes")])]):_c('div',[_c('transition',{attrs:{"name":"slide-up"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.showConfirm),expression:"showConfirm"}],staticClass:"far fa-check-circle fa-4x"})]),_vm._v(" "),_c('span',[_vm._v("Successfully deleted admin.")]),_vm._v(" "),_c('div',{staticClass:"button cta success",on:{"click":function($event){return _vm.close(true)}}},[_vm._v("Close")])],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Username")]),_vm._v(" "),_c('th',[_vm._v("Email")]),_vm._v(" "),_c('th',[_vm._v("Mobile")]),_vm._v(" "),_c('th',[_vm._v("Active")]),_vm._v(" "),_c('th')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Username")]),_vm._v(" "),_c('th',[_vm._v("Email")]),_vm._v(" "),_c('th',[_vm._v("Mobile")]),_vm._v(" "),_c('th',[_vm._v("Active")]),_vm._v(" "),_c('th')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"table-block",attrs:{"colspan":"27"}},[_c('i',{staticClass:"far fa-frown-open fa-3x"}),_vm._v(" "),_c('div',[_vm._v("No results")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" Loading...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminAdd_vue__ = __webpack_require__(388);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d4f355a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminAdd_vue__ = __webpack_require__(1075);
function injectStyle (ssrContext) {
  __webpack_require__(1073)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d4f355a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d4f355a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1074);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("270878f9", content, true, {});

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.op--modal-container[data-v-7d4f355a] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-7d4f355a] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-7d4f355a] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-7d4f355a] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.row-padding[data-v-7d4f355a] {\n  padding: 2px 30px;\n}\n.padding-L[data-v-7d4f355a] {\n  padding-left: 10px;\n}\n.padding-R[data-v-7d4f355a] {\n  padding-right: 10px;\n}\n.margin-B[data-v-7d4f355a] {\n  margin-bottom: 20px;\n}\n.form[data-v-7d4f355a] {\n  background: #fff;\n  width: 100%;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n.heading[data-v-7d4f355a] {\n  background: #333;\n  color: #fff;\n  font-weight: 600;\n  font-size: 21px;\n  padding: 10px 20px;\n  margin-bottom: 20px;\n}\n.data-field[data-v-7d4f355a] {\n  position: relative;\n  margin-bottom: 10px;\n}\n.data-field .label[data-v-7d4f355a] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 130%;\n    margin-bottom: 1px;\n}\n.data-field .label.has-error[data-v-7d4f355a] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-7d4f355a] {\n    margin: 1px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-7d4f355a] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-7d4f355a]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-7d4f355a] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.password-edit[data-v-7d4f355a] {\n  font-size: 12px;\n  color: #888;\n  line-height: 1;\n}\n.access[data-v-7d4f355a] {\n  padding: 20px 30px;\n}\n.access label[data-v-7d4f355a] {\n    display: block;\n    font-weight: 600;\n    color: #444;\n    padding-bottom: 3px;\n    font-size: 14px;\n    border-bottom: 1px solid #ddd;\n}\nul[data-v-7d4f355a] {\n  list-style: none;\n  padding: 0;\n  width: 100%;\n  text-align: left;\n  -webkit-column-count: 3;\n  /* Chrome, Safari, Opera */\n  -moz-column-count: 3;\n  /* Firefox */\n  column-count: 3;\n}\nul.one[data-v-7d4f355a] {\n    -webkit-column-count: 1;\n    /* Chrome, Safari, Opera */\n    -moz-column-count: 1;\n    /* Firefox */\n    column-count: 1;\n}\nul li[data-v-7d4f355a] {\n    display: block;\n    font-size: 14px;\n    padding: 4px 0;\n    cursor: pointer;\n    color: #555;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\nul li i[data-v-7d4f355a] {\n      margin-right: 5px;\n      color: #aaa;\n      font-size: 15px;\n}\nul li .fa-check-square[data-v-7d4f355a] {\n      color: #528cce;\n}\nul li .fa-square[data-v-7d4f355a] {\n      color: #b5cebd;\n}\nul li[data-v-7d4f355a]:hover, ul li:hover i[data-v-7d4f355a], ul li.checked i[data-v-7d4f355a] {\n      color: #528cce;\n}\nul li.disabled[data-v-7d4f355a] {\n      opacity: .4;\n      cursor: default;\n}\n.access.reports[data-v-7d4f355a] {\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin: 0 30px;\n  padding: 0;\n  background: #fffbd2;\n}\n.access.reports label[data-v-7d4f355a] {\n    padding: 10px 20px;\n    line-height: 1;\n}\n.access.reports ul[data-v-7d4f355a] {\n    padding: 0 20px;\n}\n.error[data-v-7d4f355a]:not(.button) {\n  padding: 5px;\n  margin: 0 30px 20px;\n  display: block;\n  font-size: 14px;\n  border: 1px solid #ff5b36;\n  color: #ff5b36;\n  font-style: italic;\n}\n.success-box[data-v-7d4f355a] {\n  width: 400px;\n  background: #fff;\n  margin: 0 auto;\n  padding: 20px;\n  border-radius: 3px;\n  text-align: center;\n  color: #444;\n  font-weight: 600;\n}\n.success-box i[data-v-7d4f355a] {\n    color: #36f18e;\n}\n.success-box span[data-v-7d4f355a] {\n    display: block;\n    margin: 15px 0 35px;\n}\n.success-box .button[data-v-7d4f355a] {\n    min-width: 100px;\n    margin: 0 5px;\n}\n.fixed-footer[data-v-7d4f355a] {\n  width: 100%;\n  background: #f3f3f3;\n  border-top: 1px solid #ccc;\n  padding: 6px 10px;\n  text-align: center;\n  margin-top: 30px;\n}\n.fixed-footer .button[data-v-7d4f355a] {\n    min-width: 120px;\n    margin: 0 5px;\n}\n.slide-up-enter-active[data-v-7d4f355a], .slide-up-leave-active[data-v-7d4f355a] {\n  -webkit-transition: all .4s ease;\n  transition: all .4s ease;\n}\n.slide-up-enter[data-v-7d4f355a], .slide-up-leave-to[data-v-7d4f355a] {\n  -webkit-transform: translateY(15px);\n          transform: translateY(15px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.row-padding[data-v-7d4f355a] {\n    padding: 2px 10px;\n}\n.mobile[data-v-7d4f355a] {\n    width: 100%;\n    padding: 0;\n}\n.access[data-v-7d4f355a] {\n    padding: 5px 10px;\n}\nul[data-v-7d4f355a] {\n    -webkit-column-count: 2;\n       -moz-column-count: 2;\n            column-count: 2;\n}\nul li[data-v-7d4f355a] {\n      font-size: 12px;\n}\nul li i[data-v-7d4f355a] {\n        margin-right: 0;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Admin/AdminAdd.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;CAChB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;CACrB;AACD;EACE,mBAAmB;EACnB,oBAAoB;CACrB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;CAChB;AACD;EACE,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,8BAA8B;CACjC;AACD;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,2BAA2B;EAC3B,qBAAqB;EACrB,aAAa;EACb,gBAAgB;CACjB;AACD;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,qBAAqB;IACrB,aAAa;IACb,gBAAgB;CACnB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,wBAAwB;IACxB,oBAAoB;CACvB;AACD;MACM,kBAAkB;MAClB,YAAY;MACZ,gBAAgB;CACrB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,oBAAoB;CACrB;AACD;IACI,mBAAmB;IACnB,eAAe;CAClB;AACD;IACI,gBAAgB;CACnB;AACD;EACE,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;CACpB;AACD;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;IACf,oBAAoB;CACvB;AACD;IACI,iBAAiB;IACjB,cAAc;CACjB;AACD;EACE,YAAY;EACZ,oBAAoB;EACpB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;CAClB;AACD;IACI,iBAAiB;IACjB,cAAc;CACjB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;AACA;IACI,kBAAkB;CACrB;AACD;IACI,YAAY;IACZ,WAAW;CACd;AACD;IACI,kBAAkB;CACrB;AACD;IACI,wBAAwB;OACrB,qBAAqB;YAChB,gBAAgB;CAC3B;AACD;MACM,gBAAgB;CACrB;AACD;QACQ,gBAAgB;CACvB;CACA","file":"AdminAdd.vue","sourcesContent":["\n.op--modal-container[data-v-7d4f355a] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-7d4f355a] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-7d4f355a] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-7d4f355a] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.row-padding[data-v-7d4f355a] {\n  padding: 2px 30px;\n}\n.padding-L[data-v-7d4f355a] {\n  padding-left: 10px;\n}\n.padding-R[data-v-7d4f355a] {\n  padding-right: 10px;\n}\n.margin-B[data-v-7d4f355a] {\n  margin-bottom: 20px;\n}\n.form[data-v-7d4f355a] {\n  background: #fff;\n  width: 100%;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n.heading[data-v-7d4f355a] {\n  background: #333;\n  color: #fff;\n  font-weight: 600;\n  font-size: 21px;\n  padding: 10px 20px;\n  margin-bottom: 20px;\n}\n.data-field[data-v-7d4f355a] {\n  position: relative;\n  margin-bottom: 10px;\n}\n.data-field .label[data-v-7d4f355a] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 130%;\n    margin-bottom: 1px;\n}\n.data-field .label.has-error[data-v-7d4f355a] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-7d4f355a] {\n    margin: 1px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-7d4f355a] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-7d4f355a]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-7d4f355a] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.password-edit[data-v-7d4f355a] {\n  font-size: 12px;\n  color: #888;\n  line-height: 1;\n}\n.access[data-v-7d4f355a] {\n  padding: 20px 30px;\n}\n.access label[data-v-7d4f355a] {\n    display: block;\n    font-weight: 600;\n    color: #444;\n    padding-bottom: 3px;\n    font-size: 14px;\n    border-bottom: 1px solid #ddd;\n}\nul[data-v-7d4f355a] {\n  list-style: none;\n  padding: 0;\n  width: 100%;\n  text-align: left;\n  -webkit-column-count: 3;\n  /* Chrome, Safari, Opera */\n  -moz-column-count: 3;\n  /* Firefox */\n  column-count: 3;\n}\nul.one[data-v-7d4f355a] {\n    -webkit-column-count: 1;\n    /* Chrome, Safari, Opera */\n    -moz-column-count: 1;\n    /* Firefox */\n    column-count: 1;\n}\nul li[data-v-7d4f355a] {\n    display: block;\n    font-size: 14px;\n    padding: 4px 0;\n    cursor: pointer;\n    color: #555;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\nul li i[data-v-7d4f355a] {\n      margin-right: 5px;\n      color: #aaa;\n      font-size: 15px;\n}\nul li .fa-check-square[data-v-7d4f355a] {\n      color: #528cce;\n}\nul li .fa-square[data-v-7d4f355a] {\n      color: #b5cebd;\n}\nul li[data-v-7d4f355a]:hover, ul li:hover i[data-v-7d4f355a], ul li.checked i[data-v-7d4f355a] {\n      color: #528cce;\n}\nul li.disabled[data-v-7d4f355a] {\n      opacity: .4;\n      cursor: default;\n}\n.access.reports[data-v-7d4f355a] {\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin: 0 30px;\n  padding: 0;\n  background: #fffbd2;\n}\n.access.reports label[data-v-7d4f355a] {\n    padding: 10px 20px;\n    line-height: 1;\n}\n.access.reports ul[data-v-7d4f355a] {\n    padding: 0 20px;\n}\n.error[data-v-7d4f355a]:not(.button) {\n  padding: 5px;\n  margin: 0 30px 20px;\n  display: block;\n  font-size: 14px;\n  border: 1px solid #ff5b36;\n  color: #ff5b36;\n  font-style: italic;\n}\n.success-box[data-v-7d4f355a] {\n  width: 400px;\n  background: #fff;\n  margin: 0 auto;\n  padding: 20px;\n  border-radius: 3px;\n  text-align: center;\n  color: #444;\n  font-weight: 600;\n}\n.success-box i[data-v-7d4f355a] {\n    color: #36f18e;\n}\n.success-box span[data-v-7d4f355a] {\n    display: block;\n    margin: 15px 0 35px;\n}\n.success-box .button[data-v-7d4f355a] {\n    min-width: 100px;\n    margin: 0 5px;\n}\n.fixed-footer[data-v-7d4f355a] {\n  width: 100%;\n  background: #f3f3f3;\n  border-top: 1px solid #ccc;\n  padding: 6px 10px;\n  text-align: center;\n  margin-top: 30px;\n}\n.fixed-footer .button[data-v-7d4f355a] {\n    min-width: 120px;\n    margin: 0 5px;\n}\n.slide-up-enter-active[data-v-7d4f355a], .slide-up-leave-active[data-v-7d4f355a] {\n  -webkit-transition: all .4s ease;\n  transition: all .4s ease;\n}\n.slide-up-enter[data-v-7d4f355a], .slide-up-leave-to[data-v-7d4f355a] {\n  -webkit-transform: translateY(15px);\n          transform: translateY(15px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.row-padding[data-v-7d4f355a] {\n    padding: 2px 10px;\n}\n.mobile[data-v-7d4f355a] {\n    width: 100%;\n    padding: 0;\n}\n.access[data-v-7d4f355a] {\n    padding: 5px 10px;\n}\nul[data-v-7d4f355a] {\n    -webkit-column-count: 2;\n       -moz-column-count: 2;\n            column-count: 2;\n}\nul li[data-v-7d4f355a] {\n      font-size: 12px;\n}\nul li i[data-v-7d4f355a] {\n        margin-right: 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['op--modal-container', {'hide':!_vm.show}],on:{"click":_vm.close}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content",attrs:{"id":"form"}},[_c('div',{staticClass:"form",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"heading"},[(_vm.editId)?_c('span',[_vm._v("Edit Admin")]):_c('span',[_vm._v("Add Admin")])]),_vm._v(" "),(!!_vm.error)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.firstName),expression:"firstName"}],class:{'input':true, 'has-error':!!_vm.errorMsg.firstName},attrs:{"type":"text"},domProps:{"value":(_vm.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.firstName=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.firstName))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lastName),expression:"lastName"}],class:{'input':true, 'has-error':!!_vm.errorMsg.lastName},attrs:{"type":"text"},domProps:{"value":(_vm.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lastName=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.lastName))])])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"small-6 columns padding-R mobile"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],class:{'input':true, 'has-error':!!_vm.errorMsg.email},attrs:{"type":"text"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.email))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L mobile"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Mobile")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mobile),expression:"mobile"}],class:{'input':true, 'has-error':!!_vm.errorMsg.mobile},attrs:{"type":"text"},domProps:{"value":(_vm.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mobile=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.mobile))])])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"small-6 columns padding-R mobile"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Username")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],class:{'input':true, 'has-error':!!_vm.errorMsg.username},attrs:{"type":"text"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.username))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L mobile"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],class:{'input':true, 'has-error':!!_vm.errorMsg.password},attrs:{"type":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),(_vm.editId)?_c('span',{staticClass:"password-edit"},[_vm._v("Leave blank if you dont want to change the password.")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.password))])])])]),_vm._v(" "),_c('div',{staticClass:"access"},[_c('label',[_vm._v("Permission Access")]),_vm._v(" "),_c('ul',_vm._l((_vm.fields),function(data,index){return _c('li',[_c('span',{on:{"click":function($event){return _vm.updateStorePermission(index, !!_vm.access[index])}}},[(!!_vm.access[index])?_c('i',{staticClass:"fas fa-check-square fa-2x"}):_c('i',{staticClass:"far fa-square fa-2x"}),_vm._v("\n                "+_vm._s(data)+"\n              ")])])}),0)]),_vm._v(" "),(!!_vm.access.PageAdminReports)?_c('div',{staticClass:"access reports"},[_c('label',[_vm._v("Reports Access*")]),_vm._v(" "),_c('ul',_vm._l((_vm.reportsList),function(data,index){return _c('li',[_c('span',{on:{"click":function($event){return _vm.updateReportPermission(index, !!_vm.reportAccess[index])}}},[(!!_vm.reportAccess[index])?_c('i',{staticClass:"fas fa-check-square fa-2x"}):_c('i',{staticClass:"far fa-square fa-2x"}),_vm._v("\n                "+_vm._s(data)+"\n              ")])])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"fixed-footer"},[_c('div',{class:{'button cta small warning':true, 'disabled':_vm.submitLoading},on:{"click":_vm.close}},[_vm._v("CANCEL")]),_vm._v(" "),_c('div',{class:{'button cta small':true, 'disabled':_vm.submitLoading},on:{"click":_vm.submitForm}},[(_vm.editId)?_c('span',[_vm._v("SAVE")]):_c('span',[_vm._v("ADD")])])])]),_vm._v(" "),_c('div',{class:{'op--modal-container':true, 'hide':!_vm.showSuccess},on:{"click":_vm.close}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content"},[_c('div',{staticClass:"success-box",on:{"click":function($event){$event.stopPropagation();}}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSuccess),expression:"showSuccess"}],staticClass:"far fa-check-circle fa-4x"})]),_vm._v(" "),(_vm.editId)?_c('span',[_vm._v("Successfully updated admin account.")]):_c('span',[_vm._v("Successfully created admin account.")]),_vm._v(" "),_c('div',{staticClass:"button cta success",on:{"click":_vm.close}},[_vm._v("Close")])],1)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"heading"},[_vm._v("Admins")]),_vm._v(" "),_c('admin-filter'),_vm._v(" "),_c('admin-list',{directives:[{name:"show",rawName:"v-show",value:(_vm.tab === 0),expression:"tab === 0"}]}),_vm._v(" "),_c('admin-add'),_vm._v(" "),_c('div',{staticClass:"fix-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-3 columns per-page"},[_c('span',[_vm._v("Displaying")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" "),_c('span',[_vm._v("per page")])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns page-data"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.admin.length > 0),expression:"admin.length > 0"}]},[_vm._v("\n          Displaying\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.start))]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.pageData.end))]),_vm._v(" of\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.max))])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns pagination"},[_c('span',[_vm._v("Page")]),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.currentPage === 1 || _vm.loading},on:{"click":_vm.prev}},[_c('i',{staticClass:"fas fa-chevron-left"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentPage),expression:"currentPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.totalPage),function(i){return _c('option',{domProps:{"value":i}},[_vm._v(_vm._s(i))])}),0),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.isLastPage || _vm.loading},on:{"click":_vm.next}},[_c('i',{staticClass:"fas fa-chevron-right"})])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(389);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_367070fb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1096);
function injectStyle (ssrContext) {
  __webpack_require__(1078)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-367070fb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_367070fb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1079);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0987af80", content, true, {});

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.heading[data-v-367070fb] {\n  margin-left: 50px;\n  padding-left: 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.navs[data-v-367070fb] {\n  border-bottom: 1px solid #ccc;\n  max-width: 100%;\n}\n.navs ul[data-v-367070fb] {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    font-size: 14px;\n}\n.navs ul li[data-v-367070fb] {\n      display: inline-block;\n      padding: 13px 15px;\n      color: #0D79F2;\n      font-weight: 600;\n      cursor: pointer;\n      border: 1px solid transparent;\n      text-decoration: underline;\n}\n.navs ul .active[data-v-367070fb] {\n      background: #fff;\n      border-right-color: #ccc;\n      border-left-color: #ccc;\n      cursor: default;\n      text-decoration: none;\n}\n.navs .add-form[data-v-367070fb] {\n    text-align: right;\n}\n.navs .add-form i[data-v-367070fb] {\n      margin-right: 5px;\n}\n.navs .button[data-v-367070fb] {\n    margin: 5px 15px 5px 0;\n}\n@media only screen and (max-width: 430px) {\n.small-10[data-v-367070fb] {\n    width: 100%;\n}\n.add-form[data-v-367070fb] {\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    text-align: center !important;\n    background-color: #fff;\n    padding: 5px 0;\n}\n.navs ul li[data-v-367070fb] {\n    width: 49%;\n    text-align: center;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Brands/index.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;CAC3B;AACD;EACE,8BAA8B;EAC9B,gBAAgB;CACjB;AACD;IACI,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,gBAAgB;CACnB;AACD;MACM,sBAAsB;MACtB,mBAAmB;MACnB,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,8BAA8B;MAC9B,2BAA2B;CAChC;AACD;MACM,iBAAiB;MACjB,yBAAyB;MACzB,wBAAwB;MACxB,gBAAgB;MAChB,sBAAsB;CAC3B;AACD;IACI,kBAAkB;CACrB;AACD;MACM,kBAAkB;CACvB;AACD;IACI,uBAAuB;CAC1B;AACD;AACA;IACI,YAAY;CACf;AACD;IACI,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;CAClB;AACD;IACI,WAAW;IACX,mBAAmB;CACtB;CACA","file":"index.vue","sourcesContent":["\n.heading[data-v-367070fb] {\n  margin-left: 50px;\n  padding-left: 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.navs[data-v-367070fb] {\n  border-bottom: 1px solid #ccc;\n  max-width: 100%;\n}\n.navs ul[data-v-367070fb] {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    font-size: 14px;\n}\n.navs ul li[data-v-367070fb] {\n      display: inline-block;\n      padding: 13px 15px;\n      color: #0D79F2;\n      font-weight: 600;\n      cursor: pointer;\n      border: 1px solid transparent;\n      text-decoration: underline;\n}\n.navs ul .active[data-v-367070fb] {\n      background: #fff;\n      border-right-color: #ccc;\n      border-left-color: #ccc;\n      cursor: default;\n      text-decoration: none;\n}\n.navs .add-form[data-v-367070fb] {\n    text-align: right;\n}\n.navs .add-form i[data-v-367070fb] {\n      margin-right: 5px;\n}\n.navs .button[data-v-367070fb] {\n    margin: 5px 15px 5px 0;\n}\n@media only screen and (max-width: 430px) {\n.small-10[data-v-367070fb] {\n    width: 100%;\n}\n.add-form[data-v-367070fb] {\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    text-align: center !important;\n    background-color: #fff;\n    padding: 5px 0;\n}\n.navs ul li[data-v-367070fb] {\n    width: 49%;\n    text-align: center;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandList_vue__ = __webpack_require__(390);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bdce5e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandList_vue__ = __webpack_require__(1083);
function injectStyle (ssrContext) {
  __webpack_require__(1081)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6bdce5e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bdce5e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1082);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("43b74f0f", content, true, {});

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\ntable[data-v-6bdce5e2] {\n  border-collapse: collapse;\n  width: 100%;\n  -webkit-transition: all .5s ease;\n  transition: all .5s ease;\n}\ntable.disabled[data-v-6bdce5e2] {\n    opacity: .4;\n}\ntable thead[data-v-6bdce5e2] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-6bdce5e2] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-6bdce5e2] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-6bdce5e2] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-6bdce5e2] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr[data-v-6bdce5e2]:nth-of-type(even) {\n      background: #fbfbfb;\n}\ntable tbody tr td[data-v-6bdce5e2] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-6bdce5e2] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-6bdce5e2] {\n          color: #ccc;\n}\ntable input[data-v-6bdce5e2] {\n    display: inline-block;\n    width: auto;\n}\ntable .type[data-v-6bdce5e2] {\n    display: inline-block;\n    padding: 3px 6px;\n    text-transform: uppercase;\n    border-radius: 4px;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 600;\n}\ntable .type.tnc[data-v-6bdce5e2] {\n      background: #2ab77c;\n}\ntable .type.tcp[data-v-6bdce5e2] {\n      background: #3f81a0;\n}\ntable .status[data-v-6bdce5e2] {\n    text-transform: capitalize;\n}\ntable .expired[data-v-6bdce5e2] {\n    color: #de2929;\n}\ntable .fa-check-circle[data-v-6bdce5e2] {\n    color: #0fda4e;\n}\ntable .fa-times-circle[data-v-6bdce5e2] {\n    color: #ef3535;\n}\ntable a[data-v-6bdce5e2] {\n    cursor: pointer;\n}\ntable .date[data-v-6bdce5e2] {\n    word-spacing: 5px;\n}\n.slide-down-enter-active[data-v-6bdce5e2], .slide-down-leave-active[data-v-6bdce5e2] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-6bdce5e2], .slide-down-leave-to[data-v-6bdce5e2] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.cards[data-v-6bdce5e2] {\n    padding-top: 20px;\n    padding-bottom: 100px;\n}\n.cards .card[data-v-6bdce5e2] {\n      border: 1px solid #ccc;\n      margin: 0 10px;\n      margin-bottom: 15px;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n      font-weight: 700;\n}\n.cards .card > div[data-v-6bdce5e2] {\n        margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-6bdce5e2] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n}\n.cards .card .card-header .name[data-v-6bdce5e2] {\n          font-weight: 900;\n}\n.cards .card .card-header .amount[data-v-6bdce5e2] {\n          margin-left: 5px;\n          font-size: 14px;\n}\n.cards .card .card-header .status[data-v-6bdce5e2] {\n          text-transform: uppercase;\n          font-size: 12px;\n          font-weight: 900;\n}\n.cards .card .title[data-v-6bdce5e2] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n}\n.cards .card .label[data-v-6bdce5e2] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards .card .value[data-v-6bdce5e2] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards .card .value i[data-v-6bdce5e2] {\n          opacity: 0.3;\n}\n.cards .card .edit[data-v-6bdce5e2] {\n        text-align: right;\n        margin-bottom: 10px;\n        text-transform: uppercase;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Brands/BrandList.vue"],"names":[],"mappings":";AACA;EACE,0BAA0B;EAC1B,YAAY;EACZ,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;IACI,YAAY;CACf;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,2BAA2B;CAChC;AACD;QACQ,iBAAiB;CACxB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,oBAAoB;CACzB;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;IACI,sBAAsB;IACtB,YAAY;CACf;AACD;IACI,sBAAsB;IACtB,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;CACpB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;IACI,2BAA2B;CAC9B;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,kBAAkB;CACrB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;AACA;IACI,kBAAkB;IAClB,sBAAsB;CACzB;AACD;MACM,uBAAuB;MACvB,eAAe;MACf,oBAAoB;MACpB,aAAa;MACb,oBAAoB;MACpB,+BAA+B;MAC/B,oBAAoB;MACpB,iBAAiB;CACtB;AACD;QACQ,mBAAmB;CAC1B;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,+BAA+B;QACvC,0BAA0B;YACtB,uBAAuB;gBACnB,oBAAoB;CACnC;AACD;UACU,iBAAiB;CAC1B;AACD;UACU,iBAAiB;UACjB,gBAAgB;CACzB;AACD;UACU,0BAA0B;UAC1B,gBAAgB;UAChB,iBAAiB;CAC1B;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,oBAAoB;CACnC;AACD;QACQ,gBAAgB;QAChB,0BAA0B;QAC1B,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;CACzB;AACD;QACQ,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;CACxB;AACD;UACU,aAAa;CACtB;AACD;QACQ,kBAAkB;QAClB,oBAAoB;QACpB,0BAA0B;CACjC;CACA","file":"BrandList.vue","sourcesContent":["\ntable[data-v-6bdce5e2] {\n  border-collapse: collapse;\n  width: 100%;\n  -webkit-transition: all .5s ease;\n  transition: all .5s ease;\n}\ntable.disabled[data-v-6bdce5e2] {\n    opacity: .4;\n}\ntable thead[data-v-6bdce5e2] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-6bdce5e2] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-6bdce5e2] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-6bdce5e2] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-6bdce5e2] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr[data-v-6bdce5e2]:nth-of-type(even) {\n      background: #fbfbfb;\n}\ntable tbody tr td[data-v-6bdce5e2] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-6bdce5e2] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-6bdce5e2] {\n          color: #ccc;\n}\ntable input[data-v-6bdce5e2] {\n    display: inline-block;\n    width: auto;\n}\ntable .type[data-v-6bdce5e2] {\n    display: inline-block;\n    padding: 3px 6px;\n    text-transform: uppercase;\n    border-radius: 4px;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 600;\n}\ntable .type.tnc[data-v-6bdce5e2] {\n      background: #2ab77c;\n}\ntable .type.tcp[data-v-6bdce5e2] {\n      background: #3f81a0;\n}\ntable .status[data-v-6bdce5e2] {\n    text-transform: capitalize;\n}\ntable .expired[data-v-6bdce5e2] {\n    color: #de2929;\n}\ntable .fa-check-circle[data-v-6bdce5e2] {\n    color: #0fda4e;\n}\ntable .fa-times-circle[data-v-6bdce5e2] {\n    color: #ef3535;\n}\ntable a[data-v-6bdce5e2] {\n    cursor: pointer;\n}\ntable .date[data-v-6bdce5e2] {\n    word-spacing: 5px;\n}\n.slide-down-enter-active[data-v-6bdce5e2], .slide-down-leave-active[data-v-6bdce5e2] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-6bdce5e2], .slide-down-leave-to[data-v-6bdce5e2] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.cards[data-v-6bdce5e2] {\n    padding-top: 20px;\n    padding-bottom: 100px;\n}\n.cards .card[data-v-6bdce5e2] {\n      border: 1px solid #ccc;\n      margin: 0 10px;\n      margin-bottom: 15px;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n      font-weight: 700;\n}\n.cards .card > div[data-v-6bdce5e2] {\n        margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-6bdce5e2] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n}\n.cards .card .card-header .name[data-v-6bdce5e2] {\n          font-weight: 900;\n}\n.cards .card .card-header .amount[data-v-6bdce5e2] {\n          margin-left: 5px;\n          font-size: 14px;\n}\n.cards .card .card-header .status[data-v-6bdce5e2] {\n          text-transform: uppercase;\n          font-size: 12px;\n          font-weight: 900;\n}\n.cards .card .title[data-v-6bdce5e2] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n}\n.cards .card .label[data-v-6bdce5e2] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards .card .value[data-v-6bdce5e2] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards .card .value i[data-v-6bdce5e2] {\n          opacity: 0.3;\n}\n.cards .card .edit[data-v-6bdce5e2] {\n        text-align: right;\n        margin-bottom: 10px;\n        text-transform: uppercase;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isMobile)?_c('table',{class:{'disabled':_vm.extraDataLoading}},[_c('thead',[_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'name'},on:{"click":function($event){return _vm.sort('name')}}},[_vm._v("\n        Brand Name\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'name'),expression:"currentOrder.field === 'name'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'website'},on:{"click":function($event){return _vm.sort('website')}}},[_vm._v("\n        Website\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'website'),expression:"currentOrder.field === 'website'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',[_vm._v("Webform")]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'phoneNumber'},on:{"click":function($event){return _vm.sort('phoneNumber')}}},[_vm._v("\n        Phone #\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'phoneNumber'),expression:"currentOrder.field === 'phoneNumber'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'supportEmail'},on:{"click":function($event){return _vm.sort('supportEmail')}}},[_vm._v("\n        Support Email\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'supportEmail'),expression:"currentOrder.field === 'supportEmail'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',[_vm._v("Send Email As")]),_vm._v(" "),_c('th',[_vm._v("Email Logo")]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'emailFAQ'},on:{"click":function($event){return _vm.sort('emailFAQ')}}},[_vm._v("\n        FAQ\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'emailFAQ'),expression:"currentOrder.field === 'emailFAQ'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'emailTC'},on:{"click":function($event){return _vm.sort('emailTC')}}},[_vm._v("\n        Terms\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'emailTC'),expression:"currentOrder.field === 'emailTC'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.brands),function(brand){return _c('tr',[_c('td',[_c('a',{on:{"click":function($event){return _vm.editBrand(brand.id)}}},[_vm._v(_vm._s(brand.name))])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":brand.website,"target":"_blank"}},[_vm._v(_vm._s(brand.website))])]),_vm._v(" "),_c('td',[(!_vm.webformLoading)?_c('span',[_vm._v(_vm._s(_vm.webformName(brand.webformId)))]):_c('span',[_c('i',{staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(brand.phoneNumber))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'mailto:' + brand.supportEmail}},[_vm._v(_vm._s(brand.supportEmail))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(brand.emailSendAs))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":brand.emailLogoUrl,"target":"_blank"}},[_vm._v("View")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":brand.emailFAQ,"target":"_blank"}},[_vm._v(_vm._s(brand.emailFAQ))])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":brand.emailTC,"target":"_blank"}},[_vm._v(_vm._s(brand.emailTC))])])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading && _vm.brands.length === 0),expression:"loading && brands.length === 0"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"9"}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n              Getting brands...\n            ")])])],1)]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.brands.length === 0 && !_vm.loading),expression:"brands.length === 0 && !loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"9"}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.brands.length === 0 && !_vm.loading),expression:"brands.length === 0 && !loading"}],staticClass:"empty-result"},[_c('i',{staticClass:"far fa-frown-open fa-3x"}),_c('br'),_vm._v("\n              No record found!\n            ")])])],1)])],2)]):_c('div',{staticClass:"cards"},_vm._l((_vm.brands),function(brand){return _c('div',{key:brand.id,staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('a',{on:{"click":function($event){return _vm.editBrand(brand.id)}}},[_vm._v(_vm._s(brand.name))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Website:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":brand.website,"target":"_blank"}},[_vm._v(_vm._s(brand.website))])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Webform:")]),_vm._v(" "),_c('div',{staticClass:"value"},[(!_vm.webformLoading)?_c('span',[_vm._v(_vm._s(_vm.webformName(brand.webformId)))]):_c('span',[_c('i',{staticClass:"fas fa-spinner fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Phone: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(brand.phoneNumber))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Support Email: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":'mailto:' + brand.supportEmail}},[_vm._v(_vm._s(brand.supportEmail))])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Send Email As: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(brand.emailSendAs))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("FAQ: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":brand.emailFAQ,"target":"_blank"}},[_vm._v(_vm._s(brand.emailFAQ))])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Terms: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":brand.emailTC,"target":"_blank"}},[_vm._v(_vm._s(brand.emailTC))])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Email Logo: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":brand.emailLogoUrl,"target":"_blank"}},[_vm._v("View")])])])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandAdd_vue__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_778b9ab0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandAdd_vue__ = __webpack_require__(1087);
function injectStyle (ssrContext) {
  __webpack_require__(1085)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-778b9ab0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_778b9ab0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1086);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("f9001c76", content, true, {});

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.op--modal-container[data-v-778b9ab0] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-778b9ab0] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-778b9ab0] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content.center[data-v-778b9ab0] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.brand-form[data-v-778b9ab0] {\n  background-color: #fff;\n  width: 900px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.heading[data-v-778b9ab0] {\n  background: #333;\n  color: #fff;\n  font-weight: 600;\n  font-size: 21px;\n  padding: 10px 20px;\n  margin-bottom: 20px;\n}\n.email-settings[data-v-778b9ab0] {\n  margin-top: 20px;\n  padding: 30px;\n  background: #fafafa;\n  border-top: 1px solid #ddd;\n  border-bottom: 1px solid #ddd;\n}\n.email-settings[data-v-778b9ab0]:last-child {\n    /*\r\n    padding-bottom: 50px;\r\n    margin-bottom: 0;\r\n    */\n}\n.social-links[data-v-778b9ab0] {\n  margin-bottom: 20px;\n  padding: 30px;\n  background: #fff;\n}\n.sub-heading[data-v-778b9ab0] {\n  font-weight: 600;\n  color: #0D79F2;\n  margin-bottom: 20px;\n  border-bottom: 1px solid #ccc;\n}\n.clear[data-v-778b9ab0] {\n  clear: both;\n}\n.data-field[data-v-778b9ab0] {\n  position: relative;\n  margin-bottom: 10px;\n}\n.data-field .label[data-v-778b9ab0] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 130%;\n    margin-bottom: 1px;\n}\n.data-field .label.has-error[data-v-778b9ab0] {\n      color: #f20d0d;\n}\n.data-field .label.underline[data-v-778b9ab0] {\n      padding-bottom: 3px;\n      margin-bottom: 10px;\n      border-bottom: 1px solid #ccc;\n}\n.data-field .label .secondary[data-v-778b9ab0] {\n      color: #5390dc;\n      display: inline-block;\n      margin-left: 3px;\n}\n.data-field .input[data-v-778b9ab0] {\n    margin: 1px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-778b9ab0] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-778b9ab0]:disabled {\n      background: #eee;\n}\n.data-field textarea[data-v-778b9ab0] {\n    border: 1px solid #ddd;\n    width: 100%;\n    height: 150px;\n    resize: none;\n    padding: 10px;\n    font-size: 13px;\n    color: #555;\n    outline: none;\n    margin-top: 5px;\n}\n.data-field textarea.has-error[data-v-778b9ab0] {\n      border-color: #f20d0d;\n}\n.data-field .error-msg[data-v-778b9ab0] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\nselect[data-v-778b9ab0] {\n  margin-top: 1px;\n  border: 1px solid #ddd;\n  padding: 10px;\n  color: #333;\n  height: 45px;\n  position: relative;\n  font-size: 14px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n  -webkit-transition: all .35s ease;\n  transition: all .35s ease;\n}\nselect.has-error[data-v-778b9ab0] {\n    border-color: #f20d0d;\n}\nselect[data-v-778b9ab0]:disabled {\n    background-color: #eee;\n}\n.target-frame[data-v-778b9ab0] {\n  width: 100%;\n  text-align: center;\n  border-radius: 3px;\n  border: 1px solid #ccc;\n  background: #f3f3f3;\n  padding: 5px;\n  -webkit-box-shadow: 0 0 0 3px #fff inset;\n          box-shadow: 0 0 0 3px #fff inset;\n  overflow: hidden;\n  max-width: 100%;\n  cursor: pointer;\n}\n.target-frame.h60[data-v-778b9ab0] {\n    max-height: 70px;\n}\n.target-frame.h80[data-v-778b9ab0] {\n    max-height: 90px;\n}\n.target-frame.h196[data-v-778b9ab0] {\n    max-height: 206px;\n}\n.target-frame.h200[data-v-778b9ab0] {\n    max-height: 210px;\n}\n.target-frame.h200 img[data-v-778b9ab0] {\n      max-height: 200px;\n}\n.target-frame i[data-v-778b9ab0] {\n    color: #ccc;\n}\n.upload-btn[data-v-778b9ab0] {\n  margin-bottom: 15px;\n}\n.color-picker[data-v-778b9ab0] {\n  position: absolute;\n  top: 100%;\n  z-index: 3;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.color-picker.right[data-v-778b9ab0] {\n    right: 0;\n}\n.color-picker.left[data-v-778b9ab0] {\n    left: 0;\n}\n.row[data-v-778b9ab0] {\n  max-width: 100%;\n}\n.row-padding[data-v-778b9ab0] {\n  padding: 2px 30px;\n}\n.padding-L[data-v-778b9ab0] {\n  padding-left: 10px;\n}\n.padding-R[data-v-778b9ab0] {\n  padding-right: 10px;\n}\n.margin-B[data-v-778b9ab0] {\n  margin-bottom: 20px;\n}\n.fixed-footer[data-v-778b9ab0] {\n  position: fixed;\n  bottom: 0;\n  left: 50%;\n  width: 100%;\n  max-width: 900px;\n  background: #f3f3f3;\n  border-top: 1px solid #ccc;\n  padding: 6px 20px;\n  margin-left: -458px;\n  text-align: right;\n}\n.fixed-footer .delete[data-v-778b9ab0] {\n    float: left;\n}\n.fixed-footer .button[data-v-778b9ab0] {\n    min-width: 120px;\n    margin: 0 5px;\n}\n.error-box[data-v-778b9ab0] {\n  margin: 0 30px;\n  border: 1px solid #f34c31;\n  color: #f34c31;\n  padding: 5px;\n  margin-bottom: 15px;\n  font-size: 14px;\n  font-weight: 600;\n}\n.confirm-delete[data-v-778b9ab0] {\n  width: 400px;\n  background: #fff;\n  margin: 0 auto;\n  padding: 20px;\n  border-radius: 3px;\n  text-align: center;\n  color: #444;\n  font-weight: 600;\n}\n.confirm-delete span[data-v-778b9ab0] {\n    display: block;\n    margin-bottom: 15px;\n}\n.confirm-delete .button[data-v-778b9ab0] {\n    min-width: 100px;\n    margin: 0 5px;\n}\n.slide-down-enter-active[data-v-778b9ab0], .slide-down-leave-active[data-v-778b9ab0] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-778b9ab0], .slide-down-leave-to[data-v-778b9ab0] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.isMobile[data-v-778b9ab0] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.isMobile[data-v-778b9ab0] {\n    display: block;\n    text-align: center;\n    margin-top: 20px;\n}\n.isMobile .button[data-v-778b9ab0] {\n      width: 50%;\n}\n.brand-form[data-v-778b9ab0] {\n    width: 100%;\n}\n.full-field[data-v-778b9ab0] {\n    width: 100%;\n    padding: 0;\n}\n.full-field .margin-B[data-v-778b9ab0] {\n      margin-bottom: 10px;\n}\n.fixed-footer[data-v-778b9ab0] {\n    left: 0;\n    margin-left: 0;\n    text-align: center;\n}\n.fixed-footer .delete[data-v-778b9ab0] {\n      display: none;\n}\n.social-links[data-v-778b9ab0] {\n    padding-bottom: 100px;\n}\n.op--modal-container[data-v-778b9ab0] {\n    display: block;\n}\n.op--modal-container.hide[data-v-778b9ab0] {\n      display: none;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Brands/BrandAdd.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,iDAAiD;UACzC,yCAAyC;EACjD,mBAAmB;CACpB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;CACrB;AACD;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,2BAA2B;EAC3B,8BAA8B;CAC/B;AACD;IACI;;;MAGE;CACL;AACD;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,8BAA8B;CAC/B;AACD;EACE,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,oBAAoB;CACrB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;MACM,oBAAoB;MACpB,oBAAoB;MACpB,8BAA8B;CACnC;AACD;MACM,eAAe;MACf,sBAAsB;MACtB,iBAAiB;CACtB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,gBAAgB;CACnB;AACD;MACM,sBAAsB;CAC3B;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;IACI,sBAAsB;CACzB;AACD;IACI,uBAAuB;CAC1B;AACD;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,yCAAyC;UACjC,iCAAiC;EACzC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;CACjB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,kBAAkB;CACrB;AACD;MACM,kBAAkB;CACvB;AACD;IACI,YAAY;CACf;AACD;EACE,oBAAoB;CACrB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;IACI,SAAS;CACZ;AACD;IACI,QAAQ;CACX;AACD;EACE,gBAAgB;CACjB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;EAC3B,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;CACnB;AACD;IACI,YAAY;CACf;AACD;IACI,iBAAiB;IACjB,cAAc;CACjB;AACD;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;CAClB;AACD;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;CAClB;AACD;IACI,eAAe;IACf,oBAAoB;CACvB;AACD;IACI,iBAAiB;IACjB,cAAc;CACjB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;EACE,cAAc;CACf;AACD;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,iBAAiB;CACpB;AACD;MACM,WAAW;CAChB;AACD;IACI,YAAY;CACf;AACD;IACI,YAAY;IACZ,WAAW;CACd;AACD;MACM,oBAAoB;CACzB;AACD;IACI,QAAQ;IACR,eAAe;IACf,mBAAmB;CACtB;AACD;MACM,cAAc;CACnB;AACD;IACI,sBAAsB;CACzB;AACD;IACI,eAAe;CAClB;AACD;MACM,cAAc;CACnB;CACA","file":"BrandAdd.vue","sourcesContent":["\n.op--modal-container[data-v-778b9ab0] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-778b9ab0] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-778b9ab0] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content.center[data-v-778b9ab0] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.brand-form[data-v-778b9ab0] {\n  background-color: #fff;\n  width: 900px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.heading[data-v-778b9ab0] {\n  background: #333;\n  color: #fff;\n  font-weight: 600;\n  font-size: 21px;\n  padding: 10px 20px;\n  margin-bottom: 20px;\n}\n.email-settings[data-v-778b9ab0] {\n  margin-top: 20px;\n  padding: 30px;\n  background: #fafafa;\n  border-top: 1px solid #ddd;\n  border-bottom: 1px solid #ddd;\n}\n.email-settings[data-v-778b9ab0]:last-child {\n    /*\r\n    padding-bottom: 50px;\r\n    margin-bottom: 0;\r\n    */\n}\n.social-links[data-v-778b9ab0] {\n  margin-bottom: 20px;\n  padding: 30px;\n  background: #fff;\n}\n.sub-heading[data-v-778b9ab0] {\n  font-weight: 600;\n  color: #0D79F2;\n  margin-bottom: 20px;\n  border-bottom: 1px solid #ccc;\n}\n.clear[data-v-778b9ab0] {\n  clear: both;\n}\n.data-field[data-v-778b9ab0] {\n  position: relative;\n  margin-bottom: 10px;\n}\n.data-field .label[data-v-778b9ab0] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 130%;\n    margin-bottom: 1px;\n}\n.data-field .label.has-error[data-v-778b9ab0] {\n      color: #f20d0d;\n}\n.data-field .label.underline[data-v-778b9ab0] {\n      padding-bottom: 3px;\n      margin-bottom: 10px;\n      border-bottom: 1px solid #ccc;\n}\n.data-field .label .secondary[data-v-778b9ab0] {\n      color: #5390dc;\n      display: inline-block;\n      margin-left: 3px;\n}\n.data-field .input[data-v-778b9ab0] {\n    margin: 1px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-778b9ab0] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-778b9ab0]:disabled {\n      background: #eee;\n}\n.data-field textarea[data-v-778b9ab0] {\n    border: 1px solid #ddd;\n    width: 100%;\n    height: 150px;\n    resize: none;\n    padding: 10px;\n    font-size: 13px;\n    color: #555;\n    outline: none;\n    margin-top: 5px;\n}\n.data-field textarea.has-error[data-v-778b9ab0] {\n      border-color: #f20d0d;\n}\n.data-field .error-msg[data-v-778b9ab0] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\nselect[data-v-778b9ab0] {\n  margin-top: 1px;\n  border: 1px solid #ddd;\n  padding: 10px;\n  color: #333;\n  height: 45px;\n  position: relative;\n  font-size: 14px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n  -webkit-transition: all .35s ease;\n  transition: all .35s ease;\n}\nselect.has-error[data-v-778b9ab0] {\n    border-color: #f20d0d;\n}\nselect[data-v-778b9ab0]:disabled {\n    background-color: #eee;\n}\n.target-frame[data-v-778b9ab0] {\n  width: 100%;\n  text-align: center;\n  border-radius: 3px;\n  border: 1px solid #ccc;\n  background: #f3f3f3;\n  padding: 5px;\n  -webkit-box-shadow: 0 0 0 3px #fff inset;\n          box-shadow: 0 0 0 3px #fff inset;\n  overflow: hidden;\n  max-width: 100%;\n  cursor: pointer;\n}\n.target-frame.h60[data-v-778b9ab0] {\n    max-height: 70px;\n}\n.target-frame.h80[data-v-778b9ab0] {\n    max-height: 90px;\n}\n.target-frame.h196[data-v-778b9ab0] {\n    max-height: 206px;\n}\n.target-frame.h200[data-v-778b9ab0] {\n    max-height: 210px;\n}\n.target-frame.h200 img[data-v-778b9ab0] {\n      max-height: 200px;\n}\n.target-frame i[data-v-778b9ab0] {\n    color: #ccc;\n}\n.upload-btn[data-v-778b9ab0] {\n  margin-bottom: 15px;\n}\n.color-picker[data-v-778b9ab0] {\n  position: absolute;\n  top: 100%;\n  z-index: 3;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.color-picker.right[data-v-778b9ab0] {\n    right: 0;\n}\n.color-picker.left[data-v-778b9ab0] {\n    left: 0;\n}\n.row[data-v-778b9ab0] {\n  max-width: 100%;\n}\n.row-padding[data-v-778b9ab0] {\n  padding: 2px 30px;\n}\n.padding-L[data-v-778b9ab0] {\n  padding-left: 10px;\n}\n.padding-R[data-v-778b9ab0] {\n  padding-right: 10px;\n}\n.margin-B[data-v-778b9ab0] {\n  margin-bottom: 20px;\n}\n.fixed-footer[data-v-778b9ab0] {\n  position: fixed;\n  bottom: 0;\n  left: 50%;\n  width: 100%;\n  max-width: 900px;\n  background: #f3f3f3;\n  border-top: 1px solid #ccc;\n  padding: 6px 20px;\n  margin-left: -458px;\n  text-align: right;\n}\n.fixed-footer .delete[data-v-778b9ab0] {\n    float: left;\n}\n.fixed-footer .button[data-v-778b9ab0] {\n    min-width: 120px;\n    margin: 0 5px;\n}\n.error-box[data-v-778b9ab0] {\n  margin: 0 30px;\n  border: 1px solid #f34c31;\n  color: #f34c31;\n  padding: 5px;\n  margin-bottom: 15px;\n  font-size: 14px;\n  font-weight: 600;\n}\n.confirm-delete[data-v-778b9ab0] {\n  width: 400px;\n  background: #fff;\n  margin: 0 auto;\n  padding: 20px;\n  border-radius: 3px;\n  text-align: center;\n  color: #444;\n  font-weight: 600;\n}\n.confirm-delete span[data-v-778b9ab0] {\n    display: block;\n    margin-bottom: 15px;\n}\n.confirm-delete .button[data-v-778b9ab0] {\n    min-width: 100px;\n    margin: 0 5px;\n}\n.slide-down-enter-active[data-v-778b9ab0], .slide-down-leave-active[data-v-778b9ab0] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-778b9ab0], .slide-down-leave-to[data-v-778b9ab0] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.isMobile[data-v-778b9ab0] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.isMobile[data-v-778b9ab0] {\n    display: block;\n    text-align: center;\n    margin-top: 20px;\n}\n.isMobile .button[data-v-778b9ab0] {\n      width: 50%;\n}\n.brand-form[data-v-778b9ab0] {\n    width: 100%;\n}\n.full-field[data-v-778b9ab0] {\n    width: 100%;\n    padding: 0;\n}\n.full-field .margin-B[data-v-778b9ab0] {\n      margin-bottom: 10px;\n}\n.fixed-footer[data-v-778b9ab0] {\n    left: 0;\n    margin-left: 0;\n    text-align: center;\n}\n.fixed-footer .delete[data-v-778b9ab0] {\n      display: none;\n}\n.social-links[data-v-778b9ab0] {\n    padding-bottom: 100px;\n}\n.op--modal-container[data-v-778b9ab0] {\n    display: block;\n}\n.op--modal-container.hide[data-v-778b9ab0] {\n      display: none;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'op--modal-container':true, 'hide':!_vm.show},on:{"click":_vm.close}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content brand-form",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"heading",attrs:{"id":"addBrand"}},[(_vm.editID)?_c('span',[_vm._v("Edit Brand")]):_c('span',[_vm._v("Add Brand")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.errorReturn),expression:"!!errorReturn"}],staticClass:"error-box"},[_vm._v(_vm._s(_vm.errorReturn))]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Brand Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brandName),expression:"brandName"}],class:{'input':true, 'has-error':!!_vm.error.brandName},attrs:{"type":"text"},domProps:{"value":(_vm.brandName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.brandName=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.brandName))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mobile),expression:"mobile"}],class:{'input':true, 'has-error':!!_vm.error.mobile},attrs:{"type":"text"},domProps:{"value":(_vm.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mobile=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.mobile))])])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Website")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.website),expression:"website"}],class:{'input':true, 'has-error':!!_vm.error.website},attrs:{"type":"text"},domProps:{"value":(_vm.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.website=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.website))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Webform")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.webform),expression:"webform"}],class:{'has-error':!!_vm.error.webform},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.webform=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.webforms),function(webform){return _c('option',{domProps:{"value":webform.id}},[_vm._v(_vm._s(webform.name))])}),0),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.webform))])])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Street Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.street),expression:"street"}],class:{'input':true, 'has-error':!!_vm.error.street},attrs:{"type":"text"},domProps:{"value":(_vm.street)},on:{"input":function($event){if($event.target.composing){ return; }_vm.street=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.street))])])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"small-4 columns padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city),expression:"city"}],class:{'input':true, 'has-error':!!_vm.error.city},attrs:{"type":"text"},domProps:{"value":(_vm.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.city=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.city))])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-L padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("State")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.state),expression:"state"}],class:{'has-error':!!_vm.error.state},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.state=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.states),function(state){return _c('option',{domProps:{"value":state.value}},[_vm._v(_vm._s(state.label))])}),0),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.state))])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[_c('div',{staticClass:"data-field padding-L"},[_c('div',{staticClass:"label"},[_vm._v("Zip")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zip),expression:"zip"}],class:{'input':true, 'has-error':!!_vm.error.zip},attrs:{"type":"text"},domProps:{"value":(_vm.zip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.zip=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.zip))])])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"small-6 columns padding-R full-field"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("FAQ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.faq),expression:"faq"}],class:{'input':true, 'has-error':!!_vm.error.faq},attrs:{"type":"text"},domProps:{"value":(_vm.faq)},on:{"input":function($event){if($event.target.composing){ return; }_vm.faq=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.faq))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L full-field"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Terms & Condition")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.terms),expression:"terms"}],class:{'input':true, 'has-error':!!_vm.error.terms},attrs:{"type":"text"},domProps:{"value":(_vm.terms)},on:{"input":function($event){if($event.target.composing){ return; }_vm.terms=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.terms))])])])]),_vm._v(" "),(_vm.editID)?_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"small-6 columns padding-R full-field"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Charter Booking")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.charterBooking),expression:"charterBooking"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.charterBooking=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"enabled"}},[_vm._v("Enabled")]),_vm._v(" "),_c('option',{attrs:{"value":"disabled"}},[_vm._v("Disabled")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"email-settings"},[_c('div',{staticClass:"sub-heading"},[_vm._v("Email Settings")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-4 columns padding-R full-field"},[_c('div',{staticClass:"data-field margin-B"},[_c('div',{staticClass:"label"},[_vm._v("Support Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supportEmail),expression:"supportEmail"}],class:{'input':true, 'has-error':!!_vm.error.supportEmail},attrs:{"type":"text"},domProps:{"value":(_vm.supportEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.supportEmail=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.supportEmail))])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-R padding-L full-field"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Send Email As")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendEmailAs),expression:"sendEmailAs"}],class:{'input':true, 'has-error':!!_vm.error.sendEmailAs},attrs:{"type":"text"},domProps:{"value":(_vm.sendEmailAs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sendEmailAs=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.sendEmailAs))])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-L full-field"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Email Highlight Color")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailColor),expression:"emailColor"}],class:{'input':true, 'has-error':!!_vm.error.emailColor},attrs:{"type":"text"},domProps:{"value":(_vm.emailColor)},on:{"click":function($event){_vm.showEmailColor = true},"input":function($event){if($event.target.composing){ return; }_vm.emailColor=$event.target.value}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEmailColor),expression:"showEmailColor"}],staticClass:"color-picker right"},[_c('photoshop-picker',{on:{"ok":function($event){return _vm.selectColor('email')}},model:{value:(_vm.emailColors),callback:function ($$v) {_vm.emailColors=$$v},expression:"emailColors"}})],1)]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.emailColor))])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field margin-B"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"target-frame h80",on:{"click":function($event){return _vm.triggerUpload('emailLogo')}}},[(_vm.uploadLoading.emailLogo)?_c('i',{staticClass:"fas fa-spinner fa-spin fa-5x"}):(!!_vm.file.emailLogo)?_c('img',{attrs:{"src":_vm.file.emailLogo}}):_c('i',{staticClass:"fas fa-image fa-5x"})]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.file.emailLogo))]),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"emailLogo",class:{'input':true, 'has-error':!!_vm.error.brandName},attrs:{"type":"file","id":"emailLogo","accept":"image/*"},on:{"change":_vm.uploadImg}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field margin-B"},[_c('div',{staticClass:"label"},[_vm._v("Confirmation Email Contact Information")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmEmail),expression:"confirmEmail"}],class:{'has-error':!!_vm.error.confirmEmail},domProps:{"value":(_vm.confirmEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirmEmail=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.confirmEmail))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field margin-B"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"target-frame h196",on:{"click":function($event){return _vm.triggerUpload('appDownload')}}},[(_vm.uploadLoading.appDownload)?_c('i',{staticClass:"fas fa-spinner fa-spin fa-5x"}):(!!_vm.file.appDownload)?_c('img',{attrs:{"src":_vm.file.appDownload}}):_c('i',{staticClass:"fas fa-image fa-5x"})]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.file.appDownload))]),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"appDownload",class:{'input':true, 'has-error':!!_vm.error.brandName},attrs:{"type":"file","id":"appDownload","accept":"image/*"},on:{"change":_vm.uploadImg}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('div',{staticClass:"data-field margin-B"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"target-frame h60",on:{"click":function($event){return _vm.triggerUpload('iosDownload')}}},[(_vm.uploadLoading.iosDownload)?_c('i',{staticClass:"fas fa-spinner fa-spin fa-4x"}):(!!_vm.file.iosDownload)?_c('img',{attrs:{"src":_vm.file.iosDownload}}):_c('i',{staticClass:"fas fa-image fa-4x"})]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.file.iosDownload))]),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"iosDownload",class:{'input':true, 'has-error':!!_vm.error.brandName},attrs:{"type":"file","id":"iosDownload","accept":"image/*"},on:{"change":_vm.uploadImg}})])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('div',{staticClass:"data-field margin-B"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"target-frame h60",on:{"click":function($event){return _vm.triggerUpload('androidDownload')}}},[(_vm.uploadLoading.androidDownload)?_c('i',{staticClass:"fas fa-spinner fa-spin fa-4x"}):(!!_vm.file.androidDownload)?_c('img',{attrs:{"src":_vm.file.androidDownload}}):_c('i',{staticClass:"fas fa-image fa-4x"})]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.file.androidDownload))]),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"androidDownload",class:{'input':true, 'has-error':!!_vm.error.brandName},attrs:{"type":"file","id":"androidDownload","accept":"image/*"},on:{"change":_vm.uploadImg}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns padding-R full-field"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("iOS Download Link")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.iosDownloadLink),expression:"iosDownloadLink"}],class:{'input':true, 'has-error':!!_vm.error.iosDownloadLink},attrs:{"type":"text"},domProps:{"value":(_vm.iosDownloadLink)},on:{"input":function($event){if($event.target.composing){ return; }_vm.iosDownloadLink=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.iosDownloadLink))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L full-field"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Android Download Link")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.androidDownloadLink),expression:"androidDownloadLink"}],class:{'input':true, 'has-error':!!_vm.error.androidDownloadLink},attrs:{"type":"text"},domProps:{"value":(_vm.androidDownloadLink)},on:{"input":function($event){if($event.target.composing){ return; }_vm.androidDownloadLink=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.androidDownloadLink))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns end padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Brand Color")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brandColor),expression:"brandColor"}],class:{'input':true, 'has-error':!!_vm.error.brandColor},attrs:{"type":"text"},domProps:{"value":(_vm.brandColor)},on:{"click":function($event){_vm.showBrandColor = true},"input":function($event){if($event.target.composing){ return; }_vm.brandColor=$event.target.value}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBrandColor),expression:"showBrandColor"}],staticClass:"color-picker left"},[_c('photoshop-picker',{on:{"ok":function($event){return _vm.selectColor('brand')}},model:{value:(_vm.brandColors),callback:function ($$v) {_vm.brandColors=$$v},expression:"brandColors"}})],1)]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.brandColor))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"social-links"},[_c('div',{staticClass:"sub-heading"},[_vm._v("Social Links")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-4 columns padding-R full-field"},[_c('div',{staticClass:"data-field margin-B"},[_c('div',{staticClass:"label"},[_vm._v("Facebook Link")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.facebookLink),expression:"facebookLink"}],class:{'input':true, 'has-error':!!_vm.error.facebookLink},attrs:{"type":"text"},domProps:{"value":(_vm.facebookLink)},on:{"input":function($event){if($event.target.composing){ return; }_vm.facebookLink=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.facebookLink))])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-R padding-L full-field"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Twitter Link")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.twitterLink),expression:"twitterLink"}],class:{'input':true, 'has-error':!!_vm.error.twitterLink},attrs:{"type":"text"},domProps:{"value":(_vm.twitterLink)},on:{"input":function($event){if($event.target.composing){ return; }_vm.twitterLink=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.twitterLink))])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-L full-field"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Text Link")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.textLink),expression:"textLink"}],class:{'input':true, 'has-error':!!_vm.error.textLink},attrs:{"type":"text"},domProps:{"value":(_vm.textLink)},on:{"input":function($event){if($event.target.composing){ return; }_vm.textLink=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.textLink))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-4 columns padding-R full-field"},[_c('div',{staticClass:"data-field margin-B"},[_c('div',{staticClass:"label"},[_vm._v("Facebook App ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.facebookAppID),expression:"facebookAppID"}],class:{'input':true, 'has-error':!!_vm.error.facebookAppID},attrs:{"type":"text"},domProps:{"value":(_vm.facebookAppID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.facebookAppID=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.facebookAppID))])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-R padding-L full-field"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Share Wording")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.shareWording),expression:"shareWording"}],class:{'input':true, 'has-error':!!_vm.error.shareWording},attrs:{"type":"text"},domProps:{"value":(_vm.shareWording)},on:{"input":function($event){if($event.target.composing){ return; }_vm.shareWording=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.shareWording))])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-L full-field"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("About Link")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.aboutLink),expression:"aboutLink"}],class:{'input':true, 'has-error':!!_vm.error.aboutLink},attrs:{"type":"text"},domProps:{"value":(_vm.aboutLink)},on:{"input":function($event){if($event.target.composing){ return; }_vm.aboutLink=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.aboutLink))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-4 columns end padding-R full-field"},[_c('div',{staticClass:"data-field margin-B"},[_c('div',{staticClass:"label"},[_vm._v("Email Link")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailLink),expression:"emailLink"}],class:{'input':true, 'has-error':!!_vm.error.emailLink},attrs:{"type":"text"},domProps:{"value":(_vm.emailLink)},on:{"input":function($event){if($event.target.composing){ return; }_vm.emailLink=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.emailLink))])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns end padding-R padding-L full-field"},[_c('div',{staticClass:"data-field margin-B"},[_c('div',{staticClass:"label"},[_vm._v("Instagram Link")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.instagramLink),expression:"instagramLink"}],class:{'input':true, 'has-error':!!_vm.error.instagramLink},attrs:{"type":"text"},domProps:{"value":(_vm.instagramLink)},on:{"input":function($event){if($event.target.composing){ return; }_vm.instagramLink=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.instagramLink))])])])]),_vm._v(" "),_c('div',{staticClass:"row isMobile"},[(_vm.editID)?_c('div',{class:{'button cta small error delete':true, 'disabled':_vm.submitLoading},on:{"click":function($event){_vm.showConfirm = true}}},[_vm._v("DELETE")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"fixed-footer"},[(_vm.editID)?_c('div',{class:{'button cta small error delete':true, 'disabled':_vm.submitLoading},on:{"click":function($event){_vm.showConfirm = true}}},[_vm._v("DELETE")]):_vm._e(),_vm._v(" "),_c('div',{class:{'button cta small warning':true, 'disabled':_vm.submitLoading},on:{"click":_vm.close}},[_vm._v("CANCEL")]),_vm._v(" "),_c('div',{class:{'button cta small':true, 'disabled':_vm.submitLoading},on:{"click":_vm.submit}},[(_vm.editID)?_c('span',[_vm._v("Save")]):_c('span',[_vm._v("Add")])])]),_vm._v(" "),_c('div',{class:{'op--modal-container':true, 'hide':!_vm.showConfirm},on:{"click":_vm.closeConfirmation}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content center"},[_c('div',{staticClass:"confirm-delete",on:{"click":function($event){$event.stopPropagation();}}},[_c('span',[_vm._v("Are you sure you want to delete this brand?")]),_vm._v(" "),_c('div',{class:{'button cta warning':true, 'disabled': _vm.submitLoading},on:{"click":_vm.closeConfirmation}},[_vm._v("No")]),_vm._v(" "),_c('div',{class:{'button cta success':true, 'disabled': _vm.submitLoading},on:{"click":_vm.deleteBrand}},[_vm._v("YES")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label"},[_vm._v("Email Logo "),_c('span',{staticClass:"secondary"},[_vm._v("(600x80px)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label"},[_vm._v("App Download Banner "),_c('span',{staticClass:"secondary"},[_vm._v("(600x196px)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label"},[_vm._v("iOS Download Button "),_c('span',{staticClass:"secondary"},[_vm._v("(190x60px)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label"},[_vm._v("Android Download Button "),_c('span',{staticClass:"secondary"},[_vm._v("(190x60px)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WebformList_vue__ = __webpack_require__(392);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_663ff876_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WebformList_vue__ = __webpack_require__(1091);
function injectStyle (ssrContext) {
  __webpack_require__(1089)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-663ff876"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WebformList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_663ff876_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WebformList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1090);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("64e7cf16", content, true, {});

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\ntable[data-v-663ff876] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-663ff876] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-663ff876] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-663ff876] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-663ff876] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-663ff876] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr[data-v-663ff876]:hover {\n      background: #e3e7e8 !important;\n}\ntable tbody tr[data-v-663ff876]:nth-of-type(even) {\n      background: #fcfcfc;\n}\ntable tbody tr td[data-v-663ff876] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-663ff876] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-663ff876] {\n          color: #ccc;\n}\ntable .border-R[data-v-663ff876] {\n    border-right: 1px solid #ccc;\n}\ntable .service-area[data-v-663ff876] {\n    text-align: left;\n    color: #333;\n    font-weight: 600;\n}\ntable .check-items i[data-v-663ff876] {\n    font-size: 21px;\n    color: #0fda4e;\n    /* &.fa-check-circle{ color: #0fda4e; }\r\n    &.fa-square{ color: #94b0d0; } */\n}\ntable a[data-v-663ff876] {\n    cursor: pointer;\n}\n.sticky[data-v-663ff876] {\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n.loading[data-v-663ff876] {\n  padding: 40px;\n  font-size: 38px;\n  text-align: center;\n  color: #aaa;\n}\n.loading i[data-v-663ff876] {\n    margin-right: 10px;\n}\n.slide-down-enter-active[data-v-663ff876], .slide-down-leave-active[data-v-663ff876] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-663ff876], .slide-down-leave-to[data-v-663ff876] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.loading[data-v-663ff876] {\n    font-size: 21px;\n}\n.cards[data-v-663ff876] {\n    padding-bottom: 100px;\n}\n.cards .webform[data-v-663ff876] {\n      -webkit-column-count: 2;\n         -moz-column-count: 2;\n              column-count: 2;\n      padding: 15px 20px;\n}\n.cards .webform .webform-list[data-v-663ff876] {\n        border: 1px solid #ccc;\n        padding: 5px 8px;\n        background-color: #fff;\n        font-weight: 900;\n        font-size: 14px;\n        margin-bottom: 5px;\n}\n.cards .card[data-v-663ff876] {\n      border: 1px solid #ccc;\n      margin: 0 10px;\n      margin-bottom: 15px;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n      font-weight: 700;\n}\n.cards .card .checked-items[data-v-663ff876] {\n        -webkit-column-count: 2;\n           -moz-column-count: 2;\n                column-count: 2;\n}\n.cards .card .checked-items .check-items i[data-v-663ff876] {\n          font-size: 12px;\n          color: #0fda4e;\n}\n.cards .card .checked-items .check-items span[data-v-663ff876] {\n          font-size: 14px;\n          color: #333;\n          font-weight: 100;\n}\n.cards .card > div[data-v-663ff876] {\n        margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-663ff876] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        font-size: 16px;\n}\n.cards .card .card-header .name[data-v-663ff876] {\n          font-weight: 900;\n}\n.cards .card .card-header .amount[data-v-663ff876] {\n          margin-left: 5px;\n          font-size: 14px;\n}\n.cards .card .card-header .status[data-v-663ff876] {\n          text-transform: uppercase;\n          font-size: 12px;\n          font-weight: 900;\n}\n.cards .card .title[data-v-663ff876] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n}\n.cards .card .label[data-v-663ff876] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards .card .value[data-v-663ff876] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards .card .value i[data-v-663ff876] {\n          opacity: 0.3;\n}\n.cards .card .edit[data-v-663ff876] {\n        text-align: right;\n        margin-bottom: 10px;\n        text-transform: uppercase;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Brands/WebformList.vue"],"names":[],"mappings":";AACA;EACE,0BAA0B;EAC1B,YAAY;CACb;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,2BAA2B;CAChC;AACD;QACQ,iBAAiB;CACxB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,+BAA+B;CACpC;AACD;MACM,oBAAoB;CACzB;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;IACI,6BAA6B;CAChC;AACD;IACI,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;CACpB;AACD;IACI,gBAAgB;IAChB,eAAe;IACf;qCACiC;CACpC;AACD;IACI,gBAAgB;CACnB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;CACT;AACD;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;CACb;AACD;IACI,mBAAmB;CACtB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;AACA;IACI,gBAAgB;CACnB;AACD;IACI,sBAAsB;CACzB;AACD;MACM,wBAAwB;SACrB,qBAAqB;cAChB,gBAAgB;MACxB,mBAAmB;CACxB;AACD;QACQ,uBAAuB;QACvB,iBAAiB;QACjB,uBAAuB;QACvB,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;CAC1B;AACD;MACM,uBAAuB;MACvB,eAAe;MACf,oBAAoB;MACpB,aAAa;MACb,oBAAoB;MACpB,+BAA+B;MAC/B,oBAAoB;MACpB,iBAAiB;CACtB;AACD;QACQ,wBAAwB;WACrB,qBAAqB;gBAChB,gBAAgB;CAC/B;AACD;UACU,gBAAgB;UAChB,eAAe;CACxB;AACD;UACU,gBAAgB;UAChB,YAAY;UACZ,iBAAiB;CAC1B;AACD;QACQ,mBAAmB;CAC1B;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,+BAA+B;QACvC,0BAA0B;YACtB,uBAAuB;gBACnB,oBAAoB;QAC5B,gBAAgB;CACvB;AACD;UACU,iBAAiB;CAC1B;AACD;UACU,iBAAiB;UACjB,gBAAgB;CACzB;AACD;UACU,0BAA0B;UAC1B,gBAAgB;UAChB,iBAAiB;CAC1B;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,oBAAoB;CACnC;AACD;QACQ,gBAAgB;QAChB,0BAA0B;QAC1B,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;CACzB;AACD;QACQ,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;CACxB;AACD;UACU,aAAa;CACtB;AACD;QACQ,kBAAkB;QAClB,oBAAoB;QACpB,0BAA0B;CACjC;CACA","file":"WebformList.vue","sourcesContent":["\ntable[data-v-663ff876] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-663ff876] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-663ff876] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-663ff876] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-663ff876] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-663ff876] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr[data-v-663ff876]:hover {\n      background: #e3e7e8 !important;\n}\ntable tbody tr[data-v-663ff876]:nth-of-type(even) {\n      background: #fcfcfc;\n}\ntable tbody tr td[data-v-663ff876] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-663ff876] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-663ff876] {\n          color: #ccc;\n}\ntable .border-R[data-v-663ff876] {\n    border-right: 1px solid #ccc;\n}\ntable .service-area[data-v-663ff876] {\n    text-align: left;\n    color: #333;\n    font-weight: 600;\n}\ntable .check-items i[data-v-663ff876] {\n    font-size: 21px;\n    color: #0fda4e;\n    /* &.fa-check-circle{ color: #0fda4e; }\r\n    &.fa-square{ color: #94b0d0; } */\n}\ntable a[data-v-663ff876] {\n    cursor: pointer;\n}\n.sticky[data-v-663ff876] {\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n.loading[data-v-663ff876] {\n  padding: 40px;\n  font-size: 38px;\n  text-align: center;\n  color: #aaa;\n}\n.loading i[data-v-663ff876] {\n    margin-right: 10px;\n}\n.slide-down-enter-active[data-v-663ff876], .slide-down-leave-active[data-v-663ff876] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-663ff876], .slide-down-leave-to[data-v-663ff876] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.loading[data-v-663ff876] {\n    font-size: 21px;\n}\n.cards[data-v-663ff876] {\n    padding-bottom: 100px;\n}\n.cards .webform[data-v-663ff876] {\n      -webkit-column-count: 2;\n         -moz-column-count: 2;\n              column-count: 2;\n      padding: 15px 20px;\n}\n.cards .webform .webform-list[data-v-663ff876] {\n        border: 1px solid #ccc;\n        padding: 5px 8px;\n        background-color: #fff;\n        font-weight: 900;\n        font-size: 14px;\n        margin-bottom: 5px;\n}\n.cards .card[data-v-663ff876] {\n      border: 1px solid #ccc;\n      margin: 0 10px;\n      margin-bottom: 15px;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n      font-weight: 700;\n}\n.cards .card .checked-items[data-v-663ff876] {\n        -webkit-column-count: 2;\n           -moz-column-count: 2;\n                column-count: 2;\n}\n.cards .card .checked-items .check-items i[data-v-663ff876] {\n          font-size: 12px;\n          color: #0fda4e;\n}\n.cards .card .checked-items .check-items span[data-v-663ff876] {\n          font-size: 14px;\n          color: #333;\n          font-weight: 100;\n}\n.cards .card > div[data-v-663ff876] {\n        margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-663ff876] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        font-size: 16px;\n}\n.cards .card .card-header .name[data-v-663ff876] {\n          font-weight: 900;\n}\n.cards .card .card-header .amount[data-v-663ff876] {\n          margin-left: 5px;\n          font-size: 14px;\n}\n.cards .card .card-header .status[data-v-663ff876] {\n          text-transform: uppercase;\n          font-size: 12px;\n          font-weight: 900;\n}\n.cards .card .title[data-v-663ff876] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n}\n.cards .card .label[data-v-663ff876] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards .card .value[data-v-663ff876] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards .card .value i[data-v-663ff876] {\n          opacity: 0.3;\n}\n.cards .card .edit[data-v-663ff876] {\n        text-align: right;\n        margin-bottom: 10px;\n        text-transform: uppercase;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isMobile)?_c('div',[(_vm.sticky)?_c('table',{staticClass:"sticky"},[_c('thead',[_c('tr',[_c('th',{staticClass:"border-R",style:({ width: _vm.dimension.tableSAG + 'px' }),attrs:{"rowspan":"2"}},[_vm._v("Service Area Geofences")]),_vm._v(" "),_c('th',{style:({ width: _vm.dimension.tableWN + 'px' }),attrs:{"colspan":_vm.webforms.length}},[_vm._v("Webform Name")])]),_vm._v(" "),_c('tr',_vm._l((_vm.webforms),function(webform,index){return _c('th',{style:({ width: _vm.dimension.webForms['tableWF' + index] + 'px' })},[_c('a',{on:{"click":function($event){return _vm.editWebform(webform.id)}}},[_vm._v(_vm._s(webform.name))])])}),0)])]):_vm._e(),_vm._v(" "),(!_vm.webformLoading && !_vm.serviceAreaLoading && _vm.webformIDs.length === 0)?_c('table',[_c('thead',[_c('tr',[_c('th',{ref:"tableSAG",staticClass:"border-R",attrs:{"rowspan":"2"}},[_vm._v("Service Area Geofences")]),_vm._v(" "),_c('th',{ref:"tableWN",attrs:{"colspan":_vm.webforms.length}},[_vm._v("Webform Name")])]),_vm._v(" "),_c('tr',_vm._l((_vm.webforms),function(webform,index){return _c('th',{ref:'tableWF' + index,refInFor:true,attrs:{"id":'tableWF' + index}},[_c('a',{on:{"click":function($event){return _vm.editWebform(webform.id)}}},[_vm._v(_vm._s(webform.name))])])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.serviceArea),function(service){return _c('tr',[_c('td',{staticClass:"service-area border-R"},[_vm._v(_vm._s(service.name))]),_vm._v(" "),_vm._l((_vm.webforms),function(webform){return _c('td',{key:webform.id,staticClass:"check-items"},[(_vm.isChecked(service, webform))?_c('i',{staticClass:"fas fa-check-circle fa-2x"}):_vm._e()])})],2)}),0)]):_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n      Getting webform data...\n    ")])]):_c('div',[(!_vm.webformLoading && !_vm.serviceAreaLoading && _vm.webformIDs.length === 0)?_c('div',{staticClass:"cards"},[_c('div',{staticClass:"webform"},_vm._l((_vm.webforms),function(webform,index){return _c('div',{key:index,ref:'tableWF' + index,refInFor:true,attrs:{"id":'tableWF' + index}},[_c('a',{on:{"click":function($event){return _vm.editWebform(webform.id)}}},[_c('div',{staticClass:"webform-list"},[_vm._v("\n              "+_vm._s(webform.name)+"\n            ")])])])}),0),_vm._v(" "),_vm._l((_vm.serviceArea),function(service){return _c('div',{key:service.id,staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n          "+_vm._s(service.name)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"checked-items"},_vm._l((_vm.webforms),function(webform){return _c('div',{key:webform.id,staticClass:"check-items"},[(_vm.isChecked(service, webform))?_c('div',[_c('i',{staticClass:"fas fa-check-circle fa-2x"}),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(webform.name))])]):_vm._e()])}),0)])})],2):_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n      Getting webform data...\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WebformAdd_vue__ = __webpack_require__(394);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a59d0f3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WebformAdd_vue__ = __webpack_require__(1095);
function injectStyle (ssrContext) {
  __webpack_require__(1093)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a59d0f3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WebformAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a59d0f3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WebformAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1094);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("b77202ce", content, true, {});

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.op--modal-container[data-v-2a59d0f3] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-2a59d0f3] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-2a59d0f3] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-2a59d0f3] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.row-padding[data-v-2a59d0f3] {\n  padding: 2px 30px;\n}\n.webform[data-v-2a59d0f3] {\n  background: #fff;\n  width: 100%;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n.heading[data-v-2a59d0f3] {\n  background: #333;\n  color: #fff;\n  font-weight: 600;\n  font-size: 21px;\n  padding: 10px 20px;\n  margin-bottom: 20px;\n}\n.data-field[data-v-2a59d0f3] {\n  position: relative;\n  margin-bottom: 10px;\n}\n.data-field .label[data-v-2a59d0f3] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 130%;\n    margin-bottom: 1px;\n}\n.data-field .label.has-error[data-v-2a59d0f3] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-2a59d0f3] {\n    margin: 1px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-2a59d0f3] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-2a59d0f3]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-2a59d0f3] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.service-area-label[data-v-2a59d0f3] {\n  font-weight: 600;\n  color: #444;\n  padding-bottom: 3px;\n  font-size: 14px;\n  border-bottom: 1px solid #ddd;\n  margin: 20px 30px 10px;\n}\nul[data-v-2a59d0f3] {\n  list-style: none;\n  padding: 0 30px;\n  width: 100%;\n  text-align: left;\n  -webkit-column-count: 4;\n  /* Chrome, Safari, Opera */\n  -moz-column-count: 4;\n  /* Firefox */\n  column-count: 4;\n}\nul.one[data-v-2a59d0f3] {\n    -webkit-column-count: 1;\n    /* Chrome, Safari, Opera */\n    -moz-column-count: 1;\n    /* Firefox */\n    column-count: 1;\n}\nul li[data-v-2a59d0f3] {\n    display: block;\n    font-size: 14px;\n    padding: 4px 0;\n    cursor: pointer;\n    color: #555;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\nul li i[data-v-2a59d0f3] {\n      margin-right: 5px;\n      color: #aaa;\n      font-size: 15px;\n}\nul li[data-v-2a59d0f3]:hover, ul li:hover i[data-v-2a59d0f3], ul li.checked i[data-v-2a59d0f3] {\n      color: #528cce;\n}\nul li.disabled[data-v-2a59d0f3] {\n      opacity: .4;\n      cursor: default;\n}\n.geofence-error[data-v-2a59d0f3] {\n  margin: 0 30px 20px;\n  font-size: 11px;\n  line-height: 1.6;\n  color: #f20d0d;\n  font-style: italic;\n  display: block;\n}\n.error[data-v-2a59d0f3]:not(.button) {\n  padding: 5px;\n  margin: 0 30px 20px;\n  display: block;\n  font-size: 14px;\n  border: 1px solid #ff5b36;\n  color: #ff5b36;\n  font-style: italic;\n}\n.confirm-delete[data-v-2a59d0f3] {\n  width: 400px;\n  background: #fff;\n  margin: 0 auto;\n  padding: 20px;\n  border-radius: 3px;\n  text-align: center;\n  color: #444;\n  font-weight: 600;\n}\n.confirm-delete span[data-v-2a59d0f3] {\n    display: block;\n    margin-bottom: 15px;\n}\n.confirm-delete .button[data-v-2a59d0f3] {\n    min-width: 100px;\n    margin: 0 5px;\n}\n.fixed-footer[data-v-2a59d0f3] {\n  width: 100%;\n  background: #f3f3f3;\n  border-top: 1px solid #ccc;\n  padding: 6px 10px;\n  text-align: right;\n  margin-top: 30px;\n}\n.fixed-footer .delete[data-v-2a59d0f3] {\n    float: left;\n}\n.fixed-footer .button[data-v-2a59d0f3] {\n    min-width: 120px;\n    margin: 0 5px;\n}\n@media only screen and (max-width: 430px) {\nul[data-v-2a59d0f3] {\n    -webkit-column-count: 1;\n       -moz-column-count: 1;\n            column-count: 1;\n}\n.fixed-footer[data-v-2a59d0f3] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n}\n.fixed-footer .button[data-v-2a59d0f3] {\n      min-width: -webkit-fit-content;\n      min-width: -moz-fit-content;\n      min-width: fit-content;\n      width: 100%;\n}\n.op--modal-container[data-v-2a59d0f3] {\n    display: block;\n}\n.op--modal-container.hide[data-v-2a59d0f3] {\n      display: none;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Brands/WebformAdd.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;CAChB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;CACrB;AACD;EACE,mBAAmB;EACnB,oBAAoB;CACrB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,8BAA8B;EAC9B,uBAAuB;CACxB;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,2BAA2B;EAC3B,qBAAqB;EACrB,aAAa;EACb,gBAAgB;CACjB;AACD;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,qBAAqB;IACrB,aAAa;IACb,gBAAgB;CACnB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,wBAAwB;IACxB,oBAAoB;CACvB;AACD;MACM,kBAAkB;MAClB,YAAY;MACZ,gBAAgB;CACrB;AACD;MACM,eAAe;CACpB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,eAAe;CAChB;AACD;EACE,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;CACpB;AACD;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;CAClB;AACD;IACI,eAAe;IACf,oBAAoB;CACvB;AACD;IACI,iBAAiB;IACjB,cAAc;CACjB;AACD;EACE,YAAY;EACZ,oBAAoB;EACpB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;CAClB;AACD;IACI,YAAY;CACf;AACD;IACI,iBAAiB;IACjB,cAAc;CACjB;AACD;AACA;IACI,wBAAwB;OACrB,qBAAqB;YAChB,gBAAgB;CAC3B;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,YAAY;CACf;AACD;MACM,+BAA+B;MAC/B,4BAA4B;MAC5B,uBAAuB;MACvB,YAAY;CACjB;AACD;IACI,eAAe;CAClB;AACD;MACM,cAAc;CACnB;CACA","file":"WebformAdd.vue","sourcesContent":["\n.op--modal-container[data-v-2a59d0f3] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-2a59d0f3] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-2a59d0f3] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-2a59d0f3] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.row-padding[data-v-2a59d0f3] {\n  padding: 2px 30px;\n}\n.webform[data-v-2a59d0f3] {\n  background: #fff;\n  width: 100%;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n.heading[data-v-2a59d0f3] {\n  background: #333;\n  color: #fff;\n  font-weight: 600;\n  font-size: 21px;\n  padding: 10px 20px;\n  margin-bottom: 20px;\n}\n.data-field[data-v-2a59d0f3] {\n  position: relative;\n  margin-bottom: 10px;\n}\n.data-field .label[data-v-2a59d0f3] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 130%;\n    margin-bottom: 1px;\n}\n.data-field .label.has-error[data-v-2a59d0f3] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-2a59d0f3] {\n    margin: 1px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-2a59d0f3] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-2a59d0f3]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-2a59d0f3] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.service-area-label[data-v-2a59d0f3] {\n  font-weight: 600;\n  color: #444;\n  padding-bottom: 3px;\n  font-size: 14px;\n  border-bottom: 1px solid #ddd;\n  margin: 20px 30px 10px;\n}\nul[data-v-2a59d0f3] {\n  list-style: none;\n  padding: 0 30px;\n  width: 100%;\n  text-align: left;\n  -webkit-column-count: 4;\n  /* Chrome, Safari, Opera */\n  -moz-column-count: 4;\n  /* Firefox */\n  column-count: 4;\n}\nul.one[data-v-2a59d0f3] {\n    -webkit-column-count: 1;\n    /* Chrome, Safari, Opera */\n    -moz-column-count: 1;\n    /* Firefox */\n    column-count: 1;\n}\nul li[data-v-2a59d0f3] {\n    display: block;\n    font-size: 14px;\n    padding: 4px 0;\n    cursor: pointer;\n    color: #555;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\nul li i[data-v-2a59d0f3] {\n      margin-right: 5px;\n      color: #aaa;\n      font-size: 15px;\n}\nul li[data-v-2a59d0f3]:hover, ul li:hover i[data-v-2a59d0f3], ul li.checked i[data-v-2a59d0f3] {\n      color: #528cce;\n}\nul li.disabled[data-v-2a59d0f3] {\n      opacity: .4;\n      cursor: default;\n}\n.geofence-error[data-v-2a59d0f3] {\n  margin: 0 30px 20px;\n  font-size: 11px;\n  line-height: 1.6;\n  color: #f20d0d;\n  font-style: italic;\n  display: block;\n}\n.error[data-v-2a59d0f3]:not(.button) {\n  padding: 5px;\n  margin: 0 30px 20px;\n  display: block;\n  font-size: 14px;\n  border: 1px solid #ff5b36;\n  color: #ff5b36;\n  font-style: italic;\n}\n.confirm-delete[data-v-2a59d0f3] {\n  width: 400px;\n  background: #fff;\n  margin: 0 auto;\n  padding: 20px;\n  border-radius: 3px;\n  text-align: center;\n  color: #444;\n  font-weight: 600;\n}\n.confirm-delete span[data-v-2a59d0f3] {\n    display: block;\n    margin-bottom: 15px;\n}\n.confirm-delete .button[data-v-2a59d0f3] {\n    min-width: 100px;\n    margin: 0 5px;\n}\n.fixed-footer[data-v-2a59d0f3] {\n  width: 100%;\n  background: #f3f3f3;\n  border-top: 1px solid #ccc;\n  padding: 6px 10px;\n  text-align: right;\n  margin-top: 30px;\n}\n.fixed-footer .delete[data-v-2a59d0f3] {\n    float: left;\n}\n.fixed-footer .button[data-v-2a59d0f3] {\n    min-width: 120px;\n    margin: 0 5px;\n}\n@media only screen and (max-width: 430px) {\nul[data-v-2a59d0f3] {\n    -webkit-column-count: 1;\n       -moz-column-count: 1;\n            column-count: 1;\n}\n.fixed-footer[data-v-2a59d0f3] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n}\n.fixed-footer .button[data-v-2a59d0f3] {\n      min-width: -webkit-fit-content;\n      min-width: -moz-fit-content;\n      min-width: fit-content;\n      width: 100%;\n}\n.op--modal-container[data-v-2a59d0f3] {\n    display: block;\n}\n.op--modal-container.hide[data-v-2a59d0f3] {\n      display: none;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'op--modal-container':true, 'hide':!_vm.show},on:{"click":_vm.close}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content",attrs:{"id":"addWebform"}},[_c('div',{staticClass:"webform",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"heading"},[(_vm.editId)?_c('span',[_vm._v("Edit Webform")]):_c('span',[_vm._v("Add Webform")])]),_vm._v(" "),(!!_vm.error)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"small-12 columns padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Webform")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.webform),expression:"webform"}],class:{'input':true, 'has-error':!!_vm.errorMsg.name},attrs:{"type":"text"},domProps:{"value":(_vm.webform)},on:{"input":function($event){if($event.target.composing){ return; }_vm.webform=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.name))])])])]),_vm._v(" "),_c('div',{staticClass:"service-area-label"},[_vm._v("Service Area Geofences")]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"small-12 columns padding-R"},[_c('div',{staticClass:"data-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterInput),expression:"filterInput"}],staticClass:"input",attrs:{"type":"text","placeholder":"Search service geofence"},domProps:{"value":(_vm.filterInput)},on:{"keyup":_vm.filter,"input":function($event){if($event.target.composing){ return; }_vm.filterInput=$event.target.value}}})])])]),_vm._v(" "),_c('span',{staticClass:"error-msg geofence-error"},[_vm._v(_vm._s(_vm.errorMsg.geofence))]),_vm._v(" "),_c('ul',{class:{'one':_vm.serviceArea.length === 1}},_vm._l((_vm.serviceArea),function(data){return _c('li',{class:{'checked':_vm.isChecked(data.id), 'disabled':_vm.submitLoading},on:{"click":function($event){return _vm.toggle(data.id)}}},[(_vm.isChecked(data.id))?_c('i',{staticClass:"fas fa-check-square"}):_c('i',{staticClass:"far fa-square"}),_vm._v("\n            "+_vm._s(data.name)+"\n          ")])}),0),_vm._v(" "),_c('div',{staticClass:"fixed-footer"},[(_vm.editId)?_c('div',{class:{'button cta small error delete':true, 'disabled':_vm.submitLoading},on:{"click":function($event){_vm.showConfirm = true}}},[_vm._v("DELETE")]):_vm._e(),_vm._v(" "),_c('div',{class:{'button cta small warning':true, 'disabled':_vm.submitLoading},on:{"click":_vm.close}},[_vm._v("CANCEL")]),_vm._v(" "),_c('div',{class:{'button cta small':true, 'disabled':_vm.submitLoading},on:{"click":_vm.submitWebform}},[(_vm.editId)?_c('span',[_vm._v("SAVE")]):_c('span',[_vm._v("ADD")])])])]),_vm._v(" "),_c('div',{class:{'op--modal-container':true, 'hide':!_vm.showConfirm},on:{"click":_vm.closeConfirmation}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content"},[_c('div',{staticClass:"confirm-delete",on:{"click":function($event){$event.stopPropagation();}}},[_c('span',[_vm._v("Are you sure you want to delete this webform?")]),_vm._v(" "),_c('div',{class:{'button cta warning':true, 'disabled': _vm.submitLoading},on:{"click":_vm.closeConfirmation}},[_vm._v("No")]),_vm._v(" "),_c('div',{class:{'button cta success':true, 'disabled': _vm.submitLoading},on:{"click":_vm.deleteWebform}},[_vm._v("YES")])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"heading"},[_vm._v("Brands")]),_vm._v(" "),_c('div',{staticClass:"navs row"},[_c('div',{staticClass:"small-10 columns"},[_c('ul',[_c('li',{class:{'active':_vm.tab === 0},on:{"click":function($event){_vm.tab = 0}}},[_vm._v("WEBFORMS")]),_vm._v(" "),_c('li',{class:{'active':_vm.tab === 1},on:{"click":function($event){_vm.tab = 1}}},[_vm._v("BRANDS")])])]),_vm._v(" "),_c('div',{staticClass:"small-2 columns add-form"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tab === 0),expression:"tab === 0"}],class:{'button cta small success':true, 'disabled':_vm.webformLoading || _vm.serviceAreaLoading},on:{"click":_vm.showForm}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "),_c('span',[_vm._v("Add Webform")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tab === 1),expression:"tab === 1"}],staticClass:"button cta small success",on:{"click":_vm.showForm}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "),_c('span',[_vm._v("Add Brand")])])])]),_vm._v(" "),_c('webform-list',{directives:[{name:"show",rawName:"v-show",value:(_vm.tab === 0),expression:"tab === 0"}],attrs:{"isMobile":_vm.isMobile}}),_vm._v(" "),_c('brand-list',{directives:[{name:"show",rawName:"v-show",value:(_vm.tab === 1),expression:"tab === 1"}],attrs:{"isMobile":_vm.isMobile}}),_vm._v(" "),_c('brand-add'),_vm._v(" "),_c('webform-add')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(395);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59751164_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1144);
function injectStyle (ssrContext) {
  __webpack_require__(1098)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59751164"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59751164_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1099);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("42a3787b", content, true, {});

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.heading[data-v-59751164] {\n  height: 50px;\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  padding: 10px 0;\n}\n.heading .switch-call[data-v-59751164] {\n    display: inline;\n}\n.heading .cons-name[data-v-59751164] {\n    padding: 0 5px 0 15px;\n}\n.heading .stripe-link[data-v-59751164] {\n    display: inline-block;\n    margin-right: 20px;\n}\n.heading select[data-v-59751164] {\n    width: auto;\n    float: right;\n    font-size: 16px;\n    margin-top: 5px;\n    margin-right: 40px;\n}\n.call[data-v-59751164] {\n  float: right;\n  margin-right: 10px;\n  text-transform: uppercase;\n}\n.call .fa[data-v-59751164] {\n    margin-right: 5px;\n}\n.body[data-v-59751164] {\n  padding: 20px;\n}\n.switch[data-v-59751164] {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  margin-top: 2px;\n}\n.switch .slider[data-v-59751164] {\n    position: relative;\n    display: inline-block;\n    width: 50px;\n    height: 26px;\n    border-radius: 20px;\n    background: #ccc;\n    position: relative;\n    cursor: pointer;\n    -webkit-transition: all .25s ease-in-out;\n    transition: all .25s ease-in-out;\n}\n.switch .slider.disabled[data-v-59751164] {\n      opacity: .4;\n}\n.switch .slider[data-v-59751164]:before {\n      content: '';\n      position: absolute;\n      top: 2px;\n      left: 3px;\n      width: 21px;\n      height: 21px;\n      border-radius: 50%;\n      background: #fff;\n      -webkit-transition: all .25s ease-in-out;\n      transition: all .25s ease-in-out;\n      -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n}\n.switch .slider.active[data-v-59751164] {\n      background: #57d1b7;\n}\n.switch .slider.active[data-v-59751164]:before {\n        left: 25px;\n}\n.switch .label[data-v-59751164] {\n    display: inline-block;\n    vertical-align: 8px;\n    margin-left: 5px;\n    font-size: 14px;\n    color: #555;\n    text-transform: uppercase;\n}\n.call[data-v-59751164] {\n  float: right;\n  margin-right: 10px;\n  text-transform: uppercase;\n}\n.call .fa[data-v-59751164] {\n    margin-right: 5px;\n}\n.left-panel[data-v-59751164] {\n  position: fixed;\n  z-index: 2;\n  left: 0;\n  top: 0;\n  width: 30%;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #F4F8F9;\n  overflow-y: auto;\n  padding-bottom: 60px;\n}\n.left-panel .heading[data-v-59751164] {\n    padding-left: 50px;\n}\n.right-panel[data-v-59751164] {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  top: 0;\n  width: 70%;\n  height: 100%;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #d5d5d5;\n  overflow-y: auto;\n}\n.right-panel .heading[data-v-59751164] {\n    font-size: 24px;\n    padding: 10px 20px;\n}\n.right-panel .tab[data-v-59751164] {\n    background: #d5d5d5;\n}\n.right-panel .tab .active[data-v-59751164] {\n      background: #ededed;\n}\n.right-panel .tab-contents[data-v-59751164] {\n    background: #ededed;\n}\n.tab[data-v-59751164] {\n  list-style: none;\n  padding: 0;\n  margin: 15px 0 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  z-index: 2;\n}\n.tab li[data-v-59751164] {\n    color: #0D79F2;\n    padding: 15px 25px;\n    font-size: 14px;\n    font-weight: 600;\n    text-align: center;\n    display: inline-block;\n    text-transform: uppercase;\n    cursor: pointer;\n}\n.tab li.grow[data-v-59751164] {\n      -webkit-box-flex: 100;\n          -ms-flex-positive: 100;\n              flex-grow: 100;\n}\n.tab li.active[data-v-59751164] {\n      background: #fff;\n      -webkit-box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);\n              box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);\n      border-radius: 2px 2px 0 0;\n      color: #777;\n}\n.tab-contents[data-v-59751164] {\n  background: #fff;\n  z-index: 1;\n  position: relative;\n  -webkit-box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);\n}\n.tab-contents .tab-content[data-v-59751164] {\n    padding: 20px;\n    display: none;\n}\n.tab-contents .tab-content.no-H-padding[data-v-59751164] {\n      padding: 20px 0;\n}\n.tab-contents .tab-content.active[data-v-59751164] {\n      display: block;\n}\n.fix-buttons[data-v-59751164] {\n  position: fixed;\n  z-index: 3;\n  bottom: 0;\n  left: 0;\n  padding: 10px;\n  width: 30%;\n  height: 60px;\n  background: #eee;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.fix-buttons a[data-v-59751164] {\n    margin: 0 10px 0 auto;\n}\n.fix-buttons a.right[data-v-59751164] {\n      margin-left: auto;\n}\n.modal[data-v-59751164] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.modal .modal-content[data-v-59751164] {\n    position: absolute;\n    top: 45%;\n    left: 50%;\n    width: 400px;\n    padding: 25px;\n    background: #fff;\n    text-align: center;\n    border-radius: 6px;\n    margin-left: -200px;\n    -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal.show[data-v-59751164] {\n    display: block;\n}\n.modal.show .modal-content[data-v-59751164] {\n      display: block;\n      -webkit-animation: slide-down-data-v-59751164 .3s ease-out;\n      -moz-animation: slide-down-data-v-59751164 .3s ease-out;\n}\n.logs-toggle[data-v-59751164] {\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 3;\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  text-align: center;\n  color: #777;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  border-radius: 0;\n  background-color: #F25E0D;\n  color: #fff;\n  border-bottom-left-radius: 3px;\n  -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n          box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n  -webkit-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: .5s ease;\n  transition: .5s ease;\n}\n.logs-toggle i[data-v-59751164] {\n    line-height: inherit;\n}\n.logs-toggle.on[data-v-59751164] {\n    -webkit-transform: rotate(90deg);\n    transform: rotate(90deg);\n    -webkit-transition: .5s ease;\n    transition: .5s ease;\n}\n.logs-panel[data-v-59751164] {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  top: 0;\n  width: 400px;\n  height: 100%;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #f4f8f9;\n  -webkit-transition: all .6s ease;\n  transition: all .6s ease;\n}\n.logs-panel.hide[data-v-59751164] {\n    right: -400px;\n    -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n            box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n}\n.logs-panel .heading[data-v-59751164] {\n    font-size: 24px;\n    padding: 10px 20px;\n    margin-bottom: 7px;\n}\n@-webkit-keyframes slide-down-data-v-59751164 {\n0% {\n    opacity: 0;\n    -webkit-transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n}\n}\n.toggle-mobile[data-v-59751164] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.left-panel[data-v-59751164] {\n    width: 100%;\n}\n.left-panel .heading .switch-call[data-v-59751164] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n}\n.left-panel .heading .switch[data-v-59751164] {\n      margin-top: 3px;\n      margin-left: 15px;\n}\n.left-panel .heading .call[data-v-59751164] {\n      margin-right: 30%;\n}\n.left-panel .body[data-v-59751164] {\n      margin-top: 12px;\n      padding-bottom: 100px;\n}\n.left-panel .fix-buttons[data-v-59751164] {\n      width: 100%;\n}\n.left-panel .fix-buttons .button[data-v-59751164] {\n        width: 50%;\n        margin: 0 auto;\n}\n.toggle-mobile[data-v-59751164] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.right-panel[data-v-59751164] {\n    width: 100%;\n    z-index: 1;\n    top: 100%;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n}\n.right-panel.mobile-right-panel[data-v-59751164] {\n      top: 0;\n      z-index: 2;\n}\n.right-panel.mobile-right-panel .tab[data-v-59751164] {\n        margin-top: 70px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        overflow-x: scroll;\n}\n.right-panel.mobile-right-panel .tab li[data-v-59751164] {\n          font-size: 13px;\n}\n.right-panel.mobile-right-panel .tab-contents[data-v-59751164] {\n        width: 100%;\n}\n.right-panel.mobile-right-panel .tab-contents .tab-content[data-v-59751164] {\n          padding-bottom: 100px;\n}\n.right-panel.mobile-right-panel .tab-contents .tab-content.history-panel[data-v-59751164] {\n            padding: 0;\n            padding-top: 20px;\n            padding-bottom: 60px;\n}\n.right-panel.mobile-right-panel .tab-contents .fixed-footer[data-v-59751164] {\n          width: 100%;\n          bottom: 45px;\n          background: #fff;\n          color: #000;\n          border-top: 1px solid #aaa;\n}\n.logs-toggle[data-v-59751164] {\n    z-index: 13;\n}\n.logs-panel[data-v-59751164] {\n    width: 100%;\n    z-index: 12;\n}\n.logs-panel.hide[data-v-59751164] {\n      right: -430px;\n}\n.fix-buttons[data-v-59751164] {\n    width: 100%;\n    bottom: 45px;\n}\n.fix-buttons a[data-v-59751164] {\n      margin: 0 auto;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Consumer/index.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;CACjB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,sBAAsB;CACzB;AACD;IACI,sBAAsB;IACtB,mBAAmB;CACtB;AACD;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;CACtB;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;CAC3B;AACD;IACI,kBAAkB;CACrB;AACD;EACE,cAAc;CACf;AACD;EACE,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;CACjB;AACD;IACI,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,iCAAiC;CACpC;AACD;MACM,YAAY;CACjB;AACD;MACM,YAAY;MACZ,mBAAmB;MACnB,SAAS;MACT,UAAU;MACV,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,iBAAiB;MACjB,yCAAyC;MACzC,iCAAiC;MACjC,oDAAoD;cAC5C,4CAA4C;CACzD;AACD;MACM,oBAAoB;CACzB;AACD;QACQ,WAAW;CAClB;AACD;IACI,sBAAsB;IACtB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;CAC7B;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;CAC3B;AACD;IACI,kBAAkB;CACrB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,OAAO;EACP,WAAW;EACX,aAAa;EACb,iDAAiD;UACzC,yCAAyC;EACjD,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;CACtB;AACD;IACI,mBAAmB;CACtB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;EAClD,0BAA0B;EAC1B,iBAAiB;CAClB;AACD;IACI,gBAAgB;IAChB,mBAAmB;CACtB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,oBAAoB;CACzB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,WAAW;CACZ;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;CACnB;AACD;MACM,sBAAsB;UAClB,uBAAuB;cACnB,eAAe;CAC5B;AACD;MACM,iBAAiB;MACjB,kDAAkD;cAC1C,0CAA0C;MAClD,2BAA2B;MAC3B,YAAY;CACjB;AACD;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;CACpD;AACD;IACI,cAAc;IACd,cAAc;CACjB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,eAAe;CACpB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,QAAQ;EACR,cAAc;EACd,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,+BAA+B;UACvB,uBAAuB;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,sBAAsB;CACzB;AACD;MACM,kBAAkB;CACvB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,YAAY;CACb;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,uDAAuD;YAC/C,+CAA+C;IACvD,cAAc;CACjB;AACD;IACI,eAAe;CAClB;AACD;MACM,eAAe;MACf,2DAA2D;MAC3D,wDAAwD;CAC7D;AACD;EACE,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;EACjB,0BAA0B;EAC1B,YAAY;EACZ,+BAA+B;EAC/B,mDAAmD;UAC3C,2CAA2C;EACnD,gBAAgB;EAChB,gCAAgC;EAChC,wBAAwB;EACxB,6BAA6B;EAC7B,qBAAqB;CACtB;AACD;IACI,qBAAqB;CACxB;AACD;IACI,iCAAiC;IACjC,yBAAyB;IACzB,6BAA6B;IAC7B,qBAAqB;CACxB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;EAClD,0BAA0B;EAC1B,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;IACI,cAAc;IACd,gDAAgD;YACxC,wCAAwC;CACnD;AACD;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;CACtB;AACD;AACA;IACI,WAAW;IACX,oCAAoC;CACvC;AACD;IACI,WAAW;IACX,iCAAiC;CACpC;CACA;AACD;EACE,cAAc;CACf;AACD;AACA;IACI,YAAY;CACf;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;CAC5C;AACD;MACM,gBAAgB;MAChB,kBAAkB;CACvB;AACD;MACM,kBAAkB;CACvB;AACD;MACM,iBAAiB;MACjB,sBAAsB;CAC3B;AACD;MACM,YAAY;CACjB;AACD;QACQ,WAAW;QACX,eAAe;CACtB;AACD;IACI,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;IACrB,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;CACpB;AACD;IACI,YAAY;IACZ,WAAW;IACX,UAAU;IACV,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,OAAO;MACP,WAAW;CAChB;AACD;QACQ,iBAAiB;QACjB,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,mBAAmB;CAC1B;AACD;UACU,gBAAgB;CACzB;AACD;QACQ,YAAY;CACnB;AACD;UACU,sBAAsB;CAC/B;AACD;YACY,WAAW;YACX,kBAAkB;YAClB,qBAAqB;CAChC;AACD;UACU,YAAY;UACZ,aAAa;UACb,iBAAiB;UACjB,YAAY;UACZ,2BAA2B;CACpC;AACD;IACI,YAAY;CACf;AACD;IACI,YAAY;IACZ,YAAY;CACf;AACD;MACM,cAAc;CACnB;AACD;IACI,YAAY;IACZ,aAAa;CAChB;AACD;MACM,eAAe;CACpB;CACA","file":"index.vue","sourcesContent":["\n.heading[data-v-59751164] {\n  height: 50px;\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  padding: 10px 0;\n}\n.heading .switch-call[data-v-59751164] {\n    display: inline;\n}\n.heading .cons-name[data-v-59751164] {\n    padding: 0 5px 0 15px;\n}\n.heading .stripe-link[data-v-59751164] {\n    display: inline-block;\n    margin-right: 20px;\n}\n.heading select[data-v-59751164] {\n    width: auto;\n    float: right;\n    font-size: 16px;\n    margin-top: 5px;\n    margin-right: 40px;\n}\n.call[data-v-59751164] {\n  float: right;\n  margin-right: 10px;\n  text-transform: uppercase;\n}\n.call .fa[data-v-59751164] {\n    margin-right: 5px;\n}\n.body[data-v-59751164] {\n  padding: 20px;\n}\n.switch[data-v-59751164] {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  margin-top: 2px;\n}\n.switch .slider[data-v-59751164] {\n    position: relative;\n    display: inline-block;\n    width: 50px;\n    height: 26px;\n    border-radius: 20px;\n    background: #ccc;\n    position: relative;\n    cursor: pointer;\n    -webkit-transition: all .25s ease-in-out;\n    transition: all .25s ease-in-out;\n}\n.switch .slider.disabled[data-v-59751164] {\n      opacity: .4;\n}\n.switch .slider[data-v-59751164]:before {\n      content: '';\n      position: absolute;\n      top: 2px;\n      left: 3px;\n      width: 21px;\n      height: 21px;\n      border-radius: 50%;\n      background: #fff;\n      -webkit-transition: all .25s ease-in-out;\n      transition: all .25s ease-in-out;\n      -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n}\n.switch .slider.active[data-v-59751164] {\n      background: #57d1b7;\n}\n.switch .slider.active[data-v-59751164]:before {\n        left: 25px;\n}\n.switch .label[data-v-59751164] {\n    display: inline-block;\n    vertical-align: 8px;\n    margin-left: 5px;\n    font-size: 14px;\n    color: #555;\n    text-transform: uppercase;\n}\n.call[data-v-59751164] {\n  float: right;\n  margin-right: 10px;\n  text-transform: uppercase;\n}\n.call .fa[data-v-59751164] {\n    margin-right: 5px;\n}\n.left-panel[data-v-59751164] {\n  position: fixed;\n  z-index: 2;\n  left: 0;\n  top: 0;\n  width: 30%;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #F4F8F9;\n  overflow-y: auto;\n  padding-bottom: 60px;\n}\n.left-panel .heading[data-v-59751164] {\n    padding-left: 50px;\n}\n.right-panel[data-v-59751164] {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  top: 0;\n  width: 70%;\n  height: 100%;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #d5d5d5;\n  overflow-y: auto;\n}\n.right-panel .heading[data-v-59751164] {\n    font-size: 24px;\n    padding: 10px 20px;\n}\n.right-panel .tab[data-v-59751164] {\n    background: #d5d5d5;\n}\n.right-panel .tab .active[data-v-59751164] {\n      background: #ededed;\n}\n.right-panel .tab-contents[data-v-59751164] {\n    background: #ededed;\n}\n.tab[data-v-59751164] {\n  list-style: none;\n  padding: 0;\n  margin: 15px 0 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  z-index: 2;\n}\n.tab li[data-v-59751164] {\n    color: #0D79F2;\n    padding: 15px 25px;\n    font-size: 14px;\n    font-weight: 600;\n    text-align: center;\n    display: inline-block;\n    text-transform: uppercase;\n    cursor: pointer;\n}\n.tab li.grow[data-v-59751164] {\n      -webkit-box-flex: 100;\n          -ms-flex-positive: 100;\n              flex-grow: 100;\n}\n.tab li.active[data-v-59751164] {\n      background: #fff;\n      -webkit-box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);\n              box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);\n      border-radius: 2px 2px 0 0;\n      color: #777;\n}\n.tab-contents[data-v-59751164] {\n  background: #fff;\n  z-index: 1;\n  position: relative;\n  -webkit-box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);\n}\n.tab-contents .tab-content[data-v-59751164] {\n    padding: 20px;\n    display: none;\n}\n.tab-contents .tab-content.no-H-padding[data-v-59751164] {\n      padding: 20px 0;\n}\n.tab-contents .tab-content.active[data-v-59751164] {\n      display: block;\n}\n.fix-buttons[data-v-59751164] {\n  position: fixed;\n  z-index: 3;\n  bottom: 0;\n  left: 0;\n  padding: 10px;\n  width: 30%;\n  height: 60px;\n  background: #eee;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.fix-buttons a[data-v-59751164] {\n    margin: 0 10px 0 auto;\n}\n.fix-buttons a.right[data-v-59751164] {\n      margin-left: auto;\n}\n.modal[data-v-59751164] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.modal .modal-content[data-v-59751164] {\n    position: absolute;\n    top: 45%;\n    left: 50%;\n    width: 400px;\n    padding: 25px;\n    background: #fff;\n    text-align: center;\n    border-radius: 6px;\n    margin-left: -200px;\n    -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal.show[data-v-59751164] {\n    display: block;\n}\n.modal.show .modal-content[data-v-59751164] {\n      display: block;\n      -webkit-animation: slide-down-data-v-59751164 .3s ease-out;\n      -moz-animation: slide-down-data-v-59751164 .3s ease-out;\n}\n.logs-toggle[data-v-59751164] {\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 3;\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  text-align: center;\n  color: #777;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  border-radius: 0;\n  background-color: #F25E0D;\n  color: #fff;\n  border-bottom-left-radius: 3px;\n  -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n          box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n  -webkit-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: .5s ease;\n  transition: .5s ease;\n}\n.logs-toggle i[data-v-59751164] {\n    line-height: inherit;\n}\n.logs-toggle.on[data-v-59751164] {\n    -webkit-transform: rotate(90deg);\n    transform: rotate(90deg);\n    -webkit-transition: .5s ease;\n    transition: .5s ease;\n}\n.logs-panel[data-v-59751164] {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  top: 0;\n  width: 400px;\n  height: 100%;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #f4f8f9;\n  -webkit-transition: all .6s ease;\n  transition: all .6s ease;\n}\n.logs-panel.hide[data-v-59751164] {\n    right: -400px;\n    -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n            box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n}\n.logs-panel .heading[data-v-59751164] {\n    font-size: 24px;\n    padding: 10px 20px;\n    margin-bottom: 7px;\n}\n@-webkit-keyframes slide-down-data-v-59751164 {\n0% {\n    opacity: 0;\n    -webkit-transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n}\n}\n.toggle-mobile[data-v-59751164] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.left-panel[data-v-59751164] {\n    width: 100%;\n}\n.left-panel .heading .switch-call[data-v-59751164] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n}\n.left-panel .heading .switch[data-v-59751164] {\n      margin-top: 3px;\n      margin-left: 15px;\n}\n.left-panel .heading .call[data-v-59751164] {\n      margin-right: 30%;\n}\n.left-panel .body[data-v-59751164] {\n      margin-top: 12px;\n      padding-bottom: 100px;\n}\n.left-panel .fix-buttons[data-v-59751164] {\n      width: 100%;\n}\n.left-panel .fix-buttons .button[data-v-59751164] {\n        width: 50%;\n        margin: 0 auto;\n}\n.toggle-mobile[data-v-59751164] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.right-panel[data-v-59751164] {\n    width: 100%;\n    z-index: 1;\n    top: 100%;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n}\n.right-panel.mobile-right-panel[data-v-59751164] {\n      top: 0;\n      z-index: 2;\n}\n.right-panel.mobile-right-panel .tab[data-v-59751164] {\n        margin-top: 70px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        overflow-x: scroll;\n}\n.right-panel.mobile-right-panel .tab li[data-v-59751164] {\n          font-size: 13px;\n}\n.right-panel.mobile-right-panel .tab-contents[data-v-59751164] {\n        width: 100%;\n}\n.right-panel.mobile-right-panel .tab-contents .tab-content[data-v-59751164] {\n          padding-bottom: 100px;\n}\n.right-panel.mobile-right-panel .tab-contents .tab-content.history-panel[data-v-59751164] {\n            padding: 0;\n            padding-top: 20px;\n            padding-bottom: 60px;\n}\n.right-panel.mobile-right-panel .tab-contents .fixed-footer[data-v-59751164] {\n          width: 100%;\n          bottom: 45px;\n          background: #fff;\n          color: #000;\n          border-top: 1px solid #aaa;\n}\n.logs-toggle[data-v-59751164] {\n    z-index: 13;\n}\n.logs-panel[data-v-59751164] {\n    width: 100%;\n    z-index: 12;\n}\n.logs-panel.hide[data-v-59751164] {\n      right: -430px;\n}\n.fix-buttons[data-v-59751164] {\n    width: 100%;\n    bottom: 45px;\n}\n.fix-buttons a[data-v-59751164] {\n      margin: 0 auto;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(12);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountDetails_vue__ = __webpack_require__(396);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53f2fe22_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountDetails_vue__ = __webpack_require__(1107);
function injectStyle (ssrContext) {
  __webpack_require__(1102)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53f2fe22"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53f2fe22_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1103);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("6abd0e12", content, true, {});

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.collapsible[data-v-53f2fe22] {\n  margin-bottom: 5px;\n}\n.collapsible .heading[data-v-53f2fe22] {\n    color: #0D79F2;\n    margin-bottom: 2px;\n    cursor: pointer;\n    text-transform: uppercase;\n}\n.collapsible .heading i[data-v-53f2fe22] {\n      margin-right: 5px;\n}\n.collapsible .heading span[data-v-53f2fe22] {\n      font-weight: 600;\n}\n.collapsible .content[data-v-53f2fe22] {\n    margin-left: 6px;\n    padding: 5px 0 5px 15px;\n    border-left: 2px solid #ddd;\n    max-height: 800px;\n    /* define precise max-height for more smoother transition */\n    height: auto;\n    -webkit-transition: all 0.35s ease-out;\n    transition: all 0.35s ease-out;\n}\n.collapsible .content .field-row[data-v-53f2fe22] {\n      margin-bottom: 15px;\n}\n.collapsible .content .field-row[data-v-53f2fe22]:last-child {\n      margin-bottom: 0;\n}\n.collapsible.collapse .content[data-v-53f2fe22] {\n    max-height: 0;\n    padding: 0 15px;\n}\n.country-selector[data-v-53f2fe22] {\n  padding: 10px;\n  margin-top: 5px;\n  border-color: #ccc;\n  line-height: 1;\n}\n.ada[data-v-53f2fe22] {\n  color: #555;\n}\n.ada .ada-label[data-v-53f2fe22] {\n    font-weight: 500;\n}\n.field-row[data-v-53f2fe22] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.field-row .col[data-v-53f2fe22] {\n    display: inline-block;\n}\n.field-row .col20[data-v-53f2fe22] {\n    width: 20%;\n}\n.field-row .col25[data-v-53f2fe22] {\n    width: 25%;\n}\n.field-row .col40[data-v-53f2fe22] {\n    width: 40%;\n}\n.field-row .col50[data-v-53f2fe22] {\n    width: 50%;\n}\n.field-row .col60[data-v-53f2fe22] {\n    width: 60%;\n}\n.field-row .col80[data-v-53f2fe22] {\n    width: 80%;\n}\n.field-row .col100[data-v-53f2fe22] {\n    width: 100%;\n}\n.field-row .checked[data-v-53f2fe22] {\n    color: #0D79F2;\n}\n.data-field[data-v-53f2fe22] {\n  padding-right: 10px;\n  font-weight: 600;\n}\n.data-field.no-label[data-v-53f2fe22] {\n    padding-top: 17px;\n}\n.data-field .label[data-v-53f2fe22] {\n    color: #888;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .value[data-v-53f2fe22] {\n    font-size: 17px;\n    color: #555;\n    word-break: break-all;\n}\n.data-field .value .fa[data-v-53f2fe22] {\n      color: #0D79F2;\n}\n.data-field .value a[data-v-53f2fe22] {\n      text-decoration: underline;\n      cursor: pointer;\n}\n.data-field .input[data-v-53f2fe22] {\n    margin: 5px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-53f2fe22] {\n      border-color: #f20d0d;\n}\n.data-field .error-msg[data-v-53f2fe22] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.password-status[data-v-53f2fe22] {\n  position: relative;\n  overflow: hidden;\n}\n.password-status .password-message[data-v-53f2fe22] {\n    padding: 10px;\n    background: #fafafa;\n    border: 1px solid #eaeaea;\n    margin-top: 10px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    color: #555;\n}\n.password-status .password-message .fa[data-v-53f2fe22] {\n      margin-right: 5px;\n}\n.password-status .password-message .fa-times[data-v-53f2fe22] {\n      color: #F20D0D;\n}\n.password-status .password-message .fa-check[data-v-53f2fe22] {\n      color: #26d97a;\n}\n.password-status.show .password-message[data-v-53f2fe22] {\n    position: relative;\n    -webkit-animation: slide-down-data-v-53f2fe22 .3s ease-out;\n    -moz-animation: slide-down-data-v-53f2fe22 .3s ease-out;\n}\n.input-group[data-v-53f2fe22] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  position: relative;\n  margin-bottom: 0;\n}\n.input-group .input-group-label[data-v-53f2fe22] {\n    padding: 0 10px;\n    border: 1px solid #cacaca;\n    background: #f4f8f9;\n    text-align: center;\n    white-space: nowrap;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n.input-group .input-group-label .calling-code[data-v-53f2fe22] {\n      padding-right: 3px;\n      font-weight: 100;\n}\n.input-group .mobile-input[data-v-53f2fe22] {\n    border-radius: 1px;\n    border-left: 0;\n}\n.input-group.small .mobile-input[data-v-53f2fe22] {\n    padding-left: 35px;\n}\n.input-group.medium .mobile-input[data-v-53f2fe22] {\n    padding-left: 45px;\n}\n.input-group.large .mobile-input[data-v-53f2fe22] {\n    padding-left: 55px;\n}\n.input-group.xl .mobile-input[data-v-53f2fe22] {\n    padding-left: 65px;\n}\n  /* Chrome, Safari, Edge, Opera */\ninput[data-v-53f2fe22]::-webkit-outer-spin-button,\ninput[data-v-53f2fe22]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n  /* Firefox */\ninput[type=number][data-v-53f2fe22] {\n  -moz-appearance: textfield;\n}\n.country-select[data-v-53f2fe22] {\n  margin-top: 5px;\n  cursor: pointer;\n  color: #333;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.country-select[data-v-53f2fe22]:hover {\n  background-color: #e6e6e6;\n}\n.country-code[data-v-53f2fe22] {\n  position: absolute;\n  top: 16px;\n  left: 60px;\n  font-size: 16px;\n  font-weight: 100;\n}\n@-webkit-keyframes slide-down-data-v-53f2fe22 {\n0% {\n    opacity: 0;\n    -webkit-transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n}\n}\n@media only screen and (max-width: 430px) {\n.collapsible .content .field-row[data-v-53f2fe22] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    margin-bottom: 0;\n}\n.collapsible .content .field-row .col50[data-v-53f2fe22] {\n      width: 100%;\n      display: block;\n      margin-bottom: 8px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Consumer/AccountDetails.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;MACM,iBAAiB;CACtB;AACD;IACI,iBAAiB;IACjB,wBAAwB;IACxB,4BAA4B;IAC5B,kBAAkB;IAClB,4DAA4D;IAC5D,aAAa;IACb,uCAAuC;IACvC,+BAA+B;CAClC;AACD;MACM,oBAAoB;CACzB;AACD;MACM,iBAAiB;CACtB;AACD;IACI,cAAc;IACd,gBAAgB;CACnB;AACD;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;CAChB;AACD;EACE,YAAY;CACb;AACD;IACI,iBAAiB;CACpB;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,sBAAsB;CACzB;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,YAAY;CACf;AACD;IACI,eAAe;CAClB;AACD;EACE,oBAAoB;EACpB,iBAAiB;CAClB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;CACzB;AACD;MACM,eAAe;CACpB;AACD;MACM,2BAA2B;MAC3B,gBAAgB;CACrB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;EACE,mBAAmB;EACnB,iBAAiB;CAClB;AACD;IACI,cAAc;IACd,oBAAoB;IACpB,0BAA0B;IAC1B,iBAAiB;IACjB,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;CACf;AACD;MACM,kBAAkB;CACvB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,2DAA2D;IAC3D,wDAAwD;CAC3D;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;CAClB;AACD;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,uBAAuB;IACvB,oBAAoB;CACvB;AACD;MACM,mBAAmB;MACnB,iBAAiB;CACtB;AACD;IACI,mBAAmB;IACnB,eAAe;CAClB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,mBAAmB;CACtB;EACC,iCAAiC;AACnC;;EAEE,yBAAyB;EACzB,UAAU;CACX;EACC,aAAa;AACf;EACE,2BAA2B;CAC5B;AACD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;CAClB;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;CAClB;AACD;AACA;IACI,WAAW;IACX,qCAAqC;CACxC;AACD;IACI,WAAW;IACX,iCAAiC;CACpC;CACA;AACD;AACA;IACI,6BAA6B;IAC7B,8BAA8B;QAC1B,2BAA2B;YACvB,uBAAuB;IAC/B,iBAAiB;CACpB;AACD;MACM,YAAY;MACZ,eAAe;MACf,mBAAmB;CACxB;CACA","file":"AccountDetails.vue","sourcesContent":["\n.collapsible[data-v-53f2fe22] {\n  margin-bottom: 5px;\n}\n.collapsible .heading[data-v-53f2fe22] {\n    color: #0D79F2;\n    margin-bottom: 2px;\n    cursor: pointer;\n    text-transform: uppercase;\n}\n.collapsible .heading i[data-v-53f2fe22] {\n      margin-right: 5px;\n}\n.collapsible .heading span[data-v-53f2fe22] {\n      font-weight: 600;\n}\n.collapsible .content[data-v-53f2fe22] {\n    margin-left: 6px;\n    padding: 5px 0 5px 15px;\n    border-left: 2px solid #ddd;\n    max-height: 800px;\n    /* define precise max-height for more smoother transition */\n    height: auto;\n    -webkit-transition: all 0.35s ease-out;\n    transition: all 0.35s ease-out;\n}\n.collapsible .content .field-row[data-v-53f2fe22] {\n      margin-bottom: 15px;\n}\n.collapsible .content .field-row[data-v-53f2fe22]:last-child {\n      margin-bottom: 0;\n}\n.collapsible.collapse .content[data-v-53f2fe22] {\n    max-height: 0;\n    padding: 0 15px;\n}\n.country-selector[data-v-53f2fe22] {\n  padding: 10px;\n  margin-top: 5px;\n  border-color: #ccc;\n  line-height: 1;\n}\n.ada[data-v-53f2fe22] {\n  color: #555;\n}\n.ada .ada-label[data-v-53f2fe22] {\n    font-weight: 500;\n}\n.field-row[data-v-53f2fe22] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.field-row .col[data-v-53f2fe22] {\n    display: inline-block;\n}\n.field-row .col20[data-v-53f2fe22] {\n    width: 20%;\n}\n.field-row .col25[data-v-53f2fe22] {\n    width: 25%;\n}\n.field-row .col40[data-v-53f2fe22] {\n    width: 40%;\n}\n.field-row .col50[data-v-53f2fe22] {\n    width: 50%;\n}\n.field-row .col60[data-v-53f2fe22] {\n    width: 60%;\n}\n.field-row .col80[data-v-53f2fe22] {\n    width: 80%;\n}\n.field-row .col100[data-v-53f2fe22] {\n    width: 100%;\n}\n.field-row .checked[data-v-53f2fe22] {\n    color: #0D79F2;\n}\n.data-field[data-v-53f2fe22] {\n  padding-right: 10px;\n  font-weight: 600;\n}\n.data-field.no-label[data-v-53f2fe22] {\n    padding-top: 17px;\n}\n.data-field .label[data-v-53f2fe22] {\n    color: #888;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .value[data-v-53f2fe22] {\n    font-size: 17px;\n    color: #555;\n    word-break: break-all;\n}\n.data-field .value .fa[data-v-53f2fe22] {\n      color: #0D79F2;\n}\n.data-field .value a[data-v-53f2fe22] {\n      text-decoration: underline;\n      cursor: pointer;\n}\n.data-field .input[data-v-53f2fe22] {\n    margin: 5px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-53f2fe22] {\n      border-color: #f20d0d;\n}\n.data-field .error-msg[data-v-53f2fe22] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.password-status[data-v-53f2fe22] {\n  position: relative;\n  overflow: hidden;\n}\n.password-status .password-message[data-v-53f2fe22] {\n    padding: 10px;\n    background: #fafafa;\n    border: 1px solid #eaeaea;\n    margin-top: 10px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    color: #555;\n}\n.password-status .password-message .fa[data-v-53f2fe22] {\n      margin-right: 5px;\n}\n.password-status .password-message .fa-times[data-v-53f2fe22] {\n      color: #F20D0D;\n}\n.password-status .password-message .fa-check[data-v-53f2fe22] {\n      color: #26d97a;\n}\n.password-status.show .password-message[data-v-53f2fe22] {\n    position: relative;\n    -webkit-animation: slide-down-data-v-53f2fe22 .3s ease-out;\n    -moz-animation: slide-down-data-v-53f2fe22 .3s ease-out;\n}\n.input-group[data-v-53f2fe22] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  position: relative;\n  margin-bottom: 0;\n}\n.input-group .input-group-label[data-v-53f2fe22] {\n    padding: 0 10px;\n    border: 1px solid #cacaca;\n    background: #f4f8f9;\n    text-align: center;\n    white-space: nowrap;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n.input-group .input-group-label .calling-code[data-v-53f2fe22] {\n      padding-right: 3px;\n      font-weight: 100;\n}\n.input-group .mobile-input[data-v-53f2fe22] {\n    border-radius: 1px;\n    border-left: 0;\n}\n.input-group.small .mobile-input[data-v-53f2fe22] {\n    padding-left: 35px;\n}\n.input-group.medium .mobile-input[data-v-53f2fe22] {\n    padding-left: 45px;\n}\n.input-group.large .mobile-input[data-v-53f2fe22] {\n    padding-left: 55px;\n}\n.input-group.xl .mobile-input[data-v-53f2fe22] {\n    padding-left: 65px;\n}\n  /* Chrome, Safari, Edge, Opera */\ninput[data-v-53f2fe22]::-webkit-outer-spin-button,\ninput[data-v-53f2fe22]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n  /* Firefox */\ninput[type=number][data-v-53f2fe22] {\n  -moz-appearance: textfield;\n}\n.country-select[data-v-53f2fe22] {\n  margin-top: 5px;\n  cursor: pointer;\n  color: #333;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.country-select[data-v-53f2fe22]:hover {\n  background-color: #e6e6e6;\n}\n.country-code[data-v-53f2fe22] {\n  position: absolute;\n  top: 16px;\n  left: 60px;\n  font-size: 16px;\n  font-weight: 100;\n}\n@-webkit-keyframes slide-down-data-v-53f2fe22 {\n0% {\n    opacity: 0;\n    -webkit-transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n}\n}\n@media only screen and (max-width: 430px) {\n.collapsible .content .field-row[data-v-53f2fe22] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    margin-bottom: 0;\n}\n.collapsible .content .field-row .col50[data-v-53f2fe22] {\n      width: 100%;\n      display: block;\n      margin-bottom: 8px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.34
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof module === 'object' && module.exports) {
		module.exports = factory(__webpack_require__(3)); // Node
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Resolves es6 module loading issue
	if (moment.version === undefined && moment.default) {
		moment = moment.default;
	}

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.34",
		zones = {},
		links = {},
		countries = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		countries : function () {
			var zone_name = this.name;
			return Object.keys(countries).filter(function (country_code) {
				return countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Country object
	************************************/

	function Country (country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames () {
		return Object.keys(countries);
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries (data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			countries[country_code] = new Country(
				country_code,
				country_zones
			);
		}
	}

	function getCountry (name) {
		name = name.toUpperCase();
		return countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz._countries	= countries;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;
	tz.countries    = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),
/* 1105 */
/***/ (function(module, exports) {

module.exports = {"version":"2021e","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212132121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Pacific/Port_Moresby|+10|-a0|0||25e4","Antarctica/Macquarie|AEST AEDT -00|-a0 -b0 0|010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1C00 LA0 1C00|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|BMT BST AST ADT|4j.i 3j.i 40 30|010102323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28p7E.G 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293iJ xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293i0 xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Etc/GMT-11|+11|-b0|0||","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0||","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2n5c9.l cFX9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|0123232323232323212121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2xorF.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|01212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0 4q00 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|LMT -1030 -0930 -10|aD.4 au 9u a0|0123232323232323232323232323|-FSdk.U 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Chicago|US/Central","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Atikokan","America/Panama|America/Cayman","America/Panama|America/Coral_Harbour","America/Phoenix|America/Creston","America/Phoenix|US/Arizona","America/Puerto_Rico|America/Anguilla","America/Puerto_Rico|America/Antigua","America/Puerto_Rico|America/Aruba","America/Puerto_Rico|America/Blanc-Sablon","America/Puerto_Rico|America/Curacao","America/Puerto_Rico|America/Dominica","America/Puerto_Rico|America/Grenada","America/Puerto_Rico|America/Guadeloupe","America/Puerto_Rico|America/Kralendijk","America/Puerto_Rico|America/Lower_Princes","America/Puerto_Rico|America/Marigot","America/Puerto_Rico|America/Montserrat","America/Puerto_Rico|America/Port_of_Spain","America/Puerto_Rico|America/St_Barthelemy","America/Puerto_Rico|America/St_Kitts","America/Puerto_Rico|America/St_Lucia","America/Puerto_Rico|America/St_Thomas","America/Puerto_Rico|America/St_Vincent","America/Puerto_Rico|America/Tortola","America/Puerto_Rico|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|America/Nassau","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Antarctica/Syowa","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Currie","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Enderbury|Pacific/Kanton","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Antarctica/DumontDUrville","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Port_of_Spain America/Antigua","AI|America/Port_of_Spain America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Curacao America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Port_of_Spain America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Brunei","BO|America/La_Paz","BQ|America/Curacao America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver","CC|Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Curacao","CX|Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Copenhagen","DM|America/Port_of_Spain America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Port_of_Spain America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Port_of_Spain America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Port_of_Spain America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Port_of_Spain America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Port_of_Spain America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Majuro Pacific/Kwajalein","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Port_of_Spain America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas","MY|Asia/Kuala_Lumpur Asia/Kuching","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Amsterdam","NO|Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Oslo Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Curacao America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Indian/Reunion Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Port_of_Spain","TV|Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Port_of_Spain America/St_Vincent","VE|America/Caracas","VG|America/Port_of_Spain America/Tortola","VI|America/Port_of_Spain America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

exports.endianness = function () { return 'LE' };

exports.hostname = function () {
    if (typeof location !== 'undefined') {
        return location.hostname
    }
    else return '';
};

exports.loadavg = function () { return [] };

exports.uptime = function () { return 0 };

exports.freemem = function () {
    return Number.MAX_VALUE;
};

exports.totalmem = function () {
    return Number.MAX_VALUE;
};

exports.cpus = function () { return [] };

exports.type = function () { return 'Browser' };

exports.release = function () {
    if (typeof navigator !== 'undefined') {
        return navigator.appVersion;
    }
    return '';
};

exports.networkInterfaces
= exports.getNetworkInterfaces
= function () { return {} };

exports.arch = function () { return 'javascript' };

exports.platform = function () { return 'browser' };

exports.tmpdir = exports.tmpDir = function () {
    return '/tmp';
};

exports.EOL = '\n';

exports.homedir = function () {
	return '/'
};


/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{'collapsible':true, 'collapse':!_vm.contentShow.accountInfo}},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.contentShow.accountInfo = !_vm.contentShow.accountInfo}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentShow.accountInfo),expression:"contentShow.accountInfo"}],staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentShow.accountInfo),expression:"!contentShow.accountInfo"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('consumer.accountInfo.label')))])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('consumer.accountInfo.created'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.userInfo.created))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('consumer.accountInfo.referralCode'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.userInfo.referralCode))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('consumer.accountInfo.numberOfReferral'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n            "+_vm._s(_vm.totalReferrals)+"\n            "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.referralLoading),expression:"referralLoading"}],staticClass:"fa fa-circle-notch fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('a',{staticClass:"button cta small",on:{"click":_vm.emailPassword}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.passwordLoading),expression:"!passwordLoading"}]},[_vm._v(_vm._s(_vm.$t('consumer.sendResetPassword')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.passwordLoading),expression:"passwordLoading"}]},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v("\n              "+_vm._s(_vm.$t('consumer.sending'))+"\n            ")])]),_vm._v(" "),_c('div',{class:{'password-status':true, 'show':_vm.resetPasswordMessage !== ''}},[_c('div',{staticClass:"password-message"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.resetPasswordSuccess),expression:"resetPasswordSuccess"}],staticClass:"fa fa-check"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.resetPasswordSuccess),expression:"!resetPasswordSuccess"}],staticClass:"fa fa-times"}),_vm._v("\n              "+_vm._s(_vm.resetPasswordMessage)+"\n            ")])])])])])]),_vm._v(" "),_c('div',{class:{'collapsible':true, 'collapse':!_vm.contentShow.personalInfo}},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.contentShow.personalInfo = !_vm.contentShow.personalInfo}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentShow.personalInfo),expression:"contentShow.personalInfo"}],staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentShow.personalInfo),expression:"!contentShow.personalInfo"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('consumer.personalInfo.label')))])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('consumer.personalInfo.firstName'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.firstName),expression:"userInfo.firstName"}],class:{'input':true, 'has-error':!!_vm.validation.userInfo.firstName },attrs:{"type":"text"},domProps:{"value":(_vm.userInfo.firstName)},on:{"keyup":function($event){return _vm.fieldValidate('userInfo', 'firstName')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "firstName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userInfo.firstName))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('consumer.personalInfo.lastName'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.lastName),expression:"userInfo.lastName"}],class:{'input':true, 'has-error':!!_vm.validation.userInfo.lastName },attrs:{"type":"text"},domProps:{"value":(_vm.userInfo.lastName)},on:{"keyup":function($event){return _vm.fieldValidate('userInfo', 'lastName')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "lastName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userInfo.lastName))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('consumer.personalInfo.email'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.email),expression:"userInfo.email"}],class:{'input':true, 'has-error':!!_vm.validation.userInfo.email },attrs:{"type":"text"},domProps:{"value":(_vm.userInfo.email)},on:{"keyup":function($event){return _vm.fieldValidate('userInfo', 'email')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "email", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userInfo.email))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('consumer.personalInfo.mobile'))+"*")]),_vm._v(" "),_c('div',{class:( _obj = {'input-group':true}, _obj[_vm.dialCodeLength] = true, _obj )},[_c('div',{staticClass:"country-select input-group-label",on:{"click":_vm.selectCountry}},[_c('div',{staticClass:"calling-code"},[_vm._v("(+"+_vm._s(_vm.callingCode)+")")]),_vm._v(" "),_c('i',{staticClass:"fa fa-caret-down"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.nationalNumber),expression:"userInfo.nationalNumber"}],class:{'input mobile-input':true, 'has-error':!!_vm.validation.userInfo.phone },attrs:{"type":"number"},domProps:{"value":(_vm.userInfo.nationalNumber)},on:{"keyup":function($event){return _vm.fieldValidate('userInfo', 'phone')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "nationalNumber", $event.target.value)}}})]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userInfo.phone))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v("Date of Birth (YYYY-MM-DD)")]),_vm._v(" "),_c('date-picker',{staticClass:"cons-datepicker",attrs:{"valueType":"format","clearable":false,"lang":"en"},model:{value:(_vm.userInfo.bday),callback:function ($$v) {_vm.$set(_vm.userInfo, "bday", $$v)},expression:"userInfo.bday"}})],1),_vm._v(" "),_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v("Country")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.country),expression:"userInfo.country"}],staticClass:"country-selector",attrs:{"placeholder":"Country"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.userInfo, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Select Country")]),_vm._v(" "),_vm._l((_vm.countryList),function(country,i){return _c('option',{key:i,domProps:{"value":country.code.toUpperCase()}},[_vm._v(_vm._s(_vm.cleanCountryName(country.name)))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v("Passport Number (Optional)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.passportNum),expression:"userInfo.passportNum"}],staticClass:"input",attrs:{"type":"text"},domProps:{"value":(_vm.userInfo.passportNum)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "passportNum", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"field-row ada"},[_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v("ADA")]),_vm._v(" "),_c('label',{class:{'checked':!!_vm.userInfo.wheelChair}},[_c('span',{on:{"click":function($event){return _vm.updateADA('wheel', _vm.userInfo.wheelChair)}}},[(!!_vm.userInfo.wheelChair)?_c('i',{class:{'fas fa-check-square':true, 'checked':!!_vm.userInfo.wheelChair}}):_c('i',{staticClass:"far fa-square"}),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(" ")]),_vm._v(" "),_c('label',{class:{'checked':!!_vm.userInfo.serviceDog}},[_c('span',{on:{"click":function($event){return _vm.updateADA('dog', _vm.userInfo.serviceDog)}}},[(!!_vm.userInfo.serviceDog)?_c('i',{staticClass:"fas fa-check-square"}):_c('i',{staticClass:"far fa-square"}),_vm._v(" "),_vm._m(1)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ada-label"},[_c('i',{staticClass:"fas fa-wheelchair"}),_vm._v(" Wheelchair")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ada-label"},[_c('i',{staticClass:"fas fa-dog"}),_vm._v(" Service Dog")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Referrals_vue__ = __webpack_require__(398);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e9ac276_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Referrals_vue__ = __webpack_require__(1111);
function injectStyle (ssrContext) {
  __webpack_require__(1109)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e9ac276"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Referrals_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e9ac276_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Referrals_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1110);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4173a03b", content, true, {});

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.search[data-v-3e9ac276] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 400px;\n}\n.search input[data-v-3e9ac276] {\n    display: inline-block;\n    vertical-align: middle;\n    margin-top: 0;\n    border-radius: 5px 0 0 5px;\n}\n.search button[data-v-3e9ac276] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 5px 5px 0;\n}\n.import[data-v-3e9ac276] {\n  float: right;\n}\n.import .fa[data-v-3e9ac276] {\n    margin-right: 5px;\n}\n.clearfix[data-v-3e9ac276] {\n  clear: both;\n}\n.hideMobile[data-v-3e9ac276] {\n  display: none;\n}\ntable[data-v-3e9ac276] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n}\ntable thead[data-v-3e9ac276] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-3e9ac276] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-3e9ac276] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-3e9ac276] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-3e9ac276] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-3e9ac276] {\n          color: #ccc;\n}\n@media only screen and (max-width: 430px) {\n.cards .card[data-v-3e9ac276] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n}\n.cards .card span[data-v-3e9ac276] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Consumer/Referrals.vue"],"names":[],"mappings":";AACA;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,aAAa;CACd;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;IACd,2BAA2B;CAC9B;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,2BAA2B;CAC9B;AACD;EACE,aAAa;CACd;AACD;IACI,kBAAkB;CACrB;AACD;EACE,YAAY;CACb;AACD;EACE,cAAc;CACf;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;CAClB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;AACA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,aAAa;IACb,oBAAoB;IACpB,+BAA+B;IAC/B,oBAAoB;CACvB;AACD;MACM,gBAAgB;MAChB,0BAA0B;MAC1B,YAAY;MACZ,iBAAiB;CACtB;CACA","file":"Referrals.vue","sourcesContent":["\n.search[data-v-3e9ac276] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 400px;\n}\n.search input[data-v-3e9ac276] {\n    display: inline-block;\n    vertical-align: middle;\n    margin-top: 0;\n    border-radius: 5px 0 0 5px;\n}\n.search button[data-v-3e9ac276] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 5px 5px 0;\n}\n.import[data-v-3e9ac276] {\n  float: right;\n}\n.import .fa[data-v-3e9ac276] {\n    margin-right: 5px;\n}\n.clearfix[data-v-3e9ac276] {\n  clear: both;\n}\n.hideMobile[data-v-3e9ac276] {\n  display: none;\n}\ntable[data-v-3e9ac276] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n}\ntable thead[data-v-3e9ac276] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-3e9ac276] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-3e9ac276] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-3e9ac276] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-3e9ac276] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-3e9ac276] {\n          color: #ccc;\n}\n@media only screen and (max-width: 430px) {\n.cards .card[data-v-3e9ac276] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n}\n.cards .card span[data-v-3e9ac276] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"clearfix"}),_vm._v(" "),(!_vm.isMobile)?_c('table',[_c('thead',[_c('th',[_vm._v(_vm._s(_vm.$t('consumer.referrals.id')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.referrals.firstName')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.referrals.lastName')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.referrals.email')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.referrals.mobile')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.referrals.accountCreatedDate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.referrals.lastTrx')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.referrals.totalTrx')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.referrals.avgRating')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.referrals.referralCode')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.referrals.totalReferral')))])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.referrals),function(referral){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.referrals.length > 0),expression:"referrals.length > 0"}]},[_c('td',[_c('a',{attrs:{"href":'/#/' + referral.type + '/' + referral.id}},[_vm._v(_vm._s(referral.id))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(referral.firstName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(referral.lastName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(referral.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(referral.mobile))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(referral.accountCreated))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(referral.lastTrx))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(referral.totalTrx))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(referral.rating))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(referral.referralCode))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(referral.totalReferral))])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"11"}},[_c('i',{staticClass:"fa fa-circle-notch fa-spin"}),_vm._v("\n            "+_vm._s(_vm.$t('consumer.ratings.loading'))+"\n        ")])]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.referrals.length === 0 && !_vm.loading),expression:"referrals.length === 0 && !loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"11"}},[_vm._v("\n          "+_vm._s(_vm.$t('consumer.referrals.emptyState'))+"\n        ")])])],2)]):_c('div',[(_vm.referrals.length > 0)?_c('div',_vm._l((_vm.referrals),function(referral,i){return _c('div',{key:i,staticClass:"cards"},[_c('div',{staticClass:"card"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.$t('consumer.referrals.id'))+":")]),_vm._v(" "),_c('strong',[_c('a',{attrs:{"href":'/#/' + referral.type + '/' + referral.id}},[_vm._v(_vm._s(referral.id))])])]),_vm._v(" "),_c('div',[_c('span',[_vm._v(_vm._s(_vm.$t('consumer.referrals.firstName'))+":")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(referral.firstName))])]),_vm._v(" "),_c('div',[_c('span',[_vm._v(_vm._s(_vm.$t('consumer.referrals.email'))+":")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(referral.email))])]),_vm._v(" "),_c('div',[_c('span',[_vm._v(_vm._s(_vm.$t('consumer.referrals.mobile'))+":")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(referral.mobile))])]),_vm._v(" "),_c('div',[_c('span',[_vm._v(_vm._s(_vm.$t('consumer.referrals.accountCreatedDate'))+":")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(referral.accountCreated))])]),_vm._v(" "),_c('div',[_c('span',[_vm._v(_vm._s(_vm.$t('consumer.referrals.lastTrx'))+":")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(referral.lastTrx))])]),_vm._v(" "),_c('div',[_c('span',[_vm._v(_vm._s(_vm.$t('consumer.referrals.totalTrx'))+":")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(referral.totalTrx))])]),_vm._v(" "),_c('div',[_c('span',[_vm._v(_vm._s(_vm.$t('consumer.referrals.avgRating'))+":")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(referral.rating))])]),_vm._v(" "),_c('div',[_c('span',[_vm._v(_vm._s(_vm.$t('consumer.referrals.referralCode'))+":")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(referral.referralCode))])]),_vm._v(" "),_c('div',[_c('span',[_vm._v(_vm._s(_vm.$t('consumer.referrals.totalReferral'))+":")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(referral.totalReferral))])])])])}),0):_c('div',[_vm._v("\n      "+_vm._s(_vm.$t('consumer.referrals.emptyState'))+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transactions_vue__ = __webpack_require__(400);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62b60a59_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transactions_vue__ = __webpack_require__(1116);
function injectStyle (ssrContext) {
  __webpack_require__(1113)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62b60a59"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transactions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62b60a59_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transactions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1114);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("6f745b54", content, true, {});

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.clearfix[data-v-62b60a59] {\n  clear: both;\n}\n.field-label[data-v-62b60a59] {\n  font-size: 13px;\n  color: #777;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.filter[data-v-62b60a59] {\n  padding-bottom: 15px;\n}\n.filter .row[data-v-62b60a59] {\n    max-width: inherit;\n    width: 100%;\n    margin: 0;\n}\n.filter .column[data-v-62b60a59]:not(:last-child) {\n    padding-right: 20px;\n}\n.filter .status[data-v-62b60a59] {\n    display: inline-block;\n    padding: 20px 15px;\n    width: 150px;\n}\n.search-box[data-v-62b60a59] {\n  display: block;\n  position: relative;\n}\n.search-box .error-msg[data-v-62b60a59] {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.search[data-v-62b60a59] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.search .search-input-box[data-v-62b60a59] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-62b60a59] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 3px 0 0 2px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-62b60a59] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-62b60a59] {\n      position: absolute;\n      top: 50%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n}\n.search button[data-v-62b60a59] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 3px 2px 0;\n    padding: 0 20px;\n}\n.data-field[data-v-62b60a59] {\n  padding-right: 10px;\n}\n.data-field.no-label[data-v-62b60a59] {\n    padding-top: 17px;\n}\n.data-field .label[data-v-62b60a59] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .datepicker[data-v-62b60a59] {\n    position: relative;\n}\nselect[data-v-62b60a59] {\n  padding: 10px;\n  height: 46px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-62b60a59] {\n    background-color: #ebebe4;\n}\n.date-range[data-v-62b60a59] {\n  position: relative;\n  display: inline-block;\n}\n.date-range select[data-v-62b60a59] {\n    width: 150px;\n    margin-right: 5px;\n}\n.date-range .error-msg[data-v-62b60a59] {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.datepicker-box[data-v-62b60a59] {\n  display: inline-block;\n  width: 110px;\n}\n.export[data-v-62b60a59] {\n  text-align: right;\n  padding: 15px 10px 0;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 130px;\n          flex: 0 130px;\n}\ntable[data-v-62b60a59] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n}\ntable thead[data-v-62b60a59] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-62b60a59] {\n      padding: 5px 10px;\n}\ntable thead th[data-v-62b60a59]:last-child {\n        cursor: default;\n}\ntable thead th i[data-v-62b60a59] {\n        display: none;\n}\ntable thead th i.stripe-icon[data-v-62b60a59] {\n        display: inline;\n}\ntable thead th .fa-sort-up[data-v-62b60a59] {\n        vertical-align: -2px;\n}\ntable thead th .fa-sort-down[data-v-62b60a59] {\n        vertical-align: 2px;\n}\ntable thead th.sortable[data-v-62b60a59] {\n        cursor: pointer;\n        color: #333;\n}\ntable thead th.sortable span[data-v-62b60a59] {\n          font-weight: 600;\n          text-decoration: underline;\n}\ntable thead th.sort i[data-v-62b60a59] {\n        display: inline-block;\n}\ntable tbody tr[data-v-62b60a59] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr[data-v-62b60a59]:nth-child(even) {\n      background: #f3f3f3;\n}\ntable tbody tr[data-v-62b60a59]:hover {\n      background: #d7dbe4;\n}\ntable tbody tr td[data-v-62b60a59] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      color: #555;\n}\ntable tbody tr td.status[data-v-62b60a59], table tbody tr td.bookedThrough[data-v-62b60a59] {\n        font-weight: 600;\n}\ntable tbody tr td.table-block[data-v-62b60a59] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-62b60a59] {\n          color: #ccc;\n}\ntable tbody tr td a[data-v-62b60a59] {\n        font-weight: 600;\n        text-decoration: underline;\n        cursor: pointer;\n}\n.rsvp-type[data-v-62b60a59] {\n  text-transform: uppercase;\n  padding: 3px 5px;\n  color: #fff;\n  border-radius: 4px;\n}\n.rsvp-type.rsvp[data-v-62b60a59] {\n    background: #5771d0;\n}\n.rsvp-type.asap[data-v-62b60a59] {\n    background: #d05757;\n}\n.rsvp-type.package[data-v-62b60a59] {\n    background: #26d97a;\n}\n.booked-label[data-v-62b60a59] {\n  padding: 3px 5px;\n  background: #ccc;\n  color: #fff;\n  border-radius: 3px;\n  font-size: 12px;\n  font-weight: 700;\n}\n.booked-label.Web[data-v-62b60a59] {\n    background: #a26d5d;\n}\n.booked-label.Admin[data-v-62b60a59] {\n    background: #2b83f1;\n}\n.booked-label.Android[data-v-62b60a59] {\n    background: #78c259;\n}\n.booked-label.iOS[data-v-62b60a59] {\n    background: #7fc8de;\n}\n.booked-label.CSR[data-v-62b60a59] {\n    background: #bb4a91;\n}\n.booked-label.Provider[data-v-62b60a59] {\n    background: #3f3f3f;\n}\n.status-label[data-v-62b60a59] {\n  line-height: 1;\n  color: #fff;\n  padding: 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 11px !important;\n  background: #999;\n  display: inline-block;\n}\n.status-label.Purchased[data-v-62b60a59], .status-label.Purchase[data-v-62b60a59] {\n    background: #4aadf3;\n}\n.status-label.Completed[data-v-62b60a59] {\n    background: #26D97A;\n}\n.status-label.Promo[data-v-62b60a59] {\n    background: #f3904a;\n}\n.status-label.Edited[data-v-62b60a59], .status-label.Refund[data-v-62b60a59] {\n    background: #797979;\n}\n.status-label.No.Show[data-v-62b60a59], .status-label.Cancelled[data-v-62b60a59], .status-label.Declined[data-v-62b60a59] {\n    background: #f54f4f;\n}\n.status-label.Pending.Refund[data-v-62b60a59] {\n    background: #098769;\n    color: #fff;\n}\n.status-label.NOT_PROCESSED[data-v-62b60a59] {\n    background: #FFCC00 !important;\n    color: #505050 !important;\n}\n.status-label.Credit.Conversion[data-v-62b60a59] {\n    background: #29c3c3;\n}\n.status-label.Credit.Conversion.RECLAIMED[data-v-62b60a59] {\n    background: #bbbbbb;\n}\n.fix-footer[data-v-62b60a59] {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  width: 70%;\n  height: 60px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-62b60a59] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-62b60a59] {\n    max-width: 100px;\n    padding: 5px 10px;\n    height: 30px;\n}\n.fix-footer .per-page[data-v-62b60a59] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .per-page span[data-v-62b60a59] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-62b60a59] {\n    text-align: center;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .pagination[data-v-62b60a59] {\n    text-align: right;\n    padding: 15px 10px;\n}\n.fix-footer .pagination span[data-v-62b60a59] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-62b60a59] {\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-62b60a59] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-62b60a59] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-62b60a59] {\n        opacity: .4;\n        cursor: default;\n}\n.slide-up-enter-active[data-v-62b60a59], .slide-up-leave-active[data-v-62b60a59] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-62b60a59], .slide-up-leave-to[data-v-62b60a59] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.hideMobile[data-v-62b60a59] {\n  display: none;\n}\n.datepicker-div[data-v-62b60a59] {\n  display: inline;\n}\n@media only screen and (max-width: 430px) {\n.datepicker-div[data-v-62b60a59] {\n    display: block;\n    margin-top: 5px;\n}\n.column[data-v-62b60a59] {\n    margin-bottom: 5px;\n}\n.export[data-v-62b60a59] {\n    text-align: center;\n}\n.cards .card[data-v-62b60a59] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n}\n.cards .card > div[data-v-62b60a59] {\n      margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-62b60a59] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n}\n.cards .card .card-header .time[data-v-62b60a59] {\n        font-size: 12px;\n        color: #777;\n        word-spacing: 5px;\n}\n.cards .card .card-header .amount[data-v-62b60a59] {\n        font-weight: 900;\n        font-size: 20px;\n}\n.cards .card .card-header .amount a[data-v-62b60a59] {\n          text-decoration: none;\n}\n.cards .card .tags[data-v-62b60a59] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n}\n.cards .card .tags .rsvp-type[data-v-62b60a59] {\n        font-size: 12px;\n        margin-right: 5px;\n}\n.cards .card .tags .rsvp-stats[data-v-62b60a59] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n}\n.cards .card .tags .status[data-v-62b60a59] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.cards .card .tags .status .refund[data-v-62b60a59] {\n          margin-left: 10px;\n}\n.cards .card .title[data-v-62b60a59] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .title .rsvpId[data-v-62b60a59] {\n        font-weight: 900;\n        margin-right: 10px;\n}\n.cards .card .label[data-v-62b60a59] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-62b60a59] {\n      margin-right: 10px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Consumer/Transactions.vue"],"names":[],"mappings":";AACA;EACE,YAAY;CACb;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;IACI,mBAAmB;IACnB,YAAY;IACZ,UAAU;CACb;AACD;IACI,oBAAoB;CACvB;AACD;IACI,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;CAChB;AACD;EACE,eAAe;EACf,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;CACb;AACD;IACI,YAAY;IACZ,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,uBAAuB;MACvB,cAAc;MACd,2BAA2B;MAC3B,oBAAoB;CACzB;AACD;QACQ,sBAAsB;CAC7B;AACD;MACM,mBAAmB;MACnB,SAAS;MACT,oCAAoC;cAC5B,4BAA4B;MACpC,WAAW;MACX,eAAe;MACf,gBAAgB;CACrB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;CACnB;AACD;EACE,oBAAoB;CACrB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;IACI,mBAAmB;CACtB;AACD;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,+BAA+B;CAChC;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,mBAAmB;EACnB,sBAAsB;CACvB;AACD;IACI,aAAa;IACb,kBAAkB;CACrB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;EACE,sBAAsB;EACtB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;MAChB,kBAAkB;UACd,cAAc;CACvB;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;CAClB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;QACQ,gBAAgB;CACvB;AACD;QACQ,cAAc;CACrB;AACD;QACQ,gBAAgB;CACvB;AACD;QACQ,qBAAqB;CAC5B;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,gBAAgB;QAChB,YAAY;CACnB;AACD;UACU,iBAAiB;UACjB,2BAA2B;CACpC;AACD;QACQ,sBAAsB;CAC7B;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,YAAY;CACjB;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;QACQ,iBAAiB;QACjB,2BAA2B;QAC3B,gBAAgB;CACvB;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;CAClB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;IACpB,YAAY;CACf;AACD;IACI,+BAA+B;IAC/B,0BAA0B;CAC7B;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;CACb;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;CAChB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;CACnB;AACD;MACM,sBAAsB;MACtB,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;CACnB;AACD;IACI,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,kBAAkB;CACvB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,cAAc;MACd,eAAe;MACf,uBAAuB;MACvB,iBAAiB;MACjB,gBAAgB;MAChB,uBAAuB;MACvB,aAAa;CAClB;AACD;QACQ,kBAAkB;CACzB;AACD;QACQ,YAAY;QACZ,gBAAgB;CACvB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;EACE,cAAc;CACf;AACD;EACE,gBAAgB;CACjB;AACD;AACA;IACI,eAAe;IACf,gBAAgB;CACnB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,uBAAuB;IACvB,oBAAoB;IACpB,aAAa;IACb,oBAAoB;IACpB,+BAA+B;IAC/B,oBAAoB;CACvB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,uBAAuB;UACnB,oBAAoB;cAChB,sBAAsB;CACnC;AACD;QACQ,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;CACzB;AACD;QACQ,iBAAiB;QACjB,gBAAgB;CACvB;AACD;UACU,sBAAsB;CAC/B;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;CAC5C;AACD;QACQ,gBAAgB;QAChB,kBAAkB;CACzB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,uBAAuB;YACnB,oBAAoB;gBAChB,sBAAsB;CACrC;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;CACrB;AACD;UACU,kBAAkB;CAC3B;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;QACQ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;MACM,gBAAgB;MAChB,0BAA0B;MAC1B,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;CACvB;AACD;MACM,mBAAmB;CACxB;CACA","file":"Transactions.vue","sourcesContent":["\n.clearfix[data-v-62b60a59] {\n  clear: both;\n}\n.field-label[data-v-62b60a59] {\n  font-size: 13px;\n  color: #777;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.filter[data-v-62b60a59] {\n  padding-bottom: 15px;\n}\n.filter .row[data-v-62b60a59] {\n    max-width: inherit;\n    width: 100%;\n    margin: 0;\n}\n.filter .column[data-v-62b60a59]:not(:last-child) {\n    padding-right: 20px;\n}\n.filter .status[data-v-62b60a59] {\n    display: inline-block;\n    padding: 20px 15px;\n    width: 150px;\n}\n.search-box[data-v-62b60a59] {\n  display: block;\n  position: relative;\n}\n.search-box .error-msg[data-v-62b60a59] {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.search[data-v-62b60a59] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.search .search-input-box[data-v-62b60a59] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-62b60a59] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 3px 0 0 2px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-62b60a59] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-62b60a59] {\n      position: absolute;\n      top: 50%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n}\n.search button[data-v-62b60a59] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 3px 2px 0;\n    padding: 0 20px;\n}\n.data-field[data-v-62b60a59] {\n  padding-right: 10px;\n}\n.data-field.no-label[data-v-62b60a59] {\n    padding-top: 17px;\n}\n.data-field .label[data-v-62b60a59] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .datepicker[data-v-62b60a59] {\n    position: relative;\n}\nselect[data-v-62b60a59] {\n  padding: 10px;\n  height: 46px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-62b60a59] {\n    background-color: #ebebe4;\n}\n.date-range[data-v-62b60a59] {\n  position: relative;\n  display: inline-block;\n}\n.date-range select[data-v-62b60a59] {\n    width: 150px;\n    margin-right: 5px;\n}\n.date-range .error-msg[data-v-62b60a59] {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.datepicker-box[data-v-62b60a59] {\n  display: inline-block;\n  width: 110px;\n}\n.export[data-v-62b60a59] {\n  text-align: right;\n  padding: 15px 10px 0;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 130px;\n          flex: 0 130px;\n}\ntable[data-v-62b60a59] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n}\ntable thead[data-v-62b60a59] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-62b60a59] {\n      padding: 5px 10px;\n}\ntable thead th[data-v-62b60a59]:last-child {\n        cursor: default;\n}\ntable thead th i[data-v-62b60a59] {\n        display: none;\n}\ntable thead th i.stripe-icon[data-v-62b60a59] {\n        display: inline;\n}\ntable thead th .fa-sort-up[data-v-62b60a59] {\n        vertical-align: -2px;\n}\ntable thead th .fa-sort-down[data-v-62b60a59] {\n        vertical-align: 2px;\n}\ntable thead th.sortable[data-v-62b60a59] {\n        cursor: pointer;\n        color: #333;\n}\ntable thead th.sortable span[data-v-62b60a59] {\n          font-weight: 600;\n          text-decoration: underline;\n}\ntable thead th.sort i[data-v-62b60a59] {\n        display: inline-block;\n}\ntable tbody tr[data-v-62b60a59] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr[data-v-62b60a59]:nth-child(even) {\n      background: #f3f3f3;\n}\ntable tbody tr[data-v-62b60a59]:hover {\n      background: #d7dbe4;\n}\ntable tbody tr td[data-v-62b60a59] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      color: #555;\n}\ntable tbody tr td.status[data-v-62b60a59], table tbody tr td.bookedThrough[data-v-62b60a59] {\n        font-weight: 600;\n}\ntable tbody tr td.table-block[data-v-62b60a59] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-62b60a59] {\n          color: #ccc;\n}\ntable tbody tr td a[data-v-62b60a59] {\n        font-weight: 600;\n        text-decoration: underline;\n        cursor: pointer;\n}\n.rsvp-type[data-v-62b60a59] {\n  text-transform: uppercase;\n  padding: 3px 5px;\n  color: #fff;\n  border-radius: 4px;\n}\n.rsvp-type.rsvp[data-v-62b60a59] {\n    background: #5771d0;\n}\n.rsvp-type.asap[data-v-62b60a59] {\n    background: #d05757;\n}\n.rsvp-type.package[data-v-62b60a59] {\n    background: #26d97a;\n}\n.booked-label[data-v-62b60a59] {\n  padding: 3px 5px;\n  background: #ccc;\n  color: #fff;\n  border-radius: 3px;\n  font-size: 12px;\n  font-weight: 700;\n}\n.booked-label.Web[data-v-62b60a59] {\n    background: #a26d5d;\n}\n.booked-label.Admin[data-v-62b60a59] {\n    background: #2b83f1;\n}\n.booked-label.Android[data-v-62b60a59] {\n    background: #78c259;\n}\n.booked-label.iOS[data-v-62b60a59] {\n    background: #7fc8de;\n}\n.booked-label.CSR[data-v-62b60a59] {\n    background: #bb4a91;\n}\n.booked-label.Provider[data-v-62b60a59] {\n    background: #3f3f3f;\n}\n.status-label[data-v-62b60a59] {\n  line-height: 1;\n  color: #fff;\n  padding: 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 11px !important;\n  background: #999;\n  display: inline-block;\n}\n.status-label.Purchased[data-v-62b60a59], .status-label.Purchase[data-v-62b60a59] {\n    background: #4aadf3;\n}\n.status-label.Completed[data-v-62b60a59] {\n    background: #26D97A;\n}\n.status-label.Promo[data-v-62b60a59] {\n    background: #f3904a;\n}\n.status-label.Edited[data-v-62b60a59], .status-label.Refund[data-v-62b60a59] {\n    background: #797979;\n}\n.status-label.No.Show[data-v-62b60a59], .status-label.Cancelled[data-v-62b60a59], .status-label.Declined[data-v-62b60a59] {\n    background: #f54f4f;\n}\n.status-label.Pending.Refund[data-v-62b60a59] {\n    background: #098769;\n    color: #fff;\n}\n.status-label.NOT_PROCESSED[data-v-62b60a59] {\n    background: #FFCC00 !important;\n    color: #505050 !important;\n}\n.status-label.Credit.Conversion[data-v-62b60a59] {\n    background: #29c3c3;\n}\n.status-label.Credit.Conversion.RECLAIMED[data-v-62b60a59] {\n    background: #bbbbbb;\n}\n.fix-footer[data-v-62b60a59] {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  width: 70%;\n  height: 60px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-62b60a59] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-62b60a59] {\n    max-width: 100px;\n    padding: 5px 10px;\n    height: 30px;\n}\n.fix-footer .per-page[data-v-62b60a59] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .per-page span[data-v-62b60a59] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-62b60a59] {\n    text-align: center;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .pagination[data-v-62b60a59] {\n    text-align: right;\n    padding: 15px 10px;\n}\n.fix-footer .pagination span[data-v-62b60a59] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-62b60a59] {\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-62b60a59] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-62b60a59] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-62b60a59] {\n        opacity: .4;\n        cursor: default;\n}\n.slide-up-enter-active[data-v-62b60a59], .slide-up-leave-active[data-v-62b60a59] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-62b60a59], .slide-up-leave-to[data-v-62b60a59] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.hideMobile[data-v-62b60a59] {\n  display: none;\n}\n.datepicker-div[data-v-62b60a59] {\n  display: inline;\n}\n@media only screen and (max-width: 430px) {\n.datepicker-div[data-v-62b60a59] {\n    display: block;\n    margin-top: 5px;\n}\n.column[data-v-62b60a59] {\n    margin-bottom: 5px;\n}\n.export[data-v-62b60a59] {\n    text-align: center;\n}\n.cards .card[data-v-62b60a59] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n}\n.cards .card > div[data-v-62b60a59] {\n      margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-62b60a59] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n}\n.cards .card .card-header .time[data-v-62b60a59] {\n        font-size: 12px;\n        color: #777;\n        word-spacing: 5px;\n}\n.cards .card .card-header .amount[data-v-62b60a59] {\n        font-weight: 900;\n        font-size: 20px;\n}\n.cards .card .card-header .amount a[data-v-62b60a59] {\n          text-decoration: none;\n}\n.cards .card .tags[data-v-62b60a59] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n}\n.cards .card .tags .rsvp-type[data-v-62b60a59] {\n        font-size: 12px;\n        margin-right: 5px;\n}\n.cards .card .tags .rsvp-stats[data-v-62b60a59] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n}\n.cards .card .tags .status[data-v-62b60a59] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.cards .card .tags .status .refund[data-v-62b60a59] {\n          margin-left: 10px;\n}\n.cards .card .title[data-v-62b60a59] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .title .rsvpId[data-v-62b60a59] {\n        font-weight: 900;\n        margin-right: 10px;\n}\n.cards .card .label[data-v-62b60a59] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-62b60a59] {\n      margin-right: 10px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(6);
/* global CONFIG */



/* harmony default export */ __webpack_exports__["a"] = ({
  getTransactions: function getTransactions(VueApp, conId, callback) {
    var self = this;
    var transactions = VueApp.$store.state.consumer.transactions;
    var pageSize = transactions.perPage;
    var page = transactions.currentPage;
    var pickupSince = __WEBPACK_IMPORTED_MODULE_0_moment___default()(transactions.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00');
    var pickupUntil = __WEBPACK_IMPORTED_MODULE_0_moment___default()(transactions.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59');
    if (transactions.date === 'all') {
      pickupSince = '2010-01-01 00:00';
      pickupUntil = __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(10, 'years').format('YYYY-MM-DD 23:59');
    }

    VueApp.$sdk.get('/transaction', {
      token: VueApp.$store.state.session.sessionToken,
      consId: conId,
      pageSize: pageSize,
      pageNum: page,
      order: transactions.sort.column,
      orderAsc: transactions.sort.isDesc ? 0 : 1,
      since: pickupSince,
      until: pickupUntil,
      search: transactions.search,
      status: transactions.status
    }, function (res) {
      if (!res.error) {
        VueApp.$store.commit('consumer/setTrxData', { maxList: res.paging.totalItems });

        var trxList = [];
        if (res.list.length) {
          var trx = res.list;
          for (var i = 0; i < res.list.length; i++) {
            var provider = trx[i].provider;
            // let consumer = trx[i].consumer
            var payment = trx[i].payment;

            trxList.push({
              date: __WEBPACK_IMPORTED_MODULE_0_moment___default()(trx[i].datetime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm:ss'),
              providerId: provider.id,
              company: provider.businessName,
              rsvpId: trx[i].rsvpId,
              trxId: trx[i].eventId,
              pkgId: trx[i].packageId,
              type: trx[i].isAsap ? 'asap' : 'rsvp',
              // firstName: consumer.firstName,
              // lastName: consumer.lastName,
              // mobile: consumer.phone,
              creditCard: trx[i].cardNumber,
              bookedThrough: self.bookedThroughLabel(trx[i].deviceType),
              finalOffer: self.toFixed(payment.offer),
              chargedAmount: self.toFixed(payment.charged),
              promoUsed: self.toFixed(payment.credit),
              status: trx[i].transactionType,
              statusLabel: trx[i].status,
              paymentURL: trx[i].paymentURL,
              externalId: trx[i].externalId || '',
              notes: trx[i].notes,
              transactionType: trx[i].transactionType
            });
          }
        }
        VueApp.$store.commit('consumer/setTrxData', { list: trxList });
      }
      callback(res);
    });
  },
  exportTransactions: function exportTransactions(VueApp, conId, callback) {
    var self = this;
    var transactions = VueApp.$store.state.consumer.transactions;
    var pageSize = transactions.perPage;
    var page = transactions.currentPage;

    var since = __WEBPACK_IMPORTED_MODULE_0_moment___default()(transactions.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00');
    var until = __WEBPACK_IMPORTED_MODULE_0_moment___default()(transactions.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59');
    if (transactions.date === 'all') {
      since = '2010-01-01 00:00';
      until = __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(10, 'years').format('YYYY-MM-DD 23:59');
    }

    VueApp.$sdk.get('/transaction', {
      token: VueApp.$store.state.session.sessionToken,
      consId: conId,
      pageSize: pageSize,
      pageNum: page,
      order: transactions.sort.column,
      orderAsc: transactions.sort.isDesc ? 0 : 1,
      since: since,
      until: until,
      search: transactions.search,
      status: transactions.status,
      export: true
    }, function (res) {
      if (!res.error) {
        var trx = [];
        if (res.list.length) {
          res.list.forEach(function (value) {
            trx.push(self.buildExport(value));
          });
        }
        callback(trx);
      } else {
        callback(res);
      }
    });
  },
  toFixed: function toFixed(value) {
    value = parseFloat(value);
    if (value < 0) {
      return '-$' + Math.abs(value).toFixed(2);
    }
    return '$' + value.toFixed(2);
  },
  bookedThroughLabel: function bookedThroughLabel(value) {
    switch (value) {
      case 'ww':
        return 'Web';
      case 'admin':
        return 'Admin';
      case 'android':
        return 'Android App';
      case 'ios':
        return 'iOS App';
      case 'provider':
        return 'Provider';
      default:
        return value;
    }

    return '';
  },
  buildExport: function buildExport(data) {
    var rsvpId = this.convertBrand(data.brandId) + data.rsvpId;
    var serviceType = __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].getServiceName(data.serviceCode);
    var payment = data.payment;
    var creditCard = payment.cancelFee ? 'N/A' : data.cardNumber;
    var source = this.bookedThroughLabel(data.deviceType);
    var provLicense = data.provider.accountType || '';

    if (data.packageId) {
      rsvpId = data.packageId;
      serviceType = __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].getServiceName('shared');
      source = 'PKG';
    }
    if (!{"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation) {
      serviceType = data.serviceType.label;
    }

    return {
      Date: __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY'),
      'Booking Time': __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('HH:mm:ss'),
      'Pickup Time': __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.pickupTime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm'),
      'Service Area': data.geofence.name,
      'Prov ID': data.provider.id,
      'Prov License': provLicense.toUpperCase(),
      'Company': data.provider.businessName,
      'RSVP ID': rsvpId,
      'Invoice ID': data.eventId,
      'Service Type': serviceType,
      'First Name': data.consumer.firstName,
      'Last Name': data.consumer.lastName,
      'Credit Card': creditCard,
      'Email': data.consumer.email,
      'Mobile': data.consumer.phone,
      'Source': source,
      'Final Offer': payment.offer || 0,
      'Charge Amount': payment.charged || 0,
      'Refunded Amount': -Math.abs(data.refundedAmount) || 0,
      'Promo Used': payment.credit || 0,
      'Driver Payment': payment.driverPay || 0,
      'Bonus': payment.bonus || 0,
      'Cancel Fees': payment.cancelFee || 0,
      'Status': data.status,
      'Pickup Location': data.pickupLocation,
      'Dropoff Location': data.dropoffLocation
    };
  },
  convertBrand: function convertBrand(id) {
    var index = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.findIndex(function (x) {
      return x.id === id;
    });
    if (!id || index === -1) {
      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[0].code.toUpperCase();
    }

    return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[index].code.toUpperCase();
  }
});

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-bottom":"50px"}},[_c('div',{staticClass:"filter"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column medium-3"},[_c('div',{staticClass:"search-box"},[_c('label',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.$t('transactions.filter.search'))+":")]),_vm._v(" "),_c('div',{staticClass:"search"},[_c('div',{staticClass:"search-input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],ref:"search",class:{'has-error':!!_vm.hasError.searchMsg},attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.searchInput)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search.apply(null, arguments)},"blur":_vm.blurSearch,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchInput.length > 0),expression:"searchInput.length > 0"}],staticClass:"far fa-times-circle fa-lg",on:{"click":_vm.clearSearch}})])],1),_vm._v(" "),_c('button',{class:{'button xsmall success':true, 'disabled':_vm.loading},on:{"click":_vm.search}},[_c('i',{staticClass:"fas fa-search fa-lg"})])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.hasError.searchMsg),expression:"!!hasError.searchMsg"}],staticClass:"error-msg"},[_vm._v("\n              "+_vm._s(_vm.hasError.searchMsg)+"\n            ")])])],1)]),_vm._v(" "),_c('div',{staticClass:"column medium-2"},[_c('label',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.$t('transactions.filter.status'))+":")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('transactions.filter.all')))]),_vm._v(" "),_c('option',{attrs:{"value":"Declined"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.declined')))]),_vm._v(" "),_c('option',{attrs:{"value":"Cancelled"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.cancelled')))]),_vm._v(" "),_c('option',{attrs:{"value":"Purchased"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.purchased')))]),_vm._v(" "),_c('option',{attrs:{"value":"Promo"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.promo')))]),_vm._v(" "),_c('option',{attrs:{"value":"Authorized"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.authorized')))]),_vm._v(" "),_c('option',{attrs:{"value":"No Show"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.noShow')))]),_vm._v(" "),_c('option',{attrs:{"value":"Completed"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.completed')))]),_vm._v(" "),_c('option',{attrs:{"value":"Refund"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.refund')))]),_vm._v(" "),_c('option',{attrs:{"value":"Edited"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.edited')))])])]),_vm._v(" "),_c('div',{staticClass:"column medium-5"},[_c('div',{staticClass:"date-range"},[_c('label',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.$t('transactions.filter.dateRange'))+":")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateType),expression:"dateType"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dateType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.all')))]),_vm._v(" "),_c('option',{attrs:{"value":"custom"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.custom')))]),_vm._v(" "),_c('option',{attrs:{"value":"withinDay"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.withinDay')))]),_vm._v(" "),_c('option',{attrs:{"value":"monthToDate"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.monthToDate')))]),_vm._v(" "),_c('option',{attrs:{"value":"lastMonth"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.lastMonth')))]),_vm._v(" "),_c('option',{attrs:{"value":"lastWeek"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.lastWeek')))]),_vm._v(" "),_c('option',{attrs:{"value":"last2Week"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.last2Week')))]),_vm._v(" "),_c('option',{attrs:{"value":"last30Days"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.last30Days')))]),_vm._v(" "),_c('option',{attrs:{"value":"last60Days"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.last60Days')))]),_vm._v(" "),_c('option',{attrs:{"value":"last90Days"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.last90Days')))])]),_vm._v(" "),_c('div',{staticClass:"datepicker-div"},[_c('div',{staticClass:"datepicker-box"},[_c('datepicker',{ref:"datepickerFrom",class:{'datepicker inline':true, 'has-error':false},attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"input-class":{'datepicker-empty':_vm.hasError.from},"placeholder":_vm.$t('transactions.filter.from')},on:{"input":function($event){return _vm.updateFromTo('from')}},model:{value:(_vm.date.from),callback:function ($$v) {_vm.$set(_vm.date, "from", $$v)},expression:"date.from"}})],1),_vm._v(" "),_c('div',{staticClass:"datepicker-box"},[_c('datepicker',{ref:"datepickerTo",staticClass:"datepicker inline",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"input-class":{'datepicker-empty':_vm.hasError.to},"placeholder":_vm.$t('transactions.filter.to')},on:{"input":function($event){return _vm.updateFromTo('to')}},model:{value:(_vm.date.to),callback:function ($$v) {_vm.$set(_vm.date, "to", $$v)},expression:"date.to"}})],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.hasError.fromToMsg),expression:"!!hasError.fromToMsg"}],staticClass:"error-msg"},[_vm._v("\n              "+_vm._s(_vm.hasError.fromToMsg)+"\n            ")])])],1)]),_vm._v(" "),_c('div',{staticClass:"column medium-2"},[_c('div',{staticClass:"export"},[_c('a',{class:{'button cta success small':true, 'disabled':!_vm.transactions.length || _vm.loading},on:{"click":_vm.exportTrx}},[_vm._v(_vm._s(_vm.$t('transactions.filter.export')))])])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(!_vm.isMobile)?_c('table',[_c('thead',[_c('th',{class:{'sortable':true, 'sort':_vm.sort.active ==='created'},on:{"click":function($event){return _vm.sortTable('created')}}},[_vm._v("\n        "+_vm._s(_vm.$t('consumer.transactions.date'))+"\n        "),_c('i',{class:['fas', _vm.sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']})]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.providerId')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.company')))]),_vm._v(" "),_c('th',{class:{'sortable':true, 'sort':_vm.sort.active ==='rsvpId'},on:{"click":function($event){return _vm.sortTable('rsvpId')}}},[_vm._v("\n        "+_vm._s(_vm.$t('consumer.transactions.rsvpId'))+"\n        "),_c('i',{class:['fas', _vm.sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'sort':_vm.sort.active ==='eventId'},on:{"click":function($event){return _vm.sortTable('eventId')}}},[_vm._v("\n        "+_vm._s(_vm.$t('consumer.transactions.invoiceId'))+"\n        "),_c('i',{class:['fas', _vm.sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'sort':_vm.sort.active ==='isAsap'},on:{"click":function($event){return _vm.sortTable('isAsap')}}},[_vm._v("\n        "+_vm._s(_vm.$t('consumer.transactions.type'))+"\n        "),_c('i',{class:['fas', _vm.sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']})]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.creditCard')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.bookedThrough')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.finalOffer')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.chargedAmount')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.promoUsed')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.status')))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('tbody',[_vm._l((_vm.transactions),function(trx){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions.length > 0),expression:"transactions.length > 0"}]},[_c('td',[_vm._v(_vm._s(trx.date))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'/#/provider/' + trx.providerId,"target":"_blank"}},[_vm._v(_vm._s(trx.providerId))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.company))]),_vm._v(" "),_c('td',[(trx.rsvpId !== 0)?_c('a',{attrs:{"href":'/#/reservation/' + trx.rsvpId,"target":"_blank"}},[_vm._v(_vm._s(trx.rsvpId))]):_c('a',{attrs:{"href":'/#/package/' + trx.pkgId,"target":"_blank"}},[_vm._v("\n            "+_vm._s(trx.pkgId)+" "),_c('i',{staticClass:"fa fa-cube"})])]),_vm._v(" "),_c('td',[(trx.trxId !== '0')?_c('span',[_vm._v(_vm._s(trx.trxId))]):_c('span',[_vm._v("--")])]),_vm._v(" "),_c('td',[(trx.pkgId)?_c('span',{staticClass:"package"},[_vm._v("PKG")]):_c('span',{class:['rsvp-type', trx.type]},[_vm._v(_vm._s(trx.type))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.creditCard))]),_vm._v(" "),_c('td',{staticClass:"bookedThrough"},[_c('span',{class:['booked-label', trx.bookedThrough]},[_vm._v(_vm._s(trx.bookedThrough))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.finalOffer))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.chargedAmount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.promoUsed))]),_vm._v(" "),_c('td',{staticClass:"status"},[_c('span',{class:['status-label', trx.statusLabel, trx.notes === 'NOT_PROCESSED' ? 'NOT_PROCESSED' : '', _vm.checkReclaimed(trx)]},[_vm._v(_vm._s(_vm.relabel(trx)))])]),_vm._v(" "),_c('td',[(trx.paymentURL === null)?_c('span',[_vm._v("--")]):_c('a',{attrs:{"href":trx.paymentURL,"target":"_blank"}},[_c('i',{staticClass:"fa fa-link"})])])])}),_vm._v(" "),_c('tr',[_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions.length === 0 && !_vm.loading),expression:"transactions.length === 0 && !loading"}],staticClass:"table-block",attrs:{"colspan":"12"}},[_vm._v("\n          "+_vm._s(_vm.$t('consumer.transactions.emptyState'))+"\n        ")])])],2)]):_c('div',[(_vm.transactions.length > 0)?_c('div',_vm._l((_vm.transactions),function(trx,i){return _c('div',{key:i,staticClass:"cards"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"time"},[_vm._v("\n              "+_vm._s(trx.date)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"amount"},[(trx.paymentURL === null)?_c('strong',[_vm._v(_vm._s(trx.chargedAmount))]):_c('a',{attrs:{"href":trx.paymentURL,"target":"_blank"}},[_c('strong',[_vm._v(_vm._s(trx.chargedAmount))]),_vm._v(" "),_c('i',{staticClass:"fa fa-link"})])])]),_vm._v(" "),_c('div',{staticClass:"tags"},[_c('div',{staticClass:"rsvp-stats"},[_c('div',{staticClass:"type"},[(trx.pkgId)?_c('span',{staticClass:"package"},[_vm._v("PKG")]):_c('span',{class:['rsvp-type', trx.type]},[_vm._v(_vm._s(trx.type))])]),_vm._v(" "),_c('div',{staticClass:"bookedThrough"},[_c('span',{class:['booked-label', trx.bookedThrough]},[_vm._v(_vm._s(trx.bookedThrough))])])]),_vm._v(" "),_c('div',{staticClass:"status"},[_c('span',{class:['status-label', trx.statusLabel, trx.notes === 'NOT_PROCESSED' ? 'NOT_PROCESSED' : '', _vm.checkReclaimed(trx)]},[_vm._v(_vm._s(_vm.relabel(trx)))])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("RSVP ID:")]),_vm._v(" "),_c('div',{staticClass:"rsvpId"},[(trx.rsvpId !== 0)?_c('a',{attrs:{"href":'/#/reservation/' + trx.rsvpId,"target":"_blank"}},[_vm._v(_vm._s(trx.rsvpId))]):_c('a',{attrs:{"href":'/#/package/' + trx.pkgId,"target":"_blank"}},[_vm._v("\n                "+_vm._s(trx.pkgId)+" "),_c('i',{staticClass:"fa fa-cube"})])]),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("Invoice ID:")]),_vm._v(" "),_c('div',[(trx.trxId !== '0')?_c('span',[_vm._v(_vm._s(trx.trxId))]):_c('span',[_vm._v("--")])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Provider Id:")]),_vm._v(" "),_c('div',{staticClass:"value"},[(trx.providerId)?_c('a',{attrs:{"href":'/#/provider/' + trx.providerId,"target":"_blank"}},[_vm._v(_vm._s(trx.providerId))]):_c('span',[_vm._v("--")])]),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("Company:")]),_vm._v(" "),_c('div',{staticClass:"value"},[(trx.company)?_c('span',[_vm._v(_vm._s(trx.company))]):_c('span',[_vm._v("--")])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Final Offer:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(trx.finalOffer))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Charged Amount:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(trx.chargedAmount))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Promo Used:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(trx.promoUsed))])])])])}),0):_c('div',[_vm._v("\n      "+_vm._s(_vm.$t('consumer.transactions.emptyState'))+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"fix-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-3 columns per-page"},[_c('span',[_vm._v("Displaying")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" "),_c('span',[_vm._v("per page")])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns page-data"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions.length > 0),expression:"transactions.length > 0"}]},[_vm._v("\n          Displaying\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.start))]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.pageData.end))]),_vm._v(" of\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.max))])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns pagination"},[_c('span',[_vm._v("Page")]),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.currentPage === 1 || _vm.loading},on:{"click":_vm.prev}},[_c('i',{staticClass:"fas fa-chevron-left"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentPage),expression:"currentPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.totalPage),function(i){return _c('option',{domProps:{"value":i}},[_vm._v(_vm._s(i))])}),0),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.isLastPage || _vm.loading},on:{"click":_vm.next}},[_c('i',{staticClass:"fas fa-chevron-right"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('i',{staticClass:"stripe-icon fab fa-stripe-s"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reservations_vue__ = __webpack_require__(401);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71467016_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reservations_vue__ = __webpack_require__(1121);
function injectStyle (ssrContext) {
  __webpack_require__(1118)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71467016"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reservations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71467016_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reservations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1119);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("9b413afe", content, true, {});

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.status[data-v-71467016] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-71467016], .status.completed[data-v-71467016] {\n    background: #26D97A;\n}\n.status.canceled[data-v-71467016], .status.cancelled[data-v-71467016], .status.failed[data-v-71467016] {\n    background: #bbb;\n}\n.status.upcoming[data-v-71467016] {\n    background: #f38d56;\n}\n.status.onboard[data-v-71467016] {\n    background: #dc3168;\n}\n.status.ready[data-v-71467016] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-71467016], .status.requires_dispatch[data-v-71467016] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-71467016] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-71467016] {\n    background: #5662f3;\n}\n.flight-status[data-v-71467016] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-71467016] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-71467016] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-71467016] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-71467016] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-71467016] {\n    background-color: #f35656;\n}\n.service-type[data-v-71467016] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-71467016] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-71467016] {\n    background: #26D97A;\n}\n.service-type.black[data-v-71467016] {\n    background: #777;\n}\n.service-type.suv[data-v-71467016] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-71467016] {\n    background: #6dabc3;\n}\n.license-type[data-v-71467016] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-71467016] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-71467016] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-71467016] {\n    background-color: #de6c2a;\n}\n.clearfix[data-v-71467016] {\n  clear: both;\n}\n.field-label[data-v-71467016] {\n  font-size: 13px;\n  color: #777;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.filter[data-v-71467016] {\n  padding-bottom: 15px;\n}\n.filter .row[data-v-71467016] {\n    max-width: inherit;\n    width: 100%;\n    margin: 0;\n}\n.filter .column[data-v-71467016]:not(:last-child) {\n    padding-right: 20px;\n}\n.filter .status[data-v-71467016] {\n    display: inline-block;\n    padding: 20px 15px;\n    width: 150px;\n}\n.search-box[data-v-71467016] {\n  display: block;\n  position: relative;\n}\n.search-box .error-msg[data-v-71467016] {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.search[data-v-71467016] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.search .search-input-box[data-v-71467016] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-71467016] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 3px 0 0 2px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-71467016] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-71467016] {\n      position: absolute;\n      top: 50%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n}\n.search button[data-v-71467016] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 3px 2px 0;\n    padding: 0 20px;\n}\n.data-field[data-v-71467016] {\n  padding-right: 10px;\n}\n.data-field.no-label[data-v-71467016] {\n    padding-top: 17px;\n}\n.data-field .label[data-v-71467016] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .datepicker[data-v-71467016] {\n    position: relative;\n}\nselect[data-v-71467016] {\n  padding: 10px;\n  height: 46px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-71467016] {\n    background-color: #ebebe4;\n}\n.date-range[data-v-71467016] {\n  position: relative;\n  display: inline-block;\n}\n.date-range select[data-v-71467016] {\n    width: 150px;\n    margin-right: 5px;\n}\n.date-range .error-msg[data-v-71467016] {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.datepicker-box[data-v-71467016] {\n  display: inline-block;\n  width: 110px;\n}\n.export[data-v-71467016] {\n  text-align: right;\n  padding: 15px 10px 0;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 130px;\n          flex: 0 130px;\n}\ntable[data-v-71467016] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n}\ntable thead[data-v-71467016] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-71467016] {\n      padding: 5px 10px;\n}\ntable thead th[data-v-71467016]:last-child {\n        cursor: default;\n}\ntable thead th i[data-v-71467016] {\n        display: none;\n}\ntable thead th i.stripe-icon[data-v-71467016] {\n        display: inline;\n}\ntable thead th .fa-sort-up[data-v-71467016] {\n        vertical-align: -2px;\n}\ntable thead th .fa-sort-down[data-v-71467016] {\n        vertical-align: 2px;\n}\ntable thead th.sortable[data-v-71467016] {\n        cursor: pointer;\n        color: #333;\n}\ntable thead th.sortable span[data-v-71467016] {\n          font-weight: 600;\n          text-decoration: underline;\n}\ntable thead th.sort i[data-v-71467016] {\n        display: inline-block;\n}\ntable tbody tr[data-v-71467016] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr[data-v-71467016]:nth-child(even) {\n      background: #f3f3f3;\n}\ntable tbody tr[data-v-71467016]:hover {\n      background: #d7dbe4;\n}\ntable tbody tr td[data-v-71467016] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      color: #555;\n}\ntable tbody tr td .status[data-v-71467016] {\n        line-height: 1.5;\n}\ntable tbody tr td.status[data-v-71467016], table tbody tr td.bookedThrough[data-v-71467016] {\n        font-weight: 600;\n}\ntable tbody tr td.table-block[data-v-71467016] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-71467016] {\n          color: #ccc;\n}\ntable tbody tr td a[data-v-71467016] {\n        font-weight: 600;\n        text-decoration: underline;\n        cursor: pointer;\n}\n.rsvp-type[data-v-71467016] {\n  text-transform: uppercase;\n  padding: 3px 5px;\n  color: #fff;\n  border-radius: 4px;\n}\n.rsvp-type.rsvp[data-v-71467016] {\n    background: #5771d0;\n}\n.rsvp-type.asap[data-v-71467016] {\n    background: #d05757;\n}\n.rsvp-type.package[data-v-71467016] {\n    background: #26d97a;\n}\n.booked-label[data-v-71467016] {\n  padding: 3px 5px;\n  background: #ccc;\n  color: #fff;\n  border-radius: 3px;\n  font-size: 12px;\n  font-weight: 700;\n}\n.booked-label.Web[data-v-71467016] {\n    background: #a26d5d;\n}\n.booked-label.Admin[data-v-71467016] {\n    background: #2b83f1;\n}\n.booked-label.Android[data-v-71467016] {\n    background: #78c259;\n}\n.booked-label.iOS[data-v-71467016] {\n    background: #7fc8de;\n}\n.booked-label.CSR[data-v-71467016] {\n    background: #bb4a91;\n}\n.booked-label.Provider[data-v-71467016] {\n    background: #3f3f3f;\n}\n.status-label[data-v-71467016] {\n  line-height: 1;\n  color: #fff;\n  padding: 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 11px !important;\n  background: #999;\n  display: inline-block;\n}\n.status-label.Purchased[data-v-71467016], .status-label.Purchase[data-v-71467016] {\n    background: #4aadf3;\n}\n.status-label.Completed[data-v-71467016] {\n    background: #26D97A;\n}\n.status-label.Promo[data-v-71467016] {\n    background: #f3904a;\n}\n.status-label.Edited[data-v-71467016], .status-label.Refund[data-v-71467016] {\n    background: #797979;\n}\n.status-label.No.Show[data-v-71467016], .status-label.Cancelled[data-v-71467016], .status-label.Declined[data-v-71467016] {\n    background: #f54f4f;\n}\n.slide-up-enter-active[data-v-71467016], .slide-up-leave-active[data-v-71467016] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-71467016], .slide-up-leave-to[data-v-71467016] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.service-label[data-v-71467016] {\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 12px;\n  text-transform: capitalize;\n}\n.service-label.shared[data-v-71467016] {\n    background: #f38d56;\n}\n.service-label.opoli[data-v-71467016] {\n    background: #26D97A;\n}\n.service-label.black[data-v-71467016] {\n    background: #777;\n}\n.service-label.SUV[data-v-71467016], .service-label.suv[data-v-71467016] {\n    background: #dc3168;\n}\n.service-label.shuttle[data-v-71467016] {\n    background: #6dabc3;\n}\n.hideMobile[data-v-71467016] {\n  display: none;\n}\n.datepicker-div[data-v-71467016] {\n  display: inline;\n}\n@media only screen and (max-width: 430px) {\n.datepicker-div[data-v-71467016] {\n    display: block;\n    margin-top: 5px;\n}\n.column[data-v-71467016] {\n    margin-bottom: 5px;\n}\n.export[data-v-71467016] {\n    text-align: center;\n}\n.cards .card[data-v-71467016] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n}\n.cards .card > div[data-v-71467016] {\n      margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-71467016] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n}\n.cards .card .card-header .time[data-v-71467016] {\n        font-size: 12px;\n        color: #777;\n        word-spacing: 5px;\n}\n.cards .card .card-header .amount[data-v-71467016] {\n        font-weight: 900;\n        font-size: 20px;\n}\n.cards .card .card-header .amount a[data-v-71467016] {\n          text-decoration: none;\n}\n.cards .card .tags[data-v-71467016] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n}\n.cards .card .tags .rsvp-type[data-v-71467016] {\n        font-size: 12px;\n        margin-right: 5px;\n}\n.cards .card .tags .rsvp-stats[data-v-71467016] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n}\n.cards .card .tags .status[data-v-71467016] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.cards .card .tags .status .refund[data-v-71467016] {\n          margin-left: 10px;\n}\n.cards .card .title[data-v-71467016] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .title .rsvpId[data-v-71467016] {\n        font-weight: 900;\n        margin-right: 10px;\n}\n.cards .card .label[data-v-71467016] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-71467016] {\n      margin-right: 10px;\n      font-size: 12px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Consumer/Reservations.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;CAC3B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,YAAY;CACb;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;IACI,mBAAmB;IACnB,YAAY;IACZ,UAAU;CACb;AACD;IACI,oBAAoB;CACvB;AACD;IACI,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;CAChB;AACD;EACE,eAAe;EACf,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;CACb;AACD;IACI,YAAY;IACZ,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,uBAAuB;MACvB,cAAc;MACd,2BAA2B;MAC3B,oBAAoB;CACzB;AACD;QACQ,sBAAsB;CAC7B;AACD;MACM,mBAAmB;MACnB,SAAS;MACT,oCAAoC;cAC5B,4BAA4B;MACpC,WAAW;MACX,eAAe;MACf,gBAAgB;CACrB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;CACnB;AACD;EACE,oBAAoB;CACrB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;IACI,mBAAmB;CACtB;AACD;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,+BAA+B;CAChC;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,mBAAmB;EACnB,sBAAsB;CACvB;AACD;IACI,aAAa;IACb,kBAAkB;CACrB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;EACE,sBAAsB;EACtB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;MAChB,kBAAkB;UACd,cAAc;CACvB;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;CAClB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;QACQ,gBAAgB;CACvB;AACD;QACQ,cAAc;CACrB;AACD;QACQ,gBAAgB;CACvB;AACD;QACQ,qBAAqB;CAC5B;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,gBAAgB;QAChB,YAAY;CACnB;AACD;UACU,iBAAiB;UACjB,2BAA2B;CACpC;AACD;QACQ,sBAAsB;CAC7B;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,YAAY;CACjB;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;QACQ,iBAAiB;QACjB,2BAA2B;QAC3B,gBAAgB;CACvB;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;CAClB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;CAC5B;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,cAAc;CACf;AACD;EACE,gBAAgB;CACjB;AACD;AACA;IACI,eAAe;IACf,gBAAgB;CACnB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,uBAAuB;IACvB,oBAAoB;IACpB,aAAa;IACb,oBAAoB;IACpB,+BAA+B;IAC/B,oBAAoB;CACvB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,uBAAuB;UACnB,oBAAoB;cAChB,sBAAsB;CACnC;AACD;QACQ,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;CACzB;AACD;QACQ,iBAAiB;QACjB,gBAAgB;CACvB;AACD;UACU,sBAAsB;CAC/B;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;CAC5C;AACD;QACQ,gBAAgB;QAChB,kBAAkB;CACzB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,uBAAuB;YACnB,oBAAoB;gBAChB,sBAAsB;CACrC;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;CACrB;AACD;UACU,kBAAkB;CAC3B;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;QACQ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;MACM,gBAAgB;MAChB,0BAA0B;MAC1B,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;CACvB;AACD;MACM,mBAAmB;MACnB,gBAAgB;CACrB;CACA","file":"Reservations.vue","sourcesContent":["\n.status[data-v-71467016] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-71467016], .status.completed[data-v-71467016] {\n    background: #26D97A;\n}\n.status.canceled[data-v-71467016], .status.cancelled[data-v-71467016], .status.failed[data-v-71467016] {\n    background: #bbb;\n}\n.status.upcoming[data-v-71467016] {\n    background: #f38d56;\n}\n.status.onboard[data-v-71467016] {\n    background: #dc3168;\n}\n.status.ready[data-v-71467016] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-71467016], .status.requires_dispatch[data-v-71467016] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-71467016] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-71467016] {\n    background: #5662f3;\n}\n.flight-status[data-v-71467016] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-71467016] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-71467016] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-71467016] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-71467016] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-71467016] {\n    background-color: #f35656;\n}\n.service-type[data-v-71467016] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-71467016] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-71467016] {\n    background: #26D97A;\n}\n.service-type.black[data-v-71467016] {\n    background: #777;\n}\n.service-type.suv[data-v-71467016] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-71467016] {\n    background: #6dabc3;\n}\n.license-type[data-v-71467016] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-71467016] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-71467016] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-71467016] {\n    background-color: #de6c2a;\n}\n.clearfix[data-v-71467016] {\n  clear: both;\n}\n.field-label[data-v-71467016] {\n  font-size: 13px;\n  color: #777;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.filter[data-v-71467016] {\n  padding-bottom: 15px;\n}\n.filter .row[data-v-71467016] {\n    max-width: inherit;\n    width: 100%;\n    margin: 0;\n}\n.filter .column[data-v-71467016]:not(:last-child) {\n    padding-right: 20px;\n}\n.filter .status[data-v-71467016] {\n    display: inline-block;\n    padding: 20px 15px;\n    width: 150px;\n}\n.search-box[data-v-71467016] {\n  display: block;\n  position: relative;\n}\n.search-box .error-msg[data-v-71467016] {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.search[data-v-71467016] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.search .search-input-box[data-v-71467016] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-71467016] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 3px 0 0 2px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-71467016] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-71467016] {\n      position: absolute;\n      top: 50%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n}\n.search button[data-v-71467016] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 3px 2px 0;\n    padding: 0 20px;\n}\n.data-field[data-v-71467016] {\n  padding-right: 10px;\n}\n.data-field.no-label[data-v-71467016] {\n    padding-top: 17px;\n}\n.data-field .label[data-v-71467016] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .datepicker[data-v-71467016] {\n    position: relative;\n}\nselect[data-v-71467016] {\n  padding: 10px;\n  height: 46px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-71467016] {\n    background-color: #ebebe4;\n}\n.date-range[data-v-71467016] {\n  position: relative;\n  display: inline-block;\n}\n.date-range select[data-v-71467016] {\n    width: 150px;\n    margin-right: 5px;\n}\n.date-range .error-msg[data-v-71467016] {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.datepicker-box[data-v-71467016] {\n  display: inline-block;\n  width: 110px;\n}\n.export[data-v-71467016] {\n  text-align: right;\n  padding: 15px 10px 0;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 130px;\n          flex: 0 130px;\n}\ntable[data-v-71467016] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n}\ntable thead[data-v-71467016] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-71467016] {\n      padding: 5px 10px;\n}\ntable thead th[data-v-71467016]:last-child {\n        cursor: default;\n}\ntable thead th i[data-v-71467016] {\n        display: none;\n}\ntable thead th i.stripe-icon[data-v-71467016] {\n        display: inline;\n}\ntable thead th .fa-sort-up[data-v-71467016] {\n        vertical-align: -2px;\n}\ntable thead th .fa-sort-down[data-v-71467016] {\n        vertical-align: 2px;\n}\ntable thead th.sortable[data-v-71467016] {\n        cursor: pointer;\n        color: #333;\n}\ntable thead th.sortable span[data-v-71467016] {\n          font-weight: 600;\n          text-decoration: underline;\n}\ntable thead th.sort i[data-v-71467016] {\n        display: inline-block;\n}\ntable tbody tr[data-v-71467016] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr[data-v-71467016]:nth-child(even) {\n      background: #f3f3f3;\n}\ntable tbody tr[data-v-71467016]:hover {\n      background: #d7dbe4;\n}\ntable tbody tr td[data-v-71467016] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      color: #555;\n}\ntable tbody tr td .status[data-v-71467016] {\n        line-height: 1.5;\n}\ntable tbody tr td.status[data-v-71467016], table tbody tr td.bookedThrough[data-v-71467016] {\n        font-weight: 600;\n}\ntable tbody tr td.table-block[data-v-71467016] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-71467016] {\n          color: #ccc;\n}\ntable tbody tr td a[data-v-71467016] {\n        font-weight: 600;\n        text-decoration: underline;\n        cursor: pointer;\n}\n.rsvp-type[data-v-71467016] {\n  text-transform: uppercase;\n  padding: 3px 5px;\n  color: #fff;\n  border-radius: 4px;\n}\n.rsvp-type.rsvp[data-v-71467016] {\n    background: #5771d0;\n}\n.rsvp-type.asap[data-v-71467016] {\n    background: #d05757;\n}\n.rsvp-type.package[data-v-71467016] {\n    background: #26d97a;\n}\n.booked-label[data-v-71467016] {\n  padding: 3px 5px;\n  background: #ccc;\n  color: #fff;\n  border-radius: 3px;\n  font-size: 12px;\n  font-weight: 700;\n}\n.booked-label.Web[data-v-71467016] {\n    background: #a26d5d;\n}\n.booked-label.Admin[data-v-71467016] {\n    background: #2b83f1;\n}\n.booked-label.Android[data-v-71467016] {\n    background: #78c259;\n}\n.booked-label.iOS[data-v-71467016] {\n    background: #7fc8de;\n}\n.booked-label.CSR[data-v-71467016] {\n    background: #bb4a91;\n}\n.booked-label.Provider[data-v-71467016] {\n    background: #3f3f3f;\n}\n.status-label[data-v-71467016] {\n  line-height: 1;\n  color: #fff;\n  padding: 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 11px !important;\n  background: #999;\n  display: inline-block;\n}\n.status-label.Purchased[data-v-71467016], .status-label.Purchase[data-v-71467016] {\n    background: #4aadf3;\n}\n.status-label.Completed[data-v-71467016] {\n    background: #26D97A;\n}\n.status-label.Promo[data-v-71467016] {\n    background: #f3904a;\n}\n.status-label.Edited[data-v-71467016], .status-label.Refund[data-v-71467016] {\n    background: #797979;\n}\n.status-label.No.Show[data-v-71467016], .status-label.Cancelled[data-v-71467016], .status-label.Declined[data-v-71467016] {\n    background: #f54f4f;\n}\n.slide-up-enter-active[data-v-71467016], .slide-up-leave-active[data-v-71467016] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-71467016], .slide-up-leave-to[data-v-71467016] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.service-label[data-v-71467016] {\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 12px;\n  text-transform: capitalize;\n}\n.service-label.shared[data-v-71467016] {\n    background: #f38d56;\n}\n.service-label.opoli[data-v-71467016] {\n    background: #26D97A;\n}\n.service-label.black[data-v-71467016] {\n    background: #777;\n}\n.service-label.SUV[data-v-71467016], .service-label.suv[data-v-71467016] {\n    background: #dc3168;\n}\n.service-label.shuttle[data-v-71467016] {\n    background: #6dabc3;\n}\n.hideMobile[data-v-71467016] {\n  display: none;\n}\n.datepicker-div[data-v-71467016] {\n  display: inline;\n}\n@media only screen and (max-width: 430px) {\n.datepicker-div[data-v-71467016] {\n    display: block;\n    margin-top: 5px;\n}\n.column[data-v-71467016] {\n    margin-bottom: 5px;\n}\n.export[data-v-71467016] {\n    text-align: center;\n}\n.cards .card[data-v-71467016] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n}\n.cards .card > div[data-v-71467016] {\n      margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-71467016] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n}\n.cards .card .card-header .time[data-v-71467016] {\n        font-size: 12px;\n        color: #777;\n        word-spacing: 5px;\n}\n.cards .card .card-header .amount[data-v-71467016] {\n        font-weight: 900;\n        font-size: 20px;\n}\n.cards .card .card-header .amount a[data-v-71467016] {\n          text-decoration: none;\n}\n.cards .card .tags[data-v-71467016] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n}\n.cards .card .tags .rsvp-type[data-v-71467016] {\n        font-size: 12px;\n        margin-right: 5px;\n}\n.cards .card .tags .rsvp-stats[data-v-71467016] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n}\n.cards .card .tags .status[data-v-71467016] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.cards .card .tags .status .refund[data-v-71467016] {\n          margin-left: 10px;\n}\n.cards .card .title[data-v-71467016] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .title .rsvpId[data-v-71467016] {\n        font-weight: 900;\n        margin-right: 10px;\n}\n.cards .card .label[data-v-71467016] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-71467016] {\n      margin-right: 10px;\n      font-size: 12px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__featureToggle__ = __webpack_require__(5);
/* global CONFIG */




/* harmony default export */ __webpack_exports__["a"] = ({
  getTransactions: function getTransactions(VueApp, conId, callback) {
    var self = this;
    var transactions = VueApp.$store.state.consumer.reservations;
    var pageSize = transactions.perPage;
    var page = transactions.currentPage;
    var pickupSince = __WEBPACK_IMPORTED_MODULE_0_moment___default()(transactions.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00');
    var pickupUntil = __WEBPACK_IMPORTED_MODULE_0_moment___default()(transactions.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59');
    if (transactions.date === 'all') {
      pickupSince = '2010-01-01 00:00';
      pickupUntil = __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(10, 'years').format('YYYY-MM-DD 23:59');
    }

    VueApp.$sdk.get('/consumer/' + conId + '/rsvp', {
      token: VueApp.$store.state.session.sessionToken,
      consId: conId,
      pageSize: pageSize,
      pageNum: page + 1,
      order: transactions.sort.column,
      orderAsc: transactions.sort.isDesc ? 0 : 1,
      since: pickupSince,
      until: pickupUntil,
      search: transactions.search,
      status: transactions.status
    }, function (res) {
      if (!res.error) {
        VueApp.$store.commit('consumer/setReservationsCurrentPage', page + 1);

        if (res.list.length < pageSize) {
          VueApp.$store.commit('consumer/setReservationsIsMax', true);
        }

        if (res.list.length) {
          var rsvp = res.list;
          for (var i = 0; i < res.list.length; i++) {
            var provider = rsvp[i].provider;
            // let consumer = rsvp[i].consumer
            var payment = rsvp[i].payment;
            var fareAmount = payment.fareAmount;
            if (rsvp[i].status !== 'complete' && rsvp[i].optinShared.isOptinShared && rsvp[i].optinShared.current === 'shared') {
              fareAmount = rsvp[i].optinShared.exclusive.amount;
            }
            var totalFare = fareAmount + payment.pickupFee + payment.tipAmount + rsvp[i].travelInsurance + rsvp[i].gasFee;
            if (rsvp[i].airportFee !== null) {
              totalFare = totalFare + rsvp[i].airportFee;
            }

            var pickup = rsvp[i].pickupLocation.geofenceType === 'airport' ? rsvp[i].pickupLocation.geofenceName : rsvp[i].pickupLocation.title;
            var dropoff = rsvp[i].dropoffLocation.geofenceType === 'airport' ? rsvp[i].dropoffLocation.geofenceName : rsvp[i].dropoffLocation.title;

            VueApp.$store.commit('consumer/addReservations', {
              date: __WEBPACK_IMPORTED_MODULE_0_moment___default()(rsvp[i].created, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_2__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
              providerId: provider.id,
              company: provider.businessName,
              rsvpId: rsvp[i].ID,
              pkgId: rsvp[i].packageId,
              type: rsvp[i].isAsap ? 'asap' : 'rsvp',
              status: rsvp[i].dispatchStatus,
              // firstName: consumer.firstName,
              // lastName: consumer.lastName,
              // mobile: consumer.phone,
              creditCard: rsvp[i].cardNumber,
              bookedThrough: self.bookedThroughLabel(rsvp[i].deviceType),
              finalOffer: self.toFixed(payment.offer),
              chargedAmount: self.toFixed(payment.charged),
              promoUsed: self.toFixed(payment.credit),
              statusLabel: rsvp[i].status,
              paymentURL: rsvp[i].paymentURL,
              externalId: rsvp[i].externalId || '',
              pickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(rsvp[i].pickupDate, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_2__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
              pickupLocation: pickup,
              dropoffLocation: dropoff,
              service: rsvp[i].serviceType,
              pax: rsvp[i].passengers,
              luggage: rsvp[i].luggage,
              flightNumber: rsvp[i].flightNumber || '',
              airline: rsvp[i].airline || '',
              fare: self.toFixed(totalFare) || '',
              flight: rsvp[i].airline && rsvp[i].flightNumber ? rsvp[i].airline + ' ' + rsvp[i].flightNumber : 'N/A',
              isCharter: rsvp[i].isCharter
            });
          }
        }
      }
      callback(res);
    });
  },
  exportTransactions: function exportTransactions(VueApp, conId, callback) {
    var self = this;
    var transactions = VueApp.$store.state.consumer.reservations;
    var pageSize = 99999;
    var page = 1;

    var since = __WEBPACK_IMPORTED_MODULE_0_moment___default()(transactions.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00');
    var until = __WEBPACK_IMPORTED_MODULE_0_moment___default()(transactions.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59');
    if (transactions.date === 'all') {
      since = '2010-01-01 00:00';
      until = __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(10, 'years').format('YYYY-MM-DD 23:59');
    }

    VueApp.$sdk.get('/transaction', {
      token: VueApp.$store.state.session.sessionToken,
      consId: conId,
      pageSize: pageSize,
      pageNum: page,
      order: transactions.sort.column,
      orderAsc: transactions.sort.isDesc ? 0 : 1,
      since: since,
      until: until,
      search: transactions.search,
      status: transactions.status,
      export: true
    }, function (res) {
      if (!res.error) {
        var rsvp = [];
        if (res.list.length) {
          res.list.forEach(function (value) {
            rsvp.push(self.buildExport(value));
          });
        }
        callback(rsvp);
      } else {
        callback(res);
      }
    });
  },
  toFixed: function toFixed(value) {
    value = parseFloat(value);
    if (value < 0) {
      return '-$' + Math.abs(value).toFixed(2);
    }
    return '$' + value.toFixed(2);
  },
  bookedThroughLabel: function bookedThroughLabel(value) {
    switch (value) {
      case 'ww':
        return 'Web';
      case 'admin':
        return 'Admin';
      case 'android':
        return 'Android App';
      case 'ios':
        return 'iOS App';
      case 'provider':
        return 'Provider';
      default:
        return value;
    }

    return '';
  },
  buildExport: function buildExport(data) {
    var rsvpId = this.convertBrand(data.brandId) + data.rsvpId;
    var serviceType = __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].getServiceName(data.serviceCode);
    var payment = data.payment;
    var creditCard = payment.cancelFee ? 'N/A' : data.cardNumber;
    var source = this.bookedThroughLabel(data.deviceType);
    var provLicense = data.provider.accountType || '';

    if (data.packageId) {
      rsvpId = data.packageId;
      serviceType = __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].getServiceName('shared');
      source = 'PKG';
    }
    if (!{"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.useOldQuatation) {
      serviceType = data.serviceType.label;
    }

    return {
      Date: __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY'),
      'Booking Time': __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('HH:mm:ss'),
      'Pickup Time': __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.pickupTime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm'),
      'Service Area': data.geofence.name,
      'Prov ID': data.provider.id,
      'Prov License': provLicense.toUpperCase(),
      'Company': data.provider.businessName,
      'RSVP ID': rsvpId,
      'Invoice ID': data.eventId,
      'Service Type': serviceType,
      'First Name': data.consumer.firstName,
      'Last Name': data.consumer.lastName,
      'Credit Card': creditCard,
      'Email': data.consumer.email,
      'Mobile': data.consumer.phone,
      'Source': source,
      'Final Offer': payment.offer || 0,
      'Charge Amount': payment.charged || 0,
      'Refunded Amount': -Math.abs(data.refundedAmount) || 0,
      'Promo Used': payment.credit || 0,
      'Driver Payment': payment.driverPay || 0,
      'Bonus': payment.bonus || 0,
      'Cancel Fees': payment.cancelFee || 0,
      'Status': data.status,
      'Pickup Location': data.pickupLocation,
      'Dropoff Location': data.dropoffLocation
    };
  },
  convertBrand: function convertBrand(id) {
    var index = {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands.findIndex(function (x) {
      return x.id === id;
    });
    if (!id || index === -1) {
      return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[0].code.toUpperCase();
    }

    return {"Env":"production","Gateway":{"host":"gateway.opoli.com","port":8081,"url":"https://gateway.opoli.com/","healthPath":"/"},"d2dAPI":"https://prodapi.door2dooranywhere.com","d2dGateway":"https://gateway23.opoli.com","oldBackofficeLink":"https://admin.opoli.com/","mediaHost":"https://media.opoli.com","optimizationHost":"https://opt.opoli.com","googleApiKey":"AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA","Firebase":{"apiKey":"AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk","authDomain":"opoli-production.firebaseapp.com","databaseURL":"https://opoli-production.firebaseio.com","projectId":"opoli-production","storageBucket":"opoli-production.appspot.com\"","messagingSenderId":"948692888036"},"hereApi":{"id":"0HVa2uc67AYd0cnqzAee","code":"Ar6I-EINztpimEq5fnplQA","key":"hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM"},"featureToggle":{"requiredDropoffAirport":false,"militaryTime":true},"brands":[{"id":2,"code":"op","trxCode":"op","name":"Opoli","url":"https://www.opoli.com/"},{"id":3,"code":"gs","trxCode":"gs","name":"GoSedan","url":"https://gosedan.com/"},{"id":4,"code":"pts","trxCode":"pt","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":5,"code":"s2l","trxCode":"sa","name":"Shuttle2LAX","url":"https://www.shuttletolax.com/"},{"id":6,"code":"pts","trxCode":"sv","name":"Prime Time Shuttle","url":"https://www.primetimeshuttle.com/"},{"id":7,"code":"fd","trxCode":"fd","name":"Fresh Deliveries","url":"https://www.opoli.com/"},{"id":8,"code":"bh","trxCode":"bh","name":"BeverlyHilton","url":"https://beverlyhilton.opoli.com/"},{"id":9,"code":"ms","trxCode":"ms","name":"Masimo","url":"https://masimo.primetimeshuttle.com/"},{"id":10,"code":"d2d","trxCode":"dd","name":"Door2Door","url":"https://door2doorflights.com/"},{"id":11,"code":"ip","trxCode":"ip","name":"IPW","url":"https://ipw.opoli.com/"},{"id":12,"code":"ro","trxCode":"ro","name":"Roland","url":"https://roland.opoli.com/"},{"id":13,"code":"gz","trxCode":"gz","name":"GozoCabs","url":"https://usatravel.gozocabs.com/"},{"id":14,"code":"bdp","trxCode":"bd","name":"Bobby Dee Presents","url":"https://bobbydeepresents.ridesharepro.com/"},{"id":15,"code":"ncp","trxCode":"nc","name":"NCP Mobility","url":"https://www.opoli.com/"},{"id":16,"code":"LH","trxCode":"pt","name":"Langham Hotels","url":"https://www.primetimeshuttle.com/"},{"id":17,"code":"bw","trxCode":"pt","name":"Best Western Hotels","url":"https://www.primetimeshuttle.com/"},{"id":18,"code":"bb","trxCode":"pt","name":"Big Bus Tours","url":"https://www.primetimeshuttle.com/"},{"id":19,"code":"rs","trxCode":"rs","name":"Prime Time Rideshare","url":"https://www.primetimerideshare.com/"},{"id":20,"code":"pm","trxCode":"pm","name":"PMCAA","url":"https://portal.primetimerideshare.com/pmcaa/"},{"id":21,"code":"fm","trxCode":"fm","name":"Fairmont","url":"https://portal.primetimerideshare.com/fairmont/"}],"serviceId":{"shared":5,"opoli":4,"black":3,"suv":2,"shuttle":1,"doorToDoor":49},"default":{"brandId":2,"laxAirportId":21,"laxServiceAreaId":[29,54,69,70,81,82,104,105,106,107,108,109,110,111,112,192,218,239,240,241,244,245,246,247,258,259,383,388,389,417,424,425,427,453,455,456,457,458,459,460,461,462,511,512,513,517,518,519,520,521,522,523,524,525,526,527,574,575]},"useOldQuatation":false,"Stripe":{"paymentURL":"https://dashboard.stripe.com/payments/","customerURL":"https://dashboard.stripe.com/customers/","accountURL":"https://dashboard.stripe.com/connect/accounts/","topupURL":"https://dashboard.stripe.com/topups","transferURL":"https://dashboard.stripe.com/connect/transfers","publishableKey":"pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv"},"socket":{"asap":{"host":"wss://dispatch.opoli.com","protocol":"echo-protocol"}},"goResUserId":219990,"quickResUserId":278079,"specialUser":[{"name":"Flip Flip","id":219990}],"lyftServiceIds":[201,208,215,218,216,207,203,212,206,210,217,209,205,213,211,202,204,214]}.brands[index].code.toUpperCase();
  }
});

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"filter"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column medium-3"},[_c('div',{staticClass:"search-box"},[_c('label',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.$t('transactions.filter.search'))+":")]),_vm._v(" "),_c('div',{staticClass:"search"},[_c('div',{staticClass:"search-input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],ref:"search",class:{'has-error':!!_vm.hasError.searchMsg},attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.searchInput)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search.apply(null, arguments)},"blur":_vm.blurSearch,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchInput.length > 0),expression:"searchInput.length > 0"}],staticClass:"far fa-times-circle fa-lg",on:{"click":_vm.clearSearch}})])],1),_vm._v(" "),_c('button',{class:{'button xsmall success':true, 'disabled':_vm.loading},on:{"click":_vm.search}},[_c('i',{staticClass:"fas fa-search fa-lg"})])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.hasError.searchMsg),expression:"!!hasError.searchMsg"}],staticClass:"error-msg"},[_vm._v("\n              "+_vm._s(_vm.hasError.searchMsg)+"\n            ")])])],1)]),_vm._v(" "),_c('div',{staticClass:"column medium-9"},[_c('div',{staticClass:"date-range"},[_c('label',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.$t('transactions.filter.dateRange'))+":")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateType),expression:"dateType"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dateType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.all')))]),_vm._v(" "),_c('option',{attrs:{"value":"custom"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.custom')))]),_vm._v(" "),_c('option',{attrs:{"value":"withinDay"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.withinDay')))]),_vm._v(" "),_c('option',{attrs:{"value":"monthToDate"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.monthToDate')))]),_vm._v(" "),_c('option',{attrs:{"value":"lastMonth"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.lastMonth')))]),_vm._v(" "),_c('option',{attrs:{"value":"lastWeek"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.lastWeek')))]),_vm._v(" "),_c('option',{attrs:{"value":"last2Week"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.last2Week')))]),_vm._v(" "),_c('option',{attrs:{"value":"last30Days"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.last30Days')))]),_vm._v(" "),_c('option',{attrs:{"value":"last60Days"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.last60Days')))]),_vm._v(" "),_c('option',{attrs:{"value":"last90Days"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.last90Days')))])]),_vm._v(" "),_c('div',{staticClass:"datepicker-div"},[_c('div',{staticClass:"datepicker-box"},[_c('datepicker',{ref:"datepickerFrom",class:{'datepicker inline':true, 'has-error':false},attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"input-class":{'datepicker-empty':_vm.hasError.from},"placeholder":_vm.$t('transactions.filter.from')},on:{"input":function($event){return _vm.updateFromTo('from')}},model:{value:(_vm.date.from),callback:function ($$v) {_vm.$set(_vm.date, "from", $$v)},expression:"date.from"}})],1),_vm._v(" "),_c('div',{staticClass:"datepicker-box"},[_c('datepicker',{ref:"datepickerTo",staticClass:"datepicker inline",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"input-class":{'datepicker-empty':_vm.hasError.to},"placeholder":_vm.$t('transactions.filter.to')},on:{"input":function($event){return _vm.updateFromTo('to')}},model:{value:(_vm.date.to),callback:function ($$v) {_vm.$set(_vm.date, "to", $$v)},expression:"date.to"}})],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.hasError.fromToMsg),expression:"!!hasError.fromToMsg"}],staticClass:"error-msg"},[_vm._v("\n              "+_vm._s(_vm.hasError.fromToMsg)+"\n            ")])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(!_vm.isMobile)?_c('table',[_c('thead',[_c('th',{class:{'sortable':true, 'sort':_vm.sort.active ==='created'},on:{"click":function($event){return _vm.sortTable('created')}}},[_vm._v("\n        Date Created\n        "),_c('i',{class:['fas', _vm.sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']})]),_vm._v(" "),_c('th',[_vm._v("Hudson ID")]),_vm._v(" "),_c('th',{class:{'sortable':true, 'sort':_vm.sort.active ==='rsvpId'},on:{"click":function($event){return _vm.sortTable('rsvpId')}}},[_vm._v("\n        ID\n        "),_c('i',{class:['fas', _vm.sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']})]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Pickup Time")]),_vm._v(" "),_c('th',[_vm._v("Pickup")]),_vm._v(" "),_c('th',[_vm._v("Dropoff")]),_vm._v(" "),_c('th',[_vm._v("Service")]),_vm._v(" "),_c('th',[_vm._v("PAX/Luggage")]),_vm._v(" "),_c('th',[_vm._v("Flight")]),_vm._v(" "),_c('th',[_vm._v("Fare")])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.transactions),function(trx){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions.length > 0),expression:"transactions.length > 0"}]},[_c('td',[_vm._v(_vm._s(trx.date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.externalId))]),_vm._v(" "),_c('td',[(trx.rsvpId !== 0)?_c('a',{attrs:{"href":'/#/reservation/' + trx.rsvpId,"target":"_blank"}},[_vm._v(_vm._s(trx.rsvpId))]):_c('a',{attrs:{"href":'/#/package/' + trx.pkgId,"target":"_blank"}},[_vm._v("\n            "+_vm._s(trx.pkgId)+" "),_c('i',{staticClass:"fa fa-cube"})])]),_vm._v(" "),_c('td',[_c('span',{class:'status ' + trx.status + ''},[_vm._v(_vm._s(_vm.getLabel(trx.status)))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.pickupTime))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.pickupLocation))]),_vm._v(" "),_c('td',[(trx.isCharter)?_c('span',[_vm._v("--")]):_c('span',[_vm._v(_vm._s(trx.dropoffLocation))])]),_vm._v(" "),_c('td',{staticClass:"service",attrs:{"width":"150"}},[(_vm.useOldQuatation)?_c('span',{class:['service-label', trx.service.name]},[_vm._v(_vm._s(_vm.serviceLabel(trx.service.id)))]):_c('span',{staticClass:"service-label",style:({backgroundColor: trx.service.color})},[_vm._v(_vm._s(trx.service.label))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.pax)+"/"+_vm._s(trx.luggage))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.flight))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.fare))])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_vm._m(0)]),_vm._v(" "),_c('tr',[_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions.length === 0 && !_vm.loading),expression:"transactions.length === 0 && !loading"}],staticClass:"table-block",attrs:{"colspan":"14"}},[_vm._v("\n          No reservations as of yet\n        ")])])],2)]):_c('div',[(_vm.transactions.length > 0)?_c('div',_vm._l((_vm.transactions),function(trx,i){return _c('div',{key:i,staticClass:"cards"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"time"},[_vm._v("\n              "+_vm._s(trx.date)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"amount"},[_c('strong',[_vm._v(_vm._s(trx.fare))])])]),_vm._v(" "),_c('div',{staticClass:"tags"},[_c('div',{staticClass:"service"},[(_vm.useOldQuatation)?_c('span',{class:['service-label', trx.service.name]},[_vm._v(_vm._s(_vm.serviceLabel(trx.service.id)))]):_c('span',{staticClass:"service-label",style:({backgroundColor: trx.service.color})},[_vm._v(_vm._s(trx.service.label))])]),_vm._v(" "),_c('div',{staticClass:"type"},[_c('span',{class:'status ' + trx.status + ''},[_vm._v(_vm._s(_vm.getLabel(trx.status)))])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("ID:")]),_vm._v(" "),_c('div',{staticClass:"rsvpId"},[(trx.rsvpId !== 0)?_c('a',{attrs:{"href":'/#/reservation/' + trx.rsvpId,"target":"_blank"}},[_vm._v(_vm._s(trx.rsvpId))]):_c('a',{attrs:{"href":'/#/package/' + trx.pkgId,"target":"_blank"}},[_vm._v("\n                "+_vm._s(trx.pkgId)+" "),_c('i',{staticClass:"fa fa-cube"})])]),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("Hudson ID:")]),_vm._v(" "),_c('div',[(trx.externalId)?_c('span',[_vm._v(_vm._s(trx.externalId))]):_c('span',[_vm._v("--")])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Pickup Time:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n              "+_vm._s(trx.pickupTime)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Pickup:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(trx.pickupLocation))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Dropoff:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(trx.dropoffLocation))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Pax/Luggage:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(trx.pax)+"/"+_vm._s(trx.luggage))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Flight:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(trx.flight))])])])])}),0):_c('div',[_vm._v("\n      No reservations as of yet "+_vm._s(_vm.transactions.length)+"\n    ")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"table-block",attrs:{"colspan":"14"}},[_c('i',{staticClass:"fa fa-circle-notch fa-spin"}),_vm._v("\n            Getting reservations...\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ratings_vue__ = __webpack_require__(402);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d9c124_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ratings_vue__ = __webpack_require__(1126);
function injectStyle (ssrContext) {
  __webpack_require__(1123)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69d9c124"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ratings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d9c124_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ratings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1124);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("6903d01b", content, true, {});

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.import[data-v-69d9c124] {\n  float: right;\n}\n.import .fa[data-v-69d9c124] {\n    margin-right: 5px;\n}\n.clearfix[data-v-69d9c124] {\n  clear: both;\n}\ntable[data-v-69d9c124] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n}\ntable thead[data-v-69d9c124] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-69d9c124] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-69d9c124] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-69d9c124] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.date[data-v-69d9c124], table tbody tr td.value[data-v-69d9c124] {\n        width: 160px;\n}\ntable tbody tr td.table-block[data-v-69d9c124] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-69d9c124] {\n          color: #ccc;\n}\n@media only screen and (max-width: 430px) {\n.cards .card[data-v-69d9c124] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n}\n.cards .card > div[data-v-69d9c124] {\n      margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-69d9c124] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n}\n.cards .card .card-header .time[data-v-69d9c124] {\n        font-size: 12px;\n        color: #777;\n        word-spacing: 5px;\n}\n.cards .card .card-header .rating[data-v-69d9c124] {\n        font-weight: 900;\n        font-size: 20px;\n}\n.cards .card .card-header .rating i[data-v-69d9c124] {\n          color: gold;\n}\n.cards .card .title[data-v-69d9c124] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .title .rsvpId[data-v-69d9c124] {\n        font-weight: 900;\n        margin-right: 10px;\n}\n.cards .card .label[data-v-69d9c124] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-69d9c124] {\n      margin-right: 10px;\n      font-size: 13px;\n      font-weight: 900;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Consumer/Ratings.vue"],"names":[],"mappings":";AACA;EACE,aAAa;CACd;AACD;IACI,kBAAkB;CACrB;AACD;EACE,YAAY;CACb;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;CAClB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,aAAa;CACpB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;AACA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,aAAa;IACb,oBAAoB;IACpB,+BAA+B;IAC/B,oBAAoB;CACvB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,uBAAuB;UACnB,oBAAoB;cAChB,sBAAsB;CACnC;AACD;QACQ,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;CACzB;AACD;QACQ,iBAAiB;QACjB,gBAAgB;CACvB;AACD;UACU,YAAY;CACrB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;QACQ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;MACM,gBAAgB;MAChB,0BAA0B;MAC1B,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;CACvB;AACD;MACM,mBAAmB;MACnB,gBAAgB;MAChB,iBAAiB;CACtB;CACA","file":"Ratings.vue","sourcesContent":["\n.import[data-v-69d9c124] {\n  float: right;\n}\n.import .fa[data-v-69d9c124] {\n    margin-right: 5px;\n}\n.clearfix[data-v-69d9c124] {\n  clear: both;\n}\ntable[data-v-69d9c124] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n}\ntable thead[data-v-69d9c124] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-69d9c124] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-69d9c124] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-69d9c124] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.date[data-v-69d9c124], table tbody tr td.value[data-v-69d9c124] {\n        width: 160px;\n}\ntable tbody tr td.table-block[data-v-69d9c124] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-69d9c124] {\n          color: #ccc;\n}\n@media only screen and (max-width: 430px) {\n.cards .card[data-v-69d9c124] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n}\n.cards .card > div[data-v-69d9c124] {\n      margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-69d9c124] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n}\n.cards .card .card-header .time[data-v-69d9c124] {\n        font-size: 12px;\n        color: #777;\n        word-spacing: 5px;\n}\n.cards .card .card-header .rating[data-v-69d9c124] {\n        font-weight: 900;\n        font-size: 20px;\n}\n.cards .card .card-header .rating i[data-v-69d9c124] {\n          color: gold;\n}\n.cards .card .title[data-v-69d9c124] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .title .rsvpId[data-v-69d9c124] {\n        font-weight: 900;\n        margin-right: 10px;\n}\n.cards .card .label[data-v-69d9c124] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-69d9c124] {\n      margin-right: 10px;\n      font-size: 13px;\n      font-weight: 900;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

// import ft from '../featureToggle'

/* harmony default export */ __webpack_exports__["a"] = ({
  getRatings: function getRatings(VueApp, conId, callback) {
    var ratings = VueApp.$store.state.consumer.ratings;
    var pageSize = ratings.perPage;
    var page = ratings.currentPage;

    VueApp.$sdk.get('/consumer/' + conId + '/reviews', {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: pageSize,
      pageNum: page + 1
    }, function (res) {
      if (!res.error) {
        VueApp.$store.commit('consumer/setRatingsCurrentPage', page + 1);

        if (res.list.length < pageSize) {
          VueApp.$store.commit('consumer/setRatingsIsMax', true);
        }

        if (res.list.length) {
          var rating = res.list;
          for (var i = 0; i < res.list.length; i++) {
            VueApp.$store.commit('consumer/addRatings', {
              id: rating[i].id,
              // date: moment(rating[i].created, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, true)),
              date: __WEBPACK_IMPORTED_MODULE_0_moment___default()(rating[i].created, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm:ss'),
              provName: rating[i].provider.businessName,
              provId: rating[i].provider.id,
              rsvpId: rating[i].rsvpId,
              value: rating[i].value,
              message: rating[i].message
            });
          }
        }
      }
      callback(res);
    });
  }
});

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"clearfix"}),_vm._v(" "),(!_vm.isMobile)?_c('table',[_c('thead',[_c('th',[_vm._v(_vm._s(_vm.$t('consumer.ratings.date')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.ratings.rsvpId')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.ratings.provBusinessName')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.ratings.msg')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.ratings.rating')))])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.ratings),function(rating){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.ratings.length > 0),expression:"ratings.length > 0"}]},[_c('td',{staticClass:"date"},[_vm._v(_vm._s(rating.date))]),_vm._v(" "),_c('td',{staticClass:"rsvp"},[_c('a',{attrs:{"href":'/#/reservation/' + rating.rsvpId}},[_vm._v(_vm._s(rating.rsvpId))])]),_vm._v(" "),_c('td',{staticClass:"prov"},[_c('a',{attrs:{"href":'/#/provider/' + rating.provId}},[_vm._v(_vm._s(rating.provName))])]),_vm._v(" "),_c('td',{staticClass:"message"},[_vm._v(_vm._s(rating.message))]),_vm._v(" "),_c('td',{staticClass:"value"},[_vm._v(_vm._s(rating.value))])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-circle-notch fa-spin"}),_vm._v("\n            "+_vm._s(_vm.$t('consumer.ratings.loading'))+"\n        ")])]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.ratings.length === 0 && !_vm.loading),expression:"ratings.length === 0 && !loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"5"}},[_vm._v("\n          "+_vm._s(_vm.$t('consumer.ratings.emptyState'))+"\n        ")])])],2)]):_c('div',[(_vm.ratings.length > 0)?_c('div',_vm._l((_vm.ratings),function(rating,i){return _c('div',{key:i,staticClass:"cards"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"title card-header"},[_c('div',{staticClass:"time"},[_vm._v(_vm._s(rating.date))]),_vm._v(" "),_c('div',{staticClass:"rating"},[_vm._v(_vm._s(rating.value)+" "),_c('i',{staticClass:"fas fa-star"})])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("RSVP ID:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":'/#/reservation/' + rating.rsvpId}},[_vm._v(_vm._s(rating.rsvpId))])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Provider:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":'/#/provider/' + rating.provId}},[_vm._v(_vm._s(rating.provName))])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Message:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n              "+_vm._s(rating.message ? rating.message : '--')+"\n            ")])])])])}),0):_c('div',[_vm._v(_vm._s(_vm.$t('consumer.ratings.emptyState')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreditCards_vue__ = __webpack_require__(403);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9438a5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreditCards_vue__ = __webpack_require__(1130);
function injectStyle (ssrContext) {
  __webpack_require__(1128)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d9438a5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreditCards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9438a5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreditCards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1129);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("74cf615e", content, true, {});

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.import[data-v-d9438a5e] {\n  float: right;\n}\n.import .fa[data-v-d9438a5e] {\n    margin-right: 5px;\n}\n.clearfix[data-v-d9438a5e] {\n  clear: both;\n}\ntable[data-v-d9438a5e] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n}\ntable thead[data-v-d9438a5e] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-d9438a5e] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-d9438a5e] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-d9438a5e] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-d9438a5e] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-d9438a5e] {\n          color: #ccc;\n}\n.status[data-v-d9438a5e] {\n  text-transform: uppercase;\n  font-weight: 600;\n}\n.status.verified[data-v-d9438a5e] {\n    color: #26D97A;\n}\n.status.unverified[data-v-d9438a5e] {\n    color: #F20D0D;\n}\n@media only screen and (max-width: 430px) {\n.cards .card[data-v-d9438a5e] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n}\n.cards .card > div[data-v-d9438a5e] {\n      margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-d9438a5e] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n}\n.cards .card .card-header .time[data-v-d9438a5e] {\n        font-size: 12px;\n        color: #777;\n        word-spacing: 5px;\n}\n.cards .card .credit-card[data-v-d9438a5e] {\n      font-weight: 900;\n}\n.cards .card .title[data-v-d9438a5e] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .label[data-v-d9438a5e] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-d9438a5e] {\n      margin-right: 10px;\n      font-size: 13px;\n      font-weight: 900;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Consumer/CreditCards.vue"],"names":[],"mappings":";AACA;EACE,aAAa;CACd;AACD;IACI,kBAAkB;CACrB;AACD;EACE,YAAY;CACb;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;CAClB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;EACE,0BAA0B;EAC1B,iBAAiB;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;AACA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,aAAa;IACb,oBAAoB;IACpB,+BAA+B;IAC/B,oBAAoB;CACvB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,uBAAuB;UACnB,oBAAoB;cAChB,sBAAsB;CACnC;AACD;QACQ,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;CACzB;AACD;MACM,iBAAiB;CACtB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;MACM,gBAAgB;MAChB,0BAA0B;MAC1B,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;CACvB;AACD;MACM,mBAAmB;MACnB,gBAAgB;MAChB,iBAAiB;CACtB;CACA","file":"CreditCards.vue","sourcesContent":["\n.import[data-v-d9438a5e] {\n  float: right;\n}\n.import .fa[data-v-d9438a5e] {\n    margin-right: 5px;\n}\n.clearfix[data-v-d9438a5e] {\n  clear: both;\n}\ntable[data-v-d9438a5e] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n}\ntable thead[data-v-d9438a5e] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-d9438a5e] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-d9438a5e] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-d9438a5e] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-d9438a5e] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-d9438a5e] {\n          color: #ccc;\n}\n.status[data-v-d9438a5e] {\n  text-transform: uppercase;\n  font-weight: 600;\n}\n.status.verified[data-v-d9438a5e] {\n    color: #26D97A;\n}\n.status.unverified[data-v-d9438a5e] {\n    color: #F20D0D;\n}\n@media only screen and (max-width: 430px) {\n.cards .card[data-v-d9438a5e] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n}\n.cards .card > div[data-v-d9438a5e] {\n      margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-d9438a5e] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n}\n.cards .card .card-header .time[data-v-d9438a5e] {\n        font-size: 12px;\n        color: #777;\n        word-spacing: 5px;\n}\n.cards .card .credit-card[data-v-d9438a5e] {\n      font-weight: 900;\n}\n.cards .card .title[data-v-d9438a5e] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .label[data-v-d9438a5e] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-d9438a5e] {\n      margin-right: 10px;\n      font-size: 13px;\n      font-weight: 900;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"clearfix"}),_vm._v(" "),(!_vm.isMobile)?_c('table',[_c('thead',[_c('th',[_vm._v(_vm._s(_vm.$t('consumer.creditCards.addedOn')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.creditCards.creditCard')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.creditCards.address')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.creditCards.city')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.creditCards.state')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.creditCards.zip')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.creditCards.status')))])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.creditCards),function(card){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.creditCards.length > 0),expression:"creditCards.length > 0"}]},[_c('td',[_vm._v(_vm._s(card.date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(card.card))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(card.address))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(card.city))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(card.state))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(card.zip))]),_vm._v(" "),_c('td',{class:['status', _vm.cardStatus(card.status)]},[_vm._v(_vm._s(_vm.cardStatus(card.status)))])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"7"}},[_c('i',{staticClass:"fa fa-circle-notch fa-spin"}),_vm._v("\n            "+_vm._s(_vm.$t('consumer.creditCards.loading'))+"\n        ")])]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.creditCards.length === 0 && !_vm.loading),expression:"creditCards.length === 0 && !loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"7"}},[_vm._v("\n          "+_vm._s(_vm.$t('consumer.creditCards.emptyState'))+"\n        ")])])],2)]):_c('div',[(_vm.creditCards.length > 0)?_c('div',_vm._l((_vm.creditCards),function(card,i){return _c('div',{key:i,staticClass:"cards"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"title card-header"},[_c('div',{staticClass:"time"},[_vm._v(_vm._s(card.date))]),_vm._v(" "),_c('div',{class:['status', _vm.cardStatus(card.status)]},[_vm._v(_vm._s(_vm.cardStatus(card.status)))])]),_vm._v(" "),_c('div',{staticClass:"credit-card"},[_c('i',{staticClass:"fas fa-credit-card"}),_vm._v(" "+_vm._s(card.card)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Address:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(card.address ? card.address : '--'))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("City:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(card.city ? card.city : '--'))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("State:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(card.state ? card.state : '--'))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("ZIP:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(card.zip ? card.zip : '--'))])])])])}),0):_c('div',[_vm._v("\n      "+_vm._s(_vm.$t('consumer.creditCards.emptyState'))+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoCodes_vue__ = __webpack_require__(405);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff1b2da4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoCodes_vue__ = __webpack_require__(1135);
function injectStyle (ssrContext) {
  __webpack_require__(1132)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ff1b2da4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoCodes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff1b2da4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoCodes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1133);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("b4f53936", content, true, {});

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.credit-box[data-v-ff1b2da4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.c-box[data-v-ff1b2da4] {\n  border: 1px solid #ccc;\n  background: #f3f3f3;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  line-height: 1;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.c-box label[data-v-ff1b2da4] {\n    font-size: 13px;\n    color: #111;\n    padding: 0 5px;\n    letter-spacing: .6px;\n}\n.c-box .value[data-v-ff1b2da4] {\n    background: #fff;\n    padding: 7px 10px;\n    text-align: center;\n    font-weight: 600;\n}\n.c-box .refresh[data-v-ff1b2da4] {\n    padding: 7px 10px;\n    background: #5da4ed;\n    color: #fff;\n    cursor: pointer;\n}\n.c-box .refresh[data-v-ff1b2da4]:hover {\n      background: #71b0f0;\n}\n.c-box .refresh.disabled[data-v-ff1b2da4] {\n      background: #eee;\n      cursor: default;\n}\ntable[data-v-ff1b2da4] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n}\ntable thead[data-v-ff1b2da4] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-ff1b2da4] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-ff1b2da4] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-ff1b2da4] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n      color: #555;\n}\ntable tbody tr td.code[data-v-ff1b2da4] {\n        font-weight: 600;\n}\ntable tbody tr td.empty-state[data-v-ff1b2da4] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\n@media only screen and (max-width: 430px) {\n.cards .card[data-v-ff1b2da4] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n}\n.cards .card > div[data-v-ff1b2da4] {\n      margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-ff1b2da4] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n}\n.cards .card .card-header .time[data-v-ff1b2da4] {\n        font-size: 12px;\n        color: #777;\n        word-spacing: 5px;\n}\n.cards .card .title[data-v-ff1b2da4] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .label[data-v-ff1b2da4] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-ff1b2da4] {\n      margin-right: 10px;\n      font-size: 13px;\n      font-weight: 900;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Consumer/PromoCodes.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;MAClB,mBAAmB;UACf,0BAA0B;CACnC;AACD;EACE,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;CAC7B;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,qBAAqB;CACxB;AACD;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;CACpB;AACD;IACI,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;CACnB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,iBAAiB;MACjB,gBAAgB;CACrB;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;CAClB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;MACnB,YAAY;CACjB;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;AACA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,aAAa;IACb,oBAAoB;IACpB,+BAA+B;IAC/B,oBAAoB;CACvB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,uBAAuB;UACnB,oBAAoB;cAChB,sBAAsB;CACnC;AACD;QACQ,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;CACzB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;MACM,gBAAgB;MAChB,0BAA0B;MAC1B,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;CACvB;AACD;MACM,mBAAmB;MACnB,gBAAgB;MAChB,iBAAiB;CACtB;CACA","file":"PromoCodes.vue","sourcesContent":["\n.credit-box[data-v-ff1b2da4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.c-box[data-v-ff1b2da4] {\n  border: 1px solid #ccc;\n  background: #f3f3f3;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  line-height: 1;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.c-box label[data-v-ff1b2da4] {\n    font-size: 13px;\n    color: #111;\n    padding: 0 5px;\n    letter-spacing: .6px;\n}\n.c-box .value[data-v-ff1b2da4] {\n    background: #fff;\n    padding: 7px 10px;\n    text-align: center;\n    font-weight: 600;\n}\n.c-box .refresh[data-v-ff1b2da4] {\n    padding: 7px 10px;\n    background: #5da4ed;\n    color: #fff;\n    cursor: pointer;\n}\n.c-box .refresh[data-v-ff1b2da4]:hover {\n      background: #71b0f0;\n}\n.c-box .refresh.disabled[data-v-ff1b2da4] {\n      background: #eee;\n      cursor: default;\n}\ntable[data-v-ff1b2da4] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n}\ntable thead[data-v-ff1b2da4] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-ff1b2da4] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-ff1b2da4] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-ff1b2da4] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n      color: #555;\n}\ntable tbody tr td.code[data-v-ff1b2da4] {\n        font-weight: 600;\n}\ntable tbody tr td.empty-state[data-v-ff1b2da4] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\n@media only screen and (max-width: 430px) {\n.cards .card[data-v-ff1b2da4] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n}\n.cards .card > div[data-v-ff1b2da4] {\n      margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-ff1b2da4] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n}\n.cards .card .card-header .time[data-v-ff1b2da4] {\n        font-size: 12px;\n        color: #777;\n        word-spacing: 5px;\n}\n.cards .card .title[data-v-ff1b2da4] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .label[data-v-ff1b2da4] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-ff1b2da4] {\n      margin-right: 10px;\n      font-size: 13px;\n      font-weight: 900;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

// import ft from '../featureToggle'

/* harmony default export */ __webpack_exports__["a"] = ({
  getPromoCodes: function getPromoCodes(VueApp, conId, callback) {
    var promoCodes = VueApp.$store.state.consumer.promoCodes;
    var pageSize = promoCodes.perPage;
    var page = promoCodes.currentPage;

    VueApp.$sdk.get('/consumer/' + conId + '/promocodes', {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: pageSize,
      pageNum: page + 1
    }, function (res) {
      if (!res.error) {
        VueApp.$store.commit('consumer/setPromoCodesCurrentPage', page + 1);

        if (res.list.length < pageSize) {
          VueApp.$store.commit('consumer/setPromoCodesIsMax', true);
        }

        if (res.list.length) {
          var promoCode = res.list;
          for (var i = 0; i < res.list.length; i++) {
            var redeemDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(promoCode[i].redeemedDate, 'YYYY-MM-DD HH:mm:ss');
            VueApp.$store.commit('consumer/addPromoCodes', {
              date: redeemDate.format('MM/DD/YYYY HH:mm:ss'),
              code: promoCode[i].promoCode,
              value: promoCode[i].amount,
              redeemedAmount: promoCode[i].redeemedAmount,
              type: promoCode[i].type,
              // expires: redeemDate.add(promoCode[i].redeemedValidDays, 'days').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, true))
              expires: redeemDate.add(promoCode[i].redeemedValidDays, 'days').format('MM/DD/YYYY HH:mm:ss')
            });
          }
        }
      }
      callback(res);
    });
  }
});

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"credit-box"},[_c('div',{staticClass:"c-box"},[_c('label',[_vm._v("CREDITS:")]),_vm._v(" "),_c('div',{staticClass:"value"},[(!_vm.cLoading)?_c('span',[_vm._v(_vm._s(_vm.credits))]):_c('i',{staticClass:"fas fa-spinner fa-spin"})]),_vm._v(" "),_c('div',{class:['refresh', {disabled:_vm.cLoading}],on:{"click":_vm.getCredits}},[_c('i',{staticClass:"fas fa-sync"})])])]),_vm._v(" "),(!_vm.isMobile)?_c('table',[_c('thead',[_c('th',[_vm._v(_vm._s(_vm.$t('consumer.promoCodes.date')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.promoCodes.code')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.promoCodes.value')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.promoCodes.type')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.promoCodes.expires')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.promoCodes.amountUsed')))])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.promoCodes),function(promoCode){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.promoCodes.length > 0),expression:"promoCodes.length > 0"}]},[_c('td',[_vm._v(_vm._s(promoCode.date))]),_vm._v(" "),_c('td',{staticClass:"code"},[_vm._v(_vm._s(promoCode.code))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(promoCode.value)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promoCode.type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promoCode.expires))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(promoCode.redeemedAmount)))])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"6"}},[_c('i',{staticClass:"fa fa-circle-notch fa-spin"}),_vm._v("\n            "+_vm._s(_vm.$t('consumer.promoCodes.loading'))+"\n        ")])]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.promoCodes.length === 0 && !_vm.loading),expression:"promoCodes.length === 0 && !loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"6"}},[_vm._v("\n          "+_vm._s(_vm.$t('consumer.promoCodes.emptyState'))+"\n        ")])])],2)]):_c('div',[(_vm.promoCodes.length > 0)?_c('div',_vm._l((_vm.promoCodes),function(promoCode,i){return _c('div',{key:i,staticClass:"cards"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"title card-header"},[_c('div',{staticClass:"time"},[_vm._v(_vm._s(promoCode.date))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Promo Code:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(promoCode.code ? promoCode.code : '--'))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Value:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("$"+_vm._s(_vm.toFixed(promoCode.value)))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Type:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(promoCode.type))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Expires:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(promoCode.expires))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Amount Used:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("$"+_vm._s(_vm.toFixed(promoCode.redeemedAmount)))])])])])}),0):_c('div',[_vm._v("\n      "+_vm._s(_vm.$t('consumer.promoCodes.emptyState'))+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logs_vue__ = __webpack_require__(406);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35b4b3f9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logs_vue__ = __webpack_require__(1139);
function injectStyle (ssrContext) {
  __webpack_require__(1137)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35b4b3f9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35b4b3f9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1138);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("3d7adb83", content, true, {});

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.logs-box[data-v-35b4b3f9] {\n  background: #fff;\n  border-top: 1px solid #e3e3e3;\n  overflow-y: auto;\n  height: calc(100% - 50px);\n}\n.date-range[data-v-35b4b3f9] {\n  padding: 20px;\n  background: #fafafa;\n  border-bottom: 1px solid #eee;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.date-range .small-6[data-v-35b4b3f9]:first-child {\n    padding-right: 10px;\n}\n.date-range .datepicker[data-v-35b4b3f9] {\n    margin-bottom: 5px;\n}\n.date-range .error-msg[data-v-35b4b3f9] {\n    background: #ff6115;\n    border-radius: 3px;\n    font-size: 13px;\n    color: #fff;\n    display: block;\n    padding: 4px;\n    margin-bottom: 7px;\n    font-style: italic;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.list[data-v-35b4b3f9] {\n  padding: 20px;\n}\n.action[data-v-35b4b3f9] {\n  border: 1px solid #ddd;\n  width: 100%;\n  max-height: auto;\n  padding: 10px;\n  background: #fafafa;\n  overflow: hidden;\n  -webkit-transition: all 0.35s ease-in-out;\n  transition: all 0.35s ease-in-out;\n  cursor: pointer;\n  margin-bottom: 10px;\n}\n.action[data-v-35b4b3f9]:hover {\n    background: #fff8dc;\n}\n.action.collapsed[data-v-35b4b3f9] {\n    padding: 10px;\n    background: #fff8dc;\n}\n.action .log-heading[data-v-35b4b3f9] {\n    margin: 0;\n    font-weight: 600;\n}\n.action .action-item[data-v-35b4b3f9] {\n    padding-left: 15px;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.action .action-item .icon-display[data-v-35b4b3f9] {\n      float: left;\n      width: 5%;\n}\n.action .action-item .icon-display i[data-v-35b4b3f9] {\n        font-size: 11px;\n        color: #666;\n}\n.action .action-item .action-display[data-v-35b4b3f9] {\n      float: left;\n      width: 95%;\n      margin-top: 10px;\n}\n.action .action-item .log-details[data-v-35b4b3f9] {\n      font-size: 11px;\n      color: #666;\n}\n.action .action-item .log-data[data-v-35b4b3f9] {\n      margin-bottom: 2px;\n}\n.action .minimize[data-v-35b4b3f9] {\n    font-size: 11px;\n    color: #666;\n    content: \"\";\n    clear: both;\n}\n.action .minimize .icon-display[data-v-35b4b3f9] {\n      float: left;\n      width: 5%;\n}\n.action .minimize .icon-display i[data-v-35b4b3f9] {\n        font-size: 11px;\n        color: #666;\n}\n.action .minimize .action-display[data-v-35b4b3f9] {\n      float: left;\n      width: 95%;\n}\n.action .minimize .action-display p[data-v-35b4b3f9] {\n        margin: 0;\n}\n.loader[data-v-35b4b3f9] {\n  text-align: center;\n  padding: 10px;\n  font-size: 21px;\n  color: #bbb;\n  font-weight: 600;\n}\n.loader i[data-v-35b4b3f9] {\n    margin-right: 3px;\n}\n.empty-state[data-v-35b4b3f9] {\n  padding: 30px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\n.empty-state .fa[data-v-35b4b3f9] {\n    display: block;\n    margin-bottom: 5px;\n    color: #ccc;\n    text-shadow: 0 0 5px white;\n}\n.slide-down-enter-active[data-v-35b4b3f9],\n.slide-down-leave-active[data-v-35b4b3f9] {\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.slide-down-enter[data-v-35b4b3f9],\n.slide-down-leave-to[data-v-35b4b3f9] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n.slide-up-enter-active[data-v-35b4b3f9],\n.slide-up-leave-active[data-v-35b4b3f9] {\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n.slide-up-enter[data-v-35b4b3f9],\n.slide-up-leave-to[data-v-35b4b3f9] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.service-label[data-v-35b4b3f9] {\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 12px;\n  display: inline-block;\n  margin-top: 2px;\n  text-transform: capitalize;\n}\n.service-label.shared[data-v-35b4b3f9] {\n    background: #f38d56;\n}\n.service-label.opoli[data-v-35b4b3f9] {\n    background: #26d97a;\n}\n.service-label.black[data-v-35b4b3f9] {\n    background: #777;\n}\n.service-label.SUV[data-v-35b4b3f9], .service-label.suv[data-v-35b4b3f9] {\n    background: #dc3168;\n}\n.service-label.shuttle[data-v-35b4b3f9] {\n    background: #6dabc3;\n}\n@media only screen and (max-width: 430px) {\n.list[data-v-35b4b3f9] {\n    padding-bottom: 100px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Consumer/Logs.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,iBAAiB;EACjB,0BAA0B;CAC3B;AACD;EACE,cAAc;EACd,oBAAoB;EACpB,8BAA8B;EAC9B,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;IACI,oBAAoB;CACvB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;EACE,cAAc;CACf;AACD;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,0CAA0C;EAC1C,kCAAkC;EAClC,gBAAgB;EAChB,oBAAoB;CACrB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,cAAc;IACd,oBAAoB;CACvB;AACD;IACI,UAAU;IACV,iBAAiB;CACpB;AACD;IACI,mBAAmB;IACnB,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;MACM,YAAY;MACZ,UAAU;CACf;AACD;QACQ,gBAAgB;QAChB,YAAY;CACnB;AACD;MACM,YAAY;MACZ,WAAW;MACX,iBAAiB;CACtB;AACD;MACM,gBAAgB;MAChB,YAAY;CACjB;AACD;MACM,mBAAmB;CACxB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,YAAY;CACf;AACD;MACM,YAAY;MACZ,UAAU;CACf;AACD;QACQ,gBAAgB;QAChB,YAAY;CACnB;AACD;MACM,YAAY;MACZ,WAAW;CAChB;AACD;QACQ,UAAU;CACjB;AACD;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;CAClB;AACD;IACI,kBAAkB;CACrB;AACD;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;CAC9B;AACD;;EAEE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;;EAEE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ;AACD;;EAEE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;;EAEE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;CAC5B;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;AACA;IACI,sBAAsB;CACzB;CACA","file":"Logs.vue","sourcesContent":["\n.logs-box[data-v-35b4b3f9] {\n  background: #fff;\n  border-top: 1px solid #e3e3e3;\n  overflow-y: auto;\n  height: calc(100% - 50px);\n}\n.date-range[data-v-35b4b3f9] {\n  padding: 20px;\n  background: #fafafa;\n  border-bottom: 1px solid #eee;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.date-range .small-6[data-v-35b4b3f9]:first-child {\n    padding-right: 10px;\n}\n.date-range .datepicker[data-v-35b4b3f9] {\n    margin-bottom: 5px;\n}\n.date-range .error-msg[data-v-35b4b3f9] {\n    background: #ff6115;\n    border-radius: 3px;\n    font-size: 13px;\n    color: #fff;\n    display: block;\n    padding: 4px;\n    margin-bottom: 7px;\n    font-style: italic;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.list[data-v-35b4b3f9] {\n  padding: 20px;\n}\n.action[data-v-35b4b3f9] {\n  border: 1px solid #ddd;\n  width: 100%;\n  max-height: auto;\n  padding: 10px;\n  background: #fafafa;\n  overflow: hidden;\n  -webkit-transition: all 0.35s ease-in-out;\n  transition: all 0.35s ease-in-out;\n  cursor: pointer;\n  margin-bottom: 10px;\n}\n.action[data-v-35b4b3f9]:hover {\n    background: #fff8dc;\n}\n.action.collapsed[data-v-35b4b3f9] {\n    padding: 10px;\n    background: #fff8dc;\n}\n.action .log-heading[data-v-35b4b3f9] {\n    margin: 0;\n    font-weight: 600;\n}\n.action .action-item[data-v-35b4b3f9] {\n    padding-left: 15px;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.action .action-item .icon-display[data-v-35b4b3f9] {\n      float: left;\n      width: 5%;\n}\n.action .action-item .icon-display i[data-v-35b4b3f9] {\n        font-size: 11px;\n        color: #666;\n}\n.action .action-item .action-display[data-v-35b4b3f9] {\n      float: left;\n      width: 95%;\n      margin-top: 10px;\n}\n.action .action-item .log-details[data-v-35b4b3f9] {\n      font-size: 11px;\n      color: #666;\n}\n.action .action-item .log-data[data-v-35b4b3f9] {\n      margin-bottom: 2px;\n}\n.action .minimize[data-v-35b4b3f9] {\n    font-size: 11px;\n    color: #666;\n    content: \"\";\n    clear: both;\n}\n.action .minimize .icon-display[data-v-35b4b3f9] {\n      float: left;\n      width: 5%;\n}\n.action .minimize .icon-display i[data-v-35b4b3f9] {\n        font-size: 11px;\n        color: #666;\n}\n.action .minimize .action-display[data-v-35b4b3f9] {\n      float: left;\n      width: 95%;\n}\n.action .minimize .action-display p[data-v-35b4b3f9] {\n        margin: 0;\n}\n.loader[data-v-35b4b3f9] {\n  text-align: center;\n  padding: 10px;\n  font-size: 21px;\n  color: #bbb;\n  font-weight: 600;\n}\n.loader i[data-v-35b4b3f9] {\n    margin-right: 3px;\n}\n.empty-state[data-v-35b4b3f9] {\n  padding: 30px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\n.empty-state .fa[data-v-35b4b3f9] {\n    display: block;\n    margin-bottom: 5px;\n    color: #ccc;\n    text-shadow: 0 0 5px white;\n}\n.slide-down-enter-active[data-v-35b4b3f9],\n.slide-down-leave-active[data-v-35b4b3f9] {\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.slide-down-enter[data-v-35b4b3f9],\n.slide-down-leave-to[data-v-35b4b3f9] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n.slide-up-enter-active[data-v-35b4b3f9],\n.slide-up-leave-active[data-v-35b4b3f9] {\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n.slide-up-enter[data-v-35b4b3f9],\n.slide-up-leave-to[data-v-35b4b3f9] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.service-label[data-v-35b4b3f9] {\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 12px;\n  display: inline-block;\n  margin-top: 2px;\n  text-transform: capitalize;\n}\n.service-label.shared[data-v-35b4b3f9] {\n    background: #f38d56;\n}\n.service-label.opoli[data-v-35b4b3f9] {\n    background: #26d97a;\n}\n.service-label.black[data-v-35b4b3f9] {\n    background: #777;\n}\n.service-label.SUV[data-v-35b4b3f9], .service-label.suv[data-v-35b4b3f9] {\n    background: #dc3168;\n}\n.service-label.shuttle[data-v-35b4b3f9] {\n    background: #6dabc3;\n}\n@media only screen and (max-width: 430px) {\n.list[data-v-35b4b3f9] {\n    padding-bottom: 100px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logs-box",on:{"scroll":_vm.onScroll}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDateRange),expression:"showDateRange"}],staticClass:"date-range"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-6"},[_c('datepicker',{staticClass:"datepicker small inline",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"input-class":{'datepicker-empty':_vm.error.from},"placeholder":_vm.$t('transactions.filter.from')},on:{"input":function($event){return _vm.changeDate('from')}},model:{value:(_vm.date.from),callback:function ($$v) {_vm.$set(_vm.date, "from", $$v)},expression:"date.from"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('datepicker',{staticClass:"datepicker small inline left-side",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"input-class":{'datepicker-empty':_vm.error.to},"placeholder":_vm.$t('transactions.filter.to')},on:{"input":function($event){return _vm.changeDate('to')}},model:{value:(_vm.date.to),callback:function ($$v) {_vm.$set(_vm.date, "to", $$v)},expression:"date.to"}})],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[(!!_vm.error.message)?_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.message))]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"cta button block xsmall success",on:{"click":_vm.dateApply}},[_vm._v("Submit")])],1)]),_vm._v(" "),_c('div',{staticClass:"list"},[_vm._l((_vm.logs),function(log,i){return _c('div',{key:i,class:{'action':true, 'collapsed':log.collapsed},on:{"click":function($event){log.show = !log.show}}},[_c('div',{staticClass:"minimize"},[_c('div',{staticClass:"icon-display"},[(!log.show)?_c('i',{staticClass:"fa fa-plus-circle"}):_c('i',{staticClass:"fa fa-minus-circle"})]),_vm._v(" "),_c('div',{staticClass:"action-display"},[_c('span',[_vm._v(_vm._s(log.created))]),_vm._v(" "),_c('div',{staticClass:"log-heading"},[_vm._v(_vm._s(_vm.title(log)))])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(log.show),expression:"log.show"}],staticClass:"action-item"},[_c('div',{staticClass:"icon-display"}),_vm._v(" "),_c('div',{staticClass:"action-display"},[_c('div',{staticClass:"log-details"},[( log.details.packageID)?_c('div',{staticClass:"log-data"},[_vm._v("\n                Package ID:\n                "),_c('a',{attrs:{"href":("#/package/" + (log.details.packageID)),"target":"_blank"}},[_vm._v(_vm._s(log.details.packageID))])]):_vm._e(),_vm._v(" "),(_vm.showRsvpId.indexOf(log.action) > -1)?_c('div',{staticClass:"log-data"},[_vm._v("\n                Reservation ID:\n                "),_c('a',{attrs:{"href":("#/reservation/" + (log.rsvpId)),"target":"_blank"}},[_vm._v(_vm._s(log.rsvpId))])]):_vm._e(),_vm._v(" "),(log.action === 'consumer_cancel')?_c('div',{staticClass:"log-data"},[_vm._v("\n                Cancellation Fee:\n                "),_c('b',[_vm._v("$"+_vm._s(_vm.toFixed(log.details.cancellationFee)))])]):_vm._e(),_vm._v(" "),(log.action === 'create_rsvp')?_c('div',{staticClass:"log-data"},[_c('div',{staticClass:"log-data"},[_vm._v("\n                  Charged Amount:\n                  "),_c('b',[_vm._v("$"+_vm._s(_vm.toFixed(log.details.chargeAmount)))])]),_vm._v(" "),_c('div',{staticClass:"log-data"},[_vm._v("\n                  IP Address:\n                  "),_c('b',[_vm._v(_vm._s(log.details.ip))])])]):_vm._e(),_vm._v(" "),(log.action === 'consumer_convert' && log.details.result.creditAmount)?_c('div',{staticClass:"log-data"},[_vm._v("\n                Amount:\n                "),_c('b',[_vm._v("$"+_vm._s(_vm.toFixed(Math.abs(log.details.result.creditAmount))))])]):_vm._e()])])])])],1)}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.loading)?_c('div',{staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" Loading...\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.logs.length === 0 && !_vm.loading),expression:"logs.length === 0 && !loading"}],staticClass:"empty-state"},[_c('i',{staticClass:"fa fa-clipboard-list fa-4x"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('rsvpDetails.activityLogs.emptyState')))])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountrySelectModal_vue__ = __webpack_require__(407);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12538b5c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountrySelectModal_vue__ = __webpack_require__(1143);
function injectStyle (ssrContext) {
  __webpack_require__(1141)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12538b5c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountrySelectModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12538b5c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountrySelectModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1142);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5ecc6184", content, true, {});

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.modal[data-v-12538b5c] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.modal .bg-overlay[data-v-12538b5c] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n.modal .modal-content[data-v-12538b5c] {\n    position: absolute;\n    top: 20%;\n    left: 50%;\n    width: 400px;\n    padding: 25px;\n    background: #fff;\n    text-align: center;\n    border-radius: 6px;\n    margin-left: -200px;\n    -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal .modal-content input[data-v-12538b5c] {\n      margin-top: 0;\n}\n.modal .modal-content .country-list[data-v-12538b5c] {\n      height: 400px;\n      text-align: left;\n      overflow-y: auto;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.modal .modal-content .country-list .country-name[data-v-12538b5c] {\n        padding: 10px 15px;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n        border-left: 1px solid rgba(0, 0, 0, 0.1);\n        border-right: 1px solid rgba(0, 0, 0, 0.1);\n}\n.modal .modal-content .country-list .country-name .iti-flag[data-v-12538b5c] {\n          display: inline-block;\n}\n.modal .modal-content .country-list .country-name[data-v-12538b5c]:hover {\n          background-color: #fff8dc;\n          cursor: pointer;\n}\n.modal.show[data-v-12538b5c] {\n    display: block;\n}\n.modal.show .modal-content[data-v-12538b5c] {\n      display: block;\n      -webkit-animation: slide-down-data-v-12538b5c .3s ease-out;\n      -moz-animation: slide-down-data-v-12538b5c .3s ease-out;\n}\n@-webkit-keyframes slide-down-data-v-12538b5c {\n0% {\n    opacity: 0;\n    -webkit-transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Consumer/CountrySelectModal.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,YAAY;CACb;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;CAChB;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,uDAAuD;YAC/C,+CAA+C;IACvD,cAAc;CACjB;AACD;MACM,cAAc;CACnB;AACD;MACM,cAAc;MACd,iBAAiB;MACjB,iBAAiB;MACjB,4CAA4C;CACjD;AACD;QACQ,mBAAmB;QACnB,4CAA4C;QAC5C,0CAA0C;QAC1C,2CAA2C;CAClD;AACD;UACU,sBAAsB;CAC/B;AACD;UACU,0BAA0B;UAC1B,gBAAgB;CACzB;AACD;IACI,eAAe;CAClB;AACD;MACM,eAAe;MACf,2DAA2D;MAC3D,wDAAwD;CAC7D;AACD;AACA;IACI,WAAW;IACX,oCAAoC;CACvC;AACD;IACI,WAAW;IACX,iCAAiC;CACpC;CACA","file":"CountrySelectModal.vue","sourcesContent":["\n.modal[data-v-12538b5c] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.modal .bg-overlay[data-v-12538b5c] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n.modal .modal-content[data-v-12538b5c] {\n    position: absolute;\n    top: 20%;\n    left: 50%;\n    width: 400px;\n    padding: 25px;\n    background: #fff;\n    text-align: center;\n    border-radius: 6px;\n    margin-left: -200px;\n    -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal .modal-content input[data-v-12538b5c] {\n      margin-top: 0;\n}\n.modal .modal-content .country-list[data-v-12538b5c] {\n      height: 400px;\n      text-align: left;\n      overflow-y: auto;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.modal .modal-content .country-list .country-name[data-v-12538b5c] {\n        padding: 10px 15px;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n        border-left: 1px solid rgba(0, 0, 0, 0.1);\n        border-right: 1px solid rgba(0, 0, 0, 0.1);\n}\n.modal .modal-content .country-list .country-name .iti-flag[data-v-12538b5c] {\n          display: inline-block;\n}\n.modal .modal-content .country-list .country-name[data-v-12538b5c]:hover {\n          background-color: #fff8dc;\n          cursor: pointer;\n}\n.modal.show[data-v-12538b5c] {\n    display: block;\n}\n.modal.show .modal-content[data-v-12538b5c] {\n      display: block;\n      -webkit-animation: slide-down-data-v-12538b5c .3s ease-out;\n      -moz-animation: slide-down-data-v-12538b5c .3s ease-out;\n}\n@-webkit-keyframes slide-down-data-v-12538b5c {\n0% {\n    opacity: 0;\n    -webkit-transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{'modal':true, 'show':_vm.showModal}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeModal}}),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchString),expression:"searchString"}],attrs:{"type":"text","placeholder":"Search a country..."},domProps:{"value":(_vm.searchString)},on:{"keyup":_vm.filter,"input":function($event){if($event.target.composing){ return; }_vm.searchString=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"country-list"},_vm._l((_vm.countryList),function(country,index){return (country.dialCode)?_c('div',{staticClass:"country-name",on:{"click":function($event){return _vm.selectCountry(index)}}},[_c('div',{class:['iti-flag ' + country.code]}),_vm._v(" "),_c('span',{staticClass:"country-code"},[_vm._v(" "+_vm._s(country.name)+" ")]),_vm._v(" "),(!_vm.countryOnly)?_c('span',{staticClass:"name"},[_vm._v(" (+"+_vm._s(country.dialCode)+") ")]):_vm._e()]):_vm._e()}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"left-panel"},[_c('div',{staticClass:"heading"},[_c('span',{staticClass:"cons-name"},[_vm._v(_vm._s(_vm.consumerData.firstName + ' ' + _vm.consumerData.lastName))]),_vm._v(" "),(_vm.consumerData.customerURL !== null)?_c('a',{staticClass:"stripe-link",attrs:{"href":_vm.consumerData.customerURL,"target":"_blank"}},[_c('i',{staticClass:"fa fa-link"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"switch-call"},[_c('div',{staticClass:"switch"},[_c('div',{class:{'slider':true, 'active':_vm.isActive, 'disabled':_vm.showActiveModal},on:{"click":function($event){_vm.showActiveModal = true}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"label"},[_vm._v("ACTIVE")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isActive),expression:"!isActive"}],staticClass:"label"},[_vm._v("DEACTIVATED")])]),_vm._v(" "),_c('div',{staticClass:"button cta success call small",on:{"click":function($event){return _vm.call(_vm.consumerData)}}},[_c('i',{staticClass:"fa fa-phone"}),_vm._v(_vm._s(_vm.$t('consumer.call'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('account-details',{ref:"accountDetails",attrs:{"referralLoading":_vm.referralLoading}})],1),_vm._v(" "),_c('div',{staticClass:"fix-buttons"},[_c('a',{class:{'button cta small success block':true, 'disabled':_vm.formHasError},on:{"click":_vm.triggerSave}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.formLoading),expression:"!formLoading"}]},[_vm._v(_vm._s(_vm.$t('consumer.save')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.formLoading),expression:"formLoading"}]},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-fw"}),_vm._v("\n          "+_vm._s(_vm.$t('consumer.saving'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"toggle-mobile",on:{"click":function($event){_vm.showRecords = !_vm.showRecords}}},[(!_vm.showRecords)?_c('span',[_vm._v("Show Records "),_c('i',{staticClass:"fa fa-chevron-up"})]):_c('span',[_vm._v("Hide Records "),_c('i',{staticClass:"fa fa-chevron-down"})])]),_vm._v(" "),_c('div',{class:['right-panel', _vm.showRecords ? 'mobile-right-panel' : ''],on:{"scroll":_vm.onScroll}},[_c('ul',{staticClass:"tab"},[_c('li',{class:{'active':_vm.activeTab === 0},on:{"click":function($event){return _vm.switchTab(0)}}},[_vm._v("\n        "+_vm._s(_vm.$t('consumer.tabLabel.referrals'))+"\n      ")]),_vm._v(" "),_c('li',{class:{'active':_vm.activeTab === 1},on:{"click":function($event){return _vm.switchTab(1)}}},[_vm._v("\n        "+_vm._s(_vm.$t('consumer.tabLabel.transactions'))+"\n      ")]),_vm._v(" "),_c('li',{class:{'active':_vm.activeTab === 2},on:{"click":function($event){return _vm.switchTab(2)}}},[_vm._v("\n        "+_vm._s(_vm.$t('consumer.tabLabel.reservations'))+"\n      ")]),_vm._v(" "),_c('li',{class:{'active':_vm.activeTab === 3},on:{"click":function($event){return _vm.switchTab(3)}}},[_vm._v("\n        "+_vm._s(_vm.$t('consumer.tabLabel.ratings'))+"\n      ")]),_vm._v(" "),_c('li',{class:{'active':_vm.activeTab === 4},on:{"click":function($event){return _vm.switchTab(4)}}},[_vm._v("\n        "+_vm._s(_vm.$t('consumer.tabLabel.creditCard'))+"\n      ")]),_vm._v(" "),_c('li',{class:{'active':_vm.activeTab === 5},on:{"click":function($event){return _vm.switchTab(5)}}},[_vm._v("\n        "+_vm._s(_vm.$t('consumer.tabLabel.promoCodes'))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"tab-contents"},[_c('div',{class:{'tab-content':true, 'active':_vm.activeTab == 0}},[_c('referrals',{ref:"referrals",attrs:{"isMobile":_vm.isMobile,"conId":_vm.$route.params.id}})],1),_vm._v(" "),_c('div',{class:{'tab-content':true, 'active':_vm.activeTab == 1}},[_c('transactions',{ref:"transactions",attrs:{"isMobile":_vm.isMobile,"conId":_vm.$route.params.id}})],1),_vm._v(" "),_c('div',{class:{'tab-content':true, 'active':_vm.activeTab == 2}},[_c('reservations',{ref:"reservations",attrs:{"isMobile":_vm.isMobile,"conId":_vm.$route.params.id}})],1),_vm._v(" "),_c('div',{class:{'tab-content':true, 'active':_vm.activeTab == 3}},[_c('ratings',{ref:"ratings",attrs:{"isMobile":_vm.isMobile,"conId":_vm.$route.params.id}})],1),_vm._v(" "),_c('div',{class:{'tab-content':true, 'active':_vm.activeTab == 4}},[_c('creditCards',{ref:"creditCards",attrs:{"isMobile":_vm.isMobile,"conId":_vm.$route.params.id}})],1),_vm._v(" "),_c('div',{class:{'tab-content':true, 'active':_vm.activeTab == 5}},[_c('promoCodes',{ref:"promoCodes",attrs:{"isMobile":_vm.isMobile,"conId":_vm.$route.params.id}})],1)])]),_vm._v(" "),_c('loading-modal',{attrs:{"showModal":_vm.loading,"modalMessage":_vm.$t('consumer.loading')}}),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.formResult.isDone}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeFormResult}}),_vm._v(" "),_c('div',{staticClass:"modal-content formResult"},[_c('p',[_vm._v(_vm._s(_vm.formResult.message))]),_vm._v(" "),_c('a',{staticClass:"button cta warning block small",on:{"click":_vm.closeFormResult}},[_vm._v("\n        "+_vm._s(_vm.$t('provider.close'))+"\n      ")])])]),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.showActiveModal}},[_c('div',{staticClass:"modal-content active-confirmation"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isActive),expression:"!isActive"}]},[_vm._v("\n        Are you sure you want to activate\n        "),_c('b',[_vm._v(_vm._s(_vm.consumerData.firstName + ' ' + _vm.consumerData.lastName))]),_vm._v("?\n      ")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}]},[_vm._v("\n        Are you sure you want to deactivate\n        "),_c('b',[_vm._v(_vm._s(_vm.consumerData.firstName + ' ' + _vm.consumerData.lastName))]),_vm._v("?\n      ")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"button cta warning",on:{"click":function($event){_vm.showActiveModal = false}}},[_vm._v("No")]),_vm._v(" "),_c('div',{staticClass:"button cta success",on:{"click":_vm.toggleConsActive}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.statusLoading),expression:"!statusLoading"}]},[_vm._v("Yes")]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.statusLoading),expression:"statusLoading"}],staticClass:"fa fa-spinner fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"logs"},[_c('div',{staticClass:"trigger"},[_c('a',{class:{'logs-toggle':true, on:_vm.showLogs},on:{"click":_vm.toggleLogs}},[_c('i',{class:_vm.logsIcon})])]),_vm._v(" "),_c('div',{class:{'logs-panel':true, hide:!_vm.showLogs}},[_c('div',{staticClass:"heading"},[_vm._v("\n        Logs\n        "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.logDate),expression:"logDate"}],class:{'disabled':_vm.logsLoading},attrs:{"disabled":_vm.logsLoading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.logDate=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v("All")]),_vm._v(" "),_c('option',{attrs:{"value":"custom"}},[_vm._v("Custom")])])]),_vm._v(" "),_c('logs',{ref:"logs"})],1)]),_vm._v(" "),_c('countrySelectModal')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(408);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62ba0720_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1153);
function injectStyle (ssrContext) {
  __webpack_require__(1146)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62ba0720"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62ba0720_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1147);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("21a6760a", content, true, {});

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.fixed-header[data-v-62ba0720] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 155px;\n}\n.heading[data-v-62ba0720] {\n  margin-left: 50px;\n  padding-left: 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.notif-btn[data-v-62ba0720] {\n  float: right;\n  margin: 7px 10px;\n}\nselect[data-v-62ba0720] {\n  border: 1px solid #ddd;\n  padding: 5px 10px;\n  color: #333;\n  height: 35px;\n  position: relative;\n  font-size: 14px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n  -webkit-transition: all .35s ease;\n  transition: all .35s ease;\n}\nselect.has-error[data-v-62ba0720] {\n    border-color: #f20d0d;\n}\nselect[data-v-62ba0720]:disabled {\n    background-color: #eee;\n}\n.data-field[data-v-62ba0720] {\n  position: relative;\n  margin-bottom: 20px;\n}\n.data-field .label[data-v-62ba0720] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 130%;\n    margin-bottom: 3px;\n}\n.data-field .label.has-error[data-v-62ba0720] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-62ba0720] {\n    margin: 5px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-62ba0720] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-62ba0720]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-62ba0720] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.right-panel[data-v-62ba0720] {\n  position: fixed;\n  background: #ededed;\n  z-index: 2;\n  width: 80%;\n  height: 100%;\n  top: 0;\n  right: 0;\n  padding: 20px;\n  overflow: auto;\n}\n.search[data-v-62ba0720] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 400px;\n}\n.search input[data-v-62ba0720] {\n    display: inline-block;\n    vertical-align: middle;\n    margin-top: 0;\n    border-radius: 5px 0 0 5px;\n}\n.search button[data-v-62ba0720] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 5px 5px 0;\n}\n.inline-block[data-v-62ba0720] {\n  display: inline-block;\n}\n.import[data-v-62ba0720] {\n  vertical-align: top;\n  margin-left: 5px;\n}\n.import .fa[data-v-62ba0720] {\n    margin-right: 5px;\n}\n.sticky[data-v-62ba0720] {\n  position: fixed;\n  top: 153px;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  height: 30px;\n  z-index: 3;\n}\n.sticky tbody[data-v-62ba0720] {\n    visibility: hidden;\n}\n.main-table[data-v-62ba0720] {\n  margin: 153px 0 60px;\n}\ntable[data-v-62ba0720] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-62ba0720] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-62ba0720] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-62ba0720] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr.tr-loader[data-v-62ba0720] {\n      border-left: none;\n      border-right: none;\n}\ntable tbody tr td[data-v-62ba0720] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-62ba0720] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-62ba0720] {\n          color: #ccc;\n}\ntable .status[data-v-62ba0720], table a[data-v-62ba0720] {\n    cursor: pointer;\n}\ninput[type=\"checkbox\"][data-v-62ba0720] {\n  padding: 0;\n  margin: 0;\n  width: 15px;\n  height: 15px;\n}\n.status-label[data-v-62ba0720] {\n  background: #ccc;\n  color: #fff;\n  font-size: 11px;\n  padding: 3px 5px;\n  line-height: 1;\n  border-radius: 4px;\n  text-transform: uppercase;\n}\n.status-label.unverified[data-v-62ba0720] {\n    background: #ff8100;\n}\n.status-label.active[data-v-62ba0720] {\n    background: #45c125;\n}\n.status-label.disabled[data-v-62ba0720] {\n    background: #f93636;\n}\n.fa-spinner[data-v-62ba0720] {\n  font-size: 36px;\n  color: #1f9be6;\n  margin-right: 5px;\n  vertical-align: middle;\n}\n.fix-footer[data-v-62ba0720] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 60px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-62ba0720] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-62ba0720] {\n    max-width: 100px;\n}\n.fix-footer .per-page[data-v-62ba0720] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .per-page span[data-v-62ba0720] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-62ba0720] {\n    text-align: center;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .pagination[data-v-62ba0720] {\n    text-align: right;\n    padding: 15px 10px;\n}\n.fix-footer .pagination span[data-v-62ba0720] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-62ba0720] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-62ba0720] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-62ba0720] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-62ba0720] {\n        opacity: .4;\n        cursor: default;\n}\n.op--modal-container[data-v-62ba0720] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-62ba0720] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-62ba0720] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-62ba0720] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.status-confirmation[data-v-62ba0720] {\n  background-color: #fff;\n  max-width: 440px;\n  margin: 10px auto;\n  padding: 20px;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  position: relative;\n}\n.status-confirmation p[data-v-62ba0720] {\n    padding: 0;\n    margin: 0 0 20px;\n    text-align: center;\n    color: #555;\n    font-weight: 600;\n    font-size: 15px;\n}\n.status-confirmation .cancel[data-v-62ba0720] {\n    margin-top: 10px;\n    text-align: center;\n    display: block;\n    color: #999;\n    font-size: 14px;\n    cursor: pointer;\n}\n.status-confirmation .cancel[data-v-62ba0720]:hover {\n      color: #555;\n}\n.status-confirmation .error[data-v-62ba0720] {\n    text-align: center;\n}\n.status-confirmation .error i[data-v-62ba0720] {\n      color: #fd4a38;\n}\n.status-confirmation .error p[data-v-62ba0720] {\n      margin: 5px 0 20px;\n}\n.status-confirmation .error code[data-v-62ba0720] {\n      border: 2px solid #fd4a38;\n      padding: 10px;\n      width: 100%;\n      display: block;\n      font-size: 14px;\n      background: #ffeeec;\n      border-radius: 3px;\n      margin-bottom: 30px;\n}\n.status-confirmation .success-box[data-v-62ba0720] {\n    text-align: center;\n}\n.status-confirmation .success-box i[data-v-62ba0720] {\n      color: #26d97a;\n}\n.status-confirmation .loader[data-v-62ba0720] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.3);\n}\n.status-confirmation .loader div[data-v-62ba0720] {\n      position: absolute;\n      top: 50%;\n      left: 0;\n      height: 50px;\n      width: 100%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      text-align: center;\n}\n.status-confirmation .loader div i[data-v-62ba0720] {\n        color: #45e7f9;\n}\n.status-confirmation .loader div span[data-v-62ba0720] {\n        color: #fff;\n        font-size: 21px;\n        font-weight: 600;\n        margin-left: 5px;\n        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);\n}\n.notification-form[data-v-62ba0720] {\n  background-color: #fff;\n  max-width: 400px;\n  margin: 10px auto;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n.notification-form .modal-heading[data-v-62ba0720] {\n    background: #333;\n    color: #fff;\n    padding: 10px;\n    font-size: 18px;\n    text-align: center;\n}\n.notification-form .nf-content[data-v-62ba0720] {\n    padding: 20px;\n    position: relative;\n}\n.notification-form .nf-content .label[data-v-62ba0720] {\n      font-size: 13px;\n      color: #555;\n}\n.notification-form .nf-content label[data-v-62ba0720] {\n      display: block;\n      font-size: 14px;\n      color: #555;\n      margin-bottom: 2px;\n      cursor: pointer;\n}\n.notification-form .nf-content label input[data-v-62ba0720] {\n        display: inline-block;\n        vertical-align: middle;\n        margin-right: 5px;\n}\n.notification-form .nf-content .textarea-box[data-v-62ba0720] {\n      position: relative;\n      margin-bottom: 20px;\n      padding-bottom: 20px;\n}\n.notification-form .nf-content .textarea-box .emoji-trigger[data-v-62ba0720] {\n        position: absolute;\n        top: 133px;\n        right: 0;\n        color: #aaa;\n        cursor: pointer;\n}\n.notification-form .nf-content .textarea-box .error-msg[data-v-62ba0720] {\n        font-size: 11px;\n        line-height: 1.6;\n        color: #f20d0d;\n        font-style: italic;\n        display: block;\n}\n.notification-form .nf-content textarea[data-v-62ba0720] {\n      margin: 0;\n      padding: 10px;\n      width: 100%;\n      resize: none;\n      background: #fdfdfd;\n      font-size: 14px;\n      outline: none;\n      color: #333;\n      border-color: #ddd;\n      -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.05) inset;\n              box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.05) inset;\n      -webkit-transition: all .3s ease;\n      transition: all .3s ease;\n}\n.notification-form .nf-content textarea.exceed[data-v-62ba0720] {\n        border-color: #d61613;\n        background: #fff0f0;\n}\n.notification-form .nf-content .char-count[data-v-62ba0720] {\n      font-size: 12px;\n      color: #777;\n      display: block;\n      text-align: right;\n      line-height: 1;\n      margin-top: 5px;\n}\n.notification-form .nf-content .char-count.exceed[data-v-62ba0720] {\n        color: #f00;\n}\n.notification-form .nf-content .cancel-notif[data-v-62ba0720] {\n      display: block;\n      font-size: 13px;\n      margin: 10px 0 0;\n      text-align: center;\n      cursor: pointer;\n      color: #bbb;\n      -webkit-transition: all .5s ease;\n      transition: all .5s ease;\n}\n.notification-form .nf-content .cancel-notif[data-v-62ba0720]:hover {\n        color: #333;\n}\n.notification-form .nf-content .file-box[data-v-62ba0720] {\n      position: relative;\n}\n.notification-form .nf-content .file-box input[data-v-62ba0720] {\n        padding: 5px 25px 5px 5px;\n        margin: 0;\n        font-size: 14px;\n}\n.notification-form .nf-content .file-box i[data-v-62ba0720] {\n        position: absolute;\n        z-index: 2;\n        top: 50%;\n        right: 5px;\n        -webkit-transform: translateY(-50%);\n                transform: translateY(-50%);\n        color: #fd4a38;\n        cursor: pointer;\n}\n.notification-form .error[data-v-62ba0720] {\n    text-align: center;\n}\n.notification-form .error i[data-v-62ba0720] {\n      color: #fd4a38;\n}\n.notification-form .error p[data-v-62ba0720] {\n      margin: 5px 0 20px;\n}\n.notification-form .error code[data-v-62ba0720] {\n      border: 2px solid #fd4a38;\n      padding: 10px;\n      width: 100%;\n      display: block;\n      font-size: 14px;\n      background: #ffeeec;\n      border-radius: 3px;\n      margin-bottom: 30px;\n}\n.notification-form .success-box[data-v-62ba0720] {\n    text-align: center;\n}\n.notification-form .success-box i[data-v-62ba0720] {\n      color: #26d97a;\n}\n.notification-form .loader[data-v-62ba0720] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.3);\n}\n.notification-form .loader div[data-v-62ba0720] {\n      position: absolute;\n      top: 50%;\n      left: 0;\n      height: 50px;\n      width: 100%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      text-align: center;\n}\n.notification-form .loader div i[data-v-62ba0720] {\n        color: #45e7f9;\n}\n.notification-form .loader div span[data-v-62ba0720] {\n        color: #fff;\n        font-size: 21px;\n        font-weight: 600;\n        margin-left: 5px;\n        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);\n}\n.emoji-box[data-v-62ba0720] {\n  position: absolute;\n  top: 0;\n  left: 100%;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n}\n.slide-up-enter-active[data-v-62ba0720], .slide-up-leave-active[data-v-62ba0720] {\n  -webkit-transition: all .6s ease;\n  transition: all .6s ease;\n}\n.slide-up-enter[data-v-62ba0720], .slide-up-leave-to[data-v-62ba0720] {\n  -webkit-transform: translateY(30px);\n          transform: translateY(30px);\n  opacity: 0;\n}\n.slide-down-enter-active[data-v-62ba0720], .slide-down-leave-active[data-v-62ba0720] {\n  -webkit-transition: all .6s ease;\n  transition: all .6s ease;\n}\n.slide-down-enter[data-v-62ba0720], .slide-down-leave-to[data-v-62ba0720] {\n  -webkit-transform: translateY(-30px);\n          transform: translateY(-30px);\n  opacity: 0;\n}\n.slide-left-enter-active[data-v-62ba0720], .slide-left-leave-active[data-v-62ba0720] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-left-enter[data-v-62ba0720], .slide-left-leave-to[data-v-62ba0720] {\n  -webkit-transform: translateX(-30px);\n          transform: translateX(-30px);\n  opacity: 0;\n}\n.pop-enter-active[data-v-62ba0720], .pop-leave-active[data-v-62ba0720] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.pop-enter[data-v-62ba0720], .pop-leave-to[data-v-62ba0720] {\n  -webkit-transform: scale(0.8);\n          transform: scale(0.8);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.heading[data-v-62ba0720] {\n    font-size: 20px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.card-div[data-v-62ba0720] {\n    padding-top: 220px;\n    padding-bottom: 70px;\n}\n.cards[data-v-62ba0720] {\n    width: 90%;\n    margin: 0 auto;\n}\n.cards .card[data-v-62ba0720] {\n      border: 1px solid #ccc;\n      margin-bottom: 15px;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n}\n.cards .card > div[data-v-62ba0720] {\n        margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-62ba0720] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n}\n.cards .card .card-header .time[data-v-62ba0720] {\n          font-size: 12px;\n          color: #777;\n          word-spacing: 5px;\n}\n.cards .card .card-header .link[data-v-62ba0720] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          gap: 10px;\n}\n.cards .card .credit-card[data-v-62ba0720] {\n        font-weight: 900;\n}\n.cards .card .title[data-v-62ba0720] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n}\n.cards .card .title input[data-v-62ba0720] {\n          margin-right: 5px;\n}\n.cards .card .title.view[data-v-62ba0720] {\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n          padding-top: 7px;\n          padding-bottom: 5px;\n          border-top: 1px solid #eee;\n}\n.cards .card .title .refer[data-v-62ba0720] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n.cards .card .label[data-v-62ba0720] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards .card .value[data-v-62ba0720] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards .card .value i[data-v-62ba0720] {\n          color: #bbb;\n}\n.cards .card .value a[data-v-62ba0720] {\n          text-decoration: none;\n          text-transform: uppercase;\n}\n.small-3[data-v-62ba0720] {\n    width: 50%;\n}\n.fix-footer .row[data-v-62ba0720] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.fix-footer .per-page[data-v-62ba0720] {\n    width: auto;\n}\n.fix-footer .per-page select[data-v-62ba0720] {\n      width: 55px;\n}\n.fix-footer .per-page span[data-v-62ba0720]:nth-child(3) {\n      display: none;\n}\n.fix-footer .page-data[data-v-62ba0720] {\n    display: none;\n}\n.fix-footer .pagination[data-v-62ba0720] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.fix-footer .pagination select[data-v-62ba0720] {\n      width: 55px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Consumer/List.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;CAC3B;AACD;EACE,aAAa;EACb,iBAAiB;CAClB;AACD;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;IACI,sBAAsB;CACzB;AACD;IACI,uBAAuB;CAC1B;AACD;EACE,mBAAmB;EACnB,oBAAoB;CACrB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;EACE,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX,aAAa;EACb,OAAO;EACP,SAAS;EACT,cAAc;EACd,eAAe;CAChB;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,aAAa;CACd;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;IACd,2BAA2B;CAC9B;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,2BAA2B;CAC9B;AACD;EACE,sBAAsB;CACvB;AACD;EACE,oBAAoB;EACpB,iBAAiB;CAClB;AACD;IACI,kBAAkB;CACrB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,WAAW;CACZ;AACD;IACI,mBAAmB;CACtB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,0BAA0B;EAC1B,YAAY;CACb;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,kBAAkB;MAClB,mBAAmB;CACxB;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;IACI,gBAAgB;CACnB;AACD;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,aAAa;CACd;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,0BAA0B;CAC3B;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;CACxB;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;CACb;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;CACnB;AACD;MACM,sBAAsB;MACtB,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;CACnB;AACD;IACI,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,kBAAkB;CACvB;AACD;MACM,aAAa;MACb,uBAAuB;CAC5B;AACD;MACM,cAAc;MACd,eAAe;MACf,uBAAuB;MACvB,iBAAiB;MACjB,gBAAgB;MAChB,uBAAuB;MACvB,aAAa;CAClB;AACD;QACQ,kBAAkB;CACzB;AACD;QACQ,YAAY;QACZ,gBAAgB;CACvB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,WAAW;EACX,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,iDAAiD;UACzC,yCAAyC;EACjD,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;CACnB;AACD;MACM,YAAY;CACjB;AACD;IACI,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,0BAA0B;MAC1B,cAAc;MACd,YAAY;MACZ,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,mBAAmB;MACnB,oBAAoB;CACzB;AACD;IACI,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,aAAa;IACb,+BAA+B;CAClC;AACD;MACM,mBAAmB;MACnB,SAAS;MACT,QAAQ;MACR,aAAa;MACb,YAAY;MACZ,oCAAoC;cAC5B,4BAA4B;MACpC,mBAAmB;CACxB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;QACjB,4CAA4C;CACnD;AACD;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;UACzC,yCAAyC;CAClD;AACD;IACI,iBAAiB;IACjB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,mBAAmB;CACtB;AACD;IACI,cAAc;IACd,mBAAmB;CACtB;AACD;MACM,gBAAgB;MAChB,YAAY;CACjB;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,YAAY;MACZ,mBAAmB;MACnB,gBAAgB;CACrB;AACD;QACQ,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;CACzB;AACD;MACM,mBAAmB;MACnB,oBAAoB;MACpB,qBAAqB;CAC1B;AACD;QACQ,mBAAmB;QACnB,WAAW;QACX,SAAS;QACT,YAAY;QACZ,gBAAgB;CACvB;AACD;QACQ,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;QACf,mBAAmB;QACnB,eAAe;CACtB;AACD;MACM,UAAU;MACV,cAAc;MACd,YAAY;MACZ,aAAa;MACb,oBAAoB;MACpB,gBAAgB;MAChB,cAAc;MACd,YAAY;MACZ,mBAAmB;MACnB,0DAA0D;cAClD,kDAAkD;MAC1D,iCAAiC;MACjC,yBAAyB;CAC9B;AACD;QACQ,sBAAsB;QACtB,oBAAoB;CAC3B;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,eAAe;MACf,kBAAkB;MAClB,eAAe;MACf,gBAAgB;CACrB;AACD;QACQ,YAAY;CACnB;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,mBAAmB;MACnB,gBAAgB;MAChB,YAAY;MACZ,iCAAiC;MACjC,yBAAyB;CAC9B;AACD;QACQ,YAAY;CACnB;AACD;MACM,mBAAmB;CACxB;AACD;QACQ,0BAA0B;QAC1B,UAAU;QACV,gBAAgB;CACvB;AACD;QACQ,mBAAmB;QACnB,WAAW;QACX,SAAS;QACT,WAAW;QACX,oCAAoC;gBAC5B,4BAA4B;QACpC,eAAe;QACf,gBAAgB;CACvB;AACD;IACI,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,0BAA0B;MAC1B,cAAc;MACd,YAAY;MACZ,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,mBAAmB;MACnB,oBAAoB;CACzB;AACD;IACI,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,aAAa;IACb,+BAA+B;CAClC;AACD;MACM,mBAAmB;MACnB,SAAS;MACT,QAAQ;MACR,aAAa;MACb,YAAY;MACZ,oCAAoC;cAC5B,4BAA4B;MACpC,mBAAmB;CACxB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;QACjB,4CAA4C;CACnD;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;CACd;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,8BAA8B;UACtB,sBAAsB;EAC9B,WAAW;CACZ;AACD;AACA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;CAC/B;AACD;IACI,mBAAmB;IACnB,qBAAqB;CACxB;AACD;IACI,WAAW;IACX,eAAe;CAClB;AACD;MACM,uBAAuB;MACvB,oBAAoB;MACpB,aAAa;MACb,oBAAoB;MACpB,+BAA+B;MAC/B,oBAAoB;CACzB;AACD;QACQ,mBAAmB;CAC1B;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,+BAA+B;QACvC,uBAAuB;YACnB,oBAAoB;gBAChB,sBAAsB;CACrC;AACD;UACU,gBAAgB;UAChB,YAAY;UACZ,kBAAkB;CAC3B;AACD;UACU,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;UACd,0BAA0B;cACtB,uBAAuB;kBACnB,oBAAoB;UAC5B,UAAU;CACnB;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,oBAAoB;CACnC;AACD;UACU,kBAAkB;CAC3B;AACD;UACU,0BAA0B;cACtB,uBAAuB;kBACnB,+BAA+B;UACvC,iBAAiB;UACjB,oBAAoB;UACpB,2BAA2B;CACpC;AACD;UACU,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;CACvB;AACD;QACQ,gBAAgB;QAChB,0BAA0B;QAC1B,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;CACzB;AACD;QACQ,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;CACxB;AACD;UACU,YAAY;CACrB;AACD;UACU,sBAAsB;UACtB,0BAA0B;CACnC;AACD;IACI,WAAW;CACd;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;IACI,YAAY;CACf;AACD;MACM,YAAY;CACjB;AACD;MACM,cAAc;CACnB;AACD;IACI,cAAc;CACjB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;CAC/B;AACD;MACM,YAAY;CACjB;CACA","file":"List.vue","sourcesContent":["\n.fixed-header[data-v-62ba0720] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 155px;\n}\n.heading[data-v-62ba0720] {\n  margin-left: 50px;\n  padding-left: 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.notif-btn[data-v-62ba0720] {\n  float: right;\n  margin: 7px 10px;\n}\nselect[data-v-62ba0720] {\n  border: 1px solid #ddd;\n  padding: 5px 10px;\n  color: #333;\n  height: 35px;\n  position: relative;\n  font-size: 14px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n  -webkit-transition: all .35s ease;\n  transition: all .35s ease;\n}\nselect.has-error[data-v-62ba0720] {\n    border-color: #f20d0d;\n}\nselect[data-v-62ba0720]:disabled {\n    background-color: #eee;\n}\n.data-field[data-v-62ba0720] {\n  position: relative;\n  margin-bottom: 20px;\n}\n.data-field .label[data-v-62ba0720] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 130%;\n    margin-bottom: 3px;\n}\n.data-field .label.has-error[data-v-62ba0720] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-62ba0720] {\n    margin: 5px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-62ba0720] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-62ba0720]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-62ba0720] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.right-panel[data-v-62ba0720] {\n  position: fixed;\n  background: #ededed;\n  z-index: 2;\n  width: 80%;\n  height: 100%;\n  top: 0;\n  right: 0;\n  padding: 20px;\n  overflow: auto;\n}\n.search[data-v-62ba0720] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 400px;\n}\n.search input[data-v-62ba0720] {\n    display: inline-block;\n    vertical-align: middle;\n    margin-top: 0;\n    border-radius: 5px 0 0 5px;\n}\n.search button[data-v-62ba0720] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 5px 5px 0;\n}\n.inline-block[data-v-62ba0720] {\n  display: inline-block;\n}\n.import[data-v-62ba0720] {\n  vertical-align: top;\n  margin-left: 5px;\n}\n.import .fa[data-v-62ba0720] {\n    margin-right: 5px;\n}\n.sticky[data-v-62ba0720] {\n  position: fixed;\n  top: 153px;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  height: 30px;\n  z-index: 3;\n}\n.sticky tbody[data-v-62ba0720] {\n    visibility: hidden;\n}\n.main-table[data-v-62ba0720] {\n  margin: 153px 0 60px;\n}\ntable[data-v-62ba0720] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-62ba0720] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-62ba0720] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-62ba0720] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr.tr-loader[data-v-62ba0720] {\n      border-left: none;\n      border-right: none;\n}\ntable tbody tr td[data-v-62ba0720] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-62ba0720] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-62ba0720] {\n          color: #ccc;\n}\ntable .status[data-v-62ba0720], table a[data-v-62ba0720] {\n    cursor: pointer;\n}\ninput[type=\"checkbox\"][data-v-62ba0720] {\n  padding: 0;\n  margin: 0;\n  width: 15px;\n  height: 15px;\n}\n.status-label[data-v-62ba0720] {\n  background: #ccc;\n  color: #fff;\n  font-size: 11px;\n  padding: 3px 5px;\n  line-height: 1;\n  border-radius: 4px;\n  text-transform: uppercase;\n}\n.status-label.unverified[data-v-62ba0720] {\n    background: #ff8100;\n}\n.status-label.active[data-v-62ba0720] {\n    background: #45c125;\n}\n.status-label.disabled[data-v-62ba0720] {\n    background: #f93636;\n}\n.fa-spinner[data-v-62ba0720] {\n  font-size: 36px;\n  color: #1f9be6;\n  margin-right: 5px;\n  vertical-align: middle;\n}\n.fix-footer[data-v-62ba0720] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 60px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-62ba0720] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-62ba0720] {\n    max-width: 100px;\n}\n.fix-footer .per-page[data-v-62ba0720] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .per-page span[data-v-62ba0720] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-62ba0720] {\n    text-align: center;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .pagination[data-v-62ba0720] {\n    text-align: right;\n    padding: 15px 10px;\n}\n.fix-footer .pagination span[data-v-62ba0720] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-62ba0720] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-62ba0720] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-62ba0720] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-62ba0720] {\n        opacity: .4;\n        cursor: default;\n}\n.op--modal-container[data-v-62ba0720] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-62ba0720] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-62ba0720] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-62ba0720] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.status-confirmation[data-v-62ba0720] {\n  background-color: #fff;\n  max-width: 440px;\n  margin: 10px auto;\n  padding: 20px;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  position: relative;\n}\n.status-confirmation p[data-v-62ba0720] {\n    padding: 0;\n    margin: 0 0 20px;\n    text-align: center;\n    color: #555;\n    font-weight: 600;\n    font-size: 15px;\n}\n.status-confirmation .cancel[data-v-62ba0720] {\n    margin-top: 10px;\n    text-align: center;\n    display: block;\n    color: #999;\n    font-size: 14px;\n    cursor: pointer;\n}\n.status-confirmation .cancel[data-v-62ba0720]:hover {\n      color: #555;\n}\n.status-confirmation .error[data-v-62ba0720] {\n    text-align: center;\n}\n.status-confirmation .error i[data-v-62ba0720] {\n      color: #fd4a38;\n}\n.status-confirmation .error p[data-v-62ba0720] {\n      margin: 5px 0 20px;\n}\n.status-confirmation .error code[data-v-62ba0720] {\n      border: 2px solid #fd4a38;\n      padding: 10px;\n      width: 100%;\n      display: block;\n      font-size: 14px;\n      background: #ffeeec;\n      border-radius: 3px;\n      margin-bottom: 30px;\n}\n.status-confirmation .success-box[data-v-62ba0720] {\n    text-align: center;\n}\n.status-confirmation .success-box i[data-v-62ba0720] {\n      color: #26d97a;\n}\n.status-confirmation .loader[data-v-62ba0720] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.3);\n}\n.status-confirmation .loader div[data-v-62ba0720] {\n      position: absolute;\n      top: 50%;\n      left: 0;\n      height: 50px;\n      width: 100%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      text-align: center;\n}\n.status-confirmation .loader div i[data-v-62ba0720] {\n        color: #45e7f9;\n}\n.status-confirmation .loader div span[data-v-62ba0720] {\n        color: #fff;\n        font-size: 21px;\n        font-weight: 600;\n        margin-left: 5px;\n        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);\n}\n.notification-form[data-v-62ba0720] {\n  background-color: #fff;\n  max-width: 400px;\n  margin: 10px auto;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n.notification-form .modal-heading[data-v-62ba0720] {\n    background: #333;\n    color: #fff;\n    padding: 10px;\n    font-size: 18px;\n    text-align: center;\n}\n.notification-form .nf-content[data-v-62ba0720] {\n    padding: 20px;\n    position: relative;\n}\n.notification-form .nf-content .label[data-v-62ba0720] {\n      font-size: 13px;\n      color: #555;\n}\n.notification-form .nf-content label[data-v-62ba0720] {\n      display: block;\n      font-size: 14px;\n      color: #555;\n      margin-bottom: 2px;\n      cursor: pointer;\n}\n.notification-form .nf-content label input[data-v-62ba0720] {\n        display: inline-block;\n        vertical-align: middle;\n        margin-right: 5px;\n}\n.notification-form .nf-content .textarea-box[data-v-62ba0720] {\n      position: relative;\n      margin-bottom: 20px;\n      padding-bottom: 20px;\n}\n.notification-form .nf-content .textarea-box .emoji-trigger[data-v-62ba0720] {\n        position: absolute;\n        top: 133px;\n        right: 0;\n        color: #aaa;\n        cursor: pointer;\n}\n.notification-form .nf-content .textarea-box .error-msg[data-v-62ba0720] {\n        font-size: 11px;\n        line-height: 1.6;\n        color: #f20d0d;\n        font-style: italic;\n        display: block;\n}\n.notification-form .nf-content textarea[data-v-62ba0720] {\n      margin: 0;\n      padding: 10px;\n      width: 100%;\n      resize: none;\n      background: #fdfdfd;\n      font-size: 14px;\n      outline: none;\n      color: #333;\n      border-color: #ddd;\n      -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.05) inset;\n              box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.05) inset;\n      -webkit-transition: all .3s ease;\n      transition: all .3s ease;\n}\n.notification-form .nf-content textarea.exceed[data-v-62ba0720] {\n        border-color: #d61613;\n        background: #fff0f0;\n}\n.notification-form .nf-content .char-count[data-v-62ba0720] {\n      font-size: 12px;\n      color: #777;\n      display: block;\n      text-align: right;\n      line-height: 1;\n      margin-top: 5px;\n}\n.notification-form .nf-content .char-count.exceed[data-v-62ba0720] {\n        color: #f00;\n}\n.notification-form .nf-content .cancel-notif[data-v-62ba0720] {\n      display: block;\n      font-size: 13px;\n      margin: 10px 0 0;\n      text-align: center;\n      cursor: pointer;\n      color: #bbb;\n      -webkit-transition: all .5s ease;\n      transition: all .5s ease;\n}\n.notification-form .nf-content .cancel-notif[data-v-62ba0720]:hover {\n        color: #333;\n}\n.notification-form .nf-content .file-box[data-v-62ba0720] {\n      position: relative;\n}\n.notification-form .nf-content .file-box input[data-v-62ba0720] {\n        padding: 5px 25px 5px 5px;\n        margin: 0;\n        font-size: 14px;\n}\n.notification-form .nf-content .file-box i[data-v-62ba0720] {\n        position: absolute;\n        z-index: 2;\n        top: 50%;\n        right: 5px;\n        -webkit-transform: translateY(-50%);\n                transform: translateY(-50%);\n        color: #fd4a38;\n        cursor: pointer;\n}\n.notification-form .error[data-v-62ba0720] {\n    text-align: center;\n}\n.notification-form .error i[data-v-62ba0720] {\n      color: #fd4a38;\n}\n.notification-form .error p[data-v-62ba0720] {\n      margin: 5px 0 20px;\n}\n.notification-form .error code[data-v-62ba0720] {\n      border: 2px solid #fd4a38;\n      padding: 10px;\n      width: 100%;\n      display: block;\n      font-size: 14px;\n      background: #ffeeec;\n      border-radius: 3px;\n      margin-bottom: 30px;\n}\n.notification-form .success-box[data-v-62ba0720] {\n    text-align: center;\n}\n.notification-form .success-box i[data-v-62ba0720] {\n      color: #26d97a;\n}\n.notification-form .loader[data-v-62ba0720] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.3);\n}\n.notification-form .loader div[data-v-62ba0720] {\n      position: absolute;\n      top: 50%;\n      left: 0;\n      height: 50px;\n      width: 100%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      text-align: center;\n}\n.notification-form .loader div i[data-v-62ba0720] {\n        color: #45e7f9;\n}\n.notification-form .loader div span[data-v-62ba0720] {\n        color: #fff;\n        font-size: 21px;\n        font-weight: 600;\n        margin-left: 5px;\n        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);\n}\n.emoji-box[data-v-62ba0720] {\n  position: absolute;\n  top: 0;\n  left: 100%;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n}\n.slide-up-enter-active[data-v-62ba0720], .slide-up-leave-active[data-v-62ba0720] {\n  -webkit-transition: all .6s ease;\n  transition: all .6s ease;\n}\n.slide-up-enter[data-v-62ba0720], .slide-up-leave-to[data-v-62ba0720] {\n  -webkit-transform: translateY(30px);\n          transform: translateY(30px);\n  opacity: 0;\n}\n.slide-down-enter-active[data-v-62ba0720], .slide-down-leave-active[data-v-62ba0720] {\n  -webkit-transition: all .6s ease;\n  transition: all .6s ease;\n}\n.slide-down-enter[data-v-62ba0720], .slide-down-leave-to[data-v-62ba0720] {\n  -webkit-transform: translateY(-30px);\n          transform: translateY(-30px);\n  opacity: 0;\n}\n.slide-left-enter-active[data-v-62ba0720], .slide-left-leave-active[data-v-62ba0720] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-left-enter[data-v-62ba0720], .slide-left-leave-to[data-v-62ba0720] {\n  -webkit-transform: translateX(-30px);\n          transform: translateX(-30px);\n  opacity: 0;\n}\n.pop-enter-active[data-v-62ba0720], .pop-leave-active[data-v-62ba0720] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.pop-enter[data-v-62ba0720], .pop-leave-to[data-v-62ba0720] {\n  -webkit-transform: scale(0.8);\n          transform: scale(0.8);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.heading[data-v-62ba0720] {\n    font-size: 20px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.card-div[data-v-62ba0720] {\n    padding-top: 220px;\n    padding-bottom: 70px;\n}\n.cards[data-v-62ba0720] {\n    width: 90%;\n    margin: 0 auto;\n}\n.cards .card[data-v-62ba0720] {\n      border: 1px solid #ccc;\n      margin-bottom: 15px;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n}\n.cards .card > div[data-v-62ba0720] {\n        margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-62ba0720] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n}\n.cards .card .card-header .time[data-v-62ba0720] {\n          font-size: 12px;\n          color: #777;\n          word-spacing: 5px;\n}\n.cards .card .card-header .link[data-v-62ba0720] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          gap: 10px;\n}\n.cards .card .credit-card[data-v-62ba0720] {\n        font-weight: 900;\n}\n.cards .card .title[data-v-62ba0720] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n}\n.cards .card .title input[data-v-62ba0720] {\n          margin-right: 5px;\n}\n.cards .card .title.view[data-v-62ba0720] {\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n          padding-top: 7px;\n          padding-bottom: 5px;\n          border-top: 1px solid #eee;\n}\n.cards .card .title .refer[data-v-62ba0720] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n.cards .card .label[data-v-62ba0720] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards .card .value[data-v-62ba0720] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards .card .value i[data-v-62ba0720] {\n          color: #bbb;\n}\n.cards .card .value a[data-v-62ba0720] {\n          text-decoration: none;\n          text-transform: uppercase;\n}\n.small-3[data-v-62ba0720] {\n    width: 50%;\n}\n.fix-footer .row[data-v-62ba0720] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.fix-footer .per-page[data-v-62ba0720] {\n    width: auto;\n}\n.fix-footer .per-page select[data-v-62ba0720] {\n      width: 55px;\n}\n.fix-footer .per-page span[data-v-62ba0720]:nth-child(3) {\n      display: none;\n}\n.fix-footer .page-data[data-v-62ba0720] {\n    display: none;\n}\n.fix-footer .pagination[data-v-62ba0720] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.fix-footer .pagination select[data-v-62ba0720] {\n      width: 55px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  send: function send(VueApp, data, callback) {
    data.token = VueApp.$store.state.session.sessionToken;
    VueApp.$sdk.post('/consumer/notification', data, function (res) {
      callback(res);
    });
  }
});

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListFilter_vue__ = __webpack_require__(410);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3165d773_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListFilter_vue__ = __webpack_require__(1152);
function injectStyle (ssrContext) {
  __webpack_require__(1150)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3165d773"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3165d773_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1151);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("3f0dfb22", content, true, {});

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.filter[data-v-3165d773] {\n  border-bottom: 1px solid #bbb;\n  background: #fcfcfc;\n  margin-bottom: 10px;\n  border-radius: 2px;\n}\n.filter .row[data-v-3165d773] {\n    max-width: 100%;\n}\n.field-label[data-v-3165d773] {\n  font-size: 13px;\n  color: #999;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.search-box[data-v-3165d773] {\n  display: inline-block;\n  padding: 20px 0 20px 15px;\n  position: relative;\n  width: 100%;\n}\n.search-box .error-msg[data-v-3165d773] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: calc(100% - 15px);\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    margin-left: 15px;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: bottom center;\n            transform-origin: bottom center;\n}\n.search[data-v-3165d773] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.search .search-input-box[data-v-3165d773] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-3165d773] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 5px 0 0 5px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-3165d773] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-3165d773] {\n      position: absolute;\n      top: 0;\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n      line-height: 46px;\n}\n.search button[data-v-3165d773] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 5px 5px 0;\n    padding: 0 20px;\n}\n.status[data-v-3165d773] {\n  display: inline-block;\n  padding: 20px 0 20px 15px;\n  width: 100%;\n}\n.status.last[data-v-3165d773] {\n    padding-right: 10px;\n}\nselect[data-v-3165d773] {\n  padding: 10px;\n  height: 46px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-3165d773] {\n    background-color: #ebebe4;\n}\n.flex[data-v-3165d773] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.flex select[data-v-3165d773] {\n    -webkit-box-flex: 100;\n        -ms-flex-positive: 100;\n            flex-grow: 100;\n}\n.export-box[data-v-3165d773] {\n  padding: 35px 10px 0;\n}\n.slide-left-enter-active[data-v-3165d773], .slide-left-leave-active[data-v-3165d773] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-left-enter[data-v-3165d773], .slide-left-leave-to[data-v-3165d773] {\n  -webkit-transform: translateX(30px);\n          transform: translateX(30px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.small-3[data-v-3165d773] {\n    width: 100%;\n}\n.small-2[data-v-3165d773], .small-1[data-v-3165d773] {\n    width: 50%;\n}\n.small-offset-6[data-v-3165d773] {\n    margin-left: 0;\n}\n.search-box[data-v-3165d773], .status[data-v-3165d773], .export-box[data-v-3165d773] {\n    padding: 0 10px;\n}\n.search-box[data-v-3165d773] {\n    padding-top: 5px;\n}\n.export-box[data-v-3165d773] {\n    margin-top: 15px;\n    padding-bottom: 15px;\n}\n.export-box .large[data-v-3165d773] {\n      line-height: 16px;\n      font-size: 16px;\n      padding: 12px 17px 13px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Consumer/ListFilter.vue"],"names":[],"mappings":";AACA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;CACpB;AACD;IACI,gBAAgB;CACnB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;CACpB;AACD;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;CACb;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,wCAAwC;YAChC,gCAAgC;CAC3C;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;CACb;AACD;IACI,YAAY;IACZ,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,uBAAuB;MACvB,cAAc;MACd,2BAA2B;MAC3B,oBAAoB;CACzB;AACD;QACQ,sBAAsB;CAC7B;AACD;MACM,mBAAmB;MACnB,OAAO;MACP,WAAW;MACX,eAAe;MACf,gBAAgB;MAChB,kBAAkB;CACvB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;CACnB;AACD;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;CACb;AACD;IACI,oBAAoB;CACvB;AACD;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,+BAA+B;CAChC;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,sBAAsB;QAClB,uBAAuB;YACnB,eAAe;CAC1B;AACD;EACE,qBAAqB;CACtB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;AACA;IACI,YAAY;CACf;AACD;IACI,WAAW;CACd;AACD;IACI,eAAe;CAClB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,iBAAiB;IACjB,qBAAqB;CACxB;AACD;MACM,kBAAkB;MAClB,gBAAgB;MAChB,wBAAwB;CAC7B;CACA","file":"ListFilter.vue","sourcesContent":["\n.filter[data-v-3165d773] {\n  border-bottom: 1px solid #bbb;\n  background: #fcfcfc;\n  margin-bottom: 10px;\n  border-radius: 2px;\n}\n.filter .row[data-v-3165d773] {\n    max-width: 100%;\n}\n.field-label[data-v-3165d773] {\n  font-size: 13px;\n  color: #999;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.search-box[data-v-3165d773] {\n  display: inline-block;\n  padding: 20px 0 20px 15px;\n  position: relative;\n  width: 100%;\n}\n.search-box .error-msg[data-v-3165d773] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: calc(100% - 15px);\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    margin-left: 15px;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: bottom center;\n            transform-origin: bottom center;\n}\n.search[data-v-3165d773] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.search .search-input-box[data-v-3165d773] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-3165d773] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 5px 0 0 5px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-3165d773] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-3165d773] {\n      position: absolute;\n      top: 0;\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n      line-height: 46px;\n}\n.search button[data-v-3165d773] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 5px 5px 0;\n    padding: 0 20px;\n}\n.status[data-v-3165d773] {\n  display: inline-block;\n  padding: 20px 0 20px 15px;\n  width: 100%;\n}\n.status.last[data-v-3165d773] {\n    padding-right: 10px;\n}\nselect[data-v-3165d773] {\n  padding: 10px;\n  height: 46px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-3165d773] {\n    background-color: #ebebe4;\n}\n.flex[data-v-3165d773] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.flex select[data-v-3165d773] {\n    -webkit-box-flex: 100;\n        -ms-flex-positive: 100;\n            flex-grow: 100;\n}\n.export-box[data-v-3165d773] {\n  padding: 35px 10px 0;\n}\n.slide-left-enter-active[data-v-3165d773], .slide-left-leave-active[data-v-3165d773] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-left-enter[data-v-3165d773], .slide-left-leave-to[data-v-3165d773] {\n  -webkit-transform: translateX(30px);\n          transform: translateX(30px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.small-3[data-v-3165d773] {\n    width: 100%;\n}\n.small-2[data-v-3165d773], .small-1[data-v-3165d773] {\n    width: 50%;\n}\n.small-offset-6[data-v-3165d773] {\n    margin-left: 0;\n}\n.search-box[data-v-3165d773], .status[data-v-3165d773], .export-box[data-v-3165d773] {\n    padding: 0 10px;\n}\n.search-box[data-v-3165d773] {\n    padding-top: 5px;\n}\n.export-box[data-v-3165d773] {\n    margin-top: 15px;\n    padding-bottom: 15px;\n}\n.export-box .large[data-v-3165d773] {\n      line-height: 16px;\n      font-size: 16px;\n      padding: 12px 17px 13px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-3 columns"},[_c('div',{staticClass:"search-box"},[_c('label',{staticClass:"field-label"},[_vm._v("Search:")]),_vm._v(" "),_c('div',{staticClass:"search"},[_c('div',{staticClass:"search-input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],ref:"search",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.searchInput)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search.apply(null, arguments)},"blur":_vm.blurSearch,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-left"}},[(_vm.searchInput.length > 0)?_c('i',{staticClass:"far fa-times-circle fa-lg",on:{"click":_vm.clearSearch}}):_vm._e()])],1),_vm._v(" "),_c('button',{class:{'button xsmall success':true, 'disabled':_vm.loading},on:{"click":_vm.search}},[_c('i',{staticClass:"fas fa-search fa-lg"})])])])]),_vm._v(" "),_c('div',{staticClass:"small-2 columns end small-offset-6"},[_c('div',{staticClass:"status last"},[_c('label',{staticClass:"field-label"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"activate"}},[_vm._v("Activate")]),_vm._v(" "),_c('option',{attrs:{"value":"deactivate"}},[_vm._v("Deactivate")])]),_vm._v(" "),_c('button',{class:{'button small':true, 'disabled':_vm.loading},on:{"click":_vm.updateStatus}},[_vm._v("Go")])])])]),_vm._v(" "),_c('div',{staticClass:"small-1 columns end"},[_c('div',{staticClass:"export-box"},[_c('button',{class:{'button cta success large block':true, 'disabled':_vm.exportLoading},on:{"click":_vm.exportCons}},[(_vm.exportLoading)?_c('span',[_vm._v("Loading...")]):_c('span',[_vm._v("EXPORT")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"fixed-header"},[_c('div',{staticClass:"heading"},[_vm._v("\n      "+_vm._s(_vm.$t('consumer.list.heading'))+"\n      "),_c('div',{staticClass:"button warning xsmall notif-btn",on:{"click":_vm.showNotifForm}},[_vm._v(_vm._s(_vm.$t('consumer.list.sendNotif')))])]),_vm._v(" "),_c('list-filter')],1),_vm._v(" "),(!_vm.isMobile)?_c('div',{staticClass:"sticky"},[_c('table',[_c('thead',[_c('th',{staticClass:"status"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectAll),expression:"selectAll"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectAll)?_vm._i(_vm.selectAll,null)>-1:(_vm.selectAll)},on:{"change":function($event){var $$a=_vm.selectAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectAll=$$c}}}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.list.firstName')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.list.lastName')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.list.email')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.list.mobile')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.list.created')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.list.referralCode')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.list.details')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.list.status')))])]),_vm._v(" "),_c('tbody',_vm._l((_vm.users),function(user){return _c('tr',[_c('td',{staticClass:"status"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],attrs:{"type":"checkbox","number":""},domProps:{"value":user.id,"checked":Array.isArray(_vm.selected)?_vm._i(_vm.selected,user.id)>-1:(_vm.selected)},on:{"change":function($event){var $$a=_vm.selected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=user.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selected=$$c}}}})]),_vm._v(" "),_c('td',[(user.customerURL === null)?_c('span',[_vm._v("--")]):_c('a',{attrs:{"href":"javascript:;","href":user.customerURL,"target":"_blank"}},[_c('i',{staticClass:"fa fa-link"})])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.firstName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.lastName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.email))]),_vm._v(" "),_c('td',[_c('a',{on:{"click":function($event){return _vm.call(user)}}},[_vm._v(_vm._s(user.mobile))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.created))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.referralCode))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'/#/consumer/' + user.id,"target":"_blank"}},[_vm._v("View")])]),_vm._v(" "),_c('td',[_c('label',{class:['status-label', user.status]},[_vm._v(_vm._s(user.status))])])])}),0)])]):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('table',{staticClass:"main-table"},[_c('thead',[_c('th',{staticClass:"status"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectAll),expression:"selectAll"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectAll)?_vm._i(_vm.selectAll,null)>-1:(_vm.selectAll)},on:{"change":function($event){var $$a=_vm.selectAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectAll=$$c}}}})]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.list.firstName')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.list.lastName')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.list.email')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.list.mobile')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.list.created')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.list.referralCode')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.list.details')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.list.status')))])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.users),function(user){return _c('tr',[_c('td',{staticClass:"status"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],attrs:{"type":"checkbox","number":""},domProps:{"value":user.id,"checked":Array.isArray(_vm.selected)?_vm._i(_vm.selected,user.id)>-1:(_vm.selected)},on:{"change":function($event){var $$a=_vm.selected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=user.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selected=$$c}}}})]),_vm._v(" "),_c('td',[(user.customerURL === null)?_c('span',[_vm._v("--")]):_c('a',{attrs:{"href":"javascript:;","href":user.customerURL,"target":"_blank"}},[_c('i',{staticClass:"fa fa-link"})])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.firstName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.lastName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.email))]),_vm._v(" "),_c('td',[_c('a',{on:{"click":function($event){return _vm.call(user)}}},[_vm._v(_vm._s(_vm.displayPhone(user)))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.created))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.referralCode))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'/#/consumer/' + user.id,"target":"_blank"}},[_vm._v("View")])]),_vm._v(" "),_c('td',[_c('label',{class:['status-label', user.status]},[_vm._v(_vm._s(user.status))])])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"tr-loader"},[_c('td',{staticClass:"table-block",attrs:{"colspan":"13"}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n              "+_vm._s(_vm.$t('consumer.list.gettingUsers'))+"\n            ")])])],1)])],2)]):_c('div',{staticClass:"card-div"},_vm._l((_vm.users),function(user,i){return _c('div',{key:i,staticClass:"cards"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"title card-header"},[_c('div',{staticClass:"time"},[_c('div',{staticClass:"title"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],attrs:{"type":"checkbox","number":""},domProps:{"value":user.id,"checked":Array.isArray(_vm.selected)?_vm._i(_vm.selected,user.id)>-1:(_vm.selected)},on:{"change":function($event){var $$a=_vm.selected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=user.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("Created: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(user.created))])])]),_vm._v(" "),_c('div',{staticClass:"link"},[_c('label',{class:['status-label', user.status]},[_vm._v(_vm._s(user.status))]),_vm._v(" "),_c('div',[(user.customerURL === null)?_c('span',[_vm._v("--")]):_c('a',{attrs:{"href":"javascript:;","href":user.customerURL,"target":"_blank"}},[_c('i',{staticClass:"fa fa-link"})])])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"value"},[_c('i',{staticClass:"fas fa-address-card"}),_vm._v(" "+_vm._s(user.firstName)+" "+_vm._s(user.lastName))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"value"},[_c('i',{staticClass:"fas fa-envelope"}),_vm._v(" "+_vm._s(user.email))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"value"},[_c('i',{staticClass:"fas fa-phone"}),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.call(user)}}},[_vm._v(_vm._s(_vm.displayPhone(user)))])])]),_vm._v(" "),_c('div',{staticClass:"title view"},[_c('div',{staticClass:"refer"},[_c('span',{staticClass:"label"},[_vm._v("Referral Code:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(user.referralCode))])]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":'/#/consumer/' + user.id,"target":"_blank"}},[_vm._v("View")])])])])])}),0),_vm._v(" "),_c('div',{staticClass:"fix-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-3 columns per-page"},[_c('span',[_vm._v("Displaying")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"5"}},[_vm._v("5")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" "),_c('span',[_vm._v("per page")])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns page-data"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.length > 0),expression:"users.length > 0"}]},[_vm._v("\n          Displaying\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.start))]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.pageData.end))]),_vm._v(" of\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.max))])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns pagination"},[_c('span',[_vm._v("Page")]),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.currentPage === 1 || _vm.loading},on:{"click":_vm.prev}},[_c('i',{staticClass:"fas fa-chevron-left"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentPage),expression:"currentPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.totalPage),function(i){return _c('option',{domProps:{"value":i}},[_vm._v(_vm._s(i))])}),0),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.isLastPage || _vm.loading},on:{"click":_vm.next}},[_c('i',{staticClass:"fas fa-chevron-right"})])])])]),_vm._v(" "),_c('div',{class:{ 'op--modal-container':true, hide: !_vm.notification.showForm },on:{"click":_vm.closeNotifForm}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content"},[_c('div',{staticClass:"notification-form",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"modal-heading"},[_vm._v(_vm._s(_vm.$t('consumer.list.pushNotif')))]),_vm._v(" "),_c('div',{staticClass:"nf-content",on:{"click":_vm.closeEmoji}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.notification.errorMsg && !_vm.notification.success),expression:"!notification.errorMsg && !notification.success"}]},[_c('div',{class:{'data-field':true, 'has-error':!!_vm.notification.targetMessage}},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('consumer.list.target'))+":")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.notification.target),expression:"notification.target"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.notification, "target", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"all"}},[_vm._v(_vm._s(_vm.$t('consumer.list.allUser')))]),_vm._v(" "),_c('option',{attrs:{"value":"selected"}},[_vm._v(_vm._s(_vm.$t('consumer.list.selectedUser')))])]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.notification.targetMessage))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.notification.target === 'all'),expression:"notification.target === 'all'"}],class:{'data-field':true, 'has-error':!!_vm.notification.brandErrorMsg}},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('consumer.list.brands'))+":")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.notification.brand),expression:"notification.brand"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.notification, "brand", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.brands),function(brand){return _c('option',{domProps:{"value":brand.id}},[_vm._v(_vm._s(brand.name))])}),0),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.notification.brandErrorMsg))])]),_vm._v(" "),(false)?_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notification.isPushNotif),expression:"notification.isPushNotif"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.notification.isPushNotif)?_vm._i(_vm.notification.isPushNotif,null)>-1:(_vm.notification.isPushNotif)},on:{"change":function($event){var $$a=_vm.notification.isPushNotif,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.notification, "isPushNotif", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.notification, "isPushNotif", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.notification, "isPushNotif", $$c)}}}}),_vm._v("\n                "+_vm._s(_vm.$t('consumer.list.pushNotif'))+"\n              ")]):_vm._e(),_vm._v(" "),(false)?_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notification.isSendEmail),expression:"notification.isSendEmail"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.notification.isSendEmail)?_vm._i(_vm.notification.isSendEmail,null)>-1:(_vm.notification.isSendEmail)},on:{"change":function($event){var $$a=_vm.notification.isSendEmail,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.notification, "isSendEmail", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.notification, "isSendEmail", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.notification, "isSendEmail", $$c)}}}}),_vm._v("\n                "+_vm._s(_vm.$t('consumer.list.email'))+"\n              ")]):_vm._e(),_vm._v(" "),_c('div',{class:{'data-field':true, 'has-error':!!_vm.notification.titleError}},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('consumer.list.title'))+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notification.title),expression:"notification.title"}],staticClass:"input",attrs:{"type":"text"},domProps:{"value":(_vm.notification.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.notification, "title", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.notification.titleError))])]),_vm._v(" "),_c('div',{staticClass:"textarea-box"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.notification.message),expression:"notification.message"}],ref:"notifMsg",class:{'exceed':_vm.notification.charExceed},attrs:{"rows":"5","placeholder":_vm.$t('consumer.list.message')},domProps:{"value":(_vm.notification.message)},on:{"keydown":_vm.charCountUpdate,"keyup":_vm.charCountUpdate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.notification, "message", $event.target.value)}}}),_vm._v(" "),_c('i',{staticClass:"far fa-smile fa-lg emoji-trigger",on:{"click":[function($event){$event.stopPropagation();},function($event){_vm.notification.showEmoji = !_vm.notification.showEmoji}]}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.notification.messageError))])]),_vm._v(" "),(false)?_c('div',{class:{'data-field':true, 'has-error':!!_vm.notification.fileError}},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('consumer.list.img'))+":")]),_vm._v(" "),_c('div',{staticClass:"file-box"},[(_vm.notification.fileReady)?_c('input',{ref:"fileInput",staticClass:"input-file",attrs:{"type":"file","name":"image","accept":"image/*"},on:{"change":_vm.setImage}}):_vm._e(),_vm._v(" "),(!!_vm.notification.file)?_c('i',{staticClass:"fas fa-times fa-lg",on:{"click":_vm.cleanFileInput}}):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.notification.fileError))])]):_vm._e(),_vm._v(" "),_c('div',{class:{'button cta warning block':true, 'disabled':_vm.disableNotifButton},on:{"click":_vm.checkFileUpload}},[_vm._v("\n                "+_vm._s(_vm.$t('consumer.list.send'))+"\n              ")]),_vm._v(" "),_c('a',{staticClass:"cancel-notif",on:{"click":_vm.closeNotifForm}},[_vm._v(_vm._s(_vm.$t('consumer.list.cancel')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.notification.errorMsg),expression:"!!notification.errorMsg"}],staticClass:"error"},[_c('i',{staticClass:"far fa-frown fa-5x"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('consumer.list.errorMsg')))]),_vm._v(" "),_c('code',[_vm._v(_vm._s(_vm.notification.errorMsg))]),_vm._v(" "),_c('div',{staticClass:"button cta block small error",on:{"click":_vm.closeNotifForm}},[_vm._v(_vm._s(_vm.$t('consumer.list.close')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.notification.success),expression:"notification.success"}],staticClass:"success-box"},[_c('i',{staticClass:"far fa-check-circle fa-5x"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('consumer.list.sendNotifSuccess')))]),_vm._v(" "),_c('div',{staticClass:"button cta block small success",on:{"click":_vm.closeNotifForm}},[_vm._v(_vm._s(_vm.$t('consumer.list.close')))])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-left"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.notification.showEmoji),expression:"notification.showEmoji"}],staticClass:"emoji-box",on:{"click":function($event){$event.stopPropagation();}}},[_c('picker',{style:(_vm.emojiStyle),attrs:{"exclude":['recent']},on:{"select":_vm.addEmoji}})],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"pop"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.notification.loading),expression:"notification.loading"}],staticClass:"loader"},[_c('div',[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('consumer.list.sendingNotif')))])])])])],1)])])])]),_vm._v(" "),_c('div',{class:{ 'op--modal-container':true, hide: !_vm.statusUpdate.showConfirmation },on:{"click":_vm.closeStatusUpdate}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content"},[_c('div',{staticClass:"status-confirmation",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.statusUpdate.errorMsg && !_vm.statusUpdate.success),expression:"!statusUpdate.errorMsg && !statusUpdate.success"}]},[_c('p',[_vm._v(_vm._s(_vm.$t('consumer.list.confirmLabel', {action: _vm.reactivateSelected ? 're-activate' : 'disable'})))]),_vm._v(" "),_c('div',{staticClass:"button cta block xsmall success",on:{"click":_vm.updateStatus}},[_vm._v(_vm._s(_vm.$t('consumer.list.yesUpdate')))]),_vm._v(" "),_c('a',{staticClass:"cancel",on:{"click":_vm.closeStatusUpdate}},[_vm._v(_vm._s(_vm.$t('consumer.list.cancel')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.statusUpdate.errorMsg),expression:"!!statusUpdate.errorMsg"}],staticClass:"error"},[_c('i',{staticClass:"far fa-frown fa-5x"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('consumer.list.errorMsg')))]),_vm._v(" "),_c('code',[_vm._v(_vm._s(_vm.statusUpdate.errorMsg))]),_vm._v(" "),_c('div',{staticClass:"button cta block small error",on:{"click":_vm.closeStatusUpdate}},[_vm._v(_vm._s(_vm.$t('consumer.list.close')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statusUpdate.success),expression:"statusUpdate.success"}],staticClass:"success-box"},[_c('i',{staticClass:"far fa-check-circle fa-5x"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('consumer.list.statusUpdateSuccess')))]),_vm._v(" "),_c('div',{staticClass:"button cta block small success",on:{"click":_vm.closeStatusUpdate}},[_vm._v(_vm._s(_vm.$t('consumer.list.close')))])]),_vm._v(" "),_c('transition',{attrs:{"name":"pop"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statusUpdate.loading),expression:"statusUpdate.loading"}],staticClass:"loader"},[_c('div',[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('consumer.list.statusUpdateLoading')))])])])])],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('i',{staticClass:"fab fa-stripe-s"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('i',{staticClass:"fab fa-stripe-s"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(411);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16fffadc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1165);
function injectStyle (ssrContext) {
  __webpack_require__(1155)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16fffadc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16fffadc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1156);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("707ba6db", content, true, {});

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.fixed-header[data-v-16fffadc] {\n  width: 100%;\n  margin-bottom: 30px;\n}\n.heading[data-v-16fffadc] {\n  margin-left: 50px;\n  padding-left: 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.card[data-v-16fffadc] {\n  margin-bottom: 10px;\n}\n@media only screen and (max-width: 430px) {\n.fixed-header[data-v-16fffadc] {\n    width: 100%;\n    margin-bottom: 0;\n}\n.card[data-v-16fffadc] {\n    margin-bottom: 0;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Corporate/index.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,oBAAoB;CACrB;AACD;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;CAC3B;AACD;EACE,oBAAoB;CACrB;AACD;AACA;IACI,YAAY;IACZ,iBAAiB;CACpB;AACD;IACI,iBAAiB;CACpB;CACA","file":"index.vue","sourcesContent":["\n.fixed-header[data-v-16fffadc] {\n  width: 100%;\n  margin-bottom: 30px;\n}\n.heading[data-v-16fffadc] {\n  margin-left: 50px;\n  padding-left: 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.card[data-v-16fffadc] {\n  margin-bottom: 10px;\n}\n@media only screen and (max-width: 430px) {\n.fixed-header[data-v-16fffadc] {\n    width: 100%;\n    margin-bottom: 0;\n}\n.card[data-v-16fffadc] {\n    margin-bottom: 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListFilter_vue__ = __webpack_require__(412);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_262a77d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListFilter_vue__ = __webpack_require__(1160);
function injectStyle (ssrContext) {
  __webpack_require__(1158)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-262a77d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_262a77d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1159);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2521045d", content, true, {});

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.filter[data-v-262a77d0] {\n  padding: 10px;\n}\n.filter .row[data-v-262a77d0] {\n    max-width: 100%;\n}\n.field-label[data-v-262a77d0] {\n  font-size: 13px;\n  color: #999;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.search-box[data-v-262a77d0] {\n  display: inline-block;\n  padding: 20px 0 20px 15px;\n  position: relative;\n  width: 100%;\n}\n.search-box .error-msg[data-v-262a77d0] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: calc(100% - 15px);\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    margin-left: 15px;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: bottom center;\n            transform-origin: bottom center;\n}\n.search[data-v-262a77d0] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.search .search-input-box[data-v-262a77d0] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-262a77d0] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 5px 0 0 5px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-262a77d0] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-262a77d0] {\n      position: absolute;\n      top: 0;\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n      line-height: 46px;\n}\n.search button[data-v-262a77d0] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 5px 5px 0;\n    padding: 0 20px;\n}\n.status[data-v-262a77d0] {\n  display: inline-block;\n  padding: 20px 0 20px 15px;\n  width: 100%;\n}\n.status.last[data-v-262a77d0] {\n    padding-right: 10px;\n}\nselect[data-v-262a77d0] {\n  padding: 10px;\n  height: 46px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-262a77d0] {\n    background-color: #ebebe4;\n}\n.flex[data-v-262a77d0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.flex select[data-v-262a77d0] {\n    -webkit-box-flex: 100;\n        -ms-flex-positive: 100;\n            flex-grow: 100;\n}\n.slide-left-enter-active[data-v-262a77d0], .slide-left-leave-active[data-v-262a77d0] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-left-enter[data-v-262a77d0], .slide-left-leave-to[data-v-262a77d0] {\n  -webkit-transform: translateX(30px);\n          transform: translateX(30px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.filter[data-v-262a77d0] {\n    padding: 0;\n}\n.filter .row[data-v-262a77d0] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.filter .row .small-6[data-v-262a77d0] {\n        width: 100%;\n}\n.filter .row .small-3[data-v-262a77d0] {\n        float: none;\n        width: 50%;\n        margin-left: 0;\n}\n.filter .row .small-3 .status[data-v-262a77d0] {\n          padding: 24px 15px 20px 15px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Corporate/ListFilter.vue"],"names":[],"mappings":";AACA;EACE,cAAc;CACf;AACD;IACI,gBAAgB;CACnB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;CACpB;AACD;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;CACb;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,wCAAwC;YAChC,gCAAgC;CAC3C;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;CACb;AACD;IACI,YAAY;IACZ,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,uBAAuB;MACvB,cAAc;MACd,2BAA2B;MAC3B,oBAAoB;CACzB;AACD;QACQ,sBAAsB;CAC7B;AACD;MACM,mBAAmB;MACnB,OAAO;MACP,WAAW;MACX,eAAe;MACf,gBAAgB;MAChB,kBAAkB;CACvB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;CACnB;AACD;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;CACb;AACD;IACI,oBAAoB;CACvB;AACD;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,+BAA+B;CAChC;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,sBAAsB;QAClB,uBAAuB;YACnB,eAAe;CAC1B;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;AACA;IACI,WAAW;CACd;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;CACnB;AACD;QACQ,YAAY;CACnB;AACD;QACQ,YAAY;QACZ,WAAW;QACX,eAAe;CACtB;AACD;UACU,6BAA6B;CACtC;CACA","file":"ListFilter.vue","sourcesContent":["\n.filter[data-v-262a77d0] {\n  padding: 10px;\n}\n.filter .row[data-v-262a77d0] {\n    max-width: 100%;\n}\n.field-label[data-v-262a77d0] {\n  font-size: 13px;\n  color: #999;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.search-box[data-v-262a77d0] {\n  display: inline-block;\n  padding: 20px 0 20px 15px;\n  position: relative;\n  width: 100%;\n}\n.search-box .error-msg[data-v-262a77d0] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: calc(100% - 15px);\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    margin-left: 15px;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: bottom center;\n            transform-origin: bottom center;\n}\n.search[data-v-262a77d0] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.search .search-input-box[data-v-262a77d0] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-262a77d0] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 5px 0 0 5px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-262a77d0] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-262a77d0] {\n      position: absolute;\n      top: 0;\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n      line-height: 46px;\n}\n.search button[data-v-262a77d0] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 5px 5px 0;\n    padding: 0 20px;\n}\n.status[data-v-262a77d0] {\n  display: inline-block;\n  padding: 20px 0 20px 15px;\n  width: 100%;\n}\n.status.last[data-v-262a77d0] {\n    padding-right: 10px;\n}\nselect[data-v-262a77d0] {\n  padding: 10px;\n  height: 46px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-262a77d0] {\n    background-color: #ebebe4;\n}\n.flex[data-v-262a77d0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.flex select[data-v-262a77d0] {\n    -webkit-box-flex: 100;\n        -ms-flex-positive: 100;\n            flex-grow: 100;\n}\n.slide-left-enter-active[data-v-262a77d0], .slide-left-leave-active[data-v-262a77d0] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-left-enter[data-v-262a77d0], .slide-left-leave-to[data-v-262a77d0] {\n  -webkit-transform: translateX(30px);\n          transform: translateX(30px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.filter[data-v-262a77d0] {\n    padding: 0;\n}\n.filter .row[data-v-262a77d0] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.filter .row .small-6[data-v-262a77d0] {\n        width: 100%;\n}\n.filter .row .small-3[data-v-262a77d0] {\n        float: none;\n        width: 50%;\n        margin-left: 0;\n}\n.filter .row .small-3 .status[data-v-262a77d0] {\n          padding: 24px 15px 20px 15px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"search-box"},[_c('label',{staticClass:"field-label"},[_vm._v("Search:")]),_vm._v(" "),_c('div',{staticClass:"search"},[_c('div',{staticClass:"search-input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],ref:"search",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.searchInput)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search.apply(null, arguments)},"blur":_vm.blurSearch,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-left"}},[(_vm.searchInput.length > 0)?_c('i',{staticClass:"far fa-times-circle fa-lg",on:{"click":_vm.clearSearch}}):_vm._e()])],1),_vm._v(" "),_c('button',{class:{'button xsmall success':true, disabled:_vm.loading},on:{"click":_vm.search}},[_c('i',{staticClass:"fas fa-search fa-lg"})])])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns end small-offset-3"},[_c('div',{staticClass:"status last"},[_c('label',{staticClass:"field-label"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('a',{class:{'button block cta small':true, 'disabled':_vm.loading},attrs:{"href":"/#/corporate/new"}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v("\n            CREATE\n          ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListTable_vue__ = __webpack_require__(414);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e38218c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListTable_vue__ = __webpack_require__(1164);
function injectStyle (ssrContext) {
  __webpack_require__(1162)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e38218c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e38218c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1163);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4883eedb", content, true, {});

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.list-table[data-v-5e38218c] {\n  background: #fff;\n  border-radius: 3px;\n  position: relative;\n  min-height: 100px;\n  overflow: hidden;\n}\n.sticky[data-v-5e38218c] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  height: 30px;\n  z-index: 3;\n}\n.sticky .scroll-table[data-v-5e38218c]::-webkit-scrollbar {\n    visibility: hidden;\n}\n.sticky tbody[data-v-5e38218c] {\n    visibility: hidden;\n}\n.scroll-table[data-v-5e38218c] {\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: calc(100vh - 290px);\n  min-height: 400px;\n}\ntable[data-v-5e38218c] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-5e38218c] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-5e38218c] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-5e38218c] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-5e38218c] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-5e38218c] {\n    background-color: #fff;\n    border-top: 1px solid rgba(0, 0, 0, 0.3);\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-5e38218c] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-5e38218c] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-5e38218c] {\n          color: #ccc;\n}\ntable .email-logo img[data-v-5e38218c] {\n    max-width: 100px;\n    max-height: 100px;\n}\ntable .stripe[data-v-5e38218c] {\n    font-size: 16px;\n}\ntable .stripe .fa-link[data-v-5e38218c] {\n      color: #0D79F2;\n}\ntable .stripe span .fa-link[data-v-5e38218c] {\n      opacity: .4;\n}\ntable .status[data-v-5e38218c], table a[data-v-5e38218c] {\n    cursor: pointer;\n}\ntable .status[data-v-5e38218c] {\n    width: 110px;\n}\n.switch[data-v-5e38218c] {\n  position: relative;\n  display: inline-block;\n}\n.switch .slider[data-v-5e38218c] {\n    position: relative;\n    margin-bottom: 3px;\n    display: inline-block;\n    width: 50px;\n    height: 26px;\n    border-radius: 20px;\n    background: #ccc;\n    position: relative;\n    cursor: pointer;\n    -webkit-transition: all .25s ease-in-out;\n    transition: all .25s ease-in-out;\n}\n.switch .slider.disabled[data-v-5e38218c] {\n      opacity: .4;\n}\n.switch .slider[data-v-5e38218c]:before {\n      content: '';\n      position: absolute;\n      top: 2px;\n      left: 3px;\n      width: 21px;\n      height: 21px;\n      border-radius: 50%;\n      background: #fff;\n      -webkit-transition: all .25s ease-in-out;\n      transition: all .25s ease-in-out;\n      -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n}\n.switch .slider.active[data-v-5e38218c] {\n      background: #57d1b7;\n}\n.switch .slider.active[data-v-5e38218c]:before {\n        left: 25px;\n}\n.switch .label[data-v-5e38218c] {\n    display: block;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1;\n    color: #555;\n    text-transform: uppercase;\n}\n.fix-footer[data-v-5e38218c] {\n  width: 100%;\n  height: 60px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-5e38218c] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-5e38218c] {\n    max-width: 100px;\n}\n.fix-footer .per-page[data-v-5e38218c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .per-page span[data-v-5e38218c] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-5e38218c] {\n    text-align: center;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .pagination[data-v-5e38218c] {\n    text-align: right;\n    padding: 15px 10px;\n}\n.fix-footer .pagination.prev-next[data-v-5e38218c] {\n      text-align: center;\n}\n.fix-footer .pagination span[data-v-5e38218c] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-5e38218c] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-5e38218c] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-5e38218c] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-5e38218c] {\n        opacity: .4;\n        cursor: default;\n}\n.slide-up-enter-active[data-v-5e38218c], .slide-up-leave-active[data-v-5e38218c] {\n  -webkit-transition: all .6s ease;\n  transition: all .6s ease;\n}\n.slide-up-enter[data-v-5e38218c], .slide-up-leave-to[data-v-5e38218c] {\n  -webkit-transform: translateY(30px);\n          transform: translateY(30px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.fix-footer .row[data-v-5e38218c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.fix-footer .per-page[data-v-5e38218c] {\n    width: auto;\n}\n.fix-footer .per-page select[data-v-5e38218c] {\n      width: 55px;\n}\n.fix-footer .per-page span[data-v-5e38218c]:nth-child(3) {\n      display: none;\n}\n.fix-footer .page-data[data-v-5e38218c] {\n    display: none;\n}\n.fix-footer .pagination[data-v-5e38218c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    padding: 15px 0px;\n    margin-right: 15%;\n}\n.fix-footer .pagination select[data-v-5e38218c] {\n      width: 55px;\n}\n.loader[data-v-5e38218c], .empty-result[data-v-5e38218c] {\n    text-align: center;\n    padding: 50px 0;\n}\n.cards[data-v-5e38218c] {\n    width: 90%;\n    margin: 0 auto;\n    margin-top: 20px;\n}\n.cards .card[data-v-5e38218c] {\n      border: 1px solid #ccc;\n      margin-bottom: 15px;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.cards .card .info[data-v-5e38218c] {\n        width: 100%;\n        padding-left: 10px;\n}\n.cards .card > div[data-v-5e38218c] {\n        margin-bottom: 3px;\n}\n.cards .card .email-logo img[data-v-5e38218c] {\n        max-width: 100px;\n        max-height: 100px;\n}\n.cards .card .card-header[data-v-5e38218c] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n}\n.cards .card .card-header .name-stripe[data-v-5e38218c] {\n          font-size: 16px;\n          color: #000;\n          font-weight: 900;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          gap: 5px;\n          width: 150px;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n}\n.cards .card .card-header .name-stripe .name[data-v-5e38218c] {\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n}\n.cards .card .credit-card[data-v-5e38218c] {\n        font-weight: 900;\n}\n.cards .card .title[data-v-5e38218c] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        margin-bottom: 3px;\n}\n.cards .card .title input[data-v-5e38218c] {\n          margin-right: 5px;\n}\n.cards .card .title.view[data-v-5e38218c] {\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n          padding-top: 7px;\n          padding-bottom: 5px;\n          border-top: 1px solid #eee;\n}\n.cards .card .title .refer[data-v-5e38218c] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n.cards .card .label[data-v-5e38218c] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards .card .value[data-v-5e38218c] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards .card .value i[data-v-5e38218c] {\n          color: #bbb;\n}\n.cards .card .value a[data-v-5e38218c] {\n          text-decoration: none;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Corporate/ListTable.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,WAAW;CACZ;AACD;IACI,mBAAmB;CACtB;AACD;IACI,mBAAmB;CACtB;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;CACnB;AACD;EACE,0BAA0B;EAC1B,YAAY;CACb;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,4CAA4C;IAC5C,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,2BAA2B;CAChC;AACD;QACQ,iBAAiB;CACxB;AACD;IACI,uBAAuB;IACvB,yCAAyC;IACzC,4CAA4C;CAC/C;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;IACI,iBAAiB;IACjB,kBAAkB;CACrB;AACD;IACI,gBAAgB;CACnB;AACD;MACM,eAAe;CACpB;AACD;MACM,YAAY;CACjB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,aAAa;CAChB;AACD;EACE,mBAAmB;EACnB,sBAAsB;CACvB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,iCAAiC;CACpC;AACD;MACM,YAAY;CACjB;AACD;MACM,YAAY;MACZ,mBAAmB;MACnB,SAAS;MACT,UAAU;MACV,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,iBAAiB;MACjB,yCAAyC;MACzC,iCAAiC;MACjC,oDAAoD;cAC5C,4CAA4C;CACzD;AACD;MACM,oBAAoB;CACzB;AACD;QACQ,WAAW;CAClB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,0BAA0B;CAC7B;AACD;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;CACb;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;CACnB;AACD;MACM,sBAAsB;MACtB,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;CACnB;AACD;IACI,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,sBAAsB;MACtB,kBAAkB;CACvB;AACD;MACM,aAAa;MACb,uBAAuB;CAC5B;AACD;MACM,cAAc;MACd,eAAe;MACf,uBAAuB;MACvB,iBAAiB;MACjB,gBAAgB;MAChB,uBAAuB;MACvB,aAAa;CAClB;AACD;QACQ,kBAAkB;CACzB;AACD;QACQ,YAAY;QACZ,gBAAgB;CACvB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;AACA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;IACI,YAAY;CACf;AACD;MACM,YAAY;CACjB;AACD;MACM,cAAc;CACnB;AACD;IACI,cAAc;CACjB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;IAC5B,kBAAkB;IAClB,kBAAkB;CACrB;AACD;MACM,YAAY;CACjB;AACD;IACI,mBAAmB;IACnB,gBAAgB;CACnB;AACD;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;CACpB;AACD;MACM,uBAAuB;MACvB,oBAAoB;MACpB,aAAa;MACb,oBAAoB;MACpB,+BAA+B;MAC/B,oBAAoB;MACpB,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;CACnB;AACD;QACQ,YAAY;QACZ,mBAAmB;CAC1B;AACD;QACQ,mBAAmB;CAC1B;AACD;QACQ,iBAAiB;QACjB,kBAAkB;CACzB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,+BAA+B;QACvC,yBAAyB;YACrB,sBAAsB;gBAClB,wBAAwB;CACvC;AACD;UACU,gBAAgB;UAChB,YAAY;UACZ,iBAAiB;UACjB,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;UACd,SAAS;UACT,aAAa;UACb,0BAA0B;cACtB,uBAAuB;kBACnB,oBAAoB;CACrC;AACD;YACY,oBAAoB;YACpB,iBAAiB;YACjB,wBAAwB;CACnC;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,oBAAoB;QAC5B,mBAAmB;CAC1B;AACD;UACU,kBAAkB;CAC3B;AACD;UACU,0BAA0B;cACtB,uBAAuB;kBACnB,+BAA+B;UACvC,iBAAiB;UACjB,oBAAoB;UACpB,2BAA2B;CACpC;AACD;UACU,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;CACvB;AACD;QACQ,gBAAgB;QAChB,0BAA0B;QAC1B,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;CACzB;AACD;QACQ,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;CACxB;AACD;UACU,YAAY;CACrB;AACD;UACU,sBAAsB;CAC/B;CACA","file":"ListTable.vue","sourcesContent":["\n.list-table[data-v-5e38218c] {\n  background: #fff;\n  border-radius: 3px;\n  position: relative;\n  min-height: 100px;\n  overflow: hidden;\n}\n.sticky[data-v-5e38218c] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  height: 30px;\n  z-index: 3;\n}\n.sticky .scroll-table[data-v-5e38218c]::-webkit-scrollbar {\n    visibility: hidden;\n}\n.sticky tbody[data-v-5e38218c] {\n    visibility: hidden;\n}\n.scroll-table[data-v-5e38218c] {\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: calc(100vh - 290px);\n  min-height: 400px;\n}\ntable[data-v-5e38218c] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-5e38218c] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-5e38218c] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-5e38218c] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-5e38218c] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-5e38218c] {\n    background-color: #fff;\n    border-top: 1px solid rgba(0, 0, 0, 0.3);\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-5e38218c] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-5e38218c] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-5e38218c] {\n          color: #ccc;\n}\ntable .email-logo img[data-v-5e38218c] {\n    max-width: 100px;\n    max-height: 100px;\n}\ntable .stripe[data-v-5e38218c] {\n    font-size: 16px;\n}\ntable .stripe .fa-link[data-v-5e38218c] {\n      color: #0D79F2;\n}\ntable .stripe span .fa-link[data-v-5e38218c] {\n      opacity: .4;\n}\ntable .status[data-v-5e38218c], table a[data-v-5e38218c] {\n    cursor: pointer;\n}\ntable .status[data-v-5e38218c] {\n    width: 110px;\n}\n.switch[data-v-5e38218c] {\n  position: relative;\n  display: inline-block;\n}\n.switch .slider[data-v-5e38218c] {\n    position: relative;\n    margin-bottom: 3px;\n    display: inline-block;\n    width: 50px;\n    height: 26px;\n    border-radius: 20px;\n    background: #ccc;\n    position: relative;\n    cursor: pointer;\n    -webkit-transition: all .25s ease-in-out;\n    transition: all .25s ease-in-out;\n}\n.switch .slider.disabled[data-v-5e38218c] {\n      opacity: .4;\n}\n.switch .slider[data-v-5e38218c]:before {\n      content: '';\n      position: absolute;\n      top: 2px;\n      left: 3px;\n      width: 21px;\n      height: 21px;\n      border-radius: 50%;\n      background: #fff;\n      -webkit-transition: all .25s ease-in-out;\n      transition: all .25s ease-in-out;\n      -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n}\n.switch .slider.active[data-v-5e38218c] {\n      background: #57d1b7;\n}\n.switch .slider.active[data-v-5e38218c]:before {\n        left: 25px;\n}\n.switch .label[data-v-5e38218c] {\n    display: block;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1;\n    color: #555;\n    text-transform: uppercase;\n}\n.fix-footer[data-v-5e38218c] {\n  width: 100%;\n  height: 60px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-5e38218c] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-5e38218c] {\n    max-width: 100px;\n}\n.fix-footer .per-page[data-v-5e38218c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .per-page span[data-v-5e38218c] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-5e38218c] {\n    text-align: center;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .pagination[data-v-5e38218c] {\n    text-align: right;\n    padding: 15px 10px;\n}\n.fix-footer .pagination.prev-next[data-v-5e38218c] {\n      text-align: center;\n}\n.fix-footer .pagination span[data-v-5e38218c] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-5e38218c] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-5e38218c] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-5e38218c] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-5e38218c] {\n        opacity: .4;\n        cursor: default;\n}\n.slide-up-enter-active[data-v-5e38218c], .slide-up-leave-active[data-v-5e38218c] {\n  -webkit-transition: all .6s ease;\n  transition: all .6s ease;\n}\n.slide-up-enter[data-v-5e38218c], .slide-up-leave-to[data-v-5e38218c] {\n  -webkit-transform: translateY(30px);\n          transform: translateY(30px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.fix-footer .row[data-v-5e38218c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.fix-footer .per-page[data-v-5e38218c] {\n    width: auto;\n}\n.fix-footer .per-page select[data-v-5e38218c] {\n      width: 55px;\n}\n.fix-footer .per-page span[data-v-5e38218c]:nth-child(3) {\n      display: none;\n}\n.fix-footer .page-data[data-v-5e38218c] {\n    display: none;\n}\n.fix-footer .pagination[data-v-5e38218c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    padding: 15px 0px;\n    margin-right: 15%;\n}\n.fix-footer .pagination select[data-v-5e38218c] {\n      width: 55px;\n}\n.loader[data-v-5e38218c], .empty-result[data-v-5e38218c] {\n    text-align: center;\n    padding: 50px 0;\n}\n.cards[data-v-5e38218c] {\n    width: 90%;\n    margin: 0 auto;\n    margin-top: 20px;\n}\n.cards .card[data-v-5e38218c] {\n      border: 1px solid #ccc;\n      margin-bottom: 15px;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.cards .card .info[data-v-5e38218c] {\n        width: 100%;\n        padding-left: 10px;\n}\n.cards .card > div[data-v-5e38218c] {\n        margin-bottom: 3px;\n}\n.cards .card .email-logo img[data-v-5e38218c] {\n        max-width: 100px;\n        max-height: 100px;\n}\n.cards .card .card-header[data-v-5e38218c] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n}\n.cards .card .card-header .name-stripe[data-v-5e38218c] {\n          font-size: 16px;\n          color: #000;\n          font-weight: 900;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          gap: 5px;\n          width: 150px;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n}\n.cards .card .card-header .name-stripe .name[data-v-5e38218c] {\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n}\n.cards .card .credit-card[data-v-5e38218c] {\n        font-weight: 900;\n}\n.cards .card .title[data-v-5e38218c] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        margin-bottom: 3px;\n}\n.cards .card .title input[data-v-5e38218c] {\n          margin-right: 5px;\n}\n.cards .card .title.view[data-v-5e38218c] {\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n          padding-top: 7px;\n          padding-bottom: 5px;\n          border-top: 1px solid #eee;\n}\n.cards .card .title .refer[data-v-5e38218c] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n.cards .card .label[data-v-5e38218c] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards .card .value[data-v-5e38218c] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards .card .value i[data-v-5e38218c] {\n          color: #bbb;\n}\n.cards .card .value a[data-v-5e38218c] {\n          text-decoration: none;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-table"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile),expression:"!isMobile"}],staticClass:"sticky"},[_c('div',{staticClass:"scroll-table"},[_c('table',[_c('thead',[_c('th',[_vm._v("Logo")]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'username'},on:{"click":function($event){return _vm.sort('username')}}},[_vm._v("\n            Username\n            "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'username'),expression:"currentOrder.field === 'username'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'name'},on:{"click":function($event){return _vm.sort('name')}}},[_vm._v("\n            Name\n            "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'name'),expression:"currentOrder.field === 'name'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'contactEmail'},on:{"click":function($event){return _vm.sort('contactEmail')}}},[_vm._v("\n            Email\n            "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'contactEmail'),expression:"currentOrder.field === 'contactEmail'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'contactPhone'},on:{"click":function($event){return _vm.sort('contactPhone')}}},[_vm._v("\n            Mobile\n            "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'contactPhone'),expression:"currentOrder.field === 'contactPhone'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('th',[_vm._v("Status")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.users),function(user){return _c('tr',{key:user.id},[_c('td',{staticClass:"email-logo"},[_c('img',{attrs:{"src":user.logo}})]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'/#/corporate/' + user.id,"target":"_blank"}},[_vm._v(_vm._s(user.username))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.mobile))]),_vm._v(" "),_c('td',{staticClass:"stripe"},[(user.stripeUrl)?_c('a',{attrs:{"href":user.stripeUrl,"target":"_blank"}},[_c('i',{staticClass:"fa fa-link"})]):_c('span',{staticClass:"fa-stack"},[_c('i',{staticClass:"fa fa-link fa-stack-1x"}),_vm._v(" "),_c('i',{staticClass:"fas fa-slash fa-stack-1x",staticStyle:{"color":"Tomato"}})])]),_vm._v(" "),_c('td',{staticClass:"status"},[_c('div',{staticClass:"switch"},[_c('div',{class:{'slider':true, 'active':user.active, 'disabled':_vm.statusLoading.indexOf(user.id) > -1},on:{"click":function($event){return _vm.toggleStatus(user.id, user.active)}}}),_vm._v(" "),(user.active)?_c('span',{staticClass:"label"},[_vm._v("ACTIVE")]):_c('span',{staticClass:"label"},[_vm._v("DEACTIVATED")])])])])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile),expression:"!isMobile"}],staticClass:"scroll-table"},[_c('table',{staticClass:"main-table"},[_c('thead',[_c('th',[_vm._v("Logo")]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'username'},on:{"click":function($event){return _vm.sort('username')}}},[_vm._v("\n          Username\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'username'),expression:"currentOrder.field === 'username'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'name'},on:{"click":function($event){return _vm.sort('name')}}},[_vm._v("\n          Name\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'name'),expression:"currentOrder.field === 'name'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'contactEmail'},on:{"click":function($event){return _vm.sort('contactEmail')}}},[_vm._v("\n          Email\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'contactEmail'),expression:"currentOrder.field === 'contactEmail'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'contactPhone'},on:{"click":function($event){return _vm.sort('contactPhone')}}},[_vm._v("\n          Mobile\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'contactPhone'),expression:"currentOrder.field === 'contactPhone'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('th',[_vm._v("Status")])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.users),function(user){return _c('tr',{key:user.id},[_c('td',{staticClass:"email-logo"},[_c('img',{attrs:{"src":user.logo}})]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'/#/corporate/' + user.id,"target":"_blank"}},[_vm._v(_vm._s(user.username))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.mobile))]),_vm._v(" "),_c('td',{staticClass:"stripe"},[(user.stripeUrl)?_c('a',{attrs:{"href":user.stripeUrl,"target":"_blank"}},[_c('i',{staticClass:"fa fa-link"})]):_c('span',{staticClass:"fa-stack"},[_c('i',{staticClass:"fa fa-link fa-stack-1x"}),_vm._v(" "),_c('i',{staticClass:"fas fa-slash fa-stack-1x",staticStyle:{"color":"Tomato"}})])]),_vm._v(" "),_c('td',{staticClass:"status"},[_c('div',{staticClass:"switch"},[_c('div',{class:{'slider':true, 'active':user.active, 'disabled':_vm.statusLoading.indexOf(user.id) > -1},on:{"click":function($event){return _vm.toggleStatus(user.id, user.active)}}}),_vm._v(" "),(user.active)?_c('span',{staticClass:"label"},[_vm._v("ACTIVE")]):_c('span',{staticClass:"label"},[_vm._v("DEACTIVATED")])])])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading && _vm.users.length === 0),expression:"loading && users.length === 0"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"7"}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n                Getting corporate profiles...\n              ")])])],1)]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.length === 0 && !_vm.loading),expression:"users.length === 0 && !loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"7"}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.length === 0 && !_vm.loading),expression:"users.length === 0 && !loading"}],staticClass:"empty-result"},[_c('i',{staticClass:"far fa-frown-open fa-3x"}),_c('br'),_vm._v("\n                No record found!\n              ")])])],1)])],2)])]),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"cards"},[_vm._l((_vm.users),function(user){return _c('div',{key:user.id,staticClass:"card"},[_c('div',{staticClass:"email-logo"},[_c('img',{attrs:{"src":user.logo !='#' ? user.logo : 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1200px-No-Image-Placeholder.svg.png'}})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"name-stripe"},[_c('span',{staticClass:"name"},[_vm._v("\n              "+_vm._s(user.name)+"\n            ")]),_vm._v(" "),_c('span',{staticClass:"stripe"},[(user.stripeUrl)?_c('a',{attrs:{"href":user.stripeUrl,"target":"_blank"}},[_c('i',{staticClass:"fa fa-link"})]):_c('span',{staticClass:"fa-stack"},[_c('i',{staticClass:"fa fa-link fa-stack-1x"}),_vm._v(" "),_c('i',{staticClass:"fas fa-slash fa-stack-1x",staticStyle:{"color":"Tomato"}})])])]),_vm._v(" "),_c('div',{staticClass:"switch"},[_c('div',{class:{'slider':true, 'active':user.active, 'disabled':_vm.statusLoading.indexOf(user.id) > -1},on:{"click":function($event){return _vm.toggleStatus(user.id, user.active)}}})])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"value"},[_c('i',{staticClass:"fas fa-address-card"}),_vm._v(" "),_c('a',{attrs:{"href":'/#/corporate/' + user.id,"target":"_blank"}},[_vm._v(_vm._s(user.username))])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"value"},[_c('i',{staticClass:"fas fa-envelope"}),_vm._v(" "+_vm._s(user.email))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"value"},[_c('i',{staticClass:"fas fa-phone"}),_vm._v(" "+_vm._s(user.mobile))])])])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading && _vm.users.length === 0),expression:"loading && users.length === 0"}]},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n          Getting corporate profiles...\n        ")])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.length === 0 && !_vm.loading),expression:"users.length === 0 && !loading"}]},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.length === 0 && !_vm.loading),expression:"users.length === 0 && !loading"}],staticClass:"empty-result"},[_c('i',{staticClass:"far fa-frown-open fa-3x"}),_c('br'),_vm._v("\n          No record found!\n        ")])])],1)],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"fix-footer"},[_c('div',{staticClass:"small-4 columns per-page"},[_c('span',[_vm._v("Displaying")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":20}},[_vm._v("20")]),_vm._v(" "),_c('option',{domProps:{"value":50}},[_vm._v("50")]),_vm._v(" "),_c('option',{domProps:{"value":100}},[_vm._v("100")])]),_vm._v(" "),_c('span',[_vm._v("per page")])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns page-data"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.length > 0),expression:"users.length > 0"}]},[_vm._v("\n          Displaying\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.start))]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.pageData.end))]),_vm._v(" of\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.max))])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns pagination"},[_c('span',[_vm._v("Page")]),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.currentPage === 1 || _vm.loading},on:{"click":_vm.prev}},[_c('i',{staticClass:"fas fa-chevron-left"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentPage),expression:"currentPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.totalPage),function(i){return _c('option',{key:i,domProps:{"value":i}},[_vm._v(_vm._s(i))])}),0),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.isLastPage || _vm.loading},on:{"click":_vm.next}},[_c('i',{staticClass:"fas fa-chevron-right"})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('i',{staticClass:"fab fa-stripe-s"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('i',{staticClass:"fab fa-stripe-s"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column medium-12"},[_c('div',{staticClass:"card"},[_c('list-filter',{attrs:{"isMobile":_vm.isMobile}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column medium-12"},[_c('div',{staticClass:"card"},[_c('list-table',{attrs:{"isMobile":_vm.isMobile}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-header"},[_c('div',{staticClass:"heading"},[_vm._v("CORPORATE LIST")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProfile_vue__ = __webpack_require__(415);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b03e3c12_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProfile_vue__ = __webpack_require__(1169);
function injectStyle (ssrContext) {
  __webpack_require__(1167)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b03e3c12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b03e3c12_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1168);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5cc22726", content, true, {});

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.left-panel[data-v-b03e3c12] {\n  position: fixed;\n  z-index: 2;\n  left: 0;\n  top: 0;\n  width: 500px;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #F4F8F9;\n  overflow-y: auto;\n}\n.left-panel.no-scroll[data-v-b03e3c12] {\n    overflow: hidden;\n}\n.left-panel .heading[data-v-b03e3c12] {\n    padding-left: 50px;\n}\n.left-panel.centered[data-v-b03e3c12] {\n    width: 100%;\n}\n.left-panel.centered .heading[data-v-b03e3c12] {\n      background: #fff;\n      border-bottom: 1px solid #ddd;\n      margin-bottom: 20px;\n}\n.heading[data-v-b03e3c12] {\n  height: 50px;\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  padding: 10px 0;\n}\n.heading .cons-name[data-v-b03e3c12] {\n    padding: 0 5px 0 15px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 200px;\n    display: inline-block;\n}\n.body[data-v-b03e3c12] {\n  padding: 20px;\n  background: #fafafa;\n  border-top: 1px solid #ccc;\n}\n.body.card[data-v-b03e3c12] {\n    width: 900px;\n    margin: 0 auto;\n}\n.back-section[data-v-b03e3c12] {\n  font-size: 15px;\n  margin-bottom: 5px;\n}\n.back-section a[data-v-b03e3c12] {\n    cursor: pointer;\n    text-decoration: none;\n}\n.back-section i[data-v-b03e3c12] {\n    margin-right: 7px;\n}\n.logo-box[data-v-b03e3c12] {\n  text-align: center;\n  border-bottom: 1px solid #ddd;\n  padding: 0 20px 20px;\n}\n.logo-box .fa-user-circle[data-v-b03e3c12] {\n    font-size: 140px;\n    margin-top: 30px;\n    color: #f2ad6d;\n}\n.logo-box img[data-v-b03e3c12] {\n    max-width: 200px;\n    max-height: 200px;\n    cursor: pointer;\n    -webkit-transition: .2s ease all;\n    transition: .2s ease all;\n}\n.logo-box .img-hover-box[data-v-b03e3c12] {\n    position: relative;\n    display: inline-block;\n    border: 3px dashed #ddd;\n    width: 206px;\n    height: 206px;\n    overflow: hidden;\n    background: #fff;\n}\n.logo-box .img-hover-box .button[data-v-b03e3c12] {\n      position: absolute;\n      top: 60%;\n      left: 50%;\n      margin-top: -20px;\n      margin-left: -63px;\n      opacity: 0;\n}\n.logo-box .img-hover-box:hover img[data-v-b03e3c12] {\n      opacity: .6;\n}\n.logo-box .img-hover-box:hover .button[data-v-b03e3c12] {\n      opacity: 1;\n      top: 50%;\n}\n.logo-box .img-hover-box .fa-spinner[data-v-b03e3c12] {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      z-index: 3;\n      margin-top: -16px;\n      margin-left: -16px;\n}\n.logo-box .img-hover-box.loading img[data-v-b03e3c12] {\n      opacity: .6;\n}\n.logo-box .img-hover-box.loading:hover .button[data-v-b03e3c12] {\n      display: none;\n}\n.logo-box .recommended[data-v-b03e3c12] {\n    display: block;\n    font-size: 14px;\n    margin-bottom: 5px;\n    color: #666;\n    font-weight: 600;\n}\n.logo-box .error-msg[data-v-b03e3c12] {\n    display: block;\n    font-weight: 100;\n    margin-top: 2px;\n    color: #f20d0d;\n    font-size: 12px;\n    font-style: italic;\n}\n.details-box[data-v-b03e3c12] {\n  padding: 20px 0;\n}\n.data-field[data-v-b03e3c12] {\n  padding: 5px;\n  position: relative;\n}\n.data-field .label[data-v-b03e3c12] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .label.has-error[data-v-b03e3c12] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-b03e3c12] {\n    margin: 1px 0 0;\n    padding: 5px;\n    font-size: 14px;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-b03e3c12] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-b03e3c12]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-b03e3c12] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.data-field select[data-v-b03e3c12] {\n    border: 1px solid #ddd;\n    padding: 5px;\n    color: #333;\n    height: 35px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field select.has-error[data-v-b03e3c12] {\n      border-color: #f20d0d;\n}\n.data-field select[data-v-b03e3c12]:disabled {\n      background-color: #eee;\n}\n.billing-box[data-v-b03e3c12] {\n  padding: 15px;\n  background: #f2f2f2;\n  border: 1px solid #dedede;\n  border-radius: 4px;\n  margin-top: 30px;\n}\n.billing-box .billing-label[data-v-b03e3c12] {\n    font-size: 21px;\n    font-weight: 600;\n    padding-bottom: 5px;\n    color: #333;\n    text-align: center;\n}\n.billing-box .label[data-v-b03e3c12] {\n    color: #122a43;\n}\n.billing-box .error-msg[data-v-b03e3c12] {\n    color: #f20d0d;\n}\n.palette[data-v-b03e3c12] {\n  position: absolute;\n  top: 27px;\n  right: 13px;\n  background-color: #fafafa;\n  width: 20px;\n  height: 20px;\n  border-radius: 10px;\n  cursor: pointer;\n}\n.color-picker[data-v-b03e3c12] {\n  position: absolute;\n  top: 100%;\n  z-index: 3;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.color-picker.right[data-v-b03e3c12] {\n    right: 0;\n}\n.color-picker.left[data-v-b03e3c12] {\n    left: 0;\n}\n.respond-box[data-v-b03e3c12], .confirm-card[data-v-b03e3c12] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 4;\n  background: rgba(0, 0, 0, 0.5);\n  display: table;\n}\n.respond-box .vertical-center[data-v-b03e3c12], .confirm-card .vertical-center[data-v-b03e3c12] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.respond-box .card[data-v-b03e3c12], .confirm-card .card[data-v-b03e3c12] {\n    width: 80%;\n    max-width: 500px;\n    margin: 0 auto;\n    padding: 15px;\n    text-align: center;\n}\n.respond-box .fa-check-circle[data-v-b03e3c12], .respond-box .fa-times-circle[data-v-b03e3c12], .confirm-card .fa-check-circle[data-v-b03e3c12], .confirm-card .fa-times-circle[data-v-b03e3c12] {\n    font-size: 100px;\n    color: #26d97a;\n    margin-bottom: 5px;\n}\n.respond-box .fa-times-circle[data-v-b03e3c12], .confirm-card .fa-times-circle[data-v-b03e3c12] {\n    color: #F20D0D;\n}\n.respond-box .label[data-v-b03e3c12], .confirm-card .label[data-v-b03e3c12] {\n    font-weight: 600;\n    color: #505050;\n}\n.respond-box .message[data-v-b03e3c12], .confirm-card .message[data-v-b03e3c12] {\n    font-size: 14px;\n    color: #777;\n    margin: 10px 0;\n}\n.input-group[data-v-b03e3c12] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  position: relative;\n  margin-bottom: 0;\n}\n.input-group .input-group-label[data-v-b03e3c12] {\n    padding: 0 10px;\n    border: 1px solid #cacaca;\n    background: #f4f8f9;\n    color: #0a0a0a;\n    text-align: center;\n    white-space: nowrap;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n.input-group .mobile-input[data-v-b03e3c12] {\n    padding-left: 25px;\n    border-radius: 1px;\n    border-left: 0;\n}\n.input-group.small .mobile-input[data-v-b03e3c12] {\n    padding-left: 35px;\n}\n.input-group.medium .mobile-input[data-v-b03e3c12] {\n    padding-left: 45px;\n}\n.input-group.large .mobile-input[data-v-b03e3c12] {\n    padding-left: 55px;\n}\n.input-group.xl .mobile-input[data-v-b03e3c12] {\n    padding-left: 65px;\n}\n  /* Chrome, Safari, Edge, Opera */\ninput[data-v-b03e3c12]::-webkit-outer-spin-button,\ninput[data-v-b03e3c12]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n  /* Firefox */\ninput[type=number][data-v-b03e3c12] {\n  -moz-appearance: textfield;\n}\n.country-select[data-v-b03e3c12] {\n  margin-top: 1px;\n  cursor: pointer;\n  color: #333;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.country-select[data-v-b03e3c12]:hover {\n  background-color: #e6e6e6;\n}\n.country-code[data-v-b03e3c12] {\n  margin-right: 3px;\n  font-weight: 100;\n  font-size: 15px;\n}\n.margin-B-s[data-v-b03e3c12] {\n  margin-bottom: 5px;\n}\n.margin-B-m[data-v-b03e3c12] {\n  margin-bottom: 10px;\n}\n.margin-T-l[data-v-b03e3c12] {\n  margin-top: 15px;\n}\n.padding-R-m[data-v-b03e3c12] {\n  padding-right: 10px;\n}\n.padding-L-m[data-v-b03e3c12] {\n  padding-left: 10px;\n}\n.slide-up-enter-active[data-v-b03e3c12], .slide-up-leave-active[data-v-b03e3c12] {\n  -webkit-transition: all .6s ease;\n  transition: all .6s ease;\n}\n.slide-up-enter[data-v-b03e3c12], .slide-up-leave-to[data-v-b03e3c12] {\n  -webkit-transform: translateY(30px);\n          transform: translateY(30px);\n  opacity: 0;\n}\n.slide-down-enter-active[data-v-b03e3c12], .slide-down-leave-active[data-v-b03e3c12] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-b03e3c12], .slide-down-leave-to[data-v-b03e3c12] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.expand-enter-active[data-v-b03e3c12], .expand-leave-active[data-v-b03e3c12] {\n  -webkit-transition: all .1s ease;\n  transition: all .1s ease;\n}\n.expand-enter[data-v-b03e3c12], .expand-leave-to[data-v-b03e3c12] {\n  -webkit-transform: scale(0.95);\n          transform: scale(0.95);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.body.card[data-v-b03e3c12] {\n    width: 100%;\n    padding-bottom: 50px;\n}\n.billing-box[data-v-b03e3c12] {\n    margin-top: 0;\n    margin-bottom: 20px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Corporate/CreateProfile.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,OAAO;EACP,aAAa;EACb,aAAa;EACb,iDAAiD;UACzC,yCAAyC;EACjD,0BAA0B;EAC1B,iBAAiB;CAClB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,YAAY;CACf;AACD;MACM,iBAAiB;MACjB,8BAA8B;MAC9B,oBAAoB;CACzB;AACD;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;CACjB;AACD;IACI,sBAAsB;IACtB,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,iBAAiB;IACjB,sBAAsB;CACzB;AACD;EACE,cAAc;EACd,oBAAoB;EACpB,2BAA2B;CAC5B;AACD;IACI,aAAa;IACb,eAAe;CAClB;AACD;EACE,gBAAgB;EAChB,mBAAmB;CACpB;AACD;IACI,gBAAgB;IAChB,sBAAsB;CACzB;AACD;IACI,kBAAkB;CACrB;AACD;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;CACtB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;IACjC,yBAAyB;CAC5B;AACD;IACI,mBAAmB;IACnB,sBAAsB;IACtB,wBAAwB;IACxB,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,iBAAiB;CACpB;AACD;MACM,mBAAmB;MACnB,SAAS;MACT,UAAU;MACV,kBAAkB;MAClB,mBAAmB;MACnB,WAAW;CAChB;AACD;MACM,YAAY;CACjB;AACD;MACM,WAAW;MACX,SAAS;CACd;AACD;MACM,mBAAmB;MACnB,SAAS;MACT,UAAU;MACV,WAAW;MACX,kBAAkB;MAClB,mBAAmB;CACxB;AACD;MACM,YAAY;CACjB;AACD;MACM,cAAc;CACnB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;CACpB;AACD;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;CACtB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,aAAa;EACb,mBAAmB;CACpB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;MACM,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;IACI,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,wDAAwD;IACxD,6BAA6B;IAC7B,+BAA+B;IAC/B,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,uBAAuB;CAC5B;AACD;EACE,cAAc;EACd,oBAAoB;EACpB,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;CAClB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,mBAAmB;CACtB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,gBAAgB;CACjB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;IACI,SAAS;CACZ;AACD;IACI,QAAQ;CACX;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,WAAW;EACX,+BAA+B;EAC/B,eAAe;CAChB;AACD;IACI,oBAAoB;IACpB,uBAAuB;CAC1B;AACD;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,mBAAmB;CACtB;AACD;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;CACtB;AACD;IACI,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;CAClB;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;CAClB;AACD;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,uBAAuB;IACvB,oBAAoB;CACvB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;CAClB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,mBAAmB;CACtB;EACC,iCAAiC;AACnC;;EAEE,yBAAyB;EACzB,UAAU;CACX;EACC,aAAa;AACf;EACE,2BAA2B;CAC5B;AACD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;CAClB;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;CACjB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,WAAW;CACZ;AACD;AACA;IACI,YAAY;IACZ,qBAAqB;CACxB;AACD;IACI,cAAc;IACd,oBAAoB;CACvB;CACA","file":"CreateProfile.vue","sourcesContent":["\n.left-panel[data-v-b03e3c12] {\n  position: fixed;\n  z-index: 2;\n  left: 0;\n  top: 0;\n  width: 500px;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #F4F8F9;\n  overflow-y: auto;\n}\n.left-panel.no-scroll[data-v-b03e3c12] {\n    overflow: hidden;\n}\n.left-panel .heading[data-v-b03e3c12] {\n    padding-left: 50px;\n}\n.left-panel.centered[data-v-b03e3c12] {\n    width: 100%;\n}\n.left-panel.centered .heading[data-v-b03e3c12] {\n      background: #fff;\n      border-bottom: 1px solid #ddd;\n      margin-bottom: 20px;\n}\n.heading[data-v-b03e3c12] {\n  height: 50px;\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  padding: 10px 0;\n}\n.heading .cons-name[data-v-b03e3c12] {\n    padding: 0 5px 0 15px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 200px;\n    display: inline-block;\n}\n.body[data-v-b03e3c12] {\n  padding: 20px;\n  background: #fafafa;\n  border-top: 1px solid #ccc;\n}\n.body.card[data-v-b03e3c12] {\n    width: 900px;\n    margin: 0 auto;\n}\n.back-section[data-v-b03e3c12] {\n  font-size: 15px;\n  margin-bottom: 5px;\n}\n.back-section a[data-v-b03e3c12] {\n    cursor: pointer;\n    text-decoration: none;\n}\n.back-section i[data-v-b03e3c12] {\n    margin-right: 7px;\n}\n.logo-box[data-v-b03e3c12] {\n  text-align: center;\n  border-bottom: 1px solid #ddd;\n  padding: 0 20px 20px;\n}\n.logo-box .fa-user-circle[data-v-b03e3c12] {\n    font-size: 140px;\n    margin-top: 30px;\n    color: #f2ad6d;\n}\n.logo-box img[data-v-b03e3c12] {\n    max-width: 200px;\n    max-height: 200px;\n    cursor: pointer;\n    -webkit-transition: .2s ease all;\n    transition: .2s ease all;\n}\n.logo-box .img-hover-box[data-v-b03e3c12] {\n    position: relative;\n    display: inline-block;\n    border: 3px dashed #ddd;\n    width: 206px;\n    height: 206px;\n    overflow: hidden;\n    background: #fff;\n}\n.logo-box .img-hover-box .button[data-v-b03e3c12] {\n      position: absolute;\n      top: 60%;\n      left: 50%;\n      margin-top: -20px;\n      margin-left: -63px;\n      opacity: 0;\n}\n.logo-box .img-hover-box:hover img[data-v-b03e3c12] {\n      opacity: .6;\n}\n.logo-box .img-hover-box:hover .button[data-v-b03e3c12] {\n      opacity: 1;\n      top: 50%;\n}\n.logo-box .img-hover-box .fa-spinner[data-v-b03e3c12] {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      z-index: 3;\n      margin-top: -16px;\n      margin-left: -16px;\n}\n.logo-box .img-hover-box.loading img[data-v-b03e3c12] {\n      opacity: .6;\n}\n.logo-box .img-hover-box.loading:hover .button[data-v-b03e3c12] {\n      display: none;\n}\n.logo-box .recommended[data-v-b03e3c12] {\n    display: block;\n    font-size: 14px;\n    margin-bottom: 5px;\n    color: #666;\n    font-weight: 600;\n}\n.logo-box .error-msg[data-v-b03e3c12] {\n    display: block;\n    font-weight: 100;\n    margin-top: 2px;\n    color: #f20d0d;\n    font-size: 12px;\n    font-style: italic;\n}\n.details-box[data-v-b03e3c12] {\n  padding: 20px 0;\n}\n.data-field[data-v-b03e3c12] {\n  padding: 5px;\n  position: relative;\n}\n.data-field .label[data-v-b03e3c12] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .label.has-error[data-v-b03e3c12] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-b03e3c12] {\n    margin: 1px 0 0;\n    padding: 5px;\n    font-size: 14px;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-b03e3c12] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-b03e3c12]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-b03e3c12] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.data-field select[data-v-b03e3c12] {\n    border: 1px solid #ddd;\n    padding: 5px;\n    color: #333;\n    height: 35px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field select.has-error[data-v-b03e3c12] {\n      border-color: #f20d0d;\n}\n.data-field select[data-v-b03e3c12]:disabled {\n      background-color: #eee;\n}\n.billing-box[data-v-b03e3c12] {\n  padding: 15px;\n  background: #f2f2f2;\n  border: 1px solid #dedede;\n  border-radius: 4px;\n  margin-top: 30px;\n}\n.billing-box .billing-label[data-v-b03e3c12] {\n    font-size: 21px;\n    font-weight: 600;\n    padding-bottom: 5px;\n    color: #333;\n    text-align: center;\n}\n.billing-box .label[data-v-b03e3c12] {\n    color: #122a43;\n}\n.billing-box .error-msg[data-v-b03e3c12] {\n    color: #f20d0d;\n}\n.palette[data-v-b03e3c12] {\n  position: absolute;\n  top: 27px;\n  right: 13px;\n  background-color: #fafafa;\n  width: 20px;\n  height: 20px;\n  border-radius: 10px;\n  cursor: pointer;\n}\n.color-picker[data-v-b03e3c12] {\n  position: absolute;\n  top: 100%;\n  z-index: 3;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.color-picker.right[data-v-b03e3c12] {\n    right: 0;\n}\n.color-picker.left[data-v-b03e3c12] {\n    left: 0;\n}\n.respond-box[data-v-b03e3c12], .confirm-card[data-v-b03e3c12] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 4;\n  background: rgba(0, 0, 0, 0.5);\n  display: table;\n}\n.respond-box .vertical-center[data-v-b03e3c12], .confirm-card .vertical-center[data-v-b03e3c12] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.respond-box .card[data-v-b03e3c12], .confirm-card .card[data-v-b03e3c12] {\n    width: 80%;\n    max-width: 500px;\n    margin: 0 auto;\n    padding: 15px;\n    text-align: center;\n}\n.respond-box .fa-check-circle[data-v-b03e3c12], .respond-box .fa-times-circle[data-v-b03e3c12], .confirm-card .fa-check-circle[data-v-b03e3c12], .confirm-card .fa-times-circle[data-v-b03e3c12] {\n    font-size: 100px;\n    color: #26d97a;\n    margin-bottom: 5px;\n}\n.respond-box .fa-times-circle[data-v-b03e3c12], .confirm-card .fa-times-circle[data-v-b03e3c12] {\n    color: #F20D0D;\n}\n.respond-box .label[data-v-b03e3c12], .confirm-card .label[data-v-b03e3c12] {\n    font-weight: 600;\n    color: #505050;\n}\n.respond-box .message[data-v-b03e3c12], .confirm-card .message[data-v-b03e3c12] {\n    font-size: 14px;\n    color: #777;\n    margin: 10px 0;\n}\n.input-group[data-v-b03e3c12] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  position: relative;\n  margin-bottom: 0;\n}\n.input-group .input-group-label[data-v-b03e3c12] {\n    padding: 0 10px;\n    border: 1px solid #cacaca;\n    background: #f4f8f9;\n    color: #0a0a0a;\n    text-align: center;\n    white-space: nowrap;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n.input-group .mobile-input[data-v-b03e3c12] {\n    padding-left: 25px;\n    border-radius: 1px;\n    border-left: 0;\n}\n.input-group.small .mobile-input[data-v-b03e3c12] {\n    padding-left: 35px;\n}\n.input-group.medium .mobile-input[data-v-b03e3c12] {\n    padding-left: 45px;\n}\n.input-group.large .mobile-input[data-v-b03e3c12] {\n    padding-left: 55px;\n}\n.input-group.xl .mobile-input[data-v-b03e3c12] {\n    padding-left: 65px;\n}\n  /* Chrome, Safari, Edge, Opera */\ninput[data-v-b03e3c12]::-webkit-outer-spin-button,\ninput[data-v-b03e3c12]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n  /* Firefox */\ninput[type=number][data-v-b03e3c12] {\n  -moz-appearance: textfield;\n}\n.country-select[data-v-b03e3c12] {\n  margin-top: 1px;\n  cursor: pointer;\n  color: #333;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.country-select[data-v-b03e3c12]:hover {\n  background-color: #e6e6e6;\n}\n.country-code[data-v-b03e3c12] {\n  margin-right: 3px;\n  font-weight: 100;\n  font-size: 15px;\n}\n.margin-B-s[data-v-b03e3c12] {\n  margin-bottom: 5px;\n}\n.margin-B-m[data-v-b03e3c12] {\n  margin-bottom: 10px;\n}\n.margin-T-l[data-v-b03e3c12] {\n  margin-top: 15px;\n}\n.padding-R-m[data-v-b03e3c12] {\n  padding-right: 10px;\n}\n.padding-L-m[data-v-b03e3c12] {\n  padding-left: 10px;\n}\n.slide-up-enter-active[data-v-b03e3c12], .slide-up-leave-active[data-v-b03e3c12] {\n  -webkit-transition: all .6s ease;\n  transition: all .6s ease;\n}\n.slide-up-enter[data-v-b03e3c12], .slide-up-leave-to[data-v-b03e3c12] {\n  -webkit-transform: translateY(30px);\n          transform: translateY(30px);\n  opacity: 0;\n}\n.slide-down-enter-active[data-v-b03e3c12], .slide-down-leave-active[data-v-b03e3c12] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-b03e3c12], .slide-down-leave-to[data-v-b03e3c12] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.expand-enter-active[data-v-b03e3c12], .expand-leave-active[data-v-b03e3c12] {\n  -webkit-transition: all .1s ease;\n  transition: all .1s ease;\n}\n.expand-enter[data-v-b03e3c12], .expand-leave-to[data-v-b03e3c12] {\n  -webkit-transform: scale(0.95);\n          transform: scale(0.95);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.body.card[data-v-b03e3c12] {\n    width: 100%;\n    padding-bottom: 50px;\n}\n.billing-box[data-v-b03e3c12] {\n    margin-top: 0;\n    margin-bottom: 20px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{'left-panel centered':true, 'no-scroll':_vm.respond.show}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"body card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"medium-12 column"},[_c('div',{staticClass:"logo-box"},[_c('span',{staticClass:"recommended"},[_vm._v("Recommended size: 200 x 200 px")]),_vm._v(" "),_c('div',{class:{'img-hover-box':true, 'loading':_vm.upload.loading}},[(_vm.corporateInfo.logo)?_c('img',{attrs:{"src":_vm.corporateInfo.logo}}):_c('i',{staticClass:"fas fa-user-circle"}),_vm._v(" "),_c('div',{staticClass:"button cta small",on:{"click":_vm.triggerUpload}},[_vm._v("CHANGE LOGO")]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.upload.loading),expression:"upload.loading"}],staticClass:"fa fa-spinner fa-spin fa-2x"})])],1),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.upload.message))]),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"uploadInput",attrs:{"type":"file"},on:{"change":_vm.uploadFile}})])]),_vm._v(" "),_c('div',{staticClass:"medium-6 column padding-R-m"},[_c('div',{staticClass:"details-box row"},[_c('div',{staticClass:"medium-12 column margin-B-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Username")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.username),expression:"corporateInfo.username"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading,"name":"username"},domProps:{"value":(_vm.corporateInfo.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "username", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.username))])])]),_vm._v(" "),_c('div',{staticClass:"medium-12 column"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.password),expression:"corporateInfo.password"}],staticClass:"input",attrs:{"type":"password","disabled":_vm.loading},domProps:{"value":(_vm.corporateInfo.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.password))])])]),_vm._v(" "),_c('div',{staticClass:"medium-12 column margin-B-m"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Repeat Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.repeatPassword),expression:"repeatPassword"}],staticClass:"input",attrs:{"type":"password","disabled":_vm.loading},domProps:{"value":(_vm.repeatPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.repeatPassword=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.repeatPassword))])])]),_vm._v(" "),_c('div',{staticClass:"medium-12 column margin-B-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Corporate Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.name),expression:"corporateInfo.name"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.corporateInfo.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "name", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.name))])])]),_vm._v(" "),_c('div',{staticClass:"medium-6 column margin-B-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.email),expression:"corporateInfo.email"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.corporateInfo.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "email", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.email))])])]),_vm._v(" "),_c('div',{staticClass:"medium-6 column margin-B-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Corporate Color")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.color),expression:"corporateInfo.color"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.corporateInfo.color)},on:{"click":function($event){_vm.showEmailColor = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "color", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.color))]),_vm._v(" "),_c('div',{staticClass:"palette",style:({'backgroundColor': '#' + _vm.corporateInfo.color}),on:{"click":function($event){_vm.showEmailColor = true}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEmailColor),expression:"showEmailColor"}],staticClass:"color-picker right"},[_c('chrome-picker',{on:{"input":_vm.updateColor},model:{value:(_vm.emailColors),callback:function ($$v) {_vm.emailColors=$$v},expression:"emailColors"}})],1)])],1)]),_vm._v(" "),_c('div',{staticClass:"medium-12 column margin-B-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Mobile")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"country-select input-group-label",on:{"click":_vm.selectCountry}},[_c('span',{staticClass:"country-code"},[_vm._v("(+"+_vm._s(_vm.callingCode)+") ")]),_vm._v(" "),_c('i',{staticClass:"fa fa-caret-down"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.mobile),expression:"corporateInfo.mobile"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.corporateInfo.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "mobile", $event.target.value)}}})]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.mobile))])])]),_vm._v(" "),_c('div',{staticClass:"medium-12 column margin-B-m"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Website")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.website),expression:"corporateInfo.website"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.corporateInfo.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "website", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.website))])])])])]),_vm._v(" "),_c('div',{staticClass:"medium-6 column padding-L-m"},[_c('div',{staticClass:"billing-box medium-12 column"},[_c('div',{staticClass:"billing-label"},[_vm._v("Billing Info")]),_vm._v(" "),_c('div',{staticClass:"medium-12 column"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Address1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.billingAddress1),expression:"corporateInfo.billingAddress1"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.corporateInfo.billingAddress1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "billingAddress1", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.billingAddress1))])])]),_vm._v(" "),_c('div',{staticClass:"medium-12 column margin-B-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Address2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.billingAddress2),expression:"corporateInfo.billingAddress2"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.corporateInfo.billingAddress2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "billingAddress2", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"medium-12 column margin-B-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.billingCity),expression:"corporateInfo.billingCity"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.corporateInfo.billingCity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "billingCity", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.billingCity))])])]),_vm._v(" "),_c('div',{staticClass:"medium-6 columns margin-B-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("State")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.billingState),expression:"corporateInfo.billingState"}],class:{'has-error':false},attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.corporateInfo, "billingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}}),_vm._v(" "),_c('option',{attrs:{"value":"NonUS"}},[_vm._v("Non US")]),_vm._v(" "),_vm._l((_vm.states),function(state){return _c('option',{key:state.value,domProps:{"value":state.label}},[_vm._v(_vm._s(state.label))])})],2),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.billingState))])])]),_vm._v(" "),_c('div',{staticClass:"medium-6 column margin-B-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Zip")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.billingZip),expression:"corporateInfo.billingZip"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.corporateInfo.billingZip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "billingZip", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.billingZip))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.corporateInfo.billingState === 'NonUS'),expression:"corporateInfo.billingState === 'NonUS'"}],staticClass:"medium-12 column margin-B-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Country")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.biilingCountry),expression:"corporateInfo.biilingCountry"}],class:{'input':true, 'has-error':false},attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.corporateInfo, "biilingCountry", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.countries.all),function(country,index){return _c('option',{key:index,domProps:{"value":country.alpha2}},[_vm._v(_vm._s(country.name))])}),0),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.biilingCountry))])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"medium-12 column margin-T-l"},[_c('div',{staticClass:"button cta success block",on:{"click":_vm.submit}},[(_vm.loading)?_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v("\n              Loading ...\n            ")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v("CREATE ACCOUNT")])])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"expand"}},[(_vm.respond.show)?_c('div',{staticClass:"respond-box"},[_c('div',{staticClass:"vertical-center"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"success"},[(_vm.respond.success)?_c('i',{staticClass:"fas fa-check-circle"}):_c('i',{staticClass:"fas fa-times-circle"}),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.respond.label))]),_vm._v(" "),(!!_vm.respond.message)?_c('div',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.respond.message)}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"button cta block small margin-T-l",on:{"click":_vm.closeResponModal}},[_vm._v("Close")])])])]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading"},[_c('span',{staticClass:"cons-name"},[_vm._v("CREATE PROFILE")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-section"},[_c('a',{attrs:{"href":"/#/corporate"}},[_c('i',{staticClass:"fas fa-chevron-left"}),_vm._v("Back")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invoice_vue__ = __webpack_require__(416);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63271122_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invoice_vue__ = __webpack_require__(1173);
function injectStyle (ssrContext) {
  __webpack_require__(1171)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63271122"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63271122_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1172);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5f1cec84", content, true, {});

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.margin-B-s[data-v-63271122] {\n  margin-bottom: 5px;\n}\n.margin-B-m[data-v-63271122] {\n  margin-bottom: 10px;\n}\n.margin-T-l[data-v-63271122] {\n  margin-top: 15px;\n}\n.padding-R-m[data-v-63271122] {\n  padding-right: 10px;\n}\n.clear[data-v-63271122] {\n  clear: both;\n}\n.left-panel[data-v-63271122] {\n  position: fixed;\n  z-index: 2;\n  left: 0;\n  top: 0;\n  width: 500px;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #F4F8F9;\n  overflow-y: auto;\n}\n.left-panel .heading[data-v-63271122] {\n    padding-left: 50px;\n    height: 50px;\n    font-size: 18px;\n    font-weight: 600;\n    color: #333;\n    padding: 10px 0 10px 50px;\n    border-bottom: 1px solid #ccc;\n}\n.left-panel .heading span[data-v-63271122] {\n      padding: 0 5px 0 15px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      max-width: 200px;\n      display: inline-block;\n}\n.left-panel .body[data-v-63271122] {\n    padding: 20px;\n    background: #fafafa;\n}\n.collapsible[data-v-63271122] {\n  margin-bottom: 5px;\n}\n.collapsible .head[data-v-63271122] {\n    color: #0D79F2;\n    margin-bottom: 2px;\n    cursor: pointer;\n    text-transform: uppercase;\n}\n.collapsible .head i[data-v-63271122] {\n      margin-right: 5px;\n}\n.collapsible .head span[data-v-63271122] {\n      font-weight: 600;\n}\n.collapsible .content[data-v-63271122] {\n    margin-left: 6px;\n    padding: 5px 0 5px 15px;\n    border-left: 2px solid #ddd;\n    max-height: 800px;\n    /* define precise max-height for more smoother transition */\n    height: auto;\n    -webkit-transition: all 0.35s ease-out;\n    transition: all 0.35s ease-out;\n}\n.collapsible .content .field-row[data-v-63271122] {\n      margin-bottom: 15px;\n}\n.collapsible .content .field-row[data-v-63271122]:last-child {\n      margin-bottom: 0;\n}\n.collapsible.collapse .content[data-v-63271122] {\n    max-height: 0;\n    padding: 0 15px;\n    overflow: hidden;\n}\n.logo-box[data-v-63271122] {\n  text-align: center;\n  padding: 0 20px 20px;\n}\n.logo-box img[data-v-63271122] {\n    max-width: 200px;\n    max-height: 200px;\n    cursor: pointer;\n    -webkit-transition: .2s ease all;\n    transition: .2s ease all;\n}\n.data-field[data-v-63271122] {\n  font-weight: 600;\n}\n.data-field .label[data-v-63271122] {\n    color: #888;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 120%;\n}\n.data-field .value[data-v-63271122] {\n    font-size: 17px;\n    color: #555;\n}\n.data-field .value a[data-v-63271122] {\n      text-decoration: underline;\n      cursor: pointer;\n      font-size: 13px;\n}\n.data-field select[data-v-63271122] {\n    border: 1px solid #ddd;\n    padding: 5px;\n    color: #333;\n    height: 35px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field select.has-error[data-v-63271122] {\n      border-color: #f20d0d;\n}\n.data-field select[data-v-63271122]:disabled {\n      background-color: #eee;\n}\n.status[data-v-63271122] {\n  font-size: 12px;\n  padding: 2px 6px;\n  color: #fff;\n  background: #777;\n  display: inline-block;\n  text-transform: uppercase;\n  border-radius: 2px;\n}\n.status.unpaid[data-v-63271122] {\n    background: #de5050;\n}\n.status.paid[data-v-63271122] {\n    background: #47bd63;\n}\n.edit[data-v-63271122] {\n  display: inline-block;\n  width: 100px;\n  cursor: pointer;\n  color: #0D79F2;\n  font-size: 14px;\n}\n.right-panel[data-v-63271122] {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  top: 0;\n  width: calc(100% - 500px);\n  height: 100%;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #d5d5d5;\n  overflow-y: hidden;\n  padding: 20px 40px;\n}\n.right-panel .heading[data-v-63271122] {\n    font-size: 24px;\n    padding: 10px 20px;\n}\n.right-panel .tab[data-v-63271122] {\n    background: #d5d5d5;\n}\n.right-panel .tab .active[data-v-63271122] {\n      background: #ededed;\n}\n.right-panel .tab-contents[data-v-63271122] {\n    background: #ededed;\n}\ntable[data-v-63271122] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n}\ntable thead[data-v-63271122] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-63271122] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-63271122] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-63271122] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-63271122] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-63271122] {\n          color: #ccc;\n}\n.cards-mobile[data-v-63271122] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.left-panel[data-v-63271122] {\n    width: 100%;\n    padding-bottom: 100px;\n}\n.left-panel .heading .switch[data-v-63271122] {\n      display: block;\n      padding-top: 5px;\n      padding-left: 10px;\n      padding-right: 50px;\n}\n.left-panel .heading .prov-options[data-v-63271122] {\n      position: absolute;\n      right: 0;\n      top: 15px;\n}\n.left-panel .tab[data-v-63271122] {\n      margin: 35px 0 0;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      overflow-x: scroll;\n}\n.left-panel .tab li[data-v-63271122] {\n        width: auto;\n}\n.toggle-mobile[data-v-63271122] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.right-panel[data-v-63271122] {\n    z-index: 1;\n    width: 100%;\n    top: 100%;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n}\n.right-panel table[data-v-63271122] {\n      display: none;\n}\n.right-panel.mobile-right-panel[data-v-63271122] {\n      top: 0;\n      z-index: 2;\n}\n.right-panel.mobile-right-panel .tab[data-v-63271122] {\n        margin-top: 70px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        overflow-x: scroll;\n}\n.right-panel.mobile-right-panel .tab-contents[data-v-63271122] {\n        width: 100%;\n        height: calc(100vh - 142px);\n        overflow-y: scroll;\n}\n.right-panel.mobile-right-panel .tab-contents .tab-content[data-v-63271122] {\n          padding-bottom: 60px;\n}\n.right-panel.mobile-right-panel .tab-contents .tab-content.history-panel[data-v-63271122] {\n            padding: 0;\n            padding-top: 20px;\n            padding-bottom: 60px;\n}\n.right-panel.mobile-right-panel .tab-contents .fixed-footer[data-v-63271122] {\n          width: 100%;\n          bottom: 45px;\n          background: #fff;\n          color: #000;\n          border-top: 1px solid #aaa;\n}\n.right-panel.mobile-right-panel .logs-panel[data-v-63271122] {\n        width: 100%;\n}\n.fix-buttons[data-v-63271122] {\n    width: 100%;\n    bottom: 45px;\n}\n.fix-buttons a[data-v-63271122] {\n      margin: 0 auto;\n}\n.toggle-panel .heading[data-v-63271122] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.cards-mobile[data-v-63271122] {\n    display: block;\n    margin-top: 50px;\n}\n.cards-mobile .card[data-v-63271122] {\n      border: 1px solid #ccc;\n      margin-bottom: 15px;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n}\n.cards-mobile .card .info[data-v-63271122] {\n        width: 100%;\n        padding-left: 10px;\n}\n.cards-mobile .card > div[data-v-63271122] {\n        margin-bottom: 3px;\n        width: 100%;\n}\n.cards-mobile .card .email-logo img[data-v-63271122] {\n        max-width: 100px;\n        max-height: 100px;\n}\n.cards-mobile .card .card-header[data-v-63271122] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n}\n.cards-mobile .card .card-header .time[data-v-63271122] {\n          font-size: 12px;\n          color: #777;\n          word-spacing: 5px;\n}\n.cards-mobile .card .card-header .amount[data-v-63271122] {\n          font-weight: 900;\n          font-size: 20px;\n}\n.cards-mobile .card .card-header .amount a[data-v-63271122] {\n            text-decoration: none;\n}\n.cards-mobile .card .credit-card[data-v-63271122] {\n        font-weight: 900;\n}\n.cards-mobile .card .btn-action[data-v-63271122] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        padding: 20px 10px 0;\n}\n.cards-mobile .card .btn-action a[data-v-63271122] {\n          width: 50%;\n}\n.cards-mobile .card .title[data-v-63271122] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        margin-bottom: 3px;\n}\n.cards-mobile .card .title.pkg-div[data-v-63271122] {\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n}\n.cards-mobile .card .title .pkg-type[data-v-63271122] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n.cards-mobile .card .title input[data-v-63271122] {\n          margin-right: 5px;\n}\n.cards-mobile .card .title.view[data-v-63271122] {\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n          padding-top: 7px;\n          padding-bottom: 5px;\n          border-top: 1px solid #eee;\n}\n.cards-mobile .card .title .refer[data-v-63271122] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n.cards-mobile .card .label[data-v-63271122] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards-mobile .card .value[data-v-63271122] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards-mobile .card .value i[data-v-63271122] {\n          color: #bbb;\n}\n.cards-mobile .card .value a[data-v-63271122] {\n          text-decoration: none;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Corporate/Invoice.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,YAAY;CACb;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,OAAO;EACP,aAAa;EACb,aAAa;EACb,iDAAiD;UACzC,yCAAyC;EACjD,0BAA0B;EAC1B,iBAAiB;CAClB;AACD;IACI,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,0BAA0B;IAC1B,8BAA8B;CACjC;AACD;MACM,sBAAsB;MACtB,oBAAoB;MACpB,iBAAiB;MACjB,wBAAwB;MACxB,iBAAiB;MACjB,sBAAsB;CAC3B;AACD;IACI,cAAc;IACd,oBAAoB;CACvB;AACD;EACE,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;MACM,iBAAiB;CACtB;AACD;IACI,iBAAiB;IACjB,wBAAwB;IACxB,4BAA4B;IAC5B,kBAAkB;IAClB,4DAA4D;IAC5D,aAAa;IACb,uCAAuC;IACvC,+BAA+B;CAClC;AACD;MACM,oBAAoB;CACzB;AACD;MACM,iBAAiB;CACtB;AACD;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;CACpB;AACD;EACE,mBAAmB;EACnB,qBAAqB;CACtB;AACD;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;IACjC,yBAAyB;CAC5B;AACD;EACE,iBAAiB;CAClB;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;IACI,gBAAgB;IAChB,YAAY;CACf;AACD;MACM,2BAA2B;MAC3B,gBAAgB;MAChB,gBAAgB;CACrB;AACD;IACI,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,wDAAwD;IACxD,6BAA6B;IAC7B,+BAA+B;IAC/B,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,uBAAuB;CAC5B;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;CACjB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,OAAO;EACP,0BAA0B;EAC1B,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;EAClD,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;CACpB;AACD;IACI,gBAAgB;IAChB,mBAAmB;CACtB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,oBAAoB;CACzB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;CAClB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;EACE,cAAc;CACf;AACD;AACA;IACI,YAAY;IACZ,sBAAsB;CACzB;AACD;MACM,eAAe;MACf,iBAAiB;MACjB,mBAAmB;MACnB,oBAAoB;CACzB;AACD;MACM,mBAAmB;MACnB,SAAS;MACT,UAAU;CACf;AACD;MACM,iBAAiB;MACjB,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,mBAAmB;CACxB;AACD;QACQ,YAAY;CACnB;AACD;IACI,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;IACrB,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;CACpB;AACD;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,cAAc;CACnB;AACD;MACM,OAAO;MACP,WAAW;CAChB;AACD;QACQ,iBAAiB;QACjB,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,mBAAmB;CAC1B;AACD;QACQ,YAAY;QACZ,4BAA4B;QAC5B,mBAAmB;CAC1B;AACD;UACU,qBAAqB;CAC9B;AACD;YACY,WAAW;YACX,kBAAkB;YAClB,qBAAqB;CAChC;AACD;UACU,YAAY;UACZ,aAAa;UACb,iBAAiB;UACjB,YAAY;UACZ,2BAA2B;CACpC;AACD;QACQ,YAAY;CACnB;AACD;IACI,YAAY;IACZ,aAAa;CAChB;AACD;MACM,eAAe;CACpB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,yBAAyB;QACrB,sBAAsB;YAClB,wBAAwB;CACnC;AACD;IACI,eAAe;IACf,iBAAiB;CACpB;AACD;MACM,uBAAuB;MACvB,oBAAoB;MACpB,aAAa;MACb,oBAAoB;MACpB,+BAA+B;MAC/B,oBAAoB;MACpB,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,6BAA6B;MAC7B,8BAA8B;UAC1B,2BAA2B;cACvB,uBAAuB;CACpC;AACD;QACQ,YAAY;QACZ,mBAAmB;CAC1B;AACD;QACQ,mBAAmB;QACnB,YAAY;CACnB;AACD;QACQ,iBAAiB;QACjB,kBAAkB;CACzB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,+BAA+B;QACvC,uBAAuB;YACnB,oBAAoB;gBAChB,sBAAsB;CACrC;AACD;UACU,gBAAgB;UAChB,YAAY;UACZ,kBAAkB;CAC3B;AACD;UACU,iBAAiB;UACjB,gBAAgB;CACzB;AACD;YACY,sBAAsB;CACjC;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,yBAAyB;YACrB,sBAAsB;gBAClB,wBAAwB;QAChC,qBAAqB;CAC5B;AACD;UACU,WAAW;CACpB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,oBAAoB;QAC5B,mBAAmB;CAC1B;AACD;UACU,0BAA0B;cACtB,uBAAuB;kBACnB,+BAA+B;CAChD;AACD;UACU,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;CACvB;AACD;UACU,kBAAkB;CAC3B;AACD;UACU,0BAA0B;cACtB,uBAAuB;kBACnB,+BAA+B;UACvC,iBAAiB;UACjB,oBAAoB;UACpB,2BAA2B;CACpC;AACD;UACU,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;CACvB;AACD;QACQ,gBAAgB;QAChB,0BAA0B;QAC1B,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;CACzB;AACD;QACQ,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;CACxB;AACD;UACU,YAAY;CACrB;AACD;UACU,sBAAsB;CAC/B;CACA","file":"Invoice.vue","sourcesContent":["\n.margin-B-s[data-v-63271122] {\n  margin-bottom: 5px;\n}\n.margin-B-m[data-v-63271122] {\n  margin-bottom: 10px;\n}\n.margin-T-l[data-v-63271122] {\n  margin-top: 15px;\n}\n.padding-R-m[data-v-63271122] {\n  padding-right: 10px;\n}\n.clear[data-v-63271122] {\n  clear: both;\n}\n.left-panel[data-v-63271122] {\n  position: fixed;\n  z-index: 2;\n  left: 0;\n  top: 0;\n  width: 500px;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #F4F8F9;\n  overflow-y: auto;\n}\n.left-panel .heading[data-v-63271122] {\n    padding-left: 50px;\n    height: 50px;\n    font-size: 18px;\n    font-weight: 600;\n    color: #333;\n    padding: 10px 0 10px 50px;\n    border-bottom: 1px solid #ccc;\n}\n.left-panel .heading span[data-v-63271122] {\n      padding: 0 5px 0 15px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      max-width: 200px;\n      display: inline-block;\n}\n.left-panel .body[data-v-63271122] {\n    padding: 20px;\n    background: #fafafa;\n}\n.collapsible[data-v-63271122] {\n  margin-bottom: 5px;\n}\n.collapsible .head[data-v-63271122] {\n    color: #0D79F2;\n    margin-bottom: 2px;\n    cursor: pointer;\n    text-transform: uppercase;\n}\n.collapsible .head i[data-v-63271122] {\n      margin-right: 5px;\n}\n.collapsible .head span[data-v-63271122] {\n      font-weight: 600;\n}\n.collapsible .content[data-v-63271122] {\n    margin-left: 6px;\n    padding: 5px 0 5px 15px;\n    border-left: 2px solid #ddd;\n    max-height: 800px;\n    /* define precise max-height for more smoother transition */\n    height: auto;\n    -webkit-transition: all 0.35s ease-out;\n    transition: all 0.35s ease-out;\n}\n.collapsible .content .field-row[data-v-63271122] {\n      margin-bottom: 15px;\n}\n.collapsible .content .field-row[data-v-63271122]:last-child {\n      margin-bottom: 0;\n}\n.collapsible.collapse .content[data-v-63271122] {\n    max-height: 0;\n    padding: 0 15px;\n    overflow: hidden;\n}\n.logo-box[data-v-63271122] {\n  text-align: center;\n  padding: 0 20px 20px;\n}\n.logo-box img[data-v-63271122] {\n    max-width: 200px;\n    max-height: 200px;\n    cursor: pointer;\n    -webkit-transition: .2s ease all;\n    transition: .2s ease all;\n}\n.data-field[data-v-63271122] {\n  font-weight: 600;\n}\n.data-field .label[data-v-63271122] {\n    color: #888;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 120%;\n}\n.data-field .value[data-v-63271122] {\n    font-size: 17px;\n    color: #555;\n}\n.data-field .value a[data-v-63271122] {\n      text-decoration: underline;\n      cursor: pointer;\n      font-size: 13px;\n}\n.data-field select[data-v-63271122] {\n    border: 1px solid #ddd;\n    padding: 5px;\n    color: #333;\n    height: 35px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field select.has-error[data-v-63271122] {\n      border-color: #f20d0d;\n}\n.data-field select[data-v-63271122]:disabled {\n      background-color: #eee;\n}\n.status[data-v-63271122] {\n  font-size: 12px;\n  padding: 2px 6px;\n  color: #fff;\n  background: #777;\n  display: inline-block;\n  text-transform: uppercase;\n  border-radius: 2px;\n}\n.status.unpaid[data-v-63271122] {\n    background: #de5050;\n}\n.status.paid[data-v-63271122] {\n    background: #47bd63;\n}\n.edit[data-v-63271122] {\n  display: inline-block;\n  width: 100px;\n  cursor: pointer;\n  color: #0D79F2;\n  font-size: 14px;\n}\n.right-panel[data-v-63271122] {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  top: 0;\n  width: calc(100% - 500px);\n  height: 100%;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #d5d5d5;\n  overflow-y: hidden;\n  padding: 20px 40px;\n}\n.right-panel .heading[data-v-63271122] {\n    font-size: 24px;\n    padding: 10px 20px;\n}\n.right-panel .tab[data-v-63271122] {\n    background: #d5d5d5;\n}\n.right-panel .tab .active[data-v-63271122] {\n      background: #ededed;\n}\n.right-panel .tab-contents[data-v-63271122] {\n    background: #ededed;\n}\ntable[data-v-63271122] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n}\ntable thead[data-v-63271122] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-63271122] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-63271122] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-63271122] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-63271122] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-63271122] {\n          color: #ccc;\n}\n.cards-mobile[data-v-63271122] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.left-panel[data-v-63271122] {\n    width: 100%;\n    padding-bottom: 100px;\n}\n.left-panel .heading .switch[data-v-63271122] {\n      display: block;\n      padding-top: 5px;\n      padding-left: 10px;\n      padding-right: 50px;\n}\n.left-panel .heading .prov-options[data-v-63271122] {\n      position: absolute;\n      right: 0;\n      top: 15px;\n}\n.left-panel .tab[data-v-63271122] {\n      margin: 35px 0 0;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      overflow-x: scroll;\n}\n.left-panel .tab li[data-v-63271122] {\n        width: auto;\n}\n.toggle-mobile[data-v-63271122] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.right-panel[data-v-63271122] {\n    z-index: 1;\n    width: 100%;\n    top: 100%;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n}\n.right-panel table[data-v-63271122] {\n      display: none;\n}\n.right-panel.mobile-right-panel[data-v-63271122] {\n      top: 0;\n      z-index: 2;\n}\n.right-panel.mobile-right-panel .tab[data-v-63271122] {\n        margin-top: 70px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        overflow-x: scroll;\n}\n.right-panel.mobile-right-panel .tab-contents[data-v-63271122] {\n        width: 100%;\n        height: calc(100vh - 142px);\n        overflow-y: scroll;\n}\n.right-panel.mobile-right-panel .tab-contents .tab-content[data-v-63271122] {\n          padding-bottom: 60px;\n}\n.right-panel.mobile-right-panel .tab-contents .tab-content.history-panel[data-v-63271122] {\n            padding: 0;\n            padding-top: 20px;\n            padding-bottom: 60px;\n}\n.right-panel.mobile-right-panel .tab-contents .fixed-footer[data-v-63271122] {\n          width: 100%;\n          bottom: 45px;\n          background: #fff;\n          color: #000;\n          border-top: 1px solid #aaa;\n}\n.right-panel.mobile-right-panel .logs-panel[data-v-63271122] {\n        width: 100%;\n}\n.fix-buttons[data-v-63271122] {\n    width: 100%;\n    bottom: 45px;\n}\n.fix-buttons a[data-v-63271122] {\n      margin: 0 auto;\n}\n.toggle-panel .heading[data-v-63271122] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.cards-mobile[data-v-63271122] {\n    display: block;\n    margin-top: 50px;\n}\n.cards-mobile .card[data-v-63271122] {\n      border: 1px solid #ccc;\n      margin-bottom: 15px;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n}\n.cards-mobile .card .info[data-v-63271122] {\n        width: 100%;\n        padding-left: 10px;\n}\n.cards-mobile .card > div[data-v-63271122] {\n        margin-bottom: 3px;\n        width: 100%;\n}\n.cards-mobile .card .email-logo img[data-v-63271122] {\n        max-width: 100px;\n        max-height: 100px;\n}\n.cards-mobile .card .card-header[data-v-63271122] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n}\n.cards-mobile .card .card-header .time[data-v-63271122] {\n          font-size: 12px;\n          color: #777;\n          word-spacing: 5px;\n}\n.cards-mobile .card .card-header .amount[data-v-63271122] {\n          font-weight: 900;\n          font-size: 20px;\n}\n.cards-mobile .card .card-header .amount a[data-v-63271122] {\n            text-decoration: none;\n}\n.cards-mobile .card .credit-card[data-v-63271122] {\n        font-weight: 900;\n}\n.cards-mobile .card .btn-action[data-v-63271122] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        padding: 20px 10px 0;\n}\n.cards-mobile .card .btn-action a[data-v-63271122] {\n          width: 50%;\n}\n.cards-mobile .card .title[data-v-63271122] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        margin-bottom: 3px;\n}\n.cards-mobile .card .title.pkg-div[data-v-63271122] {\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n}\n.cards-mobile .card .title .pkg-type[data-v-63271122] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n.cards-mobile .card .title input[data-v-63271122] {\n          margin-right: 5px;\n}\n.cards-mobile .card .title.view[data-v-63271122] {\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n          padding-top: 7px;\n          padding-bottom: 5px;\n          border-top: 1px solid #eee;\n}\n.cards-mobile .card .title .refer[data-v-63271122] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n.cards-mobile .card .label[data-v-63271122] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards-mobile .card .value[data-v-63271122] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards-mobile .card .value i[data-v-63271122] {\n          color: #bbb;\n}\n.cards-mobile .card .value a[data-v-63271122] {\n          text-decoration: none;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"left-panel"},[_c('div',{staticClass:"heading"},[_c('span',{staticClass:"cons-name"},[_vm._v("Invoice "+_vm._s(_vm.invoiceId))])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{class:{'collapsible':true, 'collapse':!_vm.contentShow.invoiceInfo}},[_c('div',{staticClass:"head",on:{"click":function($event){_vm.contentShow.invoiceInfo = !_vm.contentShow.invoiceInfo}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentShow.invoiceInfo),expression:"contentShow.invoiceInfo"}],staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentShow.invoiceInfo),expression:"!contentShow.invoiceInfo"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('span',[_vm._v("Invoice Information")])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"medium-6 column margin-B-m"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Invoice Start Date")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.startDate))])])])]),_vm._v(" "),_c('div',{staticClass:"medium-6 column margin-B-m"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Invoice End Date")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.endDate))])])])]),_vm._v(" "),(false)?_c('div',{staticClass:"medium-12 column margin-B-m"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("PDF File")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":_vm.pdfFile,"target":"_blank"}},[_vm._v("View attached file")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"medium-6 column margin-B-m padding-R-m"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Due Date")]),_vm._v(" "),_c('div',{staticClass:"value"},[(!_vm.showEditField)?_c('span',[_vm._v(_vm._s(_vm.dueDate))]):_c('datepicker',{staticClass:"datepicker inline small",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.statusLoading,"disabled":_vm.disabledDueDate},model:{value:(_vm.dueDateField),callback:function ($$v) {_vm.dueDateField=$$v},expression:"dueDateField"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"medium-6 column end margin-B-m"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Status")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showEditField)?_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.statusField),expression:"statusField"}],staticClass:"margin-B-s",attrs:{"disabled":_vm.statusLoading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.statusField=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"paid"}},[_vm._v("Paid")]),_vm._v(" "),_c('option',{attrs:{"value":"unpaid"}},[_vm._v("Unpaid")]),_vm._v(" "),_c('option',{attrs:{"value":"canceled"}},[_vm._v("Canceled")])])]):_c('span',{class:['status', _vm.status]},[_vm._v(_vm._s(_vm.status))])])])]),_vm._v(" "),(_vm.status !== 'canceled')?_c('div',{staticClass:"medium-12 column margin-B-m"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showEditField),expression:"!showEditField"}],staticClass:"button cta xsmall edit",on:{"click":function($event){_vm.showEditField = true}}},[_vm._v("Edit")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditField),expression:"showEditField"}],class:{'button cta error xsmall':true, 'disabled':_vm.statusLoading},on:{"click":function($event){_vm.showEditField = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditField),expression:"showEditField"}],class:{'button cta success xsmall':true, 'disabled':_vm.statusLoading},on:{"click":_vm.updateFields}},[_vm._v("Save")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clear"})])]),_vm._v(" "),_c('div',{class:{'collapsible':true, 'collapse':!_vm.contentShow.accountInfo}},[_c('div',{staticClass:"head",on:{"click":function($event){_vm.contentShow.accountInfo = !_vm.contentShow.accountInfo}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentShow.accountInfo),expression:"contentShow.accountInfo"}],staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentShow.accountInfo),expression:"!contentShow.accountInfo"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('span',[_vm._v("Corporate Profile")])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"medium-12 column margin-B-m"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Coporate Name")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.corporateInfo.name))])])])]),_vm._v(" "),_c('div',{staticClass:"medium-8 column margin-B-m"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.corporateInfo.email))])])])]),_vm._v(" "),_c('div',{staticClass:"medium-4 column margin-B-m"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Mobile")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.corporateInfo.mobile))])])])]),_vm._v(" "),_c('div',{staticClass:"clear"})])])])]),_vm._v(" "),_c('div',{staticClass:"toggle-mobile",on:{"click":function($event){_vm.showRecords = !_vm.showRecords}}},[(!_vm.showRecords)?_c('span',[_vm._v("Show Records "),_c('i',{staticClass:"fa fa-chevron-up"})]):_c('span',[_vm._v("Hide Records "),_c('i',{staticClass:"fa fa-chevron-down"})])]),_vm._v(" "),_c('div',{class:['right-panel', _vm.showRecords ? 'mobile-right-panel' : '']},[_c('table',[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._l((_vm.transactions.list),function(trx){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions.list.length > 0),expression:"transactions.list.length > 0"}],key:trx.id},[_c('td',[_vm._v(_vm._s(trx.completedDate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.passenger))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'/#/reservation/' + trx.id,"target":"_blank"}},[_vm._v(_vm._s(trx.id))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.pickup)+" "),_c('br'),_vm._v(" "+_vm._s(trx.dropoff))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(trx.total))])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions.loading),expression:"transactions.loading"}]},[_vm._m(1)]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions.list.length === 0 && !_vm.transactions.loading),expression:"transactions.list.length === 0 && !transactions.loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"5"}},[_vm._v("No Invoices as of yet.")])])],2)]),_vm._v(" "),_c('div',{staticClass:"cards-mobile"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions.loading),expression:"transactions.loading"}]},[_c('i',{staticClass:"fa fa-circle-notch fa-spin"}),_vm._v("\n        Getting your invoices...\n      ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions.list.length === 0 && !_vm.transactions.loading),expression:"transactions.list.length === 0 && !transactions.loading"}],staticStyle:{"margin-top":"50px"}},[_vm._v("\n        No Invoices as of yet.\n      ")]),_vm._v(" "),_vm._l((_vm.transactions.list),function(trx){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions.list.length > 0),expression:"transactions.list.length > 0"}],key:trx.id,staticClass:"card"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Completion Date: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(trx.completedDate))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Passenger Name: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(trx.passenger))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("RSVP ID: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":'/#/reservation/' + trx.id,"target":"_blank"}},[_vm._v(_vm._s(trx.id))])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Pickup: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(trx.pickup))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Dropoff: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(trx.dropoff))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Amount: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("$"+_vm._s(trx.total))])])])})],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',[_vm._v("Completion Date")]),_vm._v(" "),_c('th',[_vm._v("Passenger Name")]),_vm._v(" "),_c('th',[_vm._v("RSVP ID")]),_vm._v(" "),_c('th',[_vm._v("Pickup/Dropoff")]),_vm._v(" "),_c('th',[_vm._v("Amount")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"table-block",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-circle-notch fa-spin"}),_vm._v("\n            Getting your invoices...\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CorporateProfile_vue__ = __webpack_require__(418);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_000966c7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CorporateProfile_vue__ = __webpack_require__(1214);
function injectStyle (ssrContext) {
  __webpack_require__(1175)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-000966c7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CorporateProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_000966c7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CorporateProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1176);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("f2a9da52", content, true, {});

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.cc-icon[data-v-000966c7] {\n  background-image: url(\"https://s3-us-west-2.amazonaws.com/mobile-consumer-app/cc-sprite.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 20px;\n  width: 32px;\n  display: inline-block;\n}\n.cc-icon.unknown[data-v-000966c7] {\n    background-position: 0 0;\n}\n.cc-icon.visa[data-v-000966c7] {\n    background-position: 0 -20px;\n}\n.cc-icon.mastercard[data-v-000966c7] {\n    background-position: 0 -40px;\n}\n.cc-icon.amex[data-v-000966c7] {\n    background-position: 0 -60px;\n}\n.cc-icon.discover[data-v-000966c7] {\n    background-position: 0 -80px;\n}\n.cc-icon.jcb[data-v-000966c7] {\n    background-position: 0 -100px;\n}\n.cc-icon.diners[data-v-000966c7] {\n    background-position: 0 -120px;\n}\n.collapsible[data-v-000966c7] {\n  margin-bottom: 5px;\n}\n.collapsible .head[data-v-000966c7] {\n    color: #0D79F2;\n    margin-bottom: 2px;\n    cursor: pointer;\n    text-transform: uppercase;\n}\n.collapsible .head i[data-v-000966c7] {\n      margin-right: 5px;\n}\n.collapsible .head span[data-v-000966c7] {\n      font-weight: 600;\n}\n.collapsible .content[data-v-000966c7] {\n    margin-left: 6px;\n    padding: 5px 0 5px 15px;\n    border-left: 2px solid #ddd;\n    max-height: 800px;\n    /* define precise max-height for more smoother transition */\n    height: auto;\n    overflow: hidden;\n    -webkit-transition: all 0.35s ease-out;\n    transition: all 0.35s ease-out;\n}\n.collapsible .content .field-row[data-v-000966c7] {\n      margin-bottom: 15px;\n}\n.collapsible .content .field-row[data-v-000966c7]:last-child {\n      margin-bottom: 0;\n}\n.collapsible.collapse .content[data-v-000966c7] {\n    max-height: 0;\n    padding: 0 15px;\n}\n.toggle-mobile[data-v-000966c7] {\n  display: none;\n}\n.left-panel[data-v-000966c7] {\n  position: fixed;\n  z-index: 2;\n  left: 0;\n  top: 0;\n  width: 500px;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #F4F8F9;\n  overflow-y: auto;\n}\n.left-panel.no-scroll[data-v-000966c7] {\n    overflow: hidden;\n}\n.left-panel .heading[data-v-000966c7] {\n    padding-left: 50px;\n}\n.left-panel.centered[data-v-000966c7] {\n    width: 100%;\n}\n.left-panel.centered .heading[data-v-000966c7] {\n      background: #fff;\n      border-bottom: 1px solid #ddd;\n      margin-bottom: 20px;\n}\n.right-panel[data-v-000966c7] {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  top: 0;\n  width: calc(100% - 500px);\n  height: 100%;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #d5d5d5;\n  overflow-y: hidden;\n}\n.right-panel .heading[data-v-000966c7] {\n    font-size: 24px;\n    padding: 10px 20px;\n}\n.right-panel .tab[data-v-000966c7] {\n    background: #d5d5d5;\n}\n.right-panel .tab .active[data-v-000966c7] {\n      background: #ededed;\n}\n.right-panel .tab-contents[data-v-000966c7] {\n    background: #ededed;\n}\n.heading[data-v-000966c7] {\n  height: 50px;\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  padding: 10px 0;\n}\n.heading .cons-name[data-v-000966c7] {\n    padding: 0 5px 0 15px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 200px;\n    display: inline-block;\n}\n.switch[data-v-000966c7] {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n  float: right;\n}\n.switch .slider[data-v-000966c7] {\n    position: relative;\n    display: inline-block;\n    width: 50px;\n    height: 26px;\n    border-radius: 20px;\n    background: #ccc;\n    position: relative;\n    cursor: pointer;\n    -webkit-transition: all .25s ease-in-out;\n    transition: all .25s ease-in-out;\n}\n.switch .slider.disabled[data-v-000966c7] {\n      opacity: .4;\n}\n.switch .slider[data-v-000966c7]:before {\n      content: '';\n      position: absolute;\n      top: 2px;\n      left: 3px;\n      width: 21px;\n      height: 21px;\n      border-radius: 50%;\n      background: #fff;\n      -webkit-transition: all .25s ease-in-out;\n      transition: all .25s ease-in-out;\n      -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n}\n.switch .slider.active[data-v-000966c7] {\n      background: #57d1b7;\n}\n.switch .slider.active[data-v-000966c7]:before {\n        left: 25px;\n}\n.switch .label[data-v-000966c7] {\n    display: inline-block;\n    vertical-align: 8px;\n    margin-right: 5px;\n    font-size: 14px;\n    color: #555;\n    text-transform: uppercase;\n}\n.body[data-v-000966c7] {\n  padding: 20px;\n  background: #fafafa;\n  border-top: 1px solid #ccc;\n  height: calc(100vh - 111px);\n  overflow-y: auto;\n}\n.body.card[data-v-000966c7] {\n    width: 500px;\n    margin: 0 auto;\n}\n.cons-link[data-v-000966c7] {\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n.cons-link a[data-v-000966c7] {\n    letter-spacing: .5px;\n    display: inline-block;\n    margin: 0 5px;\n    font-weight: 600;\n}\n.logo-box[data-v-000966c7] {\n  text-align: center;\n  padding: 0 20px 20px;\n}\n.logo-box .fa-user-circle[data-v-000966c7] {\n    font-size: 140px;\n    margin-top: 30px;\n    color: #f2ad6d;\n}\n.logo-box img[data-v-000966c7] {\n    max-width: 200px;\n    max-height: 200px;\n    cursor: pointer;\n    -webkit-transition: .2s ease all;\n    transition: .2s ease all;\n}\n.logo-box .img-hover-box[data-v-000966c7] {\n    position: relative;\n    display: inline-block;\n    border: 3px dashed #ddd;\n    width: 206px;\n    height: 206px;\n    overflow: hidden;\n    background: #fff;\n}\n.logo-box .img-hover-box .button[data-v-000966c7] {\n      position: absolute;\n      top: 60%;\n      left: 50%;\n      margin-top: -20px;\n      margin-left: -63px;\n      opacity: 0;\n}\n.logo-box .img-hover-box:hover img[data-v-000966c7] {\n      opacity: .6;\n}\n.logo-box .img-hover-box:hover .button[data-v-000966c7] {\n      opacity: 1;\n      top: 50%;\n}\n.logo-box .img-hover-box .fa-spinner[data-v-000966c7] {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      z-index: 3;\n      margin-top: -16px;\n      margin-left: -16px;\n}\n.logo-box .img-hover-box.loading img[data-v-000966c7] {\n      opacity: .6;\n}\n.logo-box .img-hover-box.loading:hover .button[data-v-000966c7] {\n      display: none;\n}\n.logo-box .recommended[data-v-000966c7] {\n    display: block;\n    font-size: 14px;\n    margin-bottom: 5px;\n    color: #666;\n    font-weight: 600;\n}\n.logo-box .error-msg[data-v-000966c7] {\n    display: block;\n    font-weight: 100;\n    margin-top: 2px;\n    color: #f20d0d;\n    font-size: 12px;\n    font-style: italic;\n}\n.details-box[data-v-000966c7] {\n  padding: 20px 0;\n}\n.data-field[data-v-000966c7] {\n  padding: 5px;\n  position: relative;\n}\n.data-field .label[data-v-000966c7] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .label.has-error[data-v-000966c7] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-000966c7] {\n    margin: 1px 0 0;\n    padding: 5px;\n    font-size: 14px;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-000966c7] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-000966c7]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-000966c7] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.data-field select[data-v-000966c7] {\n    border: 1px solid #ddd;\n    padding: 5px;\n    color: #333;\n    height: 35px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field select.has-error[data-v-000966c7] {\n      border-color: #f20d0d;\n}\n.data-field select[data-v-000966c7]:disabled {\n      background-color: #eee;\n}\n.billing-box[data-v-000966c7] {\n  padding: 15px;\n  background: #ebf4ff;\n  border: 1px solid #0d79f2;\n  border-radius: 8px;\n  margin: 10px 0;\n}\n.billing-box .billing-label[data-v-000966c7] {\n    font-size: 21px;\n    font-weight: 600;\n    padding-bottom: 5px;\n    color: #333;\n    text-align: center;\n}\n.billing-box .label[data-v-000966c7] {\n    color: #122a43;\n}\n.billing-box .error-msg[data-v-000966c7] {\n    color: #fff;\n}\n.palette[data-v-000966c7] {\n  position: absolute;\n  top: 27px;\n  right: 13px;\n  background-color: #fafafa;\n  width: 20px;\n  height: 20px;\n  border-radius: 10px;\n  cursor: pointer;\n}\n.color-picker[data-v-000966c7] {\n  position: absolute;\n  top: 100%;\n  z-index: 3;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.color-picker.right[data-v-000966c7] {\n    right: 0;\n}\n.color-picker.left[data-v-000966c7] {\n    left: 0;\n}\n.success-password[data-v-000966c7] {\n  font-size: 13px;\n  font-weight: 600;\n  color: #11b35d;\n  padding-left: 5px;\n}\n.password-box[data-v-000966c7] {\n  border: 1px solid #888;\n  background: #fff;\n  padding: 10px;\n  border-radius: 2px;\n}\n.password-box .medium-6[data-v-000966c7]:first-child {\n    padding-right: 5px;\n}\n.password-box .medium-6[data-v-000966c7]:last-child {\n    padding-left: 5px;\n}\n.password-box .has-error[data-v-000966c7] {\n    font-size: 11px;\n    color: #f20d0d;\n    border: 1px solid #f20d0d;\n    background: #fff1f1;\n    padding: 4px;\n}\n.fix-buttons[data-v-000966c7] {\n  position: fixed;\n  z-index: 2;\n  bottom: 0;\n  left: 0;\n  padding: 10px;\n  width: 500px;\n  height: 60px;\n  background: #eee;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.fix-buttons a[data-v-000966c7] {\n    width: 50%;\n    display: inline-block;\n    margin: 0 10px 0 auto;\n}\n.fix-buttons a.right[data-v-000966c7] {\n      margin-left: auto;\n}\n.card-list-box[data-v-000966c7] {\n  padding: 0 5px;\n  margin: 20px 0 10px;\n}\n.card-list-box .label[data-v-000966c7] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.card-list-box .card-box[data-v-000966c7] {\n    background: #fff;\n    border: 1px solid #ccc;\n    padding: 10px;\n    border-radius: 2px;\n}\n.card-list-box .card-box .logo[data-v-000966c7], .card-list-box .card-box .info[data-v-000966c7], .card-list-box .card-box .action[data-v-000966c7] {\n      display: inline-block;\n}\n.card-list-box .card-box .logo[data-v-000966c7] {\n      width: 40px;\n      text-align: center;\n}\n.card-list-box .card-box .logo .far[data-v-000966c7] {\n        font-size: 21px;\n        position: relative;\n        top: 2px;\n}\n.card-list-box .card-box .logo .cc-icon[data-v-000966c7] {\n        position: relative;\n        top: 5px;\n}\n.card-list-box .card-box .info[data-v-000966c7] {\n      width: calc(100% - 130px);\n      font-size: 13px;\n}\n.card-list-box .card-box .info .number[data-v-000966c7] {\n        font-weight: 600;\n        color: #333;\n}\n.card-list-box .card-box .info .exp[data-v-000966c7] {\n        display: inline-block;\n        margin-left: 5px;\n        color: #aaa;\n}\n.card-list-box .card-box .action[data-v-000966c7] {\n      font-size: 14px;\n      width: 80px;\n      text-align: center;\n      vertical-align: 5px;\n}\n.respond-box[data-v-000966c7], .confirm-card[data-v-000966c7] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 4;\n  background: rgba(0, 0, 0, 0.5);\n  display: table;\n}\n.respond-box .vertical-center[data-v-000966c7], .confirm-card .vertical-center[data-v-000966c7] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.respond-box .card[data-v-000966c7], .confirm-card .card[data-v-000966c7] {\n    width: 80%;\n    max-width: 500px;\n    margin: 0 auto;\n    padding: 15px;\n    text-align: center;\n}\n.respond-box .fa-check-circle[data-v-000966c7], .respond-box .fa-times-circle[data-v-000966c7], .confirm-card .fa-check-circle[data-v-000966c7], .confirm-card .fa-times-circle[data-v-000966c7] {\n    font-size: 100px;\n    color: #26d97a;\n    margin-bottom: 5px;\n}\n.respond-box .fa-times-circle[data-v-000966c7], .confirm-card .fa-times-circle[data-v-000966c7] {\n    color: #F20D0D;\n}\n.respond-box .label[data-v-000966c7], .confirm-card .label[data-v-000966c7] {\n    font-weight: 600;\n    color: #505050;\n}\n.respond-box .message[data-v-000966c7], .confirm-card .message[data-v-000966c7] {\n    font-size: 14px;\n    color: #777;\n    margin: 10px 0;\n}\n.confirm-card .small-6[data-v-000966c7] {\n  margin-top: 25px;\n  padding: 0 10px;\n}\n.tab[data-v-000966c7] {\n  list-style: none;\n  padding: 0;\n  margin: 15px 0 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  z-index: 2;\n}\n.tab li[data-v-000966c7] {\n    color: #0D79F2;\n    padding: 15px 25px;\n    font-size: 14px;\n    font-weight: 600;\n    text-align: center;\n    display: inline-block;\n    text-transform: uppercase;\n    cursor: pointer;\n}\n.tab li.grow[data-v-000966c7] {\n      -webkit-box-flex: 100;\n          -ms-flex-positive: 100;\n              flex-grow: 100;\n}\n.tab li.active[data-v-000966c7] {\n      background: #fff;\n      -webkit-box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);\n              box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);\n      border-radius: 2px 2px 0 0;\n      color: #777;\n}\n.tab-contents[data-v-000966c7] {\n  background: #fff;\n  z-index: 2;\n  position: relative;\n  -webkit-box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.1);\n}\n.tab-contents .tab-content[data-v-000966c7] {\n    padding: 20px;\n    display: none;\n}\n.tab-contents .tab-content.no-H-padding[data-v-000966c7] {\n      padding: 20px 0;\n}\n.tab-contents .tab-content.active[data-v-000966c7] {\n      display: block;\n}\n.input-group[data-v-000966c7] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  position: relative;\n  margin-bottom: 0;\n}\n.input-group .input-group-label[data-v-000966c7] {\n    padding: 0 10px;\n    border: 1px solid #cacaca;\n    background: #f4f8f9;\n    color: #0a0a0a;\n    text-align: center;\n    white-space: nowrap;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n.input-group .mobile-input[data-v-000966c7] {\n    padding-left: 25px;\n    border-radius: 1px;\n    border-left: 0;\n}\n.input-group.small .mobile-input[data-v-000966c7] {\n    padding-left: 35px;\n}\n.input-group.medium .mobile-input[data-v-000966c7] {\n    padding-left: 45px;\n}\n.input-group.large .mobile-input[data-v-000966c7] {\n    padding-left: 55px;\n}\n.input-group.xl .mobile-input[data-v-000966c7] {\n    padding-left: 65px;\n}\n.toggle-panel[data-v-000966c7] {\n  -webkit-transition: all .6s ease;\n  transition: all .6s ease;\n}\n.toggle-panel .tab-contents[data-v-000966c7] {\n    background: #ededed;\n}\n.toggle-panel .tab-contents .logs[data-v-000966c7] {\n      padding: 20px;\n}\n.logs-toggle[data-v-000966c7] {\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 3;\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  text-align: center;\n  color: #777;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  border-radius: 0;\n  background-color: #F25E0D;\n  color: #fff;\n  border-bottom-left-radius: 3px;\n  -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n          box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n  -webkit-transition: .5s ease;\n  transition: .5s ease;\n}\n.logs-toggle i[data-v-000966c7] {\n    line-height: inherit;\n}\n.logs-toggle.on[data-v-000966c7] {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n    -webkit-transition: .5s ease;\n    transition: .5s ease;\n}\n.toggle-panel[data-v-000966c7] {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  top: 0;\n  width: 400px;\n  height: 100%;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #f4f8f9;\n}\n.toggle-panel.hide[data-v-000966c7] {\n    right: -400px;\n    -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n            box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n}\n.toggle-panel .heading[data-v-000966c7] {\n    font-size: 24px;\n    padding: 10px 20px;\n    margin-bottom: 7px;\n}\n.toggle-panel .tab[data-v-000966c7] {\n    background: #d5d5d5;\n}\n.toggle-panel .tab .active[data-v-000966c7] {\n      background: #ededed;\n}\n.toggle-panel .tab li[data-v-000966c7] {\n      width: 50%;\n}\n.toggle-panel .tab-contents[data-v-000966c7] {\n    background: #fff;\n    display: block;\n    height: calc(100% - 57px);\n    overflow-y: auto;\n}\n  /* Chrome, Safari, Edge, Opera */\ninput[data-v-000966c7]::-webkit-outer-spin-button,\ninput[data-v-000966c7]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n  /* Firefox */\ninput[type=number][data-v-000966c7] {\n  -moz-appearance: textfield;\n}\n.country-select[data-v-000966c7] {\n  margin-top: 1px;\n  cursor: pointer;\n  color: #333;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.country-select[data-v-000966c7]:hover {\n  background-color: #e6e6e6;\n}\n.country-code[data-v-000966c7] {\n  margin-right: 3px;\n  font-weight: 100;\n  font-size: 15px;\n}\n.infinity-loader[data-v-000966c7] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  -webkit-transform-origin: bottom center;\n          transform-origin: bottom center;\n  text-align: center;\n  font-size: 18px;\n  line-height: 40px;\n  z-index: 100;\n}\n.margin-B-s[data-v-000966c7] {\n  margin-bottom: 5px;\n}\n.margin-B-m[data-v-000966c7] {\n  margin-bottom: 10px;\n}\n.margin-T-l[data-v-000966c7] {\n  margin-top: 15px;\n}\n.slide-up-enter-active[data-v-000966c7], .slide-up-leave-active[data-v-000966c7] {\n  -webkit-transition: all .6s ease;\n  transition: all .6s ease;\n}\n.slide-up-enter[data-v-000966c7], .slide-up-leave-to[data-v-000966c7] {\n  -webkit-transform: translateY(30px);\n          transform: translateY(30px);\n  opacity: 0;\n}\n.slide-down-enter-active[data-v-000966c7], .slide-down-leave-active[data-v-000966c7] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-000966c7], .slide-down-leave-to[data-v-000966c7] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.expand-enter-active[data-v-000966c7], .expand-leave-active[data-v-000966c7] {\n  -webkit-transition: all .1s ease;\n  transition: all .1s ease;\n}\n.expand-enter[data-v-000966c7], .expand-leave-to[data-v-000966c7] {\n  -webkit-transform: scale(0.95);\n          transform: scale(0.95);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.collapsible .content[data-v-000966c7] {\n    max-height: 920px;\n}\n.password-box .medium-6[data-v-000966c7] {\n    width: 50%;\n    padding: 0;\n}\n.left-panel[data-v-000966c7] {\n    width: 100%;\n    padding-bottom: 100px;\n}\n.left-panel .heading[data-v-000966c7] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n}\n.left-panel .heading .cons-name[data-v-000966c7] {\n        padding: 0 15px 0 15px;\n        width: 140px;\n}\n.left-panel .heading .switch[data-v-000966c7] {\n        display: block;\n        padding-top: 5px;\n        padding-left: 10px;\n        padding-right: 50px;\n        padding-top: 1px;\n}\n.left-panel .heading .prov-options[data-v-000966c7] {\n        position: absolute;\n        right: 0;\n        top: 15px;\n}\n.left-panel .tab[data-v-000966c7] {\n      margin: 35px 0 0;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      overflow-x: scroll;\n}\n.left-panel .tab li[data-v-000966c7] {\n        width: auto;\n}\n.toggle-mobile[data-v-000966c7] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.right-panel[data-v-000966c7] {\n    z-index: 1;\n    width: 100%;\n    top: 100%;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n}\n.right-panel.mobile-right-panel[data-v-000966c7] {\n      top: 0;\n      z-index: 2;\n}\n.right-panel.mobile-right-panel .tab[data-v-000966c7] {\n        margin-top: 70px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        overflow-x: scroll;\n}\n.right-panel.mobile-right-panel .tab li[data-v-000966c7] {\n          font-size: 13px;\n}\n.right-panel.mobile-right-panel .tab-contents[data-v-000966c7] {\n        width: 100%;\n        height: calc(100vh - 142px);\n        overflow-y: scroll;\n}\n.right-panel.mobile-right-panel .tab-contents .tab-content[data-v-000966c7] {\n          padding-bottom: 60px;\n}\n.right-panel.mobile-right-panel .tab-contents .tab-content.history-panel[data-v-000966c7] {\n            padding: 0;\n            padding-top: 20px;\n            padding-bottom: 60px;\n}\n.right-panel.mobile-right-panel .tab-contents .fixed-footer[data-v-000966c7] {\n          width: 100%;\n          bottom: 45px;\n          background: #fff;\n          color: #000;\n          border-top: 1px solid #aaa;\n}\n.right-panel.mobile-right-panel .logs-panel[data-v-000966c7] {\n        width: 100%;\n}\n.fix-buttons[data-v-000966c7] {\n    width: 100%;\n    bottom: 45px;\n}\n.fix-buttons a[data-v-000966c7] {\n      margin: 0 auto;\n}\n.toggle-panel .heading[data-v-000966c7] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Corporate/CorporateProfile.vue"],"names":[],"mappings":";AACA;EACE,8FAA8F;EAC9F,6BAA6B;EAC7B,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,sBAAsB;CACvB;AACD;IACI,yBAAyB;CAC5B;AACD;IACI,6BAA6B;CAChC;AACD;IACI,6BAA6B;CAChC;AACD;IACI,6BAA6B;CAChC;AACD;IACI,6BAA6B;CAChC;AACD;IACI,8BAA8B;CACjC;AACD;IACI,8BAA8B;CACjC;AACD;EACE,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;MACM,iBAAiB;CACtB;AACD;IACI,iBAAiB;IACjB,wBAAwB;IACxB,4BAA4B;IAC5B,kBAAkB;IAClB,4DAA4D;IAC5D,aAAa;IACb,iBAAiB;IACjB,uCAAuC;IACvC,+BAA+B;CAClC;AACD;MACM,oBAAoB;CACzB;AACD;MACM,iBAAiB;CACtB;AACD;IACI,cAAc;IACd,gBAAgB;CACnB;AACD;EACE,cAAc;CACf;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,OAAO;EACP,aAAa;EACb,aAAa;EACb,iDAAiD;UACzC,yCAAyC;EACjD,0BAA0B;EAC1B,iBAAiB;CAClB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,YAAY;CACf;AACD;MACM,iBAAiB;MACjB,8BAA8B;MAC9B,oBAAoB;CACzB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,OAAO;EACP,0BAA0B;EAC1B,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;EAClD,0BAA0B;EAC1B,mBAAmB;CACpB;AACD;IACI,gBAAgB;IAChB,mBAAmB;CACtB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,oBAAoB;CACzB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;CACjB;AACD;IACI,sBAAsB;IACtB,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,iBAAiB;IACjB,sBAAsB;CACzB;AACD;EACE,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;CACd;AACD;IACI,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,iCAAiC;CACpC;AACD;MACM,YAAY;CACjB;AACD;MACM,YAAY;MACZ,mBAAmB;MACnB,SAAS;MACT,UAAU;MACV,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,iBAAiB;MACjB,yCAAyC;MACzC,iCAAiC;MACjC,oDAAoD;cAC5C,4CAA4C;CACzD;AACD;MACM,oBAAoB;CACzB;AACD;QACQ,WAAW;CAClB;AACD;IACI,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;CAC7B;AACD;EACE,cAAc;EACd,oBAAoB;EACpB,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB;CAClB;AACD;IACI,aAAa;IACb,eAAe;CAClB;AACD;EACE,oBAAoB;EACpB,gBAAgB;CACjB;AACD;IACI,qBAAqB;IACrB,sBAAsB;IACtB,cAAc;IACd,iBAAiB;CACpB;AACD;EACE,mBAAmB;EACnB,qBAAqB;CACtB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;IACjC,yBAAyB;CAC5B;AACD;IACI,mBAAmB;IACnB,sBAAsB;IACtB,wBAAwB;IACxB,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,iBAAiB;CACpB;AACD;MACM,mBAAmB;MACnB,SAAS;MACT,UAAU;MACV,kBAAkB;MAClB,mBAAmB;MACnB,WAAW;CAChB;AACD;MACM,YAAY;CACjB;AACD;MACM,WAAW;MACX,SAAS;CACd;AACD;MACM,mBAAmB;MACnB,SAAS;MACT,UAAU;MACV,WAAW;MACX,kBAAkB;MAClB,mBAAmB;CACxB;AACD;MACM,YAAY;CACjB;AACD;MACM,cAAc;CACnB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;CACpB;AACD;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;CACtB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,aAAa;EACb,mBAAmB;CACpB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;MACM,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;IACI,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,wDAAwD;IACxD,6BAA6B;IAC7B,+BAA+B;IAC/B,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,uBAAuB;CAC5B;AACD;EACE,cAAc;EACd,oBAAoB;EACpB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;CAChB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,mBAAmB;CACtB;AACD;IACI,eAAe;CAClB;AACD;IACI,YAAY;CACf;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,gBAAgB;CACjB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;IACI,SAAS;CACZ;AACD;IACI,QAAQ;CACX;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;CACnB;AACD;EACE,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;CACpB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,oBAAoB;IACpB,aAAa;CAChB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,QAAQ;EACR,cAAc;EACd,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,+BAA+B;UACvB,uBAAuB;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,WAAW;IACX,sBAAsB;IACtB,sBAAsB;CACzB;AACD;MACM,kBAAkB;CACvB;AACD;EACE,eAAe;EACf,oBAAoB;CACrB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;IACI,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;IACd,mBAAmB;CACtB;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,YAAY;MACZ,mBAAmB;CACxB;AACD;QACQ,gBAAgB;QAChB,mBAAmB;QACnB,SAAS;CAChB;AACD;QACQ,mBAAmB;QACnB,SAAS;CAChB;AACD;MACM,0BAA0B;MAC1B,gBAAgB;CACrB;AACD;QACQ,iBAAiB;QACjB,YAAY;CACnB;AACD;QACQ,sBAAsB;QACtB,iBAAiB;QACjB,YAAY;CACnB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,mBAAmB;MACnB,oBAAoB;CACzB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,WAAW;EACX,+BAA+B;EAC/B,eAAe;CAChB;AACD;IACI,oBAAoB;IACpB,uBAAuB;CAC1B;AACD;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,mBAAmB;CACtB;AACD;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;CACtB;AACD;IACI,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;CAClB;AACD;EACE,iBAAiB;EACjB,gBAAgB;CACjB;AACD;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,WAAW;CACZ;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;CACnB;AACD;MACM,sBAAsB;UAClB,uBAAuB;cACnB,eAAe;CAC5B;AACD;MACM,iBAAiB;MACjB,kDAAkD;cAC1C,0CAA0C;MAClD,2BAA2B;MAC3B,YAAY;CACjB;AACD;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,qDAAqD;UAC7C,6CAA6C;CACtD;AACD;IACI,cAAc;IACd,cAAc;CACjB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,eAAe;CACpB;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;CAClB;AACD;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,uBAAuB;IACvB,oBAAoB;CACvB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;CAClB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,mBAAmB;CACtB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;IACI,oBAAoB;CACvB;AACD;MACM,cAAc;CACnB;AACD;EACE,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;EACjB,0BAA0B;EAC1B,YAAY;EACZ,+BAA+B;EAC/B,mDAAmD;UAC3C,2CAA2C;EACnD,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,6BAA6B;EAC7B,qBAAqB;CACtB;AACD;IACI,qBAAqB;CACxB;AACD;IACI,gCAAgC;IAChC,wBAAwB;IACxB,6BAA6B;IAC7B,qBAAqB;CACxB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;EAClD,0BAA0B;CAC3B;AACD;IACI,cAAc;IACd,gDAAgD;YACxC,wCAAwC;CACnD;AACD;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;CACtB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,WAAW;CAChB;AACD;IACI,iBAAiB;IACjB,eAAe;IACf,0BAA0B;IAC1B,iBAAiB;CACpB;EACC,iCAAiC;AACnC;;EAEE,yBAAyB;EACzB,UAAU;CACX;EACC,aAAa;AACf;EACE,2BAA2B;CAC5B;AACD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;CAClB;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;CACjB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,wCAAwC;UAChC,gCAAgC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;CACd;AACD;EACE,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,WAAW;CACZ;AACD;AACA;IACI,kBAAkB;CACrB;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;IACI,YAAY;IACZ,sBAAsB;CACzB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;CAC5C;AACD;QACQ,uBAAuB;QACvB,aAAa;CACpB;AACD;QACQ,eAAe;QACf,iBAAiB;QACjB,mBAAmB;QACnB,oBAAoB;QACpB,iBAAiB;CACxB;AACD;QACQ,mBAAmB;QACnB,SAAS;QACT,UAAU;CACjB;AACD;MACM,iBAAiB;MACjB,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,mBAAmB;CACxB;AACD;QACQ,YAAY;CACnB;AACD;IACI,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;IACrB,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;CACpB;AACD;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,OAAO;MACP,WAAW;CAChB;AACD;QACQ,iBAAiB;QACjB,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,mBAAmB;CAC1B;AACD;UACU,gBAAgB;CACzB;AACD;QACQ,YAAY;QACZ,4BAA4B;QAC5B,mBAAmB;CAC1B;AACD;UACU,qBAAqB;CAC9B;AACD;YACY,WAAW;YACX,kBAAkB;YAClB,qBAAqB;CAChC;AACD;UACU,YAAY;UACZ,aAAa;UACb,iBAAiB;UACjB,YAAY;UACZ,2BAA2B;CACpC;AACD;QACQ,YAAY;CACnB;AACD;IACI,YAAY;IACZ,aAAa;CAChB;AACD;MACM,eAAe;CACpB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,yBAAyB;QACrB,sBAAsB;YAClB,wBAAwB;CACnC;CACA","file":"CorporateProfile.vue","sourcesContent":["\n.cc-icon[data-v-000966c7] {\n  background-image: url(\"https://s3-us-west-2.amazonaws.com/mobile-consumer-app/cc-sprite.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 20px;\n  width: 32px;\n  display: inline-block;\n}\n.cc-icon.unknown[data-v-000966c7] {\n    background-position: 0 0;\n}\n.cc-icon.visa[data-v-000966c7] {\n    background-position: 0 -20px;\n}\n.cc-icon.mastercard[data-v-000966c7] {\n    background-position: 0 -40px;\n}\n.cc-icon.amex[data-v-000966c7] {\n    background-position: 0 -60px;\n}\n.cc-icon.discover[data-v-000966c7] {\n    background-position: 0 -80px;\n}\n.cc-icon.jcb[data-v-000966c7] {\n    background-position: 0 -100px;\n}\n.cc-icon.diners[data-v-000966c7] {\n    background-position: 0 -120px;\n}\n.collapsible[data-v-000966c7] {\n  margin-bottom: 5px;\n}\n.collapsible .head[data-v-000966c7] {\n    color: #0D79F2;\n    margin-bottom: 2px;\n    cursor: pointer;\n    text-transform: uppercase;\n}\n.collapsible .head i[data-v-000966c7] {\n      margin-right: 5px;\n}\n.collapsible .head span[data-v-000966c7] {\n      font-weight: 600;\n}\n.collapsible .content[data-v-000966c7] {\n    margin-left: 6px;\n    padding: 5px 0 5px 15px;\n    border-left: 2px solid #ddd;\n    max-height: 800px;\n    /* define precise max-height for more smoother transition */\n    height: auto;\n    overflow: hidden;\n    -webkit-transition: all 0.35s ease-out;\n    transition: all 0.35s ease-out;\n}\n.collapsible .content .field-row[data-v-000966c7] {\n      margin-bottom: 15px;\n}\n.collapsible .content .field-row[data-v-000966c7]:last-child {\n      margin-bottom: 0;\n}\n.collapsible.collapse .content[data-v-000966c7] {\n    max-height: 0;\n    padding: 0 15px;\n}\n.toggle-mobile[data-v-000966c7] {\n  display: none;\n}\n.left-panel[data-v-000966c7] {\n  position: fixed;\n  z-index: 2;\n  left: 0;\n  top: 0;\n  width: 500px;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #F4F8F9;\n  overflow-y: auto;\n}\n.left-panel.no-scroll[data-v-000966c7] {\n    overflow: hidden;\n}\n.left-panel .heading[data-v-000966c7] {\n    padding-left: 50px;\n}\n.left-panel.centered[data-v-000966c7] {\n    width: 100%;\n}\n.left-panel.centered .heading[data-v-000966c7] {\n      background: #fff;\n      border-bottom: 1px solid #ddd;\n      margin-bottom: 20px;\n}\n.right-panel[data-v-000966c7] {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  top: 0;\n  width: calc(100% - 500px);\n  height: 100%;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #d5d5d5;\n  overflow-y: hidden;\n}\n.right-panel .heading[data-v-000966c7] {\n    font-size: 24px;\n    padding: 10px 20px;\n}\n.right-panel .tab[data-v-000966c7] {\n    background: #d5d5d5;\n}\n.right-panel .tab .active[data-v-000966c7] {\n      background: #ededed;\n}\n.right-panel .tab-contents[data-v-000966c7] {\n    background: #ededed;\n}\n.heading[data-v-000966c7] {\n  height: 50px;\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  padding: 10px 0;\n}\n.heading .cons-name[data-v-000966c7] {\n    padding: 0 5px 0 15px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 200px;\n    display: inline-block;\n}\n.switch[data-v-000966c7] {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n  float: right;\n}\n.switch .slider[data-v-000966c7] {\n    position: relative;\n    display: inline-block;\n    width: 50px;\n    height: 26px;\n    border-radius: 20px;\n    background: #ccc;\n    position: relative;\n    cursor: pointer;\n    -webkit-transition: all .25s ease-in-out;\n    transition: all .25s ease-in-out;\n}\n.switch .slider.disabled[data-v-000966c7] {\n      opacity: .4;\n}\n.switch .slider[data-v-000966c7]:before {\n      content: '';\n      position: absolute;\n      top: 2px;\n      left: 3px;\n      width: 21px;\n      height: 21px;\n      border-radius: 50%;\n      background: #fff;\n      -webkit-transition: all .25s ease-in-out;\n      transition: all .25s ease-in-out;\n      -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n}\n.switch .slider.active[data-v-000966c7] {\n      background: #57d1b7;\n}\n.switch .slider.active[data-v-000966c7]:before {\n        left: 25px;\n}\n.switch .label[data-v-000966c7] {\n    display: inline-block;\n    vertical-align: 8px;\n    margin-right: 5px;\n    font-size: 14px;\n    color: #555;\n    text-transform: uppercase;\n}\n.body[data-v-000966c7] {\n  padding: 20px;\n  background: #fafafa;\n  border-top: 1px solid #ccc;\n  height: calc(100vh - 111px);\n  overflow-y: auto;\n}\n.body.card[data-v-000966c7] {\n    width: 500px;\n    margin: 0 auto;\n}\n.cons-link[data-v-000966c7] {\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n.cons-link a[data-v-000966c7] {\n    letter-spacing: .5px;\n    display: inline-block;\n    margin: 0 5px;\n    font-weight: 600;\n}\n.logo-box[data-v-000966c7] {\n  text-align: center;\n  padding: 0 20px 20px;\n}\n.logo-box .fa-user-circle[data-v-000966c7] {\n    font-size: 140px;\n    margin-top: 30px;\n    color: #f2ad6d;\n}\n.logo-box img[data-v-000966c7] {\n    max-width: 200px;\n    max-height: 200px;\n    cursor: pointer;\n    -webkit-transition: .2s ease all;\n    transition: .2s ease all;\n}\n.logo-box .img-hover-box[data-v-000966c7] {\n    position: relative;\n    display: inline-block;\n    border: 3px dashed #ddd;\n    width: 206px;\n    height: 206px;\n    overflow: hidden;\n    background: #fff;\n}\n.logo-box .img-hover-box .button[data-v-000966c7] {\n      position: absolute;\n      top: 60%;\n      left: 50%;\n      margin-top: -20px;\n      margin-left: -63px;\n      opacity: 0;\n}\n.logo-box .img-hover-box:hover img[data-v-000966c7] {\n      opacity: .6;\n}\n.logo-box .img-hover-box:hover .button[data-v-000966c7] {\n      opacity: 1;\n      top: 50%;\n}\n.logo-box .img-hover-box .fa-spinner[data-v-000966c7] {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      z-index: 3;\n      margin-top: -16px;\n      margin-left: -16px;\n}\n.logo-box .img-hover-box.loading img[data-v-000966c7] {\n      opacity: .6;\n}\n.logo-box .img-hover-box.loading:hover .button[data-v-000966c7] {\n      display: none;\n}\n.logo-box .recommended[data-v-000966c7] {\n    display: block;\n    font-size: 14px;\n    margin-bottom: 5px;\n    color: #666;\n    font-weight: 600;\n}\n.logo-box .error-msg[data-v-000966c7] {\n    display: block;\n    font-weight: 100;\n    margin-top: 2px;\n    color: #f20d0d;\n    font-size: 12px;\n    font-style: italic;\n}\n.details-box[data-v-000966c7] {\n  padding: 20px 0;\n}\n.data-field[data-v-000966c7] {\n  padding: 5px;\n  position: relative;\n}\n.data-field .label[data-v-000966c7] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .label.has-error[data-v-000966c7] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-000966c7] {\n    margin: 1px 0 0;\n    padding: 5px;\n    font-size: 14px;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-000966c7] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-000966c7]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-000966c7] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.data-field select[data-v-000966c7] {\n    border: 1px solid #ddd;\n    padding: 5px;\n    color: #333;\n    height: 35px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field select.has-error[data-v-000966c7] {\n      border-color: #f20d0d;\n}\n.data-field select[data-v-000966c7]:disabled {\n      background-color: #eee;\n}\n.billing-box[data-v-000966c7] {\n  padding: 15px;\n  background: #ebf4ff;\n  border: 1px solid #0d79f2;\n  border-radius: 8px;\n  margin: 10px 0;\n}\n.billing-box .billing-label[data-v-000966c7] {\n    font-size: 21px;\n    font-weight: 600;\n    padding-bottom: 5px;\n    color: #333;\n    text-align: center;\n}\n.billing-box .label[data-v-000966c7] {\n    color: #122a43;\n}\n.billing-box .error-msg[data-v-000966c7] {\n    color: #fff;\n}\n.palette[data-v-000966c7] {\n  position: absolute;\n  top: 27px;\n  right: 13px;\n  background-color: #fafafa;\n  width: 20px;\n  height: 20px;\n  border-radius: 10px;\n  cursor: pointer;\n}\n.color-picker[data-v-000966c7] {\n  position: absolute;\n  top: 100%;\n  z-index: 3;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.color-picker.right[data-v-000966c7] {\n    right: 0;\n}\n.color-picker.left[data-v-000966c7] {\n    left: 0;\n}\n.success-password[data-v-000966c7] {\n  font-size: 13px;\n  font-weight: 600;\n  color: #11b35d;\n  padding-left: 5px;\n}\n.password-box[data-v-000966c7] {\n  border: 1px solid #888;\n  background: #fff;\n  padding: 10px;\n  border-radius: 2px;\n}\n.password-box .medium-6[data-v-000966c7]:first-child {\n    padding-right: 5px;\n}\n.password-box .medium-6[data-v-000966c7]:last-child {\n    padding-left: 5px;\n}\n.password-box .has-error[data-v-000966c7] {\n    font-size: 11px;\n    color: #f20d0d;\n    border: 1px solid #f20d0d;\n    background: #fff1f1;\n    padding: 4px;\n}\n.fix-buttons[data-v-000966c7] {\n  position: fixed;\n  z-index: 2;\n  bottom: 0;\n  left: 0;\n  padding: 10px;\n  width: 500px;\n  height: 60px;\n  background: #eee;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.fix-buttons a[data-v-000966c7] {\n    width: 50%;\n    display: inline-block;\n    margin: 0 10px 0 auto;\n}\n.fix-buttons a.right[data-v-000966c7] {\n      margin-left: auto;\n}\n.card-list-box[data-v-000966c7] {\n  padding: 0 5px;\n  margin: 20px 0 10px;\n}\n.card-list-box .label[data-v-000966c7] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.card-list-box .card-box[data-v-000966c7] {\n    background: #fff;\n    border: 1px solid #ccc;\n    padding: 10px;\n    border-radius: 2px;\n}\n.card-list-box .card-box .logo[data-v-000966c7], .card-list-box .card-box .info[data-v-000966c7], .card-list-box .card-box .action[data-v-000966c7] {\n      display: inline-block;\n}\n.card-list-box .card-box .logo[data-v-000966c7] {\n      width: 40px;\n      text-align: center;\n}\n.card-list-box .card-box .logo .far[data-v-000966c7] {\n        font-size: 21px;\n        position: relative;\n        top: 2px;\n}\n.card-list-box .card-box .logo .cc-icon[data-v-000966c7] {\n        position: relative;\n        top: 5px;\n}\n.card-list-box .card-box .info[data-v-000966c7] {\n      width: calc(100% - 130px);\n      font-size: 13px;\n}\n.card-list-box .card-box .info .number[data-v-000966c7] {\n        font-weight: 600;\n        color: #333;\n}\n.card-list-box .card-box .info .exp[data-v-000966c7] {\n        display: inline-block;\n        margin-left: 5px;\n        color: #aaa;\n}\n.card-list-box .card-box .action[data-v-000966c7] {\n      font-size: 14px;\n      width: 80px;\n      text-align: center;\n      vertical-align: 5px;\n}\n.respond-box[data-v-000966c7], .confirm-card[data-v-000966c7] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 4;\n  background: rgba(0, 0, 0, 0.5);\n  display: table;\n}\n.respond-box .vertical-center[data-v-000966c7], .confirm-card .vertical-center[data-v-000966c7] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.respond-box .card[data-v-000966c7], .confirm-card .card[data-v-000966c7] {\n    width: 80%;\n    max-width: 500px;\n    margin: 0 auto;\n    padding: 15px;\n    text-align: center;\n}\n.respond-box .fa-check-circle[data-v-000966c7], .respond-box .fa-times-circle[data-v-000966c7], .confirm-card .fa-check-circle[data-v-000966c7], .confirm-card .fa-times-circle[data-v-000966c7] {\n    font-size: 100px;\n    color: #26d97a;\n    margin-bottom: 5px;\n}\n.respond-box .fa-times-circle[data-v-000966c7], .confirm-card .fa-times-circle[data-v-000966c7] {\n    color: #F20D0D;\n}\n.respond-box .label[data-v-000966c7], .confirm-card .label[data-v-000966c7] {\n    font-weight: 600;\n    color: #505050;\n}\n.respond-box .message[data-v-000966c7], .confirm-card .message[data-v-000966c7] {\n    font-size: 14px;\n    color: #777;\n    margin: 10px 0;\n}\n.confirm-card .small-6[data-v-000966c7] {\n  margin-top: 25px;\n  padding: 0 10px;\n}\n.tab[data-v-000966c7] {\n  list-style: none;\n  padding: 0;\n  margin: 15px 0 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  z-index: 2;\n}\n.tab li[data-v-000966c7] {\n    color: #0D79F2;\n    padding: 15px 25px;\n    font-size: 14px;\n    font-weight: 600;\n    text-align: center;\n    display: inline-block;\n    text-transform: uppercase;\n    cursor: pointer;\n}\n.tab li.grow[data-v-000966c7] {\n      -webkit-box-flex: 100;\n          -ms-flex-positive: 100;\n              flex-grow: 100;\n}\n.tab li.active[data-v-000966c7] {\n      background: #fff;\n      -webkit-box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);\n              box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);\n      border-radius: 2px 2px 0 0;\n      color: #777;\n}\n.tab-contents[data-v-000966c7] {\n  background: #fff;\n  z-index: 2;\n  position: relative;\n  -webkit-box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.1);\n}\n.tab-contents .tab-content[data-v-000966c7] {\n    padding: 20px;\n    display: none;\n}\n.tab-contents .tab-content.no-H-padding[data-v-000966c7] {\n      padding: 20px 0;\n}\n.tab-contents .tab-content.active[data-v-000966c7] {\n      display: block;\n}\n.input-group[data-v-000966c7] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  position: relative;\n  margin-bottom: 0;\n}\n.input-group .input-group-label[data-v-000966c7] {\n    padding: 0 10px;\n    border: 1px solid #cacaca;\n    background: #f4f8f9;\n    color: #0a0a0a;\n    text-align: center;\n    white-space: nowrap;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n.input-group .mobile-input[data-v-000966c7] {\n    padding-left: 25px;\n    border-radius: 1px;\n    border-left: 0;\n}\n.input-group.small .mobile-input[data-v-000966c7] {\n    padding-left: 35px;\n}\n.input-group.medium .mobile-input[data-v-000966c7] {\n    padding-left: 45px;\n}\n.input-group.large .mobile-input[data-v-000966c7] {\n    padding-left: 55px;\n}\n.input-group.xl .mobile-input[data-v-000966c7] {\n    padding-left: 65px;\n}\n.toggle-panel[data-v-000966c7] {\n  -webkit-transition: all .6s ease;\n  transition: all .6s ease;\n}\n.toggle-panel .tab-contents[data-v-000966c7] {\n    background: #ededed;\n}\n.toggle-panel .tab-contents .logs[data-v-000966c7] {\n      padding: 20px;\n}\n.logs-toggle[data-v-000966c7] {\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 3;\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  text-align: center;\n  color: #777;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  border-radius: 0;\n  background-color: #F25E0D;\n  color: #fff;\n  border-bottom-left-radius: 3px;\n  -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n          box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n  -webkit-transition: .5s ease;\n  transition: .5s ease;\n}\n.logs-toggle i[data-v-000966c7] {\n    line-height: inherit;\n}\n.logs-toggle.on[data-v-000966c7] {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n    -webkit-transition: .5s ease;\n    transition: .5s ease;\n}\n.toggle-panel[data-v-000966c7] {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  top: 0;\n  width: 400px;\n  height: 100%;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #f4f8f9;\n}\n.toggle-panel.hide[data-v-000966c7] {\n    right: -400px;\n    -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n            box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n}\n.toggle-panel .heading[data-v-000966c7] {\n    font-size: 24px;\n    padding: 10px 20px;\n    margin-bottom: 7px;\n}\n.toggle-panel .tab[data-v-000966c7] {\n    background: #d5d5d5;\n}\n.toggle-panel .tab .active[data-v-000966c7] {\n      background: #ededed;\n}\n.toggle-panel .tab li[data-v-000966c7] {\n      width: 50%;\n}\n.toggle-panel .tab-contents[data-v-000966c7] {\n    background: #fff;\n    display: block;\n    height: calc(100% - 57px);\n    overflow-y: auto;\n}\n  /* Chrome, Safari, Edge, Opera */\ninput[data-v-000966c7]::-webkit-outer-spin-button,\ninput[data-v-000966c7]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n  /* Firefox */\ninput[type=number][data-v-000966c7] {\n  -moz-appearance: textfield;\n}\n.country-select[data-v-000966c7] {\n  margin-top: 1px;\n  cursor: pointer;\n  color: #333;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.country-select[data-v-000966c7]:hover {\n  background-color: #e6e6e6;\n}\n.country-code[data-v-000966c7] {\n  margin-right: 3px;\n  font-weight: 100;\n  font-size: 15px;\n}\n.infinity-loader[data-v-000966c7] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  -webkit-transform-origin: bottom center;\n          transform-origin: bottom center;\n  text-align: center;\n  font-size: 18px;\n  line-height: 40px;\n  z-index: 100;\n}\n.margin-B-s[data-v-000966c7] {\n  margin-bottom: 5px;\n}\n.margin-B-m[data-v-000966c7] {\n  margin-bottom: 10px;\n}\n.margin-T-l[data-v-000966c7] {\n  margin-top: 15px;\n}\n.slide-up-enter-active[data-v-000966c7], .slide-up-leave-active[data-v-000966c7] {\n  -webkit-transition: all .6s ease;\n  transition: all .6s ease;\n}\n.slide-up-enter[data-v-000966c7], .slide-up-leave-to[data-v-000966c7] {\n  -webkit-transform: translateY(30px);\n          transform: translateY(30px);\n  opacity: 0;\n}\n.slide-down-enter-active[data-v-000966c7], .slide-down-leave-active[data-v-000966c7] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-000966c7], .slide-down-leave-to[data-v-000966c7] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.expand-enter-active[data-v-000966c7], .expand-leave-active[data-v-000966c7] {\n  -webkit-transition: all .1s ease;\n  transition: all .1s ease;\n}\n.expand-enter[data-v-000966c7], .expand-leave-to[data-v-000966c7] {\n  -webkit-transform: scale(0.95);\n          transform: scale(0.95);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.collapsible .content[data-v-000966c7] {\n    max-height: 920px;\n}\n.password-box .medium-6[data-v-000966c7] {\n    width: 50%;\n    padding: 0;\n}\n.left-panel[data-v-000966c7] {\n    width: 100%;\n    padding-bottom: 100px;\n}\n.left-panel .heading[data-v-000966c7] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n}\n.left-panel .heading .cons-name[data-v-000966c7] {\n        padding: 0 15px 0 15px;\n        width: 140px;\n}\n.left-panel .heading .switch[data-v-000966c7] {\n        display: block;\n        padding-top: 5px;\n        padding-left: 10px;\n        padding-right: 50px;\n        padding-top: 1px;\n}\n.left-panel .heading .prov-options[data-v-000966c7] {\n        position: absolute;\n        right: 0;\n        top: 15px;\n}\n.left-panel .tab[data-v-000966c7] {\n      margin: 35px 0 0;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      overflow-x: scroll;\n}\n.left-panel .tab li[data-v-000966c7] {\n        width: auto;\n}\n.toggle-mobile[data-v-000966c7] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.right-panel[data-v-000966c7] {\n    z-index: 1;\n    width: 100%;\n    top: 100%;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n}\n.right-panel.mobile-right-panel[data-v-000966c7] {\n      top: 0;\n      z-index: 2;\n}\n.right-panel.mobile-right-panel .tab[data-v-000966c7] {\n        margin-top: 70px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        overflow-x: scroll;\n}\n.right-panel.mobile-right-panel .tab li[data-v-000966c7] {\n          font-size: 13px;\n}\n.right-panel.mobile-right-panel .tab-contents[data-v-000966c7] {\n        width: 100%;\n        height: calc(100vh - 142px);\n        overflow-y: scroll;\n}\n.right-panel.mobile-right-panel .tab-contents .tab-content[data-v-000966c7] {\n          padding-bottom: 60px;\n}\n.right-panel.mobile-right-panel .tab-contents .tab-content.history-panel[data-v-000966c7] {\n            padding: 0;\n            padding-top: 20px;\n            padding-bottom: 60px;\n}\n.right-panel.mobile-right-panel .tab-contents .fixed-footer[data-v-000966c7] {\n          width: 100%;\n          bottom: 45px;\n          background: #fff;\n          color: #000;\n          border-top: 1px solid #aaa;\n}\n.right-panel.mobile-right-panel .logs-panel[data-v-000966c7] {\n        width: 100%;\n}\n.fix-buttons[data-v-000966c7] {\n    width: 100%;\n    bottom: 45px;\n}\n.fix-buttons a[data-v-000966c7] {\n      margin: 0 auto;\n}\n.toggle-panel .heading[data-v-000966c7] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionFilter_vue__ = __webpack_require__(419);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_802d0456_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionFilter_vue__ = __webpack_require__(1180);
function injectStyle (ssrContext) {
  __webpack_require__(1178)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-802d0456"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_802d0456_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1179);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("7724574b", content, true, {});

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.clearfix[data-v-802d0456] {\n  clear: both;\n}\n.field-label[data-v-802d0456] {\n  font-size: 13px;\n  color: #777;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.filter[data-v-802d0456] {\n  padding-bottom: 30px;\n}\n.filter .row[data-v-802d0456] {\n    max-width: inherit;\n    width: 100%;\n    margin: 0;\n}\n.filter .column[data-v-802d0456]:not(:last-child) {\n    padding-right: 20px;\n}\n.filter .status[data-v-802d0456] {\n    display: inline-block;\n    padding: 20px 15px;\n    width: 150px;\n}\n.search-box[data-v-802d0456] {\n  display: block;\n  position: relative;\n}\n.search-box .error-msg[data-v-802d0456] {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.search[data-v-802d0456] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.search .search-input-box[data-v-802d0456] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-802d0456] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 3px 0 0 2px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-802d0456] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-802d0456] {\n      position: absolute;\n      top: 50%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n}\n.search button[data-v-802d0456] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 3px 2px 0;\n    padding: 0 20px;\n}\nselect[data-v-802d0456] {\n  padding: 10px;\n  height: 46px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-802d0456] {\n    background-color: #ebebe4;\n}\n.date-range[data-v-802d0456] {\n  position: relative;\n  display: inline-block;\n}\n.date-range select[data-v-802d0456] {\n    width: 150px;\n    margin-right: 5px;\n}\n.date-range .error-msg[data-v-802d0456] {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.date-range .datepicker-div[data-v-802d0456] {\n    display: inline-block;\n}\n.datepicker-box[data-v-802d0456] {\n  display: inline-block;\n  width: 110px;\n}\n.export[data-v-802d0456] {\n  text-align: right;\n  padding: 15px 10px 0;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 130px;\n          flex: 0 130px;\n}\n.modal[data-v-802d0456] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.modal .bg-overlay[data-v-802d0456] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n.modal .modal-content[data-v-802d0456] {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    padding: 15px 25px;\n    background: #fff;\n    text-align: center;\n    border-radius: 6px;\n    margin-left: -200px;\n    margin-top: -108px;\n    -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal .modal-content.upload[data-v-802d0456] {\n      top: 50%;\n      width: 900px;\n      height: 550px;\n      margin-top: -265px;\n      margin-left: -450px;\n}\n.modal.show[data-v-802d0456] {\n    display: block;\n}\n.modal.show .modal-content[data-v-802d0456] {\n      display: block;\n      -webkit-animation: slide-down .3s ease-out;\n      -moz-animation: slide-down .3s ease-out;\n}\n.modal .header[data-v-802d0456] {\n    font-size: 24px;\n    font-weight: 600;\n    margin-bottom: 15px;\n    color: #606060;\n}\n.modal .has-error[data-v-802d0456] {\n    color: #f00;\n    background: #ffefef;\n    border: 1px solid #f00;\n    margin-bottom: 10px;\n    border-radius: 2px;\n    font-size: 15px;\n    line-height: 1.6;\n}\n.modal .close[data-v-802d0456] {\n    display: block;\n    margin-top: 5px;\n    font-size: 14px;\n    color: #999;\n    cursor: pointer;\n}\n.modal .close[data-v-802d0456]:hover {\n      text-decoration: underline;\n      color: #555;\n}\n.data-field[data-v-802d0456] {\n  padding: 5px;\n  position: relative;\n}\n.data-field .label[data-v-802d0456] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .label.has-error[data-v-802d0456] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-802d0456] {\n    margin: 1px 0 0;\n    padding: 5px;\n    font-size: 14px;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-802d0456] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-802d0456]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-802d0456] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.invoice-box[data-v-802d0456] {\n  width: 500px;\n}\n.invoice-box .row[data-v-802d0456] {\n    margin-bottom: 20px;\n}\n.invoice-box .data-field[data-v-802d0456] {\n    margin-bottom: 10px;\n    text-align: left;\n}\n.padding-R-s[data-v-802d0456] {\n  padding-right: 5px;\n}\n.padding-L-s[data-v-802d0456] {\n  padding-left: 5px;\n}\n.margin-B-m[data-v-802d0456] {\n  margin-bottom: 10px;\n}\n.slide-up-enter-active[data-v-802d0456], .slide-up-leave-active[data-v-802d0456] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-802d0456], .slide-up-leave-to[data-v-802d0456] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.filter .column[data-v-802d0456]:not(:last-child) {\n    padding-right: 0;\n    margin-bottom: 10px;\n}\n.export[data-v-802d0456] {\n    text-align: center;\n    padding: 0;\n}\n.export a[data-v-802d0456] {\n      width: 100%;\n}\n.date-range select[data-v-802d0456] {\n    width: 100%;\n}\n.date-range .datepicker-div[data-v-802d0456] {\n    margin-top: 5px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    gap: 10px;\n}\n.date-range .datepicker-div .datepicker-box[data-v-802d0456] {\n      width: 100%;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Corporate/TransactionFilter.vue"],"names":[],"mappings":";AACA;EACE,YAAY;CACb;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;IACI,mBAAmB;IACnB,YAAY;IACZ,UAAU;CACb;AACD;IACI,oBAAoB;CACvB;AACD;IACI,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;CAChB;AACD;EACE,eAAe;EACf,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;CACb;AACD;IACI,YAAY;IACZ,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,uBAAuB;MACvB,cAAc;MACd,2BAA2B;MAC3B,oBAAoB;CACzB;AACD;QACQ,sBAAsB;CAC7B;AACD;MACM,mBAAmB;MACnB,SAAS;MACT,oCAAoC;cAC5B,4BAA4B;MACpC,WAAW;MACX,eAAe;MACf,gBAAgB;CACrB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;CACnB;AACD;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,+BAA+B;CAChC;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,mBAAmB;EACnB,sBAAsB;CACvB;AACD;IACI,aAAa;IACb,kBAAkB;CACrB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;IACI,sBAAsB;CACzB;AACD;EACE,sBAAsB;EACtB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;MAChB,kBAAkB;UACd,cAAc;CACvB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,YAAY;CACb;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;CAChB;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,uDAAuD;YAC/C,+CAA+C;IACvD,cAAc;CACjB;AACD;MACM,SAAS;MACT,aAAa;MACb,cAAc;MACd,mBAAmB;MACnB,oBAAoB;CACzB;AACD;IACI,eAAe;CAClB;AACD;MACM,eAAe;MACf,2CAA2C;MAC3C,wCAAwC;CAC7C;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;CAClB;AACD;IACI,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;CACpB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;CACnB;AACD;MACM,2BAA2B;MAC3B,YAAY;CACjB;AACD;EACE,aAAa;EACb,mBAAmB;CACpB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;MACM,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;EACE,aAAa;CACd;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;IACpB,iBAAiB;CACpB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;AACA;IACI,iBAAiB;IACjB,oBAAoB;CACvB;AACD;IACI,mBAAmB;IACnB,WAAW;CACd;AACD;MACM,YAAY;CACjB;AACD;IACI,YAAY;CACf;AACD;IACI,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,UAAU;CACb;AACD;MACM,YAAY;CACjB;CACA","file":"TransactionFilter.vue","sourcesContent":["\n.clearfix[data-v-802d0456] {\n  clear: both;\n}\n.field-label[data-v-802d0456] {\n  font-size: 13px;\n  color: #777;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.filter[data-v-802d0456] {\n  padding-bottom: 30px;\n}\n.filter .row[data-v-802d0456] {\n    max-width: inherit;\n    width: 100%;\n    margin: 0;\n}\n.filter .column[data-v-802d0456]:not(:last-child) {\n    padding-right: 20px;\n}\n.filter .status[data-v-802d0456] {\n    display: inline-block;\n    padding: 20px 15px;\n    width: 150px;\n}\n.search-box[data-v-802d0456] {\n  display: block;\n  position: relative;\n}\n.search-box .error-msg[data-v-802d0456] {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.search[data-v-802d0456] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.search .search-input-box[data-v-802d0456] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-802d0456] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 3px 0 0 2px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-802d0456] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-802d0456] {\n      position: absolute;\n      top: 50%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n}\n.search button[data-v-802d0456] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 3px 2px 0;\n    padding: 0 20px;\n}\nselect[data-v-802d0456] {\n  padding: 10px;\n  height: 46px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-802d0456] {\n    background-color: #ebebe4;\n}\n.date-range[data-v-802d0456] {\n  position: relative;\n  display: inline-block;\n}\n.date-range select[data-v-802d0456] {\n    width: 150px;\n    margin-right: 5px;\n}\n.date-range .error-msg[data-v-802d0456] {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.date-range .datepicker-div[data-v-802d0456] {\n    display: inline-block;\n}\n.datepicker-box[data-v-802d0456] {\n  display: inline-block;\n  width: 110px;\n}\n.export[data-v-802d0456] {\n  text-align: right;\n  padding: 15px 10px 0;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 130px;\n          flex: 0 130px;\n}\n.modal[data-v-802d0456] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.modal .bg-overlay[data-v-802d0456] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n.modal .modal-content[data-v-802d0456] {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    padding: 15px 25px;\n    background: #fff;\n    text-align: center;\n    border-radius: 6px;\n    margin-left: -200px;\n    margin-top: -108px;\n    -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal .modal-content.upload[data-v-802d0456] {\n      top: 50%;\n      width: 900px;\n      height: 550px;\n      margin-top: -265px;\n      margin-left: -450px;\n}\n.modal.show[data-v-802d0456] {\n    display: block;\n}\n.modal.show .modal-content[data-v-802d0456] {\n      display: block;\n      -webkit-animation: slide-down .3s ease-out;\n      -moz-animation: slide-down .3s ease-out;\n}\n.modal .header[data-v-802d0456] {\n    font-size: 24px;\n    font-weight: 600;\n    margin-bottom: 15px;\n    color: #606060;\n}\n.modal .has-error[data-v-802d0456] {\n    color: #f00;\n    background: #ffefef;\n    border: 1px solid #f00;\n    margin-bottom: 10px;\n    border-radius: 2px;\n    font-size: 15px;\n    line-height: 1.6;\n}\n.modal .close[data-v-802d0456] {\n    display: block;\n    margin-top: 5px;\n    font-size: 14px;\n    color: #999;\n    cursor: pointer;\n}\n.modal .close[data-v-802d0456]:hover {\n      text-decoration: underline;\n      color: #555;\n}\n.data-field[data-v-802d0456] {\n  padding: 5px;\n  position: relative;\n}\n.data-field .label[data-v-802d0456] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .label.has-error[data-v-802d0456] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-802d0456] {\n    margin: 1px 0 0;\n    padding: 5px;\n    font-size: 14px;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-802d0456] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-802d0456]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-802d0456] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.invoice-box[data-v-802d0456] {\n  width: 500px;\n}\n.invoice-box .row[data-v-802d0456] {\n    margin-bottom: 20px;\n}\n.invoice-box .data-field[data-v-802d0456] {\n    margin-bottom: 10px;\n    text-align: left;\n}\n.padding-R-s[data-v-802d0456] {\n  padding-right: 5px;\n}\n.padding-L-s[data-v-802d0456] {\n  padding-left: 5px;\n}\n.margin-B-m[data-v-802d0456] {\n  margin-bottom: 10px;\n}\n.slide-up-enter-active[data-v-802d0456], .slide-up-leave-active[data-v-802d0456] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-802d0456], .slide-up-leave-to[data-v-802d0456] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.filter .column[data-v-802d0456]:not(:last-child) {\n    padding-right: 0;\n    margin-bottom: 10px;\n}\n.export[data-v-802d0456] {\n    text-align: center;\n    padding: 0;\n}\n.export a[data-v-802d0456] {\n      width: 100%;\n}\n.date-range select[data-v-802d0456] {\n    width: 100%;\n}\n.date-range .datepicker-div[data-v-802d0456] {\n    margin-top: 5px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    gap: 10px;\n}\n.date-range .datepicker-div .datepicker-box[data-v-802d0456] {\n      width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"filter"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column medium-3"},[_c('div',{staticClass:"search-box"},[_c('label',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.$t('transactions.filter.search'))+":")]),_vm._v(" "),_c('div',{staticClass:"search"},[_c('div',{staticClass:"search-input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],ref:"search",class:{'has-error':!!_vm.hasError.searchMsg},attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.searchInput)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search.apply(null, arguments)},"blur":_vm.blurSearch,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchInput.length > 0),expression:"searchInput.length > 0"}],staticClass:"far fa-times-circle fa-lg",on:{"click":_vm.clearSearch}})])],1),_vm._v(" "),_c('button',{class:{'button xsmall success':true, 'disabled':_vm.loading},on:{"click":_vm.search}},[_c('i',{staticClass:"fas fa-search fa-lg"})])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.hasError.searchMsg),expression:"!!hasError.searchMsg"}],staticClass:"error-msg"},[_vm._v(_vm._s(_vm.hasError.searchMsg))])])],1)]),_vm._v(" "),_c('div',{staticClass:"column medium-2"},[_c('label',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.$t('transactions.filter.status'))+":")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('transactions.filter.all')))]),_vm._v(" "),_c('option',{attrs:{"value":"Declined"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.declined')))]),_vm._v(" "),_c('option',{attrs:{"value":"Cancelled"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.cancelled')))]),_vm._v(" "),_c('option',{attrs:{"value":"Purchased"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.purchased')))]),_vm._v(" "),_c('option',{attrs:{"value":"Promo"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.promo')))]),_vm._v(" "),_c('option',{attrs:{"value":"Authorized"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.authorized')))]),_vm._v(" "),_c('option',{attrs:{"value":"No Show"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.noShow')))]),_vm._v(" "),_c('option',{attrs:{"value":"Completed"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.completed')))]),_vm._v(" "),_c('option',{attrs:{"value":"Refund"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.refund')))]),_vm._v(" "),_c('option',{attrs:{"value":"Edited"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.edited')))])])]),_vm._v(" "),_c('div',{staticClass:"column medium-5"},[_c('div',{staticClass:"date-range"},[_c('label',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.$t('transactions.filter.dateRange'))+":")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateType),expression:"dateType"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dateType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.all')))]),_vm._v(" "),_c('option',{attrs:{"value":"custom"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.custom')))]),_vm._v(" "),_c('option',{attrs:{"value":"withinDay"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.withinDay')))]),_vm._v(" "),_c('option',{attrs:{"value":"monthToDate"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.monthToDate')))]),_vm._v(" "),_c('option',{attrs:{"value":"lastMonth"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.lastMonth')))]),_vm._v(" "),_c('option',{attrs:{"value":"lastWeek"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.lastWeek')))]),_vm._v(" "),_c('option',{attrs:{"value":"last2Week"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.last2Week')))]),_vm._v(" "),_c('option',{attrs:{"value":"last30Days"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.last30Days')))]),_vm._v(" "),_c('option',{attrs:{"value":"last60Days"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.last60Days')))]),_vm._v(" "),_c('option',{attrs:{"value":"last90Days"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.last90Days')))])]),_vm._v(" "),_c('div',{staticClass:"datepicker-div"},[_c('div',{staticClass:"datepicker-box"},[_c('datepicker',{ref:"datepickerFrom",class:{'datepicker inline':true, 'has-error':false},attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"input-class":{'datepicker-empty':_vm.hasError.from},"placeholder":_vm.$t('transactions.filter.from')},on:{"input":function($event){return _vm.updateFromTo('from')}},model:{value:(_vm.date.from),callback:function ($$v) {_vm.$set(_vm.date, "from", $$v)},expression:"date.from"}})],1),_vm._v(" "),_c('div',{staticClass:"datepicker-box"},[_c('datepicker',{ref:"datepickerTo",staticClass:"datepicker inline",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"input-class":{'datepicker-empty':_vm.hasError.to},"placeholder":_vm.$t('transactions.filter.to')},on:{"input":function($event){return _vm.updateFromTo('to')}},model:{value:(_vm.date.to),callback:function ($$v) {_vm.$set(_vm.date, "to", $$v)},expression:"date.to"}})],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.hasError.fromToMsg),expression:"!!hasError.fromToMsg"}],staticClass:"error-msg"},[_vm._v("\n              "+_vm._s(_vm.hasError.fromToMsg)+"\n            ")])])],1)]),_vm._v(" "),_c('div',{staticClass:"column medium-2"},[_c('div',{staticClass:"export"},[_c('a',{class:{'button cta success small':true, 'disabled':!_vm.transactions.length || _vm.loading},on:{"click":_vm.exportTrx}},[_vm._v(_vm._s(_vm.$t('transactions.filter.export')))])])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.invoice.showModal}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeInvoice}}),_vm._v(" "),_c('div',{staticClass:"modal-content invoice-box"},[_c('div',{staticClass:"header"},[_vm._v("Create Invoice")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column medium-6 padding-R-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Date Coverage From")]),_vm._v(" "),_c('datepicker',{class:{'datepicker inline':true, 'has-error':!!_vm.invoice.error.dateFrom},attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.exportLoading,"input-class":{'datepicker-empty':_vm.invoice.error.dateFrom}},model:{value:(_vm.invoice.dateFrom),callback:function ($$v) {_vm.$set(_vm.invoice, "dateFrom", $$v)},expression:"invoice.dateFrom"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.invoice.error.dateFrom))])],1)]),_vm._v(" "),_c('div',{staticClass:"column medium-6 padding-L-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Date Coverage To")]),_vm._v(" "),_c('datepicker',{class:{'datepicker inline':true, 'has-error':!!_vm.invoice.error.dateTo},attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.exportLoading,"input-class":{'datepicker-empty':_vm.invoice.error.dateTo}},model:{value:(_vm.invoice.dateTo),callback:function ($$v) {_vm.$set(_vm.invoice, "dateTo", $$v)},expression:"invoice.dateTo"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.invoice.error.dateTo))])],1)]),_vm._v(" "),_c('div',{staticClass:"column medium-12"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Payment Due Date")]),_vm._v(" "),_c('datepicker',{class:{'datepicker inline':true, 'has-error':!!_vm.invoice.error.dueDate},attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.exportLoading,"input-class":{'datepicker-empty':_vm.invoice.error.dueDate},"disabled":_vm.disabledDueDate},model:{value:(_vm.invoice.dueDate),callback:function ($$v) {_vm.$set(_vm.invoice, "dueDate", $$v)},expression:"invoice.dueDate"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.invoice.error.dueDate))])],1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.invoice.showZeroResults),expression:"invoice.showZeroResults"}],staticClass:"has-error"},[_vm._v("Empty result.")]),_vm._v(" "),_c('button',{class:{'button cta block small':true, 'disabled':_vm.invoiceLoading},on:{"click":_vm.createInvoice}},[(!_vm.invoiceLoading)?_c('span',[_vm._v("Create")]):_c('span',[_vm._v("Loading...")])]),_vm._v(" "),_c('span',{staticClass:"close",on:{"click":_vm.closeInvoice}},[_vm._v("Close")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionList_vue__ = __webpack_require__(421);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f65c306a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionList_vue__ = __webpack_require__(1184);
function injectStyle (ssrContext) {
  __webpack_require__(1182)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f65c306a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f65c306a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1183);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2fce44a2", content, true, {});

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.trx-list[data-v-f65c306a] {\n  position: relative;\n}\n.sticky[data-v-f65c306a] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  height: 44px;\n  z-index: 3;\n}\n.sticky .scroll-table[data-v-f65c306a]::-webkit-scrollbar {\n    visibility: hidden;\n}\n.sticky tbody[data-v-f65c306a] {\n    visibility: hidden;\n}\n.scroll-table[data-v-f65c306a] {\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: 100vh;\n  max-height: calc(100vh - 240px);\n}\n.scroll-table.two-line-filter[data-v-f65c306a] {\n    max-height: calc(100vh - 285px);\n}\ntable[data-v-f65c306a] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-f65c306a] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-f65c306a] {\n      padding: 5px 10px;\n}\ntable thead th[data-v-f65c306a]:last-child {\n        cursor: default;\n}\ntable thead th i[data-v-f65c306a] {\n        display: none;\n}\ntable thead th i.stripe-icon[data-v-f65c306a] {\n        display: inline;\n}\ntable thead th .fa-sort-up[data-v-f65c306a] {\n        vertical-align: -2px;\n}\ntable thead th .fa-sort-down[data-v-f65c306a] {\n        vertical-align: 2px;\n}\ntable thead th.sortable[data-v-f65c306a] {\n        cursor: pointer;\n        color: #333;\n}\ntable thead th.sortable span[data-v-f65c306a] {\n          font-weight: 600;\n          text-decoration: underline;\n}\ntable thead th.sort i[data-v-f65c306a] {\n        display: inline-block;\n}\ntable tbody tr[data-v-f65c306a] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr[data-v-f65c306a]:nth-child(even) {\n      background: #f3f3f3;\n}\ntable tbody tr[data-v-f65c306a]:hover {\n      background: #d7dbe4;\n}\ntable tbody tr td[data-v-f65c306a] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      color: #555;\n}\ntable tbody tr td.status[data-v-f65c306a], table tbody tr td.bookedThrough[data-v-f65c306a] {\n        font-weight: 600;\n}\ntable tbody tr td.table-block[data-v-f65c306a] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-f65c306a] {\n          color: #ccc;\n}\ntable tbody tr td a[data-v-f65c306a] {\n        font-weight: 600;\n        text-decoration: underline;\n        cursor: pointer;\n}\n.rsvp-type[data-v-f65c306a] {\n  text-transform: uppercase;\n  padding: 3px 5px;\n  color: #fff;\n  border-radius: 4px;\n}\n.rsvp-type.rsvp[data-v-f65c306a] {\n    background: #5771d0;\n}\n.rsvp-type.asap[data-v-f65c306a] {\n    background: #d05757;\n}\n.rsvp-type.package[data-v-f65c306a] {\n    background: #26d97a;\n}\n.booked-label[data-v-f65c306a] {\n  padding: 3px 5px;\n  background: #ccc;\n  color: #fff;\n  border-radius: 3px;\n  font-size: 12px;\n  font-weight: 700;\n}\n.booked-label.Web[data-v-f65c306a] {\n    background: #a26d5d;\n}\n.booked-label.Admin[data-v-f65c306a] {\n    background: #2b83f1;\n}\n.booked-label.Android[data-v-f65c306a] {\n    background: #78c259;\n}\n.booked-label.iOS[data-v-f65c306a] {\n    background: #7fc8de;\n}\n.booked-label.CSR[data-v-f65c306a] {\n    background: #bb4a91;\n}\n.booked-label.Provider[data-v-f65c306a] {\n    background: #3f3f3f;\n}\n.status-label[data-v-f65c306a] {\n  line-height: 1;\n  color: #fff;\n  padding: 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 11px !important;\n  background: #999;\n  display: inline-block;\n}\n.status-label.Purchased[data-v-f65c306a], .status-label.Purchase[data-v-f65c306a] {\n    background: #4aadf3;\n}\n.status-label.Completed[data-v-f65c306a] {\n    background: #26D97A;\n}\n.status-label.Promo[data-v-f65c306a] {\n    background: #f3904a;\n}\n.status-label.Edited[data-v-f65c306a], .status-label.Refund[data-v-f65c306a] {\n    background: #797979;\n}\n.status-label.No.Show[data-v-f65c306a], .status-label.Cancelled[data-v-f65c306a], .status-label.Declined[data-v-f65c306a] {\n    background: #f54f4f;\n}\n.status-label.Pending.Refund[data-v-f65c306a] {\n    background: #098769;\n    color: #fff;\n}\n.status-label.NOT_PROCESSED[data-v-f65c306a] {\n    background: #FFCC00 !important;\n    color: #505050 !important;\n}\n.fix-footer[data-v-f65c306a] {\n  width: 100%;\n  height: 60px;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-f65c306a] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-f65c306a] {\n    max-width: 100px;\n}\n.fix-footer .per-page[data-v-f65c306a] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .per-page span[data-v-f65c306a] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-f65c306a] {\n    text-align: center;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .pagination[data-v-f65c306a] {\n    text-align: right;\n    padding: 15px 10px;\n}\n.fix-footer .pagination.prev-next[data-v-f65c306a] {\n      text-align: center;\n}\n.fix-footer .pagination span[data-v-f65c306a] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-f65c306a] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-f65c306a] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-f65c306a] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-f65c306a] {\n        opacity: .4;\n        cursor: default;\n}\n.slide-up-enter-active[data-v-f65c306a], .slide-up-leave-active[data-v-f65c306a] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-f65c306a], .slide-up-leave-to[data-v-f65c306a] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.rsvp-type[data-v-f65c306a] {\n    font-size: 12px;\n    margin-right: 5px;\n}\n.fix-footer .row[data-v-f65c306a] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.fix-footer .per-page[data-v-f65c306a] {\n    width: auto;\n}\n.fix-footer .per-page select[data-v-f65c306a] {\n      width: 55px;\n}\n.fix-footer .per-page span[data-v-f65c306a]:nth-child(3) {\n      display: none;\n}\n.fix-footer .page-data[data-v-f65c306a] {\n    display: none;\n}\n.fix-footer .pagination[data-v-f65c306a] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    padding: 15px 0px;\n}\n.fix-footer .pagination select[data-v-f65c306a] {\n      width: 55px;\n}\n.loader[data-v-f65c306a], .empty-result[data-v-f65c306a] {\n    text-align: center;\n    padding: 50px 0;\n}\n.cards .card[data-v-f65c306a] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.cards .card .info[data-v-f65c306a] {\n      width: 100%;\n      padding-left: 10px;\n}\n.cards .card > div[data-v-f65c306a] {\n      margin-bottom: 3px;\n      width: 100%;\n}\n.cards .card .email-logo img[data-v-f65c306a] {\n      max-width: 100px;\n      max-height: 100px;\n}\n.cards .card .card-header[data-v-f65c306a] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n}\n.cards .card .card-header .time[data-v-f65c306a] {\n        font-size: 12px;\n        color: #777;\n        word-spacing: 5px;\n}\n.cards .card .card-header .amount[data-v-f65c306a] {\n        font-weight: 900;\n        font-size: 20px;\n}\n.cards .card .card-header .amount a[data-v-f65c306a] {\n          text-decoration: none;\n}\n.cards .card .credit-card[data-v-f65c306a] {\n      font-weight: 900;\n}\n.cards .card .title[data-v-f65c306a] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      margin-bottom: 3px;\n}\n.cards .card .title.pkg-div[data-v-f65c306a] {\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n}\n.cards .card .title .pkg-type[data-v-f65c306a] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.cards .card .title input[data-v-f65c306a] {\n        margin-right: 5px;\n}\n.cards .card .title.view[data-v-f65c306a] {\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        padding-top: 7px;\n        padding-bottom: 5px;\n        border-top: 1px solid #eee;\n}\n.cards .card .title .refer[data-v-f65c306a] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.cards .card .label[data-v-f65c306a] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-f65c306a] {\n      margin-right: 10px;\n      font-size: 13px;\n      font-weight: 900;\n}\n.cards .card .value i[data-v-f65c306a] {\n        color: #bbb;\n}\n.cards .card .value a[data-v-f65c306a] {\n        text-decoration: none;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Corporate/TransactionList.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,WAAW;CACZ;AACD;IACI,mBAAmB;CACtB;AACD;IACI,mBAAmB;CACtB;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;CACjC;AACD;IACI,gCAAgC;CACnC;AACD;EACE,0BAA0B;EAC1B,YAAY;CACb;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;QACQ,gBAAgB;CACvB;AACD;QACQ,cAAc;CACrB;AACD;QACQ,gBAAgB;CACvB;AACD;QACQ,qBAAqB;CAC5B;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,gBAAgB;QAChB,YAAY;CACnB;AACD;UACU,iBAAiB;UACjB,2BAA2B;CACpC;AACD;QACQ,sBAAsB;CAC7B;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,YAAY;CACjB;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;QACQ,iBAAiB;QACjB,2BAA2B;QAC3B,gBAAgB;CACvB;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;CAClB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;IACpB,YAAY;CACf;AACD;IACI,+BAA+B;IAC/B,0BAA0B;CAC7B;AACD;EACE,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;CACb;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;CACnB;AACD;MACM,sBAAsB;MACtB,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;CACnB;AACD;IACI,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,sBAAsB;MACtB,kBAAkB;CACvB;AACD;MACM,aAAa;MACb,uBAAuB;CAC5B;AACD;MACM,cAAc;MACd,eAAe;MACf,uBAAuB;MACvB,iBAAiB;MACjB,gBAAgB;MAChB,uBAAuB;MACvB,aAAa;CAClB;AACD;QACQ,kBAAkB;CACzB;AACD;QACQ,YAAY;QACZ,gBAAgB;CACvB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;AACA;IACI,gBAAgB;IAChB,kBAAkB;CACrB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,0BAA0B;QACtB,uBAAuB;YACnB,+BAA+B;CAC1C;AACD;IACI,YAAY;CACf;AACD;MACM,YAAY;CACjB;AACD;MACM,cAAc;CACnB;AACD;IACI,cAAc;CACjB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;IAC5B,kBAAkB;CACrB;AACD;MACM,YAAY;CACjB;AACD;IACI,mBAAmB;IACnB,gBAAgB;CACnB;AACD;IACI,uBAAuB;IACvB,oBAAoB;IACpB,aAAa;IACb,oBAAoB;IACpB,+BAA+B;IAC/B,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,6BAA6B;IAC7B,8BAA8B;QAC1B,2BAA2B;YACvB,uBAAuB;CAClC;AACD;MACM,YAAY;MACZ,mBAAmB;CACxB;AACD;MACM,mBAAmB;MACnB,YAAY;CACjB;AACD;MACM,iBAAiB;MACjB,kBAAkB;CACvB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,uBAAuB;UACnB,oBAAoB;cAChB,sBAAsB;CACnC;AACD;QACQ,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;CACzB;AACD;QACQ,iBAAiB;QACjB,gBAAgB;CACvB;AACD;UACU,sBAAsB;CAC/B;AACD;MACM,iBAAiB;CACtB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;MAC5B,mBAAmB;CACxB;AACD;QACQ,0BAA0B;YACtB,uBAAuB;gBACnB,+BAA+B;CAC9C;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;CACrB;AACD;QACQ,kBAAkB;CACzB;AACD;QACQ,0BAA0B;YACtB,uBAAuB;gBACnB,+BAA+B;QACvC,iBAAiB;QACjB,oBAAoB;QACpB,2BAA2B;CAClC;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;CACrB;AACD;MACM,gBAAgB;MAChB,0BAA0B;MAC1B,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;CACvB;AACD;MACM,mBAAmB;MACnB,gBAAgB;MAChB,iBAAiB;CACtB;AACD;QACQ,YAAY;CACnB;AACD;QACQ,sBAAsB;CAC7B;CACA","file":"TransactionList.vue","sourcesContent":["\n.trx-list[data-v-f65c306a] {\n  position: relative;\n}\n.sticky[data-v-f65c306a] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  height: 44px;\n  z-index: 3;\n}\n.sticky .scroll-table[data-v-f65c306a]::-webkit-scrollbar {\n    visibility: hidden;\n}\n.sticky tbody[data-v-f65c306a] {\n    visibility: hidden;\n}\n.scroll-table[data-v-f65c306a] {\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: 100vh;\n  max-height: calc(100vh - 240px);\n}\n.scroll-table.two-line-filter[data-v-f65c306a] {\n    max-height: calc(100vh - 285px);\n}\ntable[data-v-f65c306a] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-f65c306a] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-f65c306a] {\n      padding: 5px 10px;\n}\ntable thead th[data-v-f65c306a]:last-child {\n        cursor: default;\n}\ntable thead th i[data-v-f65c306a] {\n        display: none;\n}\ntable thead th i.stripe-icon[data-v-f65c306a] {\n        display: inline;\n}\ntable thead th .fa-sort-up[data-v-f65c306a] {\n        vertical-align: -2px;\n}\ntable thead th .fa-sort-down[data-v-f65c306a] {\n        vertical-align: 2px;\n}\ntable thead th.sortable[data-v-f65c306a] {\n        cursor: pointer;\n        color: #333;\n}\ntable thead th.sortable span[data-v-f65c306a] {\n          font-weight: 600;\n          text-decoration: underline;\n}\ntable thead th.sort i[data-v-f65c306a] {\n        display: inline-block;\n}\ntable tbody tr[data-v-f65c306a] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr[data-v-f65c306a]:nth-child(even) {\n      background: #f3f3f3;\n}\ntable tbody tr[data-v-f65c306a]:hover {\n      background: #d7dbe4;\n}\ntable tbody tr td[data-v-f65c306a] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      color: #555;\n}\ntable tbody tr td.status[data-v-f65c306a], table tbody tr td.bookedThrough[data-v-f65c306a] {\n        font-weight: 600;\n}\ntable tbody tr td.table-block[data-v-f65c306a] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-f65c306a] {\n          color: #ccc;\n}\ntable tbody tr td a[data-v-f65c306a] {\n        font-weight: 600;\n        text-decoration: underline;\n        cursor: pointer;\n}\n.rsvp-type[data-v-f65c306a] {\n  text-transform: uppercase;\n  padding: 3px 5px;\n  color: #fff;\n  border-radius: 4px;\n}\n.rsvp-type.rsvp[data-v-f65c306a] {\n    background: #5771d0;\n}\n.rsvp-type.asap[data-v-f65c306a] {\n    background: #d05757;\n}\n.rsvp-type.package[data-v-f65c306a] {\n    background: #26d97a;\n}\n.booked-label[data-v-f65c306a] {\n  padding: 3px 5px;\n  background: #ccc;\n  color: #fff;\n  border-radius: 3px;\n  font-size: 12px;\n  font-weight: 700;\n}\n.booked-label.Web[data-v-f65c306a] {\n    background: #a26d5d;\n}\n.booked-label.Admin[data-v-f65c306a] {\n    background: #2b83f1;\n}\n.booked-label.Android[data-v-f65c306a] {\n    background: #78c259;\n}\n.booked-label.iOS[data-v-f65c306a] {\n    background: #7fc8de;\n}\n.booked-label.CSR[data-v-f65c306a] {\n    background: #bb4a91;\n}\n.booked-label.Provider[data-v-f65c306a] {\n    background: #3f3f3f;\n}\n.status-label[data-v-f65c306a] {\n  line-height: 1;\n  color: #fff;\n  padding: 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 11px !important;\n  background: #999;\n  display: inline-block;\n}\n.status-label.Purchased[data-v-f65c306a], .status-label.Purchase[data-v-f65c306a] {\n    background: #4aadf3;\n}\n.status-label.Completed[data-v-f65c306a] {\n    background: #26D97A;\n}\n.status-label.Promo[data-v-f65c306a] {\n    background: #f3904a;\n}\n.status-label.Edited[data-v-f65c306a], .status-label.Refund[data-v-f65c306a] {\n    background: #797979;\n}\n.status-label.No.Show[data-v-f65c306a], .status-label.Cancelled[data-v-f65c306a], .status-label.Declined[data-v-f65c306a] {\n    background: #f54f4f;\n}\n.status-label.Pending.Refund[data-v-f65c306a] {\n    background: #098769;\n    color: #fff;\n}\n.status-label.NOT_PROCESSED[data-v-f65c306a] {\n    background: #FFCC00 !important;\n    color: #505050 !important;\n}\n.fix-footer[data-v-f65c306a] {\n  width: 100%;\n  height: 60px;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-f65c306a] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-f65c306a] {\n    max-width: 100px;\n}\n.fix-footer .per-page[data-v-f65c306a] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .per-page span[data-v-f65c306a] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-f65c306a] {\n    text-align: center;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .pagination[data-v-f65c306a] {\n    text-align: right;\n    padding: 15px 10px;\n}\n.fix-footer .pagination.prev-next[data-v-f65c306a] {\n      text-align: center;\n}\n.fix-footer .pagination span[data-v-f65c306a] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-f65c306a] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-f65c306a] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-f65c306a] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-f65c306a] {\n        opacity: .4;\n        cursor: default;\n}\n.slide-up-enter-active[data-v-f65c306a], .slide-up-leave-active[data-v-f65c306a] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-f65c306a], .slide-up-leave-to[data-v-f65c306a] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.rsvp-type[data-v-f65c306a] {\n    font-size: 12px;\n    margin-right: 5px;\n}\n.fix-footer .row[data-v-f65c306a] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.fix-footer .per-page[data-v-f65c306a] {\n    width: auto;\n}\n.fix-footer .per-page select[data-v-f65c306a] {\n      width: 55px;\n}\n.fix-footer .per-page span[data-v-f65c306a]:nth-child(3) {\n      display: none;\n}\n.fix-footer .page-data[data-v-f65c306a] {\n    display: none;\n}\n.fix-footer .pagination[data-v-f65c306a] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    padding: 15px 0px;\n}\n.fix-footer .pagination select[data-v-f65c306a] {\n      width: 55px;\n}\n.loader[data-v-f65c306a], .empty-result[data-v-f65c306a] {\n    text-align: center;\n    padding: 50px 0;\n}\n.cards .card[data-v-f65c306a] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.cards .card .info[data-v-f65c306a] {\n      width: 100%;\n      padding-left: 10px;\n}\n.cards .card > div[data-v-f65c306a] {\n      margin-bottom: 3px;\n      width: 100%;\n}\n.cards .card .email-logo img[data-v-f65c306a] {\n      max-width: 100px;\n      max-height: 100px;\n}\n.cards .card .card-header[data-v-f65c306a] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n}\n.cards .card .card-header .time[data-v-f65c306a] {\n        font-size: 12px;\n        color: #777;\n        word-spacing: 5px;\n}\n.cards .card .card-header .amount[data-v-f65c306a] {\n        font-weight: 900;\n        font-size: 20px;\n}\n.cards .card .card-header .amount a[data-v-f65c306a] {\n          text-decoration: none;\n}\n.cards .card .credit-card[data-v-f65c306a] {\n      font-weight: 900;\n}\n.cards .card .title[data-v-f65c306a] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      margin-bottom: 3px;\n}\n.cards .card .title.pkg-div[data-v-f65c306a] {\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n}\n.cards .card .title .pkg-type[data-v-f65c306a] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.cards .card .title input[data-v-f65c306a] {\n        margin-right: 5px;\n}\n.cards .card .title.view[data-v-f65c306a] {\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        padding-top: 7px;\n        padding-bottom: 5px;\n        border-top: 1px solid #eee;\n}\n.cards .card .title .refer[data-v-f65c306a] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.cards .card .label[data-v-f65c306a] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-f65c306a] {\n      margin-right: 10px;\n      font-size: 13px;\n      font-weight: 900;\n}\n.cards .card .value i[data-v-f65c306a] {\n        color: #bbb;\n}\n.cards .card .value a[data-v-f65c306a] {\n        text-decoration: none;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trx-list"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile),expression:"!isMobile"}],staticClass:"sticky"},[_c('div',{class:{'scroll-table':true, 'two-line-filter':_vm.is2lines}},[_c('table',[_c('thead',[_c('th',{class:{'sortable':true, 'sort':_vm.sort.active ==='created'},on:{"click":function($event){return _vm.sortTable('created')}}},[_vm._v("\n            "+_vm._s(_vm.$t('consumer.transactions.date'))+"\n            "),_c('i',{class:['fas', _vm.sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']})]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.providerId')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.company')))]),_vm._v(" "),_c('th',{class:{'sortable':true, 'sort':_vm.sort.active ==='rsvpId'},on:{"click":function($event){return _vm.sortTable('rsvpId')}}},[_vm._v("\n            "+_vm._s(_vm.$t('consumer.transactions.rsvpId'))+"\n            "),_c('i',{class:['fas', _vm.sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'sort':_vm.sort.active ==='eventId'},on:{"click":function($event){return _vm.sortTable('eventId')}}},[_vm._v("\n            "+_vm._s(_vm.$t('consumer.transactions.invoiceId'))+"\n            "),_c('i',{class:['fas', _vm.sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'sort':_vm.sort.active ==='isAsap'},on:{"click":function($event){return _vm.sortTable('isAsap')}}},[_vm._v("\n            "+_vm._s(_vm.$t('consumer.transactions.type'))+"\n            "),_c('i',{class:['fas', _vm.sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']})]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.creditCard')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.bookedThrough')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.finalOffer')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.chargedAmount')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.promoUsed')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.status')))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.transactions),function(trx){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions.length > 0),expression:"transactions.length > 0"}]},[_c('td',[_vm._v(_vm._s(trx.date))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'/#/provider/' + trx.providerId,"target":"_blank"}},[_vm._v(_vm._s(trx.providerId))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.company))]),_vm._v(" "),_c('td',[(trx.rsvpId !== 0)?_c('a',{attrs:{"href":'/#/reservation/' + trx.rsvpId,"target":"_blank"}},[_vm._v(_vm._s(trx.rsvpId))]):_c('a',{attrs:{"href":'/#/package/' + trx.pkgId,"target":"_blank"}},[_vm._v("\n                "+_vm._s(trx.pkgId)+" "),_c('i',{staticClass:"fa fa-cube"})])]),_vm._v(" "),_c('td',[(trx.trxId !== '0')?_c('span',[_vm._v(_vm._s(trx.trxId))]):_c('span',[_vm._v("--")])]),_vm._v(" "),_c('td',[(trx.pkgId)?_c('span',{staticClass:"package"},[_vm._v("PKG")]):_c('span',{class:['rsvp-type', trx.type]},[_vm._v(_vm._s(trx.type))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.creditCard))]),_vm._v(" "),_c('td',{staticClass:"bookedThrough"},[_c('span',{class:['booked-label', trx.bookedThrough]},[_vm._v(_vm._s(trx.bookedThrough))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.finalOffer))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.chargedAmount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.promoUsed))]),_vm._v(" "),_c('td',{staticClass:"status"},[_c('span',{class:['status-label', trx.statusLabel, trx.notes === 'NOT_PROCESSED' ? 'NOT_PROCESSED' : '']},[_vm._v(_vm._s(trx.statusLabel))])]),_vm._v(" "),_c('td',[(trx.paymentURL === null)?_c('span',[_vm._v("--")]):_c('a',{attrs:{"href":trx.paymentURL,"target":"_blank"}},[_c('i',{staticClass:"fa fa-link"})])])])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile),expression:"!isMobile"}],class:{'scroll-table':true, 'two-line-filter':_vm.is2lines}},[_c('table',{staticClass:"main-table"},[_c('thead',[_c('th',{class:{'sortable':true, 'sort':_vm.sort.active ==='created'},on:{"click":function($event){return _vm.sortTable('created')}}},[_vm._v("\n          "+_vm._s(_vm.$t('consumer.transactions.date'))+"\n          "),_c('i',{class:['fas', _vm.sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']})]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.providerId')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.company')))]),_vm._v(" "),_c('th',{class:{'sortable':true, 'sort':_vm.sort.active ==='rsvpId'},on:{"click":function($event){return _vm.sortTable('rsvpId')}}},[_vm._v("\n          "+_vm._s(_vm.$t('consumer.transactions.rsvpId'))+"\n          "),_c('i',{class:['fas', _vm.sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'sort':_vm.sort.active ==='eventId'},on:{"click":function($event){return _vm.sortTable('eventId')}}},[_vm._v("\n          "+_vm._s(_vm.$t('consumer.transactions.invoiceId'))+"\n          "),_c('i',{class:['fas', _vm.sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'sort':_vm.sort.active ==='isAsap'},on:{"click":function($event){return _vm.sortTable('isAsap')}}},[_vm._v("\n          "+_vm._s(_vm.$t('consumer.transactions.type'))+"\n          "),_c('i',{class:['fas', _vm.sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']})]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.creditCard')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.bookedThrough')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.finalOffer')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.chargedAmount')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.promoUsed')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.transactions.status')))]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('tbody',[_vm._l((_vm.transactions),function(trx){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions.length > 0),expression:"transactions.length > 0"}]},[_c('td',[_vm._v(_vm._s(trx.date))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'/#/provider/' + trx.providerId,"target":"_blank"}},[_vm._v(_vm._s(trx.providerId))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.company))]),_vm._v(" "),_c('td',[(trx.rsvpId !== 0)?_c('a',{attrs:{"href":'/#/reservation/' + trx.rsvpId,"target":"_blank"}},[_vm._v(_vm._s(trx.rsvpId))]):_c('a',{attrs:{"href":'/#/package/' + trx.pkgId,"target":"_blank"}},[_vm._v("\n              "+_vm._s(trx.pkgId)+" "),_c('i',{staticClass:"fa fa-cube"})])]),_vm._v(" "),_c('td',[(trx.trxId !== '0')?_c('span',[_vm._v(_vm._s(trx.trxId))]):_c('span',[_vm._v("--")])]),_vm._v(" "),_c('td',[(trx.pkgId)?_c('span',{staticClass:"package"},[_vm._v("PKG")]):_c('span',{class:['rsvp-type', trx.type]},[_vm._v(_vm._s(trx.type))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.creditCard))]),_vm._v(" "),_c('td',{staticClass:"bookedThrough"},[_c('span',{class:['booked-label', trx.bookedThrough]},[_vm._v(_vm._s(trx.bookedThrough))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.finalOffer))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.chargedAmount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.promoUsed))]),_vm._v(" "),_c('td',{staticClass:"status"},[_c('span',{class:['status-label', trx.statusLabel]},[_vm._v(_vm._s(trx.statusLabel))])]),_vm._v(" "),_c('td',[(trx.paymentURL === null)?_c('span',[_vm._v("--")]):_c('a',{attrs:{"href":trx.paymentURL,"target":"_blank"}},[_c('i',{staticClass:"fa fa-link"})])])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"13"}},[_c('i',{staticClass:"fa fa-circle-notch fa-spin"}),_vm._v("\n              "+_vm._s(_vm.$t('consumer.transactions.loading'))+"\n          ")])]),_vm._v(" "),_c('tr',[_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions.length === 0 && !_vm.loading),expression:"transactions.length === 0 && !loading"}],staticClass:"table-block",attrs:{"colspan":"13"}},[_vm._v("\n            "+_vm._s(_vm.$t('consumer.transactions.emptyState'))+"\n          ")])])],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobile),expression:"isMobile"}],staticClass:"cards"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"card"},[_c('i',{staticClass:"fa fa-circle-notch fa-spin"}),_vm._v("\n      "+_vm._s(_vm.$t('consumer.transactions.loading'))+"\n    ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions.length === 0 && !_vm.loading),expression:"transactions.length === 0 && !loading"}],staticClass:"card"},[_vm._v("\n      "+_vm._s(_vm.$t('consumer.transactions.emptyState'))+"\n    ")]),_vm._v(" "),_vm._l((_vm.transactions),function(trx){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions.length > 0),expression:"transactions.length > 0"}],key:trx.id,staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"time"},[_vm._v("\n          "+_vm._s(trx.date)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"amount"},[(trx.paymentURL === null)?_c('span',[_vm._v(_vm._s(trx.chargedAmount))]):_c('a',{attrs:{"href":trx.paymentURL,"target":"_blank"}},[_vm._v(_vm._s(trx.chargedAmount)+" "),_c('i',{staticClass:"fa fa-link"})])])]),_vm._v(" "),_c('div',{staticClass:"title pkg-div"},[_c('div',{staticClass:"pkg-type"},[_c('div',[(trx.pkgId)?_c('span',{staticClass:"package"},[_vm._v("PKG")]):_c('span',{class:['rsvp-type', trx.type]},[_vm._v(_vm._s(trx.type))])]),_vm._v(" "),_c('div',[_c('span',{class:['booked-label', trx.bookedThrough]},[_vm._v(_vm._s(trx.bookedThrough))])])]),_vm._v(" "),_c('div',{staticClass:"status"},[_c('span',{class:['status-label', trx.statusLabel]},[_vm._v(_vm._s(trx.statusLabel))])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Provider ID: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":'/#/provider/' + trx.providerId,"target":"_blank"}},[_vm._v(_vm._s(trx.providerId))])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Company: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(trx.company))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("RSVP ID: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[(trx.rsvpId !== 0)?_c('a',{attrs:{"href":'/#/reservation/' + trx.rsvpId,"target":"_blank"}},[_vm._v(_vm._s(trx.rsvpId))]):_c('a',{attrs:{"href":'/#/package/' + trx.pkgId,"target":"_blank"}},[_vm._v("\n            "+_vm._s(trx.pkgId)+" "),_c('i',{staticClass:"fa fa-cube"})])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Invoice ID: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[(trx.trxId !== '0')?_c('span',[_vm._v(_vm._s(trx.trxId))]):_c('span',[_vm._v("--")])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Credit Card: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(trx.creditCard))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Final Offer: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(trx.finalOffer))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Charged Amount: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(trx.chargedAmount))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Promo Used: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(trx.promoUsed))])])])})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions.length > 0),expression:"transactions.length > 0"}],staticClass:"fix-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-4 columns per-page"},[_c('span',[_vm._v("Displaying")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" "),_c('span',[_vm._v("per page")])]),_vm._v(" "),_c('div',{staticClass:"small-5 columns page-data"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions.length > 0),expression:"transactions.length > 0"}]},[_vm._v("\n          Displaying\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.start))]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.pageData.end))]),_vm._v(" of\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.max))])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns pagination"},[_c('span',[_vm._v("Page")]),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.currentPage === 1 || _vm.loading},on:{"click":_vm.prev}},[_c('i',{staticClass:"fas fa-chevron-left"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentPage),expression:"currentPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.totalPage),function(i){return _c('option',{key:i,domProps:{"value":i}},[_vm._v(_vm._s(i))])}),0),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.isLastPage || _vm.loading},on:{"click":_vm.next}},[_c('i',{staticClass:"fas fa-chevron-right"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('i',{staticClass:"stripe-icon fab fa-stripe-s"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('i',{staticClass:"stripe-icon fab fa-stripe-s"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreditCard_vue__ = __webpack_require__(422);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f0bdea3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreditCard_vue__ = __webpack_require__(1194);
function injectStyle (ssrContext) {
  __webpack_require__(1186)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f0bdea3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreditCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f0bdea3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreditCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1187);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("42f6f2da", content, true, {});

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.cc-icon[data-v-5f0bdea3] {\n  background-image: url(\"https://s3-us-west-2.amazonaws.com/mobile-consumer-app/cc-sprite.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 20px;\n  width: 32px;\n  display: inline-block;\n}\n.cc-icon.unknown[data-v-5f0bdea3] {\n    background-position: 0 0;\n}\n.cc-icon.visa[data-v-5f0bdea3] {\n    background-position: 0 -20px;\n}\n.cc-icon.mastercard[data-v-5f0bdea3] {\n    background-position: 0 -40px;\n}\n.cc-icon.amex[data-v-5f0bdea3] {\n    background-position: 0 -60px;\n}\n.cc-icon.discover[data-v-5f0bdea3] {\n    background-position: 0 -80px;\n}\n.cc-icon.jcb[data-v-5f0bdea3] {\n    background-position: 0 -100px;\n}\n.cc-icon.diners[data-v-5f0bdea3] {\n    background-position: 0 -120px;\n}\n.respond-box[data-v-5f0bdea3] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 4;\n  background: rgba(0, 0, 0, 0.5);\n  display: table;\n}\n.respond-box .vertical-center[data-v-5f0bdea3] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.respond-box .card[data-v-5f0bdea3] {\n    width: 80%;\n    max-width: 500px;\n    margin: 0 auto;\n    padding: 15px 25px;\n    text-align: center;\n}\n.respond-box .fa-check-circle[data-v-5f0bdea3], .respond-box .fa-times-circle[data-v-5f0bdea3] {\n    font-size: 100px;\n    color: #26d97a;\n    margin-bottom: 5px;\n}\n.respond-box .fa-times-circle[data-v-5f0bdea3] {\n    color: #F20D0D;\n}\n.respond-box .label[data-v-5f0bdea3] {\n    font-weight: 600;\n    color: #505050;\n}\n.respond-box .success .label[data-v-5f0bdea3] {\n    margin-bottom: 20px;\n    padding: 0 40px;\n}\n.respond-box .message[data-v-5f0bdea3] {\n    font-size: 14px;\n    color: #777;\n    margin: 10px 0;\n}\n.add-credit-box .heading[data-v-5f0bdea3] {\n  font-size: 21px;\n  margin-bottom: 20px;\n  font-weight: 600;\n  color: #606060;\n}\n.add-credit-box .label[data-v-5f0bdea3], .add-credit-box .error-msg[data-v-5f0bdea3] {\n  text-align: left;\n}\n.add-credit-box .credit-card-input[data-v-5f0bdea3] {\n  position: relative;\n}\n.add-credit-box .credit-card-input .cc-icon[data-v-5f0bdea3] {\n    position: absolute;\n    top: 7px;\n    left: 5px;\n}\n.add-credit-box .credit-card-input input[data-v-5f0bdea3] {\n    padding-left: 43px;\n}\n.add-credit-box .button[data-v-5f0bdea3] {\n  margin: 20px 0 10px;\n}\n.add-credit-box .close[data-v-5f0bdea3] {\n  font-size: 14px;\n  color: #888;\n  cursor: pointer;\n}\n.data-field[data-v-5f0bdea3] {\n  padding: 5px;\n  position: relative;\n}\n.data-field .label[data-v-5f0bdea3] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .label.has-error[data-v-5f0bdea3] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-5f0bdea3] {\n    margin: 1px 0 0;\n    padding: 5px;\n    font-size: 14px;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-5f0bdea3] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-5f0bdea3]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-5f0bdea3] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.data-field select[data-v-5f0bdea3] {\n    border: 1px solid #ddd;\n    padding: 5px;\n    color: #333;\n    height: 35px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field select.has-error[data-v-5f0bdea3] {\n      border-color: #f20d0d;\n}\n.data-field select[data-v-5f0bdea3]:disabled {\n      background-color: #eee;\n}\ntable[data-v-5f0bdea3] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n}\ntable thead[data-v-5f0bdea3] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-5f0bdea3] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-5f0bdea3] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-5f0bdea3] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-5f0bdea3] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-5f0bdea3] {\n          color: #ccc;\n}\n.status[data-v-5f0bdea3] {\n  text-transform: uppercase;\n  font-weight: 600;\n}\n.status.verified[data-v-5f0bdea3] {\n    color: #26D97A;\n}\n.status.unverified[data-v-5f0bdea3] {\n    color: #F20D0D;\n}\n.cards-mobile[data-v-5f0bdea3] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\ntable[data-v-5f0bdea3] {\n    display: none;\n}\n.respond-box .card[data-v-5f0bdea3] {\n    width: 95%;\n    max-width: -webkit-fit-content;\n    max-width: -moz-fit-content;\n    max-width: fit-content;\n    padding-bottom: 50px;\n    height: calc(100vh - 50px);\n    overflow-y: scroll;\n}\n.cards-mobile[data-v-5f0bdea3] {\n    display: block;\n    margin-top: 50px;\n}\n.cards-mobile .card[data-v-5f0bdea3] {\n      border: 1px solid #ccc;\n      margin-bottom: 15px;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n}\n.cards-mobile .card .info[data-v-5f0bdea3] {\n        width: 100%;\n        padding-left: 10px;\n}\n.cards-mobile .card > div[data-v-5f0bdea3] {\n        margin-bottom: 3px;\n        width: 100%;\n}\n.cards-mobile .card .email-logo img[data-v-5f0bdea3] {\n        max-width: 100px;\n        max-height: 100px;\n}\n.cards-mobile .card .card-header[data-v-5f0bdea3] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n}\n.cards-mobile .card .card-header .time[data-v-5f0bdea3] {\n          font-size: 12px;\n          color: #777;\n          word-spacing: 5px;\n}\n.cards-mobile .card .card-header .amount[data-v-5f0bdea3] {\n          font-weight: 900;\n          font-size: 20px;\n}\n.cards-mobile .card .card-header .amount a[data-v-5f0bdea3] {\n            text-decoration: none;\n}\n.cards-mobile .card .credit-card[data-v-5f0bdea3] {\n        font-weight: 900;\n}\n.cards-mobile .card .title[data-v-5f0bdea3] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        margin-bottom: 3px;\n}\n.cards-mobile .card .title.pkg-div[data-v-5f0bdea3] {\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n}\n.cards-mobile .card .title .pkg-type[data-v-5f0bdea3] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n.cards-mobile .card .title input[data-v-5f0bdea3] {\n          margin-right: 5px;\n}\n.cards-mobile .card .title.view[data-v-5f0bdea3] {\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n          padding-top: 7px;\n          padding-bottom: 5px;\n          border-top: 1px solid #eee;\n}\n.cards-mobile .card .title .refer[data-v-5f0bdea3] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n.cards-mobile .card .label[data-v-5f0bdea3] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards-mobile .card .value[data-v-5f0bdea3] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards-mobile .card .value i[data-v-5f0bdea3] {\n          color: #bbb;\n}\n.cards-mobile .card .value a[data-v-5f0bdea3] {\n          text-decoration: none;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Corporate/CreditCard.vue"],"names":[],"mappings":";AACA;EACE,8FAA8F;EAC9F,6BAA6B;EAC7B,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,sBAAsB;CACvB;AACD;IACI,yBAAyB;CAC5B;AACD;IACI,6BAA6B;CAChC;AACD;IACI,6BAA6B;CAChC;AACD;IACI,6BAA6B;CAChC;AACD;IACI,6BAA6B;CAChC;AACD;IACI,8BAA8B;CACjC;AACD;IACI,8BAA8B;CACjC;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,WAAW;EACX,+BAA+B;EAC/B,eAAe;CAChB;AACD;IACI,oBAAoB;IACpB,uBAAuB;CAC1B;AACD;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;CACtB;AACD;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;CACtB;AACD;IACI,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,oBAAoB;IACpB,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;CAClB;AACD;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;CAChB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,UAAU;CACb;AACD;IACI,mBAAmB;CACtB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,aAAa;EACb,mBAAmB;CACpB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;MACM,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;IACI,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,wDAAwD;IACxD,6BAA6B;IAC7B,+BAA+B;IAC/B,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,uBAAuB;CAC5B;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;CAClB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;EACE,0BAA0B;EAC1B,iBAAiB;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;EACE,cAAc;CACf;AACD;AACA;IACI,cAAc;CACjB;AACD;IACI,WAAW;IACX,+BAA+B;IAC/B,4BAA4B;IAC5B,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;CACtB;AACD;IACI,eAAe;IACf,iBAAiB;CACpB;AACD;MACM,uBAAuB;MACvB,oBAAoB;MACpB,aAAa;MACb,oBAAoB;MACpB,+BAA+B;MAC/B,oBAAoB;MACpB,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,6BAA6B;MAC7B,8BAA8B;UAC1B,2BAA2B;cACvB,uBAAuB;CACpC;AACD;QACQ,YAAY;QACZ,mBAAmB;CAC1B;AACD;QACQ,mBAAmB;QACnB,YAAY;CACnB;AACD;QACQ,iBAAiB;QACjB,kBAAkB;CACzB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,+BAA+B;QACvC,uBAAuB;YACnB,oBAAoB;gBAChB,sBAAsB;CACrC;AACD;UACU,gBAAgB;UAChB,YAAY;UACZ,kBAAkB;CAC3B;AACD;UACU,iBAAiB;UACjB,gBAAgB;CACzB;AACD;YACY,sBAAsB;CACjC;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,oBAAoB;QAC5B,mBAAmB;CAC1B;AACD;UACU,0BAA0B;cACtB,uBAAuB;kBACnB,+BAA+B;CAChD;AACD;UACU,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;CACvB;AACD;UACU,kBAAkB;CAC3B;AACD;UACU,0BAA0B;cACtB,uBAAuB;kBACnB,+BAA+B;UACvC,iBAAiB;UACjB,oBAAoB;UACpB,2BAA2B;CACpC;AACD;UACU,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;CACvB;AACD;QACQ,gBAAgB;QAChB,0BAA0B;QAC1B,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;CACzB;AACD;QACQ,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;CACxB;AACD;UACU,YAAY;CACrB;AACD;UACU,sBAAsB;CAC/B;CACA","file":"CreditCard.vue","sourcesContent":["\n.cc-icon[data-v-5f0bdea3] {\n  background-image: url(\"https://s3-us-west-2.amazonaws.com/mobile-consumer-app/cc-sprite.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 20px;\n  width: 32px;\n  display: inline-block;\n}\n.cc-icon.unknown[data-v-5f0bdea3] {\n    background-position: 0 0;\n}\n.cc-icon.visa[data-v-5f0bdea3] {\n    background-position: 0 -20px;\n}\n.cc-icon.mastercard[data-v-5f0bdea3] {\n    background-position: 0 -40px;\n}\n.cc-icon.amex[data-v-5f0bdea3] {\n    background-position: 0 -60px;\n}\n.cc-icon.discover[data-v-5f0bdea3] {\n    background-position: 0 -80px;\n}\n.cc-icon.jcb[data-v-5f0bdea3] {\n    background-position: 0 -100px;\n}\n.cc-icon.diners[data-v-5f0bdea3] {\n    background-position: 0 -120px;\n}\n.respond-box[data-v-5f0bdea3] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 4;\n  background: rgba(0, 0, 0, 0.5);\n  display: table;\n}\n.respond-box .vertical-center[data-v-5f0bdea3] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.respond-box .card[data-v-5f0bdea3] {\n    width: 80%;\n    max-width: 500px;\n    margin: 0 auto;\n    padding: 15px 25px;\n    text-align: center;\n}\n.respond-box .fa-check-circle[data-v-5f0bdea3], .respond-box .fa-times-circle[data-v-5f0bdea3] {\n    font-size: 100px;\n    color: #26d97a;\n    margin-bottom: 5px;\n}\n.respond-box .fa-times-circle[data-v-5f0bdea3] {\n    color: #F20D0D;\n}\n.respond-box .label[data-v-5f0bdea3] {\n    font-weight: 600;\n    color: #505050;\n}\n.respond-box .success .label[data-v-5f0bdea3] {\n    margin-bottom: 20px;\n    padding: 0 40px;\n}\n.respond-box .message[data-v-5f0bdea3] {\n    font-size: 14px;\n    color: #777;\n    margin: 10px 0;\n}\n.add-credit-box .heading[data-v-5f0bdea3] {\n  font-size: 21px;\n  margin-bottom: 20px;\n  font-weight: 600;\n  color: #606060;\n}\n.add-credit-box .label[data-v-5f0bdea3], .add-credit-box .error-msg[data-v-5f0bdea3] {\n  text-align: left;\n}\n.add-credit-box .credit-card-input[data-v-5f0bdea3] {\n  position: relative;\n}\n.add-credit-box .credit-card-input .cc-icon[data-v-5f0bdea3] {\n    position: absolute;\n    top: 7px;\n    left: 5px;\n}\n.add-credit-box .credit-card-input input[data-v-5f0bdea3] {\n    padding-left: 43px;\n}\n.add-credit-box .button[data-v-5f0bdea3] {\n  margin: 20px 0 10px;\n}\n.add-credit-box .close[data-v-5f0bdea3] {\n  font-size: 14px;\n  color: #888;\n  cursor: pointer;\n}\n.data-field[data-v-5f0bdea3] {\n  padding: 5px;\n  position: relative;\n}\n.data-field .label[data-v-5f0bdea3] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .label.has-error[data-v-5f0bdea3] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-5f0bdea3] {\n    margin: 1px 0 0;\n    padding: 5px;\n    font-size: 14px;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-5f0bdea3] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-5f0bdea3]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-5f0bdea3] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.data-field select[data-v-5f0bdea3] {\n    border: 1px solid #ddd;\n    padding: 5px;\n    color: #333;\n    height: 35px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field select.has-error[data-v-5f0bdea3] {\n      border-color: #f20d0d;\n}\n.data-field select[data-v-5f0bdea3]:disabled {\n      background-color: #eee;\n}\ntable[data-v-5f0bdea3] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n}\ntable thead[data-v-5f0bdea3] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-5f0bdea3] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-5f0bdea3] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-5f0bdea3] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-5f0bdea3] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-5f0bdea3] {\n          color: #ccc;\n}\n.status[data-v-5f0bdea3] {\n  text-transform: uppercase;\n  font-weight: 600;\n}\n.status.verified[data-v-5f0bdea3] {\n    color: #26D97A;\n}\n.status.unverified[data-v-5f0bdea3] {\n    color: #F20D0D;\n}\n.cards-mobile[data-v-5f0bdea3] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\ntable[data-v-5f0bdea3] {\n    display: none;\n}\n.respond-box .card[data-v-5f0bdea3] {\n    width: 95%;\n    max-width: -webkit-fit-content;\n    max-width: -moz-fit-content;\n    max-width: fit-content;\n    padding-bottom: 50px;\n    height: calc(100vh - 50px);\n    overflow-y: scroll;\n}\n.cards-mobile[data-v-5f0bdea3] {\n    display: block;\n    margin-top: 50px;\n}\n.cards-mobile .card[data-v-5f0bdea3] {\n      border: 1px solid #ccc;\n      margin-bottom: 15px;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n}\n.cards-mobile .card .info[data-v-5f0bdea3] {\n        width: 100%;\n        padding-left: 10px;\n}\n.cards-mobile .card > div[data-v-5f0bdea3] {\n        margin-bottom: 3px;\n        width: 100%;\n}\n.cards-mobile .card .email-logo img[data-v-5f0bdea3] {\n        max-width: 100px;\n        max-height: 100px;\n}\n.cards-mobile .card .card-header[data-v-5f0bdea3] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n}\n.cards-mobile .card .card-header .time[data-v-5f0bdea3] {\n          font-size: 12px;\n          color: #777;\n          word-spacing: 5px;\n}\n.cards-mobile .card .card-header .amount[data-v-5f0bdea3] {\n          font-weight: 900;\n          font-size: 20px;\n}\n.cards-mobile .card .card-header .amount a[data-v-5f0bdea3] {\n            text-decoration: none;\n}\n.cards-mobile .card .credit-card[data-v-5f0bdea3] {\n        font-weight: 900;\n}\n.cards-mobile .card .title[data-v-5f0bdea3] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        margin-bottom: 3px;\n}\n.cards-mobile .card .title.pkg-div[data-v-5f0bdea3] {\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n}\n.cards-mobile .card .title .pkg-type[data-v-5f0bdea3] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n.cards-mobile .card .title input[data-v-5f0bdea3] {\n          margin-right: 5px;\n}\n.cards-mobile .card .title.view[data-v-5f0bdea3] {\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n          padding-top: 7px;\n          padding-bottom: 5px;\n          border-top: 1px solid #eee;\n}\n.cards-mobile .card .title .refer[data-v-5f0bdea3] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n.cards-mobile .card .label[data-v-5f0bdea3] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards-mobile .card .value[data-v-5f0bdea3] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards-mobile .card .value i[data-v-5f0bdea3] {\n          color: #bbb;\n}\n.cards-mobile .card .value a[data-v-5f0bdea3] {\n          text-decoration: none;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var types = __webpack_require__(1189);
var clone = __webpack_require__(423);
var findBestMatch = __webpack_require__(1190);
var isValidInputType = __webpack_require__(1191);
var addMatchingCardsToResults = __webpack_require__(1192);

var testOrder;
var customCards = {};

var cardNames = {
  VISA: 'visa',
  MASTERCARD: 'mastercard',
  AMERICAN_EXPRESS: 'american-express',
  DINERS_CLUB: 'diners-club',
  DISCOVER: 'discover',
  JCB: 'jcb',
  UNIONPAY: 'unionpay',
  MAESTRO: 'maestro',
  ELO: 'elo',
  MIR: 'mir',
  HIPER: 'hiper',
  HIPERCARD: 'hipercard'
};

var ORIGINAL_TEST_ORDER = [
  cardNames.VISA,
  cardNames.MASTERCARD,
  cardNames.AMERICAN_EXPRESS,
  cardNames.DINERS_CLUB,
  cardNames.DISCOVER,
  cardNames.JCB,
  cardNames.UNIONPAY,
  cardNames.MAESTRO,
  cardNames.ELO,
  cardNames.MIR,
  cardNames.HIPER,
  cardNames.HIPERCARD
];

testOrder = clone(ORIGINAL_TEST_ORDER);

function findType(type) {
  return customCards[type] || types[type];
}

function getAllCardTypes() {
  return testOrder.map(function (type) {
    return clone(findType(type));
  });
}

function getCardPosition(name, ignoreErrorForNotExisting) {
  var position = testOrder.indexOf(name);

  if (!ignoreErrorForNotExisting && position === -1) {
    throw new Error('"' + name + '" is not a supported card type.');
  }

  return position;
}

function creditCardType(cardNumber) {
  var bestMatch;
  var results = [];

  if (!isValidInputType(cardNumber)) {
    return [];
  }

  if (cardNumber.length === 0) {
    return getAllCardTypes(testOrder);
  }

  testOrder.forEach(function (type) {
    var cardConfiguration = findType(type);

    addMatchingCardsToResults(cardNumber, cardConfiguration, results);
  });

  bestMatch = findBestMatch(results);

  if (bestMatch) {
    return [bestMatch];
  }

  return results;
}

creditCardType.getTypeInfo = function (type) {
  return clone(findType(type));
};

creditCardType.removeCard = function (name) {
  var position = getCardPosition(name);

  testOrder.splice(position, 1);
};

creditCardType.addCard = function (config) {
  var existingCardPosition = getCardPosition(config.type, true);

  customCards[config.type] = config;

  if (existingCardPosition === -1) {
    testOrder.push(config.type);
  }
};

creditCardType.updateCard = function (cardType, updates) {
  var clonedCard;
  var originalObject = customCards[cardType] || types[cardType];

  if (!originalObject) {
    throw new Error('"' + cardType + '" is not a recognized type. Use `addCard` instead.');
  }

  if (updates.type && originalObject.type !== updates.type) {
    throw new Error('Cannot overwrite type parameter.');
  }

  clonedCard = clone(originalObject, true);

  Object.keys(clonedCard).forEach(function (key) {
    if (updates[key]) {
      clonedCard[key] = updates[key];
    }
  });

  customCards[clonedCard.type] = clonedCard;
};

creditCardType.changeOrder = function (name, position) {
  var currentPosition = getCardPosition(name);

  testOrder.splice(currentPosition, 1);
  testOrder.splice(position, 0, name);
};

creditCardType.resetModifications = function () {
  testOrder = clone(ORIGINAL_TEST_ORDER);
  customCards = {};
};

creditCardType.types = cardNames;

module.exports = creditCardType;


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cardTypes = {
  visa: {
    niceType: 'Visa',
    type: 'visa',
    patterns: [
      4
    ],
    gaps: [4, 8, 12],
    lengths: [16, 18, 19],
    code: {
      name: 'CVV',
      size: 3
    }
  },
  mastercard: {
    niceType: 'Mastercard',
    type: 'mastercard',
    patterns: [
      [51, 55],
      [2221, 2229],
      [223, 229],
      [23, 26],
      [270, 271],
      2720
    ],
    gaps: [4, 8, 12],
    lengths: [16],
    code: {
      name: 'CVC',
      size: 3
    }
  },
  'american-express': {
    niceType: 'American Express',
    type: 'american-express',
    patterns: [
      34,
      37
    ],
    gaps: [4, 10],
    lengths: [15],
    code: {
      name: 'CID',
      size: 4
    }
  },
  'diners-club': {
    niceType: 'Diners Club',
    type: 'diners-club',
    patterns: [
      [300, 305],
      36,
      38,
      39
    ],
    gaps: [4, 10],
    lengths: [14, 16, 19],
    code: {
      name: 'CVV',
      size: 3
    }
  },
  discover: {
    niceType: 'Discover',
    type: 'discover',
    patterns: [
      6011,
      [644, 649],
      65
    ],
    gaps: [4, 8, 12],
    lengths: [16, 19],
    code: {
      name: 'CID',
      size: 3
    }
  },
  jcb: {
    niceType: 'JCB',
    type: 'jcb',
    patterns: [
      2131,
      1800,
      [3528, 3589]
    ],
    gaps: [4, 8, 12],
    lengths: [16, 17, 18, 19],
    code: {
      name: 'CVV',
      size: 3
    }
  },
  unionpay: {
    niceType: 'UnionPay',
    type: 'unionpay',
    patterns: [
      620,
      [624, 626],
      [62100, 62182],
      [62184, 62187],
      [62185, 62197],
      [62200, 62205],
      [622010, 622999],
      622018,
      [622019, 622999],
      [62207, 62209],
      [622126, 622925],
      [623, 626],
      6270,
      6272,
      6276,
      [627700, 627779],
      [627781, 627799],
      [6282, 6289],
      6291,
      6292,
      810,
      [8110, 8131],
      [8132, 8151],
      [8152, 8163],
      [8164, 8171]
    ],
    gaps: [4, 8, 12],
    lengths: [14, 15, 16, 17, 18, 19],
    code: {
      name: 'CVN',
      size: 3
    }
  },
  maestro: {
    niceType: 'Maestro',
    type: 'maestro',
    patterns: [
      493698,
      [500000, 506698],
      [506779, 508999],
      [56, 59],
      63,
      67,
      6
    ],
    gaps: [4, 8, 12],
    lengths: [12, 13, 14, 15, 16, 17, 18, 19],
    code: {
      name: 'CVC',
      size: 3
    }
  },
  elo: {
    niceType: 'Elo',
    type: 'elo',
    patterns: [
      401178,
      401179,
      438935,
      457631,
      457632,
      431274,
      451416,
      457393,
      504175,
      [506699, 506778],
      [509000, 509999],
      627780,
      636297,
      636368,
      [650031, 650033],
      [650035, 650051],
      [650405, 650439],
      [650485, 650538],
      [650541, 650598],
      [650700, 650718],
      [650720, 650727],
      [650901, 650978],
      [651652, 651679],
      [655000, 655019],
      [655021, 655058]
    ],
    gaps: [4, 8, 12],
    lengths: [16],
    code: {
      name: 'CVE',
      size: 3
    }
  },
  mir: {
    niceType: 'Mir',
    type: 'mir',
    patterns: [
      [2200, 2204]
    ],
    gaps: [4, 8, 12],
    lengths: [16, 17, 18, 19],
    code: {
      name: 'CVP2',
      size: 3
    }
  },
  hiper: {
    niceType: 'Hiper',
    type: 'hiper',
    patterns: [
      637095,
      637568,
      637599,
      637609,
      637612
    ],
    gaps: [4, 8, 12],
    lengths: [16],
    code: {
      name: 'CVC',
      size: 3
    }
  },
  hipercard: {
    niceType: 'Hipercard',
    type: 'hipercard',
    patterns: [
      606282
    ],
    gaps: [4, 8, 12],
    lengths: [16],
    code: {
      name: 'CVC',
      size: 3
    }
  }
};

module.exports = cardTypes;


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function hasEnoughResultsToDetermineBestMatch(results) {
  var numberOfResultsWithMaxStrengthProperty = results.filter(function (result) {
    return result.matchStrength;
  }).length;

  // if all possible results have a maxStrength property
  // that means the card number is sufficiently long
  // enough to determine conclusively what the type is
  return numberOfResultsWithMaxStrengthProperty > 0 &&
    numberOfResultsWithMaxStrengthProperty === results.length;
}

function findBestMatch(results) {
  if (!hasEnoughResultsToDetermineBestMatch(results)) {
    return;
  }

  return results.reduce(function (bestMatch, result) { // eslint-disable-line consistent-return
    if (!bestMatch) {
      return result;
    }

    // if the current best match pattern is less specific
    // than this result, set the result as the new best match
    if (bestMatch.matchStrength < result.matchStrength) {
      return result;
    }

    return bestMatch;
  });
}

module.exports = findBestMatch;


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function isValidInputType(cardNumber) {
  return typeof cardNumber === 'string' || cardNumber instanceof String;
}

module.exports = isValidInputType;


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var clone = __webpack_require__(423);
var matches = __webpack_require__(1193);

function addMatchingCardsToResults(cardNumber, cardConfiguration, results) {
  var i, pattern, patternLength, clonedCardConfiguration;

  for (i = 0; i < cardConfiguration.patterns.length; i++) {
    pattern = cardConfiguration.patterns[i];

    if (!matches(cardNumber, pattern)) {
      continue;
    }

    clonedCardConfiguration = clone(cardConfiguration);

    if (Array.isArray(pattern)) {
      patternLength = String(pattern[0]).length;
    } else {
      patternLength = String(pattern).length;
    }

    if (cardNumber.length >= patternLength) {
      clonedCardConfiguration.matchStrength = patternLength;
    }

    results.push(clonedCardConfiguration);
    break;
  }
}

module.exports = addMatchingCardsToResults;


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Adapted from https://github.com/polvo-labs/card-type/blob/aaab11f80fa1939bccc8f24905a06ae3cd864356/src/cardType.js#L37-L42
function matchesRange(cardNumber, min, max) {
  var maxLengthToCheck = String(min).length;
  var substr = cardNumber.substr(0, maxLengthToCheck);
  var integerRepresentationOfCardNumber = parseInt(substr, 10);

  min = parseInt(String(min).substr(0, substr.length), 10);
  max = parseInt(String(max).substr(0, substr.length), 10);

  return integerRepresentationOfCardNumber >= min && integerRepresentationOfCardNumber <= max;
}

function matchesPattern(cardNumber, pattern) {
  pattern = String(pattern);

  return pattern.substring(0, cardNumber.length) === cardNumber.substring(0, pattern.length);
}

function matches(cardNumber, pattern) {
  if (Array.isArray(pattern)) {
    return matchesRange(cardNumber, pattern[0], pattern[1]);
  }

  return matchesPattern(cardNumber, pattern);
}

module.exports = matches;


/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"button cta success",on:{"click":function($event){_vm.showAddCardModal = true}}},[_vm._v("Add Credit Card")]),_vm._v(" "),_c('table',[_c('thead',[_c('th',[_vm._v(_vm._s(_vm.$t('consumer.creditCards.addedOn')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.creditCards.creditCard')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.creditCards.address')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.creditCards.city')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.creditCards.state')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.creditCards.zip')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('consumer.creditCards.status')))])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.creditCards),function(card){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.creditCards.length > 0),expression:"creditCards.length > 0"}],key:card.id},[_c('td',[_vm._v(_vm._s(card.date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(card.card))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(card.address))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(card.city))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(card.state))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(card.zip))]),_vm._v(" "),_c('td',{class:['status', _vm.cardStatus(card.status)]},[_vm._v(_vm._s(_vm.cardStatus(card.status)))])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"7"}},[_c('i',{staticClass:"fa fa-circle-notch fa-spin"}),_vm._v("\n            "+_vm._s(_vm.$t('consumer.creditCards.loading'))+"\n        ")])]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.creditCards.length === 0 && !_vm.loading),expression:"creditCards.length === 0 && !loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"7"}},[_vm._v("\n          "+_vm._s(_vm.$t('consumer.creditCards.emptyState'))+"\n        ")])])],2)]),_vm._v(" "),_c('div',{staticClass:"cards-mobile"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_c('i',{staticClass:"fa fa-circle-notch fa-spin"}),_vm._v("\n      "+_vm._s(_vm.$t('consumer.creditCards.loading'))+"\n    ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.creditCards.length === 0 && !_vm.loading),expression:"creditCards.length === 0 && !loading"}]},[_vm._v("\n       "+_vm._s(_vm.$t('consumer.creditCards.emptyState'))+"\n    ")]),_vm._v(" "),_vm._l((_vm.creditCards),function(card){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.creditCards.length > 0),expression:"creditCards.length > 0"}],key:card.id,staticClass:"card"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Added On: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(card.date))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Card #: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(card.card))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Address: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(card.address))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("City: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(card.city))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("State: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(card.state))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Zip: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(card.zip))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Status: ")]),_vm._v(" "),_c('div',{class:['value status', _vm.cardStatus(card.status)]},[_vm._v(_vm._s(_vm.cardStatus(card.status)))])])])})],2),_vm._v(" "),_c('transition',{attrs:{"name":"expand"}},[(_vm.showAddCardModal)?_c('div',{staticClass:"respond-box"},[_c('div',{staticClass:"vertical-center"},[_c('div',{staticClass:"card add-credit-box"},[_c('div',{staticClass:"heading"},[_vm._v("ADD CREDIT CARD")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"medium-12 column"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Credit Card #")]),_vm._v(" "),_c('div',{staticClass:"credit-card-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.creditCardData.card),expression:"creditCardData.card"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.creditCardData.card)},on:{"keyup":_vm.cardTypeCheck,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.creditCardData, "card", $event.target.value)}}}),_vm._v(" "),_c('span',{class:['cc-icon', _vm.cardType]})]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.card))])])]),_vm._v(" "),_c('div',{staticClass:"medium-12 column"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Cardholder Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.creditCardData.owner),expression:"creditCardData.owner"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.creditCardData.owner)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.creditCardData, "owner", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.owner))])])]),_vm._v(" "),_c('div',{staticClass:"medium-6 column"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("EXPIRATION (MM/YYYY)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.creditCardData.expiration),expression:"creditCardData.expiration"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.creditCardData.expiration)},on:{"keyup":_vm.formatExpCC,"keypress":_vm.isNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.creditCardData, "expiration", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.expiration))])])]),_vm._v(" "),_c('div',{staticClass:"medium-6 column"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("CVV")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.creditCardData.cvv),expression:"creditCardData.cvv"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.creditCardData.cvv)},on:{"keypress":_vm.isNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.creditCardData, "cvv", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.cvv))])])]),_vm._v(" "),_c('div',{staticClass:"medium-12 column"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Address1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.creditCardData.address),expression:"creditCardData.address"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.creditCardData.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.creditCardData, "address", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.address))])])]),_vm._v(" "),_c('div',{staticClass:"medium-12 column margin-B-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.creditCardData.city),expression:"creditCardData.city"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.creditCardData.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.creditCardData, "city", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.city))])])]),_vm._v(" "),_c('div',{staticClass:"medium-6 columns margin-B-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("State")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.creditCardData.state),expression:"creditCardData.state"}],class:{'has-error':false},attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.creditCardData, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}}),_vm._v(" "),_c('option',{attrs:{"value":"NonUS"}},[_vm._v("Non US")]),_vm._v(" "),_vm._l((_vm.states),function(state){return _c('option',{key:state.value,domProps:{"value":state.label}},[_vm._v(_vm._s(state.label))])})],2),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.state))])])]),_vm._v(" "),_c('div',{staticClass:"medium-6 column margin-B-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Zip")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.creditCardData.zip),expression:"creditCardData.zip"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.creditCardData.zip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.creditCardData, "zip", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.zip))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.creditCardData.state === 'NonUS'),expression:"creditCardData.state === 'NonUS'"}],staticClass:"medium-12 column margin-B-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Country")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.creditCardData.country),expression:"creditCardData.country"}],class:{'input':true, 'has-error':false},attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.creditCardData, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.countries.all),function(country,index){return _c('option',{key:index,domProps:{"value":country.alpha2}},[_vm._v(_vm._s(country.name))])}),0),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.country))])])])]),_vm._v(" "),_c('div',{staticClass:"button cta block small",on:{"click":_vm.addCard}},[(_vm.loading)?_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v("\n              Loading ...\n            ")]):_c('span',[_vm._v("Submit")])]),_vm._v(" "),_c('div',{staticClass:"close",on:{"click":function($event){_vm.showAddCardModal = false}}},[_vm._v("Close")])])])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"expand"}},[(_vm.respond.show)?_c('div',{staticClass:"respond-box"},[_c('div',{staticClass:"vertical-center"},[_c('div',{staticClass:"card "},[_c('div',{staticClass:"success"},[(_vm.respond.success)?_c('i',{staticClass:"fas fa-check-circle"}):_c('i',{staticClass:"fas fa-times-circle"}),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.respond.label))]),_vm._v(" "),(!!_vm.respond.message)?_c('div',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.respond.message)}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"button cta block small margin-T-l",on:{"click":_vm.closeRespondModal}},[_vm._v("Close")])])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceList_vue__ = __webpack_require__(424);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5172555c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceList_vue__ = __webpack_require__(1209);
function injectStyle (ssrContext) {
  __webpack_require__(1196)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5172555c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5172555c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1197);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("32cb717e", content, true, {});

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.list-box[data-v-5172555c] {\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: 100vh;\n  max-height: calc(100vh - 150px);\n  margin-top: 20px;\n}\n.list-box table[data-v-5172555c] {\n    margin-top: 0;\n}\n.modal[data-v-5172555c] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.modal .bg-overlay[data-v-5172555c] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n.modal .modal-content[data-v-5172555c] {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    padding: 15px 25px;\n    background: #fff;\n    text-align: center;\n    border-radius: 6px;\n    margin-left: -200px;\n    margin-top: -180px;\n    -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal .modal-content.upload[data-v-5172555c] {\n      top: 50%;\n      width: 900px;\n      height: 550px;\n      margin-top: -265px;\n      margin-left: -450px;\n}\n.modal.show[data-v-5172555c] {\n    display: block;\n}\n.modal.show .modal-content[data-v-5172555c] {\n      display: block;\n      -webkit-animation: slide-down .3s ease-out;\n      -moz-animation: slide-down .3s ease-out;\n}\n.modal .header[data-v-5172555c] {\n    font-size: 24px;\n    font-weight: 600;\n    margin-bottom: 15px;\n    color: #606060;\n}\n.modal .has-error[data-v-5172555c] {\n    color: #f00;\n    background: #ffefef;\n    border: 1px solid #f00;\n    margin-bottom: 10px;\n    border-radius: 2px;\n    font-size: 15px;\n    line-height: 1.6;\n}\n.modal .close[data-v-5172555c] {\n    display: block;\n    margin-top: 5px;\n    font-size: 14px;\n    color: #999;\n    cursor: pointer;\n}\n.modal .close[data-v-5172555c]:hover {\n      text-decoration: underline;\n      color: #555;\n}\n.data-field[data-v-5172555c] {\n  padding: 5px;\n  position: relative;\n}\n.data-field .label[data-v-5172555c] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .label.has-error[data-v-5172555c] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-5172555c] {\n    margin: 1px 0 0;\n    padding: 5px;\n    font-size: 14px;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-5172555c] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-5172555c]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-5172555c] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.invoice-box[data-v-5172555c] {\n  width: 500px;\n}\n.invoice-box .row[data-v-5172555c] {\n    margin-bottom: 20px;\n}\n.invoice-box .data-field[data-v-5172555c] {\n    margin-bottom: 10px;\n    text-align: left;\n}\n.padding-R-s[data-v-5172555c] {\n  padding-right: 5px;\n}\n.padding-L-s[data-v-5172555c] {\n  padding-left: 5px;\n}\n.margin-B-m[data-v-5172555c] {\n  margin-bottom: 10px;\n}\n.margin-T-l[data-v-5172555c] {\n  margin-top: 20px;\n}\n.respond-box[data-v-5172555c] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 4;\n  background: rgba(0, 0, 0, 0.5);\n  display: table;\n}\n.respond-box .vertical-center[data-v-5172555c] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.respond-box .card[data-v-5172555c] {\n    width: 80%;\n    max-width: 500px;\n    margin: 0 auto;\n    padding: 15px;\n    text-align: center;\n}\n.respond-box .fa-check-circle[data-v-5172555c], .respond-box .fa-times-circle[data-v-5172555c] {\n    font-size: 100px;\n    color: #26d97a;\n    margin-bottom: 5px;\n}\n.respond-box .fa-times-circle[data-v-5172555c] {\n    color: #F20D0D;\n}\n.respond-box .label[data-v-5172555c] {\n    font-weight: 600;\n    color: #505050;\n}\n.respond-box .success .label[data-v-5172555c] {\n    padding: 0 40px;\n}\n.respond-box .message[data-v-5172555c] {\n    font-size: 14px;\n    color: #777;\n    margin: 10px 0;\n}\ntable[data-v-5172555c] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n}\ntable thead[data-v-5172555c] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-5172555c] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-5172555c] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-5172555c] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-5172555c] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-5172555c] {\n          color: #ccc;\n}\n.status[data-v-5172555c] {\n  font-size: 12px;\n  padding: 2px 6px;\n  color: #fff;\n  background: #777;\n  display: inline-block;\n  text-transform: uppercase;\n  border-radius: 2px;\n}\n.status.unpaid[data-v-5172555c] {\n    background: #de5050;\n}\n.status.paid[data-v-5172555c] {\n    background: #47bd63;\n}\n@media only screen and (max-width: 430px) {\n.list-box[data-v-5172555c] {\n    display: none;\n}\n.modal.show[data-v-5172555c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.modal.show .invoice-box[data-v-5172555c] {\n      position: unset;\n      margin-left: 0;\n      margin-top: -30px;\n      width: 90%;\n}\n.modal.show .invoice-box .padding-L-s[data-v-5172555c], .modal.show .invoice-box .padding-R-s[data-v-5172555c] {\n        padding: 0;\n}\n.cards-mobile[data-v-5172555c] {\n    display: block;\n    margin-top: 50px;\n}\n.cards-mobile .card[data-v-5172555c] {\n      border: 1px solid #ccc;\n      margin-bottom: 15px;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n}\n.cards-mobile .card .info[data-v-5172555c] {\n        width: 100%;\n        padding-left: 10px;\n}\n.cards-mobile .card > div[data-v-5172555c] {\n        margin-bottom: 3px;\n        width: 100%;\n}\n.cards-mobile .card .email-logo img[data-v-5172555c] {\n        max-width: 100px;\n        max-height: 100px;\n}\n.cards-mobile .card .card-header[data-v-5172555c] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n}\n.cards-mobile .card .card-header .time[data-v-5172555c] {\n          font-size: 12px;\n          color: #777;\n          word-spacing: 5px;\n}\n.cards-mobile .card .card-header .amount[data-v-5172555c] {\n          font-weight: 900;\n          font-size: 20px;\n}\n.cards-mobile .card .card-header .amount a[data-v-5172555c] {\n            text-decoration: none;\n}\n.cards-mobile .card .credit-card[data-v-5172555c] {\n        font-weight: 900;\n}\n.cards-mobile .card .btn-action[data-v-5172555c] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        padding: 20px 10px 0;\n}\n.cards-mobile .card .btn-action a[data-v-5172555c] {\n          width: 50%;\n}\n.cards-mobile .card .title[data-v-5172555c] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        margin-bottom: 3px;\n}\n.cards-mobile .card .title.pkg-div[data-v-5172555c] {\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n}\n.cards-mobile .card .title .pkg-type[data-v-5172555c] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n.cards-mobile .card .title input[data-v-5172555c] {\n          margin-right: 5px;\n}\n.cards-mobile .card .title.view[data-v-5172555c] {\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n          padding-top: 7px;\n          padding-bottom: 5px;\n          border-top: 1px solid #eee;\n}\n.cards-mobile .card .title .refer[data-v-5172555c] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n.cards-mobile .card .label[data-v-5172555c] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards-mobile .card .value[data-v-5172555c] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards-mobile .card .value i[data-v-5172555c] {\n          color: #bbb;\n}\n.cards-mobile .card .value a[data-v-5172555c] {\n          text-decoration: none;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Corporate/InvoiceList.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,iBAAiB;CAClB;AACD;IACI,cAAc;CACjB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,YAAY;CACb;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;CAChB;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,uDAAuD;YAC/C,+CAA+C;IACvD,cAAc;CACjB;AACD;MACM,SAAS;MACT,aAAa;MACb,cAAc;MACd,mBAAmB;MACnB,oBAAoB;CACzB;AACD;IACI,eAAe;CAClB;AACD;MACM,eAAe;MACf,2CAA2C;MAC3C,wCAAwC;CAC7C;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;CAClB;AACD;IACI,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;CACpB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;CACnB;AACD;MACM,2BAA2B;MAC3B,YAAY;CACjB;AACD;EACE,aAAa;EACb,mBAAmB;CACpB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;MACM,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;EACE,aAAa;CACd;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;IACpB,iBAAiB;CACpB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,WAAW;EACX,+BAA+B;EAC/B,eAAe;CAChB;AACD;IACI,oBAAoB;IACpB,uBAAuB;CAC1B;AACD;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,mBAAmB;CACtB;AACD;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;CACtB;AACD;IACI,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;CAClB;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;CAClB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;AACA;IACI,cAAc;CACjB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,yBAAyB;QACrB,sBAAsB;YAClB,wBAAwB;IAChC,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;CAC/B;AACD;MACM,gBAAgB;MAChB,eAAe;MACf,kBAAkB;MAClB,WAAW;CAChB;AACD;QACQ,WAAW;CAClB;AACD;IACI,eAAe;IACf,iBAAiB;CACpB;AACD;MACM,uBAAuB;MACvB,oBAAoB;MACpB,aAAa;MACb,oBAAoB;MACpB,+BAA+B;MAC/B,oBAAoB;MACpB,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,6BAA6B;MAC7B,8BAA8B;UAC1B,2BAA2B;cACvB,uBAAuB;CACpC;AACD;QACQ,YAAY;QACZ,mBAAmB;CAC1B;AACD;QACQ,mBAAmB;QACnB,YAAY;CACnB;AACD;QACQ,iBAAiB;QACjB,kBAAkB;CACzB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,+BAA+B;QACvC,uBAAuB;YACnB,oBAAoB;gBAChB,sBAAsB;CACrC;AACD;UACU,gBAAgB;UAChB,YAAY;UACZ,kBAAkB;CAC3B;AACD;UACU,iBAAiB;UACjB,gBAAgB;CACzB;AACD;YACY,sBAAsB;CACjC;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,yBAAyB;YACrB,sBAAsB;gBAClB,wBAAwB;QAChC,qBAAqB;CAC5B;AACD;UACU,WAAW;CACpB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,oBAAoB;QAC5B,mBAAmB;CAC1B;AACD;UACU,0BAA0B;cACtB,uBAAuB;kBACnB,+BAA+B;CAChD;AACD;UACU,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;CACvB;AACD;UACU,kBAAkB;CAC3B;AACD;UACU,0BAA0B;cACtB,uBAAuB;kBACnB,+BAA+B;UACvC,iBAAiB;UACjB,oBAAoB;UACpB,2BAA2B;CACpC;AACD;UACU,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;CACvB;AACD;QACQ,gBAAgB;QAChB,0BAA0B;QAC1B,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;CACzB;AACD;QACQ,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;CACxB;AACD;UACU,YAAY;CACrB;AACD;UACU,sBAAsB;CAC/B;CACA","file":"InvoiceList.vue","sourcesContent":["\n.list-box[data-v-5172555c] {\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: 100vh;\n  max-height: calc(100vh - 150px);\n  margin-top: 20px;\n}\n.list-box table[data-v-5172555c] {\n    margin-top: 0;\n}\n.modal[data-v-5172555c] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.modal .bg-overlay[data-v-5172555c] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n.modal .modal-content[data-v-5172555c] {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    padding: 15px 25px;\n    background: #fff;\n    text-align: center;\n    border-radius: 6px;\n    margin-left: -200px;\n    margin-top: -180px;\n    -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal .modal-content.upload[data-v-5172555c] {\n      top: 50%;\n      width: 900px;\n      height: 550px;\n      margin-top: -265px;\n      margin-left: -450px;\n}\n.modal.show[data-v-5172555c] {\n    display: block;\n}\n.modal.show .modal-content[data-v-5172555c] {\n      display: block;\n      -webkit-animation: slide-down .3s ease-out;\n      -moz-animation: slide-down .3s ease-out;\n}\n.modal .header[data-v-5172555c] {\n    font-size: 24px;\n    font-weight: 600;\n    margin-bottom: 15px;\n    color: #606060;\n}\n.modal .has-error[data-v-5172555c] {\n    color: #f00;\n    background: #ffefef;\n    border: 1px solid #f00;\n    margin-bottom: 10px;\n    border-radius: 2px;\n    font-size: 15px;\n    line-height: 1.6;\n}\n.modal .close[data-v-5172555c] {\n    display: block;\n    margin-top: 5px;\n    font-size: 14px;\n    color: #999;\n    cursor: pointer;\n}\n.modal .close[data-v-5172555c]:hover {\n      text-decoration: underline;\n      color: #555;\n}\n.data-field[data-v-5172555c] {\n  padding: 5px;\n  position: relative;\n}\n.data-field .label[data-v-5172555c] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .label.has-error[data-v-5172555c] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-5172555c] {\n    margin: 1px 0 0;\n    padding: 5px;\n    font-size: 14px;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-5172555c] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-5172555c]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-5172555c] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.invoice-box[data-v-5172555c] {\n  width: 500px;\n}\n.invoice-box .row[data-v-5172555c] {\n    margin-bottom: 20px;\n}\n.invoice-box .data-field[data-v-5172555c] {\n    margin-bottom: 10px;\n    text-align: left;\n}\n.padding-R-s[data-v-5172555c] {\n  padding-right: 5px;\n}\n.padding-L-s[data-v-5172555c] {\n  padding-left: 5px;\n}\n.margin-B-m[data-v-5172555c] {\n  margin-bottom: 10px;\n}\n.margin-T-l[data-v-5172555c] {\n  margin-top: 20px;\n}\n.respond-box[data-v-5172555c] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 4;\n  background: rgba(0, 0, 0, 0.5);\n  display: table;\n}\n.respond-box .vertical-center[data-v-5172555c] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.respond-box .card[data-v-5172555c] {\n    width: 80%;\n    max-width: 500px;\n    margin: 0 auto;\n    padding: 15px;\n    text-align: center;\n}\n.respond-box .fa-check-circle[data-v-5172555c], .respond-box .fa-times-circle[data-v-5172555c] {\n    font-size: 100px;\n    color: #26d97a;\n    margin-bottom: 5px;\n}\n.respond-box .fa-times-circle[data-v-5172555c] {\n    color: #F20D0D;\n}\n.respond-box .label[data-v-5172555c] {\n    font-weight: 600;\n    color: #505050;\n}\n.respond-box .success .label[data-v-5172555c] {\n    padding: 0 40px;\n}\n.respond-box .message[data-v-5172555c] {\n    font-size: 14px;\n    color: #777;\n    margin: 10px 0;\n}\ntable[data-v-5172555c] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n}\ntable thead[data-v-5172555c] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-5172555c] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-5172555c] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-5172555c] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-5172555c] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-5172555c] {\n          color: #ccc;\n}\n.status[data-v-5172555c] {\n  font-size: 12px;\n  padding: 2px 6px;\n  color: #fff;\n  background: #777;\n  display: inline-block;\n  text-transform: uppercase;\n  border-radius: 2px;\n}\n.status.unpaid[data-v-5172555c] {\n    background: #de5050;\n}\n.status.paid[data-v-5172555c] {\n    background: #47bd63;\n}\n@media only screen and (max-width: 430px) {\n.list-box[data-v-5172555c] {\n    display: none;\n}\n.modal.show[data-v-5172555c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.modal.show .invoice-box[data-v-5172555c] {\n      position: unset;\n      margin-left: 0;\n      margin-top: -30px;\n      width: 90%;\n}\n.modal.show .invoice-box .padding-L-s[data-v-5172555c], .modal.show .invoice-box .padding-R-s[data-v-5172555c] {\n        padding: 0;\n}\n.cards-mobile[data-v-5172555c] {\n    display: block;\n    margin-top: 50px;\n}\n.cards-mobile .card[data-v-5172555c] {\n      border: 1px solid #ccc;\n      margin-bottom: 15px;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n}\n.cards-mobile .card .info[data-v-5172555c] {\n        width: 100%;\n        padding-left: 10px;\n}\n.cards-mobile .card > div[data-v-5172555c] {\n        margin-bottom: 3px;\n        width: 100%;\n}\n.cards-mobile .card .email-logo img[data-v-5172555c] {\n        max-width: 100px;\n        max-height: 100px;\n}\n.cards-mobile .card .card-header[data-v-5172555c] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n}\n.cards-mobile .card .card-header .time[data-v-5172555c] {\n          font-size: 12px;\n          color: #777;\n          word-spacing: 5px;\n}\n.cards-mobile .card .card-header .amount[data-v-5172555c] {\n          font-weight: 900;\n          font-size: 20px;\n}\n.cards-mobile .card .card-header .amount a[data-v-5172555c] {\n            text-decoration: none;\n}\n.cards-mobile .card .credit-card[data-v-5172555c] {\n        font-weight: 900;\n}\n.cards-mobile .card .btn-action[data-v-5172555c] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        padding: 20px 10px 0;\n}\n.cards-mobile .card .btn-action a[data-v-5172555c] {\n          width: 50%;\n}\n.cards-mobile .card .title[data-v-5172555c] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        margin-bottom: 3px;\n}\n.cards-mobile .card .title.pkg-div[data-v-5172555c] {\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n}\n.cards-mobile .card .title .pkg-type[data-v-5172555c] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n.cards-mobile .card .title input[data-v-5172555c] {\n          margin-right: 5px;\n}\n.cards-mobile .card .title.view[data-v-5172555c] {\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n          padding-top: 7px;\n          padding-bottom: 5px;\n          border-top: 1px solid #eee;\n}\n.cards-mobile .card .title .refer[data-v-5172555c] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n.cards-mobile .card .label[data-v-5172555c] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards-mobile .card .value[data-v-5172555c] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards-mobile .card .value i[data-v-5172555c] {\n          color: #bbb;\n}\n.cards-mobile .card .value a[data-v-5172555c] {\n          text-decoration: none;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoicePDF_vue__ = __webpack_require__(425);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a88e630_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoicePDF_vue__ = __webpack_require__(1208);
function injectStyle (ssrContext) {
  __webpack_require__(1199)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a88e630"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoicePDF_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a88e630_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoicePDF_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1200);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5965a476", content, true, {});

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n#pdf-view[data-v-5a88e630] {\n  position: fixed;\n  top: 0%;\n  right: 100%;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n  z-index: -1;\n}\n#pdf-view .page[data-v-5a88e630] {\n    padding: 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-5a88e630] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .header-box[data-v-5a88e630] {\n    margin-bottom: 50px;\n}\n#pdf-view .header-box .img-box[data-v-5a88e630] {\n      height: 100px;\n      overflow: hidden;\n      margin: 0 0 10px 15px;\n}\n#pdf-view .header-box .img-box img[data-v-5a88e630] {\n        width: 100px;\n        max-height: 100px;\n}\n#pdf-view .header-box .sales-label[data-v-5a88e630] {\n      font-size: 36px;\n      font-weight: 600;\n      margin-top: 20px;\n      color: #444;\n      text-align: center;\n}\n#pdf-view .header-box .right-info[data-v-5a88e630] {\n      font-size: 12px;\n      line-height: 1.3;\n}\n#pdf-view .header-box .billing-address[data-v-5a88e630], #pdf-view .header-box .invoice-info[data-v-5a88e630] {\n      font-size: 15px;\n      line-height: 1.5;\n}\n#pdf-view .header-box .billing-address .attn[data-v-5a88e630], #pdf-view .header-box .invoice-info .attn[data-v-5a88e630] {\n        font-size: 12px;\n        line-height: 1;\n        color: #999;\n}\n#pdf-view .header-box .billing-address .corporate-name[data-v-5a88e630], #pdf-view .header-box .invoice-info .corporate-name[data-v-5a88e630] {\n        font-size: 21px;\n        font-weight: 600;\n}\n#pdf-view .header-box .billing-address .address[data-v-5a88e630], #pdf-view .header-box .invoice-info .address[data-v-5a88e630] {\n        line-height: 1.3;\n        font-size: 13px;\n        color: #777;\n}\n#pdf-view .header-box .invoice-info div[data-v-5a88e630] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n#pdf-view .header-box .invoice-info b[data-v-5a88e630], #pdf-view .header-box .invoice-info span[data-v-5a88e630] {\n      display: inline-block;\n}\n#pdf-view .header-box .invoice-info b[data-v-5a88e630] {\n      color: #333;\n      width: 170px;\n      text-align: right;\n      padding-right: 10px;\n}\n#pdf-view .header-box .invoice-info span[data-v-5a88e630] {\n      color: #444;\n}\n#pdf-view .invoice-period[data-v-5a88e630] {\n    font-size: 14px;\n    margin-bottom: 5px;\n}\n#pdf-view table[data-v-5a88e630] {\n    width: 100%;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-5a88e630] {\n      font-weight: 600;\n      color: #333;\n      border: 1px solid rgba(0, 0, 0, 0.3);\n      background-color: #f3f3f3;\n}\n#pdf-view table thead th[data-v-5a88e630] {\n        font-size: 13px;\n        padding: 4px;\n}\n#pdf-view table tbody tr[data-v-5a88e630] {\n      background-color: #fff;\n      border: 1px solid rgba(0, 0, 0, 0.3);\n      font-size: 13px;\n}\n#pdf-view table tbody tr[data-v-5a88e630]:nth-child(even) {\n        background: #f6f6f6;\n}\n#pdf-view table tbody td[data-v-5a88e630] {\n      padding: 4px;\n}\n#pdf-view table .date[data-v-5a88e630], #pdf-view table .location[data-v-5a88e630], #pdf-view table .passenger[data-v-5a88e630] {\n      text-align: left;\n}\n#pdf-view table .rsvp-id[data-v-5a88e630] {\n      text-align: center;\n}\n#pdf-view table .location[data-v-5a88e630] {\n      line-height: 1.1;\n}\n#pdf-view table .net-amount[data-v-5a88e630] {\n      text-align: center;\n      width: 120px;\n}\n.total-box[data-v-5a88e630] {\n  text-align: right;\n  padding: 10px 0 0;\n  font-size: 18px;\n  line-height: 1;\n}\n.total-box.records[data-v-5a88e630] {\n    margin-top: 10px;\n}\n.total-box label[data-v-5a88e630] {\n    color: #555;\n}\n.total-box span[data-v-5a88e630] {\n    font-weight: 600;\n    display: inline-block;\n    width: 120px;\n    text-align: right;\n}\n.footer-box[data-v-5a88e630] {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  font-size: 13px;\n  text-align: right;\n  padding: 0 40px 20px 0;\n}\n.modal[data-v-5a88e630] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.modal .bg-overlay[data-v-5a88e630] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n.modal .modal-content[data-v-5a88e630] {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    padding: 15px 25px;\n    background: #fff;\n    text-align: center;\n    border-radius: 6px;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%);\n    -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal .modal-content.upload[data-v-5a88e630] {\n      top: 50%;\n      width: 900px;\n      height: 550px;\n      margin-top: -265px;\n      margin-left: -450px;\n}\n.modal.show[data-v-5a88e630] {\n    display: block;\n}\n.modal.show .modal-content[data-v-5a88e630] {\n      display: block;\n      -webkit-animation: slide-down .3s ease-out;\n      -moz-animation: slide-down .3s ease-out;\n}\n.wait-modal[data-v-5a88e630] {\n  text-align: center;\n}\n.wait-modal div[data-v-5a88e630] {\n    padding: 40px 0;\n}\n.margin-B-m[data-v-5a88e630] {\n  margin-bottom: 10px;\n}\n.margin-T-m[data-v-5a88e630] {\n  margin-top: 10px;\n}\n.margin-B-l[data-v-5a88e630] {\n  margin-bottom: 20px;\n}\n.margin-T-l[data-v-5a88e630] {\n  margin-top: 20px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Corporate/InvoicePDF.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,YAAY;CACb;AACD;IACI,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,aAAa;CAChB;AACD;MACM,mBAAmB;MACnB,aAAa;MACb,YAAY;MACZ,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;CACxB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,cAAc;MACd,iBAAiB;MACjB,sBAAsB;CAC3B;AACD;QACQ,aAAa;QACb,kBAAkB;CACzB;AACD;MACM,gBAAgB;MAChB,iBAAiB;MACjB,iBAAiB;MACjB,YAAY;MACZ,mBAAmB;CACxB;AACD;MACM,gBAAgB;MAChB,iBAAiB;CACtB;AACD;MACM,gBAAgB;MAChB,iBAAiB;CACtB;AACD;QACQ,gBAAgB;QAChB,eAAe;QACf,YAAY;CACnB;AACD;QACQ,gBAAgB;QAChB,iBAAiB;CACxB;AACD;QACQ,iBAAiB;QACjB,gBAAgB;QAChB,YAAY;CACnB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;CACnB;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,YAAY;MACZ,aAAa;MACb,kBAAkB;MAClB,oBAAoB;CACzB;AACD;MACM,YAAY;CACjB;AACD;IACI,gBAAgB;IAChB,mBAAmB;CACtB;AACD;IACI,YAAY;IACZ,0BAA0B;CAC7B;AACD;MACM,iBAAiB;MACjB,YAAY;MACZ,qCAAqC;MACrC,0BAA0B;CAC/B;AACD;QACQ,gBAAgB;QAChB,aAAa;CACpB;AACD;MACM,uBAAuB;MACvB,qCAAqC;MACrC,gBAAgB;CACrB;AACD;QACQ,oBAAoB;CAC3B;AACD;MACM,aAAa;CAClB;AACD;MACM,iBAAiB;CACtB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,iBAAiB;CACtB;AACD;MACM,mBAAmB;MACnB,aAAa;CAClB;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;CAChB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,YAAY;CACf;AACD;IACI,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;IACb,kBAAkB;CACrB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;CACxB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,YAAY;CACb;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;CAChB;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,yCAAyC;YACjC,iCAAiC;IACzC,uDAAuD;YAC/C,+CAA+C;IACvD,cAAc;CACjB;AACD;MACM,SAAS;MACT,aAAa;MACb,cAAc;MACd,mBAAmB;MACnB,oBAAoB;CACzB;AACD;IACI,eAAe;CAClB;AACD;MACM,eAAe;MACf,2CAA2C;MAC3C,wCAAwC;CAC7C;AACD;EACE,mBAAmB;CACpB;AACD;IACI,gBAAgB;CACnB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,iBAAiB;CAClB","file":"InvoicePDF.vue","sourcesContent":["\n#pdf-view[data-v-5a88e630] {\n  position: fixed;\n  top: 0%;\n  right: 100%;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n  z-index: -1;\n}\n#pdf-view .page[data-v-5a88e630] {\n    padding: 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-5a88e630] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .header-box[data-v-5a88e630] {\n    margin-bottom: 50px;\n}\n#pdf-view .header-box .img-box[data-v-5a88e630] {\n      height: 100px;\n      overflow: hidden;\n      margin: 0 0 10px 15px;\n}\n#pdf-view .header-box .img-box img[data-v-5a88e630] {\n        width: 100px;\n        max-height: 100px;\n}\n#pdf-view .header-box .sales-label[data-v-5a88e630] {\n      font-size: 36px;\n      font-weight: 600;\n      margin-top: 20px;\n      color: #444;\n      text-align: center;\n}\n#pdf-view .header-box .right-info[data-v-5a88e630] {\n      font-size: 12px;\n      line-height: 1.3;\n}\n#pdf-view .header-box .billing-address[data-v-5a88e630], #pdf-view .header-box .invoice-info[data-v-5a88e630] {\n      font-size: 15px;\n      line-height: 1.5;\n}\n#pdf-view .header-box .billing-address .attn[data-v-5a88e630], #pdf-view .header-box .invoice-info .attn[data-v-5a88e630] {\n        font-size: 12px;\n        line-height: 1;\n        color: #999;\n}\n#pdf-view .header-box .billing-address .corporate-name[data-v-5a88e630], #pdf-view .header-box .invoice-info .corporate-name[data-v-5a88e630] {\n        font-size: 21px;\n        font-weight: 600;\n}\n#pdf-view .header-box .billing-address .address[data-v-5a88e630], #pdf-view .header-box .invoice-info .address[data-v-5a88e630] {\n        line-height: 1.3;\n        font-size: 13px;\n        color: #777;\n}\n#pdf-view .header-box .invoice-info div[data-v-5a88e630] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n#pdf-view .header-box .invoice-info b[data-v-5a88e630], #pdf-view .header-box .invoice-info span[data-v-5a88e630] {\n      display: inline-block;\n}\n#pdf-view .header-box .invoice-info b[data-v-5a88e630] {\n      color: #333;\n      width: 170px;\n      text-align: right;\n      padding-right: 10px;\n}\n#pdf-view .header-box .invoice-info span[data-v-5a88e630] {\n      color: #444;\n}\n#pdf-view .invoice-period[data-v-5a88e630] {\n    font-size: 14px;\n    margin-bottom: 5px;\n}\n#pdf-view table[data-v-5a88e630] {\n    width: 100%;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-5a88e630] {\n      font-weight: 600;\n      color: #333;\n      border: 1px solid rgba(0, 0, 0, 0.3);\n      background-color: #f3f3f3;\n}\n#pdf-view table thead th[data-v-5a88e630] {\n        font-size: 13px;\n        padding: 4px;\n}\n#pdf-view table tbody tr[data-v-5a88e630] {\n      background-color: #fff;\n      border: 1px solid rgba(0, 0, 0, 0.3);\n      font-size: 13px;\n}\n#pdf-view table tbody tr[data-v-5a88e630]:nth-child(even) {\n        background: #f6f6f6;\n}\n#pdf-view table tbody td[data-v-5a88e630] {\n      padding: 4px;\n}\n#pdf-view table .date[data-v-5a88e630], #pdf-view table .location[data-v-5a88e630], #pdf-view table .passenger[data-v-5a88e630] {\n      text-align: left;\n}\n#pdf-view table .rsvp-id[data-v-5a88e630] {\n      text-align: center;\n}\n#pdf-view table .location[data-v-5a88e630] {\n      line-height: 1.1;\n}\n#pdf-view table .net-amount[data-v-5a88e630] {\n      text-align: center;\n      width: 120px;\n}\n.total-box[data-v-5a88e630] {\n  text-align: right;\n  padding: 10px 0 0;\n  font-size: 18px;\n  line-height: 1;\n}\n.total-box.records[data-v-5a88e630] {\n    margin-top: 10px;\n}\n.total-box label[data-v-5a88e630] {\n    color: #555;\n}\n.total-box span[data-v-5a88e630] {\n    font-weight: 600;\n    display: inline-block;\n    width: 120px;\n    text-align: right;\n}\n.footer-box[data-v-5a88e630] {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  font-size: 13px;\n  text-align: right;\n  padding: 0 40px 20px 0;\n}\n.modal[data-v-5a88e630] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.modal .bg-overlay[data-v-5a88e630] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n.modal .modal-content[data-v-5a88e630] {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    padding: 15px 25px;\n    background: #fff;\n    text-align: center;\n    border-radius: 6px;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%);\n    -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal .modal-content.upload[data-v-5a88e630] {\n      top: 50%;\n      width: 900px;\n      height: 550px;\n      margin-top: -265px;\n      margin-left: -450px;\n}\n.modal.show[data-v-5a88e630] {\n    display: block;\n}\n.modal.show .modal-content[data-v-5a88e630] {\n      display: block;\n      -webkit-animation: slide-down .3s ease-out;\n      -moz-animation: slide-down .3s ease-out;\n}\n.wait-modal[data-v-5a88e630] {\n  text-align: center;\n}\n.wait-modal div[data-v-5a88e630] {\n    padding: 40px 0;\n}\n.margin-B-m[data-v-5a88e630] {\n  margin-bottom: 10px;\n}\n.margin-T-m[data-v-5a88e630] {\n  margin-top: 10px;\n}\n.margin-B-l[data-v-5a88e630] {\n  margin-bottom: 20px;\n}\n.margin-T-l[data-v-5a88e630] {\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105);
__webpack_require__(56);
__webpack_require__(70);
__webpack_require__(1202);
__webpack_require__(1206);
__webpack_require__(1207);
module.exports = __webpack_require__(12).Promise;


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(79);
var global = __webpack_require__(18);
var ctx = __webpack_require__(43);
var classof = __webpack_require__(101);
var $export = __webpack_require__(15);
var isObject = __webpack_require__(36);
var aFunction = __webpack_require__(76);
var anInstance = __webpack_require__(147);
var forOf = __webpack_require__(93);
var speciesConstructor = __webpack_require__(426);
var task = __webpack_require__(427).set;
var microtask = __webpack_require__(1204)();
var newPromiseCapabilityModule = __webpack_require__(148);
var perform = __webpack_require__(428);
var userAgent = __webpack_require__(1205);
var promiseResolve = __webpack_require__(429);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(19)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(149)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(82)($Promise, PROMISE);
__webpack_require__(430)(PROMISE);
Wrapper = __webpack_require__(12)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(174)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1203 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var macrotask = __webpack_require__(427).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(78)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(15);
var core = __webpack_require__(12);
var global = __webpack_require__(18);
var speciesConstructor = __webpack_require__(426);
var promiseResolve = __webpack_require__(429);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(15);
var newPromiseCapability = __webpack_require__(148);
var perform = __webpack_require__(428);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"pdf-view"}},_vm._l((_vm.pdf.data),function(pageData,pageIndex){return _c('div',{key:pageIndex,class:['page', pageIndex]},[(pageIndex === 'page1')?_c('div',{staticClass:"header-box"},[_c('div',{staticClass:"row margin-B-l"},[_c('div',{staticClass:"small-7 column"},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":_vm.profileData.logo}})]),_vm._v(" "),_c('div',{staticClass:"billing-address"},[_c('div',{staticClass:"attn"},[_vm._v("Attn: Accounts Payable")]),_vm._v(" "),_c('div',{staticClass:"corporate-name"},[_vm._v(_vm._s(_vm.profileData.name))]),_vm._v(" "),_c('div',{staticClass:"address"},[_vm._v(_vm._s(_vm.addressLine.line1))]),_vm._v(" "),_c('div',{staticClass:"address"},[_vm._v(_vm._s(_vm.addressLine.line2))])])]),_vm._v(" "),_c('div',{staticClass:"small-5 column"},[_c('div',{staticClass:"sales-label"},[_vm._v("INVOICE")]),_vm._v(" "),_c('div',{staticClass:"invoice-info"},[_c('div',[_c('b',[_vm._v("Invoice Number:")]),_vm._v(" "),_c('span',[_vm._v("INV-"+_vm._s(_vm.invoiceNumber))])]),_vm._v(" "),_c('div',[_c('b',[_vm._v("Invoice Date:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.today))])]),_vm._v(" "),_c('div',[_c('b',[_vm._v("Payment Due Date:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.invoiceData.dueDate))])])])])])]):_vm._e(),_vm._v(" "),(pageIndex === 'page1')?_c('div',{staticClass:"invoice-period"},[_c('b',[_vm._v("Invoice Period:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.invoiceData.dateFrom)+" - "+_vm._s(_vm.invoiceData.dateTo))])]):_vm._e(),_vm._v(" "),_c('table',[_vm._m(0,true),_vm._v(" "),_c('tbody',_vm._l((pageData),function(data,index){return _c('tr',{key:index},[_c('td',{staticClass:"date"},[_vm._v(_vm._s(data.completedDate))]),_vm._v(" "),_c('td',{staticClass:"passenger"},[_vm._v(_vm._s(data.passenger))]),_vm._v(" "),_c('td',{staticClass:"rsvp-id"},[_vm._v(_vm._s(data.id))]),_vm._v(" "),_c('td',{staticClass:"location"},[_vm._v("\n              "+_vm._s(data.pickup)+" - "),_c('br'),_vm._v("\n              "+_vm._s(data.dropoff)+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"net-amount"},[_vm._v("$"+_vm._s(data.total))])])}),0)]),_vm._v(" "),(pageIndex.substr(4) == _vm.totalPage)?_c('div',{staticClass:"total-box records"},[_c('label',[_vm._v("Total Rercords:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.totalRecords))])]):_vm._e(),_vm._v(" "),(pageIndex.substr(4) == _vm.totalPage)?_c('div',{staticClass:"total-box"},[_c('label',[_vm._v("Total Amount:")]),_vm._v(" "),_c('span',[_vm._v("$"+_vm._s(_vm.total))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"footer-box"},[_vm._v("Page "+_vm._s(pageIndex.substr(4))+" of "+_vm._s(_vm.totalPage))])])}),0),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.showWaitModal}},[_c('div',{staticClass:"bg-overlay",on:{"click":function($event){_vm.showWaitModal = false}}}),_vm._v(" "),_c('div',{staticClass:"modal-content wait-modal"},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"button cta block small",on:{"click":function($event){_vm.showWaitModal = false}}},[_vm._v("Close")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',{staticClass:"date"},[_vm._v("Completion Date")]),_vm._v(" "),_c('th',{staticClass:"passenger"},[_vm._v("Passenger Name")]),_vm._v(" "),_c('th',{staticClass:"rsvp-id"},[_vm._v("RSVP ID")]),_vm._v(" "),_c('th',{staticClass:"location"},[_vm._v("Pickup/Dropoff")]),_vm._v(" "),_c('th',{staticClass:"net-amount"},[_vm._v("Amount")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n        Corporate Invoices can only be downloaded once."),_c('br'),_vm._v("\n        Please keep the PDF file safe. Otherwise, "),_c('br'),_vm._v("\n        you will need to generate a new invoice.\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"button cta success",on:{"click":function($event){_vm.invoiceModal.showModal = true}}},[_vm._v("Create Invoice")]),_vm._v(" "),_c('div',{staticClass:"list-box"},[_c('table',[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._l((_vm.invoices),function(invoice){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.invoices.length > 0),expression:"invoices.length > 0"}],key:invoice.id},[_c('td',{staticClass:"id"},[_vm._v(_vm._s(invoice.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoice.startDate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoice.endDate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoice.dueDate))]),_vm._v(" "),_c('td',[_c('span',{class:['status', invoice.status]},[_vm._v(_vm._s(invoice.status))])]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button cta xsmall",attrs:{"target":"_blank","href":'/#/corporate/' + _vm.corporateId + '/invoice/' + invoice.id}},[_vm._v("View")])])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_vm._m(1)]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.invoices.length === 0 && !_vm.loading),expression:"invoices.length === 0 && !loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"6"}},[_vm._v("No Invoices as of yet.")])])],2)])]),_vm._v(" "),_c('div',{staticClass:"cards-mobile"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.invoices.length === 0 && !_vm.loading),expression:"invoices.length === 0 && !loading"}]}),_vm._v(" "),_vm._l((_vm.invoices),function(invoice){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.invoices.length > 0),expression:"invoices.length > 0"}],key:invoice.id,staticClass:"card"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Invoice ID: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(invoice.id))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Invoice Start Date: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(invoice.startDate))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Invoice End Date: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(invoice.endDate))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Invoice Due Date: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(invoice.dueDate))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Status: ")]),_vm._v(" "),_c('div',{class:['value status', invoice.status]},[_vm._v(_vm._s(invoice.status))])]),_vm._v(" "),_c('div',{staticClass:"btn-action"},[_c('a',{staticClass:"button cta xsmall",attrs:{"target":"_blank","href":'/#/corporate/' + _vm.corporateId + '/invoice/' + invoice.id}},[_vm._v("View")])])])})],2),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.invoiceModal.showModal}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeInvoice}}),_vm._v(" "),_c('div',{staticClass:"modal-content invoice-box"},[_c('div',{staticClass:"header"},[_vm._v("Create Invoice")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column medium-6 padding-R-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Date Coverage From")]),_vm._v(" "),_c('datepicker',{class:{'datepicker inline':true, 'has-error':!!_vm.invoiceModal.error.dateFrom},attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.invoiceLoading,"input-class":{'datepicker-empty':_vm.invoiceModal.error.dateFrom},"disabled":_vm.dateMaxYesterday},model:{value:(_vm.invoiceModal.dateFrom),callback:function ($$v) {_vm.$set(_vm.invoiceModal, "dateFrom", $$v)},expression:"invoiceModal.dateFrom"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.invoiceModal.error.dateFrom))])],1)]),_vm._v(" "),_c('div',{staticClass:"column medium-6 padding-L-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Date Coverage To")]),_vm._v(" "),_c('datepicker',{class:{'datepicker inline':true, 'has-error':!!_vm.invoiceModal.error.dateTo},attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.invoiceLoading,"input-class":{'datepicker-empty':_vm.invoiceModal.error.dateTo},"disabled":_vm.dateMaxYesterday},model:{value:(_vm.invoiceModal.dateTo),callback:function ($$v) {_vm.$set(_vm.invoiceModal, "dateTo", $$v)},expression:"invoiceModal.dateTo"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.invoiceModal.error.dateTo))])],1)]),_vm._v(" "),_c('div',{staticClass:"column medium-12"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Payment Due Date")]),_vm._v(" "),_c('datepicker',{class:{'datepicker inline':true, 'has-error':!!_vm.invoiceModal.error.dueDate},attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.invoiceLoading,"input-class":{'datepicker-empty':_vm.invoiceModal.error.dueDate},"disabled":_vm.disabledDueDate},model:{value:(_vm.invoiceModal.dueDate),callback:function ($$v) {_vm.$set(_vm.invoiceModal, "dueDate", $$v)},expression:"invoiceModal.dueDate"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.invoiceModal.error.dueDate))])],1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.invoiceModal.showZeroResults),expression:"invoiceModal.showZeroResults"}],staticClass:"has-error"},[_vm._v("Empty result.")]),_vm._v(" "),_c('button',{class:{'button cta block small':true, 'disabled':_vm.invoiceLoading},on:{"click":_vm.createInvoice}},[(!_vm.invoiceLoading)?_c('span',[_vm._v("Create")]):_c('span',[_vm._v("Loading...")])]),_vm._v(" "),_c('span',{staticClass:"close",on:{"click":_vm.closeInvoice}},[_vm._v("Close")])])]),_vm._v(" "),_c('invoice-pdf',{ref:"invoice",on:{"zeroResults":_vm.zeroResults,"refresh":_vm.createInvoiceSuccess}}),_vm._v(" "),_c('transition',{attrs:{"name":"expand"}},[(_vm.respond.show)?_c('div',{staticClass:"respond-box"},[_c('div',{staticClass:"vertical-center"},[_c('div',{staticClass:"card "},[_c('div',{staticClass:"success"},[(_vm.respond.success)?_c('i',{staticClass:"fas fa-check-circle"}):_c('i',{staticClass:"fas fa-times-circle"}),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.respond.label))]),_vm._v(" "),(!!_vm.respond.message)?_c('div',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.respond.message)}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"button cta block small margin-T-l",on:{"click":_vm.closeRespondModal}},[_vm._v("Close")])])])]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("Invoice Start Date")]),_vm._v(" "),_c('th',[_vm._v("Invoice End Date")]),_vm._v(" "),_c('th',[_vm._v("Due Date")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"table-block",attrs:{"colspan":"6"}},[_c('i',{staticClass:"fa fa-circle-notch fa-spin"}),_vm._v("\n            Getting your invoices...\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CorporateLogs_vue__ = __webpack_require__(431);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dfbc685_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CorporateLogs_vue__ = __webpack_require__(1213);
function injectStyle (ssrContext) {
  __webpack_require__(1211)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dfbc685"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CorporateLogs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dfbc685_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CorporateLogs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1212);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5c3757cc", content, true, {});

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.empty-state[data-v-2dfbc685] {\n  padding: 30px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\n.empty-state .fa[data-v-2dfbc685] {\n    display: block;\n    margin-bottom: 5px;\n    color: #ccc;\n    text-shadow: 0 0 5px white;\n}\n.log[data-v-2dfbc685] {\n  border: 1px solid #ddd;\n  width: 100%;\n  max-height: auto;\n  padding: 10px;\n  background: #fafafa;\n  overflow: hidden;\n  -webkit-transition: all .35s ease-in-out;\n  transition: all .35s ease-in-out;\n  cursor: pointer;\n  margin-bottom: 10px;\n}\n.log[data-v-2dfbc685]:hover {\n    background: #fff8dc;\n}\n.log.collapsed[data-v-2dfbc685] {\n    padding: 10px;\n    background: #fff8dc;\n}\n.log .log-item[data-v-2dfbc685] {\n    padding-left: 15px;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.log .log-item .icon-display[data-v-2dfbc685] {\n      float: left;\n      width: 5%;\n}\n.log .log-item .icon-display i[data-v-2dfbc685] {\n        font-size: 11px;\n        color: #666;\n}\n.log .log-item .log-display[data-v-2dfbc685] {\n      float: left;\n      width: 95%;\n}\n.log .log-item .log-display p[data-v-2dfbc685] {\n        margin: 0;\n}\n.log .log-item .log-details[data-v-2dfbc685] {\n      font-size: 11px;\n      color: #666;\n}\n.log .log-item .log-details[data-v-2dfbc685] br {\n        content: 'a';\n        display: block;\n        margin-bottom: 15px;\n}\n.log .minimize[data-v-2dfbc685] {\n    font-size: 11px;\n    color: #666;\n    content: \"\";\n    clear: both;\n}\n.log .minimize .icon-display[data-v-2dfbc685] {\n      float: left;\n      width: 5%;\n}\n.log .minimize .icon-display i[data-v-2dfbc685] {\n        font-size: 11px;\n        color: #666;\n}\n.log .minimize .log-display[data-v-2dfbc685] {\n      float: left;\n      width: 95%;\n}\n.log .minimize .log-display p[data-v-2dfbc685] {\n        margin: 0;\n}\n.log .field[data-v-2dfbc685] {\n    font-size: 12px;\n    padding: 4px 0 4px 10px;\n}\n.log .field span[data-v-2dfbc685] {\n      display: inline-block;\n}\n.log .field .label[data-v-2dfbc685] {\n      font-weight: 600;\n      margin-right: 10px;\n      color: #28b560;\n      display: block;\n}\n.log .field i[data-v-2dfbc685] {\n      margin: 0 5px;\n      color: #0D79F2;\n}\n.log .field .old[data-v-2dfbc685] {\n      color: #d0d0d0;\n}\n.log .field .old.last[data-v-2dfbc685] {\n        display: none;\n}\n.log .field .new[data-v-2dfbc685] {\n      color: #555;\n      font-weight: 600;\n}\n.log .field.no-arrow i[data-v-2dfbc685] {\n      display: none;\n}\n.log .field.no-arrow .new[data-v-2dfbc685] {\n      display: block;\n}\n.log .field.no-arrow .old.first[data-v-2dfbc685] {\n      display: none;\n}\n.log .field.no-arrow .old.last[data-v-2dfbc685] {\n      display: block;\n      font-size: 12px;\n}\n.slide-down-enter-active[data-v-2dfbc685], .slide-down-leave-active[data-v-2dfbc685] {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.slide-down-enter[data-v-2dfbc685], .slide-down-leave-to[data-v-2dfbc685] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Corporate/CorporateLogs.vue"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;CAC9B;AACD;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,yCAAyC;EACzC,iCAAiC;EACjC,gBAAgB;EAChB,oBAAoB;CACrB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,cAAc;IACd,oBAAoB;CACvB;AACD;IACI,mBAAmB;IACnB,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;MACM,YAAY;MACZ,UAAU;CACf;AACD;QACQ,gBAAgB;QAChB,YAAY;CACnB;AACD;MACM,YAAY;MACZ,WAAW;CAChB;AACD;QACQ,UAAU;CACjB;AACD;MACM,gBAAgB;MAChB,YAAY;CACjB;AACD;QACQ,aAAa;QACb,eAAe;QACf,oBAAoB;CAC3B;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,YAAY;CACf;AACD;MACM,YAAY;MACZ,UAAU;CACf;AACD;QACQ,gBAAgB;QAChB,YAAY;CACnB;AACD;MACM,YAAY;MACZ,WAAW;CAChB;AACD;QACQ,UAAU;CACjB;AACD;IACI,gBAAgB;IAChB,wBAAwB;CAC3B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;MACjB,mBAAmB;MACnB,eAAe;MACf,eAAe;CACpB;AACD;MACM,cAAc;MACd,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;QACQ,cAAc;CACrB;AACD;MACM,YAAY;MACZ,iBAAiB;CACtB;AACD;MACM,cAAc;CACnB;AACD;MACM,eAAe;CACpB;AACD;MACM,cAAc;CACnB;AACD;MACM,eAAe;MACf,gBAAgB;CACrB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ","file":"CorporateLogs.vue","sourcesContent":["\n.empty-state[data-v-2dfbc685] {\n  padding: 30px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\n.empty-state .fa[data-v-2dfbc685] {\n    display: block;\n    margin-bottom: 5px;\n    color: #ccc;\n    text-shadow: 0 0 5px white;\n}\n.log[data-v-2dfbc685] {\n  border: 1px solid #ddd;\n  width: 100%;\n  max-height: auto;\n  padding: 10px;\n  background: #fafafa;\n  overflow: hidden;\n  -webkit-transition: all .35s ease-in-out;\n  transition: all .35s ease-in-out;\n  cursor: pointer;\n  margin-bottom: 10px;\n}\n.log[data-v-2dfbc685]:hover {\n    background: #fff8dc;\n}\n.log.collapsed[data-v-2dfbc685] {\n    padding: 10px;\n    background: #fff8dc;\n}\n.log .log-item[data-v-2dfbc685] {\n    padding-left: 15px;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.log .log-item .icon-display[data-v-2dfbc685] {\n      float: left;\n      width: 5%;\n}\n.log .log-item .icon-display i[data-v-2dfbc685] {\n        font-size: 11px;\n        color: #666;\n}\n.log .log-item .log-display[data-v-2dfbc685] {\n      float: left;\n      width: 95%;\n}\n.log .log-item .log-display p[data-v-2dfbc685] {\n        margin: 0;\n}\n.log .log-item .log-details[data-v-2dfbc685] {\n      font-size: 11px;\n      color: #666;\n}\n.log .log-item .log-details[data-v-2dfbc685] br {\n        content: 'a';\n        display: block;\n        margin-bottom: 15px;\n}\n.log .minimize[data-v-2dfbc685] {\n    font-size: 11px;\n    color: #666;\n    content: \"\";\n    clear: both;\n}\n.log .minimize .icon-display[data-v-2dfbc685] {\n      float: left;\n      width: 5%;\n}\n.log .minimize .icon-display i[data-v-2dfbc685] {\n        font-size: 11px;\n        color: #666;\n}\n.log .minimize .log-display[data-v-2dfbc685] {\n      float: left;\n      width: 95%;\n}\n.log .minimize .log-display p[data-v-2dfbc685] {\n        margin: 0;\n}\n.log .field[data-v-2dfbc685] {\n    font-size: 12px;\n    padding: 4px 0 4px 10px;\n}\n.log .field span[data-v-2dfbc685] {\n      display: inline-block;\n}\n.log .field .label[data-v-2dfbc685] {\n      font-weight: 600;\n      margin-right: 10px;\n      color: #28b560;\n      display: block;\n}\n.log .field i[data-v-2dfbc685] {\n      margin: 0 5px;\n      color: #0D79F2;\n}\n.log .field .old[data-v-2dfbc685] {\n      color: #d0d0d0;\n}\n.log .field .old.last[data-v-2dfbc685] {\n        display: none;\n}\n.log .field .new[data-v-2dfbc685] {\n      color: #555;\n      font-weight: 600;\n}\n.log .field.no-arrow i[data-v-2dfbc685] {\n      display: none;\n}\n.log .field.no-arrow .new[data-v-2dfbc685] {\n      display: block;\n}\n.log .field.no-arrow .old.first[data-v-2dfbc685] {\n      display: none;\n}\n.log .field.no-arrow .old.last[data-v-2dfbc685] {\n      display: block;\n      font-size: 12px;\n}\n.slide-down-enter-active[data-v-2dfbc685], .slide-down-leave-active[data-v-2dfbc685] {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.slide-down-enter[data-v-2dfbc685], .slide-down-leave-to[data-v-2dfbc685] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"empty-state"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-2x"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.logs.length === 0 && !_vm.loading),expression:"logs.length === 0 && !loading"}],staticClass:"empty-state"},[_c('i',{staticClass:"fa fa-clipboard-list fa-4x"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('rsvpDetails.activityLogs.emptyState')))])]),_vm._v(" "),_vm._l((_vm.logs),function(log,i){return _c('div',{key:i,class:{'log':true, 'collapsed':log.collapsed},on:{"click":function($event){log.collapsed = !log.collapsed}}},[_c('div',{staticClass:"minimize"},[_c('div',{staticClass:"icon-display"},[(!log.collapsed)?_c('i',{staticClass:"fa fa-plus-circle"}):_c('i',{staticClass:"fa fa-minus-circle"})]),_vm._v(" "),_c('div',{staticClass:"log-display"},[_c('span',[_vm._v(_vm._s(_vm.dateSplit(log.created).date)+" "+_vm._s(_vm.dateSplit(log.created).time)+"  "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.displayAction(log))}})])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(log.collapsed),expression:"log.collapsed"}],staticClass:"log-item"},[_c('div',{staticClass:"icon-display"}),_vm._v(" "),_c('div',{staticClass:"log-display"},[_c('span',{staticClass:"log-details",domProps:{"innerHTML":_vm._s(_vm.displayLog(log))}})])])])],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{'left-panel':true, 'no-scroll':_vm.respond.show, 'centered':_vm.isCreate}},[_c('div',{staticClass:"heading"},[(!_vm.isCreate)?_c('span',{staticClass:"cons-name"},[_vm._v("\n        "+_vm._s(_vm.corporateInfo.name)+"\n        "),(_vm.corporateInfo.stripeUrl)?_c('a',{staticClass:"stripe-link",attrs:{"href":_vm.corporateInfo.stripeUrl,"target":"_blank"}},[_c('i',{staticClass:"fa fa-link"})]):_vm._e()]):_c('span',{staticClass:"cons-name"},[_vm._v("CREATE PROFILE")]),_vm._v(" "),(!_vm.isCreate)?_c('div',{staticClass:"switch"},[(_vm.corporateInfo.active)?_c('span',{staticClass:"label"},[_vm._v("ACTIVE")]):_c('span',{staticClass:"label"},[_vm._v("DEACTIVATED")]),_vm._v(" "),_c('div',{class:{'slider':true, 'active':_vm.corporateInfo.active, 'disabled':_vm.statusLoading},on:{"click":_vm.toggleStatus}})]):_vm._e()]),_vm._v(" "),_c('div',{class:['body', {'card':_vm.isCreate}]},[_c('div',{class:['collapsible', {'collapse':!_vm.contentShow.discountInfo}]},[_c('div',{staticClass:"head",on:{"click":function($event){_vm.contentShow.billingInfo = !_vm.contentShow.billingInfo}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentShow.billingInfo),expression:"contentShow.billingInfo"}],staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentShow.billingInfo),expression:"!contentShow.billingInfo"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('span',[_vm._v("Discount Information")])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"medium-12 column"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Discount Code")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.discountCode),expression:"corporateInfo.discountCode"}],attrs:{"disabled":_vm.discountList.loading || _vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.corporateInfo, "discountCode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.discountList.list),function(dc,i){return _c('option',{key:i,domProps:{"value":dc.code}},[_vm._v(_vm._s(dc.name))])}),0),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.discountCodeValidation))])])])])]),_vm._v(" "),_c('div',{class:{'collapsible':true, 'collapse':!_vm.contentShow.accountInfo}},[_c('div',{staticClass:"head",on:{"click":function($event){_vm.contentShow.accountInfo = !_vm.contentShow.accountInfo}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentShow.accountInfo),expression:"contentShow.accountInfo"}],staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentShow.accountInfo),expression:"!contentShow.accountInfo"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('span',[_vm._v("Account Information")])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"logo-box"},[_c('span',{staticClass:"recommended"},[_vm._v("Recommended size: 200 x 200 px")]),_vm._v(" "),_c('div',{class:{'img-hover-box':true, 'loading':_vm.upload.loading}},[(_vm.corporateInfo.logo)?_c('img',{attrs:{"src":_vm.corporateInfo.logo}}):_c('i',{staticClass:"fas fa-user-circle"}),_vm._v(" "),_c('div',{staticClass:"button cta small",on:{"click":_vm.triggerUpload}},[_vm._v("CHANGE LOGO")]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.upload.loading),expression:"upload.loading"}],staticClass:"fa fa-spinner fa-spin fa-2x"})])],1),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.upload.message))]),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"uploadInput",attrs:{"type":"file"},on:{"change":_vm.uploadFile}})]),_vm._v(" "),_c('div',{staticClass:"medium-12 column margin-B-m"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Username")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.username),expression:"corporateInfo.username"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading,"name":"username"},domProps:{"value":(_vm.corporateInfo.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "username", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.username))])])]),_vm._v(" "),(_vm.isCreate)?_c('div',{staticClass:"medium-12 column"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.password),expression:"corporateInfo.password"}],staticClass:"input",attrs:{"type":"password","disabled":_vm.loading},domProps:{"value":(_vm.corporateInfo.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.password))])])]):_vm._e(),_vm._v(" "),(_vm.isCreate)?_c('div',{staticClass:"medium-12 column margin-B-m"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Repeat Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.repeatPassword),expression:"repeatPassword"}],staticClass:"input",attrs:{"type":"password","disabled":_vm.loading},domProps:{"value":(_vm.repeatPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.repeatPassword=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.repeatPassword))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"medium-12 column margin-B-m"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Corporate Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.name),expression:"corporateInfo.name"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.corporateInfo.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "name", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.name))])])]),_vm._v(" "),_c('div',{staticClass:"medium-6 column margin-B-m"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.email),expression:"corporateInfo.email"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.corporateInfo.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "email", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.email))])])]),_vm._v(" "),_c('div',{staticClass:"medium-6 column margin-B-m"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Corporate Color")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.color),expression:"corporateInfo.color"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.corporateInfo.color)},on:{"click":function($event){_vm.showEmailColor = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "color", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.color))]),_vm._v(" "),_c('div',{staticClass:"palette",style:({'backgroundColor': '#' + _vm.corporateInfo.color}),on:{"click":function($event){_vm.showEmailColor = true}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEmailColor),expression:"showEmailColor"}],staticClass:"color-picker right"},[_c('chrome-picker',{on:{"input":_vm.updateColor},model:{value:(_vm.emailColors),callback:function ($$v) {_vm.emailColors=$$v},expression:"emailColors"}})],1)])],1)]),_vm._v(" "),_c('div',{staticClass:"medium-12 column margin-B-m"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Mobile")]),_vm._v(" "),_c('div',{class:{'input-group':true}},[_c('div',{staticClass:"country-select input-group-label",on:{"click":_vm.selectCountry}},[_c('span',{staticClass:"country-code"},[_vm._v("(+"+_vm._s(_vm.callingCode)+") ")]),_vm._v(" "),_c('i',{staticClass:"fa fa-caret-down"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.mobile),expression:"corporateInfo.mobile"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.corporateInfo.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "mobile", $event.target.value)}}})]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.mobile))])])]),_vm._v(" "),_c('div',{staticClass:"medium-12 column margin-B-m"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Website")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.website),expression:"corporateInfo.website"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.corporateInfo.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "website", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.website))])])]),_vm._v(" "),(!_vm.isCreate)?_c('div',{staticClass:"medium-12 column margin-B-m"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.password.show),expression:"!password.show"}],staticClass:"button cta small",on:{"click":function($event){_vm.password.show = true}}},[_vm._v("\n              Change Password\n            ")]),_vm._v(" "),_c('transition',{attrs:{"name":"expand"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.password.success),expression:"password.success"}],staticClass:"success-password"},[_vm._v("Successfully changed password!")])]),_vm._v(" "),_c('transition',{attrs:{"name":"expand"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.password.show),expression:"password.show"}],staticClass:"row password-box"},[_c('div',{staticClass:"medium-12 column"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.password),expression:"corporateInfo.password"}],staticClass:"input",attrs:{"type":"password","disabled":_vm.password.loading},domProps:{"value":(_vm.corporateInfo.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.password))])])]),_vm._v(" "),_c('div',{staticClass:"medium-12 column margin-B-m"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Repeat Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.repeatPassword),expression:"repeatPassword"}],staticClass:"input",attrs:{"type":"password","disabled":_vm.password.loading},domProps:{"value":(_vm.repeatPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.repeatPassword=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.repeatPassword))])])]),_vm._v(" "),(_vm.password.message)?_c('div',{staticClass:"medium-12 column margin-B-s has-error"},[_vm._v(_vm._s(_vm.password.message))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"medium-6 column margin-B-m"},[_c('div',{class:{'button cta xsmall block':true, 'disabled':_vm.password.loading},on:{"click":function($event){_vm.password.show = false}}},[_vm._v("Cancel")])]),_vm._v(" "),_c('div',{staticClass:"medium-6 column margin-B-m"},[_c('div',{class:{'button cta xsmall success block':true, 'disabled':_vm.password.loading},on:{"click":_vm.updatePassword}},[_vm._v("Save")])])])])],1):_vm._e()])]),_vm._v(" "),_c('div',{class:{'collapsible':true, 'collapse':!_vm.contentShow.billingInfo}},[_c('div',{staticClass:"head",on:{"click":function($event){_vm.contentShow.billingInfo = !_vm.contentShow.billingInfo}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentShow.billingInfo),expression:"contentShow.billingInfo"}],staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentShow.billingInfo),expression:"!contentShow.billingInfo"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('span',[_vm._v("Billing Information")])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"medium-12 column"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Address1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.billingAddress1),expression:"corporateInfo.billingAddress1"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.corporateInfo.billingAddress1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "billingAddress1", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.billingAddress1))])])]),_vm._v(" "),_c('div',{staticClass:"medium-12 column margin-B-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Address2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.billingAddress2),expression:"corporateInfo.billingAddress2"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.corporateInfo.billingAddress2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "billingAddress2", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"medium-12 column margin-B-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.billingCity),expression:"corporateInfo.billingCity"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.corporateInfo.billingCity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "billingCity", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.billingCity))])])]),_vm._v(" "),_c('div',{staticClass:"medium-6 columns margin-B-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("State")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.billingState),expression:"corporateInfo.billingState"}],class:{'has-error':false},attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.corporateInfo, "billingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}}),_vm._v(" "),_c('option',{attrs:{"value":"NonUS"}},[_vm._v("Non US")]),_vm._v(" "),_vm._l((_vm.states),function(state){return _c('option',{key:state.value,domProps:{"value":state.label}},[_vm._v(_vm._s(state.label))])})],2),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.billingState))])])]),_vm._v(" "),_c('div',{staticClass:"medium-6 column margin-B-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Zip")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.billingZip),expression:"corporateInfo.billingZip"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.corporateInfo.billingZip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporateInfo, "billingZip", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.billingZip))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.corporateInfo.billingState === 'NonUS'),expression:"corporateInfo.billingState === 'NonUS'"}],staticClass:"medium-12 column margin-B-s"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Country")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporateInfo.biilingCountry),expression:"corporateInfo.biilingCountry"}],class:{'input':true, 'has-error':false},attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.corporateInfo, "biilingCountry", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.countries.all),function(country,index){return _c('option',{key:index,domProps:{"value":country.alpha2}},[_vm._v(_vm._s(country.name))])}),0),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.biilingCountry))])])])])])]),_vm._v(" "),_c('div',{staticClass:"fix-buttons"},[_c('div',{staticClass:"medium-12 column"},[_c('div',{staticClass:"button cta success block",on:{"click":_vm.submit}},[(_vm.loading)?_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v("\n            Loading ...\n          ")]):(_vm._corporateId !== 'add')?_c('span',[_vm._v("UPDATE")]):_c('span',[_vm._v("CREATE ACCOUNT")])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"expand"}},[(_vm.respond.show)?_c('div',{staticClass:"respond-box"},[_c('div',{staticClass:"vertical-center"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"success"},[(_vm.respond.success)?_c('i',{staticClass:"fas fa-check-circle"}):_c('i',{staticClass:"fas fa-times-circle"}),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.respond.label))]),_vm._v(" "),(!!_vm.respond.message)?_c('div',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.respond.message)}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"button cta block small margin-T-l",on:{"click":_vm.closeResponModal}},[_vm._v("Close")])])])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"expand"}},[(_vm.confirmCard.show)?_c('div',{staticClass:"confirm-card"},[_c('div',{staticClass:"vertical-center"},[_c('div',{staticClass:"card"},[_vm._v("\n          Are you sure you want to remove credit card?\n\n          "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-6"},[_c('div',{class:{'button cta block xsmall':true, 'disabled':_vm.confirmCard.loading},on:{"click":function($event){_vm.confirmCard.show = false}}},[_vm._v("No")])]),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('div',{class:{'button cta block success xsmall':true, 'disabled':_vm.confirmCard.loading},on:{"click":_vm.removeCard}},[_vm._v("Yes")])])])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"toggle-mobile",on:{"click":function($event){_vm.showRecords = !_vm.showRecords}}},[(!_vm.showRecords)?_c('span',[_vm._v("Show Records "),_c('i',{staticClass:"fa fa-chevron-up"})]):_c('span',[_vm._v("Hide Records "),_c('i',{staticClass:"fa fa-chevron-down"})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCreate),expression:"!isCreate"}],class:['right-panel', _vm.showRecords ? 'mobile-right-panel' : '']},[_c('ul',{staticClass:"tab"},[_c('li',{class:{'active':_vm.activeTab === 0},on:{"click":function($event){_vm.activeTab = 0}}},[_vm._v("Transactions")]),_vm._v(" "),_c('li',{class:{'active':_vm.activeTab === 1},on:{"click":function($event){_vm.activeTab = 1}}},[_vm._v("Credit Card")]),_vm._v(" "),_c('li',{class:{'active':_vm.activeTab === 2},on:{"click":function($event){_vm.activeTab = 2}}},[_vm._v("Invoice")])]),_vm._v(" "),_c('div',{staticClass:"tab-contents"},[_c('div',{class:{'tab-content':true, 'active':_vm.activeTab == 0}},[_c('transaction-filter',{attrs:{"isMobile":_vm.isMobile}}),_vm._v(" "),_c('transaction-list',{attrs:{"isMobile":_vm.isMobile}})],1),_vm._v(" "),_c('div',{class:{'tab-content':true, 'active':_vm.activeTab == 1}},[_c('credit-card',{attrs:{"isMobile":_vm.isMobile}})],1),_vm._v(" "),_c('div',{class:{'tab-content':true, 'active':_vm.activeTab == 2}},[_c('invoice-list',{attrs:{"isMobile":_vm.isMobile}})],1)])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showIconLog),expression:"showIconLog"}],class:{'logs-toggle':true, on: _vm.showRightPanel},on:{"click":_vm.toggleRightPanel}},[_c('i',{class:_vm.iconToggleRightPanel})])]),_vm._v(" "),_c('div',{class:{'toggle-panel': true, hide: _vm.showRightPanel}},[_c('div',{staticClass:"heading"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.history')))]),_vm._v(" "),_c('div',{staticClass:"tab-contents",on:{"scroll":_vm.loadMoreLogs}},[_c('div',{staticClass:"logs"},[_c('corporate-logs',{attrs:{"corporateId":_vm.$route.params.id}})],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingMoreLogs),expression:"loadingMoreLogs"}],staticClass:"infinity-loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" Loading\n      ")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(433);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4ce1e26_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1397);
function injectStyle (ssrContext) {
  __webpack_require__(1216)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e4ce1e26"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4ce1e26_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1217);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("f2af1ed4", content, true, {});

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.rsvp-panel-container[data-v-e4ce1e26] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  width: 890px;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);\n          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);\n  border-right: 1px solid rgba(0, 0, 0, 0.3);\n}\n.rsvp-panel[data-v-e4ce1e26] {\n  position: fixed;\n  top: 101px;\n  left: 0;\n  overflow-y: auto;\n  width: 890px;\n  height: calc(100% - (50px + 51px));\n  z-index: 2;\n  margin-top: 2px;\n}\n.tabs[data-v-e4ce1e26] {\n  position: fixed;\n  top: 50px;\n  left: 0;\n  width: 890px;\n  display: block;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n  border-top: 1px solid rgba(0, 0, 0, 0.3);\n}\n.tabs .tab[data-v-e4ce1e26] {\n    display: inline-block;\n    color: #0D79F2;\n    position: relative;\n    z-index: 2;\n    font-weight: 700;\n    font-size: 14px;\n    padding: 15px 8px;\n    text-decoration: underline;\n    cursor: pointer;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.tabs .tab.selected[data-v-e4ce1e26] {\n      background-color: #fff;\n      border-left: 1px solid rgba(0, 0, 0, 0.3);\n      border-right: 1px solid rgba(0, 0, 0, 0.3);\n      text-decoration: none;\n      cursor: default;\n}\n.tabs .total[data-v-e4ce1e26] {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 1;\n    line-height: 51px;\n    padding: 0 20px;\n    font-size: 14px;\n    color: #333;\n    font-weight: 600;\n}\n.tabs .total span[data-v-e4ce1e26] {\n      color: #555;\n      display: inline-block;\n      margin-left: 3px;\n      font-size: 13px;\n      position: relative;\n      top: -1px;\n      font-weight: 500;\n}\n.tab-content[data-v-e4ce1e26] {\n  display: none;\n  height: 100%;\n  overflow: auto;\n}\n.tab-content.show[data-v-e4ce1e26] {\n    display: block;\n}\n.tab-content.with-control[data-v-e4ce1e26] {\n    height: calc(100% - 80px);\n}\n.tab-content .tab-control[data-v-e4ce1e26] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    background-color: #fff;\n    width: 100%;\n    border-top: 1px solid rgba(0, 0, 0, 0.3);\n    padding: 20px 10px;\n}\n.driver-toggle[data-v-e4ce1e26] {\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 4;\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  text-align: center;\n  color: #777;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  border-radius: 0;\n}\n.driver-toggle i[data-v-e4ce1e26] {\n    line-height: inherit;\n}\n.driver-toggle.on[data-v-e4ce1e26] {\n    background-color: #F25E0D;\n    color: #fff;\n    border-bottom-left-radius: 3px;\n    -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n            box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n}\n.available-drivers[data-v-e4ce1e26] {\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 3;\n  width: 560px;\n  height: 100%;\n  background-color: #f5f5f5;\n  -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n          box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n  border-bottom-left-radius: 3px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.available-drivers.hide[data-v-e4ce1e26] {\n    right: -560px;\n    -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n            box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n}\n.map[data-v-e4ce1e26] {\n  position: fixed;\n  top: 0;\n  z-index: 2;\n  left: 890px;\n  width: calc(100% - 890px);\n  height: 100%;\n}\n.map.shrink[data-v-e4ce1e26] {\n    left: 320px;\n    width: calc(100% - 320px);\n}\n.right-panel[data-v-e4ce1e26] {\n  z-index: 2;\n  position: fixed;\n  top: 0;\n  left: 890px;\n  width: calc(100% - 890px);\n  height: 100%;\n}\n.right-panel .map[data-v-e4ce1e26] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 55%;\n}\n.right-panel .dropzone-container[data-v-e4ce1e26] {\n    position: absolute;\n    top: 55%;\n    left: 0;\n    width: 100%;\n    height: 45%;\n    -webkit-box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.25);\n            box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.25);\n    z-index: 1;\n}\n.header[data-v-e4ce1e26] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 890px;\n  height: calc(50px + 1px);\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  z-index: 3;\n}\n.header .search[data-v-e4ce1e26] {\n    position: absolute;\n    top: 0;\n    left: 50px;\n    width: 350px;\n}\n.header .filter[data-v-e4ce1e26] {\n    position: absolute;\n    top: 0;\n    left: 400px;\n}\n.header .more-filter-trigger[data-v-e4ce1e26] {\n    position: absolute;\n    top: 0;\n    right: 0;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    height: 50px;\n    padding: 0 15px;\n    line-height: 50px;\n    border-top: none;\n    border-bottom: none;\n    background: #fff;\n    color: #555;\n    cursor: pointer;\n}\n.header .more-filter-trigger .fa-filter[data-v-e4ce1e26] {\n      margin-right: 3px;\n      color: #999;\n      -webkit-transition: all .3s ease;\n      transition: all .3s ease;\n      line-height: 50px;\n}\n.header .more-filter-trigger[data-v-e4ce1e26]:hover {\n      color: #333;\n}\n.header .more-filter-trigger:hover i[data-v-e4ce1e26] {\n        color: #333;\n}\n.header .more-filter-trigger.active[data-v-e4ce1e26] {\n      background: #eaf1f3;\n}\n.header .more-filter-trigger.active i[data-v-e4ce1e26] {\n        color: #333;\n}\n.header .more-filter[data-v-e4ce1e26] {\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.coverage-toggle[data-v-e4ce1e26] {\n  position: fixed;\n  top: 60px;\n  right: 0;\n  background-color: #fff;\n  width: 50px;\n  z-index: 4;\n  text-align: center;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  border-top-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.35);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n  padding: 13px 0;\n}\n.coverage-toggle.hide[data-v-e4ce1e26] {\n    right: -50px;\n    opacity: 0;\n}\n.expand-button[data-v-e4ce1e26], .shrink-button[data-v-e4ce1e26] {\n  position: fixed;\n  top: calc(50% - 27px);\n  left: 889px;\n  background-color: #F4F8F9;\n  padding: 15px 8px;\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n  -webkit-box-shadow: 3px 0 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 0 4px rgba(0, 0, 0, 0.3);\n  cursor: pointer;\n}\n.shrink-button[data-v-e4ce1e26] {\n  top: calc(50% + 37px);\n}\n.shrink[data-v-e4ce1e26] {\n  width: 320px;\n}\n.shrink .header[data-v-e4ce1e26], .shrink .rsvp-panel[data-v-e4ce1e26] {\n    width: 320px;\n}\n.shrink .header[data-v-e4ce1e26] {\n    height: calc((50px * 2) + 1px);\n}\n.shrink .header .search[data-v-e4ce1e26] {\n      position: relative;\n      top: 0;\n      left: 50px;\n      width: calc(100% - 50px);\n      border-bottom: 1px solid #ddd;\n}\n.shrink .header .search form[data-v-e4ce1e26] {\n        margin-bottom: 0 !important;\n}\n.shrink .header .filter[data-v-e4ce1e26] {\n      position: relative;\n      left: 0;\n      top: 0;\n      display: inline-block;\n      float: left;\n      width: 80%;\n      border-right: 1px solid #fafafa;\n}\n.shrink .header .more-filter-trigger[data-v-e4ce1e26] {\n      position: relative;\n      left: 0;\n      width: calc(20% - 1px);\n      display: inline-block;\n      float: left;\n      border: none;\n      text-align: center;\n}\n.shrink .rsvp-panel[data-v-e4ce1e26] {\n    top: calc(50px * 2);\n    height: calc(100% - (50px * 2));\n}\n.shrink .expand-button[data-v-e4ce1e26], .shrink .shrink-button[data-v-e4ce1e26] {\n    left: 319px;\n}\n.slide-up-enter-active[data-v-e4ce1e26], .slide-up-leave-active[data-v-e4ce1e26] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-e4ce1e26], .slide-up-leave-to[data-v-e4ce1e26] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.grown-in-enter-active[data-v-e4ce1e26], .grown-in-leave-active[data-v-e4ce1e26] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.grown-in-enter[data-v-e4ce1e26], .grown-in-leave-to[data-v-e4ce1e26] {\n  -webkit-transform: scale(0.98);\n          transform: scale(0.98);\n  opacity: 0;\n}\n.toggle-mobile[data-v-e4ce1e26] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.rsvp-panel-container[data-v-e4ce1e26] {\n    width: 100%;\n}\n.rsvp-panel[data-v-e4ce1e26] {\n    width: 100%;\n    margin: 0;\n    top: 150px;\n    height: calc(100% - 150px);\n}\n.rsvp-panel.hide-top[data-v-e4ce1e26] {\n      top: 101px;\n}\n.toggle-mobile[data-v-e4ce1e26] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 10;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.right-panel[data-v-e4ce1e26] {\n    left: 0;\n    width: 100%;\n    z-index: 5;\n    top: 100%;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n    background-color: #fff;\n}\n.right-panel.showMapBox[data-v-e4ce1e26] {\n      top: 0;\n}\n.right-panel .map[data-v-e4ce1e26] {\n      height: 35%;\n}\n.right-panel .dropzone-container[data-v-e4ce1e26] {\n      top: 35%;\n      height: 65%;\n}\n.tabs[data-v-e4ce1e26] {\n    width: 100%;\n    top: 100px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    overflow-x: scroll;\n    background-color: #fff;\n}\n.tabs.hide-top[data-v-e4ce1e26] {\n      top: 50px;\n}\n.tabs .tab[data-v-e4ce1e26] {\n      -ms-flex-negative: 0;\n          flex-shrink: 0;\n      padding: 14px 20px;\n      border-right: 1px solid rgba(0, 0, 0, 0.3);\n      background-color: #f4f8f9;\n}\n.tabs .total[data-v-e4ce1e26] {\n      display: none;\n}\n.header[data-v-e4ce1e26] {\n    width: 100%;\n}\n.header .search[data-v-e4ce1e26] {\n      width: calc(100% - 50px);\n}\n.header .filter-group[data-v-e4ce1e26] {\n      position: absolute;\n      top: 49px;\n      border: 1px solid #ccc;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      width: 100%;\n}\n.header .filter-group .filter[data-v-e4ce1e26], .header .filter-group .more-filter-trigger[data-v-e4ce1e26] {\n        position: initial;\n}\n.header .filter-group .filter[data-v-e4ce1e26] {\n        width: 60%;\n}\n.header .filter-group .more-filter-trigger[data-v-e4ce1e26] {\n        width: calc(40% - 40px);\n}\n.driver-toggle[data-v-e4ce1e26] {\n    top: 50px;\n    z-index: 14;\n}\n.driver-toggle.hide[data-v-e4ce1e26] {\n      display: none;\n}\n.available-drivers[data-v-e4ce1e26] {\n    z-index: 13;\n    width: 100%;\n}\n.coverage-toggle[data-v-e4ce1e26] {\n    display: none;\n}\n.map[data-v-e4ce1e26] {\n    width: 100%;\n    height: 100%;\n}\n.map.showInMobile[data-v-e4ce1e26] {\n      z-index: 2;\n      left: 0;\n}\n.close-map-button[data-v-e4ce1e26] {\n    display: block;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: 3;\n    width: 50px;\n    height: 50px;\n    line-height: 50px;\n    text-align: center;\n    color: #777;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n    border-radius: 0;\n    background-color: #eee;\n    border-bottom-left-radius: 3px;\n    -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n            box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n}\n.close-map-button i[data-v-e4ce1e26] {\n      line-height: inherit;\n}\n}\n.availability-toggle[data-v-e4ce1e26] {\n  position: fixed;\n  top: 120px;\n  right: 0;\n  z-index: 2;\n  background-color: #fff;\n  width: 50px;\n  text-align: center;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  border-top-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.35);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n  padding: 8px 0;\n}\n.availability-toggle i[data-v-e4ce1e26] {\n    line-height: inherit;\n}\n.availability-toggle.open[data-v-e4ce1e26] {\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0);\n}\n.availability-toggle.hide[data-v-e4ce1e26] {\n    right: -70px;\n}\n.filter-available-drivers[data-v-e4ce1e26] {\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 3;\n  width: 560px;\n  height: 100%;\n  background-color: #f5f5f5;\n  -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n          box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n  border-bottom-left-radius: 3px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.filter-available-drivers.hide[data-v-e4ce1e26] {\n    top: -100%;\n}\n.filter-available-drivers .message[data-v-e4ce1e26] {\n    text-align: center;\n    font-size: 14px;\n    font-weight: 700;\n    padding: 14px;\n    background-color: #0D79F2;\n    color: #fff;\n    width: 100%;\n}\n.filter-available-drivers .close-filter[data-v-e4ce1e26] {\n    width: 50px;\n    padding: 14px 0;\n    text-align: center;\n    background: #579be7;\n    cursor: pointer;\n}\n.filter-available-drivers .close-filter i[data-v-e4ce1e26] {\n      color: #fff;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/index.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;EAClD,2CAA2C;CAC5C;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,mCAAmC;EACnC,WAAW;EACX,gBAAgB;CACjB;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,aAAa;EACb,eAAe;EACf,4CAA4C;EAC5C,yCAAyC;CAC1C;AACD;IACI,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;IAChB,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;MACM,uBAAuB;MACvB,0CAA0C;MAC1C,2CAA2C;MAC3C,sBAAsB;MACtB,gBAAgB;CACrB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;CACpB;AACD;MACM,YAAY;MACZ,sBAAsB;MACtB,iBAAiB;MACjB,gBAAgB;MAChB,mBAAmB;MACnB,UAAU;MACV,iBAAiB;CACtB;AACD;EACE,cAAc;EACd,aAAa;EACb,eAAe;CAChB;AACD;IACI,eAAe;CAClB;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,uBAAuB;IACvB,YAAY;IACZ,yCAAyC;IACzC,mBAAmB;CACtB;AACD;EACE,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;CAClB;AACD;IACI,qBAAqB;CACxB;AACD;IACI,0BAA0B;IAC1B,YAAY;IACZ,+BAA+B;IAC/B,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,SAAS;EACT,WAAW;EACX,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,mDAAmD;UAC3C,2CAA2C;EACnD,+BAA+B;EAC/B,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,cAAc;IACd,gDAAgD;YACxC,wCAAwC;CACnD;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,aAAa;CACd;AACD;IACI,YAAY;IACZ,0BAA0B;CAC7B;AACD;EACE,WAAW;EACX,gBAAgB;EAChB,OAAO;EACP,YAAY;EACZ,0BAA0B;EAC1B,aAAa;CACd;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,YAAY;CACf;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,mDAAmD;YAC3C,2CAA2C;IACnD,WAAW;CACd;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,kDAAkD;UAC1C,0CAA0C;EAClD,WAAW;CACZ;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,WAAW;IACX,aAAa;CAChB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,YAAY;CACf;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,SAAS;IACT,qCAAqC;IACrC,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;CACnB;AACD;MACM,kBAAkB;MAClB,YAAY;MACZ,iCAAiC;MACjC,yBAAyB;MACzB,kBAAkB;CACvB;AACD;MACM,YAAY;CACjB;AACD;QACQ,YAAY;CACnB;AACD;MACM,oBAAoB;CACzB;AACD;QACQ,YAAY;CACnB;AACD;IACI,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,mDAAmD;UAC3C,2CAA2C;EACnD,gBAAgB;EAChB,gBAAgB;CACjB;AACD;IACI,aAAa;IACb,WAAW;CACd;AACD;EACE,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,iDAAiD;UACzC,yCAAyC;EACjD,gBAAgB;CACjB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,aAAa;CACd;AACD;IACI,aAAa;CAChB;AACD;IACI,+BAA+B;CAClC;AACD;MACM,mBAAmB;MACnB,OAAO;MACP,WAAW;MACX,yBAAyB;MACzB,8BAA8B;CACnC;AACD;QACQ,4BAA4B;CACnC;AACD;MACM,mBAAmB;MACnB,QAAQ;MACR,OAAO;MACP,sBAAsB;MACtB,YAAY;MACZ,WAAW;MACX,gCAAgC;CACrC;AACD;MACM,mBAAmB;MACnB,QAAQ;MACR,uBAAuB;MACvB,sBAAsB;MACtB,YAAY;MACZ,aAAa;MACb,mBAAmB;CACxB;AACD;IACI,oBAAoB;IACpB,gCAAgC;CACnC;AACD;IACI,YAAY;CACf;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,WAAW;CACZ;AACD;EACE,cAAc;CACf;AACD;AACA;IACI,YAAY;CACf;AACD;IACI,YAAY;IACZ,UAAU;IACV,WAAW;IACX,2BAA2B;CAC9B;AACD;MACM,WAAW;CAChB;AACD;IACI,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;IACrB,YAAY;IACZ,0BAA0B;IAC1B,iBAAiB;CACpB;AACD;IACI,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,UAAU;IACV,kCAAkC;IAClC,0BAA0B;IAC1B,uBAAuB;CAC1B;AACD;MACM,OAAO;CACZ;AACD;MACM,YAAY;CACjB;AACD;MACM,SAAS;MACT,YAAY;CACjB;AACD;IACI,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;CAC1B;AACD;MACM,UAAU;CACf;AACD;MACM,qBAAqB;UACjB,eAAe;MACnB,mBAAmB;MACnB,2CAA2C;MAC3C,0BAA0B;CAC/B;AACD;MACM,cAAc;CACnB;AACD;IACI,YAAY;CACf;AACD;MACM,yBAAyB;CAC9B;AACD;MACM,mBAAmB;MACnB,UAAU;MACV,uBAAuB;MACvB,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,YAAY;CACjB;AACD;QACQ,kBAAkB;CACzB;AACD;QACQ,WAAW;CAClB;AACD;QACQ,wBAAwB;CAC/B;AACD;IACI,UAAU;IACV,YAAY;CACf;AACD;MACM,cAAc;CACnB;AACD;IACI,YAAY;IACZ,YAAY;CACf;AACD;IACI,cAAc;CACjB;AACD;IACI,YAAY;IACZ,aAAa;CAChB;AACD;MACM,WAAW;MACX,QAAQ;CACb;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,8BAA8B;IAC9B,sBAAsB;IACtB,iBAAiB;IACjB,uBAAuB;IACvB,+BAA+B;IAC/B,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;MACM,qBAAqB;CAC1B;CACA;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,mDAAmD;UAC3C,2CAA2C;EACnD,gBAAgB;EAChB,eAAe;CAChB;AACD;IACI,qBAAqB;CACxB;AACD;IACI,+CAA+C;YACvC,uCAAuC;CAClD;AACD;IACI,aAAa;CAChB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,SAAS;EACT,WAAW;EACX,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,mDAAmD;UAC3C,2CAA2C;EACnD,+BAA+B;EAC/B,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,WAAW;CACd;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,0BAA0B;IAC1B,YAAY;IACZ,YAAY;CACf;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;MACM,YAAY;CACjB","file":"index.vue","sourcesContent":["\n.rsvp-panel-container[data-v-e4ce1e26] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  width: 890px;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);\n          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);\n  border-right: 1px solid rgba(0, 0, 0, 0.3);\n}\n.rsvp-panel[data-v-e4ce1e26] {\n  position: fixed;\n  top: 101px;\n  left: 0;\n  overflow-y: auto;\n  width: 890px;\n  height: calc(100% - (50px + 51px));\n  z-index: 2;\n  margin-top: 2px;\n}\n.tabs[data-v-e4ce1e26] {\n  position: fixed;\n  top: 50px;\n  left: 0;\n  width: 890px;\n  display: block;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n  border-top: 1px solid rgba(0, 0, 0, 0.3);\n}\n.tabs .tab[data-v-e4ce1e26] {\n    display: inline-block;\n    color: #0D79F2;\n    position: relative;\n    z-index: 2;\n    font-weight: 700;\n    font-size: 14px;\n    padding: 15px 8px;\n    text-decoration: underline;\n    cursor: pointer;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.tabs .tab.selected[data-v-e4ce1e26] {\n      background-color: #fff;\n      border-left: 1px solid rgba(0, 0, 0, 0.3);\n      border-right: 1px solid rgba(0, 0, 0, 0.3);\n      text-decoration: none;\n      cursor: default;\n}\n.tabs .total[data-v-e4ce1e26] {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 1;\n    line-height: 51px;\n    padding: 0 20px;\n    font-size: 14px;\n    color: #333;\n    font-weight: 600;\n}\n.tabs .total span[data-v-e4ce1e26] {\n      color: #555;\n      display: inline-block;\n      margin-left: 3px;\n      font-size: 13px;\n      position: relative;\n      top: -1px;\n      font-weight: 500;\n}\n.tab-content[data-v-e4ce1e26] {\n  display: none;\n  height: 100%;\n  overflow: auto;\n}\n.tab-content.show[data-v-e4ce1e26] {\n    display: block;\n}\n.tab-content.with-control[data-v-e4ce1e26] {\n    height: calc(100% - 80px);\n}\n.tab-content .tab-control[data-v-e4ce1e26] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    background-color: #fff;\n    width: 100%;\n    border-top: 1px solid rgba(0, 0, 0, 0.3);\n    padding: 20px 10px;\n}\n.driver-toggle[data-v-e4ce1e26] {\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 4;\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  text-align: center;\n  color: #777;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  border-radius: 0;\n}\n.driver-toggle i[data-v-e4ce1e26] {\n    line-height: inherit;\n}\n.driver-toggle.on[data-v-e4ce1e26] {\n    background-color: #F25E0D;\n    color: #fff;\n    border-bottom-left-radius: 3px;\n    -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n            box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n}\n.available-drivers[data-v-e4ce1e26] {\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 3;\n  width: 560px;\n  height: 100%;\n  background-color: #f5f5f5;\n  -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n          box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n  border-bottom-left-radius: 3px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.available-drivers.hide[data-v-e4ce1e26] {\n    right: -560px;\n    -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n            box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n}\n.map[data-v-e4ce1e26] {\n  position: fixed;\n  top: 0;\n  z-index: 2;\n  left: 890px;\n  width: calc(100% - 890px);\n  height: 100%;\n}\n.map.shrink[data-v-e4ce1e26] {\n    left: 320px;\n    width: calc(100% - 320px);\n}\n.right-panel[data-v-e4ce1e26] {\n  z-index: 2;\n  position: fixed;\n  top: 0;\n  left: 890px;\n  width: calc(100% - 890px);\n  height: 100%;\n}\n.right-panel .map[data-v-e4ce1e26] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 55%;\n}\n.right-panel .dropzone-container[data-v-e4ce1e26] {\n    position: absolute;\n    top: 55%;\n    left: 0;\n    width: 100%;\n    height: 45%;\n    -webkit-box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.25);\n            box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.25);\n    z-index: 1;\n}\n.header[data-v-e4ce1e26] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 890px;\n  height: calc(50px + 1px);\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  z-index: 3;\n}\n.header .search[data-v-e4ce1e26] {\n    position: absolute;\n    top: 0;\n    left: 50px;\n    width: 350px;\n}\n.header .filter[data-v-e4ce1e26] {\n    position: absolute;\n    top: 0;\n    left: 400px;\n}\n.header .more-filter-trigger[data-v-e4ce1e26] {\n    position: absolute;\n    top: 0;\n    right: 0;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    height: 50px;\n    padding: 0 15px;\n    line-height: 50px;\n    border-top: none;\n    border-bottom: none;\n    background: #fff;\n    color: #555;\n    cursor: pointer;\n}\n.header .more-filter-trigger .fa-filter[data-v-e4ce1e26] {\n      margin-right: 3px;\n      color: #999;\n      -webkit-transition: all .3s ease;\n      transition: all .3s ease;\n      line-height: 50px;\n}\n.header .more-filter-trigger[data-v-e4ce1e26]:hover {\n      color: #333;\n}\n.header .more-filter-trigger:hover i[data-v-e4ce1e26] {\n        color: #333;\n}\n.header .more-filter-trigger.active[data-v-e4ce1e26] {\n      background: #eaf1f3;\n}\n.header .more-filter-trigger.active i[data-v-e4ce1e26] {\n        color: #333;\n}\n.header .more-filter[data-v-e4ce1e26] {\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.coverage-toggle[data-v-e4ce1e26] {\n  position: fixed;\n  top: 60px;\n  right: 0;\n  background-color: #fff;\n  width: 50px;\n  z-index: 4;\n  text-align: center;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  border-top-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.35);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n  padding: 13px 0;\n}\n.coverage-toggle.hide[data-v-e4ce1e26] {\n    right: -50px;\n    opacity: 0;\n}\n.expand-button[data-v-e4ce1e26], .shrink-button[data-v-e4ce1e26] {\n  position: fixed;\n  top: calc(50% - 27px);\n  left: 889px;\n  background-color: #F4F8F9;\n  padding: 15px 8px;\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n  -webkit-box-shadow: 3px 0 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 0 4px rgba(0, 0, 0, 0.3);\n  cursor: pointer;\n}\n.shrink-button[data-v-e4ce1e26] {\n  top: calc(50% + 37px);\n}\n.shrink[data-v-e4ce1e26] {\n  width: 320px;\n}\n.shrink .header[data-v-e4ce1e26], .shrink .rsvp-panel[data-v-e4ce1e26] {\n    width: 320px;\n}\n.shrink .header[data-v-e4ce1e26] {\n    height: calc((50px * 2) + 1px);\n}\n.shrink .header .search[data-v-e4ce1e26] {\n      position: relative;\n      top: 0;\n      left: 50px;\n      width: calc(100% - 50px);\n      border-bottom: 1px solid #ddd;\n}\n.shrink .header .search form[data-v-e4ce1e26] {\n        margin-bottom: 0 !important;\n}\n.shrink .header .filter[data-v-e4ce1e26] {\n      position: relative;\n      left: 0;\n      top: 0;\n      display: inline-block;\n      float: left;\n      width: 80%;\n      border-right: 1px solid #fafafa;\n}\n.shrink .header .more-filter-trigger[data-v-e4ce1e26] {\n      position: relative;\n      left: 0;\n      width: calc(20% - 1px);\n      display: inline-block;\n      float: left;\n      border: none;\n      text-align: center;\n}\n.shrink .rsvp-panel[data-v-e4ce1e26] {\n    top: calc(50px * 2);\n    height: calc(100% - (50px * 2));\n}\n.shrink .expand-button[data-v-e4ce1e26], .shrink .shrink-button[data-v-e4ce1e26] {\n    left: 319px;\n}\n.slide-up-enter-active[data-v-e4ce1e26], .slide-up-leave-active[data-v-e4ce1e26] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-e4ce1e26], .slide-up-leave-to[data-v-e4ce1e26] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.grown-in-enter-active[data-v-e4ce1e26], .grown-in-leave-active[data-v-e4ce1e26] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.grown-in-enter[data-v-e4ce1e26], .grown-in-leave-to[data-v-e4ce1e26] {\n  -webkit-transform: scale(0.98);\n          transform: scale(0.98);\n  opacity: 0;\n}\n.toggle-mobile[data-v-e4ce1e26] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.rsvp-panel-container[data-v-e4ce1e26] {\n    width: 100%;\n}\n.rsvp-panel[data-v-e4ce1e26] {\n    width: 100%;\n    margin: 0;\n    top: 150px;\n    height: calc(100% - 150px);\n}\n.rsvp-panel.hide-top[data-v-e4ce1e26] {\n      top: 101px;\n}\n.toggle-mobile[data-v-e4ce1e26] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 10;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.right-panel[data-v-e4ce1e26] {\n    left: 0;\n    width: 100%;\n    z-index: 5;\n    top: 100%;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n    background-color: #fff;\n}\n.right-panel.showMapBox[data-v-e4ce1e26] {\n      top: 0;\n}\n.right-panel .map[data-v-e4ce1e26] {\n      height: 35%;\n}\n.right-panel .dropzone-container[data-v-e4ce1e26] {\n      top: 35%;\n      height: 65%;\n}\n.tabs[data-v-e4ce1e26] {\n    width: 100%;\n    top: 100px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    overflow-x: scroll;\n    background-color: #fff;\n}\n.tabs.hide-top[data-v-e4ce1e26] {\n      top: 50px;\n}\n.tabs .tab[data-v-e4ce1e26] {\n      -ms-flex-negative: 0;\n          flex-shrink: 0;\n      padding: 14px 20px;\n      border-right: 1px solid rgba(0, 0, 0, 0.3);\n      background-color: #f4f8f9;\n}\n.tabs .total[data-v-e4ce1e26] {\n      display: none;\n}\n.header[data-v-e4ce1e26] {\n    width: 100%;\n}\n.header .search[data-v-e4ce1e26] {\n      width: calc(100% - 50px);\n}\n.header .filter-group[data-v-e4ce1e26] {\n      position: absolute;\n      top: 49px;\n      border: 1px solid #ccc;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      width: 100%;\n}\n.header .filter-group .filter[data-v-e4ce1e26], .header .filter-group .more-filter-trigger[data-v-e4ce1e26] {\n        position: initial;\n}\n.header .filter-group .filter[data-v-e4ce1e26] {\n        width: 60%;\n}\n.header .filter-group .more-filter-trigger[data-v-e4ce1e26] {\n        width: calc(40% - 40px);\n}\n.driver-toggle[data-v-e4ce1e26] {\n    top: 50px;\n    z-index: 14;\n}\n.driver-toggle.hide[data-v-e4ce1e26] {\n      display: none;\n}\n.available-drivers[data-v-e4ce1e26] {\n    z-index: 13;\n    width: 100%;\n}\n.coverage-toggle[data-v-e4ce1e26] {\n    display: none;\n}\n.map[data-v-e4ce1e26] {\n    width: 100%;\n    height: 100%;\n}\n.map.showInMobile[data-v-e4ce1e26] {\n      z-index: 2;\n      left: 0;\n}\n.close-map-button[data-v-e4ce1e26] {\n    display: block;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: 3;\n    width: 50px;\n    height: 50px;\n    line-height: 50px;\n    text-align: center;\n    color: #777;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n    border-radius: 0;\n    background-color: #eee;\n    border-bottom-left-radius: 3px;\n    -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n            box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n}\n.close-map-button i[data-v-e4ce1e26] {\n      line-height: inherit;\n}\n}\n.availability-toggle[data-v-e4ce1e26] {\n  position: fixed;\n  top: 120px;\n  right: 0;\n  z-index: 2;\n  background-color: #fff;\n  width: 50px;\n  text-align: center;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  border-top-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.35);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n  padding: 8px 0;\n}\n.availability-toggle i[data-v-e4ce1e26] {\n    line-height: inherit;\n}\n.availability-toggle.open[data-v-e4ce1e26] {\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0);\n}\n.availability-toggle.hide[data-v-e4ce1e26] {\n    right: -70px;\n}\n.filter-available-drivers[data-v-e4ce1e26] {\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 3;\n  width: 560px;\n  height: 100%;\n  background-color: #f5f5f5;\n  -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n          box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n  border-bottom-left-radius: 3px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.filter-available-drivers.hide[data-v-e4ce1e26] {\n    top: -100%;\n}\n.filter-available-drivers .message[data-v-e4ce1e26] {\n    text-align: center;\n    font-size: 14px;\n    font-weight: 700;\n    padding: 14px;\n    background-color: #0D79F2;\n    color: #fff;\n    width: 100%;\n}\n.filter-available-drivers .close-filter[data-v-e4ce1e26] {\n    width: 50px;\n    padding: 14px 0;\n    text-align: center;\n    background: #579be7;\n    cursor: pointer;\n}\n.filter-available-drivers .close-filter i[data-v-e4ce1e26] {\n      color: #fff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1219);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("7bad036b", content, true, {});

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.tabs[data-v-2954aa28] {\n  display: block;\n  width: 100%;\n}\n.tabs a[data-v-2954aa28] {\n    cursor: pointer;\n}\n.tabs .tab[data-v-2954aa28] {\n    display: block;\n    width: calc(100% / 4);\n    float: left;\n    text-align: center;\n    padding: 15px;\n    font-size: 12px;\n    font-weight: 700;\n    background-color: #e5e5e5;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n    text-decoration: none;\n}\n.tabs .tab.active[data-v-2954aa28] {\n      background-color: #fff;\n      border-left: 1px solid rgba(0, 0, 0, 0.2);\n      border-right: 1px solid rgba(0, 0, 0, 0.2);\n      border-bottom: 1px solid #fff;\n      pointer-events: none;\n}\n.tab-content-container[data-v-2954aa28] {\n  position: absolute;\n  top: 257px;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 268px - 107px);\n  background-color: #f5f5f5;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  padding: 15px;\n  overflow-y: auto;\n}\n.tab-content-container.extend[data-v-2954aa28] {\n    height: calc(100% - 200px - 107px);\n}\n.tab-content-container .tab-content[data-v-2954aa28] {\n    display: none;\n}\n.tab-content-container .tab-content table[data-v-2954aa28] {\n      margin: 0 auto;\n}\n.tab-content-container .tab-content.active[data-v-2954aa28] {\n      display: block;\n}\n.tab-content-container.staging-drivers[data-v-2954aa28] {\n    top: 49px;\n    border-top: 0;\n    background-color: #fff;\n    height: calc(100% - 49px - 107px);\n}\n@media only screen and (max-width: 430px) {\n.tabs[data-v-2954aa28] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    overflow-x: scroll;\n}\n.tabs .tab[data-v-2954aa28] {\n      width: auto;\n      -ms-flex-negative: 0;\n          flex-shrink: 0;\n}\n.tab-content[data-v-2954aa28] {\n    padding-bottom: 30px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/AvailableDrivers.vue"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,YAAY;CACb;AACD;IACI,gBAAgB;CACnB;AACD;IACI,eAAe;IACf,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,4CAA4C;IAC5C,8BAA8B;IAC9B,sBAAsB;IACtB,sBAAsB;CACzB;AACD;MACM,uBAAuB;MACvB,0CAA0C;MAC1C,2CAA2C;MAC3C,8BAA8B;MAC9B,qBAAqB;CAC1B;AACD;EACE,mBAAmB;EACnB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,mCAAmC;EACnC,0BAA0B;EAC1B,qCAAqC;EACrC,cAAc;EACd,iBAAiB;CAClB;AACD;IACI,mCAAmC;CACtC;AACD;IACI,cAAc;CACjB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;IACI,UAAU;IACV,cAAc;IACd,uBAAuB;IACvB,kCAAkC;CACrC;AACD;AACA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,mBAAmB;CACtB;AACD;MACM,YAAY;MACZ,qBAAqB;UACjB,eAAe;CACxB;AACD;IACI,qBAAqB;CACxB;CACA","file":"AvailableDrivers.vue","sourcesContent":["\n.tabs[data-v-2954aa28] {\n  display: block;\n  width: 100%;\n}\n.tabs a[data-v-2954aa28] {\n    cursor: pointer;\n}\n.tabs .tab[data-v-2954aa28] {\n    display: block;\n    width: calc(100% / 4);\n    float: left;\n    text-align: center;\n    padding: 15px;\n    font-size: 12px;\n    font-weight: 700;\n    background-color: #e5e5e5;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n    text-decoration: none;\n}\n.tabs .tab.active[data-v-2954aa28] {\n      background-color: #fff;\n      border-left: 1px solid rgba(0, 0, 0, 0.2);\n      border-right: 1px solid rgba(0, 0, 0, 0.2);\n      border-bottom: 1px solid #fff;\n      pointer-events: none;\n}\n.tab-content-container[data-v-2954aa28] {\n  position: absolute;\n  top: 257px;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 268px - 107px);\n  background-color: #f5f5f5;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  padding: 15px;\n  overflow-y: auto;\n}\n.tab-content-container.extend[data-v-2954aa28] {\n    height: calc(100% - 200px - 107px);\n}\n.tab-content-container .tab-content[data-v-2954aa28] {\n    display: none;\n}\n.tab-content-container .tab-content table[data-v-2954aa28] {\n      margin: 0 auto;\n}\n.tab-content-container .tab-content.active[data-v-2954aa28] {\n      display: block;\n}\n.tab-content-container.staging-drivers[data-v-2954aa28] {\n    top: 49px;\n    border-top: 0;\n    background-color: #fff;\n    height: calc(100% - 49px - 107px);\n}\n@media only screen and (max-width: 430px) {\n.tabs[data-v-2954aa28] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    overflow-x: scroll;\n}\n.tabs .tab[data-v-2954aa28] {\n      width: auto;\n      -ms-flex-negative: 0;\n          flex-shrink: 0;\n}\n.tab-content[data-v-2954aa28] {\n    padding-bottom: 30px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverAvailability_vue__ = __webpack_require__(436);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cd1f2ba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverAvailability_vue__ = __webpack_require__(1223);
function injectStyle (ssrContext) {
  __webpack_require__(1221)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1cd1f2ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverAvailability_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cd1f2ba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverAvailability_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1222);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("932d0d26", content, true, {});

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.sector-name[data-v-1cd1f2ba] {\n  font-size: 18px;\n  margin-bottom: 15px;\n}\n.no-drivers[data-v-1cd1f2ba] {\n  text-align: center;\n  font-size: 14px;\n  font-weight: 600;\n  color: #555;\n}\n.instructions[data-v-1cd1f2ba], .availability-loader[data-v-1cd1f2ba] {\n  text-align: center;\n  padding: 30px 0;\n  font-weight: 600;\n  color: #555;\n}\n.instructions .message[data-v-1cd1f2ba], .availability-loader .message[data-v-1cd1f2ba] {\n    margin-top: 10px;\n}\n.drivers[data-v-1cd1f2ba] {\n  margin-bottom: 30px;\n}\n.drivers .title[data-v-1cd1f2ba] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #777;\n    margin-bottom: 10px;\n    position: relative;\n}\n.drivers .title > span[data-v-1cd1f2ba] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.drivers .title > .driver-count[data-v-1cd1f2ba] {\n      position: absolute;\n      right: 0;\n}\ntable[data-v-1cd1f2ba] {\n  border-collapse: collapse;\n  width: 100%;\n}\n.table-header[data-v-1cd1f2ba] {\n  color: #8DA0A9;\n  font-size: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n}\n.table-header th[data-v-1cd1f2ba] {\n    padding: 5px 10px;\n}\n.table-header th.sortable[data-v-1cd1f2ba] {\n      cursor: pointer;\n      text-decoration: underline;\n      color: #333;\n      -webkit-transition: all 250ms;\n      transition: all 250ms;\n}\n.table-header th.sortable.disabled[data-v-1cd1f2ba] {\n        pointer-events: none;\n        opacity: 0.5;\n}\n.driver[data-v-1cd1f2ba] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.driver.new[data-v-1cd1f2ba] {\n    border-left: 5px solid #F25E0D;\n}\n.driver td[data-v-1cd1f2ba] {\n    padding: 10px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.driver td.map-button[data-v-1cd1f2ba] {\n      padding: 10px 0;\n}\n.driver td.map-button a[data-v-1cd1f2ba] {\n        color: #fff;\n        background-color: #aaa;\n        width: 30px;\n        height: 30px;\n        line-height: 30px;\n        text-align: center;\n        display: inline-block;\n        border-radius: 30px;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.driver td.map-button a i[data-v-1cd1f2ba] {\n          line-height: inherit;\n}\n.driver td.map-button a.disabled[data-v-1cd1f2ba] {\n          pointer-events: none;\n          opacity: 0.5;\n          background-color: #bbb;\n}\n.driver td.map-button a.selected[data-v-1cd1f2ba] {\n          background-color: #26D97A;\n}\n.driver td input[data-v-1cd1f2ba] {\n      margin-top: 0;\n      width: 13px;\n}\n.driver a[data-v-1cd1f2ba] {\n    font-weight: 700;\n}\n.driver .driver-shift[data-v-1cd1f2ba] {\n    font-weight: 600;\n}\n.driver .driver-shift.success[data-v-1cd1f2ba] {\n      color: #26D97A;\n}\n.driver .driver-shift.warning[data-v-1cd1f2ba] {\n      color: #F25E0D;\n}\n.driver .driver-shift.error[data-v-1cd1f2ba] {\n      color: #F20D0D;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/DriverAvailability.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,oBAAoB;CACrB;AACD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;CACb;AACD;IACI,iBAAiB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,uBAAuB;CAC5B;AACD;MACM,mBAAmB;MACnB,SAAS;CACd;AACD;EACE,0BAA0B;EAC1B,YAAY;CACb;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,0BAA0B;CAC3B;AACD;IACI,kBAAkB;CACrB;AACD;MACM,gBAAgB;MAChB,2BAA2B;MAC3B,YAAY;MACZ,8BAA8B;MAC9B,sBAAsB;CAC3B;AACD;QACQ,qBAAqB;QACrB,aAAa;CACpB;AACD;EACE,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;CACpB;AACD;IACI,+BAA+B;CAClC;AACD;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;CACtB;AACD;MACM,gBAAgB;CACrB;AACD;QACQ,YAAY;QACZ,uBAAuB;QACvB,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,mBAAmB;QACnB,sBAAsB;QACtB,oBAAoB;QACpB,8BAA8B;QAC9B,sBAAsB;CAC7B;AACD;UACU,qBAAqB;CAC9B;AACD;UACU,qBAAqB;UACrB,aAAa;UACb,uBAAuB;CAChC;AACD;UACU,0BAA0B;CACnC;AACD;MACM,cAAc;MACd,YAAY;CACjB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,iBAAiB;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB","file":"DriverAvailability.vue","sourcesContent":["\n.sector-name[data-v-1cd1f2ba] {\n  font-size: 18px;\n  margin-bottom: 15px;\n}\n.no-drivers[data-v-1cd1f2ba] {\n  text-align: center;\n  font-size: 14px;\n  font-weight: 600;\n  color: #555;\n}\n.instructions[data-v-1cd1f2ba], .availability-loader[data-v-1cd1f2ba] {\n  text-align: center;\n  padding: 30px 0;\n  font-weight: 600;\n  color: #555;\n}\n.instructions .message[data-v-1cd1f2ba], .availability-loader .message[data-v-1cd1f2ba] {\n    margin-top: 10px;\n}\n.drivers[data-v-1cd1f2ba] {\n  margin-bottom: 30px;\n}\n.drivers .title[data-v-1cd1f2ba] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #777;\n    margin-bottom: 10px;\n    position: relative;\n}\n.drivers .title > span[data-v-1cd1f2ba] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.drivers .title > .driver-count[data-v-1cd1f2ba] {\n      position: absolute;\n      right: 0;\n}\ntable[data-v-1cd1f2ba] {\n  border-collapse: collapse;\n  width: 100%;\n}\n.table-header[data-v-1cd1f2ba] {\n  color: #8DA0A9;\n  font-size: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n}\n.table-header th[data-v-1cd1f2ba] {\n    padding: 5px 10px;\n}\n.table-header th.sortable[data-v-1cd1f2ba] {\n      cursor: pointer;\n      text-decoration: underline;\n      color: #333;\n      -webkit-transition: all 250ms;\n      transition: all 250ms;\n}\n.table-header th.sortable.disabled[data-v-1cd1f2ba] {\n        pointer-events: none;\n        opacity: 0.5;\n}\n.driver[data-v-1cd1f2ba] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.driver.new[data-v-1cd1f2ba] {\n    border-left: 5px solid #F25E0D;\n}\n.driver td[data-v-1cd1f2ba] {\n    padding: 10px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.driver td.map-button[data-v-1cd1f2ba] {\n      padding: 10px 0;\n}\n.driver td.map-button a[data-v-1cd1f2ba] {\n        color: #fff;\n        background-color: #aaa;\n        width: 30px;\n        height: 30px;\n        line-height: 30px;\n        text-align: center;\n        display: inline-block;\n        border-radius: 30px;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.driver td.map-button a i[data-v-1cd1f2ba] {\n          line-height: inherit;\n}\n.driver td.map-button a.disabled[data-v-1cd1f2ba] {\n          pointer-events: none;\n          opacity: 0.5;\n          background-color: #bbb;\n}\n.driver td.map-button a.selected[data-v-1cd1f2ba] {\n          background-color: #26D97A;\n}\n.driver td input[data-v-1cd1f2ba] {\n      margin-top: 0;\n      width: 13px;\n}\n.driver a[data-v-1cd1f2ba] {\n    font-weight: 700;\n}\n.driver .driver-shift[data-v-1cd1f2ba] {\n    font-weight: 600;\n}\n.driver .driver-shift.success[data-v-1cd1f2ba] {\n      color: #26D97A;\n}\n.driver .driver-shift.warning[data-v-1cd1f2ba] {\n      color: #F25E0D;\n}\n.driver .driver-shift.error[data-v-1cd1f2ba] {\n      color: #F20D0D;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[((_vm.rsvpInMap.id === null && _vm.tabActive.rsvp !== 'runs') || (_vm.tabActive.rsvp === 'runs' && _vm.runsStore.other.runsInMap.length !== 1))?_c('div',{staticClass:"instructions"},[_vm._v("\n    Click on the pin map icon on the reservations table to search for drivers with availability.\n    "),(_vm.tabActive.rsvp === 'runs')?_c('div',{staticClass:"message"},[_vm._v("Please select only one "),_c('b',[_vm._v("RUN")]),_vm._v(" to enable Driver Availability function.")]):_vm._e()]):_vm._e(),_vm._v(" "),((_vm.rsvpInMap.id !== null || _vm.runsStore.other.runsInMap.length === 1) && _vm.isLoading)?_c('div',{staticClass:"availability-loader"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-3x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("Searching for drivers with availability...")])]):_vm._e(),_vm._v(" "),(((_vm.rsvpInMap.id !== null && _vm.tabActive.rsvp !== 'runs') || (_vm.tabActive.rsvp === 'runs' && _vm.runsStore.other.runsInMap.length === 1)) && !_vm.isLoading)?_c('div',[_c('div',{staticClass:"sector-name"},[_vm._v(_vm._s(_vm.sectorName))]),_vm._v(" "),_c('div',{staticClass:"drivers work"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v("DRIVERS WITH AVAILABILITY")]),_vm._v(" "),_c('span',{staticClass:"driver-count"},[_vm._v("TOTAL: "+_vm._s(_vm.drivers.work.length))])]),_vm._v(" "),(_vm.drivers.work.length > 0)?_c('table',[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.drivers.work),function(driver){return _c('tr',{staticClass:"driver"},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDriver),expression:"selectedDriver"}],attrs:{"type":"radio","name":"seletedDriver"},domProps:{"value":driver.driverId,"checked":_vm._q(_vm.selectedDriver,driver.driverId)},on:{"change":function($event){_vm.selectedDriver=driver.driverId}}})]),_vm._v(" "),_c('td',{staticClass:"id"},[_c('a',{attrs:{"href":'/#/provider/' + driver.driverId,"target":"_blank"}},[_vm._v(_vm._s(driver.driverId))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(driver.firstName)+" "+_vm._s(driver.lastName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.sectorName))]),_vm._v(" "),_c('td',{class:[ 'driver-shift', driver.shiftState ]},[_vm._v(_vm._s(_vm.formatShiftTimes(driver.shiftStart)))]),_vm._v(" "),_c('td',{class:[ 'driver-shift', driver.shiftState ]},[_vm._v(_vm._s(_vm.formatShiftTimes(driver.shiftEnd)))]),_vm._v(" "),_c('td',[_vm._v("Available")])])}),0)]):_c('div',{staticClass:"no-drivers"},[_vm._v("Sorry but we can't find drivers with availability for sector "+_vm._s(_vm.sectorName)+".")])]),_vm._v(" "),_c('div',{staticClass:"drivers home"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v("HOME-BASED DRIVERS")]),_vm._v(" "),_c('span',{staticClass:"driver-count"},[_vm._v("TOTAL: "+_vm._s(_vm.drivers.home.length))])]),_vm._v(" "),(_vm.drivers.home.length > 0)?_c('table',[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.drivers.home),function(driver){return _c('tr',{staticClass:"driver"},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDriver),expression:"selectedDriver"}],attrs:{"type":"radio","name":"seletedDriver"},domProps:{"value":driver.driverId,"checked":_vm._q(_vm.selectedDriver,driver.driverId)},on:{"change":function($event){_vm.selectedDriver=driver.driverId}}})]),_vm._v(" "),_c('td',{staticClass:"id"},[_c('a',{attrs:{"href":'/#/provider/' + driver.driverId,"target":"_blank"}},[_vm._v(_vm._s(driver.driverId))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(driver.firstName)+" "+_vm._s(driver.lastName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.sectorName))]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(driver.rsvp === null ? 'Available' : 'Ongoing'))]),_vm._v(" "),(driver.rsvp !== null)?_c('span',[_vm._v("\n                ("),_c('a',{attrs:{"href":'/#/reservation/' + driver.rsvp.rsvpId,"target":"_blank"}},[_vm._v(_vm._s(driver.rsvp.rsvpId))]),_vm._v(")\n              ")]):_vm._e()])])}),0)]):_c('div',{staticClass:"no-drivers"},[_vm._v("Sorry but we can't find drivers that are home-based in sector "+_vm._s(_vm.sectorName)+".")])]),_vm._v(" "),_c('div',{staticClass:"drivers home unavailable"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v("DRIVERS WITHOUT AVAILABILITY")]),_vm._v(" "),_c('span',{staticClass:"driver-count"},[_vm._v("TOTAL: "+_vm._s(_vm.unavailableDrivers.list.length))])]),_vm._v(" "),(_vm.unavailableDrivers.list.length > 0)?_c('table',[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.unavailableDrivers.list),function(driver){return _c('tr',{staticClass:"driver"},[_c('td',{staticClass:"id"},[_c('a',{attrs:{"href":'/#/provider/' + driver.id,"target":"_blank"}},[_vm._v(_vm._s(driver.id))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(driver.firstName)+" "+_vm._s(driver.lastName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(driver.mobile))])])}),0)]):_c('div',{staticClass:"no-drivers"},[_vm._v("Sorry but we can't find drivers that are unavailable right now.")])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"table-header"},[_c('th'),_vm._v(" "),_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("NAME")]),_vm._v(" "),_c('th',[_vm._v("SECTOR")]),_vm._v(" "),_c('th',[_vm._v("SHIFT START")]),_vm._v(" "),_c('th',[_vm._v("SHIFT END")]),_vm._v(" "),_c('th',[_vm._v("STATUS")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"table-header"},[_c('th'),_vm._v(" "),_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("NAME")]),_vm._v(" "),_c('th',[_vm._v("SECTOR")]),_vm._v(" "),_c('th',[_vm._v("STATUS")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"table-header"},[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("NAME")]),_vm._v(" "),_c('th',[_vm._v("PHONE")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1225);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("8518779e", content, true, {});

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.driver-controls[data-v-461a91ea] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 15px 15px 15px;\n  background-color: #fff;\n  border-left: 1px solid rgba(0, 0, 0, 0.2);\n  border-right: 1px solid rgba(0, 0, 0, 0.2);\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n}\n.padding-R[data-v-461a91ea] {\n  padding-right: 5px;\n}\n.padding-L[data-v-461a91ea] {\n  padding-left: 5px;\n}\n.margin-T[data-v-461a91ea] {\n  margin-top: 10px;\n}\n.dispatch-modal[data-v-461a91ea] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.dispatch-modal.show[data-v-461a91ea] {\n    top: 0;\n    opacity: 1;\n}\n.dispatch-modal .option[data-v-461a91ea] {\n    display: block;\n    width: 300px;\n    margin: 0 auto;\n    text-align: left;\n}\n.dispatch-modal .option input[type=radio][data-v-461a91ea] {\n      width: auto;\n      display: inline-block;\n      margin-right: 5px;\n      margin-top: 0;\n}\n.dispatch-modal .option span.s[data-v-461a91ea] {\n      display: inline-block;\n      font-size: 14px;\n      color: #444;\n}\n.dispatch-modal-container[data-v-461a91ea] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.dispatch-modal-content[data-v-461a91ea] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.validation-modal .title[data-v-461a91ea] {\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n  background-color: #F25E0D;\n  padding: 8px 15px;\n}\n.validation-modal .message[data-v-461a91ea] {\n  font-size: 16px;\n  font-weight: 700;\n  color: #555;\n  padding: 15px 15px 10px;\n}\n.validation-modal .button[data-v-461a91ea] {\n  font-weight: 700;\n}\n.validation-modal .cancel[data-v-461a91ea] {\n  margin-top: 10px;\n  color: #999;\n  display: inline-block;\n}\n.action-modal[data-v-461a91ea] {\n  padding: 15px;\n}\n.action-modal .message[data-v-461a91ea] {\n    font-weight: 700;\n    color: #777;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.action-modal .message.success[data-v-461a91ea] {\n      color: #26D97A;\n}\n.action-modal .message.error[data-v-461a91ea] {\n      color: #F20D0D;\n}\n.circle-loader[data-v-461a91ea] {\n  margin: 0 0 10px 10px;\n  border: 5px solid rgba(0, 0, 0, 0.2);\n  border-left-color: #26D97A;\n  -webkit-animation-name: loader-spin-data-v-461a91ea;\n          animation-name: loader-spin-data-v-461a91ea;\n  -webkit-animation-duration: 1s;\n          animation-duration: 1s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n.circle-loader[data-v-461a91ea],\n.circle-loader[data-v-461a91ea]:after {\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n}\n.load-complete[data-v-461a91ea] {\n  -webkit-animation: none;\n  animation: none;\n  border-color: #26D97A;\n  -webkit-transition: border 500ms ease-out;\n  transition: border 500ms ease-out;\n}\n.load-error[data-v-461a91ea] {\n  -webkit-animation: none;\n  animation: none;\n  border-color: #F20D0D;\n  -webkit-transition: border 500ms ease-out;\n  transition: border 500ms ease-out;\n}\n.checkmark[data-v-461a91ea] {\n  opacity: 0;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n.checkmark.draw[data-v-461a91ea] {\n    opacity: 1;\n}\n.checkmark.draw[data-v-461a91ea]:after {\n    opacity: 1;\n    height: 25px;\n    width: 12.5px;\n    -webkit-transform-origin: left top;\n            transform-origin: left top;\n    border-right: 5px solid #26D97A;\n    border-top: 5px solid #26D97A;\n    content: '';\n    left: calc(12.5px - 5px);\n    top: calc(25px + 2px);\n    position: absolute;\n    -webkit-animation-duration: 1.2s;\n            animation-duration: 1.2s;\n    -webkit-animation-timing-function: ease;\n            animation-timing-function: ease;\n    -webkit-animation-name: checkmark-data-v-461a91ea;\n            animation-name: checkmark-data-v-461a91ea;\n    -webkit-transform: scaleX(-1) rotate(135deg);\n            transform: scaleX(-1) rotate(135deg);\n}\n.checkmark.error[data-v-461a91ea] {\n    position: absolute;\n    left: calc(12.5px - 2px);\n    top: 12.5px;\n    width: 25px;\n    height: 25px;\n    opacity: 0;\n}\n.checkmark.error.show[data-v-461a91ea] {\n      opacity: 1;\n}\n.checkmark.error[data-v-461a91ea]:before, .checkmark.error[data-v-461a91ea]:after {\n      position: absolute;\n      content: ' ';\n      height: 25px;\n      width: 5px;\n      background-color: #f00;\n}\n.checkmark.error[data-v-461a91ea]:before {\n      -webkit-transform: rotate(45deg);\n              transform: rotate(45deg);\n}\n.checkmark.error[data-v-461a91ea]:after {\n      -webkit-transform: rotate(-45deg);\n              transform: rotate(-45deg);\n}\n@-webkit-keyframes loader-spin-data-v-461a91ea {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes loader-spin-data-v-461a91ea {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@-webkit-keyframes checkmark-data-v-461a91ea {\n0% {\n    height: 0;\n    width: 0;\n    opacity: 1;\n}\n20% {\n    height: 0;\n    width: 12.5px;\n    opacity: 1;\n}\n40% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n100% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n}\n@keyframes checkmark-data-v-461a91ea {\n0% {\n    height: 0;\n    width: 0;\n    opacity: 1;\n}\n20% {\n    height: 0;\n    width: 12.5px;\n    opacity: 1;\n}\n40% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n100% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n}\n.input-integer > *[data-v-461a91ea] {\n  display: inline-block;\n  vertical-align: middle;\n  margin-top: 5px;\n}\ninput[type=\"number\"][data-v-461a91ea] {\n  font-size: 14px;\n  padding: 7px 10px;\n  display: inline-block;\n  width: 200px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-integer span[data-v-461a91ea] {\n  font-size: 12px;\n  background-color: #555;\n  color: #fff;\n  padding: 9px 10px 10px;\n  margin-left: -5px;\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n.button.lyft[data-v-461a91ea] {\n  width: calc(100% - 10px);\n  margin-left: 10px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/DriverControls.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,wBAAwB;EACxB,uBAAuB;EACvB,0CAA0C;EAC1C,2CAA2C;EAC3C,yCAAyC;CAC1C;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;IACI,eAAe;IACf,aAAa;IACb,eAAe;IACf,iBAAiB;CACpB;AACD;MACM,YAAY;MACZ,sBAAsB;MACtB,kBAAkB;MAClB,cAAc;CACnB;AACD;MACM,sBAAsB;MACtB,gBAAgB;MAChB,YAAY;CACjB;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,iBAAiB;CAClB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;CACnB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;CACzB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;CACvB;AACD;EACE,cAAc;CACf;AACD;IACI,iBAAiB;IACjB,YAAY;IACZ,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;EACE,sBAAsB;EACtB,qCAAqC;EACrC,2BAA2B;EAC3B,oDAAoD;UAC5C,4CAA4C;EACpD,+BAA+B;UACvB,uBAAuB;EAC/B,4CAA4C;UACpC,oCAAoC;EAC5C,0CAA0C;UAClC,kCAAkC;EAC1C,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,gCAAgC;UACxB,wBAAwB;CACjC;AACD;;EAEE,mBAAmB;EACnB,YAAY;EACZ,aAAa;CACd;AACD;EACE,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,kCAAkC;CACnC;AACD;EACE,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,kCAAkC;CACnC;AACD;EACE,WAAW;EACX,gCAAgC;UACxB,wBAAwB;CACjC;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,mCAAmC;YAC3B,2BAA2B;IACnC,gCAAgC;IAChC,8BAA8B;IAC9B,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,iCAAiC;YACzB,yBAAyB;IACjC,wCAAwC;YAChC,gCAAgC;IACxC,kDAAkD;YAC1C,0CAA0C;IAClD,6CAA6C;YACrC,qCAAqC;CAChD;AACD;IACI,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,WAAW;CACd;AACD;MACM,WAAW;CAChB;AACD;MACM,mBAAmB;MACnB,aAAa;MACb,aAAa;MACb,WAAW;MACX,uBAAuB;CAC5B;AACD;MACM,iCAAiC;cACzB,yBAAyB;CACtC;AACD;MACM,kCAAkC;cAC1B,0BAA0B;CACvC;AACD;AACA;IACI,gCAAgC;YACxB,wBAAwB;CACnC;AACD;IACI,kCAAkC;YAC1B,0BAA0B;CACrC;CACA;AACD;AACA;IACI,gCAAgC;YACxB,wBAAwB;CACnC;AACD;IACI,kCAAkC;YAC1B,0BAA0B;CACrC;CACA;AACD;AACA;IACI,UAAU;IACV,SAAS;IACT,WAAW;CACd;AACD;IACI,UAAU;IACV,cAAc;IACd,WAAW;CACd;AACD;IACI,aAAa;IACb,cAAc;IACd,WAAW;CACd;AACD;IACI,aAAa;IACb,cAAc;IACd,WAAW;CACd;CACA;AACD;AACA;IACI,UAAU;IACV,SAAS;IACT,WAAW;CACd;AACD;IACI,UAAU;IACV,cAAc;IACd,WAAW;CACd;AACD;IACI,aAAa;IACb,cAAc;IACd,WAAW;CACd;AACD;IACI,aAAa;IACb,cAAc;IACd,WAAW;CACd;CACA;AACD;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;CACjB;AACD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,2BAA2B;EAC3B,8BAA8B;CAC/B;AACD;EACE,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;CACjC;AACD;EACE,yBAAyB;EACzB,kBAAkB;CACnB","file":"DriverControls.vue","sourcesContent":["\n.driver-controls[data-v-461a91ea] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 15px 15px 15px;\n  background-color: #fff;\n  border-left: 1px solid rgba(0, 0, 0, 0.2);\n  border-right: 1px solid rgba(0, 0, 0, 0.2);\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n}\n.padding-R[data-v-461a91ea] {\n  padding-right: 5px;\n}\n.padding-L[data-v-461a91ea] {\n  padding-left: 5px;\n}\n.margin-T[data-v-461a91ea] {\n  margin-top: 10px;\n}\n.dispatch-modal[data-v-461a91ea] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.dispatch-modal.show[data-v-461a91ea] {\n    top: 0;\n    opacity: 1;\n}\n.dispatch-modal .option[data-v-461a91ea] {\n    display: block;\n    width: 300px;\n    margin: 0 auto;\n    text-align: left;\n}\n.dispatch-modal .option input[type=radio][data-v-461a91ea] {\n      width: auto;\n      display: inline-block;\n      margin-right: 5px;\n      margin-top: 0;\n}\n.dispatch-modal .option span.s[data-v-461a91ea] {\n      display: inline-block;\n      font-size: 14px;\n      color: #444;\n}\n.dispatch-modal-container[data-v-461a91ea] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.dispatch-modal-content[data-v-461a91ea] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.validation-modal .title[data-v-461a91ea] {\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n  background-color: #F25E0D;\n  padding: 8px 15px;\n}\n.validation-modal .message[data-v-461a91ea] {\n  font-size: 16px;\n  font-weight: 700;\n  color: #555;\n  padding: 15px 15px 10px;\n}\n.validation-modal .button[data-v-461a91ea] {\n  font-weight: 700;\n}\n.validation-modal .cancel[data-v-461a91ea] {\n  margin-top: 10px;\n  color: #999;\n  display: inline-block;\n}\n.action-modal[data-v-461a91ea] {\n  padding: 15px;\n}\n.action-modal .message[data-v-461a91ea] {\n    font-weight: 700;\n    color: #777;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.action-modal .message.success[data-v-461a91ea] {\n      color: #26D97A;\n}\n.action-modal .message.error[data-v-461a91ea] {\n      color: #F20D0D;\n}\n.circle-loader[data-v-461a91ea] {\n  margin: 0 0 10px 10px;\n  border: 5px solid rgba(0, 0, 0, 0.2);\n  border-left-color: #26D97A;\n  -webkit-animation-name: loader-spin-data-v-461a91ea;\n          animation-name: loader-spin-data-v-461a91ea;\n  -webkit-animation-duration: 1s;\n          animation-duration: 1s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n.circle-loader[data-v-461a91ea],\n.circle-loader[data-v-461a91ea]:after {\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n}\n.load-complete[data-v-461a91ea] {\n  -webkit-animation: none;\n  animation: none;\n  border-color: #26D97A;\n  -webkit-transition: border 500ms ease-out;\n  transition: border 500ms ease-out;\n}\n.load-error[data-v-461a91ea] {\n  -webkit-animation: none;\n  animation: none;\n  border-color: #F20D0D;\n  -webkit-transition: border 500ms ease-out;\n  transition: border 500ms ease-out;\n}\n.checkmark[data-v-461a91ea] {\n  opacity: 0;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n.checkmark.draw[data-v-461a91ea] {\n    opacity: 1;\n}\n.checkmark.draw[data-v-461a91ea]:after {\n    opacity: 1;\n    height: 25px;\n    width: 12.5px;\n    -webkit-transform-origin: left top;\n            transform-origin: left top;\n    border-right: 5px solid #26D97A;\n    border-top: 5px solid #26D97A;\n    content: '';\n    left: calc(12.5px - 5px);\n    top: calc(25px + 2px);\n    position: absolute;\n    -webkit-animation-duration: 1.2s;\n            animation-duration: 1.2s;\n    -webkit-animation-timing-function: ease;\n            animation-timing-function: ease;\n    -webkit-animation-name: checkmark-data-v-461a91ea;\n            animation-name: checkmark-data-v-461a91ea;\n    -webkit-transform: scaleX(-1) rotate(135deg);\n            transform: scaleX(-1) rotate(135deg);\n}\n.checkmark.error[data-v-461a91ea] {\n    position: absolute;\n    left: calc(12.5px - 2px);\n    top: 12.5px;\n    width: 25px;\n    height: 25px;\n    opacity: 0;\n}\n.checkmark.error.show[data-v-461a91ea] {\n      opacity: 1;\n}\n.checkmark.error[data-v-461a91ea]:before, .checkmark.error[data-v-461a91ea]:after {\n      position: absolute;\n      content: ' ';\n      height: 25px;\n      width: 5px;\n      background-color: #f00;\n}\n.checkmark.error[data-v-461a91ea]:before {\n      -webkit-transform: rotate(45deg);\n              transform: rotate(45deg);\n}\n.checkmark.error[data-v-461a91ea]:after {\n      -webkit-transform: rotate(-45deg);\n              transform: rotate(-45deg);\n}\n@-webkit-keyframes loader-spin-data-v-461a91ea {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes loader-spin-data-v-461a91ea {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@-webkit-keyframes checkmark-data-v-461a91ea {\n0% {\n    height: 0;\n    width: 0;\n    opacity: 1;\n}\n20% {\n    height: 0;\n    width: 12.5px;\n    opacity: 1;\n}\n40% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n100% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n}\n@keyframes checkmark-data-v-461a91ea {\n0% {\n    height: 0;\n    width: 0;\n    opacity: 1;\n}\n20% {\n    height: 0;\n    width: 12.5px;\n    opacity: 1;\n}\n40% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n100% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n}\n.input-integer > *[data-v-461a91ea] {\n  display: inline-block;\n  vertical-align: middle;\n  margin-top: 5px;\n}\ninput[type=\"number\"][data-v-461a91ea] {\n  font-size: 14px;\n  padding: 7px 10px;\n  display: inline-block;\n  width: 200px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-integer span[data-v-461a91ea] {\n  font-size: 12px;\n  background-color: #555;\n  color: #fff;\n  padding: 9px 10px 10px;\n  margin-left: -5px;\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n.button.lyft[data-v-461a91ea] {\n  width: calc(100% - 10px);\n  margin-left: 10px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"driver-controls"},[_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentDispatchTab !== 3),expression:"currentDispatchTab !== 3"}],class:['columns padding-R', _vm.currentDispatchTab === 0 ? 'small-4' : 'small-6' ]},[_c('a',{staticClass:"button cta small success block",attrs:{"href":"javascript:;"},on:{"click":_vm.confirmSendToDriver}},[_vm._v("SEND TO DRIVER")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentDispatchTab === 0),expression:"currentDispatchTab === 0"}],staticClass:"small-4 columns padding-R"},[_c('a',{class:{'button cta small success block':true, 'disabled':_vm.scheduleLoading},attrs:{"href":"javascript:;"},on:{"click":_vm.sendAsSchedule}},[(_vm.scheduleLoading)?_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin fa-fw"}),_vm._v(" Loading...")]):_c('span',[_vm._v("SEND AS SCHEDULE")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentDispatchTab !== 3),expression:"currentDispatchTab !== 3"}],class:['columns padding-L', _vm.currentDispatchTab === 0 ? 'small-4' : 'small-6' ]},[_c('a',{staticClass:"button cta small warning block",attrs:{"href":"javascript:;"},on:{"click":_vm.sendToDriver}},[_vm._v("SEND AS ASAP")])])]),_vm._v(" "),_c('div',{class:['row', {'margin-T': _vm.currentDispatchTab !== 3}]},[(_vm.currentDispatchTab === 3)?_c('div',{staticClass:"small-6 columns padding-R"},[_c('a',{staticClass:"button cta success small block",attrs:{"href":"javascript:;"},on:{"click":_vm.confirmSendToDriver}},[_vm._v("SEND TO DRIVER")])]):_vm._e(),_vm._v(" "),_c('div',{class:['columns small-6']},[_c('a',{staticClass:"button cta small block",attrs:{"href":"javascript:;"},on:{"click":_vm.assignToDriver}},[_vm._v("ASSIGN TO DRIVER")])]),_vm._v(" "),(_vm.currentDispatchTab === 0)?_c('div',{class:['columns small-6']},[_c('a',{staticClass:"button cta small block lyft",attrs:{"href":"javascript:;"},on:{"click":_vm.sendToLyft}},[_vm._v("SEND TO LYFT")])]):_vm._e()]),_vm._v(" "),(_vm.currentDispatchTab === 3)?_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('a',{staticClass:"button cta small block",attrs:{"href":"javascript:;"},on:{"click":_vm.moveToPool}},[_vm._v("MOVE TO POOL")])]),_vm._v(" "),_c('div',{staticClass:"columns small-6"},[_c('a',{staticClass:"button cta error small block",attrs:{"href":"javascript:;"},on:{"click":_vm.removeFromPool}},[_vm._v("REMOVE FROM POOL")])])]):_vm._e(),_vm._v(" "),_c('div',{class:['dispatch-modal', {show: _vm.modal.show}],on:{"click":_vm.close}},[_c('div',{staticClass:"dispatch-modal-container"},[_c('div',{staticClass:"dispatch-modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"validation-modal"},[_c('div',{staticClass:"title"},[_vm._v("Send to driver")]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("Accept Request Timeout")]),_vm._v(" "),_c('label',{staticClass:"option",on:{"click":function($event){_vm.modal.option = 'default'}}},[(_vm.modal.show)?_c('input',{attrs:{"type":"radio","name":"crt","checked":"checked"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"s"},[_vm._v("Default ("+_vm._s(_vm.$settings.get('RunNewdispatchTimer'))+" sec)")])]),_vm._v(" "),_c('label',{staticClass:"option",on:{"click":function($event){_vm.modal.option = 'custom'}}},[(_vm.modal.show)?_c('input',{attrs:{"type":"radio","name":"crt"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-integer",staticStyle:{"display":"inline-block"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modal.custom),expression:"modal.custom"}],attrs:{"type":"number"},domProps:{"value":(_vm.modal.custom)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modal, "custom", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v("secs")])])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"10px 50px","margin":"30px 0 10px"}},[_c('a',{staticClass:"button success block",attrs:{"href":"javascript:;"},on:{"click":_vm._sendToDriver}},[_vm._v("Yes")]),_vm._v(" "),_c('a',{staticClass:"cancel",attrs:{"href":"javascript:;"},on:{"click":_vm.close}},[_vm._v("No, I change my mind")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverListFilters_vue__ = __webpack_require__(439);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff34c270_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverListFilters_vue__ = __webpack_require__(1230);
function injectStyle (ssrContext) {
  __webpack_require__(1228)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ff34c270"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverListFilters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff34c270_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverListFilters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1229);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("b309e648", content, true, {});

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.driver-filters[data-v-ff34c270] {\n  padding: 50px 15px 15px;\n  border-left: 1px solid rgba(0, 0, 0, 0.2);\n  border-right: 1px solid rgba(0, 0, 0, 0.2);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n  background-color: #fff;\n}\n.driver-filters .title[data-v-ff34c270] {\n    color: #8DA0A9;\n    font-size: 12px;\n    font-weight: 700;\n    margin-bottom: 5px;\n    margin-top: 15px;\n}\n.driver-filters input[data-v-ff34c270] {\n    line-height: inherit;\n    font-size: 14px;\n    margin-top: 0;\n    background-color: #f5f5f5;\n}\n.driver-filters .service-types label[data-v-ff34c270] {\n    display: block;\n}\n.driver-filters .service-types label *[data-v-ff34c270] {\n      display: inline-block;\n      margin-top: 0;\n      width: auto;\n}\n.driver-filters .service-types span[data-v-ff34c270] {\n    font-size: 14px;\n}\n.driver-filters button[data-v-ff34c270] {\n    margin-top: 10px;\n}\n.service-type-filter[data-v-ff34c270] {\n  margin-top: 10px;\n}\n.divider[data-v-ff34c270] {\n  width: 100%;\n  border-top: 1px solid rgba(0, 0, 0, 0.15);\n  margin: 10px auto 15px;\n}\n@media only screen and (max-width: 430px) {\n.driver-filters[data-v-ff34c270] {\n    padding-top: 40px;\n}\n.driver-filters .title[data-v-ff34c270] {\n      margin-top: 0px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/DriverListFilters.vue"],"names":[],"mappings":";AACA;EACE,wBAAwB;EACxB,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;EAC5C,uBAAuB;CACxB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;CACpB;AACD;IACI,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,0BAA0B;CAC7B;AACD;IACI,eAAe;CAClB;AACD;MACM,sBAAsB;MACtB,cAAc;MACd,YAAY;CACjB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;CACxB;AACD;AACA;IACI,kBAAkB;CACrB;AACD;MACM,gBAAgB;CACrB;CACA","file":"DriverListFilters.vue","sourcesContent":["\n.driver-filters[data-v-ff34c270] {\n  padding: 50px 15px 15px;\n  border-left: 1px solid rgba(0, 0, 0, 0.2);\n  border-right: 1px solid rgba(0, 0, 0, 0.2);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n  background-color: #fff;\n}\n.driver-filters .title[data-v-ff34c270] {\n    color: #8DA0A9;\n    font-size: 12px;\n    font-weight: 700;\n    margin-bottom: 5px;\n    margin-top: 15px;\n}\n.driver-filters input[data-v-ff34c270] {\n    line-height: inherit;\n    font-size: 14px;\n    margin-top: 0;\n    background-color: #f5f5f5;\n}\n.driver-filters .service-types label[data-v-ff34c270] {\n    display: block;\n}\n.driver-filters .service-types label *[data-v-ff34c270] {\n      display: inline-block;\n      margin-top: 0;\n      width: auto;\n}\n.driver-filters .service-types span[data-v-ff34c270] {\n    font-size: 14px;\n}\n.driver-filters button[data-v-ff34c270] {\n    margin-top: 10px;\n}\n.service-type-filter[data-v-ff34c270] {\n  margin-top: 10px;\n}\n.divider[data-v-ff34c270] {\n  width: 100%;\n  border-top: 1px solid rgba(0, 0, 0, 0.15);\n  margin: 10px auto 15px;\n}\n@media only screen and (max-width: 430px) {\n.driver-filters[data-v-ff34c270] {\n    padding-top: 40px;\n}\n.driver-filters .title[data-v-ff34c270] {\n      margin-top: 0px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"driver-filters",on:{"submit":function($event){$event.preventDefault();return _vm.applyFilters.apply(null, arguments)}}},[_c('div',{staticClass:"search"},[_c('div',{staticClass:"title"},[_vm._v("DRIVER SEARCH:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSearch),expression:"filterSearch"}],attrs:{"type":"text","placeholder":"Type and hit enter to search."},domProps:{"value":(_vm.filterSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filterSearch=$event.target.value}}})]),_vm._v(" "),(_vm.useOldQuatation)?_c('div',{staticClass:"service-types"},[_c('div',{staticClass:"title"},[_vm._v("SERVICE TYPE FILTERS:")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-4 columns end"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterServiceTypes),expression:"filterServiceTypes"}],attrs:{"type":"checkbox","value":"shared"},domProps:{"checked":Array.isArray(_vm.filterServiceTypes)?_vm._i(_vm.filterServiceTypes,"shared")>-1:(_vm.filterServiceTypes)},on:{"change":function($event){var $$a=_vm.filterServiceTypes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="shared",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterServiceTypes=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterServiceTypes=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterServiceTypes=$$c}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.serviceLabel('shared'))+" ("+_vm._s(_vm.serviceCount['shared'])+")")])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns end"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterServiceTypes),expression:"filterServiceTypes"}],attrs:{"type":"checkbox","value":"opoli"},domProps:{"checked":Array.isArray(_vm.filterServiceTypes)?_vm._i(_vm.filterServiceTypes,"opoli")>-1:(_vm.filterServiceTypes)},on:{"change":function($event){var $$a=_vm.filterServiceTypes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="opoli",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterServiceTypes=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterServiceTypes=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterServiceTypes=$$c}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.serviceLabel('opoli'))+" ("+_vm._s(_vm.serviceCount['opoli'])+")")])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns end"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterServiceTypes),expression:"filterServiceTypes"}],attrs:{"type":"checkbox","value":"black"},domProps:{"checked":Array.isArray(_vm.filterServiceTypes)?_vm._i(_vm.filterServiceTypes,"black")>-1:(_vm.filterServiceTypes)},on:{"change":function($event){var $$a=_vm.filterServiceTypes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="black",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterServiceTypes=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterServiceTypes=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterServiceTypes=$$c}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.serviceLabel('black'))+" ("+_vm._s(_vm.serviceCount['black'])+")")])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns end"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterServiceTypes),expression:"filterServiceTypes"}],attrs:{"type":"checkbox","value":"suv"},domProps:{"checked":Array.isArray(_vm.filterServiceTypes)?_vm._i(_vm.filterServiceTypes,"suv")>-1:(_vm.filterServiceTypes)},on:{"change":function($event){var $$a=_vm.filterServiceTypes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="suv",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterServiceTypes=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterServiceTypes=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterServiceTypes=$$c}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.serviceLabel('suv'))+" ("+_vm._s(_vm.serviceCount['suv'])+")")])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns end"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterServiceTypes),expression:"filterServiceTypes"}],attrs:{"type":"checkbox","value":"shuttle"},domProps:{"checked":Array.isArray(_vm.filterServiceTypes)?_vm._i(_vm.filterServiceTypes,"shuttle")>-1:(_vm.filterServiceTypes)},on:{"change":function($event){var $$a=_vm.filterServiceTypes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="shuttle",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterServiceTypes=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterServiceTypes=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterServiceTypes=$$c}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.serviceLabel('shuttle'))+" ("+_vm._s(_vm.serviceCount['shuttle'])+")")])])])]),_vm._v(" "),_c('button',{class:{ 'cta small block success': true, disabled: _vm.applyingFilters }},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.applyingFilters),expression:"!applyingFilters"}]},[_vm._v("APPLY FILTER")]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.applyingFilters),expression:"applyingFilters"}],staticClass:"fas fa-spinner fa-spin"})])]):_c('div',[_c('div',{class:{ 'button xsmall block service-type-filter': true, disabled: _vm.applyingFilters },on:{"click":_vm.showServiceFilterModal}},[_c('span',[_vm._v("SERVICE TYPE FILTER")])]),_vm._v(" "),_c('button',{class:{ 'cta small block success': true, disabled: _vm.applyingFilters }},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.applyingFilters),expression:"!applyingFilters"}]},[_vm._v("APPLY FILTER")]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.applyingFilters),expression:"applyingFilters"}],staticClass:"fas fa-spinner fa-spin"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverTable_vue__ = __webpack_require__(440);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218b9aa0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverTable_vue__ = __webpack_require__(1237);
function injectStyle (ssrContext) {
  __webpack_require__(1232)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-218b9aa0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218b9aa0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1233);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("483fa5a7", content, true, {});

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.service-type[data-v-218b9aa0] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-218b9aa0] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-218b9aa0] {\n    background: #26D97A;\n}\n.service-type.black[data-v-218b9aa0] {\n    background: #777;\n}\n.service-type.suv[data-v-218b9aa0] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-218b9aa0] {\n    background: #6dabc3;\n}\n.license-type[data-v-218b9aa0] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-218b9aa0] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-218b9aa0] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-218b9aa0] {\n    background-color: #de6c2a;\n}\n.total[data-v-218b9aa0] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #777;\n  position: relative;\n  text-align: right;\n  margin-bottom: 5px;\n}\ntable[data-v-218b9aa0] {\n  border-collapse: collapse;\n  width: 100%;\n}\n.table-header[data-v-218b9aa0] {\n  color: #8DA0A9;\n  font-size: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n}\n.table-header th[data-v-218b9aa0] {\n    padding: 5px 10px;\n}\n.table-header th.sortable[data-v-218b9aa0] {\n      cursor: pointer;\n      text-decoration: underline;\n      color: #333;\n      -webkit-transition: all 250ms;\n      transition: all 250ms;\n}\n.table-header th.sortable.disabled[data-v-218b9aa0] {\n        pointer-events: none;\n        opacity: 0.5;\n}\n.driver[data-v-218b9aa0] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.driver.new[data-v-218b9aa0] {\n    border-left: 5px solid #F25E0D;\n}\n.driver td[data-v-218b9aa0] {\n    padding: 10px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.driver td.map-button[data-v-218b9aa0] {\n      padding: 10px 0;\n}\n.driver td.map-button a[data-v-218b9aa0] {\n        color: #fff;\n        background-color: #aaa;\n        width: 30px;\n        height: 30px;\n        line-height: 30px;\n        text-align: center;\n        display: inline-block;\n        border-radius: 30px;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.driver td.map-button a i[data-v-218b9aa0] {\n          line-height: inherit;\n}\n.driver td.map-button a.disabled[data-v-218b9aa0] {\n          pointer-events: none;\n          opacity: 0.5;\n          background-color: #bbb;\n}\n.driver td.map-button a.selected[data-v-218b9aa0] {\n          background-color: #26D97A;\n}\n.driver td input[data-v-218b9aa0] {\n      margin-top: 0;\n      width: 13px;\n}\n.driver a[data-v-218b9aa0] {\n    font-weight: 700;\n}\n.no-drivers[data-v-218b9aa0] {\n  position: absolute;\n  top: calc(50% - 111px);\n  left: 10%;\n  width: 80%;\n  text-align: center;\n}\n.no-drivers img[data-v-218b9aa0] {\n    display: block;\n    width: 100px;\n    margin: 0 auto;\n}\n.no-drivers .fa-frown[data-v-218b9aa0] {\n    color: #3F2975;\n}\n.no-drivers .title[data-v-218b9aa0] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.no-drivers .content[data-v-218b9aa0] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\n.paging[data-v-218b9aa0] {\n  margin: 15px auto 0;\n  width: 103px;\n  opacity: 1;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.paging.disabled[data-v-218b9aa0] {\n    pointer-events: none;\n    opacity: 0.6;\n}\n.paging .page[data-v-218b9aa0] {\n    display: inline-block;\n    vertical-align: middle;\n    width: auto;\n}\n.paging .page[data-v-218b9aa0]:not(:first-child) {\n      margin-left: -5px;\n}\n.paging .page-btn[data-v-218b9aa0] {\n    background-color: #f5f5f5;\n    border: 1px solid rgba(0, 0, 0, 0.25);\n    color: #777;\n    padding: 5px 5px;\n    font-size: 12px;\n}\n.paging .page-btn.disabled[data-v-218b9aa0] {\n      pointer-events: none;\n      opacity: 0.5;\n}\n.paging .page-btn i[data-v-218b9aa0] {\n      line-height: inherit;\n}\n.paging .page-btn.back[data-v-218b9aa0] {\n      border-top-left-radius: 3px;\n      border-bottom-left-radius: 3px;\n}\n.paging .page-btn.next[data-v-218b9aa0] {\n      border-top-right-radius: 3px;\n      border-bottom-right-radius: 3px;\n}\n.paging .page-number[data-v-218b9aa0] {\n    border-radius: 0;\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    line-height: inherit;\n    font-size: 12px;\n    margin: 0;\n    width: 50px;\n    font-weight: 700;\n    padding: 5px 10px;\n    color: #333;\n    text-align: center;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    outline: 0;\n    -moz-text-align-last: center;\n         text-align-last: center;\n}\n.has-exp-doc[data-v-218b9aa0] {\n  color: #f00;\n  font-weight: 600;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/DriverTable.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;CACpB;AACD;EACE,0BAA0B;EAC1B,YAAY;CACb;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,0BAA0B;CAC3B;AACD;IACI,kBAAkB;CACrB;AACD;MACM,gBAAgB;MAChB,2BAA2B;MAC3B,YAAY;MACZ,8BAA8B;MAC9B,sBAAsB;CAC3B;AACD;QACQ,qBAAqB;QACrB,aAAa;CACpB;AACD;EACE,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;CACpB;AACD;IACI,+BAA+B;CAClC;AACD;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;CACtB;AACD;MACM,gBAAgB;CACrB;AACD;QACQ,YAAY;QACZ,uBAAuB;QACvB,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,mBAAmB;QACnB,sBAAsB;QACtB,oBAAoB;QACpB,8BAA8B;QAC9B,sBAAsB;CAC7B;AACD;UACU,qBAAqB;CAC9B;AACD;UACU,qBAAqB;UACrB,aAAa;UACb,uBAAuB;CAChC;AACD;UACU,0BAA0B;CACnC;AACD;MACM,cAAc;MACd,YAAY;CACjB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,aAAa;IACb,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;EACE,oBAAoB;EACpB,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,qBAAqB;IACrB,aAAa;CAChB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;CACf;AACD;MACM,kBAAkB;CACvB;AACD;IACI,0BAA0B;IAC1B,sCAAsC;IACtC,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;CACnB;AACD;MACM,qBAAqB;MACrB,aAAa;CAClB;AACD;MACM,qBAAqB;CAC1B;AACD;MACM,4BAA4B;MAC5B,+BAA+B;CACpC;AACD;MACM,6BAA6B;MAC7B,gCAAgC;CACrC;AACD;IACI,iBAAiB;IACjB,uBAAuB;IACvB,qCAAqC;IACrC,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;OACtB,sBAAsB;YACjB,iBAAiB;IACzB,WAAW;IACX,6BAA6B;SACxB,wBAAwB;CAChC;AACD;EACE,YAAY;EACZ,iBAAiB;CAClB","file":"DriverTable.vue","sourcesContent":["\n.service-type[data-v-218b9aa0] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-218b9aa0] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-218b9aa0] {\n    background: #26D97A;\n}\n.service-type.black[data-v-218b9aa0] {\n    background: #777;\n}\n.service-type.suv[data-v-218b9aa0] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-218b9aa0] {\n    background: #6dabc3;\n}\n.license-type[data-v-218b9aa0] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-218b9aa0] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-218b9aa0] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-218b9aa0] {\n    background-color: #de6c2a;\n}\n.total[data-v-218b9aa0] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #777;\n  position: relative;\n  text-align: right;\n  margin-bottom: 5px;\n}\ntable[data-v-218b9aa0] {\n  border-collapse: collapse;\n  width: 100%;\n}\n.table-header[data-v-218b9aa0] {\n  color: #8DA0A9;\n  font-size: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n}\n.table-header th[data-v-218b9aa0] {\n    padding: 5px 10px;\n}\n.table-header th.sortable[data-v-218b9aa0] {\n      cursor: pointer;\n      text-decoration: underline;\n      color: #333;\n      -webkit-transition: all 250ms;\n      transition: all 250ms;\n}\n.table-header th.sortable.disabled[data-v-218b9aa0] {\n        pointer-events: none;\n        opacity: 0.5;\n}\n.driver[data-v-218b9aa0] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.driver.new[data-v-218b9aa0] {\n    border-left: 5px solid #F25E0D;\n}\n.driver td[data-v-218b9aa0] {\n    padding: 10px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.driver td.map-button[data-v-218b9aa0] {\n      padding: 10px 0;\n}\n.driver td.map-button a[data-v-218b9aa0] {\n        color: #fff;\n        background-color: #aaa;\n        width: 30px;\n        height: 30px;\n        line-height: 30px;\n        text-align: center;\n        display: inline-block;\n        border-radius: 30px;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.driver td.map-button a i[data-v-218b9aa0] {\n          line-height: inherit;\n}\n.driver td.map-button a.disabled[data-v-218b9aa0] {\n          pointer-events: none;\n          opacity: 0.5;\n          background-color: #bbb;\n}\n.driver td.map-button a.selected[data-v-218b9aa0] {\n          background-color: #26D97A;\n}\n.driver td input[data-v-218b9aa0] {\n      margin-top: 0;\n      width: 13px;\n}\n.driver a[data-v-218b9aa0] {\n    font-weight: 700;\n}\n.no-drivers[data-v-218b9aa0] {\n  position: absolute;\n  top: calc(50% - 111px);\n  left: 10%;\n  width: 80%;\n  text-align: center;\n}\n.no-drivers img[data-v-218b9aa0] {\n    display: block;\n    width: 100px;\n    margin: 0 auto;\n}\n.no-drivers .fa-frown[data-v-218b9aa0] {\n    color: #3F2975;\n}\n.no-drivers .title[data-v-218b9aa0] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.no-drivers .content[data-v-218b9aa0] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\n.paging[data-v-218b9aa0] {\n  margin: 15px auto 0;\n  width: 103px;\n  opacity: 1;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.paging.disabled[data-v-218b9aa0] {\n    pointer-events: none;\n    opacity: 0.6;\n}\n.paging .page[data-v-218b9aa0] {\n    display: inline-block;\n    vertical-align: middle;\n    width: auto;\n}\n.paging .page[data-v-218b9aa0]:not(:first-child) {\n      margin-left: -5px;\n}\n.paging .page-btn[data-v-218b9aa0] {\n    background-color: #f5f5f5;\n    border: 1px solid rgba(0, 0, 0, 0.25);\n    color: #777;\n    padding: 5px 5px;\n    font-size: 12px;\n}\n.paging .page-btn.disabled[data-v-218b9aa0] {\n      pointer-events: none;\n      opacity: 0.5;\n}\n.paging .page-btn i[data-v-218b9aa0] {\n      line-height: inherit;\n}\n.paging .page-btn.back[data-v-218b9aa0] {\n      border-top-left-radius: 3px;\n      border-bottom-left-radius: 3px;\n}\n.paging .page-btn.next[data-v-218b9aa0] {\n      border-top-right-radius: 3px;\n      border-bottom-right-radius: 3px;\n}\n.paging .page-number[data-v-218b9aa0] {\n    border-radius: 0;\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    line-height: inherit;\n    font-size: 12px;\n    margin: 0;\n    width: 50px;\n    font-weight: 700;\n    padding: 5px 10px;\n    color: #333;\n    text-align: center;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    outline: 0;\n    -moz-text-align-last: center;\n         text-align-last: center;\n}\n.has-exp-doc[data-v-218b9aa0] {\n  color: #f00;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1235);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("60c9b976", content, true, {});

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.ellipsis[data-v-a2e98acc] {\n  position: relative;\n  height: 40px;\n}\n.blob[data-v-a2e98acc] {\n  width: 36px;\n  height: 36px;\n  background: rgba(0, 182, 241, 0.6);\n  border-radius: 50%;\n  position: absolute;\n  top: calc(50% - 18px);\n  left: calc(50% - 18px);\n}\n.blob-2[data-v-a2e98acc] {\n  -webkit-animation: animate-to-2-data-v-a2e98acc 1.5s infinite;\n          animation: animate-to-2-data-v-a2e98acc 1.5s infinite;\n}\n.blob-3[data-v-a2e98acc] {\n  -webkit-animation: animate-to-3-data-v-a2e98acc 1.5s infinite;\n          animation: animate-to-3-data-v-a2e98acc 1.5s infinite;\n}\n.blob-1[data-v-a2e98acc] {\n  -webkit-animation: animate-to-1-data-v-a2e98acc 1.5s infinite;\n          animation: animate-to-1-data-v-a2e98acc 1.5s infinite;\n}\n.blob-4[data-v-a2e98acc] {\n  -webkit-animation: animate-to-4-data-v-a2e98acc 1.5s infinite;\n          animation: animate-to-4-data-v-a2e98acc 1.5s infinite;\n}\n.blob-0[data-v-a2e98acc] {\n  -webkit-animation: animate-to-0-data-v-a2e98acc 1.5s infinite;\n          animation: animate-to-0-data-v-a2e98acc 1.5s infinite;\n}\n.blob-5[data-v-a2e98acc] {\n  -webkit-animation: animate-to-5-data-v-a2e98acc 1.5s infinite;\n          animation: animate-to-5-data-v-a2e98acc 1.5s infinite;\n}\n@-webkit-keyframes animate-to-2-data-v-a2e98acc {\n25%, 75% {\n    -webkit-transform: translateX(-1.5rem) scale(0.75);\n            transform: translateX(-1.5rem) scale(0.75);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@keyframes animate-to-2-data-v-a2e98acc {\n25%, 75% {\n    -webkit-transform: translateX(-1.5rem) scale(0.75);\n            transform: translateX(-1.5rem) scale(0.75);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@-webkit-keyframes animate-to-3-data-v-a2e98acc {\n25%, 75% {\n    -webkit-transform: translateX(1.5rem) scale(0.75);\n            transform: translateX(1.5rem) scale(0.75);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@keyframes animate-to-3-data-v-a2e98acc {\n25%, 75% {\n    -webkit-transform: translateX(1.5rem) scale(0.75);\n            transform: translateX(1.5rem) scale(0.75);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@-webkit-keyframes animate-to-1-data-v-a2e98acc {\n25% {\n    -webkit-transform: translateX(-1.5rem) scale(0.75);\n            transform: translateX(-1.5rem) scale(0.75);\n}\n50%, 75% {\n    -webkit-transform: translateX(-4.5rem) scale(0.6);\n            transform: translateX(-4.5rem) scale(0.6);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@keyframes animate-to-1-data-v-a2e98acc {\n25% {\n    -webkit-transform: translateX(-1.5rem) scale(0.75);\n            transform: translateX(-1.5rem) scale(0.75);\n}\n50%, 75% {\n    -webkit-transform: translateX(-4.5rem) scale(0.6);\n            transform: translateX(-4.5rem) scale(0.6);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@-webkit-keyframes animate-to-4-data-v-a2e98acc {\n25% {\n    -webkit-transform: translateX(1.5rem) scale(0.75);\n            transform: translateX(1.5rem) scale(0.75);\n}\n50%, 75% {\n    -webkit-transform: translateX(4.5rem) scale(0.6);\n            transform: translateX(4.5rem) scale(0.6);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@keyframes animate-to-4-data-v-a2e98acc {\n25% {\n    -webkit-transform: translateX(1.5rem) scale(0.75);\n            transform: translateX(1.5rem) scale(0.75);\n}\n50%, 75% {\n    -webkit-transform: translateX(4.5rem) scale(0.6);\n            transform: translateX(4.5rem) scale(0.6);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@-webkit-keyframes animate-to-0-data-v-a2e98acc {\n25% {\n    -webkit-transform: translateX(-1.5rem) scale(0.75);\n            transform: translateX(-1.5rem) scale(0.75);\n}\n50% {\n    -webkit-transform: translateX(-4.5rem) scale(0.6);\n            transform: translateX(-4.5rem) scale(0.6);\n}\n75% {\n    -webkit-transform: translateX(-7.5rem) scale(0.5);\n            transform: translateX(-7.5rem) scale(0.5);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@keyframes animate-to-0-data-v-a2e98acc {\n25% {\n    -webkit-transform: translateX(-1.5rem) scale(0.75);\n            transform: translateX(-1.5rem) scale(0.75);\n}\n50% {\n    -webkit-transform: translateX(-4.5rem) scale(0.6);\n            transform: translateX(-4.5rem) scale(0.6);\n}\n75% {\n    -webkit-transform: translateX(-7.5rem) scale(0.5);\n            transform: translateX(-7.5rem) scale(0.5);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@-webkit-keyframes animate-to-5-data-v-a2e98acc {\n25% {\n    -webkit-transform: translateX(1.5rem) scale(0.75);\n            transform: translateX(1.5rem) scale(0.75);\n}\n50% {\n    -webkit-transform: translateX(4.5rem) scale(0.6);\n            transform: translateX(4.5rem) scale(0.6);\n}\n75% {\n    -webkit-transform: translateX(7.5rem) scale(0.5);\n            transform: translateX(7.5rem) scale(0.5);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@keyframes animate-to-5-data-v-a2e98acc {\n25% {\n    -webkit-transform: translateX(1.5rem) scale(0.75);\n            transform: translateX(1.5rem) scale(0.75);\n}\n50% {\n    -webkit-transform: translateX(4.5rem) scale(0.6);\n            transform: translateX(4.5rem) scale(0.6);\n}\n75% {\n    -webkit-transform: translateX(7.5rem) scale(0.5);\n            transform: translateX(7.5rem) scale(0.5);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Partials/LoadingAnimation/Ellipsis.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,aAAa;CACd;AACD;EACE,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;CACxB;AACD;EACE,8DAA8D;UACtD,sDAAsD;CAC/D;AACD;EACE,8DAA8D;UACtD,sDAAsD;CAC/D;AACD;EACE,8DAA8D;UACtD,sDAAsD;CAC/D;AACD;EACE,8DAA8D;UACtD,sDAAsD;CAC/D;AACD;EACE,8DAA8D;UACtD,sDAAsD;CAC/D;AACD;EACE,8DAA8D;UACtD,sDAAsD;CAC/D;AACD;AACA;IACI,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;IACI,6CAA6C;YACrC,qCAAqC;CAChD;CACA;AACD;AACA;IACI,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;IACI,6CAA6C;YACrC,qCAAqC;CAChD;CACA;AACD;AACA;IACI,kDAAkD;YAC1C,0CAA0C;CACrD;AACD;IACI,6CAA6C;YACrC,qCAAqC;CAChD;CACA;AACD;AACA;IACI,kDAAkD;YAC1C,0CAA0C;CACrD;AACD;IACI,6CAA6C;YACrC,qCAAqC;CAChD;CACA;AACD;AACA;IACI,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;IACI,kDAAkD;YAC1C,0CAA0C;CACrD;AACD;IACI,6CAA6C;YACrC,qCAAqC;CAChD;CACA;AACD;AACA;IACI,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;IACI,kDAAkD;YAC1C,0CAA0C;CACrD;AACD;IACI,6CAA6C;YACrC,qCAAqC;CAChD;CACA;AACD;AACA;IACI,kDAAkD;YAC1C,0CAA0C;CACrD;AACD;IACI,iDAAiD;YACzC,yCAAyC;CACpD;AACD;IACI,6CAA6C;YACrC,qCAAqC;CAChD;CACA;AACD;AACA;IACI,kDAAkD;YAC1C,0CAA0C;CACrD;AACD;IACI,iDAAiD;YACzC,yCAAyC;CACpD;AACD;IACI,6CAA6C;YACrC,qCAAqC;CAChD;CACA;AACD;AACA;IACI,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;IACI,kDAAkD;YAC1C,0CAA0C;CACrD;AACD;IACI,kDAAkD;YAC1C,0CAA0C;CACrD;AACD;IACI,6CAA6C;YACrC,qCAAqC;CAChD;CACA;AACD;AACA;IACI,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;IACI,kDAAkD;YAC1C,0CAA0C;CACrD;AACD;IACI,kDAAkD;YAC1C,0CAA0C;CACrD;AACD;IACI,6CAA6C;YACrC,qCAAqC;CAChD;CACA;AACD;AACA;IACI,kDAAkD;YAC1C,0CAA0C;CACrD;AACD;IACI,iDAAiD;YACzC,yCAAyC;CACpD;AACD;IACI,iDAAiD;YACzC,yCAAyC;CACpD;AACD;IACI,6CAA6C;YACrC,qCAAqC;CAChD;CACA;AACD;AACA;IACI,kDAAkD;YAC1C,0CAA0C;CACrD;AACD;IACI,iDAAiD;YACzC,yCAAyC;CACpD;AACD;IACI,iDAAiD;YACzC,yCAAyC;CACpD;AACD;IACI,6CAA6C;YACrC,qCAAqC;CAChD;CACA","file":"Ellipsis.vue","sourcesContent":["\n.ellipsis[data-v-a2e98acc] {\n  position: relative;\n  height: 40px;\n}\n.blob[data-v-a2e98acc] {\n  width: 36px;\n  height: 36px;\n  background: rgba(0, 182, 241, 0.6);\n  border-radius: 50%;\n  position: absolute;\n  top: calc(50% - 18px);\n  left: calc(50% - 18px);\n}\n.blob-2[data-v-a2e98acc] {\n  -webkit-animation: animate-to-2-data-v-a2e98acc 1.5s infinite;\n          animation: animate-to-2-data-v-a2e98acc 1.5s infinite;\n}\n.blob-3[data-v-a2e98acc] {\n  -webkit-animation: animate-to-3-data-v-a2e98acc 1.5s infinite;\n          animation: animate-to-3-data-v-a2e98acc 1.5s infinite;\n}\n.blob-1[data-v-a2e98acc] {\n  -webkit-animation: animate-to-1-data-v-a2e98acc 1.5s infinite;\n          animation: animate-to-1-data-v-a2e98acc 1.5s infinite;\n}\n.blob-4[data-v-a2e98acc] {\n  -webkit-animation: animate-to-4-data-v-a2e98acc 1.5s infinite;\n          animation: animate-to-4-data-v-a2e98acc 1.5s infinite;\n}\n.blob-0[data-v-a2e98acc] {\n  -webkit-animation: animate-to-0-data-v-a2e98acc 1.5s infinite;\n          animation: animate-to-0-data-v-a2e98acc 1.5s infinite;\n}\n.blob-5[data-v-a2e98acc] {\n  -webkit-animation: animate-to-5-data-v-a2e98acc 1.5s infinite;\n          animation: animate-to-5-data-v-a2e98acc 1.5s infinite;\n}\n@-webkit-keyframes animate-to-2-data-v-a2e98acc {\n25%, 75% {\n    -webkit-transform: translateX(-1.5rem) scale(0.75);\n            transform: translateX(-1.5rem) scale(0.75);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@keyframes animate-to-2-data-v-a2e98acc {\n25%, 75% {\n    -webkit-transform: translateX(-1.5rem) scale(0.75);\n            transform: translateX(-1.5rem) scale(0.75);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@-webkit-keyframes animate-to-3-data-v-a2e98acc {\n25%, 75% {\n    -webkit-transform: translateX(1.5rem) scale(0.75);\n            transform: translateX(1.5rem) scale(0.75);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@keyframes animate-to-3-data-v-a2e98acc {\n25%, 75% {\n    -webkit-transform: translateX(1.5rem) scale(0.75);\n            transform: translateX(1.5rem) scale(0.75);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@-webkit-keyframes animate-to-1-data-v-a2e98acc {\n25% {\n    -webkit-transform: translateX(-1.5rem) scale(0.75);\n            transform: translateX(-1.5rem) scale(0.75);\n}\n50%, 75% {\n    -webkit-transform: translateX(-4.5rem) scale(0.6);\n            transform: translateX(-4.5rem) scale(0.6);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@keyframes animate-to-1-data-v-a2e98acc {\n25% {\n    -webkit-transform: translateX(-1.5rem) scale(0.75);\n            transform: translateX(-1.5rem) scale(0.75);\n}\n50%, 75% {\n    -webkit-transform: translateX(-4.5rem) scale(0.6);\n            transform: translateX(-4.5rem) scale(0.6);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@-webkit-keyframes animate-to-4-data-v-a2e98acc {\n25% {\n    -webkit-transform: translateX(1.5rem) scale(0.75);\n            transform: translateX(1.5rem) scale(0.75);\n}\n50%, 75% {\n    -webkit-transform: translateX(4.5rem) scale(0.6);\n            transform: translateX(4.5rem) scale(0.6);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@keyframes animate-to-4-data-v-a2e98acc {\n25% {\n    -webkit-transform: translateX(1.5rem) scale(0.75);\n            transform: translateX(1.5rem) scale(0.75);\n}\n50%, 75% {\n    -webkit-transform: translateX(4.5rem) scale(0.6);\n            transform: translateX(4.5rem) scale(0.6);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@-webkit-keyframes animate-to-0-data-v-a2e98acc {\n25% {\n    -webkit-transform: translateX(-1.5rem) scale(0.75);\n            transform: translateX(-1.5rem) scale(0.75);\n}\n50% {\n    -webkit-transform: translateX(-4.5rem) scale(0.6);\n            transform: translateX(-4.5rem) scale(0.6);\n}\n75% {\n    -webkit-transform: translateX(-7.5rem) scale(0.5);\n            transform: translateX(-7.5rem) scale(0.5);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@keyframes animate-to-0-data-v-a2e98acc {\n25% {\n    -webkit-transform: translateX(-1.5rem) scale(0.75);\n            transform: translateX(-1.5rem) scale(0.75);\n}\n50% {\n    -webkit-transform: translateX(-4.5rem) scale(0.6);\n            transform: translateX(-4.5rem) scale(0.6);\n}\n75% {\n    -webkit-transform: translateX(-7.5rem) scale(0.5);\n            transform: translateX(-7.5rem) scale(0.5);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@-webkit-keyframes animate-to-5-data-v-a2e98acc {\n25% {\n    -webkit-transform: translateX(1.5rem) scale(0.75);\n            transform: translateX(1.5rem) scale(0.75);\n}\n50% {\n    -webkit-transform: translateX(4.5rem) scale(0.6);\n            transform: translateX(4.5rem) scale(0.6);\n}\n75% {\n    -webkit-transform: translateX(7.5rem) scale(0.5);\n            transform: translateX(7.5rem) scale(0.5);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n@keyframes animate-to-5-data-v-a2e98acc {\n25% {\n    -webkit-transform: translateX(1.5rem) scale(0.75);\n            transform: translateX(1.5rem) scale(0.75);\n}\n50% {\n    -webkit-transform: translateX(4.5rem) scale(0.6);\n            transform: translateX(4.5rem) scale(0.6);\n}\n75% {\n    -webkit-transform: translateX(7.5rem) scale(0.5);\n            transform: translateX(7.5rem) scale(0.5);\n}\n95% {\n    -webkit-transform: translateX(0rem) scale(1);\n            transform: translateX(0rem) scale(1);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ellipsis"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","version":"1.1"}},[_c('defs',[_c('filter',{attrs:{"id":"gooey"}},[_c('feGaussianBlur',{attrs:{"in":"SourceGraphic","stdDeviation":"10","result":"blur"}}),_vm._v(" "),_c('feColorMatrix',{attrs:{"in":"blur","mode":"matrix","values":"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7","result":"goo"}}),_vm._v(" "),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"goo"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"blob blob-0"}),_vm._v(" "),_c('div',{staticClass:"blob blob-1"}),_vm._v(" "),_c('div',{staticClass:"blob blob-2"}),_vm._v(" "),_c('div',{staticClass:"blob blob-3"}),_vm._v(" "),_c('div',{staticClass:"blob blob-4"}),_vm._v(" "),_c('div',{staticClass:"blob blob-5"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"total"},[_vm._v("Total: "+_vm._s(_vm.driversTotal))]),_vm._v(" "),(_vm.drivers.length > 0 || _vm.totalPages > 0)?_c('div',[_c('table',[_c('thead',[_c('tr',{staticClass:"table-header"},[_c('th'),_vm._v(" "),_c('th',{directives:[{name:"show",rawName:"v-show",value:(_vm.onDuty),expression:"onDuty"}]}),_vm._v(" "),_c('th',{class:'sortable' + (_vm.isSorting ? ' disabled' : ''),on:{"click":function($event){return _vm.sort('ID')}}},[_c('span',[_vm._v(_vm._s(_vm.$t('dispatch.driverTable.id')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.driverSort.order === 'ID'),expression:"driverSort.order === 'ID'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.driverSort.asc && !_vm.isSorting),expression:"driverSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.driverSort.asc && !_vm.isSorting),expression:"!driverSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('th',{class:'sortable' + (_vm.isSorting ? ' disabled' : ''),on:{"click":function($event){return _vm.sort('firstName')}}},[_c('span',[_vm._v(_vm._s(_vm.$t('dispatch.driverTable.name')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.driverSort.order === 'firstName'),expression:"driverSort.order === 'firstName'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.driverSort.asc && !_vm.isSorting),expression:"driverSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.driverSort.asc && !_vm.isSorting),expression:"!driverSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('th',{class:'sortable' + (_vm.isSorting ? ' disabled' : ''),on:{"click":function($event){return _vm.sort('accountType')}}},[_c('span',[_vm._v(_vm._s(_vm.$t('dispatch.driverTable.license')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.driverSort.order === 'accountType'),expression:"driverSort.order === 'accountType'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.driverSort.asc && !_vm.isSorting),expression:"driverSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.driverSort.asc && !_vm.isSorting),expression:"!driverSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('dispatch.driverTable.phone')))]),_vm._v(" "),(_vm.staging)?_c('th',[_vm._v("STAGING LOT")]):_vm._e(),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('dispatch.driverTable.pax')))]),_vm._v(" "),_c('th',{directives:[{name:"show",rawName:"v-show",value:(_vm.onDuty && !_vm.staging),expression:"onDuty && !staging"}],class:'sortable' + (_vm.isSorting ? ' disabled' : ''),on:{"click":function($event){return _vm.sort('status')}}},[_c('span',[_vm._v(_vm._s(_vm.$t('dispatch.driverTable.status')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.driverSort.order === 'status'),expression:"driverSort.order === 'status'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.driverSort.asc && !_vm.isSorting),expression:"driverSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.driverSort.asc && !_vm.isSorting),expression:"!driverSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.drivers),function(driver,index){return _c('tr',{key:index,class:{ driver: true, new: driver.isNew }},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDriver),expression:"selectedDriver"}],attrs:{"type":"radio","name":"seletedDriver"},domProps:{"value":driver.id,"checked":_vm._q(_vm.selectedDriver,driver.id)},on:{"change":function($event){_vm.selectedDriver=driver.id}}})]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.onDuty),expression:"onDuty"}],staticClass:"map-button"},[_c('a',{class:{
                 disabled: _vm.loadingDriverId !== null,
                 selected: (_vm.driverIdsInMap.indexOf(driver.id) > -1)
               },attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.showOnMap(driver)}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingDriverId !== driver.id),expression:"loadingDriverId !== driver.id"}],staticClass:"fas fa-map-marker-alt"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingDriverId === driver.id),expression:"loadingDriverId === driver.id"}],staticClass:"fas fa-spinner fa-spin fa-fw"})])]),_vm._v(" "),_c('td',{staticClass:"id"},[_c('a',{attrs:{"href":'/#/provider/' + driver.id,"target":"_blank"}},[_vm._v(_vm._s(driver.driverNum))])]),_vm._v(" "),_c('td',[_c('span',{class:{'has-exp-doc':driver.hasExpiringDoc}},[_vm._v(_vm._s(driver.firstName)+" "+_vm._s(driver.lastName))])]),_vm._v(" "),_c('td',[_c('span',{class:'license-type ' + driver.licenseType},[_vm._v(_vm._s(driver.licenseType))])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.callDriver(driver)}}},[_vm._v(_vm._s(_vm.driverPhoneDisplay(driver)))])]),_vm._v(" "),(_vm.staging)?_c('td',[_vm._v("\n            "+_vm._s(driver.stagingLot.name)+"\n          ")]):_vm._e(),_vm._v(" "),_c('td',[(_vm.onDuty)?_c('span',[_vm._v(_vm._s(driver.onBoard)+"/"+_vm._s(driver.capacity))]):_c('span',[_vm._v(_vm._s(driver.capacity))])]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.onDuty && !_vm.staging),expression:"onDuty && !staging"}]},[_c('span',[_vm._v(_vm._s(driver.status))]),_vm._v(" "),(driver.rsvp !== null)?_c('span',[_vm._v("\n              ("),_c('a',{attrs:{"href":'/#/reservation/' + driver.rsvp.rsvpId,"target":"_blank"}},[_vm._v(_vm._s(driver.rsvp.rsvpId))]),_vm._v(")\n            ")]):_vm._e()])])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.totalPages > 1),expression:"totalPages > 1"}],class:{ paging: true, disabled: _vm.isPageLoading }},[_c('a',{class:{
           'page page-btn back': true,
           disabled: _vm.currentPage === 1
        },attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.pageBtn(false)}}},[_c('i',{class:{
          'fas fa-fw': true,
          'fa-chevron-left': !_vm.isLoadingBack,
          'fa-spinner fa-spin': _vm.isLoadingBack
        }})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.currentPage),expression:"currentPage",modifiers:{"number":true}}],staticClass:"page page-number",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.currentPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.loadPage]}},_vm._l((_vm.totalPages),function(n){return _c('option',{domProps:{"value":n}},[_vm._v(_vm._s(n))])}),0),_vm._v(" "),_c('a',{class:{
           'page page-btn next': true,
           disabled: _vm.currentPage === _vm.totalPages
        },attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.pageBtn(true)}}},[_c('i',{class:{
          'fas fa-fw': true,
          'fa-chevron-right': !_vm.isLoadingNext,
          'fa-spinner fa-spin': _vm.isLoadingNext
        }})])])]):_c('div',[_c('div',{staticClass:"no-drivers"},[(_vm.isLoading)?_c('div',[_c('ellipsis-loader'),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('dispatch.driverTable.loading.title')))]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.$t('dispatch.driverTable.loading.content')))])],1):_c('div',[(_vm.noDriversFound)?_c('div',[_c('i',{staticClass:"far fa-frown fa-4x fa-fw"}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Nothing here...")]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v("We can't find any drivers using the filters you provided.")])]):_c('div',[(_vm.onDuty)?_c('div',[(_vm.staging)?_c('div',[_c('img',{attrs:{"src":"/assets/img/offline.png"}}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("No one's in staging.")]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v("There's no driver in the staging area at the moment.")])]):_c('div',[_c('img',{attrs:{"src":"/assets/img/offline.png"}}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('dispatch.driverTable.empty.title')))]),_vm._v(" "),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.$t('dispatch.driverTable.empty.content'))}})])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StagingDrivers_vue__ = __webpack_require__(441);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9adc50c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StagingDrivers_vue__ = __webpack_require__(1247);
function injectStyle (ssrContext) {
  __webpack_require__(1239)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c9adc50c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StagingDrivers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9adc50c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StagingDrivers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1240);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1fcd1a39", content, true, {});

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.staging-drivers[data-v-c9adc50c] {\n  font-size: 14px;\n  position: relative;\n}\n.staging-drivers .refresh-button[data-v-c9adc50c] {\n    position: absolute;\n    top: 0;\n    right: 0;\n    display: inline-block;\n    background-color: #26D97A;\n    color: #fff;\n    padding: 12px;\n    border-radius: 3px;\n    z-index: 9;\n}\n.airport-select[data-v-c9adc50c],\n.staging-areas[data-v-c9adc50c] {\n  position: relative;\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.airport-select > *[data-v-c9adc50c],\n  .staging-areas > *[data-v-c9adc50c] {\n    display: inline-block !important;\n    vertical-align: middle;\n}\n.airport-select > i[data-v-c9adc50c],\n  .staging-areas > i[data-v-c9adc50c] {\n    margin-left: -25px;\n    color: #aaa;\n}\n.staging-areas[data-v-c9adc50c] {\n  padding-top: 10px;\n}\n.staging-area[data-v-c9adc50c] {\n  text-align: center;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.staging-lots .loader[data-v-c9adc50c] {\n  text-align: center;\n  font-weight: 700;\n  padding: 15px;\n}\n.staging-area-error[data-v-c9adc50c] {\n  text-align: center;\n  padding: 20px 0;\n  font-weight: 700;\n  color: #F20D0D;\n}\n.total[data-v-c9adc50c] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #777;\n  position: relative;\n  text-align: right;\n  margin-bottom: 5px;\n}\n.driver-list[data-v-c9adc50c] {\n  margin-top: 8px;\n}\n.driver-list .service-drivers[data-v-c9adc50c] {\n    position: relative;\n}\n.driver-list .service-title[data-v-c9adc50c] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n    margin-bottom: 3px;\n}\ntable[data-v-c9adc50c] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-bottom: 10px;\n}\n.table-header[data-v-c9adc50c] {\n  color: #8DA0A9;\n  font-size: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n}\n.table-header th[data-v-c9adc50c] {\n    padding: 5px 10px;\n}\n.driver[data-v-c9adc50c] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.driver td[data-v-c9adc50c] {\n    padding: 10px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.driver td input[data-v-c9adc50c] {\n      margin-top: 0;\n      width: 13px;\n}\n.driver a[data-v-c9adc50c] {\n    font-weight: 700;\n}\nselect[data-v-c9adc50c] {\n  border-radius: 0;\n  outline: 0;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  border: 0;\n  background-color: #fff;\n  padding: 10px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  border-radius: 3px;\n  display: inline-block;\n  width: 250px;\n  margin-left: 10px;\n}\n.driver-name[data-v-c9adc50c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.driver-name .prov-options[data-v-c9adc50c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    margin-left: 6px;\n    cursor: pointer;\n    color: #0D79F2;\n    -webkit-transition: all .4s ease;\n    transition: all .4s ease;\n    position: relative;\n}\n.driver-name .prov-options .fa-ellipsis-v[data-v-c9adc50c] {\n      font-size: 14px;\n}\n.driver-name .prov-options[data-v-c9adc50c]:hover {\n      color: #333;\n}\n.driver-name .prov-options .options[data-v-c9adc50c] {\n      -webkit-transform-origin: top center;\n              transform-origin: top center;\n      position: absolute;\n      top: 120%;\n      z-index: 6;\n      width: 200px;\n      background: #fff;\n      padding: 10px;\n      border-radius: 4px;\n      -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);\n              box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);\n}\n.driver-name .prov-options .options .button[data-v-c9adc50c] {\n        margin-bottom: 3px;\n}\n.driver-name .prov-options .options .button i[data-v-c9adc50c] {\n          margin-right: 5px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/StagingDrivers.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,SAAS;IACT,sBAAsB;IACtB,0BAA0B;IAC1B,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,WAAW;CACd;AACD;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;CAC9C;AACD;;IAEI,iCAAiC;IACjC,uBAAuB;CAC1B;AACD;;IAEI,mBAAmB;IACnB,YAAY;CACf;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,6CAA6C;CAC9C;AACD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;CACf;AACD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;CAChB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;CACpB;AACD;EACE,gBAAgB;CACjB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;CACtB;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,oBAAoB;CACrB;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,0BAA0B;CAC3B;AACD;IACI,kBAAkB;CACrB;AACD;EACE,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;CACpB;AACD;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;CACtB;AACD;MACM,cAAc;MACd,YAAY;CACjB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,iBAAiB;EACjB,WAAW;EACX,yBAAyB;KACtB,sBAAsB;UACjB,iBAAiB;EACzB,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,qCAAqC;EACrC,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;CACnB;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;IAC5B,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,iCAAiC;IACjC,yBAAyB;IACzB,mBAAmB;CACtB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,YAAY;CACjB;AACD;MACM,qCAAqC;cAC7B,6BAA6B;MACrC,mBAAmB;MACnB,UAAU;MACV,WAAW;MACX,aAAa;MACb,iBAAiB;MACjB,cAAc;MACd,mBAAmB;MACnB,mDAAmD;cAC3C,2CAA2C;CACxD;AACD;QACQ,mBAAmB;CAC1B;AACD;UACU,kBAAkB;CAC3B","file":"StagingDrivers.vue","sourcesContent":["\n.staging-drivers[data-v-c9adc50c] {\n  font-size: 14px;\n  position: relative;\n}\n.staging-drivers .refresh-button[data-v-c9adc50c] {\n    position: absolute;\n    top: 0;\n    right: 0;\n    display: inline-block;\n    background-color: #26D97A;\n    color: #fff;\n    padding: 12px;\n    border-radius: 3px;\n    z-index: 9;\n}\n.airport-select[data-v-c9adc50c],\n.staging-areas[data-v-c9adc50c] {\n  position: relative;\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.airport-select > *[data-v-c9adc50c],\n  .staging-areas > *[data-v-c9adc50c] {\n    display: inline-block !important;\n    vertical-align: middle;\n}\n.airport-select > i[data-v-c9adc50c],\n  .staging-areas > i[data-v-c9adc50c] {\n    margin-left: -25px;\n    color: #aaa;\n}\n.staging-areas[data-v-c9adc50c] {\n  padding-top: 10px;\n}\n.staging-area[data-v-c9adc50c] {\n  text-align: center;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.staging-lots .loader[data-v-c9adc50c] {\n  text-align: center;\n  font-weight: 700;\n  padding: 15px;\n}\n.staging-area-error[data-v-c9adc50c] {\n  text-align: center;\n  padding: 20px 0;\n  font-weight: 700;\n  color: #F20D0D;\n}\n.total[data-v-c9adc50c] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #777;\n  position: relative;\n  text-align: right;\n  margin-bottom: 5px;\n}\n.driver-list[data-v-c9adc50c] {\n  margin-top: 8px;\n}\n.driver-list .service-drivers[data-v-c9adc50c] {\n    position: relative;\n}\n.driver-list .service-title[data-v-c9adc50c] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n    margin-bottom: 3px;\n}\ntable[data-v-c9adc50c] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-bottom: 10px;\n}\n.table-header[data-v-c9adc50c] {\n  color: #8DA0A9;\n  font-size: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n}\n.table-header th[data-v-c9adc50c] {\n    padding: 5px 10px;\n}\n.driver[data-v-c9adc50c] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.driver td[data-v-c9adc50c] {\n    padding: 10px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.driver td input[data-v-c9adc50c] {\n      margin-top: 0;\n      width: 13px;\n}\n.driver a[data-v-c9adc50c] {\n    font-weight: 700;\n}\nselect[data-v-c9adc50c] {\n  border-radius: 0;\n  outline: 0;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  border: 0;\n  background-color: #fff;\n  padding: 10px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  border-radius: 3px;\n  display: inline-block;\n  width: 250px;\n  margin-left: 10px;\n}\n.driver-name[data-v-c9adc50c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.driver-name .prov-options[data-v-c9adc50c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    margin-left: 6px;\n    cursor: pointer;\n    color: #0D79F2;\n    -webkit-transition: all .4s ease;\n    transition: all .4s ease;\n    position: relative;\n}\n.driver-name .prov-options .fa-ellipsis-v[data-v-c9adc50c] {\n      font-size: 14px;\n}\n.driver-name .prov-options[data-v-c9adc50c]:hover {\n      color: #333;\n}\n.driver-name .prov-options .options[data-v-c9adc50c] {\n      -webkit-transform-origin: top center;\n              transform-origin: top center;\n      position: absolute;\n      top: 120%;\n      z-index: 6;\n      width: 200px;\n      background: #fff;\n      padding: 10px;\n      border-radius: 4px;\n      -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);\n              box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);\n}\n.driver-name .prov-options .options .button[data-v-c9adc50c] {\n        margin-bottom: 3px;\n}\n.driver-name .prov-options .options .button i[data-v-c9adc50c] {\n          margin-right: 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1242);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("ce98d620", content, true, {});

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.data-field[data-v-34fc9245] {\n  position: relative;\n  margin-bottom: 20px;\n}\n.data-field.reduce-margin[data-v-34fc9245] {\n    margin-bottom: 12px;\n}\n.data-field .label[data-v-34fc9245] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 130%;\n    margin-bottom: 3px;\n}\n.data-field .label.has-error[data-v-34fc9245] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-34fc9245] {\n    margin: 5px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-34fc9245] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-34fc9245]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-34fc9245] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.op--modal-container[data-v-34fc9245] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.35);\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-34fc9245] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-34fc9245] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-34fc9245] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.notification-form[data-v-34fc9245] {\n  background-color: #fff;\n  max-width: 400px;\n  margin: 10px auto;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n.notification-form .heading[data-v-34fc9245] {\n    background: #333;\n    color: #fff;\n    padding: 10px;\n    font-size: 18px;\n    text-align: center;\n}\n.notification-form .nf-content[data-v-34fc9245] {\n    padding: 20px;\n    position: relative;\n}\n.notification-form .nf-content .label[data-v-34fc9245] {\n      font-size: 13px;\n      color: #555;\n}\n.notification-form .nf-content label[data-v-34fc9245] {\n      display: block;\n      font-size: 14px;\n      color: #555;\n      margin-bottom: 2px;\n      cursor: pointer;\n}\n.notification-form .nf-content label input[data-v-34fc9245] {\n        display: inline-block;\n        vertical-align: middle;\n        margin-right: 5px;\n}\n.notification-form .nf-content .textarea-box[data-v-34fc9245] {\n      position: relative;\n      margin-bottom: 15px;\n      padding-bottom: 20px;\n}\n.notification-form .nf-content .textarea-box .emoji-trigger[data-v-34fc9245] {\n        position: absolute;\n        bottom: -3px;\n        left: 0;\n        color: #aaa;\n        cursor: pointer;\n}\n.notification-form .nf-content textarea[data-v-34fc9245] {\n      margin: 0;\n      padding: 10px;\n      width: 100%;\n      resize: none;\n      background: #fdfdfd;\n      font-size: 14px;\n      outline: none;\n      color: #333;\n      border-color: #ddd;\n      -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.05) inset;\n              box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.05) inset;\n      -webkit-transition: all .3s ease;\n      transition: all .3s ease;\n}\n.notification-form .nf-content textarea.exceed[data-v-34fc9245] {\n        border-color: #d61613;\n        background: #fff0f0;\n}\n.notification-form .nf-content .char-count[data-v-34fc9245] {\n      font-size: 12px;\n      color: #777;\n      display: block;\n      text-align: right;\n      line-height: 1;\n      margin-top: 5px;\n}\n.notification-form .nf-content .char-count.exceed[data-v-34fc9245] {\n        color: #f00;\n}\n.notification-form .nf-content .cancel-notif[data-v-34fc9245] {\n      display: block;\n      font-size: 13px;\n      margin: 10px 0 0;\n      text-align: center;\n      cursor: pointer;\n      color: #bbb;\n      -webkit-transition: all .5s ease;\n      transition: all .5s ease;\n}\n.notification-form .nf-content .cancel-notif[data-v-34fc9245]:hover {\n        color: #333;\n}\n.notification-form .nf-content .file-box[data-v-34fc9245] {\n      position: relative;\n}\n.notification-form .nf-content .file-box input[data-v-34fc9245] {\n        padding: 5px 25px 5px 5px;\n        margin: 0;\n        font-size: 14px;\n}\n.notification-form .nf-content .file-box i[data-v-34fc9245] {\n        position: absolute;\n        z-index: 2;\n        top: 50%;\n        right: 5px;\n        -webkit-transform: translateY(-50%);\n                transform: translateY(-50%);\n        color: #fd4a38;\n        cursor: pointer;\n}\n.notification-form .error[data-v-34fc9245] {\n    text-align: center;\n}\n.notification-form .error i[data-v-34fc9245] {\n      color: #fd4a38;\n}\n.notification-form .error p[data-v-34fc9245] {\n      margin: 5px 0 20px;\n}\n.notification-form .error code[data-v-34fc9245] {\n      border: 2px solid #fd4a38;\n      padding: 10px;\n      width: 100%;\n      display: block;\n      font-size: 14px;\n      background: #ffeeec;\n      border-radius: 3px;\n      margin-bottom: 30px;\n}\n.notification-form .success-box[data-v-34fc9245] {\n    text-align: center;\n}\n.notification-form .success-box i[data-v-34fc9245] {\n      color: #26d97a;\n}\n.notification-form .loader[data-v-34fc9245] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.3);\n}\n.notification-form .loader div[data-v-34fc9245] {\n      position: absolute;\n      top: 50%;\n      left: 0;\n      height: 50px;\n      width: 100%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      text-align: center;\n}\n.notification-form .loader div i[data-v-34fc9245] {\n        color: #45e7f9;\n}\n.notification-form .loader div span[data-v-34fc9245] {\n        color: #fff;\n        font-size: 21px;\n        font-weight: 600;\n        margin-left: 5px;\n        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);\n}\n.select-box[data-v-34fc9245] {\n  position: relative;\n}\n.select-box .select-loader[data-v-34fc9245] {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    font-size: 13px;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%);\n    z-index: 2;\n    color: #a2a6aa;\n}\n.select-box .select-loader i[data-v-34fc9245] {\n      vertical-align: -1px;\n      margin-right: 3px;\n}\n.select-box select[data-v-34fc9245] {\n    position: relative;\n    z-index: 1;\n}\n.emoji-box[data-v-34fc9245] {\n  position: absolute;\n  top: 0;\n  left: 100%;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n}\n.announcement-check[data-v-34fc9245] {\n  margin-bottom: 5px !important;\n  padding-left: 2px;\n}\ninput[type=\"checkbox\"][data-v-34fc9245] {\n  width: auto;\n  margin-top: 0;\n}\n.disabled-opt[data-v-34fc9245] {\n  font-style: italic;\n  font-size: 14px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/App/NotificationModal.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,oBAAoB;CACrB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,eAAe;EACf,sCAAsC;EACtC,WAAW;EACX,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;UACzC,yCAAyC;CAClD;AACD;IACI,iBAAiB;IACjB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,mBAAmB;CACtB;AACD;IACI,cAAc;IACd,mBAAmB;CACtB;AACD;MACM,gBAAgB;MAChB,YAAY;CACjB;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,YAAY;MACZ,mBAAmB;MACnB,gBAAgB;CACrB;AACD;QACQ,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;CACzB;AACD;MACM,mBAAmB;MACnB,oBAAoB;MACpB,qBAAqB;CAC1B;AACD;QACQ,mBAAmB;QACnB,aAAa;QACb,QAAQ;QACR,YAAY;QACZ,gBAAgB;CACvB;AACD;MACM,UAAU;MACV,cAAc;MACd,YAAY;MACZ,aAAa;MACb,oBAAoB;MACpB,gBAAgB;MAChB,cAAc;MACd,YAAY;MACZ,mBAAmB;MACnB,0DAA0D;cAClD,kDAAkD;MAC1D,iCAAiC;MACjC,yBAAyB;CAC9B;AACD;QACQ,sBAAsB;QACtB,oBAAoB;CAC3B;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,eAAe;MACf,kBAAkB;MAClB,eAAe;MACf,gBAAgB;CACrB;AACD;QACQ,YAAY;CACnB;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,mBAAmB;MACnB,gBAAgB;MAChB,YAAY;MACZ,iCAAiC;MACjC,yBAAyB;CAC9B;AACD;QACQ,YAAY;CACnB;AACD;MACM,mBAAmB;CACxB;AACD;QACQ,0BAA0B;QAC1B,UAAU;QACV,gBAAgB;CACvB;AACD;QACQ,mBAAmB;QACnB,WAAW;QACX,SAAS;QACT,WAAW;QACX,oCAAoC;gBAC5B,4BAA4B;QACpC,eAAe;QACf,gBAAgB;CACvB;AACD;IACI,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,0BAA0B;MAC1B,cAAc;MACd,YAAY;MACZ,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,mBAAmB;MACnB,oBAAoB;CACzB;AACD;IACI,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,aAAa;IACb,+BAA+B;CAClC;AACD;MACM,mBAAmB;MACnB,SAAS;MACT,QAAQ;MACR,aAAa;MACb,YAAY;MACZ,oCAAoC;cAC5B,4BAA4B;MACpC,mBAAmB;CACxB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;QACjB,4CAA4C;CACnD;AACD;EACE,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,yCAAyC;YACjC,iCAAiC;IACzC,WAAW;IACX,eAAe;CAClB;AACD;MACM,qBAAqB;MACrB,kBAAkB;CACvB;AACD;IACI,mBAAmB;IACnB,WAAW;CACd;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;CACd;AACD;EACE,8BAA8B;EAC9B,kBAAkB;CACnB;AACD;EACE,YAAY;EACZ,cAAc;CACf;AACD;EACE,mBAAmB;EACnB,gBAAgB;CACjB","file":"NotificationModal.vue","sourcesContent":["\n.data-field[data-v-34fc9245] {\n  position: relative;\n  margin-bottom: 20px;\n}\n.data-field.reduce-margin[data-v-34fc9245] {\n    margin-bottom: 12px;\n}\n.data-field .label[data-v-34fc9245] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 130%;\n    margin-bottom: 3px;\n}\n.data-field .label.has-error[data-v-34fc9245] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-34fc9245] {\n    margin: 5px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-34fc9245] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-34fc9245]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-34fc9245] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.op--modal-container[data-v-34fc9245] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.35);\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-34fc9245] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-34fc9245] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-34fc9245] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.notification-form[data-v-34fc9245] {\n  background-color: #fff;\n  max-width: 400px;\n  margin: 10px auto;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n.notification-form .heading[data-v-34fc9245] {\n    background: #333;\n    color: #fff;\n    padding: 10px;\n    font-size: 18px;\n    text-align: center;\n}\n.notification-form .nf-content[data-v-34fc9245] {\n    padding: 20px;\n    position: relative;\n}\n.notification-form .nf-content .label[data-v-34fc9245] {\n      font-size: 13px;\n      color: #555;\n}\n.notification-form .nf-content label[data-v-34fc9245] {\n      display: block;\n      font-size: 14px;\n      color: #555;\n      margin-bottom: 2px;\n      cursor: pointer;\n}\n.notification-form .nf-content label input[data-v-34fc9245] {\n        display: inline-block;\n        vertical-align: middle;\n        margin-right: 5px;\n}\n.notification-form .nf-content .textarea-box[data-v-34fc9245] {\n      position: relative;\n      margin-bottom: 15px;\n      padding-bottom: 20px;\n}\n.notification-form .nf-content .textarea-box .emoji-trigger[data-v-34fc9245] {\n        position: absolute;\n        bottom: -3px;\n        left: 0;\n        color: #aaa;\n        cursor: pointer;\n}\n.notification-form .nf-content textarea[data-v-34fc9245] {\n      margin: 0;\n      padding: 10px;\n      width: 100%;\n      resize: none;\n      background: #fdfdfd;\n      font-size: 14px;\n      outline: none;\n      color: #333;\n      border-color: #ddd;\n      -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.05) inset;\n              box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.05) inset;\n      -webkit-transition: all .3s ease;\n      transition: all .3s ease;\n}\n.notification-form .nf-content textarea.exceed[data-v-34fc9245] {\n        border-color: #d61613;\n        background: #fff0f0;\n}\n.notification-form .nf-content .char-count[data-v-34fc9245] {\n      font-size: 12px;\n      color: #777;\n      display: block;\n      text-align: right;\n      line-height: 1;\n      margin-top: 5px;\n}\n.notification-form .nf-content .char-count.exceed[data-v-34fc9245] {\n        color: #f00;\n}\n.notification-form .nf-content .cancel-notif[data-v-34fc9245] {\n      display: block;\n      font-size: 13px;\n      margin: 10px 0 0;\n      text-align: center;\n      cursor: pointer;\n      color: #bbb;\n      -webkit-transition: all .5s ease;\n      transition: all .5s ease;\n}\n.notification-form .nf-content .cancel-notif[data-v-34fc9245]:hover {\n        color: #333;\n}\n.notification-form .nf-content .file-box[data-v-34fc9245] {\n      position: relative;\n}\n.notification-form .nf-content .file-box input[data-v-34fc9245] {\n        padding: 5px 25px 5px 5px;\n        margin: 0;\n        font-size: 14px;\n}\n.notification-form .nf-content .file-box i[data-v-34fc9245] {\n        position: absolute;\n        z-index: 2;\n        top: 50%;\n        right: 5px;\n        -webkit-transform: translateY(-50%);\n                transform: translateY(-50%);\n        color: #fd4a38;\n        cursor: pointer;\n}\n.notification-form .error[data-v-34fc9245] {\n    text-align: center;\n}\n.notification-form .error i[data-v-34fc9245] {\n      color: #fd4a38;\n}\n.notification-form .error p[data-v-34fc9245] {\n      margin: 5px 0 20px;\n}\n.notification-form .error code[data-v-34fc9245] {\n      border: 2px solid #fd4a38;\n      padding: 10px;\n      width: 100%;\n      display: block;\n      font-size: 14px;\n      background: #ffeeec;\n      border-radius: 3px;\n      margin-bottom: 30px;\n}\n.notification-form .success-box[data-v-34fc9245] {\n    text-align: center;\n}\n.notification-form .success-box i[data-v-34fc9245] {\n      color: #26d97a;\n}\n.notification-form .loader[data-v-34fc9245] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.3);\n}\n.notification-form .loader div[data-v-34fc9245] {\n      position: absolute;\n      top: 50%;\n      left: 0;\n      height: 50px;\n      width: 100%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      text-align: center;\n}\n.notification-form .loader div i[data-v-34fc9245] {\n        color: #45e7f9;\n}\n.notification-form .loader div span[data-v-34fc9245] {\n        color: #fff;\n        font-size: 21px;\n        font-weight: 600;\n        margin-left: 5px;\n        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);\n}\n.select-box[data-v-34fc9245] {\n  position: relative;\n}\n.select-box .select-loader[data-v-34fc9245] {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    font-size: 13px;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%);\n    z-index: 2;\n    color: #a2a6aa;\n}\n.select-box .select-loader i[data-v-34fc9245] {\n      vertical-align: -1px;\n      margin-right: 3px;\n}\n.select-box select[data-v-34fc9245] {\n    position: relative;\n    z-index: 1;\n}\n.emoji-box[data-v-34fc9245] {\n  position: absolute;\n  top: 0;\n  left: 100%;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n}\n.announcement-check[data-v-34fc9245] {\n  margin-bottom: 5px !important;\n  padding-left: 2px;\n}\ninput[type=\"checkbox\"][data-v-34fc9245] {\n  width: auto;\n  margin-top: 0;\n}\n.disabled-opt[data-v-34fc9245] {\n  font-style: italic;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'op--modal-container':true, hide: !_vm.notification.showForm },on:{"click":_vm.closeNotifForm}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content"},[_c('div',{staticClass:"notification-form",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"heading"},[_vm._v(_vm._s(_vm.$t('consumer.list.pushNotif')))]),_vm._v(" "),_c('div',{staticClass:"nf-content",on:{"click":_vm.closeEmoji}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.notification.errorMsg && !_vm.notification.success),expression:"!notification.errorMsg && !notification.success"}]},[(!_vm.hideTargetOption)?_c('div',{class:{'data-field':true, 'has-error':!!_vm.notification.targetMessage, 'reduce-margin':_vm.notification.target === 'geofence'}},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('consumer.list.target'))+":")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.notification.target),expression:"notification.target"}],attrs:{"disabled":_vm.notification.geofence.loading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.notification, "target", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.targetUpdate]}},[(!_vm.removeAllActiveUserOption)?_c('option',{attrs:{"value":"all"}},[_vm._v("All Active User")]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"value":"selected"}},[_vm._v(_vm._s(_vm.$t('consumer.list.selectedUser')))]),_vm._v(" "),(_vm.showGeofenceOption)?_c('option',{attrs:{"value":"geofence"}},[_vm._v("Geofence")]):_vm._e(),_vm._v(" "),(_vm.showBySector)?_c('option',{attrs:{"value":"sector"}},[_vm._v("By Sector Group")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.notification.targetMessage))])]):_vm._e(),_vm._v(" "),(_vm.notification.geofence.show)?_c('div',{class:{'data-field':true, 'has-error':!!_vm.notification.geofence.error.type, 'reduce-margin':_vm.notification.target === 'geofence'}},[_c('div',{staticClass:"label"},[_vm._v("Geofence Type:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.notification.geofence.type),expression:"notification.geofence.type"}],attrs:{"disabled":_vm.notification.geofence.loading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.notification.geofence, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateGeofenceList]}},[_c('option',{attrs:{"value":"airport"}},[_vm._v("Airport")]),_vm._v(" "),_c('option',{attrs:{"value":"staging"}},[_vm._v("Staging")]),_vm._v(" "),_c('option',{attrs:{"value":"serviceArea"}},[_vm._v("Service Area")])]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.notification.geofence.error.type))])]):_vm._e(),_vm._v(" "),(_vm.notification.geofence.show && _vm.notification.geofence.type === 'serviceArea')?_c('div',{class:{'data-field':true, 'has-error':!!_vm.notification.geofence.error.brand, 'reduce-margin':_vm.notification.target === 'geofence'}},[_c('div',{staticClass:"label"},[_vm._v("Brand:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.notification.geofence.brand),expression:"notification.geofence.brand"}],attrs:{"disabled":_vm.notification.geofence.loading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.notification.geofence, "brand", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateGeofenceList]}},_vm._l((_vm.brands),function(brand){return _c('option',{key:brand.id,domProps:{"value":brand.id}},[_vm._v(_vm._s(brand.name))])}),0),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.notification.geofence.error.brand))])]):_vm._e(),_vm._v(" "),(_vm.notification.geofence.show && ((_vm.notification.geofence.type === 'serviceArea' && _vm.notification.geofence.brand) || (_vm.notification.geofence.type && _vm.notification.geofence.type !== 'serviceArea')))?_c('div',{class:{'data-field':true, 'has-error':!!_vm.notification.geofence.error.id}},[_c('div',{staticClass:"label"},[_vm._v("Geofence:")]),_vm._v(" "),_c('div',{staticClass:"select-box"},[(_vm.notification.geofence.loading)?_c('div',{staticClass:"select-loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n                  Loading...\n                ")]):_vm._e(),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.notification.geofence.id),expression:"notification.geofence.id"}],attrs:{"disabled":_vm.notification.geofence.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.notification.geofence, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.notification.geofence.list),function(geofence){return _c('option',{key:geofence.id,domProps:{"value":geofence.id}},[_vm._v(_vm._s(geofence.name))])}),0)]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.notification.geofence.error.id))])]):_vm._e(),_vm._v(" "),(_vm.notification.target === 'sector')?_c('div',{class:['data-field', {'has-error':!!_vm.notification.sectorError, 'reduce-margin':true}]},[_c('div',{staticClass:"label"},[_vm._v("Sector:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.notification.sector),expression:"notification.sector"}],attrs:{"disabled":_vm.notification.geofence.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.notification, "sector", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{staticClass:"group1",attrs:{"value":"group1"}},[_vm._v("Group 1 ")]),_vm._v(" "),_c('option',{staticClass:"disabled-opt _group1",attrs:{"disabled":""}},[_vm._v("   Santa Monica / Marina, West LA / West Hollywood")]),_vm._v(" "),_c('option',{staticClass:"disabled-opt _group1",attrs:{"disabled":""}},[_vm._v("   Mid-Wilshire / Hollywood, Downtown Area")]),_vm._v(" "),_c('option',{staticClass:"disabled-opt _group1",attrs:{"disabled":""}},[_vm._v("   South Bay / Palos Verdes, South Central")]),_vm._v(" "),_c('option',{attrs:{"value":"group2"}},[_vm._v("Group 2")]),_vm._v(" "),_c('option',{staticClass:"disabled-opt",attrs:{"disabled":""}},[_vm._v("   Downey / Brea, San Pedro / LA Harbor")]),_vm._v(" "),_c('option',{staticClass:"disabled-opt",attrs:{"disabled":""}},[_vm._v("   Long Beach Shore, Anaheim / Disney")]),_vm._v(" "),_c('option',{staticClass:"disabled-opt",attrs:{"disabled":""}},[_vm._v("   Orange County Beach Cities")]),_vm._v(" "),_c('option',{attrs:{"value":"group3"}},[_vm._v("Group 3")]),_vm._v(" "),_c('option',{staticClass:"disabled-opt",attrs:{"disabled":""}},[_vm._v("   Long West Valley, Short West Valley")]),_vm._v(" "),_c('option',{staticClass:"disabled-opt",attrs:{"disabled":""}},[_vm._v("   North Valley, East Valley, Mid-Valley")]),_vm._v(" "),_c('option',{staticClass:"disabled-opt",attrs:{"disabled":""}},[_vm._v("   Glendale / La Canada, Pasadena / North San Gabriel Valley")]),_vm._v(" "),_c('option',{attrs:{"value":"group4"}},[_vm._v("Group 4")]),_vm._v(" "),_c('option',{staticClass:"disabled-opt",attrs:{"disabled":""}},[_vm._v("   West Covina / Ontario, Diamond Bar")]),_vm._v(" "),_c('option',{staticClass:"disabled-opt",attrs:{"disabled":""}},[_vm._v("    Riverside / Corona, Palm Springs, San Diego")])]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.notification.sectorError))])]):_vm._e(),_vm._v(" "),(false)?_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notification.isPushNotif),expression:"notification.isPushNotif"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.notification.isPushNotif)?_vm._i(_vm.notification.isPushNotif,null)>-1:(_vm.notification.isPushNotif)},on:{"change":function($event){var $$a=_vm.notification.isPushNotif,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.notification, "isPushNotif", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.notification, "isPushNotif", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.notification, "isPushNotif", $$c)}}}}),_vm._v("\n              "+_vm._s(_vm.$t('consumer.list.pushNotif'))+"\n            ")]):_vm._e(),_vm._v(" "),(false)?_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notification.isSendEmail),expression:"notification.isSendEmail"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.notification.isSendEmail)?_vm._i(_vm.notification.isSendEmail,null)>-1:(_vm.notification.isSendEmail)},on:{"change":function($event){var $$a=_vm.notification.isSendEmail,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.notification, "isSendEmail", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.notification, "isSendEmail", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.notification, "isSendEmail", $$c)}}}}),_vm._v("\n              "+_vm._s(_vm.$t('consumer.list.email'))+"\n            ")]):_vm._e(),_vm._v(" "),_c('div',{class:{'data-field':true, 'has-error':!!_vm.notification.titleError}},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('consumer.list.title'))+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notification.title),expression:"notification.title"}],staticClass:"input",attrs:{"type":"text"},domProps:{"value":(_vm.notification.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.notification, "title", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.notification.titleError))])]),_vm._v(" "),_c('div',{staticClass:"textarea-box"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.notification.message),expression:"notification.message"}],ref:"notifMsg",class:{'exceed':_vm.notification.charExceed},attrs:{"rows":"5","placeholder":_vm.$t('consumer.list.message')},domProps:{"value":(_vm.notification.message)},on:{"keydown":_vm.charCountUpdate,"keyup":_vm.charCountUpdate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.notification, "message", $event.target.value)}}}),_vm._v(" "),_c('i',{staticClass:"far fa-smile fa-lg emoji-trigger",on:{"click":[function($event){$event.stopPropagation();},function($event){_vm.notification.showEmoji = !_vm.notification.showEmoji}]}})]),_vm._v(" "),(false)?_c('div',{class:{'data-field':true, 'has-error':!!_vm.notification.fileError}},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('consumer.list.img'))+":")]),_vm._v(" "),_c('div',{staticClass:"file-box"},[(_vm.notification.fileReady)?_c('input',{ref:"fileInput",staticClass:"input-file",attrs:{"type":"file","name":"image","accept":"image/*"},on:{"change":_vm.setImage}}):_vm._e(),_vm._v(" "),(!!_vm.notification.file)?_c('i',{staticClass:"fas fa-times fa-lg",on:{"click":_vm.cleanFileInput}}):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.notification.fileError))])]):_vm._e(),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.notification.target === 'all'),expression:"notification.target === 'all'"}],staticClass:"announcement-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notification.isAnnouncement),expression:"notification.isAnnouncement"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.notification.isAnnouncement)?_vm._i(_vm.notification.isAnnouncement,null)>-1:(_vm.notification.isAnnouncement)},on:{"change":function($event){var $$a=_vm.notification.isAnnouncement,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.notification, "isAnnouncement", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.notification, "isAnnouncement", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.notification, "isAnnouncement", $$c)}}}}),_vm._v("\n              Send as announcement\n            ")]),_vm._v(" "),_c('div',{class:{'button cta warning block':true, 'disabled':_vm.disableNotifButton},on:{"click":_vm.checkFileUpload}},[_vm._v("\n              "+_vm._s(_vm.$t('consumer.list.send'))+"\n            ")]),_vm._v(" "),_c('a',{staticClass:"cancel-notif",on:{"click":_vm.closeNotifForm}},[_vm._v(_vm._s(_vm.$t('consumer.list.cancel')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.notification.errorMsg),expression:"!!notification.errorMsg"}],staticClass:"error"},[_c('i',{staticClass:"far fa-frown fa-5x"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('consumer.list.errorMsg')))]),_vm._v(" "),_c('code',[_vm._v(_vm._s(_vm.notification.errorMsg))]),_vm._v(" "),_c('div',{staticClass:"button cta block small error",on:{"click":_vm.closeNotifForm}},[_vm._v(_vm._s(_vm.$t('consumer.list.close')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.notification.success),expression:"notification.success"}],staticClass:"success-box"},[_c('i',{staticClass:"far fa-check-circle fa-5x"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('consumer.list.sendNotifSuccess')))]),_vm._v(" "),_c('div',{staticClass:"button cta block small success",on:{"click":_vm.closeNotifForm}},[_vm._v(_vm._s(_vm.$t('consumer.list.close')))])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-left"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.notification.showEmoji),expression:"notification.showEmoji"}],staticClass:"emoji-box",on:{"click":function($event){$event.stopPropagation();}}},[_c('picker',{style:(_vm.emojiStyle),attrs:{"exclude":['recent']},on:{"select":_vm.addEmoji}})],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"pop"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.notification.loading),expression:"notification.loading"}],staticClass:"loader"},[_c('div',[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('consumer.list.sendingNotif')))])])])])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1245);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("7b44d62d", content, true, {});

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.data-field[data-v-492822ae] {\n  position: relative;\n  margin-bottom: 20px;\n}\n.data-field.reduce-margin[data-v-492822ae] {\n    margin-bottom: 12px;\n}\n.data-field .label[data-v-492822ae] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 130%;\n    margin-bottom: 3px;\n}\n.data-field .label.has-error[data-v-492822ae] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-492822ae] {\n    margin: 5px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-492822ae] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-492822ae]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-492822ae] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.op--modal-container[data-v-492822ae] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.35);\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-492822ae] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-492822ae] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-492822ae] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.notification-form[data-v-492822ae] {\n  background-color: #fff;\n  max-width: 400px;\n  margin: 10px auto;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n.notification-form .heading[data-v-492822ae] {\n    background: #333;\n    color: #fff;\n    padding: 10px;\n    font-size: 18px;\n    text-align: center;\n}\n.notification-form .nf-content[data-v-492822ae] {\n    padding: 20px;\n    position: relative;\n}\n.notification-form .nf-content .label[data-v-492822ae] {\n      font-size: 13px;\n      color: #555;\n}\n.notification-form .nf-content label[data-v-492822ae] {\n      display: block;\n      font-size: 14px;\n      color: #555;\n      margin-bottom: 2px;\n      cursor: pointer;\n}\n.notification-form .nf-content label input[data-v-492822ae] {\n        display: inline-block;\n        vertical-align: middle;\n        margin-right: 5px;\n}\n.notification-form .nf-content .textarea-box[data-v-492822ae] {\n      position: relative;\n      margin-bottom: 20px;\n      padding-bottom: 20px;\n}\n.notification-form .nf-content .textarea-box .emoji-trigger[data-v-492822ae] {\n        position: absolute;\n        top: 133px;\n        right: 0;\n        color: #aaa;\n        cursor: pointer;\n}\n.notification-form .nf-content .textarea-box .error-msg[data-v-492822ae] {\n        font-size: 11px;\n        line-height: 1.6;\n        color: #f20d0d;\n        font-style: italic;\n        display: block;\n}\n.notification-form .nf-content textarea[data-v-492822ae] {\n      margin: 0;\n      padding: 10px;\n      width: 100%;\n      resize: none;\n      background: #fdfdfd;\n      font-size: 14px;\n      outline: none;\n      color: #333;\n      border-color: #ddd;\n      -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.05) inset;\n              box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.05) inset;\n      -webkit-transition: all .3s ease;\n      transition: all .3s ease;\n}\n.notification-form .nf-content textarea.exceed[data-v-492822ae] {\n        border-color: #d61613;\n        background: #fff0f0;\n}\n.notification-form .nf-content .char-count[data-v-492822ae] {\n      font-size: 12px;\n      color: #777;\n      display: block;\n      text-align: right;\n      line-height: 1;\n      margin-top: 5px;\n}\n.notification-form .nf-content .char-count.exceed[data-v-492822ae] {\n        color: #f00;\n}\n.notification-form .nf-content .cancel-notif[data-v-492822ae] {\n      display: block;\n      font-size: 13px;\n      margin: 10px 0 0;\n      text-align: center;\n      cursor: pointer;\n      color: #bbb;\n      -webkit-transition: all .5s ease;\n      transition: all .5s ease;\n}\n.notification-form .nf-content .cancel-notif[data-v-492822ae]:hover {\n        color: #333;\n}\n.notification-form .nf-content .file-box[data-v-492822ae] {\n      position: relative;\n}\n.notification-form .nf-content .file-box input[data-v-492822ae] {\n        padding: 5px 25px 5px 5px;\n        margin: 0;\n        font-size: 14px;\n}\n.notification-form .nf-content .file-box i[data-v-492822ae] {\n        position: absolute;\n        z-index: 2;\n        top: 50%;\n        right: 5px;\n        -webkit-transform: translateY(-50%);\n                transform: translateY(-50%);\n        color: #fd4a38;\n        cursor: pointer;\n}\n.notification-form .error[data-v-492822ae] {\n    text-align: center;\n}\n.notification-form .error i[data-v-492822ae] {\n      color: #fd4a38;\n}\n.notification-form .error p[data-v-492822ae] {\n      margin: 5px 0 20px;\n}\n.notification-form .error code[data-v-492822ae] {\n      border: 2px solid #fd4a38;\n      padding: 10px;\n      width: 100%;\n      display: block;\n      font-size: 14px;\n      background: #ffeeec;\n      border-radius: 3px;\n      margin-bottom: 30px;\n}\n.notification-form .success-box[data-v-492822ae] {\n    text-align: center;\n}\n.notification-form .success-box i[data-v-492822ae] {\n      color: #26d97a;\n}\n.notification-form .loader[data-v-492822ae] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.3);\n}\n.notification-form .loader div[data-v-492822ae] {\n      position: absolute;\n      top: 50%;\n      left: 0;\n      height: 50px;\n      width: 100%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      text-align: center;\n}\n.notification-form .loader div i[data-v-492822ae] {\n        color: #45e7f9;\n}\n.notification-form .loader div span[data-v-492822ae] {\n        color: #fff;\n        font-size: 21px;\n        font-weight: 600;\n        margin-left: 5px;\n        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);\n}\n.select-box[data-v-492822ae] {\n  position: relative;\n}\n.select-box .select-loader[data-v-492822ae] {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    font-size: 13px;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%);\n    z-index: 2;\n    color: #a2a6aa;\n}\n.select-box .select-loader i[data-v-492822ae] {\n      vertical-align: -1px;\n      margin-right: 3px;\n}\n.select-box select[data-v-492822ae] {\n    position: relative;\n    z-index: 1;\n}\n.emoji-box[data-v-492822ae] {\n  position: absolute;\n  top: 0;\n  left: 100%;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/App/SMSModal.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,oBAAoB;CACrB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,eAAe;EACf,sCAAsC;EACtC,WAAW;EACX,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;UACzC,yCAAyC;CAClD;AACD;IACI,iBAAiB;IACjB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,mBAAmB;CACtB;AACD;IACI,cAAc;IACd,mBAAmB;CACtB;AACD;MACM,gBAAgB;MAChB,YAAY;CACjB;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,YAAY;MACZ,mBAAmB;MACnB,gBAAgB;CACrB;AACD;QACQ,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;CACzB;AACD;MACM,mBAAmB;MACnB,oBAAoB;MACpB,qBAAqB;CAC1B;AACD;QACQ,mBAAmB;QACnB,WAAW;QACX,SAAS;QACT,YAAY;QACZ,gBAAgB;CACvB;AACD;QACQ,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;QACf,mBAAmB;QACnB,eAAe;CACtB;AACD;MACM,UAAU;MACV,cAAc;MACd,YAAY;MACZ,aAAa;MACb,oBAAoB;MACpB,gBAAgB;MAChB,cAAc;MACd,YAAY;MACZ,mBAAmB;MACnB,0DAA0D;cAClD,kDAAkD;MAC1D,iCAAiC;MACjC,yBAAyB;CAC9B;AACD;QACQ,sBAAsB;QACtB,oBAAoB;CAC3B;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,eAAe;MACf,kBAAkB;MAClB,eAAe;MACf,gBAAgB;CACrB;AACD;QACQ,YAAY;CACnB;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,mBAAmB;MACnB,gBAAgB;MAChB,YAAY;MACZ,iCAAiC;MACjC,yBAAyB;CAC9B;AACD;QACQ,YAAY;CACnB;AACD;MACM,mBAAmB;CACxB;AACD;QACQ,0BAA0B;QAC1B,UAAU;QACV,gBAAgB;CACvB;AACD;QACQ,mBAAmB;QACnB,WAAW;QACX,SAAS;QACT,WAAW;QACX,oCAAoC;gBAC5B,4BAA4B;QACpC,eAAe;QACf,gBAAgB;CACvB;AACD;IACI,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,0BAA0B;MAC1B,cAAc;MACd,YAAY;MACZ,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,mBAAmB;MACnB,oBAAoB;CACzB;AACD;IACI,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,aAAa;IACb,+BAA+B;CAClC;AACD;MACM,mBAAmB;MACnB,SAAS;MACT,QAAQ;MACR,aAAa;MACb,YAAY;MACZ,oCAAoC;cAC5B,4BAA4B;MACpC,mBAAmB;CACxB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;QACjB,4CAA4C;CACnD;AACD;EACE,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,yCAAyC;YACjC,iCAAiC;IACzC,WAAW;IACX,eAAe;CAClB;AACD;MACM,qBAAqB;MACrB,kBAAkB;CACvB;AACD;IACI,mBAAmB;IACnB,WAAW;CACd;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;CACd","file":"SMSModal.vue","sourcesContent":["\n.data-field[data-v-492822ae] {\n  position: relative;\n  margin-bottom: 20px;\n}\n.data-field.reduce-margin[data-v-492822ae] {\n    margin-bottom: 12px;\n}\n.data-field .label[data-v-492822ae] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 130%;\n    margin-bottom: 3px;\n}\n.data-field .label.has-error[data-v-492822ae] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-492822ae] {\n    margin: 5px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-492822ae] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-492822ae]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-492822ae] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.op--modal-container[data-v-492822ae] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.35);\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-492822ae] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-492822ae] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-492822ae] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.notification-form[data-v-492822ae] {\n  background-color: #fff;\n  max-width: 400px;\n  margin: 10px auto;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n.notification-form .heading[data-v-492822ae] {\n    background: #333;\n    color: #fff;\n    padding: 10px;\n    font-size: 18px;\n    text-align: center;\n}\n.notification-form .nf-content[data-v-492822ae] {\n    padding: 20px;\n    position: relative;\n}\n.notification-form .nf-content .label[data-v-492822ae] {\n      font-size: 13px;\n      color: #555;\n}\n.notification-form .nf-content label[data-v-492822ae] {\n      display: block;\n      font-size: 14px;\n      color: #555;\n      margin-bottom: 2px;\n      cursor: pointer;\n}\n.notification-form .nf-content label input[data-v-492822ae] {\n        display: inline-block;\n        vertical-align: middle;\n        margin-right: 5px;\n}\n.notification-form .nf-content .textarea-box[data-v-492822ae] {\n      position: relative;\n      margin-bottom: 20px;\n      padding-bottom: 20px;\n}\n.notification-form .nf-content .textarea-box .emoji-trigger[data-v-492822ae] {\n        position: absolute;\n        top: 133px;\n        right: 0;\n        color: #aaa;\n        cursor: pointer;\n}\n.notification-form .nf-content .textarea-box .error-msg[data-v-492822ae] {\n        font-size: 11px;\n        line-height: 1.6;\n        color: #f20d0d;\n        font-style: italic;\n        display: block;\n}\n.notification-form .nf-content textarea[data-v-492822ae] {\n      margin: 0;\n      padding: 10px;\n      width: 100%;\n      resize: none;\n      background: #fdfdfd;\n      font-size: 14px;\n      outline: none;\n      color: #333;\n      border-color: #ddd;\n      -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.05) inset;\n              box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.05) inset;\n      -webkit-transition: all .3s ease;\n      transition: all .3s ease;\n}\n.notification-form .nf-content textarea.exceed[data-v-492822ae] {\n        border-color: #d61613;\n        background: #fff0f0;\n}\n.notification-form .nf-content .char-count[data-v-492822ae] {\n      font-size: 12px;\n      color: #777;\n      display: block;\n      text-align: right;\n      line-height: 1;\n      margin-top: 5px;\n}\n.notification-form .nf-content .char-count.exceed[data-v-492822ae] {\n        color: #f00;\n}\n.notification-form .nf-content .cancel-notif[data-v-492822ae] {\n      display: block;\n      font-size: 13px;\n      margin: 10px 0 0;\n      text-align: center;\n      cursor: pointer;\n      color: #bbb;\n      -webkit-transition: all .5s ease;\n      transition: all .5s ease;\n}\n.notification-form .nf-content .cancel-notif[data-v-492822ae]:hover {\n        color: #333;\n}\n.notification-form .nf-content .file-box[data-v-492822ae] {\n      position: relative;\n}\n.notification-form .nf-content .file-box input[data-v-492822ae] {\n        padding: 5px 25px 5px 5px;\n        margin: 0;\n        font-size: 14px;\n}\n.notification-form .nf-content .file-box i[data-v-492822ae] {\n        position: absolute;\n        z-index: 2;\n        top: 50%;\n        right: 5px;\n        -webkit-transform: translateY(-50%);\n                transform: translateY(-50%);\n        color: #fd4a38;\n        cursor: pointer;\n}\n.notification-form .error[data-v-492822ae] {\n    text-align: center;\n}\n.notification-form .error i[data-v-492822ae] {\n      color: #fd4a38;\n}\n.notification-form .error p[data-v-492822ae] {\n      margin: 5px 0 20px;\n}\n.notification-form .error code[data-v-492822ae] {\n      border: 2px solid #fd4a38;\n      padding: 10px;\n      width: 100%;\n      display: block;\n      font-size: 14px;\n      background: #ffeeec;\n      border-radius: 3px;\n      margin-bottom: 30px;\n}\n.notification-form .success-box[data-v-492822ae] {\n    text-align: center;\n}\n.notification-form .success-box i[data-v-492822ae] {\n      color: #26d97a;\n}\n.notification-form .loader[data-v-492822ae] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.3);\n}\n.notification-form .loader div[data-v-492822ae] {\n      position: absolute;\n      top: 50%;\n      left: 0;\n      height: 50px;\n      width: 100%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      text-align: center;\n}\n.notification-form .loader div i[data-v-492822ae] {\n        color: #45e7f9;\n}\n.notification-form .loader div span[data-v-492822ae] {\n        color: #fff;\n        font-size: 21px;\n        font-weight: 600;\n        margin-left: 5px;\n        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);\n}\n.select-box[data-v-492822ae] {\n  position: relative;\n}\n.select-box .select-loader[data-v-492822ae] {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    font-size: 13px;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%);\n    z-index: 2;\n    color: #a2a6aa;\n}\n.select-box .select-loader i[data-v-492822ae] {\n      vertical-align: -1px;\n      margin-right: 3px;\n}\n.select-box select[data-v-492822ae] {\n    position: relative;\n    z-index: 1;\n}\n.emoji-box[data-v-492822ae] {\n  position: absolute;\n  top: 0;\n  left: 100%;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'op--modal-container':true, hide: !_vm.sms.showForm },on:{"click":_vm.closeSMSForm}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content"},[_c('div',{staticClass:"notification-form",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"heading"},[_vm._v(_vm._s(_vm.$t('provider.list.sms.header')))]),_vm._v(" "),_c('div',{staticClass:"nf-content",on:{"click":_vm.closeEmoji}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.sms.errorMsg && !_vm.sms.success),expression:"!sms.errorMsg && !sms.success"}]},[(!_vm.hideTargetOption)?_c('div',{class:{'data-field':true, 'has-error':!!_vm.sms.targetMessage, 'reduce-margin':_vm.sms.target === 'geofence'}},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('consumer.list.target'))+":")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sms.target),expression:"sms.target"}],attrs:{"disabled":_vm.sms.geofence.loading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.sms, "target", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.targetUpdate]}},[(!_vm.removeAllActiveUserOption)?_c('option',{attrs:{"value":"all"}},[_vm._v("All Active User")]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"value":"selected"}},[_vm._v(_vm._s(_vm.$t('consumer.list.selectedUser')))]),_vm._v(" "),(_vm.showGeofenceOption)?_c('option',{attrs:{"value":"geofence"}},[_vm._v("Geofence")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.sms.targetMessage))])]):_vm._e(),_vm._v(" "),(_vm.sms.geofence.show)?_c('div',{class:{'data-field':true, 'has-error':!!_vm.sms.geofence.error.type, 'reduce-margin':_vm.sms.target === 'geofence'}},[_c('div',{staticClass:"label"},[_vm._v("Geofence Type:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sms.geofence.type),expression:"sms.geofence.type"}],attrs:{"disabled":_vm.sms.geofence.loading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.sms.geofence, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateGeofenceList]}},[_c('option',{attrs:{"value":"airport"}},[_vm._v("Airport")]),_vm._v(" "),_c('option',{attrs:{"value":"staging"}},[_vm._v("Staging")]),_vm._v(" "),_c('option',{attrs:{"value":"serviceArea"}},[_vm._v("Service Area")])]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.sms.geofence.error.type))])]):_vm._e(),_vm._v(" "),(_vm.sms.geofence.show && _vm.sms.geofence.type === 'serviceArea')?_c('div',{class:{'data-field':true, 'has-error':!!_vm.sms.geofence.error.brand, 'reduce-margin':_vm.sms.target === 'geofence'}},[_c('div',{staticClass:"label"},[_vm._v("Brand:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sms.geofence.brand),expression:"sms.geofence.brand"}],attrs:{"disabled":_vm.sms.geofence.loading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.sms.geofence, "brand", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateGeofenceList]}},_vm._l((_vm.brands),function(brand){return _c('option',{key:brand.id,domProps:{"value":brand.id}},[_vm._v(_vm._s(brand.name))])}),0),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.sms.geofence.error.brand))])]):_vm._e(),_vm._v(" "),(_vm.sms.geofence.show && ((_vm.sms.geofence.type === 'serviceArea' && _vm.sms.geofence.brand) || (_vm.sms.geofence.type && _vm.sms.geofence.type !== 'serviceArea')))?_c('div',{class:{'data-field':true, 'has-error':!!_vm.sms.geofence.error.id}},[_c('div',{staticClass:"label"},[_vm._v("Geofence:")]),_vm._v(" "),_c('div',{staticClass:"select-box"},[(_vm.sms.geofence.loading)?_c('div',{staticClass:"select-loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n                  Loading...\n                ")]):_vm._e(),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sms.geofence.id),expression:"sms.geofence.id"}],attrs:{"disabled":_vm.sms.geofence.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.sms.geofence, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.sms.geofence.list),function(geofence){return _c('option',{key:geofence.id,domProps:{"value":geofence.id}},[_vm._v(_vm._s(geofence.name))])}),0)]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.sms.geofence.error.id))])]):_vm._e(),_vm._v(" "),(false)?_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sms.isPushNotif),expression:"sms.isPushNotif"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.sms.isPushNotif)?_vm._i(_vm.sms.isPushNotif,null)>-1:(_vm.sms.isPushNotif)},on:{"change":function($event){var $$a=_vm.sms.isPushNotif,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.sms, "isPushNotif", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.sms, "isPushNotif", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.sms, "isPushNotif", $$c)}}}}),_vm._v("\n              "+_vm._s(_vm.$t('consumer.list.pushNotif'))+"\n            ")]):_vm._e(),_vm._v(" "),(false)?_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sms.isSendEmail),expression:"sms.isSendEmail"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.sms.isSendEmail)?_vm._i(_vm.sms.isSendEmail,null)>-1:(_vm.sms.isSendEmail)},on:{"change":function($event){var $$a=_vm.sms.isSendEmail,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.sms, "isSendEmail", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.sms, "isSendEmail", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.sms, "isSendEmail", $$c)}}}}),_vm._v("\n              "+_vm._s(_vm.$t('consumer.list.email'))+"\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"textarea-box"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sms.message),expression:"sms.message"}],ref:"notifMsg",class:{'exceed':_vm.sms.charExceed},attrs:{"rows":"5","placeholder":_vm.$t('consumer.list.message')},domProps:{"value":(_vm.sms.message)},on:{"keydown":_vm.charCountUpdate,"keyup":_vm.charCountUpdate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sms, "message", $event.target.value)}}}),_vm._v(" "),_c('i',{staticClass:"far fa-smile fa-lg emoji-trigger",on:{"click":[function($event){$event.stopPropagation();},function($event){_vm.sms.showEmoji = !_vm.sms.showEmoji}]}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.sms.messageError))])]),_vm._v(" "),(false)?_c('div',{class:{'data-field':true, 'has-error':!!_vm.sms.fileError}},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('consumer.list.img'))+":")]),_vm._v(" "),_c('div',{staticClass:"file-box"},[(_vm.sms.fileReady)?_c('input',{ref:"fileInput",staticClass:"input-file",attrs:{"type":"file","name":"image","accept":"image/*"},on:{"change":_vm.setImage}}):_vm._e(),_vm._v(" "),(!!_vm.sms.file)?_c('i',{staticClass:"fas fa-times fa-lg",on:{"click":_vm.cleanFileInput}}):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.sms.fileError))])]):_vm._e(),_vm._v(" "),_c('div',{class:{'button cta warning block':true, 'disabled':_vm.disableNotifButton},on:{"click":_vm.checkFileUpload}},[_vm._v("\n              "+_vm._s(_vm.$t('consumer.list.send'))+"\n            ")]),_vm._v(" "),_c('a',{staticClass:"cancel-notif",on:{"click":_vm.closeSMSForm}},[_vm._v(_vm._s(_vm.$t('consumer.list.cancel')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.sms.errorMsg),expression:"!!sms.errorMsg"}],staticClass:"error"},[_c('i',{staticClass:"far fa-frown fa-5x"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('consumer.list.errorMsg')))]),_vm._v(" "),_c('code',[_vm._v(_vm._s(_vm.sms.errorMsg))]),_vm._v(" "),_c('div',{staticClass:"button cta block small error",on:{"click":_vm.closeSMSForm}},[_vm._v(_vm._s(_vm.$t('consumer.list.close')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sms.success),expression:"sms.success"}],staticClass:"success-box"},[_c('i',{staticClass:"far fa-check-circle fa-5x"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('consumer.list.sendNotifSuccess')))]),_vm._v(" "),_c('div',{staticClass:"button cta block small success",on:{"click":_vm.closeSMSForm}},[_vm._v(_vm._s(_vm.$t('consumer.list.close')))])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-left"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sms.showEmoji),expression:"sms.showEmoji"}],staticClass:"emoji-box",on:{"click":function($event){$event.stopPropagation();}}},[_c('picker',{style:(_vm.emojiStyle),attrs:{"exclude":['recent']},on:{"select":_vm.addEmoji}})],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"pop"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sms.loading),expression:"sms.loading"}],staticClass:"loader"},[_c('div',[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('consumer.list.sendingNotif')))])])])])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"staging-drivers"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.driversDisplayed !== null),expression:"driversDisplayed !== null"}],class:{ 'refresh-button button': true, disabled: _vm.refreshing },attrs:{"href":"javascript:;"},on:{"click":_vm.refreshDrivers}},[_c('i',{class:{ 'fas fa-sync': true, 'fa-spin': _vm.refreshing }})]),_vm._v(" "),_c('div',{staticClass:"airport-select"},[_c('label',[_vm._v("Select an airport:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.airport.selected),expression:"airport.selected",modifiers:{"number":true}}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.$set(_vm.airport, "selected", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.onAirportSelect]}},[_c('option',{attrs:{"value":"-1"}},[_vm._v("Choose one")]),_vm._v(" "),_vm._l((_vm.airport.list),function(airport){return _c('option',{key:airport.id,domProps:{"value":airport.id}},[_vm._v(_vm._s(airport.name))])})],2),_vm._v(" "),_c('i',{staticClass:"fas fa-caret-down"})]),_vm._v(" "),_c('div',{staticClass:"staging-lots"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.staging.loading),expression:"staging.loading"}],staticClass:"loader"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',[_vm._v("Loading staging lots...")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.staging.error),expression:"staging.error"}],staticClass:"staging-area-error"},[_vm._v("\n      There are no drivers staged for that airport.\n    ")]),_vm._v(" "),(!_vm.staging.loading && _vm.staging.list.length > 1 && !_vm.staging.error)?_c('div',{staticClass:"staging-areas"},[_c('label',[_vm._v("Select a staging lot:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.staging.selected),expression:"staging.selected",modifiers:{"number":true}}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.$set(_vm.staging, "selected", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.onStagingLotSelect]}},[_c('option',{attrs:{"value":"-1"}},[_vm._v("Choose one")]),_vm._v(" "),_vm._l((_vm.staging.list),function(stagingLot){return _c('option',{key:stagingLot.id,domProps:{"value":stagingLot.id}},[_vm._v(_vm._s(stagingLot.name))])})],2),_vm._v(" "),_c('i',{staticClass:"fas fa-caret-down"})]):_vm._e(),_vm._v(" "),(!_vm.staging.loading && _vm.staging.list.length === 1 && !_vm.staging.error)?_c('div',{staticClass:"staging-area"},[_vm._v("\n      Staged Drivers in "),_c('strong',[_vm._v(_vm._s(_vm.staging.list[0].name))])]):_vm._e()]),_vm._v(" "),(_vm.driversDisplayed !== null)?_c('div',{staticClass:"driver-list"},_vm._l((_vm.driversDisplayed),function(value,key){return _c('div',{key:key,staticClass:"service-drivers"},[(value.length > 0)?_c('div',{staticClass:"service-title"},[(key === 'shared')?_c('span',[_vm._v("Shared Ride")]):(key === 'opoli')?_c('span',[_vm._v("Direct Non-Stop")]):(key === 'black')?_c('span',[_vm._v("Sedan")]):(key === 'suv')?_c('span',[_vm._v("SUV")]):(key === 'shuttle')?_c('span',[_vm._v("Private Van")]):_c('span',[_vm._v(_vm._s(_vm.getServiceName(value[0].serviceTypeId)))])]):_vm._e(),_vm._v(" "),(value.length > 0)?_c('table',[_vm._m(0,true),_vm._v(" "),_c('tbody',_vm._l((value),function(queue,index){return _c('tr',{key:index,staticClass:"driver"},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDriver),expression:"selectedDriver"}],attrs:{"type":"radio"},domProps:{"value":queue.provider.ID,"checked":_vm._q(_vm.selectedDriver,queue.provider.ID)},on:{"change":function($event){_vm.selectedDriver=queue.provider.ID}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(queue.priority))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"driver-name"},[_c('div',{staticClass:"name"},[_c('a',{attrs:{"href":'#/provider/' + queue.provider.ID,"target":"_blank"}},[_vm._v("\n                    "+_vm._s(queue.provider.firstName)+" "+_vm._s(queue.provider.lastName)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"prov-options",on:{"mouseover":_vm.clearOptionDelay,"mouseout":_vm.hideOptions}},[_c('i',{staticClass:"fas fa-ellipsis-v fa-lg",on:{"click":function($event){return _vm.showForm(queue.provider.ID, key)}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOptions && _vm.driverId === queue.provider.ID && key === _vm.selectedService),expression:"showOptions && driverId === queue.provider.ID && key === selectedService"}],staticClass:"options"},[_c('div',{staticClass:"button cta success block call",on:{"click":function($event){return _vm.callDriver(queue.provider)}}},[_c('i',{staticClass:"fa fa-phone"}),_vm._v(_vm._s(_vm.$t('provider.call'))+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"button cta block send-sms",on:{"click":function($event){return _vm.sendSMS()}}},[_c('i',{staticClass:"fas fa-comment-dots"}),_vm._v(_vm._s(_vm.$t('provider.sms'))+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"button cta warning block send-notif",on:{"click":_vm.showNotif}},[_c('i',{staticClass:"fas fa-bell"}),_vm._v(_vm._s(_vm.$t('provider.notify'))+"\n                      ")])])])],1)])]),_vm._v(" "),_c('td',[_c('span',{class:'license-type ' + queue.provider.providerAccountType},[_vm._v("\n                "+_vm._s(queue.provider.providerAccountType.toUpperCase())+"\n              ")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.callDriver(queue.provider)}}},[_vm._v("\n                "+_vm._s(queue.provider.countryCode)+_vm._s(queue.provider.phone))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(queue.seatCapacity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(queue.status))])])}),0)]):_vm._e()])}),0):_vm._e(),_vm._v(" "),_c('notification-modal',{ref:"notif",attrs:{"isList":false,"provId":_vm.driverId,"removeAllActiveUserOption":true,"hideTargetOption":true}}),_vm._v(" "),_c('sms-modal',{ref:"sms",attrs:{"isList":false,"provId":_vm.driverId,"removeAllActiveUserOption":true,"hideTargetOption":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"table-header"},[_c('th'),_vm._v(" "),_c('th',[_vm._v("PRIORITY")]),_vm._v(" "),_c('th',[_vm._v("NAME")]),_vm._v(" "),_c('th',[_vm._v("LICENSE")]),_vm._v(" "),_c('th',[_vm._v("PHONE")]),_vm._v(" "),_c('th',[_vm._v("PAX")]),_vm._v(" "),_c('th',[_vm._v("STATUS")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"driver-list"},[_c('div',{staticClass:"tabs"},[_c('a',{class:{ tab: true, active: _vm.activeTab === 0 },on:{"click":function($event){_vm.activeTab = 0}}},[_vm._v("ON-DUTY DRIVERS")]),_vm._v(" "),_c('a',{class:{ tab: true, active: _vm.activeTab === 1 },on:{"click":function($event){_vm.activeTab = 1}}},[_vm._v("STAGING DRIVERS")]),_vm._v(" "),_c('a',{class:{ tab: true, active: _vm.activeTab === 2 },on:{"click":function($event){_vm.activeTab = 2}}},[_vm._v("OFF-DUTY DRIVERS")]),_vm._v(" "),_c('a',{class:{ tab: true, active: _vm.activeTab === 3 },on:{"click":function($event){_vm.activeTab = 3}}},[_vm._v("AVAILABILITY")])]),_vm._v(" "),_c('driver-list-filters',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab !== 1 && _vm.activeTab !== 3),expression:"activeTab !== 1 && activeTab !== 3"}]}),_vm._v(" "),_c('div',{class:['tab-content-container', {'staging-drivers': _vm.activeTab === 1 || _vm.activeTab === 3, 'extend':_vm.currentDispatchTab === 3 }],attrs:{"id":"driver-list-container"}},[_c('div',{class:{ 'tab-content': true, active: _vm.activeTab === 0 }},[_c('driver-table',{ref:"onDuty",attrs:{"onDuty":true,"staging":false}})],1),_vm._v(" "),_c('div',{class:{ 'tab-content': true, active: _vm.activeTab === 1 }},[_c('staging-drivers')],1),_vm._v(" "),_c('div',{class:{ 'tab-content': true, active: _vm.activeTab === 2 }},[_c('driver-table',{ref:"offDuty",attrs:{"onDuty":false,"staging":false}})],1),_vm._v(" "),_c('div',{class:{ 'tab-content': true, active: _vm.activeTab === 3 }},[_c('driver-availability',{ref:"driverAvailability"})],1)]),_vm._v(" "),_c('driver-controls',{attrs:{"tabIndex":_vm.tabIndex}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1250);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("051587fe", content, true, {});

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.dispatch-map[data-v-27596cbe] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: none;\n}\n.map-here[data-v-27596cbe] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n.map-loader[data-v-27596cbe] {\n  position: absolute;\n  left: calc(50% - 125px);\n  top: 20px;\n  z-index: 2;\n  background-color: #F25E0D;\n  border-radius: 3px;\n  padding: 5px 10px;\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  opacity: 1;\n  width: 250px;\n  text-align: center;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n.map-loader.hide[data-v-27596cbe] {\n    opacity: 0;\n    top: -50px;\n}\n.driver-filters[data-v-27596cbe] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 350px;\n  height: auto;\n  z-index: 4;\n  background-color: #F4F8F9;\n  border-bottom-right-radius: 3px;\n  overflow: hidden;\n  -webkit-box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.35);\n          box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.35);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.driver-filters.hide[data-v-27596cbe] {\n    top: -150%;\n}\n.driver-filters .message[data-v-27596cbe] {\n    text-align: center;\n    font-size: 14px;\n    font-weight: 700;\n    padding: 14px 14px 14px 46px;\n    background-color: #0D79F2;\n    color: #fff;\n}\n.driver-filters .radius-input[data-v-27596cbe] {\n    padding: 10px 15px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center !important;\n        -ms-flex-align: center !important;\n            align-items: center !important;\n}\n.driver-filters .radius-input > *[data-v-27596cbe] {\n      vertical-align: middle;\n}\n.driver-filters .radius-input label[data-v-27596cbe] {\n      font-size: 13px;\n      color: #8DA0A9;\n      font-weight: 700;\n      width: 100%;\n}\n.driver-filters .radius-input input[data-v-27596cbe] {\n      display: inline-block;\n      width: 100px;\n      padding: 12px 10px 11px;\n      margin-top: 0;\n      margin-right: 8px;\n      border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.driver-filters .service-types[data-v-27596cbe] {\n    padding: 0px 15px;\n    margin-bottom: 10px;\n}\n.driver-filters .service-types .row[data-v-27596cbe] {\n      padding-left: 25px;\n}\n.driver-filters .service-types .title[data-v-27596cbe] {\n      font-size: 12px;\n      color: #8DA0A9;\n      font-weight: 700;\n}\n.driver-filters .service-types label > *[data-v-27596cbe] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.driver-filters .service-types label input[data-v-27596cbe] {\n      width: auto;\n      margin-top: 0;\n}\n.driver-filters .service-types label span[data-v-27596cbe] {\n      font-weight: 700;\n      color: #777;\n      margin-left: 5px;\n}\n.driver-filters .divider[data-v-27596cbe] {\n    width: 80%;\n    border-top: 1px solid rgba(0, 0, 0, 0.2);\n    margin: 15px auto;\n}\n.driver-filters .button-wrapper[data-v-27596cbe] {\n    padding: 0 15px 15px;\n}\n.driver-filters .filter-note[data-v-27596cbe] {\n    padding: 10px;\n    font-size: 14px;\n    color: #93881e;\n    background: #fff9c5;\n    border: 1px solid #ccbd2f;\n    border-radius: 4px;\n    margin: 10px 20px 0;\n    -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n}\n.cover[data-v-27596cbe] {\n  position: absolute;\n  top: -500px;\n  left: 0;\n  width: 100%;\n  background-color: rgba(13, 121, 242, 0.8);\n  z-index: 5;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.cover.show[data-v-27596cbe] {\n    top: 0;\n}\n.cover .cover-container[data-v-27596cbe] {\n    display: table;\n    width: 100%;\n    height: 100%;\n}\n.cover .cover-content[data-v-27596cbe] {\n    padding: 15px;\n    font-weight: 700;\n    color: #FFF;\n    display: table-cell;\n    vertical-align: middle;\n    text-align: center;\n}\n.cover .cover-content .content[data-v-27596cbe] {\n      margin-top: 10px;\n}\n.filter-toggle[data-v-27596cbe] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 5;\n  background-color: #F4F8F9;\n  color: #555;\n  padding: 9px 10px 8px;\n  border-bottom-right-radius: 3px;\n  -webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.filter-toggle i[data-v-27596cbe] {\n    line-height: inherit;\n}\n.filter-toggle.open[data-v-27596cbe] {\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0);\n    background-color: #0D79F2;\n    color: #fff;\n}\n.filter-toggle.hide[data-v-27596cbe] {\n    top: -50px;\n}\n.recenter[data-v-27596cbe] {\n  position: absolute;\n  bottom: 30px;\n  left: 30px;\n  height: 45px;\n  width: 45px;\n  text-align: center;\n  line-height: 46px;\n  color: #777;\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);\n  border-radius: 50%;\n  z-index: 2;\n}\n.recenter i[data-v-27596cbe] {\n    line-height: inherit;\n}\n.search-status[data-v-27596cbe] {\n  position: absolute;\n  top: 20px;\n  left: calc(50% - 175px);\n  width: 350px;\n  background-color: #26D97A;\n  color: #fff;\n  text-align: center;\n  font-size: 14px;\n  padding: 5px 10px;\n  font-weight: 700;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.5);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.search-status.hide[data-v-27596cbe] {\n    top: -50px;\n}\n@media only screen and (max-width: 430px) {\n.map-here[data-v-27596cbe] {\n    height: 50%;\n}\n.cover[data-v-27596cbe] {\n    top: auto;\n    bottom: -500px;\n}\n.cover.show[data-v-27596cbe] {\n      bottom: 0;\n}\n.driver-filters[data-v-27596cbe] {\n    width: 100%;\n    bottom: 0;\n    top: auto;\n}\n.driver-filters.hide[data-v-27596cbe] {\n      top: auto;\n}\n.driver-filters .service-types[data-v-27596cbe] {\n      height: calc(50vh - 200px);\n      overflow-x: scroll;\n}\n}\n.dispatch-modal[data-v-27596cbe] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.dispatch-modal.show[data-v-27596cbe] {\n    top: 0;\n    opacity: 1;\n}\n.dispatch-modal .option[data-v-27596cbe] {\n    display: block;\n    width: 300px;\n    margin: 0 auto;\n    text-align: left;\n}\n.dispatch-modal .option input[type=radio][data-v-27596cbe] {\n      width: auto;\n      display: inline-block;\n      margin-right: 5px;\n      margin-top: 0;\n}\n.dispatch-modal .option span.s[data-v-27596cbe] {\n      display: inline-block;\n      font-size: 14px;\n      color: #444;\n}\n.dispatch-modal-container[data-v-27596cbe] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.dispatch-modal-content[data-v-27596cbe] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.validation-modal .title[data-v-27596cbe] {\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n  background-color: #F25E0D;\n  padding: 8px 15px;\n}\n.validation-modal .message[data-v-27596cbe] {\n  font-size: 16px;\n  font-weight: 700;\n  color: #555;\n  padding: 15px 15px 10px;\n}\n.validation-modal .button[data-v-27596cbe] {\n  font-weight: 700;\n}\n.validation-modal .cancel[data-v-27596cbe] {\n  margin-top: 10px;\n  color: #999;\n  display: inline-block;\n}\n.action-modal[data-v-27596cbe] {\n  padding: 15px;\n}\n.action-modal .message[data-v-27596cbe] {\n    font-weight: 700;\n    color: #777;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.action-modal .message.success[data-v-27596cbe] {\n      color: #26D97A;\n}\n.action-modal .message.error[data-v-27596cbe] {\n      color: #F20D0D;\n}\n.circle-loader[data-v-27596cbe] {\n  margin: 0 0 10px 10px;\n  border: 5px solid rgba(0, 0, 0, 0.2);\n  border-left-color: #26D97A;\n  -webkit-animation-name: loader-spin-data-v-27596cbe;\n          animation-name: loader-spin-data-v-27596cbe;\n  -webkit-animation-duration: 1s;\n          animation-duration: 1s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n.circle-loader[data-v-27596cbe],\n.circle-loader[data-v-27596cbe]:after {\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n}\n.load-complete[data-v-27596cbe] {\n  -webkit-animation: none;\n  animation: none;\n  border-color: #26D97A;\n  -webkit-transition: border 500ms ease-out;\n  transition: border 500ms ease-out;\n}\n.load-error[data-v-27596cbe] {\n  -webkit-animation: none;\n  animation: none;\n  border-color: #F20D0D;\n  -webkit-transition: border 500ms ease-out;\n  transition: border 500ms ease-out;\n}\n.checkmark[data-v-27596cbe] {\n  opacity: 0;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n.checkmark.draw[data-v-27596cbe] {\n    opacity: 1;\n}\n.checkmark.draw[data-v-27596cbe]:after {\n    opacity: 1;\n    height: 25px;\n    width: 12.5px;\n    -webkit-transform-origin: left top;\n            transform-origin: left top;\n    border-right: 5px solid #26D97A;\n    border-top: 5px solid #26D97A;\n    content: '';\n    left: calc(12.5px - 5px);\n    top: calc(25px + 2px);\n    position: absolute;\n    -webkit-animation-duration: 1.2s;\n            animation-duration: 1.2s;\n    -webkit-animation-timing-function: ease;\n            animation-timing-function: ease;\n    -webkit-animation-name: checkmark-data-v-27596cbe;\n            animation-name: checkmark-data-v-27596cbe;\n    -webkit-transform: scaleX(-1) rotate(135deg);\n            transform: scaleX(-1) rotate(135deg);\n}\n.checkmark.error[data-v-27596cbe] {\n    position: absolute;\n    left: calc(12.5px - 2px);\n    top: 12.5px;\n    width: 25px;\n    height: 25px;\n    opacity: 0;\n}\n.checkmark.error.show[data-v-27596cbe] {\n      opacity: 1;\n}\n.checkmark.error[data-v-27596cbe]:before, .checkmark.error[data-v-27596cbe]:after {\n      position: absolute;\n      content: ' ';\n      height: 25px;\n      width: 5px;\n      background-color: #f00;\n}\n.checkmark.error[data-v-27596cbe]:before {\n      -webkit-transform: rotate(45deg);\n              transform: rotate(45deg);\n}\n.checkmark.error[data-v-27596cbe]:after {\n      -webkit-transform: rotate(-45deg);\n              transform: rotate(-45deg);\n}\n@-webkit-keyframes loader-spin-data-v-27596cbe {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes loader-spin-data-v-27596cbe {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@-webkit-keyframes checkmark-data-v-27596cbe {\n0% {\n    height: 0;\n    width: 0;\n    opacity: 1;\n}\n20% {\n    height: 0;\n    width: 12.5px;\n    opacity: 1;\n}\n40% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n100% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n}\n@keyframes checkmark-data-v-27596cbe {\n0% {\n    height: 0;\n    width: 0;\n    opacity: 1;\n}\n20% {\n    height: 0;\n    width: 12.5px;\n    opacity: 1;\n}\n40% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n100% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n}\n.input-integer > *[data-v-27596cbe] {\n  display: inline-block;\n  vertical-align: middle;\n  margin-top: 5px;\n}\ninput[type=\"number\"][data-v-27596cbe] {\n  font-size: 14px;\n  padding: 7px 10px;\n  display: inline-block;\n  width: 200px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-integer span[data-v-27596cbe] {\n  font-size: 12px;\n  background-color: #555;\n  color: #fff;\n  padding: 9px 10px 10px;\n  margin-left: -5px;\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n.lr-modal[data-v-27596cbe] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-27596cbe] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-27596cbe] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  min-width: 300px;\n  max-width: 500px;\n}\n.lr-alert-msg[data-v-27596cbe] {\n  margin-bottom: 20px;\n  color: #45505b;\n}\n.show-reasons-btn[data-v-27596cbe] {\n  margin-top: 12px;\n  font-size: 14px;\n  color: #838689;\n  text-decoration: underline;\n  cursor: pointer;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/Map2.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,cAAc;CACf;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;CACd;AACD;EACE,mBAAmB;EACnB,wBAAwB;EACxB,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,iDAAiD;UACzC,yCAAyC;CAClD;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,aAAa;EACb,WAAW;EACX,0BAA0B;EAC1B,gCAAgC;EAChC,iBAAiB;EACjB,qDAAqD;UAC7C,6CAA6C;EACrD,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,WAAW;CACd;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,0BAA0B;IAC1B,YAAY;CACf;AACD;IACI,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,qCAAqC;QACjC,kCAAkC;YAC9B,+BAA+B;CAC1C;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,YAAY;CACjB;AACD;MACM,sBAAsB;MACtB,aAAa;MACb,wBAAwB;MACxB,cAAc;MACd,kBAAkB;MAClB,qCAAqC;CAC1C;AACD;IACI,kBAAkB;IAClB,oBAAoB;CACvB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,gBAAgB;MAChB,eAAe;MACf,iBAAiB;CACtB;AACD;MACM,sBAAsB;MACtB,uBAAuB;CAC5B;AACD;MACM,YAAY;MACZ,cAAc;CACnB;AACD;MACM,iBAAiB;MACjB,YAAY;MACZ,iBAAiB;CACtB;AACD;IACI,WAAW;IACX,yCAAyC;IACzC,kBAAkB;CACrB;AACD;IACI,qBAAqB;CACxB;AACD;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,0BAA0B;IAC1B,mBAAmB;IACnB,oBAAoB;IACpB,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,0CAA0C;EAC1C,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;CACV;AACD;IACI,eAAe;IACf,YAAY;IACZ,aAAa;CAChB;AACD;IACI,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;CACtB;AACD;MACM,iBAAiB;CACtB;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,0BAA0B;EAC1B,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;EAChC,mDAAmD;UAC3C,2CAA2C;EACnD,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,qBAAqB;CACxB;AACD;IACI,+CAA+C;YACvC,uCAAuC;IAC/C,0BAA0B;IAC1B,YAAY;CACf;AACD;IACI,WAAW;CACd;AACD;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,+CAA+C;UACvC,uCAAuC;EAC/C,mBAAmB;EACnB,WAAW;CACZ;AACD;IACI,qBAAqB;CACxB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,wBAAwB;EACxB,aAAa;EACb,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kDAAkD;UAC1C,0CAA0C;EAClD,4CAA4C;EAC5C,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;EACxB,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,WAAW;CACd;AACD;AACA;IACI,YAAY;CACf;AACD;IACI,UAAU;IACV,eAAe;CAClB;AACD;MACM,UAAU;CACf;AACD;IACI,YAAY;IACZ,UAAU;IACV,UAAU;CACb;AACD;MACM,UAAU;CACf;AACD;MACM,2BAA2B;MAC3B,mBAAmB;CACxB;CACA;AACD;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;IACI,eAAe;IACf,aAAa;IACb,eAAe;IACf,iBAAiB;CACpB;AACD;MACM,YAAY;MACZ,sBAAsB;MACtB,kBAAkB;MAClB,cAAc;CACnB;AACD;MACM,sBAAsB;MACtB,gBAAgB;MAChB,YAAY;CACjB;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,iBAAiB;CAClB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;CACnB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;CACzB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;CACvB;AACD;EACE,cAAc;CACf;AACD;IACI,iBAAiB;IACjB,YAAY;IACZ,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;EACE,sBAAsB;EACtB,qCAAqC;EACrC,2BAA2B;EAC3B,oDAAoD;UAC5C,4CAA4C;EACpD,+BAA+B;UACvB,uBAAuB;EAC/B,4CAA4C;UACpC,oCAAoC;EAC5C,0CAA0C;UAClC,kCAAkC;EAC1C,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,gCAAgC;UACxB,wBAAwB;CACjC;AACD;;EAEE,mBAAmB;EACnB,YAAY;EACZ,aAAa;CACd;AACD;EACE,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,kCAAkC;CACnC;AACD;EACE,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,kCAAkC;CACnC;AACD;EACE,WAAW;EACX,gCAAgC;UACxB,wBAAwB;CACjC;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,mCAAmC;YAC3B,2BAA2B;IACnC,gCAAgC;IAChC,8BAA8B;IAC9B,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,iCAAiC;YACzB,yBAAyB;IACjC,wCAAwC;YAChC,gCAAgC;IACxC,kDAAkD;YAC1C,0CAA0C;IAClD,6CAA6C;YACrC,qCAAqC;CAChD;AACD;IACI,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,WAAW;CACd;AACD;MACM,WAAW;CAChB;AACD;MACM,mBAAmB;MACnB,aAAa;MACb,aAAa;MACb,WAAW;MACX,uBAAuB;CAC5B;AACD;MACM,iCAAiC;cACzB,yBAAyB;CACtC;AACD;MACM,kCAAkC;cAC1B,0BAA0B;CACvC;AACD;AACA;IACI,gCAAgC;YACxB,wBAAwB;CACnC;AACD;IACI,kCAAkC;YAC1B,0BAA0B;CACrC;CACA;AACD;AACA;IACI,gCAAgC;YACxB,wBAAwB;CACnC;AACD;IACI,kCAAkC;YAC1B,0BAA0B;CACrC;CACA;AACD;AACA;IACI,UAAU;IACV,SAAS;IACT,WAAW;CACd;AACD;IACI,UAAU;IACV,cAAc;IACd,WAAW;CACd;AACD;IACI,aAAa;IACb,cAAc;IACd,WAAW;CACd;AACD;IACI,aAAa;IACb,cAAc;IACd,WAAW;CACd;CACA;AACD;AACA;IACI,UAAU;IACV,SAAS;IACT,WAAW;CACd;AACD;IACI,UAAU;IACV,cAAc;IACd,WAAW;CACd;AACD;IACI,aAAa;IACb,cAAc;IACd,WAAW;CACd;AACD;IACI,aAAa;IACb,cAAc;IACd,WAAW;CACd;CACA;AACD;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;CACjB;AACD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,2BAA2B;EAC3B,8BAA8B;CAC/B;AACD;EACE,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;CACjC;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oCAAoC;MAChC,iCAAiC;UAC7B,mCAAmC;EAC3C,qCAAqC;MACjC,kCAAkC;UAC9B,+BAA+B;EACvC,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;EACnD,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;CAClB;AACD;EACE,oBAAoB;EACpB,eAAe;CAChB;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;CACjB","file":"Map2.vue","sourcesContent":["\n.dispatch-map[data-v-27596cbe] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: none;\n}\n.map-here[data-v-27596cbe] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n.map-loader[data-v-27596cbe] {\n  position: absolute;\n  left: calc(50% - 125px);\n  top: 20px;\n  z-index: 2;\n  background-color: #F25E0D;\n  border-radius: 3px;\n  padding: 5px 10px;\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  opacity: 1;\n  width: 250px;\n  text-align: center;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n.map-loader.hide[data-v-27596cbe] {\n    opacity: 0;\n    top: -50px;\n}\n.driver-filters[data-v-27596cbe] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 350px;\n  height: auto;\n  z-index: 4;\n  background-color: #F4F8F9;\n  border-bottom-right-radius: 3px;\n  overflow: hidden;\n  -webkit-box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.35);\n          box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.35);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.driver-filters.hide[data-v-27596cbe] {\n    top: -150%;\n}\n.driver-filters .message[data-v-27596cbe] {\n    text-align: center;\n    font-size: 14px;\n    font-weight: 700;\n    padding: 14px 14px 14px 46px;\n    background-color: #0D79F2;\n    color: #fff;\n}\n.driver-filters .radius-input[data-v-27596cbe] {\n    padding: 10px 15px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center !important;\n        -ms-flex-align: center !important;\n            align-items: center !important;\n}\n.driver-filters .radius-input > *[data-v-27596cbe] {\n      vertical-align: middle;\n}\n.driver-filters .radius-input label[data-v-27596cbe] {\n      font-size: 13px;\n      color: #8DA0A9;\n      font-weight: 700;\n      width: 100%;\n}\n.driver-filters .radius-input input[data-v-27596cbe] {\n      display: inline-block;\n      width: 100px;\n      padding: 12px 10px 11px;\n      margin-top: 0;\n      margin-right: 8px;\n      border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.driver-filters .service-types[data-v-27596cbe] {\n    padding: 0px 15px;\n    margin-bottom: 10px;\n}\n.driver-filters .service-types .row[data-v-27596cbe] {\n      padding-left: 25px;\n}\n.driver-filters .service-types .title[data-v-27596cbe] {\n      font-size: 12px;\n      color: #8DA0A9;\n      font-weight: 700;\n}\n.driver-filters .service-types label > *[data-v-27596cbe] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.driver-filters .service-types label input[data-v-27596cbe] {\n      width: auto;\n      margin-top: 0;\n}\n.driver-filters .service-types label span[data-v-27596cbe] {\n      font-weight: 700;\n      color: #777;\n      margin-left: 5px;\n}\n.driver-filters .divider[data-v-27596cbe] {\n    width: 80%;\n    border-top: 1px solid rgba(0, 0, 0, 0.2);\n    margin: 15px auto;\n}\n.driver-filters .button-wrapper[data-v-27596cbe] {\n    padding: 0 15px 15px;\n}\n.driver-filters .filter-note[data-v-27596cbe] {\n    padding: 10px;\n    font-size: 14px;\n    color: #93881e;\n    background: #fff9c5;\n    border: 1px solid #ccbd2f;\n    border-radius: 4px;\n    margin: 10px 20px 0;\n    -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n}\n.cover[data-v-27596cbe] {\n  position: absolute;\n  top: -500px;\n  left: 0;\n  width: 100%;\n  background-color: rgba(13, 121, 242, 0.8);\n  z-index: 5;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.cover.show[data-v-27596cbe] {\n    top: 0;\n}\n.cover .cover-container[data-v-27596cbe] {\n    display: table;\n    width: 100%;\n    height: 100%;\n}\n.cover .cover-content[data-v-27596cbe] {\n    padding: 15px;\n    font-weight: 700;\n    color: #FFF;\n    display: table-cell;\n    vertical-align: middle;\n    text-align: center;\n}\n.cover .cover-content .content[data-v-27596cbe] {\n      margin-top: 10px;\n}\n.filter-toggle[data-v-27596cbe] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 5;\n  background-color: #F4F8F9;\n  color: #555;\n  padding: 9px 10px 8px;\n  border-bottom-right-radius: 3px;\n  -webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.filter-toggle i[data-v-27596cbe] {\n    line-height: inherit;\n}\n.filter-toggle.open[data-v-27596cbe] {\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0);\n    background-color: #0D79F2;\n    color: #fff;\n}\n.filter-toggle.hide[data-v-27596cbe] {\n    top: -50px;\n}\n.recenter[data-v-27596cbe] {\n  position: absolute;\n  bottom: 30px;\n  left: 30px;\n  height: 45px;\n  width: 45px;\n  text-align: center;\n  line-height: 46px;\n  color: #777;\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);\n  border-radius: 50%;\n  z-index: 2;\n}\n.recenter i[data-v-27596cbe] {\n    line-height: inherit;\n}\n.search-status[data-v-27596cbe] {\n  position: absolute;\n  top: 20px;\n  left: calc(50% - 175px);\n  width: 350px;\n  background-color: #26D97A;\n  color: #fff;\n  text-align: center;\n  font-size: 14px;\n  padding: 5px 10px;\n  font-weight: 700;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.5);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.search-status.hide[data-v-27596cbe] {\n    top: -50px;\n}\n@media only screen and (max-width: 430px) {\n.map-here[data-v-27596cbe] {\n    height: 50%;\n}\n.cover[data-v-27596cbe] {\n    top: auto;\n    bottom: -500px;\n}\n.cover.show[data-v-27596cbe] {\n      bottom: 0;\n}\n.driver-filters[data-v-27596cbe] {\n    width: 100%;\n    bottom: 0;\n    top: auto;\n}\n.driver-filters.hide[data-v-27596cbe] {\n      top: auto;\n}\n.driver-filters .service-types[data-v-27596cbe] {\n      height: calc(50vh - 200px);\n      overflow-x: scroll;\n}\n}\n.dispatch-modal[data-v-27596cbe] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.dispatch-modal.show[data-v-27596cbe] {\n    top: 0;\n    opacity: 1;\n}\n.dispatch-modal .option[data-v-27596cbe] {\n    display: block;\n    width: 300px;\n    margin: 0 auto;\n    text-align: left;\n}\n.dispatch-modal .option input[type=radio][data-v-27596cbe] {\n      width: auto;\n      display: inline-block;\n      margin-right: 5px;\n      margin-top: 0;\n}\n.dispatch-modal .option span.s[data-v-27596cbe] {\n      display: inline-block;\n      font-size: 14px;\n      color: #444;\n}\n.dispatch-modal-container[data-v-27596cbe] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.dispatch-modal-content[data-v-27596cbe] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.validation-modal .title[data-v-27596cbe] {\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n  background-color: #F25E0D;\n  padding: 8px 15px;\n}\n.validation-modal .message[data-v-27596cbe] {\n  font-size: 16px;\n  font-weight: 700;\n  color: #555;\n  padding: 15px 15px 10px;\n}\n.validation-modal .button[data-v-27596cbe] {\n  font-weight: 700;\n}\n.validation-modal .cancel[data-v-27596cbe] {\n  margin-top: 10px;\n  color: #999;\n  display: inline-block;\n}\n.action-modal[data-v-27596cbe] {\n  padding: 15px;\n}\n.action-modal .message[data-v-27596cbe] {\n    font-weight: 700;\n    color: #777;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.action-modal .message.success[data-v-27596cbe] {\n      color: #26D97A;\n}\n.action-modal .message.error[data-v-27596cbe] {\n      color: #F20D0D;\n}\n.circle-loader[data-v-27596cbe] {\n  margin: 0 0 10px 10px;\n  border: 5px solid rgba(0, 0, 0, 0.2);\n  border-left-color: #26D97A;\n  -webkit-animation-name: loader-spin-data-v-27596cbe;\n          animation-name: loader-spin-data-v-27596cbe;\n  -webkit-animation-duration: 1s;\n          animation-duration: 1s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n.circle-loader[data-v-27596cbe],\n.circle-loader[data-v-27596cbe]:after {\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n}\n.load-complete[data-v-27596cbe] {\n  -webkit-animation: none;\n  animation: none;\n  border-color: #26D97A;\n  -webkit-transition: border 500ms ease-out;\n  transition: border 500ms ease-out;\n}\n.load-error[data-v-27596cbe] {\n  -webkit-animation: none;\n  animation: none;\n  border-color: #F20D0D;\n  -webkit-transition: border 500ms ease-out;\n  transition: border 500ms ease-out;\n}\n.checkmark[data-v-27596cbe] {\n  opacity: 0;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n.checkmark.draw[data-v-27596cbe] {\n    opacity: 1;\n}\n.checkmark.draw[data-v-27596cbe]:after {\n    opacity: 1;\n    height: 25px;\n    width: 12.5px;\n    -webkit-transform-origin: left top;\n            transform-origin: left top;\n    border-right: 5px solid #26D97A;\n    border-top: 5px solid #26D97A;\n    content: '';\n    left: calc(12.5px - 5px);\n    top: calc(25px + 2px);\n    position: absolute;\n    -webkit-animation-duration: 1.2s;\n            animation-duration: 1.2s;\n    -webkit-animation-timing-function: ease;\n            animation-timing-function: ease;\n    -webkit-animation-name: checkmark-data-v-27596cbe;\n            animation-name: checkmark-data-v-27596cbe;\n    -webkit-transform: scaleX(-1) rotate(135deg);\n            transform: scaleX(-1) rotate(135deg);\n}\n.checkmark.error[data-v-27596cbe] {\n    position: absolute;\n    left: calc(12.5px - 2px);\n    top: 12.5px;\n    width: 25px;\n    height: 25px;\n    opacity: 0;\n}\n.checkmark.error.show[data-v-27596cbe] {\n      opacity: 1;\n}\n.checkmark.error[data-v-27596cbe]:before, .checkmark.error[data-v-27596cbe]:after {\n      position: absolute;\n      content: ' ';\n      height: 25px;\n      width: 5px;\n      background-color: #f00;\n}\n.checkmark.error[data-v-27596cbe]:before {\n      -webkit-transform: rotate(45deg);\n              transform: rotate(45deg);\n}\n.checkmark.error[data-v-27596cbe]:after {\n      -webkit-transform: rotate(-45deg);\n              transform: rotate(-45deg);\n}\n@-webkit-keyframes loader-spin-data-v-27596cbe {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes loader-spin-data-v-27596cbe {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@-webkit-keyframes checkmark-data-v-27596cbe {\n0% {\n    height: 0;\n    width: 0;\n    opacity: 1;\n}\n20% {\n    height: 0;\n    width: 12.5px;\n    opacity: 1;\n}\n40% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n100% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n}\n@keyframes checkmark-data-v-27596cbe {\n0% {\n    height: 0;\n    width: 0;\n    opacity: 1;\n}\n20% {\n    height: 0;\n    width: 12.5px;\n    opacity: 1;\n}\n40% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n100% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n}\n.input-integer > *[data-v-27596cbe] {\n  display: inline-block;\n  vertical-align: middle;\n  margin-top: 5px;\n}\ninput[type=\"number\"][data-v-27596cbe] {\n  font-size: 14px;\n  padding: 7px 10px;\n  display: inline-block;\n  width: 200px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-integer span[data-v-27596cbe] {\n  font-size: 12px;\n  background-color: #555;\n  color: #fff;\n  padding: 9px 10px 10px;\n  margin-left: -5px;\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n.lr-modal[data-v-27596cbe] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-27596cbe] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-27596cbe] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  min-width: 300px;\n  max-width: 500px;\n}\n.lr-alert-msg[data-v-27596cbe] {\n  margin-bottom: 20px;\n  color: #45505b;\n}\n.show-reasons-btn[data-v-27596cbe] {\n  margin-top: 12px;\n  font-size: 14px;\n  color: #838689;\n  text-decoration: underline;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(70);
__webpack_require__(56);
module.exports = __webpack_require__(1252);


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(39);
var get = __webpack_require__(124);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  'featureType': 'landscape.man_made',
  'elementType': 'all',
  'stylers': [{
    'color': '#faf5ed'
  }, {
    'lightness': '0'
  }, {
    'gamma': '1'
  }]
}, {
  'featureType': 'poi.park',
  'elementType': 'geometry.fill',
  'stylers': [{
    'color': '#bae5a6'
  }]
}, {
  'featureType': 'road',
  'elementType': 'all',
  'stylers': [{
    'weight': '1.00'
  }, {
    'gamma': '1.8'
  }, {
    'saturation': '0'
  }]
}, {
  'featureType': 'road',
  'elementType': 'geometry.fill',
  'stylers': [{
    'hue': '#ffb200'
  }]
}, {
  'featureType': 'road.arterial',
  'elementType': 'geometry.fill',
  'stylers': [{
    'lightness': '0'
  }, {
    'gamma': '1'
  }]
}, {
  'featureType': 'transit.station.airport',
  'elementType': 'all',
  'stylers': [{
    'hue': '#b000ff'
  }, {
    'saturation': '23'
  }, {
    'lightness': '-4'
  }, {
    'gamma': '0.80'
  }]
}, {
  'featureType': 'water',
  'elementType': 'all',
  'stylers': [{
    'color': '#a0daf2'
  }]
}]);

/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dispatch-map-container"},[_c('div',{staticClass:"map-here",attrs:{"id":"mapHere"}}),_vm._v(" "),_c('a',{staticClass:"recenter",attrs:{"href":"javascript:;"},on:{"click":_vm.setCenter}},[_c('i',{staticClass:"far fa-dot-circle fa-lg fa-fw"})]),_vm._v(" "),_c('a',{class:['filter-toggle', {open: _vm.driverFilter.show,hide: _vm.rsvp === null || _vm.rsvp.driver !== null}],attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.driverFilter.show = !_vm.driverFilter.show}}},[_c('i',{class:{
      'far fa-times-circle': _vm.driverFilter.show,
      'fas fa-sliders-h': !_vm.driverFilter.show,
      'fa-fw fa-lg': true
    }})]),_vm._v(" "),_c('div',{class:['driver-filters', {hide:!_vm.driverFilter.show || _vm.rsvp === null}]},[_c('div',{class:['cover', {show: _vm.driverFilter.isLoading || _vm.driverFilter.serviceLoading }]},[_c('div',{staticClass:"cover-container"},[_c('div',{staticClass:"cover-content"},[_c('pulse-loader'),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.$t('dispatch.map.filterControls.labelLoading')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"message"},[(_vm.qualifiedDrivers.active)?_c('span',[_vm._v("Use the form below to modify restrictions")]):_c('span',[_vm._v(_vm._s(_vm.$t('dispatch.map.filterControls.title')))])]),_vm._v(" "),_c('form',{staticClass:"extend-input",on:{"submit":function($event){$event.preventDefault();return _vm.driverFilterSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"radius-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.driverFilter.miles),expression:"driverFilter.miles"}],attrs:{"type":"number"},domProps:{"value":(_vm.driverFilter.miles)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.driverFilter, "miles", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('dispatch.map.filterControls.labelRadius')))])]),_vm._v(" "),(!_vm.rsvpInMap.isPackage && !_vm.qualifiedDrivers.active)?_c('div',{staticClass:"service-types"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('dispatch.map.filterControls.labelServices')))]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.driverFilter.services),function(service){return _c('div',{key:service.id,staticClass:"small-12 columns"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.driverFilter.serviceTypes),expression:"driverFilter.serviceTypes"}],attrs:{"type":"checkbox"},domProps:{"value":service.id,"checked":Array.isArray(_vm.driverFilter.serviceTypes)?_vm._i(_vm.driverFilter.serviceTypes,service.id)>-1:(_vm.driverFilter.serviceTypes)},on:{"change":function($event){var $$a=_vm.driverFilter.serviceTypes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=service.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.driverFilter, "serviceTypes", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.driverFilter, "serviceTypes", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.driverFilter, "serviceTypes", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(service.name))])])])}),0)]):_vm._e(),_vm._v(" "),(_vm.qualifiedDrivers.active)?_c('div',{staticClass:"service-types"},[_c('div',{staticClass:"title"},[_vm._v("Qualification Criteria:")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qualifiedFilter.seatCapacity),expression:"qualifiedFilter.seatCapacity"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.qualifiedFilter.seatCapacity)?_vm._i(_vm.qualifiedFilter.seatCapacity,null)>-1:(_vm.qualifiedFilter.seatCapacity)},on:{"change":function($event){var $$a=_vm.qualifiedFilter.seatCapacity,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.qualifiedFilter, "seatCapacity", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.qualifiedFilter, "seatCapacity", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.qualifiedFilter, "seatCapacity", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Seat Capacity Restriction")])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qualifiedFilter.serviceTypes),expression:"qualifiedFilter.serviceTypes"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.qualifiedFilter.serviceTypes)?_vm._i(_vm.qualifiedFilter.serviceTypes,null)>-1:(_vm.qualifiedFilter.serviceTypes)},on:{"change":function($event){var $$a=_vm.qualifiedFilter.serviceTypes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.qualifiedFilter, "serviceTypes", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.qualifiedFilter, "serviceTypes", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.qualifiedFilter, "serviceTypes", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Service Types Restriction")])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qualifiedFilter.adaWC),expression:"qualifiedFilter.adaWC"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.qualifiedFilter.adaWC)?_vm._i(_vm.qualifiedFilter.adaWC,null)>-1:(_vm.qualifiedFilter.adaWC)},on:{"change":function($event){var $$a=_vm.qualifiedFilter.adaWC,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.qualifiedFilter, "adaWC", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.qualifiedFilter, "adaWC", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.qualifiedFilter, "adaWC", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("ADA: Wheelchair Restriction")])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qualifiedFilter.adaSD),expression:"qualifiedFilter.adaSD"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.qualifiedFilter.adaSD)?_vm._i(_vm.qualifiedFilter.adaSD,null)>-1:(_vm.qualifiedFilter.adaSD)},on:{"change":function($event){var $$a=_vm.qualifiedFilter.adaSD,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.qualifiedFilter, "adaSD", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.qualifiedFilter, "adaSD", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.qualifiedFilter, "adaSD", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("ADA: Service Dog Restriction")])])]),_vm._v(" "),(false)?_c('div',{staticClass:"small-12 columns"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qualifiedFilter.fullTNC),expression:"qualifiedFilter.fullTNC"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.qualifiedFilter.fullTNC)?_vm._i(_vm.qualifiedFilter.fullTNC,null)>-1:(_vm.qualifiedFilter.fullTNC)},on:{"change":function($event){var $$a=_vm.qualifiedFilter.fullTNC,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.qualifiedFilter, "fullTNC", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.qualifiedFilter, "fullTNC", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.qualifiedFilter, "fullTNC", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("License Type Restriction")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qualifiedFilter.availability),expression:"qualifiedFilter.availability"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.qualifiedFilter.availability)?_vm._i(_vm.qualifiedFilter.availability,null)>-1:(_vm.qualifiedFilter.availability)},on:{"change":function($event){var $$a=_vm.qualifiedFilter.availability,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.qualifiedFilter, "availability", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.qualifiedFilter, "availability", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.qualifiedFilter, "availability", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Availability Restriction")])])])]),_vm._v(" "),(!_vm.qualifiedFilter.seatCapacity || !_vm.qualifiedFilter.serviceTypes || !_vm.qualifiedFilter.adaWC || !_vm.qualifiedFilter.adaSD || !_vm.qualifiedFilter.fullTNC || !_vm.qualifiedFilter.availability)?_c('div',{staticClass:"filter-note"},[_vm._v("\n          Changing the qualification criteria will also disable the checks for driver's upcoming trip conflicts, tight route, and work hours.\n        ")]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.rsvpInMap.isPackage)?_c('div',{staticClass:"divider"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"button-wrapper"},[_c('button',{staticClass:"cta block success"},[_vm._v("\n          "+_vm._s(_vm.$t('dispatch.map.filterControls.labelButton'))+"\n        ")])])])]),_vm._v(" "),_c('div',{class:['search-status', {hide: (_vm.nearbyDrivers.length <= 0 || _vm.mapLoader.show)}]},[_vm._v("\n    We found driver(s) for this reservation.\n    ")]),_vm._v(" "),_c('div',{class:['map-loader', {hide: !_vm.mapLoader.show}]},[_vm._v(_vm._s(_vm.mapLoader.label))]),_vm._v(" "),_c('div',{class:['dispatch-modal', {show: _vm.modal.show}],on:{"click":_vm.close}},[_c('div',{staticClass:"dispatch-modal-container"},[_c('div',{staticClass:"dispatch-modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"validation-modal"},[_c('div',{staticClass:"title"},[_vm._v("Send to driver")]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("Accept Request Timeout")]),_vm._v(" "),_c('label',{staticClass:"option",on:{"click":function($event){_vm.modal.option = 'default'}}},[(_vm.modal.show)?_c('input',{attrs:{"type":"radio","name":"crt","checked":"checked"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"s"},[_vm._v("Default ("+_vm._s(_vm.$settings.get('ASAPRequestTimeout'))+" sec)")])]),_vm._v(" "),_c('label',{staticClass:"option",on:{"click":function($event){_vm.modal.option = 'custom'}}},[(_vm.modal.show)?_c('input',{attrs:{"type":"radio","name":"crt"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-integer",staticStyle:{"display":"inline-block"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modal.custom),expression:"modal.custom"}],attrs:{"type":"number"},domProps:{"value":(_vm.modal.custom)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modal, "custom", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v("secs")])])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"10px 50px","margin":"30px 0 10px"}},[_c('a',{staticClass:"button success block",attrs:{"href":"javascript:;"},on:{"click":_vm.sendToDriver}},[_vm._v("Yes")]),_vm._v(" "),_c('a',{staticClass:"cancel",attrs:{"href":"javascript:;"},on:{"click":_vm.close}},[_vm._v("No, I change my mind")])])])])])]),_vm._v(" "),_c('div',{class:['lr-modal', {'hide': !_vm.queueError.show}]},[_c('div',{staticClass:"lr-box"},[_c('div',{staticClass:"lr-alert-msg",domProps:{"innerHTML":_vm._s(_vm.queueError.message)}}),_vm._v(" "),_c('a',{staticClass:"button cta small right block",on:{"click":_vm.showReasons}},[_vm._v("View Driver Qualification Checks")]),_vm._v(" "),_c('div',{staticClass:"show-reasons-btn",on:{"click":function($event){_vm.queueError.show = false}}},[_vm._v("Dismiss")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1256);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("278c03d8", content, true, {});

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.dispatch-modal[data-v-05258735] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.dispatch-modal.show[data-v-05258735] {\n    top: 0;\n    opacity: 1;\n}\n.dispatch-modal-container[data-v-05258735] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.dispatch-modal-content[data-v-05258735] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n}\n.validation-modal .title[data-v-05258735] {\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n  background-color: #F25E0D;\n  padding: 8px 15px;\n}\n.validation-modal .message[data-v-05258735] {\n  font-size: 16px;\n  font-weight: 700;\n  color: #555;\n  padding: 15px 15px 10px;\n}\n.validation-modal .button[data-v-05258735] {\n  margin: 10px 15px 15px;\n  font-weight: 700;\n}\n.action-modal[data-v-05258735] {\n  padding: 15px;\n}\n.action-modal .message[data-v-05258735] {\n    font-weight: 700;\n    color: #777;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n    word-wrap: break-word;\n}\n.action-modal .message.success[data-v-05258735] {\n      color: #26D97A;\n}\n.action-modal .message.error[data-v-05258735] {\n      color: #F20D0D;\n}\n.circle-loader[data-v-05258735] {\n  margin: 0 0 10px 10px;\n  border: 5px solid rgba(0, 0, 0, 0.2);\n  border-left-color: #26D97A;\n  -webkit-animation-name: loader-spin-data-v-05258735;\n          animation-name: loader-spin-data-v-05258735;\n  -webkit-animation-duration: 1s;\n          animation-duration: 1s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n.circle-loader[data-v-05258735],\n.circle-loader[data-v-05258735]:after {\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n}\n.load-complete[data-v-05258735] {\n  -webkit-animation: none;\n  animation: none;\n  border-color: #26D97A;\n  -webkit-transition: border 500ms ease-out;\n  transition: border 500ms ease-out;\n}\n.load-error[data-v-05258735] {\n  -webkit-animation: none;\n  animation: none;\n  border-color: #F20D0D;\n  -webkit-transition: border 500ms ease-out;\n  transition: border 500ms ease-out;\n}\n.checkmark[data-v-05258735] {\n  opacity: 0;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n.checkmark.draw[data-v-05258735] {\n    opacity: 1;\n}\n.checkmark.draw[data-v-05258735]:after {\n    opacity: 1;\n    height: 25px;\n    width: 12.5px;\n    -webkit-transform-origin: left top;\n            transform-origin: left top;\n    border-right: 5px solid #26D97A;\n    border-top: 5px solid #26D97A;\n    content: '';\n    left: calc(12.5px - 5px);\n    top: calc(25px + 2px);\n    position: absolute;\n    -webkit-animation-duration: 1.2s;\n            animation-duration: 1.2s;\n    -webkit-animation-timing-function: ease;\n            animation-timing-function: ease;\n    -webkit-animation-name: checkmark-data-v-05258735;\n            animation-name: checkmark-data-v-05258735;\n    -webkit-transform: scaleX(-1) rotate(135deg);\n            transform: scaleX(-1) rotate(135deg);\n}\n.checkmark.error[data-v-05258735] {\n    position: absolute;\n    left: calc(12.5px - 2px);\n    top: 12.5px;\n    width: 25px;\n    height: 25px;\n    opacity: 0;\n}\n.checkmark.error.show[data-v-05258735] {\n      opacity: 1;\n}\n.checkmark.error[data-v-05258735]:before, .checkmark.error[data-v-05258735]:after {\n      position: absolute;\n      content: ' ';\n      height: 25px;\n      width: 5px;\n      background-color: #f00;\n}\n.checkmark.error[data-v-05258735]:before {\n      -webkit-transform: rotate(45deg);\n              transform: rotate(45deg);\n}\n.checkmark.error[data-v-05258735]:after {\n      -webkit-transform: rotate(-45deg);\n              transform: rotate(-45deg);\n}\n@-webkit-keyframes loader-spin-data-v-05258735 {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes loader-spin-data-v-05258735 {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@-webkit-keyframes checkmark-data-v-05258735 {\n0% {\n    height: 0;\n    width: 0;\n    opacity: 1;\n}\n20% {\n    height: 0;\n    width: 12.5px;\n    opacity: 1;\n}\n40% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n100% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n}\n@keyframes checkmark-data-v-05258735 {\n0% {\n    height: 0;\n    width: 0;\n    opacity: 1;\n}\n20% {\n    height: 0;\n    width: 12.5px;\n    opacity: 1;\n}\n40% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n100% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/DispatchModal.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;CACpB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;CACnB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;CACzB;AACD;EACE,uBAAuB;EACvB,iBAAiB;CAClB;AACD;EACE,cAAc;CACf;AACD;IACI,iBAAiB;IACjB,YAAY;IACZ,8BAA8B;IAC9B,sBAAsB;IACtB,sBAAsB;CACzB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;EACE,sBAAsB;EACtB,qCAAqC;EACrC,2BAA2B;EAC3B,oDAAoD;UAC5C,4CAA4C;EACpD,+BAA+B;UACvB,uBAAuB;EAC/B,4CAA4C;UACpC,oCAAoC;EAC5C,0CAA0C;UAClC,kCAAkC;EAC1C,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,gCAAgC;UACxB,wBAAwB;CACjC;AACD;;EAEE,mBAAmB;EACnB,YAAY;EACZ,aAAa;CACd;AACD;EACE,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,kCAAkC;CACnC;AACD;EACE,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,kCAAkC;CACnC;AACD;EACE,WAAW;EACX,gCAAgC;UACxB,wBAAwB;CACjC;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,mCAAmC;YAC3B,2BAA2B;IACnC,gCAAgC;IAChC,8BAA8B;IAC9B,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,iCAAiC;YACzB,yBAAyB;IACjC,wCAAwC;YAChC,gCAAgC;IACxC,kDAAkD;YAC1C,0CAA0C;IAClD,6CAA6C;YACrC,qCAAqC;CAChD;AACD;IACI,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,WAAW;CACd;AACD;MACM,WAAW;CAChB;AACD;MACM,mBAAmB;MACnB,aAAa;MACb,aAAa;MACb,WAAW;MACX,uBAAuB;CAC5B;AACD;MACM,iCAAiC;cACzB,yBAAyB;CACtC;AACD;MACM,kCAAkC;cAC1B,0BAA0B;CACvC;AACD;AACA;IACI,gCAAgC;YACxB,wBAAwB;CACnC;AACD;IACI,kCAAkC;YAC1B,0BAA0B;CACrC;CACA;AACD;AACA;IACI,gCAAgC;YACxB,wBAAwB;CACnC;AACD;IACI,kCAAkC;YAC1B,0BAA0B;CACrC;CACA;AACD;AACA;IACI,UAAU;IACV,SAAS;IACT,WAAW;CACd;AACD;IACI,UAAU;IACV,cAAc;IACd,WAAW;CACd;AACD;IACI,aAAa;IACb,cAAc;IACd,WAAW;CACd;AACD;IACI,aAAa;IACb,cAAc;IACd,WAAW;CACd;CACA;AACD;AACA;IACI,UAAU;IACV,SAAS;IACT,WAAW;CACd;AACD;IACI,UAAU;IACV,cAAc;IACd,WAAW;CACd;AACD;IACI,aAAa;IACb,cAAc;IACd,WAAW;CACd;AACD;IACI,aAAa;IACb,cAAc;IACd,WAAW;CACd;CACA","file":"DispatchModal.vue","sourcesContent":["\n.dispatch-modal[data-v-05258735] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.dispatch-modal.show[data-v-05258735] {\n    top: 0;\n    opacity: 1;\n}\n.dispatch-modal-container[data-v-05258735] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.dispatch-modal-content[data-v-05258735] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n}\n.validation-modal .title[data-v-05258735] {\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n  background-color: #F25E0D;\n  padding: 8px 15px;\n}\n.validation-modal .message[data-v-05258735] {\n  font-size: 16px;\n  font-weight: 700;\n  color: #555;\n  padding: 15px 15px 10px;\n}\n.validation-modal .button[data-v-05258735] {\n  margin: 10px 15px 15px;\n  font-weight: 700;\n}\n.action-modal[data-v-05258735] {\n  padding: 15px;\n}\n.action-modal .message[data-v-05258735] {\n    font-weight: 700;\n    color: #777;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n    word-wrap: break-word;\n}\n.action-modal .message.success[data-v-05258735] {\n      color: #26D97A;\n}\n.action-modal .message.error[data-v-05258735] {\n      color: #F20D0D;\n}\n.circle-loader[data-v-05258735] {\n  margin: 0 0 10px 10px;\n  border: 5px solid rgba(0, 0, 0, 0.2);\n  border-left-color: #26D97A;\n  -webkit-animation-name: loader-spin-data-v-05258735;\n          animation-name: loader-spin-data-v-05258735;\n  -webkit-animation-duration: 1s;\n          animation-duration: 1s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n.circle-loader[data-v-05258735],\n.circle-loader[data-v-05258735]:after {\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n}\n.load-complete[data-v-05258735] {\n  -webkit-animation: none;\n  animation: none;\n  border-color: #26D97A;\n  -webkit-transition: border 500ms ease-out;\n  transition: border 500ms ease-out;\n}\n.load-error[data-v-05258735] {\n  -webkit-animation: none;\n  animation: none;\n  border-color: #F20D0D;\n  -webkit-transition: border 500ms ease-out;\n  transition: border 500ms ease-out;\n}\n.checkmark[data-v-05258735] {\n  opacity: 0;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n.checkmark.draw[data-v-05258735] {\n    opacity: 1;\n}\n.checkmark.draw[data-v-05258735]:after {\n    opacity: 1;\n    height: 25px;\n    width: 12.5px;\n    -webkit-transform-origin: left top;\n            transform-origin: left top;\n    border-right: 5px solid #26D97A;\n    border-top: 5px solid #26D97A;\n    content: '';\n    left: calc(12.5px - 5px);\n    top: calc(25px + 2px);\n    position: absolute;\n    -webkit-animation-duration: 1.2s;\n            animation-duration: 1.2s;\n    -webkit-animation-timing-function: ease;\n            animation-timing-function: ease;\n    -webkit-animation-name: checkmark-data-v-05258735;\n            animation-name: checkmark-data-v-05258735;\n    -webkit-transform: scaleX(-1) rotate(135deg);\n            transform: scaleX(-1) rotate(135deg);\n}\n.checkmark.error[data-v-05258735] {\n    position: absolute;\n    left: calc(12.5px - 2px);\n    top: 12.5px;\n    width: 25px;\n    height: 25px;\n    opacity: 0;\n}\n.checkmark.error.show[data-v-05258735] {\n      opacity: 1;\n}\n.checkmark.error[data-v-05258735]:before, .checkmark.error[data-v-05258735]:after {\n      position: absolute;\n      content: ' ';\n      height: 25px;\n      width: 5px;\n      background-color: #f00;\n}\n.checkmark.error[data-v-05258735]:before {\n      -webkit-transform: rotate(45deg);\n              transform: rotate(45deg);\n}\n.checkmark.error[data-v-05258735]:after {\n      -webkit-transform: rotate(-45deg);\n              transform: rotate(-45deg);\n}\n@-webkit-keyframes loader-spin-data-v-05258735 {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes loader-spin-data-v-05258735 {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@-webkit-keyframes checkmark-data-v-05258735 {\n0% {\n    height: 0;\n    width: 0;\n    opacity: 1;\n}\n20% {\n    height: 0;\n    width: 12.5px;\n    opacity: 1;\n}\n40% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n100% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n}\n@keyframes checkmark-data-v-05258735 {\n0% {\n    height: 0;\n    width: 0;\n    opacity: 1;\n}\n20% {\n    height: 0;\n    width: 12.5px;\n    opacity: 1;\n}\n40% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n100% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'dispatch-modal': true, show: _vm.validationModal.show || _vm.actionModal.show },on:{"click":_vm.close}},[_c('div',{staticClass:"dispatch-modal-container"},[_c('div',{staticClass:"dispatch-modal-content",on:{"click":function($event){$event.stopPropagation();}}},[(_vm.validationModal.show)?_c('div',{staticClass:"validation-modal"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.validationModal.title))]),_vm._v(" "),_c('div',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.validationModal.message)}}),_vm._v(" "),_c('a',{staticClass:"button success",attrs:{"href":"javascript:;"},on:{"click":_vm.close}},[_vm._v("GOT IT.")])]):_vm._e(),_vm._v(" "),(_vm.actionModal.show)?_c('div',{staticClass:"action-modal"},[_c('div',{class:{
            'circle-loader': true,
            'load-complete': _vm.actionModal.done && _vm.actionModal.success,
            'load-error': _vm.actionModal.done && !_vm.actionModal.success
          }},[_c('div',{class:{
              checkmark: true,
              draw: _vm.actionModal.done && _vm.actionModal.success,
              'error show': _vm.actionModal.done && !_vm.actionModal.success
            }})]),_vm._v(" "),_c('div',{class:['message', {
          success: _vm.actionModal.done && _vm.actionModal.success,
          error: _vm.actionModal.done && !_vm.actionModal.success
        }]},[(_vm.actionModal.done)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.actionModal.doneMessage)}}):_c('span',{domProps:{"innerHTML":_vm._s(_vm.actionModal.ongoingMessage)}})]),_vm._v(" "),(_vm.actionModal.done && _vm.actionModal.success)?_c('div',{staticStyle:{"margin-top":"30px"}},[_c('a',{staticClass:"button block",attrs:{"href":"javascript:;"},on:{"click":_vm.closeDone}},[_vm._v("CLOSE")])]):_vm._e()]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1259);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("551882cf", content, true, {});

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.dispatch-notification[data-v-184cf8aa] {\n  position: fixed;\n  z-index: 999;\n  top: 15px;\n  right: 15px;\n  background-color: #fff;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);\n  padding: 15px;\n  border-radius: 3px;\n  text-align: right;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.dispatch-notification.hide[data-v-184cf8aa] {\n    top: -130px;\n}\n.dispatch-notification.success[data-v-184cf8aa] {\n    border-top: 5px solid #26D97A;\n}\n.dispatch-notification.warning[data-v-184cf8aa] {\n    border-top: 5px solid #F25E0D;\n}\n.dispatch-notification .message[data-v-184cf8aa] {\n    font-size: 14px;\n    color: #333;\n    font-weight: 700;\n    text-align: center;\n}\n.dispatch-notification .error-title[data-v-184cf8aa] {\n    font-size: 16px;\n    display: block;\n    color: #F25E0D;\n}\n.dispatch-notification .comma[data-v-184cf8aa] {\n    display: inline-block;\n    margin-right: 4px;\n}\n.dispatch-notification .button[data-v-184cf8aa] {\n    margin-top: 10px;\n    font-weight: 700;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/DispatchNotification.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,iDAAiD;UACzC,yCAAyC;EACjD,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,YAAY;CACf;AACD;IACI,8BAA8B;CACjC;AACD;IACI,8BAA8B;CACjC;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;CACtB;AACD;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;CAClB;AACD;IACI,sBAAsB;IACtB,kBAAkB;CACrB;AACD;IACI,iBAAiB;IACjB,iBAAiB;CACpB","file":"DispatchNotification.vue","sourcesContent":["\n.dispatch-notification[data-v-184cf8aa] {\n  position: fixed;\n  z-index: 999;\n  top: 15px;\n  right: 15px;\n  background-color: #fff;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);\n  padding: 15px;\n  border-radius: 3px;\n  text-align: right;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.dispatch-notification.hide[data-v-184cf8aa] {\n    top: -130px;\n}\n.dispatch-notification.success[data-v-184cf8aa] {\n    border-top: 5px solid #26D97A;\n}\n.dispatch-notification.warning[data-v-184cf8aa] {\n    border-top: 5px solid #F25E0D;\n}\n.dispatch-notification .message[data-v-184cf8aa] {\n    font-size: 14px;\n    color: #333;\n    font-weight: 700;\n    text-align: center;\n}\n.dispatch-notification .error-title[data-v-184cf8aa] {\n    font-size: 16px;\n    display: block;\n    color: #F25E0D;\n}\n.dispatch-notification .comma[data-v-184cf8aa] {\n    display: inline-block;\n    margin-right: 4px;\n}\n.dispatch-notification .button[data-v-184cf8aa] {\n    margin-top: 10px;\n    font-weight: 700;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'dispatch-notification': true,
    warning: !_vm.notification.accept,
    success: _vm.notification.accept,
    hide: !_vm.notification.show
  }},[(_vm.notification.isSendAsSchedule && _vm.notification.sendAsScheduleError !== '')?_c('div',{staticClass:"message"},[_c('span',{staticClass:"error-title"},[_vm._v("ERROR: Send as schedule")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.notification.sendAsScheduleError))])]):(_vm.notification.runsDeclined)?_c('div',{staticClass:"message"},[_c('span',[_vm._v("\n      Driver rejected Run #"+_vm._s(_vm.notification.id)+"\n      ("),_vm._l((_vm.notification.sendAsScheduleError),function(rsvp,i){return _c('span',{key:i},[(i != 0)?_c('span',[_vm._v(",")]):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":'/#/reservation/' + rsvp,"target":"_blank"}},[_vm._v(_vm._s(rsvp))])])}),_vm._v(")\n    ")],2)]):_c('div',{staticClass:"message"},[(_vm.notification.driverId !== '')?_c('span',[_vm._v("\n      Driver\n      "),_c('a',{attrs:{"href":'/#/provider/' + _vm.notification.driverId,"target":"_blank"}},[_vm._v(_vm._s(_vm.notification.driverName))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.notification.accept),expression:"notification.accept"}]},[_vm._v("accepted")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.notification.accept),expression:"!notification.accept"}]},[_vm._v("rejected")])]):(!_vm.isSendAsSchedule)?_c('span',[_vm._v("Sorry but we did not find any drivers for")]):_vm._e(),_vm._v(" "),(!_vm.isSendAsSchedule)?_c('span',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.notification.isPackage),expression:"notification.isPackage"}]},[_vm._v("package")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.notification.isPackage),expression:"!notification.isPackage"}]},[_vm._v("reservation")]),_vm._v(" "),_c('a',{attrs:{"href":'/#/reservation/' + _vm.notification.id,"target":"_blank"}},[_vm._v(_vm._s(_vm.notification.id))]),_vm._v(".\n    ")]):_c('span',[(_vm.sendAsScheduleData.rsvp.length)?_c('span',[_vm._v("\n        reservation"),(_vm.sendAsScheduleData.rsvp.length > 1)?_c('span',[_vm._v("s")]):_vm._e(),_vm._v(" "),_vm._l((_vm.sendAsScheduleData.rsvp),function(rsvp,index){return _c('span',[_c('a',{attrs:{"href":'/#/reservation/' + rsvp}},[_vm._v(_vm._s(rsvp))]),(index < _vm.sendAsScheduleData.rsvp.length - 1)?_c('span',{staticClass:"comma"},[_vm._v(",")]):_vm._e()])})],2):_vm._e(),_vm._v(" "),(_vm.sendAsScheduleData.rsvp.length > 0 && _vm.sendAsScheduleData.pkg.length > 0)?_c('span',[_vm._v(" and ")]):_vm._e(),_vm._v(" "),(_vm.sendAsScheduleData.pkg.length)?_c('span',[_vm._v("\n        package"),(_vm.sendAsScheduleData.pkg.length > 1)?_c('span',[_vm._v("s")]):_vm._e(),_vm._v(" "),_vm._l((_vm.sendAsScheduleData.pkg),function(pkg,index){return _c('span',[_c('a',{attrs:{"href":'/#/package/' + pkg}},[_vm._v(_vm._s(pkg))]),(index < _vm.sendAsScheduleData.pkg.length - 1)?_c('span',{staticClass:"comma"},[_vm._v(",")]):_vm._e()])})],2):_vm._e()])]),_vm._v(" "),_c('a',{staticClass:"button xsmall",attrs:{"href":"javascript:;"},on:{"click":_vm.close}},[_vm._v("CLOSE")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1262);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("386bf1ba", content, true, {});

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.loading .fa[data-v-de716450] {\n  color: #5899da;\n}\n.loading div[data-v-de716450] {\n  font-size: 14px;\n  color: #555;\n  margin-top: 10px;\n}\n.accepted .fas[data-v-de716450] {\n  color: #26D97A;\n}\n.accepted div[data-v-de716450] {\n  font-size: 14px;\n  font-weight: 600;\n  color: #555;\n  margin: 20px 0 30px;\n}\n.error[data-v-de716450] {\n  color: #f53c3c;\n}\n.error .far[data-v-de716450] {\n    display: block;\n    margin-bottom: 5px;\n}\n.error span[data-v-de716450] {\n    font-size: 14px;\n}\n.modal[data-v-de716450] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.modal .modal-content[data-v-de716450] {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 400px;\n    padding: 25px;\n    background: #fff;\n    text-align: center;\n    border-radius: 6px;\n    margin-left: -200px;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n    -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal.show[data-v-de716450] {\n    display: block;\n}\n.modal.show .modal-content[data-v-de716450] {\n      display: block;\n      -webkit-animation: slide-down-data-v-de716450 .3s ease-out;\n      -moz-animation: slide-down-data-v-de716450 .3s ease-out;\n}\n@-webkit-keyframes slide-down-data-v-de716450 {\n0% {\n    opacity: 0;\n    -webkit-transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/DispatchSchedule.vue"],"names":[],"mappings":";AACA;EACE,eAAe;CAChB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;CAClB;AACD;EACE,eAAe;CAChB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;CACrB;AACD;EACE,eAAe;CAChB;AACD;IACI,eAAe;IACf,mBAAmB;CACtB;AACD;IACI,gBAAgB;CACnB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,YAAY;CACb;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,oCAAoC;YAC5B,4BAA4B;IACpC,uDAAuD;YAC/C,+CAA+C;IACvD,cAAc;CACjB;AACD;IACI,eAAe;CAClB;AACD;MACM,eAAe;MACf,2DAA2D;MAC3D,wDAAwD;CAC7D;AACD;AACA;IACI,WAAW;IACX,oCAAoC;CACvC;AACD;IACI,WAAW;IACX,iCAAiC;CACpC;CACA","file":"DispatchSchedule.vue","sourcesContent":["\n.loading .fa[data-v-de716450] {\n  color: #5899da;\n}\n.loading div[data-v-de716450] {\n  font-size: 14px;\n  color: #555;\n  margin-top: 10px;\n}\n.accepted .fas[data-v-de716450] {\n  color: #26D97A;\n}\n.accepted div[data-v-de716450] {\n  font-size: 14px;\n  font-weight: 600;\n  color: #555;\n  margin: 20px 0 30px;\n}\n.error[data-v-de716450] {\n  color: #f53c3c;\n}\n.error .far[data-v-de716450] {\n    display: block;\n    margin-bottom: 5px;\n}\n.error span[data-v-de716450] {\n    font-size: 14px;\n}\n.modal[data-v-de716450] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.modal .modal-content[data-v-de716450] {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 400px;\n    padding: 25px;\n    background: #fff;\n    text-align: center;\n    border-radius: 6px;\n    margin-left: -200px;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n    -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal.show[data-v-de716450] {\n    display: block;\n}\n.modal.show .modal-content[data-v-de716450] {\n      display: block;\n      -webkit-animation: slide-down-data-v-de716450 .3s ease-out;\n      -moz-animation: slide-down-data-v-de716450 .3s ease-out;\n}\n@-webkit-keyframes slide-down-data-v-de716450 {\n0% {\n    opacity: 0;\n    -webkit-transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'modal':true, 'show':_vm.show},on:{"click":_vm.closeModal}},[_c('div',{staticClass:"bg-overlay"}),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-fw fa-3x"}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.loadingMsg))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accepted && _vm.error === ''),expression:"accepted && error === ''"}],staticClass:"accepted"},[_c('i',{staticClass:"fas fa-clipboard-check fa-5x"}),_vm._v(" "),_c('div',[_vm._v("The schedule reservation/package has been accepted by the driver.")]),_vm._v(" "),_c('button',{staticClass:"button cta success small block",on:{"click":_vm.closeModal}},[_vm._v("Close")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error),expression:"!!error"}],staticClass:"error"},[_c('i',{staticClass:"far fa-times-circle fa-4x"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.error))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1265);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1d527508", content, true, {});

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.reservations-table-container[data-v-32808ac0] {\n  position: absolute;\n  width: 100%;\n  /*height: calc(100% - 70px);*/\n  height: calc(100% - 70px);\n  overflow: auto;\n}\n.reservations-table-wrapper[data-v-32808ac0] {\n  display: block;\n  height: 100%;\n  width: 100%;\n}\n.infinity-loader[data-v-32808ac0] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  -webkit-transform-origin: bottom center;\n          transform-origin: bottom center;\n  text-align: center;\n  font-size: 18px;\n  line-height: 40px;\n}\ntable[data-v-32808ac0] {\n  border-collapse: collapse;\n  width: 100%;\n  display: block;\n  overflow: auto;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n  padding-top: 47px;\n  height: 100%;\n  table-layout: fixed;\n  /*&.has-paging{ height: calc(100% - 60px); }*/\n}\ntable thead[data-v-32808ac0] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    display: tables;\n}\ntable tbody[data-v-32808ac0] {\n    display: block;\n}\ntable.shrink[data-v-32808ac0] {\n    padding-top: 29px;\n}\ntable.shrink tr[data-v-32808ac0] {\n      display: block;\n}\ntable.shrink .rc-1[data-v-32808ac0] {\n      width: 40px !important;\n      padding-left: 15px;\n}\ntable.shrink .rc-2[data-v-32808ac0] {\n      width: 40px !important;\n}\ntable.shrink .rc-3[data-v-32808ac0] {\n      width: 40px !important;\n}\ntable.shrink .rc-4[data-v-32808ac0] {\n      width: 65px !important;\n}\n.table-header[data-v-32808ac0] {\n  color: #8DA0A9;\n  font-size: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n}\n.table-header th[data-v-32808ac0] {\n    padding: 5px;\n}\n.table-header th.sortable[data-v-32808ac0] {\n      cursor: pointer;\n      text-decoration: underline;\n      color: #333;\n      -webkit-transition: all 250ms;\n      transition: all 250ms;\n}\n.table-header th.sortable.disabled[data-v-32808ac0] {\n        pointer-events: none;\n        opacity: 0.5;\n}\n.table-header th input[data-v-32808ac0] {\n      margin-top: 0;\n      display: block;\n      width: auto;\n}\n.empty-reservations[data-v-32808ac0] {\n  max-width: 450px;\n  margin: 50px auto;\n  text-align: center;\n  width: 90%;\n}\n.empty-reservations .title[data-v-32808ac0] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.empty-reservations .content[data-v-32808ac0] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\n.table-loader[data-v-32808ac0] {\n  position: relative;\n  width: 100%;\n  margin: 50px auto;\n  text-align: center;\n}\n.table-loader .loader-title[data-v-32808ac0] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.table-loader .loader-text[data-v-32808ac0] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\ntable .table-loader[data-v-32808ac0] {\n  width: 100%;\n}\ntable .tr-loader[data-v-32808ac0] {\n  width: 100%;\n  display: inline-table;\n}\n.paging[data-v-32808ac0] {\n  margin: 15px auto;\n  width: 103px;\n  opacity: 1;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.paging.disabled[data-v-32808ac0] {\n    pointer-events: none;\n    opacity: 0.6;\n}\n.paging .page[data-v-32808ac0] {\n    display: inline-block;\n    vertical-align: middle;\n    width: auto;\n}\n.paging .page[data-v-32808ac0]:not(:first-child) {\n      margin-left: -5px;\n}\n.paging .page-btn[data-v-32808ac0] {\n    background-color: #f5f5f5;\n    border: 1px solid rgba(0, 0, 0, 0.25);\n    color: #777;\n    padding: 5px 5px;\n    font-size: 12px;\n}\n.paging .page-btn.disabled[data-v-32808ac0] {\n      pointer-events: none;\n      opacity: 0.5;\n}\n.paging .page-btn i[data-v-32808ac0] {\n      line-height: inherit;\n}\n.paging .page-btn.back[data-v-32808ac0] {\n      border-top-left-radius: 3px;\n      border-bottom-left-radius: 3px;\n      border-right: 0;\n}\n.paging .page-btn.next[data-v-32808ac0] {\n      border-top-right-radius: 3px;\n      border-bottom-right-radius: 3px;\n}\n.paging .page-number[data-v-32808ac0] {\n    border-radius: 0;\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    line-height: inherit;\n    font-size: 12px;\n    margin: 0;\n    width: 50px;\n    font-weight: 700;\n    padding: 5px 10px;\n    color: #333;\n    text-align: center;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    outline: 0;\n    -moz-text-align-last: center;\n         text-align-last: center;\n    border-right: 0;\n}\n.slide-up-enter-active[data-v-32808ac0], .slide-up-leave-active[data-v-32808ac0] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-32808ac0], .slide-up-leave-to[data-v-32808ac0] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n#rsvp-div[data-v-32808ac0] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n#rsvp-table-container[data-v-32808ac0] {\n    padding-top: 0;\n}\ntable tbody[data-v-32808ac0] {\n    padding-bottom: 100px;\n}\n.table-loader[data-v-32808ac0] {\n    margin: 100px auto;\n}\n.infinity-loader[data-v-32808ac0] {\n    bottom: 47px;\n    z-index: 1;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/ReservationsTable.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;CAChB;AACD;EACE,eAAe;EACf,aAAa;EACb,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,wCAAwC;UAChC,gCAAgC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,eAAe;EACf,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,8CAA8C;CAC/C;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,gBAAgB;CACnB;AACD;IACI,eAAe;CAClB;AACD;IACI,kBAAkB;CACrB;AACD;MACM,eAAe;CACpB;AACD;MACM,uBAAuB;MACvB,mBAAmB;CACxB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,0BAA0B;CAC3B;AACD;IACI,aAAa;CAChB;AACD;MACM,gBAAgB;MAChB,2BAA2B;MAC3B,YAAY;MACZ,8BAA8B;MAC9B,sBAAsB;CAC3B;AACD;QACQ,qBAAqB;QACrB,aAAa;CACpB;AACD;MACM,cAAc;MACd,eAAe;MACf,YAAY;CACjB;AACD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;CACZ;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;CACpB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;EACE,YAAY;CACb;AACD;EACE,YAAY;EACZ,sBAAsB;CACvB;AACD;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,qBAAqB;IACrB,aAAa;CAChB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;CACf;AACD;MACM,kBAAkB;CACvB;AACD;IACI,0BAA0B;IAC1B,sCAAsC;IACtC,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;CACnB;AACD;MACM,qBAAqB;MACrB,aAAa;CAClB;AACD;MACM,qBAAqB;CAC1B;AACD;MACM,4BAA4B;MAC5B,+BAA+B;MAC/B,gBAAgB;CACrB;AACD;MACM,6BAA6B;MAC7B,gCAAgC;CACrC;AACD;IACI,iBAAiB;IACjB,uBAAuB;IACvB,qCAAqC;IACrC,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;OACtB,sBAAsB;YACjB,iBAAiB;IACzB,WAAW;IACX,6BAA6B;SACxB,wBAAwB;IAC7B,gBAAgB;CACnB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;EACE,cAAc;CACf;AACD;AACA;IACI,eAAe;CAClB;AACD;IACI,sBAAsB;CACzB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,aAAa;IACb,WAAW;CACd;CACA","file":"ReservationsTable.vue","sourcesContent":["\n.reservations-table-container[data-v-32808ac0] {\n  position: absolute;\n  width: 100%;\n  /*height: calc(100% - 70px);*/\n  height: calc(100% - 70px);\n  overflow: auto;\n}\n.reservations-table-wrapper[data-v-32808ac0] {\n  display: block;\n  height: 100%;\n  width: 100%;\n}\n.infinity-loader[data-v-32808ac0] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  -webkit-transform-origin: bottom center;\n          transform-origin: bottom center;\n  text-align: center;\n  font-size: 18px;\n  line-height: 40px;\n}\ntable[data-v-32808ac0] {\n  border-collapse: collapse;\n  width: 100%;\n  display: block;\n  overflow: auto;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n  padding-top: 47px;\n  height: 100%;\n  table-layout: fixed;\n  /*&.has-paging{ height: calc(100% - 60px); }*/\n}\ntable thead[data-v-32808ac0] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    display: tables;\n}\ntable tbody[data-v-32808ac0] {\n    display: block;\n}\ntable.shrink[data-v-32808ac0] {\n    padding-top: 29px;\n}\ntable.shrink tr[data-v-32808ac0] {\n      display: block;\n}\ntable.shrink .rc-1[data-v-32808ac0] {\n      width: 40px !important;\n      padding-left: 15px;\n}\ntable.shrink .rc-2[data-v-32808ac0] {\n      width: 40px !important;\n}\ntable.shrink .rc-3[data-v-32808ac0] {\n      width: 40px !important;\n}\ntable.shrink .rc-4[data-v-32808ac0] {\n      width: 65px !important;\n}\n.table-header[data-v-32808ac0] {\n  color: #8DA0A9;\n  font-size: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n}\n.table-header th[data-v-32808ac0] {\n    padding: 5px;\n}\n.table-header th.sortable[data-v-32808ac0] {\n      cursor: pointer;\n      text-decoration: underline;\n      color: #333;\n      -webkit-transition: all 250ms;\n      transition: all 250ms;\n}\n.table-header th.sortable.disabled[data-v-32808ac0] {\n        pointer-events: none;\n        opacity: 0.5;\n}\n.table-header th input[data-v-32808ac0] {\n      margin-top: 0;\n      display: block;\n      width: auto;\n}\n.empty-reservations[data-v-32808ac0] {\n  max-width: 450px;\n  margin: 50px auto;\n  text-align: center;\n  width: 90%;\n}\n.empty-reservations .title[data-v-32808ac0] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.empty-reservations .content[data-v-32808ac0] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\n.table-loader[data-v-32808ac0] {\n  position: relative;\n  width: 100%;\n  margin: 50px auto;\n  text-align: center;\n}\n.table-loader .loader-title[data-v-32808ac0] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.table-loader .loader-text[data-v-32808ac0] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\ntable .table-loader[data-v-32808ac0] {\n  width: 100%;\n}\ntable .tr-loader[data-v-32808ac0] {\n  width: 100%;\n  display: inline-table;\n}\n.paging[data-v-32808ac0] {\n  margin: 15px auto;\n  width: 103px;\n  opacity: 1;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.paging.disabled[data-v-32808ac0] {\n    pointer-events: none;\n    opacity: 0.6;\n}\n.paging .page[data-v-32808ac0] {\n    display: inline-block;\n    vertical-align: middle;\n    width: auto;\n}\n.paging .page[data-v-32808ac0]:not(:first-child) {\n      margin-left: -5px;\n}\n.paging .page-btn[data-v-32808ac0] {\n    background-color: #f5f5f5;\n    border: 1px solid rgba(0, 0, 0, 0.25);\n    color: #777;\n    padding: 5px 5px;\n    font-size: 12px;\n}\n.paging .page-btn.disabled[data-v-32808ac0] {\n      pointer-events: none;\n      opacity: 0.5;\n}\n.paging .page-btn i[data-v-32808ac0] {\n      line-height: inherit;\n}\n.paging .page-btn.back[data-v-32808ac0] {\n      border-top-left-radius: 3px;\n      border-bottom-left-radius: 3px;\n      border-right: 0;\n}\n.paging .page-btn.next[data-v-32808ac0] {\n      border-top-right-radius: 3px;\n      border-bottom-right-radius: 3px;\n}\n.paging .page-number[data-v-32808ac0] {\n    border-radius: 0;\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    line-height: inherit;\n    font-size: 12px;\n    margin: 0;\n    width: 50px;\n    font-weight: 700;\n    padding: 5px 10px;\n    color: #333;\n    text-align: center;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    outline: 0;\n    -moz-text-align-last: center;\n         text-align-last: center;\n    border-right: 0;\n}\n.slide-up-enter-active[data-v-32808ac0], .slide-up-leave-active[data-v-32808ac0] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-32808ac0], .slide-up-leave-to[data-v-32808ac0] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n#rsvp-div[data-v-32808ac0] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n#rsvp-table-container[data-v-32808ac0] {\n    padding-top: 0;\n}\ntable tbody[data-v-32808ac0] {\n    padding-bottom: 100px;\n}\n.table-loader[data-v-32808ac0] {\n    margin: 100px auto;\n}\n.infinity-loader[data-v-32808ac0] {\n    bottom: 47px;\n    z-index: 1;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1267);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("34980046", content, true, {});

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n@-webkit-keyframes uparrow-data-v-db210524 {\n0% {\n    -webkit-transform: translateY(0);\n    opacity: 0.4;\n}\n100% {\n    -webkit-transform: translateY(-0.4em);\n    opacity: 0.9;\n}\n}\n.arrow[data-v-db210524] {\n  border-color: transparent;\n  border-style: solid;\n  border-width: 0 2em;\n  display: block;\n  height: 0;\n  margin: 0 auto;\n  opacity: 0.4;\n  text-indent: -9999px;\n  -webkit-transform-origin: 50% 50%;\n          transform-origin: 50% 50%;\n  width: 0;\n}\n.up[data-v-db210524] {\n  -webkit-animation: uparrow-data-v-db210524 0.6s infinite alternate ease-in-out;\n  border-bottom: 2em solid #00b6f1;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Partials/LoadingAnimation/ArrowUp.vue"],"names":[],"mappings":";AACA;AACA;IACI,iCAAiC;IACjC,aAAa;CAChB;AACD;IACI,sCAAsC;IACtC,aAAa;CAChB;CACA;AACD;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,UAAU;EACV,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,kCAAkC;UAC1B,0BAA0B;EAClC,SAAS;CACV;AACD;EACE,+EAA+E;EAC/E,iCAAiC;CAClC","file":"ArrowUp.vue","sourcesContent":["\n@-webkit-keyframes uparrow-data-v-db210524 {\n0% {\n    -webkit-transform: translateY(0);\n    opacity: 0.4;\n}\n100% {\n    -webkit-transform: translateY(-0.4em);\n    opacity: 0.9;\n}\n}\n.arrow[data-v-db210524] {\n  border-color: transparent;\n  border-style: solid;\n  border-width: 0 2em;\n  display: block;\n  height: 0;\n  margin: 0 auto;\n  opacity: 0.4;\n  text-indent: -9999px;\n  -webkit-transform-origin: 50% 50%;\n          transform-origin: 50% 50%;\n  width: 0;\n}\n.up[data-v-db210524] {\n  -webkit-animation: uparrow-data-v-db210524 0.6s infinite alternate ease-in-out;\n  border-bottom: 2em solid #00b6f1;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"arrow up"},[_vm._v("Up")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationControls_vue__ = __webpack_require__(453);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fda5dd4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationControls_vue__ = __webpack_require__(1272);
function injectStyle (ssrContext) {
  __webpack_require__(1270)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4fda5dd4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationControls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fda5dd4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationControls_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1271);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("22ef52f1", content, true, {});

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.reservation-controls[data-v-4fda5dd4] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 15px;\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n  border-right: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #fff;\n}\n.padding-R[data-v-4fda5dd4] {\n  padding-right: 5px;\n}\n.padding-L[data-v-4fda5dd4] {\n  padding-left: 5px;\n}\n.cta.xsmall[data-v-4fda5dd4] {\n  margin-bottom: 5px;\n}\n@media only screen and (max-width: 430px) {\n.small-3[data-v-4fda5dd4] {\n    width: 50%;\n}\n.small-3 a[data-v-4fda5dd4] {\n      font-size: 11px;\n}\n.small-3.padding-L[data-v-4fda5dd4], .small-3.padding-R[data-v-4fda5dd4] {\n      padding: 2px 5px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/ReservationControls.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,yCAAyC;EACzC,2CAA2C;EAC3C,uBAAuB;CACxB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;AACA;IACI,WAAW;CACd;AACD;MACM,gBAAgB;CACrB;AACD;MACM,iBAAiB;CACtB;CACA","file":"ReservationControls.vue","sourcesContent":["\n.reservation-controls[data-v-4fda5dd4] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 15px;\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n  border-right: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #fff;\n}\n.padding-R[data-v-4fda5dd4] {\n  padding-right: 5px;\n}\n.padding-L[data-v-4fda5dd4] {\n  padding-left: 5px;\n}\n.cta.xsmall[data-v-4fda5dd4] {\n  margin-bottom: 5px;\n}\n@media only screen and (max-width: 430px) {\n.small-3[data-v-4fda5dd4] {\n    width: 50%;\n}\n.small-3 a[data-v-4fda5dd4] {\n      font-size: 11px;\n}\n.small-3.padding-L[data-v-4fda5dd4], .small-3.padding-R[data-v-4fda5dd4] {\n      padding: 2px 5px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reservation-controls"},[_c('div',{staticClass:"row"},[_c('div',{class:['columns', _vm.shrink ? 'small-12' : 'small-3 padding-R']},[_c('a',{class:['button cta small block', _vm.shrink ? 'xsmall' : ''],attrs:{"href":"javascript:;"},on:{"click":_vm.initMoveToPool}},[_vm._v("MOVE TO POOL")])]),_vm._v(" "),_c('div',{class:['columns', _vm.shrink ? 'small-12' : 'small-3 padding-R']},[_c('a',{class:['button cta small block error', _vm.shrink ? 'xsmall' : ''],on:{"click":_vm.removeFromPool}},[_vm._v("REMOVE FROM POOL")])]),_vm._v(" "),_c('div',{class:['columns', _vm.shrink ? 'small-12' : 'small-3 padding-L padding-R']},[_c('a',{class:['button cta block', _vm.shrink ? 'xsmall' : 'small', _vm.hasRSVPControl ? 'success' : 'secondary disabled'],attrs:{"href":"javascript:;"},on:{"click":_vm.markAsComplete}},[_vm._v("MARK AS COMPLETE")])]),_vm._v(" "),_c('div',{class:['columns', _vm.shrink ? 'small-12' : 'small-3 padding-L']},[_c('a',{class:['button cta warning block', _vm.shrink ? 'xsmall' : 'small'],attrs:{"href":"javascript:;"},on:{"click":_vm.autoDispatch}},[_vm._v("AUTO DISPATCH")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationRow_vue__ = __webpack_require__(454);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7063ee54_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationRow_vue__ = __webpack_require__(1282);
function injectStyle (ssrContext) {
  __webpack_require__(1274)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7063ee54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7063ee54_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1275);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("ac0a1bfc", content, true, {});

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.status[data-v-7063ee54] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-7063ee54], .status.completed[data-v-7063ee54] {\n    background: #26D97A;\n}\n.status.canceled[data-v-7063ee54], .status.cancelled[data-v-7063ee54], .status.failed[data-v-7063ee54] {\n    background: #bbb;\n}\n.status.upcoming[data-v-7063ee54] {\n    background: #f38d56;\n}\n.status.onboard[data-v-7063ee54] {\n    background: #dc3168;\n}\n.status.ready[data-v-7063ee54] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-7063ee54], .status.requires_dispatch[data-v-7063ee54] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-7063ee54] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-7063ee54] {\n    background: #5662f3;\n}\n.flight-status[data-v-7063ee54] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-7063ee54] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-7063ee54] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-7063ee54] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-7063ee54] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-7063ee54] {\n    background-color: #f35656;\n}\n.service-type[data-v-7063ee54] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-7063ee54] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-7063ee54] {\n    background: #26D97A;\n}\n.service-type.black[data-v-7063ee54] {\n    background: #777;\n}\n.service-type.suv[data-v-7063ee54] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-7063ee54] {\n    background: #6dabc3;\n}\n.license-type[data-v-7063ee54] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-7063ee54] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-7063ee54] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-7063ee54] {\n    background-color: #de6c2a;\n}\n.reservation[data-v-7063ee54] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.reservation td[data-v-7063ee54] {\n    padding: 10px 5px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.reservation td.package-icon[data-v-7063ee54] {\n      padding: 10px 0 10px 10px;\n      color: #26D97A;\n}\n.reservation td.package-icon .fa-route[data-v-7063ee54] {\n        color: #555;\n}\n.reservation td.package-icon .tool-tip-box[data-v-7063ee54] {\n        position: relative;\n}\n.reservation td.package-icon .tool-tip-box span[data-v-7063ee54] {\n          display: none;\n          position: absolute;\n          bottom: calc(100% + 6px);\n          left: -5px;\n          font-size: 13px;\n          border: 1px solid #888;\n          background: #fafafa;\n          color: #333;\n          padding: 3px 5px;\n          width: 120px;\n          text-align: center;\n}\n.reservation td.package-icon .tool-tip-box i:hover + span[data-v-7063ee54], .reservation td.package-icon .tool-tip-box img:hover + span[data-v-7063ee54] {\n          display: block;\n}\n.reservation td.map-button[data-v-7063ee54] {\n      padding: 10px 0;\n}\n.reservation td.map-button a[data-v-7063ee54] {\n        color: #fff;\n        background-color: #aaa;\n        width: 30px;\n        height: 30px;\n        line-height: 30px;\n        text-align: center;\n        display: inline-block;\n        border-radius: 30px;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.reservation td.map-button a i[data-v-7063ee54] {\n          line-height: inherit;\n}\n.reservation td.map-button a.selected[data-v-7063ee54] {\n          background-color: #26D97A;\n}\n.reservation td.map-button a.disabled[data-v-7063ee54] {\n          pointer-events: none;\n          opacity: 0.5;\n          background-color: #bbb;\n}\n.reservation td input[data-v-7063ee54] {\n      margin-top: 0;\n      width: 13px;\n}\n.reservation td img[data-v-7063ee54] {\n      min-width: 30px;\n      max-width: 30px;\n}\n.reservation .bold[data-v-7063ee54] {\n    font-weight: 700;\n}\n.reservation .flight-status[data-v-7063ee54] {\n    padding: 1px 4px;\n    font-size: 10px;\n}\n.reservation.shrink[data-v-7063ee54] {\n    display: block;\n}\n.reservation.shrink .rc-1[data-v-7063ee54] {\n      width: 40px !important;\n      padding-left: 15px;\n}\n.reservation.shrink .rc-2[data-v-7063ee54] {\n      width: 40px !important;\n}\n.reservation.shrink .rc-3[data-v-7063ee54] {\n      width: 40px !important;\n}\n.reservation.shrink .rc-4[data-v-7063ee54] {\n      width: 65px !important;\n}\n.fa-address-card[data-v-7063ee54] {\n  color: #555;\n}\n.status.accepted[data-v-7063ee54] {\n  background: #777;\n}\n.status.on-time[data-v-7063ee54] {\n  background: #26d97a;\n}\n.status.late[data-v-7063ee54] {\n  background: #dc9831;\n}\n.status.very-late[data-v-7063ee54] {\n  background: #e62e2e;\n}\n.status.pending-offer[data-v-7063ee54] {\n  background: #ef7a0b;\n  line-height: 12px;\n  position: relative;\n  overflow: hidden;\n  -webkit-box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);\n}\n.status.pending-offer[data-v-7063ee54]:after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background: linear-gradient(130deg, rgba(227, 227, 227, 0) 0%, rgba(227, 227, 227, 0) 40%, rgba(255, 255, 255, 0.7) 50%, rgba(227, 227, 227, 0) 60%, rgba(227, 227, 227, 0) 100%);\n    -webkit-animation: gradient-animation_2-data-v-7063ee54 1.2s linear infinite;\n            animation: gradient-animation_2-data-v-7063ee54 1.2s linear infinite;\n}\n@-webkit-keyframes gradient-animation_2-data-v-7063ee54 {\n0% {\n    -webkit-transform: translateX(-100%);\n            transform: translateX(-100%);\n}\n100% {\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%);\n}\n}\n@keyframes gradient-animation_2-data-v-7063ee54 {\n0% {\n    -webkit-transform: translateX(-100%);\n            transform: translateX(-100%);\n}\n100% {\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%);\n}\n}\n.timer[data-v-7063ee54] {\n  display: inline-block;\n}\ntr.reservation.no-driver[data-v-7063ee54] {\n  -webkit-animation: no-driver-data-v-7063ee54 1.5s ease infinite;\n          animation: no-driver-data-v-7063ee54 1.5s ease infinite;\n}\ntr.reservation.no-driver-urgent[data-v-7063ee54] {\n  -webkit-animation: no-driver-urgent-data-v-7063ee54 1s ease infinite;\n          animation: no-driver-urgent-data-v-7063ee54 1s ease infinite;\n}\n@-webkit-keyframes no-driver-data-v-7063ee54 {\n0% {\n    -webkit-box-shadow: inset 0 0 0 #fff;\n            box-shadow: inset 0 0 0 #fff;\n    background: #fff;\n}\n40% {\n    -webkit-box-shadow: inset 0 0 20px #ff8252;\n            box-shadow: inset 0 0 20px #ff8252;\n    background: rgba(255, 135, 0, 0.1);\n}\n100% {\n    -webkit-box-shadow: inset 0 0 0 #fff;\n            box-shadow: inset 0 0 0 #fff;\n    background: #fff;\n}\n}\n@keyframes no-driver-data-v-7063ee54 {\n0% {\n    -webkit-box-shadow: inset 0 0 0 #fff;\n            box-shadow: inset 0 0 0 #fff;\n    background: #fff;\n}\n40% {\n    -webkit-box-shadow: inset 0 0 20px #ff8252;\n            box-shadow: inset 0 0 20px #ff8252;\n    background: rgba(255, 135, 0, 0.1);\n}\n100% {\n    -webkit-box-shadow: inset 0 0 0 #fff;\n            box-shadow: inset 0 0 0 #fff;\n    background: #fff;\n}\n}\n@-webkit-keyframes no-driver-urgent-data-v-7063ee54 {\n0% {\n    -webkit-box-shadow: inset 0 0 0 #fff;\n            box-shadow: inset 0 0 0 #fff;\n    background: #fff;\n}\n40% {\n    -webkit-box-shadow: inset 0 0 10px 1px #f20d0d;\n            box-shadow: inset 0 0 10px 1px #f20d0d;\n    background: rgba(255, 0, 0, 0.1);\n}\n100% {\n    -webkit-box-shadow: inset 0 0 0 #fff;\n            box-shadow: inset 0 0 0 #fff;\n    background: #fff;\n}\n}\n@keyframes no-driver-urgent-data-v-7063ee54 {\n0% {\n    -webkit-box-shadow: inset 0 0 0 #fff;\n            box-shadow: inset 0 0 0 #fff;\n    background: #fff;\n}\n40% {\n    -webkit-box-shadow: inset 0 0 10px 1px #f20d0d;\n            box-shadow: inset 0 0 10px 1px #f20d0d;\n    background: rgba(255, 0, 0, 0.1);\n}\n100% {\n    -webkit-box-shadow: inset 0 0 0 #fff;\n            box-shadow: inset 0 0 0 #fff;\n    background: #fff;\n}\n}\n.rtg[data-v-7063ee54] {\n  color: #fff;\n  line-height: 1;\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  margin: 2px 4px;\n  cursor: pointer;\n  padding: 3px 15px;\n  border-radius: 4px;\n  background: #2586f3;\n  letter-spacing: 1px;\n  border-bottom: 3px solid #084991;\n}\n.notes[data-v-7063ee54] {\n  color: #fff;\n  line-height: 1;\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 600;\n  margin: 2px 4px;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  background: #f44336;\n  letter-spacing: 1px;\n  border-bottom: 3px solid #863a34;\n}\n@media only screen and (max-width: 430px) {\n.table-card[data-v-7063ee54] {\n    border: 1px solid #ccc;\n    margin: 10px;\n    margin-bottom: 15px;\n    padding: 10px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-size: 13px;\n}\n.table-card a[data-v-7063ee54] {\n      font-weight: 900;\n}\n.table-card i[data-v-7063ee54] {\n      color: #0d79f2;\n}\n.table-card > div[data-v-7063ee54] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n      margin-bottom: 3px;\n}\n.table-card > div.see-more[data-v-7063ee54] {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        -webkit-box-pack: start;\n            -ms-flex-pack: start;\n                justify-content: flex-start;\n        -webkit-box-align: start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n}\n.table-card > div .svg-icon svg[data-v-7063ee54] {\n        height: 20px;\n        width: 20px;\n}\n.table-card .toggle-div[data-v-7063ee54] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n}\n.table-card .toggle-div .toggle[data-v-7063ee54] {\n        font-size: 18px;\n        color: #0e79f2;\n}\n.table-card .row-1 i[data-v-7063ee54] {\n      color: #26D97A;\n}\n.table-card .row-1 input[data-v-7063ee54] {\n      display: inline-block;\n      margin: 0;\n      width: 15px;\n      height: 15px;\n      margin-right: 5px;\n}\n.table-card .row-1 .map-button[data-v-7063ee54] {\n      color: #fff;\n      background-color: #aaa;\n      width: 30px;\n      height: 30px;\n      line-height: 30px;\n      text-align: center;\n      border-radius: 30px;\n      -webkit-transition: all 250ms;\n      transition: all 250ms;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.table-card .row-1 .map-button i[data-v-7063ee54] {\n        color: #fff;\n}\n.table-card .row-2[data-v-7063ee54] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: unset;\n          -ms-flex-pack: unset;\n              justify-content: unset;\n      gap: 5px;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .row-2 .image img[data-v-7063ee54] {\n        min-width: 30px;\n        max-width: 30px;\n}\n.table-card .row-7 i[data-v-7063ee54] {\n      color: #666;\n      margin: 0 3px;\n}\n.table-card .row-8[data-v-7063ee54] {\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.table-card .actions[data-v-7063ee54] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.table-card .actions span[data-v-7063ee54] {\n        color: #fff;\n        padding: 8px 20px;\n        margin-left: 0;\n}\n.table-card .actions .notes i[data-v-7063ee54] {\n        color: #fff;\n}\n.table-card .clock i[data-v-7063ee54] {\n      color: #F25E0D;\n}\n.table-card .pickup i[data-v-7063ee54] {\n      color: #d92626;\n}\n.table-card .dropoff i[data-v-7063ee54] {\n      color: #26D97A;\n}\n}\n.optin-icon[data-v-7063ee54] {\n  min-width: 18px !important;\n  width: 18px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/ReservationRow.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;CAC3B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,uBAAuB;EACvB,qCAAqC;CACtC;AACD;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;CACtB;AACD;MACM,0BAA0B;MAC1B,eAAe;CACpB;AACD;QACQ,YAAY;CACnB;AACD;QACQ,mBAAmB;CAC1B;AACD;UACU,cAAc;UACd,mBAAmB;UACnB,yBAAyB;UACzB,WAAW;UACX,gBAAgB;UAChB,uBAAuB;UACvB,oBAAoB;UACpB,YAAY;UACZ,iBAAiB;UACjB,aAAa;UACb,mBAAmB;CAC5B;AACD;UACU,eAAe;CACxB;AACD;MACM,gBAAgB;CACrB;AACD;QACQ,YAAY;QACZ,uBAAuB;QACvB,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,mBAAmB;QACnB,sBAAsB;QACtB,oBAAoB;QACpB,8BAA8B;QAC9B,sBAAsB;CAC7B;AACD;UACU,qBAAqB;CAC9B;AACD;UACU,0BAA0B;CACnC;AACD;UACU,qBAAqB;UACrB,aAAa;UACb,uBAAuB;CAChC;AACD;MACM,cAAc;MACd,YAAY;CACjB;AACD;MACM,gBAAgB;MAChB,gBAAgB;CACrB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,eAAe;CAClB;AACD;MACM,uBAAuB;MACvB,mBAAmB;CACxB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;EACE,YAAY;CACb;AACD;EACE,iBAAiB;CAClB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mDAAmD;UAC3C,2CAA2C;CACpD;AACD;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,OAAO;IACP,QAAQ;IACR,kLAAkL;IAClL,6EAA6E;YACrE,qEAAqE;CAChF;AACD;AACA;IACI,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;IACI,oCAAoC;YAC5B,4BAA4B;CACvC;CACA;AACD;AACA;IACI,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;IACI,oCAAoC;YAC5B,4BAA4B;CACvC;CACA;AACD;EACE,sBAAsB;CACvB;AACD;EACE,gEAAgE;UACxD,wDAAwD;CACjE;AACD;EACE,qEAAqE;UAC7D,6DAA6D;CACtE;AACD;AACA;IACI,qCAAqC;YAC7B,6BAA6B;IACrC,iBAAiB;CACpB;AACD;IACI,2CAA2C;YACnC,mCAAmC;IAC3C,mCAAmC;CACtC;AACD;IACI,qCAAqC;YAC7B,6BAA6B;IACrC,iBAAiB;CACpB;CACA;AACD;AACA;IACI,qCAAqC;YAC7B,6BAA6B;IACrC,iBAAiB;CACpB;AACD;IACI,2CAA2C;YACnC,mCAAmC;IAC3C,mCAAmC;CACtC;AACD;IACI,qCAAqC;YAC7B,6BAA6B;IACrC,iBAAiB;CACpB;CACA;AACD;AACA;IACI,qCAAqC;YAC7B,6BAA6B;IACrC,iBAAiB;CACpB;AACD;IACI,+CAA+C;YACvC,uCAAuC;IAC/C,iCAAiC;CACpC;AACD;IACI,qCAAqC;YAC7B,6BAA6B;IACrC,iBAAiB;CACpB;CACA;AACD;AACA;IACI,qCAAqC;YAC7B,6BAA6B;IACrC,iBAAiB;CACpB;AACD;IACI,+CAA+C;YACvC,uCAAuC;IAC/C,iCAAiC;CACpC;AACD;IACI,qCAAqC;YAC7B,6BAA6B;IACrC,iBAAiB;CACpB;CACA;AACD;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,iCAAiC;CAClC;AACD;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,iCAAiC;CAClC;AACD;AACA;IACI,uBAAuB;IACvB,aAAa;IACb,oBAAoB;IACpB,cAAc;IACd,+BAA+B;IAC/B,oBAAoB;IACpB,gBAAgB;CACnB;AACD;MACM,iBAAiB;CACtB;AACD;MACM,eAAe;CACpB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,uBAAuB;UACnB,oBAAoB;cAChB,sBAAsB;MAC9B,mBAAmB;CACxB;AACD;QACQ,6BAA6B;QAC7B,8BAA8B;YAC1B,2BAA2B;gBACvB,uBAAuB;QAC/B,wBAAwB;YACpB,qBAAqB;gBACjB,4BAA4B;QACpC,yBAAyB;YACrB,sBAAsB;gBAClB,wBAAwB;CACvC;AACD;QACQ,aAAa;QACb,YAAY;CACnB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,uBAAuB;UACnB,oBAAoB;cAChB,sBAAsB;CACnC;AACD;QACQ,gBAAgB;QAChB,eAAe;CACtB;AACD;MACM,eAAe;CACpB;AACD;MACM,sBAAsB;MACtB,UAAU;MACV,YAAY;MACZ,aAAa;MACb,kBAAkB;CACvB;AACD;MACM,YAAY;MACZ,uBAAuB;MACvB,YAAY;MACZ,aAAa;MACb,kBAAkB;MAClB,mBAAmB;MACnB,oBAAoB;MACpB,8BAA8B;MAC9B,sBAAsB;MACtB,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;MAC5B,yBAAyB;UACrB,sBAAsB;cAClB,wBAAwB;CACrC;AACD;QACQ,YAAY;CACnB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,wBAAwB;UACpB,qBAAqB;cACjB,uBAAuB;MAC/B,SAAS;MACT,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;QACQ,gBAAgB;QAChB,gBAAgB;CACvB;AACD;MACM,YAAY;MACZ,cAAc;CACnB;AACD;MACM,yBAAyB;UACrB,sBAAsB;cAClB,wBAAwB;CACrC;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;CACnB;AACD;QACQ,YAAY;QACZ,kBAAkB;QAClB,eAAe;CACtB;AACD;QACQ,YAAY;CACnB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;CACA;AACD;EACE,2BAA2B;EAC3B,YAAY;CACb","file":"ReservationRow.vue","sourcesContent":["\n.status[data-v-7063ee54] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-7063ee54], .status.completed[data-v-7063ee54] {\n    background: #26D97A;\n}\n.status.canceled[data-v-7063ee54], .status.cancelled[data-v-7063ee54], .status.failed[data-v-7063ee54] {\n    background: #bbb;\n}\n.status.upcoming[data-v-7063ee54] {\n    background: #f38d56;\n}\n.status.onboard[data-v-7063ee54] {\n    background: #dc3168;\n}\n.status.ready[data-v-7063ee54] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-7063ee54], .status.requires_dispatch[data-v-7063ee54] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-7063ee54] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-7063ee54] {\n    background: #5662f3;\n}\n.flight-status[data-v-7063ee54] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-7063ee54] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-7063ee54] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-7063ee54] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-7063ee54] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-7063ee54] {\n    background-color: #f35656;\n}\n.service-type[data-v-7063ee54] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-7063ee54] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-7063ee54] {\n    background: #26D97A;\n}\n.service-type.black[data-v-7063ee54] {\n    background: #777;\n}\n.service-type.suv[data-v-7063ee54] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-7063ee54] {\n    background: #6dabc3;\n}\n.license-type[data-v-7063ee54] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-7063ee54] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-7063ee54] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-7063ee54] {\n    background-color: #de6c2a;\n}\n.reservation[data-v-7063ee54] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.reservation td[data-v-7063ee54] {\n    padding: 10px 5px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.reservation td.package-icon[data-v-7063ee54] {\n      padding: 10px 0 10px 10px;\n      color: #26D97A;\n}\n.reservation td.package-icon .fa-route[data-v-7063ee54] {\n        color: #555;\n}\n.reservation td.package-icon .tool-tip-box[data-v-7063ee54] {\n        position: relative;\n}\n.reservation td.package-icon .tool-tip-box span[data-v-7063ee54] {\n          display: none;\n          position: absolute;\n          bottom: calc(100% + 6px);\n          left: -5px;\n          font-size: 13px;\n          border: 1px solid #888;\n          background: #fafafa;\n          color: #333;\n          padding: 3px 5px;\n          width: 120px;\n          text-align: center;\n}\n.reservation td.package-icon .tool-tip-box i:hover + span[data-v-7063ee54], .reservation td.package-icon .tool-tip-box img:hover + span[data-v-7063ee54] {\n          display: block;\n}\n.reservation td.map-button[data-v-7063ee54] {\n      padding: 10px 0;\n}\n.reservation td.map-button a[data-v-7063ee54] {\n        color: #fff;\n        background-color: #aaa;\n        width: 30px;\n        height: 30px;\n        line-height: 30px;\n        text-align: center;\n        display: inline-block;\n        border-radius: 30px;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.reservation td.map-button a i[data-v-7063ee54] {\n          line-height: inherit;\n}\n.reservation td.map-button a.selected[data-v-7063ee54] {\n          background-color: #26D97A;\n}\n.reservation td.map-button a.disabled[data-v-7063ee54] {\n          pointer-events: none;\n          opacity: 0.5;\n          background-color: #bbb;\n}\n.reservation td input[data-v-7063ee54] {\n      margin-top: 0;\n      width: 13px;\n}\n.reservation td img[data-v-7063ee54] {\n      min-width: 30px;\n      max-width: 30px;\n}\n.reservation .bold[data-v-7063ee54] {\n    font-weight: 700;\n}\n.reservation .flight-status[data-v-7063ee54] {\n    padding: 1px 4px;\n    font-size: 10px;\n}\n.reservation.shrink[data-v-7063ee54] {\n    display: block;\n}\n.reservation.shrink .rc-1[data-v-7063ee54] {\n      width: 40px !important;\n      padding-left: 15px;\n}\n.reservation.shrink .rc-2[data-v-7063ee54] {\n      width: 40px !important;\n}\n.reservation.shrink .rc-3[data-v-7063ee54] {\n      width: 40px !important;\n}\n.reservation.shrink .rc-4[data-v-7063ee54] {\n      width: 65px !important;\n}\n.fa-address-card[data-v-7063ee54] {\n  color: #555;\n}\n.status.accepted[data-v-7063ee54] {\n  background: #777;\n}\n.status.on-time[data-v-7063ee54] {\n  background: #26d97a;\n}\n.status.late[data-v-7063ee54] {\n  background: #dc9831;\n}\n.status.very-late[data-v-7063ee54] {\n  background: #e62e2e;\n}\n.status.pending-offer[data-v-7063ee54] {\n  background: #ef7a0b;\n  line-height: 12px;\n  position: relative;\n  overflow: hidden;\n  -webkit-box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);\n}\n.status.pending-offer[data-v-7063ee54]:after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background: linear-gradient(130deg, rgba(227, 227, 227, 0) 0%, rgba(227, 227, 227, 0) 40%, rgba(255, 255, 255, 0.7) 50%, rgba(227, 227, 227, 0) 60%, rgba(227, 227, 227, 0) 100%);\n    -webkit-animation: gradient-animation_2-data-v-7063ee54 1.2s linear infinite;\n            animation: gradient-animation_2-data-v-7063ee54 1.2s linear infinite;\n}\n@-webkit-keyframes gradient-animation_2-data-v-7063ee54 {\n0% {\n    -webkit-transform: translateX(-100%);\n            transform: translateX(-100%);\n}\n100% {\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%);\n}\n}\n@keyframes gradient-animation_2-data-v-7063ee54 {\n0% {\n    -webkit-transform: translateX(-100%);\n            transform: translateX(-100%);\n}\n100% {\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%);\n}\n}\n.timer[data-v-7063ee54] {\n  display: inline-block;\n}\ntr.reservation.no-driver[data-v-7063ee54] {\n  -webkit-animation: no-driver-data-v-7063ee54 1.5s ease infinite;\n          animation: no-driver-data-v-7063ee54 1.5s ease infinite;\n}\ntr.reservation.no-driver-urgent[data-v-7063ee54] {\n  -webkit-animation: no-driver-urgent-data-v-7063ee54 1s ease infinite;\n          animation: no-driver-urgent-data-v-7063ee54 1s ease infinite;\n}\n@-webkit-keyframes no-driver-data-v-7063ee54 {\n0% {\n    -webkit-box-shadow: inset 0 0 0 #fff;\n            box-shadow: inset 0 0 0 #fff;\n    background: #fff;\n}\n40% {\n    -webkit-box-shadow: inset 0 0 20px #ff8252;\n            box-shadow: inset 0 0 20px #ff8252;\n    background: rgba(255, 135, 0, 0.1);\n}\n100% {\n    -webkit-box-shadow: inset 0 0 0 #fff;\n            box-shadow: inset 0 0 0 #fff;\n    background: #fff;\n}\n}\n@keyframes no-driver-data-v-7063ee54 {\n0% {\n    -webkit-box-shadow: inset 0 0 0 #fff;\n            box-shadow: inset 0 0 0 #fff;\n    background: #fff;\n}\n40% {\n    -webkit-box-shadow: inset 0 0 20px #ff8252;\n            box-shadow: inset 0 0 20px #ff8252;\n    background: rgba(255, 135, 0, 0.1);\n}\n100% {\n    -webkit-box-shadow: inset 0 0 0 #fff;\n            box-shadow: inset 0 0 0 #fff;\n    background: #fff;\n}\n}\n@-webkit-keyframes no-driver-urgent-data-v-7063ee54 {\n0% {\n    -webkit-box-shadow: inset 0 0 0 #fff;\n            box-shadow: inset 0 0 0 #fff;\n    background: #fff;\n}\n40% {\n    -webkit-box-shadow: inset 0 0 10px 1px #f20d0d;\n            box-shadow: inset 0 0 10px 1px #f20d0d;\n    background: rgba(255, 0, 0, 0.1);\n}\n100% {\n    -webkit-box-shadow: inset 0 0 0 #fff;\n            box-shadow: inset 0 0 0 #fff;\n    background: #fff;\n}\n}\n@keyframes no-driver-urgent-data-v-7063ee54 {\n0% {\n    -webkit-box-shadow: inset 0 0 0 #fff;\n            box-shadow: inset 0 0 0 #fff;\n    background: #fff;\n}\n40% {\n    -webkit-box-shadow: inset 0 0 10px 1px #f20d0d;\n            box-shadow: inset 0 0 10px 1px #f20d0d;\n    background: rgba(255, 0, 0, 0.1);\n}\n100% {\n    -webkit-box-shadow: inset 0 0 0 #fff;\n            box-shadow: inset 0 0 0 #fff;\n    background: #fff;\n}\n}\n.rtg[data-v-7063ee54] {\n  color: #fff;\n  line-height: 1;\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  margin: 2px 4px;\n  cursor: pointer;\n  padding: 3px 15px;\n  border-radius: 4px;\n  background: #2586f3;\n  letter-spacing: 1px;\n  border-bottom: 3px solid #084991;\n}\n.notes[data-v-7063ee54] {\n  color: #fff;\n  line-height: 1;\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 600;\n  margin: 2px 4px;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  background: #f44336;\n  letter-spacing: 1px;\n  border-bottom: 3px solid #863a34;\n}\n@media only screen and (max-width: 430px) {\n.table-card[data-v-7063ee54] {\n    border: 1px solid #ccc;\n    margin: 10px;\n    margin-bottom: 15px;\n    padding: 10px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-size: 13px;\n}\n.table-card a[data-v-7063ee54] {\n      font-weight: 900;\n}\n.table-card i[data-v-7063ee54] {\n      color: #0d79f2;\n}\n.table-card > div[data-v-7063ee54] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n      margin-bottom: 3px;\n}\n.table-card > div.see-more[data-v-7063ee54] {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        -webkit-box-pack: start;\n            -ms-flex-pack: start;\n                justify-content: flex-start;\n        -webkit-box-align: start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n}\n.table-card > div .svg-icon svg[data-v-7063ee54] {\n        height: 20px;\n        width: 20px;\n}\n.table-card .toggle-div[data-v-7063ee54] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n}\n.table-card .toggle-div .toggle[data-v-7063ee54] {\n        font-size: 18px;\n        color: #0e79f2;\n}\n.table-card .row-1 i[data-v-7063ee54] {\n      color: #26D97A;\n}\n.table-card .row-1 input[data-v-7063ee54] {\n      display: inline-block;\n      margin: 0;\n      width: 15px;\n      height: 15px;\n      margin-right: 5px;\n}\n.table-card .row-1 .map-button[data-v-7063ee54] {\n      color: #fff;\n      background-color: #aaa;\n      width: 30px;\n      height: 30px;\n      line-height: 30px;\n      text-align: center;\n      border-radius: 30px;\n      -webkit-transition: all 250ms;\n      transition: all 250ms;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.table-card .row-1 .map-button i[data-v-7063ee54] {\n        color: #fff;\n}\n.table-card .row-2[data-v-7063ee54] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: unset;\n          -ms-flex-pack: unset;\n              justify-content: unset;\n      gap: 5px;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .row-2 .image img[data-v-7063ee54] {\n        min-width: 30px;\n        max-width: 30px;\n}\n.table-card .row-7 i[data-v-7063ee54] {\n      color: #666;\n      margin: 0 3px;\n}\n.table-card .row-8[data-v-7063ee54] {\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.table-card .actions[data-v-7063ee54] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.table-card .actions span[data-v-7063ee54] {\n        color: #fff;\n        padding: 8px 20px;\n        margin-left: 0;\n}\n.table-card .actions .notes i[data-v-7063ee54] {\n        color: #fff;\n}\n.table-card .clock i[data-v-7063ee54] {\n      color: #F25E0D;\n}\n.table-card .pickup i[data-v-7063ee54] {\n      color: #d92626;\n}\n.table-card .dropoff i[data-v-7063ee54] {\n      color: #26D97A;\n}\n}\n.optin-icon[data-v-7063ee54] {\n  min-width: 18px !important;\n  width: 18px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1277);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("537df73b", content, true, {});

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\nsvg[data-v-d0720302] {\n  height: 30px;\n  width: 30px;\n}\nsvg path[data-v-d0720302] {\n    fill: #0D79F2;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Partials/SVG/ServiceDog.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,YAAY;CACb;AACD;IACI,cAAc;CACjB","file":"ServiceDog.vue","sourcesContent":["\nsvg[data-v-d0720302] {\n  height: 30px;\n  width: 30px;\n}\nsvg path[data-v-d0720302] {\n    fill: #0D79F2;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.41421"},attrs:{"width":"100%","height":"100%","viewBox":"0 0 5556 5556","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","xml:space":"preserve","xmlns:serif":"http://www.serif.com/"}},[_c('rect',{staticStyle:{"fill":"none"},attrs:{"id":"dog","x":"0","y":"0","width":"5555.56","height":"5555.56"}}),_vm._v(" "),_c('clipPath',{attrs:{"id":"_clip1"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"5555.56","height":"5555.56"}})]),_vm._v(" "),_c('g',{attrs:{"clip-path":"url(#_clip1)"}},[_c('path',{staticStyle:{"fill-rule":"nonzero"},attrs:{"id":"Forma-1","serif:id":"Forma 1","d":"M0.315,4091.93l84.364,-46.365c5.35,-2.941 533.811,-298.329 533.811,-725.25l0,-243.945c0,-192.849 52.94,-374.381 145.952,-529.883c-189.8,-100.021 -319.564,-299.218 -319.564,-528.255l325.521,0c0,131.413 93.946,241.265 218.186,266.026c135.797,-113.14 302.16,-192.447 487.511,-224.045l1811.44,-308.767c155.414,-26.487 289.127,-127.073 357.682,-269.054l658.008,-1254.52l264.919,0l0,587.977l434.028,108.507l0,114.822l553.386,217.014l0,178.418l-323.21,323.209l-664.204,0l0,561.187c0,425.391 -201.237,817.134 -542.534,1064.79l0,1618.38l325.52,0l0,325.521l-651.041,0l0,-266.851l-392.003,-1435.56c-41.016,-5.132 -1557.7,-289.627 -1557.7,-289.627c-82.292,235.07 -216.927,450.456 -398.112,631.63c-278.863,278.863 -638.694,447.635 -1026.75,484.592l0,550.293l325.521,0l0,325.521l-651.042,0l0,-1139.32l0.315,-96.441Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1280);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4828a578", content, true, {});

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\nsvg[data-v-583d8a06] {\n  height: 30px;\n  width: 30px;\n}\nsvg path[data-v-583d8a06] {\n    fill: #26D97A;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Partials/SVG/Wheelchair.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,YAAY;CACb;AACD;IACI,cAAc;CACjB","file":"Wheelchair.vue","sourcesContent":["\nsvg[data-v-583d8a06] {\n  height: 30px;\n  width: 30px;\n}\nsvg path[data-v-583d8a06] {\n    fill: #26D97A;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.41421"},attrs:{"width":"100%","height":"100%","viewBox":"0 0 5556 5556","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","xml:space":"preserve","xmlns:serif":"http://www.serif.com/"}},[_c('rect',{staticStyle:{"fill":"none"},attrs:{"id":"wheelchair","x":"0","y":"0","width":"5555.56","height":"5555.56"}}),_vm._v(" "),_c('clipPath',{attrs:{"id":"_clip1"}},[_c('rect',{attrs:{"x":"179.368","y":"0","width":"5196.82","height":"5555.56"}})]),_vm._v(" "),_c('g',{attrs:{"clip-path":"url(#_clip1)"}},[_c('path',{staticStyle:{"fill-rule":"nonzero"},attrs:{"id":"Forma-1","serif:id":"Forma 1","d":"M3849.79,3806.48c67.326,15.829 118.786,49.425 154.42,100.798c35.634,51.373 45.538,110.675 29.692,177.877c-19.797,82.992 -43.537,158.093 -71.268,225.304c-67.306,185.777 -162.334,355.744 -285.081,509.902c-122.729,154.158 -265.284,285.6 -427.608,394.287c-162.353,108.698 -338.552,192.694 -528.592,251.985c-190.054,59.292 -388.027,88.934 -593.922,88.934c-269.24,0 -521.659,-49.406 -757.246,-148.225c-235.588,-98.821 -441.483,-233.215 -617.676,-403.182c-176.2,-169.967 -315.769,-368.592 -418.714,-595.874c-102.95,-227.282 -154.42,-471.348 -154.42,-732.245c0,-193.685 29.696,-381.439 89.089,-563.261c59.389,-181.841 144.516,-349.821 255.385,-503.974c110.864,-154.158 243.506,-290.529 397.926,-409.108c154.42,-118.585 324.676,-213.451 510.77,-284.597c63.354,-19.765 125.713,-16.803 187.087,8.892c61.37,25.692 103.936,68.186 127.69,127.478c23.76,59.288 21.779,118.58 -5.937,177.872c-27.716,59.287 -73.248,98.816 -136.603,118.58c-142.541,55.338 -271.221,127.478 -386.046,216.411c-114.826,88.938 -213.814,191.708 -296.961,308.316c-83.148,116.607 -147.493,243.091 -193.026,379.462c-45.533,136.371 -68.302,277.68 -68.302,423.929c0,197.641 38.606,382.443 115.815,554.388c77.211,171.935 182.137,321.144 314.779,447.638c132.642,126.494 288.053,227.282 466.228,302.393c178.174,75.101 368.228,112.653 570.162,112.653c154.42,0 303.889,-22.745 448.411,-68.186c144.521,-45.461 277.162,-109.692 397.93,-192.712c120.748,-82.991 227.669,-181.822 320.715,-296.451c93.047,-114.629 165.31,-241.114 216.78,-379.463c23.759,-55.337 41.577,-112.652 53.451,-171.944c15.837,-63.247 50.485,-112.653 103.936,-148.226c53.451,-35.573 113.83,-45.46 181.136,-29.651Zm1496.67,907.16c19.798,39.528 29.712,81.015 29.712,124.507c0,79.057 -28.707,146.249 -86.12,201.586c-57.412,55.357 -125.714,83.011 -204.904,83.011c-63.336,0 -118.786,-15.809 -166.296,-47.428c-47.518,-31.638 -83.152,-73.143 -106.902,-124.525l-783.976,-1363.69l-1348.21,0c-15.836,3.954 -37.614,5.932 -65.33,5.932c-95.027,0 -178.174,-28.658 -249.447,-85.972c-71.268,-57.315 -114.825,-131.433 -130.662,-222.344l-326.657,-1571.22l5.942,0c-3.962,-11.859 -5.942,-27.669 -5.942,-47.433c0,-118.584 43.557,-220.366 130.661,-305.35c87.109,-84.982 194.015,-127.472 320.72,-127.472c102.945,0 193.025,29.641 270.231,88.933c77.211,59.292 129.675,134.394 157.392,225.305l5.937,17.787c0,7.909 0.99,12.848 2.97,14.825c1.981,1.978 2.972,6.916 2.972,14.825l53.456,272.738l926.512,0c39.595,0 75.229,9.882 106.902,29.647c59.393,31.618 98.013,79.05 115.829,142.298c17.818,63.242 10.89,122.534 -20.802,177.871c-23.759,43.479 -57.412,75.102 -100.95,94.866c-43.557,19.764 -89.104,27.669 -136.603,23.714l-789.929,0l118.786,581.053l1009.67,0c79.19,0 150.459,19.765 213.813,59.293c63.336,39.527 110.863,92.887 142.536,160.089l908.695,1577.15Zm-3141.83,-3604.9c-79.191,0 -152.44,-14.825 -219.752,-44.471c-67.31,-29.642 -125.713,-69.169 -175.203,-118.579c-49.494,-49.41 -89.089,-107.714 -118.786,-174.911c-29.697,-67.197 -44.542,-140.321 -44.542,-219.377c0,-75.102 14.845,-146.249 44.542,-213.445c29.697,-67.197 69.292,-125.501 118.786,-174.911c49.49,-49.41 107.893,-88.934 175.203,-118.58c67.312,-29.646 140.561,-44.471 219.752,-44.471c75.229,0 146.502,14.825 213.813,44.471c67.312,29.646 126.7,69.17 178.175,118.58c51.47,49.41 91.066,107.714 118.781,174.911c27.717,67.196 41.577,138.343 41.577,213.445c0,154.157 -53.451,285.586 -160.358,394.288c-106.906,108.697 -237.568,163.05 -391.988,163.05Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('tr',{class:( _obj = {'reservation':true, 'shrink':_vm.shrink}, _obj[_vm.resStatus(_vm.rsvp)] = true, _obj )},[_c('td',{staticClass:"rc-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedReservations),expression:"checkedReservations"}],attrs:{"type":"checkbox"},domProps:{"value":{id: _vm.rsvp.id, isPackage: _vm.rsvp.isPackage, status: _vm.rsvp.statusClass},"checked":Array.isArray(_vm.checkedReservations)?_vm._i(_vm.checkedReservations,{id: _vm.rsvp.id, isPackage: _vm.rsvp.isPackage, status: _vm.rsvp.statusClass})>-1:(_vm.checkedReservations)},on:{"change":function($event){var $$a=_vm.checkedReservations,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v={id: _vm.rsvp.id, isPackage: _vm.rsvp.isPackage, status: _vm.rsvp.statusClass},$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedReservations=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedReservations=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedReservations=$$c}}}})]),_vm._v(" "),_c('td',{staticClass:"map-button rc-2"},[_c('a',{class:{disabled: _vm.loadingRsvpId !== null, selected: _vm.rsvpInMap.id === _vm.rsvp.id},attrs:{"href":"javascript:;"},on:{"click":_vm.showOnMap}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingRsvpId !== _vm.rsvp.id),expression:"loadingRsvpId !== rsvp.id"}],staticClass:"fas fa-map-marker-alt"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingRsvpId === _vm.rsvp.id),expression:"loadingRsvpId === rsvp.id"}],staticClass:"fas fa-spinner fa-spin fa-fw"})])]),_vm._v(" "),_c('td',{staticClass:"package-icon no-padding rc-3"},[(_vm.rsvp.isPackage)?_c('i',{staticClass:"fas fa-cube fa-fw fa-lg"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tool-tip-box"},[(_vm.rsvp.hasExtraStop)?_c('i',{staticClass:"fas fa-route fa-fw fa-lg"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v("With extra stop")])]),_vm._v(" "),_c('div',{staticClass:"tool-tip-box"},[(_vm.rsvp.isOptinShared)?_c('img',{staticClass:"optin-icon",attrs:{"src":__webpack_require__(152)}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Opted in to a shared service")])])]),_vm._v(" "),_c('td',{staticClass:"bold rc-4"},[(!_vm.rsvp.isPackage)?_c('a',{attrs:{"href":'/#/reservation/' + _vm.rsvp.id,"target":"_blank"}},[_vm._v(_vm._s(_vm.rsvp.id))]):_c('a',{attrs:{"href":'/#/package/' + _vm.rsvp.id,"target":"_blank"}},[_vm._v(_vm._s(_vm.rsvp.id))])]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink),expression:"!shrink"}],staticClass:"rc-5"},[(_vm.rsvp.pendingOffer && _vm.rsvp.pendingOffer.show)?_c('div',[_c('span',{staticClass:"status pending-offer"},[_vm._v("Pending Offer")]),_vm._v(" "),(_vm.checkingDriver)?_c('i',{staticClass:"fas fa-spinner fa-spin"}):_c('b',{staticClass:"timer"},[_vm._v(_vm._s(_vm.timer)+"s")])]):_c('div',[_c('span',{class:['status', _vm.rsvp.statusClass, _vm.resStatus(_vm.rsvp)]},[_vm._v(_vm._s(_vm.rsvp.status))]),_vm._v(" "),(_vm.acceptedRTGStatus(_vm.rsvp.status) && !_vm.rsvp.isPackage && _vm.rsvp.pickup.geofenceType === 'airport' && !_vm.rsvp.isMtech)?_c('span',{staticClass:"rtg",on:{"click":function($event){return _vm.showRTG(_vm.rsvp.id)}}},[_vm._v("RTG")]):_vm._e(),_vm._v(" "),(_vm.rsvp.notes != null && _vm.rsvp.notes.length)?_c('span',{staticClass:"notes",on:{"click":function($event){return _vm.showNotes(_vm.rsvp.notes)}}},[_c('i',{staticClass:"fas fa-sticky-note"}),_vm._v(" NOTES")]):_vm._e()])]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink),expression:"!shrink"}],staticClass:"rc-6"},[_vm._v(_vm._s(_vm.rsvp.pickupTime))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink),expression:"!shrink"}],staticClass:"rc-7"},[_vm._v(_vm._s(_vm.getAddress(_vm.rsvp.pickup)))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink),expression:"!shrink"}],staticClass:"rc-8"},[(_vm.rsvp.isCharter)?_c('span',[_vm._v("--")]):_c('span',[_vm._v("\n      "+_vm._s(_vm.rsvp.dropoffTime)),_c('br'),_vm._v(" "),(!!_vm.rsvp.hoursLeft)?_c('b',[_vm._v("("+_vm._s(_vm.rsvp.hoursLeft)+")")]):_vm._e()])]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink),expression:"!shrink"}],staticClass:"rc-8"},[(_vm.rsvp.isCharter)?_c('span',[_vm._v("--")]):_c('span',[_vm._v(_vm._s(_vm.getAddress(_vm.rsvp.dropoff)))])]),_vm._v(" "),(!_vm.isShort && !_vm.shrink)?_c('td',{staticClass:"bold rc-9"},[(!_vm.rsvp.isPackage)?_c('div',[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvp.guest !== null),expression:"rsvp.guest !== null"}],staticClass:"fas fa-address-card fa-lg fa-fw"}),_vm._v(" "),_c('a',{attrs:{"href":'/#/consumer/' + _vm.rsvp.customer.id,"target":"_blank"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvp.guest !== null),expression:"rsvp.guest !== null"}]},[_vm._v(" "+_vm._s(_vm.getName(_vm.rsvp.guest))+" ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvp.guest === null),expression:"rsvp.guest === null"}]},[_vm._v(_vm._s(_vm.getName(_vm.rsvp.customer)))])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.rsvp.guest === null)?_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.callPhone(_vm.rsvp.customer)}}},[_vm._v("\n        "+_vm._s(_vm.rsvp.customer.phone)+"\n      ")]):_c('span',[(_vm.rsvp.guest !== null && _vm.rsvp.guest.phone !== '')?_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.callPhone(_vm.rsvp.guest)}}},[_vm._v("\n          "+_vm._s(_vm.rsvp.guest.phone)+"\n        ")]):_vm._e()])]):_c('div',[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvp.legs[0].guest !== null),expression:"rsvp.legs[0].guest !== null"}],staticClass:"fas fa-address-card fa-fw fa-lg"}),_vm._v(" "),_c('a',{attrs:{"href":'/#/consumer/' + _vm.rsvp.legs[0].customer.id,"target":"_blank"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvp.legs[0].guest !== null),expression:"rsvp.legs[0].guest !== null"}]},[_vm._v(" "+_vm._s(_vm.getName(_vm.rsvp.legs[0].guest))+" ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvp.legs[0].guest === null),expression:"rsvp.legs[0].guest === null"}]},[_vm._v(_vm._s(_vm.getName(_vm.rsvp.legs[0].customer)))])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.rsvp.legs[0].guest === null)?_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.callPhone(_vm.rsvp.legs[0].customer)}}},[_vm._v("\n        "+_vm._s(_vm.rsvp.legs[0].customer.phone)+"\n      ")]):_c('span',[(_vm.rsvp.legs[0].guest !== null && _vm.rsvp.legs[0].guest.phone !== '')?_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.callPhone(_vm.rsvp.legs[0].guest)}}},[_vm._v("\n          "+_vm._s(_vm.rsvp.legs[0].guest.phone)+"\n        ")]):_vm._e()])])]):_vm._e(),_vm._v(" "),(!_vm.isShort && !_vm.shrink)?_c('td',{staticClass:"rc-10"},[(_vm.rsvp.isPackage)?_c('span',[_vm._v("$"+_vm._s((_vm.rsvp.fare + _vm.rsvp.airportFee).toFixed(2)))]):_c('span',[_vm._v("$"+_vm._s(_vm.rsvp.fare.toFixed(2)))])]):_vm._e(),_vm._v(" "),(!_vm.isShort && !_vm.shrink)?_c('td',{staticClass:"bold rc-11"},[(_vm.rsvp.driver !== null)?_c('a',{attrs:{"href":'/#/provider/' + _vm.rsvp.driver.id,"target":"_blank"}},[_vm._v("\n      "+_vm._s(_vm.getName(_vm.rsvp.driver))+"\n    ")]):_c('span',[_vm._v("N/A")])]):_vm._e(),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink && _vm.showDriverPayment),expression:"!shrink && showDriverPayment"}],staticClass:"rc-12"},[_vm._v("\n    $"+_vm._s((_vm.rsvp.driverPayment.base + _vm.rsvp.driverPayment.bonus + _vm.rsvp.driverPayment.tip + _vm.rsvp.driverPayment.gasFee + _vm.rsvp.driverPayment.pickupFee).toFixed(2))+"\n  ")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink),expression:"!shrink"}],staticClass:"rc-13"},[(_vm.useOldQuatation)?_c('span',{class:'service-type ' + _vm.rsvp.serviceClass},[_vm._v(_vm._s(_vm.rsvp.serviceLabel))]):_c('span',{staticClass:"service-type",style:({background: _vm.rsvp.serviceType.color})},[_vm._v(_vm._s(_vm.rsvp.serviceType.label))])]),_vm._v(" "),(!_vm.isShort && !_vm.shrink)?_c('td',{staticClass:"rc-14"},[(_vm.rsvp.pickup.geofenceType === 'airport')?_c('div',[(_vm.rsvp.meetAndGreet)?_c('span',[_vm._v("Meet & Greet")]):_c('span',[_vm._v("Curbside")])]):_c('span',[_vm._v("N/A")])]):_vm._e(),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink),expression:"!shrink"}],staticClass:"image rc-15"},[(_vm.rsvp.pickup.geofenceType === 'airport' && _vm.rsvp.flight)?_c('img',{attrs:{"src":"/assets/img/arrival.png"}}):_vm._e(),_vm._v(" "),(_vm.rsvp.dropoff.geofenceType === 'airport' && _vm.rsvp.flight)?_c('img',{attrs:{"src":"/assets/img/departure.png"}}):_vm._e()]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink),expression:"!shrink"}],staticClass:"bold rc-16"},[(_vm.rsvp.flight !== null)?_c('span',[(_vm.rsvp.statusClass !== 'complete' && _vm.rsvp.statusClass !== 'completed' && _vm.rsvp.statusClass !== 'canceled')?_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.showFlightInfo}},[_vm._v("\n      "+_vm._s(_vm.rsvp.flight)+"\n      ")]):_c('span',[_vm._v(_vm._s(_vm.rsvp.flight))])]):_c('span',[_vm._v("N/A")]),_vm._v(" "),(_vm.flightStatus !== null)?_c('span',{class:'flight-status ' + _vm.flightStatus.class},[_vm._v(_vm._s(_vm.flightStatus.label))]):_vm._e()]),_vm._v(" "),(!_vm.isShort && !_vm.shrink)?_c('td',{staticClass:"rc-17"},[(_vm.rsvp.ada === null || (_vm.rsvp.ada.serviceDog === 0 && _vm.rsvp.ada.wheelChairLift === 0))?_c('div',[_vm._v("N/A")]):_c('div',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvp.ada.serviceDog === 1),expression:"rsvp.ada.serviceDog === 1"}]},[_c('svg-dog')],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvp.ada.wheelChairLift === 1),expression:"rsvp.ada.wheelChairLift === 1"}]},[_c('svg-wheelchair')],1)])]):_vm._e(),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink),expression:"!shrink"}],staticClass:"rc-18"},[_vm._v(_vm._s(_vm.rsvp.pax))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink),expression:"!shrink"}],staticClass:"rc-19"},[_vm._v(_vm._s(_vm.rsvp.luggage)+"/"+_vm._s(_vm.rsvp.stops))])]):_c('div',{staticClass:"table-card"},[_c('div',{staticClass:"row-1"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedReservations),expression:"checkedReservations"}],attrs:{"type":"checkbox"},domProps:{"value":{id: _vm.rsvp.id, isPackage: _vm.rsvp.isPackage, status: _vm.rsvp.statusClass},"checked":Array.isArray(_vm.checkedReservations)?_vm._i(_vm.checkedReservations,{id: _vm.rsvp.id, isPackage: _vm.rsvp.isPackage, status: _vm.rsvp.statusClass})>-1:(_vm.checkedReservations)},on:{"change":function($event){var $$a=_vm.checkedReservations,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v={id: _vm.rsvp.id, isPackage: _vm.rsvp.isPackage, status: _vm.rsvp.statusClass},$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedReservations=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedReservations=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedReservations=$$c}}}}),_vm._v(" "),(_vm.rsvp.isPackage)?_c('i',{staticClass:"fas fa-cube fa-fw fa-lg"}):_vm._e(),_vm._v(" "),(!_vm.rsvp.isPackage)?_c('a',{attrs:{"href":'/#/reservation/' + _vm.rsvp.id,"target":"_blank"}},[_vm._v(_vm._s(_vm.rsvp.id))]):_c('a',{attrs:{"href":'/#/package/' + _vm.rsvp.id,"target":"_blank"}},[_vm._v(_vm._s(_vm.rsvp.id))]),_vm._v(" "),_c('span',{class:'status ' + _vm.rsvp.statusClass + ' ' + _vm.resStatus(_vm.rsvp)},[_vm._v(_vm._s(_vm.rsvp.status))])]),_vm._v(" "),_c('div',{staticClass:"map-button"},[_c('a',{class:{
         disabled: _vm.loadingRsvpId !== null,
         selected: _vm.rsvpInMap.id === _vm.rsvp.id
       },attrs:{"href":"javascript:;"},on:{"click":_vm.showOnMap}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingRsvpId !== _vm.rsvp.id),expression:"loadingRsvpId !== rsvp.id"}],staticClass:"fas fa-map-marker-alt"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingRsvpId === _vm.rsvp.id),expression:"loadingRsvpId === rsvp.id"}],staticClass:"fas fa-spinner fa-spin fa-fw"})])])]),_vm._v(" "),_c('div',{staticClass:"row-2"},[_c('div',[(_vm.useOldQuatation)?_c('span',{class:'service-type ' + _vm.rsvp.serviceClass},[_vm._v(_vm._s(_vm.rsvp.serviceLabel))]):_c('span',{staticClass:"service-type",style:({background: _vm.rsvp.serviceType.color})},[_vm._v(_vm._s(_vm.rsvp.serviceType.label))])]),_vm._v(" "),_c('div',{staticClass:"image"},[(_vm.rsvp.pickup.geofenceType === 'airport' && _vm.rsvp.flight)?_c('img',{attrs:{"src":"/assets/img/arrival.png"}}):_vm._e(),_vm._v(" "),(_vm.rsvp.dropoff.geofenceType === 'airport' && _vm.rsvp.flight)?_c('img',{attrs:{"src":"/assets/img/departure.png"}}):_vm._e()]),_vm._v(" "),_c('div',[(_vm.rsvp.flight !== null)?_c('span',[(_vm.rsvp.statusClass !== 'complete' && _vm.rsvp.statusClass !== 'completed' && _vm.rsvp.statusClass !== 'canceled')?_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.showFlightInfo}},[_vm._v("\n        "+_vm._s(_vm.rsvp.flight)+"\n        ")]):_c('span',[_vm._v(_vm._s(_vm.rsvp.flight))])]):_c('span',[_vm._v("N/A")]),_vm._v(" "),(_vm.flightStatus !== null)?_c('span',{class:'flight-status ' + _vm.flightStatus.class},[_vm._v(_vm._s(_vm.flightStatus.label))]):_vm._e()])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Pickup Time: "+_vm._s(_vm.rsvp.pickupTime))])]),_vm._v(" "),_c('div',{staticClass:"row-4"},[_c('div',{staticClass:"pickup"},[_c('i',{staticClass:"fas fa-map-marker-alt icon"}),_vm._v("\n      "+_vm._s(_vm.getAddress(_vm.rsvp.pickup))+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"row-5"},[_c('div',{staticClass:"dropoff"},[_c('i',{staticClass:"fas fa-location-arrow icon"}),_vm._v(" "),(_vm.rsvp.isCharter)?_c('span',[_vm._v("--")]):_c('span',[_vm._v(_vm._s(_vm.getAddress(_vm.rsvp.dropoff)))])])]),_vm._v(" "),_c('div',{staticClass:"row-3"},[_c('div',{staticClass:"clock"},[_vm._v("\n      Dropoff Time:\n      "+_vm._s(_vm.rsvp.dropoffTime)+"\n      "),(!!_vm.rsvp.hoursLeft)?_c('b',[_vm._v("("+_vm._s(_vm.rsvp.hoursLeft)+")")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"toggle-div"},[_c('div',{staticClass:"row-7"},[(!_vm.isCollapsible)?_c('div',[_c('span',[_c('i',{staticClass:"fas fa-user-friends icon"}),_vm._v(_vm._s(_vm.rsvp.pax))]),_vm._v(" "),_c('span',[_c('i',{staticClass:"fas fa-suitcase icon"}),_vm._v(_vm._s(_vm.rsvp.luggage))]),_vm._v(" "),_c('span',[_c('i',{staticClass:"fas fa-hourglass-end icon"}),_vm._v(_vm._s(_vm.rsvp.stops))]),_vm._v(" "),_c('div',{staticClass:"actions"},[(_vm.acceptedRTGStatus(_vm.rsvp.status) && !_vm.rsvp.isPackage && _vm.rsvp.pickup.geofenceType === 'airport')?_c('span',{staticClass:"rtg",on:{"click":function($event){return _vm.showRTG(_vm.rsvp.id)}}},[_vm._v("RTG")]):_vm._e(),_vm._v(" "),(_vm.rsvp.notes != null && _vm.rsvp.notes.length > 0)?_c('span',{staticClass:"notes",on:{"click":function($event){return _vm.showNotes(_vm.rsvp.notes)}}},[_c('i',{staticClass:"fas fa-sticky-note"}),_vm._v(" NOTES")]):_vm._e()])]):_c('div',[_c('div',[_vm._v("Pax: "),_c('strong',[_vm._v(_vm._s(_vm.rsvp.pax))])]),_vm._v(" "),_c('div',[_vm._v("Luggage: "),_c('strong',[_vm._v(_vm._s(_vm.rsvp.luggage))])]),_vm._v(" "),_c('div',[_vm._v("Stops: "),_c('strong',[_vm._v(_vm._s(_vm.rsvp.stops))])])])]),_vm._v(" "),_c('div',{staticClass:"toggle",on:{"click":function($event){_vm.isCollapsible = !_vm.isCollapsible}}},[(!_vm.isCollapsible)?_c('span',[_c('i',{staticClass:"fas fa-plus-circle"})]):_c('span',[_c('i',{staticClass:"fas fa-minus-circle"})])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCollapsible),expression:"isCollapsible"}],staticClass:"see-more"},[_c('div',[(!_vm.rsvp.isPackage)?_c('div',[_vm._v("\n          Customer Name:\n          "),_c('strong',[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvp.guest !== null),expression:"rsvp.guest !== null"}],staticClass:"fas fa-address-card fa-lg fa-fw"}),_vm._v(" "),_c('a',{attrs:{"href":'/#/consumer/' + _vm.rsvp.customer.id,"target":"_blank"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvp.guest !== null),expression:"rsvp.guest !== null"}]},[_vm._v(" "+_vm._s(_vm.getName(_vm.rsvp.guest))+" ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvp.guest === null),expression:"rsvp.guest === null"}]},[_vm._v(_vm._s(_vm.getName(_vm.rsvp.customer)))])])]),_vm._v(" "),_c('br'),_vm._v("\n          Customer Phone:\n          "),(_vm.rsvp.guest === null)?_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.callPhone(_vm.rsvp.customer)}}},[_vm._v("\n            "+_vm._s(_vm.rsvp.customer.phone)+"\n          ")]):_c('span',[(_vm.rsvp.guest !== null && _vm.rsvp.guest.phone !== '')?_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.callPhone(_vm.rsvp.guest)}}},[_vm._v("\n              "+_vm._s(_vm.rsvp.guest.phone)+"\n            ")]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('div',[_vm._v("\n        Fare Amount: "),_c('strong',[(_vm.rsvp.isPackage)?_c('span',[_vm._v("$"+_vm._s((_vm.rsvp.fare + _vm.rsvp.airportFee).toFixed(2)))]):_c('span',[_vm._v("$"+_vm._s(_vm.rsvp.fare.toFixed(2)))])])]),_vm._v(" "),_c('div',[_vm._v("\n        Driver: "),_c('strong',[(_vm.rsvp.driver !== null)?_c('a',{attrs:{"href":'/#/provider/' + _vm.rsvp.driver.id,"target":"_blank"}},[_vm._v("\n            "+_vm._s(_vm.getName(_vm.rsvp.driver))+"\n          ")]):_c('span',[_vm._v("N/A")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDriverPayment),expression:"showDriverPayment"}],staticClass:"row-6"},[_c('span',[_vm._v("\n        Driver Payment: "),_c('b',[_vm._v("$"+_vm._s((_vm.rsvp.driverPayment.base +
              _vm.rsvp.driverPayment.bonus +
              _vm.rsvp.driverPayment.tip +
              _vm.rsvp.driverPayment.pickupFee).toFixed(2)))])])]),_vm._v(" "),_c('div',[_vm._v("\n        Pickup Type: "),_c('strong',[(_vm.rsvp.pickup.geofenceType === 'airport')?_c('div',[(_vm.rsvp.meetAndGreet)?_c('span',[_vm._v("Meet & Greet")]):_c('span',[_vm._v("Curbside")])]):_c('span',[_vm._v("N/A")])])]),_vm._v(" "),_c('div',[_vm._v("\n        ADA: "),_c('strong',[(_vm.rsvp.ada === null || (_vm.rsvp.ada.serviceDog === 0 && _vm.rsvp.ada.wheelChairLift === 0))?_c('span',[_vm._v("N/A")]):_c('span',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvp.ada.serviceDog === 1),expression:"rsvp.ada.serviceDog === 1"}],staticClass:"svg-icon"},[_c('svg-dog')],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvp.ada.wheelChairLift === 1),expression:"rsvp.ada.wheelChairLift === 1"}],staticClass:"svg-icon"},[_c('svg-wheelchair')],1)])])]),_vm._v(" "),_c('div',{staticClass:"row-8"},[_c('div',{staticClass:"actions"},[(_vm.acceptedRTGStatus(_vm.rsvp.status) && !_vm.rsvp.isPackage && _vm.rsvp.pickup.geofenceType === 'airport')?_c('span',{staticClass:"rtg",on:{"click":function($event){return _vm.showRTG(_vm.rsvp.id)}}},[_vm._v("RTG")]):_vm._e(),_vm._v(" "),(_vm.rsvp.notes != null && _vm.rsvp.notes.length > 0)?_c('span',{staticClass:"notes",on:{"click":function($event){return _vm.showNotes(_vm.rsvp.notes)}}},[_c('i',{staticClass:"fas fa-sticky-note"}),_vm._v(" NOTES")]):_vm._e()])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationNewBooking_vue__ = __webpack_require__(455);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff236c5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationNewBooking_vue__ = __webpack_require__(1286);
function injectStyle (ssrContext) {
  __webpack_require__(1284)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ff236c5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationNewBooking_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff236c5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationNewBooking_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1285);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("6b854ff9", content, true, {});

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.notification[data-v-ff236c5e] {\n  background-color: #e2f0ff;\n  display: block;\n  color: #0D79F2;\n  border: 1px solid #0D79F2;\n  padding: 15px;\n  font-size: 14px;\n  font-weight: 700;\n  text-transform: uppercase;\n  text-align: center;\n  cursor: pointer;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  height: 51px;\n  overflow: hidden;\n  border-left: 0;\n  border-right: 0;\n}\n.notification.hide[data-v-ff236c5e] {\n    height: 0;\n    padding: 0 15px;\n    border: 0;\n}\n.notification.disabled[data-v-ff236c5e] {\n    pointer-events: none;\n    opacity: 0.5;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/NotificationNewBooking.vue"],"names":[],"mappings":";AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;CACjB;AACD;IACI,UAAU;IACV,gBAAgB;IAChB,UAAU;CACb;AACD;IACI,qBAAqB;IACrB,aAAa;CAChB","file":"NotificationNewBooking.vue","sourcesContent":["\n.notification[data-v-ff236c5e] {\n  background-color: #e2f0ff;\n  display: block;\n  color: #0D79F2;\n  border: 1px solid #0D79F2;\n  padding: 15px;\n  font-size: 14px;\n  font-weight: 700;\n  text-transform: uppercase;\n  text-align: center;\n  cursor: pointer;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  height: 51px;\n  overflow: hidden;\n  border-left: 0;\n  border-right: 0;\n}\n.notification.hide[data-v-ff236c5e] {\n    height: 0;\n    padding: 0 15px;\n    border: 0;\n}\n.notification.disabled[data-v-ff236c5e] {\n    pointer-events: none;\n    opacity: 0.5;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    notification: true,
    hide: !_vm.notification.show,
    disabled: _vm.notification.isLoading
  },on:{"click":_vm.loadData}},[_c('i',{class:{ 'fas fa-sync': true, 'fa-spin': _vm.notification.isLoading }}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.notification.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"reservations-table-container"},[_c('notification-new-booking'),_vm._v(" "),(_vm.itemsToShow.length > 0 && !_vm.isFetchingData)?_c('div',{staticClass:"reservations-table-wrapper"},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scrollLoading),expression:"scrollLoading"}],staticClass:"infinity-loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" Loading\n        ")])]),_vm._v(" "),_c('table',{class:{'has-paging':_vm.totalPages > 1, 'shrink':_vm.shrink},attrs:{"id":"rsvp-table-container"},on:{"scroll":_vm.onScroll}},[_c('thead',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile),expression:"!isMobile"}]},[_c('tr',{staticClass:"table-header"},[_c('th',{staticClass:"rc-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedAll),expression:"checkedAll"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkedAll)?_vm._i(_vm.checkedAll,null)>-1:(_vm.checkedAll)},on:{"change":function($event){var $$a=_vm.checkedAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedAll=$$c}}}})]),_vm._v(" "),_c('th',{staticClass:"rc-2"}),_vm._v(" "),_c('th',{staticClass:"rc-3"}),_vm._v(" "),_c('th',{class:'sortable rc-4' + (_vm.isSorting ? ' disabled' : ''),on:{"click":function($event){return _vm.sort('r.ID')}}},[_c('span',[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.id')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.order === 'r.ID'),expression:"rsvpSort.order === 'r.ID'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.asc && !_vm.isSorting),expression:"rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.rsvpSort.asc && !_vm.isSorting),expression:"!rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('th',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink),expression:"!shrink"}],class:'sortable rc-5' + (_vm.isSorting ? ' disabled' : ''),on:{"click":function($event){return _vm.sort('cb.status')}}},[_c('span',[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.status')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.order === 'cb.status'),expression:"rsvpSort.order === 'cb.status'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.asc && !_vm.isSorting),expression:"rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.rsvpSort.asc && !_vm.isSorting),expression:"!rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('th',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink),expression:"!shrink"}],class:'sortable rc-6' + (_vm.isSorting ? ' disabled' : ''),on:{"click":function($event){return _vm.sort('cb.pickupTime')}}},[_c('span',[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.pickupTime')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.order === 'cb.pickupTime'),expression:"rsvpSort.order === 'cb.pickupTime'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.asc && !_vm.isSorting),expression:"rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.rsvpSort.asc && !_vm.isSorting),expression:"!rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('th',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink),expression:"!shrink"}],staticClass:"rc-7"},[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.pickup')))]),_vm._v(" "),_c('th',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink),expression:"!shrink"}],staticClass:"rc-7-2"},[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.dropoffTime')))]),_vm._v(" "),_c('th',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink),expression:"!shrink"}],staticClass:"rc-8"},[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.dropoff')))]),_vm._v(" "),(!_vm.isShort && !_vm.shrink)?_c('th',{class:'rc-9' + (_vm.isSorting ? ' disabled' : '')},[_c('span',[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.customer')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.order === 'CfirstName'),expression:"rsvpSort.order === 'CfirstName'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.asc && !_vm.isSorting),expression:"rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.rsvpSort.asc && !_vm.isSorting),expression:"!rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]):_vm._e(),_vm._v(" "),(!_vm.isShort && !_vm.shrink)?_c('th',{staticClass:"rc-10"},[_vm._v("FARE"),_c('br'),_vm._v("AMOUNT")]):_vm._e(),_vm._v(" "),(!_vm.isShort && !_vm.shrink)?_c('th',{class:'sortable rc-11' + (_vm.isSorting ? ' disabled' : ''),on:{"click":function($event){return _vm.sort('PfirstName')}}},[_c('span',[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.driver')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.order === 'PfirstName'),expression:"rsvpSort.order === 'PfirstName'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.asc && !_vm.isSorting),expression:"rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.rsvpSort.asc && !_vm.isSorting),expression:"!rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]):_vm._e(),_vm._v(" "),_c('th',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink && _vm.showDriverPayment),expression:"!shrink && showDriverPayment"}],staticClass:"rc-12"},[_vm._v("DRIVER"),_c('br'),_vm._v("PAYMENT")]),_vm._v(" "),_c('th',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink),expression:"!shrink"}],class:'sortable rc-13' + (_vm.isSorting ? ' disabled' : ''),on:{"click":function($event){return _vm.sort('st.name')}}},[_c('span',[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.serviceType')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.order === 'st.name'),expression:"rsvpSort.order === 'st.name'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.asc && !_vm.isSorting),expression:"rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.rsvpSort.asc && !_vm.isSorting),expression:"!rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),(!_vm.isShort && !_vm.shrink)?_c('th',{staticClass:"rc-14"},[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.pickupType')))]):_vm._e(),_vm._v(" "),_c('th',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink),expression:"!shrink"}],staticClass:"rc-15"}),_vm._v(" "),_c('th',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink),expression:"!shrink"}],staticClass:"rc-16"},[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.flight')))]),_vm._v(" "),(!_vm.isShort && !_vm.shrink)?_c('th',{staticClass:"rc-17"},[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.ada')))]):_vm._e(),_vm._v(" "),_c('th',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink),expression:"!shrink"}],class:'sortable rc-18' + (_vm.isSorting ? ' disabled' : ''),on:{"click":function($event){return _vm.sort('cb.passengers')}}},[_c('span',[_vm._v("PAX")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.order === 'cb.passengers'),expression:"rsvpSort.order === 'cb.passengers'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.asc && !_vm.isSorting),expression:"rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.rsvpSort.asc && !_vm.isSorting),expression:"!rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('th',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink),expression:"!shrink"}],class:'sortable rc-19' + (_vm.isSorting ? ' disabled' : ''),on:{"click":function($event){return _vm.sort('cb.luggage')}}},[_vm._m(0),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.order === 'cb.luggage'),expression:"rsvpSort.order === 'cb.luggage'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.asc && !_vm.isSorting),expression:"rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.rsvpSort.asc && !_vm.isSorting),expression:"!rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])])])]),_vm._v(" "),_c('tbody',[(_vm.isPageLoading)?_c('tr',{staticClass:"tr-loader"},[_c('td',{attrs:{"colspan":[_vm.shrink ? '4' : '19']}},[_c('div',{staticClass:"table-loader"},[_c('ellipsis-loader'),_vm._v(" "),_c('div',{staticClass:"loader-title"},[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.loadingData.title')))])],1)])]):_vm._e(),_vm._v(" "),_vm._l((_vm.itemsToShow),function(rsvp,index){return (!_vm.isPageLoading)?_c('reservation-row',{key:index,attrs:{"rsvp":rsvp,"isShort":_vm.isShort,"shrink":_vm.shrink,"isMobile":_vm.isMobile}}):_vm._e()})],2)]),_vm._v(" "),_c('div',{attrs:{"id":"rsvp-div"},on:{"scroll":_vm.onScroll}},_vm._l((_vm.itemsToShow),function(rsvp,index){return (!_vm.isPageLoading)?_c('div',{key:index},[_vm._v("\n         "+_vm._s(rsvp.id)+"\n        ")]):_vm._e()}),0)],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.itemsToShow.length <= 0 && !_vm.isFetchingData),expression:"itemsToShow.length <= 0 && !isFetchingData"}],staticClass:"empty-reservations"},[_c('arrow-up'),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.emptyData.title))]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.emptyData.content))])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFetchingData),expression:"isFetchingData"}],staticClass:"table-loader"},[_c('ellipsis-loader'),_vm._v(" "),_c('div',{staticClass:"loader-title"},[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.loadingData.title')))]),_vm._v(" "),_c('div',{staticClass:"loader-text"},[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.loadingData.content')))])],1)],1),_vm._v(" "),_c('reservation-controls',{attrs:{"shrink":_vm.shrink}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("LUGGAGE/"),_c('br'),_vm._v("STOPS")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1289);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5a953328", content, true, {});

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.select-input[data-v-3126d038] {\n  position: relative;\n}\n.select-input i[data-v-3126d038] {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    color: #aaa;\n}\nselect[data-v-3126d038] {\n  height: 50px;\n  line-height: 50px;\n  border-radius: 0;\n  outline: 0;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  border: 0;\n  background-color: #fff;\n  padding: 0 20px 0 15px;\n  border-right: 1px solid rgba(0, 0, 0, 0.3);\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Partials/ReservationFilter.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,YAAY;CACf;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;KACtB,sBAAsB;UACjB,iBAAiB;EACzB,UAAU;EACV,uBAAuB;EACvB,uBAAuB;EACvB,2CAA2C;CAC5C","file":"ReservationFilter.vue","sourcesContent":["\n.select-input[data-v-3126d038] {\n  position: relative;\n}\n.select-input i[data-v-3126d038] {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    color: #aaa;\n}\nselect[data-v-3126d038] {\n  height: 50px;\n  line-height: 50px;\n  border-radius: 0;\n  outline: 0;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  border: 0;\n  background-color: #fff;\n  padding: 0 20px 0 15px;\n  border-right: 1px solid rgba(0, 0, 0, 0.3);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-input"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedFilter),expression:"selectedFilter"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedFilter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.filterRsvp]}},[_c('option',{attrs:{"value":"-1","selected":""}},[_vm._v(_vm._s(_vm.$t('dispatch.filterPlaceholder')))]),_vm._v(" "),_vm._l((_vm.filters),function(filter,index){return _c('option',{domProps:{"value":index}},[_vm._v("\n      "+_vm._s(filter.name)+"\n    ")])}),_vm._v(" "),(_vm.addCustom)?_c('option',{attrs:{"value":"custom"}},[_vm._v("Custom")]):_vm._e()],2),_vm._v(" "),_c('i',{staticClass:"fas fa-caret-down"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1292);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("60c61ccf", content, true, {});

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\nform[data-v-4eee6771] {\n  display: block;\n}\ninput[data-v-4eee6771] {\n  margin: 0;\n  border-radius: 0;\n  padding: 0 15px;\n  height: 50px;\n  line-height: 50px;\n  border-top: 0;\n  border-bottom: 0;\n  border-color: rgba(0, 0, 0, 0.3);\n}\n.search-input[data-v-4eee6771] {\n  position: relative;\n}\n.search-input a[data-v-4eee6771] {\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 50px;\n    line-height: 50px;\n    color: #777;\n    width: 50px;\n    text-align: center;\n}\n.search-input a i[data-v-4eee6771] {\n      line-height: inherit;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Partials/ReservationSearch.vue"],"names":[],"mappings":";AACA;EACE,eAAe;CAChB;AACD;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,iCAAiC;CAClC;AACD;EACE,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,mBAAmB;CACtB;AACD;MACM,qBAAqB;CAC1B","file":"ReservationSearch.vue","sourcesContent":["\nform[data-v-4eee6771] {\n  display: block;\n}\ninput[data-v-4eee6771] {\n  margin: 0;\n  border-radius: 0;\n  padding: 0 15px;\n  height: 50px;\n  line-height: 50px;\n  border-top: 0;\n  border-bottom: 0;\n  border-color: rgba(0, 0, 0, 0.3);\n}\n.search-input[data-v-4eee6771] {\n  position: relative;\n}\n.search-input a[data-v-4eee6771] {\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 50px;\n    line-height: 50px;\n    color: #777;\n    width: 50px;\n    text-align: center;\n}\n.search-input a i[data-v-4eee6771] {\n      line-height: inherit;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitSearch.apply(null, arguments)}}},[_c('div',{staticClass:"search-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],attrs:{"type":"text","placeholder":_vm.$t('dispatch.rsvpSearchPlaceholder')},domProps:{"value":(_vm.searchInput)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchInput !== ''),expression:"searchInput !== ''"}],attrs:{"href":"javascript:;"},on:{"click":_vm.clearSearch}},[_c('i',{staticClass:"far fa-times-circle fa-lg fa-fw"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1295);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("bb5d9512", content, true, {});

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.clear[data-v-40480ee0] {\n  clear: both;\n}\n.more-filter[data-v-40480ee0] {\n  position: absolute;\n  top: 51px;\n  left: 0;\n  width: 100%;\n  height: calc(100vh - 50px);\n  background: #eaf1f3;\n  padding: 20px 15px;\n  border-bottom: 1px solid #aaa;\n  border-right: 1px solid #aaa;\n  -webkit-box-shadow: -3px 1px 3px rgba(0, 0, 0, 0.2);\n          box-shadow: -3px 1px 3px rgba(0, 0, 0, 0.2);\n  overflow: auto;\n}\n.more-filter .col-field[data-v-40480ee0], .more-filter .col-btn[data-v-40480ee0] {\n    padding: 0 10px;\n}\n.more-filter .col-field[data-v-40480ee0] {\n    margin-bottom: 10px;\n}\n.more-filter .col-btn[data-v-40480ee0] {\n    margin-top: 10px;\n}\n.more-filter.shrink[data-v-40480ee0] {\n    height: calc(100vh - 50px);\n}\n.more-filter.shrink .datepicker-box[data-v-40480ee0] {\n      margin-bottom: 5px;\n}\n.more-filter.shrink .button[data-v-40480ee0] {\n      margin-bottom: 5px;\n}\n.row[data-v-40480ee0] {\n  max-width: 100%;\n  margin-bottom: 20px;\n}\n.row[data-v-40480ee0]:last-child {\n  margin-bottom: 10px;\n}\n.column.padded[data-v-40480ee0] {\n  padding-right: 10px;\n}\nlabel[data-v-40480ee0] {\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 2px;\n  display: block;\n  color: #555;\n}\n.datepicker-box[data-v-40480ee0] {\n  display: inline-block;\n  width: 100%;\n}\n.time-selector[data-v-40480ee0] {\n  padding: 5px 0;\n}\n.time-selector select[data-v-40480ee0] {\n    border-color: #ccc;\n    padding: 3px;\n}\n.shrink .time-selector[data-v-40480ee0] {\n  padding: 0 0 5px;\n}\n.clear-dates[data-v-40480ee0] {\n  margin-top: 3px;\n}\n.error-msg[data-v-40480ee0] {\n  width: 100%;\n  padding: 2px 5px;\n  font-size: 12px;\n  color: #f33a27;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.service[data-v-40480ee0] {\n  font-size: 14px;\n  margin-bottom: 3px;\n}\n.service *[data-v-40480ee0] {\n    cursor: pointer;\n}\n.service i[data-v-40480ee0] {\n    margin-right: 5px;\n    color: #5ec1ac;\n}\n.service i.far[data-v-40480ee0] {\n      color: #999;\n}\n.select-brand[data-v-40480ee0] {\n  float: left;\n  width: 3%;\n  color: #999;\n  cursor: pointer;\n}\n.select-brand i[data-v-40480ee0] {\n    padding: 6px 0;\n    margin-right: 5px;\n}\n.select-brand i.fa-check-square[data-v-40480ee0] {\n      color: #5ec1ac;\n}\n.brand[data-v-40480ee0] {\n  float: left;\n  width: 97%;\n}\n.select-all .brand[data-v-40480ee0] {\n  width: auto;\n}\n.select-all .brand label[data-v-40480ee0] {\n  cursor: pointer;\n  padding: 4px 0;\n  display: inline-block;\n}\n.services[data-v-40480ee0] {\n  clear: both;\n}\n.services .head[data-v-40480ee0] {\n    padding: 5px;\n    background: #5ec1ac;\n    color: #fff;\n    border: 1px solid #3d8374;\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n}\n.services .head i[data-v-40480ee0] {\n      margin-right: 5px;\n}\n.services .body[data-v-40480ee0] {\n    list-style: none;\n    margin: 0;\n    padding: 5px 0;\n    -webkit-column-count: 3;\n    -moz-column-count: 3;\n    column-count: 3;\n    -webkit-column-gap: 5px;\n       -moz-column-gap: 5px;\n            column-gap: 5px;\n    background: #fff;\n    border: 1px solid #3d8374;\n    max-height: 999px;\n}\n.services .body li[data-v-40480ee0] {\n      padding: 3px 10px;\n      font-size: 13px;\n      cursor: pointer;\n}\n.services .body li[data-v-40480ee0]:hover {\n        background: #f3f3f3;\n}\n.services .body li i[data-v-40480ee0] {\n        vertical-align: middle;\n        margin-right: 5px;\n}\n.services .body li i.fa-check-square[data-v-40480ee0] {\n          color: #5ec1ac;\n}\n.slide-up-enter-active[data-v-40480ee0], .slide-up-leave-active[data-v-40480ee0] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-40480ee0], .slide-up-leave-to[data-v-40480ee0] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.height-enter-active[data-v-40480ee0], .height-leave-active[data-v-40480ee0] {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.height-enter[data-v-40480ee0], .height-leave-to[data-v-40480ee0] {\n  max-height: 0;\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.header .more-filter[data-v-40480ee0] {\n    padding-bottom: 100px;\n}\nlabel[data-v-40480ee0] {\n    margin-bottom: 4px;\n}\n.column.padded[data-v-40480ee0] {\n    padding: 0;\n}\n.medium-6[data-v-40480ee0] {\n    width: 50%;\n    padding: 0 2px !important;\n}\n.medium-4[data-v-40480ee0] {\n    width: 33.3%;\n}\n.brand[data-v-40480ee0] {\n    width: 90%;\n    margin-left: 5%;\n    margin-bottom: 5px;\n}\n.services .body[data-v-40480ee0] {\n    -webkit-column-count: 2;\n       -moz-column-count: 2;\n            column-count: 2;\n}\n.services .body li[data-v-40480ee0] {\n      padding: 3px 5px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/MoreFilter.vue"],"names":[],"mappings":";AACA;EACE,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,oDAAoD;UAC5C,4CAA4C;EACpD,eAAe;CAChB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,2BAA2B;CAC9B;AACD;MACM,mBAAmB;CACxB;AACD;MACM,mBAAmB;CACxB;AACD;EACE,gBAAgB;EAChB,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,YAAY;CACb;AACD;EACE,sBAAsB;EACtB,YAAY;CACb;AACD;EACE,eAAe;CAChB;AACD;IACI,mBAAmB;IACnB,aAAa;CAChB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;EACE,gBAAgB;EAChB,mBAAmB;CACpB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,kBAAkB;IAClB,eAAe;CAClB;AACD;MACM,YAAY;CACjB;AACD;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,gBAAgB;CACjB;AACD;IACI,eAAe;IACf,kBAAkB;CACrB;AACD;MACM,eAAe;CACpB;AACD;EACE,YAAY;EACZ,WAAW;CACZ;AACD;EACE,YAAY;CACb;AACD;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;CACvB;AACD;EACE,YAAY;CACb;AACD;IACI,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;CACnB;AACD;MACM,kBAAkB;CACvB;AACD;IACI,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;IAChB,wBAAwB;OACrB,qBAAqB;YAChB,gBAAgB;IACxB,iBAAiB;IACjB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;MACM,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB;CACrB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,uBAAuB;QACvB,kBAAkB;CACzB;AACD;UACU,eAAe;CACxB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,cAAc;EACd,WAAW;CACZ;AACD;AACA;IACI,sBAAsB;CACzB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;IACX,0BAA0B;CAC7B;AACD;IACI,aAAa;CAChB;AACD;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;CACtB;AACD;IACI,wBAAwB;OACrB,qBAAqB;YAChB,gBAAgB;CAC3B;AACD;MACM,iBAAiB;CACtB;CACA","file":"MoreFilter.vue","sourcesContent":["\n.clear[data-v-40480ee0] {\n  clear: both;\n}\n.more-filter[data-v-40480ee0] {\n  position: absolute;\n  top: 51px;\n  left: 0;\n  width: 100%;\n  height: calc(100vh - 50px);\n  background: #eaf1f3;\n  padding: 20px 15px;\n  border-bottom: 1px solid #aaa;\n  border-right: 1px solid #aaa;\n  -webkit-box-shadow: -3px 1px 3px rgba(0, 0, 0, 0.2);\n          box-shadow: -3px 1px 3px rgba(0, 0, 0, 0.2);\n  overflow: auto;\n}\n.more-filter .col-field[data-v-40480ee0], .more-filter .col-btn[data-v-40480ee0] {\n    padding: 0 10px;\n}\n.more-filter .col-field[data-v-40480ee0] {\n    margin-bottom: 10px;\n}\n.more-filter .col-btn[data-v-40480ee0] {\n    margin-top: 10px;\n}\n.more-filter.shrink[data-v-40480ee0] {\n    height: calc(100vh - 50px);\n}\n.more-filter.shrink .datepicker-box[data-v-40480ee0] {\n      margin-bottom: 5px;\n}\n.more-filter.shrink .button[data-v-40480ee0] {\n      margin-bottom: 5px;\n}\n.row[data-v-40480ee0] {\n  max-width: 100%;\n  margin-bottom: 20px;\n}\n.row[data-v-40480ee0]:last-child {\n  margin-bottom: 10px;\n}\n.column.padded[data-v-40480ee0] {\n  padding-right: 10px;\n}\nlabel[data-v-40480ee0] {\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 2px;\n  display: block;\n  color: #555;\n}\n.datepicker-box[data-v-40480ee0] {\n  display: inline-block;\n  width: 100%;\n}\n.time-selector[data-v-40480ee0] {\n  padding: 5px 0;\n}\n.time-selector select[data-v-40480ee0] {\n    border-color: #ccc;\n    padding: 3px;\n}\n.shrink .time-selector[data-v-40480ee0] {\n  padding: 0 0 5px;\n}\n.clear-dates[data-v-40480ee0] {\n  margin-top: 3px;\n}\n.error-msg[data-v-40480ee0] {\n  width: 100%;\n  padding: 2px 5px;\n  font-size: 12px;\n  color: #f33a27;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.service[data-v-40480ee0] {\n  font-size: 14px;\n  margin-bottom: 3px;\n}\n.service *[data-v-40480ee0] {\n    cursor: pointer;\n}\n.service i[data-v-40480ee0] {\n    margin-right: 5px;\n    color: #5ec1ac;\n}\n.service i.far[data-v-40480ee0] {\n      color: #999;\n}\n.select-brand[data-v-40480ee0] {\n  float: left;\n  width: 3%;\n  color: #999;\n  cursor: pointer;\n}\n.select-brand i[data-v-40480ee0] {\n    padding: 6px 0;\n    margin-right: 5px;\n}\n.select-brand i.fa-check-square[data-v-40480ee0] {\n      color: #5ec1ac;\n}\n.brand[data-v-40480ee0] {\n  float: left;\n  width: 97%;\n}\n.select-all .brand[data-v-40480ee0] {\n  width: auto;\n}\n.select-all .brand label[data-v-40480ee0] {\n  cursor: pointer;\n  padding: 4px 0;\n  display: inline-block;\n}\n.services[data-v-40480ee0] {\n  clear: both;\n}\n.services .head[data-v-40480ee0] {\n    padding: 5px;\n    background: #5ec1ac;\n    color: #fff;\n    border: 1px solid #3d8374;\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n}\n.services .head i[data-v-40480ee0] {\n      margin-right: 5px;\n}\n.services .body[data-v-40480ee0] {\n    list-style: none;\n    margin: 0;\n    padding: 5px 0;\n    -webkit-column-count: 3;\n    -moz-column-count: 3;\n    column-count: 3;\n    -webkit-column-gap: 5px;\n       -moz-column-gap: 5px;\n            column-gap: 5px;\n    background: #fff;\n    border: 1px solid #3d8374;\n    max-height: 999px;\n}\n.services .body li[data-v-40480ee0] {\n      padding: 3px 10px;\n      font-size: 13px;\n      cursor: pointer;\n}\n.services .body li[data-v-40480ee0]:hover {\n        background: #f3f3f3;\n}\n.services .body li i[data-v-40480ee0] {\n        vertical-align: middle;\n        margin-right: 5px;\n}\n.services .body li i.fa-check-square[data-v-40480ee0] {\n          color: #5ec1ac;\n}\n.slide-up-enter-active[data-v-40480ee0], .slide-up-leave-active[data-v-40480ee0] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-40480ee0], .slide-up-leave-to[data-v-40480ee0] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.height-enter-active[data-v-40480ee0], .height-leave-active[data-v-40480ee0] {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.height-enter[data-v-40480ee0], .height-leave-to[data-v-40480ee0] {\n  max-height: 0;\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.header .more-filter[data-v-40480ee0] {\n    padding-bottom: 100px;\n}\nlabel[data-v-40480ee0] {\n    margin-bottom: 4px;\n}\n.column.padded[data-v-40480ee0] {\n    padding: 0;\n}\n.medium-6[data-v-40480ee0] {\n    width: 50%;\n    padding: 0 2px !important;\n}\n.medium-4[data-v-40480ee0] {\n    width: 33.3%;\n}\n.brand[data-v-40480ee0] {\n    width: 90%;\n    margin-left: 5%;\n    margin-bottom: 5px;\n}\n.services .body[data-v-40480ee0] {\n    -webkit-column-count: 2;\n       -moz-column-count: 2;\n            column-count: 2;\n}\n.services .body li[data-v-40480ee0] {\n      padding: 3px 5px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'more-filter':true, 'shrink':_vm.shrink}},[_c('div',{staticClass:"field row"},[_c('div',{class:['column col-field', _vm.shrink ? 'medium-12' : 'medium-8']},[_vm._m(0),_vm._v(" "),_c('div',{class:['column padded', _vm.shrink ? 'medium-12' : 'medium-6']},[_c('div',{staticClass:"datepicker-box"},[_c('datepicker',{staticClass:"datepicker inline",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.isLoading,"input-class":{'datepicker-empty':_vm.hasError.from},"placeholder":_vm.$t('transactions.filter.from')},on:{"input":function($event){return _vm.changeDate('from')}},model:{value:(_vm.dateFrom.date),callback:function ($$v) {_vm.$set(_vm.dateFrom, "date", $$v)},expression:"dateFrom.date"}})],1),_vm._v(" "),_c('div',{staticClass:"row time-selector"},[_c('div',{staticClass:"column padded medium-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateFrom.hour),expression:"dateFrom.hour"}],class:{'has-error':_vm.hasError.from},attrs:{"disabled":_vm.isLoading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.dateFrom, "hour", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeTime('from')}]}},_vm._l((_vm.maxHour),function(n){return _c('option',{key:n,domProps:{"value":_vm.leadingZero(n)}},[_vm._v(_vm._s(_vm.leadingZero(n)))])}),0)]),_vm._v(" "),_c('div',{staticClass:"column padded medium-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateFrom.minute),expression:"dateFrom.minute"}],class:{'has-error':_vm.hasError.from},attrs:{"disabled":_vm.isLoading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.dateFrom, "minute", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeTime('from')}]}},[_c('option',{attrs:{"value":"00"}},[_vm._v("00")]),_vm._v(" "),_vm._l((11),function(n){return _c('option',{key:n,domProps:{"value":_vm.leadingZero(n * 5)}},[_vm._v(_vm._s(_vm.leadingZero(n * 5)))])})],2)]),_vm._v(" "),_c('div',{staticClass:"column medium-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateFrom.amPm),expression:"dateFrom.amPm"}],class:{'has-error':_vm.hasError.from},attrs:{"disabled":_vm.isLoading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.dateFrom, "amPm", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeTime('from')}]}},[_c('option',{attrs:{"value":"AM"}},[_vm._v("AM")]),_vm._v(" "),_c('option',{attrs:{"value":"PM"}},[_vm._v("PM")])])])])]),_vm._v(" "),_c('div',{class:['column padded', _vm.shrink ? 'medium-12' : 'medium-6']},[_c('div',{staticClass:"datepicker-box"},[_c('datepicker',{staticClass:"datepicker inline",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.isLoading,"input-class":{'datepicker-empty':_vm.hasError.to},"placeholder":_vm.$t('transactions.filter.to')},on:{"input":function($event){return _vm.changeDate('to')}},model:{value:(_vm.dateTo.date),callback:function ($$v) {_vm.$set(_vm.dateTo, "date", $$v)},expression:"dateTo.date"}})],1),_vm._v(" "),_c('div',{staticClass:"row time-selector"},[_c('div',{staticClass:"column padded medium-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateTo.hour),expression:"dateTo.hour"}],class:{'has-error':_vm.hasError.to},attrs:{"disabled":_vm.isLoading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.dateTo, "hour", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeTime('to')}]}},_vm._l((_vm.maxHour),function(n){return _c('option',{key:n,domProps:{"value":_vm.leadingZero(n)}},[_vm._v(_vm._s(_vm.leadingZero(n)))])}),0)]),_vm._v(" "),_c('div',{staticClass:"column padded medium-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateTo.minute),expression:"dateTo.minute"}],class:{'has-error':_vm.hasError.to},attrs:{"disabled":_vm.isLoading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.dateTo, "minute", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeTime('to')}]}},[_c('option',{attrs:{"value":"00"}},[_vm._v("00")]),_vm._v(" "),_vm._l((11),function(n){return _c('option',{key:n,domProps:{"value":_vm.leadingZero(n * 5)}},[_vm._v(_vm._s(_vm.leadingZero(n * 5)))])})],2)]),_vm._v(" "),_c('div',{staticClass:"column medium-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateTo.amPm),expression:"dateTo.amPm"}],class:{'has-error':_vm.hasError.to},attrs:{"disabled":_vm.isLoading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.dateTo, "amPm", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeTime('to')}]}},[_c('option',{attrs:{"value":"AM"}},[_vm._v("AM")]),_vm._v(" "),_c('option',{attrs:{"value":"PM"}},[_vm._v("PM")])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{staticClass:"column medium-12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.hasError.fromToMsg),expression:"!!hasError.fromToMsg"}],staticClass:"error-msg"},[_vm._v(_vm._s(_vm.hasError.fromToMsg))])])]),_vm._v(" "),_c('div',{staticClass:"clear"})],1),_vm._v(" "),_c('div',{staticClass:"column col-field medium-12"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"select-all",on:{"click":function($event){return _vm.selectAllBrands()}}},[_c('div',{staticClass:"select-brand"},[_c('i',{class:['fa-lg', _vm.selectedAllServices ? 'fa-check-square fas' : 'far fa-square' ]})]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),(!this.useOldQuatation)?_c('div',_vm._l((_vm.brands),function(brand){return (_vm.serviceList(brand.id).length)?_c('div',{key:brand.id,staticClass:"services"},[_c('div',{staticClass:"select-brand",on:{"click":function($event){return _vm.selectBrand(brand.id)}}},[_c('i',{class:['fa-lg', _vm.selectedBrand.indexOf(brand.id) > -1 ? 'fa-check-square fas' : 'far fa-square' ]})]),_vm._v(" "),_c('div',{staticClass:"brand"},[_c('div',{staticClass:"head",on:{"click":function($event){return _vm.toggleBrand(brand.id)}}},[(_vm.openBrand.indexOf(brand.id) > -1)?_c('i',{staticClass:"fas fa-angle-down"}):_c('i',{staticClass:"fas fa-angle-up"}),_vm._v("\n              "+_vm._s(brand.name)+"\n            ")]),_vm._v(" "),_c('transition',{attrs:{"name":"height"}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.openBrand.indexOf(brand.id) > -1),expression:"openBrand.indexOf(brand.id) > -1"}],staticClass:"body"},_vm._l((_vm.serviceList(brand.id)),function(service){return _c('li',{key:service.id,on:{"click":function($event){return _vm.toggleService(service.id, brand.id)}}},[_c('i',{class:['fa-lg', _vm.selectedService.indexOf(service.id) > -1 ? 'fa-check-square fas' : 'far fa-square' ]}),_vm._v("\n                  "+_vm._s(service.label)+"\n                ")])}),0)])],1)]):_vm._e()}),0):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{staticClass:"column medium-12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.hasError.serviceMsg),expression:"!!hasError.serviceMsg"}],staticClass:"error-msg"},[_vm._v("\n            "+_vm._s(_vm.hasError.serviceMsg)+"\n          ")])])])],1),_vm._v(" "),_c('div',{staticClass:"column col-field medium-12"},[_vm._m(3),_vm._v(" "),_c('div',{class:['column end service', _vm.shrink ? 'medium-12' : 'medium-3']},[_c('div',{on:{"click":function($event){return _vm.selectStatus('upcoming')}}},[_c('i',{class:['fa-lg', _vm.status.upcoming ? 'fa-check-square fas' : 'far fa-square' ]}),_vm._v(" "),_c('span',[_vm._v("Upcoming")])])]),_vm._v(" "),_c('div',{class:['column end service', _vm.shrink ? 'medium-12' : 'medium-3']},[_c('div',{on:{"click":function($event){return _vm.selectStatus('ready')}}},[_c('i',{class:['fa-lg', _vm.status.ready ? 'fa-check-square fas' : 'far fa-square' ]}),_vm._v(" "),_c('span',[_vm._v("Ready to go")])])]),_vm._v(" "),_c('div',{class:['column end service', _vm.shrink ? 'medium-12' : 'medium-3']},[_c('div',{on:{"click":function($event){return _vm.selectStatus('require-dispatch')}}},[_c('i',{class:['fa-lg', _vm.status['require-dispatch'] ? 'fa-check-square fas' : 'far fa-square' ]}),_vm._v(" "),_c('span',[_vm._v("Requires Dispatch")])])]),_vm._v(" "),_c('div',{class:['column end service', _vm.shrink ? 'medium-12' : 'medium-3']},[_c('div',{on:{"click":function($event){return _vm.selectStatus('dispatched')}}},[_c('i',{class:['fa-lg', _vm.status.dispatched ? 'fa-check-square fas' : 'far fa-square' ]}),_vm._v(" "),_c('span',[_vm._v("Dispatched")])])]),_vm._v(" "),_c('div',{class:['column end service', _vm.shrink ? 'medium-12' : 'medium-3']},[_c('div',{on:{"click":function($event){return _vm.selectStatus('onboard')}}},[_c('i',{class:['fa-lg', _vm.status.onboard ? 'fa-check-square fas' : 'far fa-square' ]}),_vm._v(" "),_c('span',[_vm._v("On Board")])])]),_vm._v(" "),_c('div',{class:['column end service', _vm.shrink ? 'medium-12' : 'medium-3']},[_c('div',{on:{"click":function($event){return _vm.selectStatus('completed')}}},[_c('i',{class:['fa-lg', _vm.status.completed ? 'fa-check-square fas' : 'far fa-square' ]}),_vm._v(" "),_c('span',[_vm._v("Completed")])])]),_vm._v(" "),_c('div',{class:['column end service', _vm.shrink ? 'medium-12' : 'medium-3']},[_c('div',{on:{"click":function($event){return _vm.selectStatus('cancelled')}}},[_c('i',{class:['fa-lg', _vm.status.cancelled ? 'fa-check-square fas' : 'far fa-square' ]}),_vm._v(" "),_c('span',[_vm._v("Cancelled")])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{staticClass:"column medium-12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.hasError.statusMsg),expression:"!!hasError.statusMsg"}],staticClass:"error-msg"},[_vm._v(_vm._s(_vm.hasError.statusMsg))])])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{class:['column col-btn', _vm.shrink ? 'medium-12' : 'medium-8 medium-offset-2']},[(!_vm.shrink)?_c('div',{class:['column padded', _vm.shrink ? 'medium-12' : 'medium-6']},[_c('div',{staticClass:"button cta warning block small",on:{"click":_vm.close}},[_vm._v("close")])]):_vm._e(),_vm._v(" "),_c('div',{class:['column padded', _vm.shrink ? 'medium-12' : 'medium-6']},[_c('div',{staticClass:"button cta success block small",on:{"click":_vm.applyFilter}},[_vm._v("Apply Filter")])]),_vm._v(" "),(_vm.shrink)?_c('div',{class:['column padded', _vm.shrink ? 'medium-12' : 'medium-6']},[_c('div',{staticClass:"button cta warning block small",on:{"click":_vm.close}},[_vm._v("close")])]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column medium-12"},[_c('label',[_vm._v("Date Range")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column medium-12"},[_c('label',[_vm._v("Service Type")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand"},[_c('label',[_vm._v("Select All Brands")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',[_vm._v("Reservation Status")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1298);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("598bf7d7", content, true, {});

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.routing-header[data-v-67f7a517] {\n  padding: 0 20px 0 50px;\n  height: 50px;\n  width: 100%;\n  background-color: #fff;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.routing-header .title[data-v-67f7a517] {\n    font-weight: 700;\n    font-size: 22px;\n    color: #3F2975;\n    display: inline-block;\n    width: 120px;\n    line-height: 22px;\n}\n.routing-header > *[data-v-67f7a517] {\n    height: 50px;\n}\n.routing-header input[data-v-67f7a517], .routing-header .select-input[data-v-67f7a517] {\n    display: inline-block;\n    line-height: inherit;\n}\n.routing-header input[data-v-67f7a517] {\n    width: 40%;\n    margin: 0;\n    border-radius: 0;\n    border-top: 0;\n}\n@media only screen and (max-width: 430px) {\n.routing-header[data-v-67f7a517] {\n    padding: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Routing/Header.vue"],"names":[],"mappings":";AACA;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,6CAA6C;CAC9C;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,kBAAkB;CACrB;AACD;IACI,aAAa;CAChB;AACD;IACI,sBAAsB;IACtB,qBAAqB;CACxB;AACD;IACI,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,cAAc;CACjB;AACD;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;CACA","file":"Header.vue","sourcesContent":["\n.routing-header[data-v-67f7a517] {\n  padding: 0 20px 0 50px;\n  height: 50px;\n  width: 100%;\n  background-color: #fff;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.routing-header .title[data-v-67f7a517] {\n    font-weight: 700;\n    font-size: 22px;\n    color: #3F2975;\n    display: inline-block;\n    width: 120px;\n    line-height: 22px;\n}\n.routing-header > *[data-v-67f7a517] {\n    height: 50px;\n}\n.routing-header input[data-v-67f7a517], .routing-header .select-input[data-v-67f7a517] {\n    display: inline-block;\n    line-height: inherit;\n}\n.routing-header input[data-v-67f7a517] {\n    width: 40%;\n    margin: 0;\n    border-radius: 0;\n    border-top: 0;\n}\n@media only screen and (max-width: 430px) {\n.routing-header[data-v-67f7a517] {\n    padding: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableFilter_vue__ = __webpack_require__(464);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eb3892f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableFilter_vue__ = __webpack_require__(1302);
function injectStyle (ssrContext) {
  __webpack_require__(1300)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6eb3892f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eb3892f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1301);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("312bbad2", content, true, {});

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.select-input[data-v-6eb3892f] {\n  width: 30%;\n  padding: 0;\n  position: relative;\n}\n.select-input select[data-v-6eb3892f] {\n    display: inline-block;\n    width: 100%;\n    height: 100%;\n    outline: 0;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    border-radius: 0;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    margin-left: -5px;\n    background-color: #fff;\n    padding: 0 30px 0 15px;\n    border-right: 1px solid rgba(0, 0, 0, 0.15);\n    border-top: 0;\n}\n.select-input i[data-v-6eb3892f] {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    color: #aaa;\n}\n@media only screen and (max-width: 430px) {\n.select-input[data-v-6eb3892f] {\n    width: 50%;\n}\n.select-input select[data-v-6eb3892f] {\n      margin: 0;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Routing/TableFilter.vue"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;CACpB;AACD;IACI,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,sCAAsC;IACtC,iBAAiB;IACjB,yBAAyB;OACtB,sBAAsB;YACjB,iBAAiB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;IACvB,4CAA4C;IAC5C,cAAc;CACjB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,YAAY;CACf;AACD;AACA;IACI,WAAW;CACd;AACD;MACM,UAAU;CACf;CACA","file":"TableFilter.vue","sourcesContent":["\n.select-input[data-v-6eb3892f] {\n  width: 30%;\n  padding: 0;\n  position: relative;\n}\n.select-input select[data-v-6eb3892f] {\n    display: inline-block;\n    width: 100%;\n    height: 100%;\n    outline: 0;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    border-radius: 0;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    margin-left: -5px;\n    background-color: #fff;\n    padding: 0 30px 0 15px;\n    border-right: 1px solid rgba(0, 0, 0, 0.15);\n    border-top: 0;\n}\n.select-input i[data-v-6eb3892f] {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    color: #aaa;\n}\n@media only screen and (max-width: 430px) {\n.select-input[data-v-6eb3892f] {\n    width: 50%;\n}\n.select-input select[data-v-6eb3892f] {\n      margin: 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-input"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedFilter),expression:"selectedFilter"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedFilter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.filterRsvp]}},[_c('option',{attrs:{"value":"-1","selected":""}},[_vm._v("Select a filter")]),_vm._v(" "),_vm._l((_vm.filters),function(filter,index){return _c('option',{domProps:{"value":index}},[_vm._v("\n      "+_vm._s(filter.name)+"\n    ")])})],2),_vm._v(" "),_c('i',{staticClass:"fas fa-caret-down"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableSearch_vue__ = __webpack_require__(465);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aebe14e8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableSearch_vue__ = __webpack_require__(1306);
function injectStyle (ssrContext) {
  __webpack_require__(1304)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aebe14e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aebe14e8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1305);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("fc7e2fcc", content, true, {});

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\nform[data-v-aebe14e8] {\n  position: relative;\n  width: 40%;\n  display: inline-block;\n}\ninput[data-v-aebe14e8] {\n  margin: 0;\n  border-radius: 0;\n  padding: 0 15px;\n  height: 50px;\n  line-height: 50px;\n  border-top: 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0);\n  border-color: rgba(0, 0, 0, 0.2);\n}\n.search-input[data-v-aebe14e8] {\n  position: relative;\n}\n.search-input a[data-v-aebe14e8] {\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 50px;\n    line-height: 50px;\n    color: #777;\n    width: 50px;\n    text-align: center;\n}\n.search-input a i[data-v-aebe14e8] {\n      line-height: inherit;\n}\n@media only screen and (max-width: 430px) {\nform[data-v-aebe14e8] {\n    width: 50%;\n}\ninput[data-v-aebe14e8] {\n    padding-left: 60px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Routing/TableSearch.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,WAAW;EACX,sBAAsB;CACvB;AACD;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,0CAA0C;EAC1C,iCAAiC;CAClC;AACD;EACE,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,mBAAmB;CACtB;AACD;MACM,qBAAqB;CAC1B;AACD;AACA;IACI,WAAW;CACd;AACD;IACI,mBAAmB;CACtB;CACA","file":"TableSearch.vue","sourcesContent":["\nform[data-v-aebe14e8] {\n  position: relative;\n  width: 40%;\n  display: inline-block;\n}\ninput[data-v-aebe14e8] {\n  margin: 0;\n  border-radius: 0;\n  padding: 0 15px;\n  height: 50px;\n  line-height: 50px;\n  border-top: 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0);\n  border-color: rgba(0, 0, 0, 0.2);\n}\n.search-input[data-v-aebe14e8] {\n  position: relative;\n}\n.search-input a[data-v-aebe14e8] {\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 50px;\n    line-height: 50px;\n    color: #777;\n    width: 50px;\n    text-align: center;\n}\n.search-input a i[data-v-aebe14e8] {\n      line-height: inherit;\n}\n@media only screen and (max-width: 430px) {\nform[data-v-aebe14e8] {\n    width: 50%;\n}\ninput[data-v-aebe14e8] {\n    padding-left: 60px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitSearch.apply(null, arguments)}}},[_c('div',{staticClass:"search-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],attrs:{"type":"text","placeholder":"Type and hit enter to search."},domProps:{"value":(_vm.searchInput)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchInput !== ''),expression:"searchInput !== ''"}],attrs:{"href":"javascript:;"},on:{"click":_vm.clearSearch}},[_c('i',{staticClass:"far fa-times-circle fa-lg fa-fw"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"routing-header"},[_c('table-search'),_vm._v(" "),_c('table-filter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1309);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("67875606", content, true, {});

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.status[data-v-2df4cd98] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-2df4cd98], .status.completed[data-v-2df4cd98] {\n    background: #26D97A;\n}\n.status.canceled[data-v-2df4cd98], .status.cancelled[data-v-2df4cd98], .status.failed[data-v-2df4cd98] {\n    background: #bbb;\n}\n.status.upcoming[data-v-2df4cd98] {\n    background: #f38d56;\n}\n.status.onboard[data-v-2df4cd98] {\n    background: #dc3168;\n}\n.status.ready[data-v-2df4cd98] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-2df4cd98], .status.requires_dispatch[data-v-2df4cd98] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-2df4cd98] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-2df4cd98] {\n    background: #5662f3;\n}\n.flight-status[data-v-2df4cd98] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-2df4cd98] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-2df4cd98] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-2df4cd98] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-2df4cd98] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-2df4cd98] {\n    background-color: #f35656;\n}\n.routing-list[data-v-2df4cd98] {\n  position: relative;\n}\n.table-container[data-v-2df4cd98] {\n  padding: 47px 0 0;\n  position: relative;\n}\n.table-container input[type=\"checkbox\"][data-v-2df4cd98] {\n    margin-top: 0;\n    width: auto;\n}\n.table-container table[data-v-2df4cd98] {\n    border-collapse: collapse;\n    width: 100%;\n}\n.table-container .fixed-header[data-v-2df4cd98] {\n    position: absolute;\n    top: 0;\n}\n.table-container .table-header[data-v-2df4cd98] {\n    color: #8DA0A9;\n    font-size: 12px;\n    /*border: 1px solid rgba(0,0,0,0.3);*/\n    background-color: #f5f5f5;\n}\n.table-container .table-header th[data-v-2df4cd98] {\n      padding: 5px;\n}\n.table-container .table-header th.sortable[data-v-2df4cd98] {\n        cursor: pointer;\n        text-decoration: underline;\n        color: #333;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.table-container .table-header th.sortable.disabled[data-v-2df4cd98] {\n          pointer-events: none;\n          opacity: 0.5;\n}\n.table-container .table-header th.pkg-chk[data-v-2df4cd98] {\n        width: 24px !important;\n}\n.table-container .table-header th.pkg-id[data-v-2df4cd98] {\n        width: 52px !important;\n}\n.table-container .table-header th.pkg-status[data-v-2df4cd98] {\n        width: 90px !important;\n}\n.table-container .table-header th.pkg-pickup-time[data-v-2df4cd98] {\n        width: 80px !important;\n}\n.table-container .table-header th.pkg-pickup[data-v-2df4cd98], .table-container .table-header th.pkg-dropoff[data-v-2df4cd98] {\n        width: 140px !important;\n}\n.table-container .table-header th.pkg-driver[data-v-2df4cd98] {\n        width: 86px !important;\n}\n.table-container .table-header th.pkg-payment[data-v-2df4cd98] {\n        width: 65px !important;\n}\n.table-container .table-header th.pkg-ada[data-v-2df4cd98] {\n        width: 50px !important;\n}\n.table-container .table-header th.pkg-stops[data-v-2df4cd98] {\n        width: 47px !important;\n}\n.table-container .table-header th.pkg-pax[data-v-2df4cd98] {\n        width: 32px !important;\n}\n.table-container .table-header th.pkg-luggage[data-v-2df4cd98] {\n        width: 66px !important;\n}\n.table-container .table-header th.pkg-in-pool[data-v-2df4cd98] {\n        width: 43px !important;\n}\n.table-container .table-header th.pkg-map[data-v-2df4cd98] {\n        width: 64px !important;\n}\n.empty-reservations[data-v-2df4cd98] {\n  max-width: 450px;\n  margin: 50px auto;\n  text-align: center;\n}\n.empty-reservations .title[data-v-2df4cd98] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.empty-reservations .content[data-v-2df4cd98] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\n.table-loader[data-v-2df4cd98] {\n  position: relative;\n  width: 300px;\n  margin: 50px auto;\n  text-align: center;\n}\n.table-loader .loader-title[data-v-2df4cd98] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.table-loader .loader-text[data-v-2df4cd98] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\n.paging[data-v-2df4cd98] {\n  margin: 15px auto;\n  width: 103px;\n  opacity: 1;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.paging.disabled[data-v-2df4cd98] {\n    pointer-events: none;\n    opacity: 0.6;\n}\n.paging .page[data-v-2df4cd98] {\n    display: inline-block;\n    vertical-align: middle;\n    width: auto;\n}\n.paging .page[data-v-2df4cd98]:not(:first-child) {\n      margin-left: -5px;\n}\n.paging .page-btn[data-v-2df4cd98] {\n    background-color: #f5f5f5;\n    border: 1px solid rgba(0, 0, 0, 0.25);\n    color: #777;\n    padding: 5px 5px;\n    font-size: 12px;\n}\n.paging .page-btn.disabled[data-v-2df4cd98] {\n      pointer-events: none;\n      opacity: 0.5;\n}\n.paging .page-btn i[data-v-2df4cd98] {\n      line-height: inherit;\n}\n.paging .page-btn.back[data-v-2df4cd98] {\n      border-top-left-radius: 3px;\n      border-bottom-left-radius: 3px;\n      border-right: 0;\n}\n.paging .page-btn.next[data-v-2df4cd98] {\n      border-top-right-radius: 3px;\n      border-bottom-right-radius: 3px;\n}\n.paging .page-number[data-v-2df4cd98] {\n    border-radius: 0;\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    line-height: inherit;\n    font-size: 12px;\n    margin: 0;\n    width: 50px;\n    font-weight: 700;\n    padding: 5px 10px;\n    color: #333;\n    text-align: center;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    outline: 0;\n    -moz-text-align-last: center;\n         text-align-last: center;\n    border-right: 0;\n}\n.infinity-loader[data-v-2df4cd98] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  -webkit-transform-origin: bottom center;\n          transform-origin: bottom center;\n  text-align: center;\n  font-size: 18px;\n  line-height: 40px;\n  z-index: 2;\n}\n.slide-up-enter-active[data-v-2df4cd98], .slide-up-leave-active[data-v-2df4cd98] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-2df4cd98], .slide-up-leave-to[data-v-2df4cd98] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.select-filter[data-v-2df4cd98] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin: 0 10px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.select-filter .sortable[data-v-2df4cd98] {\n      border: 1px solid #ccc;\n      padding: 5px 20px;\n      font-size: 12px;\n      font-weight: 900;\n      text-transform: uppercase;\n      width: 50%;\n      text-align: center;\n      background-color: #fff;\n}\n.table-container[data-v-2df4cd98] {\n    padding-top: 10px;\n    padding-bottom: 50px;\n}\n.empty-reservations[data-v-2df4cd98] {\n    padding: 0 10px;\n}\n.empty-reservations .title[data-v-2df4cd98] {\n      font-size: 18px;\n}\n.empty-reservations .content[data-v-2df4cd98] {\n      font-size: 12px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Routing/PackagesTable.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;CAC3B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;EAClB,mBAAmB;CACpB;AACD;IACI,cAAc;IACd,YAAY;CACf;AACD;IACI,0BAA0B;IAC1B,YAAY;CACf;AACD;IACI,mBAAmB;IACnB,OAAO;CACV;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,0BAA0B;CAC7B;AACD;MACM,aAAa;CAClB;AACD;QACQ,gBAAgB;QAChB,2BAA2B;QAC3B,YAAY;QACZ,8BAA8B;QAC9B,sBAAsB;CAC7B;AACD;UACU,qBAAqB;UACrB,aAAa;CACtB;AACD;QACQ,uBAAuB;CAC9B;AACD;QACQ,uBAAuB;CAC9B;AACD;QACQ,uBAAuB;CAC9B;AACD;QACQ,uBAAuB;CAC9B;AACD;QACQ,wBAAwB;CAC/B;AACD;QACQ,uBAAuB;CAC9B;AACD;QACQ,uBAAuB;CAC9B;AACD;QACQ,uBAAuB;CAC9B;AACD;QACQ,uBAAuB;CAC9B;AACD;QACQ,uBAAuB;CAC9B;AACD;QACQ,uBAAuB;CAC9B;AACD;QACQ,uBAAuB;CAC9B;AACD;QACQ,uBAAuB;CAC9B;AACD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;CACpB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;CACpB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,qBAAqB;IACrB,aAAa;CAChB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;CACf;AACD;MACM,kBAAkB;CACvB;AACD;IACI,0BAA0B;IAC1B,sCAAsC;IACtC,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;CACnB;AACD;MACM,qBAAqB;MACrB,aAAa;CAClB;AACD;MACM,qBAAqB;CAC1B;AACD;MACM,4BAA4B;MAC5B,+BAA+B;MAC/B,gBAAgB;CACrB;AACD;MACM,6BAA6B;MAC7B,gCAAgC;CACrC;AACD;IACI,iBAAiB;IACjB,uBAAuB;IACvB,qCAAqC;IACrC,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;OACtB,sBAAsB;YACjB,iBAAiB;IACzB,WAAW;IACX,6BAA6B;SACxB,wBAAwB;IAC7B,gBAAgB;CACnB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,wCAAwC;UAChC,gCAAgC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;CACZ;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;AACA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,yBAAyB;QACrB,sBAAsB;YAClB,wBAAwB;CACnC;AACD;MACM,uBAAuB;MACvB,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MACjB,0BAA0B;MAC1B,WAAW;MACX,mBAAmB;MACnB,uBAAuB;CAC5B;AACD;IACI,kBAAkB;IAClB,qBAAqB;CACxB;AACD;IACI,gBAAgB;CACnB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,gBAAgB;CACrB;CACA","file":"PackagesTable.vue","sourcesContent":["\n.status[data-v-2df4cd98] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-2df4cd98], .status.completed[data-v-2df4cd98] {\n    background: #26D97A;\n}\n.status.canceled[data-v-2df4cd98], .status.cancelled[data-v-2df4cd98], .status.failed[data-v-2df4cd98] {\n    background: #bbb;\n}\n.status.upcoming[data-v-2df4cd98] {\n    background: #f38d56;\n}\n.status.onboard[data-v-2df4cd98] {\n    background: #dc3168;\n}\n.status.ready[data-v-2df4cd98] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-2df4cd98], .status.requires_dispatch[data-v-2df4cd98] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-2df4cd98] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-2df4cd98] {\n    background: #5662f3;\n}\n.flight-status[data-v-2df4cd98] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-2df4cd98] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-2df4cd98] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-2df4cd98] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-2df4cd98] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-2df4cd98] {\n    background-color: #f35656;\n}\n.routing-list[data-v-2df4cd98] {\n  position: relative;\n}\n.table-container[data-v-2df4cd98] {\n  padding: 47px 0 0;\n  position: relative;\n}\n.table-container input[type=\"checkbox\"][data-v-2df4cd98] {\n    margin-top: 0;\n    width: auto;\n}\n.table-container table[data-v-2df4cd98] {\n    border-collapse: collapse;\n    width: 100%;\n}\n.table-container .fixed-header[data-v-2df4cd98] {\n    position: absolute;\n    top: 0;\n}\n.table-container .table-header[data-v-2df4cd98] {\n    color: #8DA0A9;\n    font-size: 12px;\n    /*border: 1px solid rgba(0,0,0,0.3);*/\n    background-color: #f5f5f5;\n}\n.table-container .table-header th[data-v-2df4cd98] {\n      padding: 5px;\n}\n.table-container .table-header th.sortable[data-v-2df4cd98] {\n        cursor: pointer;\n        text-decoration: underline;\n        color: #333;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.table-container .table-header th.sortable.disabled[data-v-2df4cd98] {\n          pointer-events: none;\n          opacity: 0.5;\n}\n.table-container .table-header th.pkg-chk[data-v-2df4cd98] {\n        width: 24px !important;\n}\n.table-container .table-header th.pkg-id[data-v-2df4cd98] {\n        width: 52px !important;\n}\n.table-container .table-header th.pkg-status[data-v-2df4cd98] {\n        width: 90px !important;\n}\n.table-container .table-header th.pkg-pickup-time[data-v-2df4cd98] {\n        width: 80px !important;\n}\n.table-container .table-header th.pkg-pickup[data-v-2df4cd98], .table-container .table-header th.pkg-dropoff[data-v-2df4cd98] {\n        width: 140px !important;\n}\n.table-container .table-header th.pkg-driver[data-v-2df4cd98] {\n        width: 86px !important;\n}\n.table-container .table-header th.pkg-payment[data-v-2df4cd98] {\n        width: 65px !important;\n}\n.table-container .table-header th.pkg-ada[data-v-2df4cd98] {\n        width: 50px !important;\n}\n.table-container .table-header th.pkg-stops[data-v-2df4cd98] {\n        width: 47px !important;\n}\n.table-container .table-header th.pkg-pax[data-v-2df4cd98] {\n        width: 32px !important;\n}\n.table-container .table-header th.pkg-luggage[data-v-2df4cd98] {\n        width: 66px !important;\n}\n.table-container .table-header th.pkg-in-pool[data-v-2df4cd98] {\n        width: 43px !important;\n}\n.table-container .table-header th.pkg-map[data-v-2df4cd98] {\n        width: 64px !important;\n}\n.empty-reservations[data-v-2df4cd98] {\n  max-width: 450px;\n  margin: 50px auto;\n  text-align: center;\n}\n.empty-reservations .title[data-v-2df4cd98] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.empty-reservations .content[data-v-2df4cd98] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\n.table-loader[data-v-2df4cd98] {\n  position: relative;\n  width: 300px;\n  margin: 50px auto;\n  text-align: center;\n}\n.table-loader .loader-title[data-v-2df4cd98] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.table-loader .loader-text[data-v-2df4cd98] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\n.paging[data-v-2df4cd98] {\n  margin: 15px auto;\n  width: 103px;\n  opacity: 1;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.paging.disabled[data-v-2df4cd98] {\n    pointer-events: none;\n    opacity: 0.6;\n}\n.paging .page[data-v-2df4cd98] {\n    display: inline-block;\n    vertical-align: middle;\n    width: auto;\n}\n.paging .page[data-v-2df4cd98]:not(:first-child) {\n      margin-left: -5px;\n}\n.paging .page-btn[data-v-2df4cd98] {\n    background-color: #f5f5f5;\n    border: 1px solid rgba(0, 0, 0, 0.25);\n    color: #777;\n    padding: 5px 5px;\n    font-size: 12px;\n}\n.paging .page-btn.disabled[data-v-2df4cd98] {\n      pointer-events: none;\n      opacity: 0.5;\n}\n.paging .page-btn i[data-v-2df4cd98] {\n      line-height: inherit;\n}\n.paging .page-btn.back[data-v-2df4cd98] {\n      border-top-left-radius: 3px;\n      border-bottom-left-radius: 3px;\n      border-right: 0;\n}\n.paging .page-btn.next[data-v-2df4cd98] {\n      border-top-right-radius: 3px;\n      border-bottom-right-radius: 3px;\n}\n.paging .page-number[data-v-2df4cd98] {\n    border-radius: 0;\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    line-height: inherit;\n    font-size: 12px;\n    margin: 0;\n    width: 50px;\n    font-weight: 700;\n    padding: 5px 10px;\n    color: #333;\n    text-align: center;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    outline: 0;\n    -moz-text-align-last: center;\n         text-align-last: center;\n    border-right: 0;\n}\n.infinity-loader[data-v-2df4cd98] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  -webkit-transform-origin: bottom center;\n          transform-origin: bottom center;\n  text-align: center;\n  font-size: 18px;\n  line-height: 40px;\n  z-index: 2;\n}\n.slide-up-enter-active[data-v-2df4cd98], .slide-up-leave-active[data-v-2df4cd98] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-2df4cd98], .slide-up-leave-to[data-v-2df4cd98] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.select-filter[data-v-2df4cd98] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin: 0 10px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.select-filter .sortable[data-v-2df4cd98] {\n      border: 1px solid #ccc;\n      padding: 5px 20px;\n      font-size: 12px;\n      font-weight: 900;\n      text-transform: uppercase;\n      width: 50%;\n      text-align: center;\n      background-color: #fff;\n}\n.table-container[data-v-2df4cd98] {\n    padding-top: 10px;\n    padding-bottom: 50px;\n}\n.empty-reservations[data-v-2df4cd98] {\n    padding: 0 10px;\n}\n.empty-reservations .title[data-v-2df4cd98] {\n      font-size: 18px;\n}\n.empty-reservations .content[data-v-2df4cd98] {\n      font-size: 12px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackageRow_vue__ = __webpack_require__(468);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47f383f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackageRow_vue__ = __webpack_require__(1313);
function injectStyle (ssrContext) {
  __webpack_require__(1311)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47f383f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackageRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47f383f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackageRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1312);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("3768fae0", content, true, {});

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.status[data-v-47f383f2] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-47f383f2], .status.completed[data-v-47f383f2] {\n    background: #26D97A;\n}\n.status.canceled[data-v-47f383f2], .status.cancelled[data-v-47f383f2], .status.failed[data-v-47f383f2] {\n    background: #bbb;\n}\n.status.upcoming[data-v-47f383f2] {\n    background: #f38d56;\n}\n.status.onboard[data-v-47f383f2] {\n    background: #dc3168;\n}\n.status.ready[data-v-47f383f2] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-47f383f2], .status.requires_dispatch[data-v-47f383f2] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-47f383f2] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-47f383f2] {\n    background: #5662f3;\n}\n.flight-status[data-v-47f383f2] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-47f383f2] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-47f383f2] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-47f383f2] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-47f383f2] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-47f383f2] {\n    background-color: #f35656;\n}\n.service-type[data-v-47f383f2] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-47f383f2] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-47f383f2] {\n    background: #26D97A;\n}\n.service-type.black[data-v-47f383f2] {\n    background: #777;\n}\n.service-type.suv[data-v-47f383f2] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-47f383f2] {\n    background: #6dabc3;\n}\n.license-type[data-v-47f383f2] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-47f383f2] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-47f383f2] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-47f383f2] {\n    background-color: #de6c2a;\n}\n.dragslot[data-v-47f383f2] {\n  font-weight: 700;\n  background-color: #fff;\n  padding: 5px;\n  -webkit-box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(0, 0, 0, 0.4);\n  border-radius: 3px;\n}\n.table-item[data-v-47f383f2] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.table-item input[type=\"checkbox\"][data-v-47f383f2] {\n    margin-top: 0;\n    width: auto;\n}\n.table-item td[data-v-47f383f2] {\n    padding: 5px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.table-item td a[data-v-47f383f2] {\n      font-weight: 700;\n}\n.table-item td.map-button[data-v-47f383f2] {\n      padding: 10px;\n}\n.table-item td.map-button a[data-v-47f383f2] {\n        color: #fff;\n        background-color: #aaa;\n        width: 30px;\n        height: 30px;\n        line-height: 30px;\n        text-align: center;\n        display: inline-block;\n        border-radius: 30px;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.table-item td.map-button a i[data-v-47f383f2] {\n          line-height: inherit;\n}\n.table-item td.map-button a.disabled[data-v-47f383f2] {\n          pointer-events: none;\n          opacity: 0.5;\n          background-color: #bbb;\n}\n.table-item td.map-button a.selected[data-v-47f383f2] {\n          background-color: #26D97A;\n}\n.table-item td.pool-yes[data-v-47f383f2] {\n      color: #26D97A;\n}\n.table-item td.pool-no[data-v-47f383f2] {\n      color: #F20D0D;\n}\n.table-item td.pkg-check[data-v-47f383f2] {\n      width: 24px !important;\n}\n.table-item td.pkg-id[data-v-47f383f2] {\n      width: 53px !important;\n}\n.table-item td.pkg-status[data-v-47f383f2] {\n      width: 90px !important;\n}\n.table-item td.pkg-pickup-time[data-v-47f383f2] {\n      width: 80px !important;\n}\n.table-item td.pkg-pickup[data-v-47f383f2], .table-item td.pkg-dropoff[data-v-47f383f2] {\n      width: 140px !important;\n}\n.table-item td.pkg-driver[data-v-47f383f2] {\n      width: 86px !important;\n}\n.table-item td.pkg-payment[data-v-47f383f2] {\n      width: 65px !important;\n}\n.table-item td.pkg-ada[data-v-47f383f2] {\n      width: 50px !important;\n}\n.table-item td.pkg-stops[data-v-47f383f2] {\n      width: 47px !important;\n}\n.table-item td.pkg-pax[data-v-47f383f2] {\n      width: 32px !important;\n}\n.table-item td.pkg-luggage[data-v-47f383f2] {\n      width: 66px !important;\n}\n.table-item td.pkg-in-pool[data-v-47f383f2] {\n      width: 43px !important;\n}\n.table-item td.pkg-map[data-v-47f383f2] {\n      width: 40px !important;\n}\n.last-dropoff[data-v-47f383f2] {\n  position: relative;\n  text-decoration: underline;\n  font-weight: 700;\n}\n.last-dropoff .eta-popup[data-v-47f383f2] {\n    position: absolute;\n    top: 0;\n    left: 100%;\n    background-color: #e5e5e5;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n    padding: 10px;\n    overflow: hidden;\n    height: 0;\n    width: 0;\n    padding: 0;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n    text-decoration: none;\n    font-weight: 400;\n    border-radius: 3px;\n    text-align: center;\n}\n.last-dropoff .eta-popup.show[data-v-47f383f2] {\n      padding: 5px;\n      width: 170px;\n      height: auto;\n}\n.status.pending-offer[data-v-47f383f2] {\n  background: #ef7a0b;\n  line-height: 12px;\n  position: relative;\n  overflow: hidden;\n  -webkit-box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);\n}\n.status.pending-offer[data-v-47f383f2]:after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background: linear-gradient(130deg, rgba(227, 227, 227, 0) 0%, rgba(227, 227, 227, 0) 40%, rgba(255, 255, 255, 0.7) 50%, rgba(227, 227, 227, 0) 60%, rgba(227, 227, 227, 0) 100%);\n    -webkit-animation: gradient-animation_2-data-v-47f383f2 1.2s linear infinite;\n            animation: gradient-animation_2-data-v-47f383f2 1.2s linear infinite;\n}\n@-webkit-keyframes gradient-animation_2-data-v-47f383f2 {\n0% {\n    -webkit-transform: translateX(-100%);\n            transform: translateX(-100%);\n}\n100% {\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%);\n}\n}\n@keyframes gradient-animation_2-data-v-47f383f2 {\n0% {\n    -webkit-transform: translateX(-100%);\n            transform: translateX(-100%);\n}\n100% {\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%);\n}\n}\n.timer[data-v-47f383f2] {\n  display: inline-block;\n}\n@media only screen and (max-width: 430px) {\n.table-card[data-v-47f383f2] {\n    border: 1px solid #ccc;\n    margin: 10px;\n    margin-bottom: 15px;\n    padding: 10px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-size: 13px;\n    background-color: #fff;\n}\n.table-card a[data-v-47f383f2] {\n      font-weight: 900;\n}\n.table-card i[data-v-47f383f2] {\n      color: #0d79f2;\n}\n.table-card > div[data-v-47f383f2] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n      margin-bottom: 3px;\n}\n.table-card > div.see-more[data-v-47f383f2] {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        -webkit-box-pack: start;\n            -ms-flex-pack: start;\n                justify-content: flex-start;\n        -webkit-box-align: start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n}\n.table-card .toggle-div[data-v-47f383f2] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .toggle-div .toggle[data-v-47f383f2] {\n        font-size: 16px;\n        color: #0e79f2;\n}\n.table-card .toggle-div svg[data-v-47f383f2] {\n        width: 15px;\n        height: 15px;\n}\n.table-card .toggle-div .row-7[data-v-47f383f2] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        width: 100%;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n}\n.table-card .toggle-div .row-7 .pool-yes i[data-v-47f383f2] {\n          color: #26D97A;\n}\n.table-card .toggle-div .row-7 .pool-no i[data-v-47f383f2] {\n          color: #F20D0D;\n}\n.table-card .row-1 .link[data-v-47f383f2] {\n      padding-bottom: 5px;\n      display: inline-block;\n}\n.table-card .row-1 .rtg[data-v-47f383f2] {\n      display: inline-block;\n      margin: 4px;\n}\n.table-card .row-1 i[data-v-47f383f2] {\n      color: #26D97A;\n}\n.table-card .row-1 input[data-v-47f383f2] {\n      display: inline-block;\n      margin: 0;\n      width: 15px;\n      height: 15px;\n      margin-right: 5px;\n}\n.table-card .row-1 .map-button a[data-v-47f383f2] {\n      background-color: #aaa;\n      width: 30px;\n      height: 30px;\n      line-height: 30px;\n      text-align: center;\n      border-radius: 30px;\n      -webkit-transition: all 250ms;\n      transition: all 250ms;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      text-decoration: none;\n}\n.table-card .row-1 .map-button a i[data-v-47f383f2] {\n        color: #fff;\n}\n.table-card .row-1 .map-button a.disabled[data-v-47f383f2] {\n        pointer-events: none;\n        opacity: 0.5;\n        background-color: #bbb;\n}\n.table-card .row-1 .map-button a.selected[data-v-47f383f2] {\n        background-color: #26D97A;\n}\n.table-card .row-2[data-v-47f383f2] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: unset;\n          -ms-flex-pack: unset;\n              justify-content: unset;\n      gap: 5px;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .row-2 .image img[data-v-47f383f2] {\n        min-width: 30px;\n        max-width: 30px;\n}\n.table-card .row-7 strong[data-v-47f383f2] {\n      color: #666;\n}\n.table-card .row-7 i[data-v-47f383f2] {\n      color: #666;\n      margin: 0 3px;\n}\n.table-card .row-8[data-v-47f383f2] {\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.table-card .row-8 .actions[data-v-47f383f2] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.table-card .row-8 .actions span[data-v-47f383f2] {\n          padding: 8px 20px;\n}\n.table-card .row-8 .actions .notes i[data-v-47f383f2] {\n          color: #fff;\n}\n.table-card .clock i[data-v-47f383f2] {\n      color: #F25E0D;\n}\n.table-card .pickup i[data-v-47f383f2] {\n      color: #d92626;\n}\n.table-card .dropoff i[data-v-47f383f2] {\n      color: #26D97A;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Routing/PackageRow.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;CAC3B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;EAClD,qCAAqC;EACrC,mBAAmB;CACpB;AACD;EACE,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;CACpB;AACD;IACI,cAAc;IACd,YAAY;CACf;AACD;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;CACtB;AACD;MACM,iBAAiB;CACtB;AACD;MACM,cAAc;CACnB;AACD;QACQ,YAAY;QACZ,uBAAuB;QACvB,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,mBAAmB;QACnB,sBAAsB;QACtB,oBAAoB;QACpB,8BAA8B;QAC9B,sBAAsB;CAC7B;AACD;UACU,qBAAqB;CAC9B;AACD;UACU,qBAAqB;UACrB,aAAa;UACb,uBAAuB;CAChC;AACD;UACU,0BAA0B;CACnC;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,wBAAwB;CAC7B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;CAClB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,WAAW;IACX,0BAA0B;IAC1B,qCAAqC;IACrC,kDAAkD;YAC1C,0CAA0C;IAClD,cAAc;IACd,iBAAiB;IACjB,UAAU;IACV,SAAS;IACT,WAAW;IACX,8BAA8B;IAC9B,sBAAsB;IACtB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;CACtB;AACD;MACM,aAAa;MACb,aAAa;MACb,aAAa;CAClB;AACD;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mDAAmD;UAC3C,2CAA2C;CACpD;AACD;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,OAAO;IACP,QAAQ;IACR,kLAAkL;IAClL,6EAA6E;YACrE,qEAAqE;CAChF;AACD;AACA;IACI,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;IACI,oCAAoC;YAC5B,4BAA4B;CACvC;CACA;AACD;AACA;IACI,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;IACI,oCAAoC;YAC5B,4BAA4B;CACvC;CACA;AACD;EACE,sBAAsB;CACvB;AACD;AACA;IACI,uBAAuB;IACvB,aAAa;IACb,oBAAoB;IACpB,cAAc;IACd,+BAA+B;IAC/B,oBAAoB;IACpB,gBAAgB;IAChB,uBAAuB;CAC1B;AACD;MACM,iBAAiB;CACtB;AACD;MACM,eAAe;CACpB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,uBAAuB;UACnB,oBAAoB;cAChB,sBAAsB;MAC9B,mBAAmB;CACxB;AACD;QACQ,6BAA6B;QAC7B,8BAA8B;YAC1B,2BAA2B;gBACvB,uBAAuB;QAC/B,wBAAwB;YACpB,qBAAqB;gBACjB,4BAA4B;QACpC,yBAAyB;YACrB,sBAAsB;gBAClB,wBAAwB;CACvC;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;QACQ,gBAAgB;QAChB,eAAe;CACtB;AACD;QACQ,YAAY;QACZ,aAAa;CACpB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,YAAY;QACZ,0BAA0B;YACtB,uBAAuB;gBACnB,+BAA+B;CAC9C;AACD;UACU,eAAe;CACxB;AACD;UACU,eAAe;CACxB;AACD;MACM,oBAAoB;MACpB,sBAAsB;CAC3B;AACD;MACM,sBAAsB;MACtB,YAAY;CACjB;AACD;MACM,eAAe;CACpB;AACD;MACM,sBAAsB;MACtB,UAAU;MACV,YAAY;MACZ,aAAa;MACb,kBAAkB;CACvB;AACD;MACM,uBAAuB;MACvB,YAAY;MACZ,aAAa;MACb,kBAAkB;MAClB,mBAAmB;MACnB,oBAAoB;MACpB,8BAA8B;MAC9B,sBAAsB;MACtB,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;MAC5B,yBAAyB;UACrB,sBAAsB;cAClB,wBAAwB;MAChC,sBAAsB;CAC3B;AACD;QACQ,YAAY;CACnB;AACD;QACQ,qBAAqB;QACrB,aAAa;QACb,uBAAuB;CAC9B;AACD;QACQ,0BAA0B;CACjC;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,wBAAwB;UACpB,qBAAqB;cACjB,uBAAuB;MAC/B,SAAS;MACT,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;QACQ,gBAAgB;QAChB,gBAAgB;CACvB;AACD;MACM,YAAY;CACjB;AACD;MACM,YAAY;MACZ,cAAc;CACnB;AACD;MACM,yBAAyB;UACrB,sBAAsB;cAClB,wBAAwB;CACrC;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;CACrB;AACD;UACU,kBAAkB;CAC3B;AACD;UACU,YAAY;CACrB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;CACA","file":"PackageRow.vue","sourcesContent":["\n.status[data-v-47f383f2] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-47f383f2], .status.completed[data-v-47f383f2] {\n    background: #26D97A;\n}\n.status.canceled[data-v-47f383f2], .status.cancelled[data-v-47f383f2], .status.failed[data-v-47f383f2] {\n    background: #bbb;\n}\n.status.upcoming[data-v-47f383f2] {\n    background: #f38d56;\n}\n.status.onboard[data-v-47f383f2] {\n    background: #dc3168;\n}\n.status.ready[data-v-47f383f2] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-47f383f2], .status.requires_dispatch[data-v-47f383f2] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-47f383f2] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-47f383f2] {\n    background: #5662f3;\n}\n.flight-status[data-v-47f383f2] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-47f383f2] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-47f383f2] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-47f383f2] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-47f383f2] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-47f383f2] {\n    background-color: #f35656;\n}\n.service-type[data-v-47f383f2] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-47f383f2] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-47f383f2] {\n    background: #26D97A;\n}\n.service-type.black[data-v-47f383f2] {\n    background: #777;\n}\n.service-type.suv[data-v-47f383f2] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-47f383f2] {\n    background: #6dabc3;\n}\n.license-type[data-v-47f383f2] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-47f383f2] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-47f383f2] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-47f383f2] {\n    background-color: #de6c2a;\n}\n.dragslot[data-v-47f383f2] {\n  font-weight: 700;\n  background-color: #fff;\n  padding: 5px;\n  -webkit-box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(0, 0, 0, 0.4);\n  border-radius: 3px;\n}\n.table-item[data-v-47f383f2] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.table-item input[type=\"checkbox\"][data-v-47f383f2] {\n    margin-top: 0;\n    width: auto;\n}\n.table-item td[data-v-47f383f2] {\n    padding: 5px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.table-item td a[data-v-47f383f2] {\n      font-weight: 700;\n}\n.table-item td.map-button[data-v-47f383f2] {\n      padding: 10px;\n}\n.table-item td.map-button a[data-v-47f383f2] {\n        color: #fff;\n        background-color: #aaa;\n        width: 30px;\n        height: 30px;\n        line-height: 30px;\n        text-align: center;\n        display: inline-block;\n        border-radius: 30px;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.table-item td.map-button a i[data-v-47f383f2] {\n          line-height: inherit;\n}\n.table-item td.map-button a.disabled[data-v-47f383f2] {\n          pointer-events: none;\n          opacity: 0.5;\n          background-color: #bbb;\n}\n.table-item td.map-button a.selected[data-v-47f383f2] {\n          background-color: #26D97A;\n}\n.table-item td.pool-yes[data-v-47f383f2] {\n      color: #26D97A;\n}\n.table-item td.pool-no[data-v-47f383f2] {\n      color: #F20D0D;\n}\n.table-item td.pkg-check[data-v-47f383f2] {\n      width: 24px !important;\n}\n.table-item td.pkg-id[data-v-47f383f2] {\n      width: 53px !important;\n}\n.table-item td.pkg-status[data-v-47f383f2] {\n      width: 90px !important;\n}\n.table-item td.pkg-pickup-time[data-v-47f383f2] {\n      width: 80px !important;\n}\n.table-item td.pkg-pickup[data-v-47f383f2], .table-item td.pkg-dropoff[data-v-47f383f2] {\n      width: 140px !important;\n}\n.table-item td.pkg-driver[data-v-47f383f2] {\n      width: 86px !important;\n}\n.table-item td.pkg-payment[data-v-47f383f2] {\n      width: 65px !important;\n}\n.table-item td.pkg-ada[data-v-47f383f2] {\n      width: 50px !important;\n}\n.table-item td.pkg-stops[data-v-47f383f2] {\n      width: 47px !important;\n}\n.table-item td.pkg-pax[data-v-47f383f2] {\n      width: 32px !important;\n}\n.table-item td.pkg-luggage[data-v-47f383f2] {\n      width: 66px !important;\n}\n.table-item td.pkg-in-pool[data-v-47f383f2] {\n      width: 43px !important;\n}\n.table-item td.pkg-map[data-v-47f383f2] {\n      width: 40px !important;\n}\n.last-dropoff[data-v-47f383f2] {\n  position: relative;\n  text-decoration: underline;\n  font-weight: 700;\n}\n.last-dropoff .eta-popup[data-v-47f383f2] {\n    position: absolute;\n    top: 0;\n    left: 100%;\n    background-color: #e5e5e5;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n    padding: 10px;\n    overflow: hidden;\n    height: 0;\n    width: 0;\n    padding: 0;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n    text-decoration: none;\n    font-weight: 400;\n    border-radius: 3px;\n    text-align: center;\n}\n.last-dropoff .eta-popup.show[data-v-47f383f2] {\n      padding: 5px;\n      width: 170px;\n      height: auto;\n}\n.status.pending-offer[data-v-47f383f2] {\n  background: #ef7a0b;\n  line-height: 12px;\n  position: relative;\n  overflow: hidden;\n  -webkit-box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);\n}\n.status.pending-offer[data-v-47f383f2]:after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background: linear-gradient(130deg, rgba(227, 227, 227, 0) 0%, rgba(227, 227, 227, 0) 40%, rgba(255, 255, 255, 0.7) 50%, rgba(227, 227, 227, 0) 60%, rgba(227, 227, 227, 0) 100%);\n    -webkit-animation: gradient-animation_2-data-v-47f383f2 1.2s linear infinite;\n            animation: gradient-animation_2-data-v-47f383f2 1.2s linear infinite;\n}\n@-webkit-keyframes gradient-animation_2-data-v-47f383f2 {\n0% {\n    -webkit-transform: translateX(-100%);\n            transform: translateX(-100%);\n}\n100% {\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%);\n}\n}\n@keyframes gradient-animation_2-data-v-47f383f2 {\n0% {\n    -webkit-transform: translateX(-100%);\n            transform: translateX(-100%);\n}\n100% {\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%);\n}\n}\n.timer[data-v-47f383f2] {\n  display: inline-block;\n}\n@media only screen and (max-width: 430px) {\n.table-card[data-v-47f383f2] {\n    border: 1px solid #ccc;\n    margin: 10px;\n    margin-bottom: 15px;\n    padding: 10px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-size: 13px;\n    background-color: #fff;\n}\n.table-card a[data-v-47f383f2] {\n      font-weight: 900;\n}\n.table-card i[data-v-47f383f2] {\n      color: #0d79f2;\n}\n.table-card > div[data-v-47f383f2] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n      margin-bottom: 3px;\n}\n.table-card > div.see-more[data-v-47f383f2] {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        -webkit-box-pack: start;\n            -ms-flex-pack: start;\n                justify-content: flex-start;\n        -webkit-box-align: start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n}\n.table-card .toggle-div[data-v-47f383f2] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .toggle-div .toggle[data-v-47f383f2] {\n        font-size: 16px;\n        color: #0e79f2;\n}\n.table-card .toggle-div svg[data-v-47f383f2] {\n        width: 15px;\n        height: 15px;\n}\n.table-card .toggle-div .row-7[data-v-47f383f2] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        width: 100%;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n}\n.table-card .toggle-div .row-7 .pool-yes i[data-v-47f383f2] {\n          color: #26D97A;\n}\n.table-card .toggle-div .row-7 .pool-no i[data-v-47f383f2] {\n          color: #F20D0D;\n}\n.table-card .row-1 .link[data-v-47f383f2] {\n      padding-bottom: 5px;\n      display: inline-block;\n}\n.table-card .row-1 .rtg[data-v-47f383f2] {\n      display: inline-block;\n      margin: 4px;\n}\n.table-card .row-1 i[data-v-47f383f2] {\n      color: #26D97A;\n}\n.table-card .row-1 input[data-v-47f383f2] {\n      display: inline-block;\n      margin: 0;\n      width: 15px;\n      height: 15px;\n      margin-right: 5px;\n}\n.table-card .row-1 .map-button a[data-v-47f383f2] {\n      background-color: #aaa;\n      width: 30px;\n      height: 30px;\n      line-height: 30px;\n      text-align: center;\n      border-radius: 30px;\n      -webkit-transition: all 250ms;\n      transition: all 250ms;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      text-decoration: none;\n}\n.table-card .row-1 .map-button a i[data-v-47f383f2] {\n        color: #fff;\n}\n.table-card .row-1 .map-button a.disabled[data-v-47f383f2] {\n        pointer-events: none;\n        opacity: 0.5;\n        background-color: #bbb;\n}\n.table-card .row-1 .map-button a.selected[data-v-47f383f2] {\n        background-color: #26D97A;\n}\n.table-card .row-2[data-v-47f383f2] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: unset;\n          -ms-flex-pack: unset;\n              justify-content: unset;\n      gap: 5px;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .row-2 .image img[data-v-47f383f2] {\n        min-width: 30px;\n        max-width: 30px;\n}\n.table-card .row-7 strong[data-v-47f383f2] {\n      color: #666;\n}\n.table-card .row-7 i[data-v-47f383f2] {\n      color: #666;\n      margin: 0 3px;\n}\n.table-card .row-8[data-v-47f383f2] {\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.table-card .row-8 .actions[data-v-47f383f2] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.table-card .row-8 .actions span[data-v-47f383f2] {\n          padding: 8px 20px;\n}\n.table-card .row-8 .actions .notes i[data-v-47f383f2] {\n          color: #fff;\n}\n.table-card .clock i[data-v-47f383f2] {\n      color: #F25E0D;\n}\n.table-card .pickup i[data-v-47f383f2] {\n      color: #d92626;\n}\n.table-card .dropoff i[data-v-47f383f2] {\n      color: #26D97A;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('drag',{staticClass:"table-item",attrs:{"tag":"tr","transfer-data":_vm.opPackage,"draggable":!_vm.inMap},on:{"dragstart":function($event){return _vm.$store.commit('routing/setDropzoneShow', true)},"dragend":function($event){return _vm.$store.commit('routing/setDropzoneShow', false)}}},[_c('div',{staticClass:"dragslot",attrs:{"slot":"image"},slot:"image"},[_vm._v("Package "+_vm._s(_vm.opPackage.id))]),_vm._v(" "),_c('td',{staticClass:"pkg-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedPackages),expression:"checkedPackages"}],attrs:{"type":"checkbox"},domProps:{"value":_vm.opPackage.id,"checked":Array.isArray(_vm.checkedPackages)?_vm._i(_vm.checkedPackages,_vm.opPackage.id)>-1:(_vm.checkedPackages)},on:{"change":function($event){var $$a=_vm.checkedPackages,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.opPackage.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedPackages=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedPackages=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedPackages=$$c}}}})]),_vm._v(" "),_c('td',{staticClass:"pkg-id"},[_c('a',{attrs:{"href":'/#/package/' + _vm.opPackage.id,"target":"_blank"}},[_vm._v(_vm._s(_vm.opPackage.id))])]),_vm._v(" "),_c('td',{staticClass:"pkg-status"},[(_vm.opPackage.pendingOffer && _vm.opPackage.pendingOffer.show)?_c('div',[_c('span',{staticClass:"status pending-offer"},[_vm._v("Pending Offer")]),_vm._v(" "),(_vm.checkingDriver)?_c('i',{staticClass:"fas fa-spinner fa-spin"}):_c('b',{staticClass:"timer"},[_vm._v(_vm._s(_vm.timer)+"s")])]):_c('div',{class:['status', _vm.opPackage.statusClass]},[_vm._v(_vm._s(_vm.opPackage.status))])]),_vm._v(" "),_c('td',{staticClass:"pkg-pickup-time",on:{"dblclick":function($event){return _vm.editPickupDate(_vm.opPackage)}}},[_vm._v(_vm._s(_vm.opPackage.pickupTime))]),_vm._v(" "),_c('td',{staticClass:"pkg-pickup"},[_vm._v(_vm._s(_vm.getAddress(_vm.opPackage.rsvps[0].pickup)))]),_vm._v(" "),_c('td',{staticClass:"pkg-dropoff"},[(_vm.opPackage.status === 'ONBOARD')?_c('div',{staticClass:"last-dropoff"},[_c('span',{on:{"mouseover":_vm.showEtaPopup,"mouseout":_vm.hideEtaPopup}},[_vm._v(_vm._s(_vm.getAddress(_vm.opPackage.rsvps[_vm.opPackage.rsvps.length - 1].dropoff)))]),_vm._v(" "),_c('div',{class:{ 'eta-popup': true, show: _vm.etaPopup.show }},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.etaPopup.loading),expression:"etaPopup.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('strong',{directives:[{name:"show",rawName:"v-show",value:(!_vm.etaPopup.loading),expression:"!etaPopup.loading"}]},[_vm._v(_vm._s(_vm.etaPopup.label))])])]):_c('div',[_vm._v(_vm._s(_vm.getAddress(_vm.opPackage.rsvps[_vm.opPackage.rsvps.length - 1].dropoff)))])]),_vm._v(" "),_c('td',{staticClass:"pkg-service"},[_c('span',{staticClass:"service-type",style:({background: _vm.opPackage.service.color})},[_vm._v(_vm._s(_vm.opPackage.service.label))])]),_vm._v(" "),_c('td',{staticClass:"pkg-driver"},[(_vm.opPackage.driver === null)?_c('span',[_vm._v("N/A")]):_c('div',[_c('a',{attrs:{"href":'/#/provider/' + _vm.opPackage.driver.ID,"target":"_blank"}},[_vm._v("\n        "+_vm._s(_vm.opPackage.driver.firstName)+" "+_vm._s(_vm.opPackage.driver.lastName)+"\n      ")]),_vm._v(" "),(_vm.opPackage.driver.phone !== null && _vm.opPackage.driver.phone !== '')?_c('div',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.callPhone(_vm.opPackage.driver)}}},[_vm._v("\n         ("+_vm._s(_vm.opPackage.driver.phone)+")\n        ")])]):_vm._e()])]),_vm._v(" "),_c('td',{staticClass:"pkg-payment"},[_vm._v("$"+_vm._s((_vm.opPackage.payment + _vm.opPackage.bonus + _vm.opPackage.tip + _vm.opPackage.gasFee).toFixed(2)))]),_vm._v(" "),_c('td',{staticClass:"pkg-ada"},[(_vm.opPackage.ada === null || (!_vm.opPackage.ada.wheelchair && !_vm.opPackage.ada.serviceDog))?_c('div',[_vm._v("N/A")]):_c('div',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.opPackage.ada.serviceDog),expression:"opPackage.ada.serviceDog"}]},[_c('svg-dog')],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.opPackage.ada.wheelchair),expression:"opPackage.ada.wheelchair"}]},[_c('svg-wheelchair')],1)])]),_vm._v(" "),_c('td',{staticClass:"pkg-stops"},[_vm._v(_vm._s(_vm.opPackage.stops/2))]),_vm._v(" "),_c('td',{staticClass:"pkg-pax"},[_vm._v(_vm._s(_vm.opPackage.pax))]),_vm._v(" "),_c('td',{staticClass:"pkg-luggage"},[_vm._v(_vm._s(_vm.opPackage.luggage))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.opPackage.inPool),expression:"opPackage.inPool"}],staticClass:"pool-yes pkg-in-pool"},[_c('i',{staticClass:"fas fa-check-circle fa-fw fa-lg"})]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(!_vm.opPackage.inPool),expression:"!opPackage.inPool"}],staticClass:"pool-no pkg-in-pool"},[_c('i',{staticClass:"fas fa-times-circle fa-fw fa-lg"})]),_vm._v(" "),_c('td',{staticClass:"map-button pkg-map"},[_c('a',{class:{ selected: _vm.inMap },attrs:{"href":"javascript:;"},on:{"click":_vm.toggleInMap}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])])]):_c('div',{staticClass:"table-card"},[_c('div',{staticClass:"row-1"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedPackages),expression:"checkedPackages"}],attrs:{"type":"checkbox"},domProps:{"value":_vm.opPackage.id,"checked":Array.isArray(_vm.checkedPackages)?_vm._i(_vm.checkedPackages,_vm.opPackage.id)>-1:(_vm.checkedPackages)},on:{"change":function($event){var $$a=_vm.checkedPackages,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.opPackage.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedPackages=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedPackages=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedPackages=$$c}}}}),_vm._v(" "),_c('a',{attrs:{"href":'/#/package/' + _vm.opPackage.id,"target":"_blank"}},[_vm._v(_vm._s(_vm.opPackage.id))]),_vm._v(" "),_c('div',{class:'status ' + _vm.opPackage.statusClass},[_vm._v(_vm._s(_vm.opPackage.status))])]),_vm._v(" "),_c('div',{staticClass:"map-button",on:{"click":_vm.toggleInMap}},[_c('a',{class:{ selected: _vm.inMap },attrs:{"href":"javascript:;"}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])])]),_vm._v(" "),_c('div',[_c('div',[_vm._v("Pickup Time: "+_vm._s(_vm.opPackage.pickupTime))])]),_vm._v(" "),_c('div',[_c('div',[_vm._v("First Pickup: "+_vm._s(_vm.getAddress(_vm.opPackage.rsvps[0].pickup)))])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Last Drop-Off:\n      "),(_vm.opPackage.status === 'ONBOARD')?_c('div',{staticClass:"last-dropoff"},[_c('span',{on:{"mouseover":_vm.showEtaPopup,"mouseout":_vm.hideEtaPopup}},[_vm._v(_vm._s(_vm.getAddress(_vm.opPackage.rsvps[_vm.opPackage.rsvps.length - 1].dropoff)))]),_vm._v(" "),_c('div',{class:{ 'eta-popup': true, show: _vm.etaPopup.show }},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.etaPopup.loading),expression:"etaPopup.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('strong',{directives:[{name:"show",rawName:"v-show",value:(!_vm.etaPopup.loading),expression:"!etaPopup.loading"}]},[_vm._v(_vm._s(_vm.etaPopup.label))])])]):_c('div',[_vm._v(_vm._s(_vm.getAddress(_vm.opPackage.rsvps[_vm.opPackage.rsvps.length - 1].dropoff)))])])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Driver:\n      "),(_vm.opPackage.driver === null)?_c('span',[_vm._v("N/A")]):_c('div',[_c('a',{attrs:{"href":'/#/provider/' + _vm.opPackage.driver.ID,"target":"_blank"}},[_vm._v("\n          "+_vm._s(_vm.opPackage.driver.firstName)+" "+_vm._s(_vm.opPackage.driver.lastName)+"\n        ")]),_vm._v(" "),(_vm.opPackage.driver.phone !== null && _vm.opPackage.driver.phone !== '')?_c('div',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.callPhone(_vm.opPackage.driver)}}},[_vm._v("\n          ("+_vm._s(_vm.opPackage.driver.phone)+")\n          ")])]):_vm._e()])])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Payment: $"+_vm._s((_vm.opPackage.payment + _vm.opPackage.bonus + _vm.opPackage.tip).toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"toggle-div"},[_c('div',{staticClass:"row-7"},[_c('div',[_c('span',[_c('i',{staticClass:"fas fa-user-friends icon"}),_vm._v(_vm._s(_vm.opPackage.pax))]),_vm._v(" "),_c('span',[_c('i',{staticClass:"fas fa-suitcase icon"}),_vm._v(_vm._s(_vm.opPackage.luggage))]),_vm._v(" "),_c('span',[_c('strong',[_c('i',{staticClass:"fas fa-ban icon"})]),_vm._v(" "+_vm._s(_vm.opPackage.stops/2))]),_vm._v(" "),_c('span',[_c('strong',[_vm._v("ADA:")]),_vm._v(" "),(_vm.opPackage.ada === null || (!_vm.opPackage.ada.wheelchair && !_vm.opPackage.ada.serviceDog))?_c('span',[_vm._v("N/A")]):_c('span',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.opPackage.ada.serviceDog),expression:"opPackage.ada.serviceDog"}]},[_c('svg-dog')],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.opPackage.ada.wheelchair),expression:"opPackage.ada.wheelchair"}]},[_c('svg-wheelchair')],1)])])]),_vm._v(" "),_c('span',[_vm._v("In Pool:\n        "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.opPackage.inPool),expression:"opPackage.inPool"}],staticClass:"pool-yes pkg-in-pool"},[_c('i',{staticClass:"fas fa-check-circle fa-fw fa-lg"})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.opPackage.inPool),expression:"!opPackage.inPool"}],staticClass:"pool-no pkg-in-pool"},[_c('i',{staticClass:"fas fa-times-circle fa-fw fa-lg"})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"routing-list"},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scrollLoading && !_vm.forDispatch),expression:"scrollLoading && !forDispatch"}],staticClass:"infinity-loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" Loading\n    ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading && _vm.items.length > 0),expression:"!isLoading && items.length > 0"}],staticClass:"table-container"},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scrollLoading && _vm.forDispatch),expression:"scrollLoading && forDispatch"}],staticClass:"infinity-loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" Loading\n       ")])]),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"select-filter"},[_c('div',{class:'pkg-id sortable' + (_vm.isSorting ? ' disabled': ''),on:{"click":function($event){return _vm.sort('p.ID')}}},[_c('span',[_vm._v("ID")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.packageSort.order === 'p.id'),expression:"packageSort.order === 'p.id'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.packageSort.asc && !_vm.isSorting),expression:"packageSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.packageSort.asc && !_vm.isSorting),expression:"!packageSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('div',{class:'pkg-pickup-time sortable' + (_vm.isSorting ? ' disabled': ''),on:{"click":function($event){return _vm.sort('p.pickupTime')}}},[_c('span',[_vm._v("Pickup Time")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.packageSort.order === 'p.pickupTime'),expression:"packageSort.order === 'p.pickupTime'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.packageSort.asc && !_vm.isSorting),expression:"packageSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.packageSort.asc && !_vm.isSorting),expression:"!packageSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])])]):_vm._e(),_vm._v(" "),_c('table',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobile ? !_vm.isSorting : true),expression:"isMobile ? !isSorting : true"}]},[(!_vm.isMobile)?_c('thead',{staticClass:"fixed-header"},[_c('drag',{staticClass:"table-header",attrs:{"tag":"tr"}},[_c('th',{staticClass:"pkg-chk"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedAll),expression:"checkedAll"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkedAll)?_vm._i(_vm.checkedAll,null)>-1:(_vm.checkedAll)},on:{"change":function($event){var $$a=_vm.checkedAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedAll=$$c}}}})]),_vm._v(" "),_c('th',{class:'pkg-id sortable' + (_vm.isSorting ? ' disabled': ''),on:{"click":function($event){return _vm.sort('p.id')}}},[_c('span',[_vm._v("ID")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.packageSort.order === 'p.id'),expression:"packageSort.order === 'p.id'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.packageSort.asc && !_vm.isSorting),expression:"packageSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.packageSort.asc && !_vm.isSorting),expression:"!packageSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('th',{staticClass:"pkg-status"},[_vm._v("STATUS")]),_vm._v(" "),_c('th',{class:'pkg-pickup-time sortable' + (_vm.isSorting ? ' disabled': ''),on:{"click":function($event){return _vm.sort('p.pickupTime')}}},[_c('span',[_vm._v("PICKUP TIME")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.packageSort.order === 'p.pickupTime'),expression:"packageSort.order === 'p.pickupTime'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.packageSort.asc && !_vm.isSorting),expression:"packageSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.packageSort.asc && !_vm.isSorting),expression:"!packageSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('th',{class:'pkg-pickup sortable' + (_vm.isSorting ? ' disabled': ''),on:{"click":function($event){return _vm.sort('p.firstPickup')}}},[_c('span',[_vm._v("FIRST PICKUP")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.packageSort.order === 'p.firstPickup'),expression:"packageSort.order === 'p.firstPickup'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.packageSort.asc && !_vm.isSorting),expression:"packageSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.packageSort.asc && !_vm.isSorting),expression:"!packageSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('th',{staticClass:"pkg-dropoff"},[_vm._v("LAST DROP-OFF")]),_vm._v(" "),_c('th',{staticClass:"pkg-service"},[_vm._v("SERVICE")]),_vm._v(" "),_c('th',{staticClass:"pkg-driver"},[_vm._v("DRIVER")]),_vm._v(" "),_c('th',{staticClass:"pkg-payment"},[_vm._v("PAYMENT")]),_vm._v(" "),_c('th',{staticClass:"pkg-ada"},[_vm._v("ADA")]),_vm._v(" "),_c('th',{class:'pkg-stops sortable' + (_vm.isSorting ? ' disabled': ''),on:{"click":function($event){return _vm.sort('p.stops')}}},[_c('span',[_vm._v("STOPS")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.packageSort.order === 'p.stops'),expression:"packageSort.order === 'p.stops'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.packageSort.asc && !_vm.isSorting),expression:"packageSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.packageSort.asc && !_vm.isSorting),expression:"!packageSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('th',{class:'pkg-pax sortable' + (_vm.isSorting ? ' disabled': ''),on:{"click":function($event){return _vm.sort('p.pax')}}},[_c('span',[_vm._v("PAX")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.packageSort.order === 'p.pax'),expression:"packageSort.order === 'p.pax'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.packageSort.asc && !_vm.isSorting),expression:"packageSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.packageSort.asc && !_vm.isSorting),expression:"!packageSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('th',{staticClass:"pkg-luggage"},[_vm._v("LUGGAGE")]),_vm._v(" "),_c('th',{class:'pkg-in-pool sortable' + (_vm.isSorting ? ' disabled': ''),on:{"click":function($event){return _vm.sort('p.inPool')}}},[_c('span',[_vm._v("IN POOL")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.packageSort.order === 'p.inPool'),expression:"packageSort.order === 'p.inPool'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.packageSort.asc && !_vm.isSorting),expression:"packageSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.packageSort.asc && !_vm.isSorting),expression:"!packageSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('th',{staticClass:"pkg-map"})])],1):_vm._e(),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(opPackage,index){return _c('package-row',{key:index,attrs:{"opPackage":opPackage,"forDispatch":_vm.forDispatch,"isMobile":_vm.isMobile}})}),1)])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length <= 0 && !_vm.isLoading),expression:"items.length <= 0 && !isLoading"}],staticClass:"empty-reservations"},[_c('arrow-up'),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Oops. Looks like we found nothing.")]),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"table-loader"},[_c('ellipsis-loader'),_vm._v(" "),_c('div',{staticClass:"loader-title"},[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.loadingData.title')))]),_vm._v(" "),_c('div',{staticClass:"loader-text"},[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.loadingData.content')))])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_vm._v("\n      We can't find any reservations or package for that filter."),_c('br'),_vm._v("\n      Please use another one from the form at the top.\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1316);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2c7b305c", content, true, {});

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.padding-L[data-v-56212078] {\n  padding-left: 7px;\n}\n.padding-R[data-v-56212078] {\n  padding-right: 7px;\n}\n@media only screen and (max-width: 430px) {\n.padding-R[data-v-56212078] {\n    padding-right: 0;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Routing/PackagesControl.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;AACA;IACI,iBAAiB;CACpB;CACA","file":"PackagesControl.vue","sourcesContent":["\n.padding-L[data-v-56212078] {\n  padding-left: 7px;\n}\n.padding-R[data-v-56212078] {\n  padding-right: 7px;\n}\n@media only screen and (max-width: 430px) {\n.padding-R[data-v-56212078] {\n    padding-right: 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"packages-control"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-4 columns padding-R"},[_c('a',{class:{'button cta block small error':true, 'disabled':_vm.disableBreakPkg},attrs:{"href":"javascript:;"},on:{"click":_vm.breakPackage}},[_vm._v("BREAK PACKAGE")])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-L padding-R"},[_c('a',{staticClass:"button cta block small warning",attrs:{"href":"javascript:;"},on:{"click":_vm.removeFromPool}},[_vm._v("REMOVE FROM POOL")])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-L"},[_c('a',{staticClass:"button cta block small",attrs:{"href":"javascript:;"},on:{"click":_vm.moveToPool}},[_vm._v("MOVE TO POOL")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1319);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("502b09a3", content, true, {});

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.dragslot[data-v-39609c62] {\n  font-weight: 700;\n  background-color: #fff;\n  padding: 5px;\n  -webkit-box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(0, 0, 0, 0.4);\n  border-radius: 3px;\n}\n.table-container[data-v-39609c62] {\n  padding: 47px 0 0;\n}\n.table-container input[type=\"checkbox\"][data-v-39609c62] {\n    margin-top: 0;\n    width: auto;\n}\n.table-container table[data-v-39609c62] {\n    border-collapse: collapse;\n    width: 100%;\n}\n.table-container .fixed-header[data-v-39609c62] {\n    position: absolute;\n    top: 0;\n}\n.table-container .table-header[data-v-39609c62] {\n    color: #8DA0A9;\n    font-size: 12px;\n    /*border: 1px solid rgba(0,0,0,0.3);*/\n    background-color: #f5f5f5;\n}\n.table-container .table-header th[data-v-39609c62] {\n      padding: 5px;\n}\n.table-container .table-header th.sortable[data-v-39609c62] {\n        cursor: pointer;\n        text-decoration: underline;\n        color: #333;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.table-container .table-header th.sortable.disabled[data-v-39609c62] {\n          pointer-events: none;\n          opacity: 0.5;\n}\n.table-container .table-header th.un-check[data-v-39609c62] {\n        width: 24px;\n}\n.table-container .table-header th.un-id[data-v-39609c62], .table-container .table-header th.un-luggage[data-v-39609c62] {\n        width: 60px;\n}\n.table-container .table-header th.un-pickup-time[data-v-39609c62], .table-container .table-header th.un-btt[data-v-39609c62] {\n        width: 75px;\n}\n.table-container .table-header th.un-pickup span[data-v-39609c62]:first-child, .table-container .table-header th.un-dropoff span[data-v-39609c62]:first-child {\n        width: 211px;\n        display: block;\n}\n.table-container .table-header th.un-flight[data-v-39609c62] {\n        width: 129px;\n}\n.table-container .table-header th.un-ada[data-v-39609c62] {\n        width: 46px;\n}\n.table-container .table-header th.un-pax[data-v-39609c62] {\n        width: 32px;\n}\n.table-container .table-header th.un-map[data-v-39609c62] {\n        width: 30px;\n}\n.empty-reservations[data-v-39609c62] {\n  max-width: 450px;\n  margin: 50px auto;\n  text-align: center;\n}\n.empty-reservations .title[data-v-39609c62] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.empty-reservations .content[data-v-39609c62] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\n.table-loader[data-v-39609c62] {\n  position: relative;\n  width: 300px;\n  margin: 50px auto;\n  text-align: center;\n}\n.table-loader .loader-title[data-v-39609c62] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.table-loader .loader-text[data-v-39609c62] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\n.paging[data-v-39609c62] {\n  margin: 15px auto;\n  width: 103px;\n  opacity: 1;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.paging.disabled[data-v-39609c62] {\n    pointer-events: none;\n    opacity: 0.6;\n}\n.paging .page[data-v-39609c62] {\n    display: inline-block;\n    vertical-align: middle;\n    width: auto;\n}\n.paging .page[data-v-39609c62]:not(:first-child) {\n      margin-left: -5px;\n}\n.paging .page-btn[data-v-39609c62] {\n    background-color: #f5f5f5;\n    border: 1px solid rgba(0, 0, 0, 0.25);\n    color: #777;\n    padding: 5px 5px;\n    font-size: 12px;\n}\n.paging .page-btn.disabled[data-v-39609c62] {\n      pointer-events: none;\n      opacity: 0.5;\n}\n.paging .page-btn i[data-v-39609c62] {\n      line-height: inherit;\n}\n.paging .page-btn.back[data-v-39609c62] {\n      border-top-left-radius: 3px;\n      border-bottom-left-radius: 3px;\n      border-right: 0;\n}\n.paging .page-btn.next[data-v-39609c62] {\n      border-top-right-radius: 3px;\n      border-bottom-right-radius: 3px;\n}\n.paging .page-number[data-v-39609c62] {\n    border-radius: 0;\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    line-height: inherit;\n    font-size: 12px;\n    margin: 0;\n    width: 50px;\n    font-weight: 700;\n    padding: 5px 10px;\n    color: #333;\n    text-align: center;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    outline: 0;\n    -moz-text-align-last: center;\n         text-align-last: center;\n    border-right: 0;\n}\n.infinity-loader[data-v-39609c62] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  -webkit-transform-origin: bottom center;\n          transform-origin: bottom center;\n  text-align: center;\n  font-size: 18px;\n  line-height: 40px;\n}\n.slide-up-enter-active[data-v-39609c62], .slide-up-leave-active[data-v-39609c62] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-39609c62], .slide-up-leave-to[data-v-39609c62] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.select-filter[data-v-39609c62] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin: 0 10px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.select-filter .sortable[data-v-39609c62] {\n      border: 1px solid #ccc;\n      padding: 5px 20px;\n      font-size: 12px;\n      font-weight: 900;\n      text-transform: uppercase;\n      width: 50%;\n      text-align: center;\n      background-color: #fff;\n}\n.table-container[data-v-39609c62] {\n    padding-top: 10px;\n    padding-bottom: 50px;\n}\n.empty-reservations[data-v-39609c62] {\n    padding: 0 10px;\n}\n.empty-reservations .title[data-v-39609c62] {\n      font-size: 18px;\n}\n.empty-reservations .content[data-v-39609c62] {\n      font-size: 12px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Routing/ReservationsTable.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;EAClD,qCAAqC;EACrC,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;IACI,cAAc;IACd,YAAY;CACf;AACD;IACI,0BAA0B;IAC1B,YAAY;CACf;AACD;IACI,mBAAmB;IACnB,OAAO;CACV;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,0BAA0B;CAC7B;AACD;MACM,aAAa;CAClB;AACD;QACQ,gBAAgB;QAChB,2BAA2B;QAC3B,YAAY;QACZ,8BAA8B;QAC9B,sBAAsB;CAC7B;AACD;UACU,qBAAqB;UACrB,aAAa;CACtB;AACD;QACQ,YAAY;CACnB;AACD;QACQ,YAAY;CACnB;AACD;QACQ,YAAY;CACnB;AACD;QACQ,aAAa;QACb,eAAe;CACtB;AACD;QACQ,aAAa;CACpB;AACD;QACQ,YAAY;CACnB;AACD;QACQ,YAAY;CACnB;AACD;QACQ,YAAY;CACnB;AACD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;CACpB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;CACpB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,qBAAqB;IACrB,aAAa;CAChB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;CACf;AACD;MACM,kBAAkB;CACvB;AACD;IACI,0BAA0B;IAC1B,sCAAsC;IACtC,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;CACnB;AACD;MACM,qBAAqB;MACrB,aAAa;CAClB;AACD;MACM,qBAAqB;CAC1B;AACD;MACM,4BAA4B;MAC5B,+BAA+B;MAC/B,gBAAgB;CACrB;AACD;MACM,6BAA6B;MAC7B,gCAAgC;CACrC;AACD;IACI,iBAAiB;IACjB,uBAAuB;IACvB,qCAAqC;IACrC,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;OACtB,sBAAsB;YACjB,iBAAiB;IACzB,WAAW;IACX,6BAA6B;SACxB,wBAAwB;IAC7B,gBAAgB;CACnB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,wCAAwC;UAChC,gCAAgC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;AACA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,yBAAyB;QACrB,sBAAsB;YAClB,wBAAwB;CACnC;AACD;MACM,uBAAuB;MACvB,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MACjB,0BAA0B;MAC1B,WAAW;MACX,mBAAmB;MACnB,uBAAuB;CAC5B;AACD;IACI,kBAAkB;IAClB,qBAAqB;CACxB;AACD;IACI,gBAAgB;CACnB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,gBAAgB;CACrB;CACA","file":"ReservationsTable.vue","sourcesContent":["\n.dragslot[data-v-39609c62] {\n  font-weight: 700;\n  background-color: #fff;\n  padding: 5px;\n  -webkit-box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(0, 0, 0, 0.4);\n  border-radius: 3px;\n}\n.table-container[data-v-39609c62] {\n  padding: 47px 0 0;\n}\n.table-container input[type=\"checkbox\"][data-v-39609c62] {\n    margin-top: 0;\n    width: auto;\n}\n.table-container table[data-v-39609c62] {\n    border-collapse: collapse;\n    width: 100%;\n}\n.table-container .fixed-header[data-v-39609c62] {\n    position: absolute;\n    top: 0;\n}\n.table-container .table-header[data-v-39609c62] {\n    color: #8DA0A9;\n    font-size: 12px;\n    /*border: 1px solid rgba(0,0,0,0.3);*/\n    background-color: #f5f5f5;\n}\n.table-container .table-header th[data-v-39609c62] {\n      padding: 5px;\n}\n.table-container .table-header th.sortable[data-v-39609c62] {\n        cursor: pointer;\n        text-decoration: underline;\n        color: #333;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.table-container .table-header th.sortable.disabled[data-v-39609c62] {\n          pointer-events: none;\n          opacity: 0.5;\n}\n.table-container .table-header th.un-check[data-v-39609c62] {\n        width: 24px;\n}\n.table-container .table-header th.un-id[data-v-39609c62], .table-container .table-header th.un-luggage[data-v-39609c62] {\n        width: 60px;\n}\n.table-container .table-header th.un-pickup-time[data-v-39609c62], .table-container .table-header th.un-btt[data-v-39609c62] {\n        width: 75px;\n}\n.table-container .table-header th.un-pickup span[data-v-39609c62]:first-child, .table-container .table-header th.un-dropoff span[data-v-39609c62]:first-child {\n        width: 211px;\n        display: block;\n}\n.table-container .table-header th.un-flight[data-v-39609c62] {\n        width: 129px;\n}\n.table-container .table-header th.un-ada[data-v-39609c62] {\n        width: 46px;\n}\n.table-container .table-header th.un-pax[data-v-39609c62] {\n        width: 32px;\n}\n.table-container .table-header th.un-map[data-v-39609c62] {\n        width: 30px;\n}\n.empty-reservations[data-v-39609c62] {\n  max-width: 450px;\n  margin: 50px auto;\n  text-align: center;\n}\n.empty-reservations .title[data-v-39609c62] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.empty-reservations .content[data-v-39609c62] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\n.table-loader[data-v-39609c62] {\n  position: relative;\n  width: 300px;\n  margin: 50px auto;\n  text-align: center;\n}\n.table-loader .loader-title[data-v-39609c62] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.table-loader .loader-text[data-v-39609c62] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\n.paging[data-v-39609c62] {\n  margin: 15px auto;\n  width: 103px;\n  opacity: 1;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.paging.disabled[data-v-39609c62] {\n    pointer-events: none;\n    opacity: 0.6;\n}\n.paging .page[data-v-39609c62] {\n    display: inline-block;\n    vertical-align: middle;\n    width: auto;\n}\n.paging .page[data-v-39609c62]:not(:first-child) {\n      margin-left: -5px;\n}\n.paging .page-btn[data-v-39609c62] {\n    background-color: #f5f5f5;\n    border: 1px solid rgba(0, 0, 0, 0.25);\n    color: #777;\n    padding: 5px 5px;\n    font-size: 12px;\n}\n.paging .page-btn.disabled[data-v-39609c62] {\n      pointer-events: none;\n      opacity: 0.5;\n}\n.paging .page-btn i[data-v-39609c62] {\n      line-height: inherit;\n}\n.paging .page-btn.back[data-v-39609c62] {\n      border-top-left-radius: 3px;\n      border-bottom-left-radius: 3px;\n      border-right: 0;\n}\n.paging .page-btn.next[data-v-39609c62] {\n      border-top-right-radius: 3px;\n      border-bottom-right-radius: 3px;\n}\n.paging .page-number[data-v-39609c62] {\n    border-radius: 0;\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    line-height: inherit;\n    font-size: 12px;\n    margin: 0;\n    width: 50px;\n    font-weight: 700;\n    padding: 5px 10px;\n    color: #333;\n    text-align: center;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    outline: 0;\n    -moz-text-align-last: center;\n         text-align-last: center;\n    border-right: 0;\n}\n.infinity-loader[data-v-39609c62] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  -webkit-transform-origin: bottom center;\n          transform-origin: bottom center;\n  text-align: center;\n  font-size: 18px;\n  line-height: 40px;\n}\n.slide-up-enter-active[data-v-39609c62], .slide-up-leave-active[data-v-39609c62] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-39609c62], .slide-up-leave-to[data-v-39609c62] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.select-filter[data-v-39609c62] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin: 0 10px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.select-filter .sortable[data-v-39609c62] {\n      border: 1px solid #ccc;\n      padding: 5px 20px;\n      font-size: 12px;\n      font-weight: 900;\n      text-transform: uppercase;\n      width: 50%;\n      text-align: center;\n      background-color: #fff;\n}\n.table-container[data-v-39609c62] {\n    padding-top: 10px;\n    padding-bottom: 50px;\n}\n.empty-reservations[data-v-39609c62] {\n    padding: 0 10px;\n}\n.empty-reservations .title[data-v-39609c62] {\n      font-size: 18px;\n}\n.empty-reservations .content[data-v-39609c62] {\n      font-size: 12px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationRow_vue__ = __webpack_require__(473);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47bba065_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationRow_vue__ = __webpack_require__(1323);
function injectStyle (ssrContext) {
  __webpack_require__(1321)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47bba065"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47bba065_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1322);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1a91b25e", content, true, {});

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.status[data-v-47bba065] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-47bba065], .status.completed[data-v-47bba065] {\n    background: #26D97A;\n}\n.status.canceled[data-v-47bba065], .status.cancelled[data-v-47bba065], .status.failed[data-v-47bba065] {\n    background: #bbb;\n}\n.status.upcoming[data-v-47bba065] {\n    background: #f38d56;\n}\n.status.onboard[data-v-47bba065] {\n    background: #dc3168;\n}\n.status.ready[data-v-47bba065] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-47bba065], .status.requires_dispatch[data-v-47bba065] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-47bba065] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-47bba065] {\n    background: #5662f3;\n}\n.flight-status[data-v-47bba065] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-47bba065] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-47bba065] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-47bba065] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-47bba065] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-47bba065] {\n    background-color: #f35656;\n}\n.service-type[data-v-47bba065] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-47bba065] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-47bba065] {\n    background: #26D97A;\n}\n.service-type.black[data-v-47bba065] {\n    background: #777;\n}\n.service-type.suv[data-v-47bba065] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-47bba065] {\n    background: #6dabc3;\n}\n.license-type[data-v-47bba065] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-47bba065] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-47bba065] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-47bba065] {\n    background-color: #de6c2a;\n}\n.dragslot[data-v-47bba065] {\n  font-weight: 700;\n  background-color: #fff;\n  padding: 5px;\n  -webkit-box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(0, 0, 0, 0.4);\n  border-radius: 3px;\n}\n.table-item[data-v-47bba065] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.table-item input[type=\"checkbox\"][data-v-47bba065] {\n    margin-top: 0;\n    width: auto;\n}\n.table-item td[data-v-47bba065] {\n    padding: 10px 5px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.table-item td a[data-v-47bba065] {\n      font-weight: 700;\n}\n.table-item td.map-button[data-v-47bba065] {\n      padding: 10px;\n}\n.table-item td.map-button a[data-v-47bba065] {\n        color: #fff;\n        background-color: #aaa;\n        width: 30px;\n        height: 30px;\n        line-height: 30px;\n        text-align: center;\n        display: inline-block;\n        border-radius: 30px;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.table-item td.map-button a i[data-v-47bba065] {\n          line-height: inherit;\n}\n.table-item td.map-button a.disabled[data-v-47bba065] {\n          pointer-events: none;\n          opacity: 0.5;\n          background-color: #bbb;\n}\n.table-item td.map-button a.selected[data-v-47bba065] {\n          background-color: #26D97A;\n}\n.table-item td.flight-column[data-v-47bba065] {\n      width: 130px;\n}\n.table-item td .flight-img[data-v-47bba065] {\n      width: 30px;\n      display: inline-block;\n      vertical-align: top;\n}\n.table-item td .flight-info[data-v-47bba065] {\n      width: 70px;\n      display: inline-block;\n}\n.table-item td .flight-status[data-v-47bba065] {\n      padding: 1px 4px;\n      font-size: 10px;\n}\n.table-item td.pool-yes[data-v-47bba065] {\n      color: #26D97A;\n}\n.table-item td.pool-no[data-v-47bba065] {\n      color: #F20D0D;\n}\n.table-item td.un-check[data-v-47bba065] {\n      width: 24px !important;\n}\n.table-item td.un-id a[data-v-47bba065] {\n      width: 50px !important;\n      display: block;\n}\n.table-item td.un-luggage[data-v-47bba065] {\n      width: 70px !important;\n}\n.table-item td.un-pickup-time span[data-v-47bba065], .table-item td.un-btt span[data-v-47bba065] {\n      width: 65px !important;\n      display: block;\n}\n.table-item td.un-pickup span[data-v-47bba065], .table-item td.un-dropoff span[data-v-47bba065] {\n      width: 195px !important;\n      display: block;\n}\n.table-item td.un-flight .flight-box[data-v-47bba065] {\n      width: 118px !important;\n      display: block;\n}\n.table-item td.un-ada[data-v-47bba065] {\n      width: 50px !important;\n}\n.table-item td.un-pax[data-v-47bba065] {\n      width: 38px !important;\n}\n.table-item td.un-map[data-v-47bba065] {\n      width: 40px !important;\n}\n.table-item .sector-data ul[data-v-47bba065] {\n    text-align: left;\n    margin: 0;\n    padding-left: 15px;\n}\n.rtg[data-v-47bba065] {\n  color: #fff;\n  line-height: 1;\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  margin: 2px 4px;\n  cursor: pointer;\n  padding: 3px 10px;\n  border-radius: 4px;\n  background: #2586f3;\n  letter-spacing: 1px;\n  border-bottom: 3px solid #084991;\n}\n@media only screen and (max-width: 430px) {\n.table-card[data-v-47bba065] {\n    border: 1px solid #ccc;\n    margin: 10px;\n    margin-bottom: 15px;\n    padding: 10px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-size: 13px;\n    background-color: #fff;\n}\n.table-card a[data-v-47bba065] {\n      font-weight: 900;\n}\n.table-card i[data-v-47bba065] {\n      color: #0d79f2;\n}\n.table-card > div[data-v-47bba065] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n      margin-bottom: 3px;\n}\n.table-card > div.see-more[data-v-47bba065] {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        -webkit-box-pack: start;\n            -ms-flex-pack: start;\n                justify-content: flex-start;\n        -webkit-box-align: start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n}\n.table-card .toggle-div[data-v-47bba065] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .toggle-div .toggle[data-v-47bba065] {\n        font-size: 16px;\n        color: #0e79f2;\n}\n.table-card .toggle-div svg[data-v-47bba065] {\n        width: 15px;\n        height: 15px;\n}\n.table-card .row-1 .link[data-v-47bba065] {\n      padding-bottom: 5px;\n      display: inline-block;\n}\n.table-card .row-1 .rtg[data-v-47bba065] {\n      display: inline-block;\n      margin: 4px;\n}\n.table-card .row-1 i[data-v-47bba065] {\n      color: #26D97A;\n}\n.table-card .row-1 input[data-v-47bba065] {\n      display: inline-block;\n      margin: 0;\n      width: 15px;\n      height: 15px;\n      margin-right: 5px;\n}\n.table-card .row-1 .map-button a[data-v-47bba065] {\n      background-color: #aaa;\n      width: 30px;\n      height: 30px;\n      line-height: 30px;\n      text-align: center;\n      border-radius: 30px;\n      -webkit-transition: all 250ms;\n      transition: all 250ms;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      text-decoration: none;\n}\n.table-card .row-1 .map-button a i[data-v-47bba065] {\n        color: #fff;\n}\n.table-card .row-1 .map-button a.disabled[data-v-47bba065] {\n        pointer-events: none;\n        opacity: 0.5;\n        background-color: #bbb;\n}\n.table-card .row-1 .map-button a.selected[data-v-47bba065] {\n        background-color: #26D97A;\n}\n.table-card .row-2[data-v-47bba065] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: unset;\n          -ms-flex-pack: unset;\n              justify-content: unset;\n      gap: 5px;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .row-2 .image img[data-v-47bba065] {\n        min-width: 30px;\n        max-width: 30px;\n}\n.table-card .row-7 strong[data-v-47bba065] {\n      color: #666;\n}\n.table-card .row-7 i[data-v-47bba065] {\n      color: #666;\n      margin: 0 3px;\n}\n.table-card .row-8[data-v-47bba065] {\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.table-card .row-8 .actions[data-v-47bba065] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.table-card .row-8 .actions span[data-v-47bba065] {\n          padding: 8px 20px;\n}\n.table-card .row-8 .actions .notes i[data-v-47bba065] {\n          color: #fff;\n}\n.table-card .clock i[data-v-47bba065] {\n      color: #F25E0D;\n}\n.table-card .pickup i[data-v-47bba065] {\n      color: #d92626;\n}\n.table-card .dropoff i[data-v-47bba065] {\n      color: #26D97A;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Routing/ReservationRow.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;CAC3B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;EAClD,qCAAqC;EACrC,mBAAmB;CACpB;AACD;EACE,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;CACpB;AACD;IACI,cAAc;IACd,YAAY;CACf;AACD;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;CACtB;AACD;MACM,iBAAiB;CACtB;AACD;MACM,cAAc;CACnB;AACD;QACQ,YAAY;QACZ,uBAAuB;QACvB,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,mBAAmB;QACnB,sBAAsB;QACtB,oBAAoB;QACpB,8BAA8B;QAC9B,sBAAsB;CAC7B;AACD;UACU,qBAAqB;CAC9B;AACD;UACU,qBAAqB;UACrB,aAAa;UACb,uBAAuB;CAChC;AACD;UACU,0BAA0B;CACnC;AACD;MACM,aAAa;CAClB;AACD;MACM,YAAY;MACZ,sBAAsB;MACtB,oBAAoB;CACzB;AACD;MACM,YAAY;MACZ,sBAAsB;CAC3B;AACD;MACM,iBAAiB;MACjB,gBAAgB;CACrB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;MACvB,eAAe;CACpB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;MACvB,eAAe;CACpB;AACD;MACM,wBAAwB;MACxB,eAAe;CACpB;AACD;MACM,wBAAwB;MACxB,eAAe;CACpB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;IACI,iBAAiB;IACjB,UAAU;IACV,mBAAmB;CACtB;AACD;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,iCAAiC;CAClC;AACD;AACA;IACI,uBAAuB;IACvB,aAAa;IACb,oBAAoB;IACpB,cAAc;IACd,+BAA+B;IAC/B,oBAAoB;IACpB,gBAAgB;IAChB,uBAAuB;CAC1B;AACD;MACM,iBAAiB;CACtB;AACD;MACM,eAAe;CACpB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,uBAAuB;UACnB,oBAAoB;cAChB,sBAAsB;MAC9B,mBAAmB;CACxB;AACD;QACQ,6BAA6B;QAC7B,8BAA8B;YAC1B,2BAA2B;gBACvB,uBAAuB;QAC/B,wBAAwB;YACpB,qBAAqB;gBACjB,4BAA4B;QACpC,yBAAyB;YACrB,sBAAsB;gBAClB,wBAAwB;CACvC;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;QACQ,gBAAgB;QAChB,eAAe;CACtB;AACD;QACQ,YAAY;QACZ,aAAa;CACpB;AACD;MACM,oBAAoB;MACpB,sBAAsB;CAC3B;AACD;MACM,sBAAsB;MACtB,YAAY;CACjB;AACD;MACM,eAAe;CACpB;AACD;MACM,sBAAsB;MACtB,UAAU;MACV,YAAY;MACZ,aAAa;MACb,kBAAkB;CACvB;AACD;MACM,uBAAuB;MACvB,YAAY;MACZ,aAAa;MACb,kBAAkB;MAClB,mBAAmB;MACnB,oBAAoB;MACpB,8BAA8B;MAC9B,sBAAsB;MACtB,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;MAC5B,yBAAyB;UACrB,sBAAsB;cAClB,wBAAwB;MAChC,sBAAsB;CAC3B;AACD;QACQ,YAAY;CACnB;AACD;QACQ,qBAAqB;QACrB,aAAa;QACb,uBAAuB;CAC9B;AACD;QACQ,0BAA0B;CACjC;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,wBAAwB;UACpB,qBAAqB;cACjB,uBAAuB;MAC/B,SAAS;MACT,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;QACQ,gBAAgB;QAChB,gBAAgB;CACvB;AACD;MACM,YAAY;CACjB;AACD;MACM,YAAY;MACZ,cAAc;CACnB;AACD;MACM,yBAAyB;UACrB,sBAAsB;cAClB,wBAAwB;CACrC;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;CACrB;AACD;UACU,kBAAkB;CAC3B;AACD;UACU,YAAY;CACrB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;CACA","file":"ReservationRow.vue","sourcesContent":["\n.status[data-v-47bba065] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-47bba065], .status.completed[data-v-47bba065] {\n    background: #26D97A;\n}\n.status.canceled[data-v-47bba065], .status.cancelled[data-v-47bba065], .status.failed[data-v-47bba065] {\n    background: #bbb;\n}\n.status.upcoming[data-v-47bba065] {\n    background: #f38d56;\n}\n.status.onboard[data-v-47bba065] {\n    background: #dc3168;\n}\n.status.ready[data-v-47bba065] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-47bba065], .status.requires_dispatch[data-v-47bba065] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-47bba065] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-47bba065] {\n    background: #5662f3;\n}\n.flight-status[data-v-47bba065] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-47bba065] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-47bba065] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-47bba065] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-47bba065] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-47bba065] {\n    background-color: #f35656;\n}\n.service-type[data-v-47bba065] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-47bba065] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-47bba065] {\n    background: #26D97A;\n}\n.service-type.black[data-v-47bba065] {\n    background: #777;\n}\n.service-type.suv[data-v-47bba065] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-47bba065] {\n    background: #6dabc3;\n}\n.license-type[data-v-47bba065] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-47bba065] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-47bba065] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-47bba065] {\n    background-color: #de6c2a;\n}\n.dragslot[data-v-47bba065] {\n  font-weight: 700;\n  background-color: #fff;\n  padding: 5px;\n  -webkit-box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(0, 0, 0, 0.4);\n  border-radius: 3px;\n}\n.table-item[data-v-47bba065] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.table-item input[type=\"checkbox\"][data-v-47bba065] {\n    margin-top: 0;\n    width: auto;\n}\n.table-item td[data-v-47bba065] {\n    padding: 10px 5px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.table-item td a[data-v-47bba065] {\n      font-weight: 700;\n}\n.table-item td.map-button[data-v-47bba065] {\n      padding: 10px;\n}\n.table-item td.map-button a[data-v-47bba065] {\n        color: #fff;\n        background-color: #aaa;\n        width: 30px;\n        height: 30px;\n        line-height: 30px;\n        text-align: center;\n        display: inline-block;\n        border-radius: 30px;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.table-item td.map-button a i[data-v-47bba065] {\n          line-height: inherit;\n}\n.table-item td.map-button a.disabled[data-v-47bba065] {\n          pointer-events: none;\n          opacity: 0.5;\n          background-color: #bbb;\n}\n.table-item td.map-button a.selected[data-v-47bba065] {\n          background-color: #26D97A;\n}\n.table-item td.flight-column[data-v-47bba065] {\n      width: 130px;\n}\n.table-item td .flight-img[data-v-47bba065] {\n      width: 30px;\n      display: inline-block;\n      vertical-align: top;\n}\n.table-item td .flight-info[data-v-47bba065] {\n      width: 70px;\n      display: inline-block;\n}\n.table-item td .flight-status[data-v-47bba065] {\n      padding: 1px 4px;\n      font-size: 10px;\n}\n.table-item td.pool-yes[data-v-47bba065] {\n      color: #26D97A;\n}\n.table-item td.pool-no[data-v-47bba065] {\n      color: #F20D0D;\n}\n.table-item td.un-check[data-v-47bba065] {\n      width: 24px !important;\n}\n.table-item td.un-id a[data-v-47bba065] {\n      width: 50px !important;\n      display: block;\n}\n.table-item td.un-luggage[data-v-47bba065] {\n      width: 70px !important;\n}\n.table-item td.un-pickup-time span[data-v-47bba065], .table-item td.un-btt span[data-v-47bba065] {\n      width: 65px !important;\n      display: block;\n}\n.table-item td.un-pickup span[data-v-47bba065], .table-item td.un-dropoff span[data-v-47bba065] {\n      width: 195px !important;\n      display: block;\n}\n.table-item td.un-flight .flight-box[data-v-47bba065] {\n      width: 118px !important;\n      display: block;\n}\n.table-item td.un-ada[data-v-47bba065] {\n      width: 50px !important;\n}\n.table-item td.un-pax[data-v-47bba065] {\n      width: 38px !important;\n}\n.table-item td.un-map[data-v-47bba065] {\n      width: 40px !important;\n}\n.table-item .sector-data ul[data-v-47bba065] {\n    text-align: left;\n    margin: 0;\n    padding-left: 15px;\n}\n.rtg[data-v-47bba065] {\n  color: #fff;\n  line-height: 1;\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  margin: 2px 4px;\n  cursor: pointer;\n  padding: 3px 10px;\n  border-radius: 4px;\n  background: #2586f3;\n  letter-spacing: 1px;\n  border-bottom: 3px solid #084991;\n}\n@media only screen and (max-width: 430px) {\n.table-card[data-v-47bba065] {\n    border: 1px solid #ccc;\n    margin: 10px;\n    margin-bottom: 15px;\n    padding: 10px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-size: 13px;\n    background-color: #fff;\n}\n.table-card a[data-v-47bba065] {\n      font-weight: 900;\n}\n.table-card i[data-v-47bba065] {\n      color: #0d79f2;\n}\n.table-card > div[data-v-47bba065] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n      margin-bottom: 3px;\n}\n.table-card > div.see-more[data-v-47bba065] {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        -webkit-box-pack: start;\n            -ms-flex-pack: start;\n                justify-content: flex-start;\n        -webkit-box-align: start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n}\n.table-card .toggle-div[data-v-47bba065] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .toggle-div .toggle[data-v-47bba065] {\n        font-size: 16px;\n        color: #0e79f2;\n}\n.table-card .toggle-div svg[data-v-47bba065] {\n        width: 15px;\n        height: 15px;\n}\n.table-card .row-1 .link[data-v-47bba065] {\n      padding-bottom: 5px;\n      display: inline-block;\n}\n.table-card .row-1 .rtg[data-v-47bba065] {\n      display: inline-block;\n      margin: 4px;\n}\n.table-card .row-1 i[data-v-47bba065] {\n      color: #26D97A;\n}\n.table-card .row-1 input[data-v-47bba065] {\n      display: inline-block;\n      margin: 0;\n      width: 15px;\n      height: 15px;\n      margin-right: 5px;\n}\n.table-card .row-1 .map-button a[data-v-47bba065] {\n      background-color: #aaa;\n      width: 30px;\n      height: 30px;\n      line-height: 30px;\n      text-align: center;\n      border-radius: 30px;\n      -webkit-transition: all 250ms;\n      transition: all 250ms;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      text-decoration: none;\n}\n.table-card .row-1 .map-button a i[data-v-47bba065] {\n        color: #fff;\n}\n.table-card .row-1 .map-button a.disabled[data-v-47bba065] {\n        pointer-events: none;\n        opacity: 0.5;\n        background-color: #bbb;\n}\n.table-card .row-1 .map-button a.selected[data-v-47bba065] {\n        background-color: #26D97A;\n}\n.table-card .row-2[data-v-47bba065] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: unset;\n          -ms-flex-pack: unset;\n              justify-content: unset;\n      gap: 5px;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .row-2 .image img[data-v-47bba065] {\n        min-width: 30px;\n        max-width: 30px;\n}\n.table-card .row-7 strong[data-v-47bba065] {\n      color: #666;\n}\n.table-card .row-7 i[data-v-47bba065] {\n      color: #666;\n      margin: 0 3px;\n}\n.table-card .row-8[data-v-47bba065] {\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.table-card .row-8 .actions[data-v-47bba065] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.table-card .row-8 .actions span[data-v-47bba065] {\n          padding: 8px 20px;\n}\n.table-card .row-8 .actions .notes i[data-v-47bba065] {\n          color: #fff;\n}\n.table-card .clock i[data-v-47bba065] {\n      color: #F25E0D;\n}\n.table-card .pickup i[data-v-47bba065] {\n      color: #d92626;\n}\n.table-card .dropoff i[data-v-47bba065] {\n      color: #26D97A;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('drag',{staticClass:"table-item",attrs:{"tag":"tr","transfer-data":_vm.rsvp,"draggable":!_vm.inMap},on:{"dragstart":function($event){return _vm.$store.commit('routing/setDropzoneShow', true)},"dragend":function($event){return _vm.$store.commit('routing/setDropzoneShow', false)}}},[_c('div',{staticClass:"dragslot",attrs:{"slot":"image"},slot:"image"},[_vm._v("Reservation "+_vm._s(_vm.rsvp.id))]),_vm._v(" "),_c('td',{staticClass:"un-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedReservations),expression:"checkedReservations"}],attrs:{"type":"checkbox"},domProps:{"value":_vm.rsvp.id,"checked":Array.isArray(_vm.checkedReservations)?_vm._i(_vm.checkedReservations,_vm.rsvp.id)>-1:(_vm.checkedReservations)},on:{"change":function($event){var $$a=_vm.checkedReservations,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.rsvp.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedReservations=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedReservations=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedReservations=$$c}}}})]),_vm._v(" "),_c('td',{staticClass:"un-id"},[_c('a',{attrs:{"href":"javascript:;","href":'/#/reservation/' + _vm.rsvp.id,"target":"_blank"}},[_vm._v(_vm._s(_vm.rsvp.id))]),_vm._v(" "),(_vm.acceptedRTGStatus(_vm.rsvp.status) && _vm.rsvp.pickup.geofenceType === 'airport')?_c('span',{staticClass:"rtg",on:{"click":function($event){return _vm.showRTG(_vm.rsvp.id)}}},[_vm._v("RTG")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"un-pickup-time"},[_c('span',[_vm._v(_vm._s(_vm.rsvp.pickupTime))])]),_vm._v(" "),_c('td',{staticClass:"un-pickup"},[_c('span',[_vm._v(_vm._s(_vm.getAddress(_vm.rsvp.pickup)))])]),_vm._v(" "),_c('td',{staticClass:"un-dropoff"},[_c('span',[_vm._v(_vm._s(_vm.getAddress(_vm.rsvp.dropoff)))])]),_vm._v(" "),_c('td',{staticClass:"un-service"},[_c('span',{staticClass:"service-type",style:({background: _vm.rsvp.service.color})},[_vm._v(_vm._s(_vm.rsvp.service.label))])]),_vm._v(" "),_c('td',{staticClass:"un-btt"},[_c('span',[_vm._v(_vm._s(_vm.rsvp.beThereTime))])]),_vm._v(" "),_c('td',{staticClass:"flight-column un-flight"},[_c('div',{staticClass:"flight-box"},[_c('div',{staticClass:"flight-img"},[(_vm.rsvp.pickup.geofenceType === 'airport')?_c('img',{attrs:{"src":"/assets/img/arrival.png"}}):_vm._e(),_vm._v(" "),(_vm.rsvp.dropoff.geofenceType === 'airport')?_c('img',{attrs:{"src":"/assets/img/departure.png"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flight-info"},[(_vm.rsvp.flight.airlineCode === null)?_c('span',[_vm._v("N/A")]):_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.showFlightInfo}},[_vm._v("\n            "+_vm._s(_vm.rsvp.flight.airline)+" "+_vm._s(_vm.rsvp.flight.flightNumber)+"\n          ")]),_c('br'),_vm._v(" "),(_vm.rsvp.flight.airlineCode !== null && _vm.flightStatus !== null)?_c('span',{class:'flight-status ' + _vm.flightStatus.class},[_vm._v(_vm._s(_vm.flightStatus.label))]):_vm._e()])])]),_vm._v(" "),_c('td',{staticClass:"un-ada"},[(_vm.rsvp.ada === null || (!_vm.rsvp.ada.wheelchair && !_vm.rsvp.ada.serviceDog))?_c('div',[_vm._v("N/A")]):_c('div',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvp.ada.serviceDog),expression:"rsvp.ada.serviceDog"}]},[_c('svg-dog')],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvp.ada.wheelchair),expression:"rsvp.ada.wheelchair"}]},[_c('svg-wheelchair')],1)])]),_vm._v(" "),_c('td',{staticClass:"un-pax"},[_vm._v(_vm._s(_vm.rsvp.passengers))]),_vm._v(" "),_c('td',{staticClass:"un-luggage"},[_vm._v(_vm._s(_vm.rsvp.luggage))]),_vm._v(" "),_c('td',{staticClass:"map-button un-map",on:{"click":_vm.toggleInMap}},[_c('a',{class:{ selected: _vm.inMap },attrs:{"href":"javascript:;"}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])])]):_c('div',{staticClass:"table-card"},[_c('div',{staticClass:"row-1"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedReservations),expression:"checkedReservations"}],attrs:{"type":"checkbox"},domProps:{"value":_vm.rsvp.id,"checked":Array.isArray(_vm.checkedReservations)?_vm._i(_vm.checkedReservations,_vm.rsvp.id)>-1:(_vm.checkedReservations)},on:{"change":function($event){var $$a=_vm.checkedReservations,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.rsvp.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedReservations=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedReservations=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedReservations=$$c}}}}),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"href":"javascript:;","href":'/#/reservation/' + _vm.rsvp.id,"target":"_blank"}},[_vm._v(_vm._s(_vm.rsvp.id))]),_vm._v(" "),(_vm.acceptedRTGStatus(_vm.rsvp.status) && _vm.rsvp.pickup.geofenceType === 'airport')?_c('span',{staticClass:"rtg",on:{"click":function($event){return _vm.showRTG(_vm.rsvp.id)}}},[_vm._v("RTG")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"map-button",on:{"click":_vm.toggleInMap}},[_c('a',{class:{ selected: _vm.inMap },attrs:{"href":"javascript:;"}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Pickup Time: "+_vm._s(_vm.rsvp.pickupTime))])]),_vm._v(" "),_c('div',{staticClass:"row-2"},[_c('div',{staticClass:"image"},[(_vm.rsvp.pickup.geofenceType === 'airport')?_c('img',{attrs:{"src":"/assets/img/arrival.png"}}):_vm._e(),_vm._v(" "),(_vm.rsvp.dropoff.geofenceType === 'airport')?_c('img',{attrs:{"src":"/assets/img/departure.png"}}):_vm._e()]),_vm._v(" "),_c('div',[(_vm.rsvp.flight.airlineCode === null)?_c('span',[_vm._v("N/A")]):_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.showFlightInfo}},[_vm._v("\n            "+_vm._s(_vm.rsvp.flight.airline)+" "+_vm._s(_vm.rsvp.flight.flightNumber)+"\n          ")]),_c('br'),_vm._v(" "),(_vm.rsvp.flight.airlineCode !== null && _vm.flightStatus !== null)?_c('span',{class:'flight-status ' + _vm.flightStatus.class},[_vm._v(_vm._s(_vm.flightStatus.label))]):_vm._e()])]),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',{staticClass:"row-4"},[_c('div',{staticClass:"pickup"},[_c('i',{staticClass:"fas fa-map-marker-alt icon"}),_vm._v("\n        "+_vm._s(_vm.getAddress(_vm.rsvp.pickup))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"row-5"},[_c('div',{staticClass:"dropoff"},[_c('i',{staticClass:"fas fa-location-arrow icon"}),_vm._v(" "),(_vm.rsvp.isCharter)?_c('span',[_vm._v("--")]):_c('span',[_vm._v(_vm._s(_vm.getAddress(_vm.rsvp.dropoff)))])])]),_vm._v(" "),_c('div',[_c('div',[_vm._v("Be There Time: "+_vm._s(_vm.rsvp.beThereTime))])]),_vm._v(" "),_c('div',{staticClass:"toggle-div"},[_c('div',{staticClass:"row-7"},[_c('div',[_c('span',[_c('i',{staticClass:"fas fa-user-friends icon"}),_vm._v(_vm._s(_vm.rsvp.passengers))]),_vm._v(" "),_c('span',[_c('i',{staticClass:"fas fa-suitcase icon"}),_vm._v(_vm._s(_vm.rsvp.luggage))]),_vm._v(" "),_c('span',[_c('strong',[_vm._v("ADA:")]),_vm._v(" "),(_vm.rsvp.ada === null || (!_vm.rsvp.ada.wheelchair && !_vm.rsvp.ada.serviceDog))?_c('span',[_vm._v("N/A")]):_c('span',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvp.ada.serviceDog),expression:"rsvp.ada.serviceDog"}]},[_c('svg-dog')],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvp.ada.wheelchair),expression:"rsvp.ada.wheelchair"}]},[_c('svg-wheelchair')],1)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading && _vm.items.length > 0),expression:"!isLoading && items.length > 0"}],staticClass:"table-container"},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scrollLoading),expression:"scrollLoading"}],staticClass:"infinity-loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" Loading\n      ")])]),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"select-filter"},[_c('div',{class:'un-id sortable' + (_vm.isSorting ? ' disabled': ''),on:{"click":function($event){return _vm.sort('r.ID')}}},[_c('span',[_vm._v("ID")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.order === 'r.ID'),expression:"rsvpSort.order === 'r.ID'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.asc && !_vm.isSorting),expression:"rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.rsvpSort.asc && !_vm.isSorting),expression:"!rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('div',{class:'un-pickup-time sortable' + (_vm.isSorting ? ' disabled': ''),on:{"click":function($event){return _vm.sort('b.pickupTime')}}},[_c('span',[_vm._v("Pickup Time")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.order === 'b.pickupTime'),expression:"rsvpSort.order === 'b.pickupTime'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.asc && !_vm.isSorting),expression:"rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.rsvpSort.asc && !_vm.isSorting),expression:"!rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])])]):_vm._e(),_vm._v(" "),_c('table',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobile ? !_vm.isSorting : true),expression:"isMobile ? !isSorting : true"}],on:{"scroll":_vm.onScroll}},[(!_vm.isMobile)?_c('thead',{staticClass:"fixed-header"},[_c('drag',{staticClass:"table-header",attrs:{"tag":"tr"}},[_c('th',{staticClass:"un-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedAll),expression:"checkedAll"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkedAll)?_vm._i(_vm.checkedAll,null)>-1:(_vm.checkedAll)},on:{"change":function($event){var $$a=_vm.checkedAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedAll=$$c}}}})]),_vm._v(" "),_c('th',{class:'un-id sortable' + (_vm.isSorting ? ' disabled': ''),on:{"click":function($event){return _vm.sort('r.ID')}}},[_c('span',[_vm._v("ID")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.order === 'r.ID'),expression:"rsvpSort.order === 'r.ID'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.asc && !_vm.isSorting),expression:"rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.rsvpSort.asc && !_vm.isSorting),expression:"!rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('th',{class:'un-pickup-time sortable' + (_vm.isSorting ? ' disabled': ''),on:{"click":function($event){return _vm.sort('b.pickupTime')}}},[_c('span',[_vm._v("PICKUP TIME")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.order === 'b.pickupTime'),expression:"rsvpSort.order === 'b.pickupTime'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.asc && !_vm.isSorting),expression:"rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.rsvpSort.asc && !_vm.isSorting),expression:"!rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('th',{class:'un-pickup sortable' + (_vm.isSorting ? ' disabled': ''),on:{"click":function($event){return _vm.sort('puCity')}}},[_c('span',[_vm._v("PICKUP")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.order === 'puCity'),expression:"rsvpSort.order === 'puCity'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.asc && !_vm.isSorting),expression:"rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.rsvpSort.asc && !_vm.isSorting),expression:"!rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('th',{class:'un-dropoff sortable' + (_vm.isSorting ? ' disabled': ''),on:{"click":function($event){return _vm.sort('doCity')}}},[_c('span',[_vm._v("DROP-OFF")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.order === 'doCity'),expression:"rsvpSort.order === 'doCity'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.asc && !_vm.isSorting),expression:"rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.rsvpSort.asc && !_vm.isSorting),expression:"!rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('th',{staticClass:"un-service"},[_vm._v("SERVICE")]),_vm._v(" "),_c('th',{staticClass:"un-btt"},[_vm._v("BE THERE TIME")]),_vm._v(" "),_c('th',{staticClass:"un-flight"},[_vm._v("FLIGHT")]),_vm._v(" "),_c('th',{staticClass:"un-ada"},[_vm._v("ADA")]),_vm._v(" "),_c('th',{class:'un-pax sortable' + (_vm.isSorting ? ' disabled': ''),on:{"click":function($event){return _vm.sort('b.passengers')}}},[_c('span',[_vm._v("PAX")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.order === 'b.passengers'),expression:"rsvpSort.order === 'b.passengers'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.asc && !_vm.isSorting),expression:"rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.rsvpSort.asc && !_vm.isSorting),expression:"!rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('th',{class:'un-luggage sortable' + (_vm.isSorting ? ' disabled': ''),on:{"click":function($event){return _vm.sort('b.luggage')}}},[_c('span',[_vm._v("LUGGAGE")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.order === 'b.luggage'),expression:"rsvpSort.order === 'b.luggage'"}]},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpSort.asc && !_vm.isSorting),expression:"rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.rsvpSort.asc && !_vm.isSorting),expression:"!rsvpSort.asc && !isSorting"}],staticClass:"fas fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSorting),expression:"isSorting"}],staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('th',{staticClass:"un-map"})])],1):_vm._e(),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(rsvp,index){return _c('reservation-row',{key:index,attrs:{"rsvp":rsvp,"isMobile":_vm.isMobile}})}),1)])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length <= 0 && !_vm.isLoading),expression:"items.length <= 0 && !isLoading"}],staticClass:"empty-reservations"},[_c('arrow-up'),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Oops. Looks like we found nothing.")]),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"table-loader"},[_c('ellipsis-loader'),_vm._v(" "),_c('div',{staticClass:"loader-title"},[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.loadingData.title')))]),_vm._v(" "),_c('div',{staticClass:"loader-text"},[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.loadingData.content')))])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_vm._v("\n      We can't find any reservations or package for that filter."),_c('br'),_vm._v("\n      Please use another one from the form at the top.\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1326);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2d8e0b9c", content, true, {});

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.modal[data-v-72ed28ed] {\n  position: fixed;\n  z-index: 50;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: none;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  resize: vertical;\n}\n.modal .bg-overlay[data-v-72ed28ed] {\n    position: absolute;\n    z-index: 1;\n    background: rgba(0, 0, 0, 0.5);\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n}\n.modal .modal-content[data-v-72ed28ed] {\n    position: relative;\n    z-index: 2;\n    background: #fff;\n    min-height: 150px;\n    border-radius: 6px;\n    padding: 20px;\n    margin: auto;\n    -webkit-box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal.show[data-v-72ed28ed] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.modal.show .modal-content[data-v-72ed28ed] {\n      display: block;\n      -webkit-animation: slide-down .15s ease-out;\n      -moz-animation: slide-down .15s ease-out;\n}\n.pickup-time-modal[data-v-72ed28ed] {\n  padding: 0 !important;\n  overflow: hidden;\n}\n.pickup-time-modal .title[data-v-72ed28ed] {\n    background: #444;\n    padding: 10px;\n    color: #fff;\n    text-align: center;\n    font-weight: 600;\n}\n.pickup-time-modal .box[data-v-72ed28ed] {\n    padding: 20px;\n}\n.pickup-time-modal .centered[data-v-72ed28ed] {\n    text-align: center;\n}\n.pickup-time-modal .fas[data-v-72ed28ed] {\n    margin-bottom: 10px;\n}\n.pickup-time-modal .fas.fa-check[data-v-72ed28ed] {\n      color: #26D97A;\n}\n.pickup-time-modal .fas.fa-times[data-v-72ed28ed] {\n      color: #f20d0d;\n}\n.pickup-time-modal .res-msg[data-v-72ed28ed] {\n    margin-bottom: 30px;\n    font-size: 14px;\n    font-weight: 600;\n}\n.pickup-time-modal .small-4[data-v-72ed28ed] {\n    padding: 10px 10px 10px 0;\n}\n.pickup-time-modal .small-4[data-v-72ed28ed]:last-child {\n      padding-right: 0;\n}\n.pickup-time-modal .small-4 label[data-v-72ed28ed] {\n      font-size: 12px;\n      line-height: 1.2;\n      display: block;\n}\n.pickup-time-modal select[data-v-72ed28ed] {\n    border: 1px solid #ddd;\n    padding: 5px;\n    color: #333;\n    height: 36px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.pickup-time-modal select.has-error[data-v-72ed28ed] {\n      border-color: #f20d0d;\n}\n.pickup-time-modal select[data-v-72ed28ed]:disabled {\n      background-color: #eee;\n}\n.pickup-time-modal .cta.success[data-v-72ed28ed] {\n    margin: 10px 0 5px;\n}\n.error-msg[data-v-72ed28ed] {\n  font-size: 13px;\n  color: #f20d0d;\n  display: block;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Routing/PickupDateModal.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,iBAAiB;CAClB;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,OAAO;IACP,QAAQ;CACX;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,uDAAuD;YAC/C,+CAA+C;IACvD,cAAc;CACjB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;MACM,eAAe;MACf,4CAA4C;MAC5C,yCAAyC;CAC9C;AACD;EACE,sBAAsB;EACtB,iBAAiB;CAClB;AACD;IACI,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;CACpB;AACD;IACI,cAAc;CACjB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;IACI,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;CACpB;AACD;IACI,0BAA0B;CAC7B;AACD;MACM,iBAAiB;CACtB;AACD;MACM,gBAAgB;MAChB,iBAAiB;MACjB,eAAe;CACpB;AACD;IACI,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,wDAAwD;IACxD,6BAA6B;IAC7B,+BAA+B;IAC/B,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,uBAAuB;CAC5B;AACD;IACI,mBAAmB;CACtB;AACD;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;CAChB","file":"PickupDateModal.vue","sourcesContent":["\n.modal[data-v-72ed28ed] {\n  position: fixed;\n  z-index: 50;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: none;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  resize: vertical;\n}\n.modal .bg-overlay[data-v-72ed28ed] {\n    position: absolute;\n    z-index: 1;\n    background: rgba(0, 0, 0, 0.5);\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n}\n.modal .modal-content[data-v-72ed28ed] {\n    position: relative;\n    z-index: 2;\n    background: #fff;\n    min-height: 150px;\n    border-radius: 6px;\n    padding: 20px;\n    margin: auto;\n    -webkit-box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal.show[data-v-72ed28ed] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.modal.show .modal-content[data-v-72ed28ed] {\n      display: block;\n      -webkit-animation: slide-down .15s ease-out;\n      -moz-animation: slide-down .15s ease-out;\n}\n.pickup-time-modal[data-v-72ed28ed] {\n  padding: 0 !important;\n  overflow: hidden;\n}\n.pickup-time-modal .title[data-v-72ed28ed] {\n    background: #444;\n    padding: 10px;\n    color: #fff;\n    text-align: center;\n    font-weight: 600;\n}\n.pickup-time-modal .box[data-v-72ed28ed] {\n    padding: 20px;\n}\n.pickup-time-modal .centered[data-v-72ed28ed] {\n    text-align: center;\n}\n.pickup-time-modal .fas[data-v-72ed28ed] {\n    margin-bottom: 10px;\n}\n.pickup-time-modal .fas.fa-check[data-v-72ed28ed] {\n      color: #26D97A;\n}\n.pickup-time-modal .fas.fa-times[data-v-72ed28ed] {\n      color: #f20d0d;\n}\n.pickup-time-modal .res-msg[data-v-72ed28ed] {\n    margin-bottom: 30px;\n    font-size: 14px;\n    font-weight: 600;\n}\n.pickup-time-modal .small-4[data-v-72ed28ed] {\n    padding: 10px 10px 10px 0;\n}\n.pickup-time-modal .small-4[data-v-72ed28ed]:last-child {\n      padding-right: 0;\n}\n.pickup-time-modal .small-4 label[data-v-72ed28ed] {\n      font-size: 12px;\n      line-height: 1.2;\n      display: block;\n}\n.pickup-time-modal select[data-v-72ed28ed] {\n    border: 1px solid #ddd;\n    padding: 5px;\n    color: #333;\n    height: 36px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.pickup-time-modal select.has-error[data-v-72ed28ed] {\n      border-color: #f20d0d;\n}\n.pickup-time-modal select[data-v-72ed28ed]:disabled {\n      background-color: #eee;\n}\n.pickup-time-modal .cta.success[data-v-72ed28ed] {\n    margin: 10px 0 5px;\n}\n.error-msg[data-v-72ed28ed] {\n  font-size: 13px;\n  color: #f20d0d;\n  display: block;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{'modal':true, 'show':_vm.pickupTimeModal.show}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closePickupTimeModal}}),_vm._v(" "),_c('div',{staticClass:"modal-content pickup-time-modal"},[_c('div',{staticClass:"title"},[_vm._v("Edit Pickup Time")]),_vm._v(" "),(!!_vm.pickupTimeModal.message)?_c('div',{staticClass:"box centered"},[(_vm.pickupTimeModal.success)?_c('i',{staticClass:"fas fa-check fa-5x"}):_c('i',{staticClass:"fas fa-times fa-5x"}),_vm._v(" "),_c('div',{staticClass:"res-msg"},[_vm._v(_vm._s(_vm.pickupTimeModal.message))]),_vm._v(" "),_c('a',{staticClass:"button cta xsmall block",on:{"click":_vm.closePickupTimeModal}},[_vm._v("Close")])]):_c('div',{staticClass:"box"},[_c('datepicker',{staticClass:"datepicker inline",attrs:{"format":_vm.calendarFormat,"disabled":_vm.disabledDate,"inline":true},on:{"input":_vm.changeDate},model:{value:(_vm.pickupTimeModalValue.date),callback:function ($$v) {_vm.$set(_vm.pickupTimeModalValue, "date", $$v)},expression:"pickupTimeModalValue.date"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns small-4 end"},[_c('label',[_vm._v("Hour")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pickupTimeModalValue.hour),expression:"pickupTimeModalValue.hour"}],class:{'has-error':!!_vm.validation.pickupTime},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.pickupTimeModalValue, "hour", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updatePickupDate]}},_vm._l((_vm.maxHour),function(n){return _c('option',{key:n,domProps:{"value":_vm.leadingZero(n)}},[_vm._v(_vm._s(_vm.leadingZero(n)))])}),0)]),_vm._v(" "),_c('div',{staticClass:"columns small-4 end"},[_c('label',[_vm._v("Minute")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pickupTimeModalValue.minute),expression:"pickupTimeModalValue.minute"}],class:{'has-error':!!_vm.validation.pickupTime},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.pickupTimeModalValue, "minute", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updatePickupDate]}},[_c('option',{attrs:{"value":"00"}},[_vm._v("00")]),_vm._v(" "),_vm._l((11),function(n){return _c('option',{key:n,domProps:{"value":_vm.leadingZero(n * 5)}},[_vm._v(_vm._s(_vm.leadingZero(n * 5)))])})],2)]),_vm._v(" "),(!_vm.isMilitaryTime)?_c('div',{staticClass:"columns small-4 end"},[_c('label',[_vm._v("AM/PM")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pickupTimeModalValue.amPm),expression:"pickupTimeModalValue.amPm"}],class:{'has-error':!!_vm.validation.pickupTime},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.pickupTimeModalValue, "amPm", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updatePickupDate]}},[_c('option',{attrs:{"value":"AM"}},[_vm._v("AM")]),_vm._v(" "),_c('option',{attrs:{"value":"PM"}},[_vm._v("PM")])])]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.pickupTime))]),_vm._v(" "),_c('a',{class:{'button cta xsmall success block':true, 'disabled':_vm.pickupTimeModal.loading},on:{"click":_vm.savePickupDate}},[_vm._v("Save")]),_vm._v(" "),_c('a',{class:{'button cta xsmall error block':true, 'disabled':_vm.pickupTimeModal.loading},on:{"click":_vm.closePickupTimeModal}},[_vm._v("Cancel")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1329);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2d408ab7", content, true, {});

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.routing-map[data-v-34d63f0d] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.routing-map .routing-map[data-v-34d63f0d] {\n    display: none;\n}\n.map-here[data-v-34d63f0d] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.stop-info[data-v-34d63f0d] {\n  color: #333;\n  font-size: 12px;\n}\n.stop-info a[data-v-34d63f0d], .stop-info .value[data-v-34d63f0d] {\n    font-weight: 700;\n}\n.stop-info .value[data-v-34d63f0d] {\n    color: #555;\n}\n.stop-info .stop-id[data-v-34d63f0d] {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    padding: 0 0 7px 0;\n    margin-bottom: 10px;\n}\n.stop-info .stop-id > *[data-v-34d63f0d] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.stop-info .stop-location[data-v-34d63f0d] {\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    line-height: 16px;\n    text-align: center;\n    border-radius: 100%;\n    background-color: #F20D0D;\n    margin-right: 5px;\n    color: #fff;\n    font-weight: 700;\n}\n.stop-info .stop-location.pickup[data-v-34d63f0d] {\n      background-color: #26D97A;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Routing/Map2.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;CACd;AACD;IACI,cAAc;CACjB;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;CACd;AACD;EACE,YAAY;EACZ,gBAAgB;CACjB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,YAAY;CACf;AACD;IACI,6CAA6C;IAC7C,mBAAmB;IACnB,oBAAoB;CACvB;AACD;MACM,sBAAsB;MACtB,uBAAuB;CAC5B;AACD;IACI,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;CACpB;AACD;MACM,0BAA0B;CAC/B","file":"Map2.vue","sourcesContent":["\n.routing-map[data-v-34d63f0d] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.routing-map .routing-map[data-v-34d63f0d] {\n    display: none;\n}\n.map-here[data-v-34d63f0d] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.stop-info[data-v-34d63f0d] {\n  color: #333;\n  font-size: 12px;\n}\n.stop-info a[data-v-34d63f0d], .stop-info .value[data-v-34d63f0d] {\n    font-weight: 700;\n}\n.stop-info .value[data-v-34d63f0d] {\n    color: #555;\n}\n.stop-info .stop-id[data-v-34d63f0d] {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    padding: 0 0 7px 0;\n    margin-bottom: 10px;\n}\n.stop-info .stop-id > *[data-v-34d63f0d] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.stop-info .stop-location[data-v-34d63f0d] {\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    line-height: 16px;\n    text-align: center;\n    border-radius: 100%;\n    background-color: #F20D0D;\n    margin-right: 5px;\n    color: #fff;\n    font-weight: 700;\n}\n.stop-info .stop-location.pickup[data-v-34d63f0d] {\n      background-color: #26D97A;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"routing-map"},[_c('div',{staticClass:"map-here",attrs:{"id":"mapHere2"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1332);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0f2760f8", content, true, {});

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.routing-dropzone[data-v-9616ddfa] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.empty-container[data-v-9616ddfa] {\n  display: table;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0);\n  -webkit-transition: all 500ms;\n  transition: all 500ms;\n}\n.empty-container.dragover[data-v-9616ddfa] {\n    background-color: rgba(0, 0, 0, 0.6);\n}\n.empty-container .empty[data-v-9616ddfa] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.empty-container .empty-content[data-v-9616ddfa] {\n    max-width: 350px;\n    padding: 0 15px;\n    margin: 0 auto;\n    text-align: center;\n    font-weight: 700;\n}\n.empty-container .empty-content img[data-v-9616ddfa] {\n      display: block;\n      width: 200px;\n      margin: 0 auto;\n}\n.empty-container .empty-content .title[data-v-9616ddfa] {\n      font-size: 22px;\n      color: #3F2975;\n      margin-top: 15px;\n}\n.empty-container .empty-content .message[data-v-9616ddfa] {\n      margin-top: 5px;\n      font-size: 16px;\n      color: #555;\n}\n.dropzone[data-v-9616ddfa] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.75);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.dropzone.show[data-v-9616ddfa] {\n    top: 0;\n}\n.dropzone .empty-content i[data-v-9616ddfa] {\n    color: #fff;\n}\n.dropzone .empty-content .title[data-v-9616ddfa] {\n    color: #fff;\n}\n.dropzone-items[data-v-9616ddfa] {\n  padding: 10px 10px 5px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 70px);\n  overflow: auto;\n}\n.dropzone-item[data-v-9616ddfa] {\n  position: relative;\n  background-color: #fff;\n  margin-bottom: 5px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  border-radius: 3px;\n}\n.dropzone-item .remove-item[data-v-9616ddfa] {\n    position: absolute;\n    top: 17px;\n    right: 10px;\n    text-decoration: none;\n    color: #F20D0D;\n}\n.dropzone-item a[data-v-9616ddfa] {\n    font-weight: 700;\n}\n.dropzone-item .header[data-v-9616ddfa] {\n    font-size: 12px;\n    padding: 5px;\n}\n.dropzone-item .order[data-v-9616ddfa] {\n    display: inline-block;\n    margin-right: 5px;\n    background-color: #26D97A;\n    color: #fff;\n    width: 20px;\n    height: 20px;\n    line-height: 20px;\n    text-align: center;\n    font-weight: 700;\n    border-radius: 100%;\n}\n.dropzone-item .order.dropoff[data-v-9616ddfa] {\n      background-color: #F20D0D;\n}\n.dropzone-item .icon-label[data-v-9616ddfa] {\n    display: inline-block;\n    margin-left: 10px;\n    color: #555;\n}\n.dropzone-item .icon-label.location[data-v-9616ddfa] {\n      margin: 0;\n      padding: 0 25px 0 5px;\n      color: #555;\n      font-weight: 700;\n      display: block;\n      margin: 5px 0;\n}\n.dropzone-item .icon-label.location i[data-v-9616ddfa] {\n        color: #26D97A;\n}\n.dropzone-item .icon-label.location i.dropoff[data-v-9616ddfa] {\n        color: #F20D0D;\n}\n.dropzone-item .icon-label.time .value[data-v-9616ddfa] {\n      font-weight: 700;\n}\n.dropzone-item .icon-label.validation[data-v-9616ddfa] {\n      color: #229e5c;\n}\n.dropzone-item .icon-label.validation i.success[data-v-9616ddfa] {\n        display: inline-block;\n}\n.dropzone-item .icon-label.validation i.warning[data-v-9616ddfa] {\n        display: none;\n}\n.dropzone-item .icon-label.validation.warning[data-v-9616ddfa] {\n        color: #F25E0D;\n}\n.dropzone-item .icon-label.validation.warning i.success[data-v-9616ddfa] {\n          display: none;\n}\n.dropzone-item .icon-label.validation.warning i.warning[data-v-9616ddfa] {\n          display: inline-block;\n}\n.dropzone-item .body[data-v-9616ddfa] {\n    font-size: 12px;\n    padding: 0 15px 10px 23px;\n    text-align: left;\n}\n.check-route-loading[data-v-9616ddfa] {\n  display: table;\n  position: absolute;\n  bottom: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.9);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.check-route-loading.show[data-v-9616ddfa] {\n    bottom: 0;\n}\n.check-route-loading .title[data-v-9616ddfa] {\n    display: table-cell;\n    vertical-align: middle;\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    color: #555;\n    font-weight: 700;\n    font-size: 18px;\n}\n.check-route-loading .title .text[data-v-9616ddfa] {\n      display: inline-block;\n      margin-top: 100px;\n}\n@media screen and (max-width: 430px) {\n.dropzone-item[data-v-9616ddfa] {\n    margin-bottom: 10px;\n}\n.dropzone-items[data-v-9616ddfa] {\n    height: 100%;\n    padding: 20px 40px;\n    padding-bottom: 150px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Routing/DropZone.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;CACd;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,qCAAqC;CACxC;AACD;IACI,oBAAoB;IACpB,uBAAuB;CAC1B;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;CACpB;AACD;MACM,eAAe;MACf,aAAa;MACb,eAAe;CACpB;AACD;MACM,gBAAgB;MAChB,eAAe;MACf,iBAAiB;CACtB;AACD;MACM,gBAAgB;MAChB,gBAAgB;MAChB,YAAY;CACjB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;CACV;AACD;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,0BAA0B;EAC1B,eAAe;CAChB;AACD;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,eAAe;CAClB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,gBAAgB;IAChB,aAAa;CAChB;AACD;IACI,sBAAsB;IACtB,kBAAkB;IAClB,0BAA0B;IAC1B,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;CACvB;AACD;MACM,0BAA0B;CAC/B;AACD;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;CACf;AACD;MACM,UAAU;MACV,sBAAsB;MACtB,YAAY;MACZ,iBAAiB;MACjB,eAAe;MACf,cAAc;CACnB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,eAAe;CACtB;AACD;MACM,iBAAiB;CACtB;AACD;MACM,eAAe;CACpB;AACD;QACQ,sBAAsB;CAC7B;AACD;QACQ,cAAc;CACrB;AACD;QACQ,eAAe;CACtB;AACD;UACU,cAAc;CACvB;AACD;UACU,sBAAsB;CAC/B;AACD;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;CACpB;AACD;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,2CAA2C;EAC3C,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,UAAU;CACb;AACD;IACI,oBAAoB;IACpB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;CACnB;AACD;MACM,sBAAsB;MACtB,kBAAkB;CACvB;AACD;AACA;IACI,oBAAoB;CACvB;AACD;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;CACzB;CACA","file":"DropZone.vue","sourcesContent":["\n.routing-dropzone[data-v-9616ddfa] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.empty-container[data-v-9616ddfa] {\n  display: table;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0);\n  -webkit-transition: all 500ms;\n  transition: all 500ms;\n}\n.empty-container.dragover[data-v-9616ddfa] {\n    background-color: rgba(0, 0, 0, 0.6);\n}\n.empty-container .empty[data-v-9616ddfa] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.empty-container .empty-content[data-v-9616ddfa] {\n    max-width: 350px;\n    padding: 0 15px;\n    margin: 0 auto;\n    text-align: center;\n    font-weight: 700;\n}\n.empty-container .empty-content img[data-v-9616ddfa] {\n      display: block;\n      width: 200px;\n      margin: 0 auto;\n}\n.empty-container .empty-content .title[data-v-9616ddfa] {\n      font-size: 22px;\n      color: #3F2975;\n      margin-top: 15px;\n}\n.empty-container .empty-content .message[data-v-9616ddfa] {\n      margin-top: 5px;\n      font-size: 16px;\n      color: #555;\n}\n.dropzone[data-v-9616ddfa] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.75);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.dropzone.show[data-v-9616ddfa] {\n    top: 0;\n}\n.dropzone .empty-content i[data-v-9616ddfa] {\n    color: #fff;\n}\n.dropzone .empty-content .title[data-v-9616ddfa] {\n    color: #fff;\n}\n.dropzone-items[data-v-9616ddfa] {\n  padding: 10px 10px 5px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 70px);\n  overflow: auto;\n}\n.dropzone-item[data-v-9616ddfa] {\n  position: relative;\n  background-color: #fff;\n  margin-bottom: 5px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  border-radius: 3px;\n}\n.dropzone-item .remove-item[data-v-9616ddfa] {\n    position: absolute;\n    top: 17px;\n    right: 10px;\n    text-decoration: none;\n    color: #F20D0D;\n}\n.dropzone-item a[data-v-9616ddfa] {\n    font-weight: 700;\n}\n.dropzone-item .header[data-v-9616ddfa] {\n    font-size: 12px;\n    padding: 5px;\n}\n.dropzone-item .order[data-v-9616ddfa] {\n    display: inline-block;\n    margin-right: 5px;\n    background-color: #26D97A;\n    color: #fff;\n    width: 20px;\n    height: 20px;\n    line-height: 20px;\n    text-align: center;\n    font-weight: 700;\n    border-radius: 100%;\n}\n.dropzone-item .order.dropoff[data-v-9616ddfa] {\n      background-color: #F20D0D;\n}\n.dropzone-item .icon-label[data-v-9616ddfa] {\n    display: inline-block;\n    margin-left: 10px;\n    color: #555;\n}\n.dropzone-item .icon-label.location[data-v-9616ddfa] {\n      margin: 0;\n      padding: 0 25px 0 5px;\n      color: #555;\n      font-weight: 700;\n      display: block;\n      margin: 5px 0;\n}\n.dropzone-item .icon-label.location i[data-v-9616ddfa] {\n        color: #26D97A;\n}\n.dropzone-item .icon-label.location i.dropoff[data-v-9616ddfa] {\n        color: #F20D0D;\n}\n.dropzone-item .icon-label.time .value[data-v-9616ddfa] {\n      font-weight: 700;\n}\n.dropzone-item .icon-label.validation[data-v-9616ddfa] {\n      color: #229e5c;\n}\n.dropzone-item .icon-label.validation i.success[data-v-9616ddfa] {\n        display: inline-block;\n}\n.dropzone-item .icon-label.validation i.warning[data-v-9616ddfa] {\n        display: none;\n}\n.dropzone-item .icon-label.validation.warning[data-v-9616ddfa] {\n        color: #F25E0D;\n}\n.dropzone-item .icon-label.validation.warning i.success[data-v-9616ddfa] {\n          display: none;\n}\n.dropzone-item .icon-label.validation.warning i.warning[data-v-9616ddfa] {\n          display: inline-block;\n}\n.dropzone-item .body[data-v-9616ddfa] {\n    font-size: 12px;\n    padding: 0 15px 10px 23px;\n    text-align: left;\n}\n.check-route-loading[data-v-9616ddfa] {\n  display: table;\n  position: absolute;\n  bottom: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.9);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.check-route-loading.show[data-v-9616ddfa] {\n    bottom: 0;\n}\n.check-route-loading .title[data-v-9616ddfa] {\n    display: table-cell;\n    vertical-align: middle;\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    color: #555;\n    font-weight: 700;\n    font-size: 18px;\n}\n.check-route-loading .title .text[data-v-9616ddfa] {\n      display: inline-block;\n      margin-top: 100px;\n}\n@media screen and (max-width: 430px) {\n.dropzone-item[data-v-9616ddfa] {\n    margin-bottom: 10px;\n}\n.dropzone-items[data-v-9616ddfa] {\n    height: 100%;\n    padding: 20px 40px;\n    padding-bottom: 150px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultiDrag", function() { return MultiDragPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sortable", function() { return Sortable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Swap", function() { return SwapPlugin; });
/**!
 * Sortable 1.10.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var version = "1.10.2";

function userAgent(pattern) {
  if (typeof window !== 'undefined' && window.navigator) {
    return !!
    /*@__PURE__*/
    navigator.userAgent.match(pattern);
  }
}

var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);

var captureMode = {
  capture: false,
  passive: false
};

function on(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}

function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}

function matches(
/**HTMLElement*/
el,
/**String*/
selector) {
  if (!selector) return;
  selector[0] === '>' && (selector = selector.substring(1));

  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_) {
      return false;
    }
  }

  return false;
}

function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}

function closest(
/**HTMLElement*/
el,
/**String*/
selector,
/**HTMLElement*/
ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;

    do {
      if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }

      if (el === ctx) break;
      /* jshint boss:true */
    } while (el = getParentOrHost(el));
  }

  return null;
}

var R_SPACE = /\s+/g;

function toggleClass(el, name, state) {
  if (el && name) {
    if (el.classList) {
      el.classList[state ? 'add' : 'remove'](name);
    } else {
      var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
      el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
    }
  }
}

function css(el, prop, val) {
  var style = el && el.style;

  if (style) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, '');
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }

      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style) && prop.indexOf('webkit') === -1) {
        prop = '-webkit-' + prop;
      }

      style[prop] = val + (typeof val === 'string' ? '' : 'px');
    }
  }
}

function matrix(el, selfOnly) {
  var appliedTransforms = '';

  if (typeof el === 'string') {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, 'transform');

      if (transform && transform !== 'none') {
        appliedTransforms = transform + ' ' + appliedTransforms;
      }
      /* jshint boss:true */

    } while (!selfOnly && (el = el.parentNode));
  }

  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  /*jshint -W056 */

  return matrixFn && new matrixFn(appliedTransforms);
}

function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName),
        i = 0,
        n = list.length;

    if (iterator) {
      for (; i < n; i++) {
        iterator(list[i], i);
      }
    }

    return list;
  }

  return [];
}

function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;

  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */


function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window) return;
  var elRect, top, left, bottom, right, height, width;

  if (el !== window && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }

  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    // Adjust for translate()
    container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
    // Not needed on <= IE11

    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
          var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container

          top -= containerRect.top + parseInt(css(container, 'border-top-width'));
          left -= containerRect.left + parseInt(css(container, 'border-left-width'));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
        /* jshint boss:true */

      } while (container = container.parentNode);
    }
  }

  if (undoScale && el !== window) {
    // Adjust for scale()
    var elMatrix = matrix(container || el),
        scaleX = elMatrix && elMatrix.a,
        scaleY = elMatrix && elMatrix.d;

    if (elMatrix) {
      top /= scaleY;
      left /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom = top + height;
      right = left + width;
    }
  }

  return {
    top: top,
    left: left,
    bottom: bottom,
    right: right,
    width: width,
    height: height
  };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */


function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true),
      elSideVal = getRect(el)[elSide];
  /* jshint boss:true */

  while (parent) {
    var parentSideVal = getRect(parent)[parentSide],
        visible = void 0;

    if (parentSide === 'top' || parentSide === 'left') {
      visible = elSideVal >= parentSideVal;
    } else {
      visible = elSideVal <= parentSideVal;
    }

    if (!visible) return parent;
    if (parent === getWindowScrollingElement()) break;
    parent = getParentAutoScrollElement(parent, false);
  }

  return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */


function getChild(el, childNum, options) {
  var currentChild = 0,
      i = 0,
      children = el.children;

  while (i < children.length) {
    if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && children[i] !== Sortable.dragged && closest(children[i], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children[i];
      }

      currentChild++;
    }

    i++;
  }

  return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */


function lastChild(el, selector) {
  var last = el.lastElementChild;

  while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
    last = last.previousElementSibling;
  }

  return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */


function index(el, selector) {
  var index = 0;

  if (!el || !el.parentNode) {
    return -1;
  }
  /* jshint boss:true */


  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index++;
    }
  }

  return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */


function getRelativeScrollOffset(el) {
  var offsetLeft = 0,
      offsetTop = 0,
      winScroller = getWindowScrollingElement();

  if (el) {
    do {
      var elMatrix = matrix(el),
          scaleX = elMatrix.a,
          scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }

  return [offsetLeft, offsetTop];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */


function indexOfObject(arr, obj) {
  for (var i in arr) {
    if (!arr.hasOwnProperty(i)) continue;

    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
    }
  }

  return -1;
}

function getParentAutoScrollElement(el, includeSelf) {
  // skip to window
  if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;

  do {
    // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);

      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
        if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
        if (gotSelf || includeSelf) return elem;
        gotSelf = true;
      }
    }
    /* jshint boss:true */

  } while (elem = elem.parentNode);

  return getWindowScrollingElement();
}

function extend(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }

  return dst;
}

function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}

var _throttleTimeout;

function throttle(callback, ms) {
  return function () {
    if (!_throttleTimeout) {
      var args = arguments,
          _this = this;

      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }

      _throttleTimeout = setTimeout(function () {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}

function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}

function scrollBy(el, x, y) {
  el.scrollLeft += x;
  el.scrollTop += y;
}

function clone(el) {
  var Polymer = window.Polymer;
  var $ = window.jQuery || window.Zepto;

  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($) {
    return $(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}

function setRect(el, rect) {
  css(el, 'position', 'absolute');
  css(el, 'top', rect.top);
  css(el, 'left', rect.left);
  css(el, 'width', rect.width);
  css(el, 'height', rect.height);
}

function unsetRect(el) {
  css(el, 'position', '');
  css(el, 'top', '');
  css(el, 'left', '');
  css(el, 'width', '');
  css(el, 'height', '');
}

var expando = 'Sortable' + new Date().getTime();

function AnimationStateManager() {
  var animationStates = [],
      animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation) return;
      var children = [].slice.call(this.el.children);
      children.forEach(function (child) {
        if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });

        var fromRect = _objectSpread({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation


        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);

          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }

        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target: target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;

      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === 'function') callback();
        return;
      }

      var animating = false,
          animationTime = 0;
      animationStates.forEach(function (state) {
        var time = 0,
            target = state.target,
            fromRect = target.fromRect,
            toRect = getRect(target),
            prevFromRect = target.prevFromRect,
            prevToRect = target.prevToRect,
            animatingRect = state.rect,
            targetMatrix = matrix(target, true);

        if (targetMatrix) {
          // Compensate for current animation
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }

        target.toRect = toRect;

        if (target.thisAnimationDuration) {
          // Could also check if animatingRect is between fromRect and toRect
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
          (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            // If returning to same place as started from animation and on same axis
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        } // if fromRect != toRect: animate


        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;

          if (!time) {
            time = _this.options.animation;
          }

          _this.animate(target, animatingRect, toRect, time);
        }

        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function () {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);

      if (!animating) {
        if (typeof callback === 'function') callback();
      } else {
        animationCallbackId = setTimeout(function () {
          if (typeof callback === 'function') callback();
        }, animationTime);
      }

      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, 'transition', '');
        css(target, 'transform', '');
        var elMatrix = matrix(this.el),
            scaleX = elMatrix && elMatrix.a,
            scaleY = elMatrix && elMatrix.d,
            translateX = (currentRect.left - toRect.left) / (scaleX || 1),
            translateY = (currentRect.top - toRect.top) / (scaleY || 1);
        target.animatingX = !!translateX;
        target.animatingY = !!translateY;
        css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
        repaint(target); // repaint

        css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
        css(target, 'transform', 'translate3d(0,0,0)');
        typeof target.animated === 'number' && clearTimeout(target.animated);
        target.animated = setTimeout(function () {
          css(target, 'transition', '');
          css(target, 'transform', '');
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}

function repaint(target) {
  return target.offsetWidth;
}

function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}

var plugins = [];
var defaults = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    // Set default static properties
    for (var option in defaults) {
      if (defaults.hasOwnProperty(option) && !(option in plugin)) {
        plugin[option] = defaults[option];
      }
    }

    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent(eventName, sortable, evt) {
    var _this = this;

    this.eventCanceled = false;

    evt.cancel = function () {
      _this.eventCanceled = true;
    };

    var eventNameGlobal = eventName + 'Global';
    plugins.forEach(function (plugin) {
      if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable

      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread({
          sortable: sortable
        }, evt));
      } // Only fire plugin event if plugin is enabled in this sortable,
      // and plugin has event defined


      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread({
          sortable: sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults, options) {
    plugins.forEach(function (plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized; // Add default options from plugin

      _extends(defaults, initialized.defaults);
    });

    for (var option in sortable.options) {
      if (!sortable.options.hasOwnProperty(option)) continue;
      var modified = this.modifyOption(sortable, option, sortable.options[option]);

      if (typeof modified !== 'undefined') {
        sortable.options[option] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function (plugin) {
      if (typeof plugin.eventProperties !== 'function') return;

      _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function (plugin) {
      // Plugin must exist on the Sortable
      if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin

      if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};

function dispatchEvent(_ref) {
  var sortable = _ref.sortable,
      rootEl = _ref.rootEl,
      name = _ref.name,
      targetEl = _ref.targetEl,
      cloneEl = _ref.cloneEl,
      toEl = _ref.toEl,
      fromEl = _ref.fromEl,
      oldIndex = _ref.oldIndex,
      newIndex = _ref.newIndex,
      oldDraggableIndex = _ref.oldDraggableIndex,
      newDraggableIndex = _ref.newDraggableIndex,
      originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl && rootEl[expando];
  if (!sortable) return;
  var evt,
      options = sortable.options,
      onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent(name, true, true);
  }

  evt.to = toEl || rootEl;
  evt.from = fromEl || rootEl;
  evt.item = targetEl || rootEl;
  evt.clone = cloneEl;
  evt.oldIndex = oldIndex;
  evt.newIndex = newIndex;
  evt.oldDraggableIndex = oldDraggableIndex;
  evt.newDraggableIndex = newDraggableIndex;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;

  var allEventProperties = _objectSpread({}, extraEventProperties, PluginManager.getEventProperties(name, sortable));

  for (var option in allEventProperties) {
    evt[option] = allEventProperties[option];
  }

  if (rootEl) {
    rootEl.dispatchEvent(evt);
  }

  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}

var pluginEvent = function pluginEvent(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      originalEvent = _ref.evt,
      data = _objectWithoutProperties(_ref, ["evt"]);

  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread({
    dragEl: dragEl,
    parentEl: parentEl,
    ghostEl: ghostEl,
    rootEl: rootEl,
    nextEl: nextEl,
    lastDownEl: lastDownEl,
    cloneEl: cloneEl,
    cloneHidden: cloneHidden,
    dragStarted: moved,
    putSortable: putSortable,
    activeSortable: Sortable.active,
    originalEvent: originalEvent,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable: sortable,
        name: name,
        originalEvent: originalEvent
      });
    }
  }, data));
};

function _dispatchEvent(info) {
  dispatchEvent(_objectSpread({
    putSortable: putSortable,
    cloneEl: cloneEl,
    targetEl: dragEl,
    rootEl: rootEl,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex
  }, info));
}

var dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    oldIndex,
    newIndex,
    oldDraggableIndex,
    newDraggableIndex,
    activeGroup,
    putSortable,
    awaitingDragStarted = false,
    ignoreNextClick = false,
    sortables = [],
    tapEvt,
    touchEvt,
    lastDx,
    lastDy,
    tapDistanceLeft,
    tapDistanceTop,
    moved,
    lastTarget,
    lastDirection,
    pastFirstInvertThresh = false,
    isCircumstantialInvert = false,
    targetMoveDistance,
    // For positioning ghost absolutely
ghostRelativeParent,
    ghostRelativeParentInitialScroll = [],
    // (left, top)
_silent = false,
    savedInputChecked = [];
/** @const */

var documentExists = typeof document !== 'undefined',
    PositionGhostAbsolutely = IOS,
    CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
    // This will not pass for IE9, because IE9 DnD only works on anchors
supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
    supportCssPointerEvents = function () {
  if (!documentExists) return; // false when <= IE11

  if (IE11OrLess) {
    return false;
  }

  var el = document.createElement('x');
  el.style.cssText = 'pointer-events:auto';
  return el.style.pointerEvents === 'auto';
}(),
    _detectDirection = function _detectDirection(el, options) {
  var elCSS = css(el),
      elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
      child1 = getChild(el, 0, options),
      child2 = getChild(el, 1, options),
      firstChildCSS = child1 && css(child1),
      secondChildCSS = child2 && css(child2),
      firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
      secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;

  if (elCSS.display === 'flex') {
    return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
  }

  if (elCSS.display === 'grid') {
    return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
  }

  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
    var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
    return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
  }

  return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
},
    _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
  var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
      dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
      dragElOppLength = vertical ? dragRect.width : dragRect.height,
      targetS1Opp = vertical ? targetRect.left : targetRect.top,
      targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
      targetOppLength = vertical ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
},

/**
 * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
 * @param  {Number} x      X position
 * @param  {Number} y      Y position
 * @return {HTMLElement}   Element of the first found nearest Sortable
 */
_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
  var ret;
  sortables.some(function (sortable) {
    if (lastChild(sortable)) return;
    var rect = getRect(sortable),
        threshold = sortable[expando].options.emptyInsertThreshold,
        insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
        insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;

    if (threshold && insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
},
    _prepareGroup = function _prepareGroup(options) {
  function toFn(value, pull) {
    return function (to, from, dragEl, evt) {
      var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;

      if (value == null && (pull || sameGroup)) {
        // Default pull value
        // Default pull and put value if same group
        return true;
      } else if (value == null || value === false) {
        return false;
      } else if (pull && value === 'clone') {
        return value;
      } else if (typeof value === 'function') {
        return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
      } else {
        var otherGroup = (pull ? to : from).options.group.name;
        return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
      }
    };
  }

  var group = {};
  var originalGroup = options.group;

  if (!originalGroup || _typeof(originalGroup) != 'object') {
    originalGroup = {
      name: originalGroup
    };
  }

  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
},
    _hideGhostForTarget = function _hideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', 'none');
  }
},
    _unhideGhostForTarget = function _unhideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', '');
  }
}; // #1184 fix - Prevent click event on fallback if dragged but item not changed position


if (documentExists) {
  document.addEventListener('click', function (evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}

var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;

    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);

    if (nearest) {
      // Create imitation event
      var event = {};

      for (var i in evt) {
        if (evt.hasOwnProperty(i)) {
          event[i] = evt[i];
        }
      }

      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;

      nearest[expando]._onDragOver(event);
    }
  }
};

var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */


function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }

  this.el = el; // root element

  this.options = options = _extends({}, options); // Export instance

  el[expando] = this;
  var defaults = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: 'sortable-ghost',
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
    ignore: 'a, img',
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl) {
      dataTransfer.setData('Text', dragEl.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: 'data-id',
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: 'sortable-fallback',
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window,
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults); // Set default options

  for (var name in defaults) {
    !(name in options) && (options[name] = defaults[name]);
  }

  _prepareGroup(options); // Bind all private methods


  for (var fn in this) {
    if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
      this[fn] = this[fn].bind(this);
    }
  } // Setup drag mode


  this.nativeDraggable = options.forceFallback ? false : supportDraggable;

  if (this.nativeDraggable) {
    // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
  } // Bind events


  if (options.supportPointer) {
    on(el, 'pointerdown', this._onTapStart);
  } else {
    on(el, 'mousedown', this._onTapStart);
    on(el, 'touchstart', this._onTapStart);
  }

  if (this.nativeDraggable) {
    on(el, 'dragover', this);
    on(el, 'dragenter', this);
  }

  sortables.push(this.el); // Restore sorting

  options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager

  _extends(this, AnimationStateManager());
}

Sortable.prototype =
/** @lends Sortable.prototype */
{
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(
  /** Event|TouchEvent */
  evt) {
    if (!evt.cancelable) return;

    var _this = this,
        el = this.el,
        options = this.options,
        preventOnFilter = options.preventOnFilter,
        type = evt.type,
        touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
        target = (touch || evt).target,
        originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
        filter = options.filter;

    _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.


    if (dragEl) {
      return;
    }

    if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
      return; // only left button and enabled
    } // cancel dnd if original target is content editable


    if (originalTarget.isContentEditable) {
      return;
    }

    target = closest(target, options.draggable, el, false);

    if (target && target.animated) {
      return;
    }

    if (lastDownEl === target) {
      // Ignoring duplicate `down`
      return;
    } // Get the index of the dragged element within its parent


    oldIndex = index(target);
    oldDraggableIndex = index(target, options.draggable); // Check filter

    if (typeof filter === 'function') {
      if (filter.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: 'filter',
          targetEl: target,
          toEl: el,
          fromEl: el
        });

        pluginEvent('filter', _this, {
          evt: evt
        });
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    } else if (filter) {
      filter = filter.split(',').some(function (criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);

        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: 'filter',
            targetEl: target,
            fromEl: el,
            toEl: el
          });

          pluginEvent('filter', _this, {
            evt: evt
          });
          return true;
        }
      });

      if (filter) {
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    }

    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    } // Prepare `dragstart`


    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart(
  /** Event */
  evt,
  /** Touch */
  touch,
  /** HTMLElement */
  target) {
    var _this = this,
        el = _this.el,
        options = _this.options,
        ownerDocument = el.ownerDocument,
        dragStartFn;

    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style['will-change'] = 'all';

      dragStartFn = function dragStartFn() {
        pluginEvent('delayEnded', _this, {
          evt: evt
        });

        if (Sortable.eventCanceled) {
          _this._onDrop();

          return;
        } // Delayed drag has been triggered
        // we can re-enable the events: touchmove/mousemove


        _this._disableDelayedDragEvents();

        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        } // Bind the events: dragstart/dragend


        _this._triggerDragStart(evt, touch); // Drag start event


        _dispatchEvent({
          sortable: _this,
          name: 'choose',
          originalEvent: evt
        }); // Chosen item


        toggleClass(dragEl, options.chosenClass, true);
      }; // Disable "draggable"


      options.ignore.split(',').forEach(function (criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mouseup', _this._onDrop);
      on(ownerDocument, 'touchend', _this._onDrop);
      on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)

      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }

      pluginEvent('delayStart', this, {
        evt: evt
      }); // Delay is impossible for native DnD in Edge or IE

      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();

          return;
        } // If the user moves the pointer or let go the click or touch
        // before the delay has been reached:
        // disable the delayed drag


        on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
        on(ownerDocument, 'touchend', _this._disableDelayedDrag);
        on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
        on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
        on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
  /** TouchEvent|PointerEvent **/
  e) {
    var touch = e.touches ? e.touches[0] : e;

    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);

    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._disableDelayedDrag);
    off(ownerDocument, 'touchend', this._disableDelayedDrag);
    off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
    off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(
  /** Event */
  evt,
  /** Touch */
  touch) {
    touch = touch || evt.pointerType == 'touch' && evt;

    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, 'pointermove', this._onTouchMove);
      } else if (touch) {
        on(document, 'touchmove', this._onTouchMove);
      } else {
        on(document, 'mousemove', this._onTouchMove);
      }
    } else {
      on(dragEl, 'dragend', this);
      on(rootEl, 'dragstart', this._onDragStart);
    }

    try {
      if (document.selection) {
        // Timeout neccessary for IE9
        _nextTick(function () {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {}
  },
  _dragStarted: function _dragStarted(fallback, evt) {

    awaitingDragStarted = false;

    if (rootEl && dragEl) {
      pluginEvent('dragStarted', this, {
        evt: evt
      });

      if (this.nativeDraggable) {
        on(document, 'dragover', _checkOutsideTargetEl);
      }

      var options = this.options; // Apply effect

      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost(); // Drag start event

      _dispatchEvent({
        sortable: this,
        name: 'start',
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;

      _hideGhostForTarget();

      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;

      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent) break;
        parent = target;
      }

      dragEl.parentNode[expando]._isOutsideThisEl(target);

      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target: target,
              rootEl: parent
            });

            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }

          target = parent; // store last element
        }
        /* jshint boss:true */
        while (parent = parent.parentNode);
      }

      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(
  /**TouchEvent*/
  evt) {
    if (tapEvt) {
      var options = this.options,
          fallbackTolerance = options.fallbackTolerance,
          fallbackOffset = options.fallbackOffset,
          touch = evt.touches ? evt.touches[0] : evt,
          ghostMatrix = ghostEl && matrix(ghostEl, true),
          scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
          scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
          relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
          dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
          dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging

      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }

        this._onDragStart(evt, true);
      }

      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }

        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, 'webkitTransform', cssMatrix);
        css(ghostEl, 'mozTransform', cssMatrix);
        css(ghostEl, 'msTransform', cssMatrix);
        css(ghostEl, 'transform', cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }

      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    // Bug if using scale(): https://stackoverflow.com/questions/2637058
    // Not being adjusted for
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl,
          rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
          options = this.options; // Position absolutely

      if (PositionGhostAbsolutely) {
        // Get relatively positioned parent
        ghostRelativeParent = container;

        while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }

        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }

        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }

      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, 'transition', '');
      css(ghostEl, 'transform', '');
      css(ghostEl, 'box-sizing', 'border-box');
      css(ghostEl, 'margin', 0);
      css(ghostEl, 'top', rect.top);
      css(ghostEl, 'left', rect.left);
      css(ghostEl, 'width', rect.width);
      css(ghostEl, 'height', rect.height);
      css(ghostEl, 'opacity', '0.8');
      css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
      css(ghostEl, 'zIndex', '100000');
      css(ghostEl, 'pointerEvents', 'none');
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl); // Set transform-origin

      css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
    }
  },
  _onDragStart: function _onDragStart(
  /**Event*/
  evt,
  /**boolean*/
  fallback) {
    var _this = this;

    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent('dragStart', this, {
      evt: evt
    });

    if (Sortable.eventCanceled) {
      this._onDrop();

      return;
    }

    pluginEvent('setupClone', this);

    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.draggable = false;
      cloneEl.style['will-change'] = '';

      this._hideClone();

      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    } // #1143: IFrame support workaround


    _this.cloneId = _nextTick(function () {
      pluginEvent('clone', _this);
      if (Sortable.eventCanceled) return;

      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }

      _this._hideClone();

      _dispatchEvent({
        sortable: _this,
        name: 'clone'
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events

    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      // Undo what was set in _prepareDragStart before drag started
      off(document, 'mouseup', _this._onDrop);
      off(document, 'touchend', _this._onDrop);
      off(document, 'touchcancel', _this._onDrop);

      if (dataTransfer) {
        dataTransfer.effectAllowed = 'move';
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }

      on(document, 'drop', _this); // #1276 fix:

      css(dragEl, 'transform', 'translateZ(0)');
    }

    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on(document, 'selectstart', _this);
    moved = true;

    if (Safari) {
      css(document.body, 'user-select', 'none');
    }
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function _onDragOver(
  /**Event*/
  evt) {
    var el = this.el,
        target = evt.target,
        dragRect,
        targetRect,
        revert,
        options = this.options,
        group = options.group,
        activeSortable = Sortable.active,
        isOwner = activeGroup === group,
        canSort = options.sort,
        fromSortable = putSortable || activeSortable,
        vertical,
        _this = this,
        completedFired = false;

    if (_silent) return;

    function dragOverEvent(name, extra) {
      pluginEvent(name, _this, _objectSpread({
        evt: evt,
        isOwner: isOwner,
        axis: vertical ? 'vertical' : 'horizontal',
        revert: revert,
        dragRect: dragRect,
        targetRect: targetRect,
        canSort: canSort,
        fromSortable: fromSortable,
        target: target,
        completed: completed,
        onMove: function onMove(target, after) {
          return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
        },
        changed: changed
      }, extra));
    } // Capture animation state


    function capture() {
      dragOverEvent('dragOverAnimationCapture');

      _this.captureAnimationState();

      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    } // Return invocation when dragEl is inserted (or completed)


    function completed(insertion) {
      dragOverEvent('dragOverCompleted', {
        insertion: insertion
      });

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }

        if (_this !== fromSortable) {
          // Set ghost class to new sortable's ghost class
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }

        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        } // Animation


        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }

        _this.animateAll(function () {
          dragOverEvent('dragOverAnimationComplete');
          _this._ignoreWhileAnimating = null;
        });

        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      } // Null lastTarget if it is not inside a previously swapped element


      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      } // no bubbling and not fallback


      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted


        !insertion && nearestEmptyInsertDetectEvent(evt);
      }

      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    } // Call when dragEl has been inserted


    function changed() {
      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);

      _dispatchEvent({
        sortable: _this,
        name: 'change',
        toEl: el,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex,
        originalEvent: evt
      });
    }

    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }

    target = closest(target, options.draggable, el, true);
    dragOverEvent('dragOver');
    if (Sortable.eventCanceled) return completedFired;

    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }

    ignoreNextClick = false;

    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
    : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === 'vertical';
      dragRect = getRect(dragEl);
      dragOverEvent('dragOverValid');
      if (Sortable.eventCanceled) return completedFired;

      if (revert) {
        parentEl = rootEl; // actualization

        capture();

        this._hideClone();

        dragOverEvent('revert');

        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }

        return completed(true);
      }

      var elLastChild = lastChild(el, options.draggable);

      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        // If already at end of list: Do not insert
        if (elLastChild === dragEl) {
          return completed(false);
        } // assign target only if condition is true


        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }

        if (target) {
          targetRect = getRect(target);
        }

        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          el.appendChild(dragEl);
          parentEl = el; // actualization

          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0,
            targetBeforeFirstSwap,
            differentLevel = dragEl.parentNode !== el,
            differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
            side1 = vertical ? 'top' : 'left',
            scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
            scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;

        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }

        direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;

        if (direction !== 0) {
          // Check if target is beside dragEl in respective direction (ignoring hidden elements)
          var dragIndex = index(dragEl);

          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
        } // If dragEl is already beside target: Do not insert


        if (direction === 0 || sibling === target) {
          return completed(false);
        }

        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling,
            after = false;
        after = direction === 1;

        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }

          _silent = true;
          setTimeout(_unsilent, 30);
          capture();

          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          } // Undo chrome's scroll adjustment (has no effect on other browsers)


          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }

          parentEl = dragEl.parentNode; // actualization
          // must be done before animation

          if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }

          changed();
          return completed(true);
        }
      }

      if (el.contains(dragEl)) {
        return completed(false);
      }
    }

    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, 'mousemove', this._onTouchMove);
    off(document, 'touchmove', this._onTouchMove);
    off(document, 'pointermove', this._onTouchMove);
    off(document, 'dragover', nearestEmptyInsertDetectEvent);
    off(document, 'mousemove', nearestEmptyInsertDetectEvent);
    off(document, 'touchmove', nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._onDrop);
    off(ownerDocument, 'touchend', this._onDrop);
    off(ownerDocument, 'pointerup', this._onDrop);
    off(ownerDocument, 'touchcancel', this._onDrop);
    off(document, 'selectstart', this);
  },
  _onDrop: function _onDrop(
  /**Event*/
  evt) {
    var el = this.el,
        options = this.options; // Get the index of the dragged element within its parent

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    pluginEvent('drop', this, {
      evt: evt
    });
    parentEl = dragEl && dragEl.parentNode; // Get again after plugin event

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);

    if (Sortable.eventCanceled) {
      this._nulling();

      return;
    }

    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);

    _cancelNextTick(this.cloneId);

    _cancelNextTick(this._dragStartId); // Unbind events


    if (this.nativeDraggable) {
      off(document, 'drop', this);
      off(el, 'dragstart', this._onDragStart);
    }

    this._offMoveEvents();

    this._offUpEvents();

    if (Safari) {
      css(document.body, 'user-select', '');
    }

    css(dragEl, 'transform', '');

    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }

      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        // Remove clone(s)
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }

      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, 'dragend', this);
        }

        _disableDraggable(dragEl);

        dragEl.style['will-change'] = ''; // Remove classes
        // ghostClass is added in dragStarted

        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }

        toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event

        _dispatchEvent({
          sortable: this,
          name: 'unchoose',
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });

        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            // Add event
            _dispatchEvent({
              rootEl: parentEl,
              name: 'add',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            }); // Remove event


            _dispatchEvent({
              sortable: this,
              name: 'remove',
              toEl: parentEl,
              originalEvent: evt
            }); // drag from one list and drop into another


            _dispatchEvent({
              rootEl: parentEl,
              name: 'sort',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });

            _dispatchEvent({
              sortable: this,
              name: 'sort',
              toEl: parentEl,
              originalEvent: evt
            });
          }

          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              // drag & drop within the same list
              _dispatchEvent({
                sortable: this,
                name: 'update',
                toEl: parentEl,
                originalEvent: evt
              });

              _dispatchEvent({
                sortable: this,
                name: 'sort',
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }

        if (Sortable.active) {
          /* jshint eqnull:true */
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }

          _dispatchEvent({
            sortable: this,
            name: 'end',
            toEl: parentEl,
            originalEvent: evt
          }); // Save sorting


          this.save();
        }
      }
    }

    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent('nulling', this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function (el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(
  /**Event*/
  evt) {
    switch (evt.type) {
      case 'drop':
      case 'dragend':
        this._onDrop(evt);

        break;

      case 'dragenter':
      case 'dragover':
        if (dragEl) {
          this._onDragOver(evt);

          _globalDragOver(evt);
        }

        break;

      case 'selectstart':
        evt.preventDefault();
        break;
    }
  },

  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function toArray() {
    var order = [],
        el,
        children = this.el.children,
        i = 0,
        n = children.length,
        options = this.options;

    for (; i < n; i++) {
      el = children[i];

      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }

    return order;
  },

  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function sort(order) {
    var items = {},
        rootEl = this.el;
    this.toArray().forEach(function (id, i) {
      var el = rootEl.children[i];

      if (closest(el, this.options.draggable, rootEl, false)) {
        items[id] = el;
      }
    }, this);
    order.forEach(function (id) {
      if (items[id]) {
        rootEl.removeChild(items[id]);
        rootEl.appendChild(items[id]);
      }
    });
  },

  /**
   * Save the current sorting
   */
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },

  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },

  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function option(name, value) {
    var options = this.options;

    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);

      if (typeof modifiedValue !== 'undefined') {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }

      if (name === 'group') {
        _prepareGroup(options);
      }
    }
  },

  /**
   * Destroy
   */
  destroy: function destroy() {
    pluginEvent('destroy', this);
    var el = this.el;
    el[expando] = null;
    off(el, 'mousedown', this._onTapStart);
    off(el, 'touchstart', this._onTapStart);
    off(el, 'pointerdown', this._onTapStart);

    if (this.nativeDraggable) {
      off(el, 'dragover', this);
      off(el, 'dragenter', this);
    } // Remove draggable attributes


    Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
      el.removeAttribute('draggable');
    });

    this._onDrop();

    this._disableDelayedDragEvents();

    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent('hideClone', this);
      if (Sortable.eventCanceled) return;
      css(cloneEl, 'display', 'none');

      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }

      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable) {
    if (putSortable.lastPutMode !== 'clone') {
      this._hideClone();

      return;
    }

    if (cloneHidden) {
      pluginEvent('showClone', this);
      if (Sortable.eventCanceled) return; // show clone at dragEl or original position

      if (rootEl.contains(dragEl) && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }

      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }

      css(cloneEl, 'display', '');
      cloneHidden = false;
    }
  }
};

function _globalDragOver(
/**Event*/
evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = 'move';
  }

  evt.cancelable && evt.preventDefault();
}

function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt,
      sortable = fromEl[expando],
      onMoveFn = sortable.options.onMove,
      retVal; // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent('move', {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent('move', true, true);
  }

  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);

  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }

  return retVal;
}

function _disableDraggable(el) {
  el.draggable = false;
}

function _unsilent() {
  _silent = false;
}

function _ghostIsLast(evt, vertical, sortable) {
  var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var spacer = 10;
  return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}

function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
      targetLength = vertical ? targetRect.height : targetRect.width,
      targetS1 = vertical ? targetRect.top : targetRect.left,
      targetS2 = vertical ? targetRect.bottom : targetRect.right,
      invert = false;

  if (!invertSwap) {
    // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
      // check if past first invert threshold on side opposite of lastDirection
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        // past first invert threshold, do not restrict inverted threshold to dragEl shadow
        pastFirstInvertThresh = true;
      }

      if (!pastFirstInvertThresh) {
        // dragEl shadow (target move distance shadow)
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
        : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      // Regular
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }

  invert = invert || invertSwap;

  if (invert) {
    // Invert of regular
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }

  return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */


function _getInsertDirection(target) {
  if (index(dragEl) < index(target)) {
    return 1;
  } else {
    return -1;
  }
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */


function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent,
      i = str.length,
      sum = 0;

  while (i--) {
    sum += str.charCodeAt(i);
  }

  return sum.toString(36);
}

function _saveInputCheckedState(root) {
  savedInputChecked.length = 0;
  var inputs = root.getElementsByTagName('input');
  var idx = inputs.length;

  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}

function _nextTick(fn) {
  return setTimeout(fn, 0);
}

function _cancelNextTick(id) {
  return clearTimeout(id);
} // Fixed #973:


if (documentExists) {
  on(document, 'touchmove', function (evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
} // Export utils


Sortable.utils = {
  on: on,
  off: off,
  css: css,
  find: find,
  is: function is(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend: extend,
  throttle: throttle,
  closest: closest,
  toggleClass: toggleClass,
  clone: clone,
  index: index,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild: getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */

Sortable.get = function (element) {
  return element[expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */


Sortable.mount = function () {
  for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins[_key] = arguments[_key];
  }

  if (plugins[0].constructor === Array) plugins = plugins[0];
  plugins.forEach(function (plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }

    if (plugin.utils) Sortable.utils = _objectSpread({}, Sortable.utils, plugin.utils);
    PluginManager.mount(plugin);
  });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */


Sortable.create = function (el, options) {
  return new Sortable(el, options);
}; // Export


Sortable.version = version;

var autoScrolls = [],
    scrollEl,
    scrollRootEl,
    scrolling = false,
    lastAutoScrollX,
    lastAutoScrollY,
    touchEvt$1,
    pointerElemChangedInterval;

function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    }; // Bind all private methods

    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }
  }

  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;

      if (this.sortable.nativeDraggable) {
        on(document, 'dragover', this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on(document, 'pointermove', this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on(document, 'touchmove', this._handleFallbackAutoScroll);
        } else {
          on(document, 'mousemove', this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;

      // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop() {
      if (this.sortable.nativeDraggable) {
        off(document, 'dragover', this._handleAutoScroll);
      } else {
        off(document, 'pointermove', this._handleFallbackAutoScroll);
        off(document, 'touchmove', this._handleFallbackAutoScroll);
        off(document, 'mousemove', this._handleFallbackAutoScroll);
      }

      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this = this;

      var x = (evt.touches ? evt.touches[0] : evt).clientX,
          y = (evt.touches ? evt.touches[0] : evt).clientY,
          elem = document.elementFromPoint(x, y);
      touchEvt$1 = evt; // IE does not seem to have native autoscroll,
      // Edge's autoscroll seems too conditional,
      // MACOS Safari does not have autoscroll,
      // Firefox and Chrome are good

      if (fallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change

        var ogElemScroller = getParentAutoScrollElement(elem, true);

        if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour

          pointerElemChangedInterval = setInterval(function () {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);

            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }

            autoScroll(evt, _this.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x;
          lastAutoScrollY = y;
        }
      } else {
        // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }

        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends(AutoScroll, {
    pluginName: 'scroll',
    initializeByDefault: true
  });
}

function clearAutoScrolls() {
  autoScrolls.forEach(function (autoScroll) {
    clearInterval(autoScroll.pid);
  });
  autoScrolls = [];
}

function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}

var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
  // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
  if (!options.scroll) return;
  var x = (evt.touches ? evt.touches[0] : evt).clientX,
      y = (evt.touches ? evt.touches[0] : evt).clientY,
      sens = options.scrollSensitivity,
      speed = options.scrollSpeed,
      winScroller = getWindowScrollingElement();
  var scrollThisInstance = false,
      scrollCustomFn; // New scroll root, set scrollEl

  if (scrollRootEl !== rootEl) {
    scrollRootEl = rootEl;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;

    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl, true);
    }
  }

  var layersOut = 0;
  var currentParent = scrollEl;

  do {
    var el = currentParent,
        rect = getRect(el),
        top = rect.top,
        bottom = rect.bottom,
        left = rect.left,
        right = rect.right,
        width = rect.width,
        height = rect.height,
        canScrollX = void 0,
        canScrollY = void 0,
        scrollWidth = el.scrollWidth,
        scrollHeight = el.scrollHeight,
        elCSS = css(el),
        scrollPosX = el.scrollLeft,
        scrollPosY = el.scrollTop;

    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
    }

    var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);

    if (!autoScrolls[layersOut]) {
      for (var i = 0; i <= layersOut; i++) {
        if (!autoScrolls[i]) {
          autoScrolls[i] = {};
        }
      }
    }

    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);

      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        /* jshint loopfunc:true */

        autoScrolls[layersOut].pid = setInterval(function () {
          // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely

          }

          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;

          if (typeof scrollCustomFn === 'function') {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
              return;
            }
          }

          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }.bind({
          layer: layersOut
        }), 24);
      }
    }

    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));

  scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);

var drop = function drop(_ref) {
  var originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      dragEl = _ref.dragEl,
      activeSortable = _ref.activeSortable,
      dispatchSortableEvent = _ref.dispatchSortableEvent,
      hideGhostForTarget = _ref.hideGhostForTarget,
      unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent) return;
  var toSortable = putSortable || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();

  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent('spill');
    this.onSpill({
      dragEl: dragEl,
      putSortable: putSortable
    });
  }
};

function Revert() {}

Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl = _ref3.dragEl,
        putSortable = _ref3.putSortable;
    this.sortable.captureAnimationState();

    if (putSortable) {
      putSortable.captureAnimationState();
    }

    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);

    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl);
    }

    this.sortable.animateAll();

    if (putSortable) {
      putSortable.animateAll();
    }
  },
  drop: drop
};

_extends(Revert, {
  pluginName: 'revertOnSpill'
});

function Remove() {}

Remove.prototype = {
  onSpill: function onSpill(_ref4) {
    var dragEl = _ref4.dragEl,
        putSortable = _ref4.putSortable;
    var parentSortable = putSortable || this.sortable;
    parentSortable.captureAnimationState();
    dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
    parentSortable.animateAll();
  },
  drop: drop
};

_extends(Remove, {
  pluginName: 'removeOnSpill'
});

var lastSwapEl;

function SwapPlugin() {
  function Swap() {
    this.defaults = {
      swapClass: 'sortable-swap-highlight'
    };
  }

  Swap.prototype = {
    dragStart: function dragStart(_ref) {
      var dragEl = _ref.dragEl;
      lastSwapEl = dragEl;
    },
    dragOverValid: function dragOverValid(_ref2) {
      var completed = _ref2.completed,
          target = _ref2.target,
          onMove = _ref2.onMove,
          activeSortable = _ref2.activeSortable,
          changed = _ref2.changed,
          cancel = _ref2.cancel;
      if (!activeSortable.options.swap) return;
      var el = this.sortable.el,
          options = this.options;

      if (target && target !== el) {
        var prevSwapEl = lastSwapEl;

        if (onMove(target) !== false) {
          toggleClass(target, options.swapClass, true);
          lastSwapEl = target;
        } else {
          lastSwapEl = null;
        }

        if (prevSwapEl && prevSwapEl !== lastSwapEl) {
          toggleClass(prevSwapEl, options.swapClass, false);
        }
      }

      changed();
      completed(true);
      cancel();
    },
    drop: function drop(_ref3) {
      var activeSortable = _ref3.activeSortable,
          putSortable = _ref3.putSortable,
          dragEl = _ref3.dragEl;
      var toSortable = putSortable || this.sortable;
      var options = this.options;
      lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);

      if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
        if (dragEl !== lastSwapEl) {
          toSortable.captureAnimationState();
          if (toSortable !== activeSortable) activeSortable.captureAnimationState();
          swapNodes(dragEl, lastSwapEl);
          toSortable.animateAll();
          if (toSortable !== activeSortable) activeSortable.animateAll();
        }
      }
    },
    nulling: function nulling() {
      lastSwapEl = null;
    }
  };
  return _extends(Swap, {
    pluginName: 'swap',
    eventProperties: function eventProperties() {
      return {
        swapItem: lastSwapEl
      };
    }
  });
}

function swapNodes(n1, n2) {
  var p1 = n1.parentNode,
      p2 = n2.parentNode,
      i1,
      i2;
  if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
  i1 = index(n1);
  i2 = index(n2);

  if (p1.isEqualNode(p2) && i1 < i2) {
    i2++;
  }

  p1.insertBefore(n2, p1.children[i1]);
  p2.insertBefore(n1, p2.children[i2]);
}

var multiDragElements = [],
    multiDragClones = [],
    lastMultiDragSelect,
    // for selection with modifier key down (SHIFT)
multiDragSortable,
    initialFolding = false,
    // Initial multi-drag fold when drag started
folding = false,
    // Folding any other time
dragStarted = false,
    dragEl$1,
    clonesFromRect,
    clonesHidden;

function MultiDragPlugin() {
  function MultiDrag(sortable) {
    // Bind all private methods
    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }

    if (sortable.options.supportPointer) {
      on(document, 'pointerup', this._deselectMultiDrag);
    } else {
      on(document, 'mouseup', this._deselectMultiDrag);
      on(document, 'touchend', this._deselectMultiDrag);
    }

    on(document, 'keydown', this._checkKeyDown);
    on(document, 'keyup', this._checkKeyUp);
    this.defaults = {
      selectedClass: 'sortable-selected',
      multiDragKey: null,
      setData: function setData(dataTransfer, dragEl) {
        var data = '';

        if (multiDragElements.length && multiDragSortable === sortable) {
          multiDragElements.forEach(function (multiDragElement, i) {
            data += (!i ? '' : ', ') + multiDragElement.textContent;
          });
        } else {
          data = dragEl.textContent;
        }

        dataTransfer.setData('Text', data);
      }
    };
  }

  MultiDrag.prototype = {
    multiDragKeyDown: false,
    isMultiDrag: false,
    delayStartGlobal: function delayStartGlobal(_ref) {
      var dragged = _ref.dragEl;
      dragEl$1 = dragged;
    },
    delayEnded: function delayEnded() {
      this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
    },
    setupClone: function setupClone(_ref2) {
      var sortable = _ref2.sortable,
          cancel = _ref2.cancel;
      if (!this.isMultiDrag) return;

      for (var i = 0; i < multiDragElements.length; i++) {
        multiDragClones.push(clone(multiDragElements[i]));
        multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
        multiDragClones[i].draggable = false;
        multiDragClones[i].style['will-change'] = '';
        toggleClass(multiDragClones[i], this.options.selectedClass, false);
        multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
      }

      sortable._hideClone();

      cancel();
    },
    clone: function clone(_ref3) {
      var sortable = _ref3.sortable,
          rootEl = _ref3.rootEl,
          dispatchSortableEvent = _ref3.dispatchSortableEvent,
          cancel = _ref3.cancel;
      if (!this.isMultiDrag) return;

      if (!this.options.removeCloneOnHide) {
        if (multiDragElements.length && multiDragSortable === sortable) {
          insertMultiDragClones(true, rootEl);
          dispatchSortableEvent('clone');
          cancel();
        }
      }
    },
    showClone: function showClone(_ref4) {
      var cloneNowShown = _ref4.cloneNowShown,
          rootEl = _ref4.rootEl,
          cancel = _ref4.cancel;
      if (!this.isMultiDrag) return;
      insertMultiDragClones(false, rootEl);
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', '');
      });
      cloneNowShown();
      clonesHidden = false;
      cancel();
    },
    hideClone: function hideClone(_ref5) {
      var _this = this;

      var sortable = _ref5.sortable,
          cloneNowHidden = _ref5.cloneNowHidden,
          cancel = _ref5.cancel;
      if (!this.isMultiDrag) return;
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', 'none');

        if (_this.options.removeCloneOnHide && clone.parentNode) {
          clone.parentNode.removeChild(clone);
        }
      });
      cloneNowHidden();
      clonesHidden = true;
      cancel();
    },
    dragStartGlobal: function dragStartGlobal(_ref6) {
      var sortable = _ref6.sortable;

      if (!this.isMultiDrag && multiDragSortable) {
        multiDragSortable.multiDrag._deselectMultiDrag();
      }

      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.sortableIndex = index(multiDragElement);
      }); // Sort multi-drag elements

      multiDragElements = multiDragElements.sort(function (a, b) {
        return a.sortableIndex - b.sortableIndex;
      });
      dragStarted = true;
    },
    dragStarted: function dragStarted(_ref7) {
      var _this2 = this;

      var sortable = _ref7.sortable;
      if (!this.isMultiDrag) return;

      if (this.options.sort) {
        // Capture rects,
        // hide multi drag elements (by positioning them absolute),
        // set multi drag elements rects to dragRect,
        // show multi drag elements,
        // animate to rects,
        // unset rects & remove from DOM
        sortable.captureAnimationState();

        if (this.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            css(multiDragElement, 'position', 'absolute');
          });
          var dragRect = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRect);
          });
          folding = true;
          initialFolding = true;
        }
      }

      sortable.animateAll(function () {
        folding = false;
        initialFolding = false;

        if (_this2.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
        } // Remove all auxiliary multidrag items from el, if sorting enabled


        if (_this2.options.sort) {
          removeMultiDragElements();
        }
      });
    },
    dragOver: function dragOver(_ref8) {
      var target = _ref8.target,
          completed = _ref8.completed,
          cancel = _ref8.cancel;

      if (folding && ~multiDragElements.indexOf(target)) {
        completed(false);
        cancel();
      }
    },
    revert: function revert(_ref9) {
      var fromSortable = _ref9.fromSortable,
          rootEl = _ref9.rootEl,
          sortable = _ref9.sortable,
          dragRect = _ref9.dragRect;

      if (multiDragElements.length > 1) {
        // Setup unfold animation
        multiDragElements.forEach(function (multiDragElement) {
          sortable.addAnimationState({
            target: multiDragElement,
            rect: folding ? getRect(multiDragElement) : dragRect
          });
          unsetRect(multiDragElement);
          multiDragElement.fromRect = dragRect;
          fromSortable.removeAnimationState(multiDragElement);
        });
        folding = false;
        insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref10) {
      var sortable = _ref10.sortable,
          isOwner = _ref10.isOwner,
          insertion = _ref10.insertion,
          activeSortable = _ref10.activeSortable,
          parentEl = _ref10.parentEl,
          putSortable = _ref10.putSortable;
      var options = this.options;

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        }

        initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location

        if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
          // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
          var dragRectAbsolute = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
            // while folding, and so that we can capture them again because old sortable will no longer be fromSortable

            parentEl.appendChild(multiDragElement);
          });
          folding = true;
        } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out


        if (!isOwner) {
          // Only remove if not folding (folding will remove them anyways)
          if (!folding) {
            removeMultiDragElements();
          }

          if (multiDragElements.length > 1) {
            var clonesHiddenBefore = clonesHidden;

            activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden


            if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
              multiDragClones.forEach(function (clone) {
                activeSortable.addAnimationState({
                  target: clone,
                  rect: clonesFromRect
                });
                clone.fromRect = clonesFromRect;
                clone.thisAnimationDuration = null;
              });
            }
          } else {
            activeSortable._showClone(sortable);
          }
        }
      }
    },
    dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
      var dragRect = _ref11.dragRect,
          isOwner = _ref11.isOwner,
          activeSortable = _ref11.activeSortable;
      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.thisAnimationDuration = null;
      });

      if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
        clonesFromRect = _extends({}, dragRect);
        var dragMatrix = matrix(dragEl$1, true);
        clonesFromRect.top -= dragMatrix.f;
        clonesFromRect.left -= dragMatrix.e;
      }
    },
    dragOverAnimationComplete: function dragOverAnimationComplete() {
      if (folding) {
        folding = false;
        removeMultiDragElements();
      }
    },
    drop: function drop(_ref12) {
      var evt = _ref12.originalEvent,
          rootEl = _ref12.rootEl,
          parentEl = _ref12.parentEl,
          sortable = _ref12.sortable,
          dispatchSortableEvent = _ref12.dispatchSortableEvent,
          oldIndex = _ref12.oldIndex,
          putSortable = _ref12.putSortable;
      var toSortable = putSortable || this.sortable;
      if (!evt) return;
      var options = this.options,
          children = parentEl.children; // Multi-drag selection

      if (!dragStarted) {
        if (options.multiDragKey && !this.multiDragKeyDown) {
          this._deselectMultiDrag();
        }

        toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));

        if (!~multiDragElements.indexOf(dragEl$1)) {
          multiDragElements.push(dragEl$1);
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'select',
            targetEl: dragEl$1,
            originalEvt: evt
          }); // Modifier activated, select from last to dragEl

          if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
            var lastIndex = index(lastMultiDragSelect),
                currentIndex = index(dragEl$1);

            if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
              // Must include lastMultiDragSelect (select it), in case modified selection from no selection
              // (but previous selection existed)
              var n, i;

              if (currentIndex > lastIndex) {
                i = lastIndex;
                n = currentIndex;
              } else {
                i = currentIndex;
                n = lastIndex + 1;
              }

              for (; i < n; i++) {
                if (~multiDragElements.indexOf(children[i])) continue;
                toggleClass(children[i], options.selectedClass, true);
                multiDragElements.push(children[i]);
                dispatchEvent({
                  sortable: sortable,
                  rootEl: rootEl,
                  name: 'select',
                  targetEl: children[i],
                  originalEvt: evt
                });
              }
            }
          } else {
            lastMultiDragSelect = dragEl$1;
          }

          multiDragSortable = toSortable;
        } else {
          multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
          lastMultiDragSelect = null;
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'deselect',
            targetEl: dragEl$1,
            originalEvt: evt
          });
        }
      } // Multi-drag drop


      if (dragStarted && this.isMultiDrag) {
        // Do not "unfold" after around dragEl if reverted
        if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
          var dragRect = getRect(dragEl$1),
              multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
          if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
          toSortable.captureAnimationState();

          if (!initialFolding) {
            if (options.animation) {
              dragEl$1.fromRect = dragRect;
              multiDragElements.forEach(function (multiDragElement) {
                multiDragElement.thisAnimationDuration = null;

                if (multiDragElement !== dragEl$1) {
                  var rect = folding ? getRect(multiDragElement) : dragRect;
                  multiDragElement.fromRect = rect; // Prepare unfold animation

                  toSortable.addAnimationState({
                    target: multiDragElement,
                    rect: rect
                  });
                }
              });
            } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
            // properly they must all be removed


            removeMultiDragElements();
            multiDragElements.forEach(function (multiDragElement) {
              if (children[multiDragIndex]) {
                parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
              } else {
                parentEl.appendChild(multiDragElement);
              }

              multiDragIndex++;
            }); // If initial folding is done, the elements may have changed position because they are now
            // unfolding around dragEl, even though dragEl may not have his index changed, so update event
            // must be fired here as Sortable will not.

            if (oldIndex === index(dragEl$1)) {
              var update = false;
              multiDragElements.forEach(function (multiDragElement) {
                if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                  update = true;
                  return;
                }
              });

              if (update) {
                dispatchSortableEvent('update');
              }
            }
          } // Must be done after capturing individual rects (scroll bar)


          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
          toSortable.animateAll();
        }

        multiDragSortable = toSortable;
      } // Remove clones if necessary


      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        multiDragClones.forEach(function (clone) {
          clone.parentNode && clone.parentNode.removeChild(clone);
        });
      }
    },
    nullingGlobal: function nullingGlobal() {
      this.isMultiDrag = dragStarted = false;
      multiDragClones.length = 0;
    },
    destroyGlobal: function destroyGlobal() {
      this._deselectMultiDrag();

      off(document, 'pointerup', this._deselectMultiDrag);
      off(document, 'mouseup', this._deselectMultiDrag);
      off(document, 'touchend', this._deselectMultiDrag);
      off(document, 'keydown', this._checkKeyDown);
      off(document, 'keyup', this._checkKeyUp);
    },
    _deselectMultiDrag: function _deselectMultiDrag(evt) {
      if (typeof dragStarted !== "undefined" && dragStarted) return; // Only deselect if selection is in this sortable

      if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable

      if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click

      if (evt && evt.button !== 0) return;

      while (multiDragElements.length) {
        var el = multiDragElements[0];
        toggleClass(el, this.options.selectedClass, false);
        multiDragElements.shift();
        dispatchEvent({
          sortable: this.sortable,
          rootEl: this.sortable.el,
          name: 'deselect',
          targetEl: el,
          originalEvt: evt
        });
      }
    },
    _checkKeyDown: function _checkKeyDown(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = true;
      }
    },
    _checkKeyUp: function _checkKeyUp(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = false;
      }
    }
  };
  return _extends(MultiDrag, {
    // Static methods & properties
    pluginName: 'multiDrag',
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function select(el) {
        var sortable = el.parentNode[expando];
        if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;

        if (multiDragSortable && multiDragSortable !== sortable) {
          multiDragSortable.multiDrag._deselectMultiDrag();

          multiDragSortable = sortable;
        }

        toggleClass(el, sortable.options.selectedClass, true);
        multiDragElements.push(el);
      },

      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function deselect(el) {
        var sortable = el.parentNode[expando],
            index = multiDragElements.indexOf(el);
        if (!sortable || !sortable.options.multiDrag || !~index) return;
        toggleClass(el, sortable.options.selectedClass, false);
        multiDragElements.splice(index, 1);
      }
    },
    eventProperties: function eventProperties() {
      var _this3 = this;

      var oldIndicies = [],
          newIndicies = [];
      multiDragElements.forEach(function (multiDragElement) {
        oldIndicies.push({
          multiDragElement: multiDragElement,
          index: multiDragElement.sortableIndex
        }); // multiDragElements will already be sorted if folding

        var newIndex;

        if (folding && multiDragElement !== dragEl$1) {
          newIndex = -1;
        } else if (folding) {
          newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
        } else {
          newIndex = index(multiDragElement);
        }

        newIndicies.push({
          multiDragElement: multiDragElement,
          index: newIndex
        });
      });
      return {
        items: _toConsumableArray(multiDragElements),
        clones: [].concat(multiDragClones),
        oldIndicies: oldIndicies,
        newIndicies: newIndicies
      };
    },
    optionListeners: {
      multiDragKey: function multiDragKey(key) {
        key = key.toLowerCase();

        if (key === 'ctrl') {
          key = 'Control';
        } else if (key.length > 1) {
          key = key.charAt(0).toUpperCase() + key.substr(1);
        }

        return key;
      }
    }
  });
}

function insertMultiDragElements(clonesInserted, rootEl) {
  multiDragElements.forEach(function (multiDragElement, i) {
    var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(multiDragElement, target);
    } else {
      rootEl.appendChild(multiDragElement);
    }
  });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */


function insertMultiDragClones(elementsInserted, rootEl) {
  multiDragClones.forEach(function (clone, i) {
    var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(clone, target);
    } else {
      rootEl.appendChild(clone);
    }
  });
}

function removeMultiDragElements() {
  multiDragElements.forEach(function (multiDragElement) {
    if (multiDragElement === dragEl$1) return;
    multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
  });
}

Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);

/* harmony default export */ __webpack_exports__["default"] = (Sortable);



/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropzoneControls_vue__ = __webpack_require__(480);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30db34fc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropzoneControls_vue__ = __webpack_require__(1337);
function injectStyle (ssrContext) {
  __webpack_require__(1335)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30db34fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropzoneControls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30db34fc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropzoneControls_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1336);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("52ebbda8", content, true, {});

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.dropzone-controls[data-v-30db34fc] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: #fff;\n  border-top: 1px solid rgba(0, 0, 0, 0.3);\n  padding: 15px 10px;\n}\n.row[data-v-30db34fc] {\n  padding: 0 10px;\n}\n.padding-L[data-v-30db34fc] {\n  padding-left: 5px;\n}\n.padding-R[data-v-30db34fc] {\n  padding-right: 5px;\n}\n.button[data-v-30db34fc] {\n  line-height: 135%;\n}\n@media screen and (max-width: 430px) {\n.dropzone-controls[data-v-30db34fc] {\n    bottom: 50px;\n    padding: 10px 0;\n}\n.dropzone-controls .button.small[data-v-30db34fc] {\n      font-size: 12px;\n      padding: 10px 7px 10px;\n}\n.dispatch-home .dropzone-controls[data-v-30db34fc] {\n    bottom: 40px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Routing/DropzoneControls.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,yCAAyC;EACzC,mBAAmB;CACpB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;AACA;IACI,aAAa;IACb,gBAAgB;CACnB;AACD;MACM,gBAAgB;MAChB,uBAAuB;CAC5B;AACD;IACI,aAAa;CAChB;CACA","file":"DropzoneControls.vue","sourcesContent":["\n.dropzone-controls[data-v-30db34fc] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: #fff;\n  border-top: 1px solid rgba(0, 0, 0, 0.3);\n  padding: 15px 10px;\n}\n.row[data-v-30db34fc] {\n  padding: 0 10px;\n}\n.padding-L[data-v-30db34fc] {\n  padding-left: 5px;\n}\n.padding-R[data-v-30db34fc] {\n  padding-right: 5px;\n}\n.button[data-v-30db34fc] {\n  line-height: 135%;\n}\n@media screen and (max-width: 430px) {\n.dropzone-controls[data-v-30db34fc] {\n    bottom: 50px;\n    padding: 10px 0;\n}\n.dropzone-controls .button.small[data-v-30db34fc] {\n      font-size: 12px;\n      padding: 10px 7px 10px;\n}\n.dispatch-home .dropzone-controls[data-v-30db34fc] {\n    bottom: 40px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length > 0),expression:"items.length > 0"}],staticClass:"dropzone-controls"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-4 columns padding-R"},[_c('a',{staticClass:"button cta small block warning",attrs:{"href":"javascript:;"},on:{"click":_vm.clearMap}},[_vm._v("CLEAR MAP")])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-L padding-R"},[_c('a',{staticClass:"button cta small block",attrs:{"href":"javascript:;"},on:{"click":_vm.optimizeRoute}},[_vm._v("OPTIMIZE ROUTE")])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-L"},[_c('a',{staticClass:"button cta small block success",attrs:{"href":"javascript:;"},on:{"click":_vm.savePackage}},[_vm._v("SAVE PACKAGE")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1339);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("6d3dd7d2", content, true, {});

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.pin[data-v-f788979c] {\n  width: 30px;\n  height: 30px;\n  border-radius: 50% 50% 50% 0;\n  background: #26D97A;\n  position: absolute;\n  z-index: 3;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  left: 50%;\n  top: 50%;\n  margin: -20px 0 0 -20px;\n  /*\r\n  -webkit-animation-name: bounce;\r\n  -moz-animation-name: bounce;\r\n  -o-animation-name: bounce;\r\n  -ms-animation-name: bounce;\r\n  animation-name: bounce;\r\n  */\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n}\n.pin[data-v-f788979c]:after {\n  content: '';\n  width: 14px;\n  height: 14px;\n  margin: 8px 0 0 8px;\n  background: rgba(0, 0, 0, 0.5);\n  position: absolute;\n  border-radius: 50%;\n}\n.pulse[data-v-f788979c] {\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 50%;\n  height: 14px;\n  width: 14px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin: 11px 0px 0px -12px;\n  -webkit-transform: rotateX(55deg);\n  transform: rotateX(55deg);\n  z-index: 1;\n}\n.pulse[data-v-f788979c]:after {\n  content: \"\";\n  border-radius: 50%;\n  height: 40px;\n  width: 40px;\n  position: absolute;\n  margin: -13px 0 0 -13px;\n  -webkit-animation: pulsate-data-v-f788979c 1s ease-out;\n  animation: pulsate-data-v-f788979c 1s ease-out;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  opacity: 0;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n  filter: alpha(opacity=0);\n  -webkit-box-shadow: 0 0 1px 2px black;\n  box-shadow: 0 0 1px 2px rgba(0, 0, 0, 0.6);\n  -webkit-animation-delay: 1.1s;\n  animation-delay: 1.1s;\n}\n@-webkit-keyframes pulsate-data-v-f788979c {\n0% {\n    -webkit-transform: scale(0.1, 0.1);\n    transform: scale(0.1, 0.1);\n    opacity: 0;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    filter: alpha(opacity=0);\n}\n50% {\n    opacity: 1;\n    -ms-filter: none;\n    -webkit-filter: none;\n            filter: none;\n}\n100% {\n    -webkit-transform: scale(1.2, 1.2);\n    transform: scale(1.2, 1.2);\n    opacity: 0;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    filter: alpha(opacity=0);\n}\n}\n@keyframes pulsate-data-v-f788979c {\n0% {\n    -webkit-transform: scale(0.1, 0.1);\n    transform: scale(0.1, 0.1);\n    opacity: 0;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    filter: alpha(opacity=0);\n}\n50% {\n    opacity: 1;\n    -ms-filter: none;\n    -webkit-filter: none;\n            filter: none;\n}\n100% {\n    -webkit-transform: scale(1.2, 1.2);\n    transform: scale(1.2, 1.2);\n    opacity: 0;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    filter: alpha(opacity=0);\n}\n}\n@-webkit-keyframes bounce-data-v-f788979c {\n0% {\n    opacity: 0;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    filter: alpha(opacity=0);\n    -webkit-transform: translateY(-2000px) rotate(-45deg);\n    transform: translateY(-2000px) rotate(-45deg);\n}\n60% {\n    opacity: 1;\n    -ms-filter: none;\n    -webkit-filter: none;\n            filter: none;\n    -webkit-transform: translateY(30px) rotate(-45deg);\n    transform: translateY(30px) rotate(-45deg);\n}\n80% {\n    -webkit-transform: translateY(-10px) rotate(-45deg);\n    transform: translateY(-10px) rotate(-45deg);\n}\n100% {\n    -webkit-transform: translateY(0) rotate(-45deg);\n    transform: translateY(0) rotate(-45deg);\n}\n}\n@keyframes bounce-data-v-f788979c {\n0% {\n    opacity: 0;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    filter: alpha(opacity=0);\n    -webkit-transform: translateY(-2000px) rotate(-45deg);\n    transform: translateY(-2000px) rotate(-45deg);\n}\n60% {\n    opacity: 1;\n    -ms-filter: none;\n    -webkit-filter: none;\n            filter: none;\n    -webkit-transform: translateY(30px) rotate(-45deg);\n    transform: translateY(30px) rotate(-45deg);\n}\n80% {\n    -webkit-transform: translateY(-10px) rotate(-45deg);\n    transform: translateY(-10px) rotate(-45deg);\n}\n100% {\n    -webkit-transform: translateY(0) rotate(-45deg);\n    transform: translateY(0) rotate(-45deg);\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Partials/LoadingAnimation/MapMarker.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kCAAkC;EAClC,0BAA0B;EAC1B,UAAU;EACV,SAAS;EACT,wBAAwB;EACxB;;;;;;IAME;EACF,kCAAkC;EAClC,0BAA0B;EAC1B,+BAA+B;EAC/B,uBAAuB;CACxB;AACD;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,0BAA0B;EAC1B,WAAW;CACZ;AACD;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,uDAAuD;EACvD,+CAA+C;EAC/C,4CAA4C;EAC5C,oCAAoC;EACpC,WAAW;EACX,iEAAiE;EACjE,yBAAyB;EACzB,sCAAsC;EACtC,2CAA2C;EAC3C,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;AACA;IACI,mCAAmC;IACnC,2BAA2B;IAC3B,WAAW;IACX,iEAAiE;IACjE,yBAAyB;CAC5B;AACD;IACI,WAAW;IACX,iBAAiB;IACjB,qBAAqB;YACb,aAAa;CACxB;AACD;IACI,mCAAmC;IACnC,2BAA2B;IAC3B,WAAW;IACX,iEAAiE;IACjE,yBAAyB;CAC5B;CACA;AACD;AACA;IACI,mCAAmC;IACnC,2BAA2B;IAC3B,WAAW;IACX,iEAAiE;IACjE,yBAAyB;CAC5B;AACD;IACI,WAAW;IACX,iBAAiB;IACjB,qBAAqB;YACb,aAAa;CACxB;AACD;IACI,mCAAmC;IACnC,2BAA2B;IAC3B,WAAW;IACX,iEAAiE;IACjE,yBAAyB;CAC5B;CACA;AACD;AACA;IACI,WAAW;IACX,iEAAiE;IACjE,yBAAyB;IACzB,sDAAsD;IACtD,8CAA8C;CACjD;AACD;IACI,WAAW;IACX,iBAAiB;IACjB,qBAAqB;YACb,aAAa;IACrB,mDAAmD;IACnD,2CAA2C;CAC9C;AACD;IACI,oDAAoD;IACpD,4CAA4C;CAC/C;AACD;IACI,gDAAgD;IAChD,wCAAwC;CAC3C;CACA;AACD;AACA;IACI,WAAW;IACX,iEAAiE;IACjE,yBAAyB;IACzB,sDAAsD;IACtD,8CAA8C;CACjD;AACD;IACI,WAAW;IACX,iBAAiB;IACjB,qBAAqB;YACb,aAAa;IACrB,mDAAmD;IACnD,2CAA2C;CAC9C;AACD;IACI,oDAAoD;IACpD,4CAA4C;CAC/C;AACD;IACI,gDAAgD;IAChD,wCAAwC;CAC3C;CACA","file":"MapMarker.vue","sourcesContent":["\n.pin[data-v-f788979c] {\n  width: 30px;\n  height: 30px;\n  border-radius: 50% 50% 50% 0;\n  background: #26D97A;\n  position: absolute;\n  z-index: 3;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  left: 50%;\n  top: 50%;\n  margin: -20px 0 0 -20px;\n  /*\r\n  -webkit-animation-name: bounce;\r\n  -moz-animation-name: bounce;\r\n  -o-animation-name: bounce;\r\n  -ms-animation-name: bounce;\r\n  animation-name: bounce;\r\n  */\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n}\n.pin[data-v-f788979c]:after {\n  content: '';\n  width: 14px;\n  height: 14px;\n  margin: 8px 0 0 8px;\n  background: rgba(0, 0, 0, 0.5);\n  position: absolute;\n  border-radius: 50%;\n}\n.pulse[data-v-f788979c] {\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 50%;\n  height: 14px;\n  width: 14px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin: 11px 0px 0px -12px;\n  -webkit-transform: rotateX(55deg);\n  transform: rotateX(55deg);\n  z-index: 1;\n}\n.pulse[data-v-f788979c]:after {\n  content: \"\";\n  border-radius: 50%;\n  height: 40px;\n  width: 40px;\n  position: absolute;\n  margin: -13px 0 0 -13px;\n  -webkit-animation: pulsate-data-v-f788979c 1s ease-out;\n  animation: pulsate-data-v-f788979c 1s ease-out;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  opacity: 0;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n  filter: alpha(opacity=0);\n  -webkit-box-shadow: 0 0 1px 2px black;\n  box-shadow: 0 0 1px 2px rgba(0, 0, 0, 0.6);\n  -webkit-animation-delay: 1.1s;\n  animation-delay: 1.1s;\n}\n@-webkit-keyframes pulsate-data-v-f788979c {\n0% {\n    -webkit-transform: scale(0.1, 0.1);\n    transform: scale(0.1, 0.1);\n    opacity: 0;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    filter: alpha(opacity=0);\n}\n50% {\n    opacity: 1;\n    -ms-filter: none;\n    -webkit-filter: none;\n            filter: none;\n}\n100% {\n    -webkit-transform: scale(1.2, 1.2);\n    transform: scale(1.2, 1.2);\n    opacity: 0;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    filter: alpha(opacity=0);\n}\n}\n@keyframes pulsate-data-v-f788979c {\n0% {\n    -webkit-transform: scale(0.1, 0.1);\n    transform: scale(0.1, 0.1);\n    opacity: 0;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    filter: alpha(opacity=0);\n}\n50% {\n    opacity: 1;\n    -ms-filter: none;\n    -webkit-filter: none;\n            filter: none;\n}\n100% {\n    -webkit-transform: scale(1.2, 1.2);\n    transform: scale(1.2, 1.2);\n    opacity: 0;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    filter: alpha(opacity=0);\n}\n}\n@-webkit-keyframes bounce-data-v-f788979c {\n0% {\n    opacity: 0;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    filter: alpha(opacity=0);\n    -webkit-transform: translateY(-2000px) rotate(-45deg);\n    transform: translateY(-2000px) rotate(-45deg);\n}\n60% {\n    opacity: 1;\n    -ms-filter: none;\n    -webkit-filter: none;\n            filter: none;\n    -webkit-transform: translateY(30px) rotate(-45deg);\n    transform: translateY(30px) rotate(-45deg);\n}\n80% {\n    -webkit-transform: translateY(-10px) rotate(-45deg);\n    transform: translateY(-10px) rotate(-45deg);\n}\n100% {\n    -webkit-transform: translateY(0) rotate(-45deg);\n    transform: translateY(0) rotate(-45deg);\n}\n}\n@keyframes bounce-data-v-f788979c {\n0% {\n    opacity: 0;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    filter: alpha(opacity=0);\n    -webkit-transform: translateY(-2000px) rotate(-45deg);\n    transform: translateY(-2000px) rotate(-45deg);\n}\n60% {\n    opacity: 1;\n    -ms-filter: none;\n    -webkit-filter: none;\n            filter: none;\n    -webkit-transform: translateY(30px) rotate(-45deg);\n    transform: translateY(30px) rotate(-45deg);\n}\n80% {\n    -webkit-transform: translateY(-10px) rotate(-45deg);\n    transform: translateY(-10px) rotate(-45deg);\n}\n100% {\n    -webkit-transform: translateY(0) rotate(-45deg);\n    transform: translateY(0) rotate(-45deg);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pin"}),_vm._v(" "),_c('div',{staticClass:"pulse"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"routing-dropzone"},[_c('draggable',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length > 0),expression:"items.length > 0"}],staticClass:"dropzone-items",model:{value:(_vm.items),callback:function ($$v) {_vm.items=$$v},expression:"items"}},_vm._l((_vm.items),function(item,index){return _c('div',{staticClass:"dropzone-item"},[_c('div',{staticClass:"header"},[_c('span',{class:{ order: true, dropoff: !item.isPickup }},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('a',{attrs:{"href":'/#/reservation/' + item.reservationID,"target":"_blank"}},[_vm._v(_vm._s(item.reservationID))]),_vm._v(" "),(item.packageID !== null)?_c('span',[_vm._v("-")]):_vm._e(),_vm._v(" "),(item.packageID !== null)?_c('a',{attrs:{"href":'/#/package/' + item.packageID,"target":"_blank"}},[_vm._v(_vm._s(item.packageID))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"icon-label"},[_c('i',{staticClass:"fas fa-suitcase"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.luggage))])]),_vm._v(" "),_c('span',{staticClass:"icon-label"},[_c('i',{staticClass:"fas fa-user"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.passengers))])]),_vm._v(" "),_c('span',{staticClass:"icon-label location"},[_c('i',{class:{ 'fas fa-map-marker-alt fa-fw': true, dropoff: !item.isPickup }}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getAddress(item.location)))])])]),_vm._v(" "),_c('div',{staticClass:"body"},[(item.isPickup)?_c('span',{staticClass:"icon-label time"},[_c('i',{staticClass:"fas fa-clock"}),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("PUT:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(item.originalPickupTime))])]):_vm._e(),_vm._v(" "),(index > 0 && !item.isPickup)?_c('span',{staticClass:"icon-label time"},[_c('i',{staticClass:"fas fa-clock"}),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("BTT:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.computeOriginalBTT(item)))])]):_vm._e(),_vm._v(" "),(index > 0)?_c('span',{staticClass:"icon-label time"},[_c('i',{staticClass:"fas fa-clock"}),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("ETA:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.computeEta(item)))])]):_vm._e(),_vm._v(" "),(index > 0)?_c('span',{class:{ 'icon-label validation': true, warning: _vm.showWarning(item) }},[_c('i',{staticClass:"fas fa-exclamation-triangle fa-fw warning"}),_vm._v(" "),_c('i',{staticClass:"fas fa-check-circle fa-fw success"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.hasIssues(item)))])]):_vm._e()]),_vm._v(" "),(item.isPickup && item.status !== 'COMPLETED' && item.status !== 'CANCELED')?_c('a',{staticClass:"remove-item",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.removeFromMap(item)}}},[_c('i',{staticClass:"fas fa-minus-square"})]):_vm._e()])}),0),_vm._v(" "),_c('dropzone-controls'),_vm._v(" "),_c('div',{class:{ 'check-route-loading': true, show: _vm.checkRouteLoading }},[_c('loader-map-marker'),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length <= 0),expression:"items.length <= 0"}],staticClass:"empty-container"},[_vm._m(1)]),_vm._v(" "),_c('drop',{class:{ dropzone: true, show: _vm.showDropzone, 'empty-container': true },on:{"drop":_vm.handleDrop}},[_c('div',{staticClass:"empty"},[_c('div',{staticClass:"empty-content"},[_c('i',{staticClass:"fas fa-arrow-alt-circle-down fa-4x"}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Drop it here!")])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"text"},[_vm._v("Finding optimal route...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('div',{staticClass:"empty-content"},[_c('img',{attrs:{"src":"/assets/img/routing-empty.png"}}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Nothing here yet!")]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("Drop a reservation/package here or click on the map marker icons to begin routing.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1343);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("3f45e480", content, true, {});

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.routing-modal-container[data-v-5f641a02] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.routing-modal-container.show[data-v-5f641a02] {\n    top: 0;\n    opacity: 1;\n}\n.routing-modal[data-v-5f641a02] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.routing-modal-content[data-v-5f641a02] {\n  position: relative;\n  background-color: #fff;\n  border-radius: 3px;\n  width: 350px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.ajax-modal[data-v-5f641a02] {\n  padding: 15px;\n}\n.ajax-modal i[data-v-5f641a02] {\n    color: #777;\n    display: block;\n    margin-bottom: 10px;\n}\n.ajax-modal .message[data-v-5f641a02] {\n    font-weight: 700;\n    color: #555;\n}\n.ajax-modal.success i[data-v-5f641a02] {\n    color: #26D97A;\n}\n.ajax-modal.error i[data-v-5f641a02] {\n    color: #F20D0D;\n}\n.validation-modal .title[data-v-5f641a02] {\n  background-color: #333;\n  color: #fff;\n  padding: 10px;\n}\n.validation-modal .message[data-v-5f641a02] {\n  font-weight: 700;\n  color: #555;\n  padding: 20px;\n}\n.validation-modal .button[data-v-5f641a02] {\n  margin-bottom: 15px;\n}\n.confirmation-modal .title[data-v-5f641a02] {\n  background-color: #333;\n  color: #fff;\n  padding: 10px;\n}\n.confirmation-modal .message[data-v-5f641a02] {\n  font-weight: 700;\n  color: #555;\n  padding: 15px 20px 20px;\n}\n.confirmation-modal .controls[data-v-5f641a02] {\n  padding: 0 20px 0px;\n}\n.confirmation-modal .close-button[data-v-5f641a02] {\n  display: block;\n  font-weight: 700;\n  padding: 10px 15px 15px;\n  font-size: 12px;\n}\n.confirmation-modal .text-left[data-v-5f641a02] {\n  text-align: left;\n}\n.confirmation-modal .text-left .message[data-v-5f641a02] {\n    font-size: 14px;\n    padding: 15px;\n}\n.confirmation-modal .drivers[data-v-5f641a02] {\n  padding: 0 15px;\n}\n.confirmation-modal .drivers .driver[data-v-5f641a02] {\n    padding: 10px 15px;\n    margin-bottom: 5px;\n    background-color: #f5f5f5;\n    border-radius: 3px;\n    font-size: 14px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.confirmation-modal .drivers .driver a[data-v-5f641a02] {\n      font-weight: 700;\n      display: inline-block;\n      margin-right: 5px;\n}\n.confirmation-modal .drivers .driver .name[data-v-5f641a02] {\n      font-weight: 700;\n      text-decoration: none;\n}\n.padding-R[data-v-5f641a02] {\n  padding-right: 7px;\n}\n.padding-L[data-v-5f641a02] {\n  padding-left: 7px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Routing/RoutingModal.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;EACE,cAAc;CACf;AACD;IACI,YAAY;IACZ,eAAe;IACf,oBAAoB;CACvB;AACD;IACI,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;CACf;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;CACf;AACD;EACE,oBAAoB;CACrB;AACD;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;CACf;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;CACzB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;CACjB;AACD;EACE,iBAAiB;CAClB;AACD;IACI,gBAAgB;IAChB,cAAc;CACjB;AACD;EACE,gBAAgB;CACjB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,qCAAqC;CACxC;AACD;MACM,iBAAiB;MACjB,sBAAsB;MACtB,kBAAkB;CACvB;AACD;MACM,iBAAiB;MACjB,sBAAsB;CAC3B;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB","file":"RoutingModal.vue","sourcesContent":["\n.routing-modal-container[data-v-5f641a02] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.routing-modal-container.show[data-v-5f641a02] {\n    top: 0;\n    opacity: 1;\n}\n.routing-modal[data-v-5f641a02] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.routing-modal-content[data-v-5f641a02] {\n  position: relative;\n  background-color: #fff;\n  border-radius: 3px;\n  width: 350px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.ajax-modal[data-v-5f641a02] {\n  padding: 15px;\n}\n.ajax-modal i[data-v-5f641a02] {\n    color: #777;\n    display: block;\n    margin-bottom: 10px;\n}\n.ajax-modal .message[data-v-5f641a02] {\n    font-weight: 700;\n    color: #555;\n}\n.ajax-modal.success i[data-v-5f641a02] {\n    color: #26D97A;\n}\n.ajax-modal.error i[data-v-5f641a02] {\n    color: #F20D0D;\n}\n.validation-modal .title[data-v-5f641a02] {\n  background-color: #333;\n  color: #fff;\n  padding: 10px;\n}\n.validation-modal .message[data-v-5f641a02] {\n  font-weight: 700;\n  color: #555;\n  padding: 20px;\n}\n.validation-modal .button[data-v-5f641a02] {\n  margin-bottom: 15px;\n}\n.confirmation-modal .title[data-v-5f641a02] {\n  background-color: #333;\n  color: #fff;\n  padding: 10px;\n}\n.confirmation-modal .message[data-v-5f641a02] {\n  font-weight: 700;\n  color: #555;\n  padding: 15px 20px 20px;\n}\n.confirmation-modal .controls[data-v-5f641a02] {\n  padding: 0 20px 0px;\n}\n.confirmation-modal .close-button[data-v-5f641a02] {\n  display: block;\n  font-weight: 700;\n  padding: 10px 15px 15px;\n  font-size: 12px;\n}\n.confirmation-modal .text-left[data-v-5f641a02] {\n  text-align: left;\n}\n.confirmation-modal .text-left .message[data-v-5f641a02] {\n    font-size: 14px;\n    padding: 15px;\n}\n.confirmation-modal .drivers[data-v-5f641a02] {\n  padding: 0 15px;\n}\n.confirmation-modal .drivers .driver[data-v-5f641a02] {\n    padding: 10px 15px;\n    margin-bottom: 5px;\n    background-color: #f5f5f5;\n    border-radius: 3px;\n    font-size: 14px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.confirmation-modal .drivers .driver a[data-v-5f641a02] {\n      font-weight: 700;\n      display: inline-block;\n      margin-right: 5px;\n}\n.confirmation-modal .drivers .driver .name[data-v-5f641a02] {\n      font-weight: 700;\n      text-decoration: none;\n}\n.padding-R[data-v-5f641a02] {\n  padding-right: 7px;\n}\n.padding-L[data-v-5f641a02] {\n  padding-left: 7px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'routing-modal-container': true, show: _vm.modal.show },on:{"click":_vm.close}},[_c('div',{staticClass:"routing-modal"},[_c('div',{staticClass:"routing-modal-content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modal.validation.show),expression:"modal.validation.show"}],class:{ 'validation-modal': true },on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.modal.validation.title))]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.modal.validation.message))]),_vm._v(" "),_c('a',{staticClass:"button small cta",attrs:{"href":"javascript:;"},on:{"click":_vm.close}},[_vm._v("OK, GOT IT.")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modal.ajax.show),expression:"modal.ajax.show"}],class:{
              'ajax-modal': true,
              error: !_vm.modal.ajax.loading && !_vm.modal.ajax.success,
              success: !_vm.modal.ajax.loading && _vm.modal.ajax.success
            },on:{"click":function($event){$event.stopPropagation();}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.modal.ajax.loading),expression:"modal.ajax.loading"}],staticClass:"fas fa-circle-notch fa-spin fa-3x"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.modal.ajax.loading && !_vm.modal.ajax.success),expression:"!modal.ajax.loading && !modal.ajax.success"}],staticClass:"fas fa-times-circle fa-3x"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.modal.ajax.loading && _vm.modal.ajax.success),expression:"!modal.ajax.loading && modal.ajax.success"}],staticClass:"fas fa-check-circle fa-3x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.modal.ajax.message))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modal.confirmation.show),expression:"modal.confirmation.show"}],staticClass:"confirmation-modal",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.modal.confirmation.title))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasMultipleDrivers),expression:"!hasMultipleDrivers"}]},[_c('div',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.modal.confirmation.message)}}),_vm._v(" "),_c('div',{staticClass:"row controls"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modal.confirmation.action === 'SAVE_PACKAGE_KEEP_DRIVER'),expression:"modal.confirmation.action === 'SAVE_PACKAGE_KEEP_DRIVER'"}],staticClass:"small-6 columns padding-R"},[_c('a',{staticClass:"button cta small block",attrs:{"href":"javascript:;"},on:{"click":_vm.closeAction}},[_vm._v("UNASSIGN IT.")])]),_vm._v(" "),_c('div',{class:{
              'columns': true,
              'small-6 padding-L': _vm.modal.confirmation.action === 'SAVE_PACKAGE_KEEP_DRIVER',
              'small-12': _vm.modal.confirmation.action === 'SAVE_PACKAGE'
            }},[_c('a',{staticClass:"button cta small success block",attrs:{"href":"javascript:;"},on:{"click":_vm.confirmAction}},[_vm._v("YES, I DO.")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasMultipleDrivers),expression:"hasMultipleDrivers"}],staticClass:"text-left"},[_c('div',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.modal.confirmation.message)}}),_vm._v(" "),_c('div',{staticClass:"drivers"},[_vm._l((_vm.dropzoneDrivers),function(item,index){return _c('div',{staticClass:"driver"},[_c('a',{attrs:{"href":'/#/provider/' + item.driver.ID,"target":"_blank"},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(_vm._s(item.driver.ID))]),_vm._v(" "),_c('a',{staticClass:"name",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.savePackage(item.driver.ID)}}},[_vm._v(_vm._s(item.driver.firstName)+" "+_vm._s(item.driver.lastName))])])}),_vm._v(" "),_c('div',{staticClass:"driver"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.savePackage(null)}}},[_vm._v("I'll assign this package later.")])])],2)]),_vm._v(" "),_c('a',{staticClass:"close-button",attrs:{"href":"javascript:;"},on:{"click":_vm.close}},[_vm._v("Cancel my changes.")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1346);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("33040334", content, true, {});

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.rtg-modal[data-v-375149f2] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.rtg-modal.show[data-v-375149f2] {\n    top: 0;\n    opacity: 1;\n}\n.rtg-modal-container[data-v-375149f2] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.rtg-modal-content[data-v-375149f2] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 500px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.confirmation[data-v-375149f2] {\n  padding: 30px;\n  position: relative;\n}\n.confirmation label[data-v-375149f2] {\n    display: block;\n    margin-bottom: 30px;\n    font-size: 15px;\n    font-weight: 600;\n    color: #444;\n}\n.confirmation .button[data-v-375149f2] {\n    margin: 0 5px;\n}\n.confirmation .error i[data-v-375149f2] {\n    display: block;\n    margin-bottom: 10px;\n    color: #ecaa32;\n}\n.confirmation .success i[data-v-375149f2] {\n    display: block;\n    margin-bottom: 10px;\n    color: #26d97a;\n}\n.confirmation .loader[data-v-375149f2] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    font-weight: 600;\n    color: #333;\n    background: rgba(255, 255, 255, 0.8);\n}\n.confirmation .loader i[data-v-375149f2] {\n      margin-top: 30px;\n      color: #2669bd;\n      display: block;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/ReadyToGoModal.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,iBAAiB;CAClB;AACD;EACE,cAAc;EACd,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,cAAc;CACjB;AACD;IACI,eAAe;IACf,oBAAoB;IACpB,eAAe;CAClB;AACD;IACI,eAAe;IACf,oBAAoB;IACpB,eAAe;CAClB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,qCAAqC;CACxC;AACD;MACM,iBAAiB;MACjB,eAAe;MACf,eAAe;CACpB","file":"ReadyToGoModal.vue","sourcesContent":["\n.rtg-modal[data-v-375149f2] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.rtg-modal.show[data-v-375149f2] {\n    top: 0;\n    opacity: 1;\n}\n.rtg-modal-container[data-v-375149f2] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.rtg-modal-content[data-v-375149f2] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 500px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.confirmation[data-v-375149f2] {\n  padding: 30px;\n  position: relative;\n}\n.confirmation label[data-v-375149f2] {\n    display: block;\n    margin-bottom: 30px;\n    font-size: 15px;\n    font-weight: 600;\n    color: #444;\n}\n.confirmation .button[data-v-375149f2] {\n    margin: 0 5px;\n}\n.confirmation .error i[data-v-375149f2] {\n    display: block;\n    margin-bottom: 10px;\n    color: #ecaa32;\n}\n.confirmation .success i[data-v-375149f2] {\n    display: block;\n    margin-bottom: 10px;\n    color: #26d97a;\n}\n.confirmation .loader[data-v-375149f2] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    font-weight: 600;\n    color: #333;\n    background: rgba(255, 255, 255, 0.8);\n}\n.confirmation .loader i[data-v-375149f2] {\n      margin-top: 30px;\n      color: #2669bd;\n      display: block;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'rtg-modal':true, show:_vm.show },on:{"click":_vm.close}},[_c('div',{staticClass:"rtg-modal-container"},[_c('div',{staticClass:"rtg-modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"confirmation"},[(_vm.error === '' && !_vm.success)?_c('div',[_c('label',[_vm._v("Confirm \"Ready to go\" status for Reservation #"+_vm._s(_vm.rsvpID))]),_vm._v(" "),_c('div',{staticClass:"button cta error",on:{"click":_vm.close}},[_vm._v("Cancel")]),_vm._v(" "),_c('div',{staticClass:"button cta success",on:{"click":_vm.confirm}},[_vm._v("Confirm")])]):(!_vm.success)?_c('div',{staticClass:"error"},[_c('i',{staticClass:"fas fa-exclamation-triangle fa-3x"}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.error))]),_vm._v(" "),_c('div',{staticClass:"button cta error small block",on:{"click":_vm.close}},[_vm._v("Close")])]):_vm._e(),_vm._v(" "),(_vm.success)?_c('div',{staticClass:"success"},[_c('i',{staticClass:"far fa-check-circle fa-3x"}),_vm._v(" "),_c('label',[_vm._v("Successfully applied \"Ready to go\" status on Reservation #"+_vm._s(_vm.rsvpID))]),_vm._v(" "),_c('div',{staticClass:"button cta success small block",on:{"click":_vm.close}},[_vm._v("Close")])]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin fa-4x"}),_vm._v("\n            Please wait...\n          ")])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1349);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("77ee7477", content, true, {});

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.rtg-modal[data-v-3ece986c] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.rtg-modal.show[data-v-3ece986c] {\n    top: 0;\n    opacity: 1;\n}\n.rtg-modal-container[data-v-3ece986c] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.rtg-modal-content[data-v-3ece986c] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 500px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.top[data-v-3ece986c] {\n  background-color: #0d79f2;\n  color: #fff;\n  font-size: 18px;\n  font-weight: 600;\n  padding: 10px 0;\n}\n.confirmation[data-v-3ece986c] {\n  padding: 30px;\n  position: relative;\n}\n.confirmation label[data-v-3ece986c] {\n    display: block;\n    margin-bottom: 30px;\n    font-size: 15px;\n    font-weight: 600;\n    color: #444;\n}\n.confirmation .button[data-v-3ece986c] {\n    margin: 0 5px;\n}\n.confirmation .error i[data-v-3ece986c] {\n    display: block;\n    margin-bottom: 10px;\n    color: #ecaa32;\n}\n.confirmation .success i[data-v-3ece986c] {\n    display: block;\n    margin-bottom: 10px;\n    color: #26d97a;\n}\n.confirmation .loader[data-v-3ece986c] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    font-weight: 600;\n    color: #333;\n    background: rgba(255, 255, 255, 0.8);\n}\n.confirmation .loader i[data-v-3ece986c] {\n      margin-top: 30px;\n      color: #2669bd;\n      display: block;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/NotesModal.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,iBAAiB;CAClB;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;CACjB;AACD;EACE,cAAc;EACd,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,cAAc;CACjB;AACD;IACI,eAAe;IACf,oBAAoB;IACpB,eAAe;CAClB;AACD;IACI,eAAe;IACf,oBAAoB;IACpB,eAAe;CAClB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,qCAAqC;CACxC;AACD;MACM,iBAAiB;MACjB,eAAe;MACf,eAAe;CACpB","file":"NotesModal.vue","sourcesContent":["\n.rtg-modal[data-v-3ece986c] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.rtg-modal.show[data-v-3ece986c] {\n    top: 0;\n    opacity: 1;\n}\n.rtg-modal-container[data-v-3ece986c] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.rtg-modal-content[data-v-3ece986c] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 500px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.top[data-v-3ece986c] {\n  background-color: #0d79f2;\n  color: #fff;\n  font-size: 18px;\n  font-weight: 600;\n  padding: 10px 0;\n}\n.confirmation[data-v-3ece986c] {\n  padding: 30px;\n  position: relative;\n}\n.confirmation label[data-v-3ece986c] {\n    display: block;\n    margin-bottom: 30px;\n    font-size: 15px;\n    font-weight: 600;\n    color: #444;\n}\n.confirmation .button[data-v-3ece986c] {\n    margin: 0 5px;\n}\n.confirmation .error i[data-v-3ece986c] {\n    display: block;\n    margin-bottom: 10px;\n    color: #ecaa32;\n}\n.confirmation .success i[data-v-3ece986c] {\n    display: block;\n    margin-bottom: 10px;\n    color: #26d97a;\n}\n.confirmation .loader[data-v-3ece986c] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    font-weight: 600;\n    color: #333;\n    background: rgba(255, 255, 255, 0.8);\n}\n.confirmation .loader i[data-v-3ece986c] {\n      margin-top: 30px;\n      color: #2669bd;\n      display: block;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1351);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4b9a79f0", content, true, {});

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\ndiv[data-v-3ece986c] .message {\r\n    display:block;\r\n    margin-bottom: 30px;\r\n    font-size:15px;\r\n    font-weight: 600;\r\n    color:#444;\n}\r\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/NotesModal.vue"],"names":[],"mappings":";AACA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,WAAW;CACd","file":"NotesModal.vue","sourcesContent":["\ndiv[data-v-3ece986c] .message {\r\n    display:block;\r\n    margin-bottom: 30px;\r\n    font-size:15px;\r\n    font-weight: 600;\r\n    color:#444;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'rtg-modal':true, show:_vm.show },on:{"click":_vm.close}},[_c('div',{staticClass:"rtg-modal-container"},[_c('div',{staticClass:"rtg-modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"confirmation"},[_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.message)}}),_vm._v(" "),_c('div',{staticClass:"button cta success",on:{"click":_vm.close}},[_vm._v("OK")])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin fa-4x"}),_vm._v("\n            Please wait...\n          ")])])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},[_c('span',[_vm._v("NOTES TO DRIVER")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1354);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0bd8e310", content, true, {});

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.driver-service-filter[data-v-5f90f94f] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.5);\n  width: 100%;\n  height: 100%;\n  z-index: 4;\n  padding: 30px;\n}\n.box[data-v-5f90f94f] {\n  width: 100%;\n  padding: 15px 15px 50px;\n  background: #fff;\n  height: 100%;\n  -webkit-box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);\n  border-radius: 4px;\n  position: relative;\n}\n.label[data-v-5f90f94f] {\n  text-align: center;\n  font-weight: 600;\n  color: #0D79F2;\n  margin-bottom: 15px;\n}\n.filters[data-v-5f90f94f] {\n  height: calc(100% - 40px);\n  overflow: auto;\n}\n.services[data-v-5f90f94f] {\n  clear: both;\n}\n.services .head[data-v-5f90f94f] {\n    padding: 5px;\n    background: #5ec1ac;\n    color: #fff;\n    border: 1px solid #3d8374;\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n}\n.services .head i[data-v-5f90f94f] {\n      margin-right: 5px;\n}\n.services .body[data-v-5f90f94f] {\n    list-style: none;\n    margin: 0;\n    padding: 5px 0;\n    -webkit-column-count: 2;\n    -moz-column-count: 2;\n    column-count: 2;\n    -webkit-column-gap: 5px;\n       -moz-column-gap: 5px;\n            column-gap: 5px;\n    background: #fff;\n    border: 1px solid #3d8374;\n    max-height: 999px;\n}\n.services .body li[data-v-5f90f94f] {\n      padding: 3px 10px;\n      font-size: 13px;\n      cursor: pointer;\n}\n.services .body li[data-v-5f90f94f]:hover {\n        background: #f3f3f3;\n}\n.services .body li i[data-v-5f90f94f] {\n        vertical-align: middle;\n        margin-right: 5px;\n}\n.services .body li i.fa-check-square[data-v-5f90f94f] {\n          color: #5ec1ac;\n}\n.fixed-bottom[data-v-5f90f94f] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 50px;\n  padding: 7px 0;\n  background: #333;\n}\n.fixed-bottom .column[data-v-5f90f94f] {\n    padding: 0 10px;\n}\n.height-enter-active[data-v-5f90f94f], .height-leave-active[data-v-5f90f94f] {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.height-enter[data-v-5f90f94f], .height-leave-to[data-v-5f90f94f] {\n  max-height: 0;\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.driver-service-filter[data-v-5f90f94f] {\n    padding: 0;\n}\n.medium-6[data-v-5f90f94f] {\n    width: 50%;\n}\n.fixed-bottom[data-v-5f90f94f] {\n    height: 70px;\n    padding: 15px 0;\n}\n.filters[data-v-5f90f94f] {\n    height: 100%;\n    padding-bottom: 80px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/DriverServiceFilter.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,WAAW;EACX,cAAc;CACf;AACD;EACE,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,aAAa;EACb,+CAA+C;UACvC,uCAAuC;EAC/C,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;CACrB;AACD;EACE,0BAA0B;EAC1B,eAAe;CAChB;AACD;EACE,YAAY;CACb;AACD;IACI,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;CACnB;AACD;MACM,kBAAkB;CACvB;AACD;IACI,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;IAChB,wBAAwB;OACrB,qBAAqB;YAChB,gBAAgB;IACxB,iBAAiB;IACjB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;MACM,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB;CACrB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,uBAAuB;QACvB,kBAAkB;CACzB;AACD;UACU,eAAe;CACxB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,eAAe;EACf,iBAAiB;CAClB;AACD;IACI,gBAAgB;CACnB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,cAAc;EACd,WAAW;CACZ;AACD;AACA;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,aAAa;IACb,gBAAgB;CACnB;AACD;IACI,aAAa;IACb,qBAAqB;CACxB;CACA","file":"DriverServiceFilter.vue","sourcesContent":["\n.driver-service-filter[data-v-5f90f94f] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.5);\n  width: 100%;\n  height: 100%;\n  z-index: 4;\n  padding: 30px;\n}\n.box[data-v-5f90f94f] {\n  width: 100%;\n  padding: 15px 15px 50px;\n  background: #fff;\n  height: 100%;\n  -webkit-box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);\n  border-radius: 4px;\n  position: relative;\n}\n.label[data-v-5f90f94f] {\n  text-align: center;\n  font-weight: 600;\n  color: #0D79F2;\n  margin-bottom: 15px;\n}\n.filters[data-v-5f90f94f] {\n  height: calc(100% - 40px);\n  overflow: auto;\n}\n.services[data-v-5f90f94f] {\n  clear: both;\n}\n.services .head[data-v-5f90f94f] {\n    padding: 5px;\n    background: #5ec1ac;\n    color: #fff;\n    border: 1px solid #3d8374;\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n}\n.services .head i[data-v-5f90f94f] {\n      margin-right: 5px;\n}\n.services .body[data-v-5f90f94f] {\n    list-style: none;\n    margin: 0;\n    padding: 5px 0;\n    -webkit-column-count: 2;\n    -moz-column-count: 2;\n    column-count: 2;\n    -webkit-column-gap: 5px;\n       -moz-column-gap: 5px;\n            column-gap: 5px;\n    background: #fff;\n    border: 1px solid #3d8374;\n    max-height: 999px;\n}\n.services .body li[data-v-5f90f94f] {\n      padding: 3px 10px;\n      font-size: 13px;\n      cursor: pointer;\n}\n.services .body li[data-v-5f90f94f]:hover {\n        background: #f3f3f3;\n}\n.services .body li i[data-v-5f90f94f] {\n        vertical-align: middle;\n        margin-right: 5px;\n}\n.services .body li i.fa-check-square[data-v-5f90f94f] {\n          color: #5ec1ac;\n}\n.fixed-bottom[data-v-5f90f94f] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 50px;\n  padding: 7px 0;\n  background: #333;\n}\n.fixed-bottom .column[data-v-5f90f94f] {\n    padding: 0 10px;\n}\n.height-enter-active[data-v-5f90f94f], .height-leave-active[data-v-5f90f94f] {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.height-enter[data-v-5f90f94f], .height-leave-to[data-v-5f90f94f] {\n  max-height: 0;\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.driver-service-filter[data-v-5f90f94f] {\n    padding: 0;\n}\n.medium-6[data-v-5f90f94f] {\n    width: 50%;\n}\n.fixed-bottom[data-v-5f90f94f] {\n    height: 70px;\n    padding: 15px 0;\n}\n.filters[data-v-5f90f94f] {\n    height: 100%;\n    padding-bottom: 80px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"driver-service-filter"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"label"},[_vm._v("Service type filter")]),_vm._v(" "),_c('div',{staticClass:"filters"},_vm._l((_vm.brands),function(brand){return (_vm.serviceList(brand.id).length)?_c('div',{staticClass:"services"},[_c('div',{staticClass:"head",on:{"click":function($event){return _vm.toggleBrand(brand.id)}}},[(_vm.openBrand.indexOf(brand.id) > -1)?_c('i',{staticClass:"fas fa-angle-down"}):_c('i',{staticClass:"fas fa-angle-up"}),_vm._v("\n          "+_vm._s(brand.name)+"\n        ")]),_vm._v(" "),_c('transition',{attrs:{"name":"height"}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.openBrand.indexOf(brand.id) > -1),expression:"openBrand.indexOf(brand.id) > -1"}],staticClass:"body"},_vm._l((_vm.serviceList(brand.id)),function(service){return _c('li',{on:{"click":function($event){return _vm.toggleService(service.id)}}},[_c('i',{class:['fa-lg', _vm.selectedService.indexOf(service.id) > -1 ? 'fa-check-square fas' : 'far fa-square' ]}),_vm._v("\n              "+_vm._s(service.label)+"\n            ")])}),0)])],1):_vm._e()}),0),_vm._v(" "),_c('div',{staticClass:"fixed-bottom"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column medium-6"},[_c('div',{staticClass:"button cta warning block small",on:{"click":_vm.closeModal}},[_vm._v("Cancel")])]),_vm._v(" "),_c('div',{staticClass:"column medium-6"},[_c('div',{staticClass:"button cta success block small",on:{"click":_vm.applyFilters}},[_vm._v("Apply Filter")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tables_vue__ = __webpack_require__(487);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b89739c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tables_vue__ = __webpack_require__(1373);
function injectStyle (ssrContext) {
  __webpack_require__(1357)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b89739c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b89739c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1358);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1296dcde", content, true, {});

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.tables[data-v-1b89739c] {\n  height: 100%;\n}\n.list-box[data-v-1b89739c] {\n  height: 50%;\n  overflow-y: hidden;\n  overflow-x: hidden;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Runs/Tables.vue"],"names":[],"mappings":";AACA;EACE,aAAa;CACd;AACD;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;CACpB","file":"Tables.vue","sourcesContent":["\n.tables[data-v-1b89739c] {\n  height: 100%;\n}\n.list-box[data-v-1b89739c] {\n  height: 50%;\n  overflow-y: hidden;\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1360);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("c825eb88", content, true, {});

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.runs-box[data-v-5326644a] {\n  position: relative;\n  height: 100%;\n  width: calc(100% - 1px);\n}\n.runs-box.full[data-v-5326644a] {\n    height: auto;\n}\n.table-loader[data-v-5326644a] {\n  position: relative;\n  width: 100%;\n  margin: 50px auto;\n  text-align: center;\n}\n.table-loader .loader-title[data-v-5326644a] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.table-loader .loader-text[data-v-5326644a] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\n.table-scroll[data-v-5326644a] {\n  height: 100%;\n  overflow: auto;\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n}\n.runs-table[data-v-5326644a] {\n  border-collapse: collapse;\n  width: 100%;\n  overflow: auto;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n  height: 100%;\n  display: table-footer-group;\n}\n.runs-table thead[data-v-5326644a] {\n    width: 100%;\n    color: #8DA0A9;\n    font-size: 12px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n}\n.runs-table thead th[data-v-5326644a] {\n      padding: 5px;\n      position: sticky;\n      position: -webkit-sticky;\n      top: 0;\n      z-index: 2;\n      background-color: #f5f5f5;\n      text-transform: uppercase;\n}\n.runs-table thead th.sortable[data-v-5326644a] {\n        cursor: pointer;\n        text-decoration: underline;\n        color: #333;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.runs-table thead th.sortable.disabled[data-v-5326644a] {\n          pointer-events: none;\n          opacity: 0.5;\n}\n.runs-table thead th input[data-v-5326644a] {\n        margin-top: 0;\n        display: block;\n        width: auto;\n}\n.runs-table .check[data-v-5326644a] {\n    width: 30px;\n}\n.runs-table .map[data-v-5326644a] {\n    width: 40px;\n}\n.runs-table .ids[data-v-5326644a] {\n    width: 90px;\n}\n.runs-table .date[data-v-5326644a] {\n    width: 90px;\n}\n.runs-table .driver-payment[data-v-5326644a] {\n    width: 125px;\n}\n.runs-table .service[data-v-5326644a] {\n    width: 130px;\n}\n.empty-reservations[data-v-5326644a] {\n  max-width: 450px;\n  margin: 50px auto;\n  text-align: center;\n}\n.empty-reservations .title[data-v-5326644a] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.empty-reservations .content[data-v-5326644a] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\n@media screen and (max-width: 430px) {\n.empty-reservations[data-v-5326644a], .table-loader[data-v-5326644a] {\n    margin: 10vh auto;\n    width: 90%;\n}\n.runs-table[data-v-5326644a] {\n    display: table;\n}\n.runs-table tbody[data-v-5326644a] {\n      width: 100%;\n      padding: 60px 10px;\n      display: block;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Runs/RunsList.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,aAAa;EACb,wBAAwB;CACzB;AACD;IACI,aAAa;CAChB;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;CACpB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;EACE,aAAa;EACb,eAAe;EACf,yCAAyC;CAC1C;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,4CAA4C;EAC5C,aAAa;EACb,4BAA4B;CAC7B;AACD;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,4CAA4C;CAC/C;AACD;MACM,aAAa;MACb,iBAAiB;MACjB,yBAAyB;MACzB,OAAO;MACP,WAAW;MACX,0BAA0B;MAC1B,0BAA0B;CAC/B;AACD;QACQ,gBAAgB;QAChB,2BAA2B;QAC3B,YAAY;QACZ,8BAA8B;QAC9B,sBAAsB;CAC7B;AACD;UACU,qBAAqB;UACrB,aAAa;CACtB;AACD;QACQ,cAAc;QACd,eAAe;QACf,YAAY;CACnB;AACD;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;AACD;IACI,aAAa;CAChB;AACD;IACI,aAAa;CAChB;AACD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;CACpB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;AACA;IACI,kBAAkB;IAClB,WAAW;CACd;AACD;IACI,eAAe;CAClB;AACD;MACM,YAAY;MACZ,mBAAmB;MACnB,eAAe;CACpB;CACA","file":"RunsList.vue","sourcesContent":["\n.runs-box[data-v-5326644a] {\n  position: relative;\n  height: 100%;\n  width: calc(100% - 1px);\n}\n.runs-box.full[data-v-5326644a] {\n    height: auto;\n}\n.table-loader[data-v-5326644a] {\n  position: relative;\n  width: 100%;\n  margin: 50px auto;\n  text-align: center;\n}\n.table-loader .loader-title[data-v-5326644a] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.table-loader .loader-text[data-v-5326644a] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\n.table-scroll[data-v-5326644a] {\n  height: 100%;\n  overflow: auto;\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n}\n.runs-table[data-v-5326644a] {\n  border-collapse: collapse;\n  width: 100%;\n  overflow: auto;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n  height: 100%;\n  display: table-footer-group;\n}\n.runs-table thead[data-v-5326644a] {\n    width: 100%;\n    color: #8DA0A9;\n    font-size: 12px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n}\n.runs-table thead th[data-v-5326644a] {\n      padding: 5px;\n      position: sticky;\n      position: -webkit-sticky;\n      top: 0;\n      z-index: 2;\n      background-color: #f5f5f5;\n      text-transform: uppercase;\n}\n.runs-table thead th.sortable[data-v-5326644a] {\n        cursor: pointer;\n        text-decoration: underline;\n        color: #333;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.runs-table thead th.sortable.disabled[data-v-5326644a] {\n          pointer-events: none;\n          opacity: 0.5;\n}\n.runs-table thead th input[data-v-5326644a] {\n        margin-top: 0;\n        display: block;\n        width: auto;\n}\n.runs-table .check[data-v-5326644a] {\n    width: 30px;\n}\n.runs-table .map[data-v-5326644a] {\n    width: 40px;\n}\n.runs-table .ids[data-v-5326644a] {\n    width: 90px;\n}\n.runs-table .date[data-v-5326644a] {\n    width: 90px;\n}\n.runs-table .driver-payment[data-v-5326644a] {\n    width: 125px;\n}\n.runs-table .service[data-v-5326644a] {\n    width: 130px;\n}\n.empty-reservations[data-v-5326644a] {\n  max-width: 450px;\n  margin: 50px auto;\n  text-align: center;\n}\n.empty-reservations .title[data-v-5326644a] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.empty-reservations .content[data-v-5326644a] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\n@media screen and (max-width: 430px) {\n.empty-reservations[data-v-5326644a], .table-loader[data-v-5326644a] {\n    margin: 10vh auto;\n    width: 90%;\n}\n.runs-table[data-v-5326644a] {\n    display: table;\n}\n.runs-table tbody[data-v-5326644a] {\n      width: 100%;\n      padding: 60px 10px;\n      display: block;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunsRow_vue__ = __webpack_require__(490);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d8ea25c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunsRow_vue__ = __webpack_require__(1364);
function injectStyle (ssrContext) {
  __webpack_require__(1362)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d8ea25c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RunsRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d8ea25c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RunsRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1363);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("44c37953", content, true, {});

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.service-type[data-v-6d8ea25c] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-6d8ea25c] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-6d8ea25c] {\n    background: #26D97A;\n}\n.service-type.black[data-v-6d8ea25c] {\n    background: #777;\n}\n.service-type.suv[data-v-6d8ea25c] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-6d8ea25c] {\n    background: #6dabc3;\n}\n.license-type[data-v-6d8ea25c] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-6d8ea25c] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-6d8ea25c] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-6d8ea25c] {\n    background-color: #de6c2a;\n}\n.dragslot[data-v-6d8ea25c] {\n  font-weight: 700;\n  background-color: #fff;\n  padding: 5px;\n  -webkit-box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(0, 0, 0, 0.4);\n  border-radius: 3px;\n}\n.tr[data-v-6d8ea25c] {\n  background-color: #fff;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n}\n.tr.has-issues[data-v-6d8ea25c] {\n    background-color: #dddddd;\n}\n.tr td[data-v-6d8ea25c] {\n    padding: 10px 5px;\n    text-align: center;\n    font-size: 12px;\n}\n.tr input[data-v-6d8ea25c] {\n    margin-top: 0;\n    width: 13px;\n}\n.tr .map-pin[data-v-6d8ea25c] {\n    color: #fff;\n    background-color: #aaa;\n    width: 30px;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n    display: inline-block;\n    border-radius: 30px;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.tr .map-pin i[data-v-6d8ea25c] {\n      line-height: 30px;\n}\n.tr .rsvp-id[data-v-6d8ea25c] {\n    display: block;\n    font-size: 13px;\n    outline: none;\n    font-weight: 600;\n    line-height: 1.45;\n}\n.tr .service-type[data-v-6d8ea25c] {\n    display: block;\n    background: #999;\n    margin-bottom: 3px;\n}\n.tr .check[data-v-6d8ea25c] {\n    width: 30px;\n    position: relative;\n}\n.tr .check .timer[data-v-6d8ea25c] {\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      white-space: nowrap;\n      background: #ececec;\n      padding: 3px 5px;\n      line-height: 1;\n      font-size: 12px;\n      letter-spacing: .2px;\n      color: #555;\n}\n.tr .map[data-v-6d8ea25c] {\n    width: 40px;\n}\n.tr .ids[data-v-6d8ea25c] {\n    width: 90px;\n}\n.tr .date[data-v-6d8ea25c] {\n    width: 90px;\n}\n.tr .driver-payment[data-v-6d8ea25c] {\n    width: 110px;\n}\n.tr .service[data-v-6d8ea25c] {\n    width: 130px;\n}\n.map-button[data-v-6d8ea25c] {\n  padding: 10px;\n}\n.map-button a[data-v-6d8ea25c] {\n    color: #fff;\n    background-color: #aaa;\n    width: 30px;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n    display: inline-block;\n    border-radius: 30px;\n    cursor: pointer;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.map-button a i[data-v-6d8ea25c] {\n      line-height: inherit;\n}\n.map-button a.disabled[data-v-6d8ea25c] {\n      pointer-events: none;\n      opacity: 0.5;\n      background-color: #bbb;\n}\n.map-button a.selected[data-v-6d8ea25c] {\n      background-color: #26D97A;\n}\n.break[data-v-6d8ea25c] {\n  background: #f84a4a;\n  border-color: #aa4f4f;\n  padding: 6px 13px 7px;\n}\n.break[data-v-6d8ea25c]:hover {\n    background: #cd4242;\n}\n@media screen and (max-width: 430px) {\n.table-card[data-v-6d8ea25c] {\n    border: 1px solid #ccc;\n    margin: 10px;\n    margin-bottom: 15px;\n    padding: 10px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-size: 13px;\n    background-color: #fff;\n}\n.table-card a[data-v-6d8ea25c] {\n      font-weight: 900;\n}\n.table-card i[data-v-6d8ea25c] {\n      color: #0d79f2;\n}\n.table-card > div[data-v-6d8ea25c] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n      margin-bottom: 3px;\n}\n.table-card > div.see-more[data-v-6d8ea25c] {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        -webkit-box-pack: start;\n            -ms-flex-pack: start;\n                justify-content: flex-start;\n        -webkit-box-align: start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n}\n.table-card .toggle-div[data-v-6d8ea25c] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .toggle-div .toggle[data-v-6d8ea25c] {\n        font-size: 16px;\n        color: #0e79f2;\n}\n.table-card .row-1[data-v-6d8ea25c] {\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .row-1 .rsvp-id[data-v-6d8ea25c] {\n        margin: 0 3px;\n}\n.table-card .row-1 .rtg[data-v-6d8ea25c] {\n        display: inline-block;\n        margin: 4px;\n}\n.table-card .row-1 i[data-v-6d8ea25c] {\n        color: #26D97A;\n}\n.table-card .row-1 input[data-v-6d8ea25c] {\n        display: inline-block;\n        margin: 0;\n        width: 15px;\n        height: 15px;\n        margin-right: 5px;\n}\n.table-card .row-1 .map-button[data-v-6d8ea25c] {\n        padding: 0;\n}\n.table-card .row-1 .map-button a[data-v-6d8ea25c] {\n          background-color: #aaa;\n          width: 30px;\n          height: 30px;\n          line-height: 30px;\n          text-align: center;\n          border-radius: 30px;\n          -webkit-transition: all 250ms;\n          transition: all 250ms;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n          text-decoration: none;\n}\n.table-card .row-1 .map-button a i[data-v-6d8ea25c] {\n            color: #fff;\n}\n.table-card .row-1 .map-button a.disabled[data-v-6d8ea25c] {\n            pointer-events: none;\n            opacity: 0.5;\n            background-color: #bbb;\n}\n.table-card .row-1 .map-button a.selected[data-v-6d8ea25c] {\n            background-color: #26D97A;\n}\n.table-card .row-2[data-v-6d8ea25c] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: unset;\n          -ms-flex-pack: unset;\n              justify-content: unset;\n      gap: 5px;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .row-2 .image img[data-v-6d8ea25c] {\n        min-width: 30px;\n        max-width: 30px;\n}\n.table-card .row-7 strong[data-v-6d8ea25c] {\n      color: #666;\n}\n.table-card .row-7 i[data-v-6d8ea25c] {\n      color: #666;\n      margin: 0 3px;\n}\n.table-card .row-8[data-v-6d8ea25c] {\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.table-card .row-8 .actions[data-v-6d8ea25c] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.table-card .row-8 .actions span[data-v-6d8ea25c] {\n          padding: 8px 20px;\n}\n.table-card .row-8 .actions .notes i[data-v-6d8ea25c] {\n          color: #fff;\n}\n.table-card .service-type[data-v-6d8ea25c] {\n      margin: 0 5px;\n}\n.table-card .clock i[data-v-6d8ea25c] {\n      color: #F25E0D;\n}\n.table-card .pickup i[data-v-6d8ea25c] {\n      color: #d92626;\n}\n.table-card .dropoff i[data-v-6d8ea25c] {\n      color: #26D97A;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Runs/RunsRow.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;EAClD,qCAAqC;EACrC,mBAAmB;CACpB;AACD;EACE,uBAAuB;EACvB,4CAA4C;CAC7C;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;CACnB;AACD;IACI,cAAc;IACd,YAAY;CACf;AACD;IACI,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;MACM,kBAAkB;CACvB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;CACrB;AACD;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;CACtB;AACD;IACI,YAAY;IACZ,mBAAmB;CACtB;AACD;MACM,mBAAmB;MACnB,UAAU;MACV,QAAQ;MACR,oBAAoB;MACpB,oBAAoB;MACpB,iBAAiB;MACjB,eAAe;MACf,gBAAgB;MAChB,qBAAqB;MACrB,YAAY;CACjB;AACD;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;AACD;IACI,aAAa;CAChB;AACD;IACI,aAAa;CAChB;AACD;EACE,cAAc;CACf;AACD;IACI,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;IAChB,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;MACM,qBAAqB;CAC1B;AACD;MACM,qBAAqB;MACrB,aAAa;MACb,uBAAuB;CAC5B;AACD;MACM,0BAA0B;CAC/B;AACD;EACE,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;AACA;IACI,uBAAuB;IACvB,aAAa;IACb,oBAAoB;IACpB,cAAc;IACd,+BAA+B;IAC/B,oBAAoB;IACpB,gBAAgB;IAChB,uBAAuB;CAC1B;AACD;MACM,iBAAiB;CACtB;AACD;MACM,eAAe;CACpB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,uBAAuB;UACnB,oBAAoB;cAChB,sBAAsB;MAC9B,mBAAmB;CACxB;AACD;QACQ,6BAA6B;QAC7B,8BAA8B;YAC1B,2BAA2B;gBACvB,uBAAuB;QAC/B,wBAAwB;YACpB,qBAAqB;gBACjB,4BAA4B;QACpC,yBAAyB;YACrB,sBAAsB;gBAClB,wBAAwB;CACvC;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;QACQ,gBAAgB;QAChB,eAAe;CACtB;AACD;MACM,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;QACQ,cAAc;CACrB;AACD;QACQ,sBAAsB;QACtB,YAAY;CACnB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,sBAAsB;QACtB,UAAU;QACV,YAAY;QACZ,aAAa;QACb,kBAAkB;CACzB;AACD;QACQ,WAAW;CAClB;AACD;UACU,uBAAuB;UACvB,YAAY;UACZ,aAAa;UACb,kBAAkB;UAClB,mBAAmB;UACnB,oBAAoB;UACpB,8BAA8B;UAC9B,sBAAsB;UACtB,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;UACd,0BAA0B;cACtB,uBAAuB;kBACnB,oBAAoB;UAC5B,yBAAyB;cACrB,sBAAsB;kBAClB,wBAAwB;UAChC,sBAAsB;CAC/B;AACD;YACY,YAAY;CACvB;AACD;YACY,qBAAqB;YACrB,aAAa;YACb,uBAAuB;CAClC;AACD;YACY,0BAA0B;CACrC;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,wBAAwB;UACpB,qBAAqB;cACjB,uBAAuB;MAC/B,SAAS;MACT,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;QACQ,gBAAgB;QAChB,gBAAgB;CACvB;AACD;MACM,YAAY;CACjB;AACD;MACM,YAAY;MACZ,cAAc;CACnB;AACD;MACM,yBAAyB;UACrB,sBAAsB;cAClB,wBAAwB;CACrC;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;CACrB;AACD;UACU,kBAAkB;CAC3B;AACD;UACU,YAAY;CACrB;AACD;MACM,cAAc;CACnB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;CACA","file":"RunsRow.vue","sourcesContent":["\n.service-type[data-v-6d8ea25c] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-6d8ea25c] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-6d8ea25c] {\n    background: #26D97A;\n}\n.service-type.black[data-v-6d8ea25c] {\n    background: #777;\n}\n.service-type.suv[data-v-6d8ea25c] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-6d8ea25c] {\n    background: #6dabc3;\n}\n.license-type[data-v-6d8ea25c] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-6d8ea25c] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-6d8ea25c] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-6d8ea25c] {\n    background-color: #de6c2a;\n}\n.dragslot[data-v-6d8ea25c] {\n  font-weight: 700;\n  background-color: #fff;\n  padding: 5px;\n  -webkit-box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(0, 0, 0, 0.4);\n  border-radius: 3px;\n}\n.tr[data-v-6d8ea25c] {\n  background-color: #fff;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n}\n.tr.has-issues[data-v-6d8ea25c] {\n    background-color: #dddddd;\n}\n.tr td[data-v-6d8ea25c] {\n    padding: 10px 5px;\n    text-align: center;\n    font-size: 12px;\n}\n.tr input[data-v-6d8ea25c] {\n    margin-top: 0;\n    width: 13px;\n}\n.tr .map-pin[data-v-6d8ea25c] {\n    color: #fff;\n    background-color: #aaa;\n    width: 30px;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n    display: inline-block;\n    border-radius: 30px;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.tr .map-pin i[data-v-6d8ea25c] {\n      line-height: 30px;\n}\n.tr .rsvp-id[data-v-6d8ea25c] {\n    display: block;\n    font-size: 13px;\n    outline: none;\n    font-weight: 600;\n    line-height: 1.45;\n}\n.tr .service-type[data-v-6d8ea25c] {\n    display: block;\n    background: #999;\n    margin-bottom: 3px;\n}\n.tr .check[data-v-6d8ea25c] {\n    width: 30px;\n    position: relative;\n}\n.tr .check .timer[data-v-6d8ea25c] {\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      white-space: nowrap;\n      background: #ececec;\n      padding: 3px 5px;\n      line-height: 1;\n      font-size: 12px;\n      letter-spacing: .2px;\n      color: #555;\n}\n.tr .map[data-v-6d8ea25c] {\n    width: 40px;\n}\n.tr .ids[data-v-6d8ea25c] {\n    width: 90px;\n}\n.tr .date[data-v-6d8ea25c] {\n    width: 90px;\n}\n.tr .driver-payment[data-v-6d8ea25c] {\n    width: 110px;\n}\n.tr .service[data-v-6d8ea25c] {\n    width: 130px;\n}\n.map-button[data-v-6d8ea25c] {\n  padding: 10px;\n}\n.map-button a[data-v-6d8ea25c] {\n    color: #fff;\n    background-color: #aaa;\n    width: 30px;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n    display: inline-block;\n    border-radius: 30px;\n    cursor: pointer;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.map-button a i[data-v-6d8ea25c] {\n      line-height: inherit;\n}\n.map-button a.disabled[data-v-6d8ea25c] {\n      pointer-events: none;\n      opacity: 0.5;\n      background-color: #bbb;\n}\n.map-button a.selected[data-v-6d8ea25c] {\n      background-color: #26D97A;\n}\n.break[data-v-6d8ea25c] {\n  background: #f84a4a;\n  border-color: #aa4f4f;\n  padding: 6px 13px 7px;\n}\n.break[data-v-6d8ea25c]:hover {\n    background: #cd4242;\n}\n@media screen and (max-width: 430px) {\n.table-card[data-v-6d8ea25c] {\n    border: 1px solid #ccc;\n    margin: 10px;\n    margin-bottom: 15px;\n    padding: 10px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-size: 13px;\n    background-color: #fff;\n}\n.table-card a[data-v-6d8ea25c] {\n      font-weight: 900;\n}\n.table-card i[data-v-6d8ea25c] {\n      color: #0d79f2;\n}\n.table-card > div[data-v-6d8ea25c] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n      margin-bottom: 3px;\n}\n.table-card > div.see-more[data-v-6d8ea25c] {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        -webkit-box-pack: start;\n            -ms-flex-pack: start;\n                justify-content: flex-start;\n        -webkit-box-align: start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n}\n.table-card .toggle-div[data-v-6d8ea25c] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .toggle-div .toggle[data-v-6d8ea25c] {\n        font-size: 16px;\n        color: #0e79f2;\n}\n.table-card .row-1[data-v-6d8ea25c] {\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .row-1 .rsvp-id[data-v-6d8ea25c] {\n        margin: 0 3px;\n}\n.table-card .row-1 .rtg[data-v-6d8ea25c] {\n        display: inline-block;\n        margin: 4px;\n}\n.table-card .row-1 i[data-v-6d8ea25c] {\n        color: #26D97A;\n}\n.table-card .row-1 input[data-v-6d8ea25c] {\n        display: inline-block;\n        margin: 0;\n        width: 15px;\n        height: 15px;\n        margin-right: 5px;\n}\n.table-card .row-1 .map-button[data-v-6d8ea25c] {\n        padding: 0;\n}\n.table-card .row-1 .map-button a[data-v-6d8ea25c] {\n          background-color: #aaa;\n          width: 30px;\n          height: 30px;\n          line-height: 30px;\n          text-align: center;\n          border-radius: 30px;\n          -webkit-transition: all 250ms;\n          transition: all 250ms;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n          text-decoration: none;\n}\n.table-card .row-1 .map-button a i[data-v-6d8ea25c] {\n            color: #fff;\n}\n.table-card .row-1 .map-button a.disabled[data-v-6d8ea25c] {\n            pointer-events: none;\n            opacity: 0.5;\n            background-color: #bbb;\n}\n.table-card .row-1 .map-button a.selected[data-v-6d8ea25c] {\n            background-color: #26D97A;\n}\n.table-card .row-2[data-v-6d8ea25c] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: unset;\n          -ms-flex-pack: unset;\n              justify-content: unset;\n      gap: 5px;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .row-2 .image img[data-v-6d8ea25c] {\n        min-width: 30px;\n        max-width: 30px;\n}\n.table-card .row-7 strong[data-v-6d8ea25c] {\n      color: #666;\n}\n.table-card .row-7 i[data-v-6d8ea25c] {\n      color: #666;\n      margin: 0 3px;\n}\n.table-card .row-8[data-v-6d8ea25c] {\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.table-card .row-8 .actions[data-v-6d8ea25c] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.table-card .row-8 .actions span[data-v-6d8ea25c] {\n          padding: 8px 20px;\n}\n.table-card .row-8 .actions .notes i[data-v-6d8ea25c] {\n          color: #fff;\n}\n.table-card .service-type[data-v-6d8ea25c] {\n      margin: 0 5px;\n}\n.table-card .clock i[data-v-6d8ea25c] {\n      color: #F25E0D;\n}\n.table-card .pickup i[data-v-6d8ea25c] {\n      color: #d92626;\n}\n.table-card .dropoff i[data-v-6d8ea25c] {\n      color: #26D97A;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('drag',{class:{ tr: true, 'has-issues': _vm.isDisabled },attrs:{"tag":"tr","transfer-data":_vm.run,"draggable":!_vm.inMap},on:{"dragstart":function($event){return _vm.dragFn(true)},"dragend":function($event){return _vm.dragFn(false)}}},[_c('td',{staticClass:"check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],attrs:{"type":"radio"},domProps:{"value":_vm.run.id,"checked":_vm._q(_vm.selected,_vm.run.id)},on:{"click":function($event){return _vm.select(_vm.run.id)},"change":function($event){_vm.selected=_vm.run.id}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.timeLeft),expression:"timeLeft"}],staticClass:"timer",attrs:{"data-time":_vm.sendTimer}},[_vm._v(_vm._s(_vm.timeLeft))])]),_vm._v(" "),_c('td',{staticClass:"map-button pkg-map"},[_c('a',{class:{ selected: _vm.inMap },on:{"click":_vm.toggleInMap}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])]),_vm._v(" "),_c('td',{staticClass:"ids"},_vm._l((_vm.run.rsvpIDs),function(id,x){return _c('a',{key:("x" + x),staticClass:"rsvp-id",attrs:{"href":("/#/reservation/" + id),"target":"_blank"}},[_vm._v(_vm._s(id))])}),0),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v(_vm._s(_vm.run.pickupDate))]),_vm._v(" "),_c('td',{staticClass:"date2"},[_vm._v(_vm._s(_vm.run.lastDropoff))]),_vm._v(" "),_c('td',{staticClass:"locs pickup"},[_vm._v(_vm._s(_vm.getAddress(_vm.run.pickup)))]),_vm._v(" "),_c('td',{staticClass:"locs dropoff"},[_vm._v(_vm._s(_vm.getAddress(_vm.run.dropoff)))]),_vm._v(" "),_c('td',{staticClass:"driver-payment"},[_vm._v("$"+_vm._s(parseFloat(_vm.run.driverPayment.toFixed(2))))]),_vm._v(" "),_c('td',{staticClass:"pax"},[_vm._v(_vm._s(_vm.run.pax.join('/')))]),_vm._v(" "),_c('td',{staticClass:"service"},_vm._l((_vm.run.services),function(service,n){return _c('span',{key:("n" + n),staticClass:"service-type",style:({background: service.color})},[_vm._v(_vm._s(service.name))])}),0),_vm._v(" "),_c('td',{staticClass:"action"},[_c('div',{staticClass:"button cta break xsmall",on:{"click":function($event){return _vm.breakRun(_vm.run.id)}}},[_vm._v("Break")])])]):_c('div',{staticClass:"table-card"},[_c('div',{staticClass:"row-1"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],attrs:{"type":"radio"},domProps:{"value":_vm.run.id,"checked":_vm._q(_vm.selected,_vm.run.id)},on:{"change":function($event){_vm.selected=_vm.run.id}}}),_vm._v(" "),_vm._l((_vm.run.rsvpIDs),function(id,x){return _c('a',{key:("x" + x),staticClass:"rsvp-id",attrs:{"href":("/#/reservation/" + id),"target":"_blank"}},[_vm._v(_vm._s(id))])}),_vm._v(" "),_vm._l((_vm.run.services),function(service,n){return _c('span',{key:("n" + n),staticClass:"service-type",style:({background: service.color})},[_vm._v(_vm._s(service.name))])})],2),_vm._v(" "),_c('div',{staticClass:"map-button",on:{"click":_vm.toggleInMap}},[_c('a',{class:{selected: _vm.inMap},attrs:{"href":"javascript:;"}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])])]),_vm._v(" "),_c('div',[_c('div',[_vm._v("Pickup Time: "+_vm._s(_vm.run.pickupDate))])]),_vm._v(" "),(_vm.run.flightInfo)?_c('div',[_c('a',{on:{"click":function($event){return _vm.showFlightInfo(_vm.rsvp)}}},[_vm._v(_vm._s(_vm.run.flightInfo.airline)+" "+_vm._s(_vm.run.flightInfo.flightNo))]),_vm._v(" "),(_vm.run.flightInfo.isDeparture)?_c('img',{attrs:{"src":"/assets/img/departure.png"}}):_c('img',{attrs:{"src":"/assets/img/arrival.png"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row-4"},[_c('div',{staticClass:"pickup"},[_c('i',{staticClass:"fas fa-map-marker-alt icon"}),_vm._v("\n        "+_vm._s(_vm.getAddress(_vm.run.pickup))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"row-5"},[_c('div',{staticClass:"dropoff"},[_c('i',{staticClass:"fas fa-location-arrow icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getAddress(_vm.run.dropoff)))])])]),_vm._v(" "),_c('div',[_c('div',[_vm._v("Driver Payment: $"+_vm._s(parseFloat(_vm.run.driverPayment.toFixed(2))))])]),_vm._v(" "),(_vm.run.pax)?_c('div',[_vm._v("\n      PAX: "+_vm._s(_vm.run.pax)+"\n    ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['runs-box', {full:_vm.route === 'Runs' && !_vm.runs.list.length}]},[(_vm.runs.loading && !_vm.runs.list.length)?_c('div',{staticClass:"table-loader"},[_c('ellipsis-loader'),_vm._v(" "),_c('div',{staticClass:"loader-title"},[_vm._v("Loading Runs . . .")]),_vm._v(" "),_c('div',{staticClass:"loader-text"},[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.loadingData.content')))])],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.runs.list.length && !_vm.runs.loading),expression:"runs.list.length && !runs.loading"}],staticClass:"table-scroll"},[_c('table',{staticClass:"runs-table",attrs:{"id":"runs-table"}},[(!_vm.isMobile)?_c('thead',[_c('th',{staticClass:"check"}),_vm._v(" "),_c('th',{staticClass:"map"}),_vm._v(" "),_c('th',{staticClass:"ids"},[_vm._v("IDs")]),_vm._v(" "),_c('th',{staticClass:"date"},[_vm._v("Pickup Time")]),_vm._v(" "),_c('th',{staticClass:"date2"},[_vm._v("Last Dropoff Time")]),_vm._v(" "),_c('th',{staticClass:"locs pickup"},[_vm._v("Pickup")]),_vm._v(" "),_c('th',{staticClass:"locs dropoff"},[_vm._v("Dropoff")]),_vm._v(" "),_c('th',{staticClass:"driver-payment"},[_vm._v("Driver Payment")]),_vm._v(" "),_c('th',{staticClass:"pax"},[_vm._v("PAX")]),_vm._v(" "),_c('th',{staticClass:"service"},[_vm._v("Service Type")]),_vm._v(" "),_c('th',{staticClass:"action"})]):_vm._e(),_vm._v(" "),_c('tbody',_vm._l((_vm.runs.list),function(run,i){return _c('runs-row',{key:i,attrs:{"run":run,"isMobile":_vm.isMobile}})}),1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.runs.list.length && !_vm.runs.loading),expression:"!runs.list.length && !runs.loading"}],staticClass:"empty-reservations"},[_c('arrow-up'),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Oops. Looks like we found nothing.")]),_vm._v(" "),_vm._m(0)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_vm._v("\n      We can't find any runs for that filter."),_c('br'),_vm._v("\n      Please use another one from the form at the top.\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1367);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("252c09c0", content, true, {});

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.service-type[data-v-459c7492] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-459c7492] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-459c7492] {\n    background: #26D97A;\n}\n.service-type.black[data-v-459c7492] {\n    background: #777;\n}\n.service-type.suv[data-v-459c7492] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-459c7492] {\n    background: #6dabc3;\n}\n.license-type[data-v-459c7492] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-459c7492] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-459c7492] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-459c7492] {\n    background-color: #de6c2a;\n}\n.runs-box[data-v-459c7492] {\n  position: relative;\n  height: 100%;\n  width: calc(100% - 1px);\n}\n.table-loader[data-v-459c7492] {\n  position: relative;\n  width: 100%;\n  margin: 50px auto;\n  text-align: center;\n}\n.table-loader .loader-title[data-v-459c7492] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.table-loader .loader-text[data-v-459c7492] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\n.table-scroll[data-v-459c7492] {\n  height: 100%;\n  overflow: auto;\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n}\n.runs-table[data-v-459c7492] {\n  border-collapse: collapse;\n  width: 100%;\n  overflow: auto;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n  height: 100%;\n  display: table-footer-group;\n}\n.runs-table thead[data-v-459c7492] {\n    width: 100%;\n    color: #8DA0A9;\n    font-size: 12px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n}\n.runs-table thead th[data-v-459c7492] {\n      padding: 5px;\n      position: sticky;\n      position: -webkit-sticky;\n      top: 0;\n      z-index: 2;\n      background-color: #f5f5f5;\n      text-transform: uppercase;\n}\n.runs-table thead th.sortable[data-v-459c7492] {\n        cursor: pointer;\n        text-decoration: underline;\n        color: #333;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.runs-table thead th.sortable.disabled[data-v-459c7492] {\n          pointer-events: none;\n          opacity: 0.5;\n}\n.runs-table thead th input[data-v-459c7492] {\n        margin-top: 0;\n        display: block;\n        width: auto;\n}\n.runs-table tbody[data-v-459c7492] {\n    width: 100%;\n}\n.runs-table tbody tr[data-v-459c7492] {\n      background-color: #fff;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n}\n.runs-table tbody td[data-v-459c7492] {\n      padding: 10px 5px;\n      text-align: center;\n      font-size: 12px;\n}\n.runs-table tbody input[data-v-459c7492] {\n      margin-top: 0;\n      width: 13px;\n}\n.runs-table tbody .map-pin[data-v-459c7492] {\n      color: #fff;\n      background-color: #aaa;\n      width: 30px;\n      height: 30px;\n      line-height: 30px;\n      text-align: center;\n      display: inline-block;\n      border-radius: 30px;\n      -webkit-transition: all 250ms;\n      transition: all 250ms;\n}\n.runs-table tbody .rsvp-id[data-v-459c7492] {\n      display: block;\n      font-size: 13px;\n      outline: none;\n      font-weight: 600;\n      line-height: 1.45;\n}\n.runs-table tbody .service-type[data-v-459c7492] {\n      display: block;\n      background: #999;\n      margin-bottom: 3px;\n}\n.runs-table .check[data-v-459c7492] {\n    width: 30px;\n}\n.runs-table .map[data-v-459c7492] {\n    width: 40px;\n}\n.runs-table .ids[data-v-459c7492] {\n    width: 90px;\n}\n.runs-table .date[data-v-459c7492] {\n    width: 90px;\n}\n.runs-table .driver-payment[data-v-459c7492] {\n    width: 125px;\n}\n.runs-table .flight-info[data-v-459c7492] {\n    width: 100px;\n}\n.runs-table .service[data-v-459c7492] {\n    width: 130px;\n}\n.empty-reservations[data-v-459c7492] {\n  max-width: 450px;\n  margin: 50px auto;\n  text-align: center;\n}\n.empty-reservations .title[data-v-459c7492] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.empty-reservations .content[data-v-459c7492] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\n@media screen and (max-width: 430px) {\n.empty-reservations[data-v-459c7492], .table-loader[data-v-459c7492] {\n    margin: 10vh auto;\n    width: 90%;\n}\n.runs-table[data-v-459c7492] {\n    display: table;\n}\n.runs-table tbody[data-v-459c7492] {\n      width: 100%;\n      padding: 60px 10px;\n      display: block;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Runs/ExclusiveList.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,mBAAmB;EACnB,aAAa;EACb,wBAAwB;CACzB;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;CACpB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;EACE,aAAa;EACb,eAAe;EACf,yCAAyC;CAC1C;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,4CAA4C;EAC5C,aAAa;EACb,4BAA4B;CAC7B;AACD;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,4CAA4C;CAC/C;AACD;MACM,aAAa;MACb,iBAAiB;MACjB,yBAAyB;MACzB,OAAO;MACP,WAAW;MACX,0BAA0B;MAC1B,0BAA0B;CAC/B;AACD;QACQ,gBAAgB;QAChB,2BAA2B;QAC3B,YAAY;QACZ,8BAA8B;QAC9B,sBAAsB;CAC7B;AACD;UACU,qBAAqB;UACrB,aAAa;CACtB;AACD;QACQ,cAAc;QACd,eAAe;QACf,YAAY;CACnB;AACD;IACI,YAAY;CACf;AACD;MACM,uBAAuB;MACvB,4CAA4C;CACjD;AACD;MACM,kBAAkB;MAClB,mBAAmB;MACnB,gBAAgB;CACrB;AACD;MACM,cAAc;MACd,YAAY;CACjB;AACD;MACM,YAAY;MACZ,uBAAuB;MACvB,YAAY;MACZ,aAAa;MACb,kBAAkB;MAClB,mBAAmB;MACnB,sBAAsB;MACtB,oBAAoB;MACpB,8BAA8B;MAC9B,sBAAsB;CAC3B;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,cAAc;MACd,iBAAiB;MACjB,kBAAkB;CACvB;AACD;MACM,eAAe;MACf,iBAAiB;MACjB,mBAAmB;CACxB;AACD;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;AACD;IACI,aAAa;CAChB;AACD;IACI,aAAa;CAChB;AACD;IACI,aAAa;CAChB;AACD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;CACpB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;AACA;IACI,kBAAkB;IAClB,WAAW;CACd;AACD;IACI,eAAe;CAClB;AACD;MACM,YAAY;MACZ,mBAAmB;MACnB,eAAe;CACpB;CACA","file":"ExclusiveList.vue","sourcesContent":["\n.service-type[data-v-459c7492] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-459c7492] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-459c7492] {\n    background: #26D97A;\n}\n.service-type.black[data-v-459c7492] {\n    background: #777;\n}\n.service-type.suv[data-v-459c7492] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-459c7492] {\n    background: #6dabc3;\n}\n.license-type[data-v-459c7492] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-459c7492] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-459c7492] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-459c7492] {\n    background-color: #de6c2a;\n}\n.runs-box[data-v-459c7492] {\n  position: relative;\n  height: 100%;\n  width: calc(100% - 1px);\n}\n.table-loader[data-v-459c7492] {\n  position: relative;\n  width: 100%;\n  margin: 50px auto;\n  text-align: center;\n}\n.table-loader .loader-title[data-v-459c7492] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.table-loader .loader-text[data-v-459c7492] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\n.table-scroll[data-v-459c7492] {\n  height: 100%;\n  overflow: auto;\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n}\n.runs-table[data-v-459c7492] {\n  border-collapse: collapse;\n  width: 100%;\n  overflow: auto;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n  height: 100%;\n  display: table-footer-group;\n}\n.runs-table thead[data-v-459c7492] {\n    width: 100%;\n    color: #8DA0A9;\n    font-size: 12px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n}\n.runs-table thead th[data-v-459c7492] {\n      padding: 5px;\n      position: sticky;\n      position: -webkit-sticky;\n      top: 0;\n      z-index: 2;\n      background-color: #f5f5f5;\n      text-transform: uppercase;\n}\n.runs-table thead th.sortable[data-v-459c7492] {\n        cursor: pointer;\n        text-decoration: underline;\n        color: #333;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.runs-table thead th.sortable.disabled[data-v-459c7492] {\n          pointer-events: none;\n          opacity: 0.5;\n}\n.runs-table thead th input[data-v-459c7492] {\n        margin-top: 0;\n        display: block;\n        width: auto;\n}\n.runs-table tbody[data-v-459c7492] {\n    width: 100%;\n}\n.runs-table tbody tr[data-v-459c7492] {\n      background-color: #fff;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n}\n.runs-table tbody td[data-v-459c7492] {\n      padding: 10px 5px;\n      text-align: center;\n      font-size: 12px;\n}\n.runs-table tbody input[data-v-459c7492] {\n      margin-top: 0;\n      width: 13px;\n}\n.runs-table tbody .map-pin[data-v-459c7492] {\n      color: #fff;\n      background-color: #aaa;\n      width: 30px;\n      height: 30px;\n      line-height: 30px;\n      text-align: center;\n      display: inline-block;\n      border-radius: 30px;\n      -webkit-transition: all 250ms;\n      transition: all 250ms;\n}\n.runs-table tbody .rsvp-id[data-v-459c7492] {\n      display: block;\n      font-size: 13px;\n      outline: none;\n      font-weight: 600;\n      line-height: 1.45;\n}\n.runs-table tbody .service-type[data-v-459c7492] {\n      display: block;\n      background: #999;\n      margin-bottom: 3px;\n}\n.runs-table .check[data-v-459c7492] {\n    width: 30px;\n}\n.runs-table .map[data-v-459c7492] {\n    width: 40px;\n}\n.runs-table .ids[data-v-459c7492] {\n    width: 90px;\n}\n.runs-table .date[data-v-459c7492] {\n    width: 90px;\n}\n.runs-table .driver-payment[data-v-459c7492] {\n    width: 125px;\n}\n.runs-table .flight-info[data-v-459c7492] {\n    width: 100px;\n}\n.runs-table .service[data-v-459c7492] {\n    width: 130px;\n}\n.empty-reservations[data-v-459c7492] {\n  max-width: 450px;\n  margin: 50px auto;\n  text-align: center;\n}\n.empty-reservations .title[data-v-459c7492] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.empty-reservations .content[data-v-459c7492] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\n@media screen and (max-width: 430px) {\n.empty-reservations[data-v-459c7492], .table-loader[data-v-459c7492] {\n    margin: 10vh auto;\n    width: 90%;\n}\n.runs-table[data-v-459c7492] {\n    display: table;\n}\n.runs-table tbody[data-v-459c7492] {\n      width: 100%;\n      padding: 60px 10px;\n      display: block;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExclusiveRow_vue__ = __webpack_require__(493);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_337b749a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExclusiveRow_vue__ = __webpack_require__(1371);
function injectStyle (ssrContext) {
  __webpack_require__(1369)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-337b749a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExclusiveRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_337b749a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExclusiveRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1370);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("66789ad9", content, true, {});

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.service-type[data-v-337b749a] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-337b749a] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-337b749a] {\n    background: #26D97A;\n}\n.service-type.black[data-v-337b749a] {\n    background: #777;\n}\n.service-type.suv[data-v-337b749a] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-337b749a] {\n    background: #6dabc3;\n}\n.license-type[data-v-337b749a] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-337b749a] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-337b749a] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-337b749a] {\n    background-color: #de6c2a;\n}\n.dragslot[data-v-337b749a] {\n  font-weight: 700;\n  background-color: #fff;\n  padding: 5px;\n  -webkit-box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(0, 0, 0, 0.4);\n  border-radius: 3px;\n}\n.tr[data-v-337b749a] {\n  background-color: #fff;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n}\n.tr.has-issues[data-v-337b749a] {\n    background-color: #dddddd;\n}\n.tr td[data-v-337b749a] {\n    padding: 10px 5px;\n    text-align: center;\n    font-size: 12px;\n}\n.tr input[data-v-337b749a] {\n    margin-top: 0;\n    width: 13px;\n}\n.tr .map-pin[data-v-337b749a] {\n    color: #fff;\n    background-color: #aaa;\n    width: 30px;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n    display: inline-block;\n    border-radius: 30px;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.tr .map-pin i[data-v-337b749a] {\n      line-height: 30px;\n}\n.tr .rsvp-id[data-v-337b749a] {\n    display: block;\n    font-size: 13px;\n    outline: none;\n    font-weight: 600;\n    line-height: 1.45;\n}\n.tr .service-type[data-v-337b749a] {\n    display: block;\n    background: #999;\n    margin-bottom: 3px;\n}\n.tr .check[data-v-337b749a] {\n    width: 30px;\n}\n.tr .map[data-v-337b749a] {\n    width: 40px;\n}\n.tr .ids[data-v-337b749a] {\n    width: 90px;\n}\n.tr .date[data-v-337b749a] {\n    width: 90px;\n}\n.tr .driver-payment[data-v-337b749a] {\n    width: 110px;\n}\n.tr .flight-info[data-v-337b749a] {\n    width: 100px;\n}\n.tr .flight-info img[data-v-337b749a] {\n      width: 30px;\n}\n.tr .flight-info a[data-v-337b749a] {\n      display: block;\n      cursor: pointer;\n      font-weight: 600;\n}\n.tr .service[data-v-337b749a] {\n    width: 130px;\n}\n.map-button[data-v-337b749a] {\n  padding: 10px;\n}\n.map-button a[data-v-337b749a] {\n    color: #fff;\n    background-color: #aaa;\n    width: 30px;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n    display: inline-block;\n    border-radius: 30px;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.map-button a i[data-v-337b749a] {\n      line-height: inherit;\n}\n.map-button a.disabled[data-v-337b749a] {\n      pointer-events: none;\n      opacity: 0.5;\n      background-color: #bbb;\n}\n.map-button a.selected[data-v-337b749a] {\n      background-color: #26D97A;\n}\n@media screen and (max-width: 430px) {\n.table-card[data-v-337b749a] {\n    border: 1px solid #ccc;\n    margin: 10px;\n    margin-bottom: 15px;\n    padding: 10px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-size: 13px;\n    background-color: #fff;\n}\n.table-card a[data-v-337b749a] {\n      font-weight: 900;\n}\n.table-card i[data-v-337b749a] {\n      color: #0d79f2;\n}\n.table-card > div[data-v-337b749a] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n      margin-bottom: 3px;\n}\n.table-card > div.see-more[data-v-337b749a] {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        -webkit-box-pack: start;\n            -ms-flex-pack: start;\n                justify-content: flex-start;\n        -webkit-box-align: start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n}\n.table-card .toggle-div[data-v-337b749a] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .toggle-div .toggle[data-v-337b749a] {\n        font-size: 16px;\n        color: #0e79f2;\n}\n.table-card .row-1[data-v-337b749a] {\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .row-1 .link[data-v-337b749a] {\n        padding-bottom: 5px;\n        display: inline-block;\n}\n.table-card .row-1 .rtg[data-v-337b749a] {\n        display: inline-block;\n        margin: 4px;\n}\n.table-card .row-1 i[data-v-337b749a] {\n        color: #26D97A;\n}\n.table-card .row-1 input[data-v-337b749a] {\n        display: inline-block;\n        margin: 0;\n        width: 15px;\n        height: 15px;\n        margin-right: 5px;\n}\n.table-card .row-1 .map-button[data-v-337b749a] {\n        padding: 0;\n}\n.table-card .row-1 .map-button a[data-v-337b749a] {\n          background-color: #aaa;\n          width: 30px;\n          height: 30px;\n          line-height: 30px;\n          text-align: center;\n          border-radius: 30px;\n          -webkit-transition: all 250ms;\n          transition: all 250ms;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n          text-decoration: none;\n}\n.table-card .row-1 .map-button a i[data-v-337b749a] {\n            color: #fff;\n}\n.table-card .row-1 .map-button a.disabled[data-v-337b749a] {\n            pointer-events: none;\n            opacity: 0.5;\n            background-color: #bbb;\n}\n.table-card .row-1 .map-button a.selected[data-v-337b749a] {\n            background-color: #26D97A;\n}\n.table-card .flight-info img[data-v-337b749a] {\n      min-width: 30px;\n      max-width: 30px;\n}\n.table-card .row-2[data-v-337b749a] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: unset;\n          -ms-flex-pack: unset;\n              justify-content: unset;\n      gap: 5px;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .row-2 .image img[data-v-337b749a] {\n        min-width: 30px;\n        max-width: 30px;\n}\n.table-card .row-7 strong[data-v-337b749a] {\n      color: #666;\n}\n.table-card .row-7 i[data-v-337b749a] {\n      color: #666;\n      margin: 0 3px;\n}\n.table-card .row-8[data-v-337b749a] {\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.table-card .row-8 .actions[data-v-337b749a] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.table-card .row-8 .actions span[data-v-337b749a] {\n          padding: 8px 20px;\n}\n.table-card .row-8 .actions .notes i[data-v-337b749a] {\n          color: #fff;\n}\n.table-card .service-type[data-v-337b749a] {\n      margin: 0 5px;\n}\n.table-card .clock i[data-v-337b749a] {\n      color: #F25E0D;\n}\n.table-card .pickup i[data-v-337b749a] {\n      color: #d92626;\n}\n.table-card .dropoff i[data-v-337b749a] {\n      color: #26D97A;\n}\n}\n.tool-tip-box[data-v-337b749a] {\n  position: relative;\n}\n.tool-tip-box span[data-v-337b749a] {\n    display: none;\n    position: absolute;\n    top: calc(100% + 3px);\n    left: -55px;\n    line-height: 1.2;\n    font-size: 12px;\n    border: 1px solid #888;\n    background: #fafafa;\n    color: #333;\n    padding: 3px 5px;\n    width: 170px;\n    text-align: center;\n}\n.tool-tip-box i:hover + span[data-v-337b749a], .tool-tip-box img:hover + span[data-v-337b749a] {\n    display: block;\n}\n.optin-icon[data-v-337b749a] {\n  min-width: 18px !important;\n  width: 18px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Runs/ExclusiveRow.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;EAClD,qCAAqC;EACrC,mBAAmB;CACpB;AACD;EACE,uBAAuB;EACvB,4CAA4C;CAC7C;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;CACnB;AACD;IACI,cAAc;IACd,YAAY;CACf;AACD;IACI,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;MACM,kBAAkB;CACvB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;CACrB;AACD;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;CACtB;AACD;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;AACD;IACI,aAAa;CAChB;AACD;IACI,aAAa;CAChB;AACD;MACM,YAAY;CACjB;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,iBAAiB;CACtB;AACD;IACI,aAAa;CAChB;AACD;EACE,cAAc;CACf;AACD;IACI,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;MACM,qBAAqB;CAC1B;AACD;MACM,qBAAqB;MACrB,aAAa;MACb,uBAAuB;CAC5B;AACD;MACM,0BAA0B;CAC/B;AACD;AACA;IACI,uBAAuB;IACvB,aAAa;IACb,oBAAoB;IACpB,cAAc;IACd,+BAA+B;IAC/B,oBAAoB;IACpB,gBAAgB;IAChB,uBAAuB;CAC1B;AACD;MACM,iBAAiB;CACtB;AACD;MACM,eAAe;CACpB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,uBAAuB;UACnB,oBAAoB;cAChB,sBAAsB;MAC9B,mBAAmB;CACxB;AACD;QACQ,6BAA6B;QAC7B,8BAA8B;YAC1B,2BAA2B;gBACvB,uBAAuB;QAC/B,wBAAwB;YACpB,qBAAqB;gBACjB,4BAA4B;QACpC,yBAAyB;YACrB,sBAAsB;gBAClB,wBAAwB;CACvC;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;QACQ,gBAAgB;QAChB,eAAe;CACtB;AACD;MACM,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;QACQ,oBAAoB;QACpB,sBAAsB;CAC7B;AACD;QACQ,sBAAsB;QACtB,YAAY;CACnB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,sBAAsB;QACtB,UAAU;QACV,YAAY;QACZ,aAAa;QACb,kBAAkB;CACzB;AACD;QACQ,WAAW;CAClB;AACD;UACU,uBAAuB;UACvB,YAAY;UACZ,aAAa;UACb,kBAAkB;UAClB,mBAAmB;UACnB,oBAAoB;UACpB,8BAA8B;UAC9B,sBAAsB;UACtB,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;UACd,0BAA0B;cACtB,uBAAuB;kBACnB,oBAAoB;UAC5B,yBAAyB;cACrB,sBAAsB;kBAClB,wBAAwB;UAChC,sBAAsB;CAC/B;AACD;YACY,YAAY;CACvB;AACD;YACY,qBAAqB;YACrB,aAAa;YACb,uBAAuB;CAClC;AACD;YACY,0BAA0B;CACrC;AACD;MACM,gBAAgB;MAChB,gBAAgB;CACrB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,wBAAwB;UACpB,qBAAqB;cACjB,uBAAuB;MAC/B,SAAS;MACT,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;QACQ,gBAAgB;QAChB,gBAAgB;CACvB;AACD;MACM,YAAY;CACjB;AACD;MACM,YAAY;MACZ,cAAc;CACnB;AACD;MACM,yBAAyB;UACrB,sBAAsB;cAClB,wBAAwB;CACrC;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;CACrB;AACD;UACU,kBAAkB;CAC3B;AACD;UACU,YAAY;CACrB;AACD;MACM,cAAc;CACnB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;CACA;AACD;EACE,mBAAmB;CACpB;AACD;IACI,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,mBAAmB;CACtB;AACD;IACI,eAAe;CAClB;AACD;EACE,2BAA2B;EAC3B,YAAY;CACb","file":"ExclusiveRow.vue","sourcesContent":["\n.service-type[data-v-337b749a] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-337b749a] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-337b749a] {\n    background: #26D97A;\n}\n.service-type.black[data-v-337b749a] {\n    background: #777;\n}\n.service-type.suv[data-v-337b749a] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-337b749a] {\n    background: #6dabc3;\n}\n.license-type[data-v-337b749a] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-337b749a] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-337b749a] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-337b749a] {\n    background-color: #de6c2a;\n}\n.dragslot[data-v-337b749a] {\n  font-weight: 700;\n  background-color: #fff;\n  padding: 5px;\n  -webkit-box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(0, 0, 0, 0.4);\n  border-radius: 3px;\n}\n.tr[data-v-337b749a] {\n  background-color: #fff;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n}\n.tr.has-issues[data-v-337b749a] {\n    background-color: #dddddd;\n}\n.tr td[data-v-337b749a] {\n    padding: 10px 5px;\n    text-align: center;\n    font-size: 12px;\n}\n.tr input[data-v-337b749a] {\n    margin-top: 0;\n    width: 13px;\n}\n.tr .map-pin[data-v-337b749a] {\n    color: #fff;\n    background-color: #aaa;\n    width: 30px;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n    display: inline-block;\n    border-radius: 30px;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.tr .map-pin i[data-v-337b749a] {\n      line-height: 30px;\n}\n.tr .rsvp-id[data-v-337b749a] {\n    display: block;\n    font-size: 13px;\n    outline: none;\n    font-weight: 600;\n    line-height: 1.45;\n}\n.tr .service-type[data-v-337b749a] {\n    display: block;\n    background: #999;\n    margin-bottom: 3px;\n}\n.tr .check[data-v-337b749a] {\n    width: 30px;\n}\n.tr .map[data-v-337b749a] {\n    width: 40px;\n}\n.tr .ids[data-v-337b749a] {\n    width: 90px;\n}\n.tr .date[data-v-337b749a] {\n    width: 90px;\n}\n.tr .driver-payment[data-v-337b749a] {\n    width: 110px;\n}\n.tr .flight-info[data-v-337b749a] {\n    width: 100px;\n}\n.tr .flight-info img[data-v-337b749a] {\n      width: 30px;\n}\n.tr .flight-info a[data-v-337b749a] {\n      display: block;\n      cursor: pointer;\n      font-weight: 600;\n}\n.tr .service[data-v-337b749a] {\n    width: 130px;\n}\n.map-button[data-v-337b749a] {\n  padding: 10px;\n}\n.map-button a[data-v-337b749a] {\n    color: #fff;\n    background-color: #aaa;\n    width: 30px;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n    display: inline-block;\n    border-radius: 30px;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.map-button a i[data-v-337b749a] {\n      line-height: inherit;\n}\n.map-button a.disabled[data-v-337b749a] {\n      pointer-events: none;\n      opacity: 0.5;\n      background-color: #bbb;\n}\n.map-button a.selected[data-v-337b749a] {\n      background-color: #26D97A;\n}\n@media screen and (max-width: 430px) {\n.table-card[data-v-337b749a] {\n    border: 1px solid #ccc;\n    margin: 10px;\n    margin-bottom: 15px;\n    padding: 10px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-size: 13px;\n    background-color: #fff;\n}\n.table-card a[data-v-337b749a] {\n      font-weight: 900;\n}\n.table-card i[data-v-337b749a] {\n      color: #0d79f2;\n}\n.table-card > div[data-v-337b749a] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n      margin-bottom: 3px;\n}\n.table-card > div.see-more[data-v-337b749a] {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        -webkit-box-pack: start;\n            -ms-flex-pack: start;\n                justify-content: flex-start;\n        -webkit-box-align: start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n}\n.table-card .toggle-div[data-v-337b749a] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .toggle-div .toggle[data-v-337b749a] {\n        font-size: 16px;\n        color: #0e79f2;\n}\n.table-card .row-1[data-v-337b749a] {\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .row-1 .link[data-v-337b749a] {\n        padding-bottom: 5px;\n        display: inline-block;\n}\n.table-card .row-1 .rtg[data-v-337b749a] {\n        display: inline-block;\n        margin: 4px;\n}\n.table-card .row-1 i[data-v-337b749a] {\n        color: #26D97A;\n}\n.table-card .row-1 input[data-v-337b749a] {\n        display: inline-block;\n        margin: 0;\n        width: 15px;\n        height: 15px;\n        margin-right: 5px;\n}\n.table-card .row-1 .map-button[data-v-337b749a] {\n        padding: 0;\n}\n.table-card .row-1 .map-button a[data-v-337b749a] {\n          background-color: #aaa;\n          width: 30px;\n          height: 30px;\n          line-height: 30px;\n          text-align: center;\n          border-radius: 30px;\n          -webkit-transition: all 250ms;\n          transition: all 250ms;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n          text-decoration: none;\n}\n.table-card .row-1 .map-button a i[data-v-337b749a] {\n            color: #fff;\n}\n.table-card .row-1 .map-button a.disabled[data-v-337b749a] {\n            pointer-events: none;\n            opacity: 0.5;\n            background-color: #bbb;\n}\n.table-card .row-1 .map-button a.selected[data-v-337b749a] {\n            background-color: #26D97A;\n}\n.table-card .flight-info img[data-v-337b749a] {\n      min-width: 30px;\n      max-width: 30px;\n}\n.table-card .row-2[data-v-337b749a] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: unset;\n          -ms-flex-pack: unset;\n              justify-content: unset;\n      gap: 5px;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .row-2 .image img[data-v-337b749a] {\n        min-width: 30px;\n        max-width: 30px;\n}\n.table-card .row-7 strong[data-v-337b749a] {\n      color: #666;\n}\n.table-card .row-7 i[data-v-337b749a] {\n      color: #666;\n      margin: 0 3px;\n}\n.table-card .row-8[data-v-337b749a] {\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.table-card .row-8 .actions[data-v-337b749a] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.table-card .row-8 .actions span[data-v-337b749a] {\n          padding: 8px 20px;\n}\n.table-card .row-8 .actions .notes i[data-v-337b749a] {\n          color: #fff;\n}\n.table-card .service-type[data-v-337b749a] {\n      margin: 0 5px;\n}\n.table-card .clock i[data-v-337b749a] {\n      color: #F25E0D;\n}\n.table-card .pickup i[data-v-337b749a] {\n      color: #d92626;\n}\n.table-card .dropoff i[data-v-337b749a] {\n      color: #26D97A;\n}\n}\n.tool-tip-box[data-v-337b749a] {\n  position: relative;\n}\n.tool-tip-box span[data-v-337b749a] {\n    display: none;\n    position: absolute;\n    top: calc(100% + 3px);\n    left: -55px;\n    line-height: 1.2;\n    font-size: 12px;\n    border: 1px solid #888;\n    background: #fafafa;\n    color: #333;\n    padding: 3px 5px;\n    width: 170px;\n    text-align: center;\n}\n.tool-tip-box i:hover + span[data-v-337b749a], .tool-tip-box img:hover + span[data-v-337b749a] {\n    display: block;\n}\n.optin-icon[data-v-337b749a] {\n  min-width: 18px !important;\n  width: 18px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('drag',{class:{ tr: true, 'has-issues': _vm.isDisabled },attrs:{"tag":"tr","transfer-data":_vm.rsvp,"draggable":!_vm.inMap},on:{"dragstart":function($event){return _vm.dragFn(true)},"dragend":function($event){return _vm.dragFn(false)}}},[_c('div',{staticClass:"dragslot",attrs:{"slot":"image"},slot:"image"},[_vm._v("Reservation "+_vm._s(_vm.rsvp.id))]),_vm._v(" "),_c('td',{staticClass:"check"}),_vm._v(" "),_c('td',{staticClass:"map-button pkg-map"},[_c('a',{class:{ selected: _vm.inMap },attrs:{"href":"javascript:;"},on:{"click":_vm.toggleInMap}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])]),_vm._v(" "),_c('td',{staticClass:"ids"},[_c('a',{staticClass:"rsvp-id",attrs:{"href":("/#/reservation/" + (_vm.rsvp.id)),"target":"_blank"}},[_vm._v(_vm._s(_vm.rsvp.id))]),_vm._v(" "),_c('div',{staticClass:"tool-tip-box"},[(_vm.rsvp.isOptinShared)?_c('img',{staticClass:"optin-icon",attrs:{"src":__webpack_require__(152)}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Opted in to a shared service")])])]),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v(_vm._s(_vm.rsvp.pickupDate))]),_vm._v(" "),_c('td',{staticClass:"locs pickup"},[_vm._v(_vm._s(_vm.getAddress(_vm.rsvp.pickup)))]),_vm._v(" "),_c('td',{staticClass:"locs dropoff"},[_vm._v(_vm._s(_vm.getAddress(_vm.rsvp.dropoff)))]),_vm._v(" "),_c('td',{staticClass:"driver-payment"},[_vm._v("$"+_vm._s(parseFloat(_vm.rsvp.driverPayment.toFixed(2))))]),_vm._v(" "),_c('td',{staticClass:"flight-info"},[(_vm.rsvp.flightInfo)?_c('div',[_c('a',{on:{"click":function($event){return _vm.showFlightInfo(_vm.rsvp)}}},[_vm._v(_vm._s(_vm.rsvp.flightInfo.airline)+" "+_vm._s(_vm.rsvp.flightInfo.flightNo))]),_vm._v(" "),(_vm.rsvp.flightInfo.isDeparture)?_c('img',{attrs:{"src":"/assets/img/departure.png"}}):_c('img',{attrs:{"src":"/assets/img/arrival.png"}})]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"pax"},[_vm._v(_vm._s(_vm.rsvp.pax))]),_vm._v(" "),_c('td',{staticClass:"service"},[_c('span',{staticClass:"service-type",style:({background: _vm.rsvp.service.color})},[_vm._v(_vm._s(_vm.rsvp.service.name))])])]):_c('div',{staticClass:"table-card"},[_c('div',{staticClass:"row-1"},[_c('div',[_c('a',{staticClass:"rsvp-id",attrs:{"href":("/#/reservation/" + (_vm.rsvp.id)),"target":"_blank"}},[_vm._v(_vm._s(_vm.rsvp.id))]),_vm._v(" "),_c('span',{staticClass:"service-type",style:({background: _vm.rsvp.service.color})},[_vm._v(_vm._s(_vm.rsvp.service.name))])]),_vm._v(" "),_c('div',{staticClass:"map-button",on:{"click":_vm.toggleInMap}},[_c('a',{class:{ selected: _vm.inMap },attrs:{"href":"javascript:;"}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])])]),_vm._v(" "),_c('div',[_c('div',[_vm._v("Pickup Time: "+_vm._s(_vm.rsvp.pickupDate))])]),_vm._v(" "),(_vm.rsvp.flightInfo)?_c('div',{staticClass:"flight-info"},[_c('div',[_c('a',{on:{"click":function($event){return _vm.showFlightInfo(_vm.rsvp)}}},[_vm._v(_vm._s(_vm.rsvp.flightInfo.airline)+" "+_vm._s(_vm.rsvp.flightInfo.flightNo))]),_vm._v(" "),(_vm.rsvp.flightInfo.isDeparture)?_c('img',{attrs:{"src":"/assets/img/departure.png"}}):_c('img',{attrs:{"src":"/assets/img/arrival.png"}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row-4"},[_c('div',{staticClass:"pickup"},[_c('i',{staticClass:"fas fa-map-marker-alt icon"}),_vm._v("\n      "+_vm._s(_vm.getAddress(_vm.rsvp.pickup))+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"row-5"},[_c('div',{staticClass:"dropoff"},[_c('i',{staticClass:"fas fa-location-arrow icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getAddress(_vm.rsvp.dropoff)))])])]),_vm._v(" "),_c('div',[_c('div',[_vm._v("Driver Payment: $"+_vm._s(parseFloat(_vm.rsvp.driverPayment.toFixed(2))))])]),_vm._v(" "),(_vm.rsvp.pax)?_c('div',[_vm._v("\n    PAX: "+_vm._s(_vm.rsvp.pax)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"runs-box"},[(_vm.exclusive.loading && !_vm.exclusive.list.length)?_c('div',{staticClass:"table-loader"},[_c('ellipsis-loader'),_vm._v(" "),_c('div',{staticClass:"loader-title"},[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.loadingData.title')))]),_vm._v(" "),_c('div',{staticClass:"loader-text"},[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.loadingData.content')))])],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.exclusive.list.length && !_vm.exclusive.loading),expression:"exclusive.list.length && !exclusive.loading"}],staticClass:"table-scroll"},[_c('table',{staticClass:"runs-table",attrs:{"id":"exclusive-table"}},[(!_vm.isMobile)?_c('thead',[_c('th',{staticClass:"check"}),_vm._v(" "),_c('th',{staticClass:"map"}),_vm._v(" "),_c('th',{staticClass:"ids"},[_vm._v("RSVP ID")]),_vm._v(" "),_c('th',{staticClass:"date"},[_vm._v("Pickup Time")]),_vm._v(" "),_c('th',{staticClass:"locs pickup"},[_vm._v("Pickup")]),_vm._v(" "),_c('th',{staticClass:"locs dropoff"},[_vm._v("Dropoff")]),_vm._v(" "),_c('th',{staticClass:"driver-payment"},[_vm._v("Driver Payment")]),_vm._v(" "),_c('th',{staticClass:"flight-info"},[_vm._v("Flight Info")]),_vm._v(" "),_c('th',{staticClass:"pax"},[_vm._v("PAX")]),_vm._v(" "),_c('th',{staticClass:"service"},[_vm._v("Service Type")])]):_vm._e(),_vm._v(" "),_c('tbody',_vm._l((_vm.exclusive.list),function(rsvp,i){return _c('exclusive-row',{key:i,attrs:{"rsvp":rsvp,"isMobile":_vm.isMobile}})}),1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.exclusive.list.length && !_vm.exclusive.loading),expression:"!exclusive.list.length && !exclusive.loading"}],staticClass:"empty-reservations"},[_c('arrow-up'),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Oops. Looks like we found nothing.")]),_vm._v(" "),_vm._m(0)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_vm._v("\n      We can't find any reservations for that filter."),_c('br'),_vm._v("\n      Please use another one from the form at the top.\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tables"},[_c('div',{staticClass:"list-box"},[_c('runs-list')],1),_vm._v(" "),_c('div',{staticClass:"list-box"},[_c('exclusive-list')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1375);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("64e9d8c6", content, true, {});

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.d-flex[data-v-bae0d180] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter-box[data-v-bae0d180] {\n  position: relative;\n  z-index: 3;\n}\n.search[data-v-bae0d180] {\n  margin: 0 0 0 50px;\n  border-radius: 0;\n  padding: 0 15px;\n  height: 50px;\n  line-height: 50px;\n  border-top: 0;\n  border-bottom: 0;\n  border-color: rgba(0, 0, 0, 0.3);\n  max-width: 350px;\n}\n.search.full[data-v-bae0d180] {\n    max-width: calc(100% - 142px);\n}\n.more-filter[data-v-bae0d180] {\n  display: inline-block;\n  height: 50px;\n  line-height: 50px;\n  border-right: 1px solid rgba(0, 0, 0, 0.3);\n  background: #fff;\n  cursor: pointer;\n  min-width: 160px;\n}\n.more-filter.disabled[data-v-bae0d180] {\n    background: #fafafa;\n    cursor: default;\n}\n.trigger[data-v-bae0d180] {\n  padding: 0 15px;\n}\n.trigger i[data-v-bae0d180] {\n    color: #999;\n    margin-right: 3px;\n}\n.filter-content[data-v-bae0d180] {\n  background: #eaf1f3;\n  position: absolute;\n  top: 51px;\n  left: 0;\n  width: calc(100% - 1px);\n  max-height: calc(100vh - 50px);\n  overflow-y: auto;\n  padding: 20px 15px;\n  border-bottom: 1px solid #aaa;\n}\n.column.padded[data-v-bae0d180] {\n  padding-right: 10px;\n}\nlabel[data-v-bae0d180] {\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 2px;\n  display: block;\n  color: #555;\n}\n.datepicker-box[data-v-bae0d180] {\n  display: inline-block;\n  width: 100%;\n}\n.time-selector[data-v-bae0d180] {\n  padding: 5px 0;\n}\n.time-selector select[data-v-bae0d180] {\n    border-color: #ccc;\n    padding: 3px;\n}\n.error-msg[data-v-bae0d180] {\n  width: 100%;\n  padding: 2px 5px;\n  font-size: 12px;\n  color: #f33a27;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.select-brand[data-v-bae0d180] {\n  float: left;\n  width: 3%;\n  color: #999;\n  cursor: pointer;\n}\n.select-brand i[data-v-bae0d180] {\n    padding: 6px 0;\n    margin-right: 5px;\n}\n.select-brand i.fa-check-square[data-v-bae0d180] {\n      color: #5ec1ac;\n}\n.brand[data-v-bae0d180] {\n  float: left;\n  width: 97%;\n}\n.select-all .brand[data-v-bae0d180] {\n  width: auto;\n}\n.select-all .brand label[data-v-bae0d180] {\n  cursor: pointer;\n  padding: 4px 0;\n  display: inline-block;\n}\n.services[data-v-bae0d180] {\n  clear: both;\n}\n.services .head[data-v-bae0d180] {\n    padding: 5px;\n    background: #5ec1ac;\n    color: #fff;\n    border: 1px solid #3d8374;\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n}\n.services .head i[data-v-bae0d180] {\n      margin-right: 5px;\n}\n.services .body[data-v-bae0d180] {\n    list-style: none;\n    margin: 0;\n    padding: 5px 0;\n    -webkit-column-count: 3;\n    -moz-column-count: 3;\n    column-count: 3;\n    -webkit-column-gap: 5px;\n       -moz-column-gap: 5px;\n            column-gap: 5px;\n    background: #fff;\n    border: 1px solid #3d8374;\n    max-height: 999px;\n}\n.services .body li[data-v-bae0d180] {\n      padding: 3px 10px;\n      font-size: 13px;\n      cursor: pointer;\n}\n.services .body li[data-v-bae0d180]:hover {\n        background: #f3f3f3;\n}\n.services .body li i[data-v-bae0d180] {\n        vertical-align: middle;\n        margin-right: 5px;\n}\n.services .body li i.fa-check-square[data-v-bae0d180] {\n          color: #5ec1ac;\n}\n.slide-down-enter-active[data-v-bae0d180], .slide-down-leave-active[data-v-bae0d180] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-bae0d180], .slide-down-leave-to[data-v-bae0d180] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n@media screen and (max-width: 430px) {\n.filter-box[data-v-bae0d180] {\n    z-index: 101;\n}\n.filter-content[data-v-bae0d180] {\n    padding-bottom: 80px;\n}\n.medium-6[data-v-bae0d180] {\n    width: 50%;\n}\n.time-selector[data-v-bae0d180] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.time-selector select[data-v-bae0d180] {\n      padding: 5px;\n}\n.time-selector .column.padded[data-v-bae0d180] {\n      padding-right: 3px;\n}\n.select-all .brand label[data-v-bae0d180] {\n    padding: 4px 15px;\n}\n.services[data-v-bae0d180] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.services .select-brand[data-v-bae0d180] {\n      width: auto;\n}\n.services .brand[data-v-bae0d180] {\n      width: 100%;\n}\n.services .brand .body[data-v-bae0d180] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        -ms-flex-flow: wrap;\n            flex-flow: wrap;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Runs/TableFilter.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;EACE,mBAAmB;EACnB,WAAW;CACZ;AACD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,iCAAiC;EACjC,iBAAiB;CAClB;AACD;IACI,8BAA8B;CACjC;AACD;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;CAClB;AACD;IACI,oBAAoB;IACpB,gBAAgB;CACnB;AACD;EACE,gBAAgB;CACjB;AACD;IACI,YAAY;IACZ,kBAAkB;CACrB;AACD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,wBAAwB;EACxB,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;CAC/B;AACD;EACE,oBAAoB;CACrB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,YAAY;CACb;AACD;EACE,sBAAsB;EACtB,YAAY;CACb;AACD;EACE,eAAe;CAChB;AACD;IACI,mBAAmB;IACnB,aAAa;CAChB;AACD;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,gBAAgB;CACjB;AACD;IACI,eAAe;IACf,kBAAkB;CACrB;AACD;MACM,eAAe;CACpB;AACD;EACE,YAAY;EACZ,WAAW;CACZ;AACD;EACE,YAAY;CACb;AACD;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;CACvB;AACD;EACE,YAAY;CACb;AACD;IACI,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;CACnB;AACD;MACM,kBAAkB;CACvB;AACD;IACI,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;IAChB,wBAAwB;OACrB,qBAAqB;YAChB,gBAAgB;IACxB,iBAAiB;IACjB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;MACM,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB;CACrB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,uBAAuB;QACvB,kBAAkB;CACzB;AACD;UACU,eAAe;CACxB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ;AACD;AACA;IACI,aAAa;CAChB;AACD;IACI,qBAAqB;CACxB;AACD;IACI,WAAW;CACd;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;MACM,aAAa;CAClB;AACD;MACM,mBAAmB;CACxB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;MACM,YAAY;CACjB;AACD;MACM,YAAY;CACjB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,6BAA6B;QAC7B,8BAA8B;YAC1B,2BAA2B;gBACvB,uBAAuB;QAC/B,oBAAoB;YAChB,gBAAgB;CAC3B;CACA","file":"TableFilter.vue","sourcesContent":["\n.d-flex[data-v-bae0d180] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter-box[data-v-bae0d180] {\n  position: relative;\n  z-index: 3;\n}\n.search[data-v-bae0d180] {\n  margin: 0 0 0 50px;\n  border-radius: 0;\n  padding: 0 15px;\n  height: 50px;\n  line-height: 50px;\n  border-top: 0;\n  border-bottom: 0;\n  border-color: rgba(0, 0, 0, 0.3);\n  max-width: 350px;\n}\n.search.full[data-v-bae0d180] {\n    max-width: calc(100% - 142px);\n}\n.more-filter[data-v-bae0d180] {\n  display: inline-block;\n  height: 50px;\n  line-height: 50px;\n  border-right: 1px solid rgba(0, 0, 0, 0.3);\n  background: #fff;\n  cursor: pointer;\n  min-width: 160px;\n}\n.more-filter.disabled[data-v-bae0d180] {\n    background: #fafafa;\n    cursor: default;\n}\n.trigger[data-v-bae0d180] {\n  padding: 0 15px;\n}\n.trigger i[data-v-bae0d180] {\n    color: #999;\n    margin-right: 3px;\n}\n.filter-content[data-v-bae0d180] {\n  background: #eaf1f3;\n  position: absolute;\n  top: 51px;\n  left: 0;\n  width: calc(100% - 1px);\n  max-height: calc(100vh - 50px);\n  overflow-y: auto;\n  padding: 20px 15px;\n  border-bottom: 1px solid #aaa;\n}\n.column.padded[data-v-bae0d180] {\n  padding-right: 10px;\n}\nlabel[data-v-bae0d180] {\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 2px;\n  display: block;\n  color: #555;\n}\n.datepicker-box[data-v-bae0d180] {\n  display: inline-block;\n  width: 100%;\n}\n.time-selector[data-v-bae0d180] {\n  padding: 5px 0;\n}\n.time-selector select[data-v-bae0d180] {\n    border-color: #ccc;\n    padding: 3px;\n}\n.error-msg[data-v-bae0d180] {\n  width: 100%;\n  padding: 2px 5px;\n  font-size: 12px;\n  color: #f33a27;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.select-brand[data-v-bae0d180] {\n  float: left;\n  width: 3%;\n  color: #999;\n  cursor: pointer;\n}\n.select-brand i[data-v-bae0d180] {\n    padding: 6px 0;\n    margin-right: 5px;\n}\n.select-brand i.fa-check-square[data-v-bae0d180] {\n      color: #5ec1ac;\n}\n.brand[data-v-bae0d180] {\n  float: left;\n  width: 97%;\n}\n.select-all .brand[data-v-bae0d180] {\n  width: auto;\n}\n.select-all .brand label[data-v-bae0d180] {\n  cursor: pointer;\n  padding: 4px 0;\n  display: inline-block;\n}\n.services[data-v-bae0d180] {\n  clear: both;\n}\n.services .head[data-v-bae0d180] {\n    padding: 5px;\n    background: #5ec1ac;\n    color: #fff;\n    border: 1px solid #3d8374;\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n}\n.services .head i[data-v-bae0d180] {\n      margin-right: 5px;\n}\n.services .body[data-v-bae0d180] {\n    list-style: none;\n    margin: 0;\n    padding: 5px 0;\n    -webkit-column-count: 3;\n    -moz-column-count: 3;\n    column-count: 3;\n    -webkit-column-gap: 5px;\n       -moz-column-gap: 5px;\n            column-gap: 5px;\n    background: #fff;\n    border: 1px solid #3d8374;\n    max-height: 999px;\n}\n.services .body li[data-v-bae0d180] {\n      padding: 3px 10px;\n      font-size: 13px;\n      cursor: pointer;\n}\n.services .body li[data-v-bae0d180]:hover {\n        background: #f3f3f3;\n}\n.services .body li i[data-v-bae0d180] {\n        vertical-align: middle;\n        margin-right: 5px;\n}\n.services .body li i.fa-check-square[data-v-bae0d180] {\n          color: #5ec1ac;\n}\n.slide-down-enter-active[data-v-bae0d180], .slide-down-leave-active[data-v-bae0d180] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-bae0d180], .slide-down-leave-to[data-v-bae0d180] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n@media screen and (max-width: 430px) {\n.filter-box[data-v-bae0d180] {\n    z-index: 101;\n}\n.filter-content[data-v-bae0d180] {\n    padding-bottom: 80px;\n}\n.medium-6[data-v-bae0d180] {\n    width: 50%;\n}\n.time-selector[data-v-bae0d180] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.time-selector select[data-v-bae0d180] {\n      padding: 5px;\n}\n.time-selector .column.padded[data-v-bae0d180] {\n      padding-right: 3px;\n}\n.select-all .brand label[data-v-bae0d180] {\n    padding: 4px 15px;\n}\n.services[data-v-bae0d180] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.services .select-brand[data-v-bae0d180] {\n      width: auto;\n}\n.services .brand[data-v-bae0d180] {\n      width: 100%;\n}\n.services .brand .body[data-v-bae0d180] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        -ms-flex-flow: wrap;\n            flex-flow: wrap;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-box"},[_c('div',{staticClass:"d-flex"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchKey),expression:"searchKey"}],class:['search', {'full':_vm.route === 'Runs'}],attrs:{"type":"text","placeholder":"Type and hit enter to search.","disabled":_vm.exclusive.loading || _vm.runs.loading},domProps:{"value":(_vm.searchKey)},on:{"keypress":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.searchKey=$event.target.value}}}),_vm._v(" "),_c('div',{class:['more-filter', {disabled:_vm.brands.loading || _vm.services.serviceLoading}]},[_c('div',{staticClass:"trigger",attrs:{"disabled":true},on:{"click":_vm.showFilter}},[_c('i',{staticClass:"fas fa-filter"}),_vm._v("\n        Filter\n      ")])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"filter-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column col-field medium-10 medium-offset-1"},[_c('div',{staticClass:"column medium-12"},[_c('label',[_vm._v("Date Range")])]),_vm._v(" "),_c('div',{class:['column padded', _vm.shrink ? 'medium-12' : 'medium-6']},[_c('div',{staticClass:"datepicker-box"},[_c('datepicker',{class:['datepicker inline', {'has-error':_vm.error.since}],attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.exclusive.loading || _vm.runs.loading,"input-class":{'datepicker-empty':_vm.error.since},"placeholder":_vm.$t('transactions.filter.from')},on:{"input":function($event){return _vm.changeDate('since')}},model:{value:(_vm.since.date),callback:function ($$v) {_vm.$set(_vm.since, "date", $$v)},expression:"since.date"}})],1),_vm._v(" "),_c('div',{staticClass:"row time-selector"},[_c('div',{staticClass:"column padded medium-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.since.hour),expression:"since.hour"}],class:{'has-error':_vm.error.since},attrs:{"disabled":_vm.exclusive.loading || _vm.runs.loading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.since, "hour", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeTime('since')}]}},_vm._l((_vm.maxHour),function(n){return _c('option',{key:n,domProps:{"value":_vm.leadingZero(n)}},[_vm._v(_vm._s(_vm.leadingZero(n)))])}),0)]),_vm._v(" "),_c('div',{staticClass:"column padded medium-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.since.minute),expression:"since.minute"}],class:{'has-error':_vm.error.since},attrs:{"disabled":_vm.exclusive.loading || _vm.runs.loading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.since, "minute", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeTime('since')}]}},_vm._l((60),function(n){return _c('option',{key:n,domProps:{"value":_vm.leadingZero(n - 1)}},[_vm._v(_vm._s(_vm.leadingZero(n - 1)))])}),0)]),_vm._v(" "),_c('div',{staticClass:"column medium-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.since.amPm),expression:"since.amPm"}],class:{'has-error':_vm.error.since},attrs:{"disabled":_vm.exclusive.loading || _vm.runs.loading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.since, "amPm", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeTime('since')}]}},[_c('option',{attrs:{"value":"AM"}},[_vm._v("AM")]),_vm._v(" "),_c('option',{attrs:{"value":"PM"}},[_vm._v("PM")])])])])]),_vm._v(" "),_c('div',{class:['column padded', _vm.shrink ? 'medium-12' : 'medium-6']},[_c('div',{staticClass:"datepicker-box"},[_c('datepicker',{staticClass:"datepicker inline",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.exclusive.loading || _vm.runs.loading,"input-class":{'datepicker-empty':_vm.error.until},"placeholder":_vm.$t('transactions.filter.to')},on:{"input":function($event){return _vm.changeDate('until')}},model:{value:(_vm.until.date),callback:function ($$v) {_vm.$set(_vm.until, "date", $$v)},expression:"until.date"}})],1),_vm._v(" "),_c('div',{staticClass:"row time-selector"},[_c('div',{staticClass:"column padded medium-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.until.hour),expression:"until.hour"}],class:{'has-error':_vm.error.until},attrs:{"disabled":_vm.exclusive.loading || _vm.runs.loading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.until, "hour", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeTime('until')}]}},_vm._l((_vm.maxHour),function(n){return _c('option',{key:n,domProps:{"value":_vm.leadingZero(n)}},[_vm._v(_vm._s(_vm.leadingZero(n)))])}),0)]),_vm._v(" "),_c('div',{staticClass:"column padded medium-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.until.minute),expression:"until.minute"}],class:{'has-error':_vm.error.until},attrs:{"disabled":_vm.exclusive.loading || _vm.runs.loading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.until, "minute", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeTime('until')}]}},_vm._l((60),function(n){return _c('option',{key:n,domProps:{"value":_vm.leadingZero(n - 1)}},[_vm._v(_vm._s(_vm.leadingZero(n - 1)))])}),0)]),_vm._v(" "),_c('div',{staticClass:"column medium-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.until.amPm),expression:"until.amPm"}],class:{'has-error':_vm.error.until},attrs:{"disabled":_vm.exclusive.loading || _vm.runs.loading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.until, "amPm", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeTime('until')}]}},[_c('option',{attrs:{"value":"AM"}},[_vm._v("AM")]),_vm._v(" "),_c('option',{attrs:{"value":"PM"}},[_vm._v("PM")])])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.since),expression:"!!error.since"}],staticClass:"row",staticStyle:{"margin-bottom":"15px"}},[_c('div',{staticClass:"column col-field medium-10 medium-offset-1"},[_c('div',{staticClass:"error-msg"},[_c('b',[_vm._v(_vm._s(_vm.error.since))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column col-field medium-12"},[_c('div',{staticClass:"column medium-12"},[_c('label',[_vm._v("Service Type")])]),_vm._v(" "),_c('div',{staticClass:"select-all",on:{"click":function($event){return _vm.selectAllBrands()}}},[_c('div',{staticClass:"select-brand"},[_c('i',{class:['fa-lg', _vm.selectedAllServices ? 'fa-check-square fas' : 'far fa-square' ]})]),_vm._v(" "),_c('div',{staticClass:"brand"},[_c('label',[_vm._v("Select All Brands")])])]),_vm._v(" "),_vm._l((_vm.brands.list),function(brand){return (_vm.serviceList(brand.id).length)?_c('div',{key:brand.id,staticClass:"services"},[_c('div',{staticClass:"select-brand",on:{"click":function($event){return _vm.selectBrand(brand.id)}}},[_c('i',{class:['fa-lg', _vm.selectedBrand.indexOf(brand.id) > -1 ? 'fa-check-square fas' : 'far fa-square' ]})]),_vm._v(" "),_c('div',{staticClass:"brand"},[_c('div',{staticClass:"head",on:{"click":function($event){return _vm.toggleBrand(brand.id)}}},[(_vm.openBrand.indexOf(brand.id) > -1)?_c('i',{staticClass:"fas fa-angle-down"}):_c('i',{staticClass:"fas fa-angle-up"}),_vm._v("\n                "+_vm._s(brand.name)+"\n              ")]),_vm._v(" "),_c('transition',{attrs:{"name":"height"}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.openBrand.indexOf(brand.id) > -1),expression:"openBrand.indexOf(brand.id) > -1"}],staticClass:"body"},_vm._l((_vm.serviceList(brand.id)),function(service){return _c('li',{key:service.id,on:{"click":function($event){return _vm.toggleService(service.id, brand.id)}}},[_c('i',{class:['fa-lg', _vm.selectedService.indexOf(service.id) > -1 ? 'fa-check-square fas' : 'far fa-square' ]}),_vm._v("\n                    "+_vm._s(service.label)+"\n                  ")])}),0)])],1)]):_vm._e()})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.service),expression:"!!error.service"}],staticClass:"row"},[_c('div',{staticClass:"column col-field medium-10 medium-offset-1"},[_c('div',{staticClass:"error-msg"},[_c('b',[_vm._v(_vm._s(_vm.error.service))])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"30px"}},[_c('div',{class:['column col-btn', 'medium-10 medium-offset-1']},[(!_vm.shrink)?_c('div',{class:['column padded', _vm.shrink ? 'medium-12' : 'medium-6']},[_c('div',{staticClass:"button cta warning block small",on:{"click":function($event){_vm.show = false}}},[_vm._v("Close")])]):_vm._e(),_vm._v(" "),_c('div',{class:['column padded', _vm.shrink ? 'medium-12' : 'medium-6']},[_c('div',{class:['button cta success block small', {disabled: _vm.exclusive.loading || _vm.runs.loading}],on:{"click":_vm.loadList}},[_vm._v("Apply Filter")])]),_vm._v(" "),(_vm.shrink)?_c('div',{class:['column padded', _vm.shrink ? 'medium-12' : 'medium-6']},[_c('div',{staticClass:"button cta warning block small",on:{"click":function($event){_vm.show = false}}},[_vm._v("Close")])]):_vm._e()])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1378);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("03d0e55d", content, true, {});

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.runs-map[data-v-468eb832] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.runs-map .routing-map[data-v-468eb832] {\n    display: none;\n}\n.map-here[data-v-468eb832] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n.map-loader[data-v-468eb832] {\n  position: absolute;\n  left: calc(50% - 125px);\n  top: 20px;\n  z-index: 2;\n  background-color: #F25E0D;\n  border-radius: 3px;\n  padding: 5px 10px;\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  opacity: 1;\n  width: 250px;\n  text-align: center;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n.map-loader.hide[data-v-468eb832] {\n    opacity: 0;\n    top: -50px;\n}\n.search-status[data-v-468eb832] {\n  position: absolute;\n  top: 20px;\n  left: calc(50% - 175px);\n  width: 350px;\n  background-color: #26D97A;\n  color: #fff;\n  text-align: center;\n  font-size: 14px;\n  padding: 5px 10px;\n  font-weight: 700;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.5);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.search-status.hide[data-v-468eb832] {\n    top: -50px;\n}\n.filter-toggle[data-v-468eb832] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 5;\n  background-color: #F4F8F9;\n  color: #555;\n  padding: 9px 10px 8px;\n  border-bottom-right-radius: 3px;\n  -webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.filter-toggle i[data-v-468eb832] {\n    line-height: inherit;\n}\n.filter-toggle.open[data-v-468eb832] {\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0);\n    background-color: #0D79F2;\n    color: #fff;\n}\n.filter-toggle.hide[data-v-468eb832] {\n    top: -50px;\n}\n.driver-filters[data-v-468eb832] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 350px;\n  height: auto;\n  z-index: 4;\n  background-color: #F4F8F9;\n  border-bottom-right-radius: 3px;\n  overflow: hidden;\n  -webkit-box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.35);\n          box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.35);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.driver-filters.hide[data-v-468eb832] {\n    top: -200%;\n}\n.driver-filters .message[data-v-468eb832] {\n    text-align: center;\n    font-size: 14px;\n    font-weight: 700;\n    padding: 14px;\n    background-color: #0D79F2;\n    color: #fff;\n}\n.driver-filters .radius-input[data-v-468eb832] {\n    padding: 10px 15px;\n}\n.driver-filters .radius-input > *[data-v-468eb832] {\n      vertical-align: middle;\n}\n.driver-filters .radius-input label[data-v-468eb832] {\n      font-size: 12px;\n      color: #8DA0A9;\n      font-weight: 700;\n}\n.driver-filters .radius-input input[data-v-468eb832] {\n      display: inline-block;\n      width: 80px;\n      padding: 10px;\n      margin-top: 0;\n      margin-right: 8px;\n      font-size: 14px;\n      line-height: 1;\n      border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.driver-filters .service-types[data-v-468eb832] {\n    padding: 0px 15px;\n}\n.driver-filters .service-types .row[data-v-468eb832] {\n      padding-left: 25px;\n}\n.driver-filters .service-types .title[data-v-468eb832] {\n      font-size: 12px;\n      color: #8DA0A9;\n      font-weight: 700;\n}\n.driver-filters .service-types label > *[data-v-468eb832] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.driver-filters .service-types label input[data-v-468eb832] {\n      width: auto;\n      margin-top: 0;\n}\n.driver-filters .service-types label span[data-v-468eb832] {\n      font-weight: 700;\n      color: #777;\n      margin-left: 5px;\n}\n.driver-filters .divider[data-v-468eb832] {\n    width: 80%;\n    border-top: 1px solid rgba(0, 0, 0, 0.2);\n    margin: 15px auto;\n}\n.driver-filters .button-wrapper[data-v-468eb832] {\n    padding: 0 15px 15px;\n}\n.driver-filters .filter-note[data-v-468eb832] {\n    padding: 10px;\n    font-size: 14px;\n    color: #93881e;\n    background: #fff9c5;\n    border: 1px solid #ccbd2f;\n    border-radius: 4px;\n    margin: 10px 20px 0;\n    -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n}\n.cover[data-v-468eb832] {\n  position: absolute;\n  top: -500px;\n  left: 0;\n  width: 100%;\n  background-color: rgba(13, 121, 242, 0.8);\n  z-index: 5;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.cover.show[data-v-468eb832] {\n    top: 0;\n}\n.cover .cover-container[data-v-468eb832] {\n    display: table;\n    width: 100%;\n    height: 100%;\n}\n.cover .cover-content[data-v-468eb832] {\n    padding: 15px;\n    font-weight: 700;\n    color: #FFF;\n    display: table-cell;\n    vertical-align: middle;\n    text-align: center;\n}\n.cover .cover-content .content[data-v-468eb832] {\n      margin-top: 10px;\n}\n.lr-modal[data-v-468eb832] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-468eb832] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-468eb832] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  min-width: 300px;\n  max-width: 500px;\n}\n.lr-alert-msg[data-v-468eb832] {\n  margin-bottom: 20px;\n  color: #45505b;\n}\n.show-reasons-btn[data-v-468eb832] {\n  margin-top: 12px;\n  font-size: 14px;\n  color: #838689;\n  text-decoration: underline;\n  cursor: pointer;\n}\n.reasons-modal.hide[data-v-468eb832] {\n  display: none;\n}\n.reasons-modal .lr-box[data-v-468eb832] {\n  width: 600px;\n  max-width: 600px;\n  max-height: calc(100vh - 40px);\n  overflow: auto;\n}\n.reason-table[data-v-468eb832] {\n  width: 100%;\n  max-width: 600px;\n  border: 1px solid #ccc;\n  margin-bottom: 20px;\n}\n.reason-table th[data-v-468eb832] {\n    background: #f3f3f3;\n    padding: 4px;\n    border-bottom: 1px solid #ccc;\n}\n.reason-table .driver[data-v-468eb832] {\n    text-align: left;\n}\n.reason-table .reason[data-v-468eb832] {\n    text-align: right;\n}\n.reason-table tr td[data-v-468eb832] {\n    border-bottom: 1px solid #ccc;\n    font-size: 14px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Runs/Map.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;CACd;AACD;IACI,cAAc;CACjB;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,WAAW;CACZ;AACD;EACE,mBAAmB;EACnB,wBAAwB;EACxB,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,iDAAiD;UACzC,yCAAyC;CAClD;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,wBAAwB;EACxB,aAAa;EACb,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kDAAkD;UAC1C,0CAA0C;EAClD,4CAA4C;EAC5C,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;EACxB,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,WAAW;CACd;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,0BAA0B;EAC1B,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;EAChC,mDAAmD;UAC3C,2CAA2C;EACnD,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,qBAAqB;CACxB;AACD;IACI,+CAA+C;YACvC,uCAAuC;IAC/C,0BAA0B;IAC1B,YAAY;CACf;AACD;IACI,WAAW;CACd;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,aAAa;EACb,WAAW;EACX,0BAA0B;EAC1B,gCAAgC;EAChC,iBAAiB;EACjB,qDAAqD;UAC7C,6CAA6C;EACrD,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,WAAW;CACd;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,0BAA0B;IAC1B,YAAY;CACf;AACD;IACI,mBAAmB;CACtB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,gBAAgB;MAChB,eAAe;MACf,iBAAiB;CACtB;AACD;MACM,sBAAsB;MACtB,YAAY;MACZ,cAAc;MACd,cAAc;MACd,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,qCAAqC;CAC1C;AACD;IACI,kBAAkB;CACrB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,gBAAgB;MAChB,eAAe;MACf,iBAAiB;CACtB;AACD;MACM,sBAAsB;MACtB,uBAAuB;CAC5B;AACD;MACM,YAAY;MACZ,cAAc;CACnB;AACD;MACM,iBAAiB;MACjB,YAAY;MACZ,iBAAiB;CACtB;AACD;IACI,WAAW;IACX,yCAAyC;IACzC,kBAAkB;CACrB;AACD;IACI,qBAAqB;CACxB;AACD;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,0BAA0B;IAC1B,mBAAmB;IACnB,oBAAoB;IACpB,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,0CAA0C;EAC1C,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;CACV;AACD;IACI,eAAe;IACf,YAAY;IACZ,aAAa;CAChB;AACD;IACI,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;CACtB;AACD;MACM,iBAAiB;CACtB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oCAAoC;MAChC,iCAAiC;UAC7B,mCAAmC;EAC3C,qCAAqC;MACjC,kCAAkC;UAC9B,+BAA+B;EACvC,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;EACnD,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;CAClB;AACD;EACE,oBAAoB;EACpB,eAAe;CAChB;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,aAAa;EACb,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;CAChB;AACD;EACE,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;CACrB;AACD;IACI,oBAAoB;IACpB,aAAa;IACb,8BAA8B;CACjC;AACD;IACI,iBAAiB;CACpB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,8BAA8B;IAC9B,gBAAgB;CACnB","file":"Map.vue","sourcesContent":["\n.runs-map[data-v-468eb832] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.runs-map .routing-map[data-v-468eb832] {\n    display: none;\n}\n.map-here[data-v-468eb832] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n.map-loader[data-v-468eb832] {\n  position: absolute;\n  left: calc(50% - 125px);\n  top: 20px;\n  z-index: 2;\n  background-color: #F25E0D;\n  border-radius: 3px;\n  padding: 5px 10px;\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  opacity: 1;\n  width: 250px;\n  text-align: center;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n.map-loader.hide[data-v-468eb832] {\n    opacity: 0;\n    top: -50px;\n}\n.search-status[data-v-468eb832] {\n  position: absolute;\n  top: 20px;\n  left: calc(50% - 175px);\n  width: 350px;\n  background-color: #26D97A;\n  color: #fff;\n  text-align: center;\n  font-size: 14px;\n  padding: 5px 10px;\n  font-weight: 700;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.5);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.search-status.hide[data-v-468eb832] {\n    top: -50px;\n}\n.filter-toggle[data-v-468eb832] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 5;\n  background-color: #F4F8F9;\n  color: #555;\n  padding: 9px 10px 8px;\n  border-bottom-right-radius: 3px;\n  -webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.filter-toggle i[data-v-468eb832] {\n    line-height: inherit;\n}\n.filter-toggle.open[data-v-468eb832] {\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0);\n    background-color: #0D79F2;\n    color: #fff;\n}\n.filter-toggle.hide[data-v-468eb832] {\n    top: -50px;\n}\n.driver-filters[data-v-468eb832] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 350px;\n  height: auto;\n  z-index: 4;\n  background-color: #F4F8F9;\n  border-bottom-right-radius: 3px;\n  overflow: hidden;\n  -webkit-box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.35);\n          box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.35);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.driver-filters.hide[data-v-468eb832] {\n    top: -200%;\n}\n.driver-filters .message[data-v-468eb832] {\n    text-align: center;\n    font-size: 14px;\n    font-weight: 700;\n    padding: 14px;\n    background-color: #0D79F2;\n    color: #fff;\n}\n.driver-filters .radius-input[data-v-468eb832] {\n    padding: 10px 15px;\n}\n.driver-filters .radius-input > *[data-v-468eb832] {\n      vertical-align: middle;\n}\n.driver-filters .radius-input label[data-v-468eb832] {\n      font-size: 12px;\n      color: #8DA0A9;\n      font-weight: 700;\n}\n.driver-filters .radius-input input[data-v-468eb832] {\n      display: inline-block;\n      width: 80px;\n      padding: 10px;\n      margin-top: 0;\n      margin-right: 8px;\n      font-size: 14px;\n      line-height: 1;\n      border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.driver-filters .service-types[data-v-468eb832] {\n    padding: 0px 15px;\n}\n.driver-filters .service-types .row[data-v-468eb832] {\n      padding-left: 25px;\n}\n.driver-filters .service-types .title[data-v-468eb832] {\n      font-size: 12px;\n      color: #8DA0A9;\n      font-weight: 700;\n}\n.driver-filters .service-types label > *[data-v-468eb832] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.driver-filters .service-types label input[data-v-468eb832] {\n      width: auto;\n      margin-top: 0;\n}\n.driver-filters .service-types label span[data-v-468eb832] {\n      font-weight: 700;\n      color: #777;\n      margin-left: 5px;\n}\n.driver-filters .divider[data-v-468eb832] {\n    width: 80%;\n    border-top: 1px solid rgba(0, 0, 0, 0.2);\n    margin: 15px auto;\n}\n.driver-filters .button-wrapper[data-v-468eb832] {\n    padding: 0 15px 15px;\n}\n.driver-filters .filter-note[data-v-468eb832] {\n    padding: 10px;\n    font-size: 14px;\n    color: #93881e;\n    background: #fff9c5;\n    border: 1px solid #ccbd2f;\n    border-radius: 4px;\n    margin: 10px 20px 0;\n    -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n}\n.cover[data-v-468eb832] {\n  position: absolute;\n  top: -500px;\n  left: 0;\n  width: 100%;\n  background-color: rgba(13, 121, 242, 0.8);\n  z-index: 5;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.cover.show[data-v-468eb832] {\n    top: 0;\n}\n.cover .cover-container[data-v-468eb832] {\n    display: table;\n    width: 100%;\n    height: 100%;\n}\n.cover .cover-content[data-v-468eb832] {\n    padding: 15px;\n    font-weight: 700;\n    color: #FFF;\n    display: table-cell;\n    vertical-align: middle;\n    text-align: center;\n}\n.cover .cover-content .content[data-v-468eb832] {\n      margin-top: 10px;\n}\n.lr-modal[data-v-468eb832] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-468eb832] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-468eb832] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  min-width: 300px;\n  max-width: 500px;\n}\n.lr-alert-msg[data-v-468eb832] {\n  margin-bottom: 20px;\n  color: #45505b;\n}\n.show-reasons-btn[data-v-468eb832] {\n  margin-top: 12px;\n  font-size: 14px;\n  color: #838689;\n  text-decoration: underline;\n  cursor: pointer;\n}\n.reasons-modal.hide[data-v-468eb832] {\n  display: none;\n}\n.reasons-modal .lr-box[data-v-468eb832] {\n  width: 600px;\n  max-width: 600px;\n  max-height: calc(100vh - 40px);\n  overflow: auto;\n}\n.reason-table[data-v-468eb832] {\n  width: 100%;\n  max-width: 600px;\n  border: 1px solid #ccc;\n  margin-bottom: 20px;\n}\n.reason-table th[data-v-468eb832] {\n    background: #f3f3f3;\n    padding: 4px;\n    border-bottom: 1px solid #ccc;\n}\n.reason-table .driver[data-v-468eb832] {\n    text-align: left;\n}\n.reason-table .reason[data-v-468eb832] {\n    text-align: right;\n}\n.reason-table tr td[data-v-468eb832] {\n    border-bottom: 1px solid #ccc;\n    font-size: 14px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  drawPoiMarker: function drawPoiMarker(map, id, position, cssClass) {
    var elem = '<div class="poi-marker {CSS_CLASS}"></div>';
    elem = elem.replace('{CSS_CLASS}', cssClass);
    var icon = new window.H.map.DomIcon(elem);
    var pin = new window.H.map.DomMarker(position, { icon: icon, zIndex: 1 });
    pin.id = id;
    map.addObject(pin);
  },
  drawCar: function drawCar(map, driver) {
    var elem = '<div class="car-marker" style="background-position: -' + driver.heading * 45 + 'px"></div>';
    var icon = new window.H.map.DomIcon(elem);
    var pin = new window.H.map.DomMarker(driver, { icon: icon, zIndex: 2 });
    pin.id = 'car_marker_' + driver.provContactId;
    map.addObject(pin);
  },
  removeCarMarkers: function removeCarMarkers(map) {
    if (map === null) {
      return;
    }

    map.getObjects().forEach(function (object) {
      if (object.id.indexOf('car_marker_') >= 0) {
        map.removeObject(object);
      }
    });
  },
  drawPickupLabel: function drawPickupLabel(map, id, driverEta, pickup, position) {
    var elem = '<div class="H_bubbles pickup-info info {CSS_POSITION}">' + '<img src="https://s3-us-west-2.amazonaws.com/mobile-consumer-app/maps/pins/marker-eta.png" />' + '<div class="left"><span class="value">{ETA_VALUE}</span><span class="label">{ETA_LABEL}</span></div>' + '<div class="right"><span class="label">PICK-UP</span><span class="value">{PICKUP_TITLE}</span></div>' + '</div>';

    var eta = Math.round(driverEta / 60);
    if (eta <= 0) {
      eta = 1;
    }
    var etaLabel = 'mins';
    if (eta <= 1) {
      etaLabel = 'min';
    }
    elem = elem.replace('{CSS_POSITION}', position);
    elem = elem.replace('{ETA_VALUE}', eta);
    elem = elem.replace('{ETA_LABEL}', etaLabel);
    elem = elem.replace('{PICKUP_TITLE}', pickup.title);

    var icon = new window.H.map.DomIcon(elem);
    var pin = new window.H.map.DomMarker(pickup, { icon: icon, zIndex: 3 });
    pin.id = id;
    map.addObject(pin);
  },
  drawDropoffLabel: function drawDropoffLabel(map, id, eta, dropoff, position) {
    var elem = '<div class="H_bubbles dropoff-info info {CSS_POSITION}">' + '<img src="https://s3-us-west-2.amazonaws.com/mobile-consumer-app/maps/pins/marker-arrival.png" />' + '<div class="left"><span class="value">{ETA_VALUE}</span><span class="label">{ETA_LABEL}</span></div>' + '<div class="right"><span class="label">DROP-OFF</span><span class="value">{PICKUP_TITLE}</span></div>' + '</div>';
    elem = elem.replace('{CSS_POSITION}', position);
    elem = elem.replace('{ETA_VALUE}', eta.format('hh:mm'));
    elem = elem.replace('{ETA_LABEL}', 'ETA/' + eta.format('A'));
    elem = elem.replace('{PICKUP_TITLE}', dropoff.title);
    var icon = new window.H.map.DomIcon(elem);
    var pin = new window.H.map.DomMarker(dropoff, { icon: icon, zIndex: 3 });
    pin.id = id;
    map.addObject(pin);
  },
  drawTerminalMarkers: function drawTerminalMarkers(map, id, pins) {
    var elem = '<div class="poi-marker terminal"></div>';
    var icon = new window.H.map.DomIcon(elem);
    var items = [];
    for (var i = 0; i < pins.length; i++) {
      var position = pins[i];
      var pin = new window.H.map.DomMarker({ lat: position.lat, lng: position.lng }, { icon: icon, zIndex: 1 });
      items.push(pin);
    }
    var group = new window.H.map.Group();
    group.addObjects(items);
    group.id = id;
    map.addObject(group);
  },
  drawPickupArea: function drawPickupArea(map, id, points) {
    var lineString = new window.H.geo.LineString();
    points.forEach(function (point) {
      lineString.pushLatLngAlt(point.lat, point.lng);
    });

    var polyline = new window.H.map.Polygon(lineString, {
      style: {
        lineWidth: 1,
        strokeColor: 'rgba(142,185,56,1)',
        fillColor: 'rgba(142,185,56,0.5)'
      }
    });
    polyline.id = id;
    map.addObject(polyline);
  },
  drawLaxItTerminals: function drawLaxItTerminals(map, id, terminals) {
    if (map === null) {
      return;
    }
    var items = [];
    for (var i = 0; i < terminals.length; i++) {
      var terminal = terminals[i];
      var elem = '<div class="terminal-marker">' + terminal.label + '</div>';
      var icon = new window.H.map.DomIcon(elem);
      var pin = new window.H.map.DomMarker(terminal.coords, { icon: icon, zIndex: 1 });
      items.push(pin);
    }
    var group = new window.H.map.Group();
    group.addObjects(items);
    group.id = id;
    map.addObject(group);
  }
});

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  resize: function resize(map, timeout) {
    if (map === null) {
      return;
    }
    setTimeout(function () {
      map.getViewPort().resize();
    }, timeout);
  },
  clearMap: function clearMap(map) {
    if (map === null) {
      return;
    }

    map.getObjects().forEach(function (object) {
      map.removeObject(object);
    });
  },
  setBounds: function setBounds(map, points, adjustBuffer) {
    if (map === null) {
      return;
    }
    var maxLat = -90;
    var minLat = 90;
    var maxLng = -180;
    var minLng = -90;

    for (var i = 0; i < points.length; i++) {
      var coords = points[i];
      if (coords.lat > maxLat) {
        maxLat = coords.lat;
      }
      if (coords.lat < minLat) {
        minLat = coords.lat;
      }
      if (coords.lng > maxLng) {
        maxLng = coords.lng;
      }
      if (coords.lng < minLng) {
        minLng = coords.lng;
      }
    }

    var buffer = 0.4;
    if (adjustBuffer) {
      buffer = adjustBuffer;
    }
    var latBuffer = (maxLat - minLat) * buffer;
    var lngBuffer = (maxLng - minLng) * buffer;

    var group = new window.H.map.Group();
    group.addObjects([new window.H.map.Marker({ lat: minLat - latBuffer, lng: maxLng + lngBuffer }), new window.H.map.Marker({ lat: maxLat + latBuffer, lng: minLng - lngBuffer })]);

    var box = group.getBoundingBox();
    map.getViewModel().setLookAtData({ bounds: box }, true);
  },
  removeObject: function removeObject(map, id) {
    if (map === null) {
      return;
    }

    map.getObjects().forEach(function (object) {
      if (object.id === id) {
        map.removeObject(object);
        return;
      }
    });
  },
  adjustStyle: function adjustStyle(map) {
    var provider = map.getBaseLayer().getProvider();
    var style = provider.getStyle();
    console.log('J', style);
  }
});

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"runs-map"},[_c('div',{staticClass:"map-here",attrs:{"id":"RunMapHere"}}),_vm._v(" "),_c('div',{class:['map-loader', {hide: !_vm.mapLoader.show}]},[_vm._v(_vm._s(_vm.mapLoader.label))]),_vm._v(" "),_c('a',{class:['filter-toggle', {open: _vm.driverFilter.show, hide: !_vm.only1Run(_vm.items) /*!driverFilter.showToggle*/}],attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.driverFilter.show = !_vm.driverFilter.show}}},[_c('i',{class:{
      'far fa-times-circle': _vm.driverFilter.show,
      'fas fa-sliders-h': !_vm.driverFilter.show,
      'fa-fw fa-lg': true
    }})]),_vm._v(" "),_c('div',{class:['driver-filters', {hide:!_vm.driverFilter.show || !_vm.items.length}]},[_c('div',{class:['cover', {show: _vm.driverFilter.isLoading || _vm.driverFilter.serviceLoading}]},[_c('div',{staticClass:"cover-container"},[_c('div',{staticClass:"cover-content"},[_c('pulse-loader'),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.$t('dispatch.map.filterControls.labelLoading')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("Use the form below to modify restrictions")]),_vm._v(" "),_c('form',{staticClass:"extend-input",on:{"submit":function($event){$event.preventDefault();return _vm.driverFilterSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"radius-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.driverFilter.miles),expression:"driverFilter.miles"}],attrs:{"type":"number"},domProps:{"value":(_vm.driverFilter.miles)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.driverFilter, "miles", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('dispatch.map.filterControls.labelRadius')))])]),_vm._v(" "),(!_vm.isQualifiedDriver)?_c('div',{staticClass:"service-types"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('dispatch.map.filterControls.labelServices')))]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.driverFilter.services),function(service){return _c('div',{key:service.id,staticClass:"small-12 columns"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.driverFilter.serviceTypes),expression:"driverFilter.serviceTypes"}],attrs:{"type":"checkbox"},domProps:{"value":service.id,"checked":Array.isArray(_vm.driverFilter.serviceTypes)?_vm._i(_vm.driverFilter.serviceTypes,service.id)>-1:(_vm.driverFilter.serviceTypes)},on:{"change":function($event){var $$a=_vm.driverFilter.serviceTypes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=service.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.driverFilter, "serviceTypes", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.driverFilter, "serviceTypes", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.driverFilter, "serviceTypes", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(service.name))])])])}),0)]):_c('div',{staticClass:"service-types"},[_c('div',{staticClass:"title"},[_vm._v("Qualification Criteria:")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qualifiedFilter.seatCapacity),expression:"qualifiedFilter.seatCapacity"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.qualifiedFilter.seatCapacity)?_vm._i(_vm.qualifiedFilter.seatCapacity,null)>-1:(_vm.qualifiedFilter.seatCapacity)},on:{"change":function($event){var $$a=_vm.qualifiedFilter.seatCapacity,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.qualifiedFilter, "seatCapacity", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.qualifiedFilter, "seatCapacity", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.qualifiedFilter, "seatCapacity", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Seat Capacity Restriction")])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qualifiedFilter.serviceTypes),expression:"qualifiedFilter.serviceTypes"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.qualifiedFilter.serviceTypes)?_vm._i(_vm.qualifiedFilter.serviceTypes,null)>-1:(_vm.qualifiedFilter.serviceTypes)},on:{"change":function($event){var $$a=_vm.qualifiedFilter.serviceTypes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.qualifiedFilter, "serviceTypes", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.qualifiedFilter, "serviceTypes", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.qualifiedFilter, "serviceTypes", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Service Types Restriction")])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qualifiedFilter.adaWC),expression:"qualifiedFilter.adaWC"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.qualifiedFilter.adaWC)?_vm._i(_vm.qualifiedFilter.adaWC,null)>-1:(_vm.qualifiedFilter.adaWC)},on:{"change":function($event){var $$a=_vm.qualifiedFilter.adaWC,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.qualifiedFilter, "adaWC", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.qualifiedFilter, "adaWC", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.qualifiedFilter, "adaWC", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("ADA: Wheelchair Restriction")])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qualifiedFilter.adaSD),expression:"qualifiedFilter.adaSD"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.qualifiedFilter.adaSD)?_vm._i(_vm.qualifiedFilter.adaSD,null)>-1:(_vm.qualifiedFilter.adaSD)},on:{"change":function($event){var $$a=_vm.qualifiedFilter.adaSD,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.qualifiedFilter, "adaSD", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.qualifiedFilter, "adaSD", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.qualifiedFilter, "adaSD", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("ADA: Service Dog Restriction")])])]),_vm._v(" "),(false)?_c('div',{staticClass:"small-12 columns"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qualifiedFilter.fullTNC),expression:"qualifiedFilter.fullTNC"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.qualifiedFilter.fullTNC)?_vm._i(_vm.qualifiedFilter.fullTNC,null)>-1:(_vm.qualifiedFilter.fullTNC)},on:{"change":function($event){var $$a=_vm.qualifiedFilter.fullTNC,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.qualifiedFilter, "fullTNC", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.qualifiedFilter, "fullTNC", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.qualifiedFilter, "fullTNC", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("License Type Restriction")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qualifiedFilter.availability),expression:"qualifiedFilter.availability"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.qualifiedFilter.availability)?_vm._i(_vm.qualifiedFilter.availability,null)>-1:(_vm.qualifiedFilter.availability)},on:{"change":function($event){var $$a=_vm.qualifiedFilter.availability,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.qualifiedFilter, "availability", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.qualifiedFilter, "availability", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.qualifiedFilter, "availability", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Availability Restriction")])])])]),_vm._v(" "),(!_vm.qualifiedFilter.seatCapacity || !_vm.qualifiedFilter.serviceTypes || !_vm.qualifiedFilter.adaWC || !_vm.qualifiedFilter.adaSD || !_vm.qualifiedFilter.fullTNC || !_vm.qualifiedFilter.availability)?_c('div',{staticClass:"filter-note"},[_vm._v("\n          Changing the qualification criteria will also disable the checks for driver's upcoming trip conflicts, tight route, and work hours.\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"button-wrapper"},[_c('button',{staticClass:"cta block success"},[_vm._v("\n          "+_vm._s(_vm.$t('dispatch.map.filterControls.labelButton'))+"\n        ")])])])]),_vm._v(" "),_c('div',{class:['lr-modal', {'hide': !_vm.queueError.show}]},[_c('div',{staticClass:"lr-box"},[_c('div',{staticClass:"lr-alert-msg",domProps:{"innerHTML":_vm._s(_vm.queueError.message)}}),_vm._v(" "),_c('a',{staticClass:"button cta small right block",on:{"click":_vm.showReasons}},[_vm._v("View Driver Qualification Checks")]),_vm._v(" "),_c('div',{staticClass:"show-reasons-btn",on:{"click":function($event){_vm.queueError.show = false}}},[_vm._v("Dismiss")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1383);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4e063649", content, true, {});

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.routing-dropzone[data-v-1be11774] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.empty-container[data-v-1be11774] {\n  display: table;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0);\n  -webkit-transition: all 500ms;\n  transition: all 500ms;\n}\n.empty-container.dragover[data-v-1be11774] {\n    background-color: rgba(0, 0, 0, 0.6);\n}\n.empty-container .empty[data-v-1be11774] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.empty-container .empty-content[data-v-1be11774] {\n    max-width: 350px;\n    padding: 0 15px;\n    margin: 0 auto;\n    text-align: center;\n    font-weight: 700;\n}\n.empty-container .empty-content img[data-v-1be11774] {\n      display: block;\n      width: 200px;\n      margin: 0 auto;\n}\n.empty-container .empty-content .title[data-v-1be11774] {\n      font-size: 22px;\n      color: #3F2975;\n      margin-top: 15px;\n}\n.empty-container .empty-content .message[data-v-1be11774] {\n      margin-top: 5px;\n      font-size: 16px;\n      color: #555;\n}\n.dropzone[data-v-1be11774] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.75);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.dropzone.show[data-v-1be11774] {\n    top: 0;\n}\n.dropzone .empty-content i[data-v-1be11774] {\n    color: #fff;\n}\n.dropzone .empty-content .title[data-v-1be11774] {\n    color: #fff;\n}\n.dropzone-items[data-v-1be11774] {\n  padding: 10px 10px 5px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 70px);\n  overflow: auto;\n}\n.dropzone-item[data-v-1be11774] {\n  position: relative;\n  background-color: #fff;\n  margin-bottom: 5px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  border-radius: 3px;\n}\n.dropzone-item .remove-item[data-v-1be11774] {\n    position: absolute;\n    top: 17px;\n    right: 10px;\n    text-decoration: none;\n    color: #F20D0D;\n    cursor: pointer;\n}\n.dropzone-item a[data-v-1be11774] {\n    font-weight: 700;\n}\n.dropzone-item .header[data-v-1be11774] {\n    font-size: 12px;\n    padding: 5px;\n}\n.dropzone-item .order[data-v-1be11774] {\n    display: inline-block;\n    margin-right: 5px;\n    background-color: #5d5d5d;\n    color: #fff;\n    width: 20px;\n    height: 20px;\n    line-height: 20px;\n    text-align: center;\n    font-weight: 700;\n    border-radius: 100%;\n}\n.dropzone-item .order.dropoff[data-v-1be11774] {\n      background-color: #F20D0D;\n}\n.dropzone-item .icon-label[data-v-1be11774] {\n    display: inline-block;\n    margin-left: 10px;\n    color: #555;\n}\n.dropzone-item .icon-label.location[data-v-1be11774] {\n      margin: 0;\n      padding: 0 25px 0 5px;\n      color: #555;\n      font-weight: 700;\n      display: block;\n      margin: 5px 0;\n}\n.dropzone-item .icon-label.location i[data-v-1be11774] {\n        color: #26D97A;\n}\n.dropzone-item .icon-label.location i.dropoff[data-v-1be11774] {\n        color: #F20D0D;\n}\n.dropzone-item .icon-label.time .value[data-v-1be11774] {\n      font-weight: 700;\n}\n.dropzone-item .icon-label.validation[data-v-1be11774] {\n      color: #229e5c;\n}\n.dropzone-item .icon-label.validation i.success[data-v-1be11774] {\n        display: inline-block;\n}\n.dropzone-item .icon-label.validation i.warning[data-v-1be11774] {\n        display: none;\n}\n.dropzone-item .icon-label.validation.late[data-v-1be11774] {\n        color: #F25E0D;\n}\n.dropzone-item .icon-label.validation.late i.success[data-v-1be11774] {\n          display: none;\n}\n.dropzone-item .icon-label.validation.late i.warning[data-v-1be11774] {\n          display: inline-block;\n}\n.dropzone-item .icon-label.validation.not-allowed[data-v-1be11774] {\n        color: #f20d0d;\n}\n.dropzone-item .icon-label.validation.not-allowed i.success[data-v-1be11774] {\n          display: none;\n}\n.dropzone-item .icon-label.validation.not-allowed i.warning[data-v-1be11774] {\n          display: inline-block;\n}\n.dropzone-item .body[data-v-1be11774] {\n    font-size: 12px;\n    padding: 0 15px 10px 23px;\n    text-align: left;\n}\n.check-route-loading[data-v-1be11774] {\n  display: table;\n  position: absolute;\n  bottom: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.9);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.check-route-loading.show[data-v-1be11774] {\n    bottom: 0;\n}\n.check-route-loading .title[data-v-1be11774] {\n    display: table-cell;\n    vertical-align: middle;\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    color: #555;\n    font-weight: 700;\n    font-size: 18px;\n}\n.check-route-loading .title .text[data-v-1be11774] {\n      display: inline-block;\n      margin-top: 100px;\n}\n@media screen and (max-width: 430px) {\n.dropzone-item[data-v-1be11774] {\n    margin-bottom: 10px;\n}\n.dropzone-items[data-v-1be11774] {\n    height: 100%;\n    padding: 20px 40px;\n    padding-bottom: 150px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Runs/Dropzone.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;CACd;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,qCAAqC;CACxC;AACD;IACI,oBAAoB;IACpB,uBAAuB;CAC1B;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;CACpB;AACD;MACM,eAAe;MACf,aAAa;MACb,eAAe;CACpB;AACD;MACM,gBAAgB;MAChB,eAAe;MACf,iBAAiB;CACtB;AACD;MACM,gBAAgB;MAChB,gBAAgB;MAChB,YAAY;CACjB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;CACV;AACD;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,0BAA0B;EAC1B,eAAe;CAChB;AACD;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,gBAAgB;CACnB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,gBAAgB;IAChB,aAAa;CAChB;AACD;IACI,sBAAsB;IACtB,kBAAkB;IAClB,0BAA0B;IAC1B,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;CACvB;AACD;MACM,0BAA0B;CAC/B;AACD;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;CACf;AACD;MACM,UAAU;MACV,sBAAsB;MACtB,YAAY;MACZ,iBAAiB;MACjB,eAAe;MACf,cAAc;CACnB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,eAAe;CACtB;AACD;MACM,iBAAiB;CACtB;AACD;MACM,eAAe;CACpB;AACD;QACQ,sBAAsB;CAC7B;AACD;QACQ,cAAc;CACrB;AACD;QACQ,eAAe;CACtB;AACD;UACU,cAAc;CACvB;AACD;UACU,sBAAsB;CAC/B;AACD;QACQ,eAAe;CACtB;AACD;UACU,cAAc;CACvB;AACD;UACU,sBAAsB;CAC/B;AACD;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;CACpB;AACD;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,2CAA2C;EAC3C,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,UAAU;CACb;AACD;IACI,oBAAoB;IACpB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;CACnB;AACD;MACM,sBAAsB;MACtB,kBAAkB;CACvB;AACD;AACA;IACI,oBAAoB;CACvB;AACD;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;CACzB;CACA","file":"Dropzone.vue","sourcesContent":["\n.routing-dropzone[data-v-1be11774] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.empty-container[data-v-1be11774] {\n  display: table;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0);\n  -webkit-transition: all 500ms;\n  transition: all 500ms;\n}\n.empty-container.dragover[data-v-1be11774] {\n    background-color: rgba(0, 0, 0, 0.6);\n}\n.empty-container .empty[data-v-1be11774] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.empty-container .empty-content[data-v-1be11774] {\n    max-width: 350px;\n    padding: 0 15px;\n    margin: 0 auto;\n    text-align: center;\n    font-weight: 700;\n}\n.empty-container .empty-content img[data-v-1be11774] {\n      display: block;\n      width: 200px;\n      margin: 0 auto;\n}\n.empty-container .empty-content .title[data-v-1be11774] {\n      font-size: 22px;\n      color: #3F2975;\n      margin-top: 15px;\n}\n.empty-container .empty-content .message[data-v-1be11774] {\n      margin-top: 5px;\n      font-size: 16px;\n      color: #555;\n}\n.dropzone[data-v-1be11774] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.75);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.dropzone.show[data-v-1be11774] {\n    top: 0;\n}\n.dropzone .empty-content i[data-v-1be11774] {\n    color: #fff;\n}\n.dropzone .empty-content .title[data-v-1be11774] {\n    color: #fff;\n}\n.dropzone-items[data-v-1be11774] {\n  padding: 10px 10px 5px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 70px);\n  overflow: auto;\n}\n.dropzone-item[data-v-1be11774] {\n  position: relative;\n  background-color: #fff;\n  margin-bottom: 5px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  border-radius: 3px;\n}\n.dropzone-item .remove-item[data-v-1be11774] {\n    position: absolute;\n    top: 17px;\n    right: 10px;\n    text-decoration: none;\n    color: #F20D0D;\n    cursor: pointer;\n}\n.dropzone-item a[data-v-1be11774] {\n    font-weight: 700;\n}\n.dropzone-item .header[data-v-1be11774] {\n    font-size: 12px;\n    padding: 5px;\n}\n.dropzone-item .order[data-v-1be11774] {\n    display: inline-block;\n    margin-right: 5px;\n    background-color: #5d5d5d;\n    color: #fff;\n    width: 20px;\n    height: 20px;\n    line-height: 20px;\n    text-align: center;\n    font-weight: 700;\n    border-radius: 100%;\n}\n.dropzone-item .order.dropoff[data-v-1be11774] {\n      background-color: #F20D0D;\n}\n.dropzone-item .icon-label[data-v-1be11774] {\n    display: inline-block;\n    margin-left: 10px;\n    color: #555;\n}\n.dropzone-item .icon-label.location[data-v-1be11774] {\n      margin: 0;\n      padding: 0 25px 0 5px;\n      color: #555;\n      font-weight: 700;\n      display: block;\n      margin: 5px 0;\n}\n.dropzone-item .icon-label.location i[data-v-1be11774] {\n        color: #26D97A;\n}\n.dropzone-item .icon-label.location i.dropoff[data-v-1be11774] {\n        color: #F20D0D;\n}\n.dropzone-item .icon-label.time .value[data-v-1be11774] {\n      font-weight: 700;\n}\n.dropzone-item .icon-label.validation[data-v-1be11774] {\n      color: #229e5c;\n}\n.dropzone-item .icon-label.validation i.success[data-v-1be11774] {\n        display: inline-block;\n}\n.dropzone-item .icon-label.validation i.warning[data-v-1be11774] {\n        display: none;\n}\n.dropzone-item .icon-label.validation.late[data-v-1be11774] {\n        color: #F25E0D;\n}\n.dropzone-item .icon-label.validation.late i.success[data-v-1be11774] {\n          display: none;\n}\n.dropzone-item .icon-label.validation.late i.warning[data-v-1be11774] {\n          display: inline-block;\n}\n.dropzone-item .icon-label.validation.not-allowed[data-v-1be11774] {\n        color: #f20d0d;\n}\n.dropzone-item .icon-label.validation.not-allowed i.success[data-v-1be11774] {\n          display: none;\n}\n.dropzone-item .icon-label.validation.not-allowed i.warning[data-v-1be11774] {\n          display: inline-block;\n}\n.dropzone-item .body[data-v-1be11774] {\n    font-size: 12px;\n    padding: 0 15px 10px 23px;\n    text-align: left;\n}\n.check-route-loading[data-v-1be11774] {\n  display: table;\n  position: absolute;\n  bottom: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.9);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.check-route-loading.show[data-v-1be11774] {\n    bottom: 0;\n}\n.check-route-loading .title[data-v-1be11774] {\n    display: table-cell;\n    vertical-align: middle;\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    color: #555;\n    font-weight: 700;\n    font-size: 18px;\n}\n.check-route-loading .title .text[data-v-1be11774] {\n      display: inline-block;\n      margin-top: 100px;\n}\n@media screen and (max-width: 430px) {\n.dropzone-item[data-v-1be11774] {\n    margin-bottom: 10px;\n}\n.dropzone-items[data-v-1be11774] {\n    height: 100%;\n    padding: 20px 40px;\n    padding-bottom: 150px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropzoneControls_vue__ = __webpack_require__(500);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c356f90_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropzoneControls_vue__ = __webpack_require__(1387);
function injectStyle (ssrContext) {
  __webpack_require__(1385)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c356f90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropzoneControls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c356f90_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropzoneControls_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1386);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("499a6733", content, true, {});

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.dropzone-controls[data-v-6c356f90] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: #fff;\n  border-top: 1px solid rgba(0, 0, 0, 0.3);\n  padding: 15px 10px;\n}\n.row[data-v-6c356f90] {\n  padding: 0 10px;\n}\n.padding-L[data-v-6c356f90] {\n  padding-left: 5px;\n}\n.padding-R[data-v-6c356f90] {\n  padding-right: 5px;\n}\n.button[data-v-6c356f90] {\n  line-height: 135%;\n}\n@media screen and (max-width: 430px) {\n.dropzone-controls[data-v-6c356f90] {\n    bottom: 45px;\n    padding: 10px 0;\n}\n.dropzone-controls .button.small[data-v-6c356f90] {\n      font-size: 12px;\n      padding: 10px 7px 10px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Runs/DropzoneControls.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,yCAAyC;EACzC,mBAAmB;CACpB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;AACA;IACI,aAAa;IACb,gBAAgB;CACnB;AACD;MACM,gBAAgB;MAChB,uBAAuB;CAC5B;CACA","file":"DropzoneControls.vue","sourcesContent":["\n.dropzone-controls[data-v-6c356f90] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: #fff;\n  border-top: 1px solid rgba(0, 0, 0, 0.3);\n  padding: 15px 10px;\n}\n.row[data-v-6c356f90] {\n  padding: 0 10px;\n}\n.padding-L[data-v-6c356f90] {\n  padding-left: 5px;\n}\n.padding-R[data-v-6c356f90] {\n  padding-right: 5px;\n}\n.button[data-v-6c356f90] {\n  line-height: 135%;\n}\n@media screen and (max-width: 430px) {\n.dropzone-controls[data-v-6c356f90] {\n    bottom: 45px;\n    padding: 10px 0;\n}\n.dropzone-controls .button.small[data-v-6c356f90] {\n      font-size: 12px;\n      padding: 10px 7px 10px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length > 0),expression:"items.length > 0"}],staticClass:"dropzone-controls"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('a',{staticClass:"button cta small block warning",attrs:{"href":"javascript:;"},on:{"click":_vm.clearMap}},[_vm._v("CLEAR MAP")])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('a',{class:['button cta small block success', {disabled:_vm.issueList.indexOf('not-allowed') > -1}],attrs:{"href":"javascript:;"},on:{"click":_vm.savePackage}},[_vm._v("SAVE RUN")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"routing-dropzone"},[_c('draggable',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length > 0),expression:"items.length > 0"}],staticClass:"dropzone-items",model:{value:(_vm.items),callback:function ($$v) {_vm.items=$$v},expression:"items"}},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"dropzone-item"},[_c('div',{staticClass:"header"},[_c('span',{staticClass:"order"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('a',{attrs:{"href":'/#/reservation/' + item.id,"target":"_blank"}},[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('span',{staticClass:"icon-label location"},[_c('i',{staticClass:"fas fa-map-marker-alt fa-fw"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getAddress(item.pickup)))])]),_vm._v(" "),_c('span',{staticClass:"icon-label location"},[_c('i',{staticClass:"fas fa-map-marker-alt fa-fw dropoff"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getAddress(item.dropoff)))])])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('span',{staticClass:"icon-label time"},[_c('i',{staticClass:"fas fa-clock"}),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("PUT:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(item.pickupDate))])]),_vm._v(" "),_c('span',{staticClass:"icon-label time"},[_c('i',{staticClass:"fas fa-clock"}),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("ETA:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.computeEta(item)))])]),_vm._v(" "),(item.timeToNext != null)?_c('span',{class:['icon-label validation', _vm.hasIssues(item, index).time]},[_c('i',{staticClass:"fas fa-exclamation-triangle fa-fw warning"}),_vm._v(" "),_c('i',{staticClass:"fas fa-check-circle fa-fw success"}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.hasIssues(item, index).msg)}})]):_vm._e()]),_vm._v(" "),_c('a',{staticClass:"remove-item",on:{"click":function($event){return _vm.removeFromMap(item)}}},[_c('i',{staticClass:"fas fa-minus-square"})])])}),0),_vm._v(" "),_c('dropzone-controls',{ref:"dropzoneControls"}),_vm._v(" "),_c('div',{class:['check-route-loading', {show: _vm.checkRouteLoading}]},[_c('loader-map-marker'),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length <= 0),expression:"items.length <= 0"}],staticClass:"empty-container"},[_vm._m(1)]),_vm._v(" "),_c('drop',{class:['empty-container dropzone', {show: _vm.showDropzone}],on:{"drop":_vm.handleDrop}},[_c('div',{staticClass:"empty"},[_c('div',{staticClass:"empty-content"},[_c('i',{staticClass:"fas fa-arrow-alt-circle-down fa-4x"}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Drop it here!")])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"text"},[_vm._v("Finding optimal route...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('div',{staticClass:"empty-content"},[_c('img',{attrs:{"src":"/assets/img/routing-empty.png"}}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Nothing here yet!")]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("Drop a reservation/runs here or click on the map marker icons to begin routing.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RsvpAvailableDrivers_vue__ = __webpack_require__(501);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10ae9891_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RsvpAvailableDrivers_vue__ = __webpack_require__(1392);
function injectStyle (ssrContext) {
  __webpack_require__(1390)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10ae9891"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RsvpAvailableDrivers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10ae9891_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RsvpAvailableDrivers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1391);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("ef957e46", content, true, {});

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.filter-available-drivers .available-data[data-v-10ae9891] {\n  height: calc(100% - 50px);\n}\n.available-table[data-v-10ae9891] {\n  height: 100%;\n}\ntable[data-v-10ae9891] {\n  border-collapse: collapse;\n  width: 100%;\n  overflow: auto;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n  height: 100%;\n  display: table-footer-group;\n  text-align: center;\n}\ntable thead[data-v-10ae9891] {\n    width: 100%;\n    color: #8DA0A9;\n    font-size: 12px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable thead th[data-v-10ae9891] {\n      padding: 5px;\n      position: sticky;\n      position: -webkit-sticky;\n      top: 0;\n      z-index: 2;\n      background-color: #f5f5f5;\n      text-transform: uppercase;\n}\ntable tbody[data-v-10ae9891] {\n    font-size: 13px;\n    line-height: 1.4;\n}\ntable tbody[data-v-10ae9891]::after {\n      content: '-----------------------------------------------------------------------------------';\n      max-height: 0;\n      overflow: hidden;\n      display: block;\n      word-break: break-all;\n}\ntable tbody tr[data-v-10ae9891] {\n      border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody td[data-v-10ae9891] {\n      padding: 10px 5px;\n      background: #fff;\n}\ntable tbody a[data-v-10ae9891] {\n      font-weight: 600;\n}\ntable .radio[data-v-10ae9891] {\n    width: 40px;\n    padding: 10px;\n}\ntable .radio input[data-v-10ae9891] {\n      margin: 0;\n      cursor: pointer;\n}\ntable .id[data-v-10ae9891] {\n    width: 60px;\n}\ntable .name[data-v-10ae9891] {\n    width: 130px;\n}\ntable .sector[data-v-10ae9891] {\n    width: 150px;\n}\ntable .shift[data-v-10ae9891] {\n    width: 100px;\n}\n.loader[data-v-10ae9891] {\n  text-align: center;\n  padding: 50px 0;\n  color: #a2b1b8;\n  font-size: 14px;\n  font-weight: 600;\n}\n.loader div[data-v-10ae9891] {\n    margin-top: 10px;\n}\n.empty-state[data-v-10ae9891] {\n  font-weight: 700;\n  padding: 40px;\n  font-size: 16px;\n  color: #777;\n  text-align: center;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/RsvpAvailableDrivers.vue"],"names":[],"mappings":";AACA;EACE,0BAA0B;CAC3B;AACD;EACE,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,4CAA4C;EAC5C,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;CACpB;AACD;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,4CAA4C;CAC/C;AACD;MACM,aAAa;MACb,iBAAiB;MACjB,yBAAyB;MACzB,OAAO;MACP,WAAW;MACX,0BAA0B;MAC1B,0BAA0B;CAC/B;AACD;IACI,gBAAgB;IAChB,iBAAiB;CACpB;AACD;MACM,+FAA+F;MAC/F,cAAc;MACd,iBAAiB;MACjB,eAAe;MACf,sBAAsB;CAC3B;AACD;MACM,4CAA4C;CACjD;AACD;MACM,kBAAkB;MAClB,iBAAiB;CACtB;AACD;MACM,iBAAiB;CACtB;AACD;IACI,YAAY;IACZ,cAAc;CACjB;AACD;MACM,UAAU;MACV,gBAAgB;CACrB;AACD;IACI,YAAY;CACf;AACD;IACI,aAAa;CAChB;AACD;IACI,aAAa;CAChB;AACD;IACI,aAAa;CAChB;AACD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;CAClB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;CACpB","file":"RsvpAvailableDrivers.vue","sourcesContent":["\n.filter-available-drivers .available-data[data-v-10ae9891] {\n  height: calc(100% - 50px);\n}\n.available-table[data-v-10ae9891] {\n  height: 100%;\n}\ntable[data-v-10ae9891] {\n  border-collapse: collapse;\n  width: 100%;\n  overflow: auto;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n  height: 100%;\n  display: table-footer-group;\n  text-align: center;\n}\ntable thead[data-v-10ae9891] {\n    width: 100%;\n    color: #8DA0A9;\n    font-size: 12px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable thead th[data-v-10ae9891] {\n      padding: 5px;\n      position: sticky;\n      position: -webkit-sticky;\n      top: 0;\n      z-index: 2;\n      background-color: #f5f5f5;\n      text-transform: uppercase;\n}\ntable tbody[data-v-10ae9891] {\n    font-size: 13px;\n    line-height: 1.4;\n}\ntable tbody[data-v-10ae9891]::after {\n      content: '-----------------------------------------------------------------------------------';\n      max-height: 0;\n      overflow: hidden;\n      display: block;\n      word-break: break-all;\n}\ntable tbody tr[data-v-10ae9891] {\n      border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody td[data-v-10ae9891] {\n      padding: 10px 5px;\n      background: #fff;\n}\ntable tbody a[data-v-10ae9891] {\n      font-weight: 600;\n}\ntable .radio[data-v-10ae9891] {\n    width: 40px;\n    padding: 10px;\n}\ntable .radio input[data-v-10ae9891] {\n      margin: 0;\n      cursor: pointer;\n}\ntable .id[data-v-10ae9891] {\n    width: 60px;\n}\ntable .name[data-v-10ae9891] {\n    width: 130px;\n}\ntable .sector[data-v-10ae9891] {\n    width: 150px;\n}\ntable .shift[data-v-10ae9891] {\n    width: 100px;\n}\n.loader[data-v-10ae9891] {\n  text-align: center;\n  padding: 50px 0;\n  color: #a2b1b8;\n  font-size: 14px;\n  font-weight: 600;\n}\n.loader div[data-v-10ae9891] {\n    margin-top: 10px;\n}\n.empty-state[data-v-10ae9891] {\n  font-weight: 700;\n  padding: 40px;\n  font-size: 16px;\n  color: #777;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column align-stretch available-data"},[_c('div',{staticClass:"available-table"},[(_vm.loading)?_c('div',{staticClass:"loader"},[_c('ellipsis-loader'),_vm._v(" "),_c('div',[_vm._v("Loading available drivers...")])],1):_vm._e(),_vm._v(" "),(!_vm.loading && _vm.drivers.length)?_c('table',[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.drivers),function(driver,x){return _c('tr',{key:x},[_c('td',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDriver),expression:"selectedDriver"}],attrs:{"type":"radio"},domProps:{"value":driver.id,"checked":_vm._q(_vm.selectedDriver,driver.id)},on:{"change":function($event){_vm.selectedDriver=driver.id}}})]),_vm._v(" "),_c('td',{staticClass:"id"},[_c('a',{attrs:{"href":("#/provider/" + (driver.id)),"target":"_blank"}},[_vm._v(_vm._s(driver.id))])]),_vm._v(" "),_c('td',{staticClass:"name"},[_vm._v(_vm._s(driver.name))]),_vm._v(" "),_c('td',{staticClass:"sector"},[_vm._v(_vm._s(driver.homeSector))]),_vm._v(" "),_c('td',{staticClass:"shift"},[_vm._v(_vm._s(driver.availableFrom))]),_vm._v(" "),_c('td',{staticClass:"shift"},[_vm._v(_vm._s(driver.availableUntil))])])}),0)]):_vm._e(),_vm._v(" "),(!_vm.loading && !_vm.drivers.length)?_c('div',{staticClass:"empty-state"},[_vm._v("\n      No drivers found.\n    ")]):_vm._e()]),_vm._v(" "),_c('div',[_c('driver-controls',{attrs:{"tabIndex":_vm.currentDispatchTab,"table":"rsvpAvailableDrivers"}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th'),_vm._v(" "),_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("NAME")]),_vm._v(" "),_c('th',[_vm._v("SECTOR")]),_vm._v(" "),_c('th',[_vm._v("SHIFT"),_c('br'),_vm._v("START")]),_vm._v(" "),_c('th',[_vm._v("SHIFT"),_c('br'),_vm._v("END")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LyftServices_vue__ = __webpack_require__(502);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_600f8a0d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LyftServices_vue__ = __webpack_require__(1396);
function injectStyle (ssrContext) {
  __webpack_require__(1394)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-600f8a0d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LyftServices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_600f8a0d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LyftServices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1395);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("89417cac", content, true, {});

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.lr-modal[data-v-600f8a0d] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-600f8a0d] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-600f8a0d] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n}\n.lyft-box[data-v-600f8a0d] {\n  width: 400px;\n  line-height: 1;\n}\n.l-head[data-v-600f8a0d] {\n  margin-bottom: 20px;\n}\n.lr-head[data-v-600f8a0d] {\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: .8px;\n  margin-bottom: 15px;\n}\n.lrh-price[data-v-600f8a0d] {\n  text-align: right;\n}\n.lrh-price span[data-v-600f8a0d] {\n    display: block;\n    font-size: 12px;\n    color: #797979;\n    font-weight: 500;\n}\n.lrh-price b[data-v-600f8a0d] {\n    font-size: 18px;\n    line-height: 1;\n}\n.lr-sub-head[data-v-600f8a0d] {\n  text-align: center;\n  margin-bottom: 10px;\n  font-size: 13px;\n  color: #444;\n  letter-spacing: .6px;\n}\n.l-availability[data-v-600f8a0d] {\n  font-size: 13px;\n  letter-spacing: .7px;\n  gap: 5px;\n  color: #333;\n}\n.l-availability .status[data-v-600f8a0d] {\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    display: inline-block;\n}\n.l-availability .status.GREEN[data-v-600f8a0d] {\n      background: #38d944;\n}\n.l-availability .status.RED[data-v-600f8a0d] {\n      background: #ff3f3f;\n}\n.l-availability .status.ORANGE[data-v-600f8a0d] {\n      background: #ff983f;\n}\n.l-availability i[data-v-600f8a0d] {\n    font-size: 21px;\n    color: #ff1515;\n}\n.l-availability .fa-spinner[data-v-600f8a0d] {\n    color: #777;\n}\n.lyft-service-box[data-v-600f8a0d] {\n  overflow: auto;\n  height: calc(100vh - 200px);\n  margin-bottom: 20px;\n  border: 1px solid #ccc;\n  background: #f6f6f6;\n  padding: 10px;\n  border-radius: 4px;\n}\n.lyft-service[data-v-600f8a0d] {\n  gap: 10px;\n  border: 1px solid #ccc;\n  margin-bottom: 10px;\n  padding: 10px;\n  text-align: left;\n  background: #fafafa;\n  cursor: pointer;\n  border-radius: 2px;\n  -webkit-box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);\n}\n.lyft-service.active[data-v-600f8a0d] {\n    outline: 2px solid #00a1ff;\n    border-color: #195c83;\n}\n.lyft-service.failed[data-v-600f8a0d] {\n    opacity: .5;\n    cursor: default;\n}\n.lyft-service[data-v-600f8a0d]:not(.failed):hover {\n    background: #fff;\n}\n.l-img img[data-v-600f8a0d] {\n  width: 60px;\n}\n.l-name[data-v-600f8a0d] {\n  font-size: 16px;\n  letter-spacing: .6px;\n  width: calc(100% - 100px);\n}\n.l-display-name[data-v-600f8a0d] {\n  font-weight: 600;\n}\n.l-service-code[data-v-600f8a0d] {\n  font-size: 11px;\n  color: #999;\n  margin-top: 5px;\n}\n.l-eta[data-v-600f8a0d] {\n  margin: 10px 0 0;\n  letter-spacing: .6px;\n  font-size: 13px;\n  color: #333;\n}\n.l-eta b[data-v-600f8a0d] {\n    display: inline-block;\n    margin-left: 2px;\n}\n.l-failed-txt[data-v-600f8a0d] {\n  font-size: 12px;\n  color: #f00;\n  margin-top: 5px;\n  letter-spacing: .8px;\n}\n.l-price[data-v-600f8a0d] {\n  letter-spacing: .8px;\n  text-align: right;\n}\n.l-price small[data-v-600f8a0d] {\n    font-size: 12px;\n    line-height: 1;\n    display: block;\n    margin-bottom: 3px;\n    color: #797979;\n}\n.l-price span[data-v-600f8a0d] {\n    display: block;\n    font-weight: 600;\n    color: #364560;\n}\n.l-price span.low-price[data-v-600f8a0d] {\n      color: #29a53a;\n}\n.l-price span.high-price[data-v-600f8a0d] {\n      color: #a52929;\n}\n.btn-send[data-v-600f8a0d] {\n  margin: 10px 0;\n}\n.driver-box .db-title[data-v-600f8a0d] {\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: .8px;\n  margin-bottom: 20px;\n}\n.driver-box .ride-id[data-v-600f8a0d] {\n  text-align: left;\n  font-size: 14px;\n  color: #444;\n  margin-bottom: 5px;\n}\n.driver-box .ride-id b[data-v-600f8a0d] {\n    margin-left: 5px;\n    letter-spacing: .6px;\n}\n.driver-box .d-info-box[data-v-600f8a0d] {\n  border: 1px solid #ccc;\n  padding: 10px;\n  background: #fafafa;\n  gap: 15px;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: start;\n  margin-bottom: 15px;\n}\n.driver-box .d-info-box img[data-v-600f8a0d] {\n    width: 100px;\n    border: 1px solid #eee;\n}\n.driver-box .di-field[data-v-600f8a0d] {\n  text-align: left;\n  letter-spacing: .6px;\n  color: #555;\n  font-size: 13px;\n  margin-bottom: 6px;\n  font-weight: 600;\n}\n.driver-box .di-field.name[data-v-600f8a0d] {\n    color: #333;\n    font-size: 16px;\n}\n.driver-box .di-field i[data-v-600f8a0d] {\n    font-size: 16px;\n    color: #aaa;\n    margin-right: 1px;\n    vertical-align: -1px;\n}\n.load-box .lyft-msg[data-v-600f8a0d] {\n  color: #888;\n  font-size: 15px;\n  letter-spacing: .6px;\n  font-style: italic;\n  margin: 10px 0 30px;\n}\n.pi-box .pi-header[data-v-600f8a0d] {\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: .5px;\n  color: #333;\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n}\n.pi-box .direction[data-v-600f8a0d] {\n  text-align: left;\n  letter-spacing: .4px;\n  font-size: 15px;\n  line-height: 1.2;\n  margin-bottom: 20px;\n  color: #555;\n}\n.pi-box .pi-field[data-v-600f8a0d] {\n  text-align: left;\n}\n.pi-box .pi-field label[data-v-600f8a0d] {\n    font-size: 14px;\n    letter-spacing: .6px;\n    margin-bottom: 3px;\n    display: block;\n}\n.pi-box .pi-field select[data-v-600f8a0d] {\n    background: #f7f7f7;\n    padding: 5px;\n    margin-bottom: 20px;\n    -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n            box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n    outline: none;\n}\n.pi-action[data-v-600f8a0d] {\n  gap: 20px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/LyftServices.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oCAAoC;MAChC,iCAAiC;UAC7B,mCAAmC;EAC3C,qCAAqC;MACjC,kCAAkC;UAC9B,+BAA+B;EACvC,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;EACnD,mBAAmB;CACpB;AACD;EACE,aAAa;EACb,eAAe;CAChB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;CACrB;AACD;EACE,kBAAkB;CACnB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iBAAiB;CACpB;AACD;IACI,gBAAgB;IAChB,eAAe;CAClB;AACD;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;CACtB;AACD;EACE,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;EACT,YAAY;CACb;AACD;IACI,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,sBAAsB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;IACI,gBAAgB;IAChB,eAAe;CAClB;AACD;IACI,YAAY;CACf;AACD;EACE,eAAe;EACf,4BAA4B;EAC5B,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;CACpB;AACD;EACE,UAAU;EACV,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;CACpD;AACD;IACI,2BAA2B;IAC3B,sBAAsB;CACzB;AACD;IACI,YAAY;IACZ,gBAAgB;CACnB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,YAAY;CACb;AACD;EACE,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;CAC3B;AACD;EACE,iBAAiB;CAClB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;CACb;AACD;IACI,sBAAsB;IACtB,iBAAiB;CACpB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;CACtB;AACD;EACE,qBAAqB;EACrB,kBAAkB;CACnB;AACD;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;CAClB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;EACE,eAAe;CAChB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;CACrB;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;CACpB;AACD;IACI,iBAAiB;IACjB,qBAAqB;CACxB;AACD;EACE,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,UAAU;EACV,yBAAyB;MACrB,sBAAsB;UAClB,mBAAmB;EAC3B,oBAAoB;CACrB;AACD;IACI,aAAa;IACb,uBAAuB;CAC1B;AACD;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;CAClB;AACD;IACI,YAAY;IACZ,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;CACxB;AACD;EACE,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;CACrB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,8BAA8B;EAC9B,qBAAqB;EACrB,oBAAoB;CACrB;AACD;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;CACb;AACD;EACE,iBAAiB;CAClB;AACD;IACI,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;CAClB;AACD;IACI,oBAAoB;IACpB,aAAa;IACb,oBAAoB;IACpB,+CAA+C;YACvC,uCAAuC;IAC/C,cAAc;CACjB;AACD;EACE,UAAU;CACX","file":"LyftServices.vue","sourcesContent":["\n.lr-modal[data-v-600f8a0d] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-600f8a0d] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-600f8a0d] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n}\n.lyft-box[data-v-600f8a0d] {\n  width: 400px;\n  line-height: 1;\n}\n.l-head[data-v-600f8a0d] {\n  margin-bottom: 20px;\n}\n.lr-head[data-v-600f8a0d] {\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: .8px;\n  margin-bottom: 15px;\n}\n.lrh-price[data-v-600f8a0d] {\n  text-align: right;\n}\n.lrh-price span[data-v-600f8a0d] {\n    display: block;\n    font-size: 12px;\n    color: #797979;\n    font-weight: 500;\n}\n.lrh-price b[data-v-600f8a0d] {\n    font-size: 18px;\n    line-height: 1;\n}\n.lr-sub-head[data-v-600f8a0d] {\n  text-align: center;\n  margin-bottom: 10px;\n  font-size: 13px;\n  color: #444;\n  letter-spacing: .6px;\n}\n.l-availability[data-v-600f8a0d] {\n  font-size: 13px;\n  letter-spacing: .7px;\n  gap: 5px;\n  color: #333;\n}\n.l-availability .status[data-v-600f8a0d] {\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    display: inline-block;\n}\n.l-availability .status.GREEN[data-v-600f8a0d] {\n      background: #38d944;\n}\n.l-availability .status.RED[data-v-600f8a0d] {\n      background: #ff3f3f;\n}\n.l-availability .status.ORANGE[data-v-600f8a0d] {\n      background: #ff983f;\n}\n.l-availability i[data-v-600f8a0d] {\n    font-size: 21px;\n    color: #ff1515;\n}\n.l-availability .fa-spinner[data-v-600f8a0d] {\n    color: #777;\n}\n.lyft-service-box[data-v-600f8a0d] {\n  overflow: auto;\n  height: calc(100vh - 200px);\n  margin-bottom: 20px;\n  border: 1px solid #ccc;\n  background: #f6f6f6;\n  padding: 10px;\n  border-radius: 4px;\n}\n.lyft-service[data-v-600f8a0d] {\n  gap: 10px;\n  border: 1px solid #ccc;\n  margin-bottom: 10px;\n  padding: 10px;\n  text-align: left;\n  background: #fafafa;\n  cursor: pointer;\n  border-radius: 2px;\n  -webkit-box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);\n}\n.lyft-service.active[data-v-600f8a0d] {\n    outline: 2px solid #00a1ff;\n    border-color: #195c83;\n}\n.lyft-service.failed[data-v-600f8a0d] {\n    opacity: .5;\n    cursor: default;\n}\n.lyft-service[data-v-600f8a0d]:not(.failed):hover {\n    background: #fff;\n}\n.l-img img[data-v-600f8a0d] {\n  width: 60px;\n}\n.l-name[data-v-600f8a0d] {\n  font-size: 16px;\n  letter-spacing: .6px;\n  width: calc(100% - 100px);\n}\n.l-display-name[data-v-600f8a0d] {\n  font-weight: 600;\n}\n.l-service-code[data-v-600f8a0d] {\n  font-size: 11px;\n  color: #999;\n  margin-top: 5px;\n}\n.l-eta[data-v-600f8a0d] {\n  margin: 10px 0 0;\n  letter-spacing: .6px;\n  font-size: 13px;\n  color: #333;\n}\n.l-eta b[data-v-600f8a0d] {\n    display: inline-block;\n    margin-left: 2px;\n}\n.l-failed-txt[data-v-600f8a0d] {\n  font-size: 12px;\n  color: #f00;\n  margin-top: 5px;\n  letter-spacing: .8px;\n}\n.l-price[data-v-600f8a0d] {\n  letter-spacing: .8px;\n  text-align: right;\n}\n.l-price small[data-v-600f8a0d] {\n    font-size: 12px;\n    line-height: 1;\n    display: block;\n    margin-bottom: 3px;\n    color: #797979;\n}\n.l-price span[data-v-600f8a0d] {\n    display: block;\n    font-weight: 600;\n    color: #364560;\n}\n.l-price span.low-price[data-v-600f8a0d] {\n      color: #29a53a;\n}\n.l-price span.high-price[data-v-600f8a0d] {\n      color: #a52929;\n}\n.btn-send[data-v-600f8a0d] {\n  margin: 10px 0;\n}\n.driver-box .db-title[data-v-600f8a0d] {\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: .8px;\n  margin-bottom: 20px;\n}\n.driver-box .ride-id[data-v-600f8a0d] {\n  text-align: left;\n  font-size: 14px;\n  color: #444;\n  margin-bottom: 5px;\n}\n.driver-box .ride-id b[data-v-600f8a0d] {\n    margin-left: 5px;\n    letter-spacing: .6px;\n}\n.driver-box .d-info-box[data-v-600f8a0d] {\n  border: 1px solid #ccc;\n  padding: 10px;\n  background: #fafafa;\n  gap: 15px;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: start;\n  margin-bottom: 15px;\n}\n.driver-box .d-info-box img[data-v-600f8a0d] {\n    width: 100px;\n    border: 1px solid #eee;\n}\n.driver-box .di-field[data-v-600f8a0d] {\n  text-align: left;\n  letter-spacing: .6px;\n  color: #555;\n  font-size: 13px;\n  margin-bottom: 6px;\n  font-weight: 600;\n}\n.driver-box .di-field.name[data-v-600f8a0d] {\n    color: #333;\n    font-size: 16px;\n}\n.driver-box .di-field i[data-v-600f8a0d] {\n    font-size: 16px;\n    color: #aaa;\n    margin-right: 1px;\n    vertical-align: -1px;\n}\n.load-box .lyft-msg[data-v-600f8a0d] {\n  color: #888;\n  font-size: 15px;\n  letter-spacing: .6px;\n  font-style: italic;\n  margin: 10px 0 30px;\n}\n.pi-box .pi-header[data-v-600f8a0d] {\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: .5px;\n  color: #333;\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n}\n.pi-box .direction[data-v-600f8a0d] {\n  text-align: left;\n  letter-spacing: .4px;\n  font-size: 15px;\n  line-height: 1.2;\n  margin-bottom: 20px;\n  color: #555;\n}\n.pi-box .pi-field[data-v-600f8a0d] {\n  text-align: left;\n}\n.pi-box .pi-field label[data-v-600f8a0d] {\n    font-size: 14px;\n    letter-spacing: .6px;\n    margin-bottom: 3px;\n    display: block;\n}\n.pi-box .pi-field select[data-v-600f8a0d] {\n    background: #f7f7f7;\n    padding: 5px;\n    margin-bottom: 20px;\n    -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n            box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n    outline: none;\n}\n.pi-action[data-v-600f8a0d] {\n  gap: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['lr-modal', {'hide': !_vm.show}]},[_c('div',{staticClass:"lr-box lyft-box"},[(_vm.loading)?_c('div',{staticClass:"load-box"},[_c('img',{attrs:{"src":"https://www.opoli.com/wp-content/themes/opoli/img/loading-car.gif"}}),_vm._v(" "),_c('div',{staticClass:"lyft-msg",domProps:{"innerHTML":_vm._s(_vm.msg)}})]):(_vm.driver.found)?_c('div',{staticClass:"driver-box"},[_c('div',{staticClass:"db-title"},[_vm._v("Driver Found!")]),_vm._v(" "),_c('div',{staticClass:"ride-id"},[_vm._v("\n        Ride ID:\n        "),_c('b',[_vm._v(_vm._s(_vm.rideId))])]),_vm._v(" "),_c('div',{staticClass:"d-info-box d-flex"},[_c('img',{attrs:{"src":_vm.driver.img}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"di-field name"},[_vm._v(_vm._s(_vm.driver.name))]),_vm._v(" "),_c('div',{staticClass:"di-field"},[_c('i',{staticClass:"fas fa-phone-square fa-fw",attrs:{"title":"mobile"}}),_vm._v(" "+_vm._s(_vm.driver.mobile))]),_vm._v(" "),_c('div',{staticClass:"di-field"},[_c('i',{staticClass:"fas fa-star fa-fw",attrs:{"title":"rating"}}),_vm._v(" "+_vm._s(_vm.driver.rating))])])]),_vm._v(" "),_c('div',{staticClass:"d-info-box d-flex"},[_c('img',{attrs:{"src":_vm.vehicle.img}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"di-field name"},[_vm._v(_vm._s(((_vm.vehicle.color) + " " + (_vm.vehicle.make) + " " + (_vm.vehicle.model) + " " + (_vm.vehicle.year))))]),_vm._v(" "),_c('div',{staticClass:"di-field"},[_vm._v(_vm._s(_vm.vehicle.licensePlate))])])]),_vm._v(" "),_c('a',{staticClass:"button cta small block secondary",on:{"click":function($event){_vm.show = false}}},[_vm._v("CLOSE")])]):(_vm.venueShow)?_c('div',{staticClass:"pi-box"},[_c('div',{staticClass:"pi-header"},[_vm._v("Pickup Instruction")]),_vm._v(" "),_c('div',{staticClass:"direction"},[_vm._v(_vm._s(_vm.directions))]),_vm._v(" "),(_vm.zones.length > 1)?_c('div',{staticClass:"pi-field"},[_c('label',[_vm._v("Choose a pickup zone")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.zoneIndex),expression:"zoneIndex"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.zoneIndex=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.zones),function(x,i){return _c('option',{key:i,domProps:{"value":i}},[_vm._v(_vm._s(x.name))])}),0)]):_vm._e(),_vm._v(" "),(_vm.zones.length && _vm.zones[_vm.zoneIndex].locations.length)?_c('div',{staticClass:"pi-field"},[_c('label',[_vm._v("Choose a pickup location")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.locationIndex),expression:"locationIndex"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.locationIndex=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.zones[_vm.zoneIndex].locations),function(x,i){return _c('option',{key:i,domProps:{"value":i}},[_vm._v(_vm._s(x.name))])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pi-action d-flex justify-space-between"},[_c('a',{staticClass:"button cta small block secondary",on:{"click":function($event){_vm.venueShow = false}}},[_vm._v("BACK")]),_vm._v(" "),_c('a',{staticClass:"button cta small block",on:{"click":_vm.updatePickup}},[_vm._v("SEND")])])]):_c('div',[_c('div',{staticClass:"lr-head d-flex justify-space-between align-center"},[_c('div',[_vm._v("Lyft Services")]),_vm._v(" "),_c('div',{staticClass:"lrh-price"},[_c('span',[_vm._v("Original Price")]),_vm._v(" "),_c('b',[_vm._v("$"+_vm._s(_vm.lyft.originalFare))])])]),_vm._v(" "),_c('div',{staticClass:"lr-sub-head"},[_c('span',[_vm._v("Original Service:")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.lyft.originalService))])]),_vm._v(" "),_c('div',{staticClass:"lyft-service-box"},_vm._l((_vm.services),function(service,i){return _c('div',{key:i,class:['lyft-service d-flex justify-space-between align-start', {failed: service.failed, active:_vm.selected && _vm.selected.ride_type === service.ride_type}],on:{"click":function($event){return _vm.select(service, i)}}},[_c('div',{staticClass:"l-img"},[_c('img',{attrs:{"src":service.custom_image}})]),_vm._v(" "),_c('div',{staticClass:"l-name"},[_c('div',{staticClass:"l-display-name"},[_vm._v(_vm._s(service.display_name))]),_vm._v(" "),_c('div',{staticClass:"l-service-code"},[_vm._v(_vm._s(service.ride_type))]),_vm._v(" "),(service.pickup_estimate && service.pickup_estimate.duration)?_c('div',{staticClass:"l-eta"},[_c('span',[_vm._v("ETA in ")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.getETA(service.pickup_estimate)))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"l-price"},[_c('small',[_vm._v("Up to")]),_vm._v(" "),_c('span',{class:_vm.priceDiffClass(_vm.lyft.originalFare, service.estimated_cost_cents_max)},[_vm._v("$"+_vm._s(_vm.price(service.estimated_cost_cents_max)))])])])}),0),_vm._v(" "),_c('div',{staticClass:"pi-action d-flex justify-space-between"},[_c('a',{staticClass:"button cta small block secondary",on:{"click":function($event){_vm.show = false}}},[_vm._v("CANCEL")]),_vm._v(" "),_c('a',{staticClass:"button cta small block",on:{"click":_vm.checkVenue}},[_vm._v("SEND")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dispatch-home"},[_c('div',{class:{'rsvp-panel-container':true, 'shrink':_vm.isShrink}},[_c('div',{staticClass:"header"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabIndex === 0),expression:"tabIndex === 0"}],staticClass:"header-filter"},[_c('div',{staticClass:"search"},[_c('reservation-search')],1),_vm._v(" "),_c('div',{staticClass:"filter-group"},[_c('div',{staticClass:"filter"},[_c('reservation-filter',{attrs:{"addCustom":"true"}})],1),_vm._v(" "),_c('div',{class:{'more-filter-trigger':true, 'active':_vm.showFilter},on:{"click":_vm.showCustomFilter}},[_c('div',[_c('i',{staticClass:"fas fa-filter"}),_vm._v(" "),(!_vm.isShrink)?_c('span',[_vm._v("Filter")]):_vm._e()])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('dispatch-more-filter',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilter),expression:"showFilter"}],staticClass:"more-filter",attrs:{"shrink":_vm.isShrink},on:{"close":function($event){_vm.showFilter = false}}})],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabIndex === 3),expression:"tabIndex === 3"}]},[_c('runs-table-filter',{ref:"runsTableFilter",attrs:{"shrink":_vm.isShrink}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:([1, 2].indexOf(_vm.tabIndex) > -1),expression:"[1, 2].indexOf(tabIndex) > -1"}]},[_c('routing-header')],1)]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabIndex === 0),expression:"tabIndex === 0"}],staticClass:"expand-button",on:{"click":_vm.expand}},[_c('i',{staticClass:"fas fa-chevron-right fa-lg"})]),_vm._v(" "),(!_vm.isShrink)?_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabIndex === 0),expression:"tabIndex === 0"}],staticClass:"shrink-button",on:{"click":_vm.shrinkTable}},[_c('i',{staticClass:"fas fa-chevron-left fa-lg"})]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isShrink),expression:"!isShrink"}],staticClass:"tabs",class:_vm.tabIndex != 0 ? 'hide-top' : ''},[_c('div',{class:['tab', {selected: _vm.tabIndex === 0 }],on:{"click":function($event){_vm.tabIndex = 0}}},[_vm._v("FOR DISPATCH")]),_vm._v(" "),_c('div',{class:['tab', {selected: _vm.tabIndex === 3 }],on:{"click":function($event){_vm.tabIndex = 3}}},[_vm._v("RUNS")]),_vm._v(" "),_c('div',{class:['tab', {selected: _vm.tabIndex === 1 }],on:{"click":function($event){_vm.tabIndex = 1}}},[_vm._v("ROUTED PACKAGES")]),_vm._v(" "),_c('div',{class:['tab', {selected: _vm.tabIndex === 2 }],on:{"click":function($event){_vm.tabIndex = 2}}},[_vm._v("UNPACKAGED RESERVATIONS")]),_vm._v(" "),_c('div',{staticClass:"total"},[_vm._v("\n        Total: "+_vm._s(_vm.total())+" |\n        "),(!!_vm.lastSync)?_c('span',[_vm._v("Updated: "),_c('b',[_vm._v(_vm._s(_vm.lastSync))])]):_vm._e()])]),_vm._v(" "),_c('div',{class:['rsvp-panel', _vm.tabIndex != 0 ? 'hide-top' : '']},[_c('div',{class:['tab-content', {show: _vm.tabIndex === 0 }]},[_c('reservations-table',{attrs:{"isShort":true,"shrink":_vm.isShrink}})],1),_vm._v(" "),_c('div',{class:['tab-content', {show: _vm.tabIndex === 3 }]},[_c('runs-tables',{ref:"runsTable"})],1),_vm._v(" "),_c('div',{class:['tab-content with-control', {show: _vm.tabIndex === 1 }],on:{"scroll":_vm.onScrollPackage}},[_c('routing-packages-table',{ref:"routingPkgTable",attrs:{"forDispatch":true,"isMobile":_vm.isMobile}}),_vm._v(" "),_c('routing-packages-control',{staticClass:"tab-control",attrs:{"forDispatch":true}})],1),_vm._v(" "),_c('div',{class:['tab-content', {show: _vm.tabIndex === 2 }],on:{"scroll":_vm.onScrollUnpackage}},[_c('routing-reservations-table',{ref:"routingRsvpTable",attrs:{"isMobile":_vm.isMobile}})],1)])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabIndex !== 2),expression:"tabIndex !== 2"}],class:['driver-toggle', {on:!_vm.showDriverPanel, hide:_vm.showFilter}],attrs:{"href":"javascript:;"},on:{"click":_vm.toggleDriverPanel}},[_c('i',{class:['fa-lg fa-fw', {'far fa-times-circle':_vm.showDriverPanel,'fas fa-car':!_vm.showDriverPanel}]})]),_vm._v(" "),_c('a',{class:{'close-map-button':_vm.rsvpInMap.id},attrs:{"href":"javascript:;"},on:{"click":_vm.hideMap}},[_c('i',{staticClass:"far fa-times-circle"})]),_vm._v(" "),_c('div',{class:['available-drivers', {hide: !_vm.showDriverPanel || _vm.tabIndex === 2}]},[_c('transition',{attrs:{"name":"grown-in"}},[_c('driver-service-filter',{directives:[{name:"show",rawName:"v-show",value:(_vm.showServiceFilter),expression:"showServiceFilter"}]})],1),_vm._v(" "),_c('available-drivers',{ref:"availableDrivers",attrs:{"tabIndex":_vm.tabIndex}})],1),_vm._v(" "),_c('a',{class:['availability-toggle', {
    open: _vm.availability.show, 
    hide: (_vm.tabIndex === 0 && (_vm.rsvp === null || _vm.rsvp.driver !== null)) || _vm.tabIndex === 1 || _vm.tabIndex === 2 || !_vm.availability.showToggle || _vm.showDriverPanel || (_vm.tabIndex === 3 && !_vm.runs.selected)}],attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.availability.show = !_vm.availability.show}}},[(_vm.rsvpAvailabilityLoading)?_c('i',{staticClass:"fas fa-spinner fa-spin fa-lg fa-fw"}):_c('i',{staticClass:"far fa-calendar-alt fa-lg fa-fw"})]),_vm._v(" "),_c('a',{class:['coverage-toggle', {hide: _vm.showDriverPanel || _vm.tabIndex === 1 || _vm.tabIndex === 2}],attrs:{"href":"/#/coverage"}},[_c('i',{staticClass:"fas fa-map-marked-alt fa-lg"})]),_vm._v(" "),(_vm.tabIndex === 0)?_c('div',{class:{'map':true, 'shrink':_vm.isShrink, 'showInMobile':_vm.rsvpInMap.id}},[_c('dispatch-map2',{ref:"hereMap"})],1):_vm._e(),_vm._v(" "),_c('dispatch-modal'),_vm._v(" "),_c('dispatch-notification'),_vm._v(" "),_c('dispatch-schedule'),_vm._v(" "),([0, 3].indexOf(_vm.tabIndex) === -1)?_c('div',{staticClass:"toggle-mobile",on:{"click":function($event){_vm.showMapMobile = !_vm.showMapMobile}}},[(!_vm.showMapMobile)?_c('span',[_vm._v("Show Map "),_c('i',{staticClass:"fa fa-chevron-up"})]):_c('span',[_vm._v("Hide Map "),_c('i',{staticClass:"fa fa-chevron-down"})])]):_vm._e(),_vm._v(" "),([0, 3].indexOf(_vm.tabIndex) === -1)?_c('div',{class:['right-panel', _vm.showMapMobile ? 'showMapBox' : '']},[_c('div',{staticClass:"map"},[_c('routing-map2')],1),_vm._v(" "),_c('div',{staticClass:"dropzone-container"},[_c('routing-drop-zone')],1)]):_vm._e(),_vm._v(" "),(_vm.tabIndex === 3)?_c('div',{staticClass:"right-panel"},[_c('div',{staticClass:"map"},[_c('runs-map',{ref:"hereMap"})],1),_vm._v(" "),_c('div',{staticClass:"dropzone-container"},[_c('runs-dropzone')],1)]):_vm._e(),_vm._v(" "),_c('div',{class:['filter-available-drivers', {hide:!_vm.availability.show || (_vm.tabIndex === 0 && _vm.rsvp === null) || (_vm.tabIndex === 3 && !_vm.runs.selected)}]},[_c('div',{staticClass:"d-flex justify-space-between align-stretch"},[_c('div',{staticClass:"message"},[_vm._v("Available drivers for this trip")]),_vm._v(" "),_c('div',{staticClass:"close-filter",on:{"click":function($event){_vm.availability.show = false}}},[_c('i',{staticClass:"fa-lg fa-fw far fa-times-circle"})])]),_vm._v(" "),_c('rsvp-available-drivers')],1),_vm._v(" "),_c('routing-modal'),_vm._v(" "),_c('ready-to-go-modal'),_vm._v(" "),_c('notes-modal'),_vm._v(" "),_c('pickup-date-modal'),_vm._v(" "),_c('lyft')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchMapDetails_vue__ = __webpack_require__(503);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d1ba457_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchMapDetails_vue__ = __webpack_require__(1409);
function injectStyle (ssrContext) {
  __webpack_require__(1399)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d1ba457"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchMapDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d1ba457_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchMapDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1400);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("36bc79be", content, true, {});

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.map[data-v-4d1ba457] {\n  position: fixed;\n  top: 0;\n  left: 500px;\n  z-index: 1;\n  height: 100%;\n  width: calc(100% - 500px);\n}\n.reservation-panel[data-v-4d1ba457] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  background-color: #F4F8F9;\n  width: 500px;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  overflow-x: auto;\n}\n.reservation-panel.hide[data-v-4d1ba457] {\n    left: -500px;\n}\n.no-rsvp[data-v-4d1ba457] {\n  position: relative;\n  text-align: center;\n  color: #777;\n  height: 100%;\n  width: 100%;\n}\n.no-rsvp .no-rsvp-content[data-v-4d1ba457] {\n    position: absolute;\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n    padding: 20px;\n}\n.no-rsvp .icon[data-v-4d1ba457] {\n    color: #F25E0D;\n}\n.no-rsvp .title[data-v-4d1ba457] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.no-rsvp .content[data-v-4d1ba457] {\n    font-weight: 700;\n    margin-top: 5px;\n    font-size: 16px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/DispatchMapDetails.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,YAAY;EACZ,WAAW;EACX,aAAa;EACb,0BAA0B;CAC3B;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,iDAAiD;UACzC,yCAAyC;EACjD,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;CAClB;AACD;IACI,aAAa;CAChB;AACD;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;CACb;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,oCAAoC;YAC5B,4BAA4B;IACpC,cAAc;CACjB;AACD;IACI,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;CACnB","file":"DispatchMapDetails.vue","sourcesContent":["\n.map[data-v-4d1ba457] {\n  position: fixed;\n  top: 0;\n  left: 500px;\n  z-index: 1;\n  height: 100%;\n  width: calc(100% - 500px);\n}\n.reservation-panel[data-v-4d1ba457] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  background-color: #F4F8F9;\n  width: 500px;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  overflow-x: auto;\n}\n.reservation-panel.hide[data-v-4d1ba457] {\n    left: -500px;\n}\n.no-rsvp[data-v-4d1ba457] {\n  position: relative;\n  text-align: center;\n  color: #777;\n  height: 100%;\n  width: 100%;\n}\n.no-rsvp .no-rsvp-content[data-v-4d1ba457] {\n    position: absolute;\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n    padding: 20px;\n}\n.no-rsvp .icon[data-v-4d1ba457] {\n    color: #F25E0D;\n}\n.no-rsvp .title[data-v-4d1ba457] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.no-rsvp .content[data-v-4d1ba457] {\n    font-weight: 700;\n    margin-top: 5px;\n    font-size: 16px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationDetails_vue__ = __webpack_require__(504);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3250bd8e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationDetails_vue__ = __webpack_require__(1404);
function injectStyle (ssrContext) {
  __webpack_require__(1402)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3250bd8e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3250bd8e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1403);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5fa357ee", content, true, {});

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.status[data-v-3250bd8e] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-3250bd8e], .status.completed[data-v-3250bd8e] {\n    background: #26D97A;\n}\n.status.canceled[data-v-3250bd8e], .status.cancelled[data-v-3250bd8e], .status.failed[data-v-3250bd8e] {\n    background: #bbb;\n}\n.status.upcoming[data-v-3250bd8e] {\n    background: #f38d56;\n}\n.status.onboard[data-v-3250bd8e] {\n    background: #dc3168;\n}\n.status.ready[data-v-3250bd8e] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-3250bd8e], .status.requires_dispatch[data-v-3250bd8e] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-3250bd8e] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-3250bd8e] {\n    background: #5662f3;\n}\n.flight-status[data-v-3250bd8e] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-3250bd8e] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-3250bd8e] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-3250bd8e] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-3250bd8e] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-3250bd8e] {\n    background-color: #f35656;\n}\n.service-type[data-v-3250bd8e] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-3250bd8e] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-3250bd8e] {\n    background: #26D97A;\n}\n.service-type.black[data-v-3250bd8e] {\n    background: #777;\n}\n.service-type.suv[data-v-3250bd8e] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-3250bd8e] {\n    background: #6dabc3;\n}\n.license-type[data-v-3250bd8e] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-3250bd8e] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-3250bd8e] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-3250bd8e] {\n    background-color: #de6c2a;\n}\n.rsvp[data-v-3250bd8e] {\n  padding: 0 20px 20px;\n}\n.rsvp .rsvp-id[data-v-3250bd8e] {\n    font-size: 22px;\n    font-weight: 700;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n.rsvp .rsvp-id a[data-v-3250bd8e] {\n      color: #3F2975;\n}\n.label-value[data-v-3250bd8e] {\n  margin-top: 10px;\n}\n.label-value .label[data-v-3250bd8e] {\n    font-size: 12px;\n    font-weight: 700;\n    margin-bottom: 0;\n    color: #8DA0A9;\n}\n.label-value .value[data-v-3250bd8e] {\n    color: #333;\n}\n.label-value .value.service-type[data-v-3250bd8e] {\n      color: #fff;\n}\n.label-value .value.status[data-v-3250bd8e] {\n      color: #fff;\n      font-size: 16px;\n}\n.label-value .value .info[data-v-3250bd8e] {\n      font-weight: 700;\n      margin-top: 5px;\n      margin-bottom: 10px;\n      font-size: 14px;\n}\na[data-v-3250bd8e] {\n  font-weight: 700;\n}\n.divider[data-v-3250bd8e] {\n  display: block;\n  width: 350px;\n  margin: 20px auto;\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n}\na.payment-breakdown-button[data-v-3250bd8e] {\n  font-size: 10px;\n  display: block;\n}\n.modal-container[data-v-3250bd8e] {\n  position: fixed;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 999;\n  background-color: rgba(0, 0, 0, 0.4);\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.modal-container.show[data-v-3250bd8e] {\n    opacity: 1;\n    top: 0;\n}\n.modal-container .modal[data-v-3250bd8e] {\n    display: table;\n    width: 100%;\n    height: 100%;\n}\n.modal-container .modal-content[data-v-3250bd8e] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.payment-breakdown[data-v-3250bd8e] {\n  width: 300px;\n  background-color: #fff;\n  margin: 0 auto;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  position: relative;\n}\n.payment-breakdown .close[data-v-3250bd8e] {\n    display: block;\n    position: absolute;\n    color: #fff;\n    top: 0;\n    right: 0;\n    padding: 10px 10px;\n}\n.payment-breakdown .title[data-v-3250bd8e] {\n    background-color: #333;\n    color: #fff;\n    font-weight: 700;\n    text-align: center;\n    padding: 10px 5px;\n}\n.payment-breakdown .breakdown[data-v-3250bd8e] {\n    padding: 5px 15px;\n    font-size: 14px;\n    text-transform: uppercase;\n}\n.payment-breakdown .breakdown.total[data-v-3250bd8e] {\n      font-size: 16px;\n      padding: 10px 0 10px;\n      margin: 0 15px;\n      border-top: 1px solid rgba(0, 0, 0, 0.15);\n}\n.payment-breakdown .label[data-v-3250bd8e] {\n    text-align: left;\n    color: #555;\n}\n.payment-breakdown .value[data-v-3250bd8e] {\n    text-align: right;\n    font-weight: 700;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/ReservationDetails.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;CAC3B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,qBAAqB;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;CACvB;AACD;MACM,eAAe;CACpB;AACD;EACE,iBAAiB;CAClB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,YAAY;CACf;AACD;MACM,YAAY;CACjB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;MACM,iBAAiB;MACjB,gBAAgB;MAChB,oBAAoB;MACpB,gBAAgB;CACrB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,yCAAyC;CAC1C;AACD;EACE,gBAAgB;EAChB,eAAe;CAChB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,WAAW;IACX,OAAO;CACV;AACD;IACI,eAAe;IACf,YAAY;IACZ,aAAa;CAChB;AACD;IACI,oBAAoB;IACpB,uBAAuB;CAC1B;AACD;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,iDAAiD;UACzC,yCAAyC;EACjD,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,OAAO;IACP,SAAS;IACT,mBAAmB;CACtB;AACD;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;CACrB;AACD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,gBAAgB;MAChB,qBAAqB;MACrB,eAAe;MACf,0CAA0C;CAC/C;AACD;IACI,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,kBAAkB;IAClB,iBAAiB;CACpB","file":"ReservationDetails.vue","sourcesContent":["\n.status[data-v-3250bd8e] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-3250bd8e], .status.completed[data-v-3250bd8e] {\n    background: #26D97A;\n}\n.status.canceled[data-v-3250bd8e], .status.cancelled[data-v-3250bd8e], .status.failed[data-v-3250bd8e] {\n    background: #bbb;\n}\n.status.upcoming[data-v-3250bd8e] {\n    background: #f38d56;\n}\n.status.onboard[data-v-3250bd8e] {\n    background: #dc3168;\n}\n.status.ready[data-v-3250bd8e] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-3250bd8e], .status.requires_dispatch[data-v-3250bd8e] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-3250bd8e] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-3250bd8e] {\n    background: #5662f3;\n}\n.flight-status[data-v-3250bd8e] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-3250bd8e] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-3250bd8e] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-3250bd8e] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-3250bd8e] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-3250bd8e] {\n    background-color: #f35656;\n}\n.service-type[data-v-3250bd8e] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-3250bd8e] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-3250bd8e] {\n    background: #26D97A;\n}\n.service-type.black[data-v-3250bd8e] {\n    background: #777;\n}\n.service-type.suv[data-v-3250bd8e] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-3250bd8e] {\n    background: #6dabc3;\n}\n.license-type[data-v-3250bd8e] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-3250bd8e] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-3250bd8e] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-3250bd8e] {\n    background-color: #de6c2a;\n}\n.rsvp[data-v-3250bd8e] {\n  padding: 0 20px 20px;\n}\n.rsvp .rsvp-id[data-v-3250bd8e] {\n    font-size: 22px;\n    font-weight: 700;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n.rsvp .rsvp-id a[data-v-3250bd8e] {\n      color: #3F2975;\n}\n.label-value[data-v-3250bd8e] {\n  margin-top: 10px;\n}\n.label-value .label[data-v-3250bd8e] {\n    font-size: 12px;\n    font-weight: 700;\n    margin-bottom: 0;\n    color: #8DA0A9;\n}\n.label-value .value[data-v-3250bd8e] {\n    color: #333;\n}\n.label-value .value.service-type[data-v-3250bd8e] {\n      color: #fff;\n}\n.label-value .value.status[data-v-3250bd8e] {\n      color: #fff;\n      font-size: 16px;\n}\n.label-value .value .info[data-v-3250bd8e] {\n      font-weight: 700;\n      margin-top: 5px;\n      margin-bottom: 10px;\n      font-size: 14px;\n}\na[data-v-3250bd8e] {\n  font-weight: 700;\n}\n.divider[data-v-3250bd8e] {\n  display: block;\n  width: 350px;\n  margin: 20px auto;\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n}\na.payment-breakdown-button[data-v-3250bd8e] {\n  font-size: 10px;\n  display: block;\n}\n.modal-container[data-v-3250bd8e] {\n  position: fixed;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 999;\n  background-color: rgba(0, 0, 0, 0.4);\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.modal-container.show[data-v-3250bd8e] {\n    opacity: 1;\n    top: 0;\n}\n.modal-container .modal[data-v-3250bd8e] {\n    display: table;\n    width: 100%;\n    height: 100%;\n}\n.modal-container .modal-content[data-v-3250bd8e] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.payment-breakdown[data-v-3250bd8e] {\n  width: 300px;\n  background-color: #fff;\n  margin: 0 auto;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  position: relative;\n}\n.payment-breakdown .close[data-v-3250bd8e] {\n    display: block;\n    position: absolute;\n    color: #fff;\n    top: 0;\n    right: 0;\n    padding: 10px 10px;\n}\n.payment-breakdown .title[data-v-3250bd8e] {\n    background-color: #333;\n    color: #fff;\n    font-weight: 700;\n    text-align: center;\n    padding: 10px 5px;\n}\n.payment-breakdown .breakdown[data-v-3250bd8e] {\n    padding: 5px 15px;\n    font-size: 14px;\n    text-transform: uppercase;\n}\n.payment-breakdown .breakdown.total[data-v-3250bd8e] {\n      font-size: 16px;\n      padding: 10px 0 10px;\n      margin: 0 15px;\n      border-top: 1px solid rgba(0, 0, 0, 0.15);\n}\n.payment-breakdown .label[data-v-3250bd8e] {\n    text-align: left;\n    color: #555;\n}\n.payment-breakdown .value[data-v-3250bd8e] {\n    text-align: right;\n    font-weight: 700;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rsvp !== null)?_c('div',{staticClass:"rsvp"},[_c('div',{staticClass:"rsvp-id"},[_c('a',{attrs:{"href":'/#/reservation/' + _vm.rsvp.id,"target":"_blank"}},[_vm._v("\n      "+_vm._s(_vm.$t('dispatch.mapDetails.reservation'))+" "+_vm._s(_vm.rsvp.id)+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.pickup')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.getAddress(_vm.rsvp.pickup)))])]),_vm._v(" "),_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.dropoff')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.getAddress(_vm.rsvp.dropoff)))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.pickupTime')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.rsvp.pickupTime))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.flight')))]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.rsvp.flight !== null)?_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.showFlightInfo}},[_vm._v(_vm._s(_vm.rsvp.flight))]):_c('span',[_vm._v("N/A")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-4 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.paxLuggage')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.rsvp.pax)+"/"+_vm._s(_vm.rsvp.luggage))])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.serviceType')))]),_vm._v(" "),_c('div',{class:'value service-type ' + _vm.rsvp.serviceClass},[_vm._v(_vm._s(_vm.rsvp.serviceLabel))])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.status')))]),_vm._v(" "),_c('div',{class:'value status ' + _vm.rsvp.statusClass},[_vm._v(_vm._s(_vm.rsvp.status))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-4 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v("FARE AMOUNT")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("$"+_vm._s(_vm.rsvp.fare.toFixed(2)))])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v("DRIVER PAYMENT")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("$"+_vm._s(_vm.getDriverPayment(_vm.rsvp.driverPayment).toFixed(2)))]),_vm._v(" "),_c('a',{staticClass:"payment-breakdown-button",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.showBreakdown(true)}}},[_vm._v("See Payment Breakdown")])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v("PICKUP TYPE")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.rsvp.pickup.geofenceType === 'airport')?_c('span',[_vm._v("\n            "+_vm._s(_vm.rsvp.meetAndGreet ? 'Meet & Greet' : 'Curbside')+"\n          ")]):_c('span',[_vm._v("N/A")])])])])]),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.paxName')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":'/#/consumer/' + _vm.rsvp.customer.id,"target":"_blank"}},[_vm._v("\n        "+_vm._s(_vm.rsvp.customer.firstName)+" "+_vm._s(_vm.rsvp.customer.lastName)+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-4 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.paxPhone')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.callPhone(_vm.rsvp.customer)}}},[_vm._v(_vm._s(_vm.rsvp.customer.phone))])])])]),_vm._v(" "),_c('div',{staticClass:"small-8 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.paxEmail')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":"javascript:;","href":'mailto:' + _vm.rsvp.customer.email}},[_vm._v("\n            "+_vm._s(_vm.rsvp.customer.email)+"\n          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.paxNote')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("N/A")])]),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),(_vm.rsvp.guest !== null)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.guestName')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.rsvp.guest.firstName)+" "+_vm._s(_vm.rsvp.guest.lastName))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.guestPhone')))]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.rsvp.guest.phone !== '')?_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.callPhone(_vm.rsvp.guest)}}},[_vm._v(_vm._s(_vm.rsvp.guest.phone))]):_c('span',[_vm._v("N/A")])])])])])]):_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.guestInfo')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.guestNone')))])])]),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),(_vm.rsvp.driver !== null)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.driverName')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":"javascript:;","href":'/#/provider/' + _vm.rsvp.driver.id,"target":"_blank"}},[_vm._v("\n              "+_vm._s(_vm.rsvp.driver.firstName)+" "+_vm._s(_vm.rsvp.driver.lastName)+"\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.driverEmail')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":"javascript:;","href":'mailto:' + _vm.rsvp.driver.email}},[_vm._v("\n              "+_vm._s(_vm.rsvp.driver.email)+"\n            ")])])])])])]):_c('div',[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.driverInfo')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.driverNone')))])])])]),_vm._v(" "),_c('div',{class:{ 'modal-container': true, show: _vm.showPaymentBreakdown },on:{"click":function($event){return _vm.showBreakdown(false)}}},[_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"payment-breakdown",on:{"click":function($event){$event.stopPropagation();}}},[_c('a',{staticClass:"close",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.showBreakdown(false)}}},[_c('i',{staticClass:"far fa-times-circle fa-fw"})]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("PAYMENT BREAKDOWN")]),_vm._v(" "),_c('div',{staticClass:"row breakdown"},[_c('div',{staticClass:"small-6 columns label"},[_vm._v("Fare Amount:")]),_vm._v(" "),_c('div',{staticClass:"small-6 columns value"},[_vm._v("$"+_vm._s(_vm.rsvp.driverPayment.base.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"row breakdown"},[_c('div',{staticClass:"small-6 columns label"},[_vm._v("Bonus:")]),_vm._v(" "),_c('div',{staticClass:"small-6 columns value"},[_vm._v("$"+_vm._s(_vm.rsvp.driverPayment.bonus.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"row breakdown"},[_c('div',{staticClass:"small-6 columns label"},[_vm._v("Tip:")]),_vm._v(" "),_c('div',{staticClass:"small-6 columns value"},[_vm._v("$"+_vm._s(_vm.rsvp.driverPayment.tip.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"row breakdown"},[_c('div',{staticClass:"small-6 columns label"},[_vm._v("Pickup Fee:")]),_vm._v(" "),_c('div',{staticClass:"small-6 columns value"},[_vm._v("$"+_vm._s(_vm.rsvp.driverPayment.pickupFee.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"row breakdown total"},[_c('div',{staticClass:"small-6 columns label"},[_vm._v("Total:")]),_vm._v(" "),_c('div',{staticClass:"small-6 columns value"},[_vm._v("$"+_vm._s(_vm.getDriverPayment(_vm.rsvp.driverPayment).toFixed(2)))])])])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackageDetails_vue__ = __webpack_require__(505);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_097081a4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackageDetails_vue__ = __webpack_require__(1408);
function injectStyle (ssrContext) {
  __webpack_require__(1406)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-097081a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackageDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_097081a4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackageDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1407);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4f5283a9", content, true, {});

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.status[data-v-097081a4] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-097081a4], .status.completed[data-v-097081a4] {\n    background: #26D97A;\n}\n.status.canceled[data-v-097081a4], .status.cancelled[data-v-097081a4], .status.failed[data-v-097081a4] {\n    background: #bbb;\n}\n.status.upcoming[data-v-097081a4] {\n    background: #f38d56;\n}\n.status.onboard[data-v-097081a4] {\n    background: #dc3168;\n}\n.status.ready[data-v-097081a4] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-097081a4], .status.requires_dispatch[data-v-097081a4] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-097081a4] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-097081a4] {\n    background: #5662f3;\n}\n.flight-status[data-v-097081a4] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-097081a4] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-097081a4] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-097081a4] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-097081a4] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-097081a4] {\n    background-color: #f35656;\n}\n.service-type[data-v-097081a4] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-097081a4] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-097081a4] {\n    background: #26D97A;\n}\n.service-type.black[data-v-097081a4] {\n    background: #777;\n}\n.service-type.suv[data-v-097081a4] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-097081a4] {\n    background: #6dabc3;\n}\n.license-type[data-v-097081a4] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-097081a4] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-097081a4] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-097081a4] {\n    background-color: #de6c2a;\n}\n.package[data-v-097081a4] {\n  padding: 0 20px 20px;\n}\n.package .package-id[data-v-097081a4] {\n    font-size: 22px;\n    font-weight: 700;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n.package .package-id a[data-v-097081a4] {\n      color: #3F2975;\n}\n.package .package-id a .fa-cube[data-v-097081a4] {\n        color: #26D97A;\n}\n.label-value[data-v-097081a4] {\n  margin-top: 10px;\n}\n.label-value .label[data-v-097081a4] {\n    font-size: 12px;\n    font-weight: 700;\n    margin-bottom: 0;\n    color: #8DA0A9;\n}\n.label-value .value[data-v-097081a4] {\n    color: #333;\n}\n.label-value .value.service-type[data-v-097081a4] {\n      color: #fff;\n}\n.label-value .value.status[data-v-097081a4] {\n      color: #fff;\n      font-size: 16px;\n}\n.label-value .value .info[data-v-097081a4] {\n      font-weight: 700;\n      margin-top: 5px;\n      margin-bottom: 10px;\n      font-size: 14px;\n}\na[data-v-097081a4] {\n  font-weight: 700;\n}\n.divider[data-v-097081a4] {\n  display: block;\n  width: 350px;\n  margin: 20px auto;\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n}\n.button.unassign[data-v-097081a4] {\n  margin-top: 10px;\n}\n.stops .stop[data-v-097081a4] {\n  padding: 10px;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  background-color: #fff;\n  margin-bottom: 5px;\n  border-radius: 3px;\n  border-top: 3px solid #CA3538;\n  position: relative;\n}\n.stops .stop.pickup[data-v-097081a4] {\n    border-top: 3px solid #2EE47D;\n}\n.stops .title[data-v-097081a4] {\n  font-size: 12px;\n  font-weight: 700;\n  margin-bottom: 10px;\n  color: #8DA0A9;\n}\n.stops .name[data-v-097081a4] {\n  font-size: 14px;\n  margin-bottom: 3px;\n}\n.stops .name i[data-v-097081a4] {\n    display: inline-block;\n    margin-right: 2px;\n    color: #CA3538;\n}\n.stops .name i.pickup[data-v-097081a4] {\n      color: #2EE47D;\n}\n.stops .time[data-v-097081a4] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #555;\n}\n.stops .address[data-v-097081a4] {\n  margin-top: 5px;\n  font-size: 16px;\n  font-weight: 700;\n  color: #555;\n}\n.stops .misc[data-v-097081a4] {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 14px;\n  color: #555;\n  text-align: right;\n}\n.stops .misc .pax-luggage[data-v-097081a4] {\n    color: #777;\n    font-size: 12px;\n    font-weight: 700;\n}\n.stops .misc .pax-luggage *[data-v-097081a4] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.stops .misc .pax-luggage i[data-v-097081a4] {\n      margin-left: 5px;\n      display: inline-block;\n}\n.stops .misc .pax-luggage span[data-v-097081a4] {\n      margin-left: 2px;\n}\na.payment-breakdown-button[data-v-097081a4] {\n  font-size: 10px;\n  display: block;\n}\n.modal-container[data-v-097081a4] {\n  position: fixed;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 999;\n  background-color: rgba(0, 0, 0, 0.4);\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.modal-container.show[data-v-097081a4] {\n    opacity: 1;\n    top: 0;\n}\n.modal-container .modal[data-v-097081a4] {\n    display: table;\n    width: 100%;\n    height: 100%;\n}\n.modal-container .modal-content[data-v-097081a4] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.payment-breakdown[data-v-097081a4] {\n  width: 300px;\n  background-color: #fff;\n  margin: 0 auto;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  position: relative;\n}\n.payment-breakdown .close[data-v-097081a4] {\n    display: block;\n    position: absolute;\n    color: #fff;\n    top: 0;\n    right: 0;\n    padding: 10px 10px;\n}\n.payment-breakdown .title[data-v-097081a4] {\n    background-color: #333;\n    color: #fff;\n    font-weight: 700;\n    text-align: center;\n    padding: 10px 5px;\n}\n.payment-breakdown .breakdown[data-v-097081a4] {\n    padding: 5px 15px;\n    font-size: 14px;\n    text-transform: uppercase;\n}\n.payment-breakdown .breakdown.total[data-v-097081a4] {\n      font-size: 16px;\n      padding: 10px 0 10px;\n      margin: 0 15px;\n      border-top: 1px solid rgba(0, 0, 0, 0.15);\n}\n.payment-breakdown .label[data-v-097081a4] {\n    text-align: left;\n    color: #555;\n}\n.payment-breakdown .value[data-v-097081a4] {\n    text-align: right;\n    font-weight: 700;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/PackageDetails.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;CAC3B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,qBAAqB;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;CACvB;AACD;MACM,eAAe;CACpB;AACD;QACQ,eAAe;CACtB;AACD;EACE,iBAAiB;CAClB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,YAAY;CACf;AACD;MACM,YAAY;CACjB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;MACM,iBAAiB;MACjB,gBAAgB;MAChB,oBAAoB;MACpB,gBAAgB;CACrB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,yCAAyC;CAC1C;AACD;EACE,iBAAiB;CAClB;AACD;EACE,cAAc;EACd,qCAAqC;EACrC,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;CACpB;AACD;IACI,8BAA8B;CACjC;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;CAChB;AACD;EACE,gBAAgB;EAChB,mBAAmB;CACpB;AACD;IACI,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;CAClB;AACD;MACM,eAAe;CACpB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;CACb;AACD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;CACnB;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;CACpB;AACD;MACM,sBAAsB;MACtB,uBAAuB;CAC5B;AACD;MACM,iBAAiB;MACjB,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;EACE,gBAAgB;EAChB,eAAe;CAChB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,WAAW;IACX,OAAO;CACV;AACD;IACI,eAAe;IACf,YAAY;IACZ,aAAa;CAChB;AACD;IACI,oBAAoB;IACpB,uBAAuB;CAC1B;AACD;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,iDAAiD;UACzC,yCAAyC;EACjD,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,OAAO;IACP,SAAS;IACT,mBAAmB;CACtB;AACD;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;CACrB;AACD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,gBAAgB;MAChB,qBAAqB;MACrB,eAAe;MACf,0CAA0C;CAC/C;AACD;IACI,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,kBAAkB;IAClB,iBAAiB;CACpB","file":"PackageDetails.vue","sourcesContent":["\n.status[data-v-097081a4] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-097081a4], .status.completed[data-v-097081a4] {\n    background: #26D97A;\n}\n.status.canceled[data-v-097081a4], .status.cancelled[data-v-097081a4], .status.failed[data-v-097081a4] {\n    background: #bbb;\n}\n.status.upcoming[data-v-097081a4] {\n    background: #f38d56;\n}\n.status.onboard[data-v-097081a4] {\n    background: #dc3168;\n}\n.status.ready[data-v-097081a4] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-097081a4], .status.requires_dispatch[data-v-097081a4] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-097081a4] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-097081a4] {\n    background: #5662f3;\n}\n.flight-status[data-v-097081a4] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-097081a4] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-097081a4] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-097081a4] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-097081a4] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-097081a4] {\n    background-color: #f35656;\n}\n.service-type[data-v-097081a4] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-097081a4] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-097081a4] {\n    background: #26D97A;\n}\n.service-type.black[data-v-097081a4] {\n    background: #777;\n}\n.service-type.suv[data-v-097081a4] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-097081a4] {\n    background: #6dabc3;\n}\n.license-type[data-v-097081a4] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-097081a4] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-097081a4] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-097081a4] {\n    background-color: #de6c2a;\n}\n.package[data-v-097081a4] {\n  padding: 0 20px 20px;\n}\n.package .package-id[data-v-097081a4] {\n    font-size: 22px;\n    font-weight: 700;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n.package .package-id a[data-v-097081a4] {\n      color: #3F2975;\n}\n.package .package-id a .fa-cube[data-v-097081a4] {\n        color: #26D97A;\n}\n.label-value[data-v-097081a4] {\n  margin-top: 10px;\n}\n.label-value .label[data-v-097081a4] {\n    font-size: 12px;\n    font-weight: 700;\n    margin-bottom: 0;\n    color: #8DA0A9;\n}\n.label-value .value[data-v-097081a4] {\n    color: #333;\n}\n.label-value .value.service-type[data-v-097081a4] {\n      color: #fff;\n}\n.label-value .value.status[data-v-097081a4] {\n      color: #fff;\n      font-size: 16px;\n}\n.label-value .value .info[data-v-097081a4] {\n      font-weight: 700;\n      margin-top: 5px;\n      margin-bottom: 10px;\n      font-size: 14px;\n}\na[data-v-097081a4] {\n  font-weight: 700;\n}\n.divider[data-v-097081a4] {\n  display: block;\n  width: 350px;\n  margin: 20px auto;\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n}\n.button.unassign[data-v-097081a4] {\n  margin-top: 10px;\n}\n.stops .stop[data-v-097081a4] {\n  padding: 10px;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  background-color: #fff;\n  margin-bottom: 5px;\n  border-radius: 3px;\n  border-top: 3px solid #CA3538;\n  position: relative;\n}\n.stops .stop.pickup[data-v-097081a4] {\n    border-top: 3px solid #2EE47D;\n}\n.stops .title[data-v-097081a4] {\n  font-size: 12px;\n  font-weight: 700;\n  margin-bottom: 10px;\n  color: #8DA0A9;\n}\n.stops .name[data-v-097081a4] {\n  font-size: 14px;\n  margin-bottom: 3px;\n}\n.stops .name i[data-v-097081a4] {\n    display: inline-block;\n    margin-right: 2px;\n    color: #CA3538;\n}\n.stops .name i.pickup[data-v-097081a4] {\n      color: #2EE47D;\n}\n.stops .time[data-v-097081a4] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #555;\n}\n.stops .address[data-v-097081a4] {\n  margin-top: 5px;\n  font-size: 16px;\n  font-weight: 700;\n  color: #555;\n}\n.stops .misc[data-v-097081a4] {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 14px;\n  color: #555;\n  text-align: right;\n}\n.stops .misc .pax-luggage[data-v-097081a4] {\n    color: #777;\n    font-size: 12px;\n    font-weight: 700;\n}\n.stops .misc .pax-luggage *[data-v-097081a4] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.stops .misc .pax-luggage i[data-v-097081a4] {\n      margin-left: 5px;\n      display: inline-block;\n}\n.stops .misc .pax-luggage span[data-v-097081a4] {\n      margin-left: 2px;\n}\na.payment-breakdown-button[data-v-097081a4] {\n  font-size: 10px;\n  display: block;\n}\n.modal-container[data-v-097081a4] {\n  position: fixed;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 999;\n  background-color: rgba(0, 0, 0, 0.4);\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.modal-container.show[data-v-097081a4] {\n    opacity: 1;\n    top: 0;\n}\n.modal-container .modal[data-v-097081a4] {\n    display: table;\n    width: 100%;\n    height: 100%;\n}\n.modal-container .modal-content[data-v-097081a4] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.payment-breakdown[data-v-097081a4] {\n  width: 300px;\n  background-color: #fff;\n  margin: 0 auto;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  position: relative;\n}\n.payment-breakdown .close[data-v-097081a4] {\n    display: block;\n    position: absolute;\n    color: #fff;\n    top: 0;\n    right: 0;\n    padding: 10px 10px;\n}\n.payment-breakdown .title[data-v-097081a4] {\n    background-color: #333;\n    color: #fff;\n    font-weight: 700;\n    text-align: center;\n    padding: 10px 5px;\n}\n.payment-breakdown .breakdown[data-v-097081a4] {\n    padding: 5px 15px;\n    font-size: 14px;\n    text-transform: uppercase;\n}\n.payment-breakdown .breakdown.total[data-v-097081a4] {\n      font-size: 16px;\n      padding: 10px 0 10px;\n      margin: 0 15px;\n      border-top: 1px solid rgba(0, 0, 0, 0.15);\n}\n.payment-breakdown .label[data-v-097081a4] {\n    text-align: left;\n    color: #555;\n}\n.payment-breakdown .value[data-v-097081a4] {\n    text-align: right;\n    font-weight: 700;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.package !== null)?_c('div',{staticClass:"package"},[_c('div',{staticClass:"package-id"},[_c('a',{attrs:{"href":'/#/package/' + _vm.package.id,"target":"_blank"}},[_c('span',[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.package'))+" "+_vm._s(_vm.package.id))]),_vm._v(" "),_c('i',{staticClass:"fas fa-cube fa-fw"})])]),_vm._v(" "),_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.packagePickup')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.getAddress(_vm.package.pickup)))])]),_vm._v(" "),_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.packageDropoff')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.getAddress(_vm.package.dropoff)))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.pickupTime')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.package.pickupTime))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v("PASSENGER/LUGGAGE/STOPS")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.package.pax)+"/"+_vm._s(_vm.package.luggage)+"/"+_vm._s(_vm.package.stops))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.serviceType')))]),_vm._v(" "),_c('div',{class:'value service-type ' + _vm.package.serviceClass},[_vm._v(_vm._s(_vm.package.serviceLabel))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.status')))]),_vm._v(" "),_c('div',{class:'value status ' + _vm.package.statusClass},[_vm._v(_vm._s(_vm.package.status))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v("FARE AMOUNT")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("$"+_vm._s(_vm.package.fare.toFixed(2)))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v("DRIVER PAYMENT")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("$"+_vm._s(_vm.getDriverPayment(_vm.package.driverPayment).toFixed(2)))]),_vm._v(" "),_c('a',{staticClass:"payment-breakdown-button",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.showBreakdown(true)}}},[_vm._v("See Payment Breakdown")])])])]),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),(_vm.package.driver !== null)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.driverName')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":'/#/provider/' + _vm.package.driver.id,"target":"_blank"}},[_vm._v("\n              "+_vm._s(_vm.package.driver.firstName)+" "+_vm._s(_vm.package.driver.lastName)+"\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.driverEmail')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":"javascript:;","href":'mailto:' + _vm.package.driver.email}},[_vm._v("\n              "+_vm._s(_vm.package.driver.email)+"\n            ")])])])])])]):_c('div',[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.driverInfo')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.packageDriverNone')))])])])]),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"stops"},[_c('div',{staticClass:"title"},[_vm._v("STOPS FOR PACKAGE "+_vm._s(_vm.package.id))]),_vm._v(" "),_vm._l((_vm.package.legs),function(leg,index){return _c('div',{class:{ stop: true, pickup: leg.isPickup }},[_c('div',{staticClass:"name"},[_c('i',{class:{ 'fas fa-map-marker-alt fa-fw': true, pickup: leg.isPickup }}),_vm._v(" "),_c('a',{attrs:{"href":'/#/consumer/' + leg.customer.id,"target":"_blank"}},[_vm._v(_vm._s(leg.customer.firstName)+" "+_vm._s(leg.customer.lastName))])]),_vm._v(" "),_c('div',{staticClass:"time"},[(leg.isPickup)?_c('span',[_vm._v(_vm._s(leg.pickupTime))]):_c('span',[_vm._v("TBD")])]),_vm._v(" "),_c('div',{staticClass:"address"},[(leg.isPickup)?_c('span',[_vm._v(_vm._s(_vm.getAddress(leg.pickup)))]):_c('span',[_vm._v(_vm._s(_vm.getAddress(leg.dropoff)))])]),_vm._v(" "),_c('div',{class:'status ' + leg.statusClass},[_vm._v(_vm._s(leg.status))]),_vm._v(" "),_c('div',{staticClass:"misc"},[_c('div',{staticClass:"rsvp-id"},[_c('span',[_vm._v("ID:")]),_vm._v(" "),_c('a',{attrs:{"href":'/#/reservation/' + leg.id,"target":"_blank"}},[_vm._v(_vm._s(leg.id))])]),_vm._v(" "),_c('div',{staticClass:"pax-luggage"},[_c('i',{staticClass:"fas fa-user fa-fw"}),_c('span',[_vm._v(_vm._s(leg.pax))]),_vm._v(" "),_c('i',{staticClass:"fas fa-suitcase fa-fw"}),_c('span',[_vm._v(_vm._s(leg.luggage))])])])])})],2),_vm._v(" "),_c('div',{class:{ 'modal-container': true, show: _vm.showPaymentBreakdown },on:{"click":function($event){return _vm.showBreakdown(false)}}},[_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"payment-breakdown",on:{"click":function($event){$event.stopPropagation();}}},[_c('a',{staticClass:"close",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.showBreakdown(false)}}},[_c('i',{staticClass:"far fa-times-circle fa-fw"})]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("PAYMENT BREAKDOWN")]),_vm._v(" "),_c('div',{staticClass:"row breakdown"},[_c('div',{staticClass:"small-6 columns label"},[_vm._v("Fare Amount:")]),_vm._v(" "),_c('div',{staticClass:"small-6 columns value"},[_vm._v("$"+_vm._s(_vm.package.driverPayment.base.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"row breakdown"},[_c('div',{staticClass:"small-6 columns label"},[_vm._v("Bonus:")]),_vm._v(" "),_c('div',{staticClass:"small-6 columns value"},[_vm._v("$"+_vm._s(_vm.package.driverPayment.bonus.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"row breakdown"},[_c('div',{staticClass:"small-6 columns label"},[_vm._v("Tip:")]),_vm._v(" "),_c('div',{staticClass:"small-6 columns value"},[_vm._v("$"+_vm._s(_vm.package.driverPayment.tip.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"row breakdown"},[_c('div',{staticClass:"small-6 columns label"},[_vm._v("Pickup Fee:")]),_vm._v(" "),_c('div',{staticClass:"small-6 columns value"},[_vm._v("$"+_vm._s(_vm.package.driverPayment.pickupFee.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"row breakdown total"},[_c('div',{staticClass:"small-6 columns label"},[_vm._v("Total:")]),_vm._v(" "),_c('div',{staticClass:"small-6 columns value"},[_vm._v("$"+_vm._s(_vm.getDriverPayment(_vm.package.driverPayment).toFixed(2)))])])])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dispatch-page"},[_c('div',{class:{
      'reservation-panel': true,
      hide: false
    }},[(_vm.rsvp !== null && !_vm.rsvp.isPackage)?_c('div',[_c('reservation-details',{attrs:{"rsvp":_vm.rsvp}})],1):_vm._e(),_vm._v(" "),(_vm.rsvp !== null && _vm.rsvp.isPackage)?_c('div',[_c('package-details',{attrs:{"package":_vm.rsvp}})],1):_vm._e(),_vm._v(" "),(_vm.rsvp === null)?_c('div',{staticClass:"no-rsvp"},[_c('div',{staticClass:"no-rsvp-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.emptyTitle')))]),_vm._v(" "),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.$t('dispatch.mapDetails.emptyContent'))}})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"map"},[_c('dispatch-map2')],1),_vm._v(" "),_c('dispatch-modal'),_vm._v(" "),_c('dispatch-notification'),_vm._v(" "),_c('dispatch-schedule')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-info-circle fa-4x"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchReservations_vue__ = __webpack_require__(506);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ea68ab6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchReservations_vue__ = __webpack_require__(1413);
function injectStyle (ssrContext) {
  __webpack_require__(1411)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ea68ab6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchReservations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ea68ab6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchReservations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1412);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2ae2e8da", content, true, {});

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.reservation-panel[data-v-3ea68ab6] {\n  position: fixed;\n  top: 50px;\n  left: 0;\n  height: calc(100% - 50px);\n  width: calc(100% - 30%);\n  overflow: auto;\n}\n.header[data-v-3ea68ab6] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: calc(100% - 30%);\n  height: 50px;\n  background-color: #f9f9f9;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  z-index: 4;\n}\n.header .title[data-v-3ea68ab6] {\n    display: inline-block;\n    margin: 0;\n    font-size: 22px;\n    font-weight: 700;\n    padding-left: 65px;\n    color: #3F2975;\n    height: 50px;\n    line-height: 50px;\n    padding-right: 15px;\n}\n.header .search[data-v-3ea68ab6] {\n    display: inline-block;\n    height: 50px;\n    width: 300px;\n    position: absolute;\n    left: 200px;\n    top: 0;\n}\n.header .filter[data-v-3ea68ab6] {\n    display: inline-block;\n    position: absolute;\n    top: 0;\n    left: 500px;\n    width: 250px;\n}\n.header .more-filter-trigger[data-v-3ea68ab6] {\n    position: absolute;\n    top: 0;\n    left: 749px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    height: 50px;\n    padding: 0 15px;\n    line-height: 50px;\n    border-top: none;\n    border-bottom: none;\n    background: #fff;\n    color: #555;\n    cursor: pointer;\n}\n.header .more-filter-trigger .fa-filter[data-v-3ea68ab6] {\n      margin-right: 3px;\n      color: #999;\n      -webkit-transition: all .3s ease;\n      transition: all .3s ease;\n}\n.header .more-filter-trigger[data-v-3ea68ab6]:hover {\n      color: #333;\n}\n.header .more-filter-trigger:hover i[data-v-3ea68ab6] {\n        color: #333;\n}\n.header .more-filter-trigger.active[data-v-3ea68ab6] {\n      background: #eaf1f3;\n}\n.header .more-filter-trigger.active i[data-v-3ea68ab6] {\n        color: #333;\n}\n.header .more-filter[data-v-3ea68ab6] {\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.header .buttons[data-v-3ea68ab6] {\n    display: inline-block;\n    position: absolute;\n    top: 0;\n    right: 15px;\n    height: 36px;\n    margin: 7px 0;\n    font-weight: 700;\n    text-transform: uppercase;\n}\n.driver-panel[data-v-3ea68ab6] {\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 5;\n  width: 30%;\n  height: 100%;\n  background-color: #eee;\n  -webkit-box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.35);\n  overflow-y: auto;\n}\n.driver-panel .title[data-v-3ea68ab6] {\n    font-size: 18px;\n    font-weight: 700;\n    margin-bottom: 15px;\n}\n.slide-up-enter-active[data-v-3ea68ab6], .slide-up-leave-active[data-v-3ea68ab6] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-3ea68ab6], .slide-up-leave-to[data-v-3ea68ab6] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Dispatch/DispatchReservations.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,0BAA0B;EAC1B,wBAAwB;EACxB,eAAe;CAChB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,wBAAwB;EACxB,aAAa;EACb,0BAA0B;EAC1B,kDAAkD;UAC1C,0CAA0C;EAClD,WAAW;CACZ;AACD;IACI,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,oBAAoB;CACvB;AACD;IACI,sBAAsB;IACtB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,OAAO;CACV;AACD;IACI,sBAAsB;IACtB,mBAAmB;IACnB,OAAO;IACP,YAAY;IACZ,aAAa;CAChB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,YAAY;IACZ,qCAAqC;IACrC,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;CACnB;AACD;MACM,kBAAkB;MAClB,YAAY;MACZ,iCAAiC;MACjC,yBAAyB;CAC9B;AACD;MACM,YAAY;CACjB;AACD;QACQ,YAAY;CACnB;AACD;MACM,oBAAoB;CACzB;AACD;QACQ,YAAY;CACnB;AACD;IACI,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;IACI,sBAAsB;IACtB,mBAAmB;IACnB,OAAO;IACP,YAAY;IACZ,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,0BAA0B;CAC7B;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mDAAmD;UAC3C,2CAA2C;EACnD,iBAAiB;CAClB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;CACvB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ","file":"DispatchReservations.vue","sourcesContent":["\n.reservation-panel[data-v-3ea68ab6] {\n  position: fixed;\n  top: 50px;\n  left: 0;\n  height: calc(100% - 50px);\n  width: calc(100% - 30%);\n  overflow: auto;\n}\n.header[data-v-3ea68ab6] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: calc(100% - 30%);\n  height: 50px;\n  background-color: #f9f9f9;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  z-index: 4;\n}\n.header .title[data-v-3ea68ab6] {\n    display: inline-block;\n    margin: 0;\n    font-size: 22px;\n    font-weight: 700;\n    padding-left: 65px;\n    color: #3F2975;\n    height: 50px;\n    line-height: 50px;\n    padding-right: 15px;\n}\n.header .search[data-v-3ea68ab6] {\n    display: inline-block;\n    height: 50px;\n    width: 300px;\n    position: absolute;\n    left: 200px;\n    top: 0;\n}\n.header .filter[data-v-3ea68ab6] {\n    display: inline-block;\n    position: absolute;\n    top: 0;\n    left: 500px;\n    width: 250px;\n}\n.header .more-filter-trigger[data-v-3ea68ab6] {\n    position: absolute;\n    top: 0;\n    left: 749px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    height: 50px;\n    padding: 0 15px;\n    line-height: 50px;\n    border-top: none;\n    border-bottom: none;\n    background: #fff;\n    color: #555;\n    cursor: pointer;\n}\n.header .more-filter-trigger .fa-filter[data-v-3ea68ab6] {\n      margin-right: 3px;\n      color: #999;\n      -webkit-transition: all .3s ease;\n      transition: all .3s ease;\n}\n.header .more-filter-trigger[data-v-3ea68ab6]:hover {\n      color: #333;\n}\n.header .more-filter-trigger:hover i[data-v-3ea68ab6] {\n        color: #333;\n}\n.header .more-filter-trigger.active[data-v-3ea68ab6] {\n      background: #eaf1f3;\n}\n.header .more-filter-trigger.active i[data-v-3ea68ab6] {\n        color: #333;\n}\n.header .more-filter[data-v-3ea68ab6] {\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.header .buttons[data-v-3ea68ab6] {\n    display: inline-block;\n    position: absolute;\n    top: 0;\n    right: 15px;\n    height: 36px;\n    margin: 7px 0;\n    font-weight: 700;\n    text-transform: uppercase;\n}\n.driver-panel[data-v-3ea68ab6] {\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 5;\n  width: 30%;\n  height: 100%;\n  background-color: #eee;\n  -webkit-box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.35);\n  overflow-y: auto;\n}\n.driver-panel .title[data-v-3ea68ab6] {\n    font-size: 18px;\n    font-weight: 700;\n    margin-bottom: 15px;\n}\n.slide-up-enter-active[data-v-3ea68ab6], .slide-up-leave-active[data-v-3ea68ab6] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-3ea68ab6], .slide-up-leave-to[data-v-3ea68ab6] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('dispatch.title')))]),_vm._v(" "),_c('div',{staticClass:"search"},[_c('reservation-search')],1),_vm._v(" "),_c('div',{staticClass:"filter"},[_c('reservation-filter',{attrs:{"forRouting":false,"addCustom":"true"}})],1),_vm._v(" "),_c('div',{class:{'more-filter-trigger':true, 'active':_vm.showFilter},on:{"click":_vm.showCustomFilter}},[_vm._m(0)]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('dispatch-more-filter',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilter),expression:"showFilter"}],staticClass:"more-filter",on:{"close":function($event){_vm.showFilter = false}}})],1),_vm._v(" "),_c('div',{staticClass:"buttons"},[_vm._m(1),_vm._v(" "),_c('a',{staticClass:"button success small",attrs:{"href":"/#/dispatch/map","target":"_blank"}},[_c('i',{staticClass:"far fa-map"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('dispatch.openMap')))])])])],1),_vm._v(" "),_c('div',{staticClass:"reservation-panel"},[_c('reservations-table',{attrs:{"isShort":false}})],1),_vm._v(" "),_c('div',{staticClass:"driver-panel"},[_c('transition',{attrs:{"name":"grown-in"}},[_c('driver-service-filter',{directives:[{name:"show",rawName:"v-show",value:(_vm.showServiceFilter),expression:"showServiceFilter"}]})],1),_vm._v(" "),_c('available-drivers')],1),_vm._v(" "),_c('dispatch-modal'),_vm._v(" "),_c('dispatch-notification'),_vm._v(" "),_c('dispatch-schedule'),_vm._v(" "),_c('ready-to-go-modal'),_vm._v(" "),_c('notes-modal')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fas fa-filter"}),_vm._v(" Filter\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button small",attrs:{"href":"/#/dispatch"}},[_c('i',{staticClass:"fas fa-chevron-left"}),_vm._v(" "),_c('span',[_vm._v("Back")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(507);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d4a9931_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1425);
function injectStyle (ssrContext) {
  __webpack_require__(1415)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d4a9931"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d4a9931_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1416);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0abbc603", content, true, {});

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.heading[data-v-2d4a9931] {\n  margin-left: 50px;\n  padding-left: 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.filter[data-v-2d4a9931] {\n  border-bottom: 1px solid #bbb;\n  background: #fcfcfc;\n  margin-bottom: 10px;\n  border-radius: 2px;\n}\n.filter .row[data-v-2d4a9931] {\n    max-width: 100%;\n}\n.field-label[data-v-2d4a9931] {\n  font-size: 13px;\n  color: #999;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.search-box[data-v-2d4a9931] {\n  display: inline-block;\n  padding: 10px 0 10px 15px;\n  position: relative;\n  width: 100%;\n}\n.search-box .error-msg[data-v-2d4a9931] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: calc(100% - 15px);\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    margin-left: 15px;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: bottom center;\n            transform-origin: bottom center;\n}\n.search[data-v-2d4a9931] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.search .search-input-box[data-v-2d4a9931] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-2d4a9931] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 5px 0 0 5px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-2d4a9931] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-2d4a9931] {\n      position: absolute;\n      top: 0;\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n      line-height: 46px;\n}\n.search button[data-v-2d4a9931] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 5px 5px 0;\n    padding: 0 20px;\n}\n.add-promo[data-v-2d4a9931] {\n  text-align: right;\n  padding: 20px 15px 0;\n}\n.fix-footer[data-v-2d4a9931] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 50px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-2d4a9931] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-2d4a9931] {\n    max-width: 100px;\n    height: 30px;\n    padding: 5px;\n}\n.fix-footer .per-page[data-v-2d4a9931] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 10px 0;\n}\n.fix-footer .per-page span[data-v-2d4a9931] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-2d4a9931] {\n    text-align: center;\n    line-height: 30px;\n    padding: 10px 0;\n}\n.fix-footer .pagination[data-v-2d4a9931] {\n    text-align: right;\n    padding: 10px 10px;\n}\n.fix-footer .pagination span[data-v-2d4a9931] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-2d4a9931] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-2d4a9931] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-2d4a9931] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-2d4a9931] {\n        opacity: .4;\n        cursor: default;\n}\n@media only screen and (max-width: 430px) {\n.filter .row[data-v-2d4a9931] {\n    width: 100%;\n}\n.filter .row .search-box[data-v-2d4a9931] {\n      padding: 10px 15px;\n}\n.filter .row .add-promo[data-v-2d4a9931] {\n      padding-top: 0;\n      padding-bottom: 10px;\n}\n.filter .row .add-promo .button[data-v-2d4a9931] {\n        width: 100%;\n}\n.filter .row .small-4[data-v-2d4a9931], .filter .row .small-2[data-v-2d4a9931] {\n      width: 100%;\n}\n.fix-footer .row[data-v-2d4a9931] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.fix-footer .per-page[data-v-2d4a9931] {\n    width: auto;\n}\n.fix-footer .per-page select[data-v-2d4a9931] {\n      width: 55px;\n}\n.fix-footer .per-page span[data-v-2d4a9931]:nth-child(3) {\n      display: none;\n}\n.fix-footer .page-data[data-v-2d4a9931] {\n    display: none;\n}\n.fix-footer .pagination[data-v-2d4a9931] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    margin-right: 15%;\n}\n.fix-footer .pagination select[data-v-2d4a9931] {\n      width: 55px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Promo/index.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;CAC3B;AACD;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;CACpB;AACD;IACI,gBAAgB;CACnB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;CACpB;AACD;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;CACb;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,wCAAwC;YAChC,gCAAgC;CAC3C;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;CACb;AACD;IACI,YAAY;IACZ,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,uBAAuB;MACvB,cAAc;MACd,2BAA2B;MAC3B,oBAAoB;CACzB;AACD;QACQ,sBAAsB;CAC7B;AACD;MACM,mBAAmB;MACnB,OAAO;MACP,WAAW;MACX,eAAe;MACf,gBAAgB;MAChB,kBAAkB;CACvB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;CACnB;AACD;EACE,kBAAkB;EAClB,qBAAqB;CACtB;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;CACb;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;IACjB,aAAa;IACb,aAAa;CAChB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;CACnB;AACD;MACM,sBAAsB;MACtB,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;CACnB;AACD;IACI,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,kBAAkB;CACvB;AACD;MACM,aAAa;MACb,uBAAuB;CAC5B;AACD;MACM,cAAc;MACd,eAAe;MACf,uBAAuB;MACvB,iBAAiB;MACjB,gBAAgB;MAChB,uBAAuB;MACvB,aAAa;CAClB;AACD;QACQ,kBAAkB;CACzB;AACD;QACQ,YAAY;QACZ,gBAAgB;CACvB;AACD;AACA;IACI,YAAY;CACf;AACD;MACM,mBAAmB;CACxB;AACD;MACM,eAAe;MACf,qBAAqB;CAC1B;AACD;QACQ,YAAY;CACnB;AACD;MACM,YAAY;CACjB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;IACI,YAAY;CACf;AACD;MACM,YAAY;CACjB;AACD;MACM,cAAc;CACnB;AACD;IACI,cAAc;CACjB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;IAC5B,kBAAkB;CACrB;AACD;MACM,YAAY;CACjB;CACA","file":"index.vue","sourcesContent":["\n.heading[data-v-2d4a9931] {\n  margin-left: 50px;\n  padding-left: 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.filter[data-v-2d4a9931] {\n  border-bottom: 1px solid #bbb;\n  background: #fcfcfc;\n  margin-bottom: 10px;\n  border-radius: 2px;\n}\n.filter .row[data-v-2d4a9931] {\n    max-width: 100%;\n}\n.field-label[data-v-2d4a9931] {\n  font-size: 13px;\n  color: #999;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.search-box[data-v-2d4a9931] {\n  display: inline-block;\n  padding: 10px 0 10px 15px;\n  position: relative;\n  width: 100%;\n}\n.search-box .error-msg[data-v-2d4a9931] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: calc(100% - 15px);\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    margin-left: 15px;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: bottom center;\n            transform-origin: bottom center;\n}\n.search[data-v-2d4a9931] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.search .search-input-box[data-v-2d4a9931] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-2d4a9931] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 5px 0 0 5px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-2d4a9931] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-2d4a9931] {\n      position: absolute;\n      top: 0;\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n      line-height: 46px;\n}\n.search button[data-v-2d4a9931] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 5px 5px 0;\n    padding: 0 20px;\n}\n.add-promo[data-v-2d4a9931] {\n  text-align: right;\n  padding: 20px 15px 0;\n}\n.fix-footer[data-v-2d4a9931] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 50px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-2d4a9931] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-2d4a9931] {\n    max-width: 100px;\n    height: 30px;\n    padding: 5px;\n}\n.fix-footer .per-page[data-v-2d4a9931] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 10px 0;\n}\n.fix-footer .per-page span[data-v-2d4a9931] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-2d4a9931] {\n    text-align: center;\n    line-height: 30px;\n    padding: 10px 0;\n}\n.fix-footer .pagination[data-v-2d4a9931] {\n    text-align: right;\n    padding: 10px 10px;\n}\n.fix-footer .pagination span[data-v-2d4a9931] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-2d4a9931] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-2d4a9931] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-2d4a9931] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-2d4a9931] {\n        opacity: .4;\n        cursor: default;\n}\n@media only screen and (max-width: 430px) {\n.filter .row[data-v-2d4a9931] {\n    width: 100%;\n}\n.filter .row .search-box[data-v-2d4a9931] {\n      padding: 10px 15px;\n}\n.filter .row .add-promo[data-v-2d4a9931] {\n      padding-top: 0;\n      padding-bottom: 10px;\n}\n.filter .row .add-promo .button[data-v-2d4a9931] {\n        width: 100%;\n}\n.filter .row .small-4[data-v-2d4a9931], .filter .row .small-2[data-v-2d4a9931] {\n      width: 100%;\n}\n.fix-footer .row[data-v-2d4a9931] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.fix-footer .per-page[data-v-2d4a9931] {\n    width: auto;\n}\n.fix-footer .per-page select[data-v-2d4a9931] {\n      width: 55px;\n}\n.fix-footer .per-page span[data-v-2d4a9931]:nth-child(3) {\n      display: none;\n}\n.fix-footer .page-data[data-v-2d4a9931] {\n    display: none;\n}\n.fix-footer .pagination[data-v-2d4a9931] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    margin-right: 15%;\n}\n.fix-footer .pagination select[data-v-2d4a9931] {\n      width: 55px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoList_vue__ = __webpack_require__(508);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4649e23c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoList_vue__ = __webpack_require__(1420);
function injectStyle (ssrContext) {
  __webpack_require__(1418)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4649e23c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4649e23c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1419);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("58e9320a", content, true, {});

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.sticky[data-v-4649e23c] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  height: 30px;\n  z-index: 3;\n}\ntable[data-v-4649e23c] {\n  border-collapse: collapse;\n  width: 100%;\n  -webkit-transition: all .5s ease;\n  transition: all .5s ease;\n  margin-bottom: 50px;\n}\ntable.table-loading[data-v-4649e23c] {\n    opacity: .7;\n}\ntable thead[data-v-4649e23c] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-4649e23c] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-4649e23c] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-4649e23c] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-4649e23c] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr[data-v-4649e23c]:hover {\n      background: #e3e7e8 !important;\n}\ntable tbody tr[data-v-4649e23c]:nth-of-type(even) {\n      background: #fbfbfb;\n}\ntable tbody tr td[data-v-4649e23c] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-4649e23c] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-4649e23c] {\n          color: #ccc;\n}\ntable input[data-v-4649e23c] {\n    display: inline-block;\n    width: auto;\n}\ntable .type[data-v-4649e23c] {\n    display: inline-block;\n    padding: 3px 6px;\n    text-transform: uppercase;\n    border-radius: 4px;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 600;\n}\ntable .type.tnc[data-v-4649e23c] {\n      background: #2ab77c;\n}\ntable .type.tcp[data-v-4649e23c] {\n      background: #3f81a0;\n}\ntable a[data-v-4649e23c] {\n    cursor: pointer;\n}\ntable .und[data-v-4649e23c] {\n    text-decoration: underline;\n}\ntable .date[data-v-4649e23c] {\n    word-spacing: 5px;\n}\n.loader[data-v-4649e23c] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n}\n.loader div[data-v-4649e23c] {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    width: 100%;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n    text-align: center;\n}\n.slide-up-enter-active[data-v-4649e23c], .slide-up-leave-active[data-v-4649e23c] {\n  -webkit-transition: all .4s ease;\n  transition: all .4s ease;\n}\n.slide-up-enter[data-v-4649e23c], .slide-up-leave-to[data-v-4649e23c] {\n  -webkit-transform: translateY(15px);\n          transform: translateY(15px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.cards[data-v-4649e23c] {\n    padding-bottom: 75px;\n}\n.cards .card[data-v-4649e23c] {\n      border: 1px solid #ccc;\n      margin: 0 10px;\n      margin-bottom: 15px;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n}\n.cards .card > div[data-v-4649e23c] {\n        margin-bottom: 3px;\n}\n.cards .card .card-info[data-v-4649e23c] {\n        padding: 10px;\n        padding-bottom: 0;\n}\n.cards .card .card-info .card-header[data-v-4649e23c] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          margin-bottom: 5px;\n}\n.cards .card .card-info .card-header .name[data-v-4649e23c] {\n            font-weight: 900;\n}\n.cards .card .card-info .card-header .amount[data-v-4649e23c] {\n            margin-left: 5px;\n            font-size: 14px;\n}\n.cards .card .card-info .card-header .status[data-v-4649e23c] {\n            text-transform: uppercase;\n            font-size: 14px;\n            font-weight: 900;\n}\n.cards .card .card-info .card-header .status .und[data-v-4649e23c] {\n              text-decoration: underline;\n}\n.cards .card .card-info .card-header .status .und.deactivate[data-v-4649e23c] {\n                color: #ccc;\n}\n.cards .card .card-info .title[data-v-4649e23c] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n}\n.cards .card .card-info .label[data-v-4649e23c] {\n          font-size: 12px;\n          text-transform: uppercase;\n          color: #bbb;\n          font-weight: 600;\n          margin-right: 5px;\n}\n.cards .card .card-info .value[data-v-4649e23c] {\n          margin-right: 10px;\n          font-size: 14px;\n          font-weight: 900;\n}\n.cards .card .actions[data-v-4649e23c] {\n        width: 100%;\n        background: #f3f3f3;\n        border-top: 1px solid #ccc;\n        padding: 15px 10px;\n        text-align: center;\n        margin-top: 15px;\n        border-radius: 0 0 10px 10px;\n        margin-bottom: 0;\n}\n.cards .card .actions .button[data-v-4649e23c] {\n          line-height: 14px;\n          font-size: 14px;\n          padding: 10px 18px 9px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Promo/PromoList.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,WAAW;CACZ;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,iCAAiC;EACjC,yBAAyB;EACzB,oBAAoB;CACrB;AACD;IACI,YAAY;CACf;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,2BAA2B;CAChC;AACD;QACQ,iBAAiB;CACxB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,+BAA+B;CACpC;AACD;MACM,oBAAoB;CACzB;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;IACI,sBAAsB;IACtB,YAAY;CACf;AACD;IACI,sBAAsB;IACtB,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;CACpB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,2BAA2B;CAC9B;AACD;IACI,kBAAkB;CACrB;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;CACd;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,oCAAoC;YAC5B,4BAA4B;IACpC,mBAAmB;CACtB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;AACA;IACI,qBAAqB;CACxB;AACD;MACM,uBAAuB;MACvB,eAAe;MACf,oBAAoB;MACpB,aAAa;MACb,oBAAoB;MACpB,+BAA+B;MAC/B,oBAAoB;CACzB;AACD;QACQ,mBAAmB;CAC1B;AACD;QACQ,cAAc;QACd,kBAAkB;CACzB;AACD;UACU,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;UACd,0BAA0B;cACtB,uBAAuB;kBACnB,+BAA+B;UACvC,0BAA0B;cACtB,uBAAuB;kBACnB,oBAAoB;UAC5B,mBAAmB;CAC5B;AACD;YACY,iBAAiB;CAC5B;AACD;YACY,iBAAiB;YACjB,gBAAgB;CAC3B;AACD;YACY,0BAA0B;YAC1B,gBAAgB;YAChB,iBAAiB;CAC5B;AACD;cACc,2BAA2B;CACxC;AACD;gBACgB,YAAY;CAC3B;AACD;UACU,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;UACd,0BAA0B;cACtB,uBAAuB;kBACnB,oBAAoB;CACrC;AACD;UACU,gBAAgB;UAChB,0BAA0B;UAC1B,YAAY;UACZ,iBAAiB;UACjB,kBAAkB;CAC3B;AACD;UACU,mBAAmB;UACnB,gBAAgB;UAChB,iBAAiB;CAC1B;AACD;QACQ,YAAY;QACZ,oBAAoB;QACpB,2BAA2B;QAC3B,mBAAmB;QACnB,mBAAmB;QACnB,iBAAiB;QACjB,6BAA6B;QAC7B,iBAAiB;CACxB;AACD;UACU,kBAAkB;UAClB,gBAAgB;UAChB,uBAAuB;CAChC;CACA","file":"PromoList.vue","sourcesContent":["\n.sticky[data-v-4649e23c] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  height: 30px;\n  z-index: 3;\n}\ntable[data-v-4649e23c] {\n  border-collapse: collapse;\n  width: 100%;\n  -webkit-transition: all .5s ease;\n  transition: all .5s ease;\n  margin-bottom: 50px;\n}\ntable.table-loading[data-v-4649e23c] {\n    opacity: .7;\n}\ntable thead[data-v-4649e23c] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-4649e23c] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-4649e23c] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-4649e23c] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-4649e23c] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr[data-v-4649e23c]:hover {\n      background: #e3e7e8 !important;\n}\ntable tbody tr[data-v-4649e23c]:nth-of-type(even) {\n      background: #fbfbfb;\n}\ntable tbody tr td[data-v-4649e23c] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-4649e23c] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-4649e23c] {\n          color: #ccc;\n}\ntable input[data-v-4649e23c] {\n    display: inline-block;\n    width: auto;\n}\ntable .type[data-v-4649e23c] {\n    display: inline-block;\n    padding: 3px 6px;\n    text-transform: uppercase;\n    border-radius: 4px;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 600;\n}\ntable .type.tnc[data-v-4649e23c] {\n      background: #2ab77c;\n}\ntable .type.tcp[data-v-4649e23c] {\n      background: #3f81a0;\n}\ntable a[data-v-4649e23c] {\n    cursor: pointer;\n}\ntable .und[data-v-4649e23c] {\n    text-decoration: underline;\n}\ntable .date[data-v-4649e23c] {\n    word-spacing: 5px;\n}\n.loader[data-v-4649e23c] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n}\n.loader div[data-v-4649e23c] {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    width: 100%;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n    text-align: center;\n}\n.slide-up-enter-active[data-v-4649e23c], .slide-up-leave-active[data-v-4649e23c] {\n  -webkit-transition: all .4s ease;\n  transition: all .4s ease;\n}\n.slide-up-enter[data-v-4649e23c], .slide-up-leave-to[data-v-4649e23c] {\n  -webkit-transform: translateY(15px);\n          transform: translateY(15px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.cards[data-v-4649e23c] {\n    padding-bottom: 75px;\n}\n.cards .card[data-v-4649e23c] {\n      border: 1px solid #ccc;\n      margin: 0 10px;\n      margin-bottom: 15px;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n}\n.cards .card > div[data-v-4649e23c] {\n        margin-bottom: 3px;\n}\n.cards .card .card-info[data-v-4649e23c] {\n        padding: 10px;\n        padding-bottom: 0;\n}\n.cards .card .card-info .card-header[data-v-4649e23c] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          margin-bottom: 5px;\n}\n.cards .card .card-info .card-header .name[data-v-4649e23c] {\n            font-weight: 900;\n}\n.cards .card .card-info .card-header .amount[data-v-4649e23c] {\n            margin-left: 5px;\n            font-size: 14px;\n}\n.cards .card .card-info .card-header .status[data-v-4649e23c] {\n            text-transform: uppercase;\n            font-size: 14px;\n            font-weight: 900;\n}\n.cards .card .card-info .card-header .status .und[data-v-4649e23c] {\n              text-decoration: underline;\n}\n.cards .card .card-info .card-header .status .und.deactivate[data-v-4649e23c] {\n                color: #ccc;\n}\n.cards .card .card-info .title[data-v-4649e23c] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n}\n.cards .card .card-info .label[data-v-4649e23c] {\n          font-size: 12px;\n          text-transform: uppercase;\n          color: #bbb;\n          font-weight: 600;\n          margin-right: 5px;\n}\n.cards .card .card-info .value[data-v-4649e23c] {\n          margin-right: 10px;\n          font-size: 14px;\n          font-weight: 900;\n}\n.cards .card .actions[data-v-4649e23c] {\n        width: 100%;\n        background: #f3f3f3;\n        border-top: 1px solid #ccc;\n        padding: 15px 10px;\n        text-align: center;\n        margin-top: 15px;\n        border-radius: 0 0 10px 10px;\n        margin-bottom: 0;\n}\n.cards .card .actions .button[data-v-4649e23c] {\n          line-height: 14px;\n          font-size: 14px;\n          padding: 10px 18px 9px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isMobile)?_c('div',[(_vm.sticky)?_c('div',{staticClass:"sticky"},[_c('table',{class:{'table-loading':_vm.loading}},[_c('thead',[_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'name'},on:{"click":function($event){return _vm.sort('name')}}},[_vm._v("\n          Name\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'name'),expression:"currentOrder.field === 'name'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'promoCode'},on:{"click":function($event){return _vm.sort('promoCode')}}},[_vm._v("\n          Promo Code\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'promoCode'),expression:"currentOrder.field === 'promoCode'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'amount'},on:{"click":function($event){return _vm.sort('amount')}}},[_vm._v("\n          Credit Amount\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'amount'),expression:"currentOrder.field === 'amount'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'created'},on:{"click":function($event){return _vm.sort('created')}}},[_vm._v("\n          Created Date\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'created'),expression:"currentOrder.field === 'created'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'startDate'},on:{"click":function($event){return _vm.sort('startDate')}}},[_vm._v("\n          Start Date\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'startDate'),expression:"currentOrder.field === 'startDate'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'startDate'},on:{"click":function($event){return _vm.sort('expirationDate')}}},[_vm._v("\n          Expiration Date\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'expirationDate'),expression:"currentOrder.field === 'expirationDate'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',[_vm._v("Total Codes")]),_vm._v(" "),_c('th',[_vm._v("Codes Used")]),_vm._v(" "),_c('th',[_vm._v("Codes Left")]),_vm._v(" "),_c('th',[_vm._v("Override Status")]),_vm._v(" "),_c('th')]),_vm._v(" "),_c('tbody',_vm._l((_vm.promos),function(promo){return _c('tr',[_c('td',[_c('a',{staticClass:"und",attrs:{"href":'/#/promo/' + promo.id,"target":"_blank"}},[_vm._v(_vm._s(promo.name))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.promoCode))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(promo.creditAmount)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.createdDate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.starDate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.expDate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.totalCodes))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.codesUsed))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.codesLeft))]),_vm._v(" "),_c('td',[(promo.enabled)?_c('a',{staticClass:"und",on:{"click":function($event){return _vm.deactivate(promo.id)}}},[_vm._v("Deactivate")]):_c('a',{staticClass:"und",on:{"click":function($event){return _vm.activate(promo.id)}}},[_vm._v("Active")])]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button cta xsmall success",on:{"click":function($event){return _vm.exportPromo(promo.id)}}},[_vm._v("Export")])])])}),0)])]):_vm._e(),_vm._v(" "),_c('table',{class:{'table-loading':_vm.loading}},[_c('thead',[_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'name'},on:{"click":function($event){return _vm.sort('name')}}},[_vm._v("\n        Name\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'name'),expression:"currentOrder.field === 'name'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'promoCode'},on:{"click":function($event){return _vm.sort('promoCode')}}},[_vm._v("\n        Promo Code\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'promoCode'),expression:"currentOrder.field === 'promoCode'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'amount'},on:{"click":function($event){return _vm.sort('amount')}}},[_vm._v("\n        Credit Amount\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'amount'),expression:"currentOrder.field === 'amount'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'created'},on:{"click":function($event){return _vm.sort('created')}}},[_vm._v("\n        Created Date  \n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'created'),expression:"currentOrder.field === 'created'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'startDate'},on:{"click":function($event){return _vm.sort('startDate')}}},[_vm._v("\n        Start Date\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'startDate'),expression:"currentOrder.field === 'startDate'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'startDate'},on:{"click":function($event){return _vm.sort('expirationDate')}}},[_vm._v("\n        Expiration Date\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'expirationDate'),expression:"currentOrder.field === 'expirationDate'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',[_vm._v("Total Codes")]),_vm._v(" "),_c('th',[_vm._v("Codes Used")]),_vm._v(" "),_c('th',[_vm._v("Codes Left")]),_vm._v(" "),_c('th',[_vm._v("Override Status")]),_vm._v(" "),_c('th')]),_vm._v(" "),_c('tbody',[_vm._l((_vm.promos),function(promo){return _c('tr',[_c('td',[_c('a',{staticClass:"und",attrs:{"href":'/#/promo/' + promo.id,"target":"_blank"}},[_vm._v(_vm._s(promo.name))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.promoCode))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(promo.creditAmount)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.createdDate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.starDate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.expDate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.totalCodes))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.codesUsed))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.codesLeft))]),_vm._v(" "),_c('td',[(promo.enabled)?_c('a',{staticClass:"und",on:{"click":function($event){return _vm.deactivate(promo.id)}}},[_vm._v("Deactivate")]):_c('a',{staticClass:"und",on:{"click":function($event){return _vm.activate(promo.id)}}},[_vm._v("Active")])]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button cta xsmall success",on:{"click":function($event){return _vm.exportPromo(promo.id)}}},[_vm._v("Export")])])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading && !_vm.promos.length),expression:"loading && !promos.length"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"11"}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('div',[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n                  Loading...\n                ")])])])],1)]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && !_vm.promos.length),expression:"!loading && !promos.length"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"11"}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.promos.length === 0 && !_vm.loading),expression:"promos.length === 0 && !loading"}],staticClass:"empty-result"},[_c('i',{staticClass:"far fa-frown-open fa-3x"}),_c('br'),_vm._v("\n                No record found!\n              ")])])],1)])],2)])]):_c('div',{staticClass:"cards"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading && !_vm.promos.length),expression:"loading && !promos.length"}]},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('div',[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n            Loading...\n          ")])])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && !_vm.promos.length),expression:"!loading && !promos.length"}]},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.promos.length === 0 && !_vm.loading),expression:"promos.length === 0 && !loading"}],staticClass:"empty-result"},[_c('i',{staticClass:"far fa-frown-open fa-3x"}),_c('br'),_vm._v("\n          No record found!\n        ")])])],1),_vm._v(" "),_vm._l((_vm.promos),function(promo){return _c('div',{key:promo.id,staticClass:"card"},[_c('div',{staticClass:"card-info"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"title"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(promo.promoCode))]),_vm._v(" "),_c('span',{staticClass:"amount"},[_vm._v("($"+_vm._s(_vm.toFixed(promo.creditAmount))+")")])]),_vm._v(" "),_c('div',{staticClass:"status"},[(promo.enabled)?_c('a',{staticClass:"und deactivate",on:{"click":function($event){return _vm.deactivate(promo.id)}}},[_vm._v("Deactivate")]):_c('a',{staticClass:"und activate",on:{"click":function($event){return _vm.activate(promo.id)}}},[_vm._v("Active")])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Name: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{staticClass:"und",attrs:{"href":'/#/promo/' + promo.id,"target":"_blank"}},[_vm._v(_vm._s(promo.name))])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Created Date: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(promo.createdDate))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Start Date: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(promo.starDate))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("End Date: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(promo.expDate))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Total Codes: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(promo.totalCodes))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Codes Used: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(promo.codesUsed))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Codes Left: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(promo.codesLeft))])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('a',{staticClass:"button cta xsmall success",on:{"click":function($event){return _vm.exportPromo(promo.id)}}},[_vm._v("Export")])])])])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoAdd_vue__ = __webpack_require__(509);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38e7ecfc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoAdd_vue__ = __webpack_require__(1424);
function injectStyle (ssrContext) {
  __webpack_require__(1422)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38e7ecfc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38e7ecfc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1423);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("6c13573e", content, true, {});

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.op--modal-container[data-v-38e7ecfc] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-38e7ecfc] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-38e7ecfc] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content.center[data-v-38e7ecfc] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.promo-form[data-v-38e7ecfc] {\n  background-color: #fff;\n  width: 600px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.heading[data-v-38e7ecfc] {\n  background: #333;\n  color: #fff;\n  font-weight: 600;\n  font-size: 21px;\n  padding: 10px 20px;\n  margin-bottom: 20px;\n}\n.clear[data-v-38e7ecfc] {\n  clear: both;\n}\n.data-field[data-v-38e7ecfc] {\n  position: relative;\n  margin-bottom: 10px;\n}\n.data-field .label[data-v-38e7ecfc] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 130%;\n    margin-bottom: 1px;\n}\n.data-field .label.has-error[data-v-38e7ecfc] {\n      color: #f20d0d;\n}\n.data-field .label.underline[data-v-38e7ecfc] {\n      padding-bottom: 3px;\n      margin-bottom: 10px;\n      border-bottom: 1px solid #ccc;\n}\n.data-field .label .secondary[data-v-38e7ecfc] {\n      color: #5390dc;\n      display: inline-block;\n      margin-left: 3px;\n}\n.data-field .input[data-v-38e7ecfc] {\n    margin: 1px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-38e7ecfc] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-38e7ecfc]:disabled {\n      background: #eee;\n}\n.data-field textarea[data-v-38e7ecfc] {\n    border: 1px solid #ddd;\n    width: 100%;\n    height: 150px;\n    resize: none;\n    padding: 10px;\n    font-size: 13px;\n    color: #555;\n    outline: none;\n    margin-top: 5px;\n}\n.data-field textarea.has-error[data-v-38e7ecfc] {\n      border-color: #f20d0d;\n}\n.data-field .error-msg[data-v-38e7ecfc] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\nselect[data-v-38e7ecfc] {\n  margin-top: 1px;\n  border: 1px solid #ddd;\n  padding: 10px;\n  color: #333;\n  height: 45px;\n  position: relative;\n  font-size: 14px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n  -webkit-transition: all .35s ease;\n  transition: all .35s ease;\n}\nselect.has-error[data-v-38e7ecfc] {\n    border-color: #f20d0d;\n}\nselect[data-v-38e7ecfc]:disabled {\n    background-color: #eee;\n}\n.time[data-v-38e7ecfc] {\n  display: inline-block;\n  line-height: 45px;\n}\n.row-button[data-v-38e7ecfc] {\n  background: #f6f6f6;\n  border-top: 1px solid #ddd;\n  text-align: center;\n  padding: 10px 0;\n}\n.row-button .button[data-v-38e7ecfc] {\n    margin: 0 5px;\n    min-width: 150px;\n}\n.row[data-v-38e7ecfc] {\n  max-width: 100%;\n}\n.row-padding[data-v-38e7ecfc] {\n  padding: 5px 15px;\n}\n.padding-L[data-v-38e7ecfc] {\n  padding-left: 10px;\n}\n.padding-R[data-v-38e7ecfc] {\n  padding-right: 10px;\n}\n.margin-B[data-v-38e7ecfc] {\n  margin-bottom: 20px;\n}\n.text-center[data-v-38e7ecfc] {\n  text-align: center;\n}\n.error-box[data-v-38e7ecfc] {\n  margin: 0 30px;\n  border: 1px solid #f34c31;\n  color: #f34c31;\n  padding: 5px;\n  margin-bottom: 15px;\n  font-size: 14px;\n  font-weight: 600;\n}\n.slide-down-enter-active[data-v-38e7ecfc], .slide-down-leave-active[data-v-38e7ecfc] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-38e7ecfc], .slide-down-leave-to[data-v-38e7ecfc] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.padding-L[data-v-38e7ecfc], .padding-R[data-v-38e7ecfc] {\n    padding: 0;\n}\n.small-5[data-v-38e7ecfc], .small-4[data-v-38e7ecfc], .small-6[data-v-38e7ecfc], .promo-form[data-v-38e7ecfc] {\n    width: 100%;\n}\n.small-3[data-v-38e7ecfc] {\n    width: 45%;\n}\n.small-1[data-v-38e7ecfc] {\n    width: 10%;\n}\n.small-5[data-v-38e7ecfc] {\n    margin-bottom: 10px;\n}\n.data-field textarea[data-v-38e7ecfc] {\n    height: 80px;\n}\n.input-date .small-5[data-v-38e7ecfc] {\n    width: 45%;\n    padding-right: 5%;\n}\n.input-date .small-3[data-v-38e7ecfc] {\n    width: 25%;\n    padding: 0;\n    margin: 0;\n    float: left;\n}\n.input-date .small-1[data-v-38e7ecfc] {\n    width: 5%;\n}\n.promo-code[data-v-38e7ecfc] {\n    width: 50%;\n    padding-right: 5%;\n}\n.credit-amount[data-v-38e7ecfc] {\n    width: 50%;\n}\n.w-50[data-v-38e7ecfc] {\n    width: 50%;\n}\n.w-50.padding-r[data-v-38e7ecfc] {\n      padding-right: 5%;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Promo/PromoAdd.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,iDAAiD;UACzC,yCAAyC;EACjD,mBAAmB;CACpB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;CACrB;AACD;EACE,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,oBAAoB;CACrB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;MACM,oBAAoB;MACpB,oBAAoB;MACpB,8BAA8B;CACnC;AACD;MACM,eAAe;MACf,sBAAsB;MACtB,iBAAiB;CACtB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,gBAAgB;CACnB;AACD;MACM,sBAAsB;CAC3B;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;IACI,sBAAsB;CACzB;AACD;IACI,uBAAuB;CAC1B;AACD;EACE,sBAAsB;EACtB,kBAAkB;CACnB;AACD;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;CACjB;AACD;IACI,cAAc;IACd,iBAAiB;CACpB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;CAClB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;AACA;IACI,WAAW;CACd;AACD;IACI,YAAY;CACf;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,oBAAoB;CACvB;AACD;IACI,aAAa;CAChB;AACD;IACI,WAAW;IACX,kBAAkB;CACrB;AACD;IACI,WAAW;IACX,WAAW;IACX,UAAU;IACV,YAAY;CACf;AACD;IACI,UAAU;CACb;AACD;IACI,WAAW;IACX,kBAAkB;CACrB;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;MACM,kBAAkB;CACvB;CACA","file":"PromoAdd.vue","sourcesContent":["\n.op--modal-container[data-v-38e7ecfc] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-38e7ecfc] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-38e7ecfc] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content.center[data-v-38e7ecfc] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.promo-form[data-v-38e7ecfc] {\n  background-color: #fff;\n  width: 600px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.heading[data-v-38e7ecfc] {\n  background: #333;\n  color: #fff;\n  font-weight: 600;\n  font-size: 21px;\n  padding: 10px 20px;\n  margin-bottom: 20px;\n}\n.clear[data-v-38e7ecfc] {\n  clear: both;\n}\n.data-field[data-v-38e7ecfc] {\n  position: relative;\n  margin-bottom: 10px;\n}\n.data-field .label[data-v-38e7ecfc] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 130%;\n    margin-bottom: 1px;\n}\n.data-field .label.has-error[data-v-38e7ecfc] {\n      color: #f20d0d;\n}\n.data-field .label.underline[data-v-38e7ecfc] {\n      padding-bottom: 3px;\n      margin-bottom: 10px;\n      border-bottom: 1px solid #ccc;\n}\n.data-field .label .secondary[data-v-38e7ecfc] {\n      color: #5390dc;\n      display: inline-block;\n      margin-left: 3px;\n}\n.data-field .input[data-v-38e7ecfc] {\n    margin: 1px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-38e7ecfc] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-38e7ecfc]:disabled {\n      background: #eee;\n}\n.data-field textarea[data-v-38e7ecfc] {\n    border: 1px solid #ddd;\n    width: 100%;\n    height: 150px;\n    resize: none;\n    padding: 10px;\n    font-size: 13px;\n    color: #555;\n    outline: none;\n    margin-top: 5px;\n}\n.data-field textarea.has-error[data-v-38e7ecfc] {\n      border-color: #f20d0d;\n}\n.data-field .error-msg[data-v-38e7ecfc] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\nselect[data-v-38e7ecfc] {\n  margin-top: 1px;\n  border: 1px solid #ddd;\n  padding: 10px;\n  color: #333;\n  height: 45px;\n  position: relative;\n  font-size: 14px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n  -webkit-transition: all .35s ease;\n  transition: all .35s ease;\n}\nselect.has-error[data-v-38e7ecfc] {\n    border-color: #f20d0d;\n}\nselect[data-v-38e7ecfc]:disabled {\n    background-color: #eee;\n}\n.time[data-v-38e7ecfc] {\n  display: inline-block;\n  line-height: 45px;\n}\n.row-button[data-v-38e7ecfc] {\n  background: #f6f6f6;\n  border-top: 1px solid #ddd;\n  text-align: center;\n  padding: 10px 0;\n}\n.row-button .button[data-v-38e7ecfc] {\n    margin: 0 5px;\n    min-width: 150px;\n}\n.row[data-v-38e7ecfc] {\n  max-width: 100%;\n}\n.row-padding[data-v-38e7ecfc] {\n  padding: 5px 15px;\n}\n.padding-L[data-v-38e7ecfc] {\n  padding-left: 10px;\n}\n.padding-R[data-v-38e7ecfc] {\n  padding-right: 10px;\n}\n.margin-B[data-v-38e7ecfc] {\n  margin-bottom: 20px;\n}\n.text-center[data-v-38e7ecfc] {\n  text-align: center;\n}\n.error-box[data-v-38e7ecfc] {\n  margin: 0 30px;\n  border: 1px solid #f34c31;\n  color: #f34c31;\n  padding: 5px;\n  margin-bottom: 15px;\n  font-size: 14px;\n  font-weight: 600;\n}\n.slide-down-enter-active[data-v-38e7ecfc], .slide-down-leave-active[data-v-38e7ecfc] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-38e7ecfc], .slide-down-leave-to[data-v-38e7ecfc] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.padding-L[data-v-38e7ecfc], .padding-R[data-v-38e7ecfc] {\n    padding: 0;\n}\n.small-5[data-v-38e7ecfc], .small-4[data-v-38e7ecfc], .small-6[data-v-38e7ecfc], .promo-form[data-v-38e7ecfc] {\n    width: 100%;\n}\n.small-3[data-v-38e7ecfc] {\n    width: 45%;\n}\n.small-1[data-v-38e7ecfc] {\n    width: 10%;\n}\n.small-5[data-v-38e7ecfc] {\n    margin-bottom: 10px;\n}\n.data-field textarea[data-v-38e7ecfc] {\n    height: 80px;\n}\n.input-date .small-5[data-v-38e7ecfc] {\n    width: 45%;\n    padding-right: 5%;\n}\n.input-date .small-3[data-v-38e7ecfc] {\n    width: 25%;\n    padding: 0;\n    margin: 0;\n    float: left;\n}\n.input-date .small-1[data-v-38e7ecfc] {\n    width: 5%;\n}\n.promo-code[data-v-38e7ecfc] {\n    width: 50%;\n    padding-right: 5%;\n}\n.credit-amount[data-v-38e7ecfc] {\n    width: 50%;\n}\n.w-50[data-v-38e7ecfc] {\n    width: 50%;\n}\n.w-50.padding-r[data-v-38e7ecfc] {\n      padding-right: 5%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'op--modal-container':true, 'hide':!_vm.show},on:{"click":_vm.close}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content promo-form",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"heading",attrs:{"id":"addPromo"}},[_vm._v("Add Promo")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.errorReturn),expression:"!!errorReturn"}],staticClass:"error-box"},[_vm._v(_vm._s(_vm.errorReturn))]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.promoName),expression:"promoName"}],class:{'input':true, 'has-error':!!_vm.errorMsg.promoName},attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.promoName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.promoName=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.promoName))])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"input",attrs:{"disabled":_vm.loading},domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"column small-12 end"},[_c('div',{staticClass:"data-field input-date"},[_c('div',{staticClass:"label"},[_vm._v("Start Date")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-5 padding-R"},[_c('datepicker',{staticClass:"datepicker inline",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"disabled":_vm.startDateDisabled,"input-class":{'datepicker-empty':_vm.errorMsg.startDate}},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.startDate || _vm.errorMsg.startDateHour || _vm.errorMsg.startDateMinute))])],1),_vm._v(" "),_c('div',{staticClass:"column small-3 padding-L"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDateHour),expression:"startDateHour"}],class:{'has-error':!!_vm.errorMsg.startDateHour},attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.startDateHour=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Hour")]),_vm._v(" "),_vm._l((24),function(x){return _c('option',{domProps:{"value":_vm.leadingZero(x - 1)}},[_vm._v(_vm._s(_vm.leadingZero(x - 1)))])})],2)]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column small-3 padding-R"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDateMinute),expression:"startDateMinute"}],class:{'has-error':!!_vm.errorMsg.startDateMinute},attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.startDateMinute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Minute")]),_vm._v(" "),_vm._l((12),function(x){return _c('option',{domProps:{"value":_vm.leadingZero((x - 1) * 5)}},[_vm._v(_vm._s(_vm.leadingZero((x - 1) * 5)))])})],2)])])])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"column small-12 end"},[_c('div',{staticClass:"data-field input-date"},[_c('div',{staticClass:"label"},[_vm._v("Expiration Date")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-5 padding-R"},[_c('datepicker',{staticClass:"datepicker inline",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"disabled":_vm.expirationDateDisabled,"input-class":{'datepicker-empty':_vm.errorMsg.expirationDate}},model:{value:(_vm.expirationDate),callback:function ($$v) {_vm.expirationDate=$$v},expression:"expirationDate"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.expirationDate || _vm.errorMsg.expirationDateHour || _vm.errorMsg.expirationDateMinute))])],1),_vm._v(" "),_c('div',{staticClass:"column small-3 padding-L"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.expirationDateHour),expression:"expirationDateHour"}],class:{'has-error':!!_vm.errorMsg.expirationDateHour},attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.expirationDateHour=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Hour")]),_vm._v(" "),_vm._l((24),function(x){return _c('option',{domProps:{"value":_vm.leadingZero(x - 1)}},[_vm._v(_vm._s(_vm.leadingZero(x - 1)))])})],2)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"column small-3 padding-R"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.expirationDateMinute),expression:"expirationDateMinute"}],class:{'has-error':!!_vm.errorMsg.expirationDateMinute},attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.expirationDateMinute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Minute")]),_vm._v(" "),_vm._l((12),function(x){return _c('option',{domProps:{"value":_vm.leadingZero((x - 1) * 5)}},[_vm._v(_vm._s(_vm.leadingZero((x - 1) * 5)))])})],2)])])])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"column small-6 padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Days Valid after Redemption")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.validDays),expression:"validDays"}],class:{'input':true, 'has-error':!!_vm.errorMsg.validDays},attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.validDays)},on:{"input":function($event){if($event.target.composing){ return; }_vm.validDays=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.validDays))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile),expression:"!isMobile"}],staticClass:"column small-6 padding-L"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Valid Only for New Users")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.validNewUser),expression:"validNewUser"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.validNewUser=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Yes")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("No")])])])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"column small-4 padding-R promo-code"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Promo Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],class:{'input':true, 'has-error':!!_vm.errorMsg.code},attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.code)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return (function (event) { return event.preventDefault(); }).apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.code))])])]),_vm._v(" "),_c('div',{staticClass:"column small-4 padding-R padding-L credit-amount"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Credit Amount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],class:{'input':true, 'has-error':!!_vm.errorMsg.amount},attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.amount))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobile),expression:"isMobile"}],staticClass:"column small-6 padding-L w-50 padding-r"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Valid Only for New Users")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.validNewUser),expression:"validNewUser"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.validNewUser=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Yes")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("No")])])])]),_vm._v(" "),_c('div',{staticClass:"column small-4 padding-L w-50"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Number of Codes to Redeem")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalCodes),expression:"totalCodes"}],class:{'input':true, 'has-error':!!_vm.errorMsg.totalCodes},attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.totalCodes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.totalCodes=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.totalCodes))])])])]),_vm._v(" "),_c('div',{staticClass:"row row-button"},[_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"button cta error small",on:{"click":_vm.close}},[_vm._v("Cancel")]),_vm._v(" "),_c('div',{staticClass:"button cta success small",on:{"click":_vm.save}},[_vm._v("Save")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-1 text-center"},[_c('span',{staticClass:"time"},[_vm._v(":")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-1 text-center"},[_c('span',{staticClass:"time"},[_vm._v(":")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"heading"},[_vm._v("Promo")]),_vm._v(" "),_c('div',{staticClass:"filter"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-4 column end"},[_c('div',{staticClass:"search-box"},[_c('label',{staticClass:"field-label"},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"search"},[_c('div',{staticClass:"search-input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],ref:"search",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.searchInput)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search.apply(null, arguments)},"blur":_vm.blurSearch,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-left"}},[(_vm.searchInput.length > 0)?_c('i',{staticClass:"far fa-times-circle fa-lg",on:{"click":_vm.clearSearch}}):_vm._e()])],1),_vm._v(" "),_c('button',{class:{'button xsmall success':true, 'disabled':_vm.loading},on:{"click":_vm.search}},[_c('i',{staticClass:"fas fa-search fa-lg"})])])])]),_vm._v(" "),_c('div',{staticClass:"small-2 column add-promo"},[_c('div',{staticClass:"button cta success",on:{"click":_vm.showAdd}},[_vm._v("Add Promo")])])])]),_vm._v(" "),_c('promo-list',{attrs:{"isMobile":_vm.isMobile}}),_vm._v(" "),_c('div',{staticClass:"fix-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-3 columns per-page"},[_c('span',[_vm._v("Displaying")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" "),_c('span',[_vm._v("per page")])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns page-data"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.promo.length > 0),expression:"promo.length > 0"}]},[_vm._v("\n          Displaying\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.start))]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.pageData.end))]),_vm._v(" of\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.max))])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns pagination"},[_c('span',[_vm._v("Page")]),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.currentPage === 1 || _vm.loading},on:{"click":_vm.prev}},[_c('i',{staticClass:"fas fa-chevron-left"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentPage),expression:"currentPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.totalPage),function(i){return _c('option',{domProps:{"value":i}},[_vm._v(_vm._s(i))])}),0),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.isLastPage || _vm.loading},on:{"click":_vm.next}},[_c('i',{staticClass:"fas fa-chevron-right"})])])])]),_vm._v(" "),_c('promo-add',{attrs:{"isMobile":_vm.isMobile},on:{"save":_vm.getPromo}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoView_vue__ = __webpack_require__(510);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06796ca9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoView_vue__ = __webpack_require__(1441);
function injectStyle (ssrContext) {
  __webpack_require__(1427)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06796ca9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06796ca9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1428);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("b444839a", content, true, {});

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.left-panel[data-v-06796ca9] {\n  position: fixed;\n  z-index: 2;\n  left: 0;\n  top: 0;\n  width: 40%;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #F4F8F9;\n  overflow-y: auto;\n}\n.left-panel .heading[data-v-06796ca9] {\n    padding: 0 15px 0 65px;\n    line-height: 50px;\n    font-size: 21px;\n    font-weight: 600;\n    background: #fff;\n    border-bottom: 1px solid #eee;\n    color: #333;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.left-panel .heading label[data-v-06796ca9] {\n      color: #3F2975;\n      text-transform: uppercase;\n}\n.left-panel .heading div[data-v-06796ca9] {\n      margin: 5px 5px 0;\n      float: right;\n}\n.left-panel .heading .button-actions[data-v-06796ca9] {\n      margin: 5px;\n}\n.fix-footer[data-v-06796ca9] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 40%;\n  height: 50px;\n  padding-top: 5px;\n  background: #fafafa;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .small-4[data-v-06796ca9] {\n    padding: 0 10px;\n}\n.toggle-mobile[data-v-06796ca9] {\n  display: none;\n}\n.right-panel[data-v-06796ca9] {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  top: 0;\n  width: 60%;\n  height: 100%;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #fff;\n  overflow-y: auto;\n}\n.slide-down-enter-active[data-v-06796ca9], .slide-down-leave-active[data-v-06796ca9] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-06796ca9], .slide-down-leave-to[data-v-06796ca9] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n.slide-up-enter-active[data-v-06796ca9], .slide-up-leave-active[data-v-06796ca9] {\n  -webkit-transition: all .25s ease;\n  transition: all .25s ease;\n}\n.slide-up-enter[data-v-06796ca9], .slide-up-leave-to[data-v-06796ca9] {\n  -webkit-transform: translateY(15px);\n          transform: translateY(15px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.left-panel[data-v-06796ca9] {\n    width: 100%;\n    padding-bottom: 100px;\n}\n.left-panel .heading[data-v-06796ca9] {\n      padding: 0 20px;\n      position: absolute;\n      width: 100%;\n}\n.left-panel .heading label[data-v-06796ca9] {\n        margin-left: 40px;\n}\n.left-panel .heading .button-actions[data-v-06796ca9] {\n        margin: 0;\n        margin-bottom: 10px;\n}\n.left-panel .heading div[data-v-06796ca9] {\n        float: none;\n        margin: 0;\n}\n.left-panel .heading div .button[data-v-06796ca9] {\n          width: 50%;\n}\n.left-panel .tab[data-v-06796ca9] {\n      margin: 35px 0 0;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      overflow-x: scroll;\n}\n.left-panel .tab li[data-v-06796ca9] {\n        width: auto;\n}\n.toggle-mobile[data-v-06796ca9] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.right-panel[data-v-06796ca9] {\n    z-index: 1;\n    width: 100%;\n    top: 100%;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n}\n.right-panel.mobile-right-panel[data-v-06796ca9] {\n      top: 0;\n      z-index: 2;\n}\n.right-panel.mobile-right-panel .tab[data-v-06796ca9] {\n        margin-top: 70px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        overflow-x: scroll;\n}\n.right-panel.mobile-right-panel .tab-contents[data-v-06796ca9] {\n        width: 100%;\n        height: calc(100vh - 142px);\n        overflow-y: scroll;\n}\n.right-panel.mobile-right-panel .tab-contents .tab-content[data-v-06796ca9] {\n          padding-bottom: 60px;\n}\n.right-panel.mobile-right-panel .tab-contents .tab-content.history-panel[data-v-06796ca9] {\n            padding: 0;\n            padding-top: 20px;\n            padding-bottom: 60px;\n}\n.right-panel.mobile-right-panel .tab-contents .fixed-footer[data-v-06796ca9] {\n          width: 100%;\n          bottom: 45px;\n          background: #fff;\n          color: #000;\n          border-top: 1px solid #aaa;\n}\n.right-panel.mobile-right-panel .logs-panel[data-v-06796ca9] {\n        width: 100%;\n}\n.fix-buttons[data-v-06796ca9] {\n    width: 100%;\n    bottom: 45px;\n}\n.fix-buttons a[data-v-06796ca9] {\n      margin: 0 auto;\n}\n.toggle-panel .heading[data-v-06796ca9] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Promo/PromoView.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,OAAO;EACP,WAAW;EACX,aAAa;EACb,iDAAiD;UACzC,yCAAyC;EACjD,0BAA0B;EAC1B,iBAAiB;CAClB;AACD;IACI,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,8BAA8B;IAC9B,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;CAC3B;AACD;MACM,eAAe;MACf,0BAA0B;CAC/B;AACD;MACM,kBAAkB;MAClB,aAAa;CAClB;AACD;MACM,YAAY;CACjB;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;CACb;AACD;IACI,gBAAgB;CACnB;AACD;EACE,cAAc;CACf;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;EAClD,uBAAuB;EACvB,iBAAiB;CAClB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ;AACD;EACE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;AACA;IACI,YAAY;IACZ,sBAAsB;CACzB;AACD;MACM,gBAAgB;MAChB,mBAAmB;MACnB,YAAY;CACjB;AACD;QACQ,kBAAkB;CACzB;AACD;QACQ,UAAU;QACV,oBAAoB;CAC3B;AACD;QACQ,YAAY;QACZ,UAAU;CACjB;AACD;UACU,WAAW;CACpB;AACD;MACM,iBAAiB;MACjB,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,mBAAmB;CACxB;AACD;QACQ,YAAY;CACnB;AACD;IACI,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;IACrB,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;CACpB;AACD;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,OAAO;MACP,WAAW;CAChB;AACD;QACQ,iBAAiB;QACjB,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,mBAAmB;CAC1B;AACD;QACQ,YAAY;QACZ,4BAA4B;QAC5B,mBAAmB;CAC1B;AACD;UACU,qBAAqB;CAC9B;AACD;YACY,WAAW;YACX,kBAAkB;YAClB,qBAAqB;CAChC;AACD;UACU,YAAY;UACZ,aAAa;UACb,iBAAiB;UACjB,YAAY;UACZ,2BAA2B;CACpC;AACD;QACQ,YAAY;CACnB;AACD;IACI,YAAY;IACZ,aAAa;CAChB;AACD;MACM,eAAe;CACpB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,yBAAyB;QACrB,sBAAsB;YAClB,wBAAwB;CACnC;CACA","file":"PromoView.vue","sourcesContent":["\n.left-panel[data-v-06796ca9] {\n  position: fixed;\n  z-index: 2;\n  left: 0;\n  top: 0;\n  width: 40%;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #F4F8F9;\n  overflow-y: auto;\n}\n.left-panel .heading[data-v-06796ca9] {\n    padding: 0 15px 0 65px;\n    line-height: 50px;\n    font-size: 21px;\n    font-weight: 600;\n    background: #fff;\n    border-bottom: 1px solid #eee;\n    color: #333;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.left-panel .heading label[data-v-06796ca9] {\n      color: #3F2975;\n      text-transform: uppercase;\n}\n.left-panel .heading div[data-v-06796ca9] {\n      margin: 5px 5px 0;\n      float: right;\n}\n.left-panel .heading .button-actions[data-v-06796ca9] {\n      margin: 5px;\n}\n.fix-footer[data-v-06796ca9] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 40%;\n  height: 50px;\n  padding-top: 5px;\n  background: #fafafa;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .small-4[data-v-06796ca9] {\n    padding: 0 10px;\n}\n.toggle-mobile[data-v-06796ca9] {\n  display: none;\n}\n.right-panel[data-v-06796ca9] {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  top: 0;\n  width: 60%;\n  height: 100%;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #fff;\n  overflow-y: auto;\n}\n.slide-down-enter-active[data-v-06796ca9], .slide-down-leave-active[data-v-06796ca9] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-06796ca9], .slide-down-leave-to[data-v-06796ca9] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n.slide-up-enter-active[data-v-06796ca9], .slide-up-leave-active[data-v-06796ca9] {\n  -webkit-transition: all .25s ease;\n  transition: all .25s ease;\n}\n.slide-up-enter[data-v-06796ca9], .slide-up-leave-to[data-v-06796ca9] {\n  -webkit-transform: translateY(15px);\n          transform: translateY(15px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.left-panel[data-v-06796ca9] {\n    width: 100%;\n    padding-bottom: 100px;\n}\n.left-panel .heading[data-v-06796ca9] {\n      padding: 0 20px;\n      position: absolute;\n      width: 100%;\n}\n.left-panel .heading label[data-v-06796ca9] {\n        margin-left: 40px;\n}\n.left-panel .heading .button-actions[data-v-06796ca9] {\n        margin: 0;\n        margin-bottom: 10px;\n}\n.left-panel .heading div[data-v-06796ca9] {\n        float: none;\n        margin: 0;\n}\n.left-panel .heading div .button[data-v-06796ca9] {\n          width: 50%;\n}\n.left-panel .tab[data-v-06796ca9] {\n      margin: 35px 0 0;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      overflow-x: scroll;\n}\n.left-panel .tab li[data-v-06796ca9] {\n        width: auto;\n}\n.toggle-mobile[data-v-06796ca9] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.right-panel[data-v-06796ca9] {\n    z-index: 1;\n    width: 100%;\n    top: 100%;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n}\n.right-panel.mobile-right-panel[data-v-06796ca9] {\n      top: 0;\n      z-index: 2;\n}\n.right-panel.mobile-right-panel .tab[data-v-06796ca9] {\n        margin-top: 70px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        overflow-x: scroll;\n}\n.right-panel.mobile-right-panel .tab-contents[data-v-06796ca9] {\n        width: 100%;\n        height: calc(100vh - 142px);\n        overflow-y: scroll;\n}\n.right-panel.mobile-right-panel .tab-contents .tab-content[data-v-06796ca9] {\n          padding-bottom: 60px;\n}\n.right-panel.mobile-right-panel .tab-contents .tab-content.history-panel[data-v-06796ca9] {\n            padding: 0;\n            padding-top: 20px;\n            padding-bottom: 60px;\n}\n.right-panel.mobile-right-panel .tab-contents .fixed-footer[data-v-06796ca9] {\n          width: 100%;\n          bottom: 45px;\n          background: #fff;\n          color: #000;\n          border-top: 1px solid #aaa;\n}\n.right-panel.mobile-right-panel .logs-panel[data-v-06796ca9] {\n        width: 100%;\n}\n.fix-buttons[data-v-06796ca9] {\n    width: 100%;\n    bottom: 45px;\n}\n.fix-buttons a[data-v-06796ca9] {\n      margin: 0 auto;\n}\n.toggle-panel .heading[data-v-06796ca9] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoViewDetails_vue__ = __webpack_require__(511);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13968cf8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoViewDetails_vue__ = __webpack_require__(1432);
function injectStyle (ssrContext) {
  __webpack_require__(1430)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13968cf8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoViewDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13968cf8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoViewDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1431);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("a47f7900", content, true, {});

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.details[data-v-13968cf8] {\n  margin-top: 20px;\n  padding: 0 30px;\n}\n.data-field[data-v-13968cf8] {\n  font-weight: 600;\n  margin-bottom: 30px;\n}\n.data-field .label[data-v-13968cf8] {\n    color: #5495c3;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 120%;\n}\n.data-field .value[data-v-13968cf8] {\n    font-size: 17px;\n    color: #555;\n}\n.data-field .value.service-type[data-v-13968cf8] {\n      text-transform: capitalize;\n}\n.data-field .value.credit-card[data-v-13968cf8] {\n      font-size: 16px;\n}\n.data-field .value .fa-star[data-v-13968cf8] {\n      color: #f1d724;\n      margin-right: 5px;\n}\n.data-field .value .payment-trigger[data-v-13968cf8] {\n      font-size: 11px;\n      vertical-align: 3px;\n      text-decoration: underline;\n      margin-left: 2px;\n      cursor: pointer;\n}\n.data-field .value a[data-v-13968cf8] {\n      text-decoration: underline;\n      cursor: pointer;\n}\n.padding-L[data-v-13968cf8] {\n  padding-left: 10px;\n}\n.padding-R[data-v-13968cf8] {\n  padding-right: 10px;\n}\n@media only screen and (max-width: 430px) {\n.details[data-v-13968cf8] {\n    margin-top: 125px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Promo/PromoViewDetails.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,gBAAgB;CACjB;AACD;EACE,iBAAiB;EACjB,oBAAoB;CACrB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;IACI,gBAAgB;IAChB,YAAY;CACf;AACD;MACM,2BAA2B;CAChC;AACD;MACM,gBAAgB;CACrB;AACD;MACM,eAAe;MACf,kBAAkB;CACvB;AACD;MACM,gBAAgB;MAChB,oBAAoB;MACpB,2BAA2B;MAC3B,iBAAiB;MACjB,gBAAgB;CACrB;AACD;MACM,2BAA2B;MAC3B,gBAAgB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;AACA;IACI,kBAAkB;CACrB;CACA","file":"PromoViewDetails.vue","sourcesContent":["\n.details[data-v-13968cf8] {\n  margin-top: 20px;\n  padding: 0 30px;\n}\n.data-field[data-v-13968cf8] {\n  font-weight: 600;\n  margin-bottom: 30px;\n}\n.data-field .label[data-v-13968cf8] {\n    color: #5495c3;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 120%;\n}\n.data-field .value[data-v-13968cf8] {\n    font-size: 17px;\n    color: #555;\n}\n.data-field .value.service-type[data-v-13968cf8] {\n      text-transform: capitalize;\n}\n.data-field .value.credit-card[data-v-13968cf8] {\n      font-size: 16px;\n}\n.data-field .value .fa-star[data-v-13968cf8] {\n      color: #f1d724;\n      margin-right: 5px;\n}\n.data-field .value .payment-trigger[data-v-13968cf8] {\n      font-size: 11px;\n      vertical-align: 3px;\n      text-decoration: underline;\n      margin-left: 2px;\n      cursor: pointer;\n}\n.data-field .value a[data-v-13968cf8] {\n      text-decoration: underline;\n      cursor: pointer;\n}\n.padding-L[data-v-13968cf8] {\n  padding-left: 10px;\n}\n.padding-R[data-v-13968cf8] {\n  padding-right: 10px;\n}\n@media only screen and (max-width: 430px) {\n.details[data-v-13968cf8] {\n    margin-top: 125px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.promo.name))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Description")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.promo.description || '--'))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-4 padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Start Date")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.promo.startDate))])])])]),_vm._v(" "),_c('div',{staticClass:"column small-4 padding-L padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Expiration Date")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.promo.expirationDate))])])])]),_vm._v(" "),_c('div',{staticClass:"column small-4 end padding-L"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Days Valid after Redemption")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.promo.validDays))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-4 padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Valid Only for New Users")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.promo.validNewUser))])])])]),_vm._v(" "),_c('div',{staticClass:"column small-4 padding-L end"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Valid for Specific Services")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.promo.validServices))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-4 padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Promo Code")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.promo.code))])])])]),_vm._v(" "),_c('div',{staticClass:"column small-4 padding-L padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Credit Amount")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.promo.amount))])])])]),_vm._v(" "),_c('div',{staticClass:"column small-4 padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Total Codes")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.promo.totalCodes))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-4 padding-R end"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Codes Redeemed")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.promo.redeemedCodes))])])])]),_vm._v(" "),_c('div',{staticClass:"column small-4  padding-L end"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Codes Left")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',[_vm._v(_vm._s(_vm.promo.totalCodes - _vm.promo.redeemedCodes))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoViewEdit_vue__ = __webpack_require__(512);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e225171_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoViewEdit_vue__ = __webpack_require__(1436);
function injectStyle (ssrContext) {
  __webpack_require__(1434)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e225171"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoViewEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e225171_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoViewEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1435);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1b88aa62", content, true, {});

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.details[data-v-2e225171] {\n  margin: 20px 0 100px;\n  padding: 0 30px;\n}\n.data-field[data-v-2e225171] {\n  margin-bottom: 20px;\n}\n.data-field .label[data-v-2e225171] {\n    font-weight: 600;\n    color: #5495c3;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 120%;\n}\n.data-field .input[data-v-2e225171] {\n    margin: 1px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-2e225171] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-2e225171]:disabled {\n      background: #eee;\n}\n.data-field select[data-v-2e225171] {\n    border: 1px solid #ddd;\n    padding: 10px;\n    color: #333;\n    height: 45px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field select.has-error[data-v-2e225171] {\n      border-color: #f20d0d;\n}\n.data-field select[data-v-2e225171]:disabled {\n      background-color: #eee;\n}\n.data-field .error-msg[data-v-2e225171] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.datepicker[data-v-2e225171] {\n  margin-top: 1px;\n}\n.time[data-v-2e225171] {\n  display: inline-block;\n  line-height: 45px;\n}\n.error-box[data-v-2e225171] {\n  margin: 0 30px;\n  border: 1px solid #f34c31;\n  color: #f34c31;\n  padding: 5px;\n  margin-bottom: 15px;\n  font-size: 14px;\n  font-weight: 600;\n}\n.padding-L[data-v-2e225171] {\n  padding-left: 10px;\n}\n.padding-R[data-v-2e225171] {\n  padding-right: 10px;\n}\n.text-center[data-v-2e225171] {\n  text-align: center;\n}\n@media only screen and (max-width: 430px) {\n.details[data-v-2e225171] {\n    margin-top: 125px;\n}\n.small-4[data-v-2e225171] {\n    width: 100%;\n    padding: 0;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Promo/PromoViewEdit.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,gBAAgB;CACjB;AACD;EACE,oBAAoB;CACrB;AACD;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;IACI,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,wDAAwD;IACxD,6BAA6B;IAC7B,+BAA+B;IAC/B,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,uBAAuB;CAC5B;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,sBAAsB;EACtB,kBAAkB;CACnB;AACD;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;CAClB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;AACA;IACI,kBAAkB;CACrB;AACD;IACI,YAAY;IACZ,WAAW;CACd;CACA","file":"PromoViewEdit.vue","sourcesContent":["\n.details[data-v-2e225171] {\n  margin: 20px 0 100px;\n  padding: 0 30px;\n}\n.data-field[data-v-2e225171] {\n  margin-bottom: 20px;\n}\n.data-field .label[data-v-2e225171] {\n    font-weight: 600;\n    color: #5495c3;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 120%;\n}\n.data-field .input[data-v-2e225171] {\n    margin: 1px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-2e225171] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-2e225171]:disabled {\n      background: #eee;\n}\n.data-field select[data-v-2e225171] {\n    border: 1px solid #ddd;\n    padding: 10px;\n    color: #333;\n    height: 45px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field select.has-error[data-v-2e225171] {\n      border-color: #f20d0d;\n}\n.data-field select[data-v-2e225171]:disabled {\n      background-color: #eee;\n}\n.data-field .error-msg[data-v-2e225171] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.datepicker[data-v-2e225171] {\n  margin-top: 1px;\n}\n.time[data-v-2e225171] {\n  display: inline-block;\n  line-height: 45px;\n}\n.error-box[data-v-2e225171] {\n  margin: 0 30px;\n  border: 1px solid #f34c31;\n  color: #f34c31;\n  padding: 5px;\n  margin-bottom: 15px;\n  font-size: 14px;\n  font-weight: 600;\n}\n.padding-L[data-v-2e225171] {\n  padding-left: 10px;\n}\n.padding-R[data-v-2e225171] {\n  padding-right: 10px;\n}\n.text-center[data-v-2e225171] {\n  text-align: center;\n}\n@media only screen and (max-width: 430px) {\n.details[data-v-2e225171] {\n    margin-top: 125px;\n}\n.small-4[data-v-2e225171] {\n    width: 100%;\n    padding: 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.errorReturn),expression:"!!errorReturn"}],staticClass:"error-box"},[_vm._v(_vm._s(_vm.errorReturn))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.promoName),expression:"promoName"}],class:{'input':true, 'has-error':!!_vm.errorMsg.promoName},attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.promoName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.promoName=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.promoName))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"input",attrs:{"disabled":_vm.loading},domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Start Date")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-5 padding-R"},[_c('datepicker',{staticClass:"datepicker inline",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"disabled":_vm.startDateDisabled,"input-class":{'datepicker-empty':_vm.errorMsg.startDate}},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.startDate || _vm.errorMsg.startDateHour || _vm.errorMsg.startDateMinute))])],1),_vm._v(" "),_c('div',{staticClass:"column small-3 padding-L"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDateHour),expression:"startDateHour"}],class:{'has-error':!!_vm.errorMsg.startDateHour},attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.startDateHour=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Hour")]),_vm._v(" "),_vm._l((24),function(x){return _c('option',{domProps:{"value":_vm.leadingZero(x - 1)}},[_vm._v(_vm._s(_vm.leadingZero(x - 1)))])})],2)]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column small-3"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDateMinute),expression:"startDateMinute"}],class:{'has-error':!!_vm.errorMsg.startDateMinute},attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.startDateMinute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Minute")]),_vm._v(" "),_vm._l((12),function(x){return _c('option',{domProps:{"value":_vm.leadingZero((x - 1) * 5)}},[_vm._v(_vm._s(_vm.leadingZero((x - 1) * 5)))])})],2)])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Expiration Date")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-5 padding-R"},[_c('datepicker',{staticClass:"datepicker inline",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"disabled":_vm.expirationDateDisabled,"input-class":{'datepicker-empty':_vm.errorMsg.expirationDate}},model:{value:(_vm.expirationDate),callback:function ($$v) {_vm.expirationDate=$$v},expression:"expirationDate"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.expirationDate || _vm.errorMsg.expirationDateHour || _vm.errorMsg.expirationDateMinute))])],1),_vm._v(" "),_c('div',{staticClass:"column small-3 padding-L"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.expirationDateHour),expression:"expirationDateHour"}],class:{'has-error':!!_vm.errorMsg.expirationDateHour},attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.expirationDateHour=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Hour")]),_vm._v(" "),_vm._l((24),function(x){return _c('option',{domProps:{"value":_vm.leadingZero(x - 1)}},[_vm._v(_vm._s(_vm.leadingZero(x - 1)))])})],2)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"column small-3"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.expirationDateMinute),expression:"expirationDateMinute"}],class:{'has-error':!!_vm.errorMsg.expirationDateMinute},attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.expirationDateMinute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Minute")]),_vm._v(" "),_vm._l((12),function(x){return _c('option',{domProps:{"value":_vm.leadingZero((x - 1) * 5)}},[_vm._v(_vm._s(_vm.leadingZero((x - 1) * 5)))])})],2)])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-6 padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Days Valid after Redemption")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.validDays),expression:"validDays"}],class:{'input':true, 'has-error':!!_vm.errorMsg.validDays},attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.validDays)},on:{"input":function($event){if($event.target.composing){ return; }_vm.validDays=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.validDays))])])]),_vm._v(" "),_c('div',{staticClass:"column small-6 padding-L"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Valid Only for New Users")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.validNewUser),expression:"validNewUser"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.validNewUser=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Yes")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("No")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-4 padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Promo Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],class:{'input':true, 'has-error':!!_vm.errorMsg.code},attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.code))])])]),_vm._v(" "),_c('div',{staticClass:"column small-4 padding-R padding-L"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Credit Amount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],class:{'input':true, 'has-error':!!_vm.errorMsg.amount},attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.amount))])])]),_vm._v(" "),_c('div',{staticClass:"column small-4 padding-L"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Number of Codes to Redeem")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalCodes),expression:"totalCodes"}],class:{'input':true, 'has-error':!!_vm.errorMsg.totalCodes},attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.totalCodes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.totalCodes=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.totalCodes))])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-1 text-center"},[_c('span',{staticClass:"time"},[_vm._v(":")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-1 text-center"},[_c('span',{staticClass:"time"},[_vm._v(":")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoViewList_vue__ = __webpack_require__(513);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23c83e14_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoViewList_vue__ = __webpack_require__(1440);
function injectStyle (ssrContext) {
  __webpack_require__(1438)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23c83e14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoViewList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23c83e14_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoViewList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1439);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("158a37d1", content, true, {});

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.sticky[data-v-23c83e14] {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 60%;\n  overflow: hidden;\n  height: 30px;\n  z-index: 3;\n}\ntable[data-v-23c83e14] {\n  border-collapse: collapse;\n  width: 100%;\n  -webkit-transition: all .5s ease;\n  transition: all .5s ease;\n  margin-bottom: 49px;\n}\ntable.table-loading[data-v-23c83e14] {\n    opacity: .7;\n}\ntable thead[data-v-23c83e14] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-23c83e14] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-23c83e14] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-23c83e14] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-23c83e14] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr[data-v-23c83e14]:hover {\n      background: #e3e7e8 !important;\n}\ntable tbody tr[data-v-23c83e14]:nth-of-type(even) {\n      background: #fbfbfb;\n}\ntable tbody tr td[data-v-23c83e14] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-23c83e14] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-23c83e14] {\n          color: #ccc;\n}\ntable a[data-v-23c83e14] {\n    cursor: pointer;\n}\n.fix-footer[data-v-23c83e14] {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  width: 60%;\n  height: 50px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-23c83e14] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-23c83e14] {\n    max-width: 100px;\n    height: 30px;\n    padding: 5px;\n}\n.fix-footer .per-page[data-v-23c83e14] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 10px 0;\n}\n.fix-footer .per-page span[data-v-23c83e14] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-23c83e14] {\n    text-align: center;\n    line-height: 30px;\n    padding: 10px 0;\n}\n.fix-footer .pagination[data-v-23c83e14] {\n    text-align: right;\n    padding: 10px 10px;\n}\n.fix-footer .pagination span[data-v-23c83e14] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-23c83e14] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-23c83e14] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-23c83e14] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-23c83e14] {\n        opacity: .4;\n        cursor: default;\n}\n@media only screen and (max-width: 430px) {\n.cards[data-v-23c83e14] {\n    padding: 60px 0 100px 0;\n}\n.cards .card[data-v-23c83e14] {\n      border: 1px solid #ccc;\n      margin: 0 10px;\n      margin-bottom: 15px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n      padding: 10px;\n      padding-bottom: 5px;\n}\n.cards .card > div[data-v-23c83e14] {\n        margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-23c83e14] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        margin-bottom: 5px;\n}\n.cards .card .card-header .name[data-v-23c83e14] {\n          font-weight: 900;\n}\n.cards .card .card-header .amount[data-v-23c83e14] {\n          margin-left: 5px;\n          font-size: 14px;\n}\n.cards .card .card-header .status[data-v-23c83e14] {\n          text-transform: uppercase;\n          font-size: 14px;\n          font-weight: 900;\n}\n.cards .card .card-header .status .und[data-v-23c83e14] {\n            text-decoration: underline;\n}\n.cards .card .card-header .status .und.deactivate[data-v-23c83e14] {\n              color: #ccc;\n}\n.cards .card .title[data-v-23c83e14] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n}\n.cards .card .label[data-v-23c83e14] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards .card .value[data-v-23c83e14] {\n        margin-right: 10px;\n        font-size: 14px;\n        font-weight: 900;\n}\n.cards .card .actions[data-v-23c83e14] {\n        width: 100%;\n        background: #f3f3f3;\n        border-top: 1px solid #ccc;\n        padding: 15px 10px;\n        text-align: center;\n        margin-top: 15px;\n        border-radius: 0 0 10px 10px;\n        margin-bottom: 0;\n}\n.cards .card .actions .button[data-v-23c83e14] {\n          line-height: 14px;\n          font-size: 14px;\n          padding: 10px 18px 9px;\n}\n.fix-footer[data-v-23c83e14] {\n    bottom: 45px;\n    left: 0;\n    width: 100%;\n}\n.fix-footer .row[data-v-23c83e14] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n}\n.fix-footer .per-page[data-v-23c83e14] {\n      width: auto;\n}\n.fix-footer .per-page select[data-v-23c83e14] {\n        width: 55px;\n}\n.fix-footer .per-page span[data-v-23c83e14]:nth-child(3) {\n        display: none;\n}\n.fix-footer .page-data[data-v-23c83e14] {\n      display: none;\n}\n.fix-footer .pagination[data-v-23c83e14] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      margin-right: 15%;\n}\n.fix-footer .pagination select[data-v-23c83e14] {\n        width: 55px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Promo/PromoViewList.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,WAAW;CACZ;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,iCAAiC;EACjC,yBAAyB;EACzB,oBAAoB;CACrB;AACD;IACI,YAAY;CACf;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,2BAA2B;CAChC;AACD;QACQ,iBAAiB;CACxB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,+BAA+B;CACpC;AACD;MACM,oBAAoB;CACzB;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;IACI,gBAAgB;CACnB;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;CACb;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;IACjB,aAAa;IACb,aAAa;CAChB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;CACnB;AACD;MACM,sBAAsB;MACtB,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;CACnB;AACD;IACI,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,kBAAkB;CACvB;AACD;MACM,aAAa;MACb,uBAAuB;CAC5B;AACD;MACM,cAAc;MACd,eAAe;MACf,uBAAuB;MACvB,iBAAiB;MACjB,gBAAgB;MAChB,uBAAuB;MACvB,aAAa;CAClB;AACD;QACQ,kBAAkB;CACzB;AACD;QACQ,YAAY;QACZ,gBAAgB;CACvB;AACD;AACA;IACI,wBAAwB;CAC3B;AACD;MACM,uBAAuB;MACvB,eAAe;MACf,oBAAoB;MACpB,+BAA+B;MAC/B,oBAAoB;MACpB,cAAc;MACd,oBAAoB;CACzB;AACD;QACQ,mBAAmB;CAC1B;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,+BAA+B;QACvC,0BAA0B;YACtB,uBAAuB;gBACnB,oBAAoB;QAC5B,mBAAmB;CAC1B;AACD;UACU,iBAAiB;CAC1B;AACD;UACU,iBAAiB;UACjB,gBAAgB;CACzB;AACD;UACU,0BAA0B;UAC1B,gBAAgB;UAChB,iBAAiB;CAC1B;AACD;YACY,2BAA2B;CACtC;AACD;cACc,YAAY;CACzB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,oBAAoB;CACnC;AACD;QACQ,gBAAgB;QAChB,0BAA0B;QAC1B,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;CACzB;AACD;QACQ,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;CACxB;AACD;QACQ,YAAY;QACZ,oBAAoB;QACpB,2BAA2B;QAC3B,mBAAmB;QACnB,mBAAmB;QACnB,iBAAiB;QACjB,6BAA6B;QAC7B,iBAAiB;CACxB;AACD;UACU,kBAAkB;UAClB,gBAAgB;UAChB,uBAAuB;CAChC;AACD;IACI,aAAa;IACb,QAAQ;IACR,YAAY;CACf;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;CAC5C;AACD;MACM,YAAY;CACjB;AACD;QACQ,YAAY;CACnB;AACD;QACQ,cAAc;CACrB;AACD;MACM,cAAc;CACnB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;MAC5B,kBAAkB;CACvB;AACD;QACQ,YAAY;CACnB;CACA","file":"PromoViewList.vue","sourcesContent":["\n.sticky[data-v-23c83e14] {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 60%;\n  overflow: hidden;\n  height: 30px;\n  z-index: 3;\n}\ntable[data-v-23c83e14] {\n  border-collapse: collapse;\n  width: 100%;\n  -webkit-transition: all .5s ease;\n  transition: all .5s ease;\n  margin-bottom: 49px;\n}\ntable.table-loading[data-v-23c83e14] {\n    opacity: .7;\n}\ntable thead[data-v-23c83e14] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-23c83e14] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-23c83e14] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-23c83e14] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-23c83e14] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr[data-v-23c83e14]:hover {\n      background: #e3e7e8 !important;\n}\ntable tbody tr[data-v-23c83e14]:nth-of-type(even) {\n      background: #fbfbfb;\n}\ntable tbody tr td[data-v-23c83e14] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-23c83e14] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-23c83e14] {\n          color: #ccc;\n}\ntable a[data-v-23c83e14] {\n    cursor: pointer;\n}\n.fix-footer[data-v-23c83e14] {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  width: 60%;\n  height: 50px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-23c83e14] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-23c83e14] {\n    max-width: 100px;\n    height: 30px;\n    padding: 5px;\n}\n.fix-footer .per-page[data-v-23c83e14] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 10px 0;\n}\n.fix-footer .per-page span[data-v-23c83e14] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-23c83e14] {\n    text-align: center;\n    line-height: 30px;\n    padding: 10px 0;\n}\n.fix-footer .pagination[data-v-23c83e14] {\n    text-align: right;\n    padding: 10px 10px;\n}\n.fix-footer .pagination span[data-v-23c83e14] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-23c83e14] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-23c83e14] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-23c83e14] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-23c83e14] {\n        opacity: .4;\n        cursor: default;\n}\n@media only screen and (max-width: 430px) {\n.cards[data-v-23c83e14] {\n    padding: 60px 0 100px 0;\n}\n.cards .card[data-v-23c83e14] {\n      border: 1px solid #ccc;\n      margin: 0 10px;\n      margin-bottom: 15px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n      padding: 10px;\n      padding-bottom: 5px;\n}\n.cards .card > div[data-v-23c83e14] {\n        margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-23c83e14] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        margin-bottom: 5px;\n}\n.cards .card .card-header .name[data-v-23c83e14] {\n          font-weight: 900;\n}\n.cards .card .card-header .amount[data-v-23c83e14] {\n          margin-left: 5px;\n          font-size: 14px;\n}\n.cards .card .card-header .status[data-v-23c83e14] {\n          text-transform: uppercase;\n          font-size: 14px;\n          font-weight: 900;\n}\n.cards .card .card-header .status .und[data-v-23c83e14] {\n            text-decoration: underline;\n}\n.cards .card .card-header .status .und.deactivate[data-v-23c83e14] {\n              color: #ccc;\n}\n.cards .card .title[data-v-23c83e14] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n}\n.cards .card .label[data-v-23c83e14] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards .card .value[data-v-23c83e14] {\n        margin-right: 10px;\n        font-size: 14px;\n        font-weight: 900;\n}\n.cards .card .actions[data-v-23c83e14] {\n        width: 100%;\n        background: #f3f3f3;\n        border-top: 1px solid #ccc;\n        padding: 15px 10px;\n        text-align: center;\n        margin-top: 15px;\n        border-radius: 0 0 10px 10px;\n        margin-bottom: 0;\n}\n.cards .card .actions .button[data-v-23c83e14] {\n          line-height: 14px;\n          font-size: 14px;\n          padding: 10px 18px 9px;\n}\n.fix-footer[data-v-23c83e14] {\n    bottom: 45px;\n    left: 0;\n    width: 100%;\n}\n.fix-footer .row[data-v-23c83e14] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n}\n.fix-footer .per-page[data-v-23c83e14] {\n      width: auto;\n}\n.fix-footer .per-page select[data-v-23c83e14] {\n        width: 55px;\n}\n.fix-footer .per-page span[data-v-23c83e14]:nth-child(3) {\n        display: none;\n}\n.fix-footer .page-data[data-v-23c83e14] {\n      display: none;\n}\n.fix-footer .pagination[data-v-23c83e14] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      margin-right: 15%;\n}\n.fix-footer .pagination select[data-v-23c83e14] {\n        width: 55px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list"},[(!_vm.isMobile)?_c('div',[(_vm.showFixedHeader)?_c('div',{staticClass:"sticky"},[_c('table',{class:{'table-loading':_vm.loading}},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.promos),function(promo){return _c('tr',[_c('td',[_vm._v(_vm._s(promo.placed))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.promoCode))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.status))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"und",attrs:{"href":'/#/consumer/' + promo.conID,"target":"_blank"}},[_vm._v(_vm._s(promo.conID))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.redeemedDate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.expirationDate))])])}),0)])]):_vm._e(),_vm._v(" "),_c('table',{class:{'table-loading':_vm.loading}},[_vm._m(1),_vm._v(" "),_c('tbody',[_vm._l((_vm.promos),function(promo){return _c('tr',[_c('td',[_vm._v(_vm._s(promo.placed))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.promoCode))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.status))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"und",attrs:{"href":'/#/consumer/' + promo.conID,"target":"_blank"}},[_vm._v(_vm._s(promo.conID))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.redeemedDate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(promo.expirationDate))])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading && !_vm.promos.length),expression:"loading && !promos.length"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"6"}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('div',[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n                  Loading...\n                ")])])])],1)]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && !_vm.promos.length),expression:"!loading && !promos.length"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"6"}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.promos.length === 0 && !_vm.loading),expression:"promos.length === 0 && !loading"}],staticClass:"empty-result"},[_c('i',{staticClass:"far fa-frown-open fa-3x"}),_c('br'),_vm._v("\n                No record found!\n              ")])])],1)])],2)])]):_c('div',{staticClass:"cards"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading && !_vm.promos.length),expression:"loading && !promos.length"}]},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('div',[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n            Loading...\n          ")])])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && !_vm.promos.length),expression:"!loading && !promos.length"}]},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.promos.length === 0 && !_vm.loading),expression:"promos.length === 0 && !loading"}],staticClass:"empty-result"},[_c('i',{staticClass:"far fa-frown-open fa-3x"}),_c('br'),_vm._v("\n          No record found!\n        ")])])],1),_vm._v(" "),_vm._l((_vm.promos),function(promo){return _c('div',{key:promo.id,staticClass:"card"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("#"+_vm._s(promo.placed))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Promo Code:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(promo.promoCode))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Status:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(promo.status))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Redeemed by:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{staticClass:"und",attrs:{"href":'/#/consumer/' + promo.conID,"target":"_blank"}},[_vm._v(_vm._s(promo.conID))])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Redeemed Date:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(promo.redeemedDate))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Expiration Date:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(promo.expirationDate))])])])})],2),_vm._v(" "),_c('div',{staticClass:"fix-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-3 columns per-page"},[_c('span',[_vm._v("Displaying")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" "),_c('span',[_vm._v("per page")])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns page-data"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.promos.length > 0),expression:"promos.length > 0"}]},[_vm._v("\n          Displaying\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.start))]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.pageData.end))]),_vm._v(" of\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.max))])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns pagination"},[_c('span',[_vm._v("Page")]),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.currentPage === 1 || _vm.loading},on:{"click":_vm.prev}},[_c('i',{staticClass:"fas fa-chevron-left"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentPage),expression:"currentPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.totalPage),function(i){return _c('option',{domProps:{"value":i}},[_vm._v(_vm._s(i))])}),0),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.isLastPage || _vm.loading},on:{"click":_vm.next}},[_c('i',{staticClass:"fas fa-chevron-right"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Promo Code")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Redeemed by")]),_vm._v(" "),_c('th',[_vm._v("Redeemed Date")]),_vm._v(" "),_c('th',[_vm._v("Expiration Date")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Promo Code")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Redeemed by")]),_vm._v(" "),_c('th',[_vm._v("Redeemed Date")]),_vm._v(" "),_c('th',[_vm._v("Expiration Date")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"left-panel"},[_c('div',{staticClass:"heading"},[_c('label',[_vm._v("PROMO DETAILS")]),_vm._v(" "),_c('div',{staticClass:"button-actions"},[_c('div',{class:['button cta small', _vm.edit ? 'error' : 'warning', _vm.viewSaving ? 'disabled' : ''],on:{"click":_vm.toggleEdit}},[(!_vm.edit)?_c('span',[_vm._v("edit")]):_c('span',[_vm._v("cancel")])]),_vm._v(" "),_c('div',{class:{'button cta small success':true, 'disabled':_vm.edit || _vm.viewSaving},on:{"click":function($event){return _vm.exportPromo(_vm.$route.params.id)}}},[_vm._v("export")])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('promo-view-edit',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],ref:"viewEdit"})],1),_vm._v(" "),_c('promo-view-details',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}]}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[(_vm.edit)?_c('div',{staticClass:"fix-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-4 small-offset-2"},[_c('div',{class:{'button cta error block small': true, 'disabled':_vm.viewSaving},on:{"click":function($event){_vm.edit = false}}},[_vm._v("Cancel")])]),_vm._v(" "),_c('div',{staticClass:"column small-4 end"},[_c('div',{class:{'button cta success block small': true, 'disabled':_vm.viewSaving},on:{"click":_vm.save}},[(!_vm.viewSaving)?_c('span',[_vm._v("Save")]):_c('span',[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n                Loading\n              ")])])])])]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"toggle-mobile",on:{"click":function($event){_vm.showRecords = !_vm.showRecords}}},[(!_vm.showRecords)?_c('span',[_vm._v("Show Records "),_c('i',{staticClass:"fa fa-chevron-up"})]):_c('span',[_vm._v("Hide Records "),_c('i',{staticClass:"fa fa-chevron-down"})])]),_vm._v(" "),_c('div',{class:['right-panel', _vm.showRecords ? 'mobile-right-panel' : ''],on:{"scroll":_vm.onScroll}},[_c('promo-view-list',{attrs:{"showFixedHeader":_vm.showFixedHeader,"isMobile":_vm.isMobile}})],1),_vm._v(" "),_c('loading-modal',{attrs:{"showModal":_vm.dataLoading,"modalMessage":"Getting Promo Data..."}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(514);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a2f005c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1445);
function injectStyle (ssrContext) {
  __webpack_require__(1443)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a2f005c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a2f005c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1444);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("780ddcca", content, true, {});

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.panel[data-v-6a2f005c] {\n  z-index: 1;\n  position: fixed;\n  width: 995px;\n  top: 0;\n  left: 0;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n}\n.right-panel[data-v-6a2f005c] {\n  z-index: 0;\n  position: fixed;\n  top: 0;\n  left: 995px;\n  width: calc(100% - 995px);\n  height: 100%;\n}\n.right-panel .map[data-v-6a2f005c] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 55%;\n}\n.right-panel .dropzone-container[data-v-6a2f005c] {\n    position: absolute;\n    top: 55%;\n    left: 0;\n    width: 100%;\n    height: 45%;\n    -webkit-box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.25);\n            box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.25);\n}\n.tabs[data-v-6a2f005c] {\n  position: relative;\n  z-index: 1;\n  padding: 10px 10px 0 10px;\n}\n.tabs .tab[data-v-6a2f005c] {\n    display: inline-block;\n    background-color: rgba(255, 255, 255, 0);\n    font-size: 14px;\n    font-weight: 700;\n    padding: 10px 20px;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    border-bottom: 0;\n    text-decoration: none;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.tabs .tab.active[data-v-6a2f005c] {\n      background-color: #f5f5f5;\n      pointer-events: none;\n}\n.tab-contents[data-v-6a2f005c] {\n  margin-top: -1px;\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n  background-color: #f5f5f5;\n  position: relative;\n  z-index: 0;\n  width: 100%;\n  height: calc(100% - 102px);\n}\n.tab-contents .tab-content[data-v-6a2f005c] {\n    display: none;\n    height: 100%;\n    overflow: auto;\n}\n.tab-contents .tab-content.active[data-v-6a2f005c] {\n      display: block;\n}\n.tab-contents .tab-content.with-control[data-v-6a2f005c] {\n      height: calc(100% - 80px);\n}\n.tab-contents .tab-control[data-v-6a2f005c] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    background-color: #fff;\n    width: 100%;\n    border-top: 1px solid rgba(0, 0, 0, 0.3);\n    padding: 20px 10px;\n}\n.infinity-loader[data-v-6a2f005c] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  -webkit-transform-origin: bottom center;\n          transform-origin: bottom center;\n  text-align: center;\n  font-size: 18px;\n  line-height: 40px;\n}\n.slide-up-enter-active[data-v-6a2f005c], .slide-up-leave-active[data-v-6a2f005c] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-6a2f005c], .slide-up-leave-to[data-v-6a2f005c] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media screen and (max-width: 430px) {\n.toggle-mobile[data-v-6a2f005c] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 50px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.tab-contents .tab-control[data-v-6a2f005c] {\n    bottom: 50px;\n    padding: 10px 5px;\n}\n.panel[data-v-6a2f005c] {\n    width: 100%;\n}\n.right-panel[data-v-6a2f005c] {\n    left: 0;\n    width: 100%;\n    z-index: 5;\n    top: 100%;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n    background-color: #fff;\n}\n.right-panel.showMapBox[data-v-6a2f005c] {\n      top: 0;\n}\n.right-panel .map[data-v-6a2f005c] {\n      height: 35%;\n}\n.right-panel .dropzone-container[data-v-6a2f005c] {\n      top: 35%;\n      height: 65%;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Routing/index.vue"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,OAAO;EACP,QAAQ;EACR,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;CACnD;AACD;EACE,WAAW;EACX,gBAAgB;EAChB,OAAO;EACP,YAAY;EACZ,0BAA0B;EAC1B,aAAa;CACd;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,YAAY;CACf;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;EACE,mBAAmB;EACnB,WAAW;EACX,0BAA0B;CAC3B;AACD;IACI,sBAAsB;IACtB,yCAAyC;IACzC,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,qCAAqC;IACrC,iBAAiB;IACjB,sBAAsB;IACtB,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;MACM,0BAA0B;MAC1B,qBAAqB;CAC1B;AACD;EACE,iBAAiB;EACjB,yCAAyC;EACzC,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,2BAA2B;CAC5B;AACD;IACI,cAAc;IACd,aAAa;IACb,eAAe;CAClB;AACD;MACM,eAAe;CACpB;AACD;MACM,0BAA0B;CAC/B;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,uBAAuB;IACvB,YAAY;IACZ,yCAAyC;IACzC,mBAAmB;CACtB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,wCAAwC;UAChC,gCAAgC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;AACA;IACI,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;IACrB,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;CACpB;AACD;IACI,aAAa;IACb,kBAAkB;CACrB;AACD;IACI,YAAY;CACf;AACD;IACI,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,UAAU;IACV,kCAAkC;IAClC,0BAA0B;IAC1B,uBAAuB;CAC1B;AACD;MACM,OAAO;CACZ;AACD;MACM,YAAY;CACjB;AACD;MACM,SAAS;MACT,YAAY;CACjB;CACA","file":"index.vue","sourcesContent":["\n.panel[data-v-6a2f005c] {\n  z-index: 1;\n  position: fixed;\n  width: 995px;\n  top: 0;\n  left: 0;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n}\n.right-panel[data-v-6a2f005c] {\n  z-index: 0;\n  position: fixed;\n  top: 0;\n  left: 995px;\n  width: calc(100% - 995px);\n  height: 100%;\n}\n.right-panel .map[data-v-6a2f005c] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 55%;\n}\n.right-panel .dropzone-container[data-v-6a2f005c] {\n    position: absolute;\n    top: 55%;\n    left: 0;\n    width: 100%;\n    height: 45%;\n    -webkit-box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.25);\n            box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.25);\n}\n.tabs[data-v-6a2f005c] {\n  position: relative;\n  z-index: 1;\n  padding: 10px 10px 0 10px;\n}\n.tabs .tab[data-v-6a2f005c] {\n    display: inline-block;\n    background-color: rgba(255, 255, 255, 0);\n    font-size: 14px;\n    font-weight: 700;\n    padding: 10px 20px;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    border-bottom: 0;\n    text-decoration: none;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.tabs .tab.active[data-v-6a2f005c] {\n      background-color: #f5f5f5;\n      pointer-events: none;\n}\n.tab-contents[data-v-6a2f005c] {\n  margin-top: -1px;\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n  background-color: #f5f5f5;\n  position: relative;\n  z-index: 0;\n  width: 100%;\n  height: calc(100% - 102px);\n}\n.tab-contents .tab-content[data-v-6a2f005c] {\n    display: none;\n    height: 100%;\n    overflow: auto;\n}\n.tab-contents .tab-content.active[data-v-6a2f005c] {\n      display: block;\n}\n.tab-contents .tab-content.with-control[data-v-6a2f005c] {\n      height: calc(100% - 80px);\n}\n.tab-contents .tab-control[data-v-6a2f005c] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    background-color: #fff;\n    width: 100%;\n    border-top: 1px solid rgba(0, 0, 0, 0.3);\n    padding: 20px 10px;\n}\n.infinity-loader[data-v-6a2f005c] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  -webkit-transform-origin: bottom center;\n          transform-origin: bottom center;\n  text-align: center;\n  font-size: 18px;\n  line-height: 40px;\n}\n.slide-up-enter-active[data-v-6a2f005c], .slide-up-leave-active[data-v-6a2f005c] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-6a2f005c], .slide-up-leave-to[data-v-6a2f005c] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media screen and (max-width: 430px) {\n.toggle-mobile[data-v-6a2f005c] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 50px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.tab-contents .tab-control[data-v-6a2f005c] {\n    bottom: 50px;\n    padding: 10px 5px;\n}\n.panel[data-v-6a2f005c] {\n    width: 100%;\n}\n.right-panel[data-v-6a2f005c] {\n    left: 0;\n    width: 100%;\n    z-index: 5;\n    top: 100%;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n    background-color: #fff;\n}\n.right-panel.showMapBox[data-v-6a2f005c] {\n      top: 0;\n}\n.right-panel .map[data-v-6a2f005c] {\n      height: 35%;\n}\n.right-panel .dropzone-container[data-v-6a2f005c] {\n      top: 35%;\n      height: 65%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"routing-page"},[_c('div',{staticClass:"panel"},[_c('routing-header'),_vm._v(" "),_c('div',{staticClass:"tabs"},[_c('a',{class:{ tab: true, active: _vm.activeTabIndex === 0 },attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.activeTabIndex = 0}}},[_vm._v("\n        UNPACKAGED RESERVATIONS\n      ")]),_vm._v(" "),_c('a',{class:{ tab: true, active: _vm.activeTabIndex === 1 },attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.activeTabIndex = 1}}},[_vm._v("\n        PACKAGES\n      ")])]),_vm._v(" "),_c('div',{staticClass:"tab-contents"},[_c('div',{class:{ 'tab-content': true, active: _vm.activeTabIndex === 0 },attrs:{"id":"routing-reservations-table"},on:{"scroll":_vm.onScrollUnpackage}},[_c('reservations-table',{ref:"routingRsvpTable",attrs:{"isMobile":_vm.isMobile}})],1),_vm._v(" "),_c('div',{class:{ 'tab-content with-control': true, active: _vm.activeTabIndex === 1 },attrs:{"id":"routing-packages-table"},on:{"scroll":_vm.onScrollPackage}},[_c('packages-table',{ref:"routingPkgTable",attrs:{"forDispatch":false,"isMobile":_vm.isMobile}}),_vm._v(" "),_c('packages-control',{staticClass:"tab-control",attrs:{"forDispatch":false}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"toggle-mobile",on:{"click":function($event){_vm.showMapMobile = !_vm.showMapMobile}}},[(!_vm.showMapMobile)?_c('span',[_vm._v("Show Map "),_c('i',{staticClass:"fa fa-chevron-up"})]):_c('span',[_vm._v("Hide Map "),_c('i',{staticClass:"fa fa-chevron-down"})])]),_vm._v(" "),_c('div',{class:['right-panel', _vm.showMapMobile ? 'showMapBox' : '']},[_c('div',{staticClass:"map"},[_c('routing-map2')],1),_vm._v(" "),_c('div',{staticClass:"dropzone-container"},[_c('drop-zone')],1)]),_vm._v(" "),_c('routing-modal'),_vm._v(" "),_c('ready-to-go-modal'),_vm._v(" "),_c('pickup-date-modal')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(515);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7be8fc2c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1529);
function injectStyle (ssrContext) {
  __webpack_require__(1447)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7be8fc2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7be8fc2c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1448);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("00e774fc", content, true, {});

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.reports[data-v-7be8fc2c] {\n  margin-bottom: 170px;\n}\n.header[data-v-7be8fc2c] {\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.report-box[data-v-7be8fc2c] {\n  background: #fff;\n  max-width: 800px;\n  margin: 20px auto;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.15);\n          box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.15);\n}\n.instructions[data-v-7be8fc2c] {\n  padding: 15px;\n  font-weight: 700;\n  color: #333;\n  font-size: 18px;\n  background: #e8e8e8;\n  border-bottom: 1px solid #ccc;\n}\n.report-option[data-v-7be8fc2c] {\n  background: #f8f8f8;\n  border-bottom: 1px solid #ddd;\n}\n.report-option > *[data-v-7be8fc2c] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.report-option.active[data-v-7be8fc2c] {\n    background: #fff;\n}\n.report-option.toggleable[data-v-7be8fc2c] {\n    cursor: pointer;\n}\n.report-option span[data-v-7be8fc2c] {\n    width: 250px;\n    font-weight: 700;\n    font-size: 16px;\n    color: #555;\n    line-height: 40px;\n}\n.report-option .f-right[data-v-7be8fc2c] {\n    float: right;\n}\n.report-option .heading[data-v-7be8fc2c] {\n    padding: 10px 15px;\n    display: block;\n}\n.report-option .heading[data-v-7be8fc2c]:hover {\n      background: #fff;\n}\n.report-option .heading .fa-chevron-down[data-v-7be8fc2c] {\n      float: right;\n      line-height: 40px;\n      color: #999;\n      -webkit-transition: all .4s ease;\n      transition: all .4s ease;\n}\n.report-option .heading .fa-chevron-down.show[data-v-7be8fc2c] {\n        -webkit-transform: rotate(-180deg);\n                transform: rotate(-180deg);\n        color: #777;\n}\n.daily-rsvp-rep[data-v-7be8fc2c] {\n  margin-left: 3px;\n  vertical-align: middle;\n}\n.slide-down-enter-active[data-v-7be8fc2c], .slide-down-leave-active[data-v-7be8fc2c] {\n  -webkit-transition: all .5s ease;\n  transition: all .5s ease;\n}\n.slide-down-enter[data-v-7be8fc2c], .slide-down-leave-to[data-v-7be8fc2c] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.report-option .heading .fa-chevron-down[data-v-7be8fc2c] {\n    font-size: 16px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Reports/index.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;CACtB;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,6CAA6C;CAC9C;AACD;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,oDAAoD;UAC5C,4CAA4C;CACrD;AACD;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;CAC/B;AACD;EACE,oBAAoB;EACpB,8BAA8B;CAC/B;AACD;IACI,sBAAsB;IACtB,uBAAuB;CAC1B;AACD;IACI,iBAAiB;CACpB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;CACrB;AACD;IACI,aAAa;CAChB;AACD;IACI,mBAAmB;IACnB,eAAe;CAClB;AACD;MACM,iBAAiB;CACtB;AACD;MACM,aAAa;MACb,kBAAkB;MAClB,YAAY;MACZ,iCAAiC;MACjC,yBAAyB;CAC9B;AACD;QACQ,mCAAmC;gBAC3B,2BAA2B;QACnC,YAAY;CACnB;AACD;EACE,iBAAiB;EACjB,uBAAuB;CACxB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;AACA;IACI,gBAAgB;CACnB;CACA","file":"index.vue","sourcesContent":["\n.reports[data-v-7be8fc2c] {\n  margin-bottom: 170px;\n}\n.header[data-v-7be8fc2c] {\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.report-box[data-v-7be8fc2c] {\n  background: #fff;\n  max-width: 800px;\n  margin: 20px auto;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.15);\n          box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.15);\n}\n.instructions[data-v-7be8fc2c] {\n  padding: 15px;\n  font-weight: 700;\n  color: #333;\n  font-size: 18px;\n  background: #e8e8e8;\n  border-bottom: 1px solid #ccc;\n}\n.report-option[data-v-7be8fc2c] {\n  background: #f8f8f8;\n  border-bottom: 1px solid #ddd;\n}\n.report-option > *[data-v-7be8fc2c] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.report-option.active[data-v-7be8fc2c] {\n    background: #fff;\n}\n.report-option.toggleable[data-v-7be8fc2c] {\n    cursor: pointer;\n}\n.report-option span[data-v-7be8fc2c] {\n    width: 250px;\n    font-weight: 700;\n    font-size: 16px;\n    color: #555;\n    line-height: 40px;\n}\n.report-option .f-right[data-v-7be8fc2c] {\n    float: right;\n}\n.report-option .heading[data-v-7be8fc2c] {\n    padding: 10px 15px;\n    display: block;\n}\n.report-option .heading[data-v-7be8fc2c]:hover {\n      background: #fff;\n}\n.report-option .heading .fa-chevron-down[data-v-7be8fc2c] {\n      float: right;\n      line-height: 40px;\n      color: #999;\n      -webkit-transition: all .4s ease;\n      transition: all .4s ease;\n}\n.report-option .heading .fa-chevron-down.show[data-v-7be8fc2c] {\n        -webkit-transform: rotate(-180deg);\n                transform: rotate(-180deg);\n        color: #777;\n}\n.daily-rsvp-rep[data-v-7be8fc2c] {\n  margin-left: 3px;\n  vertical-align: middle;\n}\n.slide-down-enter-active[data-v-7be8fc2c], .slide-down-leave-active[data-v-7be8fc2c] {\n  -webkit-transition: all .5s ease;\n  transition: all .5s ease;\n}\n.slide-down-enter[data-v-7be8fc2c], .slide-down-leave-to[data-v-7be8fc2c] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.report-option .heading .fa-chevron-down[data-v-7be8fc2c] {\n    font-size: 16px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProviderRatingReport_vue__ = __webpack_require__(516);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6762d3a4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProviderRatingReport_vue__ = __webpack_require__(1452);
function injectStyle (ssrContext) {
  __webpack_require__(1450)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6762d3a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProviderRatingReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6762d3a4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProviderRatingReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1451);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0f6d36fb", content, true, {});

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.rsvp-report-box[data-v-6762d3a4] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-6762d3a4] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-6762d3a4] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-6762d3a4] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-6762d3a4] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-6762d3a4] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-6762d3a4] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-6762d3a4] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-6762d3a4] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-6762d3a4]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-6762d3a4] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-6762d3a4] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-6762d3a4] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-6762d3a4] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-6762d3a4]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-6762d3a4], .rsvp-report .reports .report.loading[data-v-6762d3a4], .rsvp-report .reports .report.has-error[data-v-6762d3a4], .rsvp-report .reports .report.success[data-v-6762d3a4] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-6762d3a4] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-6762d3a4] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-6762d3a4] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-6762d3a4] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-6762d3a4] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-6762d3a4] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-6762d3a4] {\n    cursor: pointer;\n}\n.filter input[data-v-6762d3a4] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.download-type[data-v-6762d3a4] {\n  float: right;\n  width: 150px;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-6762d3a4] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-6762d3a4] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-6762d3a4] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-6762d3a4] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-6762d3a4] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-6762d3a4] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-6762d3a4] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-6762d3a4] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-6762d3a4]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-6762d3a4] {\n      font-size: 13px;\n}\n.form-group[data-v-6762d3a4] {\n  display: block;\n}\n.form-group .instruction[data-v-6762d3a4] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-6762d3a4] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox > *[data-v-6762d3a4] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-6762d3a4] {\n    margin-right: 3px;\n}\n.padding-R[data-v-6762d3a4] {\n  padding-right: 7px;\n}\n.padding-L[data-v-6762d3a4] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-6762d3a4] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#pdf-view .page[data-v-6762d3a4] {\n    padding: 30px 40px 30px 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-6762d3a4] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-6762d3a4] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-6762d3a4] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-6762d3a4] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-6762d3a4] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-6762d3a4] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-6762d3a4], #pdf-view table tbody tr.total[data-v-6762d3a4] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-6762d3a4] {\n      color: #000;\n      font-size: 12px;\n}\n#pdf-view table tbody td[data-v-6762d3a4] {\n      padding: 2px 3px;\n}\n.report-rating[data-v-6762d3a4] {\n  height: 1122px !important;\n  width: 793px !important;\n}\n.report-rating table tbody tr.total[data-v-6762d3a4] {\n    border-top: 1px solid #333;\n}\n.report-rating table .date[data-v-6762d3a4], .report-rating table .rsvpId[data-v-6762d3a4], .report-rating table .driverId[data-v-6762d3a4], .report-rating table .driver[data-v-6762d3a4], .report-rating table .customerId[data-v-6762d3a4], .report-rating table .customer[data-v-6762d3a4], .report-rating table .rating[data-v-6762d3a4], .report-rating table .message[data-v-6762d3a4] {\n    text-align: center;\n}\n.report-release table tbody td[data-v-6762d3a4] {\n  text-align: center;\n}\n.slide-down-enter-active[data-v-6762d3a4], .slide-down-leave-active[data-v-6762d3a4] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-6762d3a4], .slide-down-leave-to[data-v-6762d3a4] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.end-date[data-v-6762d3a4] .vdp-datepicker__calendar {\n    right: 1px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Reports/ProviderRatingReport.vue"],"names":[],"mappings":";AACA;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,qBAAqB;CACtB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,eAAe;CACpB;AACD;MACM,cAAc;MACd,aAAa;MACb,cAAc;MACd,yBAAyB;MACzB,sBAAsB;MACtB,iBAAiB;MACjB,sBAAsB;MACtB,gBAAgB;MAChB,YAAY;MACZ,wDAAwD;MACxD,6BAA6B;MAC7B,+BAA+B;CACpC;AACD;QACQ,0BAA0B;CACjC;AACD;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;CACtB;AACD;MACM,mBAAmB;MACnB,WAAW;CAChB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,+BAA+B;CACtC;AACD;UACU,YAAY;CACrB;AACD;QACQ,kBAAkB;QAClB,oBAAoB;QACpB,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,iCAAiC;QACjC,yBAAyB;CAChC;AACD;UACU,oBAAoB;UACpB,mBAAmB;CAC5B;AACD;UACU,oBAAoB;CAC7B;AACD;QACQ,WAAW;QACX,+CAA+C;gBACvC,uCAAuC;CACtD;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,cAAc;IACd,YAAY;CACf;AACD;IACI,gBAAgB;CACnB;AACD;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;CAC1B;AACD;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,oBAAoB;CACrB;AACD;IACI,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;CAC1B;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,gBAAgB;MAChB,cAAc;MACd,YAAY;MACZ,qBAAqB;CAC1B;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;CACtB;AACD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;IACI,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,iBAAiB;CACpB;AACD;MACM,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;CACxB;AACD;MACM,gBAAgB;CACrB;AACD;EACE,eAAe;CAChB;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,YAAY;CACf;AACD;IACI,kBAAkB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,aAAa;EACb,eAAe;EACf,iBAAiB;CAClB;AACD;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,aAAa;CAChB;AACD;MACM,mBAAmB;MACnB,aAAa;MACb,YAAY;MACZ,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;CACxB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;CACf;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,iBAAiB;CACtB;AACD;QACQ,8BAA8B;CACrC;AACD;MACM,iBAAiB;CACtB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;MACM,iBAAiB;CACtB;AACD;EACE,0BAA0B;EAC1B,wBAAwB;CACzB;AACD;IACI,2BAA2B;CAC9B;AACD;IACI,mBAAmB;CACtB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;AACA;IACI,WAAW;CACd;CACA","file":"ProviderRatingReport.vue","sourcesContent":["\n.rsvp-report-box[data-v-6762d3a4] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-6762d3a4] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-6762d3a4] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-6762d3a4] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-6762d3a4] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-6762d3a4] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-6762d3a4] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-6762d3a4] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-6762d3a4] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-6762d3a4]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-6762d3a4] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-6762d3a4] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-6762d3a4] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-6762d3a4] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-6762d3a4]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-6762d3a4], .rsvp-report .reports .report.loading[data-v-6762d3a4], .rsvp-report .reports .report.has-error[data-v-6762d3a4], .rsvp-report .reports .report.success[data-v-6762d3a4] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-6762d3a4] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-6762d3a4] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-6762d3a4] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-6762d3a4] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-6762d3a4] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-6762d3a4] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-6762d3a4] {\n    cursor: pointer;\n}\n.filter input[data-v-6762d3a4] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.download-type[data-v-6762d3a4] {\n  float: right;\n  width: 150px;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-6762d3a4] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-6762d3a4] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-6762d3a4] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-6762d3a4] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-6762d3a4] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-6762d3a4] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-6762d3a4] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-6762d3a4] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-6762d3a4]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-6762d3a4] {\n      font-size: 13px;\n}\n.form-group[data-v-6762d3a4] {\n  display: block;\n}\n.form-group .instruction[data-v-6762d3a4] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-6762d3a4] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox > *[data-v-6762d3a4] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-6762d3a4] {\n    margin-right: 3px;\n}\n.padding-R[data-v-6762d3a4] {\n  padding-right: 7px;\n}\n.padding-L[data-v-6762d3a4] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-6762d3a4] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#pdf-view .page[data-v-6762d3a4] {\n    padding: 30px 40px 30px 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-6762d3a4] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-6762d3a4] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-6762d3a4] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-6762d3a4] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-6762d3a4] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-6762d3a4] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-6762d3a4], #pdf-view table tbody tr.total[data-v-6762d3a4] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-6762d3a4] {\n      color: #000;\n      font-size: 12px;\n}\n#pdf-view table tbody td[data-v-6762d3a4] {\n      padding: 2px 3px;\n}\n.report-rating[data-v-6762d3a4] {\n  height: 1122px !important;\n  width: 793px !important;\n}\n.report-rating table tbody tr.total[data-v-6762d3a4] {\n    border-top: 1px solid #333;\n}\n.report-rating table .date[data-v-6762d3a4], .report-rating table .rsvpId[data-v-6762d3a4], .report-rating table .driverId[data-v-6762d3a4], .report-rating table .driver[data-v-6762d3a4], .report-rating table .customerId[data-v-6762d3a4], .report-rating table .customer[data-v-6762d3a4], .report-rating table .rating[data-v-6762d3a4], .report-rating table .message[data-v-6762d3a4] {\n    text-align: center;\n}\n.report-release table tbody td[data-v-6762d3a4] {\n  text-align: center;\n}\n.slide-down-enter-active[data-v-6762d3a4], .slide-down-leave-active[data-v-6762d3a4] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-6762d3a4], .slide-down-leave-to[data-v-6762d3a4] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.end-date[data-v-6762d3a4] .vdp-datepicker__calendar {\n    right: 1px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rsvp-report-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"instruction"},[_vm._v("Please select a start and end date:")]),_vm._v(" "),_c('div',{staticClass:"row expanded"},[_c('div',{staticClass:"small-6 column padding-R"},[_c('div',{staticClass:"date-input"},[_c('label',[_vm._v("Start Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}})],1)]),_vm._v(" "),_c('div',{staticClass:"small-6 column padding-L"},[_c('div',{staticClass:"date-input end-date"},[_c('label',[_vm._v("End Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"list-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"download-type"},[_c('label',{class:{'pdf':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pdfChecked),expression:"pdfChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.pdfChecked)?_vm._i(_vm.pdfChecked,null)>-1:(_vm.pdfChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.pdfChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.pdfChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.pdfChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.pdfChecked=$$c}}}}),_vm._v("\n            PDF\n          ")]),_vm._v(" "),_c('label',{class:{'csv':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.csvChecked),expression:"csvChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.csvChecked)?_vm._i(_vm.csvChecked,null)>-1:(_vm.csvChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.csvChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.csvChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.csvChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.csvChecked=$$c}}}}),_vm._v("\n            CSV\n          ")])]),_vm._v(" "),_c('div',{staticClass:"instruction"},[_vm._v("Please select the reports to generate:")]),_vm._v(" "),_c('div',{staticClass:"row expanded reports"},[_c('div',{class:['small-12 column report', _vm.reportStatus.byRating, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.byRating),expression:"selectedReports.byRating"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.byRating)?_vm._i(_vm.selectedReports.byRating,null)>-1:(_vm.selectedReports.byRating)},on:{"change":function($event){var $$a=_vm.selectedReports.byRating,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "byRating", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "byRating", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "byRating", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('byRating')))])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.rating),expression:"rating"}],class:{disabled:!_vm.selectedReports.byRating},attrs:{"disabled":!_vm.selectedReports.byRating},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.rating=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("All")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("4")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("3")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("1")])])]),_vm._v(" "),_c('div',{staticClass:"small-12 column report"},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.driverRelease),expression:"selectedReports.driverRelease"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.driverRelease)?_vm._i(_vm.selectedReports.driverRelease,null)>-1:(_vm.selectedReports.driverRelease)},on:{"change":function($event){var $$a=_vm.selectedReports.driverRelease,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "driverRelease", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "driverRelease", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "driverRelease", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Driver Release")])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.show),expression:"error.show"}],staticClass:"error"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.message),expression:"!!error.message"}]},[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.empty.length),expression:"error.empty.length"}]},[_c('li',[_vm._v("Empty Result:")]),_vm._v(" "),_vm._l((_vm.error.empty),function(empty,x){return _c('li',{key:x},[_vm._v("- "+_vm._s(empty))])})],2)])]),_vm._v(" "),_c('a',{class:{ 'button cta success small block': true, disabled: _vm.pdf.loading },attrs:{"href":"javascript:;"},on:{"click":_vm.startProcess}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.pdf.loading),expression:"pdf.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pdf.loading),expression:"!pdf.loading"}]},[_vm._v("Generate and Download Report")])])],1),_vm._v(" "),_c('div',{class:[_vm.pdf.class],attrs:{"id":"pdf-view"}},[_vm._l((_vm.pdf.table.data),function(pageData,pageIndex){return _c('div',{key:pageIndex,class:['page', pageIndex]},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',_vm._l((_vm.pdf.table.label),function(label,x){return _c('th',{key:x,domProps:{"innerHTML":_vm._s(label)}})}),0)]),_vm._v(" "),_c('tbody',_vm._l((pageData),function(data,index){return _c('tr',{key:index},_vm._l((data),function(value,i){return _c('td',{key:i,class:[i]},[_vm._v(_vm._s(value))])}),0)}),0)]),_vm._v(" "),_c('div',{staticClass:"page-count"},[_vm._v("page "+_vm._s(_vm.currentPage(pageIndex))+" of "+_vm._s(_vm.totalPage))])])}),_vm._v(" "),(Object.keys(_vm.pdf.table.data).length)?_c('div',{class:['page', ("page" + (Object.keys(_vm.pdf.table.data).length + 1))]},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',_vm._l((_vm.pdf.table.label),function(label){return _c('th',{domProps:{"innerHTML":_vm._s(label)}})}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.pdf.table.data[("page" + (Object.keys(_vm.pdf.table.data).length))]),function(data,index){return _c('tr',{key:index},_vm._l((data),function(value,i){return _c('td',{key:i,class:[i]},[_vm._v(_vm._s(value))])}),0)}),0)]),_vm._v(" "),_c('div',{staticClass:"page-count"},[_vm._v("page "+_vm._s(Object.keys(_vm.pdf.table.data).length)+" of "+_vm._s(_vm.totalPage))])]):_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RsvpReport_vue__ = __webpack_require__(517);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00db32c8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RsvpReport_vue__ = __webpack_require__(1456);
function injectStyle (ssrContext) {
  __webpack_require__(1454)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00db32c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RsvpReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00db32c8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RsvpReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1455);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5ad2f0e8", content, true, {});

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.rsvp-report-box[data-v-00db32c8] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report-box.slide-down-leave-active[data-v-00db32c8], .rsvp-report-box.slide-down-enter-active[data-v-00db32c8] {\n    overflow: hidden;\n}\n.rsvp-report[data-v-00db32c8] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-00db32c8] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-00db32c8] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-00db32c8] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-00db32c8] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-00db32c8] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-00db32c8] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    clear: both;\n    overflow: auto;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-00db32c8] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-00db32c8]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-00db32c8] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-00db32c8] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-00db32c8] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-00db32c8] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-00db32c8]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-00db32c8], .rsvp-report .reports .report.loading[data-v-00db32c8], .rsvp-report .reports .report.has-error[data-v-00db32c8], .rsvp-report .reports .report.success[data-v-00db32c8] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-00db32c8] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-00db32c8] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-00db32c8] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-00db32c8] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.download-type[data-v-00db32c8] {\n  float: right;\n  width: 150px;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-00db32c8] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-00db32c8] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-00db32c8] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-00db32c8] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-00db32c8] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-00db32c8] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-00db32c8] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-00db32c8] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-00db32c8]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-00db32c8] {\n      font-size: 13px;\n}\n.form-group[data-v-00db32c8] {\n  display: block;\n}\n.form-group .instruction[data-v-00db32c8] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-00db32c8] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox > *[data-v-00db32c8] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-00db32c8] {\n    margin-right: 3px;\n}\n.padding-R[data-v-00db32c8] {\n  padding-right: 7px;\n}\n.padding-L[data-v-00db32c8] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-00db32c8] {\n  position: fixed;\n  top: 0%;\n  right: 100%;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n  z-index: -1;\n}\n#pdf-view .page[data-v-00db32c8] {\n    padding: 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-00db32c8] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-00db32c8] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-00db32c8] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-00db32c8] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-00db32c8] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-00db32c8] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-00db32c8], #pdf-view table tbody tr.total[data-v-00db32c8] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-00db32c8] {\n      color: #000;\n      font-size: 15px;\n}\n#pdf-view table tbody td[data-v-00db32c8] {\n      padding: 2px 3px;\n}\n.rsvp-by-date[data-v-00db32c8], .rsvp-by-refund[data-v-00db32c8] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.rsvp-by-date table tbody tr.subtotal[data-v-00db32c8], .rsvp-by-refund table tbody tr.subtotal[data-v-00db32c8] {\n    border-top: 1px solid #333;\n}\n.rsvp-by-date table tbody .name[data-v-00db32c8], .rsvp-by-refund table tbody .name[data-v-00db32c8] {\n    max-width: 120px;\n}\n.rsvp-by-date table tbody .service[data-v-00db32c8], .rsvp-by-refund table tbody .service[data-v-00db32c8] {\n    max-width: 90px;\n}\n.rsvp-by-date table tbody .pickupLocation[data-v-00db32c8], .rsvp-by-date table tbody .dropoffLocation[data-v-00db32c8], .rsvp-by-refund table tbody .pickupLocation[data-v-00db32c8], .rsvp-by-refund table tbody .dropoffLocation[data-v-00db32c8] {\n    max-width: 200px;\n}\n.rsvp-by-date table tbody .name[data-v-00db32c8], .rsvp-by-date table tbody .service[data-v-00db32c8], .rsvp-by-date table tbody .pickupLocation[data-v-00db32c8], .rsvp-by-date table tbody .dropoffLocation[data-v-00db32c8], .rsvp-by-refund table tbody .name[data-v-00db32c8], .rsvp-by-refund table tbody .service[data-v-00db32c8], .rsvp-by-refund table tbody .pickupLocation[data-v-00db32c8], .rsvp-by-refund table tbody .dropoffLocation[data-v-00db32c8] {\n    max-width: 200px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.rsvp-by-date table .source[data-v-00db32c8], .rsvp-by-date table .direction[data-v-00db32c8], .rsvp-by-date table .service[data-v-00db32c8], .rsvp-by-date table .pickupTime[data-v-00db32c8], .rsvp-by-date table .refundedDate[data-v-00db32c8], .rsvp-by-date table .pickupLocation[data-v-00db32c8], .rsvp-by-date table .dropoffLocation[data-v-00db32c8],\n  .rsvp-by-date table .pax[data-v-00db32c8], .rsvp-by-date table .status[data-v-00db32c8], .rsvp-by-date table .total-pax[data-v-00db32c8], .rsvp-by-date table .flight[data-v-00db32c8], .rsvp-by-date table .flightType[data-v-00db32c8], .rsvp-by-refund table .source[data-v-00db32c8], .rsvp-by-refund table .direction[data-v-00db32c8], .rsvp-by-refund table .service[data-v-00db32c8], .rsvp-by-refund table .pickupTime[data-v-00db32c8], .rsvp-by-refund table .refundedDate[data-v-00db32c8], .rsvp-by-refund table .pickupLocation[data-v-00db32c8], .rsvp-by-refund table .dropoffLocation[data-v-00db32c8],\n  .rsvp-by-refund table .pax[data-v-00db32c8], .rsvp-by-refund table .status[data-v-00db32c8], .rsvp-by-refund table .total-pax[data-v-00db32c8], .rsvp-by-refund table .flight[data-v-00db32c8], .rsvp-by-refund table .flightType[data-v-00db32c8] {\n    text-align: center;\n}\n.rsvp-by-date table .pickupTime[data-v-00db32c8], .rsvp-by-date table .refundedDate[data-v-00db32c8], .rsvp-by-refund table .pickupTime[data-v-00db32c8], .rsvp-by-refund table .refundedDate[data-v-00db32c8] {\n    width: 120px;\n}\n.rsvp-by-date table .pax[data-v-00db32c8], .rsvp-by-refund table .pax[data-v-00db32c8] {\n    width: 70px;\n}\n.rsvp-by-date table .fare[data-v-00db32c8], .rsvp-by-date table .total-count[data-v-00db32c8], .rsvp-by-date table .total-fare[data-v-00db32c8], .rsvp-by-date table .refundAmount[data-v-00db32c8], .rsvp-by-date table .total-refund[data-v-00db32c8],\n  .rsvp-by-date table .extraFee[data-v-00db32c8], .rsvp-by-refund table .fare[data-v-00db32c8], .rsvp-by-refund table .total-count[data-v-00db32c8], .rsvp-by-refund table .total-fare[data-v-00db32c8], .rsvp-by-refund table .refundAmount[data-v-00db32c8], .rsvp-by-refund table .total-refund[data-v-00db32c8],\n  .rsvp-by-refund table .extraFee[data-v-00db32c8] {\n    text-align: right;\n}\n.rsvp-by-date table .total-count[data-v-00db32c8], .rsvp-by-refund table .total-count[data-v-00db32c8] {\n    padding-right: 10px;\n}\n.rsvp-by-date table tbody .name[data-v-00db32c8], .rsvp-by-date table tbody .pickupTime[data-v-00db32c8], .rsvp-by-date table tbody .pax[data-v-00db32c8], .rsvp-by-date table tbody .flight[data-v-00db32c8], .rsvp-by-date table tbody .flightType[data-v-00db32c8] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rsvp-by-date table tbody .pickupLocation[data-v-00db32c8], .rsvp-by-date table tbody .dropoffLocation[data-v-00db32c8] {\n  max-width: 170px;\n}\n.rsvp-by-date table tbody .name[data-v-00db32c8] {\n  max-width: 155px;\n}\n.rsvp-by-date table tbody .pickupTime[data-v-00db32c8] {\n  max-width: 130px;\n}\n.rsvp-by-date table tbody .pax[data-v-00db32c8] {\n  max-width: 60px;\n}\n.rsvp-by-date table tbody .flight[data-v-00db32c8] {\n  max-width: 70px;\n}\n.rsvp-by-date table tbody .flightType[data-v-00db32c8] {\n  max-width: 60px;\n}\n.rsvp-by-refund table tbody .name[data-v-00db32c8] {\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.rsvp-by-refund table tbody .service[data-v-00db32c8] {\n  width: 90px;\n}\n.rsvp-by-refund table tbody .pickupTime[data-v-00db32c8], .rsvp-by-refund table tbody .refundedDate[data-v-00db32c8] {\n  font-size: 11px;\n}\n.rsvp-by-refund table tbody .pickupLocation[data-v-00db32c8], .rsvp-by-refund table tbody .dropoffLocation[data-v-00db32c8] {\n  max-width: 170px;\n}\n.rsvp-summary[data-v-00db32c8], .driver-rsvp[data-v-00db32c8], .service-rsvp[data-v-00db32c8], .promo-rsvp[data-v-00db32c8], .status-rsvp[data-v-00db32c8], .brands-rsvp[data-v-00db32c8], .summary-corporate-rsvp[data-v-00db32c8], .corporate-rsvp[data-v-00db32c8], .credit-converted[data-v-00db32c8] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.rsvp-summary table tbody tr.total[data-v-00db32c8], .driver-rsvp table tbody tr.total[data-v-00db32c8], .service-rsvp table tbody tr.total[data-v-00db32c8], .promo-rsvp table tbody tr.total[data-v-00db32c8], .status-rsvp table tbody tr.total[data-v-00db32c8], .brands-rsvp table tbody tr.total[data-v-00db32c8], .summary-corporate-rsvp table tbody tr.total[data-v-00db32c8], .corporate-rsvp table tbody tr.total[data-v-00db32c8], .credit-converted table tbody tr.total[data-v-00db32c8] {\n    border-top: 1px solid #333;\n}\n.rsvp-summary table .date[data-v-00db32c8], .rsvp-summary table .rsvpCount[data-v-00db32c8], .rsvp-summary table .distance[data-v-00db32c8], .rsvp-summary table .asap[data-v-00db32c8], .rsvp-summary table .web[data-v-00db32c8], .rsvp-summary table .admin[data-v-00db32c8], .rsvp-summary table .app[data-v-00db32c8], .rsvp-summary table .go[data-v-00db32c8], .rsvp-summary table .totalPax[data-v-00db32c8], .rsvp-summary table .avgPax[data-v-00db32c8], .rsvp-summary table .dutyHours[data-v-00db32c8], .driver-rsvp table .date[data-v-00db32c8], .driver-rsvp table .rsvpCount[data-v-00db32c8], .driver-rsvp table .distance[data-v-00db32c8], .driver-rsvp table .asap[data-v-00db32c8], .driver-rsvp table .web[data-v-00db32c8], .driver-rsvp table .admin[data-v-00db32c8], .driver-rsvp table .app[data-v-00db32c8], .driver-rsvp table .go[data-v-00db32c8], .driver-rsvp table .totalPax[data-v-00db32c8], .driver-rsvp table .avgPax[data-v-00db32c8], .driver-rsvp table .dutyHours[data-v-00db32c8], .service-rsvp table .date[data-v-00db32c8], .service-rsvp table .rsvpCount[data-v-00db32c8], .service-rsvp table .distance[data-v-00db32c8], .service-rsvp table .asap[data-v-00db32c8], .service-rsvp table .web[data-v-00db32c8], .service-rsvp table .admin[data-v-00db32c8], .service-rsvp table .app[data-v-00db32c8], .service-rsvp table .go[data-v-00db32c8], .service-rsvp table .totalPax[data-v-00db32c8], .service-rsvp table .avgPax[data-v-00db32c8], .service-rsvp table .dutyHours[data-v-00db32c8], .promo-rsvp table .date[data-v-00db32c8], .promo-rsvp table .rsvpCount[data-v-00db32c8], .promo-rsvp table .distance[data-v-00db32c8], .promo-rsvp table .asap[data-v-00db32c8], .promo-rsvp table .web[data-v-00db32c8], .promo-rsvp table .admin[data-v-00db32c8], .promo-rsvp table .app[data-v-00db32c8], .promo-rsvp table .go[data-v-00db32c8], .promo-rsvp table .totalPax[data-v-00db32c8], .promo-rsvp table .avgPax[data-v-00db32c8], .promo-rsvp table .dutyHours[data-v-00db32c8], .status-rsvp table .date[data-v-00db32c8], .status-rsvp table .rsvpCount[data-v-00db32c8], .status-rsvp table .distance[data-v-00db32c8], .status-rsvp table .asap[data-v-00db32c8], .status-rsvp table .web[data-v-00db32c8], .status-rsvp table .admin[data-v-00db32c8], .status-rsvp table .app[data-v-00db32c8], .status-rsvp table .go[data-v-00db32c8], .status-rsvp table .totalPax[data-v-00db32c8], .status-rsvp table .avgPax[data-v-00db32c8], .status-rsvp table .dutyHours[data-v-00db32c8], .brands-rsvp table .date[data-v-00db32c8], .brands-rsvp table .rsvpCount[data-v-00db32c8], .brands-rsvp table .distance[data-v-00db32c8], .brands-rsvp table .asap[data-v-00db32c8], .brands-rsvp table .web[data-v-00db32c8], .brands-rsvp table .admin[data-v-00db32c8], .brands-rsvp table .app[data-v-00db32c8], .brands-rsvp table .go[data-v-00db32c8], .brands-rsvp table .totalPax[data-v-00db32c8], .brands-rsvp table .avgPax[data-v-00db32c8], .brands-rsvp table .dutyHours[data-v-00db32c8], .summary-corporate-rsvp table .date[data-v-00db32c8], .summary-corporate-rsvp table .rsvpCount[data-v-00db32c8], .summary-corporate-rsvp table .distance[data-v-00db32c8], .summary-corporate-rsvp table .asap[data-v-00db32c8], .summary-corporate-rsvp table .web[data-v-00db32c8], .summary-corporate-rsvp table .admin[data-v-00db32c8], .summary-corporate-rsvp table .app[data-v-00db32c8], .summary-corporate-rsvp table .go[data-v-00db32c8], .summary-corporate-rsvp table .totalPax[data-v-00db32c8], .summary-corporate-rsvp table .avgPax[data-v-00db32c8], .summary-corporate-rsvp table .dutyHours[data-v-00db32c8], .corporate-rsvp table .date[data-v-00db32c8], .corporate-rsvp table .rsvpCount[data-v-00db32c8], .corporate-rsvp table .distance[data-v-00db32c8], .corporate-rsvp table .asap[data-v-00db32c8], .corporate-rsvp table .web[data-v-00db32c8], .corporate-rsvp table .admin[data-v-00db32c8], .corporate-rsvp table .app[data-v-00db32c8], .corporate-rsvp table .go[data-v-00db32c8], .corporate-rsvp table .totalPax[data-v-00db32c8], .corporate-rsvp table .avgPax[data-v-00db32c8], .corporate-rsvp table .dutyHours[data-v-00db32c8], .credit-converted table .date[data-v-00db32c8], .credit-converted table .rsvpCount[data-v-00db32c8], .credit-converted table .distance[data-v-00db32c8], .credit-converted table .asap[data-v-00db32c8], .credit-converted table .web[data-v-00db32c8], .credit-converted table .admin[data-v-00db32c8], .credit-converted table .app[data-v-00db32c8], .credit-converted table .go[data-v-00db32c8], .credit-converted table .totalPax[data-v-00db32c8], .credit-converted table .avgPax[data-v-00db32c8], .credit-converted table .dutyHours[data-v-00db32c8] {\n    text-align: center;\n}\n.rsvp-summary table .totalFare[data-v-00db32c8], .rsvp-summary table .avgFare[data-v-00db32c8], .rsvp-summary table .avgFarePP[data-v-00db32c8], .rsvp-summary table .extraFee[data-v-00db32c8], .rsvp-summary table .driverPayment[data-v-00db32c8], .rsvp-summary table .driverPercent[data-v-00db32c8], .driver-rsvp table .totalFare[data-v-00db32c8], .driver-rsvp table .avgFare[data-v-00db32c8], .driver-rsvp table .avgFarePP[data-v-00db32c8], .driver-rsvp table .extraFee[data-v-00db32c8], .driver-rsvp table .driverPayment[data-v-00db32c8], .driver-rsvp table .driverPercent[data-v-00db32c8], .service-rsvp table .totalFare[data-v-00db32c8], .service-rsvp table .avgFare[data-v-00db32c8], .service-rsvp table .avgFarePP[data-v-00db32c8], .service-rsvp table .extraFee[data-v-00db32c8], .service-rsvp table .driverPayment[data-v-00db32c8], .service-rsvp table .driverPercent[data-v-00db32c8], .promo-rsvp table .totalFare[data-v-00db32c8], .promo-rsvp table .avgFare[data-v-00db32c8], .promo-rsvp table .avgFarePP[data-v-00db32c8], .promo-rsvp table .extraFee[data-v-00db32c8], .promo-rsvp table .driverPayment[data-v-00db32c8], .promo-rsvp table .driverPercent[data-v-00db32c8], .status-rsvp table .totalFare[data-v-00db32c8], .status-rsvp table .avgFare[data-v-00db32c8], .status-rsvp table .avgFarePP[data-v-00db32c8], .status-rsvp table .extraFee[data-v-00db32c8], .status-rsvp table .driverPayment[data-v-00db32c8], .status-rsvp table .driverPercent[data-v-00db32c8], .brands-rsvp table .totalFare[data-v-00db32c8], .brands-rsvp table .avgFare[data-v-00db32c8], .brands-rsvp table .avgFarePP[data-v-00db32c8], .brands-rsvp table .extraFee[data-v-00db32c8], .brands-rsvp table .driverPayment[data-v-00db32c8], .brands-rsvp table .driverPercent[data-v-00db32c8], .summary-corporate-rsvp table .totalFare[data-v-00db32c8], .summary-corporate-rsvp table .avgFare[data-v-00db32c8], .summary-corporate-rsvp table .avgFarePP[data-v-00db32c8], .summary-corporate-rsvp table .extraFee[data-v-00db32c8], .summary-corporate-rsvp table .driverPayment[data-v-00db32c8], .summary-corporate-rsvp table .driverPercent[data-v-00db32c8], .corporate-rsvp table .totalFare[data-v-00db32c8], .corporate-rsvp table .avgFare[data-v-00db32c8], .corporate-rsvp table .avgFarePP[data-v-00db32c8], .corporate-rsvp table .extraFee[data-v-00db32c8], .corporate-rsvp table .driverPayment[data-v-00db32c8], .corporate-rsvp table .driverPercent[data-v-00db32c8], .credit-converted table .totalFare[data-v-00db32c8], .credit-converted table .avgFare[data-v-00db32c8], .credit-converted table .avgFarePP[data-v-00db32c8], .credit-converted table .extraFee[data-v-00db32c8], .credit-converted table .driverPayment[data-v-00db32c8], .credit-converted table .driverPercent[data-v-00db32c8] {\n    text-align: right;\n}\n.rsvp-summary table .driver[data-v-00db32c8], .rsvp-summary table .service[data-v-00db32c8], .rsvp-summary table .promo[data-v-00db32c8], .driver-rsvp table .driver[data-v-00db32c8], .driver-rsvp table .service[data-v-00db32c8], .driver-rsvp table .promo[data-v-00db32c8], .service-rsvp table .driver[data-v-00db32c8], .service-rsvp table .service[data-v-00db32c8], .service-rsvp table .promo[data-v-00db32c8], .promo-rsvp table .driver[data-v-00db32c8], .promo-rsvp table .service[data-v-00db32c8], .promo-rsvp table .promo[data-v-00db32c8], .status-rsvp table .driver[data-v-00db32c8], .status-rsvp table .service[data-v-00db32c8], .status-rsvp table .promo[data-v-00db32c8], .brands-rsvp table .driver[data-v-00db32c8], .brands-rsvp table .service[data-v-00db32c8], .brands-rsvp table .promo[data-v-00db32c8], .summary-corporate-rsvp table .driver[data-v-00db32c8], .summary-corporate-rsvp table .service[data-v-00db32c8], .summary-corporate-rsvp table .promo[data-v-00db32c8], .corporate-rsvp table .driver[data-v-00db32c8], .corporate-rsvp table .service[data-v-00db32c8], .corporate-rsvp table .promo[data-v-00db32c8], .credit-converted table .driver[data-v-00db32c8], .credit-converted table .service[data-v-00db32c8], .credit-converted table .promo[data-v-00db32c8] {\n    max-width: 200px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.airport-rsvp table tbody tr.total[data-v-00db32c8] {\n  border-top: 1px solid #333;\n}\n.airport-rsvp table .rsvpCount[data-v-00db32c8], .airport-rsvp table .asap[data-v-00db32c8], .airport-rsvp table .oneway[data-v-00db32c8], .airport-rsvp table .roundtrip[data-v-00db32c8] {\n  text-align: center;\n}\n.airport-rsvp table .roundtripInstances[data-v-00db32c8], .airport-rsvp table .totalRsvpInstances[data-v-00db32c8], .airport-rsvp table .onewayPercent[data-v-00db32c8],\n.airport-rsvp table .roundtripPercent[data-v-00db32c8] {\n  text-align: right;\n}\n.weekly-summary .table-heading[data-v-00db32c8] {\n  line-height: 1.2;\n}\n.weekly-summary .time[data-v-00db32c8] {\n  width: 100px;\n}\n.weekly-summary table td[data-v-00db32c8] {\n  text-align: center;\n}\n.weekly-summary tr.total[data-v-00db32c8] {\n  border-top: 1px solid #333;\n}\n.airport-rsvp-deparr table tr.total[data-v-00db32c8] {\n  border-top: 1px solid #333;\n}\n.airport-rsvp-deparr table tr td[data-v-00db32c8] {\n  text-align: center;\n}\n.variance-table[data-v-00db32c8] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.variance-table table .pickupTime[data-v-00db32c8], .variance-table table .pax[data-v-00db32c8], .variance-table table .paymentType[data-v-00db32c8] {\n    text-align: center;\n}\n.variance-table table .fare[data-v-00db32c8], .variance-table table .cash[data-v-00db32c8], .variance-table table .cc[data-v-00db32c8], .variance-table table .db[data-v-00db32c8], .variance-table table .check[data-v-00db32c8], .variance-table table .other[data-v-00db32c8], .variance-table table .variance[data-v-00db32c8] {\n    text-align: right;\n}\n.payment-rsvp table tr.total[data-v-00db32c8] {\n  border-top: 1px solid #333;\n}\n.payment-rsvp table .total-label[data-v-00db32c8], .payment-rsvp table .rsvp[data-v-00db32c8], .payment-rsvp table .pax[data-v-00db32c8] {\n  text-align: center;\n}\n.payment-rsvp table .charged[data-v-00db32c8], .payment-rsvp table .gratuity[data-v-00db32c8] {\n  text-align: right;\n}\n.trx-summary[data-v-00db32c8] {\n  height: 1122px !important;\n  width: 793px !important;\n}\n.trx-summary table tbody tr.total[data-v-00db32c8] {\n    border-top: 1px solid #333;\n}\n.trx-summary table .date[data-v-00db32c8], .trx-summary table .rsvpCount[data-v-00db32c8], .trx-summary table .trxCount[data-v-00db32c8], .trx-summary table .purchaseCount[data-v-00db32c8], .trx-summary table .additionalCount[data-v-00db32c8],\n  .trx-summary table .chargedTrxCount[data-v-00db32c8], .trx-summary table .refundTrxCount[data-v-00db32c8] {\n    text-align: center;\n}\n.trx-summary table .totalCharges[data-v-00db32c8], .trx-summary table .chargedAmount[data-v-00db32c8], .trx-summary table .refundAmount[data-v-00db32c8], .trx-summary table .netTotal[data-v-00db32c8] {\n    text-align: right;\n}\n.trx-detailed[data-v-00db32c8] {\n  height: 1122px !important;\n  width: 793px !important;\n}\n.trx-detailed table tbody tr.total[data-v-00db32c8] {\n    border-top: 1px solid #333;\n}\n.trx-detailed table .date[data-v-00db32c8], .trx-detailed table .rsvpId[data-v-00db32c8], .trx-detailed table .invoiceId[data-v-00db32c8], .trx-detailed table .customer[data-v-00db32c8], .trx-detailed table .cardOwner[data-v-00db32c8], .trx-detailed table .transactionType[data-v-00db32c8] {\n    text-align: center;\n}\n.trx-detailed table .chargedAmount[data-v-00db32c8], .trx-detailed table .refundAmount[data-v-00db32c8] {\n    text-align: right;\n}\n.trx-detailed table .transactionType[data-v-00db32c8] {\n    text-transform: capitalize;\n}\n.corporate-rsvp table tbody td[data-v-00db32c8] {\n  padding: 2px 5px !important;\n}\n.corporate-rsvp table .rsvpId[data-v-00db32c8], .corporate-rsvp table .corporate[data-v-00db32c8], .corporate-rsvp table .guest[data-v-00db32c8], .corporate-rsvp table .service[data-v-00db32c8], .corporate-rsvp table .pickupTime[data-v-00db32c8], .corporate-rsvp table .fare[data-v-00db32c8] {\n  text-align: center;\n}\n.corporate-rsvp table .pickupLocation[data-v-00db32c8] {\n  padding-right: 5px !important;\n}\n.corporate-rsvp table .dropoffLocation[data-v-00db32c8] {\n  padding-left: 5px !important;\n}\n.corporate-rsvp table .pickupLocation[data-v-00db32c8], .corporate-rsvp table .dropoffLocation[data-v-00db32c8] {\n  width: 205px;\n  max-width: 210px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rsvp-terminal .table-heading[data-v-00db32c8] {\n  line-height: 1.2;\n}\n.rsvp-terminal th[data-v-00db32c8] {\n  padding-bottom: 5px;\n}\n.rsvp-terminal .time[data-v-00db32c8] {\n  width: 100px;\n}\n.rsvp-terminal table td[data-v-00db32c8] {\n  text-align: center;\n}\n.rsvp-terminal tbody tr[data-v-00db32c8] {\n  border: 1px solid #eee;\n  border-left-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: transparent;\n}\n.rsvp-terminal tbody td[data-v-00db32c8] {\n  line-height: 1.5;\n}\n.rsvp-terminal tr.total[data-v-00db32c8] {\n  border-top: 1px solid #333;\n}\n.credit-converted .rsvpId[data-v-00db32c8], .credit-converted .brand[data-v-00db32c8], .credit-converted .pickupTime[data-v-00db32c8], .credit-converted .pickup[data-v-00db32c8], .credit-converted .dropoff[data-v-00db32c8], .credit-converted .service[data-v-00db32c8], .credit-converted .pax[data-v-00db32c8], .credit-converted .source[data-v-00db32c8], .credit-converted .total-pax[data-v-00db32c8] {\n  text-align: center;\n}\n.credit-converted .fare[data-v-00db32c8], .credit-converted .creditReceived[data-v-00db32c8], .credit-converted .total-fare[data-v-00db32c8], .credit-converted .total-creditReceived[data-v-00db32c8] {\n  text-align: right;\n}\n.slide-down-enter-active[data-v-00db32c8], .slide-down-leave-active[data-v-00db32c8] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-00db32c8], .slide-down-leave-to[data-v-00db32c8] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.rsvp-report .form-group .row.expanded.filter-date[data-v-00db32c8] {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    -webkit-column-gap: 1em;\n       -moz-column-gap: 1em;\n            column-gap: 1em;\n}\n.rsvp-report .form-group .row.expanded.filter-date .select-date[data-v-00db32c8] {\n      grid-column-start: 1;\n      grid-column-end: 3;\n}\n.rsvp-report .form-group .row.expanded.filter-date .small-4[data-v-00db32c8] {\n      padding: 0;\n      width: 100%;\n}\n.rsvp-report .form-group .row.expanded.filter-date .end-date[data-v-00db32c8] .vdp-datepicker__calendar {\n      right: 1px;\n}\n.rsvp-report .reports .report[data-v-00db32c8] {\n    padding: 2px 0;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Reports/RsvpReport.vue"],"names":[],"mappings":";AACA;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,mBAAmB;EACnB,YAAY;CACb;AACD;IACI,iBAAiB;CACpB;AACD;EACE,mBAAmB;EACnB,qBAAqB;CACtB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,eAAe;CACpB;AACD;MACM,cAAc;MACd,aAAa;MACb,cAAc;MACd,yBAAyB;MACzB,sBAAsB;MACtB,iBAAiB;MACjB,sBAAsB;MACtB,gBAAgB;MAChB,YAAY;MACZ,wDAAwD;MACxD,6BAA6B;MAC7B,+BAA+B;CACpC;AACD;QACQ,0BAA0B;CACjC;AACD;IACI,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;CACtB;AACD;MACM,mBAAmB;MACnB,WAAW;CAChB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,+BAA+B;CACtC;AACD;UACU,YAAY;CACrB;AACD;QACQ,kBAAkB;QAClB,oBAAoB;QACpB,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,iCAAiC;QACjC,yBAAyB;CAChC;AACD;UACU,oBAAoB;UACpB,mBAAmB;CAC5B;AACD;UACU,oBAAoB;CAC7B;AACD;QACQ,WAAW;QACX,+CAA+C;gBACvC,uCAAuC;CACtD;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,oBAAoB;CACrB;AACD;IACI,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;CAC1B;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,gBAAgB;MAChB,cAAc;MACd,YAAY;MACZ,qBAAqB;CAC1B;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;CACtB;AACD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;IACI,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,iBAAiB;CACpB;AACD;MACM,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;CACxB;AACD;MACM,gBAAgB;CACrB;AACD;EACE,eAAe;CAChB;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,YAAY;CACf;AACD;IACI,kBAAkB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,gBAAgB;EAChB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,YAAY;CACb;AACD;IACI,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,aAAa;CAChB;AACD;MACM,mBAAmB;MACnB,aAAa;MACb,YAAY;MACZ,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;CACxB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;CACf;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,iBAAiB;CACtB;AACD;QACQ,8BAA8B;CACrC;AACD;MACM,iBAAiB;CACtB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;MACM,iBAAiB;CACtB;AACD;EACE,yBAAyB;EACzB,yBAAyB;CAC1B;AACD;IACI,2BAA2B;CAC9B;AACD;IACI,iBAAiB;CACpB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;CAC3B;AACD;;;IAGI,mBAAmB;CACtB;AACD;IACI,aAAa;CAChB;AACD;IACI,YAAY;CACf;AACD;;;IAGI,kBAAkB;CACrB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;CACzB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,YAAY;CACb;AACD;EACE,gBAAgB;CACjB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,yBAAyB;EACzB,yBAAyB;CAC1B;AACD;IACI,2BAA2B;CAC9B;AACD;IACI,mBAAmB;CACtB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;IACxB,oBAAoB;CACvB;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,mBAAmB;CACpB;AACD;;EAEE,kBAAkB;CACnB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,aAAa;CACd;AACD;EACE,mBAAmB;CACpB;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,mBAAmB;CACpB;AACD;EACE,yBAAyB;EACzB,yBAAyB;CAC1B;AACD;IACI,mBAAmB;CACtB;AACD;IACI,kBAAkB;CACrB;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,0BAA0B;EAC1B,wBAAwB;CACzB;AACD;IACI,2BAA2B;CAC9B;AACD;;IAEI,mBAAmB;CACtB;AACD;IACI,kBAAkB;CACrB;AACD;EACE,0BAA0B;EAC1B,wBAAwB;CACzB;AACD;IACI,2BAA2B;CAC9B;AACD;IACI,mBAAmB;CACtB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,2BAA2B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,mBAAmB;CACpB;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;CACzB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,aAAa;CACd;AACD;EACE,mBAAmB;CACpB;AACD;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,gCAAgC;EAChC,iCAAiC;CAClC;AACD;EACE,iBAAiB;CAClB;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;AACA;IACI,cAAc;IACd,+BAA+B;IAC/B,wBAAwB;OACrB,qBAAqB;YAChB,gBAAgB;CAC3B;AACD;MACM,qBAAqB;MACrB,mBAAmB;CACxB;AACD;MACM,WAAW;MACX,YAAY;CACjB;AACD;MACM,WAAW;CAChB;AACD;IACI,eAAe;CAClB;CACA","file":"RsvpReport.vue","sourcesContent":["\n.rsvp-report-box[data-v-00db32c8] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report-box.slide-down-leave-active[data-v-00db32c8], .rsvp-report-box.slide-down-enter-active[data-v-00db32c8] {\n    overflow: hidden;\n}\n.rsvp-report[data-v-00db32c8] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-00db32c8] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-00db32c8] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-00db32c8] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-00db32c8] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-00db32c8] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-00db32c8] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    clear: both;\n    overflow: auto;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-00db32c8] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-00db32c8]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-00db32c8] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-00db32c8] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-00db32c8] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-00db32c8] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-00db32c8]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-00db32c8], .rsvp-report .reports .report.loading[data-v-00db32c8], .rsvp-report .reports .report.has-error[data-v-00db32c8], .rsvp-report .reports .report.success[data-v-00db32c8] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-00db32c8] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-00db32c8] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-00db32c8] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-00db32c8] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.download-type[data-v-00db32c8] {\n  float: right;\n  width: 150px;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-00db32c8] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-00db32c8] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-00db32c8] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-00db32c8] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-00db32c8] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-00db32c8] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-00db32c8] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-00db32c8] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-00db32c8]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-00db32c8] {\n      font-size: 13px;\n}\n.form-group[data-v-00db32c8] {\n  display: block;\n}\n.form-group .instruction[data-v-00db32c8] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-00db32c8] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox > *[data-v-00db32c8] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-00db32c8] {\n    margin-right: 3px;\n}\n.padding-R[data-v-00db32c8] {\n  padding-right: 7px;\n}\n.padding-L[data-v-00db32c8] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-00db32c8] {\n  position: fixed;\n  top: 0%;\n  right: 100%;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n  z-index: -1;\n}\n#pdf-view .page[data-v-00db32c8] {\n    padding: 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-00db32c8] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-00db32c8] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-00db32c8] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-00db32c8] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-00db32c8] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-00db32c8] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-00db32c8], #pdf-view table tbody tr.total[data-v-00db32c8] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-00db32c8] {\n      color: #000;\n      font-size: 15px;\n}\n#pdf-view table tbody td[data-v-00db32c8] {\n      padding: 2px 3px;\n}\n.rsvp-by-date[data-v-00db32c8], .rsvp-by-refund[data-v-00db32c8] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.rsvp-by-date table tbody tr.subtotal[data-v-00db32c8], .rsvp-by-refund table tbody tr.subtotal[data-v-00db32c8] {\n    border-top: 1px solid #333;\n}\n.rsvp-by-date table tbody .name[data-v-00db32c8], .rsvp-by-refund table tbody .name[data-v-00db32c8] {\n    max-width: 120px;\n}\n.rsvp-by-date table tbody .service[data-v-00db32c8], .rsvp-by-refund table tbody .service[data-v-00db32c8] {\n    max-width: 90px;\n}\n.rsvp-by-date table tbody .pickupLocation[data-v-00db32c8], .rsvp-by-date table tbody .dropoffLocation[data-v-00db32c8], .rsvp-by-refund table tbody .pickupLocation[data-v-00db32c8], .rsvp-by-refund table tbody .dropoffLocation[data-v-00db32c8] {\n    max-width: 200px;\n}\n.rsvp-by-date table tbody .name[data-v-00db32c8], .rsvp-by-date table tbody .service[data-v-00db32c8], .rsvp-by-date table tbody .pickupLocation[data-v-00db32c8], .rsvp-by-date table tbody .dropoffLocation[data-v-00db32c8], .rsvp-by-refund table tbody .name[data-v-00db32c8], .rsvp-by-refund table tbody .service[data-v-00db32c8], .rsvp-by-refund table tbody .pickupLocation[data-v-00db32c8], .rsvp-by-refund table tbody .dropoffLocation[data-v-00db32c8] {\n    max-width: 200px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.rsvp-by-date table .source[data-v-00db32c8], .rsvp-by-date table .direction[data-v-00db32c8], .rsvp-by-date table .service[data-v-00db32c8], .rsvp-by-date table .pickupTime[data-v-00db32c8], .rsvp-by-date table .refundedDate[data-v-00db32c8], .rsvp-by-date table .pickupLocation[data-v-00db32c8], .rsvp-by-date table .dropoffLocation[data-v-00db32c8],\n  .rsvp-by-date table .pax[data-v-00db32c8], .rsvp-by-date table .status[data-v-00db32c8], .rsvp-by-date table .total-pax[data-v-00db32c8], .rsvp-by-date table .flight[data-v-00db32c8], .rsvp-by-date table .flightType[data-v-00db32c8], .rsvp-by-refund table .source[data-v-00db32c8], .rsvp-by-refund table .direction[data-v-00db32c8], .rsvp-by-refund table .service[data-v-00db32c8], .rsvp-by-refund table .pickupTime[data-v-00db32c8], .rsvp-by-refund table .refundedDate[data-v-00db32c8], .rsvp-by-refund table .pickupLocation[data-v-00db32c8], .rsvp-by-refund table .dropoffLocation[data-v-00db32c8],\n  .rsvp-by-refund table .pax[data-v-00db32c8], .rsvp-by-refund table .status[data-v-00db32c8], .rsvp-by-refund table .total-pax[data-v-00db32c8], .rsvp-by-refund table .flight[data-v-00db32c8], .rsvp-by-refund table .flightType[data-v-00db32c8] {\n    text-align: center;\n}\n.rsvp-by-date table .pickupTime[data-v-00db32c8], .rsvp-by-date table .refundedDate[data-v-00db32c8], .rsvp-by-refund table .pickupTime[data-v-00db32c8], .rsvp-by-refund table .refundedDate[data-v-00db32c8] {\n    width: 120px;\n}\n.rsvp-by-date table .pax[data-v-00db32c8], .rsvp-by-refund table .pax[data-v-00db32c8] {\n    width: 70px;\n}\n.rsvp-by-date table .fare[data-v-00db32c8], .rsvp-by-date table .total-count[data-v-00db32c8], .rsvp-by-date table .total-fare[data-v-00db32c8], .rsvp-by-date table .refundAmount[data-v-00db32c8], .rsvp-by-date table .total-refund[data-v-00db32c8],\n  .rsvp-by-date table .extraFee[data-v-00db32c8], .rsvp-by-refund table .fare[data-v-00db32c8], .rsvp-by-refund table .total-count[data-v-00db32c8], .rsvp-by-refund table .total-fare[data-v-00db32c8], .rsvp-by-refund table .refundAmount[data-v-00db32c8], .rsvp-by-refund table .total-refund[data-v-00db32c8],\n  .rsvp-by-refund table .extraFee[data-v-00db32c8] {\n    text-align: right;\n}\n.rsvp-by-date table .total-count[data-v-00db32c8], .rsvp-by-refund table .total-count[data-v-00db32c8] {\n    padding-right: 10px;\n}\n.rsvp-by-date table tbody .name[data-v-00db32c8], .rsvp-by-date table tbody .pickupTime[data-v-00db32c8], .rsvp-by-date table tbody .pax[data-v-00db32c8], .rsvp-by-date table tbody .flight[data-v-00db32c8], .rsvp-by-date table tbody .flightType[data-v-00db32c8] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rsvp-by-date table tbody .pickupLocation[data-v-00db32c8], .rsvp-by-date table tbody .dropoffLocation[data-v-00db32c8] {\n  max-width: 170px;\n}\n.rsvp-by-date table tbody .name[data-v-00db32c8] {\n  max-width: 155px;\n}\n.rsvp-by-date table tbody .pickupTime[data-v-00db32c8] {\n  max-width: 130px;\n}\n.rsvp-by-date table tbody .pax[data-v-00db32c8] {\n  max-width: 60px;\n}\n.rsvp-by-date table tbody .flight[data-v-00db32c8] {\n  max-width: 70px;\n}\n.rsvp-by-date table tbody .flightType[data-v-00db32c8] {\n  max-width: 60px;\n}\n.rsvp-by-refund table tbody .name[data-v-00db32c8] {\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.rsvp-by-refund table tbody .service[data-v-00db32c8] {\n  width: 90px;\n}\n.rsvp-by-refund table tbody .pickupTime[data-v-00db32c8], .rsvp-by-refund table tbody .refundedDate[data-v-00db32c8] {\n  font-size: 11px;\n}\n.rsvp-by-refund table tbody .pickupLocation[data-v-00db32c8], .rsvp-by-refund table tbody .dropoffLocation[data-v-00db32c8] {\n  max-width: 170px;\n}\n.rsvp-summary[data-v-00db32c8], .driver-rsvp[data-v-00db32c8], .service-rsvp[data-v-00db32c8], .promo-rsvp[data-v-00db32c8], .status-rsvp[data-v-00db32c8], .brands-rsvp[data-v-00db32c8], .summary-corporate-rsvp[data-v-00db32c8], .corporate-rsvp[data-v-00db32c8], .credit-converted[data-v-00db32c8] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.rsvp-summary table tbody tr.total[data-v-00db32c8], .driver-rsvp table tbody tr.total[data-v-00db32c8], .service-rsvp table tbody tr.total[data-v-00db32c8], .promo-rsvp table tbody tr.total[data-v-00db32c8], .status-rsvp table tbody tr.total[data-v-00db32c8], .brands-rsvp table tbody tr.total[data-v-00db32c8], .summary-corporate-rsvp table tbody tr.total[data-v-00db32c8], .corporate-rsvp table tbody tr.total[data-v-00db32c8], .credit-converted table tbody tr.total[data-v-00db32c8] {\n    border-top: 1px solid #333;\n}\n.rsvp-summary table .date[data-v-00db32c8], .rsvp-summary table .rsvpCount[data-v-00db32c8], .rsvp-summary table .distance[data-v-00db32c8], .rsvp-summary table .asap[data-v-00db32c8], .rsvp-summary table .web[data-v-00db32c8], .rsvp-summary table .admin[data-v-00db32c8], .rsvp-summary table .app[data-v-00db32c8], .rsvp-summary table .go[data-v-00db32c8], .rsvp-summary table .totalPax[data-v-00db32c8], .rsvp-summary table .avgPax[data-v-00db32c8], .rsvp-summary table .dutyHours[data-v-00db32c8], .driver-rsvp table .date[data-v-00db32c8], .driver-rsvp table .rsvpCount[data-v-00db32c8], .driver-rsvp table .distance[data-v-00db32c8], .driver-rsvp table .asap[data-v-00db32c8], .driver-rsvp table .web[data-v-00db32c8], .driver-rsvp table .admin[data-v-00db32c8], .driver-rsvp table .app[data-v-00db32c8], .driver-rsvp table .go[data-v-00db32c8], .driver-rsvp table .totalPax[data-v-00db32c8], .driver-rsvp table .avgPax[data-v-00db32c8], .driver-rsvp table .dutyHours[data-v-00db32c8], .service-rsvp table .date[data-v-00db32c8], .service-rsvp table .rsvpCount[data-v-00db32c8], .service-rsvp table .distance[data-v-00db32c8], .service-rsvp table .asap[data-v-00db32c8], .service-rsvp table .web[data-v-00db32c8], .service-rsvp table .admin[data-v-00db32c8], .service-rsvp table .app[data-v-00db32c8], .service-rsvp table .go[data-v-00db32c8], .service-rsvp table .totalPax[data-v-00db32c8], .service-rsvp table .avgPax[data-v-00db32c8], .service-rsvp table .dutyHours[data-v-00db32c8], .promo-rsvp table .date[data-v-00db32c8], .promo-rsvp table .rsvpCount[data-v-00db32c8], .promo-rsvp table .distance[data-v-00db32c8], .promo-rsvp table .asap[data-v-00db32c8], .promo-rsvp table .web[data-v-00db32c8], .promo-rsvp table .admin[data-v-00db32c8], .promo-rsvp table .app[data-v-00db32c8], .promo-rsvp table .go[data-v-00db32c8], .promo-rsvp table .totalPax[data-v-00db32c8], .promo-rsvp table .avgPax[data-v-00db32c8], .promo-rsvp table .dutyHours[data-v-00db32c8], .status-rsvp table .date[data-v-00db32c8], .status-rsvp table .rsvpCount[data-v-00db32c8], .status-rsvp table .distance[data-v-00db32c8], .status-rsvp table .asap[data-v-00db32c8], .status-rsvp table .web[data-v-00db32c8], .status-rsvp table .admin[data-v-00db32c8], .status-rsvp table .app[data-v-00db32c8], .status-rsvp table .go[data-v-00db32c8], .status-rsvp table .totalPax[data-v-00db32c8], .status-rsvp table .avgPax[data-v-00db32c8], .status-rsvp table .dutyHours[data-v-00db32c8], .brands-rsvp table .date[data-v-00db32c8], .brands-rsvp table .rsvpCount[data-v-00db32c8], .brands-rsvp table .distance[data-v-00db32c8], .brands-rsvp table .asap[data-v-00db32c8], .brands-rsvp table .web[data-v-00db32c8], .brands-rsvp table .admin[data-v-00db32c8], .brands-rsvp table .app[data-v-00db32c8], .brands-rsvp table .go[data-v-00db32c8], .brands-rsvp table .totalPax[data-v-00db32c8], .brands-rsvp table .avgPax[data-v-00db32c8], .brands-rsvp table .dutyHours[data-v-00db32c8], .summary-corporate-rsvp table .date[data-v-00db32c8], .summary-corporate-rsvp table .rsvpCount[data-v-00db32c8], .summary-corporate-rsvp table .distance[data-v-00db32c8], .summary-corporate-rsvp table .asap[data-v-00db32c8], .summary-corporate-rsvp table .web[data-v-00db32c8], .summary-corporate-rsvp table .admin[data-v-00db32c8], .summary-corporate-rsvp table .app[data-v-00db32c8], .summary-corporate-rsvp table .go[data-v-00db32c8], .summary-corporate-rsvp table .totalPax[data-v-00db32c8], .summary-corporate-rsvp table .avgPax[data-v-00db32c8], .summary-corporate-rsvp table .dutyHours[data-v-00db32c8], .corporate-rsvp table .date[data-v-00db32c8], .corporate-rsvp table .rsvpCount[data-v-00db32c8], .corporate-rsvp table .distance[data-v-00db32c8], .corporate-rsvp table .asap[data-v-00db32c8], .corporate-rsvp table .web[data-v-00db32c8], .corporate-rsvp table .admin[data-v-00db32c8], .corporate-rsvp table .app[data-v-00db32c8], .corporate-rsvp table .go[data-v-00db32c8], .corporate-rsvp table .totalPax[data-v-00db32c8], .corporate-rsvp table .avgPax[data-v-00db32c8], .corporate-rsvp table .dutyHours[data-v-00db32c8], .credit-converted table .date[data-v-00db32c8], .credit-converted table .rsvpCount[data-v-00db32c8], .credit-converted table .distance[data-v-00db32c8], .credit-converted table .asap[data-v-00db32c8], .credit-converted table .web[data-v-00db32c8], .credit-converted table .admin[data-v-00db32c8], .credit-converted table .app[data-v-00db32c8], .credit-converted table .go[data-v-00db32c8], .credit-converted table .totalPax[data-v-00db32c8], .credit-converted table .avgPax[data-v-00db32c8], .credit-converted table .dutyHours[data-v-00db32c8] {\n    text-align: center;\n}\n.rsvp-summary table .totalFare[data-v-00db32c8], .rsvp-summary table .avgFare[data-v-00db32c8], .rsvp-summary table .avgFarePP[data-v-00db32c8], .rsvp-summary table .extraFee[data-v-00db32c8], .rsvp-summary table .driverPayment[data-v-00db32c8], .rsvp-summary table .driverPercent[data-v-00db32c8], .driver-rsvp table .totalFare[data-v-00db32c8], .driver-rsvp table .avgFare[data-v-00db32c8], .driver-rsvp table .avgFarePP[data-v-00db32c8], .driver-rsvp table .extraFee[data-v-00db32c8], .driver-rsvp table .driverPayment[data-v-00db32c8], .driver-rsvp table .driverPercent[data-v-00db32c8], .service-rsvp table .totalFare[data-v-00db32c8], .service-rsvp table .avgFare[data-v-00db32c8], .service-rsvp table .avgFarePP[data-v-00db32c8], .service-rsvp table .extraFee[data-v-00db32c8], .service-rsvp table .driverPayment[data-v-00db32c8], .service-rsvp table .driverPercent[data-v-00db32c8], .promo-rsvp table .totalFare[data-v-00db32c8], .promo-rsvp table .avgFare[data-v-00db32c8], .promo-rsvp table .avgFarePP[data-v-00db32c8], .promo-rsvp table .extraFee[data-v-00db32c8], .promo-rsvp table .driverPayment[data-v-00db32c8], .promo-rsvp table .driverPercent[data-v-00db32c8], .status-rsvp table .totalFare[data-v-00db32c8], .status-rsvp table .avgFare[data-v-00db32c8], .status-rsvp table .avgFarePP[data-v-00db32c8], .status-rsvp table .extraFee[data-v-00db32c8], .status-rsvp table .driverPayment[data-v-00db32c8], .status-rsvp table .driverPercent[data-v-00db32c8], .brands-rsvp table .totalFare[data-v-00db32c8], .brands-rsvp table .avgFare[data-v-00db32c8], .brands-rsvp table .avgFarePP[data-v-00db32c8], .brands-rsvp table .extraFee[data-v-00db32c8], .brands-rsvp table .driverPayment[data-v-00db32c8], .brands-rsvp table .driverPercent[data-v-00db32c8], .summary-corporate-rsvp table .totalFare[data-v-00db32c8], .summary-corporate-rsvp table .avgFare[data-v-00db32c8], .summary-corporate-rsvp table .avgFarePP[data-v-00db32c8], .summary-corporate-rsvp table .extraFee[data-v-00db32c8], .summary-corporate-rsvp table .driverPayment[data-v-00db32c8], .summary-corporate-rsvp table .driverPercent[data-v-00db32c8], .corporate-rsvp table .totalFare[data-v-00db32c8], .corporate-rsvp table .avgFare[data-v-00db32c8], .corporate-rsvp table .avgFarePP[data-v-00db32c8], .corporate-rsvp table .extraFee[data-v-00db32c8], .corporate-rsvp table .driverPayment[data-v-00db32c8], .corporate-rsvp table .driverPercent[data-v-00db32c8], .credit-converted table .totalFare[data-v-00db32c8], .credit-converted table .avgFare[data-v-00db32c8], .credit-converted table .avgFarePP[data-v-00db32c8], .credit-converted table .extraFee[data-v-00db32c8], .credit-converted table .driverPayment[data-v-00db32c8], .credit-converted table .driverPercent[data-v-00db32c8] {\n    text-align: right;\n}\n.rsvp-summary table .driver[data-v-00db32c8], .rsvp-summary table .service[data-v-00db32c8], .rsvp-summary table .promo[data-v-00db32c8], .driver-rsvp table .driver[data-v-00db32c8], .driver-rsvp table .service[data-v-00db32c8], .driver-rsvp table .promo[data-v-00db32c8], .service-rsvp table .driver[data-v-00db32c8], .service-rsvp table .service[data-v-00db32c8], .service-rsvp table .promo[data-v-00db32c8], .promo-rsvp table .driver[data-v-00db32c8], .promo-rsvp table .service[data-v-00db32c8], .promo-rsvp table .promo[data-v-00db32c8], .status-rsvp table .driver[data-v-00db32c8], .status-rsvp table .service[data-v-00db32c8], .status-rsvp table .promo[data-v-00db32c8], .brands-rsvp table .driver[data-v-00db32c8], .brands-rsvp table .service[data-v-00db32c8], .brands-rsvp table .promo[data-v-00db32c8], .summary-corporate-rsvp table .driver[data-v-00db32c8], .summary-corporate-rsvp table .service[data-v-00db32c8], .summary-corporate-rsvp table .promo[data-v-00db32c8], .corporate-rsvp table .driver[data-v-00db32c8], .corporate-rsvp table .service[data-v-00db32c8], .corporate-rsvp table .promo[data-v-00db32c8], .credit-converted table .driver[data-v-00db32c8], .credit-converted table .service[data-v-00db32c8], .credit-converted table .promo[data-v-00db32c8] {\n    max-width: 200px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.airport-rsvp table tbody tr.total[data-v-00db32c8] {\n  border-top: 1px solid #333;\n}\n.airport-rsvp table .rsvpCount[data-v-00db32c8], .airport-rsvp table .asap[data-v-00db32c8], .airport-rsvp table .oneway[data-v-00db32c8], .airport-rsvp table .roundtrip[data-v-00db32c8] {\n  text-align: center;\n}\n.airport-rsvp table .roundtripInstances[data-v-00db32c8], .airport-rsvp table .totalRsvpInstances[data-v-00db32c8], .airport-rsvp table .onewayPercent[data-v-00db32c8],\n.airport-rsvp table .roundtripPercent[data-v-00db32c8] {\n  text-align: right;\n}\n.weekly-summary .table-heading[data-v-00db32c8] {\n  line-height: 1.2;\n}\n.weekly-summary .time[data-v-00db32c8] {\n  width: 100px;\n}\n.weekly-summary table td[data-v-00db32c8] {\n  text-align: center;\n}\n.weekly-summary tr.total[data-v-00db32c8] {\n  border-top: 1px solid #333;\n}\n.airport-rsvp-deparr table tr.total[data-v-00db32c8] {\n  border-top: 1px solid #333;\n}\n.airport-rsvp-deparr table tr td[data-v-00db32c8] {\n  text-align: center;\n}\n.variance-table[data-v-00db32c8] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.variance-table table .pickupTime[data-v-00db32c8], .variance-table table .pax[data-v-00db32c8], .variance-table table .paymentType[data-v-00db32c8] {\n    text-align: center;\n}\n.variance-table table .fare[data-v-00db32c8], .variance-table table .cash[data-v-00db32c8], .variance-table table .cc[data-v-00db32c8], .variance-table table .db[data-v-00db32c8], .variance-table table .check[data-v-00db32c8], .variance-table table .other[data-v-00db32c8], .variance-table table .variance[data-v-00db32c8] {\n    text-align: right;\n}\n.payment-rsvp table tr.total[data-v-00db32c8] {\n  border-top: 1px solid #333;\n}\n.payment-rsvp table .total-label[data-v-00db32c8], .payment-rsvp table .rsvp[data-v-00db32c8], .payment-rsvp table .pax[data-v-00db32c8] {\n  text-align: center;\n}\n.payment-rsvp table .charged[data-v-00db32c8], .payment-rsvp table .gratuity[data-v-00db32c8] {\n  text-align: right;\n}\n.trx-summary[data-v-00db32c8] {\n  height: 1122px !important;\n  width: 793px !important;\n}\n.trx-summary table tbody tr.total[data-v-00db32c8] {\n    border-top: 1px solid #333;\n}\n.trx-summary table .date[data-v-00db32c8], .trx-summary table .rsvpCount[data-v-00db32c8], .trx-summary table .trxCount[data-v-00db32c8], .trx-summary table .purchaseCount[data-v-00db32c8], .trx-summary table .additionalCount[data-v-00db32c8],\n  .trx-summary table .chargedTrxCount[data-v-00db32c8], .trx-summary table .refundTrxCount[data-v-00db32c8] {\n    text-align: center;\n}\n.trx-summary table .totalCharges[data-v-00db32c8], .trx-summary table .chargedAmount[data-v-00db32c8], .trx-summary table .refundAmount[data-v-00db32c8], .trx-summary table .netTotal[data-v-00db32c8] {\n    text-align: right;\n}\n.trx-detailed[data-v-00db32c8] {\n  height: 1122px !important;\n  width: 793px !important;\n}\n.trx-detailed table tbody tr.total[data-v-00db32c8] {\n    border-top: 1px solid #333;\n}\n.trx-detailed table .date[data-v-00db32c8], .trx-detailed table .rsvpId[data-v-00db32c8], .trx-detailed table .invoiceId[data-v-00db32c8], .trx-detailed table .customer[data-v-00db32c8], .trx-detailed table .cardOwner[data-v-00db32c8], .trx-detailed table .transactionType[data-v-00db32c8] {\n    text-align: center;\n}\n.trx-detailed table .chargedAmount[data-v-00db32c8], .trx-detailed table .refundAmount[data-v-00db32c8] {\n    text-align: right;\n}\n.trx-detailed table .transactionType[data-v-00db32c8] {\n    text-transform: capitalize;\n}\n.corporate-rsvp table tbody td[data-v-00db32c8] {\n  padding: 2px 5px !important;\n}\n.corporate-rsvp table .rsvpId[data-v-00db32c8], .corporate-rsvp table .corporate[data-v-00db32c8], .corporate-rsvp table .guest[data-v-00db32c8], .corporate-rsvp table .service[data-v-00db32c8], .corporate-rsvp table .pickupTime[data-v-00db32c8], .corporate-rsvp table .fare[data-v-00db32c8] {\n  text-align: center;\n}\n.corporate-rsvp table .pickupLocation[data-v-00db32c8] {\n  padding-right: 5px !important;\n}\n.corporate-rsvp table .dropoffLocation[data-v-00db32c8] {\n  padding-left: 5px !important;\n}\n.corporate-rsvp table .pickupLocation[data-v-00db32c8], .corporate-rsvp table .dropoffLocation[data-v-00db32c8] {\n  width: 205px;\n  max-width: 210px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rsvp-terminal .table-heading[data-v-00db32c8] {\n  line-height: 1.2;\n}\n.rsvp-terminal th[data-v-00db32c8] {\n  padding-bottom: 5px;\n}\n.rsvp-terminal .time[data-v-00db32c8] {\n  width: 100px;\n}\n.rsvp-terminal table td[data-v-00db32c8] {\n  text-align: center;\n}\n.rsvp-terminal tbody tr[data-v-00db32c8] {\n  border: 1px solid #eee;\n  border-left-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: transparent;\n}\n.rsvp-terminal tbody td[data-v-00db32c8] {\n  line-height: 1.5;\n}\n.rsvp-terminal tr.total[data-v-00db32c8] {\n  border-top: 1px solid #333;\n}\n.credit-converted .rsvpId[data-v-00db32c8], .credit-converted .brand[data-v-00db32c8], .credit-converted .pickupTime[data-v-00db32c8], .credit-converted .pickup[data-v-00db32c8], .credit-converted .dropoff[data-v-00db32c8], .credit-converted .service[data-v-00db32c8], .credit-converted .pax[data-v-00db32c8], .credit-converted .source[data-v-00db32c8], .credit-converted .total-pax[data-v-00db32c8] {\n  text-align: center;\n}\n.credit-converted .fare[data-v-00db32c8], .credit-converted .creditReceived[data-v-00db32c8], .credit-converted .total-fare[data-v-00db32c8], .credit-converted .total-creditReceived[data-v-00db32c8] {\n  text-align: right;\n}\n.slide-down-enter-active[data-v-00db32c8], .slide-down-leave-active[data-v-00db32c8] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-00db32c8], .slide-down-leave-to[data-v-00db32c8] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.rsvp-report .form-group .row.expanded.filter-date[data-v-00db32c8] {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    -webkit-column-gap: 1em;\n       -moz-column-gap: 1em;\n            column-gap: 1em;\n}\n.rsvp-report .form-group .row.expanded.filter-date .select-date[data-v-00db32c8] {\n      grid-column-start: 1;\n      grid-column-end: 3;\n}\n.rsvp-report .form-group .row.expanded.filter-date .small-4[data-v-00db32c8] {\n      padding: 0;\n      width: 100%;\n}\n.rsvp-report .form-group .row.expanded.filter-date .end-date[data-v-00db32c8] .vdp-datepicker__calendar {\n      right: 1px;\n}\n.rsvp-report .reports .report[data-v-00db32c8] {\n    padding: 2px 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rsvp-report-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"instruction"},[_vm._v("Please select a start and end date:")]),_vm._v(" "),_c('div',{staticClass:"row expanded filter-date"},[_c('div',{staticClass:"small-4 column padding-R select-date"},[_c('div',{staticClass:"date-input"},[_c('label',[_vm._v("Filter:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateType),expression:"dateType"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dateType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"bookingTime"}},[_vm._v("Booking Date")]),_vm._v(" "),_c('option',{attrs:{"value":"pickupTime"}},[_vm._v("Pickup Date")]),_vm._v(" "),_c('option',{attrs:{"value":"completeTime"}},[_vm._v("Completed Date")]),_vm._v(" "),_c('option',{attrs:{"value":"cancelTime"}},[_vm._v("Canceled Date")])])])]),_vm._v(" "),_c('div',{staticClass:"small-4 column padding-R"},[_c('div',{staticClass:"date-input"},[_c('label',[_vm._v("Start Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}})],1)]),_vm._v(" "),_c('div',{staticClass:"small-4 column padding-L"},[_c('div',{staticClass:"date-input"},[_c('label',[_vm._v("End Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker end-date",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"list-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"download-type"},[_c('label',{class:{'pdf':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pdfChecked),expression:"pdfChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.pdfChecked)?_vm._i(_vm.pdfChecked,null)>-1:(_vm.pdfChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.pdfChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.pdfChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.pdfChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.pdfChecked=$$c}}}}),_vm._v("\n            PDF\n          ")]),_vm._v(" "),_c('label',{class:{'csv':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.csvChecked),expression:"csvChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.csvChecked)?_vm._i(_vm.csvChecked,null)>-1:(_vm.csvChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.csvChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.csvChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.csvChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.csvChecked=$$c}}}}),_vm._v("\n            CSV\n          ")])]),_vm._v(" "),_c('div',{staticClass:"instruction"},[_vm._v("Please select the reports to generate:")]),_vm._v(" "),_c('div',{staticClass:"row expanded reports"},[_c('div',{class:['small-12 column report', _vm.reportStatus.rsvpSummary, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.rsvpSummary),expression:"selectedReports.rsvpSummary"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.rsvpSummary)?_vm._i(_vm.selectedReports.rsvpSummary,null)>-1:(_vm.selectedReports.rsvpSummary)},on:{"change":function($event){var $$a=_vm.selectedReports.rsvpSummary,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "rsvpSummary", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "rsvpSummary", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "rsvpSummary", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('rsvpSummary')))])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedSummary),expression:"selectedSummary"}],class:{'disabled':!_vm.selectedReports.rsvpSummary},attrs:{"disabled":!_vm.selectedReports.rsvpSummary},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedSummary=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.summaryReportStatus),function(status){return _c('option',{attrs:{"disabled":_vm.disableOption('rsvpSummary', status.value)},domProps:{"value":status.value}},[_vm._v(_vm._s(status.label))])}),0)]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.rsvpSummaryWeekly, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.rsvpSummaryWeekly),expression:"selectedReports.rsvpSummaryWeekly"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.rsvpSummaryWeekly)?_vm._i(_vm.selectedReports.rsvpSummaryWeekly,null)>-1:(_vm.selectedReports.rsvpSummaryWeekly)},on:{"change":function($event){var $$a=_vm.selectedReports.rsvpSummaryWeekly,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "rsvpSummaryWeekly", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "rsvpSummaryWeekly", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "rsvpSummaryWeekly", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('rsvpSummaryWeekly')))])])]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.rsvpByDate, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.rsvpByDate),expression:"selectedReports.rsvpByDate"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.rsvpByDate)?_vm._i(_vm.selectedReports.rsvpByDate,null)>-1:(_vm.selectedReports.rsvpByDate)},on:{"change":function($event){var $$a=_vm.selectedReports.rsvpByDate,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "rsvpByDate", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "rsvpByDate", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "rsvpByDate", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('rsvpByDate')))])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDetailed),expression:"selectedDetailed"}],class:{'disabled':!_vm.selectedReports.rsvpByDate},attrs:{"disabled":!_vm.selectedReports.rsvpByDate},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedDetailed=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.detailedReportStatus),function(status){return _c('option',{attrs:{"disabled":_vm.disableOption('rsvpByDate', status.value)},domProps:{"value":status.value}},[_vm._v(_vm._s(status.label))])}),0)]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.rsvpByRefund, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.rsvpByRefund),expression:"selectedReports.rsvpByRefund"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.rsvpByRefund)?_vm._i(_vm.selectedReports.rsvpByRefund,null)>-1:(_vm.selectedReports.rsvpByRefund)},on:{"change":function($event){var $$a=_vm.selectedReports.rsvpByRefund,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "rsvpByRefund", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "rsvpByRefund", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "rsvpByRefund", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('rsvpByRefund')))])])]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.rsvpByDriver, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.rsvpByDriver),expression:"selectedReports.rsvpByDriver"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.rsvpByDriver)?_vm._i(_vm.selectedReports.rsvpByDriver,null)>-1:(_vm.selectedReports.rsvpByDriver)},on:{"change":function($event){var $$a=_vm.selectedReports.rsvpByDriver,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "rsvpByDriver", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "rsvpByDriver", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "rsvpByDriver", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('rsvpByDriver')))])])]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.rsvpByDriverFare, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.rsvpByDriverFare),expression:"selectedReports.rsvpByDriverFare"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.rsvpByDriverFare)?_vm._i(_vm.selectedReports.rsvpByDriverFare,null)>-1:(_vm.selectedReports.rsvpByDriverFare)},on:{"change":function($event){var $$a=_vm.selectedReports.rsvpByDriverFare,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "rsvpByDriverFare", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "rsvpByDriverFare", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "rsvpByDriverFare", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('rsvpByDriverFare')))])])]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.rsvpByServiceType, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.rsvpByServiceType),expression:"selectedReports.rsvpByServiceType"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.rsvpByServiceType)?_vm._i(_vm.selectedReports.rsvpByServiceType,null)>-1:(_vm.selectedReports.rsvpByServiceType)},on:{"change":function($event){var $$a=_vm.selectedReports.rsvpByServiceType,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "rsvpByServiceType", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "rsvpByServiceType", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "rsvpByServiceType", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('rsvpByServiceType')))])])]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.rsvpByAirport, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.rsvpByAirport),expression:"selectedReports.rsvpByAirport"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.rsvpByAirport)?_vm._i(_vm.selectedReports.rsvpByAirport,null)>-1:(_vm.selectedReports.rsvpByAirport)},on:{"change":function($event){var $$a=_vm.selectedReports.rsvpByAirport,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "rsvpByAirport", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "rsvpByAirport", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "rsvpByAirport", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('rsvpByAirport')))])])]),_vm._v(" "),(_vm.airports.length)?_c('div',{class:['small-12 column report', _vm.reportStatus.rsvpByAirportDepArr, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.rsvpByAirportDepArr),expression:"selectedReports.rsvpByAirportDepArr"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.rsvpByAirportDepArr)?_vm._i(_vm.selectedReports.rsvpByAirportDepArr,null)>-1:(_vm.selectedReports.rsvpByAirportDepArr)},on:{"change":function($event){var $$a=_vm.selectedReports.rsvpByAirportDepArr,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "rsvpByAirportDepArr", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "rsvpByAirportDepArr", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "rsvpByAirportDepArr", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('rsvpByAirportDepArr')))])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAirport),expression:"selectedAirport"}],class:{'disabled':!_vm.selectedReports.rsvpByAirportDepArr},attrs:{"disabled":!_vm.selectedReports.rsvpByAirportDepArr},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedAirport=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Please select airport")]),_vm._v(" "),_vm._l((_vm.airports),function(airport){return _c('option',{domProps:{"value":airport.geofenceId}},[_vm._v("\n                "+_vm._s(airport.airportCode)+" - "+_vm._s(airport.description)+"\n              ")])})],2)]):_vm._e(),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.rsvpByGroup, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.rsvpByGroup),expression:"selectedReports.rsvpByGroup"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.rsvpByGroup)?_vm._i(_vm.selectedReports.rsvpByGroup,null)>-1:(_vm.selectedReports.rsvpByGroup)},on:{"change":function($event){var $$a=_vm.selectedReports.rsvpByGroup,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "rsvpByGroup", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "rsvpByGroup", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "rsvpByGroup", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('rsvpByGroup')))])])]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.rsvpByPayment, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.rsvpByPayment),expression:"selectedReports.rsvpByPayment"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.rsvpByPayment)?_vm._i(_vm.selectedReports.rsvpByPayment,null)>-1:(_vm.selectedReports.rsvpByPayment)},on:{"change":function($event){var $$a=_vm.selectedReports.rsvpByPayment,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "rsvpByPayment", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "rsvpByPayment", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "rsvpByPayment", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('rsvpByPayment')))])])]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.rsvpByTripStatus, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.rsvpByTripStatus),expression:"selectedReports.rsvpByTripStatus"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.rsvpByTripStatus)?_vm._i(_vm.selectedReports.rsvpByTripStatus,null)>-1:(_vm.selectedReports.rsvpByTripStatus)},on:{"change":function($event){var $$a=_vm.selectedReports.rsvpByTripStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "rsvpByTripStatus", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "rsvpByTripStatus", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "rsvpByTripStatus", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('rsvpByTripStatus')))])])]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.rsvpByBrands, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.rsvpByBrands),expression:"selectedReports.rsvpByBrands"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.rsvpByBrands)?_vm._i(_vm.selectedReports.rsvpByBrands,null)>-1:(_vm.selectedReports.rsvpByBrands)},on:{"change":function($event){var $$a=_vm.selectedReports.rsvpByBrands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "rsvpByBrands", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "rsvpByBrands", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "rsvpByBrands", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('rsvpByBrands')))])])]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.variance, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.variance),expression:"selectedReports.variance"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.variance)?_vm._i(_vm.selectedReports.variance,null)>-1:(_vm.selectedReports.variance)},on:{"change":function($event){var $$a=_vm.selectedReports.variance,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "variance", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "variance", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "variance", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('variance')))])])]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.rsvpSummaryCorporate, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.rsvpSummaryCorporate),expression:"selectedReports.rsvpSummaryCorporate"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.rsvpSummaryCorporate)?_vm._i(_vm.selectedReports.rsvpSummaryCorporate,null)>-1:(_vm.selectedReports.rsvpSummaryCorporate)},on:{"change":function($event){var $$a=_vm.selectedReports.rsvpSummaryCorporate,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "rsvpSummaryCorporate", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "rsvpSummaryCorporate", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "rsvpSummaryCorporate", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('rsvpSummaryCorporate')))])])]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.rsvpCorporate, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.rsvpCorporate),expression:"selectedReports.rsvpCorporate"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.rsvpCorporate)?_vm._i(_vm.selectedReports.rsvpCorporate,null)>-1:(_vm.selectedReports.rsvpCorporate)},on:{"change":function($event){var $$a=_vm.selectedReports.rsvpCorporate,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "rsvpCorporate", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "rsvpCorporate", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "rsvpCorporate", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('rsvpCorporate')))])])]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.rsvpTerminal, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.rsvpTerminal),expression:"selectedReports.rsvpTerminal"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.rsvpTerminal)?_vm._i(_vm.selectedReports.rsvpTerminal,null)>-1:(_vm.selectedReports.rsvpTerminal)},on:{"change":function($event){var $$a=_vm.selectedReports.rsvpTerminal,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "rsvpTerminal", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "rsvpTerminal", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "rsvpTerminal", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('rsvpTerminal')))])])]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.creditConverted, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.creditConverted),expression:"selectedReports.creditConverted"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.creditConverted)?_vm._i(_vm.selectedReports.creditConverted,null)>-1:(_vm.selectedReports.creditConverted)},on:{"change":function($event){var $$a=_vm.selectedReports.creditConverted,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "creditConverted", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "creditConverted", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "creditConverted", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('creditConverted')))])])]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.bySector, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.bySector),expression:"selectedReports.bySector"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.bySector)?_vm._i(_vm.selectedReports.bySector,null)>-1:(_vm.selectedReports.bySector)},on:{"change":function($event){var $$a=_vm.selectedReports.bySector,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "bySector", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "bySector", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "bySector", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('bySector')))])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.show),expression:"error.show"}],staticClass:"error"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.message),expression:"!!error.message"}]},[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.empty.length),expression:"error.empty.length"}]},[_c('li',[_vm._v("Empty Result:")]),_vm._v(" "),_vm._l((_vm.error.empty),function(empty){return _c('li',[_vm._v("- "+_vm._s(empty))])})],2)])]),_vm._v(" "),_c('a',{class:{ 'button cta success small block': true, disabled: _vm.pdf.loading },attrs:{"href":"javascript:;"},on:{"click":_vm.startProcess}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.pdf.loading),expression:"pdf.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pdf.loading),expression:"!pdf.loading"}]},[_vm._v("Generate and Download Report")])])],1)]),_vm._v(" "),_c('div',{class:[_vm.pdf.class],attrs:{"id":"pdf-view"}},[_vm._l((_vm.pdf.table.data),function(pageData,pageIndex){return _c('div',{class:['page', pageIndex]},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('table',[_c('thead',[(!_vm.isRsvpSummaryWeekly && !_vm.isRsvpTerminal)?_c('tr',_vm._l((_vm.pdf.table.label),function(label){return _c('th',{domProps:{"innerHTML":_vm._s(label)}})}),0):_vm._e(),_vm._v(" "),(_vm.isRsvpSummaryWeekly)?_c('tr',{staticClass:"table-heading"},[_c('th'),_vm._v(" "),(_vm.pdf.table.extra[pageIndex].day1)?_c('th',{attrs:{"colspan":"2"},domProps:{"innerHTML":_vm._s(_vm.weeklySummaryLabel(_vm.pdf.table.extra[pageIndex].day1.value))}}):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[pageIndex].day2)?_c('th',{attrs:{"colspan":"2"},domProps:{"innerHTML":_vm._s(_vm.weeklySummaryLabel(_vm.pdf.table.extra[pageIndex].day2.value))}}):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[pageIndex].day3)?_c('th',{attrs:{"colspan":"2"},domProps:{"innerHTML":_vm._s(_vm.weeklySummaryLabel(_vm.pdf.table.extra[pageIndex].day3.value))}}):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[pageIndex].day4)?_c('th',{attrs:{"colspan":"2"},domProps:{"innerHTML":_vm._s(_vm.weeklySummaryLabel(_vm.pdf.table.extra[pageIndex].day4.value))}}):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[pageIndex].day5)?_c('th',{attrs:{"colspan":"2"},domProps:{"innerHTML":_vm._s(_vm.weeklySummaryLabel(_vm.pdf.table.extra[pageIndex].day5.value))}}):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[pageIndex].day6)?_c('th',{attrs:{"colspan":"2"},domProps:{"innerHTML":_vm._s(_vm.weeklySummaryLabel(_vm.pdf.table.extra[pageIndex].day6.value))}}):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[pageIndex].day7)?_c('th',{attrs:{"colspan":"2"},domProps:{"innerHTML":_vm._s(_vm.weeklySummaryLabel(_vm.pdf.table.extra[pageIndex].day7.value))}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isRsvpSummaryWeekly)?_c('tr',{staticClass:"table-heading"},[_c('th',[_vm._v("Time period")]),_vm._v(" "),(!!_vm.pdf.table.extra[pageIndex].day1)?_c('th',[_vm._v("PAX")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[pageIndex].day1)?_c('th',[_vm._v("RSVP")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[pageIndex].day2)?_c('th',[_vm._v("PAX")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[pageIndex].day2)?_c('th',[_vm._v("RSVP")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[pageIndex].day3)?_c('th',[_vm._v("PAX")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[pageIndex].day3)?_c('th',[_vm._v("RSVP")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[pageIndex].day4)?_c('th',[_vm._v("PAX")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[pageIndex].day4)?_c('th',[_vm._v("RSVP")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[pageIndex].day5)?_c('th',[_vm._v("PAX")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[pageIndex].day5)?_c('th',[_vm._v("RSVP")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[pageIndex].day6)?_c('th',[_vm._v("PAX")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[pageIndex].day6)?_c('th',[_vm._v("RSVP")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[pageIndex].day7)?_c('th',[_vm._v("PAX")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[pageIndex].day7)?_c('th',[_vm._v("RSVP")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isRsvpTerminal)?_c('tr',{staticClass:"table-heading"},[_c('th',[_vm._v("Time period")]),_vm._v(" "),_vm._l((_vm.pdf.table.extra[pageIndex]),function(terminal,i){return _c('th',{key:i},[_vm._v("T "+_vm._s(i.substring(8)))])})],2):_vm._e()]),_vm._v(" "),_c('tbody',[_vm._l((pageData),function(data,index){return _c('tr',{key:index},_vm._l((data),function(value,i){return _c('td',{key:i,class:[i]},[_vm._v(_vm._s(value))])}),0)}),_vm._v(" "),(_vm.isRsvpByDate || _vm.isRsvpByRefund)?_c('tr',{class:{'subtotal':true, 'no-border':_vm.currentPage(pageIndex) == _vm.totalPage}},[_c('td',{staticClass:"total-count",attrs:{"colspan":[_vm.isRsvpByRefund ? '8' : '9']}},[_vm._v("Group Subtotal ("+_vm._s(_vm.pdf.table.extra[pageIndex].count)+")")]),_vm._v(" "),_c('td',{staticClass:"total-pax"},[_vm._v(_vm._s(_vm.pdf.table.extra[pageIndex].pax))]),_vm._v(" "),_c('td',{staticClass:"total-fare"},[_vm._v("$"+_vm._s(_vm.pdf.table.extra[pageIndex].fare))]),_vm._v(" "),(_vm.isRsvpByRefund)?_c('td',{staticClass:"total-refund"},[_vm._v("$"+_vm._s(_vm.pdf.table.extra[pageIndex].refund))]):_vm._e(),_vm._v(" "),(['completed', 'canceled'].indexOf(_vm.selectedDetailed) === -1)?_c('td'):_vm._e(),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:((_vm.selectedDetailed === 'canceled' || _vm.dateType === 'cancelTime') && _vm.isRsvpByDate),expression:"(selectedDetailed === 'canceled' || dateType === 'cancelTime') && isRsvpByDate"}],staticClass:"extraFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.extra[pageIndex].cancelFee))])]):_vm._e(),_vm._v(" "),(_vm.isRsvpByDate && _vm.currentPage(pageIndex) == _vm.totalPage)?_c('tr',{staticClass:"total"},[_c('td',{staticClass:"total-count",attrs:{"colspan":"9"}},[_vm._v("Report Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"total-pax"},[_vm._v(_vm._s(_vm.pdf.table.total.pax))]),_vm._v(" "),_c('td',{staticClass:"total-fare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fare))]),_vm._v(" "),(_vm.isRsvpByRefund)?_c('td',{staticClass:"total-refund"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.refund))]):_vm._e(),_vm._v(" "),(['completed', 'canceled'].indexOf(_vm.selectedDetailed) === -1)?_c('td'):_vm._e(),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedDetailed === 'canceled' && _vm.isRsvpByDate),expression:"selectedDetailed === 'canceled' && isRsvpByDate"}],staticClass:"extraFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.extraFee))])]):_vm._e(),_vm._v(" "),(_vm.isRsvpByRefund && _vm.currentPage(pageIndex) == _vm.totalPage)?_c('tr',{staticClass:"total"},[_c('td',{staticClass:"total-count",attrs:{"colspan":"8"}},[_vm._v("Report Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"total-pax"},[_vm._v(_vm._s(_vm.pdf.table.total.pax))]),_vm._v(" "),_c('td',{staticClass:"total-fare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fare))]),_vm._v(" "),(_vm.isRsvpByRefund)?_c('td',{staticClass:"total-refund"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.refund))]):_vm._e(),_vm._v(" "),(['completed', 'canceled'].indexOf(_vm.selectedDetailed) === -1)?_c('td'):_vm._e(),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedDetailed === 'canceled' && _vm.isRsvpByDate),expression:"selectedDetailed === 'canceled' && isRsvpByDate"}],staticClass:"extraFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.extraFee))])]):_vm._e(),_vm._v(" "),((_vm.isRsvpSummary || _vm.isRsvpByDriver || _vm.isRsvpByDriverFare || _vm.isServiceReservations || _vm.isRsvpByGroup || _vm.isRsvpByTripStatus || _vm.isRsvpByBrands || _vm.isRsvpSummaryCorporate) && _vm.currentPage(pageIndex) == _vm.totalPage)?_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),(_vm.isRsvpByDriver)?_c('td',{staticClass:"distance"},[_vm._v(_vm._s(_vm.pdf.table.total.distance))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"rsvpCount"},[_vm._v(_vm._s(_vm.pdf.table.total.rsvp))]),_vm._v(" "),_c('td',{staticClass:"asap"},[_vm._v(_vm._s(_vm.pdf.table.total.asap))]),_vm._v(" "),_c('td',{staticClass:"web"},[_vm._v(_vm._s(_vm.pdf.table.total.web))]),_vm._v(" "),_c('td',{staticClass:"web"},[_vm._v(_vm._s(_vm.pdf.table.total.admin))]),_vm._v(" "),_c('td',{staticClass:"web"},[_vm._v(_vm._s(_vm.pdf.table.total.app))]),_vm._v(" "),_c('td',{staticClass:"web"},[_vm._v(_vm._s(_vm.pdf.table.total.go))]),_vm._v(" "),_c('td',{staticClass:"totalPax"},[_vm._v(_vm._s(_vm.pdf.table.total.pax))]),_vm._v(" "),_c('td',{staticClass:"avgPax"},[_vm._v(_vm._s(_vm.pdf.table.total.avgPax))]),_vm._v(" "),(_vm.isDriverReservations)?_c('td',{staticClass:"dutyHours"},[_vm._v(_vm._s(_vm.pdf.table.total.dutyHours))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"totalFare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fare))]),_vm._v(" "),_c('td',{staticClass:"avgFare"},[_vm._v(_vm._s(_vm.pdf.table.total.avgFare))]),_vm._v(" "),_c('td',{staticClass:"avgFarePP"},[_vm._v(_vm._s(_vm.pdf.table.total.avgFarePP))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:((['canceled', 'promo', 'noshow'].indexOf(_vm.selectedSummary) > -1 && _vm.isRsvpSummary) || _vm.isDriverReservations),expression:"(['canceled', 'promo', 'noshow'].indexOf(selectedSummary) > -1 && isRsvpSummary) || isDriverReservations"}],staticClass:"extraFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.extraFee))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDriverReservations),expression:"isDriverReservations"}],staticClass:"driverPercent"},[_vm._v(_vm._s(_vm.pdf.table.total.percent))])]):_vm._e(),_vm._v(" "),(_vm.isRsvpCorporate && _vm.currentPage(pageIndex) == _vm.totalPage)?_c('tr',{staticClass:"total"},[_c('td',{staticClass:"total-count",attrs:{"colspan":"7"}},[_vm._v("Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"total-fare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fare))])]):_vm._e(),_vm._v(" "),(_vm.isAirportReservations && _vm.currentPage(pageIndex) == _vm.totalPage)?_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"rsvpCount"},[_vm._v(_vm._s(_vm.pdf.table.total.rsvp))]),_vm._v(" "),_c('td',{staticClass:"asap"},[_vm._v(_vm._s(_vm.pdf.table.total.asap))]),_vm._v(" "),_c('td',{staticClass:"oneway"},[_vm._v(_vm._s(_vm.pdf.table.total.oneway))]),_vm._v(" "),_c('td',{staticClass:"roundtrip"},[_vm._v(_vm._s(_vm.pdf.table.total.roundtrip))]),_vm._v(" "),_c('td',{staticClass:"roundtripInstances"},[_vm._v(_vm._s(_vm.pdf.table.total.roundtripInstances))]),_vm._v(" "),_c('td',{staticClass:"totalRsvpInstances"},[_vm._v(_vm._s(_vm.pdf.table.total.rsvpIsntances))]),_vm._v(" "),_c('td',{staticClass:"onewayPercent"},[_vm._v(_vm._s(_vm.pdf.table.total.onewayPercent)+"%")]),_vm._v(" "),_c('td',{staticClass:"roundtripPercent"},[_vm._v(_vm._s(_vm.pdf.table.total.roundtripPercent)+"%")])]):_vm._e(),_vm._v(" "),(_vm.isRsvpSummaryWeekly)?_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Totals")]),_vm._v(" "),(_vm.pdf.table.extra[pageIndex].day1)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[pageIndex].day1.pax))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[pageIndex].day1)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[pageIndex].day1.rsvp))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[pageIndex].day2)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[pageIndex].day2.pax))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[pageIndex].day2)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[pageIndex].day2.rsvp))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[pageIndex].day3)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[pageIndex].day3.pax))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[pageIndex].day3)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[pageIndex].day3.rsvp))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[pageIndex].day4)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[pageIndex].day4.pax))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[pageIndex].day4)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[pageIndex].day4.rsvp))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[pageIndex].day5)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[pageIndex].day5.pax))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[pageIndex].day5)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[pageIndex].day5.rsvp))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[pageIndex].day6)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[pageIndex].day6.pax))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[pageIndex].day6)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[pageIndex].day6.rsvp))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[pageIndex].day7)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[pageIndex].day7.pax))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[pageIndex].day7)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[pageIndex].day7.rsvp))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isRsvpTerminal)?_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Totals")]),_vm._v(" "),_vm._l((_vm.pdf.table.extra[pageIndex]),function(terminal,index){return _c('td',{key:index},[_vm._v(_vm._s(terminal.rsvp))])})],2):_vm._e(),_vm._v(" "),(_vm.isRsvpByAirportDepArr && _vm.currentPage(pageIndex) == _vm.totalPage)?_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Totals")]),_vm._v(" "),_c('td',{staticClass:"departureRsvp"},[_vm._v(_vm._s(_vm.pdf.table.total.departureRsvp))]),_vm._v(" "),_c('td',{staticClass:"arrivalRsvp"},[_vm._v(_vm._s(_vm.pdf.table.total.arrivalRsvp))]),_vm._v(" "),_c('td',{staticClass:"totalRsvp"},[_vm._v(_vm._s(_vm.pdf.table.total.totalRsvp))]),_vm._v(" "),_c('td',{staticClass:"departurePax"},[_vm._v(_vm._s(_vm.pdf.table.total.departurePax))]),_vm._v(" "),_c('td',{staticClass:"arrivalPax"},[_vm._v(_vm._s(_vm.pdf.table.total.arrivalPax))]),_vm._v(" "),_c('td',{staticClass:"totalPax"},[_vm._v(_vm._s(_vm.pdf.table.total.totalPax))])]):_vm._e(),_vm._v(" "),(_vm.isRsvpByPayment)?_c('tr',{staticClass:"total"},[_c('td',{staticClass:"total-label"},[_vm._v("Totals")]),_vm._v(" "),_c('td',{staticClass:"rsvp"},[_vm._v(_vm._s(_vm.pdf.table.total.rsvp))]),_vm._v(" "),_c('td',{staticClass:"pax"},[_vm._v(_vm._s(_vm.pdf.table.total.pax))]),_vm._v(" "),_c('td',{staticClass:"charged"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.charged))]),_vm._v(" "),_c('td',{staticClass:"gratuity"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.gratuity))])]):_vm._e(),_vm._v(" "),(_vm.isCreditConverted && _vm.currentPage(pageIndex) == _vm.totalPage)?_c('tr',{staticClass:"total"},[_c('td',{staticClass:"total-count",attrs:{"colspan":"7"}},[_vm._v("Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"total-pax"},[_vm._v(_vm._s(_vm.pdf.table.total.pax))]),_vm._v(" "),_c('td',{staticClass:"total-fare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fare))]),_vm._v(" "),_c('td',{staticClass:"total-creditReceived"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.creditReceived))])]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"page-count"},[_vm._v("page "+_vm._s(_vm.currentPage(pageIndex))+" of "+_vm._s(_vm.totalPage))])])}),_vm._v(" "),(Object.keys(_vm.pdf.table.data).length)?_c('div',{class:['page', ("page" + (Object.keys(_vm.pdf.table.data).length + 1))]},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('table',[_c('thead',[(!_vm.isRsvpSummaryWeekly && !_vm.isRsvpTerminal)?_c('tr',_vm._l((_vm.pdf.table.label),function(label){return _c('th',{domProps:{"innerHTML":_vm._s(label)}})}),0):_vm._e(),_vm._v(" "),(_vm.isRsvpSummaryWeekly)?_c('tr',{staticClass:"table-heading"},[_c('th'),_vm._v(" "),(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day1)?_c('th',{attrs:{"colspan":"2"},domProps:{"innerHTML":_vm._s(_vm.weeklySummaryLabel(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day1.value))}}):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day2)?_c('th',{attrs:{"colspan":"2"},domProps:{"innerHTML":_vm._s(_vm.weeklySummaryLabel(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day2.value))}}):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day3)?_c('th',{attrs:{"colspan":"2"},domProps:{"innerHTML":_vm._s(_vm.weeklySummaryLabel(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day3.value))}}):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day4)?_c('th',{attrs:{"colspan":"2"},domProps:{"innerHTML":_vm._s(_vm.weeklySummaryLabel(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day4.value))}}):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day5)?_c('th',{attrs:{"colspan":"2"},domProps:{"innerHTML":_vm._s(_vm.weeklySummaryLabel(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day5.value))}}):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day6)?_c('th',{attrs:{"colspan":"2"},domProps:{"innerHTML":_vm._s(_vm.weeklySummaryLabel(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day6.value))}}):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day7)?_c('th',{attrs:{"colspan":"2"},domProps:{"innerHTML":_vm._s(_vm.weeklySummaryLabel(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day7.value))}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isRsvpSummaryWeekly)?_c('tr',{staticClass:"table-heading"},[_c('th',[_vm._v("Time period")]),_vm._v(" "),(!!_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day1)?_c('th',[_vm._v("PAX")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day1)?_c('th',[_vm._v("RSVP")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day2)?_c('th',[_vm._v("PAX")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day2)?_c('th',[_vm._v("RSVP")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day3)?_c('th',[_vm._v("PAX")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day3)?_c('th',[_vm._v("RSVP")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day4)?_c('th',[_vm._v("PAX")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day4)?_c('th',[_vm._v("RSVP")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day5)?_c('th',[_vm._v("PAX")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day5)?_c('th',[_vm._v("RSVP")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day6)?_c('th',[_vm._v("PAX")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day6)?_c('th',[_vm._v("RSVP")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day7)?_c('th',[_vm._v("PAX")]):_vm._e(),_vm._v(" "),(!!_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day7)?_c('th',[_vm._v("RSVP")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isRsvpTerminal)?_c('tr',{staticClass:"table-heading"},[_c('th',[_vm._v("Time period")]),_vm._v(" "),_vm._l((_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))]),function(terminal,i){return _c('th',{key:i},[_vm._v("T "+_vm._s(i.substring(8)))])})],2):_vm._e()]),_vm._v(" "),_c('tbody',[_vm._l((_vm.pdf.table.data[("page" + (Object.keys(_vm.pdf.table.data).length))]),function(data,index){return _c('tr',{key:index},_vm._l((data),function(value,i){return _c('td',{key:i,class:[i]},[_vm._v(_vm._s(value))])}),0)}),_vm._v(" "),(_vm.isRsvpByDate || _vm.isRsvpByRefund)?_c('tr',{staticClass:"subtotal no-border"},[_c('td',{staticClass:"total-count",attrs:{"colspan":[_vm.isRsvpByRefund ? '8' : '9']}},[_vm._v("Group Subtotal ("+_vm._s(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].count)+")")]),_vm._v(" "),_c('td',{staticClass:"total-pax"},[_vm._v(_vm._s(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].pax))]),_vm._v(" "),_c('td',{staticClass:"total-fare"},[_vm._v("$"+_vm._s(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].fare))]),_vm._v(" "),(_vm.isRsvpByRefund)?_c('td',{staticClass:"total-refund"},[_vm._v("$"+_vm._s(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].refund))]):_vm._e(),_vm._v(" "),(['completed', 'canceled'].indexOf(_vm.selectedDetailed) === -1)?_c('td'):_vm._e(),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:((_vm.selectedDetailed === 'canceled' || _vm.dateType === 'cancelTime') && _vm.isRsvpByDate),expression:"(selectedDetailed === 'canceled' || dateType === 'cancelTime') && isRsvpByDate"}],staticClass:"extraFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].cancelFee))])]):_vm._e(),_vm._v(" "),(_vm.isRsvpByDate)?_c('tr',{staticClass:"total"},[_c('td',{staticClass:"total-count",attrs:{"colspan":"9"}},[_vm._v("Report Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"total-pax"},[_vm._v(_vm._s(_vm.pdf.table.total.pax))]),_vm._v(" "),_c('td',{staticClass:"total-fare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fare))]),_vm._v(" "),(_vm.isRsvpByRefund)?_c('td',{staticClass:"total-refund"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.refund))]):_vm._e(),_vm._v(" "),(['completed', 'canceled'].indexOf(_vm.selectedDetailed) === -1)?_c('td'):_vm._e(),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedDetailed === 'canceled' && _vm.isRsvpByDate),expression:"selectedDetailed === 'canceled' && isRsvpByDate"}],staticClass:"extraFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.extraFee))])]):_vm._e(),_vm._v(" "),(_vm.isRsvpByRefund)?_c('tr',{staticClass:"total"},[_c('td',{staticClass:"total-count",attrs:{"colspan":"8"}},[_vm._v("Report Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"total-pax"},[_vm._v(_vm._s(_vm.pdf.table.total.pax))]),_vm._v(" "),_c('td',{staticClass:"total-fare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fare))]),_vm._v(" "),(_vm.isRsvpByRefund)?_c('td',{staticClass:"total-refund"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.refund))]):_vm._e(),_vm._v(" "),(['completed', 'canceled'].indexOf(_vm.selectedDetailed) === -1)?_c('td'):_vm._e(),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedDetailed === 'canceled' && _vm.isRsvpByDate),expression:"selectedDetailed === 'canceled' && isRsvpByDate"}],staticClass:"extraFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.extraFee))])]):_vm._e(),_vm._v(" "),((_vm.isRsvpSummary || _vm.isDriverReservations || _vm.isServiceReservations || _vm.isRsvpByGroup || _vm.isRsvpByTripStatus || _vm.isRsvpByBrands || _vm.isRsvpSummaryCorporate))?_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"rsvpCount"},[_vm._v(_vm._s(_vm.pdf.table.total.rsvp))]),_vm._v(" "),_c('td',{staticClass:"asap"},[_vm._v(_vm._s(_vm.pdf.table.total.asap))]),_vm._v(" "),_c('td',{staticClass:"web"},[_vm._v(_vm._s(_vm.pdf.table.total.web))]),_vm._v(" "),_c('td',{staticClass:"web"},[_vm._v(_vm._s(_vm.pdf.table.total.admin))]),_vm._v(" "),_c('td',{staticClass:"web"},[_vm._v(_vm._s(_vm.pdf.table.total.app))]),_vm._v(" "),_c('td',{staticClass:"web"},[_vm._v(_vm._s(_vm.pdf.table.total.go))]),_vm._v(" "),_c('td',{staticClass:"totalPax"},[_vm._v(_vm._s(_vm.pdf.table.total.pax))]),_vm._v(" "),_c('td',{staticClass:"avgPax"},[_vm._v(_vm._s(_vm.pdf.table.total.avgPax))]),_vm._v(" "),(_vm.isDriverReservations)?_c('td',{staticClass:"dutyHours"},[_vm._v(_vm._s(_vm.pdf.table.total.dutyHours))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"totalFare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fare))]),_vm._v(" "),_c('td',{staticClass:"avgFare"},[_vm._v(_vm._s(_vm.pdf.table.total.avgFare))]),_vm._v(" "),_c('td',{staticClass:"avgFarePP"},[_vm._v(_vm._s(_vm.pdf.table.total.avgFarePP))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:((['canceled', 'promo', 'noshow'].indexOf(_vm.selectedSummary) > -1 && _vm.isRsvpSummary) || _vm.isDriverReservations),expression:"(['canceled', 'promo', 'noshow'].indexOf(selectedSummary) > -1 && isRsvpSummary) || isDriverReservations"}],staticClass:"extraFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.extraFee))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDriverReservations),expression:"isDriverReservations"}],staticClass:"driverPercent"},[_vm._v(_vm._s(_vm.pdf.table.total.percent))])]):_vm._e(),_vm._v(" "),(_vm.isRsvpCorporate)?_c('tr',{staticClass:"total"},[_c('td',{staticClass:"total-count",attrs:{"colspan":"7"}},[_vm._v("Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"total-fare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fare))])]):_vm._e(),_vm._v(" "),(_vm.isAirportReservations)?_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"rsvpCount"},[_vm._v(_vm._s(_vm.pdf.table.total.rsvp))]),_vm._v(" "),_c('td',{staticClass:"asap"},[_vm._v(_vm._s(_vm.pdf.table.total.asap))]),_vm._v(" "),_c('td',{staticClass:"oneway"},[_vm._v(_vm._s(_vm.pdf.table.total.oneway))]),_vm._v(" "),_c('td',{staticClass:"roundtrip"},[_vm._v(_vm._s(_vm.pdf.table.total.roundtrip))]),_vm._v(" "),_c('td',{staticClass:"roundtripInstances"},[_vm._v(_vm._s(_vm.pdf.table.total.roundtripInstances))]),_vm._v(" "),_c('td',{staticClass:"totalRsvpInstances"},[_vm._v(_vm._s(_vm.pdf.table.total.rsvpIsntances))]),_vm._v(" "),_c('td',{staticClass:"onewayPercent"},[_vm._v(_vm._s(_vm.pdf.table.total.onewayPercent)+"%")]),_vm._v(" "),_c('td',{staticClass:"roundtripPercent"},[_vm._v(_vm._s(_vm.pdf.table.total.roundtripPercent)+"%")])]):_vm._e(),_vm._v(" "),(_vm.isRsvpSummaryWeekly)?_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Totals")]),_vm._v(" "),(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day1)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day1.pax))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day1)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day1.rsvp))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day2)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day2.pax))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day2)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day2.rsvp))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day3)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day3.pax))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day3)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day3.rsvp))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day4)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day4.pax))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day4)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day4.rsvp))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day5)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day5.pax))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day5)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day5.rsvp))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day6)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day6.pax))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day6)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day6.rsvp))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day7)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day7.pax))]):_vm._e(),_vm._v(" "),(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day7)?_c('td',[_vm._v(_vm._s(_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))].day7.rsvp))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isRsvpTerminal)?_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Totals")]),_vm._v(" "),_vm._l((_vm.pdf.table.extra[("page" + (Object.keys(_vm.pdf.table.extra).length))]),function(terminal,index){return _c('td',{key:index},[_vm._v(_vm._s(terminal.rsvp))])})],2):_vm._e(),_vm._v(" "),(_vm.isRsvpByAirportDepArr)?_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Totals")]),_vm._v(" "),_c('td',{staticClass:"departureRsvp"},[_vm._v(_vm._s(_vm.pdf.table.total.departureRsvp))]),_vm._v(" "),_c('td',{staticClass:"arrivalRsvp"},[_vm._v(_vm._s(_vm.pdf.table.total.arrivalRsvp))]),_vm._v(" "),_c('td',{staticClass:"totalRsvp"},[_vm._v(_vm._s(_vm.pdf.table.total.totalRsvp))]),_vm._v(" "),_c('td',{staticClass:"departurePax"},[_vm._v(_vm._s(_vm.pdf.table.total.departurePax))]),_vm._v(" "),_c('td',{staticClass:"arrivalPax"},[_vm._v(_vm._s(_vm.pdf.table.total.arrivalPax))]),_vm._v(" "),_c('td',{staticClass:"totalPax"},[_vm._v(_vm._s(_vm.pdf.table.total.totalPax))])]):_vm._e(),_vm._v(" "),(_vm.isRsvpByPayment)?_c('tr',{staticClass:"total"},[_c('td',{staticClass:"total-label"},[_vm._v("Totals")]),_vm._v(" "),_c('td',{staticClass:"rsvp"},[_vm._v(_vm._s(_vm.pdf.table.total.rsvp))]),_vm._v(" "),_c('td',{staticClass:"pax"},[_vm._v(_vm._s(_vm.pdf.table.total.pax))]),_vm._v(" "),_c('td',{staticClass:"charged"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.charged))]),_vm._v(" "),_c('td',{staticClass:"gratuity"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.gratuity))])]):_vm._e(),_vm._v(" "),(_vm.isCreditConverted)?_c('tr',{staticClass:"total"},[_c('td',{staticClass:"total-count",attrs:{"colspan":"7"}},[_vm._v("Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"total-pax"},[_vm._v(_vm._s(_vm.pdf.table.total.pax))]),_vm._v(" "),_c('td',{staticClass:"total-fare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fare))]),_vm._v(" "),_c('td',{staticClass:"total-creditReceived"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.creditReceived))])]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"page-count"},[_vm._v("page "+_vm._s(Object.keys(_vm.pdf.table.data).length)+" of "+_vm._s(_vm.totalPage))])]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LAWAReport_vue__ = __webpack_require__(518);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c3573d1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LAWAReport_vue__ = __webpack_require__(1473);
function injectStyle (ssrContext) {
  __webpack_require__(1458)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c3573d1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LAWAReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c3573d1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LAWAReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1459);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5933248a", content, true, {});

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.tnc-report[data-v-1c3573d1] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  padding: 20px;\n}\n.tnc-report .title[data-v-1c3573d1] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n}\n.tnc-report .date-input[data-v-1c3573d1] {\n    margin-bottom: 10px;\n}\n.tnc-report .date-input label[data-v-1c3573d1] {\n      margin-bottom: 5px;\n      font-size: 14px;\n      color: #777;\n      display: block;\n}\n.tnc-report .instruction[data-v-1c3573d1] {\n    text-align: center;\n    margin-bottom: 10px;\n    font-size: 14px;\n    font-weight: 700;\n    color: #777;\n    text-decoration: underline;\n}\n.report-select[data-v-1c3573d1] {\n  background-color: #f5f5f5;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-bottom: 0;\n  margin-bottom: 20px;\n}\n.report-select .check-input[data-v-1c3573d1] {\n    display: block;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n    padding: 5px 10px;\n}\n.report-select .check-input > *[data-v-1c3573d1] {\n      display: inline-block;\n      vertical-align: middle;\n      width: auto;\n      margin: 0;\n}\n.report-select .check-input > span[data-v-1c3573d1] {\n      margin-left: 5px;\n}\n.error[data-v-1c3573d1] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n}\n.padding-R[data-v-1c3573d1] {\n  padding-right: 7px;\n}\n.padding-L[data-v-1c3573d1] {\n  padding-left: 7px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Reports/LAWAReport.vue"],"names":[],"mappings":";AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,cAAc;CACf;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,mBAAmB;MACnB,gBAAgB;MAChB,YAAY;MACZ,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,2BAA2B;CAC9B;AACD;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,iBAAiB;EACjB,oBAAoB;CACrB;AACD;IACI,eAAe;IACf,4CAA4C;IAC5C,kBAAkB;CACrB;AACD;MACM,sBAAsB;MACtB,uBAAuB;MACvB,YAAY;MACZ,UAAU;CACf;AACD;MACM,iBAAiB;CACtB;AACD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,oBAAoB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB","file":"LAWAReport.vue","sourcesContent":["\n.tnc-report[data-v-1c3573d1] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  padding: 20px;\n}\n.tnc-report .title[data-v-1c3573d1] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n}\n.tnc-report .date-input[data-v-1c3573d1] {\n    margin-bottom: 10px;\n}\n.tnc-report .date-input label[data-v-1c3573d1] {\n      margin-bottom: 5px;\n      font-size: 14px;\n      color: #777;\n      display: block;\n}\n.tnc-report .instruction[data-v-1c3573d1] {\n    text-align: center;\n    margin-bottom: 10px;\n    font-size: 14px;\n    font-weight: 700;\n    color: #777;\n    text-decoration: underline;\n}\n.report-select[data-v-1c3573d1] {\n  background-color: #f5f5f5;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-bottom: 0;\n  margin-bottom: 20px;\n}\n.report-select .check-input[data-v-1c3573d1] {\n    display: block;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n    padding: 5px 10px;\n}\n.report-select .check-input > *[data-v-1c3573d1] {\n      display: inline-block;\n      vertical-align: middle;\n      width: auto;\n      margin: 0;\n}\n.report-select .check-input > span[data-v-1c3573d1] {\n      margin-left: 5px;\n}\n.error[data-v-1c3573d1] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n}\n.padding-R[data-v-1c3573d1] {\n  padding-right: 7px;\n}\n.padding-L[data-v-1c3573d1] {\n  padding-left: 7px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 1461 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1462 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/*

JSZip - A Javascript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2014 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/master/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/master/LICENSE

Note: since JSZip 3 removed critical functionality, this version assigns to the
`JSZipSync` variable.  Another JSZip version can be loaded in parallel.
*/
(function(e){
	if("object"==typeof exports&&"undefined"!=typeof module&&"undefined"==typeof DO_NOT_EXPORT_JSZIP)module.exports=e();
	else if("function"=="function"&&__webpack_require__(1464)&&"undefined"==typeof DO_NOT_EXPORT_JSZIP){JSZipSync=e();!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}
	else{
		var f;
		"undefined"!=typeof window?f=window:
		"undefined"!=typeof global?f=global:
		"undefined"!=typeof $ && $.global?f=$.global:
		"undefined"!=typeof self&&(f=self),f.JSZipSync=e()
	}
}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
'use strict';
// private property
var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";


// public method for encoding
exports.encode = function(input, utf8) {
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;

    while (i < input.length) {

        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;

        if (isNaN(chr2)) {
            enc3 = enc4 = 64;
        }
        else if (isNaN(chr3)) {
            enc4 = 64;
        }

        output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);

    }

    return output;
};

// public method for decoding
exports.decode = function(input, utf8) {
    var output = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;

    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

    while (i < input.length) {

        enc1 = _keyStr.indexOf(input.charAt(i++));
        enc2 = _keyStr.indexOf(input.charAt(i++));
        enc3 = _keyStr.indexOf(input.charAt(i++));
        enc4 = _keyStr.indexOf(input.charAt(i++));

        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;

        output = output + String.fromCharCode(chr1);

        if (enc3 != 64) {
            output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
            output = output + String.fromCharCode(chr3);
        }

    }

    return output;

};

},{}],2:[function(_dereq_,module,exports){
'use strict';
function CompressedObject() {
    this.compressedSize = 0;
    this.uncompressedSize = 0;
    this.crc32 = 0;
    this.compressionMethod = null;
    this.compressedContent = null;
}

CompressedObject.prototype = {
    /**
     * Return the decompressed content in an unspecified format.
     * The format will depend on the decompressor.
     * @return {Object} the decompressed content.
     */
    getContent: function() {
        return null; // see implementation
    },
    /**
     * Return the compressed content in an unspecified format.
     * The format will depend on the compressed conten source.
     * @return {Object} the compressed content.
     */
    getCompressedContent: function() {
        return null; // see implementation
    }
};
module.exports = CompressedObject;

},{}],3:[function(_dereq_,module,exports){
'use strict';
exports.STORE = {
    magic: "\x00\x00",
    compress: function(content) {
        return content; // no compression
    },
    uncompress: function(content) {
        return content; // no compression
    },
    compressInputType: null,
    uncompressInputType: null
};
exports.DEFLATE = _dereq_('./flate');

},{"./flate":8}],4:[function(_dereq_,module,exports){
'use strict';

var utils = _dereq_('./utils');

var table = [
    0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA,
    0x076DC419, 0x706AF48F, 0xE963A535, 0x9E6495A3,
    0x0EDB8832, 0x79DCB8A4, 0xE0D5E91E, 0x97D2D988,
    0x09B64C2B, 0x7EB17CBD, 0xE7B82D07, 0x90BF1D91,
    0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
    0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7,
    0x136C9856, 0x646BA8C0, 0xFD62F97A, 0x8A65C9EC,
    0x14015C4F, 0x63066CD9, 0xFA0F3D63, 0x8D080DF5,
    0x3B6E20C8, 0x4C69105E, 0xD56041E4, 0xA2677172,
    0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
    0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940,
    0x32D86CE3, 0x45DF5C75, 0xDCD60DCF, 0xABD13D59,
    0x26D930AC, 0x51DE003A, 0xC8D75180, 0xBFD06116,
    0x21B4F4B5, 0x56B3C423, 0xCFBA9599, 0xB8BDA50F,
    0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
    0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D,
    0x76DC4190, 0x01DB7106, 0x98D220BC, 0xEFD5102A,
    0x71B18589, 0x06B6B51F, 0x9FBFE4A5, 0xE8B8D433,
    0x7807C9A2, 0x0F00F934, 0x9609A88E, 0xE10E9818,
    0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
    0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E,
    0x6C0695ED, 0x1B01A57B, 0x8208F4C1, 0xF50FC457,
    0x65B0D9C6, 0x12B7E950, 0x8BBEB8EA, 0xFCB9887C,
    0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3, 0xFBD44C65,
    0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
    0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB,
    0x4369E96A, 0x346ED9FC, 0xAD678846, 0xDA60B8D0,
    0x44042D73, 0x33031DE5, 0xAA0A4C5F, 0xDD0D7CC9,
    0x5005713C, 0x270241AA, 0xBE0B1010, 0xC90C2086,
    0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
    0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4,
    0x59B33D17, 0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD,
    0xEDB88320, 0x9ABFB3B6, 0x03B6E20C, 0x74B1D29A,
    0xEAD54739, 0x9DD277AF, 0x04DB2615, 0x73DC1683,
    0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
    0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1,
    0xF00F9344, 0x8708A3D2, 0x1E01F268, 0x6906C2FE,
    0xF762575D, 0x806567CB, 0x196C3671, 0x6E6B06E7,
    0xFED41B76, 0x89D32BE0, 0x10DA7A5A, 0x67DD4ACC,
    0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
    0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252,
    0xD1BB67F1, 0xA6BC5767, 0x3FB506DD, 0x48B2364B,
    0xD80D2BDA, 0xAF0A1B4C, 0x36034AF6, 0x41047A60,
    0xDF60EFC3, 0xA867DF55, 0x316E8EEF, 0x4669BE79,
    0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
    0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F,
    0xC5BA3BBE, 0xB2BD0B28, 0x2BB45A92, 0x5CB36A04,
    0xC2D7FFA7, 0xB5D0CF31, 0x2CD99E8B, 0x5BDEAE1D,
    0x9B64C2B0, 0xEC63F226, 0x756AA39C, 0x026D930A,
    0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
    0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38,
    0x92D28E9B, 0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21,
    0x86D3D2D4, 0xF1D4E242, 0x68DDB3F8, 0x1FDA836E,
    0x81BE16CD, 0xF6B9265B, 0x6FB077E1, 0x18B74777,
    0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
    0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45,
    0xA00AE278, 0xD70DD2EE, 0x4E048354, 0x3903B3C2,
    0xA7672661, 0xD06016F7, 0x4969474D, 0x3E6E77DB,
    0xAED16A4A, 0xD9D65ADC, 0x40DF0B66, 0x37D83BF0,
    0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
    0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6,
    0xBAD03605, 0xCDD70693, 0x54DE5729, 0x23D967BF,
    0xB3667A2E, 0xC4614AB8, 0x5D681B02, 0x2A6F2B94,
    0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B, 0x2D02EF8D
];

/**
 *
 *  Javascript crc32
 *  http://www.webtoolkit.info/
 *
 */
module.exports = function crc32(input, crc) {
    if (typeof input === "undefined" || !input.length) {
        return 0;
    }

    var isArray = utils.getTypeOf(input) !== "string";

    if (typeof(crc) == "undefined") {
        crc = 0;
    }
    var x = 0;
    var y = 0;
    var b = 0;

    crc = crc ^ (-1);
    for (var i = 0, iTop = input.length; i < iTop; i++) {
        b = isArray ? input[i] : input.charCodeAt(i);
        y = (crc ^ b) & 0xFF;
        x = table[y];
        crc = (crc >>> 8) ^ x;
    }

    return crc ^ (-1);
};
// vim: set shiftwidth=4 softtabstop=4:

},{"./utils":21}],5:[function(_dereq_,module,exports){
'use strict';
var utils = _dereq_('./utils');

function DataReader(data) {
    this.data = null; // type : see implementation
    this.length = 0;
    this.index = 0;
}
DataReader.prototype = {
    /**
     * Check that the offset will not go too far.
     * @param {string} offset the additional offset to check.
     * @throws {Error} an Error if the offset is out of bounds.
     */
    checkOffset: function(offset) {
        this.checkIndex(this.index + offset);
    },
    /**
     * Check that the specifed index will not be too far.
     * @param {string} newIndex the index to check.
     * @throws {Error} an Error if the index is out of bounds.
     */
    checkIndex: function(newIndex) {
        if (this.length < newIndex || newIndex < 0) {
            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
        }
    },
    /**
     * Change the index.
     * @param {number} newIndex The new index.
     * @throws {Error} if the new index is out of the data.
     */
    setIndex: function(newIndex) {
        this.checkIndex(newIndex);
        this.index = newIndex;
    },
    /**
     * Skip the next n bytes.
     * @param {number} n the number of bytes to skip.
     * @throws {Error} if the new index is out of the data.
     */
    skip: function(n) {
        this.setIndex(this.index + n);
    },
    /**
     * Get the byte at the specified index.
     * @param {number} i the index to use.
     * @return {number} a byte.
     */
    byteAt: function(i) {
        // see implementations
    },
    /**
     * Get the next number with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {number} the corresponding number.
     */
    readInt: function(size) {
        var result = 0,
            i;
        this.checkOffset(size);
        for (i = this.index + size - 1; i >= this.index; i--) {
            result = (result << 8) + this.byteAt(i);
        }
        this.index += size;
        return result;
    },
    /**
     * Get the next string with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {string} the corresponding string.
     */
    readString: function(size) {
        return utils.transformTo("string", this.readData(size));
    },
    /**
     * Get raw data without conversion, <size> bytes.
     * @param {number} size the number of bytes to read.
     * @return {Object} the raw data, implementation specific.
     */
    readData: function(size) {
        // see implementations
    },
    /**
     * Find the last occurence of a zip signature (4 bytes).
     * @param {string} sig the signature to find.
     * @return {number} the index of the last occurence, -1 if not found.
     */
    lastIndexOfSignature: function(sig) {
        // see implementations
    },
    /**
     * Get the next date.
     * @return {Date} the date.
     */
    readDate: function() {
        var dostime = this.readInt(4);
        return new Date(
        ((dostime >> 25) & 0x7f) + 1980, // year
        ((dostime >> 21) & 0x0f) - 1, // month
        (dostime >> 16) & 0x1f, // day
        (dostime >> 11) & 0x1f, // hour
        (dostime >> 5) & 0x3f, // minute
        (dostime & 0x1f) << 1); // second
    }
};
module.exports = DataReader;

},{"./utils":21}],6:[function(_dereq_,module,exports){
'use strict';
exports.base64 = false;
exports.binary = false;
exports.dir = false;
exports.createFolders = false;
exports.date = null;
exports.compression = null;
exports.comment = null;

},{}],7:[function(_dereq_,module,exports){
'use strict';
var utils = _dereq_('./utils');

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.string2binary = function(str) {
    return utils.string2binary(str);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.string2Uint8Array = function(str) {
    return utils.transformTo("uint8array", str);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.uint8Array2String = function(array) {
    return utils.transformTo("string", array);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.string2Blob = function(str) {
    var buffer = utils.transformTo("arraybuffer", str);
    return utils.arrayBuffer2Blob(buffer);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.arrayBuffer2Blob = function(buffer) {
    return utils.arrayBuffer2Blob(buffer);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.transformTo = function(outputType, input) {
    return utils.transformTo(outputType, input);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.getTypeOf = function(input) {
    return utils.getTypeOf(input);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.checkSupport = function(type) {
    return utils.checkSupport(type);
};

/**
 * @deprecated
 * This value will be removed in a future version without replacement.
 */
exports.MAX_VALUE_16BITS = utils.MAX_VALUE_16BITS;

/**
 * @deprecated
 * This value will be removed in a future version without replacement.
 */
exports.MAX_VALUE_32BITS = utils.MAX_VALUE_32BITS;


/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.pretty = function(str) {
    return utils.pretty(str);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.findCompression = function(compressionMethod) {
    return utils.findCompression(compressionMethod);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.isRegExp = function (object) {
    return utils.isRegExp(object);
};


},{"./utils":21}],8:[function(_dereq_,module,exports){
'use strict';
var USE_TYPEDARRAY = (typeof Uint8Array !== 'undefined') && (typeof Uint16Array !== 'undefined') && (typeof Uint32Array !== 'undefined');

var pako = _dereq_("pako");
exports.uncompressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
exports.compressInputType = USE_TYPEDARRAY ? "uint8array" : "array";

exports.magic = "\x08\x00";
exports.compress = function(input) {
    return pako.deflateRaw(input);
};
exports.uncompress =  function(input) {
    return pako.inflateRaw(input);
};

},{"pako":24}],9:[function(_dereq_,module,exports){
'use strict';

var base64 = _dereq_('./base64');

/**
Usage:
   zip = new JSZip();
   zip.file("hello.txt", "Hello, World!").file("tempfile", "nothing");
   zip.folder("images").file("smile.gif", base64Data, {base64: true});
   zip.file("Xmas.txt", "Ho ho ho !", {date : new Date("December 25, 2007 00:00:01")});
   zip.remove("tempfile");

   base64zip = zip.generate();

**/

/**
 * Representation a of zip file in js
 * @constructor
 * @param {String=|ArrayBuffer=|Uint8Array=} data the data to load, if any (optional).
 * @param {Object=} options the options for creating this objects (optional).
 */
function JSZipSync(data, options) {
    // if this constructor is used without `new`, it adds `new` before itself:
    if(!(this instanceof JSZipSync)) return new JSZipSync(data, options);

    // object containing the files :
    // {
    //   "folder/" : {...},
    //   "folder/data.txt" : {...}
    // }
    this.files = {};

    this.comment = null;

    // Where we are in the hierarchy
    this.root = "";
    if (data) {
        this.load(data, options);
    }
    this.clone = function() {
        var newObj = new JSZipSync();
        for (var i in this) {
            if (typeof this[i] !== "function") {
                newObj[i] = this[i];
            }
        }
        return newObj;
    };
}
JSZipSync.prototype = _dereq_('./object');
JSZipSync.prototype.load = _dereq_('./load');
JSZipSync.support = _dereq_('./support');
JSZipSync.defaults = _dereq_('./defaults');

/**
 * @deprecated
 * This namespace will be removed in a future version without replacement.
 */
JSZipSync.utils = _dereq_('./deprecatedPublicUtils');

JSZipSync.base64 = {
    /**
     * @deprecated
     * This method will be removed in a future version without replacement.
     */
    encode : function(input) {
        return base64.encode(input);
    },
    /**
     * @deprecated
     * This method will be removed in a future version without replacement.
     */
    decode : function(input) {
        return base64.decode(input);
    }
};
JSZipSync.compressions = _dereq_('./compressions');
module.exports = JSZipSync;

},{"./base64":1,"./compressions":3,"./defaults":6,"./deprecatedPublicUtils":7,"./load":10,"./object":13,"./support":17}],10:[function(_dereq_,module,exports){
'use strict';
var base64 = _dereq_('./base64');
var ZipEntries = _dereq_('./zipEntries');
module.exports = function(data, options) {
    var files, zipEntries, i, input;
    options = options || {};
    if (options.base64) {
        data = base64.decode(data);
    }

    zipEntries = new ZipEntries(data, options);
    files = zipEntries.files;
    for (i = 0; i < files.length; i++) {
        input = files[i];
        this.file(input.fileName, input.decompressed, {
            binary: true,
            optimizedBinaryString: true,
            date: input.date,
            dir: input.dir,
            comment : input.fileComment.length ? input.fileComment : null,
            createFolders: options.createFolders
        });
    }
    if (zipEntries.zipComment.length) {
        this.comment = zipEntries.zipComment;
    }

    return this;
};

},{"./base64":1,"./zipEntries":22}],11:[function(_dereq_,module,exports){
(function (Buffer){
'use strict';
var Buffer_from = /*::(*/function(){}/*:: :any)*/;
if(typeof Buffer !== 'undefined') {
	var nbfs = !Buffer.from;
	if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
	Buffer_from = nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
	// $FlowIgnore
	if(!Buffer.alloc) Buffer.alloc = function(n) { return new Buffer(n); };
}
module.exports = function(data, encoding){
    return typeof data == 'number' ? Buffer.alloc(data) : Buffer_from(data, encoding);
};
module.exports.test = function(b){
    return Buffer.isBuffer(b);
};
}).call(this,(typeof Buffer !== "undefined" ? Buffer : undefined))
},{}],12:[function(_dereq_,module,exports){
'use strict';
var Uint8ArrayReader = _dereq_('./uint8ArrayReader');

function NodeBufferReader(data) {
    this.data = data;
    this.length = this.data.length;
    this.index = 0;
}
NodeBufferReader.prototype = new Uint8ArrayReader();

/**
 * @see DataReader.readData
 */
NodeBufferReader.prototype.readData = function(size) {
    this.checkOffset(size);
    var result = this.data.slice(this.index, this.index + size);
    this.index += size;
    return result;
};
module.exports = NodeBufferReader;

},{"./uint8ArrayReader":18}],13:[function(_dereq_,module,exports){
'use strict';
var support = _dereq_('./support');
var utils = _dereq_('./utils');
var crc32 = _dereq_('./crc32');
var signature = _dereq_('./signature');
var defaults = _dereq_('./defaults');
var base64 = _dereq_('./base64');
var compressions = _dereq_('./compressions');
var CompressedObject = _dereq_('./compressedObject');
var nodeBuffer = _dereq_('./nodeBuffer');
var utf8 = _dereq_('./utf8');
var StringWriter = _dereq_('./stringWriter');
var Uint8ArrayWriter = _dereq_('./uint8ArrayWriter');

/**
 * Returns the raw data of a ZipObject, decompress the content if necessary.
 * @param {ZipObject} file the file to use.
 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
 */
var getRawData = function(file) {
    if (file._data instanceof CompressedObject) {
        file._data = file._data.getContent();
        file.options.binary = true;
        file.options.base64 = false;

        if (utils.getTypeOf(file._data) === "uint8array") {
            var copy = file._data;
            // when reading an arraybuffer, the CompressedObject mechanism will keep it and subarray() a Uint8Array.
            // if we request a file in the same format, we might get the same Uint8Array or its ArrayBuffer (the original zip file).
            file._data = new Uint8Array(copy.length);
            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
            if (copy.length !== 0) {
                file._data.set(copy, 0);
            }
        }
    }
    return file._data;
};

/**
 * Returns the data of a ZipObject in a binary form. If the content is an unicode string, encode it.
 * @param {ZipObject} file the file to use.
 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
 */
var getBinaryData = function(file) {
    var result = getRawData(file),
        type = utils.getTypeOf(result);
    if (type === "string") {
        if (!file.options.binary) {
            // unicode text !
            // unicode string => binary string is a painful process, check if we can avoid it.
            if (support.nodebuffer) {
                return nodeBuffer(result, "utf-8");
            }
        }
        return file.asBinary();
    }
    return result;
};

/**
 * Transform this._data into a string.
 * @param {function} filter a function String -> String, applied if not null on the result.
 * @return {String} the string representing this._data.
 */
var dataToString = function(asUTF8) {
    var result = getRawData(this);
    if (result === null || typeof result === "undefined") {
        return "";
    }
    // if the data is a base64 string, we decode it before checking the encoding !
    if (this.options.base64) {
        result = base64.decode(result);
    }
    if (asUTF8 && this.options.binary) {
        // JSZip.prototype.utf8decode supports arrays as input
        // skip to array => string step, utf8decode will do it.
        result = out.utf8decode(result);
    }
    else {
        // no utf8 transformation, do the array => string step.
        result = utils.transformTo("string", result);
    }

    if (!asUTF8 && !this.options.binary) {
        result = utils.transformTo("string", out.utf8encode(result));
    }
    return result;
};
/**
 * A simple object representing a file in the zip file.
 * @constructor
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
 * @param {Object} options the options of the file
 */
var ZipObject = function(name, data, options) {
    this.name = name;
    this.dir = options.dir;
    this.date = options.date;
    this.comment = options.comment;

    this._data = data;
    this.options = options;

    /*
     * This object contains initial values for dir and date.
     * With them, we can check if the user changed the deprecated metadata in
     * `ZipObject#options` or not.
     */
    this._initialMetadata = {
      dir : options.dir,
      date : options.date
    };
};

ZipObject.prototype = {
    /**
     * Return the content as UTF8 string.
     * @return {string} the UTF8 string.
     */
    asText: function() {
        return dataToString.call(this, true);
    },
    /**
     * Returns the binary content.
     * @return {string} the content as binary.
     */
    asBinary: function() {
        return dataToString.call(this, false);
    },
    /**
     * Returns the content as a nodejs Buffer.
     * @return {Buffer} the content as a Buffer.
     */
    asNodeBuffer: function() {
        var result = getBinaryData(this);
        return utils.transformTo("nodebuffer", result);
    },
    /**
     * Returns the content as an Uint8Array.
     * @return {Uint8Array} the content as an Uint8Array.
     */
    asUint8Array: function() {
        var result = getBinaryData(this);
        return utils.transformTo("uint8array", result);
    },
    /**
     * Returns the content as an ArrayBuffer.
     * @return {ArrayBuffer} the content as an ArrayBufer.
     */
    asArrayBuffer: function() {
        return this.asUint8Array().buffer;
    }
};

/**
 * Transform an integer into a string in hexadecimal.
 * @private
 * @param {number} dec the number to convert.
 * @param {number} bytes the number of bytes to generate.
 * @returns {string} the result.
 */
var decToHex = function(dec, bytes) {
    var hex = "",
        i;
    for (i = 0; i < bytes; i++) {
        hex += String.fromCharCode(dec & 0xff);
        dec = dec >>> 8;
    }
    return hex;
};

/**
 * Merge the objects passed as parameters into a new one.
 * @private
 * @param {...Object} var_args All objects to merge.
 * @return {Object} a new object with the data of the others.
 */
var extend = function() {
    var result = {}, i, attr;
    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
        for (attr in arguments[i]) {
            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
                result[attr] = arguments[i][attr];
            }
        }
    }
    return result;
};

/**
 * Transforms the (incomplete) options from the user into the complete
 * set of options to create a file.
 * @private
 * @param {Object} o the options from the user.
 * @return {Object} the complete set of options.
 */
var prepareFileAttrs = function(o) {
    o = o || {};
    if (o.base64 === true && (o.binary === null || o.binary === undefined)) {
        o.binary = true;
    }
    o = extend(o, defaults);
    o.date = o.date || new Date();
    if (o.compression !== null) o.compression = o.compression.toUpperCase();

    return o;
};

/**
 * Add a file in the current folder.
 * @private
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
 * @param {Object} o the options of the file
 * @return {Object} the new file.
 */
var fileAdd = function(name, data, o) {
    // be sure sub folders exist
    var dataType = utils.getTypeOf(data),
        parent;

    o = prepareFileAttrs(o);

    if (o.createFolders && (parent = parentFolder(name))) {
        folderAdd.call(this, parent, true);
    }

    if (o.dir || data === null || typeof data === "undefined") {
        o.base64 = false;
        o.binary = false;
        data = null;
    }
    else if (dataType === "string") {
        if (o.binary && !o.base64) {
            // optimizedBinaryString == true means that the file has already been filtered with a 0xFF mask
            if (o.optimizedBinaryString !== true) {
                // this is a string, not in a base64 format.
                // Be sure that this is a correct "binary string"
                data = utils.string2binary(data);
            }
        }
    }
    else { // arraybuffer, uint8array, ...
        o.base64 = false;
        o.binary = true;

        if (!dataType && !(data instanceof CompressedObject)) {
            throw new Error("The data of '" + name + "' is in an unsupported format !");
        }

        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
        if (dataType === "arraybuffer") {
            data = utils.transformTo("uint8array", data);
        }
    }

    var object = new ZipObject(name, data, o);
    this.files[name] = object;
    return object;
};

/**
 * Find the parent folder of the path.
 * @private
 * @param {string} path the path to use
 * @return {string} the parent folder, or ""
 */
var parentFolder = function (path) {
    if (path.slice(-1) == '/') {
        path = path.substring(0, path.length - 1);
    }
    var lastSlash = path.lastIndexOf('/');
    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
};

/**
 * Add a (sub) folder in the current folder.
 * @private
 * @param {string} name the folder's name
 * @param {boolean=} [createFolders] If true, automatically create sub
 *  folders. Defaults to false.
 * @return {Object} the new folder.
 */
var folderAdd = function(name, createFolders) {
    // Check the name ends with a /
    if (name.slice(-1) != "/") {
        name += "/"; // IE doesn't like substr(-1)
    }

    createFolders = (typeof createFolders !== 'undefined') ? createFolders : false;

    // Does this folder already exist?
    if (!this.files[name]) {
        fileAdd.call(this, name, null, {
            dir: true,
            createFolders: createFolders
        });
    }
    return this.files[name];
};

/**
 * Generate a JSZip.CompressedObject for a given zipOject.
 * @param {ZipObject} file the object to read.
 * @param {JSZip.compression} compression the compression to use.
 * @return {JSZip.CompressedObject} the compressed result.
 */
var generateCompressedObjectFrom = function(file, compression) {
    var result = new CompressedObject(),
        content;

    // the data has not been decompressed, we might reuse things !
    if (file._data instanceof CompressedObject) {
        result.uncompressedSize = file._data.uncompressedSize;
        result.crc32 = file._data.crc32;

        if (result.uncompressedSize === 0 || file.dir) {
            compression = compressions['STORE'];
            result.compressedContent = "";
            result.crc32 = 0;
        }
        else if (file._data.compressionMethod === compression.magic) {
            result.compressedContent = file._data.getCompressedContent();
        }
        else {
            content = file._data.getContent();
            // need to decompress / recompress
            result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
        }
    }
    else {
        // have uncompressed data
        content = getBinaryData(file);
        if (!content || content.length === 0 || file.dir) {
            compression = compressions['STORE'];
            content = "";
        }
        result.uncompressedSize = content.length;
        result.crc32 = crc32(content);
        result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
    }

    result.compressedSize = result.compressedContent.length;
    result.compressionMethod = compression.magic;

    return result;
};

/**
 * Generate the various parts used in the construction of the final zip file.
 * @param {string} name the file name.
 * @param {ZipObject} file the file content.
 * @param {JSZip.CompressedObject} compressedObject the compressed object.
 * @param {number} offset the current offset from the start of the zip file.
 * @return {object} the zip parts.
 */
var generateZipParts = function(name, file, compressedObject, offset) {
    var data = compressedObject.compressedContent,
        utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
        comment = file.comment || "",
        utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
        useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
        useUTF8ForComment = utfEncodedComment.length !== comment.length,
        o = file.options,
        dosTime,
        dosDate,
        extraFields = "",
        unicodePathExtraField = "",
        unicodeCommentExtraField = "",
        dir, date;


    // handle the deprecated options.dir
    if (file._initialMetadata.dir !== file.dir) {
        dir = file.dir;
    } else {
        dir = o.dir;
    }

    // handle the deprecated options.date
    if(file._initialMetadata.date !== file.date) {
        date = file.date;
    } else {
        date = o.date;
    }


    dosTime = date.getHours();
    dosTime = dosTime << 6;
    dosTime = dosTime | date.getMinutes();
    dosTime = dosTime << 5;
    dosTime = dosTime | date.getSeconds() / 2;

    dosDate = date.getFullYear() - 1980;
    dosDate = dosDate << 4;
    dosDate = dosDate | (date.getMonth() + 1);
    dosDate = dosDate << 5;
    dosDate = dosDate | date.getDate();

    if (useUTF8ForFileName) {
        // set the unicode path extra field. unzip needs at least one extra
        // field to correctly handle unicode path, so using the path is as good
        // as any other information. This could improve the situation with
        // other archive managers too.
        // This field is usually used without the utf8 flag, with a non
        // unicode path in the header (winrar, winzip). This helps (a bit)
        // with the messy Windows' default compressed folders feature but
        // breaks on p7zip which doesn't seek the unicode path extra field.
        // So for now, UTF-8 everywhere !
        unicodePathExtraField =
            // Version
            decToHex(1, 1) +
            // NameCRC32
            decToHex(crc32(utfEncodedFileName), 4) +
            // UnicodeName
            utfEncodedFileName;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x70" +
            // size
            decToHex(unicodePathExtraField.length, 2) +
            // content
            unicodePathExtraField;
    }

    if(useUTF8ForComment) {

        unicodeCommentExtraField =
            // Version
            decToHex(1, 1) +
            // CommentCRC32
            decToHex(this.crc32(utfEncodedComment), 4) +
            // UnicodeName
            utfEncodedComment;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x63" +
            // size
            decToHex(unicodeCommentExtraField.length, 2) +
            // content
            unicodeCommentExtraField;
    }

    var header = "";

    // version needed to extract
    header += "\x0A\x00";
    // general purpose bit flag
    // set bit 11 if utf8
    header += (useUTF8ForFileName || useUTF8ForComment) ? "\x00\x08" : "\x00\x00";
    // compression method
    header += compressedObject.compressionMethod;
    // last mod file time
    header += decToHex(dosTime, 2);
    // last mod file date
    header += decToHex(dosDate, 2);
    // crc-32
    header += decToHex(compressedObject.crc32, 4);
    // compressed size
    header += decToHex(compressedObject.compressedSize, 4);
    // uncompressed size
    header += decToHex(compressedObject.uncompressedSize, 4);
    // file name length
    header += decToHex(utfEncodedFileName.length, 2);
    // extra field length
    header += decToHex(extraFields.length, 2);


    var fileRecord = signature.LOCAL_FILE_HEADER + header + utfEncodedFileName + extraFields;

    var dirRecord = signature.CENTRAL_FILE_HEADER +
    // version made by (00: DOS)
    "\x14\x00" +
    // file header (common to file and central directory)
    header +
    // file comment length
    decToHex(utfEncodedComment.length, 2) +
    // disk number start
    "\x00\x00" +
    // internal file attributes TODO
    "\x00\x00" +
    // external file attributes
    (dir === true ? "\x10\x00\x00\x00" : "\x00\x00\x00\x00") +
    // relative offset of local header
    decToHex(offset, 4) +
    // file name
    utfEncodedFileName +
    // extra field
    extraFields +
    // file comment
    utfEncodedComment;

    return {
        fileRecord: fileRecord,
        dirRecord: dirRecord,
        compressedObject: compressedObject
    };
};


// return the actual prototype of JSZip
var out = {
    /**
     * Read an existing zip and merge the data in the current JSZip object.
     * The implementation is in jszip-load.js, don't forget to include it.
     * @param {String|ArrayBuffer|Uint8Array|Buffer} stream  The stream to load
     * @param {Object} options Options for loading the stream.
     *  options.base64 : is the stream in base64 ? default : false
     * @return {JSZip} the current JSZip object
     */
    load: function(stream, options) {
        throw new Error("Load method is not defined. Is the file jszip-load.js included ?");
    },

    /**
     * Filter nested files/folders with the specified function.
     * @param {Function} search the predicate to use :
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     * @return {Array} An array of matching elements.
     */
    filter: function(search) {
        var result = [],
            filename, relativePath, file, fileClone;
        for (filename in this.files) {
            if (!this.files.hasOwnProperty(filename)) {
                continue;
            }
            file = this.files[filename];
            // return a new object, don't let the user mess with our internal objects :)
            fileClone = new ZipObject(file.name, file._data, extend(file.options));
            relativePath = filename.slice(this.root.length, filename.length);
            if (filename.slice(0, this.root.length) === this.root && // the file is in the current root
            search(relativePath, fileClone)) { // and the file matches the function
                result.push(fileClone);
            }
        }
        return result;
    },

    /**
     * Add a file to the zip file, or search a file.
     * @param   {string|RegExp} name The name of the file to add (if data is defined),
     * the name of the file to find (if no data) or a regex to match files.
     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
     * @param   {Object} o     File options
     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
     * a file (when searching by string) or an array of files (when searching by regex).
     */
    file: function(name, data, o) {
        if (arguments.length === 1) {
            if (utils.isRegExp(name)) {
                var regexp = name;
                return this.filter(function(relativePath, file) {
                    return !file.dir && regexp.test(relativePath);
                });
            }
            else { // text
                return this.filter(function(relativePath, file) {
                    return !file.dir && relativePath === name;
                })[0] || null;
            }
        }
        else { // more than one argument : we have data !
            name = this.root + name;
            fileAdd.call(this, name, data, o);
        }
        return this;
    },

    /**
     * Add a directory to the zip file, or search.
     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
     */
    folder: function(arg) {
        if (!arg) {
            return this;
        }

        if (utils.isRegExp(arg)) {
            return this.filter(function(relativePath, file) {
                return file.dir && arg.test(relativePath);
            });
        }

        // else, name is a new folder
        var name = this.root + arg;
        var newFolder = folderAdd.call(this, name);

        // Allow chaining by returning a new object with this folder as the root
        var ret = this.clone();
        ret.root = newFolder.name;
        return ret;
    },

    /**
     * Delete a file, or a directory and all sub-files, from the zip
     * @param {string} name the name of the file to delete
     * @return {JSZip} this JSZip object
     */
    remove: function(name) {
        name = this.root + name;
        var file = this.files[name];
        if (!file) {
            // Look for any folders
            if (name.slice(-1) != "/") {
                name += "/";
            }
            file = this.files[name];
        }

        if (file && !file.dir) {
            // file
            delete this.files[name];
        } else {
            // maybe a folder, delete recursively
            var kids = this.filter(function(relativePath, file) {
                return file.name.slice(0, name.length) === name;
            });
            for (var i = 0; i < kids.length; i++) {
                delete this.files[kids[i].name];
            }
        }

        return this;
    },

    /**
     * Generate the complete zip file
     * @param {Object} options the options to generate the zip file :
     * - base64, (deprecated, use type instead) true to generate base64.
     * - compression, "STORE" by default.
     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
     */
    generate: function(options) {
        options = extend(options || {}, {
            base64: true,
            compression: "STORE",
            type: "base64",
            comment: null
        });

        utils.checkSupport(options.type);

        var zipData = [],
            localDirLength = 0,
            centralDirLength = 0,
            writer, i,
            utfEncodedComment = utils.transformTo("string", this.utf8encode(options.comment || this.comment || ""));

        // first, generate all the zip parts.
        for (var name in this.files) {
            if (!this.files.hasOwnProperty(name)) {
                continue;
            }
            var file = this.files[name];

            var compressionName = file.options.compression || options.compression.toUpperCase();
            var compression = compressions[compressionName];
            if (!compression) {
                throw new Error(compressionName + " is not a valid compression method !");
            }

            var compressedObject = generateCompressedObjectFrom.call(this, file, compression);

            var zipPart = generateZipParts.call(this, name, file, compressedObject, localDirLength);
            localDirLength += zipPart.fileRecord.length + compressedObject.compressedSize;
            centralDirLength += zipPart.dirRecord.length;
            zipData.push(zipPart);
        }

        var dirEnd = "";

        // end of central dir signature
        dirEnd = signature.CENTRAL_DIRECTORY_END +
        // number of this disk
        "\x00\x00" +
        // number of the disk with the start of the central directory
        "\x00\x00" +
        // total number of entries in the central directory on this disk
        decToHex(zipData.length, 2) +
        // total number of entries in the central directory
        decToHex(zipData.length, 2) +
        // size of the central directory   4 bytes
        decToHex(centralDirLength, 4) +
        // offset of start of central directory with respect to the starting disk number
        decToHex(localDirLength, 4) +
        // .ZIP file comment length
        decToHex(utfEncodedComment.length, 2) +
        // .ZIP file comment
        utfEncodedComment;


        // we have all the parts (and the total length)
        // time to create a writer !
        var typeName = options.type.toLowerCase();
        if(typeName==="uint8array"||typeName==="arraybuffer"||typeName==="blob"||typeName==="nodebuffer") {
            writer = new Uint8ArrayWriter(localDirLength + centralDirLength + dirEnd.length);
        }else{
            writer = new StringWriter(localDirLength + centralDirLength + dirEnd.length);
        }

        for (i = 0; i < zipData.length; i++) {
            writer.append(zipData[i].fileRecord);
            writer.append(zipData[i].compressedObject.compressedContent);
        }
        for (i = 0; i < zipData.length; i++) {
            writer.append(zipData[i].dirRecord);
        }

        writer.append(dirEnd);

        var zip = writer.finalize();



        switch(options.type.toLowerCase()) {
            // case "zip is an Uint8Array"
            case "uint8array" :
            case "arraybuffer" :
            case "nodebuffer" :
               return utils.transformTo(options.type.toLowerCase(), zip);
            case "blob" :
               return utils.arrayBuffer2Blob(utils.transformTo("arraybuffer", zip));
            // case "zip is a string"
            case "base64" :
               return (options.base64) ? base64.encode(zip) : zip;
            default : // case "string" :
               return zip;
         }

    },

    /**
     * @deprecated
     * This method will be removed in a future version without replacement.
     */
    crc32: function (input, crc) {
        return crc32(input, crc);
    },

    /**
     * @deprecated
     * This method will be removed in a future version without replacement.
     */
    utf8encode: function (string) {
        return utils.transformTo("string", utf8.utf8encode(string));
    },

    /**
     * @deprecated
     * This method will be removed in a future version without replacement.
     */
    utf8decode: function (input) {
        return utf8.utf8decode(input);
    }
};
module.exports = out;

},{"./base64":1,"./compressedObject":2,"./compressions":3,"./crc32":4,"./defaults":6,"./nodeBuffer":11,"./signature":14,"./stringWriter":16,"./support":17,"./uint8ArrayWriter":19,"./utf8":20,"./utils":21}],14:[function(_dereq_,module,exports){
'use strict';
exports.LOCAL_FILE_HEADER = "PK\x03\x04";
exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
exports.DATA_DESCRIPTOR = "PK\x07\x08";

},{}],15:[function(_dereq_,module,exports){
'use strict';
var DataReader = _dereq_('./dataReader');
var utils = _dereq_('./utils');

function StringReader(data, optimizedBinaryString) {
    this.data = data;
    if (!optimizedBinaryString) {
        this.data = utils.string2binary(this.data);
    }
    this.length = this.data.length;
    this.index = 0;
}
StringReader.prototype = new DataReader();
/**
 * @see DataReader.byteAt
 */
StringReader.prototype.byteAt = function(i) {
    return this.data.charCodeAt(i);
};
/**
 * @see DataReader.lastIndexOfSignature
 */
StringReader.prototype.lastIndexOfSignature = function(sig) {
    return this.data.lastIndexOf(sig);
};
/**
 * @see DataReader.readData
 */
StringReader.prototype.readData = function(size) {
    this.checkOffset(size);
    // this will work because the constructor applied the "& 0xff" mask.
    var result = this.data.slice(this.index, this.index + size);
    this.index += size;
    return result;
};
module.exports = StringReader;

},{"./dataReader":5,"./utils":21}],16:[function(_dereq_,module,exports){
'use strict';

var utils = _dereq_('./utils');

/**
 * An object to write any content to a string.
 * @constructor
 */
var StringWriter = function() {
    this.data = [];
};
StringWriter.prototype = {
    /**
     * Append any content to the current string.
     * @param {Object} input the content to add.
     */
    append: function(input) {
        input = utils.transformTo("string", input);
        this.data.push(input);
    },
    /**
     * Finalize the construction an return the result.
     * @return {string} the generated string.
     */
    finalize: function() {
        return this.data.join("");
    }
};

module.exports = StringWriter;

},{"./utils":21}],17:[function(_dereq_,module,exports){
(function (Buffer){
'use strict';
exports.base64 = true;
exports.array = true;
exports.string = true;
exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
// contains true if JSZip can read/generate nodejs Buffer, false otherwise.
// Browserify will provide a Buffer implementation for browsers, which is
// an augmented Uint8Array (i.e., can be used as either Buffer or U8).
exports.nodebuffer = typeof Buffer !== "undefined";
// contains true if JSZip can read/generate Uint8Array, false otherwise.
exports.uint8array = typeof Uint8Array !== "undefined";

if (typeof ArrayBuffer === "undefined") {
    exports.blob = false;
}
else {
    var buffer = new ArrayBuffer(0);
    try {
        exports.blob = new Blob([buffer], {
            type: "application/zip"
        }).size === 0;
    }
    catch (e) {
        try {
            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
            var builder = new Builder();
            builder.append(buffer);
            exports.blob = builder.getBlob('application/zip').size === 0;
        }
        catch (e) {
            exports.blob = false;
        }
    }
}

}).call(this,(typeof Buffer !== "undefined" ? Buffer : undefined))
},{}],18:[function(_dereq_,module,exports){
'use strict';
var DataReader = _dereq_('./dataReader');

function Uint8ArrayReader(data) {
    if (data) {
        this.data = data;
        this.length = this.data.length;
        this.index = 0;
    }
}
Uint8ArrayReader.prototype = new DataReader();
/**
 * @see DataReader.byteAt
 */
Uint8ArrayReader.prototype.byteAt = function(i) {
    return this.data[i];
};
/**
 * @see DataReader.lastIndexOfSignature
 */
Uint8ArrayReader.prototype.lastIndexOfSignature = function(sig) {
    var sig0 = sig.charCodeAt(0),
        sig1 = sig.charCodeAt(1),
        sig2 = sig.charCodeAt(2),
        sig3 = sig.charCodeAt(3);
    for (var i = this.length - 4; i >= 0; --i) {
        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
            return i;
        }
    }

    return -1;
};
/**
 * @see DataReader.readData
 */
Uint8ArrayReader.prototype.readData = function(size) {
    this.checkOffset(size);
    if(size === 0) {
        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
        return new Uint8Array(0);
    }
    var result = this.data.subarray(this.index, this.index + size);
    this.index += size;
    return result;
};
module.exports = Uint8ArrayReader;

},{"./dataReader":5}],19:[function(_dereq_,module,exports){
'use strict';

var utils = _dereq_('./utils');

/**
 * An object to write any content to an Uint8Array.
 * @constructor
 * @param {number} length The length of the array.
 */
var Uint8ArrayWriter = function(length) {
    this.data = new Uint8Array(length);
    this.index = 0;
};
Uint8ArrayWriter.prototype = {
    /**
     * Append any content to the current array.
     * @param {Object} input the content to add.
     */
    append: function(input) {
        if (input.length !== 0) {
            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
            input = utils.transformTo("uint8array", input);
            this.data.set(input, this.index);
            this.index += input.length;
        }
    },
    /**
     * Finalize the construction an return the result.
     * @return {Uint8Array} the generated array.
     */
    finalize: function() {
        return this.data;
    }
};

module.exports = Uint8ArrayWriter;

},{"./utils":21}],20:[function(_dereq_,module,exports){
'use strict';

var utils = _dereq_('./utils');
var support = _dereq_('./support');
var nodeBuffer = _dereq_('./nodeBuffer');

/**
 * The following functions come from pako, from pako/lib/utils/strings
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */

// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new Array(256);
for (var i=0; i<256; i++) {
  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
}
_utf8len[254]=_utf8len[254]=1; // Invalid sequence start

// convert string to array (typed, when possible)
var string2buf = function (str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

    // count binary size
    for (m_pos = 0; m_pos < str_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if (((c & 0xfc00) === 0xd800) && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += (c < 0x80) ? 1 : ((c < 0x800) ? 2 : ((c < 0x10000) ? 3 : 4));
    }

    // allocate buffer
    if (support.uint8array) {
        buf = new Uint8Array(buf_len);
    } else {
        buf = new Array(buf_len);
    }

    // convert
    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) {
            /* one byte */
            buf[i++] = c;
        } else if (c < 0x800) {
            /* two bytes */
            buf[i++] = 0xC0 | (c >>> 6);
            buf[i++] = 0x80 | (c & 0x3f);
        } else if (c < 0x10000) {
            /* three bytes */
            buf[i++] = 0xE0 | (c >>> 12);
            buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        } else {
            /* four bytes */
            buf[i++] = 0xf0 | (c >>> 18);
            buf[i++] = 0x80 | ((c >>> 12) & 0x3f);
            buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        }
    }

    return buf;
};

// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var utf8border = function(buf, max) {
    var pos;

    max = max || buf.length;
    if (max > buf.length) { max = buf.length; }

    // go back from last position, until start of sequence found
    pos = max-1;
    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

    // Fuckup - very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) { return max; }

    // If we came to start of buffer - that means vuffer is too small,
    // return max too.
    if (pos === 0) { return max; }

    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

// convert array to string
var buf2string = function (buf) {
    var str, i, out, c, c_len;
    var len = buf.length;

    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len*2);

    for (out=0, i=0; i<len;) {
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) { utf16buf[out++] = c; continue; }

        c_len = _utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }

        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while (c_len > 1 && i < len) {
            c = (c << 6) | (buf[i++] & 0x3f);
            c_len--;
        }

        // terminated by end of string?
        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

        if (c < 0x10000) {
            utf16buf[out++] = c;
        } else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
        }
    }

    // shrinkBuf(utf16buf, out)
    if (utf16buf.length !== out) {
        if(utf16buf.subarray) {
            utf16buf = utf16buf.subarray(0, out);
        } else {
            utf16buf.length = out;
        }
    }

    // return String.fromCharCode.apply(null, utf16buf);
    return utils.applyFromCharCode(utf16buf);
};


// That's all for the pako functions.


/**
 * Transform a javascript string into an array (typed if possible) of bytes,
 * UTF-8 encoded.
 * @param {String} str the string to encode
 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
 */
exports.utf8encode = function utf8encode(str) {
    if (support.nodebuffer) {
        return nodeBuffer(str, "utf-8");
    }

    return string2buf(str);
};


/**
 * Transform a bytes array (or a representation) representing an UTF-8 encoded
 * string into a javascript string.
 * @param {Array|Uint8Array|Buffer} buf the data de decode
 * @return {String} the decoded string.
 */
exports.utf8decode = function utf8decode(buf) {
    if (support.nodebuffer) {
        return utils.transformTo("nodebuffer", buf).toString("utf-8");
    }

    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);

    // return buf2string(buf);
    // Chrome prefers to work with "small" chunks of data
    // for the method buf2string.
    // Firefox and Chrome has their own shortcut, IE doesn't seem to really care.
    var result = [], k = 0, len = buf.length, chunk = 65536;
    while (k < len) {
        var nextBoundary = utf8border(buf, Math.min(k + chunk, len));
        if (support.uint8array) {
            result.push(buf2string(buf.subarray(k, nextBoundary)));
        } else {
            result.push(buf2string(buf.slice(k, nextBoundary)));
        }
        k = nextBoundary;
    }
    return result.join("");

};
// vim: set shiftwidth=4 softtabstop=4:

},{"./nodeBuffer":11,"./support":17,"./utils":21}],21:[function(_dereq_,module,exports){
'use strict';
var support = _dereq_('./support');
var compressions = _dereq_('./compressions');
var nodeBuffer = _dereq_('./nodeBuffer');
/**
 * Convert a string to a "binary string" : a string containing only char codes between 0 and 255.
 * @param {string} str the string to transform.
 * @return {String} the binary string.
 */
exports.string2binary = function(str) {
    var result = "";
    for (var i = 0; i < str.length; i++) {
        result += String.fromCharCode(str.charCodeAt(i) & 0xff);
    }
    return result;
};
exports.arrayBuffer2Blob = function(buffer) {
    exports.checkSupport("blob");

    try {
        // Blob constructor
        return new Blob([buffer], {
            type: "application/zip"
        });
    }
    catch (e) {

        try {
            // deprecated, browser only, old way
            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
            var builder = new Builder();
            builder.append(buffer);
            return builder.getBlob('application/zip');
        }
        catch (e) {

            // well, fuck ?!
            throw new Error("Bug : can't construct the Blob.");
        }
    }


};
/**
 * The identity function.
 * @param {Object} input the input.
 * @return {Object} the same input.
 */
function identity(input) {
    return input;
}

/**
 * Fill in an array with a string.
 * @param {String} str the string to use.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
 */
function stringToArrayLike(str, array) {
    for (var i = 0; i < str.length; ++i) {
        array[i] = str.charCodeAt(i) & 0xFF;
    }
    return array;
}

/**
 * Transform an array-like object to a string.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
 * @return {String} the result.
 */
function arrayLikeToString(array) {
    // Performances notes :
    // --------------------
    // String.fromCharCode.apply(null, array) is the fastest, see
    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
    // but the stack is limited (and we can get huge arrays !).
    //
    // result += String.fromCharCode(array[i]); generate too many strings !
    //
    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
    var chunk = 65536;
    var result = [],
        len = array.length,
        type = exports.getTypeOf(array),
        k = 0,
        canUseApply = true;
      try {
         switch(type) {
            case "uint8array":
               String.fromCharCode.apply(null, new Uint8Array(0));
               break;
            case "nodebuffer":
               String.fromCharCode.apply(null, nodeBuffer(0));
               break;
         }
      } catch(e) {
         canUseApply = false;
      }

      // no apply : slow and painful algorithm
      // default browser on android 4.*
      if (!canUseApply) {
         var resultStr = "";
         for(var i = 0; i < array.length;i++) {
            resultStr += String.fromCharCode(array[i]);
         }
    return resultStr;
    }
    while (k < len && chunk > 1) {
        try {
            if (type === "array" || type === "nodebuffer") {
                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
            }
            else {
                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
            }
            k += chunk;
        }
        catch (e) {
            chunk = Math.floor(chunk / 2);
        }
    }
    return result.join("");
}

exports.applyFromCharCode = arrayLikeToString;


/**
 * Copy the data from an array-like to an other array-like.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
 */
function arrayLikeToArrayLike(arrayFrom, arrayTo) {
    for (var i = 0; i < arrayFrom.length; i++) {
        arrayTo[i] = arrayFrom[i];
    }
    return arrayTo;
}

// a matrix containing functions to transform everything into everything.
var transform = {};

// string to ?
transform["string"] = {
    "string": identity,
    "array": function(input) {
        return stringToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["string"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return stringToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": function(input) {
        return stringToArrayLike(input, nodeBuffer(input.length));
    }
};

// array to ?
transform["array"] = {
    "string": arrayLikeToString,
    "array": identity,
    "arraybuffer": function(input) {
        return (new Uint8Array(input)).buffer;
    },
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodeBuffer(input);
    }
};

// arraybuffer to ?
transform["arraybuffer"] = {
    "string": function(input) {
        return arrayLikeToString(new Uint8Array(input));
    },
    "array": function(input) {
        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
    },
    "arraybuffer": identity,
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodeBuffer(new Uint8Array(input));
    }
};

// uint8array to ?
transform["uint8array"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return input.buffer;
    },
    "uint8array": identity,
    "nodebuffer": function(input) {
        return nodeBuffer(input);
    }
};

// nodebuffer to ?
transform["nodebuffer"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["nodebuffer"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": identity
};

/**
 * Transform an input into any type.
 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
 * If no output type is specified, the unmodified input will be returned.
 * @param {String} outputType the output type.
 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
 * @throws {Error} an Error if the browser doesn't support the requested output type.
 */
exports.transformTo = function(outputType, input) {
    if (!input) {
        // undefined, null, etc
        // an empty string won't harm.
        input = "";
    }
    if (!outputType) {
        return input;
    }
    exports.checkSupport(outputType);
    var inputType = exports.getTypeOf(input);
    var result = transform[inputType][outputType](input);
    return result;
};

/**
 * Return the type of the input.
 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
 * @param {Object} input the input to identify.
 * @return {String} the (lowercase) type of the input.
 */
exports.getTypeOf = function(input) {
    if (typeof input === "string") {
        return "string";
    }
    if (Object.prototype.toString.call(input) === "[object Array]") {
        return "array";
    }
    if (support.nodebuffer && nodeBuffer.test(input)) {
        return "nodebuffer";
    }
    if (support.uint8array && input instanceof Uint8Array) {
        return "uint8array";
    }
    if (support.arraybuffer && input instanceof ArrayBuffer) {
        return "arraybuffer";
    }
};

/**
 * Throw an exception if the type is not supported.
 * @param {String} type the type to check.
 * @throws {Error} an Error if the browser doesn't support the requested type.
 */
exports.checkSupport = function(type) {
    var supported = support[type.toLowerCase()];
    if (!supported) {
        throw new Error(type + " is not supported by this browser");
    }
};
exports.MAX_VALUE_16BITS = 65535;
exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1

/**
 * Prettify a string read as binary.
 * @param {string} str the string to prettify.
 * @return {string} a pretty string.
 */
exports.pretty = function(str) {
    var res = '',
        code, i;
    for (i = 0; i < (str || "").length; i++) {
        code = str.charCodeAt(i);
        res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
    }
    return res;
};

/**
 * Find a compression registered in JSZip.
 * @param {string} compressionMethod the method magic to find.
 * @return {Object|null} the JSZip compression object, null if none found.
 */
exports.findCompression = function(compressionMethod) {
    for (var method in compressions) {
        if (!compressions.hasOwnProperty(method)) {
            continue;
        }
        if (compressions[method].magic === compressionMethod) {
            return compressions[method];
        }
    }
    return null;
};
/**
* Cross-window, cross-Node-context regular expression detection
* @param  {Object}  object Anything
* @return {Boolean}        true if the object is a regular expression,
* false otherwise
*/
exports.isRegExp = function (object) {
    return Object.prototype.toString.call(object) === "[object RegExp]";
};


},{"./compressions":3,"./nodeBuffer":11,"./support":17}],22:[function(_dereq_,module,exports){
'use strict';
var StringReader = _dereq_('./stringReader');
var NodeBufferReader = _dereq_('./nodeBufferReader');
var Uint8ArrayReader = _dereq_('./uint8ArrayReader');
var utils = _dereq_('./utils');
var sig = _dereq_('./signature');
var ZipEntry = _dereq_('./zipEntry');
var support = _dereq_('./support');
var jszipProto = _dereq_('./object');
//  class ZipEntries {{{
/**
 * All the entries in the zip file.
 * @constructor
 * @param {String|ArrayBuffer|Uint8Array} data the binary stream to load.
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntries(data, loadOptions) {
    this.files = [];
    this.loadOptions = loadOptions;
    if (data) {
        this.load(data);
    }
}
ZipEntries.prototype = {
    /**
     * Check that the reader is on the speficied signature.
     * @param {string} expectedSignature the expected signature.
     * @throws {Error} if it is an other signature.
     */
    checkSignature: function(expectedSignature) {
        var signature = this.reader.readString(4);
        if (signature !== expectedSignature) {
            throw new Error("Corrupted zip or bug : unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
        }
    },
    /**
     * Read the end of the central directory.
     */
    readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2);
        this.diskWithCentralDirStart = this.reader.readInt(2);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
        this.centralDirRecords = this.reader.readInt(2);
        this.centralDirSize = this.reader.readInt(4);
        this.centralDirOffset = this.reader.readInt(4);

        this.zipCommentLength = this.reader.readInt(2);
        // warning : the encoding depends of the system locale
        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
        // On a windows machine, this field is encoded with the localized windows code page.
        this.zipComment = this.reader.readString(this.zipCommentLength);
        // To get consistent behavior with the generation part, we will assume that
        // this is utf8 encoded.
        this.zipComment = jszipProto.utf8decode(this.zipComment);
    },
    /**
     * Read the end of the Zip 64 central directory.
     * Not merged with the method readEndOfCentral :
     * The end of central can coexist with its Zip64 brother,
     * I don't want to read the wrong number of bytes !
     */
    readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8);
        this.versionMadeBy = this.reader.readString(2);
        this.versionNeeded = this.reader.readInt(2);
        this.diskNumber = this.reader.readInt(4);
        this.diskWithCentralDirStart = this.reader.readInt(4);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
        this.centralDirRecords = this.reader.readInt(8);
        this.centralDirSize = this.reader.readInt(8);
        this.centralDirOffset = this.reader.readInt(8);

        this.zip64ExtensibleData = {};
        var extraDataSize = this.zip64EndOfCentralSize - 44,
            index = 0,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;
        while (index < extraDataSize) {
            extraFieldId = this.reader.readInt(2);
            extraFieldLength = this.reader.readInt(4);
            extraFieldValue = this.reader.readString(extraFieldLength);
            this.zip64ExtensibleData[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Read the end of the Zip 64 central directory locator.
     */
    readBlockZip64EndOfCentralLocator: function() {
        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
        this.disksCount = this.reader.readInt(4);
        if (this.disksCount > 1) {
            throw new Error("Multi-volumes zip are not supported");
        }
    },
    /**
     * Read the local files, based on the offset read in the central part.
     */
    readLocalFiles: function() {
        var i, file;
        for (i = 0; i < this.files.length; i++) {
            file = this.files[i];
            this.reader.setIndex(file.localHeaderOffset);
            this.checkSignature(sig.LOCAL_FILE_HEADER);
            file.readLocalPart(this.reader);
            file.handleUTF8();
        }
    },
    /**
     * Read the central directory.
     */
    readCentralDir: function() {
        var file;

        this.reader.setIndex(this.centralDirOffset);
        while (this.reader.readString(4) === sig.CENTRAL_FILE_HEADER) {
            file = new ZipEntry({
                zip64: this.zip64
            }, this.loadOptions);
            file.readCentralPart(this.reader);
            this.files.push(file);
        }
    },
    /**
     * Read the end of central directory.
     */
    readEndOfCentral: function() {
        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
        if (offset === -1) {
            throw new Error("Corrupted zip : can't find end of central directory");
        }
        this.reader.setIndex(offset);
        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
        this.readBlockEndOfCentral();


        /* extract from the zip spec :
            4)  If one of the fields in the end of central directory
                record is too small to hold required data, the field
                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
                ZIP64 format record should be created.
            5)  The end of central directory record and the
                Zip64 end of central directory locator record must
                reside on the same disk when splitting or spanning
                an archive.
         */
        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
            this.zip64 = true;

            /*
            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
            the zip file can fit into a 32bits integer. This cannot be solved : Javascript represents
            all numbers as 64-bit double precision IEEE 754 floating point numbers.
            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
            */

            // should look for a zip64 EOCD locator
            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            if (offset === -1) {
                throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
            }
            this.reader.setIndex(offset);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            this.readBlockZip64EndOfCentralLocator();

            // now the zip64 EOCD record
            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
            this.readBlockZip64EndOfCentral();
        }
    },
    prepareReader: function(data) {
        var type = utils.getTypeOf(data);
        if (type === "string" && !support.uint8array) {
            this.reader = new StringReader(data, this.loadOptions.optimizedBinaryString);
        }
        else if (type === "nodebuffer") {
            this.reader = new NodeBufferReader(data);
        }
        else {
            this.reader = new Uint8ArrayReader(utils.transformTo("uint8array", data));
        }
    },
    /**
     * Read a zip file and create ZipEntries.
     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
     */
    load: function(data) {
        this.prepareReader(data);
        this.readEndOfCentral();
        this.readCentralDir();
        this.readLocalFiles();
    }
};
// }}} end of ZipEntries
module.exports = ZipEntries;

},{"./nodeBufferReader":12,"./object":13,"./signature":14,"./stringReader":15,"./support":17,"./uint8ArrayReader":18,"./utils":21,"./zipEntry":23}],23:[function(_dereq_,module,exports){
'use strict';
var StringReader = _dereq_('./stringReader');
var utils = _dereq_('./utils');
var CompressedObject = _dereq_('./compressedObject');
var jszipProto = _dereq_('./object');
// class ZipEntry {{{
/**
 * An entry in the zip file.
 * @constructor
 * @param {Object} options Options of the current file.
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntry(options, loadOptions) {
    this.options = options;
    this.loadOptions = loadOptions;
}
ZipEntry.prototype = {
    /**
     * say if the file is encrypted.
     * @return {boolean} true if the file is encrypted, false otherwise.
     */
    isEncrypted: function() {
        // bit 1 is set
        return (this.bitFlag & 0x0001) === 0x0001;
    },
    /**
     * say if the file has utf-8 filename/comment.
     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
     */
    useUTF8: function() {
        // bit 11 is set
        return (this.bitFlag & 0x0800) === 0x0800;
    },
    /**
     * Prepare the function used to generate the compressed content from this ZipFile.
     * @param {DataReader} reader the reader to use.
     * @param {number} from the offset from where we should read the data.
     * @param {number} length the length of the data to read.
     * @return {Function} the callback to get the compressed content (the type depends of the DataReader class).
     */
    prepareCompressedContent: function(reader, from, length) {
        return function() {
            var previousIndex = reader.index;
            reader.setIndex(from);
            var compressedFileData = reader.readData(length);
            reader.setIndex(previousIndex);

            return compressedFileData;
        };
    },
    /**
     * Prepare the function used to generate the uncompressed content from this ZipFile.
     * @param {DataReader} reader the reader to use.
     * @param {number} from the offset from where we should read the data.
     * @param {number} length the length of the data to read.
     * @param {JSZip.compression} compression the compression used on this file.
     * @param {number} uncompressedSize the uncompressed size to expect.
     * @return {Function} the callback to get the uncompressed content (the type depends of the DataReader class).
     */
    prepareContent: function(reader, from, length, compression, uncompressedSize) {
        return function() {

            var compressedFileData = utils.transformTo(compression.uncompressInputType, this.getCompressedContent());
            var uncompressedFileData = compression.uncompress(compressedFileData);

            if (uncompressedFileData.length !== uncompressedSize) {
                throw new Error("Bug : uncompressed data size mismatch");
            }

            return uncompressedFileData;
        };
    },
    /**
     * Read the local part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readLocalPart: function(reader) {
        var compression, localExtraFieldsLength;

        // we already know everything from the central dir !
        // If the central dir data are false, we are doomed.
        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
        // The less data we get here, the more reliable this should be.
        // Let's skip the whole header and dash to the data !
        reader.skip(22);
        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
        // Strangely, the filename here is OK.
        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
        // the internet.
        //
        // I think I see the logic here : the central directory is used to display
        // content and the local directory is used to extract the files. Mixing / and \
        // may be used to display \ to windows users and use / when extracting the files.
        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
        this.fileNameLength = reader.readInt(2);
        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
        this.fileName = reader.readString(this.fileNameLength);
        reader.skip(localExtraFieldsLength);

        if (this.compressedSize == -1 || this.uncompressedSize == -1) {
            throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory " + "(compressedSize == -1 || uncompressedSize == -1)");
        }

        compression = utils.findCompression(this.compressionMethod);
        if (compression === null) { // no compression found
            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + this.fileName + ")");
        }
        this.decompressed = new CompressedObject();
        this.decompressed.compressedSize = this.compressedSize;
        this.decompressed.uncompressedSize = this.uncompressedSize;
        this.decompressed.crc32 = this.crc32;
        this.decompressed.compressionMethod = this.compressionMethod;
        this.decompressed.getCompressedContent = this.prepareCompressedContent(reader, reader.index, this.compressedSize, compression);
        this.decompressed.getContent = this.prepareContent(reader, reader.index, this.compressedSize, compression, this.uncompressedSize);

        // we need to compute the crc32...
        if (this.loadOptions.checkCRC32) {
            this.decompressed = utils.transformTo("string", this.decompressed.getContent());
            if (jszipProto.crc32(this.decompressed) !== this.crc32) {
                throw new Error("Corrupted zip : CRC32 mismatch");
            }
        }
    },

    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readCentralPart: function(reader) {
        this.versionMadeBy = reader.readString(2);
        this.versionNeeded = reader.readInt(2);
        this.bitFlag = reader.readInt(2);
        this.compressionMethod = reader.readString(2);
        this.date = reader.readDate();
        this.crc32 = reader.readInt(4);
        this.compressedSize = reader.readInt(4);
        this.uncompressedSize = reader.readInt(4);
        this.fileNameLength = reader.readInt(2);
        this.extraFieldsLength = reader.readInt(2);
        this.fileCommentLength = reader.readInt(2);
        this.diskNumberStart = reader.readInt(2);
        this.internalFileAttributes = reader.readInt(2);
        this.externalFileAttributes = reader.readInt(4);
        this.localHeaderOffset = reader.readInt(4);

        if (this.isEncrypted()) {
            throw new Error("Encrypted zip are not supported");
        }

        this.fileName = reader.readString(this.fileNameLength);
        this.readExtraFields(reader);
        this.parseZIP64ExtraField(reader);
        this.fileComment = reader.readString(this.fileCommentLength);

        // warning, this is true only for zip with madeBy == DOS (plateform dependent feature)
        this.dir = this.externalFileAttributes & 0x00000010 ? true : false;
    },
    /**
     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
     * @param {DataReader} reader the reader to use.
     */
    parseZIP64ExtraField: function(reader) {

        if (!this.extraFields[0x0001]) {
            return;
        }

        // should be something, preparing the extra reader
        var extraReader = new StringReader(this.extraFields[0x0001].value);

        // I really hope that these 64bits integer can fit in 32 bits integer, because js
        // won't let us have more.
        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
            this.uncompressedSize = extraReader.readInt(8);
        }
        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
            this.compressedSize = extraReader.readInt(8);
        }
        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
            this.localHeaderOffset = extraReader.readInt(8);
        }
        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
            this.diskNumberStart = extraReader.readInt(4);
        }
    },
    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readExtraFields: function(reader) {
        var start = reader.index,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;

        this.extraFields = this.extraFields || {};

        while (reader.index < start + this.extraFieldsLength) {
            extraFieldId = reader.readInt(2);
            extraFieldLength = reader.readInt(2);
            extraFieldValue = reader.readString(extraFieldLength);

            this.extraFields[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Apply an UTF8 transformation if needed.
     */
    handleUTF8: function() {
        if (this.useUTF8()) {
            this.fileName = jszipProto.utf8decode(this.fileName);
            this.fileComment = jszipProto.utf8decode(this.fileComment);
        } else {
            var upath = this.findExtraFieldUnicodePath();
            if (upath !== null) {
                this.fileName = upath;
            }
            var ucomment = this.findExtraFieldUnicodeComment();
            if (ucomment !== null) {
                this.fileComment = ucomment;
            }
        }
    },

    /**
     * Find the unicode path declared in the extra field, if any.
     * @return {String} the unicode path, null otherwise.
     */
    findExtraFieldUnicodePath: function() {
        var upathField = this.extraFields[0x7075];
        if (upathField) {
            var extraReader = new StringReader(upathField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the filename changed, this field is out of date.
            if (jszipProto.crc32(this.fileName) !== extraReader.readInt(4)) {
                return null;
            }

            return jszipProto.utf8decode(extraReader.readString(upathField.length - 5));
        }
        return null;
    },

    /**
     * Find the unicode comment declared in the extra field, if any.
     * @return {String} the unicode comment, null otherwise.
     */
    findExtraFieldUnicodeComment: function() {
        var ucommentField = this.extraFields[0x6375];
        if (ucommentField) {
            var extraReader = new StringReader(ucommentField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the comment changed, this field is out of date.
            if (jszipProto.crc32(this.fileComment) !== extraReader.readInt(4)) {
                return null;
            }

            return jszipProto.utf8decode(extraReader.readString(ucommentField.length - 5));
        }
        return null;
    }
};
module.exports = ZipEntry;

},{"./compressedObject":2,"./object":13,"./stringReader":15,"./utils":21}],24:[function(_dereq_,module,exports){
// Top level file is just a mixin of submodules & constants
'use strict';

var assign    = _dereq_('./lib/utils/common').assign;

var deflate   = _dereq_('./lib/deflate');
var inflate   = _dereq_('./lib/inflate');
var constants = _dereq_('./lib/zlib/constants');

var pako = {};

assign(pako, deflate, inflate, constants);

module.exports = pako;
},{"./lib/deflate":25,"./lib/inflate":26,"./lib/utils/common":27,"./lib/zlib/constants":30}],25:[function(_dereq_,module,exports){
'use strict';


var zlib_deflate = _dereq_('./zlib/deflate.js');
var utils = _dereq_('./utils/common');
var strings = _dereq_('./utils/strings');
var msg = _dereq_('./zlib/messages');
var zstream = _dereq_('./zlib/zstream');


/* Public constants ==========================================================*/
/* ===========================================================================*/

var Z_NO_FLUSH      = 0;
var Z_FINISH        = 4;

var Z_OK            = 0;
var Z_STREAM_END    = 1;

var Z_DEFAULT_COMPRESSION = -1;

var Z_DEFAULT_STRATEGY    = 0;

var Z_DEFLATED  = 8;

/* ===========================================================================*/


/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/

/* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overriden.
 **/

/**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/

/**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/

/**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/


/**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/
var Deflate = function(options) {

  this.options = utils.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY,
    to: ''
  }, options || {});

  var opt = this.options;

  if (opt.raw && (opt.windowBits > 0)) {
    opt.windowBits = -opt.windowBits;
  }

  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
    opt.windowBits += 16;
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm = new zstream();
  this.strm.avail_out = 0;

  var status = zlib_deflate.deflateInit2(
    this.strm,
    opt.level,
    opt.method,
    opt.windowBits,
    opt.memLevel,
    opt.strategy
  );

  if (status !== Z_OK) {
    throw new Error(msg[status]);
  }

  if (opt.header) {
    zlib_deflate.deflateSetHeader(this.strm, opt.header);
  }
};

/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|String): input data. Strings will be converted to
 *   utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That flush internal pending buffers and call
 * [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Deflate.prototype.push = function(data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var status, _mode;

  if (this.ended) { return false; }

  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // If we need to compress text, change encoding to utf8.
    strm.input = strings.string2buf(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }
    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */

    if (status !== Z_STREAM_END && status !== Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }
    if (strm.avail_out === 0 || (strm.avail_in === 0 && _mode === Z_FINISH)) {
      if (this.options.to === 'string') {
        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
      } else {
        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
      }
    }
  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);

  // Finalize on the last chunk.
  if (_mode === Z_FINISH) {
    status = zlib_deflate.deflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === Z_OK;
  }

  return true;
};


/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Deflate.prototype.onData = function(chunk) {
  this.chunks.push(chunk);
};


/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that input stream complete
 * or error happenned. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Deflate.prototype.onEnd = function(status) {
  // On success - join
  if (status === Z_OK) {
    if (this.options.to === 'string') {
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate alrorythm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/
function deflate(input, options) {
  var deflator = new Deflate(options);

  deflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (deflator.err) { throw deflator.msg; }

  return deflator.result;
}


/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function deflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return deflate(input, options);
}


/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/
function gzip(input, options) {
  options = options || {};
  options.gzip = true;
  return deflate(input, options);
}


exports.Deflate = Deflate;
exports.deflate = deflate;
exports.deflateRaw = deflateRaw;
exports.gzip = gzip;
},{"./utils/common":27,"./utils/strings":28,"./zlib/deflate.js":32,"./zlib/messages":37,"./zlib/zstream":39}],26:[function(_dereq_,module,exports){
'use strict';


var zlib_inflate = _dereq_('./zlib/inflate.js');
var utils = _dereq_('./utils/common');
var strings = _dereq_('./utils/strings');
var c = _dereq_('./zlib/constants');
var msg = _dereq_('./zlib/messages');
var zstream = _dereq_('./zlib/zstream');
var gzheader = _dereq_('./zlib/gzheader');


/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/

/* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overriden.
 **/

/**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/

/**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/

/**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/


/**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/
var Inflate = function(options) {

  this.options = utils.assign({
    chunkSize: 16384,
    windowBits: 0,
    to: ''
  }, options || {});

  var opt = this.options;

  // Force window size for `raw` data, if not set directly,
  // because we have no header for autodetect.
  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
    opt.windowBits = -opt.windowBits;
    if (opt.windowBits === 0) { opt.windowBits = -15; }
  }

  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
      !(options && options.windowBits)) {
    opt.windowBits += 32;
  }

  // Gzip header has no info about windows size, we can do autodetect only
  // for deflate. So, if window size not set, force it to max when gzip possible
  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
    // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    if ((opt.windowBits & 15) === 0) {
      opt.windowBits |= 15;
    }
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm   = new zstream();
  this.strm.avail_out = 0;

  var status  = zlib_inflate.inflateInit2(
    this.strm,
    opt.windowBits
  );

  if (status !== c.Z_OK) {
    throw new Error(msg[status]);
  }

  this.header = new gzheader();

  zlib_inflate.inflateGetHeader(this.strm, this.header);
};

/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That flush internal pending buffers and call
 * [[Inflate#onEnd]].
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Inflate.prototype.push = function(data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var status, _mode;
  var next_out_utf8, tail, utf8str;

  if (this.ended) { return false; }
  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // Only binary strings can be decompressed on practice
    strm.input = strings.binstring2buf(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */

    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }

    if (strm.next_out) {
      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && _mode === c.Z_FINISH)) {

        if (this.options.to === 'string') {

          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);

          tail = strm.next_out - next_out_utf8;
          utf8str = strings.buf2string(strm.output, next_out_utf8);

          // move tail
          strm.next_out = tail;
          strm.avail_out = chunkSize - tail;
          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }

          this.onData(utf8str);

        } else {
          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
        }
      }
    }
  } while ((strm.avail_in > 0) && status !== c.Z_STREAM_END);

  if (status === c.Z_STREAM_END) {
    _mode = c.Z_FINISH;
  }
  // Finalize on the last chunk.
  if (_mode === c.Z_FINISH) {
    status = zlib_inflate.inflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === c.Z_OK;
  }

  return true;
};


/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Inflate.prototype.onData = function(chunk) {
  this.chunks.push(chunk);
};


/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell inflate that input stream complete
 * or error happenned. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Inflate.prototype.onEnd = function(status) {
  // On success - join
  if (status === c.Z_OK) {
    if (this.options.to === 'string') {
      // Glue & convert here, until we teach pako to send
      // utf8 alligned strings to onData
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/
function inflate(input, options) {
  var inflator = new Inflate(options);

  inflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (inflator.err) { throw inflator.msg; }

  return inflator.result;
}


/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function inflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return inflate(input, options);
}


/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/


exports.Inflate = Inflate;
exports.inflate = inflate;
exports.inflateRaw = inflateRaw;
exports.ungzip  = inflate;

},{"./utils/common":27,"./utils/strings":28,"./zlib/constants":30,"./zlib/gzheader":33,"./zlib/inflate.js":35,"./zlib/messages":37,"./zlib/zstream":39}],27:[function(_dereq_,module,exports){
'use strict';


var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
                (typeof Uint16Array !== 'undefined') &&
                (typeof Int32Array !== 'undefined');


exports.assign = function (obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    var source = sources.shift();
    if (!source) { continue; }

    if (typeof(source) !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (var p in source) {
      if (source.hasOwnProperty(p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function (buf, size) {
  if (buf.length === size) { return buf; }
  if (buf.subarray) { return buf.subarray(0, size); }
  buf.length = size;
  return buf;
};


var fnTyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
      dest.set(src.subarray(src_offs, src_offs+len), dest_offs);
      return;
    }
    // Fallback to ordinary array
    for(var i=0; i<len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function(chunks) {
    var i, l, len, pos, chunk, result;

    // calculate data length
    len = 0;
    for (i=0, l=chunks.length; i<l; i++) {
      len += chunks[i].length;
    }

    // join chunks
    result = new Uint8Array(len);
    pos = 0;
    for (i=0, l=chunks.length; i<l; i++) {
      chunk = chunks[i];
      result.set(chunk, pos);
      pos += chunk.length;
    }

    return result;
  }
};

var fnUntyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    for(var i=0; i<len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function(chunks) {
    return [].concat.apply([], chunks);
  }
};


// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function (on) {
  if (on) {
    exports.Buf8  = Uint8Array;
    exports.Buf16 = Uint16Array;
    exports.Buf32 = Int32Array;
    exports.assign(exports, fnTyped);
  } else {
    exports.Buf8  = Array;
    exports.Buf16 = Array;
    exports.Buf32 = Array;
    exports.assign(exports, fnUntyped);
  }
};

exports.setTyped(TYPED_OK);
},{}],28:[function(_dereq_,module,exports){
// String encode/decode helpers
'use strict';


var utils = _dereq_('./common');


// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safary
//
var STR_APPLY_OK = true;
var STR_APPLY_UIA_OK = true;

try { String.fromCharCode.apply(null, [0]); } catch(__) { STR_APPLY_OK = false; }
try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch(__) { STR_APPLY_UIA_OK = false; }


// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new utils.Buf8(256);
for (var i=0; i<256; i++) {
  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
}
_utf8len[254]=_utf8len[254]=1; // Invalid sequence start


// convert string to array (typed, when possible)
exports.string2buf = function (str) {
  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

  // count binary size
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
      c2 = str.charCodeAt(m_pos+1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }

  // allocate buffer
  buf = new utils.Buf8(buf_len);

  // convert
  for (i=0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
      c2 = str.charCodeAt(m_pos+1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      /* one byte */
      buf[i++] = c;
    } else if (c < 0x800) {
      /* two bytes */
      buf[i++] = 0xC0 | (c >>> 6);
      buf[i++] = 0x80 | (c & 0x3f);
    } else if (c < 0x10000) {
      /* three bytes */
      buf[i++] = 0xE0 | (c >>> 12);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    } else {
      /* four bytes */
      buf[i++] = 0xf0 | (c >>> 18);
      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    }
  }

  return buf;
};

// Helper (used in 2 places)
function buf2binstring(buf, len) {
  // use fallback for big arrays to avoid stack overflow
  if (len < 65537) {
    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
    }
  }

  var result = '';
  for(var i=0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
}


// Convert byte array to binary string
exports.buf2binstring = function(buf) {
  return buf2binstring(buf, buf.length);
};


// Convert binary string (typed, when possible)
exports.binstring2buf = function(str) {
  var buf = new utils.Buf8(str.length);
  for(var i=0, len=buf.length; i < len; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
};


// convert array to string
exports.buf2string = function (buf, max) {
  var i, out, c, c_len;
  var len = max || buf.length;

  // Reserve max possible length (2 words per char)
  // NB: by unknown reasons, Array is significantly faster for
  //     String.fromCharCode.apply than Uint16Array.
  var utf16buf = new Array(len*2);

  for (out=0, i=0; i<len;) {
    c = buf[i++];
    // quick process ascii
    if (c < 0x80) { utf16buf[out++] = c; continue; }

    c_len = _utf8len[c];
    // skip 5 & 6 byte codes
    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }

    // apply mask on first byte
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    // join the rest
    while (c_len > 1 && i < len) {
      c = (c << 6) | (buf[i++] & 0x3f);
      c_len--;
    }

    // terminated by end of string?
    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
    }
  }

  return buf2binstring(utf16buf, out);
};


// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
exports.utf8border = function(buf, max) {
  var pos;

  max = max || buf.length;
  if (max > buf.length) { max = buf.length; }

  // go back from last position, until start of sequence found
  pos = max-1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

  // Fuckup - very small and broken sequence,
  // return max, because we should return something anyway.
  if (pos < 0) { return max; }

  // If we came to start of buffer - that means vuffer is too small,
  // return max too.
  if (pos === 0) { return max; }

  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

},{"./common":27}],29:[function(_dereq_,module,exports){
'use strict';

// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It doesn't worth to make additional optimizationa as in original.
// Small size is preferable.

function adler32(adler, buf, len, pos) {
  var s1 = (adler & 0xffff) |0
    , s2 = ((adler >>> 16) & 0xffff) |0
    , n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
}


module.exports = adler32;
},{}],30:[function(_dereq_,module,exports){
module.exports = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
},{}],31:[function(_dereq_,module,exports){
'use strict';

// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.


// Use ordinary array, since untyped makes no boost here
function makeTable() {
  var c, table = [];

  for(var n =0; n < 256; n++){
    c = n;
    for(var k =0; k < 8; k++){
      c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
  var t = crcTable
    , end = pos + len;

  crc = crc ^ (-1);

  for (var i = pos; i < end; i++ ) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
}


module.exports = crc32;
},{}],32:[function(_dereq_,module,exports){
'use strict';

var utils   = _dereq_('../utils/common');
var trees   = _dereq_('./trees');
var adler32 = _dereq_('./adler32');
var crc32   = _dereq_('./crc32');
var msg   = _dereq_('./messages');

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
var Z_NO_FLUSH      = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
//var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;


/* compression levels */
//var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;


var Z_FILTERED            = 1;
var Z_HUFFMAN_ONLY        = 2;
var Z_RLE                 = 3;
var Z_FIXED               = 4;
var Z_DEFAULT_STRATEGY    = 0;

/* Possible values of the data_type field (though see inflate()) */
//var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;


/* The deflate compression method */
var Z_DEFLATED  = 8;

/*============================================================================*/


var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_MEM_LEVEL = 8;


var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
var LITERALS      = 256;
/* number of literal bytes 0..255 */
var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
var D_CODES       = 30;
/* number of distance codes */
var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
var HEAP_SIZE     = 2*L_CODES + 1;
/* maximum heap size */
var MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

var PRESET_DICT = 0x20;

var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;

var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
var BS_BLOCK_DONE     = 2; /* block flush performed */
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

function err(strm, errorCode) {
  strm.msg = msg[errorCode];
  return errorCode;
}

function rank(f) {
  return ((f) << 1) - ((f) > 4 ? 9 : 0);
}

function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
function flush_pending(strm) {
  var s = strm.state;

  //_tr_flush_bits(s);
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}


function flush_block_only (s, last) {
  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}


function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
function putShortMSB(s, b) {
//  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
}


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
function read_buf(strm, buf, start, size) {
  var len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  utils.arraySet(buf, strm.input, strm.next_in, len, start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
}


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;      /* max hash chain length */
  var scan = s.strstart; /* current string */
  var match;                       /* matched string */
  var len;                           /* length of current match */
  var best_len = s.prev_length;              /* best match length so far */
  var nice_match = s.nice_match;             /* stop if match long enough */
  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  var _win = s.window; // shortcut

  var wmask = s.w_mask;
  var prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  var strend = s.strstart + MAX_MATCH;
  var scan_end1  = _win[scan + best_len - 1];
  var scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;

      /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = (m >= _w_size ? m - _w_size : 0);
      } while (--n);

      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);

      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH-1]) & s.hash_mask;

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
function deflate_stored(s, flush) {
  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
  var max_block_size = 0xffff;

  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }

  /* Copy as much as possible from input to output: */
  for (;;) {
    /* Fill the window as much as possible: */
    if (s.lookahead <= 1) {

      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
      //  s->block_start >= (long)s->w_size, "slide too late");
//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
//        s.block_start >= s.w_size)) {
//        throw  new Error("slide too late");
//      }

      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }

      if (s.lookahead === 0) {
        break;
      }
      /* flush the current block */
    }
    //Assert(s->block_start >= 0L, "block gone");
//    if (s.block_start < 0) throw new Error("block gone");

    s.strstart += s.lookahead;
    s.lookahead = 0;

    /* Emit a stored block if pending_buf will be full: */
    var max_start = s.block_start + max_block_size;

    if (s.strstart === 0 || s.strstart >= max_start) {
      /* strstart == 0 is possible when wraparound on 16-bit machine */
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/


    }
    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }

  s.insert = 0;

  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }

  if (s.strstart > s.block_start) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_NEED_MORE;
}

/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
function deflate_fast(s, flush) {
  var hash_head;        /* head of the hash chain */
  var bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH-1)) ? s.strstart : MIN_MATCH-1);
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
function deflate_slow(s, flush) {
  var hash_head;          /* head of hash chain */
  var bflush;              /* set if current block must be flushed */

  var max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH-1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size-MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH-1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = trees._tr_tally(s, s.strstart - 1- s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length-1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH-1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart-1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart-1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH-1 ? s.strstart : MIN_MATCH-1;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
}


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
function deflate_rle(s, flush) {
  var bflush;            /* set if current block must be flushed */
  var prev;              /* byte at distance one to match */
  var scan, strend;      /* scan goes up to strend for length of run */

  var _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
function deflate_huff(s, flush) {
  var bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
var Config = function (good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
};

var configuration_table;

configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
function lm_init(s) {
  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
}


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
  this.dyn_dtree  = new utils.Buf16((2*D_CODES+1) * 2);
  this.bl_tree    = new utils.Buf16((2*BL_CODES+1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new utils.Buf16(MAX_BITS+1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new utils.Buf16(2*L_CODES+1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new utils.Buf16(2*L_CODES+1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.l_buf = 0;          /* buffer index for literals or lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.last_lit = 0;      /* running index in l_buf */

  this.d_buf = 0;
  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


function deflateResetKeep(strm) {
  var s;

  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = Z_NO_FLUSH;
  trees._tr_init(s);
  return Z_OK;
}


function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK) {
    lm_init(strm.state);
  }
  return ret;
}


function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
  strm.state.gzhead = head;
  return Z_OK;
}


function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR;
  }
  var wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  var s = new DeflateState();

  strm.state = s;
  s.strm = strm;

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new utils.Buf8(s.w_size * 2);
  s.head = new utils.Buf16(s.hash_size);
  s.prev = new utils.Buf16(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  s.pending_buf_size = s.lit_bufsize * 4;
  s.pending_buf = new utils.Buf8(s.pending_buf_size);

  s.d_buf = s.lit_bufsize >> 1;
  s.l_buf = (1 + 2) * s.lit_bufsize;

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
}

function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}


function deflate(strm, flush) {
  var old_flush, s;
  var beg, val; // for gzip header write only

  if (!strm || !strm.state ||
    flush > Z_BLOCK || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
  }

  s = strm.state;

  if (!strm.output ||
      (!strm.input && strm.avail_in !== 0) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
  }

  s.strm = strm; /* just in case */
  old_flush = s.last_flush;
  s.last_flush = flush;

  /* Write the header */
  if (s.status === INIT_STATE) {

    if (s.wrap === 2) { // GZIP header
      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) { // s->gzhead == Z_NULL
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      }
      else {
        put_byte(s, (s.gzhead.text ? 1 : 0) +
                    (s.gzhead.hcrc ? 2 : 0) +
                    (!s.gzhead.extra ? 0 : 4) +
                    (!s.gzhead.name ? 0 : 8) +
                    (!s.gzhead.comment ? 0 : 16)
                );
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, (s.gzhead.time >> 8) & 0xff);
        put_byte(s, (s.gzhead.time >> 16) & 0xff);
        put_byte(s, (s.gzhead.time >> 24) & 0xff);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    }
    else // DEFLATE header
    {
      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
      var level_flags = -1;

      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= (level_flags << 6);
      if (s.strstart !== 0) { header |= PRESET_DICT; }
      header += 31 - (header % 31);

      s.status = BUSY_STATE;
      putShortMSB(s, header);

      /* Save the adler32 of the preset dictionary: */
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }
      strm.adler = 1; // adler32(0L, Z_NULL, 0);
    }
  }

//#ifdef GZIP
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */

      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    }
    else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg){
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    }
    else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    }
    else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        strm.adler = 0; //crc32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
      }
    }
    else {
      s.status = BUSY_STATE;
    }
  }
//#endif

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH) {
    return err(strm, Z_BUF_ERROR);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR);
  }

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
        configuration_table[s.level].func(s, flush));

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      }
      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

        trees._tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK;
      }
    }
  }
  //Assert(strm->avail_out > 0, "bug2");
  //if (strm.avail_out <= 0) { throw new Error("bug2");}

  if (flush !== Z_FINISH) { return Z_OK; }
  if (s.wrap <= 0) { return Z_STREAM_END; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}

function deflateEnd(strm) {
  var status;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  status = strm.state.status;
  if (status !== INIT_STATE &&
    status !== EXTRA_STATE &&
    status !== NAME_STATE &&
    status !== COMMENT_STATE &&
    status !== HCRC_STATE &&
    status !== BUSY_STATE &&
    status !== FINISH_STATE
  ) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}

/* =========================================================================
 * Copy the source state to the destination state
 */
//function deflateCopy(dest, source) {
//
//}

exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/
},{"../utils/common":27,"./adler32":29,"./crc32":31,"./messages":37,"./trees":38}],33:[function(_dereq_,module,exports){
'use strict';


function GZheader() {
  /* true if compressed data believed to be text */
  this.text       = 0;
  /* modification time */
  this.time       = 0;
  /* extra flags (not used when writing a gzip file) */
  this.xflags     = 0;
  /* operating system */
  this.os         = 0;
  /* pointer to extra field or Z_NULL if none */
  this.extra      = null;
  /* extra field length (valid if extra != Z_NULL) */
  this.extra_len  = 0; // Actually, we don't need it in JS,
                       // but leave for few code modifications

  //
  // Setup limits is not necessary because in js we should not preallocate memory
  // for inflate use constant limit in 65536 bytes
  //

  /* space at extra (only when reading header) */
  // this.extra_max  = 0;
  /* pointer to zero-terminated file name or Z_NULL */
  this.name       = '';
  /* space at name (only when reading header) */
  // this.name_max   = 0;
  /* pointer to zero-terminated comment or Z_NULL */
  this.comment    = '';
  /* space at comment (only when reading header) */
  // this.comm_max   = 0;
  /* true if there was or will be a header crc */
  this.hcrc       = 0;
  /* true when done reading gzip header (not used when writing a gzip file) */
  this.done       = false;
}

module.exports = GZheader;
},{}],34:[function(_dereq_,module,exports){
'use strict';

// See state defs from inflate.js
var BAD = 30;       /* got a data error -- remain here until reset */
var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
module.exports = function inflate_fast(strm, start) {
  var state;
  var _in;                    /* local strm.input */
  var last;                   /* have enough input while in < last */
  var _out;                   /* local strm.output */
  var beg;                    /* inflate()'s initial strm.output */
  var end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  var dmax;                   /* maximum distance from zlib header */
//#endif
  var wsize;                  /* window size or zero if not using window */
  var whave;                  /* valid bytes in the window */
  var wnext;                  /* window write index */
  var window;                 /* allocated sliding window, if wsize != 0 */
  var hold;                   /* local strm.hold */
  var bits;                   /* local strm.bits */
  var lcode;                  /* local strm.lencode */
  var dcode;                  /* local strm.distcode */
  var lmask;                  /* mask for first level of length codes */
  var dmask;                  /* mask for first level of distance codes */
  var here;                   /* retrieved table entry */
  var op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  var len;                    /* match length, unused bytes */
  var dist;                   /* match distance */
  var from;                   /* where to copy match from */
  var from_source;


  var input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD;
                  break top;
                }

// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};

},{}],35:[function(_dereq_,module,exports){
'use strict';


var utils = _dereq_('../utils/common');
var adler32 = _dereq_('./adler32');
var crc32   = _dereq_('./crc32');
var inflate_fast = _dereq_('./inffast');
var inflate_table = _dereq_('./inftrees');

var CODES = 0;
var LENS = 1;
var DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
//var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;

/* The deflate compression method */
var Z_DEFLATED  = 8;


/* STATES ====================================================================*/
/* ===========================================================================*/


var    HEAD = 1;       /* i: waiting for magic header */
var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
var    TIME = 3;       /* i: waiting for modification time (gzip) */
var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
var    NAME = 7;       /* i: waiting for end of file name (gzip) */
var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
var    HCRC = 9;       /* i: waiting for header crc (gzip) */
var    DICTID = 10;    /* i: waiting for dictionary check value */
var    DICT = 11;      /* waiting for inflateSetDictionary() call */
var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
var        STORED = 14;    /* i: waiting for stored size (length and complement) */
var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
var        LENLENS = 18;   /* i: waiting for code length code lengths */
var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
var            LEN = 21;       /* i: waiting for length/lit/eob code */
var            LENEXT = 22;    /* i: waiting for length extra bits */
var            DIST = 23;      /* i: waiting for distance code */
var            DISTEXT = 24;   /* i: waiting for distance extra bits */
var            MATCH = 25;     /* o: waiting for output space to copy string */
var            LIT = 26;       /* o: waiting for output space to write literal */
var    CHECK = 27;     /* i: waiting for 32-bit check value */
var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
var    DONE = 29;      /* finished check, done -- remain here until reset */
var    BAD = 30;       /* got a data error -- remain here until reset */
var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_WBITS = MAX_WBITS;


function ZSWAP32(q) {
  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
}


function InflateState() {
  this.mode = 0;             /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
  this.work = new utils.Buf16(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}

function inflateResetKeep(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK;
}

function inflateReset(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

}

function inflateReset2(strm, windowBits) {
  var wrap;
  var state;

  /* get the state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
}

function inflateInit2(strm, windowBits) {
  var ret;
  var state;

  if (!strm) { return Z_STREAM_ERROR; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.window = null/*Z_NULL*/;
  ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
}

function inflateInit(strm) {
  return inflateInit2(strm, DEF_WBITS);
}


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
var virgin = true;

var lenfix, distfix; // We have no pointers in JS, so keep tables separate

function fixedtables(state) {
  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    var sym;

    lenfix = new utils.Buf32(512);
    distfix = new utils.Buf32(32);

    /* literal/length table */
    sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, {bits: 9});

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, {bits: 5});

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
}


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
function updatewindow(strm, src, end, copy) {
  var dist;
  var state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new utils.Buf8(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    utils.arraySet(state.window,src, end - state.wsize, state.wsize, 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    utils.arraySet(state.window,src, end - copy, dist, state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      utils.arraySet(state.window,src, end - copy, copy, 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
}

function inflate(strm, flush) {
  var state;
  var input, output;          // input/output buffers
  var next;                   /* next input INDEX */
  var put;                    /* next output INDEX */
  var have, left;             /* available input and output */
  var hold;                   /* bit buffer */
  var bits;                   /* bits in bit buffer */
  var _in, _out;              /* save starting available input and output */
  var copy;                   /* number of stored or match bytes to copy */
  var from;                   /* where to copy match bytes from */
  var from_source;
  var here = 0;               /* current decoding table entry */
  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //var last;                   /* parent table entry */
  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  var len;                    /* length to copy for repeats, bits to drop */
  var ret;                    /* return code */
  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
  var opts;

  var n; // temporary var for NEED_BITS

  var order = /* permutation of code lengths */
    [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];


  if (!strm || !strm.state || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
    case HEAD:
      if (state.wrap === 0) {
        state.mode = TYPEDO;
        break;
      }
      //=== NEEDBITS(16);
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//

        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = FLAGS;
        break;
      }
      state.flags = 0;           /* expect zlib header */
      if (state.head) {
        state.head.done = false;
      }
      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
        strm.msg = 'incorrect header check';
        state.mode = BAD;
        break;
      }
      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
        strm.msg = 'unknown compression method';
        state.mode = BAD;
        break;
      }
      //--- DROPBITS(4) ---//
      hold >>>= 4;
      bits -= 4;
      //---//
      len = (hold & 0x0f)/*BITS(4)*/ + 8;
      if (state.wbits === 0) {
        state.wbits = len;
      }
      else if (len > state.wbits) {
        strm.msg = 'invalid window size';
        state.mode = BAD;
        break;
      }
      state.dmax = 1 << len;
      //Tracev((stderr, "inflate:   zlib header ok\n"));
      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
      state.mode = hold & 0x200 ? DICTID : TYPE;
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      break;
    case FLAGS:
      //=== NEEDBITS(16); */
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.flags = hold;
      if ((state.flags & 0xff) !== Z_DEFLATED) {
        strm.msg = 'unknown compression method';
        state.mode = BAD;
        break;
      }
      if (state.flags & 0xe000) {
        strm.msg = 'unknown header flags set';
        state.mode = BAD;
        break;
      }
      if (state.head) {
        state.head.text = ((hold >> 8) & 1);
      }
      if (state.flags & 0x0200) {
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = TIME;
      /* falls through */
    case TIME:
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if (state.head) {
        state.head.time = hold;
      }
      if (state.flags & 0x0200) {
        //=== CRC4(state.check, hold)
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        hbuf[2] = (hold >>> 16) & 0xff;
        hbuf[3] = (hold >>> 24) & 0xff;
        state.check = crc32(state.check, hbuf, 4, 0);
        //===
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = OS;
      /* falls through */
    case OS:
      //=== NEEDBITS(16); */
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if (state.head) {
        state.head.xflags = (hold & 0xff);
        state.head.os = (hold >> 8);
      }
      if (state.flags & 0x0200) {
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = EXLEN;
      /* falls through */
    case EXLEN:
      if (state.flags & 0x0400) {
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.length = hold;
        if (state.head) {
          state.head.extra_len = hold;
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
      }
      else if (state.head) {
        state.head.extra = null/*Z_NULL*/;
      }
      state.mode = EXTRA;
      /* falls through */
    case EXTRA:
      if (state.flags & 0x0400) {
        copy = state.length;
        if (copy > have) { copy = have; }
        if (copy) {
          if (state.head) {
            len = state.head.extra_len - state.length;
            if (!state.head.extra) {
              // Use untyped array for more conveniend processing later
              state.head.extra = new Array(state.head.extra_len);
            }
            utils.arraySet(
              state.head.extra,
              input,
              next,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              copy,
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              len
            );
            //zmemcpy(state.head.extra + len, next,
            //        len + copy > state.head.extra_max ?
            //        state.head.extra_max - len : copy);
          }
          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          state.length -= copy;
        }
        if (state.length) { break inf_leave; }
      }
      state.length = 0;
      state.mode = NAME;
      /* falls through */
    case NAME:
      if (state.flags & 0x0800) {
        if (have === 0) { break inf_leave; }
        copy = 0;
        do {
          // TODO: 2 or 1 bytes?
          len = input[next + copy++];
          /* use constant limit because in js we should not preallocate memory */
          if (state.head && len &&
              (state.length < 65536 /*state.head.name_max*/)) {
            state.head.name += String.fromCharCode(len);
          }
        } while (len && copy < have);

        if (state.flags & 0x0200) {
          state.check = crc32(state.check, input, copy, next);
        }
        have -= copy;
        next += copy;
        if (len) { break inf_leave; }
      }
      else if (state.head) {
        state.head.name = null;
      }
      state.length = 0;
      state.mode = COMMENT;
      /* falls through */
    case COMMENT:
      if (state.flags & 0x1000) {
        if (have === 0) { break inf_leave; }
        copy = 0;
        do {
          len = input[next + copy++];
          /* use constant limit because in js we should not preallocate memory */
          if (state.head && len &&
              (state.length < 65536 /*state.head.comm_max*/)) {
            state.head.comment += String.fromCharCode(len);
          }
        } while (len && copy < have);
        if (state.flags & 0x0200) {
          state.check = crc32(state.check, input, copy, next);
        }
        have -= copy;
        next += copy;
        if (len) { break inf_leave; }
      }
      else if (state.head) {
        state.head.comment = null;
      }
      state.mode = HCRC;
      /* falls through */
    case HCRC:
      if (state.flags & 0x0200) {
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (hold !== (state.check & 0xffff)) {
          strm.msg = 'header crc mismatch';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
      }
      if (state.head) {
        state.head.hcrc = ((state.flags >> 9) & 1);
        state.head.done = true;
      }
      strm.adler = state.check = 0 /*crc32(0L, Z_NULL, 0)*/;
      state.mode = TYPE;
      break;
    case DICTID:
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      strm.adler = state.check = ZSWAP32(hold);
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = DICT;
      /* falls through */
    case DICT:
      if (state.havedict === 0) {
        //--- RESTORE() ---
        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits;
        //---
        return Z_NEED_DICT;
      }
      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
      state.mode = TYPE;
      /* falls through */
    case TYPE:
      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case TYPEDO:
      if (state.last) {
        //--- BYTEBITS() ---//
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        state.mode = CHECK;
        break;
      }
      //=== NEEDBITS(3); */
      while (bits < 3) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.last = (hold & 0x01)/*BITS(1)*/;
      //--- DROPBITS(1) ---//
      hold >>>= 1;
      bits -= 1;
      //---//

      switch ((hold & 0x03)/*BITS(2)*/) {
      case 0:                             /* stored block */
        //Tracev((stderr, "inflate:     stored block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = STORED;
        break;
      case 1:                             /* fixed block */
        fixedtables(state);
        //Tracev((stderr, "inflate:     fixed codes block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = LEN_;             /* decode codes */
        if (flush === Z_TREES) {
          //--- DROPBITS(2) ---//
          hold >>>= 2;
          bits -= 2;
          //---//
          break inf_leave;
        }
        break;
      case 2:                             /* dynamic block */
        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = TABLE;
        break;
      case 3:
        strm.msg = 'invalid block type';
        state.mode = BAD;
      }
      //--- DROPBITS(2) ---//
      hold >>>= 2;
      bits -= 2;
      //---//
      break;
    case STORED:
      //--- BYTEBITS() ---// /* go to byte boundary */
      hold >>>= bits & 7;
      bits -= bits & 7;
      //---//
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
        strm.msg = 'invalid stored block lengths';
        state.mode = BAD;
        break;
      }
      state.length = hold & 0xffff;
      //Tracev((stderr, "inflate:       stored length %u\n",
      //        state.length));
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = COPY_;
      if (flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case COPY_:
      state.mode = COPY;
      /* falls through */
    case COPY:
      copy = state.length;
      if (copy) {
        if (copy > have) { copy = have; }
        if (copy > left) { copy = left; }
        if (copy === 0) { break inf_leave; }
        //--- zmemcpy(put, next, copy); ---
        utils.arraySet(output, input, next, copy, put);
        //---//
        have -= copy;
        next += copy;
        left -= copy;
        put += copy;
        state.length -= copy;
        break;
      }
      //Tracev((stderr, "inflate:       stored end\n"));
      state.mode = TYPE;
      break;
    case TABLE:
      //=== NEEDBITS(14); */
      while (bits < 14) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
      //--- DROPBITS(5) ---//
      hold >>>= 5;
      bits -= 5;
      //---//
      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
      //--- DROPBITS(5) ---//
      hold >>>= 5;
      bits -= 5;
      //---//
      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
      //--- DROPBITS(4) ---//
      hold >>>= 4;
      bits -= 4;
      //---//
//#ifndef PKZIP_BUG_WORKAROUND
      if (state.nlen > 286 || state.ndist > 30) {
        strm.msg = 'too many length or distance symbols';
        state.mode = BAD;
        break;
      }
//#endif
      //Tracev((stderr, "inflate:       table sizes ok\n"));
      state.have = 0;
      state.mode = LENLENS;
      /* falls through */
    case LENLENS:
      while (state.have < state.ncode) {
        //=== NEEDBITS(3);
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
        //--- DROPBITS(3) ---//
        hold >>>= 3;
        bits -= 3;
        //---//
      }
      while (state.have < 19) {
        state.lens[order[state.have++]] = 0;
      }
      // We have separate tables & no pointers. 2 commented lines below not needed.
      //state.next = state.codes;
      //state.lencode = state.next;
      // Switch to use dynamic table
      state.lencode = state.lendyn;
      state.lenbits = 7;

      opts = {bits: state.lenbits};
      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
      state.lenbits = opts.bits;

      if (ret) {
        strm.msg = 'invalid code lengths set';
        state.mode = BAD;
        break;
      }
      //Tracev((stderr, "inflate:       code lengths ok\n"));
      state.have = 0;
      state.mode = CODELENS;
      /* falls through */
    case CODELENS:
      while (state.have < state.nlen + state.ndist) {
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_val < 16) {
          //--- DROPBITS(here.bits) ---//
          hold >>>= here_bits;
          bits -= here_bits;
          //---//
          state.lens[state.have++] = here_val;
        }
        else {
          if (here_val === 16) {
            //=== NEEDBITS(here.bits + 2);
            n = here_bits + 2;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            if (state.have === 0) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            len = state.lens[state.have - 1];
            copy = 3 + (hold & 0x03);//BITS(2);
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            //---//
          }
          else if (here_val === 17) {
            //=== NEEDBITS(here.bits + 3);
            n = here_bits + 3;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            len = 0;
            copy = 3 + (hold & 0x07);//BITS(3);
            //--- DROPBITS(3) ---//
            hold >>>= 3;
            bits -= 3;
            //---//
          }
          else {
            //=== NEEDBITS(here.bits + 7);
            n = here_bits + 7;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            len = 0;
            copy = 11 + (hold & 0x7f);//BITS(7);
            //--- DROPBITS(7) ---//
            hold >>>= 7;
            bits -= 7;
            //---//
          }
          if (state.have + copy > state.nlen + state.ndist) {
            strm.msg = 'invalid bit length repeat';
            state.mode = BAD;
            break;
          }
          while (copy--) {
            state.lens[state.have++] = len;
          }
        }
      }

      /* handle error breaks in while */
      if (state.mode === BAD) { break; }

      /* check for end-of-block code (better have one) */
      if (state.lens[256] === 0) {
        strm.msg = 'invalid code -- missing end-of-block';
        state.mode = BAD;
        break;
      }

      /* build code tables -- note: do not change the lenbits or distbits
         values here (9 and 6) without reading the comments in inftrees.h
         concerning the ENOUGH constants, which depend on those values */
      state.lenbits = 9;

      opts = {bits: state.lenbits};
      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
      // We have separate tables & no pointers. 2 commented lines below not needed.
      // state.next_index = opts.table_index;
      state.lenbits = opts.bits;
      // state.lencode = state.next;

      if (ret) {
        strm.msg = 'invalid literal/lengths set';
        state.mode = BAD;
        break;
      }

      state.distbits = 6;
      //state.distcode.copy(state.codes);
      // Switch to use dynamic table
      state.distcode = state.distdyn;
      opts = {bits: state.distbits};
      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
      // We have separate tables & no pointers. 2 commented lines below not needed.
      // state.next_index = opts.table_index;
      state.distbits = opts.bits;
      // state.distcode = state.next;

      if (ret) {
        strm.msg = 'invalid distances set';
        state.mode = BAD;
        break;
      }
      //Tracev((stderr, 'inflate:       codes ok\n'));
      state.mode = LEN_;
      if (flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case LEN_:
      state.mode = LEN;
      /* falls through */
    case LEN:
      if (have >= 6 && left >= 258) {
        //--- RESTORE() ---
        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits;
        //---
        inflate_fast(strm, _out);
        //--- LOAD() ---
        put = strm.next_out;
        output = strm.output;
        left = strm.avail_out;
        next = strm.next_in;
        input = strm.input;
        have = strm.avail_in;
        hold = state.hold;
        bits = state.bits;
        //---

        if (state.mode === TYPE) {
          state.back = -1;
        }
        break;
      }
      state.back = 0;
      for (;;) {
        here = state.lencode[hold & ((1 << state.lenbits) -1)];  /*BITS(state.lenbits)*/
        here_bits = here >>> 24;
        here_op = (here >>> 16) & 0xff;
        here_val = here & 0xffff;

        if (here_bits <= bits) { break; }
        //--- PULLBYTE() ---//
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
        //---//
      }
      if (here_op && (here_op & 0xf0) === 0) {
        last_bits = here_bits;
        last_op = here_op;
        last_val = here_val;
        for (;;) {
          here = state.lencode[last_val +
                  ((hold & ((1 << (last_bits + last_op)) -1))/*BITS(last.bits + last.op)*/ >> last_bits)];
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((last_bits + here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        //--- DROPBITS(last.bits) ---//
        hold >>>= last_bits;
        bits -= last_bits;
        //---//
        state.back += last_bits;
      }
      //--- DROPBITS(here.bits) ---//
      hold >>>= here_bits;
      bits -= here_bits;
      //---//
      state.back += here_bits;
      state.length = here_val;
      if (here_op === 0) {
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        state.mode = LIT;
        break;
      }
      if (here_op & 32) {
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.back = -1;
        state.mode = TYPE;
        break;
      }
      if (here_op & 64) {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break;
      }
      state.extra = here_op & 15;
      state.mode = LENEXT;
      /* falls through */
    case LENEXT:
      if (state.extra) {
        //=== NEEDBITS(state.extra);
        n = state.extra;
        while (bits < n) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.length += hold & ((1 << state.extra) -1)/*BITS(state.extra)*/;
        //--- DROPBITS(state.extra) ---//
        hold >>>= state.extra;
        bits -= state.extra;
        //---//
        state.back += state.extra;
      }
      //Tracevv((stderr, "inflate:         length %u\n", state.length));
      state.was = state.length;
      state.mode = DIST;
      /* falls through */
    case DIST:
      for (;;) {
        here = state.distcode[hold & ((1 << state.distbits) -1)];/*BITS(state.distbits)*/
        here_bits = here >>> 24;
        here_op = (here >>> 16) & 0xff;
        here_val = here & 0xffff;

        if ((here_bits) <= bits) { break; }
        //--- PULLBYTE() ---//
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
        //---//
      }
      if ((here_op & 0xf0) === 0) {
        last_bits = here_bits;
        last_op = here_op;
        last_val = here_val;
        for (;;) {
          here = state.distcode[last_val +
                  ((hold & ((1 << (last_bits + last_op)) -1))/*BITS(last.bits + last.op)*/ >> last_bits)];
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((last_bits + here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        //--- DROPBITS(last.bits) ---//
        hold >>>= last_bits;
        bits -= last_bits;
        //---//
        state.back += last_bits;
      }
      //--- DROPBITS(here.bits) ---//
      hold >>>= here_bits;
      bits -= here_bits;
      //---//
      state.back += here_bits;
      if (here_op & 64) {
        strm.msg = 'invalid distance code';
        state.mode = BAD;
        break;
      }
      state.offset = here_val;
      state.extra = (here_op) & 15;
      state.mode = DISTEXT;
      /* falls through */
    case DISTEXT:
      if (state.extra) {
        //=== NEEDBITS(state.extra);
        n = state.extra;
        while (bits < n) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.offset += hold & ((1 << state.extra) -1)/*BITS(state.extra)*/;
        //--- DROPBITS(state.extra) ---//
        hold >>>= state.extra;
        bits -= state.extra;
        //---//
        state.back += state.extra;
      }
//#ifdef INFLATE_STRICT
      if (state.offset > state.dmax) {
        strm.msg = 'invalid distance too far back';
        state.mode = BAD;
        break;
      }
//#endif
      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
      state.mode = MATCH;
      /* falls through */
    case MATCH:
      if (left === 0) { break inf_leave; }
      copy = _out - left;
      if (state.offset > copy) {         /* copy from window */
        copy = state.offset - copy;
        if (copy > state.whave) {
          if (state.sane) {
            strm.msg = 'invalid distance too far back';
            state.mode = BAD;
            break;
          }
// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
        }
        if (copy > state.wnext) {
          copy -= state.wnext;
          from = state.wsize - copy;
        }
        else {
          from = state.wnext - copy;
        }
        if (copy > state.length) { copy = state.length; }
        from_source = state.window;
      }
      else {                              /* copy from output */
        from_source = output;
        from = put - state.offset;
        copy = state.length;
      }
      if (copy > left) { copy = left; }
      left -= copy;
      state.length -= copy;
      do {
        output[put++] = from_source[from++];
      } while (--copy);
      if (state.length === 0) { state.mode = LEN; }
      break;
    case LIT:
      if (left === 0) { break inf_leave; }
      output[put++] = state.length;
      left--;
      state.mode = LEN;
      break;
    case CHECK:
      if (state.wrap) {
        //=== NEEDBITS(32);
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          // Use '|' insdead of '+' to make sure that result is signed
          hold |= input[next++] << bits;
          bits += 8;
        }
        //===//
        _out -= left;
        strm.total_out += _out;
        state.total += _out;
        if (_out) {
          strm.adler = state.check =
              /*UPDATE(state.check, put - _out, _out);*/
              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

        }
        _out = left;
        // NB: crc32 stored as signed 32-bit int, ZSWAP32 returns signed too
        if ((state.flags ? hold : ZSWAP32(hold)) !== state.check) {
          strm.msg = 'incorrect data check';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        //Tracev((stderr, "inflate:   check matches trailer\n"));
      }
      state.mode = LENGTH;
      /* falls through */
    case LENGTH:
      if (state.wrap && state.flags) {
        //=== NEEDBITS(32);
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (hold !== (state.total & 0xffffffff)) {
          strm.msg = 'incorrect length check';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        //Tracev((stderr, "inflate:   length matches trailer\n"));
      }
      state.mode = DONE;
      /* falls through */
    case DONE:
      ret = Z_STREAM_END;
      break inf_leave;
    case BAD:
      ret = Z_DATA_ERROR;
      break inf_leave;
    case MEM:
      return Z_MEM_ERROR;
    case SYNC:
      /* falls through */
    default:
      return Z_STREAM_ERROR;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
      state.mode = MEM;
      return Z_MEM_ERROR;
    }
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
    ret = Z_BUF_ERROR;
  }
  return ret;
}

function inflateEnd(strm) {

  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
    return Z_STREAM_ERROR;
  }

  var state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK;
}

function inflateGetHeader(strm, head) {
  var state;

  /* check state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK;
}


exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateInfo = 'pako inflate (from Nodeca project)';

/* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/
},{"../utils/common":27,"./adler32":29,"./crc32":31,"./inffast":34,"./inftrees":36}],36:[function(_dereq_,module,exports){
'use strict';


var utils = _dereq_('../utils/common');

var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

var lbase = [ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
];

var lext = [ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
];

var dbase = [ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
];

var dext = [ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
];

module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
{
  var bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  var len = 0;               /* a code's length in bits */
  var sym = 0;               /* index of code symbols */
  var min = 0, max = 0;          /* minimum and maximum code lengths */
  var root = 0;              /* number of index bits for root table */
  var curr = 0;              /* number of index bits for current table */
  var drop = 0;              /* code bits to drop for sub-table */
  var left = 0;                   /* number of prefix codes available */
  var used = 0;              /* code entries in table used */
  var huff = 0;              /* Huffman code */
  var incr;              /* for incrementing code, index */
  var fill;              /* index for replicating entries */
  var low;               /* low bits for current root entry */
  var mask;              /* mask for low root bits */
  var next;             /* next available space in table */
  var base = null;     /* base value table to use */
  var base_index = 0;
//  var shoextra;    /* extra bits table to use */
  var end;                    /* use base and extra for symbol > end */
  var count = new utils.Buf16(MAXBITS+1); //[MAXBITS+1];    /* number of codes of each length */
  var offs = new utils.Buf16(MAXBITS+1); //[MAXBITS+1];     /* offsets in table for each length */
  var extra = null;
  var extra_index = 0;

  var here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES) {
      base = extra = work;    /* dummy value--not used */
      end = 19;
  } else if (type === LENS) {
      base = lbase;
      base_index -= 257;
      extra = lext;
      extra_index -= 257;
      end = 256;
  } else {                    /* DISTS */
      base = dbase;
      extra = dext;
      end = -1;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS && used > ENOUGH_LENS) ||
    (type === DISTS && used > ENOUGH_DISTS)) {
    return 1;
  }

  var i=0;
  /* process all codes and make table entries */
  for (;;) {
    i++;
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] < end) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] > end) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS && used > ENOUGH_LENS) ||
        (type === DISTS && used > ENOUGH_DISTS)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};

},{"../utils/common":27}],37:[function(_dereq_,module,exports){
'use strict';

module.exports = {
  '2':    'need dictionary',     /* Z_NEED_DICT       2  */
  '1':    'stream end',          /* Z_STREAM_END      1  */
  '0':    '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};
},{}],38:[function(_dereq_,module,exports){
'use strict';


var utils = _dereq_('../utils/common');

/* Public constants ==========================================================*/
/* ===========================================================================*/


//var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED               = 4;
//var Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
var Z_BINARY              = 0;
var Z_TEXT                = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;

/*============================================================================*/


function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES    = 2;
/* The three kinds of block type */

var MIN_MATCH    = 3;
var MAX_MATCH    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */

var LITERALS      = 256;
/* number of literal bytes 0..255 */

var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */

var D_CODES       = 30;
/* number of distance codes */

var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */

var HEAP_SIZE     = 2*L_CODES + 1;
/* maximum heap size */

var MAX_BITS      = 15;
/* All codes must not exceed MAX_BITS bits */

var Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

var END_BLOCK   = 256;
/* end of block literal code */

var REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

var REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

var extra_lbits =   /* extra bits for each length code */
  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

var extra_dbits =   /* extra bits for each distance code */
  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

var extra_blbits =  /* extra bits for each bit length code */
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

var bl_order =
  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
var static_ltree  = new Array((L_CODES+2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

var static_dtree  = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

var _dist_code    = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

var _length_code  = new Array(MAX_MATCH-MIN_MATCH+1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

var base_length   = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

var base_dist     = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


var StaticTreeDesc = function (static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
};


var static_l_desc;
var static_d_desc;
var static_bl_desc;


var TreeDesc = function(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
};



function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
function put_short (s, w) {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
}


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
function send_bits(s, value, length) {
  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
}


function send_code(s, c, tree) {
  send_bits(s, tree[c*2]/*.Code*/, tree[c*2 + 1]/*.Len*/);
}


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
function bi_reverse(code, len) {
  var res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
function gen_bitlen(s, desc)
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
  var tree            = desc.dyn_tree;
  var max_code        = desc.max_code;
  var stree           = desc.stat_desc.static_tree;
  var has_stree       = desc.stat_desc.has_stree;
  var extra           = desc.stat_desc.extra_bits;
  var base            = desc.stat_desc.extra_base;
  var max_length      = desc.stat_desc.max_length;
  var h;              /* heap index */
  var n, m;           /* iterate over the tree elements */
  var bits;           /* bit length */
  var xbits;          /* extra bits */
  var f;              /* frequency */
  var overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max]*2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max+1; h < HEAP_SIZE; h++) {
    n = s.heap[h];
    bits = tree[tree[n*2 +1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n*2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n-base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n*2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Trace((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length-1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits+1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m*2 + 1]/*.Len*/ !== bits) {
        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m*2 + 1]/*.Len*/)*tree[m*2]/*.Freq*/;
        tree[m*2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
}


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
function gen_codes(tree, max_code, bl_count)
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
  var next_code = new Array(MAX_BITS+1); /* next code value for each bit length */
  var code = 0;              /* running code value */
  var bits;                  /* bit index */
  var n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS; bits++) {
    next_code[bits] = code = (code + bl_count[bits-1]) << 1;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    var len = tree[n*2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n*2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
}


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
function tr_static_init() {
  var n;        /* iterates over tree elements */
  var bits;     /* bit counter */
  var length;   /* length value */
  var code;     /* code value */
  var dist;     /* distance index */
  var bl_count = new Array(MAX_BITS+1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES-1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1<<extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length-1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0 ; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1<<extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for ( ; code < D_CODES; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1<<(extra_dbits[code]-7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n*2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n*2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n*2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n*2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES+1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES; n++) {
    static_dtree[n*2 + 1]/*.Len*/ = 5;
    static_dtree[n*2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS+1, L_CODES, MAX_BITS);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
  static_bl_desc =new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);

  //static_init_done = true;
}


/* ===========================================================================
 * Initialize a new block.
 */
function init_block(s) {
  var n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n*2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n*2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n*2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK*2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
function bi_windup(s)
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}

/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
function copy_block(s, buf, len, header)
//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
  bi_windup(s);        /* align on byte boundary */

  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
//  while (len--) {
//    put_byte(s, *buf++);
//  }
  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
function smaller(tree, n, m, depth) {
  var _n2 = n*2;
  var _m2 = m*2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
}

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
function pqdownheap(s, tree, k)
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
  var v = s.heap[k];
  var j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j+1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
}


// inlined manually
// var SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
function compress_block(s, ltree, dtree)
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
  var dist;           /* distance of matched string */
  var lc;             /* match length or unmatched char (if dist == 0) */
  var lx = 0;         /* running index in l_buf */
  var code;           /* the code to send */
  var extra;          /* number of extra bits to send */

  if (s.last_lit !== 0) {
    do {
      dist = (s.pending_buf[s.d_buf + lx*2] << 8) | (s.pending_buf[s.d_buf + lx*2 + 1]);
      lc = s.pending_buf[s.l_buf + lx];
      lx++;

      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code+LITERALS+1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
      //       "pendingBuf overflow");

    } while (lx < s.last_lit);
  }

  send_code(s, END_BLOCK, ltree);
}


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
function build_tree(s, desc)
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
  var tree     = desc.dyn_tree;
  var stree    = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems    = desc.stat_desc.elems;
  var n, m;          /* iterate over heap elements */
  var max_code = -1; /* largest code with non zero frequency */
  var node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n*2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node*2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n*2 + 1]/*.Dad*/ = tree[m*2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
}


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
function scan_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0*2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code+1)*2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n+1)*2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6*2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10*2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138*2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
function send_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0*2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n+1)*2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count-3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count-3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count-11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
function build_bl_tree(s) {
  var max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES-1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex]*2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3*(max_blindex+1) + 5+5+4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
}


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
function send_all_trees(s, lcodes, dcodes, blcodes)
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
  var rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes-257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes-1,   5);
  send_bits(s, blcodes-4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank]*2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes-1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes-1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
function detect_data_type(s) {
  /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  var black_mask = 0xf3ffc07f;
  var n;

  /* Check for non-textual ("black-listed") bytes. */
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if ((black_mask & 1) && (s.dyn_ltree[n*2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("white-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
}


var static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
function _tr_init(s)
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
}


/* ===========================================================================
 * Send a stored block
 */
function _tr_stored_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  send_bits(s, (STORED_BLOCK<<1)+(last ? 1 : 0), 3);    /* send block type */
  copy_block(s, buf, stored_len, true); /* with header */
}


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
function _tr_align(s) {
  send_bits(s, STATIC_TREES<<1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
function _tr_flush_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  var max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len+3+7) >>> 3;
    static_lenb = (s.static_len+3+7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->last_lit));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len+4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES<<1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES<<1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code+1, s.d_desc.max_code+1, max_blindex+1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
}

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
function _tr_tally(s, dist, lc)
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
  //var out_length, in_length, dcode;

  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;

  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc*2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc]+LITERALS+1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility

//#ifdef TRUNCATE_BLOCK
//  /* Try to guess if it is profitable to stop the current block here */
//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
//    /* Compute an upper bound for the compressed length */
//    out_length = s.last_lit*8;
//    in_length = s.strstart - s.block_start;
//
//    for (dcode = 0; dcode < D_CODES; dcode++) {
//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
//    }
//    out_length >>>= 3;
//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
//    //       s->last_lit, in_length, out_length,
//    //       100L - out_length*100L/in_length));
//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
//      return true;
//    }
//  }
//#endif

  return (s.last_lit === s.lit_bufsize-1);
  /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
}

exports._tr_init  = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block  = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;
},{"../utils/common":27}],39:[function(_dereq_,module,exports){
'use strict';


function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

module.exports = ZStream;
},{}]},{},[9])
(9)
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(155).Buffer, __webpack_require__(22)))

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{ "lat": 33.95015879684598, "lng": -118.38337399261604 }, { "lat": 33.952045538566246, "lng": -118.38101364868294 }, { "lat": 33.94923321014263, "lng": -118.38118531005989 }, { "lat": 33.95062158642275, "lng": -118.38436104553352 }, { "lat": 33.95055038819012, "lng": -118.38457562225472 }, { "lat": 33.95008759822619, "lng": -118.38371731536995 }, { "lat": 33.9489484122087, "lng": -118.38436104553352 }, { "lat": 33.948912812399946, "lng": -118.38315941589485 }, { "lat": 33.94791601170923, "lng": -118.38277317779671 }, { "lat": 33.94780921094279, "lng": -118.38504769104134 }, { "lat": 33.947275205100375, "lng": -118.38496186035286 }, { "lat": 33.947844811213166, "lng": -118.38281609314095 }, { "lat": 33.94620807002934, "lng": -118.38163375854492 }, { "lat": 33.94791601170923, "lng": -118.38028408783089 }, { "lat": 33.947382006536884, "lng": -118.37959744232307 }, { "lat": 33.94884161273777, "lng": -118.37925411956917 }, { "lat": 33.94656319209873, "lng": -118.37959744232307 }, { "lat": 33.94898401200255, "lng": -118.3838889767469 }, { "lat": 33.94855681349344, "lng": -118.38569142120491 }, { "lat": 33.94759560900786, "lng": -118.38599182861458 }, { "lat": 33.94681239732684, "lng": -118.38599182861458 }, { "lat": 33.94741760698595, "lng": -118.38710762756477 }, { "lat": 33.948663613321756, "lng": -118.38805176513802 }, { "lat": 33.950585987313865, "lng": -118.3873651196302 }, { "lat": 33.95001639954684, "lng": -118.38461853759895 }, { "lat": 33.95101317563739, "lng": -118.39187123077522 }, { "lat": 33.952045538566246, "lng": -118.39242913025032 }, { "lat": 33.95329147714649, "lng": -118.39131333130013 }, { "lat": 33.953469466883035, "lng": -118.39337326782356 }, { "lat": 33.95183194726365, "lng": -118.39221455352913 }, { "lat": 33.95129796666178, "lng": -118.39298702972542 }, { "lat": 33.94969600475261, "lng": -118.39311577575813 }, { "lat": 33.94973160423374, "lng": -118.39122750061165 }, { "lat": 33.95158275673306, "lng": -118.39122750061165 }, { "lat": 33.95165395410198, "lng": -118.39324452179085 }, { "lat": 33.95197434152495, "lng": -118.39461781280647 }, { "lat": 33.95087077976782, "lng": -118.3943174053968 }, { "lat": 33.95069278459578, "lng": -118.39324452179085 }, { "lat": 33.949446807967625, "lng": -118.39324452179085 }, { "lat": 33.94955360667912, "lng": -118.39066960113655 }, { "lat": 33.94955360667912, "lng": -118.39350201385628 }, { "lat": 33.949446807967625, "lng": -118.39457489746223 }, { "lat": 33.9485212135209, "lng": -118.39290119903694 }, { "lat": 33.950728383659985, "lng": -118.39311577575813 }, { "lat": 33.94966040525659, "lng": -118.39320160644661 }, { "lat": 33.95026559466399, "lng": -118.39101292389046 }, { "lat": 33.94923321014263, "lng": -118.3910558392347 }, { "lat": 33.94880601288436, "lng": -118.38933922546516 }, { "lat": 33.950229995406225, "lng": -118.38912464874397 }, { "lat": 33.95026559466399, "lng": -118.3875796963514 }, { "lat": 33.94926880981735, "lng": -118.38779427307259 }, { "lat": 33.948770413016035, "lng": -118.38878132599007 }, { "lat": 33.949340009122146, "lng": -118.38629223602425 }, { "lat": 33.949802803151385, "lng": -118.38509060638557 }, { "lat": 33.95026559466399, "lng": -118.38689305084358 }, { "lat": 33.950977576692345, "lng": -118.38788010376106 }, { "lat": 33.95129796666178, "lng": -118.38921047943245 }, { "lat": 33.95197434152495, "lng": -118.39002587097298 }, { "lat": 33.95257951447726, "lng": -118.39144207733284 }, { "lat": 33.95257951447726, "lng": -118.39204289215218 }, { "lat": 33.95197434152495, "lng": -118.39238621490608 }, { "lat": 33.95193874298196, "lng": -118.39118458526741 }, { "lat": 33.950906378757544, "lng": -118.39118458526741 }, { "lat": 33.950229995406225, "lng": -118.39217163818489 }, { "lat": 33.95129796666178, "lng": -118.39294411438118 }, { "lat": 33.95183194726365, "lng": -118.39350201385628 }, { "lat": 33.95225912933273, "lng": -118.39281536834847 }, { "lat": 33.95197434152495, "lng": -118.38942505615364 }, { "lat": 33.951404763050185, "lng": -118.38740803497444 }, { "lat": 33.951796348661105, "lng": -118.38586308258186 }, { "lat": 33.95101317563739, "lng": -118.38509060638557 }, { "lat": 33.94994520080792, "lng": -118.38770844238411 }, { "lat": 33.949838402587844, "lng": -118.3838889767469 }, { "lat": 33.950728383659985, "lng": -118.38324524658333 }, { "lat": 33.950443590729506, "lng": -118.38294483917366 }, { "lat": 33.951725151411324, "lng": -118.3813140560926 }, { "lat": 33.95051478905147, "lng": -118.38251568573128 }, { "lat": 33.94987400200944, "lng": -118.38221527832161 }, { "lat": 33.949802803151385, "lng": -118.38307358520638 }, { "lat": 33.95005199889396, "lng": -118.38367440002571 }, { "lat": 33.949197610453, "lng": -118.3818719555677 }, { "lat": 33.949340009122146, "lng": -118.38148571746956 }, { "lat": 33.94880601288436, "lng": -118.38101364868294 }, { "lat": 33.94816521297637, "lng": -118.3829877545179 }, { "lat": 33.949802803151385, "lng": -118.38200070160042 }, { "lat": 33.95126236783584, "lng": -118.38139988678108 }, { "lat": 33.952045538566246, "lng": -118.38088490265022 }, { "lat": 33.95236592451492, "lng": -118.38139988678108 }, { "lat": 33.953469466883035, "lng": -118.38105656402718 }, { "lat": 33.952045538566246, "lng": -118.38071324127327 }, { "lat": 33.95211673554797, "lng": -118.3829877545179 }, { "lat": 33.95233032613576, "lng": -118.38367440002571 }, { "lat": 33.951903144424094, "lng": -118.38367440002571 }, { "lat": 33.95193874298196, "lng": -118.38517643707405 }, { "lat": 33.95101317563739, "lng": -118.38517643707405 }, { "lat": 33.95119117013932, "lng": -118.38779427307259 }, { "lat": 33.95015879684598, "lng": -118.38809468048225 }, { "lat": 33.95055038819012, "lng": -118.383545653993 }, { "lat": 33.9493044094772, "lng": -118.38200070160042 }, { "lat": 33.94759560900786, "lng": -118.38474728363167 }, { "lat": 33.94788041146863, "lng": -118.38277317779671 }, { "lat": 33.95101317563739, "lng": -118.38260151641975 }, { "lat": 33.95101317563739, "lng": -118.38423229950081 }, { "lat": 33.95101317563739, "lng": -118.3859059979261 }, { "lat": 33.94969600475261, "lng": -118.38127114074837 }, { "lat": 33.9485212135209, "lng": -118.38084198730598 }, { "lat": 33.947773610657514, "lng": -118.38071324127327 }, { "lat": 33.94759560900786, "lng": -118.3829877545179 }, { "lat": 33.94962480574566, "lng": -118.38268734710823 }, { "lat": 33.95051478905147, "lng": -118.38058449524056 }, { "lat": 33.95222353090888, "lng": -118.3804128338636 }, { "lat": 33.95222353090888, "lng": -118.38268734710823 }, { "lat": 33.95211673554797, "lng": -118.38474728363167 }, { "lat": 33.952806053495124, "lng": -118.38545549359355 }, { "lat": 33.951796348661105, "lng": -118.38560559051643 }, { "lat": 33.95161835542496, "lng": -118.3868072201551 }, { "lat": 33.95094197773239, "lng": -118.38607765930306 }, { "lat": 33.95015879684598, "lng": -118.38418938415657 }, { "lat": 33.949340009122146, "lng": -118.38637806671272 }, { "lat": 33.949446807967625, "lng": -118.3868072201551 }, { "lat": 33.94966040525659, "lng": -118.38539101379524 }, { "lat": 33.949019611781516, "lng": -118.3855626751722 }, { "lat": 33.948343213434775, "lng": -118.38564850586067 }, { "lat": 33.947987212145726, "lng": -118.38526226776253 }, { "lat": 33.947666809712416, "lng": -118.3850047756971 }, { "lat": 33.947666809712416, "lng": -118.38376023071419 }, { "lat": 33.94791601170923, "lng": -118.38350273864876 }, { "lat": 33.94791601170923, "lng": -118.38401772277962 }, { "lat": 33.94958920621982, "lng": -118.38393189209114 }, { "lat": 33.95030119390689, "lng": -118.38466145294319 }, { "lat": 33.951475960568025, "lng": -118.38466145294319 }, { "lat": 33.95272190748764, "lng": -118.38401772277962 }, { "lat": 33.9533982710331, "lng": -118.38453270691048 }, { "lat": 33.95259776376292, "lng": -118.38407136367044 }, { "lat": 33.95289144902278, "lng": -118.38381387160501 }, { "lat": 33.95262446246478, "lng": -118.38337398932657 }, { "lat": 33.952375274254905, "lng": -118.38310576842508 }, { "lat": 33.952232880664496, "lng": -118.38365293906412 }, { "lat": 33.95158320688475, "lng": -118.38471509383402 }, { "lat": 33.9514497116582, "lng": -118.38544465468607 }, { "lat": 33.951227219148585, "lng": -118.38540173934183 }, { "lat": 33.95125391828045, "lng": -118.38488675521097 }, { "lat": 33.95112042253735, "lng": -118.38488675521097 }, { "lat": 33.95078223238426, "lng": -118.3853051798173 }, { "lat": 33.95047074026479, "lng": -118.38500477240763 }, { "lat": 33.950105848046235, "lng": -118.38539101050577 }, { "lat": 33.94981215317294, "lng": -118.38499404357157 }, { "lat": 33.950417341501264, "lng": -118.38421083853922 }, { "lat": 33.951701064629795, "lng": -118.37983617766628 }, { "lat": 33.95187905769295, "lng": -118.38155279143581 }, { "lat": 33.95187905769295, "lng": -118.38069448455104 }, { "lat": 33.95173666327221, "lng": -118.38069448455104 }, { "lat": 33.95173666327221, "lng": -118.38069448455104 }, { "lat": 33.95175257575516, "lng": -118.38109744751085 }, { "lat": 33.952217243487226, "lng": -118.38108072264919 }, { "lat": 33.95235946069179, "lng": -118.38949130462771 }, { "lat": 33.95235946069179, "lng": -118.39095042633181 }, { "lat": 33.951149107353636, "lng": -118.39034961151248 }, { "lat": 33.95157629285044, "lng": -118.38871882843142 }, { "lat": 33.952003476202854, "lng": -118.38931964325076 }, { "lat": 33.95228826391313, "lng": -118.38871882843142 }, { "lat": 33.95171868753948, "lng": -118.39249537872439 }, { "lat": 33.9503659283734, "lng": -118.39232371734744 }, { "lat": 33.9503659283734, "lng": -118.38931964325076 }, { "lat": 33.949653941227915, "lng": -118.38923381256228 }, { "lat": 33.94858594934133, "lng": -118.3888046591199 }, { "lat": 33.948016348188595, "lng": -118.38906215118533 }, { "lat": 33.949369144701905, "lng": -118.38683055328494 }, { "lat": 33.94872834903387, "lng": -118.3858864157117 }, { "lat": 33.9503659283734, "lng": -118.38502810882693 }, { "lat": 33.9503659283734, "lng": -118.38597224640017 }, { "lat": 33.9503659283734, "lng": -118.38614390777713 }, { "lat": 33.95072191971242, "lng": -118.38674472259646 }, { "lat": 33.95122030508533, "lng": -118.38451312469607 }, { "lat": 33.95122030508533, "lng": -118.38391230987673 }, { "lat": 33.95157629285044, "lng": -118.38519977020388 }, { "lat": 33.9518610819903, "lng": -118.38648723053103 }, { "lat": 33.9518610819903, "lng": -118.38931964325076 }, { "lat": 33.951647490224744, "lng": -118.3913795797742 }, { "lat": 33.95228826391313, "lng": -118.39198039459353 }, { "lat": 33.951932279126346, "lng": -118.39275287078982 }, { "lat": 33.951433897923096, "lng": -118.39275287078982 }, { "lat": 33.95136270037007, "lng": -118.39189456390505 }, { "lat": 33.94972514021051, "lng": -118.39343951629763 }, { "lat": 33.949653941227915, "lng": -118.3928387014783 }, { "lat": 33.949938736800895, "lng": -118.39223788665896 }, { "lat": 33.94908434722288, "lng": -118.38897632049685 }, { "lat": 33.950935513801085, "lng": -118.38777469085818 }, { "lat": 33.950935513801085, "lng": -118.38597224640017 }, { "lat": 33.95022353142083, "lng": -118.38356898712283 }, { "lat": 33.95136270037007, "lng": -118.3807365744031 }, { "lat": 33.951505095416536, "lng": -118.38228152679568 }, { "lat": 33.95178988479469, "lng": -118.38322566436892 }, { "lat": 33.9512915027575, "lng": -118.38451312469607 }, { "lat": 33.95008113422998, "lng": -118.38451312469607 }, { "lat": 33.94986753799699, "lng": -118.38562892364627 }, { "lat": 33.949511543084036, "lng": -118.3851139395154 }, { "lat": 33.94872834903387, "lng": -118.38528560089236 }, { "lat": 33.94872834903387, "lng": -118.38434146331912 }, { "lat": 33.949013147704214, "lng": -118.38356898712283 }, { "lat": 33.948941948125956, "lng": -118.38202403473025 }, { "lat": 33.94858594934133, "lng": -118.38099406646853 }, { "lat": 33.94822994906762, "lng": -118.38065074371463 }, { "lat": 33.948016348188595, "lng": -118.38399814056521 }, { "lat": 33.948087548541174, "lng": -118.38562892364627 }, { "lat": 33.94794514777647, "lng": -118.38743136810427 }, { "lat": 33.948016348188595, "lng": -118.38854716705447 }, { "lat": 33.95000993554523, "lng": -118.38416980194216 }, { "lat": 33.9512915027575, "lng": -118.38176654266482 }, { "lat": 33.952217067074905, "lng": -118.38090823578005 }, { "lat": 33.95250185407037, "lng": -118.38056491302615 }, { "lat": 33.9508643158311, "lng": -118.38056491302615 }, { "lat": 33.94944034392277, "lng": -118.38056491302615 }, { "lat": 33.94822994906762, "lng": -118.38047908233767 }, { "lat": 33.94872834903387, "lng": -118.38193820404177 }, { "lat": 33.94766034553234, "lng": -118.38339732574588 }, { "lat": 33.94780274677354, "lng": -118.38468478607302 }, { "lat": 33.9487995487908, "lng": -118.38502810882693 }, { "lat": 33.94858594934133, "lng": -118.38863299774295 }, { "lat": 33.948016348188595, "lng": -118.38871882843142 }, { "lat": 33.95043712676034, "lng": -118.38871882843142 }, { "lat": 33.95043712676034, "lng": -118.38176654266482 }, { "lat": 33.949262345758946, "lng": -118.39348243164187 }, { "lat": 33.94872834903387, "lng": -118.39249537872439 }, { "lat": 33.95022353142083, "lng": -118.39185164856082 }, { "lat": 33.949369144701905, "lng": -118.39099334167605 }, { "lat": 33.949262345758946, "lng": -118.3897058813489 }, { "lat": 33.948835148646936, "lng": -118.3897058813489 }, { "lat": 33.94822994906762, "lng": -118.38974879669314 }, { "lat": 33.94780274677354, "lng": -118.38901923584109 }, { "lat": 33.949511543084036, "lng": -118.3888046591199 }, { "lat": 33.949511543084036, "lng": -118.3888046591199 }, { "lat": 33.94986753799699, "lng": -118.38904069351321 }, { "lat": 33.949885337703535, "lng": -118.38801072525149 }, { "lat": 33.950490525511455, "lng": -118.38582204269534 }, { "lat": 33.95120250565799, "lng": -118.38637994217044 }, { "lat": 33.951629690886755, "lng": -118.38788197921878 }, { "lat": 33.95227046470916, "lng": -118.38912652420169 }, { "lat": 33.95251965322594, "lng": -118.39187310623294 }, { "lat": 33.95287563555558, "lng": -118.39303182052737 }, { "lat": 33.9533740083152, "lng": -118.3927314131177 }, { "lat": 33.952306063113355, "lng": -118.38427709030276 }, { "lat": 33.951344900972515, "lng": -118.38453458236819 }, { "lat": 33.951344900972515, "lng": -118.38363336013919 }, { "lat": 33.94995653649256, "lng": -118.38247464584475 }, { "lat": 33.95027693030596, "lng": -118.38195966171389 }, { "lat": 33.94920894623723, "lng": -118.38153050827151 }, { "lat": 33.948746148978685, "lng": -118.38054345535403 }, { "lat": 33.95002773522199, "lng": -118.38058637069827 }, { "lat": 33.9506685211065, "lng": -118.38801072525149 }, { "lat": 33.95013453320447, "lng": -118.38912652420169 }, { "lat": 33.95024133105293, "lng": -118.38852570938235 }, { "lat": 33.948941948125956, "lng": -118.39088605331546 }, { "lat": 33.94920894623723, "lng": -118.39101479934817 }, { "lat": 33.949386944512725, "lng": -118.3899204580701 }, { "lat": 33.94917334653745, "lng": -118.38946984695559 }, { "lat": 33.948746148978685, "lng": -118.389362558595 }, { "lat": 33.94945814371868, "lng": -118.3895985929883 }, { "lat": 33.94992093710552, "lng": -118.39056418823367 }, { "lat": 33.95045492634776, "lng": -118.39049981521731 }, { "lat": 33.950063334564376, "lng": -118.39159415649539 }, { "lat": 33.94974293994685, "lng": -118.38998483108645 }, { "lat": 33.949030947589456, "lng": -118.38964150833255 }, { "lat": 33.94826554916199, "lng": -118.3898131697095 }, { "lat": 33.94846134941492, "lng": -118.38893340515261 }, { "lat": 33.94846134941492, "lng": -118.38826821731692 }, { "lat": 33.94821214901484, "lng": -118.3866803495801 }, { "lat": 33.94846134941492, "lng": -118.38605807708865 }, { "lat": 33.94773154618272, "lng": -118.38575766967898 }, { "lat": 33.94753574425084, "lng": -118.38528560089236 }, { "lat": 33.947464543436666, "lng": -118.38698075698977 }, { "lat": 33.94760694500546, "lng": -118.38852570938235 }, { "lat": 33.94760694500546, "lng": -118.38934110092288 }, { "lat": 33.94812314869511, "lng": -118.38983462738162 }, { "lat": 33.94895974802611, "lng": -118.38921235489016 }, { "lat": 33.94977853940835, "lng": -118.38977025436526 }, { "lat": 33.950383727975726, "lng": -118.39142249511843 }, { "lat": 33.94976073967946, "lng": -118.39178727554446 }, { "lat": 33.9503125295441, "lng": -118.39268849777346 }, { "lat": 33.9503125295441, "lng": -118.39341805862551 }, { "lat": 33.95079311780154, "lng": -118.39346097396975 }, { "lat": 33.95196787767205, "lng": -118.39350388931399 }, { "lat": 33.9526620463365, "lng": -118.39380429672366 }, { "lat": 33.9533740083152, "lng": -118.3936326353467 }, { "lat": 33.9533740083152, "lng": -118.39215205597048 }, { "lat": 33.952715443691524, "lng": -118.3913795797742 }, { "lat": 33.95342740522349, "lng": -118.39208768295413 }, { "lat": 33.95191447984793, "lng": -118.38951276229983 }, { "lat": 33.9526620463365, "lng": -118.39000628875857 }, { "lat": 33.9526620463365, "lng": -118.38940547393923 }, { "lat": 33.95187888127989, "lng": -118.38957713531619 }, { "lat": 33.951700888216386, "lng": -118.38996337341433 }, { "lat": 33.950935513801085, "lng": -118.38919089721804 }, { "lat": 33.95029472992689, "lng": -118.38983462738162 }, { "lat": 33.9485147494057, "lng": -118.38852570938235 }, { "lat": 33.9488529485694, "lng": -118.38968442367678 }, { "lat": 33.94871054908535, "lng": -118.38983462738162 }, { "lat": 33.94819434895833, "lng": -118.3898131697095 }, { "lat": 33.94760694500546, "lng": -118.38989900039797 }, { "lat": 33.948746148978685, "lng": -118.38590787338381 }, { "lat": 33.94876394891978, "lng": -118.38545726226931 }, { "lat": 33.94864957966589, "lng": -118.37954655180681 }, { "lat": 33.94765277589217, "lng": -118.37958946715105 }, { "lat": 33.95082114746542, "lng": -118.37984695921648 }, { "lat": 33.95074994939976, "lng": -118.38186398039568 }, { "lat": 33.95349103192817, "lng": -118.37967529783953 }, { "lat": 33.95302825795603, "lng": -118.38194981108416 }, { "lat": 33.9513195322572, "lng": -118.38156357298601 }, { "lat": 33.95124833460849, "lng": -118.38396683226335 }, { "lat": 33.95071435034458, "lng": -118.38302269469011 }, { "lat": 33.95231629308452, "lng": -118.38778629790056 }, { "lat": 33.95302825795603, "lng": -118.3901895571779 }, { "lat": 33.95217389939541, "lng": -118.38958874235857 }, { "lat": 33.95171111826029, "lng": -118.38791504393328 }, { "lat": 33.95067875127453, "lng": -118.38830128203142 }, { "lat": 33.95078554844002, "lng": -118.3901895571779 }, { "lat": 33.949717570754, "lng": -118.38950291167009 }, { "lat": 33.95071435034458, "lng": -118.38778629790056 }, { "lat": 33.950073564805145, "lng": -118.38701382170427 }, { "lat": 33.9493259755778, "lng": -118.38778629790056 }, { "lat": 33.949575172716585, "lng": -118.38821545134294 }, { "lat": 33.95071435034458, "lng": -118.38791504393328 }, { "lat": 33.95078554844002, "lng": -118.39027538786638 }, { "lat": 33.95035835897388, "lng": -118.38971748839128 }, { "lat": 33.95078554844002, "lng": -118.38976040373552 }, { "lat": 33.95082114746542, "lng": -118.38924541960466 }, { "lat": 33.95082114746542, "lng": -118.38830128203142 }, { "lat": 33.95046515654144, "lng": -118.38830128203142 }, { "lat": 33.9493259755778, "lng": -118.38877335081804 }, { "lat": 33.94875637937778, "lng": -118.38821545134294 }, { "lat": 33.94790197793008, "lng": -118.38825836668718 }, { "lat": 33.94985996855315, "lng": -118.38993206511248 }, { "lat": 33.95064315218956, "lng": -118.38825836668718 }, { "lat": 33.951141538023755, "lng": -118.38971748839128 }, { "lat": 33.95021596200864, "lng": -118.389846234424 }, { "lat": 33.950287160521036, "lng": -118.39048996458757 }, { "lat": 33.95149752611834, "lng": -118.38808670531023 }, { "lat": 33.95146192737591, "lng": -118.38898792753923 }, { "lat": 33.95124833460849, "lng": -118.39066162596453 }, { "lat": 33.95057195397501, "lng": -118.39010372648943 }, { "lat": 33.95071435034458, "lng": -118.38997498045671 }, { "lat": 33.95074994939976, "lng": -118.39023247252214 }, { "lat": 33.950999142368964, "lng": -118.38847294340837 }, { "lat": 33.9513195322572, "lng": -118.38851585875261 }, { "lat": 33.950999142368964, "lng": -118.38765755186785 }, { "lat": 33.95096354341804, "lng": -118.38770046721208 }, { "lat": 33.95078554844002, "lng": -118.3872713137697 }, { "lat": 33.95046515654144, "lng": -118.38825836668718 }, { "lat": 33.950393958177955, "lng": -118.39323654661882 }, { "lat": 33.94993116736339, "lng": -118.39280739317644 }, { "lat": 33.95014476343667, "lng": -118.39203491698015 }, { "lat": 33.95000236611404, "lng": -118.39169159422624 }, { "lat": 33.949717570754, "lng": -118.39057579527605 }, { "lat": 33.94907677770937, "lng": -118.39001789580095 }, { "lat": 33.9491479771748, "lng": -118.38971748839128 }, { "lat": 33.94879197925198, "lng": -118.38967457304705 }, { "lat": 33.94879197925198, "lng": -118.3892883349489 }, { "lat": 33.94850717984156, "lng": -118.38847294340837 }, { "lat": 33.94968197126698, "lng": -118.38774338255632 }, { "lat": 33.94993116736339, "lng": -118.38731422911394 }, { "lat": 33.95078554844002, "lng": -118.38804378996599 }, { "lat": 33.95085674647591, "lng": -118.38731422911394 }, { "lat": 33.95146192737591, "lng": -118.38933125029314 }, { "lat": 33.95153312484591, "lng": -118.38988914976824 }, { "lat": 33.951639920939215, "lng": -118.39006081114519 }, { "lat": 33.95188911130241, "lng": -118.39083328734148 }, { "lat": 33.95224509626976, "lng": -118.39173450957048 }, { "lat": 33.95238748983972, "lng": -118.39182034025896 }, { "lat": 33.95249428486085, "lng": -118.3929790545534 }, { "lat": 33.95270787450098, "lng": -118.39336529265154 }, { "lat": 33.95196030841502, "lng": -118.39336529265154 }, { "lat": 33.95071435034458, "lng": -118.39319363127458 }, { "lat": 33.95003796546704, "lng": -118.39379444609392 }, { "lat": 33.94993116736339, "lng": -118.3944381762575 }, { "lat": 33.949753170226124, "lng": -118.39263573179949 }, { "lat": 33.94989556796571, "lng": -118.39057579527605 }, { "lat": 33.94904117795433, "lng": -118.38933125029314 }, { "lat": 33.94786637768363, "lng": -118.38731422911394 }, { "lat": 33.947723976548886, "lng": -118.38551178465593 }, { "lat": 33.94775957685491, "lng": -118.38439598570574 }, { "lat": 33.947723976548886, "lng": -118.38306561003435 }, { "lat": 33.947474773989796, "lng": -118.38220730314958 }, { "lat": 33.94840037981694, "lng": -118.3823360491823 }, { "lat": 33.94946837403217, "lng": -118.38388100157488 }, { "lat": 33.95000236611404, "lng": -118.38207855711687 }, { "lat": 33.94900557818437, "lng": -118.38083401213396 }, { "lat": 33.94968197126698, "lng": -118.38074818144548 }, { "lat": 33.94989556796571, "lng": -118.38061943541277 }, { "lat": 33.95060755308974, "lng": -118.38293686400164 }, { "lat": 33.95107034022616, "lng": -118.38431015501726 }, { "lat": 33.95245868653537, "lng": -118.38461056242693 }, { "lat": 33.95252988317144, "lng": -118.3832372714113 }, { "lat": 33.952601079747936, "lng": -118.38684216032732 }, { "lat": 33.95256548146712, "lng": -118.38877335081804 }, { "lat": 33.952992659853905, "lng": -118.3892883349489 }, { "lat": 33.95245868653537, "lng": -118.39061871062029 }, { "lat": 33.95217389939541, "lng": -118.38585510740984 }, { "lat": 33.95242308819498, "lng": -118.3849109698366 }, { "lat": 33.95156872355857, "lng": -118.38353767882097 }, { "lat": 33.95071435034458, "lng": -118.38190689573992 }, { "lat": 33.950287160521036, "lng": -118.38139191160906 }, { "lat": 33.950287160521036, "lng": -118.38220730314958 }, { "lat": 33.95021596200864, "lng": -118.38508263121355 }, { "lat": 33.95067875127453, "lng": -118.38684216032732 }, { "lat": 33.950429557367166, "lng": -118.38697090636003 }, { "lat": 33.94953957317001, "lng": -118.38765755186785 }, { "lat": 33.94953957317001, "lng": -118.38885918150652 }, { "lat": 33.94953957317001, "lng": -118.38667049895037 }, { "lat": 33.94900557818437, "lng": -118.38340893278826 }, { "lat": 33.94754597479542, "lng": -118.38027611265886 }, { "lat": 33.949575172716585, "lng": -118.38229313383806 }, { "lat": 33.9511059391324, "lng": -118.38503971586931 }, { "lat": 33.95050075570085, "lng": -118.38821545134294 }, { "lat": 33.95107034022616, "lng": -118.38937416563738 }, { "lat": 33.95285026729659, "lng": -118.39203491698015 }, { "lat": 33.95276127182726, "lng": -118.39399337768555 }, { "lat": 33.9522806946846, "lng": -118.39259281645525 }, { "lat": 33.95199590694898, "lng": -118.38993206511248 }, { "lat": 33.95117713690023, "lng": -118.38971748839128 }, { "lat": 33.95064315218956, "lng": -118.38851585875261 }, { "lat": 33.95021596200864, "lng": -118.38864460478533 }, { "lat": 33.949361575213736, "lng": -118.39147701750505 }, { "lat": 33.94843597984004, "lng": -118.39091911802996 }, { "lat": 33.94868517958475, "lng": -118.38907375822771 }, { "lat": 33.94697636668272, "lng": -118.38851585875261 }, { "lat": 33.9473116922476, "lng": -118.38652029524553 }, { "lat": 33.94804437876699, "lng": -118.38585510740984 }, { "lat": 33.9503227597549, "lng": -118.3878292132448 }, { "lat": 33.95050075570085, "lng": -118.38340893278826 }, { "lat": 33.952102702461524, "lng": -118.38396683226335 }, { "lat": 33.952102702461524, "lng": -118.38130608092058 }, { "lat": 33.95089234547151, "lng": -118.38130608092058 }, { "lat": 33.95085674647591, "lng": -118.38070526610124 }, { "lat": 33.95171111826029, "lng": -118.37967529783953 }, { "lat": 33.95180011482789, "lng": -118.37996006011963 }, { "lat": 33.95206710397223, "lng": -118.38044777403582 }, { "lat": 33.95256548146712, "lng": -118.38044777403582 }, { "lat": 33.953313042236715, "lng": -118.38134899626482 }, { "lat": 33.95245868653537, "lng": -118.38225021849382 }, { "lat": 33.95192470986617, "lng": -118.38632717619646 }, { "lat": 33.95139072984634, "lng": -118.38413849364031 }, { "lat": 33.950999142368964, "lng": -118.38229313383806 }, { "lat": 33.950429557367166, "lng": -118.38212147246111 }, { "lat": 33.95053635484538, "lng": -118.38585510740984 }, { "lat": 33.95053635484538, "lng": -118.38722839842546 }, { "lat": 33.95199590694898, "lng": -118.3887304354738 }, { "lat": 33.95156872355857, "lng": -118.3883871127199 }, { "lat": 33.95146192737591, "lng": -118.38860168944109 }, { "lat": 33.951034741305, "lng": -118.38701382170427 }, { "lat": 33.95085674647591, "lng": -118.38624134550798 }, { "lat": 33.95053635484538, "lng": -118.38576927672136 }, { "lat": 33.949290375927, "lng": -118.38761463652361 }, { "lat": 33.94900557818437, "lng": -118.388945012195 }, { "lat": 33.948364779778956, "lng": -118.38890209685076 }, { "lat": 33.94765277589217, "lng": -118.38679924498308 }, { "lat": 33.94715436962742, "lng": -118.38499680052507 }, { "lat": 33.94620807002934, "lng": -118.38163375854492 }, { "lat": 33.9470831684942, "lng": -118.38096275816667 }, { "lat": 33.946691561196864, "lng": -118.38010445128191 }, { "lat": 33.94620807002934, "lng": -118.38163375854492 }, { "lat": 33.94620807002934, "lng": -118.38163375854492 }, { "lat": 33.94968197126698, "lng": -118.38057652006853 }, { "lat": 33.950393958177955, "lng": -118.38074818144548 }, { "lat": 33.95053635484538, "lng": -118.38160648833025 }, { "lat": 33.9511059391324, "lng": -118.38293686400164 }, { "lat": 33.95139072984634, "lng": -118.38439598570574 }, { "lat": 33.9503227597549, "lng": -118.38594093809832 }, { "lat": 33.95046515654144, "lng": -118.3874858904909 }, { "lat": 33.95046515654144, "lng": -118.38877335081804 }, { "lat": 33.950429557367166, "lng": -118.38877335081804 }, { "lat": 33.950429557367166, "lng": -118.38943853865374 }, { "lat": 33.95062535264151, "lng": -118.38712111006487 }, { "lat": 33.949788769683344, "lng": -118.38742151747454 }, { "lat": 33.94996676674616, "lng": -118.38879480849016 }, { "lat": 33.95073214987404, "lng": -118.38619843016374 }, { "lat": 33.950447356956154, "lng": -118.38553324232805 }, { "lat": 33.95035835897388, "lng": -118.38478222380388 }, { "lat": 33.950269360898524, "lng": -118.38231459151018 }, { "lat": 33.94948617382223, "lng": -118.38130608092058 }, { "lat": 33.948952178501536, "lng": -118.38083401213396 }, { "lat": 33.9485605798036, "lng": -118.38034048567522 }, { "lat": 33.948293579658326, "lng": -118.3804263163637 }, { "lat": 33.94799097848107, "lng": -118.38010445128191 }, { "lat": 33.94795537827185, "lng": -118.38029757033098 }, { "lat": 33.94795537827185, "lng": -118.38072672377336 }, { "lat": 33.94824017952874, "lng": -118.38094130049456 }, { "lat": 33.94824017952874, "lng": -118.38113441954363 }, { "lat": 33.94806217885485, "lng": -118.38118806372393 }, { "lat": 33.94799097848107, "lng": -118.38141336928118 }, { "lat": 33.948996678239546, "lng": -118.3819390822481 }, { "lat": 33.94965527164195, "lng": -118.38215365896929 }, { "lat": 33.9498688684077, "lng": -118.38243260870684 }, { "lat": 33.95068765104343, "lng": -118.3818317938875 }, { "lat": 33.95093684419508, "lng": -118.38256135473955 }, { "lat": 33.95122163547487, "lng": -118.38333383093584 }, { "lat": 33.9519692080499, "lng": -118.38307633887041 }, { "lat": 33.951648820607616, "lng": -118.38168159018267 }, { "lat": 33.95214720055218, "lng": -118.381381182773 }, { "lat": 33.952253995874855, "lng": -118.38269010077227 }, { "lat": 33.95193360950477, "lng": -118.38324800024736 }, { "lat": 33.95111483885665, "lng": -118.38301196585405 }, { "lat": 33.95104364103668, "lng": -118.38468566427935 }, { "lat": 33.95148862643412, "lng": -118.38481441031206 }, { "lat": 33.95170221859842, "lng": -118.38535085211504 }, { "lat": 33.95278797047784, "lng": -118.3892346907686 }, { "lat": 33.95252098359518, "lng": -118.38921323309648 }, { "lat": 33.952681175825276, "lng": -118.38904157171953 }, { "lat": 33.95296596126756, "lng": -118.38927760611284 }, { "lat": 33.95300155938083, "lng": -118.38876262198198 }, { "lat": 33.952218397448874, "lng": -118.38861241827715 }, { "lat": 33.951898010944745, "lng": -118.38601603995073 }, { "lat": 33.95154202452545, "lng": -118.38582292090166 }, { "lat": 33.95154202452545, "lng": -118.38578000555742 }, { "lat": 33.951061440497256, "lng": -118.38492169867266 }, { "lat": 33.95097244315717, "lng": -118.38513627539385 }, { "lat": 33.950830047219426, "lng": -118.38412776480425 }, { "lat": 33.9512038360478, "lng": -118.38421359549272 }, { "lat": 33.9512038360478, "lng": -118.38320508490312 }, { "lat": 33.95207600359595, "lng": -118.38271155844438 }, { "lat": 33.95129283314591, "lng": -118.38305488119829 }, { "lat": 33.9511682371825, "lng": -118.38404193411577 }, { "lat": 33.95122163547487, "lng": -118.3849646140169 }, { "lat": 33.95036725877629, "lng": -118.38515773306597 }, { "lat": 33.950189262551135, "lng": -118.38547959814775 }, { "lat": 33.94992226751536, "lng": -118.38571563254106 }, { "lat": 33.9498688684077, "lng": -118.38588729391802 }, { "lat": 33.9498688684077, "lng": -118.38588729391802 }, { "lat": 33.94949507371583, "lng": -118.38625207434404 }, { "lat": 33.949281476011976, "lng": -118.38612332831133 }, { "lat": 33.9491568771038, "lng": -118.38603749762285 }, { "lat": 33.948996678239546, "lng": -118.38584437857378 }, { "lat": 33.94869407956214, "lng": -118.3857585478853 }, { "lat": 33.94881867914785, "lng": -118.38605895529497 }, { "lat": 33.94881867914785, "lng": -118.38532939444292 }, { "lat": 33.94881867914785, "lng": -118.38477149496782 }, { "lat": 33.949067877772, "lng": -118.38453546057451 }, { "lat": 33.949067877772, "lng": -118.38378444205034 }, { "lat": 33.94856947979402, "lng": -118.38344111929644 }, { "lat": 33.94851607983756, "lng": -118.38269010077227 }, { "lat": 33.94808887897969, "lng": -118.38266864310015 }, { "lat": 33.94805327881141, "lng": -118.38191762457598 }, { "lat": 33.947946478217204, "lng": -118.38215365896929 }, { "lat": 33.94791087798938, "lng": -118.38335528860796 }, { "lat": 33.947715076470075, "lng": -118.38427796850908 }, { "lat": 33.94753707469798, "lng": -118.38494315634478 }, { "lat": 33.947608275451486, "lng": -118.38524356375444 }, { "lat": 33.9478574776197, "lng": -118.38562980185259 }, { "lat": 33.94766167597752, "lng": -118.38578000555742 }, { "lat": 33.94743027345604, "lng": -118.38582292090166 }, { "lat": 33.94755487489194, "lng": -118.38410630713213 }, { "lat": 33.94755487489194, "lng": -118.38281884680498 }, { "lat": 33.947786277074655, "lng": -118.38144555578936 }, { "lat": 33.947893077869864, "lng": -118.38045850287187 }, { "lat": 33.948017678628226, "lng": -118.38063016424883 }, { "lat": 33.948213479451404, "lng": -118.38063016424883 }, { "lat": 33.94871187951412, "lng": -118.38110223303545 }, { "lat": 33.949281476011976, "lng": -118.38129535208452 }, { "lat": 33.950100264298946, "lng": -118.38075891028154 }, { "lat": 33.95024266145776, "lng": -118.38030829916704 }, { "lat": 33.94940607473771, "lng": -118.3807159949373 }, { "lat": 33.949192476810474, "lng": -118.38043704519976 }, { "lat": 33.94878307928481, "lng": -118.3803726721834 }, { "lat": 33.948587279772056, "lng": -118.38020101080645 }, { "lat": 33.94837367978985, "lng": -118.38017955313433 }, { "lat": 33.94812447913307, "lng": -118.38022246847856 }, { "lat": 33.95058085375508, "lng": -118.3802653838228 }, { "lat": 33.95014476343667, "lng": -118.38006153593767 }, { "lat": 33.95052745506063, "lng": -118.38008299360979 }, { "lat": 33.95058085375508, "lng": -118.38027611265886 }, { "lat": 33.95080334795458, "lng": -118.38058724890459 }, { "lat": 33.950999142368964, "lng": -118.38056579123247 }, { "lat": 33.95101694183885, "lng": -118.38099494467485 }, { "lat": 33.95117713690023, "lng": -118.38137045393694 }, { "lat": 33.95101694183885, "lng": -118.3814884711336 }, { "lat": 33.950874545975566, "lng": -118.38141336928118 }, { "lat": 33.950910144963714, "lng": -118.3818854380678 }, { "lat": 33.9511059391324, "lng": -118.38227167616594 }, { "lat": 33.95071435034458, "lng": -118.38276520262468 }, { "lat": 33.95062535264151, "lng": -118.3827866602968 }, { "lat": 33.950669851504664, "lng": -118.38285103331316 }, { "lat": 33.95085674647591, "lng": -118.38348403464067 }, { "lat": 33.95092794445223, "lng": -118.38321581373918 }, { "lat": 33.95089234547151, "lng": -118.38367715368975 }, { "lat": 33.950741049637365, "lng": -118.38355913649309 }, { "lat": 33.95058085375508, "lng": -118.38361278067339 }, { "lat": 33.95059865331244, "lng": -118.3837415267061 }, { "lat": 33.950429557367166, "lng": -118.38373079787004 }, { "lat": 33.9502960603309, "lng": -118.38314071188677 }, { "lat": 33.94960187236676, "lng": -118.38166013251055 }, { "lat": 33.94949507371583, "lng": -118.38149919996965 }, { "lat": 33.94955737294515, "lng": -118.38144555578936 }, { "lat": 33.949317075666514, "lng": -118.38119879255999 }, { "lat": 33.94923697642284, "lng": -118.3808769274782 }, { "lat": 33.949317075666514, "lng": -118.38088765631426 }, { "lat": 33.949192476810474, "lng": -118.38070526610124 }, { "lat": 33.94922807650224, "lng": -118.38070526610124 }, { "lat": 33.94913017731403, "lng": -118.38057652006853 }, { "lat": 33.949312625710505, "lng": -118.38059261332262 }, { "lat": 33.94965082170362, "lng": -118.38009908686388 }, { "lat": 33.949481723875046, "lng": -118.38009908686388 }, { "lat": 33.949214726619566, "lng": -118.38009908686388 }, { "lat": 33.94888542885087, "lng": -118.38009908686388 }, { "lat": 33.94803992874447, "lng": -118.38010981569994 }, { "lat": 33.94802212865195, "lng": -118.38026001940477 }, { "lat": 33.947105418854754, "lng": -118.37999179850328 }, { "lat": 33.947320592368605, "lng": -118.38020101080645 }, { "lat": 33.947461423832124, "lng": -118.38027074824083 }, { "lat": 33.947692826268906, "lng": -118.38104322443712 }, { "lat": 33.94758602522241, "lng": -118.38149383555162 }, { "lat": 33.94805772883324, "lng": -118.38149383555162 }, { "lat": 33.94834252974765, "lng": -118.38106468210924 }, { "lat": 33.948262429586805, "lng": -118.3820302773546 }, { "lat": 33.948066628876255, "lng": -118.38198736201036 }, { "lat": 33.94763942576241, "lng": -118.38190153132189 }, { "lat": 33.94777292696584, "lng": -118.38132217417467 }, { "lat": 33.94833362973351, "lng": -118.38153675089586 }, { "lat": 33.94852052983519, "lng": -118.38271692286241 }, { "lat": 33.94852052983519, "lng": -118.38287785540331 }, { "lat": 33.948600629753145, "lng": -118.38310316096056 }, { "lat": 33.94853832982349, "lng": -118.38341429720629 }, { "lat": 33.94941942459035, "lng": -118.38362887392748 }, { "lat": 33.94941942459035, "lng": -118.38417604456652 }, { "lat": 33.949312625710505, "lng": -118.3839936543535 }, { "lat": 33.94918802684795, "lng": -118.38413312922228 }, { "lat": 33.95103919117096, "lng": -118.38284566889513 }, { "lat": 33.951181586758736, "lng": -118.38315680514086 }, { "lat": 33.94950842355453, "lng": -118.38086083422411 }, { "lat": 33.94957962265886, "lng": -118.38137581835497 }, { "lat": 33.949481723875046, "lng": -118.38137581835497 }, { "lat": 33.94964192182627, "lng": -118.38075354586351 }, { "lat": 33.94965082170362, "lng": -118.38026001940477 }, { "lat": 33.94984661876959, "lng": -118.38027074824083 }, { "lat": 33.94938382497864, "lng": -118.38077500353563 }, { "lat": 33.949437224390635, "lng": -118.38159039507616 }, { "lat": 33.94974872029291, "lng": -118.38164403925646 }, { "lat": 33.94973982042582, "lng": -118.3822448540758 }, { "lat": 33.95197365786699, "lng": -118.38641837130297 }, { "lat": 33.9519291596856, "lng": -118.38678315172899 }, { "lat": 33.95183126360456, "lng": -118.38660076151598 }, { "lat": 33.9519825575005, "lng": -118.3859570313524 }, { "lat": 33.95099469250091, "lng": -118.3860106755327 }, { "lat": 33.95088789559786, "lng": -118.38653638849962 }, { "lat": 33.95052300516792, "lng": -118.38619306574572 }, { "lat": 33.95046070664547, "lng": -118.38669732104051 }, { "lat": 33.950398408077426, "lng": -118.38716938982714 }, { "lat": 33.95030941004395, "lng": -118.38759854326952 }, { "lat": 33.950398408077426, "lng": -118.38798478136766 }, { "lat": 33.95049630580675, "lng": -118.38810279856432 }, { "lat": 33.950861196351156, "lng": -118.38653638849962 }, { "lat": 33.95127948358712, "lng": -118.38779166231859 }, { "lat": 33.95134178151021, "lng": -118.3881886292528 }, { "lat": 33.951430778464044, "lng": -118.38851049433458 }, { "lat": 33.950976893026386, "lng": -118.38857486735094 }, { "lat": 33.95076329904159, "lng": -118.38882163058031 }, { "lat": 33.95041620767296, "lng": -118.38876798640001 }, { "lat": 33.95036280887521, "lng": -118.38859632502306 }, { "lat": 33.95026491099231, "lng": -118.38860705385912 }, { "lat": 33.9501937124613, "lng": -118.38883235941637 }, { "lat": 33.95003351554873, "lng": -118.3886392403673 }, { "lat": 33.94986441848054, "lng": -118.38857486735094 }, { "lat": 33.94969532107635, "lng": -118.38885381708849 }, { "lat": 33.94918802684795, "lng": -118.38801696787584 }, { "lat": 33.94888542885087, "lng": -118.38796332369554 }, { "lat": 33.949656367208874, "lng": -118.3892038249707 }, { "lat": 33.949335971059234, "lng": -118.38922528264283 }, { "lat": 33.95102693712167, "lng": -118.38912872311829 }, { "lat": 33.95111593440476, "lng": -118.38954714772461 }, { "lat": 33.950252656831516, "lng": -118.38967589375733 }, { "lat": 33.94994116277371, "lng": -118.38945058820008 }, { "lat": 33.94937157069098, "lng": -118.38938621518372 }, { "lat": 33.94906897334648, "lng": -118.38916090962647 }, { "lat": 33.94889987436183, "lng": -118.38927892682312 }, { "lat": 33.94897107397528, "lng": -118.38968662259339 }, { "lat": 33.94886427453277, "lng": -118.38845280644654 }, { "lat": 33.948944374127194, "lng": -118.38822750088929 }, { "lat": 33.94888207444916, "lng": -118.38810948369263 }, { "lat": 33.94946946960148, "lng": -118.38813094136475 }, { "lat": 33.9495050691774, "lng": -118.38818458554505 }, { "lat": 33.950978053482, "lng": -118.38833481382278 }, { "lat": 33.950978053482, "lng": -118.38858157705215 }, { "lat": 33.95160103286705, "lng": -118.38863522123245 }, { "lat": 33.95244649759506, "lng": -118.38917166303543 }, { "lat": 33.95262448909903, "lng": -118.38908583234695 }, { "lat": 33.95274018337699, "lng": -118.38923603605178 }, { "lat": 33.952597790397164, "lng": -118.38996559690383 }, { "lat": 33.952802480230716, "lng": -118.3899763257399 }, { "lat": 33.952490995505954, "lng": -118.38917166303543 }, { "lat": 33.952757982482694, "lng": -118.3892038495436 }, { "lat": 33.952179509641056, "lng": -118.38783055852798 }, { "lat": 33.9524731963444, "lng": -118.38816315244583 }, { "lat": 33.95088015630685, "lng": -118.38834554265884 }, { "lat": 33.95093355477998, "lng": -118.3884635598555 }, { "lat": 33.95096915374345, "lng": -118.38856011938003 }, { "lat": 33.951058151087, "lng": -118.38871032308487 }, { "lat": 33.95099585295628, "lng": -118.38891417097 }, { "lat": 33.95035506953645, "lng": -118.38860303472427 }, { "lat": 33.950274971269714, "lng": -118.38794857572464 }, { "lat": 33.94992787790942, "lng": -118.38759452413467 }, { "lat": 33.94891328920117, "lng": -118.38778764318374 }, { "lat": 33.9489844888034, "lng": -118.388012948741 }, { "lat": 33.948895489291324, "lng": -118.38821679662612 }, { "lat": 33.9489221891547, "lng": -118.38837772916702 }, { "lat": 33.948619590212466, "lng": -118.3883026273146 }, { "lat": 33.948361490264475, "lng": -118.3883026273146 }, { "lat": 33.948361490264475, "lng": -118.38808805059341 }, { "lat": 33.94754268524929, "lng": -118.3883026273146 }, { "lat": 33.94754268524929, "lng": -118.38817388128189 }, { "lat": 33.94749818475105, "lng": -118.38864595006851 }, { "lat": 33.948308090177484, "lng": -118.38860303472427 }, { "lat": 33.94883318957749, "lng": -118.38873178075698 }, { "lat": 33.94883318957749, "lng": -118.38912874769119 }, { "lat": 33.94909128809502, "lng": -118.38917166303543 }, { "lat": 33.949411685165785, "lng": -118.38921457837966 }, { "lat": 33.9497409808983, "lng": -118.38887125562576 }, { "lat": 33.94981217980807, "lng": -118.38898927282241 }, { "lat": 33.949847779240635, "lng": -118.38917166303543 }, { "lat": 33.95014147399096, "lng": -118.38917166303543 }, { "lat": 33.95033726992811, "lng": -118.38922530721572 }, { "lat": 33.95048856648012, "lng": -118.3892038495436 }, { "lat": 33.95070216115444, "lng": -118.3892038495436 }, { "lat": 33.95083565755365, "lng": -118.38923603605178 }, { "lat": 33.951156048057385, "lng": -118.38911801885513 }, { "lat": 33.950978053482, "lng": -118.3870044381514 }, { "lat": 33.9509869532196, "lng": -118.38609248708633 }, { "lat": 33.95073776021469, "lng": -118.38610321592239 }, { "lat": 33.95052416562974, "lng": -118.38632852147964 }, { "lat": 33.950363969339186, "lng": -118.38624269079116 }, { "lat": 33.95018597310716, "lng": -118.38627487729934 }, { "lat": 33.950274971269714, "lng": -118.38680059026626 }, { "lat": 33.950274971269714, "lng": -118.38690787862686 }, { "lat": 33.949918978061056, "lng": -118.38692933629898 }, { "lat": 33.949669781928975, "lng": -118.38692933629898 }, { "lat": 33.95007027535667, "lng": -118.3869507939711 }, { "lat": 33.95014147399096, "lng": -118.38763743947891 }, { "lat": 33.95004357585346, "lng": -118.38763743947891 }, { "lat": 33.94987447880526, "lng": -118.38762671064285 }, { "lat": 33.949616382662875, "lng": -118.38762671064285 }, { "lat": 33.949411685165785, "lng": -118.38762671064285 }, { "lat": 33.949242586862084, "lng": -118.38761598180679 }, { "lat": 33.94912688782912, "lng": -118.38755160879043 }, { "lat": 33.948993388749464, "lng": -118.38742286275772 }, { "lat": 33.948850989500386, "lng": -118.38726193021682 }, { "lat": 33.949162487548314, "lng": -118.38727265905288 }, { "lat": 33.949109087963926, "lng": -118.38737994741348 }, { "lat": 33.94901118863886, "lng": -118.38758379529861 }, { "lat": 33.94897558885636, "lng": -118.38780910085586 }, { "lat": 33.94893108910731, "lng": -118.38804513524917 }, { "lat": 33.948886589335004, "lng": -118.38833481382278 }, { "lat": 33.948886589335004, "lng": -118.38850647519973 }, { "lat": 33.94934938582983, "lng": -118.38663965772537 }, { "lat": 33.94939388536019, "lng": -118.38611394475845 }, { "lat": 33.94940278526346, "lng": -118.38574916433242 }, { "lat": 33.950274971269714, "lng": -118.38585645269302 }, { "lat": 33.95034616973274, "lng": -118.38616758893875 }, { "lat": 33.95034616973274, "lng": -118.38640362333206 }, { "lat": 33.95002577618002, "lng": -118.38691860746292 }, { "lat": 33.95003467601721, "lng": -118.38748723577407 }, { "lat": 33.95009697485153, "lng": -118.38755160879043 }, { "lat": 33.950274971269714, "lng": -118.38755160879043 }, { "lat": 33.950274971269714, "lng": -118.38704735349563 }, { "lat": 33.950274971269714, "lng": -118.38658601354507 }, { "lat": 33.95021267256569, "lng": -118.38784128736404 }, { "lat": 33.950274971269714, "lng": -118.38797003339675 }, { "lat": 33.950274971269714, "lng": -118.38815242360977 }, { "lat": 33.95028387108085, "lng": -118.3883026273146 }, { "lat": 33.95012367433797, "lng": -118.38825971197036 }, { "lat": 33.94980327994762, "lng": -118.38825971197036 }, { "lat": 33.94950068413806, "lng": -118.38821679662612 }, { "lat": 33.94926038669934, "lng": -118.38821679662612 }, { "lat": 33.949242586862084, "lng": -118.38809877942947 }, { "lat": 33.949233686942044, "lng": -118.38783055852798 }, { "lat": 33.949224787021095, "lng": -118.38753015111831 }, { "lat": 33.949251486781186, "lng": -118.38746577810196 }, { "lat": 33.949411685165785, "lng": -118.38719755720047 }, { "lat": 33.9494294849677, "lng": -118.38698298047927 }, { "lat": 33.949562983363286, "lng": -118.38676840375808 }, { "lat": 33.94958968301725, "lng": -118.38651091169265 }, { "lat": 33.949616382662875, "lng": -118.38632852147964 }, { "lat": 33.949616382662875, "lng": -118.38613540243057 }, { "lat": 33.94936718564477, "lng": -118.38637143682388 }, { "lat": 33.94938498545597, "lng": -118.38624269079116 }, { "lat": 33.94938498545597, "lng": -118.38582426618484 }, { "lat": 33.94933158601117, "lng": -118.38658601354507 }, { "lat": 33.94928708644827, "lng": -118.38685423444656 }, { "lat": 33.94919808725265, "lng": -118.38710099767593 }, { "lat": 33.94908238815918, "lng": -118.38735848974136 }, { "lat": 33.94906458828467, "lng": -118.38749796461013 }, { "lat": 33.94906458828467, "lng": -118.38749796461013 }, { "lat": 33.94908238815918, "lng": -118.38757306646255 }, { "lat": 33.94921588709919, "lng": -118.38759452413467 }, { "lat": 33.94921588709919, "lng": -118.38773399900344 }, { "lat": 33.94920253721462, "lng": -118.38781982969192 }, { "lat": 33.94920253721462, "lng": -118.38793784688858 }, { "lat": 33.94920253721462, "lng": -118.38806659292129 }, { "lat": 33.94920253721462, "lng": -118.38815242360977 }, { "lat": 33.94922923698168, "lng": -118.38820606779007 }, { "lat": 33.949442834816686, "lng": -118.3882489831343 }, { "lat": 33.949683131740244, "lng": -118.38825971197036 }, { "lat": 33.94996792721555, "lng": -118.38827044080642 }, { "lat": 33.950056925606134, "lng": -118.3883026273146 }, { "lat": 33.95021712247463, "lng": -118.38837772916702 }, { "lat": 33.95027052136378, "lng": -118.38817388128189 }, { "lat": 33.95027052136378, "lng": -118.38778764318374 }, { "lat": 33.95027052136378, "lng": -118.38751942228225 }, { "lat": 33.95027052136378, "lng": -118.38739067624954 }, { "lat": 33.95027052136378, "lng": -118.38697225164321 }, { "lat": 33.95018152319656, "lng": -118.38696152280716 }, { "lat": 33.9501014247665, "lng": -118.38696152280716 }, { "lat": 33.9499768270588, "lng": -118.38694006513504 }, { "lat": 33.94978993015518, "lng": -118.38694006513504 }, { "lat": 33.949683131740244, "lng": -118.38691860746292 }, { "lat": 33.94959413295879, "lng": -118.38691860746292 }, { "lat": 33.94950513408422, "lng": -118.38691860746292 }, { "lat": 33.94942503501757, "lng": -118.38709026883987 }, { "lat": 33.95041291823774, "lng": -118.3863392503157 }, { "lat": 33.950564214655245, "lng": -118.38627487729934 }, { "lat": 33.95066211219383, "lng": -118.38627487729934 }, { "lat": 33.95100030282429, "lng": -118.3862319619551 }, { "lat": 33.95105370122202, "lng": -118.38638216565994 }, { "lat": 33.95106260095171, "lng": -118.38683277677444 }, { "lat": 33.95106260095171, "lng": -118.38701516698745 }, { "lat": 33.95106260095171, "lng": -118.3872404725447 }, { "lat": 33.95120499650033, "lng": -118.38726193021682 }, { "lat": 33.95136519120772, "lng": -118.38732630323318 }, { "lat": 33.95137409090485, "lng": -118.38741213392166 }, { "lat": 33.95137409090485, "lng": -118.38761598180679 }, { "lat": 33.95142748906806, "lng": -118.38784128736404 }, { "lat": 33.95140968968405, "lng": -118.38806659292129 }, { "lat": 33.95140968968405, "lng": -118.38831335615066 }, { "lat": 33.951400789990636, "lng": -118.38845283101944 }, { "lat": 33.951400789990636, "lng": -118.38850647519973 }, { "lat": 33.95151648593226, "lng": -118.38858157705215 }, { "lat": 33.95164108138579, "lng": -118.38858157705215 }, { "lat": 33.95164998105406, "lng": -118.38853866170791 }, { "lat": 33.95168557971784, "lng": -118.38815242360977 }, { "lat": 33.95168557971784, "lng": -118.38788420270828 }, { "lat": 33.95168557971784, "lng": -118.38765889715103 }, { "lat": 33.95168557971784, "lng": -118.38741213392166 }, { "lat": 33.951667780387815, "lng": -118.38712245534805 }, { "lat": 33.951667780387815, "lng": -118.38696152280716 }, { "lat": 33.952628938881865, "lng": -118.38953644346145 }, { "lat": 33.952824729096, "lng": -118.39069515775589 }, { "lat": 33.95227295552023, "lng": -118.3909311921492 }, { "lat": 33.95161438237539, "lng": -118.39022308896926 }, { "lat": 33.95141858937651, "lng": -118.39069515775589 }, { "lat": 33.950920205164834, "lng": -118.39056641172317 }, { "lat": 33.95083120767705, "lng": -118.38857084821609 }, { "lat": 33.950279421175395, "lng": -118.38831335615066 }, { "lat": 33.94887323939877, "lng": -118.38861376356033 }, { "lat": 33.94798323892662, "lng": -118.38942915510086 }, { "lat": 33.94801883912419, "lng": -118.39033037732986 }, { "lat": 33.949051238376356, "lng": -118.39058786939529 }, { "lat": 33.94933603596619, "lng": -118.39163929532913 }, { "lat": 33.949051238376356, "lng": -118.39232594083694 }, { "lat": 33.95141858937651, "lng": -118.39337736677078 }, { "lat": 33.9518101749238, "lng": -118.3943000466719 }, { "lat": 33.95323410717896, "lng": -118.39369923185257 }, { "lat": 33.95280693000424, "lng": -118.39279800962356 }, { "lat": 33.95326970518006, "lng": -118.3919397027388 }, { "lat": 33.952539943181065, "lng": -118.39112431119827 }, { "lat": 33.951667780387815, "lng": -118.38949352811721 }, { "lat": 33.951756777000725, "lng": -118.38863522123245 }, { "lat": 33.95225515631305, "lng": -118.38904291700271 }, { "lat": 33.953198509162966, "lng": -118.38964373182205 }, { "lat": 33.95213056175862, "lng": -118.38726193021682 }, { "lat": 33.953073915989734, "lng": -118.3872404725447 }, { "lat": 33.953056116950115, "lng": -118.38618904661087 }, { "lat": 33.952611139749166, "lng": -118.38618904661087 }, { "lat": 33.950795608655866, "lng": -118.38503033231643 }, { "lat": 33.95026162155126, "lng": -118.38608175825027 }, { "lat": 33.949104637997046, "lng": -118.38569552015213 }, { "lat": 33.94858844026026, "lng": -118.38580280851272 }, { "lat": 33.947876438244556, "lng": -118.38550240110305 }, { "lat": 33.94752043500306, "lng": -118.38423639844802 }, { "lat": 33.94737803328953, "lng": -118.38307768415359 }, { "lat": 33.94705762856299, "lng": -118.38187605451492 }, { "lat": 33.947627236131865, "lng": -118.38181168149856 }, { "lat": 33.947627236131865, "lng": -118.38076025556472 }, { "lat": 33.94805443930688, "lng": -118.38020235608963 }, { "lat": 33.94880203970347, "lng": -118.38069588254837 }, { "lat": 33.94834054932866, "lng": -118.38035915423654 }, { "lat": 33.947877747348045, "lng": -118.37971542407297 }, { "lat": 33.94773534623231, "lng": -118.38018749285959 }, { "lat": 33.94730814145567, "lng": -118.37993000079416 }, { "lat": 33.94855414939402, "lng": -118.38074539233469 }, { "lat": 33.951224104979175, "lng": -118.38057373095774 }, { "lat": 33.95121516763197, "lng": -118.3799751629 }, { "lat": 33.95204287457601, "lng": -118.38023040820383 }, { "lat": 33.95204287457601, "lng": -118.38023040820383 }, { "lat": 33.95230096335946, "lng": -118.38025186587595 }, { "lat": 33.95300934865097, "lng": -118.38081395268978 }, { "lat": 33.95276016156816, "lng": -118.37991273046077 }, { "lat": 33.952421977931465, "lng": -118.37996006011963 }, { "lat": 33.950837836688315, "lng": -118.38205849767269 }, { "lat": 33.95033944907556, "lng": -118.38326012731136 }, { "lat": 33.94909346727437, "lng": -118.38300263524593 }, { "lat": 33.94912906700753, "lng": -118.38450467229427 }, { "lat": 33.952261785213416, "lng": -118.38703667760433 }, { "lat": 33.95058864324679, "lng": -118.38630711675228 }, { "lat": 33.94620807002934, "lng": -118.38163375854492 }, { "lat": 33.9481144687764, "lng": -118.37996006011963 }, { "lat": 33.94895106819272, "lng": -118.3803847992474 }, { "lat": 33.950731039588426, "lng": -118.37935483098568 }, { "lat": 33.950837836688315, "lng": -118.38025605321468 }, { "lat": 33.951905800315906, "lng": -118.38403260350765 }, { "lat": 33.95076663863663, "lng": -118.38519131780208 }, { "lat": 33.951051430486025, "lng": -118.38755166173519 }, { "lat": 33.953578916385865, "lng": -118.3913711273724 }, { "lat": 33.952226186790696, "lng": -118.39055573583187 }, { "lat": 33.952617768621764, "lng": -118.39304482579769 }, { "lat": 33.95318733897765, "lng": -118.3931735718304 }, { "lat": 33.95247537543714, "lng": -118.39355980992855 }, { "lat": 33.95247537543714, "lng": -118.39394604802669 }, { "lat": 33.952261785213416, "lng": -118.39102780461849 }, { "lat": 33.95140741895754, "lng": -118.39077031255306 }, { "lat": 33.951229424907936, "lng": -118.3905986511761 }, { "lat": 33.94927146579136, "lng": -118.3937314713055 }, { "lat": 33.94798986815974, "lng": -118.39291607976497 }, { "lat": 33.9490578675263, "lng": -118.39330231786312 }, { "lat": 33.94891546838508, "lng": -118.38901078343929 }, { "lat": 33.948737469123515, "lng": -118.38094269872249 }, { "lat": 33.94934266509395, "lng": -118.38055646062435 }, { "lat": 33.9493070654501, "lng": -118.37862527013363 }, { "lat": 33.94980545910874, "lng": -118.38042771459163 }, { "lat": 33.950125853490896, "lng": -118.38055646062435 }, { "lat": 33.95016145279224, "lng": -118.37879693151058 }, { "lat": 33.95037504828755, "lng": -118.38201558232845 }, { "lat": 33.95051744498661, "lng": -118.38317429662288 }]);
// 928 points

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{ "lat": 33.945485411091006, "lng": -118.4003581241156 }, { "lat": 33.945467610464235, "lng": -118.40074436221374 }, { "lat": 33.94537860727465, "lng": -118.40119497332824 }, { "lat": 33.94539640792002, "lng": -118.40095893893493 }, { "lat": 33.94536080662556, "lng": -118.40138809237732 }, { "lat": 33.94318909950695, "lng": -118.40089456591858 }, { "lat": 33.94308229280939, "lng": -118.40158121142639 }, { "lat": 33.94295768482618, "lng": -118.40263263736023 }, { "lat": 33.94329590607052, "lng": -118.40022937808288 }, { "lat": 33.94347391671198, "lng": -118.40143100772156 }, { "lat": 33.943349309302036, "lng": -118.40340511355652 }, { "lat": 33.94302888941035, "lng": -118.403490944245 }, { "lat": 33.94293988367085, "lng": -118.40452091250671 }, { "lat": 33.94285087783828, "lng": -118.40550796542419 }, { "lat": 33.94285087783828, "lng": -118.40550796542419 }, { "lat": 33.94263726346043, "lng": -118.4059585765387 }, { "lat": 33.94338491143779, "lng": -118.40600149188293 }, { "lat": 33.94340271250007, "lng": -118.4066452220465 }, { "lat": 33.943972344527715, "lng": -118.40572254214538 }, { "lat": 33.94381213590522, "lng": -118.40625898394836 }, { "lat": 33.94349171775566, "lng": -118.40591566119446 }, { "lat": 33.943117895056794, "lng": -118.40589420352234 }, { "lat": 33.94294459844354, "lng": -118.4079160254787 }, { "lat": 33.94264197824985, "lng": -118.40785165246234 }, { "lat": 33.94338072565376, "lng": -118.40795894082294 }, { "lat": 33.94333177271086, "lng": -118.40803940709338 }, { "lat": 33.94341632777636, "lng": -118.40816278870807 }, { "lat": 33.94352313405482, "lng": -118.40773363526569 }, { "lat": 33.94362103969235, "lng": -118.40754051621661 }, { "lat": 33.94407496435866, "lng": -118.4076638978313 }, { "lat": 33.94406606389828, "lng": -118.40803404267535 }, { "lat": 33.94438647988595, "lng": -118.4074654143642 }, { "lat": 33.94426123000054, "lng": -118.40697730706955 }, { "lat": 33.944546043618345, "lng": -118.4073635451677 }, { "lat": 33.94456384443781, "lng": -118.40798581765915 }, { "lat": 33.94426123000054, "lng": -118.40699876474167 }, { "lat": 33.944848657043096, "lng": -118.40652669595505 }, { "lat": 33.94404761916181, "lng": -118.40687001870896 }, { "lat": 33.943086363754, "lng": -118.40663398431565 }, { "lat": 33.94337118130276, "lng": -118.40663398431565 }, { "lat": 33.94319317044646, "lng": -118.40764249490525 }, { "lat": 33.94354919178682, "lng": -118.40526069330002 }, { "lat": 33.94306856262556, "lng": -118.40390885995652 }, { "lat": 33.942872749967066, "lng": -118.40345824884201 }, { "lat": 33.94346018659133, "lng": -118.40347970651413 }, { "lat": 33.943673798904165, "lng": -118.40324367212082 }, { "lat": 33.9455922610342, "lng": -118.40159824191028 }, { "lat": 33.94533415190599, "lng": -118.40185573397571 }, { "lat": 33.94477342937872, "lng": -118.40108325777942 }, { "lat": 33.944906935077384, "lng": -118.40069701968127 }, { "lat": 33.944533118593455, "lng": -118.40069701968127 }, { "lat": 33.94466662466903, "lng": -118.40019276438647 }, { "lat": 33.944898034704, "lng": -118.40019276438647 }, { "lat": 33.94407919637027, "lng": -118.40048244296008 }, { "lat": 33.944007992664645, "lng": -118.40109398661548 }, { "lat": 33.94356296815511, "lng": -118.40092232523853 }, { "lat": 33.943794381190436, "lng": -118.40073993502551 }, { "lat": 33.9435985702015, "lng": -118.40020349322253 }, { "lat": 33.943534841186924, "lng": -118.3997494456475 }, { "lat": 33.94425577996219, "lng": -118.39936320754936 }, { "lat": 33.94380185626007, "lng": -118.39905207130363 }, { "lat": 33.94349033859331, "lng": -118.39928810569694 }, { "lat": 33.94336573120741, "lng": -118.39915935966422 }, { "lat": 33.943214421993616, "lng": -118.39982454749992 }, { "lat": 33.94328562636301, "lng": -118.40027515861442 }, { "lat": 33.94313431700683, "lng": -118.40040390464713 }, { "lat": 33.94324112363912, "lng": -118.40103690597465 }, { "lat": 33.94299190795531, "lng": -118.40144460174491 }, { "lat": 33.94367724933016, "lng": -118.40100471946647 }, { "lat": 33.94385525917419, "lng": -118.40157334777763 }, { "lat": 33.94456729482774, "lng": -118.40145533058097 }, { "lat": 33.944745302810496, "lng": -118.4017128226464 }, { "lat": 33.94519922148164, "lng": -118.40177719566276 }, { "lat": 33.945314925853786, "lng": -118.40123002502372 }, { "lat": 33.94543953038638, "lng": -118.4013158557122 }, { "lat": 33.945350527167435, "lng": -118.40052192184379 }, { "lat": 33.944754203199885, "lng": -118.40018932792594 }, { "lat": 33.94466519926432, "lng": -118.39993183586051 }, { "lat": 33.94435368475705, "lng": -118.4016055342858 }, { "lat": 33.94384635869081, "lng": -118.40105836364677 }, { "lat": 33.94355264221786, "lng": -118.4024316546624 }, { "lat": 33.94302953859167, "lng": -118.40267618663097 }, { "lat": 33.94290493053125, "lng": -118.4028263903358 }, { "lat": 33.9431808481341, "lng": -118.40306242472911 }, { "lat": 33.94348346641212, "lng": -118.40334137446666 }, { "lat": 33.9435457700417, "lng": -118.4038349009254 }, { "lat": 33.94322535088951, "lng": -118.40392073161388 }, { "lat": 33.94310074311573, "lng": -118.4042855120399 }, { "lat": 33.942655713863196, "lng": -118.4040494776466 }, { "lat": 33.942636354685014, "lng": -118.40486438579387 }, { "lat": 33.94278766492631, "lng": -118.40531499690837 }, { "lat": 33.94301908006928, "lng": -118.40561540431804 }, { "lat": 33.943793426165485, "lng": -118.40572269267864 }, { "lat": 33.943793426165485, "lng": -118.40614111728496 }, { "lat": 33.94255624915426, "lng": -118.4062913209898 }, { "lat": 33.942425930921765, "lng": -118.40699426250819 }, { "lat": 33.94259504276827, "lng": -118.40714446621303 }, { "lat": 33.9425683409201, "lng": -118.4074287803686 }, { "lat": 33.94245708312926, "lng": -118.40735904293422 }, { "lat": 33.94250603657514, "lng": -118.40777210312251 }, { "lat": 33.942839809319494, "lng": -118.40782574730281 }, { "lat": 33.94283090872996, "lng": -118.40805641727809 }, { "lat": 33.943191381861666, "lng": -118.40799740867976 }, { "lat": 33.94318693158539, "lng": -118.40809933262233 }, { "lat": 33.94318693158539, "lng": -118.40779356079463 }, { "lat": 33.94301782091472, "lng": -118.4078418405569 }, { "lat": 33.94331153923301, "lng": -118.40806714611415 }, { "lat": 33.94333379057946, "lng": -118.4081851633108 }, { "lat": 33.943382743521205, "lng": -118.40797058658961 }, { "lat": 33.94364530881909, "lng": -118.40824164857003 }, { "lat": 33.94364085856656, "lng": -118.40793587674233 }, { "lat": 33.94384556994259, "lng": -118.40810753811928 }, { "lat": 33.94391677378408, "lng": -118.40831138600441 }, { "lat": 33.94411703426892, "lng": -118.40806998719307 }, { "lat": 33.94417043698532, "lng": -118.40822555531594 }, { "lat": 33.944201588554385, "lng": -118.40837575902077 }, { "lat": 33.944277242317575, "lng": -118.40831675042244 }, { "lat": 33.94425499121773, "lng": -118.40783395279976 }, { "lat": 33.944352896013534, "lng": -118.408236284152 }, { "lat": 33.94450420320371, "lng": -118.40829529275032 }, { "lat": 33.94450420320371, "lng": -118.40773739327523 }, { "lat": 33.94473561368024, "lng": -118.40780713070961 }, { "lat": 33.94473116348469, "lng": -118.40737797726723 }, { "lat": 33.944837968113404, "lng": -118.40739407052132 }, { "lat": 33.94481571716013, "lng": -118.40708829869362 }, { "lat": 33.94492252168277, "lng": -118.40722240914437 }, { "lat": 33.94468221131841, "lng": -118.40713657845589 }, { "lat": 33.944508653411106, "lng": -118.40682007779213 }, { "lat": 33.9449146508759, "lng": -118.40588715733992 }, { "lat": 33.944985853823106, "lng": -118.40532925786482 }, { "lat": 33.94506595706753, "lng": -118.405361444373 }, { "lat": 33.945208362649275, "lng": -118.40476062955366 }, { "lat": 33.94443402942431, "lng": -118.40553310574995 }, { "lat": 33.94487904937995, "lng": -118.40511468114363 }, { "lat": 33.94386440048615, "lng": -118.40589788617598 }, { "lat": 33.94330366827719, "lng": -118.40634849729048 }, { "lat": 33.943098955597975, "lng": -118.40516832532393 }, { "lat": 33.943020102413946, "lng": -118.40355190248118 }, { "lat": 33.94291329550433, "lng": -118.4030691048585 }, { "lat": 33.94343842818625, "lng": -118.40387376756297 }, { "lat": 33.94297559955123, "lng": -118.40342315644847 }, { "lat": 33.94363423954355, "lng": -118.40291890115367 }, { "lat": 33.942886593756015, "lng": -118.40287598580943 }, { "lat": 33.94295779839962, "lng": -118.40188893289195 }, { "lat": 33.943064605253404, "lng": -118.40057286762044 }, { "lat": 33.94423057135704, "lng": -118.39988622211263 }, { "lat": 33.94385675190283, "lng": -118.39918358520384 }, { "lat": 33.94343842818625, "lng": -118.39906556800719 }, { "lat": 33.9432070141833, "lng": -118.39876516059752 }, { "lat": 33.94399915950753, "lng": -118.39944107726927 }, { "lat": 33.9439724580998, "lng": -118.40094311431761 }, { "lat": 33.94364314004909, "lng": -118.40073926643248 }, { "lat": 33.944239471800245, "lng": -118.40155465797301 }, { "lat": 33.94455988713516, "lng": -118.40159757331725 }, { "lat": 33.94456878754391, "lng": -118.40114696220274 }, { "lat": 33.944906179507996, "lng": -118.40130640685095 }, { "lat": 33.94523549267236, "lng": -118.40055538832678 }, { "lat": 33.94532449601159, "lng": -118.39982582747473 }, { "lat": 33.944968482096264, "lng": -118.39976145445837 }, { "lat": 33.943873729977525, "lng": -118.40024425208105 }, { "lat": 33.94293917434635, "lng": -118.40031935393347 }]);
// 160 points

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{ "lat": 33.945511802408745, "lng": -118.39645606819204 }, { "lat": 33.945422799265366, "lng": -118.39634877983144 }, { "lat": 33.945445050059924, "lng": -118.39623612705282 }, { "lat": 33.94548955163162, "lng": -118.3960537368398 }, { "lat": 33.9455652042501, "lng": -118.39587134662679 }, { "lat": 33.94564085680134, "lng": -118.39572114292196 }, { "lat": 33.94552515287223, "lng": -118.39552802387288 }, { "lat": 33.945422799265366, "lng": -118.39559239688924 }, { "lat": 33.945422596277275, "lng": -118.39567383565827 }, { "lat": 33.94545840053387, "lng": -118.39582574907354 }, { "lat": 33.94536494717225, "lng": -118.3958177024465 }, { "lat": 33.94529596962524, "lng": -118.39591962638906 }, { "lat": 33.94529151945901, "lng": -118.39601886812261 }, { "lat": 33.94524256761498, "lng": -118.39591426197103 }, { "lat": 33.94513798858116, "lng": -118.39552534166387 }, { "lat": 33.94519806591416, "lng": -118.39557362142614 }, { "lat": 33.945349371602, "lng": -118.39561653677038 }, { "lat": 33.94539387322371, "lng": -118.3952973538976 }, { "lat": 33.94537384749683, "lng": -118.39523566309026 }, { "lat": 33.945409448785824, "lng": -118.39513105693868 }, { "lat": 33.94559858038393, "lng": -118.39511228147558 }, { "lat": 33.945611930833806, "lng": -118.3953858667951 }, { "lat": 33.94556075409794, "lng": -118.39530540052465 }, { "lat": 33.94560303053413, "lng": -118.39510590680516 }, { "lat": 33.9455518537929, "lng": -118.39514077552235 }, { "lat": 33.94562528128159, "lng": -118.39515686877644 }, { "lat": 33.945616380983296, "lng": -118.39495033868229 }, { "lat": 33.9455518537929, "lng": -118.394896694502 }, { "lat": 33.9455652042501, "lng": -118.39501739390766 }, { "lat": 33.945672007832314, "lng": -118.39469016440785 }, { "lat": 33.94556075409794, "lng": -118.39467943557179 }, { "lat": 33.94554740364005, "lng": -118.39485646136677 }, { "lat": 33.94565198217084, "lng": -118.39495033868229 }, { "lat": 33.945425024345084, "lng": -118.39501471169865 }, { "lat": 33.94534714652031, "lng": -118.39491278775608 }, { "lat": 33.94542057418557, "lng": -118.39499593623555 }, { "lat": 33.94536494717225, "lng": -118.39503616937077 }, { "lat": 33.94541834910575, "lng": -118.39517832644856 }, { "lat": 33.94534047127487, "lng": -118.39521587737477 }, { "lat": 33.94543837482217, "lng": -118.39493960984623 }, { "lat": 33.94536049700963, "lng": -118.39472503312504 }, { "lat": 33.94542057418557, "lng": -118.39463115580952 }, { "lat": 33.94540054846498, "lng": -118.39454264291203 }, { "lat": 33.945453950376134, "lng": -118.39398494387581 }, { "lat": 33.94544282498074, "lng": -118.39411100769951 }, { "lat": 33.945498451943166, "lng": -118.39386692667915 }, { "lat": 33.94547397608418, "lng": -118.39384278679802 }, { "lat": 33.9454917767096, "lng": -118.3936952653022 }, { "lat": 33.9455518537929, "lng": -118.39374622727348 }, { "lat": 33.945509577331286, "lng": -118.39361211682274 }, { "lat": 33.945485101475505, "lng": -118.39359602356865 }, { "lat": 33.94547842624087, "lng": -118.39345118428184 }, { "lat": 33.94552070271796, "lng": -118.39339217568352 }, { "lat": 33.9455006770209, "lng": -118.39331975604011 }, { "lat": 33.9455652042501, "lng": -118.3929201068969 }, { "lat": 33.94553850333361, "lng": -118.39286109829857 }, { "lat": 33.94556742932608, "lng": -118.39282891179039 }, { "lat": 33.9455407284103, "lng": -118.39276453877403 }, { "lat": 33.94556297917404, "lng": -118.39271625901176 }, { "lat": 33.94559858038393, "lng": -118.39282354737236 }, { "lat": 33.94559858038393, "lng": -118.39263042832329 }, { "lat": 33.94551847764075, "lng": -118.39258483077003 }, { "lat": 33.9455518537929, "lng": -118.39248022461845 }, { "lat": 33.94553627825687, "lng": -118.3924694957824 }, { "lat": 33.94559858038393, "lng": -118.39245876694633 }, { "lat": 33.94560080545907, "lng": -118.39235147858574 }, { "lat": 33.945634181578924, "lng": -118.39243194485618 }, { "lat": 33.94558077978085, "lng": -118.39226028347923 }, { "lat": 33.945583004856445, "lng": -118.39219591046287 }, { "lat": 33.945576329629496, "lng": -118.39214494849159 }, { "lat": 33.9455407284103, "lng": -118.39241048718407 }, { "lat": 33.94559413023352, "lng": -118.39242926264717 }, { "lat": 33.94560303053413, "lng": -118.3925606908889 }, { "lat": 33.94558077978085, "lng": -118.39263042832329 }, { "lat": 33.94553850333361, "lng": -118.39258751297905 }, { "lat": 33.94555852902175, "lng": -118.39278331423714 }, { "lat": 33.94558077978085, "lng": -118.39290937806084 }, { "lat": 33.94553405318004, "lng": -118.39288792038872 }, { "lat": 33.94560303053413, "lng": -118.39280745411827 }, { "lat": 33.94557187947792, "lng": -118.39271089459373 }]);
// 80 points

/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{ "lat": 33.9451767541153, "lng": -118.39361711209835 }, { "lat": 33.945158953424, "lng": -118.39350982373776 }, { "lat": 33.94498984667099, "lng": -118.39373512929501 }, { "lat": 33.945020997940226, "lng": -118.3939497060162 }, { "lat": 33.945065499733616, "lng": -118.39381559556546 }, { "lat": 33.94495869539038, "lng": -118.3939497060162 }, { "lat": 33.94488304223285, "lng": -118.3940569943768 }, { "lat": 33.94489639279496, "lng": -118.39415355390133 }, { "lat": 33.94480293881629, "lng": -118.39418574040951 }, { "lat": 33.94483854034408, "lng": -118.39430375760617 }, { "lat": 33.94523015616686, "lng": -118.39340253537716 }, { "lat": 33.94495869539038, "lng": -118.3939497060162 }, { "lat": 33.94488304223285, "lng": -118.39400871461453 }, { "lat": 33.94490084298186, "lng": -118.39407308763089 }, { "lat": 33.944758436885635, "lng": -118.39409990972104 }, { "lat": 33.944762887079754, "lng": -118.39429302877011 }, { "lat": 33.94498094630629, "lng": -118.39393897718014 }, { "lat": 33.94498094630629, "lng": -118.39406235879483 }, { "lat": 33.94490974335496, "lng": -118.39427157109799 }, { "lat": 33.94479403843204, "lng": -118.39428229993405 }, { "lat": 33.94482073958204, "lng": -118.39435740178646 }, { "lat": 33.94535957843783, "lng": -118.39297293899307 }, { "lat": 33.94532397712798, "lng": -118.39296221015701 }, { "lat": 33.94527502530263, "lng": -118.39288174388656 }, { "lat": 33.94520827276812, "lng": -118.39304804084549 }, { "lat": 33.94525722463187, "lng": -118.3931231426979 }, { "lat": 33.94538627941046, "lng": -118.39293002364883 }, { "lat": 33.945319526963196, "lng": -118.39278518436203 }, { "lat": 33.94530617646747, "lng": -118.39285492179641 }, { "lat": 33.945399629893615, "lng": -118.39282273528823 }, { "lat": 33.94541743053458, "lng": -118.39269935367355 }, { "lat": 33.94535067811177, "lng": -118.39271008250961 }, { "lat": 33.945412980374684, "lng": -118.39279591319809 }, { "lat": 33.945056966829455, "lng": -118.39393853423843 }, { "lat": 33.94470540199232, "lng": -118.39403509376297 }, { "lat": 33.94470540199232, "lng": -118.39409946677932 }, { "lat": 33.94481220665335, "lng": -118.39399217841873 }, { "lat": 33.9450258155734, "lng": -118.3936273979927 }, { "lat": 33.94470673547506, "lng": -118.39449240564954 }, { "lat": 33.94459993068167, "lng": -118.39452459215772 }, { "lat": 33.944635532294356, "lng": -118.39462651610029 }, { "lat": 33.94469783508074, "lng": -118.39468016028059 }, { "lat": 33.9447779385962, "lng": -118.39467479586256 }, { "lat": 33.94474678723803, "lng": -118.39454068541181 }, { "lat": 33.9446622334941, "lng": -118.3947177112068 }, { "lat": 33.944671133892165, "lng": -118.39483572840345 }, { "lat": 33.944577679666196, "lng": -118.39492692350996 }, { "lat": 33.94468003428926, "lng": -118.39502884745252 }, { "lat": 33.944764588015516, "lng": -118.39481963514936 }, { "lat": 33.9446933848832, "lng": -118.39472844004285 }, { "lat": 33.94495594613846, "lng": -118.39418126940382 }, { "lat": 33.945071650841285, "lng": -118.3940149724449 }, { "lat": 33.94500489814731, "lng": -118.39397742151868 }, { "lat": 33.9449158944739, "lng": -118.39413835405958 }, { "lat": 33.94488029297848, "lng": -118.39413298964155 }, { "lat": 33.94506720066332, "lng": -118.39387549757612 }, { "lat": 33.94514285365719, "lng": -118.39383794664991 }, { "lat": 33.94510280208057, "lng": -118.39374138712537 }, { "lat": 33.94499154760222, "lng": -118.39383794664991 }, { "lat": 33.94504049959062, "lng": -118.39392377733839 }, { "lat": 33.94512950313376, "lng": -118.39373065828931 }, { "lat": 33.945200705901236, "lng": -118.3937092006172 }, { "lat": 33.945200705901236, "lng": -118.39357509016645 }, { "lat": 33.94525410793776, "lng": -118.39355899691236 }, { "lat": 33.945227406923685, "lng": -118.39343561529768 }, { "lat": 33.945294159443186, "lng": -118.39344634413374 }, { "lat": 33.94524965776934, "lng": -118.39328541159284 }, { "lat": 33.94533421092975, "lng": -118.39330686926496 }, { "lat": 33.94527635877641, "lng": -118.39338733553541 }, { "lat": 33.94523630726265, "lng": -118.39339269995344 }, { "lat": 33.94508945155085, "lng": -118.39366628527296 }, { "lat": 33.944995997784154, "lng": -118.39389695524824 }, { "lat": 33.944889193353724, "lng": -118.39389695524824 }, { "lat": 33.944893643541, "lng": -118.3941061675514 }, { "lat": 33.94496039632222, "lng": -118.39418663382185 }]);
// 75 entries

/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{ "lat": 33.94544597256177, "lng": -118.37642484648666 }, { "lat": 33.94545487287788, "lng": -118.37688618643722 }, { "lat": 33.94557947720559, "lng": -118.37703639014205 }, { "lat": 33.94535696934954, "lng": -118.37710076315841 }, { "lat": 33.94554387598772, "lng": -118.37761574728927 }, { "lat": 33.94542817192676, "lng": -118.37764793379745 }, { "lat": 33.945632879004485, "lng": -118.37768012030563 }, { "lat": 33.945623978707, "lng": -118.3772616956993 }, { "lat": 33.94532136803862, "lng": -118.37724023802718 }, { "lat": 33.945650679596675, "lng": -118.3769183729454 }, { "lat": 33.944677215519796, "lng": -118.37666630744934 }, { "lat": 33.945542521840125, "lng": -118.3764131799598 }, { "lat": 33.945391216495594, "lng": -118.37626297625496 }, { "lat": 33.94553362153318, "lng": -118.37703545245125 }, { "lat": 33.944677215519796, "lng": -118.37666630744934 }, { "lat": 33.945987536000445, "lng": -118.37559778841927 }, { "lat": 33.94523991088214, "lng": -118.3758552804847 }, { "lat": 33.94533781454508, "lng": -118.37654192599251 }, { "lat": 33.94515980780142, "lng": -118.37752897891 }, { "lat": 33.94465051432477, "lng": -118.37834000587463 }, { "lat": 33.95265142573999, "lng": -118.38426737546149 }, { "lat": 33.95231324167118, "lng": -118.38184265851203 }, { "lat": 33.95160127081746, "lng": -118.38053374051276 }, { "lat": 33.952384438428936, "lng": -118.3804693674964 }, { "lat": 33.95243783595816, "lng": -118.37924628018561 }, { "lat": 33.95268702398486, "lng": -118.37870983838263 }, { "lat": 33.95206405254996, "lng": -118.37813048123542 }, { "lat": 33.95185046129385, "lng": -118.3795681452674 }, { "lat": 33.95120968430891, "lng": -118.38029770611945 }, { "lat": 33.95206405254996, "lng": -118.38107018231574 }, { "lat": 33.95293621128184, "lng": -118.37422518490973 }, { "lat": 33.951565672118406, "lng": -118.37568430661383 }, { "lat": 33.95119188487932, "lng": -118.37248711346808 }, { "lat": 33.951939457715696, "lng": -118.37401060818854 }, { "lat": 33.951814862699045, "lng": -118.37692885159674 }, { "lat": 33.951779264089325, "lng": -118.37903170346442 }, { "lat": 33.95106728876813, "lng": -118.37939648389045 }, { "lat": 33.950924892989086, "lng": -118.37740092038337 }, { "lat": 33.95097829143415, "lng": -118.37527661084357 }, { "lat": 33.95217084797697, "lng": -118.37538389920417 }, { "lat": 33.95160127081746, "lng": -118.37246565579596 }, { "lat": 33.951814862699045, "lng": -118.37126402615729 }, { "lat": 33.95044430547579, "lng": -118.3715000605506 }, { "lat": 33.951476675305635, "lng": -118.37259440182868 }, { "lat": 33.95185046129385, "lng": -118.37173609494391 }, { "lat": 33.95298960846483, "lng": -118.3753710491738 }, { "lat": 33.953434583686715, "lng": -118.37848241163107 }, { "lat": 33.953701567702936, "lng": -118.38062817884298 }, { "lat": 33.94752512301458, "lng": -118.37307507825705 }, { "lat": 33.94693771444301, "lng": -118.3767228825173 }, { "lat": 33.9458831785836, "lng": -118.37589709895343 }, { "lat": 33.94623918867316, "lng": -118.37688415187091 }, { "lat": 33.94643499358772, "lng": -118.37521045344562 }, { "lat": 33.94700460532346, "lng": -118.37705581324786 }, { "lat": 33.94540256260067, "lng": -118.38211982386798 }, { "lat": 33.94558056883671, "lng": -118.38231294291705 }, { "lat": 33.94619026955371, "lng": -118.38163375854492 }, { "lat": 33.94547376513977, "lng": -118.38362186091632 }, { "lat": 33.94545596451058, "lng": -118.38264566826172 }, { "lat": 33.94598998176684, "lng": -118.37661606239624 }, { "lat": 33.945491565765245, "lng": -118.37665897774048 }, { "lat": 33.94595438072065, "lng": -118.38333231376953 }, { "lat": 33.94547376513977, "lng": -118.38389021324463 }, { "lat": 33.9454025626007, "lng": -118.3830748217041 }, { "lat": 33.945491565765245, "lng": -118.38348251747436 }, { "lat": 33.94622138820407, "lng": -118.38436228203125 }, { "lat": 33.94590097912345, "lng": -118.38346105980224 }, { "lat": 33.945722973557515, "lng": -118.38268858360595 }, { "lat": 33.94575857470048, "lng": -118.37625128197021 }, { "lat": 33.94590097912345, "lng": -118.37554317879028 }, { "lat": 33.94611458531122, "lng": -118.37659460472412 }, { "lat": 33.94588317858363, "lng": -118.37607962059326 }, { "lat": 33.946559596480675, "lng": -118.37629419731445 }, { "lat": 33.945972181245615, "lng": -118.37558609413452 }, { "lat": 33.945972181245615, "lng": -118.37650877403564 }]);
// 75

/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{ "lat": 33.94735558829705, "lng": -118.3858394349391 }, { "lat": 33.94646557195489, "lng": -118.38607546933241 }, { "lat": 33.94708858437159, "lng": -118.38607546933241 }, { "lat": 33.94621636571135, "lng": -118.38598963864393 }, { "lat": 33.9481209949078, "lng": -118.38541028149672 }, { "lat": 33.94756919083433, "lng": -118.38551756985731 }, { "lat": 33.947337788061404, "lng": -118.38534590848036 }, { "lat": 33.94817439511215, "lng": -118.38581797726698 }, { "lat": 33.94731998782205, "lng": -118.38513133175917 }, { "lat": 33.95305147249939, "lng": -118.38905808575697 }, { "lat": 33.953193864720056, "lng": -118.38970181592055 }, { "lat": 33.95314046766522, "lng": -118.38871476300307 }, { "lat": 33.95417280478688, "lng": -118.38847872860975 }, { "lat": 33.95283788372169, "lng": -118.38804957516737 }, { "lat": 33.95290908004049, "lng": -118.38862893231459 }, { "lat": 33.95296247724051, "lng": -118.38770625241347 }, { "lat": 33.95322116773954, "lng": -118.38684797286987 }, { "lat": 33.952695490905356, "lng": -118.38667628415175 }, { "lat": 33.95307930683466, "lng": -118.38616130002089 }, { "lat": 33.95318610098755, "lng": -118.38907954342909 }, { "lat": 33.95297251254773, "lng": -118.3859467232997 }, { "lat": 33.95154857591526, "lng": -118.38547465451308 }, { "lat": 33.95090779665722, "lng": -118.38532445080824 }, { "lat": 33.950373810256536, "lng": -118.3853888238246 }, { "lat": 33.95033821104404, "lng": -118.3849382127101 }, { "lat": 33.95003561713647, "lng": -118.3854961121852 }, { "lat": 33.94991101933238, "lng": -118.3853888238246 }, { "lat": 33.95129938455491, "lng": -118.3848309243495 }, { "lat": 33.951317183961976, "lng": -118.38513133175917 }, { "lat": 33.95053400652856, "lng": -118.3854961121852 }, { "lat": 33.950053416807854, "lng": -118.38560340054579 }, { "lat": 33.94823783114855, "lng": -118.38571068890639 }, { "lat": 33.95008901613951, "lng": -118.38543173916884 }, { "lat": 33.94861163136227, "lng": -118.38553902752943 }, { "lat": 33.947436825162384, "lng": -118.38558194287367 }, { "lat": 33.946155199904595, "lng": -118.385281535464 }, { "lat": 33.94649287713301, "lng": -118.3848524093628 }, { "lat": 33.95140618094154, "lng": -118.38547465451308 }, { "lat": 33.95108579137955, "lng": -118.38491675503798 }, { "lat": 33.95016021475812, "lng": -118.38541028149672 }, { "lat": 33.95021361368296, "lng": -118.38470217831679 }, { "lat": 33.95062300432715, "lng": -118.38515278943129 }, { "lat": 33.951245986311314, "lng": -118.38515278943129 }, { "lat": 33.95090779665722, "lng": -118.3854961121852 }, { "lat": 33.952936914422324, "lng": -118.38641879208632 }, { "lat": 33.95288351720628, "lng": -118.38798520215101 }, { "lat": 33.95291911535402, "lng": -118.38882205136366 }, { "lat": 33.952936914422324, "lng": -118.38927266247816 }, { "lat": 33.954147242332276, "lng": -118.38925120480604 }, { "lat": 33.95427183393397, "lng": -118.38845727093764 }, { "lat": 33.95439642535322, "lng": -118.38899371274061 }, { "lat": 33.95439642535322, "lng": -118.38884350903578 }, { "lat": 33.95439642535322, "lng": -118.38882205136366 }, { "lat": 33.95517956723978, "lng": -118.38826415188856 }, { "lat": 33.95466340635158, "lng": -118.38747021802016 }, { "lat": 33.95284791904363, "lng": -118.38845727093764 }, { "lat": 33.9527055262441, "lng": -118.38787791379042 }, { "lat": 33.950872197668076, "lng": -118.38566777356215 }, { "lat": 33.95010681579974, "lng": -118.38562485821791 }, { "lat": 33.95051620695766, "lng": -118.38562485821791 }, { "lat": 33.95163757265285, "lng": -118.38564631589003 }, { "lat": 33.95078320013008, "lng": -118.38543173916884 }, { "lat": 33.95021361368296, "lng": -118.38515278943129 }, { "lat": 33.95126378572958, "lng": -118.38562485821791 }, { "lat": 33.95088999716451, "lng": -118.38530299313612 }, { "lat": 33.95083659866405, "lng": -118.38547465451308 }, { "lat": 33.950373810256536, "lng": -118.38508841641493 }, { "lat": 33.950320411432195, "lng": -118.38545319684096 }, { "lat": 33.94996441841361, "lng": -118.38556048520155 }]);
// 69

/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"global-modal",on:{"click":_vm.close}},[_c('div',{staticClass:"global-modal-content"},[_c('div',{staticClass:"tnc-report",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"title"},[_vm._v("Please select the start and end dates:")]),_vm._v(" "),_c('div',{staticClass:"row expanded"},[_c('div',{staticClass:"small-6 column padding-R"},[_c('div',{staticClass:"date-input"},[_c('label',[_vm._v("Start Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}})],1)]),_vm._v(" "),_c('div',{staticClass:"small-6 column padding-L"},[_c('div',{staticClass:"date-input"},[_c('label',[_vm._v("End Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"instruction"},[_vm._v("Select the reports to generate:")]),_vm._v(" "),_c('div',{staticClass:"report-select"},[_c('label',{staticClass:"check-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports[0]),expression:"selectedReports[0]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports[0])?_vm._i(_vm.selectedReports[0],null)>-1:(_vm.selectedReports[0])},on:{"change":function($event){var $$a=_vm.selectedReports[0],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, 0, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, 0, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, 0, $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("01 - Hourly Traffic")])]),_vm._v(" "),_c('label',{staticClass:"check-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports[1]),expression:"selectedReports[1]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports[1])?_vm._i(_vm.selectedReports[1],null)>-1:(_vm.selectedReports[1])},on:{"change":function($event){var $$a=_vm.selectedReports[1],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, 1, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, 1, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, 1, $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("02 - Daily Traffic")])]),_vm._v(" "),_c('label',{staticClass:"check-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports[2]),expression:"selectedReports[2]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports[2])?_vm._i(_vm.selectedReports[2],null)>-1:(_vm.selectedReports[2])},on:{"change":function($event){var $$a=_vm.selectedReports[2],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, 2, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, 2, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, 2, $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("03 - Account Trip Summary")])]),_vm._v(" "),_c('label',{staticClass:"check-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports[3]),expression:"selectedReports[3]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports[3])?_vm._i(_vm.selectedReports[3],null)>-1:(_vm.selectedReports[3])},on:{"change":function($event){var $$a=_vm.selectedReports[3],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, 3, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, 3, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, 3, $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("04 - Trip Detail")])]),_vm._v(" "),_c('label',{staticClass:"check-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports[4]),expression:"selectedReports[4]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports[4])?_vm._i(_vm.selectedReports[4],null)>-1:(_vm.selectedReports[4])},on:{"change":function($event){var $$a=_vm.selectedReports[4],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, 4, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, 4, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, 4, $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("05 - Assignment/Pick-Up Trip")])]),_vm._v(" "),_c('label',{staticClass:"check-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports[5]),expression:"selectedReports[5]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports[5])?_vm._i(_vm.selectedReports[5],null)>-1:(_vm.selectedReports[5])},on:{"change":function($event){var $$a=_vm.selectedReports[5],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, 5, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, 5, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, 5, $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("06 - Active Accounts")])]),_vm._v(" "),_c('label',{staticClass:"check-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports[6]),expression:"selectedReports[6]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports[6])?_vm._i(_vm.selectedReports[6],null)>-1:(_vm.selectedReports[6])},on:{"change":function($event){var $$a=_vm.selectedReports[6],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, 6, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, 6, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, 6, $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("07 - Assignment Area Details")])]),_vm._v(" "),_c('label',{staticClass:"check-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports[7]),expression:"selectedReports[7]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports[7])?_vm._i(_vm.selectedReports[7],null)>-1:(_vm.selectedReports[7])},on:{"change":function($event){var $$a=_vm.selectedReports[7],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, 7, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, 7, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, 7, $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("08 - Assignment Area Daily Count")])]),_vm._v(" "),_c('label',{staticClass:"check-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports[8]),expression:"selectedReports[8]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports[8])?_vm._i(_vm.selectedReports[8],null)>-1:(_vm.selectedReports[8])},on:{"change":function($event){var $$a=_vm.selectedReports[8],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, 8, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, 8, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, 8, $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("09 - Assignment Area Monthly Average")])]),_vm._v(" "),_c('label',{staticClass:"check-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports[9]),expression:"selectedReports[9]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports[9])?_vm._i(_vm.selectedReports[9],null)>-1:(_vm.selectedReports[9])},on:{"change":function($event){var $$a=_vm.selectedReports[9],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, 9, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, 9, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, 9, $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("10 - ABT Report (LAX)")])]),_vm._v(" "),_c('label',{staticClass:"check-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports[10]),expression:"selectedReports[10]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports[10])?_vm._i(_vm.selectedReports[10],null)>-1:(_vm.selectedReports[10])},on:{"change":function($event){var $$a=_vm.selectedReports[10],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, 10, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, 10, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, 10, $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("11 - PUC Report")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.show),expression:"error.show"}],staticClass:"error"},[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('a',{class:{ 'button cta success small block': true, disabled: _vm.isLoading },attrs:{"href":"javascript:;"},on:{"click":_vm.generateTNC}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}]},[_vm._v("Generate and Download Report")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrxReport_vue__ = __webpack_require__(522);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05008ac8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrxReport_vue__ = __webpack_require__(1477);
function injectStyle (ssrContext) {
  __webpack_require__(1475)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05008ac8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrxReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05008ac8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrxReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1476);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("58ce8b0e", content, true, {});

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.rsvp-report-box[data-v-05008ac8] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-05008ac8] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-05008ac8] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-05008ac8] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-05008ac8] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-05008ac8] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-05008ac8] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-05008ac8] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-05008ac8] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-05008ac8]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-05008ac8] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-05008ac8] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-05008ac8] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-05008ac8] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-05008ac8]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-05008ac8], .rsvp-report .reports .report.loading[data-v-05008ac8], .rsvp-report .reports .report.has-error[data-v-05008ac8], .rsvp-report .reports .report.success[data-v-05008ac8] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-05008ac8] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-05008ac8] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-05008ac8] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-05008ac8] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-05008ac8] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-05008ac8] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-05008ac8] {\n    cursor: pointer;\n}\n.filter input[data-v-05008ac8] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.download-type[data-v-05008ac8] {\n  float: right;\n  width: 150px;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-05008ac8] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-05008ac8] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-05008ac8] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-05008ac8] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-05008ac8] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-05008ac8] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-05008ac8] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-05008ac8] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-05008ac8]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-05008ac8] {\n      font-size: 13px;\n}\n.form-group[data-v-05008ac8] {\n  display: block;\n}\n.form-group .instruction[data-v-05008ac8] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-05008ac8] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox > *[data-v-05008ac8] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-05008ac8] {\n    margin-right: 3px;\n}\n.padding-R[data-v-05008ac8] {\n  padding-right: 7px;\n}\n.padding-L[data-v-05008ac8] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-05008ac8] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#pdf-view .page[data-v-05008ac8] {\n    padding: 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-05008ac8] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-05008ac8] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-05008ac8] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-05008ac8] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-05008ac8] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-05008ac8] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-05008ac8], #pdf-view table tbody tr.total[data-v-05008ac8] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-05008ac8] {\n      color: #000;\n      font-size: 15px;\n}\n#pdf-view table tbody td[data-v-05008ac8] {\n      padding: 2px 3px;\n}\n.trx-summary[data-v-05008ac8] {\n  height: 1122px !important;\n  width: 793px !important;\n}\n.trx-summary table tbody tr.total[data-v-05008ac8] {\n    border-top: 1px solid #333;\n}\n.trx-summary table .date[data-v-05008ac8], .trx-summary table .rsvpCount[data-v-05008ac8], .trx-summary table .trxCount[data-v-05008ac8], .trx-summary table .purchaseCount[data-v-05008ac8], .trx-summary table .additionalCount[data-v-05008ac8],\n  .trx-summary table .chargedTrxCount[data-v-05008ac8], .trx-summary table .refundTrxCount[data-v-05008ac8] {\n    text-align: center;\n}\n.trx-summary table .totalCharges[data-v-05008ac8], .trx-summary table .chargedAmount[data-v-05008ac8], .trx-summary table .refundAmount[data-v-05008ac8], .trx-summary table .netTotal[data-v-05008ac8] {\n    text-align: right;\n}\n.trx-detailed[data-v-05008ac8] {\n  height: 1122px !important;\n  width: 793px !important;\n}\n.trx-detailed table tbody tr.total[data-v-05008ac8] {\n    border-top: 1px solid #333;\n}\n.trx-detailed table .date[data-v-05008ac8], .trx-detailed table .rsvpId[data-v-05008ac8], .trx-detailed table .invoiceId[data-v-05008ac8], .trx-detailed table .customer[data-v-05008ac8], .trx-detailed table .cardOwner[data-v-05008ac8], .trx-detailed table .transactionType[data-v-05008ac8] {\n    text-align: center;\n}\n.trx-detailed table .chargedAmount[data-v-05008ac8], .trx-detailed table .refundAmount[data-v-05008ac8] {\n    text-align: right;\n}\n.trx-detailed table .transactionType[data-v-05008ac8] {\n    text-transform: capitalize;\n}\n.trx-creditcard table tr.total[data-v-05008ac8] {\n  border-top: 1px solid #333;\n}\n.trx-creditcard table .rsvp[data-v-05008ac8] {\n  text-align: center;\n}\n.trx-creditcard table .charged[data-v-05008ac8], .trx-creditcard table .postAuthorized[data-v-05008ac8], .trx-creditcard table .credits[data-v-05008ac8], .trx-creditcard table .authorized[data-v-05008ac8], .trx-creditcard table .declines[data-v-05008ac8], .trx-creditcard table .failed[data-v-05008ac8],\n.trx-creditcard table .notProcessed[data-v-05008ac8], .trx-creditcard table .canceled[data-v-05008ac8], .trx-creditcard table .other[data-v-05008ac8] {\n  text-align: right;\n}\n.slide-down-enter-active[data-v-05008ac8], .slide-down-leave-active[data-v-05008ac8] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-05008ac8], .slide-down-leave-to[data-v-05008ac8] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.end-date[data-v-05008ac8] .vdp-datepicker__calendar {\n    right: 1px;\n}\n.filter[data-v-05008ac8] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Reports/TrxReport.vue"],"names":[],"mappings":";AACA;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,qBAAqB;CACtB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,eAAe;CACpB;AACD;MACM,cAAc;MACd,aAAa;MACb,cAAc;MACd,yBAAyB;MACzB,sBAAsB;MACtB,iBAAiB;MACjB,sBAAsB;MACtB,gBAAgB;MAChB,YAAY;MACZ,wDAAwD;MACxD,6BAA6B;MAC7B,+BAA+B;CACpC;AACD;QACQ,0BAA0B;CACjC;AACD;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;CACtB;AACD;MACM,mBAAmB;MACnB,WAAW;CAChB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,+BAA+B;CACtC;AACD;UACU,YAAY;CACrB;AACD;QACQ,kBAAkB;QAClB,oBAAoB;QACpB,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,iCAAiC;QACjC,yBAAyB;CAChC;AACD;UACU,oBAAoB;UACpB,mBAAmB;CAC5B;AACD;UACU,oBAAoB;CAC7B;AACD;QACQ,WAAW;QACX,+CAA+C;gBACvC,uCAAuC;CACtD;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,cAAc;IACd,YAAY;CACf;AACD;IACI,gBAAgB;CACnB;AACD;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;CAC1B;AACD;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,oBAAoB;CACrB;AACD;IACI,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;CAC1B;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,gBAAgB;MAChB,cAAc;MACd,YAAY;MACZ,qBAAqB;CAC1B;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;CACtB;AACD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;IACI,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,iBAAiB;CACpB;AACD;MACM,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;CACxB;AACD;MACM,gBAAgB;CACrB;AACD;EACE,eAAe;CAChB;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,YAAY;CACf;AACD;IACI,kBAAkB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,aAAa;EACb,eAAe;EACf,iBAAiB;CAClB;AACD;IACI,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,aAAa;CAChB;AACD;MACM,mBAAmB;MACnB,aAAa;MACb,YAAY;MACZ,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;CACxB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;CACf;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,iBAAiB;CACtB;AACD;QACQ,8BAA8B;CACrC;AACD;MACM,iBAAiB;CACtB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;MACM,iBAAiB;CACtB;AACD;EACE,0BAA0B;EAC1B,wBAAwB;CACzB;AACD;IACI,2BAA2B;CAC9B;AACD;;IAEI,mBAAmB;CACtB;AACD;IACI,kBAAkB;CACrB;AACD;EACE,0BAA0B;EAC1B,wBAAwB;CACzB;AACD;IACI,2BAA2B;CAC9B;AACD;IACI,mBAAmB;CACtB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,2BAA2B;CAC9B;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,mBAAmB;CACpB;AACD;;EAEE,kBAAkB;CACnB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;AACA;IACI,WAAW;CACd;AACD;IACI,6BAA6B;IAC7B,8BAA8B;QAC1B,2BAA2B;YACvB,uBAAuB;CAClC;CACA","file":"TrxReport.vue","sourcesContent":["\n.rsvp-report-box[data-v-05008ac8] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-05008ac8] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-05008ac8] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-05008ac8] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-05008ac8] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-05008ac8] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-05008ac8] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-05008ac8] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-05008ac8] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-05008ac8]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-05008ac8] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-05008ac8] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-05008ac8] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-05008ac8] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-05008ac8]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-05008ac8], .rsvp-report .reports .report.loading[data-v-05008ac8], .rsvp-report .reports .report.has-error[data-v-05008ac8], .rsvp-report .reports .report.success[data-v-05008ac8] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-05008ac8] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-05008ac8] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-05008ac8] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-05008ac8] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-05008ac8] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-05008ac8] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-05008ac8] {\n    cursor: pointer;\n}\n.filter input[data-v-05008ac8] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.download-type[data-v-05008ac8] {\n  float: right;\n  width: 150px;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-05008ac8] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-05008ac8] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-05008ac8] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-05008ac8] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-05008ac8] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-05008ac8] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-05008ac8] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-05008ac8] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-05008ac8]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-05008ac8] {\n      font-size: 13px;\n}\n.form-group[data-v-05008ac8] {\n  display: block;\n}\n.form-group .instruction[data-v-05008ac8] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-05008ac8] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox > *[data-v-05008ac8] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-05008ac8] {\n    margin-right: 3px;\n}\n.padding-R[data-v-05008ac8] {\n  padding-right: 7px;\n}\n.padding-L[data-v-05008ac8] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-05008ac8] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#pdf-view .page[data-v-05008ac8] {\n    padding: 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-05008ac8] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-05008ac8] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-05008ac8] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-05008ac8] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-05008ac8] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-05008ac8] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-05008ac8], #pdf-view table tbody tr.total[data-v-05008ac8] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-05008ac8] {\n      color: #000;\n      font-size: 15px;\n}\n#pdf-view table tbody td[data-v-05008ac8] {\n      padding: 2px 3px;\n}\n.trx-summary[data-v-05008ac8] {\n  height: 1122px !important;\n  width: 793px !important;\n}\n.trx-summary table tbody tr.total[data-v-05008ac8] {\n    border-top: 1px solid #333;\n}\n.trx-summary table .date[data-v-05008ac8], .trx-summary table .rsvpCount[data-v-05008ac8], .trx-summary table .trxCount[data-v-05008ac8], .trx-summary table .purchaseCount[data-v-05008ac8], .trx-summary table .additionalCount[data-v-05008ac8],\n  .trx-summary table .chargedTrxCount[data-v-05008ac8], .trx-summary table .refundTrxCount[data-v-05008ac8] {\n    text-align: center;\n}\n.trx-summary table .totalCharges[data-v-05008ac8], .trx-summary table .chargedAmount[data-v-05008ac8], .trx-summary table .refundAmount[data-v-05008ac8], .trx-summary table .netTotal[data-v-05008ac8] {\n    text-align: right;\n}\n.trx-detailed[data-v-05008ac8] {\n  height: 1122px !important;\n  width: 793px !important;\n}\n.trx-detailed table tbody tr.total[data-v-05008ac8] {\n    border-top: 1px solid #333;\n}\n.trx-detailed table .date[data-v-05008ac8], .trx-detailed table .rsvpId[data-v-05008ac8], .trx-detailed table .invoiceId[data-v-05008ac8], .trx-detailed table .customer[data-v-05008ac8], .trx-detailed table .cardOwner[data-v-05008ac8], .trx-detailed table .transactionType[data-v-05008ac8] {\n    text-align: center;\n}\n.trx-detailed table .chargedAmount[data-v-05008ac8], .trx-detailed table .refundAmount[data-v-05008ac8] {\n    text-align: right;\n}\n.trx-detailed table .transactionType[data-v-05008ac8] {\n    text-transform: capitalize;\n}\n.trx-creditcard table tr.total[data-v-05008ac8] {\n  border-top: 1px solid #333;\n}\n.trx-creditcard table .rsvp[data-v-05008ac8] {\n  text-align: center;\n}\n.trx-creditcard table .charged[data-v-05008ac8], .trx-creditcard table .postAuthorized[data-v-05008ac8], .trx-creditcard table .credits[data-v-05008ac8], .trx-creditcard table .authorized[data-v-05008ac8], .trx-creditcard table .declines[data-v-05008ac8], .trx-creditcard table .failed[data-v-05008ac8],\n.trx-creditcard table .notProcessed[data-v-05008ac8], .trx-creditcard table .canceled[data-v-05008ac8], .trx-creditcard table .other[data-v-05008ac8] {\n  text-align: right;\n}\n.slide-down-enter-active[data-v-05008ac8], .slide-down-leave-active[data-v-05008ac8] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-05008ac8], .slide-down-leave-to[data-v-05008ac8] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.end-date[data-v-05008ac8] .vdp-datepicker__calendar {\n    right: 1px;\n}\n.filter[data-v-05008ac8] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rsvp-report-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"instruction"},[_vm._v("Please select a start and end date:")]),_vm._v(" "),_c('div',{staticClass:"row expanded"},[_c('div',{staticClass:"small-6 column padding-R"},[_c('div',{staticClass:"date-input"},[_c('label',[_vm._v("Start Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}})],1)]),_vm._v(" "),_c('div',{staticClass:"small-6 column padding-L"},[_c('div',{staticClass:"date-input end-date"},[_c('label',[_vm._v("End Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row expanded"},[_c('div',{staticClass:"instruction"},[_vm._v("Please select a filter:")]),_vm._v(" "),_c('ul',{staticClass:"filter"},[_c('li',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nonCompletedChecked),expression:"nonCompletedChecked"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.nonCompletedChecked)?_vm._i(_vm.nonCompletedChecked,null)>-1:(_vm.nonCompletedChecked)},on:{"change":function($event){var $$a=_vm.nonCompletedChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.nonCompletedChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.nonCompletedChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.nonCompletedChecked=$$c}}}}),_vm._v(" "),_c('span',[_vm._v("Include Original Purchases")])])]),_vm._v(" "),_c('li',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.purchasedChecked),expression:"purchasedChecked"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.purchasedChecked)?_vm._i(_vm.purchasedChecked,null)>-1:(_vm.purchasedChecked)},on:{"change":function($event){var $$a=_vm.purchasedChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.purchasedChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.purchasedChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.purchasedChecked=$$c}}}}),_vm._v(" "),_c('span',[_vm._v("Include Purchased Tip")])])]),_vm._v(" "),_c('li',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.canceledChecked),expression:"canceledChecked"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.canceledChecked)?_vm._i(_vm.canceledChecked,null)>-1:(_vm.canceledChecked)},on:{"change":function($event){var $$a=_vm.canceledChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.canceledChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.canceledChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.canceledChecked=$$c}}}}),_vm._v(" "),_c('span',[_vm._v("Include Purchased Cancelled")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"list-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"download-type"},[_c('label',{class:{'pdf':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pdfChecked),expression:"pdfChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.pdfChecked)?_vm._i(_vm.pdfChecked,null)>-1:(_vm.pdfChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.pdfChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.pdfChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.pdfChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.pdfChecked=$$c}}}}),_vm._v("\n            PDF\n          ")]),_vm._v(" "),_c('label',{class:{'csv':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.csvChecked),expression:"csvChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.csvChecked)?_vm._i(_vm.csvChecked,null)>-1:(_vm.csvChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.csvChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.csvChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.csvChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.csvChecked=$$c}}}}),_vm._v("\n            CSV\n          ")])]),_vm._v(" "),_c('div',{staticClass:"instruction"},[_vm._v("Please select the reports to generate:")]),_vm._v(" "),_c('div',{staticClass:"row expanded reports"},[_c('div',{class:['small-12 column report', _vm.reportStatus.trxSummary, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.trxSummary),expression:"selectedReports.trxSummary"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.trxSummary)?_vm._i(_vm.selectedReports.trxSummary,null)>-1:(_vm.selectedReports.trxSummary)},on:{"change":function($event){var $$a=_vm.selectedReports.trxSummary,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "trxSummary", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "trxSummary", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "trxSummary", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('trxSummary')))])])]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.trxDetailed, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.trxDetailed),expression:"selectedReports.trxDetailed"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.trxDetailed)?_vm._i(_vm.selectedReports.trxDetailed,null)>-1:(_vm.selectedReports.trxDetailed)},on:{"change":function($event){var $$a=_vm.selectedReports.trxDetailed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "trxDetailed", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "trxDetailed", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "trxDetailed", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('trxDetailed')))])])]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.trxByCreditCard, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.trxByCreditCard),expression:"selectedReports.trxByCreditCard"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.trxByCreditCard)?_vm._i(_vm.selectedReports.trxByCreditCard,null)>-1:(_vm.selectedReports.trxByCreditCard)},on:{"change":function($event){var $$a=_vm.selectedReports.trxByCreditCard,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "trxByCreditCard", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "trxByCreditCard", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "trxByCreditCard", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('trxByCreditCard')))])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.show),expression:"error.show"}],staticClass:"error"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.message),expression:"!!error.message"}]},[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.empty.length),expression:"error.empty.length"}]},[_c('li',[_vm._v("Empty Result:")]),_vm._v(" "),_vm._l((_vm.error.empty),function(empty){return _c('li',[_vm._v("- "+_vm._s(empty))])})],2)])]),_vm._v(" "),_c('a',{class:{ 'button cta success small block': true, disabled: _vm.pdf.loading },attrs:{"href":"javascript:;"},on:{"click":_vm.startProcess}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.pdf.loading),expression:"pdf.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pdf.loading),expression:"!pdf.loading"}]},[_vm._v("Generate and Download Report")])])],1),_vm._v(" "),_c('div',{class:[_vm.pdf.class],attrs:{"id":"pdf-view"}},[_vm._l((_vm.pdf.table.data),function(pageData,pageIndex){return _c('div',{class:['page', pageIndex]},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',_vm._l((_vm.pdf.table.label),function(label){return _c('th',{domProps:{"innerHTML":_vm._s(label)}})}),0)]),_vm._v(" "),_c('tbody',[_vm._l((pageData),function(data,index){return _c('tr',_vm._l((data),function(value,i){return _c('td',{class:[i]},[_vm._v(_vm._s(value))])}),0)}),_vm._v(" "),(_vm.isTrxSummary && _vm.currentPage(pageIndex) == _vm.totalPage)?_c('tr',{staticClass:"total"},[_c('td',{staticClass:"date"},[_vm._v("Total")]),_vm._v(" "),_c('td',{staticClass:"trxCount"},[_vm._v(_vm._s(_vm.pdf.table.total.trx))]),_vm._v(" "),_c('td',{staticClass:"chargedTrxCount"},[_vm._v(_vm._s(_vm.pdf.table.total.chargedTrx))]),_vm._v(" "),_c('td',{staticClass:"chargedAmount"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.charged))]),_vm._v(" "),_c('td',{staticClass:"refundTrxCount"},[_vm._v(_vm._s(_vm.pdf.table.total.refundTrx))]),_vm._v(" "),_c('td',{staticClass:"refundAmount"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.refund))]),_vm._v(" "),_c('td',{staticClass:"netTotal"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.net))])]):_vm._e(),_vm._v(" "),(_vm.isTrxDetailed && _vm.currentPage(pageIndex) == _vm.totalPage)?_c('tr',{staticClass:"total"},[_c('td',{attrs:{"colspan":"5"}}),_vm._v(" "),_c('td',{staticClass:"transactionType"},[_vm._v("Record Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"chargedAmount"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.charged))]),_vm._v(" "),_c('td',{staticClass:"chargedAmount"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.refund))])]):_vm._e(),_vm._v(" "),(_vm.isTrxByCreditCard && _vm.currentPage(pageIndex) == _vm.totalPage)?_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Totals")]),_vm._v(" "),_c('td',{staticClass:"rsvp"},[_vm._v(_vm._s(_vm.pdf.table.total.rsvp))]),_vm._v(" "),_c('td',{staticClass:"charged"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.charged))]),_vm._v(" "),_c('td',{staticClass:"canceled"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.canceled))])]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"page-count"},[_vm._v("page "+_vm._s(_vm.currentPage(pageIndex))+" of "+_vm._s(_vm.totalPage))])])}),_vm._v(" "),(Object.keys(_vm.pdf.table.data).length)?_c('div',{class:['page', ("page" + (Object.keys(_vm.pdf.table.data).length + 1))]},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',_vm._l((_vm.pdf.table.label),function(label){return _c('th',{domProps:{"innerHTML":_vm._s(label)}})}),0)]),_vm._v(" "),_c('tbody',[_vm._l((_vm.pdf.table.data[("page" + (Object.keys(_vm.pdf.table.data).length))]),function(data,index){return _c('tr',{key:index},_vm._l((data),function(value,i){return _c('td',{key:i,class:[i]},[_vm._v(_vm._s(value))])}),0)}),_vm._v(" "),(_vm.isTrxSummary)?_c('tr',{staticClass:"total"},[_c('td',{staticClass:"date"},[_vm._v("Total")]),_vm._v(" "),_c('td',{staticClass:"trxCount"},[_vm._v(_vm._s(_vm.pdf.table.total.trx))]),_vm._v(" "),_c('td',{staticClass:"chargedTrxCount"},[_vm._v(_vm._s(_vm.pdf.table.total.chargedTrx))]),_vm._v(" "),_c('td',{staticClass:"chargedAmount"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.charged))]),_vm._v(" "),_c('td',{staticClass:"refundTrxCount"},[_vm._v(_vm._s(_vm.pdf.table.total.refundTrx))]),_vm._v(" "),_c('td',{staticClass:"refundAmount"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.refund))]),_vm._v(" "),_c('td',{staticClass:"netTotal"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.net))])]):_vm._e(),_vm._v(" "),(_vm.isTrxDetailed)?_c('tr',{staticClass:"total"},[_c('td',{attrs:{"colspan":"5"}}),_vm._v(" "),_c('td',{staticClass:"transactionType"},[_vm._v("Record Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"chargedAmount"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.charged))]),_vm._v(" "),_c('td',{staticClass:"chargedAmount"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.refund))])]):_vm._e(),_vm._v(" "),(_vm.isTrxByCreditCard)?_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Totals")]),_vm._v(" "),_c('td',{staticClass:"rsvp"},[_vm._v(_vm._s(_vm.pdf.table.total.rsvp))]),_vm._v(" "),_c('td',{staticClass:"charged"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.charged))]),_vm._v(" "),_c('td',{staticClass:"canceled"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.canceled))])]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"page-count"},[_vm._v("page "+_vm._s(Object.keys(_vm.pdf.table.data).length)+" of "+_vm._s(_vm.totalPage))])]):_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpecializeReport_vue__ = __webpack_require__(523);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6517067c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpecializeReport_vue__ = __webpack_require__(1481);
function injectStyle (ssrContext) {
  __webpack_require__(1479)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6517067c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpecializeReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6517067c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpecializeReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1480);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("3fb1bdcd", content, true, {});

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.rsvp-report-box[data-v-6517067c] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-6517067c] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-6517067c] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-6517067c] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-6517067c] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-6517067c] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-6517067c] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-6517067c] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-6517067c] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-6517067c]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-6517067c] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-6517067c] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-6517067c] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-6517067c] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-6517067c]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-6517067c], .rsvp-report .reports .report.loading[data-v-6517067c], .rsvp-report .reports .report.has-error[data-v-6517067c], .rsvp-report .reports .report.success[data-v-6517067c] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-6517067c] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-6517067c] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-6517067c] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-6517067c] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-6517067c] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-6517067c] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-6517067c] {\n    cursor: pointer;\n}\n.filter input[data-v-6517067c] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.download-type[data-v-6517067c] {\n  float: right;\n  width: 150px;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-6517067c] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-6517067c] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-6517067c] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-6517067c] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-6517067c] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-6517067c] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-6517067c] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-6517067c] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-6517067c]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-6517067c] {\n      font-size: 13px;\n}\n.form-group[data-v-6517067c] {\n  display: block;\n}\n.form-group .instruction[data-v-6517067c] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-6517067c] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox > *[data-v-6517067c] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-6517067c] {\n    margin-right: 3px;\n}\n.note[data-v-6517067c] {\n  font-size: 11px;\n  letter-spacing: .6px;\n  padding-left: 30px;\n  display: block;\n  line-height: 1;\n  margin-bottom: 4px;\n  color: #777;\n}\n.padding-R[data-v-6517067c] {\n  padding-right: 7px;\n}\n.padding-L[data-v-6517067c] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-6517067c] {\n  position: fixed;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n  z-index: -1;\n}\n#pdf-view .page[data-v-6517067c] {\n    padding: 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-6517067c] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-6517067c] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-6517067c] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-6517067c] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-6517067c] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-6517067c] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-6517067c], #pdf-view table tbody tr.total[data-v-6517067c] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-6517067c] {\n      color: #000;\n      font-size: 12px;\n}\n#pdf-view table tbody td[data-v-6517067c] {\n      padding: 2px 3px;\n}\n.report-payout[data-v-6517067c] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.report-payout table tbody tr.total[data-v-6517067c] {\n    border-top: 1px solid #333;\n    font-weight: 600;\n    font-size: 11px !important;\n}\n.report-payout table .driverCount[data-v-6517067c], .report-payout table .rsvpCount[data-v-6517067c], .report-payout table .totalPax[data-v-6517067c], .report-payout table .avgPax[data-v-6517067c] {\n    text-align: center;\n}\n.report-payout table .gasFee[data-v-6517067c], .report-payout table .fare[data-v-6517067c], .report-payout table .totalFare[data-v-6517067c], .report-payout table .avgFare[data-v-6517067c], .report-payout table .travelInsurance[data-v-6517067c], .report-payout table .airportFee[data-v-6517067c], .report-payout table .extraFee[data-v-6517067c], .report-payout table .charged[data-v-6517067c], .report-payout table .payment[data-v-6517067c], .report-payout table .pickupFee[data-v-6517067c],\n  .report-payout table .tips[data-v-6517067c], .report-payout table .bonus[data-v-6517067c], .report-payout table .cancelFee[data-v-6517067c], .report-payout table .driverPayment[data-v-6517067c], .report-payout table .paymentPercent[data-v-6517067c], .report-payout table .driverPercent[data-v-6517067c] {\n    text-align: right;\n}\n.report-payout table .driverPayment[data-v-6517067c] {\n    font-weight: 600;\n}\n.report-payout table .gasFee[data-v-6517067c], .report-payout table .fare[data-v-6517067c], .report-payout table .travelInsurance[data-v-6517067c], .report-payout table .airportFee[data-v-6517067c], .report-payout table .payment[data-v-6517067c], .report-payout table .pickupFee[data-v-6517067c], .report-payout table .tips[data-v-6517067c], .report-payout table .bonus[data-v-6517067c], .report-payout table .cancelFee[data-v-6517067c] {\n    color: #777;\n}\n.report-payout table .company[data-v-6517067c] {\n    max-width: 130px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.service-brand[data-v-6517067c] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.service-brand .brand-box[data-v-6517067c] {\n    margin-bottom: 50px;\n}\n.service-brand table[data-v-6517067c] {\n    /*.fare, .airportFee, .payment, .pickupFee, .tips, .bonus, .cancelFee{ color: #777; }*/\n}\n.service-brand table tbody tr.total[data-v-6517067c] {\n      border-top: 1px solid #333;\n      font-weight: 600;\n}\n.service-brand table .rsvp[data-v-6517067c], .service-brand table .asap[data-v-6517067c], .service-brand table .web[data-v-6517067c], .service-brand table .admin[data-v-6517067c], .service-brand table .app[data-v-6517067c], .service-brand table .go[data-v-6517067c], .service-brand table .paxSum[data-v-6517067c], .service-brand table .paxAvg[data-v-6517067c] {\n      text-align: center;\n}\n.service-brand table .fareSum[data-v-6517067c], .service-brand table .fareAvg[data-v-6517067c], .service-brand table .farePP[data-v-6517067c] {\n      text-align: right;\n}\n.driver-payment-bonus[data-v-6517067c] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.driver-payment-bonus table .rsvpId[data-v-6517067c], .driver-payment-bonus table .brand[data-v-6517067c], .driver-payment-bonus table .updatedOn[data-v-6517067c], .driver-payment-bonus table .baseFare[data-v-6517067c], .driver-payment-bonus table .driverPayment[data-v-6517067c], .driver-payment-bonus table .bonus[data-v-6517067c], .driver-payment-bonus table .avgBonus[data-v-6517067c], .driver-payment-bonus table .totalDriverPayment[data-v-6517067c] {\n    text-align: center;\n}\n.driver-payment-bonus table .driverName[data-v-6517067c], .driver-payment-bonus table .updatedBy[data-v-6517067c] {\n    width: 150px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n#pdf-view.insurance[data-v-6517067c] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n#pdf-view.insurance table tbody td[data-v-6517067c] {\n    text-align: center;\n}\n#pdf-view.insurance .total-p[data-v-6517067c] {\n    text-align: left;\n}\n#pdf-view.insurance .total-p span[data-v-6517067c] {\n      display: inline-block;\n      margin: 0 10px;\n}\n#pdf-view.insurance table tbody tr.total[data-v-6517067c] {\n  border-top: 1px solid #333;\n}\n#pdf-view.insurance table .date[data-v-6517067c], #pdf-view.insurance table .rsvpCount[data-v-6517067c], #pdf-view.insurance table .asap[data-v-6517067c], #pdf-view.insurance table .web[data-v-6517067c], #pdf-view.insurance table .admin[data-v-6517067c], #pdf-view.insurance table .app[data-v-6517067c], #pdf-view.insurance table .insurance[data-v-6517067c] {\n  text-align: center;\n}\n#pdf-view.insurance table .totalFare[data-v-6517067c], #pdf-view.insurance table .avgFare[data-v-6517067c], #pdf-view.insurance table .extraFee[data-v-6517067c], #pdf-view.insurance table .driverPayment[data-v-6517067c], #pdf-view.insurance table .driverPercent[data-v-6517067c] {\n  text-align: right;\n}\n#pdf-view.insurance table .driver[data-v-6517067c], #pdf-view.insurance table .service[data-v-6517067c], #pdf-view.insurance table .promo[data-v-6517067c] {\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n#pdf-view.insurance table .geofences[data-v-6517067c] {\n  max-width: 110px;\n  font-size: 11px;\n}\n#pdf-view.insurance table .insurance[data-v-6517067c] {\n  max-width: 70px;\n}\n.insurance-email[data-v-6517067c] {\n  padding: 3px 10px;\n  margin: 0 10px 10px 25px;\n  width: calc(100% - 35px);\n  font-size: 13px;\n}\n.insurance-email[data-v-6517067c]::-webkit-input-placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: #777;\n    opacity: 1;\n    /* Firefox */\n}\n.insurance-email[data-v-6517067c]::-moz-placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: #777;\n    opacity: 1;\n    /* Firefox */\n}\n.insurance-email[data-v-6517067c]::-ms-input-placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: #777;\n    opacity: 1;\n    /* Firefox */\n}\n.insurance-email[data-v-6517067c]::placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: #777;\n    opacity: 1;\n    /* Firefox */\n}\n.portal-fee thead th[data-v-6517067c]:first-child {\n  text-align: left;\n}\n.portal-fee tbody tr.total[data-v-6517067c] {\n  border-top: 1px solid #333;\n}\n.portal-fee .rsvpID[data-v-6517067c], .portal-fee .baseFare[data-v-6517067c], .portal-fee .portalFee[data-v-6517067c] {\n  text-align: center;\n}\n.admin-box[data-v-6517067c] {\n  position: relative;\n  margin: 0 15px 15px 28px;\n}\n.admin-box input[data-v-6517067c] {\n    padding: 5px 8px;\n    margin: 0 0 5px;\n    font-size: 14px;\n}\n.admin-box ul[data-v-6517067c] {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    background: #fafafa;\n    border: 1px solid #ccc;\n    border-radius: 2px;\n    height: 100px;\n    overflow: auto;\n}\n.admin-box ul li[data-v-6517067c] {\n      display: block;\n      line-height: 1;\n      padding: 5px 8px;\n      font-size: 14px;\n      color: #333;\n}\n.admin-box ul li[data-v-6517067c]:hover {\n        background: #f3f3f3;\n}\n.modal[data-v-6517067c] {\n  position: fixed;\n  z-index: 12;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: none;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  resize: vertical;\n}\n.modal .bg-overlay[data-v-6517067c] {\n    position: absolute;\n    z-index: 1;\n    background: rgba(0, 0, 0, 0.5);\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n}\n.modal .modal-content[data-v-6517067c] {\n    position: relative;\n    z-index: 2;\n    background: #fff;\n    width: 400px;\n    min-height: 150px;\n    border-radius: 6px;\n    padding: 20px;\n    margin: auto;\n    -webkit-box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n    display: none;\n    text-align: center;\n}\n.modal.show[data-v-6517067c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.modal.show .modal-content[data-v-6517067c] {\n      display: block;\n      -webkit-animation: slide-down-data-v-6517067c .15s ease-out;\n      -moz-animation: slide-down-data-v-6517067c .15s ease-out;\n}\n@-webkit-keyframes slide-down-data-v-6517067c {\n0% {\n    opacity: 0;\n    -webkit-transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n}\n}\n.slide-down-enter-active[data-v-6517067c], .slide-down-leave-active[data-v-6517067c] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-6517067c], .slide-down-leave-to[data-v-6517067c] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.end-date[data-v-6517067c] .vdp-datepicker__calendar {\n    right: 1px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Reports/SpecializeReport.vue"],"names":[],"mappings":";AACA;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,qBAAqB;CACtB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,eAAe;CACpB;AACD;MACM,cAAc;MACd,aAAa;MACb,cAAc;MACd,yBAAyB;MACzB,sBAAsB;MACtB,iBAAiB;MACjB,sBAAsB;MACtB,gBAAgB;MAChB,YAAY;MACZ,wDAAwD;MACxD,6BAA6B;MAC7B,+BAA+B;CACpC;AACD;QACQ,0BAA0B;CACjC;AACD;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;CACtB;AACD;MACM,mBAAmB;MACnB,WAAW;CAChB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,+BAA+B;CACtC;AACD;UACU,YAAY;CACrB;AACD;QACQ,kBAAkB;QAClB,oBAAoB;QACpB,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,iCAAiC;QACjC,yBAAyB;CAChC;AACD;UACU,oBAAoB;UACpB,mBAAmB;CAC5B;AACD;UACU,oBAAoB;CAC7B;AACD;QACQ,WAAW;QACX,+CAA+C;gBACvC,uCAAuC;CACtD;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,cAAc;IACd,YAAY;CACf;AACD;IACI,gBAAgB;CACnB;AACD;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;CAC1B;AACD;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,oBAAoB;CACrB;AACD;IACI,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;CAC1B;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,gBAAgB;MAChB,cAAc;MACd,YAAY;MACZ,qBAAqB;CAC1B;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;CACtB;AACD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;IACI,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,iBAAiB;CACpB;AACD;MACM,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;CACxB;AACD;MACM,gBAAgB;CACrB;AACD;EACE,eAAe;CAChB;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,YAAY;CACf;AACD;IACI,kBAAkB;CACrB;AACD;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,YAAY;CACb;AACD;IACI,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,aAAa;CAChB;AACD;MACM,mBAAmB;MACnB,aAAa;MACb,YAAY;MACZ,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;CACxB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;CACf;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,iBAAiB;CACtB;AACD;QACQ,8BAA8B;CACrC;AACD;MACM,iBAAiB;CACtB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;MACM,iBAAiB;CACtB;AACD;EACE,yBAAyB;EACzB,yBAAyB;CAC1B;AACD;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,2BAA2B;CAC9B;AACD;IACI,mBAAmB;CACtB;AACD;;IAEI,kBAAkB;CACrB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,YAAY;CACf;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;IACxB,oBAAoB;CACvB;AACD;EACE,yBAAyB;EACzB,yBAAyB;CAC1B;AACD;IACI,oBAAoB;CACvB;AACD;IACI,uFAAuF;CAC1F;AACD;MACM,2BAA2B;MAC3B,iBAAiB;CACtB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,kBAAkB;CACvB;AACD;EACE,yBAAyB;EACzB,yBAAyB;CAC1B;AACD;IACI,mBAAmB;CACtB;AACD;IACI,aAAa;IACb,iBAAiB;IACjB,wBAAwB;IACxB,oBAAoB;CACvB;AACD;EACE,yBAAyB;EACzB,yBAAyB;CAC1B;AACD;IACI,mBAAmB;CACtB;AACD;IACI,iBAAiB;CACpB;AACD;MACM,sBAAsB;MACtB,eAAe;CACpB;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,iBAAiB;EACjB,gBAAgB;CACjB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;CACjB;AACD;IACI,0CAA0C;IAC1C,YAAY;IACZ,WAAW;IACX,aAAa;CAChB;AACD;IACI,0CAA0C;IAC1C,YAAY;IACZ,WAAW;IACX,aAAa;CAChB;AACD;IACI,0CAA0C;IAC1C,YAAY;IACZ,WAAW;IACX,aAAa;CAChB;AACD;IACI,0CAA0C;IAC1C,YAAY;IACZ,WAAW;IACX,aAAa;CAChB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,yBAAyB;CAC1B;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;CACnB;AACD;IACI,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,eAAe;CAClB;AACD;MACM,eAAe;MACf,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,YAAY;CACjB;AACD;QACQ,oBAAoB;CAC3B;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,iBAAiB;CAClB;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,OAAO;IACP,QAAQ;CACX;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,uDAAuD;YAC/C,+CAA+C;IACvD,cAAc;IACd,mBAAmB;CACtB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;MACM,eAAe;MACf,4DAA4D;MAC5D,yDAAyD;CAC9D;AACD;AACA;IACI,WAAW;IACX,oCAAoC;CACvC;AACD;IACI,WAAW;IACX,iCAAiC;CACpC;CACA;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;AACA;IACI,WAAW;CACd;CACA","file":"SpecializeReport.vue","sourcesContent":["\n.rsvp-report-box[data-v-6517067c] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-6517067c] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-6517067c] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-6517067c] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-6517067c] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-6517067c] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-6517067c] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-6517067c] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-6517067c] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-6517067c]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-6517067c] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-6517067c] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-6517067c] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-6517067c] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-6517067c]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-6517067c], .rsvp-report .reports .report.loading[data-v-6517067c], .rsvp-report .reports .report.has-error[data-v-6517067c], .rsvp-report .reports .report.success[data-v-6517067c] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-6517067c] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-6517067c] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-6517067c] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-6517067c] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-6517067c] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-6517067c] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-6517067c] {\n    cursor: pointer;\n}\n.filter input[data-v-6517067c] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.download-type[data-v-6517067c] {\n  float: right;\n  width: 150px;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-6517067c] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-6517067c] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-6517067c] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-6517067c] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-6517067c] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-6517067c] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-6517067c] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-6517067c] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-6517067c]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-6517067c] {\n      font-size: 13px;\n}\n.form-group[data-v-6517067c] {\n  display: block;\n}\n.form-group .instruction[data-v-6517067c] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-6517067c] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox > *[data-v-6517067c] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-6517067c] {\n    margin-right: 3px;\n}\n.note[data-v-6517067c] {\n  font-size: 11px;\n  letter-spacing: .6px;\n  padding-left: 30px;\n  display: block;\n  line-height: 1;\n  margin-bottom: 4px;\n  color: #777;\n}\n.padding-R[data-v-6517067c] {\n  padding-right: 7px;\n}\n.padding-L[data-v-6517067c] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-6517067c] {\n  position: fixed;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n  z-index: -1;\n}\n#pdf-view .page[data-v-6517067c] {\n    padding: 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-6517067c] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-6517067c] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-6517067c] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-6517067c] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-6517067c] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-6517067c] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-6517067c], #pdf-view table tbody tr.total[data-v-6517067c] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-6517067c] {\n      color: #000;\n      font-size: 12px;\n}\n#pdf-view table tbody td[data-v-6517067c] {\n      padding: 2px 3px;\n}\n.report-payout[data-v-6517067c] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.report-payout table tbody tr.total[data-v-6517067c] {\n    border-top: 1px solid #333;\n    font-weight: 600;\n    font-size: 11px !important;\n}\n.report-payout table .driverCount[data-v-6517067c], .report-payout table .rsvpCount[data-v-6517067c], .report-payout table .totalPax[data-v-6517067c], .report-payout table .avgPax[data-v-6517067c] {\n    text-align: center;\n}\n.report-payout table .gasFee[data-v-6517067c], .report-payout table .fare[data-v-6517067c], .report-payout table .totalFare[data-v-6517067c], .report-payout table .avgFare[data-v-6517067c], .report-payout table .travelInsurance[data-v-6517067c], .report-payout table .airportFee[data-v-6517067c], .report-payout table .extraFee[data-v-6517067c], .report-payout table .charged[data-v-6517067c], .report-payout table .payment[data-v-6517067c], .report-payout table .pickupFee[data-v-6517067c],\n  .report-payout table .tips[data-v-6517067c], .report-payout table .bonus[data-v-6517067c], .report-payout table .cancelFee[data-v-6517067c], .report-payout table .driverPayment[data-v-6517067c], .report-payout table .paymentPercent[data-v-6517067c], .report-payout table .driverPercent[data-v-6517067c] {\n    text-align: right;\n}\n.report-payout table .driverPayment[data-v-6517067c] {\n    font-weight: 600;\n}\n.report-payout table .gasFee[data-v-6517067c], .report-payout table .fare[data-v-6517067c], .report-payout table .travelInsurance[data-v-6517067c], .report-payout table .airportFee[data-v-6517067c], .report-payout table .payment[data-v-6517067c], .report-payout table .pickupFee[data-v-6517067c], .report-payout table .tips[data-v-6517067c], .report-payout table .bonus[data-v-6517067c], .report-payout table .cancelFee[data-v-6517067c] {\n    color: #777;\n}\n.report-payout table .company[data-v-6517067c] {\n    max-width: 130px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.service-brand[data-v-6517067c] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.service-brand .brand-box[data-v-6517067c] {\n    margin-bottom: 50px;\n}\n.service-brand table[data-v-6517067c] {\n    /*.fare, .airportFee, .payment, .pickupFee, .tips, .bonus, .cancelFee{ color: #777; }*/\n}\n.service-brand table tbody tr.total[data-v-6517067c] {\n      border-top: 1px solid #333;\n      font-weight: 600;\n}\n.service-brand table .rsvp[data-v-6517067c], .service-brand table .asap[data-v-6517067c], .service-brand table .web[data-v-6517067c], .service-brand table .admin[data-v-6517067c], .service-brand table .app[data-v-6517067c], .service-brand table .go[data-v-6517067c], .service-brand table .paxSum[data-v-6517067c], .service-brand table .paxAvg[data-v-6517067c] {\n      text-align: center;\n}\n.service-brand table .fareSum[data-v-6517067c], .service-brand table .fareAvg[data-v-6517067c], .service-brand table .farePP[data-v-6517067c] {\n      text-align: right;\n}\n.driver-payment-bonus[data-v-6517067c] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.driver-payment-bonus table .rsvpId[data-v-6517067c], .driver-payment-bonus table .brand[data-v-6517067c], .driver-payment-bonus table .updatedOn[data-v-6517067c], .driver-payment-bonus table .baseFare[data-v-6517067c], .driver-payment-bonus table .driverPayment[data-v-6517067c], .driver-payment-bonus table .bonus[data-v-6517067c], .driver-payment-bonus table .avgBonus[data-v-6517067c], .driver-payment-bonus table .totalDriverPayment[data-v-6517067c] {\n    text-align: center;\n}\n.driver-payment-bonus table .driverName[data-v-6517067c], .driver-payment-bonus table .updatedBy[data-v-6517067c] {\n    width: 150px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n#pdf-view.insurance[data-v-6517067c] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n#pdf-view.insurance table tbody td[data-v-6517067c] {\n    text-align: center;\n}\n#pdf-view.insurance .total-p[data-v-6517067c] {\n    text-align: left;\n}\n#pdf-view.insurance .total-p span[data-v-6517067c] {\n      display: inline-block;\n      margin: 0 10px;\n}\n#pdf-view.insurance table tbody tr.total[data-v-6517067c] {\n  border-top: 1px solid #333;\n}\n#pdf-view.insurance table .date[data-v-6517067c], #pdf-view.insurance table .rsvpCount[data-v-6517067c], #pdf-view.insurance table .asap[data-v-6517067c], #pdf-view.insurance table .web[data-v-6517067c], #pdf-view.insurance table .admin[data-v-6517067c], #pdf-view.insurance table .app[data-v-6517067c], #pdf-view.insurance table .insurance[data-v-6517067c] {\n  text-align: center;\n}\n#pdf-view.insurance table .totalFare[data-v-6517067c], #pdf-view.insurance table .avgFare[data-v-6517067c], #pdf-view.insurance table .extraFee[data-v-6517067c], #pdf-view.insurance table .driverPayment[data-v-6517067c], #pdf-view.insurance table .driverPercent[data-v-6517067c] {\n  text-align: right;\n}\n#pdf-view.insurance table .driver[data-v-6517067c], #pdf-view.insurance table .service[data-v-6517067c], #pdf-view.insurance table .promo[data-v-6517067c] {\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n#pdf-view.insurance table .geofences[data-v-6517067c] {\n  max-width: 110px;\n  font-size: 11px;\n}\n#pdf-view.insurance table .insurance[data-v-6517067c] {\n  max-width: 70px;\n}\n.insurance-email[data-v-6517067c] {\n  padding: 3px 10px;\n  margin: 0 10px 10px 25px;\n  width: calc(100% - 35px);\n  font-size: 13px;\n}\n.insurance-email[data-v-6517067c]::-webkit-input-placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: #777;\n    opacity: 1;\n    /* Firefox */\n}\n.insurance-email[data-v-6517067c]::-moz-placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: #777;\n    opacity: 1;\n    /* Firefox */\n}\n.insurance-email[data-v-6517067c]::-ms-input-placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: #777;\n    opacity: 1;\n    /* Firefox */\n}\n.insurance-email[data-v-6517067c]::placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: #777;\n    opacity: 1;\n    /* Firefox */\n}\n.portal-fee thead th[data-v-6517067c]:first-child {\n  text-align: left;\n}\n.portal-fee tbody tr.total[data-v-6517067c] {\n  border-top: 1px solid #333;\n}\n.portal-fee .rsvpID[data-v-6517067c], .portal-fee .baseFare[data-v-6517067c], .portal-fee .portalFee[data-v-6517067c] {\n  text-align: center;\n}\n.admin-box[data-v-6517067c] {\n  position: relative;\n  margin: 0 15px 15px 28px;\n}\n.admin-box input[data-v-6517067c] {\n    padding: 5px 8px;\n    margin: 0 0 5px;\n    font-size: 14px;\n}\n.admin-box ul[data-v-6517067c] {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    background: #fafafa;\n    border: 1px solid #ccc;\n    border-radius: 2px;\n    height: 100px;\n    overflow: auto;\n}\n.admin-box ul li[data-v-6517067c] {\n      display: block;\n      line-height: 1;\n      padding: 5px 8px;\n      font-size: 14px;\n      color: #333;\n}\n.admin-box ul li[data-v-6517067c]:hover {\n        background: #f3f3f3;\n}\n.modal[data-v-6517067c] {\n  position: fixed;\n  z-index: 12;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: none;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  resize: vertical;\n}\n.modal .bg-overlay[data-v-6517067c] {\n    position: absolute;\n    z-index: 1;\n    background: rgba(0, 0, 0, 0.5);\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n}\n.modal .modal-content[data-v-6517067c] {\n    position: relative;\n    z-index: 2;\n    background: #fff;\n    width: 400px;\n    min-height: 150px;\n    border-radius: 6px;\n    padding: 20px;\n    margin: auto;\n    -webkit-box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n    display: none;\n    text-align: center;\n}\n.modal.show[data-v-6517067c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.modal.show .modal-content[data-v-6517067c] {\n      display: block;\n      -webkit-animation: slide-down-data-v-6517067c .15s ease-out;\n      -moz-animation: slide-down-data-v-6517067c .15s ease-out;\n}\n@-webkit-keyframes slide-down-data-v-6517067c {\n0% {\n    opacity: 0;\n    -webkit-transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n}\n}\n.slide-down-enter-active[data-v-6517067c], .slide-down-leave-active[data-v-6517067c] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-6517067c], .slide-down-leave-to[data-v-6517067c] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.end-date[data-v-6517067c] .vdp-datepicker__calendar {\n    right: 1px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rsvp-report-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"instruction"},[_vm._v("Please select a start and end date:")]),_vm._v(" "),_c('div',{staticClass:"row expanded"},[_c('div',{staticClass:"small-6 column padding-R"},[_c('div',{staticClass:"date-input"},[_c('label',[_vm._v("Start Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}})],1)]),_vm._v(" "),_c('div',{staticClass:"small-6 column padding-L"},[_c('div',{staticClass:"date-input end-date"},[_c('label',[_vm._v("End Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"list-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"download-type"},[_c('label',{class:{'pdf':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pdfChecked),expression:"pdfChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.pdfChecked)?_vm._i(_vm.pdfChecked,null)>-1:(_vm.pdfChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.pdfChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.pdfChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.pdfChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.pdfChecked=$$c}}}}),_vm._v("\n            PDF\n          ")]),_vm._v(" "),_c('label',{class:{'csv':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.csvChecked),expression:"csvChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.csvChecked)?_vm._i(_vm.csvChecked,null)>-1:(_vm.csvChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.csvChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.csvChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.csvChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.csvChecked=$$c}}}}),_vm._v("\n            CSV\n          ")])]),_vm._v(" "),_c('div',{staticClass:"instruction"},[_vm._v("Please select the reports to generate:")]),_vm._v(" "),_c('div',{staticClass:"row expanded reports"},[_c('div',{class:['small-12 column report', _vm.reportStatus.payout, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.payout),expression:"selectedReports.payout"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.payout)?_vm._i(_vm.selectedReports.payout,null)>-1:(_vm.selectedReports.payout)},on:{"change":function($event){var $$a=_vm.selectedReports.payout,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "payout", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "payout", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "payout", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('payout')))])])]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.serviceTypeBrand, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.serviceTypeBrand),expression:"selectedReports.serviceTypeBrand"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.serviceTypeBrand)?_vm._i(_vm.selectedReports.serviceTypeBrand,null)>-1:(_vm.selectedReports.serviceTypeBrand)},on:{"change":function($event){var $$a=_vm.selectedReports.serviceTypeBrand,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "serviceTypeBrand", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "serviceTypeBrand", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "serviceTypeBrand", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('serviceTypeBrand')))])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedServiceBrand),expression:"selectedServiceBrand"}],class:{'disabled':!_vm.selectedReports.serviceTypeBrand},attrs:{"disabled":!_vm.selectedReports.serviceTypeBrand},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedServiceBrand=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"bookingTime"}},[_vm._v("Booking Date")]),_vm._v(" "),_c('option',{attrs:{"value":"pickupTime"}},[_vm._v("Pickup Date")])])]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.cancellationReport, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.cancellationReport),expression:"selectedReports.cancellationReport"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.cancellationReport)?_vm._i(_vm.selectedReports.cancellationReport,null)>-1:(_vm.selectedReports.cancellationReport)},on:{"change":function($event){var $$a=_vm.selectedReports.cancellationReport,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "cancellationReport", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "cancellationReport", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "cancellationReport", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('cancellationReport')))])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCancellationType),expression:"selectedCancellationType"}],class:{'disabled':!_vm.selectedReports.cancellationReport},attrs:{"disabled":!_vm.selectedReports.cancellationReport},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedCancellationType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v("All")]),_vm._v(" "),_c('option',{attrs:{"value":"consumer"}},[_vm._v("Canceled by Consumer")]),_vm._v(" "),_c('option',{attrs:{"value":"admin"}},[_vm._v("Canceled by Any Admin")]),_vm._v(" "),_c('option',{attrs:{"value":"_admin"}},[_vm._v("Canceled by Specific Admin")]),_vm._v(" "),_c('option',{attrs:{"value":"goRes"}},[_vm._v("Go Reservations")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedCancellationType === '_admin'),expression:"selectedCancellationType === '_admin'"}],staticClass:"admin-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchAdmin),expression:"searchAdmin"}],attrs:{"type":"text","disabled":!_vm.selectedReports.cancellationReport},domProps:{"value":(_vm.searchAdmin)},on:{"focus":_vm.adminSearchFocus,"blur":_vm.adminSearchBlur,"input":function($event){if($event.target.composing){ return; }_vm.searchAdmin=$event.target.value}}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearchAdminList),expression:"showSearchAdminList"}]},_vm._l((_vm.admins),function(admin){return _c('li',{key:admin.id,on:{"click":function($event){return _vm.selectAdmin(admin)}}},[_vm._v(_vm._s(admin.name))])}),0)])]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.driverPaymentBonus, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.driverPaymentBonus),expression:"selectedReports.driverPaymentBonus"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.driverPaymentBonus)?_vm._i(_vm.selectedReports.driverPaymentBonus,null)>-1:(_vm.selectedReports.driverPaymentBonus)},on:{"change":function($event){var $$a=_vm.selectedReports.driverPaymentBonus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "driverPaymentBonus", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "driverPaymentBonus", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "driverPaymentBonus", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('driverPaymentBonus')))])])]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.insurance, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.insurance),expression:"selectedReports.insurance"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.insurance)?_vm._i(_vm.selectedReports.insurance,null)>-1:(_vm.selectedReports.insurance)},on:{"change":function($event){var $$a=_vm.selectedReports.insurance,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "insurance", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "insurance", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "insurance", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('insurance')))])])]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.insuranceMonthly, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.insuranceMonthly),expression:"selectedReports.insuranceMonthly"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.insuranceMonthly)?_vm._i(_vm.selectedReports.insuranceMonthly,null)>-1:(_vm.selectedReports.insuranceMonthly)},on:{"change":function($event){var $$a=_vm.selectedReports.insuranceMonthly,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "insuranceMonthly", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "insuranceMonthly", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "insuranceMonthly", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('insuranceMonthly')))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.insuranceEmail),expression:"insuranceEmail"}],staticClass:"insurance-email",attrs:{"type":"text","placeholder":"Email Recipient","disabled":!_vm.selectedReports.insuranceMonthly},domProps:{"value":(_vm.insuranceEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.insuranceEmail=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.miles),expression:"miles"}],staticClass:"insurance-email",attrs:{"type":"text","placeholder":"Miles per day","disabled":!_vm.selectedReports.insuranceMonthly},domProps:{"value":(_vm.miles)},on:{"keypress":_vm.isNumber,"input":function($event){if($event.target.composing){ return; }_vm.miles=$event.target.value}}})]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.portalFee, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.portalFee),expression:"selectedReports.portalFee"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.portalFee)?_vm._i(_vm.selectedReports.portalFee,null)>-1:(_vm.selectedReports.portalFee)},on:{"change":function($event){var $$a=_vm.selectedReports.portalFee,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "portalFee", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "portalFee", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "portalFee", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('portalFee')))])]),_vm._v(" "),_c('span',{staticClass:"note"},[_vm._v("Portal fee is calculated against Base Fare. Reports show Totals including fees.")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedBrand),expression:"selectedBrand"}],class:{'disabled':!_vm.selectedReports.portalFee},attrs:{"disabled":!_vm.selectedReports.portalFee},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedBrand=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Select Brand")]),_vm._v(" "),_vm._l((_vm.brands.list),function(brand){return _c('option',{key:brand.id,domProps:{"value":brand.id}},[_vm._v(_vm._s(brand.name))])})],2)])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.show),expression:"error.show"}],staticClass:"error"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.message),expression:"!!error.message"}]},[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.empty.length),expression:"error.empty.length"}]},[_c('li',[_vm._v("Empty Result:")]),_vm._v(" "),_vm._l((_vm.error.empty),function(empty,ix){return _c('li',{key:ix},[_vm._v("- "+_vm._s(empty))])})],2)])]),_vm._v(" "),_c('a',{class:{ 'button cta success small block': true, disabled: _vm.pdf.loading },attrs:{"href":"javascript:;"},on:{"click":_vm.startProcess}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.pdf.loading),expression:"pdf.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pdf.loading),expression:"!pdf.loading"}]},[_vm._v("Generate and Download Report")])])],1),_vm._v(" "),_c('div',{class:[_vm.pdf.class],attrs:{"id":"pdf-view"}},_vm._l((_vm.pdf.table.data),function(pageData,pageIndex){return (!_vm.isServiceTypeBrand)?_c('div',{class:['page', pageIndex]},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',_vm._l((_vm.pdf.table.label),function(label){return _c('th',{domProps:{"innerHTML":_vm._s(label)}})}),0)]),_vm._v(" "),_c('tbody',[_vm._l((pageData),function(data,index){return _c('tr',_vm._l((data),function(value,i){return _c('td',{class:[i]},[_vm._v(_vm._s(value))])}),0)}),_vm._v(" "),(_vm.isPayout && _vm.currentPage(pageIndex) == _vm.totalPage)?_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"driverCount"},[_vm._v(_vm._s(_vm.pdf.table.total.drivers))]),_vm._v(" "),_c('td',{staticClass:"rsvpCount"},[_vm._v(_vm._s(_vm.pdf.table.total.rsvp))]),_vm._v(" "),_c('td',{staticClass:"fare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fare))]),_vm._v(" "),_c('td',{staticClass:"travelInsurance"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.travelInsurance))]),_vm._v(" "),_c('td',{staticClass:"airportFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.airportFee))]),_vm._v(" "),_c('td',{staticClass:"totalFare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fareSum))]),_vm._v(" "),_c('td',{staticClass:"avgFare"},[_vm._v(_vm._s(_vm.pdf.table.total.avgFare))]),_vm._v(" "),_c('td',{staticClass:"payment"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.payment))]),_vm._v(" "),_c('td',{staticClass:"paymentPercent"},[_vm._v(_vm._s(_vm.pdf.table.total.paymentPercent)+"%")]),_vm._v(" "),_c('td',{staticClass:"pickupFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.pickupFee))]),_vm._v(" "),_c('td',{staticClass:"gasFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.gasFee))]),_vm._v(" "),_c('td',{staticClass:"tips"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.tips))]),_vm._v(" "),_c('td',{staticClass:"bonus"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.bonus))]),_vm._v(" "),_c('td',{staticClass:"cancelFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.cancelFee))]),_vm._v(" "),_c('td',{staticClass:"driverPayment"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.extraFee))]),_vm._v(" "),_c('td',{staticClass:"driverPercent"},[_vm._v(_vm._s(_vm.pdf.table.total.percent)+"%")])]):_vm._e(),_vm._v(" "),(_vm.isDriverPaymentBonus && _vm.currentPage(pageIndex) == _vm.totalPage)?_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"brand",attrs:{"colspan":"3"}}),_vm._v(" "),_c('td',{staticClass:"baseFare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.baseFare))]),_vm._v(" "),_c('td',{staticClass:"driverPayment"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.driverPayment))]),_vm._v(" "),_c('td',{staticClass:"bonus"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.bonus))]),_vm._v(" "),_c('td',{staticClass:"avgBonus"},[_vm._v(_vm._s(_vm.pdf.table.total.avgBonus)+"%")]),_vm._v(" "),_c('td',{staticClass:"totalDriverPayment"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.totalDriverPayment))]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}})]):_vm._e(),_vm._v(" "),(_vm.isInsurance && _vm.currentPage(pageIndex) == _vm.totalPage)?_c('tr',{staticClass:"total"},[_c('td',{staticClass:"total-p",attrs:{"colspan":"11"}},[_vm._v("\n                Total \n                "),_c('span',[_vm._v("RSVP: "+_vm._s(_vm.pdf.table.total.rsvp))]),_vm._v(" "),_c('span',[_vm._v("P1: "+_vm._s(_vm.pdf.table.total.p1))]),_vm._v(" "),_c('span',[_vm._v("P2: "+_vm._s(_vm.pdf.table.total.p2))]),_vm._v(" "),_c('span',[_vm._v("P3: "+_vm._s(_vm.pdf.table.total.p3))]),_vm._v(" "),_c('span',[_vm._v("Grand Total: "+_vm._s(_vm.pdf.table.total.overAll))])])]):_vm._e(),_vm._v(" "),(_vm.isPortalFee && _vm.currentPage(pageIndex) == _vm.totalPage)?_c('tr',{staticClass:"total"},[_c('td',{attrs:{"colspan":"2"}},[_vm._v("Total ("+_vm._s(_vm.pdf.table.total.rsvp)+")")]),_vm._v(" "),_c('td',{staticClass:"baseFare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fare))]),_vm._v(" "),_c('td',{staticClass:"portalFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.portalFee))])]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"page-count"},[_vm._v("page "+_vm._s(_vm.currentPage(pageIndex))+" of "+_vm._s(_vm.totalPage))])]):_c('div',_vm._l((_vm.pdf.table.serviceTypeBrandData),function(data,pageIndex){return _c('div',{class:['page', pageIndex]},_vm._l((_vm.pdf.table.serviceTypeBrandData[pageIndex]),function(dat,brand){return _c('div',{staticClass:"brand-box"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(brand)+" "+_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',_vm._l((_vm.pdf.table.label),function(label){return _c('th',{domProps:{"innerHTML":_vm._s(label)}})}),0)]),_vm._v(" "),_c('tbody',[_vm._l((dat),function(tableData,index){return _c('tr',_vm._l((tableData),function(value,i){return _c('td',{class:[i]},[_vm._v(_vm._s(value))])}),0)}),_vm._v(" "),_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Total")]),_vm._v(" "),_c('td',{staticClass:"rsvp"},[_vm._v(_vm._s(_vm.pdf.table.total[brand].rsvp))]),_vm._v(" "),_c('td',{staticClass:"asap"},[_vm._v(_vm._s(_vm.pdf.table.total[brand].asap))]),_vm._v(" "),_c('td',{staticClass:"web"},[_vm._v(_vm._s(_vm.pdf.table.total[brand].web))]),_vm._v(" "),_c('td',{staticClass:"admin"},[_vm._v(_vm._s(_vm.pdf.table.total[brand].admin))]),_vm._v(" "),_c('td',{staticClass:"app"},[_vm._v(_vm._s(_vm.pdf.table.total[brand].app))]),_vm._v(" "),_c('td',{staticClass:"app"},[_vm._v(_vm._s(_vm.pdf.table.total[brand].go))]),_vm._v(" "),_c('td',{staticClass:"paxSum"},[_vm._v(_vm._s(_vm.pdf.table.total[brand].paxSum))]),_vm._v(" "),_c('td',{staticClass:"paxAvg"},[_vm._v(_vm._s(_vm.pdf.table.total[brand].paxAvg))]),_vm._v(" "),_c('td',{staticClass:"fareSum"},[_vm._v("$"+_vm._s(_vm.pdf.table.total[brand].fareSum))]),_vm._v(" "),_c('td',{staticClass:"fareAvg"},[_vm._v(_vm._s(_vm.pdf.table.total[brand].fareAvg))]),_vm._v(" "),_c('td',{staticClass:"farePP"},[_vm._v(_vm._s(_vm.pdf.table.total[brand].farePP))])])],2)])])}),0)}),0)}),0)]),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.insuranceModal.show}},[_c('div',{staticClass:"bg-overlay"}),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_c('i',{staticClass:"fas fa-check-circle fa-5x",staticStyle:{"color":"#2db96f"}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.insuranceModal.message)}}),_vm._v(" "),_c('a',{staticClass:"button cta block small",on:{"click":function($event){_vm.insuranceModal.show = false}}},[_vm._v("\n        "+_vm._s(_vm.$t('rsvpDetails.close'))+"\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DirectBill_vue__ = __webpack_require__(524);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e98be24_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DirectBill_vue__ = __webpack_require__(1485);
function injectStyle (ssrContext) {
  __webpack_require__(1483)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e98be24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DirectBill_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e98be24_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DirectBill_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1484);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1fbd4df1", content, true, {});

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.rsvp-report-box[data-v-0e98be24] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-0e98be24] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-0e98be24] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-0e98be24] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-0e98be24] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-0e98be24] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-0e98be24] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-0e98be24] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-0e98be24] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-0e98be24]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-0e98be24] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-0e98be24] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-0e98be24] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-0e98be24] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-0e98be24]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-0e98be24], .rsvp-report .reports .report.loading[data-v-0e98be24], .rsvp-report .reports .report.has-error[data-v-0e98be24], .rsvp-report .reports .report.success[data-v-0e98be24] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-0e98be24] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-0e98be24] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-0e98be24] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-0e98be24] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-0e98be24] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-0e98be24] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-0e98be24] {\n    cursor: pointer;\n}\n.filter input[data-v-0e98be24] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.download-type[data-v-0e98be24] {\n  width: 100%;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-0e98be24] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-0e98be24] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-0e98be24] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-0e98be24] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-0e98be24] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-0e98be24] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-0e98be24] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-0e98be24] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-0e98be24]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-0e98be24] {\n      font-size: 13px;\n}\n.form-group[data-v-0e98be24] {\n  display: block;\n}\n.form-group .instruction[data-v-0e98be24] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-0e98be24] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox > *[data-v-0e98be24] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-0e98be24] {\n    margin-right: 3px;\n}\n.padding-R[data-v-0e98be24] {\n  padding-right: 7px;\n}\n.padding-L[data-v-0e98be24] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-0e98be24] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#pdf-view .page[data-v-0e98be24] {\n    padding: 30px 40px 30px 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-0e98be24] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-0e98be24] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-0e98be24] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-0e98be24] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-0e98be24] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-0e98be24] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-0e98be24], #pdf-view table tbody tr.total[data-v-0e98be24] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-0e98be24] {\n      color: #000;\n      font-size: 12px;\n}\n#pdf-view table tbody td[data-v-0e98be24] {\n      padding: 2px 3px;\n}\n.report-direct-bill[data-v-0e98be24] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.report-direct-bill table tbody td[data-v-0e98be24] {\n    text-align: center;\n}\n.report-direct-bill table tbody .fare[data-v-0e98be24] {\n    text-align: right;\n}\n.report-direct-bill table tbody .pickupTime[data-v-0e98be24], .report-direct-bill table tbody .completedTime[data-v-0e98be24] {\n    width: 120px;\n}\n.report-direct-bill table tbody .consumerNotes[data-v-0e98be24] {\n    font-size: 11px;\n    line-height: 1.15;\n}\n.report-payout[data-v-0e98be24] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.report-payout table tbody tr.total[data-v-0e98be24] {\n    border-top: 1px solid #333;\n    font-weight: 600;\n    font-size: 12.5px;\n}\n.report-payout table .driverCount[data-v-0e98be24], .report-payout table .rsvpCount[data-v-0e98be24], .report-payout table .totalPax[data-v-0e98be24], .report-payout table .avgPax[data-v-0e98be24] {\n    text-align: center;\n}\n.report-payout table .fare[data-v-0e98be24], .report-payout table .totalFare[data-v-0e98be24], .report-payout table .avgFare[data-v-0e98be24], .report-payout table .travelInsurance[data-v-0e98be24], .report-payout table .airportFee[data-v-0e98be24], .report-payout table .extraFee[data-v-0e98be24], .report-payout table .charged[data-v-0e98be24], .report-payout table .payment[data-v-0e98be24], .report-payout table .pickupFee[data-v-0e98be24],\n  .report-payout table .tips[data-v-0e98be24], .report-payout table .bonus[data-v-0e98be24], .report-payout table .cancelFee[data-v-0e98be24], .report-payout table .driverPayment[data-v-0e98be24], .report-payout table .paymentPercent[data-v-0e98be24], .report-payout table .driverPercent[data-v-0e98be24] {\n    text-align: right;\n}\n.report-payout table .driverPayment[data-v-0e98be24] {\n    font-weight: 600;\n}\n.report-payout table .fare[data-v-0e98be24], .report-payout table .travelInsurance[data-v-0e98be24], .report-payout table .airportFee[data-v-0e98be24], .report-payout table .payment[data-v-0e98be24], .report-payout table .pickupFee[data-v-0e98be24], .report-payout table .tips[data-v-0e98be24], .report-payout table .bonus[data-v-0e98be24], .report-payout table .cancelFee[data-v-0e98be24] {\n    color: #777;\n}\n.report-payout table .company[data-v-0e98be24] {\n    max-width: 150px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.service-brand[data-v-0e98be24] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.service-brand .brand-box[data-v-0e98be24] {\n    margin-bottom: 50px;\n}\n.service-brand table[data-v-0e98be24] {\n    /*.fare, .airportFee, .payment, .pickupFee, .tips, .bonus, .cancelFee{ color: #777; }*/\n}\n.service-brand table tbody tr.total[data-v-0e98be24] {\n      border-top: 1px solid #333;\n      font-weight: 600;\n}\n.service-brand table .rsvp[data-v-0e98be24], .service-brand table .asap[data-v-0e98be24], .service-brand table .web[data-v-0e98be24], .service-brand table .admin[data-v-0e98be24], .service-brand table .app[data-v-0e98be24], .service-brand table .go[data-v-0e98be24], .service-brand table .paxSum[data-v-0e98be24], .service-brand table .paxAvg[data-v-0e98be24] {\n      text-align: center;\n}\n.service-brand table .fareSum[data-v-0e98be24], .service-brand table .fareAvg[data-v-0e98be24], .service-brand table .farePP[data-v-0e98be24] {\n      text-align: right;\n}\n.driver-payment-bonus[data-v-0e98be24] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.driver-payment-bonus table .rsvpId[data-v-0e98be24], .driver-payment-bonus table .brand[data-v-0e98be24], .driver-payment-bonus table .updatedOn[data-v-0e98be24], .driver-payment-bonus table .baseFare[data-v-0e98be24], .driver-payment-bonus table .driverPayment[data-v-0e98be24], .driver-payment-bonus table .bonus[data-v-0e98be24], .driver-payment-bonus table .avgBonus[data-v-0e98be24], .driver-payment-bonus table .totalDriverPayment[data-v-0e98be24] {\n    text-align: center;\n}\n.driver-payment-bonus table .driverName[data-v-0e98be24], .driver-payment-bonus table .updatedBy[data-v-0e98be24] {\n    width: 150px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.admin-box[data-v-0e98be24] {\n  position: relative;\n  margin: 0 15px 15px 28px;\n}\n.admin-box input[data-v-0e98be24] {\n    padding: 5px 8px;\n    margin: 0 0 5px;\n    font-size: 14px;\n}\n.admin-box ul[data-v-0e98be24] {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    background: #fafafa;\n    border: 1px solid #ccc;\n    border-radius: 2px;\n    height: 100px;\n    overflow: auto;\n}\n.admin-box ul li[data-v-0e98be24] {\n      display: block;\n      line-height: 1;\n      padding: 5px 8px;\n      font-size: 14px;\n      color: #333;\n}\n.admin-box ul li[data-v-0e98be24]:hover {\n        background: #f3f3f3;\n}\n.slide-down-enter-active[data-v-0e98be24], .slide-down-leave-active[data-v-0e98be24] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-0e98be24], .slide-down-leave-to[data-v-0e98be24] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.end-date[data-v-0e98be24] .vdp-datepicker__calendar {\n    right: 1px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Reports/DirectBill.vue"],"names":[],"mappings":";AACA;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,qBAAqB;CACtB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,eAAe;CACpB;AACD;MACM,cAAc;MACd,aAAa;MACb,cAAc;MACd,yBAAyB;MACzB,sBAAsB;MACtB,iBAAiB;MACjB,sBAAsB;MACtB,gBAAgB;MAChB,YAAY;MACZ,wDAAwD;MACxD,6BAA6B;MAC7B,+BAA+B;CACpC;AACD;QACQ,0BAA0B;CACjC;AACD;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;CACtB;AACD;MACM,mBAAmB;MACnB,WAAW;CAChB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,+BAA+B;CACtC;AACD;UACU,YAAY;CACrB;AACD;QACQ,kBAAkB;QAClB,oBAAoB;QACpB,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,iCAAiC;QACjC,yBAAyB;CAChC;AACD;UACU,oBAAoB;UACpB,mBAAmB;CAC5B;AACD;UACU,oBAAoB;CAC7B;AACD;QACQ,WAAW;QACX,+CAA+C;gBACvC,uCAAuC;CACtD;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,cAAc;IACd,YAAY;CACf;AACD;IACI,gBAAgB;CACnB;AACD;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;CAC1B;AACD;EACE,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;CACrB;AACD;IACI,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;CAC1B;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,gBAAgB;MAChB,cAAc;MACd,YAAY;MACZ,qBAAqB;CAC1B;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;CACtB;AACD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;IACI,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,iBAAiB;CACpB;AACD;MACM,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;CACxB;AACD;MACM,gBAAgB;CACrB;AACD;EACE,eAAe;CAChB;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,YAAY;CACf;AACD;IACI,kBAAkB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,aAAa;EACb,eAAe;EACf,iBAAiB;CAClB;AACD;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,aAAa;CAChB;AACD;MACM,mBAAmB;MACnB,aAAa;MACb,YAAY;MACZ,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;CACxB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;CACf;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,iBAAiB;CACtB;AACD;QACQ,8BAA8B;CACrC;AACD;MACM,iBAAiB;CACtB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;MACM,iBAAiB;CACtB;AACD;EACE,yBAAyB;EACzB,yBAAyB;CAC1B;AACD;IACI,mBAAmB;CACtB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,aAAa;CAChB;AACD;IACI,gBAAgB;IAChB,kBAAkB;CACrB;AACD;EACE,yBAAyB;EACzB,yBAAyB;CAC1B;AACD;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;CACrB;AACD;IACI,mBAAmB;CACtB;AACD;;IAEI,kBAAkB;CACrB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,YAAY;CACf;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;IACxB,oBAAoB;CACvB;AACD;EACE,yBAAyB;EACzB,yBAAyB;CAC1B;AACD;IACI,oBAAoB;CACvB;AACD;IACI,uFAAuF;CAC1F;AACD;MACM,2BAA2B;MAC3B,iBAAiB;CACtB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,kBAAkB;CACvB;AACD;EACE,yBAAyB;EACzB,yBAAyB;CAC1B;AACD;IACI,mBAAmB;CACtB;AACD;IACI,aAAa;IACb,iBAAiB;IACjB,wBAAwB;IACxB,oBAAoB;CACvB;AACD;EACE,mBAAmB;EACnB,yBAAyB;CAC1B;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;CACnB;AACD;IACI,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,eAAe;CAClB;AACD;MACM,eAAe;MACf,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,YAAY;CACjB;AACD;QACQ,oBAAoB;CAC3B;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;AACA;IACI,WAAW;CACd;CACA","file":"DirectBill.vue","sourcesContent":["\n.rsvp-report-box[data-v-0e98be24] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-0e98be24] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-0e98be24] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-0e98be24] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-0e98be24] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-0e98be24] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-0e98be24] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-0e98be24] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-0e98be24] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-0e98be24]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-0e98be24] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-0e98be24] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-0e98be24] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-0e98be24] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-0e98be24]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-0e98be24], .rsvp-report .reports .report.loading[data-v-0e98be24], .rsvp-report .reports .report.has-error[data-v-0e98be24], .rsvp-report .reports .report.success[data-v-0e98be24] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-0e98be24] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-0e98be24] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-0e98be24] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-0e98be24] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-0e98be24] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-0e98be24] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-0e98be24] {\n    cursor: pointer;\n}\n.filter input[data-v-0e98be24] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.download-type[data-v-0e98be24] {\n  width: 100%;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-0e98be24] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-0e98be24] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-0e98be24] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-0e98be24] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-0e98be24] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-0e98be24] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-0e98be24] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-0e98be24] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-0e98be24]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-0e98be24] {\n      font-size: 13px;\n}\n.form-group[data-v-0e98be24] {\n  display: block;\n}\n.form-group .instruction[data-v-0e98be24] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-0e98be24] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox > *[data-v-0e98be24] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-0e98be24] {\n    margin-right: 3px;\n}\n.padding-R[data-v-0e98be24] {\n  padding-right: 7px;\n}\n.padding-L[data-v-0e98be24] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-0e98be24] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#pdf-view .page[data-v-0e98be24] {\n    padding: 30px 40px 30px 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-0e98be24] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-0e98be24] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-0e98be24] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-0e98be24] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-0e98be24] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-0e98be24] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-0e98be24], #pdf-view table tbody tr.total[data-v-0e98be24] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-0e98be24] {\n      color: #000;\n      font-size: 12px;\n}\n#pdf-view table tbody td[data-v-0e98be24] {\n      padding: 2px 3px;\n}\n.report-direct-bill[data-v-0e98be24] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.report-direct-bill table tbody td[data-v-0e98be24] {\n    text-align: center;\n}\n.report-direct-bill table tbody .fare[data-v-0e98be24] {\n    text-align: right;\n}\n.report-direct-bill table tbody .pickupTime[data-v-0e98be24], .report-direct-bill table tbody .completedTime[data-v-0e98be24] {\n    width: 120px;\n}\n.report-direct-bill table tbody .consumerNotes[data-v-0e98be24] {\n    font-size: 11px;\n    line-height: 1.15;\n}\n.report-payout[data-v-0e98be24] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.report-payout table tbody tr.total[data-v-0e98be24] {\n    border-top: 1px solid #333;\n    font-weight: 600;\n    font-size: 12.5px;\n}\n.report-payout table .driverCount[data-v-0e98be24], .report-payout table .rsvpCount[data-v-0e98be24], .report-payout table .totalPax[data-v-0e98be24], .report-payout table .avgPax[data-v-0e98be24] {\n    text-align: center;\n}\n.report-payout table .fare[data-v-0e98be24], .report-payout table .totalFare[data-v-0e98be24], .report-payout table .avgFare[data-v-0e98be24], .report-payout table .travelInsurance[data-v-0e98be24], .report-payout table .airportFee[data-v-0e98be24], .report-payout table .extraFee[data-v-0e98be24], .report-payout table .charged[data-v-0e98be24], .report-payout table .payment[data-v-0e98be24], .report-payout table .pickupFee[data-v-0e98be24],\n  .report-payout table .tips[data-v-0e98be24], .report-payout table .bonus[data-v-0e98be24], .report-payout table .cancelFee[data-v-0e98be24], .report-payout table .driverPayment[data-v-0e98be24], .report-payout table .paymentPercent[data-v-0e98be24], .report-payout table .driverPercent[data-v-0e98be24] {\n    text-align: right;\n}\n.report-payout table .driverPayment[data-v-0e98be24] {\n    font-weight: 600;\n}\n.report-payout table .fare[data-v-0e98be24], .report-payout table .travelInsurance[data-v-0e98be24], .report-payout table .airportFee[data-v-0e98be24], .report-payout table .payment[data-v-0e98be24], .report-payout table .pickupFee[data-v-0e98be24], .report-payout table .tips[data-v-0e98be24], .report-payout table .bonus[data-v-0e98be24], .report-payout table .cancelFee[data-v-0e98be24] {\n    color: #777;\n}\n.report-payout table .company[data-v-0e98be24] {\n    max-width: 150px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.service-brand[data-v-0e98be24] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.service-brand .brand-box[data-v-0e98be24] {\n    margin-bottom: 50px;\n}\n.service-brand table[data-v-0e98be24] {\n    /*.fare, .airportFee, .payment, .pickupFee, .tips, .bonus, .cancelFee{ color: #777; }*/\n}\n.service-brand table tbody tr.total[data-v-0e98be24] {\n      border-top: 1px solid #333;\n      font-weight: 600;\n}\n.service-brand table .rsvp[data-v-0e98be24], .service-brand table .asap[data-v-0e98be24], .service-brand table .web[data-v-0e98be24], .service-brand table .admin[data-v-0e98be24], .service-brand table .app[data-v-0e98be24], .service-brand table .go[data-v-0e98be24], .service-brand table .paxSum[data-v-0e98be24], .service-brand table .paxAvg[data-v-0e98be24] {\n      text-align: center;\n}\n.service-brand table .fareSum[data-v-0e98be24], .service-brand table .fareAvg[data-v-0e98be24], .service-brand table .farePP[data-v-0e98be24] {\n      text-align: right;\n}\n.driver-payment-bonus[data-v-0e98be24] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.driver-payment-bonus table .rsvpId[data-v-0e98be24], .driver-payment-bonus table .brand[data-v-0e98be24], .driver-payment-bonus table .updatedOn[data-v-0e98be24], .driver-payment-bonus table .baseFare[data-v-0e98be24], .driver-payment-bonus table .driverPayment[data-v-0e98be24], .driver-payment-bonus table .bonus[data-v-0e98be24], .driver-payment-bonus table .avgBonus[data-v-0e98be24], .driver-payment-bonus table .totalDriverPayment[data-v-0e98be24] {\n    text-align: center;\n}\n.driver-payment-bonus table .driverName[data-v-0e98be24], .driver-payment-bonus table .updatedBy[data-v-0e98be24] {\n    width: 150px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.admin-box[data-v-0e98be24] {\n  position: relative;\n  margin: 0 15px 15px 28px;\n}\n.admin-box input[data-v-0e98be24] {\n    padding: 5px 8px;\n    margin: 0 0 5px;\n    font-size: 14px;\n}\n.admin-box ul[data-v-0e98be24] {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    background: #fafafa;\n    border: 1px solid #ccc;\n    border-radius: 2px;\n    height: 100px;\n    overflow: auto;\n}\n.admin-box ul li[data-v-0e98be24] {\n      display: block;\n      line-height: 1;\n      padding: 5px 8px;\n      font-size: 14px;\n      color: #333;\n}\n.admin-box ul li[data-v-0e98be24]:hover {\n        background: #f3f3f3;\n}\n.slide-down-enter-active[data-v-0e98be24], .slide-down-leave-active[data-v-0e98be24] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-0e98be24], .slide-down-leave-to[data-v-0e98be24] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.end-date[data-v-0e98be24] .vdp-datepicker__calendar {\n    right: 1px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rsvp-report-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row expanded"},[_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"date-input"},[_c('label',[_vm._v("User:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedUser),expression:"selectedUser"}],attrs:{"disabled":_vm.corpLoading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedUser=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":_vm.goResID}},[_vm._v(_vm._s(("GO Reservations (" + _vm.goResID + ")")))]),_vm._v(" "),_vm._l((_vm.dbUsers),function(x,i){return _c('option',{key:i,domProps:{"value":x.id}},[_vm._v(_vm._s(((x.name) + " (" + (x.id) + ")")))])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row expanded"},[_c('div',{staticClass:"small-6 column padding-R"},[_c('div',{staticClass:"date-input"},[_c('label',[_vm._v("Start Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}})],1)]),_vm._v(" "),_c('div',{staticClass:"small-6 column padding-L"},[_c('div',{staticClass:"date-input end-date"},[_c('label',[_vm._v("End Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"list-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"download-type"},[_c('label',{class:{'pdf':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pdfChecked),expression:"pdfChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.pdfChecked)?_vm._i(_vm.pdfChecked,null)>-1:(_vm.pdfChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.pdfChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.pdfChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.pdfChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.pdfChecked=$$c}}}}),_vm._v("\n            PDF\n          ")]),_vm._v(" "),_c('label',{class:{'csv':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.csvChecked),expression:"csvChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.csvChecked)?_vm._i(_vm.csvChecked,null)>-1:(_vm.csvChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.csvChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.csvChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.csvChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.csvChecked=$$c}}}}),_vm._v("\n            CSV\n          ")])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.show),expression:"error.show"}],staticClass:"error"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.message),expression:"!!error.message"}]},[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.empty.length),expression:"error.empty.length"}]},[_c('li',[_vm._v("Empty Result:")]),_vm._v(" "),_vm._l((_vm.error.empty),function(empty){return _c('li',[_vm._v("- "+_vm._s(empty))])})],2)])]),_vm._v(" "),_c('a',{class:{ 'button cta success small block': true, disabled: _vm.pdf.loading },attrs:{"href":"javascript:;"},on:{"click":_vm.startProcess}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.pdf.loading),expression:"pdf.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pdf.loading),expression:"!pdf.loading"}]},[_vm._v("Generate and Download Report")])])],1),_vm._v(" "),_c('div',{class:[_vm.pdf.class],attrs:{"id":"pdf-view"}},[(_vm.isDirectBill)?_c('div',[_vm._l((_vm.pdf.table.data.completed),function(pageData,pageIndex){return _c('div',{class:['page', pageIndex]},[_c('div',{staticClass:"title"},[_vm._v("Opoli Reports")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v("Completed")]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',_vm._l((_vm.pdf.table.label),function(label){return _c('th',{domProps:{"innerHTML":_vm._s(label)}})}),0)]),_vm._v(" "),_c('tbody',_vm._l((pageData),function(data,index){return _c('tr',_vm._l((data),function(value,i){return _c('td',{class:[i]},[_vm._v(_vm._s(value))])}),0)}),0)]),_vm._v(" "),_c('div',{staticClass:"page-count"},[_vm._v("page "+_vm._s(_vm.currentPage(pageIndex))+" of "+_vm._s(parseInt(_vm.totalPageCompleted) + parseInt(_vm.totalPageNoShow)))])])}),_vm._v(" "),_vm._l((_vm.pdf.table.data.noshow),function(pageDataNS,pageIndexNS){return _c('div',{class:['page', ("page" + (parseInt(_vm.currentPage(pageIndexNS)) + _vm.totalPageCompleted))]},[_c('div',{staticClass:"title"},[_vm._v("Opoli Reports")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v("No Show")]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',_vm._l((_vm.pdf.table.label),function(label){return _c('th',{domProps:{"innerHTML":_vm._s(label)}})}),0)]),_vm._v(" "),_c('tbody',_vm._l((pageDataNS),function(data,index){return _c('tr',_vm._l((data),function(value,i){return _c('td',{class:[i]},[_vm._v(_vm._s(value))])}),0)}),0)]),_vm._v(" "),_c('div',{staticClass:"page-count"},[_vm._v("page "+_vm._s(parseInt(_vm.currentPage(pageIndexNS)) + _vm.totalPageCompleted)+" of "+_vm._s(_vm.totalPageCompleted + _vm.totalPageNoShow))])])})],2):(!_vm.isServiceTypeBrand)?_vm._l((_vm.pdf.table.data),function(pageData,pageIndex){return _c('div',{class:['page', pageIndex]},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',_vm._l((_vm.pdf.table.label),function(label){return _c('th',{domProps:{"innerHTML":_vm._s(label)}})}),0)]),_vm._v(" "),_c('tbody',[_vm._l((pageData),function(data,index){return _c('tr',_vm._l((data),function(value,i){return _c('td',{class:[i]},[_vm._v(_vm._s(value))])}),0)}),_vm._v(" "),(_vm.isDirectBill && _vm.currentPage(pageIndex) == _vm.totalPage)?_c('tr',{staticClass:"total"},[_c('td',{attrs:{"colspan":"4"}},[_vm._v("Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"fare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fare))]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}})]):_vm._e(),_vm._v(" "),(_vm.isPayout && _vm.currentPage(pageIndex) == _vm.totalPage)?_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"driverCount"},[_vm._v(_vm._s(_vm.pdf.table.total.drivers))]),_vm._v(" "),_c('td',{staticClass:"rsvpCount"},[_vm._v(_vm._s(_vm.pdf.table.total.rsvp))]),_vm._v(" "),_c('td',{staticClass:"totalPax"},[_vm._v(_vm._s(_vm.pdf.table.total.pax))]),_vm._v(" "),_c('td',{staticClass:"avgPax"},[_vm._v(_vm._s(_vm.pdf.table.total.avgPax))]),_vm._v(" "),_c('td',{staticClass:"fare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fare))]),_vm._v(" "),_c('td',{staticClass:"travelInsurance"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.travelInsurance))]),_vm._v(" "),_c('td',{staticClass:"airportFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.airportFee))]),_vm._v(" "),_c('td',{staticClass:"totalFare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fareSum))]),_vm._v(" "),_c('td',{staticClass:"avgFare"},[_vm._v(_vm._s(_vm.pdf.table.total.avgFare))]),_vm._v(" "),_c('td',{staticClass:"payment"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.payment))]),_vm._v(" "),_c('td',{staticClass:"paymentPercent"},[_vm._v(_vm._s(_vm.pdf.table.total.paymentPercent)+"%")]),_vm._v(" "),_c('td',{staticClass:"pickupFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.pickupFee))]),_vm._v(" "),_c('td',{staticClass:"tips"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.tips))]),_vm._v(" "),_c('td',{staticClass:"bonus"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.bonus))]),_vm._v(" "),_c('td',{staticClass:"cancelFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.cancelFee))]),_vm._v(" "),_c('td',{staticClass:"driverPayment"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.extraFee))]),_vm._v(" "),_c('td',{staticClass:"driverPercent"},[_vm._v(_vm._s(_vm.pdf.table.total.percent)+"%")])]):_vm._e(),_vm._v(" "),(_vm.isDriverPaymentBonus && _vm.currentPage(pageIndex) == _vm.totalPage)?_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"brand",attrs:{"colspan":"3"}}),_vm._v(" "),_c('td',{staticClass:"baseFare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.baseFare))]),_vm._v(" "),_c('td',{staticClass:"driverPayment"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.driverPayment))]),_vm._v(" "),_c('td',{staticClass:"bonus"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.bonus))]),_vm._v(" "),_c('td',{staticClass:"avgBonus"},[_vm._v(_vm._s(_vm.pdf.table.total.avgBonus)+"%")]),_vm._v(" "),_c('td',{staticClass:"totalDriverPayment"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.totalDriverPayment))]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}})]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"page-count"},[_vm._v("page "+_vm._s(_vm.currentPage(pageIndex))+" of "+_vm._s(_vm.totalPage))])])}):_c('div',_vm._l((_vm.pdf.table.serviceTypeBrandData),function(data,pageIndex){return _c('div',{class:['page', pageIndex]},_vm._l((_vm.pdf.table.serviceTypeBrandData[pageIndex]),function(dat,brand){return _c('div',{staticClass:"brand-box"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(brand)+" "+_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',_vm._l((_vm.pdf.table.label),function(label){return _c('th',{domProps:{"innerHTML":_vm._s(label)}})}),0)]),_vm._v(" "),_c('tbody',[_vm._l((dat),function(tableData,index){return _c('tr',_vm._l((tableData),function(value,i){return _c('td',{class:[i]},[_vm._v(_vm._s(value))])}),0)}),_vm._v(" "),_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Total")]),_vm._v(" "),_c('td',{staticClass:"rsvp"},[_vm._v(_vm._s(_vm.pdf.table.total[brand].rsvp))]),_vm._v(" "),_c('td',{staticClass:"asap"},[_vm._v(_vm._s(_vm.pdf.table.total[brand].asap))]),_vm._v(" "),_c('td',{staticClass:"web"},[_vm._v(_vm._s(_vm.pdf.table.total[brand].web))]),_vm._v(" "),_c('td',{staticClass:"admin"},[_vm._v(_vm._s(_vm.pdf.table.total[brand].admin))]),_vm._v(" "),_c('td',{staticClass:"app"},[_vm._v(_vm._s(_vm.pdf.table.total[brand].app))]),_vm._v(" "),_c('td',{staticClass:"app"},[_vm._v(_vm._s(_vm.pdf.table.total[brand].go))]),_vm._v(" "),_c('td',{staticClass:"paxSum"},[_vm._v(_vm._s(_vm.pdf.table.total[brand].paxSum))]),_vm._v(" "),_c('td',{staticClass:"paxAvg"},[_vm._v(_vm._s(_vm.pdf.table.total[brand].paxAvg))]),_vm._v(" "),_c('td',{staticClass:"fareSum"},[_vm._v("$"+_vm._s(_vm.pdf.table.total[brand].fareSum))]),_vm._v(" "),_c('td',{staticClass:"fareAvg"},[_vm._v(_vm._s(_vm.pdf.table.total[brand].fareAvg))]),_vm._v(" "),_c('td',{staticClass:"farePP"},[_vm._v(_vm._s(_vm.pdf.table.total[brand].farePP))])])],2)])])}),0)}),0)],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverPayouts_vue__ = __webpack_require__(525);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86b494a2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverPayouts_vue__ = __webpack_require__(1489);
function injectStyle (ssrContext) {
  __webpack_require__(1487)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-86b494a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverPayouts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86b494a2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverPayouts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1488);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2b967852", content, true, {});

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.rsvp-report-box[data-v-86b494a2] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-86b494a2] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-86b494a2] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-86b494a2] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-86b494a2] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-86b494a2] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-86b494a2] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-86b494a2] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-86b494a2] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-86b494a2]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-86b494a2] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-86b494a2] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-86b494a2] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-86b494a2] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-86b494a2]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-86b494a2], .rsvp-report .reports .report.loading[data-v-86b494a2], .rsvp-report .reports .report.has-error[data-v-86b494a2], .rsvp-report .reports .report.success[data-v-86b494a2] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-86b494a2] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-86b494a2] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-86b494a2] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-86b494a2] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-86b494a2] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-86b494a2] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-86b494a2] {\n    cursor: pointer;\n}\n.filter input[data-v-86b494a2] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.weekly-select[data-v-86b494a2] {\n  padding: 5px;\n}\n.download-type[data-v-86b494a2] {\n  float: right;\n  width: 150px;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-86b494a2] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-86b494a2] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-86b494a2] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-86b494a2] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-86b494a2] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-86b494a2] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-86b494a2] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-86b494a2] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-86b494a2]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-86b494a2] {\n      font-size: 13px;\n}\n.form-group[data-v-86b494a2] {\n  display: block;\n}\n.form-group .instruction[data-v-86b494a2] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-86b494a2] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox > *[data-v-86b494a2] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-86b494a2] {\n    margin-right: 3px;\n}\n.padding-R[data-v-86b494a2] {\n  padding-right: 7px;\n}\n.padding-L[data-v-86b494a2] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-86b494a2] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#pdf-view .page[data-v-86b494a2] {\n    padding: 30px 40px 30px 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-86b494a2] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-86b494a2] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-86b494a2] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-86b494a2] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-86b494a2] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-86b494a2] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-86b494a2], #pdf-view table tbody tr.total[data-v-86b494a2] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-86b494a2] {\n      color: #000;\n      font-size: 12px;\n}\n#pdf-view table tbody td[data-v-86b494a2] {\n      padding: 2px 3px;\n}\n.report-payout[data-v-86b494a2] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.report-payout table tbody tr.total[data-v-86b494a2] {\n    border-top: 1px solid #333;\n    font-weight: 600;\n    font-size: 12.5px;\n}\n.report-payout table .driverCount[data-v-86b494a2], .report-payout table .rsvpCount[data-v-86b494a2], .report-payout table .totalPax[data-v-86b494a2], .report-payout table .avgPax[data-v-86b494a2] {\n    text-align: center;\n}\n.report-payout table .gasFee[data-v-86b494a2], .report-payout table .fare[data-v-86b494a2], .report-payout table .totalFare[data-v-86b494a2], .report-payout table .avgFare[data-v-86b494a2], .report-payout table .travelInsurance[data-v-86b494a2], .report-payout table .airportFee[data-v-86b494a2], .report-payout table .extraFee[data-v-86b494a2], .report-payout table .charged[data-v-86b494a2], .report-payout table .payment[data-v-86b494a2], .report-payout table .pickupFee[data-v-86b494a2],\n  .report-payout table .tips[data-v-86b494a2], .report-payout table .bonus[data-v-86b494a2], .report-payout table .cancelFee[data-v-86b494a2], .report-payout table .driverPayment[data-v-86b494a2], .report-payout table .paymentPercent[data-v-86b494a2], .report-payout table .driverPercent[data-v-86b494a2] {\n    text-align: right;\n}\n.report-payout table .driverPayment[data-v-86b494a2] {\n    font-weight: 600;\n}\n.report-payout table .gasFee[data-v-86b494a2], .report-payout table .fare[data-v-86b494a2], .report-payout table .travelInsurance[data-v-86b494a2], .report-payout table .airportFee[data-v-86b494a2], .report-payout table .payment[data-v-86b494a2], .report-payout table .pickupFee[data-v-86b494a2], .report-payout table .tips[data-v-86b494a2], .report-payout table .bonus[data-v-86b494a2], .report-payout table .cancelFee[data-v-86b494a2] {\n    color: #777;\n}\n.report-payout table .company[data-v-86b494a2] {\n    max-width: 150px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n#pdf-view.mileage[data-v-86b494a2] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n#pdf-view.mileage table tbody tr.total[data-v-86b494a2] {\n    border-top: 1px solid #333;\n}\n#pdf-view.mileage table .date[data-v-86b494a2], #pdf-view.mileage table .rsvpCount[data-v-86b494a2], #pdf-view.mileage table .asap[data-v-86b494a2], #pdf-view.mileage table .web[data-v-86b494a2], #pdf-view.mileage table .admin[data-v-86b494a2], #pdf-view.mileage table .app[data-v-86b494a2], #pdf-view.mileage table .mileage[data-v-86b494a2] {\n    text-align: center;\n}\n#pdf-view.mileage table .totalFare[data-v-86b494a2], #pdf-view.mileage table .avgFare[data-v-86b494a2], #pdf-view.mileage table .extraFee[data-v-86b494a2], #pdf-view.mileage table .driverPayment[data-v-86b494a2], #pdf-view.mileage table .driverPercent[data-v-86b494a2] {\n    text-align: right;\n}\n#pdf-view.mileage table .driver[data-v-86b494a2], #pdf-view.mileage table .service[data-v-86b494a2], #pdf-view.mileage table .promo[data-v-86b494a2] {\n    max-width: 200px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n#pdf-view.mileage table .geofences[data-v-86b494a2] {\n    max-width: 110px;\n    font-size: 11px;\n}\n#pdf-view.mileage table .mileage[data-v-86b494a2] {\n    max-width: 70px;\n}\n.admin-box[data-v-86b494a2] {\n  position: relative;\n  margin: 0 15px 15px 28px;\n}\n.admin-box input[data-v-86b494a2] {\n    padding: 5px 8px;\n    margin: 0 0 5px;\n    font-size: 14px;\n}\n.admin-box ul[data-v-86b494a2] {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    background: #fafafa;\n    border: 1px solid #ccc;\n    border-radius: 2px;\n    height: 100px;\n    overflow: auto;\n}\n.admin-box ul li[data-v-86b494a2] {\n      display: block;\n      line-height: 1;\n      padding: 5px 8px;\n      font-size: 14px;\n      color: #333;\n}\n.admin-box ul li[data-v-86b494a2]:hover {\n        background: #f3f3f3;\n}\n.slide-down-enter-active[data-v-86b494a2], .slide-down-leave-active[data-v-86b494a2] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-86b494a2], .slide-down-leave-to[data-v-86b494a2] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Reports/DriverPayouts.vue"],"names":[],"mappings":";AACA;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,qBAAqB;CACtB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,eAAe;CACpB;AACD;MACM,cAAc;MACd,aAAa;MACb,cAAc;MACd,yBAAyB;MACzB,sBAAsB;MACtB,iBAAiB;MACjB,sBAAsB;MACtB,gBAAgB;MAChB,YAAY;MACZ,wDAAwD;MACxD,6BAA6B;MAC7B,+BAA+B;CACpC;AACD;QACQ,0BAA0B;CACjC;AACD;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;CACtB;AACD;MACM,mBAAmB;MACnB,WAAW;CAChB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,+BAA+B;CACtC;AACD;UACU,YAAY;CACrB;AACD;QACQ,kBAAkB;QAClB,oBAAoB;QACpB,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,iCAAiC;QACjC,yBAAyB;CAChC;AACD;UACU,oBAAoB;UACpB,mBAAmB;CAC5B;AACD;UACU,oBAAoB;CAC7B;AACD;QACQ,WAAW;QACX,+CAA+C;gBACvC,uCAAuC;CACtD;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,cAAc;IACd,YAAY;CACf;AACD;IACI,gBAAgB;CACnB;AACD;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;CAC1B;AACD;EACE,aAAa;CACd;AACD;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,oBAAoB;CACrB;AACD;IACI,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;CAC1B;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,gBAAgB;MAChB,cAAc;MACd,YAAY;MACZ,qBAAqB;CAC1B;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;CACtB;AACD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;IACI,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,iBAAiB;CACpB;AACD;MACM,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;CACxB;AACD;MACM,gBAAgB;CACrB;AACD;EACE,eAAe;CAChB;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,YAAY;CACf;AACD;IACI,kBAAkB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,aAAa;EACb,eAAe;EACf,iBAAiB;CAClB;AACD;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,aAAa;CAChB;AACD;MACM,mBAAmB;MACnB,aAAa;MACb,YAAY;MACZ,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;CACxB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;CACf;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,iBAAiB;CACtB;AACD;QACQ,8BAA8B;CACrC;AACD;MACM,iBAAiB;CACtB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;MACM,iBAAiB;CACtB;AACD;EACE,yBAAyB;EACzB,yBAAyB;CAC1B;AACD;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;CACrB;AACD;IACI,mBAAmB;CACtB;AACD;;IAEI,kBAAkB;CACrB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,YAAY;CACf;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;IACxB,oBAAoB;CACvB;AACD;EACE,yBAAyB;EACzB,yBAAyB;CAC1B;AACD;IACI,2BAA2B;CAC9B;AACD;IACI,mBAAmB;CACtB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;IACxB,oBAAoB;CACvB;AACD;IACI,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,gBAAgB;CACnB;AACD;EACE,mBAAmB;EACnB,yBAAyB;CAC1B;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;CACnB;AACD;IACI,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,eAAe;CAClB;AACD;MACM,eAAe;MACf,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,YAAY;CACjB;AACD;QACQ,oBAAoB;CAC3B;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ","file":"DriverPayouts.vue","sourcesContent":["\n.rsvp-report-box[data-v-86b494a2] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-86b494a2] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-86b494a2] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-86b494a2] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-86b494a2] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-86b494a2] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-86b494a2] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-86b494a2] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-86b494a2] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-86b494a2]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-86b494a2] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-86b494a2] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-86b494a2] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-86b494a2] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-86b494a2]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-86b494a2], .rsvp-report .reports .report.loading[data-v-86b494a2], .rsvp-report .reports .report.has-error[data-v-86b494a2], .rsvp-report .reports .report.success[data-v-86b494a2] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-86b494a2] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-86b494a2] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-86b494a2] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-86b494a2] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-86b494a2] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-86b494a2] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-86b494a2] {\n    cursor: pointer;\n}\n.filter input[data-v-86b494a2] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.weekly-select[data-v-86b494a2] {\n  padding: 5px;\n}\n.download-type[data-v-86b494a2] {\n  float: right;\n  width: 150px;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-86b494a2] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-86b494a2] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-86b494a2] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-86b494a2] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-86b494a2] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-86b494a2] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-86b494a2] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-86b494a2] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-86b494a2]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-86b494a2] {\n      font-size: 13px;\n}\n.form-group[data-v-86b494a2] {\n  display: block;\n}\n.form-group .instruction[data-v-86b494a2] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-86b494a2] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox > *[data-v-86b494a2] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-86b494a2] {\n    margin-right: 3px;\n}\n.padding-R[data-v-86b494a2] {\n  padding-right: 7px;\n}\n.padding-L[data-v-86b494a2] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-86b494a2] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#pdf-view .page[data-v-86b494a2] {\n    padding: 30px 40px 30px 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-86b494a2] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-86b494a2] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-86b494a2] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-86b494a2] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-86b494a2] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-86b494a2] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-86b494a2], #pdf-view table tbody tr.total[data-v-86b494a2] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-86b494a2] {\n      color: #000;\n      font-size: 12px;\n}\n#pdf-view table tbody td[data-v-86b494a2] {\n      padding: 2px 3px;\n}\n.report-payout[data-v-86b494a2] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.report-payout table tbody tr.total[data-v-86b494a2] {\n    border-top: 1px solid #333;\n    font-weight: 600;\n    font-size: 12.5px;\n}\n.report-payout table .driverCount[data-v-86b494a2], .report-payout table .rsvpCount[data-v-86b494a2], .report-payout table .totalPax[data-v-86b494a2], .report-payout table .avgPax[data-v-86b494a2] {\n    text-align: center;\n}\n.report-payout table .gasFee[data-v-86b494a2], .report-payout table .fare[data-v-86b494a2], .report-payout table .totalFare[data-v-86b494a2], .report-payout table .avgFare[data-v-86b494a2], .report-payout table .travelInsurance[data-v-86b494a2], .report-payout table .airportFee[data-v-86b494a2], .report-payout table .extraFee[data-v-86b494a2], .report-payout table .charged[data-v-86b494a2], .report-payout table .payment[data-v-86b494a2], .report-payout table .pickupFee[data-v-86b494a2],\n  .report-payout table .tips[data-v-86b494a2], .report-payout table .bonus[data-v-86b494a2], .report-payout table .cancelFee[data-v-86b494a2], .report-payout table .driverPayment[data-v-86b494a2], .report-payout table .paymentPercent[data-v-86b494a2], .report-payout table .driverPercent[data-v-86b494a2] {\n    text-align: right;\n}\n.report-payout table .driverPayment[data-v-86b494a2] {\n    font-weight: 600;\n}\n.report-payout table .gasFee[data-v-86b494a2], .report-payout table .fare[data-v-86b494a2], .report-payout table .travelInsurance[data-v-86b494a2], .report-payout table .airportFee[data-v-86b494a2], .report-payout table .payment[data-v-86b494a2], .report-payout table .pickupFee[data-v-86b494a2], .report-payout table .tips[data-v-86b494a2], .report-payout table .bonus[data-v-86b494a2], .report-payout table .cancelFee[data-v-86b494a2] {\n    color: #777;\n}\n.report-payout table .company[data-v-86b494a2] {\n    max-width: 150px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n#pdf-view.mileage[data-v-86b494a2] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n#pdf-view.mileage table tbody tr.total[data-v-86b494a2] {\n    border-top: 1px solid #333;\n}\n#pdf-view.mileage table .date[data-v-86b494a2], #pdf-view.mileage table .rsvpCount[data-v-86b494a2], #pdf-view.mileage table .asap[data-v-86b494a2], #pdf-view.mileage table .web[data-v-86b494a2], #pdf-view.mileage table .admin[data-v-86b494a2], #pdf-view.mileage table .app[data-v-86b494a2], #pdf-view.mileage table .mileage[data-v-86b494a2] {\n    text-align: center;\n}\n#pdf-view.mileage table .totalFare[data-v-86b494a2], #pdf-view.mileage table .avgFare[data-v-86b494a2], #pdf-view.mileage table .extraFee[data-v-86b494a2], #pdf-view.mileage table .driverPayment[data-v-86b494a2], #pdf-view.mileage table .driverPercent[data-v-86b494a2] {\n    text-align: right;\n}\n#pdf-view.mileage table .driver[data-v-86b494a2], #pdf-view.mileage table .service[data-v-86b494a2], #pdf-view.mileage table .promo[data-v-86b494a2] {\n    max-width: 200px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n#pdf-view.mileage table .geofences[data-v-86b494a2] {\n    max-width: 110px;\n    font-size: 11px;\n}\n#pdf-view.mileage table .mileage[data-v-86b494a2] {\n    max-width: 70px;\n}\n.admin-box[data-v-86b494a2] {\n  position: relative;\n  margin: 0 15px 15px 28px;\n}\n.admin-box input[data-v-86b494a2] {\n    padding: 5px 8px;\n    margin: 0 0 5px;\n    font-size: 14px;\n}\n.admin-box ul[data-v-86b494a2] {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    background: #fafafa;\n    border: 1px solid #ccc;\n    border-radius: 2px;\n    height: 100px;\n    overflow: auto;\n}\n.admin-box ul li[data-v-86b494a2] {\n      display: block;\n      line-height: 1;\n      padding: 5px 8px;\n      font-size: 14px;\n      color: #333;\n}\n.admin-box ul li[data-v-86b494a2]:hover {\n        background: #f3f3f3;\n}\n.slide-down-enter-active[data-v-86b494a2], .slide-down-leave-active[data-v-86b494a2] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-86b494a2], .slide-down-leave-to[data-v-86b494a2] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rsvp-report-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"instruction"},[_vm._v("Please select a start and end date:")]),_vm._v(" "),_c('div',{staticClass:"row expanded"},[_c('div',{staticClass:"small-12 column"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedWeek),expression:"selectedWeek"}],staticClass:"weekly-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedWeek=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.weeks),function(week,index){return _c('option',{key:index,domProps:{"value":week}},[_vm._v("\n              "+_vm._s(week.start.format('MMM DD'))+" - "+_vm._s(week.end.format('MMM DD'))+"\n            ")])}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"list-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"download-type"},[_c('label',{class:{'pdf':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pdfChecked),expression:"pdfChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.pdfChecked)?_vm._i(_vm.pdfChecked,null)>-1:(_vm.pdfChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.pdfChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.pdfChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.pdfChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.pdfChecked=$$c}}}}),_vm._v("\n            PDF\n          ")]),_vm._v(" "),_c('label',{class:{'csv':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.csvChecked),expression:"csvChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.csvChecked)?_vm._i(_vm.csvChecked,null)>-1:(_vm.csvChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.csvChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.csvChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.csvChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.csvChecked=$$c}}}}),_vm._v("\n            CSV\n          ")])]),_vm._v(" "),_c('div',{staticClass:"instruction"},[_vm._v("Please select the reports to generate:")]),_vm._v(" "),_c('div',{staticClass:"row expanded reports"},[_c('div',{class:['small-12 column report', _vm.reportStatus.payout, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.payout),expression:"selectedReports.payout"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.payout)?_vm._i(_vm.selectedReports.payout,null)>-1:(_vm.selectedReports.payout)},on:{"change":function($event){var $$a=_vm.selectedReports.payout,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "payout", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "payout", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "payout", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('payout')))])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.show),expression:"error.show"}],staticClass:"error"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.message),expression:"!!error.message"}]},[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.empty.length),expression:"error.empty.length"}]},[_c('li',[_vm._v("Empty Result:")]),_vm._v(" "),_vm._l((_vm.error.empty),function(empty){return _c('li',[_vm._v("- "+_vm._s(empty))])})],2)])]),_vm._v(" "),_c('a',{class:{ 'button cta success small block': true, disabled: _vm.pdf.loading },attrs:{"href":"javascript:;"},on:{"click":_vm.startProcess}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.pdf.loading),expression:"pdf.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pdf.loading),expression:"!pdf.loading"}]},[_vm._v("Generate and Download Report")])])],1),_vm._v(" "),_c('div',{class:[_vm.pdf.class],attrs:{"id":"pdf-view"}},[_vm._l((_vm.pdf.table.data),function(pageData,pageIndex){return _c('div',{key:pageIndex,class:['page', pageIndex]},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',_vm._l((_vm.pdf.table.label),function(label){return _c('th',{domProps:{"innerHTML":_vm._s(label)}})}),0)]),_vm._v(" "),_c('tbody',[_vm._l((pageData),function(data,index){return _c('tr',{key:index},_vm._l((data),function(value,i){return _c('td',{key:i,class:[i]},[_vm._v(_vm._s(value))])}),0)}),_vm._v(" "),(_vm.isPayout && _vm.currentPage(pageIndex) == _vm.totalPage)?_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"driverCount"},[_vm._v(_vm._s(_vm.pdf.table.total.drivers))]),_vm._v(" "),_c('td',{staticClass:"rsvpCount"},[_vm._v(_vm._s(_vm.pdf.table.total.rsvp))]),_vm._v(" "),_c('td',{staticClass:"fare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fare))]),_vm._v(" "),_c('td',{staticClass:"travelInsurance"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.travelInsurance))]),_vm._v(" "),_c('td',{staticClass:"airportFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.airportFee))]),_vm._v(" "),_c('td',{staticClass:"totalFare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fareSum))]),_vm._v(" "),_c('td',{staticClass:"avgFare"},[_vm._v(_vm._s(_vm.pdf.table.total.avgFare))]),_vm._v(" "),_c('td',{staticClass:"payment"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.payment))]),_vm._v(" "),_c('td',{staticClass:"paymentPercent"},[_vm._v(_vm._s(_vm.pdf.table.total.paymentPercent)+"%")]),_vm._v(" "),_c('td',{staticClass:"pickupFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.pickupFee))]),_vm._v(" "),_c('td',{staticClass:"gasFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.gasFee))]),_vm._v(" "),_c('td',{staticClass:"tips"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.tips))]),_vm._v(" "),_c('td',{staticClass:"bonus"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.bonus))]),_vm._v(" "),_c('td',{staticClass:"cancelFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.cancelFee))]),_vm._v(" "),_c('td',{staticClass:"driverPayment"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.extraFee))]),_vm._v(" "),_c('td',{staticClass:"driverPercent"},[_vm._v(_vm._s(_vm.pdf.table.total.percent)+"%")])]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"page-count"},[_vm._v("page "+_vm._s(_vm.currentPage(pageIndex))+" of "+_vm._s(_vm.totalPage))])])}),_vm._v(" "),(Object.keys(_vm.pdf.table.data).length)?_c('div',{class:['page', ("page" + (Object.keys(_vm.pdf.table.data).length + 1))]},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',_vm._l((_vm.pdf.table.label),function(label){return _c('th',{domProps:{"innerHTML":_vm._s(label)}})}),0)]),_vm._v(" "),_c('tbody',[_vm._l((_vm.pdf.table.data[("page" + (Object.keys(_vm.pdf.table.data).length))]),function(data,index){return _c('tr',{key:index},_vm._l((data),function(value,i){return _c('td',{key:i,class:[i]},[_vm._v(_vm._s(value))])}),0)}),_vm._v(" "),(_vm.isPayout)?_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"driverCount"},[_vm._v(_vm._s(_vm.pdf.table.total.drivers))]),_vm._v(" "),_c('td',{staticClass:"rsvpCount"},[_vm._v(_vm._s(_vm.pdf.table.total.rsvp))]),_vm._v(" "),_c('td',{staticClass:"fare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fare))]),_vm._v(" "),_c('td',{staticClass:"travelInsurance"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.travelInsurance))]),_vm._v(" "),_c('td',{staticClass:"airportFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.airportFee))]),_vm._v(" "),_c('td',{staticClass:"totalFare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fareSum))]),_vm._v(" "),_c('td',{staticClass:"avgFare"},[_vm._v(_vm._s(_vm.pdf.table.total.avgFare))]),_vm._v(" "),_c('td',{staticClass:"payment"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.payment))]),_vm._v(" "),_c('td',{staticClass:"paymentPercent"},[_vm._v(_vm._s(_vm.pdf.table.total.paymentPercent)+"%")]),_vm._v(" "),_c('td',{staticClass:"pickupFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.pickupFee))]),_vm._v(" "),_c('td',{staticClass:"gasFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.gasFee))]),_vm._v(" "),_c('td',{staticClass:"tips"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.tips))]),_vm._v(" "),_c('td',{staticClass:"bonus"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.bonus))]),_vm._v(" "),_c('td',{staticClass:"cancelFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.cancelFee))]),_vm._v(" "),_c('td',{staticClass:"driverPayment"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.extraFee))]),_vm._v(" "),_c('td',{staticClass:"driverPercent"},[_vm._v(_vm._s(_vm.pdf.table.total.percent)+"%")])]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"page-count"},[_vm._v("page "+_vm._s(Object.keys(_vm.pdf.table.data).length)+" of "+_vm._s(_vm.totalPage))])]):_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackendManager_vue__ = __webpack_require__(526);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7bfef0e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackendManager_vue__ = __webpack_require__(1493);
function injectStyle (ssrContext) {
  __webpack_require__(1491)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d7bfef0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackendManager_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7bfef0e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackendManager_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1492);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("50ac4d52", content, true, {});

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.rsvp-report-box[data-v-d7bfef0e] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-d7bfef0e] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-d7bfef0e] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-d7bfef0e] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-d7bfef0e] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .reports[data-v-d7bfef0e] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-d7bfef0e] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-d7bfef0e]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-d7bfef0e] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-d7bfef0e] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-d7bfef0e] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-d7bfef0e] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-d7bfef0e]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-d7bfef0e], .rsvp-report .reports .report.loading[data-v-d7bfef0e], .rsvp-report .reports .report.has-error[data-v-d7bfef0e], .rsvp-report .reports .report.success[data-v-d7bfef0e] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-d7bfef0e] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-d7bfef0e] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-d7bfef0e] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-d7bfef0e] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.checkbox[data-v-d7bfef0e] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox > *[data-v-d7bfef0e] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-d7bfef0e] {\n    margin-right: 3px;\n}\n.padding-R[data-v-d7bfef0e] {\n  padding-right: 7px;\n}\n.padding-L[data-v-d7bfef0e] {\n  padding-left: 7px;\n}\n.error[data-v-d7bfef0e] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-d7bfef0e] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-d7bfef0e]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-d7bfef0e] {\n      font-size: 13px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Reports/BackendManager.vue"],"names":[],"mappings":";AACA;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,qBAAqB;CACtB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,eAAe;CACpB;AACD;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;CACtB;AACD;MACM,mBAAmB;MACnB,WAAW;CAChB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,+BAA+B;CACtC;AACD;UACU,YAAY;CACrB;AACD;QACQ,kBAAkB;QAClB,oBAAoB;QACpB,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,iCAAiC;QACjC,yBAAyB;CAChC;AACD;UACU,oBAAoB;UACpB,mBAAmB;CAC5B;AACD;UACU,oBAAoB;CAC7B;AACD;QACQ,WAAW;QACX,+CAA+C;gBACvC,uCAAuC;CACtD;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,YAAY;CACf;AACD;IACI,kBAAkB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;IACI,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,iBAAiB;CACpB;AACD;MACM,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;CACxB;AACD;MACM,gBAAgB;CACrB","file":"BackendManager.vue","sourcesContent":["\n.rsvp-report-box[data-v-d7bfef0e] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-d7bfef0e] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-d7bfef0e] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-d7bfef0e] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-d7bfef0e] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .reports[data-v-d7bfef0e] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-d7bfef0e] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-d7bfef0e]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-d7bfef0e] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-d7bfef0e] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-d7bfef0e] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-d7bfef0e] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-d7bfef0e]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-d7bfef0e], .rsvp-report .reports .report.loading[data-v-d7bfef0e], .rsvp-report .reports .report.has-error[data-v-d7bfef0e], .rsvp-report .reports .report.success[data-v-d7bfef0e] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-d7bfef0e] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-d7bfef0e] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-d7bfef0e] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-d7bfef0e] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.checkbox[data-v-d7bfef0e] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox > *[data-v-d7bfef0e] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-d7bfef0e] {\n    margin-right: 3px;\n}\n.padding-R[data-v-d7bfef0e] {\n  padding-right: 7px;\n}\n.padding-L[data-v-d7bfef0e] {\n  padding-left: 7px;\n}\n.error[data-v-d7bfef0e] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-d7bfef0e] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-d7bfef0e]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-d7bfef0e] {\n      font-size: 13px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rsvp-report-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"instruction"},[_vm._v("Please select a date:")]),_vm._v(" "),_c('div',{staticClass:"row expanded"},[_c('div',{staticClass:"small-12 column padding-R"},[_c('div',{staticClass:"date-input"},[_c('label',[_vm._v("Start Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy"},model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"list-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"instruction"},[_vm._v("Please select the reports to generate:")]),_vm._v(" "),_c('div',{staticClass:"row expanded reports"},[_c('div',{class:['small-12 column report', _vm.reportStatus.assigned, {'processing':_vm.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.assigned),expression:"selectedReports.assigned"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.assigned)?_vm._i(_vm.selectedReports.assigned,null)>-1:(_vm.selectedReports.assigned)},on:{"change":function($event){var $$a=_vm.selectedReports.assigned,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "assigned", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "assigned", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "assigned", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('assigned')))])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.show),expression:"error.show"}],staticClass:"error"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.message),expression:"!!error.message"}]},[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.empty.length),expression:"error.empty.length"}]},[_c('li',[_vm._v("Empty Result:")]),_vm._v(" "),_vm._l((_vm.error.empty),function(empty,ix){return _c('li',{key:ix},[_vm._v("- "+_vm._s(empty))])})],2)])]),_vm._v(" "),_c('a',{class:{ 'button cta success small block': true, disabled: _vm.loading },attrs:{"href":"javascript:;"},on:{"click":_vm.generate}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}]},[_vm._v("Generate and Download Report")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mtech_vue__ = __webpack_require__(527);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2143ac30_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mtech_vue__ = __webpack_require__(1497);
function injectStyle (ssrContext) {
  __webpack_require__(1495)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2143ac30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mtech_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2143ac30_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mtech_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1496);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0dff0973", content, true, {});

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.rsvp-report-box[data-v-2143ac30] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-2143ac30] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-2143ac30] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-2143ac30] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-2143ac30] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-2143ac30] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-2143ac30] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-2143ac30] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-2143ac30] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-2143ac30]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-2143ac30] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-2143ac30] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-2143ac30] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-2143ac30] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-2143ac30]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-2143ac30], .rsvp-report .reports .report.loading[data-v-2143ac30], .rsvp-report .reports .report.has-error[data-v-2143ac30], .rsvp-report .reports .report.success[data-v-2143ac30] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-2143ac30] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-2143ac30] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-2143ac30] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-2143ac30] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-2143ac30] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-2143ac30] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-2143ac30] {\n    cursor: pointer;\n}\n.filter input[data-v-2143ac30] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.weekly-select[data-v-2143ac30] {\n  padding: 5px;\n}\n.download-type[data-v-2143ac30] {\n  float: right;\n  width: 150px;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-2143ac30] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-2143ac30] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-2143ac30] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-2143ac30] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-2143ac30] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-2143ac30] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-2143ac30] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-2143ac30] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-2143ac30]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-2143ac30] {\n      font-size: 13px;\n}\n.form-group[data-v-2143ac30] {\n  display: block;\n}\n.form-group .instruction[data-v-2143ac30] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-2143ac30] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox > *[data-v-2143ac30] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-2143ac30] {\n    margin-right: 3px;\n}\n.padding-R[data-v-2143ac30] {\n  padding-right: 7px;\n}\n.padding-L[data-v-2143ac30] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-2143ac30] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#pdf-view .page[data-v-2143ac30] {\n    padding: 30px 40px 30px 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-2143ac30] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-2143ac30] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-2143ac30] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-2143ac30] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-2143ac30] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-2143ac30] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-2143ac30], #pdf-view table tbody tr.total[data-v-2143ac30] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-2143ac30] {\n      color: #000;\n      font-size: 12px;\n}\n#pdf-view table tbody td[data-v-2143ac30] {\n      padding: 2px 3px;\n}\n.report-mtech[data-v-2143ac30] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.report-mtech table tbody tr.total[data-v-2143ac30] {\n    border-top: 1px solid #333;\n    font-weight: 600;\n    font-size: 12.5px;\n}\n.report-mtech table .id[data-v-2143ac30], .report-mtech table .created[data-v-2143ac30], .report-mtech table .pickupDate[data-v-2143ac30], .report-mtech table .origAmount[data-v-2143ac30], .report-mtech table .chargeAmount[data-v-2143ac30], .report-mtech table .serviceType[data-v-2143ac30], .report-mtech table .geofence[data-v-2143ac30], .report-mtech table .source[data-v-2143ac30] {\n    text-align: center;\n}\n.report-mtech table .gasFee[data-v-2143ac30], .report-mtech table .fare[data-v-2143ac30], .report-mtech table .travelInsurance[data-v-2143ac30], .report-mtech table .airportFee[data-v-2143ac30], .report-mtech table .payment[data-v-2143ac30], .report-mtech table .pickupFee[data-v-2143ac30], .report-mtech table .tips[data-v-2143ac30], .report-mtech table .bonus[data-v-2143ac30], .report-mtech table .cancelFee[data-v-2143ac30] {\n    color: #777;\n}\n.slide-down-enter-active[data-v-2143ac30], .slide-down-leave-active[data-v-2143ac30] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-2143ac30], .slide-down-leave-to[data-v-2143ac30] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Reports/mtech.vue"],"names":[],"mappings":";AACA;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,qBAAqB;CACtB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,eAAe;CACpB;AACD;MACM,cAAc;MACd,aAAa;MACb,cAAc;MACd,yBAAyB;MACzB,sBAAsB;MACtB,iBAAiB;MACjB,sBAAsB;MACtB,gBAAgB;MAChB,YAAY;MACZ,wDAAwD;MACxD,6BAA6B;MAC7B,+BAA+B;CACpC;AACD;QACQ,0BAA0B;CACjC;AACD;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;CACtB;AACD;MACM,mBAAmB;MACnB,WAAW;CAChB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,+BAA+B;CACtC;AACD;UACU,YAAY;CACrB;AACD;QACQ,kBAAkB;QAClB,oBAAoB;QACpB,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,iCAAiC;QACjC,yBAAyB;CAChC;AACD;UACU,oBAAoB;UACpB,mBAAmB;CAC5B;AACD;UACU,oBAAoB;CAC7B;AACD;QACQ,WAAW;QACX,+CAA+C;gBACvC,uCAAuC;CACtD;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,cAAc;IACd,YAAY;CACf;AACD;IACI,gBAAgB;CACnB;AACD;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;CAC1B;AACD;EACE,aAAa;CACd;AACD;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,oBAAoB;CACrB;AACD;IACI,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;CAC1B;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,gBAAgB;MAChB,cAAc;MACd,YAAY;MACZ,qBAAqB;CAC1B;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;CACtB;AACD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;IACI,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,iBAAiB;CACpB;AACD;MACM,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;CACxB;AACD;MACM,gBAAgB;CACrB;AACD;EACE,eAAe;CAChB;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,YAAY;CACf;AACD;IACI,kBAAkB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,aAAa;EACb,eAAe;EACf,iBAAiB;CAClB;AACD;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,aAAa;CAChB;AACD;MACM,mBAAmB;MACnB,aAAa;MACb,YAAY;MACZ,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;CACxB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;CACf;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,iBAAiB;CACtB;AACD;QACQ,8BAA8B;CACrC;AACD;MACM,iBAAiB;CACtB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;MACM,iBAAiB;CACtB;AACD;EACE,yBAAyB;EACzB,yBAAyB;CAC1B;AACD;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;CACrB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,YAAY;CACf;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ","file":"mtech.vue","sourcesContent":["\n.rsvp-report-box[data-v-2143ac30] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-2143ac30] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-2143ac30] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-2143ac30] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-2143ac30] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-2143ac30] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-2143ac30] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-2143ac30] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-2143ac30] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-2143ac30]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-2143ac30] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-2143ac30] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-2143ac30] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-2143ac30] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-2143ac30]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-2143ac30], .rsvp-report .reports .report.loading[data-v-2143ac30], .rsvp-report .reports .report.has-error[data-v-2143ac30], .rsvp-report .reports .report.success[data-v-2143ac30] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-2143ac30] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-2143ac30] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-2143ac30] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-2143ac30] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-2143ac30] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-2143ac30] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-2143ac30] {\n    cursor: pointer;\n}\n.filter input[data-v-2143ac30] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.weekly-select[data-v-2143ac30] {\n  padding: 5px;\n}\n.download-type[data-v-2143ac30] {\n  float: right;\n  width: 150px;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-2143ac30] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-2143ac30] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-2143ac30] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-2143ac30] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-2143ac30] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-2143ac30] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-2143ac30] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-2143ac30] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-2143ac30]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-2143ac30] {\n      font-size: 13px;\n}\n.form-group[data-v-2143ac30] {\n  display: block;\n}\n.form-group .instruction[data-v-2143ac30] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-2143ac30] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox > *[data-v-2143ac30] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-2143ac30] {\n    margin-right: 3px;\n}\n.padding-R[data-v-2143ac30] {\n  padding-right: 7px;\n}\n.padding-L[data-v-2143ac30] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-2143ac30] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#pdf-view .page[data-v-2143ac30] {\n    padding: 30px 40px 30px 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-2143ac30] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-2143ac30] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-2143ac30] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-2143ac30] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-2143ac30] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-2143ac30] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-2143ac30], #pdf-view table tbody tr.total[data-v-2143ac30] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-2143ac30] {\n      color: #000;\n      font-size: 12px;\n}\n#pdf-view table tbody td[data-v-2143ac30] {\n      padding: 2px 3px;\n}\n.report-mtech[data-v-2143ac30] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.report-mtech table tbody tr.total[data-v-2143ac30] {\n    border-top: 1px solid #333;\n    font-weight: 600;\n    font-size: 12.5px;\n}\n.report-mtech table .id[data-v-2143ac30], .report-mtech table .created[data-v-2143ac30], .report-mtech table .pickupDate[data-v-2143ac30], .report-mtech table .origAmount[data-v-2143ac30], .report-mtech table .chargeAmount[data-v-2143ac30], .report-mtech table .serviceType[data-v-2143ac30], .report-mtech table .geofence[data-v-2143ac30], .report-mtech table .source[data-v-2143ac30] {\n    text-align: center;\n}\n.report-mtech table .gasFee[data-v-2143ac30], .report-mtech table .fare[data-v-2143ac30], .report-mtech table .travelInsurance[data-v-2143ac30], .report-mtech table .airportFee[data-v-2143ac30], .report-mtech table .payment[data-v-2143ac30], .report-mtech table .pickupFee[data-v-2143ac30], .report-mtech table .tips[data-v-2143ac30], .report-mtech table .bonus[data-v-2143ac30], .report-mtech table .cancelFee[data-v-2143ac30] {\n    color: #777;\n}\n.slide-down-enter-active[data-v-2143ac30], .slide-down-leave-active[data-v-2143ac30] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-2143ac30], .slide-down-leave-to[data-v-2143ac30] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rsvp-report-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"instruction"},[_vm._v("Please select a start and end date:")]),_vm._v(" "),_c('div',{staticClass:"row expanded"},[_c('div',{staticClass:"small-6 column padding-R"},[_c('div',{staticClass:"date-input"},[_c('label',[_vm._v("Start Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}})],1)]),_vm._v(" "),_c('div',{staticClass:"small-6 column padding-L"},[_c('div',{staticClass:"date-input"},[_c('label',[_vm._v("End Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"list-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"download-type"},[_c('label',{class:{'pdf':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pdfChecked),expression:"pdfChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.pdfChecked)?_vm._i(_vm.pdfChecked,null)>-1:(_vm.pdfChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.pdfChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.pdfChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.pdfChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.pdfChecked=$$c}}}}),_vm._v("\n            PDF\n          ")]),_vm._v(" "),_c('label',{class:{'csv':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.csvChecked),expression:"csvChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.csvChecked)?_vm._i(_vm.csvChecked,null)>-1:(_vm.csvChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.csvChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.csvChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.csvChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.csvChecked=$$c}}}}),_vm._v("\n            CSV\n          ")])]),_vm._v(" "),_c('div',{staticClass:"instruction"},[_vm._v("Please select the reports to generate:")]),_vm._v(" "),_c('div',{staticClass:"row expanded reports"},[_c('div',{class:['small-12 column report', _vm.reportStatus.mtech, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.mtech),expression:"selectedReports.mtech"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.mtech)?_vm._i(_vm.selectedReports.mtech,null)>-1:(_vm.selectedReports.mtech)},on:{"change":function($event){var $$a=_vm.selectedReports.mtech,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "mtech", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "mtech", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "mtech", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('mtech')))])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateType),expression:"dateType"}],class:{'disabled':!_vm.selectedReports.mtech},attrs:{"disabled":!_vm.selectedReports.mtech},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dateType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v("All Bookings")]),_vm._v(" "),_c('option',{attrs:{"value":"completed"}},[_vm._v("Completed")])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.show),expression:"error.show"}],staticClass:"error"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.message),expression:"!!error.message"}]},[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.empty.length),expression:"error.empty.length"}]},[_c('li',[_vm._v("Empty Result:")]),_vm._v(" "),_vm._l((_vm.error.empty),function(empty,i){return _c('li',{key:i},[_vm._v("- "+_vm._s(empty))])})],2)])]),_vm._v(" "),_c('a',{class:['button cta success small block', {disabled: _vm.pdf.loading}],attrs:{"href":"javascript:;"},on:{"click":_vm.startProcess}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.pdf.loading),expression:"pdf.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pdf.loading),expression:"!pdf.loading"}]},[_vm._v("Generate and Download Report")])])],1),_vm._v(" "),_c('div',{class:[_vm.pdf.class],attrs:{"id":"pdf-view"}},[_vm._l((_vm.pdf.table.data),function(pageData,pageIndex){return _c('div',{key:pageIndex,class:['page', pageIndex]},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',_vm._l((_vm.pdf.table.label),function(label){return _c('th',{domProps:{"innerHTML":_vm._s(label)}})}),0)]),_vm._v(" "),_c('tbody',[_vm._l((pageData),function(data,index){return _c('tr',{key:index},_vm._l((data),function(value,i){return _c('td',{key:i,class:[i]},[_vm._v(_vm._s(value))])}),0)}),_vm._v(" "),(_vm.isMtech && _vm.currentPage(pageIndex) == _vm.totalPage)?_c('tr',{staticClass:"total"},[_c('td',{attrs:{"colspan":"6"}},[_vm._v("Total ("+_vm._s(_vm.pdf.table.total.rsvp)+")")]),_vm._v(" "),_c('td',{staticClass:"origAmount"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.origAmount))]),_vm._v(" "),_c('td',{staticClass:"chargeAmount"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.chargeAmount))])]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"page-count"},[_vm._v("page "+_vm._s(_vm.currentPage(pageIndex))+" of "+_vm._s(_vm.totalPage))])])}),_vm._v(" "),(Object.keys(_vm.pdf.table.data).length)?_c('div',{class:['page', ("page" + (Object.keys(_vm.pdf.table.data).length + 1))]},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',_vm._l((_vm.pdf.table.label),function(label){return _c('th',{domProps:{"innerHTML":_vm._s(label)}})}),0)]),_vm._v(" "),_c('tbody',[_vm._l((_vm.pdf.table.data[("page" + (Object.keys(_vm.pdf.table.data).length))]),function(data,index){return _c('tr',{key:index},_vm._l((data),function(value,i){return _c('td',{key:i,class:[i]},[_vm._v(_vm._s(value))])}),0)}),_vm._v(" "),(_vm.isMtech)?_c('tr',{staticClass:"total"},[_c('td',{attrs:{"colspan":"6"}},[_vm._v("Total ("+_vm._s(_vm.pdf.table.total.rsvp)+")")]),_vm._v(" "),_c('td',{staticClass:"origAmount"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.origAmount))]),_vm._v(" "),_c('td',{staticClass:"chargeAmount"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.chargeAmount))])]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"page-count"},[_vm._v("page "+_vm._s(Object.keys(_vm.pdf.table.data).length)+" of "+_vm._s(_vm.totalPage))])]):_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DailyRsvpReport_vue__ = __webpack_require__(528);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9eed97c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DailyRsvpReport_vue__ = __webpack_require__(1501);
function injectStyle (ssrContext) {
  __webpack_require__(1499)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d9eed97c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DailyRsvpReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9eed97c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DailyRsvpReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1500);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("9b865ea8", content, true, {});

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.reservation-notes-modal[data-v-d9eed97c] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.reservation-notes-modal.show[data-v-d9eed97c] {\n    top: 0;\n    opacity: 1;\n}\n.reservation-notes-modal-container[data-v-d9eed97c] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.reservation-notes-modal-content[data-v-d9eed97c] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  padding: 20px;\n}\n.lr-title[data-v-d9eed97c] {\n  font-size: 16px;\n  margin-bottom: 20px;\n  display: block;\n}\n.lr-label[data-v-d9eed97c] {\n  display: block;\n  text-align: left;\n  margin-bottom: 2px;\n  font-size: 14px;\n  color: #777;\n  display: block;\n}\n.download-type[data-v-d9eed97c] {\n  width: 100%;\n  padding-bottom: 5px;\n  margin-top: 10px;\n}\n.download-type label[data-v-d9eed97c] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 20px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-d9eed97c] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-d9eed97c] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-d9eed97c] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-d9eed97c] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.generate[data-v-d9eed97c] {\n  margin-top: 10px;\n}\n.error[data-v-d9eed97c] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-top: 10px;\n}\n#pdf-view[data-v-d9eed97c] {\n  position: fixed;\n  top: 0%;\n  right: 100%;\n  width: 1122px;\n  height: 793px;\n  background: #fff;\n  z-index: -1;\n}\n#pdf-view .page-daily[data-v-d9eed97c] {\n    padding: 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page-daily .page-count[data-v-d9eed97c] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-d9eed97c] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-d9eed97c] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-d9eed97c] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-d9eed97c] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-d9eed97c] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-d9eed97c], #pdf-view table tbody tr.total[data-v-d9eed97c] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-d9eed97c] {\n      color: #000;\n      font-size: 15px;\n      border-top: 1px solid #333;\n}\n#pdf-view table tbody td[data-v-d9eed97c] {\n      padding: 2px 3px;\n}\n#pdf-view table tbody .center[data-v-d9eed97c] {\n      text-align: center;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Reports/DailyRsvpReport.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,cAAc;CACf;AACD;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;CAChB;AACD;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;CAChB;AACD;EACE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;CAClB;AACD;IACI,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;CAC1B;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,gBAAgB;MAChB,cAAc;MACd,YAAY;MACZ,qBAAqB;CAC1B;AACD;EACE,iBAAiB;CAClB;AACD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,iBAAiB;CAClB;AACD;EACE,gBAAgB;EAChB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,YAAY;CACb;AACD;IACI,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,aAAa;CAChB;AACD;MACM,mBAAmB;MACnB,aAAa;MACb,YAAY;MACZ,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;CACxB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;CACf;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,iBAAiB;CACtB;AACD;QACQ,8BAA8B;CACrC;AACD;MACM,iBAAiB;CACtB;AACD;MACM,YAAY;MACZ,gBAAgB;MAChB,2BAA2B;CAChC;AACD;MACM,iBAAiB;CACtB;AACD;MACM,mBAAmB;CACxB","file":"DailyRsvpReport.vue","sourcesContent":["\n.reservation-notes-modal[data-v-d9eed97c] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.reservation-notes-modal.show[data-v-d9eed97c] {\n    top: 0;\n    opacity: 1;\n}\n.reservation-notes-modal-container[data-v-d9eed97c] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.reservation-notes-modal-content[data-v-d9eed97c] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  padding: 20px;\n}\n.lr-title[data-v-d9eed97c] {\n  font-size: 16px;\n  margin-bottom: 20px;\n  display: block;\n}\n.lr-label[data-v-d9eed97c] {\n  display: block;\n  text-align: left;\n  margin-bottom: 2px;\n  font-size: 14px;\n  color: #777;\n  display: block;\n}\n.download-type[data-v-d9eed97c] {\n  width: 100%;\n  padding-bottom: 5px;\n  margin-top: 10px;\n}\n.download-type label[data-v-d9eed97c] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 20px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-d9eed97c] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-d9eed97c] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-d9eed97c] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-d9eed97c] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.generate[data-v-d9eed97c] {\n  margin-top: 10px;\n}\n.error[data-v-d9eed97c] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-top: 10px;\n}\n#pdf-view[data-v-d9eed97c] {\n  position: fixed;\n  top: 0%;\n  right: 100%;\n  width: 1122px;\n  height: 793px;\n  background: #fff;\n  z-index: -1;\n}\n#pdf-view .page-daily[data-v-d9eed97c] {\n    padding: 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page-daily .page-count[data-v-d9eed97c] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-d9eed97c] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-d9eed97c] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-d9eed97c] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-d9eed97c] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-d9eed97c] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-d9eed97c], #pdf-view table tbody tr.total[data-v-d9eed97c] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-d9eed97c] {\n      color: #000;\n      font-size: 15px;\n      border-top: 1px solid #333;\n}\n#pdf-view table tbody td[data-v-d9eed97c] {\n      padding: 2px 3px;\n}\n#pdf-view table tbody .center[data-v-d9eed97c] {\n      text-align: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:['reservation-notes-modal', {show: _vm.modal}],on:{"click":_vm.closeModal}},[_c('div',{staticClass:"reservation-notes-modal-container"},[_c('div',{staticClass:"reservation-notes-modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('b',{staticClass:"lr-title"},[_vm._v("Daily Reservation Report")]),_vm._v(" "),_c('label',{staticClass:"lr-label"},[_vm._v("Select Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('div',{staticClass:"download-type"},[_c('label',{class:['pdf', {'has-error':_vm.error.format}]},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pdfChecked),expression:"pdfChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.pdfChecked)?_vm._i(_vm.pdfChecked,null)>-1:(_vm.pdfChecked)},on:{"change":function($event){var $$a=_vm.pdfChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.pdfChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.pdfChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.pdfChecked=$$c}}}}),_vm._v("\n            PDF\n          ")]),_vm._v(" "),_c('label',{class:['csv', {'has-error':_vm.error.format}]},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.csvChecked),expression:"csvChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.csvChecked)?_vm._i(_vm.csvChecked,null)>-1:(_vm.csvChecked)},on:{"change":function($event){var $$a=_vm.csvChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.csvChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.csvChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.csvChecked=$$c}}}}),_vm._v("\n            CSV\n          ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.msg),expression:"error.msg"}],staticClass:"error",domProps:{"innerHTML":_vm._s(_vm.error.msg)}}),_vm._v(" "),_c('a',{class:['button cta success small block generate', {disabled: _vm.loading}],on:{"click":_vm.generate}},[(_vm.loading)?_c('span',[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Generating Report...\n          ")]):_c('span',[_vm._v("Generate and Download Report")])])],1)])]),_vm._v(" "),_c('div',{attrs:{"id":"pdf-view"}},[_c('div',{staticClass:"page-daily"},[_c('div',{staticClass:"title"},[_vm._v("Opoli Daily Reservation Report")]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.dateFormat(_vm.date)))]),_vm._v(" "),_c('table',[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._l((_vm.pdf.list),function(data,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(data.brand))]),_vm._v(" "),_c('td',{staticClass:"center"},[_vm._v(_vm._s(data.dailyRsvp))]),_vm._v(" "),_c('td',{staticClass:"center"},[_vm._v(_vm._s(data.dailyGoal))]),_vm._v(" "),_c('td',{staticClass:"center"},[_vm._v(_vm._s(data.dailyTotal))]),_vm._v(" "),_c('td',{staticClass:"center"},[_vm._v(_vm._s(data.weeklyRsvp))]),_vm._v(" "),_c('td',{staticClass:"center"},[_vm._v(_vm._s(data.weeklyGoal))]),_vm._v(" "),_c('td',{staticClass:"center"},[_vm._v(_vm._s(data.weeklyTotal))]),_vm._v(" "),_c('td',{staticClass:"center"},[_vm._v(_vm._s(data.avgFare))])])}),_vm._v(" "),_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Total")]),_vm._v(" "),_c('td',{staticClass:"center"},[_vm._v(_vm._s(_vm.pdf.total.totalDailyRsvp))]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"center"},[_vm._v("$"+_vm._s(_vm.pdf.total.totalDailyAmount))]),_vm._v(" "),_c('td',{staticClass:"center"},[_vm._v(_vm._s(_vm.pdf.total.totalWeeklyRsvp))]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"center"},[_vm._v("$"+_vm._s(_vm.pdf.total.totalWeeklyAmount))]),_vm._v(" "),_c('td',{staticClass:"center"})])],2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"table-heading"},[_c('th',[_vm._v("Brand")]),_vm._v(" "),_c('th',[_vm._v("Daily"),_c('br'),_vm._v("RSVP")]),_vm._v(" "),_c('th',[_vm._v("Daily"),_c('br'),_vm._v("Goal")]),_vm._v(" "),_c('th',[_vm._v("Total Amount"),_c('br'),_vm._v("Daily")]),_vm._v(" "),_c('th',[_vm._v("Weekly"),_c('br'),_vm._v("RSVP")]),_vm._v(" "),_c('th',[_vm._v("Weekly"),_c('br'),_vm._v("Goal")]),_vm._v(" "),_c('th',[_vm._v("Total Amount"),_c('br'),_vm._v("Weekly")]),_vm._v(" "),_c('th',[_vm._v("Avg"),_c('br'),_vm._v("Fare")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlockReport_vue__ = __webpack_require__(529);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ade67e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlockReport_vue__ = __webpack_require__(1505);
function injectStyle (ssrContext) {
  __webpack_require__(1503)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8ade67e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlockReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ade67e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlockReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1504);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2c856468", content, true, {});

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.rsvp-report-box[data-v-8ade67e0] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-8ade67e0] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-8ade67e0] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-8ade67e0] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-8ade67e0] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-8ade67e0] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-8ade67e0] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-8ade67e0] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-8ade67e0] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-8ade67e0]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-8ade67e0] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-8ade67e0] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-8ade67e0] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-8ade67e0] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-8ade67e0]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-8ade67e0], .rsvp-report .reports .report.loading[data-v-8ade67e0], .rsvp-report .reports .report.has-error[data-v-8ade67e0], .rsvp-report .reports .report.success[data-v-8ade67e0] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-8ade67e0] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-8ade67e0] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-8ade67e0] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-8ade67e0] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-8ade67e0] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-8ade67e0] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-8ade67e0] {\n    cursor: pointer;\n}\n.filter input[data-v-8ade67e0] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.download-type[data-v-8ade67e0] {\n  float: right;\n  width: 150px;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-8ade67e0] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-8ade67e0] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-8ade67e0] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-8ade67e0] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-8ade67e0] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-8ade67e0] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-8ade67e0] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-8ade67e0] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-8ade67e0]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-8ade67e0] {\n      font-size: 13px;\n}\n.form-group[data-v-8ade67e0] {\n  display: block;\n}\n.form-group .instruction[data-v-8ade67e0] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-8ade67e0] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox.sub[data-v-8ade67e0] {\n    padding-left: 30px;\n    margin-bottom: 10px;\n}\n.checkbox > *[data-v-8ade67e0] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-8ade67e0] {\n    margin-right: 3px;\n}\n.padding-R[data-v-8ade67e0] {\n  padding-right: 7px;\n}\n.padding-L[data-v-8ade67e0] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-8ade67e0] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#pdf-view .page[data-v-8ade67e0] {\n    padding: 30px 40px 30px 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-8ade67e0] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-8ade67e0] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-8ade67e0] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-8ade67e0] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-8ade67e0] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-8ade67e0] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-8ade67e0], #pdf-view table tbody tr.total[data-v-8ade67e0] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-8ade67e0] {\n      color: #000;\n      font-size: 12px;\n}\n#pdf-view table tbody td[data-v-8ade67e0] {\n      padding: 2px 3px;\n}\n.report-block[data-v-8ade67e0] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.report-block table tbody tr.total[data-v-8ade67e0] {\n    border-top: 1px solid #333;\n    font-weight: 600;\n    font-size: 12.5px;\n}\n.report-block table .provId[data-v-8ade67e0], .report-block table .provName[data-v-8ade67e0], .report-block table .sectorId[data-v-8ade67e0], .report-block table .runId[data-v-8ade67e0], .report-block table .rsvpId[data-v-8ade67e0], .report-block table .accepted[data-v-8ade67e0], .report-block table .timeQueue[data-v-8ade67e0], .report-block table .service[data-v-8ade67e0], .report-block table .date[data-v-8ade67e0] {\n    text-align: center;\n}\n.slide-down-enter-active[data-v-8ade67e0], .slide-down-leave-active[data-v-8ade67e0] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-8ade67e0], .slide-down-leave-to[data-v-8ade67e0] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Reports/BlockReport.vue"],"names":[],"mappings":";AACA;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,qBAAqB;CACtB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,eAAe;CACpB;AACD;MACM,cAAc;MACd,aAAa;MACb,cAAc;MACd,yBAAyB;MACzB,sBAAsB;MACtB,iBAAiB;MACjB,sBAAsB;MACtB,gBAAgB;MAChB,YAAY;MACZ,wDAAwD;MACxD,6BAA6B;MAC7B,+BAA+B;CACpC;AACD;QACQ,0BAA0B;CACjC;AACD;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;CACtB;AACD;MACM,mBAAmB;MACnB,WAAW;CAChB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,+BAA+B;CACtC;AACD;UACU,YAAY;CACrB;AACD;QACQ,kBAAkB;QAClB,oBAAoB;QACpB,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,iCAAiC;QACjC,yBAAyB;CAChC;AACD;UACU,oBAAoB;UACpB,mBAAmB;CAC5B;AACD;UACU,oBAAoB;CAC7B;AACD;QACQ,WAAW;QACX,+CAA+C;gBACvC,uCAAuC;CACtD;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,cAAc;IACd,YAAY;CACf;AACD;IACI,gBAAgB;CACnB;AACD;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;CAC1B;AACD;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,oBAAoB;CACrB;AACD;IACI,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;CAC1B;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,gBAAgB;MAChB,cAAc;MACd,YAAY;MACZ,qBAAqB;CAC1B;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;CACtB;AACD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;IACI,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,iBAAiB;CACpB;AACD;MACM,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;CACxB;AACD;MACM,gBAAgB;CACrB;AACD;EACE,eAAe;CAChB;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;IACI,mBAAmB;IACnB,oBAAoB;CACvB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,YAAY;CACf;AACD;IACI,kBAAkB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,aAAa;EACb,eAAe;EACf,iBAAiB;CAClB;AACD;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,aAAa;CAChB;AACD;MACM,mBAAmB;MACnB,aAAa;MACb,YAAY;MACZ,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;CACxB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;CACf;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,iBAAiB;CACtB;AACD;QACQ,8BAA8B;CACrC;AACD;MACM,iBAAiB;CACtB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;MACM,iBAAiB;CACtB;AACD;EACE,yBAAyB;EACzB,yBAAyB;CAC1B;AACD;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;CACrB;AACD;IACI,mBAAmB;CACtB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ","file":"BlockReport.vue","sourcesContent":["\n.rsvp-report-box[data-v-8ade67e0] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-8ade67e0] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-8ade67e0] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-8ade67e0] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-8ade67e0] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-8ade67e0] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-8ade67e0] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-8ade67e0] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-8ade67e0] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-8ade67e0]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-8ade67e0] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-8ade67e0] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-8ade67e0] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-8ade67e0] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-8ade67e0]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-8ade67e0], .rsvp-report .reports .report.loading[data-v-8ade67e0], .rsvp-report .reports .report.has-error[data-v-8ade67e0], .rsvp-report .reports .report.success[data-v-8ade67e0] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-8ade67e0] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-8ade67e0] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-8ade67e0] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-8ade67e0] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-8ade67e0] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-8ade67e0] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-8ade67e0] {\n    cursor: pointer;\n}\n.filter input[data-v-8ade67e0] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.download-type[data-v-8ade67e0] {\n  float: right;\n  width: 150px;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-8ade67e0] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-8ade67e0] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-8ade67e0] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-8ade67e0] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-8ade67e0] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-8ade67e0] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-8ade67e0] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-8ade67e0] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-8ade67e0]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-8ade67e0] {\n      font-size: 13px;\n}\n.form-group[data-v-8ade67e0] {\n  display: block;\n}\n.form-group .instruction[data-v-8ade67e0] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-8ade67e0] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox.sub[data-v-8ade67e0] {\n    padding-left: 30px;\n    margin-bottom: 10px;\n}\n.checkbox > *[data-v-8ade67e0] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-8ade67e0] {\n    margin-right: 3px;\n}\n.padding-R[data-v-8ade67e0] {\n  padding-right: 7px;\n}\n.padding-L[data-v-8ade67e0] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-8ade67e0] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#pdf-view .page[data-v-8ade67e0] {\n    padding: 30px 40px 30px 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-8ade67e0] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-8ade67e0] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-8ade67e0] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-8ade67e0] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-8ade67e0] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-8ade67e0] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-8ade67e0], #pdf-view table tbody tr.total[data-v-8ade67e0] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-8ade67e0] {\n      color: #000;\n      font-size: 12px;\n}\n#pdf-view table tbody td[data-v-8ade67e0] {\n      padding: 2px 3px;\n}\n.report-block[data-v-8ade67e0] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.report-block table tbody tr.total[data-v-8ade67e0] {\n    border-top: 1px solid #333;\n    font-weight: 600;\n    font-size: 12.5px;\n}\n.report-block table .provId[data-v-8ade67e0], .report-block table .provName[data-v-8ade67e0], .report-block table .sectorId[data-v-8ade67e0], .report-block table .runId[data-v-8ade67e0], .report-block table .rsvpId[data-v-8ade67e0], .report-block table .accepted[data-v-8ade67e0], .report-block table .timeQueue[data-v-8ade67e0], .report-block table .service[data-v-8ade67e0], .report-block table .date[data-v-8ade67e0] {\n    text-align: center;\n}\n.slide-down-enter-active[data-v-8ade67e0], .slide-down-leave-active[data-v-8ade67e0] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-8ade67e0], .slide-down-leave-to[data-v-8ade67e0] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rsvp-report-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"instruction"},[_vm._v("Please select a start and end date:")]),_vm._v(" "),_c('div',{staticClass:"row expanded"},[_c('div',{staticClass:"small-6 column padding-R"},[_c('div',{staticClass:"date-input"},[_c('label',[_vm._v("Start Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}})],1)]),_vm._v(" "),_c('div',{staticClass:"small-6 column padding-L"},[_c('div',{staticClass:"date-input"},[_c('label',[_vm._v("End Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"list-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"download-type"},[_c('label',{class:{'pdf':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pdfChecked),expression:"pdfChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.pdfChecked)?_vm._i(_vm.pdfChecked,null)>-1:(_vm.pdfChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.pdfChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.pdfChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.pdfChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.pdfChecked=$$c}}}}),_vm._v("\n            PDF\n          ")]),_vm._v(" "),_c('label',{class:{'csv':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.csvChecked),expression:"csvChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.csvChecked)?_vm._i(_vm.csvChecked,null)>-1:(_vm.csvChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.csvChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.csvChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.csvChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.csvChecked=$$c}}}}),_vm._v("\n            CSV\n          ")])]),_vm._v(" "),_c('div',{staticClass:"instruction"},[_vm._v("Please select the reports to generate:")]),_vm._v(" "),_c('div',{staticClass:"row expanded reports"},[_c('div',{class:['small-12 column report', _vm.reportStatus.block, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.block),expression:"selectedReports.block"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.block)?_vm._i(_vm.selectedReports.block,null)>-1:(_vm.selectedReports.block)},on:{"change":function($event){var $$a=_vm.selectedReports.block,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "block", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "block", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "block", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('block')))])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.blockSort),expression:"blockSort"}],class:{'disabled':!_vm.selectedReports.block},attrs:{"disabled":!_vm.selectedReports.block},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.blockSort=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"rsvp"}},[_vm._v("By Rsvp")]),_vm._v(" "),_c('option',{attrs:{"value":"service"}},[_vm._v("By Service")]),_vm._v(" "),_c('option',{attrs:{"value":"sector"}},[_vm._v("By Sector")]),_vm._v(" "),_c('option',{attrs:{"value":"provider"}},[_vm._v("By Provider")])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.show),expression:"error.show"}],staticClass:"error"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.message),expression:"!!error.message"}]},[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.empty.length),expression:"error.empty.length"}]},[_c('li',[_vm._v("Empty Result:")]),_vm._v(" "),_vm._l((_vm.error.empty),function(empty,i){return _c('li',{key:i},[_vm._v("- "+_vm._s(empty))])})],2)])]),_vm._v(" "),_c('a',{class:['button cta success small block', {disabled: _vm.pdf.loading}],attrs:{"href":"javascript:;"},on:{"click":_vm.startProcess}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.pdf.loading),expression:"pdf.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pdf.loading),expression:"!pdf.loading"}]},[_vm._v("Generate and Download Report")])])],1),_vm._v(" "),_c('div',{class:[_vm.pdf.class],attrs:{"id":"pdf-view"}},[_vm._l((_vm.pdf.table.data),function(pageData,pageIndex){return _c('div',{key:pageIndex,class:['page', pageIndex]},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',_vm._l((_vm.pdf.table.label),function(label){return _c('th',{domProps:{"innerHTML":_vm._s(label)}})}),0)]),_vm._v(" "),_c('tbody',[_vm._l((pageData),function(data,index){return _c('tr',{key:index},_vm._l((data),function(value,i){return _c('td',{key:i,class:[i]},[_vm._v(_vm._s(value))])}),0)}),_vm._v(" "),(_vm.currentPage(pageIndex) == _vm.totalPage)?_c('tr',{staticClass:"total"},[_c('td',{attrs:{"colspan":"3"}}),_vm._v(" "),_c('td',[_vm._v("Total Run ("+_vm._s(_vm.pdf.table.total.run)+")")]),_vm._v(" "),_c('td',[_vm._v("Total RSVP ("+_vm._s(_vm.pdf.table.total.rsvp)+")")]),_vm._v(" "),_c('td',{attrs:{"colspan":"4"}})]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"page-count"},[_vm._v("page "+_vm._s(_vm.currentPage(pageIndex))+" of "+_vm._s(_vm.totalPage))])])}),_vm._v(" "),(Object.keys(_vm.pdf.table.data).length)?_c('div',{class:['page', ("page" + (Object.keys(_vm.pdf.table.data).length + 1))]},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',_vm._l((_vm.pdf.table.label),function(label){return _c('th',{domProps:{"innerHTML":_vm._s(label)}})}),0)]),_vm._v(" "),_c('tbody',[_vm._l((_vm.pdf.table.data[("page" + (Object.keys(_vm.pdf.table.data).length))]),function(data,index){return _c('tr',{key:index},_vm._l((data),function(value,i){return _c('td',{key:i,class:[i]},[_vm._v(_vm._s(value))])}),0)}),_vm._v(" "),_c('tr',{staticClass:"total"},[_c('td',{attrs:{"colspan":"3"}}),_vm._v(" "),_c('td',[_vm._v("Total Run ("+_vm._s(_vm.pdf.table.total.run)+")")]),_vm._v(" "),_c('td',[_vm._v("Total RSVP ("+_vm._s(_vm.pdf.table.total.rsvp)+")")]),_vm._v(" "),_c('td',{attrs:{"colspan":"4"}})])],2)]),_vm._v(" "),_c('div',{staticClass:"page-count"},[_vm._v("page "+_vm._s(Object.keys(_vm.pdf.table.data).length)+" of "+_vm._s(_vm.totalPage))])]):_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LGBReport_vue__ = __webpack_require__(530);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f42d1706_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LGBReport_vue__ = __webpack_require__(1509);
function injectStyle (ssrContext) {
  __webpack_require__(1507)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f42d1706"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LGBReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f42d1706_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LGBReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1508);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("41a650e2", content, true, {});

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.rsvp-report-box[data-v-f42d1706] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-f42d1706] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-f42d1706] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-f42d1706] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-f42d1706] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-f42d1706] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-f42d1706] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-f42d1706] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-f42d1706] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-f42d1706]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-f42d1706] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-f42d1706] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-f42d1706] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-f42d1706] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-f42d1706]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-f42d1706], .rsvp-report .reports .report.loading[data-v-f42d1706], .rsvp-report .reports .report.has-error[data-v-f42d1706], .rsvp-report .reports .report.success[data-v-f42d1706] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-f42d1706] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-f42d1706] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-f42d1706] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-f42d1706] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-f42d1706] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-f42d1706] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-f42d1706] {\n    cursor: pointer;\n}\n.filter input[data-v-f42d1706] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.download-type[data-v-f42d1706] {\n  float: right;\n  width: 150px;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-f42d1706] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-f42d1706] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-f42d1706] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-f42d1706] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-f42d1706] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-f42d1706] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-f42d1706] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-f42d1706] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-f42d1706]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-f42d1706] {\n      font-size: 13px;\n}\n.form-group[data-v-f42d1706] {\n  display: block;\n}\n.form-group .instruction[data-v-f42d1706] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-f42d1706] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox > *[data-v-f42d1706] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-f42d1706] {\n    margin-right: 3px;\n}\n.padding-R[data-v-f42d1706] {\n  padding-right: 7px;\n}\n.padding-L[data-v-f42d1706] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-f42d1706] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#pdf-view .page[data-v-f42d1706] {\n    padding: 30px 40px 30px 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-f42d1706] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-f42d1706] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-f42d1706] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-f42d1706] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-f42d1706] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-f42d1706] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-f42d1706], #pdf-view table tbody tr.total[data-v-f42d1706] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-f42d1706] {\n      color: #000;\n      font-size: 12px;\n}\n#pdf-view table tbody td[data-v-f42d1706] {\n      padding: 2px 3px;\n}\n.report-completed[data-v-f42d1706] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.report-completed table tbody td[data-v-f42d1706] {\n    text-align: center;\n}\n.report-completed table tbody tr.total[data-v-f42d1706] {\n    border-top: 1px solid #333;\n    font-weight: 600;\n    font-size: 12.5px;\n}\n.brand-select[data-v-f42d1706] {\n  margin: 0 0 10px 28px;\n  border: 1px solid #999;\n  width: calc(100% - 43px);\n  height: 120px;\n  overflow: auto;\n}\n.brand-select.disabled[data-v-f42d1706] {\n    opacity: .5;\n}\n.brand-select label[data-v-f42d1706] {\n    border-bottom: 1px solid #ddd;\n    padding: 4px 10px;\n    font-size: 14px;\n    background: #fff;\n    display: block;\n    cursor: pointer;\n}\n.brand-select input[data-v-f42d1706] {\n    width: auto;\n    display: inline-block;\n    margin: 0 5px 5px 0;\n    vertical-align: -1px;\n}\n.slide-down-enter-active[data-v-f42d1706], .slide-down-leave-active[data-v-f42d1706] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-f42d1706], .slide-down-leave-to[data-v-f42d1706] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Reports/LGBReport.vue"],"names":[],"mappings":";AACA;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,qBAAqB;CACtB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,eAAe;CACpB;AACD;MACM,cAAc;MACd,aAAa;MACb,cAAc;MACd,yBAAyB;MACzB,sBAAsB;MACtB,iBAAiB;MACjB,sBAAsB;MACtB,gBAAgB;MAChB,YAAY;MACZ,wDAAwD;MACxD,6BAA6B;MAC7B,+BAA+B;CACpC;AACD;QACQ,0BAA0B;CACjC;AACD;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;CACtB;AACD;MACM,mBAAmB;MACnB,WAAW;CAChB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,+BAA+B;CACtC;AACD;UACU,YAAY;CACrB;AACD;QACQ,kBAAkB;QAClB,oBAAoB;QACpB,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,iCAAiC;QACjC,yBAAyB;CAChC;AACD;UACU,oBAAoB;UACpB,mBAAmB;CAC5B;AACD;UACU,oBAAoB;CAC7B;AACD;QACQ,WAAW;QACX,+CAA+C;gBACvC,uCAAuC;CACtD;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,cAAc;IACd,YAAY;CACf;AACD;IACI,gBAAgB;CACnB;AACD;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;CAC1B;AACD;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,oBAAoB;CACrB;AACD;IACI,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;CAC1B;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,gBAAgB;MAChB,cAAc;MACd,YAAY;MACZ,qBAAqB;CAC1B;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;CACtB;AACD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;IACI,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,iBAAiB;CACpB;AACD;MACM,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;CACxB;AACD;MACM,gBAAgB;CACrB;AACD;EACE,eAAe;CAChB;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,YAAY;CACf;AACD;IACI,kBAAkB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,aAAa;EACb,eAAe;EACf,iBAAiB;CAClB;AACD;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,aAAa;CAChB;AACD;MACM,mBAAmB;MACnB,aAAa;MACb,YAAY;MACZ,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;CACxB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;CACf;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,iBAAiB;CACtB;AACD;QACQ,8BAA8B;CACrC;AACD;MACM,iBAAiB;CACtB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;MACM,iBAAiB;CACtB;AACD;EACE,yBAAyB;EACzB,yBAAyB;CAC1B;AACD;IACI,mBAAmB;CACtB;AACD;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;CACrB;AACD;EACE,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,eAAe;CAChB;AACD;IACI,YAAY;CACf;AACD;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;CACnB;AACD;IACI,YAAY;IACZ,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;CACxB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ","file":"LGBReport.vue","sourcesContent":["\n.rsvp-report-box[data-v-f42d1706] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-f42d1706] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-f42d1706] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-f42d1706] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-f42d1706] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-f42d1706] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-f42d1706] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-f42d1706] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-f42d1706] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-f42d1706]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-f42d1706] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-f42d1706] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-f42d1706] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-f42d1706] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-f42d1706]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-f42d1706], .rsvp-report .reports .report.loading[data-v-f42d1706], .rsvp-report .reports .report.has-error[data-v-f42d1706], .rsvp-report .reports .report.success[data-v-f42d1706] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-f42d1706] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-f42d1706] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-f42d1706] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-f42d1706] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-f42d1706] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-f42d1706] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-f42d1706] {\n    cursor: pointer;\n}\n.filter input[data-v-f42d1706] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.download-type[data-v-f42d1706] {\n  float: right;\n  width: 150px;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-f42d1706] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-f42d1706] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-f42d1706] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-f42d1706] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-f42d1706] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-f42d1706] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-f42d1706] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-f42d1706] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-f42d1706]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-f42d1706] {\n      font-size: 13px;\n}\n.form-group[data-v-f42d1706] {\n  display: block;\n}\n.form-group .instruction[data-v-f42d1706] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-f42d1706] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox > *[data-v-f42d1706] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-f42d1706] {\n    margin-right: 3px;\n}\n.padding-R[data-v-f42d1706] {\n  padding-right: 7px;\n}\n.padding-L[data-v-f42d1706] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-f42d1706] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#pdf-view .page[data-v-f42d1706] {\n    padding: 30px 40px 30px 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-f42d1706] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-f42d1706] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-f42d1706] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-f42d1706] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-f42d1706] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-f42d1706] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-f42d1706], #pdf-view table tbody tr.total[data-v-f42d1706] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-f42d1706] {\n      color: #000;\n      font-size: 12px;\n}\n#pdf-view table tbody td[data-v-f42d1706] {\n      padding: 2px 3px;\n}\n.report-completed[data-v-f42d1706] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.report-completed table tbody td[data-v-f42d1706] {\n    text-align: center;\n}\n.report-completed table tbody tr.total[data-v-f42d1706] {\n    border-top: 1px solid #333;\n    font-weight: 600;\n    font-size: 12.5px;\n}\n.brand-select[data-v-f42d1706] {\n  margin: 0 0 10px 28px;\n  border: 1px solid #999;\n  width: calc(100% - 43px);\n  height: 120px;\n  overflow: auto;\n}\n.brand-select.disabled[data-v-f42d1706] {\n    opacity: .5;\n}\n.brand-select label[data-v-f42d1706] {\n    border-bottom: 1px solid #ddd;\n    padding: 4px 10px;\n    font-size: 14px;\n    background: #fff;\n    display: block;\n    cursor: pointer;\n}\n.brand-select input[data-v-f42d1706] {\n    width: auto;\n    display: inline-block;\n    margin: 0 5px 5px 0;\n    vertical-align: -1px;\n}\n.slide-down-enter-active[data-v-f42d1706], .slide-down-leave-active[data-v-f42d1706] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-f42d1706], .slide-down-leave-to[data-v-f42d1706] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rsvp-report-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"instruction"},[_vm._v("Please select a start and end date:")]),_vm._v(" "),_c('div',{staticClass:"row expanded"},[_c('div',{staticClass:"small-6 column padding-R"},[_c('div',{staticClass:"date-input"},[_c('label',[_vm._v("Start Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}})],1)]),_vm._v(" "),_c('div',{staticClass:"small-6 column padding-L"},[_c('div',{staticClass:"date-input end-date"},[_c('label',[_vm._v("End Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"list-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"download-type"},[_c('label',{class:{'pdf':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pdfChecked),expression:"pdfChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.pdfChecked)?_vm._i(_vm.pdfChecked,null)>-1:(_vm.pdfChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.pdfChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.pdfChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.pdfChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.pdfChecked=$$c}}}}),_vm._v("\n            PDF\n          ")]),_vm._v(" "),_c('label',{class:{'csv':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.csvChecked),expression:"csvChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.csvChecked)?_vm._i(_vm.csvChecked,null)>-1:(_vm.csvChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.csvChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.csvChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.csvChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.csvChecked=$$c}}}}),_vm._v("\n            CSV\n          ")])]),_vm._v(" "),_c('div',{staticClass:"instruction"},[_vm._v("Please select the reports to generate:")]),_vm._v(" "),_c('div',{staticClass:"row expanded reports"},[_c('div',{class:['small-12 column report', _vm.reportStatus.completedRsvp, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.completedRsvp),expression:"selectedReports.completedRsvp"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.completedRsvp)?_vm._i(_vm.selectedReports.completedRsvp,null)>-1:(_vm.selectedReports.completedRsvp)},on:{"change":function($event){var $$a=_vm.selectedReports.completedRsvp,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "completedRsvp", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "completedRsvp", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "completedRsvp", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('completedRsvp')))])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.completeRsvpAirport),expression:"completeRsvpAirport"}],class:{'disabled':!_vm.selectedReports.completedRsvp},attrs:{"disabled":!_vm.selectedReports.completedRsvp},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.completeRsvpAirport=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Please select airport")]),_vm._v(" "),_vm._l((_vm.airports),function(airport){return _c('option',{domProps:{"value":airport.geofenceId}},[_vm._v("\n                "+_vm._s(airport.airportCode)+" - "+_vm._s(airport.description)+"\n              ")])})],2),_vm._v(" "),_c('div',{class:['brand-select', {disabled:!_vm.selectedReports.completedRsvp}]},_vm._l((_vm.brands.list),function(brand){return _c('label',{key:brand.id},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.completeRsvpBrands),expression:"completeRsvpBrands"}],attrs:{"type":"checkbox","name":"brand"},domProps:{"value":brand.id,"checked":Array.isArray(_vm.completeRsvpBrands)?_vm._i(_vm.completeRsvpBrands,brand.id)>-1:(_vm.completeRsvpBrands)},on:{"change":function($event){var $$a=_vm.completeRsvpBrands,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=brand.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.completeRsvpBrands=$$a.concat([$$v]))}else{$$i>-1&&(_vm.completeRsvpBrands=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.completeRsvpBrands=$$c}}}}),_vm._v("\n                "+_vm._s(brand.name)+"\n              ")])}),0)]),_vm._v(" "),_c('div',{class:['small-12 column report', _vm.reportStatus.eventLogs, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.eventLogs),expression:"selectedReports.eventLogs"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.eventLogs)?_vm._i(_vm.selectedReports.eventLogs,null)>-1:(_vm.selectedReports.eventLogs)},on:{"change":function($event){var $$a=_vm.selectedReports.eventLogs,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "eventLogs", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "eventLogs", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "eventLogs", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('eventLogs')))])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.eventLogsAirport),expression:"eventLogsAirport"}],class:{'disabled':!_vm.selectedReports.eventLogs || _vm.geoTracking.loading},attrs:{"disabled":!_vm.selectedReports.eventLogs || _vm.geoTracking.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.eventLogsAirport=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Please select service area")]),_vm._v(" "),_vm._l((_vm.geoTracking.list),function(servicearea){return _c('option',{domProps:{"value":servicearea.id}},[_vm._v("\n                "+_vm._s(servicearea.name)+"\n              ")])})],2)])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.show),expression:"error.show"}],staticClass:"error"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.message),expression:"!!error.message"}]},[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.empty.length),expression:"error.empty.length"}]},[_c('li',[_vm._v("Empty Result:")]),_vm._v(" "),_vm._l((_vm.error.empty),function(empty){return _c('li',[_vm._v("- "+_vm._s(empty))])})],2)])]),_vm._v(" "),_c('a',{class:{ 'button cta success small block': true, disabled: _vm.pdf.loading },attrs:{"href":"javascript:;"},on:{"click":_vm.startProcess}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.pdf.loading),expression:"pdf.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pdf.loading),expression:"!pdf.loading"}]},[_vm._v("Generate and Download Report")])])],1),_vm._v(" "),_c('div',{class:[_vm.pdf.class],attrs:{"id":"pdf-view"}},[_vm._l((_vm.pdf.table.data),function(pageData,pageIndex){return _c('div',{key:pageIndex,class:['page', pageIndex]},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',_vm._l((_vm.pdf.table.label),function(label){return _c('th',{domProps:{"innerHTML":_vm._s(label)}})}),0)]),_vm._v(" "),_c('tbody',[_vm._l((pageData),function(data,index){return _c('tr',{key:index},_vm._l((data),function(value,i){return _c('td',{key:i,class:[i]},[_vm._v(_vm._s(value))])}),0)}),_vm._v(" "),(_vm.isPayout && _vm.currentPage(pageIndex) == _vm.totalPage)?_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"driverCount"},[_vm._v(_vm._s(_vm.pdf.table.total.drivers))]),_vm._v(" "),_c('td',{staticClass:"rsvpCount"},[_vm._v(_vm._s(_vm.pdf.table.total.rsvp))]),_vm._v(" "),_c('td',{staticClass:"fare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fare))]),_vm._v(" "),_c('td',{staticClass:"travelInsurance"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.travelInsurance))]),_vm._v(" "),_c('td',{staticClass:"airportFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.airportFee))]),_vm._v(" "),_c('td',{staticClass:"totalFare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fareSum))]),_vm._v(" "),_c('td',{staticClass:"avgFare"},[_vm._v(_vm._s(_vm.pdf.table.total.avgFare))]),_vm._v(" "),_c('td',{staticClass:"payment"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.payment))]),_vm._v(" "),_c('td',{staticClass:"paymentPercent"},[_vm._v(_vm._s(_vm.pdf.table.total.paymentPercent)+"%")]),_vm._v(" "),_c('td',{staticClass:"pickupFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.pickupFee))]),_vm._v(" "),_c('td',{staticClass:"gasFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.gasFee))]),_vm._v(" "),_c('td',{staticClass:"tips"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.tips))]),_vm._v(" "),_c('td',{staticClass:"bonus"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.bonus))]),_vm._v(" "),_c('td',{staticClass:"cancelFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.cancelFee))]),_vm._v(" "),_c('td',{staticClass:"driverPayment"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.extraFee))]),_vm._v(" "),_c('td',{staticClass:"driverPercent"},[_vm._v(_vm._s(_vm.pdf.table.total.percent)+"%")])]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"page-count"},[_vm._v("page "+_vm._s(_vm.currentPage(pageIndex))+" of "+_vm._s(_vm.totalPage))])])}),_vm._v(" "),(Object.keys(_vm.pdf.table.data).length)?_c('div',{class:['page', ("page" + (Object.keys(_vm.pdf.table.data).length + 1))]},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',_vm._l((_vm.pdf.table.label),function(label){return _c('th',{domProps:{"innerHTML":_vm._s(label)}})}),0)]),_vm._v(" "),_c('tbody',[_vm._l((_vm.pdf.table.data[("page" + (Object.keys(_vm.pdf.table.data).length))]),function(data,index){return _c('tr',{key:index},_vm._l((data),function(value,i){return _c('td',{key:i,class:[i]},[_vm._v(_vm._s(value))])}),0)}),_vm._v(" "),(_vm.isPayout)?_c('tr',{staticClass:"total"},[_c('td',[_vm._v("Total ("+_vm._s(_vm.pdf.table.total.record)+")")]),_vm._v(" "),_c('td',{staticClass:"driverCount"},[_vm._v(_vm._s(_vm.pdf.table.total.drivers))]),_vm._v(" "),_c('td',{staticClass:"rsvpCount"},[_vm._v(_vm._s(_vm.pdf.table.total.rsvp))]),_vm._v(" "),_c('td',{staticClass:"fare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fare))]),_vm._v(" "),_c('td',{staticClass:"travelInsurance"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.travelInsurance))]),_vm._v(" "),_c('td',{staticClass:"airportFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.airportFee))]),_vm._v(" "),_c('td',{staticClass:"totalFare"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.fareSum))]),_vm._v(" "),_c('td',{staticClass:"avgFare"},[_vm._v(_vm._s(_vm.pdf.table.total.avgFare))]),_vm._v(" "),_c('td',{staticClass:"payment"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.payment))]),_vm._v(" "),_c('td',{staticClass:"paymentPercent"},[_vm._v(_vm._s(_vm.pdf.table.total.paymentPercent)+"%")]),_vm._v(" "),_c('td',{staticClass:"pickupFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.pickupFee))]),_vm._v(" "),_c('td',{staticClass:"gasFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.gasFee))]),_vm._v(" "),_c('td',{staticClass:"tips"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.tips))]),_vm._v(" "),_c('td',{staticClass:"bonus"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.bonus))]),_vm._v(" "),_c('td',{staticClass:"cancelFee"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.cancelFee))]),_vm._v(" "),_c('td',{staticClass:"driverPayment"},[_vm._v("$"+_vm._s(_vm.pdf.table.total.extraFee))]),_vm._v(" "),_c('td',{staticClass:"driverPercent"},[_vm._v(_vm._s(_vm.pdf.table.total.percent)+"%")])]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"page-count"},[_vm._v("page "+_vm._s(Object.keys(_vm.pdf.table.data).length)+" of "+_vm._s(_vm.totalPage))])]):_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActiveDriverReport_vue__ = __webpack_require__(531);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290ed128_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActiveDriverReport_vue__ = __webpack_require__(1513);
function injectStyle (ssrContext) {
  __webpack_require__(1511)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-290ed128"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActiveDriverReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290ed128_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActiveDriverReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1512);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4b114b4b", content, true, {});

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.rsvp-report-box[data-v-290ed128] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.driver-type[data-v-290ed128] {\n  padding: 5px;\n}\n.rsvp-report[data-v-290ed128] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-290ed128] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-290ed128] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-290ed128] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-290ed128] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-290ed128] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-290ed128] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-290ed128] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-290ed128]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-290ed128] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-290ed128] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-290ed128] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-290ed128] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-290ed128]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-290ed128], .rsvp-report .reports .report.loading[data-v-290ed128], .rsvp-report .reports .report.has-error[data-v-290ed128], .rsvp-report .reports .report.success[data-v-290ed128] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-290ed128] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-290ed128] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-290ed128] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-290ed128] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-290ed128] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-290ed128] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-290ed128] {\n    cursor: pointer;\n}\n.filter input[data-v-290ed128] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.list-box[data-v-290ed128] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-290ed128] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-290ed128] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-290ed128]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-290ed128] {\n      font-size: 13px;\n}\n.form-group[data-v-290ed128] {\n  display: block;\n}\n.form-group .instruction[data-v-290ed128] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-290ed128] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox.sub[data-v-290ed128] {\n    padding-left: 30px;\n    margin-bottom: 10px;\n}\n.checkbox > *[data-v-290ed128] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-290ed128] {\n    margin-right: 3px;\n}\n.padding-R[data-v-290ed128] {\n  padding-right: 7px;\n}\n.padding-L[data-v-290ed128] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-290ed128] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#pdf-view .page[data-v-290ed128] {\n    padding: 30px 40px 30px 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-290ed128] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-290ed128] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-290ed128] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-290ed128] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-290ed128] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-290ed128] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-290ed128], #pdf-view table tbody tr.total[data-v-290ed128] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-290ed128] {\n      color: #000;\n      font-size: 12px;\n}\n#pdf-view table tbody td[data-v-290ed128] {\n      padding: 2px 3px;\n}\n.report-active-drivers[data-v-290ed128] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.report-active-drivers table tbody tr.total[data-v-290ed128] {\n    border-top: 1px solid #333;\n    font-weight: 600;\n    font-size: 12.5px;\n}\n.report-active-drivers table .provId[data-v-290ed128], .report-active-drivers table .provName[data-v-290ed128], .report-active-drivers table .sectorId[data-v-290ed128], .report-active-drivers table .runId[data-v-290ed128], .report-active-drivers table .rsvpId[data-v-290ed128], .report-active-drivers table .accepted[data-v-290ed128], .report-active-drivers table .timeQueue[data-v-290ed128], .report-active-drivers table .service[data-v-290ed128], .report-active-drivers table .date[data-v-290ed128] {\n    text-align: center;\n}\n.slide-down-enter-active[data-v-290ed128], .slide-down-leave-active[data-v-290ed128] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-290ed128], .slide-down-leave-to[data-v-290ed128] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Reports/ActiveDriverReport.vue"],"names":[],"mappings":";AACA;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,aAAa;CACd;AACD;EACE,mBAAmB;EACnB,qBAAqB;CACtB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,eAAe;CACpB;AACD;MACM,cAAc;MACd,aAAa;MACb,cAAc;MACd,yBAAyB;MACzB,sBAAsB;MACtB,iBAAiB;MACjB,sBAAsB;MACtB,gBAAgB;MAChB,YAAY;MACZ,wDAAwD;MACxD,6BAA6B;MAC7B,+BAA+B;CACpC;AACD;QACQ,0BAA0B;CACjC;AACD;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;CACtB;AACD;MACM,mBAAmB;MACnB,WAAW;CAChB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,+BAA+B;CACtC;AACD;UACU,YAAY;CACrB;AACD;QACQ,kBAAkB;QAClB,oBAAoB;QACpB,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,iCAAiC;QACjC,yBAAyB;CAChC;AACD;UACU,oBAAoB;UACpB,mBAAmB;CAC5B;AACD;UACU,oBAAoB;CAC7B;AACD;QACQ,WAAW;QACX,+CAA+C;gBACvC,uCAAuC;CACtD;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,cAAc;IACd,YAAY;CACf;AACD;IACI,gBAAgB;CACnB;AACD;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;CAC1B;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;CACtB;AACD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;IACI,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,iBAAiB;CACpB;AACD;MACM,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;CACxB;AACD;MACM,gBAAgB;CACrB;AACD;EACE,eAAe;CAChB;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;IACI,mBAAmB;IACnB,oBAAoB;CACvB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,YAAY;CACf;AACD;IACI,kBAAkB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,aAAa;EACb,eAAe;EACf,iBAAiB;CAClB;AACD;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,aAAa;CAChB;AACD;MACM,mBAAmB;MACnB,aAAa;MACb,YAAY;MACZ,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;CACxB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;CACf;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,iBAAiB;CACtB;AACD;QACQ,8BAA8B;CACrC;AACD;MACM,iBAAiB;CACtB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;MACM,iBAAiB;CACtB;AACD;EACE,yBAAyB;EACzB,yBAAyB;CAC1B;AACD;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;CACrB;AACD;IACI,mBAAmB;CACtB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ","file":"ActiveDriverReport.vue","sourcesContent":["\n.rsvp-report-box[data-v-290ed128] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.driver-type[data-v-290ed128] {\n  padding: 5px;\n}\n.rsvp-report[data-v-290ed128] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-290ed128] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-290ed128] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-290ed128] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-290ed128] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-290ed128] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-290ed128] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-290ed128] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-290ed128]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-290ed128] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-290ed128] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-290ed128] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-290ed128] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-290ed128]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-290ed128], .rsvp-report .reports .report.loading[data-v-290ed128], .rsvp-report .reports .report.has-error[data-v-290ed128], .rsvp-report .reports .report.success[data-v-290ed128] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-290ed128] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-290ed128] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-290ed128] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-290ed128] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-290ed128] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-290ed128] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-290ed128] {\n    cursor: pointer;\n}\n.filter input[data-v-290ed128] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.list-box[data-v-290ed128] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-290ed128] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-290ed128] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-290ed128]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-290ed128] {\n      font-size: 13px;\n}\n.form-group[data-v-290ed128] {\n  display: block;\n}\n.form-group .instruction[data-v-290ed128] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-290ed128] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox.sub[data-v-290ed128] {\n    padding-left: 30px;\n    margin-bottom: 10px;\n}\n.checkbox > *[data-v-290ed128] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-290ed128] {\n    margin-right: 3px;\n}\n.padding-R[data-v-290ed128] {\n  padding-right: 7px;\n}\n.padding-L[data-v-290ed128] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-290ed128] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#pdf-view .page[data-v-290ed128] {\n    padding: 30px 40px 30px 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-290ed128] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-290ed128] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-290ed128] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-290ed128] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-290ed128] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-290ed128] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-290ed128], #pdf-view table tbody tr.total[data-v-290ed128] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-290ed128] {\n      color: #000;\n      font-size: 12px;\n}\n#pdf-view table tbody td[data-v-290ed128] {\n      padding: 2px 3px;\n}\n.report-active-drivers[data-v-290ed128] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.report-active-drivers table tbody tr.total[data-v-290ed128] {\n    border-top: 1px solid #333;\n    font-weight: 600;\n    font-size: 12.5px;\n}\n.report-active-drivers table .provId[data-v-290ed128], .report-active-drivers table .provName[data-v-290ed128], .report-active-drivers table .sectorId[data-v-290ed128], .report-active-drivers table .runId[data-v-290ed128], .report-active-drivers table .rsvpId[data-v-290ed128], .report-active-drivers table .accepted[data-v-290ed128], .report-active-drivers table .timeQueue[data-v-290ed128], .report-active-drivers table .service[data-v-290ed128], .report-active-drivers table .date[data-v-290ed128] {\n    text-align: center;\n}\n.slide-down-enter-active[data-v-290ed128], .slide-down-leave-active[data-v-290ed128] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-290ed128], .slide-down-leave-to[data-v-290ed128] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rsvp-report-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"instruction"},[_vm._v("Please select a start and end date:")]),_vm._v(" "),_c('div',{staticClass:"row expanded"},[_c('div',{staticClass:"small-6 column padding-R"},[_c('div',{staticClass:"date-input"},[_c('label',[_vm._v("Start Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}})],1)]),_vm._v(" "),_c('div',{staticClass:"small-6 column padding-L"},[_c('div',{staticClass:"date-input"},[_c('label',[_vm._v("End Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"instruction"},[_vm._v("License Type:")]),_vm._v(" "),_c('div',{staticClass:"row expanded"},[_c('div',{staticClass:"small-12 column"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.driverType),expression:"driverType"}],staticClass:"driver-type",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.driverType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"tnc"}},[_vm._v("TNC")]),_vm._v(" "),_c('option',{attrs:{"value":"tcp"}},[_vm._v("TCP")])])])])])]),_vm._v(" "),_c('div',{staticClass:"list-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"instruction"},[_vm._v("Please select the reports to generate:")]),_vm._v(" "),_c('div',{staticClass:"row expanded reports"},[_c('div',{class:['small-12 column report', _vm.reportStatus.activeDrivers, {'processing':_vm.csv.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.activeDrivers),expression:"selectedReports.activeDrivers"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.activeDrivers)?_vm._i(_vm.selectedReports.activeDrivers,null)>-1:(_vm.selectedReports.activeDrivers)},on:{"change":function($event){var $$a=_vm.selectedReports.activeDrivers,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "activeDrivers", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "activeDrivers", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "activeDrivers", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('activeDrivers')))])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.show),expression:"error.show"}],staticClass:"error"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.message),expression:"!!error.message"}]},[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.empty.length),expression:"error.empty.length"}]},[_c('li',[_vm._v("Empty Result:")]),_vm._v(" "),_vm._l((_vm.error.empty),function(empty,i){return _c('li',{key:i},[_vm._v("- "+_vm._s(empty))])})],2)])]),_vm._v(" "),_c('a',{class:['button cta success small block', {disabled: _vm.csv.loading}],attrs:{"href":"javascript:;"},on:{"click":_vm.startProcess}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.csv.loading),expression:"csv.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.csv.loading),expression:"!csv.loading"}]},[_vm._v("Generate and Download Report")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverCount_vue__ = __webpack_require__(532);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3100fa6e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverCount_vue__ = __webpack_require__(1517);
function injectStyle (ssrContext) {
  __webpack_require__(1515)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3100fa6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverCount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3100fa6e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverCount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1516);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("27770d04", content, true, {});

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.rsvp-report-box[data-v-3100fa6e] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-3100fa6e] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-3100fa6e] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-3100fa6e] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-3100fa6e] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-3100fa6e] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-3100fa6e] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-3100fa6e] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-3100fa6e] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-3100fa6e]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-3100fa6e] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-3100fa6e] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-3100fa6e] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-3100fa6e] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-3100fa6e]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-3100fa6e], .rsvp-report .reports .report.loading[data-v-3100fa6e], .rsvp-report .reports .report.has-error[data-v-3100fa6e], .rsvp-report .reports .report.success[data-v-3100fa6e] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-3100fa6e] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-3100fa6e] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-3100fa6e] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-3100fa6e] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-3100fa6e] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-3100fa6e] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-3100fa6e] {\n    cursor: pointer;\n}\n.filter input[data-v-3100fa6e] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.download-type[data-v-3100fa6e] {\n  float: right;\n  width: 150px;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-3100fa6e] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-3100fa6e] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-3100fa6e] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-3100fa6e] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-3100fa6e] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-3100fa6e] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-3100fa6e] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-3100fa6e] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-3100fa6e]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-3100fa6e] {\n      font-size: 13px;\n}\n.form-group[data-v-3100fa6e] {\n  display: block;\n}\n.form-group .instruction[data-v-3100fa6e] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-3100fa6e] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox.sub[data-v-3100fa6e] {\n    padding-left: 30px;\n    margin-bottom: 10px;\n}\n.checkbox > *[data-v-3100fa6e] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-3100fa6e] {\n    margin-right: 3px;\n}\n.padding-R[data-v-3100fa6e] {\n  padding-right: 7px;\n}\n.padding-L[data-v-3100fa6e] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-3100fa6e] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#pdf-view .page[data-v-3100fa6e] {\n    padding: 30px 40px 30px 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-3100fa6e] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-3100fa6e] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-3100fa6e] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-3100fa6e] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-3100fa6e] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-3100fa6e] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-3100fa6e], #pdf-view table tbody tr.total[data-v-3100fa6e] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-3100fa6e] {\n      color: #000;\n      font-size: 12px;\n}\n#pdf-view table tbody td[data-v-3100fa6e] {\n      padding: 2px 3px;\n}\n.report-drivercount[data-v-3100fa6e] {\n  width: 793px !important;\n  height: 1122px !important;\n}\n.report-drivercount table thead th[data-v-3100fa6e] {\n    text-align: left;\n}\n.slide-down-enter-active[data-v-3100fa6e], .slide-down-leave-active[data-v-3100fa6e] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-3100fa6e], .slide-down-leave-to[data-v-3100fa6e] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Reports/DriverCount.vue"],"names":[],"mappings":";AACA;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,qBAAqB;CACtB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,eAAe;CACpB;AACD;MACM,cAAc;MACd,aAAa;MACb,cAAc;MACd,yBAAyB;MACzB,sBAAsB;MACtB,iBAAiB;MACjB,sBAAsB;MACtB,gBAAgB;MAChB,YAAY;MACZ,wDAAwD;MACxD,6BAA6B;MAC7B,+BAA+B;CACpC;AACD;QACQ,0BAA0B;CACjC;AACD;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;CACtB;AACD;MACM,mBAAmB;MACnB,WAAW;CAChB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,+BAA+B;CACtC;AACD;UACU,YAAY;CACrB;AACD;QACQ,kBAAkB;QAClB,oBAAoB;QACpB,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,iCAAiC;QACjC,yBAAyB;CAChC;AACD;UACU,oBAAoB;UACpB,mBAAmB;CAC5B;AACD;UACU,oBAAoB;CAC7B;AACD;QACQ,WAAW;QACX,+CAA+C;gBACvC,uCAAuC;CACtD;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,cAAc;IACd,YAAY;CACf;AACD;IACI,gBAAgB;CACnB;AACD;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;CAC1B;AACD;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,oBAAoB;CACrB;AACD;IACI,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;CAC1B;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,gBAAgB;MAChB,cAAc;MACd,YAAY;MACZ,qBAAqB;CAC1B;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;CACtB;AACD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;IACI,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,iBAAiB;CACpB;AACD;MACM,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;CACxB;AACD;MACM,gBAAgB;CACrB;AACD;EACE,eAAe;CAChB;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;IACI,mBAAmB;IACnB,oBAAoB;CACvB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,YAAY;CACf;AACD;IACI,kBAAkB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,aAAa;EACb,eAAe;EACf,iBAAiB;CAClB;AACD;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,aAAa;CAChB;AACD;MACM,mBAAmB;MACnB,aAAa;MACb,YAAY;MACZ,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;CACxB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;CACf;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,iBAAiB;CACtB;AACD;QACQ,8BAA8B;CACrC;AACD;MACM,iBAAiB;CACtB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;MACM,iBAAiB;CACtB;AACD;EACE,wBAAwB;EACxB,0BAA0B;CAC3B;AACD;IACI,iBAAiB;CACpB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ","file":"DriverCount.vue","sourcesContent":["\n.rsvp-report-box[data-v-3100fa6e] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-3100fa6e] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-3100fa6e] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-3100fa6e] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-3100fa6e] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-3100fa6e] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-3100fa6e] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-3100fa6e] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-3100fa6e] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-3100fa6e]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-3100fa6e] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-3100fa6e] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-3100fa6e] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-3100fa6e] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-3100fa6e]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-3100fa6e], .rsvp-report .reports .report.loading[data-v-3100fa6e], .rsvp-report .reports .report.has-error[data-v-3100fa6e], .rsvp-report .reports .report.success[data-v-3100fa6e] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-3100fa6e] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-3100fa6e] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-3100fa6e] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-3100fa6e] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-3100fa6e] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-3100fa6e] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-3100fa6e] {\n    cursor: pointer;\n}\n.filter input[data-v-3100fa6e] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.download-type[data-v-3100fa6e] {\n  float: right;\n  width: 150px;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-3100fa6e] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-3100fa6e] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-3100fa6e] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-3100fa6e] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-3100fa6e] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-3100fa6e] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-3100fa6e] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-3100fa6e] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-3100fa6e]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-3100fa6e] {\n      font-size: 13px;\n}\n.form-group[data-v-3100fa6e] {\n  display: block;\n}\n.form-group .instruction[data-v-3100fa6e] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-3100fa6e] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox.sub[data-v-3100fa6e] {\n    padding-left: 30px;\n    margin-bottom: 10px;\n}\n.checkbox > *[data-v-3100fa6e] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-3100fa6e] {\n    margin-right: 3px;\n}\n.padding-R[data-v-3100fa6e] {\n  padding-right: 7px;\n}\n.padding-L[data-v-3100fa6e] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-3100fa6e] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#pdf-view .page[data-v-3100fa6e] {\n    padding: 30px 40px 30px 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-3100fa6e] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-3100fa6e] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-3100fa6e] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-3100fa6e] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-3100fa6e] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-3100fa6e] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-3100fa6e], #pdf-view table tbody tr.total[data-v-3100fa6e] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-3100fa6e] {\n      color: #000;\n      font-size: 12px;\n}\n#pdf-view table tbody td[data-v-3100fa6e] {\n      padding: 2px 3px;\n}\n.report-drivercount[data-v-3100fa6e] {\n  width: 793px !important;\n  height: 1122px !important;\n}\n.report-drivercount table thead th[data-v-3100fa6e] {\n    text-align: left;\n}\n.slide-down-enter-active[data-v-3100fa6e], .slide-down-leave-active[data-v-3100fa6e] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-3100fa6e], .slide-down-leave-to[data-v-3100fa6e] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rsvp-report-box"},[_c('div',{staticClass:"list-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"download-type"},[_c('label',{class:{'pdf':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pdfChecked),expression:"pdfChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.pdfChecked)?_vm._i(_vm.pdfChecked,null)>-1:(_vm.pdfChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.pdfChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.pdfChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.pdfChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.pdfChecked=$$c}}}}),_vm._v("\n            PDF\n          ")]),_vm._v(" "),_c('label',{class:{'csv':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.csvChecked),expression:"csvChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.csvChecked)?_vm._i(_vm.csvChecked,null)>-1:(_vm.csvChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.csvChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.csvChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.csvChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.csvChecked=$$c}}}}),_vm._v("\n            CSV\n          ")])]),_vm._v(" "),_c('div',{staticClass:"instruction"},[_vm._v("Please select the reports to generate:")]),_vm._v(" "),_c('div',{staticClass:"row expanded reports"},[_c('div',{class:['small-12 column report', _vm.reportStatus.driverCount, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.driverCount),expression:"selectedReports.driverCount"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.driverCount)?_vm._i(_vm.selectedReports.driverCount,null)>-1:(_vm.selectedReports.driverCount)},on:{"change":function($event){var $$a=_vm.selectedReports.driverCount,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "driverCount", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "driverCount", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "driverCount", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('driverCount')))])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.show),expression:"error.show"}],staticClass:"error"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.message),expression:"!!error.message"}]},[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.empty.length),expression:"error.empty.length"}]},[_c('li',[_vm._v("Empty Result:")]),_vm._v(" "),_vm._l((_vm.error.empty),function(empty,i){return _c('li',{key:i},[_vm._v("- "+_vm._s(empty))])})],2)])]),_vm._v(" "),_c('a',{class:['button cta success small block', {disabled: _vm.pdf.loading}],attrs:{"href":"javascript:;"},on:{"click":_vm.startProcess}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.pdf.loading),expression:"pdf.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pdf.loading),expression:"!pdf.loading"}]},[_vm._v("Generate and Download Report")])])],1),_vm._v(" "),_c('div',{class:[_vm.pdf.class],attrs:{"id":"pdf-view"}},_vm._l((_vm.pdf.table.data),function(pageData,pageIndex){return _c('div',{key:pageIndex,class:['page', pageIndex]},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',_vm._l((_vm.pdf.table.label),function(label){return _c('th',{domProps:{"innerHTML":_vm._s(label)}})}),0)]),_vm._v(" "),_c('tbody',_vm._l((pageData),function(data,index){return _c('tr',{key:index},_vm._l((data),function(value,i){return _c('td',{key:i,class:[i]},[_vm._v(_vm._s(value))])}),0)}),0)]),_vm._v(" "),_c('div',{staticClass:"page-count"},[_vm._v("page "+_vm._s(_vm.currentPage(pageIndex))+" of "+_vm._s(_vm.totalPage))])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LyftReport_vue__ = __webpack_require__(533);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_490eebd2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LyftReport_vue__ = __webpack_require__(1528);
function injectStyle (ssrContext) {
  __webpack_require__(1519)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-490eebd2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LyftReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_490eebd2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LyftReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1520);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0abaa7fb", content, true, {});

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.rsvp-report-box[data-v-490eebd2] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-490eebd2] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-490eebd2] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-490eebd2] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-490eebd2] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-490eebd2] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-490eebd2] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-490eebd2] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-490eebd2] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-490eebd2]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-490eebd2] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-490eebd2] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-490eebd2] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-490eebd2] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-490eebd2]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-490eebd2], .rsvp-report .reports .report.loading[data-v-490eebd2], .rsvp-report .reports .report.has-error[data-v-490eebd2], .rsvp-report .reports .report.success[data-v-490eebd2] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-490eebd2] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-490eebd2] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-490eebd2] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-490eebd2] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-490eebd2] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-490eebd2] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-490eebd2] {\n    cursor: pointer;\n}\n.filter input[data-v-490eebd2] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.download-type[data-v-490eebd2] {\n  float: right;\n  width: 150px;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-490eebd2] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-490eebd2] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-490eebd2] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-490eebd2] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-490eebd2] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-490eebd2] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-490eebd2] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-490eebd2] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-490eebd2]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-490eebd2] {\n      font-size: 13px;\n}\n.form-group[data-v-490eebd2] {\n  display: block;\n}\n.form-group .instruction[data-v-490eebd2] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-490eebd2] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox > *[data-v-490eebd2] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-490eebd2] {\n    margin-right: 3px;\n}\n.padding-R[data-v-490eebd2] {\n  padding-right: 7px;\n}\n.padding-L[data-v-490eebd2] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-490eebd2] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#pdf-view .page[data-v-490eebd2] {\n    padding: 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-490eebd2] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-490eebd2] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-490eebd2] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-490eebd2] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-490eebd2] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-490eebd2] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-490eebd2], #pdf-view table tbody tr.total[data-v-490eebd2] {\n      font-weight: 600;\n}\n#pdf-view table tbody tr.total[data-v-490eebd2] {\n      color: #000;\n      font-size: 14px;\n}\n#pdf-view table tbody td[data-v-490eebd2] {\n      padding: 2px 3px;\n}\n.trx-summary[data-v-490eebd2] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.trx-summary table tbody tr.total[data-v-490eebd2]:not(.remove-top) {\n    border-top: 1px solid #333;\n}\n.trx-summary table .date[data-v-490eebd2], .trx-summary table .rsvpId[data-v-490eebd2], .trx-summary table .type[data-v-490eebd2], .trx-summary table .brand[data-v-490eebd2], .trx-summary table .source[data-v-490eebd2], .trx-summary table .rideId[data-v-490eebd2], .trx-summary table .amount[data-v-490eebd2], .trx-summary table .lyftPrice[data-v-490eebd2], .trx-summary table .pickup[data-v-490eebd2], .trx-summary table .dropoff[data-v-490eebd2] {\n    text-align: center;\n}\n.trx-summary table .pickup[data-v-490eebd2], .trx-summary table .dropoff[data-v-490eebd2] {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 250px;\n}\n.slide-down-enter-active[data-v-490eebd2], .slide-down-leave-active[data-v-490eebd2] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-490eebd2], .slide-down-leave-to[data-v-490eebd2] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.end-date[data-v-490eebd2] .vdp-datepicker__calendar {\n    right: 1px;\n}\n.filter[data-v-490eebd2] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Reports/LyftReport.vue"],"names":[],"mappings":";AACA;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,qBAAqB;CACtB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,eAAe;CACpB;AACD;MACM,cAAc;MACd,aAAa;MACb,cAAc;MACd,yBAAyB;MACzB,sBAAsB;MACtB,iBAAiB;MACjB,sBAAsB;MACtB,gBAAgB;MAChB,YAAY;MACZ,wDAAwD;MACxD,6BAA6B;MAC7B,+BAA+B;CACpC;AACD;QACQ,0BAA0B;CACjC;AACD;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;CACtB;AACD;MACM,mBAAmB;MACnB,WAAW;CAChB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,+BAA+B;CACtC;AACD;UACU,YAAY;CACrB;AACD;QACQ,kBAAkB;QAClB,oBAAoB;QACpB,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,iCAAiC;QACjC,yBAAyB;CAChC;AACD;UACU,oBAAoB;UACpB,mBAAmB;CAC5B;AACD;UACU,oBAAoB;CAC7B;AACD;QACQ,WAAW;QACX,+CAA+C;gBACvC,uCAAuC;CACtD;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,eAAe;QACf,oBAAoB;CAC3B;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,cAAc;IACd,YAAY;CACf;AACD;IACI,gBAAgB;CACnB;AACD;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;CAC1B;AACD;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,oBAAoB;CACrB;AACD;IACI,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;CAC1B;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,gBAAgB;MAChB,cAAc;MACd,YAAY;MACZ,qBAAqB;CAC1B;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;CACtB;AACD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;IACI,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,iBAAiB;CACpB;AACD;MACM,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;CACxB;AACD;MACM,gBAAgB;CACrB;AACD;EACE,eAAe;CAChB;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,YAAY;CACf;AACD;IACI,kBAAkB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,aAAa;EACb,eAAe;EACf,iBAAiB;CAClB;AACD;IACI,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,aAAa;CAChB;AACD;MACM,mBAAmB;MACnB,aAAa;MACb,YAAY;MACZ,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;CACxB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;CACf;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,iBAAiB;CACtB;AACD;QACQ,8BAA8B;CACrC;AACD;MACM,iBAAiB;CACtB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;MACM,iBAAiB;CACtB;AACD;EACE,yBAAyB;EACzB,yBAAyB;CAC1B;AACD;IACI,2BAA2B;CAC9B;AACD;IACI,mBAAmB;CACtB;AACD;IACI,iBAAiB;IACjB,wBAAwB;IACxB,oBAAoB;IACpB,iBAAiB;CACpB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;AACA;IACI,WAAW;CACd;AACD;IACI,6BAA6B;IAC7B,8BAA8B;QAC1B,2BAA2B;YACvB,uBAAuB;CAClC;CACA","file":"LyftReport.vue","sourcesContent":["\n.rsvp-report-box[data-v-490eebd2] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  position: relative;\n  width: 100%;\n}\n.rsvp-report[data-v-490eebd2] {\n  border-radius: 3px;\n  padding: 0 20px 20px;\n}\n.rsvp-report .title[data-v-490eebd2] {\n    text-align: center;\n    font-weight: 700;\n    margin-bottom: 20px;\n    font-size: 18px;\n}\n.rsvp-report .date-input[data-v-490eebd2] {\n    margin-bottom: 10px;\n}\n.rsvp-report .date-input label[data-v-490eebd2] {\n      font-size: 13px;\n      color: #999;\n      display: block;\n}\n.rsvp-report .date-input select[data-v-490eebd2] {\n      padding: 10px;\n      height: 46px;\n      outline: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-color: #cacaca;\n      font-size: 14px;\n      color: #333;\n      background-image: url(\"/assets/img/dropdown-arrow.png\");\n      background-repeat: no-repeat;\n      background-position: right 50%;\n}\n.rsvp-report .date-input select[disabled][data-v-490eebd2] {\n        background-color: #ebebe4;\n}\n.rsvp-report .reports[data-v-490eebd2] {\n    max-height: 350px;\n    margin-bottom: 10px;\n    overflow: auto;\n    clear: both;\n    background: #fafafa;\n    border: 1px solid #ddd;\n    position: relative;\n}\n.rsvp-report .reports .report[data-v-490eebd2] {\n      position: relative;\n      z-index: 1;\n}\n.rsvp-report .reports .report[data-v-490eebd2]:hover {\n        background: #f1f1f1;\n}\n.rsvp-report .reports .report.processing[data-v-490eebd2] {\n        background: rgba(0, 0, 0, 0.7);\n}\n.rsvp-report .reports .report.processing input[data-v-490eebd2] {\n          opacity: .5;\n}\n.rsvp-report .reports .report select[data-v-490eebd2] {\n        margin-left: 28px;\n        margin-bottom: 10px;\n        width: calc(100% - 43px);\n        border-color: #999;\n        font-size: 13px;\n        color: #333;\n        padding: 3px 5px;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.rsvp-report .reports .report select.disabled[data-v-490eebd2] {\n          background: #fafafa;\n          border-color: #ccc;\n}\n.rsvp-report .reports .report select option[data-v-490eebd2]:disabled {\n          background: #eaeaea;\n}\n.rsvp-report .reports .report.on-queue[data-v-490eebd2], .rsvp-report .reports .report.loading[data-v-490eebd2], .rsvp-report .reports .report.has-error[data-v-490eebd2], .rsvp-report .reports .report.success[data-v-490eebd2] {\n        z-index: 3;\n        -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n}\n.rsvp-report .reports .report.on-queue[data-v-490eebd2] {\n        background: #fff;\n}\n.rsvp-report .reports .report.loading[data-v-490eebd2] {\n        color: #775913;\n        background: #f1ce7e;\n}\n.rsvp-report .reports .report.success[data-v-490eebd2] {\n        color: #0f693a;\n        background: #a9f7ce;\n}\n.rsvp-report .reports .report.has-error[data-v-490eebd2] {\n        color: #b93030;\n        background: #fbb0b0;\n}\n.filter[data-v-490eebd2] {\n  list-style: none;\n  margin: 0 0 5px;\n  padding: 0;\n  font-size: 13px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter li[data-v-490eebd2] {\n    margin: 2px 0;\n    width: 100%;\n}\n.filter label[data-v-490eebd2] {\n    cursor: pointer;\n}\n.filter input[data-v-490eebd2] {\n    display: inline-block;\n    margin: 0 3px 0 0;\n    width: auto;\n    vertical-align: middle;\n}\n.download-type[data-v-490eebd2] {\n  float: right;\n  width: 150px;\n  text-align: right;\n  padding-bottom: 5px;\n}\n.download-type label[data-v-490eebd2] {\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border: 1px solid #ddd;\n}\n.download-type label.pdf[data-v-490eebd2] {\n      color: #c54d4d;\n}\n.download-type label.csv[data-v-490eebd2] {\n      color: #7ad275;\n}\n.download-type label.has-error[data-v-490eebd2] {\n      border: 1px solid #d00;\n}\n.download-type label input[data-v-490eebd2] {\n      display: inline;\n      margin-top: 0;\n      width: auto;\n      vertical-align: -1px;\n}\n.list-box[data-v-490eebd2] {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n}\n.error[data-v-490eebd2] {\n  background-color: #F25E0D;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  border-radius: 3px;\n  padding: 5px;\n  margin-bottom: 15px;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.error ul[data-v-490eebd2] {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    text-align: left;\n}\n.error ul li[data-v-490eebd2]:first-child {\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1;\n      margin-bottom: 2px;\n}\n.error ul li[data-v-490eebd2] {\n      font-size: 13px;\n}\n.form-group[data-v-490eebd2] {\n  display: block;\n}\n.form-group .instruction[data-v-490eebd2] {\n    margin-bottom: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n}\n.checkbox[data-v-490eebd2] {\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n.checkbox > *[data-v-490eebd2] {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    width: auto;\n}\n.checkbox input[data-v-490eebd2] {\n    margin-right: 3px;\n}\n.padding-R[data-v-490eebd2] {\n  padding-right: 7px;\n}\n.padding-L[data-v-490eebd2] {\n  padding-left: 7px;\n}\n#pdf-view[data-v-490eebd2] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#pdf-view .page[data-v-490eebd2] {\n    padding: 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-490eebd2] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-490eebd2] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n}\n#pdf-view .date-range[data-v-490eebd2] {\n    text-align: center;\n    font-style: italic;\n    font-size: 18px;\n    margin-bottom: 20px;\n    color: #555;\n}\n#pdf-view table[data-v-490eebd2] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-490eebd2] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-490eebd2] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-490eebd2], #pdf-view table tbody tr.total[data-v-490eebd2] {\n      font-weight: 600;\n}\n#pdf-view table tbody tr.total[data-v-490eebd2] {\n      color: #000;\n      font-size: 14px;\n}\n#pdf-view table tbody td[data-v-490eebd2] {\n      padding: 2px 3px;\n}\n.trx-summary[data-v-490eebd2] {\n  width: 1122px !important;\n  height: 793px !important;\n}\n.trx-summary table tbody tr.total[data-v-490eebd2]:not(.remove-top) {\n    border-top: 1px solid #333;\n}\n.trx-summary table .date[data-v-490eebd2], .trx-summary table .rsvpId[data-v-490eebd2], .trx-summary table .type[data-v-490eebd2], .trx-summary table .brand[data-v-490eebd2], .trx-summary table .source[data-v-490eebd2], .trx-summary table .rideId[data-v-490eebd2], .trx-summary table .amount[data-v-490eebd2], .trx-summary table .lyftPrice[data-v-490eebd2], .trx-summary table .pickup[data-v-490eebd2], .trx-summary table .dropoff[data-v-490eebd2] {\n    text-align: center;\n}\n.trx-summary table .pickup[data-v-490eebd2], .trx-summary table .dropoff[data-v-490eebd2] {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 250px;\n}\n.slide-down-enter-active[data-v-490eebd2], .slide-down-leave-active[data-v-490eebd2] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-490eebd2], .slide-down-leave-to[data-v-490eebd2] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.end-date[data-v-490eebd2] .vdp-datepicker__calendar {\n    right: 1px;\n}\n.filter[data-v-490eebd2] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1522), __esModule: true };

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1523);
module.exports = __webpack_require__(12).Object.entries;


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(15);
var $entries = __webpack_require__(175)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1525);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(35);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1526), __esModule: true };

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(70);
__webpack_require__(56);
module.exports = __webpack_require__(1527);


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(101);
var ITERATOR = __webpack_require__(19)('iterator');
var Iterators = __webpack_require__(66);
module.exports = __webpack_require__(12).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rsvp-report-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"instruction"},[_vm._v("Please select a start and end date:")]),_vm._v(" "),_c('div',{staticClass:"row expanded"},[_c('div',{staticClass:"small-6 column padding-R"},[_c('div',{staticClass:"date-input"},[_c('label',[_vm._v("Start Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}})],1)]),_vm._v(" "),_c('div',{staticClass:"small-6 column padding-L"},[_c('div',{staticClass:"date-input end-date"},[_c('label',[_vm._v("End Date:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy","highlighted":_vm.highlightedDates},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"list-box"},[_c('div',{staticClass:"rsvp-report"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"download-type"},[_c('label',{class:{'pdf':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pdfChecked),expression:"pdfChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.pdfChecked)?_vm._i(_vm.pdfChecked,null)>-1:(_vm.pdfChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.pdfChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.pdfChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.pdfChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.pdfChecked=$$c}}}}),_vm._v("\n            PDF\n          ")]),_vm._v(" "),_c('label',{class:{'csv':true, 'has-error':_vm.formatError}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.csvChecked),expression:"csvChecked"}],attrs:{"type":"checkbox","name":"downloadType"},domProps:{"checked":Array.isArray(_vm.csvChecked)?_vm._i(_vm.csvChecked,null)>-1:(_vm.csvChecked)},on:{"click":_vm.formatCheck,"change":function($event){var $$a=_vm.csvChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.csvChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.csvChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.csvChecked=$$c}}}}),_vm._v("\n            CSV\n          ")])]),_vm._v(" "),_c('div',{staticClass:"instruction"},[_vm._v("Please select the reports to generate:")]),_vm._v(" "),_c('div',{staticClass:"row expanded reports"},[_c('div',{class:['small-12 column report', _vm.reportStatus.lyftReport, {'processing':_vm.pdf.loading}]},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports.lyftReport),expression:"selectedReports.lyftReport"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedReports.lyftReport)?_vm._i(_vm.selectedReports.lyftReport,null)>-1:(_vm.selectedReports.lyftReport)},on:{"change":function($event){var $$a=_vm.selectedReports.lyftReport,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedReports, "lyftReport", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedReports, "lyftReport", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedReports, "lyftReport", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reportLabel('lyftReport')))])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.show),expression:"error.show"}],staticClass:"error"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.message),expression:"!!error.message"}]},[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.empty.length),expression:"error.empty.length"}]},[_c('li',[_vm._v("Empty Result:")]),_vm._v(" "),_vm._l((_vm.error.empty),function(empty){return _c('li',[_vm._v("- "+_vm._s(empty))])})],2)])]),_vm._v(" "),_c('a',{class:{ 'button cta success small block': true, disabled: _vm.pdf.loading },attrs:{"href":"javascript:;"},on:{"click":_vm.startProcess}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.pdf.loading),expression:"pdf.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pdf.loading),expression:"!pdf.loading"}]},[_vm._v("Generate and Download Report")])])],1),_vm._v(" "),_c('div',{class:[_vm.pdf.class],attrs:{"id":"pdf-view"}},[_vm._l((_vm.pdf.table.data),function(pageData,pageIndex){return _c('div',{class:['page', pageIndex]},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',_vm._l((_vm.pdf.table.label),function(label){return _c('th',{domProps:{"innerHTML":_vm._s(label)}})}),0)]),_vm._v(" "),_c('tbody',_vm._l((pageData),function(data,index){return _c('tr',_vm._l((data),function(value,i){return _c('td',{class:[i]},[_vm._v(_vm._s(i == 'amount' ? parseFloat(value).toFixed(2) : value))])}),0)}),0)]),_vm._v(" "),_c('div',{staticClass:"page-count"},[_vm._v("page "+_vm._s(_vm.currentPage(pageIndex))+" of "+_vm._s(_vm.totalPage))])])}),_vm._v(" "),(_vm.isLyftReport)?_c('div',{class:['page', ("page" + (_vm.totalPage + 1))]},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.pdf.title))]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.pdf.date))]),_vm._v(" "),_c('table',[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._m(1),_vm._v(" "),(_vm.pdf.table.total.type.lyft)?_c('tr',{staticClass:"total remove-top"},[_c('td',{staticClass:"date",attrs:{"valign":"top"}},[_vm._v("Lyft ("+_vm._s(_vm.pdf.table.total.type.lyft)+")")]),_vm._v(" "),_c('td',{attrs:{"colspan":"6"}},[_c('div',{staticStyle:{"padding-bottom":"1px"}},[_vm._v("Primetime Total: $"+_vm._s((_vm.totals.lyft.pts + _vm.totals.lyft.ptsOnly).toFixed(2)))]),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"1px"}},[_vm._v("\n                  Lyft Total:\n                  "),(!_vm.totals.lyft.lyft)?_c('span',[_vm._v("N/A")]):_c('span',[_vm._v("-$"+_vm._s(_vm.totals.lyft.lyft))])])]),_vm._v(" "),_c('td',{attrs:{"valign":"top"}},[_c('div',{staticStyle:{"padding-bottom":"3px"}},[_vm._v("Margin: $"+_vm._s((parseFloat((_vm.totals.lyft.pts + _vm.totals.lyft.ptsOnly)) - parseFloat(_vm.totals.lyft.lyft)).toFixed(2)))])])]):_vm._e(),_vm._v(" "),(_vm.pdf.table.total.type.lyft)?_c('tr',{staticClass:"total remove-top"},[_c('td',{staticClass:"date",attrs:{"valign":"top"}}),_vm._v(" "),_c('td',{staticStyle:{"padding-bottom":"10px"},attrs:{"colspan":"7"}},_vm._l((_vm.pdf.table.total.deviceType.lyft),function(val2,key2){return _c('span',{staticStyle:{"display":"inline-block","margin-right":"10px","font-weight":"500","color":"#333"}},[_vm._v("\n                  "+_vm._s(_vm.sourceLabel(key2))+": "+_vm._s(val2)+"\n                ")])}),0)]):_vm._e(),_vm._v(" "),_vm._l((Math.ceil(Object.keys(_vm.pdf.table.total.brand.lyft || {}).length / 2)),function(n){return (_vm.pdf.table.total.brand.lyft)?_c('tr',{staticClass:"total remove-top"},[_c('td',{staticClass:"date",attrs:{"valign":"top"}}),_vm._v(" "),_c('td',{attrs:{"colspan":"7"}},[(Object.entries(_vm.pdf.table.total.brand.lyft)[(n - 1) * 2])?_c('span',{staticStyle:{"display":"inline-block","margin-right":"10px","font-weight":"500","color":"#333"}},[_vm._v(_vm._s(Object.entries(_vm.pdf.table.total.brand.lyft)[(n - 1) * 2][0])+": "+_vm._s(Object.entries(_vm.pdf.table.total.brand.lyft)[(n - 1) * 2][1]))]):_vm._e(),_vm._v(" "),(Object.entries(_vm.pdf.table.total.brand.lyft)[(n * 2) - 1])?_c('span',{staticStyle:{"display":"inline-block","margin-right":"10px","font-weight":"500","color":"#333"}},[_vm._v(_vm._s(Object.entries(_vm.pdf.table.total.brand.lyft)[(n * 2) - 1][0])+": "+_vm._s(Object.entries(_vm.pdf.table.total.brand.lyft)[(n * 2) - 1][1]))]):_vm._e()])]):_vm._e()}),_vm._v(" "),_vm._m(2),_vm._v(" "),(_vm.pdf.table.total.type.farmout)?_c('tr',{staticClass:"total remove-top"},[_c('td',{staticClass:"date",attrs:{"valign":"top"}},[_vm._v("Farm out ("+_vm._s(_vm.pdf.table.total.type.farmout)+")")]),_vm._v(" "),_c('td',{attrs:{"colspan":"6"}},[_c('div',{staticStyle:{"padding-bottom":"1px"}},[_vm._v("Primetime Total: $"+_vm._s((_vm.totals.farmout.pts + _vm.totals.farmout.ptsOnly).toFixed(2)))]),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"1px"}},[_vm._v("\n                  Lyft Total:\n                  "),(!_vm.totals.farmout.lyft)?_c('span',[_vm._v("N/A")]):_c('span',[_vm._v("-$"+_vm._s(_vm.totals.farmout.lyft))])])]),_vm._v(" "),_c('td',{attrs:{"valign":"top"}},[_c('div',{staticStyle:{"padding-bottom":"3px"}},[_vm._v("Margin: $"+_vm._s((parseFloat((_vm.totals.farmout.pts + _vm.totals.farmout.ptsOnly)) - parseFloat(_vm.totals.farmout.lyft)).toFixed(2)))])])]):_vm._e(),_vm._v(" "),(_vm.pdf.table.total.type.farmout)?_c('tr',{staticClass:"total remove-top"},[_c('td',{staticClass:"date",attrs:{"valign":"top"}}),_vm._v(" "),_c('td',{staticStyle:{"padding-bottom":"10px"},attrs:{"colspan":"7"}},_vm._l((_vm.pdf.table.total.deviceType.farmout),function(val2,key2){return _c('span',{staticStyle:{"display":"inline-block","margin-right":"10px","font-weight":"500","color":"#333"}},[_vm._v("\n                  "+_vm._s(_vm.sourceLabel(key2))+": "+_vm._s(val2)+"\n                ")])}),0)]):_vm._e(),_vm._v(" "),_vm._l((Math.ceil(Object.keys(_vm.pdf.table.total.brand.farmout || {}).length / 2)),function(n){return (_vm.pdf.table.total.brand.farmout)?_c('tr',{staticClass:"total remove-top"},[_c('td'),_vm._v(" "),_c('td',{attrs:{"colspan":"7"}},[(Object.entries(_vm.pdf.table.total.brand.farmout)[(n - 1) * 2])?_c('span',{staticStyle:{"display":"inline-block","margin-right":"10px","font-weight":"500","color":"#333"}},[_vm._v(_vm._s(Object.entries(_vm.pdf.table.total.brand.farmout)[(n - 1) * 2][0])+": "+_vm._s(Object.entries(_vm.pdf.table.total.brand.farmout)[(n - 1) * 2][1]))]):_vm._e(),_vm._v(" "),(Object.entries(_vm.pdf.table.total.brand.farmout)[(n * 2) - 1])?_c('span',{staticStyle:{"display":"inline-block","margin-right":"10px","font-weight":"500","color":"#333"}},[_vm._v(_vm._s(Object.entries(_vm.pdf.table.total.brand.farmout)[(n * 2) - 1][0])+": "+_vm._s(Object.entries(_vm.pdf.table.total.brand.farmout)[(n * 2) - 1][1]))]):_vm._e()])]):_vm._e()}),_vm._v(" "),(_vm.pdf.table.total.type.manual)?_c('tr',{staticClass:"total remove-top"},[_c('td',{staticClass:"date",attrs:{"valign":"top"}},[_vm._v("Manual ("+_vm._s(_vm.pdf.table.total.type.manual)+")")]),_vm._v(" "),_c('td',{attrs:{"colspan":"6"}},[_c('div',{staticStyle:{"padding-bottom":"1px"}},[_vm._v("Primetime Total: $"+_vm._s((_vm.totals.manual.pts + _vm.totals.manual.ptsOnly).toFixed(2)))]),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"1px"}},[_vm._v("\n                  Lyft Total: \n                  "),(!_vm.totals.manual.lyft)?_c('span',[_vm._v("N/A")]):_c('span',[_vm._v("-$"+_vm._s(_vm.totals.manual.lyft))])])]),_vm._v(" "),_c('td',{attrs:{"valign":"top"}},[_c('div',{staticStyle:{"padding-bottom":"3px"}},[_vm._v("Margin: $"+_vm._s((parseFloat((_vm.totals.manual.pts + _vm.totals.manual.ptsOnly)) - parseFloat(_vm.totals.manual.lyft)).toFixed(2)))])])]):_vm._e(),_vm._v(" "),(_vm.pdf.table.total.type.manual)?_c('tr',{staticClass:"total remove-top"},[_c('td',{staticClass:"date",attrs:{"valign":"top"}}),_vm._v(" "),_c('td',{staticStyle:{"padding-bottom":"10px"},attrs:{"colspan":"7"}},_vm._l((_vm.pdf.table.total.deviceType.manual),function(val2,key2){return _c('span',{staticStyle:{"display":"inline-block","margin-right":"10px","font-weight":"500","color":"#333"}},[_vm._v("\n                  "+_vm._s(_vm.sourceLabel(key2))+": "+_vm._s(val2)+"\n                ")])}),0)]):_vm._e(),_vm._v(" "),_vm._l((Math.ceil(Object.keys(_vm.pdf.table.total.brand.manual || {}).length / 2)),function(n){return (_vm.pdf.table.total.brand.manual)?_c('tr',{staticClass:"total remove-top"},[_c('td'),_vm._v(" "),_c('td',{attrs:{"colspan":"7"}},[(Object.entries(_vm.pdf.table.total.brand.manual)[(n - 1) * 2])?_c('span',{staticStyle:{"display":"inline-block","margin-right":"10px","font-weight":"500","color":"#333"}},[_vm._v(_vm._s(Object.entries(_vm.pdf.table.total.brand.manual)[(n - 1) * 2][0])+": "+_vm._s(Object.entries(_vm.pdf.table.total.brand.manual)[(n - 1) * 2][1]))]):_vm._e(),_vm._v(" "),(Object.entries(_vm.pdf.table.total.brand.manual)[(n * 2) - 1])?_c('span',{staticStyle:{"display":"inline-block","margin-right":"10px","font-weight":"500","color":"#333"}},[_vm._v(_vm._s(Object.entries(_vm.pdf.table.total.brand.manual)[(n * 2) - 1][0])+": "+_vm._s(Object.entries(_vm.pdf.table.total.brand.manual)[(n * 2) - 1][1]))]):_vm._e()])]):_vm._e()}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('tr',{staticClass:"total remove-top"},[_c('td',{staticClass:"date"},[_vm._v("Total ("+_vm._s(_vm.pdf.table.total.rsvp)+")")]),_vm._v(" "),_c('td',{attrs:{"colspan":"6"}},[_vm._v("Primetime Total: $"+_vm._s(_vm.pdf.table.total.amount.toFixed(2)))]),_vm._v(" "),_c('td',{attrs:{"valign":"top"}},[_vm._v("Total Margin: $"+_vm._s((parseFloat(_vm.pdf.table.total.amount) - parseFloat(_vm.pdf.table.total.lyftPrice)).toFixed(2)))])]),_vm._v(" "),_c('tr',{staticClass:"total remove-top"},[_c('td',{staticClass:"date"}),_vm._v(" "),_c('td',{attrs:{"colspan":"7"}},[_vm._v("Lyft Total: -$"+_vm._s(_vm.pdf.table.total.lyftPrice.toFixed(2)))])])],2)])]):_vm._e()],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"8"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"total"},[_c('td',{attrs:{"colspan":"8"}},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"6"}},[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"6"}},[_vm._v(" ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reports"},[_c('div',{staticClass:"header"},[_vm._v("REPORTS")]),_vm._v(" "),_c('div',{staticClass:"report-box"},[_c('div',{staticClass:"instructions"},[_vm._v("Select the report you want to generate:")]),_vm._v(" "),_c('div',{staticClass:"report-list"},[(_vm.reportAccess.PageReportsTNCReportForLAWA)?_c('div',{staticClass:"report-option"},[_c('div',{staticClass:"heading"},[_c('span',[_vm._v("1. TNC Report for LAWA")]),_vm._v(" "),_c('a',{staticClass:"button cta small f-right",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$store.commit('reports/showTNCReport')}}},[_vm._v("Generate Report")])])]):_vm._e(),_vm._v(" "),(_vm.reportAccess.PageReportsReservationReports)?_c('div',{class:{'report-option toggleable':true, 'active':_vm.showRsvpReport}},[_c('div',{staticClass:"heading",on:{"click":function($event){return _vm.$store.commit('reports/setShowRsvpReport', !_vm.showRsvpReport)}}},[_c('span',[_vm._v("\n            2. Reservation Reports\n            "),_c('a',{staticClass:"button cta xsmall daily-rsvp-rep",on:{"click":[function($event){$event.stopPropagation();},function($event){_vm.showDailyRsvpReport = true}]}},[_vm._v("Daily RSVP Report")])]),_vm._v(" "),_c('i',{class:{'fas fa-chevron-down fa-2x':true, 'show':_vm.showRsvpReport}})]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('rsvp-report',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRsvpReport),expression:"showRsvpReport"}]})],1)],1):_vm._e(),_vm._v(" "),(_vm.reportAccess.PageReportsTransactionReports)?_c('div',{class:{'report-option toggleable':true, 'active':_vm.showTrxReport}},[_c('div',{staticClass:"heading",on:{"click":function($event){return _vm.$store.commit('reports/setShowTrxReport', !_vm.showTrxReport)}}},[_c('span',[_vm._v("3. Transaction Reports")]),_vm._v(" "),_c('i',{class:{'fas fa-chevron-down fa-2x':true, 'show':_vm.showTrxReport}})]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('trx-report',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTrxReport),expression:"showTrxReport"}]})],1)],1):_vm._e(),_vm._v(" "),(_vm.reportAccess.PageReportsDriverReviews)?_c('div',{class:{'report-option toggleable':true, 'active':_vm.showDriverRatingReport}},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.showDriverRatingReport = !_vm.showDriverRatingReport}}},[_c('span',[_vm._v("4. Driver Reviews")]),_vm._v(" "),_c('i',{class:{'fas fa-chevron-down fa-2x':true, 'show':_vm.showDriverRatingReport}})]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('driver-rating-report',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDriverRatingReport),expression:"showDriverRatingReport"}]})],1)],1):_vm._e(),_vm._v(" "),(_vm.reportAccess.PageReportsSpecialReports)?_c('div',{class:{'report-option toggleable':true, 'active':_vm.showSpecializeReport}},[_c('div',{staticClass:"heading",on:{"click":function($event){return _vm.$store.commit('reports/setShowSpecializeReport', !_vm.showSpecializeReport)}}},[_c('span',[_vm._v("5. Special Reports")]),_vm._v(" "),_c('i',{class:{'fas fa-chevron-down fa-2x':true, 'show':_vm.showSpecializeReport}})]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('specialize-report',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSpecializeReport),expression:"showSpecializeReport"}]})],1)],1):_vm._e(),_vm._v(" "),(_vm.reportAccess.PageReportsDirectBill)?_c('div',{class:{'report-option toggleable':true, 'active':_vm.showDirectBill}},[_c('div',{staticClass:"heading",on:{"click":function($event){return _vm.$store.commit('reports/setShowDirectBill', !_vm.showDirectBill)}}},[_c('span',[_vm._v("6. Direct Bill")]),_vm._v(" "),_c('i',{class:{'fas fa-chevron-down fa-2x':true, 'show':_vm.showDirectBill}})]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('direct-bill',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDirectBill),expression:"showDirectBill"}]})],1)],1):_vm._e(),_vm._v(" "),(_vm.reportAccess.PageReportsPayoutReport)?_c('div',{class:{'report-option toggleable':true, 'active':_vm.showDriverPayouts}},[_c('div',{staticClass:"heading",on:{"click":function($event){return _vm.$store.commit('reports/setDriverPayouts', !_vm.showDriverPayouts)}}},[_c('span',[_vm._v("7. Payout Report")]),_vm._v(" "),_c('i',{class:{'fas fa-chevron-down fa-2x':true, 'show':_vm.showDriverPayouts}})]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('driver-payouts',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDriverPayouts),expression:"showDriverPayouts"}]})],1)],1):_vm._e(),_vm._v(" "),(_vm.reportAccess.PageReportsBackendManager)?_c('div',{class:{'report-option toggleable':true, 'active':_vm.showBackendManger}},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.showBackendManger = !_vm.showBackendManger}}},[_c('span',[_vm._v("8. Backend Manager")]),_vm._v(" "),_c('i',{class:{'fas fa-chevron-down fa-2x':true, 'show':_vm.showBackendManger}})]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('backend-manager',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBackendManger),expression:"showBackendManger"}]})],1)],1):_vm._e(),_vm._v(" "),(_vm.reportAccess.PageReportsMTech)?_c('div',{class:['report-option toggleable', {'active':_vm.showMtech}]},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.showMtech = !_vm.showMtech}}},[_c('span',[_vm._v("9. MTech")]),_vm._v(" "),_c('i',{class:['fas fa-chevron-down fa-2x', {'show':_vm.showMtech}]})]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('mtech',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMtech),expression:"showMtech"}]})],1)],1):_vm._e(),_vm._v(" "),(_vm.reportAccess.PageReportsBlockReport)?_c('div',{class:['report-option toggleable', {'active':_vm.showBlockReport}]},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.showBlockReport = !_vm.showBlockReport}}},[_c('span',[_vm._v("10. Block Report")]),_vm._v(" "),_c('i',{class:['fas fa-chevron-down fa-2x', {'show':_vm.showBlockReport}]})]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('block-report',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBlockReport),expression:"showBlockReport"}]})],1)],1):_vm._e(),_vm._v(" "),(_vm.reportAccess.PageReportsTNCReportLongBeach)?_c('div',{class:['report-option toggleable', {'active':_vm.showLGBReport}]},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.showLGBReport = !_vm.showLGBReport}}},[_c('span',[_vm._v("11. TNC Report - Long Beach")]),_vm._v(" "),_c('i',{class:['fas fa-chevron-down fa-2x', {'show':_vm.showLGBReport}]})]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('lgb-report',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLGBReport),expression:"showLGBReport"}]})],1)],1):_vm._e(),_vm._v(" "),(_vm.reportAccess.PageReportsActiveDrivers)?_c('div',{class:['report-option toggleable', {'active':_vm.showActiveDrivers}]},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.showActiveDrivers = !_vm.showActiveDrivers}}},[_c('span',[_vm._v("12. Active Drivers")]),_vm._v(" "),_c('i',{class:['fas fa-chevron-down fa-2x', {'show':_vm.showActiveDrivers}]})]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('active-drivers',{directives:[{name:"show",rawName:"v-show",value:(_vm.showActiveDrivers),expression:"showActiveDrivers"}]})],1)],1):_vm._e(),_vm._v(" "),(_vm.reportAccess.PageReportsDriverCount)?_c('div',{class:['report-option toggleable', {'active':_vm.showDriverCount}]},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.showDriverCount = !_vm.showDriverCount}}},[_c('span',[_vm._v("13. Driver Count")]),_vm._v(" "),_c('i',{class:['fas fa-chevron-down fa-2x', {'show':_vm.showDriverCount}]})]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('driver-count',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDriverCount),expression:"showDriverCount"}]})],1)],1):_vm._e(),_vm._v(" "),(_vm.reportAccess.PageReportsLyftReport)?_c('div',{class:['report-option toggleable', {'active':_vm.showLyftReport}]},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.showLyftReport = !_vm.showLyftReport}}},[_c('span',[_vm._v("14. Lyft Report")]),_vm._v(" "),_c('i',{class:['fas fa-chevron-down fa-2x', {'show':_vm.showLyftReport}]})]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('lyft-report',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLyftReport),expression:"showLyftReport"}]})],1)],1):_vm._e()])]),_vm._v(" "),_c('lawa-report'),_vm._v(" "),_c('daily-rsvp-report',{attrs:{"modal":_vm.showDailyRsvpReport},on:{"closeDailyRsvp":function($event){_vm.showDailyRsvpReport = false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(534);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b208f2a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1533);
function injectStyle (ssrContext) {
  __webpack_require__(1531)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b208f2a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b208f2a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1532);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("61f5ce2c", content, true, {});

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.header[data-v-b208f2a8] {\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  margin-bottom: 30px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.import-rsvp[data-v-b208f2a8] {\n  width: 100%;\n  display: table;\n}\n.v-center[data-v-b208f2a8] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.import-box[data-v-b208f2a8] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n  width: 100%;\n  margin: 0 auto;\n  max-width: 800px;\n}\n.import-box .input-box[data-v-b208f2a8] {\n    border: 2px dashed #b7a711;\n    padding: 15px;\n    border-radius: 4px;\n    margin-top: 5px;\n    background: #fbf9e6;\n}\n.import-box .input-box .fa-spin[data-v-b208f2a8] {\n      margin-left: 3px;\n}\n.import-box .input-box .note[data-v-b208f2a8] {\n      font-size: 13px;\n      font-style: italic;\n      padding: 0 5px;\n      color: #555;\n      display: block;\n}\n.import-box .rsvp-box[data-v-b208f2a8] {\n    margin-top: 10px;\n    padding: 15px;\n    border-radius: 4px;\n    border: 2px solid #ccc;\n}\n.import-box .rsvp-box .rsvp-item[data-v-b208f2a8] {\n      border: 1px solid #888;\n      font-size: 14px;\n      margin-bottom: 8px;\n      text-align: left;\n      border-radius: 2px;\n      position: relative;\n}\n.import-box .rsvp-box .rsvp-item.success[data-v-b208f2a8] {\n        border-color: #09a63a;\n        background: #e1ffea;\n        color: #09a63a;\n}\n.import-box .rsvp-box .rsvp-item.success a[data-v-b208f2a8] {\n          color: #09a63a;\n}\n.import-box .rsvp-box .rsvp-item.failed[data-v-b208f2a8] {\n        border-color: #f23333;\n        color: #f23333;\n}\n.import-box .rsvp-box .rsvp-item.on-going[data-v-b208f2a8] {\n        border-color: #c56a0d;\n        background: #fbfaea;\n        color: #c56a0d;\n}\n.import-box .rsvp-box .rsvp-item .info[data-v-b208f2a8] {\n        padding: 5px;\n        width: calc(100% - 130px);\n        float: left;\n}\n.import-box .rsvp-box .rsvp-item .info span[data-v-b208f2a8] {\n          display: inline-block;\n          vertical-align: middle;\n}\n.import-box .rsvp-box .rsvp-item .info .index[data-v-b208f2a8] {\n          min-width: 30px;\n          text-align: center;\n          margin-right: 3px;\n          font-weight: 600;\n}\n.import-box .rsvp-box .rsvp-item .info .email[data-v-b208f2a8] {\n          margin-left: 5px;\n          font-size: 13px;\n          opacity: .75;\n}\n.import-box .rsvp-box .rsvp-item .action[data-v-b208f2a8] {\n        max-width: 130px;\n        min-width: 50px;\n        float: right;\n        padding: 5px;\n        text-align: center;\n}\n.import-box .rsvp-box .rsvp-item .fa-sync[data-v-b208f2a8] {\n        cursor: pointer;\n}\n.import-box .rsvp-box .rsvp-item .error-msg[data-v-b208f2a8] {\n        background: #fde3e3;\n        color: #f23333;\n        font-style: italic;\n        padding: 2px 5px;\n        font-size: 13px;\n}\n.clearfix[data-v-b208f2a8] {\n  clear: both;\n}\n.p-R-10[data-v-b208f2a8] {\n  padding-right: 10px;\n}\n.p-T-10[data-v-b208f2a8] {\n  padding-top: 10px;\n}\n.data-field[data-v-b208f2a8] {\n  padding: 5px;\n  position: relative;\n}\n.data-field .label[data-v-b208f2a8] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .label.has-error[data-v-b208f2a8] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-b208f2a8] {\n    margin: 1px 0 0;\n    padding: 5px;\n    font-size: 14px;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-b208f2a8] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-b208f2a8]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-b208f2a8] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\nselect[data-v-b208f2a8] {\n  padding: 5px 25px 5px 5px;\n  height: 30px;\n  font-size: 14px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-b208f2a8] {\n    background-color: #ebebe4;\n}\ninput[type=\"file\"][data-v-b208f2a8] {\n  margin-top: 0;\n  padding: 4px;\n  font-size: 14px;\n  background: #fdfdfd;\n}\n.control-box[data-v-b208f2a8] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n}\n.control-box .control[data-v-b208f2a8] {\n    margin: 0 auto;\n    width: 100%;\n    max-width: 800px;\n    border-radius: 4px 4px 0 0;\n    height: 50px;\n    line-height: 50px;\n    font-size: 21px;\n    cursor: pointer;\n    text-align: center;\n    background: #c5d0dc;\n}\n.control-box .control i[data-v-b208f2a8] {\n      margin-right: 4px;\n}\n.slide-up-enter-active[data-v-b208f2a8], .slide-up-leave-active[data-v-b208f2a8] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-b208f2a8], .slide-up-leave-to[data-v-b208f2a8] {\n  -webkit-transform: translateY(30px);\n          transform: translateY(30px);\n  opacity: 0;\n}\n.slide-down-enter-active[data-v-b208f2a8], .slide-down-leave-active[data-v-b208f2a8] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-b208f2a8], .slide-down-leave-to[data-v-b208f2a8] {\n  -webkit-transform: translateY(-30px);\n          transform: translateY(-30px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.small-6[data-v-b208f2a8] {\n    width: 100%;\n}\n.p-T-10[data-v-b208f2a8] {\n    padding-top: 25px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/ImportRsvp/index.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,oBAAoB;EACpB,6CAA6C;CAC9C;AACD;EACE,YAAY;EACZ,eAAe;CAChB;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,kDAAkD;UAC1C,0CAA0C;EAClD,YAAY;EACZ,eAAe;EACf,iBAAiB;CAClB;AACD;IACI,2BAA2B;IAC3B,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;CACvB;AACD;MACM,iBAAiB;CACtB;AACD;MACM,gBAAgB;MAChB,mBAAmB;MACnB,eAAe;MACf,YAAY;MACZ,eAAe;CACpB;AACD;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;CAC1B;AACD;MACM,uBAAuB;MACvB,gBAAgB;MAChB,mBAAmB;MACnB,iBAAiB;MACjB,mBAAmB;MACnB,mBAAmB;CACxB;AACD;QACQ,sBAAsB;QACtB,oBAAoB;QACpB,eAAe;CACtB;AACD;UACU,eAAe;CACxB;AACD;QACQ,sBAAsB;QACtB,eAAe;CACtB;AACD;QACQ,sBAAsB;QACtB,oBAAoB;QACpB,eAAe;CACtB;AACD;QACQ,aAAa;QACb,0BAA0B;QAC1B,YAAY;CACnB;AACD;UACU,sBAAsB;UACtB,uBAAuB;CAChC;AACD;UACU,gBAAgB;UAChB,mBAAmB;UACnB,kBAAkB;UAClB,iBAAiB;CAC1B;AACD;UACU,iBAAiB;UACjB,gBAAgB;UAChB,aAAa;CACtB;AACD;QACQ,iBAAiB;QACjB,gBAAgB;QAChB,aAAa;QACb,aAAa;QACb,mBAAmB;CAC1B;AACD;QACQ,gBAAgB;CACvB;AACD;QACQ,oBAAoB;QACpB,eAAe;QACf,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;CACvB;AACD;EACE,YAAY;CACb;AACD;EACE,oBAAoB;CACrB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,aAAa;EACb,mBAAmB;CACpB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;MACM,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;EACE,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,+BAA+B;CAChC;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,oBAAoB;CACrB;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,YAAY;CACb;AACD;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;CACvB;AACD;MACM,kBAAkB;CACvB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ;AACD;AACA;IACI,YAAY;CACf;AACD;IACI,kBAAkB;CACrB;CACA","file":"index.vue","sourcesContent":["\n.header[data-v-b208f2a8] {\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  margin-bottom: 30px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.import-rsvp[data-v-b208f2a8] {\n  width: 100%;\n  display: table;\n}\n.v-center[data-v-b208f2a8] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.import-box[data-v-b208f2a8] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n  width: 100%;\n  margin: 0 auto;\n  max-width: 800px;\n}\n.import-box .input-box[data-v-b208f2a8] {\n    border: 2px dashed #b7a711;\n    padding: 15px;\n    border-radius: 4px;\n    margin-top: 5px;\n    background: #fbf9e6;\n}\n.import-box .input-box .fa-spin[data-v-b208f2a8] {\n      margin-left: 3px;\n}\n.import-box .input-box .note[data-v-b208f2a8] {\n      font-size: 13px;\n      font-style: italic;\n      padding: 0 5px;\n      color: #555;\n      display: block;\n}\n.import-box .rsvp-box[data-v-b208f2a8] {\n    margin-top: 10px;\n    padding: 15px;\n    border-radius: 4px;\n    border: 2px solid #ccc;\n}\n.import-box .rsvp-box .rsvp-item[data-v-b208f2a8] {\n      border: 1px solid #888;\n      font-size: 14px;\n      margin-bottom: 8px;\n      text-align: left;\n      border-radius: 2px;\n      position: relative;\n}\n.import-box .rsvp-box .rsvp-item.success[data-v-b208f2a8] {\n        border-color: #09a63a;\n        background: #e1ffea;\n        color: #09a63a;\n}\n.import-box .rsvp-box .rsvp-item.success a[data-v-b208f2a8] {\n          color: #09a63a;\n}\n.import-box .rsvp-box .rsvp-item.failed[data-v-b208f2a8] {\n        border-color: #f23333;\n        color: #f23333;\n}\n.import-box .rsvp-box .rsvp-item.on-going[data-v-b208f2a8] {\n        border-color: #c56a0d;\n        background: #fbfaea;\n        color: #c56a0d;\n}\n.import-box .rsvp-box .rsvp-item .info[data-v-b208f2a8] {\n        padding: 5px;\n        width: calc(100% - 130px);\n        float: left;\n}\n.import-box .rsvp-box .rsvp-item .info span[data-v-b208f2a8] {\n          display: inline-block;\n          vertical-align: middle;\n}\n.import-box .rsvp-box .rsvp-item .info .index[data-v-b208f2a8] {\n          min-width: 30px;\n          text-align: center;\n          margin-right: 3px;\n          font-weight: 600;\n}\n.import-box .rsvp-box .rsvp-item .info .email[data-v-b208f2a8] {\n          margin-left: 5px;\n          font-size: 13px;\n          opacity: .75;\n}\n.import-box .rsvp-box .rsvp-item .action[data-v-b208f2a8] {\n        max-width: 130px;\n        min-width: 50px;\n        float: right;\n        padding: 5px;\n        text-align: center;\n}\n.import-box .rsvp-box .rsvp-item .fa-sync[data-v-b208f2a8] {\n        cursor: pointer;\n}\n.import-box .rsvp-box .rsvp-item .error-msg[data-v-b208f2a8] {\n        background: #fde3e3;\n        color: #f23333;\n        font-style: italic;\n        padding: 2px 5px;\n        font-size: 13px;\n}\n.clearfix[data-v-b208f2a8] {\n  clear: both;\n}\n.p-R-10[data-v-b208f2a8] {\n  padding-right: 10px;\n}\n.p-T-10[data-v-b208f2a8] {\n  padding-top: 10px;\n}\n.data-field[data-v-b208f2a8] {\n  padding: 5px;\n  position: relative;\n}\n.data-field .label[data-v-b208f2a8] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .label.has-error[data-v-b208f2a8] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-b208f2a8] {\n    margin: 1px 0 0;\n    padding: 5px;\n    font-size: 14px;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-b208f2a8] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-b208f2a8]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-b208f2a8] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\nselect[data-v-b208f2a8] {\n  padding: 5px 25px 5px 5px;\n  height: 30px;\n  font-size: 14px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-b208f2a8] {\n    background-color: #ebebe4;\n}\ninput[type=\"file\"][data-v-b208f2a8] {\n  margin-top: 0;\n  padding: 4px;\n  font-size: 14px;\n  background: #fdfdfd;\n}\n.control-box[data-v-b208f2a8] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n}\n.control-box .control[data-v-b208f2a8] {\n    margin: 0 auto;\n    width: 100%;\n    max-width: 800px;\n    border-radius: 4px 4px 0 0;\n    height: 50px;\n    line-height: 50px;\n    font-size: 21px;\n    cursor: pointer;\n    text-align: center;\n    background: #c5d0dc;\n}\n.control-box .control i[data-v-b208f2a8] {\n      margin-right: 4px;\n}\n.slide-up-enter-active[data-v-b208f2a8], .slide-up-leave-active[data-v-b208f2a8] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-b208f2a8], .slide-up-leave-to[data-v-b208f2a8] {\n  -webkit-transform: translateY(30px);\n          transform: translateY(30px);\n  opacity: 0;\n}\n.slide-down-enter-active[data-v-b208f2a8], .slide-down-leave-active[data-v-b208f2a8] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-b208f2a8], .slide-down-leave-to[data-v-b208f2a8] {\n  -webkit-transform: translateY(-30px);\n          transform: translateY(-30px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.small-6[data-v-b208f2a8] {\n    width: 100%;\n}\n.p-T-10[data-v-b208f2a8] {\n    padding-top: 25px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[_vm._v("IMPORT RSVP")]),_vm._v(" "),_c('div',{staticClass:"import-rsvp"},[_c('div',{staticClass:"v-center"},[_c('div',{staticClass:"import-box"},[_c('div',{staticClass:"input-box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns end"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Service Map")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.serviceMapping),expression:"serviceMapping"}],attrs:{"disabled":_vm.brandLoading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.serviceMapping=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Default")]),_vm._v(" "),(_vm.isStaging)?_c('option',{attrs:{"value":"qa-test"}},[_vm._v("QA-Staging")]):_vm._e(),_vm._v(" "),_vm._l((_vm.serviceMappingValues),function(data){return _c('option',{key:data.key,domProps:{"value":data.key}},[_vm._v(_vm._s(data.name))])})],2),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.serviceMapping))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns end"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Source")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.source),expression:"source"}],class:{'input':true, 'has-error':!!_vm.validation.source},attrs:{"type":"text"},domProps:{"value":(_vm.source)},on:{"input":function($event){if($event.target.composing){ return; }_vm.source=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.source))])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns end"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Upload CSV")]),_vm._v(" "),_c('input',{ref:"uploadInput",attrs:{"type":"file"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.fileError))])])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns end p-T-10"},[_c('button',{class:{'button small block':true, 'disabled':_vm.uploading},on:{"click":_vm.upload}},[_vm._v("\n                "+_vm._s(_vm.buttonLabel)+"\n                "),(_vm.uploading)?_c('i',{staticClass:"fas fa-spin fa-spinner"}):_vm._e()])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.rsvps.list.length)?_c('div',{staticClass:"rsvp-box"},_vm._l((_vm.rsvps.list),function(rsvp,index){return _c('div',{key:rsvp.id,class:{
              'rsvp-item': true,
              'success': _vm.rsvpStatus.success.indexOf(rsvp.id) > -1,
              'on-going': _vm.rsvpStatus.onGoing.indexOf(rsvp.id) > -1,
              'failed': _vm.rsvpStatus.failed.indexOf(rsvp.id) > -1
            }},[_c('div',{staticClass:"info"},[_c('span',{staticClass:"index"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(rsvp.data.custFirstName + ' ' + rsvp.data.custLastName))]),_vm._v(" "),_c('span',{staticClass:"email"},[_vm._v(_vm._s(rsvp.data.custEmail))])]),_vm._v(" "),_c('div',{staticClass:"action"},[(_vm.rsvpStatus.success.indexOf(rsvp.id) > -1)?_c('span',[_c('a',{attrs:{"href":'/#/reservation/' + rsvp.rsvpId,"target":"_blank"}},[_vm._v("RSVP #"+_vm._s(rsvp.rsvpId))])]):_vm._e(),_vm._v(" "),(_vm.rsvpStatus.onGoing.indexOf(rsvp.id) > -1)?_c('i',{staticClass:"fas fa-spin fa-spinner"}):_vm._e(),_vm._v(" "),(_vm.rsvpStatus.failed.indexOf(rsvp.id) > -1)?_c('i',{staticClass:"fas fa-sync",on:{"click":function($event){return _vm.createRsvp(rsvp.id, true)}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(!!_vm.errorMessage(rsvp.id))?_c('div',{staticClass:"error-msg"},[_c('span',[_vm._v(_vm._s(_vm.errorMessage(rsvp.id).msg))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.errorMessage(rsvp.id).debug))])]):_vm._e()])}),0):_vm._e()])],1)])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvps.processing.length),expression:"rsvps.processing.length"}],staticClass:"control-box"},[_c('div',{staticClass:"control"},[(_vm.processing)?_c('div',{on:{"click":_vm.pauseProcess}},[_c('i',{staticClass:"fas fa-pause"}),_vm._v(" STOP\n        ")]):_c('div',{on:{"click":_vm.beginCreateRsvp}},[_c('i',{staticClass:"fas fa-play"}),_vm._v(" CONTINUE\n        ")])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns end"},[_c('span',{staticClass:"note"},[_c('b',[_vm._v("Note:")]),_vm._v(" Confirmation Email and SMS will be sent to the consumers contained within the CSV file to be uploaded\n              ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(535);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fae8d5e8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1570);
function injectStyle (ssrContext) {
  __webpack_require__(1535)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fae8d5e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fae8d5e8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1536);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("67f7a18f", content, true, {});

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.m-B-10[data-v-fae8d5e8] {\n  margin-bottom: 10px;\n}\n.p-L-10[data-v-fae8d5e8] {\n  padding-left: 10px;\n}\n.p-R-10[data-v-fae8d5e8] {\n  padding-right: 10px;\n}\n.tooltip[data-v-fae8d5e8] {\n  background-color: red !important;\n}\n.header[data-v-fae8d5e8] {\n  height: 50px;\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 50px;\n  padding-left: 70px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.logs-toggle[data-v-fae8d5e8] {\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 3;\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  text-align: center;\n  color: #777;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  border-radius: 0;\n  background-color: #F25E0D;\n  color: #fff;\n  border-bottom-left-radius: 3px;\n  -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n          box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n  -webkit-transition: .5s ease;\n  transition: .5s ease;\n}\n.logs-toggle i[data-v-fae8d5e8] {\n    line-height: inherit;\n}\n.logs-toggle.on[data-v-fae8d5e8] {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n    -webkit-transition: .5s ease;\n    transition: .5s ease;\n}\n.left-panel[data-v-fae8d5e8] {\n  width: 380px;\n  height: calc(100% - 50px);\n  background: #e8f0fb;\n  position: fixed;\n  top: 50px;\n  left: 0;\n  padding: 10px;\n  overflow: auto;\n}\n.left-panel .brands[data-v-fae8d5e8] {\n    margin-bottom: 30px;\n    border: 1px solid #ddd;\n    padding: 10px;\n    color: #333;\n    height: 45px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.left-panel .brands.has-error[data-v-fae8d5e8] {\n      border-color: #f20d0d;\n}\n.left-panel .brands[data-v-fae8d5e8]:disabled {\n      background-color: #eee;\n}\n.left-panel .servicearea-list[data-v-fae8d5e8] {\n    position: relative;\n    min-height: 50px;\n}\n.left-panel .servicearea-list .loader[data-v-fae8d5e8] {\n      position: absolute;\n      width: 80%;\n      background: #fff;\n      top: 50%;\n      left: 10%;\n      padding: 10px;\n      text-align: center;\n      font-size: 14px;\n      font-style: italic;\n      color: #777;\n      margin-top: -25px;\n      -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);\n              box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);\n      border-radius: 4px;\n}\n.left-panel .servicearea-list .loader i[data-v-fae8d5e8] {\n        color: #0D79F2;\n        margin-right: 4px;\n}\n.left-panel ul[data-v-fae8d5e8] {\n    list-style: none;\n    padding: 0;\n    margin: 6px 0;\n    border: 1px solid #dedede;\n    border-radius: 2px;\n    overflow: hidden;\n    -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n            box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n}\n.left-panel ul.disabled[data-v-fae8d5e8] {\n      opacity: .3;\n}\n.left-panel ul li[data-v-fae8d5e8] {\n      background: #fff;\n      padding: 10px;\n      font-size: 13px;\n      border-bottom: 1px solid #dedede;\n      font-weight: 600;\n      cursor: pointer;\n}\n.left-panel ul li[data-v-fae8d5e8]:last-child {\n        border-bottom: none;\n}\n.left-panel ul li[data-v-fae8d5e8]:hover {\n        background: #fafafa;\n}\n.left-panel ul li.active[data-v-fae8d5e8] {\n        background: #f0f9ff;\n        -webkit-box-shadow: 0 0 0 3px #2f8cc7 inset;\n                box-shadow: 0 0 0 3px #2f8cc7 inset;\n}\n.left-panel ul li i[data-v-fae8d5e8] {\n        margin-right: 5px;\n        color: #acb6c3;\n}\n.left-panel ul li .color[data-v-fae8d5e8] {\n        display: inline-block;\n        width: 10px;\n        height: 10px;\n        border: 1px solid #777;\n        margin-right: 5px;\n}\n.fixed-bottom-left[data-v-fae8d5e8] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  background: #e8f0fb;\n  padding: 10px;\n  height: 50px;\n  width: 380px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.fixed-bottom-left .prev-next[data-v-fae8d5e8] {\n    background: #fafafa;\n    height: 30px;\n    width: 30px;\n    line-height: 30px;\n    text-align: center;\n    display: inline-block;\n    border: 1px solid #bbb;\n    border-radius: 3px;\n    cursor: pointer;\n}\n.fixed-bottom-left .prev-next.disabled[data-v-fae8d5e8] {\n      opacity: .4;\n      cursor: default;\n}\n.fixed-bottom-left select[data-v-fae8d5e8] {\n    margin: 0 5px;\n    border: 1px solid #ddd;\n    padding: 5px 10px;\n    color: #333;\n    height: 30px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.fixed-bottom-left select.has-error[data-v-fae8d5e8] {\n      border-color: #f20d0d;\n}\n.fixed-bottom-left select[data-v-fae8d5e8]:disabled {\n      background-color: #eee;\n}\n.data-field[data-v-fae8d5e8] {\n  padding: 0;\n  position: relative;\n}\n.data-field.no-label[data-v-fae8d5e8] {\n    padding-top: 24px;\n}\n.data-field input[type='checkbox'][data-v-fae8d5e8] {\n    width: inherit;\n    display: inline-block;\n    margin: 0 3px 0 0;\n}\n.data-field .label[data-v-fae8d5e8] {\n    color: #0D79F2;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .label.bigger[data-v-fae8d5e8] {\n      font-size: 14px;\n}\n.data-field .label input[type='checkbox'][data-v-fae8d5e8] {\n      vertical-align: -2px;\n}\n.data-field .input[data-v-fae8d5e8] {\n    margin: 3px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-fae8d5e8] {\n      border-color: #f20d0d;\n}\n.right-panel[data-v-fae8d5e8] {\n  width: calc(100% - (380px));\n  height: calc(100% - 50px);\n  position: fixed;\n  top: 50px;\n  left: 380px;\n  background: #f4f9ff;\n  padding: 70px 20px 50px;\n  overflow: auto;\n}\n.right-panel .tabs[data-v-fae8d5e8] {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    height: 50px;\n    background: #fff;\n    position: absolute;\n    top: 0;\n    left: 0;\n    padding: 10px 10px 0;\n    border-bottom: 1px solid #b0c6e4;\n}\n.right-panel .tabs li[data-v-fae8d5e8] {\n      display: inline-block;\n      height: 40px;\n      line-height: 40px;\n      border: 1px solid #b0c6e4;\n      padding: 0 15px;\n      margin-right: 5px;\n      cursor: pointer;\n}\n.right-panel .tabs li.active[data-v-fae8d5e8] {\n        background: #f4f9ff;\n        border-bottom: 1px solid #f4f9ff;\n}\n.right-panel .tabs li.disabled[data-v-fae8d5e8] {\n        opacity: .4;\n        background-color: #ddd;\n        cursor: not-allowed;\n}\n.right-panel .box[data-v-fae8d5e8] {\n    background: #fff;\n    border-radius: 2px;\n    border: 1px solid #b0c6e4;\n    padding: 15px;\n    -webkit-box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n            box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n}\n.global-notes[data-v-fae8d5e8] {\n  font-size: 14px;\n  color: #333;\n  font-style: italic;\n  font-weight: 600;\n}\n.is-mtech-label[data-v-fae8d5e8] {\n  padding: 10px 0;\n  font-size: 18px;\n  font-family: 'Work Sans';\n  font-weight: 600;\n  font-style: italic;\n  color: #777;\n}\n.op--modal-container[data-v-fae8d5e8] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-fae8d5e8] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-fae8d5e8] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-fae8d5e8] {\n  display: table-cell;\n  vertical-align: middle;\n  text-align: center;\n}\n.op--modal-content .response-box[data-v-fae8d5e8] {\n    text-align: center;\n    margin-bottom: 40px;\n    background-color: #fff;\n    border-radius: 4px;\n    width: 100%;\n    max-width: 400px;\n    margin: 0 auto;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    position: relative;\n    padding: 20px;\n}\n.op--modal-content .response-box .success[data-v-fae8d5e8] {\n      color: #26D97A;\n}\n.op--modal-content .response-box .error[data-v-fae8d5e8] {\n      color: #F20D0D;\n}\n.op--modal-content .response-box .message[data-v-fae8d5e8] {\n      display: block;\n      margin-top: 10px;\n      font-size: 15px;\n      font-weight: 600;\n}\n.op--modal-content .response-box .extra[data-v-fae8d5e8] {\n      border: 1px solid #f20d0d;\n      background: #ffefef;\n      border-radius: 4px;\n      color: #000;\n      padding: 5px;\n      font-style: italic;\n      font-size: 13px;\n      display: block;\n      margin-top: 10px;\n}\n.op--modal-content .response-box .button[data-v-fae8d5e8] {\n      margin-top: 25px;\n}\n.global-modal-box[data-v-fae8d5e8] {\n  background-color: #fff;\n  width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  position: relative;\n  padding: 20px;\n  border-radius: 2px;\n  font-size: 14px;\n  color: #444;\n}\n.global-modal-box .check-all[data-v-fae8d5e8] {\n    text-align: left;\n    display: block;\n    margin: 0 10px;\n    padding: 0 5px;\n    font-size: 13px;\n    cursor: pointer;\n}\n.global-modal-box .check-all input[data-v-fae8d5e8] {\n      display: inline-block;\n      width: inherit;\n      vertical-align: -2px;\n      margin: 0 5px 0 0;\n}\n.global-modal-box ul[data-v-fae8d5e8] {\n    list-style: none;\n    text-align: left;\n    margin: 5px 10px 15px;\n    padding: 0;\n    border: 1px solid #ccc;\n    max-height: 300px;\n    overflow: auto;\n}\n.global-modal-box ul li[data-v-fae8d5e8] {\n      border-bottom: 1px solid #eee;\n}\n.global-modal-box ul li[data-v-fae8d5e8]:last-child {\n        border-bottom: none;\n}\n.global-modal-box ul li[data-v-fae8d5e8]:nth-child(odd) {\n        background: #fafafa;\n}\n.global-modal-box ul li[data-v-fae8d5e8]:hover {\n        background: #eaeaea;\n}\n.global-modal-box ul li label[data-v-fae8d5e8] {\n        padding: 5px;\n        display: block;\n        cursor: pointer;\n}\n.global-modal-box ul input[data-v-fae8d5e8] {\n      display: inline-block;\n      width: inherit;\n      margin: 0 5px 0 0;\n}\n.global-modal-box .global-error[data-v-fae8d5e8] {\n    font-size: 13px;\n    background: #ffeaea;\n    padding: 5px;\n    color: #f25757;\n    border: 1px solid #f25757;\n    line-height: 1.25;\n    margin: 0 10px 15px;\n}\n.fixed-bottom-right[data-v-fae8d5e8] {\n  height: 50px;\n  width: calc(100% - (380px));\n  left: 380px;\n  bottom: 0;\n  position: fixed;\n  background: #fff;\n  border-top: 1px solid #b0c6e4;\n  text-align: center;\n  padding: 5px 0;\n  -webkit-box-shadow: 0 -2px 3px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 -2px 3px rgba(0, 0, 0, 0.1);\n  z-index: 3;\n}\n.fixed-bottom-right .button[data-v-fae8d5e8] {\n    text-transform: uppercase;\n    margin: 0 5px;\n    min-width: 160px;\n}\n.fixed-bottom-right .button i[data-v-fae8d5e8] {\n      margin-right: 7px;\n}\n.slide-up-enter-active[data-v-fae8d5e8], .slide-up-leave-active[data-v-fae8d5e8] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-fae8d5e8], .slide-up-leave-to[data-v-fae8d5e8] {\n  -webkit-transform: translateY(20px);\n          transform: translateY(20px);\n  opacity: 0;\n}\n.fade-right-enter-active[data-v-fae8d5e8], .fade-right-leave-active[data-v-fae8d5e8] {\n  -webkit-transition: all .15s ease;\n  transition: all .15s ease;\n}\n.fade-right-enter[data-v-fae8d5e8], .fade-right-leave-to[data-v-fae8d5e8] {\n  -webkit-transform: translateX(15px);\n          transform: translateX(15px);\n  opacity: 0;\n}\n.toggle-mobile[data-v-fae8d5e8] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.pricing[data-v-fae8d5e8] {\n    font-size: 16px;\n    font-size: 3.6vw;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.pricing .color[data-v-fae8d5e8] {\n      display: inline-block;\n      width: 12px;\n      height: 12px;\n      border: 1px solid #777;\n      margin-right: 5px;\n}\n.pricing .name[data-v-fae8d5e8] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n}\n.left-panel[data-v-fae8d5e8] {\n    width: 100%;\n    padding: 20px;\n    padding-bottom: 70px;\n}\n.left-panel .brands[data-v-fae8d5e8] {\n      margin-bottom: 15px;\n}\n.right-panel[data-v-fae8d5e8] {\n    width: 100%;\n    padding: 0;\n    height: 0;\n}\n.right-panel.open-panel[data-v-fae8d5e8] {\n      position: sticky;\n      padding: 0 10px 120px;\n      height: 100vh;\n}\n.right-panel.open-panel .back[data-v-fae8d5e8] {\n        padding: 15px 0;\n        text-transform: uppercase;\n        font-size: 14px;\n        font-weight: 900;\n        color: #777;\n}\n.right-panel .tabs[data-v-fae8d5e8] {\n      display: none;\n}\n.toggle-mobile[data-v-fae8d5e8] {\n    display: block;\n    cursor: pointer;\n    position: fixed;\n    bottom: 40px;\n    left: 0;\n    width: 100%;\n    padding: 8px 0;\n    height: 50px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.toggle-mobile .tabs[data-v-fae8d5e8] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n      list-style: none;\n      margin: 0;\n      padding: 0;\n      width: 100%;\n      height: 90px;\n      background: #fff;\n      position: absolute;\n      top: 0;\n      left: 0;\n      border: 1px solid #b0c6e4;\n      font-size: 12px;\n      display: flex;\n      justify-content: space-between;\n}\n.toggle-mobile .tabs li[data-v-fae8d5e8] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: left;\n            -ms-flex-pack: left;\n                justify-content: left;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        border-right: 1px solid #b0c6e4;\n        border-bottom: 1px solid #b0c6e4;\n        padding: 0 20px;\n        cursor: pointer;\n        width: 50%;\n        height: 30px;\n}\n.toggle-mobile .tabs li.active[data-v-fae8d5e8] {\n          background: #cce1f9;\n}\n.toggle-mobile .tabs li.disabled[data-v-fae8d5e8] {\n          opacity: .4;\n          background-color: #ddd;\n          cursor: not-allowed;\n}\n.fixed-bottom-right[data-v-fae8d5e8] {\n    left: 0;\n    width: 100%;\n    bottom: 90px;\n    height: auto;\n    padding: 10px 0;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Pricing/index.vue"],"names":[],"mappings":";AACA;EACE,oBAAoB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;CAC9C;AACD;EACE,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;EACjB,0BAA0B;EAC1B,YAAY;EACZ,+BAA+B;EAC/B,mDAAmD;UAC3C,2CAA2C;EACnD,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,6BAA6B;EAC7B,qBAAqB;CACtB;AACD;IACI,qBAAqB;CACxB;AACD;IACI,gCAAgC;IAChC,wBAAwB;IACxB,6BAA6B;IAC7B,qBAAqB;CACxB;AACD;EACE,aAAa;EACb,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,cAAc;EACd,eAAe;CAChB;AACD;IACI,oBAAoB;IACpB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,wDAAwD;IACxD,6BAA6B;IAC7B,+BAA+B;IAC/B,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,uBAAuB;CAC5B;AACD;IACI,mBAAmB;IACnB,iBAAiB;CACpB;AACD;MACM,mBAAmB;MACnB,WAAW;MACX,iBAAiB;MACjB,SAAS;MACT,UAAU;MACV,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;MACnB,YAAY;MACZ,kBAAkB;MAClB,+CAA+C;cACvC,uCAAuC;MAC/C,mBAAmB;CACxB;AACD;QACQ,eAAe;QACf,kBAAkB;CACzB;AACD;IACI,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,0BAA0B;IAC1B,mBAAmB;IACnB,iBAAiB;IACjB,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;MACM,YAAY;CACjB;AACD;MACM,iBAAiB;MACjB,cAAc;MACd,gBAAgB;MAChB,iCAAiC;MACjC,iBAAiB;MACjB,gBAAgB;CACrB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,oBAAoB;QACpB,4CAA4C;gBACpC,oCAAoC;CACnD;AACD;QACQ,kBAAkB;QAClB,eAAe;CACtB;AACD;QACQ,sBAAsB;QACtB,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,kBAAkB;CACzB;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,oBAAoB;IACpB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;CACnB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;IACI,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,wDAAwD;IACxD,6BAA6B;IAC7B,+BAA+B;IAC/B,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,uBAAuB;CAC5B;AACD;EACE,WAAW;EACX,mBAAmB;CACpB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,eAAe;IACf,sBAAsB;IACtB,kBAAkB;CACrB;AACD;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,qBAAqB;CAC1B;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;CAChB;AACD;IACI,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,qBAAqB;IACrB,iCAAiC;CACpC;AACD;MACM,sBAAsB;MACtB,aAAa;MACb,kBAAkB;MAClB,0BAA0B;MAC1B,gBAAgB;MAChB,kBAAkB;MAClB,gBAAgB;CACrB;AACD;QACQ,oBAAoB;QACpB,iCAAiC;CACxC;AACD;QACQ,YAAY;QACZ,uBAAuB;QACvB,oBAAoB;CAC3B;AACD;IACI,iBAAiB;IACjB,mBAAmB;IACnB,0BAA0B;IAC1B,cAAc;IACd,kDAAkD;YAC1C,0CAA0C;CACrD;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;CAClB;AACD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,iDAAiD;YACzC,yCAAyC;IACjD,mBAAmB;IACnB,cAAc;CACjB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,iBAAiB;CACtB;AACD;MACM,0BAA0B;MAC1B,oBAAoB;MACpB,mBAAmB;MACnB,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,gBAAgB;MAChB,eAAe;MACf,iBAAiB;CACtB;AACD;MACM,iBAAiB;CACtB;AACD;EACE,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,iDAAiD;UACzC,yCAAyC;EACjD,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;CACb;AACD;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;CACnB;AACD;MACM,sBAAsB;MACtB,eAAe;MACf,qBAAqB;MACrB,kBAAkB;CACvB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;CAClB;AACD;MACM,8BAA8B;CACnC;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,aAAa;QACb,eAAe;QACf,gBAAgB;CACvB;AACD;MACM,sBAAsB;MACtB,eAAe;MACf,kBAAkB;CACvB;AACD;IACI,gBAAgB;IAChB,oBAAoB;IACpB,aAAa;IACb,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;IAClB,oBAAoB;CACvB;AACD;EACE,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,WAAW;CACZ;AACD;IACI,0BAA0B;IAC1B,cAAc;IACd,iBAAiB;CACpB;AACD;MACM,kBAAkB;CACvB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;EACE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;EACE,cAAc;CACf;AACD;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;CAC/B;AACD;MACM,sBAAsB;MACtB,YAAY;MACZ,aAAa;MACb,uBAAuB;MACvB,kBAAkB;CACvB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,wBAAwB;MACxB,oBAAoB;MACpB,iBAAiB;CACtB;AACD;IACI,YAAY;IACZ,cAAc;IACd,qBAAqB;CACxB;AACD;MACM,oBAAoB;CACzB;AACD;IACI,YAAY;IACZ,WAAW;IACX,UAAU;CACb;AACD;MACM,iBAAiB;MACjB,sBAAsB;MACtB,cAAc;CACnB;AACD;QACQ,gBAAgB;QAChB,0BAA0B;QAC1B,gBAAgB;QAChB,iBAAiB;QACjB,YAAY;CACnB;AACD;MACM,cAAc;CACnB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;IACrB,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;CACpB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,oBAAoB;UAChB,gBAAgB;MACpB,iBAAiB;MACjB,UAAU;MACV,WAAW;MACX,YAAY;MACZ,aAAa;MACb,iBAAiB;MACjB,mBAAmB;MACnB,OAAO;MACP,QAAQ;MACR,0BAA0B;MAC1B,gBAAgB;MAChB,cAAc;MACd,+BAA+B;CACpC;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,uBAAuB;YACnB,oBAAoB;gBAChB,sBAAsB;QAC9B,0BAA0B;YACtB,uBAAuB;gBACnB,oBAAoB;QAC5B,gCAAgC;QAChC,iCAAiC;QACjC,gBAAgB;QAChB,gBAAgB;QAChB,WAAW;QACX,aAAa;CACpB;AACD;UACU,oBAAoB;CAC7B;AACD;UACU,YAAY;UACZ,uBAAuB;UACvB,oBAAoB;CAC7B;AACD;IACI,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,aAAa;IACb,gBAAgB;CACnB;CACA","file":"index.vue","sourcesContent":["\n.m-B-10[data-v-fae8d5e8] {\n  margin-bottom: 10px;\n}\n.p-L-10[data-v-fae8d5e8] {\n  padding-left: 10px;\n}\n.p-R-10[data-v-fae8d5e8] {\n  padding-right: 10px;\n}\n.tooltip[data-v-fae8d5e8] {\n  background-color: red !important;\n}\n.header[data-v-fae8d5e8] {\n  height: 50px;\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 50px;\n  padding-left: 70px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.logs-toggle[data-v-fae8d5e8] {\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 3;\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  text-align: center;\n  color: #777;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  border-radius: 0;\n  background-color: #F25E0D;\n  color: #fff;\n  border-bottom-left-radius: 3px;\n  -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n          box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n  -webkit-transition: .5s ease;\n  transition: .5s ease;\n}\n.logs-toggle i[data-v-fae8d5e8] {\n    line-height: inherit;\n}\n.logs-toggle.on[data-v-fae8d5e8] {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n    -webkit-transition: .5s ease;\n    transition: .5s ease;\n}\n.left-panel[data-v-fae8d5e8] {\n  width: 380px;\n  height: calc(100% - 50px);\n  background: #e8f0fb;\n  position: fixed;\n  top: 50px;\n  left: 0;\n  padding: 10px;\n  overflow: auto;\n}\n.left-panel .brands[data-v-fae8d5e8] {\n    margin-bottom: 30px;\n    border: 1px solid #ddd;\n    padding: 10px;\n    color: #333;\n    height: 45px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.left-panel .brands.has-error[data-v-fae8d5e8] {\n      border-color: #f20d0d;\n}\n.left-panel .brands[data-v-fae8d5e8]:disabled {\n      background-color: #eee;\n}\n.left-panel .servicearea-list[data-v-fae8d5e8] {\n    position: relative;\n    min-height: 50px;\n}\n.left-panel .servicearea-list .loader[data-v-fae8d5e8] {\n      position: absolute;\n      width: 80%;\n      background: #fff;\n      top: 50%;\n      left: 10%;\n      padding: 10px;\n      text-align: center;\n      font-size: 14px;\n      font-style: italic;\n      color: #777;\n      margin-top: -25px;\n      -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);\n              box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);\n      border-radius: 4px;\n}\n.left-panel .servicearea-list .loader i[data-v-fae8d5e8] {\n        color: #0D79F2;\n        margin-right: 4px;\n}\n.left-panel ul[data-v-fae8d5e8] {\n    list-style: none;\n    padding: 0;\n    margin: 6px 0;\n    border: 1px solid #dedede;\n    border-radius: 2px;\n    overflow: hidden;\n    -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n            box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n}\n.left-panel ul.disabled[data-v-fae8d5e8] {\n      opacity: .3;\n}\n.left-panel ul li[data-v-fae8d5e8] {\n      background: #fff;\n      padding: 10px;\n      font-size: 13px;\n      border-bottom: 1px solid #dedede;\n      font-weight: 600;\n      cursor: pointer;\n}\n.left-panel ul li[data-v-fae8d5e8]:last-child {\n        border-bottom: none;\n}\n.left-panel ul li[data-v-fae8d5e8]:hover {\n        background: #fafafa;\n}\n.left-panel ul li.active[data-v-fae8d5e8] {\n        background: #f0f9ff;\n        -webkit-box-shadow: 0 0 0 3px #2f8cc7 inset;\n                box-shadow: 0 0 0 3px #2f8cc7 inset;\n}\n.left-panel ul li i[data-v-fae8d5e8] {\n        margin-right: 5px;\n        color: #acb6c3;\n}\n.left-panel ul li .color[data-v-fae8d5e8] {\n        display: inline-block;\n        width: 10px;\n        height: 10px;\n        border: 1px solid #777;\n        margin-right: 5px;\n}\n.fixed-bottom-left[data-v-fae8d5e8] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  background: #e8f0fb;\n  padding: 10px;\n  height: 50px;\n  width: 380px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.fixed-bottom-left .prev-next[data-v-fae8d5e8] {\n    background: #fafafa;\n    height: 30px;\n    width: 30px;\n    line-height: 30px;\n    text-align: center;\n    display: inline-block;\n    border: 1px solid #bbb;\n    border-radius: 3px;\n    cursor: pointer;\n}\n.fixed-bottom-left .prev-next.disabled[data-v-fae8d5e8] {\n      opacity: .4;\n      cursor: default;\n}\n.fixed-bottom-left select[data-v-fae8d5e8] {\n    margin: 0 5px;\n    border: 1px solid #ddd;\n    padding: 5px 10px;\n    color: #333;\n    height: 30px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.fixed-bottom-left select.has-error[data-v-fae8d5e8] {\n      border-color: #f20d0d;\n}\n.fixed-bottom-left select[data-v-fae8d5e8]:disabled {\n      background-color: #eee;\n}\n.data-field[data-v-fae8d5e8] {\n  padding: 0;\n  position: relative;\n}\n.data-field.no-label[data-v-fae8d5e8] {\n    padding-top: 24px;\n}\n.data-field input[type='checkbox'][data-v-fae8d5e8] {\n    width: inherit;\n    display: inline-block;\n    margin: 0 3px 0 0;\n}\n.data-field .label[data-v-fae8d5e8] {\n    color: #0D79F2;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .label.bigger[data-v-fae8d5e8] {\n      font-size: 14px;\n}\n.data-field .label input[type='checkbox'][data-v-fae8d5e8] {\n      vertical-align: -2px;\n}\n.data-field .input[data-v-fae8d5e8] {\n    margin: 3px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-fae8d5e8] {\n      border-color: #f20d0d;\n}\n.right-panel[data-v-fae8d5e8] {\n  width: calc(100% - (380px));\n  height: calc(100% - 50px);\n  position: fixed;\n  top: 50px;\n  left: 380px;\n  background: #f4f9ff;\n  padding: 70px 20px 50px;\n  overflow: auto;\n}\n.right-panel .tabs[data-v-fae8d5e8] {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    height: 50px;\n    background: #fff;\n    position: absolute;\n    top: 0;\n    left: 0;\n    padding: 10px 10px 0;\n    border-bottom: 1px solid #b0c6e4;\n}\n.right-panel .tabs li[data-v-fae8d5e8] {\n      display: inline-block;\n      height: 40px;\n      line-height: 40px;\n      border: 1px solid #b0c6e4;\n      padding: 0 15px;\n      margin-right: 5px;\n      cursor: pointer;\n}\n.right-panel .tabs li.active[data-v-fae8d5e8] {\n        background: #f4f9ff;\n        border-bottom: 1px solid #f4f9ff;\n}\n.right-panel .tabs li.disabled[data-v-fae8d5e8] {\n        opacity: .4;\n        background-color: #ddd;\n        cursor: not-allowed;\n}\n.right-panel .box[data-v-fae8d5e8] {\n    background: #fff;\n    border-radius: 2px;\n    border: 1px solid #b0c6e4;\n    padding: 15px;\n    -webkit-box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n            box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n}\n.global-notes[data-v-fae8d5e8] {\n  font-size: 14px;\n  color: #333;\n  font-style: italic;\n  font-weight: 600;\n}\n.is-mtech-label[data-v-fae8d5e8] {\n  padding: 10px 0;\n  font-size: 18px;\n  font-family: 'Work Sans';\n  font-weight: 600;\n  font-style: italic;\n  color: #777;\n}\n.op--modal-container[data-v-fae8d5e8] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-fae8d5e8] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-fae8d5e8] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-fae8d5e8] {\n  display: table-cell;\n  vertical-align: middle;\n  text-align: center;\n}\n.op--modal-content .response-box[data-v-fae8d5e8] {\n    text-align: center;\n    margin-bottom: 40px;\n    background-color: #fff;\n    border-radius: 4px;\n    width: 100%;\n    max-width: 400px;\n    margin: 0 auto;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    position: relative;\n    padding: 20px;\n}\n.op--modal-content .response-box .success[data-v-fae8d5e8] {\n      color: #26D97A;\n}\n.op--modal-content .response-box .error[data-v-fae8d5e8] {\n      color: #F20D0D;\n}\n.op--modal-content .response-box .message[data-v-fae8d5e8] {\n      display: block;\n      margin-top: 10px;\n      font-size: 15px;\n      font-weight: 600;\n}\n.op--modal-content .response-box .extra[data-v-fae8d5e8] {\n      border: 1px solid #f20d0d;\n      background: #ffefef;\n      border-radius: 4px;\n      color: #000;\n      padding: 5px;\n      font-style: italic;\n      font-size: 13px;\n      display: block;\n      margin-top: 10px;\n}\n.op--modal-content .response-box .button[data-v-fae8d5e8] {\n      margin-top: 25px;\n}\n.global-modal-box[data-v-fae8d5e8] {\n  background-color: #fff;\n  width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  position: relative;\n  padding: 20px;\n  border-radius: 2px;\n  font-size: 14px;\n  color: #444;\n}\n.global-modal-box .check-all[data-v-fae8d5e8] {\n    text-align: left;\n    display: block;\n    margin: 0 10px;\n    padding: 0 5px;\n    font-size: 13px;\n    cursor: pointer;\n}\n.global-modal-box .check-all input[data-v-fae8d5e8] {\n      display: inline-block;\n      width: inherit;\n      vertical-align: -2px;\n      margin: 0 5px 0 0;\n}\n.global-modal-box ul[data-v-fae8d5e8] {\n    list-style: none;\n    text-align: left;\n    margin: 5px 10px 15px;\n    padding: 0;\n    border: 1px solid #ccc;\n    max-height: 300px;\n    overflow: auto;\n}\n.global-modal-box ul li[data-v-fae8d5e8] {\n      border-bottom: 1px solid #eee;\n}\n.global-modal-box ul li[data-v-fae8d5e8]:last-child {\n        border-bottom: none;\n}\n.global-modal-box ul li[data-v-fae8d5e8]:nth-child(odd) {\n        background: #fafafa;\n}\n.global-modal-box ul li[data-v-fae8d5e8]:hover {\n        background: #eaeaea;\n}\n.global-modal-box ul li label[data-v-fae8d5e8] {\n        padding: 5px;\n        display: block;\n        cursor: pointer;\n}\n.global-modal-box ul input[data-v-fae8d5e8] {\n      display: inline-block;\n      width: inherit;\n      margin: 0 5px 0 0;\n}\n.global-modal-box .global-error[data-v-fae8d5e8] {\n    font-size: 13px;\n    background: #ffeaea;\n    padding: 5px;\n    color: #f25757;\n    border: 1px solid #f25757;\n    line-height: 1.25;\n    margin: 0 10px 15px;\n}\n.fixed-bottom-right[data-v-fae8d5e8] {\n  height: 50px;\n  width: calc(100% - (380px));\n  left: 380px;\n  bottom: 0;\n  position: fixed;\n  background: #fff;\n  border-top: 1px solid #b0c6e4;\n  text-align: center;\n  padding: 5px 0;\n  -webkit-box-shadow: 0 -2px 3px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 -2px 3px rgba(0, 0, 0, 0.1);\n  z-index: 3;\n}\n.fixed-bottom-right .button[data-v-fae8d5e8] {\n    text-transform: uppercase;\n    margin: 0 5px;\n    min-width: 160px;\n}\n.fixed-bottom-right .button i[data-v-fae8d5e8] {\n      margin-right: 7px;\n}\n.slide-up-enter-active[data-v-fae8d5e8], .slide-up-leave-active[data-v-fae8d5e8] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-fae8d5e8], .slide-up-leave-to[data-v-fae8d5e8] {\n  -webkit-transform: translateY(20px);\n          transform: translateY(20px);\n  opacity: 0;\n}\n.fade-right-enter-active[data-v-fae8d5e8], .fade-right-leave-active[data-v-fae8d5e8] {\n  -webkit-transition: all .15s ease;\n  transition: all .15s ease;\n}\n.fade-right-enter[data-v-fae8d5e8], .fade-right-leave-to[data-v-fae8d5e8] {\n  -webkit-transform: translateX(15px);\n          transform: translateX(15px);\n  opacity: 0;\n}\n.toggle-mobile[data-v-fae8d5e8] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.pricing[data-v-fae8d5e8] {\n    font-size: 16px;\n    font-size: 3.6vw;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.pricing .color[data-v-fae8d5e8] {\n      display: inline-block;\n      width: 12px;\n      height: 12px;\n      border: 1px solid #777;\n      margin-right: 5px;\n}\n.pricing .name[data-v-fae8d5e8] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n}\n.left-panel[data-v-fae8d5e8] {\n    width: 100%;\n    padding: 20px;\n    padding-bottom: 70px;\n}\n.left-panel .brands[data-v-fae8d5e8] {\n      margin-bottom: 15px;\n}\n.right-panel[data-v-fae8d5e8] {\n    width: 100%;\n    padding: 0;\n    height: 0;\n}\n.right-panel.open-panel[data-v-fae8d5e8] {\n      position: sticky;\n      padding: 0 10px 120px;\n      height: 100vh;\n}\n.right-panel.open-panel .back[data-v-fae8d5e8] {\n        padding: 15px 0;\n        text-transform: uppercase;\n        font-size: 14px;\n        font-weight: 900;\n        color: #777;\n}\n.right-panel .tabs[data-v-fae8d5e8] {\n      display: none;\n}\n.toggle-mobile[data-v-fae8d5e8] {\n    display: block;\n    cursor: pointer;\n    position: fixed;\n    bottom: 40px;\n    left: 0;\n    width: 100%;\n    padding: 8px 0;\n    height: 50px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.toggle-mobile .tabs[data-v-fae8d5e8] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n      list-style: none;\n      margin: 0;\n      padding: 0;\n      width: 100%;\n      height: 90px;\n      background: #fff;\n      position: absolute;\n      top: 0;\n      left: 0;\n      border: 1px solid #b0c6e4;\n      font-size: 12px;\n      display: flex;\n      justify-content: space-between;\n}\n.toggle-mobile .tabs li[data-v-fae8d5e8] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: left;\n            -ms-flex-pack: left;\n                justify-content: left;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        border-right: 1px solid #b0c6e4;\n        border-bottom: 1px solid #b0c6e4;\n        padding: 0 20px;\n        cursor: pointer;\n        width: 50%;\n        height: 30px;\n}\n.toggle-mobile .tabs li.active[data-v-fae8d5e8] {\n          background: #cce1f9;\n}\n.toggle-mobile .tabs li.disabled[data-v-fae8d5e8] {\n          opacity: .4;\n          background-color: #ddd;\n          cursor: not-allowed;\n}\n.fixed-bottom-right[data-v-fae8d5e8] {\n    left: 0;\n    width: 100%;\n    bottom: 90px;\n    height: auto;\n    padding: 10px 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Services_vue__ = __webpack_require__(536);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f572690_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Services_vue__ = __webpack_require__(1549);
function injectStyle (ssrContext) {
  __webpack_require__(1538)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f572690"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Services_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f572690_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Services_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1539);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("f3bca984", content, true, {});

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.box[data-v-2f572690] {\n  background: #fff;\n  border-radius: 2px;\n  border: 1px solid #b0c6e4;\n  padding: 15px;\n  -webkit-box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n          box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n  margin-bottom: 20px;\n}\n.box label[data-v-2f572690] {\n    font-weight: 600;\n    font-size: 18px;\n    margin-bottom: 5px;\n    display: block;\n    color: #333;\n}\ntable[data-v-2f572690] {\n  background: #fff;\n  width: 100%;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  border-radius: 3px;\n  text-align: left;\n  border-spacing: 0;\n}\ntable thead th[data-v-2f572690] {\n    padding: 5px;\n    font-size: 14px;\n    color: #0D79F2;\n    border-bottom: 1px solid #ddd;\n    border-right: 1px solid #eee;\n}\ntable thead th[data-v-2f572690]:last-child {\n      border-right: none;\n}\ntable thead th.enable[data-v-2f572690] {\n      width: 90px;\n}\ntable tbody tr[data-v-2f572690]:nth-child(odd) {\n    background: #fafafa;\n}\ntable tbody tr:hover td[data-v-2f572690] {\n    background: #f1f1f1;\n}\ntable tbody td[data-v-2f572690] {\n    padding: 5px 7px;\n    font-size: 14px;\n    border-right: 1px solid #eee;\n    border-bottom: 1px solid #eee;\n}\ntable tbody td.license-type[data-v-2f572690] {\n      width: 200px;\n}\ntable tbody td[data-v-2f572690]:last-child {\n      border-right: none;\n}\ntable tbody .action[data-v-2f572690] {\n    width: 240px;\n}\ntable tbody span.license-type[data-v-2f572690] {\n    display: inline-block;\n    color: #fff;\n    padding: 3px 5px;\n    margin: 0 5px;\n    min-width: 50px;\n    border-radius: 3px;\n    text-transform: uppercase;\n    font-weight: 700;\n    text-align: center;\n}\ntable tbody span.license-type.tnc[data-v-2f572690] {\n      background-color: #2ab77c;\n}\ntable tbody span.license-type.tcp[data-v-2f572690] {\n      background-color: #3f81a0;\n}\ntable tbody span.license-type.psc[data-v-2f572690] {\n      background-color: #de6c2a;\n}\ntable tbody .pax-luggage[data-v-2f572690] {\n    width: 120px;\n}\ntable tbody .active[data-v-2f572690] {\n    width: 80px;\n}\ntable tbody .edit[data-v-2f572690] {\n    width: 100px;\n}\ntable .action[data-v-2f572690], table .enable[data-v-2f572690], table .active[data-v-2f572690], table .edit[data-v-2f572690], table .license-type[data-v-2f572690], table .pax-luggage[data-v-2f572690] {\n    text-align: center;\n}\n.button.default[data-v-2f572690] {\n  background: #fff;\n  color: #333 !important;\n  border-bottom: 4px solid #ccc;\n  -webkit-box-shadow: 0 0 0 1px #ccc;\n          box-shadow: 0 0 0 1px #ccc;\n}\n.switch[data-v-2f572690] {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n}\n.switch .slider[data-v-2f572690] {\n    position: relative;\n    display: inline-block;\n    width: 50px;\n    height: 30px;\n    border-radius: 20px;\n    background: #ccc;\n    position: relative;\n    cursor: pointer;\n    -webkit-transition: all .25s ease-in-out;\n    transition: all .25s ease-in-out;\n}\n.switch .slider.disabled[data-v-2f572690] {\n      opacity: .4;\n      cursor: not-allowed;\n}\n.switch .slider[data-v-2f572690]:before {\n      content: '';\n      position: absolute;\n      top: 4px;\n      left: 4px;\n      width: 22px;\n      height: 22px;\n      border-radius: 50%;\n      background: #fff;\n      -webkit-transition: all .25s ease-in-out;\n      transition: all .25s ease-in-out;\n      -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n}\n.switch .slider.active[data-v-2f572690] {\n      background: #57d1b7;\n}\n.switch .slider.active[data-v-2f572690]:before {\n        left: 24px;\n}\n.switch .label[data-v-2f572690] {\n    display: inline-block;\n    vertical-align: 10px;\n    margin-left: 5px;\n    font-size: 14px;\n    color: #555;\n    text-transform: uppercase;\n}\n@media only screen and (max-width: 430px) {\n.cards .card[data-v-2f572690] {\n    border: 1px solid #ccc;\n    margin: 0 10px;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-weight: 700;\n}\n.cards .card > div[data-v-2f572690] {\n      margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-2f572690] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .card-header .name[data-v-2f572690] {\n        font-weight: 900;\n}\n.cards .card .card-header .amount[data-v-2f572690] {\n        margin-left: 5px;\n        font-size: 14px;\n}\n.cards .card .card-header .status[data-v-2f572690] {\n        text-transform: uppercase;\n        font-size: 12px;\n        font-weight: 900;\n}\n.cards .card span.license-type[data-v-2f572690] {\n      display: inline-block;\n      color: #fff;\n      padding: 3px 5px;\n      margin: 0 5px;\n      margin-right: 0;\n      min-width: 50px;\n      border-radius: 3px;\n      text-transform: uppercase;\n      font-weight: 700;\n      text-align: center;\n      font-size: 12px;\n}\n.cards .card span.license-type.tnc[data-v-2f572690] {\n        background-color: #2ab77c;\n}\n.cards .card span.license-type.tcp[data-v-2f572690] {\n        background-color: #3f81a0;\n}\n.cards .card span.license-type.psc[data-v-2f572690] {\n        background-color: #de6c2a;\n}\n.cards .card .title[data-v-2f572690] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .label[data-v-2f572690] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-2f572690] {\n      margin-right: 10px;\n      font-size: 13px;\n      font-weight: 900;\n}\n.cards .card .value i[data-v-2f572690] {\n        opacity: 0.3;\n}\n.cards .card .edit[data-v-2f572690] {\n      text-align: right;\n      margin-bottom: 10px;\n      text-transform: uppercase;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Pricing/Services.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,kDAAkD;UAC1C,0CAA0C;EAClD,oBAAoB;CACrB;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,YAAY;CACf;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,sCAAsC;EACtC,iDAAiD;UACzC,yCAAyC;EACjD,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;CACnB;AACD;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,8BAA8B;IAC9B,6BAA6B;CAChC;AACD;MACM,mBAAmB;CACxB;AACD;MACM,YAAY;CACjB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,8BAA8B;CACjC;AACD;MACM,aAAa;CAClB;AACD;MACM,mBAAmB;CACxB;AACD;IACI,aAAa;CAChB;AACD;IACI,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;IACjB,mBAAmB;CACtB;AACD;MACM,0BAA0B;CAC/B;AACD;MACM,0BAA0B;CAC/B;AACD;MACM,0BAA0B;CAC/B;AACD;IACI,aAAa;CAChB;AACD;IACI,YAAY;CACf;AACD;IACI,aAAa;CAChB;AACD;IACI,mBAAmB;CACtB;AACD;EACE,iBAAiB;EACjB,uBAAuB;EACvB,8BAA8B;EAC9B,mCAAmC;UAC3B,2BAA2B;CACpC;AACD;EACE,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;CACrB;AACD;IACI,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,iCAAiC;CACpC;AACD;MACM,YAAY;MACZ,oBAAoB;CACzB;AACD;MACM,YAAY;MACZ,mBAAmB;MACnB,SAAS;MACT,UAAU;MACV,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,iBAAiB;MACjB,yCAAyC;MACzC,iCAAiC;MACjC,oDAAoD;cAC5C,4CAA4C;CACzD;AACD;MACM,oBAAoB;CACzB;AACD;QACQ,WAAW;CAClB;AACD;IACI,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;CAC7B;AACD;AACA;IACI,uBAAuB;IACvB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,oBAAoB;IACpB,+BAA+B;IAC/B,oBAAoB;IACpB,iBAAiB;CACpB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,iBAAiB;QACjB,gBAAgB;CACvB;AACD;QACQ,0BAA0B;QAC1B,gBAAgB;QAChB,iBAAiB;CACxB;AACD;MACM,sBAAsB;MACtB,YAAY;MACZ,iBAAiB;MACjB,cAAc;MACd,gBAAgB;MAChB,gBAAgB;MAChB,mBAAmB;MACnB,0BAA0B;MAC1B,iBAAiB;MACjB,mBAAmB;MACnB,gBAAgB;CACrB;AACD;QACQ,0BAA0B;CACjC;AACD;QACQ,0BAA0B;CACjC;AACD;QACQ,0BAA0B;CACjC;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;MACM,gBAAgB;MAChB,0BAA0B;MAC1B,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;CACvB;AACD;MACM,mBAAmB;MACnB,gBAAgB;MAChB,iBAAiB;CACtB;AACD;QACQ,aAAa;CACpB;AACD;MACM,kBAAkB;MAClB,oBAAoB;MACpB,0BAA0B;CAC/B;CACA","file":"Services.vue","sourcesContent":["\n.box[data-v-2f572690] {\n  background: #fff;\n  border-radius: 2px;\n  border: 1px solid #b0c6e4;\n  padding: 15px;\n  -webkit-box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n          box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n  margin-bottom: 20px;\n}\n.box label[data-v-2f572690] {\n    font-weight: 600;\n    font-size: 18px;\n    margin-bottom: 5px;\n    display: block;\n    color: #333;\n}\ntable[data-v-2f572690] {\n  background: #fff;\n  width: 100%;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  border-radius: 3px;\n  text-align: left;\n  border-spacing: 0;\n}\ntable thead th[data-v-2f572690] {\n    padding: 5px;\n    font-size: 14px;\n    color: #0D79F2;\n    border-bottom: 1px solid #ddd;\n    border-right: 1px solid #eee;\n}\ntable thead th[data-v-2f572690]:last-child {\n      border-right: none;\n}\ntable thead th.enable[data-v-2f572690] {\n      width: 90px;\n}\ntable tbody tr[data-v-2f572690]:nth-child(odd) {\n    background: #fafafa;\n}\ntable tbody tr:hover td[data-v-2f572690] {\n    background: #f1f1f1;\n}\ntable tbody td[data-v-2f572690] {\n    padding: 5px 7px;\n    font-size: 14px;\n    border-right: 1px solid #eee;\n    border-bottom: 1px solid #eee;\n}\ntable tbody td.license-type[data-v-2f572690] {\n      width: 200px;\n}\ntable tbody td[data-v-2f572690]:last-child {\n      border-right: none;\n}\ntable tbody .action[data-v-2f572690] {\n    width: 240px;\n}\ntable tbody span.license-type[data-v-2f572690] {\n    display: inline-block;\n    color: #fff;\n    padding: 3px 5px;\n    margin: 0 5px;\n    min-width: 50px;\n    border-radius: 3px;\n    text-transform: uppercase;\n    font-weight: 700;\n    text-align: center;\n}\ntable tbody span.license-type.tnc[data-v-2f572690] {\n      background-color: #2ab77c;\n}\ntable tbody span.license-type.tcp[data-v-2f572690] {\n      background-color: #3f81a0;\n}\ntable tbody span.license-type.psc[data-v-2f572690] {\n      background-color: #de6c2a;\n}\ntable tbody .pax-luggage[data-v-2f572690] {\n    width: 120px;\n}\ntable tbody .active[data-v-2f572690] {\n    width: 80px;\n}\ntable tbody .edit[data-v-2f572690] {\n    width: 100px;\n}\ntable .action[data-v-2f572690], table .enable[data-v-2f572690], table .active[data-v-2f572690], table .edit[data-v-2f572690], table .license-type[data-v-2f572690], table .pax-luggage[data-v-2f572690] {\n    text-align: center;\n}\n.button.default[data-v-2f572690] {\n  background: #fff;\n  color: #333 !important;\n  border-bottom: 4px solid #ccc;\n  -webkit-box-shadow: 0 0 0 1px #ccc;\n          box-shadow: 0 0 0 1px #ccc;\n}\n.switch[data-v-2f572690] {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n}\n.switch .slider[data-v-2f572690] {\n    position: relative;\n    display: inline-block;\n    width: 50px;\n    height: 30px;\n    border-radius: 20px;\n    background: #ccc;\n    position: relative;\n    cursor: pointer;\n    -webkit-transition: all .25s ease-in-out;\n    transition: all .25s ease-in-out;\n}\n.switch .slider.disabled[data-v-2f572690] {\n      opacity: .4;\n      cursor: not-allowed;\n}\n.switch .slider[data-v-2f572690]:before {\n      content: '';\n      position: absolute;\n      top: 4px;\n      left: 4px;\n      width: 22px;\n      height: 22px;\n      border-radius: 50%;\n      background: #fff;\n      -webkit-transition: all .25s ease-in-out;\n      transition: all .25s ease-in-out;\n      -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n}\n.switch .slider.active[data-v-2f572690] {\n      background: #57d1b7;\n}\n.switch .slider.active[data-v-2f572690]:before {\n        left: 24px;\n}\n.switch .label[data-v-2f572690] {\n    display: inline-block;\n    vertical-align: 10px;\n    margin-left: 5px;\n    font-size: 14px;\n    color: #555;\n    text-transform: uppercase;\n}\n@media only screen and (max-width: 430px) {\n.cards .card[data-v-2f572690] {\n    border: 1px solid #ccc;\n    margin: 0 10px;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-weight: 700;\n}\n.cards .card > div[data-v-2f572690] {\n      margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-2f572690] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .card-header .name[data-v-2f572690] {\n        font-weight: 900;\n}\n.cards .card .card-header .amount[data-v-2f572690] {\n        margin-left: 5px;\n        font-size: 14px;\n}\n.cards .card .card-header .status[data-v-2f572690] {\n        text-transform: uppercase;\n        font-size: 12px;\n        font-weight: 900;\n}\n.cards .card span.license-type[data-v-2f572690] {\n      display: inline-block;\n      color: #fff;\n      padding: 3px 5px;\n      margin: 0 5px;\n      margin-right: 0;\n      min-width: 50px;\n      border-radius: 3px;\n      text-transform: uppercase;\n      font-weight: 700;\n      text-align: center;\n      font-size: 12px;\n}\n.cards .card span.license-type.tnc[data-v-2f572690] {\n        background-color: #2ab77c;\n}\n.cards .card span.license-type.tcp[data-v-2f572690] {\n        background-color: #3f81a0;\n}\n.cards .card span.license-type.psc[data-v-2f572690] {\n        background-color: #de6c2a;\n}\n.cards .card .title[data-v-2f572690] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .label[data-v-2f572690] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-2f572690] {\n      margin-right: 10px;\n      font-size: 13px;\n      font-weight: 900;\n}\n.cards .card .value i[data-v-2f572690] {\n        opacity: 0.3;\n}\n.cards .card .edit[data-v-2f572690] {\n      text-align: right;\n      margin-bottom: 10px;\n      text-transform: uppercase;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105);
__webpack_require__(56);
__webpack_require__(70);
__webpack_require__(1541);
__webpack_require__(1545);
__webpack_require__(1547);
__webpack_require__(1548);
module.exports = __webpack_require__(12).Set;


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(538);
var validate = __webpack_require__(159);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(539)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(43);
var IObject = __webpack_require__(115);
var toObject = __webpack_require__(65);
var toLength = __webpack_require__(98);
var asc = __webpack_require__(1543);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1544);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(36);
var isArray = __webpack_require__(365);
var SPECIES = __webpack_require__(19)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(15);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(540)('Set') });


/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(93);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(541)('Set');


/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(542)('Set');


/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"services"},[_c('div',{staticClass:"box"},[(!_vm.isMobile)?_c('table',[(_vm.selectedServiceArea !== 0)?_c('thead',[_c('th',{staticClass:"enable"},[_vm._v("Enable")]),_vm._v(" "),_c('th',[_vm._v("Service Types")]),_vm._v(" "),_c('th',{staticClass:"license-type"},[_vm._v("License Type")]),_vm._v(" "),_c('th',{staticClass:"pax-luggage"},[_vm._v("Max Passenger")]),_vm._v(" "),_c('th',{staticClass:"pax-luggage"},[_vm._v("Max Luggage")]),_vm._v(" "),_c('th')]):_c('thead',[_c('th',{staticClass:"action"}),_vm._v(" "),_c('th',[_vm._v("Service Types")])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.services),function(service){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(service.brandEnabled && _vm.selectedServiceArea !== 0),expression:"service.brandEnabled && selectedServiceArea !== 0"}],key:service.id},[_c('td',{staticClass:"active"},[_c('div',{staticClass:"switch",on:{"click":function($event){return _vm.toggleEnable(service.id, service.enabled)}}},[_c('div',{class:{'slider':true, 'active':service.enabled, 'disabled':_vm.enabledLoading.indexOf(service.id) > -1}})])]),_vm._v(" "),_c('td',{staticClass:"name"},[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('td',{staticClass:"license-type"},_vm._l((service.licenseType),function(licenseType){return _c('span',{class:['license-type', licenseType]},[_vm._v(_vm._s(licenseType))])}),0),_vm._v(" "),_c('td',{staticClass:"pax-luggage"},[_vm._v(_vm._s(service.maxPassenger))]),_vm._v(" "),_c('td',{staticClass:"pax-luggage"},[_vm._v(_vm._s(service.maxLuggages))]),_vm._v(" "),_c('td',{staticClass:"edit"},[_c('a',{staticClass:"button xsmall warning",attrs:{"href":'/#/services/' + _vm.selectedBrand + '/' +service.id}},[_vm._v("Edit Info")])])])}),_vm._v(" "),_vm._l((_vm.services),function(service){return (service.brandEnabled && _vm.selectedServiceArea === 0)?_c('tr',[_c('td',{staticClass:"action"},[_c('div',{class:['button cta xsmall', _vm.enableList.indexOf(service.id) === -1 ? 'default' : 'success'],on:{"click":function($event){return _vm.toggleEnableList(service.id)}}},[_vm._v("Enable All")]),_vm._v(" "),_c('div',{class:['button cta xsmall', _vm.disableList.indexOf(service.id) === -1 ? 'default' : 'error'],on:{"click":function($event){return _vm.toggleDisableList(service.id)}}},[_vm._v("Disable All")])]),_vm._v(" "),_c('td',{staticClass:"name"},[_vm._v(_vm._s(service.name))])]):_vm._e()})],2)]):_c('div',[(_vm.selectedServiceArea !== 0)?_c('div',{staticClass:"cards"},_vm._l((_vm.services),function(service){return (service.brandEnabled && _vm.selectedServiceArea !== 0)?_c('div',{key:service.id,staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"title"},[_vm._v("\n              "+_vm._s(service.name)+"\n              "),_vm._l((service.licenseType),function(licenseType){return _c('span',{class:['license-type', licenseType]},[_vm._v(_vm._s(licenseType))])})],2),_vm._v(" "),_c('div',{staticClass:"status active"},[_c('div',{staticClass:"switch",on:{"click":function($event){return _vm.toggleEnable(service.id, service.enabled)}}},[_c('div',{class:{'slider':true, 'active':service.enabled, 'disabled':_vm.enabledLoading.indexOf(service.id) > -1}})])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Max Passenger: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(service.maxPassenger)+" "),_c('i',{staticClass:"fas fa-users"})])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Max Luggage: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(service.maxLuggages)+" "),_c('i',{staticClass:"fas fa-suitcase"})])]),_vm._v(" "),_c('div',{staticClass:"edit"},[_c('a',{staticClass:"button xsmall warning",attrs:{"href":'/#/services/' + _vm.selectedBrand + '/' +service.id}},[_c('i',{staticClass:"fas fa-edit"}),_vm._v(" Edit Info")])])]):_vm._e()}),0):_c('div',[_c('table',[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.services),function(service){return (service.brandEnabled && _vm.selectedServiceArea === 0)?_c('tr',[_c('td',{staticClass:"action"},[_c('div',{class:['button cta xsmall', _vm.enableList.indexOf(service.id) === -1 ? 'default' : 'success'],on:{"click":function($event){return _vm.toggleEnableList(service.id)}}},[_vm._v("Enable All")]),_vm._v(" "),_c('div',{class:['button cta xsmall', _vm.disableList.indexOf(service.id) === -1 ? 'default' : 'error'],on:{"click":function($event){return _vm.toggleDisableList(service.id)}}},[_vm._v("Disable All")])]),_vm._v(" "),_c('td',{staticClass:"name"},[_vm._v(_vm._s(service.name))])]):_vm._e()}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('label',[_vm._v("Charter Service")]),_vm._v(" "),(!_vm.isMobile)?_c('table',[(_vm.selectedServiceArea !== 0)?_c('thead',[_c('th',{staticClass:"enable"},[_vm._v("Enable")]),_vm._v(" "),_c('th',[_vm._v("Service Types")]),_vm._v(" "),_c('th',{staticClass:"license-type"},[_vm._v("License Type")]),_vm._v(" "),_c('th',{staticClass:"pax-luggage"},[_vm._v("Max Passenger")]),_vm._v(" "),_c('th',{staticClass:"pax-luggage"},[_vm._v("Max Luggage")]),_vm._v(" "),_c('th')]):_c('thead',[_c('th',{staticClass:"action"}),_vm._v(" "),_c('th',[_vm._v("Service Types")])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.charterServices),function(service){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(service.brandEnabled && _vm.selectedServiceArea !== 0),expression:"service.brandEnabled && selectedServiceArea !== 0"}],key:service.id},[_c('td',{staticClass:"active"},[_c('div',{staticClass:"switch",on:{"click":function($event){return _vm.toggleEnable(service.id, service.enabled)}}},[_c('div',{class:{'slider':true, 'active':service.enabled, 'disabled':_vm.enabledLoading.indexOf(service.id) > -1}})])]),_vm._v(" "),_c('td',{staticClass:"name"},[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('td',{staticClass:"license-type"},_vm._l((service.licenseType),function(licenseType){return _c('span',{class:['license-type', licenseType]},[_vm._v(_vm._s(licenseType))])}),0),_vm._v(" "),_c('td',{staticClass:"pax-luggage"},[_vm._v(_vm._s(service.maxPassenger))]),_vm._v(" "),_c('td',{staticClass:"pax-luggage"},[_vm._v(_vm._s(service.maxLuggages))]),_vm._v(" "),_c('td',{staticClass:"edit"},[_c('a',{staticClass:"button xsmall warning",attrs:{"href":'/#/services/' + _vm.selectedBrand + '/' +service.id}},[_vm._v("Edit Info")])])])}),_vm._v(" "),_vm._l((_vm.charterServices),function(service){return (service.brandEnabled && _vm.selectedServiceArea === 0)?_c('tr',[_c('td',{staticClass:"action"},[_c('div',{class:['button cta xsmall', _vm.enableList.indexOf(service.id) === -1 ? 'default' : 'success'],on:{"click":function($event){return _vm.toggleEnableList(service.id)}}},[_vm._v("Enable All")]),_vm._v(" "),_c('div',{class:['button cta xsmall', _vm.disableList.indexOf(service.id) === -1 ? 'default' : 'error'],on:{"click":function($event){return _vm.toggleDisableList(service.id)}}},[_vm._v("Disable All")])]),_vm._v(" "),_c('td',{staticClass:"name"},[_vm._v(_vm._s(service.name))])]):_vm._e()})],2)]):_c('div',[(_vm.selectedServiceArea !== 0)?_c('div',{staticClass:"cards"},_vm._l((_vm.charterServices),function(service){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(service.brandEnabled && _vm.selectedServiceArea !== 0),expression:"service.brandEnabled && selectedServiceArea !== 0"}],key:service.id,staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"title"},[_vm._v("\n              "+_vm._s(service.name)+"\n              "),_vm._l((service.licenseType),function(licenseType){return _c('span',{class:['license-type', licenseType]},[_vm._v(_vm._s(licenseType))])})],2),_vm._v(" "),_c('div',{staticClass:"status active"},[_c('div',{staticClass:"switch",on:{"click":function($event){return _vm.toggleEnable(service.id, service.enabled)}}},[_c('div',{class:{'slider':true, 'active':service.enabled, 'disabled':_vm.enabledLoading.indexOf(service.id) > -1}})])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Max Passenger: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(service.maxPassenger)+" "),_c('i',{staticClass:"fas fa-users"})])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Max Luggage: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(service.maxLuggages)+" "),_c('i',{staticClass:"fas fa-suitcase"})])]),_vm._v(" "),_c('div',{staticClass:"edit"},[_c('a',{staticClass:"button xsmall warning",attrs:{"href":'/#/services/' + _vm.selectedBrand + '/' +service.id}},[_c('i',{staticClass:"fas fa-edit"}),_vm._v(" Edit Info")])])])}),0):_c('div',[_c('table',[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.services),function(service){return (service.brandEnabled && _vm.selectedServiceArea === 0)?_c('tr',[_c('td',{staticClass:"action"},[_c('div',{class:['button cta xsmall', _vm.enableList.indexOf(service.id) === -1 ? 'default' : 'success'],on:{"click":function($event){return _vm.toggleEnableList(service.id)}}},[_vm._v("Enable All")]),_vm._v(" "),_c('div',{class:['button cta xsmall', _vm.disableList.indexOf(service.id) === -1 ? 'default' : 'error'],on:{"click":function($event){return _vm.toggleDisableList(service.id)}}},[_vm._v("Disable All")])]),_vm._v(" "),_c('td',{staticClass:"name"},[_vm._v(_vm._s(service.name))])]):_vm._e()}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('label',[_vm._v("Rental Service")]),_vm._v(" "),(!_vm.isMobile)?_c('table',[(_vm.selectedServiceArea !== 0)?_c('thead',[_c('th',{staticClass:"enable"},[_vm._v("Enable")]),_vm._v(" "),_c('th',[_vm._v("Service Types")]),_vm._v(" "),_c('th',{staticClass:"license-type"},[_vm._v("License Type")]),_vm._v(" "),_c('th',{staticClass:"pax-luggage"},[_vm._v("Max Passenger")]),_vm._v(" "),_c('th',{staticClass:"pax-luggage"},[_vm._v("Max Luggage")]),_vm._v(" "),_c('th')]):_c('thead',[_c('th',{staticClass:"action"}),_vm._v(" "),_c('th',[_vm._v("Service Types")])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.rentalServices),function(service){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(service.brandEnabled && _vm.selectedServiceArea !== 0),expression:"service.brandEnabled && selectedServiceArea !== 0"}],key:service.id},[_c('td',{staticClass:"active"},[_c('div',{staticClass:"switch",on:{"click":function($event){return _vm.toggleEnable(service.id, service.enabled)}}},[_c('div',{class:{'slider':true, 'active':service.enabled, 'disabled':_vm.enabledLoading.indexOf(service.id) > -1}})])]),_vm._v(" "),_c('td',{staticClass:"name"},[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('td',{staticClass:"license-type"},_vm._l((service.licenseType),function(licenseType){return _c('span',{class:['license-type', licenseType]},[_vm._v(_vm._s(licenseType))])}),0),_vm._v(" "),_c('td',{staticClass:"pax-luggage"},[_vm._v(_vm._s(service.maxPassenger))]),_vm._v(" "),_c('td',{staticClass:"pax-luggage"},[_vm._v(_vm._s(service.maxLuggages))]),_vm._v(" "),_c('td',{staticClass:"edit"},[_c('a',{staticClass:"button xsmall warning",attrs:{"href":'/#/services/' + _vm.selectedBrand + '/' +service.id}},[_vm._v("Edit Info")])])])}),_vm._v(" "),_vm._l((_vm.rentalServices),function(service){return (service.brandEnabled && _vm.selectedServiceArea === 0)?_c('tr',[_c('td',{staticClass:"action"},[_c('div',{class:['button cta xsmall', _vm.enableList.indexOf(service.id) === -1 ? 'default' : 'success'],on:{"click":function($event){return _vm.toggleEnableList(service.id)}}},[_vm._v("Enable All")]),_vm._v(" "),_c('div',{class:['button cta xsmall', _vm.disableList.indexOf(service.id) === -1 ? 'default' : 'error'],on:{"click":function($event){return _vm.toggleDisableList(service.id)}}},[_vm._v("Disable All")])]),_vm._v(" "),_c('td',{staticClass:"name"},[_vm._v(_vm._s(service.name))])]):_vm._e()})],2)]):_c('div',[(_vm.selectedServiceArea !== 0)?_c('div',{staticClass:"cards"},_vm._l((_vm.rentalServices),function(service){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(service.brandEnabled && _vm.selectedServiceArea !== 0),expression:"service.brandEnabled && selectedServiceArea !== 0"}],key:service.id,staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"title"},[_vm._v("\n              "+_vm._s(service.name)+"\n              "),_vm._l((service.licenseType),function(licenseType){return _c('span',{class:['license-type', licenseType]},[_vm._v(_vm._s(licenseType))])})],2),_vm._v(" "),_c('div',{staticClass:"status active"},[_c('div',{staticClass:"switch",on:{"click":function($event){return _vm.toggleEnable(service.id, service.enabled)}}},[_c('div',{class:{'slider':true, 'active':service.enabled, 'disabled':_vm.enabledLoading.indexOf(service.id) > -1}})])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Max Passenger: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(service.maxPassenger)+" "),_c('i',{staticClass:"fas fa-users"})])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Max Luggage: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(service.maxLuggages)+" "),_c('i',{staticClass:"fas fa-suitcase"})])]),_vm._v(" "),_c('div',{staticClass:"edit"},[_c('a',{staticClass:"button xsmall warning",attrs:{"href":'/#/services/' + _vm.selectedBrand + '/' +service.id}},[_c('i',{staticClass:"fas fa-edit"}),_vm._v(" Edit Info")])])])}),0):_c('div',[_c('table',[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.services),function(service){return (service.brandEnabled && _vm.selectedServiceArea === 0)?_c('tr',[_c('td',{staticClass:"action"},[_c('div',{class:['button cta xsmall', _vm.enableList.indexOf(service.id) === -1 ? 'default' : 'success'],on:{"click":function($event){return _vm.toggleEnableList(service.id)}}},[_vm._v("Enable All")]),_vm._v(" "),_c('div',{class:['button cta xsmall', _vm.disableList.indexOf(service.id) === -1 ? 'default' : 'error'],on:{"click":function($event){return _vm.toggleDisableList(service.id)}}},[_vm._v("Disable All")])]),_vm._v(" "),_c('td',{staticClass:"name"},[_vm._v(_vm._s(service.name))])]):_vm._e()}),0)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',{staticClass:"action"}),_vm._v(" "),_c('th',[_vm._v("Service Types")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',{staticClass:"action"}),_vm._v(" "),_c('th',[_vm._v("Service Types")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',{staticClass:"action"}),_vm._v(" "),_c('th',[_vm._v("Service Types")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logs_vue__ = __webpack_require__(543);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c14e7faa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logs_vue__ = __webpack_require__(1553);
function injectStyle (ssrContext) {
  __webpack_require__(1551)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c14e7faa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c14e7faa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1552);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("a2aed606", content, true, {});

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.logs-box[data-v-c14e7faa] {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  top: 0;\n  width: 400px;\n  height: 100%;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n  background: #fff;\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.logs-box.hide[data-v-c14e7faa] {\n    right: -400px;\n    -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n            box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n}\n.logs-box .heading[data-v-c14e7faa] {\n    font-size: 21px;\n    font-weight: 600;\n    letter-spacing: .7px;\n    color: #333;\n    padding: 0 20px;\n    line-height: 49px;\n    background-color: #f4f8f9;\n}\n.logs-box .logs-body[data-v-c14e7faa] {\n    display: block;\n    height: calc(100% - 50px);\n    background: #fff;\n    overflow-y: auto;\n    padding: 20px;\n    border-top: 1px solid #ccc;\n}\n.l-box[data-v-c14e7faa] {\n  border: 1px solid #ddd;\n  width: 100%;\n  max-height: auto;\n  padding: 10px;\n  background: #fafafa;\n  overflow: hidden;\n  -webkit-transition: all .35s ease-in-out;\n  transition: all .35s ease-in-out;\n  cursor: pointer;\n  margin-bottom: 10px;\n  gap: 10px;\n  font-size: 11px;\n  letter-spacing: .5px;\n  color: #666;\n}\n.l-box.open[data-v-c14e7faa] {\n    background: #fff8dc;\n}\n.l-date[data-v-c14e7faa] {\n  line-height: 1;\n  margin-bottom: 3px;\n}\n.l-action[data-v-c14e7faa] {\n  font-weight: 600;\n}\n.l-admin[data-v-c14e7faa] {\n  margin: 15px 0 20px;\n}\n.l-field[data-v-c14e7faa] {\n  margin-bottom: 15px;\n}\n.l-label[data-v-c14e7faa] {\n  line-height: 1;\n  letter-spacing: .6px;\n  margin-bottom: 3px;\n}\n.l-label i[data-v-c14e7faa] {\n    display: inline-block;\n    margin-left: 3px;\n}\n.l-value[data-v-c14e7faa] {\n  font-weight: 600;\n  color: #555;\n}\n.empty-state[data-v-c14e7faa] {\n  padding: 30px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\n.empty-state .fa[data-v-c14e7faa] {\n    display: block;\n    margin-bottom: 5px;\n    color: #ccc;\n    text-shadow: 0 0 5px white;\n}\n.slide-down-enter-active[data-v-c14e7faa], .slide-down-leave-active[data-v-c14e7faa] {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.slide-down-enter[data-v-c14e7faa], .slide-down-leave-to[data-v-c14e7faa] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Pricing/Logs.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;EAClD,iBAAiB;EACjB,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;IACI,cAAc;IACd,gDAAgD;YACxC,wCAAwC;CACnD;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;CAC7B;AACD;IACI,eAAe;IACf,0BAA0B;IAC1B,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,2BAA2B;CAC9B;AACD;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,yCAAyC;EACzC,iCAAiC;EACjC,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;CACb;AACD;IACI,oBAAoB;CACvB;AACD;EACE,eAAe;EACf,mBAAmB;CACpB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;CACpB;AACD;IACI,sBAAsB;IACtB,iBAAiB;CACpB;AACD;EACE,iBAAiB;EACjB,YAAY;CACb;AACD;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;CAC9B;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ","file":"Logs.vue","sourcesContent":["\n.logs-box[data-v-c14e7faa] {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  top: 0;\n  width: 400px;\n  height: 100%;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n  background: #fff;\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.logs-box.hide[data-v-c14e7faa] {\n    right: -400px;\n    -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n            box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n}\n.logs-box .heading[data-v-c14e7faa] {\n    font-size: 21px;\n    font-weight: 600;\n    letter-spacing: .7px;\n    color: #333;\n    padding: 0 20px;\n    line-height: 49px;\n    background-color: #f4f8f9;\n}\n.logs-box .logs-body[data-v-c14e7faa] {\n    display: block;\n    height: calc(100% - 50px);\n    background: #fff;\n    overflow-y: auto;\n    padding: 20px;\n    border-top: 1px solid #ccc;\n}\n.l-box[data-v-c14e7faa] {\n  border: 1px solid #ddd;\n  width: 100%;\n  max-height: auto;\n  padding: 10px;\n  background: #fafafa;\n  overflow: hidden;\n  -webkit-transition: all .35s ease-in-out;\n  transition: all .35s ease-in-out;\n  cursor: pointer;\n  margin-bottom: 10px;\n  gap: 10px;\n  font-size: 11px;\n  letter-spacing: .5px;\n  color: #666;\n}\n.l-box.open[data-v-c14e7faa] {\n    background: #fff8dc;\n}\n.l-date[data-v-c14e7faa] {\n  line-height: 1;\n  margin-bottom: 3px;\n}\n.l-action[data-v-c14e7faa] {\n  font-weight: 600;\n}\n.l-admin[data-v-c14e7faa] {\n  margin: 15px 0 20px;\n}\n.l-field[data-v-c14e7faa] {\n  margin-bottom: 15px;\n}\n.l-label[data-v-c14e7faa] {\n  line-height: 1;\n  letter-spacing: .6px;\n  margin-bottom: 3px;\n}\n.l-label i[data-v-c14e7faa] {\n    display: inline-block;\n    margin-left: 3px;\n}\n.l-value[data-v-c14e7faa] {\n  font-weight: 600;\n  color: #555;\n}\n.empty-state[data-v-c14e7faa] {\n  padding: 30px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\n.empty-state .fa[data-v-c14e7faa] {\n    display: block;\n    margin-bottom: 5px;\n    color: #ccc;\n    text-shadow: 0 0 5px white;\n}\n.slide-down-enter-active[data-v-c14e7faa], .slide-down-leave-active[data-v-c14e7faa] {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.slide-down-enter[data-v-c14e7faa], .slide-down-leave-to[data-v-c14e7faa] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['logs-box', {hide:!_vm.logs.show}]},[_c('div',{staticClass:"heading"},[_vm._v("Logs")]),_vm._v(" "),_c('div',{staticClass:"logs-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.logs.list.length),expression:"!logs.list.length"}],staticClass:"empty-state"},[_c('i',{staticClass:"fa fa-clipboard-list fa-4x"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('rsvpDetails.activityLogs.emptyState')))])]),_vm._v(" "),_vm._l((_vm.logs.list),function(log,i){return _c('div',{key:i,class:['l-box d-flex align-start', {open:log.open}],on:{"click":function($event){log.open = !log.open}}},[_c('div',[(!log.open)?_c('i',{staticClass:"fa fa-plus-circle"}):_c('i',{staticClass:"fa fa-minus-circle"})]),_vm._v(" "),_c('div',[_c('div',{staticClass:"l-date"},[_vm._v(_vm._s(log.date))]),_vm._v(" "),_c('div',{staticClass:"l-action"},[_vm._v(_vm._s(_vm.actionLabel(log.type)))]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(log.open),expression:"log.open"}]},[_c('div',{staticClass:"l-admin"},[_c('div',[_vm._v("Admin ID: "),_c('b',[_vm._v(_vm._s(log.admin.id))])]),_vm._v(" "),_c('div',[_vm._v("Admin Email: "),_c('b',[_vm._v(_vm._s(log.admin.email))])])]),_vm._v(" "),_vm._l((log.fields),function(field,k){return (['enable', 'type'].indexOf(k) === -1)?_c('div',{key:k,staticClass:"l-field"},[_c('div',{staticClass:"l-label"},[_vm._v(_vm._s(_vm.relabel(k))+" "),_c('i',[_vm._v("("+_vm._s(k)+")")])]),_vm._v(" "),_c('div',{staticClass:"l-value"},[_vm._v(_vm._s(field))])]):_vm._e()})],2)])],1)])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PricingSettings_vue__ = __webpack_require__(544);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_240b660a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PricingSettings_vue__ = __webpack_require__(1561);
function injectStyle (ssrContext) {
  __webpack_require__(1555)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-240b660a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PricingSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_240b660a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PricingSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1556);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("926e6abc", content, true, {});

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.p-R-0[data-v-240b660a] {\n  padding-right: 0;\n}\n.p-L-0[data-v-240b660a] {\n  padding-left: 0;\n}\n.p-L-10[data-v-240b660a] {\n  padding-left: 10px;\n}\n.row[data-v-240b660a] {\n  max-width: 100%;\n}\n.box[data-v-240b660a] {\n  background: #fff;\n  border-radius: 2px;\n  border: 1px solid #b0c6e4;\n  margin-bottom: 30px;\n  -webkit-box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n          box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n}\n.box .header[data-v-240b660a] {\n    padding: 10px;\n    background: #0D79F2;\n    text-transform: uppercase;\n    color: #fff;\n    font-weight: 600;\n    font-size: 14px;\n}\n.box .body .error-msg[data-v-240b660a] {\n    font-size: 12px;\n    color: #fff;\n    font-style: italic;\n    display: block;\n    padding: 5px;\n    text-align: center;\n    background: #ff4d4d;\n}\n.box.d2d[data-v-240b660a] {\n    max-width: 500px;\n}\n.g20[data-v-240b660a] {\n  gap: 20px;\n}\ntable[data-v-240b660a] {\n  background: #fff;\n  width: 100%;\n  text-align: left;\n  border-spacing: 0;\n  text-align: center;\n}\ntable thead th[data-v-240b660a] {\n    font-size: 13px;\n    font-weight: 100;\n    color: #777;\n    padding: 10px 0 0;\n}\ntable tbody td[data-v-240b660a] {\n    vertical-align: baseline;\n    padding: 8px 7px;\n    font-size: 14px;\n}\ntable tbody td[data-v-240b660a]:last-child {\n      padding-bottom: 15px;\n}\ntable tbody input[data-v-240b660a] {\n    max-width: 90px;\n    margin: 0;\n    font-size: 13px;\n    display: inline-block;\n    text-align: center;\n}\ntable tbody .small-input[data-v-240b660a] {\n    width: 60px;\n}\ntable tbody .discount[data-v-240b660a], table tbody .roundtrip[data-v-240b660a] {\n    max-width: 90px;\n    min-width: 50px;\n}\ntable tbody .fa-square[data-v-240b660a], table tbody .fa-check-square[data-v-240b660a] {\n    color: #0D79F2;\n}\ntable tbody i.disabled[data-v-240b660a] {\n    opacity: .4;\n    cursor: not-allowed;\n}\ntable tbody .base-rate[data-v-240b660a] {\n    max-width: 80px;\n}\ntable tbody .mile-threshold[data-v-240b660a] {\n    width: 70px;\n}\ntable .discount[data-v-240b660a] {\n    background: #fafafa;\n}\ntable .roundtrip[data-v-240b660a] {\n    background: #f5f5f5;\n}\n.date-box[data-v-240b660a] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.discount-date[data-v-240b660a] {\n  background: #eaf2fb;\n  text-align: left;\n  border-top: 1px solid #b0c6e4;\n  padding: 10px 0;\n}\n.discount-date.holiday[data-v-240b660a], .discount-date.promo[data-v-240b660a] {\n    text-align: center;\n}\n.discount-date .label[data-v-240b660a], .discount-date .field[data-v-240b660a] {\n    display: inline-block;\n}\n.discount-date .label[data-v-240b660a] {\n    font-size: 14px;\n    font-weight: 600;\n    color: #3b5573;\n    margin-right: 10px;\n}\n.discount-date.holiday .label[data-v-240b660a] {\n    vertical-align: top;\n    line-height: 30px;\n}\n.discount-date .field[data-v-240b660a] {\n    min-width: 150px;\n    padding-right: 10px;\n}\n.discount-date .sub-label[data-v-240b660a] {\n    display: block;\n    font-size: 11px;\n    color: #888;\n    line-height: 1;\n    margin: 0 0 3px 2px;\n}\n.discount-date .table-label[data-v-240b660a] {\n    text-align: right;\n    padding-right: 20px !important;\n}\n.discount-date .date-input-block[data-v-240b660a] {\n    display: block;\n    width: 100%;\n    margin-bottom: 2px;\n}\n.discount-date .button[data-v-240b660a] {\n    margin-top: 10px;\n}\n.dc-type-box[data-v-240b660a] {\n  height: 48px;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.dc-type[data-v-240b660a] {\n  display: inline-block;\n  margin: 0 10px;\n  font-size: 16px;\n  cursor: pointer;\n}\n.dc-type i[data-v-240b660a] {\n    vertical-align: -2px;\n    color: #0D79F2;\n    font-size: 21px;\n    margin-right: 3px;\n}\n.holiday-rates select[data-v-240b660a], .conv-box select[data-v-240b660a] {\n  max-width: 60px;\n  min-width: 60px;\n}\nselect[data-v-240b660a] {\n  border: 1px solid #ddd;\n  padding: 8px 15px 8px 8px;\n  color: #333;\n  height: 42px;\n  position: relative;\n  font-size: 14px;\n  outline: none;\n  text-align: center;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: calc(100% + 4px) 50%;\n  -webkit-transition: all .35s ease;\n  transition: all .35s ease;\n}\nselect.has-error[data-v-240b660a] {\n    border-color: #f20d0d;\n}\nselect[data-v-240b660a]:disabled {\n    background-color: #eee;\n}\n@media only screen and (max-width: 430px) {\n.p-L-10[data-v-240b660a] {\n    padding: 0;\n}\n.discount-date .field[data-v-240b660a] {\n    width: 100%;\n}\n.date-box[data-v-240b660a] {\n    padding: 0 10px;\n}\n.cards[data-v-240b660a] {\n    padding-top: 10px;\n}\n.cards .card[data-v-240b660a] {\n      border: 1px solid #b0c6e4;\n      margin: 0 10px;\n      margin-bottom: 15px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #b0c6e4;\n      font-weight: 700;\n}\n.cards .card > div[data-v-240b660a] {\n        margin-bottom: 3px;\n}\n.cards .card.promo-card[data-v-240b660a] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        padding-bottom: 0;\n}\n.cards .card.promo-card .action[data-v-240b660a] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          width: 100%;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n          margin: 0;\n          margin-top: 5px;\n          border-top: 1px solid #b0c6e4;\n          padding: 10px;\n          background-color: #eaf2fb;\n}\n.cards .card .row-fields[data-v-240b660a] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.cards .card .card-header[data-v-240b660a] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        background-color: #eaf2fb;\n        padding: 5px 10px;\n        font-size: 14px;\n}\n.cards .card .card-header .name[data-v-240b660a] {\n          font-weight: 900;\n}\n.cards .card .card-header .amount[data-v-240b660a] {\n          margin-left: 5px;\n          font-size: 14px;\n}\n.cards .card .card-header .status[data-v-240b660a] {\n          text-transform: uppercase;\n          font-size: 12px;\n          font-weight: 900;\n}\n.cards .card .title[data-v-240b660a] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        padding: 5px 10px;\n}\n.cards .card .title input[data-v-240b660a] {\n          margin: 0;\n          padding: 5px 10px;\n          font-size: 14px;\n}\n.cards .card .title select[data-v-240b660a] {\n          margin: 0;\n          padding: 5px 10px;\n          font-size: 14px;\n          height: 35px;\n          width: 80px;\n}\n.cards .card .title .discount[data-v-240b660a] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          width: 100%;\n}\n.cards .card .label[data-v-240b660a] {\n        font-size: 11px;\n        color: #666;\n        font-weight: 100;\n}\n.cards .card .value[data-v-240b660a] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Pricing/PricingSettings.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;CAClB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,kDAAkD;UAC1C,0CAA0C;CACnD;AACD;IACI,cAAc;IACd,oBAAoB;IACpB,0BAA0B;IAC1B,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,UAAU;CACX;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;CACpB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;CACrB;AACD;IACI,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;CACnB;AACD;MACM,qBAAqB;CAC1B;AACD;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;CACtB;AACD;IACI,YAAY;CACf;AACD;IACI,gBAAgB;IAChB,gBAAgB;CACnB;AACD;IACI,eAAe;CAClB;AACD;IACI,YAAY;IACZ,oBAAoB;CACvB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,YAAY;CACf;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;CACjC;AACD;EACE,oBAAoB;EACpB,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;CACjB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,sBAAsB;CACzB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;CACtB;AACD;IACI,oBAAoB;IACpB,kBAAkB;CACrB;AACD;IACI,iBAAiB;IACjB,oBAAoB;CACvB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,oBAAoB;CACvB;AACD;IACI,kBAAkB;IAClB,+BAA+B;CAClC;AACD;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;CACtB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,aAAa;EACb,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;CACjC;AACD;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;CACjB;AACD;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;CACrB;AACD;EACE,gBAAgB;EAChB,gBAAgB;CACjB;AACD;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,0CAA0C;EAC1C,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;IACI,sBAAsB;CACzB;AACD;IACI,uBAAuB;CAC1B;AACD;AACA;IACI,WAAW;CACd;AACD;IACI,YAAY;CACf;AACD;IACI,gBAAgB;CACnB;AACD;IACI,kBAAkB;CACrB;AACD;MACM,0BAA0B;MAC1B,eAAe;MACf,oBAAoB;MACpB,oBAAoB;MACpB,iCAAiC;MACjC,iBAAiB;CACtB;AACD;QACQ,mBAAmB;CAC1B;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,oBAAoB;YAChB,gBAAgB;QACpB,kBAAkB;CACzB;AACD;UACU,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;UACd,YAAY;UACZ,yBAAyB;cACrB,sBAAsB;kBAClB,wBAAwB;UAChC,UAAU;UACV,gBAAgB;UAChB,8BAA8B;UAC9B,cAAc;UACd,0BAA0B;CACnC;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;CACrB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,+BAA+B;QACvC,0BAA0B;YACtB,uBAAuB;gBACnB,oBAAoB;QAC5B,0BAA0B;QAC1B,kBAAkB;QAClB,gBAAgB;CACvB;AACD;UACU,iBAAiB;CAC1B;AACD;UACU,iBAAiB;UACjB,gBAAgB;CACzB;AACD;UACU,0BAA0B;UAC1B,gBAAgB;UAChB,iBAAiB;CAC1B;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,6BAA6B;QAC7B,8BAA8B;YAC1B,2BAA2B;gBACvB,uBAAuB;QAC/B,kBAAkB;CACzB;AACD;UACU,UAAU;UACV,kBAAkB;UAClB,gBAAgB;CACzB;AACD;UACU,UAAU;UACV,kBAAkB;UAClB,gBAAgB;UAChB,aAAa;UACb,YAAY;CACrB;AACD;UACU,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;UACd,YAAY;CACrB;AACD;QACQ,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;CACxB;AACD;QACQ,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;CACxB;CACA","file":"PricingSettings.vue","sourcesContent":["\n.p-R-0[data-v-240b660a] {\n  padding-right: 0;\n}\n.p-L-0[data-v-240b660a] {\n  padding-left: 0;\n}\n.p-L-10[data-v-240b660a] {\n  padding-left: 10px;\n}\n.row[data-v-240b660a] {\n  max-width: 100%;\n}\n.box[data-v-240b660a] {\n  background: #fff;\n  border-radius: 2px;\n  border: 1px solid #b0c6e4;\n  margin-bottom: 30px;\n  -webkit-box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n          box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n}\n.box .header[data-v-240b660a] {\n    padding: 10px;\n    background: #0D79F2;\n    text-transform: uppercase;\n    color: #fff;\n    font-weight: 600;\n    font-size: 14px;\n}\n.box .body .error-msg[data-v-240b660a] {\n    font-size: 12px;\n    color: #fff;\n    font-style: italic;\n    display: block;\n    padding: 5px;\n    text-align: center;\n    background: #ff4d4d;\n}\n.box.d2d[data-v-240b660a] {\n    max-width: 500px;\n}\n.g20[data-v-240b660a] {\n  gap: 20px;\n}\ntable[data-v-240b660a] {\n  background: #fff;\n  width: 100%;\n  text-align: left;\n  border-spacing: 0;\n  text-align: center;\n}\ntable thead th[data-v-240b660a] {\n    font-size: 13px;\n    font-weight: 100;\n    color: #777;\n    padding: 10px 0 0;\n}\ntable tbody td[data-v-240b660a] {\n    vertical-align: baseline;\n    padding: 8px 7px;\n    font-size: 14px;\n}\ntable tbody td[data-v-240b660a]:last-child {\n      padding-bottom: 15px;\n}\ntable tbody input[data-v-240b660a] {\n    max-width: 90px;\n    margin: 0;\n    font-size: 13px;\n    display: inline-block;\n    text-align: center;\n}\ntable tbody .small-input[data-v-240b660a] {\n    width: 60px;\n}\ntable tbody .discount[data-v-240b660a], table tbody .roundtrip[data-v-240b660a] {\n    max-width: 90px;\n    min-width: 50px;\n}\ntable tbody .fa-square[data-v-240b660a], table tbody .fa-check-square[data-v-240b660a] {\n    color: #0D79F2;\n}\ntable tbody i.disabled[data-v-240b660a] {\n    opacity: .4;\n    cursor: not-allowed;\n}\ntable tbody .base-rate[data-v-240b660a] {\n    max-width: 80px;\n}\ntable tbody .mile-threshold[data-v-240b660a] {\n    width: 70px;\n}\ntable .discount[data-v-240b660a] {\n    background: #fafafa;\n}\ntable .roundtrip[data-v-240b660a] {\n    background: #f5f5f5;\n}\n.date-box[data-v-240b660a] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.discount-date[data-v-240b660a] {\n  background: #eaf2fb;\n  text-align: left;\n  border-top: 1px solid #b0c6e4;\n  padding: 10px 0;\n}\n.discount-date.holiday[data-v-240b660a], .discount-date.promo[data-v-240b660a] {\n    text-align: center;\n}\n.discount-date .label[data-v-240b660a], .discount-date .field[data-v-240b660a] {\n    display: inline-block;\n}\n.discount-date .label[data-v-240b660a] {\n    font-size: 14px;\n    font-weight: 600;\n    color: #3b5573;\n    margin-right: 10px;\n}\n.discount-date.holiday .label[data-v-240b660a] {\n    vertical-align: top;\n    line-height: 30px;\n}\n.discount-date .field[data-v-240b660a] {\n    min-width: 150px;\n    padding-right: 10px;\n}\n.discount-date .sub-label[data-v-240b660a] {\n    display: block;\n    font-size: 11px;\n    color: #888;\n    line-height: 1;\n    margin: 0 0 3px 2px;\n}\n.discount-date .table-label[data-v-240b660a] {\n    text-align: right;\n    padding-right: 20px !important;\n}\n.discount-date .date-input-block[data-v-240b660a] {\n    display: block;\n    width: 100%;\n    margin-bottom: 2px;\n}\n.discount-date .button[data-v-240b660a] {\n    margin-top: 10px;\n}\n.dc-type-box[data-v-240b660a] {\n  height: 48px;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.dc-type[data-v-240b660a] {\n  display: inline-block;\n  margin: 0 10px;\n  font-size: 16px;\n  cursor: pointer;\n}\n.dc-type i[data-v-240b660a] {\n    vertical-align: -2px;\n    color: #0D79F2;\n    font-size: 21px;\n    margin-right: 3px;\n}\n.holiday-rates select[data-v-240b660a], .conv-box select[data-v-240b660a] {\n  max-width: 60px;\n  min-width: 60px;\n}\nselect[data-v-240b660a] {\n  border: 1px solid #ddd;\n  padding: 8px 15px 8px 8px;\n  color: #333;\n  height: 42px;\n  position: relative;\n  font-size: 14px;\n  outline: none;\n  text-align: center;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: calc(100% + 4px) 50%;\n  -webkit-transition: all .35s ease;\n  transition: all .35s ease;\n}\nselect.has-error[data-v-240b660a] {\n    border-color: #f20d0d;\n}\nselect[data-v-240b660a]:disabled {\n    background-color: #eee;\n}\n@media only screen and (max-width: 430px) {\n.p-L-10[data-v-240b660a] {\n    padding: 0;\n}\n.discount-date .field[data-v-240b660a] {\n    width: 100%;\n}\n.date-box[data-v-240b660a] {\n    padding: 0 10px;\n}\n.cards[data-v-240b660a] {\n    padding-top: 10px;\n}\n.cards .card[data-v-240b660a] {\n      border: 1px solid #b0c6e4;\n      margin: 0 10px;\n      margin-bottom: 15px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #b0c6e4;\n      font-weight: 700;\n}\n.cards .card > div[data-v-240b660a] {\n        margin-bottom: 3px;\n}\n.cards .card.promo-card[data-v-240b660a] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        padding-bottom: 0;\n}\n.cards .card.promo-card .action[data-v-240b660a] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          width: 100%;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n          margin: 0;\n          margin-top: 5px;\n          border-top: 1px solid #b0c6e4;\n          padding: 10px;\n          background-color: #eaf2fb;\n}\n.cards .card .row-fields[data-v-240b660a] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.cards .card .card-header[data-v-240b660a] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        background-color: #eaf2fb;\n        padding: 5px 10px;\n        font-size: 14px;\n}\n.cards .card .card-header .name[data-v-240b660a] {\n          font-weight: 900;\n}\n.cards .card .card-header .amount[data-v-240b660a] {\n          margin-left: 5px;\n          font-size: 14px;\n}\n.cards .card .card-header .status[data-v-240b660a] {\n          text-transform: uppercase;\n          font-size: 12px;\n          font-weight: 900;\n}\n.cards .card .title[data-v-240b660a] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        padding: 5px 10px;\n}\n.cards .card .title input[data-v-240b660a] {\n          margin: 0;\n          padding: 5px 10px;\n          font-size: 14px;\n}\n.cards .card .title select[data-v-240b660a] {\n          margin: 0;\n          padding: 5px 10px;\n          font-size: 14px;\n          height: 35px;\n          width: 80px;\n}\n.cards .card .title .discount[data-v-240b660a] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          width: 100%;\n}\n.cards .card .label[data-v-240b660a] {\n        font-size: 11px;\n        color: #666;\n        font-weight: 100;\n}\n.cards .card .value[data-v-240b660a] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * AutoNumeric.js v4.6.0
 * © 2009-2019 Robert J. Knothe, Alexandre Bonneau
 * Released under the MIT License.
 */
!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.AutoNumeric=t():e.AutoNumeric=t()}(this,function(){return n={},a.m=i=[function(e,t,i){"use strict";i.r(t);var n={allowedTagList:["b","caption","cite","code","const","dd","del","div","dfn","dt","em","h1","h2","h3","h4","h5","h6","input","ins","kdb","label","li","option","output","p","q","s","sample","span","strong","td","th","u"]};Object.freeze(n.allowedTagList),Object.defineProperty(n,"allowedTagList",{configurable:!1,writable:!1}),n.keyCode={Backspace:8,Tab:9,Enter:13,Shift:16,Ctrl:17,Alt:18,Pause:19,CapsLock:20,Esc:27,Space:32,PageUp:33,PageDown:34,End:35,Home:36,LeftArrow:37,UpArrow:38,RightArrow:39,DownArrow:40,Insert:45,Delete:46,num0:48,num1:49,num2:50,num3:51,num4:52,num5:53,num6:54,num7:55,num8:56,num9:57,a:65,b:66,c:67,d:68,e:69,f:70,g:71,h:72,i:73,j:74,k:75,l:76,m:77,n:78,o:79,p:80,q:81,r:82,s:83,t:84,u:85,v:86,w:87,x:88,y:89,z:90,OSLeft:91,OSRight:92,ContextMenu:93,numpad0:96,numpad1:97,numpad2:98,numpad3:99,numpad4:100,numpad5:101,numpad6:102,numpad7:103,numpad8:104,numpad9:105,MultiplyNumpad:106,PlusNumpad:107,MinusNumpad:109,DotNumpad:110,SlashNumpad:111,F1:112,F2:113,F3:114,F4:115,F5:116,F6:117,F7:118,F8:119,F9:120,F10:121,F11:122,F12:123,NumLock:144,ScrollLock:145,HyphenFirefox:173,MyComputer:182,MyCalculator:183,Semicolon:186,Equal:187,Comma:188,Hyphen:189,Dot:190,Slash:191,Backquote:192,LeftBracket:219,Backslash:220,RightBracket:221,Quote:222,Command:224,AltGraph:225,AndroidDefault:229},Object.freeze(n.keyCode),Object.defineProperty(n,"keyCode",{configurable:!1,writable:!1}),n.fromCharCodeKeyCode={0:"LaunchCalculator",8:"Backspace",9:"Tab",13:"Enter",16:"Shift",17:"Ctrl",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",48:"0",49:"1",50:"2",51:"3",52:"4",53:"5",54:"6",55:"7",56:"8",57:"9",91:"OS",92:"OSRight",93:"ContextMenu",96:"0",97:"1",98:"2",99:"3",100:"4",101:"5",102:"6",103:"7",104:"8",105:"9",106:"*",107:"+",109:"-",110:".",111:"/",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",173:"-",182:"MyComputer",183:"MyCalculator",186:";",187:"=",188:",",189:"-",190:".",191:"/",192:"`",219:"[",220:"\\",221:"]",222:"'",224:"Meta",225:"AltGraph"},Object.freeze(n.fromCharCodeKeyCode),Object.defineProperty(n,"fromCharCodeKeyCode",{configurable:!1,writable:!1}),n.keyName={Unidentified:"Unidentified",AndroidDefault:"AndroidDefault",Alt:"Alt",AltGr:"AltGraph",CapsLock:"CapsLock",Ctrl:"Control",Fn:"Fn",FnLock:"FnLock",Hyper:"Hyper",Meta:"Meta",OSLeft:"OS",OSRight:"OS",Command:"OS",NumLock:"NumLock",ScrollLock:"ScrollLock",Shift:"Shift",Super:"Super",Symbol:"Symbol",SymbolLock:"SymbolLock",Enter:"Enter",Tab:"Tab",Space:" ",LeftArrow:"ArrowLeft",UpArrow:"ArrowUp",RightArrow:"ArrowRight",DownArrow:"ArrowDown",End:"End",Home:"Home",PageUp:"PageUp",PageDown:"PageDown",Backspace:"Backspace",Clear:"Clear",Copy:"Copy",CrSel:"CrSel",Cut:"Cut",Delete:"Delete",EraseEof:"EraseEof",ExSel:"ExSel",Insert:"Insert",Paste:"Paste",Redo:"Redo",Undo:"Undo",Accept:"Accept",Again:"Again",Attn:"Attn",Cancel:"Cancel",ContextMenu:"ContextMenu",Esc:"Escape",Execute:"Execute",Find:"Find",Finish:"Finish",Help:"Help",Pause:"Pause",Play:"Play",Props:"Props",Select:"Select",ZoomIn:"ZoomIn",ZoomOut:"ZoomOut",BrightnessDown:"BrightnessDown",BrightnessUp:"BrightnessUp",Eject:"Eject",LogOff:"LogOff",Power:"Power",PowerOff:"PowerOff",PrintScreen:"PrintScreen",Hibernate:"Hibernate",Standby:"Standby",WakeUp:"WakeUp",Compose:"Compose",Dead:"Dead",F1:"F1",F2:"F2",F3:"F3",F4:"F4",F5:"F5",F6:"F6",F7:"F7",F8:"F8",F9:"F9",F10:"F10",F11:"F11",F12:"F12",Print:"Print",num0:"0",num1:"1",num2:"2",num3:"3",num4:"4",num5:"5",num6:"6",num7:"7",num8:"8",num9:"9",a:"a",b:"b",c:"c",d:"d",e:"e",f:"f",g:"g",h:"h",i:"i",j:"j",k:"k",l:"l",m:"m",n:"n",o:"o",p:"p",q:"q",r:"r",s:"s",t:"t",u:"u",v:"v",w:"w",x:"x",y:"y",z:"z",A:"A",B:"B",C:"C",D:"D",E:"E",F:"F",G:"G",H:"H",I:"I",J:"J",K:"K",L:"L",M:"M",N:"N",O:"O",P:"P",Q:"Q",R:"R",S:"S",T:"T",U:"U",V:"V",W:"W",X:"X",Y:"Y",Z:"Z",Semicolon:";",Equal:"=",Comma:",",Hyphen:"-",Minus:"-",Plus:"+",Dot:".",Slash:"/",Backquote:"`",LeftParenthesis:"(",RightParenthesis:")",LeftBracket:"[",RightBracket:"]",Backslash:"\\",Quote:"'",numpad0:"0",numpad1:"1",numpad2:"2",numpad3:"3",numpad4:"4",numpad5:"5",numpad6:"6",numpad7:"7",numpad8:"8",numpad9:"9",NumpadDot:".",NumpadDotAlt:",",NumpadMultiply:"*",NumpadPlus:"+",NumpadMinus:"-",NumpadSubtract:"-",NumpadSlash:"/",NumpadDotObsoleteBrowsers:"Decimal",NumpadMultiplyObsoleteBrowsers:"Multiply",NumpadPlusObsoleteBrowsers:"Add",NumpadMinusObsoleteBrowsers:"Subtract",NumpadSlashObsoleteBrowsers:"Divide",_allFnKeys:["F1","F2","F3","F4","F5","F6","F7","F8","F9","F10","F11","F12"],_someNonPrintableKeys:["Tab","Enter","Shift","ShiftLeft","ShiftRight","Control","ControlLeft","ControlRight","Alt","AltLeft","AltRight","Pause","CapsLock","Escape"],_directionKeys:["PageUp","PageDown","End","Home","ArrowDown","ArrowLeft","ArrowRight","ArrowUp"]},Object.freeze(n.keyName._allFnKeys),Object.freeze(n.keyName._someNonPrintableKeys),Object.freeze(n.keyName._directionKeys),Object.freeze(n.keyName),Object.defineProperty(n,"keyName",{configurable:!1,writable:!1}),Object.freeze(n);var d=n;function a(e){return function(e){if(Array.isArray(e))return o(e)}(e)||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}(e)||s(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function r(){return(r=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var i=arguments[t];for(var n in i)Object.prototype.hasOwnProperty.call(i,n)&&(e[n]=i[n])}return e}).apply(this,arguments)}function h(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var i=[],n=!0,a=!1,r=void 0;try{for(var s,o=e[Symbol.iterator]();!(n=(s=o.next()).done)&&(i.push(s.value),!t||i.length!==t);n=!0);}catch(e){a=!0,r=e}finally{try{n||null==o.return||o.return()}finally{if(a)throw r}}return i}}(e,t)||s(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function s(e,t){if(e){if("string"==typeof e)return o(e,t);var i=Object.prototype.toString.call(e).slice(8,-1);return"Object"===i&&e.constructor&&(i=e.constructor.name),"Map"===i||"Set"===i?Array.from(i):"Arguments"===i||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)?o(e,t):void 0}}function o(e,t){(null==t||t>e.length)&&(t=e.length);for(var i=0,n=new Array(t);i<t;i++)n[i]=e[i];return n}function l(e){return(l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var M=function(){function s(){!function(e){if(!(e instanceof s))throw new TypeError("Cannot call a class as a function")}(this)}return function(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}(s,[{key:"isNull",value:function(e){return null===e}},{key:"isUndefined",value:function(e){return void 0===e}},{key:"isUndefinedOrNullOrEmpty",value:function(e){return null==e||""===e}},{key:"isString",value:function(e){return"string"==typeof e||e instanceof String}},{key:"isEmptyString",value:function(e){return""===e}},{key:"isBoolean",value:function(e){return"boolean"==typeof e}},{key:"isTrueOrFalseString",value:function(e){var t=String(e).toLowerCase();return"true"===t||"false"===t}},{key:"isObject",value:function(e){return"object"===l(e)&&null!==e&&!Array.isArray(e)}},{key:"isEmptyObj",value:function(e){for(var t in e)if(Object.prototype.hasOwnProperty.call(e,t))return!1;return!0}},{key:"isNumberStrict",value:function(e){return"number"==typeof e}},{key:"isNumber",value:function(e){return!this.isArray(e)&&!isNaN(parseFloat(e))&&isFinite(e)}},{key:"isDigit",value:function(e){return/\d/.test(e)}},{key:"isNumberOrArabic",value:function(e){var t=this.arabicToLatinNumbers(e,!1,!0,!0);return this.isNumber(t)}},{key:"isInt",value:function(e){return"number"==typeof e&&parseFloat(e)===parseInt(e,10)&&!isNaN(e)}},{key:"isFunction",value:function(e){return"function"==typeof e}},{key:"isIE11",value:function(){return"undefined"!=typeof window&&!!window.MSInputMethodContext&&!!document.documentMode}},{key:"contains",value:function(e,t){return!(!this.isString(e)||!this.isString(t)||""===e||""===t)&&-1!==e.indexOf(t)}},{key:"isInArray",value:function(e,t){return!(!this.isArray(t)||t===[]||this.isUndefined(e))&&-1!==t.indexOf(e)}},{key:"isArray",value:function(e){if("[object Array]"===Object.prototype.toString.call([]))return Array.isArray(e)||"object"===l(e)&&"[object Array]"===Object.prototype.toString.call(e);throw new Error("toString message changed for Object Array")}},{key:"isElement",value:function(e){return"undefined"!=typeof Element&&e instanceof Element}},{key:"isInputElement",value:function(e){return this.isElement(e)&&"input"===e.tagName.toLowerCase()}},{key:"decimalPlaces",value:function(e){var t=h(e.split("."),2)[1];return this.isUndefined(t)?0:t.length}},{key:"indexFirstNonZeroDecimalPlace",value:function(e){var t=h(String(Math.abs(e)).split("."),2)[1];if(this.isUndefined(t))return 0;var i=t.lastIndexOf("0");return-1===i?i=0:i+=2,i}},{key:"keyCodeNumber",value:function(e){return void 0===e.which?e.keyCode:e.which}},{key:"character",value:function(e){var t;if("Unidentified"===e.key||void 0===e.key||this.isSeleniumBot()){var i=this.keyCodeNumber(e);if(i===d.keyCode.AndroidDefault)return d.keyName.AndroidDefault;var n=d.fromCharCodeKeyCode[i];t=s.isUndefinedOrNullOrEmpty(n)?String.fromCharCode(i):n}else{var a;switch(e.key){case"Add":t=d.keyName.NumpadPlus;break;case"Apps":t=d.keyName.ContextMenu;break;case"Crsel":t=d.keyName.CrSel;break;case"Decimal":t=e.char?e.char:d.keyName.NumpadDot;break;case"Del":t="firefox"===(a=this.browser()).name&&a.version<=36||"ie"===a.name&&a.version<=9?d.keyName.Dot:d.keyName.Delete;break;case"Divide":t=d.keyName.NumpadSlash;break;case"Down":t=d.keyName.DownArrow;break;case"Esc":t=d.keyName.Esc;break;case"Exsel":t=d.keyName.ExSel;break;case"Left":t=d.keyName.LeftArrow;break;case"Meta":case"Super":t=d.keyName.OSLeft;break;case"Multiply":t=d.keyName.NumpadMultiply;break;case"Right":t=d.keyName.RightArrow;break;case"Spacebar":t=d.keyName.Space;break;case"Subtract":t=d.keyName.NumpadMinus;break;case"Up":t=d.keyName.UpArrow;break;default:t=e.key}}return t}},{key:"browser",value:function(){var e,t=navigator.userAgent,i=t.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i)||[];return/trident/i.test(i[1])?{name:"ie",version:(e=/\brv[ :]+(\d+)/g.exec(t)||[])[1]||""}:"Chrome"===i[1]&&null!==(e=t.match(/\b(OPR|Edge)\/(\d+)/))?{name:e[1].replace("OPR","opera"),version:e[2]}:(i=i[2]?[i[1],i[2]]:[navigator.appName,navigator.appVersion,"-?"],null!==(e=t.match(/version\/(\d+)/i))&&i.splice(1,1,e[1]),{name:i[0].toLowerCase(),version:i[1]})}},{key:"isSeleniumBot",value:function(){return!0===window.navigator.webdriver}},{key:"isNegative",value:function(e,t,i){var n=1<arguments.length&&void 0!==t?t:"-",a=!(2<arguments.length&&void 0!==i)||i;return e===n||""!==e&&(s.isNumber(e)?e<0:a?this.contains(e,n):this.isNegativeStrict(e,n))}},{key:"isNegativeStrict",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:"-";return e.charAt(0)===i}},{key:"isNegativeWithBrackets",value:function(e,t,i){return e.charAt(0)===t&&this.contains(e,i)}},{key:"isZeroOrHasNoValue",value:function(e){return!/[1-9]/g.test(e)}},{key:"setRawNegativeSign",value:function(e){return this.isNegativeStrict(e,"-")?e:"-".concat(e)}},{key:"replaceCharAt",value:function(e,t,i){return"".concat(e.substr(0,t)).concat(i).concat(e.substr(t+i.length))}},{key:"clampToRangeLimits",value:function(e,t){return Math.max(t.minimumValue,Math.min(t.maximumValue,e))}},{key:"countNumberCharactersOnTheCaretLeftSide",value:function(e,t,i){for(var n=new RegExp("[0-9".concat(i,"-]")),a=0,r=0;r<t;r++)n.test(e[r])&&a++;return a}},{key:"findCaretPositionInFormattedNumber",value:function(e,t,i,n){var a,r=i.length,s=e.length,o=0;for(a=0;a<r&&o<s&&o<t;a++)(e[o]===i[a]||"."===e[o]&&i[a]===n)&&o++;return a}},{key:"countCharInText",value:function(e,t){for(var i=0,n=0;n<t.length;n++)t[n]===e&&i++;return i}},{key:"convertCharacterCountToIndexPosition",value:function(e){return Math.max(e,e-1)}},{key:"getElementSelection",value:function(e){var t,i={};try{t=this.isUndefined(e.selectionStart)}catch(e){t=!1}try{if(t){var n=window.getSelection().getRangeAt(0);i.start=n.startOffset,i.end=n.endOffset,i.length=i.end-i.start}else i.start=e.selectionStart,i.end=e.selectionEnd,i.length=i.end-i.start}catch(e){i.start=0,i.end=0,i.length=0}return i}},{key:"setElementSelection",value:function(e,t,i){var n=2<arguments.length&&void 0!==i?i:null;if(this.isUndefinedOrNullOrEmpty(n)&&(n=t),this.isInputElement(e))e.setSelectionRange(t,n);else if(!s.isNull(e.firstChild)){var a=document.createRange();a.setStart(e.firstChild,t),a.setEnd(e.firstChild,n);var r=window.getSelection();r.removeAllRanges(),r.addRange(a)}}},{key:"throwError",value:function(e){throw new Error(e)}},{key:"warning",value:function(e,t){1<arguments.length&&void 0!==t&&!t||console.warn("Warning: ".concat(e))}},{key:"isWheelUpEvent",value:function(e){return e.deltaY||this.throwError("The event passed as a parameter is not a valid wheel event, '".concat(e.type,"' given.")),e.deltaY<0}},{key:"isWheelDownEvent",value:function(e){return e.deltaY||this.throwError("The event passed as a parameter is not a valid wheel event, '".concat(e.type,"' given.")),0<e.deltaY}},{key:"forceDecimalPlaces",value:function(e,t){var i=h(String(e).split("."),2),n=i[0],a=i[1];return a?"".concat(n,".").concat(a.substr(0,t)):e}},{key:"roundToNearest",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:1e3;return 0===e?0:(0===i&&this.throwError("The `stepPlace` used to round is equal to `0`. This value must not be equal to zero."),Math.round(e/i)*i)}},{key:"modifyAndRoundToNearestAuto",value:function(e,t,i){e=Number(this.forceDecimalPlaces(e,i));var n=Math.abs(e);if(0<=n&&n<1){var a,r=Math.pow(10,-i);if(0===e)return t?r:-r;var s,o=i,l=this.indexFirstNonZeroDecimalPlace(e);return a=o-1<=l?r:Math.pow(10,-(l+1)),s=t?e+a:e-a,this.roundToNearest(s,a)}e=parseInt(e,10);var u,c=Math.abs(e).toString().length;switch(c){case 1:u=0;break;case 2:case 3:u=1;break;case 4:case 5:u=2;break;default:u=c-3}var h,m=Math.pow(10,u);return(h=t?e+m:e-m)<=10&&-10<=h?h:this.roundToNearest(h,m)}},{key:"addAndRoundToNearestAuto",value:function(e,t){return this.modifyAndRoundToNearestAuto(e,!0,t)}},{key:"subtractAndRoundToNearestAuto",value:function(e,t){return this.modifyAndRoundToNearestAuto(e,!1,t)}},{key:"arabicToLatinNumbers",value:function(e,t,i,n){var a=!(1<arguments.length&&void 0!==t)||t,r=2<arguments.length&&void 0!==i&&i,s=3<arguments.length&&void 0!==n&&n;if(this.isNull(e))return e;var o=e.toString();if(""===o)return e;if(null===o.match(/[٠١٢٣٤٥٦٧٨٩۴۵۶]/g))return a&&(o=Number(o)),o;r&&(o=o.replace(/٫/,".")),s&&(o=o.replace(/٬/g,"")),o=o.replace(/[٠١٢٣٤٥٦٧٨٩]/g,function(e){return e.charCodeAt(0)-1632}).replace(/[۰۱۲۳۴۵۶۷۸۹]/g,function(e){return e.charCodeAt(0)-1776});var l=Number(o);return isNaN(l)?l:(a&&(o=l),o)}},{key:"triggerEvent",value:function(e,t,i,n,a){var r,s=1<arguments.length&&void 0!==t?t:document,o=2<arguments.length&&void 0!==i?i:null,l=!(3<arguments.length&&void 0!==n)||n,u=!(4<arguments.length&&void 0!==a)||a;window.CustomEvent?r=new CustomEvent(e,{detail:o,bubbles:l,cancelable:u}):(r=document.createEvent("CustomEvent")).initCustomEvent(e,l,u,{detail:o}),s.dispatchEvent(r)}},{key:"parseStr",value:function(e){var t,i,n,a,r={};if(0===e&&1/e<0&&(e="-0"),e=e.toString(),this.isNegativeStrict(e,"-")?(e=e.slice(1),r.s=-1):r.s=1,-1<(t=e.indexOf("."))&&(e=e.replace(".","")),t<0&&(t=e.length),(i=-1===e.search(/[1-9]/i)?e.length:e.search(/[1-9]/i))===(n=e.length))r.e=0,r.c=[0];else{for(a=n-1;"0"===e.charAt(a);--a)--n;for(--n,r.e=t-i-1,r.c=[],t=0;i<=n;i+=1)r.c[t]=+e.charAt(i),t+=1}return r}},{key:"testMinMax",value:function(e,t){var i=t.c,n=e.c,a=t.s,r=e.s,s=t.e,o=e.e;if(!i[0]||!n[0])return i[0]?a:n[0]?-r:0;if(a!==r)return a;var l=a<0;if(s!==o)return o<s^l?1:-1;for(a=-1,r=(s=i.length)<(o=n.length)?s:o,a+=1;a<r;a+=1)if(i[a]!==n[a])return i[a]>n[a]^l?1:-1;return s===o?0:o<s^l?1:-1}},{key:"randomString",value:function(e){var t=0<arguments.length&&void 0!==e?e:5;return Math.random().toString(36).substr(2,t)}},{key:"domElement",value:function(e){return s.isString(e)?document.querySelector(e):e}},{key:"getElementValue",value:function(e){return"input"===e.tagName.toLowerCase()?e.value:this.text(e)}},{key:"setElementValue",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:null;"input"===e.tagName.toLowerCase()?e.value=i:e.textContent=i}},{key:"setInvalidState",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:"Invalid";""!==i&&!this.isNull(i)||this.throwError("Cannot set the invalid state with an empty message."),e.setCustomValidity(i)}},{key:"setValidState",value:function(e){e.setCustomValidity("")}},{key:"cloneObject",value:function(e){return r({},e)}},{key:"camelize",value:function(e,t,i,n){var a=1<arguments.length&&void 0!==t?t:"-",r=!(2<arguments.length&&void 0!==i)||i,s=!(3<arguments.length&&void 0!==n)||n;if(this.isNull(e))return null;r&&(e=e.replace(/^data-/,""));var o=e.split(a).map(function(e){return"".concat(e.charAt(0).toUpperCase()).concat(e.slice(1))});return o=o.join(""),s&&(o="".concat(o.charAt(0).toLowerCase()).concat(o.slice(1))),o}},{key:"text",value:function(e){var t=e.nodeType;return t===Node.ELEMENT_NODE||t===Node.DOCUMENT_NODE||t===Node.DOCUMENT_FRAGMENT_NODE?e.textContent:t===Node.TEXT_NODE?e.nodeValue:""}},{key:"setText",value:function(e,t){var i=e.nodeType;i!==Node.ELEMENT_NODE&&i!==Node.DOCUMENT_NODE&&i!==Node.DOCUMENT_FRAGMENT_NODE||(e.textContent=t)}},{key:"filterOut",value:function(e,t){var i=this;return e.filter(function(e){return!i.isInArray(e,t)})}},{key:"trimPaddedZerosFromDecimalPlaces",value:function(e){if(""===(e=String(e)))return"";var t=h(e.split("."),2),i=t[0],n=t[1];if(this.isUndefinedOrNullOrEmpty(n))return i;var a=n.replace(/0+$/g,"");return""===a?i:"".concat(i,".").concat(a)}},{key:"getHoveredElement",value:function(){var e=a(document.querySelectorAll(":hover"));return e[e.length-1]}},{key:"arrayTrim",value:function(e,t){var i=e.length;return 0===i||i<t?e:t<0?[]:(e.length=parseInt(t,10),e)}},{key:"arrayUnique",value:function(){var e;return a(new Set((e=[]).concat.apply(e,arguments)))}},{key:"mergeMaps",value:function(){for(var e=arguments.length,t=new Array(e),i=0;i<e;i++)t[i]=arguments[i];return new Map(t.reduce(function(e,t){return e.concat(a(t))},[]))}},{key:"objectKeyLookup",value:function(e,t){var i=Object.entries(e).find(function(e){return e[1]===t}),n=null;return void 0!==i&&(n=i[0]),n}},{key:"insertAt",value:function(e,t,i){if(i>(e=String(e)).length)throw new Error("The given index is out of the string range.");if(1!==t.length)throw new Error("The given string `char` should be only one character long.");return""===e&&0===i?t:"".concat(e.slice(0,i)).concat(t).concat(e.slice(i))}},{key:"scientificToDecimal",value:function(e){var t=Number(e);if(isNaN(t))return NaN;if(e=String(e),!this.contains(e,"e")&&!this.contains(e,"E"))return e;var i=h(e.split(/e/i),2),n=i[0],a=i[1],r=n<0;r&&(n=n.replace("-",""));var s=+a<0;s&&(a=a.replace("-",""));var o,l=h(n.split(/\./),2),u=l[0],c=l[1];return o=s?(o=u.length>a?this.insertAt(u,".",u.length-a):"0.".concat("0".repeat(a-u.length)).concat(u),"".concat(o).concat(c||"")):c?(n="".concat(u).concat(c),a<c.length?this.insertAt(n,".",+a+u.length):"".concat(n).concat("0".repeat(a-c.length))):(n=n.replace(".",""),"".concat(n).concat("0".repeat(Number(a)))),r&&(o="-".concat(o)),o}}]),s}(),u=function(){function t(e){if(function(e){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this),null===e)throw new Error("Invalid AST")}return function(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}(t.prototype,[{key:"evaluate",value:function(e){if(null==e)throw new Error("Invalid AST sub-tree");if("number"===e.type)return e.value;if("unaryMinus"===e.type)return-this.evaluate(e.left);var t=this.evaluate(e.left),i=this.evaluate(e.right);switch(e.type){case"op_+":return Number(t)+Number(i);case"op_-":return t-i;case"op_*":return t*i;case"op_/":return t/i;default:throw new Error("Invalid operator '".concat(e.type,"'"))}}}]),t}(),c=function(){function a(){!function(e){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this)}return function(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}(a,[{key:"createNode",value:function(e,t,i){var n=new a;return n.type=e,n.left=t,n.right=i,n}},{key:"createUnaryNode",value:function(e){var t=new a;return t.type="unaryMinus",t.left=e,t.right=null,t}},{key:"createLeaf",value:function(e){var t=new a;return t.type="number",t.value=e,t}}]),a}();function m(e,t,i){!function(e){if(!(e instanceof m))throw new TypeError("Cannot call a class as a function")}(this),this.type=e,this.value=t,this.symbol=i}var g=function(){function t(e){!function(e){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this),this.text=e,this.textLength=e.length,this.index=0,this.token=new m("Error",0,0)}return function(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}(t.prototype,[{key:"_skipSpaces",value:function(){for(;" "===this.text[this.index]&&this.index<=this.textLength;)this.index++}},{key:"getIndex",value:function(){return this.index}},{key:"getNextToken",value:function(e){var t=0<arguments.length&&void 0!==e?e:".";if(this._skipSpaces(),this.textLength===this.index)return this.token.type="EOT",this.token;if(M.isDigit(this.text[this.index]))return this.token.type="num",this.token.value=this._getNumber(t),this.token;switch(this.token.type="Error",this.text[this.index]){case"+":this.token.type="+";break;case"-":this.token.type="-";break;case"*":this.token.type="*";break;case"/":this.token.type="/";break;case"(":this.token.type="(";break;case")":this.token.type=")"}if("Error"===this.token.type)throw new Error("Unexpected token '".concat(this.token.symbol,"' at position '").concat(this.token.index,"' in the token function"));return this.token.symbol=this.text[this.index],this.index++,this.token}},{key:"_getNumber",value:function(e){this._skipSpaces();for(var t=this.index;this.index<=this.textLength&&M.isDigit(this.text[this.index]);)this.index++;for(this.text[this.index]===e&&this.index++;this.index<=this.textLength&&M.isDigit(this.text[this.index]);)this.index++;if(this.index===t)throw new Error("No number has been found while it was expected");return this.text.substring(t,this.index).replace(e,".")}}]),t}(),v=function(){function i(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:".";return function(e){if(!(e instanceof i))throw new TypeError("Cannot call a class as a function")}(this),this.text=e,this.decimalCharacter=t,this.lexer=new g(e),this.token=this.lexer.getNextToken(this.decimalCharacter),this._exp()}return function(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}(i.prototype,[{key:"_exp",value:function(){var e=this._term(),t=this._moreExp();return c.createNode("op_+",e,t)}},{key:"_moreExp",value:function(){var e,t;switch(this.token.type){case"+":return this.token=this.lexer.getNextToken(this.decimalCharacter),e=this._term(),t=this._moreExp(),c.createNode("op_+",t,e);case"-":return this.token=this.lexer.getNextToken(this.decimalCharacter),e=this._term(),t=this._moreExp(),c.createNode("op_-",t,e)}return c.createLeaf(0)}},{key:"_term",value:function(){var e=this._factor(),t=this._moreTerms();return c.createNode("op_*",e,t)}},{key:"_moreTerms",value:function(){var e,t;switch(this.token.type){case"*":return this.token=this.lexer.getNextToken(this.decimalCharacter),e=this._factor(),t=this._moreTerms(),c.createNode("op_*",t,e);case"/":return this.token=this.lexer.getNextToken(this.decimalCharacter),e=this._factor(),t=this._moreTerms(),c.createNode("op_/",t,e)}return c.createLeaf(1)}},{key:"_factor",value:function(){var e,t,i;switch(this.token.type){case"num":return i=this.token.value,this.token=this.lexer.getNextToken(this.decimalCharacter),c.createLeaf(i);case"-":return this.token=this.lexer.getNextToken(this.decimalCharacter),t=this._factor(),c.createUnaryNode(t);case"(":return this.token=this.lexer.getNextToken(this.decimalCharacter),e=this._exp(),this._match(")"),e;default:throw new Error("Unexpected token '".concat(this.token.symbol,"' with type '").concat(this.token.type,"' at position '").concat(this.token.index,"' in the factor function"))}}},{key:"_match",value:function(e){var t=this.lexer.getIndex()-1;if(this.text[t]!==e)throw new Error("Unexpected token '".concat(this.token.symbol,"' at position '").concat(t,"' in the match function"));this.token=this.lexer.getNextToken(this.decimalCharacter)}}]),i}();function p(e){return function(e){if(Array.isArray(e))return y(e)}(e)||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}(e)||f(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function S(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var i=[],n=!0,a=!1,r=void 0;try{for(var s,o=e[Symbol.iterator]();!(n=(s=o.next()).done)&&(i.push(s.value),!t||i.length!==t);n=!0);}catch(e){a=!0,r=e}finally{try{n||null==o.return||o.return()}finally{if(a)throw r}}return i}}(e,t)||f(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function f(e,t){if(e){if("string"==typeof e)return y(e,t);var i=Object.prototype.toString.call(e).slice(8,-1);return"Object"===i&&e.constructor&&(i=e.constructor.name),"Map"===i||"Set"===i?Array.from(i):"Arguments"===i||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)?y(e,t):void 0}}function y(e,t){(null==t||t>e.length)&&(t=e.length);for(var i=0,n=new Array(t);i<t;i++)n[i]=e[i];return n}function b(){return(b=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var i=arguments[t];for(var n in i)Object.prototype.hasOwnProperty.call(i,n)&&(e[n]=i[n])}return e}).apply(this,arguments)}function w(e){return(w="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function P(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var O,k=function(){function B(){var s=this,e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:null,t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:null,i=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;!function(e){if(!(e instanceof B))throw new TypeError("Cannot call a class as a function")}(this);var n=B._setArgumentsValues(e,t,i),a=n.domElement,r=n.initialValue,o=n.userOptions;if(this.domElement=a,this.defaultRawValue="",this._setSettings(o,!1),this._checkElement(),this.savedCancellableValue=null,this.historyTable=[],this.historyTableIndex=-1,this.onGoingRedo=!1,this.parentForm=this._getParentForm(),!this.runOnce&&this.settings.formatOnPageLoad)this._formatDefaultValueOnPageLoad(r);else{var l;if(M.isNull(r))switch(this.settings.emptyInputBehavior){case B.options.emptyInputBehavior.min:l=this.settings.minimumValue;break;case B.options.emptyInputBehavior.max:l=this.settings.maximumValue;break;case B.options.emptyInputBehavior.zero:l="0";break;case B.options.emptyInputBehavior.focus:case B.options.emptyInputBehavior.press:case B.options.emptyInputBehavior.always:case B.options.emptyInputBehavior.null:l="";break;default:l=this.settings.emptyInputBehavior}else l=r;this._setElementAndRawValue(l)}this.runOnce=!0,this.hasEventListeners=!1,(this.isInputElement||this.isContentEditable)&&(this.settings.noEventListeners||this._createEventListeners(),this._setWritePermissions(!0)),this._saveInitialValues(r),this.sessionStorageAvailable=this.constructor._storageTest(),this.storageNamePrefix="AUTO_",this._setPersistentStorageName(),this.validState=!0,this.isFocused=!1,this.isWheelEvent=!1,this.isDropEvent=!1,this.isEditing=!1,this.rawValueOnFocus=void 0,this.internalModification=!1,this.attributeToWatch=this._getAttributeToWatch(),this.getterSetter=Object.getOwnPropertyDescriptor(this.domElement.__proto__,this.attributeToWatch),this._addWatcher(),this.settings.createLocalList&&this._createLocalList(),this.constructor._addToGlobalList(this),this.global={set:function(t,e){var i=1<arguments.length&&void 0!==e?e:null;s.autoNumericLocalList.forEach(function(e){e.set(t,i)})},setUnformatted:function(t,e){var i=1<arguments.length&&void 0!==e?e:null;s.autoNumericLocalList.forEach(function(e){e.setUnformatted(t,i)})},get:function(e){var t=0<arguments.length&&void 0!==e?e:null,i=[];return s.autoNumericLocalList.forEach(function(e){i.push(e.get())}),s._executeCallback(i,t),i},getNumericString:function(e){var t=0<arguments.length&&void 0!==e?e:null,i=[];return s.autoNumericLocalList.forEach(function(e){i.push(e.getNumericString())}),s._executeCallback(i,t),i},getFormatted:function(e){var t=0<arguments.length&&void 0!==e?e:null,i=[];return s.autoNumericLocalList.forEach(function(e){i.push(e.getFormatted())}),s._executeCallback(i,t),i},getNumber:function(e){var t=0<arguments.length&&void 0!==e?e:null,i=[];return s.autoNumericLocalList.forEach(function(e){i.push(e.getNumber())}),s._executeCallback(i,t),i},getLocalized:function(e){var t=0<arguments.length&&void 0!==e?e:null,i=[];return s.autoNumericLocalList.forEach(function(e){i.push(e.getLocalized())}),s._executeCallback(i,t),i},reformat:function(){s.autoNumericLocalList.forEach(function(e){e.reformat()})},unformat:function(){s.autoNumericLocalList.forEach(function(e){e.unformat()})},unformatLocalized:function(e){var t=0<arguments.length&&void 0!==e?e:null;s.autoNumericLocalList.forEach(function(e){e.unformatLocalized(t)})},update:function(){for(var e=arguments.length,t=new Array(e),i=0;i<e;i++)t[i]=arguments[i];s.autoNumericLocalList.forEach(function(e){e.update.apply(e,t)})},isPristine:function(){var t=!(0<arguments.length&&void 0!==arguments[0])||arguments[0],i=!0;return s.autoNumericLocalList.forEach(function(e){i&&!e.isPristine(t)&&(i=!1)}),i},clear:function(e){var t=0<arguments.length&&void 0!==e&&e;s.autoNumericLocalList.forEach(function(e){e.clear(t)})},remove:function(){s.autoNumericLocalList.forEach(function(e){e.remove()})},wipe:function(){s.autoNumericLocalList.forEach(function(e){e.wipe()})},nuke:function(){s.autoNumericLocalList.forEach(function(e){e.nuke()})},has:function(e){return e instanceof B?s.autoNumericLocalList.has(e.node()):s.autoNumericLocalList.has(e)},addObject:function(e){var t,i;i=e instanceof B?(t=e.node(),e):B.getAutoNumericElement(t=e),s._hasLocalList()||s._createLocalList();var n,a=i._getLocalList();0===a.size&&(i._createLocalList(),a=i._getLocalList()),(n=a instanceof Map?M.mergeMaps(s._getLocalList(),a):(s._addToLocalList(t,i),s._getLocalList())).forEach(function(e){e._setLocalList(n)})},removeObject:function(e,t){var i,n,a=1<arguments.length&&void 0!==t&&t;n=e instanceof B?(i=e.node(),e):B.getAutoNumericElement(i=e);var r=s.autoNumericLocalList;s.autoNumericLocalList.delete(i),r.forEach(function(e){e._setLocalList(s.autoNumericLocalList)}),a||i!==s.node()?n._createLocalList():n._setLocalList(new Map)},empty:function(e){var t=0<arguments.length&&void 0!==e&&e;s.autoNumericLocalList.forEach(function(e){t?e._createLocalList():e._setLocalList(new Map)})},elements:function(){var t=[];return s.autoNumericLocalList.forEach(function(e){t.push(e.node())}),t},getList:function(){return s.autoNumericLocalList},size:function(){return s.autoNumericLocalList.size}},this.options={reset:function(){return s.settings={rawValue:s.defaultRawValue},s.update(B.defaultSettings),s},allowDecimalPadding:function(e){return s.update({allowDecimalPadding:e}),s},alwaysAllowDecimalCharacter:function(e){return s.update({alwaysAllowDecimalCharacter:e}),s},caretPositionOnFocus:function(e){return s.settings.caretPositionOnFocus=e,s},createLocalList:function(e){return s.settings.createLocalList=e,s.settings.createLocalList?s._hasLocalList()||s._createLocalList():s._deleteLocalList(),s},currencySymbol:function(e){return s.update({currencySymbol:e}),s},currencySymbolPlacement:function(e){return s.update({currencySymbolPlacement:e}),s},decimalCharacter:function(e){return s.update({decimalCharacter:e}),s},decimalCharacterAlternative:function(e){return s.settings.decimalCharacterAlternative=e,s},decimalPlaces:function(e){return M.warning("Using `options.decimalPlaces()` instead of calling the specific `options.decimalPlacesRawValue()`, `options.decimalPlacesShownOnFocus()` and `options.decimalPlacesShownOnBlur()` methods will reset those options.\nPlease call the specific methods if you do not want to reset those.",s.settings.showWarnings),s.update({decimalPlaces:e}),s},decimalPlacesRawValue:function(e){return s.update({decimalPlacesRawValue:e}),s},decimalPlacesShownOnBlur:function(e){return s.update({decimalPlacesShownOnBlur:e}),s},decimalPlacesShownOnFocus:function(e){return s.update({decimalPlacesShownOnFocus:e}),s},defaultValueOverride:function(e){return s.update({defaultValueOverride:e}),s},digitalGroupSpacing:function(e){return s.update({digitalGroupSpacing:e}),s},digitGroupSeparator:function(e){return s.update({digitGroupSeparator:e}),s},divisorWhenUnfocused:function(e){return s.update({divisorWhenUnfocused:e}),s},emptyInputBehavior:function(e){return null===s.rawValue&&e!==B.options.emptyInputBehavior.null&&(M.warning("You are trying to modify the `emptyInputBehavior` option to something different than `'null'` (".concat(e,"), but the element raw value is currently set to `null`. This would result in an invalid `rawValue`. In order to fix that, the element value has been changed to the empty string `''`."),s.settings.showWarnings),s.rawValue=""),s.update({emptyInputBehavior:e}),s},eventBubbles:function(e){return s.settings.eventBubbles=e,s},eventIsCancelable:function(e){return s.settings.eventIsCancelable=e,s},failOnUnknownOption:function(e){return s.settings.failOnUnknownOption=e,s},formatOnPageLoad:function(e){return s.settings.formatOnPageLoad=e,s},formulaMode:function(e){return s.settings.formulaMode=e,s},historySize:function(e){return s.settings.historySize=e,s},invalidClass:function(e){return s.settings.invalidClass=e,s},isCancellable:function(e){return s.settings.isCancellable=e,s},leadingZero:function(e){return s.update({leadingZero:e}),s},maximumValue:function(e){return s.update({maximumValue:e}),s},minimumValue:function(e){return s.update({minimumValue:e}),s},modifyValueOnWheel:function(e){return s.settings.modifyValueOnWheel=e,s},negativeBracketsTypeOnBlur:function(e){return s.update({negativeBracketsTypeOnBlur:e}),s},negativePositiveSignPlacement:function(e){return s.update({negativePositiveSignPlacement:e}),s},negativeSignCharacter:function(e){return s.update({negativeSignCharacter:e}),s},noEventListeners:function(e){return e===B.options.noEventListeners.noEvents&&s.settings.noEventListeners===B.options.noEventListeners.addEvents&&s._removeEventListeners(),s.update({noEventListeners:e}),s},onInvalidPaste:function(e){return s.settings.onInvalidPaste=e,s},outputFormat:function(e){return s.settings.outputFormat=e,s},overrideMinMaxLimits:function(e){return s.update({overrideMinMaxLimits:e}),s},positiveSignCharacter:function(e){return s.update({positiveSignCharacter:e}),s},rawValueDivisor:function(e){return s.update({rawValueDivisor:e}),s},readOnly:function(e){return s.settings.readOnly=e,s._setWritePermissions(),s},roundingMethod:function(e){return s.update({roundingMethod:e}),s},saveValueToSessionStorage:function(e){return s.update({saveValueToSessionStorage:e}),s},symbolWhenUnfocused:function(e){return s.update({symbolWhenUnfocused:e}),s},selectNumberOnly:function(e){return s.settings.selectNumberOnly=e,s},selectOnFocus:function(e){return s.settings.selectOnFocus=e,s},serializeSpaces:function(e){return s.settings.serializeSpaces=e,s},showOnlyNumbersOnFocus:function(e){return s.update({showOnlyNumbersOnFocus:e}),s},showPositiveSign:function(e){return s.update({showPositiveSign:e}),s},showWarnings:function(e){return s.settings.showWarnings=e,s},styleRules:function(e){return s.update({styleRules:e}),s},suffixText:function(e){return s.update({suffixText:e}),s},unformatOnHover:function(e){return s.settings.unformatOnHover=e,s},unformatOnSubmit:function(e){return s.settings.unformatOnSubmit=e,s},valuesToStrings:function(e){return s.update({valuesToStrings:e}),s},watchExternalChanges:function(e){return s.update({watchExternalChanges:e}),s},wheelOn:function(e){return s.settings.wheelOn=e,s},wheelStep:function(e){return s.settings.wheelStep=e,s}},this._triggerEvent(B.events.initialized,this.domElement,{newValue:M.getElementValue(this.domElement),newRawValue:this.rawValue,error:null,aNElement:this})}var e,t;return t=[{key:"version",value:function(){return"4.6.0"}},{key:"_setArgumentsValues",value:function(e,t,i){M.isNull(e)&&M.throwError("At least one valid parameter is needed in order to initialize an AutoNumeric object");var n,a,r,s=M.isElement(e),o=M.isString(e),l=M.isObject(t),u=Array.isArray(t)&&0<t.length,c=M.isNumberOrArabic(t)||""===t,h=this._isPreDefinedOptionValid(t),m=M.isNull(t),g=M.isEmptyString(t),d=M.isObject(i),v=Array.isArray(i)&&0<i.length,p=M.isNull(i),f=this._isPreDefinedOptionValid(i);return s&&m&&p?(n=e,a=r=null):s&&c&&p?(n=e,r=t,a=null):s&&l&&p?(n=e,r=null,a=t):s&&h&&p?(n=e,r=null,a=this._getOptionObject(t)):s&&u&&p?(n=e,r=null,a=this.mergeOptions(t)):s&&(m||g)&&d?(n=e,r=null,a=i):s&&(m||g)&&v?(n=e,r=null,a=this.mergeOptions(i)):o&&m&&p?(n=document.querySelector(e),a=r=null):o&&l&&p?(n=document.querySelector(e),r=null,a=t):o&&h&&p?(n=document.querySelector(e),r=null,a=this._getOptionObject(t)):o&&u&&p?(n=document.querySelector(e),r=null,a=this.mergeOptions(t)):o&&(m||g)&&d?(n=document.querySelector(e),r=null,a=i):o&&(m||g)&&v?(n=document.querySelector(e),r=null,a=this.mergeOptions(i)):o&&c&&p?(n=document.querySelector(e),r=t,a=null):o&&c&&d?(n=document.querySelector(e),r=t,a=i):o&&c&&f?(n=document.querySelector(e),r=t,a=this._getOptionObject(i)):o&&c&&v?(n=document.querySelector(e),r=t,a=this.mergeOptions(i)):s&&c&&d?(n=e,r=t,a=i):s&&c&&f?(n=e,r=t,a=this._getOptionObject(i)):s&&c&&v?(n=e,r=t,a=this.mergeOptions(i)):M.throwError("The parameters given to the AutoNumeric object are not valid, '".concat(e,"', '").concat(t,"' and '").concat(i,"' given.")),M.isNull(n)&&M.throwError("The selector '".concat(e,"' did not select any valid DOM element. Please check on which element you called AutoNumeric.")),{domElement:n,initialValue:r,userOptions:a}}},{key:"mergeOptions",value:function(e){var t=this,i={};return e.forEach(function(e){b(i,t._getOptionObject(e))}),i}},{key:"_isPreDefinedOptionValid",value:function(e){return Object.prototype.hasOwnProperty.call(B.predefinedOptions,e)}},{key:"_getOptionObject",value:function(e){var t;return M.isString(e)?null==(t=B.getPredefinedOptions()[e])&&M.warning("The given pre-defined option [".concat(e,"] is not recognized by autoNumeric. Please check that pre-defined option name."),!0):t=e,t}},{key:"_doesFormHandlerListExists",value:function(){var e=w(window.aNFormHandlerMap);return"undefined"!==e&&"object"===e}},{key:"_createFormHandlerList",value:function(){window.aNFormHandlerMap=new Map}},{key:"_checkValuesToStringsArray",value:function(e,t){return M.isInArray(String(e),t)}},{key:"_checkValuesToStringsSettings",value:function(e,t){return this._checkValuesToStringsArray(e,Object.keys(t.valuesToStrings))}},{key:"_checkStringsToValuesSettings",value:function(e,t){return this._checkValuesToStringsArray(e,Object.values(t.valuesToStrings))}},{key:"_unformatAltHovered",value:function(e){e.hoveredWithAlt=!0,e.unformat()}},{key:"_reformatAltHovered",value:function(e){e.hoveredWithAlt=!1,e.reformat()}},{key:"_getChildANInputElement",value:function(e){var t=this,i=e.getElementsByTagName("input"),n=[];return Array.prototype.slice.call(i,0).forEach(function(e){t.test(e)&&n.push(e)}),n}},{key:"test",value:function(e){return this._isInGlobalList(M.domElement(e))}},{key:"_createWeakMap",value:function(e){window[e]=new WeakMap}},{key:"_createGlobalList",value:function(){this.autoNumericGlobalListName="autoNumericGlobalList",this._createWeakMap(this.autoNumericGlobalListName)}},{key:"_doesGlobalListExists",value:function(){var e=w(window[this.autoNumericGlobalListName]);return"undefined"!==e&&"object"===e}},{key:"_addToGlobalList",value:function(e){this._doesGlobalListExists()||this._createGlobalList();var t=e.node();if(this._isInGlobalList(t)){if(this._getFromGlobalList(t)===this)return;M.warning("A reference to the DOM element you just initialized already exists in the global AutoNumeric element list. Please make sure to not initialize the same DOM element multiple times.",e.getSettings().showWarnings)}window[this.autoNumericGlobalListName].set(t,e)}},{key:"_removeFromGlobalList",value:function(e){this._doesGlobalListExists()&&window[this.autoNumericGlobalListName].delete(e.node())}},{key:"_getFromGlobalList",value:function(e){return this._doesGlobalListExists()?window[this.autoNumericGlobalListName].get(e):null}},{key:"_isInGlobalList",value:function(e){return!!this._doesGlobalListExists()&&window[this.autoNumericGlobalListName].has(e)}},{key:"validate",value:function(e,t,i){var n=!(1<arguments.length&&void 0!==t)||t,a=2<arguments.length&&void 0!==i?i:null;!M.isUndefinedOrNullOrEmpty(e)&&M.isObject(e)||M.throwError("The userOptions are invalid ; it should be a valid object, [".concat(e,"] given."));var r,s=M.isObject(a);s||M.isNull(a)||M.throwError("The 'originalOptions' parameter is invalid ; it should either be a valid option object or `null`, [".concat(e,"] given.")),M.isNull(e)||this._convertOldOptionsToNewOnes(e),r=n?b({},this.getDefaultConfig(),e):e,M.isTrueOrFalseString(r.showWarnings)||M.isBoolean(r.showWarnings)||M.throwError("The debug option 'showWarnings' is invalid ; it should be either 'true' or 'false', [".concat(r.showWarnings,"] given."));var o,l=/^[0-9]+$/,u=/[0-9]+/,c=/^-?[0-9]+(\.?[0-9]+)?$/,h=/^[0-9]+(\.?[0-9]+)?$/;M.isTrueOrFalseString(r.allowDecimalPadding)||M.isBoolean(r.allowDecimalPadding)||r.allowDecimalPadding===B.options.allowDecimalPadding.floats||M.throwError("The decimal padding option 'allowDecimalPadding' is invalid ; it should either be `false`, `true` or `'floats'`, [".concat(r.allowDecimalPadding,"] given.")),r.allowDecimalPadding!==B.options.allowDecimalPadding.never&&"false"!==r.allowDecimalPadding||r.decimalPlaces===B.options.decimalPlaces.none&&r.decimalPlacesShownOnBlur===B.options.decimalPlacesShownOnBlur.none&&r.decimalPlacesShownOnFocus===B.options.decimalPlacesShownOnFocus.none||M.warning("Setting 'allowDecimalPadding' to [".concat(r.allowDecimalPadding,"] will override the current 'decimalPlaces*' settings [").concat(r.decimalPlaces,", ").concat(r.decimalPlacesShownOnBlur," and ").concat(r.decimalPlacesShownOnFocus,"]."),r.showWarnings),M.isTrueOrFalseString(r.alwaysAllowDecimalCharacter)||M.isBoolean(r.alwaysAllowDecimalCharacter)||M.throwError("The option 'alwaysAllowDecimalCharacter' is invalid ; it should either be `true` or `false`, [".concat(r.alwaysAllowDecimalCharacter,"] given.")),M.isNull(r.caretPositionOnFocus)||M.isInArray(r.caretPositionOnFocus,[B.options.caretPositionOnFocus.start,B.options.caretPositionOnFocus.end,B.options.caretPositionOnFocus.decimalLeft,B.options.caretPositionOnFocus.decimalRight])||M.throwError("The display on empty string option 'caretPositionOnFocus' is invalid ; it should either be `null`, 'focus', 'press', 'always' or 'zero', [".concat(r.caretPositionOnFocus,"] given.")),o=s?a:this._correctCaretPositionOnFocusAndSelectOnFocusOptions(e),M.isNull(o)||o.caretPositionOnFocus===B.options.caretPositionOnFocus.doNoForceCaretPosition||o.selectOnFocus!==B.options.selectOnFocus.select||M.warning("The 'selectOnFocus' option is set to 'select', which is in conflict with the 'caretPositionOnFocus' which is set to '".concat(o.caretPositionOnFocus,"'. As a result, if this has been called when instantiating an AutoNumeric object, the 'selectOnFocus' option is forced to 'doNotSelect'."),r.showWarnings),M.isInArray(r.digitGroupSeparator,[B.options.digitGroupSeparator.comma,B.options.digitGroupSeparator.dot,B.options.digitGroupSeparator.normalSpace,B.options.digitGroupSeparator.thinSpace,B.options.digitGroupSeparator.narrowNoBreakSpace,B.options.digitGroupSeparator.noBreakSpace,B.options.digitGroupSeparator.noSeparator,B.options.digitGroupSeparator.apostrophe,B.options.digitGroupSeparator.arabicThousandsSeparator,B.options.digitGroupSeparator.dotAbove,B.options.digitGroupSeparator.privateUseTwo])||M.throwError("The thousand separator character option 'digitGroupSeparator' is invalid ; it should be ',', '.', '٬', '˙', \"'\", '', ' ', ' ', ' ', ' ' or empty (''), [".concat(r.digitGroupSeparator,"] given.")),M.isTrueOrFalseString(r.showOnlyNumbersOnFocus)||M.isBoolean(r.showOnlyNumbersOnFocus)||M.throwError("The 'showOnlyNumbersOnFocus' option is invalid ; it should be either 'true' or 'false', [".concat(r.showOnlyNumbersOnFocus,"] given.")),M.isInArray(r.digitalGroupSpacing,[B.options.digitalGroupSpacing.two,B.options.digitalGroupSpacing.twoScaled,B.options.digitalGroupSpacing.three,B.options.digitalGroupSpacing.four])||2<=r.digitalGroupSpacing&&r.digitalGroupSpacing<=4||M.throwError("The grouping separator option for thousands 'digitalGroupSpacing' is invalid ; it should be '2', '2s', '3', or '4', [".concat(r.digitalGroupSpacing,"] given.")),M.isInArray(r.decimalCharacter,[B.options.decimalCharacter.comma,B.options.decimalCharacter.dot,B.options.decimalCharacter.middleDot,B.options.decimalCharacter.arabicDecimalSeparator,B.options.decimalCharacter.decimalSeparatorKeySymbol])||M.throwError("The decimal separator character option 'decimalCharacter' is invalid ; it should be '.', ',', '·', '⎖' or '٫', [".concat(r.decimalCharacter,"] given.")),r.decimalCharacter===r.digitGroupSeparator&&M.throwError("autoNumeric will not function properly when the decimal character 'decimalCharacter' [".concat(r.decimalCharacter,"] and the thousand separator 'digitGroupSeparator' [").concat(r.digitGroupSeparator,"] are the same character.")),M.isNull(r.decimalCharacterAlternative)||M.isString(r.decimalCharacterAlternative)||M.throwError("The alternate decimal separator character option 'decimalCharacterAlternative' is invalid ; it should be a string, [".concat(r.decimalCharacterAlternative,"] given.")),""===r.currencySymbol||M.isString(r.currencySymbol)||M.throwError("The currency symbol option 'currencySymbol' is invalid ; it should be a string, [".concat(r.currencySymbol,"] given.")),M.isInArray(r.currencySymbolPlacement,[B.options.currencySymbolPlacement.prefix,B.options.currencySymbolPlacement.suffix])||M.throwError("The placement of the currency sign option 'currencySymbolPlacement' is invalid ; it should either be 'p' (prefix) or 's' (suffix), [".concat(r.currencySymbolPlacement,"] given.")),M.isInArray(r.negativePositiveSignPlacement,[B.options.negativePositiveSignPlacement.prefix,B.options.negativePositiveSignPlacement.suffix,B.options.negativePositiveSignPlacement.left,B.options.negativePositiveSignPlacement.right,B.options.negativePositiveSignPlacement.none])||M.throwError("The placement of the negative sign option 'negativePositiveSignPlacement' is invalid ; it should either be 'p' (prefix), 's' (suffix), 'l' (left), 'r' (right) or 'null', [".concat(r.negativePositiveSignPlacement,"] given.")),M.isTrueOrFalseString(r.showPositiveSign)||M.isBoolean(r.showPositiveSign)||M.throwError("The show positive sign option 'showPositiveSign' is invalid ; it should be either 'true' or 'false', [".concat(r.showPositiveSign,"] given.")),M.isString(r.suffixText)&&(""===r.suffixText||!M.isNegative(r.suffixText,r.negativeSignCharacter)&&!u.test(r.suffixText))||M.throwError("The additional suffix option 'suffixText' is invalid ; it should not contains the negative sign '".concat(r.negativeSignCharacter,"' nor any numerical characters, [").concat(r.suffixText,"] given.")),M.isString(r.negativeSignCharacter)&&1===r.negativeSignCharacter.length&&!M.isUndefinedOrNullOrEmpty(r.negativeSignCharacter)&&!u.test(r.negativeSignCharacter)||M.throwError("The negative sign character option 'negativeSignCharacter' is invalid ; it should be a single character, and cannot be any numerical characters, [".concat(r.negativeSignCharacter,"] given.")),M.isString(r.positiveSignCharacter)&&1===r.positiveSignCharacter.length&&!M.isUndefinedOrNullOrEmpty(r.positiveSignCharacter)&&!u.test(r.positiveSignCharacter)||M.throwError("The positive sign character option 'positiveSignCharacter' is invalid ; it should be a single character, and cannot be any numerical characters, [".concat(r.positiveSignCharacter,"] given.\nIf you want to hide the positive sign character, you need to set the `showPositiveSign` option to `true`.")),r.negativeSignCharacter===r.positiveSignCharacter&&M.throwError("The positive 'positiveSignCharacter' and negative 'negativeSignCharacter' sign characters cannot be identical ; [".concat(r.negativeSignCharacter,"] given."));var m=S(M.isNull(r.negativeBracketsTypeOnBlur)?["",""]:r.negativeBracketsTypeOnBlur.split(","),2),g=m[0],d=m[1];(M.contains(r.digitGroupSeparator,r.negativeSignCharacter)||M.contains(r.decimalCharacter,r.negativeSignCharacter)||M.contains(r.decimalCharacterAlternative,r.negativeSignCharacter)||M.contains(g,r.negativeSignCharacter)||M.contains(d,r.negativeSignCharacter)||M.contains(r.suffixText,r.negativeSignCharacter))&&M.throwError("The negative sign character option 'negativeSignCharacter' is invalid ; it should not be equal or a part of the digit separator, the decimal character, the decimal character alternative, the negative brackets or the suffix text, [".concat(r.negativeSignCharacter,"] given.")),(M.contains(r.digitGroupSeparator,r.positiveSignCharacter)||M.contains(r.decimalCharacter,r.positiveSignCharacter)||M.contains(r.decimalCharacterAlternative,r.positiveSignCharacter)||M.contains(g,r.positiveSignCharacter)||M.contains(d,r.positiveSignCharacter)||M.contains(r.suffixText,r.positiveSignCharacter))&&M.throwError("The positive sign character option 'positiveSignCharacter' is invalid ; it should not be equal or a part of the digit separator, the decimal character, the decimal character alternative, the negative brackets or the suffix text, [".concat(r.positiveSignCharacter,"] given.")),M.isNull(r.overrideMinMaxLimits)||M.isInArray(r.overrideMinMaxLimits,[B.options.overrideMinMaxLimits.ceiling,B.options.overrideMinMaxLimits.floor,B.options.overrideMinMaxLimits.ignore,B.options.overrideMinMaxLimits.invalid])||M.throwError("The override min & max limits option 'overrideMinMaxLimits' is invalid ; it should either be 'ceiling', 'floor', 'ignore' or 'invalid', [".concat(r.overrideMinMaxLimits,"] given.")),r.overrideMinMaxLimits!==B.options.overrideMinMaxLimits.invalid&&r.overrideMinMaxLimits!==B.options.overrideMinMaxLimits.ignore&&(0<r.minimumValue||r.maximumValue<0)&&M.warning("You've set a `minimumValue` or a `maximumValue` excluding the value `0`. AutoNumeric will force the users to always have a valid value in the input, hence preventing them to clear the field. If you want to allow for temporary invalid values (ie. out-of-range), you should use the 'invalid' option for the 'overrideMinMaxLimits' setting."),M.isString(r.maximumValue)&&c.test(r.maximumValue)||M.throwError("The maximum possible value option 'maximumValue' is invalid ; it should be a string that represents a positive or negative number, [".concat(r.maximumValue,"] given.")),M.isString(r.minimumValue)&&c.test(r.minimumValue)||M.throwError("The minimum possible value option 'minimumValue' is invalid ; it should be a string that represents a positive or negative number, [".concat(r.minimumValue,"] given.")),parseFloat(r.minimumValue)>parseFloat(r.maximumValue)&&M.throwError("The minimum possible value option is greater than the maximum possible value option ; 'minimumValue' [".concat(r.minimumValue,"] should be smaller than 'maximumValue' [").concat(r.maximumValue,"].")),M.isInt(r.decimalPlaces)&&0<=r.decimalPlaces||M.isString(r.decimalPlaces)&&l.test(r.decimalPlaces)||M.throwError("The number of decimal places option 'decimalPlaces' is invalid ; it should be a positive integer, [".concat(r.decimalPlaces,"] given.")),M.isNull(r.decimalPlacesRawValue)||M.isInt(r.decimalPlacesRawValue)&&0<=r.decimalPlacesRawValue||M.isString(r.decimalPlacesRawValue)&&l.test(r.decimalPlacesRawValue)||M.throwError("The number of decimal places for the raw value option 'decimalPlacesRawValue' is invalid ; it should be a positive integer or `null`, [".concat(r.decimalPlacesRawValue,"] given.")),this._validateDecimalPlacesRawValue(r),M.isNull(r.decimalPlacesShownOnFocus)||l.test(String(r.decimalPlacesShownOnFocus))||M.throwError("The number of expanded decimal places option 'decimalPlacesShownOnFocus' is invalid ; it should be a positive integer or `null`, [".concat(r.decimalPlacesShownOnFocus,"] given.")),!M.isNull(r.decimalPlacesShownOnFocus)&&Number(r.decimalPlaces)>Number(r.decimalPlacesShownOnFocus)&&M.warning("The extended decimal places 'decimalPlacesShownOnFocus' [".concat(r.decimalPlacesShownOnFocus,"] should be greater than the 'decimalPlaces' [").concat(r.decimalPlaces,"] value. Currently, this will limit the ability of your user to manually change some of the decimal places. Do you really want to do that?"),r.showWarnings),(M.isNull(r.divisorWhenUnfocused)||h.test(r.divisorWhenUnfocused))&&0!==r.divisorWhenUnfocused&&"0"!==r.divisorWhenUnfocused&&1!==r.divisorWhenUnfocused&&"1"!==r.divisorWhenUnfocused||M.throwError("The divisor option 'divisorWhenUnfocused' is invalid ; it should be a positive number higher than one, preferably an integer, [".concat(r.divisorWhenUnfocused,"] given.")),M.isNull(r.decimalPlacesShownOnBlur)||l.test(r.decimalPlacesShownOnBlur)||M.throwError("The number of decimals shown when unfocused option 'decimalPlacesShownOnBlur' is invalid ; it should be a positive integer or `null`, [".concat(r.decimalPlacesShownOnBlur,"] given.")),M.isNull(r.symbolWhenUnfocused)||M.isString(r.symbolWhenUnfocused)||M.throwError("The symbol to show when unfocused option 'symbolWhenUnfocused' is invalid ; it should be a string, [".concat(r.symbolWhenUnfocused,"] given.")),M.isTrueOrFalseString(r.saveValueToSessionStorage)||M.isBoolean(r.saveValueToSessionStorage)||M.throwError("The save to session storage option 'saveValueToSessionStorage' is invalid ; it should be either 'true' or 'false', [".concat(r.saveValueToSessionStorage,"] given.")),M.isInArray(r.onInvalidPaste,[B.options.onInvalidPaste.error,B.options.onInvalidPaste.ignore,B.options.onInvalidPaste.clamp,B.options.onInvalidPaste.truncate,B.options.onInvalidPaste.replace])||M.throwError("The paste behavior option 'onInvalidPaste' is invalid ; it should either be 'error', 'ignore', 'clamp', 'truncate' or 'replace' (cf. documentation), [".concat(r.onInvalidPaste,"] given.")),M.isInArray(r.roundingMethod,[B.options.roundingMethod.halfUpSymmetric,B.options.roundingMethod.halfUpAsymmetric,B.options.roundingMethod.halfDownSymmetric,B.options.roundingMethod.halfDownAsymmetric,B.options.roundingMethod.halfEvenBankersRounding,B.options.roundingMethod.upRoundAwayFromZero,B.options.roundingMethod.downRoundTowardZero,B.options.roundingMethod.toCeilingTowardPositiveInfinity,B.options.roundingMethod.toFloorTowardNegativeInfinity,B.options.roundingMethod.toNearest05,B.options.roundingMethod.toNearest05Alt,B.options.roundingMethod.upToNext05,B.options.roundingMethod.downToNext05])||M.throwError("The rounding method option 'roundingMethod' is invalid ; it should either be 'S', 'A', 's', 'a', 'B', 'U', 'D', 'C', 'F', 'N05', 'CHF', 'U05' or 'D05' (cf. documentation), [".concat(r.roundingMethod,"] given.")),M.isNull(r.negativeBracketsTypeOnBlur)||M.isInArray(r.negativeBracketsTypeOnBlur,[B.options.negativeBracketsTypeOnBlur.parentheses,B.options.negativeBracketsTypeOnBlur.brackets,B.options.negativeBracketsTypeOnBlur.chevrons,B.options.negativeBracketsTypeOnBlur.curlyBraces,B.options.negativeBracketsTypeOnBlur.angleBrackets,B.options.negativeBracketsTypeOnBlur.japaneseQuotationMarks,B.options.negativeBracketsTypeOnBlur.halfBrackets,B.options.negativeBracketsTypeOnBlur.whiteSquareBrackets,B.options.negativeBracketsTypeOnBlur.quotationMarks,B.options.negativeBracketsTypeOnBlur.guillemets])||M.throwError("The brackets for negative values option 'negativeBracketsTypeOnBlur' is invalid ; it should either be '(,)', '[,]', '<,>', '{,}', '〈,〉', '｢,｣', '⸤,⸥', '⟦,⟧', '‹,›' or '«,»', [".concat(r.negativeBracketsTypeOnBlur,"] given.")),(M.isString(r.emptyInputBehavior)||M.isNumber(r.emptyInputBehavior))&&(M.isInArray(r.emptyInputBehavior,[B.options.emptyInputBehavior.focus,B.options.emptyInputBehavior.press,B.options.emptyInputBehavior.always,B.options.emptyInputBehavior.min,B.options.emptyInputBehavior.max,B.options.emptyInputBehavior.zero,B.options.emptyInputBehavior.null])||c.test(r.emptyInputBehavior))||M.throwError("The display on empty string option 'emptyInputBehavior' is invalid ; it should either be 'focus', 'press', 'always', 'min', 'max', 'zero', 'null', a number, or a string that represents a number, [".concat(r.emptyInputBehavior,"] given.")),r.emptyInputBehavior===B.options.emptyInputBehavior.zero&&(0<r.minimumValue||r.maximumValue<0)&&M.throwError("The 'emptyInputBehavior' option is set to 'zero', but this value is outside of the range defined by 'minimumValue' and 'maximumValue' [".concat(r.minimumValue,", ").concat(r.maximumValue,"].")),c.test(String(r.emptyInputBehavior))&&(this._isWithinRangeWithOverrideOption(r.emptyInputBehavior,r)||M.throwError("The 'emptyInputBehavior' option is set to a number or a string that represents a number, but its value [".concat(r.emptyInputBehavior,"] is outside of the range defined by the 'minimumValue' and 'maximumValue' options [").concat(r.minimumValue,", ").concat(r.maximumValue,"]."))),M.isTrueOrFalseString(r.eventBubbles)||M.isBoolean(r.eventBubbles)||M.throwError("The event bubbles option 'eventBubbles' is invalid ; it should be either 'true' or 'false', [".concat(r.eventBubbles,"] given.")),M.isTrueOrFalseString(r.eventIsCancelable)||M.isBoolean(r.eventIsCancelable)||M.throwError("The event is cancelable option 'eventIsCancelable' is invalid ; it should be either 'true' or 'false', [".concat(r.eventIsCancelable,"] given.")),!M.isBoolean(r.invalidClass)&&/^-?[_a-zA-Z]+[_a-zA-Z0-9-]*$/.test(r.invalidClass)||M.throwError("The name of the 'invalidClass' option is not a valid CSS class name ; it should not be empty, and should follow the '^-?[_a-zA-Z]+[_a-zA-Z0-9-]*$' regex, [".concat(r.invalidClass,"] given.")),M.isInArray(r.leadingZero,[B.options.leadingZero.allow,B.options.leadingZero.deny,B.options.leadingZero.keep])||M.throwError("The leading zero behavior option 'leadingZero' is invalid ; it should either be 'allow', 'deny' or 'keep', [".concat(r.leadingZero,"] given.")),M.isTrueOrFalseString(r.formatOnPageLoad)||M.isBoolean(r.formatOnPageLoad)||M.throwError("The format on initialization option 'formatOnPageLoad' is invalid ; it should be either 'true' or 'false', [".concat(r.formatOnPageLoad,"] given.")),M.isTrueOrFalseString(r.formulaMode)||M.isBoolean(r.formulaMode)||M.throwError("The formula mode option 'formulaMode' is invalid ; it should be either 'true' or 'false', [".concat(r.formulaMode,"] given.")),l.test(r.historySize)&&0!==r.historySize||M.throwError("The history size option 'historySize' is invalid ; it should be a positive integer, [".concat(r.historySize,"] given.")),M.isTrueOrFalseString(r.selectNumberOnly)||M.isBoolean(r.selectNumberOnly)||M.throwError("The select number only option 'selectNumberOnly' is invalid ; it should be either 'true' or 'false', [".concat(r.selectNumberOnly,"] given.")),M.isTrueOrFalseString(r.selectOnFocus)||M.isBoolean(r.selectOnFocus)||M.throwError("The select on focus option 'selectOnFocus' is invalid ; it should be either 'true' or 'false', [".concat(r.selectOnFocus,"] given.")),M.isNull(r.defaultValueOverride)||""===r.defaultValueOverride||c.test(r.defaultValueOverride)||M.throwError("The unformatted default value option 'defaultValueOverride' is invalid ; it should be a string that represents a positive or negative number, [".concat(r.defaultValueOverride,"] given.")),M.isTrueOrFalseString(r.unformatOnSubmit)||M.isBoolean(r.unformatOnSubmit)||M.throwError("The remove formatting on submit option 'unformatOnSubmit' is invalid ; it should be either 'true' or 'false', [".concat(r.unformatOnSubmit,"] given.")),M.isNull(r.valuesToStrings)||M.isObject(r.valuesToStrings)||M.throwError("The option 'valuesToStrings' is invalid ; it should be an object, ideally with 'key -> value' entries, [".concat(r.valuesToStrings,"] given.")),M.isNull(r.outputFormat)||M.isInArray(r.outputFormat,[B.options.outputFormat.string,B.options.outputFormat.number,B.options.outputFormat.dot,B.options.outputFormat.negativeDot,B.options.outputFormat.comma,B.options.outputFormat.negativeComma,B.options.outputFormat.dotNegative,B.options.outputFormat.commaNegative])||M.throwError("The custom locale format option 'outputFormat' is invalid ; it should either be null, 'string', 'number', '.', '-.', ',', '-,', '.-' or ',-', [".concat(r.outputFormat,"] given.")),M.isTrueOrFalseString(r.isCancellable)||M.isBoolean(r.isCancellable)||M.throwError("The cancellable behavior option 'isCancellable' is invalid ; it should be either 'true' or 'false', [".concat(r.isCancellable,"] given.")),M.isTrueOrFalseString(r.modifyValueOnWheel)||M.isBoolean(r.modifyValueOnWheel)||M.throwError("The increment/decrement on mouse wheel option 'modifyValueOnWheel' is invalid ; it should be either 'true' or 'false', [".concat(r.modifyValueOnWheel,"] given.")),M.isTrueOrFalseString(r.watchExternalChanges)||M.isBoolean(r.watchExternalChanges)||M.throwError("The option 'watchExternalChanges' is invalid ; it should be either 'true' or 'false', [".concat(r.watchExternalChanges,"] given.")),M.isInArray(r.wheelOn,[B.options.wheelOn.focus,B.options.wheelOn.hover])||M.throwError("The wheel behavior option 'wheelOn' is invalid ; it should either be 'focus' or 'hover', [".concat(r.wheelOn,"] given.")),(M.isString(r.wheelStep)||M.isNumber(r.wheelStep))&&("progressive"===r.wheelStep||h.test(r.wheelStep))&&0!==Number(r.wheelStep)||M.throwError("The wheel step value option 'wheelStep' is invalid ; it should either be the string 'progressive', or a number or a string that represents a positive number (excluding zero), [".concat(r.wheelStep,"] given.")),M.isInArray(r.serializeSpaces,[B.options.serializeSpaces.plus,B.options.serializeSpaces.percent])||M.throwError("The space replacement character option 'serializeSpaces' is invalid ; it should either be '+' or '%20', [".concat(r.serializeSpaces,"] given.")),M.isTrueOrFalseString(r.noEventListeners)||M.isBoolean(r.noEventListeners)||M.throwError("The option 'noEventListeners' that prevent the creation of event listeners is invalid ; it should be either 'true' or 'false', [".concat(r.noEventListeners,"] given.")),M.isNull(r.styleRules)||M.isObject(r.styleRules)&&(Object.prototype.hasOwnProperty.call(r.styleRules,"positive")||Object.prototype.hasOwnProperty.call(r.styleRules,"negative")||Object.prototype.hasOwnProperty.call(r.styleRules,"ranges")||Object.prototype.hasOwnProperty.call(r.styleRules,"userDefined"))||M.throwError("The option 'styleRules' is invalid ; it should be a correctly structured object, with one or more 'positive', 'negative', 'ranges' or 'userDefined' attributes, [".concat(r.styleRules,"] given.")),M.isNull(r.styleRules)||!Object.prototype.hasOwnProperty.call(r.styleRules,"userDefined")||M.isNull(r.styleRules.userDefined)||r.styleRules.userDefined.forEach(function(e){Object.prototype.hasOwnProperty.call(e,"callback")&&!M.isFunction(e.callback)&&M.throwError("The callback defined in the `userDefined` attribute is not a function, ".concat(w(e.callback)," given."))}),(M.isNull(r.rawValueDivisor)||h.test(r.rawValueDivisor))&&0!==r.rawValueDivisor&&"0"!==r.rawValueDivisor&&1!==r.rawValueDivisor&&"1"!==r.rawValueDivisor||M.throwError("The raw value divisor option 'rawValueDivisor' is invalid ; it should be a positive number higher than one, preferably an integer, [".concat(r.rawValueDivisor,"] given.")),M.isTrueOrFalseString(r.readOnly)||M.isBoolean(r.readOnly)||M.throwError("The option 'readOnly' is invalid ; it should be either 'true' or 'false', [".concat(r.readOnly,"] given.")),M.isTrueOrFalseString(r.unformatOnHover)||M.isBoolean(r.unformatOnHover)||M.throwError("The option 'unformatOnHover' is invalid ; it should be either 'true' or 'false', [".concat(r.unformatOnHover,"] given.")),M.isTrueOrFalseString(r.failOnUnknownOption)||M.isBoolean(r.failOnUnknownOption)||M.throwError("The debug option 'failOnUnknownOption' is invalid ; it should be either 'true' or 'false', [".concat(r.failOnUnknownOption,"] given.")),M.isTrueOrFalseString(r.createLocalList)||M.isBoolean(r.createLocalList)||M.throwError("The debug option 'createLocalList' is invalid ; it should be either 'true' or 'false', [".concat(r.createLocalList,"] given."))}},{key:"_validateDecimalPlacesRawValue",value:function(e){M.isNull(e.decimalPlacesRawValue)||(e.decimalPlacesRawValue<e.decimalPlaces&&M.warning("The number of decimal places to store in the raw value [".concat(e.decimalPlacesRawValue,"] is lower than the ones to display [").concat(e.decimalPlaces,"]. This will likely confuse your users.\nTo solve that, you'd need to either set `decimalPlacesRawValue` to `null`, or set a number of decimal places for the raw value equal of bigger than `decimalPlaces`."),e.showWarnings),e.decimalPlacesRawValue<e.decimalPlacesShownOnFocus&&M.warning("The number of decimal places to store in the raw value [".concat(e.decimalPlacesRawValue,"] is lower than the ones shown on focus [").concat(e.decimalPlacesShownOnFocus,"]. This will likely confuse your users.\nTo solve that, you'd need to either set `decimalPlacesRawValue` to `null`, or set a number of decimal places for the raw value equal of bigger than `decimalPlacesShownOnFocus`."),e.showWarnings),e.decimalPlacesRawValue<e.decimalPlacesShownOnBlur&&M.warning("The number of decimal places to store in the raw value [".concat(e.decimalPlacesRawValue,"] is lower than the ones shown when unfocused [").concat(e.decimalPlacesShownOnBlur,"]. This will likely confuse your users.\nTo solve that, you'd need to either set `decimalPlacesRawValue` to `null`, or set a number of decimal places for the raw value equal of bigger than `decimalPlacesShownOnBlur`."),e.showWarnings))}},{key:"areSettingsValid",value:function(e){var t=!0;try{this.validate(e,!0)}catch(e){t=!1}return t}},{key:"getDefaultConfig",value:function(){return B.defaultSettings}},{key:"getPredefinedOptions",value:function(){return B.predefinedOptions}},{key:"_generateOptionsObjectFromOptionsArray",value:function(e){var t,i=this;return M.isUndefinedOrNullOrEmpty(e)||0===e.length?t=null:(t={},1===e.length&&Array.isArray(e[0])?e[0].forEach(function(e){b(t,i._getOptionObject(e))}):1<=e.length&&e.forEach(function(e){b(t,i._getOptionObject(e))})),t}},{key:"format",value:function(e){if(M.isUndefined(e)||null===e)return null;var t;t=M.isElement(e)?M.getElementValue(e):e,M.isString(t)||M.isNumber(t)||M.throwError('The value "'.concat(t,'" being "set" is not numeric and therefore cannot be used appropriately.'));for(var i=arguments.length,n=new Array(1<i?i-1:0),a=1;a<i;a++)n[a-1]=arguments[a];var r=this._generateOptionsObjectFromOptionsArray(n),s=b({},this.getDefaultConfig(),r);s.isNegativeSignAllowed=t<0,s.isPositiveSignAllowed=0<=t,this._setBrackets(s),this._cachesUsualRegularExpressions(s,{});var o=this._toNumericValue(t,s);return isNaN(Number(o))&&M.throwError("The value [".concat(o,"] that you are trying to format is not a recognized number.")),this._isWithinRangeWithOverrideOption(o,s)||(M.triggerEvent(B.events.formatted,document,{oldValue:null,newValue:null,oldRawValue:null,newRawValue:null,isPristine:null,error:"Range test failed",aNElement:null},!0,!0),M.throwError("The value [".concat(o,"] being set falls outside of the minimumValue [").concat(s.minimumValue,"] and maximumValue [").concat(s.maximumValue,"] range set for this element"))),s.valuesToStrings&&this._checkValuesToStringsSettings(t,s)?s.valuesToStrings[t]:(this._correctNegativePositiveSignPlacementOption(s),this._calculateDecimalPlacesOnInit(s),M.isUndefinedOrNullOrEmpty(s.rawValueDivisor)||0===s.rawValueDivisor||""===o||null===o||(o*=s.rawValueDivisor),o=this._roundFormattedValueShownOnFocus(o,s),o=this._modifyNegativeSignAndDecimalCharacterForFormattedValue(o,s),o=this._addGroupSeparators(o,s,!1,o))}},{key:"formatAndSet",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:null,n=this.format(e,i);return M.setElementValue(e,n),n}},{key:"unformat",value:function(e){if(M.isNumberStrict(e))return e;var t;if(""===(t=M.isElement(e)?M.getElementValue(e):e))return"";if(M.isUndefined(t)||null===t)return null;(M.isArray(t)||M.isObject(t))&&M.throwError("A number or a string representing a number is needed to be able to unformat it, [".concat(t,"] given."));for(var i=arguments.length,n=new Array(1<i?i-1:0),a=1;a<i;a++)n[a-1]=arguments[a];var r=this._generateOptionsObjectFromOptionsArray(n),s=b({},this.getDefaultConfig(),r);if(s.isNegativeSignAllowed=!1,s.isPositiveSignAllowed=!0,t=t.toString(),s.valuesToStrings&&this._checkStringsToValuesSettings(t,s))return M.objectKeyLookup(s.valuesToStrings,t);if(M.isNegative(t,s.negativeSignCharacter))s.isNegativeSignAllowed=!0,s.isPositiveSignAllowed=!1;else if(!M.isNull(s.negativeBracketsTypeOnBlur)){var o=S(s.negativeBracketsTypeOnBlur.split(","),2);s.firstBracket=o[0],s.lastBracket=o[1],t.charAt(0)===s.firstBracket&&t.charAt(t.length-1)===s.lastBracket&&(s.isNegativeSignAllowed=!0,s.isPositiveSignAllowed=!1,t=this._removeBrackets(t,s,!1))}return t=this._convertToNumericString(t,s),new RegExp("[^+-0123456789.]","gi").test(t)?NaN:(this._correctNegativePositiveSignPlacementOption(s),s.decimalPlacesRawValue?s.originalDecimalPlacesRawValue=s.decimalPlacesRawValue:s.originalDecimalPlacesRawValue=s.decimalPlaces,this._calculateDecimalPlacesOnInit(s),M.isUndefinedOrNullOrEmpty(s.rawValueDivisor)||0===s.rawValueDivisor||""===t||null===t||(t/=s.rawValueDivisor),t=(t=this._roundRawValue(t,s)).replace(s.decimalCharacter,"."),t=this._toLocale(t,s.outputFormat,s))}},{key:"unformatAndSet",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:null,n=this.unformat(e,i);return M.setElementValue(e,n),n}},{key:"localize",value:function(e,t){var i,n,a=1<arguments.length&&void 0!==t?t:null;return""===(i=M.isElement(e)?M.getElementValue(e):e)?"":(M.isNull(a)&&(a=B.defaultSettings),i=this.unformat(i,a),0===Number(i)&&a.leadingZero!==B.options.leadingZero.keep&&(i="0"),n=M.isNull(a)?a.outputFormat:B.defaultSettings.outputFormat,this._toLocale(i,n,a))}},{key:"localizeAndSet",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:null,n=this.localize(e,i);return M.setElementValue(e,n),n}},{key:"isManagedByAutoNumeric",value:function(e){return this._isInGlobalList(M.domElement(e))}},{key:"getAutoNumericElement",value:function(e){var t=M.domElement(e);return this.isManagedByAutoNumeric(t)?this._getFromGlobalList(t):null}},{key:"set",value:function(e,t,i,n){var a,r=2<arguments.length&&void 0!==i?i:null,s=!(3<arguments.length&&void 0!==n)||n,o=M.domElement(e);return this.isManagedByAutoNumeric(o)?this.getAutoNumericElement(o).set(t,r,s):(a=!(!M.isNull(r)&&Object.prototype.hasOwnProperty.call(r,"showWarnings"))||r.showWarnings,M.warning("Impossible to find an AutoNumeric object for the given DOM element or selector.",a),null)}},{key:"getNumericString",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:null;return this._get(e,"getNumericString",i)}},{key:"getFormatted",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:null;return this._get(e,"getFormatted",i)}},{key:"getNumber",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:null;return this._get(e,"getNumber",i)}},{key:"_get",value:function(e,t,i){var n=2<arguments.length&&void 0!==i?i:null,a=M.domElement(e);return this.isManagedByAutoNumeric(a)||M.throwError("Impossible to find an AutoNumeric object for the given DOM element or selector."),this.getAutoNumericElement(a)[t](n)}},{key:"getLocalized",value:function(e,t,i){var n=1<arguments.length&&void 0!==t?t:null,a=2<arguments.length&&void 0!==i?i:null,r=M.domElement(e);return this.isManagedByAutoNumeric(r)||M.throwError("Impossible to find an AutoNumeric object for the given DOM element or selector."),this.getAutoNumericElement(r).getLocalized(n,a)}},{key:"_stripAllNonNumberCharacters",value:function(e,t,i,n){return this._stripAllNonNumberCharactersExceptCustomDecimalChar(e,t,i,n).replace(t.decimalCharacter,".")}},{key:"_stripAllNonNumberCharactersExceptCustomDecimalChar",value:function(e,t,i,n){var a=(e=(e=this._normalizeCurrencySuffixAndNegativeSignCharacters(e,t)).replace(t.allowedAutoStrip,"")).match(t.numRegAutoStrip);if(e=a?[a[1],a[2],a[3]].join(""):"",t.leadingZero===B.options.leadingZero.allow||t.leadingZero===B.options.leadingZero.keep){var r="",s=S(e.split(t.decimalCharacter),2),o=s[0],l=s[1],u=o;M.contains(u,t.negativeSignCharacter)&&(r=t.negativeSignCharacter,u=u.replace(t.negativeSignCharacter,"")),""===r&&u.length>t.mIntPos&&"0"===u.charAt(0)&&(u=u.slice(1)),""!==r&&u.length>t.mIntNeg&&"0"===u.charAt(0)&&(u=u.slice(1)),e="".concat(r).concat(u).concat(M.isUndefined(l)?"":t.decimalCharacter+l)}return(i&&t.leadingZero===B.options.leadingZero.deny||!n&&t.leadingZero===B.options.leadingZero.allow)&&(e=e.replace(t.stripReg,"$1$2")),e}},{key:"_toggleNegativeBracket",value:function(e,t,i){return i?this._removeBrackets(e,t):this._addBrackets(e,t)}},{key:"_addBrackets",value:function(e,t){return M.isNull(t.negativeBracketsTypeOnBlur)?e:"".concat(t.firstBracket).concat(e.replace(t.negativeSignCharacter,"")).concat(t.lastBracket)}},{key:"_removeBrackets",value:function(e,t,i){var n,a=!(2<arguments.length&&void 0!==i)||i;return M.isNull(t.negativeBracketsTypeOnBlur)||e.charAt(0)!==t.firstBracket?e:(n=(n=e.replace(t.firstBracket,"")).replace(t.lastBracket,""),a?(n=n.replace(t.currencySymbol,""),this._mergeCurrencySignNegativePositiveSignAndValue(n,t,!0,!1)):"".concat(t.negativeSignCharacter).concat(n))}},{key:"_setBrackets",value:function(e){if(M.isNull(e.negativeBracketsTypeOnBlur))e.firstBracket="",e.lastBracket="";else{var t=S(e.negativeBracketsTypeOnBlur.split(","),2),i=t[0],n=t[1];e.firstBracket=i,e.lastBracket=n}}},{key:"_convertToNumericString",value:function(e,t){e=this._removeBrackets(e,t,!1),e=(e=this._normalizeCurrencySuffixAndNegativeSignCharacters(e,t)).replace(new RegExp("[".concat(t.digitGroupSeparator,"]"),"g"),""),"."!==t.decimalCharacter&&(e=e.replace(t.decimalCharacter,".")),M.isNegative(e)&&e.lastIndexOf("-")===e.length-1&&(e=e.replace("-",""),e="-".concat(e)),t.showPositiveSign&&(e=e.replace(t.positiveSignCharacter,""));var i=t.leadingZero!==B.options.leadingZero.keep,n=M.arabicToLatinNumbers(e,i,!1,!1);return isNaN(n)||(e=n.toString()),e}},{key:"_normalizeCurrencySuffixAndNegativeSignCharacters",value:function(e,t){return e=String(e),t.currencySymbol!==B.options.currencySymbol.none&&(e=e.replace(t.currencySymbol,"")),t.suffixText!==B.options.suffixText.none&&(e=e.replace(t.suffixText,"")),t.negativeSignCharacter!==B.options.negativeSignCharacter.hyphen&&(e=e.replace(t.negativeSignCharacter,"-")),e}},{key:"_toLocale",value:function(e,t,i){if(M.isNull(t)||t===B.options.outputFormat.string)return e;var n;switch(t){case B.options.outputFormat.number:n=Number(e);break;case B.options.outputFormat.dotNegative:n=M.isNegative(e)?e.replace("-","")+"-":e;break;case B.options.outputFormat.comma:case B.options.outputFormat.negativeComma:n=e.replace(".",",");break;case B.options.outputFormat.commaNegative:n=e.replace(".",","),n=M.isNegative(n)?n.replace("-","")+"-":n;break;case B.options.outputFormat.dot:case B.options.outputFormat.negativeDot:n=e;break;default:M.throwError("The given outputFormat [".concat(t,"] option is not recognized."))}return t!==B.options.outputFormat.number&&"-"!==i.negativeSignCharacter&&(n=n.replace("-",i.negativeSignCharacter)),n}},{key:"_modifyNegativeSignAndDecimalCharacterForFormattedValue",value:function(e,t){return"-"!==t.negativeSignCharacter&&(e=e.replace("-",t.negativeSignCharacter)),"."!==t.decimalCharacter&&(e=e.replace(".",t.decimalCharacter)),e}},{key:"_isElementValueEmptyOrOnlyTheNegativeSign",value:function(e,t){return""===e||e===t.negativeSignCharacter}},{key:"_orderValueCurrencySymbolAndSuffixText",value:function(e,t,i){var n;if(t.emptyInputBehavior===B.options.emptyInputBehavior.always||i)switch(t.negativePositiveSignPlacement){case B.options.negativePositiveSignPlacement.left:case B.options.negativePositiveSignPlacement.prefix:case B.options.negativePositiveSignPlacement.none:n=e+t.currencySymbol+t.suffixText;break;default:n=t.currencySymbol+e+t.suffixText}else n=e;return n}},{key:"_addGroupSeparators",value:function(e,t,i,n,a){var r,s=4<arguments.length&&void 0!==a?a:null;if(r=M.isNull(s)?M.isNegative(e,t.negativeSignCharacter)||M.isNegativeWithBrackets(e,t.firstBracket,t.lastBracket):s<0,e=this._stripAllNonNumberCharactersExceptCustomDecimalChar(e,t,!1,i),this._isElementValueEmptyOrOnlyTheNegativeSign(e,t))return this._orderValueCurrencySymbolAndSuffixText(e,t,!0);var o,l=M.isZeroOrHasNoValue(e);switch(r&&(e=e.replace("-","")),t.digitalGroupSpacing=t.digitalGroupSpacing.toString(),t.digitalGroupSpacing){case B.options.digitalGroupSpacing.two:o=/(\d)((\d)(\d{2}?)+)$/;break;case B.options.digitalGroupSpacing.twoScaled:o=/(\d)((?:\d{2}){0,2}\d{3}(?:(?:\d{2}){2}\d{3})*?)$/;break;case B.options.digitalGroupSpacing.four:o=/(\d)((\d{4}?)+)$/;break;case B.options.digitalGroupSpacing.three:default:o=/(\d)((\d{3}?)+)$/}var u,c=S(e.split(t.decimalCharacter),2),h=c[0],m=c[1];if(t.decimalCharacterAlternative&&M.isUndefined(m)){var g=S(e.split(t.decimalCharacterAlternative),2);h=g[0],m=g[1]}if(""!==t.digitGroupSeparator)for(;o.test(h);)h=h.replace(o,"$1".concat(t.digitGroupSeparator,"$2"));return e=0===(u=i?t.decimalPlacesShownOnFocus:t.decimalPlacesShownOnBlur)||M.isUndefined(m)?h:(m.length>u&&(m=m.substring(0,u)),"".concat(h).concat(t.decimalCharacter).concat(m)),e=B._mergeCurrencySignNegativePositiveSignAndValue(e,t,r,l),M.isNull(s)&&(s=n),null!==t.negativeBracketsTypeOnBlur&&(s<0||M.isNegativeStrict(e,t.negativeSignCharacter))&&(e=this._toggleNegativeBracket(e,t,i)),t.suffixText?"".concat(e).concat(t.suffixText):e}},{key:"_mergeCurrencySignNegativePositiveSignAndValue",value:function(e,t,i,n){var a,r="";if(i?r=t.negativeSignCharacter:t.showPositiveSign&&!n&&(r=t.positiveSignCharacter),t.currencySymbolPlacement===B.options.currencySymbolPlacement.prefix)if(t.negativePositiveSignPlacement!==B.options.negativePositiveSignPlacement.none&&(i||!i&&t.showPositiveSign&&!n))switch(t.negativePositiveSignPlacement){case B.options.negativePositiveSignPlacement.prefix:case B.options.negativePositiveSignPlacement.left:a="".concat(r).concat(t.currencySymbol).concat(e);break;case B.options.negativePositiveSignPlacement.right:a="".concat(t.currencySymbol).concat(r).concat(e);break;case B.options.negativePositiveSignPlacement.suffix:a="".concat(t.currencySymbol).concat(e).concat(r)}else a=t.currencySymbol+e;else if(t.currencySymbolPlacement===B.options.currencySymbolPlacement.suffix)if(t.negativePositiveSignPlacement!==B.options.negativePositiveSignPlacement.none&&(i||!i&&t.showPositiveSign&&!n))switch(t.negativePositiveSignPlacement){case B.options.negativePositiveSignPlacement.suffix:case B.options.negativePositiveSignPlacement.right:a="".concat(e).concat(t.currencySymbol).concat(r);break;case B.options.negativePositiveSignPlacement.left:a="".concat(e).concat(r).concat(t.currencySymbol);break;case B.options.negativePositiveSignPlacement.prefix:a="".concat(r).concat(e).concat(t.currencySymbol)}else a=e+t.currencySymbol;return a}},{key:"_truncateZeros",value:function(e,t){var i;switch(t){case 0:i=/(\.(?:\d*[1-9])?)0*$/;break;case 1:i=/(\.\d(?:\d*[1-9])?)0*$/;break;default:i=new RegExp("(\\.\\d{".concat(t,"}(?:\\d*[1-9])?)0*"))}return e=e.replace(i,"$1"),0===t&&(e=e.replace(/\.$/,"")),e}},{key:"_roundRawValue",value:function(e,t){return this._roundValue(e,t,t.decimalPlacesRawValue)}},{key:"_roundFormattedValueShownOnFocus",value:function(e,t){return this._roundValue(e,t,Number(t.decimalPlacesShownOnFocus))}},{key:"_roundFormattedValueShownOnBlur",value:function(e,t){return this._roundValue(e,t,Number(t.decimalPlacesShownOnBlur))}},{key:"_roundFormattedValueShownOnFocusOrBlur",value:function(e,t,i){return i?this._roundFormattedValueShownOnFocus(e,t):this._roundFormattedValueShownOnBlur(e,t)}},{key:"_roundValue",value:function(e,t,i){if(M.isNull(e))return e;if(e=""===e?"0":e.toString(),t.roundingMethod===B.options.roundingMethod.toNearest05||t.roundingMethod===B.options.roundingMethod.toNearest05Alt||t.roundingMethod===B.options.roundingMethod.upToNext05||t.roundingMethod===B.options.roundingMethod.downToNext05)return this._roundCloseTo05(e,t);var n,a=S(B._prepareValueForRounding(e,t),2),r=a[0],s=(e=a[1]).lastIndexOf("."),o=-1===s,l=S(e.split("."),2),u=l[0];if(!(0<l[1]||t.allowDecimalPadding!==B.options.allowDecimalPadding.never&&t.allowDecimalPadding!==B.options.allowDecimalPadding.floats))return 0===Number(e)?u:"".concat(r).concat(u);n=t.allowDecimalPadding===B.options.allowDecimalPadding.always||t.allowDecimalPadding===B.options.allowDecimalPadding.floats?i:0;var c,h=o?e.length-1:s,m=e.length-1-h,g="";if(m<=i){if(g=e,m<n){o&&(g="".concat(g).concat(t.decimalCharacter));for(var d="000000";m<n;)g+=d=d.substring(0,n-m),m+=d.length}else n<m?g=this._truncateZeros(g,n):0===m&&0===n&&(g=g.replace(/\.$/,""));return 0===Number(g)?g:"".concat(r).concat(g)}c=o?i-1:Number(i)+Number(s);var v,p=Number(e.charAt(c+1)),f=e.substring(0,c+1).split("");if(v="."===e.charAt(c)?e.charAt(c-1)%2:e.charAt(c)%2,this._shouldRoundUp(p,t,r,v))for(var y=f.length-1;0<=y;--y)if("."!==f[y]){if(f[y]=+f[y]+1,f[y]<10)break;0<y&&(f[y]="0")}return f=f.slice(0,c+1),g=this._truncateZeros(f.join(""),n),0===Number(g)?g:"".concat(r).concat(g)}},{key:"_roundCloseTo05",value:function(e,t){switch(t.roundingMethod){case B.options.roundingMethod.toNearest05:case B.options.roundingMethod.toNearest05Alt:e=(Math.round(20*e)/20).toString();break;case B.options.roundingMethod.upToNext05:e=(Math.ceil(20*e)/20).toString();break;default:e=(Math.floor(20*e)/20).toString()}return M.contains(e,".")?e.length-e.indexOf(".")<3?e+"0":e:e+".00"}},{key:"_prepareValueForRounding",value:function(e,t){var i="";return M.isNegativeStrict(e,"-")&&(i="-",e=e.replace("-","")),e.match(/^\d/)||(e="0".concat(e)),0===Number(e)&&(i=""),(0<Number(e)&&t.leadingZero!==B.options.leadingZero.keep||0<e.length&&t.leadingZero===B.options.leadingZero.allow)&&(e=e.replace(/^0*(\d)/,"$1")),[i,e]}},{key:"_shouldRoundUp",value:function(e,t,i,n){return 4<e&&t.roundingMethod===B.options.roundingMethod.halfUpSymmetric||4<e&&t.roundingMethod===B.options.roundingMethod.halfUpAsymmetric&&""===i||5<e&&t.roundingMethod===B.options.roundingMethod.halfUpAsymmetric&&"-"===i||5<e&&t.roundingMethod===B.options.roundingMethod.halfDownSymmetric||5<e&&t.roundingMethod===B.options.roundingMethod.halfDownAsymmetric&&""===i||4<e&&t.roundingMethod===B.options.roundingMethod.halfDownAsymmetric&&"-"===i||5<e&&t.roundingMethod===B.options.roundingMethod.halfEvenBankersRounding||5===e&&t.roundingMethod===B.options.roundingMethod.halfEvenBankersRounding&&1===n||0<e&&t.roundingMethod===B.options.roundingMethod.toCeilingTowardPositiveInfinity&&""===i||0<e&&t.roundingMethod===B.options.roundingMethod.toFloorTowardNegativeInfinity&&"-"===i||0<e&&t.roundingMethod===B.options.roundingMethod.upRoundAwayFromZero}},{key:"_truncateDecimalPlaces",value:function(e,t,i,n){i&&(e=this._roundFormattedValueShownOnFocus(e,t));var a=S(e.split(t.decimalCharacter),2),r=a[0],s=a[1];if(s&&s.length>n)if(0<n){var o=s.substring(0,n);e="".concat(r).concat(t.decimalCharacter).concat(o)}else e=r;return e}},{key:"_checkIfInRangeWithOverrideOption",value:function(e,t){if(M.isNull(e)&&t.emptyInputBehavior===B.options.emptyInputBehavior.null||t.overrideMinMaxLimits===B.options.overrideMinMaxLimits.ignore||t.overrideMinMaxLimits===B.options.overrideMinMaxLimits.invalid)return[!0,!0];e=(e=e.toString()).replace(",",".");var i,n=M.parseStr(t.minimumValue),a=M.parseStr(t.maximumValue),r=M.parseStr(e);switch(t.overrideMinMaxLimits){case B.options.overrideMinMaxLimits.floor:i=[-1<M.testMinMax(n,r),!0];break;case B.options.overrideMinMaxLimits.ceiling:i=[!0,M.testMinMax(a,r)<1];break;default:i=[-1<M.testMinMax(n,r),M.testMinMax(a,r)<1]}return i}},{key:"_isWithinRangeWithOverrideOption",value:function(e,t){var i=S(this._checkIfInRangeWithOverrideOption(e,t),2),n=i[0],a=i[1];return n&&a}},{key:"_cleanValueForRangeParse",value:function(e){return e=e.toString().replace(",","."),M.parseStr(e)}},{key:"_isMinimumRangeRespected",value:function(e,t){return-1<M.testMinMax(M.parseStr(t.minimumValue),this._cleanValueForRangeParse(e))}},{key:"_isMaximumRangeRespected",value:function(e,t){return M.testMinMax(M.parseStr(t.maximumValue),this._cleanValueForRangeParse(e))<1}},{key:"_readCookie",value:function(e){for(var t=e+"=",i=document.cookie.split(";"),n="",a=0;a<i.length;a+=1){for(n=i[a];" "===n.charAt(0);)n=n.substring(1,n.length);if(0===n.indexOf(t))return n.substring(t.length,n.length)}return null}},{key:"_storageTest",value:function(){var e="modernizr";try{return sessionStorage.setItem(e,e),sessionStorage.removeItem(e),!0}catch(e){return!1}}},{key:"_correctNegativePositiveSignPlacementOption",value:function(e){if(M.isNull(e.negativePositiveSignPlacement))if(M.isUndefined(e)||!M.isUndefinedOrNullOrEmpty(e.negativePositiveSignPlacement)||M.isUndefinedOrNullOrEmpty(e.currencySymbol))e.negativePositiveSignPlacement=B.options.negativePositiveSignPlacement.left;else switch(e.currencySymbolPlacement){case B.options.currencySymbolPlacement.suffix:e.negativePositiveSignPlacement=B.options.negativePositiveSignPlacement.prefix;break;case B.options.currencySymbolPlacement.prefix:e.negativePositiveSignPlacement=B.options.negativePositiveSignPlacement.left}}},{key:"_correctCaretPositionOnFocusAndSelectOnFocusOptions",value:function(e){return M.isNull(e)?null:(!M.isUndefinedOrNullOrEmpty(e.caretPositionOnFocus)&&M.isUndefinedOrNullOrEmpty(e.selectOnFocus)&&(e.selectOnFocus=B.options.selectOnFocus.doNotSelect),M.isUndefinedOrNullOrEmpty(e.caretPositionOnFocus)&&!M.isUndefinedOrNullOrEmpty(e.selectOnFocus)&&e.selectOnFocus===B.options.selectOnFocus.select&&(e.caretPositionOnFocus=B.options.caretPositionOnFocus.doNoForceCaretPosition),e)}},{key:"_calculateDecimalPlacesOnInit",value:function(e){this._validateDecimalPlacesRawValue(e),e.decimalPlacesShownOnFocus===B.options.decimalPlacesShownOnFocus.useDefault&&(e.decimalPlacesShownOnFocus=e.decimalPlaces),e.decimalPlacesShownOnBlur===B.options.decimalPlacesShownOnBlur.useDefault&&(e.decimalPlacesShownOnBlur=e.decimalPlaces),e.decimalPlacesRawValue===B.options.decimalPlacesRawValue.useDefault&&(e.decimalPlacesRawValue=e.decimalPlaces);var t=0;e.rawValueDivisor&&e.rawValueDivisor!==B.options.rawValueDivisor.none&&(t=String(e.rawValueDivisor).length-1)<0&&(t=0),e.decimalPlacesRawValue=Math.max(Math.max(e.decimalPlacesShownOnBlur,e.decimalPlacesShownOnFocus)+t,Number(e.originalDecimalPlacesRawValue)+t)}},{key:"_calculateDecimalPlacesOnUpdate",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:null;this._validateDecimalPlacesRawValue(e),M.isNull(i)&&M.throwError("When updating the settings, the previous ones should be passed as an argument.");var n="decimalPlaces"in e;if(n||"decimalPlacesRawValue"in e||"decimalPlacesShownOnFocus"in e||"decimalPlacesShownOnBlur"in e||"rawValueDivisor"in e){n?("decimalPlacesShownOnFocus"in e&&e.decimalPlacesShownOnFocus!==B.options.decimalPlacesShownOnFocus.useDefault||(e.decimalPlacesShownOnFocus=e.decimalPlaces),"decimalPlacesShownOnBlur"in e&&e.decimalPlacesShownOnBlur!==B.options.decimalPlacesShownOnBlur.useDefault||(e.decimalPlacesShownOnBlur=e.decimalPlaces),"decimalPlacesRawValue"in e&&e.decimalPlacesRawValue!==B.options.decimalPlacesRawValue.useDefault||(e.decimalPlacesRawValue=e.decimalPlaces)):(M.isUndefined(e.decimalPlacesShownOnFocus)&&(e.decimalPlacesShownOnFocus=i.decimalPlacesShownOnFocus),M.isUndefined(e.decimalPlacesShownOnBlur)&&(e.decimalPlacesShownOnBlur=i.decimalPlacesShownOnBlur));var a=0;e.rawValueDivisor&&e.rawValueDivisor!==B.options.rawValueDivisor.none&&(a=String(e.rawValueDivisor).length-1)<0&&(a=0),e.decimalPlaces||e.decimalPlacesRawValue?e.decimalPlacesRawValue=Math.max(Math.max(e.decimalPlacesShownOnBlur,e.decimalPlacesShownOnFocus)+a,Number(e.decimalPlacesRawValue)+a):e.decimalPlacesRawValue=Math.max(Math.max(e.decimalPlacesShownOnBlur,e.decimalPlacesShownOnFocus)+a,Number(i.originalDecimalPlacesRawValue)+a)}}},{key:"_cachesUsualRegularExpressions",value:function(e,t){var i;i=e.negativeSignCharacter!==B.options.negativeSignCharacter.hyphen?"([-\\".concat(e.negativeSignCharacter,"]?)"):"(-?)",t.aNegRegAutoStrip=i,e.allowedAutoStrip=new RegExp("[^-0123456789\\".concat(e.decimalCharacter,"]"),"g"),e.numRegAutoStrip=new RegExp("".concat(i,"(?:\\").concat(e.decimalCharacter,"?([0-9]+\\").concat(e.decimalCharacter,"[0-9]+)|([0-9]*(?:\\").concat(e.decimalCharacter,"[0-9]*)?))")),e.stripReg=new RegExp("^".concat(t.aNegRegAutoStrip,"0*([0-9])")),e.formulaChars=new RegExp("[0-9".concat(e.decimalCharacter,"+\\-*/() ]"))}},{key:"_convertOldOptionsToNewOnes",value:function(e){var t={aSep:"digitGroupSeparator",nSep:"showOnlyNumbersOnFocus",dGroup:"digitalGroupSpacing",aDec:"decimalCharacter",altDec:"decimalCharacterAlternative",aSign:"currencySymbol",pSign:"currencySymbolPlacement",pNeg:"negativePositiveSignPlacement",aSuffix:"suffixText",oLimits:"overrideMinMaxLimits",vMax:"maximumValue",vMin:"minimumValue",mDec:"decimalPlacesOverride",eDec:"decimalPlacesShownOnFocus",scaleDecimal:"decimalPlacesShownOnBlur",aStor:"saveValueToSessionStorage",mRound:"roundingMethod",aPad:"allowDecimalPadding",nBracket:"negativeBracketsTypeOnBlur",wEmpty:"emptyInputBehavior",lZero:"leadingZero",aForm:"formatOnPageLoad",sNumber:"selectNumberOnly",anDefault:"defaultValueOverride",unSetOnSubmit:"unformatOnSubmit",outputType:"outputFormat",debug:"showWarnings",allowDecimalPadding:!0,alwaysAllowDecimalCharacter:!0,caretPositionOnFocus:!0,createLocalList:!0,currencySymbol:!0,currencySymbolPlacement:!0,decimalCharacter:!0,decimalCharacterAlternative:!0,decimalPlaces:!0,decimalPlacesRawValue:!0,decimalPlacesShownOnBlur:!0,decimalPlacesShownOnFocus:!0,defaultValueOverride:!0,digitalGroupSpacing:!0,digitGroupSeparator:!0,divisorWhenUnfocused:!0,emptyInputBehavior:!0,eventBubbles:!0,eventIsCancelable:!0,failOnUnknownOption:!0,formatOnPageLoad:!0,formulaMode:!0,historySize:!0,isCancellable:!0,leadingZero:!0,maximumValue:!0,minimumValue:!0,modifyValueOnWheel:!0,negativeBracketsTypeOnBlur:!0,negativePositiveSignPlacement:!0,negativeSignCharacter:!0,noEventListeners:!0,onInvalidPaste:!0,outputFormat:!0,overrideMinMaxLimits:!0,positiveSignCharacter:!0,rawValueDivisor:!0,readOnly:!0,roundingMethod:!0,saveValueToSessionStorage:!0,selectNumberOnly:!0,selectOnFocus:!0,serializeSpaces:!0,showOnlyNumbersOnFocus:!0,showPositiveSign:!0,showWarnings:!0,styleRules:!0,suffixText:!0,symbolWhenUnfocused:!0,unformatOnHover:!0,unformatOnSubmit:!0,valuesToStrings:!0,watchExternalChanges:!0,wheelOn:!0,wheelStep:!0,allowedAutoStrip:!0,formulaChars:!0,isNegativeSignAllowed:!0,isPositiveSignAllowed:!0,mIntNeg:!0,mIntPos:!0,numRegAutoStrip:!0,originalDecimalPlaces:!0,originalDecimalPlacesRawValue:!0,stripReg:!0};for(var i in e)if(Object.prototype.hasOwnProperty.call(e,i)){if(!0===t[i])continue;Object.prototype.hasOwnProperty.call(t,i)?(M.warning("You are using the deprecated option name '".concat(i,"'. Please use '").concat(t[i],"' instead from now on. The old option name will be dropped very soon™."),!0),e[t[i]]=e[i],delete e[i]):e.failOnUnknownOption&&M.throwError("Option name '".concat(i,"' is unknown. Please fix the options passed to autoNumeric"))}"mDec"in e&&M.warning("The old `mDec` option has been deprecated in favor of more accurate options ; `decimalPlaces`, `decimalPlacesRawValue`, `decimalPlacesShownOnFocus` and `decimalPlacesShownOnBlur`.",!0)}},{key:"_setNegativePositiveSignPermissions",value:function(e){e.isNegativeSignAllowed=e.minimumValue<0,e.isPositiveSignAllowed=0<=e.maximumValue}},{key:"_toNumericValue",value:function(e,t){var i;return M.isNumber(Number(e))?i=M.scientificToDecimal(e):(i=this._convertToNumericString(e.toString(),t),M.isNumber(Number(i))||(M.warning('The given value "'.concat(e,'" cannot be converted to a numeric one and therefore cannot be used appropriately.'),t.showWarnings),i=NaN)),i}},{key:"_checkIfInRange",value:function(e,t,i){var n=M.parseStr(e);return-1<M.testMinMax(t,n)&&M.testMinMax(i,n)<1}},{key:"_shouldSkipEventKey",value:function(e){var t=M.isInArray(e,d.keyName._allFnKeys),i=e===d.keyName.OSLeft||e===d.keyName.OSRight,n=e===d.keyName.ContextMenu,a=M.isInArray(e,d.keyName._someNonPrintableKeys),r=e===d.keyName.NumLock||e===d.keyName.ScrollLock||e===d.keyName.Insert||e===d.keyName.Command,s=e===d.keyName.Unidentified;return t||i||n||a||s||r}},{key:"_serialize",value:function(e,t,i,n,a){var r,s=this,o=1<arguments.length&&void 0!==t&&t,l=2<arguments.length&&void 0!==i?i:"unformatted",u=3<arguments.length&&void 0!==n?n:"+",c=4<arguments.length&&void 0!==a?a:null,h=[];return"object"===w(e)&&"form"===e.nodeName.toLowerCase()&&Array.prototype.slice.call(e.elements).forEach(function(t){if(t.name&&!t.disabled&&-1===["file","reset","submit","button"].indexOf(t.type))if("select-multiple"===t.type)Array.prototype.slice.call(t.options).forEach(function(e){e.selected&&(o?h.push({name:t.name,value:e.value}):h.push("".concat(encodeURIComponent(t.name),"=").concat(encodeURIComponent(e.value))))});else if(-1===["checkbox","radio"].indexOf(t.type)||t.checked){var e,i;if(s.isManagedByAutoNumeric(t))switch(l){case"unformatted":i=s.getAutoNumericElement(t),M.isNull(i)||(e=s.unformat(t,i.getSettings()));break;case"localized":if(i=s.getAutoNumericElement(t),!M.isNull(i)){var n=M.cloneObject(i.getSettings());M.isNull(c)||(n.outputFormat=c),e=s.localize(t,n)}break;case"formatted":default:e=t.value}else e=t.value;M.isUndefined(e)&&M.throwError("This error should never be hit. If it has, something really wrong happened!"),o?h.push({name:t.name,value:e}):h.push("".concat(encodeURIComponent(t.name),"=").concat(encodeURIComponent(e)))}}),o?r=h:(r=h.join("&"),"+"===u&&(r=r.replace(/%20/g,"+"))),r}},{key:"_serializeNumericString",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:"+";return this._serialize(e,!1,"unformatted",i)}},{key:"_serializeFormatted",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:"+";return this._serialize(e,!1,"formatted",i)}},{key:"_serializeLocalized",value:function(e,t,i){var n=1<arguments.length&&void 0!==t?t:"+",a=2<arguments.length&&void 0!==i?i:null;return this._serialize(e,!1,"localized",n,a)}},{key:"_serializeNumericStringArray",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:"+";return this._serialize(e,!0,"unformatted",i)}},{key:"_serializeFormattedArray",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:"+";return this._serialize(e,!0,"formatted",i)}},{key:"_serializeLocalizedArray",value:function(e,t,i){var n=1<arguments.length&&void 0!==t?t:"+",a=2<arguments.length&&void 0!==i?i:null;return this._serialize(e,!0,"localized",n,a)}}],P((e=B).prototype,[{key:"_saveInitialValues",value:function(e){this.initialValueHtmlAttribute=M.scientificToDecimal(this.domElement.getAttribute("value")),M.isNull(this.initialValueHtmlAttribute)&&(this.initialValueHtmlAttribute=""),this.initialValue=e,M.isNull(this.initialValue)&&(this.initialValue="")}},{key:"_createEventListeners",value:function(){var t=this;this.formulaMode=!1,this._onFocusInFunc=function(e){t._onFocusIn(e)},this._onFocusInAndMouseEnterFunc=function(e){t._onFocusInAndMouseEnter(e)},this._onFocusFunc=function(){t._onFocus()},this._onKeydownFunc=function(e){t._onKeydown(e)},this._onKeypressFunc=function(e){t._onKeypress(e)},this._onKeyupFunc=function(e){t._onKeyup(e)},this._onFocusOutAndMouseLeaveFunc=function(e){t._onFocusOutAndMouseLeave(e)},this._onPasteFunc=function(e){t._onPaste(e)},this._onWheelFunc=function(e){t._onWheel(e)},this._onDropFunc=function(e){t._onDrop(e)},this._onKeydownGlobalFunc=function(e){t._onKeydownGlobal(e)},this._onKeyupGlobalFunc=function(e){t._onKeyupGlobal(e)},this.domElement.addEventListener("focusin",this._onFocusInFunc,!1),this.domElement.addEventListener("focus",this._onFocusInAndMouseEnterFunc,!1),this.domElement.addEventListener("focus",this._onFocusFunc,!1),this.domElement.addEventListener("mouseenter",this._onFocusInAndMouseEnterFunc,!1),this.domElement.addEventListener("keydown",this._onKeydownFunc,!1),this.domElement.addEventListener("keypress",this._onKeypressFunc,!1),this.domElement.addEventListener("keyup",this._onKeyupFunc,!1),this.domElement.addEventListener("blur",this._onFocusOutAndMouseLeaveFunc,!1),this.domElement.addEventListener("mouseleave",this._onFocusOutAndMouseLeaveFunc,!1),this.domElement.addEventListener("paste",this._onPasteFunc,!1),this.domElement.addEventListener("wheel",this._onWheelFunc,!1),this.domElement.addEventListener("drop",this._onDropFunc,!1),this._setupFormListener(),this.hasEventListeners=!0,B._doesGlobalListExists()||(document.addEventListener("keydown",this._onKeydownGlobalFunc,!1),document.addEventListener("keyup",this._onKeyupGlobalFunc,!1))}},{key:"_removeEventListeners",value:function(){this.domElement.removeEventListener("focusin",this._onFocusInFunc,!1),this.domElement.removeEventListener("focus",this._onFocusInAndMouseEnterFunc,!1),this.domElement.removeEventListener("focus",this._onFocusFunc,!1),this.domElement.removeEventListener("mouseenter",this._onFocusInAndMouseEnterFunc,!1),this.domElement.removeEventListener("blur",this._onFocusOutAndMouseLeaveFunc,!1),this.domElement.removeEventListener("mouseleave",this._onFocusOutAndMouseLeaveFunc,!1),this.domElement.removeEventListener("keydown",this._onKeydownFunc,!1),this.domElement.removeEventListener("keypress",this._onKeypressFunc,!1),this.domElement.removeEventListener("keyup",this._onKeyupFunc,!1),this.domElement.removeEventListener("paste",this._onPasteFunc,!1),this.domElement.removeEventListener("wheel",this._onWheelFunc,!1),this.domElement.removeEventListener("drop",this._onDropFunc,!1),this._removeFormListener(),this.hasEventListeners=!1,document.removeEventListener("keydown",this._onKeydownGlobalFunc,!1),document.removeEventListener("keyup",this._onKeyupGlobalFunc,!1)}},{key:"_updateEventListeners",value:function(){this.settings.noEventListeners||this.hasEventListeners||this._createEventListeners(),this.settings.noEventListeners&&this.hasEventListeners&&this._removeEventListeners()}},{key:"_setupFormListener",value:function(){var e=this;M.isNull(this.parentForm)||(this._onFormSubmitFunc=function(){e._onFormSubmit()},this._onFormResetFunc=function(){e._onFormReset()},this._hasParentFormCounter()?this._incrementParentFormCounter():(this._initializeFormCounterToOne(),this.parentForm.addEventListener("submit",this._onFormSubmitFunc,!1),this.parentForm.addEventListener("reset",this._onFormResetFunc,!1),this._storeFormHandlerFunction()))}},{key:"_removeFormListener",value:function(){if(!M.isNull(this.parentForm)){var e=this._getParentFormCounter();1===e?(this.parentForm.removeEventListener("submit",this._getFormHandlerFunction().submitFn,!1),this.parentForm.removeEventListener("reset",this._getFormHandlerFunction().resetFn,!1),this._removeFormDataSetInfo()):1<e?this._decrementParentFormCounter():M.throwError("The AutoNumeric object count on the form is incoherent.")}}},{key:"_hasParentFormCounter",value:function(){return"anCount"in this.parentForm.dataset}},{key:"_getParentFormCounter",value:function(){return Number(this.parentForm.dataset.anCount)}},{key:"_initializeFormCounterToOne",value:function(e){var t=0<arguments.length&&void 0!==e?e:null;this._getFormElement(t).dataset.anCount=1}},{key:"_incrementParentFormCounter",value:function(e){var t=0<arguments.length&&void 0!==e?e:null;this._getFormElement(t).dataset.anCount++}},{key:"_decrementParentFormCounter",value:function(){this.parentForm.dataset.anCount--}},{key:"_hasFormHandlerFunction",value:function(e){var t=0<arguments.length&&void 0!==e?e:null;return"anFormHandler"in this._getFormElement(t).dataset}},{key:"_getFormElement",value:function(e){var t=0<arguments.length&&void 0!==e?e:null;return M.isNull(t)?this.parentForm:t}},{key:"_storeFormHandlerFunction",value:function(e){var t=0<arguments.length&&void 0!==e?e:null;this.constructor._doesFormHandlerListExists()||this.constructor._createFormHandlerList();var i=M.randomString();this._getFormElement(t).dataset.anFormHandler=i,window.aNFormHandlerMap.set(i,{submitFn:this._onFormSubmitFunc,resetFn:this._onFormResetFunc})}},{key:"_getFormHandlerKey",value:function(){this._hasFormHandlerFunction()||M.throwError("Unable to retrieve the form handler name");var e=this.parentForm.dataset.anFormHandler;return""===e&&M.throwError("The form handler name is invalid"),e}},{key:"_getFormHandlerFunction",value:function(){var e=this._getFormHandlerKey();return window.aNFormHandlerMap.get(e)}},{key:"_removeFormDataSetInfo",value:function(){this._decrementParentFormCounter(),window.aNFormHandlerMap.delete(this._getFormHandlerKey()),this.parentForm.removeAttribute("data-an-count"),this.parentForm.removeAttribute("data-an-form-handler")}},{key:"_setWritePermissions",value:function(e){0<arguments.length&&void 0!==e&&e&&this.domElement.readOnly||this.settings.readOnly?this._setReadOnly():this._setReadWrite()}},{key:"_setReadOnly",value:function(){this.isInputElement?this.domElement.readOnly=!0:this.domElement.setAttribute("contenteditable",!1)}},{key:"_setReadWrite",value:function(){this.isInputElement?this.domElement.readOnly=!1:this.domElement.setAttribute("contenteditable",!0)}},{key:"_addWatcher",value:function(){var t=this;if(!M.isUndefined(this.getterSetter)){var e=this.getterSetter,i=e.set,n=e.get;Object.defineProperty(this.domElement,this.attributeToWatch,{configurable:!0,get:function(){return n.call(t.domElement)},set:function(e){i.call(t.domElement,e),t.settings.watchExternalChanges&&!t.internalModification&&t.set(e)}})}}},{key:"_removeWatcher",value:function(){var t=this;if(!M.isUndefined(this.getterSetter)){var e=this.getterSetter,i=e.set,n=e.get;Object.defineProperty(this.domElement,this.attributeToWatch,{configurable:!0,get:function(){return n.call(t.domElement)},set:function(e){i.call(t.domElement,e)}})}}},{key:"_getAttributeToWatch",value:function(){var e;if(this.isInputElement)e="value";else{var t=this.domElement.nodeType;t===Node.ELEMENT_NODE||t===Node.DOCUMENT_NODE||t===Node.DOCUMENT_FRAGMENT_NODE?e="textContent":t===Node.TEXT_NODE&&(e="nodeValue")}return e}},{key:"_historyTableAdd",value:function(){var e=0===this.historyTable.length;if(e||this.rawValue!==this._historyTableCurrentValueUsed()){var t=!0;if(!e){var i=this.historyTableIndex+1;i<this.historyTable.length&&this.rawValue===this.historyTable[i].value?t=!1:M.arrayTrim(this.historyTable,this.historyTableIndex+1)}if(this.historyTableIndex++,t){var n=M.getElementSelection(this.domElement);this.selectionStart=n.start,this.selectionEnd=n.end,this.historyTable.push({value:this.rawValue,start:this.selectionStart+1,end:this.selectionEnd+1}),1<this.historyTable.length&&(this.historyTable[this.historyTableIndex-1].start=this.selectionStart,this.historyTable[this.historyTableIndex-1].end=this.selectionEnd)}this.historyTable.length>this.settings.historySize&&this._historyTableForget()}}},{key:"_historyTableUndoOrRedo",value:function(e){var t;if(0<arguments.length&&void 0!==e&&!e?(t=this.historyTableIndex+1<this.historyTable.length)&&this.historyTableIndex++:(t=0<this.historyTableIndex)&&this.historyTableIndex--,t){var i=this.historyTable[this.historyTableIndex];this.set(i.value,null,!1),M.setElementSelection(this.domElement,i.start,i.end)}}},{key:"_historyTableUndo",value:function(){this._historyTableUndoOrRedo(!0)}},{key:"_historyTableRedo",value:function(){this._historyTableUndoOrRedo(!1)}},{key:"_historyTableForget",value:function(e){for(var t=0<arguments.length&&void 0!==e?e:1,i=[],n=0;n<t;n++)i.push(this.historyTable.shift()),this.historyTableIndex--,this.historyTableIndex<0&&(this.historyTableIndex=0);return 1===i.length?i[0]:i}},{key:"_historyTableCurrentValueUsed",value:function(){var e=this.historyTableIndex;return e<0&&(e=0),M.isUndefinedOrNullOrEmpty(this.historyTable[e])?"":this.historyTable[e].value}},{key:"_parseStyleRules",value:function(){var n=this;M.isUndefinedOrNullOrEmpty(this.settings.styleRules)||""===this.rawValue||(M.isUndefinedOrNullOrEmpty(this.settings.styleRules.positive)||(0<=this.rawValue?this._addCSSClass(this.settings.styleRules.positive):this._removeCSSClass(this.settings.styleRules.positive)),M.isUndefinedOrNullOrEmpty(this.settings.styleRules.negative)||(this.rawValue<0?this._addCSSClass(this.settings.styleRules.negative):this._removeCSSClass(this.settings.styleRules.negative)),M.isUndefinedOrNullOrEmpty(this.settings.styleRules.ranges)||0===this.settings.styleRules.ranges.length||this.settings.styleRules.ranges.forEach(function(e){n.rawValue>=e.min&&n.rawValue<e.max?n._addCSSClass(e.class):n._removeCSSClass(e.class)}),M.isUndefinedOrNullOrEmpty(this.settings.styleRules.userDefined)||0===this.settings.styleRules.userDefined.length||this.settings.styleRules.userDefined.forEach(function(e){if(M.isFunction(e.callback))if(M.isString(e.classes))e.callback(n.rawValue)?n._addCSSClass(e.classes):n._removeCSSClass(e.classes);else if(M.isArray(e.classes))if(2===e.classes.length)e.callback(n.rawValue)?(n._addCSSClass(e.classes[0]),n._removeCSSClass(e.classes[1])):(n._removeCSSClass(e.classes[0]),n._addCSSClass(e.classes[1]));else if(2<e.classes.length){var i=e.callback(n.rawValue);M.isArray(i)?e.classes.forEach(function(e,t){M.isInArray(t,i)?n._addCSSClass(e):n._removeCSSClass(e)}):M.isInt(i)?e.classes.forEach(function(e,t){t===i?n._addCSSClass(e):n._removeCSSClass(e)}):M.isNull(i)?e.classes.forEach(function(e){n._removeCSSClass(e)}):M.throwError("The callback result is not an array nor a valid array index, ".concat(w(i)," given."))}else M.throwError("The classes attribute is not valid for the `styleRules` option.");else M.isUndefinedOrNullOrEmpty(e.classes)?e.callback(n):M.throwError("The callback/classes structure is not valid for the `styleRules` option.");else M.warning("The given `styleRules` callback is not a function, ".concat("undefined"==typeof callback?"undefined":w(callback)," given."),n.settings.showWarnings)}))}},{key:"_addCSSClass",value:function(e){this.domElement.classList.add(e)}},{key:"_removeCSSClass",value:function(e){this.domElement.classList.remove(e)}},{key:"update",value:function(){for(var t=this,e=arguments.length,i=new Array(e),n=0;n<e;n++)i[n]=arguments[n];Array.isArray(i)&&Array.isArray(i[0])&&(i=i[0]);var a=M.cloneObject(this.settings),r=this.rawValue,s={};M.isUndefinedOrNullOrEmpty(i)||0===i.length?s=null:1<=i.length&&i.forEach(function(e){t.constructor._isPreDefinedOptionValid(e)&&(e=t.constructor._getOptionObject(e)),b(s,e)});try{this._setSettings(s,!0),this._setWritePermissions(),this._updateEventListeners(),this.set(r)}catch(e){return this._setSettings(a,!0),M.throwError("Unable to update the settings, those are invalid: [".concat(e,"]")),this}return this}},{key:"getSettings",value:function(){return this.settings}},{key:"set",value:function(e,t,i){var n,a=1<arguments.length&&void 0!==t?t:null,r=!(2<arguments.length&&void 0!==i)||i;if(M.isUndefined(e))return M.warning("You are trying to set an 'undefined' value ; an error could have occurred.",this.settings.showWarnings),this;if(M.isNull(a)||this._setSettings(a,!0),null===e&&this.settings.emptyInputBehavior!==B.options.emptyInputBehavior.null)return M.warning("You are trying to set the `null` value while the `emptyInputBehavior` option is set to ".concat(this.settings.emptyInputBehavior,". If you want to be able to set the `null` value, you need to change the 'emptyInputBehavior' option to `'null'`."),this.settings.showWarnings),this;if(null===e)return this._setElementAndRawValue(null,null,r),this._saveValueToPersistentStorage(),this;if(n=this.constructor._toNumericValue(e,this.settings),isNaN(Number(n)))return M.warning("The value you are trying to set results in `NaN`. The element value is set to the empty string instead.",this.settings.showWarnings),this.setValue("",r),this;if(""===n)switch(this.settings.emptyInputBehavior){case B.options.emptyInputBehavior.zero:n=0;break;case B.options.emptyInputBehavior.min:n=this.settings.minimumValue;break;case B.options.emptyInputBehavior.max:n=this.settings.maximumValue;break;default:M.isNumber(this.settings.emptyInputBehavior)&&(n=Number(this.settings.emptyInputBehavior))}if(""===n)return s=this.settings.emptyInputBehavior===B.options.emptyInputBehavior.always?this.settings.currencySymbol:"",this._setElementAndRawValue(s,"",r),this;var s,o=S(this.constructor._checkIfInRangeWithOverrideOption(n,this.settings),2),l=o[0],u=o[1];if(l&&u&&this.settings.valuesToStrings&&this._checkValuesToStrings(n))return this._setElementAndRawValue(this.settings.valuesToStrings[n],n,r),this._saveValueToPersistentStorage(),this;if(M.isZeroOrHasNoValue(n)&&(n="0"),l&&u){var c=this.constructor._roundRawValue(n,this.settings);return c=this._trimLeadingAndTrailingZeros(c.replace(this.settings.decimalCharacter,".")),n=this._getRawValueToFormat(n),n=this.isFocused?this.constructor._roundFormattedValueShownOnFocus(n,this.settings):(this.settings.divisorWhenUnfocused&&(n=(n/=this.settings.divisorWhenUnfocused).toString()),this.constructor._roundFormattedValueShownOnBlur(n,this.settings)),n=this.constructor._modifyNegativeSignAndDecimalCharacterForFormattedValue(n,this.settings),n=this.constructor._addGroupSeparators(n,this.settings,this.isFocused,this.rawValue,c),!this.isFocused&&this.settings.symbolWhenUnfocused&&(n="".concat(n).concat(this.settings.symbolWhenUnfocused)),(this.settings.decimalPlacesShownOnFocus||this.settings.divisorWhenUnfocused)&&this._saveValueToPersistentStorage(),this._setElementAndRawValue(n,c,r),this._setValidOrInvalidState(c),this}return this._triggerRangeEvents(l,u),M.throwError("The value [".concat(n,"] being set falls outside of the minimumValue [").concat(this.settings.minimumValue,"] and maximumValue [").concat(this.settings.maximumValue,"] range set for this element")),this._removeValueFromPersistentStorage(),this.setValue("",r),this}},{key:"setUnformatted",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:null;if(null===e||M.isUndefined(e))return this;M.isNull(i)||this._setSettings(i,!0);var n=this.constructor._removeBrackets(e,this.settings),a=this.constructor._stripAllNonNumberCharacters(n,this.settings,!0,this.isFocused);return M.isNumber(a)||M.throwError("The value is not a valid one, it's not a numeric string nor a recognized currency."),this.constructor._isWithinRangeWithOverrideOption(a,this.settings)?this.setValue(e):M.throwError("The value is out of the range limits [".concat(this.settings.minimumValue,", ").concat(this.settings.maximumValue,"].")),this}},{key:"setValue",value:function(e,t){var i=!(1<arguments.length&&void 0!==t)||t;return this._setElementAndRawValue(e,i),this}},{key:"_setRawValue",value:function(e,t){var i=!(1<arguments.length&&void 0!==t)||t;if(this.rawValue!==e){var n=this.rawValue;this.rawValue=e,!M.isNull(this.settings.rawValueDivisor)&&0!==this.settings.rawValueDivisor&&""!==e&&null!==e&&this._isUserManuallyEditingTheValue()&&(this.rawValue/=this.settings.rawValueDivisor),this._triggerEvent(B.events.rawValueModified,this.domElement,{oldRawValue:n,newRawValue:this.rawValue,isPristine:this.isPristine(!0),error:null,aNElement:this}),this._parseStyleRules(),i&&this._historyTableAdd()}}},{key:"_setElementValue",value:function(e,t){var i=!(1<arguments.length&&void 0!==t)||t,n=M.getElementValue(this.domElement);return e!==n&&(this.internalModification=!0,M.setElementValue(this.domElement,e),this.internalModification=!1,i&&this._triggerEvent(B.events.formatted,this.domElement,{oldValue:n,newValue:e,oldRawValue:this.rawValue,newRawValue:this.rawValue,isPristine:this.isPristine(!1),error:null,aNElement:this})),this}},{key:"_setElementAndRawValue",value:function(e,t,i){var n=1<arguments.length&&void 0!==t?t:null,a=!(2<arguments.length&&void 0!==i)||i;return M.isNull(n)?n=e:M.isBoolean(n)&&(a=n,n=e),this._setElementValue(e),this._setRawValue(n,a),this}},{key:"_getRawValueToFormat",value:function(e){return M.isNull(this.settings.rawValueDivisor)||0===this.settings.rawValueDivisor||""===e||null===e?e:e*this.settings.rawValueDivisor}},{key:"_checkValuesToStrings",value:function(e){return this.constructor._checkValuesToStringsArray(e,this.valuesToStringsKeys)}},{key:"_isUserManuallyEditingTheValue",value:function(){return this.isFocused&&this.isEditing||this.isDropEvent}},{key:"_executeCallback",value:function(e,t){!M.isNull(t)&&M.isFunction(t)&&t(e,this)}},{key:"_triggerEvent",value:function(e,t,i){var n=1<arguments.length&&void 0!==t?t:document,a=2<arguments.length&&void 0!==i?i:null;M.triggerEvent(e,n,a,this.settings.eventBubbles,this.settings.eventIsCancelable)}},{key:"get",value:function(e){var t=0<arguments.length&&void 0!==e?e:null;return this.getNumericString(t)}},{key:"getNumericString",value:function(e){var t,i=0<arguments.length&&void 0!==e?e:null;return t=M.isNull(this.rawValue)?null:M.trimPaddedZerosFromDecimalPlaces(this.rawValue),this._executeCallback(t,i),t}},{key:"getFormatted",value:function(e){var t=0<arguments.length&&void 0!==e?e:null;"value"in this.domElement||"textContent"in this.domElement||M.throwError("Unable to get the formatted string from the element.");var i=M.getElementValue(this.domElement);return this._executeCallback(i,t),i}},{key:"getNumber",value:function(e){var t,i=0<arguments.length&&void 0!==e?e:null;return t=null===this.rawValue?null:this.constructor._toLocale(this.getNumericString(),"number",this.settings),this._executeCallback(t,i),t}},{key:"getLocalized",value:function(e,t){var i,n,a=0<arguments.length&&void 0!==e?e:null,r=1<arguments.length&&void 0!==t?t:null;M.isFunction(a)&&M.isNull(r)&&(r=a,a=null),(i=M.isEmptyString(this.rawValue)?"":""+Number(this.rawValue))&&0===Number(i)&&this.settings.leadingZero!==B.options.leadingZero.keep&&(i="0"),n=M.isNull(a)?this.settings.outputFormat:a;var s=this.constructor._toLocale(i,n,this.settings);return this._executeCallback(s,r),s}},{key:"reformat",value:function(){return this.set(this.rawValue),this}},{key:"unformat",value:function(){return this._setElementValue(this.getNumericString()),this}},{key:"unformatLocalized",value:function(e){var t=0<arguments.length&&void 0!==e?e:null;return this._setElementValue(this.getLocalized(t)),this}},{key:"isPristine",value:function(e){return 0<arguments.length&&void 0!==e&&!e?this.initialValueHtmlAttribute===this.getFormatted():this.initialValue===this.getNumericString()}},{key:"select",value:function(){return this.settings.selectNumberOnly?this.selectNumber():this._defaultSelectAll(),this}},{key:"_defaultSelectAll",value:function(){M.setElementSelection(this.domElement,0,M.getElementValue(this.domElement).length)}},{key:"selectNumber",value:function(){var e,t,i=M.getElementValue(this.domElement),n=i.length,a=this.settings.currencySymbol.length,r=this.settings.currencySymbolPlacement,s=M.isNegative(i,this.settings.negativeSignCharacter)?1:0,o=this.settings.suffixText.length;if(e=r===B.options.currencySymbolPlacement.suffix?0:this.settings.negativePositiveSignPlacement===B.options.negativePositiveSignPlacement.left&&1==s&&0<a?a+1:a,r===B.options.currencySymbolPlacement.prefix)t=n-o;else switch(this.settings.negativePositiveSignPlacement){case B.options.negativePositiveSignPlacement.left:t=n-(o+a);break;case B.options.negativePositiveSignPlacement.right:t=0<a?n-(a+s+o):n-(a+o);break;default:t=n-(a+o)}return M.setElementSelection(this.domElement,e,t),this}},{key:"selectInteger",value:function(){var e=0,t=0<=this.rawValue;this.settings.currencySymbolPlacement!==B.options.currencySymbolPlacement.prefix&&(this.settings.currencySymbolPlacement!==B.options.currencySymbolPlacement.suffix||this.settings.negativePositiveSignPlacement!==B.options.negativePositiveSignPlacement.prefix&&this.settings.negativePositiveSignPlacement!==B.options.negativePositiveSignPlacement.none)||(this.settings.showPositiveSign&&t||!t&&this.settings.currencySymbolPlacement===B.options.currencySymbolPlacement.prefix&&this.settings.negativePositiveSignPlacement===B.options.negativePositiveSignPlacement.left)&&(e+=1),this.settings.currencySymbolPlacement===B.options.currencySymbolPlacement.prefix&&(e+=this.settings.currencySymbol.length);var i=M.getElementValue(this.domElement),n=i.indexOf(this.settings.decimalCharacter);return-1===n&&(n=this.settings.currencySymbolPlacement===B.options.currencySymbolPlacement.suffix?i.length-this.settings.currencySymbol.length:i.length,t||this.settings.negativePositiveSignPlacement!==B.options.negativePositiveSignPlacement.suffix&&this.settings.currencySymbolPlacement!==B.options.currencySymbolPlacement.suffix||--n,n-=this.settings.suffixText.length),M.setElementSelection(this.domElement,e,n),this}},{key:"selectDecimal",value:function(){var e,t,i=M.getElementValue(this.domElement).indexOf(this.settings.decimalCharacter);return e=-1===i?i=0:(i+=1,t=this.isFocused?this.settings.decimalPlacesShownOnFocus:this.settings.decimalPlacesShownOnBlur,i+Number(t)),M.setElementSelection(this.domElement,i,e),this}},{key:"node",value:function(){return this.domElement}},{key:"parent",value:function(){return this.domElement.parentNode}},{key:"detach",value:function(e){var t,i=0<arguments.length&&void 0!==e?e:null;return t=M.isNull(i)?this.domElement:i.node(),this._removeFromLocalList(t),this}},{key:"attach",value:function(e,t){var i=!(1<arguments.length&&void 0!==t)||t;return this._addToLocalList(e.node()),i&&e.update(this.settings),this}},{key:"formatOther",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:null;return this._formatOrUnformatOther(!0,e,i)}},{key:"unformatOther",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:null;return this._formatOrUnformatOther(!1,e,i)}},{key:"_formatOrUnformatOther",value:function(e,t,i){var n,a,r=2<arguments.length&&void 0!==i?i:null;if(n=M.isNull(r)?this.settings:this._cloneAndMergeSettings(r),M.isElement(t)){var s=M.getElementValue(t);return a=e?B.format(s,n):B.unformat(s,n),M.setElementValue(t,a),null}return e?B.format(t,n):B.unformat(t,n)}},{key:"init",value:function(e,t){var n=this,a=!(1<arguments.length&&void 0!==t)||t,i=!1,r=[];if(M.isString(e)?r=p(document.querySelectorAll(e)):M.isElement(e)?(r.push(e),i=!0):M.isArray(e)?r=e:M.throwError("The given parameters to the 'init' function are invalid."),0===r.length)return M.warning("No valid DOM elements were given hence no AutoNumeric object were instantiated.",!0),[];var s=this._getLocalList(),o=[];return r.forEach(function(e){var t=n.settings.createLocalList;a&&(n.settings.createLocalList=!1);var i=new B(e,M.getElementValue(e),n.settings);a&&(i._setLocalList(s),n._addToLocalList(e,i),n.settings.createLocalList=t),o.push(i)}),i?o[0]:o}},{key:"clear",value:function(e){if(0<arguments.length&&void 0!==e&&e){var t={emptyInputBehavior:B.options.emptyInputBehavior.focus};this.set("",t)}else this.set("");return this}},{key:"remove",value:function(){this._removeValueFromPersistentStorage(),this._removeEventListeners(),this._removeWatcher(),this._removeFromLocalList(this.domElement),this.constructor._removeFromGlobalList(this)}},{key:"wipe",value:function(){this._setElementValue("",!1),this.remove()}},{key:"nuke",value:function(){this.remove(),this.domElement.parentNode.removeChild(this.domElement)}},{key:"form",value:function(e){if(0<arguments.length&&void 0!==e&&e||M.isUndefinedOrNullOrEmpty(this.parentForm)){var t=this._getParentForm();if(!M.isNull(t)&&t!==this.parentForm){var i=this._getFormAutoNumericChildren(this.parentForm);this.parentForm.dataset.anCount=i.length,this._hasFormHandlerFunction(t)?this._incrementParentFormCounter(t):(this._storeFormHandlerFunction(t),this._initializeFormCounterToOne(t))}this.parentForm=t}return this.parentForm}},{key:"_getFormAutoNumericChildren",value:function(e){var t=this;return p(e.querySelectorAll("input")).filter(function(e){return t.constructor.isManagedByAutoNumeric(e)})}},{key:"_getParentForm",value:function(){if("body"===this.domElement.tagName.toLowerCase())return null;var e,t=this.domElement;do{if(t=t.parentNode,M.isNull(t))return null;if("body"===(e=t.tagName?t.tagName.toLowerCase():""))break}while("form"!==e);return"form"===e?t:null}},{key:"formNumericString",value:function(){return this.constructor._serializeNumericString(this.form(),this.settings.serializeSpaces)}},{key:"formFormatted",value:function(){return this.constructor._serializeFormatted(this.form(),this.settings.serializeSpaces)}},{key:"formLocalized",value:function(e){var t,i=0<arguments.length&&void 0!==e?e:null;return t=M.isNull(i)?this.settings.outputFormat:i,this.constructor._serializeLocalized(this.form(),this.settings.serializeSpaces,t)}},{key:"formArrayNumericString",value:function(){return this.constructor._serializeNumericStringArray(this.form(),this.settings.serializeSpaces)}},{key:"formArrayFormatted",value:function(){return this.constructor._serializeFormattedArray(this.form(),this.settings.serializeSpaces)}},{key:"formArrayLocalized",value:function(e){var t,i=0<arguments.length&&void 0!==e?e:null;return t=M.isNull(i)?this.settings.outputFormat:i,this.constructor._serializeLocalizedArray(this.form(),this.settings.serializeSpaces,t)}},{key:"formJsonNumericString",value:function(){return JSON.stringify(this.formArrayNumericString())}},{key:"formJsonFormatted",value:function(){return JSON.stringify(this.formArrayFormatted())}},{key:"formJsonLocalized",value:function(e){var t=0<arguments.length&&void 0!==e?e:null;return JSON.stringify(this.formArrayLocalized(t))}},{key:"formUnformat",value:function(){return this.constructor._getChildANInputElement(this.form()).forEach(function(e){B.getAutoNumericElement(e).unformat()}),this}},{key:"formUnformatLocalized",value:function(){return this.constructor._getChildANInputElement(this.form()).forEach(function(e){B.getAutoNumericElement(e).unformatLocalized()}),this}},{key:"formReformat",value:function(){return this.constructor._getChildANInputElement(this.form()).forEach(function(e){B.getAutoNumericElement(e).reformat()}),this}},{key:"formSubmitNumericString",value:function(e){var t=0<arguments.length&&void 0!==e?e:null;return M.isNull(t)?(this.formUnformat(),this.form().submit(),this.formReformat()):M.isFunction(t)?t(this.formNumericString()):M.throwError("The given callback is not a function."),this}},{key:"formSubmitFormatted",value:function(e){var t=0<arguments.length&&void 0!==e?e:null;return M.isNull(t)?this.form().submit():M.isFunction(t)?t(this.formFormatted()):M.throwError("The given callback is not a function."),this}},{key:"formSubmitLocalized",value:function(e,t){var i=0<arguments.length&&void 0!==e?e:null,n=1<arguments.length&&void 0!==t?t:null;return M.isNull(n)?(this.formUnformatLocalized(),this.form().submit(),this.formReformat()):M.isFunction(n)?n(this.formLocalized(i)):M.throwError("The given callback is not a function."),this}},{key:"formSubmitArrayNumericString",value:function(e){return M.isFunction(e)?e(this.formArrayNumericString()):M.throwError("The given callback is not a function."),this}},{key:"formSubmitArrayFormatted",value:function(e){return M.isFunction(e)?e(this.formArrayFormatted()):M.throwError("The given callback is not a function."),this}},{key:"formSubmitArrayLocalized",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:null;return M.isFunction(e)?e(this.formArrayLocalized(i)):M.throwError("The given callback is not a function."),this}},{key:"formSubmitJsonNumericString",value:function(e){return M.isFunction(e)?e(this.formJsonNumericString()):M.throwError("The given callback is not a function."),this}},{key:"formSubmitJsonFormatted",value:function(e){return M.isFunction(e)?e(this.formJsonFormatted()):M.throwError("The given callback is not a function."),this}},{key:"formSubmitJsonLocalized",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:null;return M.isFunction(e)?e(this.formJsonLocalized(i)):M.throwError("The given callback is not a function."),this}},{key:"_createLocalList",value:function(){this.autoNumericLocalList=new Map,this._addToLocalList(this.domElement)}},{key:"_deleteLocalList",value:function(){delete this.autoNumericLocalList}},{key:"_setLocalList",value:function(e){this.autoNumericLocalList=e}},{key:"_getLocalList",value:function(){return this.autoNumericLocalList}},{key:"_hasLocalList",value:function(){return this.autoNumericLocalList instanceof Map&&0!==this.autoNumericLocalList.size}},{key:"_addToLocalList",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:null;M.isNull(i)&&(i=this),M.isUndefined(this.autoNumericLocalList)?M.throwError("The local list provided does not exists when trying to add an element. [".concat(this.autoNumericLocalList,"] given.")):this.autoNumericLocalList.set(e,i)}},{key:"_removeFromLocalList",value:function(e){M.isUndefined(this.autoNumericLocalList)?this.settings.createLocalList&&M.throwError("The local list provided does not exists when trying to remove an element. [".concat(this.autoNumericLocalList,"] given.")):this.autoNumericLocalList.delete(e)}},{key:"_mergeSettings",value:function(){for(var e=arguments.length,t=new Array(e),i=0;i<e;i++)t[i]=arguments[i];b.apply(void 0,[this.settings].concat(t))}},{key:"_cloneAndMergeSettings",value:function(){for(var e={},t=arguments.length,i=new Array(t),n=0;n<t;n++)i[n]=arguments[n];return b.apply(void 0,[e,this.settings].concat(i)),e}},{key:"_updatePredefinedOptions",value:function(e,t){var i=1<arguments.length&&void 0!==t?t:null;return M.isNull(i)?this.update(e):(this._mergeSettings(e,i),this.update(this.settings)),this}},{key:"french",value:function(e){var t=0<arguments.length&&void 0!==e?e:null;return this._updatePredefinedOptions(B.getPredefinedOptions().French,t),this}},{key:"northAmerican",value:function(e){var t=0<arguments.length&&void 0!==e?e:null;return this._updatePredefinedOptions(B.getPredefinedOptions().NorthAmerican,t),this}},{key:"british",value:function(e){var t=0<arguments.length&&void 0!==e?e:null;return this._updatePredefinedOptions(B.getPredefinedOptions().British,t),this}},{key:"swiss",value:function(e){var t=0<arguments.length&&void 0!==e?e:null;return this._updatePredefinedOptions(B.getPredefinedOptions().Swiss,t),this}},{key:"japanese",value:function(e){var t=0<arguments.length&&void 0!==e?e:null;return this._updatePredefinedOptions(B.getPredefinedOptions().Japanese,t),this}},{key:"spanish",value:function(e){var t=0<arguments.length&&void 0!==e?e:null;return this._updatePredefinedOptions(B.getPredefinedOptions().Spanish,t),this}},{key:"chinese",value:function(e){var t=0<arguments.length&&void 0!==e?e:null;return this._updatePredefinedOptions(B.getPredefinedOptions().Chinese,t),this}},{key:"brazilian",value:function(e){var t=0<arguments.length&&void 0!==e?e:null;return this._updatePredefinedOptions(B.getPredefinedOptions().Brazilian,t),this}},{key:"_runCallbacksFoundInTheSettingsObject",value:function(){for(var e in this.settings)if(Object.prototype.hasOwnProperty.call(this.settings,e)){var t=this.settings[e];if("function"==typeof t)this.settings[e]=t(this,e);else{var i=this.domElement.getAttribute(e);i=M.camelize(i),"function"==typeof this.settings[i]&&(this.settings[e]=i(this,e))}}}},{key:"_setTrailingNegativeSignInfo",value:function(){this.isTrailingNegative=this.settings.currencySymbolPlacement===B.options.currencySymbolPlacement.prefix&&this.settings.negativePositiveSignPlacement===B.options.negativePositiveSignPlacement.suffix||this.settings.currencySymbolPlacement===B.options.currencySymbolPlacement.suffix&&(this.settings.negativePositiveSignPlacement===B.options.negativePositiveSignPlacement.left||this.settings.negativePositiveSignPlacement===B.options.negativePositiveSignPlacement.right)}},{key:"_modifyNegativeSignAndDecimalCharacterForRawValue",value:function(e){return"."!==this.settings.decimalCharacter&&(e=e.replace(this.settings.decimalCharacter,".")),"-"!==this.settings.negativeSignCharacter&&this.settings.isNegativeSignAllowed&&(e=e.replace(this.settings.negativeSignCharacter,"-")),e.match(/\d/)||(e+="0"),e}},{key:"_initialCaretPosition",value:function(e){M.isNull(this.settings.caretPositionOnFocus)&&this.settings.selectOnFocus===B.options.selectOnFocus.doNotSelect&&M.throwError("`_initialCaretPosition()` should never be called when the `caretPositionOnFocus` option is `null`.");var t=this.rawValue<0,i=M.isZeroOrHasNoValue(e),n=e.length,a=0,r=0,s=!1,o=0;this.settings.caretPositionOnFocus!==B.options.caretPositionOnFocus.start&&(a=(e=(e=(e=e.replace(this.settings.negativeSignCharacter,"")).replace(this.settings.positiveSignCharacter,"")).replace(this.settings.currencySymbol,"")).length,s=M.contains(e,this.settings.decimalCharacter),this.settings.caretPositionOnFocus!==B.options.caretPositionOnFocus.decimalLeft&&this.settings.caretPositionOnFocus!==B.options.caretPositionOnFocus.decimalRight||(o=s?(r=e.indexOf(this.settings.decimalCharacter),this.settings.decimalCharacter.length):(r=a,0)));var l="";t?l=this.settings.negativeSignCharacter:this.settings.showPositiveSign&&!i&&(l=this.settings.positiveSignCharacter);var u,c=l.length,h=this.settings.currencySymbol.length;if(this.settings.currencySymbolPlacement===B.options.currencySymbolPlacement.prefix){if(this.settings.caretPositionOnFocus===B.options.caretPositionOnFocus.start)if(this.settings.negativePositiveSignPlacement!==B.options.negativePositiveSignPlacement.none&&(t||!t&&this.settings.showPositiveSign&&!i))switch(this.settings.negativePositiveSignPlacement){case B.options.negativePositiveSignPlacement.prefix:case B.options.negativePositiveSignPlacement.left:case B.options.negativePositiveSignPlacement.right:u=c+h;break;case B.options.negativePositiveSignPlacement.suffix:u=h}else u=h;else if(this.settings.caretPositionOnFocus===B.options.caretPositionOnFocus.end)if(this.settings.negativePositiveSignPlacement!==B.options.negativePositiveSignPlacement.none&&(t||!t&&this.settings.showPositiveSign&&!i))switch(this.settings.negativePositiveSignPlacement){case B.options.negativePositiveSignPlacement.prefix:case B.options.negativePositiveSignPlacement.left:case B.options.negativePositiveSignPlacement.right:u=n;break;case B.options.negativePositiveSignPlacement.suffix:u=h+a}else u=n;else if(this.settings.caretPositionOnFocus===B.options.caretPositionOnFocus.decimalLeft)if(this.settings.negativePositiveSignPlacement!==B.options.negativePositiveSignPlacement.none&&(t||!t&&this.settings.showPositiveSign&&!i))switch(this.settings.negativePositiveSignPlacement){case B.options.negativePositiveSignPlacement.prefix:case B.options.negativePositiveSignPlacement.left:case B.options.negativePositiveSignPlacement.right:u=c+h+r;break;case B.options.negativePositiveSignPlacement.suffix:u=h+r}else u=h+r;else if(this.settings.caretPositionOnFocus===B.options.caretPositionOnFocus.decimalRight)if(this.settings.negativePositiveSignPlacement!==B.options.negativePositiveSignPlacement.none&&(t||!t&&this.settings.showPositiveSign&&!i))switch(this.settings.negativePositiveSignPlacement){case B.options.negativePositiveSignPlacement.prefix:case B.options.negativePositiveSignPlacement.left:case B.options.negativePositiveSignPlacement.right:u=c+h+r+o;break;case B.options.negativePositiveSignPlacement.suffix:u=h+r+o}else u=h+r+o}else if(this.settings.currencySymbolPlacement===B.options.currencySymbolPlacement.suffix)if(this.settings.caretPositionOnFocus===B.options.caretPositionOnFocus.start)if(this.settings.negativePositiveSignPlacement!==B.options.negativePositiveSignPlacement.none&&(t||!t&&this.settings.showPositiveSign&&!i))switch(this.settings.negativePositiveSignPlacement){case B.options.negativePositiveSignPlacement.suffix:case B.options.negativePositiveSignPlacement.right:case B.options.negativePositiveSignPlacement.left:u=0;break;case B.options.negativePositiveSignPlacement.prefix:u=c}else u=0;else if(this.settings.caretPositionOnFocus===B.options.caretPositionOnFocus.end)if(this.settings.negativePositiveSignPlacement!==B.options.negativePositiveSignPlacement.none&&(t||!t&&this.settings.showPositiveSign&&!i))switch(this.settings.negativePositiveSignPlacement){case B.options.negativePositiveSignPlacement.suffix:case B.options.negativePositiveSignPlacement.right:case B.options.negativePositiveSignPlacement.left:u=a;break;case B.options.negativePositiveSignPlacement.prefix:u=c+a}else u=a;else if(this.settings.caretPositionOnFocus===B.options.caretPositionOnFocus.decimalLeft)if(this.settings.negativePositiveSignPlacement!==B.options.negativePositiveSignPlacement.none&&(t||!t&&this.settings.showPositiveSign&&!i))switch(this.settings.negativePositiveSignPlacement){case B.options.negativePositiveSignPlacement.suffix:case B.options.negativePositiveSignPlacement.right:case B.options.negativePositiveSignPlacement.left:u=r;break;case B.options.negativePositiveSignPlacement.prefix:u=c+r}else u=r;else if(this.settings.caretPositionOnFocus===B.options.caretPositionOnFocus.decimalRight)if(this.settings.negativePositiveSignPlacement!==B.options.negativePositiveSignPlacement.none&&(t||!t&&this.settings.showPositiveSign&&!i))switch(this.settings.negativePositiveSignPlacement){case B.options.negativePositiveSignPlacement.suffix:case B.options.negativePositiveSignPlacement.right:case B.options.negativePositiveSignPlacement.left:u=r+o;break;case B.options.negativePositiveSignPlacement.prefix:u=c+r+o}else u=r+o;return u}},{key:"_triggerRangeEvents",value:function(e,t){e||this._triggerEvent(B.events.minRangeExceeded,this.domElement),t||this._triggerEvent(B.events.maxRangeExceeded,this.domElement)}},{key:"_setInvalidState",value:function(){this.isInputElement?M.setInvalidState(this.domElement):this._addCSSClass(this.settings.invalidClass),this._triggerEvent(B.events.invalidValue,this.domElement),this.validState=!1}},{key:"_setValidState",value:function(){this.isInputElement?M.setValidState(this.domElement):this._removeCSSClass(this.settings.invalidClass),this.validState||this._triggerEvent(B.events.correctedValue,this.domElement),this.validState=!0}},{key:"_setValidOrInvalidState",value:function(e){if(this.settings.overrideMinMaxLimits===B.options.overrideMinMaxLimits.invalid){var t=this.constructor._isMinimumRangeRespected(e,this.settings),i=this.constructor._isMaximumRangeRespected(e,this.settings);t&&i?this._setValidState():this._setInvalidState(),this._triggerRangeEvents(t,i)}}},{key:"_keepAnOriginalSettingsCopy",value:function(){this.originalDigitGroupSeparator=this.settings.digitGroupSeparator,this.originalCurrencySymbol=this.settings.currencySymbol,this.originalSuffixText=this.settings.suffixText}},{key:"_trimLeadingAndTrailingZeros",value:function(e){if(""===e||null===e)return e;if(this.settings.leadingZero!==B.options.leadingZero.keep){if(0===Number(e))return"0";e=e.replace(/^(-)?0+(?=\d)/g,"$1")}return M.contains(e,".")&&(e=e.replace(/(\.[0-9]*?)0+$/,"$1")),e.replace(/\.$/,"")}},{key:"_setPersistentStorageName",value:function(){this.settings.saveValueToSessionStorage&&(""===this.domElement.name||M.isUndefined(this.domElement.name)?this.rawValueStorageName="".concat(this.storageNamePrefix).concat(this.domElement.id):this.rawValueStorageName="".concat(this.storageNamePrefix).concat(decodeURIComponent(this.domElement.name)))}},{key:"_saveValueToPersistentStorage",value:function(){this.settings.saveValueToSessionStorage&&(this.sessionStorageAvailable?sessionStorage.setItem(this.rawValueStorageName,this.rawValue):document.cookie="".concat(this.rawValueStorageName,"=").concat(this.rawValue,"; expires= ; path=/"))}},{key:"_getValueFromPersistentStorage",value:function(){return this.settings.saveValueToSessionStorage?this.sessionStorageAvailable?sessionStorage.getItem(this.rawValueStorageName):this.constructor._readCookie(this.rawValueStorageName):(M.warning("`_getValueFromPersistentStorage()` is called but `settings.saveValueToSessionStorage` is false. There must be an error that needs fixing.",this.settings.showWarnings),null)}},{key:"_removeValueFromPersistentStorage",value:function(){if(this.settings.saveValueToSessionStorage)if(this.sessionStorageAvailable)sessionStorage.removeItem(this.rawValueStorageName);else{var e=new Date;e.setTime(e.getTime()-864e5);var t="; expires=".concat(e.toUTCString());document.cookie="".concat(this.rawValueStorageName,"='' ;").concat(t,"; path=/")}}},{key:"_getDefaultValue",value:function(e){var t=e.getAttribute("value");return M.isNull(t)?"":t}},{key:"_onFocusInAndMouseEnter",value:function(e){if(this.isEditing=!1,!this.formulaMode&&this.settings.unformatOnHover&&"mouseenter"===e.type&&e.altKey)this.constructor._unformatAltHovered(this);else if("focus"===e.type&&(this.isFocused=!0,this.rawValueOnFocus=this.rawValue),"focus"===e.type&&this.settings.unformatOnHover&&this.hoveredWithAlt&&this.constructor._reformatAltHovered(this),"focus"===e.type||"mouseenter"===e.type&&!this.isFocused){var t=null;this.settings.emptyInputBehavior===B.options.emptyInputBehavior.focus&&this.rawValue<0&&null!==this.settings.negativeBracketsTypeOnBlur&&this.settings.isNegativeSignAllowed&&(t=this.constructor._removeBrackets(M.getElementValue(this.domElement),this.settings));var i=this._getRawValueToFormat(this.rawValue);if(""!==i){var n=this.constructor._roundFormattedValueShownOnFocusOrBlur(i,this.settings,this.isFocused);t=this.settings.showOnlyNumbersOnFocus===B.options.showOnlyNumbersOnFocus.onlyNumbers?(this.settings.digitGroupSeparator="",this.settings.currencySymbol="",this.settings.suffixText="",n.replace(".",this.settings.decimalCharacter)):M.isNull(n)?"":this.constructor._addGroupSeparators(n.replace(".",this.settings.decimalCharacter),this.settings,this.isFocused,i)}M.isNull(t)?this.valueOnFocus="":this.valueOnFocus=t,this.lastVal=this.valueOnFocus;var a=this.constructor._isElementValueEmptyOrOnlyTheNegativeSign(this.valueOnFocus,this.settings),r=this.constructor._orderValueCurrencySymbolAndSuffixText(this.valueOnFocus,this.settings,!0),s=a&&""!==r&&this.settings.emptyInputBehavior===B.options.emptyInputBehavior.focus;s&&(t=r),M.isNull(t)||this._setElementValue(t),s&&r===this.settings.currencySymbol&&this.settings.currencySymbolPlacement===B.options.currencySymbolPlacement.suffix&&M.setElementSelection(e.target,0)}}},{key:"_onFocus",value:function(){this.settings.isCancellable&&this._saveCancellableValue()}},{key:"_onFocusIn",value:function(e){this.settings.selectOnFocus?this.select():M.isNull(this.settings.caretPositionOnFocus)||M.setElementSelection(e.target,this._initialCaretPosition(M.getElementValue(this.domElement)))}},{key:"_enterFormulaMode",value:function(){this.settings.formulaMode&&(this.formulaMode=!0,M.setElementValue(this.domElement,"="),M.setElementSelection(this.domElement,1))}},{key:"_exitFormulaMode",value:function(){var e,t=M.getElementValue(this.domElement);t=t.replace(/^\s*=/,"");try{var i=new v(t,this.settings.decimalCharacter);e=(new u).evaluate(i)}catch(e){return this._triggerEvent(B.events.invalidFormula,this.domElement,{formula:t,aNElement:this}),this.reformat(),void(this.formulaMode=!1)}this._triggerEvent(B.events.validFormula,this.domElement,{formula:t,result:e,aNElement:this}),this.set(e),this.formulaMode=!1}},{key:"_acceptNonPrintableKeysInFormulaMode",value:function(){return this.eventKey===d.keyName.Backspace||this.eventKey===d.keyName.Delete||this.eventKey===d.keyName.LeftArrow||this.eventKey===d.keyName.RightArrow||this.eventKey===d.keyName.Home||this.eventKey===d.keyName.End}},{key:"_onKeydown",value:function(e){if(this.formatted=!1,this.isEditing=!0,this.formulaMode||this.isFocused||!this.settings.unformatOnHover||!e.altKey||this.domElement!==M.getHoveredElement()){if(this._updateEventKeyInfo(e),this.keydownEventCounter+=1,1===this.keydownEventCounter&&(this.initialValueOnFirstKeydown=M.getElementValue(e.target),this.initialRawValueOnFirstKeydown=this.rawValue),this.formulaMode){if(this.eventKey===d.keyName.Esc)return this.formulaMode=!1,void this.reformat();if(this.eventKey===d.keyName.Enter)return void this._exitFormulaMode();if(this._acceptNonPrintableKeysInFormulaMode())return}else if(this.eventKey===d.keyName.Equal)return void this._enterFormulaMode();if(this.domElement.readOnly||this.settings.readOnly||this.domElement.disabled)this.processed=!0;else{this.eventKey===d.keyName.Esc&&(e.preventDefault(),this.settings.isCancellable&&this.rawValue!==this.savedCancellableValue&&(this.set(this.savedCancellableValue),this._triggerEvent(B.events.native.input,e.target)),this.select());var t=M.getElementValue(e.target);if(this.eventKey===d.keyName.Enter&&this.rawValue!==this.rawValueOnFocus&&(this._triggerEvent(B.events.native.change,e.target),this.valueOnFocus=t,this.rawValueOnFocus=this.rawValue,this.settings.isCancellable&&this._saveCancellableValue()),this._updateInternalProperties(e),this._processNonPrintableKeysAndShortcuts(e))this.processed=!0;else if(this.eventKey===d.keyName.Backspace||this.eventKey===d.keyName.Delete){var i=this._processCharacterDeletion();if(this.processed=!0,!i)return void e.preventDefault();this._formatValue(e),(t=M.getElementValue(e.target))!==this.lastVal&&this.throwInput&&(this._triggerEvent(B.events.native.input,e.target),e.preventDefault()),this.lastVal=t,this.throwInput=!0}}}else this.constructor._unformatAltHovered(this)}},{key:"_onKeypress",value:function(e){if(this.formulaMode){if(this._acceptNonPrintableKeysInFormulaMode())return;if(this.settings.formulaChars.test(this.eventKey))return;e.preventDefault()}else if(this.eventKey!==d.keyName.Insert){var t=this.processed;if(this._updateInternalProperties(e),!this._processNonPrintableKeysAndShortcuts(e))if(t)e.preventDefault();else{if(this._processCharacterInsertion()){this._formatValue(e);var i=M.getElementValue(e.target);if(i!==this.lastVal&&this.throwInput)this._triggerEvent(B.events.native.input,e.target),e.preventDefault();else{if((this.eventKey===this.settings.decimalCharacter||this.eventKey===this.settings.decimalCharacterAlternative)&&M.getElementSelection(e.target).start===M.getElementSelection(e.target).end&&M.getElementSelection(e.target).start===i.indexOf(this.settings.decimalCharacter)){var n=M.getElementSelection(e.target).start+1;M.setElementSelection(e.target,n)}e.preventDefault()}return this.lastVal=M.getElementValue(e.target),this.throwInput=!0,void this._setValidOrInvalidState(this.rawValue)}e.preventDefault()}}}},{key:"_onKeyup",value:function(e){if(this.isEditing=!1,this.keydownEventCounter=0,!this.formulaMode)if(this.settings.isCancellable&&this.eventKey===d.keyName.Esc)e.preventDefault();else{if(this.eventKey===d.keyName.Z||this.eventKey===d.keyName.z){if(e.ctrlKey&&e.shiftKey)return e.preventDefault(),this._historyTableRedo(),void(this.onGoingRedo=!0);if(e.ctrlKey&&!e.shiftKey){if(!this.onGoingRedo)return e.preventDefault(),void this._historyTableUndo();this.onGoingRedo=!1}}if(this.onGoingRedo&&(e.ctrlKey||e.shiftKey)&&(this.onGoingRedo=!1),(e.ctrlKey||e.metaKey)&&this.eventKey===d.keyName.x){var t=M.getElementSelection(this.domElement).start,i=this.constructor._toNumericValue(M.getElementValue(e.target),this.settings);this.set(i),this._setCaretPosition(t)}if(this.eventKey===d.keyName.Alt&&this.settings.unformatOnHover&&this.hoveredWithAlt)this.constructor._reformatAltHovered(this);else if(!e.ctrlKey&&!e.metaKey||this.eventKey!==d.keyName.Backspace&&this.eventKey!==d.keyName.Delete){this._updateInternalProperties(e);var n=this._processNonPrintableKeysAndShortcuts(e);delete this.valuePartsBeforePaste;var a=M.getElementValue(e.target);if(!(n||""===a&&""===this.initialValueOnFirstKeydown)&&(a===this.settings.currencySymbol?this.settings.currencySymbolPlacement===B.options.currencySymbolPlacement.suffix?M.setElementSelection(e.target,0):M.setElementSelection(e.target,this.settings.currencySymbol.length):this.eventKey===d.keyName.Tab&&M.setElementSelection(e.target,0,a.length),(a===this.settings.suffixText||""===this.rawValue&&""!==this.settings.currencySymbol&&""!==this.settings.suffixText)&&M.setElementSelection(e.target,0),null!==this.settings.decimalPlacesShownOnFocus&&this._saveValueToPersistentStorage(),this.formatted||this._formatValue(e),this._setValidOrInvalidState(this.rawValue),this._saveRawValueForAndroid(),a!==this.initialValueOnFirstKeydown&&this._triggerEvent(B.events.formatted,e.target,{oldValue:this.initialValueOnFirstKeydown,newValue:a,oldRawValue:this.initialRawValueOnFirstKeydown,newRawValue:this.rawValue,isPristine:this.isPristine(!1),error:null,aNElement:this}),1<this.historyTable.length)){var r=M.getElementSelection(this.domElement);this.selectionStart=r.start,this.selectionEnd=r.end,this.historyTable[this.historyTableIndex].start=this.selectionStart,this.historyTable[this.historyTableIndex].end=this.selectionEnd}}else{var s=M.getElementValue(e.target);this._setRawValue(this._formatOrUnformatOther(!1,s))}}}},{key:"_saveRawValueForAndroid",value:function(){if(this.eventKey===d.keyName.AndroidDefault){var e=this.constructor._stripAllNonNumberCharactersExceptCustomDecimalChar(this.getFormatted(),this.settings,!0,this.isFocused);e=this.constructor._convertToNumericString(e,this.settings),this._setRawValue(e)}}},{key:"_onFocusOutAndMouseLeave",value:function(e){if(this.isEditing=!1,"mouseleave"!==e.type||!this.formulaMode)if(this.settings.unformatOnHover&&"mouseleave"===e.type&&this.hoveredWithAlt)this.constructor._reformatAltHovered(this);else if("mouseleave"===e.type&&!this.isFocused||"blur"===e.type){"blur"===e.type&&this.formulaMode&&this._exitFormulaMode(),this._saveValueToPersistentStorage(),this.settings.showOnlyNumbersOnFocus===B.options.showOnlyNumbersOnFocus.onlyNumbers&&(this.settings.digitGroupSeparator=this.originalDigitGroupSeparator,this.settings.currencySymbol=this.originalCurrencySymbol,this.settings.suffixText=this.originalSuffixText);var t=this._getRawValueToFormat(this.rawValue),i=M.isNull(t),n=S(this.constructor._checkIfInRangeWithOverrideOption(t,this.settings),2),a=n[0],r=n[1],s=!1;if(""===t||i||(this._triggerRangeEvents(a,r),this.settings.valuesToStrings&&this._checkValuesToStrings(t)&&(this._setElementValue(this.settings.valuesToStrings[t]),s=!0)),!s){var o;if(o=i||""===t?t:String(t),""===t||i){if(""===t)switch(this.settings.emptyInputBehavior){case B.options.emptyInputBehavior.zero:this._setRawValue("0"),o=this.constructor._roundValue("0",this.settings,0);break;case B.options.emptyInputBehavior.min:this._setRawValue(this.settings.minimumValue),o=this.constructor._roundFormattedValueShownOnFocusOrBlur(this.settings.minimumValue,this.settings,this.isFocused);break;case B.options.emptyInputBehavior.max:this._setRawValue(this.settings.maximumValue),o=this.constructor._roundFormattedValueShownOnFocusOrBlur(this.settings.maximumValue,this.settings,this.isFocused);break;default:M.isNumber(this.settings.emptyInputBehavior)&&(this._setRawValue(this.settings.emptyInputBehavior),o=this.constructor._roundFormattedValueShownOnFocusOrBlur(this.settings.emptyInputBehavior,this.settings,this.isFocused))}}else a&&r&&!this.constructor._isElementValueEmptyOrOnlyTheNegativeSign(t,this.settings)?(o=this._modifyNegativeSignAndDecimalCharacterForRawValue(o),this.settings.divisorWhenUnfocused&&!M.isNull(o)&&(o=(o/=this.settings.divisorWhenUnfocused).toString()),o=this.constructor._roundFormattedValueShownOnBlur(o,this.settings),o=this.constructor._modifyNegativeSignAndDecimalCharacterForFormattedValue(o,this.settings)):this._triggerRangeEvents(a,r);var l=this.constructor._orderValueCurrencySymbolAndSuffixText(o,this.settings,!1);this.constructor._isElementValueEmptyOrOnlyTheNegativeSign(o,this.settings)||i&&this.settings.emptyInputBehavior===B.options.emptyInputBehavior.null||(l=this.constructor._addGroupSeparators(o,this.settings,!1,t)),l===t&&""!==t&&this.settings.allowDecimalPadding!==B.options.allowDecimalPadding.never&&this.settings.allowDecimalPadding!==B.options.allowDecimalPadding.floats||(this.settings.symbolWhenUnfocused&&""!==t&&null!==t&&(l="".concat(l).concat(this.settings.symbolWhenUnfocused)),this._setElementValue(l))}this._setValidOrInvalidState(this.rawValue),"blur"===e.type&&this._onBlur(e)}}},{key:"_onPaste",value:function(e){if(e.preventDefault(),!(this.settings.readOnly||this.domElement.readOnly||this.domElement.disabled)){var t,i;window.clipboardData&&window.clipboardData.getData?t=window.clipboardData.getData("Text"):e.clipboardData&&e.clipboardData.getData?t=e.clipboardData.getData("text/plain"):M.throwError("Unable to retrieve the pasted value. Please use a modern browser (ie. Firefox or Chromium)."),i=e.target.tagName?e.target:e.explicitOriginalTarget;var n=M.getElementValue(i),a=i.selectionStart||0,r=i.selectionEnd||0,s=r-a;if(s===n.length){var o=this._preparePastedText(t),l=M.arabicToLatinNumbers(o,!1,!1,!1);return"."===l||""===l||"."!==l&&!M.isNumber(l)?(this.formatted=!0,void(this.settings.onInvalidPaste===B.options.onInvalidPaste.error&&M.throwError("The pasted value '".concat(t,"' is not a valid paste content.")))):(this.set(l),this.formatted=!0,void this._triggerEvent(B.events.native.input,i))}var u=M.isNegativeStrict(t,this.settings.negativeSignCharacter);u&&(t=t.slice(1,t.length));var c,h,m=this._preparePastedText(t);if("."!==(c="."===m?".":M.arabicToLatinNumbers(m,!1,!1,!1))&&(!M.isNumber(c)||""===c))return this.formatted=!0,void(this.settings.onInvalidPaste===B.options.onInvalidPaste.error&&M.throwError("The pasted value '".concat(t,"' is not a valid paste content.")));var g,d,v=M.isNegativeStrict(this.getNumericString(),this.settings.negativeSignCharacter);g=!(!u||v)&&(v=!0);var p=n.slice(0,a),f=n.slice(r,n.length);d=a!==r?this._preparePastedText(p+f):this._preparePastedText(n),v&&(d=M.setRawNegativeSign(d)),h=M.convertCharacterCountToIndexPosition(M.countNumberCharactersOnTheCaretLeftSide(n,a,this.settings.decimalCharacter)),g&&h++;var y=d.slice(0,h),S=d.slice(h,d.length),b=!1;"."===c&&(M.contains(y,".")&&(b=!0,y=y.replace(".","")),S=S.replace(".",""));var w=!1;switch(""===y&&"-"===S&&(y="-",w=!(S="")),this.settings.onInvalidPaste){case B.options.onInvalidPaste.truncate:case B.options.onInvalidPaste.replace:for(var P=M.parseStr(this.settings.minimumValue),O=M.parseStr(this.settings.maximumValue),k=d,N=0,E=y;N<c.length&&(d=(E+=c[N])+S,this.constructor._checkIfInRange(d,P,O));)k=d,N++;if(h+=N,w&&h++,this.settings.onInvalidPaste===B.options.onInvalidPaste.truncate){d=k,b&&h--;break}for(var _=h,C=k.length;N<c.length&&_<C;)if("."!==k[_]){if(d=M.replaceCharAt(k,_,c[N]),!this.constructor._checkIfInRange(d,P,O))break;k=d,N++,_++}else _++;h=_,b&&h--,d=k;break;case B.options.onInvalidPaste.error:case B.options.onInvalidPaste.ignore:case B.options.onInvalidPaste.clamp:default:if(d="".concat(y).concat(c).concat(S),a===r)h=M.convertCharacterCountToIndexPosition(M.countNumberCharactersOnTheCaretLeftSide(n,a,this.settings.decimalCharacter))+c.length;else if(""===S)h=M.convertCharacterCountToIndexPosition(M.countNumberCharactersOnTheCaretLeftSide(n,a,this.settings.decimalCharacter))+c.length,w&&h++;else{var F=M.convertCharacterCountToIndexPosition(M.countNumberCharactersOnTheCaretLeftSide(n,r,this.settings.decimalCharacter)),x=M.getElementValue(i).slice(a,r);h=F-s+M.countCharInText(this.settings.digitGroupSeparator,x)+c.length}g&&h++,b&&h--}if(M.isNumber(d)&&""!==d){var V=!1,T=!1;try{this.set(d),V=!0}catch(e){var A;switch(this.settings.onInvalidPaste){case B.options.onInvalidPaste.clamp:A=M.clampToRangeLimits(d,this.settings);try{this.set(A)}catch(e){M.throwError("Fatal error: Unable to set the clamped value '".concat(A,"'."))}V=T=!0,d=A;break;case B.options.onInvalidPaste.error:case B.options.onInvalidPaste.truncate:case B.options.onInvalidPaste.replace:M.throwError("The pasted value '".concat(t,"' results in a value '").concat(d,"' that is outside of the minimum [").concat(this.settings.minimumValue,"] and maximum [").concat(this.settings.maximumValue,"] value range."));case B.options.onInvalidPaste.ignore:default:return}}var L,I=M.getElementValue(i);if(V)switch(this.settings.onInvalidPaste){case B.options.onInvalidPaste.clamp:if(T){this.settings.currencySymbolPlacement===B.options.currencySymbolPlacement.suffix?M.setElementSelection(i,I.length-this.settings.currencySymbol.length):M.setElementSelection(i,I.length);break}case B.options.onInvalidPaste.error:case B.options.onInvalidPaste.ignore:case B.options.onInvalidPaste.truncate:case B.options.onInvalidPaste.replace:default:L=M.findCaretPositionInFormattedNumber(d,h,I,this.settings.decimalCharacter),M.setElementSelection(i,L)}V&&n!==I&&this._triggerEvent(B.events.native.input,i)}else this.settings.onInvalidPaste===B.options.onInvalidPaste.error&&M.throwError("The pasted value '".concat(t,"' would result into an invalid content '").concat(d,"'."))}}},{key:"_onBlur",value:function(e){this.isFocused=!1,this.isEditing=!1,this.rawValue!==this.rawValueOnFocus&&this._triggerEvent(B.events.native.change,e.target),this.rawValueOnFocus=void 0}},{key:"_onWheel",value:function(e){this.formulaMode||this.settings.readOnly||this.domElement.readOnly||this.domElement.disabled||this.settings.modifyValueOnWheel&&(this.settings.wheelOn===B.options.wheelOn.focus?this.isFocused?e.shiftKey||this.wheelAction(e):e.shiftKey&&this.wheelAction(e):this.settings.wheelOn===B.options.wheelOn.hover?e.shiftKey?(e.preventDefault(),window.scrollBy(0,M.isNegativeStrict(String(e.deltaY))?-50:50)):this.wheelAction(e):M.throwError("Unknown `wheelOn` option."))}},{key:"wheelAction",value:function(e){this.isWheelEvent=!0;var t,i=e.target.selectionStart||0,n=e.target.selectionEnd||0,a=this.rawValue;if(M.isUndefinedOrNullOrEmpty(a)?0<this.settings.minimumValue||this.settings.maximumValue<0?M.isWheelUpEvent(e)?t=this.settings.minimumValue:M.isWheelDownEvent(e)?t=this.settings.maximumValue:M.throwError("The event is not a 'wheel' event."):t=0:t=a,t=+t,M.isNumber(this.settings.wheelStep)){var r=+this.settings.wheelStep;M.isWheelUpEvent(e)?t+=r:M.isWheelDownEvent(e)&&(t-=r)}else M.isWheelUpEvent(e)?t=M.addAndRoundToNearestAuto(t,this.settings.decimalPlacesRawValue):M.isWheelDownEvent(e)&&(t=M.subtractAndRoundToNearestAuto(t,this.settings.decimalPlacesRawValue));(t=M.clampToRangeLimits(t,this.settings))!==+a&&(this.set(t),this._triggerEvent(B.events.native.input,e.target)),e.preventDefault(),this._setSelection(i,n),this.isWheelEvent=!1}},{key:"_onDrop",value:function(e){if(!this.formulaMode){var t;this.isDropEvent=!0,e.preventDefault(),t=M.isIE11()?"text":"text/plain";var i=e.dataTransfer.getData(t),n=this.unformatOther(i);this.set(n),this.isDropEvent=!1}}},{key:"_onFormSubmit",value:function(){var t=this;return this._getFormAutoNumericChildren(this.parentForm).map(function(e){return t.constructor.getAutoNumericElement(e)}).forEach(function(e){return e._unformatOnSubmit()}),!0}},{key:"_onFormReset",value:function(){var i=this;this._getFormAutoNumericChildren(this.parentForm).map(function(e){return i.constructor.getAutoNumericElement(e)}).forEach(function(e){var t=i._getDefaultValue(e.node());setTimeout(function(){return e.set(t)},0)})}},{key:"_unformatOnSubmit",value:function(){this.settings.unformatOnSubmit&&this._setElementValue(this.rawValue)}},{key:"_onKeydownGlobal",value:function(e){if(M.character(e)===d.keyName.Alt){var t=M.getHoveredElement();if(B.isManagedByAutoNumeric(t)){var i=B.getAutoNumericElement(t);!i.formulaMode&&i.settings.unformatOnHover&&this.constructor._unformatAltHovered(i)}}}},{key:"_onKeyupGlobal",value:function(e){if(M.character(e)===d.keyName.Alt){var t=M.getHoveredElement();if(B.isManagedByAutoNumeric(t)){var i=B.getAutoNumericElement(t);if(i.formulaMode||!i.settings.unformatOnHover)return;this.constructor._reformatAltHovered(i)}}}},{key:"_isElementTagSupported",value:function(){return M.isElement(this.domElement)||M.throwError("The DOM element is not valid, ".concat(this.domElement," given.")),M.isInArray(this.domElement.tagName.toLowerCase(),this.allowedTagList)}},{key:"_isInputElement",value:function(){return"input"===this.domElement.tagName.toLowerCase()}},{key:"_isInputTypeSupported",value:function(){return"text"===this.domElement.type||"hidden"===this.domElement.type||"tel"===this.domElement.type||M.isUndefinedOrNullOrEmpty(this.domElement.type)}},{key:"_checkElement",value:function(){var e=this.domElement.tagName.toLowerCase();this._isElementTagSupported()||M.throwError("The <".concat(e,"> tag is not supported by autoNumeric")),this._isInputElement()?(this._isInputTypeSupported()||M.throwError('The input type "'.concat(this.domElement.type,'" is not supported by autoNumeric')),this.isInputElement=!0):(this.isInputElement=!1,this.isContentEditable=this.domElement.hasAttribute("contenteditable")&&"true"===this.domElement.getAttribute("contenteditable"))}},{key:"_formatDefaultValueOnPageLoad",value:function(e){var t,i=0<arguments.length&&void 0!==e?e:null,n=!0;if(M.isNull(i)?(t=M.getElementValue(this.domElement).trim(),this.domElement.setAttribute("value",t)):t=i,this.isInputElement||this.isContentEditable){var a=this.constructor._toNumericValue(t,this.settings);if(this.domElement.hasAttribute("value")&&""!==this.domElement.getAttribute("value")){if(null!==this.settings.defaultValueOverride&&this.settings.defaultValueOverride.toString()!==t||null===this.settings.defaultValueOverride&&""!==t&&t!==this.domElement.getAttribute("value")||""!==t&&"hidden"===this.domElement.getAttribute("type")&&!M.isNumber(a)){if(this.settings.saveValueToSessionStorage&&(null!==this.settings.decimalPlacesShownOnFocus||this.settings.divisorWhenUnfocused)&&this._setRawValue(this._getValueFromPersistentStorage()),!this.settings.saveValueToSessionStorage){var r=this.constructor._removeBrackets(t,this.settings);(this.settings.negativePositiveSignPlacement===B.options.negativePositiveSignPlacement.suffix||this.settings.negativePositiveSignPlacement!==B.options.negativePositiveSignPlacement.prefix&&this.settings.currencySymbolPlacement===B.options.currencySymbolPlacement.suffix)&&""!==this.settings.negativeSignCharacter&&M.isNegative(t,this.settings.negativeSignCharacter)?this._setRawValue("-".concat(this.constructor._stripAllNonNumberCharacters(r,this.settings,!0,this.isFocused))):this._setRawValue(this.constructor._stripAllNonNumberCharacters(r,this.settings,!0,this.isFocused))}n=!1}}else isNaN(Number(a))||1/0===a?M.throwError("The value [".concat(t,"] used in the input is not a valid value autoNumeric can work with.")):(this.set(a),n=!1);if(""===t)switch(this.settings.emptyInputBehavior){case B.options.emptyInputBehavior.focus:case B.options.emptyInputBehavior.null:case B.options.emptyInputBehavior.press:break;case B.options.emptyInputBehavior.always:this._setElementValue(this.settings.currencySymbol);break;case B.options.emptyInputBehavior.min:this.set(this.settings.minimumValue);break;case B.options.emptyInputBehavior.max:this.set(this.settings.maximumValue);break;case B.options.emptyInputBehavior.zero:this.set("0");break;default:this.set(this.settings.emptyInputBehavior)}else n&&t===this.domElement.getAttribute("value")&&this.set(t)}else null!==this.settings.defaultValueOverride&&this.settings.defaultValueOverride!==t||this.set(t)}},{key:"_calculateVMinAndVMaxIntegerSizes",value:function(){var e=S(this.settings.maximumValue.toString().split("."),1)[0],t=S(this.settings.minimumValue||0===this.settings.minimumValue?this.settings.minimumValue.toString().split("."):[],1)[0];e=e.replace(this.settings.negativeSignCharacter,""),t=t.replace(this.settings.negativeSignCharacter,""),this.settings.mIntPos=Math.max(e.length,1),this.settings.mIntNeg=Math.max(t.length,1)}},{key:"_calculateValuesToStringsKeys",value:function(){this.settings.valuesToStrings?this.valuesToStringsKeys=Object.keys(this.settings.valuesToStrings):this.valuesToStringsKeys=[]}},{key:"_transformOptionsValuesToDefaultTypes",value:function(){for(var e in this.settings)if(Object.prototype.hasOwnProperty.call(this.settings,e)){var t=this.settings[e];"true"!==t&&"false"!==t||(this.settings[e]="true"===t),"number"==typeof t&&(this.settings[e]=t.toString())}}},{key:"_setSettings",value:function(e,t){var i=1<arguments.length&&void 0!==t&&t;!i&&M.isNull(e)||this.constructor._convertOldOptionsToNewOnes(e),i?("decimalPlacesRawValue"in e&&(this.settings.originalDecimalPlacesRawValue=e.decimalPlacesRawValue),"decimalPlaces"in e&&(this.settings.originalDecimalPlaces=e.decimalPlaces),this.constructor._calculateDecimalPlacesOnUpdate(e,this.settings),this._mergeSettings(e)):(this.settings={},this._mergeSettings(this.constructor.getDefaultConfig(),this.domElement.dataset,e,{rawValue:this.defaultRawValue}),this.caretFix=!1,this.throwInput=!0,this.allowedTagList=d.allowedTagList,this.runOnce=!1,this.hoveredWithAlt=!1),this._transformOptionsValuesToDefaultTypes(),this._runCallbacksFoundInTheSettingsObject(),this.constructor._correctNegativePositiveSignPlacementOption(this.settings),this.constructor._correctCaretPositionOnFocusAndSelectOnFocusOptions(this.settings),this.constructor._setNegativePositiveSignPermissions(this.settings),i||(M.isNull(e)||!e.decimalPlaces?this.settings.originalDecimalPlaces=null:this.settings.originalDecimalPlaces=e.decimalPlaces,this.settings.originalDecimalPlacesRawValue=this.settings.decimalPlacesRawValue,this.constructor._calculateDecimalPlacesOnInit(this.settings)),this._calculateVMinAndVMaxIntegerSizes(),this._setTrailingNegativeSignInfo(),this.regex={},this.constructor._cachesUsualRegularExpressions(this.settings,this.regex),this.constructor._setBrackets(this.settings),this._calculateValuesToStringsKeys(),M.isEmptyObj(this.settings)&&M.throwError("Unable to set the settings, those are invalid ; an empty object was given."),this.constructor.validate(this.settings,!1,e),this._keepAnOriginalSettingsCopy()}},{key:"_preparePastedText",value:function(e){return this.constructor._stripAllNonNumberCharacters(e,this.settings,!0,this.isFocused)}},{key:"_updateInternalProperties",value:function(){this.selection=M.getElementSelection(this.domElement),this.processed=!1}},{key:"_updateEventKeyInfo",value:function(e){this.eventKey=M.character(e)}},{key:"_saveCancellableValue",value:function(){this.savedCancellableValue=this.rawValue}},{key:"_setSelection",value:function(e,t){e=Math.max(e,0),t=Math.min(t,M.getElementValue(this.domElement).length),this.selection={start:e,end:t,length:t-e},M.setElementSelection(this.domElement,e,t)}},{key:"_setCaretPosition",value:function(e){this._setSelection(e,e)}},{key:"_getLeftAndRightPartAroundTheSelection",value:function(){var e=M.getElementValue(this.domElement);return[e.substring(0,this.selection.start),e.substring(this.selection.end,e.length)]}},{key:"_getUnformattedLeftAndRightPartAroundTheSelection",value:function(){var e=S(this._getLeftAndRightPartAroundTheSelection(),2),t=e[0],i=e[1];if(""===t&&""===i)return["",""];var n=!0;return this.eventKey!==d.keyName.Hyphen&&this.eventKey!==d.keyName.Minus||0!==Number(t)||(n=!1),this.isTrailingNegative&&(M.isNegative(i,this.settings.negativeSignCharacter)&&!M.isNegative(t,this.settings.negativeSignCharacter)||""===i&&M.isNegative(t,this.settings.negativeSignCharacter,!0))&&(t=t.replace(this.settings.negativeSignCharacter,""),i=i.replace(this.settings.negativeSignCharacter,""),t=t.replace("-",""),i=i.replace("-",""),t="-".concat(t)),[t=B._stripAllNonNumberCharactersExceptCustomDecimalChar(t,this.settings,n,this.isFocused),i=B._stripAllNonNumberCharactersExceptCustomDecimalChar(i,this.settings,!1,this.isFocused)]}},{key:"_normalizeParts",value:function(e,t){var i=!0;this.eventKey!==d.keyName.Hyphen&&this.eventKey!==d.keyName.Minus||0!==Number(e)||(i=!1),this.isTrailingNegative&&M.isNegative(t,this.settings.negativeSignCharacter)&&!M.isNegative(e,this.settings.negativeSignCharacter)&&(e="-".concat(e),t=t.replace(this.settings.negativeSignCharacter,"")),e=B._stripAllNonNumberCharactersExceptCustomDecimalChar(e,this.settings,i,this.isFocused),t=B._stripAllNonNumberCharactersExceptCustomDecimalChar(t,this.settings,!1,this.isFocused),this.settings.leadingZero!==B.options.leadingZero.deny||this.eventKey!==d.keyName.num0&&this.eventKey!==d.keyName.numpad0||0!==Number(e)||M.contains(e,this.settings.decimalCharacter)||""===t||(e=e.substring(0,e.length-1));var n=e+t;if(this.settings.decimalCharacter){var a=n.match(new RegExp("^".concat(this.regex.aNegRegAutoStrip,"\\").concat(this.settings.decimalCharacter)));a&&(n=(e=e.replace(a[1],a[1]+"0"))+t)}return[e,t,n]}},{key:"_setValueParts",value:function(e,t,i){var n=2<arguments.length&&void 0!==i&&i,a=S(this._normalizeParts(e,t),3),r=a[0],s=a[1],o=a[2],l=S(B._checkIfInRangeWithOverrideOption(o,this.settings),2),u=l[0],c=l[1];if(u&&c){var h=B._truncateDecimalPlaces(o,this.settings,n,this.settings.decimalPlacesRawValue).replace(this.settings.decimalCharacter,".");if(""===h||h===this.settings.negativeSignCharacter){var m;switch(this.settings.emptyInputBehavior){case B.options.emptyInputBehavior.focus:case B.options.emptyInputBehavior.press:case B.options.emptyInputBehavior.always:m="";break;case B.options.emptyInputBehavior.min:m=this.settings.minimumValue;break;case B.options.emptyInputBehavior.max:m=this.settings.maximumValue;break;case B.options.emptyInputBehavior.zero:m="0";break;case B.options.emptyInputBehavior.null:m=null;break;default:m=this.settings.emptyInputBehavior}this._setRawValue(m)}else this._setRawValue(this._trimLeadingAndTrailingZeros(h));var g=B._truncateDecimalPlaces(o,this.settings,n,this.settings.decimalPlacesShownOnFocus),d=r.length;return d>g.length&&(d=g.length),1===d&&"0"===r&&this.settings.leadingZero===B.options.leadingZero.deny&&(d=""===s||"0"===r&&""!==s?1:0),this._setElementValue(g,!1),this._setCaretPosition(d),!0}return this._triggerRangeEvents(u,c),!1}},{key:"_getSignPosition",value:function(){var e;if(this.settings.currencySymbol){var t=this.settings.currencySymbol.length,i=M.getElementValue(this.domElement);if(this.settings.currencySymbolPlacement===B.options.currencySymbolPlacement.prefix)e=this.settings.negativeSignCharacter&&i&&i.charAt(0)===this.settings.negativeSignCharacter?[1,t+1]:[0,t];else{var n=i.length;e=[n-t,n]}}else e=[1e3,-1];return e}},{key:"_expandSelectionOnSign",value:function(){var e=S(this._getSignPosition(),2),t=e[0],i=e[1],n=this.selection;n.start<i&&n.end>t&&((n.start<t||n.end>i)&&M.getElementValue(this.domElement).substring(Math.max(n.start,t),Math.min(n.end,i)).match(/^\s*$/)?n.start<t?this._setSelection(n.start,t):this._setSelection(i,n.end):this._setSelection(Math.min(n.start,t),Math.max(n.end,i)))}},{key:"_checkPaste",value:function(){if(!this.formatted&&!M.isUndefined(this.valuePartsBeforePaste)){var e=this.valuePartsBeforePaste,t=S(this._getLeftAndRightPartAroundTheSelection(),2),i=t[0],n=t[1];delete this.valuePartsBeforePaste;var a=i.substr(0,e[0].length)+B._stripAllNonNumberCharactersExceptCustomDecimalChar(i.substr(e[0].length),this.settings,!0,this.isFocused);this._setValueParts(a,n,!0)||(this._setElementValue(e.join(""),!1),this._setCaretPosition(e[0].length))}}},{key:"_processNonPrintableKeysAndShortcuts",value:function(e){if((e.ctrlKey||e.metaKey)&&"keyup"===e.type&&!M.isUndefined(this.valuePartsBeforePaste)||e.shiftKey&&this.eventKey===d.keyName.Insert)return this._checkPaste(),!1;if(this.constructor._shouldSkipEventKey(this.eventKey))return!0;if((e.ctrlKey||e.metaKey)&&this.eventKey===d.keyName.a)return this.settings.selectNumberOnly&&(e.preventDefault(),this.selectNumber()),!0;if((e.ctrlKey||e.metaKey)&&(this.eventKey===d.keyName.c||this.eventKey===d.keyName.v||this.eventKey===d.keyName.x))return"keydown"===e.type&&this._expandSelectionOnSign(),this.eventKey!==d.keyName.v&&this.eventKey!==d.keyName.Insert||("keydown"===e.type||"keypress"===e.type?M.isUndefined(this.valuePartsBeforePaste)&&(this.valuePartsBeforePaste=this._getLeftAndRightPartAroundTheSelection()):this._checkPaste()),"keydown"===e.type||"keypress"===e.type||this.eventKey===d.keyName.c;if(e.ctrlKey||e.metaKey)return!(this.eventKey===d.keyName.Z||this.eventKey===d.keyName.z);if(this.eventKey!==d.keyName.LeftArrow&&this.eventKey!==d.keyName.RightArrow)return M.isInArray(this.eventKey,d.keyName._directionKeys);if("keydown"===e.type&&!e.shiftKey){var t=M.getElementValue(this.domElement);this.eventKey!==d.keyName.LeftArrow||t.charAt(this.selection.start-2)!==this.settings.digitGroupSeparator&&t.charAt(this.selection.start-2)!==this.settings.decimalCharacter?this.eventKey!==d.keyName.RightArrow||t.charAt(this.selection.start+1)!==this.settings.digitGroupSeparator&&t.charAt(this.selection.start+1)!==this.settings.decimalCharacter||this._setCaretPosition(this.selection.start+1):this._setCaretPosition(this.selection.start-1)}return!0}},{key:"_processCharacterDeletionIfTrailingNegativeSign",value:function(e){var t=S(e,2),i=t[0],n=t[1],a=M.getElementValue(this.domElement),r=M.isNegative(a,this.settings.negativeSignCharacter);if(this.settings.currencySymbolPlacement===B.options.currencySymbolPlacement.prefix&&this.settings.negativePositiveSignPlacement===B.options.negativePositiveSignPlacement.suffix&&(this.eventKey===d.keyName.Backspace?(this.caretFix=this.selection.start>=a.indexOf(this.settings.suffixText)&&""!==this.settings.suffixText,"-"===a.charAt(this.selection.start-1)?i=i.substring(1):this.selection.start<=a.length-this.settings.suffixText.length&&(i=i.substring(0,i.length-1))):(this.caretFix=this.selection.start>=a.indexOf(this.settings.suffixText)&&""!==this.settings.suffixText,this.selection.start>=a.indexOf(this.settings.currencySymbol)+this.settings.currencySymbol.length&&(n=n.substring(1,n.length)),M.isNegative(i,this.settings.negativeSignCharacter)&&"-"===a.charAt(this.selection.start)&&(i=i.substring(1)))),this.settings.currencySymbolPlacement===B.options.currencySymbolPlacement.suffix)switch(this.settings.negativePositiveSignPlacement){case B.options.negativePositiveSignPlacement.left:this.caretFix=this.selection.start>=a.indexOf(this.settings.negativeSignCharacter)+this.settings.negativeSignCharacter.length,this.eventKey===d.keyName.Backspace?this.selection.start===a.indexOf(this.settings.negativeSignCharacter)+this.settings.negativeSignCharacter.length&&r?i=i.substring(1):"-"!==i&&(this.selection.start<=a.indexOf(this.settings.negativeSignCharacter)||!r)&&(i=i.substring(0,i.length-1)):("-"===i[0]&&(n=n.substring(1)),this.selection.start===a.indexOf(this.settings.negativeSignCharacter)&&r&&(i=i.substring(1)));break;case B.options.negativePositiveSignPlacement.right:this.caretFix=this.selection.start>=a.indexOf(this.settings.negativeSignCharacter)+this.settings.negativeSignCharacter.length,this.eventKey===d.keyName.Backspace?this.selection.start===a.indexOf(this.settings.negativeSignCharacter)+this.settings.negativeSignCharacter.length?i=i.substring(1):("-"!==i&&this.selection.start<=a.indexOf(this.settings.negativeSignCharacter)-this.settings.currencySymbol.length||""!==i&&!r)&&(i=i.substring(0,i.length-1)):(this.caretFix=this.selection.start>=a.indexOf(this.settings.currencySymbol)&&""!==this.settings.currencySymbol,this.selection.start===a.indexOf(this.settings.negativeSignCharacter)&&(i=i.substring(1)),n=n.substring(1))}return[i,n]}},{key:"_processCharacterDeletion",value:function(){var e,t;if(this.selection.length){this._expandSelectionOnSign();var i=S(this._getUnformattedLeftAndRightPartAroundTheSelection(),2);e=i[0],t=i[1]}else{var n=S(this._getUnformattedLeftAndRightPartAroundTheSelection(),2);if(e=n[0],t=n[1],""===e&&""===t&&(this.throwInput=!1),this.isTrailingNegative&&M.isNegative(M.getElementValue(this.domElement),this.settings.negativeSignCharacter)){var a=S(this._processCharacterDeletionIfTrailingNegativeSign([e,t]),2);e=a[0],t=a[1]}else this.eventKey===d.keyName.Backspace?e=e.substring(0,e.length-1):t=t.substring(1,t.length)}return!!this.constructor._isWithinRangeWithOverrideOption("".concat(e).concat(t),this.settings)&&(this._setValueParts(e,t),!0)}},{key:"_isDecimalCharacterInsertionAllowed",value:function(){return String(this.settings.decimalPlacesShownOnFocus)!==String(B.options.decimalPlacesShownOnFocus.none)&&String(this.settings.decimalPlaces)!==String(B.options.decimalPlaces.none)}},{key:"_processCharacterInsertion",value:function(){var e=S(this._getUnformattedLeftAndRightPartAroundTheSelection(),2),t=e[0],i=e[1];if(this.eventKey!==d.keyName.AndroidDefault&&(this.throwInput=!0),this.eventKey===this.settings.decimalCharacter||this.settings.decimalCharacterAlternative&&this.eventKey===this.settings.decimalCharacterAlternative){if(!this._isDecimalCharacterInsertionAllowed()||!this.settings.decimalCharacter)return!1;if(this.settings.alwaysAllowDecimalCharacter)t=t.replace(this.settings.decimalCharacter,""),i=i.replace(this.settings.decimalCharacter,"");else{if(M.contains(t,this.settings.decimalCharacter))return!0;if(0<i.indexOf(this.settings.decimalCharacter))return!0;0===i.indexOf(this.settings.decimalCharacter)&&(i=i.substr(1))}return this.settings.negativeSignCharacter&&M.contains(i,this.settings.negativeSignCharacter)&&(t="".concat(this.settings.negativeSignCharacter).concat(t),i=i.replace(this.settings.negativeSignCharacter,"")),this._setValueParts(t+this.settings.decimalCharacter,i),!0}if(("-"===this.eventKey||"+"===this.eventKey)&&this.settings.isNegativeSignAllowed)return""===t&&M.contains(i,"-")?i=i.replace("-",""):t=M.isNegativeStrict(t,"-")?t.replace("-",""):"".concat(this.settings.negativeSignCharacter).concat(t),this._setValueParts(t,i),!0;var n=Number(this.eventKey);return 0<=n&&n<=9?(this.settings.isNegativeSignAllowed&&""===t&&M.contains(i,"-")&&(t="-",i=i.substring(1,i.length)),this.settings.maximumValue<=0&&this.settings.minimumValue<this.settings.maximumValue&&!M.contains(M.getElementValue(this.domElement),this.settings.negativeSignCharacter)&&"0"!==this.eventKey&&(t="-".concat(t)),this._setValueParts("".concat(t).concat(this.eventKey),i),!0):this.throwInput=!1}},{key:"_formatValue",value:function(e){var t=M.getElementValue(this.domElement),i=S(this._getUnformattedLeftAndRightPartAroundTheSelection(),1)[0];if((""===this.settings.digitGroupSeparator||""!==this.settings.digitGroupSeparator&&!M.contains(t,this.settings.digitGroupSeparator))&&(""===this.settings.currencySymbol||""!==this.settings.currencySymbol&&!M.contains(t,this.settings.currencySymbol))){var n=S(t.split(this.settings.decimalCharacter),1)[0],a="";M.isNegative(n,this.settings.negativeSignCharacter)&&(a=this.settings.negativeSignCharacter,n=n.replace(this.settings.negativeSignCharacter,""),i=i.replace("-","")),""===a&&n.length>this.settings.mIntPos&&"0"===i.charAt(0)&&(i=i.slice(1)),a===this.settings.negativeSignCharacter&&n.length>this.settings.mIntNeg&&"0"===i.charAt(0)&&(i=i.slice(1)),this.isTrailingNegative||(i="".concat(a).concat(i))}var r=this.constructor._addGroupSeparators(t,this.settings,this.isFocused,this.rawValue),s=r.length;if(r){var o,l=i.split("");if((this.settings.negativePositiveSignPlacement===B.options.negativePositiveSignPlacement.suffix||this.settings.negativePositiveSignPlacement!==B.options.negativePositiveSignPlacement.prefix&&this.settings.currencySymbolPlacement===B.options.currencySymbolPlacement.suffix)&&l[0]===this.settings.negativeSignCharacter&&!this.settings.isNegativeSignAllowed&&(l.shift(),(this.eventKey===d.keyName.Backspace||this.eventKey===d.keyName.Delete)&&this.caretFix&&((this.settings.currencySymbolPlacement===B.options.currencySymbolPlacement.suffix&&this.settings.negativePositiveSignPlacement===B.options.negativePositiveSignPlacement.left||this.settings.currencySymbolPlacement===B.options.currencySymbolPlacement.prefix&&this.settings.negativePositiveSignPlacement===B.options.negativePositiveSignPlacement.suffix)&&(l.push(this.settings.negativeSignCharacter),this.caretFix="keydown"===e.type),this.settings.currencySymbolPlacement===B.options.currencySymbolPlacement.suffix&&this.settings.negativePositiveSignPlacement===B.options.negativePositiveSignPlacement.right))){var u=this.settings.currencySymbol.split(""),c=["\\","^","$",".","|","?","*","+","(",")","["],h=[];u.forEach(function(e,t){t=u[e],M.isInArray(t,c)?h.push("\\"+t):h.push(t)}),this.eventKey===d.keyName.Backspace&&"-"===this.settings.negativeSignCharacter&&h.push("-"),l.push(h.join("")),this.caretFix="keydown"===e.type}for(var m=0;m<l.length;m++)l[m].match("\\d")||(l[m]="\\"+l[m]);o=this.settings.currencySymbolPlacement===B.options.currencySymbolPlacement.suffix?new RegExp("^.*?".concat(l.join(".*?"))):new RegExp("^.*?".concat(this.settings.currencySymbol).concat(l.join(".*?")));var g=r.match(o);g?(s=g[0].length,this.settings.showPositiveSign&&(0===s&&g.input.charAt(0)===this.settings.positiveSignCharacter&&(s=1===g.input.indexOf(this.settings.currencySymbol)?this.settings.currencySymbol.length+1:1),0===s&&g.input.charAt(this.settings.currencySymbol.length)===this.settings.positiveSignCharacter&&(s=this.settings.currencySymbol.length+1)),(0===s&&r.charAt(0)!==this.settings.negativeSignCharacter||1===s&&r.charAt(0)===this.settings.negativeSignCharacter)&&this.settings.currencySymbol&&this.settings.currencySymbolPlacement===B.options.currencySymbolPlacement.prefix&&(s=this.settings.currencySymbol.length+(M.isNegativeStrict(r,this.settings.negativeSignCharacter)?1:0))):(this.settings.currencySymbol&&this.settings.currencySymbolPlacement===B.options.currencySymbolPlacement.suffix&&(s-=this.settings.currencySymbol.length),this.settings.suffixText&&(s-=this.settings.suffixText.length))}r!==t&&(this._setElementValue(r,!1),this._setCaretPosition(s)),this.formatted=!0}}]),P(e,t),B}();function N(e,t){t=t||{bubbles:!1,cancelable:!1,detail:void 0};var i=document.createEvent("CustomEvent");return i.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),i}k.multiple=function(e){var i=1<arguments.length&&void 0!==arguments[1]?arguments[1]:null,t=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null,n=[];if(M.isObject(i)&&(t=i,i=null),M.isString(e))e=p(document.querySelectorAll(e));else if(M.isObject(e)){Object.prototype.hasOwnProperty.call(e,"rootElement")||M.throwError("The object passed to the 'multiple' function is invalid ; no 'rootElement' attribute found.");var a=p(e.rootElement.querySelectorAll("input"));e=Object.prototype.hasOwnProperty.call(e,"exclude")?(Array.isArray(e.exclude)||M.throwError("The 'exclude' array passed to the 'multiple' function is invalid."),M.filterOut(a,e.exclude)):a}else M.isArray(e)||M.throwError("The given parameters to the 'multiple' function are invalid.");if(0===e.length){var r=!0;return!M.isNull(t)&&M.isBoolean(t.showWarnings)&&(r=t.showWarnings),M.warning("No valid DOM elements were given hence no AutoNumeric objects were instantiated.",r),[]}var s=M.isArray(i)&&1<=i.length,o=!1,l=!1;if(s){var u=w(Number(i[0]));(o="number"===u&&!isNaN(Number(i[0])))||"string"!==u&&!isNaN(u)&&"object"!==u||(l=!0)}var c,h=!1;if(M.isArray(t)&&1<=t.length){var m=w(t[0]);"string"!==m&&"object"!==m||(h=!0)}c=l?k.mergeOptions(i):h?k.mergeOptions(t):t;var g,d=M.isNumber(i);return o&&(g=i.length),e.forEach(function(e,t){d?n.push(new k(e,i,c)):o&&t<=g?n.push(new k(e,i[t],c)):n.push(new k(e,null,c))}),n},Array.from||(Array.from=function(e){return[].slice.call(e)}),"undefined"!=typeof window&&"function"!=typeof window.CustomEvent&&(N.prototype=window.Event.prototype,window.CustomEvent=N),k.events={correctedValue:"autoNumeric:correctedValue",initialized:"autoNumeric:initialized",invalidFormula:"autoNumeric:invalidFormula",invalidValue:"autoNumeric:invalidValue",formatted:"autoNumeric:formatted",rawValueModified:"autoNumeric:rawValueModified",minRangeExceeded:"autoNumeric:minExceeded",maxRangeExceeded:"autoNumeric:maxExceeded",native:{input:"input",change:"change"},validFormula:"autoNumeric:validFormula"},Object.freeze(k.events.native),Object.freeze(k.events),Object.defineProperty(k,"events",{configurable:!1,writable:!1}),k.options={allowDecimalPadding:{always:!0,never:!1,floats:"floats"},alwaysAllowDecimalCharacter:{alwaysAllow:!0,doNotAllow:!1},caretPositionOnFocus:{start:"start",end:"end",decimalLeft:"decimalLeft",decimalRight:"decimalRight",doNoForceCaretPosition:null},createLocalList:{createList:!0,doNotCreateList:!1},currencySymbol:{none:"",currencySign:"¤",austral:"₳",australCentavo:"¢",baht:"฿",cedi:"₵",cent:"¢",colon:"₡",cruzeiro:"₢",dollar:"$",dong:"₫",drachma:"₯",dram:"​֏",european:"₠",euro:"€",florin:"ƒ",franc:"₣",guarani:"₲",hryvnia:"₴",kip:"₭",att:"ອັດ",lepton:"Λ.",lira:"₺",liraOld:"₤",lari:"₾",mark:"ℳ",mill:"₥",naira:"₦",peseta:"₧",peso:"₱",pfennig:"₰",pound:"£",real:"R$",riel:"៛",ruble:"₽",rupee:"₹",rupeeOld:"₨",shekel:"₪",shekelAlt:"ש״ח‎‎",taka:"৳",tenge:"₸",togrog:"₮",won:"₩",yen:"¥"},currencySymbolPlacement:{prefix:"p",suffix:"s"},decimalCharacter:{comma:",",dot:".",middleDot:"·",arabicDecimalSeparator:"٫",decimalSeparatorKeySymbol:"⎖"},decimalCharacterAlternative:{none:null,comma:",",dot:"."},decimalPlaces:{none:0,one:1,two:2,three:3,four:4,five:5,six:6},decimalPlacesRawValue:{useDefault:null,none:0,one:1,two:2,three:3,four:4,five:5,six:6},decimalPlacesShownOnBlur:{useDefault:null,none:0,one:1,two:2,three:3,four:4,five:5,six:6},decimalPlacesShownOnFocus:{useDefault:null,none:0,one:1,two:2,three:3,four:4,five:5,six:6},defaultValueOverride:{doNotOverride:null},digitalGroupSpacing:{two:"2",twoScaled:"2s",three:"3",four:"4"},digitGroupSeparator:{comma:",",dot:".",normalSpace:" ",thinSpace:" ",narrowNoBreakSpace:" ",noBreakSpace:" ",noSeparator:"",apostrophe:"'",arabicThousandsSeparator:"٬",dotAbove:"˙",privateUseTwo:"’"},divisorWhenUnfocused:{none:null,percentage:100,permille:1e3,basisPoint:1e4},emptyInputBehavior:{focus:"focus",press:"press",always:"always",zero:"zero",min:"min",max:"max",null:"null"},eventBubbles:{bubbles:!0,doesNotBubble:!1},eventIsCancelable:{isCancelable:!0,isNotCancelable:!1},failOnUnknownOption:{fail:!0,ignore:!1},formatOnPageLoad:{format:!0,doNotFormat:!1},formulaMode:{enabled:!0,disabled:!1},historySize:{verySmall:5,small:10,medium:20,large:50,veryLarge:100,insane:Number.MAX_SAFE_INTEGER},invalidClass:"an-invalid",isCancellable:{cancellable:!0,notCancellable:!1},leadingZero:{allow:"allow",deny:"deny",keep:"keep"},maximumValue:{tenTrillions:"10000000000000",oneBillion:"1000000000",zero:"0"},minimumValue:{tenTrillions:"-10000000000000",oneBillion:"-1000000000",zero:"0"},modifyValueOnWheel:{modifyValue:!0,doNothing:!1},negativeBracketsTypeOnBlur:{parentheses:"(,)",brackets:"[,]",chevrons:"<,>",curlyBraces:"{,}",angleBrackets:"〈,〉",japaneseQuotationMarks:"｢,｣",halfBrackets:"⸤,⸥",whiteSquareBrackets:"⟦,⟧",quotationMarks:"‹,›",guillemets:"«,»",none:null},negativePositiveSignPlacement:{prefix:"p",suffix:"s",left:"l",right:"r",none:null},negativeSignCharacter:{hyphen:"-",minus:"−",heavyMinus:"➖",fullWidthHyphen:"－",circledMinus:"⊖",squaredMinus:"⊟",triangleMinus:"⨺",plusMinus:"±",minusPlus:"∓",dotMinus:"∸",minusTilde:"≂",not:"¬"},noEventListeners:{noEvents:!0,addEvents:!1},onInvalidPaste:{error:"error",ignore:"ignore",clamp:"clamp",truncate:"truncate",replace:"replace"},outputFormat:{string:"string",number:"number",dot:".",negativeDot:"-.",comma:",",negativeComma:"-,",dotNegative:".-",commaNegative:",-",none:null},overrideMinMaxLimits:{ceiling:"ceiling",floor:"floor",ignore:"ignore",invalid:"invalid",doNotOverride:null},positiveSignCharacter:{plus:"+",fullWidthPlus:"＋",heavyPlus:"➕",doublePlus:"⧺",triplePlus:"⧻",circledPlus:"⊕",squaredPlus:"⊞",trianglePlus:"⨹",plusMinus:"±",minusPlus:"∓",dotPlus:"∔",altHebrewPlus:"﬩",normalSpace:" ",thinSpace:" ",narrowNoBreakSpace:" ",noBreakSpace:" "},rawValueDivisor:{none:null,percentage:100,permille:1e3,basisPoint:1e4},readOnly:{readOnly:!0,readWrite:!1},roundingMethod:{halfUpSymmetric:"S",halfUpAsymmetric:"A",halfDownSymmetric:"s",halfDownAsymmetric:"a",halfEvenBankersRounding:"B",upRoundAwayFromZero:"U",downRoundTowardZero:"D",toCeilingTowardPositiveInfinity:"C",toFloorTowardNegativeInfinity:"F",toNearest05:"N05",toNearest05Alt:"CHF",upToNext05:"U05",downToNext05:"D05"},saveValueToSessionStorage:{save:!0,doNotSave:!1},selectNumberOnly:{selectNumbersOnly:!0,selectAll:!1},selectOnFocus:{select:!0,doNotSelect:!1},serializeSpaces:{plus:"+",percent:"%20"},showOnlyNumbersOnFocus:{onlyNumbers:!0,showAll:!1},showPositiveSign:{show:!0,hide:!1},showWarnings:{show:!0,hide:!1},styleRules:{none:null,positiveNegative:{positive:"autoNumeric-positive",negative:"autoNumeric-negative"},range0To100With4Steps:{ranges:[{min:0,max:25,class:"autoNumeric-red"},{min:25,max:50,class:"autoNumeric-orange"},{min:50,max:75,class:"autoNumeric-yellow"},{min:75,max:100,class:"autoNumeric-green"}]},evenOdd:{userDefined:[{callback:function(e){return e%2==0},classes:["autoNumeric-even","autoNumeric-odd"]}]},rangeSmallAndZero:{userDefined:[{callback:function(e){return-1<=e&&e<0?0:0===Number(e)?1:0<e&&e<=1?2:null},classes:["autoNumeric-small-negative","autoNumeric-zero","autoNumeric-small-positive"]}]}},suffixText:{none:"",percentage:"%",permille:"‰",basisPoint:"‱"},symbolWhenUnfocused:{none:null,percentage:"%",permille:"‰",basisPoint:"‱"},unformatOnHover:{unformat:!0,doNotUnformat:!1},unformatOnSubmit:{unformat:!0,keepCurrentValue:!1},valuesToStrings:{none:null,zeroDash:{0:"-"},oneAroundZero:{"-1":"Min",1:"Max"}},watchExternalChanges:{watch:!0,doNotWatch:!1},wheelOn:{focus:"focus",hover:"hover"},wheelStep:{progressive:"progressive"}},O=k.options,Object.getOwnPropertyNames(O).forEach(function(e){"valuesToStrings"===e?Object.getOwnPropertyNames(O.valuesToStrings).forEach(function(e){M.isIE11()||null===O.valuesToStrings[e]||Object.freeze(O.valuesToStrings[e])}):"styleRules"!==e&&(M.isIE11()||null===O[e]||Object.freeze(O[e]))}),Object.freeze(O),Object.defineProperty(k,"options",{configurable:!1,writable:!1}),k.defaultSettings={allowDecimalPadding:k.options.allowDecimalPadding.always,alwaysAllowDecimalCharacter:k.options.alwaysAllowDecimalCharacter.doNotAllow,caretPositionOnFocus:k.options.caretPositionOnFocus.doNoForceCaretPosition,createLocalList:k.options.createLocalList.createList,currencySymbol:k.options.currencySymbol.none,currencySymbolPlacement:k.options.currencySymbolPlacement.prefix,decimalCharacter:k.options.decimalCharacter.dot,decimalCharacterAlternative:k.options.decimalCharacterAlternative.none,decimalPlaces:k.options.decimalPlaces.two,decimalPlacesRawValue:k.options.decimalPlacesRawValue.useDefault,decimalPlacesShownOnBlur:k.options.decimalPlacesShownOnBlur.useDefault,decimalPlacesShownOnFocus:k.options.decimalPlacesShownOnFocus.useDefault,defaultValueOverride:k.options.defaultValueOverride.doNotOverride,digitalGroupSpacing:k.options.digitalGroupSpacing.three,digitGroupSeparator:k.options.digitGroupSeparator.comma,divisorWhenUnfocused:k.options.divisorWhenUnfocused.none,emptyInputBehavior:k.options.emptyInputBehavior.focus,eventBubbles:k.options.eventBubbles.bubbles,eventIsCancelable:k.options.eventIsCancelable.isCancelable,failOnUnknownOption:k.options.failOnUnknownOption.ignore,formatOnPageLoad:k.options.formatOnPageLoad.format,formulaMode:k.options.formulaMode.disabled,historySize:k.options.historySize.medium,invalidClass:k.options.invalidClass,isCancellable:k.options.isCancellable.cancellable,leadingZero:k.options.leadingZero.deny,maximumValue:k.options.maximumValue.tenTrillions,minimumValue:k.options.minimumValue.tenTrillions,modifyValueOnWheel:k.options.modifyValueOnWheel.modifyValue,negativeBracketsTypeOnBlur:k.options.negativeBracketsTypeOnBlur.none,negativePositiveSignPlacement:k.options.negativePositiveSignPlacement.none,negativeSignCharacter:k.options.negativeSignCharacter.hyphen,noEventListeners:k.options.noEventListeners.addEvents,onInvalidPaste:k.options.onInvalidPaste.error,outputFormat:k.options.outputFormat.none,overrideMinMaxLimits:k.options.overrideMinMaxLimits.doNotOverride,positiveSignCharacter:k.options.positiveSignCharacter.plus,rawValueDivisor:k.options.rawValueDivisor.none,readOnly:k.options.readOnly.readWrite,roundingMethod:k.options.roundingMethod.halfUpSymmetric,saveValueToSessionStorage:k.options.saveValueToSessionStorage.doNotSave,selectNumberOnly:k.options.selectNumberOnly.selectNumbersOnly,selectOnFocus:k.options.selectOnFocus.select,serializeSpaces:k.options.serializeSpaces.plus,showOnlyNumbersOnFocus:k.options.showOnlyNumbersOnFocus.showAll,showPositiveSign:k.options.showPositiveSign.hide,showWarnings:k.options.showWarnings.show,styleRules:k.options.styleRules.none,suffixText:k.options.suffixText.none,symbolWhenUnfocused:k.options.symbolWhenUnfocused.none,unformatOnHover:k.options.unformatOnHover.unformat,unformatOnSubmit:k.options.unformatOnSubmit.keepCurrentValue,valuesToStrings:k.options.valuesToStrings.none,watchExternalChanges:k.options.watchExternalChanges.doNotWatch,wheelOn:k.options.wheelOn.focus,wheelStep:k.options.wheelStep.progressive},Object.freeze(k.defaultSettings),Object.defineProperty(k,"defaultSettings",{configurable:!1,writable:!1});var E={digitGroupSeparator:k.options.digitGroupSeparator.dot,decimalCharacter:k.options.decimalCharacter.comma,decimalCharacterAlternative:k.options.decimalCharacterAlternative.dot,currencySymbol:" €",currencySymbolPlacement:k.options.currencySymbolPlacement.suffix,negativePositiveSignPlacement:k.options.negativePositiveSignPlacement.prefix},_={digitGroupSeparator:k.options.digitGroupSeparator.comma,decimalCharacter:k.options.decimalCharacter.dot,currencySymbol:k.options.currencySymbol.dollar,currencySymbolPlacement:k.options.currencySymbolPlacement.prefix,negativePositiveSignPlacement:k.options.negativePositiveSignPlacement.right},C={digitGroupSeparator:k.options.digitGroupSeparator.comma,decimalCharacter:k.options.decimalCharacter.dot,currencySymbol:k.options.currencySymbol.yen,currencySymbolPlacement:k.options.currencySymbolPlacement.prefix,negativePositiveSignPlacement:k.options.negativePositiveSignPlacement.right};M.cloneObject(E).formulaMode=k.options.formulaMode.enabled;var F=M.cloneObject(E);F.minimumValue=0;var x=M.cloneObject(E);x.maximumValue=0,x.negativePositiveSignPlacement=k.options.negativePositiveSignPlacement.prefix;var V=M.cloneObject(E);V.digitGroupSeparator=k.options.digitGroupSeparator.normalSpace;var T=M.cloneObject(V);T.minimumValue=0;var A=M.cloneObject(V);A.maximumValue=0,A.negativePositiveSignPlacement=k.options.negativePositiveSignPlacement.prefix;var L=M.cloneObject(E);L.currencySymbol=k.options.currencySymbol.none,L.suffixText=" ".concat(k.options.suffixText.percentage),L.wheelStep=1e-4,L.rawValueDivisor=k.options.rawValueDivisor.percentage;var I=M.cloneObject(L);I.minimumValue=0;var B=M.cloneObject(L);B.maximumValue=0,B.negativePositiveSignPlacement=k.options.negativePositiveSignPlacement.prefix;var D=M.cloneObject(L);D.decimalPlaces=3;var R=M.cloneObject(I);R.decimalPlaces=3;var U=M.cloneObject(B);U.decimalPlaces=3,M.cloneObject(_).formulaMode=k.options.formulaMode.enabled;var j=M.cloneObject(_);j.minimumValue=0;var z=M.cloneObject(_);z.maximumValue=0,z.negativePositiveSignPlacement=k.options.negativePositiveSignPlacement.prefix;var K=M.cloneObject(z);K.negativeBracketsTypeOnBlur=k.options.negativeBracketsTypeOnBlur.parentheses;var G=M.cloneObject(_);G.currencySymbol=k.options.currencySymbol.none,G.suffixText=k.options.suffixText.percentage,G.wheelStep=1e-4,G.rawValueDivisor=k.options.rawValueDivisor.percentage;var W=M.cloneObject(G);W.minimumValue=0;var H=M.cloneObject(G);H.maximumValue=0,H.negativePositiveSignPlacement=k.options.negativePositiveSignPlacement.prefix;var Z=M.cloneObject(G);Z.decimalPlaces=3;var q=M.cloneObject(W);q.decimalPlaces=3;var $=M.cloneObject(H);$.decimalPlaces=3;var J=M.cloneObject(E);J.currencySymbol=k.options.currencySymbol.lira,k.predefinedOptions={euro:E,euroPos:F,euroNeg:x,euroSpace:V,euroSpacePos:T,euroSpaceNeg:A,percentageEU2dec:L,percentageEU2decPos:I,percentageEU2decNeg:B,percentageEU3dec:D,percentageEU3decPos:R,percentageEU3decNeg:U,dollar:_,dollarPos:j,dollarNeg:z,dollarNegBrackets:K,percentageUS2dec:G,percentageUS2decPos:W,percentageUS2decNeg:H,percentageUS3dec:Z,percentageUS3decPos:q,percentageUS3decNeg:$,French:E,Spanish:E,NorthAmerican:_,British:{digitGroupSeparator:k.options.digitGroupSeparator.comma,decimalCharacter:k.options.decimalCharacter.dot,currencySymbol:k.options.currencySymbol.pound,currencySymbolPlacement:k.options.currencySymbolPlacement.prefix,negativePositiveSignPlacement:k.options.negativePositiveSignPlacement.right},Swiss:{digitGroupSeparator:k.options.digitGroupSeparator.apostrophe,decimalCharacter:k.options.decimalCharacter.dot,currencySymbol:" CHF",currencySymbolPlacement:k.options.currencySymbolPlacement.suffix,negativePositiveSignPlacement:k.options.negativePositiveSignPlacement.prefix},Japanese:C,Chinese:C,Brazilian:{digitGroupSeparator:k.options.digitGroupSeparator.dot,decimalCharacter:k.options.decimalCharacter.comma,currencySymbol:k.options.currencySymbol.real,currencySymbolPlacement:k.options.currencySymbolPlacement.prefix,negativePositiveSignPlacement:k.options.negativePositiveSignPlacement.right},Turkish:J,dotDecimalCharCommaSeparator:{digitGroupSeparator:k.options.digitGroupSeparator.comma,decimalCharacter:k.options.decimalCharacter.dot},commaDecimalCharDotSeparator:{digitGroupSeparator:k.options.digitGroupSeparator.dot,decimalCharacter:k.options.decimalCharacter.comma,decimalCharacterAlternative:k.options.decimalCharacterAlternative.dot},integer:{decimalPlaces:0},integerPos:{minimumValue:k.options.minimumValue.zero,decimalPlaces:0},integerNeg:{maximumValue:k.options.maximumValue.zero,decimalPlaces:0},float:{allowDecimalPadding:k.options.allowDecimalPadding.never},floatPos:{allowDecimalPadding:k.options.allowDecimalPadding.never,minimumValue:k.options.minimumValue.zero,maximumValue:k.options.maximumValue.tenTrillions},floatNeg:{allowDecimalPadding:k.options.allowDecimalPadding.never,minimumValue:k.options.minimumValue.tenTrillions,maximumValue:k.options.maximumValue.zero},numeric:{digitGroupSeparator:k.options.digitGroupSeparator.noSeparator,decimalCharacter:k.options.decimalCharacter.dot,currencySymbol:k.options.currencySymbol.none},numericPos:{digitGroupSeparator:k.options.digitGroupSeparator.noSeparator,decimalCharacter:k.options.decimalCharacter.dot,currencySymbol:k.options.currencySymbol.none,minimumValue:k.options.minimumValue.zero,maximumValue:k.options.maximumValue.tenTrillions},numericNeg:{digitGroupSeparator:k.options.digitGroupSeparator.noSeparator,decimalCharacter:k.options.decimalCharacter.dot,currencySymbol:k.options.currencySymbol.none,minimumValue:k.options.minimumValue.tenTrillions,maximumValue:k.options.maximumValue.zero}},Object.getOwnPropertyNames(k.predefinedOptions).forEach(function(e){Object.freeze(k.predefinedOptions[e])}),Object.freeze(k.predefinedOptions),Object.defineProperty(k,"predefinedOptions",{configurable:!1,writable:!1}),t.default=k}],a.c=n,a.d=function(e,t,i){a.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:i})},a.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},a.t=function(t,e){if(1&e&&(t=a(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var i=Object.create(null);if(a.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var n in t)a.d(i,n,function(e){return t[e]}.bind(null,n));return i},a.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return a.d(t,"a",t),t},a.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},a.p="",a(a.s=0).default;function a(e){if(n[e])return n[e].exports;var t=n[e]={i:e,l:!1,exports:{}};return i[e].call(t.exports,t,t.exports,a),t.l=!0,t.exports}var i,n});
//# sourceMappingURL=autoNumeric.min.js.map

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1559);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("25e137e1", content, true, {});

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.promo-pricing-modal-container[data-v-3f7ede68] {\n  position: fixed;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 13;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.promo-pricing-modal-container.show[data-v-3f7ede68] {\n    top: 0;\n    opacity: 1;\n}\n.promo-pricing-modal-container .promo-pricing-modal[data-v-3f7ede68] {\n    display: table;\n    width: 100%;\n    height: 100%;\n}\n.promo-pricing-modal-container .promo-pricing-modal-content[data-v-3f7ede68] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.promo-pricing-modal-container .promo-pricing-form[data-v-3f7ede68] {\n    background-color: #fff;\n    border-radius: 3px;\n    width: 400px;\n    margin: 0 auto;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    padding: 15px;\n}\n.promo-pricing-modal-container .promo-pricing-form .title[data-v-3f7ede68] {\n      text-align: center;\n      color: #0D79F2;\n      font-size: 14px;\n      font-weight: 700;\n      margin-bottom: 15px;\n}\n.promo-pricing-modal-container .promo-pricing-form .select-input[data-v-3f7ede68] {\n      margin-bottom: 10px;\n}\n.promo-pricing-modal-container .promo-pricing-form .select-input label[data-v-3f7ede68] {\n        color: #0D79F2;\n        font-size: 10px;\n        font-weight: 700;\n}\n.promo-pricing-modal-container .promo-pricing-form .select-input select[data-v-3f7ede68] {\n        font-size: 14px;\n        outline: 0;\n        padding: 10px;\n        border-color: rgba(0, 0, 0, 0.15);\n        background-color: #fff;\n        border-radius: 3px;\n        height: 43px;\n}\n.promo-pricing-modal-container .promo-pricing-form .text-input[data-v-3f7ede68] {\n      margin-bottom: 10px;\n}\n.promo-pricing-modal-container .promo-pricing-form .text-input label[data-v-3f7ede68] {\n        color: #0D79F2;\n        font-size: 10px;\n        font-weight: 700;\n}\n.promo-pricing-modal-container .promo-pricing-form .text-input input[data-v-3f7ede68] {\n        margin-top: 0;\n        font-size: 14px;\n}\n.promo-pricing-modal-container .promo-pricing-form .promo-error[data-v-3f7ede68] {\n      font-size: 12px;\n      font-weight: 700;\n      text-align: center;\n      padding: 10px;\n      border: 1px solid #F20D0D;\n      border-radius: 3px;\n      color: #F20D0D;\n}\n.promo-pricing-modal-container .promo-pricing-form .controls[data-v-3f7ede68] {\n      text-align: center;\n      margin-top: 15px;\n}\n.promo-pricing-modal-container .promo-pricing-form .controls .button[data-v-3f7ede68] {\n        width: 70px;\n        height: 33px;\n}\n@media only screen and (max-width: 430px) {\n.promo-pricing-modal-container .promo-pricing-form[data-v-3f7ede68] {\n    width: 100%;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Pricing/Promo.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;IACI,eAAe;IACf,YAAY;IACZ,aAAa;CAChB;AACD;IACI,oBAAoB;IACpB,uBAAuB;CAC1B;AACD;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,iDAAiD;YACzC,yCAAyC;IACjD,cAAc;CACjB;AACD;MACM,mBAAmB;MACnB,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;QACQ,eAAe;QACf,gBAAgB;QAChB,iBAAiB;CACxB;AACD;QACQ,gBAAgB;QAChB,WAAW;QACX,cAAc;QACd,kCAAkC;QAClC,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;CACpB;AACD;MACM,oBAAoB;CACzB;AACD;QACQ,eAAe;QACf,gBAAgB;QAChB,iBAAiB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;CACvB;AACD;MACM,gBAAgB;MAChB,iBAAiB;MACjB,mBAAmB;MACnB,cAAc;MACd,0BAA0B;MAC1B,mBAAmB;MACnB,eAAe;CACpB;AACD;MACM,mBAAmB;MACnB,iBAAiB;CACtB;AACD;QACQ,YAAY;QACZ,aAAa;CACpB;AACD;AACA;IACI,YAAY;CACf;CACA","file":"Promo.vue","sourcesContent":["\n.promo-pricing-modal-container[data-v-3f7ede68] {\n  position: fixed;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 13;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.promo-pricing-modal-container.show[data-v-3f7ede68] {\n    top: 0;\n    opacity: 1;\n}\n.promo-pricing-modal-container .promo-pricing-modal[data-v-3f7ede68] {\n    display: table;\n    width: 100%;\n    height: 100%;\n}\n.promo-pricing-modal-container .promo-pricing-modal-content[data-v-3f7ede68] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.promo-pricing-modal-container .promo-pricing-form[data-v-3f7ede68] {\n    background-color: #fff;\n    border-radius: 3px;\n    width: 400px;\n    margin: 0 auto;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    padding: 15px;\n}\n.promo-pricing-modal-container .promo-pricing-form .title[data-v-3f7ede68] {\n      text-align: center;\n      color: #0D79F2;\n      font-size: 14px;\n      font-weight: 700;\n      margin-bottom: 15px;\n}\n.promo-pricing-modal-container .promo-pricing-form .select-input[data-v-3f7ede68] {\n      margin-bottom: 10px;\n}\n.promo-pricing-modal-container .promo-pricing-form .select-input label[data-v-3f7ede68] {\n        color: #0D79F2;\n        font-size: 10px;\n        font-weight: 700;\n}\n.promo-pricing-modal-container .promo-pricing-form .select-input select[data-v-3f7ede68] {\n        font-size: 14px;\n        outline: 0;\n        padding: 10px;\n        border-color: rgba(0, 0, 0, 0.15);\n        background-color: #fff;\n        border-radius: 3px;\n        height: 43px;\n}\n.promo-pricing-modal-container .promo-pricing-form .text-input[data-v-3f7ede68] {\n      margin-bottom: 10px;\n}\n.promo-pricing-modal-container .promo-pricing-form .text-input label[data-v-3f7ede68] {\n        color: #0D79F2;\n        font-size: 10px;\n        font-weight: 700;\n}\n.promo-pricing-modal-container .promo-pricing-form .text-input input[data-v-3f7ede68] {\n        margin-top: 0;\n        font-size: 14px;\n}\n.promo-pricing-modal-container .promo-pricing-form .promo-error[data-v-3f7ede68] {\n      font-size: 12px;\n      font-weight: 700;\n      text-align: center;\n      padding: 10px;\n      border: 1px solid #F20D0D;\n      border-radius: 3px;\n      color: #F20D0D;\n}\n.promo-pricing-modal-container .promo-pricing-form .controls[data-v-3f7ede68] {\n      text-align: center;\n      margin-top: 15px;\n}\n.promo-pricing-modal-container .promo-pricing-form .controls .button[data-v-3f7ede68] {\n        width: 70px;\n        height: 33px;\n}\n@media only screen and (max-width: 430px) {\n.promo-pricing-modal-container .promo-pricing-form[data-v-3f7ede68] {\n    width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'promo-pricing-modal-container': true, show: _vm.show }},[_c('div',{staticClass:"promo-pricing-modal"},[_c('div',{staticClass:"promo-pricing-modal-content"},[_c('div',{staticClass:"promo-pricing-form"},[_c('div',{staticClass:"title"},[_vm._v("NEW PROMOTIONAL PRICING")]),_vm._v(" "),_c('div',{staticClass:"select-input"},[_c('label',[_vm._v("SERVICE TYPE")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.promoForm.serviceType),expression:"promoForm.serviceType"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.promoForm, "serviceType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Choose One")]),_vm._v(" "),_vm._l((_vm.services),function(service){return _c('option',{domProps:{"value":service.id}},[_vm._v(_vm._s(service.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"select-input"},[_c('label',[_vm._v("PROMOTION TYPE")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.promoForm.promoType),expression:"promoForm.promoType"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.promoForm, "promoType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Choose One")]),_vm._v(" "),_c('option',{attrs:{"value":"flat"}},[_vm._v("Flat Rate")]),_vm._v(" "),_c('option',{attrs:{"value":"discount"}},[_vm._v("Discount Mileage Rate")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.promoForm.promoType === 'flat'),expression:"promoForm.promoType === 'flat'"}],staticClass:"text-input"},[_c('label',[_vm._v("FLAT RATE")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar},model:{value:(_vm.promoForm.flatRate),callback:function ($$v) {_vm.$set(_vm.promoForm, "flatRate", $$v)},expression:"promoForm.flatRate"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.promoForm.promoType === 'discount'),expression:"promoForm.promoType === 'discount'"}],staticClass:"text-input"},[_c('label',[_vm._v("BASE RATE")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar},model:{value:(_vm.promoForm.baseRate),callback:function ($$v) {_vm.$set(_vm.promoForm, "baseRate", $$v)},expression:"promoForm.baseRate"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.promoForm.promoType === 'discount'),expression:"promoForm.promoType === 'discount'"}],staticClass:"text-input"},[_c('label',[_vm._v("MILEAGE RATE")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar},model:{value:(_vm.promoForm.mileageRate),callback:function ($$v) {_vm.$set(_vm.promoForm, "mileageRate", $$v)},expression:"promoForm.mileageRate"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.promoForm.promoType !== ''),expression:"promoForm.promoType !== ''"}],staticClass:"text-input"},[_c('label',[_vm._v("2ND PAX FEE")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar},model:{value:(_vm.promoForm.secondPaxFee),callback:function ($$v) {_vm.$set(_vm.promoForm, "secondPaxFee", $$v)},expression:"promoForm.secondPaxFee"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.promoForm.promoType !== ''),expression:"promoForm.promoType !== ''"}],staticClass:"text-input"},[_c('label',[_vm._v("ADDITIONAL PAX FEE")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar},model:{value:(_vm.promoForm.addPaxFee),callback:function ($$v) {_vm.$set(_vm.promoForm, "addPaxFee", $$v)},expression:"promoForm.addPaxFee"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.promoForm.error.show),expression:"promoForm.error.show"}],staticClass:"promo-error"},[_vm._v(_vm._s(_vm.promoForm.error.message))]),_vm._v(" "),_c('div',{staticClass:"controls"},[_c('a',{class:{ 'button xsmall cta secondary': true, disabled: _vm.promoForm.saving },attrs:{"href":"javascript:;"},on:{"click":_vm.hideForm}},[_vm._v("CANCEL")]),_vm._v(" "),_c('a',{class:{ 'button xsmall cta success': true, disabled: _vm.promoForm.saving },attrs:{"href":"javascript:;"},on:{"click":_vm.addPromo}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.promoForm.saving),expression:"promoForm.saving"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.promoForm.saving),expression:"!promoForm.saving"}]},[_vm._v("SAVE")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box no-padding"},[_c('div',{staticClass:"header"},[_vm._v("Service Rate Settings")]),_vm._v(" "),_c('div',{staticClass:"body"},[(!_vm.isMobile)?_c('table',[_c('thead',[_c('th'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.travelInsuranceLabel)),_c('br'),_vm._v("Per Mile")]),_vm._v(" "),_c('th',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAirportFee),expression:"showAirportFee"}]},[_vm._v("Airport Fee")]),_vm._v(" "),_c('th',[_vm._v("Per Mile Rate")]),_vm._v(" "),_c('th',[_vm._v("Base Rate")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('th',[_vm._v("Flat 2nd Pax Fee")]),_vm._v(" "),_c('th',[_vm._v("Flat Add. Pax Fee")]),_vm._v(" "),_c('th',{staticClass:"discount",attrs:{"colspan":"2"}},[_vm._v("Discount")]),_vm._v(" "),(_vm.type !== 'asap')?_c('th',{staticClass:"roundtrip",attrs:{"colspan":"2"}},[_vm._v("Roundtrip")]):_vm._e()]),_vm._v(" "),_c('tbody',_vm._l((_vm.services),function(service,index){return (_vm.showService(service))?_c('tr',[_c('td',{attrs:{"title":service.id}},[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.dollar10,"disabled":_vm.saving},model:{value:(service[_vm.type].gasFee),callback:function ($$v) {_vm.$set(service[_vm.type], "gasFee", $$v)},expression:"service[type].gasFee"}})],1),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service[_vm.type].travelInsurance),callback:function ($$v) {_vm.$set(service[_vm.type], "travelInsurance", $$v)},expression:"service[type].travelInsurance"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(service[_vm.type]))])],1),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAirportFee),expression:"showAirportFee"}]},[_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service[_vm.type].airportFee),callback:function ($$v) {_vm.$set(service[_vm.type], "airportFee", $$v)},expression:"service[type].airportFee"}})],1),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service[_vm.type].mileageRate),callback:function ($$v) {_vm.$set(service[_vm.type], "mileageRate", $$v)},expression:"service[type].mileageRate"}})],1),_vm._v(" "),_c('td',[_c('vue-autonumeric',{staticClass:"base-rate",attrs:{"options":_vm.dollar2,"disabled":_vm.saving},model:{value:(service[_vm.type].fare),callback:function ($$v) {_vm.$set(service[_vm.type], "fare", $$v)},expression:"service[type].fare"}})],1),_vm._v(" "),_c('td',[_c('vue-autonumeric',{staticClass:"mile-threshold",attrs:{"options":'floatPos',"disabled":_vm.saving},model:{value:(service[_vm.type].mileageThreshold),callback:function ($$v) {_vm.$set(service[_vm.type], "mileageThreshold", $$v)},expression:"service[type].mileageThreshold"}})],1),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service[_vm.type].flat2paxFee),callback:function ($$v) {_vm.$set(service[_vm.type], "flat2paxFee", $$v)},expression:"service[type].flat2paxFee"}})],1),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service[_vm.type].flatNpaxFee),callback:function ($$v) {_vm.$set(service[_vm.type], "flatNpaxFee", $$v)},expression:"service[type].flatNpaxFee"}})],1),_vm._v(" "),_c('td',{staticClass:"discount p-R-0"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(service[_vm.type].discountType),expression:"service[type].discountType"}],attrs:{"disabled":_vm.saving},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(service[_vm.type], "discountType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateValue(index, 'discountType')}]}},[_c('option',{attrs:{"value":"$"}},[_vm._v("$")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])]),_vm._v(" "),_c('td',{staticClass:"discount p-L-0 discount-value"},[_c('vue-autonumeric',{attrs:{"options":_vm.oneHundred,"disabled":_vm.saving},model:{value:(service[_vm.type].discountAmount),callback:function ($$v) {_vm.$set(service[_vm.type], "discountAmount", $$v)},expression:"service[type].discountAmount"}})],1),_vm._v(" "),(_vm.type !== 'asap')?_c('td',{staticClass:"roundtrip p-R-0"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(service[_vm.type].roundtripType),expression:"service[type].roundtripType"}],attrs:{"disabled":_vm.saving},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(service[_vm.type], "roundtripType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateValue(index, 'roundtripType')}]}},[_c('option',{attrs:{"value":"$"}},[_vm._v("$")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])]):_vm._e(),_vm._v(" "),(_vm.type !== 'asap')?_c('td',{staticClass:"roundtrip p-L-0 discount-value"},[_c('vue-autonumeric',{attrs:{"options":_vm.oneHundred,"disabled":_vm.saving},model:{value:(service[_vm.type].roundtripAmount),callback:function ($$v) {_vm.$set(service[_vm.type], "roundtripAmount", $$v)},expression:"service[type].roundtripAmount"}})],1):_vm._e()]):_vm._e()}),0)]):_c('div',{staticClass:"cards"},_vm._l((_vm.services),function(service,index){return (_vm.showService(service))?_c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('div',{staticClass:"row-fields"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.travelInsuranceLabel)+" Per Mile")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service[_vm.type].travelInsurance),callback:function ($$v) {_vm.$set(service[_vm.type], "travelInsurance", $$v)},expression:"service[type].travelInsurance"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAirportFee),expression:"showAirportFee"}],staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Airport Fee")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service[_vm.type].airportFee),callback:function ($$v) {_vm.$set(service[_vm.type], "airportFee", $$v)},expression:"service[type].airportFee"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row-fields"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Per Mile Rate")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service[_vm.type].mileageRate),callback:function ($$v) {_vm.$set(service[_vm.type], "mileageRate", $$v)},expression:"service[type].mileageRate"}})],1),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Base Rate")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar2,"disabled":_vm.saving},model:{value:(service[_vm.type].fare),callback:function ($$v) {_vm.$set(service[_vm.type], "fare", $$v)},expression:"service[type].fare"}})],1),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Mileage Threshold")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":'floatPos',"disabled":_vm.saving},model:{value:(service[_vm.type].mileageThreshold),callback:function ($$v) {_vm.$set(service[_vm.type], "mileageThreshold", $$v)},expression:"service[type].mileageThreshold"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row-fields"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Flat 2nd Pax Fee")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service[_vm.type].flat2paxFee),callback:function ($$v) {_vm.$set(service[_vm.type], "flat2paxFee", $$v)},expression:"service[type].flat2paxFee"}})],1),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Flat Add. Pax Fee")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service[_vm.type].flatNpaxFee),callback:function ($$v) {_vm.$set(service[_vm.type], "flatNpaxFee", $$v)},expression:"service[type].flatNpaxFee"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row-fields"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Discount")]),_vm._v(" "),_c('div',{staticClass:"discount"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(service[_vm.type].discountType),expression:"service[type].discountType"}],attrs:{"disabled":_vm.saving},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(service[_vm.type], "discountType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateValue(index, 'discountType')}]}},[_c('option',{attrs:{"value":"$"}},[_vm._v("$")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.oneHundred,"disabled":_vm.saving},model:{value:(service[_vm.type].discountAmount),callback:function ($$v) {_vm.$set(service[_vm.type], "discountAmount", $$v)},expression:"service[type].discountAmount"}})],1)]),_vm._v(" "),(_vm.type !== 'asap')?_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Roundtrip")]),_vm._v(" "),_c('div',{staticClass:"discount"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(service[_vm.type].roundtripType),expression:"service[type].roundtripType"}],attrs:{"disabled":_vm.saving},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(service[_vm.type], "roundtripType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateValue(index, 'roundtripType')}]}},[_c('option',{attrs:{"value":"$"}},[_vm._v("$")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.oneHundred,"disabled":_vm.saving},model:{value:(service[_vm.type].roundtripAmount),callback:function ($$v) {_vm.$set(service[_vm.type], "roundtripAmount", $$v)},expression:"service[type].roundtripAmount"}})],1)]):_vm._e()])]):_vm._e()}),0),_vm._v(" "),_c('div',{staticClass:"discount-date"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column medium-6 date-box"},[_c('div',{staticClass:"label"},[_vm._v("Discount Date")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"sub-label"},[_vm._v("Start")]),_vm._v(" "),_c('date-picker',{staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},model:{value:(_vm.discountStart),callback:function ($$v) {_vm.discountStart=$$v},expression:"discountStart"}})],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"sub-label"},[_vm._v("End")]),_vm._v(" "),_c('date-picker',{staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.discountEndMin},model:{value:(_vm.discountEnd),callback:function ($$v) {_vm.discountEnd=$$v},expression:"discountEnd"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column medium-6 dc-type-box"},[_c('span',{staticClass:"dc-type",on:{"click":function($event){_vm.dcTypeAdmin = !_vm.dcTypeAdmin}}},[(_vm.dcTypeAdmin)?_c('i',{staticClass:"fas fa-check-square fa-2x"}):_c('i',{class:['far fa-square fa-2x', {'disabled':_vm.selectedServiceArea === 0}]}),_vm._v("\n              Backoffice\n            ")]),_vm._v(" "),_c('span',{staticClass:"dc-type",on:{"click":function($event){_vm.dcTypeWidget = !_vm.dcTypeWidget}}},[(_vm.dcTypeWidget)?_c('i',{staticClass:"fas fa-check-square fa-2x"}):_c('i',{class:['far fa-square fa-2x', {'disabled':_vm.selectedServiceArea === 0}]}),_vm._v("\n              Widget\n            ")]),_vm._v(" "),_c('span',{staticClass:"dc-type",on:{"click":function($event){_vm.dcTypeApp = !_vm.dcTypeApp}}},[(_vm.dcTypeApp)?_c('i',{staticClass:"fas fa-check-square fa-2x"}):_c('i',{class:['far fa-square fa-2x', {'disabled':_vm.selectedServiceArea === 0}]}),_vm._v("\n              CA\n            ")]),_vm._v(" "),_c('span',{staticClass:"dc-type",on:{"click":function($event){_vm.dcTypeCsr = !_vm.dcTypeCsr}}},[(_vm.dcTypeCsr)?_c('i',{staticClass:"fas fa-check-square fa-2x"}):_c('i',{class:['far fa-square fa-2x', {'disabled':_vm.selectedServiceArea === 0}]}),_vm._v("\n              CSR\n            ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"d-flex g20"},[(_vm.type !== 'asap' && _vm.isD2D)?_c('div',{staticClass:"box no-padding d2d"},[_c('div',{staticClass:"header"},[_vm._v("Service Rate Settings (Ground Bookings on Flights)")]),_vm._v(" "),_c('div',{staticClass:"body"},[(!_vm.isMobile)?_c('table',[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.services),function(service,index){return (_vm.showService(service))?_c('tr',[_c('td',[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('td',{staticClass:"discount p-R-0"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(service.flight.onewayType),expression:"service.flight.onewayType"}],attrs:{"disabled":_vm.saving},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(service.flight, "onewayType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateValue(index, 'discountType')}]}},[_c('option',{attrs:{"value":"$"}},[_vm._v("$")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])]),_vm._v(" "),_c('td',{staticClass:"discount p-L-0 discount-value"},[_c('vue-autonumeric',{attrs:{"options":_vm.oneHundred,"disabled":_vm.saving},model:{value:(service.flight.onewayRate),callback:function ($$v) {_vm.$set(service.flight, "onewayRate", $$v)},expression:"service.flight.onewayRate"}})],1),_vm._v(" "),_c('td',{staticClass:"roundtrip p-R-0"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(service.flight.roundtripType),expression:"service.flight.roundtripType"}],attrs:{"disabled":_vm.saving},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(service.flight, "roundtripType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateValue(index, 'roundtripType')}]}},[_c('option',{attrs:{"value":"$"}},[_vm._v("$")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])]),_vm._v(" "),_c('td',{staticClass:"roundtrip p-L-0 discount-value"},[_c('vue-autonumeric',{attrs:{"options":_vm.oneHundred,"disabled":_vm.saving},model:{value:(service.flight.roundtripRate),callback:function ($$v) {_vm.$set(service.flight, "roundtripRate", $$v)},expression:"service.flight.roundtripRate"}})],1)]):_vm._e()}),0)]):_c('div',{staticClass:"cards"},_vm._l((_vm.services),function(service,index){return (_vm.showService(service))?_c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('div',{staticClass:"row-fields"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Discount")]),_vm._v(" "),_c('div',{staticClass:"discount"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(service[_vm.type].discountType),expression:"service[type].discountType"}],attrs:{"disabled":_vm.saving},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(service[_vm.type], "discountType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateValue(index, 'discountType')}]}},[_c('option',{attrs:{"value":"$"}},[_vm._v("$")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.oneHundred,"disabled":_vm.saving},model:{value:(service[_vm.type].discountAmount),callback:function ($$v) {_vm.$set(service[_vm.type], "discountAmount", $$v)},expression:"service[type].discountAmount"}})],1)]),_vm._v(" "),(_vm.type !== 'asap')?_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Roundtrip")]),_vm._v(" "),_c('div',{staticClass:"discount"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(service[_vm.type].roundtripType),expression:"service[type].roundtripType"}],attrs:{"disabled":_vm.saving},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(service[_vm.type], "roundtripType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateValue(index, 'roundtripType')}]}},[_c('option',{attrs:{"value":"$"}},[_vm._v("$")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.oneHundred,"disabled":_vm.saving},model:{value:(service[_vm.type].roundtripAmount),callback:function ($$v) {_vm.$set(service[_vm.type], "roundtripAmount", $$v)},expression:"service[type].roundtripAmount"}})],1)]):_vm._e()])]):_vm._e()}),0)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"box no-padding conv-box"},[_c('div',{staticClass:"header"},[_vm._v("Convenience Fee")]),_vm._v(" "),_c('div',{staticClass:"body"},[(!_vm.isMobile)?_c('table',[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.services),function(service,index){return (_vm.showService(service))?_c('tr',[_c('td',[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(service[_vm.type].portalFeeType),expression:"service[type].portalFeeType"}],attrs:{"disabled":_vm.saving},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(service[_vm.type], "portalFeeType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateValue(index, 'portalType')}]}},[_c('option',{attrs:{"value":"$"}},[_vm._v("$")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])]),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":'floatPos',"disabled":_vm.saving},model:{value:(service[_vm.type].portalFee),callback:function ($$v) {_vm.$set(service[_vm.type], "portalFee", $$v)},expression:"service[type].portalFee"}})],1)]):_vm._e()}),0)]):_c('div',{staticClass:"cards"},_vm._l((_vm.services),function(service,index){return (_vm.showService(service))?_c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('div',{staticClass:"row-fields"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Type")]),_vm._v(" "),_c('div',{staticClass:"discount"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(service[_vm.type].portalFeeType),expression:"service[type].portalFeeType"}],attrs:{"disabled":_vm.saving},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(service[_vm.type], "portalFeeType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateValue(index, 'portalType')}]}},[_c('option',{attrs:{"value":"$"}},[_vm._v("$")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])])]),_vm._v(" "),(_vm.type !== 'asap')?_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Value")]),_vm._v(" "),_c('div',{staticClass:"discount"},[_c('vue-autonumeric',{attrs:{"options":'floatPos',"disabled":_vm.saving},model:{value:(service[_vm.type].portalFee),callback:function ($$v) {_vm.$set(service[_vm.type], "portalFee", $$v)},expression:"service[type].portalFee"}})],1)]):_vm._e()])]):_vm._e()}),0)])])]),_vm._v(" "),_c('div',{staticClass:"box no-padding"},[_c('div',{staticClass:"header"},[_vm._v("Provider Rate Settings")]),_vm._v(" "),_c('div',{staticClass:"body"},[(!_vm.isMobile)?_c('table',[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((_vm.services),function(service){return (_vm.showService(service))?_c('tr',{key:service.id},[_c('td',[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service[_vm.type].provMileage),callback:function ($$v) {_vm.$set(service[_vm.type], "provMileage", $$v)},expression:"service[type].provMileage"}})],1),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.dollar2,"disabled":_vm.saving},model:{value:(service[_vm.type].provBaseFee),callback:function ($$v) {_vm.$set(service[_vm.type], "provBaseFee", $$v)},expression:"service[type].provBaseFee"}})],1),_vm._v(" "),_c('td',[(!service.isShared)?_c('span',[_vm._v("--")]):_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service[_vm.type].provBonus),callback:function ($$v) {_vm.$set(service[_vm.type], "provBonus", $$v)},expression:"service[type].provBonus"}})],1),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service[_vm.type].prov2paxFee),callback:function ($$v) {_vm.$set(service[_vm.type], "prov2paxFee", $$v)},expression:"service[type].prov2paxFee"}})],1),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service[_vm.type].provNpaxFee),callback:function ($$v) {_vm.$set(service[_vm.type], "provNpaxFee", $$v)},expression:"service[type].provNpaxFee"}})],1),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.percent,"disabled":_vm.saving},model:{value:(service[_vm.type].provDiscountRate),callback:function ($$v) {_vm.$set(service[_vm.type], "provDiscountRate", $$v)},expression:"service[type].provDiscountRate"}})],1)]):_vm._e()}),0)]):_c('div',{staticClass:"cards"},_vm._l((_vm.services),function(service){return (_vm.showService(service))?_c('div',{key:service.id,staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n            "+_vm._s(service.name)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"row-fields"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Per Mile Rate")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service[_vm.type].provMileage),callback:function ($$v) {_vm.$set(service[_vm.type], "provMileage", $$v)},expression:"service[type].provMileage"}})],1),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("\n                Base Fee\n              ")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service[_vm.type].provBaseFee),callback:function ($$v) {_vm.$set(service[_vm.type], "provBaseFee", $$v)},expression:"service[type].provBaseFee"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row-fields"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Flat 2nd Pax Fee")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service[_vm.type].prov2paxFee),callback:function ($$v) {_vm.$set(service[_vm.type], "prov2paxFee", $$v)},expression:"service[type].prov2paxFee"}})],1),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Flat Add. Pax Fee")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service[_vm.type].provNpaxFee),callback:function ($$v) {_vm.$set(service[_vm.type], "provNpaxFee", $$v)},expression:"service[type].provNpaxFee"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row-fields"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Discount Rate")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.percent,"disabled":_vm.saving},model:{value:(service[_vm.type].provDiscountRate),callback:function ($$v) {_vm.$set(service[_vm.type], "provDiscountRate", $$v)},expression:"service[type].provDiscountRate"}})],1),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Bonus Per Mile Party")]),_vm._v(" "),(!service.isShared)?_c('span',[_vm._v("--")]):_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service[_vm.type].provBonus),callback:function ($$v) {_vm.$set(service[_vm.type], "provBonus", $$v)},expression:"service[type].provBonus"}})],1)])]):_vm._e()}),0)])]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.type !== 'asap' && _vm.selectedServiceArea === 0)?_c('div',{staticClass:"column medium-6"},[_c('div',{staticClass:"box no-padding"},[_c('div',{staticClass:"header"},[_vm._v("Pickup Types")]),_vm._v(" "),_c('div',{staticClass:"body"},[(_vm.error.pickupTypes)?_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.pickupTypes))]):_vm._e(),_vm._v(" "),_c('table',[_vm._m(5),_vm._v(" "),_c('tbody',_vm._l((_vm.pickupTypesGlobal),function(service,index){return _c('tr',{key:service.id},[_c('td',[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('td',[_c('span',{on:{"click":function($event){return _vm.toggleGlobalPickupType(index, 'Curbside')}}},[(service.pickupTypes.Curbside && service.pickupTypes.Curbside.enabled)?_c('i',{staticClass:"fas fa-check-square fa-2x"}):_c('i',{staticClass:"far fa-square fa-2x"})])]),_vm._v(" "),_c('td',[_c('span',{on:{"click":function($event){return _vm.toggleGlobalPickupType(index, 'MeetAndGreet')}}},[(service.pickupTypes.MeetAndGreet && service.pickupTypes.MeetAndGreet.enabled)?_c('i',{staticClass:"fas fa-check-square fa-2x"}):_c('i',{staticClass:"far fa-square fa-2x"})])]),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},nativeOn:{"autoNumeric:rawValueModified":function($event){return _vm.toggleGlobalPickupTypeFee(index, 'MeetAndGreet')}},model:{value:(service.pickupTypes.MeetAndGreet.fee),callback:function ($$v) {_vm.$set(service.pickupTypes.MeetAndGreet, "fee", $$v)},expression:"service.pickupTypes.MeetAndGreet.fee"}})],1)])}),0)])])])]):_vm._e(),_vm._v(" "),(_vm.type !== 'asap' && _vm.selectedServiceArea !== 0)?_c('div',{staticClass:"column medium-6"},[_c('div',{staticClass:"box no-padding"},[_c('div',{staticClass:"header"},[_vm._v("Pickup Types")]),_vm._v(" "),_c('div',{staticClass:"body"},[(_vm.error.pickupTypes)?_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.pickupTypes))]):_vm._e(),_vm._v(" "),_c('table',[_vm._m(6),_vm._v(" "),_c('tbody',_vm._l((_vm.services),function(service,index){return (_vm.showService(service))?_c('tr',{key:service.id},[_c('td',[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('td',[_c('span',{on:{"click":function($event){return _vm.togglePickupType(index, 'Curbside', 'enabled')}}},[(service.pickupTypes.Curbside && service.pickupTypes.Curbside.enabled)?_c('i',{staticClass:"fas fa-check-square fa-2x"}):_c('i',{class:{'far fa-square fa-2x':true, 'disabled':_vm.selectedServiceArea === 0}})])]),_vm._v(" "),_c('td',[_c('span',{on:{"click":function($event){return _vm.togglePickupType(index, 'MeetAndGreet', 'enabled')}}},[(service.pickupTypes.MeetAndGreet && service.pickupTypes.MeetAndGreet.enabled)?_c('i',{staticClass:"fas fa-check-square fa-2x"}):_c('i',{class:{'far fa-square fa-2x':true, 'disabled':_vm.selectedServiceArea === 0}})])]),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},nativeOn:{"autoNumeric:rawValueModified":function($event){return _vm.togglePickupType(index, 'MeetAndGreet', 'fee')}},model:{value:(service.pickupTypes.MeetAndGreet.fee),callback:function ($$v) {_vm.$set(service.pickupTypes.MeetAndGreet, "fee", $$v)},expression:"service.pickupTypes.MeetAndGreet.fee"}})],1)]):_vm._e()}),0)])])])]):_vm._e(),_vm._v(" "),_c('div',{class:{'column medium-4 end':true, 'p-L-10': _vm.type !== 'asap'}},[_c('div',{staticClass:"box no-padding"},[_c('div',{staticClass:"header"},[_vm._v("Holiday Rates")]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('table',{staticClass:"holiday-rates"},[_c('tbody',_vm._l((_vm.services),function(service,index){return (_vm.showService(service))?_c('tr',{key:service.id},[_c('td',[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(service[_vm.type].holidayRateType),expression:"service[type].holidayRateType"}],attrs:{"disabled":_vm.saving},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(service[_vm.type], "holidayRateType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateValue(index, 'holidayRateType')}]}},[_c('option',{attrs:{"value":"$"}},[_vm._v("$")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])]),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.oneHundred,"disabled":_vm.saving},nativeOn:{"autoNumeric:rawValueModified":function($event){return _vm.updateValue(index, 'holidayRateAmount')}},model:{value:(service[_vm.type].holidayRateAmount),callback:function ($$v) {_vm.$set(service[_vm.type], "holidayRateAmount", $$v)},expression:"service[type].holidayRateAmount"}})],1)]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"discount-date holiday"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column medium-12 date-box"},[_c('div',{staticClass:"label"},[_vm._v("Holiday Date")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('date-picker',{staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},model:{value:(_vm.holidayDate),callback:function ($$v) {_vm.holidayDate=$$v},expression:"holidayDate"}}),_vm._v(" "),_c('date-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.holidays[1]),expression:"holidays[1]"}],staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},on:{"clear":function($event){return _vm.clearDate(1)}},model:{value:(_vm.holidayDate2),callback:function ($$v) {_vm.holidayDate2=$$v},expression:"holidayDate2"}}),_vm._v(" "),_c('date-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.holidays[2]),expression:"holidays[2]"}],staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},on:{"clear":function($event){return _vm.clearDate(2)}},model:{value:(_vm.holidayDate3),callback:function ($$v) {_vm.holidayDate3=$$v},expression:"holidayDate3"}}),_vm._v(" "),_c('date-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.holidays[3]),expression:"holidays[3]"}],staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},on:{"clear":function($event){return _vm.clearDate(3)}},model:{value:(_vm.holidayDate4),callback:function ($$v) {_vm.holidayDate4=$$v},expression:"holidayDate4"}}),_vm._v(" "),_c('date-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.holidays[4]),expression:"holidays[4]"}],staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},on:{"clear":function($event){return _vm.clearDate(4)}},model:{value:(_vm.holidayDate5),callback:function ($$v) {_vm.holidayDate5=$$v},expression:"holidayDate5"}}),_vm._v(" "),_c('date-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.holidays[5]),expression:"holidays[5]"}],staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},on:{"clear":function($event){return _vm.clearDate(5)}},model:{value:(_vm.holidayDate6),callback:function ($$v) {_vm.holidayDate6=$$v},expression:"holidayDate6"}}),_vm._v(" "),_c('date-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.holidays[6]),expression:"holidays[6]"}],staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},on:{"clear":function($event){return _vm.clearDate(6)}},model:{value:(_vm.holidayDate7),callback:function ($$v) {_vm.holidayDate7=$$v},expression:"holidayDate7"}}),_vm._v(" "),_c('date-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.holidays[7]),expression:"holidays[7]"}],staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},on:{"clear":function($event){return _vm.clearDate(7)}},model:{value:(_vm.holidayDate8),callback:function ($$v) {_vm.holidayDate8=$$v},expression:"holidayDate8"}}),_vm._v(" "),_c('date-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.holidays[8]),expression:"holidays[8]"}],staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},on:{"clear":function($event){return _vm.clearDate(8)}},model:{value:(_vm.holidayDate9),callback:function ($$v) {_vm.holidayDate9=$$v},expression:"holidayDate9"}}),_vm._v(" "),_c('date-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.holidays[9]),expression:"holidays[9]"}],staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},on:{"clear":function($event){return _vm.clearDate(9)}},model:{value:(_vm.holidayDate10),callback:function ($$v) {_vm.holidayDate10=$$v},expression:"holidayDate10"}}),_vm._v(" "),(_vm.holidays.filter(function (x) { return x; }).length <= 10)?_c('div',{staticClass:"button xsmall block",on:{"click":_vm.addHoliday}},[_c('i',{staticClass:"fas fa-plus fa-fw"}),_vm._v("Add Holiday")]):_vm._e()],1)])])])])])])]),_vm._v(" "),(_vm.selectedServiceArea > 0 && _vm.type !== 'asap')?_c('div',{staticClass:"box no-padding"},[_c('div',{staticClass:"header"},[_vm._v("Promotional Pricing")]),_vm._v(" "),_c('div',{staticClass:"body"},[(!_vm.isMobile)?_c('table',{staticClass:"table"},[_c('thead',{directives:[{name:"show",rawName:"v-show",value:(!_vm.promos.loading && _vm.promos.list.length > 0),expression:"!promos.loading && promos.list.length > 0"}]},[_c('th',[_vm._v("Service Type")]),_vm._v(" "),_c('th',[_vm._v("Promo Type")]),_vm._v(" "),_c('th',[_vm._v("Flat Rate")]),_vm._v(" "),_c('th',[_vm._v("Base Rate")]),_vm._v(" "),_c('th',[_vm._v("Mileage Threshold")]),_vm._v(" "),_c('th',[_vm._v("2nd Pax Fee")]),_vm._v(" "),_c('th',[_vm._v("Add. Pax Fee")]),_vm._v(" "),_c('th')]),_vm._v(" "),_c('tbody',[_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.promos.loading),expression:"promos.loading"}]},[_vm._m(7)]),_vm._v(" "),_vm._l((_vm.promos.list),function(promo,index){return _c('tr',[_c('td',{staticClass:"table-label"},[_vm._v(_vm._s(promo.serviceName))]),_vm._v(" "),_c('td',{staticClass:"table-label"},[(promo.type === 'flat')?_c('span',[_vm._v("Flat Rate")]):_c('span',[_vm._v("Discount Mileage Rate")])]),_vm._v(" "),_c('td',{staticClass:"table-label"},[(promo.type === 'flat')?_c('span',[_vm._v("$"+_vm._s(promo.flatRate.toFixed(2)))]):_c('span',[_vm._v("--")])]),_vm._v(" "),_c('td',{staticClass:"table-label"},[(promo.type === 'discount')?_c('span',[_vm._v("$"+_vm._s(promo.discountBaseRate.toFixed(2)))]):_c('span',[_vm._v("--")])]),_vm._v(" "),_c('td',{staticClass:"table-label"},[(promo.type === 'discount')?_c('span',[_vm._v("$"+_vm._s(promo.discountMileageRate.toFixed(2)))]):_c('span',[_vm._v("--")])]),_vm._v(" "),_c('td',{staticClass:"table-label"},[(promo.type === 'flat')?_c('span',[_vm._v("$"+_vm._s(promo.flat2ndPAXFee.toFixed(2)))]):_c('span',[_vm._v("$"+_vm._s(promo.discount2ndPAXFee.toFixed(2)))])]),_vm._v(" "),_c('td',{staticClass:"table-label"},[(promo.type === 'flat')?_c('span',[_vm._v("$"+_vm._s(promo.flatAddPAXFee.toFixed(2)))]):_c('span',[_vm._v("$"+_vm._s(promo.discountAddPAXFee.toFixed(2)))])]),_vm._v(" "),_c('td',{staticClass:"table-label"},[_c('a',{staticClass:"button cta xsmall error",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.removePromo(index)}}},[_vm._v("REMOVE")])])])})],2)]):_c('div',{staticClass:"cards"},_vm._l((_vm.promos.list),function(promo,index){return _c('div',{key:index,staticClass:"card promo-card"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Service Type")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(promo.serviceName))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Promo Type")]),_vm._v(" "),(promo.type === 'flat')?_c('div',{staticClass:"value"},[_vm._v("Flat Rate")]):_c('div',{staticClass:"value"},[_vm._v("Discount Mileage Rate")])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Flat Rate")]),_vm._v(" "),(promo.type === 'flat')?_c('div',{staticClass:"value"},[_vm._v("$"+_vm._s(promo.flatRate.toFixed(2)))]):_c('div',{staticClass:"value"},[_vm._v("--")])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Base Rate")]),_vm._v(" "),(promo.type === 'flat')?_c('div',{staticClass:"value"},[_vm._v("$"+_vm._s(promo.discountBaseRate.toFixed(2)))]):_c('div',{staticClass:"value"},[_vm._v("Discount")])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Mileage Threshold")]),_vm._v(" "),(promo.type === 'flat')?_c('div',{staticClass:"value"},[_vm._v("$"+_vm._s(promo.discountMileageRate.toFixed(2)))]):_c('div',{staticClass:"value"},[_vm._v("--")])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("2nd Pax Fee")]),_vm._v(" "),(promo.type === 'flat')?_c('div',{staticClass:"value"},[_vm._v("$"+_vm._s(promo.flat2ndPAXFee.toFixed(2)))]):_c('div',{staticClass:"value"},[_vm._v("$"+_vm._s(promo.discount2ndPAXFee.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Add. Pax Fee")]),_vm._v(" "),(promo.type === 'flat')?_c('div',{staticClass:"value"},[_vm._v("$"+_vm._s(promo.flatAddPAXFee.toFixed(2)))]):_c('div',{staticClass:"value"},[_vm._v("$"+_vm._s(promo.discountAddPAXFee.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"action"},[_c('a',{staticClass:"button cta xsmall error",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.removePromo(index)}}},[_vm._v("REMOVE")])])])}),0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.promos.loading),expression:"!promos.loading"}],staticClass:"discount-date promo"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column medium-6 medium-offset-3"},[_c('div',{staticClass:"button cta xsmall success",on:{"click":_vm.showPromoForm}},[_vm._v("\n              ADD ANOTHER SERVICE\n            ")])])])])])]):_vm._e(),_vm._v(" "),_c('promo')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_vm._v("Fuel Surcharge"),_c('br'),_vm._v("Per Mile")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_vm._v("Mileage "),_c('br'),_vm._v("Threshold")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th'),_vm._v(" "),_c('th',{staticClass:"discount",attrs:{"colspan":"2"}},[_vm._v("Discount")]),_vm._v(" "),_c('th',{staticClass:"roundtrip",attrs:{"colspan":"2"}},[_vm._v("Roundtrip")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Value")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Per Mile Rate")]),_vm._v(" "),_c('th',[_vm._v("Base Fee")]),_vm._v(" "),_c('th',[_vm._v("Bonus Per Mile Party")]),_vm._v(" "),_c('th',[_vm._v("Flat 2nd Pax Fee")]),_vm._v(" "),_c('th',[_vm._v("Flat Add. Pax Fee")]),_vm._v(" "),_c('th',[_vm._v("Discount Rate")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Curbside")]),_vm._v(" "),_c('th',[_vm._v("Meet & Greet")]),_vm._v(" "),_c('th',[_vm._v("Fee")]),_vm._v(" "),_c('th')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Curbside")]),_vm._v(" "),_c('th',[_vm._v("Meet & Greet")]),_vm._v(" "),_c('th',[_vm._v("Fee")]),_vm._v(" "),_c('th')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"8"}},[_c('div',{staticClass:"promo-loading"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',[_vm._v("LOADING PROMOS")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CharterPricing_vue__ = __webpack_require__(546);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d1041f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CharterPricing_vue__ = __webpack_require__(1565);
function injectStyle (ssrContext) {
  __webpack_require__(1563)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d1041f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CharterPricing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d1041f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CharterPricing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1564);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("98b08c46", content, true, {});

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.p-R-0[data-v-6d1041f2] {\n  padding-right: 0;\n}\n.p-L-0[data-v-6d1041f2] {\n  padding-left: 0;\n}\n.p-L-10[data-v-6d1041f2] {\n  padding-left: 10px;\n}\n.row[data-v-6d1041f2] {\n  max-width: 100%;\n}\n.box[data-v-6d1041f2] {\n  background: #fff;\n  border-radius: 2px;\n  border: 1px solid #b0c6e4;\n  margin-bottom: 30px;\n  -webkit-box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n          box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n}\n.box .header[data-v-6d1041f2] {\n    padding: 10px;\n    background: #0D79F2;\n    text-transform: uppercase;\n    color: #fff;\n    font-weight: 600;\n    font-size: 14px;\n}\n.box .body .error-msg[data-v-6d1041f2] {\n    font-size: 12px;\n    color: #fff;\n    font-style: italic;\n    display: block;\n    padding: 5px;\n    text-align: center;\n    background: #ff4d4d;\n}\ntable[data-v-6d1041f2] {\n  background: #fff;\n  width: 100%;\n  text-align: left;\n  border-spacing: 0;\n  text-align: center;\n}\ntable thead th[data-v-6d1041f2] {\n    font-size: 13px;\n    font-weight: 100;\n    color: #777;\n    padding: 10px 0 0;\n}\ntable tbody td[data-v-6d1041f2] {\n    padding: 8px 7px;\n    font-size: 14px;\n}\ntable tbody td[data-v-6d1041f2]:last-child {\n      padding-bottom: 15px;\n}\ntable tbody input[data-v-6d1041f2] {\n    max-width: 100px;\n    margin: 0;\n    display: inline-block;\n    text-align: center;\n}\ntable tbody .small-input[data-v-6d1041f2] {\n    width: 60px;\n}\ntable tbody .discount[data-v-6d1041f2], table tbody .roundtrip[data-v-6d1041f2] {\n    max-width: 90px;\n    min-width: 50px;\n}\ntable tbody .fa-square[data-v-6d1041f2], table tbody .fa-check-square[data-v-6d1041f2] {\n    color: #0D79F2;\n}\ntable tbody i.disabled[data-v-6d1041f2] {\n    opacity: .4;\n    cursor: not-allowed;\n}\ntable .discount[data-v-6d1041f2] {\n    background: #fafafa;\n}\ntable .roundtrip[data-v-6d1041f2] {\n    background: #f5f5f5;\n}\n.discount-date[data-v-6d1041f2] {\n  background: #eaf2fb;\n  text-align: left;\n  border-top: 1px solid #b0c6e4;\n  padding: 10px 0;\n}\n.discount-date.holiday[data-v-6d1041f2], .discount-date.promo[data-v-6d1041f2] {\n    text-align: center;\n}\n.discount-date .label[data-v-6d1041f2], .discount-date .field[data-v-6d1041f2] {\n    display: inline-block;\n}\n.discount-date .label[data-v-6d1041f2] {\n    font-size: 14px;\n    font-weight: 600;\n    color: #3b5573;\n    margin-right: 10px;\n}\n.discount-date .field[data-v-6d1041f2] {\n    min-width: 150px;\n}\n.discount-date .sub-label[data-v-6d1041f2] {\n    display: block;\n    font-size: 11px;\n    color: #888;\n    line-height: 1;\n    margin: 0 0 3px 2px;\n}\n.discount-date .table-label[data-v-6d1041f2] {\n    text-align: right;\n    padding-right: 20px !important;\n}\n.discount-date .date-input-block[data-v-6d1041f2] {\n    display: block;\n    width: 100%;\n    margin-bottom: 2px;\n}\n.discount-date .button[data-v-6d1041f2] {\n    margin-top: 10px;\n}\n.holiday-rates select[data-v-6d1041f2], .conv-box select[data-v-6d1041f2] {\n  max-width: 60px;\n  min-width: 60px;\n}\nselect[data-v-6d1041f2] {\n  border: 1px solid #ddd;\n  padding: 10px;\n  color: #333;\n  height: 43px;\n  position: relative;\n  font-size: 14px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n  -webkit-transition: all .35s ease;\n  transition: all .35s ease;\n}\nselect.has-error[data-v-6d1041f2] {\n    border-color: #f20d0d;\n}\nselect[data-v-6d1041f2]:disabled {\n    background-color: #eee;\n}\n@media only screen and (max-width: 430px) {\n.p-R-0[data-v-6d1041f2] {\n    padding-right: 0;\n}\n.p-L-0[data-v-6d1041f2] {\n    padding-left: 0;\n}\n.p-L-10[data-v-6d1041f2] {\n    padding-left: 0;\n}\n.discount-date[data-v-6d1041f2] {\n    padding: 10px;\n}\n.discount-date .field[data-v-6d1041f2] {\n      width: 100%;\n}\n.date-box[data-v-6d1041f2] {\n    padding: 0 10px;\n}\n.cards[data-v-6d1041f2] {\n    padding-top: 10px;\n}\n.cards .card[data-v-6d1041f2] {\n      border: 1px solid #b0c6e4;\n      margin: 0 10px;\n      margin-bottom: 15px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #b0c6e4;\n      font-weight: 700;\n}\n.cards .card > div[data-v-6d1041f2] {\n        margin-bottom: 3px;\n}\n.cards .card .row-fields[data-v-6d1041f2] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.cards .card .card-header[data-v-6d1041f2] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        background-color: #eaf2fb;\n        padding: 5px 10px;\n        font-size: 14px;\n}\n.cards .card .card-header .name[data-v-6d1041f2] {\n          font-weight: 900;\n}\n.cards .card .card-header .amount[data-v-6d1041f2] {\n          margin-left: 5px;\n          font-size: 14px;\n}\n.cards .card .card-header .status[data-v-6d1041f2] {\n          text-transform: uppercase;\n          font-size: 12px;\n          font-weight: 900;\n}\n.cards .card .title[data-v-6d1041f2] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        padding: 5px 10px;\n}\n.cards .card .title input[data-v-6d1041f2] {\n          margin: 0;\n          padding: 5px 10px;\n          font-size: 14px;\n}\n.cards .card .title select[data-v-6d1041f2] {\n          margin: 0;\n          padding: 5px 10px;\n          font-size: 14px;\n          height: 35px;\n          width: 80px;\n}\n.cards .card .title .discount[data-v-6d1041f2] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          width: 100%;\n}\n.cards .card .label[data-v-6d1041f2] {\n        font-size: 12px;\n        color: #666;\n        font-weight: 100;\n}\n.cards .card .value[data-v-6d1041f2] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Pricing/CharterPricing.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;CAClB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,kDAAkD;UAC1C,0CAA0C;CACnD;AACD;IACI,cAAc;IACd,oBAAoB;IACpB,0BAA0B;IAC1B,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,oBAAoB;CACvB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;CACpB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;CACrB;AACD;IACI,iBAAiB;IACjB,gBAAgB;CACnB;AACD;MACM,qBAAqB;CAC1B;AACD;IACI,iBAAiB;IACjB,UAAU;IACV,sBAAsB;IACtB,mBAAmB;CACtB;AACD;IACI,YAAY;CACf;AACD;IACI,gBAAgB;IAChB,gBAAgB;CACnB;AACD;IACI,eAAe;CAClB;AACD;IACI,YAAY;IACZ,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,oBAAoB;EACpB,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;CACjB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,sBAAsB;CACzB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;CACtB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,oBAAoB;CACvB;AACD;IACI,kBAAkB;IAClB,+BAA+B;CAClC;AACD;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;CACtB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,gBAAgB;EAChB,gBAAgB;CACjB;AACD;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;IACI,sBAAsB;CACzB;AACD;IACI,uBAAuB;CAC1B;AACD;AACA;IACI,iBAAiB;CACpB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,cAAc;CACjB;AACD;MACM,YAAY;CACjB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,kBAAkB;CACrB;AACD;MACM,0BAA0B;MAC1B,eAAe;MACf,oBAAoB;MACpB,oBAAoB;MACpB,iCAAiC;MACjC,iBAAiB;CACtB;AACD;QACQ,mBAAmB;CAC1B;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;CACrB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,+BAA+B;QACvC,0BAA0B;YACtB,uBAAuB;gBACnB,oBAAoB;QAC5B,0BAA0B;QAC1B,kBAAkB;QAClB,gBAAgB;CACvB;AACD;UACU,iBAAiB;CAC1B;AACD;UACU,iBAAiB;UACjB,gBAAgB;CACzB;AACD;UACU,0BAA0B;UAC1B,gBAAgB;UAChB,iBAAiB;CAC1B;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,6BAA6B;QAC7B,8BAA8B;YAC1B,2BAA2B;gBACvB,uBAAuB;QAC/B,kBAAkB;CACzB;AACD;UACU,UAAU;UACV,kBAAkB;UAClB,gBAAgB;CACzB;AACD;UACU,UAAU;UACV,kBAAkB;UAClB,gBAAgB;UAChB,aAAa;UACb,YAAY;CACrB;AACD;UACU,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;UACd,YAAY;CACrB;AACD;QACQ,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;CACxB;AACD;QACQ,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;CACxB;CACA","file":"CharterPricing.vue","sourcesContent":["\n.p-R-0[data-v-6d1041f2] {\n  padding-right: 0;\n}\n.p-L-0[data-v-6d1041f2] {\n  padding-left: 0;\n}\n.p-L-10[data-v-6d1041f2] {\n  padding-left: 10px;\n}\n.row[data-v-6d1041f2] {\n  max-width: 100%;\n}\n.box[data-v-6d1041f2] {\n  background: #fff;\n  border-radius: 2px;\n  border: 1px solid #b0c6e4;\n  margin-bottom: 30px;\n  -webkit-box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n          box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n}\n.box .header[data-v-6d1041f2] {\n    padding: 10px;\n    background: #0D79F2;\n    text-transform: uppercase;\n    color: #fff;\n    font-weight: 600;\n    font-size: 14px;\n}\n.box .body .error-msg[data-v-6d1041f2] {\n    font-size: 12px;\n    color: #fff;\n    font-style: italic;\n    display: block;\n    padding: 5px;\n    text-align: center;\n    background: #ff4d4d;\n}\ntable[data-v-6d1041f2] {\n  background: #fff;\n  width: 100%;\n  text-align: left;\n  border-spacing: 0;\n  text-align: center;\n}\ntable thead th[data-v-6d1041f2] {\n    font-size: 13px;\n    font-weight: 100;\n    color: #777;\n    padding: 10px 0 0;\n}\ntable tbody td[data-v-6d1041f2] {\n    padding: 8px 7px;\n    font-size: 14px;\n}\ntable tbody td[data-v-6d1041f2]:last-child {\n      padding-bottom: 15px;\n}\ntable tbody input[data-v-6d1041f2] {\n    max-width: 100px;\n    margin: 0;\n    display: inline-block;\n    text-align: center;\n}\ntable tbody .small-input[data-v-6d1041f2] {\n    width: 60px;\n}\ntable tbody .discount[data-v-6d1041f2], table tbody .roundtrip[data-v-6d1041f2] {\n    max-width: 90px;\n    min-width: 50px;\n}\ntable tbody .fa-square[data-v-6d1041f2], table tbody .fa-check-square[data-v-6d1041f2] {\n    color: #0D79F2;\n}\ntable tbody i.disabled[data-v-6d1041f2] {\n    opacity: .4;\n    cursor: not-allowed;\n}\ntable .discount[data-v-6d1041f2] {\n    background: #fafafa;\n}\ntable .roundtrip[data-v-6d1041f2] {\n    background: #f5f5f5;\n}\n.discount-date[data-v-6d1041f2] {\n  background: #eaf2fb;\n  text-align: left;\n  border-top: 1px solid #b0c6e4;\n  padding: 10px 0;\n}\n.discount-date.holiday[data-v-6d1041f2], .discount-date.promo[data-v-6d1041f2] {\n    text-align: center;\n}\n.discount-date .label[data-v-6d1041f2], .discount-date .field[data-v-6d1041f2] {\n    display: inline-block;\n}\n.discount-date .label[data-v-6d1041f2] {\n    font-size: 14px;\n    font-weight: 600;\n    color: #3b5573;\n    margin-right: 10px;\n}\n.discount-date .field[data-v-6d1041f2] {\n    min-width: 150px;\n}\n.discount-date .sub-label[data-v-6d1041f2] {\n    display: block;\n    font-size: 11px;\n    color: #888;\n    line-height: 1;\n    margin: 0 0 3px 2px;\n}\n.discount-date .table-label[data-v-6d1041f2] {\n    text-align: right;\n    padding-right: 20px !important;\n}\n.discount-date .date-input-block[data-v-6d1041f2] {\n    display: block;\n    width: 100%;\n    margin-bottom: 2px;\n}\n.discount-date .button[data-v-6d1041f2] {\n    margin-top: 10px;\n}\n.holiday-rates select[data-v-6d1041f2], .conv-box select[data-v-6d1041f2] {\n  max-width: 60px;\n  min-width: 60px;\n}\nselect[data-v-6d1041f2] {\n  border: 1px solid #ddd;\n  padding: 10px;\n  color: #333;\n  height: 43px;\n  position: relative;\n  font-size: 14px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n  -webkit-transition: all .35s ease;\n  transition: all .35s ease;\n}\nselect.has-error[data-v-6d1041f2] {\n    border-color: #f20d0d;\n}\nselect[data-v-6d1041f2]:disabled {\n    background-color: #eee;\n}\n@media only screen and (max-width: 430px) {\n.p-R-0[data-v-6d1041f2] {\n    padding-right: 0;\n}\n.p-L-0[data-v-6d1041f2] {\n    padding-left: 0;\n}\n.p-L-10[data-v-6d1041f2] {\n    padding-left: 0;\n}\n.discount-date[data-v-6d1041f2] {\n    padding: 10px;\n}\n.discount-date .field[data-v-6d1041f2] {\n      width: 100%;\n}\n.date-box[data-v-6d1041f2] {\n    padding: 0 10px;\n}\n.cards[data-v-6d1041f2] {\n    padding-top: 10px;\n}\n.cards .card[data-v-6d1041f2] {\n      border: 1px solid #b0c6e4;\n      margin: 0 10px;\n      margin-bottom: 15px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #b0c6e4;\n      font-weight: 700;\n}\n.cards .card > div[data-v-6d1041f2] {\n        margin-bottom: 3px;\n}\n.cards .card .row-fields[data-v-6d1041f2] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.cards .card .card-header[data-v-6d1041f2] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        background-color: #eaf2fb;\n        padding: 5px 10px;\n        font-size: 14px;\n}\n.cards .card .card-header .name[data-v-6d1041f2] {\n          font-weight: 900;\n}\n.cards .card .card-header .amount[data-v-6d1041f2] {\n          margin-left: 5px;\n          font-size: 14px;\n}\n.cards .card .card-header .status[data-v-6d1041f2] {\n          text-transform: uppercase;\n          font-size: 12px;\n          font-weight: 900;\n}\n.cards .card .title[data-v-6d1041f2] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        padding: 5px 10px;\n}\n.cards .card .title input[data-v-6d1041f2] {\n          margin: 0;\n          padding: 5px 10px;\n          font-size: 14px;\n}\n.cards .card .title select[data-v-6d1041f2] {\n          margin: 0;\n          padding: 5px 10px;\n          font-size: 14px;\n          height: 35px;\n          width: 80px;\n}\n.cards .card .title .discount[data-v-6d1041f2] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          width: 100%;\n}\n.cards .card .label[data-v-6d1041f2] {\n        font-size: 12px;\n        color: #666;\n        font-weight: 100;\n}\n.cards .card .value[data-v-6d1041f2] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box no-padding"},[_c('div',{staticClass:"header"},[_vm._v("Service Rate Settings")]),_vm._v(" "),_c('div',{staticClass:"body"},[(!_vm.isMobile)?_c('table',[_c('thead',[_c('th'),_vm._v(" "),_c('th',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAirportFee),expression:"showAirportFee"}]},[_vm._v("Airport Fee")]),_vm._v(" "),_c('th',[_vm._v("Per Minute Rate")]),_vm._v(" "),_c('th',[_vm._v("Base Rate")]),_vm._v(" "),_c('th',{staticClass:"discount"},[_vm._v("Discount")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.services),function(service,index){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.showService(service)),expression:"showService(service)"}],key:index},[_c('td',[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAirportFee),expression:"showAirportFee"}]},[_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service.future.airportFee),callback:function ($$v) {_vm.$set(service.future, "airportFee", $$v)},expression:"service.future.airportFee"}})],1),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service.charter.minuteRate),callback:function ($$v) {_vm.$set(service.charter, "minuteRate", $$v)},expression:"service.charter.minuteRate"}})],1),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.dollar2,"disabled":_vm.saving},model:{value:(service.charter.fare),callback:function ($$v) {_vm.$set(service.charter, "fare", $$v)},expression:"service.charter.fare"}})],1),_vm._v(" "),_c('td',{staticClass:"discount p-L-0 discount-value"},[_c('vue-autonumeric',{attrs:{"options":_vm.percent,"disabled":_vm.saving},model:{value:(service.future.discountAmount),callback:function ($$v) {_vm.$set(service.future, "discountAmount", $$v)},expression:"service.future.discountAmount"}})],1)])}),0)]):_c('div',{staticClass:"cards"},_vm._l((_vm.services),function(service,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showService(service)),expression:"showService(service)"}],key:index,staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n            "+_vm._s(service.name)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"row-fields"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAirportFee),expression:"showAirportFee"}],staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Airport Fee")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service.future.airportFee),callback:function ($$v) {_vm.$set(service.future, "airportFee", $$v)},expression:"service.future.airportFee"}})],1),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Per Minute Rate")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service.charter.minuteRate),callback:function ($$v) {_vm.$set(service.charter, "minuteRate", $$v)},expression:"service.charter.minuteRate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row-fields"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Base Rate")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service.charter.fare),callback:function ($$v) {_vm.$set(service.charter, "fare", $$v)},expression:"service.charter.fare"}})],1),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Discount")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.percent,"disabled":_vm.saving},model:{value:(service.future.discountAmount),callback:function ($$v) {_vm.$set(service.future, "discountAmount", $$v)},expression:"service.future.discountAmount"}})],1)])])}),0),_vm._v(" "),_c('div',{staticClass:"discount-date"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"label"},[_vm._v("Discount Date")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"sub-label"},[_vm._v("Start")]),_vm._v(" "),_c('date-picker',{staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},model:{value:(_vm.discountStart),callback:function ($$v) {_vm.discountStart=$$v},expression:"discountStart"}})],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"sub-label"},[_vm._v("End")]),_vm._v(" "),_c('date-picker',{staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.discountEndMin},model:{value:(_vm.discountEnd),callback:function ($$v) {_vm.discountEnd=$$v},expression:"discountEnd"}})],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"box no-padding conv-box"},[_c('div',{staticClass:"header"},[_vm._v("Convenience Fee")]),_vm._v(" "),_c('div',{staticClass:"body"},[(!_vm.isMobile)?_c('table',[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.services),function(service,index){return (_vm.showService(service))?_c('tr',[_c('td',[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(service.future.portalFeeType),expression:"service.future.portalFeeType"}],attrs:{"disabled":_vm.saving},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(service.future, "portalFeeType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateValue(index, 'portalType')}]}},[_c('option',{attrs:{"value":"$"}},[_vm._v("$")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])]),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":'floatPos',"disabled":_vm.saving},model:{value:(service.future.portalFee),callback:function ($$v) {_vm.$set(service.future, "portalFee", $$v)},expression:"service.future.portalFee"}})],1)]):_vm._e()}),0)]):_c('div',{staticClass:"cards"},_vm._l((_vm.services),function(service,index){return (_vm.showService(service))?_c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('div',{staticClass:"row-fields"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Type")]),_vm._v(" "),_c('div',{staticClass:"discount"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(service.future.portalFeeType),expression:"service.future.portalFeeType"}],attrs:{"disabled":_vm.saving},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(service.future, "portalFeeType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateValue(index, 'portalType')}]}},[_c('option',{attrs:{"value":"$"}},[_vm._v("$")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])])]),_vm._v(" "),(_vm.type !== 'asap')?_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Value")]),_vm._v(" "),_c('div',{staticClass:"discount"},[_c('vue-autonumeric',{attrs:{"options":'floatPos',"disabled":_vm.saving},model:{value:(service.future.portalFee),callback:function ($$v) {_vm.$set(service.future, "portalFee", $$v)},expression:"service.future.portalFee"}})],1)]):_vm._e()])]):_vm._e()}),0)])]),_vm._v(" "),_c('div',{staticClass:"box no-padding"},[_c('div',{staticClass:"header"},[_vm._v("Provider Rate Settings")]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('table',[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.services),function(service){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.showService(service)),expression:"showService(service)"}],key:service.id},[_c('td',[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service.charter.provRate),callback:function ($$v) {_vm.$set(service.charter, "provRate", $$v)},expression:"service.charter.provRate"}})],1),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service.charter.provBase),callback:function ($$v) {_vm.$set(service.charter, "provBase", $$v)},expression:"service.charter.provBase"}})],1),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.percent,"disabled":_vm.saving},model:{value:(service.charter.provDiscount),callback:function ($$v) {_vm.$set(service.charter, "provDiscount", $$v)},expression:"service.charter.provDiscount"}})],1)])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.type !== 'asap' && _vm.selectedServiceArea === 0)?_c('div',{staticClass:"column medium-6"},[_c('div',{staticClass:"box no-padding"},[_c('div',{staticClass:"header"},[_vm._v("Pickup Types")]),_vm._v(" "),_c('div',{staticClass:"body"},[(_vm.error.pickupTypes)?_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.pickupTypes))]):_vm._e(),_vm._v(" "),_c('table',[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.pickupTypesGlobal),function(service,index){return _c('tr',{key:service.id},[_c('td',[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('td',[_c('span',{on:{"click":function($event){return _vm.toggleGlobalPickupType(index, 'Curbside')}}},[(service.pickupTypes.Curbside && service.pickupTypes.Curbside.enabled)?_c('i',{staticClass:"fas fa-check-square fa-2x"}):_c('i',{staticClass:"far fa-square fa-2x"})])]),_vm._v(" "),_c('td',[_c('span',{on:{"click":function($event){return _vm.toggleGlobalPickupType(index, 'MeetAndGreet')}}},[(service.pickupTypes.MeetAndGreet && service.pickupTypes.MeetAndGreet.enabled)?_c('i',{staticClass:"fas fa-check-square fa-2x"}):_c('i',{staticClass:"far fa-square fa-2x"})])]),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},nativeOn:{"autoNumeric:rawValueModified":function($event){return _vm.toggleGlobalPickupTypeFee(index, 'MeetAndGreet')}},model:{value:(service.pickupTypes.MeetAndGreet.fee),callback:function ($$v) {_vm.$set(service.pickupTypes.MeetAndGreet, "fee", $$v)},expression:"service.pickupTypes.MeetAndGreet.fee"}})],1)])}),0)])])])]):_vm._e(),_vm._v(" "),(_vm.type !== 'asap' && _vm.selectedServiceArea !== 0)?_c('div',{staticClass:"column medium-6"},[_c('div',{staticClass:"box no-padding"},[_c('div',{staticClass:"header"},[_vm._v("Pickup Types")]),_vm._v(" "),_c('div',{staticClass:"body"},[(_vm.error.pickupTypes)?_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.pickupTypes))]):_vm._e(),_vm._v(" "),_c('table',[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.services),function(service,index){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.showService(service)),expression:"showService(service)"}],key:service.id},[_c('td',[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('td',[_c('span',{on:{"click":function($event){return _vm.togglePickupType(index, 'Curbside', 'enabled')}}},[(service.pickupTypes.Curbside && service.pickupTypes.Curbside.enabled)?_c('i',{staticClass:"fas fa-check-square fa-2x"}):_c('i',{class:{'far fa-square fa-2x':true, 'disabled':_vm.selectedServiceArea === 0}})])]),_vm._v(" "),_c('td',[_c('span',{on:{"click":function($event){return _vm.togglePickupType(index, 'MeetAndGreet', 'enabled')}}},[(service.pickupTypes.MeetAndGreet && service.pickupTypes.MeetAndGreet.enabled)?_c('i',{staticClass:"fas fa-check-square fa-2x"}):_c('i',{class:{'far fa-square fa-2x':true, 'disabled':_vm.selectedServiceArea === 0}})])]),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},nativeOn:{"autoNumeric:rawValueModified":function($event){return _vm.togglePickupType(index, 'MeetAndGreet', 'fee')}},model:{value:(service.pickupTypes.MeetAndGreet.fee),callback:function ($$v) {_vm.$set(service.pickupTypes.MeetAndGreet, "fee", $$v)},expression:"service.pickupTypes.MeetAndGreet.fee"}})],1)])}),0)])])])]):_vm._e(),_vm._v(" "),_c('div',{class:{'column medium-4 end':true, 'p-L-10': _vm.type !== 'asap'}},[_c('div',{staticClass:"box no-padding"},[_c('div',{staticClass:"header"},[_vm._v("Holiday Rates")]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('table',{staticClass:"holiday-rates"},[_c('tbody',_vm._l((_vm.services),function(service,index){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.showService(service)),expression:"showService(service)"}],key:service.id},[_c('td',[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(service.future.holidayRateType),expression:"service.future.holidayRateType"}],attrs:{"disabled":_vm.saving},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(service.future, "holidayRateType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateValue(index, 'holidayRateType')}]}},[_c('option',{attrs:{"value":"$"}},[_vm._v("$")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])]),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.oneHundred,"disabled":_vm.saving},nativeOn:{"autoNumeric:rawValueModified":function($event){return _vm.updateValue(index, 'holidayRateAmount')}},model:{value:(service.future.holidayRateAmount),callback:function ($$v) {_vm.$set(service.future, "holidayRateAmount", $$v)},expression:"service.future.holidayRateAmount"}})],1)])}),0)]),_vm._v(" "),_c('div',{staticClass:"discount-date holiday"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column medium-12"},[_c('div',{staticClass:"label"},[_vm._v("Holiday Date")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('date-picker',{staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},model:{value:(_vm.holidayDate),callback:function ($$v) {_vm.holidayDate=$$v},expression:"holidayDate"}}),_vm._v(" "),_c('date-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.holidays[1]),expression:"holidays[1]"}],staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},on:{"clear":function($event){return _vm.clearDate(1)}},model:{value:(_vm.holidayDate2),callback:function ($$v) {_vm.holidayDate2=$$v},expression:"holidayDate2"}}),_vm._v(" "),_c('date-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.holidays[2]),expression:"holidays[2]"}],staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},on:{"clear":function($event){return _vm.clearDate(2)}},model:{value:(_vm.holidayDate3),callback:function ($$v) {_vm.holidayDate3=$$v},expression:"holidayDate3"}}),_vm._v(" "),_c('date-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.holidays[3]),expression:"holidays[3]"}],staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},on:{"clear":function($event){return _vm.clearDate(3)}},model:{value:(_vm.holidayDate4),callback:function ($$v) {_vm.holidayDate4=$$v},expression:"holidayDate4"}}),_vm._v(" "),_c('date-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.holidays[4]),expression:"holidays[4]"}],staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},on:{"clear":function($event){return _vm.clearDate(4)}},model:{value:(_vm.holidayDate5),callback:function ($$v) {_vm.holidayDate5=$$v},expression:"holidayDate5"}}),_vm._v(" "),_c('date-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.holidays[5]),expression:"holidays[5]"}],staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},on:{"clear":function($event){return _vm.clearDate(5)}},model:{value:(_vm.holidayDate6),callback:function ($$v) {_vm.holidayDate6=$$v},expression:"holidayDate6"}}),_vm._v(" "),_c('date-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.holidays[6]),expression:"holidays[6]"}],staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},on:{"clear":function($event){return _vm.clearDate(6)}},model:{value:(_vm.holidayDate7),callback:function ($$v) {_vm.holidayDate7=$$v},expression:"holidayDate7"}}),_vm._v(" "),_c('date-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.holidays[7]),expression:"holidays[7]"}],staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},on:{"clear":function($event){return _vm.clearDate(7)}},model:{value:(_vm.holidayDate8),callback:function ($$v) {_vm.holidayDate8=$$v},expression:"holidayDate8"}}),_vm._v(" "),_c('date-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.holidays[8]),expression:"holidays[8]"}],staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},on:{"clear":function($event){return _vm.clearDate(8)}},model:{value:(_vm.holidayDate9),callback:function ($$v) {_vm.holidayDate9=$$v},expression:"holidayDate9"}}),_vm._v(" "),_c('date-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.holidays[9]),expression:"holidays[9]"}],staticClass:"date-input-block",attrs:{"input-class":"servicearea-date-input","lang":"en","disabled":_vm.saving,"not-before":_vm.minDate},on:{"clear":function($event){return _vm.clearDate(9)}},model:{value:(_vm.holidayDate10),callback:function ($$v) {_vm.holidayDate10=$$v},expression:"holidayDate10"}}),_vm._v(" "),(_vm.holidays.filter(function (x) { return x; }).length <= 10)?_c('div',{staticClass:"button xsmall block",on:{"click":_vm.addHoliday}},[_c('i',{staticClass:"fas fa-plus fa-fw"}),_vm._v("Add Holiday")]):_vm._e()],1)])])])])])])]),_vm._v(" "),(_vm.selectedServiceArea > 0 && _vm.type !== 'asap')?_c('div',{staticClass:"box no-padding"},[_c('div',{staticClass:"header"},[_vm._v("Promotional Pricing")]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('table',{staticClass:"table"},[_c('thead',{directives:[{name:"show",rawName:"v-show",value:(!_vm.promos.loading && _vm.promos.list.length > 0),expression:"!promos.loading && promos.list.length > 0"}]},[_c('th',[_vm._v("Service Type")]),_vm._v(" "),_c('th',[_vm._v("Promo Type")]),_vm._v(" "),_c('th',[_vm._v("Flat Rate")]),_vm._v(" "),_c('th',[_vm._v("Base Rate")]),_vm._v(" "),_c('th',[_vm._v("Mileage Threshold")]),_vm._v(" "),_c('th',[_vm._v("2nd Pax Fee")]),_vm._v(" "),_c('th',[_vm._v("Add. Pax Fee")]),_vm._v(" "),_c('th')]),_vm._v(" "),_c('tbody',[_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.promos.loading),expression:"promos.loading"}]},[_vm._m(4)]),_vm._v(" "),_vm._l((_vm.promos.list),function(promo,index){return _c('tr',{key:index},[_c('td',{staticClass:"table-label"},[_vm._v(_vm._s(promo.serviceName))]),_vm._v(" "),_c('td',{staticClass:"table-label"},[(promo.type === 'flat')?_c('span',[_vm._v("Flat Rate")]):_c('span',[_vm._v("Discount Mileage Rate")])]),_vm._v(" "),_c('td',{staticClass:"table-label"},[(promo.type === 'flat')?_c('span',[_vm._v("$"+_vm._s(promo.flatRate.toFixed(2)))]):_c('span',[_vm._v("--")])]),_vm._v(" "),_c('td',{staticClass:"table-label"},[(promo.type === 'discount')?_c('span',[_vm._v("$"+_vm._s(promo.discountBaseRate.toFixed(2)))]):_c('span',[_vm._v("--")])]),_vm._v(" "),_c('td',{staticClass:"table-label"},[(promo.type === 'discount')?_c('span',[_vm._v("$"+_vm._s(promo.discountMileageRate.toFixed(2)))]):_c('span',[_vm._v("--")])]),_vm._v(" "),_c('td',{staticClass:"table-label"},[(promo.type === 'flat')?_c('span',[_vm._v("$"+_vm._s(promo.flat2ndPAXFee.toFixed(2)))]):_c('span',[_vm._v("$"+_vm._s(promo.discount2ndPAXFee.toFixed(2)))])]),_vm._v(" "),_c('td',{staticClass:"table-label"},[(promo.type === 'flat')?_c('span',[_vm._v("$"+_vm._s(promo.flatAddPAXFee.toFixed(2)))]):_c('span',[_vm._v("$"+_vm._s(promo.discountAddPAXFee.toFixed(2)))])]),_vm._v(" "),_c('td',{staticClass:"table-label"},[_c('a',{staticClass:"button cta xsmall error",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.removePromo(index)}}},[_vm._v("REMOVE")])])])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.promos.loading),expression:"!promos.loading"}],staticClass:"discount-date promo"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column medium-6 medium-offset-3"},[_c('div',{staticClass:"button cta xsmall success",on:{"click":_vm.showPromoForm}},[_vm._v("\n              ADD ANOTHER SERVICE\n            ")])])])])])]):_vm._e(),_vm._v(" "),_c('promo')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Value")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Per Minute Rate")]),_vm._v(" "),_c('th',[_vm._v("Base Fee")]),_vm._v(" "),_c('th',[_vm._v("Discount Rate")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Curbside")]),_vm._v(" "),_c('th',[_vm._v("Meet & Greet")]),_vm._v(" "),_c('th',[_vm._v("Fee")]),_vm._v(" "),_c('th')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Curbside")]),_vm._v(" "),_c('th',[_vm._v("Meet & Greet")]),_vm._v(" "),_c('th',[_vm._v("Fee")]),_vm._v(" "),_c('th')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"8"}},[_c('div',{staticClass:"promo-loading"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',[_vm._v("LOADING PROMOS")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rental_vue__ = __webpack_require__(547);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eebf4e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rental_vue__ = __webpack_require__(1569);
function injectStyle (ssrContext) {
  __webpack_require__(1567)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2eebf4e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rental_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eebf4e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rental_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1568);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("c566efb0", content, true, {});

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.p-R-0[data-v-2eebf4e6] {\n  padding-right: 0;\n}\n.p-L-0[data-v-2eebf4e6] {\n  padding-left: 0;\n}\n.p-L-10[data-v-2eebf4e6] {\n  padding-left: 10px;\n}\n.row[data-v-2eebf4e6] {\n  max-width: 100%;\n}\n.box[data-v-2eebf4e6] {\n  background: #fff;\n  border-radius: 2px;\n  border: 1px solid #b0c6e4;\n  margin-bottom: 30px;\n  -webkit-box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n          box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n}\n.box .header[data-v-2eebf4e6] {\n    padding: 10px;\n    background: #0D79F2;\n    text-transform: uppercase;\n    color: #fff;\n    font-weight: 600;\n    font-size: 14px;\n}\n.box .body .error-msg[data-v-2eebf4e6] {\n    font-size: 12px;\n    color: #fff;\n    font-style: italic;\n    display: block;\n    padding: 5px;\n    text-align: center;\n    background: #ff4d4d;\n}\ntable[data-v-2eebf4e6] {\n  background: #fff;\n  width: 100%;\n  text-align: left;\n  border-spacing: 0;\n  text-align: center;\n}\ntable thead th[data-v-2eebf4e6] {\n    font-size: 13px;\n    font-weight: 100;\n    color: #777;\n    padding: 10px 0 0;\n}\ntable tbody td[data-v-2eebf4e6] {\n    padding: 8px 7px;\n    font-size: 14px;\n}\ntable tbody td[data-v-2eebf4e6]:last-child {\n      padding-bottom: 15px;\n}\ntable tbody input[data-v-2eebf4e6] {\n    max-width: 110px;\n    margin: 0;\n    display: inline-block;\n    text-align: center;\n}\ntable tbody .small-input[data-v-2eebf4e6] {\n    width: 60px;\n}\ntable tbody .discount[data-v-2eebf4e6], table tbody .roundtrip[data-v-2eebf4e6] {\n    max-width: 90px;\n    min-width: 50px;\n}\ntable tbody .fa-square[data-v-2eebf4e6], table tbody .fa-check-square[data-v-2eebf4e6] {\n    color: #0D79F2;\n}\ntable tbody i.disabled[data-v-2eebf4e6] {\n    opacity: .4;\n    cursor: not-allowed;\n}\ntable .discount[data-v-2eebf4e6] {\n    background: #fafafa;\n}\ntable .roundtrip[data-v-2eebf4e6] {\n    background: #f5f5f5;\n}\n.discount-date[data-v-2eebf4e6] {\n  background: #eaf2fb;\n  text-align: left;\n  border-top: 1px solid #b0c6e4;\n  padding: 10px 0;\n}\n.discount-date.holiday[data-v-2eebf4e6], .discount-date.promo[data-v-2eebf4e6] {\n    text-align: center;\n}\n.discount-date .label[data-v-2eebf4e6], .discount-date .field[data-v-2eebf4e6] {\n    display: inline-block;\n}\n.discount-date .label[data-v-2eebf4e6] {\n    font-size: 14px;\n    font-weight: 600;\n    color: #3b5573;\n    margin-right: 10px;\n}\n.discount-date .field[data-v-2eebf4e6] {\n    min-width: 150px;\n}\n.discount-date .sub-label[data-v-2eebf4e6] {\n    display: block;\n    font-size: 11px;\n    color: #888;\n    line-height: 1;\n    margin: 0 0 3px 2px;\n}\n.discount-date .table-label[data-v-2eebf4e6] {\n    text-align: right;\n    padding-right: 20px !important;\n}\n.discount-date .date-input-block[data-v-2eebf4e6] {\n    display: block;\n    width: 100%;\n    margin-bottom: 2px;\n}\n.discount-date .button[data-v-2eebf4e6] {\n    margin-top: 10px;\n}\n.holiday-rates select[data-v-2eebf4e6] {\n  max-width: 60px;\n  min-width: 60px;\n}\nselect[data-v-2eebf4e6] {\n  border: 1px solid #ddd;\n  padding: 10px;\n  color: #333;\n  height: 43px;\n  position: relative;\n  font-size: 14px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n  -webkit-transition: all .35s ease;\n  transition: all .35s ease;\n}\nselect.has-error[data-v-2eebf4e6] {\n    border-color: #f20d0d;\n}\nselect[data-v-2eebf4e6]:disabled {\n    background-color: #eee;\n}\n@media only screen and (max-width: 430px) {\n.p-R-0[data-v-2eebf4e6] {\n    padding-right: 0;\n}\n.p-L-0[data-v-2eebf4e6] {\n    padding-left: 0;\n}\n.p-L-10[data-v-2eebf4e6] {\n    padding-left: 0;\n}\n.discount-date[data-v-2eebf4e6] {\n    padding: 10px;\n}\n.discount-date .field[data-v-2eebf4e6] {\n      width: 100%;\n}\n.date-box[data-v-2eebf4e6] {\n    padding: 0 10px;\n}\n.cards[data-v-2eebf4e6] {\n    padding-top: 10px;\n}\n.cards .card[data-v-2eebf4e6] {\n      border: 1px solid #b0c6e4;\n      margin: 0 10px;\n      margin-bottom: 15px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #b0c6e4;\n      font-weight: 700;\n}\n.cards .card > div[data-v-2eebf4e6] {\n        margin-bottom: 3px;\n}\n.cards .card .row-fields[data-v-2eebf4e6] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.cards .card .card-header[data-v-2eebf4e6] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        background-color: #eaf2fb;\n        padding: 5px 10px;\n        font-size: 14px;\n}\n.cards .card .card-header .name[data-v-2eebf4e6] {\n          font-weight: 900;\n}\n.cards .card .card-header .amount[data-v-2eebf4e6] {\n          margin-left: 5px;\n          font-size: 14px;\n}\n.cards .card .card-header .status[data-v-2eebf4e6] {\n          text-transform: uppercase;\n          font-size: 12px;\n          font-weight: 900;\n}\n.cards .card .title[data-v-2eebf4e6] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        padding: 5px 10px;\n}\n.cards .card .title input[data-v-2eebf4e6] {\n          margin: 0;\n          padding: 5px 10px;\n          font-size: 14px;\n}\n.cards .card .title select[data-v-2eebf4e6] {\n          margin: 0;\n          padding: 5px 10px;\n          font-size: 14px;\n          height: 35px;\n          width: 80px;\n}\n.cards .card .title .discount[data-v-2eebf4e6] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          width: 100%;\n}\n.cards .card .label[data-v-2eebf4e6] {\n        font-size: 12px;\n        color: #666;\n        font-weight: 100;\n}\n.cards .card .value[data-v-2eebf4e6] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Pricing/Rental.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;CAClB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,kDAAkD;UAC1C,0CAA0C;CACnD;AACD;IACI,cAAc;IACd,oBAAoB;IACpB,0BAA0B;IAC1B,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,oBAAoB;CACvB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;CACpB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;CACrB;AACD;IACI,iBAAiB;IACjB,gBAAgB;CACnB;AACD;MACM,qBAAqB;CAC1B;AACD;IACI,iBAAiB;IACjB,UAAU;IACV,sBAAsB;IACtB,mBAAmB;CACtB;AACD;IACI,YAAY;CACf;AACD;IACI,gBAAgB;IAChB,gBAAgB;CACnB;AACD;IACI,eAAe;CAClB;AACD;IACI,YAAY;IACZ,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,oBAAoB;EACpB,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;CACjB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,sBAAsB;CACzB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;CACtB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,oBAAoB;CACvB;AACD;IACI,kBAAkB;IAClB,+BAA+B;CAClC;AACD;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;CACtB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,gBAAgB;EAChB,gBAAgB;CACjB;AACD;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;IACI,sBAAsB;CACzB;AACD;IACI,uBAAuB;CAC1B;AACD;AACA;IACI,iBAAiB;CACpB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,cAAc;CACjB;AACD;MACM,YAAY;CACjB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,kBAAkB;CACrB;AACD;MACM,0BAA0B;MAC1B,eAAe;MACf,oBAAoB;MACpB,oBAAoB;MACpB,iCAAiC;MACjC,iBAAiB;CACtB;AACD;QACQ,mBAAmB;CAC1B;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;CACrB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,+BAA+B;QACvC,0BAA0B;YACtB,uBAAuB;gBACnB,oBAAoB;QAC5B,0BAA0B;QAC1B,kBAAkB;QAClB,gBAAgB;CACvB;AACD;UACU,iBAAiB;CAC1B;AACD;UACU,iBAAiB;UACjB,gBAAgB;CACzB;AACD;UACU,0BAA0B;UAC1B,gBAAgB;UAChB,iBAAiB;CAC1B;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,6BAA6B;QAC7B,8BAA8B;YAC1B,2BAA2B;gBACvB,uBAAuB;QAC/B,kBAAkB;CACzB;AACD;UACU,UAAU;UACV,kBAAkB;UAClB,gBAAgB;CACzB;AACD;UACU,UAAU;UACV,kBAAkB;UAClB,gBAAgB;UAChB,aAAa;UACb,YAAY;CACrB;AACD;UACU,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;UACd,YAAY;CACrB;AACD;QACQ,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;CACxB;AACD;QACQ,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;CACxB;CACA","file":"Rental.vue","sourcesContent":["\n.p-R-0[data-v-2eebf4e6] {\n  padding-right: 0;\n}\n.p-L-0[data-v-2eebf4e6] {\n  padding-left: 0;\n}\n.p-L-10[data-v-2eebf4e6] {\n  padding-left: 10px;\n}\n.row[data-v-2eebf4e6] {\n  max-width: 100%;\n}\n.box[data-v-2eebf4e6] {\n  background: #fff;\n  border-radius: 2px;\n  border: 1px solid #b0c6e4;\n  margin-bottom: 30px;\n  -webkit-box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n          box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n}\n.box .header[data-v-2eebf4e6] {\n    padding: 10px;\n    background: #0D79F2;\n    text-transform: uppercase;\n    color: #fff;\n    font-weight: 600;\n    font-size: 14px;\n}\n.box .body .error-msg[data-v-2eebf4e6] {\n    font-size: 12px;\n    color: #fff;\n    font-style: italic;\n    display: block;\n    padding: 5px;\n    text-align: center;\n    background: #ff4d4d;\n}\ntable[data-v-2eebf4e6] {\n  background: #fff;\n  width: 100%;\n  text-align: left;\n  border-spacing: 0;\n  text-align: center;\n}\ntable thead th[data-v-2eebf4e6] {\n    font-size: 13px;\n    font-weight: 100;\n    color: #777;\n    padding: 10px 0 0;\n}\ntable tbody td[data-v-2eebf4e6] {\n    padding: 8px 7px;\n    font-size: 14px;\n}\ntable tbody td[data-v-2eebf4e6]:last-child {\n      padding-bottom: 15px;\n}\ntable tbody input[data-v-2eebf4e6] {\n    max-width: 110px;\n    margin: 0;\n    display: inline-block;\n    text-align: center;\n}\ntable tbody .small-input[data-v-2eebf4e6] {\n    width: 60px;\n}\ntable tbody .discount[data-v-2eebf4e6], table tbody .roundtrip[data-v-2eebf4e6] {\n    max-width: 90px;\n    min-width: 50px;\n}\ntable tbody .fa-square[data-v-2eebf4e6], table tbody .fa-check-square[data-v-2eebf4e6] {\n    color: #0D79F2;\n}\ntable tbody i.disabled[data-v-2eebf4e6] {\n    opacity: .4;\n    cursor: not-allowed;\n}\ntable .discount[data-v-2eebf4e6] {\n    background: #fafafa;\n}\ntable .roundtrip[data-v-2eebf4e6] {\n    background: #f5f5f5;\n}\n.discount-date[data-v-2eebf4e6] {\n  background: #eaf2fb;\n  text-align: left;\n  border-top: 1px solid #b0c6e4;\n  padding: 10px 0;\n}\n.discount-date.holiday[data-v-2eebf4e6], .discount-date.promo[data-v-2eebf4e6] {\n    text-align: center;\n}\n.discount-date .label[data-v-2eebf4e6], .discount-date .field[data-v-2eebf4e6] {\n    display: inline-block;\n}\n.discount-date .label[data-v-2eebf4e6] {\n    font-size: 14px;\n    font-weight: 600;\n    color: #3b5573;\n    margin-right: 10px;\n}\n.discount-date .field[data-v-2eebf4e6] {\n    min-width: 150px;\n}\n.discount-date .sub-label[data-v-2eebf4e6] {\n    display: block;\n    font-size: 11px;\n    color: #888;\n    line-height: 1;\n    margin: 0 0 3px 2px;\n}\n.discount-date .table-label[data-v-2eebf4e6] {\n    text-align: right;\n    padding-right: 20px !important;\n}\n.discount-date .date-input-block[data-v-2eebf4e6] {\n    display: block;\n    width: 100%;\n    margin-bottom: 2px;\n}\n.discount-date .button[data-v-2eebf4e6] {\n    margin-top: 10px;\n}\n.holiday-rates select[data-v-2eebf4e6] {\n  max-width: 60px;\n  min-width: 60px;\n}\nselect[data-v-2eebf4e6] {\n  border: 1px solid #ddd;\n  padding: 10px;\n  color: #333;\n  height: 43px;\n  position: relative;\n  font-size: 14px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n  -webkit-transition: all .35s ease;\n  transition: all .35s ease;\n}\nselect.has-error[data-v-2eebf4e6] {\n    border-color: #f20d0d;\n}\nselect[data-v-2eebf4e6]:disabled {\n    background-color: #eee;\n}\n@media only screen and (max-width: 430px) {\n.p-R-0[data-v-2eebf4e6] {\n    padding-right: 0;\n}\n.p-L-0[data-v-2eebf4e6] {\n    padding-left: 0;\n}\n.p-L-10[data-v-2eebf4e6] {\n    padding-left: 0;\n}\n.discount-date[data-v-2eebf4e6] {\n    padding: 10px;\n}\n.discount-date .field[data-v-2eebf4e6] {\n      width: 100%;\n}\n.date-box[data-v-2eebf4e6] {\n    padding: 0 10px;\n}\n.cards[data-v-2eebf4e6] {\n    padding-top: 10px;\n}\n.cards .card[data-v-2eebf4e6] {\n      border: 1px solid #b0c6e4;\n      margin: 0 10px;\n      margin-bottom: 15px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #b0c6e4;\n      font-weight: 700;\n}\n.cards .card > div[data-v-2eebf4e6] {\n        margin-bottom: 3px;\n}\n.cards .card .row-fields[data-v-2eebf4e6] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.cards .card .card-header[data-v-2eebf4e6] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        background-color: #eaf2fb;\n        padding: 5px 10px;\n        font-size: 14px;\n}\n.cards .card .card-header .name[data-v-2eebf4e6] {\n          font-weight: 900;\n}\n.cards .card .card-header .amount[data-v-2eebf4e6] {\n          margin-left: 5px;\n          font-size: 14px;\n}\n.cards .card .card-header .status[data-v-2eebf4e6] {\n          text-transform: uppercase;\n          font-size: 12px;\n          font-weight: 900;\n}\n.cards .card .title[data-v-2eebf4e6] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        padding: 5px 10px;\n}\n.cards .card .title input[data-v-2eebf4e6] {\n          margin: 0;\n          padding: 5px 10px;\n          font-size: 14px;\n}\n.cards .card .title select[data-v-2eebf4e6] {\n          margin: 0;\n          padding: 5px 10px;\n          font-size: 14px;\n          height: 35px;\n          width: 80px;\n}\n.cards .card .title .discount[data-v-2eebf4e6] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          width: 100%;\n}\n.cards .card .label[data-v-2eebf4e6] {\n        font-size: 12px;\n        color: #666;\n        font-weight: 100;\n}\n.cards .card .value[data-v-2eebf4e6] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box no-padding"},[_c('div',{staticClass:"header"},[_vm._v("Service Rate Settings")]),_vm._v(" "),_c('div',{staticClass:"body"},[(!_vm.isMobile)?_c('table',[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.services),function(service,index){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.showService(service)),expression:"showService(service)"}],key:index},[_c('td',[_vm._v(_vm._s(service.name))]),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service.rental.rentFare),callback:function ($$v) {_vm.$set(service.rental, "rentFare", $$v)},expression:"service.rental.rentFare"}})],1),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.dollar6deci,"disabled":_vm.saving},model:{value:(service.rental.rentRate),callback:function ($$v) {_vm.$set(service.rental, "rentRate", $$v)},expression:"service.rental.rentRate"}})],1),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.dollar6deci,"disabled":_vm.saving},model:{value:(service.rental.rentRateDaily),callback:function ($$v) {_vm.$set(service.rental, "rentRateDaily", $$v)},expression:"service.rental.rentRateDaily"}})],1),_vm._v(" "),_c('td',[_c('vue-autonumeric',{attrs:{"options":_vm.dollar6deci,"disabled":_vm.saving},model:{value:(service.rental.rentRateWeekend),callback:function ($$v) {_vm.$set(service.rental, "rentRateWeekend", $$v)},expression:"service.rental.rentRateWeekend"}})],1)])}),0)]):_c('div',{staticClass:"cards"},_vm._l((_vm.services),function(service,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showService(service)),expression:"showService(service)"}],key:index,staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n            "+_vm._s(service.name)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"row-fields"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAirportFee),expression:"showAirportFee"}],staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Rent Fare")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar,"disabled":_vm.saving},model:{value:(service.future.airportFee),callback:function ($$v) {_vm.$set(service.future, "airportFee", $$v)},expression:"service.future.airportFee"}})],1),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Hourly Rent Rate")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar6deci,"disabled":_vm.saving},model:{value:(service.rental.rentRate),callback:function ($$v) {_vm.$set(service.rental, "rentRate", $$v)},expression:"service.rental.rentRate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row-fields"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Daily Rent Rate")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar6deci,"disabled":_vm.saving},model:{value:(service.rental.rentRateDaily),callback:function ($$v) {_vm.$set(service.rental, "rentRateDaily", $$v)},expression:"service.rental.rentRateDaily"}})],1),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Weekend Rent Rate")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar6deci,"disabled":_vm.saving},model:{value:(service.rental.rentRateWeekend),callback:function ($$v) {_vm.$set(service.rental, "rentRateWeekend", $$v)},expression:"service.rental.rentRateWeekend"}})],1)])])}),0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Rent Fare")]),_vm._v(" "),_c('th',[_vm._v("Hourly Rent Rate")]),_vm._v(" "),_c('th',[_vm._v("Daily Rent Rate")]),_vm._v(" "),_c('th',[_vm._v("Weekend Rent Rate")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.activeServiceArea)?_c('div',{staticClass:"header"},[_vm._v("PRICING")]):_c('div',{staticClass:"header pricing"},[_c('span',{staticClass:"color",style:({backgroundColor: '#' + _vm.brand.color})}),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.brand.name))])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.logs.current)?_c('a',{class:['logs-toggle', {on: !_vm.logs.show}],on:{"click":_vm.toggleLogsPanel}},[_c('i',{class:_vm.logsIcon})]):_vm._e()]),_vm._v(" "),_c('logs',{directives:[{name:"show",rawName:"v-show",value:(_vm.logs.current),expression:"logs.current"}],ref:"logs"}),_vm._v(" "),_c('div',{staticClass:"left-panel"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedBrand),expression:"selectedBrand"}],staticClass:"brands",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedBrand=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.brands),function(brand,i){return _c('option',{key:i,domProps:{"value":brand.id}},[_vm._v(_vm._s(brand.name))])}),0),_vm._v(" "),_c('div',{staticClass:"data-field m-B-10"},[_c('div',{staticClass:"label"},[_vm._v("Search")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],staticClass:"input",attrs:{"type":"text"},domProps:{"value":(_vm.searchInput)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"servicearea-list"},[_c('ul',{class:{'disabled': _vm.loading}},[_c('li',{class:{'active': _vm.activeServiceArea === 0},on:{"click":function($event){return _vm.selectServiceArea(0)}}},[_c('i',{staticClass:"fas fa-globe"}),_vm._v(" "),_c('span',[_vm._v("Global Pricing")])]),_vm._v(" "),_vm._l((_vm.serviceArea),function(data){return _c('li',{key:data.id,class:{'geofence-box': true, 'active': _vm.activeServiceArea === data.id},on:{"click":function($event){return _vm.selectServiceArea(data)}}},[_c('span',{staticClass:"color",style:({backgroundColor: '#' + data.color})}),_vm._v(" "),_c('span',[_vm._v(_vm._s(data.name))])])})],2),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" Loading\n        ")])])],1)]),_vm._v(" "),_c('div',{staticClass:"toggle-mobile"},[_c('ul',{staticClass:"tabs"},[_c('li',{class:{'active': _vm.activeTab === 0, 'disabled': !_vm.isMobileClickable || _vm.isMTechPricing},on:{"click":function($event){return _vm.mobileShowTab(0)}}},[_vm._v("Services")]),_vm._v(" "),_c('li',{class:{'active': _vm.activeTab === 1, 'disabled': !_vm.isMobileClickable || _vm.isMTechPricing},attrs:{"title":!_vm.isMobileClickable ? 'Please enable at least 1 service type' : ''},on:{"click":function($event){return _vm.mobileShowTab(1)}}},[_vm._v("Pricing - ASAP")]),_vm._v(" "),_c('li',{class:{'active': _vm.activeTab === 2, 'disabled': !_vm.isMobileClickable || _vm.isMTechPricing},attrs:{"title":!_vm.isMobileClickable ? 'Please enable at least 1 service type' : ''},on:{"click":function($event){return _vm.mobileShowTab(2)}}},[_vm._v("Pricing - Future")]),_vm._v(" "),_c('li',{class:{'active': _vm.activeTab === 3, 'disabled': !_vm.isMobileClickable || _vm.isMTechPricing},attrs:{"title":!_vm.isMobileClickable ? 'Please enable at least 1 service type' : ''},on:{"click":function($event){return _vm.mobileShowTab(3)}}},[_vm._v("Pricing - Charter")]),_vm._v(" "),_c('li',{class:{'active': _vm.activeTab === 4, 'disabled': !_vm.isMobileClickable || _vm.isMTechPricing},attrs:{"title":!_vm.isMobileClickable ? 'Please enable at least 1 service type' : ''},on:{"click":function($event){return _vm.mobileShowTab(4)}}},[_vm._v("Pricing - Rental")])])]),_vm._v(" "),_c('div',{class:['right-panel', _vm.isMobileClickable ? 'open-panel' : '']},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobile),expression:"isMobile"}],staticClass:"back",on:{"click":function($event){return _vm.mobileShowTab(4)}}},[_c('i',{staticClass:"fas fa-chevron-left"}),_vm._v(" Back")]),_vm._v(" "),_c('ul',{staticClass:"tabs"},[_c('li',{class:{'active': _vm.activeTab === 0, disabled: _vm.isMTechPricing},on:{"click":function($event){_vm.activeTab = 0}}},[_vm._v("Services")]),_vm._v(" "),_c('li',{class:{'active': _vm.activeTab === 1, 'disabled': !_vm.isClickable || _vm.isMTechPricing},attrs:{"title":!_vm.isClickable ? 'Please enable at least 1 service type' : ''},on:{"click":function($event){_vm.isClickable ? _vm.activeTab = 1 : ''}}},[_vm._v("Pricing - ASAP")]),_vm._v(" "),_c('li',{class:{'active': _vm.activeTab === 2, 'disabled': !_vm.isClickable || _vm.isMTechPricing},attrs:{"title":!_vm.isClickable ? 'Please enable at least 1 service type' : ''},on:{"click":function($event){_vm.isClickable ? _vm.activeTab = 2 : ''}}},[_vm._v("Pricing - Future")]),_vm._v(" "),_c('li',{class:{'active': _vm.activeTab === 3, 'disabled': !_vm.isClickable || _vm.isMTechPricing},attrs:{"title":!_vm.isClickable ? 'Please enable at least 1 service type' : ''},on:{"click":function($event){_vm.isClickable ? _vm.activeTab = 3 : ''}}},[_vm._v("Pricing - Charter")]),_vm._v(" "),_c('li',{class:{'active': _vm.activeTab === 4, 'disabled': !_vm.isClickable || _vm.isMTechPricing},attrs:{"title":!_vm.isClickable ? 'Please enable at least 1 service type' : ''},on:{"click":function($event){_vm.isClickable ? _vm.activeTab = 4 : ''}}},[_vm._v("Pricing - Rental")])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade-right"}},[(_vm.transitionRightPanel && !_vm.isMTechPricing)?_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === 0),expression:"activeTab === 0"}]},[_c('services',{attrs:{"isMobile":_vm.isMobile},on:{"change":_vm.reRender}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === 1),expression:"activeTab === 1"}]},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeServiceArea === 0),expression:"activeServiceArea === 0"}],staticClass:"global-notes"},[_vm._v("\n            Global Pricing updates all service areas for this brand, and saves only the fields whose values have changed.\n          ")]),_vm._v(" "),(_vm.priceSettingsShow)?_c('pricing-settings',{ref:"asapPriceSettings",attrs:{"type":"asap","isMobile":_vm.isMobile},on:{"response":_vm.response}}):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === 2),expression:"activeTab === 2"}]},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeServiceArea === 0),expression:"activeServiceArea === 0"}],staticClass:"global-notes"},[_vm._v("\n            Global Pricing updates all service areas for this brand, and saves only the fields whose values have changed.\n          ")]),_vm._v(" "),(_vm.priceSettingsShow)?_c('pricing-settings',{ref:"priceSettings",attrs:{"type":"future","isMobile":_vm.isMobile},on:{"response":_vm.response}}):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === 3),expression:"activeTab === 3"}]},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeServiceArea === 0),expression:"activeServiceArea === 0"}],staticClass:"global-notes"},[_vm._v("\n            Global Pricing updates all service areas for this brand, and saves only the fields whose values have changed.\n          ")]),_vm._v(" "),(_vm.priceSettingsShow)?_c('charter-pricing',{ref:"charterSettings",attrs:{"type":"charter","isMobile":_vm.isMobile},on:{"response":_vm.response}}):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === 4),expression:"activeTab === 4"}]},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeServiceArea === 0),expression:"activeServiceArea === 0"}],staticClass:"global-notes"},[_vm._v("\n            Global Pricing updates all service areas for this brand, and saves only the fields whose values have changed.\n          ")]),_vm._v(" "),(_vm.priceSettingsShow)?_c('rental',{ref:"rental",attrs:{"type":"rental","isMobile":_vm.isMobile},on:{"response":_vm.response}}):_vm._e()],1)]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade-right"}},[(_vm.isMTechPricing)?_c('div',{staticClass:"is-mtech-label"},[_vm._v("\n        Pricing Table and service settings is disabled for MTech enabled geofence.\n      ")]):_vm._e()])],1),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeServiceArea !== '' && _vm.transitionRightPanel && !_vm.promoShow && !_vm.isServiceNonGlobal),expression:"activeServiceArea !== '' && transitionRightPanel && !promoShow && !isServiceNonGlobal"}],staticClass:"fixed-bottom-right"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column medium-6 medium-offset-3 end"},[_c('a',{class:{'button cta small success':true, 'disabled':_vm.saving},on:{"click":_vm.save}},[(_vm.saving)?_c('span',[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" Loading...")]):_c('span',[_vm._v("Save")])])])])])]),_vm._v(" "),_c('div',{class:{'op--modal-container':true, 'hide':!_vm.global.modal},on:{"click":_vm.closeGlobalModal}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content"},[(_vm.global.status === '')?_c('div',{staticClass:"global-modal-box",on:{"click":function($event){$event.stopPropagation();}}},[_c('p',[_vm._v("Please select which service area you would like to apply your changes.")]),_vm._v(" "),_c('label',{staticClass:"check-all"},[_c('input',{attrs:{"type":"checkbox"},on:{"click":_vm.toggleSelectAll}}),_vm._v("\n            Select all\n          ")]),_vm._v(" "),_c('ul',_vm._l((_vm.completeServiceArea),function(data){return _c('li',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.global.selectedServiceArea),expression:"global.selectedServiceArea"}],attrs:{"type":"checkbox"},domProps:{"value":data.id,"checked":Array.isArray(_vm.global.selectedServiceArea)?_vm._i(_vm.global.selectedServiceArea,data.id)>-1:(_vm.global.selectedServiceArea)},on:{"change":function($event){var $$a=_vm.global.selectedServiceArea,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=data.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.global, "selectedServiceArea", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.global, "selectedServiceArea", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.global, "selectedServiceArea", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(data.name))])])])}),0),_vm._v(" "),(!!_vm.global.message)?_c('div',{staticClass:"global-error"},[_vm._v(_vm._s(_vm.global.message))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row m-T-20"},[_c('div',{staticClass:"column medium-6 p-R-10"},[_c('a',{class:{'button cta warning block': true, 'disabled': _vm.global.saving},on:{"click":_vm.closeGlobalModal}},[_vm._v("Cancel")])]),_vm._v(" "),_c('div',{staticClass:"column medium-6 p-L-10"},[_c('a',{class:{'button cta success block': true, 'disabled': _vm.global.saving},on:{"click":_vm.updateGlobal}},[(_vm.global.saving)?_c('span',[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" Loading...")]):_c('span',[_vm._v("Update")])])])])]):_c('div',{staticClass:"response-box"},[(_vm.global.status === 'success')?_c('i',{staticClass:"fas fa-check-circle fa-4x success"}):_c('i',{staticClass:"fas fa-times-circle fa-4x error"}),_vm._v(" "),_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.global.message))]),_vm._v(" "),(_vm.global.extra)?_c('span',{staticClass:"extra"},[_vm._v(_vm._s(_vm.global.extra))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"button cta block",on:{"click":_vm.closeGlobalModal}},[_vm._v("Close")])])])])]),_vm._v(" "),_c('div',{class:{'op--modal-container':true, 'hide': !_vm.responseModal.show},on:{"click":_vm.closeResponseModal}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"response-box"},[(_vm.responseModal.status === 'success')?_c('i',{staticClass:"fas fa-check-circle fa-4x success"}):_c('i',{staticClass:"fas fa-times-circle fa-4x error"}),_vm._v(" "),_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.responseModal.message))]),_vm._v(" "),(_vm.responseModal.extra)?_c('span',{staticClass:"extra"},[_vm._v(_vm._s(_vm.responseModal.extra))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"button cta block",on:{"click":_vm.closeResponseModal}},[_vm._v("Close")])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(548);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49492fda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1598);
function injectStyle (ssrContext) {
  __webpack_require__(1572)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49492fda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49492fda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1573);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4cae37a8", content, true, {});

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.m-B-10[data-v-49492fda] {\n  margin-bottom: 10px;\n}\n.p-L-10[data-v-49492fda] {\n  padding-left: 10px;\n}\n.p-R-10[data-v-49492fda] {\n  padding-right: 10px;\n}\n.header[data-v-49492fda] {\n  height: 50px;\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 50px;\n  padding-left: 70px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.left-panel[data-v-49492fda] {\n  width: 280px;\n  height: calc(100% - 50px);\n  background: #e8f0fb;\n  position: fixed;\n  top: 50px;\n  left: 0;\n  padding: 10px;\n  overflow: auto;\n}\n.left-panel .brands[data-v-49492fda] {\n    margin-bottom: 20px;\n    border: 1px solid #ddd;\n    padding: 10px;\n    color: #333;\n    height: 45px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.left-panel .brands.has-error[data-v-49492fda] {\n      border-color: #f20d0d;\n}\n.left-panel .brands[data-v-49492fda]:disabled {\n      background-color: #eee;\n}\n.left-panel .service-list[data-v-49492fda] {\n    position: relative;\n    min-height: 50px;\n}\n.left-panel .service-list .loader[data-v-49492fda] {\n      position: absolute;\n      width: 80%;\n      background: #fff;\n      top: 50%;\n      left: 10%;\n      padding: 10px;\n      text-align: center;\n      font-size: 14px;\n      font-style: italic;\n      color: #777;\n      margin-top: -25px;\n      -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);\n              box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);\n      border-radius: 4px;\n}\n.left-panel .service-list .loader i[data-v-49492fda] {\n        color: #0D79F2;\n        margin-right: 4px;\n}\n.left-panel ul[data-v-49492fda] {\n    list-style: none;\n    padding: 0;\n    margin: 6px 0;\n    border: 1px solid #dedede;\n    border-radius: 2px;\n    overflow: hidden;\n    -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n            box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n}\n.left-panel ul.disabled[data-v-49492fda] {\n      opacity: .5;\n}\n.left-panel ul li[data-v-49492fda] {\n      background: #fff;\n      padding: 10px;\n      font-size: 16px;\n      border-bottom: 1px solid #dedede;\n      font-weight: 600;\n      cursor: pointer;\n}\n.left-panel ul li[data-v-49492fda]:last-child {\n        border-bottom: none;\n}\n.left-panel ul li[data-v-49492fda]:hover {\n        background: #fafafa;\n}\n.left-panel ul li.active[data-v-49492fda] {\n        background: #f0f9ff;\n        -webkit-box-shadow: 0 0 0 3px #2f8cc7 inset;\n                box-shadow: 0 0 0 3px #2f8cc7 inset;\n}\n.left-panel ul li .left[data-v-49492fda], .left-panel ul li .mid[data-v-49492fda], .left-panel ul li .right[data-v-49492fda] {\n        display: inline-block;\n        vertical-align: top;\n}\n.left-panel ul li .mid[data-v-49492fda] {\n        width: calc(100% - 70px);\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n}\n.left-panel ul li .drag-icon[data-v-49492fda] {\n        color: #acb6c3;\n        margin-right: 3px;\n}\n.left-panel ul li span[data-v-49492fda] {\n        display: block;\n        font-size: 11px;\n        color: #aaa;\n        line-height: 1;\n        font-weight: 100;\n}\n.right-panel[data-v-49492fda] {\n  width: calc(100% - (280px));\n  height: calc(100% - 50px);\n  position: fixed;\n  top: 50px;\n  left: 280px;\n  background: #f4f9ff;\n  padding: 10px 20px 70px;\n  overflow: auto;\n}\n.right-panel .fixed-bottom[data-v-49492fda] {\n    height: 50px;\n    width: calc(100% - (280px));\n    left: 280px;\n    bottom: 0;\n    position: fixed;\n    background: #fff;\n    border-top: 1px solid #b0c6e4;\n    text-align: center;\n    padding: 5px 0;\n    -webkit-box-shadow: 0 -2px 3px rgba(0, 0, 0, 0.1);\n            box-shadow: 0 -2px 3px rgba(0, 0, 0, 0.1);\n    z-index: 3;\n}\n.right-panel .fixed-bottom .button[data-v-49492fda] {\n      text-transform: uppercase;\n      margin: 0 5px;\n      min-width: 160px;\n}\n.right-panel .fixed-bottom .button i[data-v-49492fda] {\n        margin-right: 7px;\n}\n.row[data-v-49492fda] {\n  max-width: 100%;\n}\n.box[data-v-49492fda] {\n  background: #fff;\n  border-radius: 2px;\n  border: 1px solid #b0c6e4;\n  padding: 15px;\n  -webkit-box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n          box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n}\n.box.general-settings[data-v-49492fda] {\n    width: 750px;\n    margin: 0 10px;\n}\n.switch[data-v-49492fda] {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n}\n.switch .slider[data-v-49492fda] {\n    position: relative;\n    display: inline-block;\n    width: 40px;\n    height: 20px;\n    border-radius: 20px;\n    background: #ccc;\n    position: relative;\n    cursor: pointer;\n    -webkit-transition: all .15s linear;\n    transition: all .15s linear;\n}\n.switch .slider.disabled[data-v-49492fda] {\n      opacity: .4;\n}\n.switch .slider[data-v-49492fda]:before {\n      content: '';\n      position: absolute;\n      top: 2px;\n      left: 2px;\n      width: 16px;\n      height: 16px;\n      border-radius: 50%;\n      background: #fff;\n      -webkit-transition: all .25s ease-in-out;\n      transition: all .25s ease-in-out;\n      -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n}\n.switch .slider.active[data-v-49492fda] {\n      background: #57d1b7;\n}\n.switch .slider.active[data-v-49492fda]:before {\n        left: 21px;\n}\n.switch .label[data-v-49492fda] {\n    display: block;\n    font-size: 9px;\n    color: #aaa;\n    text-transform: uppercase;\n}\n.flip-list-move[data-v-49492fda] {\n  -webkit-transition: -webkit-transform 0s;\n  transition: -webkit-transform 0s;\n  transition: transform 0s;\n  transition: transform 0s, -webkit-transform 0s;\n}\n.no-move[data-v-49492fda] {\n  -webkit-transition: -webkit-transform 0s;\n  transition: -webkit-transform 0s;\n  transition: transform 0s;\n  transition: transform 0s, -webkit-transform 0s;\n}\n.ghost[data-v-49492fda] {\n  opacity: 0.5;\n  background: #c8ebfb;\n}\n.op--modal-container[data-v-49492fda] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-49492fda] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-49492fda] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-49492fda] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.op--modal-content .response-box[data-v-49492fda], .op--modal-content .clone-box[data-v-49492fda], .op--modal-content .driver-box[data-v-49492fda], .op--modal-content .enable-driver-modal[data-v-49492fda] {\n    text-align: center;\n    margin-bottom: 40px;\n    background-color: #fff;\n    border-radius: 4px;\n    width: 100%;\n    max-width: 400px;\n    margin: 0 auto;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    position: relative;\n    padding: 20px;\n}\n.op--modal-content .response-box .skip[data-v-49492fda], .op--modal-content .clone-box .skip[data-v-49492fda], .op--modal-content .driver-box .skip[data-v-49492fda], .op--modal-content .enable-driver-modal .skip[data-v-49492fda] {\n      background-color: #fff;\n      color: #333 !important;\n      margin-top: 5px !important;\n}\n.op--modal-content .response-box .success[data-v-49492fda], .op--modal-content .clone-box .success[data-v-49492fda], .op--modal-content .driver-box .success[data-v-49492fda], .op--modal-content .enable-driver-modal .success[data-v-49492fda] {\n      color: #26D97A;\n}\n.op--modal-content .response-box .error[data-v-49492fda], .op--modal-content .clone-box .error[data-v-49492fda], .op--modal-content .driver-box .error[data-v-49492fda], .op--modal-content .enable-driver-modal .error[data-v-49492fda] {\n      color: #F20D0D;\n}\n.op--modal-content .response-box .message[data-v-49492fda], .op--modal-content .clone-box .message[data-v-49492fda], .op--modal-content .driver-box .message[data-v-49492fda], .op--modal-content .enable-driver-modal .message[data-v-49492fda] {\n      display: block;\n      margin-top: 10px;\n      font-size: 15px;\n      font-weight: 600;\n}\n.op--modal-content .response-box .extra[data-v-49492fda], .op--modal-content .clone-box .extra[data-v-49492fda], .op--modal-content .driver-box .extra[data-v-49492fda], .op--modal-content .enable-driver-modal .extra[data-v-49492fda] {\n      border: 1px solid #f20d0d;\n      background: #ffefef;\n      border-radius: 4px;\n      color: #000;\n      padding: 5px;\n      font-style: italic;\n      font-size: 13px;\n      display: block;\n      margin-top: 10px;\n}\n.op--modal-content .response-box .button[data-v-49492fda], .op--modal-content .clone-box .button[data-v-49492fda], .op--modal-content .driver-box .button[data-v-49492fda], .op--modal-content .enable-driver-modal .button[data-v-49492fda] {\n      margin-top: 25px;\n}\n.op--modal-content .clone-box select[data-v-49492fda] {\n    margin-bottom: 20px;\n}\n.op--modal-content .clone-box .message[data-v-49492fda] {\n    margin-bottom: 20px;\n}\n.op--modal-content .clone-box .button[data-v-49492fda] {\n    margin-top: 0;\n}\n.op--modal-content .driver-box[data-v-49492fda] {\n    max-width: 1160px;\n}\nselect[data-v-49492fda] {\n  margin-top: 5px;\n  border: 1px solid #ddd;\n  padding: 10px;\n  color: #333;\n  height: 45px;\n  position: relative;\n  font-size: 14px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n  -webkit-transition: all .35s ease;\n  transition: all .35s ease;\n}\nselect.has-error[data-v-49492fda] {\n    border-color: #f20d0d;\n}\nselect[data-v-49492fda]:disabled {\n    background-color: #eee;\n}\n.slide-up-enter-active[data-v-49492fda], .slide-up-leave-active[data-v-49492fda] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-49492fda], .slide-up-leave-to[data-v-49492fda] {\n  -webkit-transform: translateY(30px);\n          transform: translateY(30px);\n  opacity: 0;\n}\n.slide-down-enter-active[data-v-49492fda], .slide-down-leave-active[data-v-49492fda] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-49492fda], .slide-down-leave-to[data-v-49492fda] {\n  -webkit-transform: translateY(-20px);\n          transform: translateY(-20px);\n  opacity: 0;\n}\n.fade-right-enter-active[data-v-49492fda], .fade-right-leave-active[data-v-49492fda] {\n  -webkit-transition: all .15s ease;\n  transition: all .15s ease;\n}\n.fade-right-enter[data-v-49492fda], .fade-right-leave-to[data-v-49492fda] {\n  -webkit-transform: translateX(15px);\n          transform: translateX(15px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.p-R-10[data-v-49492fda] {\n    padding: 0;\n}\n.clone-box .row[data-v-49492fda] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.clone-box .row .column[data-v-49492fda] {\n      width: 50%;\n      padding: 0 10px;\n}\n.left-panel[data-v-49492fda] {\n    width: 100%;\n    padding: 20px 2rem 50px;\n}\n.right-panel.hide[data-v-49492fda] {\n    width: 0;\n    height: 0;\n    position: unset;\n}\n.right-panel.show[data-v-49492fda] {\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    left: 0;\n    padding-bottom: 200px;\n}\n.right-panel .fixed-bottom[data-v-49492fda] {\n    width: 100%;\n    left: 0;\n    height: auto;\n    padding: 10px;\n}\n.right-panel .fixed-bottom .column[data-v-49492fda] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      gap: 2%;\n}\n.right-panel .fixed-bottom .button[data-v-49492fda] {\n      margin: 0;\n      min-width: 100px;\n}\n.right-panel .fixed-bottom .button.long-btn[data-v-49492fda] {\n        width: 100%;\n        margin-bottom: 5px;\n}\n.right-panel .fixed-bottom .button.short-btn[data-v-49492fda] {\n        width: 32%;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Services/index.vue"],"names":[],"mappings":";AACA;EACE,oBAAoB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;CAC9C;AACD;EACE,aAAa;EACb,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,cAAc;EACd,eAAe;CAChB;AACD;IACI,oBAAoB;IACpB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,wDAAwD;IACxD,6BAA6B;IAC7B,+BAA+B;IAC/B,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,uBAAuB;CAC5B;AACD;IACI,mBAAmB;IACnB,iBAAiB;CACpB;AACD;MACM,mBAAmB;MACnB,WAAW;MACX,iBAAiB;MACjB,SAAS;MACT,UAAU;MACV,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;MACnB,YAAY;MACZ,kBAAkB;MAClB,+CAA+C;cACvC,uCAAuC;MAC/C,mBAAmB;CACxB;AACD;QACQ,eAAe;QACf,kBAAkB;CACzB;AACD;IACI,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,0BAA0B;IAC1B,mBAAmB;IACnB,iBAAiB;IACjB,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;MACM,YAAY;CACjB;AACD;MACM,iBAAiB;MACjB,cAAc;MACd,gBAAgB;MAChB,iCAAiC;MACjC,iBAAiB;MACjB,gBAAgB;CACrB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,oBAAoB;QACpB,4CAA4C;gBACpC,oCAAoC;CACnD;AACD;QACQ,sBAAsB;QACtB,oBAAoB;CAC3B;AACD;QACQ,yBAAyB;QACzB,oBAAoB;QACpB,iBAAiB;QACjB,wBAAwB;CAC/B;AACD;QACQ,eAAe;QACf,kBAAkB;CACzB;AACD;QACQ,eAAe;QACf,gBAAgB;QAChB,YAAY;QACZ,eAAe;QACf,iBAAiB;CACxB;AACD;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;CAChB;AACD;IACI,aAAa;IACb,4BAA4B;IAC5B,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,kDAAkD;YAC1C,0CAA0C;IAClD,WAAW;CACd;AACD;MACM,0BAA0B;MAC1B,cAAc;MACd,iBAAiB;CACtB;AACD;QACQ,kBAAkB;CACzB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,kDAAkD;UAC1C,0CAA0C;CACnD;AACD;IACI,aAAa;IACb,eAAe;CAClB;AACD;EACE,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;CACrB;AACD;IACI,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,oCAAoC;IACpC,4BAA4B;CAC/B;AACD;MACM,YAAY;CACjB;AACD;MACM,YAAY;MACZ,mBAAmB;MACnB,SAAS;MACT,UAAU;MACV,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,iBAAiB;MACjB,yCAAyC;MACzC,iCAAiC;MACjC,oDAAoD;cAC5C,4CAA4C;CACzD;AACD;MACM,oBAAoB;CACzB;AACD;QACQ,WAAW;CAClB;AACD;IACI,eAAe;IACf,eAAe;IACf,YAAY;IACZ,0BAA0B;CAC7B;AACD;EACE,yCAAyC;EACzC,iCAAiC;EACjC,yBAAyB;EACzB,+CAA+C;CAChD;AACD;EACE,yCAAyC;EACzC,iCAAiC;EACjC,yBAAyB;EACzB,+CAA+C;CAChD;AACD;EACE,aAAa;EACb,oBAAoB;CACrB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;IACI,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,iDAAiD;YACzC,yCAAyC;IACjD,mBAAmB;IACnB,cAAc;CACjB;AACD;MACM,uBAAuB;MACvB,uBAAuB;MACvB,2BAA2B;CAChC;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,iBAAiB;CACtB;AACD;MACM,0BAA0B;MAC1B,oBAAoB;MACpB,mBAAmB;MACnB,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,gBAAgB;MAChB,eAAe;MACf,iBAAiB;CACtB;AACD;MACM,iBAAiB;CACtB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,cAAc;CACjB;AACD;IACI,kBAAkB;CACrB;AACD;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;IACI,sBAAsB;CACzB;AACD;IACI,uBAAuB;CAC1B;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ;AACD;EACE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;AACA;IACI,WAAW;CACd;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;MACM,WAAW;MACX,gBAAgB;CACrB;AACD;IACI,YAAY;IACZ,wBAAwB;CAC3B;AACD;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;CACnB;AACD;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,QAAQ;IACR,sBAAsB;CACzB;AACD;IACI,YAAY;IACZ,QAAQ;IACR,aAAa;IACb,cAAc;CACjB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,oBAAoB;UAChB,gBAAgB;MACpB,yBAAyB;UACrB,sBAAsB;cAClB,wBAAwB;MAChC,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;MAC5B,QAAQ;CACb;AACD;MACM,UAAU;MACV,iBAAiB;CACtB;AACD;QACQ,YAAY;QACZ,mBAAmB;CAC1B;AACD;QACQ,WAAW;CAClB;CACA","file":"index.vue","sourcesContent":["\n.m-B-10[data-v-49492fda] {\n  margin-bottom: 10px;\n}\n.p-L-10[data-v-49492fda] {\n  padding-left: 10px;\n}\n.p-R-10[data-v-49492fda] {\n  padding-right: 10px;\n}\n.header[data-v-49492fda] {\n  height: 50px;\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 50px;\n  padding-left: 70px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.left-panel[data-v-49492fda] {\n  width: 280px;\n  height: calc(100% - 50px);\n  background: #e8f0fb;\n  position: fixed;\n  top: 50px;\n  left: 0;\n  padding: 10px;\n  overflow: auto;\n}\n.left-panel .brands[data-v-49492fda] {\n    margin-bottom: 20px;\n    border: 1px solid #ddd;\n    padding: 10px;\n    color: #333;\n    height: 45px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.left-panel .brands.has-error[data-v-49492fda] {\n      border-color: #f20d0d;\n}\n.left-panel .brands[data-v-49492fda]:disabled {\n      background-color: #eee;\n}\n.left-panel .service-list[data-v-49492fda] {\n    position: relative;\n    min-height: 50px;\n}\n.left-panel .service-list .loader[data-v-49492fda] {\n      position: absolute;\n      width: 80%;\n      background: #fff;\n      top: 50%;\n      left: 10%;\n      padding: 10px;\n      text-align: center;\n      font-size: 14px;\n      font-style: italic;\n      color: #777;\n      margin-top: -25px;\n      -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);\n              box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);\n      border-radius: 4px;\n}\n.left-panel .service-list .loader i[data-v-49492fda] {\n        color: #0D79F2;\n        margin-right: 4px;\n}\n.left-panel ul[data-v-49492fda] {\n    list-style: none;\n    padding: 0;\n    margin: 6px 0;\n    border: 1px solid #dedede;\n    border-radius: 2px;\n    overflow: hidden;\n    -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n            box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n}\n.left-panel ul.disabled[data-v-49492fda] {\n      opacity: .5;\n}\n.left-panel ul li[data-v-49492fda] {\n      background: #fff;\n      padding: 10px;\n      font-size: 16px;\n      border-bottom: 1px solid #dedede;\n      font-weight: 600;\n      cursor: pointer;\n}\n.left-panel ul li[data-v-49492fda]:last-child {\n        border-bottom: none;\n}\n.left-panel ul li[data-v-49492fda]:hover {\n        background: #fafafa;\n}\n.left-panel ul li.active[data-v-49492fda] {\n        background: #f0f9ff;\n        -webkit-box-shadow: 0 0 0 3px #2f8cc7 inset;\n                box-shadow: 0 0 0 3px #2f8cc7 inset;\n}\n.left-panel ul li .left[data-v-49492fda], .left-panel ul li .mid[data-v-49492fda], .left-panel ul li .right[data-v-49492fda] {\n        display: inline-block;\n        vertical-align: top;\n}\n.left-panel ul li .mid[data-v-49492fda] {\n        width: calc(100% - 70px);\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n}\n.left-panel ul li .drag-icon[data-v-49492fda] {\n        color: #acb6c3;\n        margin-right: 3px;\n}\n.left-panel ul li span[data-v-49492fda] {\n        display: block;\n        font-size: 11px;\n        color: #aaa;\n        line-height: 1;\n        font-weight: 100;\n}\n.right-panel[data-v-49492fda] {\n  width: calc(100% - (280px));\n  height: calc(100% - 50px);\n  position: fixed;\n  top: 50px;\n  left: 280px;\n  background: #f4f9ff;\n  padding: 10px 20px 70px;\n  overflow: auto;\n}\n.right-panel .fixed-bottom[data-v-49492fda] {\n    height: 50px;\n    width: calc(100% - (280px));\n    left: 280px;\n    bottom: 0;\n    position: fixed;\n    background: #fff;\n    border-top: 1px solid #b0c6e4;\n    text-align: center;\n    padding: 5px 0;\n    -webkit-box-shadow: 0 -2px 3px rgba(0, 0, 0, 0.1);\n            box-shadow: 0 -2px 3px rgba(0, 0, 0, 0.1);\n    z-index: 3;\n}\n.right-panel .fixed-bottom .button[data-v-49492fda] {\n      text-transform: uppercase;\n      margin: 0 5px;\n      min-width: 160px;\n}\n.right-panel .fixed-bottom .button i[data-v-49492fda] {\n        margin-right: 7px;\n}\n.row[data-v-49492fda] {\n  max-width: 100%;\n}\n.box[data-v-49492fda] {\n  background: #fff;\n  border-radius: 2px;\n  border: 1px solid #b0c6e4;\n  padding: 15px;\n  -webkit-box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n          box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n}\n.box.general-settings[data-v-49492fda] {\n    width: 750px;\n    margin: 0 10px;\n}\n.switch[data-v-49492fda] {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n}\n.switch .slider[data-v-49492fda] {\n    position: relative;\n    display: inline-block;\n    width: 40px;\n    height: 20px;\n    border-radius: 20px;\n    background: #ccc;\n    position: relative;\n    cursor: pointer;\n    -webkit-transition: all .15s linear;\n    transition: all .15s linear;\n}\n.switch .slider.disabled[data-v-49492fda] {\n      opacity: .4;\n}\n.switch .slider[data-v-49492fda]:before {\n      content: '';\n      position: absolute;\n      top: 2px;\n      left: 2px;\n      width: 16px;\n      height: 16px;\n      border-radius: 50%;\n      background: #fff;\n      -webkit-transition: all .25s ease-in-out;\n      transition: all .25s ease-in-out;\n      -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n}\n.switch .slider.active[data-v-49492fda] {\n      background: #57d1b7;\n}\n.switch .slider.active[data-v-49492fda]:before {\n        left: 21px;\n}\n.switch .label[data-v-49492fda] {\n    display: block;\n    font-size: 9px;\n    color: #aaa;\n    text-transform: uppercase;\n}\n.flip-list-move[data-v-49492fda] {\n  -webkit-transition: -webkit-transform 0s;\n  transition: -webkit-transform 0s;\n  transition: transform 0s;\n  transition: transform 0s, -webkit-transform 0s;\n}\n.no-move[data-v-49492fda] {\n  -webkit-transition: -webkit-transform 0s;\n  transition: -webkit-transform 0s;\n  transition: transform 0s;\n  transition: transform 0s, -webkit-transform 0s;\n}\n.ghost[data-v-49492fda] {\n  opacity: 0.5;\n  background: #c8ebfb;\n}\n.op--modal-container[data-v-49492fda] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-49492fda] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-49492fda] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-49492fda] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.op--modal-content .response-box[data-v-49492fda], .op--modal-content .clone-box[data-v-49492fda], .op--modal-content .driver-box[data-v-49492fda], .op--modal-content .enable-driver-modal[data-v-49492fda] {\n    text-align: center;\n    margin-bottom: 40px;\n    background-color: #fff;\n    border-radius: 4px;\n    width: 100%;\n    max-width: 400px;\n    margin: 0 auto;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    position: relative;\n    padding: 20px;\n}\n.op--modal-content .response-box .skip[data-v-49492fda], .op--modal-content .clone-box .skip[data-v-49492fda], .op--modal-content .driver-box .skip[data-v-49492fda], .op--modal-content .enable-driver-modal .skip[data-v-49492fda] {\n      background-color: #fff;\n      color: #333 !important;\n      margin-top: 5px !important;\n}\n.op--modal-content .response-box .success[data-v-49492fda], .op--modal-content .clone-box .success[data-v-49492fda], .op--modal-content .driver-box .success[data-v-49492fda], .op--modal-content .enable-driver-modal .success[data-v-49492fda] {\n      color: #26D97A;\n}\n.op--modal-content .response-box .error[data-v-49492fda], .op--modal-content .clone-box .error[data-v-49492fda], .op--modal-content .driver-box .error[data-v-49492fda], .op--modal-content .enable-driver-modal .error[data-v-49492fda] {\n      color: #F20D0D;\n}\n.op--modal-content .response-box .message[data-v-49492fda], .op--modal-content .clone-box .message[data-v-49492fda], .op--modal-content .driver-box .message[data-v-49492fda], .op--modal-content .enable-driver-modal .message[data-v-49492fda] {\n      display: block;\n      margin-top: 10px;\n      font-size: 15px;\n      font-weight: 600;\n}\n.op--modal-content .response-box .extra[data-v-49492fda], .op--modal-content .clone-box .extra[data-v-49492fda], .op--modal-content .driver-box .extra[data-v-49492fda], .op--modal-content .enable-driver-modal .extra[data-v-49492fda] {\n      border: 1px solid #f20d0d;\n      background: #ffefef;\n      border-radius: 4px;\n      color: #000;\n      padding: 5px;\n      font-style: italic;\n      font-size: 13px;\n      display: block;\n      margin-top: 10px;\n}\n.op--modal-content .response-box .button[data-v-49492fda], .op--modal-content .clone-box .button[data-v-49492fda], .op--modal-content .driver-box .button[data-v-49492fda], .op--modal-content .enable-driver-modal .button[data-v-49492fda] {\n      margin-top: 25px;\n}\n.op--modal-content .clone-box select[data-v-49492fda] {\n    margin-bottom: 20px;\n}\n.op--modal-content .clone-box .message[data-v-49492fda] {\n    margin-bottom: 20px;\n}\n.op--modal-content .clone-box .button[data-v-49492fda] {\n    margin-top: 0;\n}\n.op--modal-content .driver-box[data-v-49492fda] {\n    max-width: 1160px;\n}\nselect[data-v-49492fda] {\n  margin-top: 5px;\n  border: 1px solid #ddd;\n  padding: 10px;\n  color: #333;\n  height: 45px;\n  position: relative;\n  font-size: 14px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n  -webkit-transition: all .35s ease;\n  transition: all .35s ease;\n}\nselect.has-error[data-v-49492fda] {\n    border-color: #f20d0d;\n}\nselect[data-v-49492fda]:disabled {\n    background-color: #eee;\n}\n.slide-up-enter-active[data-v-49492fda], .slide-up-leave-active[data-v-49492fda] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-49492fda], .slide-up-leave-to[data-v-49492fda] {\n  -webkit-transform: translateY(30px);\n          transform: translateY(30px);\n  opacity: 0;\n}\n.slide-down-enter-active[data-v-49492fda], .slide-down-leave-active[data-v-49492fda] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-49492fda], .slide-down-leave-to[data-v-49492fda] {\n  -webkit-transform: translateY(-20px);\n          transform: translateY(-20px);\n  opacity: 0;\n}\n.fade-right-enter-active[data-v-49492fda], .fade-right-leave-active[data-v-49492fda] {\n  -webkit-transition: all .15s ease;\n  transition: all .15s ease;\n}\n.fade-right-enter[data-v-49492fda], .fade-right-leave-to[data-v-49492fda] {\n  -webkit-transform: translateX(15px);\n          transform: translateX(15px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.p-R-10[data-v-49492fda] {\n    padding: 0;\n}\n.clone-box .row[data-v-49492fda] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.clone-box .row .column[data-v-49492fda] {\n      width: 50%;\n      padding: 0 10px;\n}\n.left-panel[data-v-49492fda] {\n    width: 100%;\n    padding: 20px 2rem 50px;\n}\n.right-panel.hide[data-v-49492fda] {\n    width: 0;\n    height: 0;\n    position: unset;\n}\n.right-panel.show[data-v-49492fda] {\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    left: 0;\n    padding-bottom: 200px;\n}\n.right-panel .fixed-bottom[data-v-49492fda] {\n    width: 100%;\n    left: 0;\n    height: auto;\n    padding: 10px;\n}\n.right-panel .fixed-bottom .column[data-v-49492fda] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      gap: 2%;\n}\n.right-panel .fixed-bottom .button[data-v-49492fda] {\n      margin: 0;\n      min-width: 100px;\n}\n.right-panel .fixed-bottom .button.long-btn[data-v-49492fda] {\n        width: 100%;\n        margin-bottom: 5px;\n}\n.right-panel .fixed-bottom .button.short-btn[data-v-49492fda] {\n        width: 32%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preview_vue__ = __webpack_require__(549);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b9a2d1f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preview_vue__ = __webpack_require__(1589);
function injectStyle (ssrContext) {
  __webpack_require__(1575)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b9a2d1f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b9a2d1f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1576);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4992dbd8", content, true, {});

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.op--modal-container[data-v-6b9a2d1f] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-6b9a2d1f] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-6b9a2d1f] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content.center[data-v-6b9a2d1f] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.preview-box[data-v-6b9a2d1f] {\n  background-color: #fff;\n  border-radius: 4px;\n  width: 100%;\n  max-width: 800px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  position: relative;\n  padding: 20px;\n}\n.preview[data-v-6b9a2d1f] {\n  text-align: center;\n  margin-bottom: 40px;\n}\n.preview .label[data-v-6b9a2d1f] {\n    font-size: 21px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #eee;\n    text-align: left;\n}\n.fixed-bottom[data-v-6b9a2d1f] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.preview-box[data-v-6b9a2d1f] {\n    width: 100%;\n    padding: 20px 0;\n    padding-bottom: 100px;\n}\n.preview-box .web[data-v-6b9a2d1f] {\n      display: none;\n}\n.preview-box .preview[data-v-6b9a2d1f] {\n      padding: 0 10px;\n}\n.fixed-bottom[data-v-6b9a2d1f] {\n    display: block;\n    width: 100%;\n    padding: 10px 0;\n    position: fixed;\n    bottom: 0;\n    background: #fff;\n    border-top: 1px solid #b0c6e4;\n    text-align: center;\n    -webkit-box-shadow: 0 -2px 3px rgba(0, 0, 0, 0.1);\n            box-shadow: 0 -2px 3px rgba(0, 0, 0, 0.1);\n    z-index: 3;\n}\n.fixed-bottom .button[data-v-6b9a2d1f] {\n      text-transform: uppercase;\n      margin: 0 5px;\n      min-width: 160px;\n}\n.fixed-bottom .button i[data-v-6b9a2d1f] {\n        margin-right: 7px;\n}\n.hide .fixed-bottom[data-v-6b9a2d1f] {\n    display: none;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Services/Preview.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iDAAiD;UACzC,yCAAyC;EACjD,mBAAmB;EACnB,cAAc;CACf;AACD;EACE,mBAAmB;EACnB,oBAAoB;CACrB;AACD;IACI,gBAAgB;IAChB,qBAAqB;IACrB,8BAA8B;IAC9B,iBAAiB;CACpB;AACD;EACE,cAAc;CACf;AACD;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;CACzB;AACD;MACM,cAAc;CACnB;AACD;MACM,gBAAgB;CACrB;AACD;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;IACnB,kDAAkD;YAC1C,0CAA0C;IAClD,WAAW;CACd;AACD;MACM,0BAA0B;MAC1B,cAAc;MACd,iBAAiB;CACtB;AACD;QACQ,kBAAkB;CACzB;AACD;IACI,cAAc;CACjB;CACA","file":"Preview.vue","sourcesContent":["\n.op--modal-container[data-v-6b9a2d1f] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-6b9a2d1f] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-6b9a2d1f] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content.center[data-v-6b9a2d1f] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.preview-box[data-v-6b9a2d1f] {\n  background-color: #fff;\n  border-radius: 4px;\n  width: 100%;\n  max-width: 800px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  position: relative;\n  padding: 20px;\n}\n.preview[data-v-6b9a2d1f] {\n  text-align: center;\n  margin-bottom: 40px;\n}\n.preview .label[data-v-6b9a2d1f] {\n    font-size: 21px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #eee;\n    text-align: left;\n}\n.fixed-bottom[data-v-6b9a2d1f] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.preview-box[data-v-6b9a2d1f] {\n    width: 100%;\n    padding: 20px 0;\n    padding-bottom: 100px;\n}\n.preview-box .web[data-v-6b9a2d1f] {\n      display: none;\n}\n.preview-box .preview[data-v-6b9a2d1f] {\n      padding: 0 10px;\n}\n.fixed-bottom[data-v-6b9a2d1f] {\n    display: block;\n    width: 100%;\n    padding: 10px 0;\n    position: fixed;\n    bottom: 0;\n    background: #fff;\n    border-top: 1px solid #b0c6e4;\n    text-align: center;\n    -webkit-box-shadow: 0 -2px 3px rgba(0, 0, 0, 0.1);\n            box-shadow: 0 -2px 3px rgba(0, 0, 0, 0.1);\n    z-index: 3;\n}\n.fixed-bottom .button[data-v-6b9a2d1f] {\n      text-transform: uppercase;\n      margin: 0 5px;\n      min-width: 160px;\n}\n.fixed-bottom .button i[data-v-6b9a2d1f] {\n        margin-right: 7px;\n}\n.hide .fixed-bottom[data-v-6b9a2d1f] {\n    display: none;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreviewWeb_vue__ = __webpack_require__(550);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9efbd8fc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreviewWeb_vue__ = __webpack_require__(1580);
function injectStyle (ssrContext) {
  __webpack_require__(1578)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9efbd8fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreviewWeb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9efbd8fc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreviewWeb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1579);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("8480414c", content, true, {});

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.services[data-v-9efbd8fc] {\n  padding: 10px 0;\n  position: relative;\n}\n.service-box[data-v-9efbd8fc] {\n  position: relative;\n  overflow: hidden;\n  max-height: 999px;\n  padding: 10px 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #2c3e50;\n  font-family: Questrial,sans-serif;\n}\n.service[data-v-9efbd8fc] {\n  background-color: #d0d0d0;\n  border: 2px solid #ccc;\n  border-radius: 3px;\n  width: 100%;\n  display: block;\n  margin-right: 11px;\n  margin-bottom: 0 !important;\n  text-align: center;\n  padding: 0;\n  cursor: pointer;\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.service[data-v-9efbd8fc]:hover:not(.disabled), .service.active[data-v-9efbd8fc] {\n    border: 2px solid #13bcac;\n}\n.service.disabled[data-v-9efbd8fc] {\n    opacity: .65;\n    cursor: default;\n}\n.service.no-margin[data-v-9efbd8fc] {\n    margin-right: 0;\n}\n.service .service-img[data-v-9efbd8fc] {\n    display: table-cell;\n    z-index: 2;\n    -webkit-transition: all .2s ease-in;\n    transition: all .2s ease-in;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n}\n.service .service-img img[data-v-9efbd8fc] {\n      max-width: 100%;\n      max-height: 150px;\n}\n.service .service-data-box[data-v-9efbd8fc] {\n    background: #f6f6f6;\n}\n.service .service-data[data-v-9efbd8fc] {\n    width: 100%;\n    text-align: left;\n    padding: 15px;\n    position: relative;\n    z-index: 2;\n}\n.service .service-data .break[data-v-9efbd8fc] {\n      height: 24px;\n      width: 100%;\n      margin-bottom: 10px;\n}\n.service .service-max-paxluggage[data-v-9efbd8fc] {\n    font-size: 12px;\n    line-height: 12px;\n    margin-bottom: 10px;\n}\n.service .service-max-paxluggage .pax-luggage[data-v-9efbd8fc] {\n      display: inline-block;\n      color: #838d98;\n}\n.service .service-max-paxluggage .stairs-label[data-v-9efbd8fc] {\n      display: inline-block;\n      padding: 3px 5px;\n      color: #838d98;\n      font-weight: 600;\n}\n.service .service-max-paxluggage .fa-stack i[data-v-9efbd8fc] {\n      width: 24px;\n}\n.service .service-max-paxluggage span[data-v-9efbd8fc] {\n      margin-right: 15px;\n}\n.service .service-name[data-v-9efbd8fc] {\n    font-size: 24px;\n    font-weight: 700;\n    margin-bottom: 5px;\n    line-height: 18px;\n}\n.service .service-desc-excerpt[data-v-9efbd8fc], .service .service-desc[data-v-9efbd8fc] {\n    color: #838d98;\n    line-height: 125%;\n    margin-bottom: 7px;\n}\n.service .service-desc-more[data-v-9efbd8fc] {\n    font-size: 13px;\n    font-weight: 600;\n    color: #13bcac;\n    -webkit-transition: all .3s ease;\n    transition: all .3s ease;\n}\n.service .service-desc-more a span[data-v-9efbd8fc] {\n      color: #13bcac;\n}\n.service .service-quote[data-v-9efbd8fc] {\n    padding: 0 10px;\n}\n.service .service-price[data-v-9efbd8fc] {\n    font-size: 32px;\n    font-weight: 700;\n    color: #13bcac;\n    line-height: 1;\n    text-align: right;\n}\n.service .service-price .shared-error[data-v-9efbd8fc] {\n      font-size: 13px;\n      color: #ff4a4a;\n      line-height: 1.4;\n}\n.service .service-price .suggested-service[data-v-9efbd8fc] {\n      font-size: 14px;\n      color: #2c3e50;\n      line-height: 1.4;\n      margin-top: 10px;\n      cursor: pointer;\n      text-decoration: underline;\n}\n.service .service-discount-info[data-v-9efbd8fc] {\n    text-align: right;\n}\n.service .service-discount-info span[data-v-9efbd8fc] {\n      display: inline-block;\n}\n.service .service-discount-info .service-original-price[data-v-9efbd8fc] {\n      font-size: 18px;\n      margin-right: 5px;\n      position: relative;\n      color: #ccc;\n      vertical-align: middle;\n}\n.service .service-discount-info .service-original-price[data-v-9efbd8fc]:after {\n        content: '';\n        border-bottom: 1px solid rgba(255, 0, 0, 0.5);\n        position: absolute;\n        top: 50%;\n        left: 0;\n        width: 100%;\n}\n.service .service-discount-info .service-discount-saved[data-v-9efbd8fc] {\n      font-size: 12px;\n      color: #fff;\n      background: #d55556;\n      padding: 2px 4px;\n      vertical-align: middle;\n      border-radius: 3px;\n}\n.service .service-discount-timer[data-v-9efbd8fc] {\n    margin-top: 15px;\n    color: #777;\n    text-align: right;\n}\n.service .service-discount-timer div[data-v-9efbd8fc] {\n      font-size: 13px;\n}\n.service .service-discount-timer .timer[data-v-9efbd8fc] {\n      font-size: 15px;\n}\n.service .eta[data-v-9efbd8fc] {\n    text-align: right;\n}\n.service .eta span[data-v-9efbd8fc] {\n      display: block;\n}\n.service .eta .minutes-away[data-v-9efbd8fc], .service .eta .no-cars[data-v-9efbd8fc] {\n      font-size: 13px;\n      color: #aaa;\n}\n.service .eta .suggested-pickup-time[data-v-9efbd8fc] {\n      font-size: 14px;\n      padding-top: 12px;\n}\n.service .eta .suggested-pickup-time.not-allowed[data-v-9efbd8fc] {\n        color: #ea4242;\n}\n.service .eta .suggested-pickup-time a[data-v-9efbd8fc] {\n        text-decoration: underline;\n        font-weight: 600;\n}\n.service .eta .suggested-pickup-time i[data-v-9efbd8fc] {\n        margin-left: 3px;\n        vertical-align: 1px;\n}\n.service .eta .dropoff-time[data-v-9efbd8fc] {\n      line-height: 1.1;\n      font-size: 14px;\n      color: #777;\n}\n.service .eta .no-cars[data-v-9efbd8fc] {\n      font-style: italic;\n}\n.service .mng[data-v-9efbd8fc] {\n    text-align: right;\n    font-size: 13px;\n    color: #ea5427;\n}\n.service .loader-box[data-v-9efbd8fc] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    background: rgba(0, 0, 0, 0);\n    -webkit-transition: all .3s ease-in;\n    transition: all .3s ease-in;\n}\n.service .loader-box.show[data-v-9efbd8fc] {\n      z-index: 3;\n      background: rgba(0, 0, 0, 0.4);\n}\n.service .loader-box .spinner-box[data-v-9efbd8fc] {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      margin-left: -18px;\n      margin-top: -18px;\n}\n.service .loader-box .fa-spinner[data-v-9efbd8fc] {\n      font-size: 36px;\n}\n.medium-below .icon-font[data-v-9efbd8fc], .medium-below .logo[data-v-9efbd8fc] {\n  text-align: center !important;\n}\n.medium-below.pricing[data-v-9efbd8fc] {\n  margin-bottom: 15px;\n}\n.medium-below.pricing .service-quote[data-v-9efbd8fc] {\n    padding: 0;\n}\n.medium-below.pricing .service-price[data-v-9efbd8fc] {\n    text-align: center;\n    line-height: 18px;\n    margin-bottom: 10px;\n    font-size: 28px;\n}\n.medium-below.pricing .service-price .shared-error[data-v-9efbd8fc] {\n      margin-top: 5px;\n}\n.medium-below.pricing .service-discount-timer[data-v-9efbd8fc] {\n    margin-top: 3px;\n    line-height: 10px;\n}\n.medium-below.pricing .service-discount-timer span[data-v-9efbd8fc] {\n      font-size: 12px !important;\n}\n.medium-below.pricing .service-discount-info[data-v-9efbd8fc], .medium-below.pricing .service-discount-timer[data-v-9efbd8fc] {\n    text-align: center;\n}\n.medium-below.service-desc-more[data-v-9efbd8fc] {\n  clear: both;\n}\n.medium-below .eta[data-v-9efbd8fc], .medium-below .mng[data-v-9efbd8fc] {\n  text-align: center;\n}\n.one-way-fare[data-v-9efbd8fc] {\n  font-size: 12px;\n  color: #999;\n}\n.margin-t-m[data-v-9efbd8fc] {\n  margin-top: 20px;\n}\n.margin-b-s[data-v-9efbd8fc] {\n  margin-bottom: 10px;\n}\n.margin-t-s[data-v-9efbd8fc] {\n  margin-top: 10px;\n}\nb[data-v-9efbd8fc] {\n  color: #353535;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Services/PreviewWeb.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,mCAAmC;EACnC,eAAe;EACf,kCAAkC;CACnC;AACD;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,aAAa;IACb,gBAAgB;CACnB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,oBAAoB;IACpB,WAAW;IACX,oCAAoC;IACpC,4BAA4B;IAC5B,mBAAmB;IACnB,SAAS;IACT,QAAQ;IACR,oCAAoC;YAC5B,4BAA4B;CACvC;AACD;MACM,gBAAgB;MAChB,kBAAkB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,WAAW;CACd;AACD;MACM,aAAa;MACb,YAAY;MACZ,oBAAoB;CACzB;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;CACvB;AACD;MACM,sBAAsB;MACtB,eAAe;CACpB;AACD;MACM,sBAAsB;MACtB,iBAAiB;MACjB,eAAe;MACf,iBAAiB;CACtB;AACD;MACM,YAAY;CACjB;AACD;MACM,mBAAmB;CACxB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;CACrB;AACD;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,iCAAiC;IACjC,yBAAyB;CAC5B;AACD;MACM,eAAe;CACpB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;CACrB;AACD;MACM,gBAAgB;MAChB,eAAe;MACf,iBAAiB;CACtB;AACD;MACM,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,iBAAiB;MACjB,gBAAgB;MAChB,2BAA2B;CAChC;AACD;IACI,kBAAkB;CACrB;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;MACnB,YAAY;MACZ,uBAAuB;CAC5B;AACD;QACQ,YAAY;QACZ,8CAA8C;QAC9C,mBAAmB;QACnB,SAAS;QACT,QAAQ;QACR,YAAY;CACnB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,oBAAoB;MACpB,iBAAiB;MACjB,uBAAuB;MACvB,mBAAmB;CACxB;AACD;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;CACrB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,gBAAgB;CACrB;AACD;IACI,kBAAkB;CACrB;AACD;MACM,eAAe;CACpB;AACD;MACM,gBAAgB;MAChB,YAAY;CACjB;AACD;MACM,gBAAgB;MAChB,kBAAkB;CACvB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,2BAA2B;QAC3B,iBAAiB;CACxB;AACD;QACQ,iBAAiB;QACjB,oBAAoB;CAC3B;AACD;MACM,iBAAiB;MACjB,gBAAgB;MAChB,YAAY;CACjB;AACD;MACM,mBAAmB;CACxB;AACD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;CAClB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,WAAW;IACX,6BAA6B;IAC7B,oCAAoC;IACpC,4BAA4B;CAC/B;AACD;MACM,WAAW;MACX,+BAA+B;CACpC;AACD;MACM,mBAAmB;MACnB,SAAS;MACT,UAAU;MACV,mBAAmB;MACnB,kBAAkB;CACvB;AACD;MACM,gBAAgB;CACrB;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,oBAAoB;CACrB;AACD;IACI,WAAW;CACd;AACD;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;MACM,gBAAgB;CACrB;AACD;IACI,gBAAgB;IAChB,kBAAkB;CACrB;AACD;MACM,2BAA2B;CAChC;AACD;IACI,mBAAmB;CACtB;AACD;EACE,YAAY;CACb;AACD;EACE,mBAAmB;CACpB;AACD;EACE,gBAAgB;EAChB,YAAY;CACb;AACD;EACE,iBAAiB;CAClB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,eAAe;CAChB","file":"PreviewWeb.vue","sourcesContent":["\n.services[data-v-9efbd8fc] {\n  padding: 10px 0;\n  position: relative;\n}\n.service-box[data-v-9efbd8fc] {\n  position: relative;\n  overflow: hidden;\n  max-height: 999px;\n  padding: 10px 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #2c3e50;\n  font-family: Questrial,sans-serif;\n}\n.service[data-v-9efbd8fc] {\n  background-color: #d0d0d0;\n  border: 2px solid #ccc;\n  border-radius: 3px;\n  width: 100%;\n  display: block;\n  margin-right: 11px;\n  margin-bottom: 0 !important;\n  text-align: center;\n  padding: 0;\n  cursor: pointer;\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.service[data-v-9efbd8fc]:hover:not(.disabled), .service.active[data-v-9efbd8fc] {\n    border: 2px solid #13bcac;\n}\n.service.disabled[data-v-9efbd8fc] {\n    opacity: .65;\n    cursor: default;\n}\n.service.no-margin[data-v-9efbd8fc] {\n    margin-right: 0;\n}\n.service .service-img[data-v-9efbd8fc] {\n    display: table-cell;\n    z-index: 2;\n    -webkit-transition: all .2s ease-in;\n    transition: all .2s ease-in;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n}\n.service .service-img img[data-v-9efbd8fc] {\n      max-width: 100%;\n      max-height: 150px;\n}\n.service .service-data-box[data-v-9efbd8fc] {\n    background: #f6f6f6;\n}\n.service .service-data[data-v-9efbd8fc] {\n    width: 100%;\n    text-align: left;\n    padding: 15px;\n    position: relative;\n    z-index: 2;\n}\n.service .service-data .break[data-v-9efbd8fc] {\n      height: 24px;\n      width: 100%;\n      margin-bottom: 10px;\n}\n.service .service-max-paxluggage[data-v-9efbd8fc] {\n    font-size: 12px;\n    line-height: 12px;\n    margin-bottom: 10px;\n}\n.service .service-max-paxluggage .pax-luggage[data-v-9efbd8fc] {\n      display: inline-block;\n      color: #838d98;\n}\n.service .service-max-paxluggage .stairs-label[data-v-9efbd8fc] {\n      display: inline-block;\n      padding: 3px 5px;\n      color: #838d98;\n      font-weight: 600;\n}\n.service .service-max-paxluggage .fa-stack i[data-v-9efbd8fc] {\n      width: 24px;\n}\n.service .service-max-paxluggage span[data-v-9efbd8fc] {\n      margin-right: 15px;\n}\n.service .service-name[data-v-9efbd8fc] {\n    font-size: 24px;\n    font-weight: 700;\n    margin-bottom: 5px;\n    line-height: 18px;\n}\n.service .service-desc-excerpt[data-v-9efbd8fc], .service .service-desc[data-v-9efbd8fc] {\n    color: #838d98;\n    line-height: 125%;\n    margin-bottom: 7px;\n}\n.service .service-desc-more[data-v-9efbd8fc] {\n    font-size: 13px;\n    font-weight: 600;\n    color: #13bcac;\n    -webkit-transition: all .3s ease;\n    transition: all .3s ease;\n}\n.service .service-desc-more a span[data-v-9efbd8fc] {\n      color: #13bcac;\n}\n.service .service-quote[data-v-9efbd8fc] {\n    padding: 0 10px;\n}\n.service .service-price[data-v-9efbd8fc] {\n    font-size: 32px;\n    font-weight: 700;\n    color: #13bcac;\n    line-height: 1;\n    text-align: right;\n}\n.service .service-price .shared-error[data-v-9efbd8fc] {\n      font-size: 13px;\n      color: #ff4a4a;\n      line-height: 1.4;\n}\n.service .service-price .suggested-service[data-v-9efbd8fc] {\n      font-size: 14px;\n      color: #2c3e50;\n      line-height: 1.4;\n      margin-top: 10px;\n      cursor: pointer;\n      text-decoration: underline;\n}\n.service .service-discount-info[data-v-9efbd8fc] {\n    text-align: right;\n}\n.service .service-discount-info span[data-v-9efbd8fc] {\n      display: inline-block;\n}\n.service .service-discount-info .service-original-price[data-v-9efbd8fc] {\n      font-size: 18px;\n      margin-right: 5px;\n      position: relative;\n      color: #ccc;\n      vertical-align: middle;\n}\n.service .service-discount-info .service-original-price[data-v-9efbd8fc]:after {\n        content: '';\n        border-bottom: 1px solid rgba(255, 0, 0, 0.5);\n        position: absolute;\n        top: 50%;\n        left: 0;\n        width: 100%;\n}\n.service .service-discount-info .service-discount-saved[data-v-9efbd8fc] {\n      font-size: 12px;\n      color: #fff;\n      background: #d55556;\n      padding: 2px 4px;\n      vertical-align: middle;\n      border-radius: 3px;\n}\n.service .service-discount-timer[data-v-9efbd8fc] {\n    margin-top: 15px;\n    color: #777;\n    text-align: right;\n}\n.service .service-discount-timer div[data-v-9efbd8fc] {\n      font-size: 13px;\n}\n.service .service-discount-timer .timer[data-v-9efbd8fc] {\n      font-size: 15px;\n}\n.service .eta[data-v-9efbd8fc] {\n    text-align: right;\n}\n.service .eta span[data-v-9efbd8fc] {\n      display: block;\n}\n.service .eta .minutes-away[data-v-9efbd8fc], .service .eta .no-cars[data-v-9efbd8fc] {\n      font-size: 13px;\n      color: #aaa;\n}\n.service .eta .suggested-pickup-time[data-v-9efbd8fc] {\n      font-size: 14px;\n      padding-top: 12px;\n}\n.service .eta .suggested-pickup-time.not-allowed[data-v-9efbd8fc] {\n        color: #ea4242;\n}\n.service .eta .suggested-pickup-time a[data-v-9efbd8fc] {\n        text-decoration: underline;\n        font-weight: 600;\n}\n.service .eta .suggested-pickup-time i[data-v-9efbd8fc] {\n        margin-left: 3px;\n        vertical-align: 1px;\n}\n.service .eta .dropoff-time[data-v-9efbd8fc] {\n      line-height: 1.1;\n      font-size: 14px;\n      color: #777;\n}\n.service .eta .no-cars[data-v-9efbd8fc] {\n      font-style: italic;\n}\n.service .mng[data-v-9efbd8fc] {\n    text-align: right;\n    font-size: 13px;\n    color: #ea5427;\n}\n.service .loader-box[data-v-9efbd8fc] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    background: rgba(0, 0, 0, 0);\n    -webkit-transition: all .3s ease-in;\n    transition: all .3s ease-in;\n}\n.service .loader-box.show[data-v-9efbd8fc] {\n      z-index: 3;\n      background: rgba(0, 0, 0, 0.4);\n}\n.service .loader-box .spinner-box[data-v-9efbd8fc] {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      margin-left: -18px;\n      margin-top: -18px;\n}\n.service .loader-box .fa-spinner[data-v-9efbd8fc] {\n      font-size: 36px;\n}\n.medium-below .icon-font[data-v-9efbd8fc], .medium-below .logo[data-v-9efbd8fc] {\n  text-align: center !important;\n}\n.medium-below.pricing[data-v-9efbd8fc] {\n  margin-bottom: 15px;\n}\n.medium-below.pricing .service-quote[data-v-9efbd8fc] {\n    padding: 0;\n}\n.medium-below.pricing .service-price[data-v-9efbd8fc] {\n    text-align: center;\n    line-height: 18px;\n    margin-bottom: 10px;\n    font-size: 28px;\n}\n.medium-below.pricing .service-price .shared-error[data-v-9efbd8fc] {\n      margin-top: 5px;\n}\n.medium-below.pricing .service-discount-timer[data-v-9efbd8fc] {\n    margin-top: 3px;\n    line-height: 10px;\n}\n.medium-below.pricing .service-discount-timer span[data-v-9efbd8fc] {\n      font-size: 12px !important;\n}\n.medium-below.pricing .service-discount-info[data-v-9efbd8fc], .medium-below.pricing .service-discount-timer[data-v-9efbd8fc] {\n    text-align: center;\n}\n.medium-below.service-desc-more[data-v-9efbd8fc] {\n  clear: both;\n}\n.medium-below .eta[data-v-9efbd8fc], .medium-below .mng[data-v-9efbd8fc] {\n  text-align: center;\n}\n.one-way-fare[data-v-9efbd8fc] {\n  font-size: 12px;\n  color: #999;\n}\n.margin-t-m[data-v-9efbd8fc] {\n  margin-top: 20px;\n}\n.margin-b-s[data-v-9efbd8fc] {\n  margin-bottom: 10px;\n}\n.margin-t-s[data-v-9efbd8fc] {\n  margin-top: 10px;\n}\nb[data-v-9efbd8fc] {\n  color: #353535;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"service-box"},[_c('div',{staticClass:"service row"},[_c('div',{staticClass:"column medium-2 service-img"},[_c('img',{attrs:{"src":_vm.details.image,"alt":"service img"}})]),_vm._v(" "),_c('div',{staticClass:"column medium-10 service-data-box"},[_c('div',{staticClass:"service-data"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"medium-9 column"},[_c('div',{staticClass:"service-max-paxluggage"},[_c('div',{staticClass:"pax-luggage"},[_vm._m(0),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.details.maxPassengers)+" max")])]),_vm._v(" "),_c('div',{staticClass:"pax-luggage"},[_vm._m(1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.details.maxLuggages)+" max")])]),_vm._v(" "),_c('div',{staticClass:"stairs-label"},[_vm._v("Pick Up: "+_vm._s(_vm.upDownstairs()))])]),_vm._v(" "),_c('div',{staticClass:"service-name"},[_vm._v("\n                "+_vm._s(_vm.details.name)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"break"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showDescription),expression:"!showDescription"}],staticClass:"service-desc-excerpt"},[_vm._v("\n                "+_vm._s(_vm.details.excerptWeb)+"\n              ")]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDescription),expression:"showDescription"}],staticClass:"service-desc"},[_c('div',{staticClass:"margin-b-s"},[_vm._v("\n                    "+_vm._s(_vm.details.descriptionWeb)+"\n                  ")]),_vm._v(" "),_c('div',[_c('b',[_vm._v("[Advantage]")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.details.advantageWeb))])]),_vm._v(" "),_c('div',{staticClass:"margin-t-s"},[_c('b',[_vm._v("[Stops]")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.details.stops))])])])]),_vm._v(" "),_c('div',{staticClass:"service-desc-more margin-t-s"},[_c('a',{on:{"click":function($event){_vm.showDescription = !_vm.showDescription}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showDescription),expression:"!showDescription"}]},[_vm._v("More Info")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDescription),expression:"showDescription"}]},[_vm._v("Hide Info")])])])],1),_vm._v(" "),_vm._m(2)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fa-stack"},[_c('i',{staticClass:"fas fa-circle fa-stack-2x"}),_vm._v(" "),_c('i',{staticClass:"fas fa-user fa-stack-1x fa-inverse"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fa-stack"},[_c('i',{staticClass:"fas fa-circle fa-stack-2x"}),_vm._v(" "),_c('i',{staticClass:"fas fa-suitcase fa-stack-1x fa-inverse"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"medium-3 column"},[_c('div',{staticClass:"service-quote"},[_c('div',{staticClass:"service-price"},[_vm._v("\n                  $88.00\n                  "),_c('div',{staticClass:"one-way-fare"},[_vm._v("\n                  One-way fare\n                  ")]),_vm._v(" "),_c('div',{staticClass:"eta margin-t-m"},[_c('div',[_c('span',{staticClass:"no-cars"},[_vm._v("Book in advance")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreviewMobile_vue__ = __webpack_require__(551);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b61214c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreviewMobile_vue__ = __webpack_require__(1584);
function injectStyle (ssrContext) {
  __webpack_require__(1582)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b61214c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreviewMobile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b61214c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreviewMobile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1583);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("776a3068", content, true, {});

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.services[data-v-b61214c2] {\n  padding: 10px 0;\n  position: relative;\n}\n.service-box[data-v-b61214c2] {\n  width: 370px;\n  margin: 0 auto;\n  position: relative;\n  overflow: hidden;\n  max-height: 999px;\n  padding: 10px 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #2c3e50;\n  font-family: Questrial,sans-serif;\n}\n.service[data-v-b61214c2] {\n  background-color: #d0d0d0;\n  border: 2px solid #ccc;\n  border-radius: 3px;\n  width: 100%;\n  display: block;\n  margin-right: 11px;\n  margin-bottom: 0 !important;\n  text-align: center;\n  padding: 0;\n  cursor: pointer;\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.service[data-v-b61214c2]:hover:not(.disabled), .service.active[data-v-b61214c2] {\n    border: 2px solid #13bcac;\n}\n.service.disabled[data-v-b61214c2] {\n    opacity: .65;\n    cursor: default;\n}\n.service.no-margin[data-v-b61214c2] {\n    margin-right: 0;\n}\n.service .service-img[data-v-b61214c2] {\n    position: relative;\n    top: 50%;\n    left: 0;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n    height: 150px;\n}\n.service .service-img img[data-v-b61214c2] {\n      max-width: 100%;\n      max-height: 150px;\n      position: relative;\n      top: 50%;\n}\n.service .service-data-box[data-v-b61214c2] {\n    background: #f6f6f6;\n}\n.service .service-data[data-v-b61214c2] {\n    width: 100%;\n    text-align: left;\n    padding: 15px;\n    position: relative;\n    z-index: 2;\n}\n.service .service-data .break[data-v-b61214c2] {\n      height: 24px;\n      width: 100%;\n      margin-bottom: 10px;\n}\n.service .service-max-paxluggage[data-v-b61214c2] {\n    font-size: 12px;\n    line-height: 12px;\n    margin-bottom: 20px;\n    text-align: center;\n}\n.service .service-max-paxluggage .pax-luggage[data-v-b61214c2] {\n      display: inline-block;\n      color: #838d98;\n      padding: 0 5px;\n}\n.service .service-max-paxluggage .stairs-label[data-v-b61214c2] {\n      display: inline-block;\n      padding: 3px 5px;\n      color: #838d98;\n      font-weight: 600;\n}\n.service .service-max-paxluggage .fa-stack[data-v-b61214c2] {\n      width: 2em;\n}\n.service .service-max-paxluggage .fa-stack i[data-v-b61214c2] {\n        width: 24px;\n}\n.service .service-name[data-v-b61214c2] {\n    font-size: 24px;\n    font-weight: 700;\n    margin-bottom: 5px;\n    line-height: 18px;\n    text-align: center;\n}\n.service .service-desc-excerpt[data-v-b61214c2], .service .service-desc[data-v-b61214c2] {\n    color: #838d98;\n    line-height: 125%;\n    margin-bottom: 7px;\n}\n.service .service-desc-more[data-v-b61214c2] {\n    font-size: 13px;\n    font-weight: 600;\n    color: #13bcac;\n    text-align: center;\n}\n.service .service-quote[data-v-b61214c2] {\n    padding: 0 10px;\n}\n.service .service-price[data-v-b61214c2] {\n    font-size: 28px;\n    font-weight: 700;\n    color: #13bcac;\n    line-height: 18px;\n    margin-bottom: 10px;\n    text-align: center;\n}\n.service .service-price .shared-error[data-v-b61214c2] {\n      font-size: 13px;\n      color: #ff4a4a;\n      line-height: 1.4;\n}\n.service .service-price .suggested-service[data-v-b61214c2] {\n      font-size: 14px;\n      color: #2c3e50;\n      line-height: 1.4;\n      margin-top: 10px;\n      cursor: pointer;\n      text-decoration: underline;\n}\n.service .service-discount-info[data-v-b61214c2] {\n    text-align: right;\n}\n.service .service-discount-info span[data-v-b61214c2] {\n      display: inline-block;\n}\n.service .service-discount-info .service-original-price[data-v-b61214c2] {\n      font-size: 18px;\n      margin-right: 5px;\n      position: relative;\n      color: #ccc;\n      vertical-align: middle;\n}\n.service .service-discount-info .service-original-price[data-v-b61214c2]:after {\n        content: '';\n        border-bottom: 1px solid rgba(255, 0, 0, 0.5);\n        position: absolute;\n        top: 50%;\n        left: 0;\n        width: 100%;\n}\n.service .service-discount-info .service-discount-saved[data-v-b61214c2] {\n      font-size: 12px;\n      color: #fff;\n      background: #d55556;\n      padding: 2px 4px;\n      vertical-align: middle;\n      border-radius: 3px;\n}\n.service .service-discount-timer[data-v-b61214c2] {\n    margin-top: 15px;\n    color: #777;\n    text-align: right;\n}\n.service .service-discount-timer div[data-v-b61214c2] {\n      font-size: 13px;\n}\n.service .service-discount-timer .timer[data-v-b61214c2] {\n      font-size: 15px;\n}\n.service .eta[data-v-b61214c2] {\n    text-align: right;\n}\n.service .eta span[data-v-b61214c2] {\n      display: block;\n}\n.service .eta .minutes-away[data-v-b61214c2], .service .eta .no-cars[data-v-b61214c2] {\n      font-size: 13px;\n      color: #aaa;\n}\n.service .eta .suggested-pickup-time[data-v-b61214c2] {\n      font-size: 14px;\n      padding-top: 12px;\n}\n.service .eta .suggested-pickup-time.not-allowed[data-v-b61214c2] {\n        color: #ea4242;\n}\n.service .eta .suggested-pickup-time a[data-v-b61214c2] {\n        text-decoration: underline;\n        font-weight: 600;\n}\n.service .eta .suggested-pickup-time i[data-v-b61214c2] {\n        margin-left: 3px;\n        vertical-align: 1px;\n}\n.service .eta .dropoff-time[data-v-b61214c2] {\n      line-height: 1.1;\n      font-size: 14px;\n      color: #777;\n}\n.service .eta .no-cars[data-v-b61214c2] {\n      font-style: italic;\n}\n.service .mng[data-v-b61214c2] {\n    text-align: right;\n    font-size: 13px;\n    color: #ea5427;\n}\n.service .loader-box[data-v-b61214c2] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    background: rgba(0, 0, 0, 0);\n    -webkit-transition: all .3s ease-in;\n    transition: all .3s ease-in;\n}\n.service .loader-box.show[data-v-b61214c2] {\n      z-index: 3;\n      background: rgba(0, 0, 0, 0.4);\n}\n.service .loader-box .spinner-box[data-v-b61214c2] {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      margin-left: -18px;\n      margin-top: -18px;\n}\n.service .loader-box .fa-spinner[data-v-b61214c2] {\n      font-size: 36px;\n}\n.medium-below .icon-font[data-v-b61214c2], .medium-below .logo[data-v-b61214c2] {\n  text-align: center !important;\n}\n.medium-below.pricing[data-v-b61214c2] {\n  margin-bottom: 15px;\n}\n.medium-below.pricing .service-quote[data-v-b61214c2] {\n    padding: 0;\n}\n.medium-below.pricing .service-price[data-v-b61214c2] {\n    text-align: center;\n    line-height: 18px;\n    margin-bottom: 10px;\n    font-size: 28px;\n}\n.medium-below.pricing .service-price .shared-error[data-v-b61214c2] {\n      margin-top: 5px;\n}\n.medium-below.pricing .service-discount-timer[data-v-b61214c2] {\n    margin-top: 3px;\n    line-height: 10px;\n}\n.medium-below.pricing .service-discount-timer span[data-v-b61214c2] {\n      font-size: 12px !important;\n}\n.medium-below.pricing .service-discount-info[data-v-b61214c2], .medium-below.pricing .service-discount-timer[data-v-b61214c2] {\n    text-align: center;\n}\n.medium-below.service-desc-more[data-v-b61214c2] {\n  clear: both;\n}\n.medium-below .eta[data-v-b61214c2], .medium-below .mng[data-v-b61214c2] {\n  text-align: center;\n}\n.one-way-fare[data-v-b61214c2] {\n  font-size: 12px;\n  color: #999;\n}\n.margin-t-m[data-v-b61214c2] {\n  margin-top: 20px;\n}\n.margin-b-s[data-v-b61214c2] {\n  margin-bottom: 10px;\n}\n.margin-t-s[data-v-b61214c2] {\n  margin-top: 10px;\n}\nb[data-v-b61214c2] {\n  color: #353535;\n}\n.btn-success[data-v-b61214c2] {\n  background: #3ac568;\n  border-color: #0f943b;\n  color: #fff !important;\n  width: 100%;\n  display: block;\n  text-align: center;\n  padding: 10px;\n  font-size: .8em;\n  border-radius: 4px;\n  border: 1px solid #b1b1b1;\n  outline: 0;\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n  -webkit-box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.15), 0 2px 5px rgba(0, 0, 0, 0.2);\n  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.15), 0 2px 5px rgba(0, 0, 0, 0.2);\n  cursor: pointer;\n  line-height: 1em;\n}\n.btn-success[data-v-b61214c2]:hover {\n  background: #23b051;\n  -webkit-box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.15);\n  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.15);\n}\n@media only screen and (max-width: 430px) {\n.service-box[data-v-b61214c2] {\n    width: 100%;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Services/PreviewMobile.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,mBAAmB;CACpB;AACD;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,mCAAmC;EACnC,eAAe;EACf,kCAAkC;CACnC;AACD;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,aAAa;IACb,gBAAgB;CACnB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,QAAQ;IACR,oCAAoC;YAC5B,4BAA4B;IACpC,cAAc;CACjB;AACD;MACM,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;MACnB,SAAS;CACd;AACD;IACI,oBAAoB;CACvB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,WAAW;CACd;AACD;MACM,aAAa;MACb,YAAY;MACZ,oBAAoB;CACzB;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,eAAe;MACf,eAAe;CACpB;AACD;MACM,sBAAsB;MACtB,iBAAiB;MACjB,eAAe;MACf,iBAAiB;CACtB;AACD;MACM,WAAW;CAChB;AACD;QACQ,YAAY;CACnB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;CACtB;AACD;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;CACtB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;CACtB;AACD;MACM,gBAAgB;MAChB,eAAe;MACf,iBAAiB;CACtB;AACD;MACM,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,iBAAiB;MACjB,gBAAgB;MAChB,2BAA2B;CAChC;AACD;IACI,kBAAkB;CACrB;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;MACnB,YAAY;MACZ,uBAAuB;CAC5B;AACD;QACQ,YAAY;QACZ,8CAA8C;QAC9C,mBAAmB;QACnB,SAAS;QACT,QAAQ;QACR,YAAY;CACnB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,oBAAoB;MACpB,iBAAiB;MACjB,uBAAuB;MACvB,mBAAmB;CACxB;AACD;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;CACrB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,gBAAgB;CACrB;AACD;IACI,kBAAkB;CACrB;AACD;MACM,eAAe;CACpB;AACD;MACM,gBAAgB;MAChB,YAAY;CACjB;AACD;MACM,gBAAgB;MAChB,kBAAkB;CACvB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,2BAA2B;QAC3B,iBAAiB;CACxB;AACD;QACQ,iBAAiB;QACjB,oBAAoB;CAC3B;AACD;MACM,iBAAiB;MACjB,gBAAgB;MAChB,YAAY;CACjB;AACD;MACM,mBAAmB;CACxB;AACD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;CAClB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,WAAW;IACX,6BAA6B;IAC7B,oCAAoC;IACpC,4BAA4B;CAC/B;AACD;MACM,WAAW;MACX,+BAA+B;CACpC;AACD;MACM,mBAAmB;MACnB,SAAS;MACT,UAAU;MACV,mBAAmB;MACnB,kBAAkB;CACvB;AACD;MACM,gBAAgB;CACrB;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,oBAAoB;CACrB;AACD;IACI,WAAW;CACd;AACD;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;MACM,gBAAgB;CACrB;AACD;IACI,gBAAgB;IAChB,kBAAkB;CACrB;AACD;MACM,2BAA2B;CAChC;AACD;IACI,mBAAmB;CACtB;AACD;EACE,YAAY;CACb;AACD;EACE,mBAAmB;CACpB;AACD;EACE,gBAAgB;EAChB,YAAY;CACb;AACD;EACE,iBAAiB;CAClB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,eAAe;CAChB;AACD;EACE,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;EACX,iCAAiC;EACjC,yBAAyB;EACzB,uFAAuF;EACvF,+EAA+E;EAC/E,gBAAgB;EAChB,iBAAiB;CAClB;AACD;EACE,oBAAoB;EACpB,yDAAyD;EACzD,iDAAiD;CAClD;AACD;AACA;IACI,YAAY;CACf;CACA","file":"PreviewMobile.vue","sourcesContent":["\n.services[data-v-b61214c2] {\n  padding: 10px 0;\n  position: relative;\n}\n.service-box[data-v-b61214c2] {\n  width: 370px;\n  margin: 0 auto;\n  position: relative;\n  overflow: hidden;\n  max-height: 999px;\n  padding: 10px 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #2c3e50;\n  font-family: Questrial,sans-serif;\n}\n.service[data-v-b61214c2] {\n  background-color: #d0d0d0;\n  border: 2px solid #ccc;\n  border-radius: 3px;\n  width: 100%;\n  display: block;\n  margin-right: 11px;\n  margin-bottom: 0 !important;\n  text-align: center;\n  padding: 0;\n  cursor: pointer;\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.service[data-v-b61214c2]:hover:not(.disabled), .service.active[data-v-b61214c2] {\n    border: 2px solid #13bcac;\n}\n.service.disabled[data-v-b61214c2] {\n    opacity: .65;\n    cursor: default;\n}\n.service.no-margin[data-v-b61214c2] {\n    margin-right: 0;\n}\n.service .service-img[data-v-b61214c2] {\n    position: relative;\n    top: 50%;\n    left: 0;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n    height: 150px;\n}\n.service .service-img img[data-v-b61214c2] {\n      max-width: 100%;\n      max-height: 150px;\n      position: relative;\n      top: 50%;\n}\n.service .service-data-box[data-v-b61214c2] {\n    background: #f6f6f6;\n}\n.service .service-data[data-v-b61214c2] {\n    width: 100%;\n    text-align: left;\n    padding: 15px;\n    position: relative;\n    z-index: 2;\n}\n.service .service-data .break[data-v-b61214c2] {\n      height: 24px;\n      width: 100%;\n      margin-bottom: 10px;\n}\n.service .service-max-paxluggage[data-v-b61214c2] {\n    font-size: 12px;\n    line-height: 12px;\n    margin-bottom: 20px;\n    text-align: center;\n}\n.service .service-max-paxluggage .pax-luggage[data-v-b61214c2] {\n      display: inline-block;\n      color: #838d98;\n      padding: 0 5px;\n}\n.service .service-max-paxluggage .stairs-label[data-v-b61214c2] {\n      display: inline-block;\n      padding: 3px 5px;\n      color: #838d98;\n      font-weight: 600;\n}\n.service .service-max-paxluggage .fa-stack[data-v-b61214c2] {\n      width: 2em;\n}\n.service .service-max-paxluggage .fa-stack i[data-v-b61214c2] {\n        width: 24px;\n}\n.service .service-name[data-v-b61214c2] {\n    font-size: 24px;\n    font-weight: 700;\n    margin-bottom: 5px;\n    line-height: 18px;\n    text-align: center;\n}\n.service .service-desc-excerpt[data-v-b61214c2], .service .service-desc[data-v-b61214c2] {\n    color: #838d98;\n    line-height: 125%;\n    margin-bottom: 7px;\n}\n.service .service-desc-more[data-v-b61214c2] {\n    font-size: 13px;\n    font-weight: 600;\n    color: #13bcac;\n    text-align: center;\n}\n.service .service-quote[data-v-b61214c2] {\n    padding: 0 10px;\n}\n.service .service-price[data-v-b61214c2] {\n    font-size: 28px;\n    font-weight: 700;\n    color: #13bcac;\n    line-height: 18px;\n    margin-bottom: 10px;\n    text-align: center;\n}\n.service .service-price .shared-error[data-v-b61214c2] {\n      font-size: 13px;\n      color: #ff4a4a;\n      line-height: 1.4;\n}\n.service .service-price .suggested-service[data-v-b61214c2] {\n      font-size: 14px;\n      color: #2c3e50;\n      line-height: 1.4;\n      margin-top: 10px;\n      cursor: pointer;\n      text-decoration: underline;\n}\n.service .service-discount-info[data-v-b61214c2] {\n    text-align: right;\n}\n.service .service-discount-info span[data-v-b61214c2] {\n      display: inline-block;\n}\n.service .service-discount-info .service-original-price[data-v-b61214c2] {\n      font-size: 18px;\n      margin-right: 5px;\n      position: relative;\n      color: #ccc;\n      vertical-align: middle;\n}\n.service .service-discount-info .service-original-price[data-v-b61214c2]:after {\n        content: '';\n        border-bottom: 1px solid rgba(255, 0, 0, 0.5);\n        position: absolute;\n        top: 50%;\n        left: 0;\n        width: 100%;\n}\n.service .service-discount-info .service-discount-saved[data-v-b61214c2] {\n      font-size: 12px;\n      color: #fff;\n      background: #d55556;\n      padding: 2px 4px;\n      vertical-align: middle;\n      border-radius: 3px;\n}\n.service .service-discount-timer[data-v-b61214c2] {\n    margin-top: 15px;\n    color: #777;\n    text-align: right;\n}\n.service .service-discount-timer div[data-v-b61214c2] {\n      font-size: 13px;\n}\n.service .service-discount-timer .timer[data-v-b61214c2] {\n      font-size: 15px;\n}\n.service .eta[data-v-b61214c2] {\n    text-align: right;\n}\n.service .eta span[data-v-b61214c2] {\n      display: block;\n}\n.service .eta .minutes-away[data-v-b61214c2], .service .eta .no-cars[data-v-b61214c2] {\n      font-size: 13px;\n      color: #aaa;\n}\n.service .eta .suggested-pickup-time[data-v-b61214c2] {\n      font-size: 14px;\n      padding-top: 12px;\n}\n.service .eta .suggested-pickup-time.not-allowed[data-v-b61214c2] {\n        color: #ea4242;\n}\n.service .eta .suggested-pickup-time a[data-v-b61214c2] {\n        text-decoration: underline;\n        font-weight: 600;\n}\n.service .eta .suggested-pickup-time i[data-v-b61214c2] {\n        margin-left: 3px;\n        vertical-align: 1px;\n}\n.service .eta .dropoff-time[data-v-b61214c2] {\n      line-height: 1.1;\n      font-size: 14px;\n      color: #777;\n}\n.service .eta .no-cars[data-v-b61214c2] {\n      font-style: italic;\n}\n.service .mng[data-v-b61214c2] {\n    text-align: right;\n    font-size: 13px;\n    color: #ea5427;\n}\n.service .loader-box[data-v-b61214c2] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    background: rgba(0, 0, 0, 0);\n    -webkit-transition: all .3s ease-in;\n    transition: all .3s ease-in;\n}\n.service .loader-box.show[data-v-b61214c2] {\n      z-index: 3;\n      background: rgba(0, 0, 0, 0.4);\n}\n.service .loader-box .spinner-box[data-v-b61214c2] {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      margin-left: -18px;\n      margin-top: -18px;\n}\n.service .loader-box .fa-spinner[data-v-b61214c2] {\n      font-size: 36px;\n}\n.medium-below .icon-font[data-v-b61214c2], .medium-below .logo[data-v-b61214c2] {\n  text-align: center !important;\n}\n.medium-below.pricing[data-v-b61214c2] {\n  margin-bottom: 15px;\n}\n.medium-below.pricing .service-quote[data-v-b61214c2] {\n    padding: 0;\n}\n.medium-below.pricing .service-price[data-v-b61214c2] {\n    text-align: center;\n    line-height: 18px;\n    margin-bottom: 10px;\n    font-size: 28px;\n}\n.medium-below.pricing .service-price .shared-error[data-v-b61214c2] {\n      margin-top: 5px;\n}\n.medium-below.pricing .service-discount-timer[data-v-b61214c2] {\n    margin-top: 3px;\n    line-height: 10px;\n}\n.medium-below.pricing .service-discount-timer span[data-v-b61214c2] {\n      font-size: 12px !important;\n}\n.medium-below.pricing .service-discount-info[data-v-b61214c2], .medium-below.pricing .service-discount-timer[data-v-b61214c2] {\n    text-align: center;\n}\n.medium-below.service-desc-more[data-v-b61214c2] {\n  clear: both;\n}\n.medium-below .eta[data-v-b61214c2], .medium-below .mng[data-v-b61214c2] {\n  text-align: center;\n}\n.one-way-fare[data-v-b61214c2] {\n  font-size: 12px;\n  color: #999;\n}\n.margin-t-m[data-v-b61214c2] {\n  margin-top: 20px;\n}\n.margin-b-s[data-v-b61214c2] {\n  margin-bottom: 10px;\n}\n.margin-t-s[data-v-b61214c2] {\n  margin-top: 10px;\n}\nb[data-v-b61214c2] {\n  color: #353535;\n}\n.btn-success[data-v-b61214c2] {\n  background: #3ac568;\n  border-color: #0f943b;\n  color: #fff !important;\n  width: 100%;\n  display: block;\n  text-align: center;\n  padding: 10px;\n  font-size: .8em;\n  border-radius: 4px;\n  border: 1px solid #b1b1b1;\n  outline: 0;\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n  -webkit-box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.15), 0 2px 5px rgba(0, 0, 0, 0.2);\n  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.15), 0 2px 5px rgba(0, 0, 0, 0.2);\n  cursor: pointer;\n  line-height: 1em;\n}\n.btn-success[data-v-b61214c2]:hover {\n  background: #23b051;\n  -webkit-box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.15);\n  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.15);\n}\n@media only screen and (max-width: 430px) {\n.service-box[data-v-b61214c2] {\n    width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"service-box"},[_c('div',{staticClass:"service"},[_c('div',{staticClass:"service-img"},[_c('img',{attrs:{"src":_vm.details.image,"alt":"service img"}})]),_vm._v(" "),_c('div',{staticClass:"service-data-box"},[_c('div',{staticClass:"service-data"},[_c('div',[_c('div',[_c('div',{staticClass:"service-max-paxluggage"},[_c('div',{staticClass:"pax-luggage"},[_vm._m(0),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.details.maxPassengers)+" max")])]),_vm._v(" "),_c('div',{staticClass:"pax-luggage"},[_vm._m(1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.details.maxLuggages)+" max")])]),_vm._v(" "),_c('div',{staticClass:"stairs-label"},[_vm._v("Pick Up: "+_vm._s(_vm.upDownstairs()))])]),_vm._v(" "),_c('div',{staticClass:"service-name"},[_vm._v("\n                "+_vm._s(_vm.details.name)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"break"}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDescription),expression:"showDescription"}],staticClass:"service-desc"},[_c('div',{staticClass:"margin-b-s"},[_vm._v("\n                    "+_vm._s(_vm.details.descriptionWeb)+"\n                  ")]),_vm._v(" "),_c('div',[_c('b',[_vm._v("[Advantage]")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.details.advantageWeb))])]),_vm._v(" "),_c('div',{staticClass:"margin-t-s"},[_c('b',[_vm._v("[Stops]")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.details.stops))])])])])],1),_vm._v(" "),_c('div',{staticClass:"service-desc-more margin-t-s"},[_c('a',{staticClass:"btn-success",on:{"click":function($event){_vm.showDescription = !_vm.showDescription}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showDescription),expression:"!showDescription"}]},[_vm._v("More Info")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDescription),expression:"showDescription"}]},[_vm._v("Hide Info")])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fa-stack"},[_c('i',{staticClass:"fas fa-circle fa-stack-2x"}),_vm._v(" "),_c('i',{staticClass:"fas fa-user fa-stack-1x fa-inverse"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fa-stack"},[_c('i',{staticClass:"fas fa-circle fa-stack-2x"}),_vm._v(" "),_c('i',{staticClass:"fas fa-suitcase fa-stack-1x fa-inverse"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service-quote"},[_c('div',{staticClass:"service-price"},[_vm._v("\n                  $88.00\n                  "),_c('div',{staticClass:"one-way-fare"},[_vm._v("\n                  One-way fare\n                  ")]),_vm._v(" "),_c('div',{staticClass:"eta margin-t-m margin-b-m"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('span',{staticClass:"no-cars"},[_vm._v("Book in advance")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreviewConsumer_vue__ = __webpack_require__(552);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a5033be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreviewConsumer_vue__ = __webpack_require__(1588);
function injectStyle (ssrContext) {
  __webpack_require__(1586)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a5033be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreviewConsumer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a5033be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreviewConsumer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1587);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0e2713dc", content, true, {});

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.preview-consumer[data-v-6a5033be] {\n  margin-top: 15px;\n}\n.preview-consumer .collapsed-preview[data-v-6a5033be] {\n    position: relative;\n    display: inline-block;\n}\n.preview-consumer .collapsed-preview .bg-image[data-v-6a5033be] {\n      width: 300px;\n      display: block;\n}\n.preview-consumer .collapsed-preview .map-image[data-v-6a5033be] {\n      position: absolute;\n      top: 76px;\n      left: 22px;\n      width: 259px;\n      height: 461px;\n}\n.preview-consumer .collapsed-preview .collapsed[data-v-6a5033be] {\n      position: absolute;\n      bottom: 125px;\n      left: 32px;\n      width: 239px;\n      border-radius: 7px;\n      background-color: #fff;\n      display: block;\n      text-align: center;\n      -webkit-transition: all 350ms ease;\n      transition: all 350ms ease;\n      padding: 4px;\n      background-color: #fff;\n      -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);\n              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);\n      background-color: #009688 !important;\n      color: #777;\n      margin-bottom: 5px;\n}\n.preview-consumer .collapsed-preview .collapsed .service-background[data-v-6a5033be] {\n        position: relative;\n        background-color: #fff;\n        border-radius: 4px;\n        padding: 6px;\n}\n.preview-consumer .collapsed-preview .collapsed .service-background .icon[data-v-6a5033be] {\n          position: relative;\n          width: 50px !important;\n          height: 50px !important;\n          margin-bottom: 5px !important;\n}\n.preview-consumer .collapsed-preview .collapsed .service-background .icon img[data-v-6a5033be] {\n            position: absolute;\n            top: 0;\n            left: 0;\n            height: 50px !important;\n}\n.preview-consumer .collapsed-preview .collapsed .service-background .name[data-v-6a5033be] {\n          position: absolute;\n          font-weight: 700;\n          color: #009688 !important;\n          left: 62px !important;\n          top: 2px !important;\n          font-size: 13px !important;\n}\n.preview-consumer .collapsed-preview .collapsed .service-background .short-desc[data-v-6a5033be] {\n          position: absolute;\n          font-weight: 300;\n          left: 62px !important;\n          top: 16px !important;\n          font-size: 12px !important;\n}\n.preview-consumer .collapsed-preview .collapsed .service-background .ammenities[data-v-6a5033be] {\n          position: absolute;\n          font-weight: 400;\n          left: 62px !important;\n          top: 31px !important;\n          font-size: 9px !important;\n}\n.preview-consumer .collapsed-preview .collapsed .service-background .ammenities span[data-v-6a5033be] {\n            margin-right: 5px;\n            display: inline-block;\n}\n.preview-consumer .collapsed-preview .collapsed .service-background .price[data-v-6a5033be] {\n          position: absolute;\n          font-weight: 900;\n          color: #333;\n          text-align: right;\n          right: 10px;\n          top: 14px !important;\n          font-size: 15px !important;\n          color: #009688;\n}\n.preview-consumer .expanded-preview[data-v-6a5033be] {\n    position: relative;\n    display: inline-block;\n}\n.preview-consumer .expanded-preview .bg-image[data-v-6a5033be] {\n      width: 300px;\n      display: block;\n}\n.preview-consumer .expanded-preview .map-image[data-v-6a5033be] {\n      position: absolute;\n      top: 76px;\n      left: 22px;\n      width: 259px;\n      height: 461px;\n}\n.preview-consumer .expanded-preview .expanded[data-v-6a5033be] {\n      position: absolute;\n      top: 190px;\n      left: 22px;\n      background-color: #fff;\n      text-align: center;\n      padding-bottom: 60px;\n      border: 1px solid #ccc;\n      width: 260px;\n      margin: 0% auto;\n      font-family: 'Work Sans', sans-serif;\n      color: #1f1f21;\n      height: 348px;\n      overflow-y: auto;\n}\n.preview-consumer .expanded-preview .expanded .car[data-v-6a5033be] {\n        margin: 20px 0 20px;\n        width: 30%;\n}\n.preview-consumer .expanded-preview .expanded .service-selected[data-v-6a5033be] {\n        display: block;\n        position: relative;\n        bottom: 10px;\n}\n.preview-consumer .expanded-preview .expanded .title[data-v-6a5033be] {\n        font-size: 18px;\n        padding: 0 5px;\n        margin-bottom: 20px;\n        font-weight: 600;\n}\n.preview-consumer .expanded-preview .expanded .pax-luggage[data-v-6a5033be] {\n        margin-bottom: 20px;\n        padding: 0 10px;\n        display: -moz-flex;\n        display: -ms-flexbox;\n        display: -webkit-box;\n        display: flex;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        width: 100%;\n        -webkit-box-sizing: border-box;\n                box-sizing: border-box;\n}\n.preview-consumer .expanded-preview .expanded .pax-luggage .col[data-v-6a5033be] {\n          -webkit-box-flex: 1;\n          -moz-flex: 1;\n          -ms-flex: 1;\n          flex: 1;\n          display: block;\n          width: 100%;\n          -webkit-box-sizing: border-box;\n                  box-sizing: border-box;\n}\n.preview-consumer .expanded-preview .expanded .pax-luggage .col div[data-v-6a5033be] {\n            display: inline-block;\n            text-align: left;\n            margin-left: 5px;\n}\n.preview-consumer .expanded-preview .expanded .pax-luggage .col div .label[data-v-6a5033be] {\n              font-size: 13px;\n              display: block;\n}\n.preview-consumer .expanded-preview .expanded .description[data-v-6a5033be] {\n        text-align: left;\n        font-size: 14px;\n        line-height: 150%;\n        padding: 0 15px;\n        margin-bottom: 20px;\n}\n.preview-consumer .expanded-preview .expanded .advance[data-v-6a5033be] {\n        text-align: left;\n        font-size: 14px;\n        line-height: 150%;\n        padding: 0 15px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Services/PreviewConsumer.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;CAClB;AACD;IACI,mBAAmB;IACnB,sBAAsB;CACzB;AACD;MACM,aAAa;MACb,eAAe;CACpB;AACD;MACM,mBAAmB;MACnB,UAAU;MACV,WAAW;MACX,aAAa;MACb,cAAc;CACnB;AACD;MACM,mBAAmB;MACnB,cAAc;MACd,WAAW;MACX,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,eAAe;MACf,mBAAmB;MACnB,mCAAmC;MACnC,2BAA2B;MAC3B,aAAa;MACb,uBAAuB;MACvB,kDAAkD;cAC1C,0CAA0C;MAClD,qCAAqC;MACrC,YAAY;MACZ,mBAAmB;CACxB;AACD;QACQ,mBAAmB;QACnB,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;CACpB;AACD;UACU,mBAAmB;UACnB,uBAAuB;UACvB,wBAAwB;UACxB,8BAA8B;CACvC;AACD;YACY,mBAAmB;YACnB,OAAO;YACP,QAAQ;YACR,wBAAwB;CACnC;AACD;UACU,mBAAmB;UACnB,iBAAiB;UACjB,0BAA0B;UAC1B,sBAAsB;UACtB,oBAAoB;UACpB,2BAA2B;CACpC;AACD;UACU,mBAAmB;UACnB,iBAAiB;UACjB,sBAAsB;UACtB,qBAAqB;UACrB,2BAA2B;CACpC;AACD;UACU,mBAAmB;UACnB,iBAAiB;UACjB,sBAAsB;UACtB,qBAAqB;UACrB,0BAA0B;CACnC;AACD;YACY,kBAAkB;YAClB,sBAAsB;CACjC;AACD;UACU,mBAAmB;UACnB,iBAAiB;UACjB,YAAY;UACZ,kBAAkB;UAClB,YAAY;UACZ,qBAAqB;UACrB,2BAA2B;UAC3B,eAAe;CACxB;AACD;IACI,mBAAmB;IACnB,sBAAsB;CACzB;AACD;MACM,aAAa;MACb,eAAe;CACpB;AACD;MACM,mBAAmB;MACnB,UAAU;MACV,WAAW;MACX,aAAa;MACb,cAAc;CACnB;AACD;MACM,mBAAmB;MACnB,WAAW;MACX,WAAW;MACX,uBAAuB;MACvB,mBAAmB;MACnB,qBAAqB;MACrB,uBAAuB;MACvB,aAAa;MACb,gBAAgB;MAChB,qCAAqC;MACrC,eAAe;MACf,cAAc;MACd,iBAAiB;CACtB;AACD;QACQ,oBAAoB;QACpB,WAAW;CAClB;AACD;QACQ,eAAe;QACf,mBAAmB;QACnB,aAAa;CACpB;AACD;QACQ,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,iBAAiB;CACxB;AACD;QACQ,oBAAoB;QACpB,gBAAgB;QAChB,mBAAmB;QACnB,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,oBAAoB;YAChB,gBAAgB;QACpB,YAAY;QACZ,+BAA+B;gBACvB,uBAAuB;CACtC;AACD;UACU,oBAAoB;UACpB,aAAa;UACb,YAAY;UACZ,QAAQ;UACR,eAAe;UACf,YAAY;UACZ,+BAA+B;kBACvB,uBAAuB;CACxC;AACD;YACY,sBAAsB;YACtB,iBAAiB;YACjB,iBAAiB;CAC5B;AACD;cACc,gBAAgB;cAChB,eAAe;CAC5B;AACD;QACQ,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;QAClB,gBAAgB;QAChB,oBAAoB;CAC3B;AACD;QACQ,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;QAClB,gBAAgB;CACvB","file":"PreviewConsumer.vue","sourcesContent":["\n.preview-consumer[data-v-6a5033be] {\n  margin-top: 15px;\n}\n.preview-consumer .collapsed-preview[data-v-6a5033be] {\n    position: relative;\n    display: inline-block;\n}\n.preview-consumer .collapsed-preview .bg-image[data-v-6a5033be] {\n      width: 300px;\n      display: block;\n}\n.preview-consumer .collapsed-preview .map-image[data-v-6a5033be] {\n      position: absolute;\n      top: 76px;\n      left: 22px;\n      width: 259px;\n      height: 461px;\n}\n.preview-consumer .collapsed-preview .collapsed[data-v-6a5033be] {\n      position: absolute;\n      bottom: 125px;\n      left: 32px;\n      width: 239px;\n      border-radius: 7px;\n      background-color: #fff;\n      display: block;\n      text-align: center;\n      -webkit-transition: all 350ms ease;\n      transition: all 350ms ease;\n      padding: 4px;\n      background-color: #fff;\n      -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);\n              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);\n      background-color: #009688 !important;\n      color: #777;\n      margin-bottom: 5px;\n}\n.preview-consumer .collapsed-preview .collapsed .service-background[data-v-6a5033be] {\n        position: relative;\n        background-color: #fff;\n        border-radius: 4px;\n        padding: 6px;\n}\n.preview-consumer .collapsed-preview .collapsed .service-background .icon[data-v-6a5033be] {\n          position: relative;\n          width: 50px !important;\n          height: 50px !important;\n          margin-bottom: 5px !important;\n}\n.preview-consumer .collapsed-preview .collapsed .service-background .icon img[data-v-6a5033be] {\n            position: absolute;\n            top: 0;\n            left: 0;\n            height: 50px !important;\n}\n.preview-consumer .collapsed-preview .collapsed .service-background .name[data-v-6a5033be] {\n          position: absolute;\n          font-weight: 700;\n          color: #009688 !important;\n          left: 62px !important;\n          top: 2px !important;\n          font-size: 13px !important;\n}\n.preview-consumer .collapsed-preview .collapsed .service-background .short-desc[data-v-6a5033be] {\n          position: absolute;\n          font-weight: 300;\n          left: 62px !important;\n          top: 16px !important;\n          font-size: 12px !important;\n}\n.preview-consumer .collapsed-preview .collapsed .service-background .ammenities[data-v-6a5033be] {\n          position: absolute;\n          font-weight: 400;\n          left: 62px !important;\n          top: 31px !important;\n          font-size: 9px !important;\n}\n.preview-consumer .collapsed-preview .collapsed .service-background .ammenities span[data-v-6a5033be] {\n            margin-right: 5px;\n            display: inline-block;\n}\n.preview-consumer .collapsed-preview .collapsed .service-background .price[data-v-6a5033be] {\n          position: absolute;\n          font-weight: 900;\n          color: #333;\n          text-align: right;\n          right: 10px;\n          top: 14px !important;\n          font-size: 15px !important;\n          color: #009688;\n}\n.preview-consumer .expanded-preview[data-v-6a5033be] {\n    position: relative;\n    display: inline-block;\n}\n.preview-consumer .expanded-preview .bg-image[data-v-6a5033be] {\n      width: 300px;\n      display: block;\n}\n.preview-consumer .expanded-preview .map-image[data-v-6a5033be] {\n      position: absolute;\n      top: 76px;\n      left: 22px;\n      width: 259px;\n      height: 461px;\n}\n.preview-consumer .expanded-preview .expanded[data-v-6a5033be] {\n      position: absolute;\n      top: 190px;\n      left: 22px;\n      background-color: #fff;\n      text-align: center;\n      padding-bottom: 60px;\n      border: 1px solid #ccc;\n      width: 260px;\n      margin: 0% auto;\n      font-family: 'Work Sans', sans-serif;\n      color: #1f1f21;\n      height: 348px;\n      overflow-y: auto;\n}\n.preview-consumer .expanded-preview .expanded .car[data-v-6a5033be] {\n        margin: 20px 0 20px;\n        width: 30%;\n}\n.preview-consumer .expanded-preview .expanded .service-selected[data-v-6a5033be] {\n        display: block;\n        position: relative;\n        bottom: 10px;\n}\n.preview-consumer .expanded-preview .expanded .title[data-v-6a5033be] {\n        font-size: 18px;\n        padding: 0 5px;\n        margin-bottom: 20px;\n        font-weight: 600;\n}\n.preview-consumer .expanded-preview .expanded .pax-luggage[data-v-6a5033be] {\n        margin-bottom: 20px;\n        padding: 0 10px;\n        display: -moz-flex;\n        display: -ms-flexbox;\n        display: -webkit-box;\n        display: flex;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        width: 100%;\n        -webkit-box-sizing: border-box;\n                box-sizing: border-box;\n}\n.preview-consumer .expanded-preview .expanded .pax-luggage .col[data-v-6a5033be] {\n          -webkit-box-flex: 1;\n          -moz-flex: 1;\n          -ms-flex: 1;\n          flex: 1;\n          display: block;\n          width: 100%;\n          -webkit-box-sizing: border-box;\n                  box-sizing: border-box;\n}\n.preview-consumer .expanded-preview .expanded .pax-luggage .col div[data-v-6a5033be] {\n            display: inline-block;\n            text-align: left;\n            margin-left: 5px;\n}\n.preview-consumer .expanded-preview .expanded .pax-luggage .col div .label[data-v-6a5033be] {\n              font-size: 13px;\n              display: block;\n}\n.preview-consumer .expanded-preview .expanded .description[data-v-6a5033be] {\n        text-align: left;\n        font-size: 14px;\n        line-height: 150%;\n        padding: 0 15px;\n        margin-bottom: 20px;\n}\n.preview-consumer .expanded-preview .expanded .advance[data-v-6a5033be] {\n        text-align: left;\n        font-size: 14px;\n        line-height: 150%;\n        padding: 0 15px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-consumer"},[_c('div',{staticClass:"collapsed-preview"},[_c('img',{staticClass:"bg-image",attrs:{"src":"/assets/img/iphone_6.png"}}),_vm._v(" "),_c('img',{staticClass:"map-image",attrs:{"src":"/assets/img/map.png"}}),_vm._v(" "),_c('div',{staticClass:"collapsed"},[_c('div',{staticClass:"service-background"},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":_vm.details.image,"alt":"service img"}})]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.details.name))]),_vm._v(" "),_c('div',{staticClass:"short-desc"},[_vm._v(_vm._s(_vm.details.excerptApp))]),_vm._v(" "),_c('div',{staticClass:"ammenities"},[_c('i',{staticClass:"fas fa-user"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.details.maxPassengers)+" max")]),_vm._v(" "),_c('i',{staticClass:"fas fa-briefcase"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.details.maxLuggages)+" max")])]),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('div',{staticClass:"expanded-preview"},[_c('img',{staticClass:"bg-image",attrs:{"src":"/assets/img/iphone_6.png"}}),_vm._v(" "),_c('img',{staticClass:"map-image",attrs:{"src":"/assets/img/map.png"}}),_vm._v(" "),_c('div',{staticClass:"expanded"},[_c('img',{staticClass:"car",attrs:{"src":_vm.details.image,"alt":"service img"}}),_vm._v(" "),_c('div',{staticClass:"service-selected"},[_vm._v(_vm._s(_vm.details.name))]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.details.slogan))]),_vm._v(" "),_c('div',{staticClass:"row pax-luggage"},[_c('div',{staticClass:"col"},[_c('i',{staticClass:"fas fa-user fa-2x"}),_vm._v(" "),_c('div',[_c('span',{staticClass:"label"},[_vm._v("Passenger")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.details.maxPassengers)+" max")])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('i',{staticClass:"fas fa-briefcase fa-2x"}),_vm._v(" "),_c('div',[_c('span',{staticClass:"label"},[_vm._v("Luggage")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.details.maxLuggages)+" max")])])])]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("\n          "+_vm._s(_vm.details.descriptionApp)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"advance"},[_c('i',[_vm._v(_vm._s(_vm.details.advantageApp))])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"price"},[_c('span',{staticClass:"value"},[_vm._v("$10.00")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'op--modal-container':true, 'hide': !_vm.preview},on:{"click":_vm.close}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content preview-box",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"preview web"},[_c('div',{staticClass:"label"},[_vm._v("Web")]),_vm._v(" "),_c('preview-web',{attrs:{"details":_vm.details}})],1),_vm._v(" "),_c('div',{staticClass:"preview"},[_c('div',{staticClass:"label"},[_vm._v("Web - Mobile")]),_vm._v(" "),_c('preview-mobile',{attrs:{"details":_vm.details}})],1),_vm._v(" "),_c('div',{staticClass:"preview"},[_c('div',{staticClass:"label"},[_vm._v("Consumer App")]),_vm._v(" "),_c('preview-consumer',{attrs:{"details":_vm.details}})],1),_vm._v(" "),_c('div',{staticClass:"fixed-bottom"},[_c('div',[_c('a',{staticClass:"button cta small",on:{"click":_vm.close}},[_c('i',{staticClass:"fas fa-ban"}),_vm._v(" Close Preview\n            ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceDetails_vue__ = __webpack_require__(553);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52a1522a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceDetails_vue__ = __webpack_require__(1593);
function injectStyle (ssrContext) {
  __webpack_require__(1591)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52a1522a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52a1522a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1592);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0aea08fa", content, true, {});

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.m-T-20[data-v-52a1522a] {\n  margin-top: 20px;\n}\n.m-B-10[data-v-52a1522a] {\n  margin-bottom: 10px;\n}\n.p-L-10[data-v-52a1522a] {\n  padding-left: 10px;\n}\n.p-R-10[data-v-52a1522a] {\n  padding-right: 10px;\n}\n.row[data-v-52a1522a] {\n  max-width: 100%;\n}\n.box[data-v-52a1522a] {\n  background: #fff;\n  border-radius: 2px;\n  border: 1px solid #b0c6e4;\n  padding: 15px;\n  -webkit-box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n          box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n  margin-bottom: 10px;\n}\n.box .top-line[data-v-52a1522a] {\n    border-top: 1px solid #b0c6e4;\n    padding-top: 10px;\n}\n.box .box-header[data-v-52a1522a] {\n    font-size: 21px;\n    font-weight: 600;\n    color: #555;\n    margin-bottom: 10px;\n}\n.box input[data-v-52a1522a] {\n    display: inline-block;\n    width: inherit;\n}\n.box .service-unavailable-options[data-v-52a1522a] {\n    gap: 20px;\n    margin: 20px 0;\n}\n.box .service-unavailable-options label[data-v-52a1522a] {\n      color: #0D79F2;\n      font-weight: 600;\n      font-size: 11px;\n      text-transform: uppercase;\n      line-height: 130%;\n      letter-spacing: .4px;\n}\n.box .service-unavailable-options label input[data-v-52a1522a] {\n        vertical-align: -2px;\n        margin: 0 3px 0 0;\n}\n.box .time-select[data-v-52a1522a] {\n    width: 100px;\n    margin-top: 0;\n}\n.box .button.smaller[data-v-52a1522a] {\n    padding: 12px 20px 4px;\n}\n.data-field[data-v-52a1522a] {\n  padding: 0 5px;\n  position: relative;\n}\n.data-field.no-label[data-v-52a1522a] {\n    padding-top: 24px;\n}\n.data-field input[type='checkbox'][data-v-52a1522a], .data-field input[type='radio'][data-v-52a1522a] {\n    width: inherit;\n    display: inline-block;\n    margin: 0 3px 0 0;\n}\n.data-field.check-item label[data-v-52a1522a] {\n    height: 25px;\n    display: block;\n}\n.data-field.check-item label.disabled[data-v-52a1522a] {\n      color: #89a2be;\n}\n.data-field.optin-discount[data-v-52a1522a] {\n    padding-left: 24px;\n}\n.data-field.optin-discount .label[data-v-52a1522a] {\n      color: #445568;\n}\n.data-field .label[data-v-52a1522a] {\n    color: #0D79F2;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .label.bigger[data-v-52a1522a] {\n      font-size: 14px;\n}\n.data-field .label input[type='checkbox'][data-v-52a1522a] {\n      vertical-align: -2px;\n}\n.data-field .note[data-v-52a1522a] {\n    font-size: 12.5px;\n    color: #999;\n    display: block;\n}\n.data-field .input[data-v-52a1522a] {\n    margin: 3px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-52a1522a] {\n      border-color: #f20d0d;\n}\n.data-field textarea[data-v-52a1522a] {\n    resize: vertical;\n    margin: 3px 0 0;\n}\n.data-field .check-option[data-v-52a1522a] {\n    font-size: 14px;\n    cursor: pointer;\n    display: block;\n}\n.data-field .check-option input[data-v-52a1522a] {\n      vertical-align: -1px;\n}\n.data-field .radio-option[data-v-52a1522a] {\n    font-size: 14px;\n    cursor: pointer;\n    display: block;\n    margin: 5px 0;\n}\n.data-field .radio-option input[data-v-52a1522a] {\n      vertical-align: -1px;\n}\n.data-field .sub-val[data-v-52a1522a] {\n    margin: 0 0 20px 20px;\n    line-height: 1;\n    padding: 5px;\n    font-size: 13px;\n    width: calc(100% - 20px);\n}\n.data-field .has-error[data-v-52a1522a] {\n    border-color: #f20d0d;\n}\n.data-field .error-msg[data-v-52a1522a] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\nselect[data-v-52a1522a] {\n  margin-top: 5px;\n  border: 1px solid #ddd;\n  padding: 10px;\n  color: #333;\n  height: 45px;\n  position: relative;\n  font-size: 14px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n  -webkit-transition: all .35s ease;\n  transition: all .35s ease;\n}\nselect.has-error[data-v-52a1522a] {\n    border-color: #f20d0d;\n}\nselect[data-v-52a1522a]:disabled {\n    background-color: #eee;\n}\n.required[data-v-52a1522a] {\n  color: #f00;\n  font-weight: 600;\n  margin-left: 2px;\n}\n.tip-input[data-v-52a1522a] {\n  position: relative;\n}\n.tip-input span[data-v-52a1522a] {\n    position: absolute;\n    top: 0;\n    left: 10px;\n    z-index: 2;\n    line-height: 44px;\n    font-weight: 600;\n    color: #888;\n}\n.tip-input input[data-v-52a1522a] {\n    padding-left: 30px;\n}\n.input-integer[data-v-52a1522a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.input-integer > *[data-v-52a1522a] {\n    display: inline-block;\n    vertical-align: middle;\n    margin-top: 0;\n}\n.input-integer input[type=\"number\"][data-v-52a1522a] {\n    font-size: 16px;\n    padding: 10px;\n    display: inline-block;\n    width: 100%;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n.input-integer span[data-v-52a1522a] {\n    font-size: 13px;\n    background-color: #555;\n    color: #fff;\n    padding: 10px;\n    margin-left: -5px;\n    border-top-right-radius: 3px;\n    border-bottom-right-radius: 3px;\n    line-height: 24px;\n}\n.service-types[data-v-52a1522a] {\n  background: #fafafa;\n  padding: 10px;\n  margin-top: 5px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n}\n.brand-box[data-v-52a1522a] {\n  background: #fff;\n  margin: 20px 0;\n  -webkit-box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2);\n          box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2);\n  border: 1px solid #b0c6e4;\n}\n.brand-box .body[data-v-52a1522a] {\n    padding: 20px;\n}\n.brand-box .img-upload[data-v-52a1522a] {\n    text-align: center;\n    padding: 20px;\n}\n.brand-box .img-upload .inactive-image[data-v-52a1522a] {\n      margin-top: 30px;\n}\n.brand-box .img-upload .data-field[data-v-52a1522a] {\n      padding: 0 0 5px;\n}\n.brand-box .img-upload .label[data-v-52a1522a] {\n      text-align: left;\n}\n.brand-box .img-upload .img-box[data-v-52a1522a] {\n      background: #fafafa;\n      border: 1px solid #555;\n      margin-bottom: 28px;\n      cursor: pointer;\n      position: relative;\n      text-align: center;\n}\n.brand-box .img-upload .img-box.loading .fa-image[data-v-52a1522a], .brand-box .img-upload .img-box.loading img[data-v-52a1522a] {\n        opacity: .4;\n}\n.brand-box .img-upload .img-box img[data-v-52a1522a] {\n        width: 90%;\n}\n.brand-box .img-upload .img-box .recommened[data-v-52a1522a] {\n        position: absolute;\n        top: 100%;\n        left: -1px;\n        width: calc(100% + 2px);\n        font-size: 13px;\n        font-weight: 600;\n        line-height: 25px;\n        background: #555;\n        border: 1px solid #555;\n        color: #fff;\n}\n.brand-box .img-upload .img-box.has-error[data-v-52a1522a] {\n        border-color: #f20d0d;\n}\n.brand-box .img-upload .img-box.has-error .recommened[data-v-52a1522a] {\n          border-color: #f20d0d;\n          background: #f20d0d;\n}\n.brand-box .img-upload .fa-image[data-v-52a1522a] {\n      font-size: 120px;\n      color: #becfd3;\n      line-height: 100px;\n      margin: 10px 0;\n}\n.brand-box .img-upload .loader[data-v-52a1522a] {\n      position: absolute;\n      top: 50%;\n      left: 0;\n      width: 100%;\n      font-size: 14px;\n      font-weight: 600;\n      color: #333;\n      margin-top: -10px;\n}\n.brand-box .img-upload .loader i[data-v-52a1522a] {\n        font-size: 21px;\n        margin-right: 5px;\n        vertical-align: middle;\n}\n.brand-box .img-upload .error-msg[data-v-52a1522a] {\n      font-size: 13px;\n      line-height: 1.6;\n      color: #f20d0d;\n      font-style: italic;\n      display: block;\n}\n.brand-box .img-upload .button[data-v-52a1522a] {\n      max-width: 400px;\n      margin-top: 15px;\n}\n.brand-box .sub-box[data-v-52a1522a] {\n    border: 1px solid #ccc;\n    margin: 0 5px 10px;\n    padding: 15px;\n    background: #fafafa;\n}\n.brand-box .sub-box .heading[data-v-52a1522a] {\n      padding: 0 5px;\n      font-size: 21px;\n      font-weight: 600;\n      color: #555;\n}\n.palette[data-v-52a1522a] {\n  position: absolute;\n  top: 30px;\n  right: 14px;\n  width: 20px;\n  height: 20px;\n  border-radius: 100%;\n  border: 1px solid #333;\n}\n.color-picker[data-v-52a1522a] {\n  position: absolute;\n  top: 100%;\n  z-index: 3;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.color-picker.right[data-v-52a1522a] {\n    right: 0;\n}\n.color-picker.left[data-v-52a1522a] {\n    left: 0;\n}\n.slide-down-enter-active[data-v-52a1522a], .slide-down-leave-active[data-v-52a1522a] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-52a1522a], .slide-down-leave-to[data-v-52a1522a] {\n  -webkit-transform: translateY(-20px);\n          transform: translateY(-20px);\n  opacity: 0;\n}\n.group-field[data-v-52a1522a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.group-field .button[data-v-52a1522a] {\n    margin-left: 10px;\n}\n.disabled-list[data-v-52a1522a] {\n  list-style: none;\n  margin: 10px 0 0;\n  padding: 10px;\n  font-size: 14px;\n  background: #fafafa;\n  border: 1px solid #ccc;\n  -webkit-column-count: 2;\n     -moz-column-count: 2;\n          column-count: 2;\n}\n.disabled-list li[data-v-52a1522a] {\n    margin: 3px 0;\n}\n.disabled-list a[data-v-52a1522a] {\n    font-weight: 600;\n    cursor: pointer;\n    margin-left: 5px;\n}\n.disabled-list a[data-v-52a1522a]:hover {\n      text-decoration: underline;\n}\n.more-imgs[data-v-52a1522a] {\n  list-style: none;\n  margin: 10px 0 0;\n  font-size: 14px;\n  padding: 0;\n  background: #f8f8f8;\n  border: 1px solid #ccc;\n}\n.more-imgs li[data-v-52a1522a] {\n    padding: 10px;\n    border-bottom: 1px solid #ddd;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify !important;\n        -ms-flex-pack: justify !important;\n            justify-content: space-between !important;\n}\n.more-imgs li[data-v-52a1522a]:hover {\n      background: #fcfcfc;\n}\n.more-imgs .link[data-v-52a1522a] {\n    display: block;\n    width: calc(100% - 100px);\n    color: #555;\n    text-decoration: underline;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.more-imgs .remove[data-v-52a1522a] {\n    font-weight: 600;\n    cursor: pointer;\n    margin-left: 5px;\n}\n.more-imgs .remove[data-v-52a1522a]:hover {\n      text-decoration: underline;\n}\n@media only screen and (max-width: 430px) {\n.medium-3[data-v-52a1522a] {\n    width: 50%;\n}\n.medium-3.pax[data-v-52a1522a] {\n      padding-right: 5px;\n}\n.p-L-10[data-v-52a1522a], .p-R-10[data-v-52a1522a] {\n    padding: 0;\n}\n.m-B-10[data-v-52a1522a] {\n    margin: 0;\n}\n.data-field[data-v-52a1522a] {\n    margin-bottom: 10px;\n    padding: 0;\n}\n.data-field textarea[data-v-52a1522a] {\n      min-height: 100px;\n}\n.box[data-v-52a1522a] {\n    margin-top: 10px;\n}\n.service-types[data-v-52a1522a] {\n    margin: 0;\n    margin-bottom: 10px;\n}\n.brand-box .img-upload[data-v-52a1522a] {\n    padding: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    gap: 10px;\n    margin-bottom: 15px;\n}\n.brand-box .img-upload .inactive-image[data-v-52a1522a] {\n      margin-top: 0;\n}\n.brand-box .img-upload .img-box .recommened[data-v-52a1522a] {\n      line-height: unset;\n}\n.brand-box .sub-box[data-v-52a1522a] {\n    padding: 10px;\n    margin: 0;\n    margin-bottom: 10px;\n}\n.brand-box .sub-box .heading[data-v-52a1522a] {\n      padding: 0;\n}\n.color-picker[data-v-52a1522a] {\n    width: 100%;\n}\n.color-picker .vc-photoshop[data-v-52a1522a] {\n      width: 100%;\n}\n.disabled-list[data-v-52a1522a] {\n    -webkit-column-count: 1;\n       -moz-column-count: 1;\n            column-count: 1;\n}\n.disabled-list li[data-v-52a1522a] {\n      display: block;\n}\n.disabled-list li a[data-v-52a1522a] {\n        display: inline-block;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Services/ServiceDetails.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;CAClB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,kDAAkD;UAC1C,0CAA0C;EAClD,oBAAoB;CACrB;AACD;IACI,8BAA8B;IAC9B,kBAAkB;CACrB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;CACvB;AACD;IACI,sBAAsB;IACtB,eAAe;CAClB;AACD;IACI,UAAU;IACV,eAAe;CAClB;AACD;MACM,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,0BAA0B;MAC1B,kBAAkB;MAClB,qBAAqB;CAC1B;AACD;QACQ,qBAAqB;QACrB,kBAAkB;CACzB;AACD;IACI,aAAa;IACb,cAAc;CACjB;AACD;IACI,uBAAuB;CAC1B;AACD;EACE,eAAe;EACf,mBAAmB;CACpB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,eAAe;IACf,sBAAsB;IACtB,kBAAkB;CACrB;AACD;IACI,aAAa;IACb,eAAe;CAClB;AACD;MACM,eAAe;CACpB;AACD;IACI,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,qBAAqB;CAC1B;AACD;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;CAClB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;IACI,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;CAClB;AACD;MACM,qBAAqB;CAC1B;AACD;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,cAAc;CACjB;AACD;MACM,qBAAqB;CAC1B;AACD;IACI,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,yBAAyB;CAC5B;AACD;IACI,sBAAsB;CACzB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;IACI,sBAAsB;CACzB;AACD;IACI,uBAAuB;CAC1B;AACD;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;CAClB;AACD;EACE,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,mBAAmB;CACtB;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;CACjB;AACD;IACI,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,YAAY;IACZ,2BAA2B;IAC3B,8BAA8B;CACjC;AACD;IACI,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,6BAA6B;IAC7B,gCAAgC;IAChC,kBAAkB;CACrB;AACD;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;CACpB;AACD;EACE,iBAAiB;EACjB,eAAe;EACf,mDAAmD;UAC3C,2CAA2C;EACnD,0BAA0B;CAC3B;AACD;IACI,cAAc;CACjB;AACD;IACI,mBAAmB;IACnB,cAAc;CACjB;AACD;MACM,iBAAiB;CACtB;AACD;MACM,iBAAiB;CACtB;AACD;MACM,iBAAiB;CACtB;AACD;MACM,oBAAoB;MACpB,uBAAuB;MACvB,oBAAoB;MACpB,gBAAgB;MAChB,mBAAmB;MACnB,mBAAmB;CACxB;AACD;QACQ,YAAY;CACnB;AACD;QACQ,WAAW;CAClB;AACD;QACQ,mBAAmB;QACnB,UAAU;QACV,WAAW;QACX,wBAAwB;QACxB,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,iBAAiB;QACjB,uBAAuB;QACvB,YAAY;CACnB;AACD;QACQ,sBAAsB;CAC7B;AACD;UACU,sBAAsB;UACtB,oBAAoB;CAC7B;AACD;MACM,iBAAiB;MACjB,eAAe;MACf,mBAAmB;MACnB,eAAe;CACpB;AACD;MACM,mBAAmB;MACnB,SAAS;MACT,QAAQ;MACR,YAAY;MACZ,gBAAgB;MAChB,iBAAiB;MACjB,YAAY;MACZ,kBAAkB;CACvB;AACD;QACQ,gBAAgB;QAChB,kBAAkB;QAClB,uBAAuB;CAC9B;AACD;MACM,gBAAgB;MAChB,iBAAiB;MACjB,eAAe;MACf,mBAAmB;MACnB,eAAe;CACpB;AACD;MACM,iBAAiB;MACjB,iBAAiB;CACtB;AACD;IACI,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;CACvB;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,YAAY;CACjB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;IACI,SAAS;CACZ;AACD;IACI,QAAQ;CACX;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,kBAAkB;CACrB;AACD;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;KACrB,qBAAqB;UAChB,gBAAgB;CACzB;AACD;IACI,cAAc;CACjB;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;CACpB;AACD;MACM,2BAA2B;CAChC;AACD;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,uBAAuB;CACxB;AACD;IACI,cAAc;IACd,8BAA8B;IAC9B,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,qCAAqC;QACjC,kCAAkC;YAC9B,0CAA0C;CACrD;AACD;MACM,oBAAoB;CACzB;AACD;IACI,eAAe;IACf,0BAA0B;IAC1B,YAAY;IACZ,2BAA2B;IAC3B,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;CAC3B;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;CACpB;AACD;MACM,2BAA2B;CAChC;AACD;AACA;IACI,WAAW;CACd;AACD;MACM,mBAAmB;CACxB;AACD;IACI,WAAW;CACd;AACD;IACI,UAAU;CACb;AACD;IACI,oBAAoB;IACpB,WAAW;CACd;AACD;MACM,kBAAkB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,UAAU;IACV,oBAAoB;CACvB;AACD;IACI,WAAW;IACX,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,UAAU;IACV,oBAAoB;CACvB;AACD;MACM,cAAc;CACnB;AACD;MACM,mBAAmB;CACxB;AACD;IACI,cAAc;IACd,UAAU;IACV,oBAAoB;CACvB;AACD;MACM,WAAW;CAChB;AACD;IACI,YAAY;CACf;AACD;MACM,YAAY;CACjB;AACD;IACI,wBAAwB;OACrB,qBAAqB;YAChB,gBAAgB;CAC3B;AACD;MACM,eAAe;CACpB;AACD;QACQ,sBAAsB;CAC7B;CACA","file":"ServiceDetails.vue","sourcesContent":["\n.m-T-20[data-v-52a1522a] {\n  margin-top: 20px;\n}\n.m-B-10[data-v-52a1522a] {\n  margin-bottom: 10px;\n}\n.p-L-10[data-v-52a1522a] {\n  padding-left: 10px;\n}\n.p-R-10[data-v-52a1522a] {\n  padding-right: 10px;\n}\n.row[data-v-52a1522a] {\n  max-width: 100%;\n}\n.box[data-v-52a1522a] {\n  background: #fff;\n  border-radius: 2px;\n  border: 1px solid #b0c6e4;\n  padding: 15px;\n  -webkit-box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n          box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);\n  margin-bottom: 10px;\n}\n.box .top-line[data-v-52a1522a] {\n    border-top: 1px solid #b0c6e4;\n    padding-top: 10px;\n}\n.box .box-header[data-v-52a1522a] {\n    font-size: 21px;\n    font-weight: 600;\n    color: #555;\n    margin-bottom: 10px;\n}\n.box input[data-v-52a1522a] {\n    display: inline-block;\n    width: inherit;\n}\n.box .service-unavailable-options[data-v-52a1522a] {\n    gap: 20px;\n    margin: 20px 0;\n}\n.box .service-unavailable-options label[data-v-52a1522a] {\n      color: #0D79F2;\n      font-weight: 600;\n      font-size: 11px;\n      text-transform: uppercase;\n      line-height: 130%;\n      letter-spacing: .4px;\n}\n.box .service-unavailable-options label input[data-v-52a1522a] {\n        vertical-align: -2px;\n        margin: 0 3px 0 0;\n}\n.box .time-select[data-v-52a1522a] {\n    width: 100px;\n    margin-top: 0;\n}\n.box .button.smaller[data-v-52a1522a] {\n    padding: 12px 20px 4px;\n}\n.data-field[data-v-52a1522a] {\n  padding: 0 5px;\n  position: relative;\n}\n.data-field.no-label[data-v-52a1522a] {\n    padding-top: 24px;\n}\n.data-field input[type='checkbox'][data-v-52a1522a], .data-field input[type='radio'][data-v-52a1522a] {\n    width: inherit;\n    display: inline-block;\n    margin: 0 3px 0 0;\n}\n.data-field.check-item label[data-v-52a1522a] {\n    height: 25px;\n    display: block;\n}\n.data-field.check-item label.disabled[data-v-52a1522a] {\n      color: #89a2be;\n}\n.data-field.optin-discount[data-v-52a1522a] {\n    padding-left: 24px;\n}\n.data-field.optin-discount .label[data-v-52a1522a] {\n      color: #445568;\n}\n.data-field .label[data-v-52a1522a] {\n    color: #0D79F2;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .label.bigger[data-v-52a1522a] {\n      font-size: 14px;\n}\n.data-field .label input[type='checkbox'][data-v-52a1522a] {\n      vertical-align: -2px;\n}\n.data-field .note[data-v-52a1522a] {\n    font-size: 12.5px;\n    color: #999;\n    display: block;\n}\n.data-field .input[data-v-52a1522a] {\n    margin: 3px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-52a1522a] {\n      border-color: #f20d0d;\n}\n.data-field textarea[data-v-52a1522a] {\n    resize: vertical;\n    margin: 3px 0 0;\n}\n.data-field .check-option[data-v-52a1522a] {\n    font-size: 14px;\n    cursor: pointer;\n    display: block;\n}\n.data-field .check-option input[data-v-52a1522a] {\n      vertical-align: -1px;\n}\n.data-field .radio-option[data-v-52a1522a] {\n    font-size: 14px;\n    cursor: pointer;\n    display: block;\n    margin: 5px 0;\n}\n.data-field .radio-option input[data-v-52a1522a] {\n      vertical-align: -1px;\n}\n.data-field .sub-val[data-v-52a1522a] {\n    margin: 0 0 20px 20px;\n    line-height: 1;\n    padding: 5px;\n    font-size: 13px;\n    width: calc(100% - 20px);\n}\n.data-field .has-error[data-v-52a1522a] {\n    border-color: #f20d0d;\n}\n.data-field .error-msg[data-v-52a1522a] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\nselect[data-v-52a1522a] {\n  margin-top: 5px;\n  border: 1px solid #ddd;\n  padding: 10px;\n  color: #333;\n  height: 45px;\n  position: relative;\n  font-size: 14px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n  -webkit-transition: all .35s ease;\n  transition: all .35s ease;\n}\nselect.has-error[data-v-52a1522a] {\n    border-color: #f20d0d;\n}\nselect[data-v-52a1522a]:disabled {\n    background-color: #eee;\n}\n.required[data-v-52a1522a] {\n  color: #f00;\n  font-weight: 600;\n  margin-left: 2px;\n}\n.tip-input[data-v-52a1522a] {\n  position: relative;\n}\n.tip-input span[data-v-52a1522a] {\n    position: absolute;\n    top: 0;\n    left: 10px;\n    z-index: 2;\n    line-height: 44px;\n    font-weight: 600;\n    color: #888;\n}\n.tip-input input[data-v-52a1522a] {\n    padding-left: 30px;\n}\n.input-integer[data-v-52a1522a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.input-integer > *[data-v-52a1522a] {\n    display: inline-block;\n    vertical-align: middle;\n    margin-top: 0;\n}\n.input-integer input[type=\"number\"][data-v-52a1522a] {\n    font-size: 16px;\n    padding: 10px;\n    display: inline-block;\n    width: 100%;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n.input-integer span[data-v-52a1522a] {\n    font-size: 13px;\n    background-color: #555;\n    color: #fff;\n    padding: 10px;\n    margin-left: -5px;\n    border-top-right-radius: 3px;\n    border-bottom-right-radius: 3px;\n    line-height: 24px;\n}\n.service-types[data-v-52a1522a] {\n  background: #fafafa;\n  padding: 10px;\n  margin-top: 5px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n}\n.brand-box[data-v-52a1522a] {\n  background: #fff;\n  margin: 20px 0;\n  -webkit-box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2);\n          box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2);\n  border: 1px solid #b0c6e4;\n}\n.brand-box .body[data-v-52a1522a] {\n    padding: 20px;\n}\n.brand-box .img-upload[data-v-52a1522a] {\n    text-align: center;\n    padding: 20px;\n}\n.brand-box .img-upload .inactive-image[data-v-52a1522a] {\n      margin-top: 30px;\n}\n.brand-box .img-upload .data-field[data-v-52a1522a] {\n      padding: 0 0 5px;\n}\n.brand-box .img-upload .label[data-v-52a1522a] {\n      text-align: left;\n}\n.brand-box .img-upload .img-box[data-v-52a1522a] {\n      background: #fafafa;\n      border: 1px solid #555;\n      margin-bottom: 28px;\n      cursor: pointer;\n      position: relative;\n      text-align: center;\n}\n.brand-box .img-upload .img-box.loading .fa-image[data-v-52a1522a], .brand-box .img-upload .img-box.loading img[data-v-52a1522a] {\n        opacity: .4;\n}\n.brand-box .img-upload .img-box img[data-v-52a1522a] {\n        width: 90%;\n}\n.brand-box .img-upload .img-box .recommened[data-v-52a1522a] {\n        position: absolute;\n        top: 100%;\n        left: -1px;\n        width: calc(100% + 2px);\n        font-size: 13px;\n        font-weight: 600;\n        line-height: 25px;\n        background: #555;\n        border: 1px solid #555;\n        color: #fff;\n}\n.brand-box .img-upload .img-box.has-error[data-v-52a1522a] {\n        border-color: #f20d0d;\n}\n.brand-box .img-upload .img-box.has-error .recommened[data-v-52a1522a] {\n          border-color: #f20d0d;\n          background: #f20d0d;\n}\n.brand-box .img-upload .fa-image[data-v-52a1522a] {\n      font-size: 120px;\n      color: #becfd3;\n      line-height: 100px;\n      margin: 10px 0;\n}\n.brand-box .img-upload .loader[data-v-52a1522a] {\n      position: absolute;\n      top: 50%;\n      left: 0;\n      width: 100%;\n      font-size: 14px;\n      font-weight: 600;\n      color: #333;\n      margin-top: -10px;\n}\n.brand-box .img-upload .loader i[data-v-52a1522a] {\n        font-size: 21px;\n        margin-right: 5px;\n        vertical-align: middle;\n}\n.brand-box .img-upload .error-msg[data-v-52a1522a] {\n      font-size: 13px;\n      line-height: 1.6;\n      color: #f20d0d;\n      font-style: italic;\n      display: block;\n}\n.brand-box .img-upload .button[data-v-52a1522a] {\n      max-width: 400px;\n      margin-top: 15px;\n}\n.brand-box .sub-box[data-v-52a1522a] {\n    border: 1px solid #ccc;\n    margin: 0 5px 10px;\n    padding: 15px;\n    background: #fafafa;\n}\n.brand-box .sub-box .heading[data-v-52a1522a] {\n      padding: 0 5px;\n      font-size: 21px;\n      font-weight: 600;\n      color: #555;\n}\n.palette[data-v-52a1522a] {\n  position: absolute;\n  top: 30px;\n  right: 14px;\n  width: 20px;\n  height: 20px;\n  border-radius: 100%;\n  border: 1px solid #333;\n}\n.color-picker[data-v-52a1522a] {\n  position: absolute;\n  top: 100%;\n  z-index: 3;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.color-picker.right[data-v-52a1522a] {\n    right: 0;\n}\n.color-picker.left[data-v-52a1522a] {\n    left: 0;\n}\n.slide-down-enter-active[data-v-52a1522a], .slide-down-leave-active[data-v-52a1522a] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-52a1522a], .slide-down-leave-to[data-v-52a1522a] {\n  -webkit-transform: translateY(-20px);\n          transform: translateY(-20px);\n  opacity: 0;\n}\n.group-field[data-v-52a1522a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.group-field .button[data-v-52a1522a] {\n    margin-left: 10px;\n}\n.disabled-list[data-v-52a1522a] {\n  list-style: none;\n  margin: 10px 0 0;\n  padding: 10px;\n  font-size: 14px;\n  background: #fafafa;\n  border: 1px solid #ccc;\n  -webkit-column-count: 2;\n     -moz-column-count: 2;\n          column-count: 2;\n}\n.disabled-list li[data-v-52a1522a] {\n    margin: 3px 0;\n}\n.disabled-list a[data-v-52a1522a] {\n    font-weight: 600;\n    cursor: pointer;\n    margin-left: 5px;\n}\n.disabled-list a[data-v-52a1522a]:hover {\n      text-decoration: underline;\n}\n.more-imgs[data-v-52a1522a] {\n  list-style: none;\n  margin: 10px 0 0;\n  font-size: 14px;\n  padding: 0;\n  background: #f8f8f8;\n  border: 1px solid #ccc;\n}\n.more-imgs li[data-v-52a1522a] {\n    padding: 10px;\n    border-bottom: 1px solid #ddd;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify !important;\n        -ms-flex-pack: justify !important;\n            justify-content: space-between !important;\n}\n.more-imgs li[data-v-52a1522a]:hover {\n      background: #fcfcfc;\n}\n.more-imgs .link[data-v-52a1522a] {\n    display: block;\n    width: calc(100% - 100px);\n    color: #555;\n    text-decoration: underline;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.more-imgs .remove[data-v-52a1522a] {\n    font-weight: 600;\n    cursor: pointer;\n    margin-left: 5px;\n}\n.more-imgs .remove[data-v-52a1522a]:hover {\n      text-decoration: underline;\n}\n@media only screen and (max-width: 430px) {\n.medium-3[data-v-52a1522a] {\n    width: 50%;\n}\n.medium-3.pax[data-v-52a1522a] {\n      padding-right: 5px;\n}\n.p-L-10[data-v-52a1522a], .p-R-10[data-v-52a1522a] {\n    padding: 0;\n}\n.m-B-10[data-v-52a1522a] {\n    margin: 0;\n}\n.data-field[data-v-52a1522a] {\n    margin-bottom: 10px;\n    padding: 0;\n}\n.data-field textarea[data-v-52a1522a] {\n      min-height: 100px;\n}\n.box[data-v-52a1522a] {\n    margin-top: 10px;\n}\n.service-types[data-v-52a1522a] {\n    margin: 0;\n    margin-bottom: 10px;\n}\n.brand-box .img-upload[data-v-52a1522a] {\n    padding: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    gap: 10px;\n    margin-bottom: 15px;\n}\n.brand-box .img-upload .inactive-image[data-v-52a1522a] {\n      margin-top: 0;\n}\n.brand-box .img-upload .img-box .recommened[data-v-52a1522a] {\n      line-height: unset;\n}\n.brand-box .sub-box[data-v-52a1522a] {\n    padding: 10px;\n    margin: 0;\n    margin-bottom: 10px;\n}\n.brand-box .sub-box .heading[data-v-52a1522a] {\n      padding: 0;\n}\n.color-picker[data-v-52a1522a] {\n    width: 100%;\n}\n.color-picker .vc-photoshop[data-v-52a1522a] {\n      width: 100%;\n}\n.disabled-list[data-v-52a1522a] {\n    -webkit-column-count: 1;\n       -moz-column-count: 1;\n            column-count: 1;\n}\n.disabled-list li[data-v-52a1522a] {\n      display: block;\n}\n.disabled-list li a[data-v-52a1522a] {\n        display: inline-block;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column medium-6 p-R-10"},[_c('div',{staticClass:"box general-settings"},[_c('div',{staticClass:"row m-B-10"},[_c('div',{staticClass:"column medium-6 p-R-10"},[_c('div',{staticClass:"data-field"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.label),expression:"details.label"}],class:{'input':true, 'has-error':!!_vm.errors.label },attrs:{"type":"text","disabled":_vm.saving},domProps:{"value":(_vm.details.label)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.details, "label", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errors.label))])])]),_vm._v(" "),_c('div',{staticClass:"column medium-6"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Service ID")]),_vm._v(" "),_c('input',{staticClass:"input",attrs:{"type":"text","disabled":true,"readonly":""},domProps:{"value":_vm.details.id}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errors.label))])])])]),_vm._v(" "),_c('div',{staticClass:"row m-B-10"},[_c('div',{staticClass:"column medium-6 p-R-10"},[_c('div',{staticClass:"data-field"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.code),expression:"details.code"}],class:{'input':true, 'has-error':!!_vm.errors.code },attrs:{"type":"text","disabled":_vm.saving},domProps:{"value":(_vm.details.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.details, "code", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errors.code))])])]),_vm._v(" "),_c('div',{staticClass:"column medium-6"},[_c('div',{staticClass:"data-field"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.color),expression:"details.color"}],class:{'input':true, 'has-error':!!_vm.errors.color },attrs:{"type":"text","disabled":_vm.saving},domProps:{"value":(_vm.details.color)},on:{"click":function($event){_vm.showColor = true},"focus":function($event){_vm.showColor = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.details, "color", $event.target.value)}}}),_vm._v(" "),(!!_vm.details.color)?_c('div',{staticClass:"palette",style:({ background: _vm.details.color })}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showColor),expression:"showColor"}],staticClass:"color-picker right"},[_c('photoshop-picker',{on:{"ok":function($event){return _vm.selectColor()},"cancel":function($event){_vm.showColor = false}},model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}})],1)]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errors.color))])],1)])]),_vm._v(" "),_c('div',{staticClass:"row m-B-10"},[_c('div',{staticClass:"column medium-6 p-R-10"},[_c('div',{staticClass:"service-types m-B-10"},[_c('div',{staticClass:"data-field"},[_vm._m(3),_vm._v(" "),_c('label',{staticClass:"radio-option"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.allowTNC),expression:"details.allowTNC"}],attrs:{"type":"checkbox","disabled":_vm.saving},domProps:{"checked":Array.isArray(_vm.details.allowTNC)?_vm._i(_vm.details.allowTNC,null)>-1:(_vm.details.allowTNC)},on:{"change":function($event){var $$a=_vm.details.allowTNC,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.details, "allowTNC", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.details, "allowTNC", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.details, "allowTNC", $$c)}}}}),_vm._v(" TNC\n                ")]),_vm._v(" "),_c('label',{staticClass:"radio-option"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.allowTCP),expression:"details.allowTCP"}],attrs:{"type":"checkbox","disabled":_vm.saving},domProps:{"checked":Array.isArray(_vm.details.allowTCP)?_vm._i(_vm.details.allowTCP,null)>-1:(_vm.details.allowTCP)},on:{"change":function($event){var $$a=_vm.details.allowTCP,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.details, "allowTCP", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.details, "allowTCP", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.details, "allowTCP", $$c)}}}}),_vm._v(" TCP\n                ")]),_vm._v(" "),_c('label',{staticClass:"radio-option"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.allowPSC),expression:"details.allowPSC"}],attrs:{"type":"checkbox","disabled":_vm.saving},domProps:{"checked":Array.isArray(_vm.details.allowPSC)?_vm._i(_vm.details.allowPSC,null)>-1:(_vm.details.allowPSC)},on:{"change":function($event){var $$a=_vm.details.allowPSC,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.details, "allowPSC", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.details, "allowPSC", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.details, "allowPSC", $$c)}}}}),_vm._v(" PSC\n                ")]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errors.licenseType))])])]),_vm._v(" "),_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Default Tip")]),_vm._v(" "),_c('div',{staticClass:"tip-input"},[_c('span',[_vm._v("%")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.defaultTip),expression:"details.defaultTip"}],class:{'input':true, 'has-error':!!_vm.errors.defaultTip },attrs:{"type":"text","disabled":_vm.saving},domProps:{"value":(_vm.details.defaultTip)},on:{"keypress":_vm.isNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.details, "defaultTip", $event.target.value)}}})]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errors.defaultTip))])])]),_vm._v(" "),_c('div',{staticClass:"column medium-6"},[_c('div',{staticClass:"data-field check-item"},[_c('label',{class:['label', {disabled:_vm.details.isCharter}]},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.isShared),expression:"details.isShared"}],attrs:{"type":"checkbox","disabled":_vm.details.isCharter},domProps:{"checked":Array.isArray(_vm.details.isShared)?_vm._i(_vm.details.isShared,null)>-1:(_vm.details.isShared)},on:{"change":function($event){var $$a=_vm.details.isShared,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.details, "isShared", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.details, "isShared", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.details, "isShared", $$c)}}}}),_vm._v(" Shared Ride Enable\n              ")])]),_vm._v(" "),_c('div',{staticClass:"data-field check-item"},[_c('label',{staticClass:"label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.poolP2P),expression:"details.poolP2P"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.details.poolP2P)?_vm._i(_vm.details.poolP2P,null)>-1:(_vm.details.poolP2P)},on:{"change":function($event){var $$a=_vm.details.poolP2P,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.details, "poolP2P", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.details, "poolP2P", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.details, "poolP2P", $$c)}}}}),_vm._v(" Pool P2P\n              ")])]),_vm._v(" "),_c('div',{staticClass:"data-field check-item"},[_c('label',{staticClass:"label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.poolFromAirport),expression:"details.poolFromAirport"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.details.poolFromAirport)?_vm._i(_vm.details.poolFromAirport,null)>-1:(_vm.details.poolFromAirport)},on:{"change":function($event){var $$a=_vm.details.poolFromAirport,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.details, "poolFromAirport", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.details, "poolFromAirport", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.details, "poolFromAirport", $$c)}}}}),_vm._v(" Pool from Airport\n              ")])]),_vm._v(" "),_c('div',{staticClass:"data-field check-item"},[_c('label',{staticClass:"label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.poolToAirport),expression:"details.poolToAirport"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.details.poolToAirport)?_vm._i(_vm.details.poolToAirport,null)>-1:(_vm.details.poolToAirport)},on:{"change":function($event){var $$a=_vm.details.poolToAirport,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.details, "poolToAirport", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.details, "poolToAirport", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.details, "poolToAirport", $$c)}}}}),_vm._v(" Pool to Airport\n              ")])]),_vm._v(" "),_c('div',{staticClass:"data-field check-item"},[_c('label',{staticClass:"label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.useShifts),expression:"details.useShifts"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.details.useShifts)?_vm._i(_vm.details.useShifts,null)>-1:(_vm.details.useShifts)},on:{"change":function($event){var $$a=_vm.details.useShifts,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.details, "useShifts", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.details, "useShifts", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.details, "useShifts", $$c)}}}}),_vm._v(" Driver Availability Enable\n              ")])]),_vm._v(" "),_c('div',{staticClass:"data-field check-item"},[_c('label',{staticClass:"label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.isCharter),expression:"details.isCharter"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.details.isCharter)?_vm._i(_vm.details.isCharter,null)>-1:(_vm.details.isCharter)},on:{"change":function($event){var $$a=_vm.details.isCharter,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.details, "isCharter", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.details, "isCharter", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.details, "isCharter", $$c)}}}}),_vm._v(" Charter Service\n              ")])]),_vm._v(" "),_c('div',{staticClass:"data-field check-item",staticStyle:{"height":"20px"}},[_c('label',{class:['label', {disabled:_vm.details.isCharter || _vm.details.isShared}]},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.optinAllow),expression:"details.optinAllow"}],attrs:{"type":"checkbox","disabled":_vm.details.isCharter || _vm.details.isShared},domProps:{"checked":Array.isArray(_vm.details.optinAllow)?_vm._i(_vm.details.optinAllow,null)>-1:(_vm.details.optinAllow)},on:{"change":function($event){var $$a=_vm.details.optinAllow,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.details, "optinAllow", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.details, "optinAllow", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.details, "optinAllow", $$c)}}}}),_vm._v(" Offer as Opt-in Service\n              ")])]),_vm._v(" "),(_vm.details.optinAllow)?_c('div',{staticClass:"data-field optin-discount"},[_c('div',{staticClass:"label"},[_vm._v("Opt-in Discount")]),_vm._v(" "),_c('div',{staticClass:"input-integer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.optinPercent),expression:"details.optinPercent"}],attrs:{"type":"number","disabled":!_vm.details.optinAllow || _vm.details.isShared || _vm.saving},domProps:{"value":(_vm.details.optinPercent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.details, "optinPercent", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v("percent")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"data-field check-item"},[_c('label',{staticClass:"label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.isRental),expression:"details.isRental"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.details.isRental)?_vm._i(_vm.details.isRental,null)>-1:(_vm.details.isRental)},on:{"change":function($event){var $$a=_vm.details.isRental,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.details, "isRental", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.details, "isRental", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.details, "isRental", $$c)}}}}),_vm._v(" Rental Service\n              ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.maxConcurrent),expression:"details.maxConcurrent"}],staticClass:"sub-val",attrs:{"type":"text","placeholder":"Max Concurrent"},domProps:{"value":(_vm.details.maxConcurrent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.details, "maxConcurrent", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row m-B-10"},[_c('div',{staticClass:"column medium-4"},[_c('div',{staticClass:"data-field m-B-10"},[_c('div',{staticClass:"label"},[_vm._v("Admin Booking Buffer")]),_vm._v(" "),_c('div',{staticClass:"input-integer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.bufferAdminMins),expression:"details.bufferAdminMins"}],attrs:{"type":"number","disabled":_vm.saving},domProps:{"value":(_vm.details.bufferAdminMins)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.details, "bufferAdminMins", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v("minutes")])])])]),_vm._v(" "),_c('div',{staticClass:"column medium-4"},[_c('div',{staticClass:"data-field m-B-10"},[_c('div',{staticClass:"label"},[_vm._v("Web Booking Buffer")]),_vm._v(" "),_c('div',{staticClass:"input-integer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.bufferWidgetMins),expression:"details.bufferWidgetMins"}],attrs:{"type":"number","disabled":_vm.saving},domProps:{"value":(_vm.details.bufferWidgetMins)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.details, "bufferWidgetMins", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v("minutes")])])])]),_vm._v(" "),_c('div',{staticClass:"column medium-4"},[_c('div',{staticClass:"data-field m-B-10"},[_c('div',{staticClass:"label"},[_vm._v("App Booking Buffer")]),_vm._v(" "),_c('div',{staticClass:"input-integer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.bufferAppMins),expression:"details.bufferAppMins"}],attrs:{"type":"number","disabled":_vm.saving},domProps:{"value":(_vm.details.bufferAppMins)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.details, "bufferAppMins", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v("minutes")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"column medium-6 p-L-10"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row m-B-10"},[_c('div',{staticClass:"column medium-6 end"},[_c('div',{staticClass:"data-field"},[_c('label',{staticClass:"label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subscription),expression:"subscription"}],attrs:{"type":"checkbox","disabled":_vm.saving},domProps:{"checked":Array.isArray(_vm.subscription)?_vm._i(_vm.subscription,null)>-1:(_vm.subscription)},on:{"change":function($event){var $$a=_vm.subscription,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.subscription=$$a.concat([$$v]))}else{$$i>-1&&(_vm.subscription=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.subscription=$$c}}}}),_vm._v(" Subscription\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"row m-B-10"},[_c('div',{staticClass:"column medium-12"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Price")]),_vm._v(" "),_c('input',{staticClass:"input",attrs:{"type":"text","disabled":!_vm.subscription || _vm.saving}})])])]),_vm._v(" "),_c('div',{staticClass:"row m-B-10"},[_c('div',{staticClass:"column medium-6"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Billing Interval")]),_vm._v(" "),_c('select',{attrs:{"disabled":!_vm.subscription || _vm.saving}},[_c('option',[_vm._v("Weekly")]),_vm._v(" "),_c('option',[_vm._v("Monthly")])])])]),_vm._v(" "),_c('div',{staticClass:"column medium-6"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Trial Period")]),_vm._v(" "),_c('input',{staticClass:"input",attrs:{"type":"text","disabled":!_vm.subscription || _vm.saving}})])])]),_vm._v(" "),_c('div',{staticClass:"row m-B-10 m-T-20 top-line"},[_c('div',{staticClass:"column medium-6 end"},[_c('div',{staticClass:"data-field"},[_c('label',{staticClass:"label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hourlyRate),expression:"hourlyRate"}],attrs:{"type":"checkbox","disabled":_vm.saving},domProps:{"checked":Array.isArray(_vm.hourlyRate)?_vm._i(_vm.hourlyRate,null)>-1:(_vm.hourlyRate)},on:{"change":function($event){var $$a=_vm.hourlyRate,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.hourlyRate=$$a.concat([$$v]))}else{$$i>-1&&(_vm.hourlyRate=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.hourlyRate=$$c}}}}),_vm._v(" Hourly Rate\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"row m-B-10"},[_c('div',{staticClass:"column medium-6"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Per Hour Price")]),_vm._v(" "),_c('input',{staticClass:"input",attrs:{"type":"text","disabled":!_vm.hourlyRate || _vm.saving}})])]),_vm._v(" "),_c('div',{staticClass:"column medium-6"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Succeeding Hours")]),_vm._v(" "),_c('input',{staticClass:"input",attrs:{"type":"text","disabled":!_vm.hourlyRate || _vm.saving}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"brand-box"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column medium-4 img-upload"},[_c('div',{staticClass:"active-image image-box"},[_vm._m(4),_vm._v(" "),_c('div',{class:{'img-box': true, 'loading': _vm.uploadingImg, 'has-error':!!_vm.errors.imgUrl},on:{"click":function($event){return _vm.triggerClickUpload('uploadImg')}}},[(_vm.imgUrl)?_c('img',{attrs:{"src":_vm.imgUrl}}):_c('i',{staticClass:"fa fa-image"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.uploadingImg),expression:"uploadingImg"}],staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n                Uploading image...\n              ")]),_vm._v(" "),_c('div',{staticClass:"recommened"},[_vm._v("Recommended size: 300x300")])]),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"uploadImg",attrs:{"type":"file","accept":"image/*"},on:{"change":function($event){return _vm.uploadImg($event, 'Img')}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errors.imgUrl))]),_vm._v(" "),_c('a',{staticClass:"button cta xsmall block error",on:{"click":function($event){return _vm.triggerClickUpload('uploadImg')}}},[_vm._v("Upload Image")])]),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"uploadImg",attrs:{"type":"file","accept":"image/*"},on:{"change":function($event){return _vm.uploadImg($event, 'Img')}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errors.imgUrl))]),_vm._v(" "),(false)?_c('a',{staticClass:"button cta xsmall block error",on:{"click":function($event){return _vm.triggerClickUpload('uploadImg')}}},[_vm._v("Upload Image")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"inactive-image image-box"},[_vm._m(5),_vm._v(" "),_c('div',{class:{'img-box': true, 'loading': _vm.uploadingImgOff, 'has-error':!!_vm.errors.imgOffUrl},on:{"click":function($event){return _vm.triggerClickUpload('uploadImgOff')}}},[(_vm.imgOffUrl)?_c('img',{attrs:{"src":_vm.imgOffUrl}}):_c('i',{staticClass:"fa fa-image"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.uploadingImgOff),expression:"uploadingImgOff"}],staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n                Uploading image...\n              ")]),_vm._v(" "),_c('div',{staticClass:"recommened"},[_vm._v("Recommended size: 300x300")])]),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"uploadImgOff",attrs:{"type":"file","accept":"image/*"},on:{"change":function($event){return _vm.uploadImg($event, 'ImgOff')}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errors.imgOffUrl))]),_vm._v(" "),_c('a',{staticClass:"button cta xsmall block error",on:{"click":function($event){return _vm.triggerClickUpload('uploadImgOff')}}},[_vm._v("Upload Image")])])]),_vm._v(" "),_c('div',{staticClass:"column medium-8"},[_c('div',{staticClass:"row m-B-10"},[_c('div',{staticClass:"column medium-6"},[_c('div',{staticClass:"data-field"},[_vm._m(6),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.name),expression:"details.name"}],class:{'input':true, 'has-error':!!_vm.errors.name },attrs:{"type":"text","disabled":_vm.saving},domProps:{"value":(_vm.details.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.details, "name", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errors.name))])])]),_vm._v(" "),_c('div',{staticClass:"column medium-3 pax"},[_c('div',{staticClass:"data-field"},[_vm._m(7),_vm._v(" "),_c('vue-autonumeric',{class:{'input':true, 'has-error':!!_vm.errors.maxPassengers },attrs:{"options":_vm.passenger,"disabled":_vm.saving},model:{value:(_vm.details.maxPassengers),callback:function ($$v) {_vm.$set(_vm.details, "maxPassengers", $$v)},expression:"details.maxPassengers"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errors.maxPassengers))])],1)]),_vm._v(" "),_c('div',{staticClass:"column medium-3"},[_c('div',{staticClass:"data-field"},[_vm._m(8),_vm._v(" "),_c('vue-autonumeric',{class:{'input':true, 'has-error':!!_vm.errors.maxLuggages },attrs:{"options":_vm.luggage,"disabled":_vm.saving},model:{value:(_vm.details.maxLuggages),callback:function ($$v) {_vm.$set(_vm.details, "maxLuggages", $$v)},expression:"details.maxLuggages"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errors.maxLuggages))])],1)])]),_vm._v(" "),_c('div',{staticClass:"sub-box"},[_c('div',{staticClass:"heading m-B-10"},[_vm._v("Web Form")]),_vm._v(" "),_c('div',{staticClass:"row m-B-10"},[_c('div',{staticClass:"column medium-12"},[_c('div',{staticClass:"data-field"},[_vm._m(9),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.excerptWeb),expression:"details.excerptWeb"}],class:{'has-error':!!_vm.errors.excerptWeb },attrs:{"disabled":_vm.saving},domProps:{"value":(_vm.details.excerptWeb)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.details, "excerptWeb", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errors.excerptWeb))])])])]),_vm._v(" "),_c('div',{staticClass:"row m-B-10"},[_c('div',{staticClass:"column medium-12"},[_c('div',{staticClass:"data-field"},[_vm._m(10),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.descriptionWeb),expression:"details.descriptionWeb"}],class:{'has-error':!!_vm.errors.descriptionWeb },attrs:{"disabled":_vm.saving},domProps:{"value":(_vm.details.descriptionWeb)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.details, "descriptionWeb", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errors.descriptionWeb))])])])]),_vm._v(" "),_c('div',{staticClass:"row m-B-10"},[_c('div',{staticClass:"column medium-6"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Description - Advantage")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.advantageWeb),expression:"details.advantageWeb"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.saving},domProps:{"value":(_vm.details.advantageWeb)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.details, "advantageWeb", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"column medium-6"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Description - Stops")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.stops),expression:"details.stops"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.saving},domProps:{"value":(_vm.details.stops)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.details, "stops", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"sub-box"},[_c('div',{staticClass:"heading m-B-10"},[_vm._v("Consumer App")]),_vm._v(" "),_c('div',{staticClass:"row m-B-10"},[_c('div',{staticClass:"data-field"},[_vm._m(11),_vm._v(" "),_c('span',{staticClass:"note"},[_vm._v("For best customer viewing experience, please specify only up to three service types in each category")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.category),expression:"details.category"}],class:{'input':true, 'has-error':!!_vm.errors.category },attrs:{"type":"text","disabled":_vm.saving},domProps:{"value":(_vm.details.category)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.details, "category", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errors.category))])])]),_vm._v(" "),_c('div',{staticClass:"row m-B-10"},[_c('div',{staticClass:"data-field"},[_vm._m(12),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.excerptApp),expression:"details.excerptApp"}],class:{'has-error':!!_vm.errors.excerptApp },attrs:{"disabled":_vm.saving},domProps:{"value":(_vm.details.excerptApp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.details, "excerptApp", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errors.excerptApp))])])]),_vm._v(" "),_c('div',{staticClass:"row m-B-10"},[_c('div',{staticClass:"data-field"},[_vm._m(13),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.slogan),expression:"details.slogan"}],class:{'input':true, 'has-error':!!_vm.errors.slogan },attrs:{"type":"text","disabled":_vm.saving},domProps:{"value":(_vm.details.slogan)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.details, "slogan", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errors.slogan))])])]),_vm._v(" "),_c('div',{staticClass:"row m-B-10"},[_c('div',{staticClass:"data-field"},[_vm._m(14),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.descriptionApp),expression:"details.descriptionApp"}],class:{'has-error':!!_vm.errors.descriptionApp },attrs:{"disabled":_vm.saving},domProps:{"value":(_vm.details.descriptionApp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.details, "descriptionApp", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errors.descriptionApp))])])]),_vm._v(" "),_c('div',{staticClass:"row m-B-10"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Description - Advantage")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.details.advantageApp),expression:"details.advantageApp"}],staticClass:"input",attrs:{"type":"text","disabled":_vm.saving},domProps:{"value":(_vm.details.advantageApp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.details, "advantageApp", $event.target.value)}}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column medium-6 p-R-10"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"data-field",staticStyle:{"padding-left":"0"}},[_c('div',{staticClass:"label",staticStyle:{"margin-bottom":"3px"}},[_vm._v("Disabled on dates")]),_vm._v(" "),_c('div',{staticClass:"group-field"},[_c('datepicker',{staticClass:"datepicker",attrs:{"format":_vm.calendarFormat,"input-class":"datepicker m-T-0","disabled-picker":_vm.saving,"placeholder":"Select Date","calendar-button-icon":"fa fa-calendar","calendar-button":true,"disabled":_vm.disabledDates,"calendar-class":"top-calendar"},model:{value:(_vm.disabledDate),callback:function ($$v) {_vm.disabledDate=$$v},expression:"disabledDate"}}),_vm._v(" "),_c('a',{staticClass:"button cta",on:{"click":_vm.addDisabledDate}},[_vm._v("ADD")])],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.unavailableTimes.length)?_c('ul',{staticClass:"disabled-list"},_vm._l((_vm.unavailableTimes),function(dates,i){return _c('li',{key:i},[_vm._v("\n              "+_vm._s(dates)+"\n              "),_c('a',{on:{"click":function($event){return _vm.removeDisabledDate(dates)}}},[_vm._v("[ Remove ]")])])}),0):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header"},[_vm._v("Service Unavailability")]),_vm._v(" "),_c('div',{staticClass:"d-flex service-unavailable-options"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.serviceUnavailable.asap),expression:"serviceUnavailable.asap"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.serviceUnavailable.asap)?_vm._i(_vm.serviceUnavailable.asap,null)>-1:(_vm.serviceUnavailable.asap)},on:{"change":function($event){var $$a=_vm.serviceUnavailable.asap,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.serviceUnavailable, "asap", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.serviceUnavailable, "asap", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.serviceUnavailable, "asap", $$c)}}}}),_vm._v("\n            ASAP\n          ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.serviceUnavailable.future),expression:"serviceUnavailable.future"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.serviceUnavailable.future)?_vm._i(_vm.serviceUnavailable.future,null)>-1:(_vm.serviceUnavailable.future)},on:{"change":function($event){var $$a=_vm.serviceUnavailable.future,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.serviceUnavailable, "future", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.serviceUnavailable, "future", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.serviceUnavailable, "future", $$c)}}}}),_vm._v("\n            Future\n          ")])]),_vm._v(" "),_c('div',{staticClass:"d-flex service-unavailable-options"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.serviceUnavailable.p2p),expression:"serviceUnavailable.p2p"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.serviceUnavailable.p2p)?_vm._i(_vm.serviceUnavailable.p2p,null)>-1:(_vm.serviceUnavailable.p2p)},on:{"change":function($event){var $$a=_vm.serviceUnavailable.p2p,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.serviceUnavailable, "p2p", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.serviceUnavailable, "p2p", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.serviceUnavailable, "p2p", $$c)}}}}),_vm._v("\n            Point to Point\n          ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.serviceUnavailable.fromAirport),expression:"serviceUnavailable.fromAirport"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.serviceUnavailable.fromAirport)?_vm._i(_vm.serviceUnavailable.fromAirport,null)>-1:(_vm.serviceUnavailable.fromAirport)},on:{"change":function($event){var $$a=_vm.serviceUnavailable.fromAirport,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.serviceUnavailable, "fromAirport", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.serviceUnavailable, "fromAirport", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.serviceUnavailable, "fromAirport", $$c)}}}}),_vm._v("\n            From Airport\n          ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.serviceUnavailable.toAirport),expression:"serviceUnavailable.toAirport"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.serviceUnavailable.toAirport)?_vm._i(_vm.serviceUnavailable.toAirport,null)>-1:(_vm.serviceUnavailable.toAirport)},on:{"change":function($event){var $$a=_vm.serviceUnavailable.toAirport,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.serviceUnavailable, "toAirport", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.serviceUnavailable, "toAirport", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.serviceUnavailable, "toAirport", $$c)}}}}),_vm._v("\n            To Airport\n          ")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"data-field",staticStyle:{"padding-left":"0"}},[_c('div',{staticClass:"label",staticStyle:{"margin-bottom":"3px"}},[_vm._v("Start Time")]),_vm._v(" "),_c('div',{staticClass:"group-field"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.serviceUnavailable.startTime),expression:"serviceUnavailable.startTime"}],staticClass:"time-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.serviceUnavailable, "startTime", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((24),function(x){return _c('option',{key:x,domProps:{"value":x - 1}},[_vm._v(_vm._s(_vm.leadingZero(x - 1))+":00")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"data-field",staticStyle:{"padding-left":"0"}},[_c('div',{staticClass:"label",staticStyle:{"margin-bottom":"3px"}},[_vm._v("End Time")]),_vm._v(" "),_c('div',{staticClass:"group-field"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.serviceUnavailable.endTime),expression:"serviceUnavailable.endTime"}],staticClass:"time-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.serviceUnavailable, "endTime", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((24),function(x){return _c('option',{key:x,domProps:{"value":x - 1}},[_vm._v(_vm._s(_vm.leadingZero(x - 1))+":00")])}),0)])])])])]),_vm._v(" "),_c('div',{staticClass:"column medium-6 p-R-10"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"data-field",staticStyle:{"padding-left":"0"}},[_c('div',{staticClass:"label",staticStyle:{"margin-bottom":"3px"}},[_vm._v("More Images")]),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"moreImages",attrs:{"type":"file","multiple":"","disabled":_vm.moreImages.loading,"accept":"image/*"},on:{"change":function($event){return _vm.uploadMoreStart($event)}}}),_vm._v(" "),_c('a',{class:['button cta', {disabled: _vm.moreImages.loading}],on:{"click":function($event){return _vm.triggerClickUpload('moreImages')}}},[(!_vm.moreImages.loading)?_c('span',[_c('i',{staticClass:"fas fa-plus fa-fw"}),_vm._v("\n              Upload\n            ")]):_c('span',[_c('i',{staticClass:"fas fa-spinner fa-spin fa-fw"}),_vm._v("\n              Uploading...\n            ")])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.moreImgs && _vm.moreImgs.length)?_c('ul',{staticClass:"more-imgs"},_vm._l((_vm.moreImgs),function(img,i){return _c('li',{key:i},[_c('a',{staticClass:"link",attrs:{"href":img,"target":"_blank"}},[_vm._v(_vm._s(img))]),_vm._v(" "),_c('a',{staticClass:"remove",on:{"click":function($event){return _vm.removeMoreImg(img)}}},[_vm._v("[ Remove ]")])])}),0):_vm._e()])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label"},[_vm._v("Service Name (Backoffice Label) "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label"},[_vm._v("Service Code "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label"},[_vm._v("Color "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label"},[_vm._v("License Type "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Active Image")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Inactive Image")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label"},[_vm._v("Service Name "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label"},[_vm._v("Max Passenger "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label"},[_vm._v("Max Luggage "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label"},[_vm._v("Description - Excerpt "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label"},[_vm._v("Description - Full "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label"},[_vm._v("Service Category "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label"},[_vm._v("Description - Excerpt "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label"},[_vm._v("Description - Slogan "),_c('span',{staticClass:"required"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label"},[_vm._v("Description - Full"),_c('span',{staticClass:"required"},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnableDrivers_vue__ = __webpack_require__(554);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25b4d079_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnableDrivers_vue__ = __webpack_require__(1597);
function injectStyle (ssrContext) {
  __webpack_require__(1595)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25b4d079"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnableDrivers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25b4d079_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnableDrivers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1596);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("c46bb668", content, true, {});

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.loader[data-v-25b4d079] {\n  height: 150px;\n  text-align: center;\n}\n.loader div[data-v-25b4d079] {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    width: 100%;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n}\n.loader div i[data-v-25b4d079], .loader div span[data-v-25b4d079] {\n      color: #2a2a2a;\n      font-size: 21px;\n      font-weight: 600;\n}\n.field-label[data-v-25b4d079] {\n  font-size: 13px;\n  color: #999;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n  text-align: left;\n}\n.status[data-v-25b4d079], .type[data-v-25b4d079] {\n  display: inline-block;\n  padding-left: 20px;\n  width: 100%;\n}\n.status[data-v-25b4d079] {\n  padding-left: 45px;\n}\n.status-select[data-v-25b4d079], .type-select[data-v-25b4d079] {\n  padding: 10px;\n  height: 46px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n  width: 175px;\n  cursor: pointer;\n}\n.status-select[disabled][data-v-25b4d079], .type-select[disabled][data-v-25b4d079] {\n    background-color: #ebebe4;\n}\n.select-all[data-v-25b4d079] {\n  display: inline-block;\n  padding-left: 10px;\n  width: 100%;\n}\n.select-all .checkbox[data-v-25b4d079] {\n    text-align: left;\n    cursor: pointer;\n    margin-top: 8px;\n}\n.select-all .checkbox .fa-check-square[data-v-25b4d079] {\n      color: #27d979;\n}\n.select-all .checkbox .fa-square[data-v-25b4d079] {\n      color: #d8e8dd;\n}\n.select-all .checkbox .fa-square[data-v-25b4d079]:hover {\n        color: #f4eccb;\n}\n.empty[data-v-25b4d079] {\n  -webkit-column-count: 1 !important;\n  -moz-column-count: 1 !important;\n  column-count: 1 !important;\n  padding: 35px 0;\n  width: 100%;\n}\n.driver-modal[data-v-25b4d079] {\n  -webkit-column-count: 4;\n  -moz-column-count: 4;\n  column-count: 4;\n  border-top: 1px solid #ddd;\n  border-bottom: 1px solid #ddd;\n  padding: 15px 0;\n  margin: 10px 0;\n}\n.driver-modal .driver-info[data-v-25b4d079] {\n    -webkit-column-break-inside: avoid;\n    page-break-inside: avoid;\n    break-inside: avoid;\n    border: 1px solid #ddd;\n    margin-bottom: 6px;\n    width: 100%;\n    padding: 9px;\n    height: 150px;\n    overflow: hidden;\n}\n.driver-modal .driver-info[data-v-25b4d079]:hover {\n      background-color: #fff8dc;\n      cursor: pointer;\n}\n.driver-modal .driver-info .check-box[data-v-25b4d079] {\n      float: left;\n      width: 30px;\n}\n.driver-modal .driver-info .check-box i[data-v-25b4d079] {\n        margin-right: 5px;\n        color: #aaa;\n        font-size: 18px;\n}\n.driver-modal .driver-info .check-box .fa-check-square[data-v-25b4d079] {\n        color: #2fd77e;\n}\n.driver-modal .driver-info .check-box .fa-square[data-v-25b4d079] {\n        color: #d8e8dd;\n}\n.driver-modal .driver-info .driver-img[data-v-25b4d079], .driver-modal .driver-info .car-img[data-v-25b4d079] {\n      height: 75px;\n      width: 75px;\n      border: 1px solid #ddd;\n      border-radius: 50%;\n      margin-left: -18px;\n      overflow: hidden;\n      background-color: #ddd;\n}\n.driver-modal .driver-info .car-img[data-v-25b4d079] {\n      margin-left: -15px;\n}\n.driver-modal .driver-info .driver-details[data-v-25b4d079] {\n      text-align: center;\n}\n.driver-modal .driver-info .driver-details p[data-v-25b4d079] {\n        margin: 0;\n        font-size: 15px;\n}\n.driver-modal .driver-info .driver-details .driver-name[data-v-25b4d079] {\n        font-weight: 600;\n        margin-top: 8px;\n        font-size: 16px;\n}\n.driver-modal .driver-info .driver-details .driver-name a[data-v-25b4d079] {\n          text-decoration: none;\n          color: #3c3c3c;\n}\n.driver-modal .driver-info .driver-details .driver-name a[data-v-25b4d079]:hover {\n            color: #0D79F2 !important;\n}\n.driver-modal .checked[data-v-25b4d079] {\n    background-color: #fff8dc;\n}\n.fixed-bottom[data-v-25b4d079] {\n  bottom: 0;\n  text-align: right;\n}\n.pagination[data-v-25b4d079] {\n  text-align: right;\n  padding: 10px 10px;\n}\n.pagination span[data-v-25b4d079] {\n    display: inline-block;\n    margin-right: 5px;\n}\n.pagination select[data-v-25b4d079] {\n    height: 30px;\n    vertical-align: middle;\n    max-width: 40%;\n}\n.pagination .prevNext[data-v-25b4d079] {\n    margin: 0 2px;\n    padding: 0 8px;\n    border: 1px solid #bbb;\n    background: #fff;\n    cursor: pointer;\n    vertical-align: middle;\n    height: 30px;\n}\n.pagination .prevNext i[data-v-25b4d079] {\n      line-height: 28px;\n}\n.pagination .prevNext.disabled[data-v-25b4d079] {\n      opacity: .4;\n      cursor: default;\n}\n.search-row[data-v-25b4d079] {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.search-row .search[data-v-25b4d079] {\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n}\n.search-row .search .search-input-box[data-v-25b4d079] {\n      width: 100%;\n      position: relative;\n}\n.search-row .search .search-input-box input[data-v-25b4d079] {\n        display: inline-block;\n        vertical-align: middle;\n        margin-top: 0;\n        border-radius: 5px 0 0 5px;\n        padding-right: 30px;\n}\n.search-row .search .search-input-box input.has-error[data-v-25b4d079] {\n          border-color: #f33a27;\n}\n.search-row .search .search-input-box i[data-v-25b4d079] {\n        position: absolute;\n        top: 0;\n        right: 5px;\n        color: #d92626;\n        cursor: pointer;\n        line-height: 46px;\n}\n.search-row .search button[data-v-25b4d079] {\n      display: inline-block;\n      vertical-align: middle;\n      line-height: 1;\n      border-radius: 0 5px 5px 0;\n      padding: 0 20px;\n}\n.slide-left-enter-active[data-v-25b4d079], .slide-left-leave-active[data-v-25b4d079] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-left-enter[data-v-25b4d079], .slide-left-leave-to[data-v-25b4d079] {\n  -webkit-transform: translateX(30px);\n          transform: translateX(30px);\n  opacity: 0;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Services/EnableDrivers.vue"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,oCAAoC;YAC5B,4BAA4B;CACvC;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,iBAAiB;CACtB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,iBAAiB;CAClB;AACD;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,mBAAmB;CACpB;AACD;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;CACjB;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;CACb;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;CACnB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;QACQ,eAAe;CACtB;AACD;EACE,mCAAmC;EACnC,gCAAgC;EAChC,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;CACb;AACD;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;CAChB;AACD;IACI,mCAAmC;IACnC,yBAAyB;IACzB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,iBAAiB;CACpB;AACD;MACM,0BAA0B;MAC1B,gBAAgB;CACrB;AACD;MACM,YAAY;MACZ,YAAY;CACjB;AACD;QACQ,kBAAkB;QAClB,YAAY;QACZ,gBAAgB;CACvB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,eAAe;CACtB;AACD;MACM,aAAa;MACb,YAAY;MACZ,uBAAuB;MACvB,mBAAmB;MACnB,mBAAmB;MACnB,iBAAiB;MACjB,uBAAuB;CAC5B;AACD;MACM,mBAAmB;CACxB;AACD;MACM,mBAAmB;CACxB;AACD;QACQ,UAAU;QACV,gBAAgB;CACvB;AACD;QACQ,iBAAiB;QACjB,gBAAgB;QAChB,gBAAgB;CACvB;AACD;UACU,sBAAsB;UACtB,eAAe;CACxB;AACD;YACY,0BAA0B;CACrC;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,UAAU;EACV,kBAAkB;CACnB;AACD;EACE,kBAAkB;EAClB,mBAAmB;CACpB;AACD;IACI,sBAAsB;IACtB,kBAAkB;CACrB;AACD;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;CAClB;AACD;IACI,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;CAChB;AACD;MACM,kBAAkB;CACvB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;EACE,0BAA0B;EAC1B,2BAA2B;CAC5B;AACD;IACI,+BAA+B;YACvB,uBAAuB;IAC/B,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,YAAY;CACf;AACD;MACM,YAAY;MACZ,mBAAmB;CACxB;AACD;QACQ,sBAAsB;QACtB,uBAAuB;QACvB,cAAc;QACd,2BAA2B;QAC3B,oBAAoB;CAC3B;AACD;UACU,sBAAsB;CAC/B;AACD;QACQ,mBAAmB;QACnB,OAAO;QACP,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB,kBAAkB;CACzB;AACD;MACM,sBAAsB;MACtB,uBAAuB;MACvB,eAAe;MACf,2BAA2B;MAC3B,gBAAgB;CACrB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ","file":"EnableDrivers.vue","sourcesContent":["\n.loader[data-v-25b4d079] {\n  height: 150px;\n  text-align: center;\n}\n.loader div[data-v-25b4d079] {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    width: 100%;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n}\n.loader div i[data-v-25b4d079], .loader div span[data-v-25b4d079] {\n      color: #2a2a2a;\n      font-size: 21px;\n      font-weight: 600;\n}\n.field-label[data-v-25b4d079] {\n  font-size: 13px;\n  color: #999;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n  text-align: left;\n}\n.status[data-v-25b4d079], .type[data-v-25b4d079] {\n  display: inline-block;\n  padding-left: 20px;\n  width: 100%;\n}\n.status[data-v-25b4d079] {\n  padding-left: 45px;\n}\n.status-select[data-v-25b4d079], .type-select[data-v-25b4d079] {\n  padding: 10px;\n  height: 46px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n  width: 175px;\n  cursor: pointer;\n}\n.status-select[disabled][data-v-25b4d079], .type-select[disabled][data-v-25b4d079] {\n    background-color: #ebebe4;\n}\n.select-all[data-v-25b4d079] {\n  display: inline-block;\n  padding-left: 10px;\n  width: 100%;\n}\n.select-all .checkbox[data-v-25b4d079] {\n    text-align: left;\n    cursor: pointer;\n    margin-top: 8px;\n}\n.select-all .checkbox .fa-check-square[data-v-25b4d079] {\n      color: #27d979;\n}\n.select-all .checkbox .fa-square[data-v-25b4d079] {\n      color: #d8e8dd;\n}\n.select-all .checkbox .fa-square[data-v-25b4d079]:hover {\n        color: #f4eccb;\n}\n.empty[data-v-25b4d079] {\n  -webkit-column-count: 1 !important;\n  -moz-column-count: 1 !important;\n  column-count: 1 !important;\n  padding: 35px 0;\n  width: 100%;\n}\n.driver-modal[data-v-25b4d079] {\n  -webkit-column-count: 4;\n  -moz-column-count: 4;\n  column-count: 4;\n  border-top: 1px solid #ddd;\n  border-bottom: 1px solid #ddd;\n  padding: 15px 0;\n  margin: 10px 0;\n}\n.driver-modal .driver-info[data-v-25b4d079] {\n    -webkit-column-break-inside: avoid;\n    page-break-inside: avoid;\n    break-inside: avoid;\n    border: 1px solid #ddd;\n    margin-bottom: 6px;\n    width: 100%;\n    padding: 9px;\n    height: 150px;\n    overflow: hidden;\n}\n.driver-modal .driver-info[data-v-25b4d079]:hover {\n      background-color: #fff8dc;\n      cursor: pointer;\n}\n.driver-modal .driver-info .check-box[data-v-25b4d079] {\n      float: left;\n      width: 30px;\n}\n.driver-modal .driver-info .check-box i[data-v-25b4d079] {\n        margin-right: 5px;\n        color: #aaa;\n        font-size: 18px;\n}\n.driver-modal .driver-info .check-box .fa-check-square[data-v-25b4d079] {\n        color: #2fd77e;\n}\n.driver-modal .driver-info .check-box .fa-square[data-v-25b4d079] {\n        color: #d8e8dd;\n}\n.driver-modal .driver-info .driver-img[data-v-25b4d079], .driver-modal .driver-info .car-img[data-v-25b4d079] {\n      height: 75px;\n      width: 75px;\n      border: 1px solid #ddd;\n      border-radius: 50%;\n      margin-left: -18px;\n      overflow: hidden;\n      background-color: #ddd;\n}\n.driver-modal .driver-info .car-img[data-v-25b4d079] {\n      margin-left: -15px;\n}\n.driver-modal .driver-info .driver-details[data-v-25b4d079] {\n      text-align: center;\n}\n.driver-modal .driver-info .driver-details p[data-v-25b4d079] {\n        margin: 0;\n        font-size: 15px;\n}\n.driver-modal .driver-info .driver-details .driver-name[data-v-25b4d079] {\n        font-weight: 600;\n        margin-top: 8px;\n        font-size: 16px;\n}\n.driver-modal .driver-info .driver-details .driver-name a[data-v-25b4d079] {\n          text-decoration: none;\n          color: #3c3c3c;\n}\n.driver-modal .driver-info .driver-details .driver-name a[data-v-25b4d079]:hover {\n            color: #0D79F2 !important;\n}\n.driver-modal .checked[data-v-25b4d079] {\n    background-color: #fff8dc;\n}\n.fixed-bottom[data-v-25b4d079] {\n  bottom: 0;\n  text-align: right;\n}\n.pagination[data-v-25b4d079] {\n  text-align: right;\n  padding: 10px 10px;\n}\n.pagination span[data-v-25b4d079] {\n    display: inline-block;\n    margin-right: 5px;\n}\n.pagination select[data-v-25b4d079] {\n    height: 30px;\n    vertical-align: middle;\n    max-width: 40%;\n}\n.pagination .prevNext[data-v-25b4d079] {\n    margin: 0 2px;\n    padding: 0 8px;\n    border: 1px solid #bbb;\n    background: #fff;\n    cursor: pointer;\n    vertical-align: middle;\n    height: 30px;\n}\n.pagination .prevNext i[data-v-25b4d079] {\n      line-height: 28px;\n}\n.pagination .prevNext.disabled[data-v-25b4d079] {\n      opacity: .4;\n      cursor: default;\n}\n.search-row[data-v-25b4d079] {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.search-row .search[data-v-25b4d079] {\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n}\n.search-row .search .search-input-box[data-v-25b4d079] {\n      width: 100%;\n      position: relative;\n}\n.search-row .search .search-input-box input[data-v-25b4d079] {\n        display: inline-block;\n        vertical-align: middle;\n        margin-top: 0;\n        border-radius: 5px 0 0 5px;\n        padding-right: 30px;\n}\n.search-row .search .search-input-box input.has-error[data-v-25b4d079] {\n          border-color: #f33a27;\n}\n.search-row .search .search-input-box i[data-v-25b4d079] {\n        position: absolute;\n        top: 0;\n        right: 5px;\n        color: #d92626;\n        cursor: pointer;\n        line-height: 46px;\n}\n.search-row .search button[data-v-25b4d079] {\n      display: inline-block;\n      vertical-align: middle;\n      line-height: 1;\n      border-radius: 0 5px 5px 0;\n      padding: 0 20px;\n}\n.slide-left-enter-active[data-v-25b4d079], .slide-left-leave-active[data-v-25b4d079] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-left-enter[data-v-25b4d079], .slide-left-leave-to[data-v-25b4d079] {\n  -webkit-transform: translateX(30px);\n          transform: translateX(30px);\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"row search-row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.drivers.length !== 0),expression:"drivers.length !== 0"}],staticClass:"small-1 columns"},[_c('div',{staticClass:"select-all"},[_c('label',{staticClass:"field-label"},[_vm._v("Select All:")]),_vm._v(" "),_c('div',{staticClass:"checkbox",on:{"click":_vm.selectAll}},[(_vm.checked)?_c('i',{staticClass:"fas fa-check-square fa-2x"}):_c('i',{staticClass:"fas fa-square fa-2x"})])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns"},[_c('label',{staticClass:"field-label"},[_vm._v("Search:")]),_vm._v(" "),_c('div',{staticClass:"search"},[_c('div',{staticClass:"search-input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],ref:"search",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.searchInput)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search.apply(null, arguments)},"blur":_vm.blurSearch,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-left"}},[(_vm.searchInput.length > 0)?_c('i',{staticClass:"far fa-times-circle fa-lg",on:{"click":_vm.clearSearch}}):_vm._e()])],1),_vm._v(" "),_c('button',{class:{'button xsmall success':true, 'disabled':_vm.loading},on:{"click":_vm.search}},[_c('i',{staticClass:"fas fa-search fa-lg"})])])]),_vm._v(" "),_c('div',{staticClass:"small-2 columns"},[_c('div',{staticClass:"type"},[_c('label',{staticClass:"field-label"},[_vm._v("License Type:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.type),expression:"type"}],staticClass:"type-select",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v(_vm._s(_vm.$t('provider.list.filter.all')))]),_vm._v(" "),_c('option',{attrs:{"value":"tcp"}},[_vm._v(_vm._s(_vm.$t('provider.list.filter.tcp')))]),_vm._v(" "),_c('option',{attrs:{"value":"tnc"}},[_vm._v(_vm._s(_vm.$t('provider.list.filter.tnc')))]),_vm._v(" "),_c('option',{attrs:{"value":"psc"}},[_vm._v("PSC")])])])]),_vm._v(" "),_c('div',{staticClass:"small-2 columns end"},[_c('div',{staticClass:"status"},[_c('label',{staticClass:"field-label"},[_vm._v("Status:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.statusTable),expression:"statusTable"}],staticClass:"status-select",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.statusTable=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"unarchived"}},[_vm._v(_vm._s(_vm.$t('provider.list.filter.allNonArchive')))]),_vm._v(" "),_c('option',{attrs:{"value":"active"}},[_vm._v(_vm._s(_vm.$t('provider.list.filter.active')))]),_vm._v(" "),_c('option',{attrs:{"value":"inactive"}},[_vm._v(_vm._s(_vm.$t('provider.list.filter.inactive')))])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_vm._m(0)]),_vm._v(" "),_c('div',{class:{'driver-modal':!_vm.loading, 'empty':_vm.drivers.length === 0 && !_vm.loading}},[_vm._l((_vm.drivers),function(driver){return _c('div',{key:driver.id,class:{'driver-info':true, 'checked':_vm.checkedDriver(driver.id)},on:{"click":function($event){return _vm.selectDriver(driver.id)}}},[_c('div',{staticClass:"check-box"},[(_vm.checkedDriver(driver.id))?_c('i',{staticClass:"fas fa-check-square fa-2x"}):_c('i',{staticClass:"fas fa-square fa-2x"})]),_vm._v(" "),_c('div',{staticClass:"driver-images"},[_c('img',{staticClass:"driver-img",attrs:{"src":driver.driverImg,"alt":driver.business + ' pic'}}),_vm._v(" "),_c('img',{staticClass:"car-img",attrs:{"src":driver.carImg,"alt":driver.business + ' car'}})]),_vm._v(" "),_c('div',{staticClass:"driver-details"},[_c('p',{staticClass:"driver-name"},[_c('a',{attrs:{"href":'/#/provider/' + driver.id,"target":"_blank"}},[_vm._v(_vm._s(driver.business))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(driver.car)+" | "+_vm._s(driver.plateNo))])])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.drivers.length === 0 && !_vm.loading),expression:"drivers.length === 0 && !loading"}],staticClass:"empty-result"},[_c('i',{staticClass:"far fa-frown-open fa-3x"}),_c('br'),_vm._v("\n      No record found!\n    ")])],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"fixed-bottom"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-3 small-offset-4 columns"},[_c('a',{staticClass:"button cta",on:{"click":_vm.closeDriverModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('a',{staticClass:"button cta success",on:{"click":_vm.save}},[_vm._v("Save")])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns pagination"},[_c('span',[_vm._v("Page")]),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.currentPage === 1 || _vm.loading},on:{"click":_vm.prev}},[_c('i',{staticClass:"fas fa-chevron-left"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentPage),expression:"currentPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.totalPage),function(i){return _c('option',{key:i,domProps:{"value":i}},[_vm._v(_vm._s(i))])}),0),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.isLastPage || _vm.loading},on:{"click":_vm.next}},[_c('i',{staticClass:"fas fa-chevron-right"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" "),_c('span',[_vm._v("Getting Drivers")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[_vm._v("Service Types Management")]),_vm._v(" "),_c('div',{staticClass:"left-panel"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedBrand),expression:"selectedBrand"}],staticClass:"brands",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedBrand=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changeBrand]}},_vm._l((_vm.brands),function(brand,index){return _c('option',{key:index,domProps:{"value":brand.id}},[_vm._v(_vm._s(brand.name))])}),0),_vm._v(" "),_c('a',{class:{'button cta success small block': true, 'disabled': _vm.serviceLoading},attrs:{"disabled":_vm.serviceLoading},on:{"click":_vm.initAddService}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v("\n      Add Service\n    ")]),_vm._v(" "),_c('div',{staticClass:"service-list"},[_c('ul',{class:{'disabled': _vm.serviceLoading}},[_c('draggable',_vm._b({attrs:{"disabled":_vm.serviceLoading},on:{"change":_vm.positionChange},model:{value:(_vm.serviceList),callback:function ($$v) {_vm.serviceList=$$v},expression:"serviceList"}},'draggable',_vm.dragOptions,false),[_c('transition-group',{attrs:{"type":"transition","name":!_vm.drag ? 'flip-list' : null}},_vm._l((_vm.serviceList),function(service){return _c('li',{key:service.id,class:{'active': _vm.activeService === service.id}},[_c('div',{staticClass:"left"},[_c('i',{staticClass:"fas fa-grip-lines drag-icon"})]),_vm._v(" "),_c('div',{staticClass:"mid",on:{"click":function($event){return _vm.loadDetails(service.id)}}},[_vm._v("\n                "+_vm._s(service.name)+"\n                "),_c('span',[_vm._v(_vm._s(service.id)+" - "+_vm._s(service.code))])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"switch"},[_c('div',{class:{'slider':true, 'active': service.enabled, 'disabled':_vm.enabledLoading['a' + service.id] || _vm.serviceAreaLoading},on:{"click":function($event){return _vm.toggleServiceEnable(service.id, service.enabled)}}}),_vm._v(" "),(service.enabled)?_c('span',{staticClass:"label"},[_vm._v("Enabled")]):_c('span',{staticClass:"label"},[_vm._v("Disabled")])])])])}),0)],1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.serviceLoading),expression:"serviceLoading"}],staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" Loading\n        ")])])],1)]),_vm._v(" "),_c('div',{class:['right-panel', _vm.activeService ? 'show' : 'hide']},[_c('transition',{attrs:{"name":"fade-right"}},[_c('service-details',{directives:[{name:"show",rawName:"v-show",value:(_vm.transitionRightPanel),expression:"transitionRightPanel"}],ref:"serviceDetails",on:{"response":_vm.response,"revalidate":_vm.showCloneModal,"clone":_vm.cloneResponse,"fieldChange":_vm.reRenderPreview}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeService !== ''),expression:"activeService !== ''"}],staticClass:"fixed-bottom"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column medium-12 end"},[_c('a',{class:{'button cta small long-btn':true, 'disabled':_vm.saving || _vm.currentDetailsId === 0},on:{"click":_vm.revalidate}},[_c('i',{staticClass:"far fa-clone"}),_vm._v("Use for other brands\n            ")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobile),expression:"isMobile"}],class:{'button cta small secondary short-btn':true, 'disabled':_vm.saving},on:{"click":_vm.cancelSelect}},[_c('i',{staticClass:"fas fa-ban"}),_vm._v("Cancel\n            ")]),_vm._v(" "),_c('a',{class:{'button cta small warning preview short-btn':true, 'disabled':_vm.saving},on:{"click":_vm.showPreview}},[_c('i',{staticClass:"far fa-eye"}),_vm._v("Preview\n            ")]),_vm._v(" "),_c('a',{class:{'button cta small success save short-btn':true, 'disabled':_vm.saving},on:{"click":_vm.save}},[(_vm.saving && !_vm.cloneModal.show)?_c('div',[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("Saving...")]):_c('div',[_c('i',{staticClass:"fas fa-save"}),_vm._v("Save")])])])])])])],1),_vm._v(" "),(_vm.renderPreview)?_c('preview'):_vm._e(),_vm._v(" "),_c('div',{class:{'op--modal-container':true, 'hide': !_vm.responseModal.show},on:{"click":_vm.closeResponseModal}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"response-box"},[(_vm.responseModal.status === 'success')?_c('i',{staticClass:"fas fa-check-circle fa-4x success"}):_c('i',{staticClass:"fas fa-times-circle fa-4x error"}),_vm._v(" "),_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.responseModal.message))]),_vm._v(" "),(_vm.responseModal.extra)?_c('span',{staticClass:"extra"},[_vm._v(_vm._s(_vm.responseModal.extra))]):_vm._e(),_vm._v(" "),(_vm.responseModal.status === 'success')?_c('a',{staticClass:"button cta block",on:{"click":_vm.openDriverModal}},[_vm._v("Enable on Drivers")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"button skip",on:{"click":_vm.closeResponseModal}},[_vm._v("Skip")])])])])]),_vm._v(" "),_c('div',{class:{'op--modal-container':true, 'hide': !_vm.cloneModal.show},on:{"click":_vm.closeCloneModal}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"clone-box"},[(_vm.cloneModal.status === '')?_c('div',[_c('p',[_vm._v("\n              Please select which brand you want to make a duplicate of\n              "),_c('b',[_vm._v(_vm._s(_vm.currentServiceLabel))]),_vm._v(".\n            ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cloneModal.brand),expression:"cloneModal.brand"}],staticClass:"brands",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.cloneModal, "brand", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.brands),function(brand,index){return _c('option',{key:index,domProps:{"value":brand.id}},[_vm._v(_vm._s(brand.name))])}),0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column medium-6 p-R-10"},[_c('a',{class:{'button cta warning block':true, 'disabled':_vm.saving},on:{"click":_vm.closeCloneModal}},[_vm._v("Cancel")])]),_vm._v(" "),_c('div',{staticClass:"column medium-6"},[_c('a',{class:{'button cta success block':true, 'disabled':_vm.saving},on:{"click":_vm.clone}},[(_vm.saving)?_c('div',[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("Saving...")]):_c('div',[_vm._v("Add")])])])])]):_c('div',[(_vm.cloneModal.status === 'success')?_c('i',{staticClass:"fas fa-check-circle fa-4x success"}):_c('i',{staticClass:"fas fa-times-circle fa-4x error"}),_vm._v(" "),_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.cloneModal.message))]),_vm._v(" "),(_vm.cloneModal.extra)?_c('span',{staticClass:"extra"},[_vm._v(_vm._s(_vm.cloneModal.extra))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"button cta block",on:{"click":_vm.closeCloneModal}},[_vm._v("Close")])])])])])]),_vm._v(" "),_c('div',{class:{'op--modal-container':true, 'hide': !_vm.driverModal.show},on:{"click":_vm.closeDriverModal}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"driver-box"},[_c('enable-drivers',{on:{"clicked":_vm.closeDriverModal,"enableModal":_vm.showEnableDriverModal}})],1)])])]),_vm._v(" "),_c('div',{class:{'op--modal-container':true, 'hide': !_vm.enableDriverModal.show},on:{"click":_vm.closeEnableDriverModal}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"enable-driver-modal"},[(_vm.enableDriverModal.status === 'success')?_c('i',{staticClass:"fas fa-check-circle fa-4x success"}):_c('i',{staticClass:"fas fa-times-circle fa-4x error"}),_vm._v(" "),_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.enableDriverModal.message))]),_vm._v(" "),_c('a',{staticClass:"button cta block",on:{"click":_vm.closeEnableDriverModal}},[_vm._v("Close")])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(555);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_891643a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1652);
function injectStyle (ssrContext) {
  __webpack_require__(1600)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-891643a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_891643a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1601);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1087a534", content, true, {});

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.header[data-v-891643a8] {\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  z-index: 2;\n}\n.geofences[data-v-891643a8] {\n  position: relative;\n}\n.geofence-container[data-v-891643a8] {\n  position: fixed;\n  top: 51px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.geofence[data-v-891643a8] {\n  position: absolute;\n  top: 0;\n  height: 100%;\n}\n.geofence.list[data-v-891643a8] {\n    left: 0;\n    overflow-y: auto;\n    width: 60%;\n    z-index: 1;\n    -webkit-box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.3);\n}\n.geofence.map[data-v-891643a8] {\n    left: 60%;\n    width: calc(100% - 60%);\n    z-index: 0;\n}\n.toggle-mobile[data-v-891643a8] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.toggle-mobile[data-v-891643a8] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.geofence.list[data-v-891643a8] {\n    width: 100%;\n}\n.geofence.map[data-v-891643a8] {\n    width: 100%;\n    z-index: 5;\n    left: 0;\n    top: 100%;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n}\n.geofence.map.showMapBox[data-v-891643a8] {\n      top: 0;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Geofences/index.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,6CAA6C;EAC7C,WAAW;CACZ;AACD;EACE,mBAAmB;CACpB;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;CACd;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,aAAa;CACd;AACD;IACI,QAAQ;IACR,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;IACI,UAAU;IACV,wBAAwB;IACxB,WAAW;CACd;AACD;EACE,cAAc;CACf;AACD;AACA;IACI,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;IACrB,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;CACpB;AACD;IACI,YAAY;CACf;AACD;IACI,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,UAAU;IACV,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,OAAO;CACZ;CACA","file":"index.vue","sourcesContent":["\n.header[data-v-891643a8] {\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  z-index: 2;\n}\n.geofences[data-v-891643a8] {\n  position: relative;\n}\n.geofence-container[data-v-891643a8] {\n  position: fixed;\n  top: 51px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.geofence[data-v-891643a8] {\n  position: absolute;\n  top: 0;\n  height: 100%;\n}\n.geofence.list[data-v-891643a8] {\n    left: 0;\n    overflow-y: auto;\n    width: 60%;\n    z-index: 1;\n    -webkit-box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.3);\n}\n.geofence.map[data-v-891643a8] {\n    left: 60%;\n    width: calc(100% - 60%);\n    z-index: 0;\n}\n.toggle-mobile[data-v-891643a8] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.toggle-mobile[data-v-891643a8] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.geofence.list[data-v-891643a8] {\n    width: 100%;\n}\n.geofence.map[data-v-891643a8] {\n    width: 100%;\n    z-index: 5;\n    left: 0;\n    top: 100%;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n}\n.geofence.map.showMapBox[data-v-891643a8] {\n      top: 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofenceList_vue__ = __webpack_require__(556);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_208a56f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofenceList_vue__ = __webpack_require__(1629);
function injectStyle (ssrContext) {
  __webpack_require__(1603)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-208a56f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofenceList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_208a56f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofenceList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1604);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("32d96e18", content, true, {});

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.geofences[data-v-208a56f6] {\n  padding: 20px;\n  display: block;\n  position: relative;\n  margin-bottom: 40px;\n}\n.geofence[data-v-208a56f6] {\n  border-radius: 3px;\n  margin-bottom: 15px;\n  overflow: hidden;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.geofence.show[data-v-208a56f6] {\n    overflow: visible;\n}\n.geofence .geofence-title[data-v-208a56f6] {\n    position: relative;\n    display: block;\n    padding: 10px 15px 12px;\n    background-color: #fff;\n    font-size: 14px;\n    font-weight: 700;\n    cursor: pointer;\n}\n.geofence .geofence-title.isMobile[data-v-208a56f6] {\n      display: none;\n}\n.geofence .geofence-title > span[data-v-208a56f6], .geofence .geofence-title > i[data-v-208a56f6] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.geofence .geofence-title .color[data-v-208a56f6] {\n      width: 13px;\n      height: 13px;\n      border: 1px solid rgba(0, 0, 0, 0.2);\n      border-radius: 3px;\n      margin-right: 10px;\n}\n.geofence .geofence-title i[data-v-208a56f6] {\n      color: #999;\n      position: absolute;\n      right: 0;\n      top: 0;\n      padding: 15px;\n      cursor: pointer;\n      color: #0D79F2;\n}\n.geofence .geofence-title .geofence-type[data-v-208a56f6] {\n      position: absolute;\n      top: 0;\n      right: 160px;\n      padding: 14px 10px;\n      font-size: 12px;\n      color: #555;\n}\n.geofence .geofence-title .show-map[data-v-208a56f6] {\n      font-size: 12px;\n      color: #0D79F2;\n      position: absolute;\n      top: 0;\n      right: 30px;\n      padding: 13px 10px;\n}\n.geofence .geofence-title .show-map > *[data-v-208a56f6] {\n        display: inline-block;\n        vertical-align: middle;\n        margin: 0;\n        width: auto;\n}\n.geofence .geofence-title .show-map input[data-v-208a56f6] {\n        margin-right: 3px;\n}\n.geofence[data-v-208a56f6]:last-child {\n    margin-bottom: 50px;\n}\n.geofence-form[data-v-208a56f6] {\n  overflow: hidden;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  background-color: #fff;\n  height: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.15);\n  opacity: 0;\n}\n.geofence-form.show[data-v-208a56f6] {\n    height: auto;\n    opacity: 1;\n    overflow: visible;\n}\n.geofence-list[data-v-208a56f6] {\n  margin-top: 90px;\n}\n.empty-list[data-v-208a56f6] {\n  text-align: center;\n  color: #777;\n  padding: 30px 0;\n}\n.empty-list .message[data-v-208a56f6] {\n    margin-top: 5px;\n    font-weight: 700;\n}\n.geofence-loading[data-v-208a56f6] {\n  position: absolute;\n  overflow: hidden;\n  top: -150%;\n  left: 0;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  z-index: 5;\n}\n.geofence-loading.show[data-v-208a56f6] {\n    top: 0;\n    opacity: 1;\n}\n.geofence-loading .loading-content[data-v-208a56f6] {\n    margin-top: 20px;\n}\n.geofence-loading .loading[data-v-208a56f6] {\n    background-color: #fff;\n    width: 170px;\n    margin: 0 auto;\n    border-radius: 3px;\n    text-align: center;\n    padding: 15px;\n    color: #777;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n.geofence-loading .loading .message[data-v-208a56f6] {\n      font-weight: 700;\n      color: #555;\n      margin-top: 5px;\n}\n@media only screen and (max-width: 430px) {\n.geofences[data-v-208a56f6] {\n    padding: 12px 2rem 80px;\n}\n.geofence-loading.show[data-v-208a56f6] {\n    height: 100vh;\n}\n.geofence-list[data-v-208a56f6] {\n    margin-top: 65px;\n}\n.geofence-list .geofence[data-v-208a56f6] {\n      border-radius: 5px;\n}\n.geofence-list .geofence .geofence-title[data-v-208a56f6] {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        padding: 10px;\n}\n.geofence-list .geofence .geofence-title.isDesktop[data-v-208a56f6] {\n          display: none;\n}\n.geofence-list .geofence .geofence-title.isMobile[data-v-208a56f6] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n.geofence-list .geofence .geofence-title div[data-v-208a56f6] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n}\n.geofence-list .geofence .geofence-title div span[data-v-208a56f6], .geofence-list .geofence .geofence-title div label[data-v-208a56f6], .geofence-list .geofence .geofence-title div i[data-v-208a56f6] {\n            position: unset;\n            padding: 0;\n}\n.geofence-list .geofence .geofence-title div span.geofence-type[data-v-208a56f6], .geofence-list .geofence .geofence-title div label.geofence-type[data-v-208a56f6], .geofence-list .geofence .geofence-title div i.geofence-type[data-v-208a56f6] {\n              color: #aaa;\n              font-size: 10px;\n}\n.geofence-list .geofence .geofence-title div span.fa[data-v-208a56f6], .geofence-list .geofence .geofence-title div label.fa[data-v-208a56f6], .geofence-list .geofence .geofence-title div i.fa[data-v-208a56f6] {\n              font-size: 16px;\n              display: -webkit-box;\n              display: -ms-flexbox;\n              display: flex;\n              -webkit-box-align: center;\n                  -ms-flex-align: center;\n                      align-items: center;\n              margin: 6px 0 2px;\n}\n.geofence-list .geofence .geofence-title .color[data-v-208a56f6] {\n          margin-right: 6px;\n}\n.geofence-list .geofence .geofence-title .show-map[data-v-208a56f6] {\n          font-size: 11px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Geofences/GeofenceList.vue"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,oBAAoB;CACrB;AACD;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,sCAAsC;EACtC,kDAAkD;UAC1C,0CAA0C;CACnD;AACD;IACI,kBAAkB;CACrB;AACD;IACI,mBAAmB;IACnB,eAAe;IACf,wBAAwB;IACxB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;CACnB;AACD;MACM,cAAc;CACnB;AACD;MACM,sBAAsB;MACtB,uBAAuB;CAC5B;AACD;MACM,YAAY;MACZ,aAAa;MACb,qCAAqC;MACrC,mBAAmB;MACnB,mBAAmB;CACxB;AACD;MACM,YAAY;MACZ,mBAAmB;MACnB,SAAS;MACT,OAAO;MACP,cAAc;MACd,gBAAgB;MAChB,eAAe;CACpB;AACD;MACM,mBAAmB;MACnB,OAAO;MACP,aAAa;MACb,mBAAmB;MACnB,gBAAgB;MAChB,YAAY;CACjB;AACD;MACM,gBAAgB;MAChB,eAAe;MACf,mBAAmB;MACnB,OAAO;MACP,YAAY;MACZ,mBAAmB;CACxB;AACD;QACQ,sBAAsB;QACtB,uBAAuB;QACvB,UAAU;QACV,YAAY;CACnB;AACD;QACQ,kBAAkB;CACzB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,0CAA0C;EAC1C,WAAW;CACZ;AACD;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;CACrB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;CACjB;AACD;IACI,gBAAgB;IAChB,iBAAiB;CACpB;AACD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;CACZ;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;IACI,iBAAiB;CACpB;AACD;IACI,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,iDAAiD;YACzC,yCAAyC;CACpD;AACD;MACM,iBAAiB;MACjB,YAAY;MACZ,gBAAgB;CACrB;AACD;AACA;IACI,wBAAwB;CAC3B;AACD;IACI,cAAc;CACjB;AACD;IACI,iBAAiB;CACpB;AACD;MACM,mBAAmB;CACxB;AACD;QACQ,6BAA6B;QAC7B,8BAA8B;YAC1B,2BAA2B;gBACvB,uBAAuB;QAC/B,cAAc;CACrB;AACD;UACU,cAAc;CACvB;AACD;UACU,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;CACvB;AACD;UACU,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;UACd,0BAA0B;cACtB,uBAAuB;kBACnB,oBAAoB;UAC5B,0BAA0B;cACtB,uBAAuB;kBACnB,+BAA+B;CAChD;AACD;YACY,gBAAgB;YAChB,WAAW;CACtB;AACD;cACc,YAAY;cACZ,gBAAgB;CAC7B;AACD;cACc,gBAAgB;cAChB,qBAAqB;cACrB,qBAAqB;cACrB,cAAc;cACd,0BAA0B;kBACtB,uBAAuB;sBACnB,oBAAoB;cAC5B,kBAAkB;CAC/B;AACD;UACU,kBAAkB;CAC3B;AACD;UACU,gBAAgB;CACzB;CACA","file":"GeofenceList.vue","sourcesContent":["\n.geofences[data-v-208a56f6] {\n  padding: 20px;\n  display: block;\n  position: relative;\n  margin-bottom: 40px;\n}\n.geofence[data-v-208a56f6] {\n  border-radius: 3px;\n  margin-bottom: 15px;\n  overflow: hidden;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n.geofence.show[data-v-208a56f6] {\n    overflow: visible;\n}\n.geofence .geofence-title[data-v-208a56f6] {\n    position: relative;\n    display: block;\n    padding: 10px 15px 12px;\n    background-color: #fff;\n    font-size: 14px;\n    font-weight: 700;\n    cursor: pointer;\n}\n.geofence .geofence-title.isMobile[data-v-208a56f6] {\n      display: none;\n}\n.geofence .geofence-title > span[data-v-208a56f6], .geofence .geofence-title > i[data-v-208a56f6] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.geofence .geofence-title .color[data-v-208a56f6] {\n      width: 13px;\n      height: 13px;\n      border: 1px solid rgba(0, 0, 0, 0.2);\n      border-radius: 3px;\n      margin-right: 10px;\n}\n.geofence .geofence-title i[data-v-208a56f6] {\n      color: #999;\n      position: absolute;\n      right: 0;\n      top: 0;\n      padding: 15px;\n      cursor: pointer;\n      color: #0D79F2;\n}\n.geofence .geofence-title .geofence-type[data-v-208a56f6] {\n      position: absolute;\n      top: 0;\n      right: 160px;\n      padding: 14px 10px;\n      font-size: 12px;\n      color: #555;\n}\n.geofence .geofence-title .show-map[data-v-208a56f6] {\n      font-size: 12px;\n      color: #0D79F2;\n      position: absolute;\n      top: 0;\n      right: 30px;\n      padding: 13px 10px;\n}\n.geofence .geofence-title .show-map > *[data-v-208a56f6] {\n        display: inline-block;\n        vertical-align: middle;\n        margin: 0;\n        width: auto;\n}\n.geofence .geofence-title .show-map input[data-v-208a56f6] {\n        margin-right: 3px;\n}\n.geofence[data-v-208a56f6]:last-child {\n    margin-bottom: 50px;\n}\n.geofence-form[data-v-208a56f6] {\n  overflow: hidden;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  background-color: #fff;\n  height: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.15);\n  opacity: 0;\n}\n.geofence-form.show[data-v-208a56f6] {\n    height: auto;\n    opacity: 1;\n    overflow: visible;\n}\n.geofence-list[data-v-208a56f6] {\n  margin-top: 90px;\n}\n.empty-list[data-v-208a56f6] {\n  text-align: center;\n  color: #777;\n  padding: 30px 0;\n}\n.empty-list .message[data-v-208a56f6] {\n    margin-top: 5px;\n    font-weight: 700;\n}\n.geofence-loading[data-v-208a56f6] {\n  position: absolute;\n  overflow: hidden;\n  top: -150%;\n  left: 0;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  z-index: 5;\n}\n.geofence-loading.show[data-v-208a56f6] {\n    top: 0;\n    opacity: 1;\n}\n.geofence-loading .loading-content[data-v-208a56f6] {\n    margin-top: 20px;\n}\n.geofence-loading .loading[data-v-208a56f6] {\n    background-color: #fff;\n    width: 170px;\n    margin: 0 auto;\n    border-radius: 3px;\n    text-align: center;\n    padding: 15px;\n    color: #777;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n.geofence-loading .loading .message[data-v-208a56f6] {\n      font-weight: 700;\n      color: #555;\n      margin-top: 5px;\n}\n@media only screen and (max-width: 430px) {\n.geofences[data-v-208a56f6] {\n    padding: 12px 2rem 80px;\n}\n.geofence-loading.show[data-v-208a56f6] {\n    height: 100vh;\n}\n.geofence-list[data-v-208a56f6] {\n    margin-top: 65px;\n}\n.geofence-list .geofence[data-v-208a56f6] {\n      border-radius: 5px;\n}\n.geofence-list .geofence .geofence-title[data-v-208a56f6] {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        padding: 10px;\n}\n.geofence-list .geofence .geofence-title.isDesktop[data-v-208a56f6] {\n          display: none;\n}\n.geofence-list .geofence .geofence-title.isMobile[data-v-208a56f6] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n.geofence-list .geofence .geofence-title div[data-v-208a56f6] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n}\n.geofence-list .geofence .geofence-title div span[data-v-208a56f6], .geofence-list .geofence .geofence-title div label[data-v-208a56f6], .geofence-list .geofence .geofence-title div i[data-v-208a56f6] {\n            position: unset;\n            padding: 0;\n}\n.geofence-list .geofence .geofence-title div span.geofence-type[data-v-208a56f6], .geofence-list .geofence .geofence-title div label.geofence-type[data-v-208a56f6], .geofence-list .geofence .geofence-title div i.geofence-type[data-v-208a56f6] {\n              color: #aaa;\n              font-size: 10px;\n}\n.geofence-list .geofence .geofence-title div span.fa[data-v-208a56f6], .geofence-list .geofence .geofence-title div label.fa[data-v-208a56f6], .geofence-list .geofence .geofence-title div i.fa[data-v-208a56f6] {\n              font-size: 16px;\n              display: -webkit-box;\n              display: -ms-flexbox;\n              display: flex;\n              -webkit-box-align: center;\n                  -ms-flex-align: center;\n                      align-items: center;\n              margin: 6px 0 2px;\n}\n.geofence-list .geofence .geofence-title .color[data-v-208a56f6] {\n          margin-right: 6px;\n}\n.geofence-list .geofence .geofence-title .show-map[data-v-208a56f6] {\n          font-size: 11px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofenceFields_vue__ = __webpack_require__(557);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e1e889c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofenceFields_vue__ = __webpack_require__(1624);
function injectStyle (ssrContext) {
  __webpack_require__(1606)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e1e889c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofenceFields_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e1e889c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofenceFields_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1607);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("ebbe9c38", content, true, {});

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.heading[data-v-5e1e889c] {\n  border-bottom: 2px solid #ccc;\n  margin-bottom: 10px;\n}\n.heading label[data-v-5e1e889c] {\n    font-weight: 600;\n    color: #0D79F2;\n    padding-top: 5px;\n    display: block;\n}\n.geofence-fields[data-v-5e1e889c] {\n  padding: 15px;\n  position: relative;\n}\n.geofence-controls[data-v-5e1e889c] {\n  margin-top: 15px;\n  border-top: 1px solid rgba(0, 0, 0, 0.15);\n  padding-top: 15px;\n}\n.input-field[data-v-5e1e889c] {\n  font-size: 14px;\n}\n.input-field label[data-v-5e1e889c] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n}\n.input-field label .center-point[data-v-5e1e889c] {\n      color: #888;\n      display: inline-block;\n      margin-left: 5px;\n}\n.input-field input[data-v-5e1e889c], .input-field textarea[data-v-5e1e889c] {\n    margin-top: 0;\n    padding: 7px 10px;\n}\n.input-field textarea[data-v-5e1e889c] {\n    resize: none;\n    height: 100px;\n}\n.checkbox-input > *[data-v-5e1e889c] {\n  display: inline-block;\n  vertical-align: middle;\n  width: auto;\n}\n.checkbox-input input[data-v-5e1e889c] {\n  margin-top: 0;\n}\n.checkbox-input span[data-v-5e1e889c] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #0D79F2;\n  height: 16px;\n  margin-left: 3px;\n}\n.autocomplete[data-v-5e1e889c] {\n  position: relative;\n  width: 100%;\n}\n.input-location[data-v-5e1e889c] {\n  margin: 5px 0 0;\n  color: #333;\n  line-height: inherit;\n  -webkit-transition: all .15s ease;\n  transition: all .15s ease;\n}\n.input-location.loading[data-v-5e1e889c] {\n    padding-right: 40px;\n}\n.input-location.has-error[data-v-5e1e889c] {\n    border-color: #f20d0d;\n}\n.input-location[data-v-5e1e889c]:disabled {\n    background: #eee;\n}\n.suggestions[data-v-5e1e889c] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  max-height: 150px;\n  z-index: 3;\n  list-style: none;\n  overflow: auto;\n  padding: 0;\n  margin: 0;\n  -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);\n}\n.suggestions li[data-v-5e1e889c] {\n    background: #f6f6f6;\n    padding: 8px 10px;\n    width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor: pointer;\n    border-bottom: 1px solid #bbb;\n    color: #333;\n}\n.suggestions li[data-v-5e1e889c]:last-child {\n      border-bottom: none;\n}\n.suggestions li i[data-v-5e1e889c] {\n      margin-right: 5px;\n}\n.suggestions li span[data-v-5e1e889c] {\n      font-size: 13px;\n}\n.suggestions li .fa-exclamation-triangle[data-v-5e1e889c] {\n      color: #e2c84a;\n}\n.suggestions li .fa-map-marker[data-v-5e1e889c] {\n      color: #ea5c5c;\n}\n.suggestions li[data-v-5e1e889c]:hover {\n      background: #0D79F2;\n      color: #fff;\n}\n.suggestions li:hover i[data-v-5e1e889c] {\n        color: #fff;\n}\n.suggestions li.empty[data-v-5e1e889c] {\n      cursor: default;\n}\n.color-input-box[data-v-5e1e889c] {\n  position: relative;\n}\n.color-input-box .palette[data-v-5e1e889c] {\n    border-radius: 3px;\n    position: absolute;\n    top: 50%;\n    right: 10px;\n    margin-top: -10px;\n    width: 20px;\n    height: 20px;\n    z-index: 2;\n    cursor: pointer;\n    -webkit-box-shadow: inset 0 0 1px 1px rgba(0, 0, 0, 0.25);\n            box-shadow: inset 0 0 1px 1px rgba(0, 0, 0, 0.25);\n}\n.slide-overlay-color[data-v-5e1e889c] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 2;\n}\n.upload-row[data-v-5e1e889c] {\n  position: relative;\n  z-index: 2;\n}\n.upload-row.below[data-v-5e1e889c] {\n    z-index: 1;\n}\n.upload-loading-bg[data-v-5e1e889c] {\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.75);\n}\n.upload-box[data-v-5e1e889c] {\n  position: relative;\n  border: 1px solid #ffc23a;\n  background: #fffee9;\n  padding: 10px;\n  font-size: 14px;\n  margin: 20px 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.upload-box .upload-file[data-v-5e1e889c] {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n    font-size: 13px;\n    line-height: 24px;\n}\n.upload-box .button[data-v-5e1e889c] {\n    padding: 6px 10px;\n    margin-left: 5px;\n    float: right;\n    text-transform: uppercase;\n}\n.upload-box.airline[data-v-5e1e889c] {\n    border: 1px solid #48e02c;\n    background: #eeffe9;\n}\n.upload-box.has-message[data-v-5e1e889c] {\n    margin-bottom: 15px;\n}\n.upload-message[data-v-5e1e889c] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  color: #2bc74d;\n  font-weight: 600;\n}\n.upload-message.error[data-v-5e1e889c] {\n    color: #f20d0d;\n}\n.loader[data-v-5e1e889c] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 3;\n}\n.loader .modal-table[data-v-5e1e889c] {\n    display: table;\n    width: 100%;\n    height: 100%;\n}\n.loader .modal-content[data-v-5e1e889c] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.loader .box[data-v-5e1e889c] {\n    margin: auto;\n    background: #fff;\n    width: 400px;\n    text-align: center;\n    padding: 20px;\n    position: relative;\n}\n.loader .box #scrollHere[data-v-5e1e889c] {\n      position: absolute;\n      top: -60px;\n      left: 0;\n      width: 100%;\n      height: 20px;\n}\n.loader .box i[data-v-5e1e889c] {\n      vertical-align: middle;\n      margin-right: 5px;\n}\n.loader .box .fa-spinner[data-v-5e1e889c] {\n      color: #0d79f2;\n}\n.loader .box .response[data-v-5e1e889c] {\n      display: block;\n      margin-bottom: 10px;\n}\n.loader .box .fa-check-circle[data-v-5e1e889c] {\n      color: #59e484;\n}\n.loader .box .fa-times-circle[data-v-5e1e889c] {\n      color: #f13434;\n}\n.loader .box span[data-v-5e1e889c] {\n      display: inline-block;\n      vertical-align: middle;\n      font-weight: 600;\n      color: #555;\n}\n.loader .box .message[data-v-5e1e889c] {\n      display: block;\n      margin-bottom: 20px;\n}\n.error-message[data-v-5e1e889c] {\n  margin-top: 10px;\n  font-size: 13px;\n  font-weight: 700;\n  border: 1px solid #F20D0D;\n  border-radius: 3px;\n  color: #F20D0D;\n  padding: 15px;\n}\n.error-message ul[data-v-5e1e889c] {\n    margin-bottom: 0;\n    margin-top: 5px;\n}\n.padding-L[data-v-5e1e889c] {\n  padding-left: 7px;\n}\n.padding-R[data-v-5e1e889c] {\n  padding-right: 7px;\n}\n.margin-T[data-v-5e1e889c] {\n  margin-top: 15px;\n}\n.margin-B[data-v-5e1e889c] {\n  margin-bottom: 10px;\n}\n.expand-enter-active[data-v-5e1e889c], .expand-leave-active[data-v-5e1e889c] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.expand-enter[data-v-5e1e889c], .expand-leave-to[data-v-5e1e889c] {\n  -webkit-transform: scale(0.8);\n          transform: scale(0.8);\n  opacity: 0;\n}\n.slide-down-enter-active[data-v-5e1e889c], .slide-down-leave-active[data-v-5e1e889c] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-5e1e889c], .slide-down-leave-to[data-v-5e1e889c] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.hideMobile[data-v-5e1e889c] {\n    display: none;\n}\n.padding-R[data-v-5e1e889c], .padding-L[data-v-5e1e889c] {\n    padding: 0;\n}\n.small-2[data-v-5e1e889c], .small-5[data-v-5e1e889c], .small-6[data-v-5e1e889c], .small-3[data-v-5e1e889c] {\n    width: 100%;\n}\n.small-offset-8[data-v-5e1e889c], .small-offset-6[data-v-5e1e889c], .small-offset-4[data-v-5e1e889c] {\n    margin: 0;\n}\n.geofence-fields[data-v-5e1e889c] {\n    padding: 12px;\n}\n.heading[data-v-5e1e889c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n        -ms-flex-direction: column-reverse;\n            flex-direction: column-reverse;\n}\n.geofence-controls[data-v-5e1e889c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    gap: 5px;\n}\n.geofence-controls.service-area[data-v-5e1e889c] {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Geofences/GeofenceFields.vue"],"names":[],"mappings":";AACA;EACE,8BAA8B;EAC9B,oBAAoB;CACrB;AACD;IACI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,eAAe;CAClB;AACD;EACE,cAAc;EACd,mBAAmB;CACpB;AACD;EACE,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;CACnB;AACD;EACE,gBAAgB;CACjB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;CAClB;AACD;MACM,YAAY;MACZ,sBAAsB;MACtB,iBAAiB;CACtB;AACD;IACI,cAAc;IACd,kBAAkB;CACrB;AACD;IACI,aAAa;IACb,cAAc;CACjB;AACD;EACE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;CACb;AACD;EACE,cAAc;CACf;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,iBAAiB;CAClB;AACD;EACE,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;IACI,oBAAoB;CACvB;AACD;IACI,sBAAsB;CACzB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,UAAU;EACV,mDAAmD;UAC3C,2CAA2C;CACpD;AACD;IACI,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,8BAA8B;IAC9B,YAAY;CACf;AACD;MACM,oBAAoB;CACzB;AACD;MACM,kBAAkB;CACvB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,oBAAoB;MACpB,YAAY;CACjB;AACD;QACQ,YAAY;CACnB;AACD;MACM,gBAAgB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,0DAA0D;YAClD,kDAAkD;CAC7D;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,WAAW;CACZ;AACD;EACE,mBAAmB;EACnB,WAAW;CACZ;AACD;IACI,WAAW;CACd;AACD;EACE,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,gCAAgC;CACjC;AACD;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;CACrB;AACD;IACI,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,0BAA0B;CAC7B;AACD;IACI,0BAA0B;IAC1B,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,iBAAiB;CAClB;AACD;IACI,eAAe;CAClB;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,WAAW;CACZ;AACD;IACI,eAAe;IACf,YAAY;IACZ,aAAa;CAChB;AACD;IACI,oBAAoB;IACpB,uBAAuB;CAC1B;AACD;IACI,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,mBAAmB;CACtB;AACD;MACM,mBAAmB;MACnB,WAAW;MACX,QAAQ;MACR,YAAY;MACZ,aAAa;CAClB;AACD;MACM,uBAAuB;MACvB,kBAAkB;CACvB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;MACf,oBAAoB;CACzB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,sBAAsB;MACtB,uBAAuB;MACvB,iBAAiB;MACjB,YAAY;CACjB;AACD;MACM,eAAe;MACf,oBAAoB;CACzB;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,cAAc;CACf;AACD;IACI,iBAAiB;IACjB,gBAAgB;CACnB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,8BAA8B;UACtB,sBAAsB;EAC9B,WAAW;CACZ;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ;AACD;AACA;IACI,cAAc;CACjB;AACD;IACI,WAAW;CACd;AACD;IACI,YAAY;CACf;AACD;IACI,UAAU;CACb;AACD;IACI,cAAc;CACjB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,6BAA6B;IAC7B,+BAA+B;QAC3B,mCAAmC;YAC/B,+BAA+B;CAC1C;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,yBAAyB;QACrB,sBAAsB;YAClB,wBAAwB;IAChC,SAAS;CACZ;AACD;MACM,cAAc;MACd,sCAAsC;CAC3C;CACA","file":"GeofenceFields.vue","sourcesContent":["\n.heading[data-v-5e1e889c] {\n  border-bottom: 2px solid #ccc;\n  margin-bottom: 10px;\n}\n.heading label[data-v-5e1e889c] {\n    font-weight: 600;\n    color: #0D79F2;\n    padding-top: 5px;\n    display: block;\n}\n.geofence-fields[data-v-5e1e889c] {\n  padding: 15px;\n  position: relative;\n}\n.geofence-controls[data-v-5e1e889c] {\n  margin-top: 15px;\n  border-top: 1px solid rgba(0, 0, 0, 0.15);\n  padding-top: 15px;\n}\n.input-field[data-v-5e1e889c] {\n  font-size: 14px;\n}\n.input-field label[data-v-5e1e889c] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n}\n.input-field label .center-point[data-v-5e1e889c] {\n      color: #888;\n      display: inline-block;\n      margin-left: 5px;\n}\n.input-field input[data-v-5e1e889c], .input-field textarea[data-v-5e1e889c] {\n    margin-top: 0;\n    padding: 7px 10px;\n}\n.input-field textarea[data-v-5e1e889c] {\n    resize: none;\n    height: 100px;\n}\n.checkbox-input > *[data-v-5e1e889c] {\n  display: inline-block;\n  vertical-align: middle;\n  width: auto;\n}\n.checkbox-input input[data-v-5e1e889c] {\n  margin-top: 0;\n}\n.checkbox-input span[data-v-5e1e889c] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #0D79F2;\n  height: 16px;\n  margin-left: 3px;\n}\n.autocomplete[data-v-5e1e889c] {\n  position: relative;\n  width: 100%;\n}\n.input-location[data-v-5e1e889c] {\n  margin: 5px 0 0;\n  color: #333;\n  line-height: inherit;\n  -webkit-transition: all .15s ease;\n  transition: all .15s ease;\n}\n.input-location.loading[data-v-5e1e889c] {\n    padding-right: 40px;\n}\n.input-location.has-error[data-v-5e1e889c] {\n    border-color: #f20d0d;\n}\n.input-location[data-v-5e1e889c]:disabled {\n    background: #eee;\n}\n.suggestions[data-v-5e1e889c] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  max-height: 150px;\n  z-index: 3;\n  list-style: none;\n  overflow: auto;\n  padding: 0;\n  margin: 0;\n  -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);\n}\n.suggestions li[data-v-5e1e889c] {\n    background: #f6f6f6;\n    padding: 8px 10px;\n    width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor: pointer;\n    border-bottom: 1px solid #bbb;\n    color: #333;\n}\n.suggestions li[data-v-5e1e889c]:last-child {\n      border-bottom: none;\n}\n.suggestions li i[data-v-5e1e889c] {\n      margin-right: 5px;\n}\n.suggestions li span[data-v-5e1e889c] {\n      font-size: 13px;\n}\n.suggestions li .fa-exclamation-triangle[data-v-5e1e889c] {\n      color: #e2c84a;\n}\n.suggestions li .fa-map-marker[data-v-5e1e889c] {\n      color: #ea5c5c;\n}\n.suggestions li[data-v-5e1e889c]:hover {\n      background: #0D79F2;\n      color: #fff;\n}\n.suggestions li:hover i[data-v-5e1e889c] {\n        color: #fff;\n}\n.suggestions li.empty[data-v-5e1e889c] {\n      cursor: default;\n}\n.color-input-box[data-v-5e1e889c] {\n  position: relative;\n}\n.color-input-box .palette[data-v-5e1e889c] {\n    border-radius: 3px;\n    position: absolute;\n    top: 50%;\n    right: 10px;\n    margin-top: -10px;\n    width: 20px;\n    height: 20px;\n    z-index: 2;\n    cursor: pointer;\n    -webkit-box-shadow: inset 0 0 1px 1px rgba(0, 0, 0, 0.25);\n            box-shadow: inset 0 0 1px 1px rgba(0, 0, 0, 0.25);\n}\n.slide-overlay-color[data-v-5e1e889c] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 2;\n}\n.upload-row[data-v-5e1e889c] {\n  position: relative;\n  z-index: 2;\n}\n.upload-row.below[data-v-5e1e889c] {\n    z-index: 1;\n}\n.upload-loading-bg[data-v-5e1e889c] {\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.75);\n}\n.upload-box[data-v-5e1e889c] {\n  position: relative;\n  border: 1px solid #ffc23a;\n  background: #fffee9;\n  padding: 10px;\n  font-size: 14px;\n  margin: 20px 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.upload-box .upload-file[data-v-5e1e889c] {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n    font-size: 13px;\n    line-height: 24px;\n}\n.upload-box .button[data-v-5e1e889c] {\n    padding: 6px 10px;\n    margin-left: 5px;\n    float: right;\n    text-transform: uppercase;\n}\n.upload-box.airline[data-v-5e1e889c] {\n    border: 1px solid #48e02c;\n    background: #eeffe9;\n}\n.upload-box.has-message[data-v-5e1e889c] {\n    margin-bottom: 15px;\n}\n.upload-message[data-v-5e1e889c] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  color: #2bc74d;\n  font-weight: 600;\n}\n.upload-message.error[data-v-5e1e889c] {\n    color: #f20d0d;\n}\n.loader[data-v-5e1e889c] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 3;\n}\n.loader .modal-table[data-v-5e1e889c] {\n    display: table;\n    width: 100%;\n    height: 100%;\n}\n.loader .modal-content[data-v-5e1e889c] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.loader .box[data-v-5e1e889c] {\n    margin: auto;\n    background: #fff;\n    width: 400px;\n    text-align: center;\n    padding: 20px;\n    position: relative;\n}\n.loader .box #scrollHere[data-v-5e1e889c] {\n      position: absolute;\n      top: -60px;\n      left: 0;\n      width: 100%;\n      height: 20px;\n}\n.loader .box i[data-v-5e1e889c] {\n      vertical-align: middle;\n      margin-right: 5px;\n}\n.loader .box .fa-spinner[data-v-5e1e889c] {\n      color: #0d79f2;\n}\n.loader .box .response[data-v-5e1e889c] {\n      display: block;\n      margin-bottom: 10px;\n}\n.loader .box .fa-check-circle[data-v-5e1e889c] {\n      color: #59e484;\n}\n.loader .box .fa-times-circle[data-v-5e1e889c] {\n      color: #f13434;\n}\n.loader .box span[data-v-5e1e889c] {\n      display: inline-block;\n      vertical-align: middle;\n      font-weight: 600;\n      color: #555;\n}\n.loader .box .message[data-v-5e1e889c] {\n      display: block;\n      margin-bottom: 20px;\n}\n.error-message[data-v-5e1e889c] {\n  margin-top: 10px;\n  font-size: 13px;\n  font-weight: 700;\n  border: 1px solid #F20D0D;\n  border-radius: 3px;\n  color: #F20D0D;\n  padding: 15px;\n}\n.error-message ul[data-v-5e1e889c] {\n    margin-bottom: 0;\n    margin-top: 5px;\n}\n.padding-L[data-v-5e1e889c] {\n  padding-left: 7px;\n}\n.padding-R[data-v-5e1e889c] {\n  padding-right: 7px;\n}\n.margin-T[data-v-5e1e889c] {\n  margin-top: 15px;\n}\n.margin-B[data-v-5e1e889c] {\n  margin-bottom: 10px;\n}\n.expand-enter-active[data-v-5e1e889c], .expand-leave-active[data-v-5e1e889c] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.expand-enter[data-v-5e1e889c], .expand-leave-to[data-v-5e1e889c] {\n  -webkit-transform: scale(0.8);\n          transform: scale(0.8);\n  opacity: 0;\n}\n.slide-down-enter-active[data-v-5e1e889c], .slide-down-leave-active[data-v-5e1e889c] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-5e1e889c], .slide-down-leave-to[data-v-5e1e889c] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.hideMobile[data-v-5e1e889c] {\n    display: none;\n}\n.padding-R[data-v-5e1e889c], .padding-L[data-v-5e1e889c] {\n    padding: 0;\n}\n.small-2[data-v-5e1e889c], .small-5[data-v-5e1e889c], .small-6[data-v-5e1e889c], .small-3[data-v-5e1e889c] {\n    width: 100%;\n}\n.small-offset-8[data-v-5e1e889c], .small-offset-6[data-v-5e1e889c], .small-offset-4[data-v-5e1e889c] {\n    margin: 0;\n}\n.geofence-fields[data-v-5e1e889c] {\n    padding: 12px;\n}\n.heading[data-v-5e1e889c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n        -ms-flex-direction: column-reverse;\n            flex-direction: column-reverse;\n}\n.geofence-controls[data-v-5e1e889c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    gap: 5px;\n}\n.geofence-controls.service-area[data-v-5e1e889c] {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofenceFieldsAirport_vue__ = __webpack_require__(558);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2999dc52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofenceFieldsAirport_vue__ = __webpack_require__(1611);
function injectStyle (ssrContext) {
  __webpack_require__(1609)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2999dc52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofenceFieldsAirport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2999dc52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofenceFieldsAirport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1610);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("db697866", content, true, {});

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.input-field[data-v-2999dc52] {\n  font-size: 14px;\n}\n.input-field label[data-v-2999dc52] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n}\n.input-field input[data-v-2999dc52], .input-field textarea[data-v-2999dc52] {\n    margin-top: 0;\n    padding: 7px 10px;\n}\n.input-field textarea[data-v-2999dc52] {\n    resize: none;\n    height: 100px;\n}\n.checkbox-input > *[data-v-2999dc52] {\n  display: inline-block;\n  vertical-align: middle;\n  width: auto;\n}\n.checkbox-input input[data-v-2999dc52] {\n  margin-top: 0;\n}\n.checkbox-input span[data-v-2999dc52] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #777;\n  height: 16px;\n  margin-left: 3px;\n  cursor: pointer;\n}\n.arrival-instruction-box[data-v-2999dc52] {\n  border: 1px solid #ccc;\n  padding: 15px;\n  background: #fafafa;\n  margin-top: 15px;\n}\n.arrival-instruction-box .heading[data-v-2999dc52] {\n    font-size: 18px;\n    font-weight: 600;\n    margin-bottom: 10px;\n    position: relative;\n}\n.arrival-instruction-box .heading label[data-v-2999dc52] {\n      color: #555;\n}\n.arrival-instruction-box .heading .preview[data-v-2999dc52] {\n      position: absolute;\n      top: 0;\n      right: 0;\n      text-align: center;\n      line-height: 1;\n      padding: 5px;\n      border: 1px solid #ccc;\n      border-radius: 4px;\n      background: #fff;\n      color: #555;\n      -webkit-box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1);\n              box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1);\n      cursor: pointer;\n}\n.arrival-instruction-box .heading .preview i[data-v-2999dc52] {\n        margin-bottom: 1px;\n}\n.arrival-instruction-box .heading .preview span[data-v-2999dc52] {\n        font-size: 9px;\n        display: block;\n}\n.arrival-instruction-box .error-message[data-v-2999dc52] {\n    font-size: 12px;\n    color: #ec3e3e;\n    line-height: 1;\n    margin: 2px 0;\n}\n.sub-geofences[data-v-2999dc52] {\n  margin-bottom: 20px;\n}\n.sub-geofences .heading[data-v-2999dc52] {\n    border-bottom: 2px solid #ccc;\n}\n.sub-geofences .heading label[data-v-2999dc52] {\n      font-weight: 600;\n      color: #0D79F2;\n      padding-top: 5px;\n      display: block;\n}\n.sub-geofences .heading .add[data-v-2999dc52] {\n      float: right;\n      padding-bottom: 5px;\n}\n.sub-geofences .heading .add span[data-v-2999dc52] {\n        display: inline-block;\n        margin-right: 5px;\n        font-weight: 600;\n        font-size: 13px;\n        color: #777;\n}\n.sub-geofences .heading .add select[data-v-2999dc52] {\n        width: 150px;\n}\n.sub-geofences .heading .add select[disabled][data-v-2999dc52] {\n          background-color: #ebebe4;\n}\n.sub-geofences .loader[data-v-2999dc52] {\n    padding: 10px 5px;\n    font-size: 14px;\n    color: #555;\n}\n.sub-geofences .loader i[data-v-2999dc52] {\n      margin-right: 5px;\n}\n.sub-geofences .list[data-v-2999dc52] {\n    margin: 5px 0;\n    padding: 0;\n}\n.sub-geofences .list.disabled[data-v-2999dc52] {\n      opacity: .6;\n}\n.sub-geofences .list .item[data-v-2999dc52] {\n      padding: 5px 10px;\n      border-bottom: 1px solid #eee;\n      cursor: pointer;\n      position: relative;\n}\n.sub-geofences .list .item[data-v-2999dc52]:nth-child(even) {\n        background: #fafafa;\n}\n.sub-geofences .list .item.sortable-chosen[data-v-2999dc52] {\n        background: #b2e6ff;\n}\n.sub-geofences .list .fa-bars[data-v-2999dc52] {\n      color: #bbb;\n      margin-right: 5px;\n}\n.sub-geofences .list span[data-v-2999dc52] {\n      font-size: 14px;\n      color: #555;\n      font-weight: 600;\n}\n.sub-geofences .list .fa-times[data-v-2999dc52] {\n      float: right;\n      color: #e62a2a;\n      font-size: 21px;\n      margin: 2px 5px 0 0;\n}\n.confirm[data-v-2999dc52] {\n  position: absolute;\n  right: 0;\n  top: 5px;\n  line-height: 24px;\n}\n.confirm span[data-v-2999dc52] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.confirm .button[data-v-2999dc52] {\n    vertical-align: middle;\n    padding: 4px 13px 5px;\n}\n.padding-L[data-v-2999dc52] {\n  padding-left: 7px;\n}\n.padding-R[data-v-2999dc52] {\n  padding-right: 7px;\n}\n.margin-T[data-v-2999dc52] {\n  margin-top: 15px;\n}\n.clear[data-v-2999dc52] {\n  clear: both;\n}\n.slide-left-enter-active[data-v-2999dc52], .slide-left-leave-active[data-v-2999dc52] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-left-enter[data-v-2999dc52], .slide-left-leave-to[data-v-2999dc52] {\n  -webkit-transform: translateX(-20px);\n          transform: translateX(-20px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.padding-R[data-v-2999dc52], .padding-L[data-v-2999dc52] {\n    padding: 0;\n}\n.margin-T[data-v-2999dc52] {\n    margin-top: 5px;\n}\n.small-2[data-v-2999dc52], .small-5[data-v-2999dc52], .small-6[data-v-2999dc52], .small-3[data-v-2999dc52], .small-4[data-v-2999dc52], .small-8[data-v-2999dc52] {\n    width: 100%;\n}\n.small-6[data-v-2999dc52] {\n    margin-bottom: 5px;\n}\n.confirm[data-v-2999dc52] {\n    background-color: #fff;\n    width: 100%;\n    text-align: right;\n}\n.heading[data-v-2999dc52] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n        -ms-flex-direction: column-reverse;\n            flex-direction: column-reverse;\n}\n.heading .add[data-v-2999dc52] {\n      text-align: right;\n}\n.heading label[data-v-2999dc52] {\n      margin-bottom: 5px;\n}\n.sub-geofences .list span[data-v-2999dc52] {\n    font-size: 12px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Geofences/GeofenceFieldsAirport.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;CACjB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,cAAc;IACd,kBAAkB;CACrB;AACD;IACI,aAAa;IACb,cAAc;CACjB;AACD;EACE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;CACb;AACD;EACE,cAAc;CACf;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;CACjB;AACD;EACE,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;CAClB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;CACtB;AACD;MACM,YAAY;CACjB;AACD;MACM,mBAAmB;MACnB,OAAO;MACP,SAAS;MACT,mBAAmB;MACnB,eAAe;MACf,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,iBAAiB;MACjB,YAAY;MACZ,mDAAmD;cAC3C,2CAA2C;MACnD,gBAAgB;CACrB;AACD;QACQ,mBAAmB;CAC1B;AACD;QACQ,eAAe;QACf,eAAe;CACtB;AACD;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,cAAc;CACjB;AACD;EACE,oBAAoB;CACrB;AACD;IACI,8BAA8B;CACjC;AACD;MACM,iBAAiB;MACjB,eAAe;MACf,iBAAiB;MACjB,eAAe;CACpB;AACD;MACM,aAAa;MACb,oBAAoB;CACzB;AACD;QACQ,sBAAsB;QACtB,kBAAkB;QAClB,iBAAiB;QACjB,gBAAgB;QAChB,YAAY;CACnB;AACD;QACQ,aAAa;CACpB;AACD;UACU,0BAA0B;CACnC;AACD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;CACf;AACD;MACM,kBAAkB;CACvB;AACD;IACI,cAAc;IACd,WAAW;CACd;AACD;MACM,YAAY;CACjB;AACD;MACM,kBAAkB;MAClB,8BAA8B;MAC9B,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,oBAAoB;CAC3B;AACD;MACM,YAAY;MACZ,kBAAkB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,iBAAiB;CACtB;AACD;MACM,aAAa;MACb,eAAe;MACf,gBAAgB;MAChB,oBAAoB;CACzB;AACD;EACE,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,kBAAkB;CACnB;AACD;IACI,sBAAsB;IACtB,uBAAuB;CAC1B;AACD;IACI,uBAAuB;IACvB,sBAAsB;CACzB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,YAAY;CACb;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ;AACD;AACA;IACI,WAAW;CACd;AACD;IACI,gBAAgB;CACnB;AACD;IACI,YAAY;CACf;AACD;IACI,mBAAmB;CACtB;AACD;IACI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;CACrB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,6BAA6B;IAC7B,+BAA+B;QAC3B,mCAAmC;YAC/B,+BAA+B;CAC1C;AACD;MACM,kBAAkB;CACvB;AACD;MACM,mBAAmB;CACxB;AACD;IACI,gBAAgB;CACnB;CACA","file":"GeofenceFieldsAirport.vue","sourcesContent":["\n.input-field[data-v-2999dc52] {\n  font-size: 14px;\n}\n.input-field label[data-v-2999dc52] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n}\n.input-field input[data-v-2999dc52], .input-field textarea[data-v-2999dc52] {\n    margin-top: 0;\n    padding: 7px 10px;\n}\n.input-field textarea[data-v-2999dc52] {\n    resize: none;\n    height: 100px;\n}\n.checkbox-input > *[data-v-2999dc52] {\n  display: inline-block;\n  vertical-align: middle;\n  width: auto;\n}\n.checkbox-input input[data-v-2999dc52] {\n  margin-top: 0;\n}\n.checkbox-input span[data-v-2999dc52] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #777;\n  height: 16px;\n  margin-left: 3px;\n  cursor: pointer;\n}\n.arrival-instruction-box[data-v-2999dc52] {\n  border: 1px solid #ccc;\n  padding: 15px;\n  background: #fafafa;\n  margin-top: 15px;\n}\n.arrival-instruction-box .heading[data-v-2999dc52] {\n    font-size: 18px;\n    font-weight: 600;\n    margin-bottom: 10px;\n    position: relative;\n}\n.arrival-instruction-box .heading label[data-v-2999dc52] {\n      color: #555;\n}\n.arrival-instruction-box .heading .preview[data-v-2999dc52] {\n      position: absolute;\n      top: 0;\n      right: 0;\n      text-align: center;\n      line-height: 1;\n      padding: 5px;\n      border: 1px solid #ccc;\n      border-radius: 4px;\n      background: #fff;\n      color: #555;\n      -webkit-box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1);\n              box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1);\n      cursor: pointer;\n}\n.arrival-instruction-box .heading .preview i[data-v-2999dc52] {\n        margin-bottom: 1px;\n}\n.arrival-instruction-box .heading .preview span[data-v-2999dc52] {\n        font-size: 9px;\n        display: block;\n}\n.arrival-instruction-box .error-message[data-v-2999dc52] {\n    font-size: 12px;\n    color: #ec3e3e;\n    line-height: 1;\n    margin: 2px 0;\n}\n.sub-geofences[data-v-2999dc52] {\n  margin-bottom: 20px;\n}\n.sub-geofences .heading[data-v-2999dc52] {\n    border-bottom: 2px solid #ccc;\n}\n.sub-geofences .heading label[data-v-2999dc52] {\n      font-weight: 600;\n      color: #0D79F2;\n      padding-top: 5px;\n      display: block;\n}\n.sub-geofences .heading .add[data-v-2999dc52] {\n      float: right;\n      padding-bottom: 5px;\n}\n.sub-geofences .heading .add span[data-v-2999dc52] {\n        display: inline-block;\n        margin-right: 5px;\n        font-weight: 600;\n        font-size: 13px;\n        color: #777;\n}\n.sub-geofences .heading .add select[data-v-2999dc52] {\n        width: 150px;\n}\n.sub-geofences .heading .add select[disabled][data-v-2999dc52] {\n          background-color: #ebebe4;\n}\n.sub-geofences .loader[data-v-2999dc52] {\n    padding: 10px 5px;\n    font-size: 14px;\n    color: #555;\n}\n.sub-geofences .loader i[data-v-2999dc52] {\n      margin-right: 5px;\n}\n.sub-geofences .list[data-v-2999dc52] {\n    margin: 5px 0;\n    padding: 0;\n}\n.sub-geofences .list.disabled[data-v-2999dc52] {\n      opacity: .6;\n}\n.sub-geofences .list .item[data-v-2999dc52] {\n      padding: 5px 10px;\n      border-bottom: 1px solid #eee;\n      cursor: pointer;\n      position: relative;\n}\n.sub-geofences .list .item[data-v-2999dc52]:nth-child(even) {\n        background: #fafafa;\n}\n.sub-geofences .list .item.sortable-chosen[data-v-2999dc52] {\n        background: #b2e6ff;\n}\n.sub-geofences .list .fa-bars[data-v-2999dc52] {\n      color: #bbb;\n      margin-right: 5px;\n}\n.sub-geofences .list span[data-v-2999dc52] {\n      font-size: 14px;\n      color: #555;\n      font-weight: 600;\n}\n.sub-geofences .list .fa-times[data-v-2999dc52] {\n      float: right;\n      color: #e62a2a;\n      font-size: 21px;\n      margin: 2px 5px 0 0;\n}\n.confirm[data-v-2999dc52] {\n  position: absolute;\n  right: 0;\n  top: 5px;\n  line-height: 24px;\n}\n.confirm span[data-v-2999dc52] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.confirm .button[data-v-2999dc52] {\n    vertical-align: middle;\n    padding: 4px 13px 5px;\n}\n.padding-L[data-v-2999dc52] {\n  padding-left: 7px;\n}\n.padding-R[data-v-2999dc52] {\n  padding-right: 7px;\n}\n.margin-T[data-v-2999dc52] {\n  margin-top: 15px;\n}\n.clear[data-v-2999dc52] {\n  clear: both;\n}\n.slide-left-enter-active[data-v-2999dc52], .slide-left-leave-active[data-v-2999dc52] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-left-enter[data-v-2999dc52], .slide-left-leave-to[data-v-2999dc52] {\n  -webkit-transform: translateX(-20px);\n          transform: translateX(-20px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.padding-R[data-v-2999dc52], .padding-L[data-v-2999dc52] {\n    padding: 0;\n}\n.margin-T[data-v-2999dc52] {\n    margin-top: 5px;\n}\n.small-2[data-v-2999dc52], .small-5[data-v-2999dc52], .small-6[data-v-2999dc52], .small-3[data-v-2999dc52], .small-4[data-v-2999dc52], .small-8[data-v-2999dc52] {\n    width: 100%;\n}\n.small-6[data-v-2999dc52] {\n    margin-bottom: 5px;\n}\n.confirm[data-v-2999dc52] {\n    background-color: #fff;\n    width: 100%;\n    text-align: right;\n}\n.heading[data-v-2999dc52] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n        -ms-flex-direction: column-reverse;\n            flex-direction: column-reverse;\n}\n.heading .add[data-v-2999dc52] {\n      text-align: right;\n}\n.heading label[data-v-2999dc52] {\n      margin-bottom: 5px;\n}\n.sub-geofences .list span[data-v-2999dc52] {\n    font-size: 12px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geofence-fields-airport"},[_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-3 columns"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.trackEntryExit),expression:"geofence.trackEntryExit"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.geofence.trackEntryExit)?_vm._i(_vm.geofence.trackEntryExit,null)>-1:(_vm.geofence.trackEntryExit)},on:{"change":[function($event){var $$a=_vm.geofence.trackEntryExit,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.geofence, "trackEntryExit", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.geofence, "trackEntryExit", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.geofence, "trackEntryExit", $$c)}},function($event){return _vm.updateField('trackEntryExit')}]}}),_vm._v(" "),_c('span',[_vm._v("TRACK ENTRY AND EXITS")])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.showInAppBanner),expression:"geofence.showInAppBanner"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.geofence.showInAppBanner)?_vm._i(_vm.geofence.showInAppBanner,null)>-1:(_vm.geofence.showInAppBanner)},on:{"change":[function($event){var $$a=_vm.geofence.showInAppBanner,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.geofence, "showInAppBanner", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.geofence, "showInAppBanner", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.geofence, "showInAppBanner", $$c)}},function($event){return _vm.updateField('showInAppBanner')}]}}),_vm._v(" "),_c('span',[_vm._v("SHOW BANNER IN PROVIDER APP")])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.pushNotificationToProvUponEntry),expression:"geofence.pushNotificationToProvUponEntry"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.geofence.pushNotificationToProvUponEntry)?_vm._i(_vm.geofence.pushNotificationToProvUponEntry,null)>-1:(_vm.geofence.pushNotificationToProvUponEntry)},on:{"change":[function($event){var $$a=_vm.geofence.pushNotificationToProvUponEntry,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.geofence, "pushNotificationToProvUponEntry", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.geofence, "pushNotificationToProvUponEntry", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.geofence, "pushNotificationToProvUponEntry", $$c)}},function($event){return _vm.updateField('pushNotificationToProvUponEntry')}]}}),_vm._v(" "),_c('span',[_vm._v("PUSH ENTRY NOTIFICATIONS")])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.autoSetLocationToGeofenceName),expression:"geofence.autoSetLocationToGeofenceName"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.geofence.autoSetLocationToGeofenceName)?_vm._i(_vm.geofence.autoSetLocationToGeofenceName,null)>-1:(_vm.geofence.autoSetLocationToGeofenceName)},on:{"change":[function($event){var $$a=_vm.geofence.autoSetLocationToGeofenceName,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.geofence, "autoSetLocationToGeofenceName", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.geofence, "autoSetLocationToGeofenceName", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.geofence, "autoSetLocationToGeofenceName", $$c)}},function($event){return _vm.updateField('autoSetLocationToGeofenceName')}]}}),_vm._v(" "),_c('span',[_vm._v("SET PICKUP/DROPOFF TO GEOFENCE")])])])]),_vm._v(" "),_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("Formal Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.formalName),expression:"geofence.formalName"}],attrs:{"type":"name","placeholder":"LAX Internation Airport"},domProps:{"value":(_vm.geofence.formalName)},on:{"change":function($event){return _vm.updateFieldValue('formalName')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.geofence, "formalName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("Deactivate Provider Distance")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.deactiveDistance),expression:"geofence.deactiveDistance"}],attrs:{"type":"number","placeholder":"in Miles"},domProps:{"value":(_vm.geofence.deactiveDistance)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.geofence, "deactiveDistance", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"arrival-instruction-box row"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"heading"},[_c('label',{attrs:{"data-v-71d9b8c5":""}},[_vm._v("ARRIVAL INSTRUCTION")]),_vm._v(" "),_c('div',{staticClass:"preview",on:{"click":_vm.openPreview}},[_c('i',{staticClass:"far fa-eye"}),_vm._v(" "),_c('span',[_vm._v("PREVIEW")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns padding-R"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("Label")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.airportPickupTitle),expression:"geofence.airportPickupTitle"}],attrs:{"type":"text","placeholder":"LAX Pickup Instruction"},domProps:{"value":(_vm.geofence.airportPickupTitle)},on:{"change":function($event){return _vm.updateFieldValue('airportPickupTitle')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.geofence, "airportPickupTitle", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("Upstairs Label ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.airportPickupUpstairs),expression:"geofence.airportPickupUpstairs"}],attrs:{"type":"text","placeholder":"Upstairs"},domProps:{"value":(_vm.geofence.airportPickupUpstairs)},on:{"change":function($event){return _vm.updateFieldValue('airportPickupUpstairs')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.geofence, "airportPickupUpstairs", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("Downstairs Label ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.airportPickupDownstairs),expression:"geofence.airportPickupDownstairs"}],attrs:{"type":"text","placeholder":"Downstairs"},domProps:{"value":(_vm.geofence.airportPickupDownstairs)},on:{"change":function($event){return _vm.updateFieldValue('airportPickupDownstairs')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.geofence, "airportPickupDownstairs", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-R"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("TNC Instruction ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.airportPickupInstructionsTNC),expression:"geofence.airportPickupInstructionsTNC"}],domProps:{"value":(_vm.geofence.airportPickupInstructionsTNC)},on:{"change":function($event){return _vm.updateFieldValue('airportPickupInstructionsTNC')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.geofence, "airportPickupInstructionsTNC", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("TCP Instruction ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.airportPickupInstructionsTCP),expression:"geofence.airportPickupInstructionsTCP"}],domProps:{"value":(_vm.geofence.airportPickupInstructionsTCP)},on:{"change":function($event){return _vm.updateFieldValue('airportPickupInstructionsTCP')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.geofence, "airportPickupInstructionsTCP", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-R margin-T"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("TNC Image ")]),_vm._v(" "),_c('div',{staticClass:"row upload-box"},[_c('div',{staticClass:"small-8 columns padding-R"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.airportPickupImageTNC),expression:"geofence.airportPickupImageTNC"}],staticClass:"img-url",attrs:{"type":"text","disabled":_vm.geofence.uploading.tnc},domProps:{"value":(_vm.geofence.airportPickupImageTNC)},on:{"change":function($event){return _vm.updateFieldValue('airportPickupImageTNC')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.geofence, "airportPickupImageTNC", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[_c('a',{class:{'button success small block':true, 'disabled':_vm.geofence.uploading.tnc},on:{"click":function($event){return _vm.$refs.imageTNC.click()}}},[(_vm.geofence.uploading.tnc)?_c('span',[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" Uploading..")]):(_vm.geofence.airportPickupImageTNC)?_c('span',[_vm._v("Change")]):_c('span',[_vm._v("Upload")])]),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"imageTNC",attrs:{"type":"file"},on:{"change":function($event){return _vm.upload('imageTNC')}}})])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.uploadMsg.tnc),expression:"!!uploadMsg.tnc"}],staticClass:"error-message"},[_vm._v(_vm._s(_vm.uploadMsg.tnc))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L margin-T"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("TCP Image ")]),_vm._v(" "),_c('div',{staticClass:"row upload-box"},[_c('div',{staticClass:"small-8 columns padding-R"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.airportPickupImageTCP),expression:"geofence.airportPickupImageTCP"}],staticClass:"img-url",attrs:{"type":"text","disabled":_vm.geofence.uploading.tcp},domProps:{"value":(_vm.geofence.airportPickupImageTCP)},on:{"change":function($event){return _vm.updateFieldValue('airportPickupImageTNC')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.geofence, "airportPickupImageTCP", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[_c('a',{class:{'button success small block':true, 'disabled':_vm.geofence.uploading.tcp},on:{"click":function($event){return _vm.$refs.imageTCP.click()}}},[(_vm.geofence.uploading.tcp)?_c('span',[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" Uploading...")]):(_vm.geofence.airportPickupImageTCP)?_c('span',[_vm._v("Change")]):_c('span',[_vm._v("Upload")])]),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"imageTCP",attrs:{"type":"file"},on:{"change":function($event){return _vm.upload('imageTCP')}}})])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.uploadMsg.tcp),expression:"!!uploadMsg.tcp"}],staticClass:"error-message"},[_vm._v(_vm._s(_vm.uploadMsg.tcp))])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row margin-T sub-geofences"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"heading"},[_c('div',{staticClass:"add"},[_c('span',[_vm._v("Add Geofence")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected.stagingLots),expression:"selected.stagingLots"}],attrs:{"disabled":_vm.dragOptions.stagingLots.disabled || _vm.subgeofencesLoading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selected, "stagingLots", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.addSubGeofence('stagingLots')}]}},_vm._l((_vm.activeGeofenceList('stagingLots')),function(geo){return _c('option',{domProps:{"value":geo.id}},[_vm._v(_vm._s(geo.name))])}),0)]),_vm._v(" "),_c('label',[_vm._v("STAGING LOTS")]),_vm._v(" "),_c('div',{staticClass:"clear"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.subgeofencesLoading),expression:"subgeofencesLoading"}],staticClass:"loader"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading...\n      ")]),_vm._v(" "),_c('draggable',_vm._b({class:{'list':true, 'disabled':_vm.dragOptions.stagingLots.disabled},on:{"change":function($event){return _vm.sorted('stagingLots')}},model:{value:(_vm.stagingLots),callback:function ($$v) {_vm.stagingLots=$$v},expression:"stagingLots"}},'draggable',_vm.dragOptions.stagingLots,false),_vm._l((_vm.stagingLots),function(data){return _c('div',{key:data.id,staticClass:"item"},[_c('i',{staticClass:"fas fa-bars"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(data.name))]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.deleteConfirm['a' + data.id]),expression:"!deleteConfirm['a' + data.id]"}],staticClass:"fas fa-times",on:{"click":function($event){return _vm.toggleConfirm(data.id, 'stagingLots')}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-left"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.deleteConfirm['a' + data.id]),expression:"deleteConfirm['a' + data.id]"}],staticClass:"confirm"},[_c('span',[_vm._v("Confirm remove?")]),_vm._v(" "),_c('div',{staticClass:"button cta error xsmall",on:{"click":function($event){return _vm.toggleConfirm(data.id, 'stagingLots')}}},[_vm._v("No")]),_vm._v(" "),_c('div',{staticClass:"button cta success xsmall",on:{"click":function($event){return _vm.deleteSubGeofence(data.id, 'stagingLots')}}},[_vm._v("Yes")])])])],1)}),0)],1)]),_vm._v(" "),_c('div',{staticClass:"row margin-T sub-geofences"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"heading"},[_c('div',{staticClass:"add"},[_c('span',[_vm._v("Add Geofence")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected.restrictedAreas),expression:"selected.restrictedAreas"}],attrs:{"disabled":_vm.dragOptions.restrictedAreas.disabled || _vm.subgeofencesLoading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selected, "restrictedAreas", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.addSubGeofence('restrictedAreas')}]}},_vm._l((_vm.activeGeofenceList('restrictedAreas')),function(geo){return _c('option',{domProps:{"value":geo.id}},[_vm._v(_vm._s(geo.name))])}),0)]),_vm._v(" "),_c('label',[_vm._v("RESTRICTED AREAS")]),_vm._v(" "),_c('div',{staticClass:"clear"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.subgeofencesLoading),expression:"subgeofencesLoading"}],staticClass:"loader"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading...\n      ")]),_vm._v(" "),_c('draggable',_vm._b({class:{'list':true, 'disabled':_vm.dragOptions.restrictedAreas.disabled},on:{"change":function($event){return _vm.sorted('restrictedAreas')}},model:{value:(_vm.restrictedAreas),callback:function ($$v) {_vm.restrictedAreas=$$v},expression:"restrictedAreas"}},'draggable',_vm.dragOptions.restrictedAreas,false),_vm._l((_vm.restrictedAreas),function(data){return _c('div',{key:data.id,staticClass:"item"},[_c('i',{staticClass:"fas fa-bars"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(data.name))]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.deleteConfirm['a' + data.id]),expression:"!deleteConfirm['a' + data.id]"}],staticClass:"fas fa-times",on:{"click":function($event){return _vm.toggleConfirm(data.id, 'restrictedAreas')}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-left"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.deleteConfirm['a' + data.id]),expression:"deleteConfirm['a' + data.id]"}],staticClass:"confirm"},[_c('span',[_vm._v("Confirm remove?")]),_vm._v(" "),_c('div',{staticClass:"button cta error xsmall",on:{"click":function($event){return _vm.toggleConfirm(data.id, 'restrictedAreas')}}},[_vm._v("No")]),_vm._v(" "),_c('div',{staticClass:"button cta success xsmall",on:{"click":function($event){return _vm.deleteSubGeofence(data.id, 'restrictedAreas')}}},[_vm._v("Yes")])])])],1)}),0)],1)]),_vm._v(" "),_c('div',{staticClass:"row margin-T sub-geofences"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"heading"},[_c('div',{staticClass:"add"},[_c('span',[_vm._v("Add Geofence")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected.serviceAreas),expression:"selected.serviceAreas"}],attrs:{"disabled":_vm.dragOptions.serviceAreas.disabled || _vm.subgeofencesLoading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selected, "serviceAreas", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.addSubGeofence('serviceAreas')}]}},_vm._l((_vm.activeGeofenceList('serviceAreas')),function(geo){return _c('option',{domProps:{"value":geo.id}},[_vm._v(_vm._s(geo.name))])}),0)]),_vm._v(" "),_c('label',[_vm._v("SERVICE AREAS")]),_vm._v(" "),_c('div',{staticClass:"clear"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.subgeofencesLoading),expression:"subgeofencesLoading"}],staticClass:"loader"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading...\n      ")]),_vm._v(" "),_c('draggable',_vm._b({class:{'list':true, 'disabled':_vm.dragOptions.serviceAreas.disabled},on:{"change":function($event){return _vm.sorted('serviceAreas')}},model:{value:(_vm.serviceAreas),callback:function ($$v) {_vm.serviceAreas=$$v},expression:"serviceAreas"}},'draggable',_vm.dragOptions.serviceAreas,false),_vm._l((_vm.serviceAreas),function(data){return _c('div',{key:data.id,staticClass:"item"},[_c('i',{staticClass:"fas fa-bars"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(data.name))]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.deleteConfirm['a' + data.id]),expression:"!deleteConfirm['a' + data.id]"}],staticClass:"fas fa-times",on:{"click":function($event){return _vm.toggleConfirm(data.id, 'serviceAreas')}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-left"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.deleteConfirm['a' + data.id]),expression:"deleteConfirm['a' + data.id]"}],staticClass:"confirm"},[_c('span',[_vm._v("Confirm remove?")]),_vm._v(" "),_c('div',{staticClass:"button cta error xsmall",on:{"click":function($event){return _vm.toggleConfirm(data.id, 'serviceAreas')}}},[_vm._v("No")]),_vm._v(" "),_c('div',{staticClass:"button cta success xsmall",on:{"click":function($event){return _vm.deleteSubGeofence(data.id, 'serviceAreas')}}},[_vm._v("Yes")])])])],1)}),0)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofenceFieldsRestricted_vue__ = __webpack_require__(559);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd0c85f0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofenceFieldsRestricted_vue__ = __webpack_require__(1615);
function injectStyle (ssrContext) {
  __webpack_require__(1613)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bd0c85f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofenceFieldsRestricted_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd0c85f0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofenceFieldsRestricted_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1614);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("99850cb0", content, true, {});

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.input-field[data-v-bd0c85f0] {\n  font-size: 14px;\n}\n.input-field label[data-v-bd0c85f0] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n}\n.input-field input[data-v-bd0c85f0], .input-field textarea[data-v-bd0c85f0] {\n    margin-top: 0;\n    padding: 7px 10px;\n}\n.input-field textarea[data-v-bd0c85f0] {\n    resize: none;\n    height: 100px;\n}\n.checkbox-input > *[data-v-bd0c85f0] {\n  display: inline-block;\n  vertical-align: middle;\n  width: auto;\n}\n.checkbox-input input[data-v-bd0c85f0] {\n  margin-top: 0;\n}\n.checkbox-input span[data-v-bd0c85f0] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #777;\n  height: 16px;\n  margin-left: 3px;\n  cursor: pointer;\n}\n.padding-L[data-v-bd0c85f0] {\n  padding-left: 7px;\n}\n.padding-R[data-v-bd0c85f0] {\n  padding-right: 7px;\n}\n.margin-T[data-v-bd0c85f0] {\n  margin-top: 15px;\n}\n@media only screen and (max-width: 430px) {\n.padding-R[data-v-bd0c85f0], .padding-L[data-v-bd0c85f0] {\n    padding: 0;\n}\n.small-2[data-v-bd0c85f0], .small-5[data-v-bd0c85f0], .small-6[data-v-bd0c85f0], .small-3[data-v-bd0c85f0], .small-4[data-v-bd0c85f0], .small-8[data-v-bd0c85f0] {\n    width: 100%;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Geofences/GeofenceFieldsRestricted.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;CACjB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,cAAc;IACd,kBAAkB;CACrB;AACD;IACI,aAAa;IACb,cAAc;CACjB;AACD;EACE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;CACb;AACD;EACE,cAAc;CACf;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;CACjB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,iBAAiB;CAClB;AACD;AACA;IACI,WAAW;CACd;AACD;IACI,YAAY;CACf;CACA","file":"GeofenceFieldsRestricted.vue","sourcesContent":["\n.input-field[data-v-bd0c85f0] {\n  font-size: 14px;\n}\n.input-field label[data-v-bd0c85f0] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n}\n.input-field input[data-v-bd0c85f0], .input-field textarea[data-v-bd0c85f0] {\n    margin-top: 0;\n    padding: 7px 10px;\n}\n.input-field textarea[data-v-bd0c85f0] {\n    resize: none;\n    height: 100px;\n}\n.checkbox-input > *[data-v-bd0c85f0] {\n  display: inline-block;\n  vertical-align: middle;\n  width: auto;\n}\n.checkbox-input input[data-v-bd0c85f0] {\n  margin-top: 0;\n}\n.checkbox-input span[data-v-bd0c85f0] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #777;\n  height: 16px;\n  margin-left: 3px;\n  cursor: pointer;\n}\n.padding-L[data-v-bd0c85f0] {\n  padding-left: 7px;\n}\n.padding-R[data-v-bd0c85f0] {\n  padding-right: 7px;\n}\n.margin-T[data-v-bd0c85f0] {\n  margin-top: 15px;\n}\n@media only screen and (max-width: 430px) {\n.padding-R[data-v-bd0c85f0], .padding-L[data-v-bd0c85f0] {\n    padding: 0;\n}\n.small-2[data-v-bd0c85f0], .small-5[data-v-bd0c85f0], .small-6[data-v-bd0c85f0], .small-3[data-v-bd0c85f0], .small-4[data-v-bd0c85f0], .small-8[data-v-bd0c85f0] {\n    width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geofence-fields-airport"},[_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-3 columns"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.trackEntryExit),expression:"geofence.trackEntryExit"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.geofence.trackEntryExit)?_vm._i(_vm.geofence.trackEntryExit,null)>-1:(_vm.geofence.trackEntryExit)},on:{"change":[function($event){var $$a=_vm.geofence.trackEntryExit,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.geofence, "trackEntryExit", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.geofence, "trackEntryExit", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.geofence, "trackEntryExit", $$c)}},function($event){return _vm.updateField('trackEntryExit')}]}}),_vm._v(" "),_c('span',[_vm._v("TRACK ENTRY AND EXITS")])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.showInAppBanner),expression:"geofence.showInAppBanner"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.geofence.showInAppBanner)?_vm._i(_vm.geofence.showInAppBanner,null)>-1:(_vm.geofence.showInAppBanner)},on:{"change":[function($event){var $$a=_vm.geofence.showInAppBanner,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.geofence, "showInAppBanner", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.geofence, "showInAppBanner", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.geofence, "showInAppBanner", $$c)}},function($event){return _vm.updateField('showInAppBanner')}]}}),_vm._v(" "),_c('span',[_vm._v("SHOW BANNER IN PROVIDER APP")])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.pushNotificationToProvUponEntry),expression:"geofence.pushNotificationToProvUponEntry"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.geofence.pushNotificationToProvUponEntry)?_vm._i(_vm.geofence.pushNotificationToProvUponEntry,null)>-1:(_vm.geofence.pushNotificationToProvUponEntry)},on:{"change":[function($event){var $$a=_vm.geofence.pushNotificationToProvUponEntry,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.geofence, "pushNotificationToProvUponEntry", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.geofence, "pushNotificationToProvUponEntry", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.geofence, "pushNotificationToProvUponEntry", $$c)}},function($event){return _vm.updateField('pushNotificationToProvUponEntry')}]}}),_vm._v(" "),_c('span',[_vm._v("PUSH ENTRY NOTIFICATIONS")])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.hideProvidersInGeofence),expression:"geofence.hideProvidersInGeofence"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.geofence.hideProvidersInGeofence)?_vm._i(_vm.geofence.hideProvidersInGeofence,null)>-1:(_vm.geofence.hideProvidersInGeofence)},on:{"change":[function($event){var $$a=_vm.geofence.hideProvidersInGeofence,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.geofence, "hideProvidersInGeofence", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.geofence, "hideProvidersInGeofence", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.geofence, "hideProvidersInGeofence", $$c)}},function($event){return _vm.updateField('hideProvidersInGeofence')}]}}),_vm._v(" "),_c('span',[_vm._v("HIDE PROVIDERS FROM CONSUMERS")])])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-2 columns padding-R"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkService.shared),expression:"checkService.shared"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkService.shared)?_vm._i(_vm.checkService.shared,null)>-1:(_vm.checkService.shared)},on:{"change":function($event){var $$a=_vm.checkService.shared,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkService, "shared", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkService, "shared", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkService, "shared", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.serviceLabel('shared')))])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns padding-L padding-R"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkService.opoli),expression:"checkService.opoli"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkService.opoli)?_vm._i(_vm.checkService.opoli,null)>-1:(_vm.checkService.opoli)},on:{"change":function($event){var $$a=_vm.checkService.opoli,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkService, "opoli", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkService, "opoli", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkService, "opoli", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.serviceLabel('opoli')))])])]),_vm._v(" "),_c('div',{staticClass:"small-2 columns padding-L padding-R"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkService.black),expression:"checkService.black"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkService.black)?_vm._i(_vm.checkService.black,null)>-1:(_vm.checkService.black)},on:{"change":function($event){var $$a=_vm.checkService.black,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkService, "black", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkService, "black", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkService, "black", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.serviceLabel('black')))])])]),_vm._v(" "),_c('div',{staticClass:"small-2 columns padding-L padding-R"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkService.suv),expression:"checkService.suv"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkService.suv)?_vm._i(_vm.checkService.suv,null)>-1:(_vm.checkService.suv)},on:{"change":function($event){var $$a=_vm.checkService.suv,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkService, "suv", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkService, "suv", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkService, "suv", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.serviceLabel('suv')))])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns padding-L"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkService.shuttle),expression:"checkService.shuttle"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkService.shuttle)?_vm._i(_vm.checkService.shuttle,null)>-1:(_vm.checkService.shuttle)},on:{"change":function($event){var $$a=_vm.checkService.shuttle,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkService, "shuttle", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkService, "shuttle", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkService, "shuttle", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.serviceLabel('shuttle')))])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("APPLICABLE SERVICE TYPES")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofenceFieldsServiceArea_vue__ = __webpack_require__(560);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ae3e3ba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofenceFieldsServiceArea_vue__ = __webpack_require__(1619);
function injectStyle (ssrContext) {
  __webpack_require__(1617)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ae3e3ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofenceFieldsServiceArea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ae3e3ba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofenceFieldsServiceArea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1618);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("e89aca20", content, true, {});

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.table[data-v-6ae3e3ba] {\n  border: 1px solid #0D79F2;\n  margin: 10px 0;\n  border-collapse: collapse;\n  width: 100%;\n}\n.table .table-label[data-v-6ae3e3ba] {\n    font-size: 12px;\n    text-align: center;\n    vertical-align: middle;\n}\n.table .sub-box[data-v-6ae3e3ba] {\n    border-top: 1px solid #0D79F2;\n    background: #f3f3f3;\n}\n.table .sub-box td[data-v-6ae3e3ba] {\n      padding: 10px 4px !important;\n}\n.table .sub-box .sub-label[data-v-6ae3e3ba] {\n      display: block;\n      font-size: 11px;\n      color: #888;\n      line-height: 1;\n      margin: 0 0 3px 2px;\n}\n.table .sub-box .date-input-block[data-v-6ae3e3ba] {\n      display: block;\n      margin-bottom: 2px;\n}\n.table .sub-box .button[data-v-6ae3e3ba] {\n      margin-top: 10px;\n}\n.table .table-label-header[data-v-6ae3e3ba] {\n    font-size: 12px;\n    text-align: center;\n    vertical-align: middle;\n    font-weight: 700;\n}\n.table input[data-v-6ae3e3ba] {\n    margin: 0;\n    padding: 5px;\n    font-size: 13px;\n    text-align: right;\n}\n.table input[type=\"text\"][data-v-6ae3e3ba], .table input[type=\"number\"][data-v-6ae3e3ba], .table input[type=\"date\"][data-v-6ae3e3ba] {\n      margin: 0 auto;\n      width: 60px;\n}\n.table input[type=\"text\"].small-input[data-v-6ae3e3ba], .table input[type=\"number\"].small-input[data-v-6ae3e3ba], .table input[type=\"date\"].small-input[data-v-6ae3e3ba] {\n        width: 60px;\n}\n.table input[type=\"text\"].date-input[data-v-6ae3e3ba], .table input[type=\"number\"].date-input[data-v-6ae3e3ba], .table input[type=\"date\"].date-input[data-v-6ae3e3ba] {\n        width: 150px;\n        margin-top: 0 !important;\n}\n.table input[type=\"checkbox\"][data-v-6ae3e3ba] {\n      margin: 0 7px;\n}\n.table input[type=\"checkbox\"].center-checkbox[data-v-6ae3e3ba] {\n        width: 12px;\n        margin: 0 auto;\n}\n.table select[data-v-6ae3e3ba] {\n    font-size: 13px;\n    height: 31px;\n    outline: 0;\n    padding: 5px;\n    display: inline-block;\n    width: 50px;\n    border-color: rgba(0, 0, 0, 0.15);\n    background-color: #fff;\n    border-radius: 3px;\n}\n.table td[data-v-6ae3e3ba] {\n    padding: 7px 4px;\n}\n.table .table-title[data-v-6ae3e3ba] {\n    background-color: #0D79F2;\n    font-size: 13px;\n    color: #fff;\n    font-weight: 700;\n    padding: 8px 15px;\n}\n.table .promo-pricing[data-v-6ae3e3ba] {\n    text-align: center;\n    padding: 15px 0;\n    border-top: 1px solid #0D79F2;\n}\n.input-field[data-v-6ae3e3ba] {\n  font-size: 14px;\n}\n.input-field label[data-v-6ae3e3ba] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n}\n.input-field input[data-v-6ae3e3ba], .input-field textarea[data-v-6ae3e3ba] {\n    margin-top: 0;\n    padding: 7px 10px;\n}\n.input-field textarea[data-v-6ae3e3ba] {\n    resize: none;\n    height: 100px;\n}\n.checkbox-input > *[data-v-6ae3e3ba] {\n  display: inline-block;\n  vertical-align: middle;\n  width: auto;\n}\n.checkbox-input input[data-v-6ae3e3ba] {\n  margin-top: 0;\n}\n.checkbox-input span[data-v-6ae3e3ba] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #0D79F2;\n  height: 16px;\n  margin-left: 3px;\n}\n.promo-loading[data-v-6ae3e3ba] {\n  font-size: 14px;\n  font-weight: 700;\n  text-align: center;\n  padding: 15px;\n}\n.padding-L[data-v-6ae3e3ba] {\n  padding-left: 7px;\n}\n.padding-R[data-v-6ae3e3ba] {\n  padding-right: 7px;\n}\n.margin-T[data-v-6ae3e3ba] {\n  margin-top: 15px;\n}\n@media only screen and (max-width: 430px) {\n.padding-R[data-v-6ae3e3ba], .padding-L[data-v-6ae3e3ba] {\n    padding: 0;\n}\n.small-2[data-v-6ae3e3ba], .small-5[data-v-6ae3e3ba], .small-6[data-v-6ae3e3ba], .small-3[data-v-6ae3e3ba], .small-4[data-v-6ae3e3ba], .small-8[data-v-6ae3e3ba] {\n    width: 100%;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Geofences/GeofenceFieldsServiceArea.vue"],"names":[],"mappings":";AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,0BAA0B;EAC1B,YAAY;CACb;AACD;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;CAC1B;AACD;IACI,8BAA8B;IAC9B,oBAAoB;CACvB;AACD;MACM,6BAA6B;CAClC;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,YAAY;MACZ,eAAe;MACf,oBAAoB;CACzB;AACD;MACM,eAAe;MACf,mBAAmB;CACxB;AACD;MACM,iBAAiB;CACtB;AACD;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;CACpB;AACD;IACI,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,kBAAkB;CACrB;AACD;MACM,eAAe;MACf,YAAY;CACjB;AACD;QACQ,YAAY;CACnB;AACD;QACQ,aAAa;QACb,yBAAyB;CAChC;AACD;MACM,cAAc;CACnB;AACD;QACQ,YAAY;QACZ,eAAe;CACtB;AACD;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kCAAkC;IAClC,uBAAuB;IACvB,mBAAmB;CACtB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;CACrB;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,8BAA8B;CACjC;AACD;EACE,gBAAgB;CACjB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,cAAc;IACd,kBAAkB;CACrB;AACD;IACI,aAAa;IACb,cAAc;CACjB;AACD;EACE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;CACb;AACD;EACE,cAAc;CACf;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,iBAAiB;CAClB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;CACf;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,iBAAiB;CAClB;AACD;AACA;IACI,WAAW;CACd;AACD;IACI,YAAY;CACf;CACA","file":"GeofenceFieldsServiceArea.vue","sourcesContent":["\n.table[data-v-6ae3e3ba] {\n  border: 1px solid #0D79F2;\n  margin: 10px 0;\n  border-collapse: collapse;\n  width: 100%;\n}\n.table .table-label[data-v-6ae3e3ba] {\n    font-size: 12px;\n    text-align: center;\n    vertical-align: middle;\n}\n.table .sub-box[data-v-6ae3e3ba] {\n    border-top: 1px solid #0D79F2;\n    background: #f3f3f3;\n}\n.table .sub-box td[data-v-6ae3e3ba] {\n      padding: 10px 4px !important;\n}\n.table .sub-box .sub-label[data-v-6ae3e3ba] {\n      display: block;\n      font-size: 11px;\n      color: #888;\n      line-height: 1;\n      margin: 0 0 3px 2px;\n}\n.table .sub-box .date-input-block[data-v-6ae3e3ba] {\n      display: block;\n      margin-bottom: 2px;\n}\n.table .sub-box .button[data-v-6ae3e3ba] {\n      margin-top: 10px;\n}\n.table .table-label-header[data-v-6ae3e3ba] {\n    font-size: 12px;\n    text-align: center;\n    vertical-align: middle;\n    font-weight: 700;\n}\n.table input[data-v-6ae3e3ba] {\n    margin: 0;\n    padding: 5px;\n    font-size: 13px;\n    text-align: right;\n}\n.table input[type=\"text\"][data-v-6ae3e3ba], .table input[type=\"number\"][data-v-6ae3e3ba], .table input[type=\"date\"][data-v-6ae3e3ba] {\n      margin: 0 auto;\n      width: 60px;\n}\n.table input[type=\"text\"].small-input[data-v-6ae3e3ba], .table input[type=\"number\"].small-input[data-v-6ae3e3ba], .table input[type=\"date\"].small-input[data-v-6ae3e3ba] {\n        width: 60px;\n}\n.table input[type=\"text\"].date-input[data-v-6ae3e3ba], .table input[type=\"number\"].date-input[data-v-6ae3e3ba], .table input[type=\"date\"].date-input[data-v-6ae3e3ba] {\n        width: 150px;\n        margin-top: 0 !important;\n}\n.table input[type=\"checkbox\"][data-v-6ae3e3ba] {\n      margin: 0 7px;\n}\n.table input[type=\"checkbox\"].center-checkbox[data-v-6ae3e3ba] {\n        width: 12px;\n        margin: 0 auto;\n}\n.table select[data-v-6ae3e3ba] {\n    font-size: 13px;\n    height: 31px;\n    outline: 0;\n    padding: 5px;\n    display: inline-block;\n    width: 50px;\n    border-color: rgba(0, 0, 0, 0.15);\n    background-color: #fff;\n    border-radius: 3px;\n}\n.table td[data-v-6ae3e3ba] {\n    padding: 7px 4px;\n}\n.table .table-title[data-v-6ae3e3ba] {\n    background-color: #0D79F2;\n    font-size: 13px;\n    color: #fff;\n    font-weight: 700;\n    padding: 8px 15px;\n}\n.table .promo-pricing[data-v-6ae3e3ba] {\n    text-align: center;\n    padding: 15px 0;\n    border-top: 1px solid #0D79F2;\n}\n.input-field[data-v-6ae3e3ba] {\n  font-size: 14px;\n}\n.input-field label[data-v-6ae3e3ba] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n}\n.input-field input[data-v-6ae3e3ba], .input-field textarea[data-v-6ae3e3ba] {\n    margin-top: 0;\n    padding: 7px 10px;\n}\n.input-field textarea[data-v-6ae3e3ba] {\n    resize: none;\n    height: 100px;\n}\n.checkbox-input > *[data-v-6ae3e3ba] {\n  display: inline-block;\n  vertical-align: middle;\n  width: auto;\n}\n.checkbox-input input[data-v-6ae3e3ba] {\n  margin-top: 0;\n}\n.checkbox-input span[data-v-6ae3e3ba] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #0D79F2;\n  height: 16px;\n  margin-left: 3px;\n}\n.promo-loading[data-v-6ae3e3ba] {\n  font-size: 14px;\n  font-weight: 700;\n  text-align: center;\n  padding: 15px;\n}\n.padding-L[data-v-6ae3e3ba] {\n  padding-left: 7px;\n}\n.padding-R[data-v-6ae3e3ba] {\n  padding-right: 7px;\n}\n.margin-T[data-v-6ae3e3ba] {\n  margin-top: 15px;\n}\n@media only screen and (max-width: 430px) {\n.padding-R[data-v-6ae3e3ba], .padding-L[data-v-6ae3e3ba] {\n    padding: 0;\n}\n.small-2[data-v-6ae3e3ba], .small-5[data-v-6ae3e3ba], .small-6[data-v-6ae3e3ba], .small-3[data-v-6ae3e3ba], .small-4[data-v-6ae3e3ba], .small-8[data-v-6ae3e3ba] {\n    width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-4 columns end"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.trackEntryExit),expression:"geofence.trackEntryExit"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.geofence.trackEntryExit)?_vm._i(_vm.geofence.trackEntryExit,null)>-1:(_vm.geofence.trackEntryExit)},on:{"change":[function($event){var $$a=_vm.geofence.trackEntryExit,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.geofence, "trackEntryExit", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.geofence, "trackEntryExit", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.geofence, "trackEntryExit", $$c)}},function($event){return _vm.updateBooleanField('trackEntryExit')}]}}),_vm._v(" "),_c('span',[_vm._v("TRACK ENTRY AND EXITS")])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns end"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.showInAppBanner),expression:"geofence.showInAppBanner"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.geofence.showInAppBanner)?_vm._i(_vm.geofence.showInAppBanner,null)>-1:(_vm.geofence.showInAppBanner)},on:{"change":[function($event){var $$a=_vm.geofence.showInAppBanner,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.geofence, "showInAppBanner", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.geofence, "showInAppBanner", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.geofence, "showInAppBanner", $$c)}},function($event){return _vm.updateBooleanField('showInAppBanner')}]}}),_vm._v(" "),_c('span',[_vm._v("SHOW BANNER IN PROVIDER APP")])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns end"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.pushNotificationToProvUponEntry),expression:"geofence.pushNotificationToProvUponEntry"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.geofence.pushNotificationToProvUponEntry)?_vm._i(_vm.geofence.pushNotificationToProvUponEntry,null)>-1:(_vm.geofence.pushNotificationToProvUponEntry)},on:{"change":[function($event){var $$a=_vm.geofence.pushNotificationToProvUponEntry,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.geofence, "pushNotificationToProvUponEntry", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.geofence, "pushNotificationToProvUponEntry", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.geofence, "pushNotificationToProvUponEntry", $$c)}},function($event){return _vm.updateBooleanField('pushNotificationToProvUponEntry')}]}}),_vm._v(" "),_c('span',[_vm._v("PUSH ENTRY NOTIFICATIONS")])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns end"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.isMTechPricing),expression:"geofence.isMTechPricing"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.geofence.isMTechPricing)?_vm._i(_vm.geofence.isMTechPricing,null)>-1:(_vm.geofence.isMTechPricing)},on:{"change":[function($event){var $$a=_vm.geofence.isMTechPricing,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.geofence, "isMTechPricing", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.geofence, "isMTechPricing", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.geofence, "isMTechPricing", $$c)}},function($event){return _vm.updateBooleanField('isMTechPricing')}]}}),_vm._v(" "),_c('span',[_vm._v("USE MTECH PRICING")])])])]),_vm._v(" "),_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-2 columns padding-R padding-L"},[_c('table',{staticClass:"table"},[_vm._m(0),_vm._v(" "),_c('tr',[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.allowASAP),expression:"geofence.allowASAP"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.geofence.allowASAP)?_vm._i(_vm.geofence.allowASAP,null)>-1:(_vm.geofence.allowASAP)},on:{"change":[function($event){var $$a=_vm.geofence.allowASAP,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.geofence, "allowASAP", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.geofence, "allowASAP", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.geofence, "allowASAP", $$c)}},function($event){return _vm.updateRsvpType('allowASAP')}]}})]),_vm._v(" "),_c('td',{staticClass:"table-label"},[_vm._v("ASAP")])]),_vm._v(" "),_c('tr',[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.allowFuture),expression:"geofence.allowFuture"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.geofence.allowFuture)?_vm._i(_vm.geofence.allowFuture,null)>-1:(_vm.geofence.allowFuture)},on:{"change":[function($event){var $$a=_vm.geofence.allowFuture,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.geofence, "allowFuture", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.geofence, "allowFuture", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.geofence, "allowFuture", $$c)}},function($event){return _vm.updateRsvpType('allowFuture')}]}})]),_vm._v(" "),_c('td',{staticClass:"table-label"},[_vm._v("Future RSVP")])])])]),_vm._v(" "),_c('div',{staticClass:"small-2 columns padding-L"},[_c('table',{staticClass:"table"},[_vm._m(1),_vm._v(" "),_c('tr',[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.allowTNC),expression:"geofence.allowTNC"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.geofence.allowTNC)?_vm._i(_vm.geofence.allowTNC,null)>-1:(_vm.geofence.allowTNC)},on:{"change":[function($event){var $$a=_vm.geofence.allowTNC,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.geofence, "allowTNC", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.geofence, "allowTNC", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.geofence, "allowTNC", $$c)}},function($event){return _vm.updateBooleanField('allowTNC')}]}})]),_vm._v(" "),_c('td',{staticClass:"table-label"},[_vm._v("TNC")])]),_vm._v(" "),_c('tr',[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.allowTCP),expression:"geofence.allowTCP"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.geofence.allowTCP)?_vm._i(_vm.geofence.allowTCP,null)>-1:(_vm.geofence.allowTCP)},on:{"change":[function($event){var $$a=_vm.geofence.allowTCP,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.geofence, "allowTCP", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.geofence, "allowTCP", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.geofence, "allowTCP", $$c)}},function($event){return _vm.updateBooleanField('allowTCP')}]}})]),_vm._v(" "),_c('td',{staticClass:"table-label"},[_vm._v("TCP")])])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"table-title",attrs:{"colspan":"2"}},[_vm._v("RSVP TYPES")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"table-title",attrs:{"colspan":"2"}},[_vm._v("LICENSE TYPES")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofenceFieldsStaging_vue__ = __webpack_require__(561);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51eadd58_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofenceFieldsStaging_vue__ = __webpack_require__(1623);
function injectStyle (ssrContext) {
  __webpack_require__(1621)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51eadd58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofenceFieldsStaging_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51eadd58_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofenceFieldsStaging_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1622);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("dce554b6", content, true, {});

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.input-field[data-v-51eadd58] {\n  font-size: 14px;\n}\n.input-field label[data-v-51eadd58] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n}\n.input-field input[data-v-51eadd58], .input-field textarea[data-v-51eadd58] {\n    margin-top: 0;\n    padding: 7px 10px;\n}\n.input-field textarea[data-v-51eadd58] {\n    resize: none;\n    height: 100px;\n}\n.checkbox-input > *[data-v-51eadd58] {\n  display: inline-block;\n  vertical-align: middle;\n  width: auto;\n}\n.checkbox-input input[data-v-51eadd58] {\n  margin-top: 0;\n}\n.checkbox-input span[data-v-51eadd58] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #777;\n  height: 16px;\n  margin-left: 3px;\n  cursor: pointer;\n}\n.service-list[data-v-51eadd58] {\n  padding: 0 30px;\n  margin-bottom: 10px;\n}\n.service-list .brand[data-v-51eadd58] {\n    font-weight: 600;\n    font-size: 14px;\n}\n.service-list .service[data-v-51eadd58] {\n    cursor: pointer;\n    font-size: 13px;\n    color: #333;\n}\n.service-list input[data-v-51eadd58] {\n    margin: 0;\n    width: 20px;\n    display: inline-block;\n    vertical-align: -1px;\n}\n.padding-L[data-v-51eadd58] {\n  padding-left: 7px;\n}\n.padding-R[data-v-51eadd58] {\n  padding-right: 7px;\n}\n.margin-T[data-v-51eadd58] {\n  margin-top: 15px;\n}\n@media only screen and (max-width: 430px) {\n.padding-R[data-v-51eadd58], .padding-L[data-v-51eadd58] {\n    padding: 0;\n}\n.small-2[data-v-51eadd58], .small-5[data-v-51eadd58], .small-6[data-v-51eadd58], .small-3[data-v-51eadd58], .small-4[data-v-51eadd58], .small-8[data-v-51eadd58] {\n    width: 100%;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Geofences/GeofenceFieldsStaging.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;CACjB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,cAAc;IACd,kBAAkB;CACrB;AACD;IACI,aAAa;IACb,cAAc;CACjB;AACD;EACE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;CACb;AACD;EACE,cAAc;CACf;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;CACjB;AACD;EACE,gBAAgB;EAChB,oBAAoB;CACrB;AACD;IACI,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;CACf;AACD;IACI,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;CACxB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,iBAAiB;CAClB;AACD;AACA;IACI,WAAW;CACd;AACD;IACI,YAAY;CACf;CACA","file":"GeofenceFieldsStaging.vue","sourcesContent":["\n.input-field[data-v-51eadd58] {\n  font-size: 14px;\n}\n.input-field label[data-v-51eadd58] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n}\n.input-field input[data-v-51eadd58], .input-field textarea[data-v-51eadd58] {\n    margin-top: 0;\n    padding: 7px 10px;\n}\n.input-field textarea[data-v-51eadd58] {\n    resize: none;\n    height: 100px;\n}\n.checkbox-input > *[data-v-51eadd58] {\n  display: inline-block;\n  vertical-align: middle;\n  width: auto;\n}\n.checkbox-input input[data-v-51eadd58] {\n  margin-top: 0;\n}\n.checkbox-input span[data-v-51eadd58] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #777;\n  height: 16px;\n  margin-left: 3px;\n  cursor: pointer;\n}\n.service-list[data-v-51eadd58] {\n  padding: 0 30px;\n  margin-bottom: 10px;\n}\n.service-list .brand[data-v-51eadd58] {\n    font-weight: 600;\n    font-size: 14px;\n}\n.service-list .service[data-v-51eadd58] {\n    cursor: pointer;\n    font-size: 13px;\n    color: #333;\n}\n.service-list input[data-v-51eadd58] {\n    margin: 0;\n    width: 20px;\n    display: inline-block;\n    vertical-align: -1px;\n}\n.padding-L[data-v-51eadd58] {\n  padding-left: 7px;\n}\n.padding-R[data-v-51eadd58] {\n  padding-right: 7px;\n}\n.margin-T[data-v-51eadd58] {\n  margin-top: 15px;\n}\n@media only screen and (max-width: 430px) {\n.padding-R[data-v-51eadd58], .padding-L[data-v-51eadd58] {\n    padding: 0;\n}\n.small-2[data-v-51eadd58], .small-5[data-v-51eadd58], .small-6[data-v-51eadd58], .small-3[data-v-51eadd58], .small-4[data-v-51eadd58], .small-8[data-v-51eadd58] {\n    width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geofence-fields-airport"},[_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-4 columns"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.trackEntryExit),expression:"geofence.trackEntryExit"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.geofence.trackEntryExit)?_vm._i(_vm.geofence.trackEntryExit,null)>-1:(_vm.geofence.trackEntryExit)},on:{"change":[function($event){var $$a=_vm.geofence.trackEntryExit,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.geofence, "trackEntryExit", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.geofence, "trackEntryExit", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.geofence, "trackEntryExit", $$c)}},function($event){return _vm.updateField('trackEntryExit')}]}}),_vm._v(" "),_c('span',[_vm._v("TRACK ENTRY AND EXITS")])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.showInAppBanner),expression:"geofence.showInAppBanner"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.geofence.showInAppBanner)?_vm._i(_vm.geofence.showInAppBanner,null)>-1:(_vm.geofence.showInAppBanner)},on:{"change":[function($event){var $$a=_vm.geofence.showInAppBanner,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.geofence, "showInAppBanner", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.geofence, "showInAppBanner", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.geofence, "showInAppBanner", $$c)}},function($event){return _vm.updateField('showInAppBanner')}]}}),_vm._v(" "),_c('span',[_vm._v("SHOW BANNER IN PROVIDER APP")])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.pushNotificationToProvUponEntry),expression:"geofence.pushNotificationToProvUponEntry"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.geofence.pushNotificationToProvUponEntry)?_vm._i(_vm.geofence.pushNotificationToProvUponEntry,null)>-1:(_vm.geofence.pushNotificationToProvUponEntry)},on:{"change":[function($event){var $$a=_vm.geofence.pushNotificationToProvUponEntry,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.geofence, "pushNotificationToProvUponEntry", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.geofence, "pushNotificationToProvUponEntry", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.geofence, "pushNotificationToProvUponEntry", $$c)}},function($event){return _vm.updateField('pushNotificationToProvUponEntry')}]}}),_vm._v(" "),_c('span',[_vm._v("PUSH ENTRY NOTIFICATIONS")])])])]),_vm._v(" "),_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-4 columns padding-R"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("ON DECK - TIMEOUT")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.onDeckTimeout),expression:"geofence.onDeckTimeout"}],attrs:{"type":"number","placeholder":"in Seconds"},domProps:{"value":(_vm.geofence.onDeckTimeout)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.geofence, "onDeckTimeout", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-L padding-R"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("ON DECK - NUMBER OF CHANCES")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.numberOfChances),expression:"geofence.numberOfChances"}],attrs:{"type":"number"},domProps:{"value":(_vm.geofence.numberOfChances)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.geofence, "numberOfChances", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-R"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("ACTIVE TIMER PASSENGER LOADING")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.activeTimer),expression:"geofence.activeTimer"}],attrs:{"type":"number","placeholder":"in Minutes"},domProps:{"value":(_vm.geofence.activeTimer)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.geofence, "activeTimer", $event.target.value)}}})])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._l((_vm.brands),function(brand){return (_vm.serviceList(brand.id).length)?_c('div',{staticClass:"service-list"},[_c('div',{staticClass:"brand"},[_vm._v(_vm._s(brand.name))]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.serviceList(brand.id)),function(service){return _c('div',{staticClass:"column medium-3 end"},[_c('label',{staticClass:"service"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.serviceTypeIds),expression:"geofence.serviceTypeIds"}],attrs:{"type":"checkbox"},domProps:{"value":service.id,"checked":Array.isArray(_vm.geofence.serviceTypeIds)?_vm._i(_vm.geofence.serviceTypeIds,service.id)>-1:(_vm.geofence.serviceTypeIds)},on:{"click":function($event){return _vm.addServiceID(service.id)},"change":function($event){var $$a=_vm.geofence.serviceTypeIds,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=service.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.geofence, "serviceTypeIds", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.geofence, "serviceTypeIds", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.geofence, "serviceTypeIds", $$c)}}}}),_vm._v("\n          "+_vm._s(service.label)+"\n        ")])])}),0)]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"service-list"},[_c('div',{staticClass:"brand"},[_vm._v("LEGACY")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-3 columns end"},[_c('label',{staticClass:"service"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkService.shared),expression:"checkService.shared"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkService.shared)?_vm._i(_vm.checkService.shared,null)>-1:(_vm.checkService.shared)},on:{"change":function($event){var $$a=_vm.checkService.shared,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkService, "shared", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkService, "shared", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkService, "shared", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.serviceLabel('shared')))])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns end"},[_c('label',{staticClass:"service"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkService.opoli),expression:"checkService.opoli"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkService.opoli)?_vm._i(_vm.checkService.opoli,null)>-1:(_vm.checkService.opoli)},on:{"change":function($event){var $$a=_vm.checkService.opoli,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkService, "opoli", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkService, "opoli", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkService, "opoli", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.serviceLabel('opoli')))])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns end"},[_c('label',{staticClass:"service"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkService.black),expression:"checkService.black"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkService.black)?_vm._i(_vm.checkService.black,null)>-1:(_vm.checkService.black)},on:{"change":function($event){var $$a=_vm.checkService.black,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkService, "black", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkService, "black", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkService, "black", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.serviceLabel('black')))])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns end"},[_c('label',{staticClass:"service"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkService.suv),expression:"checkService.suv"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkService.suv)?_vm._i(_vm.checkService.suv,null)>-1:(_vm.checkService.suv)},on:{"change":function($event){var $$a=_vm.checkService.suv,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkService, "suv", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkService, "suv", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkService, "suv", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.serviceLabel('suv')))])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns end"},[_c('label',{staticClass:"service"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkService.shuttle),expression:"checkService.shuttle"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkService.shuttle)?_vm._i(_vm.checkService.shuttle,null)>-1:(_vm.checkService.shuttle)},on:{"change":function($event){var $$a=_vm.checkService.shuttle,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkService, "shuttle", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkService, "shuttle", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkService, "shuttle", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.serviceLabel('shuttle')))])])])])])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("APPLICABLE SERVICE TYPES")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geofence-fields"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"columns margin-B small-6 padding-R"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("Geofence Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.name),expression:"geofence.name"}],attrs:{"type":"text"},domProps:{"value":(_vm.geofence.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.geofence, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns margin-B padding-L"},[(_vm.geofence.type === 'airport')?_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("Airport Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.airportCode),expression:"geofence.airportCode"}],attrs:{"type":"text"},domProps:{"value":(_vm.geofence.airportCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.geofence, "airportCode", $event.target.value)}}})]):_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("Airport Association")]),_vm._v(" "),_c('input',{attrs:{"type":"text","disabled":""},domProps:{"value":_vm.airportAssocioation}})])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns margin-B padding-R end"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("\n          Navigation Address\n          "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.centerpoint),expression:"!!centerpoint"}],staticClass:"center-point"},[_vm._v("("+_vm._s(_vm.centerpoint)+")")])]),_vm._v(" "),_c('div',{staticClass:"autocomplete"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.navigationAddress),expression:"navigationAddress"}],class:{'input-location':true, 'has-error':!!_vm.error.navigationAddress},attrs:{"type":"text","disabled":_vm.loading || _vm.navigationAddressLoading},domProps:{"value":(_vm.navigationAddress)},on:{"keyup":_vm.query,"blur":_vm.clickOut,"input":function($event){if($event.target.composing){ return; }_vm.navigationAddress=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.navigationAddress),expression:"!!error.navigationAddress"}],staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.navigationAddress))]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSuggestion),expression:"showSuggestion"}],staticClass:"suggestions"},_vm._l((_vm.suggestions),function(item,index){return _c('li',{key:index,class:{'empty':item.title === 'Sorry'},on:{"click":function($event){return _vm.selectLocation(index)}}},[_c('i',{class:['fas', item.icon]}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.title + ', ' + item.subtitle))])])}),0)])],1)])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns margin-B padding-L end"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("Overlay Color")]),_vm._v(" "),_c('div',{staticClass:"color-input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofence.overlayColor ? _vm.geofence.overlayColor : _vm.geofence.color),expression:"geofence.overlayColor ? geofence.overlayColor : geofence.color"}],attrs:{"type":"text"},domProps:{"value":(_vm.geofence.overlayColor ? _vm.geofence.overlayColor : _vm.geofence.color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.geofence.overlayColor ? _vm.geofence.overlayColor : _vm.geofence, "color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"palette",style:(_vm.geofence.overlayColor ? {background: '#' + _vm.geofence.overlayColor} : {background: '#' + _vm.geofence.color}),on:{"click":_vm.toggleOverlayColor}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('photoshop-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOverlayColor),expression:"showOverlayColor"}],staticClass:"slide-overlay-color",on:{"ok":_vm.selectColor,"cancel":function($event){_vm.showOverlayColor = false}},model:{value:(_vm.overlayColor),callback:function ($$v) {_vm.overlayColor=$$v},expression:"overlayColor"}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns margin-B padding-R end"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("Manual Coords (OPTIONAL)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.manualCoords),expression:"manualCoords"}],attrs:{"type":"text","disabled":_vm.loading || _vm.navigationAddressLoading},domProps:{"value":(_vm.manualCoords)},on:{"input":function($event){if($event.target.composing){ return; }_vm.manualCoords=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-5 columns padding-R end"},[_c('div',{class:{'row upload-row':true, 'below':!_vm.upload.kml.loading}},[_c('div',{class:{'upload-box':true, 'has-message':_vm.upload.kml.message}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.upload.kml.loading),expression:"!upload.kml.loading"}],class:{'upload-message':true, 'error':!_vm.upload.kml.success}},[_vm._v(_vm._s(_vm.upload.kml.message))]),_vm._v(" "),_c('b',{staticClass:"upload-file"},[_vm._v("KML file")]),_vm._v(" "),_c('div',{staticClass:"button warning xsmall",on:{"click":_vm.triggerKMLUpload}},[(!!_vm.geofence.kmlFile && !_vm.upload.kml.loading)?_c('span',[_vm._v("Replace")]):(!_vm.upload.kml.loading)?_c('span',[_vm._v("Upload")]):_c('span',[_vm._v("Uploading...")])]),_vm._v(" "),(!!_vm.geofence.kmlFile)?_c('a',{staticClass:"button success xsmall download",attrs:{"href":_vm.geofence.kmlFile,"download":""}},[_vm._v("Download")]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"kmlUpload",staticClass:"input",attrs:{"type":"file"}})])])]),_vm._v(" "),_c('div',{staticClass:"small-5 columns padding-L end"},[(_vm.geofence.type === 'airport')?_c('div',{class:{'row upload-row':true, 'below':!_vm.upload.csv.loading}},[_c('div',{class:{'upload-box airline':true, 'has-message':_vm.upload.csv.message}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.upload.csv.loading),expression:"!upload.csv.loading"}],class:{'upload-message':true, 'error':!_vm.upload.csv.success}},[_vm._v(_vm._s(_vm.upload.csv.message))]),_vm._v(" "),_c('b',{staticClass:"upload-file"},[_vm._v("Airlines and Terminal CSV")]),_vm._v(" "),_c('div',{staticClass:"button warning xsmall",on:{"click":_vm.triggerCSVUpload}},[(!_vm.upload.csv.loading)?_c('span',[_vm._v("Replace")]):(_vm.upload.action === 'upload')?_c('span',[_vm._v("Uploading...")]):_c('span',[_vm._v("Replace")])]),_vm._v(" "),_c('div',{staticClass:"button success xsmall download",on:{"click":_vm.downloadCSV}},[(!_vm.upload.csv.loading)?_c('span',[_vm._v("Download")]):(_vm.upload.action === 'download')?_c('span',[_vm._v("Downloading...")]):_c('span',[_vm._v("Download")])]),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"csvUpload",staticClass:"input",attrs:{"type":"file"},on:{"change":_vm.uploadFile}})])]):_vm._e()])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.upload.csv.loading || _vm.upload.kml.loading),expression:"upload.csv.loading || upload.kml.loading"}],staticClass:"upload-loading-bg"})]),_vm._v(" "),(_vm.geofence.type === 'airport')?_c('div',[_c('geofence-fields-airport',{attrs:{"geofence":_vm.geofence,"loadOtherData":_vm.loadOtherData},on:{"uploading":_vm.uploadingPickupInstruction}})],1):_vm._e(),_vm._v(" "),(_vm.geofence.type === 'restricted')?_c('div',[_c('geofence-fields-restricted',{attrs:{"geofence":_vm.geofence}})],1):_vm._e(),_vm._v(" "),(_vm.geofence.type === 'staging')?_c('div',[_c('geofence-fields-staging',{attrs:{"geofence":_vm.geofence}})],1):_vm._e(),_vm._v(" "),(_vm.geofence.type === 'servicearea')?_c('div',[_c('geofence-fields-service-area',{attrs:{"geofence":_vm.geofence}})],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.formError.show),expression:"formError.show"}],staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"error-message"},[_vm._v("\n        Please fix the following errors first before continuing:\n        "),_c('ul',_vm._l((_vm.formError.items),function(item){return _c('li',[_vm._v(_vm._s(item))])}),0)])])]),_vm._v(" "),_c('div',{class:['row geofence-controls', _vm.geofence.type === 'servicearea' ? 'service-area' : '']},[(_vm.geofence.type === 'servicearea')?_c('div',{staticClass:"small-2 columns padding-L padding-R"},[_c('a',{staticClass:"button cta xsmall block info",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.clone(_vm.geofence.id)}}},[_vm._v("Clone")])]):_vm._e(),_vm._v(" "),(_vm.geofenceStatus !== 'archived')?_c('div',{class:['small-2 columns padding-R', _vm.geofence.type === 'servicearea' ? 'small-offset-4' : 'small-offset-6']},[_c('a',{staticClass:"button cta xsmall block warning",attrs:{"href":"javascript:;"},on:{"click":_vm.toggleEnabled}},[(_vm.geofenceStatus === 'active')?_c('span',[_vm._v("DEACTIVATE")]):_c('span',[_vm._v("ACTIVATE")])])]):_vm._e(),_vm._v(" "),_c('div',{class:['small-2 columns padding-L padding-R', _vm.geofence.archived ? 'small-offset-8' : _vm.geofence.type === 'servicearea' && _vm.geofence.status === 'archived' ? 'small-offset-6' : '']},[_c('a',{staticClass:"button cta xsmall block error",attrs:{"href":"javascript:;"},on:{"click":_vm.toggleArchived}},[(_vm.geofenceStatus === 'archived')?_c('span',[_vm._v("UNARCHIVE")]):_c('span',[_vm._v("ARCHIVE")])])]),_vm._v(" "),_c('div',{staticClass:"small-2 columns padding-L"},[_c('button',{class:{'button cta xsmall block success':true, 'disabled':_vm.uploading.tnc || _vm.uploading.tcp},attrs:{"href":"javascript:;","disabled":_vm.uploading.tnc || _vm.uploading.tcp},on:{"click":_vm.uploadKML}},[_vm._v("SAVE "),_c('span',{staticClass:"hideMobile"},[_vm._v("CHANGES")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"expand"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('div',{staticClass:"modal-table"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"box"},[_c('div',{attrs:{"id":"scrollHere"}}),_vm._v(" "),(!!_vm.message)?_c('div',[(_vm.success)?_c('i',{staticClass:"far fa-check-circle fa-4x response"}):_c('i',{staticClass:"far fa-times-circle fa-4x response"}),_vm._v(" "),_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),(!_vm.success)?_c('div',{staticClass:"button cta block",on:{"click":_vm.closeModal}},[_vm._v("Close")]):_vm._e()]):_c('div',[_c('i',{staticClass:"fa fa-spinner fa-spin fa-2x"}),_vm._v(" "),_c('span',[_vm._v("Saving...")])])])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"heading"},[_c('label',[_vm._v("GEOFENCE INFORMATION")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofenceFilters_vue__ = __webpack_require__(562);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c376c0a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofenceFilters_vue__ = __webpack_require__(1628);
function injectStyle (ssrContext) {
  __webpack_require__(1626)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c376c0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofenceFilters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c376c0a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofenceFilters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1627);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("21994c7e", content, true, {});

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.geofence-filters[data-v-1c376c0a] {\n  margin-bottom: 15px;\n  padding: 10px 20px 15px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  position: fixed;\n  top: 51px;\n  left: 0;\n  width: 60%;\n  z-index: 4;\n  background-color: #F4F8F9;\n}\n.filter-field label[data-v-1c376c0a] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #0D79F2;\n}\n.filter-field input[data-v-1c376c0a],\n.filter-field select[data-v-1c376c0a] {\n  margin-top: 0;\n  font-size: 14px;\n  padding: 7px 10px;\n}\n.filter-field select[data-v-1c376c0a] {\n  height: 37px;\n  outline: 0;\n  display: block;\n  border-color: rgba(0, 0, 0, 0.15);\n  background-color: #fff;\n  border-radius: 3px;\n}\n.filter-field select[data-v-1c376c0a]:disabled {\n  background: #eee;\n}\n.filter-button[data-v-1c376c0a] {\n  margin-top: 25px;\n}\n.padding-L[data-v-1c376c0a] {\n  padding-left: 7px;\n}\n.padding-R[data-v-1c376c0a] {\n  padding-right: 7px;\n}\n.show-mobile[data-v-1c376c0a] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.geofence-filters[data-v-1c376c0a] {\n    width: 100%;\n}\n.geofence-filters .padding-L[data-v-1c376c0a], .geofence-filters .padding-R[data-v-1c376c0a] {\n      padding: 0;\n}\n.geofence-filters .small-2[data-v-1c376c0a], .geofence-filters .small-1[data-v-1c376c0a] {\n      width: 48%;\n      margin: 0 1%;\n}\n.geofence-filters .small-offset-1[data-v-1c376c0a] {\n      margin: 0;\n}\n.show-mobile[data-v-1c376c0a] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.show-mobile div[data-v-1c376c0a] {\n      width: 43%;\n}\n.show-mobile .filter-btn[data-v-1c376c0a] {\n      background-color: gray;\n}\n.show-mobile .filter-button[data-v-1c376c0a] {\n      margin-top: 0;\n}\n.filter[data-v-1c376c0a] {\n    display: none;\n}\n.filter.show[data-v-1c376c0a] {\n      display: block;\n}\n.row[data-v-1c376c0a] {\n    margin-top: 10px;\n}\n.hide-mobile[data-v-1c376c0a] {\n    display: none;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Geofences/GeofenceFilters.vue"],"names":[],"mappings":";AACA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,6CAA6C;EAC7C,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,WAAW;EACX,0BAA0B;CAC3B;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;CAChB;AACD;;EAEE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;CACnB;AACD;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;CACpB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,cAAc;CACf;AACD;AACA;IACI,YAAY;CACf;AACD;MACM,WAAW;CAChB;AACD;MACM,WAAW;MACX,aAAa;CAClB;AACD;MACM,UAAU;CACf;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,0BAA0B;QACtB,uBAAuB;YACnB,+BAA+B;CAC1C;AACD;MACM,WAAW;CAChB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,cAAc;CACnB;AACD;IACI,cAAc;CACjB;AACD;MACM,eAAe;CACpB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,cAAc;CACjB;CACA","file":"GeofenceFilters.vue","sourcesContent":["\n.geofence-filters[data-v-1c376c0a] {\n  margin-bottom: 15px;\n  padding: 10px 20px 15px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  position: fixed;\n  top: 51px;\n  left: 0;\n  width: 60%;\n  z-index: 4;\n  background-color: #F4F8F9;\n}\n.filter-field label[data-v-1c376c0a] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #0D79F2;\n}\n.filter-field input[data-v-1c376c0a],\n.filter-field select[data-v-1c376c0a] {\n  margin-top: 0;\n  font-size: 14px;\n  padding: 7px 10px;\n}\n.filter-field select[data-v-1c376c0a] {\n  height: 37px;\n  outline: 0;\n  display: block;\n  border-color: rgba(0, 0, 0, 0.15);\n  background-color: #fff;\n  border-radius: 3px;\n}\n.filter-field select[data-v-1c376c0a]:disabled {\n  background: #eee;\n}\n.filter-button[data-v-1c376c0a] {\n  margin-top: 25px;\n}\n.padding-L[data-v-1c376c0a] {\n  padding-left: 7px;\n}\n.padding-R[data-v-1c376c0a] {\n  padding-right: 7px;\n}\n.show-mobile[data-v-1c376c0a] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.geofence-filters[data-v-1c376c0a] {\n    width: 100%;\n}\n.geofence-filters .padding-L[data-v-1c376c0a], .geofence-filters .padding-R[data-v-1c376c0a] {\n      padding: 0;\n}\n.geofence-filters .small-2[data-v-1c376c0a], .geofence-filters .small-1[data-v-1c376c0a] {\n      width: 48%;\n      margin: 0 1%;\n}\n.geofence-filters .small-offset-1[data-v-1c376c0a] {\n      margin: 0;\n}\n.show-mobile[data-v-1c376c0a] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.show-mobile div[data-v-1c376c0a] {\n      width: 43%;\n}\n.show-mobile .filter-btn[data-v-1c376c0a] {\n      background-color: gray;\n}\n.show-mobile .filter-button[data-v-1c376c0a] {\n      margin-top: 0;\n}\n.filter[data-v-1c376c0a] {\n    display: none;\n}\n.filter.show[data-v-1c376c0a] {\n      display: block;\n}\n.row[data-v-1c376c0a] {\n    margin-top: 10px;\n}\n.hide-mobile[data-v-1c376c0a] {\n    display: none;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geofence-filters"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.applyFilters(false)}}},[_c('div',{staticClass:"show-mobile"},[_c('div',[_c('a',{staticClass:"button cta xsmall block filter-button",on:{"click":_vm.prioritizeGeofences}},[_vm._v("PRIORITIZE")])]),_vm._v(" "),_c('div',[_c('a',{staticClass:"button cta xsmall block success filter-button",on:{"click":_vm.showCreateForm}},[_vm._v("CREATE GEOFENCE")])]),_vm._v(" "),_c('a',{staticClass:"button xsmall info filter-btn",on:{"click":function($event){_vm.isOpenFilter = !_vm.isOpenFilter}}},[_c('i',{staticClass:"fas fa-filter"})])]),_vm._v(" "),_c('div',{class:['row filter', _vm.isOpenFilter ? 'show' : '']},[_c('div',{staticClass:"small-2 columns padding-R"},[_c('div',{staticClass:"filter-field"},[_c('label',[_vm._v("FILTER BY TYPE")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofenceType),expression:"geofenceType"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.geofenceType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.applyFilters(true)}]}},[_c('option',{attrs:{"value":"airport"}},[_vm._v("Airport")]),_vm._v(" "),_c('option',{attrs:{"value":"staging"}},[_vm._v("Staging")]),_vm._v(" "),_c('option',{attrs:{"value":"restricted"}},[_vm._v("Restricted")]),_vm._v(" "),_c('option',{attrs:{"value":"servicearea"}},[_vm._v("Service Area")]),_vm._v(" "),_c('option',{attrs:{"value":"tracking"}},[_vm._v("Tracking")])])])]),_vm._v(" "),_c('div',{staticClass:"small-2 columns padding-L padding-R"},[_c('div',{staticClass:"filter-field"},[_c('label',[_vm._v("FILTER BY STATUS")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofenceStatus),expression:"geofenceStatus"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.geofenceStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.applyFilters(true)}]}},[_c('option',{attrs:{"value":"active"}},[_vm._v("Active")]),_vm._v(" "),_c('option',{attrs:{"value":"deactivated"}},[_vm._v("Inactive")]),_vm._v(" "),_c('option',{attrs:{"value":"archived"}},[_vm._v("Archived")])])])]),_vm._v(" "),_c('div',{staticClass:"small-2 columns padding-L padding-R"},[_c('div',{staticClass:"filter-field"},[_c('label',[_vm._v("FILTER BY BRAND")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofenceBrand),expression:"geofenceBrand"}],class:{'disabled': _vm.isBrand},attrs:{"disabled":_vm.isBrand},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.geofenceBrand=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.applyFilters(true)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("Unbranded")]),_vm._v(" "),_vm._l((_vm.brands),function(brand,index){return _c('option',{key:index,domProps:{"value":brand.id}},[_vm._v(_vm._s(brand.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"small-1 columns padding-L"},[_c('div',{staticClass:"filter-field"},[_c('label',[_vm._v("PAGE")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.pageNum),expression:"pageNum",modifiers:{"number":true}}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.pageNum=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.applyFilters(false)}]}},_vm._l((_vm.pageTotal),function(n){return _c('option',{domProps:{"value":n}},[_vm._v(_vm._s(n))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"small-offset-1 small-2 columns padding-R hide-mobile"},[_c('a',{staticClass:"button cta xsmall block filter-button",on:{"click":_vm.prioritizeGeofences}},[_vm._v("PRIORITIZE")])]),_vm._v(" "),_c('div',{staticClass:"small-2 columns padding-L hide-mobile"},[_c('a',{staticClass:"button cta xsmall block success filter-button",on:{"click":_vm.showCreateForm}},[_vm._v("CREATE GEOFENCE")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geofences"},[_c('geofence-filters'),_vm._v(" "),_c('div',{staticClass:"geofence-list"},[_vm._l((_vm.geofences),function(geofence,index){return _c('div',{key:'GEO_' + geofence.id,class:{'geofence':true, 'show':geofence.showForm}},[_c('div',{staticClass:"geofence-title isDesktop",on:{"click":function($event){return _vm.toggleForm(index, geofence.id)}}},[_c('span',{staticClass:"color",style:(geofence.overlayColor ? { backgroundColor: '#' + geofence.overlayColor } : { backgroundColor: '#' + geofence.color })}),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(geofence.name))]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!geofence.showForm),expression:"!geofence.showForm"}],staticClass:"fa fa-caret-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(geofence.showForm),expression:"geofence.showForm"}],staticClass:"fa fa-caret-up"}),_vm._v(" "),_c('span',{staticClass:"geofence-type"},[_vm._v(_vm._s(_vm.formatGeofenceType(geofence.type)))]),_vm._v(" "),_c('label',{staticClass:"show-map",on:{"click":function($event){$event.stopPropagation();}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.polygons),expression:"polygons"}],attrs:{"type":"checkbox"},domProps:{"value":geofence.id,"checked":Array.isArray(_vm.polygons)?_vm._i(_vm.polygons,geofence.id)>-1:(_vm.polygons)},on:{"change":function($event){var $$a=_vm.polygons,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=geofence.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.polygons=$$a.concat([$$v]))}else{$$i>-1&&(_vm.polygons=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.polygons=$$c}}}}),_vm._v(" "),_c('span',[_vm._v("SHOW ON MAP")])])]),_vm._v(" "),_c('div',{staticClass:"geofence-title isMobile",on:{"click":function($event){return _vm.toggleForm(index, geofence.id)}}},[_c('div',[_c('span',{staticClass:"geofence-type"},[_vm._v(_vm._s(_vm.formatGeofenceType(geofence.type)))]),_vm._v(" "),_c('label',{staticClass:"show-map",on:{"click":function($event){$event.stopPropagation();}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.polygons),expression:"polygons"}],attrs:{"type":"checkbox"},domProps:{"value":geofence.id,"checked":Array.isArray(_vm.polygons)?_vm._i(_vm.polygons,geofence.id)>-1:(_vm.polygons)},on:{"change":function($event){var $$a=_vm.polygons,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=geofence.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.polygons=$$a.concat([$$v]))}else{$$i>-1&&(_vm.polygons=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.polygons=$$c}}}}),_vm._v(" "),_c('span',[_vm._v("SHOW ON MAP")])])]),_vm._v(" "),_c('div',[_c('div',[_c('span',{staticClass:"color",style:(geofence.overlayColor ? { backgroundColor: '#' + geofence.overlayColor } : { backgroundColor: '#' + geofence.color })}),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(geofence.name))])]),_vm._v(" "),_c('div',{on:{"click":function($event){}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(!geofence.showForm),expression:"!geofence.showForm"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(geofence.showForm),expression:"geofence.showForm"}],staticClass:"fa fa-minus-circle"})])])]),_vm._v(" "),_c('div',{class:{ 'geofence-form': true, show: geofence.showForm }},[_c('geofence-fields',{key:geofence.id,ref:'geofenceField' + index,refInFor:true,attrs:{"geofence":geofence,"loadOtherData":_vm.loadOtherData[index] || false}})],1)])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.geofences.length <= 0),expression:"geofences.length <= 0"}],staticClass:"empty-list"},[_c('i',{staticClass:"far fa-compass fa-lg"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("No Geofences found.")])])],2),_vm._v(" "),_c('div',{class:{ 'geofence-loading': true, show: _vm.isLoading }},[_vm._m(0)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-content"},[_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-lg"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("LOADING...")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofenceMap2_vue__ = __webpack_require__(563);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_307611a3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofenceMap2_vue__ = __webpack_require__(1635);
function injectStyle (ssrContext) {
  __webpack_require__(1631)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-307611a3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofenceMap2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_307611a3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofenceMap2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1632);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("b3dae284", content, true, {});

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.geofence-map[data-v-307611a3] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: none;\n}\n.map-here[data-v-307611a3] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Geofences/GeofenceMap2.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,cAAc;CACf;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;CACd","file":"GeofenceMap2.vue","sourcesContent":["\n.geofence-map[data-v-307611a3] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: none;\n}\n.map-here[data-v-307611a3] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(1634);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 1634 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 1635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geofence-map-container"},[_c('div',{staticClass:"map-here",attrs:{"id":"mapHere"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofenceCreate_vue__ = __webpack_require__(566);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218f0170_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofenceCreate_vue__ = __webpack_require__(1639);
function injectStyle (ssrContext) {
  __webpack_require__(1637)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-218f0170"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofenceCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218f0170_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofenceCreate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1638);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2c204543", content, true, {});

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.op--modal-container[data-v-218f0170] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-218f0170] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-218f0170] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-218f0170] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.create-box[data-v-218f0170] {\n  width: 100%;\n  max-width: 500px;\n  background: #fff;\n  margin: 0 auto;\n  padding-bottom: 20px;\n  border-radius: 3px;\n  position: relative;\n}\n.create-box .title[data-v-218f0170] {\n    font-size: 21px;\n    font-weight: 600;\n    text-align: center;\n    margin-bottom: 25px;\n    padding: 10px;\n    color: #FFF;\n    background: #333;\n    border-radius: 3px 3px 0 0;\n}\n.create-box .row[data-v-218f0170] {\n    width: 100%;\n    padding: 0 20px;\n    margin-bottom: 10px;\n}\n.create-box .row .small-6[data-v-218f0170]:first-child {\n      padding-right: 10px;\n}\n.create-box .cancel[data-v-218f0170] {\n    display: block;\n    text-align: center;\n    font-size: 14px;\n    margin: 10px 0 0;\n    color: #999;\n    cursor: pointer;\n}\n.input-field[data-v-218f0170] {\n  font-size: 14px;\n}\n.input-field label[data-v-218f0170] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n}\n.input-field input[data-v-218f0170] {\n    margin-top: 0;\n    padding: 7px 10px;\n}\n.input-field input.has-error[data-v-218f0170] {\n      border-color: #fb2d2d;\n}\n.input-field select[data-v-218f0170] {\n    padding: 7px 3px;\n    border-color: #ccc;\n    background-color: #fff;\n}\n.input-field select[data-v-218f0170]:disabled {\n      background: #ebebe4;\n}\n.input-field .error-msg[data-v-218f0170] {\n    display: block;\n    font-size: 12px;\n    color: #fb2d2d;\n    font-style: italic;\n}\n.input-field .center-point[data-v-218f0170] {\n    color: #888;\n    display: inline-block;\n    margin-left: 5px;\n}\n.autocomplete[data-v-218f0170] {\n  position: relative;\n  width: 100%;\n}\n.input-location[data-v-218f0170] {\n  margin: 5px 0 0;\n  color: #333;\n  line-height: inherit;\n  -webkit-transition: all .15s ease;\n  transition: all .15s ease;\n}\n.input-location.loading[data-v-218f0170] {\n    padding-right: 40px;\n}\n.input-location.has-error[data-v-218f0170] {\n    border-color: #f20d0d;\n}\n.input-location[data-v-218f0170]:disabled {\n    background: #eee;\n}\n.suggestions[data-v-218f0170] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  max-height: 150px;\n  z-index: 2;\n  list-style: none;\n  overflow: auto;\n  padding: 0;\n  margin: 0;\n  -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);\n}\n.suggestions li[data-v-218f0170] {\n    background: #f6f6f6;\n    padding: 8px 10px;\n    width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor: pointer;\n    border-bottom: 1px solid #bbb;\n    color: #333;\n}\n.suggestions li[data-v-218f0170]:last-child {\n      border-bottom: none;\n}\n.suggestions li i[data-v-218f0170] {\n      margin-right: 5px;\n}\n.suggestions li span[data-v-218f0170] {\n      font-size: 13px;\n}\n.suggestions li .fa-exclamation-triangle[data-v-218f0170] {\n      color: #e2c84a;\n}\n.suggestions li .fa-map-marker[data-v-218f0170] {\n      color: #ea5c5c;\n}\n.suggestions li[data-v-218f0170]:hover {\n      background: #0D79F2;\n      color: #fff;\n}\n.suggestions li:hover i[data-v-218f0170] {\n        color: #fff;\n}\n.suggestions li.empty[data-v-218f0170] {\n      cursor: default;\n}\n.color-box[data-v-218f0170] {\n  position: relative;\n}\n.color-blocker[data-v-218f0170] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n  background: rgba(255, 255, 255, 0.4);\n}\n.response-box[data-v-218f0170] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.3);\n}\n.response-box .content[data-v-218f0170] {\n    width: 300px;\n    position: absolute;\n    top: 50%;\n    left: 100px;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n    padding: 20px;\n    background: #fff;\n    text-align: center;\n    color: #33c761;\n}\n.response-box .content span[data-v-218f0170] {\n      display: block;\n      font-size: 21px;\n      margin: 5px 0 10px;\n}\n.slide-down-enter-active[data-v-218f0170], .slide-down-leave-active[data-v-218f0170] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-218f0170], .slide-down-leave-to[data-v-218f0170] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.create-box[data-v-218f0170] {\n    max-width: none;\n    width: 100vw;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Geofences/GeofenceCreate.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,2BAA2B;CAC9B;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;CACvB;AACD;MACM,oBAAoB;CACzB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;CACnB;AACD;EACE,gBAAgB;CACjB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,cAAc;IACd,kBAAkB;CACrB;AACD;MACM,sBAAsB;CAC3B;AACD;IACI,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;CAC1B;AACD;MACM,oBAAoB;CACzB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;CACtB;AACD;IACI,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;CACpB;AACD;EACE,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;IACI,oBAAoB;CACvB;AACD;IACI,sBAAsB;CACzB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,UAAU;EACV,mDAAmD;UAC3C,2CAA2C;CACpD;AACD;IACI,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,8BAA8B;IAC9B,YAAY;CACf;AACD;MACM,oBAAoB;CACzB;AACD;MACM,kBAAkB;CACvB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,oBAAoB;MACpB,YAAY;CACjB;AACD;QACQ,YAAY;CACnB;AACD;MACM,gBAAgB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,WAAW;EACX,qCAAqC;CACtC;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;CAChC;AACD;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,oCAAoC;YAC5B,4BAA4B;IACpC,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;CAClB;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,mBAAmB;CACxB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ;AACD;AACA;IACI,gBAAgB;IAChB,aAAa;CAChB;CACA","file":"GeofenceCreate.vue","sourcesContent":["\n.op--modal-container[data-v-218f0170] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-218f0170] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-218f0170] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-218f0170] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.create-box[data-v-218f0170] {\n  width: 100%;\n  max-width: 500px;\n  background: #fff;\n  margin: 0 auto;\n  padding-bottom: 20px;\n  border-radius: 3px;\n  position: relative;\n}\n.create-box .title[data-v-218f0170] {\n    font-size: 21px;\n    font-weight: 600;\n    text-align: center;\n    margin-bottom: 25px;\n    padding: 10px;\n    color: #FFF;\n    background: #333;\n    border-radius: 3px 3px 0 0;\n}\n.create-box .row[data-v-218f0170] {\n    width: 100%;\n    padding: 0 20px;\n    margin-bottom: 10px;\n}\n.create-box .row .small-6[data-v-218f0170]:first-child {\n      padding-right: 10px;\n}\n.create-box .cancel[data-v-218f0170] {\n    display: block;\n    text-align: center;\n    font-size: 14px;\n    margin: 10px 0 0;\n    color: #999;\n    cursor: pointer;\n}\n.input-field[data-v-218f0170] {\n  font-size: 14px;\n}\n.input-field label[data-v-218f0170] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n}\n.input-field input[data-v-218f0170] {\n    margin-top: 0;\n    padding: 7px 10px;\n}\n.input-field input.has-error[data-v-218f0170] {\n      border-color: #fb2d2d;\n}\n.input-field select[data-v-218f0170] {\n    padding: 7px 3px;\n    border-color: #ccc;\n    background-color: #fff;\n}\n.input-field select[data-v-218f0170]:disabled {\n      background: #ebebe4;\n}\n.input-field .error-msg[data-v-218f0170] {\n    display: block;\n    font-size: 12px;\n    color: #fb2d2d;\n    font-style: italic;\n}\n.input-field .center-point[data-v-218f0170] {\n    color: #888;\n    display: inline-block;\n    margin-left: 5px;\n}\n.autocomplete[data-v-218f0170] {\n  position: relative;\n  width: 100%;\n}\n.input-location[data-v-218f0170] {\n  margin: 5px 0 0;\n  color: #333;\n  line-height: inherit;\n  -webkit-transition: all .15s ease;\n  transition: all .15s ease;\n}\n.input-location.loading[data-v-218f0170] {\n    padding-right: 40px;\n}\n.input-location.has-error[data-v-218f0170] {\n    border-color: #f20d0d;\n}\n.input-location[data-v-218f0170]:disabled {\n    background: #eee;\n}\n.suggestions[data-v-218f0170] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  max-height: 150px;\n  z-index: 2;\n  list-style: none;\n  overflow: auto;\n  padding: 0;\n  margin: 0;\n  -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);\n}\n.suggestions li[data-v-218f0170] {\n    background: #f6f6f6;\n    padding: 8px 10px;\n    width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor: pointer;\n    border-bottom: 1px solid #bbb;\n    color: #333;\n}\n.suggestions li[data-v-218f0170]:last-child {\n      border-bottom: none;\n}\n.suggestions li i[data-v-218f0170] {\n      margin-right: 5px;\n}\n.suggestions li span[data-v-218f0170] {\n      font-size: 13px;\n}\n.suggestions li .fa-exclamation-triangle[data-v-218f0170] {\n      color: #e2c84a;\n}\n.suggestions li .fa-map-marker[data-v-218f0170] {\n      color: #ea5c5c;\n}\n.suggestions li[data-v-218f0170]:hover {\n      background: #0D79F2;\n      color: #fff;\n}\n.suggestions li:hover i[data-v-218f0170] {\n        color: #fff;\n}\n.suggestions li.empty[data-v-218f0170] {\n      cursor: default;\n}\n.color-box[data-v-218f0170] {\n  position: relative;\n}\n.color-blocker[data-v-218f0170] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n  background: rgba(255, 255, 255, 0.4);\n}\n.response-box[data-v-218f0170] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.3);\n}\n.response-box .content[data-v-218f0170] {\n    width: 300px;\n    position: absolute;\n    top: 50%;\n    left: 100px;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n    padding: 20px;\n    background: #fff;\n    text-align: center;\n    color: #33c761;\n}\n.response-box .content span[data-v-218f0170] {\n      display: block;\n      font-size: 21px;\n      margin: 5px 0 10px;\n}\n.slide-down-enter-active[data-v-218f0170], .slide-down-leave-active[data-v-218f0170] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-218f0170], .slide-down-leave-to[data-v-218f0170] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.create-box[data-v-218f0170] {\n    max-width: none;\n    width: 100vw;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'op--modal-container':true, 'hide':!_vm.showCreateGeofence},on:{"click":_vm.close}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content"},[_c('div',{staticClass:"create-box",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(this.formName)+" Geofence")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("Geofence Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofenceName),expression:"geofenceName"}],class:{'has-error':!!_vm.error.geofenceName},attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.geofenceName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.geofenceName=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.geofenceName),expression:"!!error.geofenceName"}],staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.geofenceName))])])])]),_vm._v(" "),(false)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("Geofence ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofenceID),expression:"geofenceID"}],class:{'has-error':!!_vm.error.geofenceID},attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.geofenceID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.geofenceID=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.geofenceID),expression:"!!error.geofenceID"}],staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.geofenceID))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("\n                Navigation Address\n                "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.centerpoint),expression:"!!centerpoint"}],staticClass:"center-point"},[_vm._v("("+_vm._s(_vm.centerpoint)+")")])]),_vm._v(" "),_c('div',{staticClass:"autocomplete"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.navigationAddress),expression:"navigationAddress"}],class:{'input-location':true, 'has-error':!!_vm.error.navigationAddress},attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.navigationAddress)},on:{"keyup":_vm.query,"blur":_vm.clickOut,"input":function($event){if($event.target.composing){ return; }_vm.navigationAddress=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.navigationAddress),expression:"!!error.navigationAddress"}],staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.navigationAddress))]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSuggestion),expression:"showSuggestion"}],staticClass:"suggestions"},_vm._l((_vm.suggestions),function(item,index){return _c('li',{class:{'empty':item.title === 'Sorry'},on:{"click":function($event){return _vm.selectLocation(index)}}},[_c('i',{class:['fas', item.icon]}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.title + ', ' + item.subtitle))])])}),0)])],1)])])]),_vm._v(" "),(this.formName === 'Create')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("Geofence Type")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.type),expression:"type"}],attrs:{"disabled":_vm.loading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changeType]}},[_c('option',{attrs:{"value":"airport"}},[_vm._v("Airport")]),_vm._v(" "),_c('option',{attrs:{"value":"staging"}},[_vm._v("Staging Lot")]),_vm._v(" "),_c('option',{attrs:{"value":"restricted"}},[_vm._v("Restricted Area")]),_vm._v(" "),_c('option',{attrs:{"value":"servicearea"}},[_vm._v("Service Area")]),_vm._v(" "),_c('option',{attrs:{"value":"tracking"}},[_vm._v("Tracking")])])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("Airport Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.airportCode),expression:"airportCode"}],class:{'has-error':!!_vm.error.airportCode},attrs:{"type":"text","disabled":_vm.loading || _vm.type !== 'airport'},domProps:{"value":(_vm.airportCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.airportCode=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.airportCode),expression:"!!error.airportCode"}],staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.airportCode))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("Geofence Brand")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.geofenceBrand),expression:"geofenceBrand"}],attrs:{"disabled":_vm.loading || _vm.type !=='servicearea'},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.geofenceBrand=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.brands),function(brand,index){return _c('option',{key:index,domProps:{"value":brand.id}},[_vm._v(_vm._s(brand.name))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"input-field"},[_c('label',[_vm._v("Overlay Color")]),_vm._v(" "),_c('div',{staticClass:"color-box"},[_c('photoshop-picker',{staticClass:"overlayColor",model:{value:(_vm.overlayColor),callback:function ($$v) {_vm.overlayColor=$$v},expression:"overlayColor"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"color-blocker"})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('br'),_vm._v(" "),_c('div',{class:{'button cta success block':true, 'disabled':_vm.loading || _vm.airportAssoc.loading},on:{"click":_vm.createGeofence}},[_vm._v(_vm._s(this.formName))]),_vm._v(" "),_c('a',{staticClass:"cancel",on:{"click":_vm.close}},[_vm._v("Cancel")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSuccess),expression:"showSuccess"}],staticClass:"response-box"},[_c('div',{staticClass:"content"},[_c('i',{staticClass:"far fa-check-circle fa-4x response"}),_vm._v(" "),_c('span',[_vm._v("Success")]),_vm._v(" "),_c('div',{staticClass:"button cta success block xsmall",on:{"click":_vm.refreshTable}},[_vm._v("Close")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofencePriority_vue__ = __webpack_require__(567);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3ec32a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofencePriority_vue__ = __webpack_require__(1643);
function injectStyle (ssrContext) {
  __webpack_require__(1641)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a3ec32a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofencePriority_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3ec32a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofencePriority_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1642);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("fea6c71c", content, true, {});

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.priority-modal-container[data-v-a3ec32a8] {\n  position: fixed;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 12;\n  opacity: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  overflow: auto;\n}\n.priority-modal-container.show[data-v-a3ec32a8] {\n    top: 0;\n    opacity: 1;\n}\n.geofence-priority-container[data-v-a3ec32a8] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.geofence-priority[data-v-a3ec32a8] {\n  display: table-cell;\n  vertical-align: middle;\n  padding: 30px;\n  position: relative;\n}\n.geofence-priority .title[data-v-a3ec32a8] {\n    padding: 20px 0 30px;\n    text-align: center;\n    font-weight: 700;\n    font-size: 18px;\n    color: #0D79F2;\n}\n.geofences[data-v-a3ec32a8] {\n  padding: 0 30px 30px;\n  position: relative;\n  background-color: #fff;\n  margin: 30px;\n  min-height: 300px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  width: 500px;\n  margin: 0 auto;\n}\n.geofences.loading[data-v-a3ec32a8] {\n    min-height: 100px;\n    width: 300px;\n    margin: 0 auto;\n}\n.geofence[data-v-a3ec32a8] {\n  padding: 10px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  margin: 0 7px 10px;\n  border-radius: 3px;\n  font-size: 14px;\n  cursor: pointer;\n}\n.geofence span[data-v-a3ec32a8] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.geofence .color[data-v-a3ec32a8] {\n    width: 13px;\n    height: 13px;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n    margin-right: 10px;\n}\n.controls[data-v-a3ec32a8] {\n  text-align: center;\n  margin-top: 30px;\n}\n.loader[data-v-a3ec32a8] {\n  text-align: center;\n  padding: 30px 0 0;\n}\n.save-btn[data-v-a3ec32a8] {\n  width: 83px;\n}\n@media only screen and (max-width: 430px) {\n.geofence-priority[data-v-a3ec32a8] {\n    padding: 0;\n}\n.geofence-priority .geofences[data-v-a3ec32a8] {\n      width: 100%;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Geofences/GeofencePriority.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;EACX,qCAAqC;EACrC,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;CAChB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;CACpB;AACD;IACI,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;CAClB;AACD;EACE,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;EACb,eAAe;CAChB;AACD;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;CAClB;AACD;EACE,cAAc;EACd,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;CACjB;AACD;IACI,sBAAsB;IACtB,uBAAuB;CAC1B;AACD;IACI,YAAY;IACZ,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,mBAAmB;CACtB;AACD;EACE,mBAAmB;EACnB,iBAAiB;CAClB;AACD;EACE,mBAAmB;EACnB,kBAAkB;CACnB;AACD;EACE,YAAY;CACb;AACD;AACA;IACI,WAAW;CACd;AACD;MACM,YAAY;CACjB;CACA","file":"GeofencePriority.vue","sourcesContent":["\n.priority-modal-container[data-v-a3ec32a8] {\n  position: fixed;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 12;\n  opacity: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  overflow: auto;\n}\n.priority-modal-container.show[data-v-a3ec32a8] {\n    top: 0;\n    opacity: 1;\n}\n.geofence-priority-container[data-v-a3ec32a8] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.geofence-priority[data-v-a3ec32a8] {\n  display: table-cell;\n  vertical-align: middle;\n  padding: 30px;\n  position: relative;\n}\n.geofence-priority .title[data-v-a3ec32a8] {\n    padding: 20px 0 30px;\n    text-align: center;\n    font-weight: 700;\n    font-size: 18px;\n    color: #0D79F2;\n}\n.geofences[data-v-a3ec32a8] {\n  padding: 0 30px 30px;\n  position: relative;\n  background-color: #fff;\n  margin: 30px;\n  min-height: 300px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  width: 500px;\n  margin: 0 auto;\n}\n.geofences.loading[data-v-a3ec32a8] {\n    min-height: 100px;\n    width: 300px;\n    margin: 0 auto;\n}\n.geofence[data-v-a3ec32a8] {\n  padding: 10px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  margin: 0 7px 10px;\n  border-radius: 3px;\n  font-size: 14px;\n  cursor: pointer;\n}\n.geofence span[data-v-a3ec32a8] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.geofence .color[data-v-a3ec32a8] {\n    width: 13px;\n    height: 13px;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n    margin-right: 10px;\n}\n.controls[data-v-a3ec32a8] {\n  text-align: center;\n  margin-top: 30px;\n}\n.loader[data-v-a3ec32a8] {\n  text-align: center;\n  padding: 30px 0 0;\n}\n.save-btn[data-v-a3ec32a8] {\n  width: 83px;\n}\n@media only screen and (max-width: 430px) {\n.geofence-priority[data-v-a3ec32a8] {\n    padding: 0;\n}\n.geofence-priority .geofences[data-v-a3ec32a8] {\n      width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'priority-modal-container': true, show: _vm.show }},[_c('div',{staticClass:"geofence-priority-container"},[_c('div',{staticClass:"geofence-priority"},[_c('div',{class:{ geofences: true, loading: _vm.loading }},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"title"},[_vm._v("Drag and drop to the items to sort.")]),_vm._v(" "),_c('div',{staticClass:"row expanded"},[_c('draggable',{model:{value:(_vm.geofences),callback:function ($$v) {_vm.geofences=$$v},expression:"geofences"}},_vm._l((_vm.geofences),function(geofence,index){return _c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"geofence"},[_c('span',{staticClass:"color",style:({ backgroundColor: '#' + (geofence.overlayColor || geofence.color) })}),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(geofence.name))])])])}),0)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"controls"},[_c('a',{staticClass:"button small cta secondary",attrs:{"href":"javascript:;"},on:{"click":_vm.close}},[_vm._v("CANCEL")]),_vm._v(" "),_c('a',{class:{ 'button small cta success save-btn': true, disabled: _vm.saving },attrs:{"href":"javascript:;"},on:{"click":_vm.save}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.saving),expression:"saving"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.saving),expression:"!saving"}]},[_vm._v("SAVE")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-lg"}),_vm._v(" "),_c('div',[_vm._v("LOADING GEOFENCES...")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofencePromoPrices_vue__ = __webpack_require__(568);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce13d128_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofencePromoPrices_vue__ = __webpack_require__(1647);
function injectStyle (ssrContext) {
  __webpack_require__(1645)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ce13d128"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeofencePromoPrices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce13d128_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeofencePromoPrices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1646);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("e75f15fe", content, true, {});

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.promo-pricing-modal-container[data-v-ce13d128] {\n  position: fixed;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 13;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.promo-pricing-modal-container.show[data-v-ce13d128] {\n    top: 0;\n    opacity: 1;\n}\n.promo-pricing-modal-container .promo-pricing-modal[data-v-ce13d128] {\n    display: table;\n    width: 100%;\n    height: 100%;\n}\n.promo-pricing-modal-container .promo-pricing-modal-content[data-v-ce13d128] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.promo-pricing-modal-container .promo-pricing-form[data-v-ce13d128] {\n    background-color: #fff;\n    border-radius: 3px;\n    width: 400px;\n    margin: 0 auto;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    padding: 15px;\n}\n.promo-pricing-modal-container .promo-pricing-form .title[data-v-ce13d128] {\n      text-align: center;\n      color: #0D79F2;\n      font-size: 14px;\n      font-weight: 700;\n      margin-bottom: 15px;\n}\n.promo-pricing-modal-container .promo-pricing-form .select-input[data-v-ce13d128] {\n      margin-bottom: 10px;\n}\n.promo-pricing-modal-container .promo-pricing-form .select-input label[data-v-ce13d128] {\n        color: #0D79F2;\n        font-size: 10px;\n        font-weight: 700;\n}\n.promo-pricing-modal-container .promo-pricing-form .select-input select[data-v-ce13d128] {\n        font-size: 14px;\n        outline: 0;\n        padding: 10px;\n        border-color: rgba(0, 0, 0, 0.15);\n        background-color: #fff;\n        border-radius: 3px;\n        height: 43px;\n}\n.promo-pricing-modal-container .promo-pricing-form .text-input[data-v-ce13d128] {\n      margin-bottom: 10px;\n}\n.promo-pricing-modal-container .promo-pricing-form .text-input label[data-v-ce13d128] {\n        color: #0D79F2;\n        font-size: 10px;\n        font-weight: 700;\n}\n.promo-pricing-modal-container .promo-pricing-form .text-input input[data-v-ce13d128] {\n        margin-top: 0;\n        font-size: 14px;\n}\n.promo-pricing-modal-container .promo-pricing-form .promo-error[data-v-ce13d128] {\n      font-size: 12px;\n      font-weight: 700;\n      text-align: center;\n      padding: 10px;\n      border: 1px solid #F20D0D;\n      border-radius: 3px;\n      color: #F20D0D;\n}\n.promo-pricing-modal-container .promo-pricing-form .controls[data-v-ce13d128] {\n      text-align: center;\n      margin-top: 15px;\n}\n.promo-pricing-modal-container .promo-pricing-form .controls .button[data-v-ce13d128] {\n        width: 70px;\n        height: 33px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Geofences/GeofencePromoPrices.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;IACI,eAAe;IACf,YAAY;IACZ,aAAa;CAChB;AACD;IACI,oBAAoB;IACpB,uBAAuB;CAC1B;AACD;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,iDAAiD;YACzC,yCAAyC;IACjD,cAAc;CACjB;AACD;MACM,mBAAmB;MACnB,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;QACQ,eAAe;QACf,gBAAgB;QAChB,iBAAiB;CACxB;AACD;QACQ,gBAAgB;QAChB,WAAW;QACX,cAAc;QACd,kCAAkC;QAClC,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;CACpB;AACD;MACM,oBAAoB;CACzB;AACD;QACQ,eAAe;QACf,gBAAgB;QAChB,iBAAiB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;CACvB;AACD;MACM,gBAAgB;MAChB,iBAAiB;MACjB,mBAAmB;MACnB,cAAc;MACd,0BAA0B;MAC1B,mBAAmB;MACnB,eAAe;CACpB;AACD;MACM,mBAAmB;MACnB,iBAAiB;CACtB;AACD;QACQ,YAAY;QACZ,aAAa;CACpB","file":"GeofencePromoPrices.vue","sourcesContent":["\n.promo-pricing-modal-container[data-v-ce13d128] {\n  position: fixed;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 13;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.promo-pricing-modal-container.show[data-v-ce13d128] {\n    top: 0;\n    opacity: 1;\n}\n.promo-pricing-modal-container .promo-pricing-modal[data-v-ce13d128] {\n    display: table;\n    width: 100%;\n    height: 100%;\n}\n.promo-pricing-modal-container .promo-pricing-modal-content[data-v-ce13d128] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.promo-pricing-modal-container .promo-pricing-form[data-v-ce13d128] {\n    background-color: #fff;\n    border-radius: 3px;\n    width: 400px;\n    margin: 0 auto;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    padding: 15px;\n}\n.promo-pricing-modal-container .promo-pricing-form .title[data-v-ce13d128] {\n      text-align: center;\n      color: #0D79F2;\n      font-size: 14px;\n      font-weight: 700;\n      margin-bottom: 15px;\n}\n.promo-pricing-modal-container .promo-pricing-form .select-input[data-v-ce13d128] {\n      margin-bottom: 10px;\n}\n.promo-pricing-modal-container .promo-pricing-form .select-input label[data-v-ce13d128] {\n        color: #0D79F2;\n        font-size: 10px;\n        font-weight: 700;\n}\n.promo-pricing-modal-container .promo-pricing-form .select-input select[data-v-ce13d128] {\n        font-size: 14px;\n        outline: 0;\n        padding: 10px;\n        border-color: rgba(0, 0, 0, 0.15);\n        background-color: #fff;\n        border-radius: 3px;\n        height: 43px;\n}\n.promo-pricing-modal-container .promo-pricing-form .text-input[data-v-ce13d128] {\n      margin-bottom: 10px;\n}\n.promo-pricing-modal-container .promo-pricing-form .text-input label[data-v-ce13d128] {\n        color: #0D79F2;\n        font-size: 10px;\n        font-weight: 700;\n}\n.promo-pricing-modal-container .promo-pricing-form .text-input input[data-v-ce13d128] {\n        margin-top: 0;\n        font-size: 14px;\n}\n.promo-pricing-modal-container .promo-pricing-form .promo-error[data-v-ce13d128] {\n      font-size: 12px;\n      font-weight: 700;\n      text-align: center;\n      padding: 10px;\n      border: 1px solid #F20D0D;\n      border-radius: 3px;\n      color: #F20D0D;\n}\n.promo-pricing-modal-container .promo-pricing-form .controls[data-v-ce13d128] {\n      text-align: center;\n      margin-top: 15px;\n}\n.promo-pricing-modal-container .promo-pricing-form .controls .button[data-v-ce13d128] {\n        width: 70px;\n        height: 33px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'promo-pricing-modal-container': true, show: _vm.show }},[_c('div',{staticClass:"promo-pricing-modal"},[_c('div',{staticClass:"promo-pricing-modal-content"},[_c('div',{staticClass:"promo-pricing-form"},[_c('div',{staticClass:"title"},[_vm._v("NEW PROMOTIONAL PRICING")]),_vm._v(" "),_c('div',{staticClass:"select-input"},[_c('label',[_vm._v("SERVICE TYPE")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.promoForm.serviceType),expression:"promoForm.serviceType"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.promoForm, "serviceType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Choose One")]),_vm._v(" "),_c('option',{attrs:{"value":"shared"}},[_vm._v(_vm._s(_vm.serviceLabel('shared')))]),_vm._v(" "),_c('option',{attrs:{"value":"opoli"}},[_vm._v(_vm._s(_vm.serviceLabel('opoli')))]),_vm._v(" "),_c('option',{attrs:{"value":"black"}},[_vm._v(_vm._s(_vm.serviceLabel('black')))]),_vm._v(" "),_c('option',{attrs:{"value":"suv"}},[_vm._v(_vm._s(_vm.serviceLabel('suv')))]),_vm._v(" "),_c('option',{attrs:{"value":"shuttle"}},[_vm._v(_vm._s(_vm.serviceLabel('shuttle')))])])]),_vm._v(" "),_c('div',{staticClass:"select-input"},[_c('label',[_vm._v("PROMOTION TYPE")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.promoForm.promoType),expression:"promoForm.promoType"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.promoForm, "promoType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Choose One")]),_vm._v(" "),_c('option',{attrs:{"value":"flat"}},[_vm._v("Flat Rate")]),_vm._v(" "),_c('option',{attrs:{"value":"discount"}},[_vm._v("Discount Mileage Rate")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.promoForm.promoType === 'flat'),expression:"promoForm.promoType === 'flat'"}],staticClass:"text-input"},[_c('label',[_vm._v("FLAT RATE")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar},model:{value:(_vm.promoForm.flatRate),callback:function ($$v) {_vm.$set(_vm.promoForm, "flatRate", $$v)},expression:"promoForm.flatRate"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.promoForm.promoType === 'discount'),expression:"promoForm.promoType === 'discount'"}],staticClass:"text-input"},[_c('label',[_vm._v("BASE RATE")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar},model:{value:(_vm.promoForm.baseRate),callback:function ($$v) {_vm.$set(_vm.promoForm, "baseRate", $$v)},expression:"promoForm.baseRate"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.promoForm.promoType === 'discount'),expression:"promoForm.promoType === 'discount'"}],staticClass:"text-input"},[_c('label',[_vm._v("MILEAGE RATE")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar},model:{value:(_vm.promoForm.mileageRate),callback:function ($$v) {_vm.$set(_vm.promoForm, "mileageRate", $$v)},expression:"promoForm.mileageRate"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.promoForm.promoType !== ''),expression:"promoForm.promoType !== ''"}],staticClass:"text-input"},[_c('label',[_vm._v("2ND PAX FEE")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar},model:{value:(_vm.promoForm.secondPaxFee),callback:function ($$v) {_vm.$set(_vm.promoForm, "secondPaxFee", $$v)},expression:"promoForm.secondPaxFee"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.promoForm.promoType !== ''),expression:"promoForm.promoType !== ''"}],staticClass:"text-input"},[_c('label',[_vm._v("ADDITIONAL PAX FEE")]),_vm._v(" "),_c('vue-autonumeric',{attrs:{"options":_vm.dollar},model:{value:(_vm.promoForm.addPaxFee),callback:function ($$v) {_vm.$set(_vm.promoForm, "addPaxFee", $$v)},expression:"promoForm.addPaxFee"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.promoForm.error.show),expression:"promoForm.error.show"}],staticClass:"promo-error"},[_vm._v(_vm._s(_vm.promoForm.error.message))]),_vm._v(" "),_c('div',{staticClass:"controls"},[_c('a',{class:{ 'button xsmall cta secondary': true, disabled: _vm.promoForm.saving },attrs:{"href":"javascript:;"},on:{"click":_vm.hideForm}},[_vm._v("CANCEL")]),_vm._v(" "),_c('a',{class:{ 'button xsmall cta success': true, disabled: _vm.promoForm.saving },attrs:{"href":"javascript:;"},on:{"click":_vm.addPromo}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.promoForm.saving),expression:"promoForm.saving"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.promoForm.saving),expression:"!promoForm.saving"}]},[_vm._v("SAVE")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(569);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27c43bd9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(1651);
function injectStyle (ssrContext) {
  __webpack_require__(1649)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27c43bd9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27c43bd9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1650);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("b79560f8", content, true, {});

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.modal[data-v-27c43bd9] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  overflow: auto;\n}\n.modal.show[data-v-27c43bd9] {\n    top: 0;\n    opacity: 1;\n}\n.modal-container[data-v-27c43bd9] {\n  display: table;\n  width: 100%;\n  height: 100%;\n  padding: 35px;\n}\n.modal-content[data-v-27c43bd9] {\n  vertical-align: middle;\n  position: relative;\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 960px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  overflow: hidden;\n  padding: 25px;\n}\n.modal-content p[data-v-27c43bd9] {\n    margin: 0;\n    font-size: 14px;\n    color: #444;\n}\n.modal-content b[data-v-27c43bd9] {\n    font-size: 15px;\n}\n.modal-content .button[data-v-27c43bd9] {\n    margin-top: 25px;\n}\n.modal-content ul[data-v-27c43bd9] {\n    list-style: none;\n    padding-left: 0;\n    -webkit-column-count: 4;\n    /* Chrome, Safari, Opera */\n    -moz-column-count: 4;\n    /* Firefox */\n    column-count: 4;\n}\n.modal-content ul li[data-v-27c43bd9] {\n      font-size: 14px;\n      margin-bottom: 8px;\n      line-height: 135%;\n}\n.modal-content ul li label[data-v-27c43bd9] {\n        cursor: pointer;\n}\n.modal-content ul li input[data-v-27c43bd9] {\n        width: inherit;\n        display: inline-block;\n        margin: 0 5px 0 0;\n}\n.modal-content .loader[data-v-27c43bd9] {\n    text-align: center;\n    padding: 30px 0 0;\n}\n.modal-content .buttons-section[data-v-27c43bd9] {\n    text-align: center;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Geofences/Modal.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;CAChB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,cAAc;CACf;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,iBAAiB;EACjB,cAAc;CACf;AACD;IACI,UAAU;IACV,gBAAgB;IAChB,YAAY;CACf;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,2BAA2B;IAC3B,qBAAqB;IACrB,aAAa;IACb,gBAAgB;CACnB;AACD;MACM,gBAAgB;MAChB,mBAAmB;MACnB,kBAAkB;CACvB;AACD;QACQ,gBAAgB;CACvB;AACD;QACQ,eAAe;QACf,sBAAsB;QACtB,kBAAkB;CACzB;AACD;IACI,mBAAmB;IACnB,kBAAkB;CACrB;AACD;IACI,mBAAmB;CACtB","file":"Modal.vue","sourcesContent":["\n.modal[data-v-27c43bd9] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  overflow: auto;\n}\n.modal.show[data-v-27c43bd9] {\n    top: 0;\n    opacity: 1;\n}\n.modal-container[data-v-27c43bd9] {\n  display: table;\n  width: 100%;\n  height: 100%;\n  padding: 35px;\n}\n.modal-content[data-v-27c43bd9] {\n  vertical-align: middle;\n  position: relative;\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 960px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  overflow: hidden;\n  padding: 25px;\n}\n.modal-content p[data-v-27c43bd9] {\n    margin: 0;\n    font-size: 14px;\n    color: #444;\n}\n.modal-content b[data-v-27c43bd9] {\n    font-size: 15px;\n}\n.modal-content .button[data-v-27c43bd9] {\n    margin-top: 25px;\n}\n.modal-content ul[data-v-27c43bd9] {\n    list-style: none;\n    padding-left: 0;\n    -webkit-column-count: 4;\n    /* Chrome, Safari, Opera */\n    -moz-column-count: 4;\n    /* Firefox */\n    column-count: 4;\n}\n.modal-content ul li[data-v-27c43bd9] {\n      font-size: 14px;\n      margin-bottom: 8px;\n      line-height: 135%;\n}\n.modal-content ul li label[data-v-27c43bd9] {\n        cursor: pointer;\n}\n.modal-content ul li input[data-v-27c43bd9] {\n        width: inherit;\n        display: inline-block;\n        margin: 0 5px 0 0;\n}\n.modal-content .loader[data-v-27c43bd9] {\n    text-align: center;\n    padding: 30px 0 0;\n}\n.modal-content .buttons-section[data-v-27c43bd9] {\n    text-align: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{ 'modal':true, 'show':_vm.show }},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-lg"}),_vm._v(" "),_c('h3',[_vm._v("LOADING GEOFENCES SERVICE AREA...")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}]},[_c('h3',[_vm._v("Select service area you want to apply with the same promo period.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Start Date: ")]),_vm._v(" "+_vm._s(_vm.startDate.split(' ')[0]))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("End Date: ")]),_vm._v(" "+_vm._s(_vm.endDate.split(' ')[0]))]),_vm._v(" "),_c('ul',_vm._l((_vm.geofences),function(geofence,index){return _c('li',{key:index},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.services),expression:"services"}],attrs:{"type":"checkbox"},domProps:{"value":geofence.id,"checked":Array.isArray(_vm.services)?_vm._i(_vm.services,geofence.id)>-1:(_vm.services)},on:{"change":function($event){var $$a=_vm.services,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=geofence.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.services=$$a.concat([$$v]))}else{$$i>-1&&(_vm.services=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.services=$$c}}}}),_vm._v("\n                "+_vm._s(geofence.name)+"\n              ")])])}),0),_vm._v(" "),_c('section',{staticClass:"buttons-section"},[_c('div',{staticClass:"button cta large cta secondary",on:{"click":_vm.closeModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('div',{staticClass:"button cta large",on:{"click":_vm.savePromo}},[_vm._v("Save")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geofences"},[_c('div',{staticClass:"header"},[_vm._v("GEOFENCES")]),_vm._v(" "),_c('div',{staticClass:"geofence-container"},[_c('div',{staticClass:"geofence list"},[_c('geofence-list')],1),_vm._v(" "),_c('div',{staticClass:"toggle-mobile",on:{"click":function($event){_vm.showMapMobile = !_vm.showMapMobile}}},[(!_vm.showMapMobile)?_c('span',[_vm._v("Show Map "),_c('i',{staticClass:"fa fa-chevron-up"})]):_c('span',[_vm._v("Hide Map "),_c('i',{staticClass:"fa fa-chevron-down"})])]),_vm._v(" "),_c('div',{class:['geofence map', _vm.showMapMobile ? 'showMapBox' : '']},[_c('geofence-map2')],1)]),_vm._v(" "),_c('geofence-create'),_vm._v(" "),_c('geofence-priority'),_vm._v(" "),_c('geofence-promo-prices'),_vm._v(" "),_c('modal')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InstructionPreview_vue__ = __webpack_require__(570);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35ac4bdd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InstructionPreview_vue__ = __webpack_require__(1656);
function injectStyle (ssrContext) {
  __webpack_require__(1654)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InstructionPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35ac4bdd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InstructionPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1655);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("61201476", content, true, {});

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Questrial);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Work+Sans);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Montserrat%3A400%2C500%2C600%2C700%2C800%2C900&#038;display=swap&#038;ver=4.6.1);", ""]);

// module
exports.push([module.i, "\n#side-menu {\n  display: none;\n}\n.row {\n  max-width: 62.5rem;\n}\n.geofence-instruction-preview {\n  padding: 20px;\n}\n.geofence-instruction-preview .heading {\n    font-size: 21px;\n    color: #0D79F2;\n    margin-bottom: 5px;\n    font-weight: 600;\n}\n.card {\n  background-color: #fff;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  padding: 20px;\n  color: #2c3e50;\n  margin-bottom: 30px;\n  display: inline-block;\n  font-family: 'Montserrat', sans-serif;\n}\n.card .column.medium-8 {\n    padding-right: 10px;\n}\n.card h3 {\n    font-size: 1.5em;\n    margin: 0 0 5px;\n    font-weight: 500;\n}\n.card .steps {\n    font-size: 15px;\n    margin-bottom: 5px;\n}\n.card .steps .step {\n      margin-bottom: 3px;\n}\n.card .steps strong {\n      margin-right: 3px;\n}\n.card .thumbnail {\n    cursor: pointer;\n}\n.card .large-view {\n    font-size: 13px;\n    display: block;\n    text-align: center;\n}\n.ca-app {\n  width: 100%;\n  max-width: 450px;\n  background: #f9f9f9;\n  font-family: 'Work Sans', san-serif;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n.ca-app .heading {\n    height: 56px;\n    line-height: 56px;\n    overflow: hidden;\n    background: #009688;\n    color: #fff;\n    font-weight: 500;\n}\n.ca-app .heading .left {\n      text-align: center;\n      display: inline-block;\n      width: 75px;\n}\n.ca-app .heading .right {\n      display: inline-block;\n      font-size: 20px;\n      vertical-align: top;\n      color: #ffffff;\n      width: auto;\n      -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n      flex-grow: 1;\n      overflow: hidden;\n      text-overflow: ellipsis;\n}\n.ca-app .body {\n    padding: 15px;\n}\n.ca-app .body .steps {\n      line-height: 1.3;\n      margin-bottom: 10px;\n      color: #555;\n}\n.ca-app .body .steps b {\n        color: #1f1f21;\n}\n.ca-app .body .image {\n      margin-top: 10px;\n      width: 100%;\n}\n.ca-app .body .next-button {\n      color: #fff;\n      display: block;\n      text-align: center;\n      font-weight: 700;\n      text-decoration: none;\n      padding: 10px;\n      margin: 15px;\n      border-radius: 3px;\n      background: #009688;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Geofences/InstructionPreview.vue"],"names":[],"mappings":";AAIA;EACE,cAAc;CACf;AACD;EACE,mBAAmB;CACpB;AACD;EACE,cAAc;CACf;AACD;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;CACpB;AACD;EACE,uBAAuB;EACvB,kDAAkD;UAC1C,0CAA0C;EAClD,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,sCAAsC;CACvC;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;CACpB;AACD;IACI,gBAAgB;IAChB,mBAAmB;CACtB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,kBAAkB;CACvB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;CACtB;AACD;EACE,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,oCAAoC;EACpC,kDAAkD;UAC1C,0CAA0C;CACnD;AACD;IACI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,iBAAiB;CACpB;AACD;MACM,mBAAmB;MACnB,sBAAsB;MACtB,YAAY;CACjB;AACD;MACM,sBAAsB;MACtB,gBAAgB;MAChB,oBAAoB;MACpB,eAAe;MACf,YAAY;MACZ,oBAAoB;MACpB,qBAAqB;MACrB,aAAa;MACb,iBAAiB;MACjB,wBAAwB;CAC7B;AACD;IACI,cAAc;CACjB;AACD;MACM,iBAAiB;MACjB,oBAAoB;MACpB,YAAY;CACjB;AACD;QACQ,eAAe;CACtB;AACD;MACM,iBAAiB;MACjB,YAAY;CACjB;AACD;MACM,YAAY;MACZ,eAAe;MACf,mBAAmB;MACnB,iBAAiB;MACjB,sBAAsB;MACtB,cAAc;MACd,aAAa;MACb,mBAAmB;MACnB,oBAAoB;CACzB","file":"InstructionPreview.vue","sourcesContent":["\n@import url(\"https://fonts.googleapis.com/css?family=Questrial\");\n@import url(\"https://fonts.googleapis.com/css?family=Work+Sans\");\n@import url(\"https://fonts.googleapis.com/css?family=Montserrat%3A400%2C500%2C600%2C700%2C800%2C900&#038;display=swap&#038;ver=4.6.1\");\n#side-menu {\n  display: none;\n}\n.row {\n  max-width: 62.5rem;\n}\n.geofence-instruction-preview {\n  padding: 20px;\n}\n.geofence-instruction-preview .heading {\n    font-size: 21px;\n    color: #0D79F2;\n    margin-bottom: 5px;\n    font-weight: 600;\n}\n.card {\n  background-color: #fff;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  padding: 20px;\n  color: #2c3e50;\n  margin-bottom: 30px;\n  display: inline-block;\n  font-family: 'Montserrat', sans-serif;\n}\n.card .column.medium-8 {\n    padding-right: 10px;\n}\n.card h3 {\n    font-size: 1.5em;\n    margin: 0 0 5px;\n    font-weight: 500;\n}\n.card .steps {\n    font-size: 15px;\n    margin-bottom: 5px;\n}\n.card .steps .step {\n      margin-bottom: 3px;\n}\n.card .steps strong {\n      margin-right: 3px;\n}\n.card .thumbnail {\n    cursor: pointer;\n}\n.card .large-view {\n    font-size: 13px;\n    display: block;\n    text-align: center;\n}\n.ca-app {\n  width: 100%;\n  max-width: 450px;\n  background: #f9f9f9;\n  font-family: 'Work Sans', san-serif;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n.ca-app .heading {\n    height: 56px;\n    line-height: 56px;\n    overflow: hidden;\n    background: #009688;\n    color: #fff;\n    font-weight: 500;\n}\n.ca-app .heading .left {\n      text-align: center;\n      display: inline-block;\n      width: 75px;\n}\n.ca-app .heading .right {\n      display: inline-block;\n      font-size: 20px;\n      vertical-align: top;\n      color: #ffffff;\n      width: auto;\n      -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n      flex-grow: 1;\n      overflow: hidden;\n      text-overflow: ellipsis;\n}\n.ca-app .body {\n    padding: 15px;\n}\n.ca-app .body .steps {\n      line-height: 1.3;\n      margin-bottom: 10px;\n      color: #555;\n}\n.ca-app .body .steps b {\n        color: #1f1f21;\n}\n.ca-app .body .image {\n      margin-top: 10px;\n      width: 100%;\n}\n.ca-app .body .next-button {\n      color: #fff;\n      display: block;\n      text-align: center;\n      font-weight: 700;\n      text-decoration: none;\n      padding: 10px;\n      margin: 15px;\n      border-radius: 3px;\n      background: #009688;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geofence-instruction-preview"},[_c('div',{staticClass:"heading"},[_vm._v("Widget")]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"row"},[_c('h3',[_vm._v(_vm._s(_vm.preview.title))]),_vm._v(" "),_c('div',{staticClass:"column end medium-8"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.preview.tnc.text)}})]),_vm._v(" "),_c('div',{staticClass:"column end medium-4"},[_c('img',{staticClass:"thumbnail",attrs:{"src":_vm.preview.tnc.img}}),_vm._v(" "),_c('span',{staticClass:"large-view"},[_vm._v("Click image for larger view")])])])]),_vm._v(" "),_c('div',{staticClass:"heading"},[_vm._v("Consumer App")]),_vm._v(" "),_c('div',{staticClass:"ca-app"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.preview.tnc.text)}}),_vm._v(" "),_c('img',{staticClass:"thumbnail",attrs:{"src":_vm.preview.tnc.img}}),_vm._v(" "),_c('a',{staticClass:"next-button"},[_vm._v("OK, I understand.")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading"},[_c('div',{staticClass:"left"},[_c('i',{staticClass:"fas fa-arrow-left"})]),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._v("Pickup at LAX")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(571);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4a203ee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1722);
function injectStyle (ssrContext) {
  __webpack_require__(1658)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d4a203ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4a203ee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1659);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("01586e1c", content, true, {});

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.clear[data-v-d4a203ee] {\n  clear: both;\n}\n.heading[data-v-d4a203ee] {\n  height: 50px;\n  font-size: 20px;\n  font-weight: 600;\n  color: #333;\n  padding: 10px 0;\n}\n.heading > span[data-v-d4a203ee] {\n    padding: 0 5px 0 15px;\n}\n.heading select[data-v-d4a203ee] {\n    width: auto;\n    float: right;\n    font-size: 16px;\n    margin-top: 5px;\n    margin-right: 40px;\n}\n.switch[data-v-d4a203ee] {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n}\n.switch .slider[data-v-d4a203ee] {\n    position: relative;\n    display: inline-block;\n    width: 50px;\n    height: 30px;\n    border-radius: 20px;\n    background: #ccc;\n    position: relative;\n    cursor: pointer;\n    -webkit-transition: all .25s ease-in-out;\n    transition: all .25s ease-in-out;\n}\n.switch .slider.disabled[data-v-d4a203ee] {\n      opacity: .4;\n}\n.switch .slider[data-v-d4a203ee]:before {\n      content: '';\n      position: absolute;\n      top: 4px;\n      left: 4px;\n      width: 22px;\n      height: 22px;\n      border-radius: 50%;\n      background: #fff;\n      -webkit-transition: all .25s ease-in-out;\n      transition: all .25s ease-in-out;\n      -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n}\n.switch .slider.active[data-v-d4a203ee] {\n      background: #57d1b7;\n}\n.switch .slider.active[data-v-d4a203ee]:before {\n        left: 24px;\n}\n.switch .label[data-v-d4a203ee] {\n    display: inline-block;\n    vertical-align: 10px;\n    margin-left: 5px;\n    font-size: 14px;\n    color: #555;\n    text-transform: uppercase;\n}\n.prov-options[data-v-d4a203ee] {\n  float: right;\n  width: 30px;\n  height: 40px;\n  text-align: center;\n  margin-right: 10px;\n  cursor: pointer;\n  color: #777;\n  -webkit-transition: all .4s ease;\n  transition: all .4s ease;\n  position: relative;\n  z-index: 5;\n}\n.prov-options .fa-ellipsis-v[data-v-d4a203ee] {\n    padding: 5px 10px;\n}\n.prov-options[data-v-d4a203ee]:hover {\n    color: #333;\n}\n.prov-options .options[data-v-d4a203ee] {\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n    position: absolute;\n    top: 100%;\n    right: 0;\n    width: 240px;\n    background: #fff;\n    padding: 10px;\n    border-radius: 4px;\n    -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);\n            box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);\n}\n.call[data-v-d4a203ee], .send-notif[data-v-d4a203ee], .print-placard[data-v-d4a203ee], .send-sms[data-v-d4a203ee], .download-profile[data-v-d4a203ee] {\n  /*float: right;*/\n  margin-bottom: 5px;\n  text-transform: uppercase;\n}\n.call i[data-v-d4a203ee], .send-notif i[data-v-d4a203ee], .print-placard i[data-v-d4a203ee], .send-sms i[data-v-d4a203ee], .download-profile i[data-v-d4a203ee] {\n    margin-right: 5px;\n}\n.send-sms[data-v-d4a203ee] {\n  background-color: #16b0de;\n}\n.download-profile[data-v-d4a203ee] {\n  background-color: #ec4545;\n}\n.left-panel[data-v-d4a203ee] {\n  position: fixed;\n  z-index: 2;\n  left: 0;\n  top: 0;\n  width: 40%;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #F4F8F9;\n  overflow-y: auto;\n  padding-bottom: 60px;\n}\n.left-panel .heading[data-v-d4a203ee] {\n    padding-left: 50px;\n}\n.toggle-mobile[data-v-d4a203ee] {\n  display: none;\n}\n.tab[data-v-d4a203ee] {\n  list-style: none;\n  padding: 0;\n  margin: 15px 0 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  z-index: 2;\n}\n.tab li[data-v-d4a203ee] {\n    color: #0D79F2;\n    padding: 15px 25px;\n    font-size: 14px;\n    font-weight: 600;\n    text-align: center;\n    display: inline-block;\n    text-transform: uppercase;\n    cursor: pointer;\n}\n.tab li.grow[data-v-d4a203ee] {\n      -webkit-box-flex: 100;\n          -ms-flex-positive: 100;\n              flex-grow: 100;\n}\n.tab li.active[data-v-d4a203ee] {\n      background: #fff;\n      -webkit-box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);\n              box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);\n      border-radius: 2px 2px 0 0;\n      color: #777;\n}\n.left-panel .tab li[data-v-d4a203ee] {\n  width: 25%;\n}\n.tab-contents[data-v-d4a203ee] {\n  background: #fff;\n  z-index: 2;\n  position: relative;\n  -webkit-box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);\n}\n.tab-contents .tab-content[data-v-d4a203ee] {\n    padding: 20px;\n    display: none;\n}\n.tab-contents .tab-content.no-H-padding[data-v-d4a203ee] {\n      padding: 20px 0;\n}\n.tab-contents .tab-content.active[data-v-d4a203ee] {\n      display: block;\n}\n.tab-contents .fixed-footer[data-v-d4a203ee] {\n    position: fixed;\n    bottom: 0;\n    right: 0;\n    width: 60%;\n    padding: 15px;\n    background: #313131;\n    color: #eee;\n    font-size: 18px;\n    line-height: 1;\n    text-align: center;\n}\n.tab-contents .fixed-footer span[data-v-d4a203ee] {\n      color: #36a2ff;\n      cursor: pointer;\n}\n.tab-contents .fixed-footer b[data-v-d4a203ee] {\n      font-size: 21px;\n      margin-left: 5px;\n}\n.tab-contents .fixed-footer i[data-v-d4a203ee] {\n      margin-left: 3px;\n}\n.right-panel[data-v-d4a203ee] {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  top: 0;\n  width: 60%;\n  height: 100%;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #d5d5d5;\n  overflow-y: auto;\n}\n.right-panel .heading[data-v-d4a203ee] {\n    font-size: 24px;\n    padding: 10px 20px;\n}\n.right-panel .tab[data-v-d4a203ee] {\n    background: #d5d5d5;\n}\n.right-panel .tab .active[data-v-d4a203ee] {\n      background: #ededed;\n}\n.right-panel .tab-contents[data-v-d4a203ee] {\n    background: #ededed;\n}\n.fix-buttons[data-v-d4a203ee] {\n  position: fixed;\n  z-index: 3;\n  bottom: 0;\n  left: 0;\n  padding: 10px;\n  width: 40%;\n  height: 60px;\n  background: #eee;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.fix-buttons a[data-v-d4a203ee] {\n    width: 50%;\n    display: inline-block;\n    margin: 0 auto;\n}\n.fix-buttons a.right[data-v-d4a203ee] {\n      margin-left: auto;\n}\n.modal[data-v-d4a203ee] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.modal .bg-overlay[data-v-d4a203ee] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n.modal .modal-content[data-v-d4a203ee] {\n    position: absolute;\n    top: 45%;\n    left: 50%;\n    width: 400px;\n    padding: 25px;\n    background: #fff;\n    text-align: center;\n    border-radius: 6px;\n    margin-left: -200px;\n    -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal .modal-content.upload[data-v-d4a203ee] {\n      top: 50%;\n      width: 900px;\n      height: 550px;\n      margin-top: -265px;\n      margin-left: -450px;\n}\n.modal.no-preview .upload[data-v-d4a203ee] {\n    height: 150px;\n    margin-top: -75px;\n}\n.modal.show[data-v-d4a203ee] {\n    display: block;\n}\n.modal.show .modal-content[data-v-d4a203ee] {\n      display: block;\n      -webkit-animation: slide-down-data-v-d4a203ee .3s ease-out;\n      -moz-animation: slide-down-data-v-d4a203ee .3s ease-out;\n}\n.service-save i[data-v-d4a203ee] {\n  display: block;\n  margin-bottom: 5px;\n}\n.service-save .fa-check-circle[data-v-d4a203ee] {\n  color: #1bd35d;\n}\n.service-save .fa-times-circle[data-v-d4a203ee] {\n  color: #ea4949;\n}\n.service-save span[data-v-d4a203ee] {\n  margin-bottom: 10px;\n  display: block;\n}\n.service-save p[data-v-d4a203ee] {\n  padding: 3px;\n  margin: 0 0 15px;\n  background: #ea4949;\n  color: #fff;\n  font-size: 14px;\n  border-radius: 4px;\n}\n.service-save .button[data-v-d4a203ee] {\n  margin-top: 10px;\n}\n.breakdown[data-v-d4a203ee] {\n  overflow: auto;\n}\n.breakdown .modal-content[data-v-d4a203ee] {\n    max-width: 800px;\n    width: 100%;\n    position: relative;\n    top: 20px;\n    left: 0;\n    margin: 0 auto;\n}\n.breakdown .has-error i[data-v-d4a203ee] {\n    color: #fb4040;\n}\n.breakdown .has-error span[data-v-d4a203ee] {\n    display: block;\n    font-size: 21px;\n    margin: 10px 0 15px;\n}\n.breakdown .has-error p[data-v-d4a203ee] {\n    line-height: 135%;\n    padding: 0;\n    margin: 0 0 20px;\n    color: #777;\n}\n.breakdown .label[data-v-d4a203ee] {\n    font-size: 21px;\n    margin-bottom: 20px;\n    font-weight: 600;\n    color: #0D79F2;\n}\n.breakdown .list[data-v-d4a203ee] {\n    width: 100%;\n}\n.breakdown .list thead[data-v-d4a203ee] {\n      font-weight: 600;\n      color: #999;\n      font-size: 14px;\n}\n.breakdown .list thead td[data-v-d4a203ee] {\n        border-bottom: 1px solid #ccc;\n        padding: 3px 2px;\n}\n.breakdown .list tbody[data-v-d4a203ee] {\n      font-size: 14px;\n}\n.breakdown .list tbody tr[data-v-d4a203ee] {\n        -webkit-transition: all .1s linear;\n        transition: all .1s linear;\n}\n.breakdown .list tbody tr[data-v-d4a203ee]:hover {\n        background: #e2f3ff;\n}\n.breakdown .list tbody a[data-v-d4a203ee] {\n        font-size: 13px;\n}\n.breakdown .list tbody a.pkg[data-v-d4a203ee] {\n        color: #14ab3b;\n}\n.breakdown .list tbody td[data-v-d4a203ee] {\n        padding: 3px 0;\n        text-align: center;\n}\n.breakdown .list tbody .total td[data-v-d4a203ee] {\n        border-top: 1px solid #ccc;\n        font-weight: 600;\n}\n.breakdown .computations[data-v-d4a203ee] {\n    float: right;\n    margin: 20px 0;\n    border: 1px solid #eee;\n    background: #fafafa;\n    padding: 10px;\n    -webkit-box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);\n            box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);\n}\n.breakdown .computations td[data-v-d4a203ee] {\n      padding: 2px 20px;\n}\n.breakdown .computations td[data-v-d4a203ee]:first-child {\n      text-align: right;\n}\n.breakdown .computations td[data-v-d4a203ee]:last-child {\n      text-align: right;\n      padding-left: 20px;\n}\n.breakdown .computations .total td[data-v-d4a203ee] {\n      border-top: 1px solid #aaa;\n      font-size: 21px;\n      font-weight: 600;\n      color: #e44e4e;\n}\n@-webkit-keyframes slide-down-data-v-d4a203ee {\n0% {\n    opacity: 0;\n    -webkit-transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n}\n}\n.active-confirmation p[data-v-d4a203ee] {\n  margin-top: 0;\n  font-size: 18px;\n}\n.active-confirmation .button[data-v-d4a203ee] {\n  width: 40%;\n  margin: 0 5px;\n}\n.formResult p[data-v-d4a203ee] {\n  margin: 0 0 40px;\n  font-size: 18px;\n  color: #333;\n}\n.upload .input-file[data-v-d4a203ee] {\n  margin: 0 0 15px;\n  font-size: 14px;\n  padding: 5px;\n  background: #fafafa;\n  -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1) inset;\n          box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1) inset;\n}\n.upload .cropper-wrap[data-v-d4a203ee] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  margin-bottom: 15px;\n  padding-top: 20px;\n}\n.upload .upload-side[data-v-d4a203ee], .upload .preview-side[data-v-d4a203ee] {\n  position: relative;\n  display: inline-block;\n  width: 50%;\n  max-height: 380px;\n  vertical-align: top;\n  background: #555;\n}\n.upload .upload-side ._label[data-v-d4a203ee], .upload .preview-side ._label[data-v-d4a203ee] {\n    position: absolute;\n    top: -22px;\n    left: 0;\n    font-weight: 600;\n    font-size: 14px;\n    color: #777;\n    width: 100%;\n    text-align: center;\n}\n.upload .preview-side[data-v-d4a203ee] {\n  margin-left: 10px;\n}\n.upload .preview-side img[data-v-d4a203ee] {\n    position: relative;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n    top: 50%;\n    max-width: 420px;\n    max-height: 380px;\n}\n.upload .button.cta[data-v-d4a203ee] {\n  width: 200px;\n  margin: 0 5px;\n}\n.uploadError[data-v-d4a203ee] {\n  text-align: center;\n}\n.uploadError p[data-v-d4a203ee] {\n    margin-top: 0;\n    color: #f20d0d;\n    font-weight: 600;\n}\n.uploadError .fa[data-v-d4a203ee] {\n    display: block;\n    color: #999;\n    margin-bottom: 5px;\n}\n.logs-toggle[data-v-d4a203ee] {\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 3;\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  text-align: center;\n  color: #777;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  border-radius: 0;\n  background-color: #F25E0D;\n  color: #fff;\n  border-bottom-left-radius: 3px;\n  -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n          box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n  -webkit-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: .5s ease;\n  transition: .5s ease;\n}\n.logs-toggle i[data-v-d4a203ee] {\n    line-height: inherit;\n}\n.logs-toggle.on[data-v-d4a203ee] {\n    -webkit-transform: rotate(90deg);\n    transform: rotate(90deg);\n    -webkit-transition: .5s ease;\n    transition: .5s ease;\n}\n.logs-panel[data-v-d4a203ee] {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  top: 0;\n  width: 400px;\n  height: 100%;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #f4f8f9;\n  -webkit-transition: all .6s ease;\n  transition: all .6s ease;\n}\n.logs-panel.hide[data-v-d4a203ee] {\n    right: -400px;\n    -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n            box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n}\n.logs-panel .heading[data-v-d4a203ee] {\n    font-size: 24px;\n    padding: 10px 20px;\n    margin-bottom: 7px;\n}\n.slide-up-enter-active[data-v-d4a203ee], .slide-up-leave-active[data-v-d4a203ee] {\n  -webkit-transition: all .45s ease;\n  transition: all .45s ease;\n}\n.slide-up-enter[data-v-d4a203ee], .slide-up-leave-to[data-v-d4a203ee] {\n  -webkit-transform: translateY(80px);\n          transform: translateY(80px);\n}\n.slide-down-enter-active[data-v-d4a203ee], .slide-down-leave-active[data-v-d4a203ee] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-d4a203ee], .slide-down-leave-to[data-v-d4a203ee] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n}\n@media only screen and (max-width: 430px) {\n.left-panel[data-v-d4a203ee] {\n    width: 100%;\n    padding-bottom: 100px;\n}\n.left-panel .heading[data-v-d4a203ee] {\n      height: auto;\n}\n.left-panel .heading .switch[data-v-d4a203ee] {\n        display: block;\n        padding-top: 5px;\n        padding-left: 10px;\n}\n.left-panel .heading .prov-options[data-v-d4a203ee] {\n        position: absolute;\n        right: 0;\n        top: 15px;\n}\n.left-panel .tab[data-v-d4a203ee] {\n      margin: 20px 0 0;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      overflow-x: scroll;\n}\n.left-panel .tab li[data-v-d4a203ee] {\n        width: auto;\n}\n.toggle-mobile[data-v-d4a203ee] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.right-panel[data-v-d4a203ee] {\n    z-index: 1;\n    width: 100%;\n    top: 100%;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n}\n.right-panel.mobile-right-panel[data-v-d4a203ee] {\n      top: 0;\n      z-index: 2;\n}\n.right-panel.mobile-right-panel .tab[data-v-d4a203ee] {\n        margin-top: 70px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        overflow-x: scroll;\n}\n.right-panel.mobile-right-panel .tab li[data-v-d4a203ee] {\n          white-space: nowrap;\n}\n.right-panel.mobile-right-panel .tab-contents[data-v-d4a203ee] {\n        width: 100%;\n}\n.right-panel.mobile-right-panel .tab-contents .tab-content[data-v-d4a203ee] {\n          padding-bottom: 100px;\n}\n.right-panel.mobile-right-panel .tab-contents .tab-content.history-panel[data-v-d4a203ee] {\n            padding: 0;\n            padding-top: 20px;\n            padding-bottom: 60px;\n}\n.right-panel.mobile-right-panel .tab-contents .fixed-footer[data-v-d4a203ee] {\n          width: 100%;\n          bottom: 45px;\n          background: #fff;\n          color: #000;\n          border-top: 1px solid #aaa;\n}\n.right-panel.mobile-right-panel .logs-panel[data-v-d4a203ee] {\n        width: 100%;\n}\n.right-panel.mobile-right-panel .logs-panel.hide[data-v-d4a203ee] {\n          right: -430px;\n}\n.fix-buttons[data-v-d4a203ee] {\n    width: 100%;\n    bottom: 45px;\n}\n.fix-buttons a[data-v-d4a203ee] {\n      margin: 0 auto;\n}\n}\n.dl-profile[data-v-d4a203ee] {\n  position: fixed;\n  right: 100%;\n  top: 0;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Provider/index.vue"],"names":[],"mappings":";AACA;EACE,YAAY;CACb;AACD;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;CACjB;AACD;IACI,sBAAsB;CACzB;AACD;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;CACtB;AACD;EACE,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;CACrB;AACD;IACI,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,iCAAiC;CACpC;AACD;MACM,YAAY;CACjB;AACD;MACM,YAAY;MACZ,mBAAmB;MACnB,SAAS;MACT,UAAU;MACV,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,iBAAiB;MACjB,yCAAyC;MACzC,iCAAiC;MACjC,oDAAoD;cAC5C,4CAA4C;CACzD;AACD;MACM,oBAAoB;CACzB;AACD;QACQ,WAAW;CAClB;AACD;IACI,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;CAC7B;AACD;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;EACjC,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;CACZ;AACD;IACI,kBAAkB;CACrB;AACD;IACI,YAAY;CACf;AACD;IACI,qCAAqC;YAC7B,6BAA6B;IACrC,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;CAC3B;AACD;IACI,kBAAkB;CACrB;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,OAAO;EACP,WAAW;EACX,aAAa;EACb,iDAAiD;UACzC,yCAAyC;EACjD,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;CACtB;AACD;IACI,mBAAmB;CACtB;AACD;EACE,cAAc;CACf;AACD;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,WAAW;CACZ;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;CACnB;AACD;MACM,sBAAsB;UAClB,uBAAuB;cACnB,eAAe;CAC5B;AACD;MACM,iBAAiB;MACjB,kDAAkD;cAC1C,0CAA0C;MAClD,2BAA2B;MAC3B,YAAY;CACjB;AACD;EACE,WAAW;CACZ;AACD;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;CACpD;AACD;IACI,cAAc;IACd,cAAc;CACjB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,WAAW;IACX,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,mBAAmB;CACtB;AACD;MACM,eAAe;MACf,gBAAgB;CACrB;AACD;MACM,gBAAgB;MAChB,iBAAiB;CACtB;AACD;MACM,iBAAiB;CACtB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;EAClD,0BAA0B;EAC1B,iBAAiB;CAClB;AACD;IACI,gBAAgB;IAChB,mBAAmB;CACtB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,oBAAoB;CACzB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,QAAQ;EACR,cAAc;EACd,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,+BAA+B;UACvB,uBAAuB;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,WAAW;IACX,sBAAsB;IACtB,eAAe;CAClB;AACD;MACM,kBAAkB;CACvB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,YAAY;CACb;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;CAChB;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,uDAAuD;YAC/C,+CAA+C;IACvD,cAAc;CACjB;AACD;MACM,SAAS;MACT,aAAa;MACb,cAAc;MACd,mBAAmB;MACnB,oBAAoB;CACzB;AACD;IACI,cAAc;IACd,kBAAkB;CACrB;AACD;IACI,eAAe;CAClB;AACD;MACM,eAAe;MACf,2DAA2D;MAC3D,wDAAwD;CAC7D;AACD;EACE,eAAe;EACf,mBAAmB;CACpB;AACD;EACE,eAAe;CAChB;AACD;EACE,eAAe;CAChB;AACD;EACE,oBAAoB;EACpB,eAAe;CAChB;AACD;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;CACpB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,eAAe;CAChB;AACD;IACI,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;CACvB;AACD;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,YAAY;CACf;AACD;MACM,iBAAiB;MACjB,YAAY;MACZ,gBAAgB;CACrB;AACD;QACQ,8BAA8B;QAC9B,iBAAiB;CACxB;AACD;MACM,gBAAgB;CACrB;AACD;QACQ,mCAAmC;QACnC,2BAA2B;CAClC;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,gBAAgB;CACvB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,eAAe;QACf,mBAAmB;CAC1B;AACD;QACQ,2BAA2B;QAC3B,iBAAiB;CACxB;AACD;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,oBAAoB;IACpB,cAAc;IACd,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;MACM,kBAAkB;CACvB;AACD;MACM,kBAAkB;CACvB;AACD;MACM,kBAAkB;MAClB,mBAAmB;CACxB;AACD;MACM,2BAA2B;MAC3B,gBAAgB;MAChB,iBAAiB;MACjB,eAAe;CACpB;AACD;AACA;IACI,WAAW;IACX,oCAAoC;CACvC;AACD;IACI,WAAW;IACX,iCAAiC;CACpC;CACA;AACD;EACE,cAAc;EACd,gBAAgB;CACjB;AACD;EACE,WAAW;EACX,cAAc;CACf;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;CACb;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,yDAAyD;UACjD,iDAAiD;CAC1D;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;CACnB;AACD;EACE,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;CAClB;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,mBAAmB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;IACI,mBAAmB;IACnB,oCAAoC;IACpC,4BAA4B;IAC5B,SAAS;IACT,iBAAiB;IACjB,kBAAkB;CACrB;AACD;EACE,aAAa;EACb,cAAc;CACf;AACD;EACE,mBAAmB;CACpB;AACD;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;CACpB;AACD;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;CACtB;AACD;EACE,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;EACjB,0BAA0B;EAC1B,YAAY;EACZ,+BAA+B;EAC/B,mDAAmD;UAC3C,2CAA2C;EACnD,gBAAgB;EAChB,gCAAgC;EAChC,wBAAwB;EACxB,6BAA6B;EAC7B,qBAAqB;CACtB;AACD;IACI,qBAAqB;CACxB;AACD;IACI,iCAAiC;IACjC,yBAAyB;IACzB,6BAA6B;IAC7B,qBAAqB;CACxB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;EAClD,0BAA0B;EAC1B,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;IACI,cAAc;IACd,gDAAgD;YACxC,wCAAwC;CACnD;AACD;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;CACtB;AACD;EACE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;CACrC;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;AACA;IACI,YAAY;IACZ,sBAAsB;CACzB;AACD;MACM,aAAa;CAClB;AACD;QACQ,eAAe;QACf,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;QACQ,mBAAmB;QACnB,SAAS;QACT,UAAU;CACjB;AACD;MACM,iBAAiB;MACjB,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,mBAAmB;CACxB;AACD;QACQ,YAAY;CACnB;AACD;IACI,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;IACrB,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;CACpB;AACD;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,OAAO;MACP,WAAW;CAChB;AACD;QACQ,iBAAiB;QACjB,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,mBAAmB;CAC1B;AACD;UACU,oBAAoB;CAC7B;AACD;QACQ,YAAY;CACnB;AACD;UACU,sBAAsB;CAC/B;AACD;YACY,WAAW;YACX,kBAAkB;YAClB,qBAAqB;CAChC;AACD;UACU,YAAY;UACZ,aAAa;UACb,iBAAiB;UACjB,YAAY;UACZ,2BAA2B;CACpC;AACD;QACQ,YAAY;CACnB;AACD;UACU,cAAc;CACvB;AACD;IACI,YAAY;IACZ,aAAa;CAChB;AACD;MACM,eAAe;CACpB;CACA;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,OAAO;CACR","file":"index.vue","sourcesContent":["\n.clear[data-v-d4a203ee] {\n  clear: both;\n}\n.heading[data-v-d4a203ee] {\n  height: 50px;\n  font-size: 20px;\n  font-weight: 600;\n  color: #333;\n  padding: 10px 0;\n}\n.heading > span[data-v-d4a203ee] {\n    padding: 0 5px 0 15px;\n}\n.heading select[data-v-d4a203ee] {\n    width: auto;\n    float: right;\n    font-size: 16px;\n    margin-top: 5px;\n    margin-right: 40px;\n}\n.switch[data-v-d4a203ee] {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n}\n.switch .slider[data-v-d4a203ee] {\n    position: relative;\n    display: inline-block;\n    width: 50px;\n    height: 30px;\n    border-radius: 20px;\n    background: #ccc;\n    position: relative;\n    cursor: pointer;\n    -webkit-transition: all .25s ease-in-out;\n    transition: all .25s ease-in-out;\n}\n.switch .slider.disabled[data-v-d4a203ee] {\n      opacity: .4;\n}\n.switch .slider[data-v-d4a203ee]:before {\n      content: '';\n      position: absolute;\n      top: 4px;\n      left: 4px;\n      width: 22px;\n      height: 22px;\n      border-radius: 50%;\n      background: #fff;\n      -webkit-transition: all .25s ease-in-out;\n      transition: all .25s ease-in-out;\n      -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n}\n.switch .slider.active[data-v-d4a203ee] {\n      background: #57d1b7;\n}\n.switch .slider.active[data-v-d4a203ee]:before {\n        left: 24px;\n}\n.switch .label[data-v-d4a203ee] {\n    display: inline-block;\n    vertical-align: 10px;\n    margin-left: 5px;\n    font-size: 14px;\n    color: #555;\n    text-transform: uppercase;\n}\n.prov-options[data-v-d4a203ee] {\n  float: right;\n  width: 30px;\n  height: 40px;\n  text-align: center;\n  margin-right: 10px;\n  cursor: pointer;\n  color: #777;\n  -webkit-transition: all .4s ease;\n  transition: all .4s ease;\n  position: relative;\n  z-index: 5;\n}\n.prov-options .fa-ellipsis-v[data-v-d4a203ee] {\n    padding: 5px 10px;\n}\n.prov-options[data-v-d4a203ee]:hover {\n    color: #333;\n}\n.prov-options .options[data-v-d4a203ee] {\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n    position: absolute;\n    top: 100%;\n    right: 0;\n    width: 240px;\n    background: #fff;\n    padding: 10px;\n    border-radius: 4px;\n    -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);\n            box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);\n}\n.call[data-v-d4a203ee], .send-notif[data-v-d4a203ee], .print-placard[data-v-d4a203ee], .send-sms[data-v-d4a203ee], .download-profile[data-v-d4a203ee] {\n  /*float: right;*/\n  margin-bottom: 5px;\n  text-transform: uppercase;\n}\n.call i[data-v-d4a203ee], .send-notif i[data-v-d4a203ee], .print-placard i[data-v-d4a203ee], .send-sms i[data-v-d4a203ee], .download-profile i[data-v-d4a203ee] {\n    margin-right: 5px;\n}\n.send-sms[data-v-d4a203ee] {\n  background-color: #16b0de;\n}\n.download-profile[data-v-d4a203ee] {\n  background-color: #ec4545;\n}\n.left-panel[data-v-d4a203ee] {\n  position: fixed;\n  z-index: 2;\n  left: 0;\n  top: 0;\n  width: 40%;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #F4F8F9;\n  overflow-y: auto;\n  padding-bottom: 60px;\n}\n.left-panel .heading[data-v-d4a203ee] {\n    padding-left: 50px;\n}\n.toggle-mobile[data-v-d4a203ee] {\n  display: none;\n}\n.tab[data-v-d4a203ee] {\n  list-style: none;\n  padding: 0;\n  margin: 15px 0 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  z-index: 2;\n}\n.tab li[data-v-d4a203ee] {\n    color: #0D79F2;\n    padding: 15px 25px;\n    font-size: 14px;\n    font-weight: 600;\n    text-align: center;\n    display: inline-block;\n    text-transform: uppercase;\n    cursor: pointer;\n}\n.tab li.grow[data-v-d4a203ee] {\n      -webkit-box-flex: 100;\n          -ms-flex-positive: 100;\n              flex-grow: 100;\n}\n.tab li.active[data-v-d4a203ee] {\n      background: #fff;\n      -webkit-box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);\n              box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);\n      border-radius: 2px 2px 0 0;\n      color: #777;\n}\n.left-panel .tab li[data-v-d4a203ee] {\n  width: 25%;\n}\n.tab-contents[data-v-d4a203ee] {\n  background: #fff;\n  z-index: 2;\n  position: relative;\n  -webkit-box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);\n}\n.tab-contents .tab-content[data-v-d4a203ee] {\n    padding: 20px;\n    display: none;\n}\n.tab-contents .tab-content.no-H-padding[data-v-d4a203ee] {\n      padding: 20px 0;\n}\n.tab-contents .tab-content.active[data-v-d4a203ee] {\n      display: block;\n}\n.tab-contents .fixed-footer[data-v-d4a203ee] {\n    position: fixed;\n    bottom: 0;\n    right: 0;\n    width: 60%;\n    padding: 15px;\n    background: #313131;\n    color: #eee;\n    font-size: 18px;\n    line-height: 1;\n    text-align: center;\n}\n.tab-contents .fixed-footer span[data-v-d4a203ee] {\n      color: #36a2ff;\n      cursor: pointer;\n}\n.tab-contents .fixed-footer b[data-v-d4a203ee] {\n      font-size: 21px;\n      margin-left: 5px;\n}\n.tab-contents .fixed-footer i[data-v-d4a203ee] {\n      margin-left: 3px;\n}\n.right-panel[data-v-d4a203ee] {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  top: 0;\n  width: 60%;\n  height: 100%;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #d5d5d5;\n  overflow-y: auto;\n}\n.right-panel .heading[data-v-d4a203ee] {\n    font-size: 24px;\n    padding: 10px 20px;\n}\n.right-panel .tab[data-v-d4a203ee] {\n    background: #d5d5d5;\n}\n.right-panel .tab .active[data-v-d4a203ee] {\n      background: #ededed;\n}\n.right-panel .tab-contents[data-v-d4a203ee] {\n    background: #ededed;\n}\n.fix-buttons[data-v-d4a203ee] {\n  position: fixed;\n  z-index: 3;\n  bottom: 0;\n  left: 0;\n  padding: 10px;\n  width: 40%;\n  height: 60px;\n  background: #eee;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.fix-buttons a[data-v-d4a203ee] {\n    width: 50%;\n    display: inline-block;\n    margin: 0 auto;\n}\n.fix-buttons a.right[data-v-d4a203ee] {\n      margin-left: auto;\n}\n.modal[data-v-d4a203ee] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.modal .bg-overlay[data-v-d4a203ee] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n.modal .modal-content[data-v-d4a203ee] {\n    position: absolute;\n    top: 45%;\n    left: 50%;\n    width: 400px;\n    padding: 25px;\n    background: #fff;\n    text-align: center;\n    border-radius: 6px;\n    margin-left: -200px;\n    -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal .modal-content.upload[data-v-d4a203ee] {\n      top: 50%;\n      width: 900px;\n      height: 550px;\n      margin-top: -265px;\n      margin-left: -450px;\n}\n.modal.no-preview .upload[data-v-d4a203ee] {\n    height: 150px;\n    margin-top: -75px;\n}\n.modal.show[data-v-d4a203ee] {\n    display: block;\n}\n.modal.show .modal-content[data-v-d4a203ee] {\n      display: block;\n      -webkit-animation: slide-down-data-v-d4a203ee .3s ease-out;\n      -moz-animation: slide-down-data-v-d4a203ee .3s ease-out;\n}\n.service-save i[data-v-d4a203ee] {\n  display: block;\n  margin-bottom: 5px;\n}\n.service-save .fa-check-circle[data-v-d4a203ee] {\n  color: #1bd35d;\n}\n.service-save .fa-times-circle[data-v-d4a203ee] {\n  color: #ea4949;\n}\n.service-save span[data-v-d4a203ee] {\n  margin-bottom: 10px;\n  display: block;\n}\n.service-save p[data-v-d4a203ee] {\n  padding: 3px;\n  margin: 0 0 15px;\n  background: #ea4949;\n  color: #fff;\n  font-size: 14px;\n  border-radius: 4px;\n}\n.service-save .button[data-v-d4a203ee] {\n  margin-top: 10px;\n}\n.breakdown[data-v-d4a203ee] {\n  overflow: auto;\n}\n.breakdown .modal-content[data-v-d4a203ee] {\n    max-width: 800px;\n    width: 100%;\n    position: relative;\n    top: 20px;\n    left: 0;\n    margin: 0 auto;\n}\n.breakdown .has-error i[data-v-d4a203ee] {\n    color: #fb4040;\n}\n.breakdown .has-error span[data-v-d4a203ee] {\n    display: block;\n    font-size: 21px;\n    margin: 10px 0 15px;\n}\n.breakdown .has-error p[data-v-d4a203ee] {\n    line-height: 135%;\n    padding: 0;\n    margin: 0 0 20px;\n    color: #777;\n}\n.breakdown .label[data-v-d4a203ee] {\n    font-size: 21px;\n    margin-bottom: 20px;\n    font-weight: 600;\n    color: #0D79F2;\n}\n.breakdown .list[data-v-d4a203ee] {\n    width: 100%;\n}\n.breakdown .list thead[data-v-d4a203ee] {\n      font-weight: 600;\n      color: #999;\n      font-size: 14px;\n}\n.breakdown .list thead td[data-v-d4a203ee] {\n        border-bottom: 1px solid #ccc;\n        padding: 3px 2px;\n}\n.breakdown .list tbody[data-v-d4a203ee] {\n      font-size: 14px;\n}\n.breakdown .list tbody tr[data-v-d4a203ee] {\n        -webkit-transition: all .1s linear;\n        transition: all .1s linear;\n}\n.breakdown .list tbody tr[data-v-d4a203ee]:hover {\n        background: #e2f3ff;\n}\n.breakdown .list tbody a[data-v-d4a203ee] {\n        font-size: 13px;\n}\n.breakdown .list tbody a.pkg[data-v-d4a203ee] {\n        color: #14ab3b;\n}\n.breakdown .list tbody td[data-v-d4a203ee] {\n        padding: 3px 0;\n        text-align: center;\n}\n.breakdown .list tbody .total td[data-v-d4a203ee] {\n        border-top: 1px solid #ccc;\n        font-weight: 600;\n}\n.breakdown .computations[data-v-d4a203ee] {\n    float: right;\n    margin: 20px 0;\n    border: 1px solid #eee;\n    background: #fafafa;\n    padding: 10px;\n    -webkit-box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);\n            box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);\n}\n.breakdown .computations td[data-v-d4a203ee] {\n      padding: 2px 20px;\n}\n.breakdown .computations td[data-v-d4a203ee]:first-child {\n      text-align: right;\n}\n.breakdown .computations td[data-v-d4a203ee]:last-child {\n      text-align: right;\n      padding-left: 20px;\n}\n.breakdown .computations .total td[data-v-d4a203ee] {\n      border-top: 1px solid #aaa;\n      font-size: 21px;\n      font-weight: 600;\n      color: #e44e4e;\n}\n@-webkit-keyframes slide-down-data-v-d4a203ee {\n0% {\n    opacity: 0;\n    -webkit-transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n}\n}\n.active-confirmation p[data-v-d4a203ee] {\n  margin-top: 0;\n  font-size: 18px;\n}\n.active-confirmation .button[data-v-d4a203ee] {\n  width: 40%;\n  margin: 0 5px;\n}\n.formResult p[data-v-d4a203ee] {\n  margin: 0 0 40px;\n  font-size: 18px;\n  color: #333;\n}\n.upload .input-file[data-v-d4a203ee] {\n  margin: 0 0 15px;\n  font-size: 14px;\n  padding: 5px;\n  background: #fafafa;\n  -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1) inset;\n          box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1) inset;\n}\n.upload .cropper-wrap[data-v-d4a203ee] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  margin-bottom: 15px;\n  padding-top: 20px;\n}\n.upload .upload-side[data-v-d4a203ee], .upload .preview-side[data-v-d4a203ee] {\n  position: relative;\n  display: inline-block;\n  width: 50%;\n  max-height: 380px;\n  vertical-align: top;\n  background: #555;\n}\n.upload .upload-side ._label[data-v-d4a203ee], .upload .preview-side ._label[data-v-d4a203ee] {\n    position: absolute;\n    top: -22px;\n    left: 0;\n    font-weight: 600;\n    font-size: 14px;\n    color: #777;\n    width: 100%;\n    text-align: center;\n}\n.upload .preview-side[data-v-d4a203ee] {\n  margin-left: 10px;\n}\n.upload .preview-side img[data-v-d4a203ee] {\n    position: relative;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n    top: 50%;\n    max-width: 420px;\n    max-height: 380px;\n}\n.upload .button.cta[data-v-d4a203ee] {\n  width: 200px;\n  margin: 0 5px;\n}\n.uploadError[data-v-d4a203ee] {\n  text-align: center;\n}\n.uploadError p[data-v-d4a203ee] {\n    margin-top: 0;\n    color: #f20d0d;\n    font-weight: 600;\n}\n.uploadError .fa[data-v-d4a203ee] {\n    display: block;\n    color: #999;\n    margin-bottom: 5px;\n}\n.logs-toggle[data-v-d4a203ee] {\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 3;\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  text-align: center;\n  color: #777;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  border-radius: 0;\n  background-color: #F25E0D;\n  color: #fff;\n  border-bottom-left-radius: 3px;\n  -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n          box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n  -webkit-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: .5s ease;\n  transition: .5s ease;\n}\n.logs-toggle i[data-v-d4a203ee] {\n    line-height: inherit;\n}\n.logs-toggle.on[data-v-d4a203ee] {\n    -webkit-transform: rotate(90deg);\n    transform: rotate(90deg);\n    -webkit-transition: .5s ease;\n    transition: .5s ease;\n}\n.logs-panel[data-v-d4a203ee] {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  top: 0;\n  width: 400px;\n  height: 100%;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #f4f8f9;\n  -webkit-transition: all .6s ease;\n  transition: all .6s ease;\n}\n.logs-panel.hide[data-v-d4a203ee] {\n    right: -400px;\n    -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n            box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n}\n.logs-panel .heading[data-v-d4a203ee] {\n    font-size: 24px;\n    padding: 10px 20px;\n    margin-bottom: 7px;\n}\n.slide-up-enter-active[data-v-d4a203ee], .slide-up-leave-active[data-v-d4a203ee] {\n  -webkit-transition: all .45s ease;\n  transition: all .45s ease;\n}\n.slide-up-enter[data-v-d4a203ee], .slide-up-leave-to[data-v-d4a203ee] {\n  -webkit-transform: translateY(80px);\n          transform: translateY(80px);\n}\n.slide-down-enter-active[data-v-d4a203ee], .slide-down-leave-active[data-v-d4a203ee] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-d4a203ee], .slide-down-leave-to[data-v-d4a203ee] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n}\n@media only screen and (max-width: 430px) {\n.left-panel[data-v-d4a203ee] {\n    width: 100%;\n    padding-bottom: 100px;\n}\n.left-panel .heading[data-v-d4a203ee] {\n      height: auto;\n}\n.left-panel .heading .switch[data-v-d4a203ee] {\n        display: block;\n        padding-top: 5px;\n        padding-left: 10px;\n}\n.left-panel .heading .prov-options[data-v-d4a203ee] {\n        position: absolute;\n        right: 0;\n        top: 15px;\n}\n.left-panel .tab[data-v-d4a203ee] {\n      margin: 20px 0 0;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      overflow-x: scroll;\n}\n.left-panel .tab li[data-v-d4a203ee] {\n        width: auto;\n}\n.toggle-mobile[data-v-d4a203ee] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.right-panel[data-v-d4a203ee] {\n    z-index: 1;\n    width: 100%;\n    top: 100%;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n}\n.right-panel.mobile-right-panel[data-v-d4a203ee] {\n      top: 0;\n      z-index: 2;\n}\n.right-panel.mobile-right-panel .tab[data-v-d4a203ee] {\n        margin-top: 70px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        overflow-x: scroll;\n}\n.right-panel.mobile-right-panel .tab li[data-v-d4a203ee] {\n          white-space: nowrap;\n}\n.right-panel.mobile-right-panel .tab-contents[data-v-d4a203ee] {\n        width: 100%;\n}\n.right-panel.mobile-right-panel .tab-contents .tab-content[data-v-d4a203ee] {\n          padding-bottom: 100px;\n}\n.right-panel.mobile-right-panel .tab-contents .tab-content.history-panel[data-v-d4a203ee] {\n            padding: 0;\n            padding-top: 20px;\n            padding-bottom: 60px;\n}\n.right-panel.mobile-right-panel .tab-contents .fixed-footer[data-v-d4a203ee] {\n          width: 100%;\n          bottom: 45px;\n          background: #fff;\n          color: #000;\n          border-top: 1px solid #aaa;\n}\n.right-panel.mobile-right-panel .logs-panel[data-v-d4a203ee] {\n        width: 100%;\n}\n.right-panel.mobile-right-panel .logs-panel.hide[data-v-d4a203ee] {\n          right: -430px;\n}\n.fix-buttons[data-v-d4a203ee] {\n    width: 100%;\n    bottom: 45px;\n}\n.fix-buttons a[data-v-d4a203ee] {\n      margin: 0 auto;\n}\n}\n.dl-profile[data-v-d4a203ee] {\n  position: fixed;\n  right: 100%;\n  top: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountDetails_vue__ = __webpack_require__(572);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dc61230_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountDetails_vue__ = __webpack_require__(1667);
function injectStyle (ssrContext) {
  __webpack_require__(1661)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0dc61230"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dc61230_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1662);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("968a1d0a", content, true, {});

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.top-part[data-v-0dc61230] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 20px;\n}\n.quick-res[data-v-0dc61230] {\n  line-height: 1;\n  font-size: 14px;\n  color: #555;\n  font-weight: 600;\n  margin-bottom: 3px;\n}\n.switch[data-v-0dc61230] {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  margin-bottom: 10px;\n}\n.switch .slider[data-v-0dc61230] {\n    position: relative;\n    display: inline-block;\n    width: 50px;\n    height: 25px;\n    border-radius: 20px;\n    background: #ccc;\n    position: relative;\n    cursor: pointer;\n    -webkit-transition: all .25s ease-in-out;\n    transition: all .25s ease-in-out;\n}\n.switch .slider.disabled[data-v-0dc61230] {\n      opacity: .4;\n}\n.switch .slider[data-v-0dc61230]:before {\n      content: '';\n      position: absolute;\n      top: 4px;\n      left: 4px;\n      width: 17px;\n      height: 17px;\n      border-radius: 50%;\n      background: #fff;\n      -webkit-transition: all .25s ease-in-out;\n      transition: all .25s ease-in-out;\n      -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n}\n.switch .slider.active[data-v-0dc61230] {\n      background: #57d1b7;\n}\n.switch .slider.active[data-v-0dc61230]:before {\n        left: 29px;\n}\n.switch .label[data-v-0dc61230] {\n    display: inline-block;\n    vertical-align: 7px;\n    margin-left: 5px;\n    font-size: 14px;\n    color: #777;\n    text-transform: uppercase;\n}\n.driver-id[data-v-0dc61230] {\n  display: inline-table;\n  vertical-align: top;\n  position: relative;\n}\n.driver-id label[data-v-0dc61230] {\n    border: 1px solid #ccc;\n    border-right: none;\n    background: #fafafa;\n    padding: 0 5px;\n    vertical-align: top;\n    height: 30px;\n    line-height: 30px;\n    font-size: 13px;\n    font-weight: 600;\n    color: #555;\n    display: inline-block;\n}\n.driver-id label.value[data-v-0dc61230] {\n      display: none;\n}\n.driver-id input[data-v-0dc61230] {\n    display: inline-block;\n    width: 60px;\n    margin: 0;\n    height: 30px;\n    padding: 5px;\n    font-size: 13px;\n    color: #555;\n    vertical-align: top;\n    border-radius: 0;\n    position: relative;\n    cursor: default;\n    text-align: center;\n    z-index: 3;\n}\n.driver-id input.has-error[data-v-0dc61230] {\n      border: 1px solid #f20d0d;\n}\n.driver-id input.filled[data-v-0dc61230] {\n      font-weight: 600;\n      border: none;\n      border-left: 1px solid #ccc;\n}\n.driver-id input.no-access[data-v-0dc61230] {\n      background: #f3f3f3;\n}\n.driver-id button[data-v-0dc61230] {\n    border-radius: 0;\n    font-size: 14px;\n    display: inline-block;\n    height: 30px;\n    line-height: 30px;\n    vertical-align: top;\n    padding: 0 10px;\n}\n.driver-id button.disabled[data-v-0dc61230] {\n      opacity: .5;\n}\n.driver-id .next-id[data-v-0dc61230] {\n    font-size: 14px;\n    color: #777;\n    font-weight: 500;\n    margin-left: 5px;\n}\n.driver-id .error-msg[data-v-0dc61230], .driver-id .saved[data-v-0dc61230] {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    font-size: 12px;\n    font-weight: 500;\n    color: #f20d0d;\n    white-space: nowrap;\n}\n.driver-id .saved[data-v-0dc61230] {\n    top: 27px;\n    color: #12c748 !important;\n    font-weight: 600;\n    z-index: 1;\n    padding-left: 6px;\n}\n.driver-id.filled label[data-v-0dc61230] {\n    border: none;\n    background: none;\n}\n.driver-id.filled label.value[data-v-0dc61230] {\n      display: inline-block;\n      font-weight: 600;\n}\n.driver-id.filled input[data-v-0dc61230] {\n    display: none;\n    font-weight: 600;\n    border: none;\n    background: none;\n    width: auto !important;\n}\n.other-data[data-v-0dc61230] {\n  background: #fafafa;\n  padding: 15px;\n  border: 1px solid #eaeaea;\n  margin-bottom: 20px;\n}\n.other-data .services[data-v-0dc61230] {\n    border-bottom: 1px solid #dadada;\n    margin-bottom: 10px;\n}\n.collapsible[data-v-0dc61230] {\n  margin-bottom: 5px;\n}\n.collapsible .heading[data-v-0dc61230] {\n    color: #0D79F2;\n    margin-bottom: 2px;\n    cursor: pointer;\n    text-transform: uppercase;\n}\n.collapsible .heading i[data-v-0dc61230] {\n      margin-right: 5px;\n}\n.collapsible .heading span[data-v-0dc61230] {\n      font-weight: 600;\n}\n.collapsible .content[data-v-0dc61230] {\n    margin-left: 6px;\n    padding: 5px 0 5px 15px;\n    border-left: 2px solid #ddd;\n    max-height: 700px;\n    /* define precise max-height for more smoother transition */\n    height: auto;\n    -webkit-transition: all 0.35s ease-out;\n    transition: all 0.35s ease-out;\n}\n.collapsible .content.documentation[data-v-0dc61230] {\n      max-height: 1900px;\n}\n.collapsible .content .two-col[data-v-0dc61230] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      margin-bottom: 20px;\n      border-bottom: 1px dotted #cfcfcf;\n      padding-bottom: 20px;\n}\n.collapsible .content .two-col[data-v-0dc61230]:last-child {\n        border-bottom: none;\n}\n.collapsible .content .two-col .img-view[data-v-0dc61230] {\n        width: 30%;\n        padding: 0 15px;\n        display: inline-block;\n        text-align: center;\n        position: relative;\n}\n.collapsible .content .two-col .img-view.full[data-v-0dc61230] {\n          width: 100%;\n}\n.collapsible .content .two-col .img-view .thumbnail[data-v-0dc61230] {\n          width: 100%;\n          padding: 15px 0;\n}\n.collapsible .content .two-col .img-view .thumbnail img[data-v-0dc61230] {\n            margin-bottom: 10px;\n            max-height: 150px;\n}\n.collapsible .content .two-col .img-view .thumbnail .fa-image[data-v-0dc61230] {\n            font-size: 80px;\n            color: #c1cede;\n            position: relative;\n            z-index: 1;\n}\n.collapsible .content .two-col .img-view .thumbnail .fa-spinner[data-v-0dc61230] {\n            margin-right: 5px;\n}\n.collapsible .content .two-col .fields[data-v-0dc61230] {\n        width: 70%;\n        display: inline-block;\n}\n.collapsible .content .field-row[data-v-0dc61230] {\n      margin-bottom: 15px;\n}\n.collapsible .content .field-row[data-v-0dc61230]:last-child {\n      margin-bottom: 0;\n}\n.collapsible.collapse .content[data-v-0dc61230] {\n    max-height: 0;\n    overflow: hidden;\n    padding: 0 15px;\n}\n.ssn-ein-label[data-v-0dc61230] {\n  color: #888;\n  font-weight: 600;\n  font-size: 11px;\n  text-transform: uppercase;\n  line-height: 130%;\n  margin-bottom: 10px;\n}\n.w9-form .img-view[data-v-0dc61230] {\n  width: 100%;\n  padding: 0 !important;\n  display: inline-block;\n  text-align: left !important;\n  position: relative;\n}\n.w9-form .img-view .thumbnail[data-v-0dc61230] {\n    width: 100%;\n    padding: 15px 0;\n}\n.w9-form .img-view .thumbnail img[data-v-0dc61230] {\n      margin-bottom: 10px;\n      max-height: 150px;\n}\n.w9-form .img-view .thumbnail .fa-image[data-v-0dc61230] {\n      font-size: 80px;\n      color: #c1cede;\n      position: relative;\n      z-index: 1;\n}\n.w9-form .img-view .thumbnail .fa-spinner[data-v-0dc61230] {\n      margin-right: 5px;\n}\n.w9-form .img-view .thumbnail .button[data-v-0dc61230] {\n      width: 30%;\n      display: block;\n}\n.w9-form .fields[data-v-0dc61230] {\n  width: 70%;\n  display: inline-block;\n}\n.field-row[data-v-0dc61230] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.field-row .col[data-v-0dc61230] {\n    display: inline-block;\n}\n.field-row .col20[data-v-0dc61230] {\n    width: 20%;\n}\n.field-row .col25[data-v-0dc61230] {\n    width: 25%;\n}\n.field-row .col33[data-v-0dc61230] {\n    width: 33%;\n}\n.field-row .col34[data-v-0dc61230] {\n    width: 34%;\n}\n.field-row .col40[data-v-0dc61230] {\n    width: 40%;\n}\n.field-row .col50[data-v-0dc61230] {\n    width: 50%;\n}\n.field-row .col60[data-v-0dc61230] {\n    width: 60%;\n}\n.field-row .col80[data-v-0dc61230] {\n    width: 80%;\n}\n.field-row .col100[data-v-0dc61230] {\n    width: 100%;\n}\n.data-field[data-v-0dc61230] {\n  padding-right: 10px;\n  position: relative;\n}\n.data-field.no-label[data-v-0dc61230] {\n    padding-top: 17px;\n}\n.data-field .label[data-v-0dc61230] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .label.bigger[data-v-0dc61230] {\n      font-size: 14px;\n}\n.data-field .input[data-v-0dc61230] {\n    margin: 5px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-0dc61230] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-0dc61230]:disabled {\n      background: #fbfbfb;\n}\n.data-field select[data-v-0dc61230] {\n    margin-top: 5px;\n    border: 1px solid #ddd;\n    padding: 10px;\n    color: #333;\n    height: 45px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background: url(\"/assets/img/down.png\") no-repeat right 12px;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field select.has-error[data-v-0dc61230] {\n      border-color: #f20d0d;\n}\n.data-field select[data-v-0dc61230]:disabled {\n      background: #fbfbfb;\n}\n.data-field .checkbox[data-v-0dc61230] {\n    line-height: 100%;\n    margin-bottom: 3px;\n}\n.data-field .checkbox.inline[data-v-0dc61230] {\n      display: inline-block;\n      margin: 0 25px 10px 0;\n}\n.data-field .checkbox[data-v-0dc61230]:last-child {\n      margin-bottom: 0;\n}\n.data-field .checkbox input[data-v-0dc61230] {\n      display: inline-block;\n      width: auto;\n      vertical-align: -2px;\n      margin: 0 5px 0 0;\n}\n.data-field .checkbox label[data-v-0dc61230] {\n      font-size: 14px;\n      color: #555;\n      line-height: 150%;\n}\n.data-field .radio[data-v-0dc61230] {\n    display: block;\n    color: #333;\n    font-size: 14px;\n    margin-top: 5px;\n}\n.data-field .radio[data-v-0dc61230]:first-child {\n      margin-top: 5px;\n}\n.data-field .radio input[data-v-0dc61230] {\n      display: inline-block;\n      width: auto;\n      margin: 0 0 0 5px;\n}\n.data-field .error-msg[data-v-0dc61230] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.data-field .df-created[data-v-0dc61230] {\n    text-align: center;\n    letter-spacing: .6px;\n    font-size: 14px;\n    color: #777;\n    line-height: 1;\n    margin-top: 10px;\n}\n.datepicker[data-v-0dc61230] {\n  position: relative;\n  margin-top: 3px;\n  /*top: -10px;*/\n}\n.fa-file-pdf[data-v-0dc61230] {\n  margin-bottom: 10px;\n  color: #f44f4f;\n}\n.reset-password-wrap[data-v-0dc61230] {\n  position: relative;\n  overflow: hidden;\n}\n.mark-test-account[data-v-0dc61230] {\n  color: #333;\n  font-size: 14px;\n  letter-spacing: .3px;\n  border: 1px solid #c5b359;\n  background: #fffbe8;\n  padding: 10px 8px;\n  line-height: 1;\n}\n.mark-test-account label[data-v-0dc61230] {\n    cursor: pointer;\n}\n.mark-test-account input[data-v-0dc61230] {\n    width: auto;\n    display: inline-block;\n    margin: 0 3px 0 0;\n    vertical-align: -1px;\n}\n.documentation-notice[data-v-0dc61230] {\n  margin: 0 0 25px;\n  font-size: 12px;\n  color: #777;\n}\n.documentation-notice i[data-v-0dc61230] {\n    font-weight: 600;\n}\n.input-group[data-v-0dc61230] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  position: relative;\n  margin-bottom: 0;\n}\n.input-group .input-group-label[data-v-0dc61230] {\n    padding: 0 10px;\n    border: 1px solid #cacaca;\n    background: #f4f8f9;\n    color: #0a0a0a;\n    text-align: center;\n    white-space: nowrap;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n.input-group .mobile-input[data-v-0dc61230] {\n    padding-left: 25px;\n    border-radius: 1px;\n    border-left: 0;\n}\n.input-group.small .mobile-input[data-v-0dc61230] {\n    padding-left: 35px;\n}\n.input-group.medium .mobile-input[data-v-0dc61230] {\n    padding-left: 45px;\n}\n.input-group.large .mobile-input[data-v-0dc61230] {\n    padding-left: 55px;\n}\n.input-group.xl .mobile-input[data-v-0dc61230] {\n    padding-left: 65px;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput[data-v-0dc61230]::-webkit-outer-spin-button,\ninput[data-v-0dc61230]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number][data-v-0dc61230] {\n  -moz-appearance: textfield;\n}\n.country-select[data-v-0dc61230] {\n  margin-top: 5px;\n  cursor: pointer;\n  color: #333;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.country-select[data-v-0dc61230]:hover {\n  background-color: #e6e6e6;\n}\n.country-code[data-v-0dc61230] {\n  margin-right: 3px;\n  font-weight: 100;\n}\n@media only screen and (max-width: 430px) {\n.top-part[data-v-0dc61230] {\n    display: block;\n}\n.top-part .driver-id[data-v-0dc61230] {\n      width: 100%;\n}\n.data-field.no-label[data-v-0dc61230] {\n    padding-top: 0;\n}\n.collapsible .content .field-row[data-v-0dc61230] {\n    margin: 0;\n}\n.data-field .label[data-v-0dc61230] {\n    margin-top: 10px;\n}\n.data-field .checkbox[data-v-0dc61230] {\n    margin-top: 5px;\n}\n.data-field.pwd[data-v-0dc61230] {\n    margin-top: 10px;\n}\n.field-row[data-v-0dc61230] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.field-row .col50[data-v-0dc61230], .field-row .col33[data-v-0dc61230], .field-row .col34[data-v-0dc61230] {\n      width: 100%;\n}\n.field-row .col40[data-v-0dc61230] {\n      width: 100%;\n}\n.field-row .password-div[data-v-0dc61230] {\n      margin-top: 20px;\n      text-align: center;\n}\n.collapsible .content[data-v-0dc61230] {\n    max-height: none;\n}\n.collapsible .content .two-col[data-v-0dc61230] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n}\n.collapsible .content .two-col .img-view[data-v-0dc61230] {\n        width: 100%;\n}\n.collapsible .content .two-col .fields[data-v-0dc61230] {\n        width: 100%;\n}\n.collapsible .content.documentation[data-v-0dc61230] {\n      max-height: none;\n}\n.w9-form .img-view .thumbnail[data-v-0dc61230] {\n    text-align: center;\n}\n.w9-form .img-view .thumbnail .button[data-v-0dc61230] {\n      width: 100%;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Provider/AccountDetails.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;MACtB,uBAAuB;UACnB,+BAA+B;EACvC,oBAAoB;CACrB;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;CACrB;AACD;IACI,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,iCAAiC;CACpC;AACD;MACM,YAAY;CACjB;AACD;MACM,YAAY;MACZ,mBAAmB;MACnB,SAAS;MACT,UAAU;MACV,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,iBAAiB;MACjB,yCAAyC;MACzC,iCAAiC;MACjC,oDAAoD;cAC5C,4CAA4C;CACzD;AACD;MACM,oBAAoB;CACzB;AACD;QACQ,WAAW;CAClB;AACD;IACI,sBAAsB;IACtB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;CAC7B;AACD;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;CACpB;AACD;IACI,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;CACzB;AACD;MACM,cAAc;CACnB;AACD;IACI,sBAAsB;IACtB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;CACd;AACD;MACM,0BAA0B;CAC/B;AACD;MACM,iBAAiB;MACjB,aAAa;MACb,4BAA4B;CACjC;AACD;MACM,oBAAoB;CACzB;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;MACM,YAAY;CACjB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;CACpB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,oBAAoB;CACvB;AACD;IACI,UAAU;IACV,0BAA0B;IAC1B,iBAAiB;IACjB,WAAW;IACX,kBAAkB;CACrB;AACD;IACI,aAAa;IACb,iBAAiB;CACpB;AACD;MACM,sBAAsB;MACtB,iBAAiB;CACtB;AACD;IACI,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB,uBAAuB;CAC1B;AACD;EACE,oBAAoB;EACpB,cAAc;EACd,0BAA0B;EAC1B,oBAAoB;CACrB;AACD;IACI,iCAAiC;IACjC,oBAAoB;CACvB;AACD;EACE,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;MACM,iBAAiB;CACtB;AACD;IACI,iBAAiB;IACjB,wBAAwB;IACxB,4BAA4B;IAC5B,kBAAkB;IAClB,4DAA4D;IAC5D,aAAa;IACb,uCAAuC;IACvC,+BAA+B;CAClC;AACD;MACM,mBAAmB;CACxB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,oBAAoB;MACpB,kCAAkC;MAClC,qBAAqB;CAC1B;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,WAAW;QACX,gBAAgB;QAChB,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;UACU,YAAY;UACZ,gBAAgB;CACzB;AACD;YACY,oBAAoB;YACpB,kBAAkB;CAC7B;AACD;YACY,gBAAgB;YAChB,eAAe;YACf,mBAAmB;YACnB,WAAW;CACtB;AACD;YACY,kBAAkB;CAC7B;AACD;QACQ,WAAW;QACX,sBAAsB;CAC7B;AACD;MACM,oBAAoB;CACzB;AACD;MACM,iBAAiB;CACtB;AACD;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;CACnB;AACD;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;CACrB;AACD;EACE,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;CACpB;AACD;IACI,YAAY;IACZ,gBAAgB;CACnB;AACD;MACM,oBAAoB;MACpB,kBAAkB;CACvB;AACD;MACM,gBAAgB;MAChB,eAAe;MACf,mBAAmB;MACnB,WAAW;CAChB;AACD;MACM,kBAAkB;CACvB;AACD;MACM,WAAW;MACX,eAAe;CACpB;AACD;EACE,WAAW;EACX,sBAAsB;CACvB;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,sBAAsB;CACzB;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,YAAY;CACf;AACD;EACE,oBAAoB;EACpB,mBAAmB;CACpB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;MACM,gBAAgB;CACrB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,oBAAoB;CACzB;AACD;IACI,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,6DAA6D;IAC7D,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,oBAAoB;CACzB;AACD;IACI,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;MACM,sBAAsB;MACtB,YAAY;MACZ,qBAAqB;MACrB,kBAAkB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,kBAAkB;CACvB;AACD;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;CACnB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,sBAAsB;MACtB,YAAY;MACZ,kBAAkB;CACvB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;IACI,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;CACpB;AACD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;CAChB;AACD;EACE,oBAAoB;EACpB,eAAe;CAChB;AACD;EACE,mBAAmB;EACnB,iBAAiB;CAClB;AACD;EACE,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;CAChB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;CACxB;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;CACb;AACD;IACI,iBAAiB;CACpB;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;CAClB;AACD;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,uBAAuB;IACvB,oBAAoB;CACvB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;CAClB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,mBAAmB;CACtB;;AAED,iCAAiC;AACjC;;EAEE,yBAAyB;EACzB,UAAU;CACX;;AAED,aAAa;AACb;EACE,2BAA2B;CAC5B;AACD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;CAClB;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;AACA;IACI,eAAe;CAClB;AACD;MACM,YAAY;CACjB;AACD;IACI,eAAe;CAClB;AACD;IACI,UAAU;CACb;AACD;IACI,iBAAiB;CACpB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,6BAA6B;IAC7B,8BAA8B;QAC1B,2BAA2B;YACvB,uBAAuB;CAClC;AACD;MACM,YAAY;CACjB;AACD;MACM,YAAY;CACjB;AACD;MACM,iBAAiB;MACjB,mBAAmB;CACxB;AACD;IACI,iBAAiB;CACpB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,6BAA6B;MAC7B,8BAA8B;UAC1B,2BAA2B;cACvB,uBAAuB;CACpC;AACD;QACQ,YAAY;CACnB;AACD;QACQ,YAAY;CACnB;AACD;MACM,iBAAiB;CACtB;AACD;IACI,mBAAmB;CACtB;AACD;MACM,YAAY;CACjB;CACA","file":"AccountDetails.vue","sourcesContent":["\n.top-part[data-v-0dc61230] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 20px;\n}\n.quick-res[data-v-0dc61230] {\n  line-height: 1;\n  font-size: 14px;\n  color: #555;\n  font-weight: 600;\n  margin-bottom: 3px;\n}\n.switch[data-v-0dc61230] {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  margin-bottom: 10px;\n}\n.switch .slider[data-v-0dc61230] {\n    position: relative;\n    display: inline-block;\n    width: 50px;\n    height: 25px;\n    border-radius: 20px;\n    background: #ccc;\n    position: relative;\n    cursor: pointer;\n    -webkit-transition: all .25s ease-in-out;\n    transition: all .25s ease-in-out;\n}\n.switch .slider.disabled[data-v-0dc61230] {\n      opacity: .4;\n}\n.switch .slider[data-v-0dc61230]:before {\n      content: '';\n      position: absolute;\n      top: 4px;\n      left: 4px;\n      width: 17px;\n      height: 17px;\n      border-radius: 50%;\n      background: #fff;\n      -webkit-transition: all .25s ease-in-out;\n      transition: all .25s ease-in-out;\n      -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n}\n.switch .slider.active[data-v-0dc61230] {\n      background: #57d1b7;\n}\n.switch .slider.active[data-v-0dc61230]:before {\n        left: 29px;\n}\n.switch .label[data-v-0dc61230] {\n    display: inline-block;\n    vertical-align: 7px;\n    margin-left: 5px;\n    font-size: 14px;\n    color: #777;\n    text-transform: uppercase;\n}\n.driver-id[data-v-0dc61230] {\n  display: inline-table;\n  vertical-align: top;\n  position: relative;\n}\n.driver-id label[data-v-0dc61230] {\n    border: 1px solid #ccc;\n    border-right: none;\n    background: #fafafa;\n    padding: 0 5px;\n    vertical-align: top;\n    height: 30px;\n    line-height: 30px;\n    font-size: 13px;\n    font-weight: 600;\n    color: #555;\n    display: inline-block;\n}\n.driver-id label.value[data-v-0dc61230] {\n      display: none;\n}\n.driver-id input[data-v-0dc61230] {\n    display: inline-block;\n    width: 60px;\n    margin: 0;\n    height: 30px;\n    padding: 5px;\n    font-size: 13px;\n    color: #555;\n    vertical-align: top;\n    border-radius: 0;\n    position: relative;\n    cursor: default;\n    text-align: center;\n    z-index: 3;\n}\n.driver-id input.has-error[data-v-0dc61230] {\n      border: 1px solid #f20d0d;\n}\n.driver-id input.filled[data-v-0dc61230] {\n      font-weight: 600;\n      border: none;\n      border-left: 1px solid #ccc;\n}\n.driver-id input.no-access[data-v-0dc61230] {\n      background: #f3f3f3;\n}\n.driver-id button[data-v-0dc61230] {\n    border-radius: 0;\n    font-size: 14px;\n    display: inline-block;\n    height: 30px;\n    line-height: 30px;\n    vertical-align: top;\n    padding: 0 10px;\n}\n.driver-id button.disabled[data-v-0dc61230] {\n      opacity: .5;\n}\n.driver-id .next-id[data-v-0dc61230] {\n    font-size: 14px;\n    color: #777;\n    font-weight: 500;\n    margin-left: 5px;\n}\n.driver-id .error-msg[data-v-0dc61230], .driver-id .saved[data-v-0dc61230] {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    font-size: 12px;\n    font-weight: 500;\n    color: #f20d0d;\n    white-space: nowrap;\n}\n.driver-id .saved[data-v-0dc61230] {\n    top: 27px;\n    color: #12c748 !important;\n    font-weight: 600;\n    z-index: 1;\n    padding-left: 6px;\n}\n.driver-id.filled label[data-v-0dc61230] {\n    border: none;\n    background: none;\n}\n.driver-id.filled label.value[data-v-0dc61230] {\n      display: inline-block;\n      font-weight: 600;\n}\n.driver-id.filled input[data-v-0dc61230] {\n    display: none;\n    font-weight: 600;\n    border: none;\n    background: none;\n    width: auto !important;\n}\n.other-data[data-v-0dc61230] {\n  background: #fafafa;\n  padding: 15px;\n  border: 1px solid #eaeaea;\n  margin-bottom: 20px;\n}\n.other-data .services[data-v-0dc61230] {\n    border-bottom: 1px solid #dadada;\n    margin-bottom: 10px;\n}\n.collapsible[data-v-0dc61230] {\n  margin-bottom: 5px;\n}\n.collapsible .heading[data-v-0dc61230] {\n    color: #0D79F2;\n    margin-bottom: 2px;\n    cursor: pointer;\n    text-transform: uppercase;\n}\n.collapsible .heading i[data-v-0dc61230] {\n      margin-right: 5px;\n}\n.collapsible .heading span[data-v-0dc61230] {\n      font-weight: 600;\n}\n.collapsible .content[data-v-0dc61230] {\n    margin-left: 6px;\n    padding: 5px 0 5px 15px;\n    border-left: 2px solid #ddd;\n    max-height: 700px;\n    /* define precise max-height for more smoother transition */\n    height: auto;\n    -webkit-transition: all 0.35s ease-out;\n    transition: all 0.35s ease-out;\n}\n.collapsible .content.documentation[data-v-0dc61230] {\n      max-height: 1900px;\n}\n.collapsible .content .two-col[data-v-0dc61230] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      margin-bottom: 20px;\n      border-bottom: 1px dotted #cfcfcf;\n      padding-bottom: 20px;\n}\n.collapsible .content .two-col[data-v-0dc61230]:last-child {\n        border-bottom: none;\n}\n.collapsible .content .two-col .img-view[data-v-0dc61230] {\n        width: 30%;\n        padding: 0 15px;\n        display: inline-block;\n        text-align: center;\n        position: relative;\n}\n.collapsible .content .two-col .img-view.full[data-v-0dc61230] {\n          width: 100%;\n}\n.collapsible .content .two-col .img-view .thumbnail[data-v-0dc61230] {\n          width: 100%;\n          padding: 15px 0;\n}\n.collapsible .content .two-col .img-view .thumbnail img[data-v-0dc61230] {\n            margin-bottom: 10px;\n            max-height: 150px;\n}\n.collapsible .content .two-col .img-view .thumbnail .fa-image[data-v-0dc61230] {\n            font-size: 80px;\n            color: #c1cede;\n            position: relative;\n            z-index: 1;\n}\n.collapsible .content .two-col .img-view .thumbnail .fa-spinner[data-v-0dc61230] {\n            margin-right: 5px;\n}\n.collapsible .content .two-col .fields[data-v-0dc61230] {\n        width: 70%;\n        display: inline-block;\n}\n.collapsible .content .field-row[data-v-0dc61230] {\n      margin-bottom: 15px;\n}\n.collapsible .content .field-row[data-v-0dc61230]:last-child {\n      margin-bottom: 0;\n}\n.collapsible.collapse .content[data-v-0dc61230] {\n    max-height: 0;\n    overflow: hidden;\n    padding: 0 15px;\n}\n.ssn-ein-label[data-v-0dc61230] {\n  color: #888;\n  font-weight: 600;\n  font-size: 11px;\n  text-transform: uppercase;\n  line-height: 130%;\n  margin-bottom: 10px;\n}\n.w9-form .img-view[data-v-0dc61230] {\n  width: 100%;\n  padding: 0 !important;\n  display: inline-block;\n  text-align: left !important;\n  position: relative;\n}\n.w9-form .img-view .thumbnail[data-v-0dc61230] {\n    width: 100%;\n    padding: 15px 0;\n}\n.w9-form .img-view .thumbnail img[data-v-0dc61230] {\n      margin-bottom: 10px;\n      max-height: 150px;\n}\n.w9-form .img-view .thumbnail .fa-image[data-v-0dc61230] {\n      font-size: 80px;\n      color: #c1cede;\n      position: relative;\n      z-index: 1;\n}\n.w9-form .img-view .thumbnail .fa-spinner[data-v-0dc61230] {\n      margin-right: 5px;\n}\n.w9-form .img-view .thumbnail .button[data-v-0dc61230] {\n      width: 30%;\n      display: block;\n}\n.w9-form .fields[data-v-0dc61230] {\n  width: 70%;\n  display: inline-block;\n}\n.field-row[data-v-0dc61230] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.field-row .col[data-v-0dc61230] {\n    display: inline-block;\n}\n.field-row .col20[data-v-0dc61230] {\n    width: 20%;\n}\n.field-row .col25[data-v-0dc61230] {\n    width: 25%;\n}\n.field-row .col33[data-v-0dc61230] {\n    width: 33%;\n}\n.field-row .col34[data-v-0dc61230] {\n    width: 34%;\n}\n.field-row .col40[data-v-0dc61230] {\n    width: 40%;\n}\n.field-row .col50[data-v-0dc61230] {\n    width: 50%;\n}\n.field-row .col60[data-v-0dc61230] {\n    width: 60%;\n}\n.field-row .col80[data-v-0dc61230] {\n    width: 80%;\n}\n.field-row .col100[data-v-0dc61230] {\n    width: 100%;\n}\n.data-field[data-v-0dc61230] {\n  padding-right: 10px;\n  position: relative;\n}\n.data-field.no-label[data-v-0dc61230] {\n    padding-top: 17px;\n}\n.data-field .label[data-v-0dc61230] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .label.bigger[data-v-0dc61230] {\n      font-size: 14px;\n}\n.data-field .input[data-v-0dc61230] {\n    margin: 5px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-0dc61230] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-0dc61230]:disabled {\n      background: #fbfbfb;\n}\n.data-field select[data-v-0dc61230] {\n    margin-top: 5px;\n    border: 1px solid #ddd;\n    padding: 10px;\n    color: #333;\n    height: 45px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background: url(\"/assets/img/down.png\") no-repeat right 12px;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field select.has-error[data-v-0dc61230] {\n      border-color: #f20d0d;\n}\n.data-field select[data-v-0dc61230]:disabled {\n      background: #fbfbfb;\n}\n.data-field .checkbox[data-v-0dc61230] {\n    line-height: 100%;\n    margin-bottom: 3px;\n}\n.data-field .checkbox.inline[data-v-0dc61230] {\n      display: inline-block;\n      margin: 0 25px 10px 0;\n}\n.data-field .checkbox[data-v-0dc61230]:last-child {\n      margin-bottom: 0;\n}\n.data-field .checkbox input[data-v-0dc61230] {\n      display: inline-block;\n      width: auto;\n      vertical-align: -2px;\n      margin: 0 5px 0 0;\n}\n.data-field .checkbox label[data-v-0dc61230] {\n      font-size: 14px;\n      color: #555;\n      line-height: 150%;\n}\n.data-field .radio[data-v-0dc61230] {\n    display: block;\n    color: #333;\n    font-size: 14px;\n    margin-top: 5px;\n}\n.data-field .radio[data-v-0dc61230]:first-child {\n      margin-top: 5px;\n}\n.data-field .radio input[data-v-0dc61230] {\n      display: inline-block;\n      width: auto;\n      margin: 0 0 0 5px;\n}\n.data-field .error-msg[data-v-0dc61230] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.data-field .df-created[data-v-0dc61230] {\n    text-align: center;\n    letter-spacing: .6px;\n    font-size: 14px;\n    color: #777;\n    line-height: 1;\n    margin-top: 10px;\n}\n.datepicker[data-v-0dc61230] {\n  position: relative;\n  margin-top: 3px;\n  /*top: -10px;*/\n}\n.fa-file-pdf[data-v-0dc61230] {\n  margin-bottom: 10px;\n  color: #f44f4f;\n}\n.reset-password-wrap[data-v-0dc61230] {\n  position: relative;\n  overflow: hidden;\n}\n.mark-test-account[data-v-0dc61230] {\n  color: #333;\n  font-size: 14px;\n  letter-spacing: .3px;\n  border: 1px solid #c5b359;\n  background: #fffbe8;\n  padding: 10px 8px;\n  line-height: 1;\n}\n.mark-test-account label[data-v-0dc61230] {\n    cursor: pointer;\n}\n.mark-test-account input[data-v-0dc61230] {\n    width: auto;\n    display: inline-block;\n    margin: 0 3px 0 0;\n    vertical-align: -1px;\n}\n.documentation-notice[data-v-0dc61230] {\n  margin: 0 0 25px;\n  font-size: 12px;\n  color: #777;\n}\n.documentation-notice i[data-v-0dc61230] {\n    font-weight: 600;\n}\n.input-group[data-v-0dc61230] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  position: relative;\n  margin-bottom: 0;\n}\n.input-group .input-group-label[data-v-0dc61230] {\n    padding: 0 10px;\n    border: 1px solid #cacaca;\n    background: #f4f8f9;\n    color: #0a0a0a;\n    text-align: center;\n    white-space: nowrap;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n.input-group .mobile-input[data-v-0dc61230] {\n    padding-left: 25px;\n    border-radius: 1px;\n    border-left: 0;\n}\n.input-group.small .mobile-input[data-v-0dc61230] {\n    padding-left: 35px;\n}\n.input-group.medium .mobile-input[data-v-0dc61230] {\n    padding-left: 45px;\n}\n.input-group.large .mobile-input[data-v-0dc61230] {\n    padding-left: 55px;\n}\n.input-group.xl .mobile-input[data-v-0dc61230] {\n    padding-left: 65px;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput[data-v-0dc61230]::-webkit-outer-spin-button,\ninput[data-v-0dc61230]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number][data-v-0dc61230] {\n  -moz-appearance: textfield;\n}\n.country-select[data-v-0dc61230] {\n  margin-top: 5px;\n  cursor: pointer;\n  color: #333;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.country-select[data-v-0dc61230]:hover {\n  background-color: #e6e6e6;\n}\n.country-code[data-v-0dc61230] {\n  margin-right: 3px;\n  font-weight: 100;\n}\n@media only screen and (max-width: 430px) {\n.top-part[data-v-0dc61230] {\n    display: block;\n}\n.top-part .driver-id[data-v-0dc61230] {\n      width: 100%;\n}\n.data-field.no-label[data-v-0dc61230] {\n    padding-top: 0;\n}\n.collapsible .content .field-row[data-v-0dc61230] {\n    margin: 0;\n}\n.data-field .label[data-v-0dc61230] {\n    margin-top: 10px;\n}\n.data-field .checkbox[data-v-0dc61230] {\n    margin-top: 5px;\n}\n.data-field.pwd[data-v-0dc61230] {\n    margin-top: 10px;\n}\n.field-row[data-v-0dc61230] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.field-row .col50[data-v-0dc61230], .field-row .col33[data-v-0dc61230], .field-row .col34[data-v-0dc61230] {\n      width: 100%;\n}\n.field-row .col40[data-v-0dc61230] {\n      width: 100%;\n}\n.field-row .password-div[data-v-0dc61230] {\n      margin-top: 20px;\n      text-align: center;\n}\n.collapsible .content[data-v-0dc61230] {\n    max-height: none;\n}\n.collapsible .content .two-col[data-v-0dc61230] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n}\n.collapsible .content .two-col .img-view[data-v-0dc61230] {\n        width: 100%;\n}\n.collapsible .content .two-col .fields[data-v-0dc61230] {\n        width: 100%;\n}\n.collapsible .content.documentation[data-v-0dc61230] {\n      max-height: none;\n}\n.w9-form .img-view .thumbnail[data-v-0dc61230] {\n    text-align: center;\n}\n.w9-form .img-view .thumbnail .button[data-v-0dc61230] {\n      width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__(573);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3699468a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__(1666);
function injectStyle (ssrContext) {
  __webpack_require__(1664)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3699468a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3699468a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1665);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("91ed09d0", content, true, {});

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.field-row[data-v-3699468a] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.field-row .col[data-v-3699468a] {\n    display: inline-block;\n}\n.field-row .col20[data-v-3699468a] {\n    width: 20%;\n}\n.field-row .col25[data-v-3699468a] {\n    width: 25%;\n}\n.field-row .col40[data-v-3699468a] {\n    width: 40%;\n}\n.field-row .col50[data-v-3699468a] {\n    width: 50%;\n}\n.field-row .col60[data-v-3699468a] {\n    width: 60%;\n}\n.field-row .col80[data-v-3699468a] {\n    width: 80%;\n}\n.field-row .col100[data-v-3699468a] {\n    width: 100%;\n}\n.data-field[data-v-3699468a] {\n  padding-right: 10px;\n}\n.data-field.no-label[data-v-3699468a] {\n    padding-top: 17px;\n}\n.data-field .label[data-v-3699468a] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .input[data-v-3699468a] {\n    margin: 5px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-3699468a] {\n      border-color: #f20d0d;\n}\n.data-field .error-msg[data-v-3699468a] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.password-wrap[data-v-3699468a] {\n  padding: 15px;\n  background: #fafafa;\n  border: 1px solid #eaeaea;\n  margin-top: 10px;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.password-wrap .topLabel[data-v-3699468a] {\n    text-align: center;\n    margin: 0;\n    font-size: 14px;\n    color: #333;\n    padding-bottom: 15px;\n}\n.password-wrap .topLabel a[data-v-3699468a] {\n      vertical-align: middle;\n}\n.password-wrap .or-hr[data-v-3699468a] {\n    text-align: center;\n    margin-bottom: 15px;\n    font-size: 14px;\n    color: #444;\n    position: relative;\n}\n.password-wrap .or-hr span[data-v-3699468a] {\n      position: relative;\n      z-index: 2;\n      display: inline-block;\n      padding: 0 15px;\n      background: #fafafa;\n      font-style: italic;\n}\n.password-wrap .or-hr[data-v-3699468a]:before {\n      content: '';\n      border-bottom: 1px solid #eaeaea;\n      position: absolute;\n      width: 100%;\n      height: 1px;\n      top: 50%;\n      left: 0;\n      z-index: 1;\n}\n.password-wrap .message-wrap[data-v-3699468a] {\n    text-align: center;\n    color: #444;\n}\n.password-wrap .message-wrap .fa[data-v-3699468a] {\n      vertical-align: baseline;\n      margin-right: 10px;\n      color: #F20D0D;\n}\n.password-wrap .message-wrap.success .fa[data-v-3699468a] {\n      color: #26d97a;\n}\n.password-wrap.show[data-v-3699468a] {\n    position: relative;\n    -webkit-animation: slide-down-data-v-3699468a .3s ease-out;\n    -moz-animation: slide-down-data-v-3699468a .3s ease-out;\n}\n@-webkit-keyframes slide-down-data-v-3699468a {\n0% {\n    opacity: 0;\n    -webkit-transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n}\n}\n@media only screen and (max-width: 430px) {\n.data-field .label[data-v-3699468a] {\n    margin-top: 10px;\n}\n.field-row[data-v-3699468a] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.field-row .col40[data-v-3699468a] {\n      width: 100%;\n}\n.field-row .col20[data-v-3699468a] {\n      width: 100%;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Provider/ResetPassword.vue"],"names":[],"mappings":";AACA;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,sBAAsB;CACzB;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,YAAY;CACf;AACD;EACE,oBAAoB;CACrB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;EACE,cAAc;EACd,oBAAoB;EACpB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,OAAO;EACP,QAAQ;CACT;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;CACxB;AACD;MACM,uBAAuB;CAC5B;AACD;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;CACtB;AACD;MACM,mBAAmB;MACnB,WAAW;MACX,sBAAsB;MACtB,gBAAgB;MAChB,oBAAoB;MACpB,mBAAmB;CACxB;AACD;MACM,YAAY;MACZ,iCAAiC;MACjC,mBAAmB;MACnB,YAAY;MACZ,YAAY;MACZ,SAAS;MACT,QAAQ;MACR,WAAW;CAChB;AACD;IACI,mBAAmB;IACnB,YAAY;CACf;AACD;MACM,yBAAyB;MACzB,mBAAmB;MACnB,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,2DAA2D;IAC3D,wDAAwD;CAC3D;AACD;AACA;IACI,WAAW;IACX,qCAAqC;CACxC;AACD;IACI,WAAW;IACX,iCAAiC;CACpC;CACA;AACD;AACA;IACI,iBAAiB;CACpB;AACD;IACI,6BAA6B;IAC7B,8BAA8B;QAC1B,2BAA2B;YACvB,uBAAuB;CAClC;AACD;MACM,YAAY;CACjB;AACD;MACM,YAAY;CACjB;CACA","file":"ResetPassword.vue","sourcesContent":["\n.field-row[data-v-3699468a] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.field-row .col[data-v-3699468a] {\n    display: inline-block;\n}\n.field-row .col20[data-v-3699468a] {\n    width: 20%;\n}\n.field-row .col25[data-v-3699468a] {\n    width: 25%;\n}\n.field-row .col40[data-v-3699468a] {\n    width: 40%;\n}\n.field-row .col50[data-v-3699468a] {\n    width: 50%;\n}\n.field-row .col60[data-v-3699468a] {\n    width: 60%;\n}\n.field-row .col80[data-v-3699468a] {\n    width: 80%;\n}\n.field-row .col100[data-v-3699468a] {\n    width: 100%;\n}\n.data-field[data-v-3699468a] {\n  padding-right: 10px;\n}\n.data-field.no-label[data-v-3699468a] {\n    padding-top: 17px;\n}\n.data-field .label[data-v-3699468a] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .input[data-v-3699468a] {\n    margin: 5px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-3699468a] {\n      border-color: #f20d0d;\n}\n.data-field .error-msg[data-v-3699468a] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.password-wrap[data-v-3699468a] {\n  padding: 15px;\n  background: #fafafa;\n  border: 1px solid #eaeaea;\n  margin-top: 10px;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.password-wrap .topLabel[data-v-3699468a] {\n    text-align: center;\n    margin: 0;\n    font-size: 14px;\n    color: #333;\n    padding-bottom: 15px;\n}\n.password-wrap .topLabel a[data-v-3699468a] {\n      vertical-align: middle;\n}\n.password-wrap .or-hr[data-v-3699468a] {\n    text-align: center;\n    margin-bottom: 15px;\n    font-size: 14px;\n    color: #444;\n    position: relative;\n}\n.password-wrap .or-hr span[data-v-3699468a] {\n      position: relative;\n      z-index: 2;\n      display: inline-block;\n      padding: 0 15px;\n      background: #fafafa;\n      font-style: italic;\n}\n.password-wrap .or-hr[data-v-3699468a]:before {\n      content: '';\n      border-bottom: 1px solid #eaeaea;\n      position: absolute;\n      width: 100%;\n      height: 1px;\n      top: 50%;\n      left: 0;\n      z-index: 1;\n}\n.password-wrap .message-wrap[data-v-3699468a] {\n    text-align: center;\n    color: #444;\n}\n.password-wrap .message-wrap .fa[data-v-3699468a] {\n      vertical-align: baseline;\n      margin-right: 10px;\n      color: #F20D0D;\n}\n.password-wrap .message-wrap.success .fa[data-v-3699468a] {\n      color: #26d97a;\n}\n.password-wrap.show[data-v-3699468a] {\n    position: relative;\n    -webkit-animation: slide-down-data-v-3699468a .3s ease-out;\n    -moz-animation: slide-down-data-v-3699468a .3s ease-out;\n}\n@-webkit-keyframes slide-down-data-v-3699468a {\n0% {\n    opacity: 0;\n    -webkit-transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n}\n}\n@media only screen and (max-width: 430px) {\n.data-field .label[data-v-3699468a] {\n    margin-top: 10px;\n}\n.field-row[data-v-3699468a] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.field-row .col40[data-v-3699468a] {\n      width: 100%;\n}\n.field-row .col20[data-v-3699468a] {\n      width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'password-wrap':true, 'show':_vm.showForm || _vm.showMessage}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showForm),expression:"showForm"}]},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col40"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.basicInfo.password')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.value),expression:"password.value"}],class:{'input':true, 'has-error':_vm.password.hasError},attrs:{"type":"password"},domProps:{"value":(_vm.password.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "value", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.password.message))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col40"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.basicInfo.repassword')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.repassword.value),expression:"repassword.value"}],class:{'input':true, 'has-error':_vm.repassword.hasError},attrs:{"type":"password"},domProps:{"value":(_vm.repassword.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.repassword, "value", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.repassword.message))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col20 no-label"},[_c('a',{class:{'button cta warning block':true, 'disabled':_vm.passwordLoading.manual},on:{"click":_vm.resetPassword}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.passwordLoading.manual),expression:"!passwordLoading.manual"}]},[_vm._v(_vm._s(_vm.$t('provider.save')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.passwordLoading.manual),expression:"passwordLoading.manual"}]},[_c('i',{staticClass:"fa fa-spinner fa-spin"})])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMessage),expression:"showMessage"}],class:{'message-wrap':true, 'success':_vm.resetSuccess}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.resetSuccess),expression:"resetSuccess"}],staticClass:"fa fa-check"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.resetSuccess),expression:"!resetSuccess"}],staticClass:"fa fa-times"}),_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"top-part"},[_c('div',{staticClass:"switch"},[_c('div',{class:{'slider':true, 'active':_vm.quickRes.enable, 'disabled':_vm.quickRes.loading || !_vm.editEnabled},on:{"click":_vm.confirmQuickRes}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.quickRes.enable),expression:"quickRes.enable"}],staticClass:"label"},[_vm._v("Quick Res ENABLED")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.quickRes.enable),expression:"!quickRes.enable"}],staticClass:"label"},[_vm._v("Quick Res DISABLED")])]),_vm._v(" "),_c('div',{class:['driver-id', {'filled':!_vm.nextDriverId}]},[_c('label',[_vm._v("VEHICLE #")]),_vm._v(" "),_c('label',{staticClass:"value"},[_vm._v(_vm._s(_vm.accountType.type.toUpperCase())+"-"+_vm._s(_vm.driverId))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.driverId),expression:"driverId"}],class:{'no-access':_vm.driverNumEnabled, 'has-error':!!_vm.driverIdError},attrs:{"type":"text","disabled":_vm.driverIdLoading,"readonly":""},domProps:{"value":(_vm.driverId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.driverId=$event.target.value}}}),_vm._v(" "),(_vm.nextDriverId && _vm.driverNumEnabled)?_c('button',{class:{disabled:_vm.driverIdLoading || !_vm.editEnabled},attrs:{"disabled":!_vm.editEnabled},on:{"click":_vm.saveDriverId}},[(!_vm.driverIdLoading)?_c('span',[_vm._v("SAVE")]):_c('i',{staticClass:"fas fa-spinner fa-spin"})]):_vm._e(),_vm._v(" "),(_vm.driverIdError)?_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.driverIdError))]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.driverIdSuccess),expression:"driverIdSuccess"}],staticClass:"saved"},[_vm._v("Driver ID saved.")])])],1)]),_vm._v(" "),_c('div',{staticClass:"other-data"},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col50 no-label"},[_c('div',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.backgroundSubmitted),expression:"backgroundSubmitted"}],attrs:{"type":"checkbox","id":"backgroundSubmitted","disabled":!_vm.editEnabled},domProps:{"checked":Array.isArray(_vm.backgroundSubmitted)?_vm._i(_vm.backgroundSubmitted,null)>-1:(_vm.backgroundSubmitted)},on:{"change":function($event){var $$a=_vm.backgroundSubmitted,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.backgroundSubmitted=$$a.concat([$$v]))}else{$$i>-1&&(_vm.backgroundSubmitted=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.backgroundSubmitted=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"backgroundSubmitted"}},[_vm._v(_vm._s(_vm.$t('provider.backgroundSubmitted')))])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.backgroundPassed),expression:"backgroundPassed"}],attrs:{"type":"checkbox","id":"backgroundPassed","disabled":!_vm.editEnabled},domProps:{"checked":Array.isArray(_vm.backgroundPassed)?_vm._i(_vm.backgroundPassed,null)>-1:(_vm.backgroundPassed)},on:{"change":function($event){var $$a=_vm.backgroundPassed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.backgroundPassed=$$a.concat([$$v]))}else{$$i>-1&&(_vm.backgroundPassed=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.backgroundPassed=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"backgroundPassed"}},[_vm._v(_vm._s(_vm.$t('provider.backgroundPassed')))])])]),_vm._v(" "),_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.maxRsvp'))+":")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxDailyRsvpIsCustom),expression:"maxDailyRsvpIsCustom"}],staticClass:"input",attrs:{"type":"radio","name":"maxDailyRsvp","value":"0","disabled":!_vm.editEnabled},domProps:{"checked":_vm._q(_vm.maxDailyRsvpIsCustom,"0")},on:{"change":function($event){_vm.maxDailyRsvpIsCustom="0"}}}),_vm._v("\n          "+_vm._s(_vm.$t('provider.default'))+"\n        ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxDailyRsvpIsCustom),expression:"maxDailyRsvpIsCustom"}],staticClass:"input",attrs:{"type":"radio","name":"maxDailyRsvp","value":"1"},domProps:{"checked":_vm._q(_vm.maxDailyRsvpIsCustom,"1")},on:{"change":function($event){_vm.maxDailyRsvpIsCustom="1"}}}),_vm._v("\n          "+_vm._s(_vm.$t('provider.custom'))+"\n            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxDailyRsvp),expression:"maxDailyRsvp"}],staticClass:"input",attrs:{"type":"number","disabled":_vm.maxDailyRsvpIsCustom === '0' || !_vm.editEnabled},domProps:{"value":(_vm.maxDailyRsvp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxDailyRsvp=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{class:{'collapsible':true, 'collapse':!_vm.contentShow.basicInfo}},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.contentShow.basicInfo = !_vm.contentShow.basicInfo}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentShow.basicInfo),expression:"contentShow.basicInfo"}],staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentShow.basicInfo),expression:"!contentShow.basicInfo"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('provider.basicInfo.label')))])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"two-col"},[_c('div',{staticClass:"img-view"},[_c('div',{staticClass:"thumbnail"},[(_vm.basicInfo.img !== '')?_c('a',{attrs:{"href":_vm.basicInfo.img,"target":"_blank"}},[(_vm.isPdfFile(_vm.basicInfo.img))?_c('i',{staticClass:"far fa-file-pdf fa-5x"}):_c('img',{attrs:{"src":_vm.basicInfo.img}})]):_vm._e(),_vm._v(" "),(_vm.basicInfo.img === '')?_c('i',{staticClass:"fa fa-image"}):_vm._e(),_vm._v(" "),(_vm.editEnabled)?_c('a',{class:['button cta xsmall block', _vm.imgUploadButton(_vm.basicInfo.img).class],on:{"click":function($event){return _vm.triggerCropUpload('basicInfo')}}},[_vm._v("\n              "+_vm._s(_vm.imgUploadButton(_vm.basicInfo.img).label)+"\n            ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.basicInfo.firstName'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.basicInfo.firstName),expression:"basicInfo.firstName"}],class:{'input':true, 'has-error':!!_vm.validation.basicInfo.firstName },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.basicInfo.firstName)},on:{"keyup":function($event){return _vm.fieldValidate('basicInfo', 'firstName')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.basicInfo, "firstName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.basicInfo.firstName))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.basicInfo.lastName'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.basicInfo.lastName),expression:"basicInfo.lastName"}],class:{'input':true, 'has-error':!!_vm.validation.basicInfo.lastName },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.basicInfo.lastName)},on:{"keyup":function($event){return _vm.fieldValidate('basicInfo', 'lastName')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.basicInfo, "lastName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.basicInfo.lastName))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.basicInfo.deviceOS'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.basicInfo.deviceOS),expression:"basicInfo.deviceOS"}],class:{'has-error':!!_vm.validation.basicInfo.deviceOS },attrs:{"disabled":!_vm.editEnabled},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.basicInfo, "deviceOS", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.fieldValidate('basicInfo', 'deviceOS')}]}},[_c('option',{attrs:{"value":"Android"}},[_vm._v("Android")]),_vm._v(" "),_c('option',{attrs:{"value":"iOS"}},[_vm._v("iOS")]),_vm._v(" "),_c('option',{attrs:{"value":"Windows"}},[_vm._v("Windows")]),_vm._v(" "),_c('option',{attrs:{"value":"Other"}},[_vm._v("Other")])]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.basicInfo.deviceOS))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.basicInfo.deviceModel')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.basicInfo.deviceModel),expression:"basicInfo.deviceModel"}],class:{'input':true, },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.basicInfo.deviceModel)},on:{"keyup":function($event){return _vm.fieldValidate('basicInfo', 'deviceModel')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.basicInfo, "deviceModel", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.basicInfo.birthday'))+"*")]),_vm._v(" "),(_vm.editEnabled)?_c('datepicker',{class:{'datepicker':true, 'has-error':!!_vm.validation.basicInfo.birthday},attrs:{"selected":_vm.fieldValidate('basicInfo', 'birthday'),"format":_vm.calendarFormat},model:{value:(_vm.basicInfo.birthday),callback:function ($$v) {_vm.$set(_vm.basicInfo, "birthday", $$v)},expression:"basicInfo.birthday"}}):_c('input',{staticClass:"input",attrs:{"type":"text","disabled":!_vm.editEnabled,"disabled":"disabled"},domProps:{"value":_vm.basicInfo.birthday}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.basicInfo.birthday))])],1),_vm._v(" "),_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.basicInfo.language'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.basicInfo.language),expression:"basicInfo.language"}],class:{'has-error':!!_vm.validation.basicInfo.language },attrs:{"disabled":!_vm.editEnabled},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.basicInfo, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.fieldValidate('basicInfo', 'language')}]}},[_c('option',{attrs:{"value":"Chinese"}},[_vm._v("Chinese")]),_vm._v(" "),_c('option',{attrs:{"value":"Deutsch"}},[_vm._v("Deutsch")]),_vm._v(" "),_c('option',{attrs:{"value":"English"}},[_vm._v("English")]),_vm._v(" "),_c('option',{attrs:{"value":"French"}},[_vm._v("French")]),_vm._v(" "),_c('option',{attrs:{"value":"Italian"}},[_vm._v("Italian")]),_vm._v(" "),_c('option',{attrs:{"value":"Japanese"}},[_vm._v("Japanese")]),_vm._v(" "),_c('option',{attrs:{"value":"Korean"}},[_vm._v("Korean")]),_vm._v(" "),_c('option',{attrs:{"value":"Spanish"}},[_vm._v("Spanish")])]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.basicInfo.language))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.basicInfo.email'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.basicInfo.email),expression:"basicInfo.email"}],class:{'input':true, 'has-error':!!_vm.validation.basicInfo.email },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.basicInfo.email)},on:{"keyup":function($event){return _vm.fieldValidate('basicInfo', 'email')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.basicInfo, "email", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.basicInfo.email))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.basicInfo.mobile'))+"*")]),_vm._v(" "),_c('div',{class:{'input-group':true}},[_c('div',{staticClass:"country-select input-group-label",on:{"click":_vm.selectCountry}},[_c('span',{staticClass:"country-code"},[_vm._v("(+"+_vm._s(_vm.callingCode)+") ")]),_vm._v(" "),_c('i',{staticClass:"fa fa-caret-down"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.basicInfo.phoneNumber),expression:"basicInfo.phoneNumber"}],class:{'input':true, 'has-error':!!_vm.validation.basicInfo.phoneNumber },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.basicInfo.phoneNumber)},on:{"keyup":function($event){return _vm.fieldValidate('basicInfo', 'mobile')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.basicInfo, "phoneNumber", $event.target.value)}}})]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.basicInfo.phoneNumber))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100 password-div"},[_c('a',{staticClass:"button cta small",on:{"click":_vm.showResetPassword}},[_vm._v("\n                "+_vm._s(_vm.$t('provider.basicInfo.resetPassword'))+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"reset-password-wrap"},[_c('reset-password',{ref:"resetPassword",attrs:{"show":_vm.showResetPassword}})],1)])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100 mark-test-account"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isTestAcct),expression:"isTestAcct"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isTestAcct)?_vm._i(_vm.isTestAcct,null)>-1:(_vm.isTestAcct)},on:{"change":function($event){var $$a=_vm.isTestAcct,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isTestAcct=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isTestAcct=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isTestAcct=$$c}}}}),_vm._v("\n                Mark as test account\n              ")])])])])])])]),_vm._v(" "),_c('div',{class:{'collapsible':true, 'collapse':!_vm.contentShow.vehicleInfo}},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.contentShow.vehicleInfo = !_vm.contentShow.vehicleInfo}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentShow.vehicleInfo),expression:"contentShow.vehicleInfo"}],staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentShow.vehicleInfo),expression:"!contentShow.vehicleInfo"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('provider.vehicleInfo.label')))])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"two-col"},[_c('div',{staticClass:"img-view"},[_c('div',{staticClass:"thumbnail"},[(_vm.vehicleInfo.img !== '')?_c('a',{attrs:{"href":_vm.vehicleInfo.img,"target":"_blank"}},[(_vm.isPdfFile(_vm.vehicleInfo.img))?_c('i',{staticClass:"far fa-file-pdf fa-5x"}):_c('img',{attrs:{"src":_vm.vehicleInfo.img}})]):_vm._e(),_vm._v(" "),(_vm.vehicleInfo.img === '')?_c('i',{staticClass:"fa fa-image"}):_vm._e(),_vm._v(" "),(_vm.editEnabled)?_c('a',{class:['button cta xsmall block', _vm.imgUploadButton(_vm.vehicleInfo.img).class],on:{"click":function($event){return _vm.triggerCropUpload('vehicleInfo')}}},[_vm._v("\n              "+_vm._s(_vm.imgUploadButton(_vm.vehicleInfo.img).label)+"\n            ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.vehicleInfo.manufacturer'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vehicleInfo.manufacturer),expression:"vehicleInfo.manufacturer"}],class:{'input':true, 'has-error':!!_vm.validation.vehicleInfo.manufacturer },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.vehicleInfo.manufacturer)},on:{"keyup":function($event){return _vm.fieldValidate('vehicleInfo', 'manufacturer')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.vehicleInfo, "manufacturer", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.vehicleInfo.manufacturer))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.vehicleInfo.model'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vehicleInfo.model),expression:"vehicleInfo.model"}],class:{'input':true, 'has-error':!!_vm.validation.vehicleInfo.model },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.vehicleInfo.model)},on:{"keyup":function($event){return _vm.fieldValidate('vehicleInfo', 'model')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.vehicleInfo, "model", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.vehicleInfo.model))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.vehicleInfo.year'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vehicleInfo.year),expression:"vehicleInfo.year"}],class:{'input':true, 'has-error':!!_vm.validation.vehicleInfo.year },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.vehicleInfo.year)},on:{"keyup":function($event){return _vm.fieldValidate('vehicleInfo', 'year')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.vehicleInfo, "year", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.vehicleInfo.year))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.vehicleInfo.type'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.vehicleInfo.type),expression:"vehicleInfo.type"}],class:{'has-error':!!_vm.validation.vehicleInfo.type },attrs:{"disabled":!_vm.editEnabled},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.vehicleInfo, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.fieldValidate('vehicleInfo', 'type')}]}},[_c('option',{attrs:{"value":"Sedan"}},[_vm._v("Sedan")]),_vm._v(" "),_c('option',{attrs:{"value":"Mini SUV"}},[_vm._v("Mini SUV")]),_vm._v(" "),_c('option',{attrs:{"value":"Minivan"}},[_vm._v("Minivan")]),_vm._v(" "),_c('option',{attrs:{"value":"Black Car"}},[_vm._v("Black Car")]),_vm._v(" "),_c('option',{attrs:{"value":"Black SUV"}},[_vm._v("Black SUV")]),_vm._v(" "),_c('option',{attrs:{"value":"Limousine"}},[_vm._v("Limousine")]),_vm._v(" "),_c('option',{attrs:{"value":"Tesla"}},[_vm._v("Tesla")]),_vm._v(" "),_c('option',{attrs:{"value":"Private Van"}},[_vm._v("Private Van")]),_vm._v(" "),_c('option',{attrs:{"value":"Mini Bus"}},[_vm._v("Mini Bus")]),_vm._v(" "),_c('option',{attrs:{"value":"34 Pax Bus"}},[_vm._v("34 Pax Bus")]),_vm._v(" "),_c('option',{attrs:{"value":"56 Pax Bus"}},[_vm._v("56 Pax Bus")])]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.vehicleInfo.type))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.vehicleInfo.licensePlate'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vehicleInfo.licensePlate),expression:"vehicleInfo.licensePlate"}],class:{'input':true, 'has-error':!!_vm.validation.vehicleInfo.licensePlate },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.vehicleInfo.licensePlate)},on:{"keyup":function($event){return _vm.fieldValidate('vehicleInfo', 'licensePlate')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.vehicleInfo, "licensePlate", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.vehicleInfo.licensePlate))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.vehicleInfo.identificationNumber'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vehicleInfo.identificationNumber),expression:"vehicleInfo.identificationNumber"}],class:{'input':true, 'has-error':!!_vm.validation.vehicleInfo.identificationNumber },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.vehicleInfo.identificationNumber)},on:{"keyup":function($event){return _vm.fieldValidate('vehicleInfo', 'identificationNumber')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.vehicleInfo, "identificationNumber", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.vehicleInfo.identificationNumber))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.vehicleInfo.door'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vehicleInfo.door),expression:"vehicleInfo.door"}],class:{'input':true, 'has-error':!!_vm.validation.vehicleInfo.door },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.vehicleInfo.door)},on:{"keyup":function($event){return _vm.fieldValidate('vehicleInfo', 'door')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.vehicleInfo, "door", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.vehicleInfo.door))])]),_vm._v(" "),_c('div',{class:['data-field col', _vm.isDoorToDoorEnabled ? 'col33':'col50']},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.vehicleInfo.capacity'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vehicleInfo.capacity),expression:"vehicleInfo.capacity"}],class:{'input':true, 'has-error':!!_vm.validation.vehicleInfo.capacity },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.vehicleInfo.capacity)},on:{"keyup":function($event){return _vm.fieldValidate('vehicleInfo', 'capacity')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.vehicleInfo, "capacity", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.vehicleInfo.capacity))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDoorToDoorEnabled),expression:"isDoorToDoorEnabled"}],staticClass:"data-field col col34"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.vehicleInfo.boxCapacity'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vehicleInfo.boxCapacity),expression:"vehicleInfo.boxCapacity"}],class:{'input':true, 'has-error':!!_vm.validation.vehicleInfo.boxCapacity },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.vehicleInfo.boxCapacity)},on:{"keyup":function($event){return _vm.fieldValidate('vehicleInfo', 'boxCapacity')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.vehicleInfo, "boxCapacity", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.vehicleInfo.boxCapacity))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100 pwd"},[_c('div',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vehicleInfo.wheelchair),expression:"vehicleInfo.wheelchair"}],attrs:{"type":"checkbox","id":"wheelchair","disabled":!_vm.editEnabled},domProps:{"checked":Array.isArray(_vm.vehicleInfo.wheelchair)?_vm._i(_vm.vehicleInfo.wheelchair,null)>-1:(_vm.vehicleInfo.wheelchair)},on:{"change":function($event){var $$a=_vm.vehicleInfo.wheelchair,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.vehicleInfo, "wheelchair", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.vehicleInfo, "wheelchair", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.vehicleInfo, "wheelchair", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"wheelchair"}},[_vm._v(_vm._s(_vm.$t('provider.vehicleInfo.wheelchair')))])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vehicleInfo.serviceDog),expression:"vehicleInfo.serviceDog"}],attrs:{"type":"checkbox","id":"serviceDog","disabled":!_vm.editEnabled},domProps:{"checked":Array.isArray(_vm.vehicleInfo.serviceDog)?_vm._i(_vm.vehicleInfo.serviceDog,null)>-1:(_vm.vehicleInfo.serviceDog)},on:{"change":function($event){var $$a=_vm.vehicleInfo.serviceDog,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.vehicleInfo, "serviceDog", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.vehicleInfo, "serviceDog", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.vehicleInfo, "serviceDog", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"serviceDog"}},[_vm._v(_vm._s(_vm.$t('provider.vehicleInfo.serviceDog')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"two-col"},[_c('div',{staticClass:"img-view"},[_c('div',{staticClass:"thumbnail"},[(_vm.documentation.vehicleRegistrationImg !== '')?_c('a',{attrs:{"href":_vm.documentation.vehicleRegistrationImg,"target":"_blank"}},[(_vm.isPdfFile(_vm.documentation.vehicleRegistrationImg))?_c('i',{staticClass:"far fa-file-pdf fa-5x"}):_c('img',{attrs:{"src":_vm.documentation.vehicleRegistrationImg}})]):_vm._e(),_vm._v(" "),(_vm.documentation.vehicleRegistrationImg === '')?_c('i',{staticClass:"fa fa-image"}):_vm._e(),_vm._v(" "),(_vm.editEnabled)?_c('a',{class:['button cta xsmall block', _vm.imgUploadButton(_vm.documentation.vehicleRegistrationImg).class, {'disabled':_vm.fileLoading.vehicleRegistrationImg}],on:{"click":function($event){return _vm.triggerUploadInput('vehicleRegistrationImg')}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.fileLoading.vehicleRegistrationImg),expression:"!fileLoading.vehicleRegistrationImg"}]},[_vm._v(_vm._s(_vm.imgUploadButton(_vm.documentation.vehicleRegistrationImg).label))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.fileLoading.vehicleRegistrationImg),expression:"fileLoading.vehicleRegistrationImg"}]},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v("\n                "+_vm._s(_vm.$t('provider.uploading'))+"\n              ")])]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"vehicleRegistrationImg",attrs:{"type":"file","accept":"image/*,application/pdf"},on:{"change":_vm.uploadImg}})])]),_vm._v(" "),_c('div',{staticClass:"fields"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.documentation.drivingRecordExp')))]),_vm._v(" "),(_vm.editEnabled)?_c('datepicker',{staticClass:"datepicker",attrs:{"format":_vm.calendarFormat},model:{value:(_vm.documentation.vehicleRegistrationExp),callback:function ($$v) {_vm.$set(_vm.documentation, "vehicleRegistrationExp", $$v)},expression:"documentation.vehicleRegistrationExp"}}):_c('input',{staticClass:"input",attrs:{"type":"text","disabled":"disabled"},domProps:{"value":_vm.documentation.vehicleRegistrationExp}})],1)])])])])]),_vm._v(" "),_c('div',{class:{'collapsible':true, 'collapse':!_vm.contentShow.accountType}},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.contentShow.accountType = !_vm.contentShow.accountType}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentShow.accountType),expression:"contentShow.accountType"}],staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentShow.accountType),expression:"!contentShow.accountType"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('provider.accountType.label')))])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('label',{staticClass:"radio"},[_c('input',{staticClass:"input",attrs:{"type":"radio","name":"override","disabled":!_vm.editEnabled},domProps:{"checked":_vm.accountType.type === 'tnc'},on:{"click":function($event){return _vm.updateAccountType('tnc')}}}),_vm._v("\n            TNC\n          ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{staticClass:"input",attrs:{"type":"radio","name":"override","disabled":!_vm.editEnabled},domProps:{"checked":_vm.accountType.type === 'tcp'},on:{"click":function($event){return _vm.updateAccountType('tcp')}}}),_vm._v("\n            TCP\n          ")]),_vm._v(" "),(!_vm.useOldQuatation)?_c('label',{staticClass:"radio"},[_c('input',{staticClass:"input",attrs:{"type":"radio","name":"override","disabled":!_vm.editEnabled},domProps:{"checked":_vm.accountType.type === 'psc'},on:{"click":function($event){return _vm.updateAccountType('psc')}}}),_vm._v("\n            PSC\n          ")]):_vm._e()])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:((_vm.accountType.type === 'tcp' || ((_vm.accountType.type === 'tnc' || _vm.accountType.type === 'psc') && _vm.enableTCPDocToTNC))),expression:"(accountType.type === 'tcp' || ((accountType.type === 'tnc' || accountType.type === 'psc') && enableTCPDocToTNC))"}],class:{'collapsible':true, 'collapse':!_vm.contentShow.businessInfo}},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.contentShow.businessInfo = !_vm.contentShow.businessInfo}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentShow.businessInfo),expression:"contentShow.businessInfo"}],staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentShow.businessInfo),expression:"!contentShow.businessInfo"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('provider.businessInfo.label')))])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"two-col"},[_c('div',{staticClass:"img-view"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.businessInfo.type === 'Sole Proprietorship'),expression:"businessInfo.type === 'Sole Proprietorship'"}],staticClass:"thumbnail"},[(_vm.businessInfo.ssnImg !== '')?_c('a',{attrs:{"href":_vm.businessInfo.ssnImg,"target":"_blank"}},[(_vm.isPdfFile(_vm.businessInfo.ssnImg))?_c('i',{staticClass:"far fa-file-pdf fa-5x"}):_c('img',{attrs:{"src":_vm.businessInfo.ssnImg}})]):_vm._e(),_vm._v(" "),(_vm.businessInfo.ssnImg === '')?_c('i',{staticClass:"fa fa-image"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ssn-ein-label"},[_vm._v("SSN Image")]),_vm._v(" "),(_vm.editEnabled)?_c('a',{class:['button cta xsmall block', _vm.imgUploadButton(_vm.businessInfo.ssnImg).class, {'disabled':_vm.fileLoading.ssnImg}],on:{"click":function($event){return _vm.triggerUploadInput('ssnImg')}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.fileLoading.ssnImg),expression:"!fileLoading.ssnImg"}]},[_vm._v(_vm._s(_vm.imgUploadButton(_vm.businessInfo.ssnImg).label))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.fileLoading.ssnImg),expression:"fileLoading.ssnImg"}]},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v("\n                "+_vm._s(_vm.$t('provider.uploading'))+"\n              ")])]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"ssnImg",attrs:{"type":"file","accept":"image/*,application/pdf"},on:{"change":_vm.uploadImg}})]),_vm._v(" "),_c('div',{staticClass:"thumbnail"},[(_vm.businessInfo.einImg !== '')?_c('a',{attrs:{"href":_vm.businessInfo.einImg,"target":"_blank"}},[(_vm.isPdfFile(_vm.businessInfo.einImg))?_c('i',{staticClass:"far fa-file-pdf fa-5x"}):_c('img',{attrs:{"src":_vm.businessInfo.einImg}})]):_vm._e(),_vm._v(" "),(_vm.businessInfo.einImg === '')?_c('i',{staticClass:"fa fa-image"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ssn-ein-label"},[_vm._v("EIN Image")]),_vm._v(" "),(_vm.editEnabled)?_c('a',{class:['button cta xsmall block', _vm.imgUploadButton(_vm.businessInfo.einImg).class, {'disabled':_vm.fileLoading.einImg}],on:{"click":function($event){return _vm.triggerUploadInput('einImg')}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.fileLoading.einImg),expression:"!fileLoading.einImg"}]},[_vm._v(_vm._s(_vm.imgUploadButton(_vm.businessInfo.einImg).label))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.fileLoading.einImg),expression:"fileLoading.einImg"}]},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v("\n                "+_vm._s(_vm.$t('provider.uploading'))+"\n              ")])]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"einImg",attrs:{"type":"file","accept":"image/*,application/pdf"},on:{"change":_vm.uploadImg}})])]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.businessInfo.name'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessInfo.name),expression:"businessInfo.name"}],class:{'input':true, 'has-error':!!_vm.validation.businessInfo.name },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.businessInfo.name)},on:{"keyup":function($event){return _vm.fieldValidate('businessInfo', 'name')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.businessInfo, "name", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.businessInfo.name))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.businessInfo.type'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessInfo.type),expression:"businessInfo.type"}],class:{'has-error':!!_vm.validation.businessInfo.type },attrs:{"disabled":!_vm.editEnabled},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.businessInfo, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.fieldValidate('businessInfo', 'type')}]}},[_c('option',{attrs:{"value":"Sole Proprietorship"}},[_vm._v("Sole Proprietorship")]),_vm._v(" "),_c('option',{attrs:{"value":"C Corp"}},[_vm._v("C Corp")]),_vm._v(" "),_c('option',{attrs:{"value":"S Corp"}},[_vm._v("S Corp")]),_vm._v(" "),_c('option',{attrs:{"value":"LLC"}},[_vm._v("LLC")])]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.businessInfo.type))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[(_vm.businessInfo.type === 'Sole Proprietorship')?_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v("Social Security Number (SSN)*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessInfo.ssn),expression:"businessInfo.ssn"}],class:{'input':true, 'has-error':!!_vm.validation.businessInfo.ssn },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.businessInfo.ssn)},on:{"focus":function($event){return _vm.focusChangeCheck('ssn')},"keyup":function($event){return _vm.fieldValidate('businessInfo', 'ssn')},"keypress":_vm.isNumber,"blur":function($event){return _vm.changeCheck('ssn')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.businessInfo, "ssn", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.businessInfo.ssn))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v("Employer ID Number (EIN)*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessInfo.ein),expression:"businessInfo.ein"}],class:{'input':true, 'has-error':!!_vm.validation.businessInfo.ein },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.businessInfo.ein)},on:{"keyup":function($event){return _vm.fieldValidate('businessInfo', 'ein')},"focus":function($event){return _vm.focusChangeCheck('ein')},"blur":function($event){return _vm.changeCheck('ein')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.businessInfo, "ein", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.businessInfo.ein))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.businessInfo.address1'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessInfo.address1),expression:"businessInfo.address1"}],class:{'input':true, 'has-error':!!_vm.validation.businessInfo.address1 },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.businessInfo.address1)},on:{"keyup":function($event){return _vm.fieldValidate('businessInfo', 'address1')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.businessInfo, "address1", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.businessInfo.address1))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.businessInfo.address2')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessInfo.address2),expression:"businessInfo.address2"}],staticClass:"input",attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.businessInfo.address2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.businessInfo, "address2", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.businessInfo.address2))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.businessInfo.city'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessInfo.city),expression:"businessInfo.city"}],class:{'input':true, 'has-error':!!_vm.validation.businessInfo.city },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.businessInfo.city)},on:{"keyup":function($event){return _vm.fieldValidate('businessInfo', 'city')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.businessInfo, "city", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.businessInfo.city))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.businessInfo.country'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessInfo.country),expression:"businessInfo.country"}],class:{'has-error':!!_vm.validation.businessInfo.country },attrs:{"disabled":!_vm.editEnabled},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.businessInfo, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.fieldValidate('businessInfo', 'country')}]}},_vm._l((_vm.countries.all),function(country){return _c('option',[_vm._v(_vm._s(country.name))])}),0),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.businessInfo.country))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.businessInfo.country === 'United States'),expression:"businessInfo.country === 'United States'"}],staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.businessInfo.state'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessInfo.state),expression:"businessInfo.state"}],class:{'has-error':!!_vm.validation.businessInfo.state },attrs:{"disabled":!_vm.editEnabled},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.businessInfo, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.fieldValidate('businessInfo', 'state')}]}},_vm._l((_vm.states),function(state){return _c('option',{domProps:{"value":state.value}},[_vm._v(_vm._s(state.label))])}),0),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.businessInfo.state))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.businessInfo.zip'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessInfo.zip),expression:"businessInfo.zip"}],class:{'input':true, 'has-error':!!_vm.validation.businessInfo.zip },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.businessInfo.zip)},on:{"keyup":function($event){return _vm.fieldValidate('businessInfo', 'zip')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.businessInfo, "zip", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.businessInfo.zip))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100 w9-form"},[_c('div',{staticClass:"label"},[_vm._v("W-9 Form*")]),_vm._v(" "),_c('div',{staticClass:"img-view full"},[_c('div',{staticClass:"thumbnail"},[(_vm.businessInfo.w9fileImg !== '')?_c('a',{attrs:{"href":_vm.businessInfo.w9fileImg,"target":"_blank"}},[(_vm.isPdfFile(_vm.businessInfo.w9fileImg))?_c('i',{staticClass:"far fa-file-pdf fa-5x"}):_c('img',{attrs:{"src":_vm.businessInfo.w9fileImg}})]):_vm._e(),_vm._v(" "),(_vm.businessInfo.w9fileImg === '')?_c('i',{staticClass:"fa fa-image"}):_vm._e(),_vm._v(" "),(_vm.editEnabled)?_c('a',{class:['button cta xsmall block', _vm.imgUploadButton(_vm.businessInfo.w9fileImg).class, {'disabled':_vm.fileLoading.w9fileImg}],on:{"click":function($event){return _vm.triggerUploadInput('w9fileImg')}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.fileLoading.w9fileImg),expression:"!fileLoading.w9fileImg"}]},[_vm._v(_vm._s(_vm.imgUploadButton(_vm.businessInfo.w9fileImg).form))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.fileLoading.w9fileImg),expression:"fileLoading.w9fileImg"}]},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v("\n                      "+_vm._s(_vm.$t('provider.uploading'))+"\n                    ")])]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"w9fileImg",attrs:{"type":"file","accept":"image/*,application/pdf"},on:{"change":_vm.uploadImg}})])])])])])])])]),_vm._v(" "),_c('div',{class:{'collapsible':true, 'collapse':!_vm.contentShow.documentation}},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.contentShow.documentation = !_vm.contentShow.documentation}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentShow.documentation),expression:"contentShow.documentation"}],staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentShow.documentation),expression:"!contentShow.documentation"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('provider.documentation.label')))])]),_vm._v(" "),_c('div',{staticClass:"content documentation"},[_c('p',{staticClass:"documentation-notice",domProps:{"innerHTML":_vm._s(_vm.$t('provider.documenationNotice'))}}),_vm._v(" "),_c('div',{staticClass:"two-col"},[_c('div',{staticClass:"img-view"},[_c('div',{staticClass:"thumbnail"},[(_vm.documentation.insuranceImg !== '')?_c('a',{attrs:{"href":_vm.documentation.insuranceImg,"target":"_blank"}},[(_vm.isPdfFile(_vm.documentation.insuranceImg))?_c('i',{staticClass:"far fa-file-pdf fa-5x"}):_c('img',{attrs:{"src":_vm.documentation.insuranceImg}})]):_vm._e(),_vm._v(" "),(_vm.documentation.insuranceImg === '')?_c('i',{staticClass:"fa fa-image"}):_vm._e(),_vm._v(" "),(_vm.editEnabled)?_c('a',{class:['button cta xsmall block', _vm.imgUploadButton(_vm.documentation.insuranceImg).class, {'disabled':_vm.fileLoading.insuranceImg}],on:{"click":function($event){return _vm.triggerUploadInput('insuranceImg')}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.fileLoading.insuranceImg),expression:"!fileLoading.insuranceImg"}]},[_vm._v(_vm._s(_vm.imgUploadButton(_vm.documentation.insuranceImg).label))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.fileLoading.insuranceImg),expression:"fileLoading.insuranceImg"}]},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v("\n                "+_vm._s(_vm.$t('provider.uploading'))+"\n              ")])]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"insuranceImg",attrs:{"type":"file","accept":"image/*,application/pdf,application/pdf"},on:{"change":_vm.uploadImg}})])]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.documentation.insuranceCompany')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.documentation.insuranceCompany),expression:"documentation.insuranceCompany"}],staticClass:"input",attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.documentation.insuranceCompany)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.documentation, "insuranceCompany", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.documentation.insurancePolicy'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.documentation.insurancePolicy),expression:"documentation.insurancePolicy"}],class:{'input':true, 'has-error':!!_vm.validation.documentation.insurancePolicy },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.documentation.insurancePolicy)},on:{"keyup":function($event){return _vm.fieldValidate('documentation', 'insurancePolicy')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.documentation, "insurancePolicy", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.documentation.insurancePolicy))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.documentation.insuranceExp'))+"*")]),_vm._v(" "),(_vm.editEnabled)?_c('datepicker',{class:{'datepicker':true, 'has-error':!!_vm.validation.documentation.insuranceExp},attrs:{"selected":_vm.fieldValidate('documentation', 'insuranceExp'),"format":_vm.calendarFormat},model:{value:(_vm.documentation.insuranceExp),callback:function ($$v) {_vm.$set(_vm.documentation, "insuranceExp", $$v)},expression:"documentation.insuranceExp"}}):_c('input',{staticClass:"input",attrs:{"type":"text","disabled":"disabled"},domProps:{"value":_vm.documentation.insuranceExp}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.documentation.insuranceExp))])],1)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accountType.type === 'tcp' || ((_vm.accountType.type === 'tnc' || _vm.accountType.type === 'psc') && _vm.enableTCPDocToTNC)),expression:"accountType.type === 'tcp' || ((accountType.type === 'tnc' || accountType.type === 'psc') && enableTCPDocToTNC)"}],staticClass:"two-col"},[_c('div',{staticClass:"img-view"},[_c('div',{staticClass:"thumbnail"},[(_vm.documentation.cityLicenseImg !== '')?_c('a',{attrs:{"href":_vm.documentation.cityLicenseImg,"target":"_blank"}},[(_vm.isPdfFile(_vm.documentation.cityLicenseImg))?_c('i',{staticClass:"far fa-file-pdf fa-5x"}):_c('img',{attrs:{"src":_vm.documentation.cityLicenseImg}})]):_vm._e(),_vm._v(" "),(_vm.documentation.insuranceImg === '')?_c('i',{staticClass:"fa fa-image"}):_vm._e(),_vm._v(" "),(_vm.editEnabled)?_c('a',{class:['button cta xsmall block', _vm.imgUploadButton(_vm.documentation.cityLicenseImg).class, {'disabled':_vm.fileLoading.cityLicenseImg}],on:{"click":function($event){return _vm.triggerUploadInput('cityLicenseImg')}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.fileLoading.cityLicenseImg),expression:"!fileLoading.cityLicenseImg"}]},[_vm._v(_vm._s(_vm.imgUploadButton(_vm.documentation.cityLicenseImg).label))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.fileLoading.cityLicenseImg),expression:"fileLoading.cityLicenseImg"}]},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v("\n                "+_vm._s(_vm.$t('provider.uploading'))+"\n              ")])]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"cityLicenseImg",attrs:{"type":"file","accept":"image/*,application/pdf"},on:{"change":_vm.uploadImg}})])]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.documentation.cityLicense'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.documentation.cityLicense),expression:"documentation.cityLicense"}],class:{'input':true, 'has-error':!!_vm.validation.documentation.cityLicense },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.documentation.cityLicense)},on:{"keyup":function($event){return _vm.fieldValidate('documentation', 'cityLicense')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.documentation, "cityLicense", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.documentation.cityLicense))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.documentation.cityLicenseExp'))+"*")]),_vm._v(" "),(_vm.editEnabled)?_c('datepicker',{class:{'datepicker':true, 'has-error':!!_vm.validation.documentation.cityLicenseExp},attrs:{"selected":_vm.fieldValidate('documentation', 'cityLicenseExp'),"format":_vm.calendarFormat},model:{value:(_vm.documentation.cityLicenseExp),callback:function ($$v) {_vm.$set(_vm.documentation, "cityLicenseExp", $$v)},expression:"documentation.cityLicenseExp"}}):_c('input',{staticClass:"input",attrs:{"type":"text","disabled":"disabled"},domProps:{"value":_vm.documentation.cityLicenseExp}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.documentation.cityLicenseExp))])],1)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accountType.type === 'tcp'),expression:"accountType.type === 'tcp'"}],staticClass:"two-col"},[_c('div',{staticClass:"img-view"},[_c('div',{staticClass:"thumbnail"},[(_vm.documentation.tcpPermitImg !== '')?_c('a',{attrs:{"href":_vm.documentation.tcpPermitImg,"target":"_blank"}},[(_vm.isPdfFile(_vm.documentation.tcpPermitImg))?_c('i',{staticClass:"far fa-file-pdf fa-5x"}):_c('img',{attrs:{"src":_vm.documentation.tcpPermitImg}})]):_vm._e(),_vm._v(" "),(_vm.documentation.tcpPermitImg === '')?_c('i',{staticClass:"fa fa-image"}):_vm._e(),_vm._v(" "),(_vm.editEnabled)?_c('a',{class:['button cta xsmall block', _vm.imgUploadButton(_vm.documentation.tcpPermitImg).class, {'disabled':_vm.fileLoading.tcpPermitImg}],on:{"click":function($event){return _vm.triggerUploadInput('tcpPermitImg')}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.fileLoading.tcpPermitImg),expression:"!fileLoading.tcpPermitImg"}]},[_vm._v(_vm._s(_vm.imgUploadButton(_vm.documentation.tcpPermitImg).label))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.fileLoading.tcpPermitImg),expression:"fileLoading.tcpPermitImg"}]},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v("\n                "+_vm._s(_vm.$t('provider.uploading'))+"\n              ")])]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"tcpPermitImg",attrs:{"type":"file","accept":"image/*,application/pdf"},on:{"change":_vm.uploadImg}})])]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.documentation.tcpPermit'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.documentation.tcpPermit),expression:"documentation.tcpPermit"}],class:{'input':true, 'has-error':!!_vm.validation.documentation.tcpPermit },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.documentation.tcpPermit)},on:{"keyup":function($event){return _vm.fieldValidate('documentation', 'tcpPermit')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.documentation, "tcpPermit", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.documentation.tcpPermit))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.documentation.tcpPermitExp'))+"*")]),_vm._v(" "),(_vm.editEnabled)?_c('datepicker',{class:{'datepicker':true, 'has-error':!!_vm.validation.documentation.tcpPermitExp},attrs:{"selected":_vm.fieldValidate('documentation', 'tcpPermitExp'),"format":_vm.calendarFormat},model:{value:(_vm.documentation.tcpPermitExp),callback:function ($$v) {_vm.$set(_vm.documentation, "tcpPermitExp", $$v)},expression:"documentation.tcpPermitExp"}}):_c('input',{staticClass:"input",attrs:{"type":"text","disabled":"disabled"},domProps:{"value":_vm.documentation.tcpPermitExp}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.documentation.tcpPermitExp))])],1)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accountType.type === 'tcp'),expression:"accountType.type === 'tcp'"}],staticClass:"two-col"},[_c('div',{staticClass:"img-view"},[_c('div',{staticClass:"thumbnail"},[(_vm.documentation.airportPermitImg !== '')?_c('a',{attrs:{"href":_vm.documentation.airportPermitImg,"target":"_blank"}},[(_vm.isPdfFile(_vm.documentation.airportPermitImg))?_c('i',{staticClass:"far fa-file-pdf fa-5x"}):_c('img',{attrs:{"src":_vm.documentation.airportPermitImg}})]):_vm._e(),_vm._v(" "),(_vm.documentation.airportPermitImg === '')?_c('i',{staticClass:"fa fa-image"}):_vm._e(),_vm._v(" "),(_vm.editEnabled)?_c('a',{class:['button cta xsmall block', _vm.imgUploadButton(_vm.documentation.airportPermitImg).class, {'disabled':_vm.fileLoading.airportPermitImg}],on:{"click":function($event){return _vm.triggerUploadInput('airportPermitImg')}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.fileLoading.airportPermitImg),expression:"!fileLoading.airportPermitImg"}]},[_vm._v(_vm._s(_vm.imgUploadButton(_vm.documentation.airportPermitImg).label))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.fileLoading.airportPermitImg),expression:"fileLoading.airportPermitImg"}]},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v("\n                "+_vm._s(_vm.$t('provider.uploading'))+"\n              ")])]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"airportPermitImg",attrs:{"type":"file","accept":"image/*,application/pdf"},on:{"change":_vm.uploadImg}})])]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.documentation.airportPermit'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.documentation.airportPermit),expression:"documentation.airportPermit"}],class:{'input':true, 'has-error':!!_vm.validation.documentation.airportPermit },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.documentation.airportPermit)},on:{"keyup":function($event){return _vm.fieldValidate('documentation', 'airportPermit')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.documentation, "airportPermit", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.documentation.airportPermit))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.documentation.airportPermitExp'))+"*")]),_vm._v(" "),(_vm.editEnabled)?_c('datepicker',{class:{'datepicker':true, 'has-error':!!_vm.validation.documentation.airportPermitExp},attrs:{"selected":_vm.fieldValidate('documentation', 'airportPermitExp'),"format":_vm.calendarFormat},model:{value:(_vm.documentation.airportPermitExp),callback:function ($$v) {_vm.$set(_vm.documentation, "airportPermitExp", $$v)},expression:"documentation.airportPermitExp"}}):_c('input',{staticClass:"input",attrs:{"type":"text","disabled":"disabled"},domProps:{"value":_vm.documentation.airportPermitExp}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.documentation.airportPermitExp))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"two-col"},[_c('div',{staticClass:"img-view"},[_c('div',{staticClass:"thumbnail"},[(_vm.documentation.driversLicenseImg !== '')?_c('a',{attrs:{"href":_vm.documentation.driversLicenseImg,"target":"_blank"}},[(_vm.isPdfFile(_vm.documentation.driversLicenseImg))?_c('i',{staticClass:"far fa-file-pdf fa-5x"}):_c('img',{attrs:{"src":_vm.documentation.driversLicenseImg}})]):_vm._e(),_vm._v(" "),(_vm.documentation.driversLicenseImg === '')?_c('i',{staticClass:"fa fa-image"}):_vm._e(),_vm._v(" "),(_vm.editEnabled)?_c('a',{class:['button cta xsmall block', _vm.imgUploadButton(_vm.documentation.driversLicenseImg).class, {'disabled':_vm.fileLoading.driversLicenseImg}],on:{"click":function($event){return _vm.triggerUploadInput('driversLicenseImg')}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.fileLoading.driversLicenseImg),expression:"!fileLoading.driversLicenseImg"}]},[_vm._v(_vm._s(_vm.imgUploadButton(_vm.documentation.driversLicenseImg).label))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.fileLoading.driversLicenseImg),expression:"fileLoading.driversLicenseImg"}]},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v("\n                "+_vm._s(_vm.$t('provider.uploading'))+"\n              ")])]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"driversLicenseImg",attrs:{"type":"file","accept":"image/*,application/pdf"},on:{"change":_vm.uploadImg}})])]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.documentation.driversLicense'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.documentation.driversLicense),expression:"documentation.driversLicense"}],class:{'input':true, 'has-error':!!_vm.validation.documentation.driversLicense },attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.documentation.driversLicense)},on:{"keyup":function($event){return _vm.fieldValidate('documentation', 'driversLicense')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.documentation, "driversLicense", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.documentation.driversLicense))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.documentation.driversLicenseExp'))+"*")]),_vm._v(" "),(_vm.editEnabled)?_c('datepicker',{class:{'datepicker':true, 'has-error':!!_vm.validation.documentation.driversLicenseExp},attrs:{"selected":_vm.fieldValidate('documentation', 'driversLicenseExp'),"format":_vm.calendarFormat},model:{value:(_vm.documentation.driversLicenseExp),callback:function ($$v) {_vm.$set(_vm.documentation, "driversLicenseExp", $$v)},expression:"documentation.driversLicenseExp"}}):_c('input',{staticClass:"input",attrs:{"type":"text","disabled":"disabled"},domProps:{"value":_vm.documentation.driversLicenseExp}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.documentation.driversLicenseExp))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"two-col"},[_c('div',{staticClass:"img-view"},[_c('div',{staticClass:"thumbnail"},[(_vm.documentation.vehicleInspectionImg !== '')?_c('a',{attrs:{"href":_vm.documentation.vehicleInspectionImg,"target":"_blank"}},[(_vm.isPdfFile(_vm.documentation.vehicleInspectionImg))?_c('i',{staticClass:"far fa-file-pdf fa-5x"}):_c('img',{attrs:{"src":_vm.documentation.vehicleInspectionImg}})]):_vm._e(),_vm._v(" "),(_vm.documentation.vehicleInspectionImg === '')?_c('i',{staticClass:"fa fa-image"}):_vm._e(),_vm._v(" "),(_vm.editEnabled)?_c('a',{class:['button cta xsmall block', _vm.imgUploadButton(_vm.documentation.vehicleInspectionImg).class, {'disabled':_vm.fileLoading.vehicleInspectionImg}],on:{"click":function($event){return _vm.triggerUploadInput('vehicleInspectionImg')}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.fileLoading.vehicleInspectionImg),expression:"!fileLoading.vehicleInspectionImg"}]},[_vm._v(_vm._s(_vm.imgUploadButton(_vm.documentation.vehicleInspectionImg).label))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.fileLoading.vehicleInspectionImg),expression:"fileLoading.vehicleInspectionImg"}]},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v("\n                "+_vm._s(_vm.$t('provider.uploading'))+"\n              ")])]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"vehicleInspectionImg",attrs:{"type":"file","accept":"image/*,application/pdf"},on:{"change":_vm.uploadImg}})])]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.documentation.vehicleInspection')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.documentation.vehicleInspection),expression:"documentation.vehicleInspection"}],staticClass:"input",attrs:{"type":"text","disabled":!_vm.editEnabled},domProps:{"value":(_vm.documentation.vehicleInspection)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.documentation, "vehicleInspection", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.documentation.vehicleInspectionExp')))]),_vm._v(" "),(_vm.editEnabled)?_c('datepicker',{staticClass:"datepicker",attrs:{"format":_vm.calendarFormat},model:{value:(_vm.documentation.vehicleInspectionExp),callback:function ($$v) {_vm.$set(_vm.documentation, "vehicleInspectionExp", $$v)},expression:"documentation.vehicleInspectionExp"}}):_c('input',{staticClass:"input",attrs:{"type":"text","disabled":"disabled"},domProps:{"value":_vm.documentation.vehicleInspectionExp}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"two-col"},[_c('div',{staticClass:"img-view"},[_c('div',{staticClass:"thumbnail"},[(_vm.documentation.drivingRecordImg !== '')?_c('a',{attrs:{"href":_vm.documentation.drivingRecordImg,"target":"_blank"}},[(_vm.isPdfFile(_vm.documentation.drivingRecordImg))?_c('i',{staticClass:"far fa-file-pdf fa-5x"}):_c('img',{attrs:{"src":_vm.documentation.drivingRecordImg}})]):_vm._e(),_vm._v(" "),(_vm.documentation.drivingRecordImg === '')?_c('i',{staticClass:"fa fa-image"}):_vm._e(),_vm._v(" "),(_vm.editEnabled)?_c('a',{class:['button cta xsmall block', _vm.imgUploadButton(_vm.documentation.drivingRecordImg).class, {'disabled':_vm.fileLoading.drivingRecordImg}],on:{"click":function($event){return _vm.triggerUploadInput('drivingRecordImg')}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.fileLoading.drivingRecordImg),expression:"!fileLoading.drivingRecordImg"}]},[_vm._v(_vm._s(_vm.imgUploadButton(_vm.documentation.drivingRecordImg).label))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.fileLoading.drivingRecordImg),expression:"fileLoading.drivingRecordImg"}]},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v("\n                "+_vm._s(_vm.$t('provider.uploading'))+"\n              ")])]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"drivingRecordImg",attrs:{"type":"file","accept":"image/*,application/pdf"},on:{"change":_vm.uploadImg}})])]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.documentation.drivingRecord')))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.documentation.drivingRecordExp')))]),_vm._v(" "),(_vm.editEnabled)?_c('datepicker',{staticClass:"datepicker",attrs:{"format":_vm.calendarFormat},model:{value:(_vm.documentation.drivingRecordExp),callback:function ($$v) {_vm.$set(_vm.documentation, "drivingRecordExp", $$v)},expression:"documentation.drivingRecordExp"}}):_c('input',{staticClass:"input",attrs:{"type":"text","disabled":"disabled"},domProps:{"value":_vm.documentation.drivingRecordExp}})],1)])])]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}}),_vm._v(" "),_c('div',{class:{'collapsible':true, 'collapse':!_vm.contentShow.eligibility}},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.contentShow.eligibility = !_vm.contentShow.eligibility}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentShow.eligibility),expression:"contentShow.eligibility"}],staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentShow.eligibility),expression:"!contentShow.eligibility"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('provider.eligibility.label')))])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.eligibility.convicted')))]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eligibility.convicted),expression:"eligibility.convicted"}],staticClass:"input",attrs:{"type":"radio","name":"convicted","disabled":!_vm.editEnabled,"value":"true"},domProps:{"checked":_vm._q(_vm.eligibility.convicted,"true")},on:{"change":function($event){return _vm.$set(_vm.eligibility, "convicted", "true")}}}),_vm._v("\n            Yes\n          ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eligibility.convicted),expression:"eligibility.convicted"}],staticClass:"input",attrs:{"type":"radio","name":"convicted","disabled":!_vm.editEnabled,"value":"false"},domProps:{"checked":_vm._q(_vm.eligibility.convicted,"false")},on:{"change":function($event){return _vm.$set(_vm.eligibility, "convicted", "false")}}}),_vm._v("\n            No\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.eligibility.conviction')))]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eligibility.conviction),expression:"eligibility.conviction"}],staticClass:"input",attrs:{"type":"radio","name":"conviction","disabled":!_vm.editEnabled,"value":"true"},domProps:{"checked":_vm._q(_vm.eligibility.conviction,"true")},on:{"change":function($event){return _vm.$set(_vm.eligibility, "conviction", "true")}}}),_vm._v("\n            Yes\n          ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eligibility.conviction),expression:"eligibility.conviction"}],staticClass:"input",attrs:{"type":"radio","name":"conviction","disabled":!_vm.editEnabled,"value":"false"},domProps:{"checked":_vm._q(_vm.eligibility.conviction,"false")},on:{"change":function($event){return _vm.$set(_vm.eligibility, "conviction", "false")}}}),_vm._v("\n            No\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.eligibility.ownVehicle')))]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eligibility.ownVehicle),expression:"eligibility.ownVehicle"}],staticClass:"input",attrs:{"type":"radio","name":"ownVehicle","disabled":!_vm.editEnabled,"value":"true"},domProps:{"checked":_vm._q(_vm.eligibility.ownVehicle,"true")},on:{"change":function($event){return _vm.$set(_vm.eligibility, "ownVehicle", "true")}}}),_vm._v("\n            Yes\n          ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eligibility.ownVehicle),expression:"eligibility.ownVehicle"}],staticClass:"input",attrs:{"type":"radio","name":"ownVehicle","disabled":!_vm.editEnabled,"value":"false"},domProps:{"checked":_vm._q(_vm.eligibility.ownVehicle,"false")},on:{"change":function($event){return _vm.$set(_vm.eligibility, "ownVehicle", "false")}}}),_vm._v("\n            No\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.eligibility.modifiedVehicle')))]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eligibility.modifiedVehicle),expression:"eligibility.modifiedVehicle"}],staticClass:"input",attrs:{"type":"radio","name":"modifiedVehicle","disabled":!_vm.editEnabled,"value":"true"},domProps:{"checked":_vm._q(_vm.eligibility.modifiedVehicle,"true")},on:{"change":function($event){return _vm.$set(_vm.eligibility, "modifiedVehicle", "true")}}}),_vm._v("\n              Yes\n          ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eligibility.modifiedVehicle),expression:"eligibility.modifiedVehicle"}],staticClass:"input",attrs:{"type":"radio","name":"modifiedVehicle","disabled":!_vm.editEnabled,"value":"false"},domProps:{"checked":_vm._q(_vm.eligibility.modifiedVehicle,"false")},on:{"change":function($event){return _vm.$set(_vm.eligibility, "modifiedVehicle", "false")}}}),_vm._v("\n            No\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.eligibility.driversLicense')))]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eligibility.driversLicense),expression:"eligibility.driversLicense"}],staticClass:"input",attrs:{"type":"radio","name":"driversLicense","disabled":!_vm.editEnabled,"value":"true"},domProps:{"checked":_vm._q(_vm.eligibility.driversLicense,"true")},on:{"change":function($event){return _vm.$set(_vm.eligibility, "driversLicense", "true")}}}),_vm._v("\n            Yes\n          ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eligibility.driversLicense),expression:"eligibility.driversLicense"}],staticClass:"input",attrs:{"type":"radio","name":"driversLicense","disabled":!_vm.editEnabled,"value":"false"},domProps:{"checked":_vm._q(_vm.eligibility.driversLicense,"false")},on:{"change":function($event){return _vm.$set(_vm.eligibility, "driversLicense", "false")}}}),_vm._v("\n            No\n          ")])])])])]),_vm._v(" "),_c('div',{class:{'collapsible':true, 'collapse':!_vm.contentShow.agreements}},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.contentShow.agreements = !_vm.contentShow.agreements}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentShow.agreements),expression:"contentShow.agreements"}],staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentShow.agreements),expression:"!contentShow.agreements"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('provider.agreements.label')))])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"checkbox"},[_c('input',{attrs:{"type":"checkbox","id":"declarePenalty","disabled":true},domProps:{"checked":true}}),_vm._v(" "),_c('label',{attrs:{"for":"declarePenalty"}},[_vm._v(_vm._s(_vm.$t('provider.agreements.declarePenalty')))])])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"checkbox"},[_c('input',{attrs:{"type":"checkbox","id":"agree","disabled":true},domProps:{"checked":true}}),_vm._v(" "),_c('label',{attrs:{"for":"agree"},domProps:{"innerHTML":_vm._s(_vm.$t('provider.agreements.agree', _vm.aggreementsLink))}})])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.agreements.signature')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signture),expression:"signture"}],staticClass:"input",attrs:{"type":"text","disabled":true},domProps:{"value":(_vm.signture)},on:{"input":function($event){if($event.target.composing){ return; }_vm.signture=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"df-created"},[_vm._v("\n            "+_vm._s(_vm.ptrsDriverAgreeUTC ? ("Accepted agreement on " + _vm.ptrsDriverAgreeUTC) : _vm.createdDate(_vm.created))+"\n          ")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col100"},[_c('div',{staticClass:"label"},[_vm._v("Vehicle Registration")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverPayouts_vue__ = __webpack_require__(574);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ffe6cf4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverPayouts_vue__ = __webpack_require__(1671);
function injectStyle (ssrContext) {
  __webpack_require__(1669)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ffe6cf4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverPayouts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ffe6cf4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverPayouts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1670);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1d064c8c", content, true, {});

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"DriverPayouts.vue","sourceRoot":""}]);

// exports


/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"driver-payouts"},[_vm._v("\n  DRIVER PAYOUTS "+_vm._s(_vm.provId)+"\n  "),(_vm.account !== null)?_c('div',{staticClass:"account-info"},[_vm._v("\n    "+_vm._s(_vm.account.id)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.externalAccounts !== null)?_c('div',{staticClass:"external-accounts"},_vm._l((_vm.externalAccounts),function(exAcct){return _c('div',{staticClass:"external-account"},[_vm._v("\n      "+_vm._s(exAcct.accountType)+_vm._s(exAcct.lastFour)+"\n    ")])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shifts_vue__ = __webpack_require__(575);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9fb33f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Shifts_vue__ = __webpack_require__(1675);
function injectStyle (ssrContext) {
  __webpack_require__(1673)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b9fb33f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shifts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9fb33f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Shifts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1674);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("50d49bc2", content, true, {});

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.home-sector[data-v-b9fb33f4] {\n  font-size: 14px;\n  margin-top: 15px;\n  cursor: pointer;\n}\n.home-sector.disabled[data-v-b9fb33f4] {\n    cursor: default;\n}\n.home-sector > div > *[data-v-b9fb33f4] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.home-sector > div > i.fa-home[data-v-b9fb33f4] {\n    background-color: #26D97A;\n    width: 25px;\n    height: 25px;\n    text-align: center;\n    line-height: 25px;\n    color: #fff;\n    border-radius: 100%;\n    margin-right: 5px;\n}\n.home-sector > div > .highlight[data-v-b9fb33f4] {\n    font-weight: 700;\n    color: #0D79F2;\n}\n.home-sector .none[data-v-b9fb33f4] {\n    color: #F25E0D;\n    font-weight: 700;\n}\n.home-sector .fa-edit[data-v-b9fb33f4] {\n    color: #0D79F2;\n}\n.shifts[data-v-b9fb33f4] {\n  margin-top: 20px;\n  width: 100%;\n  position: relative;\n  border: 2px solid rgba(0, 0, 0, 0.55);\n}\n.shift-day-empty[data-v-b9fb33f4] {\n  width: 60px;\n  height: 30px;\n  background-color: #f5f5f5;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  border-left: 0;\n}\n.shift-day[data-v-b9fb33f4] {\n  width: 60px;\n  background-color: #f5f5f5;\n  text-align: center;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  border-top: 0;\n  border-left: 0;\n  padding: 10px 0;\n}\n.shift-day .date[data-v-b9fb33f4] {\n    font-size: 20px;\n    line-height: 20px;\n    font-weight: 700;\n    margin-bottom: 5px;\n    color: #0D79F2;\n}\n.shift-day .month[data-v-b9fb33f4] {\n    font-size: 14px;\n    line-height: 14px;\n    font-weight: 700;\n    margin-bottom: 2px;\n    color: #777;\n}\n.shift-day .day[data-v-b9fb33f4] {\n    font-size: 12px;\n    line-height: 12px;\n    font-weight: 700;\n    color: #333;\n}\n.driver-shift[data-v-b9fb33f4] {\n  position: absolute;\n  z-index: 5;\n  height: 74px;\n  padding: 10px 0;\n}\n.driver-shift .shift-content[data-v-b9fb33f4] {\n    background-color: #F25E0D;\n    color: #fff;\n    font-weight: 700;\n    padding: 10px;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n    cursor: pointer;\n    width: 100%;\n}\n.driver-shift .shift-content[data-v-b9fb33f4]:hover {\n      background-color: #D05E0D;\n}\n.driver-shift .shift-content.confirmed[data-v-b9fb33f4] {\n      background-color: #26CF7A;\n}\n.driver-shift .shift-content.confirmed[data-v-b9fb33f4]:hover {\n        background-color: #26B67A;\n}\n.driver-shift .time[data-v-b9fb33f4] {\n    font-size: 14px;\n    line-height: 14px;\n    margin-bottom: 6px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n}\n.driver-shift .place[data-v-b9fb33f4] {\n    font-size: 12px;\n    line-height: 12px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n}\n.shift-times-wrapper[data-v-b9fb33f4] {\n  overflow-y: hidden;\n  overflow-x: auto;\n  position: absolute;\n  top: 0;\n  left: 60px;\n  width: calc(100% - 60px);\n  z-index: 3;\n}\n.shift-times[data-v-b9fb33f4] {\n  width: 1444px;\n}\n.shift-times .time-label[data-v-b9fb33f4] {\n    font-size: 10px;\n    font-weight: 700;\n    color: #555;\n    width: 60px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    padding: 7px 0 6px;\n    display: inline-block;\n    text-align: center;\n    border-left: 0;\n}\n.shift-times .time-label[data-v-b9fb33f4]:not(:first-child) {\n      margin-left: -4px;\n}\n.shift-times .time-label[data-v-b9fb33f4]:last-child {\n      border-right: 0;\n}\n.shift-placeholder-row[data-v-b9fb33f4] {\n  position: relative;\n  width: 1444px;\n  height: 74px;\n}\n.shift-placeholder-row .shift-placeholder[data-v-b9fb33f4] {\n    position: static;\n    width: 60px;\n    height: 74px;\n    display: inline-block;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    border-top: 0;\n    border-left: 0;\n    cursor: pointer;\n    background-color: rgba(255, 255, 255, 0);\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.shift-placeholder-row .shift-placeholder[data-v-b9fb33f4]:hover {\n      background-color: rgba(0, 0, 0, 0.03);\n}\n.shift-placeholder-row .shift-placeholder[data-v-b9fb33f4]:not(:first-child) {\n      margin-left: -4px;\n}\n.shift-placeholder-row .shift-placeholder[data-v-b9fb33f4]:last-child {\n      border-right: 0;\n}\n.shift-placeholder-row .shift-item[data-v-b9fb33f4] {\n    position: absolute;\n    top: 10px;\n    left: 0;\n    height: 30px;\n    width: 10%;\n    background-color: red;\n}\n.shift-times-wrapper.disabled .shift-placeholder[data-v-b9fb33f4] {\n  cursor: default;\n}\n.field-input label[data-v-b9fb33f4] {\n  color: #0D79F2;\n  font-weight: 700;\n  font-size: 10px;\n}\n.field-input input[data-v-b9fb33f4] {\n  margin-top: 0;\n  font-size: 14px;\n  padding: 7px 7px;\n}\n.field-input select[data-v-b9fb33f4] {\n  font-size: 14px;\n  height: 37px;\n  outline: 0;\n  padding: 7px 7px;\n  display: block;\n  border-color: rgba(0, 0, 0, 0.15);\n  background-color: #fff;\n  border-radius: 3px;\n}\n.filter-btn[data-v-b9fb33f4] {\n  margin-top: 25px;\n  position: relative;\n}\n.filter-btn > *[data-v-b9fb33f4] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.filter-btn i[data-v-b9fb33f4] {\n    position: absolute;\n    top: 9px;\n    right: 15px;\n}\n.padding-R[data-v-b9fb33f4] {\n  padding-right: 7px;\n}\n.padding-L[data-v-b9fb33f4] {\n  padding-left: 7px;\n}\n.margin-T[data-v-b9fb33f4] {\n  margin-top: 20px;\n}\n@media only screen and (max-width: 430px) {\n.shift-header[data-v-b9fb33f4] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.shift-header .columns[data-v-b9fb33f4] {\n      width: 100% !important;\n      padding: 0 !important;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Provider/Shifts.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;CACjB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,sBAAsB;IACtB,uBAAuB;CAC1B;AACD;IACI,0BAA0B;IAC1B,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;CACrB;AACD;IACI,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,eAAe;IACf,iBAAiB;CACpB;AACD;IACI,eAAe;CAClB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;CACvC;AACD;EACE,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,qCAAqC;EACrC,eAAe;CAChB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;CACjB;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;CAClB;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;CACf;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,gBAAgB;CACjB;AACD;IACI,0BAA0B;IAC1B,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,8BAA8B;IAC9B,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;CACf;AACD;MACM,0BAA0B;CAC/B;AACD;MACM,0BAA0B;CAC/B;AACD;QACQ,0BAA0B;CACjC;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;CACf;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;CACf;AACD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,WAAW;CACZ;AACD;EACE,cAAc;CACf;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,qCAAqC;IACrC,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;CAClB;AACD;MACM,kBAAkB;CACvB;AACD;MACM,gBAAgB;CACrB;AACD;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;CACd;AACD;IACI,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,qCAAqC;IACrC,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yCAAyC;IACzC,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;MACM,sCAAsC;CAC3C;AACD;MACM,kBAAkB;CACvB;AACD;MACM,gBAAgB;CACrB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,aAAa;IACb,WAAW;IACX,sBAAsB;CACzB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;CACjB;AACD;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;CAClB;AACD;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;CACpB;AACD;EACE,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,sBAAsB;IACtB,uBAAuB;CAC1B;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,YAAY;CACf;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,iBAAiB;CAClB;AACD;AACA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,6BAA6B;IAC7B,8BAA8B;QAC1B,2BAA2B;YACvB,uBAAuB;CAClC;AACD;MACM,uBAAuB;MACvB,sBAAsB;CAC3B;CACA","file":"Shifts.vue","sourcesContent":["\n.home-sector[data-v-b9fb33f4] {\n  font-size: 14px;\n  margin-top: 15px;\n  cursor: pointer;\n}\n.home-sector.disabled[data-v-b9fb33f4] {\n    cursor: default;\n}\n.home-sector > div > *[data-v-b9fb33f4] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.home-sector > div > i.fa-home[data-v-b9fb33f4] {\n    background-color: #26D97A;\n    width: 25px;\n    height: 25px;\n    text-align: center;\n    line-height: 25px;\n    color: #fff;\n    border-radius: 100%;\n    margin-right: 5px;\n}\n.home-sector > div > .highlight[data-v-b9fb33f4] {\n    font-weight: 700;\n    color: #0D79F2;\n}\n.home-sector .none[data-v-b9fb33f4] {\n    color: #F25E0D;\n    font-weight: 700;\n}\n.home-sector .fa-edit[data-v-b9fb33f4] {\n    color: #0D79F2;\n}\n.shifts[data-v-b9fb33f4] {\n  margin-top: 20px;\n  width: 100%;\n  position: relative;\n  border: 2px solid rgba(0, 0, 0, 0.55);\n}\n.shift-day-empty[data-v-b9fb33f4] {\n  width: 60px;\n  height: 30px;\n  background-color: #f5f5f5;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  border-left: 0;\n}\n.shift-day[data-v-b9fb33f4] {\n  width: 60px;\n  background-color: #f5f5f5;\n  text-align: center;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  border-top: 0;\n  border-left: 0;\n  padding: 10px 0;\n}\n.shift-day .date[data-v-b9fb33f4] {\n    font-size: 20px;\n    line-height: 20px;\n    font-weight: 700;\n    margin-bottom: 5px;\n    color: #0D79F2;\n}\n.shift-day .month[data-v-b9fb33f4] {\n    font-size: 14px;\n    line-height: 14px;\n    font-weight: 700;\n    margin-bottom: 2px;\n    color: #777;\n}\n.shift-day .day[data-v-b9fb33f4] {\n    font-size: 12px;\n    line-height: 12px;\n    font-weight: 700;\n    color: #333;\n}\n.driver-shift[data-v-b9fb33f4] {\n  position: absolute;\n  z-index: 5;\n  height: 74px;\n  padding: 10px 0;\n}\n.driver-shift .shift-content[data-v-b9fb33f4] {\n    background-color: #F25E0D;\n    color: #fff;\n    font-weight: 700;\n    padding: 10px;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n    cursor: pointer;\n    width: 100%;\n}\n.driver-shift .shift-content[data-v-b9fb33f4]:hover {\n      background-color: #D05E0D;\n}\n.driver-shift .shift-content.confirmed[data-v-b9fb33f4] {\n      background-color: #26CF7A;\n}\n.driver-shift .shift-content.confirmed[data-v-b9fb33f4]:hover {\n        background-color: #26B67A;\n}\n.driver-shift .time[data-v-b9fb33f4] {\n    font-size: 14px;\n    line-height: 14px;\n    margin-bottom: 6px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n}\n.driver-shift .place[data-v-b9fb33f4] {\n    font-size: 12px;\n    line-height: 12px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n}\n.shift-times-wrapper[data-v-b9fb33f4] {\n  overflow-y: hidden;\n  overflow-x: auto;\n  position: absolute;\n  top: 0;\n  left: 60px;\n  width: calc(100% - 60px);\n  z-index: 3;\n}\n.shift-times[data-v-b9fb33f4] {\n  width: 1444px;\n}\n.shift-times .time-label[data-v-b9fb33f4] {\n    font-size: 10px;\n    font-weight: 700;\n    color: #555;\n    width: 60px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    padding: 7px 0 6px;\n    display: inline-block;\n    text-align: center;\n    border-left: 0;\n}\n.shift-times .time-label[data-v-b9fb33f4]:not(:first-child) {\n      margin-left: -4px;\n}\n.shift-times .time-label[data-v-b9fb33f4]:last-child {\n      border-right: 0;\n}\n.shift-placeholder-row[data-v-b9fb33f4] {\n  position: relative;\n  width: 1444px;\n  height: 74px;\n}\n.shift-placeholder-row .shift-placeholder[data-v-b9fb33f4] {\n    position: static;\n    width: 60px;\n    height: 74px;\n    display: inline-block;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    border-top: 0;\n    border-left: 0;\n    cursor: pointer;\n    background-color: rgba(255, 255, 255, 0);\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.shift-placeholder-row .shift-placeholder[data-v-b9fb33f4]:hover {\n      background-color: rgba(0, 0, 0, 0.03);\n}\n.shift-placeholder-row .shift-placeholder[data-v-b9fb33f4]:not(:first-child) {\n      margin-left: -4px;\n}\n.shift-placeholder-row .shift-placeholder[data-v-b9fb33f4]:last-child {\n      border-right: 0;\n}\n.shift-placeholder-row .shift-item[data-v-b9fb33f4] {\n    position: absolute;\n    top: 10px;\n    left: 0;\n    height: 30px;\n    width: 10%;\n    background-color: red;\n}\n.shift-times-wrapper.disabled .shift-placeholder[data-v-b9fb33f4] {\n  cursor: default;\n}\n.field-input label[data-v-b9fb33f4] {\n  color: #0D79F2;\n  font-weight: 700;\n  font-size: 10px;\n}\n.field-input input[data-v-b9fb33f4] {\n  margin-top: 0;\n  font-size: 14px;\n  padding: 7px 7px;\n}\n.field-input select[data-v-b9fb33f4] {\n  font-size: 14px;\n  height: 37px;\n  outline: 0;\n  padding: 7px 7px;\n  display: block;\n  border-color: rgba(0, 0, 0, 0.15);\n  background-color: #fff;\n  border-radius: 3px;\n}\n.filter-btn[data-v-b9fb33f4] {\n  margin-top: 25px;\n  position: relative;\n}\n.filter-btn > *[data-v-b9fb33f4] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.filter-btn i[data-v-b9fb33f4] {\n    position: absolute;\n    top: 9px;\n    right: 15px;\n}\n.padding-R[data-v-b9fb33f4] {\n  padding-right: 7px;\n}\n.padding-L[data-v-b9fb33f4] {\n  padding-left: 7px;\n}\n.margin-T[data-v-b9fb33f4] {\n  margin-top: 20px;\n}\n@media only screen and (max-width: 430px) {\n.shift-header[data-v-b9fb33f4] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.shift-header .columns[data-v-b9fb33f4] {\n      width: 100% !important;\n      padding: 0 !important;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"driver-shifts"},[_c('div',{staticClass:"row shift-header"},[_c('div',{staticClass:"small-3 columns padding-R"},[_c('div',{staticClass:"field-input"},[_c('label',[_vm._v("FROM:")]),_vm._v(" "),(_vm.editEnabled)?_c('date-picker',{attrs:{"format":"MM/dd/yyyy","disabled":_vm.startDateDisabledDates,"input-class":"drivershift-dateinput","calendar-class":"drivershift-calendar"},on:{"selected":_vm.filterShifts},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}}):_c('input',{staticClass:"input",attrs:{"type":"text","disabled":"disabled"},domProps:{"value":_vm.dateFormat(_vm.startDate)}})],1)]),_vm._v(" "),_c('div',{staticClass:"small-3 columns padding-L"},[_c('div',{staticClass:"field-input"},[_c('label',[_vm._v("TO:")]),_vm._v(" "),(_vm.editEnabled)?_c('date-picker',{attrs:{"format":"MM/dd/yyyy","disabled":_vm.endDateDisabledDates,"input-class":"drivershift-dateinput","calendar-class":"drivershift-calendar"},on:{"selected":_vm.filterShifts},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}}):_c('input',{staticClass:"input",attrs:{"type":"text","disabled":"disabled"},domProps:{"value":_vm.dateFormat(_vm.endDate)}})],1)]),_vm._v(" "),_c('div',{staticClass:"small-2 columns"}),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[(_vm.editEnabled)?_c('a',{staticClass:"button cta xsmall block filter-btn",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.addNewShift(null, null, null)}}},[_c('span',[_vm._v("ADD NEW AVAILABILITY")])]):_vm._e()])]),_vm._v(" "),_c('div',{class:{'home-sector':true, 'disabled':!_vm.editEnabled}},[(_vm.homeSector !== null)?_c('div',{on:{"click":_vm.openHomeSector}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" "),_c('span',[_vm._v("Home Sector is set to")]),_vm._v(" "),_c('span',{staticClass:"highlight"},[_vm._v(_vm._s(_vm.homeSector))]),_vm._v(" "),(_vm.editEnabled)?_c('i',{staticClass:"fa fa-edit"}):_vm._e()]):_c('div',{staticClass:"none",on:{"click":_vm.openHomeSector}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" "),_c('span',[_vm._v("No Home Sector set for this driver.")]),_vm._v(" "),(_vm.editEnabled)?_c('i',{staticClass:"fa fa-edit"}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"shifts"},[_c('div',{staticClass:"shift-dates"},[_c('div',{staticClass:"shift-day-empty"}),_vm._v(" "),_vm._l((_vm.days),function(day){return _c('div',{staticClass:"shift-day"},[_c('div',{staticClass:"date"},[_vm._v(_vm._s(day.format('DD')))]),_vm._v(" "),_c('div',{staticClass:"month"},[_vm._v(_vm._s(day.format('MMM')))]),_vm._v(" "),_c('div',{staticClass:"day"},[_vm._v(_vm._s(day.format('ddd')))])])})],2),_vm._v(" "),_c('div',{class:{'shift-times-wrapper':true, 'disabled':!_vm.editEnabled}},[_vm._m(0),_vm._v(" "),_vm._l((_vm.days),function(day){return _c('div',{staticClass:"shift-placeholder-row"},[_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 12, 'AM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 1, 'AM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 2, 'AM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 3, 'AM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 4, 'AM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 5, 'AM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 6, 'AM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 7, 'AM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 8, 'AM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 9, 'AM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 10, 'AM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 11, 'AM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 12, 'PM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 1, 'PM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 2, 'PM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 3, 'PM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 4, 'PM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 5, 'PM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 6, 'PM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 7, 'PM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 8, 'PM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 9, 'PM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 10, 'PM')}}}),_vm._v(" "),_c('div',{staticClass:"shift-placeholder",on:{"click":function($event){return _vm.addNewShift(day, 11, 'PM')}}})])}),_vm._v(" "),_vm._l((_vm.driverShifts),function(shift){return _c('div',{staticClass:"driver-shift",style:(shift.shiftPosition)},[_c('div',{class:{ 'shift-content': true, confirmed: shift.confirmed },on:{"click":function($event){return _vm.editShift(shift)}}},[_c('div',{staticClass:"time"},[(shift.startsPrevDay)?_c('span',[_vm._v("(-1)")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(shift.start.format('hh:mm A')))]),_vm._v(" - \n            "),_c('span',[_vm._v(_vm._s(shift.end.format('hh:mm A')))]),_vm._v(" "),(shift.endsNextDay)?_c('span',[_vm._v("(+1)")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"place"},[_vm._v(_vm._s(shift.workSectorName))])])])})],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shift-times"},[_c('div',{staticClass:"time-labels"},[_c('div',{staticClass:"time-label"},[_vm._v("12:00 AM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("01:00 AM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("02:00 AM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("03:00 AM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("04:00 AM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("05:00 AM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("06:00 AM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("07:00 AM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("08:00 AM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("09:00 AM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("10:00 AM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("11:00 AM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("12:00 PM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("01:00 PM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("02:00 PM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("03:00 PM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("04:00 PM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("05:00 PM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("06:00 PM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("07:00 PM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("08:00 PM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("09:00 PM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("10:00 PM")]),_vm._v(" "),_c('div',{staticClass:"time-label"},[_vm._v("11:00 PM")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShiftForm_vue__ = __webpack_require__(576);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ad2274c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShiftForm_vue__ = __webpack_require__(1679);
function injectStyle (ssrContext) {
  __webpack_require__(1677)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ad2274c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShiftForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ad2274c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShiftForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1678);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("615e20a6", content, true, {});

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.shift-form-container[data-v-2ad2274c] {\n  position: fixed;\n  top: -100%;\n  left: 0;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: -1;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.shift-form-container.show[data-v-2ad2274c] {\n    top: 0;\n    opacity: 1;\n    z-index: 12;\n}\n.shift-form[data-v-2ad2274c] {\n  background-color: #fff;\n  width: 80%;\n  max-width: 560px;\n  overflow: hidden;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n.shift-form .title[data-v-2ad2274c] {\n    background-color: #0D79F2;\n    color: #fff;\n    text-align: center;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 14px;\n    text-transform: uppercase;\n    padding: 10px 0;\n}\n.shift-form .form-container[data-v-2ad2274c] {\n    padding: 10px 15px 15px;\n}\n.time-picker[data-v-2ad2274c] {\n  margin-left: 8px;\n  margin-top: 10px;\n  width: 100%;\n}\n.time-picker label[data-v-2ad2274c] {\n    color: #0D79F2;\n    font-weight: 700;\n    font-size: 10px;\n    line-height: 10px;\n    display: block;\n    margin-bottom: 10px;\n    padding-left: 10px;\n}\n.time-picker .inline[data-v-2ad2274c] {\n    display: inline-block;\n    vertical-align: middle;\n    float: left;\n    text-align: center;\n}\n.time-picker .selection[data-v-2ad2274c] {\n    text-align: center;\n    width: 30%;\n}\n.time-picker .selection .value[data-v-2ad2274c] {\n      font-size: 22px;\n      font-weight: 700;\n      color: #555;\n}\n.time-picker .selection .control[data-v-2ad2274c] {\n      font-size: 12px;\n      color: #0D79F2;\n      cursor: pointer;\n      width: 100%;\n}\n.time-picker .separator[data-v-2ad2274c] {\n    line-height: 69px;\n    height: 69px;\n    color: #777;\n    padding: 0 5px;\n    width: 5%;\n}\n.shift-duration[data-v-2ad2274c] {\n  margin-left: 10px;\n  margin-top: 90px;\n}\n.form-controls[data-v-2ad2274c] {\n  margin-top: 30px;\n  margin-left: 10px;\n}\n.form-controls.show-delete[data-v-2ad2274c] {\n    margin-top: 15px;\n}\n.form-controls .success[data-v-2ad2274c], .form-controls .error[data-v-2ad2274c] {\n    margin-bottom: 10px;\n}\n.error-message[data-v-2ad2274c] {\n  color: #F20D0D;\n  font-size: 14px;\n  font-weight: 700;\n  text-align: center;\n  margin-top: 15px;\n  border: 1px solid #F20D0D;\n  padding: 5px;\n}\n.field-input label[data-v-2ad2274c] {\n  color: #0D79F2;\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 10px;\n}\n.field-input input[data-v-2ad2274c] {\n  margin-top: 0;\n  font-size: 14px;\n  padding: 7px 7px;\n}\n.field-input select[data-v-2ad2274c] {\n  font-size: 14px;\n  height: 37px;\n  outline: 0;\n  padding: 7px 7px;\n  display: block;\n  border-color: rgba(0, 0, 0, 0.15);\n  background-color: #fff;\n  border-radius: 3px;\n}\n.padding-L[data-v-2ad2274c] {\n  padding-left: 7px;\n}\n.padding-R[data-v-2ad2274c] {\n  padding-right: 7px;\n}\n.margin-T[data-v-2ad2274c] {\n  margin-top: 20px;\n}\n@media only screen and (max-width: 430px) {\n.shift-form-container[data-v-2ad2274c], .small-7[data-v-2ad2274c], .small-5[data-v-2ad2274c], .shift-form[data-v-2ad2274c] {\n    width: 100%;\n}\n[data-v-2ad2274c] .vdp-datepicker__calendar {\n    width: 100%;\n}\n.shift-form-container[data-v-2ad2274c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: auto;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.shift-form[data-v-2ad2274c] {\n    margin: 0;\n    height: 100vh;\n    overflow-y: auto;\n}\n.shift-form .form-container[data-v-2ad2274c] {\n      padding-bottom: 40px;\n}\n.shift-form .time-picker[data-v-2ad2274c] {\n      margin-left: 0;\n}\n.shift-form .time-picker label[data-v-2ad2274c] {\n        padding-left: 0;\n}\n.shift-form .shift-duration[data-v-2ad2274c] {\n      margin-left: 0;\n}\n.shift-form .form-controls[data-v-2ad2274c] {\n      margin-left: 0;\n      margin-top: 40px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      gap: 10px;\n}\n.shift-form .form-controls .block[data-v-2ad2274c] {\n        width: 50%;\n        margin: 0;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Provider/ShiftForm.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;CAC7B;AACD;IACI,OAAO;IACP,WAAW;IACX,YAAY;CACf;AACD;EACE,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,iDAAiD;UACzC,yCAAyC;CAClD;AACD;IACI,0BAA0B;IAC1B,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,gBAAgB;CACnB;AACD;IACI,wBAAwB;CAC3B;AACD;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;CACb;AACD;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;CACtB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;CACtB;AACD;IACI,mBAAmB;IACnB,WAAW;CACd;AACD;MACM,gBAAgB;MAChB,iBAAiB;MACjB,YAAY;CACjB;AACD;MACM,gBAAgB;MAChB,eAAe;MACf,gBAAgB;MAChB,YAAY;CACjB;AACD;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,UAAU;CACb;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,kBAAkB;CACnB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;EAC1B,aAAa;CACd;AACD;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;CAClB;AACD;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,iBAAiB;CAClB;AACD;AACA;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,aAAa;IACb,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;CAC/B;AACD;IACI,UAAU;IACV,cAAc;IACd,iBAAiB;CACpB;AACD;MACM,qBAAqB;CAC1B;AACD;MACM,eAAe;CACpB;AACD;QACQ,gBAAgB;CACvB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;MACf,iBAAiB;MACjB,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;MAC5B,UAAU;CACf;AACD;QACQ,WAAW;QACX,UAAU;CACjB;CACA","file":"ShiftForm.vue","sourcesContent":["\n.shift-form-container[data-v-2ad2274c] {\n  position: fixed;\n  top: -100%;\n  left: 0;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: -1;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.shift-form-container.show[data-v-2ad2274c] {\n    top: 0;\n    opacity: 1;\n    z-index: 12;\n}\n.shift-form[data-v-2ad2274c] {\n  background-color: #fff;\n  width: 80%;\n  max-width: 560px;\n  overflow: hidden;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n.shift-form .title[data-v-2ad2274c] {\n    background-color: #0D79F2;\n    color: #fff;\n    text-align: center;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 14px;\n    text-transform: uppercase;\n    padding: 10px 0;\n}\n.shift-form .form-container[data-v-2ad2274c] {\n    padding: 10px 15px 15px;\n}\n.time-picker[data-v-2ad2274c] {\n  margin-left: 8px;\n  margin-top: 10px;\n  width: 100%;\n}\n.time-picker label[data-v-2ad2274c] {\n    color: #0D79F2;\n    font-weight: 700;\n    font-size: 10px;\n    line-height: 10px;\n    display: block;\n    margin-bottom: 10px;\n    padding-left: 10px;\n}\n.time-picker .inline[data-v-2ad2274c] {\n    display: inline-block;\n    vertical-align: middle;\n    float: left;\n    text-align: center;\n}\n.time-picker .selection[data-v-2ad2274c] {\n    text-align: center;\n    width: 30%;\n}\n.time-picker .selection .value[data-v-2ad2274c] {\n      font-size: 22px;\n      font-weight: 700;\n      color: #555;\n}\n.time-picker .selection .control[data-v-2ad2274c] {\n      font-size: 12px;\n      color: #0D79F2;\n      cursor: pointer;\n      width: 100%;\n}\n.time-picker .separator[data-v-2ad2274c] {\n    line-height: 69px;\n    height: 69px;\n    color: #777;\n    padding: 0 5px;\n    width: 5%;\n}\n.shift-duration[data-v-2ad2274c] {\n  margin-left: 10px;\n  margin-top: 90px;\n}\n.form-controls[data-v-2ad2274c] {\n  margin-top: 30px;\n  margin-left: 10px;\n}\n.form-controls.show-delete[data-v-2ad2274c] {\n    margin-top: 15px;\n}\n.form-controls .success[data-v-2ad2274c], .form-controls .error[data-v-2ad2274c] {\n    margin-bottom: 10px;\n}\n.error-message[data-v-2ad2274c] {\n  color: #F20D0D;\n  font-size: 14px;\n  font-weight: 700;\n  text-align: center;\n  margin-top: 15px;\n  border: 1px solid #F20D0D;\n  padding: 5px;\n}\n.field-input label[data-v-2ad2274c] {\n  color: #0D79F2;\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 10px;\n}\n.field-input input[data-v-2ad2274c] {\n  margin-top: 0;\n  font-size: 14px;\n  padding: 7px 7px;\n}\n.field-input select[data-v-2ad2274c] {\n  font-size: 14px;\n  height: 37px;\n  outline: 0;\n  padding: 7px 7px;\n  display: block;\n  border-color: rgba(0, 0, 0, 0.15);\n  background-color: #fff;\n  border-radius: 3px;\n}\n.padding-L[data-v-2ad2274c] {\n  padding-left: 7px;\n}\n.padding-R[data-v-2ad2274c] {\n  padding-right: 7px;\n}\n.margin-T[data-v-2ad2274c] {\n  margin-top: 20px;\n}\n@media only screen and (max-width: 430px) {\n.shift-form-container[data-v-2ad2274c], .small-7[data-v-2ad2274c], .small-5[data-v-2ad2274c], .shift-form[data-v-2ad2274c] {\n    width: 100%;\n}\n[data-v-2ad2274c] .vdp-datepicker__calendar {\n    width: 100%;\n}\n.shift-form-container[data-v-2ad2274c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: auto;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.shift-form[data-v-2ad2274c] {\n    margin: 0;\n    height: 100vh;\n    overflow-y: auto;\n}\n.shift-form .form-container[data-v-2ad2274c] {\n      padding-bottom: 40px;\n}\n.shift-form .time-picker[data-v-2ad2274c] {\n      margin-left: 0;\n}\n.shift-form .time-picker label[data-v-2ad2274c] {\n        padding-left: 0;\n}\n.shift-form .shift-duration[data-v-2ad2274c] {\n      margin-left: 0;\n}\n.shift-form .form-controls[data-v-2ad2274c] {\n      margin-left: 0;\n      margin-top: 40px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      gap: 10px;\n}\n.shift-form .form-controls .block[data-v-2ad2274c] {\n        width: 50%;\n        margin: 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['shift-form-container', {show: _vm.show}],on:{"click":_vm.hideForm}},[(!_vm.forHomeSector)?_c('div',{staticClass:"shift-form",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"form-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"field-input"},[_c('label',[_vm._v("SECTOR:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.selectedSector),expression:"selectedSector",modifiers:{"number":true}}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.selectedSector=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.getSubsectors(true)}]}},[_c('option',{domProps:{"value":-1}},[_vm._v("Choose a sector")]),_vm._v(" "),_vm._l((_vm.sectors),function(sector){return _c('option',{domProps:{"value":sector.ID}},[_vm._v(_vm._s(sector.name))])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-7 columns"},[_c('div',{staticClass:"field-input"},[_c('label',[_vm._v("START DATE:")]),_vm._v(" "),_c('date-picker',{attrs:{"calendar-class":"drivershift-calendar","inline":true,"disabled":_vm.calendarDisabled},model:{value:(_vm.shiftDay),callback:function ($$v) {_vm.shiftDay=$$v},expression:"shiftDay"}})],1)]),_vm._v(" "),_c('div',{staticClass:"small-5 columns"},[_c('div',{staticClass:"field-input",staticStyle:{"padding-left":"10px"}},[_c('label',[_vm._v("START TIME:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.timeSelected),expression:"timeSelected"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.timeSelected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.getSubsectors(true)}]}},[_c('option',{domProps:{"value":-1}},[_vm._v("Choose time")]),_vm._v(" "),_c('option',{attrs:{"value":"AM"}},[_vm._v("AM Start")]),_vm._v(" "),_c('option',{attrs:{"value":"PM"}},[_vm._v("PM Start")])])]),_vm._v(" "),(_vm.timeSelected === 'custom')?_c('div',{staticClass:"time-picker"},[_c('span',{staticClass:"inline selection"},[_c('div',{staticClass:"control",on:{"click":function($event){return _vm.setHour(true)}}},[_c('i',{staticClass:"fa fa-chevron-up"})]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.timeHour))]),_vm._v(" "),_c('div',{staticClass:"control",on:{"click":function($event){return _vm.setHour(false)}}},[_c('i',{staticClass:"fa fa-chevron-down"})])]),_vm._v(" "),_c('span',{staticClass:"inline separator"},[_vm._v(":")]),_vm._v(" "),_c('span',{staticClass:"inline selection"},[_c('div',{staticClass:"control",on:{"click":function($event){return _vm.setMinute(true)}}},[_c('i',{staticClass:"fa fa-chevron-up"})]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.timeMinute))]),_vm._v(" "),_c('div',{staticClass:"control",on:{"click":function($event){return _vm.setMinute(false)}}},[_c('i',{staticClass:"fa fa-chevron-down"})])]),_vm._v(" "),_c('span',{staticClass:"inline separator"},[_vm._v(":")]),_vm._v(" "),_c('span',{staticClass:"inline selection"},[_c('div',{staticClass:"control",on:{"click":_vm.setAmPm}},[_c('i',{staticClass:"fa fa-chevron-up"})]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.timeAmPm))]),_vm._v(" "),_c('div',{staticClass:"control",on:{"click":_vm.setAmPm}},[_c('i',{staticClass:"fa fa-chevron-down"})])])]):_vm._e(),_vm._v(" "),(_vm.timeSelected === 'custom')?_c('div',{staticClass:"field-input shift-duration"},[_c('label',[_vm._v("DURATION:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.shiftDuration),expression:"shiftDuration",modifiers:{"number":true}}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.shiftDuration=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.durationRange),function(n){return _c('option',{domProps:{"value":n}},[_vm._v(_vm._s(n + (n > 1 ? ' hours' : ' hour')))])}),0)]):_vm._e(),_vm._v(" "),_c('div',{class:{ 'form-controls': true, 'show-delete': _vm.isEdit }},[_c('a',{class:{ 'button cta xsmall success block': true, disabled: _vm.saving },attrs:{"href":"javascript:;"},on:{"click":_vm.save}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.saving),expression:"saving"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.saving),expression:"!saving"}]},[_vm._v("SAVE")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.isEdit),expression:"isEdit"}],class:{ 'button cta xsmall error block': true, disabled: _vm.deleting },attrs:{"href":"javascript:;"},on:{"click":_vm.deleteShift}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.deleting),expression:"deleting"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.deleting),expression:"!deleting"}]},[_vm._v("DELETE")])]),_vm._v(" "),_c('a',{staticClass:"button cta xsmall secondary block",attrs:{"href":"javascript:;"},on:{"click":_vm.hideForm}},[_vm._v("CANCEL")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.show),expression:"error.show"}],staticClass:"error-message"},[_vm._v(_vm._s(_vm.error.message))])])]):_c('div',{staticClass:"shift-form",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"form-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"field-input"},[_c('label',[_vm._v("SECTOR:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.selectedSector),expression:"selectedSector",modifiers:{"number":true}}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.selectedSector=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.getSubsectors(true)}]}},[_c('option',{domProps:{"value":-1}},[_vm._v("Choose a sector")]),_vm._v(" "),_vm._l((_vm.sectors),function(sector){return _c('option',{domProps:{"value":sector.ID}},[_vm._v(_vm._s(sector.name))])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-3 small-push-6 columns padding-R"},[_c('a',{staticClass:"button cta xsmall secondary block",attrs:{"href":"javascript:;"},on:{"click":_vm.hideForm}},[_vm._v("CANCEL")])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns padding-L"},[_c('a',{class:{ 'button cta xsmall success block': true, disabled: _vm.saving },attrs:{"href":"javascript:;"},on:{"click":_vm.saveHomeSector}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.saving),expression:"saving"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.saving),expression:"!saving"}]},[_vm._v("SAVE")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.show),expression:"error.show"}],staticClass:"error-message"},[_vm._v(_vm._s(_vm.error.message))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reviews_vue__ = __webpack_require__(577);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb0eebe0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reviews_vue__ = __webpack_require__(1684);
function injectStyle (ssrContext) {
  __webpack_require__(1681)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cb0eebe0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reviews_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb0eebe0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reviews_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1682);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("35432468", content, true, {});

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.stats[data-v-cb0eebe0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.stats .stats-box[data-v-cb0eebe0] {\n    width: 35%;\n    margin: 0 5px;\n    padding: 15px;\n    background: #eee;\n    border-radius: 4px;\n    -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);\n            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);\n    text-align: center;\n    color: #fff;\n}\n.stats .stats-box.average[data-v-cb0eebe0] {\n      background: #d15757;\n}\n.stats .stats-box.five-star[data-v-cb0eebe0] {\n      background: #57d182;\n}\n.stats .stats-box.total[data-v-cb0eebe0] {\n      background: #57aad1;\n}\n.stats .stats-box span[data-v-cb0eebe0] {\n      display: block;\n      line-height: 1;\n}\n.stats .stats-box span.value[data-v-cb0eebe0] {\n        font-size: 32px;\n        line-height: 120%;\n        font-weight: 600;\n}\n.stats .stats-box span.value .fa[data-v-cb0eebe0] {\n          font-size: 24px;\n          vertical-align: 4px;\n          margin-right: 5px;\n}\n.stats .stats-box span.label[data-v-cb0eebe0] {\n        font-size: 14px;\n}\ntable[data-v-cb0eebe0] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n}\ntable thead[data-v-cb0eebe0] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-cb0eebe0] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-cb0eebe0] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-cb0eebe0] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.date[data-v-cb0eebe0] {\n        width: 150px;\n        color: #999;\n}\ntable tbody tr td.name[data-v-cb0eebe0] {\n        width: 130px;\n}\ntable tbody tr td.rating[data-v-cb0eebe0] {\n        width: 60px;\n}\ntable tbody tr td.table-block[data-v-cb0eebe0] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-cb0eebe0] {\n          color: #ccc;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Provider/Reviews.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,WAAW;IACX,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,mDAAmD;YAC3C,2CAA2C;IACnD,mBAAmB;IACnB,YAAY;CACf;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,eAAe;MACf,eAAe;CACpB;AACD;QACQ,gBAAgB;QAChB,kBAAkB;QAClB,iBAAiB;CACxB;AACD;UACU,gBAAgB;UAChB,oBAAoB;UACpB,kBAAkB;CAC3B;AACD;QACQ,gBAAgB;CACvB;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;CAClB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,aAAa;QACb,YAAY;CACnB;AACD;QACQ,aAAa;CACpB;AACD;QACQ,YAAY;CACnB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB","file":"Reviews.vue","sourcesContent":["\n.stats[data-v-cb0eebe0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.stats .stats-box[data-v-cb0eebe0] {\n    width: 35%;\n    margin: 0 5px;\n    padding: 15px;\n    background: #eee;\n    border-radius: 4px;\n    -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);\n            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);\n    text-align: center;\n    color: #fff;\n}\n.stats .stats-box.average[data-v-cb0eebe0] {\n      background: #d15757;\n}\n.stats .stats-box.five-star[data-v-cb0eebe0] {\n      background: #57d182;\n}\n.stats .stats-box.total[data-v-cb0eebe0] {\n      background: #57aad1;\n}\n.stats .stats-box span[data-v-cb0eebe0] {\n      display: block;\n      line-height: 1;\n}\n.stats .stats-box span.value[data-v-cb0eebe0] {\n        font-size: 32px;\n        line-height: 120%;\n        font-weight: 600;\n}\n.stats .stats-box span.value .fa[data-v-cb0eebe0] {\n          font-size: 24px;\n          vertical-align: 4px;\n          margin-right: 5px;\n}\n.stats .stats-box span.label[data-v-cb0eebe0] {\n        font-size: 14px;\n}\ntable[data-v-cb0eebe0] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n}\ntable thead[data-v-cb0eebe0] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-cb0eebe0] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-cb0eebe0] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-cb0eebe0] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.date[data-v-cb0eebe0] {\n        width: 150px;\n        color: #999;\n}\ntable tbody tr td.name[data-v-cb0eebe0] {\n        width: 130px;\n}\ntable tbody tr td.rating[data-v-cb0eebe0] {\n        width: 60px;\n}\ntable tbody tr td.table-block[data-v-cb0eebe0] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-cb0eebe0] {\n          color: #ccc;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__featureToggle__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  getReviewStats: function getReviewStats(VueApp, provId, callback) {
    var self = this;
    VueApp.$sdk.get('/provider/' + provId + '/reviews/summary', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      if (res.error) {
        callback(res);
        return;
      }

      VueApp.$store.commit('provider/setAverageTotalReviews', {
        average: res.average,
        total: res.count
      });

      self.getFiveStarReviewsCount(VueApp, provId, callback);
    });
  },
  getFiveStarReviewsCount: function getFiveStarReviewsCount(VueApp, provId, callback) {
    VueApp.$sdk.get('/provider/' + provId + '/reviews', {
      token: VueApp.$store.state.session.sessionToken,
      value: 5
    }, function (res) {
      if (!res.error) {
        VueApp.$store.commit('provider/setFiveStarReview', res.list.length);
      }
      callback(res);
    });
  },
  getProviderReviews: function getProviderReviews(VueApp, provId, callback) {
    var provider = VueApp.$store.state.provider;
    var pageSize = provider.reviewsPerPage;
    var page = provider.reviewPage;

    VueApp.$sdk.get('/provider/' + provId + '/reviews', {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: pageSize,
      pageNum: page + 1
    }, function (res) {
      if (!res.error) {
        VueApp.$store.commit('provider/setReviewPage', page + 1);

        if (res.list.length < pageSize) {
          VueApp.$store.commit('provider/setReviewMax', true);
        }

        if (res.list.length) {
          for (var i = 0; i < res.list.length; i++) {
            VueApp.$store.commit('provider/addReviews', {
              id: res.list[i].id,
              name: res.list[i].name,
              consumerId: res.list[i].consumerId,
              message: res.list[i].message,
              value: res.list[i].value,
              created: __WEBPACK_IMPORTED_MODULE_0_moment___default()(res.list[i].created, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false))
            });
          }
        }
      }
      callback(res);
    });
  }
});

/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"stats"},[_c('div',{staticClass:"stats-box average"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.statsLoading),expression:"statsLoading"}],staticClass:"value"},[_c('i',{staticClass:"fa fa-circle-notch fa-spin"})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.statsLoading),expression:"!statsLoading"}],staticClass:"value"},[_c('i',{staticClass:"fa fa-star"}),_vm._v(_vm._s(_vm.stats.average)+"\n      ")]),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.reviews.average')))])]),_vm._v(" "),_c('div',{staticClass:"stats-box five-star"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.statsLoading),expression:"statsLoading"}],staticClass:"value"},[_c('i',{staticClass:"fa fa-circle-notch fa-spin"})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.statsLoading),expression:"!statsLoading"}],staticClass:"value"},[_vm._v(_vm._s(_vm.stats.fiveStar))]),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.reviews.fiveStar')))])]),_vm._v(" "),_c('div',{staticClass:"stats-box total"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.statsLoading),expression:"statsLoading"}],staticClass:"value"},[_c('i',{staticClass:"fa fa-circle-notch fa-spin"})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.statsLoading),expression:"!statsLoading"}],staticClass:"value"},[_vm._v(_vm._s(_vm.stats.total))]),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.reviews.total')))])])]),_vm._v(" "),_c('table',[_c('thead',[_c('th',[_vm._v(_vm._s(_vm.$t('provider.reviews.date')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('provider.reviews.name')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('provider.reviews.message')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('provider.reviews.rating')))])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.reviews),function(review){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.reviews.length > 0),expression:"reviews.length > 0"}]},[_c('td',{staticClass:"date"},[_vm._v(_vm._s(review.created))]),_vm._v(" "),_c('td',{staticClass:"name"},[_vm._v(_vm._s(review.name))]),_vm._v(" "),_c('td',{staticClass:"message"},[_vm._v(_vm._s(review.message))]),_vm._v(" "),_c('td',{staticClass:"rating"},[_vm._v(_vm._s(review.value))])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"4"}},[_c('i',{staticClass:"fa fa-circle-notch fa-spin"}),_vm._v("\n            "+_vm._s(_vm.$t('provider.reviews.loading'))+"\n        ")])]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.reviews.length === 0 && !_vm.loading),expression:"reviews.length === 0 && !loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"4"}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.reviews.emptyState'))+"\n        ")])])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notes_vue__ = __webpack_require__(578);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c715bb8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notes_vue__ = __webpack_require__(1689);
function injectStyle (ssrContext) {
  __webpack_require__(1686)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c715bb8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c715bb8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1687);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("52aa3248", content, true, {});

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.loading[data-v-4c715bb8] {\n  text-align: center;\n  padding: 30px;\n  font-size: 18px;\n}\n.loading .fa[data-v-4c715bb8] {\n    margin-right: 5px;\n    color: #555;\n}\n.loading span[data-v-4c715bb8] {\n    color: #888;\n}\n.notes-type[data-v-4c715bb8] {\n  text-align: right;\n  margin-bottom: 10px;\n}\n.notes-type label[data-v-4c715bb8] {\n    font-size: 14px;\n    font-weight: 600;\n    margin-right: 3px;\n    color: #888;\n}\n.notes-type select[data-v-4c715bb8] {\n    width: 110px;\n    outline: none;\n}\n.empty-state[data-v-4c715bb8] {\n  padding: 30px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\n.empty-state .fa[data-v-4c715bb8] {\n    display: block;\n    margin-bottom: 5px;\n    color: #ddd;\n}\n.note[data-v-4c715bb8] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 10px 20px;\n  position: relative;\n}\n.user[data-v-4c715bb8] {\n  text-align: center;\n  width: 170px;\n  padding: 0 10px;\n  display: inline-block;\n  vertical-align: top;\n  position: relative;\n  z-index: 1;\n}\n.user .img-holder[data-v-4c715bb8] {\n    width: 75px;\n    height: 75px;\n    border-radius: 100%;\n    overflow: hidden;\n    display: inline-block;\n}\n.user span[data-v-4c715bb8] {\n    display: block;\n}\n.user .name[data-v-4c715bb8] {\n    font-weight: 600;\n    font-size: 14px;\n    color: #555;\n}\n.user .date[data-v-4c715bb8] {\n    font-size: 11px;\n    color: #999;\n}\n.note-content[data-v-4c715bb8] {\n  background: #f5f5f5;\n  padding: 15px;\n  display: inline-block;\n  width: calc(100% - 170px);\n  /*min-height: 100px;*/\n  position: relative;\n  z-index: 2;\n  border-radius: 2px;\n  -webkit-box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);\n}\n.note-content .arrow[data-v-4c715bb8] {\n    position: absolute;\n    z-index: 2;\n    top: 30px;\n    right: 100%;\n    margin-right: -20px;\n    width: 20px;\n    height: 20px;\n    background: #f5f5f5;\n    -webkit-box-shadow: -2px 2px 1px rgba(0, 0, 0, 0.15);\n            box-shadow: -2px 2px 1px rgba(0, 0, 0, 0.15);\n    -webkit-transform: translate(-50%, 0) rotate(45deg);\n            transform: translate(-50%, 0) rotate(45deg);\n}\n.note-content .status[data-v-4c715bb8] {\n    font-size: 10px;\n    font-weight: 600;\n    padding: 2px 7px;\n    color: #fff;\n    text-transform: uppercase;\n    border-radius: 4px;\n    font-style: italic;\n    float: left;\n}\n.note-content .status.resolved[data-v-4c715bb8] {\n      background: #26D97A;\n}\n.note-content .status.investigation[data-v-4c715bb8] {\n      background: #F25E0D;\n}\n.note-content .status.new[data-v-4c715bb8] {\n      background: #F20D0D;\n}\n.note-content .status.availability[data-v-4c715bb8] {\n      background: #ab11e7;\n}\n.note-content p[data-v-4c715bb8] {\n    position: relative;\n    z-index: 3;\n    font-size: 13px;\n    margin: 0;\n    color: #555;\n    min-height: 60px;\n    word-wrap: break-word;\n}\n.note-content .actions[data-v-4c715bb8] {\n    text-align: right;\n    font-size: 12px;\n    margin-top: 10px;\n    font-weight: 600;\n}\n.note-content .actions div[data-v-4c715bb8] {\n      display: inline-block;\n}\n.note-content .actions span[data-v-4c715bb8] {\n      color: #0D79F2;\n      display: inline-block;\n      margin: 0 2px;\n      cursor: pointer;\n}\n.delete-block[data-v-4c715bb8] {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  width: 100%;\n  height: 0%;\n  visibility: hidden;\n  z-index: 2;\n  text-align: center;\n  overflow: hidden;\n  -webkit-transition: background .2s, height .2s, top .2s;\n  transition: background .2s, height .2s, top .2s;\n}\n.delete-block .content[data-v-4c715bb8] {\n    display: none;\n}\n.delete-block .content p[data-v-4c715bb8] {\n      color: #fff;\n      font-weight: 600;\n}\n.delete-block .content .button[data-v-4c715bb8] {\n      min-width: 100px;\n      margin: 0 5px;\n      display: inline-block;\n}\n.delete-block .content.disabled .button[data-v-4c715bb8] {\n      opacity: .5;\n      cursor: default;\n      font-weight: 100;\n      color: #f00;\n}\n.delete-block.show[data-v-4c715bb8] {\n    visibility: visible;\n    background: rgba(0, 0, 0, 0.8);\n    height: 100%;\n    top: 0;\n}\n.delete-block.show .content[data-v-4c715bb8] {\n      display: block;\n}\n.load-more[data-v-4c715bb8] {\n  text-align: center;\n  padding: 10px;\n  font-size: 14px;\n  color: #555;\n  cursor: pointer;\n  background: #efefef;\n  margin: 20px auto 10px;\n  font-weight: 600;\n  width: 40%;\n  border-radius: 4px;\n}\n.load-more[data-v-4c715bb8]:hover {\n    background: #e0e0e0;\n    color: #333;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Provider/Notes.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;CACjB;AACD;IACI,kBAAkB;IAClB,YAAY;CACf;AACD;IACI,YAAY;CACf;AACD;EACE,kBAAkB;EAClB,oBAAoB;CACrB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;CACf;AACD;IACI,aAAa;IACb,cAAc;CACjB;AACD;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;CACf;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;CACZ;AACD;IACI,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;CACzB;AACD;IACI,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;IACI,gBAAgB;IAChB,YAAY;CACf;AACD;EACE,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;CACpD;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,oBAAoB;IACpB,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,qDAAqD;YAC7C,6CAA6C;IACrD,oDAAoD;YAC5C,4CAA4C;CACvD;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;CACf;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;CACzB;AACD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;CACpB;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,eAAe;MACf,sBAAsB;MACtB,cAAc;MACd,gBAAgB;CACrB;AACD;EACE,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,wDAAwD;EACxD,gDAAgD;CACjD;AACD;IACI,cAAc;CACjB;AACD;MACM,YAAY;MACZ,iBAAiB;CACtB;AACD;MACM,iBAAiB;MACjB,cAAc;MACd,sBAAsB;CAC3B;AACD;MACM,YAAY;MACZ,gBAAgB;MAChB,iBAAiB;MACjB,YAAY;CACjB;AACD;IACI,oBAAoB;IACpB,+BAA+B;IAC/B,aAAa;IACb,OAAO;CACV;AACD;MACM,eAAe;CACpB;AACD;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;CACpB;AACD;IACI,oBAAoB;IACpB,YAAY;CACf","file":"Notes.vue","sourcesContent":["\n.loading[data-v-4c715bb8] {\n  text-align: center;\n  padding: 30px;\n  font-size: 18px;\n}\n.loading .fa[data-v-4c715bb8] {\n    margin-right: 5px;\n    color: #555;\n}\n.loading span[data-v-4c715bb8] {\n    color: #888;\n}\n.notes-type[data-v-4c715bb8] {\n  text-align: right;\n  margin-bottom: 10px;\n}\n.notes-type label[data-v-4c715bb8] {\n    font-size: 14px;\n    font-weight: 600;\n    margin-right: 3px;\n    color: #888;\n}\n.notes-type select[data-v-4c715bb8] {\n    width: 110px;\n    outline: none;\n}\n.empty-state[data-v-4c715bb8] {\n  padding: 30px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\n.empty-state .fa[data-v-4c715bb8] {\n    display: block;\n    margin-bottom: 5px;\n    color: #ddd;\n}\n.note[data-v-4c715bb8] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 10px 20px;\n  position: relative;\n}\n.user[data-v-4c715bb8] {\n  text-align: center;\n  width: 170px;\n  padding: 0 10px;\n  display: inline-block;\n  vertical-align: top;\n  position: relative;\n  z-index: 1;\n}\n.user .img-holder[data-v-4c715bb8] {\n    width: 75px;\n    height: 75px;\n    border-radius: 100%;\n    overflow: hidden;\n    display: inline-block;\n}\n.user span[data-v-4c715bb8] {\n    display: block;\n}\n.user .name[data-v-4c715bb8] {\n    font-weight: 600;\n    font-size: 14px;\n    color: #555;\n}\n.user .date[data-v-4c715bb8] {\n    font-size: 11px;\n    color: #999;\n}\n.note-content[data-v-4c715bb8] {\n  background: #f5f5f5;\n  padding: 15px;\n  display: inline-block;\n  width: calc(100% - 170px);\n  /*min-height: 100px;*/\n  position: relative;\n  z-index: 2;\n  border-radius: 2px;\n  -webkit-box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);\n}\n.note-content .arrow[data-v-4c715bb8] {\n    position: absolute;\n    z-index: 2;\n    top: 30px;\n    right: 100%;\n    margin-right: -20px;\n    width: 20px;\n    height: 20px;\n    background: #f5f5f5;\n    -webkit-box-shadow: -2px 2px 1px rgba(0, 0, 0, 0.15);\n            box-shadow: -2px 2px 1px rgba(0, 0, 0, 0.15);\n    -webkit-transform: translate(-50%, 0) rotate(45deg);\n            transform: translate(-50%, 0) rotate(45deg);\n}\n.note-content .status[data-v-4c715bb8] {\n    font-size: 10px;\n    font-weight: 600;\n    padding: 2px 7px;\n    color: #fff;\n    text-transform: uppercase;\n    border-radius: 4px;\n    font-style: italic;\n    float: left;\n}\n.note-content .status.resolved[data-v-4c715bb8] {\n      background: #26D97A;\n}\n.note-content .status.investigation[data-v-4c715bb8] {\n      background: #F25E0D;\n}\n.note-content .status.new[data-v-4c715bb8] {\n      background: #F20D0D;\n}\n.note-content .status.availability[data-v-4c715bb8] {\n      background: #ab11e7;\n}\n.note-content p[data-v-4c715bb8] {\n    position: relative;\n    z-index: 3;\n    font-size: 13px;\n    margin: 0;\n    color: #555;\n    min-height: 60px;\n    word-wrap: break-word;\n}\n.note-content .actions[data-v-4c715bb8] {\n    text-align: right;\n    font-size: 12px;\n    margin-top: 10px;\n    font-weight: 600;\n}\n.note-content .actions div[data-v-4c715bb8] {\n      display: inline-block;\n}\n.note-content .actions span[data-v-4c715bb8] {\n      color: #0D79F2;\n      display: inline-block;\n      margin: 0 2px;\n      cursor: pointer;\n}\n.delete-block[data-v-4c715bb8] {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  width: 100%;\n  height: 0%;\n  visibility: hidden;\n  z-index: 2;\n  text-align: center;\n  overflow: hidden;\n  -webkit-transition: background .2s, height .2s, top .2s;\n  transition: background .2s, height .2s, top .2s;\n}\n.delete-block .content[data-v-4c715bb8] {\n    display: none;\n}\n.delete-block .content p[data-v-4c715bb8] {\n      color: #fff;\n      font-weight: 600;\n}\n.delete-block .content .button[data-v-4c715bb8] {\n      min-width: 100px;\n      margin: 0 5px;\n      display: inline-block;\n}\n.delete-block .content.disabled .button[data-v-4c715bb8] {\n      opacity: .5;\n      cursor: default;\n      font-weight: 100;\n      color: #f00;\n}\n.delete-block.show[data-v-4c715bb8] {\n    visibility: visible;\n    background: rgba(0, 0, 0, 0.8);\n    height: 100%;\n    top: 0;\n}\n.delete-block.show .content[data-v-4c715bb8] {\n      display: block;\n}\n.load-more[data-v-4c715bb8] {\n  text-align: center;\n  padding: 10px;\n  font-size: 14px;\n  color: #555;\n  cursor: pointer;\n  background: #efefef;\n  margin: 20px auto 10px;\n  font-weight: 600;\n  width: 40%;\n  border-radius: 4px;\n}\n.load-more[data-v-4c715bb8]:hover {\n    background: #e0e0e0;\n    color: #333;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__featureToggle__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  getNotes: function getNotes(VueApp, provId, callback) {
    var notes = VueApp.$store.state.provider.notes;
    var pageSize = notes.pageSize;
    var page = notes.pageNum;

    VueApp.$sdk.get('/provider/' + provId + '/notes', {
      token: VueApp.$store.state.session.sessionToken,
      order: 'created',
      orderAsc: 0,
      pageSize: pageSize,
      pageNum: page + 1
    }, function (res) {
      if (!res.error) {
        VueApp.$store.commit('provider/setNotesPage', page + 1);

        if (res.list.length < pageSize) {
          VueApp.$store.commit('provider/setNotesIsMax', true);
        }

        if (res.list.length) {
          var note = res.list;
          for (var i = 0; i < res.list.length; i++) {
            var date = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(note[i].created, 'YYYY-MM-DD@hh:mm:ss').tz('America/Los_Angeles');
            var admin = {
              name: 'Deleted Admin',
              id: 0,
              pic: 'https://s3-us-west-2.amazonaws.com/staging-backoffice/staging/default-user.jpg'
            };
            if (note[i].admin) {
              admin = {
                name: note[i].admin.firstName + ' ' + note[i].admin.lastName,
                id: note[i].admin.id,
                pic: note[i].admin.avatarUrl
              };
            }
            VueApp.$store.commit('provider/addNotes', {
              id: note[i].id,
              date: date.format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_1__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
              message: note[i].message,
              status: note[i].status,
              userId: admin.id || 0,
              name: admin.name,
              picture: admin.pic || 'https://s3-us-west-2.amazonaws.com/staging-backoffice/staging/default-user.jpg'
            });
          }
        }
      }
      callback(res);
    });
  },
  deleteNote: function deleteNote(VueApp, noteId, callback) {
    VueApp.$sdk.delete('/note/' + noteId, {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      if (!res.error) {
        VueApp.$store.commit('provider/deleteNote', noteId);
      }
      callback(res);
    });
  }
});

/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('provider.notes.loading')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"notes-type"},[_c('label',[_vm._v("Type:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.notesType),expression:"notesType"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.notesType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"notes"}},[_vm._v("General")]),_vm._v(" "),_c('option',{attrs:{"value":"availability"}},[_vm._v("Availability")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.notes.length === 0 && !_vm.loading),expression:"notes.length === 0 && !loading"}],staticClass:"empty-state"},[_c('i',{staticClass:"fa fa-address-card fa-4x"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('provider.notes.emptyState')))])]),_vm._v(" "),_vm._l((_vm.notes),function(note){return _c('div',{key:note.id,staticClass:"note"},[_c('div',{staticClass:"user"},[_c('div',{staticClass:"img-holder"},[_c('img',{attrs:{"src":note.picture}})]),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(note.name))]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v(_vm._s(note.date))])]),_vm._v(" "),_c('div',{staticClass:"note-content"},[_c('div',{staticClass:"arrow"}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(note.message)}}),_vm._v(" "),_c('div',{staticClass:"actions"},[(_vm.adminId === note.userId)?_c('div',[_c('span',{on:{"click":function($event){return _vm.editNote(note)}}},[_vm._v(_vm._s(_vm.$t('rsvpDetails.notes.edit')))]),_vm._v(" |\n          "),_c('span',{on:{"click":function($event){return _vm.deleteNote(note)}}},[_vm._v(_vm._s(_vm.$t('rsvpDetails.notes.delete')))])]):_vm._e(),_vm._v(" "),_c('label',{class:['status', note.status]},[_vm._v(_vm._s(note.status))])])]),_vm._v(" "),_c('div',{class:{'delete-block':true, 'show':_vm.noteDeleteId === note.id}},[_c('div',{class:{'content':true, 'disabled':_vm.deleteLoading}},[_c('p',[_vm._v("\n          "+_vm._s(_vm.$t('rsvpDetails.notes.deleteMessage'))+"\n          "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.deleteMessage),expression:"!!deleteMessage"}]},[_c('br'),_vm._v(" "+_vm._s(_vm.deleteMessage)+"\n          ")])]),_vm._v(" "),_c('a',{staticClass:"button cta warning small",on:{"click":_vm.hideDelete}},[_vm._v(_vm._s(_vm.$t('rsvpDetails.notes.no')))]),_vm._v(" "),_c('a',{staticClass:"button cta success small",on:{"click":function($event){return _vm.deleteConfirm(note.id)}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.deleteLoading),expression:"!deleteLoading"}]},[_vm._v(_vm._s(_vm.$t('rsvpDetails.notes.yes')))]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.deleteLoading),expression:"deleteLoading"}],staticClass:"fa fa-spinner fa-spin fa-fw"})])])])])}),_vm._v(" "),(!_vm.endOfResult && !_vm.loading)?_c('div',{staticClass:"load-more",on:{"click":_vm.getNotes}},[_vm._v("\n    Load More\n  ")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payouts_vue__ = __webpack_require__(579);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f4a0536_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payouts_vue__ = __webpack_require__(1693);
function injectStyle (ssrContext) {
  __webpack_require__(1691)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f4a0536"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payouts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f4a0536_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payouts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1692);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("9f4bfd32", content, true, {});

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.payout-account[data-v-6f4a0536] {\n  padding: 0;\n  line-height: 14px;\n  font-size: 14px;\n}\n.payout-account > *[data-v-6f4a0536] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.payout-account .link[data-v-6f4a0536] {\n    margin-left: 10px;\n}\n.payout-account i.fa-times-circle[data-v-6f4a0536] {\n    color: #F25E0D;\n}\n.payout-account i.fa-check-circle[data-v-6f4a0536] {\n    color: #26D97A;\n}\n.payout-account .default-payout[data-v-6f4a0536] {\n    color: #333;\n    font-weight: 700;\n    text-decoration: underline;\n    margin: 0 15px 0 10px;\n}\n.payout-details[data-v-6f4a0536] {\n  margin-top: 15px;\n  font-size: 14px;\n}\n.payout-details .batch-info[data-v-6f4a0536] {\n    position: relative;\n    background-color: #fff;\n    padding: 15px;\n    border-radius: 3px;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.payout-details .batch-info .details-box[data-v-6f4a0536] {\n      width: 100%;\n}\n.payout-details .batch-info .batch-title[data-v-6f4a0536] {\n      color: #555;\n}\n.payout-details .batch-info .batch-title .value[data-v-6f4a0536] {\n        font-weight: 700;\n        text-decoration: underline;\n}\n.payout-details .batch-info .batch-title .schedule[data-v-6f4a0536] {\n        margin-left: 20px;\n}\n.payout-details .batch-info .amount[data-v-6f4a0536] {\n      margin-top: 15px;\n      line-height: 14px;\n}\n.payout-details .batch-info .amount .key-value[data-v-6f4a0536] {\n        padding: 5px 0;\n}\n.payout-details .batch-info .amount .key-value > span[data-v-6f4a0536] {\n          display: inline-block;\n          vertical-align: middle;\n          width: 60px;\n          color: #555;\n}\n.payout-details .batch-info .amount .key-value > span.value[data-v-6f4a0536] {\n          width: 140px;\n          text-align: right;\n          font-weight: 600;\n          color: #444;\n}\n.payout-details .batch-info .amount .key-value > span.box-icon[data-v-6f4a0536] {\n          width: 15px;\n          height: 15px;\n          background-color: red;\n}\n.payout-details .batch-info .amount .key-value > span.box-icon.credit[data-v-6f4a0536] {\n            background-color: #26D97A;\n}\n.payout-details .batch-info .amount .key-value > span.box-icon.debit[data-v-6f4a0536] {\n            background-color: #F25E0D;\n}\n.payout-details .batch-info .amount .key-value > span.box-icon.total[data-v-6f4a0536] {\n            background-color: #0D79F2;\n}\n.payout-details .batch-info .amount .key-value.total[data-v-6f4a0536] {\n          padding-top: 10px;\n          margin-top: 10px;\n          width: 224px;\n          font-size: 16px;\n          line-height: 16px;\n          border-top: 1px solid rgba(0, 0, 0, 0.3);\n}\n.payout-details .batch-info .amount .key-value.total .value[data-v-6f4a0536] {\n            font-weight: 700;\n            color: #0D79F2;\n            font-size: 18px;\n}\n.payout-details .batch-info .batch-filter[data-v-6f4a0536] {\n      width: 200px;\n      text-align: right;\n}\n.payout-details .batch-info .batch-filter select[data-v-6f4a0536] {\n        margin-top: 5px;\n        border: 1px solid #ccc;\n        padding: 10px;\n        color: #333;\n        height: 40px;\n        position: relative;\n        font-size: 14px;\n        outline: none;\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        background: url(\"/assets/img/down.png\") no-repeat 173px 9px;\n        -webkit-transition: all .35s ease;\n        transition: all .35s ease;\n}\n.payout-details .batch-info .batch-filter .batch-btn[data-v-6f4a0536] {\n        display: block;\n        margin-top: 10px;\n}\n.payout-details .batch-transactions[data-v-6f4a0536] {\n    margin-top: 15px;\n    background-color: #fff;\n    padding: 15px;\n    border-radius: 3px;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n.payout-details .batch-transactions .title[data-v-6f4a0536] {\n      font-size: 12px;\n      font-weight: 700;\n      color: #555;\n      margin-bottom: 10px;\n}\n.payout-details .batch-transactions .empty-transactions[data-v-6f4a0536] {\n      text-align: center;\n      color: #555;\n      padding: 30px 0;\n}\n.payout-details .batch-transactions .empty-transactions > i[data-v-6f4a0536] {\n        color: #777;\n}\n.payout-details .date-range[data-v-6f4a0536] {\n    margin: 5px 0 3px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify !important;\n        -ms-flex-pack: justify !important;\n            justify-content: space-between !important;\n}\n.payout-details .error-msg[data-v-6f4a0536] {\n    color: #f00;\n    display: block;\n    font-size: 13px;\n    text-align: center;\n}\n.payout-details .transaction[data-v-6f4a0536] {\n    position: relative;\n    padding: 10px 0 12px;\n    border-top: 1px solid rgba(0, 0, 0, 0.2);\n}\n.payout-details .transaction > .date[data-v-6f4a0536],\n    .payout-details .transaction > .type[data-v-6f4a0536],\n    .payout-details .transaction > .description[data-v-6f4a0536],\n    .payout-details .transaction > .note[data-v-6f4a0536],\n    .payout-details .transaction > .controls[data-v-6f4a0536] {\n      vertical-align: middle;\n}\n.payout-details .transaction .date[data-v-6f4a0536] {\n      font-size: 12px;\n      line-height: 12px;\n      font-weight: 700;\n      color: #555;\n      margin-top: 5px;\n      margin-bottom: 5px;\n}\n.payout-details .transaction .type[data-v-6f4a0536] {\n      font-size: 11px;\n      line-height: 11px;\n      text-transform: uppercase;\n      font-weight: 700;\n      color: #fff;\n      display: inline-block;\n      padding: 3px 5px 4px;\n      border-radius: 3px;\n      width: 50px;\n      text-align: center;\n}\n.payout-details .transaction .type.credit[data-v-6f4a0536] {\n        background-color: #26D97A;\n}\n.payout-details .transaction .type.debit[data-v-6f4a0536] {\n        background-color: #F25E0D;\n}\n.payout-details .transaction .description[data-v-6f4a0536] {\n      display: inline-block;\n      margin-left: 10px;\n}\n.payout-details .transaction .description a[data-v-6f4a0536] {\n        font-weight: 700;\n}\n.payout-details .transaction .note[data-v-6f4a0536] {\n      color: #555;\n      font-size: 16px;\n      margin: 0 15px;\n}\n.payout-details .transaction .controls[data-v-6f4a0536] {\n      position: absolute;\n      right: 0;\n      top: 20px;\n}\n.payout-details .transaction .controls .xsmall[data-v-6f4a0536] {\n        font-size: 12px;\n        padding: 5px 7px;\n}\n.payout-details .transaction .amount[data-v-6f4a0536] {\n      font-size: 18px;\n      font-weight: 700;\n      position: absolute;\n      top: 20px;\n      right: 130px;\n}\n.payout-details .transaction.no-controls .amount[data-v-6f4a0536] {\n      right: 0;\n}\n.payout-details .transaction .remove-prompt[data-v-6f4a0536] {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      text-align: center;\n      background-color: rgba(0, 0, 0, 0.7);\n      color: #fff;\n      font-weight: 700;\n}\n.payout-details .transaction .remove-prompt .message[data-v-6f4a0536] {\n        padding: 7px 0 5px;\n}\n.payout-details .transaction .remove-prompt .xsmall[data-v-6f4a0536] {\n        font-size: 12px;\n        padding: 5px 7px;\n        margin: 0 5px;\n}\n.payout-details .transaction .remove-prompt .removing-message[data-v-6f4a0536] {\n        padding: 20px 0;\n}\n.payout-details .transaction .remove-prompt .removing-message > *[data-v-6f4a0536] {\n          display: inline-block;\n          vertical-align: middle;\n}\n.dtp[data-v-6f4a0536] {\n  padding: 0;\n}\n.batch-status[data-v-6f4a0536] {\n  position: absolute;\n  top: 40px;\n  left: 300px;\n  width: 400px;\n  text-align: center;\n}\n.batch-status .fa-check-circle[data-v-6f4a0536] {\n    color: #26D97A;\n}\n.batch-status .fa-times-circle[data-v-6f4a0536] {\n    color: #F20D0D;\n}\n.batch-status .fa-exclamation-circle[data-v-6f4a0536] {\n    color: #F25E0D;\n}\n.batch-status .message[data-v-6f4a0536] {\n    margin-top: 5px;\n}\n.no-permission[data-v-6f4a0536] {\n  text-align: center;\n  color: #777;\n  padding: 30px 0;\n}\n.no-permission .message[data-v-6f4a0536] {\n    margin-top: 10px;\n    color: #555;\n}\n.loading-trx[data-v-6f4a0536] {\n  display: block;\n  text-align: center;\n  padding: 30px 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #555;\n}\n.loading-trx > *[data-v-6f4a0536] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.loading-trx > span[data-v-6f4a0536] {\n    margin-left: 10px;\n}\n.lr-modal[data-v-6f4a0536] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99119;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-6f4a0536] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-6f4a0536] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  min-width: 300px;\n  max-width: 500px;\n}\n.lr-alert-msg[data-v-6f4a0536] {\n  margin-bottom: 20px;\n  color: #45505b;\n}\n.lr-alert-msg input[data-v-6f4a0536] {\n    width: auto;\n    display: inline-block;\n}\n@media only screen and (max-width: 430px) {\n.payouts .payout-details[data-v-6f4a0536] {\n    width: 90vw;\n}\n.payouts .payout-details .batch-info .batch-filter[data-v-6f4a0536] {\n      position: initial;\n      margin: 0 auto;\n      margin-top: 15px;\n}\n.payouts .payout-details .batch-info .batch-status[data-v-6f4a0536] {\n      position: initial;\n      width: auto;\n}\n.payouts .payout-details .batch-info .amount .key-value > span.value[data-v-6f4a0536] {\n      width: 70%;\n}\n.payouts .payout-details .batch-info .amount .key-value.total[data-v-6f4a0536] {\n      width: 100%;\n}\n.payouts .payout-details .transaction .amount[data-v-6f4a0536] {\n      position: initial;\n      margin: 10px 0;\n}\n.payouts .payout-details .transaction .controls[data-v-6f4a0536] {\n      position: initial;\n}\n.payouts .payout-details .transaction .controls .xsmall[data-v-6f4a0536] {\n        padding: 8px 13px 9px;\n}\n}\n@media only screen and (max-width: 430px) {\n.pay-div[data-v-6f4a0536] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    gap: 10px;\n    margin-bottom: 10px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Provider/Payouts.vue"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;CACjB;AACD;IACI,sBAAsB;IACtB,uBAAuB;CAC1B;AACD;IACI,kBAAkB;CACrB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,2BAA2B;IAC3B,sBAAsB;CACzB;AACD;EACE,iBAAiB;EACjB,gBAAgB;CACjB;AACD;IACI,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,mBAAmB;IACnB,iDAAiD;YACzC,yCAAyC;IACjD,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;MACM,YAAY;CACjB;AACD;MACM,YAAY;CACjB;AACD;QACQ,iBAAiB;QACjB,2BAA2B;CAClC;AACD;QACQ,kBAAkB;CACzB;AACD;MACM,iBAAiB;MACjB,kBAAkB;CACvB;AACD;QACQ,eAAe;CACtB;AACD;UACU,sBAAsB;UACtB,uBAAuB;UACvB,YAAY;UACZ,YAAY;CACrB;AACD;UACU,aAAa;UACb,kBAAkB;UAClB,iBAAiB;UACjB,YAAY;CACrB;AACD;UACU,YAAY;UACZ,aAAa;UACb,sBAAsB;CAC/B;AACD;YACY,0BAA0B;CACrC;AACD;YACY,0BAA0B;CACrC;AACD;YACY,0BAA0B;CACrC;AACD;UACU,kBAAkB;UAClB,iBAAiB;UACjB,aAAa;UACb,gBAAgB;UAChB,kBAAkB;UAClB,yCAAyC;CAClD;AACD;YACY,iBAAiB;YACjB,eAAe;YACf,gBAAgB;CAC3B;AACD;MACM,aAAa;MACb,kBAAkB;CACvB;AACD;QACQ,gBAAgB;QAChB,uBAAuB;QACvB,cAAc;QACd,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,gBAAgB;QAChB,cAAc;QACd,yBAAyB;QACzB,sBAAsB;QACtB,iBAAiB;QACjB,4DAA4D;QAC5D,kCAAkC;QAClC,0BAA0B;CACjC;AACD;QACQ,eAAe;QACf,iBAAiB;CACxB;AACD;IACI,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;IACd,mBAAmB;IACnB,iDAAiD;YACzC,yCAAyC;CACpD;AACD;MACM,gBAAgB;MAChB,iBAAiB;MACjB,YAAY;MACZ,oBAAoB;CACzB;AACD;MACM,mBAAmB;MACnB,YAAY;MACZ,gBAAgB;CACrB;AACD;QACQ,YAAY;CACnB;AACD;IACI,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,qCAAqC;QACjC,kCAAkC;YAC9B,0CAA0C;CACrD;AACD;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;CACtB;AACD;IACI,mBAAmB;IACnB,qBAAqB;IACrB,yCAAyC;CAC5C;AACD;;;;;MAKM,uBAAuB;CAC5B;AACD;MACM,gBAAgB;MAChB,kBAAkB;MAClB,iBAAiB;MACjB,YAAY;MACZ,gBAAgB;MAChB,mBAAmB;CACxB;AACD;MACM,gBAAgB;MAChB,kBAAkB;MAClB,0BAA0B;MAC1B,iBAAiB;MACjB,YAAY;MACZ,sBAAsB;MACtB,qBAAqB;MACrB,mBAAmB;MACnB,YAAY;MACZ,mBAAmB;CACxB;AACD;QACQ,0BAA0B;CACjC;AACD;QACQ,0BAA0B;CACjC;AACD;MACM,sBAAsB;MACtB,kBAAkB;CACvB;AACD;QACQ,iBAAiB;CACxB;AACD;MACM,YAAY;MACZ,gBAAgB;MAChB,eAAe;CACpB;AACD;MACM,mBAAmB;MACnB,SAAS;MACT,UAAU;CACf;AACD;QACQ,gBAAgB;QAChB,iBAAiB;CACxB;AACD;MACM,gBAAgB;MAChB,iBAAiB;MACjB,mBAAmB;MACnB,UAAU;MACV,aAAa;CAClB;AACD;MACM,SAAS;CACd;AACD;MACM,mBAAmB;MACnB,OAAO;MACP,QAAQ;MACR,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,qCAAqC;MACrC,YAAY;MACZ,iBAAiB;CACtB;AACD;QACQ,mBAAmB;CAC1B;AACD;QACQ,gBAAgB;QAChB,iBAAiB;QACjB,cAAc;CACrB;AACD;QACQ,gBAAgB;CACvB;AACD;UACU,sBAAsB;UACtB,uBAAuB;CAChC;AACD;EACE,WAAW;CACZ;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;CACpB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,gBAAgB;CACnB;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;CACjB;AACD;IACI,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;CACb;AACD;IACI,sBAAsB;IACtB,uBAAuB;CAC1B;AACD;IACI,kBAAkB;CACrB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oCAAoC;MAChC,iCAAiC;UAC7B,mCAAmC;EAC3C,qCAAqC;MACjC,kCAAkC;UAC9B,+BAA+B;EACvC,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;EACnD,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;CAClB;AACD;EACE,oBAAoB;EACpB,eAAe;CAChB;AACD;IACI,YAAY;IACZ,sBAAsB;CACzB;AACD;AACA;IACI,YAAY;CACf;AACD;MACM,kBAAkB;MAClB,eAAe;MACf,iBAAiB;CACtB;AACD;MACM,kBAAkB;MAClB,YAAY;CACjB;AACD;MACM,WAAW;CAChB;AACD;MACM,YAAY;CACjB;AACD;MACM,kBAAkB;MAClB,eAAe;CACpB;AACD;MACM,kBAAkB;CACvB;AACD;QACQ,sBAAsB;CAC7B;CACA;AACD;AACA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,6BAA6B;IAC7B,8BAA8B;QAC1B,2BAA2B;YACvB,uBAAuB;IAC/B,UAAU;IACV,oBAAoB;CACvB;CACA","file":"Payouts.vue","sourcesContent":["\n.payout-account[data-v-6f4a0536] {\n  padding: 0;\n  line-height: 14px;\n  font-size: 14px;\n}\n.payout-account > *[data-v-6f4a0536] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.payout-account .link[data-v-6f4a0536] {\n    margin-left: 10px;\n}\n.payout-account i.fa-times-circle[data-v-6f4a0536] {\n    color: #F25E0D;\n}\n.payout-account i.fa-check-circle[data-v-6f4a0536] {\n    color: #26D97A;\n}\n.payout-account .default-payout[data-v-6f4a0536] {\n    color: #333;\n    font-weight: 700;\n    text-decoration: underline;\n    margin: 0 15px 0 10px;\n}\n.payout-details[data-v-6f4a0536] {\n  margin-top: 15px;\n  font-size: 14px;\n}\n.payout-details .batch-info[data-v-6f4a0536] {\n    position: relative;\n    background-color: #fff;\n    padding: 15px;\n    border-radius: 3px;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.payout-details .batch-info .details-box[data-v-6f4a0536] {\n      width: 100%;\n}\n.payout-details .batch-info .batch-title[data-v-6f4a0536] {\n      color: #555;\n}\n.payout-details .batch-info .batch-title .value[data-v-6f4a0536] {\n        font-weight: 700;\n        text-decoration: underline;\n}\n.payout-details .batch-info .batch-title .schedule[data-v-6f4a0536] {\n        margin-left: 20px;\n}\n.payout-details .batch-info .amount[data-v-6f4a0536] {\n      margin-top: 15px;\n      line-height: 14px;\n}\n.payout-details .batch-info .amount .key-value[data-v-6f4a0536] {\n        padding: 5px 0;\n}\n.payout-details .batch-info .amount .key-value > span[data-v-6f4a0536] {\n          display: inline-block;\n          vertical-align: middle;\n          width: 60px;\n          color: #555;\n}\n.payout-details .batch-info .amount .key-value > span.value[data-v-6f4a0536] {\n          width: 140px;\n          text-align: right;\n          font-weight: 600;\n          color: #444;\n}\n.payout-details .batch-info .amount .key-value > span.box-icon[data-v-6f4a0536] {\n          width: 15px;\n          height: 15px;\n          background-color: red;\n}\n.payout-details .batch-info .amount .key-value > span.box-icon.credit[data-v-6f4a0536] {\n            background-color: #26D97A;\n}\n.payout-details .batch-info .amount .key-value > span.box-icon.debit[data-v-6f4a0536] {\n            background-color: #F25E0D;\n}\n.payout-details .batch-info .amount .key-value > span.box-icon.total[data-v-6f4a0536] {\n            background-color: #0D79F2;\n}\n.payout-details .batch-info .amount .key-value.total[data-v-6f4a0536] {\n          padding-top: 10px;\n          margin-top: 10px;\n          width: 224px;\n          font-size: 16px;\n          line-height: 16px;\n          border-top: 1px solid rgba(0, 0, 0, 0.3);\n}\n.payout-details .batch-info .amount .key-value.total .value[data-v-6f4a0536] {\n            font-weight: 700;\n            color: #0D79F2;\n            font-size: 18px;\n}\n.payout-details .batch-info .batch-filter[data-v-6f4a0536] {\n      width: 200px;\n      text-align: right;\n}\n.payout-details .batch-info .batch-filter select[data-v-6f4a0536] {\n        margin-top: 5px;\n        border: 1px solid #ccc;\n        padding: 10px;\n        color: #333;\n        height: 40px;\n        position: relative;\n        font-size: 14px;\n        outline: none;\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        background: url(\"/assets/img/down.png\") no-repeat 173px 9px;\n        -webkit-transition: all .35s ease;\n        transition: all .35s ease;\n}\n.payout-details .batch-info .batch-filter .batch-btn[data-v-6f4a0536] {\n        display: block;\n        margin-top: 10px;\n}\n.payout-details .batch-transactions[data-v-6f4a0536] {\n    margin-top: 15px;\n    background-color: #fff;\n    padding: 15px;\n    border-radius: 3px;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n.payout-details .batch-transactions .title[data-v-6f4a0536] {\n      font-size: 12px;\n      font-weight: 700;\n      color: #555;\n      margin-bottom: 10px;\n}\n.payout-details .batch-transactions .empty-transactions[data-v-6f4a0536] {\n      text-align: center;\n      color: #555;\n      padding: 30px 0;\n}\n.payout-details .batch-transactions .empty-transactions > i[data-v-6f4a0536] {\n        color: #777;\n}\n.payout-details .date-range[data-v-6f4a0536] {\n    margin: 5px 0 3px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify !important;\n        -ms-flex-pack: justify !important;\n            justify-content: space-between !important;\n}\n.payout-details .error-msg[data-v-6f4a0536] {\n    color: #f00;\n    display: block;\n    font-size: 13px;\n    text-align: center;\n}\n.payout-details .transaction[data-v-6f4a0536] {\n    position: relative;\n    padding: 10px 0 12px;\n    border-top: 1px solid rgba(0, 0, 0, 0.2);\n}\n.payout-details .transaction > .date[data-v-6f4a0536],\n    .payout-details .transaction > .type[data-v-6f4a0536],\n    .payout-details .transaction > .description[data-v-6f4a0536],\n    .payout-details .transaction > .note[data-v-6f4a0536],\n    .payout-details .transaction > .controls[data-v-6f4a0536] {\n      vertical-align: middle;\n}\n.payout-details .transaction .date[data-v-6f4a0536] {\n      font-size: 12px;\n      line-height: 12px;\n      font-weight: 700;\n      color: #555;\n      margin-top: 5px;\n      margin-bottom: 5px;\n}\n.payout-details .transaction .type[data-v-6f4a0536] {\n      font-size: 11px;\n      line-height: 11px;\n      text-transform: uppercase;\n      font-weight: 700;\n      color: #fff;\n      display: inline-block;\n      padding: 3px 5px 4px;\n      border-radius: 3px;\n      width: 50px;\n      text-align: center;\n}\n.payout-details .transaction .type.credit[data-v-6f4a0536] {\n        background-color: #26D97A;\n}\n.payout-details .transaction .type.debit[data-v-6f4a0536] {\n        background-color: #F25E0D;\n}\n.payout-details .transaction .description[data-v-6f4a0536] {\n      display: inline-block;\n      margin-left: 10px;\n}\n.payout-details .transaction .description a[data-v-6f4a0536] {\n        font-weight: 700;\n}\n.payout-details .transaction .note[data-v-6f4a0536] {\n      color: #555;\n      font-size: 16px;\n      margin: 0 15px;\n}\n.payout-details .transaction .controls[data-v-6f4a0536] {\n      position: absolute;\n      right: 0;\n      top: 20px;\n}\n.payout-details .transaction .controls .xsmall[data-v-6f4a0536] {\n        font-size: 12px;\n        padding: 5px 7px;\n}\n.payout-details .transaction .amount[data-v-6f4a0536] {\n      font-size: 18px;\n      font-weight: 700;\n      position: absolute;\n      top: 20px;\n      right: 130px;\n}\n.payout-details .transaction.no-controls .amount[data-v-6f4a0536] {\n      right: 0;\n}\n.payout-details .transaction .remove-prompt[data-v-6f4a0536] {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      text-align: center;\n      background-color: rgba(0, 0, 0, 0.7);\n      color: #fff;\n      font-weight: 700;\n}\n.payout-details .transaction .remove-prompt .message[data-v-6f4a0536] {\n        padding: 7px 0 5px;\n}\n.payout-details .transaction .remove-prompt .xsmall[data-v-6f4a0536] {\n        font-size: 12px;\n        padding: 5px 7px;\n        margin: 0 5px;\n}\n.payout-details .transaction .remove-prompt .removing-message[data-v-6f4a0536] {\n        padding: 20px 0;\n}\n.payout-details .transaction .remove-prompt .removing-message > *[data-v-6f4a0536] {\n          display: inline-block;\n          vertical-align: middle;\n}\n.dtp[data-v-6f4a0536] {\n  padding: 0;\n}\n.batch-status[data-v-6f4a0536] {\n  position: absolute;\n  top: 40px;\n  left: 300px;\n  width: 400px;\n  text-align: center;\n}\n.batch-status .fa-check-circle[data-v-6f4a0536] {\n    color: #26D97A;\n}\n.batch-status .fa-times-circle[data-v-6f4a0536] {\n    color: #F20D0D;\n}\n.batch-status .fa-exclamation-circle[data-v-6f4a0536] {\n    color: #F25E0D;\n}\n.batch-status .message[data-v-6f4a0536] {\n    margin-top: 5px;\n}\n.no-permission[data-v-6f4a0536] {\n  text-align: center;\n  color: #777;\n  padding: 30px 0;\n}\n.no-permission .message[data-v-6f4a0536] {\n    margin-top: 10px;\n    color: #555;\n}\n.loading-trx[data-v-6f4a0536] {\n  display: block;\n  text-align: center;\n  padding: 30px 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #555;\n}\n.loading-trx > *[data-v-6f4a0536] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.loading-trx > span[data-v-6f4a0536] {\n    margin-left: 10px;\n}\n.lr-modal[data-v-6f4a0536] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99119;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-6f4a0536] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-6f4a0536] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  min-width: 300px;\n  max-width: 500px;\n}\n.lr-alert-msg[data-v-6f4a0536] {\n  margin-bottom: 20px;\n  color: #45505b;\n}\n.lr-alert-msg input[data-v-6f4a0536] {\n    width: auto;\n    display: inline-block;\n}\n@media only screen and (max-width: 430px) {\n.payouts .payout-details[data-v-6f4a0536] {\n    width: 90vw;\n}\n.payouts .payout-details .batch-info .batch-filter[data-v-6f4a0536] {\n      position: initial;\n      margin: 0 auto;\n      margin-top: 15px;\n}\n.payouts .payout-details .batch-info .batch-status[data-v-6f4a0536] {\n      position: initial;\n      width: auto;\n}\n.payouts .payout-details .batch-info .amount .key-value > span.value[data-v-6f4a0536] {\n      width: 70%;\n}\n.payouts .payout-details .batch-info .amount .key-value.total[data-v-6f4a0536] {\n      width: 100%;\n}\n.payouts .payout-details .transaction .amount[data-v-6f4a0536] {\n      position: initial;\n      margin: 10px 0;\n}\n.payouts .payout-details .transaction .controls[data-v-6f4a0536] {\n      position: initial;\n}\n.payouts .payout-details .transaction .controls .xsmall[data-v-6f4a0536] {\n        padding: 8px 13px 9px;\n}\n}\n@media only screen and (max-width: 430px) {\n.pay-div[data-v-6f4a0536] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    gap: 10px;\n    margin-bottom: 10px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.hasPermission)?_c('div',{staticClass:"no-permission"},[_c('i',{staticClass:"far fa-frown fa-2x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("You don't have permission to access the driver payouts.")])]):_c('div',[_c('div',{staticClass:"payouts"},[_c('div',{staticClass:"payout-account"},[_c('div',{staticClass:"title"},[(_vm.payoutAccount !== null && _vm.payoutAccount.defaultPayoutMethod !== null)?_c('div',{staticClass:"pay-div"},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"default-payout"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.payoutAccount.defaultPayoutMethod.accountType === 'bank_account'),expression:"payoutAccount.defaultPayoutMethod.accountType === 'bank_account'"}],staticClass:"fa fa-university"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.payoutAccount.defaultPayoutMethod.accountType === 'card'),expression:"payoutAccount.defaultPayoutMethod.accountType === 'card'"}],staticClass:"fa fa-credit-card"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.payoutAccount.defaultPayoutMethod.accountBrand))]),_vm._v(" "),_c('span',[_vm._v("("+_vm._s(_vm.payoutAccount.defaultPayoutMethod.lastFour)+")")])]),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"href":_vm.payoutAccount.execRideUrl,"target":"_blank"}},[_c('span',[_vm._v("Executive Ride")]),_vm._v(" "),_c('i',{staticClass:"fa fa-external-link-alt"})]),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"href":_vm.payoutAccount.firstClassUrl,"target":"_blank"}},[_c('span',[_vm._v("First Class Transportation")]),_vm._v(" "),_c('i',{staticClass:"fa fa-external-link-alt"})])]):_c('div',[_c('i',{staticClass:"fa fa-times-circle"}),_vm._v(" "),_c('span',[_vm._v("Auto-Deposit Disabled")])])])]),_vm._v(" "),_c('div',{staticClass:"payout-details"},[_c('div',{staticClass:"batch-info"},[_c('div',{staticClass:"details-box"},[(_vm.filter.selectedWeek !== null)?_c('div',{staticClass:"batch-title"},[_c('span',[_vm._v("Payout for")]),_vm._v(" "),(!_vm.filter.selectedWeek.isCustom)?_c('span',{staticClass:"value"},[_vm._v("\n                "+_vm._s(_vm.filter.selectedWeek.start ? _vm.filter.selectedWeek.start.format('MMMM DD') : '')+" - \n                "+_vm._s(_vm.filter.selectedWeek.end ? _vm.filter.selectedWeek.end.format('MMMM DD') : '')+"\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(_vm.formatDate(_vm.startDate))+" -\n                "+_vm._s(_vm.formatDate(_vm.endDate))+"\n              ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"amount"},[_c('div',{staticClass:"key-value"},[_c('span',{staticClass:"box-icon credit"}),_vm._v(" "),_c('span',[_vm._v("Credit")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("$"+_vm._s(_vm.batch.credit.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"key-value"},[_c('span',{staticClass:"box-icon debit"}),_vm._v(" "),_c('span',[_vm._v("Debit")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("- ($"+_vm._s(_vm.batch.debit.toFixed(2))+")")])]),_vm._v(" "),_c('div',{staticClass:"separator"}),_vm._v(" "),_c('div',{staticClass:"key-value total"},[_c('span',{staticClass:"box-icon total"}),_vm._v(" "),_c('span',[_vm._v("Total")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("$"+_vm._s((_vm.batch.credit - _vm.batch.debit).toFixed(2)))])])]),_vm._v(" "),(_vm.batch.item !== null)?_c('div',{staticClass:"batch-status"},[(_vm.batch.item.payoutStatus === 'paid')?_c('div',[_c('i',{staticClass:"fa fa-check-circle fa-2x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("This batch was already paid to the driver.")])]):_vm._e(),_vm._v(" "),(_vm.batch.item.payoutStatus === 'pending')?_c('div',[_c('i',{staticClass:"fa fa-exclamation-circle fa-2x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("This batch is not paid yet.")])]):_vm._e(),_vm._v(" "),(_vm.batch.item.payoutStatus === 'in_transit')?_c('div',[_c('i',{staticClass:"fa fa-exclamation-circle fa-2x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("The payment for this batch is on the way to the driver's account.")])]):_vm._e(),_vm._v(" "),(_vm.batch.item.payoutStatus === 'failed')?_c('div',[_c('i',{staticClass:"fa fa-times-circle fa-2x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("Something went wrong for the payout of this batch.")])]):_vm._e(),_vm._v(" "),(_vm.batch.item.payoutStatus === 'canceled')?_c('div',[_c('i',{staticClass:"fa fa-times-circle fa-2x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("This payout batch has been cancelled.")])]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.filter.weeks !== null)?_c('div',{staticClass:"batch-filter"},[_c('div',{staticClass:"select-input"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter.selectedWeek),expression:"filter.selectedWeek"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filter, "selectedWeek", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.initTransactions]}},[_vm._l((_vm.filter.weeks),function(week,index){return _c('option',{key:index,domProps:{"value":week}},[_vm._v("\n                    "+_vm._s(week.start.format('MMM DD'))+" - "+_vm._s(week.end.format('MMM DD'))+"\n                  ")])}),_vm._v(" "),_c('option',{domProps:{"value":_vm.customVal}},[_vm._v("Custom Date")])],2)]),_vm._v(" "),(_vm.filter.selectedWeek.isCustom)?_c('div',{staticClass:"date-range"},[_c('div',[_c('datepicker',{class:['datepicker inline rtl-dp'],attrs:{"format":"MMM dd","placeholder":"Start","input-class":"dtp","disabled-picker":_vm.downloading},on:{"input":_vm.changeDateRange},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})],1),_vm._v(" "),_c('div',[_c('datepicker',{class:['datepicker inline rtl-dp', {'has-error':!!_vm.validation.startDate}],attrs:{"format":"MMM dd","placeholder":"End","input-class":"dtp","disabled-picker":_vm.downloading},on:{"input":_vm.changeDateRange},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})],1)]):_vm._e(),_vm._v(" "),(!!_vm.validation.startDate)?_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.startDate))]):_vm._e(),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions != null && _vm.transactions.length > 0),expression:"transactions != null && transactions.length > 0"}],class:{ 'batch-btn button cta xsmall': true, disabled: _vm.downloading },attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.dlModal = true}}},[_c('i',{staticClass:"fa fa-print"}),_vm._v(" "),_c('span',[_vm._v("DOWNLOAD RECEIPT")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCurrentBatch),expression:"isCurrentBatch"}],staticClass:"batch-btn button cta xsmall success",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.showPayoutForm(null)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "),_c('span',[_vm._v("ADD TRANSACTION")])]),_vm._v(" "),(_vm.batch.item !== null && _vm.batch.item.payoutStatus !== 'paid' && _vm.batch.item.providerExternalAccountId === null && _vm.batch.item.amount > 0)?_c('a',{class:{ 'batch-btn button cta xsmall success': true, disabled: _vm.batch.updating },attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.markAsPaid(_vm.batch.item)}}},[_vm._v("\n                CHECK ISSUED\n              ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"batch-transactions"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingTransactions),expression:"loadingTransactions"}],staticClass:"loading-trx"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-lg"}),_c('span',[_vm._v("LOADING TRANSACTIONS...")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loadingTransactions),expression:"!loadingTransactions"}]},[(_vm.transactions !== null && _vm.transactions.length <= 0)?_c('div',{staticClass:"empty-transactions"},[_c('i',{staticClass:"fa fa-folder-open fa-2x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("This driver does not have any transaction for this period.")])]):_c('div',[_c('div',{staticClass:"title"},[_vm._v("BATCH TRANSACTIONS")]),_vm._v(" "),_vm._l((_vm.transactions),function(trx,index){return _c('div',{class:{ transaction: true, 'no-controls': !_vm.isCurrentBatch }},[_c('div',{staticClass:"date"},[_vm._v(_vm._s(trx.created))]),_vm._v(" "),_c('div',{class:[ 'type', trx.type ]},[_vm._v(_vm._s(trx.type))]),_vm._v(" "),_c('div',{staticClass:"description"},[(trx.reservationId === null && trx.packageId === null)?_c('span',[_vm._v(_vm._s(trx.origDescription))]):_vm._e(),_vm._v(" "),(trx.reservationId !== null || trx.packageId !== null)?_c('span',[_vm._v(_vm._s(trx.description))]):_vm._e(),_vm._v(" "),(trx.reservationId !== null)?_c('a',{attrs:{"href":'/#/reservation/' + trx.reservationId,"target":"_blank"}},[_vm._v("Reservation "+_vm._s(trx.reservationId))]):_vm._e(),_vm._v(" "),(trx.packageId !== null)?_c('a',{attrs:{"href":'/#/package/' + trx.packageId,"target":"_blank"}},[_vm._v("Package "+_vm._s(trx.packageId))]):_vm._e()]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(trx.notes !== null && trx.notes !== ''),expression:"trx.notes !== null && trx.notes !== ''"}],staticClass:"note",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.showNotes(trx)}}},[_c('i',{staticClass:"fa fa-comment-dots"})]),_vm._v(" "),_c('div',{staticClass:"amount"},[(trx.type === 'credit')?_c('span',[_vm._v("$"+_vm._s(trx.amount.toFixed(2)))]):_c('span',[_vm._v("- ($"+_vm._s(trx.amount.toFixed(2))+")")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCurrentBatch),expression:"isCurrentBatch"}],staticClass:"controls"},[_c('a',{staticClass:"button cta xsmall",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.showPayoutForm(trx)}}},[_vm._v("EDIT")]),_vm._v(" "),_c('a',{staticClass:"button cta error xsmall",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.toggleRemovePrompt(index)}}},[_vm._v("REMOVE")])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(trx.showRemove),expression:"trx.showRemove"}],staticClass:"remove-prompt"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.removingTransaction),expression:"!removingTransaction"}]},[_c('div',{staticClass:"message"},[_vm._v("Are you sure you want to remove this transaction?")]),_vm._v(" "),_c('div',{staticClass:"remove-controls"},[_c('a',{staticClass:"button cta xsmall warning",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.removeTransaction(index)}}},[_vm._v("YES")]),_vm._v(" "),_c('a',{staticClass:"button cta xsmall",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.toggleRemovePrompt(index)}}},[_vm._v("NO")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.removingTransaction),expression:"removingTransaction"}]},[_c('div',{staticClass:"removing-message"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',[_vm._v("REMOVING TRANSACTION...")])])])])])],1)})],2)])])])])]),_vm._v(" "),_c('div',{class:['lr-modal', {'hide': !_vm.dlModal}]},[_c('div',{staticClass:"lr-box"},[_c('div',{staticClass:"lr-alert-msg",staticStyle:{"margin-bottom":"30px"}},[_c('b',[_vm._v("Download receipt:")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-space-around"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dlVia),expression:"dlVia"}],attrs:{"type":"radio","value":"pdf"},domProps:{"checked":_vm._q(_vm.dlVia,"pdf")},on:{"change":function($event){_vm.dlVia="pdf"}}}),_vm._v("\n            PDF\n          ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dlVia),expression:"dlVia"}],attrs:{"type":"radio","value":"csv"},domProps:{"checked":_vm._q(_vm.dlVia,"csv")},on:{"change":function($event){_vm.dlVia="csv"}}}),_vm._v("\n            CSV\n          ")])])]),_vm._v(" "),_c('a',{staticClass:"button success small block",on:{"click":_vm.initDownload}},[_vm._v("Download")]),_vm._v(" "),_c('a',{staticClass:"button small secondary block",staticStyle:{"margin-top":"10px"},on:{"click":function($event){_vm.dlModal = false}}},[_vm._v("\n        Cancel\n      ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fa fa-check-circle"}),_vm._v(" "),_c('span',[_vm._v("Auto-Deposit Enabled")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayoutForm_vue__ = __webpack_require__(580);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb152e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayoutForm_vue__ = __webpack_require__(1697);
function injectStyle (ssrContext) {
  __webpack_require__(1695)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bb152e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayoutForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb152e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayoutForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1696);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("332ecc72", content, true, {});

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.payout-form[data-v-1bb152e6] {\n  width: 500px;\n  margin: 0 auto;\n  border-radius: 3px;\n  font-size: 14px;\n  background-color: #fff;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n}\n.payout-form .title[data-v-1bb152e6] {\n    text-align: center;\n    color: #fff;\n    font-weight: 700;\n    background-color: #0D79F2;\n    padding: 10px 0;\n}\n.payout-form .controls[data-v-1bb152e6] {\n    text-align: center;\n    padding: 5px 0 15px;\n}\n.payout-form .controls .button[data-v-1bb152e6] {\n      width: 80px;\n}\n.form-fields[data-v-1bb152e6] {\n  padding: 10px 8px;\n}\n.field-input[data-v-1bb152e6] {\n  position: relative;\n}\n.field-input label[data-v-1bb152e6] {\n    font-size: 10px;\n    font-weight: 700;\n    color: #0D79F2;\n}\n.field-input select[data-v-1bb152e6] {\n    margin-top: 0;\n    border: 1px solid #ccc;\n    padding: 10px;\n    color: #333;\n    height: 40px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background: url(\"/assets/img/down.png\") no-repeat 200px 9px;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.field-input input[data-v-1bb152e6] {\n    margin-top: 0;\n    padding: 8px 10px 9px;\n}\n.field-input input.disabled[data-v-1bb152e6] {\n      pointer-events: none;\n      background-color: #eee;\n}\n.field-input textarea[data-v-1bb152e6] {\n    margin-top: 0;\n    resize: none;\n    height: 80px;\n}\n.field-input i[data-v-1bb152e6] {\n    position: absolute;\n    top: 35px;\n    right: 15px;\n}\n.field-input i.fa-check[data-v-1bb152e6] {\n      color: #26D97A;\n}\n.field-input i.fa-exclamation-circle[data-v-1bb152e6] {\n      color: #F20D0D;\n}\n.error-message[data-v-1bb152e6] {\n  border: 1px solid #F20D0D;\n  color: #F20D0D;\n  padding: 10px;\n  font-size: 13px;\n  border-radius: 3px;\n  text-align: center;\n  margin: 5px 15px 10px;\n}\n.payout-notes[data-v-1bb152e6] {\n  width: 300px;\n  margin: 0 auto;\n  border-radius: 3px;\n  font-size: 14px;\n  background-color: #fff;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  padding: 15px;\n  text-align: center;\n}\n.payout-notes .message[data-v-1bb152e6] {\n    margin-bottom: 10px;\n}\n.padding-L[data-v-1bb152e6] {\n  padding-left: 7px;\n}\n.padding-R[data-v-1bb152e6] {\n  padding-right: 7px;\n}\n.margin-T[data-v-1bb152e6] {\n  margin-top: 10px;\n}\n.margin-L[data-v-1bb152e6] {\n  margin-left: 5px;\n}\n.margin-R[data-v-1bb152e6] {\n  margin-right: 5px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Provider/PayoutForm.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iDAAiD;UACzC,yCAAyC;EACjD,iBAAiB;CAClB;AACD;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,0BAA0B;IAC1B,gBAAgB;CACnB;AACD;IACI,mBAAmB;IACnB,oBAAoB;CACvB;AACD;MACM,YAAY;CACjB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,cAAc;IACd,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,4DAA4D;IAC5D,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;IACI,cAAc;IACd,sBAAsB;CACzB;AACD;MACM,qBAAqB;MACrB,uBAAuB;CAC5B;AACD;IACI,cAAc;IACd,aAAa;IACb,aAAa;CAChB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;CACf;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;CACvB;AACD;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iDAAiD;UACzC,yCAAyC;EACjD,iBAAiB;EACjB,cAAc;EACd,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,kBAAkB;CACnB","file":"PayoutForm.vue","sourcesContent":["\n.payout-form[data-v-1bb152e6] {\n  width: 500px;\n  margin: 0 auto;\n  border-radius: 3px;\n  font-size: 14px;\n  background-color: #fff;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n}\n.payout-form .title[data-v-1bb152e6] {\n    text-align: center;\n    color: #fff;\n    font-weight: 700;\n    background-color: #0D79F2;\n    padding: 10px 0;\n}\n.payout-form .controls[data-v-1bb152e6] {\n    text-align: center;\n    padding: 5px 0 15px;\n}\n.payout-form .controls .button[data-v-1bb152e6] {\n      width: 80px;\n}\n.form-fields[data-v-1bb152e6] {\n  padding: 10px 8px;\n}\n.field-input[data-v-1bb152e6] {\n  position: relative;\n}\n.field-input label[data-v-1bb152e6] {\n    font-size: 10px;\n    font-weight: 700;\n    color: #0D79F2;\n}\n.field-input select[data-v-1bb152e6] {\n    margin-top: 0;\n    border: 1px solid #ccc;\n    padding: 10px;\n    color: #333;\n    height: 40px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background: url(\"/assets/img/down.png\") no-repeat 200px 9px;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.field-input input[data-v-1bb152e6] {\n    margin-top: 0;\n    padding: 8px 10px 9px;\n}\n.field-input input.disabled[data-v-1bb152e6] {\n      pointer-events: none;\n      background-color: #eee;\n}\n.field-input textarea[data-v-1bb152e6] {\n    margin-top: 0;\n    resize: none;\n    height: 80px;\n}\n.field-input i[data-v-1bb152e6] {\n    position: absolute;\n    top: 35px;\n    right: 15px;\n}\n.field-input i.fa-check[data-v-1bb152e6] {\n      color: #26D97A;\n}\n.field-input i.fa-exclamation-circle[data-v-1bb152e6] {\n      color: #F20D0D;\n}\n.error-message[data-v-1bb152e6] {\n  border: 1px solid #F20D0D;\n  color: #F20D0D;\n  padding: 10px;\n  font-size: 13px;\n  border-radius: 3px;\n  text-align: center;\n  margin: 5px 15px 10px;\n}\n.payout-notes[data-v-1bb152e6] {\n  width: 300px;\n  margin: 0 auto;\n  border-radius: 3px;\n  font-size: 14px;\n  background-color: #fff;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  padding: 15px;\n  text-align: center;\n}\n.payout-notes .message[data-v-1bb152e6] {\n    margin-bottom: 10px;\n}\n.padding-L[data-v-1bb152e6] {\n  padding-left: 7px;\n}\n.padding-R[data-v-1bb152e6] {\n  padding-right: 7px;\n}\n.margin-T[data-v-1bb152e6] {\n  margin-top: 10px;\n}\n.margin-L[data-v-1bb152e6] {\n  margin-left: 5px;\n}\n.margin-R[data-v-1bb152e6] {\n  margin-right: 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"global-modal"},[_c('div',{staticClass:"global-modal-content"},[_c('div',{staticClass:"payout-form"},[_c('div',{staticClass:"title"},[(_vm.trxId === null)?_c('span',[_vm._v("NEW TRANSACTION")]):_c('span',[_vm._v("EDITING TRANSACTION")])]),_vm._v(" "),_c('div',{staticClass:"form-fields"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns padding-L padding-R"},[_c('div',{staticClass:"field-input"},[_c('label',[_vm._v("TYPE")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.trxType),expression:"trxType"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.trxType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"credit"}},[_vm._v("Credit")]),_vm._v(" "),_c('option',{attrs:{"value":"debit"}},[_vm._v("Debit")])])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L padding-R"},[_c('div',{staticClass:"field-input"},[_c('label',[_vm._v("TRANSACTION TYPE")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.trxTransactionType),expression:"trxTransactionType"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.trxTransactionType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"completed"}},[_vm._v("Completed")]),_vm._v(" "),_c('option',{attrs:{"value":"noshow"}},[_vm._v("No Show")]),_vm._v(" "),_c('option',{attrs:{"value":"release_fee"}},[_vm._v("Release Fee")]),_vm._v(" "),_c('option',{attrs:{"value":"chargeback"}},[_vm._v("Chargeback")]),_vm._v(" "),_c('option',{attrs:{"value":"deduction"}},[_vm._v("Deduction")]),_vm._v(" "),_c('option',{attrs:{"value":"other"}},[_vm._v("Other")])])])])]),_vm._v(" "),_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-12 columns padding-L padding-R"},[_c('div',{staticClass:"field-input"},[_c('label',[_vm._v("DESCRIPTION")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.trxDescription),expression:"trxDescription"}],domProps:{"value":(_vm.trxDescription)},on:{"input":function($event){if($event.target.composing){ return; }_vm.trxDescription=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-4 columns padding-L padding-R"},[_c('div',{staticClass:"field-input"},[_c('label',[_vm._v("AMOUNT")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trxAmount),expression:"trxAmount"}],attrs:{"type":"number","placeholder":"0"},domProps:{"value":(_vm.trxAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.trxAmount=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-L padding-R"},[_c('div',{staticClass:"field-input"},[_c('label',[_vm._v("RESERVATION ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trxReservationId),expression:"trxReservationId"}],class:{ disabled: _vm.rsvpValid !== null && _vm.rsvpValid.validating },attrs:{"type":"text","placeholder":"123456"},domProps:{"value":(_vm.trxReservationId)},on:{"change":_vm.validateRsvp,"input":function($event){if($event.target.composing){ return; }_vm.trxReservationId=$event.target.value}}}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpValid !== null && _vm.rsvpValid.validating),expression:"rsvpValid !== null && rsvpValid.validating"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpValid !== null && _vm.trxReservationId !== null && _vm.trxReservationId !== '' && !_vm.rsvpValid.validating && _vm.rsvpValid.isValid),expression:"rsvpValid !== null && trxReservationId !== null && trxReservationId !== '' && !rsvpValid.validating && rsvpValid.isValid"}],staticClass:"fa fa-check"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpValid !== null && _vm.trxReservationId !== null && _vm.trxReservationId !== '' && !_vm.rsvpValid.validating && !_vm.rsvpValid.isValid),expression:"rsvpValid !== null && trxReservationId !== null && trxReservationId !== '' && !rsvpValid.validating && !rsvpValid.isValid"}],staticClass:"fa fa-exclamation-circle"})])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-L padding-R"},[_c('div',{staticClass:"field-input"},[_c('label',[_vm._v("PACKAGE ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trxPackageId),expression:"trxPackageId"}],class:{ disabled: _vm.packageValid !== null && _vm.packageValid.validating },attrs:{"type":"text","placeholder":"123456"},domProps:{"value":(_vm.trxPackageId)},on:{"change":_vm.validatePackage,"input":function($event){if($event.target.composing){ return; }_vm.trxPackageId=$event.target.value}}}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.packageValid !== null && _vm.packageValid.validating),expression:"packageValid !== null && packageValid.validating"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.packageValid !== null && _vm.trxReservationId !== null && _vm.trxReservationId !== '' && !_vm.packageValid.validating && _vm.packageValid.isValid),expression:"packageValid !== null && trxReservationId !== null && trxReservationId !== '' && !packageValid.validating && packageValid.isValid"}],staticClass:"fa fa-check"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.packageValid !== null && _vm.trxReservationId !== null && _vm.trxReservationId !== '' && !_vm.packageValid.validating && !_vm.packageValid.isValid),expression:"packageValid !== null && trxReservationId !== null && trxReservationId !== '' && !packageValid.validating && !packageValid.isValid"}],staticClass:"fa fa-exclamation-circle"})])])]),_vm._v(" "),_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-12 columns padding-L padding-R"},[_c('div',{staticClass:"field-input"},[_c('label',[_vm._v("NOTE TO DRIVER")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.trxNotes),expression:"trxNotes"}],domProps:{"value":(_vm.trxNotes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.trxNotes=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.show),expression:"error.show"}],staticClass:"error-message"},[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('div',{staticClass:"controls"},[_c('a',{class:{ 'button cta xsmall warning margin-R': true, disabled: _vm.saving },attrs:{"href":"javascript:;"},on:{"click":_vm.hidePayoutForm}},[_vm._v("CANCEL")]),_vm._v(" "),_c('a',{class:{ 'button cta xsmall success margin-L': true,
                                disabled: _vm.saving || (_vm.rsvpValid !== null && _vm.rsvpValid.validating) || (_vm.packageValid !== null && _vm.packageValid.validating) },attrs:{"href":"javascript:;"},on:{"click":_vm.save}},[(_vm.saving)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_c('span',[_vm._v("SAVE")])])])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.notes.show),expression:"notes.show"}],staticClass:"global-modal"},[_c('div',{staticClass:"global-modal-content"},[_c('div',{staticClass:"payout-notes"},[_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.notes.note))]),_vm._v(" "),_c('a',{staticClass:"button cta xsmall",attrs:{"href":"javascript:;"},on:{"click":_vm.closeNotes}},[_vm._v("CLOSE")])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocHistory_vue__ = __webpack_require__(581);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa212f82_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocHistory_vue__ = __webpack_require__(1701);
function injectStyle (ssrContext) {
  __webpack_require__(1699)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fa212f82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa212f82_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1700);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("6f4a6438", content, true, {});

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.date-group[data-v-fa212f82] {\n  text-align: center;\n  font-size: 24px;\n  color: #0D79F2;\n  margin: 25px auto 5px;\n  position: relative;\n  width: 90%;\n}\n.date-group[data-v-fa212f82]:after {\n    content: ' ';\n    width: 100%;\n    position: absolute;\n    top: 50%;\n    border-top: 1px solid #ccc;\n    left: 0;\n    z-index: 1;\n}\n.date-group span[data-v-fa212f82] {\n    position: relative;\n    background: #ededed;\n    z-index: 2;\n    padding: 0 20px;\n}\n.history-box[data-v-fa212f82] {\n  background-color: #fff;\n  padding: 15px;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  margin: 0 auto 10px;\n  width: 90%;\n}\n.history-box .head[data-v-fa212f82] {\n    cursor: pointer;\n}\n.history-box .head .icon[data-v-fa212f82] {\n      float: left;\n      width: 35px;\n      color: #0D79F2;\n}\n.history-box .head .icon i[data-v-fa212f82] {\n        font-size: 24px;\n}\n.history-box .head .info[data-v-fa212f82] {\n      width: calc(100% - 30px);\n}\n.history-box .head .doc-type[data-v-fa212f82] {\n      font-weight: 600;\n      color: #0D79F2;\n}\n.history-box .body[data-v-fa212f82] {\n    padding: 10px;\n    font-size: 13px;\n    border-radius: 4px;\n    margin: 10px 0 0;\n}\n.history-box .body .label[data-v-fa212f82] {\n      text-align: right;\n      color: #606060;\n      width: 170px;\n}\n.history-box .body .value[data-v-fa212f82] {\n      padding-left: 8px;\n      font-weight: 600;\n      color: #333;\n}\n.history-box.empty[data-v-fa212f82] {\n    text-align: center;\n    padding: 40px;\n}\n.history-box.empty i[data-v-fa212f82] {\n      color: #ccc;\n      margin-bottom: 5px;\n}\n.history-box.empty span[data-v-fa212f82] {\n      display: block;\n      font-size: 24px;\n      font-weight: 600;\n      color: #777;\n      font-style: italic;\n}\ntable[data-v-fa212f82] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-fa212f82] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-fa212f82] {\n      padding: 5px 10px;\n}\ntable thead th[data-v-fa212f82]:last-child {\n        cursor: default;\n}\ntable thead th i[data-v-fa212f82] {\n        display: none;\n}\ntable thead th i.stripe-icon[data-v-fa212f82] {\n        display: inline;\n}\ntable thead th .fa-sort-up[data-v-fa212f82] {\n        vertical-align: -2px;\n}\ntable thead th .fa-sort-down[data-v-fa212f82] {\n        vertical-align: 2px;\n}\ntable thead th.sortable[data-v-fa212f82] {\n        cursor: pointer;\n        color: #333;\n}\ntable thead th.sortable span[data-v-fa212f82] {\n          font-weight: 600;\n          text-decoration: underline;\n}\ntable thead th.sort i[data-v-fa212f82] {\n        display: inline-block;\n}\ntable tbody tr[data-v-fa212f82] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr[data-v-fa212f82]:nth-child(even) {\n      background: #f3f3f3;\n}\ntable tbody tr[data-v-fa212f82]:hover {\n      background: #d7dbe4;\n}\ntable tbody tr td[data-v-fa212f82] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      color: #555;\n}\ntable tbody tr td.status[data-v-fa212f82], table tbody tr td.bookedThrough[data-v-fa212f82] {\n        font-weight: 600;\n}\ntable tbody tr td.table-block[data-v-fa212f82] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-fa212f82] {\n          color: #ccc;\n}\ntable tbody tr td a[data-v-fa212f82] {\n        font-weight: 600;\n        text-decoration: underline;\n        cursor: pointer;\n}\n.slide-down-enter-active[data-v-fa212f82], .slide-down-leave-active[data-v-fa212f82] {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.slide-down-enter[data-v-fa212f82], .slide-down-leave-to[data-v-fa212f82] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n.mobileTable[data-v-fa212f82] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.desktopTable[data-v-fa212f82] {\n    display: none;\n}\n.mobileTable[data-v-fa212f82] {\n    display: block;\n}\n.cards .card[data-v-fa212f82] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.cards .card .info[data-v-fa212f82] {\n      width: 100%;\n      padding-left: 10px;\n}\n.cards .card > div[data-v-fa212f82] {\n      margin-bottom: 3px;\n      width: 100%;\n}\n.cards .card .data[data-v-fa212f82] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      margin-bottom: 3px;\n}\n.cards .card .title[data-v-fa212f82] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-fa212f82] {\n      padding: 0;\n      margin-right: 10px;\n      font-size: 13px;\n      font-weight: 900;\n}\n.cards .card .value i[data-v-fa212f82] {\n        color: #bbb;\n}\n.cards .card .value a[data-v-fa212f82] {\n        text-decoration: none;\n}\n.cards .card .link[data-v-fa212f82] {\n      font-weight: 900;\n}\n.cards .card .link i[data-v-fa212f82] {\n        color: #bbb;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Provider/DocHistory.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;CACZ;AACD;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,SAAS;IACT,2BAA2B;IAC3B,QAAQ;IACR,WAAW;CACd;AACD;IACI,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX,gBAAgB;CACnB;AACD;EACE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,iDAAiD;EACjD,yCAAyC;EACzC,oBAAoB;EACpB,WAAW;CACZ;AACD;IACI,gBAAgB;CACnB;AACD;MACM,YAAY;MACZ,YAAY;MACZ,eAAe;CACpB;AACD;QACQ,gBAAgB;CACvB;AACD;MACM,yBAAyB;CAC9B;AACD;MACM,iBAAiB;MACjB,eAAe;CACpB;AACD;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;CACpB;AACD;MACM,kBAAkB;MAClB,eAAe;MACf,aAAa;CAClB;AACD;MACM,kBAAkB;MAClB,iBAAiB;MACjB,YAAY;CACjB;AACD;IACI,mBAAmB;IACnB,cAAc;CACjB;AACD;MACM,YAAY;MACZ,mBAAmB;CACxB;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,YAAY;MACZ,mBAAmB;CACxB;AACD;EACE,0BAA0B;EAC1B,YAAY;CACb;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;QACQ,gBAAgB;CACvB;AACD;QACQ,cAAc;CACrB;AACD;QACQ,gBAAgB;CACvB;AACD;QACQ,qBAAqB;CAC5B;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,gBAAgB;QAChB,YAAY;CACnB;AACD;UACU,iBAAiB;UACjB,2BAA2B;CACpC;AACD;QACQ,sBAAsB;CAC7B;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,YAAY;CACjB;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;QACQ,iBAAiB;QACjB,2BAA2B;QAC3B,gBAAgB;CACvB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ;AACD;EACE,cAAc;CACf;AACD;AACA;IACI,cAAc;CACjB;AACD;IACI,eAAe;CAClB;AACD;IACI,uBAAuB;IACvB,oBAAoB;IACpB,aAAa;IACb,oBAAoB;IACpB,+BAA+B;IAC/B,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,6BAA6B;IAC7B,8BAA8B;QAC1B,2BAA2B;YACvB,uBAAuB;CAClC;AACD;MACM,YAAY;MACZ,mBAAmB;CACxB;AACD;MACM,mBAAmB;MACnB,YAAY;CACjB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;MAC5B,mBAAmB;CACxB;AACD;MACM,gBAAgB;MAChB,0BAA0B;MAC1B,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;CACvB;AACD;MACM,WAAW;MACX,mBAAmB;MACnB,gBAAgB;MAChB,iBAAiB;CACtB;AACD;QACQ,YAAY;CACnB;AACD;QACQ,sBAAsB;CAC7B;AACD;MACM,iBAAiB;CACtB;AACD;QACQ,YAAY;CACnB;CACA","file":"DocHistory.vue","sourcesContent":["\n.date-group[data-v-fa212f82] {\n  text-align: center;\n  font-size: 24px;\n  color: #0D79F2;\n  margin: 25px auto 5px;\n  position: relative;\n  width: 90%;\n}\n.date-group[data-v-fa212f82]:after {\n    content: ' ';\n    width: 100%;\n    position: absolute;\n    top: 50%;\n    border-top: 1px solid #ccc;\n    left: 0;\n    z-index: 1;\n}\n.date-group span[data-v-fa212f82] {\n    position: relative;\n    background: #ededed;\n    z-index: 2;\n    padding: 0 20px;\n}\n.history-box[data-v-fa212f82] {\n  background-color: #fff;\n  padding: 15px;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  margin: 0 auto 10px;\n  width: 90%;\n}\n.history-box .head[data-v-fa212f82] {\n    cursor: pointer;\n}\n.history-box .head .icon[data-v-fa212f82] {\n      float: left;\n      width: 35px;\n      color: #0D79F2;\n}\n.history-box .head .icon i[data-v-fa212f82] {\n        font-size: 24px;\n}\n.history-box .head .info[data-v-fa212f82] {\n      width: calc(100% - 30px);\n}\n.history-box .head .doc-type[data-v-fa212f82] {\n      font-weight: 600;\n      color: #0D79F2;\n}\n.history-box .body[data-v-fa212f82] {\n    padding: 10px;\n    font-size: 13px;\n    border-radius: 4px;\n    margin: 10px 0 0;\n}\n.history-box .body .label[data-v-fa212f82] {\n      text-align: right;\n      color: #606060;\n      width: 170px;\n}\n.history-box .body .value[data-v-fa212f82] {\n      padding-left: 8px;\n      font-weight: 600;\n      color: #333;\n}\n.history-box.empty[data-v-fa212f82] {\n    text-align: center;\n    padding: 40px;\n}\n.history-box.empty i[data-v-fa212f82] {\n      color: #ccc;\n      margin-bottom: 5px;\n}\n.history-box.empty span[data-v-fa212f82] {\n      display: block;\n      font-size: 24px;\n      font-weight: 600;\n      color: #777;\n      font-style: italic;\n}\ntable[data-v-fa212f82] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-fa212f82] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-fa212f82] {\n      padding: 5px 10px;\n}\ntable thead th[data-v-fa212f82]:last-child {\n        cursor: default;\n}\ntable thead th i[data-v-fa212f82] {\n        display: none;\n}\ntable thead th i.stripe-icon[data-v-fa212f82] {\n        display: inline;\n}\ntable thead th .fa-sort-up[data-v-fa212f82] {\n        vertical-align: -2px;\n}\ntable thead th .fa-sort-down[data-v-fa212f82] {\n        vertical-align: 2px;\n}\ntable thead th.sortable[data-v-fa212f82] {\n        cursor: pointer;\n        color: #333;\n}\ntable thead th.sortable span[data-v-fa212f82] {\n          font-weight: 600;\n          text-decoration: underline;\n}\ntable thead th.sort i[data-v-fa212f82] {\n        display: inline-block;\n}\ntable tbody tr[data-v-fa212f82] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr[data-v-fa212f82]:nth-child(even) {\n      background: #f3f3f3;\n}\ntable tbody tr[data-v-fa212f82]:hover {\n      background: #d7dbe4;\n}\ntable tbody tr td[data-v-fa212f82] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      color: #555;\n}\ntable tbody tr td.status[data-v-fa212f82], table tbody tr td.bookedThrough[data-v-fa212f82] {\n        font-weight: 600;\n}\ntable tbody tr td.table-block[data-v-fa212f82] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-fa212f82] {\n          color: #ccc;\n}\ntable tbody tr td a[data-v-fa212f82] {\n        font-weight: 600;\n        text-decoration: underline;\n        cursor: pointer;\n}\n.slide-down-enter-active[data-v-fa212f82], .slide-down-leave-active[data-v-fa212f82] {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.slide-down-enter[data-v-fa212f82], .slide-down-leave-to[data-v-fa212f82] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n.mobileTable[data-v-fa212f82] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.desktopTable[data-v-fa212f82] {\n    display: none;\n}\n.mobileTable[data-v-fa212f82] {\n    display: block;\n}\n.cards .card[data-v-fa212f82] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.cards .card .info[data-v-fa212f82] {\n      width: 100%;\n      padding-left: 10px;\n}\n.cards .card > div[data-v-fa212f82] {\n      margin-bottom: 3px;\n      width: 100%;\n}\n.cards .card .data[data-v-fa212f82] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      margin-bottom: 3px;\n}\n.cards .card .title[data-v-fa212f82] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-fa212f82] {\n      padding: 0;\n      margin-right: 10px;\n      font-size: 13px;\n      font-weight: 900;\n}\n.cards .card .value i[data-v-fa212f82] {\n        color: #bbb;\n}\n.cards .card .value a[data-v-fa212f82] {\n        text-decoration: none;\n}\n.cards .card .link[data-v-fa212f82] {\n      font-weight: 900;\n}\n.cards .card .link i[data-v-fa212f82] {\n        color: #bbb;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.history),function(group,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(Object.keys(_vm.history).length && !_vm.loading),expression:"Object.keys(history).length && !loading"}],key:index,staticClass:"history-box"},[_c('div',{staticClass:"head",on:{"click":function($event){return _vm.toggle(index)}}},[_c('div',{staticClass:"icon"},[(_vm.open.indexOf(index) > -1)?_c('i',{staticClass:"fa fa-minus-circle"}):_c('i',{staticClass:"fa fa-plus-circle"})]),_vm._v(" "),_c('div',{staticClass:"info"},[(index != 'W-9')?_c('div',{staticClass:"doc-type"},[_vm._v(_vm._s(_vm.renameDocument(index)))]):_c('div',{staticClass:"doc-type"},[_vm._v("W-9 Form")])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.open.indexOf(index) > -1),expression:"open.indexOf(index) > -1"}]},[_c('div',{staticClass:"body"},[_c('table',{staticClass:"desktopTable"},[_c('thead',[_c('th',[_vm._v("Replaced On")]),_vm._v(" "),(index === 'Insurance Policy')?_c('th',[_vm._v("Insurance Company Name")]):_vm._e(),_vm._v(" "),(index === 'Insurance Policy')?_c('th',[_vm._v("Insurance Policy #")]):_vm._e(),_vm._v(" "),(index === 'City License')?_c('th',[_vm._v("City License #")]):_vm._e(),_vm._v(" "),(index === 'TCP Permit')?_c('th',[_vm._v("TCP Permit #")]):_vm._e(),_vm._v(" "),(index === 'Airport Permit')?_c('th',[_vm._v("Airport Permit #")]):_vm._e(),_vm._v(" "),(index === 'Driver\'s License')?_c('th',[_vm._v("Driver's License #")]):_vm._e(),_vm._v(" "),(index === 'Vehicle Safety Inspection')?_c('th',[_vm._v("Inspection Performed By")]):_vm._e(),_vm._v(" "),(['SSN', 'EIN', 'W-9'].indexOf(index) === -1)?_c('th',[_vm._v("Expiration Date")]):_vm._e(),_vm._v(" "),_c('th',[_vm._v("File")])]),_vm._v(" "),_c('tbody',_vm._l((group),function(data){return _c('tr',{key:data.id},[_c('td',[_vm._v(_vm._s(_vm.formatDate(data.replacedOn)))]),_vm._v(" "),(data.document === 'Insurance Policy')?_c('td',[_vm._v(_vm._s(data.company))]):_vm._e(),_vm._v(" "),(data.document === 'Vehicle Safety Inspection')?_c('td',[_vm._v(_vm._s(data.by))]):_vm._e(),_vm._v(" "),(['Driving Record', 'Vehicle Safety Inspection', 'SSN', 'EIN', 'W-9', 'Vehicle Registration', 'Background Check'].indexOf(data.document) === -1)?_c('td',[_vm._v(_vm._s(data.number))]):_vm._e(),_vm._v(" "),(['SSN', 'EIN', 'W-9'].indexOf(data.document) === -1)?_c('td',[_vm._v(_vm._s(data.expire))]):_vm._e(),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":data.file,"target":"_blank"}},[_vm._v("View attached file")])])])}),0)]),_vm._v(" "),_c('div',{staticClass:"mobileTable"},[_c('div',{staticClass:"cards"},_vm._l((group),function(data){return _c('div',{key:data.id,staticClass:"card"},[_c('div',{staticClass:"data"},[_c('div',{staticClass:"title"},[_vm._v("Replaced On: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.formatDate(data.replacedOn)))])]),_vm._v(" "),(data.document === 'Insurance Policy')?_c('div',{staticClass:"data"},[_c('div',{staticClass:"title"},[_vm._v("Insurance Company Name: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(data.company))])]):_vm._e(),_vm._v(" "),(data.document === 'Vehicle Safety Inspection')?_c('div',{staticClass:"data"},[_c('div',{staticClass:"title"},[_vm._v("Inspection Performed By: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(data.by))])]):_vm._e(),_vm._v(" "),(['Driving Record', 'Vehicle Safety Inspection', 'SSN', 'EIN', 'W-9', 'Vehicle Registration', 'Background Check'].indexOf(data.document) === -1)?_c('div',{staticClass:"data"},[(index === 'Insurance Policy')?_c('div',{staticClass:"title"},[_vm._v("Insurance Policy #")]):_vm._e(),_vm._v(" "),(index === 'City License')?_c('div',{staticClass:"title"},[_vm._v("City License #")]):_vm._e(),_vm._v(" "),(index === 'TCP Permit')?_c('div',{staticClass:"title"},[_vm._v("TCP Permit #")]):_vm._e(),_vm._v(" "),(index === 'Airport Permit')?_c('div',{staticClass:"title"},[_vm._v("Airport Permit #")]):_vm._e(),_vm._v(" "),(index === 'Driver\'s License')?_c('div',{staticClass:"title"},[_vm._v("Driver's License #")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(data.number))])]):_vm._e(),_vm._v(" "),(['SSN', 'EIN', 'W-9'].indexOf(data.document) === -1)?_c('div',{staticClass:"data"},[_c('div',{staticClass:"title"},[_vm._v("Expiration Date: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(data.expire)+" - "+_vm._s(data.document))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"link"},[_c('i',{staticClass:"fas fa-paperclip"}),_vm._v(" "),_c('a',{attrs:{"href":data.file,"target":"_blank"}},[_vm._v("View attached file")])])])}),0)])])])])],1)}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"history-box empty"},[_c('ellipsis-loader'),_vm._v(" "),_c('span',[_vm._v("Getting document history...")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!Object.keys(_vm.history).length && !_vm.loading),expression:"!Object.keys(history).length && !loading"}],staticClass:"history-box empty"},[_c('i',{staticClass:"fa fa-list-alt fa-2x"}),_vm._v(" "),_c('span',[_vm._v("No document history as of yet.")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Services_vue__ = __webpack_require__(582);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0363c6e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Services_vue__ = __webpack_require__(1705);
function injectStyle (ssrContext) {
  __webpack_require__(1703)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0363c6e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Services_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0363c6e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Services_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1704);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1e29fcc2", content, true, {});

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.collapsible[data-v-0363c6e0] {\n  margin-bottom: 5px;\n}\n.collapsible .heading[data-v-0363c6e0] {\n    color: #0D79F2;\n    margin-bottom: 2px;\n    cursor: pointer;\n    text-transform: uppercase;\n}\n.collapsible .heading i[data-v-0363c6e0] {\n      margin-right: 5px;\n}\n.collapsible .heading span[data-v-0363c6e0] {\n      font-weight: 600;\n}\n.collapsible .content[data-v-0363c6e0] {\n    margin-left: 6px;\n    padding: 5px 0 5px 15px;\n    border-left: 2px solid #ddd;\n    max-height: 700px;\n    /* define precise max-height for more smoother transition */\n    height: auto;\n    -webkit-transition: all 0.35s ease-out;\n    transition: all 0.35s ease-out;\n}\n.collapsible .content ul[data-v-0363c6e0] {\n      list-style: none;\n      background: #fff;\n      padding: 10px;\n      margin: 0;\n      -webkit-column-count: 2;\n      -moz-column-count: 2;\n      column-count: 2;\n      -webkit-column-gap: 5px;\n         -moz-column-gap: 5px;\n              column-gap: 5px;\n}\n.collapsible .content ul li[data-v-0363c6e0] {\n        padding: 3px 10px;\n        font-size: 13px;\n        cursor: pointer;\n}\n.collapsible .content ul li[data-v-0363c6e0]:hover {\n          background: #fafafa;\n}\n.collapsible .content ul li i[data-v-0363c6e0] {\n          margin-right: 5px;\n          color: #57d1b7;\n}\n.collapsible .content ul.disabled li[data-v-0363c6e0] {\n        cursor: default;\n}\n.collapsible .content ul.disabled li[data-v-0363c6e0]:hover {\n        background: #fff;\n}\n.collapsible.collapse .content[data-v-0363c6e0] {\n    max-height: 0;\n    overflow: hidden;\n    padding: 0 15px;\n}\n@media only screen and (max-width: 430px) {\n.collapsible .content[data-v-0363c6e0] {\n    padding: 5px 0 5px 5px;\n}\n.collapsible .content ul[data-v-0363c6e0] {\n      padding: 0;\n}\n.collapsible .content ul li[data-v-0363c6e0] {\n        padding: 5px 3px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Provider/Services.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;MACM,iBAAiB;CACtB;AACD;IACI,iBAAiB;IACjB,wBAAwB;IACxB,4BAA4B;IAC5B,kBAAkB;IAClB,4DAA4D;IAC5D,aAAa;IACb,uCAAuC;IACvC,+BAA+B;CAClC;AACD;MACM,iBAAiB;MACjB,iBAAiB;MACjB,cAAc;MACd,UAAU;MACV,wBAAwB;MACxB,qBAAqB;MACrB,gBAAgB;MAChB,wBAAwB;SACrB,qBAAqB;cAChB,gBAAgB;CAC7B;AACD;QACQ,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;CACvB;AACD;UACU,oBAAoB;CAC7B;AACD;UACU,kBAAkB;UAClB,eAAe;CACxB;AACD;QACQ,gBAAgB;CACvB;AACD;QACQ,iBAAiB;CACxB;AACD;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;CACnB;AACD;AACA;IACI,uBAAuB;CAC1B;AACD;MACM,WAAW;CAChB;AACD;QACQ,iBAAiB;CACxB;CACA","file":"Services.vue","sourcesContent":["\n.collapsible[data-v-0363c6e0] {\n  margin-bottom: 5px;\n}\n.collapsible .heading[data-v-0363c6e0] {\n    color: #0D79F2;\n    margin-bottom: 2px;\n    cursor: pointer;\n    text-transform: uppercase;\n}\n.collapsible .heading i[data-v-0363c6e0] {\n      margin-right: 5px;\n}\n.collapsible .heading span[data-v-0363c6e0] {\n      font-weight: 600;\n}\n.collapsible .content[data-v-0363c6e0] {\n    margin-left: 6px;\n    padding: 5px 0 5px 15px;\n    border-left: 2px solid #ddd;\n    max-height: 700px;\n    /* define precise max-height for more smoother transition */\n    height: auto;\n    -webkit-transition: all 0.35s ease-out;\n    transition: all 0.35s ease-out;\n}\n.collapsible .content ul[data-v-0363c6e0] {\n      list-style: none;\n      background: #fff;\n      padding: 10px;\n      margin: 0;\n      -webkit-column-count: 2;\n      -moz-column-count: 2;\n      column-count: 2;\n      -webkit-column-gap: 5px;\n         -moz-column-gap: 5px;\n              column-gap: 5px;\n}\n.collapsible .content ul li[data-v-0363c6e0] {\n        padding: 3px 10px;\n        font-size: 13px;\n        cursor: pointer;\n}\n.collapsible .content ul li[data-v-0363c6e0]:hover {\n          background: #fafafa;\n}\n.collapsible .content ul li i[data-v-0363c6e0] {\n          margin-right: 5px;\n          color: #57d1b7;\n}\n.collapsible .content ul.disabled li[data-v-0363c6e0] {\n        cursor: default;\n}\n.collapsible .content ul.disabled li[data-v-0363c6e0]:hover {\n        background: #fff;\n}\n.collapsible.collapse .content[data-v-0363c6e0] {\n    max-height: 0;\n    overflow: hidden;\n    padding: 0 15px;\n}\n@media only screen and (max-width: 430px) {\n.collapsible .content[data-v-0363c6e0] {\n    padding: 5px 0 5px 5px;\n}\n.collapsible .content ul[data-v-0363c6e0] {\n      padding: 0;\n}\n.collapsible .content ul li[data-v-0363c6e0] {\n        padding: 5px 3px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.brands),function(brand){return (_vm.serviceList(brand.id).length)?_c('div',{class:{'collapsible':true, 'collapse':_vm.collapsed.indexOf(brand.id) > -1}},[_c('div',{staticClass:"heading",on:{"click":function($event){return _vm.toggleBrand(brand.id)}}},[(_vm.collapsed.indexOf(brand.id) > -1)?_c('i',{staticClass:"fa fa-plus-circle"}):_c('i',{staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(brand.name))])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('ul',{class:{'disabled':!_vm.editEnabled}},_vm._l((_vm.serviceList(brand.id)),function(service){return _c('li',{on:{"click":function($event){return _vm.toggleService(service.id)}}},[_c('i',{class:['fa-lg', _vm.selectedService.indexOf(service.id) > -1 ? 'fa-check-square fas' : 'far fa-square' ]}),_vm._v("\n          "+_vm._s(service.label)+"\n        ")])}),0)])]):_vm._e()}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reservations_vue__ = __webpack_require__(583);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08b4b424_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reservations_vue__ = __webpack_require__(1709);
function injectStyle (ssrContext) {
  __webpack_require__(1707)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08b4b424"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reservations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08b4b424_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reservations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1708);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("06050f12", content, true, {});

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.range[data-v-08b4b424] {\n  margin-bottom: 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.range .data-field[data-v-08b4b424] {\n    display: inline-block;\n    width: 40%;\n}\n.range .export-box[data-v-08b4b424] {\n    width: 20%;\n    padding-top: 17px;\n}\n.data-field[data-v-08b4b424] {\n  padding-right: 10px;\n}\n.data-field.no-label[data-v-08b4b424] {\n    padding-top: 17px;\n}\n.data-field .label[data-v-08b4b424] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .datepicker[data-v-08b4b424] {\n    position: relative;\n}\ntable[data-v-08b4b424] {\n  border-collapse: collapse;\n  width: 100%;\n  margin: 20px 0 50px;\n}\ntable thead[data-v-08b4b424] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n    text-align: center;\n}\ntable thead th[data-v-08b4b424] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-08b4b424] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-08b4b424] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td a[data-v-08b4b424] {\n        font-weight: 600;\n}\ntable tbody tr td.pkg[data-v-08b4b424] {\n        color: #0d79f2;\n}\ntable tbody tr td.date[data-v-08b4b424] {\n        width: 160px;\n        color: #888;\n}\ntable tbody tr td.service[data-v-08b4b424], table tbody tr td.hudson[data-v-08b4b424] {\n        width: 120px;\n}\ntable tbody tr td.pax-luggage[data-v-08b4b424] {\n        width: 60px;\n}\ntable tbody tr td.flight[data-v-08b4b424] {\n        width: 70px;\n}\ntable tbody tr td.table-block[data-v-08b4b424] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-08b4b424] {\n          color: #ccc;\n}\n.service-label[data-v-08b4b424] {\n  line-height: 24px;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 12px;\n  text-transform: capitalize;\n}\n.service-label.shared[data-v-08b4b424] {\n    background: #f38d56;\n}\n.service-label.opoli[data-v-08b4b424] {\n    background: #26D97A;\n}\n.service-label.black[data-v-08b4b424] {\n    background: #777;\n}\n.service-label.SUV[data-v-08b4b424], .service-label.suv[data-v-08b4b424] {\n    background: #dc3168;\n}\n.service-label.shuttle[data-v-08b4b424] {\n    background: #6dabc3;\n}\n.hideMobile[data-v-08b4b424], .hideDesktop[data-v-08b4b424] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.table-card[data-v-08b4b424] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 10px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-size: 13px;\n    background-color: #fff;\n}\n.table-card a[data-v-08b4b424] {\n      font-weight: 900;\n}\n.table-card .card-header[data-v-08b4b424] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .card-header .time[data-v-08b4b424] {\n        font-size: 12px;\n        color: #777;\n        word-spacing: 5px;\n}\n.table-card .card-header .amount[data-v-08b4b424] {\n        font-weight: 900;\n        font-size: 20px;\n}\n.table-card .card-header .amount a[data-v-08b4b424] {\n          text-decoration: none;\n}\n.table-card .card-header .service-div[data-v-08b4b424] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.table-card .card-header .service-div .service[data-v-08b4b424] {\n          margin-left: 10px;\n}\n.table-card .clock i[data-v-08b4b424] {\n      color: #F25E0D;\n}\n.table-card .clock span[data-v-08b4b424] {\n      font-size: 13px;\n}\n.table-card .pickup i[data-v-08b4b424] {\n      color: #d92626;\n}\n.table-card .dropoff i[data-v-08b4b424] {\n      color: #26D97A;\n}\n.table-card .flight i[data-v-08b4b424] {\n      color: #187f07;\n}\n.table-card .name i[data-v-08b4b424] {\n      color: #0d79f2;\n}\n.table-block[data-v-08b4b424] {\n    padding: 20px 15px;\n    font-size: 20px;\n    color: #777;\n    font-weight: 600;\n    font-style: italic;\n    text-align: center;\n}\n.table-block .fa[data-v-08b4b424] {\n      color: #ccc;\n}\n.icon[data-v-08b4b424] {\n    color: dimgray;\n    font-size: 12px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Provider/Reservations.vue"],"names":[],"mappings":";AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,sBAAsB;IACtB,WAAW;CACd;AACD;IACI,WAAW;IACX,kBAAkB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;IACI,mBAAmB;CACtB;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,oBAAoB;CACrB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;IAC1B,mBAAmB;CACtB;AACD;MACM,kBAAkB;CACvB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,aAAa;QACb,YAAY;CACnB;AACD;QACQ,aAAa;CACpB;AACD;QACQ,YAAY;CACnB;AACD;QACQ,YAAY;CACnB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;CAC5B;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,cAAc;CACf;AACD;AACA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,cAAc;IACd,+BAA+B;IAC/B,oBAAoB;IACpB,gBAAgB;IAChB,uBAAuB;CAC1B;AACD;MACM,iBAAiB;CACtB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;QACQ,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;CACzB;AACD;QACQ,iBAAiB;QACjB,gBAAgB;CACvB;AACD;UACU,sBAAsB;CAC/B;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;CACrB;AACD;UACU,kBAAkB;CAC3B;AACD;MACM,eAAe;CACpB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;CACtB;AACD;MACM,YAAY;CACjB;AACD;IACI,eAAe;IACf,gBAAgB;CACnB;CACA","file":"Reservations.vue","sourcesContent":["\n.range[data-v-08b4b424] {\n  margin-bottom: 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.range .data-field[data-v-08b4b424] {\n    display: inline-block;\n    width: 40%;\n}\n.range .export-box[data-v-08b4b424] {\n    width: 20%;\n    padding-top: 17px;\n}\n.data-field[data-v-08b4b424] {\n  padding-right: 10px;\n}\n.data-field.no-label[data-v-08b4b424] {\n    padding-top: 17px;\n}\n.data-field .label[data-v-08b4b424] {\n    color: #888;\n    font-weight: 600;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .datepicker[data-v-08b4b424] {\n    position: relative;\n}\ntable[data-v-08b4b424] {\n  border-collapse: collapse;\n  width: 100%;\n  margin: 20px 0 50px;\n}\ntable thead[data-v-08b4b424] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n    text-align: center;\n}\ntable thead th[data-v-08b4b424] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-08b4b424] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-08b4b424] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td a[data-v-08b4b424] {\n        font-weight: 600;\n}\ntable tbody tr td.pkg[data-v-08b4b424] {\n        color: #0d79f2;\n}\ntable tbody tr td.date[data-v-08b4b424] {\n        width: 160px;\n        color: #888;\n}\ntable tbody tr td.service[data-v-08b4b424], table tbody tr td.hudson[data-v-08b4b424] {\n        width: 120px;\n}\ntable tbody tr td.pax-luggage[data-v-08b4b424] {\n        width: 60px;\n}\ntable tbody tr td.flight[data-v-08b4b424] {\n        width: 70px;\n}\ntable tbody tr td.table-block[data-v-08b4b424] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-08b4b424] {\n          color: #ccc;\n}\n.service-label[data-v-08b4b424] {\n  line-height: 24px;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 12px;\n  text-transform: capitalize;\n}\n.service-label.shared[data-v-08b4b424] {\n    background: #f38d56;\n}\n.service-label.opoli[data-v-08b4b424] {\n    background: #26D97A;\n}\n.service-label.black[data-v-08b4b424] {\n    background: #777;\n}\n.service-label.SUV[data-v-08b4b424], .service-label.suv[data-v-08b4b424] {\n    background: #dc3168;\n}\n.service-label.shuttle[data-v-08b4b424] {\n    background: #6dabc3;\n}\n.hideMobile[data-v-08b4b424], .hideDesktop[data-v-08b4b424] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.table-card[data-v-08b4b424] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 10px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-size: 13px;\n    background-color: #fff;\n}\n.table-card a[data-v-08b4b424] {\n      font-weight: 900;\n}\n.table-card .card-header[data-v-08b4b424] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .card-header .time[data-v-08b4b424] {\n        font-size: 12px;\n        color: #777;\n        word-spacing: 5px;\n}\n.table-card .card-header .amount[data-v-08b4b424] {\n        font-weight: 900;\n        font-size: 20px;\n}\n.table-card .card-header .amount a[data-v-08b4b424] {\n          text-decoration: none;\n}\n.table-card .card-header .service-div[data-v-08b4b424] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.table-card .card-header .service-div .service[data-v-08b4b424] {\n          margin-left: 10px;\n}\n.table-card .clock i[data-v-08b4b424] {\n      color: #F25E0D;\n}\n.table-card .clock span[data-v-08b4b424] {\n      font-size: 13px;\n}\n.table-card .pickup i[data-v-08b4b424] {\n      color: #d92626;\n}\n.table-card .dropoff i[data-v-08b4b424] {\n      color: #26D97A;\n}\n.table-card .flight i[data-v-08b4b424] {\n      color: #187f07;\n}\n.table-card .name i[data-v-08b4b424] {\n      color: #0d79f2;\n}\n.table-block[data-v-08b4b424] {\n    padding: 20px 15px;\n    font-size: 20px;\n    color: #777;\n    font-weight: 600;\n    font-style: italic;\n    text-align: center;\n}\n.table-block .fa[data-v-08b4b424] {\n      color: #ccc;\n}\n.icon[data-v-08b4b424] {\n    color: dimgray;\n    font-size: 12px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type === 'history')?_c('div',{staticClass:"range"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.reservations.from'))+":")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":_vm.calendarFormat},on:{"input":_vm.updateFrom},model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}})],1),_vm._v(" "),_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.reservations.to'))+":")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":_vm.calendarFormat},on:{"input":_vm.updateTo},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}})],1),_vm._v(" "),_c('div',{staticClass:"export-box no-label"},[_c('a',{staticClass:"button cta small success",on:{"click":_vm.exportComplete}},[_vm._v("EXPORT")])])]):_vm._e(),_vm._v(" "),_c('table',{class:[ 'trx-table', {'hideMobile':_vm.isMobile}],attrs:{"cellspacing":"0"}},[_c('thead',[_c('td',[_vm._v(_vm._s(_vm.$t('provider.reservations.id')))]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('provider.reservations.pickupTime')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('provider.reservations.pickup')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('provider.reservations.dropoff')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('provider.reservations.service')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('provider.reservations.customer')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('provider.reservations.paxLuggage')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('provider.reservations.flight')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('provider.reservations.driverPayment')))])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.reservations),function(rsvp){return _c('tr',{class:rsvp.type},[_c('td',{staticClass:"id"},[(rsvp.type !== 'pkg')?_c('a',{attrs:{"href":'/#/reservation/' + rsvp.id,"target":"_blank"}},[_vm._v("\n            "+_vm._s(rsvp.id)+"\n          ")]):_vm._e(),_vm._v(" "),(rsvp.type === 'pkg')?_c('a',{attrs:{"href":'/#/package/' + rsvp.id,"target":"_blank"}},[_vm._v("\n            "+_vm._s(rsvp.id)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"pkg"},[(rsvp.type === 'pkg')?_c('a',{attrs:{"href":'/#/package/' + rsvp.id,"target":"_blank"}},[_c('i',{staticClass:"fa fa-cube"})]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v(_vm._s(rsvp.pickupTime))]),_vm._v(" "),_c('td',{staticClass:"pickup"},[_vm._v(_vm._s(rsvp.pickup))]),_vm._v(" "),_c('td',{staticClass:"dropoff"},[(rsvp.isCharter)?_c('span',[_vm._v("--")]):_c('span',[_vm._v(_vm._s(rsvp.dropoff))])]),_vm._v(" "),_c('td',{staticClass:"service"},[(_vm.useOldQuatation)?_c('span',{class:['service-label', rsvp.service]},[_vm._v(_vm._s(_vm.serviceLabel(rsvp.service)))]):_c('span',{staticClass:"service-label",style:({backgroundColor: rsvp.serviceType.color})},[_vm._v(_vm._s(rsvp.serviceType.label))])]),_vm._v(" "),_c('td',{staticClass:"customer"},[_vm._v(_vm._s(rsvp.customer))]),_vm._v(" "),_c('td',{staticClass:"pax-luggage"},[_vm._v(_vm._s(rsvp.pax + '/' + rsvp.luggage))]),_vm._v(" "),_c('td',{staticClass:"flight"},[_vm._v(_vm._s(rsvp.flight))]),_vm._v(" "),_c('td',{staticClass:"flight"},[_vm._v("$"+_vm._s(_vm.toFixed(rsvp.amountPaid)))])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"11"}},[_c('ellipsis-loader'),_vm._v("\n          "+_vm._s(_vm.$t('provider.reservations.loading'))+"\n        ")],1)]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.reservations.length === 0 && !_vm.loading),expression:"reservations.length === 0 && !loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"11"}},[_c('i',{staticClass:"fa fa-list-alt fa-2x"}),_c('br'),_vm._v("\n          "+_vm._s(_vm.$t('provider.reservations.emptyState.' + _vm.type))+"\n        ")])])],2)]),_vm._v(" "),_c('div',{class:[{'hideDesktop':!_vm.isMobile}, 'table-cards']},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_c('div',{staticClass:"table-block"},[_c('ellipsis-loader'),_vm._v("\n        "+_vm._s(_vm.$t('provider.reservations.loading'))+"\n      ")],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reservations.length === 0 && !_vm.loading),expression:"reservations.length === 0 && !loading"}]},[_c('div',{staticClass:"table-block"},[_c('i',{staticClass:"fa fa-list-alt fa-2x"}),_c('br'),_vm._v("\n        "+_vm._s(_vm.$t('provider.reservations.emptyState.' + _vm.type))+"\n      ")])]),_vm._v(" "),_vm._l((_vm.reservations),function(rsvp,index){return _c('div',{key:index,staticClass:"table-card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"service-div"},[_c('div',[(rsvp.type !== 'pkg')?_c('a',{attrs:{"href":'/#/reservation/' + rsvp.id,"target":"_blank"}},[_vm._v("\n              "+_vm._s(rsvp.id)+"\n            ")]):_vm._e(),_vm._v(" "),(rsvp.type === 'pkg')?_c('a',{attrs:{"href":'/#/package/' + rsvp.id,"target":"_blank"}},[_vm._v("\n              "+_vm._s(rsvp.id)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"service"},[(_vm.useOldQuatation)?_c('span',{class:['service-label', rsvp.service]},[_vm._v(_vm._s(_vm.serviceLabel(rsvp.service)))]):_c('span',{staticClass:"service-label",style:({backgroundColor: rsvp.serviceType.color})},[_vm._v(_vm._s(rsvp.serviceType.label))]),_vm._v(" "),(rsvp.type === 'pkg')?_c('a',{attrs:{"href":'/#/package/' + rsvp.id,"target":"_blank"}},[_c('i',{staticClass:"fa fa-cube"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"amount"},[_vm._v("\n          $"+_vm._s(_vm.toFixed(rsvp.amountPaid))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"clock"},[_c('i',{staticClass:"fas fa-clock icon"}),_vm._v(" "),_c('span',[_vm._v("\n          "+_vm._s(rsvp.pickupTime)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"pickup"},[_c('i',{staticClass:"fas fa-map-marker-alt icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(rsvp.pickup))])]),_vm._v(" "),_c('div',{staticClass:"dropoff"},[_c('i',{staticClass:"fas fa-location-arrow icon"}),_vm._v(" "),(rsvp.isCharter)?_c('span',[_vm._v("--")]):_c('span',[_vm._v(_vm._s(rsvp.dropoff))])]),_vm._v(" "),_c('div',{staticClass:"flight"},[_c('i',{staticClass:"fas fa-plane-departure icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(rsvp.flight))])]),_vm._v(" "),_c('div',[_c('i',{staticClass:"fas fa-user-friends icon"}),_vm._v("\n        "+_vm._s(rsvp.pax)+"\n        "),_c('i',{staticClass:"fas fa-suitcase icon"}),_vm._v("\n        "+_vm._s(rsvp.luggage)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"name"},[_c('i',{staticClass:"fas fa-user icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(rsvp.customer))])])])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logs_vue__ = __webpack_require__(585);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04b09547_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logs_vue__ = __webpack_require__(1721);
function injectStyle (ssrContext) {
  __webpack_require__(1711)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04b09547"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04b09547_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1712);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("05e194a2", content, true, {});

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.tab[data-v-04b09547] {\n  list-style: none;\n  padding: 0;\n  margin: 15px 0 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  z-index: 2;\n}\n.tab li[data-v-04b09547] {\n    color: #0D79F2;\n    padding: 15px 25px;\n    font-size: 14px;\n    font-weight: 600;\n    text-align: center;\n    display: inline-block;\n    text-transform: uppercase;\n    cursor: pointer;\n}\n.tab li.active[data-v-04b09547] {\n      background: #fff;\n      -webkit-box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);\n              box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);\n      border-radius: 2px 2px 0 0;\n      color: #777;\n}\n.tab-contents[data-v-04b09547] {\n  background: #fff;\n  z-index: 1;\n  position: relative;\n  -webkit-box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);\n}\n.tab-contents .tab-content[data-v-04b09547] {\n    padding: 20px;\n    display: none;\n    height: calc(100vh - 65px);\n    overflow: auto;\n}\n.tab-contents .tab-content.active[data-v-04b09547] {\n      display: block;\n}\n@media only screen and (max-width: 430px) {\n.tab[data-v-04b09547] {\n    margin-top: 60px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Provider/Logs.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,WAAW;CACZ;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;CACnB;AACD;MACM,iBAAiB;MACjB,kDAAkD;cAC1C,0CAA0C;MAClD,2BAA2B;MAC3B,YAAY;CACjB;AACD;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;CACpD;AACD;IACI,cAAc;IACd,cAAc;IACd,2BAA2B;IAC3B,eAAe;CAClB;AACD;MACM,eAAe;CACpB;AACD;AACA;IACI,iBAAiB;CACpB;CACA","file":"Logs.vue","sourcesContent":["\n.tab[data-v-04b09547] {\n  list-style: none;\n  padding: 0;\n  margin: 15px 0 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  z-index: 2;\n}\n.tab li[data-v-04b09547] {\n    color: #0D79F2;\n    padding: 15px 25px;\n    font-size: 14px;\n    font-weight: 600;\n    text-align: center;\n    display: inline-block;\n    text-transform: uppercase;\n    cursor: pointer;\n}\n.tab li.active[data-v-04b09547] {\n      background: #fff;\n      -webkit-box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);\n              box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);\n      border-radius: 2px 2px 0 0;\n      color: #777;\n}\n.tab-contents[data-v-04b09547] {\n  background: #fff;\n  z-index: 1;\n  position: relative;\n  -webkit-box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);\n}\n.tab-contents .tab-content[data-v-04b09547] {\n    padding: 20px;\n    display: none;\n    height: calc(100vh - 65px);\n    overflow: auto;\n}\n.tab-contents .tab-content.active[data-v-04b09547] {\n      display: block;\n}\n@media only screen and (max-width: 430px) {\n.tab[data-v-04b09547] {\n    margin-top: 60px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileHistory_vue__ = __webpack_require__(586);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_805c937a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileHistory_vue__ = __webpack_require__(1716);
function injectStyle (ssrContext) {
  __webpack_require__(1714)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-805c937a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_805c937a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1715);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("6b0c5416", content, true, {});

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.logs-box[data-v-805c937a] {\n  background: #fff;\n}\n.list[data-v-805c937a] {\n  margin-top: 15px;\n}\n.date-range[data-v-805c937a] {\n  padding: 20px;\n  background: #fafafa;\n  border-bottom: 1px solid #eee;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.date-range .small-6[data-v-805c937a]:first-child {\n    padding-right: 10px;\n}\n.date-range .datepicker[data-v-805c937a] {\n    margin-bottom: 5px;\n}\n.date-range .error-msg[data-v-805c937a] {\n    background: #ff6115;\n    border-radius: 3px;\n    font-size: 13px;\n    color: #fff;\n    display: block;\n    padding: 4px;\n    margin-bottom: 7px;\n    font-style: italic;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.action[data-v-805c937a] {\n  border: 1px solid #ddd;\n  width: 100%;\n  max-height: auto;\n  padding: 10px;\n  background: #fafafa;\n  overflow: hidden;\n  -webkit-transition: all .35s ease-in-out;\n  transition: all .35s ease-in-out;\n  cursor: pointer;\n  margin-bottom: 10px;\n}\n.action[data-v-805c937a]:hover {\n    background: #fff8dc;\n}\n.action.collapsed[data-v-805c937a] {\n    padding: 10px;\n    background: #fff8dc;\n}\n.action .log-heading[data-v-805c937a] {\n    margin: 0;\n    font-weight: 600;\n}\n.action .action-item[data-v-805c937a] {\n    padding-left: 15px;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.action .action-item .icon-display[data-v-805c937a] {\n      float: left;\n      width: 5%;\n}\n.action .action-item .icon-display i[data-v-805c937a] {\n        font-size: 11px;\n        color: #666;\n}\n.action .action-item .action-display[data-v-805c937a] {\n      float: left;\n      width: 95%;\n      margin-top: 10px;\n}\n.action .action-item .log-details[data-v-805c937a] {\n      font-size: 11px;\n      color: #666;\n}\n.action .action-item .log-data[data-v-805c937a] {\n      margin-bottom: 2px;\n}\n.action .minimize[data-v-805c937a] {\n    font-size: 11px;\n    color: #666;\n    content: \"\";\n    clear: both;\n}\n.action .minimize .icon-display[data-v-805c937a] {\n      float: left;\n      width: 5%;\n}\n.action .minimize .icon-display i[data-v-805c937a] {\n        font-size: 11px;\n        color: #666;\n}\n.action .minimize .action-display[data-v-805c937a] {\n      float: left;\n      width: 95%;\n}\n.action .minimize .action-display p[data-v-805c937a] {\n        margin: 0;\n}\n.loader[data-v-805c937a] {\n  text-align: center;\n  padding: 10px;\n  font-size: 21px;\n  color: #bbb;\n  font-weight: 600;\n}\n.loader i[data-v-805c937a] {\n    margin-right: 3px;\n}\n.empty-state[data-v-805c937a] {\n  padding: 30px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\n.empty-state .fa[data-v-805c937a] {\n    display: block;\n    margin-bottom: 5px;\n    color: #ccc;\n    text-shadow: 0 0 5px white;\n}\n.slide-down-enter-active[data-v-805c937a], .slide-down-leave-active[data-v-805c937a] {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.slide-down-enter[data-v-805c937a], .slide-down-leave-to[data-v-805c937a] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n.slide-up-enter-active[data-v-805c937a], .slide-up-leave-active[data-v-805c937a] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-805c937a], .slide-up-leave-to[data-v-805c937a] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.service-label[data-v-805c937a] {\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 12px;\n  display: inline-block;\n  margin-top: 2px;\n  text-transform: capitalize;\n}\n.service-label.shared[data-v-805c937a] {\n    background: #f38d56;\n}\n.service-label.opoli[data-v-805c937a] {\n    background: #26D97A;\n}\n.service-label.black[data-v-805c937a] {\n    background: #777;\n}\n.service-label.SUV[data-v-805c937a], .service-label.suv[data-v-805c937a] {\n    background: #dc3168;\n}\n.service-label.shuttle[data-v-805c937a] {\n    background: #6dabc3;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Provider/ProfileHistory.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;CAClB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,cAAc;EACd,oBAAoB;EACpB,8BAA8B;EAC9B,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;IACI,oBAAoB;CACvB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,yCAAyC;EACzC,iCAAiC;EACjC,gBAAgB;EAChB,oBAAoB;CACrB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,cAAc;IACd,oBAAoB;CACvB;AACD;IACI,UAAU;IACV,iBAAiB;CACpB;AACD;IACI,mBAAmB;IACnB,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;MACM,YAAY;MACZ,UAAU;CACf;AACD;QACQ,gBAAgB;QAChB,YAAY;CACnB;AACD;MACM,YAAY;MACZ,WAAW;MACX,iBAAiB;CACtB;AACD;MACM,gBAAgB;MAChB,YAAY;CACjB;AACD;MACM,mBAAmB;CACxB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,YAAY;CACf;AACD;MACM,YAAY;MACZ,UAAU;CACf;AACD;QACQ,gBAAgB;QAChB,YAAY;CACnB;AACD;MACM,YAAY;MACZ,WAAW;CAChB;AACD;QACQ,UAAU;CACjB;AACD;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;CAClB;AACD;IACI,kBAAkB;CACrB;AACD;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;CAC9B;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;CAC5B;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB","file":"ProfileHistory.vue","sourcesContent":["\n.logs-box[data-v-805c937a] {\n  background: #fff;\n}\n.list[data-v-805c937a] {\n  margin-top: 15px;\n}\n.date-range[data-v-805c937a] {\n  padding: 20px;\n  background: #fafafa;\n  border-bottom: 1px solid #eee;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.date-range .small-6[data-v-805c937a]:first-child {\n    padding-right: 10px;\n}\n.date-range .datepicker[data-v-805c937a] {\n    margin-bottom: 5px;\n}\n.date-range .error-msg[data-v-805c937a] {\n    background: #ff6115;\n    border-radius: 3px;\n    font-size: 13px;\n    color: #fff;\n    display: block;\n    padding: 4px;\n    margin-bottom: 7px;\n    font-style: italic;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.action[data-v-805c937a] {\n  border: 1px solid #ddd;\n  width: 100%;\n  max-height: auto;\n  padding: 10px;\n  background: #fafafa;\n  overflow: hidden;\n  -webkit-transition: all .35s ease-in-out;\n  transition: all .35s ease-in-out;\n  cursor: pointer;\n  margin-bottom: 10px;\n}\n.action[data-v-805c937a]:hover {\n    background: #fff8dc;\n}\n.action.collapsed[data-v-805c937a] {\n    padding: 10px;\n    background: #fff8dc;\n}\n.action .log-heading[data-v-805c937a] {\n    margin: 0;\n    font-weight: 600;\n}\n.action .action-item[data-v-805c937a] {\n    padding-left: 15px;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.action .action-item .icon-display[data-v-805c937a] {\n      float: left;\n      width: 5%;\n}\n.action .action-item .icon-display i[data-v-805c937a] {\n        font-size: 11px;\n        color: #666;\n}\n.action .action-item .action-display[data-v-805c937a] {\n      float: left;\n      width: 95%;\n      margin-top: 10px;\n}\n.action .action-item .log-details[data-v-805c937a] {\n      font-size: 11px;\n      color: #666;\n}\n.action .action-item .log-data[data-v-805c937a] {\n      margin-bottom: 2px;\n}\n.action .minimize[data-v-805c937a] {\n    font-size: 11px;\n    color: #666;\n    content: \"\";\n    clear: both;\n}\n.action .minimize .icon-display[data-v-805c937a] {\n      float: left;\n      width: 5%;\n}\n.action .minimize .icon-display i[data-v-805c937a] {\n        font-size: 11px;\n        color: #666;\n}\n.action .minimize .action-display[data-v-805c937a] {\n      float: left;\n      width: 95%;\n}\n.action .minimize .action-display p[data-v-805c937a] {\n        margin: 0;\n}\n.loader[data-v-805c937a] {\n  text-align: center;\n  padding: 10px;\n  font-size: 21px;\n  color: #bbb;\n  font-weight: 600;\n}\n.loader i[data-v-805c937a] {\n    margin-right: 3px;\n}\n.empty-state[data-v-805c937a] {\n  padding: 30px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\n.empty-state .fa[data-v-805c937a] {\n    display: block;\n    margin-bottom: 5px;\n    color: #ccc;\n    text-shadow: 0 0 5px white;\n}\n.slide-down-enter-active[data-v-805c937a], .slide-down-leave-active[data-v-805c937a] {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.slide-down-enter[data-v-805c937a], .slide-down-leave-to[data-v-805c937a] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n.slide-up-enter-active[data-v-805c937a], .slide-up-leave-active[data-v-805c937a] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-805c937a], .slide-up-leave-to[data-v-805c937a] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.service-label[data-v-805c937a] {\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 12px;\n  display: inline-block;\n  margin-top: 2px;\n  text-transform: capitalize;\n}\n.service-label.shared[data-v-805c937a] {\n    background: #f38d56;\n}\n.service-label.opoli[data-v-805c937a] {\n    background: #26D97A;\n}\n.service-label.black[data-v-805c937a] {\n    background: #777;\n}\n.service-label.SUV[data-v-805c937a], .service-label.suv[data-v-805c937a] {\n    background: #dc3168;\n}\n.service-label.shuttle[data-v-805c937a] {\n    background: #6dabc3;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logs-box",on:{"scroll":_vm.onScroll}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDateRange),expression:"showDateRange"}],staticClass:"date-range"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-6"},[_c('datepicker',{staticClass:"datepicker small inline",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"input-class":{'datepicker-empty':_vm.error.from},"placeholder":_vm.$t('transactions.filter.from')},on:{"input":function($event){return _vm.changeDate('from')}},model:{value:(_vm.date.from),callback:function ($$v) {_vm.$set(_vm.date, "from", $$v)},expression:"date.from"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('datepicker',{staticClass:"datepicker small inline left-side",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"input-class":{'datepicker-empty':_vm.error.to},"placeholder":_vm.$t('transactions.filter.to')},on:{"input":function($event){return _vm.changeDate('to')}},model:{value:(_vm.date.to),callback:function ($$v) {_vm.$set(_vm.date, "to", $$v)},expression:"date.to"}})],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[(!!_vm.error.message)?_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.message))]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"cta button block xsmall success",on:{"click":_vm.dateApply}},[_vm._v("Submit")])],1)]),_vm._v(" "),_c('div',{staticClass:"list"},[_vm._l((_vm.logs),function(log,i){return _c('div',{key:i,class:{'action':true, 'collapsed':log.collapsed},on:{"click":function($event){log.show = !log.show}}},[_c('div',{staticClass:"minimize"},[_c('div',{staticClass:"icon-display"},[(!log.show)?_c('i',{staticClass:"fa fa-plus-circle"}):_c('i',{staticClass:"fa fa-minus-circle"})]),_vm._v(" "),_c('div',{staticClass:"action-display"},[_c('span',[_vm._v(_vm._s(log.created))]),_vm._v(" "),_c('div',{staticClass:"log-heading"},[_vm._v(_vm._s(_vm.title(log)))])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(log.show),expression:"log.show"}],staticClass:"action-item"},[_c('div',{staticClass:"icon-display"}),_vm._v(" "),_c('div',{staticClass:"action-display"},[_c('div',{staticClass:"log-details"},[(_vm.showPkgId.indexOf(log.action) > -1 || log.details.packageID)?_c('div',{staticClass:"log-data"},[_vm._v("\n              Package ID: \n              "),_c('a',{attrs:{"href":("#/package/" + (log.details.packageID)),"target":"_blank"}},[_vm._v(_vm._s(log.details.packageID))])]):_vm._e(),_vm._v(" "),(_vm.showRsvpId.indexOf(log.action) > -1)?_c('div',{staticClass:"log-data"},[_vm._v("\n              Reservation ID: \n              "),_c('a',{attrs:{"href":("#/reservation/" + (log.rsvpId)),"target":"_blank"}},[_vm._v(_vm._s(log.rsvpId))])]):_vm._e(),_vm._v(" "),(log.action === 'driver_release')?_c('div',{staticClass:"log-data"},[_vm._v("\n              Cancellation Fee: "),_c('b',[_vm._v("$"+_vm._s(_vm.toFixed(log.details.fee.Charge)))])]):_vm._e(),_vm._v(" "),(log.action === 'provider_services')?_c('div',{staticClass:"log-data"},_vm._l((log.details.services),function(detail,index){return _c('div',{domProps:{"innerHTML":_vm._s(_vm.serviceLabel(detail))}})}),0):_vm._e(),_vm._v(" "),(['admin_edit_provider', 'provider_activate', 'provider_deactivate'].indexOf(log.action) > -1)?_c('div',[_c('div',{staticClass:"log-data"},[_vm._v("Admin ID: "),_c('b',[_vm._v(_vm._s(log.details.adminId))])]),_vm._v(" "),_c('div',{staticClass:"log-data"},[_vm._v("Admin Name: "),_c('b',[_vm._v(_vm._s(log.details.adminName))])]),_vm._v(" "),_c('div',{staticClass:"log-data"},[_vm._v("Admin Email: "),_c('b',[_vm._v(_vm._s(log.details.adminEmail))])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((log.details.changes),function(detail,index){return _c('div',{key:index,staticClass:"log-data"},[(['profile.businessSSN', 'profile.businessSSNUrl', 'profile.businessEIN', 'profile.businessEINUrl', 'profile.w9fileUrl'].indexOf(detail.property) > -1)?_c('div',[_c('b',[(log.action === 'admin_edit_provider')?_c('span',[_vm._v("Admin ")]):_c('span',[_vm._v("Driver ")]),_vm._v("\n                  updated "+_vm._s(_vm.fieldLabel[detail.property])+".\n                ")])]):(log.action === 'edit_provider' && ['profile.avatarUrl'].indexOf(detail.property) > -1)?_c('div',[_c('b',[_vm._v("Driver updated profile photo.")])]):(log.action === 'admin_edit_provider' && ['profile.avatarUrl'].indexOf(detail.property) > -1)?_c('div',[_c('b',[_vm._v("Admin updated profile photo.")])]):(log.action === 'edit_provider' && ['vehicle.serviceDog'].indexOf(detail.property) > -1)?_c('div'):_c('div',[_c('b',[_vm._v(_vm._s(_vm.fieldLabel[detail.property] || detail.property))]),_vm._v(" "),_c('div',[_vm._v("\n                  "+_vm._s(detail.old)+"\n                  "),_c('i',{staticClass:"fas fa-chevron-right"}),_vm._v(" "),_c('b',[_vm._v(_vm._s(detail.new))])])]),_vm._v(" "),(!(log.action === 'edit_provider' && ['vehicle.serviceDog'].indexOf(detail.property) > -1))?_c('br'):_vm._e()])}),_vm._v(" "),_vm._l((log.details.docs),function(detail,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(['SSN', 'EIN', 'W-9'].indexOf(detail.document) < 0),expression:"['SSN', 'EIN', 'W-9'].indexOf(detail.document) < 0"}],key:'doc' +index,staticClass:"log-data"},[_c('div',[_c('b',[(log.action === 'admin_edit_provider')?_c('span',[_vm._v("Admin ")]):_c('span',[_vm._v("Driver ")]),_vm._v("\n                  updated "+_vm._s(_vm.renameDocument(detail.document))+".\n                ")])]),_vm._v(" "),_c('br')])})],2)])])])],1)}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.loading)?_c('div',{staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" Loading...\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.logs.length === 0 && !_vm.loading),expression:"logs.length === 0 && !loading"}],staticClass:"empty-state"},[_c('i',{staticClass:"fa fa-clipboard-list fa-4x"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('rsvpDetails.activityLogs.emptyState')))])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivityHistory_vue__ = __webpack_require__(587);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_355c89fa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivityHistory_vue__ = __webpack_require__(1720);
function injectStyle (ssrContext) {
  __webpack_require__(1718)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-355c89fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivityHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_355c89fa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivityHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1719);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5480aee0", content, true, {});

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.logs-box[data-v-355c89fa] {\n  background: #fff;\n}\n.list[data-v-355c89fa] {\n  margin-top: 15px;\n}\n.date-range[data-v-355c89fa] {\n  padding: 20px;\n  background: #fafafa;\n  border-bottom: 1px solid #eee;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.date-range .small-6[data-v-355c89fa]:first-child {\n    padding-right: 10px;\n}\n.date-range .datepicker[data-v-355c89fa] {\n    margin-bottom: 5px;\n}\n.date-range .error-msg[data-v-355c89fa] {\n    background: #ff6115;\n    border-radius: 3px;\n    font-size: 13px;\n    color: #fff;\n    display: block;\n    padding: 4px;\n    margin-bottom: 7px;\n    font-style: italic;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.action[data-v-355c89fa] {\n  border: 1px solid #ddd;\n  width: 100%;\n  max-height: auto;\n  padding: 10px;\n  background: #fafafa;\n  overflow: hidden;\n  -webkit-transition: all .35s ease-in-out;\n  transition: all .35s ease-in-out;\n  cursor: pointer;\n  margin-bottom: 10px;\n}\n.action[data-v-355c89fa]:hover {\n    background: #fff8dc;\n}\n.action.collapsed[data-v-355c89fa] {\n    padding: 10px;\n    background: #fff8dc;\n}\n.action .log-heading[data-v-355c89fa] {\n    margin: 0;\n    font-weight: 600;\n}\n.action .action-item[data-v-355c89fa] {\n    padding-left: 15px;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.action .action-item .icon-display[data-v-355c89fa] {\n      float: left;\n      width: 5%;\n}\n.action .action-item .icon-display i[data-v-355c89fa] {\n        font-size: 11px;\n        color: #666;\n}\n.action .action-item .action-display[data-v-355c89fa] {\n      float: left;\n      width: 95%;\n      margin-top: 10px;\n}\n.action .action-item .log-details[data-v-355c89fa] {\n      font-size: 11px;\n      color: #666;\n}\n.action .action-item .log-data[data-v-355c89fa] {\n      margin-bottom: 2px;\n}\n.action .minimize[data-v-355c89fa] {\n    font-size: 11px;\n    color: #666;\n    content: \"\";\n    clear: both;\n}\n.action .minimize .icon-display[data-v-355c89fa] {\n      float: left;\n      width: 5%;\n}\n.action .minimize .icon-display i[data-v-355c89fa] {\n        font-size: 11px;\n        color: #666;\n}\n.action .minimize .action-display[data-v-355c89fa] {\n      float: left;\n      width: 95%;\n}\n.action .minimize .action-display p[data-v-355c89fa] {\n        margin: 0;\n}\n.loader[data-v-355c89fa] {\n  text-align: center;\n  padding: 10px;\n  font-size: 21px;\n  color: #bbb;\n  font-weight: 600;\n}\n.loader i[data-v-355c89fa] {\n    margin-right: 3px;\n}\n.empty-state[data-v-355c89fa] {\n  padding: 30px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\n.empty-state .fa[data-v-355c89fa] {\n    display: block;\n    margin-bottom: 5px;\n    color: #ccc;\n    text-shadow: 0 0 5px white;\n}\n.slide-down-enter-active[data-v-355c89fa], .slide-down-leave-active[data-v-355c89fa] {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.slide-down-enter[data-v-355c89fa], .slide-down-leave-to[data-v-355c89fa] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n.slide-up-enter-active[data-v-355c89fa], .slide-up-leave-active[data-v-355c89fa] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-355c89fa], .slide-up-leave-to[data-v-355c89fa] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.service-label[data-v-355c89fa] {\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 12px;\n  display: inline-block;\n  margin-top: 2px;\n  text-transform: capitalize;\n}\n.service-label.shared[data-v-355c89fa] {\n    background: #f38d56;\n}\n.service-label.opoli[data-v-355c89fa] {\n    background: #26D97A;\n}\n.service-label.black[data-v-355c89fa] {\n    background: #777;\n}\n.service-label.SUV[data-v-355c89fa], .service-label.suv[data-v-355c89fa] {\n    background: #dc3168;\n}\n.service-label.shuttle[data-v-355c89fa] {\n    background: #6dabc3;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Provider/ActivityHistory.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;CAClB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,cAAc;EACd,oBAAoB;EACpB,8BAA8B;EAC9B,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;IACI,oBAAoB;CACvB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,yCAAyC;EACzC,iCAAiC;EACjC,gBAAgB;EAChB,oBAAoB;CACrB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,cAAc;IACd,oBAAoB;CACvB;AACD;IACI,UAAU;IACV,iBAAiB;CACpB;AACD;IACI,mBAAmB;IACnB,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;MACM,YAAY;MACZ,UAAU;CACf;AACD;QACQ,gBAAgB;QAChB,YAAY;CACnB;AACD;MACM,YAAY;MACZ,WAAW;MACX,iBAAiB;CACtB;AACD;MACM,gBAAgB;MAChB,YAAY;CACjB;AACD;MACM,mBAAmB;CACxB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,YAAY;CACf;AACD;MACM,YAAY;MACZ,UAAU;CACf;AACD;QACQ,gBAAgB;QAChB,YAAY;CACnB;AACD;MACM,YAAY;MACZ,WAAW;CAChB;AACD;QACQ,UAAU;CACjB;AACD;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;CAClB;AACD;IACI,kBAAkB;CACrB;AACD;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;CAC9B;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;CAC5B;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB","file":"ActivityHistory.vue","sourcesContent":["\n.logs-box[data-v-355c89fa] {\n  background: #fff;\n}\n.list[data-v-355c89fa] {\n  margin-top: 15px;\n}\n.date-range[data-v-355c89fa] {\n  padding: 20px;\n  background: #fafafa;\n  border-bottom: 1px solid #eee;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n.date-range .small-6[data-v-355c89fa]:first-child {\n    padding-right: 10px;\n}\n.date-range .datepicker[data-v-355c89fa] {\n    margin-bottom: 5px;\n}\n.date-range .error-msg[data-v-355c89fa] {\n    background: #ff6115;\n    border-radius: 3px;\n    font-size: 13px;\n    color: #fff;\n    display: block;\n    padding: 4px;\n    margin-bottom: 7px;\n    font-style: italic;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.action[data-v-355c89fa] {\n  border: 1px solid #ddd;\n  width: 100%;\n  max-height: auto;\n  padding: 10px;\n  background: #fafafa;\n  overflow: hidden;\n  -webkit-transition: all .35s ease-in-out;\n  transition: all .35s ease-in-out;\n  cursor: pointer;\n  margin-bottom: 10px;\n}\n.action[data-v-355c89fa]:hover {\n    background: #fff8dc;\n}\n.action.collapsed[data-v-355c89fa] {\n    padding: 10px;\n    background: #fff8dc;\n}\n.action .log-heading[data-v-355c89fa] {\n    margin: 0;\n    font-weight: 600;\n}\n.action .action-item[data-v-355c89fa] {\n    padding-left: 15px;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.action .action-item .icon-display[data-v-355c89fa] {\n      float: left;\n      width: 5%;\n}\n.action .action-item .icon-display i[data-v-355c89fa] {\n        font-size: 11px;\n        color: #666;\n}\n.action .action-item .action-display[data-v-355c89fa] {\n      float: left;\n      width: 95%;\n      margin-top: 10px;\n}\n.action .action-item .log-details[data-v-355c89fa] {\n      font-size: 11px;\n      color: #666;\n}\n.action .action-item .log-data[data-v-355c89fa] {\n      margin-bottom: 2px;\n}\n.action .minimize[data-v-355c89fa] {\n    font-size: 11px;\n    color: #666;\n    content: \"\";\n    clear: both;\n}\n.action .minimize .icon-display[data-v-355c89fa] {\n      float: left;\n      width: 5%;\n}\n.action .minimize .icon-display i[data-v-355c89fa] {\n        font-size: 11px;\n        color: #666;\n}\n.action .minimize .action-display[data-v-355c89fa] {\n      float: left;\n      width: 95%;\n}\n.action .minimize .action-display p[data-v-355c89fa] {\n        margin: 0;\n}\n.loader[data-v-355c89fa] {\n  text-align: center;\n  padding: 10px;\n  font-size: 21px;\n  color: #bbb;\n  font-weight: 600;\n}\n.loader i[data-v-355c89fa] {\n    margin-right: 3px;\n}\n.empty-state[data-v-355c89fa] {\n  padding: 30px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\n.empty-state .fa[data-v-355c89fa] {\n    display: block;\n    margin-bottom: 5px;\n    color: #ccc;\n    text-shadow: 0 0 5px white;\n}\n.slide-down-enter-active[data-v-355c89fa], .slide-down-leave-active[data-v-355c89fa] {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.slide-down-enter[data-v-355c89fa], .slide-down-leave-to[data-v-355c89fa] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n.slide-up-enter-active[data-v-355c89fa], .slide-up-leave-active[data-v-355c89fa] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-355c89fa], .slide-up-leave-to[data-v-355c89fa] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.service-label[data-v-355c89fa] {\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 12px;\n  display: inline-block;\n  margin-top: 2px;\n  text-transform: capitalize;\n}\n.service-label.shared[data-v-355c89fa] {\n    background: #f38d56;\n}\n.service-label.opoli[data-v-355c89fa] {\n    background: #26D97A;\n}\n.service-label.black[data-v-355c89fa] {\n    background: #777;\n}\n.service-label.SUV[data-v-355c89fa], .service-label.suv[data-v-355c89fa] {\n    background: #dc3168;\n}\n.service-label.shuttle[data-v-355c89fa] {\n    background: #6dabc3;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logs-box",on:{"scroll":_vm.onScroll}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDateRange),expression:"showDateRange"}],staticClass:"date-range"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-6"},[_c('datepicker',{staticClass:"datepicker small inline",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"input-class":{'datepicker-empty':_vm.error.from},"placeholder":_vm.$t('transactions.filter.from')},on:{"input":function($event){return _vm.changeDate('from')}},model:{value:(_vm.date.from),callback:function ($$v) {_vm.$set(_vm.date, "from", $$v)},expression:"date.from"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('datepicker',{staticClass:"datepicker small inline left-side",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"input-class":{'datepicker-empty':_vm.error.to},"placeholder":_vm.$t('transactions.filter.to')},on:{"input":function($event){return _vm.changeDate('to')}},model:{value:(_vm.date.to),callback:function ($$v) {_vm.$set(_vm.date, "to", $$v)},expression:"date.to"}})],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[(!!_vm.error.message)?_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.message))]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"cta button block xsmall success",on:{"click":_vm.dateApply}},[_vm._v("Submit")])],1)]),_vm._v(" "),_c('div',{staticClass:"list"},[_vm._l((_vm.logs),function(log,i){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(log.action !== 'admin_edit_provider' || (log.action === 'admin_edit_provider' && log.details.changes.length)),expression:"log.action !== 'admin_edit_provider' || (log.action === 'admin_edit_provider' && log.details.changes.length)"}],key:i,class:{'action':true, 'collapsed':log.collapsed},on:{"click":function($event){log.show = !log.show}}},[_c('div',{staticClass:"minimize"},[_c('div',{staticClass:"icon-display"},[(!log.show)?_c('i',{staticClass:"fa fa-plus-circle"}):_c('i',{staticClass:"fa fa-minus-circle"})]),_vm._v(" "),_c('div',{staticClass:"action-display"},[_c('span',[_vm._v(_vm._s(log.created))]),_vm._v(" "),_c('div',{staticClass:"log-heading"},[_vm._v(_vm._s(_vm.title(log)))])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(log.show),expression:"log.show"}],staticClass:"action-item"},[_c('div',{staticClass:"icon-display"}),_vm._v(" "),_c('div',{staticClass:"action-display"},[_c('div',{staticClass:"log-details"},[(_vm.showPkgId.indexOf(log.action) > -1 || log.details.packageID)?_c('div',{staticClass:"log-data"},[_vm._v("\n                Package ID: \n                "),_c('a',{attrs:{"href":("#/package/" + (log.details.packageID)),"target":"_blank"}},[_vm._v(_vm._s(log.details.packageID))])]):_vm._e(),_vm._v(" "),(_vm.showRsvpId.indexOf(log.action) > -1)?_c('div',{staticClass:"log-data"},[_vm._v("\n                Reservation ID: \n                "),_c('a',{attrs:{"href":("#/reservation/" + (log.rsvpId)),"target":"_blank"}},[_vm._v(_vm._s(log.rsvpId))])]):_vm._e(),_vm._v(" "),(log.action === 'driver_release')?_c('div',{staticClass:"log-data"},[_vm._v("\n                Cancellation Fee: "),_c('b',[_vm._v("$"+_vm._s(_vm.toFixed(log.details.fee.Charge)))])]):_vm._e(),_vm._v(" "),(log.action === 'admin_edit_provider')?_c('div',[_c('div',{staticClass:"log-data"},[_vm._v("Admin ID: "),_c('b',[_vm._v(_vm._s(log.details.adminId))])]),_vm._v(" "),_c('div',{staticClass:"log-data"},[_vm._v("Admin Name: "),_c('b',[_vm._v(_vm._s(log.details.adminName))])]),_vm._v(" "),_c('div',{staticClass:"log-data"},[_vm._v("Admin Email: "),_c('b',[_vm._v(_vm._s(log.details.adminEmail))])]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((log.details.changes),function(detail,index){return _c('div',{key:index,staticClass:"log-data"},[(['profile.businessSSN', 'profile.businessSSNUrl', 'profile.businessEIN', 'profile.businessEINUrl'].indexOf(detail.property) > -1)?_c('div',[_c('b',[_vm._v("Admin updated "+_vm._s(_vm.fieldLabel[detail.property])+".")])]):_c('div',[_c('b',[_vm._v(_vm._s(_vm.fieldLabel[detail.property] || detail.property))]),_vm._v(" "),_c('div',[_vm._v("\n                      "+_vm._s(detail.old)+"\n                      "),_c('i',{staticClass:"fas fa-chevron-right"}),_vm._v(" "),_c('b',[_vm._v(_vm._s(detail.new))])]),_vm._v(" "),_c('br')])])})],2):_vm._e()])])])])],1)}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.loading)?_c('div',{staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" Loading...\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.logs.length === 0 && !_vm.loading),expression:"logs.length === 0 && !loading"}],staticClass:"empty-state"},[_c('i',{staticClass:"fa fa-clipboard-list fa-4x"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('rsvpDetails.activityLogs.emptyState')))])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"tab"},[_c('li',{class:{'active':_vm.activeTab === 0},on:{"click":function($event){_vm.activeTab = 0}}},[_vm._v("\n      Profile History\n    ")]),_vm._v(" "),_c('li',{class:{'active':_vm.activeTab === 1},on:{"click":function($event){_vm.activeTab = 1}}},[_vm._v("\n      Activity History\n    ")])]),_vm._v(" "),_c('div',{staticClass:"tab-contents"},[_c('div',{class:{'tab-content':true, 'active':_vm.activeTab === 0},on:{"scroll":_vm.onScrollProfile}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.profileHistoryDate),expression:"profileHistoryDate"}],class:{'date-select':true, 'disabled':_vm.profileHistoryLoading},attrs:{"disabled":_vm.profileHistoryLoading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.profileHistoryDate=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v("All")]),_vm._v(" "),_c('option',{attrs:{"value":"custom"}},[_vm._v("Custom")])]),_vm._v(" "),_c('profile-history',{ref:"profileHistory"})],1),_vm._v(" "),_c('div',{class:{'tab-content':true, 'active':_vm.activeTab === 1},on:{"scroll":_vm.onScrollActivity}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.activityHistoryDate),expression:"activityHistoryDate"}],class:{'date-select':true, 'disabled':_vm.activityHistoryLoading},attrs:{"disabled":_vm.activityHistoryLoading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.activityHistoryDate=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v("All")]),_vm._v(" "),_c('option',{attrs:{"value":"custom"}},[_vm._v("Custom")])]),_vm._v(" "),_c('activity-history',{ref:"activityHistory"})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"left-panel",on:{"scroll":_vm.onScrollLeftPanel}},[_c('div',{staticClass:"heading"},[_c('span',[_vm._v(_vm._s(_vm.providerName))]),_vm._v(" "),_c('div',{staticClass:"switch"},[_c('div',{class:{'slider':true, 'active':_vm.isActive, 'disabled':_vm.showActiveModal || !_vm.editEnabled},on:{"click":_vm.confirmModal}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.active')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isActive),expression:"!isActive"}],staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.deactive')))])]),_vm._v(" "),_c('div',{staticClass:"prov-options",on:{"mouseover":_vm.clearOptionDelay,"mouseout":_vm.hideOptions}},[_c('i',{staticClass:"fas fa-ellipsis-v fa-lg",on:{"click":function($event){_vm.showOptions = !_vm.showOptions}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOptions),expression:"showOptions"}],staticClass:"options"},[_c('div',{staticClass:"button cta success block call",on:{"click":function($event){return _vm.call(_vm.providerData)}}},[_c('i',{staticClass:"fa fa-phone"}),_vm._v(_vm._s(_vm.$t('provider.call'))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"button cta block send-sms",on:{"click":function($event){return _vm.sendSMS(_vm.providerData)}}},[_c('i',{staticClass:"fas fa-comment-dots"}),_vm._v(_vm._s(_vm.$t('provider.sms'))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"button cta warning block send-notif",on:{"click":_vm.showNotif}},[_c('i',{staticClass:"fas fa-bell"}),_vm._v(_vm._s(_vm.$t('provider.notify'))+"\n            ")]),_vm._v(" "),(_vm.isTnc)?_c('div',{staticClass:"button cta block print-placard",on:{"click":_vm.printPlacard}},[_c('i',{staticClass:"far fa-address-card"}),_vm._v(_vm._s(_vm.$t('provider.print'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.isBefore2026(_vm.created))?_c('div',{staticClass:"button cta block error download-profile",on:{"click":function($event){return _vm.dlProfile('op')}}},[_c('i',{staticClass:"fas fa-file-download"}),_vm._v("Download Profile\n              "),_c('span',[_vm._v("(OP)")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"button cta block error download-profile",on:{"click":function($event){return _vm.dlProfile('ptrs')}}},[_c('i',{staticClass:"fas fa-file-download"}),_vm._v("Download Profile\n              "),(_vm.isBefore2026(_vm.created))?_c('span',[_vm._v("(PTRS)")]):_vm._e()])])])],1)]),_vm._v(" "),_c('ul',{staticClass:"tab"},[_c('li',{class:{'active':_vm.activeTab.left === 0},on:{"click":function($event){return _vm.switchTab('left', 0)}}},[_vm._v("\n        "+_vm._s(_vm.$t('provider.tabLabel.accountDetails'))+"\n      ")]),_vm._v(" "),(!_vm.useOldQuatation)?_c('li',{class:{'active':_vm.activeTab.left === 5},on:{"click":function($event){return _vm.switchTab('left', 5)}}},[_vm._v("\n        "+_vm._s(_vm.$t('provider.tabLabel.services'))+"\n      ")]):_vm._e(),_vm._v(" "),_c('li',{class:{'active':_vm.activeTab.left === 2},on:{"click":function($event){return _vm.switchTab('left', 2)}}},[_vm._v("\n        "+_vm._s(_vm.$t('provider.tabLabel.availability'))+"\n      ")]),_vm._v(" "),_c('li',{class:{'active':_vm.activeTab.left === 3},on:{"click":function($event){return _vm.switchTab('left', 3)}}},[_vm._v("\n        "+_vm._s(_vm.$t('provider.tabLabel.reviews'))+"\n      ")]),_vm._v(" "),_c('li',{class:{'active':_vm.activeTab.left === 4},on:{"click":function($event){return _vm.switchTab('left', 4)}}},[_vm._v("\n        "+_vm._s(_vm.$t('provider.tabLabel.notes'))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"tab-contents"},[_c('div',{class:{'tab-content':true, 'active':_vm.activeTab.left == 0}},[_c('account-details',{ref:"accountDetails",attrs:{"basicInfoImg":_vm.basicInfoImg,"vehicleInfoImg":_vm.vehicleInfoImg,"nextDrvrId":_vm.nextDriverId}})],1),_vm._v(" "),(!_vm.useOldQuatation)?_c('div',{class:{'tab-content':true, 'active':_vm.activeTab.left == 5}},[_c('services',{ref:"services",attrs:{"_licenseType":_vm.licenseType}})],1):_vm._e(),_vm._v(" "),_c('div',{class:{'tab-content':true, 'active':_vm.activeTab.left == 2}},[_c('driver-shifts',{ref:"shifts",attrs:{"active":_vm.activeTab.left == 2}})],1),_vm._v(" "),_c('div',{class:{'tab-content':true, 'active':_vm.activeTab.left == 3}},[_c('reviews',{ref:"reviews",attrs:{"active":_vm.activeTab.left == 3}})],1),_vm._v(" "),_c('div',{class:{'tab-content':true, 'active':_vm.activeTab.left == 4}},[_c('notes',{ref:"notes",attrs:{"active":_vm.activeTab.left == 4}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(((_vm.activeTab.left === 0 || _vm.activeTab.left === 5) && _vm.editEnabled) || _vm.activeTab.left === 4),expression:"((activeTab.left === 0 || activeTab.left === 5) && editEnabled) || activeTab.left === 4"}],staticClass:"fix-buttons"},[(_vm.activeTab.left === 0)?_c('a',{class:{'button cta small success':true, 'disabled':_vm.formHasError},on:{"click":_vm.triggerSave}},[(!_vm.formLoading)?_c('span',[_vm._v(_vm._s(_vm.$t('provider.save')))]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin fa-fw"}),_vm._v("\n          "+_vm._s(_vm.$t('provider.saving'))+"\n        ")])]):_vm._e(),_vm._v(" "),(_vm.activeTab.left === 4)?_c('a',{staticClass:"button cta small success right",on:{"click":_vm.AddNotes}},[_vm._v("\n        "+_vm._s(_vm.$t('provider.addNotes'))+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.activeTab.left === 5)?_c('a',{class:{'button cta small success center':true, 'disabled':_vm.serviceSave.loading},on:{"click":_vm.saveServices}},[(_vm.serviceSave.loading)?_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin fa-fw"}),_vm._v("\n          "+_vm._s(_vm.$t('provider.saving'))+"\n        ")]):_c('span',[_vm._v("Save")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"toggle-mobile",on:{"click":function($event){_vm.showRecords = !_vm.showRecords}}},[(!_vm.showRecords)?_c('span',[_vm._v("Show Records "),_c('i',{staticClass:"fa fa-chevron-up"})]):_c('span',[_vm._v("Hide Records "),_c('i',{staticClass:"fa fa-chevron-down"})])]),_vm._v(" "),_c('div',{class:['right-panel', _vm.showRecords ? 'mobile-right-panel' : ''],on:{"scroll":_vm.onScrollRsvp}},[_c('ul',{staticClass:"tab"},[_c('li',{class:{'active':_vm.activeTab.right === 0},on:{"click":function($event){return _vm.switchTab('right', 0)}}},[_vm._v("\n        "+_vm._s(_vm.$t('provider.tabLabel.upcoming'))+"\n      ")]),_vm._v(" "),_c('li',{class:{'active':_vm.activeTab.right === 1},on:{"click":function($event){return _vm.switchTab('right', 1)}}},[_vm._v("\n        "+_vm._s(_vm.$t('provider.tabLabel.completed'))+"\n      ")]),_vm._v(" "),(_vm.editEnabled)?_c('li',{class:{'active':_vm.activeTab.right === 2},on:{"click":function($event){return _vm.switchTab('right', 2)}}},[_vm._v("\n        "+_vm._s(_vm.$t('provider.tabLabel.payout'))+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.editEnabled)?_c('li',{class:{'active':_vm.activeTab.right === 3},on:{"click":function($event){return _vm.switchTab('right', 3)}}},[_vm._v("\n        Doc History\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-contents"},[_c('div',{class:{'tab-content':true, 'active':_vm.activeTab.right == 0}},[_c('reservations',{ref:"upcoming",attrs:{"type":"upcoming","active":_vm.activeTab.right == 0}})],1),_vm._v(" "),_c('div',{class:{'tab-content':true, 'active':_vm.activeTab.right == 1}},[_c('reservations',{ref:"history",attrs:{"type":"history","active":_vm.activeTab.right == 1}})],1),_vm._v(" "),(_vm.editEnabled)?_c('div',{class:{'tab-content':true, 'active':_vm.activeTab.right == 2}},[_c('payouts',{attrs:{"active":_vm.activeTab.right == 2}})],1):_vm._e(),_vm._v(" "),(_vm.editEnabled)?_c('div',{class:{'tab-content':true, 'active history-panel':_vm.activeTab.right == 3}},[_c('doc-history',{attrs:{"active":_vm.activeTab.right == 3}})],1):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:((_vm.activeTab.right == 0 && _vm.hasUpcoming) || (_vm.activeTab.right == 1 && _vm.hasHistory)),expression:"(activeTab.right == 0 && hasUpcoming) || (activeTab.right == 1 && hasHistory)"}],staticClass:"fixed-footer"},[_vm._v("\n          "+_vm._s(_vm.$t('provider.reservations.totalDriverPayment'))+":\n          "),((_vm.hasUpcoming && !_vm.totalDriverPayment.upcomingLoading) || (_vm.hasHistory && !_vm.totalDriverPayment.historyLoading))?_c('span',{on:{"click":_vm.showBreakdown}},[(_vm.activeTab.right == 0)?_c('b',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.totalDriverPayment.upcoming)))]):_c('b',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.totalDriverPayment.history)))]),_vm._v(" "),_c('i',{staticClass:"fas fa-receipt"})]):_c('span',[_c('i',{staticClass:"fas fa-sync-alt fa-spin"})])])])],1),_vm._v(" "),_c('div',{staticClass:"logs"},[_c('div',{staticClass:"trigger"},[_c('a',{class:{'logs-toggle':true, on:_vm.showLogs},on:{"click":_vm.toggleLogs}},[_c('i',{class:_vm.logsIcon})])]),_vm._v(" "),_c('div',{class:{'logs-panel':true, hide:!_vm.showLogs}},[_c('logs',{ref:"logs"})],1)])]),_vm._v(" "),_c('loading-modal',{attrs:{"showModal":_vm.loading,"modalMessage":"Loading"}}),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.showActiveModal}},[_c('div',{staticClass:"modal-content active-confirmation"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isActive),expression:"!isActive"}],domProps:{"innerHTML":_vm._s(_vm.$t('provider.modal.toActivate', {provider: _vm.providerName}))}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],domProps:{"innerHTML":_vm._s(_vm.$t('provider.modal.toDeactivate', {provider: _vm.providerName}))}}),_vm._v(" "),_c('div',{staticClass:"button cta warning",on:{"click":function($event){_vm.showActiveModal = false}}},[_vm._v(_vm._s(_vm.$t('provider.modal.no')))]),_vm._v(" "),_c('div',{staticClass:"button cta success",on:{"click":_vm.toggleProvActive}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.statusLoading),expression:"!statusLoading"}]},[_vm._v(_vm._s(_vm.$t('provider.modal.yes')))]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.statusLoading),expression:"statusLoading"}],staticClass:"fa fa-spinner fa-spin"})])])]),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.formResult.isDone}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeFormResult}}),_vm._v(" "),_c('div',{staticClass:"modal-content formResult"},[_c('p',[_vm._v(_vm._s(_vm.formResult.message))]),_vm._v(" "),_c('a',{staticClass:"button cta warning block small",on:{"click":_vm.closeFormResult}},[_vm._v("\n        "+_vm._s(_vm.$t('provider.close'))+"\n      ")])])]),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.showUpload, 'no-preview':!_vm.showUploadPreview}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeUploadForm}}),_vm._v(" "),_c('div',{staticClass:"modal-content upload"},[_c('input',{ref:"fileInput",staticClass:"input-file",attrs:{"type":"file","name":"image","accept":"image/*"},on:{"change":_vm.setImage}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showUploadPreview),expression:"showUploadPreview"}],staticClass:"cropper-wrap"},[_c('div',{staticClass:"upload-side"},[_c('span',{staticClass:"_label"},[_vm._v("Selected Image:")]),_vm._v(" "),_c('vue-cropper',{ref:"cropper",attrs:{"guides":false,"drag-mode":"crop","zoom":_vm.updateCropPreview,"cropmove":_vm.updateCropPreview,"view-mode":2,"min-container-width":420,"min-container-height":380,"background":true,"src":_vm.canvasUrl,"alt":" ","img-style":{ width: '420px', 'height': '380px' }}})],1),_vm._v(" "),_c('div',{staticClass:"preview-side"},[_c('span',{staticClass:"_label"},[_vm._v("Preview Image:")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.previewUrl}})])]),_vm._v(" "),_c('a',{class:{'button cta warning small':true, 'disabled':_vm.uploadLoading },on:{"click":_vm.closeUploadForm}},[_vm._v("\n        "+_vm._s(_vm.$t('provider.cancel'))+"\n      ")]),_vm._v(" "),_c('a',{class:{'button cta success small':true, 'disabled':_vm.uploadLoading },on:{"click":_vm.cropImage}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.uploadLoading),expression:"!uploadLoading"}]},[_vm._v(_vm._s(_vm.$t('provider.upload')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.uploadLoading),expression:"uploadLoading"}]},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v("\n          "+_vm._s(_vm.$t('provider.uploading'))+"\n        ")])])])]),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.showUploadError}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeUploadError}}),_vm._v(" "),_c('div',{staticClass:"modal-content uploadError"},[_c('p',[_c('i',{staticClass:"fa fa-frown fa-5x"}),_vm._v("\n        "+_vm._s(_vm.$t('provider.uploadError'))+"\n      ")]),_vm._v(" "),_c('a',{staticClass:"button cta warning block small",on:{"click":_vm.closeUploadError}},[_vm._v("\n        "+_vm._s(_vm.$t('provider.close'))+"\n      ")])])]),_vm._v(" "),_c('div',{class:{'modal breakdown':true, 'show':_vm.showBreakdownModal},on:{"click":function($event){_vm.showBreakdownModal = false}}},[_c('div',{staticClass:"modal-content",on:{"click":function($event){$event.stopPropagation();}}},[(!!_vm.breakdownError)?_c('div',{staticClass:"has-error"},[_c('i',{staticClass:"far fa-frown fa-4x"}),_vm._v(" "),_c('span',[_vm._v("Something went wrong!")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.breakdownError))])]):(_vm.showBreakdownModal)?_c('div',[_c('div',{staticClass:"label"},[_vm._v("Breakdown")]),_vm._v(" "),_c('table',{staticClass:"list",attrs:{"cellspacing":"0"}},[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._l((_vm.breakdownList[_vm.activeTable]),function(data,index){return _c('tr',[_c('td',[_c('a',{class:{'pkg':data.type !== 'RSVP'},attrs:{"href":'/#/' + (data.type === 'RSVP' ? 'reservation' : 'package') + '/' + data.id,"target":"_blank"}},[_vm._v(_vm._s(data.type + ' ' + data.id))])]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(data.amount)))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(data.gasFee)))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(data.pickupFee)))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(data.bonusAmount)))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(data.tip)))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(data.releaseBonus)))]),_vm._v(" "),_c('td',[_vm._v("($"+_vm._s(_vm.toFixed(data.deductions))+")")])])}),_vm._v(" "),_c('tr',{staticClass:"total"},[_c('td'),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.totalBreakdown('amount'))))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.totalBreakdown('gasFee'))))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.totalBreakdown('pickupFee'))))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.totalBreakdown('bonusAmount'))))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.totalBreakdown('tip'))))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.totalBreakdown('releaseBonus'))))]),_vm._v(" "),_c('td',[_vm._v("($"+_vm._s(_vm.toFixed(_vm.totalBreakdown('deductions')))+")")])])],2)]),_vm._v(" "),_c('table',{staticClass:"computations"},[_c('tr',[_c('td',[_vm._v("Amount")]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.totalBreakdown('amount'))))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Fuel Surcharge")]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.totalBreakdown('gasFee'))))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Pickup Fee")]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.totalBreakdown('pickupFee'))))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Payment Bonus")]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.totalBreakdown('bonusAmount'))))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Tip")]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.totalBreakdown('tip'))))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Release Bonus")]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.totalBreakdown('releaseBonus'))))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Deductions")]),_vm._v(" "),_c('td',[_vm._v("($"+_vm._s(_vm.toFixed(_vm.totalBreakdown('deductions')))+")")])]),_vm._v(" "),_c('tr',{staticClass:"total"},[_c('td',{attrs:{"colspan":"2"}},[_vm._v("$"+_vm._s(_vm.totalOverall()))])])]),_vm._v(" "),_c('div',{staticClass:"clear"})]):_vm._e()])]),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.serviceSave.modal}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeServiceModal}}),_vm._v(" "),_c('div',{staticClass:"modal-content service-save"},[(_vm.serviceSave.success)?_c('i',{staticClass:"fas fa-check-circle fa-5x"}):_c('i',{staticClass:"fas fa-times-circle fa-5x"}),_vm._v(" "),(_vm.serviceSave.success && _vm.serviceSave.message)?_c('span',[_vm._v("No changes to provider service types.")]):(_vm.serviceSave.success)?_c('span',[_vm._v("Succesfully saved provider service!")]):_c('span',[_vm._v("Oops! Something went wrong")]),_vm._v(" "),(_vm.serviceSave.message && !_vm.serviceSave.success)?_c('p',[_vm._v(_vm._s(_vm.serviceSave.message))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"button cta warning block small",on:{"click":_vm.closeServiceModal}},[_vm._v("\n        "+_vm._s(_vm.$t('provider.close'))+"\n      ")])])]),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.quickRes.modal}},[_c('div',{staticClass:"modal-content active-confirmation"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.quickRes.enable),expression:"!quickRes.enable"}]},[_vm._v("Confirm enable quick res?")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.quickRes.enable),expression:"quickRes.enable"}]},[_vm._v("Confirm disable quick res?")]),_vm._v(" "),_c('div',{staticClass:"button cta warning",on:{"click":_vm.closeQuickResModal}},[_vm._v("No")]),_vm._v(" "),_c('div',{staticClass:"button cta success",on:{"click":_vm.toggleQuickRes}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.quickRes.loading),expression:"!quickRes.loading"}]},[_vm._v("Yes")]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.quickRes.loading),expression:"quickRes.loading"}],staticClass:"fa fa-spinner fa-spin"})])])]),_vm._v(" "),_c('notification-modal',{ref:"notif",attrs:{"isList":false,"provId":_vm.$route.params.id,"broadcastOnly":true,"removeAllActiveUserOption":true,"hideTargetOption":true}}),_vm._v(" "),_c('sms-modal',{ref:"sms",attrs:{"isList":false,"provId":_vm.$route.params.id,"removeAllActiveUserOption":true,"hideTargetOption":true}}),_vm._v(" "),_c('shift-form'),_vm._v(" "),_c('payout-form',{attrs:{"provId":_vm.$route.params.id}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('td'),_vm._v(" "),_c('td',[_vm._v("Fare")]),_vm._v(" "),_c('td',[_vm._v("Fuel Surcharge")]),_vm._v(" "),_c('td',[_vm._v("Pickup Fee")]),_vm._v(" "),_c('td',[_vm._v("Payment Bonus")]),_vm._v(" "),_c('td',[_vm._v("Tip")]),_vm._v(" "),_c('td',[_vm._v("Release Bonus")]),_vm._v(" "),_c('td',[_vm._v("Deductions")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(588);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e7b1a08_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1738);
function injectStyle (ssrContext) {
  __webpack_require__(1724)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e7b1a08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e7b1a08_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1725);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("02102ebe", content, true, {});

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.fixed-header[data-v-5e7b1a08] {\n  width: 100%;\n}\n.heading[data-v-5e7b1a08] {\n  margin-left: 50px;\n  padding-left: 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.notif-btn[data-v-5e7b1a08], .sms-btn[data-v-5e7b1a08], .filter-btn[data-v-5e7b1a08] {\n  float: right;\n  margin: 7px 10px;\n}\n.sms-btn[data-v-5e7b1a08] {\n  background-color: #16b0de;\n}\n.filter-btn[data-v-5e7b1a08] {\n  background-color: gray;\n}\n.tables-box[data-v-5e7b1a08] {\n  padding: 20px 40px 30px;\n  overflow: auto;\n}\n.tables-box.no-shift[data-v-5e7b1a08] {\n    max-width: 1100px;\n}\n.tables-box .t-label[data-v-5e7b1a08] {\n    font-size: 21px;\n    letter-spacing: .4px;\n    font-weight: 600;\n    line-height: 1;\n    margin-bottom: 10px;\n    color: #56666a;\n}\n.tables-box .t-label span[data-v-5e7b1a08] {\n      color: #939a9c;\n      margin-left: 5px;\n      display: inline-block;\n}\n.export-box[data-v-5e7b1a08] {\n  text-align: right;\n  padding-bottom: 10px;\n}\n.action .columns[data-v-5e7b1a08] {\n  padding: 0 10px;\n}\n.modal[data-v-5e7b1a08] {\n  position: fixed;\n  z-index: 12;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: none;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  resize: vertical;\n}\n.modal .bg-overlay[data-v-5e7b1a08] {\n    position: absolute;\n    z-index: 1;\n    background: rgba(0, 0, 0, 0.5);\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n}\n.modal .modal-content[data-v-5e7b1a08] {\n    position: relative;\n    z-index: 2;\n    background: #fff;\n    width: 400px;\n    min-height: 150px;\n    border-radius: 6px;\n    padding: 20px;\n    margin: auto;\n    -webkit-box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n    display: none;\n    text-align: center;\n}\n.modal .loading-box[data-v-5e7b1a08] {\n    padding: 50px 0;\n    font-size: 18px;\n}\n.modal .loading-box i[data-v-5e7b1a08] {\n      color: #999;\n      margin-right: 3px;\n}\n.modal .error-box[data-v-5e7b1a08] {\n    margin: 0 10px 10px;\n    border: 2px solid #e00;\n    background: rgba(255, 0, 0, 0.1);\n    padding: 3px;\n    color: #e00;\n    font-size: 14px;\n}\n.modal .success i[data-v-5e7b1a08] {\n    color: #26D97A;\n    font-size: 70px;\n}\n.modal .success span[data-v-5e7b1a08] {\n    display: block;\n    margin: 20px 0 30px;\n    font-weight: 600;\n}\n.modal.show[data-v-5e7b1a08] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.modal.show .modal-content[data-v-5e7b1a08] {\n      display: block;\n      -webkit-animation: slide-down .15s ease-out;\n      -moz-animation: slide-down .15s ease-out;\n}\n.modal .title[data-v-5e7b1a08] {\n    color: #555;\n}\n.modal .file-type[data-v-5e7b1a08] {\n    display: inline-block;\n    margin: 20px 0 40px;\n    width: 48%;\n}\n.modal .file-type input[data-v-5e7b1a08] {\n      display: inline-block;\n      width: 20px;\n      margin: 0 0 5px 0;\n      cursor: pointer;\n}\n.modal .file-type label[data-v-5e7b1a08] {\n      cursor: pointer;\n      font-weight: 600;\n      font-size: 14px;\n      vertical-align: 1px;\n}\n#pdf-view[data-v-5e7b1a08] {\n  position: fixed;\n  top: 100%;\n  right: 0;\n  width: 1122px;\n  height: 793px;\n  background: #EFE;\n  z-index: -2;\n}\n#pdf-view .page[data-v-5e7b1a08] {\n    padding: 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-5e7b1a08] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-5e7b1a08] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n    margin-bottom: 20px;\n}\n#pdf-view .filters-box[data-v-5e7b1a08] {\n    margin-bottom: 40px;\n}\n#pdf-view .filters-box .columns label[data-v-5e7b1a08] {\n      width: 100px;\n      font-weight: 600;\n      font-size: 14px;\n      display: inline-block;\n      text-align: right;\n}\n#pdf-view .filters-box .columns div[data-v-5e7b1a08] {\n      font-size: 14px;\n      display: inline-block;\n      width: calc(100% - 120px);\n      border-bottom: 1px solid #999;\n      padding-left: 5px;\n}\n#pdf-view table[data-v-5e7b1a08] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-5e7b1a08] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-5e7b1a08] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-5e7b1a08], #pdf-view table tbody tr.total[data-v-5e7b1a08] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-5e7b1a08] {\n      color: #000;\n      font-size: 15px;\n}\n#pdf-view table tbody td[data-v-5e7b1a08] {\n      padding: 2px 3px;\n      text-align: center;\n}\n@media only screen and (max-width: 430px) {\n.modal .modal-content[data-v-5e7b1a08] {\n    width: auto;\n}\n.heading[data-v-5e7b1a08] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.heading .send-buttons[data-v-5e7b1a08] {\n      margin-left: -60px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.small-3[data-v-5e7b1a08] {\n    width: 100%;\n}\n.export-box[data-v-5e7b1a08] {\n    width: 100%;\n    margin: 50px 0 10px;\n}\n.export-box button[data-v-5e7b1a08] {\n      width: 100%;\n}\n.tables-box[data-v-5e7b1a08] {\n    z-index: 1;\n    padding: 10px;\n}\n.tables-box .tables[data-v-5e7b1a08] {\n      margin-bottom: 30px;\n}\n.tables-box .table-header .export-box .success[data-v-5e7b1a08] {\n      margin-right: 0;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/ProviderAvailability/index.vue"],"names":[],"mappings":";AACA;EACE,YAAY;CACb;AACD;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;CAC3B;AACD;EACE,aAAa;EACb,iBAAiB;CAClB;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,uBAAuB;CACxB;AACD;EACE,wBAAwB;EACxB,eAAe;CAChB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,eAAe;CAClB;AACD;MACM,eAAe;MACf,iBAAiB;MACjB,sBAAsB;CAC3B;AACD;EACE,kBAAkB;EAClB,qBAAqB;CACtB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,iBAAiB;CAClB;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,OAAO;IACP,QAAQ;CACX;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,uDAAuD;YAC/C,+CAA+C;IACvD,cAAc;IACd,mBAAmB;CACtB;AACD;IACI,gBAAgB;IAChB,gBAAgB;CACnB;AACD;MACM,YAAY;MACZ,kBAAkB;CACvB;AACD;IACI,oBAAoB;IACpB,uBAAuB;IACvB,iCAAiC;IACjC,aAAa;IACb,YAAY;IACZ,gBAAgB;CACnB;AACD;IACI,eAAe;IACf,gBAAgB;CACnB;AACD;IACI,eAAe;IACf,oBAAoB;IACpB,iBAAiB;CACpB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;MACM,eAAe;MACf,4CAA4C;MAC5C,yCAAyC;CAC9C;AACD;IACI,YAAY;CACf;AACD;IACI,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;CACd;AACD;MACM,sBAAsB;MACtB,YAAY;MACZ,kBAAkB;MAClB,gBAAgB;CACrB;AACD;MACM,gBAAgB;MAChB,iBAAiB;MACjB,gBAAgB;MAChB,oBAAoB;CACzB;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,YAAY;CACb;AACD;IACI,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,aAAa;CAChB;AACD;MACM,mBAAmB;MACnB,aAAa;MACb,YAAY;MACZ,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;CACxB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,aAAa;MACb,iBAAiB;MACjB,gBAAgB;MAChB,sBAAsB;MACtB,kBAAkB;CACvB;AACD;MACM,gBAAgB;MAChB,sBAAsB;MACtB,0BAA0B;MAC1B,8BAA8B;MAC9B,kBAAkB;CACvB;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,iBAAiB;CACtB;AACD;QACQ,8BAA8B;CACrC;AACD;MACM,iBAAiB;CACtB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;MACM,iBAAiB;MACjB,mBAAmB;CACxB;AACD;AACA;IACI,YAAY;CACf;AACD;IACI,6BAA6B;IAC7B,8BAA8B;QAC1B,2BAA2B;YACvB,uBAAuB;CAClC;AACD;MACM,mBAAmB;MACnB,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,yBAAyB;UACrB,sBAAsB;cAClB,wBAAwB;CACrC;AACD;IACI,YAAY;CACf;AACD;IACI,YAAY;IACZ,oBAAoB;CACvB;AACD;MACM,YAAY;CACjB;AACD;IACI,WAAW;IACX,cAAc;CACjB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,gBAAgB;CACrB;CACA","file":"index.vue","sourcesContent":["\n.fixed-header[data-v-5e7b1a08] {\n  width: 100%;\n}\n.heading[data-v-5e7b1a08] {\n  margin-left: 50px;\n  padding-left: 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.notif-btn[data-v-5e7b1a08], .sms-btn[data-v-5e7b1a08], .filter-btn[data-v-5e7b1a08] {\n  float: right;\n  margin: 7px 10px;\n}\n.sms-btn[data-v-5e7b1a08] {\n  background-color: #16b0de;\n}\n.filter-btn[data-v-5e7b1a08] {\n  background-color: gray;\n}\n.tables-box[data-v-5e7b1a08] {\n  padding: 20px 40px 30px;\n  overflow: auto;\n}\n.tables-box.no-shift[data-v-5e7b1a08] {\n    max-width: 1100px;\n}\n.tables-box .t-label[data-v-5e7b1a08] {\n    font-size: 21px;\n    letter-spacing: .4px;\n    font-weight: 600;\n    line-height: 1;\n    margin-bottom: 10px;\n    color: #56666a;\n}\n.tables-box .t-label span[data-v-5e7b1a08] {\n      color: #939a9c;\n      margin-left: 5px;\n      display: inline-block;\n}\n.export-box[data-v-5e7b1a08] {\n  text-align: right;\n  padding-bottom: 10px;\n}\n.action .columns[data-v-5e7b1a08] {\n  padding: 0 10px;\n}\n.modal[data-v-5e7b1a08] {\n  position: fixed;\n  z-index: 12;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: none;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  resize: vertical;\n}\n.modal .bg-overlay[data-v-5e7b1a08] {\n    position: absolute;\n    z-index: 1;\n    background: rgba(0, 0, 0, 0.5);\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n}\n.modal .modal-content[data-v-5e7b1a08] {\n    position: relative;\n    z-index: 2;\n    background: #fff;\n    width: 400px;\n    min-height: 150px;\n    border-radius: 6px;\n    padding: 20px;\n    margin: auto;\n    -webkit-box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n    display: none;\n    text-align: center;\n}\n.modal .loading-box[data-v-5e7b1a08] {\n    padding: 50px 0;\n    font-size: 18px;\n}\n.modal .loading-box i[data-v-5e7b1a08] {\n      color: #999;\n      margin-right: 3px;\n}\n.modal .error-box[data-v-5e7b1a08] {\n    margin: 0 10px 10px;\n    border: 2px solid #e00;\n    background: rgba(255, 0, 0, 0.1);\n    padding: 3px;\n    color: #e00;\n    font-size: 14px;\n}\n.modal .success i[data-v-5e7b1a08] {\n    color: #26D97A;\n    font-size: 70px;\n}\n.modal .success span[data-v-5e7b1a08] {\n    display: block;\n    margin: 20px 0 30px;\n    font-weight: 600;\n}\n.modal.show[data-v-5e7b1a08] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.modal.show .modal-content[data-v-5e7b1a08] {\n      display: block;\n      -webkit-animation: slide-down .15s ease-out;\n      -moz-animation: slide-down .15s ease-out;\n}\n.modal .title[data-v-5e7b1a08] {\n    color: #555;\n}\n.modal .file-type[data-v-5e7b1a08] {\n    display: inline-block;\n    margin: 20px 0 40px;\n    width: 48%;\n}\n.modal .file-type input[data-v-5e7b1a08] {\n      display: inline-block;\n      width: 20px;\n      margin: 0 0 5px 0;\n      cursor: pointer;\n}\n.modal .file-type label[data-v-5e7b1a08] {\n      cursor: pointer;\n      font-weight: 600;\n      font-size: 14px;\n      vertical-align: 1px;\n}\n#pdf-view[data-v-5e7b1a08] {\n  position: fixed;\n  top: 100%;\n  right: 0;\n  width: 1122px;\n  height: 793px;\n  background: #EFE;\n  z-index: -2;\n}\n#pdf-view .page[data-v-5e7b1a08] {\n    padding: 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n#pdf-view .page .page-count[data-v-5e7b1a08] {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#pdf-view .title[data-v-5e7b1a08] {\n    text-align: center;\n    font-weight: 600;\n    font-size: 21px;\n    margin-bottom: 20px;\n}\n#pdf-view .filters-box[data-v-5e7b1a08] {\n    margin-bottom: 40px;\n}\n#pdf-view .filters-box .columns label[data-v-5e7b1a08] {\n      width: 100px;\n      font-weight: 600;\n      font-size: 14px;\n      display: inline-block;\n      text-align: right;\n}\n#pdf-view .filters-box .columns div[data-v-5e7b1a08] {\n      font-size: 14px;\n      display: inline-block;\n      width: calc(100% - 120px);\n      border-bottom: 1px solid #999;\n      padding-left: 5px;\n}\n#pdf-view table[data-v-5e7b1a08] {\n    width: 100%;\n    font-size: 12px;\n    border-collapse: collapse;\n}\n#pdf-view table thead[data-v-5e7b1a08] {\n      font-weight: 600;\n}\n#pdf-view table thead tr:last-child th[data-v-5e7b1a08] {\n        border-bottom: 1px solid #333;\n}\n#pdf-view table tbody tr.subtotal[data-v-5e7b1a08], #pdf-view table tbody tr.total[data-v-5e7b1a08] {\n      font-weight: 700;\n}\n#pdf-view table tbody tr.total[data-v-5e7b1a08] {\n      color: #000;\n      font-size: 15px;\n}\n#pdf-view table tbody td[data-v-5e7b1a08] {\n      padding: 2px 3px;\n      text-align: center;\n}\n@media only screen and (max-width: 430px) {\n.modal .modal-content[data-v-5e7b1a08] {\n    width: auto;\n}\n.heading[data-v-5e7b1a08] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.heading .send-buttons[data-v-5e7b1a08] {\n      margin-left: -60px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.small-3[data-v-5e7b1a08] {\n    width: 100%;\n}\n.export-box[data-v-5e7b1a08] {\n    width: 100%;\n    margin: 50px 0 10px;\n}\n.export-box button[data-v-5e7b1a08] {\n      width: 100%;\n}\n.tables-box[data-v-5e7b1a08] {\n    z-index: 1;\n    padding: 10px;\n}\n.tables-box .tables[data-v-5e7b1a08] {\n      margin-bottom: 30px;\n}\n.tables-box .table-header .export-box .success[data-v-5e7b1a08] {\n      margin-right: 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableFilter_vue__ = __webpack_require__(589);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aae4ad5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableFilter_vue__ = __webpack_require__(1729);
function injectStyle (ssrContext) {
  __webpack_require__(1727)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6aae4ad5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aae4ad5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1728);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("19f913e8", content, true, {});

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.filter[data-v-6aae4ad5] {\n  border-bottom: 1px solid #bbb;\n  background: #fcfcfc;\n  margin-bottom: 10px;\n  border-radius: 2px;\n}\n.filter .row[data-v-6aae4ad5] {\n    max-width: 100%;\n}\n.field-label[data-v-6aae4ad5] {\n  font-size: 12.5px;\n  color: #777;\n  line-height: 1;\n  display: block;\n  margin-bottom: 2px;\n  letter-spacing: .4px;\n}\nselect[data-v-6aae4ad5] {\n  padding: 5px 10px;\n  height: 36px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-6aae4ad5] {\n    background-color: #ebebe4;\n}\n.time select[data-v-6aae4ad5] {\n  display: inline-block;\n  width: 32%;\n  margin-top: 5px;\n}\n.date-box[data-v-6aae4ad5] {\n  position: relative;\n}\n.error-box[data-v-6aae4ad5] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  font-style: italic;\n  font-size: 13px;\n  background: #ff6115;\n  color: #fff;\n  padding: 0 15px;\n  text-align: center;\n  -webkit-transform-origin: bottom center;\n          transform-origin: bottom center;\n}\n.has-error[data-v-6aae4ad5] {\n  border: 1px solid #f33a27;\n}\n.status[data-v-6aae4ad5] {\n  display: inline-block;\n  padding: 15px 0 15px 15px;\n  width: 100%;\n}\n.status.last[data-v-6aae4ad5] {\n    padding-right: 3px;\n    padding-left: 3px;\n}\n.status.last button[data-v-6aae4ad5] {\n      height: 46px;\n}\n.status.search[data-v-6aae4ad5] {\n    padding-top: 30px;\n}\n.shift-slash[data-v-6aae4ad5] {\n  margin: 0 5px;\n}\n.shift-btn[data-v-6aae4ad5] {\n  border-radius: 5px;\n  display: inline-block;\n  padding: 5px 10px;\n  background: #d7edff;\n  border: 1px solid #2181d6;\n  font-size: 14px;\n  color: #2181d6;\n  font-weight: 600;\n  cursor: pointer;\n  -webkit-box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  text-align: center;\n}\n.shift-btn.active[data-v-6aae4ad5] {\n    background: #2181d6;\n    color: #fff;\n}\n.shift-btn.disabled[data-v-6aae4ad5] {\n    background: #eee;\n    border-color: #ccc;\n    color: #bbb;\n    cursor: default;\n}\n.slide-up-enter-active[data-v-6aae4ad5], .slide-up-leave-active[data-v-6aae4ad5] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-6aae4ad5], .slide-up-leave-to[data-v-6aae4ad5] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.filter .row[data-v-6aae4ad5] {\n    padding-top: 25px;\n}\n.filter .row .small-5 .row[data-v-6aae4ad5] {\n      padding: 0;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.filter .row .small-5 .row .small-4[data-v-6aae4ad5] {\n        width: 100%;\n}\n.filter .row .small-5 .row .small-4 .status[data-v-6aae4ad5] {\n          padding: 10px;\n}\n.filter .row .status[data-v-6aae4ad5] {\n      padding: 10px;\n      padding-top: 25px;\n      padding-bottom: 0;\n}\n.filter .row .date-box[data-v-6aae4ad5] {\n      padding: 0;\n}\n.filter .row .date-box .status[data-v-6aae4ad5] {\n        padding: 10px;\n}\n.filter .row .date-box .status .time[data-v-6aae4ad5] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          gap: 3px;\n}\n.filter .row .date-box .status .time select[data-v-6aae4ad5] {\n            width: 100%;\n            height: auto;\n}\n.small-1[data-v-6aae4ad5], .small-2[data-v-6aae4ad5], .small-4[data-v-6aae4ad5], .small-5[data-v-6aae4ad5] {\n    width: 100%;\n}\n.small-1 .small-4[data-v-6aae4ad5], .small-2 .small-4[data-v-6aae4ad5], .small-4 .small-4[data-v-6aae4ad5], .small-5 .small-4[data-v-6aae4ad5] {\n      width: 25%;\n}\n.small-1 .status.search[data-v-6aae4ad5], .small-2 .status.search[data-v-6aae4ad5], .small-4 .status.search[data-v-6aae4ad5], .small-5 .status.search[data-v-6aae4ad5] {\n      padding: 10px;\n}\n.small-1 .status.search .button[data-v-6aae4ad5], .small-2 .status.search .button[data-v-6aae4ad5], .small-4 .status.search .button[data-v-6aae4ad5], .small-5 .status.search .button[data-v-6aae4ad5] {\n        width: 100%;\n}\n.end-date[data-v-6aae4ad5] .vdp-datepicker__calendar {\n    right: 1px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/ProviderAvailability/TableFilter.vue"],"names":[],"mappings":";AACA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;CACpB;AACD;IACI,gBAAgB;CACnB;AACD;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,qBAAqB;CACtB;AACD;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,+BAA+B;CAChC;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;CACjB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;UAChC,gCAAgC;CACzC;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;CACb;AACD;IACI,mBAAmB;IACnB,kBAAkB;CACrB;AACD;MACM,aAAa;CAClB;AACD;IACI,kBAAkB;CACrB;AACD;EACE,cAAc;CACf;AACD;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mDAAmD;UAC3C,2CAA2C;EACnD,oBAAoB;MAChB,qBAAqB;UACjB,aAAa;EACrB,mBAAmB;CACpB;AACD;IACI,oBAAoB;IACpB,YAAY;CACf;AACD;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;CACnB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;AACA;IACI,kBAAkB;CACrB;AACD;MACM,WAAW;MACX,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;CACnB;AACD;QACQ,YAAY;CACnB;AACD;UACU,cAAc;CACvB;AACD;MACM,cAAc;MACd,kBAAkB;MAClB,kBAAkB;CACvB;AACD;MACM,WAAW;CAChB;AACD;QACQ,cAAc;CACrB;AACD;UACU,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;UACd,SAAS;CAClB;AACD;YACY,YAAY;YACZ,aAAa;CACxB;AACD;IACI,YAAY;CACf;AACD;MACM,WAAW;CAChB;AACD;MACM,cAAc;CACnB;AACD;QACQ,YAAY;CACnB;AACD;IACI,WAAW;CACd;CACA","file":"TableFilter.vue","sourcesContent":["\n.filter[data-v-6aae4ad5] {\n  border-bottom: 1px solid #bbb;\n  background: #fcfcfc;\n  margin-bottom: 10px;\n  border-radius: 2px;\n}\n.filter .row[data-v-6aae4ad5] {\n    max-width: 100%;\n}\n.field-label[data-v-6aae4ad5] {\n  font-size: 12.5px;\n  color: #777;\n  line-height: 1;\n  display: block;\n  margin-bottom: 2px;\n  letter-spacing: .4px;\n}\nselect[data-v-6aae4ad5] {\n  padding: 5px 10px;\n  height: 36px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-6aae4ad5] {\n    background-color: #ebebe4;\n}\n.time select[data-v-6aae4ad5] {\n  display: inline-block;\n  width: 32%;\n  margin-top: 5px;\n}\n.date-box[data-v-6aae4ad5] {\n  position: relative;\n}\n.error-box[data-v-6aae4ad5] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  font-style: italic;\n  font-size: 13px;\n  background: #ff6115;\n  color: #fff;\n  padding: 0 15px;\n  text-align: center;\n  -webkit-transform-origin: bottom center;\n          transform-origin: bottom center;\n}\n.has-error[data-v-6aae4ad5] {\n  border: 1px solid #f33a27;\n}\n.status[data-v-6aae4ad5] {\n  display: inline-block;\n  padding: 15px 0 15px 15px;\n  width: 100%;\n}\n.status.last[data-v-6aae4ad5] {\n    padding-right: 3px;\n    padding-left: 3px;\n}\n.status.last button[data-v-6aae4ad5] {\n      height: 46px;\n}\n.status.search[data-v-6aae4ad5] {\n    padding-top: 30px;\n}\n.shift-slash[data-v-6aae4ad5] {\n  margin: 0 5px;\n}\n.shift-btn[data-v-6aae4ad5] {\n  border-radius: 5px;\n  display: inline-block;\n  padding: 5px 10px;\n  background: #d7edff;\n  border: 1px solid #2181d6;\n  font-size: 14px;\n  color: #2181d6;\n  font-weight: 600;\n  cursor: pointer;\n  -webkit-box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  text-align: center;\n}\n.shift-btn.active[data-v-6aae4ad5] {\n    background: #2181d6;\n    color: #fff;\n}\n.shift-btn.disabled[data-v-6aae4ad5] {\n    background: #eee;\n    border-color: #ccc;\n    color: #bbb;\n    cursor: default;\n}\n.slide-up-enter-active[data-v-6aae4ad5], .slide-up-leave-active[data-v-6aae4ad5] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-6aae4ad5], .slide-up-leave-to[data-v-6aae4ad5] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.filter .row[data-v-6aae4ad5] {\n    padding-top: 25px;\n}\n.filter .row .small-5 .row[data-v-6aae4ad5] {\n      padding: 0;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.filter .row .small-5 .row .small-4[data-v-6aae4ad5] {\n        width: 100%;\n}\n.filter .row .small-5 .row .small-4 .status[data-v-6aae4ad5] {\n          padding: 10px;\n}\n.filter .row .status[data-v-6aae4ad5] {\n      padding: 10px;\n      padding-top: 25px;\n      padding-bottom: 0;\n}\n.filter .row .date-box[data-v-6aae4ad5] {\n      padding: 0;\n}\n.filter .row .date-box .status[data-v-6aae4ad5] {\n        padding: 10px;\n}\n.filter .row .date-box .status .time[data-v-6aae4ad5] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          gap: 3px;\n}\n.filter .row .date-box .status .time select[data-v-6aae4ad5] {\n            width: 100%;\n            height: auto;\n}\n.small-1[data-v-6aae4ad5], .small-2[data-v-6aae4ad5], .small-4[data-v-6aae4ad5], .small-5[data-v-6aae4ad5] {\n    width: 100%;\n}\n.small-1 .small-4[data-v-6aae4ad5], .small-2 .small-4[data-v-6aae4ad5], .small-4 .small-4[data-v-6aae4ad5], .small-5 .small-4[data-v-6aae4ad5] {\n      width: 25%;\n}\n.small-1 .status.search[data-v-6aae4ad5], .small-2 .status.search[data-v-6aae4ad5], .small-4 .status.search[data-v-6aae4ad5], .small-5 .status.search[data-v-6aae4ad5] {\n      padding: 10px;\n}\n.small-1 .status.search .button[data-v-6aae4ad5], .small-2 .status.search .button[data-v-6aae4ad5], .small-4 .status.search .button[data-v-6aae4ad5], .small-5 .status.search .button[data-v-6aae4ad5] {\n        width: 100%;\n}\n.end-date[data-v-6aae4ad5] .vdp-datepicker__calendar {\n    right: 1px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-1 columns end"},[_c('div',{staticClass:"status"},[_c('label',{staticClass:"field-label"},[_vm._v("Work Sector:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedSector),expression:"selectedSector"}],attrs:{"disabled":_vm.sectorLoading || _vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedSector=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("ALL")]),_vm._v(" "),_vm._l((_vm.sectors),function(sector){return _c('option',{key:sector.id,domProps:{"value":sector.id}},[_vm._v(_vm._s(sector.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns end"},[_c('div',{staticClass:"date-box row"},[_c('div',{staticClass:"small-6 columns end"},[_c('div',{staticClass:"status"},[_c('label',{staticClass:"field-label"},[_vm._v("Start Date/Time:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker inline custom-pa-availability",attrs:{"format":_vm.calendarFormat,"input-class":{'datepicker-empty': _vm.dateError.target === 'date'},"placeholder":"MM/DD/YYYY","disabled-picker":_vm.loading},on:{"input":function($event){return _vm.changeDate('start')}},model:{value:(_vm.startDate.date),callback:function ($$v) {_vm.$set(_vm.startDate, "date", $$v)},expression:"startDate.date"}}),_vm._v(" "),_c('div',{staticClass:"time"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate.hour),expression:"startDate.hour"}],class:{'has-error':_vm.dateError.target === 'time'},attrs:{"disabled":_vm.loading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.startDate, "hour", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateDate('start')}]}},_vm._l((_vm.maxHour),function(n){return _c('option',{domProps:{"value":_vm.leadingZero(n)}},[_vm._v(_vm._s(_vm.leadingZero(n)))])}),0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate.minute),expression:"startDate.minute"}],class:{'has-error':_vm.dateError.target === 'time'},attrs:{"disabled":_vm.loading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.startDate, "minute", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateDate('start')}]}},[_c('option',{attrs:{"value":"00"}},[_vm._v("00")]),_vm._v(" "),_vm._l((11),function(n){return _c('option',{domProps:{"value":_vm.leadingZero(n * 5)}},[_vm._v(_vm._s(_vm.leadingZero(n * 5)))])})],2),_vm._v(" "),(!_vm.isMilitaryTime)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate.amPm),expression:"startDate.amPm"}],class:{'has-error':_vm.dateError.target === 'time'},attrs:{"disabled":_vm.loading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.startDate, "amPm", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateDate('start')}]}},[_c('option',{attrs:{"value":"AM"}},[_vm._v("AM")]),_vm._v(" "),_c('option',{attrs:{"value":"PM"}},[_vm._v("PM")])]):_vm._e()])],1)]),_vm._v(" "),_c('div',{staticClass:"small-6 columns end"},[_c('div',{staticClass:"status end-date"},[_c('label',{staticClass:"field-label"},[_vm._v("End Date/Time:")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker inline custom-pa-availability",attrs:{"format":_vm.calendarFormat,"input-class":{'datepicker-empty': _vm.dateError.target === 'date'},"placeholder":"MM/DD/YYYY","disabled-picker":_vm.loading},on:{"input":function($event){return _vm.changeDate('end')}},model:{value:(_vm.endDate.date),callback:function ($$v) {_vm.$set(_vm.endDate, "date", $$v)},expression:"endDate.date"}}),_vm._v(" "),_c('div',{staticClass:"time"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate.hour),expression:"endDate.hour"}],class:{'has-error':_vm.dateError.target === 'time'},attrs:{"disabled":_vm.loading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.endDate, "hour", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateDate('end')}]}},_vm._l((_vm.maxHour),function(n){return _c('option',{domProps:{"value":_vm.leadingZero(n)}},[_vm._v(_vm._s(_vm.leadingZero(n)))])}),0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate.minute),expression:"endDate.minute"}],class:{'has-error':_vm.dateError.target === 'time'},attrs:{"disabled":_vm.loading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.endDate, "minute", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateDate('end')}]}},[_c('option',{attrs:{"value":"00"}},[_vm._v("00")]),_vm._v(" "),_vm._l((11),function(n){return _c('option',{domProps:{"value":_vm.leadingZero(n * 5)}},[_vm._v(_vm._s(_vm.leadingZero(n * 5)))])})],2),_vm._v(" "),(!_vm.isMilitaryTime)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate.amPm),expression:"endDate.amPm"}],class:{'has-error':_vm.dateError.target === 'time'},attrs:{"disabled":_vm.loading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.endDate, "amPm", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateDate('end')}]}},[_c('option',{attrs:{"value":"AM"}},[_vm._v("AM")]),_vm._v(" "),_c('option',{attrs:{"value":"PM"}},[_vm._v("PM")])]):_vm._e()])],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[(_vm.dateError.showMsg)?_c('div',{staticClass:"error-box"},[_vm._v("Invalid Date Range.")]):_vm._e()])],1)]),_vm._v(" "),_c('div',{staticClass:"small-6 columns end"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 medium-3 columns end"},[_c('div',{staticClass:"status"},[_c('label',{staticClass:"field-label"},[_vm._v("Shift Preset:")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-center"},[_c('div',{class:['shift-btn', {active:_vm.shiftActive==='AM', disabled:_vm.sectorLoading || _vm.loading}],on:{"click":function($event){return _vm.toggleShift('AM')}}},[_vm._v("AM")]),_vm._v(" "),_c('div',{staticClass:"shift-slash"},[_vm._v("/")]),_vm._v(" "),_c('div',{class:['shift-btn', {active:_vm.shiftActive==='PM', disabled:_vm.sectorLoading || _vm.loading}],on:{"click":function($event){return _vm.toggleShift('PM')}}},[_vm._v("PM")])])])]),_vm._v(" "),_c('div',{staticClass:"small-6 medium-2 columns end"},[_c('div',{staticClass:"status"},[_c('label',{staticClass:"field-label"},[_vm._v("Type:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedType),expression:"selectedType"}],attrs:{"disabled":_vm.sectorLoading || _vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("ALL")]),_vm._v(" "),_c('option',{attrs:{"value":"tnc"}},[_vm._v("TNC")]),_vm._v(" "),_c('option',{attrs:{"value":"tcp"}},[_vm._v("TCP")]),_vm._v(" "),_c('option',{attrs:{"value":"psc"}},[_vm._v("PSC")])])])]),_vm._v(" "),_c('div',{staticClass:"small-6 medium-2 columns end"},[_c('div',{staticClass:"status"},[_c('label',{staticClass:"field-label"},[_vm._v("Vehicle Type:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.vehicleType),expression:"vehicleType"}],attrs:{"disabled":_vm.sectorLoading || _vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.vehicleType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("ALL")]),_vm._v(" "),_c('option',{attrs:{"value":"Sedan"}},[_vm._v("Sedan")]),_vm._v(" "),_c('option',{attrs:{"value":"Mini SUV"}},[_vm._v("Mini SUV")]),_vm._v(" "),_c('option',{attrs:{"value":"Minivan"}},[_vm._v("Minivan")]),_vm._v(" "),_c('option',{attrs:{"value":"Black Car"}},[_vm._v("Black Car")]),_vm._v(" "),_c('option',{attrs:{"value":"Black SUV"}},[_vm._v("Black SUV")]),_vm._v(" "),_c('option',{attrs:{"value":"Limousine"}},[_vm._v("Limousine")]),_vm._v(" "),_c('option',{attrs:{"value":"Tesla"}},[_vm._v("Tesla")]),_vm._v(" "),_c('option',{attrs:{"value":"Private Van"}},[_vm._v("Private Van")]),_vm._v(" "),_c('option',{attrs:{"value":"Mini Bus"}},[_vm._v("Mini Bus")]),_vm._v(" "),_c('option',{attrs:{"value":"34 Pax Bus"}},[_vm._v("34 Pax Bus")]),_vm._v(" "),_c('option',{attrs:{"value":"56 Pax Bus"}},[_vm._v("56 Pax Bus")])])])]),_vm._v(" "),_c('div',{staticClass:"small-6 medium-2 columns end"},[_c('div',{staticClass:"status"},[_c('label',{staticClass:"field-label"},[_vm._v("Service:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedService),expression:"selectedService"}],attrs:{"disabled":_vm.sectorLoading || _vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedService=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("ALL")]),_vm._v(" "),_c('option',{attrs:{"value":"PAX"}},[_vm._v("PAX")]),_vm._v(" "),_c('option',{attrs:{"value":"DTD"}},[_vm._v("DTD")]),_vm._v(" "),_c('option',{attrs:{"value":"PAX/DTD"}},[_vm._v("PAX/DTD")])])])]),_vm._v(" "),_c('div',{staticClass:"small-6 medium-3 columns end"},[_c('div',{staticClass:"status"},[_c('label',{staticClass:"field-label"},[_vm._v("Assignment:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAssigned),expression:"selectedAssigned"}],attrs:{"disabled":_vm.sectorLoading || _vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedAssigned=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("ALL")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Assigned")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("No assignments")])])])])])]),_vm._v(" "),_c('div',{staticClass:"small-1 columns end"},[_c('div',{staticClass:"status search"},[_c('a',{class:{'button cta success':true, 'disabled':_vm.sectorLoading || _vm.loading},on:{"click":_vm.updateTable}},[_c('i',{staticClass:"fas fa-search"}),_vm._v("\n          Search\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverTable_vue__ = __webpack_require__(591);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72079060_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverTable_vue__ = __webpack_require__(1733);
function injectStyle (ssrContext) {
  __webpack_require__(1731)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72079060"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72079060_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1732);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("68c7f6e6", content, true, {});

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.status[data-v-72079060] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-72079060], .status.completed[data-v-72079060] {\n    background: #26D97A;\n}\n.status.canceled[data-v-72079060], .status.cancelled[data-v-72079060], .status.failed[data-v-72079060] {\n    background: #bbb;\n}\n.status.upcoming[data-v-72079060] {\n    background: #f38d56;\n}\n.status.onboard[data-v-72079060] {\n    background: #dc3168;\n}\n.status.ready[data-v-72079060] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-72079060], .status.requires_dispatch[data-v-72079060] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-72079060] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-72079060] {\n    background: #5662f3;\n}\n.flight-status[data-v-72079060] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-72079060] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-72079060] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-72079060] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-72079060] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-72079060] {\n    background-color: #f35656;\n}\n.status.ready[data-v-72079060] {\n  background: #6dabc3;\n}\n.status.accepted[data-v-72079060] {\n  background: #777;\n}\n.status.on-time[data-v-72079060] {\n  background: #26d97a;\n}\n.status.late[data-v-72079060] {\n  background: #dc9831;\n}\n.status.ontheway[data-v-72079060] {\n  background: #f38d56;\n}\n.status.very-late[data-v-72079060] {\n  background: #e62e2e;\n}\n.status.open-credit[data-v-72079060] {\n  background: #29c3c3;\n}\n.list-table.outside[data-v-72079060] {\n  border: 1px solid #aaa;\n  background: #fff;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);\n  position: relative;\n  overflow: hidden;\n}\n.sticky[data-v-72079060] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  height: 44px;\n  z-index: 3;\n}\n.sticky tbody[data-v-72079060] {\n    visibility: hidden;\n}\ntable[data-v-72079060] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-72079060] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-72079060] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-72079060] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-72079060] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-72079060] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-72079060] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-72079060] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-72079060] {\n          color: #ccc;\n}\ntable input[data-v-72079060] {\n    display: inline-block;\n    width: auto;\n}\ntable .type[data-v-72079060] {\n    display: inline-block;\n    padding: 3px 6px;\n    text-transform: uppercase;\n    border-radius: 4px;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 600;\n}\ntable .type.tnc[data-v-72079060] {\n      background: #2ab77c;\n}\ntable .type.tcp[data-v-72079060] {\n      background: #3f81a0;\n}\ntable .type.psc[data-v-72079060] {\n      background: #de6c2a;\n}\ntable .expired[data-v-72079060] {\n    color: #de2929;\n}\ntable .fa-check-circle[data-v-72079060] {\n    color: #0fda4e;\n}\ntable .fa-times-circle[data-v-72079060] {\n    color: #ef3535;\n}\ntable a[data-v-72079060] {\n    cursor: pointer;\n}\ntable .date[data-v-72079060] {\n    word-spacing: 5px;\n}\n.checkbox[data-v-72079060] {\n  margin-top: 5px;\n  cursor: pointer;\n}\n.fix-footer[data-v-72079060] {\n  width: 100%;\n  height: 60px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-72079060] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-72079060] {\n    max-width: 100px;\n}\n.fix-footer .per-page[data-v-72079060] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .per-page span[data-v-72079060] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-72079060] {\n    text-align: center;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .pagination[data-v-72079060] {\n    text-align: right;\n    padding: 15px 10px;\n}\n.fix-footer .pagination span[data-v-72079060] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-72079060] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-72079060] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-72079060] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-72079060] {\n        opacity: .4;\n        cursor: default;\n}\n.modal[data-v-72079060] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.modal .bg-overlay[data-v-72079060] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n.modal .modal-content[data-v-72079060] {\n    vertical-align: middle;\n    display: none;\n    position: relative;\n    z-index: 2;\n}\n.modal .modal-content .list-table[data-v-72079060] {\n      padding: 0 25px;\n      position: relative;\n      overflow: auto;\n      max-height: calc(80vh - 115px);\n}\n.modal .modal-content .content-box[data-v-72079060] {\n      width: 800px;\n      padding: 25px 0 90px;\n      max-height: 80vh;\n      min-height: 300px;\n      overflow: hidden;\n      margin: 0 auto;\n      background: #fff;\n      text-align: center;\n      border-radius: 6px;\n      -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n              box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n      position: relative;\n}\n.modal .modal-content .content-box h1[data-v-72079060] {\n        margin: 0 0 10px;\n        line-height: 1;\n        font-size: 32px;\n        color: #434343;\n}\n.modal .modal-content .content-box .main-table[data-v-72079060] {\n        border: 1px solid #aaa;\n        margin-bottom: 20px;\n}\n.modal .modal-content .content-box a[data-v-72079060] {\n        text-decoration: none;\n}\n.modal .modal-content .content-box .fa-cube[data-v-72079060] {\n        margin-left: 3px;\n}\n.modal .modal-content .content-box .pickup-date[data-v-72079060] {\n        color: #888;\n}\n.modal .modal-content .content-box .action[data-v-72079060] {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        height: 50px;\n        padding: 5px;\n        background: #fafafa;\n        border-top: 1px solid #f3f3f3;\n}\n.modal .modal-content .content-box .action .button[data-v-72079060] {\n          width: 150px;\n}\n.modal.show[data-v-72079060] {\n    display: table;\n}\n.modal.show .modal-content[data-v-72079060] {\n      display: table-cell;\n      -webkit-animation: slide-down .3s ease-out;\n      -moz-animation: slide-down .3s ease-out;\n}\n.modal .close[data-v-72079060] {\n    display: block;\n    margin-top: 5px;\n    font-size: 14px;\n    color: #999;\n    cursor: pointer;\n}\n.modal .close[data-v-72079060]:hover {\n      text-decoration: underline;\n      color: #555;\n}\n.res-type[data-v-72079060] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 20px;\n  margin-bottom: 10px;\n}\n.res-type div[data-v-72079060] {\n    color: #bbb;\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n    border-bottom: 2px solid transparent;\n}\n.res-type div.active[data-v-72079060] {\n      color: #2071db;\n      border-bottom-color: #2071db;\n}\n.status[data-v-72079060] {\n  text-transform: uppercase;\n  letter-spacing: .4px;\n  background: #666;\n}\n@media only screen and (max-width: 430px) {\n.fix-footer .row[data-v-72079060] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.fix-footer .per-page[data-v-72079060] {\n    width: auto;\n}\n.fix-footer .per-page select[data-v-72079060] {\n      width: 55px;\n}\n.fix-footer .per-page span[data-v-72079060]:nth-child(3) {\n      display: none;\n}\n.fix-footer .page-data[data-v-72079060] {\n    display: none;\n}\n.fix-footer .pagination[data-v-72079060] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    padding: 15px 0px;\n    margin-right: 15%;\n}\n.fix-footer .pagination select[data-v-72079060] {\n      width: 55px;\n}\n.loader[data-v-72079060], .empty-result[data-v-72079060] {\n    text-align: center;\n    padding: 50px 0;\n}\n.cards[data-v-72079060] {\n    width: 90%;\n    margin: 0 auto;\n    margin-top: 20px;\n}\n.cards .result-stat[data-v-72079060] {\n      width: 100%;\n}\n.cards .card[data-v-72079060] {\n      border: 1px solid #ccc;\n      margin-bottom: 15px;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n}\n.cards .card .info[data-v-72079060] {\n        width: 100%;\n        padding-left: 10px;\n}\n.cards .card > div[data-v-72079060] {\n        margin-bottom: 3px;\n}\n.cards .card .email-logo img[data-v-72079060] {\n        max-width: 100px;\n        max-height: 100px;\n}\n.cards .card .card-header[data-v-72079060] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: start;\n            -ms-flex-pack: start;\n                justify-content: flex-start;\n        -webkit-box-align: start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n}\n.cards .card .card-header input[data-v-72079060] {\n          margin-top: 5px;\n          cursor: pointer;\n          width: auto;\n          margin-right: 5px;\n}\n.cards .card .card-header .type[data-v-72079060] {\n          display: inline-block;\n          padding: 3px 6px;\n          text-transform: uppercase;\n          border-radius: 4px;\n          color: #fff;\n          font-size: 11px;\n          font-weight: 600;\n}\n.cards .card .card-header .type.tnc[data-v-72079060] {\n            background: #2ab77c;\n}\n.cards .card .card-header .type.tcp[data-v-72079060] {\n            background: #3f81a0;\n}\n.cards .card .card-header .type.psc[data-v-72079060] {\n            background: #de6c2a;\n}\n.cards .card .credit-card[data-v-72079060] {\n        font-weight: 900;\n}\n.cards .card .title[data-v-72079060] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        margin-bottom: 3px;\n}\n.cards .card .title input[data-v-72079060] {\n          margin-right: 5px;\n}\n.cards .card .title.btn[data-v-72079060] {\n          text-align: center;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n          margin-top: 15px;\n          margin-bottom: 10px;\n}\n.cards .card .title.btn .button[data-v-72079060] {\n            padding: 10px 20px;\n}\n.cards .card .label[data-v-72079060] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards .card .value[data-v-72079060] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards .card .value i[data-v-72079060] {\n          color: #bbb;\n}\n.cards .card .value a[data-v-72079060] {\n          text-decoration: none;\n}\n.modal .modal-content .content-box[data-v-72079060] {\n    width: auto;\n    padding: 25px 25px 70px;\n}\n.modal .modal-content .content-box h1[data-v-72079060] {\n      font-size: 28px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/ProviderAvailability/DriverTable.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;CAC3B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,oBAAoB;CACrB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;EACnD,mBAAmB;EACnB,iBAAiB;CAClB;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,WAAW;CACZ;AACD;IACI,mBAAmB;CACtB;AACD;EACE,0BAA0B;EAC1B,YAAY;CACb;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,4CAA4C;IAC5C,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,2BAA2B;CAChC;AACD;QACQ,iBAAiB;CACxB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;IACI,sBAAsB;IACtB,YAAY;CACf;AACD;IACI,sBAAsB;IACtB,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;CACpB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,kBAAkB;CACrB;AACD;EACE,gBAAgB;EAChB,gBAAgB;CACjB;AACD;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;CACb;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;CACnB;AACD;MACM,sBAAsB;MACtB,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;CACnB;AACD;IACI,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,kBAAkB;CACvB;AACD;MACM,aAAa;MACb,uBAAuB;CAC5B;AACD;MACM,cAAc;MACd,eAAe;MACf,uBAAuB;MACvB,iBAAiB;MACjB,gBAAgB;MAChB,uBAAuB;MACvB,aAAa;CAClB;AACD;QACQ,kBAAkB;CACzB;AACD;QACQ,YAAY;QACZ,gBAAgB;CACvB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,YAAY;CACb;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;CAChB;AACD;IACI,uBAAuB;IACvB,cAAc;IACd,mBAAmB;IACnB,WAAW;CACd;AACD;MACM,gBAAgB;MAChB,mBAAmB;MACnB,eAAe;MACf,+BAA+B;CACpC;AACD;MACM,aAAa;MACb,qBAAqB;MACrB,iBAAiB;MACjB,kBAAkB;MAClB,iBAAiB;MACjB,eAAe;MACf,iBAAiB;MACjB,mBAAmB;MACnB,mBAAmB;MACnB,uDAAuD;cAC/C,+CAA+C;MACvD,mBAAmB;CACxB;AACD;QACQ,iBAAiB;QACjB,eAAe;QACf,gBAAgB;QAChB,eAAe;CACtB;AACD;QACQ,uBAAuB;QACvB,oBAAoB;CAC3B;AACD;QACQ,sBAAsB;CAC7B;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,YAAY;CACnB;AACD;QACQ,mBAAmB;QACnB,UAAU;QACV,QAAQ;QACR,YAAY;QACZ,aAAa;QACb,aAAa;QACb,oBAAoB;QACpB,8BAA8B;CACrC;AACD;UACU,aAAa;CACtB;AACD;IACI,eAAe;CAClB;AACD;MACM,oBAAoB;MACpB,2CAA2C;MAC3C,wCAAwC;CAC7C;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;CACnB;AACD;MACM,2BAA2B;MAC3B,YAAY;CACjB;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,UAAU;EACV,oBAAoB;CACrB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,qCAAqC;CACxC;AACD;MACM,eAAe;MACf,6BAA6B;CAClC;AACD;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,iBAAiB;CAClB;AACD;AACA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;IACI,YAAY;CACf;AACD;MACM,YAAY;CACjB;AACD;MACM,cAAc;CACnB;AACD;IACI,cAAc;CACjB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;IAC5B,kBAAkB;IAClB,kBAAkB;CACrB;AACD;MACM,YAAY;CACjB;AACD;IACI,mBAAmB;IACnB,gBAAgB;CACnB;AACD;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;CACpB;AACD;MACM,YAAY;CACjB;AACD;MACM,uBAAuB;MACvB,oBAAoB;MACpB,aAAa;MACb,oBAAoB;MACpB,+BAA+B;MAC/B,oBAAoB;CACzB;AACD;QACQ,YAAY;QACZ,mBAAmB;CAC1B;AACD;QACQ,mBAAmB;CAC1B;AACD;QACQ,iBAAiB;QACjB,kBAAkB;CACzB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,wBAAwB;YACpB,qBAAqB;gBACjB,4BAA4B;QACpC,yBAAyB;YACrB,sBAAsB;gBAClB,wBAAwB;CACvC;AACD;UACU,gBAAgB;UAChB,gBAAgB;UAChB,YAAY;UACZ,kBAAkB;CAC3B;AACD;UACU,sBAAsB;UACtB,iBAAiB;UACjB,0BAA0B;UAC1B,mBAAmB;UACnB,YAAY;UACZ,gBAAgB;UAChB,iBAAiB;CAC1B;AACD;YACY,oBAAoB;CAC/B;AACD;YACY,oBAAoB;CAC/B;AACD;YACY,oBAAoB;CAC/B;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,oBAAoB;QAC5B,mBAAmB;CAC1B;AACD;UACU,kBAAkB;CAC3B;AACD;UACU,mBAAmB;UACnB,yBAAyB;cACrB,sBAAsB;kBAClB,wBAAwB;UAChC,iBAAiB;UACjB,oBAAoB;CAC7B;AACD;YACY,mBAAmB;CAC9B;AACD;QACQ,gBAAgB;QAChB,0BAA0B;QAC1B,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;CACzB;AACD;QACQ,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;CACxB;AACD;UACU,YAAY;CACrB;AACD;UACU,sBAAsB;CAC/B;AACD;IACI,YAAY;IACZ,wBAAwB;CAC3B;AACD;MACM,gBAAgB;CACrB;CACA","file":"DriverTable.vue","sourcesContent":["\n.status[data-v-72079060] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-72079060], .status.completed[data-v-72079060] {\n    background: #26D97A;\n}\n.status.canceled[data-v-72079060], .status.cancelled[data-v-72079060], .status.failed[data-v-72079060] {\n    background: #bbb;\n}\n.status.upcoming[data-v-72079060] {\n    background: #f38d56;\n}\n.status.onboard[data-v-72079060] {\n    background: #dc3168;\n}\n.status.ready[data-v-72079060] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-72079060], .status.requires_dispatch[data-v-72079060] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-72079060] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-72079060] {\n    background: #5662f3;\n}\n.flight-status[data-v-72079060] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-72079060] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-72079060] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-72079060] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-72079060] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-72079060] {\n    background-color: #f35656;\n}\n.status.ready[data-v-72079060] {\n  background: #6dabc3;\n}\n.status.accepted[data-v-72079060] {\n  background: #777;\n}\n.status.on-time[data-v-72079060] {\n  background: #26d97a;\n}\n.status.late[data-v-72079060] {\n  background: #dc9831;\n}\n.status.ontheway[data-v-72079060] {\n  background: #f38d56;\n}\n.status.very-late[data-v-72079060] {\n  background: #e62e2e;\n}\n.status.open-credit[data-v-72079060] {\n  background: #29c3c3;\n}\n.list-table.outside[data-v-72079060] {\n  border: 1px solid #aaa;\n  background: #fff;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);\n  position: relative;\n  overflow: hidden;\n}\n.sticky[data-v-72079060] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  height: 44px;\n  z-index: 3;\n}\n.sticky tbody[data-v-72079060] {\n    visibility: hidden;\n}\ntable[data-v-72079060] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-72079060] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-72079060] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-72079060] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-72079060] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-72079060] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-72079060] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-72079060] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-72079060] {\n          color: #ccc;\n}\ntable input[data-v-72079060] {\n    display: inline-block;\n    width: auto;\n}\ntable .type[data-v-72079060] {\n    display: inline-block;\n    padding: 3px 6px;\n    text-transform: uppercase;\n    border-radius: 4px;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 600;\n}\ntable .type.tnc[data-v-72079060] {\n      background: #2ab77c;\n}\ntable .type.tcp[data-v-72079060] {\n      background: #3f81a0;\n}\ntable .type.psc[data-v-72079060] {\n      background: #de6c2a;\n}\ntable .expired[data-v-72079060] {\n    color: #de2929;\n}\ntable .fa-check-circle[data-v-72079060] {\n    color: #0fda4e;\n}\ntable .fa-times-circle[data-v-72079060] {\n    color: #ef3535;\n}\ntable a[data-v-72079060] {\n    cursor: pointer;\n}\ntable .date[data-v-72079060] {\n    word-spacing: 5px;\n}\n.checkbox[data-v-72079060] {\n  margin-top: 5px;\n  cursor: pointer;\n}\n.fix-footer[data-v-72079060] {\n  width: 100%;\n  height: 60px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-72079060] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-72079060] {\n    max-width: 100px;\n}\n.fix-footer .per-page[data-v-72079060] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .per-page span[data-v-72079060] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-72079060] {\n    text-align: center;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .pagination[data-v-72079060] {\n    text-align: right;\n    padding: 15px 10px;\n}\n.fix-footer .pagination span[data-v-72079060] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-72079060] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-72079060] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-72079060] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-72079060] {\n        opacity: .4;\n        cursor: default;\n}\n.modal[data-v-72079060] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.modal .bg-overlay[data-v-72079060] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n.modal .modal-content[data-v-72079060] {\n    vertical-align: middle;\n    display: none;\n    position: relative;\n    z-index: 2;\n}\n.modal .modal-content .list-table[data-v-72079060] {\n      padding: 0 25px;\n      position: relative;\n      overflow: auto;\n      max-height: calc(80vh - 115px);\n}\n.modal .modal-content .content-box[data-v-72079060] {\n      width: 800px;\n      padding: 25px 0 90px;\n      max-height: 80vh;\n      min-height: 300px;\n      overflow: hidden;\n      margin: 0 auto;\n      background: #fff;\n      text-align: center;\n      border-radius: 6px;\n      -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n              box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n      position: relative;\n}\n.modal .modal-content .content-box h1[data-v-72079060] {\n        margin: 0 0 10px;\n        line-height: 1;\n        font-size: 32px;\n        color: #434343;\n}\n.modal .modal-content .content-box .main-table[data-v-72079060] {\n        border: 1px solid #aaa;\n        margin-bottom: 20px;\n}\n.modal .modal-content .content-box a[data-v-72079060] {\n        text-decoration: none;\n}\n.modal .modal-content .content-box .fa-cube[data-v-72079060] {\n        margin-left: 3px;\n}\n.modal .modal-content .content-box .pickup-date[data-v-72079060] {\n        color: #888;\n}\n.modal .modal-content .content-box .action[data-v-72079060] {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        height: 50px;\n        padding: 5px;\n        background: #fafafa;\n        border-top: 1px solid #f3f3f3;\n}\n.modal .modal-content .content-box .action .button[data-v-72079060] {\n          width: 150px;\n}\n.modal.show[data-v-72079060] {\n    display: table;\n}\n.modal.show .modal-content[data-v-72079060] {\n      display: table-cell;\n      -webkit-animation: slide-down .3s ease-out;\n      -moz-animation: slide-down .3s ease-out;\n}\n.modal .close[data-v-72079060] {\n    display: block;\n    margin-top: 5px;\n    font-size: 14px;\n    color: #999;\n    cursor: pointer;\n}\n.modal .close[data-v-72079060]:hover {\n      text-decoration: underline;\n      color: #555;\n}\n.res-type[data-v-72079060] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 20px;\n  margin-bottom: 10px;\n}\n.res-type div[data-v-72079060] {\n    color: #bbb;\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n    border-bottom: 2px solid transparent;\n}\n.res-type div.active[data-v-72079060] {\n      color: #2071db;\n      border-bottom-color: #2071db;\n}\n.status[data-v-72079060] {\n  text-transform: uppercase;\n  letter-spacing: .4px;\n  background: #666;\n}\n@media only screen and (max-width: 430px) {\n.fix-footer .row[data-v-72079060] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.fix-footer .per-page[data-v-72079060] {\n    width: auto;\n}\n.fix-footer .per-page select[data-v-72079060] {\n      width: 55px;\n}\n.fix-footer .per-page span[data-v-72079060]:nth-child(3) {\n      display: none;\n}\n.fix-footer .page-data[data-v-72079060] {\n    display: none;\n}\n.fix-footer .pagination[data-v-72079060] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    padding: 15px 0px;\n    margin-right: 15%;\n}\n.fix-footer .pagination select[data-v-72079060] {\n      width: 55px;\n}\n.loader[data-v-72079060], .empty-result[data-v-72079060] {\n    text-align: center;\n    padding: 50px 0;\n}\n.cards[data-v-72079060] {\n    width: 90%;\n    margin: 0 auto;\n    margin-top: 20px;\n}\n.cards .result-stat[data-v-72079060] {\n      width: 100%;\n}\n.cards .card[data-v-72079060] {\n      border: 1px solid #ccc;\n      margin-bottom: 15px;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n}\n.cards .card .info[data-v-72079060] {\n        width: 100%;\n        padding-left: 10px;\n}\n.cards .card > div[data-v-72079060] {\n        margin-bottom: 3px;\n}\n.cards .card .email-logo img[data-v-72079060] {\n        max-width: 100px;\n        max-height: 100px;\n}\n.cards .card .card-header[data-v-72079060] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: start;\n            -ms-flex-pack: start;\n                justify-content: flex-start;\n        -webkit-box-align: start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n}\n.cards .card .card-header input[data-v-72079060] {\n          margin-top: 5px;\n          cursor: pointer;\n          width: auto;\n          margin-right: 5px;\n}\n.cards .card .card-header .type[data-v-72079060] {\n          display: inline-block;\n          padding: 3px 6px;\n          text-transform: uppercase;\n          border-radius: 4px;\n          color: #fff;\n          font-size: 11px;\n          font-weight: 600;\n}\n.cards .card .card-header .type.tnc[data-v-72079060] {\n            background: #2ab77c;\n}\n.cards .card .card-header .type.tcp[data-v-72079060] {\n            background: #3f81a0;\n}\n.cards .card .card-header .type.psc[data-v-72079060] {\n            background: #de6c2a;\n}\n.cards .card .credit-card[data-v-72079060] {\n        font-weight: 900;\n}\n.cards .card .title[data-v-72079060] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        margin-bottom: 3px;\n}\n.cards .card .title input[data-v-72079060] {\n          margin-right: 5px;\n}\n.cards .card .title.btn[data-v-72079060] {\n          text-align: center;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n          margin-top: 15px;\n          margin-bottom: 10px;\n}\n.cards .card .title.btn .button[data-v-72079060] {\n            padding: 10px 20px;\n}\n.cards .card .label[data-v-72079060] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards .card .value[data-v-72079060] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards .card .value i[data-v-72079060] {\n          color: #bbb;\n}\n.cards .card .value a[data-v-72079060] {\n          text-decoration: none;\n}\n.modal .modal-content .content-box[data-v-72079060] {\n    width: auto;\n    padding: 25px 25px 70px;\n}\n.modal .modal-content .content-box h1[data-v-72079060] {\n      font-size: 28px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-table outside"},[(!_vm.isMobile)?_c('div',{staticClass:"scroll-table"},[_c('table',{staticClass:"main-table"},[_c('thead',[_c('th',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkAll),expression:"checkAll"}],staticClass:"checkbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkAll)?_vm._i(_vm.checkAll,null)>-1:(_vm.checkAll)},on:{"change":[function($event){var $$a=_vm.checkAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkAll=$$c}},_vm.toggleCheckAll]}})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'name'},on:{"click":function($event){return _vm.sort('name')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.availability.businessName'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'name'),expression:"currentOrder.field === 'name'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'license'},on:{"click":function($event){return _vm.sort('license')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.availability.type'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'license'),expression:"currentOrder.field === 'license'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'sector'},on:{"click":function($event){return _vm.sort('sector')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.availability.homeSector'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'sector'),expression:"currentOrder.field === 'sector'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',[_vm._v("Service")]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'vehicle'},on:{"click":function($event){return _vm.sort('vehicle')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.availability.vehicle'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'vehicle'),expression:"currentOrder.field === 'vehicle'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'startShift'},on:{"click":function($event){return _vm.sort('startShift')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.availability.availableFrom'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'startShift'),expression:"currentOrder.field === 'startShift'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'endShift'},on:{"click":function($event){return _vm.sort('endShift')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.availability.availableUntil'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'endShift'),expression:"currentOrder.field === 'endShift'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('provider.availability.phone')))]),_vm._v(" "),_c('th',{class:['sortable', {'active':_vm.currentOrder.field === 'assigned'}],on:{"click":function($event){return _vm.sort('assigned')}}},[_vm._v("\n          Assigned Trips\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'assigned'),expression:"currentOrder.field === 'assigned'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.users),function(user,index){return _c('tr',{key:index},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked),expression:"checked"}],staticClass:"checkbox",attrs:{"type":"checkbox"},domProps:{"value":user.id,"checked":Array.isArray(_vm.checked)?_vm._i(_vm.checked,user.id)>-1:(_vm.checked)},on:{"change":function($event){var $$a=_vm.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=user.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked=$$c}}}})]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'/#/provider/' + user.id,"target":"_blank"}},[_vm._v(_vm._s(user.name))])]),_vm._v(" "),_c('td',[_c('span',{class:['type', user.licenseType]},[_vm._v(_vm._s(user.licenseType))])]),_vm._v(" "),_c('td',{staticClass:"home-sector"},[_vm._v(_vm._s(user.homeSector))]),_vm._v(" "),_c('td',{staticClass:"pax-dtd"},[_vm._v(_vm._s(user.paxDtd))]),_vm._v(" "),_c('td',{staticClass:"vehicle-type"},[_vm._v(_vm._s(user.vehicleType))]),_vm._v(" "),_c('td',{staticClass:"available-from"},[_vm._v(_vm._s(user.availableFrom))]),_vm._v(" "),_c('td',{staticClass:"available-until"},[_vm._v(_vm._s(user.availableUntil))]),_vm._v(" "),_c('td',{staticClass:"mobile"},[_c('a',{on:{"click":function($event){return _vm.call(user)}}},[_vm._v(_vm._s(user.mobile))])]),_vm._v(" "),_c('td',[(user.hasAssignment)?_c('a',{on:{"click":function($event){return _vm.showTrips(user)}}},[_vm._v("View")]):_vm._e()])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading && _vm.users.length === 0),expression:"loading && users.length === 0"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"10"}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n                "+_vm._s(_vm.$t('consumer.list.gettingUsers'))+"\n              ")])])],1)]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.length === 0 && !_vm.loading),expression:"users.length === 0 && !loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"10"}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.length === 0 && !_vm.loading),expression:"users.length === 0 && !loading"}],staticClass:"empty-result"},[_c('i',{staticClass:"far fa-frown-open fa-3x"}),_c('br'),_vm._v("\n                No record found!~\n              ")])])],1)])],2)])]):_c('div',{staticClass:"cards"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading && _vm.users.length === 0),expression:"loading && users.length === 0"}],staticClass:"result-stat"},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n          "+_vm._s(_vm.$t('consumer.list.gettingUsers'))+"\n        ")])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.length === 0 && !_vm.loading),expression:"users.length === 0 && !loading"}],staticClass:"result-stat"},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.length === 0 && !_vm.loading),expression:"users.length === 0 && !loading"}],staticClass:"empty-result"},[_c('i',{staticClass:"far fa-frown-open fa-3x"}),_c('br'),_vm._v("\n          No record found!\n        ")])])],1),_vm._v(" "),_vm._l((_vm.users),function(user,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked),expression:"checked"}],staticClass:"checkbox",attrs:{"type":"checkbox"},domProps:{"value":user.id,"checked":Array.isArray(_vm.checked)?_vm._i(_vm.checked,user.id)>-1:(_vm.checked)},on:{"change":function($event){var $$a=_vm.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=user.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked=$$c}}}}),_vm._v(" "),_c('span',{class:['type', user.licenseType]},[_vm._v(_vm._s(user.licenseType))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.availability.businessName'))+": ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":'/#/provider/' + user.id,"target":"_blank"}},[_vm._v(_vm._s(user.name))])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.availability.homeSector'))+": ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(user.homeSector))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Service: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(user.paxDtd))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.availability.vehicle'))+": ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(user.vehicleType))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.availability.availableFrom'))+": ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(user.availableFrom))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.availability.availableUntil'))+": ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(user.availableUntil))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.availability.phone'))+": ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{on:{"click":function($event){return _vm.call(user)}}},[_vm._v(_vm._s(user.mobile))])])]),_vm._v(" "),_c('div',{staticClass:"title btn"},[(user.hasAssignment)?_c('a',{staticClass:"button cta xsmall",on:{"click":function($event){return _vm.showTrips(user)}}},[_vm._v("View")]):_vm._e()])])})],2),_vm._v(" "),_c('div',{staticClass:"fix-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-3 columns per-page"},[_c('span',[_vm._v("Displaying")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" "),_c('span',[_vm._v("per page")])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns page-data"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.length > 0),expression:"users.length > 0"}]},[_vm._v("\n          Displaying\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.start))]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.pageData.end))]),_vm._v(" of\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.max))])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns pagination"},[_c('span',[_vm._v("Page")]),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.currentPage === 1 || _vm.loading},on:{"click":_vm.prev}},[_c('i',{staticClass:"fas fa-chevron-left"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentPage),expression:"currentPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.totalPage),function(i){return _c('option',{domProps:{"value":i}},[_vm._v(_vm._s(i))])}),0),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.isLastPage || _vm.loading},on:{"click":_vm.next}},[_c('i',{staticClass:"fas fa-chevron-right"})])])])]),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.modal.show}},[_c('div',{staticClass:"bg-overlay"}),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"content-box"},[_c('h1',[_vm._v("Assigned Trips")]),_vm._v(" "),_c('div',{staticClass:"list-table tables"},[_c('table',{staticClass:"main-table"},[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._l((_vm.modal.trips),function(data,index){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(!_vm.modal.loading && _vm.dateCheck(data.pickupDate)),expression:"!modal.loading && dateCheck(data.pickupDate)"}],key:index},[_c('td',[(data.type === 'package')?_c('a',{attrs:{"href":("/#/package/" + (data.id)),"target":"_blank"}},[_vm._v(_vm._s(data.id)),_c('i',{staticClass:"fa fa-cube"})]):_c('a',{attrs:{"href":("/#/reservation/" + (data.id)),"target":"_blank"}},[_vm._v(_vm._s(data.id))])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"pickup-date"},[_vm._v(_vm._s(data.pickupDate))])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"location"},[_vm._v(_vm._s(data.pickup))])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"location"},[_vm._v(_vm._s(data.dropoff))])]),_vm._v(" "),_c('td',[_c('span',{class:['status', data.status, data.dispatchStatusX]},[_vm._v(_vm._s(data.statusLabel))])])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.modal.loading),expression:"modal.loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"4"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modal.loading),expression:"modal.loading"}],staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n                    Getting assigned trips\n                  ")])])]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.modal.trips.length === 0 && !_vm.modal.loading),expression:"modal.trips.length === 0 && !modal.loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"4"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modal.trips.length === 0 && !_vm.loading),expression:"modal.trips.length === 0 && !loading"}],staticClass:"empty-result"},[_c('i',{staticClass:"far fa-frown-open fa-3x"}),_c('br'),_vm._v("\n                    No record found!~\n                  ")])])])],2)])]),_vm._v(" "),_c('div',{staticClass:"action"},[_c('a',{staticClass:"button cta small",on:{"click":function($event){_vm.modal.show = false}}},[_vm._v("Close")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("Pickup Date")]),_vm._v(" "),_c('th',[_vm._v("Pickup")]),_vm._v(" "),_c('th',[_vm._v("Dropoff")]),_vm._v(" "),_c('th',[_vm._v("Status")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoShiftTable_vue__ = __webpack_require__(592);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8be41f0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoShiftTable_vue__ = __webpack_require__(1737);
function injectStyle (ssrContext) {
  __webpack_require__(1735)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c8be41f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoShiftTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8be41f0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoShiftTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1736);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5adf3946", content, true, {});

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.status[data-v-c8be41f0] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-c8be41f0], .status.completed[data-v-c8be41f0] {\n    background: #26D97A;\n}\n.status.canceled[data-v-c8be41f0], .status.cancelled[data-v-c8be41f0], .status.failed[data-v-c8be41f0] {\n    background: #bbb;\n}\n.status.upcoming[data-v-c8be41f0] {\n    background: #f38d56;\n}\n.status.onboard[data-v-c8be41f0] {\n    background: #dc3168;\n}\n.status.ready[data-v-c8be41f0] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-c8be41f0], .status.requires_dispatch[data-v-c8be41f0] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-c8be41f0] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-c8be41f0] {\n    background: #5662f3;\n}\n.flight-status[data-v-c8be41f0] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-c8be41f0] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-c8be41f0] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-c8be41f0] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-c8be41f0] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-c8be41f0] {\n    background-color: #f35656;\n}\n.status.ready[data-v-c8be41f0] {\n  background: #6dabc3;\n}\n.status.accepted[data-v-c8be41f0] {\n  background: #777;\n}\n.status.on-time[data-v-c8be41f0] {\n  background: #26d97a;\n}\n.status.late[data-v-c8be41f0] {\n  background: #dc9831;\n}\n.status.ontheway[data-v-c8be41f0] {\n  background: #f38d56;\n}\n.status.very-late[data-v-c8be41f0] {\n  background: #e62e2e;\n}\n.status.open-credit[data-v-c8be41f0] {\n  background: #29c3c3;\n}\n.list-table.outside[data-v-c8be41f0] {\n  border: 1px solid #aaa;\n  background: #fff;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);\n  position: relative;\n  overflow: hidden;\n}\n.sticky[data-v-c8be41f0] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  height: 44px;\n  z-index: 3;\n}\n.sticky tbody[data-v-c8be41f0] {\n    visibility: hidden;\n}\ntable[data-v-c8be41f0] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-c8be41f0] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-c8be41f0] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-c8be41f0] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-c8be41f0] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-c8be41f0] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-c8be41f0] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-c8be41f0] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-c8be41f0] {\n          color: #ccc;\n}\ntable input[data-v-c8be41f0] {\n    display: inline-block;\n    width: auto;\n}\ntable .type[data-v-c8be41f0] {\n    display: inline-block;\n    padding: 3px 6px;\n    text-transform: uppercase;\n    border-radius: 4px;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 600;\n}\ntable .type.tnc[data-v-c8be41f0] {\n      background: #2ab77c;\n}\ntable .type.tcp[data-v-c8be41f0] {\n      background: #3f81a0;\n}\ntable .type.psc[data-v-c8be41f0] {\n      background: #de6c2a;\n}\ntable .expired[data-v-c8be41f0] {\n    color: #de2929;\n}\ntable .fa-check-circle[data-v-c8be41f0] {\n    color: #0fda4e;\n}\ntable .fa-times-circle[data-v-c8be41f0] {\n    color: #ef3535;\n}\ntable a[data-v-c8be41f0] {\n    cursor: pointer;\n}\ntable .date[data-v-c8be41f0] {\n    word-spacing: 5px;\n}\n.checkbox[data-v-c8be41f0] {\n  margin-top: 5px;\n  cursor: pointer;\n}\n.fix-footer[data-v-c8be41f0] {\n  width: 100%;\n  height: 60px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 15px;\n}\n.fix-footer select[data-v-c8be41f0] {\n    max-width: 100px;\n}\n.fix-footer .per-page[data-v-c8be41f0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 15px 0;\n    width: 33%;\n}\n.fix-footer .per-page span[data-v-c8be41f0] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-c8be41f0] {\n    text-align: center;\n    line-height: 30px;\n    padding: 15px 0;\n    width: 34%;\n}\n.fix-footer .pagination[data-v-c8be41f0] {\n    text-align: right;\n    padding: 15px 10px;\n    width: 33%;\n}\n.fix-footer .pagination span[data-v-c8be41f0] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-c8be41f0] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-c8be41f0] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-c8be41f0] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-c8be41f0] {\n        opacity: .4;\n        cursor: default;\n}\n.modal[data-v-c8be41f0] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.modal .bg-overlay[data-v-c8be41f0] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n.modal .modal-content[data-v-c8be41f0] {\n    vertical-align: middle;\n    display: none;\n    position: relative;\n    z-index: 2;\n}\n.modal .modal-content .list-table[data-v-c8be41f0] {\n      padding: 0 25px;\n      position: relative;\n      overflow: auto;\n      max-height: calc(80vh - 115px);\n}\n.modal .modal-content .content-box[data-v-c8be41f0] {\n      width: 800px;\n      padding: 25px 0 90px;\n      max-height: 80vh;\n      min-height: 300px;\n      overflow: hidden;\n      margin: 0 auto;\n      background: #fff;\n      text-align: center;\n      border-radius: 6px;\n      -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n              box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n      position: relative;\n}\n.modal .modal-content .content-box h1[data-v-c8be41f0] {\n        margin: 0 0 10px;\n        line-height: 1;\n        font-size: 32px;\n        color: #434343;\n}\n.modal .modal-content .content-box .main-table[data-v-c8be41f0] {\n        border: 1px solid #aaa;\n        margin-bottom: 20px;\n}\n.modal .modal-content .content-box a[data-v-c8be41f0] {\n        text-decoration: none;\n}\n.modal .modal-content .content-box .fa-cube[data-v-c8be41f0] {\n        margin-left: 3px;\n}\n.modal .modal-content .content-box .pickup-date[data-v-c8be41f0] {\n        color: #888;\n}\n.modal .modal-content .content-box .action[data-v-c8be41f0] {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        height: 50px;\n        padding: 5px;\n        background: #fafafa;\n        border-top: 1px solid #f3f3f3;\n}\n.modal .modal-content .content-box .action .button[data-v-c8be41f0] {\n          width: 150px;\n}\n.modal.show[data-v-c8be41f0] {\n    display: table;\n}\n.modal.show .modal-content[data-v-c8be41f0] {\n      display: table-cell;\n      -webkit-animation: slide-down .3s ease-out;\n      -moz-animation: slide-down .3s ease-out;\n}\n.modal .close[data-v-c8be41f0] {\n    display: block;\n    margin-top: 5px;\n    font-size: 14px;\n    color: #999;\n    cursor: pointer;\n}\n.modal .close[data-v-c8be41f0]:hover {\n      text-decoration: underline;\n      color: #555;\n}\n.res-type[data-v-c8be41f0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 20px;\n  margin-bottom: 10px;\n}\n.res-type div[data-v-c8be41f0] {\n    color: #bbb;\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n    border-bottom: 2px solid transparent;\n}\n.res-type div.active[data-v-c8be41f0] {\n      color: #2071db;\n      border-bottom-color: #2071db;\n}\n.status[data-v-c8be41f0] {\n  text-transform: uppercase;\n  letter-spacing: .4px;\n  background: #666;\n}\n@media only screen and (max-width: 430px) {\n.fix-footer .row[data-v-c8be41f0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.fix-footer .per-page[data-v-c8be41f0] {\n    width: auto;\n}\n.fix-footer .per-page select[data-v-c8be41f0] {\n      width: 55px;\n}\n.fix-footer .per-page span[data-v-c8be41f0]:nth-child(3) {\n      display: none;\n}\n.fix-footer .page-data[data-v-c8be41f0] {\n    display: none;\n}\n.fix-footer .pagination[data-v-c8be41f0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    padding: 15px 0px;\n    margin-right: 15%;\n}\n.fix-footer .pagination select[data-v-c8be41f0] {\n      width: 55px;\n}\n.loader[data-v-c8be41f0], .empty-result[data-v-c8be41f0] {\n    text-align: center;\n    padding: 50px 0;\n}\n.cards[data-v-c8be41f0] {\n    width: 90%;\n    margin: 0 auto;\n    margin-top: 20px;\n}\n.cards .result-stat[data-v-c8be41f0] {\n      width: 100%;\n}\n.cards .card[data-v-c8be41f0] {\n      border: 1px solid #ccc;\n      margin-bottom: 15px;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n}\n.cards .card .info[data-v-c8be41f0] {\n        width: 100%;\n        padding-left: 10px;\n}\n.cards .card > div[data-v-c8be41f0] {\n        margin-bottom: 3px;\n}\n.cards .card .email-logo img[data-v-c8be41f0] {\n        max-width: 100px;\n        max-height: 100px;\n}\n.cards .card .card-header[data-v-c8be41f0] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: start;\n            -ms-flex-pack: start;\n                justify-content: flex-start;\n        -webkit-box-align: start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n}\n.cards .card .card-header input[data-v-c8be41f0] {\n          margin-top: 5px;\n          cursor: pointer;\n          width: auto;\n          margin-right: 5px;\n}\n.cards .card .card-header .type[data-v-c8be41f0] {\n          display: inline-block;\n          padding: 3px 6px;\n          text-transform: uppercase;\n          border-radius: 4px;\n          color: #fff;\n          font-size: 11px;\n          font-weight: 600;\n}\n.cards .card .card-header .type.tnc[data-v-c8be41f0] {\n            background: #2ab77c;\n}\n.cards .card .card-header .type.tcp[data-v-c8be41f0] {\n            background: #3f81a0;\n}\n.cards .card .card-header .type.psc[data-v-c8be41f0] {\n            background: #de6c2a;\n}\n.cards .card .credit-card[data-v-c8be41f0] {\n        font-weight: 900;\n}\n.cards .card .title[data-v-c8be41f0] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        margin-bottom: 3px;\n}\n.cards .card .title input[data-v-c8be41f0] {\n          margin-right: 5px;\n}\n.cards .card .title.btn[data-v-c8be41f0] {\n          text-align: center;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n          margin-top: 15px;\n          margin-bottom: 10px;\n}\n.cards .card .title.btn .button[data-v-c8be41f0] {\n            padding: 10px 20px;\n}\n.cards .card .label[data-v-c8be41f0] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards .card .value[data-v-c8be41f0] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards .card .value i[data-v-c8be41f0] {\n          color: #bbb;\n}\n.cards .card .value a[data-v-c8be41f0] {\n          text-decoration: none;\n}\n.modal .modal-content .content-box[data-v-c8be41f0] {\n    width: auto;\n    padding: 25px 25px 70px;\n}\n.modal .modal-content .content-box h1[data-v-c8be41f0] {\n      font-size: 28px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/ProviderAvailability/NoShiftTable.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;CAC3B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,oBAAoB;CACrB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;EACnD,mBAAmB;EACnB,iBAAiB;CAClB;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,WAAW;CACZ;AACD;IACI,mBAAmB;CACtB;AACD;EACE,0BAA0B;EAC1B,YAAY;CACb;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,4CAA4C;IAC5C,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,2BAA2B;CAChC;AACD;QACQ,iBAAiB;CACxB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;IACI,sBAAsB;IACtB,YAAY;CACf;AACD;IACI,sBAAsB;IACtB,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;CACpB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,kBAAkB;CACrB;AACD;EACE,gBAAgB;EAChB,gBAAgB;CACjB;AACD;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,UAAU;CACX;AACD;IACI,iBAAiB;CACpB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;CACd;AACD;MACM,sBAAsB;MACtB,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;CACd;AACD;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;CACd;AACD;MACM,sBAAsB;MACtB,kBAAkB;CACvB;AACD;MACM,aAAa;MACb,uBAAuB;CAC5B;AACD;MACM,cAAc;MACd,eAAe;MACf,uBAAuB;MACvB,iBAAiB;MACjB,gBAAgB;MAChB,uBAAuB;MACvB,aAAa;CAClB;AACD;QACQ,kBAAkB;CACzB;AACD;QACQ,YAAY;QACZ,gBAAgB;CACvB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,YAAY;CACb;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;CAChB;AACD;IACI,uBAAuB;IACvB,cAAc;IACd,mBAAmB;IACnB,WAAW;CACd;AACD;MACM,gBAAgB;MAChB,mBAAmB;MACnB,eAAe;MACf,+BAA+B;CACpC;AACD;MACM,aAAa;MACb,qBAAqB;MACrB,iBAAiB;MACjB,kBAAkB;MAClB,iBAAiB;MACjB,eAAe;MACf,iBAAiB;MACjB,mBAAmB;MACnB,mBAAmB;MACnB,uDAAuD;cAC/C,+CAA+C;MACvD,mBAAmB;CACxB;AACD;QACQ,iBAAiB;QACjB,eAAe;QACf,gBAAgB;QAChB,eAAe;CACtB;AACD;QACQ,uBAAuB;QACvB,oBAAoB;CAC3B;AACD;QACQ,sBAAsB;CAC7B;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,YAAY;CACnB;AACD;QACQ,mBAAmB;QACnB,UAAU;QACV,QAAQ;QACR,YAAY;QACZ,aAAa;QACb,aAAa;QACb,oBAAoB;QACpB,8BAA8B;CACrC;AACD;UACU,aAAa;CACtB;AACD;IACI,eAAe;CAClB;AACD;MACM,oBAAoB;MACpB,2CAA2C;MAC3C,wCAAwC;CAC7C;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;CACnB;AACD;MACM,2BAA2B;MAC3B,YAAY;CACjB;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,UAAU;EACV,oBAAoB;CACrB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,qCAAqC;CACxC;AACD;MACM,eAAe;MACf,6BAA6B;CAClC;AACD;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,iBAAiB;CAClB;AACD;AACA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;IACI,YAAY;CACf;AACD;MACM,YAAY;CACjB;AACD;MACM,cAAc;CACnB;AACD;IACI,cAAc;CACjB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;IAC5B,kBAAkB;IAClB,kBAAkB;CACrB;AACD;MACM,YAAY;CACjB;AACD;IACI,mBAAmB;IACnB,gBAAgB;CACnB;AACD;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;CACpB;AACD;MACM,YAAY;CACjB;AACD;MACM,uBAAuB;MACvB,oBAAoB;MACpB,aAAa;MACb,oBAAoB;MACpB,+BAA+B;MAC/B,oBAAoB;CACzB;AACD;QACQ,YAAY;QACZ,mBAAmB;CAC1B;AACD;QACQ,mBAAmB;CAC1B;AACD;QACQ,iBAAiB;QACjB,kBAAkB;CACzB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,wBAAwB;YACpB,qBAAqB;gBACjB,4BAA4B;QACpC,yBAAyB;YACrB,sBAAsB;gBAClB,wBAAwB;CACvC;AACD;UACU,gBAAgB;UAChB,gBAAgB;UAChB,YAAY;UACZ,kBAAkB;CAC3B;AACD;UACU,sBAAsB;UACtB,iBAAiB;UACjB,0BAA0B;UAC1B,mBAAmB;UACnB,YAAY;UACZ,gBAAgB;UAChB,iBAAiB;CAC1B;AACD;YACY,oBAAoB;CAC/B;AACD;YACY,oBAAoB;CAC/B;AACD;YACY,oBAAoB;CAC/B;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,oBAAoB;QAC5B,mBAAmB;CAC1B;AACD;UACU,kBAAkB;CAC3B;AACD;UACU,mBAAmB;UACnB,yBAAyB;cACrB,sBAAsB;kBAClB,wBAAwB;UAChC,iBAAiB;UACjB,oBAAoB;CAC7B;AACD;YACY,mBAAmB;CAC9B;AACD;QACQ,gBAAgB;QAChB,0BAA0B;QAC1B,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;CACzB;AACD;QACQ,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;CACxB;AACD;UACU,YAAY;CACrB;AACD;UACU,sBAAsB;CAC/B;AACD;IACI,YAAY;IACZ,wBAAwB;CAC3B;AACD;MACM,gBAAgB;CACrB;CACA","file":"NoShiftTable.vue","sourcesContent":["\n.status[data-v-c8be41f0] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-c8be41f0], .status.completed[data-v-c8be41f0] {\n    background: #26D97A;\n}\n.status.canceled[data-v-c8be41f0], .status.cancelled[data-v-c8be41f0], .status.failed[data-v-c8be41f0] {\n    background: #bbb;\n}\n.status.upcoming[data-v-c8be41f0] {\n    background: #f38d56;\n}\n.status.onboard[data-v-c8be41f0] {\n    background: #dc3168;\n}\n.status.ready[data-v-c8be41f0] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-c8be41f0], .status.requires_dispatch[data-v-c8be41f0] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-c8be41f0] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-c8be41f0] {\n    background: #5662f3;\n}\n.flight-status[data-v-c8be41f0] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-c8be41f0] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-c8be41f0] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-c8be41f0] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-c8be41f0] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-c8be41f0] {\n    background-color: #f35656;\n}\n.status.ready[data-v-c8be41f0] {\n  background: #6dabc3;\n}\n.status.accepted[data-v-c8be41f0] {\n  background: #777;\n}\n.status.on-time[data-v-c8be41f0] {\n  background: #26d97a;\n}\n.status.late[data-v-c8be41f0] {\n  background: #dc9831;\n}\n.status.ontheway[data-v-c8be41f0] {\n  background: #f38d56;\n}\n.status.very-late[data-v-c8be41f0] {\n  background: #e62e2e;\n}\n.status.open-credit[data-v-c8be41f0] {\n  background: #29c3c3;\n}\n.list-table.outside[data-v-c8be41f0] {\n  border: 1px solid #aaa;\n  background: #fff;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);\n  position: relative;\n  overflow: hidden;\n}\n.sticky[data-v-c8be41f0] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  height: 44px;\n  z-index: 3;\n}\n.sticky tbody[data-v-c8be41f0] {\n    visibility: hidden;\n}\ntable[data-v-c8be41f0] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-c8be41f0] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-c8be41f0] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-c8be41f0] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-c8be41f0] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-c8be41f0] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-c8be41f0] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-c8be41f0] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-c8be41f0] {\n          color: #ccc;\n}\ntable input[data-v-c8be41f0] {\n    display: inline-block;\n    width: auto;\n}\ntable .type[data-v-c8be41f0] {\n    display: inline-block;\n    padding: 3px 6px;\n    text-transform: uppercase;\n    border-radius: 4px;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 600;\n}\ntable .type.tnc[data-v-c8be41f0] {\n      background: #2ab77c;\n}\ntable .type.tcp[data-v-c8be41f0] {\n      background: #3f81a0;\n}\ntable .type.psc[data-v-c8be41f0] {\n      background: #de6c2a;\n}\ntable .expired[data-v-c8be41f0] {\n    color: #de2929;\n}\ntable .fa-check-circle[data-v-c8be41f0] {\n    color: #0fda4e;\n}\ntable .fa-times-circle[data-v-c8be41f0] {\n    color: #ef3535;\n}\ntable a[data-v-c8be41f0] {\n    cursor: pointer;\n}\ntable .date[data-v-c8be41f0] {\n    word-spacing: 5px;\n}\n.checkbox[data-v-c8be41f0] {\n  margin-top: 5px;\n  cursor: pointer;\n}\n.fix-footer[data-v-c8be41f0] {\n  width: 100%;\n  height: 60px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 15px;\n}\n.fix-footer select[data-v-c8be41f0] {\n    max-width: 100px;\n}\n.fix-footer .per-page[data-v-c8be41f0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 15px 0;\n    width: 33%;\n}\n.fix-footer .per-page span[data-v-c8be41f0] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-c8be41f0] {\n    text-align: center;\n    line-height: 30px;\n    padding: 15px 0;\n    width: 34%;\n}\n.fix-footer .pagination[data-v-c8be41f0] {\n    text-align: right;\n    padding: 15px 10px;\n    width: 33%;\n}\n.fix-footer .pagination span[data-v-c8be41f0] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-c8be41f0] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-c8be41f0] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-c8be41f0] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-c8be41f0] {\n        opacity: .4;\n        cursor: default;\n}\n.modal[data-v-c8be41f0] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  z-index: 12;\n}\n.modal .bg-overlay[data-v-c8be41f0] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n.modal .modal-content[data-v-c8be41f0] {\n    vertical-align: middle;\n    display: none;\n    position: relative;\n    z-index: 2;\n}\n.modal .modal-content .list-table[data-v-c8be41f0] {\n      padding: 0 25px;\n      position: relative;\n      overflow: auto;\n      max-height: calc(80vh - 115px);\n}\n.modal .modal-content .content-box[data-v-c8be41f0] {\n      width: 800px;\n      padding: 25px 0 90px;\n      max-height: 80vh;\n      min-height: 300px;\n      overflow: hidden;\n      margin: 0 auto;\n      background: #fff;\n      text-align: center;\n      border-radius: 6px;\n      -webkit-box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n              box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.3);\n      position: relative;\n}\n.modal .modal-content .content-box h1[data-v-c8be41f0] {\n        margin: 0 0 10px;\n        line-height: 1;\n        font-size: 32px;\n        color: #434343;\n}\n.modal .modal-content .content-box .main-table[data-v-c8be41f0] {\n        border: 1px solid #aaa;\n        margin-bottom: 20px;\n}\n.modal .modal-content .content-box a[data-v-c8be41f0] {\n        text-decoration: none;\n}\n.modal .modal-content .content-box .fa-cube[data-v-c8be41f0] {\n        margin-left: 3px;\n}\n.modal .modal-content .content-box .pickup-date[data-v-c8be41f0] {\n        color: #888;\n}\n.modal .modal-content .content-box .action[data-v-c8be41f0] {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        height: 50px;\n        padding: 5px;\n        background: #fafafa;\n        border-top: 1px solid #f3f3f3;\n}\n.modal .modal-content .content-box .action .button[data-v-c8be41f0] {\n          width: 150px;\n}\n.modal.show[data-v-c8be41f0] {\n    display: table;\n}\n.modal.show .modal-content[data-v-c8be41f0] {\n      display: table-cell;\n      -webkit-animation: slide-down .3s ease-out;\n      -moz-animation: slide-down .3s ease-out;\n}\n.modal .close[data-v-c8be41f0] {\n    display: block;\n    margin-top: 5px;\n    font-size: 14px;\n    color: #999;\n    cursor: pointer;\n}\n.modal .close[data-v-c8be41f0]:hover {\n      text-decoration: underline;\n      color: #555;\n}\n.res-type[data-v-c8be41f0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 20px;\n  margin-bottom: 10px;\n}\n.res-type div[data-v-c8be41f0] {\n    color: #bbb;\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n    border-bottom: 2px solid transparent;\n}\n.res-type div.active[data-v-c8be41f0] {\n      color: #2071db;\n      border-bottom-color: #2071db;\n}\n.status[data-v-c8be41f0] {\n  text-transform: uppercase;\n  letter-spacing: .4px;\n  background: #666;\n}\n@media only screen and (max-width: 430px) {\n.fix-footer .row[data-v-c8be41f0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.fix-footer .per-page[data-v-c8be41f0] {\n    width: auto;\n}\n.fix-footer .per-page select[data-v-c8be41f0] {\n      width: 55px;\n}\n.fix-footer .per-page span[data-v-c8be41f0]:nth-child(3) {\n      display: none;\n}\n.fix-footer .page-data[data-v-c8be41f0] {\n    display: none;\n}\n.fix-footer .pagination[data-v-c8be41f0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    padding: 15px 0px;\n    margin-right: 15%;\n}\n.fix-footer .pagination select[data-v-c8be41f0] {\n      width: 55px;\n}\n.loader[data-v-c8be41f0], .empty-result[data-v-c8be41f0] {\n    text-align: center;\n    padding: 50px 0;\n}\n.cards[data-v-c8be41f0] {\n    width: 90%;\n    margin: 0 auto;\n    margin-top: 20px;\n}\n.cards .result-stat[data-v-c8be41f0] {\n      width: 100%;\n}\n.cards .card[data-v-c8be41f0] {\n      border: 1px solid #ccc;\n      margin-bottom: 15px;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n}\n.cards .card .info[data-v-c8be41f0] {\n        width: 100%;\n        padding-left: 10px;\n}\n.cards .card > div[data-v-c8be41f0] {\n        margin-bottom: 3px;\n}\n.cards .card .email-logo img[data-v-c8be41f0] {\n        max-width: 100px;\n        max-height: 100px;\n}\n.cards .card .card-header[data-v-c8be41f0] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: start;\n            -ms-flex-pack: start;\n                justify-content: flex-start;\n        -webkit-box-align: start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n}\n.cards .card .card-header input[data-v-c8be41f0] {\n          margin-top: 5px;\n          cursor: pointer;\n          width: auto;\n          margin-right: 5px;\n}\n.cards .card .card-header .type[data-v-c8be41f0] {\n          display: inline-block;\n          padding: 3px 6px;\n          text-transform: uppercase;\n          border-radius: 4px;\n          color: #fff;\n          font-size: 11px;\n          font-weight: 600;\n}\n.cards .card .card-header .type.tnc[data-v-c8be41f0] {\n            background: #2ab77c;\n}\n.cards .card .card-header .type.tcp[data-v-c8be41f0] {\n            background: #3f81a0;\n}\n.cards .card .card-header .type.psc[data-v-c8be41f0] {\n            background: #de6c2a;\n}\n.cards .card .credit-card[data-v-c8be41f0] {\n        font-weight: 900;\n}\n.cards .card .title[data-v-c8be41f0] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        margin-bottom: 3px;\n}\n.cards .card .title input[data-v-c8be41f0] {\n          margin-right: 5px;\n}\n.cards .card .title.btn[data-v-c8be41f0] {\n          text-align: center;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n          margin-top: 15px;\n          margin-bottom: 10px;\n}\n.cards .card .title.btn .button[data-v-c8be41f0] {\n            padding: 10px 20px;\n}\n.cards .card .label[data-v-c8be41f0] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards .card .value[data-v-c8be41f0] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards .card .value i[data-v-c8be41f0] {\n          color: #bbb;\n}\n.cards .card .value a[data-v-c8be41f0] {\n          text-decoration: none;\n}\n.modal .modal-content .content-box[data-v-c8be41f0] {\n    width: auto;\n    padding: 25px 25px 70px;\n}\n.modal .modal-content .content-box h1[data-v-c8be41f0] {\n      font-size: 28px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-table outside"},[(!_vm.isMobile)?_c('div',{staticClass:"scroll-table"},[_c('table',{staticClass:"main-table"},[_c('thead',[_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'name'},on:{"click":function($event){return _vm.sort('name')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.availability.businessName'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'name'),expression:"currentOrder.field === 'name'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'license'},on:{"click":function($event){return _vm.sort('license')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.availability.type'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'license'),expression:"currentOrder.field === 'license'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'sector'},on:{"click":function($event){return _vm.sort('sector')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.availability.homeSector'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'sector'),expression:"currentOrder.field === 'sector'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',[_vm._v("Service")]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'vehicle'},on:{"click":function($event){return _vm.sort('vehicle')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.availability.vehicle'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'vehicle'),expression:"currentOrder.field === 'vehicle'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('provider.availability.phone')))])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.users),function(user,index){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDriver(index)),expression:"showDriver(index)"}],key:index},[_c('td',[_c('a',{attrs:{"href":'/#/provider/' + user.id,"target":"_blank"}},[_vm._v(_vm._s(user.name))])]),_vm._v(" "),_c('td',[_c('span',{class:['type', user.licenseType]},[_vm._v(_vm._s(user.licenseType))])]),_vm._v(" "),_c('td',{staticClass:"home-sector"},[_vm._v(_vm._s(user.homeSector))]),_vm._v(" "),_c('td',{staticClass:"pax-dtd"},[_vm._v(_vm._s(user.paxDtd))]),_vm._v(" "),_c('td',{staticClass:"vehicle-type"},[_vm._v(_vm._s(user.vehicleType))]),_vm._v(" "),_c('td',{staticClass:"mobile"},[_c('a',{on:{"click":function($event){return _vm.call(user)}}},[_vm._v(_vm._s(user.mobile))])])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading && _vm.users.length === 0),expression:"loading && users.length === 0"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"7"}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n                "+_vm._s(_vm.$t('consumer.list.gettingUsers'))+"\n              ")])])],1)]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.length === 0 && !_vm.loading),expression:"users.length === 0 && !loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"7"}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.length === 0 && !_vm.loading),expression:"users.length === 0 && !loading"}],staticClass:"empty-result"},[_c('i',{staticClass:"far fa-frown-open fa-3x"}),_c('br'),_vm._v("\n                No record found!~\n              ")])])],1)])],2)])]):_c('div',{staticClass:"cards"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading && _vm.users.length === 0),expression:"loading && users.length === 0"}],staticClass:"result-stat"},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n          "+_vm._s(_vm.$t('consumer.list.gettingUsers'))+"\n        ")])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.length === 0 && !_vm.loading),expression:"users.length === 0 && !loading"}],staticClass:"result-stat"},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.length === 0 && !_vm.loading),expression:"users.length === 0 && !loading"}],staticClass:"empty-result"},[_c('i',{staticClass:"far fa-frown-open fa-3x"}),_c('br'),_vm._v("\n          No record found!\n        ")])])],1),_vm._v(" "),_vm._l((_vm.users),function(user,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked),expression:"checked"}],staticClass:"checkbox",attrs:{"type":"checkbox"},domProps:{"value":user.id,"checked":Array.isArray(_vm.checked)?_vm._i(_vm.checked,user.id)>-1:(_vm.checked)},on:{"change":function($event){var $$a=_vm.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=user.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked=$$c}}}}),_vm._v(" "),_c('span',{class:['type', user.licenseType]},[_vm._v(_vm._s(user.licenseType))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.availability.businessName'))+": ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":'/#/provider/' + user.id,"target":"_blank"}},[_vm._v(_vm._s(user.name))])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.availability.homeSector'))+": ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(user.homeSector))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Service: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(user.paxDtd))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.availability.vehicle'))+": ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(user.vehicleType))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('provider.availability.phone'))+": ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{on:{"click":function($event){return _vm.call(user)}}},[_vm._v(_vm._s(user.mobile))])])])])})],2),_vm._v(" "),_c('div',{staticClass:"fix-footer"},[_c('div',{staticClass:"per-page"},[_c('span',[_vm._v("Displaying")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" "),_c('span',[_vm._v("per page")])]),_vm._v(" "),_c('div',{staticClass:"page-data"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.length > 0),expression:"users.length > 0"}]},[_vm._v("\n          Displaying\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.start))]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.pageData.end))]),_vm._v(" of\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.max))])])]),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('span',[_vm._v("Page")]),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.currentPage === 1 || _vm.loading},on:{"click":_vm.prev}},[_c('i',{staticClass:"fas fa-chevron-left"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentPage),expression:"currentPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.totalPage),function(i){return _c('option',{domProps:{"value":i}},[_vm._v(_vm._s(i))])}),0),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.isLastPage || _vm.loading},on:{"click":_vm.next}},[_c('i',{staticClass:"fas fa-chevron-right"})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"fixed-header"},[_c('div',{staticClass:"heading d-flex justify-space-between"},[_vm._v("\n      "+_vm._s(_vm.$t('provider.availability.title'))+"\n      "),_c('div',{staticClass:"send-buttons"},[_c('button',{staticClass:"button small warning notif-btn",on:{"click":_vm.showSenfNotif}},[_vm._v("Send Notification")]),_vm._v(" "),_c('button',{staticClass:"button small info sms-btn",on:{"click":_vm.showSendSMS}},[_c('i',{staticClass:"fas fa-comment-dots"}),_vm._v(" Send SMS")]),_vm._v(" "),(_vm.isMobile)?_c('button',{staticClass:"button small info filter-btn",on:{"click":_vm.showFilter}},[_c('i',{staticClass:"fas fa-filter"})]):_vm._e()])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('table-filter',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpenFilter),expression:"isOpenFilter"}],ref:"filter"})],1)],1),_vm._v(" "),_c('div',{class:{'tables-box':true, 'filterHide':!_vm.isOpenFilter}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobile ? !_vm.isOpenFilter : true),expression:"isMobile ? !isOpenFilter : true"}],staticClass:"export-box"},[_c('button',{staticClass:"button small success cta",on:{"click":function($event){_vm.xport.show = true}}},[_vm._v("Export")])]),_vm._v(" "),_c('driver-table',{staticClass:"tables",attrs:{"isMobile":_vm.isMobile}})],1),_vm._v(" "),_c('div',{class:['tables-box no-shift', {'filterHide':!_vm.isOpenFilter}]},[_c('div',{staticClass:"t-label"},[_vm._v("Drivers with no availability "),_c('span',[_vm._v("("+_vm._s(_vm.dateToday)+")")])]),_vm._v(" "),_c('no-shift-table',{staticClass:"tables",attrs:{"isMobile":_vm.isMobile}})],1),_vm._v(" "),_c('notification-modal',{ref:"notif",attrs:{"isList":true,"provId":_vm.checked,"showGeofenceOption":true,"removeAllActiveUserOption":true,"hideTargetOption":false}}),_vm._v(" "),_c('sms-modal',{ref:"sms",attrs:{"isList":true,"provId":_vm.checked,"showGeofenceOption":true,"removeAllActiveUserOption":true,"hideTargetOption":false}}),_vm._v(" "),_c('div',{class:['modal', {'show':_vm.xport.show}]},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeExport}}),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.xport.loading && !_vm.xport.success),expression:"xport.loading && !xport.success"}],staticClass:"loading-box"},[_c('i',{staticClass:"fa fa-circle-notch fa-spin"}),_vm._v("\n        Loading...\n      ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.xport.loading && !_vm.xport.success),expression:"!xport.loading && !xport.success"}],staticClass:"flight-error"},[_c('span',{staticClass:"title"},[_vm._v("Select which file to export:")]),_vm._v(" "),_c('div',{staticClass:"file-type"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.xport.pdf),expression:"xport.pdf"}],attrs:{"type":"checkbox","id":"pdf"},domProps:{"checked":Array.isArray(_vm.xport.pdf)?_vm._i(_vm.xport.pdf,null)>-1:(_vm.xport.pdf)},on:{"change":function($event){var $$a=_vm.xport.pdf,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.xport, "pdf", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.xport, "pdf", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.xport, "pdf", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"pdf"}},[_vm._v("PDF")])]),_vm._v(" "),_c('div',{staticClass:"file-type"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.xport.csv),expression:"xport.csv"}],attrs:{"type":"checkbox","id":"csv"},domProps:{"checked":Array.isArray(_vm.xport.csv)?_vm._i(_vm.xport.csv,null)>-1:(_vm.xport.csv)},on:{"change":function($event){var $$a=_vm.xport.csv,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.xport, "csv", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.xport, "csv", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.xport, "csv", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"csv"}},[_vm._v("CSV")])])]),_vm._v(" "),(!!_vm.xport.error)?_c('div',{staticClass:"error-box"},[_vm._v(_vm._s(_vm.xport.error))]):_vm._e(),_vm._v(" "),(!_vm.xport.success)?_c('div',{staticClass:"row action"},[_c('div',{staticClass:"small-6 columns"},[_c('a',{class:['button cta block small', {disabled:_vm.xport.loading}],attrs:{"href":"javascript:;"},on:{"click":_vm.closeExport}},[_vm._v("\n            CANCEL\n          ")])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('a',{class:['button cta warning block small', {disabled:_vm.xport.loading}],attrs:{"href":"javascript:;"},on:{"click":_vm.beginExport}},[_vm._v("\n            EXPORT\n          ")])])]):_vm._e(),_vm._v(" "),(_vm.xport.success)?_c('div',{staticClass:"success"},[_c('i',{staticClass:"fas fa-check-circle fa-fw fa-3x"}),_vm._v(" "),_c('span',[_vm._v("Export Success!")]),_vm._v(" "),_c('div',[_c('a',{staticClass:"button cta block small",attrs:{"href":"javascript:;"},on:{"click":_vm.closeExport}},[_vm._v("CLOSE")])])]):_vm._e()])]),_vm._v(" "),_c('div',{attrs:{"id":"pdf-view"}},_vm._l((_vm.xport.data),function(pageData,pageIndex){return _c('div',{class:['page', pageIndex]},[_c('div',{staticClass:"title"},[_vm._v("Provider Availability")]),_vm._v(" "),_c('div',{staticClass:"row filters-box"},[_c('div',{staticClass:"small-4 columns"},[_c('label',[_vm._v("Work Sector")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.workSector))])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[_c('label',[_vm._v("Start Date")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.startDate))])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[_c('label',[_vm._v("End Date")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.endDate))])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[_c('label',[_vm._v("Type")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm._type))])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[_c('label',[_vm._v("Service")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.tableFilter.service || 'All'))])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[_c('label',[_vm._v("Assignment")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.assigned))])])]),_vm._v(" "),_c('table',[_vm._m(0,true),_vm._v(" "),_c('tbody',_vm._l((pageData),function(data,index){return _c('tr',{key:index},_vm._l((data),function(value,i){return _c('td',{key:i,class:[i]},[_vm._v(_vm._s(value))])}),0)}),0)]),_vm._v(" "),_c('div',{staticClass:"page-count"},[_vm._v("page "+_vm._s(_vm.currentPage(pageIndex))+" of "+_vm._s(_vm.totalPage))])])}),0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("Business Name")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Home Sector")]),_vm._v(" "),_c('th',[_vm._v("Service")]),_vm._v(" "),_c('th',[_vm._v("Vehicle Type")]),_vm._v(" "),_c('th',[_vm._v("Available From")]),_vm._v(" "),_c('th',[_vm._v("Available Until")]),_vm._v(" "),_c('th',[_vm._v("Phone")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(593);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb3b6a06_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1750);
function injectStyle (ssrContext) {
  __webpack_require__(1740)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bb3b6a06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb3b6a06_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1741);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5b99e0e0", content, true, {});

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.fixed-header[data-v-bb3b6a06] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 155px;\n}\n.heading[data-v-bb3b6a06] {\n  margin-left: 50px;\n  padding-left: 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.notif-btn[data-v-bb3b6a06], .sms-btn[data-v-bb3b6a06], .filter-btn[data-v-bb3b6a06] {\n  margin: 7px 10px;\n}\n.sms-btn[data-v-bb3b6a06] {\n  background-color: #16b0de;\n}\n.filter-btn[data-v-bb3b6a06] {\n  background-color: gray;\n}\n.tables-box[data-v-bb3b6a06] {\n  margin-top: 153px;\n  padding: 30px 40px;\n  height: calc(100vh - 153px);\n  overflow: auto;\n}\n.tables-box .table-label[data-v-bb3b6a06] {\n    font-size: 24px;\n    font-weight: 600;\n    color: #fff;\n    padding-left: 5px;\n    display: inline-block;\n}\n.tables-box .tables[data-v-bb3b6a06] {\n    margin-bottom: 50px;\n}\n.tables-box .table-header[data-v-bb3b6a06] {\n    background: #4a4a4a;\n    margin-bottom: 5px;\n    padding: 5px;\n}\n.tables-box .table-header .export-box[data-v-bb3b6a06] {\n      float: right;\n      padding: 4px 10px 0 0;\n}\n.tables-box .table-header .export-box .success[data-v-bb3b6a06] {\n        margin-right: 5px;\n}\n.sticky[data-v-bb3b6a06] {\n  position: fixed;\n  top: 153px;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  height: 50px;\n  z-index: 3;\n}\n.sticky tbody[data-v-bb3b6a06] {\n    visibility: hidden;\n}\n.main-table[data-v-bb3b6a06] {\n  margin: 153px 0 70px;\n}\ntable[data-v-bb3b6a06] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-bb3b6a06] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-bb3b6a06] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-bb3b6a06] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-bb3b6a06] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-bb3b6a06] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-bb3b6a06] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-bb3b6a06] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-bb3b6a06] {\n          color: #ccc;\n}\ntable input[data-v-bb3b6a06] {\n    display: inline-block;\n    width: auto;\n}\ntable .type[data-v-bb3b6a06] {\n    display: inline-block;\n    padding: 3px 6px;\n    text-transform: uppercase;\n    border-radius: 4px;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 600;\n}\ntable .type.tnc[data-v-bb3b6a06] {\n      background: #2ab77c;\n}\ntable .type.tcp[data-v-bb3b6a06] {\n      background: #3f81a0;\n}\ntable .type.psc[data-v-bb3b6a06] {\n      background: #de6c2a;\n}\ntable .status[data-v-bb3b6a06] {\n    text-transform: capitalize;\n}\ntable .expired[data-v-bb3b6a06] {\n    color: #de2929;\n}\ntable .fa-check-circle[data-v-bb3b6a06] {\n    color: #0fda4e;\n}\ntable .fa-times-circle[data-v-bb3b6a06] {\n    color: #ef3535;\n}\ntable a[data-v-bb3b6a06] {\n    cursor: pointer;\n}\ntable .date[data-v-bb3b6a06] {\n    word-spacing: 5px;\n}\n.announcement-check[data-v-bb3b6a06] {\n  margin-bottom: 5px !important;\n  padding-left: 2px;\n}\ninput[type=\"checkbox\"][data-v-bb3b6a06] {\n  width: auto;\n  margin-top: 0;\n}\n.fix-footer[data-v-bb3b6a06] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 60px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-bb3b6a06] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-bb3b6a06] {\n    max-width: 100px;\n}\n.fix-footer .per-page[data-v-bb3b6a06] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .per-page span[data-v-bb3b6a06] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-bb3b6a06] {\n    text-align: center;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .pagination[data-v-bb3b6a06] {\n    text-align: right;\n    padding: 15px 10px;\n}\n.fix-footer .pagination span[data-v-bb3b6a06] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-bb3b6a06] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-bb3b6a06] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-bb3b6a06] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-bb3b6a06] {\n        opacity: .4;\n        cursor: default;\n}\n.data-field[data-v-bb3b6a06] {\n  position: relative;\n  margin-bottom: 20px;\n}\n.data-field .label[data-v-bb3b6a06] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 130%;\n    margin-bottom: 3px;\n}\n.data-field .label.has-error[data-v-bb3b6a06] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-bb3b6a06] {\n    margin: 5px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-bb3b6a06] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-bb3b6a06]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-bb3b6a06] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.op--modal-container[data-v-bb3b6a06] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-bb3b6a06] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal-container select[data-v-bb3b6a06] {\n    border: 1px solid #ddd;\n    padding: 5px 10px;\n    color: #333;\n    height: 35px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.op--modal-container select.has-error[data-v-bb3b6a06] {\n      border-color: #f20d0d;\n}\n.op--modal-container select[data-v-bb3b6a06]:disabled {\n      background-color: #eee;\n}\n.op--modal[data-v-bb3b6a06] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-bb3b6a06] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.notification-form[data-v-bb3b6a06] {\n  background-color: #fff;\n  max-width: 400px;\n  margin: 10px auto;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n.notification-form .header[data-v-bb3b6a06] {\n    background: #333;\n    color: #fff;\n    padding: 10px;\n    font-size: 18px;\n    text-align: center;\n}\n.notification-form .nf-content[data-v-bb3b6a06] {\n    padding: 20px;\n    position: relative;\n}\n.notification-form .nf-content .label[data-v-bb3b6a06] {\n      font-size: 13px;\n      color: #555;\n}\n.notification-form .nf-content label[data-v-bb3b6a06] {\n      display: block;\n      font-size: 14px;\n      color: #555;\n      margin-bottom: 2px;\n      cursor: pointer;\n}\n.notification-form .nf-content label input[data-v-bb3b6a06] {\n        display: inline-block;\n        vertical-align: middle;\n        margin-right: 5px;\n}\n.notification-form .nf-content .textarea-box[data-v-bb3b6a06] {\n      position: relative;\n      margin-bottom: 15px;\n      padding-bottom: 20px;\n}\n.notification-form .nf-content .textarea-box .emoji-trigger[data-v-bb3b6a06] {\n        position: absolute;\n        top: 133px;\n        right: 0;\n        color: #aaa;\n        cursor: pointer;\n}\n.notification-form .nf-content .textarea-box .error-msg[data-v-bb3b6a06] {\n        font-size: 11px;\n        line-height: 1.6;\n        color: #f20d0d;\n        font-style: italic;\n        display: block;\n}\n.notification-form .nf-content textarea[data-v-bb3b6a06] {\n      margin: 0;\n      padding: 10px;\n      width: 100%;\n      resize: none;\n      background: #fdfdfd;\n      font-size: 14px;\n      outline: none;\n      color: #333;\n      border-color: #ddd;\n      -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.05) inset;\n              box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.05) inset;\n      -webkit-transition: all .3s ease;\n      transition: all .3s ease;\n}\n.notification-form .nf-content textarea.exceed[data-v-bb3b6a06] {\n        border-color: #d61613;\n        background: #fff0f0;\n}\n.notification-form .nf-content .char-count[data-v-bb3b6a06] {\n      font-size: 12px;\n      color: #777;\n      display: block;\n      text-align: right;\n      line-height: 1;\n      margin-top: 5px;\n}\n.notification-form .nf-content .char-count.exceed[data-v-bb3b6a06] {\n        color: #f00;\n}\n.notification-form .nf-content .cancel-notif[data-v-bb3b6a06] {\n      display: block;\n      font-size: 13px;\n      margin: 10px 0 0;\n      text-align: center;\n      cursor: pointer;\n      color: #bbb;\n      -webkit-transition: all .5s ease;\n      transition: all .5s ease;\n}\n.notification-form .nf-content .cancel-notif[data-v-bb3b6a06]:hover {\n        color: #333;\n}\n.notification-form .nf-content .file-box[data-v-bb3b6a06] {\n      position: relative;\n}\n.notification-form .nf-content .file-box input[data-v-bb3b6a06] {\n        padding: 5px 25px 5px 5px;\n        margin: 0;\n        font-size: 14px;\n}\n.notification-form .nf-content .file-box i[data-v-bb3b6a06] {\n        position: absolute;\n        z-index: 2;\n        top: 50%;\n        right: 5px;\n        -webkit-transform: translateY(-50%);\n                transform: translateY(-50%);\n        color: #fd4a38;\n        cursor: pointer;\n}\n.notification-form .error[data-v-bb3b6a06] {\n    text-align: center;\n}\n.notification-form .error i[data-v-bb3b6a06] {\n      color: #fd4a38;\n}\n.notification-form .error p[data-v-bb3b6a06] {\n      margin: 5px 0 20px;\n}\n.notification-form .error code[data-v-bb3b6a06] {\n      border: 2px solid #fd4a38;\n      padding: 10px;\n      width: 100%;\n      display: block;\n      font-size: 14px;\n      background: #ffeeec;\n      border-radius: 3px;\n      margin-bottom: 30px;\n}\n.notification-form .success-box[data-v-bb3b6a06] {\n    text-align: center;\n}\n.notification-form .success-box i[data-v-bb3b6a06] {\n      color: #26d97a;\n}\n.notification-form .loader[data-v-bb3b6a06] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.3);\n}\n.notification-form .loader div[data-v-bb3b6a06] {\n      position: absolute;\n      top: 50%;\n      left: 0;\n      height: 50px;\n      width: 100%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      text-align: center;\n}\n.notification-form .loader div i[data-v-bb3b6a06] {\n        color: #45e7f9;\n}\n.notification-form .loader div span[data-v-bb3b6a06] {\n        color: #fff;\n        font-size: 21px;\n        font-weight: 600;\n        margin-left: 5px;\n        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);\n}\n.emoji-box[data-v-bb3b6a06] {\n  position: absolute;\n  top: 0;\n  left: 100%;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n}\n.slide-up-enter-active[data-v-bb3b6a06],\n.slide-up-leave-active[data-v-bb3b6a06] {\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n.slide-up-enter[data-v-bb3b6a06],\n.slide-up-leave-to[data-v-bb3b6a06] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.slide-down-enter-active[data-v-bb3b6a06],\n.slide-down-leave-active[data-v-bb3b6a06] {\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.slide-down-enter[data-v-bb3b6a06],\n.slide-down-leave-to[data-v-bb3b6a06] {\n  -webkit-transform: translateY(-5px);\n          transform: translateY(-5px);\n  opacity: 0;\n}\n.pop-enter-active[data-v-bb3b6a06], .pop-leave-active[data-v-bb3b6a06] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.pop-enter[data-v-bb3b6a06], .pop-leave-to[data-v-bb3b6a06] {\n  -webkit-transform: scale(0.8);\n          transform: scale(0.8);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.fixed-header[data-v-bb3b6a06] {\n    position: absolute;\n    height: 0;\n}\n.heading[data-v-bb3b6a06] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.heading .send-buttons[data-v-bb3b6a06] {\n      margin-left: -60px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.small-3[data-v-bb3b6a06] {\n    width: 100%;\n}\n.tables-box[data-v-bb3b6a06] {\n    margin-top: 330px;\n    z-index: 1;\n    padding: 10px;\n}\n.tables-box .table[data-v-bb3b6a06] {\n      margin-bottom: 30px;\n}\n.tables-box .table-header .export-box .success[data-v-bb3b6a06] {\n      margin-right: 0;\n}\n.tables-box.filterHide[data-v-bb3b6a06] {\n      margin-top: 190px;\n      height: calc(100vh - 190px);\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Provider/List.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;MACtB,uBAAuB;UACnB,+BAA+B;CACxC;AACD;EACE,iBAAiB;CAClB;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,uBAAuB;CACxB;AACD;EACE,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;CAChB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;CACzB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;CAChB;AACD;MACM,aAAa;MACb,sBAAsB;CAC3B;AACD;QACQ,kBAAkB;CACzB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,WAAW;CACZ;AACD;IACI,mBAAmB;CACtB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,0BAA0B;EAC1B,YAAY;CACb;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,2BAA2B;CAChC;AACD;QACQ,iBAAiB;CACxB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;IACI,sBAAsB;IACtB,YAAY;CACf;AACD;IACI,sBAAsB;IACtB,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;CACpB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;IACI,2BAA2B;CAC9B;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,kBAAkB;CACrB;AACD;EACE,8BAA8B;EAC9B,kBAAkB;CACnB;AACD;EACE,YAAY;EACZ,cAAc;CACf;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;CACb;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;CACnB;AACD;MACM,sBAAsB;MACtB,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;CACnB;AACD;IACI,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,kBAAkB;CACvB;AACD;MACM,aAAa;MACb,uBAAuB;CAC5B;AACD;MACM,cAAc;MACd,eAAe;MACf,uBAAuB;MACvB,iBAAiB;MACjB,gBAAgB;MAChB,uBAAuB;MACvB,aAAa;CAClB;AACD;QACQ,kBAAkB;CACzB;AACD;QACQ,YAAY;QACZ,gBAAgB;CACvB;AACD;EACE,mBAAmB;EACnB,oBAAoB;CACrB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,WAAW;EACX,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;IACI,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,wDAAwD;IACxD,6BAA6B;IAC7B,+BAA+B;IAC/B,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,uBAAuB;CAC5B;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;UACzC,yCAAyC;CAClD;AACD;IACI,iBAAiB;IACjB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,mBAAmB;CACtB;AACD;IACI,cAAc;IACd,mBAAmB;CACtB;AACD;MACM,gBAAgB;MAChB,YAAY;CACjB;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,YAAY;MACZ,mBAAmB;MACnB,gBAAgB;CACrB;AACD;QACQ,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;CACzB;AACD;MACM,mBAAmB;MACnB,oBAAoB;MACpB,qBAAqB;CAC1B;AACD;QACQ,mBAAmB;QACnB,WAAW;QACX,SAAS;QACT,YAAY;QACZ,gBAAgB;CACvB;AACD;QACQ,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;QACf,mBAAmB;QACnB,eAAe;CACtB;AACD;MACM,UAAU;MACV,cAAc;MACd,YAAY;MACZ,aAAa;MACb,oBAAoB;MACpB,gBAAgB;MAChB,cAAc;MACd,YAAY;MACZ,mBAAmB;MACnB,0DAA0D;cAClD,kDAAkD;MAC1D,iCAAiC;MACjC,yBAAyB;CAC9B;AACD;QACQ,sBAAsB;QACtB,oBAAoB;CAC3B;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,eAAe;MACf,kBAAkB;MAClB,eAAe;MACf,gBAAgB;CACrB;AACD;QACQ,YAAY;CACnB;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,mBAAmB;MACnB,gBAAgB;MAChB,YAAY;MACZ,iCAAiC;MACjC,yBAAyB;CAC9B;AACD;QACQ,YAAY;CACnB;AACD;MACM,mBAAmB;CACxB;AACD;QACQ,0BAA0B;QAC1B,UAAU;QACV,gBAAgB;CACvB;AACD;QACQ,mBAAmB;QACnB,WAAW;QACX,SAAS;QACT,WAAW;QACX,oCAAoC;gBAC5B,4BAA4B;QACpC,eAAe;QACf,gBAAgB;CACvB;AACD;IACI,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,0BAA0B;MAC1B,cAAc;MACd,YAAY;MACZ,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,mBAAmB;MACnB,oBAAoB;CACzB;AACD;IACI,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,aAAa;IACb,+BAA+B;CAClC;AACD;MACM,mBAAmB;MACnB,SAAS;MACT,QAAQ;MACR,aAAa;MACb,YAAY;MACZ,oCAAoC;cAC5B,4BAA4B;MACpC,mBAAmB;CACxB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;QACjB,4CAA4C;CACnD;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;CACd;AACD;;EAEE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;;EAEE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;;EAEE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;;EAEE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,8BAA8B;UACtB,sBAAsB;EAC9B,WAAW;CACZ;AACD;AACA;IACI,mBAAmB;IACnB,UAAU;CACb;AACD;IACI,6BAA6B;IAC7B,8BAA8B;QAC1B,2BAA2B;YACvB,uBAAuB;CAClC;AACD;MACM,mBAAmB;MACnB,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,yBAAyB;UACrB,sBAAsB;cAClB,wBAAwB;CACrC;AACD;IACI,YAAY;CACf;AACD;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;CACjB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,kBAAkB;MAClB,4BAA4B;CACjC;CACA","file":"List.vue","sourcesContent":["\n.fixed-header[data-v-bb3b6a06] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 155px;\n}\n.heading[data-v-bb3b6a06] {\n  margin-left: 50px;\n  padding-left: 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.notif-btn[data-v-bb3b6a06], .sms-btn[data-v-bb3b6a06], .filter-btn[data-v-bb3b6a06] {\n  margin: 7px 10px;\n}\n.sms-btn[data-v-bb3b6a06] {\n  background-color: #16b0de;\n}\n.filter-btn[data-v-bb3b6a06] {\n  background-color: gray;\n}\n.tables-box[data-v-bb3b6a06] {\n  margin-top: 153px;\n  padding: 30px 40px;\n  height: calc(100vh - 153px);\n  overflow: auto;\n}\n.tables-box .table-label[data-v-bb3b6a06] {\n    font-size: 24px;\n    font-weight: 600;\n    color: #fff;\n    padding-left: 5px;\n    display: inline-block;\n}\n.tables-box .tables[data-v-bb3b6a06] {\n    margin-bottom: 50px;\n}\n.tables-box .table-header[data-v-bb3b6a06] {\n    background: #4a4a4a;\n    margin-bottom: 5px;\n    padding: 5px;\n}\n.tables-box .table-header .export-box[data-v-bb3b6a06] {\n      float: right;\n      padding: 4px 10px 0 0;\n}\n.tables-box .table-header .export-box .success[data-v-bb3b6a06] {\n        margin-right: 5px;\n}\n.sticky[data-v-bb3b6a06] {\n  position: fixed;\n  top: 153px;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  height: 50px;\n  z-index: 3;\n}\n.sticky tbody[data-v-bb3b6a06] {\n    visibility: hidden;\n}\n.main-table[data-v-bb3b6a06] {\n  margin: 153px 0 70px;\n}\ntable[data-v-bb3b6a06] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-bb3b6a06] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-bb3b6a06] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-bb3b6a06] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-bb3b6a06] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-bb3b6a06] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-bb3b6a06] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-bb3b6a06] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-bb3b6a06] {\n          color: #ccc;\n}\ntable input[data-v-bb3b6a06] {\n    display: inline-block;\n    width: auto;\n}\ntable .type[data-v-bb3b6a06] {\n    display: inline-block;\n    padding: 3px 6px;\n    text-transform: uppercase;\n    border-radius: 4px;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 600;\n}\ntable .type.tnc[data-v-bb3b6a06] {\n      background: #2ab77c;\n}\ntable .type.tcp[data-v-bb3b6a06] {\n      background: #3f81a0;\n}\ntable .type.psc[data-v-bb3b6a06] {\n      background: #de6c2a;\n}\ntable .status[data-v-bb3b6a06] {\n    text-transform: capitalize;\n}\ntable .expired[data-v-bb3b6a06] {\n    color: #de2929;\n}\ntable .fa-check-circle[data-v-bb3b6a06] {\n    color: #0fda4e;\n}\ntable .fa-times-circle[data-v-bb3b6a06] {\n    color: #ef3535;\n}\ntable a[data-v-bb3b6a06] {\n    cursor: pointer;\n}\ntable .date[data-v-bb3b6a06] {\n    word-spacing: 5px;\n}\n.announcement-check[data-v-bb3b6a06] {\n  margin-bottom: 5px !important;\n  padding-left: 2px;\n}\ninput[type=\"checkbox\"][data-v-bb3b6a06] {\n  width: auto;\n  margin-top: 0;\n}\n.fix-footer[data-v-bb3b6a06] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 60px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-bb3b6a06] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-bb3b6a06] {\n    max-width: 100px;\n}\n.fix-footer .per-page[data-v-bb3b6a06] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .per-page span[data-v-bb3b6a06] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-bb3b6a06] {\n    text-align: center;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .pagination[data-v-bb3b6a06] {\n    text-align: right;\n    padding: 15px 10px;\n}\n.fix-footer .pagination span[data-v-bb3b6a06] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-bb3b6a06] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-bb3b6a06] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-bb3b6a06] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-bb3b6a06] {\n        opacity: .4;\n        cursor: default;\n}\n.data-field[data-v-bb3b6a06] {\n  position: relative;\n  margin-bottom: 20px;\n}\n.data-field .label[data-v-bb3b6a06] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 130%;\n    margin-bottom: 3px;\n}\n.data-field .label.has-error[data-v-bb3b6a06] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-bb3b6a06] {\n    margin: 5px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-bb3b6a06] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-bb3b6a06]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-bb3b6a06] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.op--modal-container[data-v-bb3b6a06] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-bb3b6a06] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal-container select[data-v-bb3b6a06] {\n    border: 1px solid #ddd;\n    padding: 5px 10px;\n    color: #333;\n    height: 35px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.op--modal-container select.has-error[data-v-bb3b6a06] {\n      border-color: #f20d0d;\n}\n.op--modal-container select[data-v-bb3b6a06]:disabled {\n      background-color: #eee;\n}\n.op--modal[data-v-bb3b6a06] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-bb3b6a06] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.notification-form[data-v-bb3b6a06] {\n  background-color: #fff;\n  max-width: 400px;\n  margin: 10px auto;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n.notification-form .header[data-v-bb3b6a06] {\n    background: #333;\n    color: #fff;\n    padding: 10px;\n    font-size: 18px;\n    text-align: center;\n}\n.notification-form .nf-content[data-v-bb3b6a06] {\n    padding: 20px;\n    position: relative;\n}\n.notification-form .nf-content .label[data-v-bb3b6a06] {\n      font-size: 13px;\n      color: #555;\n}\n.notification-form .nf-content label[data-v-bb3b6a06] {\n      display: block;\n      font-size: 14px;\n      color: #555;\n      margin-bottom: 2px;\n      cursor: pointer;\n}\n.notification-form .nf-content label input[data-v-bb3b6a06] {\n        display: inline-block;\n        vertical-align: middle;\n        margin-right: 5px;\n}\n.notification-form .nf-content .textarea-box[data-v-bb3b6a06] {\n      position: relative;\n      margin-bottom: 15px;\n      padding-bottom: 20px;\n}\n.notification-form .nf-content .textarea-box .emoji-trigger[data-v-bb3b6a06] {\n        position: absolute;\n        top: 133px;\n        right: 0;\n        color: #aaa;\n        cursor: pointer;\n}\n.notification-form .nf-content .textarea-box .error-msg[data-v-bb3b6a06] {\n        font-size: 11px;\n        line-height: 1.6;\n        color: #f20d0d;\n        font-style: italic;\n        display: block;\n}\n.notification-form .nf-content textarea[data-v-bb3b6a06] {\n      margin: 0;\n      padding: 10px;\n      width: 100%;\n      resize: none;\n      background: #fdfdfd;\n      font-size: 14px;\n      outline: none;\n      color: #333;\n      border-color: #ddd;\n      -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.05) inset;\n              box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.05) inset;\n      -webkit-transition: all .3s ease;\n      transition: all .3s ease;\n}\n.notification-form .nf-content textarea.exceed[data-v-bb3b6a06] {\n        border-color: #d61613;\n        background: #fff0f0;\n}\n.notification-form .nf-content .char-count[data-v-bb3b6a06] {\n      font-size: 12px;\n      color: #777;\n      display: block;\n      text-align: right;\n      line-height: 1;\n      margin-top: 5px;\n}\n.notification-form .nf-content .char-count.exceed[data-v-bb3b6a06] {\n        color: #f00;\n}\n.notification-form .nf-content .cancel-notif[data-v-bb3b6a06] {\n      display: block;\n      font-size: 13px;\n      margin: 10px 0 0;\n      text-align: center;\n      cursor: pointer;\n      color: #bbb;\n      -webkit-transition: all .5s ease;\n      transition: all .5s ease;\n}\n.notification-form .nf-content .cancel-notif[data-v-bb3b6a06]:hover {\n        color: #333;\n}\n.notification-form .nf-content .file-box[data-v-bb3b6a06] {\n      position: relative;\n}\n.notification-form .nf-content .file-box input[data-v-bb3b6a06] {\n        padding: 5px 25px 5px 5px;\n        margin: 0;\n        font-size: 14px;\n}\n.notification-form .nf-content .file-box i[data-v-bb3b6a06] {\n        position: absolute;\n        z-index: 2;\n        top: 50%;\n        right: 5px;\n        -webkit-transform: translateY(-50%);\n                transform: translateY(-50%);\n        color: #fd4a38;\n        cursor: pointer;\n}\n.notification-form .error[data-v-bb3b6a06] {\n    text-align: center;\n}\n.notification-form .error i[data-v-bb3b6a06] {\n      color: #fd4a38;\n}\n.notification-form .error p[data-v-bb3b6a06] {\n      margin: 5px 0 20px;\n}\n.notification-form .error code[data-v-bb3b6a06] {\n      border: 2px solid #fd4a38;\n      padding: 10px;\n      width: 100%;\n      display: block;\n      font-size: 14px;\n      background: #ffeeec;\n      border-radius: 3px;\n      margin-bottom: 30px;\n}\n.notification-form .success-box[data-v-bb3b6a06] {\n    text-align: center;\n}\n.notification-form .success-box i[data-v-bb3b6a06] {\n      color: #26d97a;\n}\n.notification-form .loader[data-v-bb3b6a06] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.3);\n}\n.notification-form .loader div[data-v-bb3b6a06] {\n      position: absolute;\n      top: 50%;\n      left: 0;\n      height: 50px;\n      width: 100%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      text-align: center;\n}\n.notification-form .loader div i[data-v-bb3b6a06] {\n        color: #45e7f9;\n}\n.notification-form .loader div span[data-v-bb3b6a06] {\n        color: #fff;\n        font-size: 21px;\n        font-weight: 600;\n        margin-left: 5px;\n        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);\n}\n.emoji-box[data-v-bb3b6a06] {\n  position: absolute;\n  top: 0;\n  left: 100%;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n}\n.slide-up-enter-active[data-v-bb3b6a06],\n.slide-up-leave-active[data-v-bb3b6a06] {\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n.slide-up-enter[data-v-bb3b6a06],\n.slide-up-leave-to[data-v-bb3b6a06] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n.slide-down-enter-active[data-v-bb3b6a06],\n.slide-down-leave-active[data-v-bb3b6a06] {\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.slide-down-enter[data-v-bb3b6a06],\n.slide-down-leave-to[data-v-bb3b6a06] {\n  -webkit-transform: translateY(-5px);\n          transform: translateY(-5px);\n  opacity: 0;\n}\n.pop-enter-active[data-v-bb3b6a06], .pop-leave-active[data-v-bb3b6a06] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.pop-enter[data-v-bb3b6a06], .pop-leave-to[data-v-bb3b6a06] {\n  -webkit-transform: scale(0.8);\n          transform: scale(0.8);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.fixed-header[data-v-bb3b6a06] {\n    position: absolute;\n    height: 0;\n}\n.heading[data-v-bb3b6a06] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.heading .send-buttons[data-v-bb3b6a06] {\n      margin-left: -60px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.small-3[data-v-bb3b6a06] {\n    width: 100%;\n}\n.tables-box[data-v-bb3b6a06] {\n    margin-top: 330px;\n    z-index: 1;\n    padding: 10px;\n}\n.tables-box .table[data-v-bb3b6a06] {\n      margin-bottom: 30px;\n}\n.tables-box .table-header .export-box .success[data-v-bb3b6a06] {\n      margin-right: 0;\n}\n.tables-box.filterHide[data-v-bb3b6a06] {\n      margin-top: 190px;\n      height: calc(100vh - 190px);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListFilter_vue__ = __webpack_require__(594);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25caa0aa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListFilter_vue__ = __webpack_require__(1745);
function injectStyle (ssrContext) {
  __webpack_require__(1743)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25caa0aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25caa0aa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1744);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("b7eba520", content, true, {});

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.filter[data-v-25caa0aa] {\n  border-bottom: 1px solid #bbb;\n  background: #fcfcfc;\n  margin-bottom: 10px;\n  border-radius: 2px;\n}\n.filter .row[data-v-25caa0aa] {\n    max-width: 100%;\n}\n.field-label[data-v-25caa0aa] {\n  font-size: 13px;\n  color: #999;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.search-box[data-v-25caa0aa] {\n  display: inline-block;\n  padding: 20px 0 20px 15px;\n  position: relative;\n  width: 100%;\n}\n.search-box .error-msg[data-v-25caa0aa] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: calc(100% - 15px);\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    margin-left: 15px;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: bottom center;\n            transform-origin: bottom center;\n}\n.search[data-v-25caa0aa] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.search .search-input-box[data-v-25caa0aa] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-25caa0aa] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 5px 0 0 5px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-25caa0aa] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-25caa0aa] {\n      position: absolute;\n      top: 0;\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n      line-height: 46px;\n}\n.search button[data-v-25caa0aa] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 5px 5px 0;\n    padding: 0 20px;\n}\n.status[data-v-25caa0aa] {\n  display: inline-block;\n  padding: 20px 0 20px 15px;\n  width: 100%;\n}\n.status.last[data-v-25caa0aa] {\n    padding-right: 3px;\n    padding-left: 3px;\n}\n.status.last button[data-v-25caa0aa] {\n      height: 46px;\n}\nselect[data-v-25caa0aa] {\n  padding: 10px;\n  height: 46px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-25caa0aa] {\n    background-color: #ebebe4;\n}\n.flex[data-v-25caa0aa] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.flex select[data-v-25caa0aa] {\n    -webkit-box-flex: 100;\n        -ms-flex-positive: 100;\n            flex-grow: 100;\n}\n.slide-left-enter-active[data-v-25caa0aa], .slide-left-leave-active[data-v-25caa0aa] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-left-enter[data-v-25caa0aa], .slide-left-leave-to[data-v-25caa0aa] {\n  -webkit-transform: translateX(30px);\n          transform: translateX(30px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.filter[data-v-25caa0aa] {\n    margin-top: 35px;\n    padding-bottom: 15px;\n}\n.status[data-v-25caa0aa] {\n    padding: 10px 0 0px 15px;\n}\n.status.last[data-v-25caa0aa] {\n      padding-right: 0px;\n      padding-left: 0px;\n}\n.small-3[data-v-25caa0aa] {\n    width: 100%;\n}\n.small-3 .search-box[data-v-25caa0aa] {\n      padding-right: 20px;\n      padding-bottom: 0;\n}\n.small-2[data-v-25caa0aa] {\n    width: 47%;\n}\n.small-offset-1[data-v-25caa0aa] {\n    float: none;\n    padding-left: 15px;\n    margin: 0;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Provider/ListFilter.vue"],"names":[],"mappings":";AACA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;CACpB;AACD;IACI,gBAAgB;CACnB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;CACpB;AACD;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;CACb;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,wCAAwC;YAChC,gCAAgC;CAC3C;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;CACb;AACD;IACI,YAAY;IACZ,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,uBAAuB;MACvB,cAAc;MACd,2BAA2B;MAC3B,oBAAoB;CACzB;AACD;QACQ,sBAAsB;CAC7B;AACD;MACM,mBAAmB;MACnB,OAAO;MACP,WAAW;MACX,eAAe;MACf,gBAAgB;MAChB,kBAAkB;CACvB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;CACnB;AACD;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;CACb;AACD;IACI,mBAAmB;IACnB,kBAAkB;CACrB;AACD;MACM,aAAa;CAClB;AACD;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,+BAA+B;CAChC;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,sBAAsB;QAClB,uBAAuB;YACnB,eAAe;CAC1B;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;AACA;IACI,iBAAiB;IACjB,qBAAqB;CACxB;AACD;IACI,yBAAyB;CAC5B;AACD;MACM,mBAAmB;MACnB,kBAAkB;CACvB;AACD;IACI,YAAY;CACf;AACD;MACM,oBAAoB;MACpB,kBAAkB;CACvB;AACD;IACI,WAAW;CACd;AACD;IACI,YAAY;IACZ,mBAAmB;IACnB,UAAU;CACb;CACA","file":"ListFilter.vue","sourcesContent":["\n.filter[data-v-25caa0aa] {\n  border-bottom: 1px solid #bbb;\n  background: #fcfcfc;\n  margin-bottom: 10px;\n  border-radius: 2px;\n}\n.filter .row[data-v-25caa0aa] {\n    max-width: 100%;\n}\n.field-label[data-v-25caa0aa] {\n  font-size: 13px;\n  color: #999;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.search-box[data-v-25caa0aa] {\n  display: inline-block;\n  padding: 20px 0 20px 15px;\n  position: relative;\n  width: 100%;\n}\n.search-box .error-msg[data-v-25caa0aa] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: calc(100% - 15px);\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    margin-left: 15px;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: bottom center;\n            transform-origin: bottom center;\n}\n.search[data-v-25caa0aa] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.search .search-input-box[data-v-25caa0aa] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-25caa0aa] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 5px 0 0 5px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-25caa0aa] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-25caa0aa] {\n      position: absolute;\n      top: 0;\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n      line-height: 46px;\n}\n.search button[data-v-25caa0aa] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 5px 5px 0;\n    padding: 0 20px;\n}\n.status[data-v-25caa0aa] {\n  display: inline-block;\n  padding: 20px 0 20px 15px;\n  width: 100%;\n}\n.status.last[data-v-25caa0aa] {\n    padding-right: 3px;\n    padding-left: 3px;\n}\n.status.last button[data-v-25caa0aa] {\n      height: 46px;\n}\nselect[data-v-25caa0aa] {\n  padding: 10px;\n  height: 46px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-25caa0aa] {\n    background-color: #ebebe4;\n}\n.flex[data-v-25caa0aa] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.flex select[data-v-25caa0aa] {\n    -webkit-box-flex: 100;\n        -ms-flex-positive: 100;\n            flex-grow: 100;\n}\n.slide-left-enter-active[data-v-25caa0aa], .slide-left-leave-active[data-v-25caa0aa] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-left-enter[data-v-25caa0aa], .slide-left-leave-to[data-v-25caa0aa] {\n  -webkit-transform: translateX(30px);\n          transform: translateX(30px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.filter[data-v-25caa0aa] {\n    margin-top: 35px;\n    padding-bottom: 15px;\n}\n.status[data-v-25caa0aa] {\n    padding: 10px 0 0px 15px;\n}\n.status.last[data-v-25caa0aa] {\n      padding-right: 0px;\n      padding-left: 0px;\n}\n.small-3[data-v-25caa0aa] {\n    width: 100%;\n}\n.small-3 .search-box[data-v-25caa0aa] {\n      padding-right: 20px;\n      padding-bottom: 0;\n}\n.small-2[data-v-25caa0aa] {\n    width: 47%;\n}\n.small-offset-1[data-v-25caa0aa] {\n    float: none;\n    padding-left: 15px;\n    margin: 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-3 columns"},[_c('div',{staticClass:"search-box"},[_c('label',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.$t('provider.list.filter.search'))+":")]),_vm._v(" "),_c('div',{staticClass:"search"},[_c('div',{staticClass:"search-input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],ref:"search",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.searchInput)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search.apply(null, arguments)},"blur":_vm.blurSearch,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-left"}},[(_vm.searchInput.length > 0)?_c('i',{staticClass:"far fa-times-circle fa-lg",on:{"click":_vm.clearSearch}}):_vm._e()])],1),_vm._v(" "),_c('button',{class:{'button xsmall success':true, 'disabled':_vm.loading},on:{"click":_vm.search}},[_c('i',{staticClass:"fas fa-search fa-lg"})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobile ? _vm.isOpen : true),expression:"isMobile ? isOpen : true"}]},[_c('div',{staticClass:"small-2 columns end"},[_c('div',{staticClass:"status"},[_c('label',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.$t('provider.list.filter.type'))+":")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.type),expression:"type"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v(_vm._s(_vm.$t('provider.list.filter.all')))]),_vm._v(" "),_c('option',{attrs:{"value":"tnc"}},[_vm._v(_vm._s(_vm.$t('provider.list.filter.tnc')))]),_vm._v(" "),_c('option',{attrs:{"value":"tcp"}},[_vm._v(_vm._s(_vm.$t('provider.list.filter.tcp')))]),_vm._v(" "),_c('option',{attrs:{"value":"psc"}},[_vm._v("PSC")])])])]),_vm._v(" "),_c('div',{staticClass:"small-2 columns end"},[_c('div',{staticClass:"status"},[_c('label',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.$t('provider.list.filter.status'))+":")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.statusTable),expression:"statusTable"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.statusTable=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"unarchived"}},[_vm._v(_vm._s(_vm.$t('provider.list.filter.allNonArchive')))]),_vm._v(" "),_c('option',{attrs:{"value":"activated"}},[_vm._v("Active (On/Off Road)")]),_vm._v(" "),_c('option',{attrs:{"value":"active"}},[_vm._v("On Road")]),_vm._v(" "),_c('option',{attrs:{"value":"inactive"}},[_vm._v("Off Road")]),_vm._v(" "),_c('option',{attrs:{"value":"pending"}},[_vm._v("Pending")]),_vm._v(" "),_c('option',{attrs:{"value":"deactivated"}},[_vm._v(_vm._s(_vm.$t('provider.list.filter.deactivated')))]),_vm._v(" "),_c('option',{attrs:{"value":"archived"}},[_vm._v(_vm._s(_vm.$t('provider.list.filter.archived')))])])])]),_vm._v(" "),_c('div',{staticClass:"small-2 columns end"},[_c('div',{staticClass:"status"},[_c('label',{staticClass:"field-label"},[_vm._v("Service:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.serviceFilter),expression:"serviceFilter"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.serviceFilter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("All")]),_vm._v(" "),_c('option',{attrs:{"value":"PAX"}},[_vm._v("PAX")]),_vm._v(" "),_c('option',{attrs:{"value":"DTD"}},[_vm._v("DTD")]),_vm._v(" "),_c('option',{attrs:{"value":"PAX/DTD"}},[_vm._v("PAX/DTD")])])])]),_vm._v(" "),_c('div',{staticClass:"small-2 columns end small-offset-1"},[_c('div',{staticClass:"status last"},[_c('label',{staticClass:"field-label"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"activate"}},[_vm._v(_vm._s(_vm.$t('provider.list.filter.activate')))]),_vm._v(" "),_c('option',{attrs:{"value":"deactivate"}},[_vm._v(_vm._s(_vm.$t('provider.list.filter.deactivate')))]),_vm._v(" "),_c('option',{attrs:{"value":"archive"}},[_vm._v(_vm._s(_vm.$t('provider.list.filter.archive')))])]),_vm._v(" "),_c('button',{class:{'button small success':true, 'disabled':_vm.loading},on:{"click":_vm.updateStatus}},[_vm._v("Go")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListTable_vue__ = __webpack_require__(595);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fcf7787_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListTable_vue__ = __webpack_require__(1749);
function injectStyle (ssrContext) {
  __webpack_require__(1747)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fcf7787"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fcf7787_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1748);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("33c4c460", content, true, {});

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.list-table[data-v-6fcf7787] {\n  border: 1px solid #aaa;\n  background: #fff;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);\n  position: relative;\n  min-height: 100px;\n  overflow: hidden;\n}\n.sticky[data-v-6fcf7787] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  height: 44px;\n  z-index: 3;\n}\n.sticky tbody[data-v-6fcf7787] {\n    visibility: hidden;\n}\n.scroll-table[data-v-6fcf7787] {\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: 400px;\n}\ntable[data-v-6fcf7787] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-6fcf7787] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-6fcf7787] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-6fcf7787] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-6fcf7787] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-6fcf7787] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-6fcf7787] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-6fcf7787] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-6fcf7787] {\n          color: #ccc;\n}\ntable input[data-v-6fcf7787] {\n    display: inline-block;\n    width: auto;\n}\ntable .type[data-v-6fcf7787] {\n    display: inline-block;\n    padding: 3px 6px;\n    text-transform: uppercase;\n    border-radius: 4px;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 600;\n}\ntable .type.tnc[data-v-6fcf7787] {\n      background: #2ab77c;\n}\ntable .type.tcp[data-v-6fcf7787] {\n      background: #3f81a0;\n}\ntable .type.psc[data-v-6fcf7787] {\n      background: #de6c2a;\n}\ntable .status[data-v-6fcf7787] {\n    text-transform: capitalize;\n}\ntable .expired[data-v-6fcf7787] {\n    color: #de2929;\n}\ntable .fa-check-circle[data-v-6fcf7787] {\n    color: #0fda4e;\n}\ntable .fa-times-circle[data-v-6fcf7787] {\n    color: #ef3535;\n}\ntable a[data-v-6fcf7787] {\n    cursor: pointer;\n}\ntable .date[data-v-6fcf7787] {\n    word-spacing: 5px;\n}\n.fix-footer[data-v-6fcf7787] {\n  width: 100%;\n  height: 60px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-6fcf7787] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-6fcf7787] {\n    max-width: 100px;\n}\n.fix-footer .per-page[data-v-6fcf7787] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .per-page span[data-v-6fcf7787] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-6fcf7787] {\n    text-align: center;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .pagination[data-v-6fcf7787] {\n    text-align: right;\n    padding: 15px 10px;\n}\n.fix-footer .pagination span[data-v-6fcf7787] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-6fcf7787] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-6fcf7787] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-6fcf7787] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-6fcf7787] {\n        opacity: .4;\n        cursor: default;\n}\n.stat-ico[data-v-6fcf7787] {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #dd2222;\n  margin-right: 5px;\n  vertical-align: -1px;\n}\n.stat-ico.onduty[data-v-6fcf7787] {\n    background: #22d728;\n}\n@media only screen and (max-width: 430px) {\n.loader[data-v-6fcf7787], .empty-result[data-v-6fcf7787] {\n    text-align: center;\n    padding: 30px;\n}\n.small-3[data-v-6fcf7787] {\n    width: 50%;\n}\n.fix-footer select[data-v-6fcf7787] {\n    max-width: 40px;\n}\n.cards .card[data-v-6fcf7787] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-size: 11px;\n}\n.cards .card > div[data-v-6fcf7787] {\n      margin-bottom: 1px;\n}\n.cards .card .card-header[data-v-6fcf7787] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .card-header .left[data-v-6fcf7787], .cards .card .card-header .right[data-v-6fcf7787] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        gap: 10px;\n        text-transform: uppercase;\n}\n.cards .card .card-header .left a[data-v-6fcf7787], .cards .card .card-header .right a[data-v-6fcf7787] {\n          font-weight: 900;\n}\n.cards .card .card-header .left .type[data-v-6fcf7787], .cards .card .card-header .right .type[data-v-6fcf7787] {\n          display: inline-block;\n          padding: 3px 6px;\n          text-transform: uppercase;\n          border-radius: 4px;\n          color: #fff;\n          font-size: 11px;\n          font-weight: 600;\n}\n.cards .card .card-header .left .type.tnc[data-v-6fcf7787], .cards .card .card-header .right .type.tnc[data-v-6fcf7787] {\n            background: #2ab77c;\n}\n.cards .card .card-header .left .type.tcp[data-v-6fcf7787], .cards .card .card-header .right .type.tcp[data-v-6fcf7787] {\n            background: #3f81a0;\n}\n.cards .card .card-header .left .type.psc[data-v-6fcf7787], .cards .card .card-header .right .type.psc[data-v-6fcf7787] {\n            background: #de6c2a;\n}\n.cards .card .card-header .left .status[data-v-6fcf7787], .cards .card .card-header .right .status[data-v-6fcf7787] {\n          font-weight: 900;\n}\n.cards .card .card-header .left .status.deactivated[data-v-6fcf7787], .cards .card .card-header .right .status.deactivated[data-v-6fcf7787] {\n            color: #de2929;\n}\n.cards .card .card-header .left .status.active[data-v-6fcf7787], .cards .card .card-header .right .status.active[data-v-6fcf7787] {\n            color: #2ab77c;\n}\n.cards .card .card-header .left .status.pending[data-v-6fcf7787], .cards .card .card-header .right .status.pending[data-v-6fcf7787] {\n            color: #de6c2a;\n}\n.cards .card .card-header .left .status.inactive[data-v-6fcf7787], .cards .card .card-header .right .status.inactive[data-v-6fcf7787] {\n            color: #bbb;\n}\n.cards .card .card-header .right[data-v-6fcf7787] {\n        gap: 5px;\n}\n.cards .card .card-header .right span[data-v-6fcf7787] {\n          color: #999;\n}\n.cards .card .card-header input[data-v-6fcf7787] {\n        display: inline-block;\n        width: auto;\n        margin: 0;\n}\n.cards .card .card-header .expired[data-v-6fcf7787] {\n        color: #de2929;\n}\n.cards .card .card-header .fa-check-circle[data-v-6fcf7787] {\n        color: #0fda4e;\n}\n.cards .card .card-header .fa-times-circle[data-v-6fcf7787] {\n        color: #ef3535;\n}\n.cards .card .title[data-v-6fcf7787] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .label[data-v-6fcf7787] {\n      font-size: 10px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-6fcf7787] {\n      margin-right: 10px;\n      font-size: 13px;\n      font-weight: 900;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Provider/ListTable.vue"],"names":[],"mappings":";AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;EACnD,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,WAAW;CACZ;AACD;IACI,mBAAmB;CACtB;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;CACnB;AACD;EACE,0BAA0B;EAC1B,YAAY;CACb;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,4CAA4C;IAC5C,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,2BAA2B;CAChC;AACD;QACQ,iBAAiB;CACxB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;IACI,sBAAsB;IACtB,YAAY;CACf;AACD;IACI,sBAAsB;IACtB,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;CACpB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;IACI,2BAA2B;CAC9B;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,kBAAkB;CACrB;AACD;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;CACb;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;CACnB;AACD;MACM,sBAAsB;MACtB,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;CACnB;AACD;IACI,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,kBAAkB;CACvB;AACD;MACM,aAAa;MACb,uBAAuB;CAC5B;AACD;MACM,cAAc;MACd,eAAe;MACf,uBAAuB;MACvB,iBAAiB;MACjB,gBAAgB;MAChB,uBAAuB;MACvB,aAAa;CAClB;AACD;QACQ,kBAAkB;CACzB;AACD;QACQ,YAAY;QACZ,gBAAgB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;CACtB;AACD;IACI,oBAAoB;CACvB;AACD;AACA;IACI,mBAAmB;IACnB,cAAc;CACjB;AACD;IACI,WAAW;CACd;AACD;IACI,gBAAgB;CACnB;AACD;IACI,uBAAuB;IACvB,oBAAoB;IACpB,aAAa;IACb,oBAAoB;IACpB,+BAA+B;IAC/B,oBAAoB;IACpB,gBAAgB;CACnB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,oBAAoB;QAC5B,UAAU;QACV,0BAA0B;CACjC;AACD;UACU,iBAAiB;CAC1B;AACD;UACU,sBAAsB;UACtB,iBAAiB;UACjB,0BAA0B;UAC1B,mBAAmB;UACnB,YAAY;UACZ,gBAAgB;UAChB,iBAAiB;CAC1B;AACD;YACY,oBAAoB;CAC/B;AACD;YACY,oBAAoB;CAC/B;AACD;YACY,oBAAoB;CAC/B;AACD;UACU,iBAAiB;CAC1B;AACD;YACY,eAAe;CAC1B;AACD;YACY,eAAe;CAC1B;AACD;YACY,eAAe;CAC1B;AACD;YACY,YAAY;CACvB;AACD;QACQ,SAAS;CAChB;AACD;UACU,YAAY;CACrB;AACD;QACQ,sBAAsB;QACtB,YAAY;QACZ,UAAU;CACjB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,eAAe;CACtB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;MACM,gBAAgB;MAChB,0BAA0B;MAC1B,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;CACvB;AACD;MACM,mBAAmB;MACnB,gBAAgB;MAChB,iBAAiB;CACtB;CACA","file":"ListTable.vue","sourcesContent":["\n.list-table[data-v-6fcf7787] {\n  border: 1px solid #aaa;\n  background: #fff;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);\n  position: relative;\n  min-height: 100px;\n  overflow: hidden;\n}\n.sticky[data-v-6fcf7787] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  height: 44px;\n  z-index: 3;\n}\n.sticky tbody[data-v-6fcf7787] {\n    visibility: hidden;\n}\n.scroll-table[data-v-6fcf7787] {\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: 400px;\n}\ntable[data-v-6fcf7787] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-6fcf7787] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-6fcf7787] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-6fcf7787] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-6fcf7787] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-6fcf7787] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-6fcf7787] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-6fcf7787] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-6fcf7787] {\n          color: #ccc;\n}\ntable input[data-v-6fcf7787] {\n    display: inline-block;\n    width: auto;\n}\ntable .type[data-v-6fcf7787] {\n    display: inline-block;\n    padding: 3px 6px;\n    text-transform: uppercase;\n    border-radius: 4px;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 600;\n}\ntable .type.tnc[data-v-6fcf7787] {\n      background: #2ab77c;\n}\ntable .type.tcp[data-v-6fcf7787] {\n      background: #3f81a0;\n}\ntable .type.psc[data-v-6fcf7787] {\n      background: #de6c2a;\n}\ntable .status[data-v-6fcf7787] {\n    text-transform: capitalize;\n}\ntable .expired[data-v-6fcf7787] {\n    color: #de2929;\n}\ntable .fa-check-circle[data-v-6fcf7787] {\n    color: #0fda4e;\n}\ntable .fa-times-circle[data-v-6fcf7787] {\n    color: #ef3535;\n}\ntable a[data-v-6fcf7787] {\n    cursor: pointer;\n}\ntable .date[data-v-6fcf7787] {\n    word-spacing: 5px;\n}\n.fix-footer[data-v-6fcf7787] {\n  width: 100%;\n  height: 60px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-6fcf7787] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-6fcf7787] {\n    max-width: 100px;\n}\n.fix-footer .per-page[data-v-6fcf7787] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .per-page span[data-v-6fcf7787] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-6fcf7787] {\n    text-align: center;\n    line-height: 30px;\n    padding: 15px 0;\n}\n.fix-footer .pagination[data-v-6fcf7787] {\n    text-align: right;\n    padding: 15px 10px;\n}\n.fix-footer .pagination span[data-v-6fcf7787] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-6fcf7787] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-6fcf7787] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-6fcf7787] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-6fcf7787] {\n        opacity: .4;\n        cursor: default;\n}\n.stat-ico[data-v-6fcf7787] {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #dd2222;\n  margin-right: 5px;\n  vertical-align: -1px;\n}\n.stat-ico.onduty[data-v-6fcf7787] {\n    background: #22d728;\n}\n@media only screen and (max-width: 430px) {\n.loader[data-v-6fcf7787], .empty-result[data-v-6fcf7787] {\n    text-align: center;\n    padding: 30px;\n}\n.small-3[data-v-6fcf7787] {\n    width: 50%;\n}\n.fix-footer select[data-v-6fcf7787] {\n    max-width: 40px;\n}\n.cards .card[data-v-6fcf7787] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-size: 11px;\n}\n.cards .card > div[data-v-6fcf7787] {\n      margin-bottom: 1px;\n}\n.cards .card .card-header[data-v-6fcf7787] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .card-header .left[data-v-6fcf7787], .cards .card .card-header .right[data-v-6fcf7787] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        gap: 10px;\n        text-transform: uppercase;\n}\n.cards .card .card-header .left a[data-v-6fcf7787], .cards .card .card-header .right a[data-v-6fcf7787] {\n          font-weight: 900;\n}\n.cards .card .card-header .left .type[data-v-6fcf7787], .cards .card .card-header .right .type[data-v-6fcf7787] {\n          display: inline-block;\n          padding: 3px 6px;\n          text-transform: uppercase;\n          border-radius: 4px;\n          color: #fff;\n          font-size: 11px;\n          font-weight: 600;\n}\n.cards .card .card-header .left .type.tnc[data-v-6fcf7787], .cards .card .card-header .right .type.tnc[data-v-6fcf7787] {\n            background: #2ab77c;\n}\n.cards .card .card-header .left .type.tcp[data-v-6fcf7787], .cards .card .card-header .right .type.tcp[data-v-6fcf7787] {\n            background: #3f81a0;\n}\n.cards .card .card-header .left .type.psc[data-v-6fcf7787], .cards .card .card-header .right .type.psc[data-v-6fcf7787] {\n            background: #de6c2a;\n}\n.cards .card .card-header .left .status[data-v-6fcf7787], .cards .card .card-header .right .status[data-v-6fcf7787] {\n          font-weight: 900;\n}\n.cards .card .card-header .left .status.deactivated[data-v-6fcf7787], .cards .card .card-header .right .status.deactivated[data-v-6fcf7787] {\n            color: #de2929;\n}\n.cards .card .card-header .left .status.active[data-v-6fcf7787], .cards .card .card-header .right .status.active[data-v-6fcf7787] {\n            color: #2ab77c;\n}\n.cards .card .card-header .left .status.pending[data-v-6fcf7787], .cards .card .card-header .right .status.pending[data-v-6fcf7787] {\n            color: #de6c2a;\n}\n.cards .card .card-header .left .status.inactive[data-v-6fcf7787], .cards .card .card-header .right .status.inactive[data-v-6fcf7787] {\n            color: #bbb;\n}\n.cards .card .card-header .right[data-v-6fcf7787] {\n        gap: 5px;\n}\n.cards .card .card-header .right span[data-v-6fcf7787] {\n          color: #999;\n}\n.cards .card .card-header input[data-v-6fcf7787] {\n        display: inline-block;\n        width: auto;\n        margin: 0;\n}\n.cards .card .card-header .expired[data-v-6fcf7787] {\n        color: #de2929;\n}\n.cards .card .card-header .fa-check-circle[data-v-6fcf7787] {\n        color: #0fda4e;\n}\n.cards .card .card-header .fa-times-circle[data-v-6fcf7787] {\n        color: #ef3535;\n}\n.cards .card .title[data-v-6fcf7787] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .label[data-v-6fcf7787] {\n      font-size: 10px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-6fcf7787] {\n      margin-right: 10px;\n      font-size: 13px;\n      font-weight: 900;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('div',{staticClass:"list-table"},[_c('div',{staticClass:"sticky"},[_c('table',[_c('thead',[_c('th',{staticClass:"status"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectAll),expression:"selectAll"}],attrs:{"type":"checkbox","disabled":_vm.loading},domProps:{"checked":Array.isArray(_vm.selectAll)?_vm._i(_vm.selectAll,null)>-1:(_vm.selectAll)},on:{"change":function($event){var $$a=_vm.selectAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectAll=$$c}}}})]),_vm._v(" "),_c('th',[_vm._v("Vehicle #")]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'businessName'},on:{"click":function($event){return _vm.sort('businessName')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.list.table.businessName'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'businessName'),expression:"currentOrder.field === 'businessName'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'licenseType'},on:{"click":function($event){return _vm.sort('licenseType')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.list.table.type'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'licenseType'),expression:"currentOrder.field === 'licenseType'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'accountStatus'},on:{"click":function($event){return _vm.sort('accountStatus')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.list.table.status'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'accountStatus'),expression:"currentOrder.field === 'accountStatus'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',[_vm._v("Service")]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'vehicleType'},on:{"click":function($event){return _vm.sort('vehicleType')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.list.table.vehicle'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'vehicleType'),expression:"currentOrder.field === 'vehicleType'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'wheelchair'},on:{"click":function($event){return _vm.sort('wheelchair')}}},[_vm._v("\n          ADA\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'wheelchair'),expression:"currentOrder.field === 'wheelchair'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'city'},on:{"click":function($event){return _vm.sort('city')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.list.table.city'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'city'),expression:"currentOrder.field === 'city'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('provider.list.table.phone')))]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'created'},on:{"click":function($event){return _vm.sort('created')}}},[_vm._v("\n          Created Date\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'created'),expression:"currentOrder.field === 'created'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'lastUpdate'},on:{"click":function($event){return _vm.sort('lastUpdate')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.list.table.lastUpdate'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'lastUpdate'),expression:"currentOrder.field === 'lastUpdate'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'lastLogin'},on:{"click":function($event){return _vm.sort('lastLogin')}}},[_vm._v("\n          Last On Duty\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'lastLogin'),expression:"currentOrder.field === 'lastLogin'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'bgCheck'},on:{"click":function($event){return _vm.sort('bgCheck')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.list.table.bgCheck'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'bgCheck'),expression:"currentOrder.field === 'bgCheck'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.users),function(user){return _c('tr',{key:user.id},[_c('td',{staticClass:"status"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],attrs:{"type":"checkbox","number":"","disabled":_vm.loading},domProps:{"value":user.id,"checked":Array.isArray(_vm.selected)?_vm._i(_vm.selected,user.id)>-1:(_vm.selected)},on:{"change":function($event){var $$a=_vm.selected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=user.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selected=$$c}}}})]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'/#/provider/' + user.id,"target":"_blank"}},[_vm._v(_vm._s(user.driverNum))])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'/#/provider/' + user.id,"target":"_blank"}},[_vm._v(_vm._s(user.business))])]),_vm._v(" "),_c('td',[_c('span',{class:['type', user.type]},[_vm._v(_vm._s(user.type))])]),_vm._v(" "),_c('td',{staticClass:"status"},[_c('span',{class:['stat-ico', user.status]}),_vm._v(_vm._s(_vm.statusLabel(user.status)))]),_vm._v(" "),_c('td',{staticClass:"status"},[_vm._v(_vm._s(user.service))]),_vm._v(" "),_c('td',{staticClass:"status"},[_vm._v(_vm._s(user.vehicleType))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(user.wheelChairLift ? 'YES' : 'NO'))]),_vm._v(" "),_c('td',{staticClass:"city"},[_vm._v(_vm._s(user.city))]),_vm._v(" "),_c('td',{staticClass:"phone"},[_vm._v(_vm._s(user.phone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.created))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.lastUpdate))]),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v(_vm._s(user.lastLogin))]),_vm._v(" "),_c('td',[(user.bgCheckPassed && _vm.target == 'tnc')?_c('i',{staticClass:"fas fa-check-circle fa-2x"}):(user.bgCheckSubmitted && _vm.target == 'tnc')?_c('i',[_vm._v("Submitted")]):(!user.bgCheckPassed && !user.bgCheckSubmitted && _vm.target == 'tnc')?_c('span',{staticClass:"empty"}):(user.bgCheck && _vm.target != 'tnc')?_c('i',{staticClass:"fas fa-check-circle fa-2x"}):_c('i',{staticClass:"fas fa-times-circle fa-2x"})])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"scroll-table"},[_c('table',{staticClass:"main-table"},[_c('thead',[_c('th',{staticClass:"status"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectAll),expression:"selectAll"}],attrs:{"type":"checkbox","disabled":_vm.loading},domProps:{"checked":Array.isArray(_vm.selectAll)?_vm._i(_vm.selectAll,null)>-1:(_vm.selectAll)},on:{"change":function($event){var $$a=_vm.selectAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectAll=$$c}}}})]),_vm._v(" "),_c('th',[_vm._v("Vehicle #")]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'businessName'},on:{"click":function($event){return _vm.sort('businessName')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.list.table.businessName'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'businessName'),expression:"currentOrder.field === 'businessName'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'licenseType'},on:{"click":function($event){return _vm.sort('licenseType')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.list.table.type'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'licenseType'),expression:"currentOrder.field === 'licenseType'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'accountStatus'},on:{"click":function($event){return _vm.sort('accountStatus')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.list.table.status'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'accountStatus'),expression:"currentOrder.field === 'accountStatus'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',[_vm._v("Service")]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'vehicleType'},on:{"click":function($event){return _vm.sort('vehicleType')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.list.table.vehicle'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'vehicleType'),expression:"currentOrder.field === 'vehicleType'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'wheelchair'},on:{"click":function($event){return _vm.sort('wheelchair')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.list.table.vehicle'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'wheelchair'),expression:"currentOrder.field === 'wheelchair'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'city'},on:{"click":function($event){return _vm.sort('city')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.list.table.city'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'city'),expression:"currentOrder.field === 'city'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('provider.list.table.phone')))]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'created'},on:{"click":function($event){return _vm.sort('created')}}},[_vm._v("\n          Created Date\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'created'),expression:"currentOrder.field === 'created'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'lastUpdate'},on:{"click":function($event){return _vm.sort('lastUpdate')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.list.table.lastUpdate'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'lastUpdate'),expression:"currentOrder.field === 'lastUpdate'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'lastLogin'},on:{"click":function($event){return _vm.sort('lastLogin')}}},[_vm._v("\n          Last On Duty\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'lastLogin'),expression:"currentOrder.field === 'lastLogin'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'bgCheck'},on:{"click":function($event){return _vm.sort('bgCheck')}}},[_vm._v("\n          "+_vm._s(_vm.$t('provider.list.table.bgCheck'))+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'bgCheck'),expression:"currentOrder.field === 'bgCheck'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.users),function(user){return _c('tr',{key:user.id},[_c('td',{staticClass:"status"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],attrs:{"type":"checkbox","number":"","disabled":_vm.loading},domProps:{"value":user.id,"checked":Array.isArray(_vm.selected)?_vm._i(_vm.selected,user.id)>-1:(_vm.selected)},on:{"change":function($event){var $$a=_vm.selected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=user.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selected=$$c}}}})]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'/#/provider/' + user.id,"target":"_blank"}},[_vm._v(_vm._s(user.driverNum))])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'/#/provider/' + user.id,"target":"_blank"}},[_vm._v(_vm._s(user.business))])]),_vm._v(" "),_c('td',[_c('span',{class:['type', user.type]},[_vm._v(_vm._s(user.type))])]),_vm._v(" "),_c('td',{staticClass:"status"},[_c('span',{class:['stat-ico', user.status]}),_vm._v(_vm._s(_vm.statusLabel(user.status)))]),_vm._v(" "),_c('td',{staticClass:"status"},[_vm._v(_vm._s(user.service))]),_vm._v(" "),_c('td',{staticClass:"status"},[_vm._v(_vm._s(user.vehicleType))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(user.wheelChairLift ? 'YES' : 'No'))]),_vm._v(" "),_c('td',{staticClass:"city"},[_vm._v(_vm._s(user.city))]),_vm._v(" "),_c('td',{staticClass:"phone"},[_vm._v(_vm._s(user.phone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.created))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.lastUpdate))]),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v(_vm._s(user.lastLogin))]),_vm._v(" "),_c('td',[(user.bgCheckPassed && _vm.target == 'tnc')?_c('i',{staticClass:"fas fa-check-circle fa-2x"}):(user.bgCheckSubmitted && _vm.target == 'tnc')?_c('i',[_vm._v("Submitted")]):(!user.bgCheckPassed && !user.bgCheckSubmitted && _vm.target == 'tnc')?_c('span',{staticClass:"empty"}):(user.bgCheck && _vm.target != 'tnc')?_c('i',{staticClass:"fas fa-check-circle fa-2x"}):_c('i',{staticClass:"fas fa-times-circle fa-2x"})])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading && _vm.users.length === 0),expression:"loading && users.length === 0"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"13"}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n                "+_vm._s(_vm.$t('consumer.list.gettingUsers'))+"\n              ")])])],1)]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.length === 0 && !_vm.loading),expression:"users.length === 0 && !loading"}]},[_c('td',{staticClass:"table-block",attrs:{"colspan":"13"}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.length === 0 && !_vm.loading),expression:"users.length === 0 && !loading"}],staticClass:"empty-result"},[_c('i',{staticClass:"far fa-frown-open fa-3x"}),_c('br'),_vm._v("\n                No record found!\n              ")])])],1)])],2)])]),_vm._v(" "),_c('div',{staticClass:"fix-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-3 columns per-page"},[_c('span',[_vm._v("Displaying")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" "),_c('span',[_vm._v("per page")])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns page-data"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.length > 0),expression:"users.length > 0"}]},[_vm._v("\n          Displaying\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.start))]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.pageData.end))]),_vm._v(" of\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.max))])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns pagination"},[_c('span',[_vm._v("Page")]),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.currentPage === 1 || _vm.loading},on:{"click":_vm.prev}},[_c('i',{staticClass:"fas fa-chevron-left"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentPage),expression:"currentPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.totalPage),function(i){return _c('option',{domProps:{"value":i}},[_vm._v(_vm._s(i))])}),0),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.isLastPage || _vm.loading},on:{"click":_vm.next}},[_c('i',{staticClass:"fas fa-chevron-right"})])])])])]):_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading && _vm.users.length === 0),expression:"loading && users.length === 0"}]},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n        "+_vm._s(_vm.$t('consumer.list.gettingUsers'))+"\n      ")])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.length === 0 && !_vm.loading),expression:"users.length === 0 && !loading"}]},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.length === 0 && !_vm.loading),expression:"users.length === 0 && !loading"}],staticClass:"empty-result"},[_c('i',{staticClass:"far fa-frown-open fa-3x"}),_c('br'),_vm._v("\n        No record found!\n      ")])])],1),_vm._v(" "),_vm._l((_vm.users),function(user){return _c('div',{key:user.id,staticClass:"cards"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],attrs:{"type":"checkbox","number":"","disabled":_vm.loading},domProps:{"value":user.id,"checked":Array.isArray(_vm.selected)?_vm._i(_vm.selected,user.id)>-1:(_vm.selected)},on:{"change":function($event){var $$a=_vm.selected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=user.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selected=$$c}}}}),_vm._v(" "),_c('span',{class:['type', user.type]},[_vm._v(_vm._s(user.type))]),_vm._v(" "),_c('div',{class:['status', user.status]},[_vm._v(_vm._s(user.status))])]),_vm._v(" "),_c('div',{staticClass:"right"},[(user.bgCheckPassed && _vm.target == 'tnc' || user.bgCheck && _vm.target != 'tnc')?_c('span',[_vm._v("BG CHECK")]):_vm._e(),_vm._v(" "),_c('div',[(user.bgCheckPassed && _vm.target == 'tnc')?_c('i',{staticClass:"fas fa-check-circle fa-2x"}):(user.bgCheckSubmitted && _vm.target == 'tnc')?_c('i',[_vm._v("Submitted")]):(!user.bgCheckPassed && !user.bgCheckSubmitted && _vm.target == 'tnc')?_c('span',{staticClass:"empty"}):(user.bgCheck && _vm.target != 'tnc')?_c('i',{staticClass:"fas fa-check-circle fa-2x"}):_c('i',{staticClass:"fas fa-times-circle fa-2x"})])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(user.driverNum),expression:"user.driverNum"}]},[_c('a',{attrs:{"href":'/#/provider/' + user.id,"target":"_blank"}},[_vm._v("#"+_vm._s(user.driverNum))])]),_vm._v(" "),_c('a',{attrs:{"href":'/#/provider/' + user.id,"target":"_blank"}},[_vm._v(_vm._s(user.business))])])]),_vm._v(" "),(user.service)?_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Service:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(user.service))])]):_vm._e(),_vm._v(" "),(user.vehicleType)?_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Vehicle Type:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(user.vehicleType))])]):_vm._e(),_vm._v(" "),(user.city)?_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("City:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(user.city))])]):_vm._e(),_vm._v(" "),(user.phone)?_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Phone:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(user.phone))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("ADA:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(user.wheelChairLift ? 'YES' : 'NO'))])]),_vm._v(" "),(user.created)?_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Date Created:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(user.created))])]):_vm._e(),_vm._v(" "),(user.lastUpdate)?_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Last Update:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(user.lastUpdate))])]):_vm._e(),_vm._v(" "),(user.lastLogin)?_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Last Login:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(user.lastLogin))])]):_vm._e()])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && _vm.users.length != 0),expression:"!loading && users.length != 0"}],staticClass:"fix-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-3 columns per-page"},[_c('span',[_vm._v("Displaying")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns pagination"},[_c('span',[_vm._v("Page")]),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.currentPage === 1 || _vm.loading},on:{"click":_vm.prev}},[_c('i',{staticClass:"fas fa-chevron-left"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentPage),expression:"currentPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.totalPage),function(i){return _c('option',{domProps:{"value":i}},[_vm._v(_vm._s(i))])}),0),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.isLastPage || _vm.loading},on:{"click":_vm.next}},[_c('i',{staticClass:"fas fa-chevron-right"})])])])])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"label"},[_c('i',{staticClass:"fas fa-address-card"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"fixed-header"},[_c('div',{staticClass:"heading"},[_c('span',[_vm._v("\n        "+_vm._s(_vm.$t('provider.list.title'))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"send-buttons"},[_c('button',{staticClass:"button small warning notif-btn",on:{"click":_vm.showNotifModal}},[_vm._v("Send Notification")]),_vm._v(" "),_c('button',{staticClass:"button small info sms-btn",on:{"click":_vm.showSMSModal}},[_c('i',{staticClass:"fas fa-comment-dots"}),_vm._v(" Send SMS")]),_vm._v(" "),(_vm.isMobile)?_c('button',{staticClass:"button small info filter-btn",on:{"click":_vm.showFilter}},[_c('i',{staticClass:"fas fa-filter"})]):_vm._e()])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('list-filter',{ref:"filter",attrs:{"isOpen":_vm.isOpenFilter,"isMobile":_vm.isMobile}})],1)],1),_vm._v(" "),_c('div',{class:{'tables-box':true, 'filterHide':!_vm.isOpenFilter}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'all' || _vm.type === 'tnc'),expression:"type === 'all' || type === 'tnc'"}]},[_c('div',{staticClass:"table-header"},[_c('div',{staticClass:"table-label"},[_vm._v("TNC Drivers")]),_vm._v(" "),_c('div',{staticClass:"export-box"},[_c('button',{class:{'button success xsmall':true, 'disabled':_vm.loading || _vm.exportLoading.tnc},attrs:{"disabled":_vm.loading || _vm.exportLoading.tnc},on:{"click":function($event){return _vm.exportProvInSeries('tnc')}}},[(_vm.exportLoading.tnc)?_c('span',[_vm._v("Loading...")]):_c('span',[_vm._v("EXPORT")])])])]),_vm._v(" "),_c('list-table',{staticClass:"tables",attrs:{"target":"tnc"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'all' || _vm.type === 'tcp'),expression:"type === 'all' || type === 'tcp'"}]},[_c('div',{staticClass:"table-header"},[_c('div',{staticClass:"table-label"},[_vm._v("TCP Drivers")]),_vm._v(" "),_c('div',{staticClass:"export-box"},[_c('button',{class:{'button success xsmall':true, 'disabled':_vm.loading || _vm.exportLoading.tcp},attrs:{"disabled":_vm.loading || _vm.exportLoading.tcp},on:{"click":function($event){return _vm.exportProvInSeries('tcp')}}},[(_vm.exportLoading.tcp)?_c('span',[_vm._v("Loading...")]):_c('span',[_vm._v("EXPORT")])])])]),_vm._v(" "),_c('list-table',{staticClass:"tables",attrs:{"target":"tcp"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'all' || _vm.type === 'psc'),expression:"type === 'all' || type === 'psc'"}]},[_c('div',{staticClass:"table-header"},[_c('div',{staticClass:"table-label"},[_vm._v("PSC Drivers")]),_vm._v(" "),_c('div',{staticClass:"export-box"},[_c('button',{class:{'button success xsmall':true, 'disabled':_vm.loading || _vm.exportLoading.psc},attrs:{"disabled":_vm.loading || _vm.exportLoading.psc},on:{"click":function($event){return _vm.exportProvInSeries('psc')}}},[(_vm.exportLoading.psc)?_c('span',[_vm._v("Loading...")]):_c('span',[_vm._v("EXPORT")])])])]),_vm._v(" "),_c('list-table',{staticClass:"tables",attrs:{"target":"psc"}})],1)]),_vm._v(" "),_c('notification-modal',{ref:"notif",attrs:{"isList":true,"provId":_vm.selected,"showGeofenceOption":true,"removeAllActiveUserOption":false,"hideTargetOption":false,"showBySector":true}}),_vm._v(" "),_c('sms-modal',{ref:"sms",attrs:{"isList":true,"provId":_vm.selected,"showGeofenceOption":true,"removeAllActiveUserOption":false,"hideTargetOption":false}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(596);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1192e4d5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1766);
function injectStyle (ssrContext) {
  __webpack_require__(1752)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1192e4d5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1192e4d5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1753);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("139d364b", content, true, {});

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.header[data-v-1192e4d5] {\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  z-index: 2;\n}\n.deductions[data-v-1192e4d5] {\n  position: relative;\n}\n.deductions-container[data-v-1192e4d5] {\n  position: fixed;\n  top: 51px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.deduction-content[data-v-1192e4d5] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: calc(100% - 51px);\n  width: 100%;\n  overflow-y: auto;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/ProviderDeductions/index.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,6CAA6C;EAC7C,WAAW;CACZ;AACD;EACE,mBAAmB;CACpB;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;CACd;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;CAClB","file":"index.vue","sourcesContent":["\n.header[data-v-1192e4d5] {\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  z-index: 2;\n}\n.deductions[data-v-1192e4d5] {\n  position: relative;\n}\n.deductions-container[data-v-1192e4d5] {\n  position: fixed;\n  top: 51px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.deduction-content[data-v-1192e4d5] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: calc(100% - 51px);\n  width: 100%;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeductionDelete_vue__ = __webpack_require__(597);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a89cf906_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeductionDelete_vue__ = __webpack_require__(1757);
function injectStyle (ssrContext) {
  __webpack_require__(1755)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a89cf906"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeductionDelete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a89cf906_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeductionDelete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1756);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("da0cf1f4", content, true, {});

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.op--modal-container[data-v-a89cf906] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-a89cf906] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-a89cf906] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-a89cf906] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.form[data-v-a89cf906] {\n  background: #fff;\n  width: 100%;\n  max-width: 500px;\n  margin: 0 auto;\n  border-radius: 5px;\n  overflow: hidden;\n}\n.heading[data-v-a89cf906] {\n  background: #333;\n  color: #fff;\n  font-weight: 600;\n  font-size: 16px;\n  padding: 10px 20px;\n  margin-bottom: 20px;\n}\n.message[data-v-a89cf906] {\n  text-align: center;\n  padding: 0 20px 10px;\n}\n.error[data-v-a89cf906] {\n  font-size: 14px;\n  font-weight: 700;\n  text-align: center;\n  color: #F25E0D;\n  border: 2px solid #F25E0D;\n  padding: 10px;\n  margin: 10px 20px 20px;\n  border-radius: 5px;\n}\n.fixed-footer[data-v-a89cf906] {\n  width: 100%;\n  background: #f3f3f3;\n  border-top: 1px solid #ccc;\n  padding: 15px 10px;\n  text-align: center;\n  margin-top: 15px;\n}\n.fixed-footer .button[data-v-a89cf906] {\n    min-width: 120px;\n    margin: 0 5px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/ProviderDeductions/DeductionDelete.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;CACrB;AACD;EACE,mBAAmB;EACnB,qBAAqB;CACtB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,uBAAuB;EACvB,mBAAmB;CACpB;AACD;EACE,YAAY;EACZ,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;CAClB;AACD;IACI,iBAAiB;IACjB,cAAc;CACjB","file":"DeductionDelete.vue","sourcesContent":["\n.op--modal-container[data-v-a89cf906] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-a89cf906] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-a89cf906] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-a89cf906] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.form[data-v-a89cf906] {\n  background: #fff;\n  width: 100%;\n  max-width: 500px;\n  margin: 0 auto;\n  border-radius: 5px;\n  overflow: hidden;\n}\n.heading[data-v-a89cf906] {\n  background: #333;\n  color: #fff;\n  font-weight: 600;\n  font-size: 16px;\n  padding: 10px 20px;\n  margin-bottom: 20px;\n}\n.message[data-v-a89cf906] {\n  text-align: center;\n  padding: 0 20px 10px;\n}\n.error[data-v-a89cf906] {\n  font-size: 14px;\n  font-weight: 700;\n  text-align: center;\n  color: #F25E0D;\n  border: 2px solid #F25E0D;\n  padding: 10px;\n  margin: 10px 20px 20px;\n  border-radius: 5px;\n}\n.fixed-footer[data-v-a89cf906] {\n  width: 100%;\n  background: #f3f3f3;\n  border-top: 1px solid #ccc;\n  padding: 15px 10px;\n  text-align: center;\n  margin-top: 15px;\n}\n.fixed-footer .button[data-v-a89cf906] {\n    min-width: 120px;\n    margin: 0 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'op--modal-container':true, 'hide':!_vm.show}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content",attrs:{"id":"form"}},[_c('div',{staticClass:"form"},[_c('div',{staticClass:"heading"},[_vm._v("DELETING DEDUCTION")]),_vm._v(" "),(_vm.item !== null)?_c('div',{staticClass:"message"},[_c('span',[_vm._v("Are you sure you want to delete the deduction with the name")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.item.name)+"?")])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.show),expression:"error.show"}],staticClass:"error"},[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('div',{staticClass:"fixed-footer"},[_c('div',{class:{'button cta small warning':true, 'disabled':_vm.deleting},on:{"click":_vm.close}},[_vm._v("NO")]),_vm._v(" "),_c('div',{class:{'button cta small':true, 'disabled':_vm.deleting},on:{"click":_vm.submitDelete}},[_vm._v("YES")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeductionForm_vue__ = __webpack_require__(598);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7809a778_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeductionForm_vue__ = __webpack_require__(1761);
function injectStyle (ssrContext) {
  __webpack_require__(1759)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7809a778"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeductionForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7809a778_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeductionForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1760);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1c71ccf1", content, true, {});

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.op--modal-container[data-v-7809a778] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-7809a778] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-7809a778] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-7809a778] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.form[data-v-7809a778] {\n  background: #fff;\n  width: 100%;\n  max-width: 700px;\n  margin: 0 auto;\n  border-radius: 5px;\n  overflow: hidden;\n}\n.heading[data-v-7809a778] {\n  background: #333;\n  color: #fff;\n  font-weight: 600;\n  font-size: 16px;\n  padding: 10px 20px;\n  margin-bottom: 20px;\n}\n.row-padding[data-v-7809a778] {\n  padding: 2px 20px;\n}\n.padding-L[data-v-7809a778] {\n  padding-left: 10px;\n}\n.padding-R[data-v-7809a778] {\n  padding-right: 10px;\n}\n.margin-B[data-v-7809a778] {\n  margin-bottom: 20px;\n}\n.data-field[data-v-7809a778] {\n  position: relative;\n  margin-bottom: 10px;\n}\n.data-field .label[data-v-7809a778] {\n    color: #0D79F2;\n    font-weight: 600;\n    font-size: 12px;\n    margin-bottom: 1px;\n}\n.data-field .label.has-error[data-v-7809a778] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-7809a778] {\n    margin: 5px 0 0;\n    padding: 10px;\n    font-size: 14px;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n    border-radius: 3px;\n}\n.data-field .input.has-error[data-v-7809a778] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-7809a778]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-7809a778] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.data-field .hint[data-v-7809a778] {\n    font-size: 12px;\n    color: #555;\n    line-height: 1;\n}\n.data-field textarea[data-v-7809a778] {\n    resize: none;\n    font-size: 14px;\n    height: 150px;\n    padding: 10px;\n}\n.data-field select[data-v-7809a778] {\n    margin-top: 5px;\n    font-size: 14px;\n    padding: 10px;\n    height: 43px;\n    outline: 0;\n    display: block;\n    border-color: rgba(0, 0, 0, 0.15);\n    background-color: #fff;\n    border-radius: 3px;\n}\n.checkbox-input[data-v-7809a778] {\n  display: block;\n  text-align: center;\n  margin: 10px 0;\n}\n.checkbox-input > input[data-v-7809a778] {\n    margin-top: 0;\n    width: auto;\n}\n.checkbox-input > *[data-v-7809a778] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.checkbox-input > span[data-v-7809a778] {\n    font-size: 14px;\n}\n.error[data-v-7809a778] {\n  font-size: 14px;\n  font-weight: 700;\n  text-align: center;\n  color: #F25E0D;\n  border: 2px solid #F25E0D;\n  padding: 10px;\n  margin: 10px 20px 20px;\n  border-radius: 5px;\n}\n.fixed-footer[data-v-7809a778] {\n  width: 100%;\n  background: #f3f3f3;\n  border-top: 1px solid #ccc;\n  padding: 15px 10px;\n  text-align: center;\n  margin-top: 15px;\n}\n.fixed-footer .button[data-v-7809a778] {\n    min-width: 120px;\n    margin: 0 5px;\n}\n@media only screen and (max-width: 430px) {\n.form[data-v-7809a778] {\n    width: 90%;\n}\n.form .small-6.inputDate[data-v-7809a778] {\n      width: 100%;\n      padding: 0;\n}\n.form .apply-checkbox[data-v-7809a778] {\n      display: grid;\n      grid-template-rows: auto;\n      grid-template-areas: \"top-apply top-apply\"\r \"bottom-apply bottom-apply\";\n}\n.form .end-date[data-v-7809a778] .vdp-datepicker__calendar {\n      right: 1px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/ProviderDeductions/DeductionForm.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;CACrB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,mBAAmB;EACnB,oBAAoB;CACrB;AACD;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;IAC1B,mBAAmB;CACtB;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;CAClB;AACD;IACI,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,cAAc;CACjB;AACD;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,WAAW;IACX,eAAe;IACf,kCAAkC;IAClC,uBAAuB;IACvB,mBAAmB;CACtB;AACD;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;CAChB;AACD;IACI,cAAc;IACd,YAAY;CACf;AACD;IACI,sBAAsB;IACtB,uBAAuB;CAC1B;AACD;IACI,gBAAgB;CACnB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,uBAAuB;EACvB,mBAAmB;CACpB;AACD;EACE,YAAY;EACZ,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;CAClB;AACD;IACI,iBAAiB;IACjB,cAAc;CACjB;AACD;AACA;IACI,WAAW;CACd;AACD;MACM,YAAY;MACZ,WAAW;CAChB;AACD;MACM,cAAc;MACd,yBAAyB;MACzB,wEACuB;CAC5B;AACD;MACM,WAAW;CAChB;CACA","file":"DeductionForm.vue","sourcesContent":["\n.op--modal-container[data-v-7809a778] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-7809a778] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-7809a778] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-7809a778] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.form[data-v-7809a778] {\n  background: #fff;\n  width: 100%;\n  max-width: 700px;\n  margin: 0 auto;\n  border-radius: 5px;\n  overflow: hidden;\n}\n.heading[data-v-7809a778] {\n  background: #333;\n  color: #fff;\n  font-weight: 600;\n  font-size: 16px;\n  padding: 10px 20px;\n  margin-bottom: 20px;\n}\n.row-padding[data-v-7809a778] {\n  padding: 2px 20px;\n}\n.padding-L[data-v-7809a778] {\n  padding-left: 10px;\n}\n.padding-R[data-v-7809a778] {\n  padding-right: 10px;\n}\n.margin-B[data-v-7809a778] {\n  margin-bottom: 20px;\n}\n.data-field[data-v-7809a778] {\n  position: relative;\n  margin-bottom: 10px;\n}\n.data-field .label[data-v-7809a778] {\n    color: #0D79F2;\n    font-weight: 600;\n    font-size: 12px;\n    margin-bottom: 1px;\n}\n.data-field .label.has-error[data-v-7809a778] {\n      color: #f20d0d;\n}\n.data-field .input[data-v-7809a778] {\n    margin: 5px 0 0;\n    padding: 10px;\n    font-size: 14px;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n    border-radius: 3px;\n}\n.data-field .input.has-error[data-v-7809a778] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-7809a778]:disabled {\n      background: #eee;\n}\n.data-field .error-msg[data-v-7809a778] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.data-field .hint[data-v-7809a778] {\n    font-size: 12px;\n    color: #555;\n    line-height: 1;\n}\n.data-field textarea[data-v-7809a778] {\n    resize: none;\n    font-size: 14px;\n    height: 150px;\n    padding: 10px;\n}\n.data-field select[data-v-7809a778] {\n    margin-top: 5px;\n    font-size: 14px;\n    padding: 10px;\n    height: 43px;\n    outline: 0;\n    display: block;\n    border-color: rgba(0, 0, 0, 0.15);\n    background-color: #fff;\n    border-radius: 3px;\n}\n.checkbox-input[data-v-7809a778] {\n  display: block;\n  text-align: center;\n  margin: 10px 0;\n}\n.checkbox-input > input[data-v-7809a778] {\n    margin-top: 0;\n    width: auto;\n}\n.checkbox-input > *[data-v-7809a778] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.checkbox-input > span[data-v-7809a778] {\n    font-size: 14px;\n}\n.error[data-v-7809a778] {\n  font-size: 14px;\n  font-weight: 700;\n  text-align: center;\n  color: #F25E0D;\n  border: 2px solid #F25E0D;\n  padding: 10px;\n  margin: 10px 20px 20px;\n  border-radius: 5px;\n}\n.fixed-footer[data-v-7809a778] {\n  width: 100%;\n  background: #f3f3f3;\n  border-top: 1px solid #ccc;\n  padding: 15px 10px;\n  text-align: center;\n  margin-top: 15px;\n}\n.fixed-footer .button[data-v-7809a778] {\n    min-width: 120px;\n    margin: 0 5px;\n}\n@media only screen and (max-width: 430px) {\n.form[data-v-7809a778] {\n    width: 90%;\n}\n.form .small-6.inputDate[data-v-7809a778] {\n      width: 100%;\n      padding: 0;\n}\n.form .apply-checkbox[data-v-7809a778] {\n      display: grid;\n      grid-template-rows: auto;\n      grid-template-areas: \"top-apply top-apply\"\r \"bottom-apply bottom-apply\";\n}\n.form .end-date[data-v-7809a778] .vdp-datepicker__calendar {\n      right: 1px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'op--modal-container':true, 'hide':!_vm.show}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content",attrs:{"id":"form"}},[_c('div',{staticClass:"form"},[_c('div',{staticClass:"heading"},[(_vm.id === null)?_c('span',[_vm._v("NEW DEDUCTION")]):_c('span',[_vm._v("EDITING DEDUCTION")])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("NAME")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"input",attrs:{"type":"text"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"hint"},[_vm._v("This will appear on the driver's payout statement.")])])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("DESCRIPTION")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"input",domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"small-6 inputDate columns padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("START DATE")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy"},model:{value:(_vm.effectiveStart),callback:function ($$v) {_vm.effectiveStart=$$v},expression:"effectiveStart"}})],1)]),_vm._v(" "),_c('div',{staticClass:"small-6 inputDate columns padding-L"},[_c('div',{staticClass:"data-field end-date"},[_c('div',{staticClass:"label"},[_vm._v("END DATE")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MMMM dd, yyyy"},model:{value:(_vm.effectiveEnd),callback:function ($$v) {_vm.effectiveEnd=$$v},expression:"effectiveEnd"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("DEDUCTION INTERVAL")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedInterval),expression:"selectedInterval"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedInterval=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.interval),function(i){return _c('option',{domProps:{"value":i}},[_vm._v(_vm._s(_vm.ucFirst(i)))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("AMOUNT")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.amount),expression:"amount",modifiers:{"number":true}}],staticClass:"input",attrs:{"type":"number"},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedInterval === 'weekly'),expression:"selectedInterval === 'weekly'"}],staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("WEEKLY ANCHOR")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedWeeklyAnchor),expression:"selectedWeeklyAnchor"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedWeeklyAnchor=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.weeklyAnchor),function(i){return _c('option',{domProps:{"value":i}},[_vm._v(_vm._s(_vm.ucFirst(i)))])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedInterval === 'monthly'),expression:"selectedInterval === 'monthly'"}],staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("MONTHLY ANCHOR")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.selectedMonthlyAnchor),expression:"selectedMonthlyAnchor",modifiers:{"number":true}}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.selectedMonthlyAnchor=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.monthlyAnchor),function(n){return _c('option',{domProps:{"value":n}},[_vm._v(_vm._s(_vm.daySuffix(n))+" of the month")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("ENABLED")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.boolean",value:(_vm.enabled),expression:"enabled",modifiers:{"boolean":true}}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.enabled=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":false}},[_vm._v("No")]),_vm._v(" "),_c('option',{domProps:{"value":true}},[_vm._v("Yes")])])])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding apply-checkbox"},[_c('div',{staticClass:"small-4 columns top-apply"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model.boolean",value:(_vm.applyTNC),expression:"applyTNC",modifiers:{"boolean":true}}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.applyTNC)?_vm._i(_vm.applyTNC,null)>-1:(_vm.applyTNC)},on:{"change":function($event){var $$a=_vm.applyTNC,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.applyTNC=$$a.concat([$$v]))}else{$$i>-1&&(_vm.applyTNC=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.applyTNC=$$c}}}}),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns top-apply"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model.boolean",value:(_vm.applyTCP),expression:"applyTCP",modifiers:{"boolean":true}}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.applyTCP)?_vm._i(_vm.applyTCP,null)>-1:(_vm.applyTCP)},on:{"change":function($event){var $$a=_vm.applyTCP,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.applyTCP=$$a.concat([$$v]))}else{$$i>-1&&(_vm.applyTCP=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.applyTCP=$$c}}}}),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns bottom-apply"},[_c('label',{staticClass:"checkbox-input"},[_c('input',{directives:[{name:"model",rawName:"v-model.boolean",value:(_vm.applyPSC),expression:"applyPSC",modifiers:{"boolean":true}}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.applyPSC)?_vm._i(_vm.applyPSC,null)>-1:(_vm.applyPSC)},on:{"change":function($event){var $$a=_vm.applyPSC,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.applyPSC=$$a.concat([$$v]))}else{$$i>-1&&(_vm.applyPSC=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.applyPSC=$$c}}}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.show),expression:"error.show"}],staticClass:"error"},[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('div',{staticClass:"fixed-footer"},[_c('div',{class:{'button cta small warning':true, 'disabled':_vm.submitLoading},on:{"click":_vm.close}},[_vm._v("CANCEL")]),_vm._v(" "),_c('div',{class:{'button cta small':true, 'disabled':_vm.submitLoading},on:{"click":_vm.submitForm}},[(_vm.id !== null)?_c('span',[_vm._v("SAVE")]):_c('span',[_vm._v("ADD")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("Apply to "),_c('b',[_vm._v("TNC")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("Apply to "),_c('b',[_vm._v("TCP")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("Apply to "),_c('b',[_vm._v("PSC")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeductionList_vue__ = __webpack_require__(599);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bf9276b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeductionList_vue__ = __webpack_require__(1765);
function injectStyle (ssrContext) {
  __webpack_require__(1763)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bf9276b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeductionList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bf9276b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeductionList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1764);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1e2cad15", content, true, {});

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.add-new[data-v-5bf9276b] {\n  margin: 20px 0;\n}\n.deduction-list[data-v-5bf9276b] {\n  position: relative;\n  padding: 0 20px;\n}\ntable[data-v-5bf9276b] {\n  border-collapse: collapse;\n  width: 100%;\n}\n.table-header[data-v-5bf9276b] {\n  color: #8DA0A9;\n  font-size: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n}\n.table-header th[data-v-5bf9276b] {\n    padding: 5px;\n}\n.table-row[data-v-5bf9276b] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.table-row td[data-v-5bf9276b] {\n    padding: 10px 5px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.table-row td > .fa-check-circle[data-v-5bf9276b] {\n      color: #26D97A;\n}\n.table-row td > .fa-times-circle[data-v-5bf9276b] {\n      color: #F25E0D;\n}\n.table-row .empty-row[data-v-5bf9276b] {\n    font-size: 16px;\n    padding: 20px;\n}\n.enabled[data-v-5bf9276b] {\n  display: inline-block;\n  background-color: #26D97A;\n  color: #fff;\n  font-weight: 700;\n  padding: 5px;\n  border-radius: 5px;\n}\n.enabled.no[data-v-5bf9276b] {\n    background-color: #F25E0D;\n}\n.loading-deduction[data-v-5bf9276b] {\n  text-align: center;\n  color: #777;\n  margin-top: 80px;\n}\n.loading-deduction > *[data-v-5bf9276b] {\n    display: block;\n}\n.loading-deduction > span[data-v-5bf9276b] {\n    font-size: 20px;\n    font-weight: 700;\n    margin-top: 20px;\n}\n@media only screen and (max-width: 430px) {\n.add-new[data-v-5bf9276b] {\n    text-align: center;\n}\n.cards[data-v-5bf9276b] {\n    margin: 0 auto;\n    margin-top: 20px;\n}\n.cards .result-stat[data-v-5bf9276b] {\n      width: 100%;\n}\n.cards .card[data-v-5bf9276b] {\n      border: 1px solid #ccc;\n      margin-bottom: 15px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n}\n.cards .card .internal-card[data-v-5bf9276b] {\n        padding: 8px;\n}\n.cards .card .card-header[data-v-5bf9276b] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n}\n.cards .card .card-header .id[data-v-5bf9276b] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n.cards .card .card-header .enabled[data-v-5bf9276b] {\n          padding: 2px;\n          font-size: 13px;\n          background-color: transparent;\n}\n.cards .card .card-header .enabled .yes[data-v-5bf9276b] {\n            background-color: #26D97A;\n            padding: 2px 5px;\n            border-radius: 5px;\n}\n.cards .card .card-header .enabled .no[data-v-5bf9276b] {\n            background-color: #ccc;\n            padding: 2px 5px;\n            border-radius: 5px;\n}\n.cards .card .title[data-v-5bf9276b] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        margin-bottom: 3px;\n}\n.cards .card .title.checks[data-v-5bf9276b] {\n          margin-top: 8px;\n}\n.cards .card .title.block[data-v-5bf9276b] {\n          display: block;\n}\n.cards .card .actions[data-v-5bf9276b] {\n        width: 100%;\n        background: #f3f3f3;\n        border-top: 1px solid #ccc;\n        padding: 15px 10px;\n        text-align: center;\n        margin-top: 15px;\n}\n.cards .card .label[data-v-5bf9276b] {\n        font-size: 10px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards .card .label i[data-v-5bf9276b] {\n          font-size: 16px;\n}\n.cards .card .label > .fa-check-circle[data-v-5bf9276b] {\n          color: #26D97A;\n}\n.cards .card .label > .fa-times-circle[data-v-5bf9276b] {\n          color: #F25E0D;\n}\n.cards .card .value[data-v-5bf9276b] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards .card .value i[data-v-5bf9276b] {\n          color: #bbb;\n}\n.cards .card .value a[data-v-5bf9276b] {\n          text-decoration: none;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/ProviderDeductions/DeductionList.vue"],"names":[],"mappings":";AACA;EACE,eAAe;CAChB;AACD;EACE,mBAAmB;EACnB,gBAAgB;CACjB;AACD;EACE,0BAA0B;EAC1B,YAAY;CACb;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,0BAA0B;CAC3B;AACD;IACI,aAAa;CAChB;AACD;EACE,uBAAuB;EACvB,qCAAqC;CACtC;AACD;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,cAAc;CACjB;AACD;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;CACpB;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;CACpB;AACD;AACA;IACI,mBAAmB;CACtB;AACD;IACI,eAAe;IACf,iBAAiB;CACpB;AACD;MACM,YAAY;CACjB;AACD;MACM,uBAAuB;MACvB,oBAAoB;MACpB,+BAA+B;MAC/B,oBAAoB;CACzB;AACD;QACQ,aAAa;CACpB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,+BAA+B;QACvC,uBAAuB;YACnB,oBAAoB;gBAChB,sBAAsB;CACrC;AACD;UACU,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;CACvB;AACD;UACU,aAAa;UACb,gBAAgB;UAChB,8BAA8B;CACvC;AACD;YACY,0BAA0B;YAC1B,iBAAiB;YACjB,mBAAmB;CAC9B;AACD;YACY,uBAAuB;YACvB,iBAAiB;YACjB,mBAAmB;CAC9B;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,oBAAoB;QAC5B,mBAAmB;CAC1B;AACD;UACU,gBAAgB;CACzB;AACD;UACU,eAAe;CACxB;AACD;QACQ,YAAY;QACZ,oBAAoB;QACpB,2BAA2B;QAC3B,mBAAmB;QACnB,mBAAmB;QACnB,iBAAiB;CACxB;AACD;QACQ,gBAAgB;QAChB,0BAA0B;QAC1B,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;CACzB;AACD;UACU,gBAAgB;CACzB;AACD;UACU,eAAe;CACxB;AACD;UACU,eAAe;CACxB;AACD;QACQ,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;CACxB;AACD;UACU,YAAY;CACrB;AACD;UACU,sBAAsB;CAC/B;CACA","file":"DeductionList.vue","sourcesContent":["\n.add-new[data-v-5bf9276b] {\n  margin: 20px 0;\n}\n.deduction-list[data-v-5bf9276b] {\n  position: relative;\n  padding: 0 20px;\n}\ntable[data-v-5bf9276b] {\n  border-collapse: collapse;\n  width: 100%;\n}\n.table-header[data-v-5bf9276b] {\n  color: #8DA0A9;\n  font-size: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n}\n.table-header th[data-v-5bf9276b] {\n    padding: 5px;\n}\n.table-row[data-v-5bf9276b] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.table-row td[data-v-5bf9276b] {\n    padding: 10px 5px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.table-row td > .fa-check-circle[data-v-5bf9276b] {\n      color: #26D97A;\n}\n.table-row td > .fa-times-circle[data-v-5bf9276b] {\n      color: #F25E0D;\n}\n.table-row .empty-row[data-v-5bf9276b] {\n    font-size: 16px;\n    padding: 20px;\n}\n.enabled[data-v-5bf9276b] {\n  display: inline-block;\n  background-color: #26D97A;\n  color: #fff;\n  font-weight: 700;\n  padding: 5px;\n  border-radius: 5px;\n}\n.enabled.no[data-v-5bf9276b] {\n    background-color: #F25E0D;\n}\n.loading-deduction[data-v-5bf9276b] {\n  text-align: center;\n  color: #777;\n  margin-top: 80px;\n}\n.loading-deduction > *[data-v-5bf9276b] {\n    display: block;\n}\n.loading-deduction > span[data-v-5bf9276b] {\n    font-size: 20px;\n    font-weight: 700;\n    margin-top: 20px;\n}\n@media only screen and (max-width: 430px) {\n.add-new[data-v-5bf9276b] {\n    text-align: center;\n}\n.cards[data-v-5bf9276b] {\n    margin: 0 auto;\n    margin-top: 20px;\n}\n.cards .result-stat[data-v-5bf9276b] {\n      width: 100%;\n}\n.cards .card[data-v-5bf9276b] {\n      border: 1px solid #ccc;\n      margin-bottom: 15px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n}\n.cards .card .internal-card[data-v-5bf9276b] {\n        padding: 8px;\n}\n.cards .card .card-header[data-v-5bf9276b] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n}\n.cards .card .card-header .id[data-v-5bf9276b] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n.cards .card .card-header .enabled[data-v-5bf9276b] {\n          padding: 2px;\n          font-size: 13px;\n          background-color: transparent;\n}\n.cards .card .card-header .enabled .yes[data-v-5bf9276b] {\n            background-color: #26D97A;\n            padding: 2px 5px;\n            border-radius: 5px;\n}\n.cards .card .card-header .enabled .no[data-v-5bf9276b] {\n            background-color: #ccc;\n            padding: 2px 5px;\n            border-radius: 5px;\n}\n.cards .card .title[data-v-5bf9276b] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        margin-bottom: 3px;\n}\n.cards .card .title.checks[data-v-5bf9276b] {\n          margin-top: 8px;\n}\n.cards .card .title.block[data-v-5bf9276b] {\n          display: block;\n}\n.cards .card .actions[data-v-5bf9276b] {\n        width: 100%;\n        background: #f3f3f3;\n        border-top: 1px solid #ccc;\n        padding: 15px 10px;\n        text-align: center;\n        margin-top: 15px;\n}\n.cards .card .label[data-v-5bf9276b] {\n        font-size: 10px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards .card .label i[data-v-5bf9276b] {\n          font-size: 16px;\n}\n.cards .card .label > .fa-check-circle[data-v-5bf9276b] {\n          color: #26D97A;\n}\n.cards .card .label > .fa-times-circle[data-v-5bf9276b] {\n          color: #F25E0D;\n}\n.cards .card .value[data-v-5bf9276b] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards .card .value i[data-v-5bf9276b] {\n          color: #bbb;\n}\n.cards .card .value a[data-v-5bf9276b] {\n          text-decoration: none;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"deduction-list"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading-deduction"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-4x"}),_vm._v(" "),_c('span',[_vm._v("LOADING DEDUCTIONS...")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}]},[_c('div',{staticClass:"add-new"},[_c('a',{staticClass:"button cta small",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.openForm(null)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "),_c('span',[_vm._v("ADD NEW DEDUCTION")])])]),_vm._v(" "),(!_vm.isMobile)?_c('table',[_vm._m(0),_vm._v(" "),_c('tbody',[_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length <= 0),expression:"items.length <= 0"}],staticClass:"table-row"},[_vm._m(1)]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length > 0),expression:"items.length > 0"}],staticClass:"table-row"},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.description))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(item.amount.toFixed(2)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.effectiveStart.format('MM/DD/YYYY')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.effectiveEnd.format('MM/DD/YYYY')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getDeductionDetails(item)))]),_vm._v(" "),_c('td',[_c('i',{directives:[{name:"show",rawName:"v-show",value:(item.applyTNC),expression:"item.applyTNC"}],staticClass:"fa fa-check-circle fa-lg"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!item.applyTNC),expression:"!item.applyTNC"}],staticClass:"fa fa-times-circle fa-lg"})]),_vm._v(" "),_c('td',[_c('i',{directives:[{name:"show",rawName:"v-show",value:(item.applyTCP),expression:"item.applyTCP"}],staticClass:"fa fa-check-circle fa-lg"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!item.applyTCP),expression:"!item.applyTCP"}],staticClass:"fa fa-times-circle fa-lg"})]),_vm._v(" "),_c('td',[_c('i',{directives:[{name:"show",rawName:"v-show",value:(item.applyPSC),expression:"item.applyPSC"}],staticClass:"fa fa-check-circle fa-lg"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!item.applyPSC),expression:"!item.applyPSC"}],staticClass:"fa fa-times-circle fa-lg"})]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.enabled),expression:"item.enabled"}],staticClass:"enabled"},[_vm._v("YES")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!item.enabled),expression:"!item.enabled"}],staticClass:"enabled no"},[_vm._v("NO")])]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button cta xsmall",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.openForm(item)}}},[_vm._v("EDIT")]),_vm._v(" "),_c('a',{staticClass:"button cta xsmall warning",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.showDelete(item)}}},[_vm._v("DELETE")])])])})],2)]):_c('div',{staticClass:"cards"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length <= 0),expression:"items.length <= 0"}],staticClass:"card"},[_vm._v("There are no deductions yet."),_c('br'),_vm._v("Click on the button at the top-left to create one.")]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length > 0),expression:"items.length > 0"}],key:item.id,staticClass:"card"},[_c('div',{staticClass:"internal-card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"id"},[_c('div',{staticClass:"label"},[_vm._v("ID: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(item.id))])]),_vm._v(" "),_c('div',{staticClass:"enabled"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.enabled),expression:"item.enabled"}],staticClass:"yes"},[_vm._v("Enabled")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!item.enabled),expression:"!item.enabled"}],staticClass:"no"},[_vm._v("Disabled")])])]),_vm._v(" "),_c('div',{staticClass:"title block"},[_c('span',{staticClass:"label"},[_vm._v("Name: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_c('div',{staticClass:"title block"},[_c('div',{staticClass:"label"},[_vm._v("Description: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(item.description))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Amount: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("$"+_vm._s(item.amount.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Start Date: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(item.effectiveStart.format('MM/DD/YYYY')))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("End Date: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(item.effectiveEnd.format('MM/DD/YYYY')))])]),_vm._v(" "),_c('div',{staticClass:"title block"},[_c('div',{staticClass:"label"},[_vm._v("DEDUCTION DETAILS: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.getDeductionDetails(item)))])]),_vm._v(" "),_c('div',{staticClass:"title checks"},[_c('div',{staticClass:"label"},[_vm._v("TNC: \n                "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(item.applyTNC),expression:"item.applyTNC"}],staticClass:"fa fa-check-circle fa-lg"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!item.applyTNC),expression:"!item.applyTNC"}],staticClass:"fa fa-times-circle fa-lg"})]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("TCP: \n                "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(item.applyTCP),expression:"item.applyTCP"}],staticClass:"fa fa-check-circle fa-lg"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!item.applyTCP),expression:"!item.applyTCP"}],staticClass:"fa fa-times-circle fa-lg"})]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("PSC: \n                "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(item.applyPSC),expression:"item.applyPSC"}],staticClass:"fa fa-check-circle fa-lg"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!item.applyPSC),expression:"!item.applyPSC"}],staticClass:"fa fa-times-circle fa-lg"})])])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('a',{staticClass:"button cta small",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.openForm(item)}}},[_vm._v("EDIT")]),_vm._v(" "),_c('a',{staticClass:"button cta small warning",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.showDelete(item)}}},[_vm._v("DELETE")])])])})],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"table-header"},[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("NAME")]),_vm._v(" "),_c('th',[_vm._v("DESCRIPTION")]),_vm._v(" "),_c('th',[_vm._v("AMOUNT")]),_vm._v(" "),_c('th',[_vm._v("START DATE")]),_vm._v(" "),_c('th',[_vm._v("END DATE")]),_vm._v(" "),_c('th',[_vm._v("DEDUCTION DETAILS")]),_vm._v(" "),_c('th',[_vm._v("TNC")]),_vm._v(" "),_c('th',[_vm._v("TCP")]),_vm._v(" "),_c('th',[_vm._v("PSC")]),_vm._v(" "),_c('th',[_vm._v("ENABLED")]),_vm._v(" "),_c('th',[_vm._v("CONTROLS")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"empty-row",attrs:{"colspan":"10"}},[_vm._v("\n              There are no deductions yet."),_c('br'),_vm._v("Click on the button at the top-left to create one.\n            ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deductions"},[_c('div',{staticClass:"header"},[_vm._v("DRIVER DEDUCTIONS")]),_vm._v(" "),_c('div',{staticClass:"deductions-container"},[_c('div',{staticClass:"deduction-content"},[_c('deduction-list',{attrs:{"isMobile":_vm.isMobile}})],1)]),_vm._v(" "),_c('deduction-form'),_vm._v(" "),_c('deduction-delete')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(600);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_472e735e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1770);
function injectStyle (ssrContext) {
  __webpack_require__(1768)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-472e735e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_472e735e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1769);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("55affb95", content, true, {});

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.heading[data-v-472e735e] {\n  margin-left: 50px;\n  padding-left: 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.section-title[data-v-472e735e] {\n  margin: 20px 0 0;\n  font-size: 14px;\n  line-height: 14px;\n  color: #555;\n}\n.section-title strong[data-v-472e735e] {\n    text-decoration: underline;\n}\n.balances[data-v-472e735e] {\n  background-color: #fff;\n  padding: 15px;\n  border-radius: 5px;\n  -webkit-box-shadow: 0 3px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 3px 8px rgba(0, 0, 0, 0.3);\n}\n.balances .account-name[data-v-472e735e] {\n    font-size: 18px;\n    font-weight: 700;\n    color: #555;\n    margin-bottom: 10px;\n}\n.balances .balance[data-v-472e735e] {\n    text-align: right;\n    margin-top: 10px;\n}\n.balances .balance .amount[data-v-472e735e] {\n      font-size: 24px;\n      line-height: 24px;\n      color: #0D79F2;\n      margin-bottom: 5px;\n}\n.balances .balance .label[data-v-472e735e] {\n      font-size: 12px;\n      font-weight: 700;\n      color: #777;\n}\n.totals-group .group-label[data-v-472e735e] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #777;\n}\n.group-separator[data-v-472e735e] {\n  height: 0;\n  border-top: 1px dashed rgba(0, 0, 0, 0.5);\n  margin: 15px 0;\n}\n.select-input[data-v-472e735e] {\n  text-align: right;\n}\n.select-input label[data-v-472e735e] {\n    font-size: 14px;\n    font-weight: 700;\n    margin-right: 10px;\n    color: #777;\n}\n.select-input select[data-v-472e735e] {\n    margin-top: 5px;\n    border: 1px solid #ccc;\n    padding: 10px;\n    color: #333;\n    height: 40px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background: url(\"/assets/img/down.png\") no-repeat 173px 9px;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n    width: 200px;\n    background-color: #fff;\n}\n.topup-modal[data-v-472e735e] {\n  width: 400px;\n  margin: 0 auto;\n  text-align: center;\n  background-color: #fff;\n  border-radius: 7px;\n  padding: 20px 15px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  color: #777;\n}\n.topup-modal .fa-check-circle[data-v-472e735e] {\n    color: #26D97A;\n}\n.topup-modal .message[data-v-472e735e] {\n    margin-top: 10px;\n    color: #555;\n    font-size: 16px;\n}\n.topup-modal .close-button[data-v-472e735e] {\n    margin-top: 20px;\n}\n.topup-modal.providers-modal[data-v-472e735e] {\n    width: 500px;\n}\n.topup-modal.providers-modal .message[data-v-472e735e] {\n      margin: 0;\n}\n.topup-modal.providers-modal .title[data-v-472e735e] {\n      margin-bottom: 0;\n      font-weight: 600;\n      font-size: 18px;\n}\n.topup-modal.providers-modal .type[data-v-472e735e] {\n      font-size: 14px;\n      color: #888;\n      margin-bottom: 15px;\n}\n.topup-modal.providers-modal ul[data-v-472e735e] {\n      list-style: none;\n      display: block;\n      margin: 0;\n      padding: 0;\n      text-align: left;\n      border: 1px solid #ddd;\n      height: 300px;\n      overflow: auto;\n      -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);\n              box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);\n}\n.topup-modal.providers-modal ul li[data-v-472e735e] {\n        padding: 8px 10px;\n        border-bottom: 1px solid #eee;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.topup-modal.providers-modal ul li[data-v-472e735e]:nth-child(even) {\n          background: #F4F8F9;\n}\n.topup-modal.providers-modal ul .loading[data-v-472e735e] {\n        font-style: italic;\n        text-align: center;\n        padding: 15px;\n}\n.topup-modal.providers-modal ul a[data-v-472e735e] {\n        font-size: 15px;\n        color: #0d79f2;\n        font-weight: 600;\n        line-height: 1;\n        margin-bottom: 2px;\n        cursor: pointer;\n}\n.topup-modal.providers-modal ul div[data-v-472e735e] {\n        line-height: 1;\n}\n.topup-modal.providers-modal ul div span[data-v-472e735e] {\n          font-size: 13px;\n          color: #aaa;\n}\n.topup-modal.providers-modal ul div span i[data-v-472e735e] {\n            vertical-align: middle;\n            margin-right: 1px;\n}\n.topup-modal.providers-modal ul .email[data-v-472e735e] {\n        margin-right: 8px;\n}\nspan.license-type[data-v-472e735e] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  min-width: 50px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  font-size: 13px;\n  text-align: center;\n  float: right;\n}\nspan.license-type.tnc[data-v-472e735e] {\n    background-color: #2ab77c;\n}\nspan.license-type.tcp[data-v-472e735e] {\n    background-color: #3f81a0;\n}\nspan.license-type.psc[data-v-472e735e] {\n    background-color: #de6c2a;\n}\n.controls[data-v-472e735e] {\n  text-align: right;\n  margin-top: 10px;\n}\n.padding-L[data-v-472e735e] {\n  padding-left: 7px;\n}\n.padding-R[data-v-472e735e] {\n  padding-right: 7px;\n}\n.margin-T[data-v-472e735e] {\n  margin-top: 15px;\n}\n.margin-B[data-v-472e735e] {\n  margin-bottom: 30px;\n}\n.margin-T-z[data-v-472e735e] {\n  margin-top: 0 !important;\n}\n.payout-dates[data-v-472e735e] {\n  display: inline;\n}\n@media only screen and (max-width: 430px) {\n.row[data-v-472e735e] {\n    padding: 0 15px;\n}\n.small-4[data-v-472e735e], .small-8[data-v-472e735e], .small-6[data-v-472e735e], .small-7[data-v-472e735e], .small-5[data-v-472e735e] {\n    width: 100%;\n}\n.padding-L[data-v-472e735e], .padding-R[data-v-472e735e] {\n    padding: 5px 0;\n}\n.balances .account-name[data-v-472e735e] {\n    font-size: 15px;\n}\n.section-title[data-v-472e735e] {\n    text-align: center;\n    margin-bottom: 10px;\n    margin-top: 5px;\n}\n.section-title strong[data-v-472e735e] {\n      display: block;\n}\n.section-title .payout-dates[data-v-472e735e] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      gap: 5px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/ProviderPayouts/index.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;CAC3B;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;CACb;AACD;IACI,2BAA2B;CAC9B;AACD;EACE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,iDAAiD;UACzC,yCAAyC;CAClD;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;CACvB;AACD;IACI,kBAAkB;IAClB,iBAAiB;CACpB;AACD;MACM,gBAAgB;MAChB,kBAAkB;MAClB,eAAe;MACf,mBAAmB;CACxB;AACD;MACM,gBAAgB;MAChB,iBAAiB;MACjB,YAAY;CACjB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;CACb;AACD;EACE,UAAU;EACV,0CAA0C;EAC1C,eAAe;CAChB;AACD;EACE,kBAAkB;CACnB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;CACf;AACD;IACI,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,4DAA4D;IAC5D,kCAAkC;IAClC,0BAA0B;IAC1B,aAAa;IACb,uBAAuB;CAC1B;AACD;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;UACzC,yCAAyC;EACjD,YAAY;CACb;AACD;IACI,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;CACnB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,aAAa;CAChB;AACD;MACM,UAAU;CACf;AACD;MACM,iBAAiB;MACjB,iBAAiB;MACjB,gBAAgB;CACrB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,oBAAoB;CACzB;AACD;MACM,iBAAiB;MACjB,eAAe;MACf,UAAU;MACV,WAAW;MACX,iBAAiB;MACjB,uBAAuB;MACvB,cAAc;MACd,eAAe;MACf,+CAA+C;cACvC,uCAAuC;CACpD;AACD;QACQ,kBAAkB;QAClB,8BAA8B;QAC9B,iCAAiC;QACjC,yBAAyB;CAChC;AACD;UACU,oBAAoB;CAC7B;AACD;QACQ,mBAAmB;QACnB,mBAAmB;QACnB,cAAc;CACrB;AACD;QACQ,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,eAAe;QACf,mBAAmB;QACnB,gBAAgB;CACvB;AACD;QACQ,eAAe;CACtB;AACD;UACU,gBAAgB;UAChB,YAAY;CACrB;AACD;YACY,uBAAuB;YACvB,kBAAkB;CAC7B;AACD;QACQ,kBAAkB;CACzB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;CACd;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,yBAAyB;CAC1B;AACD;EACE,gBAAgB;CACjB;AACD;AACA;IACI,gBAAgB;CACnB;AACD;IACI,YAAY;CACf;AACD;IACI,eAAe;CAClB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;MACM,eAAe;CACpB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,yBAAyB;UACrB,sBAAsB;cAClB,wBAAwB;MAChC,SAAS;CACd;CACA","file":"index.vue","sourcesContent":["\n.heading[data-v-472e735e] {\n  margin-left: 50px;\n  padding-left: 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.section-title[data-v-472e735e] {\n  margin: 20px 0 0;\n  font-size: 14px;\n  line-height: 14px;\n  color: #555;\n}\n.section-title strong[data-v-472e735e] {\n    text-decoration: underline;\n}\n.balances[data-v-472e735e] {\n  background-color: #fff;\n  padding: 15px;\n  border-radius: 5px;\n  -webkit-box-shadow: 0 3px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 3px 8px rgba(0, 0, 0, 0.3);\n}\n.balances .account-name[data-v-472e735e] {\n    font-size: 18px;\n    font-weight: 700;\n    color: #555;\n    margin-bottom: 10px;\n}\n.balances .balance[data-v-472e735e] {\n    text-align: right;\n    margin-top: 10px;\n}\n.balances .balance .amount[data-v-472e735e] {\n      font-size: 24px;\n      line-height: 24px;\n      color: #0D79F2;\n      margin-bottom: 5px;\n}\n.balances .balance .label[data-v-472e735e] {\n      font-size: 12px;\n      font-weight: 700;\n      color: #777;\n}\n.totals-group .group-label[data-v-472e735e] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #777;\n}\n.group-separator[data-v-472e735e] {\n  height: 0;\n  border-top: 1px dashed rgba(0, 0, 0, 0.5);\n  margin: 15px 0;\n}\n.select-input[data-v-472e735e] {\n  text-align: right;\n}\n.select-input label[data-v-472e735e] {\n    font-size: 14px;\n    font-weight: 700;\n    margin-right: 10px;\n    color: #777;\n}\n.select-input select[data-v-472e735e] {\n    margin-top: 5px;\n    border: 1px solid #ccc;\n    padding: 10px;\n    color: #333;\n    height: 40px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background: url(\"/assets/img/down.png\") no-repeat 173px 9px;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n    width: 200px;\n    background-color: #fff;\n}\n.topup-modal[data-v-472e735e] {\n  width: 400px;\n  margin: 0 auto;\n  text-align: center;\n  background-color: #fff;\n  border-radius: 7px;\n  padding: 20px 15px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  color: #777;\n}\n.topup-modal .fa-check-circle[data-v-472e735e] {\n    color: #26D97A;\n}\n.topup-modal .message[data-v-472e735e] {\n    margin-top: 10px;\n    color: #555;\n    font-size: 16px;\n}\n.topup-modal .close-button[data-v-472e735e] {\n    margin-top: 20px;\n}\n.topup-modal.providers-modal[data-v-472e735e] {\n    width: 500px;\n}\n.topup-modal.providers-modal .message[data-v-472e735e] {\n      margin: 0;\n}\n.topup-modal.providers-modal .title[data-v-472e735e] {\n      margin-bottom: 0;\n      font-weight: 600;\n      font-size: 18px;\n}\n.topup-modal.providers-modal .type[data-v-472e735e] {\n      font-size: 14px;\n      color: #888;\n      margin-bottom: 15px;\n}\n.topup-modal.providers-modal ul[data-v-472e735e] {\n      list-style: none;\n      display: block;\n      margin: 0;\n      padding: 0;\n      text-align: left;\n      border: 1px solid #ddd;\n      height: 300px;\n      overflow: auto;\n      -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);\n              box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);\n}\n.topup-modal.providers-modal ul li[data-v-472e735e] {\n        padding: 8px 10px;\n        border-bottom: 1px solid #eee;\n        -webkit-transition: all .2s ease;\n        transition: all .2s ease;\n}\n.topup-modal.providers-modal ul li[data-v-472e735e]:nth-child(even) {\n          background: #F4F8F9;\n}\n.topup-modal.providers-modal ul .loading[data-v-472e735e] {\n        font-style: italic;\n        text-align: center;\n        padding: 15px;\n}\n.topup-modal.providers-modal ul a[data-v-472e735e] {\n        font-size: 15px;\n        color: #0d79f2;\n        font-weight: 600;\n        line-height: 1;\n        margin-bottom: 2px;\n        cursor: pointer;\n}\n.topup-modal.providers-modal ul div[data-v-472e735e] {\n        line-height: 1;\n}\n.topup-modal.providers-modal ul div span[data-v-472e735e] {\n          font-size: 13px;\n          color: #aaa;\n}\n.topup-modal.providers-modal ul div span i[data-v-472e735e] {\n            vertical-align: middle;\n            margin-right: 1px;\n}\n.topup-modal.providers-modal ul .email[data-v-472e735e] {\n        margin-right: 8px;\n}\nspan.license-type[data-v-472e735e] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  min-width: 50px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  font-size: 13px;\n  text-align: center;\n  float: right;\n}\nspan.license-type.tnc[data-v-472e735e] {\n    background-color: #2ab77c;\n}\nspan.license-type.tcp[data-v-472e735e] {\n    background-color: #3f81a0;\n}\nspan.license-type.psc[data-v-472e735e] {\n    background-color: #de6c2a;\n}\n.controls[data-v-472e735e] {\n  text-align: right;\n  margin-top: 10px;\n}\n.padding-L[data-v-472e735e] {\n  padding-left: 7px;\n}\n.padding-R[data-v-472e735e] {\n  padding-right: 7px;\n}\n.margin-T[data-v-472e735e] {\n  margin-top: 15px;\n}\n.margin-B[data-v-472e735e] {\n  margin-bottom: 30px;\n}\n.margin-T-z[data-v-472e735e] {\n  margin-top: 0 !important;\n}\n.payout-dates[data-v-472e735e] {\n  display: inline;\n}\n@media only screen and (max-width: 430px) {\n.row[data-v-472e735e] {\n    padding: 0 15px;\n}\n.small-4[data-v-472e735e], .small-8[data-v-472e735e], .small-6[data-v-472e735e], .small-7[data-v-472e735e], .small-5[data-v-472e735e] {\n    width: 100%;\n}\n.padding-L[data-v-472e735e], .padding-R[data-v-472e735e] {\n    padding: 5px 0;\n}\n.balances .account-name[data-v-472e735e] {\n    font-size: 15px;\n}\n.section-title[data-v-472e735e] {\n    text-align: center;\n    margin-bottom: 10px;\n    margin-top: 5px;\n}\n.section-title strong[data-v-472e735e] {\n      display: block;\n}\n.section-title .payout-dates[data-v-472e735e] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      gap: 5px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"provider-payouts"},[_c('div',{staticClass:"heading"},[_vm._v("PAYOUTS")]),_vm._v(" "),_c('div',{staticClass:"stripe-accounts"},[_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-8 columns"},[_c('div',{staticClass:"section-title"},[_c('span',[_vm._v("Available Balance in Stripe as of")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.now.format('MM/DD/YYYY hh:mm A')))])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[_c('div',{staticClass:"controls"},[_c('a',{staticClass:"button cta xsmall success",attrs:{"href":"javascript:;"},on:{"click":_vm.refresh}},[_vm._v("REFRESH")])])])]),_vm._v(" "),_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('div',{staticClass:"balances"},[_c('div',{staticClass:"account-name"},[_vm._v("Executive Ride")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"balance margin-T-z"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.er.loading),expression:"er.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.er.loading),expression:"!er.loading"}]},[_vm._v("$"+_vm._s(_vm.er.available.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Available Balance")])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"balance margin-T-z"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.er.loading || _vm.total.loading),expression:"er.loading || total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.er.loading && !_vm.total.loading),expression:"!er.loading && !total.loading"}]},[_vm._v("$"+_vm._s(_vm.requiredER.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Balance required for Auto-Deposit")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.isOpenBatch),expression:"!total.isOpenBatch"}],staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"payout-controls"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.requiredER > 0),expression:"requiredER > 0"}],staticClass:"button small cta block margin-T",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.createTopup(true)}}},[_c('span',[_vm._v("Top-up")]),_vm._v(" "),_c('strong',[_vm._v("$"+_vm._s(_vm.requiredER.toFixed(2)))]),_vm._v(" "),_c('span',[_vm._v("to Executive Ride")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.requiredER <= 0 && _vm.total.er.pending.amount > 0),expression:"requiredER <= 0 && total.er.pending.amount > 0"}],staticClass:"button small cta block success margin-T",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.startAutodeposit(true)}}},[_c('span',[_vm._v("Auto-Deposit")]),_vm._v(" "),_c('strong',[_vm._v("$"+_vm._s(_vm.total.er.pending.amount.toFixed(2)))]),_vm._v(" "),_c('span',[_vm._v("to Drivers")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('div',{staticClass:"balances"},[_c('div',{staticClass:"account-name"},[_vm._v("First Class Transportation")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"balance margin-T-z"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.fct.loading),expression:"fct.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.fct.loading),expression:"!fct.loading"}]},[_vm._v("$"+_vm._s(_vm.fct.available.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Available Balance")])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"balance margin-T-z"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.fct.loading || _vm.total.loading),expression:"fct.loading || total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.fct.loading && !_vm.total.loading),expression:"!fct.loading && !total.loading"}]},[_vm._v("$"+_vm._s(_vm.requiredFCT.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Balance required for Auto-Deposit")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.isOpenBatch),expression:"!total.isOpenBatch"}],staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"payout-controls"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.requiredFCT > 0),expression:"requiredFCT > 0"}],staticClass:"button small cta block margin-T",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.createTopup(false)}}},[_c('span',[_vm._v("Top-up")]),_vm._v(" "),_c('strong',[_vm._v("$"+_vm._s(_vm.requiredFCT.toFixed(2)))]),_vm._v(" "),_c('span',[_vm._v("to Executive Ride")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.requiredFCT <= 0 && _vm.total.fct.pending.amount > 0),expression:"requiredFCT <= 0 && total.fct.pending.amount > 0"}],staticClass:"button small cta block success margin-T",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.startAutodeposit(false)}}},[_c('span',[_vm._v("Auto-Deposit")]),_vm._v(" "),_c('strong',[_vm._v("$"+_vm._s(_vm.total.fct.pending.amount.toFixed(2)))]),_vm._v(" "),_c('span',[_vm._v("to Drivers")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-7 columns"},[(_vm.filter.selectedWeek !== null)?_c('div',{staticClass:"section-title"},[_c('span',[_vm._v("Driver Payouts for")]),_vm._v(" "),_c('div',{staticClass:"payout-dates"},[_c('strong',[_vm._v(_vm._s(_vm.filter.selectedWeek.start.format('MM/DD/YYYY')))]),_vm._v(" "),_c('span',[_vm._v("to")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.filter.selectedWeek.end.format('MM/DD/YYYY')))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"small-5 columns"},[_c('div',{staticClass:"select-input"},[_c('label',[_vm._v("Choose a batch:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter.selectedWeek),expression:"filter.selectedWeek"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filter, "selectedWeek", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.getPayouts]}},_vm._l((_vm.filter.weeks),function(week,index){return _c('option',{domProps:{"value":week}},[_vm._v("\n              "+_vm._s(week.start.format('MMM DD'))+" - "+_vm._s(week.end.format('MMM DD'))+"\n            ")])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.isOpenBatch),expression:"!total.isOpenBatch"}],staticClass:"row margin-T margin-B"},[_c('div',{staticClass:"small-4 columns padding-R"},[_c('div',{staticClass:"balances"},[_c('div',{staticClass:"account-name"},[_vm._v("Executive Ride Payouts")]),_vm._v(" "),_c('div',{staticClass:"totals-group"},[_c('div',{staticClass:"group-label"},[_vm._v("PENDING PAYOUTS")]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}],on:{"click":function($event){return _vm.showProviders(_vm.total.er.pending, 'Executive Ride Payouts', 'pending')}}},[_vm._v(_vm._s(_vm.total.er.pending.count))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Number of Drivers")])]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}]},[_vm._v("$"+_vm._s(_vm.total.er.pending.amount.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Total Amount")])])]),_vm._v(" "),_c('div',{staticClass:"group-separator"}),_vm._v(" "),_c('div',{staticClass:"totals-group"},[_c('div',{staticClass:"group-label"},[_vm._v("PAID PAYOUTS")]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}],on:{"click":function($event){return _vm.showProviders(_vm.total.er.paid, 'Executive Ride Payouts', 'paid')}}},[_vm._v(_vm._s(_vm.total.er.paid.count))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Number of Drivers")])]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}]},[_vm._v("$"+_vm._s(_vm.total.er.paid.amount.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Total Amount")])])]),_vm._v(" "),_c('div',{staticClass:"group-separator"}),_vm._v(" "),_c('div',{staticClass:"totals-group"},[_c('div',{staticClass:"group-label"},[_vm._v("IN TRANSIT PAYOUTS")]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}],on:{"click":function($event){return _vm.showProviders(_vm.total.er.in_transit, 'Executive Ride Payouts', 'in transit')}}},[_vm._v(_vm._s(_vm.total.er.in_transit.count))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Number of Drivers")])]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}]},[_vm._v("$"+_vm._s(_vm.total.er.in_transit.amount.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Total Amount")])])]),_vm._v(" "),_c('div',{staticClass:"group-separator"}),_vm._v(" "),_c('div',{staticClass:"totals-group"},[_c('div',{staticClass:"group-label"},[_vm._v("CANCELED PAYOUTS")]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}],on:{"click":function($event){return _vm.showProviders(_vm.total.er.canceled, 'Executive Ride Payouts', 'canceled')}}},[_vm._v(_vm._s(_vm.total.er.canceled.count))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Number of Drivers")])]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}]},[_vm._v("$"+_vm._s(_vm.total.er.canceled.amount.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Total Amount")])])]),_vm._v(" "),_c('div',{staticClass:"group-separator"}),_vm._v(" "),_c('div',{staticClass:"totals-group"},[_c('div',{staticClass:"group-label"},[_vm._v("FAILED PAYOUTS")]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}],on:{"click":function($event){return _vm.showProviders(_vm.total.er.failed, 'Executive Ride Payouts', 'falied')}}},[_vm._v(_vm._s(_vm.total.er.failed.count))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Number of Drivers")])]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}]},[_vm._v("$"+_vm._s(_vm.total.er.failed.amount.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Total Amount")])])])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-L padding-R"},[_c('div',{staticClass:"balances"},[_c('div',{staticClass:"account-name"},[_vm._v("First Class Transportation Payouts")]),_vm._v(" "),_c('div',{staticClass:"totals-group"},[_c('div',{staticClass:"group-label"},[_vm._v("PENDING PAYOUTS")]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}],on:{"click":function($event){return _vm.showProviders(_vm.total.fct.pending, 'First Class Transportation Payouts', 'pending')}}},[_vm._v(_vm._s(_vm.total.fct.pending.count))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Number of Drivers")])]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}]},[_vm._v("$"+_vm._s(_vm.total.fct.pending.amount.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Total Amount")])])]),_vm._v(" "),_c('div',{staticClass:"group-separator"}),_vm._v(" "),_c('div',{staticClass:"totals-group"},[_c('div',{staticClass:"group-label"},[_vm._v("PAID PAYOUTS")]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}],on:{"click":function($event){return _vm.showProviders(_vm.total.fct.paid, 'First Class Transportation Payouts', 'paid')}}},[_vm._v(_vm._s(_vm.total.fct.paid.count))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Number of Drivers")])]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}]},[_vm._v("$"+_vm._s(_vm.total.fct.paid.amount.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Total Amount")])])]),_vm._v(" "),_c('div',{staticClass:"group-separator"}),_vm._v(" "),_c('div',{staticClass:"totals-group"},[_c('div',{staticClass:"group-label"},[_vm._v("IN TRANSIT PAYOUTS")]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}],on:{"click":function($event){return _vm.showProviders(_vm.total.fct.in_transit, 'First Class Transportation Payouts', 'in transit')}}},[_vm._v(_vm._s(_vm.total.fct.in_transit.count))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Number of Drivers")])]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}]},[_vm._v("$"+_vm._s(_vm.total.fct.in_transit.amount.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Total Amount")])])]),_vm._v(" "),_c('div',{staticClass:"group-separator"}),_vm._v(" "),_c('div',{staticClass:"totals-group"},[_c('div',{staticClass:"group-label"},[_vm._v("CANCELED PAYOUTS")]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}],on:{"click":function($event){return _vm.showProviders(_vm.total.fct.canceled, 'First Class Transportation Payouts', 'canceled')}}},[_vm._v(_vm._s(_vm.total.fct.canceled.count))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Number of Drivers")])]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}]},[_vm._v("$"+_vm._s(_vm.total.fct.canceled.amount.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Total Amount")])])]),_vm._v(" "),_c('div',{staticClass:"group-separator"}),_vm._v(" "),_c('div',{staticClass:"totals-group"},[_c('div',{staticClass:"group-label"},[_vm._v("FAILED PAYOUTS")]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}],on:{"click":function($event){return _vm.showProviders(_vm.total.fct.failed, 'First Class Transportation Payouts', 'failed')}}},[_vm._v(_vm._s(_vm.total.fct.failed.count))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Number of Drivers")])]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}]},[_vm._v("$"+_vm._s(_vm.total.fct.failed.amount.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Total Amount")])])])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-L"},[_c('div',{staticClass:"balances"},[_c('div',{staticClass:"account-name"},[_vm._v("Non Auto-Deposit Payouts")]),_vm._v(" "),_c('div',{staticClass:"totals-group"},[_c('div',{staticClass:"group-label"},[_vm._v("PENDING PAYOUTS")]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}],on:{"click":function($event){return _vm.showProviders(_vm.total.check.pending, 'Non Auto-Deposit Payouts', 'pending')}}},[_vm._v(_vm._s(_vm.total.check.pending.count))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Number of Drivers")])]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}]},[_vm._v("$"+_vm._s(_vm.total.check.pending.amount.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Total Amount")])])]),_vm._v(" "),_c('div',{staticClass:"group-separator"}),_vm._v(" "),_c('div',{staticClass:"totals-group"},[_c('div',{staticClass:"group-label"},[_vm._v("PAID PAYOUTS")]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}],on:{"click":function($event){return _vm.showProviders(_vm.total.check.paid, 'Non Auto-Deposit Payouts', 'paid')}}},[_vm._v(_vm._s(_vm.total.check.paid.count))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Number of Drivers")])]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}]},[_vm._v("$"+_vm._s(_vm.total.check.paid.amount.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Total Amount")])])]),_vm._v(" "),_c('div',{staticClass:"group-separator"}),_vm._v(" "),_c('div',{staticClass:"totals-group"},[_c('div',{staticClass:"group-label"},[_vm._v("IN TRANSIT PAYOUTS")]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}],on:{"click":function($event){return _vm.showProviders(_vm.total.check.in_transit, 'Non Auto-Deposit Payouts', 'in transit')}}},[_vm._v(_vm._s(_vm.total.check.in_transit.count))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Number of Drivers")])]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}]},[_vm._v("$"+_vm._s(_vm.total.check.in_transit.amount.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Total Amount")])])]),_vm._v(" "),_c('div',{staticClass:"group-separator"}),_vm._v(" "),_c('div',{staticClass:"totals-group"},[_c('div',{staticClass:"group-label"},[_vm._v("CANCELED PAYOUTS")]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}],on:{"click":function($event){return _vm.showProviders(_vm.total.check.canceled, 'Non Auto-Deposit Payouts', 'canceled')}}},[_vm._v(_vm._s(_vm.total.check.canceled.count))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Number of Drivers")])]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}]},[_vm._v("$"+_vm._s(_vm.total.check.canceled.amount.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Total Amount")])])]),_vm._v(" "),_c('div',{staticClass:"group-separator"}),_vm._v(" "),_c('div',{staticClass:"totals-group"},[_c('div',{staticClass:"group-label"},[_vm._v("FAILED PAYOUTS")]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}],on:{"click":function($event){return _vm.showProviders(_vm.total.check.failed, 'Non Auto-Deposit Payouts', 'failed')}}},[_vm._v(_vm._s(_vm.total.check.failed.count))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Number of Drivers")])]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}]},[_vm._v("$"+_vm._s(_vm.total.check.failed.amount.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Total Amount")])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.isOpenBatch),expression:"total.isOpenBatch"}],staticClass:"row margin-T margin-B"},[_c('div',{staticClass:"small-6 padding-R columns"},[_c('div',{staticClass:"balances"},[_c('div',{staticClass:"account-name"},[_vm._v("Running Credits")]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}]},[_vm._v(_vm._s(_vm.total.openBatch.credits.count.length))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Number of Drivers with Credits")])]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}]},[_vm._v("$"+_vm._s(_vm.total.openBatch.credits.amount.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Total Credits")])])])]),_vm._v(" "),_c('div',{staticClass:"small-6 padding-L columns"},[_c('div',{staticClass:"balances"},[_c('div',{staticClass:"account-name"},[_vm._v("Running Debits")]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}]},[_vm._v(_vm._s(_vm.total.openBatch.debits.count.length))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Number of Drivers with Debits")])]),_vm._v(" "),_c('div',{staticClass:"balance"},[_c('div',{staticClass:"amount"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.total.loading),expression:"total.loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.total.loading),expression:"!total.loading"}]},[_vm._v("-($"+_vm._s(_vm.total.openBatch.debits.amount.toFixed(2))+")")])]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Total Debits")])])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.topup.loading),expression:"topup.loading"}],staticClass:"global-modal"},[_c('div',{staticClass:"global-modal-content"},[_c('div',{staticClass:"topup-modal"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-2x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.topup.message))])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.topup.showSuccess),expression:"topup.showSuccess"}],staticClass:"global-modal"},[_c('div',{staticClass:"global-modal-content"},[_c('div',{staticClass:"topup-modal"},[_c('i',{staticClass:"fa fa-check-circle fa-2x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("Top-up was successful.")]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("\n            To check the status of your top-up, log-in to your Stripe Dashboard and go to\n            "),_c('a',{attrs:{"target":"_blank","href":_vm.stripeConfig.topupURL}},[_vm._v("Balance "),_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" Top-ups")]),_vm._v(".\n          ")]),_vm._v(" "),_c('a',{staticClass:"button cta small block close-button",attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.topup.showSuccess = false}}},[_vm._v("OK, I GOT IT.")])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.autodeposit.loading),expression:"autodeposit.loading"}],staticClass:"global-modal"},[_c('div',{staticClass:"global-modal-content"},[_c('div',{staticClass:"topup-modal"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-2x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.autodeposit.message))])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.autodeposit.showSuccess),expression:"autodeposit.showSuccess"}],staticClass:"global-modal"},[_c('div',{staticClass:"global-modal-content"},[_c('div',{staticClass:"topup-modal"},[_c('i',{staticClass:"fa fa-check-circle fa-2x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("Auto-Deposit was successful.")]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("\n            To check the status of the payouts, log-in to your Stripe Dashboard and go to\n            "),_c('a',{attrs:{"target":"_blank","href":_vm.stripeConfig.transferURL}},[_vm._v("Connect "),_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" Transfers")]),_vm._v(".\n          ")]),_vm._v(" "),_c('a',{staticClass:"button cta small block close-button",attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.autodeposit.showSuccess = false}}},[_vm._v("OK, I GOT IT.")])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.provBatch.show),expression:"provBatch.show"}],staticClass:"global-modal"},[_c('div',{staticClass:"global-modal-content"},[_c('div',{staticClass:"topup-modal providers-modal"},[_c('div',{staticClass:"message title"},[_vm._v(_vm._s(_vm.provBatch.title))]),_vm._v(" "),_c('div',{staticClass:"message type"},[_vm._v("Drivers with "+_vm._s(_vm.provBatch.type)+" payouts.")]),_vm._v(" "),_c('ul',[(_vm.provBatch.loading)?_c('li',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading...\n            ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.provBatch.filteredData),function(prov){return (!_vm.provBatch.loading)?_c('li',[_c('span',{class:['license-type', prov.licenseType]},[_vm._v(_vm._s(prov.licenseType))]),_vm._v(" "),_c('a',{attrs:{"href":'/#/provider/' + prov.id + '?payouts',"target":"_blank"}},[_vm._v(_vm._s(prov.name))]),_vm._v(" "),_c('div',[_c('span',{staticClass:"email"},[_c('i',{staticClass:"fas fa-envelope"}),_vm._v(" "+_vm._s(prov.email))]),_vm._v(" "),_c('span',{staticClass:"phone"},[_c('i',{staticClass:"fas fa-phone-square"}),_vm._v(" "+_vm._s(prov.phone))])])]):_vm._e()})],2),_vm._v(" "),_c('a',{staticClass:"button cta small block close-button",on:{"click":function($event){_vm.provBatch.show = false}}},[_vm._v("close")])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrintPlacard_vue__ = __webpack_require__(601);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0133ddc4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrintPlacard_vue__ = __webpack_require__(1774);
function injectStyle (ssrContext) {
  __webpack_require__(1772)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrintPlacard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0133ddc4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrintPlacard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1773);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("788fb513", content, true, {});

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\nbody {\n  background: #ececec;\n}\n#side-menu {\n  display: none;\n}\n.dad-wrap {\n  height: 100vh;\n  position: relative;\n}\n.card {\n  position: relative;\n  width: 528px;\n  height: 408px;\n  border-radius: 0;\n  border: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  position: absolute;\n  bottom: 10px;\n  left: calc(50% - 264px);\n}\n.card .card-bg {\n    width: 528px;\n    height: 409px;\n}\n.card .qr {\n    position: absolute;\n    top: 65px;\n    left: 61px;\n    width: 172px;\n    height: 172px;\n    background: rgba(0, 0, 0, 0.3);\n    z-index: 2;\n}\n.card .qr.loading {\n      opacity: .5;\n}\n.card .loader {\n    position: absolute;\n    top: 110px;\n    left: 110px;\n    z-index: 3;\n    color: #2581e0;\n}\n.card span {\n    position: absolute;\n    color: #222;\n    font-weight: 600;\n    display: inline-block;\n    line-height: 1;\n    z-index: 2;\n}\n.card .tnc-name {\n    top: 105px;\n    left: 270px;\n    width: 180px;\n    font-size: 24px;\n    text-align: center;\n}\n.card .issue-date {\n    top: 175px;\n    left: 270px;\n    width: 180px;\n    font-size: 26px;\n    padding: 2px 0;\n    text-align: center;\n    border: 1px solid transparent;\n    letter-spacing: 2px;\n    cursor: pointer;\n}\n.card .issue-date:hover {\n      border: 1px solid #ccc;\n}\n.card input {\n    z-index: 3;\n    position: absolute;\n    padding: 0 5px !important;\n    font-weight: 600;\n    font-size: 26px !important;\n}\n.card .issue-input {\n    top: 160px;\n    left: 270px;\n    width: 180px;\n    text-align: center;\n    height: 32px;\n    letter-spacing: 2px;\n}\n.card .license-plate {\n    top: 257px;\n    left: 266px;\n    width: 170px;\n    font-size: 22px;\n    text-align: left;\n}\n.card .driver-id {\n    top: 285px;\n    left: 240px;\n    width: 160px;\n    font-size: 22px;\n    text-align: left;\n    border: 1px solid transparent;\n    padding: 2px 0;\n    word-wrap: break-word;\n    line-height: 1;\n    cursor: pointer;\n}\n.card .driver-id:hover {\n      border: 1px solid #ccc;\n}\n.card .driver-input {\n    top: 268px;\n    left: 240px;\n    width: 160px;\n    height: 32px;\n    font-size: 22px !important;\n    text-align: left;\n    line-height: 1;\n    padding: 0 !important;\n    word-wrap: break-word;\n}\n.page-break {\n  page-break-after: always;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Provider/PrintPlacard.vue"],"names":[],"mappings":";AACA;EACE,oBAAoB;CACrB;AACD;EACE,cAAc;CACf;AACD;EACE,cAAc;EACd,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,yBAAyB;UACjB,iBAAiB;EACzB,mBAAmB;EACnB,aAAa;EACb,wBAAwB;CACzB;AACD;IACI,aAAa;IACb,cAAc;CACjB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,aAAa;IACb,cAAc;IACd,+BAA+B;IAC/B,WAAW;CACd;AACD;MACM,YAAY;CACjB;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,eAAe;CAClB;AACD;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,WAAW;CACd;AACD;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,mBAAmB;CACtB;AACD;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;IACpB,gBAAgB;CACnB;AACD;MACM,uBAAuB;CAC5B;AACD;IACI,WAAW;IACX,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;IACjB,2BAA2B;CAC9B;AACD;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,oBAAoB;CACvB;AACD;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;CACpB;AACD;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,8BAA8B;IAC9B,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,gBAAgB;CACnB;AACD;MACM,uBAAuB;CAC5B;AACD;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;IACb,2BAA2B;IAC3B,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,sBAAsB;CACzB;AACD;EACE,yBAAyB;CAC1B","file":"PrintPlacard.vue","sourcesContent":["\nbody {\n  background: #ececec;\n}\n#side-menu {\n  display: none;\n}\n.dad-wrap {\n  height: 100vh;\n  position: relative;\n}\n.card {\n  position: relative;\n  width: 528px;\n  height: 408px;\n  border-radius: 0;\n  border: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  position: absolute;\n  bottom: 10px;\n  left: calc(50% - 264px);\n}\n.card .card-bg {\n    width: 528px;\n    height: 409px;\n}\n.card .qr {\n    position: absolute;\n    top: 65px;\n    left: 61px;\n    width: 172px;\n    height: 172px;\n    background: rgba(0, 0, 0, 0.3);\n    z-index: 2;\n}\n.card .qr.loading {\n      opacity: .5;\n}\n.card .loader {\n    position: absolute;\n    top: 110px;\n    left: 110px;\n    z-index: 3;\n    color: #2581e0;\n}\n.card span {\n    position: absolute;\n    color: #222;\n    font-weight: 600;\n    display: inline-block;\n    line-height: 1;\n    z-index: 2;\n}\n.card .tnc-name {\n    top: 105px;\n    left: 270px;\n    width: 180px;\n    font-size: 24px;\n    text-align: center;\n}\n.card .issue-date {\n    top: 175px;\n    left: 270px;\n    width: 180px;\n    font-size: 26px;\n    padding: 2px 0;\n    text-align: center;\n    border: 1px solid transparent;\n    letter-spacing: 2px;\n    cursor: pointer;\n}\n.card .issue-date:hover {\n      border: 1px solid #ccc;\n}\n.card input {\n    z-index: 3;\n    position: absolute;\n    padding: 0 5px !important;\n    font-weight: 600;\n    font-size: 26px !important;\n}\n.card .issue-input {\n    top: 160px;\n    left: 270px;\n    width: 180px;\n    text-align: center;\n    height: 32px;\n    letter-spacing: 2px;\n}\n.card .license-plate {\n    top: 257px;\n    left: 266px;\n    width: 170px;\n    font-size: 22px;\n    text-align: left;\n}\n.card .driver-id {\n    top: 285px;\n    left: 240px;\n    width: 160px;\n    font-size: 22px;\n    text-align: left;\n    border: 1px solid transparent;\n    padding: 2px 0;\n    word-wrap: break-word;\n    line-height: 1;\n    cursor: pointer;\n}\n.card .driver-id:hover {\n      border: 1px solid #ccc;\n}\n.card .driver-input {\n    top: 268px;\n    left: 240px;\n    width: 160px;\n    height: 32px;\n    font-size: 22px !important;\n    text-align: left;\n    line-height: 1;\n    padding: 0 !important;\n    word-wrap: break-word;\n}\n.page-break {\n  page-break-after: always;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"dad-wrap"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"main-card card-bg",attrs:{"src":_vm.frontUrl}}),_vm._v(" "),_c('img',{class:{'qr':true, 'loading':_vm.qrLoading },attrs:{"src":_vm.qrUrl}}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.qrLoading),expression:"qrLoading"}],staticClass:"fa fa-spinner fa-spin loader fa-5x"}),_vm._v(" "),(!_vm.issueActive)?_c('span',{staticClass:"issue-date",on:{"click":_vm.showIssueInput}},[_vm._v(_vm._s(_vm.issueDate))]):_vm._e(),_vm._v(" "),(_vm.issueActive)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.issueDate),expression:"issueDate"}],ref:"issueInput",staticClass:"issue-input",attrs:{"type":"text"},domProps:{"value":(_vm.issueDate)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.issueUpdate.apply(null, arguments)},"blur":_vm.issueUpdate,"input":function($event){if($event.target.composing){ return; }_vm.issueDate=$event.target.value}}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"license-plate"},[_vm._v(_vm._s(_vm.license))]),_vm._v(" "),(!_vm.driverActive)?_c('span',{staticClass:"driver-id",on:{"click":_vm.showDriverInput}},[_vm._v(_vm._s(_vm.driverID))]):_vm._e(),_vm._v(" "),(_vm.driverActive)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.driverID),expression:"driverID"}],ref:"driverInput",staticClass:"driver-input",attrs:{"type":"text"},domProps:{"value":(_vm.driverID)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.driverUpdate.apply(null, arguments)},"blur":_vm.driverUpdate,"input":function($event){if($event.target.composing){ return; }_vm.driverID=$event.target.value}}}):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"page-break"})]),_vm._v(" "),_c('div',{staticClass:"dad-wrap"},[_c('div',{staticClass:"card right"},[_c('img',{staticClass:"card-bg",attrs:{"src":_vm.backUrl}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index2_vue__ = __webpack_require__(602);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e347e5b6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index2_vue__ = __webpack_require__(1832);
function injectStyle (ssrContext) {
  __webpack_require__(1776)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e347e5b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e347e5b6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1777);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4ecd78b6", content, true, {});

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.status[data-v-e347e5b6] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-e347e5b6], .status.completed[data-v-e347e5b6] {\n    background: #26D97A;\n}\n.status.canceled[data-v-e347e5b6], .status.cancelled[data-v-e347e5b6], .status.failed[data-v-e347e5b6] {\n    background: #bbb;\n}\n.status.upcoming[data-v-e347e5b6] {\n    background: #f38d56;\n}\n.status.onboard[data-v-e347e5b6] {\n    background: #dc3168;\n}\n.status.ready[data-v-e347e5b6] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-e347e5b6], .status.requires_dispatch[data-v-e347e5b6] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-e347e5b6] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-e347e5b6] {\n    background: #5662f3;\n}\n.flight-status[data-v-e347e5b6] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-e347e5b6] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-e347e5b6] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-e347e5b6] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-e347e5b6] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-e347e5b6] {\n    background-color: #f35656;\n}\n*[data-v-e347e5b6] {\n  -webkit-overflow-scrolling: touch;\n}\n.route-map[data-v-e347e5b6],\n.left-panel[data-v-e347e5b6],\n.right-panel[data-v-e347e5b6],\n.fixed-bottom[data-v-e347e5b6] {\n  -webkit-transition: all .6s ease;\n  transition: all .6s ease;\n}\n.logs-toggle[data-v-e347e5b6] {\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 3;\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  text-align: center;\n  color: #777;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  border-radius: 0;\n  background-color: #F25E0D;\n  color: #fff;\n  border-bottom-left-radius: 3px;\n  -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n          box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n  -webkit-transition: .5s ease;\n  transition: .5s ease;\n}\n.logs-toggle i[data-v-e347e5b6] {\n    line-height: inherit;\n}\n.logs-toggle.on[data-v-e347e5b6] {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n    -webkit-transition: .5s ease;\n    transition: .5s ease;\n}\n.route-map[data-v-e347e5b6] {\n  position: fixed;\n  top: 0;\n  left: 652px;\n  width: calc(100% - (652px));\n  height: 100%;\n  z-index: 1;\n  display: none;\n  /* ADDED */\n}\n.map-here[data-v-e347e5b6] {\n  position: fixed;\n  top: 0;\n  left: 652px;\n  width: calc(100% - (652px));\n  height: 100%;\n  z-index: 1;\n}\n.map-box[data-v-e347e5b6] {\n  position: fixed;\n  top: 0;\n  left: 652px;\n  width: calc(100% - (652px));\n  height: 100%;\n  z-index: 2;\n}\n.map-box .legend[data-v-e347e5b6], .map-box .cancel-data-box[data-v-e347e5b6] {\n    position: absolute;\n    bottom: 15px;\n    right: 15px;\n    background: #fff;\n    border: 1px solid #999;\n    padding: 5px 10px;\n    z-index: 2;\n    -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);\n            box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);\n    border-radius: 2px;\n}\n.map-box .legend ul[data-v-e347e5b6], .map-box .cancel-data-box ul[data-v-e347e5b6] {\n      list-style-type: none;\n      margin: 0;\n      padding: 0;\n}\n.map-box .legend ul .icon[data-v-e347e5b6], .map-box .cancel-data-box ul .icon[data-v-e347e5b6] {\n        display: inline-block;\n        border: 1px solid #777;\n        width: 12px;\n        height: 12px;\n        vertical-align: -1px;\n        border-radius: 2px;\n}\n.map-box .legend ul .icon.pickup[data-v-e347e5b6], .map-box .cancel-data-box ul .icon.pickup[data-v-e347e5b6] {\n          background: #2ee47d;\n}\n.map-box .legend ul .icon.extra-stop[data-v-e347e5b6], .map-box .cancel-data-box ul .icon.extra-stop[data-v-e347e5b6] {\n          background: #fe8214;\n}\n.map-box .legend ul .icon.dropoff[data-v-e347e5b6], .map-box .cancel-data-box ul .icon.dropoff[data-v-e347e5b6] {\n          background: #ca3538;\n}\n.map-box .legend ul .icon.ontheway[data-v-e347e5b6], .map-box .cancel-data-box ul .icon.ontheway[data-v-e347e5b6] {\n          background: #dbd935;\n}\n.map-box .legend ul .icon.arrived[data-v-e347e5b6], .map-box .legend ul .icon.onboard[data-v-e347e5b6], .map-box .cancel-data-box ul .icon.arrived[data-v-e347e5b6], .map-box .cancel-data-box ul .icon.onboard[data-v-e347e5b6] {\n          background: #389ce1;\n}\n.map-box .legend ul .icon.completed[data-v-e347e5b6], .map-box .cancel-data-box ul .icon.completed[data-v-e347e5b6] {\n          background: #1ac1b1;\n}\n.map-box .legend ul .icon.canceled[data-v-e347e5b6], .map-box .cancel-data-box ul .icon.canceled[data-v-e347e5b6] {\n          background: #bbb;\n}\n.map-box .legend ul li[data-v-e347e5b6] {\n    display: inline-block;\n    padding-right: 15px;\n}\n.map-box .legend ul li[data-v-e347e5b6]:last-child {\n      padding-right: 0;\n}\n.map-box .legend ul li span[data-v-e347e5b6] {\n      font-size: 13px;\n      color: #333;\n}\n.map-box .cancel-data-box[data-v-e347e5b6] {\n    font-size: 13px;\n}\n.map-box .cancel-data-box li[data-v-e347e5b6] {\n      display: block;\n      margin-bottom: 3px;\n}\n.map-box .cancel-data-box label[data-v-e347e5b6] {\n      color: #999;\n      margin-right: 5px;\n}\n.map-box .cancel-data-box label div[data-v-e347e5b6] {\n        margin-right: 4px;\n}\n.map-box .cancel-data-box span[data-v-e347e5b6] {\n      font-weight: 600;\n      color: #444;\n}\n.render-loader[data-v-e347e5b6] {\n  position: fixed;\n  z-index: 2;\n  bottom: 20px;\n  right: 20px;\n}\n.render-loader .map-loading[data-v-e347e5b6] {\n    color: #fff;\n    font-size: 12px;\n    font-weight: 700;\n    background-color: #F25E0D;\n    padding: 5px 10px;\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);\n}\n.heading[data-v-e347e5b6] {\n  font-weight: 600;\n  color: #333;\n  padding: 10px 0;\n}\n.heading span[data-v-e347e5b6] {\n    margin-left: 15px;\n}\n.heading .label[data-v-e347e5b6] {\n    font-size: 20px;\n    line-height: 100%;\n    display: block;\n}\n.heading .edit[data-v-e347e5b6], .heading .rtg[data-v-e347e5b6] {\n    float: right;\n    margin-right: 5px;\n}\n.heading .cxl-reason[data-v-e347e5b6] {\n    margin-left: 2px;\n    font-size: 12px;\n    color: #777;\n    display: inline-block;\n    width: 480px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    vertical-align: middle;\n}\n.heading .track-link[data-v-e347e5b6] {\n    font-size: 12px;\n    letter-spacing: .7px;\n    margin-left: 5px;\n}\n.heading .lyft-link[data-v-e347e5b6] {\n    color: #ff00bf;\n}\n.mtech-id[data-v-e347e5b6] {\n  margin-left: 0 !important;\n  color: #7a878a;\n  font-size: 16px;\n  display: block;\n}\n.mtech-id span[data-v-e347e5b6] {\n    margin-left: 1px;\n}\n.status.ready[data-v-e347e5b6] {\n  background: #6dabc3;\n}\n.status.accepted[data-v-e347e5b6] {\n  background: #777;\n}\n.status.on-time[data-v-e347e5b6] {\n  background: #26d97a;\n}\n.status.late[data-v-e347e5b6] {\n  background: #dc9831;\n}\n.status.ontheway[data-v-e347e5b6] {\n  background: #f38d56;\n}\n.status.very-late[data-v-e347e5b6] {\n  background: #e62e2e;\n}\n.status.open-credit[data-v-e347e5b6] {\n  background: #29c3c3;\n}\n.left-panel[data-v-e347e5b6] {\n  position: fixed;\n  z-index: 2;\n  left: 0;\n  top: 0;\n  width: 652px;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #F4F8F9;\n  overflow-y: auto;\n  padding-bottom: 60px;\n}\n.left-panel .heading[data-v-e347e5b6] {\n    padding-left: 50px;\n}\n.left-panel .tab li[data-v-e347e5b6] {\n    width: 33.3%;\n}\n.left-panel .toggle-mobile[data-v-e347e5b6] {\n    display: none;\n}\n.tab[data-v-e347e5b6] {\n  list-style: none;\n  padding: 0;\n  margin: 15px 0 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  z-index: 2;\n}\n.tab li[data-v-e347e5b6] {\n    color: #0D79F2;\n    padding: 15px 25px;\n    font-size: 14px;\n    font-weight: 600;\n    text-align: center;\n    display: inline-block;\n    text-transform: uppercase;\n    cursor: pointer;\n    line-height: 1.3;\n}\n.tab li.active[data-v-e347e5b6] {\n      background: #fff;\n      -webkit-box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);\n              box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);\n      border-radius: 2px 2px 0 0;\n      color: #777;\n}\n.tab li.disabled[data-v-e347e5b6] {\n      color: #ccc;\n      cursor: default;\n}\n.tab-contents[data-v-e347e5b6] {\n  background: #fff;\n  z-index: 1;\n  position: relative;\n  -webkit-box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);\n}\n.tab-contents .tab-content[data-v-e347e5b6] {\n    padding: 20px 20px 50px;\n    display: none;\n}\n.tab-contents .tab-content.no-H-padding[data-v-e347e5b6] {\n      padding: 20px 0;\n}\n.tab-contents .tab-content.active[data-v-e347e5b6] {\n      display: block;\n}\n.tab-contents .dispatch-log[data-v-e347e5b6] {\n    padding-bottom: 80px;\n}\n.right-panel[data-v-e347e5b6] {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  top: 0;\n  width: 400px;\n  height: 100%;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #f4f8f9;\n}\n.right-panel.hide[data-v-e347e5b6] {\n    right: -400px;\n    -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n            box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n}\n.right-panel .heading[data-v-e347e5b6] {\n    font-size: 24px;\n    padding: 10px 20px;\n    margin-bottom: 7px;\n}\n.right-panel .tab[data-v-e347e5b6] {\n    background: #d5d5d5;\n}\n.right-panel .tab .active[data-v-e347e5b6] {\n      background: #fff;\n}\n.right-panel .tab li[data-v-e347e5b6] {\n      width: 50%;\n      background-color: #f4f8f9;\n}\n.right-panel .tab-contents[data-v-e347e5b6] {\n    background: #fff;\n    display: block;\n    height: calc(100% - 57px);\n    overflow-y: auto;\n}\n.fixed-bottom[data-v-e347e5b6] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 652px;\n  height: 60px;\n  z-index: 3;\n  background: #eee;\n  padding: 10px 15px 10px 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.25);\n          box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.25);\n}\n.fixed-bottom a[data-v-e347e5b6] {\n    width: 50%;\n    margin: 0 5px;\n}\n.fixed-bottom a.right[data-v-e347e5b6] {\n      margin-left: auto;\n}\n.fixed-bottom a.create[data-v-e347e5b6] {\n      margin: 0 auto;\n}\n.modal[data-v-e347e5b6] {\n  position: fixed;\n  z-index: 12;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: none;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  resize: vertical;\n}\n.modal .bg-overlay[data-v-e347e5b6] {\n    position: absolute;\n    z-index: 1;\n    background: rgba(0, 0, 0, 0.5);\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n}\n.modal .modal-content[data-v-e347e5b6] {\n    position: relative;\n    z-index: 2;\n    background: #fff;\n    width: 400px;\n    min-height: 150px;\n    border-radius: 6px;\n    padding: 20px;\n    margin: auto;\n    -webkit-box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal.show[data-v-e347e5b6] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.modal.show .modal-content[data-v-e347e5b6] {\n      display: block;\n      -webkit-animation: slide-down-data-v-e347e5b6 .15s ease-out;\n      -moz-animation: slide-down-data-v-e347e5b6 .15s ease-out;\n}\n.breakdown .head[data-v-e347e5b6] {\n  text-align: center;\n  font-size: 18px;\n  font-weight: 600;\n  color: #555;\n  display: block;\n  padding-bottom: 3px;\n  border-bottom: 1px solid #ddd;\n  margin-bottom: 10px;\n}\n.breakdown .head.d-flex[data-v-e347e5b6] {\n    text-align: left;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.breakdown .item[data-v-e347e5b6] {\n  font-size: 15px;\n  margin-bottom: 5px;\n}\n.breakdown .item .label[data-v-e347e5b6] {\n    color: #777;\n    text-transform: uppercase;\n}\n.breakdown .item .value[data-v-e347e5b6] {\n    float: right;\n    font-weight: 600;\n}\n.breakdown .button[data-v-e347e5b6] {\n  margin-top: 20px;\n}\n.breakdown .op-link[data-v-e347e5b6] {\n  font-size: 13px;\n  color: #4da1ff;\n  font-weight: 500;\n  cursor: pointer;\n}\n.flightStatusModal[data-v-e347e5b6] {\n  text-align: center;\n}\n.flightStatusModal .loading[data-v-e347e5b6] {\n    padding: 30px 0;\n    font-size: 21px;\n    color: #555;\n}\n.flightStatusModal .loading .fa[data-v-e347e5b6] {\n      color: #0D79F2;\n}\n.flightStatusModal span[data-v-e347e5b6] {\n    display: block;\n    line-height: 1;\n}\n.flightStatusModal .label[data-v-e347e5b6] {\n    font-size: 12px;\n    color: #999;\n    text-transform: uppercase;\n}\n.flightStatusModal .value[data-v-e347e5b6] {\n    color: #555;\n    font-weight: 600;\n    font-size: 18px;\n    margin: 2px 0 20px;\n}\n.flight-error[data-v-e347e5b6] {\n  padding: 20px 0 30px;\n}\n.flight-error .fa[data-v-e347e5b6] {\n    color: #ccc;\n    margin-bottom: 10px;\n}\n.flight-error .title[data-v-e347e5b6] {\n    font-size: 24px;\n    color: #aaa;\n    font-weight: 600;\n    margin-bottom: 5px;\n}\n.flight-error .body[data-v-e347e5b6] {\n    font-style: italic;\n    color: #333;\n    font-size: 14px;\n}\n.try-again[data-v-e347e5b6] {\n  margin-bottom: 8px;\n}\n@-webkit-keyframes slide-down-data-v-e347e5b6 {\n0% {\n    opacity: 0;\n    -webkit-transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n}\n}\n.email-result[data-v-e347e5b6] {\n  text-align: center;\n}\n.email-result p[data-v-e347e5b6] {\n    font-size: 18px;\n}\n.email-result .header[data-v-e347e5b6] {\n    display: block;\n    font-weight: 600;\n    color: #333;\n    margin-bottom: 10px;\n}\n.email-result .body[data-v-e347e5b6] {\n    display: block;\n    font-size: 14px;\n    color: #444;\n    margin-bottom: 30px;\n}\n.email-result .cancel[data-v-e347e5b6] {\n    font-size: 14px;\n    margin: 10px 0 0;\n    display: block;\n    cursor: pointer;\n}\n.release-modal[data-v-e347e5b6] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.release-modal.show[data-v-e347e5b6] {\n    top: 0;\n    opacity: 1;\n}\n.release-modal-container[data-v-e347e5b6] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.release-modal-content[data-v-e347e5b6] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.release-modal-content .title[data-v-e347e5b6] {\n    font-weight: 700;\n    background-color: #333;\n    color: #fff;\n    padding: 10px;\n}\n.release-modal-content .loading[data-v-e347e5b6], .release-modal-content .error[data-v-e347e5b6] {\n    text-align: center;\n    padding: 25px 0;\n}\n.release-modal-content .loading i[data-v-e347e5b6] {\n    color: #4fa1f7;\n}\n.release-modal-content .loading div[data-v-e347e5b6] {\n    color: #999;\n}\n.release-modal-content .error i[data-v-e347e5b6] {\n    color: #f3e26d;\n}\n.release-modal-content .error div[data-v-e347e5b6] {\n    color: #777;\n    margin-top: 15px;\n}\n.release-modal-content .fee[data-v-e347e5b6] {\n    padding: 10px;\n    margin: 0 10px 20px;\n    background: #f7eeb2;\n    border: 1px solid #d0be42;\n    border-radius: 10px;\n    color: #444;\n    -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n            box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n}\n.release-modal-content .fee p[data-v-e347e5b6] {\n      margin: 0 0 5px;\n      font-size: 14px;\n}\n.release-modal-content .fee label[data-v-e347e5b6] {\n      float: left;\n      width: 50%;\n      font-weight: 600;\n}\n.release-modal-content .fee input[data-v-e347e5b6] {\n      width: initial;\n      display: inline-block;\n      margin: 0;\n}\n.release-modal-content .fee .clear[data-v-e347e5b6] {\n      clear: both;\n}\n.release-modal-content .message[data-v-e347e5b6] {\n    padding: 15px;\n    font-weight: 700;\n    color: #555;\n}\n.release-modal-content .sub-message[data-v-e347e5b6] {\n    font-size: 14px;\n    padding: 0 15px 15px;\n    color: #777;\n}\n.release-modal-content .sub-message strong[data-v-e347e5b6] {\n      color: #555;\n      text-decoration: underline;\n}\n.release-modal-content .controls[data-v-e347e5b6] {\n    padding: 0px 15px 15px;\n}\n.release-modal-content .controls .padding-R[data-v-e347e5b6] {\n      padding-right: 5px;\n}\n.release-modal-content .controls .padding-L[data-v-e347e5b6] {\n      padding-left: 5px;\n}\n.release-modal-content .releasing .message[data-v-e347e5b6] {\n    padding-top: 10px;\n}\n.release-modal-content .releasing i[data-v-e347e5b6] {\n    margin-top: 18px;\n    color: #0D79F2;\n}\n.release-modal-content .releasing i.success[data-v-e347e5b6] {\n      color: #26D97A;\n}\n.suggested-time-modal[data-v-e347e5b6] {\n  text-align: center;\n  width: 450px !important;\n}\n.suggested-time-modal .title[data-v-e347e5b6] {\n    font-size: 21px;\n    font-weight: 600;\n    color: #3c6879;\n}\n.suggested-time-modal p[data-v-e347e5b6] {\n    font-size: 15px;\n    margin: 10px 0 15px;\n}\n.suggested-time-modal .time[data-v-e347e5b6] {\n    display: inline-block;\n    font-size: 18px;\n    font-weight: 600;\n    margin-bottom: 15px;\n    border-bottom: 1px solid #24af65;\n    color: #24af65;\n    word-spacing: 5px;\n}\n.suggested-time-modal .keep[data-v-e347e5b6] {\n    display: block;\n    margin-top: 10px;\n    font-size: 14px;\n    color: #999;\n    cursor: pointer;\n}\n.editing .legend[data-v-e347e5b6] {\n  display: none;\n}\n.editing .route-map[data-v-e347e5b6], .editing .map-here[data-v-e347e5b6] {\n  width: 30%;\n  left: 70%;\n}\n.editing .left-panel[data-v-e347e5b6], .editing .fixed-bottom[data-v-e347e5b6] {\n  width: 70%;\n}\n.editing .right-panel[data-v-e347e5b6] {\n  right: -400px;\n}\n.select-user[data-v-e347e5b6] {\n  text-align: center;\n  width: 500px !important;\n  height: 400px;\n  padding: 0 !important;\n  overflow: hidden;\n  background: #f8f8f8 !important;\n}\n.select-user .title[data-v-e347e5b6] {\n    background: #444;\n    padding: 10px;\n    color: #fff;\n}\n.select-user .box[data-v-e347e5b6] {\n    padding: 10px;\n}\n.select-user .search-input[data-v-e347e5b6] {\n    margin: 0 0 10px;\n    font-size: 14px;\n    -webkit-box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.07);\n            box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.07);\n}\n.select-user .box-list[data-v-e347e5b6] {\n    position: relative;\n}\n.select-user .loader[data-v-e347e5b6] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.7);\n    color: #fff;\n}\n.select-user .loader i[data-v-e347e5b6] {\n      vertical-align: middle;\n      margin-right: 5px;\n}\n.select-user .loader .v-center[data-v-e347e5b6] {\n      text-align: center;\n      width: 100%;\n      position: absolute;\n      top: 50%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n}\n.select-user .list[data-v-e347e5b6] {\n    display: block;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    border: 1px solid #ddd;\n    height: 220px;\n    background: #fefefe;\n    border-radius: 2px;\n    -webkit-box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.07);\n            box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.07);\n    overflow: auto;\n}\n.select-user .list li[data-v-e347e5b6] {\n      text-align: left;\n      padding: 8px;\n      border-bottom: 1px solid #ddd;\n      cursor: pointer;\n}\n.select-user .list li[data-v-e347e5b6]:hover {\n        background: #fffbe7;\n}\n.select-user .list li .name[data-v-e347e5b6] {\n        font-size: 14px;\n        display: inline-block;\n        font-weight: 600;\n}\n.select-user .list li .id[data-v-e347e5b6] {\n        display: inline-block;\n        width: 70px;\n        text-align: right;\n        color: #333;\n        font-size: 12px;\n}\n.select-user .list li .email[data-v-e347e5b6], .select-user .list li .mobile[data-v-e347e5b6] {\n        display: block;\n        font-size: 12px;\n        line-height: 130%;\n        color: #aaa;\n}\n.select-user .list li.disabled[data-v-e347e5b6] {\n        cursor: default;\n        opacity: .6;\n        background: #f3f3f3;\n}\n.select-user .list li.disabled[data-v-e347e5b6]:hover {\n          background: #f3f3f3;\n}\n.select-user .list li .status[data-v-e347e5b6] {\n        letter-spacing: .9px;\n        background: #888;\n}\n.select-user .is-d2d[data-v-e347e5b6] {\n    color: #fff;\n    padding: 3px 5px;\n    line-height: 1;\n    background: #444;\n    border-radius: 4px;\n    font-weight: 600;\n    letter-spacing: .8px;\n    margin-top: 3px;\n    display: inline-block;\n}\n.select-user .actions[data-v-e347e5b6] {\n    margin-top: 10px;\n}\n.select-user .padding-L[data-v-e347e5b6] {\n    padding-left: 5px;\n}\n.select-user .padding-R[data-v-e347e5b6] {\n    padding-right: 5px;\n}\n.asap-modal[data-v-e347e5b6] {\n  max-width: 500px;\n  width: 100% !important;\n  text-align: center;\n}\n.asap-modal .fa-car[data-v-e347e5b6] {\n    color: #999;\n    font-size: 40px;\n}\n.asap-modal .fa-spinner[data-v-e347e5b6] {\n    color: #ccc;\n}\n.asap-modal .looking-for[data-v-e347e5b6] {\n    display: block;\n    margin-top: 10px;\n}\n.asap-modal .cancel-asap[data-v-e347e5b6] {\n    margin-top: 10px;\n    width: 200px;\n}\n.optin-modal[data-v-e347e5b6] {\n  text-align: center;\n}\n.optin-modal label[data-v-e347e5b6] {\n    margin-bottom: 20px;\n    display: block;\n    font-weight: 600;\n}\n.optin-modal .button[data-v-e347e5b6] {\n    width: 45%;\n}\n.select-email-recipient[data-v-e347e5b6] {\n  padding: 0 !important;\n  overflow: hidden;\n}\n.select-email-recipient .title[data-v-e347e5b6] {\n    background: #444;\n    padding: 10px;\n    color: #fff;\n    text-align: center;\n}\n.select-email-recipient .box[data-v-e347e5b6] {\n    padding: 20px;\n}\n.select-email-recipient .label[data-v-e347e5b6] {\n    color: #555;\n    font-weight: 600;\n}\n.select-email-recipient ul[data-v-e347e5b6] {\n    list-style: none;\n    padding: 0;\n}\n.select-email-recipient ul li[data-v-e347e5b6] {\n      margin-bottom: 10px;\n      font-size: 14px;\n}\n.select-email-recipient ul li span[data-v-e347e5b6] {\n        vertical-align: 2px;\n}\n.select-email-recipient input[data-v-e347e5b6] {\n    margin: 0;\n}\n.select-email-recipient input[type=\"radio\"][data-v-e347e5b6] {\n      width: auto;\n      display: inline-block;\n      margin-right: 5px;\n      width: 20px;\n}\n.select-email-recipient input[type=\"input\"][data-v-e347e5b6] {\n      display: inline-block;\n      width: calc(100% - 30px);\n      padding: 5px;\n}\n.select-email-recipient input.has-error[data-v-e347e5b6] {\n      border-color: #f00;\n}\n.select-email-recipient .padding-L[data-v-e347e5b6] {\n    padding-left: 5px;\n}\n.select-email-recipient .has-error[data-v-e347e5b6] {\n    font-size: 12px;\n    color: #f00;\n    padding-left: 30px;\n    line-height: 1.6;\n}\n.no-driver .fa-user-circle[data-v-e347e5b6] {\n  color: #555;\n}\n.no-driver .message[data-v-e347e5b6] {\n  display: block;\n  margin-top: 15px;\n  font-size: 14px;\n}\n.no-driver .change-service[data-v-e347e5b6] {\n  margin: 20px 0 5px;\n}\n.driver-info .info[data-v-e347e5b6] {\n  margin-bottom: 10px;\n}\n.driver-info .title[data-v-e347e5b6] {\n  margin-bottom: 20px;\n  display: block;\n  font-size: 21px;\n  color: #555;\n  font-weight: 600;\n}\n.driver-info .img[data-v-e347e5b6] {\n  display: inline-block;\n  width: 60px;\n  margin-right: 20px;\n  vertical-align: top;\n}\n.driver-info .desc[data-v-e347e5b6] {\n  display: inline-block;\n  width: 320px;\n  text-align: left;\n}\n.driver-info .desc .rating[data-v-e347e5b6], .driver-info .desc .name[data-v-e347e5b6], .driver-info .desc .model[data-v-e347e5b6] {\n    font-size: 14px;\n}\n.driver-info .desc .email[data-v-e347e5b6], .driver-info .desc .plate[data-v-e347e5b6] {\n    font-size: 12px;\n    color: #999;\n}\n.driver-info .desc .fa-star[data-v-e347e5b6] {\n    color: #d2c52d;\n    margin-right: 5px;\n}\n.driver-info .close-asap[data-v-e347e5b6] {\n  margin-top: 20px;\n  width: 300px;\n}\n.create-error[data-v-e347e5b6] {\n  text-align: center;\n}\n.create-error .fa-exclamation-circle[data-v-e347e5b6] {\n    color: #ffd86b;\n    margin-bottom: 3px;\n}\n.create-error .message[data-v-e347e5b6] {\n    font-size: 16px;\n    margin-bottom: 15px;\n}\n.stop-info[data-v-e347e5b6] {\n  color: #555;\n}\n.stop-info .location[data-v-e347e5b6] {\n    max-width: 300px;\n}\n.stop-info .data.top-line[data-v-e347e5b6] {\n    margin-top: 5px;\n    padding-top: 5px;\n    border-top: 1px solid #eee;\n}\n.stop-info .data div[data-v-e347e5b6] {\n    margin-bottom: 2px;\n}\n.stop-info .data label[data-v-e347e5b6] {\n    color: #999;\n}\n.stop-info .data span[data-v-e347e5b6] {\n    word-spacing: 2px;\n    font-weight: 500;\n}\n.driver-infowindow[data-v-e347e5b6] {\n  position: relative;\n  padding: 15px 0 10px 15px;\n  width: 400px;\n}\n.driver-infowindow .photo[data-v-e347e5b6] {\n    display: block;\n    width: 70px;\n    height: 70px;\n    background-color: #ddd;\n    margin: 0 auto;\n    border-radius: 70px;\n    -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.5);\n            box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.5);\n    border: 1px solid rgba(0, 0, 0, 0.25);\n}\n.driver-infowindow .name[data-v-e347e5b6] {\n    display: block;\n    text-align: center;\n    margin-top: 5px;\n    font-size: 14px;\n    font-weight: 700;\n    text-transform: uppercase;\n}\n.driver-infowindow .subtext[data-v-e347e5b6] {\n    text-align: center;\n    margin-bottom: 10px;\n    font-size: 12px;\n    color: #777;\n    font-weight: 700;\n}\n.driver-infowindow .cta[data-v-e347e5b6] {\n    margin-bottom: 5px;\n}\n.down-scale-enter-active[data-v-e347e5b6], .down-scale-leave-active[data-v-e347e5b6] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.down-scale-enter[data-v-e347e5b6], .down-scale-leave-to[data-v-e347e5b6] {\n  -webkit-transform: scale(0.7) translateY(-10px);\n          transform: scale(0.7) translateY(-10px);\n  opacity: 0;\n}\n.show-up-enter-active[data-v-e347e5b6], .show-up-leave-active[data-v-e347e5b6] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.show-up-enter[data-v-e347e5b6], .show-up-leave-to[data-v-e347e5b6] {\n  -webkit-transform: translateY(20px);\n          transform: translateY(20px);\n  opacity: 0;\n}\n.slide-up-enter-active[data-v-e347e5b6], .slide-up-leave-active[data-v-e347e5b6] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-e347e5b6], .slide-up-leave-to[data-v-e347e5b6] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n.appear-enter-active[data-v-e347e5b6], .appear-leave-active[data-v-e347e5b6] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.appear-enter[data-v-e347e5b6], .appear-leave-to[data-v-e347e5b6] {\n  -webkit-transform: scale(0.95);\n          transform: scale(0.95);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.map-box[data-v-e347e5b6] {\n    width: 100%;\n    z-index: 5;\n}\n.map-box #mapHere[data-v-e347e5b6] {\n      left: 0;\n      width: 100%;\n      top: 100%;\n      -webkit-transition: all 0.3s ease;\n      transition: all 0.3s ease;\n}\n.map-box.showMapBox #mapHere[data-v-e347e5b6] {\n      top: 0;\n}\n.heading .edit[data-v-e347e5b6] {\n    float: none;\n    margin: 0;\n}\n.left-panel[data-v-e347e5b6] {\n    width: 100%;\n    padding-bottom: 85px;\n}\n.left-panel .edit-btn-div[data-v-e347e5b6] {\n      padding-left: 13px;\n}\n.left-panel .tab[data-v-e347e5b6] {\n      margin-top: 50px;\n      display: table;\n}\n.left-panel .tab li[data-v-e347e5b6] {\n        padding: 12px 10px;\n        vertical-align: middle;\n        display: table-cell;\n        font-size: 12px;\n}\n.left-panel .fixed-bottom[data-v-e347e5b6] {\n      bottom: 40px;\n}\n.left-panel .fixed-bottom a.right[data-v-e347e5b6] {\n        margin-left: inherit;\n}\n.left-panel .fixed-bottom a.create[data-v-e347e5b6] {\n        margin: 0 auto;\n}\n.toggle-mobile[data-v-e347e5b6] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.editing .left-panel[data-v-e347e5b6],\n  .editing .fixed-bottom[data-v-e347e5b6] {\n    width: 100%;\n}\n.editing .tab li[data-v-e347e5b6] {\n    padding: 5px 13px;\n}\n.tab-contents .tab-content[data-v-e347e5b6] {\n    padding: 10px;\n}\n.transaction-tab[data-v-e347e5b6] {\n    width: 100%;\n}\n.select-user[data-v-e347e5b6] {\n    width: 95vw !important;\n    height: auto;\n}\n.right-panel[data-v-e347e5b6] {\n    width: calc(100vw - 55px) !important;\n}\n.button.small[data-v-e347e5b6] {\n    font-size: 11px;\n    width: auto;\n    padding: 7px;\n}\n.button.small.btn-close[data-v-e347e5b6] {\n      font-size: 14px;\n      width: 100%;\n}\n.fixed-bottom[data-v-e347e5b6] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    width: 100vw;\n}\n.fixed-bottom .button.small[data-v-e347e5b6] {\n      font-size: 12px;\n      width: auto;\n      padding: 7px 15px;\n}\n.fixed-bottom .button.small.create[data-v-e347e5b6] {\n        width: 100%;\n        font-size: 16px !important;\n}\n.fixed-bottom .create[data-v-e347e5b6] {\n      font-size: 14px !important;\n      padding: 10px 22px !important;\n}\n.modal .modal-content[data-v-e347e5b6] {\n    width: 100%;\n}\n.select-email-recipient .medium-6[data-v-e347e5b6] {\n    width: 50%;\n}\n.select-email-recipient .medium-6 a[data-v-e347e5b6] {\n      width: 100%;\n}\n}\n.lr-tooltip[data-v-e347e5b6] {\n  margin-left: 2px;\n  display: inline-block;\n  position: relative;\n}\n.lr-tooltip .tp-desc[data-v-e347e5b6] {\n    -webkit-transition: all .3s ease;\n    transition: all .3s ease;\n    position: absolute;\n    top: 100%;\n    width: 100px;\n    background: #fafafa;\n    padding: 5px;\n    font-size: 12px;\n    text-align: center;\n    line-height: 1.1;\n    border-radius: 4px;\n    border: 1px solid #eee;\n    left: -50px;\n    -webkit-box-shadow: 1px 1px 2px #ccc;\n            box-shadow: 1px 1px 2px #ccc;\n    opacity: 0;\n    z-index: -1;\n}\n.lr-tooltip:hover .tp-desc[data-v-e347e5b6] {\n    top: calc(100% + 4px);\n    opacity: 1;\n    z-index: 1;\n}\n.optin-icon[data-v-e347e5b6] {\n  width: 18px;\n}\n.dpo-field[data-v-e347e5b6] {\n  position: relative;\n}\n.dpo-field span[data-v-e347e5b6] {\n    position: absolute;\n    z-index: 2;\n    font-weight: 600;\n    color: #666;\n    line-height: 46px;\n    padding: 0 10px;\n}\n.dpo-field input[data-v-e347e5b6] {\n    position: relative;\n    z-index: 1;\n    padding-left: 25px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/RsvpDetails/index2.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;CAC3B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,kCAAkC;CACnC;AACD;;;;EAIE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;EACjB,0BAA0B;EAC1B,YAAY;EACZ,+BAA+B;EAC/B,mDAAmD;UAC3C,2CAA2C;EACnD,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,6BAA6B;EAC7B,qBAAqB;CACtB;AACD;IACI,qBAAqB;CACxB;AACD;IACI,gCAAgC;IAChC,wBAAwB;IACxB,6BAA6B;IAC7B,qBAAqB;CACxB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,WAAW;EACX,cAAc;EACd,WAAW;CACZ;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,WAAW;CACZ;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,WAAW;CACZ;AACD;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,+CAA+C;YACvC,uCAAuC;IAC/C,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,UAAU;MACV,WAAW;CAChB;AACD;QACQ,sBAAsB;QACtB,uBAAuB;QACvB,YAAY;QACZ,aAAa;QACb,qBAAqB;QACrB,mBAAmB;CAC1B;AACD;UACU,oBAAoB;CAC7B;AACD;UACU,oBAAoB;CAC7B;AACD;UACU,oBAAoB;CAC7B;AACD;UACU,oBAAoB;CAC7B;AACD;UACU,oBAAoB;CAC7B;AACD;UACU,oBAAoB;CAC7B;AACD;UACU,iBAAiB;CAC1B;AACD;IACI,sBAAsB;IACtB,oBAAoB;CACvB;AACD;MACM,iBAAiB;CACtB;AACD;MACM,gBAAgB;MAChB,YAAY;CACjB;AACD;IACI,gBAAgB;CACnB;AACD;MACM,eAAe;MACf,mBAAmB;CACxB;AACD;MACM,YAAY;MACZ,kBAAkB;CACvB;AACD;QACQ,kBAAkB;CACzB;AACD;MACM,iBAAiB;MACjB,YAAY;CACjB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,YAAY;CACb;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,kBAAkB;IAClB,kDAAkD;YAC1C,0CAA0C;CACrD;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;CACjB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;CAClB;AACD;IACI,aAAa;IACb,kBAAkB;CACrB;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,uBAAuB;CAC1B;AACD;IACI,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;CACpB;AACD;IACI,eAAe;CAClB;AACD;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;CAChB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,OAAO;EACP,aAAa;EACb,aAAa;EACb,iDAAiD;UACzC,yCAAyC;EACjD,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;CACtB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,aAAa;CAChB;AACD;IACI,cAAc;CACjB;AACD;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,WAAW;CACZ;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;CACpB;AACD;MACM,iBAAiB;MACjB,kDAAkD;cAC1C,0CAA0C;MAClD,2BAA2B;MAC3B,YAAY;CACjB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;CACpD;AACD;IACI,wBAAwB;IACxB,cAAc;CACjB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,eAAe;CACpB;AACD;IACI,qBAAqB;CACxB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;EAClD,0BAA0B;CAC3B;AACD;IACI,cAAc;IACd,gDAAgD;YACxC,wCAAwC;CACnD;AACD;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;CACtB;AACD;IACI,oBAAoB;CACvB;AACD;MACM,iBAAiB;CACtB;AACD;MACM,WAAW;MACX,0BAA0B;CAC/B;AACD;IACI,iBAAiB;IACjB,eAAe;IACf,0BAA0B;IAC1B,iBAAiB;CACpB;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,aAAa;EACb,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,6BAA6B;EAC7B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,mDAAmD;UAC3C,2CAA2C;CACpD;AACD;IACI,WAAW;IACX,cAAc;CACjB;AACD;MACM,kBAAkB;CACvB;AACD;MACM,eAAe;CACpB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,iBAAiB;CAClB;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,OAAO;IACP,QAAQ;CACX;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,uDAAuD;YAC/C,+CAA+C;IACvD,cAAc;CACjB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;MACM,eAAe;MACf,4DAA4D;MAC5D,yDAAyD;CAC9D;AACD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,8BAA8B;EAC9B,oBAAoB;CACrB;AACD;IACI,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;EACE,gBAAgB;EAChB,mBAAmB;CACpB;AACD;IACI,YAAY;IACZ,0BAA0B;CAC7B;AACD;IACI,aAAa;IACb,iBAAiB;CACpB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;CACjB;AACD;EACE,mBAAmB;CACpB;AACD;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;CACf;AACD;MACM,eAAe;CACpB;AACD;IACI,eAAe;IACf,eAAe;CAClB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;CAC7B;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;CACtB;AACD;EACE,qBAAqB;CACtB;AACD;IACI,YAAY;IACZ,oBAAoB;CACvB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;CACtB;AACD;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;AACA;IACI,WAAW;IACX,oCAAoC;CACvC;AACD;IACI,WAAW;IACX,iCAAiC;CACpC;CACA;AACD;EACE,mBAAmB;CACpB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;CACvB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;CACvB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;CACnB;AACD;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,iBAAiB;CAClB;AACD;IACI,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,cAAc;CACjB;AACD;IACI,mBAAmB;IACnB,gBAAgB;CACnB;AACD;IACI,eAAe;CAClB;AACD;IACI,YAAY;CACf;AACD;IACI,eAAe;CAClB;AACD;IACI,YAAY;IACZ,iBAAiB;CACpB;AACD;IACI,cAAc;IACd,oBAAoB;IACpB,oBAAoB;IACpB,0BAA0B;IAC1B,oBAAoB;IACpB,YAAY;IACZ,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;MACM,gBAAgB;MAChB,gBAAgB;CACrB;AACD;MACM,YAAY;MACZ,WAAW;MACX,iBAAiB;CACtB;AACD;MACM,eAAe;MACf,sBAAsB;MACtB,UAAU;CACf;AACD;MACM,YAAY;CACjB;AACD;IACI,cAAc;IACd,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;CACf;AACD;MACM,YAAY;MACZ,2BAA2B;CAChC;AACD;IACI,uBAAuB;CAC1B;AACD;MACM,mBAAmB;CACxB;AACD;MACM,kBAAkB;CACvB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,iBAAiB;IACjB,eAAe;CAClB;AACD;MACM,eAAe;CACpB;AACD;EACE,mBAAmB;EACnB,wBAAwB;CACzB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,gBAAgB;IAChB,oBAAoB;CACvB;AACD;IACI,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,iCAAiC;IACjC,eAAe;IACf,kBAAkB;CACrB;AACD;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;CACnB;AACD;EACE,cAAc;CACf;AACD;EACE,WAAW;EACX,UAAU;CACX;AACD;EACE,WAAW;CACZ;AACD;EACE,cAAc;CACf;AACD;EACE,mBAAmB;EACnB,wBAAwB;EACxB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,+BAA+B;CAChC;AACD;IACI,iBAAiB;IACjB,cAAc;IACd,YAAY;CACf;AACD;IACI,cAAc;CACjB;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,oDAAoD;YAC5C,4CAA4C;CACvD;AACD;IACI,mBAAmB;CACtB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,+BAA+B;IAC/B,YAAY;CACf;AACD;MACM,uBAAuB;MACvB,kBAAkB;CACvB;AACD;MACM,mBAAmB;MACnB,YAAY;MACZ,mBAAmB;MACnB,SAAS;MACT,oCAAoC;cAC5B,4BAA4B;CACzC;AACD;IACI,eAAe;IACf,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,oDAAoD;YAC5C,4CAA4C;IACpD,eAAe;CAClB;AACD;MACM,iBAAiB;MACjB,aAAa;MACb,8BAA8B;MAC9B,gBAAgB;CACrB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,gBAAgB;QAChB,sBAAsB;QACtB,iBAAiB;CACxB;AACD;QACQ,sBAAsB;QACtB,YAAY;QACZ,kBAAkB;QAClB,YAAY;QACZ,gBAAgB;CACvB;AACD;QACQ,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,YAAY;CACnB;AACD;QACQ,gBAAgB;QAChB,YAAY;QACZ,oBAAoB;CAC3B;AACD;UACU,oBAAoB;CAC7B;AACD;QACQ,qBAAqB;QACrB,iBAAiB;CACxB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;CACzB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,mBAAmB;CACtB;AACD;EACE,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;CACpB;AACD;IACI,YAAY;IACZ,gBAAgB;CACnB;AACD;IACI,YAAY;CACf;AACD;IACI,eAAe;IACf,iBAAiB;CACpB;AACD;IACI,iBAAiB;IACjB,aAAa;CAChB;AACD;EACE,mBAAmB;CACpB;AACD;IACI,oBAAoB;IACpB,eAAe;IACf,iBAAiB;CACpB;AACD;IACI,WAAW;CACd;AACD;EACE,sBAAsB;EACtB,iBAAiB;CAClB;AACD;IACI,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,mBAAmB;CACtB;AACD;IACI,cAAc;CACjB;AACD;IACI,YAAY;IACZ,iBAAiB;CACpB;AACD;IACI,iBAAiB;IACjB,WAAW;CACd;AACD;MACM,oBAAoB;MACpB,gBAAgB;CACrB;AACD;QACQ,oBAAoB;CAC3B;AACD;IACI,UAAU;CACb;AACD;MACM,YAAY;MACZ,sBAAsB;MACtB,kBAAkB;MAClB,YAAY;CACjB;AACD;MACM,sBAAsB;MACtB,yBAAyB;MACzB,aAAa;CAClB;AACD;MACM,mBAAmB;CACxB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;CACpB;AACD;EACE,YAAY;CACb;AACD;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;CACjB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;CAClB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;CACrB;AACD;EACE,sBAAsB;EACtB,aAAa;EACb,iBAAiB;CAClB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,YAAY;CACf;AACD;IACI,eAAe;IACf,kBAAkB;CACrB;AACD;EACE,iBAAiB;EACjB,aAAa;CACd;AACD;EACE,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,mBAAmB;CACtB;AACD;IACI,gBAAgB;IAChB,oBAAoB;CACvB;AACD;EACE,YAAY;CACb;AACD;IACI,iBAAiB;CACpB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;CAC9B;AACD;IACI,mBAAmB;CACtB;AACD;IACI,YAAY;CACf;AACD;IACI,kBAAkB;IAClB,iBAAiB;CACpB;AACD;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;CACd;AACD;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,oBAAoB;IACpB,qDAAqD;YAC7C,6CAA6C;IACrD,sCAAsC;CACzC;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;CAC7B;AACD;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;CACpB;AACD;IACI,mBAAmB;CACtB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,gDAAgD;UACxC,wCAAwC;EAChD,WAAW;CACZ;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,WAAW;CACZ;AACD;AACA;IACI,YAAY;IACZ,WAAW;CACd;AACD;MACM,QAAQ;MACR,YAAY;MACZ,UAAU;MACV,kCAAkC;MAClC,0BAA0B;CAC/B;AACD;MACM,OAAO;CACZ;AACD;IACI,YAAY;IACZ,UAAU;CACb;AACD;IACI,YAAY;IACZ,qBAAqB;CACxB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,iBAAiB;MACjB,eAAe;CACpB;AACD;QACQ,mBAAmB;QACnB,uBAAuB;QACvB,oBAAoB;QACpB,gBAAgB;CACvB;AACD;MACM,aAAa;CAClB;AACD;QACQ,qBAAqB;CAC5B;AACD;QACQ,eAAe;CACtB;AACD;IACI,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;IACrB,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;CACpB;AACD;;IAEI,YAAY;CACf;AACD;IACI,kBAAkB;CACrB;AACD;IACI,cAAc;CACjB;AACD;IACI,YAAY;CACf;AACD;IACI,uBAAuB;IACvB,aAAa;CAChB;AACD;IACI,qCAAqC;CACxC;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;CAChB;AACD;MACM,gBAAgB;MAChB,YAAY;CACjB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,yBAAyB;QACrB,sBAAsB;YAClB,wBAAwB;IAChC,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;IAC5B,aAAa;CAChB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,kBAAkB;CACvB;AACD;QACQ,YAAY;QACZ,2BAA2B;CAClC;AACD;MACM,2BAA2B;MAC3B,8BAA8B;CACnC;AACD;IACI,YAAY;CACf;AACD;IACI,WAAW;CACd;AACD;MACM,YAAY;CACjB;CACA;AACD;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;CACpB;AACD;IACI,iCAAiC;IACjC,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,qCAAqC;YAC7B,6BAA6B;IACrC,WAAW;IACX,YAAY;CACf;AACD;IACI,sBAAsB;IACtB,WAAW;IACX,WAAW;CACd;AACD;EACE,YAAY;CACb;AACD;EACE,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;CACnB;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,mBAAmB;CACtB","file":"index2.vue","sourcesContent":["\n.status[data-v-e347e5b6] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-e347e5b6], .status.completed[data-v-e347e5b6] {\n    background: #26D97A;\n}\n.status.canceled[data-v-e347e5b6], .status.cancelled[data-v-e347e5b6], .status.failed[data-v-e347e5b6] {\n    background: #bbb;\n}\n.status.upcoming[data-v-e347e5b6] {\n    background: #f38d56;\n}\n.status.onboard[data-v-e347e5b6] {\n    background: #dc3168;\n}\n.status.ready[data-v-e347e5b6] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-e347e5b6], .status.requires_dispatch[data-v-e347e5b6] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-e347e5b6] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-e347e5b6] {\n    background: #5662f3;\n}\n.flight-status[data-v-e347e5b6] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-e347e5b6] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-e347e5b6] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-e347e5b6] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-e347e5b6] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-e347e5b6] {\n    background-color: #f35656;\n}\n*[data-v-e347e5b6] {\n  -webkit-overflow-scrolling: touch;\n}\n.route-map[data-v-e347e5b6],\n.left-panel[data-v-e347e5b6],\n.right-panel[data-v-e347e5b6],\n.fixed-bottom[data-v-e347e5b6] {\n  -webkit-transition: all .6s ease;\n  transition: all .6s ease;\n}\n.logs-toggle[data-v-e347e5b6] {\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 3;\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  text-align: center;\n  color: #777;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  border-radius: 0;\n  background-color: #F25E0D;\n  color: #fff;\n  border-bottom-left-radius: 3px;\n  -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n          box-shadow: -2px 0 8px rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n  -webkit-transition: .5s ease;\n  transition: .5s ease;\n}\n.logs-toggle i[data-v-e347e5b6] {\n    line-height: inherit;\n}\n.logs-toggle.on[data-v-e347e5b6] {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n    -webkit-transition: .5s ease;\n    transition: .5s ease;\n}\n.route-map[data-v-e347e5b6] {\n  position: fixed;\n  top: 0;\n  left: 652px;\n  width: calc(100% - (652px));\n  height: 100%;\n  z-index: 1;\n  display: none;\n  /* ADDED */\n}\n.map-here[data-v-e347e5b6] {\n  position: fixed;\n  top: 0;\n  left: 652px;\n  width: calc(100% - (652px));\n  height: 100%;\n  z-index: 1;\n}\n.map-box[data-v-e347e5b6] {\n  position: fixed;\n  top: 0;\n  left: 652px;\n  width: calc(100% - (652px));\n  height: 100%;\n  z-index: 2;\n}\n.map-box .legend[data-v-e347e5b6], .map-box .cancel-data-box[data-v-e347e5b6] {\n    position: absolute;\n    bottom: 15px;\n    right: 15px;\n    background: #fff;\n    border: 1px solid #999;\n    padding: 5px 10px;\n    z-index: 2;\n    -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);\n            box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);\n    border-radius: 2px;\n}\n.map-box .legend ul[data-v-e347e5b6], .map-box .cancel-data-box ul[data-v-e347e5b6] {\n      list-style-type: none;\n      margin: 0;\n      padding: 0;\n}\n.map-box .legend ul .icon[data-v-e347e5b6], .map-box .cancel-data-box ul .icon[data-v-e347e5b6] {\n        display: inline-block;\n        border: 1px solid #777;\n        width: 12px;\n        height: 12px;\n        vertical-align: -1px;\n        border-radius: 2px;\n}\n.map-box .legend ul .icon.pickup[data-v-e347e5b6], .map-box .cancel-data-box ul .icon.pickup[data-v-e347e5b6] {\n          background: #2ee47d;\n}\n.map-box .legend ul .icon.extra-stop[data-v-e347e5b6], .map-box .cancel-data-box ul .icon.extra-stop[data-v-e347e5b6] {\n          background: #fe8214;\n}\n.map-box .legend ul .icon.dropoff[data-v-e347e5b6], .map-box .cancel-data-box ul .icon.dropoff[data-v-e347e5b6] {\n          background: #ca3538;\n}\n.map-box .legend ul .icon.ontheway[data-v-e347e5b6], .map-box .cancel-data-box ul .icon.ontheway[data-v-e347e5b6] {\n          background: #dbd935;\n}\n.map-box .legend ul .icon.arrived[data-v-e347e5b6], .map-box .legend ul .icon.onboard[data-v-e347e5b6], .map-box .cancel-data-box ul .icon.arrived[data-v-e347e5b6], .map-box .cancel-data-box ul .icon.onboard[data-v-e347e5b6] {\n          background: #389ce1;\n}\n.map-box .legend ul .icon.completed[data-v-e347e5b6], .map-box .cancel-data-box ul .icon.completed[data-v-e347e5b6] {\n          background: #1ac1b1;\n}\n.map-box .legend ul .icon.canceled[data-v-e347e5b6], .map-box .cancel-data-box ul .icon.canceled[data-v-e347e5b6] {\n          background: #bbb;\n}\n.map-box .legend ul li[data-v-e347e5b6] {\n    display: inline-block;\n    padding-right: 15px;\n}\n.map-box .legend ul li[data-v-e347e5b6]:last-child {\n      padding-right: 0;\n}\n.map-box .legend ul li span[data-v-e347e5b6] {\n      font-size: 13px;\n      color: #333;\n}\n.map-box .cancel-data-box[data-v-e347e5b6] {\n    font-size: 13px;\n}\n.map-box .cancel-data-box li[data-v-e347e5b6] {\n      display: block;\n      margin-bottom: 3px;\n}\n.map-box .cancel-data-box label[data-v-e347e5b6] {\n      color: #999;\n      margin-right: 5px;\n}\n.map-box .cancel-data-box label div[data-v-e347e5b6] {\n        margin-right: 4px;\n}\n.map-box .cancel-data-box span[data-v-e347e5b6] {\n      font-weight: 600;\n      color: #444;\n}\n.render-loader[data-v-e347e5b6] {\n  position: fixed;\n  z-index: 2;\n  bottom: 20px;\n  right: 20px;\n}\n.render-loader .map-loading[data-v-e347e5b6] {\n    color: #fff;\n    font-size: 12px;\n    font-weight: 700;\n    background-color: #F25E0D;\n    padding: 5px 10px;\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);\n}\n.heading[data-v-e347e5b6] {\n  font-weight: 600;\n  color: #333;\n  padding: 10px 0;\n}\n.heading span[data-v-e347e5b6] {\n    margin-left: 15px;\n}\n.heading .label[data-v-e347e5b6] {\n    font-size: 20px;\n    line-height: 100%;\n    display: block;\n}\n.heading .edit[data-v-e347e5b6], .heading .rtg[data-v-e347e5b6] {\n    float: right;\n    margin-right: 5px;\n}\n.heading .cxl-reason[data-v-e347e5b6] {\n    margin-left: 2px;\n    font-size: 12px;\n    color: #777;\n    display: inline-block;\n    width: 480px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    vertical-align: middle;\n}\n.heading .track-link[data-v-e347e5b6] {\n    font-size: 12px;\n    letter-spacing: .7px;\n    margin-left: 5px;\n}\n.heading .lyft-link[data-v-e347e5b6] {\n    color: #ff00bf;\n}\n.mtech-id[data-v-e347e5b6] {\n  margin-left: 0 !important;\n  color: #7a878a;\n  font-size: 16px;\n  display: block;\n}\n.mtech-id span[data-v-e347e5b6] {\n    margin-left: 1px;\n}\n.status.ready[data-v-e347e5b6] {\n  background: #6dabc3;\n}\n.status.accepted[data-v-e347e5b6] {\n  background: #777;\n}\n.status.on-time[data-v-e347e5b6] {\n  background: #26d97a;\n}\n.status.late[data-v-e347e5b6] {\n  background: #dc9831;\n}\n.status.ontheway[data-v-e347e5b6] {\n  background: #f38d56;\n}\n.status.very-late[data-v-e347e5b6] {\n  background: #e62e2e;\n}\n.status.open-credit[data-v-e347e5b6] {\n  background: #29c3c3;\n}\n.left-panel[data-v-e347e5b6] {\n  position: fixed;\n  z-index: 2;\n  left: 0;\n  top: 0;\n  width: 652px;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #F4F8F9;\n  overflow-y: auto;\n  padding-bottom: 60px;\n}\n.left-panel .heading[data-v-e347e5b6] {\n    padding-left: 50px;\n}\n.left-panel .tab li[data-v-e347e5b6] {\n    width: 33.3%;\n}\n.left-panel .toggle-mobile[data-v-e347e5b6] {\n    display: none;\n}\n.tab[data-v-e347e5b6] {\n  list-style: none;\n  padding: 0;\n  margin: 15px 0 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  z-index: 2;\n}\n.tab li[data-v-e347e5b6] {\n    color: #0D79F2;\n    padding: 15px 25px;\n    font-size: 14px;\n    font-weight: 600;\n    text-align: center;\n    display: inline-block;\n    text-transform: uppercase;\n    cursor: pointer;\n    line-height: 1.3;\n}\n.tab li.active[data-v-e347e5b6] {\n      background: #fff;\n      -webkit-box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);\n              box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);\n      border-radius: 2px 2px 0 0;\n      color: #777;\n}\n.tab li.disabled[data-v-e347e5b6] {\n      color: #ccc;\n      cursor: default;\n}\n.tab-contents[data-v-e347e5b6] {\n  background: #fff;\n  z-index: 1;\n  position: relative;\n  -webkit-box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);\n}\n.tab-contents .tab-content[data-v-e347e5b6] {\n    padding: 20px 20px 50px;\n    display: none;\n}\n.tab-contents .tab-content.no-H-padding[data-v-e347e5b6] {\n      padding: 20px 0;\n}\n.tab-contents .tab-content.active[data-v-e347e5b6] {\n      display: block;\n}\n.tab-contents .dispatch-log[data-v-e347e5b6] {\n    padding-bottom: 80px;\n}\n.right-panel[data-v-e347e5b6] {\n  position: fixed;\n  z-index: 2;\n  right: 0;\n  top: 0;\n  width: 400px;\n  height: 100%;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #f4f8f9;\n}\n.right-panel.hide[data-v-e347e5b6] {\n    right: -400px;\n    -webkit-box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n            box-shadow: -2px 0 8px rgba(0, 0, 0, 0);\n}\n.right-panel .heading[data-v-e347e5b6] {\n    font-size: 24px;\n    padding: 10px 20px;\n    margin-bottom: 7px;\n}\n.right-panel .tab[data-v-e347e5b6] {\n    background: #d5d5d5;\n}\n.right-panel .tab .active[data-v-e347e5b6] {\n      background: #fff;\n}\n.right-panel .tab li[data-v-e347e5b6] {\n      width: 50%;\n      background-color: #f4f8f9;\n}\n.right-panel .tab-contents[data-v-e347e5b6] {\n    background: #fff;\n    display: block;\n    height: calc(100% - 57px);\n    overflow-y: auto;\n}\n.fixed-bottom[data-v-e347e5b6] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 652px;\n  height: 60px;\n  z-index: 3;\n  background: #eee;\n  padding: 10px 15px 10px 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.25);\n          box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.25);\n}\n.fixed-bottom a[data-v-e347e5b6] {\n    width: 50%;\n    margin: 0 5px;\n}\n.fixed-bottom a.right[data-v-e347e5b6] {\n      margin-left: auto;\n}\n.fixed-bottom a.create[data-v-e347e5b6] {\n      margin: 0 auto;\n}\n.modal[data-v-e347e5b6] {\n  position: fixed;\n  z-index: 12;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: none;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  resize: vertical;\n}\n.modal .bg-overlay[data-v-e347e5b6] {\n    position: absolute;\n    z-index: 1;\n    background: rgba(0, 0, 0, 0.5);\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n}\n.modal .modal-content[data-v-e347e5b6] {\n    position: relative;\n    z-index: 2;\n    background: #fff;\n    width: 400px;\n    min-height: 150px;\n    border-radius: 6px;\n    padding: 20px;\n    margin: auto;\n    -webkit-box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal.show[data-v-e347e5b6] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.modal.show .modal-content[data-v-e347e5b6] {\n      display: block;\n      -webkit-animation: slide-down-data-v-e347e5b6 .15s ease-out;\n      -moz-animation: slide-down-data-v-e347e5b6 .15s ease-out;\n}\n.breakdown .head[data-v-e347e5b6] {\n  text-align: center;\n  font-size: 18px;\n  font-weight: 600;\n  color: #555;\n  display: block;\n  padding-bottom: 3px;\n  border-bottom: 1px solid #ddd;\n  margin-bottom: 10px;\n}\n.breakdown .head.d-flex[data-v-e347e5b6] {\n    text-align: left;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.breakdown .item[data-v-e347e5b6] {\n  font-size: 15px;\n  margin-bottom: 5px;\n}\n.breakdown .item .label[data-v-e347e5b6] {\n    color: #777;\n    text-transform: uppercase;\n}\n.breakdown .item .value[data-v-e347e5b6] {\n    float: right;\n    font-weight: 600;\n}\n.breakdown .button[data-v-e347e5b6] {\n  margin-top: 20px;\n}\n.breakdown .op-link[data-v-e347e5b6] {\n  font-size: 13px;\n  color: #4da1ff;\n  font-weight: 500;\n  cursor: pointer;\n}\n.flightStatusModal[data-v-e347e5b6] {\n  text-align: center;\n}\n.flightStatusModal .loading[data-v-e347e5b6] {\n    padding: 30px 0;\n    font-size: 21px;\n    color: #555;\n}\n.flightStatusModal .loading .fa[data-v-e347e5b6] {\n      color: #0D79F2;\n}\n.flightStatusModal span[data-v-e347e5b6] {\n    display: block;\n    line-height: 1;\n}\n.flightStatusModal .label[data-v-e347e5b6] {\n    font-size: 12px;\n    color: #999;\n    text-transform: uppercase;\n}\n.flightStatusModal .value[data-v-e347e5b6] {\n    color: #555;\n    font-weight: 600;\n    font-size: 18px;\n    margin: 2px 0 20px;\n}\n.flight-error[data-v-e347e5b6] {\n  padding: 20px 0 30px;\n}\n.flight-error .fa[data-v-e347e5b6] {\n    color: #ccc;\n    margin-bottom: 10px;\n}\n.flight-error .title[data-v-e347e5b6] {\n    font-size: 24px;\n    color: #aaa;\n    font-weight: 600;\n    margin-bottom: 5px;\n}\n.flight-error .body[data-v-e347e5b6] {\n    font-style: italic;\n    color: #333;\n    font-size: 14px;\n}\n.try-again[data-v-e347e5b6] {\n  margin-bottom: 8px;\n}\n@-webkit-keyframes slide-down-data-v-e347e5b6 {\n0% {\n    opacity: 0;\n    -webkit-transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n}\n}\n.email-result[data-v-e347e5b6] {\n  text-align: center;\n}\n.email-result p[data-v-e347e5b6] {\n    font-size: 18px;\n}\n.email-result .header[data-v-e347e5b6] {\n    display: block;\n    font-weight: 600;\n    color: #333;\n    margin-bottom: 10px;\n}\n.email-result .body[data-v-e347e5b6] {\n    display: block;\n    font-size: 14px;\n    color: #444;\n    margin-bottom: 30px;\n}\n.email-result .cancel[data-v-e347e5b6] {\n    font-size: 14px;\n    margin: 10px 0 0;\n    display: block;\n    cursor: pointer;\n}\n.release-modal[data-v-e347e5b6] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.release-modal.show[data-v-e347e5b6] {\n    top: 0;\n    opacity: 1;\n}\n.release-modal-container[data-v-e347e5b6] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.release-modal-content[data-v-e347e5b6] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.release-modal-content .title[data-v-e347e5b6] {\n    font-weight: 700;\n    background-color: #333;\n    color: #fff;\n    padding: 10px;\n}\n.release-modal-content .loading[data-v-e347e5b6], .release-modal-content .error[data-v-e347e5b6] {\n    text-align: center;\n    padding: 25px 0;\n}\n.release-modal-content .loading i[data-v-e347e5b6] {\n    color: #4fa1f7;\n}\n.release-modal-content .loading div[data-v-e347e5b6] {\n    color: #999;\n}\n.release-modal-content .error i[data-v-e347e5b6] {\n    color: #f3e26d;\n}\n.release-modal-content .error div[data-v-e347e5b6] {\n    color: #777;\n    margin-top: 15px;\n}\n.release-modal-content .fee[data-v-e347e5b6] {\n    padding: 10px;\n    margin: 0 10px 20px;\n    background: #f7eeb2;\n    border: 1px solid #d0be42;\n    border-radius: 10px;\n    color: #444;\n    -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n            box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n}\n.release-modal-content .fee p[data-v-e347e5b6] {\n      margin: 0 0 5px;\n      font-size: 14px;\n}\n.release-modal-content .fee label[data-v-e347e5b6] {\n      float: left;\n      width: 50%;\n      font-weight: 600;\n}\n.release-modal-content .fee input[data-v-e347e5b6] {\n      width: initial;\n      display: inline-block;\n      margin: 0;\n}\n.release-modal-content .fee .clear[data-v-e347e5b6] {\n      clear: both;\n}\n.release-modal-content .message[data-v-e347e5b6] {\n    padding: 15px;\n    font-weight: 700;\n    color: #555;\n}\n.release-modal-content .sub-message[data-v-e347e5b6] {\n    font-size: 14px;\n    padding: 0 15px 15px;\n    color: #777;\n}\n.release-modal-content .sub-message strong[data-v-e347e5b6] {\n      color: #555;\n      text-decoration: underline;\n}\n.release-modal-content .controls[data-v-e347e5b6] {\n    padding: 0px 15px 15px;\n}\n.release-modal-content .controls .padding-R[data-v-e347e5b6] {\n      padding-right: 5px;\n}\n.release-modal-content .controls .padding-L[data-v-e347e5b6] {\n      padding-left: 5px;\n}\n.release-modal-content .releasing .message[data-v-e347e5b6] {\n    padding-top: 10px;\n}\n.release-modal-content .releasing i[data-v-e347e5b6] {\n    margin-top: 18px;\n    color: #0D79F2;\n}\n.release-modal-content .releasing i.success[data-v-e347e5b6] {\n      color: #26D97A;\n}\n.suggested-time-modal[data-v-e347e5b6] {\n  text-align: center;\n  width: 450px !important;\n}\n.suggested-time-modal .title[data-v-e347e5b6] {\n    font-size: 21px;\n    font-weight: 600;\n    color: #3c6879;\n}\n.suggested-time-modal p[data-v-e347e5b6] {\n    font-size: 15px;\n    margin: 10px 0 15px;\n}\n.suggested-time-modal .time[data-v-e347e5b6] {\n    display: inline-block;\n    font-size: 18px;\n    font-weight: 600;\n    margin-bottom: 15px;\n    border-bottom: 1px solid #24af65;\n    color: #24af65;\n    word-spacing: 5px;\n}\n.suggested-time-modal .keep[data-v-e347e5b6] {\n    display: block;\n    margin-top: 10px;\n    font-size: 14px;\n    color: #999;\n    cursor: pointer;\n}\n.editing .legend[data-v-e347e5b6] {\n  display: none;\n}\n.editing .route-map[data-v-e347e5b6], .editing .map-here[data-v-e347e5b6] {\n  width: 30%;\n  left: 70%;\n}\n.editing .left-panel[data-v-e347e5b6], .editing .fixed-bottom[data-v-e347e5b6] {\n  width: 70%;\n}\n.editing .right-panel[data-v-e347e5b6] {\n  right: -400px;\n}\n.select-user[data-v-e347e5b6] {\n  text-align: center;\n  width: 500px !important;\n  height: 400px;\n  padding: 0 !important;\n  overflow: hidden;\n  background: #f8f8f8 !important;\n}\n.select-user .title[data-v-e347e5b6] {\n    background: #444;\n    padding: 10px;\n    color: #fff;\n}\n.select-user .box[data-v-e347e5b6] {\n    padding: 10px;\n}\n.select-user .search-input[data-v-e347e5b6] {\n    margin: 0 0 10px;\n    font-size: 14px;\n    -webkit-box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.07);\n            box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.07);\n}\n.select-user .box-list[data-v-e347e5b6] {\n    position: relative;\n}\n.select-user .loader[data-v-e347e5b6] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.7);\n    color: #fff;\n}\n.select-user .loader i[data-v-e347e5b6] {\n      vertical-align: middle;\n      margin-right: 5px;\n}\n.select-user .loader .v-center[data-v-e347e5b6] {\n      text-align: center;\n      width: 100%;\n      position: absolute;\n      top: 50%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n}\n.select-user .list[data-v-e347e5b6] {\n    display: block;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    border: 1px solid #ddd;\n    height: 220px;\n    background: #fefefe;\n    border-radius: 2px;\n    -webkit-box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.07);\n            box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.07);\n    overflow: auto;\n}\n.select-user .list li[data-v-e347e5b6] {\n      text-align: left;\n      padding: 8px;\n      border-bottom: 1px solid #ddd;\n      cursor: pointer;\n}\n.select-user .list li[data-v-e347e5b6]:hover {\n        background: #fffbe7;\n}\n.select-user .list li .name[data-v-e347e5b6] {\n        font-size: 14px;\n        display: inline-block;\n        font-weight: 600;\n}\n.select-user .list li .id[data-v-e347e5b6] {\n        display: inline-block;\n        width: 70px;\n        text-align: right;\n        color: #333;\n        font-size: 12px;\n}\n.select-user .list li .email[data-v-e347e5b6], .select-user .list li .mobile[data-v-e347e5b6] {\n        display: block;\n        font-size: 12px;\n        line-height: 130%;\n        color: #aaa;\n}\n.select-user .list li.disabled[data-v-e347e5b6] {\n        cursor: default;\n        opacity: .6;\n        background: #f3f3f3;\n}\n.select-user .list li.disabled[data-v-e347e5b6]:hover {\n          background: #f3f3f3;\n}\n.select-user .list li .status[data-v-e347e5b6] {\n        letter-spacing: .9px;\n        background: #888;\n}\n.select-user .is-d2d[data-v-e347e5b6] {\n    color: #fff;\n    padding: 3px 5px;\n    line-height: 1;\n    background: #444;\n    border-radius: 4px;\n    font-weight: 600;\n    letter-spacing: .8px;\n    margin-top: 3px;\n    display: inline-block;\n}\n.select-user .actions[data-v-e347e5b6] {\n    margin-top: 10px;\n}\n.select-user .padding-L[data-v-e347e5b6] {\n    padding-left: 5px;\n}\n.select-user .padding-R[data-v-e347e5b6] {\n    padding-right: 5px;\n}\n.asap-modal[data-v-e347e5b6] {\n  max-width: 500px;\n  width: 100% !important;\n  text-align: center;\n}\n.asap-modal .fa-car[data-v-e347e5b6] {\n    color: #999;\n    font-size: 40px;\n}\n.asap-modal .fa-spinner[data-v-e347e5b6] {\n    color: #ccc;\n}\n.asap-modal .looking-for[data-v-e347e5b6] {\n    display: block;\n    margin-top: 10px;\n}\n.asap-modal .cancel-asap[data-v-e347e5b6] {\n    margin-top: 10px;\n    width: 200px;\n}\n.optin-modal[data-v-e347e5b6] {\n  text-align: center;\n}\n.optin-modal label[data-v-e347e5b6] {\n    margin-bottom: 20px;\n    display: block;\n    font-weight: 600;\n}\n.optin-modal .button[data-v-e347e5b6] {\n    width: 45%;\n}\n.select-email-recipient[data-v-e347e5b6] {\n  padding: 0 !important;\n  overflow: hidden;\n}\n.select-email-recipient .title[data-v-e347e5b6] {\n    background: #444;\n    padding: 10px;\n    color: #fff;\n    text-align: center;\n}\n.select-email-recipient .box[data-v-e347e5b6] {\n    padding: 20px;\n}\n.select-email-recipient .label[data-v-e347e5b6] {\n    color: #555;\n    font-weight: 600;\n}\n.select-email-recipient ul[data-v-e347e5b6] {\n    list-style: none;\n    padding: 0;\n}\n.select-email-recipient ul li[data-v-e347e5b6] {\n      margin-bottom: 10px;\n      font-size: 14px;\n}\n.select-email-recipient ul li span[data-v-e347e5b6] {\n        vertical-align: 2px;\n}\n.select-email-recipient input[data-v-e347e5b6] {\n    margin: 0;\n}\n.select-email-recipient input[type=\"radio\"][data-v-e347e5b6] {\n      width: auto;\n      display: inline-block;\n      margin-right: 5px;\n      width: 20px;\n}\n.select-email-recipient input[type=\"input\"][data-v-e347e5b6] {\n      display: inline-block;\n      width: calc(100% - 30px);\n      padding: 5px;\n}\n.select-email-recipient input.has-error[data-v-e347e5b6] {\n      border-color: #f00;\n}\n.select-email-recipient .padding-L[data-v-e347e5b6] {\n    padding-left: 5px;\n}\n.select-email-recipient .has-error[data-v-e347e5b6] {\n    font-size: 12px;\n    color: #f00;\n    padding-left: 30px;\n    line-height: 1.6;\n}\n.no-driver .fa-user-circle[data-v-e347e5b6] {\n  color: #555;\n}\n.no-driver .message[data-v-e347e5b6] {\n  display: block;\n  margin-top: 15px;\n  font-size: 14px;\n}\n.no-driver .change-service[data-v-e347e5b6] {\n  margin: 20px 0 5px;\n}\n.driver-info .info[data-v-e347e5b6] {\n  margin-bottom: 10px;\n}\n.driver-info .title[data-v-e347e5b6] {\n  margin-bottom: 20px;\n  display: block;\n  font-size: 21px;\n  color: #555;\n  font-weight: 600;\n}\n.driver-info .img[data-v-e347e5b6] {\n  display: inline-block;\n  width: 60px;\n  margin-right: 20px;\n  vertical-align: top;\n}\n.driver-info .desc[data-v-e347e5b6] {\n  display: inline-block;\n  width: 320px;\n  text-align: left;\n}\n.driver-info .desc .rating[data-v-e347e5b6], .driver-info .desc .name[data-v-e347e5b6], .driver-info .desc .model[data-v-e347e5b6] {\n    font-size: 14px;\n}\n.driver-info .desc .email[data-v-e347e5b6], .driver-info .desc .plate[data-v-e347e5b6] {\n    font-size: 12px;\n    color: #999;\n}\n.driver-info .desc .fa-star[data-v-e347e5b6] {\n    color: #d2c52d;\n    margin-right: 5px;\n}\n.driver-info .close-asap[data-v-e347e5b6] {\n  margin-top: 20px;\n  width: 300px;\n}\n.create-error[data-v-e347e5b6] {\n  text-align: center;\n}\n.create-error .fa-exclamation-circle[data-v-e347e5b6] {\n    color: #ffd86b;\n    margin-bottom: 3px;\n}\n.create-error .message[data-v-e347e5b6] {\n    font-size: 16px;\n    margin-bottom: 15px;\n}\n.stop-info[data-v-e347e5b6] {\n  color: #555;\n}\n.stop-info .location[data-v-e347e5b6] {\n    max-width: 300px;\n}\n.stop-info .data.top-line[data-v-e347e5b6] {\n    margin-top: 5px;\n    padding-top: 5px;\n    border-top: 1px solid #eee;\n}\n.stop-info .data div[data-v-e347e5b6] {\n    margin-bottom: 2px;\n}\n.stop-info .data label[data-v-e347e5b6] {\n    color: #999;\n}\n.stop-info .data span[data-v-e347e5b6] {\n    word-spacing: 2px;\n    font-weight: 500;\n}\n.driver-infowindow[data-v-e347e5b6] {\n  position: relative;\n  padding: 15px 0 10px 15px;\n  width: 400px;\n}\n.driver-infowindow .photo[data-v-e347e5b6] {\n    display: block;\n    width: 70px;\n    height: 70px;\n    background-color: #ddd;\n    margin: 0 auto;\n    border-radius: 70px;\n    -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.5);\n            box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.5);\n    border: 1px solid rgba(0, 0, 0, 0.25);\n}\n.driver-infowindow .name[data-v-e347e5b6] {\n    display: block;\n    text-align: center;\n    margin-top: 5px;\n    font-size: 14px;\n    font-weight: 700;\n    text-transform: uppercase;\n}\n.driver-infowindow .subtext[data-v-e347e5b6] {\n    text-align: center;\n    margin-bottom: 10px;\n    font-size: 12px;\n    color: #777;\n    font-weight: 700;\n}\n.driver-infowindow .cta[data-v-e347e5b6] {\n    margin-bottom: 5px;\n}\n.down-scale-enter-active[data-v-e347e5b6], .down-scale-leave-active[data-v-e347e5b6] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.down-scale-enter[data-v-e347e5b6], .down-scale-leave-to[data-v-e347e5b6] {\n  -webkit-transform: scale(0.7) translateY(-10px);\n          transform: scale(0.7) translateY(-10px);\n  opacity: 0;\n}\n.show-up-enter-active[data-v-e347e5b6], .show-up-leave-active[data-v-e347e5b6] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.show-up-enter[data-v-e347e5b6], .show-up-leave-to[data-v-e347e5b6] {\n  -webkit-transform: translateY(20px);\n          transform: translateY(20px);\n  opacity: 0;\n}\n.slide-up-enter-active[data-v-e347e5b6], .slide-up-leave-active[data-v-e347e5b6] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-e347e5b6], .slide-up-leave-to[data-v-e347e5b6] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n.appear-enter-active[data-v-e347e5b6], .appear-leave-active[data-v-e347e5b6] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.appear-enter[data-v-e347e5b6], .appear-leave-to[data-v-e347e5b6] {\n  -webkit-transform: scale(0.95);\n          transform: scale(0.95);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.map-box[data-v-e347e5b6] {\n    width: 100%;\n    z-index: 5;\n}\n.map-box #mapHere[data-v-e347e5b6] {\n      left: 0;\n      width: 100%;\n      top: 100%;\n      -webkit-transition: all 0.3s ease;\n      transition: all 0.3s ease;\n}\n.map-box.showMapBox #mapHere[data-v-e347e5b6] {\n      top: 0;\n}\n.heading .edit[data-v-e347e5b6] {\n    float: none;\n    margin: 0;\n}\n.left-panel[data-v-e347e5b6] {\n    width: 100%;\n    padding-bottom: 85px;\n}\n.left-panel .edit-btn-div[data-v-e347e5b6] {\n      padding-left: 13px;\n}\n.left-panel .tab[data-v-e347e5b6] {\n      margin-top: 50px;\n      display: table;\n}\n.left-panel .tab li[data-v-e347e5b6] {\n        padding: 12px 10px;\n        vertical-align: middle;\n        display: table-cell;\n        font-size: 12px;\n}\n.left-panel .fixed-bottom[data-v-e347e5b6] {\n      bottom: 40px;\n}\n.left-panel .fixed-bottom a.right[data-v-e347e5b6] {\n        margin-left: inherit;\n}\n.left-panel .fixed-bottom a.create[data-v-e347e5b6] {\n        margin: 0 auto;\n}\n.toggle-mobile[data-v-e347e5b6] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.editing .left-panel[data-v-e347e5b6],\n  .editing .fixed-bottom[data-v-e347e5b6] {\n    width: 100%;\n}\n.editing .tab li[data-v-e347e5b6] {\n    padding: 5px 13px;\n}\n.tab-contents .tab-content[data-v-e347e5b6] {\n    padding: 10px;\n}\n.transaction-tab[data-v-e347e5b6] {\n    width: 100%;\n}\n.select-user[data-v-e347e5b6] {\n    width: 95vw !important;\n    height: auto;\n}\n.right-panel[data-v-e347e5b6] {\n    width: calc(100vw - 55px) !important;\n}\n.button.small[data-v-e347e5b6] {\n    font-size: 11px;\n    width: auto;\n    padding: 7px;\n}\n.button.small.btn-close[data-v-e347e5b6] {\n      font-size: 14px;\n      width: 100%;\n}\n.fixed-bottom[data-v-e347e5b6] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    width: 100vw;\n}\n.fixed-bottom .button.small[data-v-e347e5b6] {\n      font-size: 12px;\n      width: auto;\n      padding: 7px 15px;\n}\n.fixed-bottom .button.small.create[data-v-e347e5b6] {\n        width: 100%;\n        font-size: 16px !important;\n}\n.fixed-bottom .create[data-v-e347e5b6] {\n      font-size: 14px !important;\n      padding: 10px 22px !important;\n}\n.modal .modal-content[data-v-e347e5b6] {\n    width: 100%;\n}\n.select-email-recipient .medium-6[data-v-e347e5b6] {\n    width: 50%;\n}\n.select-email-recipient .medium-6 a[data-v-e347e5b6] {\n      width: 100%;\n}\n}\n.lr-tooltip[data-v-e347e5b6] {\n  margin-left: 2px;\n  display: inline-block;\n  position: relative;\n}\n.lr-tooltip .tp-desc[data-v-e347e5b6] {\n    -webkit-transition: all .3s ease;\n    transition: all .3s ease;\n    position: absolute;\n    top: 100%;\n    width: 100px;\n    background: #fafafa;\n    padding: 5px;\n    font-size: 12px;\n    text-align: center;\n    line-height: 1.1;\n    border-radius: 4px;\n    border: 1px solid #eee;\n    left: -50px;\n    -webkit-box-shadow: 1px 1px 2px #ccc;\n            box-shadow: 1px 1px 2px #ccc;\n    opacity: 0;\n    z-index: -1;\n}\n.lr-tooltip:hover .tp-desc[data-v-e347e5b6] {\n    top: calc(100% + 4px);\n    opacity: 1;\n    z-index: 1;\n}\n.optin-icon[data-v-e347e5b6] {\n  width: 18px;\n}\n.dpo-field[data-v-e347e5b6] {\n  position: relative;\n}\n.dpo-field span[data-v-e347e5b6] {\n    position: absolute;\n    z-index: 2;\n    font-weight: 600;\n    color: #666;\n    line-height: 46px;\n    padding: 0 10px;\n}\n.dpo-field input[data-v-e347e5b6] {\n    position: relative;\n    z-index: 1;\n    padding-left: 25px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__(605);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca10b0e4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__(1794);
function injectStyle (ssrContext) {
  __webpack_require__(1779)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ca10b0e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca10b0e4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1780);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("59b9f4fe", content, true, {});

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.cc-icon[data-v-ca10b0e4] {\n  background-image: url(\"https://s3-us-west-2.amazonaws.com/mobile-consumer-app/cc-sprite.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 20px;\n  width: 32px;\n  display: inline-block;\n}\n.cc-icon.unknown[data-v-ca10b0e4] {\n    background-position: 0 0;\n}\n.cc-icon.visa[data-v-ca10b0e4] {\n    background-position: 0 -20px;\n}\n.cc-icon.mastercard[data-v-ca10b0e4] {\n    background-position: 0 -40px;\n}\n.cc-icon.amex[data-v-ca10b0e4] {\n    background-position: 0 -60px;\n}\n.cc-icon.discover[data-v-ca10b0e4] {\n    background-position: 0 -80px;\n}\n.cc-icon.jcb[data-v-ca10b0e4] {\n    background-position: 0 -100px;\n}\n.cc-icon.diners[data-v-ca10b0e4] {\n    background-position: 0 -120px;\n}\n*[data-v-ca10b0e4] {\n  -webkit-overflow-scrolling: touch;\n}\n.showDesktop[data-v-ca10b0e4], .showMobile[data-v-ca10b0e4] {\n  display: block;\n}\n.hideDesktop[data-v-ca10b0e4], .hideMobile[data-v-ca10b0e4] {\n  display: none;\n}\n.row[data-v-ca10b0e4] {\n  margin: 0 0 20px;\n  padding-top: 10px;\n  width: 100% !important;\n  max-width: 100%;\n  clear: both;\n}\n.row.row-d2d[data-v-ca10b0e4] {\n    margin: 0 0 5px;\n}\n.margin-T[data-v-ca10b0e4] {\n  margin-top: 10px;\n}\n.margin-xT[data-v-ca10b0e4] {\n  margin-top: 50px;\n}\n.margin-B[data-v-ca10b0e4] {\n  margin-bottom: 10px !important;\n}\n.margin-R[data-v-ca10b0e4] {\n  margin-right: 10px;\n}\n.padding-N-T[data-v-ca10b0e4] {\n  padding-top: 0;\n}\n.padding-R[data-v-ca10b0e4] {\n  padding-right: 10px;\n}\n.padding-xR[data-v-ca10b0e4] {\n  padding-right: 30px;\n}\n.padding-L[data-v-ca10b0e4] {\n  padding-left: 10px;\n}\n.padding-xL[data-v-ca10b0e4] {\n  padding-left: 30px;\n}\n.right[data-v-ca10b0e4] {\n  float: right;\n}\n.clearfix[data-v-ca10b0e4] {\n  clear: both;\n}\n.pointer[data-v-ca10b0e4] {\n  cursor: pointer;\n}\n.heading[data-v-ca10b0e4] {\n  font-size: 24px;\n  color: #57D1B7;\n  font-weight: 600;\n}\n.data-field[data-v-ca10b0e4] {\n  padding-right: 10px;\n  position: relative;\n}\n.data-field.no-label[data-v-ca10b0e4] {\n    padding-top: 17px;\n}\n.data-field .label[data-v-ca10b0e4] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .label.has-error[data-v-ca10b0e4] {\n      color: #f20d0d;\n}\n.data-field .label.bigger[data-v-ca10b0e4] {\n      font-size: 14px;\n}\n.data-field .label small[data-v-ca10b0e4] {\n      color: #bbb;\n      margin-left: 5px;\n      vertical-align: 2px;\n}\n.data-field .value[data-v-ca10b0e4] {\n    font-weight: 600;\n    font-size: 17px;\n    color: #555;\n}\n.data-field .value a[data-v-ca10b0e4] {\n      text-decoration: underline;\n      cursor: pointer;\n      word-wrap: break-word;\n}\n.data-field .description[data-v-ca10b0e4] {\n    font-size: 11px;\n    color: #999;\n    font-style: italic;\n    display: block;\n    color: #ff8d00;\n}\n.data-field .input[data-v-ca10b0e4] {\n    margin: 5px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-ca10b0e4] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-ca10b0e4]:disabled {\n      background: #eee;\n}\n.data-field textarea[data-v-ca10b0e4] {\n    border: 1px solid #ddd;\n    width: 100%;\n    height: 100px;\n    resize: none;\n    padding: 10px;\n    font-size: 13px;\n    color: #555;\n    outline: none;\n    margin: 5px 0 0;\n}\n.data-field select[data-v-ca10b0e4] {\n    margin-top: 5px;\n    border: 1px solid #ddd;\n    padding: 10px;\n    color: #333;\n    height: 45px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field select.has-error[data-v-ca10b0e4] {\n      border-color: #f20d0d;\n}\n.data-field select[data-v-ca10b0e4]:disabled {\n      background-color: #eee;\n}\n.data-field .checkbox[data-v-ca10b0e4] {\n    line-height: 100%;\n    margin-bottom: 3px;\n}\n.data-field .checkbox.inline[data-v-ca10b0e4] {\n      display: inline-block;\n      margin: 0 25px 10px 0;\n}\n.data-field .checkbox[data-v-ca10b0e4]:last-child {\n      margin-bottom: 0;\n}\n.data-field .checkbox input[data-v-ca10b0e4] {\n      display: inline-block;\n      width: auto;\n      vertical-align: -2px;\n      margin: 0 5px 0 0;\n}\n.data-field .checkbox label[data-v-ca10b0e4] {\n      font-size: 14px;\n      color: #555;\n      line-height: 150%;\n}\n.data-field .radio[data-v-ca10b0e4] {\n    display: block;\n    color: #333;\n    font-size: 14px;\n    margin-top: 5px;\n}\n.data-field .radio[data-v-ca10b0e4]:first-child {\n      margin-top: 5px;\n}\n.data-field .radio input[type=\"radio\"][data-v-ca10b0e4] {\n      display: inline-block;\n      width: auto;\n      margin: 0 0 0 5px;\n      vertical-align: middle;\n      cursor: pointer;\n}\n.data-field .radio .radio-fa[data-v-ca10b0e4] {\n      margin: 20px 10px 0 0;\n      color: #aaa;\n      -webkit-transition: all .5s ease;\n      transition: all .5s ease;\n}\n.data-field .radio .radio-fa.checked[data-v-ca10b0e4] {\n        color: #57d1b7;\n}\n.data-field .radio .radio-fa.checked[data-v-ca10b0e4]:before {\n          content: \"\\F192\";\n}\n.data-field .radio.with-textbox[data-v-ca10b0e4] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.data-field .radio.with-textbox input[type=\"radio\"][data-v-ca10b0e4] {\n        margin: 15px 10px 0 0;\n}\n.data-field .radio.with-textbox .input[data-v-ca10b0e4] {\n        display: inline-block;\n        vertical-align: middle;\n}\n.data-field .radio.label-only .radio-fa[data-v-ca10b0e4] {\n      margin: 0 10px 10px 0;\n}\n.data-field .error-msg[data-v-ca10b0e4] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.datepicker[data-v-ca10b0e4] {\n  position: relative;\n}\n.pickup-time .vdp-datepicker[data-v-ca10b0e4] {\n  margin-bottom: 5px;\n}\n.pickup-time .datepicker[data-v-ca10b0e4] {\n  margin-right: 25px;\n  display: inline-block;\n}\n.pickup-time select[data-v-ca10b0e4] {\n  display: inline-block;\n  width: auto;\n  min-width: 70px;\n  margin-top: 0;\n}\n.apt-gate[data-v-ca10b0e4] {\n  padding-left: 23px;\n}\n.cc-icon[data-v-ca10b0e4] {\n  margin-right: 5px;\n  vertical-align: middle;\n}\n.pricing[data-v-ca10b0e4] {\n  padding: 5px 10px;\n  border-radius: 4px;\n  -webkit-transition: all .15s ease;\n  transition: all .15s ease;\n  cursor: pointer;\n  border: 1px solid #777;\n  clear: both;\n  opacity: .65;\n  background: #fafafa;\n  color: #999;\n  min-height: 55px;\n  /*.radio-fa{ margin: 0 10px 0 0!important; }\r\n  input[type=\"radio\"]{\r\n    margin-right: 5px!important;\r\n  }*/\n}\n.pricing[data-v-ca10b0e4]:hover, .pricing.active[data-v-ca10b0e4] {\n    opacity: 1;\n}\n.pricing.active[data-v-ca10b0e4] {\n    border: 1px solid #0D79F2;\n    background: #e6f6ff;\n    color: #333;\n    -webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.35);\n            box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.35);\n}\n.pricing.disabled[data-v-ca10b0e4] {\n    cursor: default;\n    opacity: .35;\n}\n.pricing .service-desc .service-label[data-v-ca10b0e4] {\n    font-weight: 600;\n    font-size: 18px;\n    display: block;\n}\n.pricing .service-desc .rule-value[data-v-ca10b0e4] {\n    display: inline-block;\n    margin-right: 10px;\n}\n.pricing .service-desc .pax-luggage .item[data-v-ca10b0e4] {\n    display: inline-block;\n}\n.pricing .service-desc .pax-luggage .disabled[data-v-ca10b0e4] {\n    color: #f00;\n}\n.pricing .value[data-v-ca10b0e4] {\n    float: right;\n    font-weight: 600;\n    font-size: 32px;\n    display: inline-block;\n}\n.pricing .value.has-discount[data-v-ca10b0e4]:not(.price-override) {\n      font-size: 24px;\n}\n.pricing .value.has-discount:not(.price-override) div[data-v-ca10b0e4] {\n        font-size: 14px;\n        line-height: 1;\n        text-align: center;\n        color: #999;\n}\n.pricing .value.has-discount:not(.price-override) div span[data-v-ca10b0e4]:after {\n          content: '';\n          border-top: 1px solid #f00;\n          position: absolute;\n          top: 50%;\n          left: 0;\n          width: 100%;\n          height: 2px;\n}\n.pricing .value.has-discount:not(.price-override) span[data-v-ca10b0e4] {\n        position: relative;\n        padding: 0 5px;\n}\n.pricing .value.price-override[data-v-ca10b0e4] {\n      color: #923bbd;\n}\n.pricing .unavailable .availability[data-v-ca10b0e4] {\n    float: right;\n    font-weight: 600;\n    font-size: 32px;\n    display: grid;\n    text-align: center;\n}\n.pricing .unavailable .availability .available[data-v-ca10b0e4] {\n      font-size: 14px;\n      padding: 2px;\n}\n.pricing .unavailable .availability .date-time[data-v-ca10b0e4] {\n      display: block;\n      font-size: 14px;\n      font-weight: 900;\n}\n.input-group[data-v-ca10b0e4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  position: relative;\n  margin-bottom: 0;\n  margin-top: 5px;\n}\n.input-group .input-group-label[data-v-ca10b0e4] {\n    padding: 0 10px;\n    border: 1px solid #cacaca;\n    background: #f4f8f9;\n    color: #0a0a0a;\n    text-align: center;\n    white-space: nowrap;\n    cursor: pointer;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n.input-group input[data-v-ca10b0e4] {\n    border-radius: 0 3px 3px 0;\n    margin-top: 0 !important;\n}\n.currency[data-v-ca10b0e4] {\n  position: relative;\n}\n.currency input[data-v-ca10b0e4] {\n    position: relative;\n    z-index: 1;\n    padding-left: 20px;\n}\n.currency span[data-v-ca10b0e4] {\n    position: absolute;\n    top: 0;\n    left: 5px;\n    z-index: 2;\n    font-size: 21px;\n    padding: 10px 0;\n    line-height: 125%;\n    color: #ccc;\n}\n.currency .amount[data-v-ca10b0e4] {\n    color: #000;\n}\n.custom-check[data-v-ca10b0e4] {\n  cursor: pointer;\n  display: inline-block;\n  margin-right: 3px;\n  vertical-align: middle;\n}\n.custom-check div[data-v-ca10b0e4] {\n    border: 2px solid #ccc;\n    width: 22px;\n    height: 22px;\n    line-height: 1;\n    text-align: center;\n    padding: 1px 0;\n    border-radius: 3px;\n    -webkit-transition: all .25s ease-out;\n    transition: all .25s ease-out;\n}\n.custom-check div i[data-v-ca10b0e4] {\n      color: #fff;\n}\n.custom-check.enabled div[data-v-ca10b0e4] {\n    background: #57d1b7;\n    border-color: #57d1b7;\n}\n.customer-info .row[data-v-ca10b0e4] {\n  margin: 0 0 5px;\n}\n.customer-info .guest[data-v-ca10b0e4] {\n  margin: 25px 0;\n}\n.payment-summary[data-v-ca10b0e4] {\n  border: 1px solid #aaa;\n  border-radius: 6px;\n  overflow: hidden;\n  background: #fdfdfd;\n  margin-top: 50px;\n  -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);\n}\n.payment-summary .row[data-v-ca10b0e4] {\n    padding: 0;\n}\n.payment-summary .title[data-v-ca10b0e4] {\n    display: block;\n    text-align: center;\n    font-weight: 600;\n    font-size: 18px;\n    color: #fff;\n    padding: 5px 0;\n    background: #444;\n}\n.payment-summary .stats[data-v-ca10b0e4] {\n    padding: 10px;\n    font-size: 14px;\n    margin: 0 15px;\n    border-bottom: 1px solid #f0f0f0;\n}\n.payment-summary .stats.hard-border[data-v-ca10b0e4] {\n      border-bottom: 1px solid #bbb;\n}\n.payment-summary .stats .label[data-v-ca10b0e4] {\n      color: #aaa;\n      vertical-align: middle;\n}\n.payment-summary .stats .value[data-v-ca10b0e4] {\n      float: right;\n      font-weight: 600;\n      color: #555;\n}\n.payment-summary .stats .value.price-override[data-v-ca10b0e4] {\n        color: #923bbd;\n}\n.payment-summary .stats .value.total[data-v-ca10b0e4] {\n        font-size: 18px;\n        color: #333;\n}\n.payment-summary .columns:last-child .stats[data-v-ca10b0e4] {\n    border-bottom: none;\n}\n.waive-payment label[data-v-ca10b0e4] {\n  color: #888;\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: .5px;\n  vertical-align: -1px;\n  cursor: pointer;\n}\n.service-field[data-v-ca10b0e4] {\n  position: relative;\n}\n.service-field .service-loader[data-v-ca10b0e4] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 2;\n}\n.service-field .service-loader .fa-spinner[data-v-ca10b0e4] {\n      color: #00b6f1;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      margin-top: -40px;\n      margin-left: -40px;\n}\n.customer-option[data-v-ca10b0e4] {\n  padding: 10px 0;\n}\n.customer-option .or[data-v-ca10b0e4] {\n    display: inline-block;\n    margin: 0 10px;\n    color: #888;\n    font-size: 14px;\n}\n.payment-line[data-v-ca10b0e4] {\n  text-align: center;\n}\n.payment-line[data-v-ca10b0e4]:after {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    height: 1px;\n    width: 100%;\n    border-top: 1px solid #c1c1c1;\n    content: ' ';\n    z-index: 1;\n}\n.payment-line span[data-v-ca10b0e4] {\n    background: #fff;\n    padding: 0 10px;\n    position: relative;\n    z-index: 2;\n}\n.payment-option-box .fa-circle[data-v-ca10b0e4] {\n  margin-top: 3px !important;\n}\n.payment-option[data-v-ca10b0e4] {\n  vertical-align: middle;\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n}\n.cc-form[data-v-ca10b0e4] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  display: none;\n  padding: 10px;\n  background: #f5f5f5;\n}\n.cc-form.show[data-v-ca10b0e4] {\n    display: block;\n}\n.paid-notes.has-error[data-v-ca10b0e4] {\n  border: 1px solid #f20d0d;\n}\n.notes-char-count[data-v-ca10b0e4] {\n  font-size: 12px;\n  display: block;\n  float: right;\n  text-align: right;\n  color: #555;\n}\n.select-card[data-v-ca10b0e4] {\n  font-size: 11px;\n  line-height: 1.6;\n  color: #f20d0d;\n  font-style: italic;\n  display: block;\n}\n.send-email[data-v-ca10b0e4] {\n  margin-top: 40px;\n}\n.asap[data-v-ca10b0e4] {\n  margin: 10px 0;\n}\n.geofence-label[data-v-ca10b0e4] {\n  font-size: 13px;\n  margin-bottom: 10px;\n  color: #444;\n}\n.geofence-label b[data-v-ca10b0e4] {\n    margin-left: 5px;\n}\n.add-extra-stop[data-v-ca10b0e4] {\n  font-size: 13px;\n  color: #2586f3;\n  font-weight: 600;\n}\n.add-extra-stop span[data-v-ca10b0e4] {\n    cursor: pointer;\n}\n.add-extra-stop i[data-v-ca10b0e4] {\n    margin-right: 5px;\n}\n.extra-stop-notice[data-v-ca10b0e4] {\n  color: #999;\n  font-style: italic;\n  font-size: 13px;\n  margin-bottom: 3px;\n}\n.optin-toggle[data-v-ca10b0e4] {\n  font-size: 14px;\n  cursor: pointer;\n}\n.optin-toggle input[data-v-ca10b0e4] {\n    width: auto;\n    display: inline-block;\n    vertical-align: -2px;\n}\n.optin-desc[data-v-ca10b0e4] {\n  background: #fafafa;\n  border: 1px solid #424769;\n  border-radius: 4px;\n  color: #424769;\n  opacity: .6;\n}\n.optin-desc.active[data-v-ca10b0e4] {\n    opacity: 1;\n}\n.optin-desc .opt-copy[data-v-ca10b0e4] {\n    padding: 5px 10px;\n    font-size: 14px;\n}\n.optin-desc .opt-copy .head[data-v-ca10b0e4] {\n      font-weight: 600;\n      font-size: 18px;\n}\n.optin-desc .flex[data-v-ca10b0e4] {\n    padding: 5px 10px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.optin-desc .info[data-v-ca10b0e4] {\n    width: 100%;\n}\n.optin-desc .info .service-name[data-v-ca10b0e4] {\n      font-size: 18px;\n}\n.optin-desc .capacity i[data-v-ca10b0e4]:last-child {\n    margin-left: 10px;\n}\n.optin-desc .availability div[data-v-ca10b0e4] {\n    padding: 4px;\n}\n.optin-box[data-v-ca10b0e4] {\n  padding-top: 0;\n  margin-bottom: 10px !important;\n}\n.optin-box .price span[data-v-ca10b0e4] {\n    font-weight: 600;\n    font-size: 32px;\n}\n.optin-box .availability[data-v-ca10b0e4] {\n    font-size: 14px;\n    text-align: center;\n    background: #424769;\n    color: #fff;\n}\n.optin-box .availability b[data-v-ca10b0e4] {\n      margin-left: 5px;\n}\n.padding-N-r[data-v-ca10b0e4] {\n  padding-right: 0;\n}\n.margin-B-10[data-v-ca10b0e4] {\n  margin-bottom: 10px;\n}\n.margin-B-0[data-v-ca10b0e4] {\n  margin-bottom: 0;\n}\n.slide-down-enter-active[data-v-ca10b0e4], .slide-down-leave-active[data-v-ca10b0e4] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-ca10b0e4], .slide-down-leave-to[data-v-ca10b0e4] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n.show-down-enter-active[data-v-ca10b0e4], .show-down-leave-active[data-v-ca10b0e4] {\n  -webkit-transition: height 1s ease-in-out;\n  transition: height 1s ease-in-out;\n  overflow: hidden;\n}\n.show-down-enter[data-v-ca10b0e4], .show-down-leave-to[data-v-ca10b0e4] {\n  height: 0;\n}\n.popin-enter-active[data-v-ca10b0e4], .popin-leave-active[data-v-ca10b0e4] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n  -webkit-transition-delay: .3s;\n          transition-delay: .3s;\n}\n.popin-enter[data-v-ca10b0e4], .popin-leave-to[data-v-ca10b0e4] {\n  -webkit-transform: scale(0.8);\n          transform: scale(0.8);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.row[data-v-ca10b0e4] {\n    margin-bottom: 5px;\n    padding-top: 5px;\n}\n.data-field[data-v-ca10b0e4] {\n    margin-top: 5px;\n    padding-right: 5px;\n}\n.heading[data-v-ca10b0e4] {\n    font-size: 18px;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.heading.margin-xT[data-v-ca10b0e4] {\n      margin-top: 20px;\n}\n.send-email[data-v-ca10b0e4] {\n    margin-top: 10px;\n}\n.payment-summary[data-v-ca10b0e4] {\n    margin-top: 20px;\n    margin-bottom: 50px;\n}\n.pickup-time .datepicker[data-v-ca10b0e4] {\n    margin-right: 0px;\n    display: block;\n}\n.pickup-time .medium-8[data-v-ca10b0e4] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    gap: 5px;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.pickup-time .medium-8 select[data-v-ca10b0e4] {\n      width: 32%;\n}\n.padding-xL[data-v-ca10b0e4],\n  .padding-xR[data-v-ca10b0e4] {\n    padding: 0;\n}\n.customer-option .cta[data-v-ca10b0e4] {\n    margin: 5px 0;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/RsvpDetails/Edit.vue"],"names":[],"mappings":";AACA;EACE,8FAA8F;EAC9F,6BAA6B;EAC7B,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,sBAAsB;CACvB;AACD;IACI,yBAAyB;CAC5B;AACD;IACI,6BAA6B;CAChC;AACD;IACI,6BAA6B;CAChC;AACD;IACI,6BAA6B;CAChC;AACD;IACI,6BAA6B;CAChC;AACD;IACI,8BAA8B;CACjC;AACD;IACI,8BAA8B;CACjC;AACD;EACE,kCAAkC;CACnC;AACD;EACE,eAAe;CAChB;AACD;EACE,cAAc;CACf;AACD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;CACb;AACD;IACI,gBAAgB;CACnB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,+BAA+B;CAChC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,eAAe;CAChB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,aAAa;CACd;AACD;EACE,YAAY;CACb;AACD;EACE,gBAAgB;CACjB;AACD;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;CAClB;AACD;EACE,oBAAoB;EACpB,mBAAmB;CACpB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;MACM,eAAe;CACpB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,YAAY;MACZ,iBAAiB;MACjB,oBAAoB;CACzB;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;MACM,2BAA2B;MAC3B,gBAAgB;MAChB,sBAAsB;CAC3B;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,eAAe;CAClB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,wDAAwD;IACxD,6BAA6B;IAC7B,+BAA+B;IAC/B,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,uBAAuB;CAC5B;AACD;IACI,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;MACM,sBAAsB;MACtB,YAAY;MACZ,qBAAqB;MACrB,kBAAkB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,kBAAkB;CACvB;AACD;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;CACnB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,sBAAsB;MACtB,YAAY;MACZ,kBAAkB;MAClB,uBAAuB;MACvB,gBAAgB;CACrB;AACD;MACM,sBAAsB;MACtB,YAAY;MACZ,iCAAiC;MACjC,yBAAyB;CAC9B;AACD;QACQ,eAAe;CACtB;AACD;UACU,iBAAiB;CAC1B;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;CACnB;AACD;QACQ,sBAAsB;CAC7B;AACD;QACQ,sBAAsB;QACtB,uBAAuB;CAC9B;AACD;MACM,sBAAsB;CAC3B;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,sBAAsB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,cAAc;CACf;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;EAClB,uBAAuB;CACxB;AACD;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB;;;KAGG;CACJ;AACD;IACI,WAAW;CACd;AACD;IACI,0BAA0B;IAC1B,oBAAoB;IACpB,YAAY;IACZ,oDAAoD;YAC5C,4CAA4C;CACvD;AACD;IACI,gBAAgB;IAChB,aAAa;CAChB;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;CAClB;AACD;IACI,sBAAsB;IACtB,mBAAmB;CACtB;AACD;IACI,sBAAsB;CACzB;AACD;IACI,YAAY;CACf;AACD;IACI,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;CACzB;AACD;MACM,gBAAgB;CACrB;AACD;QACQ,gBAAgB;QAChB,eAAe;QACf,mBAAmB;QACnB,YAAY;CACnB;AACD;UACU,YAAY;UACZ,2BAA2B;UAC3B,mBAAmB;UACnB,SAAS;UACT,QAAQ;UACR,YAAY;UACZ,YAAY;CACrB;AACD;QACQ,mBAAmB;QACnB,eAAe;CACtB;AACD;MACM,eAAe;CACpB;AACD;IACI,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;CACtB;AACD;MACM,gBAAgB;MAChB,aAAa;CAClB;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,iBAAiB;CACtB;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;CACjB;AACD;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,uBAAuB;IACvB,oBAAoB;CACvB;AACD;IACI,2BAA2B;IAC3B,yBAAyB;CAC5B;AACD;EACE,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,mBAAmB;CACtB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;CACf;AACD;IACI,YAAY;CACf;AACD;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;CACxB;AACD;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,sCAAsC;IACtC,8BAA8B;CACjC;AACD;MACM,YAAY;CACjB;AACD;IACI,oBAAoB;IACpB,sBAAsB;CACzB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,eAAe;CAChB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,+CAA+C;UACvC,uCAAuC;CAChD;AACD;IACI,WAAW;CACd;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;CACpB;AACD;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iCAAiC;CACpC;AACD;MACM,8BAA8B;CACnC;AACD;MACM,YAAY;MACZ,uBAAuB;CAC5B;AACD;MACM,aAAa;MACb,iBAAiB;MACjB,YAAY;CACjB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,gBAAgB;QAChB,YAAY;CACnB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;CACjB;AACD;EACE,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,WAAW;CACd;AACD;MACM,eAAe;MACf,mBAAmB;MACnB,SAAS;MACT,UAAU;MACV,kBAAkB;MAClB,mBAAmB;CACxB;AACD;EACE,gBAAgB;CACjB;AACD;IACI,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,gBAAgB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,WAAW;CACd;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;CACd;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;CACjB;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,cAAc;EACd,cAAc;EACd,oBAAoB;CACrB;AACD;IACI,eAAe;CAClB;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,YAAY;CACb;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,eAAe;CAChB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,eAAe;CAChB;AACD;EACE,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;CACb;AACD;IACI,iBAAiB;CACpB;AACD;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;CAClB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,kBAAkB;CACrB;AACD;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;CACpB;AACD;EACE,gBAAgB;EAChB,gBAAgB;CACjB;AACD;IACI,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;CACxB;AACD;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,YAAY;CACb;AACD;IACI,WAAW;CACd;AACD;IACI,kBAAkB;IAClB,gBAAgB;CACnB;AACD;MACM,iBAAiB;MACjB,gBAAgB;CACrB;AACD;IACI,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;IACI,YAAY;CACf;AACD;MACM,gBAAgB;CACrB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,aAAa;CAChB;AACD;EACE,eAAe;EACf,+BAA+B;CAChC;AACD;IACI,iBAAiB;IACjB,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;CACf;AACD;MACM,iBAAiB;CACtB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ;AACD;EACE,0CAA0C;EAC1C,kCAAkC;EAClC,iBAAiB;CAClB;AACD;EACE,UAAU;CACX;AACD;EACE,iCAAiC;EACjC,yBAAyB;EACzB,8BAA8B;UACtB,sBAAsB;CAC/B;AACD;EACE,8BAA8B;UACtB,sBAAsB;EAC9B,WAAW;CACZ;AACD;AACA;IACI,mBAAmB;IACnB,iBAAiB;CACpB;AACD;IACI,gBAAgB;IAChB,mBAAmB;CACtB;AACD;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;CACpB;AACD;MACM,iBAAiB;CACtB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,iBAAiB;IACjB,oBAAoB;CACvB;AACD;IACI,kBAAkB;IAClB,eAAe;CAClB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,SAAS;IACT,oBAAoB;QAChB,gBAAgB;IACpB,yBAAyB;QACrB,sBAAsB;YAClB,wBAAwB;CACnC;AACD;MACM,WAAW;CAChB;AACD;;IAEI,WAAW;CACd;AACD;IACI,cAAc;CACjB;CACA","file":"Edit.vue","sourcesContent":["\n.cc-icon[data-v-ca10b0e4] {\n  background-image: url(\"https://s3-us-west-2.amazonaws.com/mobile-consumer-app/cc-sprite.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 20px;\n  width: 32px;\n  display: inline-block;\n}\n.cc-icon.unknown[data-v-ca10b0e4] {\n    background-position: 0 0;\n}\n.cc-icon.visa[data-v-ca10b0e4] {\n    background-position: 0 -20px;\n}\n.cc-icon.mastercard[data-v-ca10b0e4] {\n    background-position: 0 -40px;\n}\n.cc-icon.amex[data-v-ca10b0e4] {\n    background-position: 0 -60px;\n}\n.cc-icon.discover[data-v-ca10b0e4] {\n    background-position: 0 -80px;\n}\n.cc-icon.jcb[data-v-ca10b0e4] {\n    background-position: 0 -100px;\n}\n.cc-icon.diners[data-v-ca10b0e4] {\n    background-position: 0 -120px;\n}\n*[data-v-ca10b0e4] {\n  -webkit-overflow-scrolling: touch;\n}\n.showDesktop[data-v-ca10b0e4], .showMobile[data-v-ca10b0e4] {\n  display: block;\n}\n.hideDesktop[data-v-ca10b0e4], .hideMobile[data-v-ca10b0e4] {\n  display: none;\n}\n.row[data-v-ca10b0e4] {\n  margin: 0 0 20px;\n  padding-top: 10px;\n  width: 100% !important;\n  max-width: 100%;\n  clear: both;\n}\n.row.row-d2d[data-v-ca10b0e4] {\n    margin: 0 0 5px;\n}\n.margin-T[data-v-ca10b0e4] {\n  margin-top: 10px;\n}\n.margin-xT[data-v-ca10b0e4] {\n  margin-top: 50px;\n}\n.margin-B[data-v-ca10b0e4] {\n  margin-bottom: 10px !important;\n}\n.margin-R[data-v-ca10b0e4] {\n  margin-right: 10px;\n}\n.padding-N-T[data-v-ca10b0e4] {\n  padding-top: 0;\n}\n.padding-R[data-v-ca10b0e4] {\n  padding-right: 10px;\n}\n.padding-xR[data-v-ca10b0e4] {\n  padding-right: 30px;\n}\n.padding-L[data-v-ca10b0e4] {\n  padding-left: 10px;\n}\n.padding-xL[data-v-ca10b0e4] {\n  padding-left: 30px;\n}\n.right[data-v-ca10b0e4] {\n  float: right;\n}\n.clearfix[data-v-ca10b0e4] {\n  clear: both;\n}\n.pointer[data-v-ca10b0e4] {\n  cursor: pointer;\n}\n.heading[data-v-ca10b0e4] {\n  font-size: 24px;\n  color: #57D1B7;\n  font-weight: 600;\n}\n.data-field[data-v-ca10b0e4] {\n  padding-right: 10px;\n  position: relative;\n}\n.data-field.no-label[data-v-ca10b0e4] {\n    padding-top: 17px;\n}\n.data-field .label[data-v-ca10b0e4] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    text-transform: uppercase;\n    line-height: 130%;\n}\n.data-field .label.has-error[data-v-ca10b0e4] {\n      color: #f20d0d;\n}\n.data-field .label.bigger[data-v-ca10b0e4] {\n      font-size: 14px;\n}\n.data-field .label small[data-v-ca10b0e4] {\n      color: #bbb;\n      margin-left: 5px;\n      vertical-align: 2px;\n}\n.data-field .value[data-v-ca10b0e4] {\n    font-weight: 600;\n    font-size: 17px;\n    color: #555;\n}\n.data-field .value a[data-v-ca10b0e4] {\n      text-decoration: underline;\n      cursor: pointer;\n      word-wrap: break-word;\n}\n.data-field .description[data-v-ca10b0e4] {\n    font-size: 11px;\n    color: #999;\n    font-style: italic;\n    display: block;\n    color: #ff8d00;\n}\n.data-field .input[data-v-ca10b0e4] {\n    margin: 5px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-ca10b0e4] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-ca10b0e4]:disabled {\n      background: #eee;\n}\n.data-field textarea[data-v-ca10b0e4] {\n    border: 1px solid #ddd;\n    width: 100%;\n    height: 100px;\n    resize: none;\n    padding: 10px;\n    font-size: 13px;\n    color: #555;\n    outline: none;\n    margin: 5px 0 0;\n}\n.data-field select[data-v-ca10b0e4] {\n    margin-top: 5px;\n    border: 1px solid #ddd;\n    padding: 10px;\n    color: #333;\n    height: 45px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field select.has-error[data-v-ca10b0e4] {\n      border-color: #f20d0d;\n}\n.data-field select[data-v-ca10b0e4]:disabled {\n      background-color: #eee;\n}\n.data-field .checkbox[data-v-ca10b0e4] {\n    line-height: 100%;\n    margin-bottom: 3px;\n}\n.data-field .checkbox.inline[data-v-ca10b0e4] {\n      display: inline-block;\n      margin: 0 25px 10px 0;\n}\n.data-field .checkbox[data-v-ca10b0e4]:last-child {\n      margin-bottom: 0;\n}\n.data-field .checkbox input[data-v-ca10b0e4] {\n      display: inline-block;\n      width: auto;\n      vertical-align: -2px;\n      margin: 0 5px 0 0;\n}\n.data-field .checkbox label[data-v-ca10b0e4] {\n      font-size: 14px;\n      color: #555;\n      line-height: 150%;\n}\n.data-field .radio[data-v-ca10b0e4] {\n    display: block;\n    color: #333;\n    font-size: 14px;\n    margin-top: 5px;\n}\n.data-field .radio[data-v-ca10b0e4]:first-child {\n      margin-top: 5px;\n}\n.data-field .radio input[type=\"radio\"][data-v-ca10b0e4] {\n      display: inline-block;\n      width: auto;\n      margin: 0 0 0 5px;\n      vertical-align: middle;\n      cursor: pointer;\n}\n.data-field .radio .radio-fa[data-v-ca10b0e4] {\n      margin: 20px 10px 0 0;\n      color: #aaa;\n      -webkit-transition: all .5s ease;\n      transition: all .5s ease;\n}\n.data-field .radio .radio-fa.checked[data-v-ca10b0e4] {\n        color: #57d1b7;\n}\n.data-field .radio .radio-fa.checked[data-v-ca10b0e4]:before {\n          content: \"\\f192\";\n}\n.data-field .radio.with-textbox[data-v-ca10b0e4] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.data-field .radio.with-textbox input[type=\"radio\"][data-v-ca10b0e4] {\n        margin: 15px 10px 0 0;\n}\n.data-field .radio.with-textbox .input[data-v-ca10b0e4] {\n        display: inline-block;\n        vertical-align: middle;\n}\n.data-field .radio.label-only .radio-fa[data-v-ca10b0e4] {\n      margin: 0 10px 10px 0;\n}\n.data-field .error-msg[data-v-ca10b0e4] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n.datepicker[data-v-ca10b0e4] {\n  position: relative;\n}\n.pickup-time .vdp-datepicker[data-v-ca10b0e4] {\n  margin-bottom: 5px;\n}\n.pickup-time .datepicker[data-v-ca10b0e4] {\n  margin-right: 25px;\n  display: inline-block;\n}\n.pickup-time select[data-v-ca10b0e4] {\n  display: inline-block;\n  width: auto;\n  min-width: 70px;\n  margin-top: 0;\n}\n.apt-gate[data-v-ca10b0e4] {\n  padding-left: 23px;\n}\n.cc-icon[data-v-ca10b0e4] {\n  margin-right: 5px;\n  vertical-align: middle;\n}\n.pricing[data-v-ca10b0e4] {\n  padding: 5px 10px;\n  border-radius: 4px;\n  -webkit-transition: all .15s ease;\n  transition: all .15s ease;\n  cursor: pointer;\n  border: 1px solid #777;\n  clear: both;\n  opacity: .65;\n  background: #fafafa;\n  color: #999;\n  min-height: 55px;\n  /*.radio-fa{ margin: 0 10px 0 0!important; }\r\n  input[type=\"radio\"]{\r\n    margin-right: 5px!important;\r\n  }*/\n}\n.pricing[data-v-ca10b0e4]:hover, .pricing.active[data-v-ca10b0e4] {\n    opacity: 1;\n}\n.pricing.active[data-v-ca10b0e4] {\n    border: 1px solid #0D79F2;\n    background: #e6f6ff;\n    color: #333;\n    -webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.35);\n            box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.35);\n}\n.pricing.disabled[data-v-ca10b0e4] {\n    cursor: default;\n    opacity: .35;\n}\n.pricing .service-desc .service-label[data-v-ca10b0e4] {\n    font-weight: 600;\n    font-size: 18px;\n    display: block;\n}\n.pricing .service-desc .rule-value[data-v-ca10b0e4] {\n    display: inline-block;\n    margin-right: 10px;\n}\n.pricing .service-desc .pax-luggage .item[data-v-ca10b0e4] {\n    display: inline-block;\n}\n.pricing .service-desc .pax-luggage .disabled[data-v-ca10b0e4] {\n    color: #f00;\n}\n.pricing .value[data-v-ca10b0e4] {\n    float: right;\n    font-weight: 600;\n    font-size: 32px;\n    display: inline-block;\n}\n.pricing .value.has-discount[data-v-ca10b0e4]:not(.price-override) {\n      font-size: 24px;\n}\n.pricing .value.has-discount:not(.price-override) div[data-v-ca10b0e4] {\n        font-size: 14px;\n        line-height: 1;\n        text-align: center;\n        color: #999;\n}\n.pricing .value.has-discount:not(.price-override) div span[data-v-ca10b0e4]:after {\n          content: '';\n          border-top: 1px solid #f00;\n          position: absolute;\n          top: 50%;\n          left: 0;\n          width: 100%;\n          height: 2px;\n}\n.pricing .value.has-discount:not(.price-override) span[data-v-ca10b0e4] {\n        position: relative;\n        padding: 0 5px;\n}\n.pricing .value.price-override[data-v-ca10b0e4] {\n      color: #923bbd;\n}\n.pricing .unavailable .availability[data-v-ca10b0e4] {\n    float: right;\n    font-weight: 600;\n    font-size: 32px;\n    display: grid;\n    text-align: center;\n}\n.pricing .unavailable .availability .available[data-v-ca10b0e4] {\n      font-size: 14px;\n      padding: 2px;\n}\n.pricing .unavailable .availability .date-time[data-v-ca10b0e4] {\n      display: block;\n      font-size: 14px;\n      font-weight: 900;\n}\n.input-group[data-v-ca10b0e4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  position: relative;\n  margin-bottom: 0;\n  margin-top: 5px;\n}\n.input-group .input-group-label[data-v-ca10b0e4] {\n    padding: 0 10px;\n    border: 1px solid #cacaca;\n    background: #f4f8f9;\n    color: #0a0a0a;\n    text-align: center;\n    white-space: nowrap;\n    cursor: pointer;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n.input-group input[data-v-ca10b0e4] {\n    border-radius: 0 3px 3px 0;\n    margin-top: 0 !important;\n}\n.currency[data-v-ca10b0e4] {\n  position: relative;\n}\n.currency input[data-v-ca10b0e4] {\n    position: relative;\n    z-index: 1;\n    padding-left: 20px;\n}\n.currency span[data-v-ca10b0e4] {\n    position: absolute;\n    top: 0;\n    left: 5px;\n    z-index: 2;\n    font-size: 21px;\n    padding: 10px 0;\n    line-height: 125%;\n    color: #ccc;\n}\n.currency .amount[data-v-ca10b0e4] {\n    color: #000;\n}\n.custom-check[data-v-ca10b0e4] {\n  cursor: pointer;\n  display: inline-block;\n  margin-right: 3px;\n  vertical-align: middle;\n}\n.custom-check div[data-v-ca10b0e4] {\n    border: 2px solid #ccc;\n    width: 22px;\n    height: 22px;\n    line-height: 1;\n    text-align: center;\n    padding: 1px 0;\n    border-radius: 3px;\n    -webkit-transition: all .25s ease-out;\n    transition: all .25s ease-out;\n}\n.custom-check div i[data-v-ca10b0e4] {\n      color: #fff;\n}\n.custom-check.enabled div[data-v-ca10b0e4] {\n    background: #57d1b7;\n    border-color: #57d1b7;\n}\n.customer-info .row[data-v-ca10b0e4] {\n  margin: 0 0 5px;\n}\n.customer-info .guest[data-v-ca10b0e4] {\n  margin: 25px 0;\n}\n.payment-summary[data-v-ca10b0e4] {\n  border: 1px solid #aaa;\n  border-radius: 6px;\n  overflow: hidden;\n  background: #fdfdfd;\n  margin-top: 50px;\n  -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);\n}\n.payment-summary .row[data-v-ca10b0e4] {\n    padding: 0;\n}\n.payment-summary .title[data-v-ca10b0e4] {\n    display: block;\n    text-align: center;\n    font-weight: 600;\n    font-size: 18px;\n    color: #fff;\n    padding: 5px 0;\n    background: #444;\n}\n.payment-summary .stats[data-v-ca10b0e4] {\n    padding: 10px;\n    font-size: 14px;\n    margin: 0 15px;\n    border-bottom: 1px solid #f0f0f0;\n}\n.payment-summary .stats.hard-border[data-v-ca10b0e4] {\n      border-bottom: 1px solid #bbb;\n}\n.payment-summary .stats .label[data-v-ca10b0e4] {\n      color: #aaa;\n      vertical-align: middle;\n}\n.payment-summary .stats .value[data-v-ca10b0e4] {\n      float: right;\n      font-weight: 600;\n      color: #555;\n}\n.payment-summary .stats .value.price-override[data-v-ca10b0e4] {\n        color: #923bbd;\n}\n.payment-summary .stats .value.total[data-v-ca10b0e4] {\n        font-size: 18px;\n        color: #333;\n}\n.payment-summary .columns:last-child .stats[data-v-ca10b0e4] {\n    border-bottom: none;\n}\n.waive-payment label[data-v-ca10b0e4] {\n  color: #888;\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: .5px;\n  vertical-align: -1px;\n  cursor: pointer;\n}\n.service-field[data-v-ca10b0e4] {\n  position: relative;\n}\n.service-field .service-loader[data-v-ca10b0e4] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 2;\n}\n.service-field .service-loader .fa-spinner[data-v-ca10b0e4] {\n      color: #00b6f1;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      margin-top: -40px;\n      margin-left: -40px;\n}\n.customer-option[data-v-ca10b0e4] {\n  padding: 10px 0;\n}\n.customer-option .or[data-v-ca10b0e4] {\n    display: inline-block;\n    margin: 0 10px;\n    color: #888;\n    font-size: 14px;\n}\n.payment-line[data-v-ca10b0e4] {\n  text-align: center;\n}\n.payment-line[data-v-ca10b0e4]:after {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    height: 1px;\n    width: 100%;\n    border-top: 1px solid #c1c1c1;\n    content: ' ';\n    z-index: 1;\n}\n.payment-line span[data-v-ca10b0e4] {\n    background: #fff;\n    padding: 0 10px;\n    position: relative;\n    z-index: 2;\n}\n.payment-option-box .fa-circle[data-v-ca10b0e4] {\n  margin-top: 3px !important;\n}\n.payment-option[data-v-ca10b0e4] {\n  vertical-align: middle;\n  display: block;\n  font-size: 13px;\n  cursor: pointer;\n}\n.cc-form[data-v-ca10b0e4] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  display: none;\n  padding: 10px;\n  background: #f5f5f5;\n}\n.cc-form.show[data-v-ca10b0e4] {\n    display: block;\n}\n.paid-notes.has-error[data-v-ca10b0e4] {\n  border: 1px solid #f20d0d;\n}\n.notes-char-count[data-v-ca10b0e4] {\n  font-size: 12px;\n  display: block;\n  float: right;\n  text-align: right;\n  color: #555;\n}\n.select-card[data-v-ca10b0e4] {\n  font-size: 11px;\n  line-height: 1.6;\n  color: #f20d0d;\n  font-style: italic;\n  display: block;\n}\n.send-email[data-v-ca10b0e4] {\n  margin-top: 40px;\n}\n.asap[data-v-ca10b0e4] {\n  margin: 10px 0;\n}\n.geofence-label[data-v-ca10b0e4] {\n  font-size: 13px;\n  margin-bottom: 10px;\n  color: #444;\n}\n.geofence-label b[data-v-ca10b0e4] {\n    margin-left: 5px;\n}\n.add-extra-stop[data-v-ca10b0e4] {\n  font-size: 13px;\n  color: #2586f3;\n  font-weight: 600;\n}\n.add-extra-stop span[data-v-ca10b0e4] {\n    cursor: pointer;\n}\n.add-extra-stop i[data-v-ca10b0e4] {\n    margin-right: 5px;\n}\n.extra-stop-notice[data-v-ca10b0e4] {\n  color: #999;\n  font-style: italic;\n  font-size: 13px;\n  margin-bottom: 3px;\n}\n.optin-toggle[data-v-ca10b0e4] {\n  font-size: 14px;\n  cursor: pointer;\n}\n.optin-toggle input[data-v-ca10b0e4] {\n    width: auto;\n    display: inline-block;\n    vertical-align: -2px;\n}\n.optin-desc[data-v-ca10b0e4] {\n  background: #fafafa;\n  border: 1px solid #424769;\n  border-radius: 4px;\n  color: #424769;\n  opacity: .6;\n}\n.optin-desc.active[data-v-ca10b0e4] {\n    opacity: 1;\n}\n.optin-desc .opt-copy[data-v-ca10b0e4] {\n    padding: 5px 10px;\n    font-size: 14px;\n}\n.optin-desc .opt-copy .head[data-v-ca10b0e4] {\n      font-weight: 600;\n      font-size: 18px;\n}\n.optin-desc .flex[data-v-ca10b0e4] {\n    padding: 5px 10px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.optin-desc .info[data-v-ca10b0e4] {\n    width: 100%;\n}\n.optin-desc .info .service-name[data-v-ca10b0e4] {\n      font-size: 18px;\n}\n.optin-desc .capacity i[data-v-ca10b0e4]:last-child {\n    margin-left: 10px;\n}\n.optin-desc .availability div[data-v-ca10b0e4] {\n    padding: 4px;\n}\n.optin-box[data-v-ca10b0e4] {\n  padding-top: 0;\n  margin-bottom: 10px !important;\n}\n.optin-box .price span[data-v-ca10b0e4] {\n    font-weight: 600;\n    font-size: 32px;\n}\n.optin-box .availability[data-v-ca10b0e4] {\n    font-size: 14px;\n    text-align: center;\n    background: #424769;\n    color: #fff;\n}\n.optin-box .availability b[data-v-ca10b0e4] {\n      margin-left: 5px;\n}\n.padding-N-r[data-v-ca10b0e4] {\n  padding-right: 0;\n}\n.margin-B-10[data-v-ca10b0e4] {\n  margin-bottom: 10px;\n}\n.margin-B-0[data-v-ca10b0e4] {\n  margin-bottom: 0;\n}\n.slide-down-enter-active[data-v-ca10b0e4], .slide-down-leave-active[data-v-ca10b0e4] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-ca10b0e4], .slide-down-leave-to[data-v-ca10b0e4] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n.show-down-enter-active[data-v-ca10b0e4], .show-down-leave-active[data-v-ca10b0e4] {\n  -webkit-transition: height 1s ease-in-out;\n  transition: height 1s ease-in-out;\n  overflow: hidden;\n}\n.show-down-enter[data-v-ca10b0e4], .show-down-leave-to[data-v-ca10b0e4] {\n  height: 0;\n}\n.popin-enter-active[data-v-ca10b0e4], .popin-leave-active[data-v-ca10b0e4] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n  -webkit-transition-delay: .3s;\n          transition-delay: .3s;\n}\n.popin-enter[data-v-ca10b0e4], .popin-leave-to[data-v-ca10b0e4] {\n  -webkit-transform: scale(0.8);\n          transform: scale(0.8);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.row[data-v-ca10b0e4] {\n    margin-bottom: 5px;\n    padding-top: 5px;\n}\n.data-field[data-v-ca10b0e4] {\n    margin-top: 5px;\n    padding-right: 5px;\n}\n.heading[data-v-ca10b0e4] {\n    font-size: 18px;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.heading.margin-xT[data-v-ca10b0e4] {\n      margin-top: 20px;\n}\n.send-email[data-v-ca10b0e4] {\n    margin-top: 10px;\n}\n.payment-summary[data-v-ca10b0e4] {\n    margin-top: 20px;\n    margin-bottom: 50px;\n}\n.pickup-time .datepicker[data-v-ca10b0e4] {\n    margin-right: 0px;\n    display: block;\n}\n.pickup-time .medium-8[data-v-ca10b0e4] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    gap: 5px;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.pickup-time .medium-8 select[data-v-ca10b0e4] {\n      width: 32%;\n}\n.padding-xL[data-v-ca10b0e4],\n  .padding-xR[data-v-ca10b0e4] {\n    padding: 0;\n}\n.customer-option .cta[data-v-ca10b0e4] {\n    margin: 5px 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationInput_vue__ = __webpack_require__(606);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a001aff8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationInput_vue__ = __webpack_require__(1784);
function injectStyle (ssrContext) {
  __webpack_require__(1782)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a001aff8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a001aff8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1783);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("33968036", content, true, {});

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.autocomplete[data-v-a001aff8] {\n  position: relative;\n  width: 100%;\n}\n.suggestions[data-v-a001aff8] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  max-height: 150px;\n  z-index: 2;\n  list-style: none;\n  overflow: auto;\n  padding: 0;\n  margin: 0;\n  -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);\n}\n.suggestions li[data-v-a001aff8] {\n    background: #f6f6f6;\n    padding: 8px 10px;\n    width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor: pointer;\n    border-bottom: 1px solid #bbb;\n    color: #333;\n}\n.suggestions li[data-v-a001aff8]:last-child {\n      border-bottom: none;\n}\n.suggestions li i[data-v-a001aff8] {\n      margin-right: 5px;\n}\n.suggestions li span[data-v-a001aff8] {\n      font-size: 13px;\n}\n.suggestions li .fa-exclamation-triangle[data-v-a001aff8] {\n      color: #e2c84a;\n}\n.suggestions li .fa-map-marker[data-v-a001aff8] {\n      color: #ea5c5c;\n}\n.suggestions li[data-v-a001aff8]:hover {\n      background: #0D79F2;\n      color: #fff;\n}\n.suggestions li:hover i[data-v-a001aff8] {\n        color: #fff;\n}\n.suggestions li.empty[data-v-a001aff8] {\n      cursor: default;\n}\n.input[data-v-a001aff8] {\n  margin: 5px 0 0;\n  color: #333;\n  line-height: inherit;\n  -webkit-transition: all .15s ease;\n  transition: all .15s ease;\n}\n.input.loading[data-v-a001aff8] {\n    padding-right: 40px;\n}\n.input.has-error[data-v-a001aff8] {\n    border-color: #f20d0d;\n}\n.input[data-v-a001aff8]:disabled {\n    background: #eee;\n}\n.error-msg[data-v-a001aff8] {\n  font-size: 11px;\n  line-height: 1.6;\n  color: #f20d0d;\n  font-style: italic;\n  display: block;\n}\n.loader[data-v-a001aff8] {\n  position: absolute;\n  top: 8px;\n  right: 5px;\n  z-index: 2;\n  color: #aaa;\n}\n.slide-down-enter-active[data-v-a001aff8], .slide-down-leave-active[data-v-a001aff8] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-a001aff8], .slide-down-leave-to[data-v-a001aff8] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Partials/LocationInput.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,UAAU;EACV,mDAAmD;UAC3C,2CAA2C;CACpD;AACD;IACI,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,8BAA8B;IAC9B,YAAY;CACf;AACD;MACM,oBAAoB;CACzB;AACD;MACM,kBAAkB;CACvB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,oBAAoB;MACpB,YAAY;CACjB;AACD;QACQ,YAAY;CACnB;AACD;MACM,gBAAgB;CACrB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;IACI,oBAAoB;CACvB;AACD;IACI,sBAAsB;CACzB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,eAAe;CAChB;AACD;EACE,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;CACb;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ","file":"LocationInput.vue","sourcesContent":["\n.autocomplete[data-v-a001aff8] {\n  position: relative;\n  width: 100%;\n}\n.suggestions[data-v-a001aff8] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  max-height: 150px;\n  z-index: 2;\n  list-style: none;\n  overflow: auto;\n  padding: 0;\n  margin: 0;\n  -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);\n}\n.suggestions li[data-v-a001aff8] {\n    background: #f6f6f6;\n    padding: 8px 10px;\n    width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor: pointer;\n    border-bottom: 1px solid #bbb;\n    color: #333;\n}\n.suggestions li[data-v-a001aff8]:last-child {\n      border-bottom: none;\n}\n.suggestions li i[data-v-a001aff8] {\n      margin-right: 5px;\n}\n.suggestions li span[data-v-a001aff8] {\n      font-size: 13px;\n}\n.suggestions li .fa-exclamation-triangle[data-v-a001aff8] {\n      color: #e2c84a;\n}\n.suggestions li .fa-map-marker[data-v-a001aff8] {\n      color: #ea5c5c;\n}\n.suggestions li[data-v-a001aff8]:hover {\n      background: #0D79F2;\n      color: #fff;\n}\n.suggestions li:hover i[data-v-a001aff8] {\n        color: #fff;\n}\n.suggestions li.empty[data-v-a001aff8] {\n      cursor: default;\n}\n.input[data-v-a001aff8] {\n  margin: 5px 0 0;\n  color: #333;\n  line-height: inherit;\n  -webkit-transition: all .15s ease;\n  transition: all .15s ease;\n}\n.input.loading[data-v-a001aff8] {\n    padding-right: 40px;\n}\n.input.has-error[data-v-a001aff8] {\n    border-color: #f20d0d;\n}\n.input[data-v-a001aff8]:disabled {\n    background: #eee;\n}\n.error-msg[data-v-a001aff8] {\n  font-size: 11px;\n  line-height: 1.6;\n  color: #f20d0d;\n  font-style: italic;\n  display: block;\n}\n.loader[data-v-a001aff8] {\n  position: absolute;\n  top: 8px;\n  right: 5px;\n  z-index: 2;\n  color: #aaa;\n}\n.slide-down-enter-active[data-v-a001aff8], .slide-down-leave-active[data-v-a001aff8] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-a001aff8], .slide-down-leave-to[data-v-a001aff8] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"autocomplete"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyInput),expression:"keyInput"}],class:{'input':true, 'loading':_vm.loading, 'has-error':!!_vm.extra.error},attrs:{"type":"text","disabled":_vm.extra.disabled || _vm.loading},domProps:{"value":(_vm.keyInput)},on:{"keyup":_vm.query,"blur":_vm.clickOut,"input":function($event){if($event.target.composing){ return; }_vm.keyInput=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.extra.error))]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"fa fa-spinner fa-spin loader fa-2x"}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSuggestion),expression:"showSuggestion"}],staticClass:"suggestions"},_vm._l((_vm.suggestions),function(item,index){return _c('li',{key:index,class:{'empty':item.title === 'Sorry'},on:{"click":function($event){return _vm.selectLocation(index)}}},[_c('i',{class:['fas', item.icon]}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.title + ', ' + item.subtitle))])])}),0)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlightInput_vue__ = __webpack_require__(607);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50a93b11_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlightInput_vue__ = __webpack_require__(1788);
function injectStyle (ssrContext) {
  __webpack_require__(1786)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50a93b11"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlightInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50a93b11_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlightInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1787);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2386c0f6", content, true, {});

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.autocomplete[data-v-50a93b11] {\n  position: relative;\n  width: 100%;\n}\n.suggestions[data-v-50a93b11] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  max-height: 150px;\n  z-index: 2;\n  list-style: none;\n  overflow: auto;\n  padding: 0;\n  margin: 0;\n  -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);\n}\n.suggestions li[data-v-50a93b11] {\n    background: #f6f6f6;\n    padding: 8px 10px;\n    width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor: pointer;\n    border-bottom: 1px solid #bbb;\n    color: #333;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.suggestions li[data-v-50a93b11]:last-child {\n      border-bottom: none;\n}\n.suggestions li i[data-v-50a93b11] {\n      margin-right: 10px;\n}\n.suggestions li span[data-v-50a93b11] {\n      font-size: 13px;\n}\n.suggestions li div[data-v-50a93b11] {\n      width: 100%;\n}\n.suggestions li div span[data-v-50a93b11] {\n        font-size: 14px;\n        line-height: 1;\n}\n.suggestions li div small[data-v-50a93b11] {\n        font-size: 13px;\n        color: #888;\n        display: block;\n        line-height: 1;\n}\n.suggestions li div small i[data-v-50a93b11] {\n          margin: 0 5px;\n}\n.suggestions li .fa-exclamation-triangle[data-v-50a93b11] {\n      color: #e2c84a;\n}\n.suggestions li .fa-map-marker[data-v-50a93b11] {\n      color: #ea5c5c;\n}\n.suggestions li[data-v-50a93b11]:hover {\n      background: #0D79F2;\n}\n.suggestions li:hover *[data-v-50a93b11] {\n        color: #fff;\n}\n.suggestions li.empty[data-v-50a93b11] {\n      cursor: default;\n}\n.input[data-v-50a93b11] {\n  margin: 5px 0 0;\n  color: #333;\n  line-height: inherit;\n  -webkit-transition: all .15s ease;\n  transition: all .15s ease;\n}\n.input.loading[data-v-50a93b11] {\n    padding-right: 40px;\n}\n.input.has-error[data-v-50a93b11] {\n    border-color: #f20d0d;\n}\n.input[data-v-50a93b11]:disabled {\n    background: #eee;\n}\n.error-msg[data-v-50a93b11] {\n  font-size: 11px;\n  line-height: 1.6;\n  color: #f20d0d;\n  font-style: italic;\n  display: block;\n}\n.loader[data-v-50a93b11] {\n  position: absolute;\n  top: 8px;\n  right: 5px;\n  z-index: 2;\n  color: #aaa;\n}\n.slide-down-enter-active[data-v-50a93b11], .slide-down-leave-active[data-v-50a93b11] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-50a93b11], .slide-down-leave-to[data-v-50a93b11] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Partials/FlightInput.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,UAAU;EACV,mDAAmD;UAC3C,2CAA2C;CACpD;AACD;IACI,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,8BAA8B;IAC9B,YAAY;IACZ,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;CAC/B;AACD;MACM,oBAAoB;CACzB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,YAAY;CACjB;AACD;QACQ,gBAAgB;QAChB,eAAe;CACtB;AACD;QACQ,gBAAgB;QAChB,YAAY;QACZ,eAAe;QACf,eAAe;CACtB;AACD;UACU,cAAc;CACvB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,oBAAoB;CACzB;AACD;QACQ,YAAY;CACnB;AACD;MACM,gBAAgB;CACrB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;IACI,oBAAoB;CACvB;AACD;IACI,sBAAsB;CACzB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,eAAe;CAChB;AACD;EACE,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;CACb;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ","file":"FlightInput.vue","sourcesContent":["\n.autocomplete[data-v-50a93b11] {\n  position: relative;\n  width: 100%;\n}\n.suggestions[data-v-50a93b11] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  max-height: 150px;\n  z-index: 2;\n  list-style: none;\n  overflow: auto;\n  padding: 0;\n  margin: 0;\n  -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);\n}\n.suggestions li[data-v-50a93b11] {\n    background: #f6f6f6;\n    padding: 8px 10px;\n    width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor: pointer;\n    border-bottom: 1px solid #bbb;\n    color: #333;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.suggestions li[data-v-50a93b11]:last-child {\n      border-bottom: none;\n}\n.suggestions li i[data-v-50a93b11] {\n      margin-right: 10px;\n}\n.suggestions li span[data-v-50a93b11] {\n      font-size: 13px;\n}\n.suggestions li div[data-v-50a93b11] {\n      width: 100%;\n}\n.suggestions li div span[data-v-50a93b11] {\n        font-size: 14px;\n        line-height: 1;\n}\n.suggestions li div small[data-v-50a93b11] {\n        font-size: 13px;\n        color: #888;\n        display: block;\n        line-height: 1;\n}\n.suggestions li div small i[data-v-50a93b11] {\n          margin: 0 5px;\n}\n.suggestions li .fa-exclamation-triangle[data-v-50a93b11] {\n      color: #e2c84a;\n}\n.suggestions li .fa-map-marker[data-v-50a93b11] {\n      color: #ea5c5c;\n}\n.suggestions li[data-v-50a93b11]:hover {\n      background: #0D79F2;\n}\n.suggestions li:hover *[data-v-50a93b11] {\n        color: #fff;\n}\n.suggestions li.empty[data-v-50a93b11] {\n      cursor: default;\n}\n.input[data-v-50a93b11] {\n  margin: 5px 0 0;\n  color: #333;\n  line-height: inherit;\n  -webkit-transition: all .15s ease;\n  transition: all .15s ease;\n}\n.input.loading[data-v-50a93b11] {\n    padding-right: 40px;\n}\n.input.has-error[data-v-50a93b11] {\n    border-color: #f20d0d;\n}\n.input[data-v-50a93b11]:disabled {\n    background: #eee;\n}\n.error-msg[data-v-50a93b11] {\n  font-size: 11px;\n  line-height: 1.6;\n  color: #f20d0d;\n  font-style: italic;\n  display: block;\n}\n.loader[data-v-50a93b11] {\n  position: absolute;\n  top: 8px;\n  right: 5px;\n  z-index: 2;\n  color: #aaa;\n}\n.slide-down-enter-active[data-v-50a93b11], .slide-down-leave-active[data-v-50a93b11] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-50a93b11], .slide-down-leave-to[data-v-50a93b11] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"autocomplete"},[(_vm.type === 'airlines')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyInput),expression:"keyInput"}],class:{'input':true, 'loading':_vm.loading, 'has-error':!!_vm.extra.error},attrs:{"type":"text","disabled":_vm.loading || _vm.airlineLoading},domProps:{"value":(_vm.keyInput)},on:{"keyup":_vm.filterAirlines,"focus":_vm.filterAirlines,"blur":_vm.clickOut,"input":function($event){if($event.target.composing){ return; }_vm.keyInput=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'flight')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyInput),expression:"keyInput"}],ref:"flight",class:{'input':true, 'loading':_vm.loading, 'has-error':!!_vm.extra.error},attrs:{"type":"text","id":"flightInput","disabled":_vm.loading || _vm.airlineLoading},domProps:{"value":(_vm.keyInput)},on:{"keyup":_vm.filterFlights,"click":_vm.getFlightList,"blur":_vm.clickOut,"input":function($event){if($event.target.composing){ return; }_vm.keyInput=$event.target.value}}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.extra.error))]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"fa fa-spinner fa-spin loader fa-2x"}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSuggestion && !_vm.airlineLoading),expression:"showSuggestion && !airlineLoading"}],staticClass:"suggestions"},_vm._l((_vm.suggestions),function(item,index){return _c('li',{on:{"click":function($event){return _vm.selectItem(item)}}},[_c('i',{staticClass:"fas fa-plane"}),_vm._v(" "),(_vm.type === 'airlines')?_c('div',[_c('span',[_vm._v(_vm._s(item.label))])]):_c('div',[_c('span',[_c('b',[_vm._v(_vm._s(item.label))])]),_vm._v(" "),(item.fromTo)?_c('small',{domProps:{"innerHTML":_vm._s(item.fromTo)}}):_vm._e()])])}),0)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  cardIcon: function cardIcon(val) {
    switch (val) {
      case 'Visa':
        return 'visa';
      case 'Master Card':
        return 'mastercard';
      case 'MasterCard':
        return 'mastercard';
      case 'mastercard':
        return 'mastercard';
      case 'American Express':
        return 'amex';
      case 'Discover':
        return 'discover';
      case 'JCB':
        return 'jcb';
      case 'Diners Club':
        return 'diners';
      default:
        return 'unknown';
    }
  }
});

/***/ }),
/* 1790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StripeForm_vue__ = __webpack_require__(608);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bf69d2e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StripeForm_vue__ = __webpack_require__(1793);
function injectStyle (ssrContext) {
  __webpack_require__(1791)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bf69d2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StripeForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bf69d2e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StripeForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1792);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("438c6a10", content, true, {});

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.cc-form[data-v-2bf69d2e] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  display: none;\n  padding: 15px 20px;\n  background: #f5f5f5;\n}\n.cc-form.show[data-v-2bf69d2e] {\n    display: block;\n}\n.data-field[data-v-2bf69d2e] {\n  position: relative;\n  margin-bottom: 10px;\n}\n.data-field.no-label[data-v-2bf69d2e] {\n    padding-top: 17px;\n}\n.data-field .label[data-v-2bf69d2e] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    text-transform: uppercase;\n    line-height: 130%;\n    letter-spacing: .5px;\n}\n.data-field .label.has-error[data-v-2bf69d2e] {\n      color: #f20d0d;\n}\n.data-field .label.bigger[data-v-2bf69d2e] {\n      font-size: 14px;\n}\n.data-field .label small[data-v-2bf69d2e] {\n      color: #bbb;\n      margin-left: 5px;\n      vertical-align: 2px;\n}\n.data-field .value[data-v-2bf69d2e] {\n    font-weight: 600;\n    font-size: 17px;\n    color: #555;\n}\n.data-field .value a[data-v-2bf69d2e] {\n      text-decoration: underline;\n      cursor: pointer;\n      word-wrap: break-word;\n}\n.data-field .description[data-v-2bf69d2e] {\n    font-size: 11px;\n    color: #999;\n    font-style: italic;\n    display: block;\n    color: #ff8d00;\n}\n.data-field .input[data-v-2bf69d2e] {\n    margin: 2px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-2bf69d2e] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-2bf69d2e]:disabled {\n      background: #eee;\n}\n.data-field textarea[data-v-2bf69d2e] {\n    border: 1px solid #ddd;\n    width: 100%;\n    height: 100px;\n    resize: none;\n    padding: 10px;\n    font-size: 13px;\n    color: #555;\n    outline: none;\n    margin: 5px 0 0;\n}\n.data-field select[data-v-2bf69d2e] {\n    margin-top: 5px;\n    border: 1px solid #ddd;\n    padding: 10px;\n    color: #333;\n    height: 45px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field select.has-error[data-v-2bf69d2e] {\n      border-color: #f20d0d;\n}\n.data-field select[data-v-2bf69d2e]:disabled {\n      background-color: #eee;\n}\n.data-field .checkbox[data-v-2bf69d2e] {\n    line-height: 100%;\n    margin-bottom: 3px;\n}\n.data-field .checkbox.inline[data-v-2bf69d2e] {\n      display: inline-block;\n      margin: 0 25px 10px 0;\n}\n.data-field .checkbox[data-v-2bf69d2e]:last-child {\n      margin-bottom: 0;\n}\n.data-field .checkbox input[data-v-2bf69d2e] {\n      display: inline-block;\n      width: auto;\n      vertical-align: -2px;\n      margin: 0 5px 0 0;\n}\n.data-field .checkbox label[data-v-2bf69d2e] {\n      font-size: 14px;\n      color: #555;\n      line-height: 150%;\n}\n.data-field .radio[data-v-2bf69d2e] {\n    display: block;\n    color: #333;\n    font-size: 14px;\n    margin-top: 5px;\n}\n.data-field .radio[data-v-2bf69d2e]:first-child {\n      margin-top: 5px;\n}\n.data-field .radio input[type=\"radio\"][data-v-2bf69d2e] {\n      display: inline-block;\n      width: auto;\n      margin: 0 0 0 5px;\n      vertical-align: middle;\n      cursor: pointer;\n}\n.data-field .radio .radio-fa[data-v-2bf69d2e] {\n      margin: 20px 10px 0 0;\n      color: #aaa;\n      -webkit-transition: all .5s ease;\n      transition: all .5s ease;\n}\n.data-field .radio .radio-fa.checked[data-v-2bf69d2e] {\n        color: #57d1b7;\n}\n.data-field .radio .radio-fa.checked[data-v-2bf69d2e]:before {\n          content: \"\\F192\";\n}\n.data-field .radio.with-textbox[data-v-2bf69d2e] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.data-field .radio.with-textbox input[type=\"radio\"][data-v-2bf69d2e] {\n        margin: 15px 10px 0 0;\n}\n.data-field .radio.with-textbox .input[data-v-2bf69d2e] {\n        display: inline-block;\n        vertical-align: middle;\n}\n.data-field .radio.label-only .radio-fa[data-v-2bf69d2e] {\n      margin: 0 10px 10px 0;\n}\n.data-field .error-msg[data-v-2bf69d2e] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n#card-element[data-v-2bf69d2e] {\n  border: 1px solid #ccc;\n  padding: 10px;\n  margin-bottom: 15px;\n  background: #fbfbfb;\n  -webkit-box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.1);\n          box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.1);\n}\n.state-zip[data-v-2bf69d2e] {\n  gap: 15px;\n}\n.state-zip .data-field[data-v-2bf69d2e] {\n    width: 100%;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/RsvpDetails/StripeForm.vue"],"names":[],"mappings":";AACA;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,cAAc;EACd,mBAAmB;EACnB,oBAAoB;CACrB;AACD;IACI,eAAe;CAClB;AACD;EACE,mBAAmB;EACnB,oBAAoB;CACrB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,qBAAqB;CACxB;AACD;MACM,eAAe;CACpB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,YAAY;MACZ,iBAAiB;MACjB,oBAAoB;CACzB;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;MACM,2BAA2B;MAC3B,gBAAgB;MAChB,sBAAsB;CAC3B;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,eAAe;CAClB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,wDAAwD;IACxD,6BAA6B;IAC7B,+BAA+B;IAC/B,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,uBAAuB;CAC5B;AACD;IACI,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;MACM,sBAAsB;MACtB,YAAY;MACZ,qBAAqB;MACrB,kBAAkB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,kBAAkB;CACvB;AACD;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;CACnB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,sBAAsB;MACtB,YAAY;MACZ,kBAAkB;MAClB,uBAAuB;MACvB,gBAAgB;CACrB;AACD;MACM,sBAAsB;MACtB,YAAY;MACZ,iCAAiC;MACjC,yBAAyB;CAC9B;AACD;QACQ,eAAe;CACtB;AACD;UACU,iBAAiB;CAC1B;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;CACnB;AACD;QACQ,sBAAsB;CAC7B;AACD;QACQ,sBAAsB;QACtB,uBAAuB;CAC9B;AACD;MACM,sBAAsB;CAC3B;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;EACE,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,yDAAyD;UACjD,iDAAiD;CAC1D;AACD;EACE,UAAU;CACX;AACD;IACI,YAAY;CACf","file":"StripeForm.vue","sourcesContent":["\n.cc-form[data-v-2bf69d2e] {\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n  display: none;\n  padding: 15px 20px;\n  background: #f5f5f5;\n}\n.cc-form.show[data-v-2bf69d2e] {\n    display: block;\n}\n.data-field[data-v-2bf69d2e] {\n  position: relative;\n  margin-bottom: 10px;\n}\n.data-field.no-label[data-v-2bf69d2e] {\n    padding-top: 17px;\n}\n.data-field .label[data-v-2bf69d2e] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    text-transform: uppercase;\n    line-height: 130%;\n    letter-spacing: .5px;\n}\n.data-field .label.has-error[data-v-2bf69d2e] {\n      color: #f20d0d;\n}\n.data-field .label.bigger[data-v-2bf69d2e] {\n      font-size: 14px;\n}\n.data-field .label small[data-v-2bf69d2e] {\n      color: #bbb;\n      margin-left: 5px;\n      vertical-align: 2px;\n}\n.data-field .value[data-v-2bf69d2e] {\n    font-weight: 600;\n    font-size: 17px;\n    color: #555;\n}\n.data-field .value a[data-v-2bf69d2e] {\n      text-decoration: underline;\n      cursor: pointer;\n      word-wrap: break-word;\n}\n.data-field .description[data-v-2bf69d2e] {\n    font-size: 11px;\n    color: #999;\n    font-style: italic;\n    display: block;\n    color: #ff8d00;\n}\n.data-field .input[data-v-2bf69d2e] {\n    margin: 2px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-2bf69d2e] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-2bf69d2e]:disabled {\n      background: #eee;\n}\n.data-field textarea[data-v-2bf69d2e] {\n    border: 1px solid #ddd;\n    width: 100%;\n    height: 100px;\n    resize: none;\n    padding: 10px;\n    font-size: 13px;\n    color: #555;\n    outline: none;\n    margin: 5px 0 0;\n}\n.data-field select[data-v-2bf69d2e] {\n    margin-top: 5px;\n    border: 1px solid #ddd;\n    padding: 10px;\n    color: #333;\n    height: 45px;\n    position: relative;\n    font-size: 14px;\n    outline: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field select.has-error[data-v-2bf69d2e] {\n      border-color: #f20d0d;\n}\n.data-field select[data-v-2bf69d2e]:disabled {\n      background-color: #eee;\n}\n.data-field .checkbox[data-v-2bf69d2e] {\n    line-height: 100%;\n    margin-bottom: 3px;\n}\n.data-field .checkbox.inline[data-v-2bf69d2e] {\n      display: inline-block;\n      margin: 0 25px 10px 0;\n}\n.data-field .checkbox[data-v-2bf69d2e]:last-child {\n      margin-bottom: 0;\n}\n.data-field .checkbox input[data-v-2bf69d2e] {\n      display: inline-block;\n      width: auto;\n      vertical-align: -2px;\n      margin: 0 5px 0 0;\n}\n.data-field .checkbox label[data-v-2bf69d2e] {\n      font-size: 14px;\n      color: #555;\n      line-height: 150%;\n}\n.data-field .radio[data-v-2bf69d2e] {\n    display: block;\n    color: #333;\n    font-size: 14px;\n    margin-top: 5px;\n}\n.data-field .radio[data-v-2bf69d2e]:first-child {\n      margin-top: 5px;\n}\n.data-field .radio input[type=\"radio\"][data-v-2bf69d2e] {\n      display: inline-block;\n      width: auto;\n      margin: 0 0 0 5px;\n      vertical-align: middle;\n      cursor: pointer;\n}\n.data-field .radio .radio-fa[data-v-2bf69d2e] {\n      margin: 20px 10px 0 0;\n      color: #aaa;\n      -webkit-transition: all .5s ease;\n      transition: all .5s ease;\n}\n.data-field .radio .radio-fa.checked[data-v-2bf69d2e] {\n        color: #57d1b7;\n}\n.data-field .radio .radio-fa.checked[data-v-2bf69d2e]:before {\n          content: \"\\f192\";\n}\n.data-field .radio.with-textbox[data-v-2bf69d2e] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.data-field .radio.with-textbox input[type=\"radio\"][data-v-2bf69d2e] {\n        margin: 15px 10px 0 0;\n}\n.data-field .radio.with-textbox .input[data-v-2bf69d2e] {\n        display: inline-block;\n        vertical-align: middle;\n}\n.data-field .radio.label-only .radio-fa[data-v-2bf69d2e] {\n      margin: 0 10px 10px 0;\n}\n.data-field .error-msg[data-v-2bf69d2e] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\n#card-element[data-v-2bf69d2e] {\n  border: 1px solid #ccc;\n  padding: 10px;\n  margin-bottom: 15px;\n  background: #fbfbfb;\n  -webkit-box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.1);\n          box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.1);\n}\n.state-zip[data-v-2bf69d2e] {\n  gap: 15px;\n}\n.state-zip .data-field[data-v-2bf69d2e] {\n    width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cc-form show"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Cardholder Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardOwner),expression:"cardOwner"}],class:['input', {'has-error':!!_vm.validation.userCardOwner}],attrs:{"type":"text"},domProps:{"value":(_vm.cardOwner)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cardOwner=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userCardOwner))])]),_vm._v(" "),_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],class:['input', {'has-error':!!_vm.validation.address}],attrs:{"type":"text"},domProps:{"value":(_vm.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.address))])]),_vm._v(" "),_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userCity),expression:"userCity"}],class:['input', {'has-error':!!_vm.validation.userCity}],attrs:{"type":"text"},domProps:{"value":(_vm.userCity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userCity=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userCity))])]),_vm._v(" "),_c('div',{staticClass:"d-flex state-zip"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("State")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.userState),expression:"userState"}],class:{'has-error':!!_vm.validation.userState},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.userState=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{class:{'hideDesktop':_vm.isDesktop, 'showMobile':_vm.isMobile},attrs:{"disabled":""},domProps:{"value":null}}),_vm._v(" "),_c('option',{attrs:{"value":".."}}),_vm._v(" "),_c('option',{attrs:{"value":""}},[_vm._v("Non US")]),_vm._v(" "),_vm._l((_vm.states),function(state){return _c('option',{domProps:{"value":state.value}},[_vm._v(_vm._s(state.label))])})],2),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userState))])]),_vm._v(" "),_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Zip")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userZip),expression:"userZip"}],class:['input', {'has-error':!!_vm.validation.userZip}],attrs:{"type":"text"},domProps:{"value":(_vm.userZip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userZip=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userZip))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.userState === ''),expression:"userState === ''"}],staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Country")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.userCountry),expression:"userCountry"}],class:['input', {'has-error':!!_vm.validation.userCountry}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.userCountry=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{class:{'hideDesktop':_vm.isDesktop, 'showMobile':_vm.isMobile},attrs:{"disabled":""},domProps:{"value":null}}),_vm._v(" "),_vm._l((_vm.countries.all),function(country){return _c('option',{domProps:{"value":country.alpha2}},[_vm._v(_vm._s(country.name))])})],2),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userCountry))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Credit Card #")]),_vm._v(" "),_c('div',{attrs:{"id":"card-element"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"medium-7 columns padding-xR"},[_c('div',{staticClass:"heading"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.rideRetails')))]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.isNewRsvp && !!_vm.currentGeofence)?_c('div',{staticClass:"geofence-label"},[_vm._v("Geofence: "),_c('b',[_vm._v(_vm._s(_vm.currentGeofence))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"medium-6 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.brand'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.editData.tripInfo.brandId),expression:"editData.tripInfo.brandId"}],attrs:{"disabled":_vm.brandsLoading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.editData.tripInfo, "brandId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.changeBrand]}},[_c('option',{class:{'hideDesktop':_vm.isDesktop, 'showMobile':_vm.isMobile},attrs:{"disabled":""},domProps:{"value":null}}),_vm._v(" "),_vm._l((_vm.brands),function(brand){return _c('option',{key:brand.id,domProps:{"value":brand.id}},[_vm._v(_vm._s(brand.name))])})],2)])]),_vm._v(" "),(_vm.enableCharterBooking && _vm.isNewRsvp)?_c('div',{staticClass:"medium-6 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Booking Type")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.bookingType),expression:"bookingType"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.bookingType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"mileage"}},[_vm._v("Mileage")]),_vm._v(" "),_c('option',{attrs:{"value":"charter"}},[_vm._v("Charter")])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.pickup'))+"*")]),_vm._v(" "),_c('div',{staticClass:"radio with-textbox"},[_c('i',{class:{'far fa-circle fa-lg radio-fa':true, 'checked':_vm.isCustomPickupLocation},on:{"click":function($event){_vm.isCustomPickupLocation = !_vm.isCustomPickupLocation}}}),_vm._v(" "),_c('div',{staticClass:"small-8 columns padding-R"},[_c('location',{ref:"customPickupLoc",attrs:{"value":_vm.customPickupLocation,"extra":_vm.pickupExtra},on:{"change":_vm.locationNewValue}})],1),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-L"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editData.tripInfo.aptGate),expression:"editData.tripInfo.aptGate"}],staticClass:"input",attrs:{"type":"text","disabled":!_vm.isCustomPickupLocation || _vm.tripInfo.isAirportPickup,"placeholder":_vm.$t('rsvpDetails.edit.aptGate')},domProps:{"value":(_vm.editData.tripInfo.aptGate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editData.tripInfo, "aptGate", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"radio with-textbox"},[_c('i',{class:{'far fa-circle fa-lg radio-fa':true, 'checked':!_vm.isCustomPickupLocation},on:{"click":function($event){_vm.isCustomPickupLocation = !_vm.isCustomPickupLocation}}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pickupAirportId),expression:"pickupAirportId"}],attrs:{"disabled":_vm.isCustomPickupLocation || _vm.waivePayments},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.pickupAirportId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.selectAirportPickup]}},[_c('option',{attrs:{"value":"0","disabled":"","selected":""}},[_vm._v("Airport List")]),_vm._v(" "),_vm._l((_vm.airportList),function(airport){return _c('option',{domProps:{"value":airport.geofenceId}},[_vm._v("\n                  "+_vm._s(airport.description)+"\n                ")])})],2)])])])]),_vm._v(" "),(!_vm.charter.enabled)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field"},[(_vm.extraStops && _vm.extraStops.length)?_c('div',{staticClass:"label"},[_vm._v("Extra Stop*")]):_vm._e(),_vm._v(" "),_vm._l((_vm.extraStops),function(stop){return _c('location',{key:stop.id,ref:("extraStop" + (stop.id)),refInFor:true,staticClass:"margin-B-10",attrs:{"value":stop,"extra":_vm.extraData(stop)},on:{"change":_vm.locationNewStop}})})],2),_vm._v(" "),_c('div',{staticClass:"add-extra-stop"},[(_vm.extraStops && _vm.extraStops.length === 0)?_c('span',{on:{"click":_vm.addExtraStop}},[_c('i',{staticClass:"fas fa-plus-circle"}),_vm._v(" Add extra stop")]):_c('span',{on:{"click":_vm.removeExtraStop}},[_c('i',{staticClass:"fas fa-minus-circle"}),_vm._v(" Remove extra stop")])])])]):_vm._e(),_vm._v(" "),(!_vm.charter.enabled)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.dropoff'))+"*")]),_vm._v(" "),_c('div',{staticClass:"radio with-textbox"},[_c('i',{class:{'far fa-circle fa-lg radio-fa':true, 'checked':_vm.isCustomDropoffLocation},on:{"click":function($event){_vm.isCustomDropoffLocation = !_vm.isCustomDropoffLocation}}}),_vm._v(" "),_c('div',{staticClass:"small-8 columns padding-R"},[_c('location',{ref:"customDropoffLoc",attrs:{"value":_vm.customDropoffLocation,"extra":_vm.dropoffExtra},on:{"change":_vm.locationNewValue}})],1),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-L"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editData.tripInfo.aptGateDropoff),expression:"editData.tripInfo.aptGateDropoff"}],staticClass:"input",attrs:{"type":"text","disabled":!_vm.isCustomDropoffLocation || _vm.tripInfo.isAirportDropoff,"placeholder":_vm.$t('rsvpDetails.edit.aptGate')},domProps:{"value":(_vm.editData.tripInfo.aptGateDropoff)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editData.tripInfo, "aptGateDropoff", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"radio with-textbox"},[_c('i',{class:{'far fa-circle fa-lg radio-fa':true, 'checked':!_vm.isCustomDropoffLocation},on:{"click":function($event){_vm.isCustomDropoffLocation = !_vm.isCustomDropoffLocation}}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dropoffAirportId),expression:"dropoffAirportId"}],attrs:{"disabled":_vm.isCustomDropoffLocation},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dropoffAirportId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.selectAirportDropoff]}},[_c('option',{attrs:{"value":"0","disabled":"","selected":""}},[_vm._v("Airport List")]),_vm._v(" "),_vm._l((_vm.airportList),function(airport){return _c('option',{domProps:{"value":airport.geofenceId}},[_vm._v("\n                  "+_vm._s(airport.description)+"\n                ")])})],2)])])])]):_vm._e(),_vm._v(" "),(_vm.mtech.enabled && (_vm.airportPickup || _vm.airportDropoff))?_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Flight Date*")]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"0"}},[_c('div',{staticClass:"pickup-time"},[_c('div',{staticClass:"small-12 medium-4 columns"},[_c('datepicker',{class:['datepicker inline', {'has-error':!!_vm.validation.pickupTime && false}],attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm._edit.serviceLoading,"disabled":_vm.disabledDate},on:{"input":_vm.changeFlightDate},model:{value:(_vm.flightDate.date),callback:function ($$v) {_vm.$set(_vm.flightDate, "date", $$v)},expression:"flightDate.date"}})],1),_vm._v(" "),_c('div',{staticClass:"small-12 medium-8 columns time-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.flightDate.hour),expression:"flightDate.hour"}],class:{'has-error':!!_vm.validation.pickupTime && false},attrs:{"disabled":_vm._edit.serviceLoading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.flightDate, "hour", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateFlightDate]}},_vm._l((_vm.maxHour),function(n,i){return _c('option',{key:i,domProps:{"value":_vm.leadingZero(n)}},[_vm._v(_vm._s(_vm.leadingZero(n)))])}),0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.flightDate.minute),expression:"flightDate.minute"}],class:{'has-error':!!_vm.validation.pickupTime && false},attrs:{"disabled":_vm._edit.serviceLoading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.flightDate, "minute", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateFlightDate]}},[_c('option',{attrs:{"value":"00"}},[_vm._v("00")]),_vm._v(" "),_vm._l((11),function(n,i){return _c('option',{key:i,domProps:{"value":_vm.leadingZero(n * 5)}},[_vm._v(_vm._s(_vm.leadingZero(n * 5)))])})],2),_vm._v(" "),(!_vm.isMilitaryTime)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.flightDate.amPm),expression:"flightDate.amPm"}],class:{'has-error':!!_vm.validation.pickupTime && false},attrs:{"disabled":_vm._edit.serviceLoading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.flightDate, "amPm", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateFlightDate]}},[_c('option',{attrs:{"value":"AM"}},[_vm._v("AM")]),_vm._v(" "),_c('option',{attrs:{"value":"PM"}},[_vm._v("PM")])]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{class:{'custom-check':true, 'enabled':_vm.isDomestic},on:{"click":function($event){_vm.isDomestic = !_vm.isDomestic}}},[_vm._m(0)]),_vm._v(" "),_c('span',{staticClass:"label",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.isDomestic = !_vm.isDomestic}}},[_vm._v("\n              This is a domestic flight\n            ")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(!_vm.charter.enabled)?_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.pickupDate'))+"*")]),_vm._v(" "),(!_vm.mtech.enabled)?_c('div',{staticClass:"asap"},[_c('div',{class:{'custom-check':true, 'enabled':_vm.pickupAsap},on:{"click":_vm.pickupAsapToggle}},[_vm._m(1)]),_vm._v(" "),_c('span',{staticClass:"label",on:{"click":_vm.pickupAsapToggle}},[_vm._v("\n                As Soon As Possible\n              ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"0"}},[_c('div',{staticClass:"pickup-time"},[_c('div',{staticClass:"small-12 medium-4 columns"},[_c('datepicker',{class:{'datepicker inline':true, 'has-error':!!_vm.validation.pickupTime},attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.tripInfo.isAsap || _vm.pickupAsap,"disabled":_vm.disabledDate},on:{"input":_vm.changeDate},model:{value:(_vm.pickupDate.date),callback:function ($$v) {_vm.$set(_vm.pickupDate, "date", $$v)},expression:"pickupDate.date"}})],1),_vm._v(" "),_c('div',{staticClass:"small-12 medium-8 columns time-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pickupDate.hour),expression:"pickupDate.hour"}],class:{'has-error':!!_vm.validation.pickupTime},attrs:{"disabled":_vm.tripInfo.isAsap || _vm.pickupAsap},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.pickupDate, "hour", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updatePickupDate]}},_vm._l((_vm.maxHour),function(n){return _c('option',{domProps:{"value":_vm.leadingZero(n)}},[_vm._v(_vm._s(_vm.leadingZero(n)))])}),0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pickupDate.minute),expression:"pickupDate.minute"}],class:{'has-error':!!_vm.validation.pickupTime},attrs:{"disabled":_vm.tripInfo.isAsap || _vm.pickupAsap},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.pickupDate, "minute", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updatePickupDate]}},[_c('option',{attrs:{"value":"00"}},[_vm._v("00")]),_vm._v(" "),_vm._l((11),function(n){return _c('option',{domProps:{"value":_vm.leadingZero(n * 5)}},[_vm._v(_vm._s(_vm.leadingZero(n * 5)))])})],2),_vm._v(" "),(!_vm.isMilitaryTime)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pickupDate.amPm),expression:"pickupDate.amPm"}],class:{'has-error':!!_vm.validation.pickupTime},attrs:{"disabled":_vm.tripInfo.isAsap || _vm.pickupAsap},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.pickupDate, "amPm", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updatePickupDate]}},[_c('option',{attrs:{"value":"AM"}},[_vm._v("AM")]),_vm._v(" "),_c('option',{attrs:{"value":"PM"}},[_vm._v("PM")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.pickupTime))])])])])])]):_vm._e(),_vm._v(" "),(_vm.charter.enabled)?_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Start Date*")]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"0"}},[_c('div',{staticClass:"pickup-time"},[_c('div',{staticClass:"small-12 medium-4 columns"},[_c('datepicker',{class:{'datepicker inline':true, 'has-error':!!_vm.charterValidation.startDate},attrs:{"format":_vm.calendarFormat,"disabled":_vm.disabledDate},on:{"input":function($event){return _vm.changeCharterDate('startDate')}},model:{value:(_vm.startDate.date),callback:function ($$v) {_vm.$set(_vm.startDate, "date", $$v)},expression:"startDate.date"}})],1),_vm._v(" "),_c('div',{staticClass:"small-12 medium-8 columns"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate.hour),expression:"startDate.hour"}],class:{'has-error':!!_vm.charterValidation.startDate},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.startDate, "hour", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateCharterTime('startDate')}]}},_vm._l((_vm.maxHour),function(n){return _c('option',{key:n,domProps:{"value":_vm.leadingZero(n)}},[_vm._v(_vm._s(_vm.leadingZero(n)))])}),0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate.minute),expression:"startDate.minute"}],class:{'has-error':!!_vm.charterValidation.startDate},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.startDate, "minute", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateCharterTime('startDate')}]}},[_c('option',{attrs:{"value":"00"}},[_vm._v("00")]),_vm._v(" "),_vm._l((11),function(n){return _c('option',{key:n,domProps:{"value":_vm.leadingZero(n * 5)}},[_vm._v(_vm._s(_vm.leadingZero(n * 5)))])})],2),_vm._v(" "),(!_vm.isMilitaryTime)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate.amPm),expression:"startDate.amPm"}],class:{'has-error':!!_vm.charterValidation.startDate},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.startDate, "amPm", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateCharterTime('startDate')}]}},[_c('option',{attrs:{"value":"AM"}},[_vm._v("AM")]),_vm._v(" "),_c('option',{attrs:{"value":"PM"}},[_vm._v("PM")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.charterValidation.startDate))])])])])])]):_vm._e(),_vm._v(" "),(_vm.charter.enabled)?_c('div',{staticClass:"small-12 columns",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("End Date*")]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"0"}},[_c('div',{staticClass:"pickup-time"},[_c('div',{staticClass:"small-12 medium-4 columns"},[_c('datepicker',{class:{'datepicker inline':true, 'has-error':!!_vm.charterValidation.endDate},attrs:{"format":_vm.calendarFormat,"disabled":_vm.disabledDate},on:{"input":function($event){return _vm.changeCharterDate('endDate')}},model:{value:(_vm.endDate.date),callback:function ($$v) {_vm.$set(_vm.endDate, "date", $$v)},expression:"endDate.date"}})],1),_vm._v(" "),_c('div',{staticClass:"small-12 medium-8 columns"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate.hour),expression:"endDate.hour"}],class:{'has-error':!!_vm.charterValidation.endDate},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.endDate, "hour", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateCharterTime('endDate')}]}},_vm._l((_vm.maxHour),function(n){return _c('option',{key:n,domProps:{"value":_vm.leadingZero(n)}},[_vm._v(_vm._s(_vm.leadingZero(n)))])}),0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate.minute),expression:"endDate.minute"}],class:{'has-error':!!_vm.charterValidation.endDate},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.endDate, "minute", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateCharterTime('endDate')}]}},[_c('option',{attrs:{"value":"00"}},[_vm._v("00")]),_vm._v(" "),_vm._l((11),function(n){return _c('option',{key:n,domProps:{"value":_vm.leadingZero(n * 5)}},[_vm._v(_vm._s(_vm.leadingZero(n * 5)))])})],2),_vm._v(" "),(!_vm.isMilitaryTime)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate.amPm),expression:"endDate.amPm"}],class:{'has-error':!!_vm.charterValidation.endDate},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.endDate, "amPm", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateCharterTime('endDate')}]}},[_c('option',{attrs:{"value":"AM"}},[_vm._v("AM")]),_vm._v(" "),_c('option',{attrs:{"value":"PM"}},[_vm._v("PM")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.charterValidation.endDate))])])])])])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFlightInput()),expression:"showFlightInput()"}],staticClass:"row"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.$t('rsvpDetails.edit.airline'))+"\n                "),(!_vm.isFreshDeliveries)?_c('span',[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('flight',{attrs:{"type":"airlines","value":_vm.editData.tripInfo.airline,"extra":_vm.airlinesExtra,"airlineLoading":_vm.airlineLoading}})],1)]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.$t('rsvpDetails.edit.flight'))+"\n                "),(!_vm.isFreshDeliveries)?_c('span',[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('flight',{attrs:{"type":"flight","value":_vm.editData.tripInfo.flightNo,"extra":_vm.flightExtra,"airlineLoading":_vm.airlineLoading}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.passenger'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.passenger),expression:"passenger"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.passenger=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_vm._l((9),function(n){return _c('option',{key:n,domProps:{"value":n}},[_vm._v(_vm._s(n))])}),_vm._v(" "),(!_vm.mtech.enabled)?_c('option',{domProps:{"value":27}},[_vm._v("Up to 27")]):_vm._e(),_vm._v(" "),(!_vm.mtech.enabled)?_c('option',{domProps:{"value":34}},[_vm._v("Up to 34")]):_vm._e(),_vm._v(" "),(!_vm.mtech.enabled)?_c('option',{domProps:{"value":56}},[_vm._v("Up to 56")]):_vm._e(),_vm._v(" "),_vm._l((5),function(n){return (_vm.mtech.enabled)?_c('option',{key:n + 9},[_vm._v(_vm._s(n + 9))]):_vm._e()})],2)])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.luggage'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.luggage),expression:"luggage"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.luggage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("0")]),_vm._v(" "),_vm._l((50),function(x){return _c('option',{key:x,domProps:{"value":x}},[_vm._v(_vm._s(x))])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{class:{'custom-check':true, 'enabled':_vm.wheelchairEnabled},on:{"click":function($event){_vm.wheelchairEnabled = !_vm.wheelchairEnabled}}},[_vm._m(2)]),_vm._v(" "),_c('span',{staticClass:"label",on:{"click":function($event){_vm.wheelchairEnabled = !_vm.wheelchairEnabled}}},[_vm._v("\n              "+_vm._s(_vm.$t('rsvpDetails.edit.wheelchair'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{class:{'custom-check':true, 'enabled':_vm.serviceDogEnabled},on:{"click":function($event){_vm.serviceDogEnabled = !_vm.serviceDogEnabled}}},[_vm._m(3)]),_vm._v(" "),_c('span',{staticClass:"label",on:{"click":function($event){_vm.serviceDogEnabled = !_vm.serviceDogEnabled}}},[_vm._v("\n              "+_vm._s(_vm.$t('rsvpDetails.edit.serviceDog'))+"\n            ")])])])]),_vm._v(" "),_c('div',{class:{'row margin-B':true, 'hideDesktop':_vm.isDesktop, 'showMobile':_vm.isMobile}},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field service-field"},[_c('div',{class:{'label':true, 'has-error':!!_vm.validation.service}},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.services'))+"*")]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.service))]),_vm._v(" "),_c('transition',{attrs:{"name":"popin"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.serviceLoading),expression:"serviceLoading"}],staticClass:"service-loader"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-5x"})])]),_vm._v(" "),_vm._l((_vm.servicePrices),function(service,index){return _c('label',{class:{'radio pricing':true, 'active':_vm.selectedService === _vm.serviceDetails(index).code, 'disabled':_vm.serviceDisable(index, service) || service.status !== 'allowed'},on:{"click":function($event){_vm.selectService(_vm.serviceDetails(index).code, service)}}},[(!_vm.serviceAvailability(service).enabled || !(_vm.serviceAvailability(service).enabled && !_vm.serviceAvailability(service).eligible))?_c('span',[_c('span',{class:{'value':true, 'has-discount':_vm.price(service).hasDiscount, 'price-override':_vm.priceOverrideEnabled && !!_vm.priceOverride}},[_vm._v("\n                  "+_vm._s(_vm.price(service).value)+"\n                  "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.price(service).hasDiscount),expression:"price(service).hasDiscount"}]},[_c('span',[_vm._v(_vm._s(_vm.price(service).original))])])])]):_c('span',{staticClass:"unavailable"},[_c('span',{staticClass:"availability"},[(_vm.serviceAvailability(service).unavailable)?_c('span',{staticClass:"available"},[_vm._v("\n                    Not Available\n                  ")]):_c('span',{staticClass:"available"},[(_vm.serviceAvailability(service).after)?_c('span',[_c('span',{staticClass:"available"},[_vm._v("Available from")]),_vm._v(" "),_c('span',{staticClass:"date-time"},[_vm._v(_vm._s(_vm.serviceAvailability(service).after))])]):_c('span',[_c('span',{staticClass:"available"},[_vm._v("Available until")]),_vm._v(" "),_c('span',{staticClass:"date-time"},[_vm._v(_vm._s(_vm.serviceAvailability(service).before))])])])])]),_vm._v(" "),_c('div',{staticClass:"service-desc"},[_c('span',{staticClass:"service-label"},[_vm._v(_vm._s(_vm.serviceDetails(index).label))]),_vm._v(" "),_c('div',{staticClass:"pax-luggage"},[_c('div',{class:{'item':true, 'disabled':_vm.maxPax[index]},attrs:{"title":_vm.$t('rsvpDetails.tripInformation.passenger')}},[_c('i',{staticClass:"fas fa-users"}),_vm._v(" "),_c('span',{staticClass:"rule-value"},[_vm._v(_vm._s(service.maxPassengers))])]),_vm._v(" "),_c('div',{class:{'item':true, 'disabled':_vm.maxLuggage[index]},attrs:{"title":_vm.$t('rsvpDetails.tripInformation.luggage')}},[_c('i',{staticClass:"fas fa-briefcase"}),_vm._v(" "),_c('span',{staticClass:"rule-value"},[_vm._v(_vm._s(service.maxLuggage))])])])])])})],2)])]),_vm._v(" "),(_vm.airportPickup && _vm.hasPickupType)?_c('div',{class:{'row':true, 'hideDesktop':_vm.isDesktop, 'showMobile':_vm.isMobile}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCurbside && !_vm.forceMeetandGreet),expression:"showCurbside && !forceMeetandGreet"}],staticClass:"medium-6 small-12 columns end"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"radio label-only"},[_c('span',{staticClass:"pointer pickuptype-label",on:{"click":function($event){_vm.isMeetAndGreet = false}}},[_c('i',{class:{'far fa-circle fa-lg radio-fa':true, 'checked':!_vm.isMeetAndGreet}}),_vm._v("\n                "+_vm._s(_vm.$t('rsvpDetails.edit.curbside'))+"\n              ")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.pickupTypeData.meetAndGreet || _vm.forceMeetandGreet),expression:"pickupTypeData.meetAndGreet || forceMeetandGreet"}],staticClass:"medium-6 small-12 columns end"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"radio label-only"},[_c('span',{staticClass:"pointer pickuptype-label",on:{"click":function($event){_vm.isMeetAndGreet = true}}},[_c('i',{class:{'far fa-circle fa-lg radio-fa':true, 'checked':_vm.isMeetAndGreet}}),_vm._v("\n                "+_vm._s(_vm.$t('rsvpDetails.edit.meetAndGreet'))+"\n                (\n                "),(_vm.priceOverrideEnabled && !!_vm.priceOverride)?_c('b',[_vm._v("$0")]):(_vm.pickupTypeData.pickupFee)?_c('b',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.pickupTypeData.pickupFee)))]):_c('b',[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.complimentary')))]),_vm._v(")\n              ")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"heading margin-xT"},[_vm._v("Customer / Corporate Information")]),_vm._v(" "),(_vm.isNewRsvp)?_c('div',{staticClass:"customer-option"},[_c('a',{staticClass:"button cta xsmall",on:{"click":function($event){return _vm.$store.commit('rsvpDetails/setShowSelectUser', true)}}},[(_vm.customerInfo.firstName)?_c('span',[_vm._v("Change Selected User")]):_c('span',[_vm._v("Select Existing User")])]),_vm._v(" "),_c('span',{staticClass:"or"},[_vm._v("or")]),_vm._v(" "),_c('a',{class:{'button cta warning xsmall':true, 'disabled':_vm.createUser.show && !_vm.customerInfo.firstName},attrs:{"disabled":_vm.createUser.show && !_vm.customerInfo.firstName},on:{"click":_vm.initCreateUser}},[_vm._v("Create New User")]),_vm._v(" "),_c('span',{staticClass:"or"},[_vm._v("or")]),_vm._v(" "),_c('a',{staticClass:"button cta xsmall",on:{"click":function($event){return _vm.$store.commit('rsvpDetails/setShowSelectCorporate', true)}}},[(_vm.customerInfo.firstName)?_c('span',[_vm._v("Change Selected Corporate")]):_c('span',[_vm._v("Select Corporate User")])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"select-card error-msg"},[_vm._v(_vm._s(_vm.validation.userSelected))])])]):_vm._e(),_vm._v(" "),(_vm.customerInfo.firstName)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-8 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.customerInformation.name')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n                "+_vm._s(_vm.customerInfo.firstName + ' ' +_vm.customerInfo.lastName)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.customerInformation.id')))]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.isCorporate)?_c('a',{attrs:{"href":'/#/corporate/' + _vm.customerInfo.id,"target":"_blank"}},[_vm._v(_vm._s(_vm.customerInfo.id))]):_c('a',{attrs:{"href":'/#/consumer/' + _vm.customerInfo.id,"target":"_blank"}},[_vm._v(_vm._s(_vm.customerInfo.id))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-8 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.customerInformation.email')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":'mailto:' + _vm.customerInfo.email}},[_vm._v(_vm._s(_vm.customerInfo.email))])])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.customerInformation.mobile')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{on:{"click":function($event){return _vm.call(_vm.customerInfo)}}},[_vm._v("+"+_vm._s(_vm.customerInfo.countryCode)+" "+_vm._s(_vm.customerInfo.nationalNumber || _vm.customerInfo.mobile))])])])])]),_vm._v(" "),(!_vm.isNewRsvp)?_c('div',{staticClass:"row margin-B-10"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field padding-N-r"},[_c('div',{staticClass:"label"},[_vm._v("PAYING with")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('div',[_c('span',{class:['cc-icon', _vm.cardIcon]}),_vm._v("\n                  "+_vm._s(_vm.creditCard)+"\n                ")])])])])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.createUser.show && !_vm.customerInfo.firstName)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns margin-B"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("First Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.createUser.firstName),expression:"createUser.firstName"}],class:{'input':true, 'has-error':!!_vm.validation.userFirstName},attrs:{"type":"text"},domProps:{"value":(_vm.createUser.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.createUser, "firstName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userFirstName))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns margin-B"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Last Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.createUser.lastName),expression:"createUser.lastName"}],class:{'input':true, 'has-error':!!_vm.validation.userLastName},attrs:{"type":"text"},domProps:{"value":(_vm.createUser.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.createUser, "lastName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userLastName))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Email*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.createUser.email),expression:"createUser.email"}],class:{'input':true, 'has-error':!!_vm.validation.userEmail},attrs:{"type":"text"},domProps:{"value":(_vm.createUser.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.createUser, "email", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userEmail))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Mobile*")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"country-select input-group-label",on:{"click":_vm.selectCountry}},[_c('span',{staticClass:"country-code"},[_vm._v("(+"+_vm._s(_vm.callingCode)+") ")]),_vm._v(" "),_c('i',{staticClass:"fa fa-caret-down"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.createUser.mobile),expression:"createUser.mobile"}],class:['input', {'has-error':!!_vm.validation.userMobile}],attrs:{"type":"text"},domProps:{"value":(_vm.createUser.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.createUser, "mobile", $event.target.value)}}})]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userMobile))])])])]),_vm._v(" "),(_vm.isD2D)?_c('div',{staticClass:"row row-d2d"},[_c('div',{staticClass:"small-6 columns margin-B"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Birthday*")]),_vm._v(" "),_c('datepicker',{class:['datepicker inline', {'has-error':!!_vm.d2dValidation.birthday}],attrs:{"initialView":"year","format":_vm.calendarFormat,"input-class":"input"},model:{value:(_vm.d2dUser.birthday),callback:function ($$v) {_vm.$set(_vm.d2dUser, "birthday", $$v)},expression:"d2dUser.birthday"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.d2dValidation.birthday))])],1)]),_vm._v(" "),_c('div',{staticClass:"small-6 columns margin-B"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Passport (Optional)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.d2dUser.passport),expression:"d2dUser.passport"}],staticClass:"input",attrs:{"type":"text"},domProps:{"value":(_vm.d2dUser.passport)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.d2dUser, "passport", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),(_vm.isD2D)?_c('div',{staticClass:"row row-d2d"},[_c('div',{staticClass:"small-6 columns margin-B"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Address*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.d2dUser.address),expression:"d2dUser.address"}],class:['input', {'has-error':!!_vm.d2dValidation.address}],attrs:{"type":"text"},domProps:{"value":(_vm.d2dUser.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.d2dUser, "address", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.d2dValidation.address))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns margin-B"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("City*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.d2dUser.city),expression:"d2dUser.city"}],class:['input', {'has-error':!!_vm.d2dValidation.city}],attrs:{"type":"text"},domProps:{"value":(_vm.d2dUser.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.d2dUser, "city", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.d2dValidation.city))])])])]):_vm._e(),_vm._v(" "),(_vm.isD2D)?_c('div',{staticClass:"row row-d2d"},[_c('div',{staticClass:"small-6 columns margin-B"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Zip*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.d2dUser.zip),expression:"d2dUser.zip"}],class:['input', {'has-error':!!_vm.d2dValidation.zip}],attrs:{"type":"text"},domProps:{"value":(_vm.d2dUser.zip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.d2dUser, "zip", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.d2dValidation.zip))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns margin-B"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Country*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.d2dUser.country),expression:"d2dUser.country"}],class:['country-selector', {'has-error':_vm.d2dValidation.country}],attrs:{"placeholder":"Country"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.d2dUser, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Select Country")]),_vm._v(" "),_vm._l((_vm.countryList),function(country,i){return _c('option',{key:i,domProps:{"value":country.code.toUpperCase()}},[_vm._v(_vm._s(_vm.cleanCountryName(country.name)))])})],2),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.d2dValidation.country))])])])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{class:{'row guest':true, 'hideDesktop':_vm.isDesktop, 'showMobile':_vm.isMobile}},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{class:{'custom-check':true, 'enabled':_vm.bookingForSomeone},on:{"click":function($event){_vm.bookingForSomeone = !_vm.bookingForSomeone}}},[_vm._m(4)]),_vm._v(" "),_c('span',{staticClass:"label",on:{"click":function($event){_vm.bookingForSomeone = !_vm.bookingForSomeone}}},[_vm._v("\n              "+_vm._s(_vm.$t('rsvpDetails.edit.bookingForSomeone'))+"\n            ")])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.bookingForSomeone),expression:"bookingForSomeone"}]},[_c('div',[_c('div',{staticClass:"small-6 columns margin-T"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.guestFirstName'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editData.guestInfo.firstName),expression:"editData.guestInfo.firstName"}],class:{'input':true, 'has-error':!!_vm.validation.guestFirstName},attrs:{"type":"text"},domProps:{"value":(_vm.editData.guestInfo.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editData.guestInfo, "firstName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.guestFirstName))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns margin-T"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.guestLastName'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editData.guestInfo.lastName),expression:"editData.guestInfo.lastName"}],class:{'input':true, 'has-error':!!_vm.validation.guestLastName},attrs:{"type":"text"},domProps:{"value":(_vm.editData.guestInfo.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editData.guestInfo, "lastName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.guestLastName))])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns margin-T"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.guestMobile')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editData.guestInfo.mobile),expression:"editData.guestInfo.mobile"}],class:{'input':true, 'has-error':!!_vm.validation.guestMobile},attrs:{"type":"text"},domProps:{"value":(_vm.editData.guestInfo.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editData.guestInfo, "mobile", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.guestMobile))])])])])])])],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"heading margin-xT"},[_vm._v("Billing Info")]),_vm._v(" "),(_vm.isNewRsvp)?_c('div',{staticClass:"row margin-B-0 payment-option-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCorporate),expression:"isCorporate"}],staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field margin-B"},[_c('div',{staticClass:"radio with-textbox",on:{"click":function($event){_vm.createUser.paymentMethod = 'directBilling'}}},[_c('i',{class:{'far fa-circle fa-lg radio-fa':true, 'checked':_vm.createUser.paymentMethod === 'directBilling'}}),_vm._v(" "),_c('span',{staticClass:"payment-option"},[_vm._v("Direct Billing")])])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field margin-B"},[_c('div',{staticClass:"radio with-textbox",on:{"click":function($event){_vm.createUser.paymentMethod = 'otherMeans'}}},[_c('i',{class:{'far fa-circle fa-lg radio-fa':true, 'checked':_vm.createUser.paymentMethod === 'otherMeans'}}),_vm._v(" "),_c('span',{staticClass:"payment-option"},[_vm._v("Customer already paid through other means")])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.createUser.paymentMethod === 'otherMeans'),expression:"createUser.paymentMethod === 'otherMeans'"}],staticClass:"cc-form show"},[_c('div',{staticClass:"small-12 columns margin-B"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Notes")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.createUser.notes),expression:"createUser.notes"}],class:{'paid-notes':true, 'has-error':!!_vm.validation.userNotes},domProps:{"value":(_vm.createUser.notes)},on:{"keypress":_vm.charCountChecker,"keyup":_vm.charCountChecker,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.createUser, "notes", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"notes-char-count"},[_vm._v(_vm._s(_vm.noteCounter)+" character(s) left")]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userNotes))])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns margin-B"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.createUser.noteStatus),expression:"createUser.noteStatus"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.createUser, "noteStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{class:{'hideDesktop':_vm.isDesktop, 'showMobile':_vm.isMobile},attrs:{"disabled":""},domProps:{"value":null}}),_vm._v(" "),_c('option',{attrs:{"value":"new"}},[_vm._v(_vm._s(_vm.$t('rsvpNotes.new')))]),_vm._v(" "),_c('option',{attrs:{"value":"investigation"}},[_vm._v(_vm._s(_vm.$t('rsvpNotes.investigation')))]),_vm._v(" "),_c('option',{attrs:{"value":"resolved"}},[_vm._v(_vm._s(_vm.$t('rsvpNotes.resolved')))])]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userNotesStatus))])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field margin-B"},[_c('div',{staticClass:"radio with-textbox",on:{"click":function($event){_vm.createUser.paymentMethod = 'newCard'}}},[_c('i',{class:{'far fa-circle fa-lg radio-fa':true, 'checked':_vm.createUser.paymentMethod === 'newCard'}}),_vm._v(" "),_c('span',{staticClass:"payment-option"},[_vm._v("Charge customer using a new card")])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.createUser.paymentMethod === 'newCard' && !_vm.isD2D),expression:"createUser.paymentMethod === 'newCard' && !isD2D"}],staticClass:"cc-form show"},[_c('div',{staticClass:"small-12 columns margin-B"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Cardholder Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.createUser.cardOwner),expression:"createUser.cardOwner"}],class:{'input':true, 'has-error':!!_vm.validation.userCardOwner},attrs:{"type":"text"},domProps:{"value":(_vm.createUser.cardOwner)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.createUser, "cardOwner", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userCardOwner))])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns margin-B"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Credit Card #")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.createUser.creditCard),expression:"createUser.creditCard"}],class:{'input':true, 'has-error':!!_vm.validation.userCreditCard},attrs:{"type":"text"},domProps:{"value":(_vm.createUser.creditCard)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.createUser, "creditCard", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userCreditCard))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns margin-B"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Expiration (MM/YYYY)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.createUser.cardExp),expression:"createUser.cardExp"}],class:{'input':true, 'has-error':!!_vm.validation.userCardExp},attrs:{"type":"text"},domProps:{"value":(_vm.createUser.cardExp)},on:{"keyup":_vm.formatExpCC,"keypress":_vm.isNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.createUser, "cardExp", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userCardExp))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns margin-B"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("CVV")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.createUser.cvv),expression:"createUser.cvv"}],class:{'input':true, 'has-error':!!_vm.validation.userCvv},attrs:{"type":"text"},domProps:{"value":(_vm.createUser.cvv)},on:{"keypress":_vm.isNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.createUser, "cvv", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userCvv))])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns margin-B"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.createUser.address),expression:"createUser.address"}],class:{'input':true, 'has-error':!!_vm.validation.userAddress},attrs:{"type":"text"},domProps:{"value":(_vm.createUser.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.createUser, "address", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userAddress))])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns margin-B"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.createUser.city),expression:"createUser.city"}],class:{'input':true, 'has-error':!!_vm.validation.userCity},attrs:{"type":"text"},domProps:{"value":(_vm.createUser.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.createUser, "city", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userCity))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns margin-B"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("State")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.createUser.state),expression:"createUser.state"}],class:{'has-error':!!_vm.validation.userState},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.createUser, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{class:{'hideDesktop':_vm.isDesktop, 'showMobile':_vm.isMobile},attrs:{"disabled":""},domProps:{"value":null}}),_vm._v(" "),_c('option',{attrs:{"value":".."}}),_vm._v(" "),_c('option',{attrs:{"value":""}},[_vm._v("Non US")]),_vm._v(" "),_vm._l((_vm.states),function(state){return _c('option',{domProps:{"value":state.value}},[_vm._v(_vm._s(state.label))])})],2),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userState))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns margin-B"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Zip")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.createUser.zip),expression:"createUser.zip"}],class:{'input':true, 'has-error':!!_vm.validation.userZip},attrs:{"type":"text"},domProps:{"value":(_vm.createUser.zip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.createUser, "zip", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userZip))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.createUser.state === ''),expression:"createUser.state === ''"}],staticClass:"small-6 columns margin-B"},[_c('div',{staticClass:"data-field col col50"},[_c('div',{staticClass:"label"},[_vm._v("Country")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.createUser.country),expression:"createUser.country"}],class:{'input':true, 'has-error':!!_vm.validation.userCountry},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.createUser, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{class:{'hideDesktop':_vm.isDesktop, 'showMobile':_vm.isMobile},attrs:{"disabled":""},domProps:{"value":null}}),_vm._v(" "),_vm._l((_vm.countries.all),function(country){return _c('option',[_vm._v(_vm._s(country.name))])})],2),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.userCountry))])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('stripe-form',{directives:[{name:"show",rawName:"v-show",value:(_vm.createUser.paymentMethod === 'newCard' && _vm.isD2D),expression:"createUser.paymentMethod === 'newCard' && isD2D"}],ref:"stripeForm",on:{"cardAdded":_vm.setNewD2DCard}})],1),_vm._v(" "),((!!_vm.customerInfo.firstName || _vm.isCorporate) && _vm.userCardlist.length > 0)?_c('div',[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field margin-B"},[_c('div',{staticClass:"radio with-textbox",on:{"click":function($event){_vm.createUser.paymentMethod = 'oldCard'}}},[_c('i',{class:{'far fa-circle fa-lg radio-fa':true, 'checked':_vm.createUser.paymentMethod === 'oldCard'}}),_vm._v(" "),_c('span',{staticClass:"payment-option"},[_vm._v("Charge customer using his/her credit card")])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.createUser.paymentMethod === 'oldCard'),expression:"createUser.paymentMethod === 'oldCard'"}],staticClass:"row margin-B-10"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field padding-N-r"},[_c('div',{staticClass:"label"},[_vm._v("PAYING with")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.createUser.selectedCard),expression:"createUser.selectedCard"}],class:{'has-error': !!_vm.validation.creditCard},attrs:{"disabled":_vm.userCardLoading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.createUser, "selectedCard", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{class:{'hideDesktop':_vm.isDesktop, 'showMobile':_vm.isMobile},attrs:{"disabled":""},domProps:{"value":null}}),_vm._v(" "),_vm._l((_vm.userCardlist),function(card,index){return _c('option',{domProps:{"value":index}},[_vm._v(_vm._s(card.name))])})],2),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.creditCard))])])])])])])],1):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('div',{class:{'row guest':true, 'showDesktop':_vm.isDesktop, 'hideMobile':_vm.isMobile}},[(!_vm.isCorporate)?_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{class:{'custom-check':true, 'enabled':_vm.bookingForSomeone},on:{"click":function($event){_vm.bookingForSomeone = !_vm.bookingForSomeone}}},[_vm._m(5)]),_vm._v(" "),_c('span',{staticClass:"label",on:{"click":function($event){_vm.bookingForSomeone = !_vm.bookingForSomeone}}},[_vm._v("\n              "+_vm._s(_vm.$t('rsvpDetails.edit.bookingForSomeone'))+"\n            ")])])]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.bookingForSomeone || _vm.isCorporate),expression:"bookingForSomeone || isCorporate"}]},[_c('div',[_c('div',{staticClass:"small-6 columns margin-T"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.guestFirstName'))+" *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editData.guestInfo.firstName),expression:"editData.guestInfo.firstName"}],class:{'input':true, 'has-error':!!_vm.validation.guestFirstName},attrs:{"type":"text"},domProps:{"value":(_vm.editData.guestInfo.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editData.guestInfo, "firstName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.guestFirstName))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns margin-T"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.guestLastName'))+" *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editData.guestInfo.lastName),expression:"editData.guestInfo.lastName"}],class:{'input':true, 'has-error':!!_vm.validation.guestLastName},attrs:{"type":"text"},domProps:{"value":(_vm.editData.guestInfo.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editData.guestInfo, "lastName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.guestLastName))])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns margin-T"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("\n                    "+_vm._s(_vm.$t('rsvpDetails.edit.guestMobile'))+"\n                    "),(_vm.isCorporate)?_c('span',[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editData.guestInfo.mobile),expression:"editData.guestInfo.mobile"}],class:{'input':true, 'has-error':!!_vm.validation.guestMobile},attrs:{"type":"text"},domProps:{"value":(_vm.editData.guestInfo.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editData.guestInfo, "mobile", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.guestMobile))])])])])])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.driverNotes')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.editData.tripInfo.notes),expression:"editData.tripInfo.notes"}],domProps:{"value":(_vm.editData.tripInfo.notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editData.tripInfo, "notes", $event.target.value)}}})])]),_vm._v(" "),(!_vm.isNewRsvp)?_c('div',{staticClass:"small-12 columns send-email"},[_c('div',{staticClass:"data-field"},[_c('div',{class:{'custom-check':true, 'enabled':_vm.sendEmailReminder},on:{"click":function($event){_vm.sendEmailReminder = !_vm.sendEmailReminder}}},[_vm._m(6)]),_vm._v(" "),_c('span',{staticClass:"label",on:{"click":function($event){_vm.sendEmailReminder = !_vm.sendEmailReminder}}},[_vm._v("Send email and sms update")])])]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"medium-5 columns padding-xL customer-info"},[(!_vm.isNewRsvp && _vm.hasWaivePaymentAccess && !_vm.mtech.enabled)?_c('div',{staticClass:"row margin-B"},[_c('div',{staticClass:"medium-12 columns waive-payment"},[_c('div',{class:['custom-check', {'enabled':_vm.waivePayments}],on:{"click":function($event){_vm.waivePayments = !_vm.waivePayments}}},[_vm._m(7)]),_vm._v(" "),_c('label',{attrs:{"for":"waivePayment"},on:{"click":function($event){_vm.waivePayments = !_vm.waivePayments}}},[_vm._v("Waive edit payments")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row margin-B"},[_c('div',{staticClass:"medium-12 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Currency")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currencyCode),expression:"currencyCode"}],attrs:{"disabled":_vm.rsvpId !== 'new'},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currencyCode=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"USD"}},[_vm._v("$ (USD)")]),_vm._v(" "),_c('option',{attrs:{"value":"INR"}},[_vm._v(_vm._s(_vm.currencySymbol.INR)+" (INR)")]),_vm._v(" "),_c('option',{attrs:{"value":"CAD"}},[_vm._v(_vm._s(_vm.currencySymbol.CAD)+" (CAD)")]),_vm._v(" "),_c('option',{attrs:{"value":"EUR"}},[_vm._v(_vm._s(_vm.currencySymbol.EUR)+" (EUR)")]),_vm._v(" "),_c('option',{attrs:{"value":"GBP"}},[_vm._v(_vm._s(_vm.currencySymbol.GBP)+" (GBP)")]),_vm._v(" "),_c('option',{attrs:{"value":"JPY"}},[_vm._v(_vm._s(_vm.currencySymbol.JPY)+" (JPY)")]),_vm._v(" "),_c('option',{attrs:{"value":"CNY"}},[_vm._v(_vm._s(_vm.currencySymbol.CNY)+" (CNY)")]),_vm._v(" "),_c('option',{attrs:{"value":"AUD"}},[_vm._v(_vm._s(_vm.currencySymbol.AUD)+" (AUD)")]),_vm._v(" "),_c('option',{attrs:{"value":"AED"}},[_vm._v(_vm._s(_vm.currencySymbol.AED)+" (AED)")]),_vm._v(" "),_c('option',{attrs:{"value":"MXN"}},[_vm._v(_vm._s(_vm.currencySymbol.MXN)+" (MXN)")]),_vm._v(" "),_c('option',{attrs:{"value":"PHP"}},[_vm._v(_vm._s(_vm.currencySymbol.PHP)+" (PHP)")])])])])]),_vm._v(" "),_c('div',{class:['row margin-B', {'showDesktop':_vm.isDesktop, 'hideMobile':_vm.isMobile}]},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field service-field"},[_c('div',{class:['label', {'has-error':!!_vm.validation.service}]},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.services'))+"*")]),_vm._v(" "),(!_vm.mtech.enabled && _vm.extraStops && _vm.extraStops.length)?_c('div',{staticClass:"extra-stop-notice"},[_vm._v("\n              Shared service is not allowed on booking with Extra stops.\n            ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.service))]),_vm._v(" "),_c('transition',{attrs:{"name":"popin"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.serviceLoading),expression:"serviceLoading"}],staticClass:"service-loader"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-5x"})])]),_vm._v(" "),(_vm.mtech.enabled)?_c('div',_vm._l((_vm.mtech.services),function(service,index){return _c('label',{key:index,class:['radio pricing', {'active':_vm.selectedService === service.code, 'disabled':_vm.passenger > service.maxPaxVal || _vm.luggage > service.maxLuggageVal}],on:{"click":function($event){return _vm.selectMtechService(service)}}},[_c('span',[_c('span',{class:['value', {'has-discount':service.price.hasDiscount, 'price-override':_vm.priceOverrideEnabled && !!_vm.priceOverride}]},[_vm._v("\n                    "+_vm._s(_vm.applyCurrency(_vm.toFixed(service.price.baseFare + service.price.addMarkup - service.price.discountVal)))+"\n                    "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(service.price.hasDiscount),expression:"service.price.hasDiscount"}]},[_c('span',[_vm._v(_vm._s(_vm.applyCurrency(_vm.toFixed(service.price.baseFare + service.price.addMarkup))))])])])]),_vm._v(" "),_c('div',{staticClass:"service-desc"},[_c('span',{staticClass:"service-label"},[_vm._v(_vm._s(service.desc))]),_vm._v(" "),_c('div',{staticClass:"pax-luggage"},[_c('div',{class:{'item':true, 'disabled':_vm.passenger > service.maxPaxVal},attrs:{"title":_vm.$t('rsvpDetails.tripInformation.passenger')}},[_c('i',{staticClass:"fas fa-users"}),_vm._v(" "),_c('span',{staticClass:"rule-value"},[_vm._v(_vm._s(service.maxPaxVal))])]),_vm._v(" "),_c('div',{class:{'item':true, 'disabled':_vm.luggage > service.maxLuggageVal},attrs:{"title":_vm.$t('rsvpDetails.tripInformation.luggage')}},[_c('i',{staticClass:"fas fa-briefcase"}),_vm._v(" "),_c('span',{staticClass:"rule-value"},[_vm._v(_vm._s(service.maxLuggageVal))])])])])])}),0):_c('div',_vm._l((_vm.servicePrices),function(service,index){return _c('label',{class:{'radio pricing':true, 'active':_vm.selectedService === _vm.serviceDetails(index).code, 'disabled':_vm.serviceDisable(index, service) || service.status !== 'allowed' || service.unavailableService},on:{"click":function($event){_vm.selectService(_vm.serviceDetails(index).code, service)}}},[(service.unavailableService)?_c('span',{staticClass:"unavailable"},[_vm._m(8,true)]):(!_vm.serviceAvailability(service).enabled || !(_vm.serviceAvailability(service).enabled && !_vm.serviceAvailability(service).eligible))?_c('span',[_c('span',{class:{'value':true, 'has-discount':_vm.price(service).hasDiscount, 'price-override':_vm.priceOverrideEnabled && !!_vm.priceOverride}},[(_vm.priceOverrideEnabled)?_c('span',[_vm._v(_vm._s(("" + (_vm.currencyCode !== 'USD' ? _vm.price(service).value : _vm.price(service).original))))]):_c('span',[_vm._v(_vm._s(_vm.price(service).value))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.price(service).hasDiscount),expression:"price(service).hasDiscount"}]},[_c('span',[_vm._v(_vm._s(_vm.price(service).original))])])])]):_c('span',{staticClass:"unavailable"},[_c('span',{staticClass:"availability"},[(_vm.serviceAvailability(service).unavailable)?_c('span',{staticClass:"available"},[_vm._v("\n                      Not Available\n                    ")]):_c('span',{staticClass:"available"},[(_vm.serviceAvailability(service).after)?_c('span',[_c('span',{staticClass:"available"},[_vm._v("Available from")]),_vm._v(" "),_c('span',{staticClass:"date-time"},[_vm._v(_vm._s(_vm.serviceAvailability(service).after))])]):_c('span',[_c('span',{staticClass:"available"},[_vm._v("Available until")]),_vm._v(" "),_c('span',{staticClass:"date-time"},[_vm._v(_vm._s(_vm.serviceAvailability(service).before))])])])])]),_vm._v(" "),_c('div',{staticClass:"service-desc"},[_c('span',{staticClass:"service-label"},[_vm._v(_vm._s(_vm.serviceDetails(index).label))]),_vm._v(" "),_c('div',{staticClass:"pax-luggage"},[_c('div',{class:{'item':true, 'disabled':_vm.maxPax[index]},attrs:{"title":_vm.$t('rsvpDetails.tripInformation.passenger')}},[_c('i',{staticClass:"fas fa-users"}),_vm._v(" "),_c('span',{staticClass:"rule-value"},[_vm._v(_vm._s(service.maxPassengers))])]),_vm._v(" "),_c('div',{class:{'item':true, 'disabled':_vm.maxLuggage[index]},attrs:{"title":_vm.$t('rsvpDetails.tripInformation.luggage')}},[_c('i',{staticClass:"fas fa-briefcase"}),_vm._v(" "),_c('span',{staticClass:"rule-value"},[_vm._v(_vm._s(service.maxLuggage))])])])])])}),0)],1)])]),_vm._v(" "),(_vm.airportPickup && _vm.hasPickupType)?_c('div',{class:['row', {'showDesktop':_vm.isDesktop, 'hideMobile':_vm.isMobile}]},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCurbside && !_vm.forceMeetandGreet),expression:"showCurbside && !forceMeetandGreet"}],staticClass:"medium-6 small-12 columns end"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"radio label-only"},[_c('span',{staticClass:"pointer pickuptype-label",on:{"click":function($event){_vm.isMeetAndGreet = false}}},[_c('i',{class:{'far fa-circle fa-lg radio-fa':true, 'checked':!_vm.isMeetAndGreet}}),_vm._v("\n                "+_vm._s(_vm.$t('rsvpDetails.edit.curbside'))+"\n              ")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.pickupTypeData.meetAndGreet || _vm.forceMeetandGreet),expression:"pickupTypeData.meetAndGreet || forceMeetandGreet"}],staticClass:"medium-6 small-12 columns end"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"radio label-only"},[_c('span',{staticClass:"pointer pickuptype-label",on:{"click":function($event){_vm.isMeetAndGreet = true}}},[_c('i',{class:{'far fa-circle fa-lg radio-fa':true, 'checked':_vm.isMeetAndGreet}}),_vm._v("\n                "+_vm._s(_vm.$t('rsvpDetails.edit.meetAndGreet'))+"\n                (\n                "),(_vm.priceOverrideEnabled && !!_vm.priceOverride)?_c('b',[_vm._v(_vm._s(_vm.applyCurrency(0)))]):(_vm.pickupTypeData.pickupFee)?_c('b',[_vm._v(_vm._s(_vm.applyCurrency(_vm.toFixed(_vm.pickupTypeData.pickupFee))))]):_c('b',[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.complimentary')))]),_vm._v(")\n              ")])])])])]):_vm._e(),_vm._v(" "),(!_vm.mtech.enabled && _vm._edit.selectedService && Object.keys(_vm._edit.services).length && _vm._edit.services[_vm._edit.selectedService] && _vm._edit.services[_vm._edit.selectedService].optinAllow && _vm.optinSharedAllowedTime() && !_vm.pickupAsap && !_vm.extraStops.length && _vm.bookingType === 'mileage')?_c('div',{staticClass:"row optin-box"},[_c('label',{staticClass:"optin-toggle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.optinEnabled),expression:"optinEnabled"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.optinEnabled)?_vm._i(_vm.optinEnabled,null)>-1:(_vm.optinEnabled)},on:{"change":function($event){var $$a=_vm.optinEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.optinEnabled=$$a.concat([$$v]))}else{$$i>-1&&(_vm.optinEnabled=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.optinEnabled=$$c}}}}),_vm._v("\n          I want to share my ride with someone else\n        ")]),_vm._v(" "),_c('div',{class:['optin-desc', {active: _vm.optinEnabled}]},[_c('div',{staticClass:"availability"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.editData.tripInfo.isAirportPickup),expression:"editData.tripInfo.isAirportPickup"}]},[_c('i',[_vm._v("\n                Available only from\n                "),_c('b',[_vm._v(_vm._s(_vm.settings.optinAllowedTime.start)+" - "+_vm._s(_vm.settings.optinAllowedTime.end))])])])]),_vm._v(" "),_c('div',{staticClass:"opt-copy"},[_c('div',{staticClass:"head"},[_vm._v("Save "+_vm._s(_vm._edit.services[_vm._edit.selectedService].optinPercent)+"% by sharing this ride.")]),_vm._v("\n            If we find atleast 1 other person to share this ride with, we will refund you "),_c('b',[_vm._v(_vm._s(_vm.applyCurrency(_vm.optinRefundPrice().toFixed(2))))]),_vm._v(" \n            at the time your trip is completed.\n          ")]),_vm._v(" "),(false)?_c('div',{staticClass:"flex"},[_c('div',{staticClass:"info"},[_c('div',{staticClass:"service-name"},[_vm._v(_vm._s(_vm._edit.services[_vm._edit.selectedService].name))]),_vm._v(" "),_c('div',{staticClass:"capacity"},[_c('i',{staticClass:"fas fa-users"}),_vm._v("\n                "+_vm._s(_vm._edit.services[_vm._edit.selectedService].maxPassengers)+"\n                "),_c('i',{staticClass:"fas fa-briefcase"}),_vm._v("\n                "+_vm._s(_vm._edit.services[_vm._edit.selectedService].maxLuggage)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"price"},[_c('span',[_vm._v(_vm._s(_vm.applyCurrency(_vm.optinSharedPrice().toFixed(2))))])])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.tip')))]),_vm._v(" "),_c('div',{staticClass:"currency"},[(_vm.currencyCode !== 'USD')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipIntnl),expression:"tipIntnl"}],ref:"tip",class:['input', {'has-error':!!_vm.validation.tip}],attrs:{"type":"text","disabled":!_vm.isNewRsvp || (_vm.isNewRsvp && _vm.driverOverrideEnabled)},domProps:{"value":(_vm.tipIntnl)},on:{"keypress":_vm.isNumber,"keyup":_vm.forceManualTip,"input":function($event){if($event.target.composing){ return; }_vm.tipIntnl=$event.target.value}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tripInfo.tip),expression:"tripInfo.tip"}],ref:"tip",class:{'input':true, 'has-error':!!_vm.validation.tip},attrs:{"type":"text","disabled":!_vm.isNewRsvp || (_vm.isNewRsvp && _vm.driverOverrideEnabled)},domProps:{"value":(_vm.tripInfo.tip)},on:{"keypress":_vm.isNumber,"keyup":_vm.forceManualTip,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tripInfo, "tip", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.currency.symbol))])]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.tip))])])])]),_vm._v(" "),(!_vm.mtech.enabled)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"data-field"},[_c('div',{class:{'custom-check':true, 'enabled':_vm.priceOverrideEnabled && _vm.priceOverrideAccess},on:{"click":_vm.priceOverrideToggle}},[_vm._m(9)]),_vm._v(" "),_c('span',{staticClass:"label",on:{"click":_vm.priceOverrideToggle}},[_vm._v("\n              "+_vm._s(_vm.$t('rsvpDetails.edit.priceOverride.label'))+"\n              "),(!_vm.priceOverrideAccess)?_c('small',[_vm._v("(Disabled)")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"currency"},[(_vm.currencyCode === 'USD')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.priceOverride),expression:"priceOverride"}],ref:"priceOverride",class:{'input':true, 'has-error':!!_vm.validation.priceOverride},attrs:{"type":"text","disabled":!_vm.priceOverrideEnabled || !_vm.priceOverrideAccess},domProps:{"value":(_vm.priceOverride)},on:{"input":function($event){if($event.target.composing){ return; }_vm.priceOverride=$event.target.value}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.priceOverrideIntnl),expression:"priceOverrideIntnl"}],ref:"priceOverride",class:['input', {'has-error':!!_vm.validation.priceOverride}],attrs:{"type":"text","disabled":!_vm.priceOverrideEnabled || !_vm.priceOverrideAccess},domProps:{"value":(_vm.priceOverrideIntnl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.priceOverrideIntnl=$event.target.value}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.currency.symbol))])]),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.priceOverride))]),_vm._v(" "),_c('span',{staticClass:"description"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.priceOverride.desc')))])])])]):_vm._e(),_vm._v(" "),(!_vm.isNewRsvp)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"data-field"},[_c('div',{class:{'custom-check':true, 'enabled':_vm.paymentBonusEnabled && _vm.overrideAccess},on:{"click":_vm.paymentBonusToggle}},[_vm._m(10)]),_vm._v(" "),_c('span',{staticClass:"label",on:{"click":_vm.paymentBonusToggle}},[_vm._v("Driver Payment Bonus\n                "),(!_vm.overrideAccess)?_c('small',[_vm._v("(Disabled)")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"currency"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paymentBonus),expression:"paymentBonus"}],ref:"paymentBonus",class:{'input':true, 'has-error':!!_vm.validation.paymentBonus},attrs:{"type":"text","disabled":!_vm.paymentBonusEnabled || !_vm.overrideAccess},domProps:{"value":(_vm.paymentBonus)},on:{"input":function($event){if($event.target.composing){ return; }_vm.paymentBonus=$event.target.value}}}),_vm._v(" "),_c('span',[_vm._v("$")])]),_vm._v(" "),(!!_vm.validation.paymentBonus)?_c('span',{staticClass:"error-msg",staticStyle:{"margin-bottom":"5px"}},[_vm._v(_vm._s(_vm.validation.paymentBonus))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"description"},[_vm._v("Driver payment bonus is only up to "+_vm._s(_vm.paymentBonusComputation.bonusLimitPercent)+"% of fare ($"+_vm._s(_vm.toFixed(_vm.paymentBonusComputation.limitAmount))+")")])])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[(_vm.overrideAccess && _vm.paymentBonusEnabled)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"data-field"},[_c('span',{staticClass:"label"},[_vm._v("\n                  Original\n                ")]),_vm._v(" "),_c('div',{staticClass:"currency"},[_c('span',{staticClass:"amount"},[_vm._v("$"+_vm._s(_vm.paymentBonusComputation.original))])])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"data-field"},[_c('span',{staticClass:"label"},[_vm._v("\n                    Total\n                  ")]),_vm._v(" "),_c('div',{staticClass:"currency"},[_c('span',{staticClass:"amount"},[_vm._v("$"+_vm._s(_vm.paymentBonusComputation.updated))])])])])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.mtech.enabled)?_c('div',{staticClass:"payment-summary"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.paymentSummary')))])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"stats"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.fare')))]),_vm._v(" "),_c('span',{class:{'value':true, 'price-override':_vm.priceOverrideEnabled && !!_vm.priceOverride}},[_vm._v("\n                "+_vm._s(_vm.applyCurrency(_vm.toFixed(_vm.paymentSummaryMtech.fare)))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"stats"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.tip')))]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.applyCurrency(_vm.toFixed(_vm.paymentSummaryMtech.tip))))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.paymentSummaryMtech.tax),expression:"!!paymentSummaryMtech.tax"}],staticClass:"small-12 columns"},[_c('div',{staticClass:"stats"},[_c('span',{staticClass:"label"},[_vm._v("Tax & Fees")]),_vm._v(" "),_c('span',{class:['value', {'price-override':_vm.priceOverrideEnabled && !!_vm.priceOverride}]},[_vm._v("\n                "+_vm._s(_vm.applyCurrency(_vm.toFixed(_vm.paymentSummaryMtech.tax)))+"\n              ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.paymentSummaryMtech.gratuity),expression:"!!paymentSummaryMtech.gratuity"}],staticClass:"small-12 columns"},[_c('div',{staticClass:"stats"},[_c('span',{staticClass:"label"},[_vm._v("Service Gratuity")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.applyCurrency(_vm.toFixed(Math.abs(_vm.paymentSummaryMtech.gratuity)))))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.paymentSummaryMtech.discount),expression:"!!paymentSummaryMtech.discount"}],staticClass:"small-12 columns"},[_c('div',{staticClass:"stats"},[_c('span',{staticClass:"label"},[_vm._v("Discount")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("-"+_vm._s(_vm.applyCurrency(_vm.toFixed(Math.abs(_vm.paymentSummaryMtech.discount)))))])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"stats hard-border"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.creditsUsed')))]),_vm._v(" "),_c('span',{staticClass:"value"},[(_vm.paymentSummaryMtech.credits !== 0)?_c('span',[_vm._v("-")]):_vm._e(),_vm._v("\n                "+_vm._s(_vm.applyCurrency(_vm.toFixed(_vm.paymentSummaryMtech.credits)))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"stats"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.total')))]),_vm._v(" "),_c('span',{staticClass:"value total"},[_vm._v(_vm._s(_vm.applyCurrency(_vm.toFixed(_vm.paymentSummaryMtech.total))))])])])])]):_c('div',{staticClass:"payment-summary"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.paymentSummary')))])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"stats"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.fare')))]),_vm._v(" "),_c('span',{class:['value', {'price-override':_vm.priceOverrideEnabled && !!_vm.priceOverride}]},[(_vm.priceOverrideEnabled && !!_vm.priceOverride && _vm.currencyCode !== 'USD' && !_vm.waivePayments)?_c('span',[_vm._v("\n                  "+_vm._s(_vm.xcurrency.format({ code: _vm.currency.code, val: _vm.toFixed(_vm.priceOverrideIntnl || 0) }))+"\n                ")]):_c('span',[_vm._v(_vm._s(_vm.applyCurrency(_vm.toFixed(_vm.paymentSummaryData.fare))))])])])]),_vm._v(" "),(_vm.paymentSummaryData.portalFee)?_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"stats"},[_c('span',{staticClass:"label"},[_vm._v("Convenience Fee")]),_vm._v(" "),_c('span',{class:['value', {'price-override':_vm.priceOverrideEnabled && !!_vm.priceOverride}]},[(_vm.priceOverrideEnabled && !!_vm.priceOverride && _vm.currencyCode !== 'USD' && !_vm.waivePayments)?_c('span',[_vm._v("\n                  "+_vm._s(_vm.xcurrency.format({ code: _vm.currency.code, val: _vm.toFixed(0) }))+"\n                ")]):_c('span',[_vm._v(_vm._s(_vm.applyCurrency(_vm.toFixed(_vm.paymentSummaryData.portalFee))))])])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.paymentSummaryData.travelInsurance !== null && _vm.paymentSummaryData.travelInsurance > 0),expression:"paymentSummaryData.travelInsurance !== null && paymentSummaryData.travelInsurance > 0"}],staticClass:"small-12 columns"},[_c('div',{staticClass:"stats"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.travelInsuranceLabel))]),_vm._v(" "),_c('span',{class:{'value':true, 'price-override':_vm.priceOverrideEnabled && !!_vm.priceOverride}},[_vm._v("\n                "+_vm._s(_vm.applyCurrency(_vm.toFixed(_vm.paymentSummaryData.travelInsurance)))+"\n              ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMeetAndGreet && _vm.airportPickup),expression:"isMeetAndGreet && airportPickup"}],staticClass:"small-12 columns"},[_c('div',{staticClass:"stats"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.meetAndGreet')))]),_vm._v(" "),(_vm.paymentSummaryData.meetAndGreet !== _vm.$t('rsvpDetails.edit.complimentary'))?_c('span',{class:{'value':true, 'price-override':_vm.priceOverrideEnabled && !!_vm.priceOverride}},[_vm._v("\n                "+_vm._s(_vm.applyCurrency(_vm.toFixed(_vm.paymentSummaryData.meetAndGreet)))+"\n              ")]):_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.paymentSummaryData.meetAndGreet))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.paymentSummaryData.airportFee !== null && _vm.paymentSummaryData.airportFee > 0),expression:"paymentSummaryData.airportFee !== null && paymentSummaryData.airportFee > 0"}],staticClass:"small-12 columns"},[_c('div',{staticClass:"stats"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.airportFee')))]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.applyCurrency(_vm.toFixed(_vm.paymentSummaryData.airportFee))))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.paymentSummaryData.gasFee !== null && _vm.paymentSummaryData.gasFee > 0),expression:"paymentSummaryData.gasFee !== null && paymentSummaryData.gasFee > 0"}],staticClass:"small-12 columns"},[_c('div',{staticClass:"stats"},[_c('span',{staticClass:"label"},[_vm._v("Fuel Surcharge")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.applyCurrency(_vm.toFixed(_vm.paymentSummaryData.gasFee))))])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"stats"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.tip')))]),_vm._v(" "),(_vm.currencyCode === 'USD')?_c('span',{staticClass:"value"},[_vm._v("\n                "+_vm._s(_vm.applyCurrency(_vm.toFixed(_vm.paymentSummaryData.tip)))+"\n              ")]):_c('span',{staticClass:"value"},[_vm._v("\n                "+_vm._s(_vm.xcurrency.format({ code: _vm.currency.code, val: _vm.toFixed(_vm.tipIntnl || 0) }))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"stats hard-border"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.creditsUsed')))]),_vm._v(" "),_c('span',{staticClass:"value"},[(_vm.paymentSummaryData.credits !== 0)?_c('span',[_vm._v("-")]):_vm._e(),_vm._v("\n                "+_vm._s(_vm.applyCurrency(_vm.toFixed(_vm.paymentSummaryData.credits)))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"stats"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.edit.total')))]),_vm._v(" "),(_vm.currencyCode === 'USD')?_c('span',{staticClass:"value total"},[_vm._v(_vm._s(_vm.applyCurrency(_vm.toFixed(_vm.paymentSummaryData.total))))]):_c('span',{staticClass:"value total"},[_vm._v("\n                "+_vm._s(_vm.xcurrency.format({ code: _vm.currency.code, val: _vm.toFixed(_vm.paymentSummaryData.totalIntnl) }))+"\n                ")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fa fa-check"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fa fa-check"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fa fa-check"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fa fa-check"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fa fa-check"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fa fa-check"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fa fa-check"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fa fa-check"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"availability"},[_c('span',{staticClass:"available"},[_vm._v("Not Available")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fa fa-check"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fa fa-check"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasicInformation_vue__ = __webpack_require__(609);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_264a8858_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasicInformation_vue__ = __webpack_require__(1800);
function injectStyle (ssrContext) {
  __webpack_require__(1796)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-264a8858"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasicInformation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_264a8858_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasicInformation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1797);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("3bc20940", content, true, {});

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.collapsible[data-v-264a8858] {\n  margin-bottom: 5px;\n}\n.collapsible .heading[data-v-264a8858] {\n    color: #0D79F2;\n    margin-bottom: 2px;\n    cursor: pointer;\n    text-transform: uppercase;\n}\n.collapsible .heading i[data-v-264a8858] {\n      margin-right: 5px;\n}\n.collapsible .heading span[data-v-264a8858] {\n      font-weight: 600;\n}\n.collapsible .content[data-v-264a8858] {\n    margin-left: 6px;\n    padding: 5px 0 5px 15px;\n    border-left: 2px solid #ddd;\n    max-height: 700px;\n    /* define precise max-height for more smoother transition */\n    height: auto;\n    overflow: visible;\n    -webkit-transition: all 0.35s ease-out;\n    transition: all 0.35s ease-out;\n}\n.collapsible .content .field-row[data-v-264a8858] {\n      margin-bottom: 15px;\n}\n.collapsible .content .field-row[data-v-264a8858]:last-child {\n      margin-bottom: 0;\n}\n.collapsible.collapse .content[data-v-264a8858] {\n    max-height: 0;\n    padding: 0 15px;\n    overflow: hidden;\n}\n.field-row[data-v-264a8858] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.field-row .col[data-v-264a8858] {\n    display: inline-block;\n}\n.field-row .col1[data-v-264a8858] {\n    width: 20%;\n}\n.field-row .col2[data-v-264a8858] {\n    width: 40%;\n}\n.field-row .col3[data-v-264a8858] {\n    width: 60%;\n}\n.field-row .col4[data-v-264a8858] {\n    width: 80%;\n}\n.field-row .col5[data-v-264a8858] {\n    width: 100%;\n}\n.booked-label[data-v-264a8858] {\n  color: #fff;\n  background: #ccc;\n  font-size: 12px;\n  padding: 3px 5px;\n  border-radius: 3px;\n  line-height: 1;\n  display: inline-block;\n  margin-top: 2px;\n}\n.booked-label.Web[data-v-264a8858] {\n    background: #a26d5d;\n}\n.booked-label.Android[data-v-264a8858] {\n    background: #78c259;\n}\n.booked-label.iOS[data-v-264a8858] {\n    background: #7fc8de;\n}\n.booked-label.Admin[data-v-264a8858] {\n    background: #2b83f1;\n}\n.booked-label.CSR[data-v-264a8858] {\n    background: #bb4a91;\n}\n.booked-label.Provider[data-v-264a8858] {\n    background: #3f3f3f;\n}\n.service-label[data-v-264a8858] {\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 12px;\n  display: inline-block;\n  margin-top: 2px;\n}\n.service-label.shared[data-v-264a8858] {\n    background: #f38d56;\n}\n.service-label.opoli[data-v-264a8858] {\n    background: #26D97A;\n}\n.service-label.black[data-v-264a8858] {\n    background: #777;\n}\n.service-label.SUV[data-v-264a8858], .service-label.suv[data-v-264a8858] {\n    background: #dc3168;\n}\n.service-label.shuttle[data-v-264a8858] {\n    background: #6dabc3;\n}\n.service-label.shared-optin[data-v-264a8858] {\n    background: #dd9a54;\n    border: 2px solid #a55b2e;\n}\n.service-label.mtech-service[data-v-264a8858] {\n    background: #18ab4c;\n    border: 1px solid #398316;\n}\n.data-field[data-v-264a8858] {\n  font-weight: 600;\n}\n.data-field .label[data-v-264a8858] {\n    color: #888;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 120%;\n}\n.data-field .value[data-v-264a8858] {\n    font-size: 17px;\n    color: #555;\n}\n.data-field .value.driver-name[data-v-264a8858] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.data-field .value.service-type[data-v-264a8858] {\n      text-transform: capitalize;\n}\n.data-field .value.credit-card[data-v-264a8858] {\n      font-size: 16px;\n}\n.data-field .value .fa-star[data-v-264a8858] {\n      color: #f1d724;\n      margin-right: 5px;\n}\n.data-field .value .payment-trigger[data-v-264a8858] {\n      font-size: 11px;\n      vertical-align: 3px;\n      text-decoration: underline;\n      margin-left: 2px;\n      cursor: pointer;\n}\n.data-field .value a[data-v-264a8858] {\n      text-decoration: underline;\n      cursor: pointer;\n}\n.data-field .value .cross[data-v-264a8858] {\n      text-decoration: line-through;\n}\n.data-field .value .grayed[data-v-264a8858] {\n      color: #888;\n}\n.trip-reminder-btn[data-v-264a8858], .no-show-btn[data-v-264a8858] {\n  margin-left: 10px;\n}\n.empty-state[data-v-264a8858] {\n  font-weight: 600;\n  color: #555;\n  font-size: 18px;\n}\n.empty-state p[data-v-264a8858] {\n    margin: 0 0 5px;\n}\n.empty-state button[data-v-264a8858] {\n    cursor: pointer;\n}\n.breakdown-modal[data-v-264a8858] {\n  position: fixed;\n  z-index: 12;\n  background: #f00;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.flightLabel .fa-circle-notch[data-v-264a8858] {\n  color: #0D79F2;\n}\n.flightLabel label[data-v-264a8858] {\n  cursor: pointer;\n  font-size: 11px;\n  vertical-align: middle;\n  color: #fff;\n  background: #ccc;\n  padding: 2px 6px;\n  margin-left: 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 100;\n}\n.flightLabel label.Scheduled[data-v-264a8858] {\n    background: #b97a2b;\n}\n.flightLabel label.Active[data-v-264a8858] {\n    background: #43b3e8;\n}\n.flightLabel label.Unknown[data-v-264a8858] {\n    background: #333;\n}\n.flightLabel label.Redirected[data-v-264a8858] {\n    background: #dc4c4c;\n}\n.flightLabel label.Landed[data-v-264a8858] {\n    background: #2bb971;\n}\n.flightLabel label.Diverted[data-v-264a8858] {\n    background: #b92b87;\n}\n.flightLabel label.Cancelled[data-v-264a8858] {\n    background: #8a8a8a;\n}\n.flightLabel label.arrived[data-v-264a8858] {\n    background: #26D97A;\n}\n.flightLabel label.Not.Operational[data-v-264a8858] {\n    background: #ef4958;\n}\n.truncate[data-v-264a8858] {\n  margin: 0;\n}\n@media only screen and (max-width: 430px) {\n.data-field .label[data-v-264a8858] {\n    font-size: 10px;\n    white-space: nowrap;\n}\n.data-field .value[data-v-264a8858] {\n    font-size: 15px;\n}\n.data-field .value .payment-trigger[data-v-264a8858] {\n      display: block;\n}\n.empty-state[data-v-264a8858] {\n    color: #999;\n    font-size: 15px;\n}\n.field-row .col1[data-v-264a8858] {\n    width: 23%;\n}\n.field-row .col3[data-v-264a8858] {\n    width: 50%;\n}\n.flightLabel label[data-v-264a8858] {\n    display: inline-block;\n    margin-left: 0;\n}\n.truncate[data-v-264a8858] {\n    margin: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.button.small[data-v-264a8858] {\n    font-size: 11px;\n    padding: 7px;\n}\n}\n.prov-options[data-v-264a8858] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-left: 5px;\n  cursor: pointer;\n  color: #0D79F2;\n  -webkit-transition: all .4s ease;\n  transition: all .4s ease;\n  position: relative;\n  z-index: 5;\n}\n.prov-options .fa-ellipsis-v[data-v-264a8858] {\n    font-size: 18px;\n}\n.prov-options[data-v-264a8858]:hover {\n    color: #333;\n}\n.prov-options .options[data-v-264a8858] {\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n    position: absolute;\n    top: 120%;\n    width: 200px;\n    background: #fff;\n    padding: 10px;\n    border-radius: 4px;\n    -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);\n            box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);\n}\n.prov-options .options .button[data-v-264a8858] {\n      margin-bottom: 3px;\n}\n.prov-options .options .button i[data-v-264a8858] {\n        margin-right: 5px;\n}\n.optin-icon[data-v-264a8858] {\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n.optin-icon img[data-v-264a8858] {\n    width: 18px;\n    vertical-align: -3px;\n    margin-right: 5px;\n}\n.optin-fare[data-v-264a8858] {\n  display: inline-block;\n}\n.switch[data-v-264a8858] {\n  position: relative;\n  display: inline-block;\n  height: 23px;\n}\n.switch .slider[data-v-264a8858] {\n    position: relative;\n    display: inline-block;\n    width: 50px;\n    height: 23px;\n    border-radius: 20px;\n    background: #ccc;\n    position: relative;\n    cursor: pointer;\n    -webkit-transition: all .25s ease-in-out;\n    transition: all .25s ease-in-out;\n}\n.switch .slider[data-v-264a8858]:before {\n      content: '';\n      position: absolute;\n      top: 4px;\n      left: 4px;\n      width: 15px;\n      height: 15px;\n      border-radius: 50%;\n      background: #fff;\n      -webkit-transition: all .25s ease-in-out;\n      transition: all .25s ease-in-out;\n      -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n}\n.switch .slider.active[data-v-264a8858] {\n      background: #57d1b7;\n}\n.switch .slider.active[data-v-264a8858]:before {\n        left: 30px;\n}\n.switch .label[data-v-264a8858] {\n    display: inline-block;\n    vertical-align: 10px;\n    margin-left: 5px;\n    font-size: 14px;\n    color: #555;\n    text-transform: uppercase;\n}\n.local-currency-box[data-v-264a8858] {\n  margin-bottom: 10px;\n  background: #fff792;\n  border: 1px solid #cdc23d;\n  padding: 5px;\n  border-radius: 5px;\n}\n.local-currency-box label[data-v-264a8858] {\n    font-size: 13px;\n    color: #565656;\n    margin-left: 5px;\n    font-family: 'Space Grotesk';\n    font-weight: 600;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/RsvpDetails/BasicInformation.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;MACM,iBAAiB;CACtB;AACD;IACI,iBAAiB;IACjB,wBAAwB;IACxB,4BAA4B;IAC5B,kBAAkB;IAClB,4DAA4D;IAC5D,aAAa;IACb,kBAAkB;IAClB,uCAAuC;IACvC,+BAA+B;CAClC;AACD;MACM,oBAAoB;CACzB;AACD;MACM,iBAAiB;CACtB;AACD;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;CACpB;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;IACI,sBAAsB;CACzB;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,YAAY;CACf;AACD;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;CACjB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;CACjB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;IACpB,0BAA0B;CAC7B;AACD;IACI,oBAAoB;IACpB,0BAA0B;CAC7B;AACD;EACE,iBAAiB;CAClB;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;CACrB;AACD;IACI,gBAAgB;IAChB,YAAY;CACf;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;CACnB;AACD;MACM,2BAA2B;CAChC;AACD;MACM,gBAAgB;CACrB;AACD;MACM,eAAe;MACf,kBAAkB;CACvB;AACD;MACM,gBAAgB;MAChB,oBAAoB;MACpB,2BAA2B;MAC3B,iBAAiB;MACjB,gBAAgB;CACrB;AACD;MACM,2BAA2B;MAC3B,gBAAgB;CACrB;AACD;MACM,8BAA8B;CACnC;AACD;MACM,YAAY;CACjB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;CACjB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,gBAAgB;CACnB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,OAAO;EACP,QAAQ;CACT;AACD;EACE,eAAe;CAChB;AACD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;CAClB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,UAAU;CACX;AACD;AACA;IACI,gBAAgB;IAChB,oBAAoB;CACvB;AACD;IACI,gBAAgB;CACnB;AACD;MACM,eAAe;CACpB;AACD;IACI,YAAY;IACZ,gBAAgB;CACnB;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,sBAAsB;IACtB,eAAe;CAClB;AACD;IACI,UAAU;IACV,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;CAC3B;AACD;IACI,gBAAgB;IAChB,aAAa;CAChB;CACA;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;CACZ;AACD;IACI,gBAAgB;CACnB;AACD;IACI,YAAY;CACf;AACD;IACI,qCAAqC;YAC7B,6BAA6B;IACrC,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;MACM,mBAAmB;CACxB;AACD;QACQ,kBAAkB;CACzB;AACD;EACE,gBAAgB;EAChB,oBAAoB;CACrB;AACD;IACI,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;CACrB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;CACd;AACD;IACI,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,iCAAiC;CACpC;AACD;MACM,YAAY;MACZ,mBAAmB;MACnB,SAAS;MACT,UAAU;MACV,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,iBAAiB;MACjB,yCAAyC;MACzC,iCAAiC;MACjC,oDAAoD;cAC5C,4CAA4C;CACzD;AACD;MACM,oBAAoB;CACzB;AACD;QACQ,WAAW;CAClB;AACD;IACI,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;CAC7B;AACD;EACE,oBAAoB;EACpB,oBAAoB;EACpB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;CACpB;AACD;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,iBAAiB;CACpB","file":"BasicInformation.vue","sourcesContent":["\n.collapsible[data-v-264a8858] {\n  margin-bottom: 5px;\n}\n.collapsible .heading[data-v-264a8858] {\n    color: #0D79F2;\n    margin-bottom: 2px;\n    cursor: pointer;\n    text-transform: uppercase;\n}\n.collapsible .heading i[data-v-264a8858] {\n      margin-right: 5px;\n}\n.collapsible .heading span[data-v-264a8858] {\n      font-weight: 600;\n}\n.collapsible .content[data-v-264a8858] {\n    margin-left: 6px;\n    padding: 5px 0 5px 15px;\n    border-left: 2px solid #ddd;\n    max-height: 700px;\n    /* define precise max-height for more smoother transition */\n    height: auto;\n    overflow: visible;\n    -webkit-transition: all 0.35s ease-out;\n    transition: all 0.35s ease-out;\n}\n.collapsible .content .field-row[data-v-264a8858] {\n      margin-bottom: 15px;\n}\n.collapsible .content .field-row[data-v-264a8858]:last-child {\n      margin-bottom: 0;\n}\n.collapsible.collapse .content[data-v-264a8858] {\n    max-height: 0;\n    padding: 0 15px;\n    overflow: hidden;\n}\n.field-row[data-v-264a8858] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.field-row .col[data-v-264a8858] {\n    display: inline-block;\n}\n.field-row .col1[data-v-264a8858] {\n    width: 20%;\n}\n.field-row .col2[data-v-264a8858] {\n    width: 40%;\n}\n.field-row .col3[data-v-264a8858] {\n    width: 60%;\n}\n.field-row .col4[data-v-264a8858] {\n    width: 80%;\n}\n.field-row .col5[data-v-264a8858] {\n    width: 100%;\n}\n.booked-label[data-v-264a8858] {\n  color: #fff;\n  background: #ccc;\n  font-size: 12px;\n  padding: 3px 5px;\n  border-radius: 3px;\n  line-height: 1;\n  display: inline-block;\n  margin-top: 2px;\n}\n.booked-label.Web[data-v-264a8858] {\n    background: #a26d5d;\n}\n.booked-label.Android[data-v-264a8858] {\n    background: #78c259;\n}\n.booked-label.iOS[data-v-264a8858] {\n    background: #7fc8de;\n}\n.booked-label.Admin[data-v-264a8858] {\n    background: #2b83f1;\n}\n.booked-label.CSR[data-v-264a8858] {\n    background: #bb4a91;\n}\n.booked-label.Provider[data-v-264a8858] {\n    background: #3f3f3f;\n}\n.service-label[data-v-264a8858] {\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 12px;\n  display: inline-block;\n  margin-top: 2px;\n}\n.service-label.shared[data-v-264a8858] {\n    background: #f38d56;\n}\n.service-label.opoli[data-v-264a8858] {\n    background: #26D97A;\n}\n.service-label.black[data-v-264a8858] {\n    background: #777;\n}\n.service-label.SUV[data-v-264a8858], .service-label.suv[data-v-264a8858] {\n    background: #dc3168;\n}\n.service-label.shuttle[data-v-264a8858] {\n    background: #6dabc3;\n}\n.service-label.shared-optin[data-v-264a8858] {\n    background: #dd9a54;\n    border: 2px solid #a55b2e;\n}\n.service-label.mtech-service[data-v-264a8858] {\n    background: #18ab4c;\n    border: 1px solid #398316;\n}\n.data-field[data-v-264a8858] {\n  font-weight: 600;\n}\n.data-field .label[data-v-264a8858] {\n    color: #888;\n    font-size: 11px;\n    text-transform: uppercase;\n    line-height: 120%;\n}\n.data-field .value[data-v-264a8858] {\n    font-size: 17px;\n    color: #555;\n}\n.data-field .value.driver-name[data-v-264a8858] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.data-field .value.service-type[data-v-264a8858] {\n      text-transform: capitalize;\n}\n.data-field .value.credit-card[data-v-264a8858] {\n      font-size: 16px;\n}\n.data-field .value .fa-star[data-v-264a8858] {\n      color: #f1d724;\n      margin-right: 5px;\n}\n.data-field .value .payment-trigger[data-v-264a8858] {\n      font-size: 11px;\n      vertical-align: 3px;\n      text-decoration: underline;\n      margin-left: 2px;\n      cursor: pointer;\n}\n.data-field .value a[data-v-264a8858] {\n      text-decoration: underline;\n      cursor: pointer;\n}\n.data-field .value .cross[data-v-264a8858] {\n      text-decoration: line-through;\n}\n.data-field .value .grayed[data-v-264a8858] {\n      color: #888;\n}\n.trip-reminder-btn[data-v-264a8858], .no-show-btn[data-v-264a8858] {\n  margin-left: 10px;\n}\n.empty-state[data-v-264a8858] {\n  font-weight: 600;\n  color: #555;\n  font-size: 18px;\n}\n.empty-state p[data-v-264a8858] {\n    margin: 0 0 5px;\n}\n.empty-state button[data-v-264a8858] {\n    cursor: pointer;\n}\n.breakdown-modal[data-v-264a8858] {\n  position: fixed;\n  z-index: 12;\n  background: #f00;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.flightLabel .fa-circle-notch[data-v-264a8858] {\n  color: #0D79F2;\n}\n.flightLabel label[data-v-264a8858] {\n  cursor: pointer;\n  font-size: 11px;\n  vertical-align: middle;\n  color: #fff;\n  background: #ccc;\n  padding: 2px 6px;\n  margin-left: 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 100;\n}\n.flightLabel label.Scheduled[data-v-264a8858] {\n    background: #b97a2b;\n}\n.flightLabel label.Active[data-v-264a8858] {\n    background: #43b3e8;\n}\n.flightLabel label.Unknown[data-v-264a8858] {\n    background: #333;\n}\n.flightLabel label.Redirected[data-v-264a8858] {\n    background: #dc4c4c;\n}\n.flightLabel label.Landed[data-v-264a8858] {\n    background: #2bb971;\n}\n.flightLabel label.Diverted[data-v-264a8858] {\n    background: #b92b87;\n}\n.flightLabel label.Cancelled[data-v-264a8858] {\n    background: #8a8a8a;\n}\n.flightLabel label.arrived[data-v-264a8858] {\n    background: #26D97A;\n}\n.flightLabel label.Not.Operational[data-v-264a8858] {\n    background: #ef4958;\n}\n.truncate[data-v-264a8858] {\n  margin: 0;\n}\n@media only screen and (max-width: 430px) {\n.data-field .label[data-v-264a8858] {\n    font-size: 10px;\n    white-space: nowrap;\n}\n.data-field .value[data-v-264a8858] {\n    font-size: 15px;\n}\n.data-field .value .payment-trigger[data-v-264a8858] {\n      display: block;\n}\n.empty-state[data-v-264a8858] {\n    color: #999;\n    font-size: 15px;\n}\n.field-row .col1[data-v-264a8858] {\n    width: 23%;\n}\n.field-row .col3[data-v-264a8858] {\n    width: 50%;\n}\n.flightLabel label[data-v-264a8858] {\n    display: inline-block;\n    margin-left: 0;\n}\n.truncate[data-v-264a8858] {\n    margin: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.button.small[data-v-264a8858] {\n    font-size: 11px;\n    padding: 7px;\n}\n}\n.prov-options[data-v-264a8858] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-left: 5px;\n  cursor: pointer;\n  color: #0D79F2;\n  -webkit-transition: all .4s ease;\n  transition: all .4s ease;\n  position: relative;\n  z-index: 5;\n}\n.prov-options .fa-ellipsis-v[data-v-264a8858] {\n    font-size: 18px;\n}\n.prov-options[data-v-264a8858]:hover {\n    color: #333;\n}\n.prov-options .options[data-v-264a8858] {\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n    position: absolute;\n    top: 120%;\n    width: 200px;\n    background: #fff;\n    padding: 10px;\n    border-radius: 4px;\n    -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);\n            box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);\n}\n.prov-options .options .button[data-v-264a8858] {\n      margin-bottom: 3px;\n}\n.prov-options .options .button i[data-v-264a8858] {\n        margin-right: 5px;\n}\n.optin-icon[data-v-264a8858] {\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n.optin-icon img[data-v-264a8858] {\n    width: 18px;\n    vertical-align: -3px;\n    margin-right: 5px;\n}\n.optin-fare[data-v-264a8858] {\n  display: inline-block;\n}\n.switch[data-v-264a8858] {\n  position: relative;\n  display: inline-block;\n  height: 23px;\n}\n.switch .slider[data-v-264a8858] {\n    position: relative;\n    display: inline-block;\n    width: 50px;\n    height: 23px;\n    border-radius: 20px;\n    background: #ccc;\n    position: relative;\n    cursor: pointer;\n    -webkit-transition: all .25s ease-in-out;\n    transition: all .25s ease-in-out;\n}\n.switch .slider[data-v-264a8858]:before {\n      content: '';\n      position: absolute;\n      top: 4px;\n      left: 4px;\n      width: 15px;\n      height: 15px;\n      border-radius: 50%;\n      background: #fff;\n      -webkit-transition: all .25s ease-in-out;\n      transition: all .25s ease-in-out;\n      -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n}\n.switch .slider.active[data-v-264a8858] {\n      background: #57d1b7;\n}\n.switch .slider.active[data-v-264a8858]:before {\n        left: 30px;\n}\n.switch .label[data-v-264a8858] {\n    display: inline-block;\n    vertical-align: 10px;\n    margin-left: 5px;\n    font-size: 14px;\n    color: #555;\n    text-transform: uppercase;\n}\n.local-currency-box[data-v-264a8858] {\n  margin-bottom: 10px;\n  background: #fff792;\n  border: 1px solid #cdc23d;\n  padding: 5px;\n  border-radius: 5px;\n}\n.local-currency-box label[data-v-264a8858] {\n    font-size: 13px;\n    color: #565656;\n    margin-left: 5px;\n    font-family: 'Space Grotesk';\n    font-weight: 600;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_bundle_envs_production__ = __webpack_require__(1799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_bundle_envs_production___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_bundle_envs_production__);
/* global CONFIG */



/* harmony default export */ __webpack_exports__["a"] = ({
  isFDBrand: function isFDBrand(brand) {
    var search = __WEBPACK_IMPORTED_MODULE_0__config_bundle_envs_production__["CONFIG"].brands.find(function (x) {
      return x.id === brand;
    });
    return search && search.code === 'fd';
  }
});

/***/ }),
/* 1799 */
/***/ (function(module, exports) {

module.exports = {
  NODE_ENV: '"production"',
  CONFIG: {
    Env: 'production',
    Gateway: {
      host: 'gateway.opoli.com',
      port: 8081,
      url: 'https://gateway.opoli.com/',
      healthPath: '/'
    },
    d2dAPI: 'https://prodapi.door2dooranywhere.com',
    d2dGateway: 'https://gateway23.opoli.com',
    oldBackofficeLink: 'https://admin.opoli.com/',
    mediaHost: 'https://media.opoli.com',
    optimizationHost: 'https://opt.opoli.com',
    googleApiKey: 'AIzaSyD5pC4VioDmz6ByQtT1bfVsLi1yBwfvVQA',
    Firebase: {
      apiKey: 'AIzaSyCEZtk08WRaPDKUWNIidYioLrTeP-uA5Gk',
      authDomain: 'opoli-production.firebaseapp.com',
      databaseURL: 'https://opoli-production.firebaseio.com',
      projectId: 'opoli-production',
      storageBucket: 'opoli-production.appspot.com"',
      messagingSenderId: '948692888036'
    },
    hereApi: {
      id: '0HVa2uc67AYd0cnqzAee',
      code: 'Ar6I-EINztpimEq5fnplQA',
      key: 'hIBkP_ApUWA-JBk4TUMDtp9rd6EusNz0HqydDFdSYvM'
    },
    featureToggle: {
      requiredDropoffAirport: false,
      militaryTime: true
    },
    brands: [
      {
        id: 2,
        code: 'op',
        trxCode: 'op',
        name: 'Opoli',
        url: 'https://www.opoli.com/'
      },
      {
        id: 3,
        code: 'gs',
        trxCode: 'gs',
        name: 'GoSedan',
        url: 'https://gosedan.com/'
      },
      {
        id: 4,
        code: 'pts',
        trxCode: 'pt',
        name: 'Prime Time Shuttle',
        url: 'https://www.primetimeshuttle.com/'
      },
      {
        id: 5,
        code: 's2l',
        trxCode: 'sa',
        name: 'Shuttle2LAX',
        url: 'https://www.shuttletolax.com/'
      },
      {
        id: 6,
        code: 'pts',
        trxCode: 'sv',
        name: 'Prime Time Shuttle',
        url: 'https://www.primetimeshuttle.com/'
      },
      {
        id: 7,
        code: 'fd',
        trxCode: 'fd',
        name: 'Fresh Deliveries',
        url: 'https://www.opoli.com/'
      },
      {
        id: 8,
        code: 'bh',
        trxCode: 'bh',
        name: 'BeverlyHilton',
        url: 'https://beverlyhilton.opoli.com/'
      },
      {
        id: 9,
        code: 'ms',
        trxCode: 'ms',
        name: 'Masimo',
        url: 'https://masimo.primetimeshuttle.com/'
      },
      {
        id: 10,
        code: 'd2d',
        trxCode: 'dd',
        name: 'Door2Door',
        url: 'https://door2doorflights.com/'
      },
      {
        id: 11,
        code: 'ip',
        trxCode: 'ip',
        name: 'IPW',
        url: 'https://ipw.opoli.com/'
      },
      {
        id: 12,
        code: 'ro',
        trxCode: 'ro',
        name: 'Roland',
        url: 'https://roland.opoli.com/'
      },
      {
        id: 13,
        code: 'gz',
        trxCode: 'gz',
        name: 'GozoCabs',
        url: 'https://usatravel.gozocabs.com/'
      },
      {
        id: 14,
        code: 'bdp',
        trxCode: 'bd',
        name: 'Bobby Dee Presents',
        url: 'https://bobbydeepresents.ridesharepro.com/'
      },
      {
        id: 15,
        code: 'ncp',
        trxCode: 'nc',
        name: 'NCP Mobility',
        url: 'https://www.opoli.com/'
      },
      {
        id: 16,
        code: 'LH',
        trxCode: 'pt',
        name: 'Langham Hotels',
        url: 'https://www.primetimeshuttle.com/'
      },
      {
        id: 17,
        code: 'bw',
        trxCode: 'pt',
        name: 'Best Western Hotels',
        url: 'https://www.primetimeshuttle.com/'
      },
      {
        id: 18,
        code: 'bb',
        trxCode: 'pt',
        name: 'Big Bus Tours',
        url: 'https://www.primetimeshuttle.com/'
      },
      {
        id: 19,
        code: 'rs',
        trxCode: 'rs',
        name: 'Prime Time Rideshare',
        url: 'https://www.primetimerideshare.com/'
      },
      {
        id: 20,
        code: 'pm',
        trxCode: 'pm',
        name: 'PMCAA',
        url: 'https://portal.primetimerideshare.com/pmcaa/'
      },
      {
        id: 21,
        code: 'fm',
        trxCode: 'fm',
        name: 'Fairmont',
        url: 'https://portal.primetimerideshare.com/fairmont/'
      },
    ],
    serviceId: {
      shared: 5,
      opoli: 4,
      black: 3,
      suv: 2,
      shuttle: 1,
      doorToDoor: 49
    },
    default: {
      brandId: 2,
      laxAirportId: 21,
      laxServiceAreaId: [29, 54, 69, 70, 81, 82, 104, 105, 106, 107, 108, 109, 110, 111, 112, 192, 218, 239, 240, 241, 244, 245, 246, 247, 258, 259, 383, 388, 389, 417, 424, 425, 427, 453, 455, 456, 457, 458, 459, 460, 461, 462, 511, 512, 513, 517, 518, 519, 520, 521, 522, 523, 524, 525, 526, 527, 574, 575]
    },
    useOldQuatation: false,
    Stripe: {
      paymentURL: 'https://dashboard.stripe.com/payments/',
      customerURL: 'https://dashboard.stripe.com/customers/',
      accountURL: 'https://dashboard.stripe.com/connect/accounts/',
      topupURL: 'https://dashboard.stripe.com/topups',
      transferURL: 'https://dashboard.stripe.com/connect/transfers',
      publishableKey: 'pk_live_51OKnVkKp7cuQZ4H0Xm1yzlUiqsY0Aurl4tdxBz5lRkRHqzntX8roPCoNmcKSKIdNLVBnhasu8Nj0JODaBtuUv4Hf006sP7YVdv',
    },
    socket: {
      asap: {
        host: 'wss://dispatch.opoli.com',
        protocol: 'echo-protocol'
      }
    },
    goResUserId: 219990,
    quickResUserId: 278079,
    specialUser: [
      {
        name: 'Flip Flip',
        id: 219990
      }
    ],
    lyftServiceIds: [201, 208, 215, 218, 216, 207, 203, 212, 206, 210, 217, 209, 205, 213, 211, 202, 204, 214]
  }
}


/***/ }),
/* 1800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.currency.currency !== 'USD')?_c('div',{staticClass:"local-currency-box d-flex align-center"},[_c('div',{staticClass:"switch",on:{"click":function($event){_vm.useLocalCurrency = !_vm.useLocalCurrency}}},[_c('div',{class:['slider', {'active':_vm.useLocalCurrency}]})]),_vm._v(" "),_c('label',[_vm._v("USE LOCAL CURRENCY")])]):_vm._e(),_vm._v(" "),_c('div',{class:{'collapsible':true, 'collapse':!_vm.contentShow.tripInfo}},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.contentShow.tripInfo = !_vm.contentShow.tripInfo}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentShow.tripInfo),expression:"contentShow.tripInfo"}],staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentShow.tripInfo),expression:"!contentShow.tripInfo"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.label')))])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col3"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.brand'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',{staticClass:"brand",style:({color: '#' + _vm.tripInfo.brandColor})},[_vm._v(_vm._s(_vm.tripInfo.brand))])])]),_vm._v(" "),_c('div',{staticClass:"data-field col col1"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.bookedThrough'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',{class:['booked-label', _vm.tripInfo.bookedThrough]},[_vm._v(_vm._s(_vm.tripInfo.bookedThrough))])])]),_vm._v(" "),_c('div',{staticClass:"data-field col col1"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.serviceType'))+":")]),_vm._v(" "),_c('div',{staticClass:"value service-type"},[(_vm.useOldQuatation)?_c('span',{class:['service-label', _vm.tripInfo.serviceType]},[_vm._v(_vm._s(_vm.tripInfo.serviceLabel))]):_c('span',{staticClass:"service-label",style:({backgroundColor: _vm.tripInfo.serviceType.color})},[_vm._v(_vm._s(_vm.tripInfo.serviceType.label))]),_vm._v(" "),(_vm.tripInfo.optinShared.isOptinShared && _vm.tripInfo.optinShared.current === 'shared')?_c('span',{staticClass:"service-label shared-optin"},[_vm._v("Shared")]):_vm._e(),_vm._v(" "),(_vm.mtech.enabled)?_c('span',{staticClass:"service-label mtech-service"},[_vm._v(_vm._s(_vm.mtech.details.service.code))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col3"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.serviceArea'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',{staticClass:"brand"},[_vm._v(_vm._s(_vm.tripInfo.serviceArea))])])]),_vm._v(" "),_c('div',{class:['data-field col', _vm.tripInfo.isCharter || _vm.tripInfo.isRental ? 'col1' : 'col2']},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.fare'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('span',{class:{'cross grayed': _vm.tripInfo.optinShared.isOptinShared && _vm.tripInfo.optinShared.current === 'shared'}},[(!_vm.useLocalCurrency)?_c('span',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.totalFare)))]):_c('span',[_vm._v(_vm._s(_vm.totalFareIntl))])]),_vm._v(" "),(_vm.tripInfo.optinShared.isOptinShared && _vm.tripInfo.optinShared.current === 'shared')?_c('span',{staticStyle:{"display":"inline-block","margin":"0 5px"}},[_vm._v("/")]):_vm._e(),_vm._v(" "),(_vm.tripInfo.optinShared.isOptinShared && _vm.tripInfo.optinShared.current === 'shared')?_c('span',{class:['optin-fare', {'grayed': _vm.tripInfo.optinShared.current !== 'shared'}]},[(!_vm.useLocalCurrency)?_c('span',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.totalFareOptin)))]):_c('span',[_vm._v(_vm._s(_vm.totalFareOptinIntl))])]):_vm._e()])]),_vm._v(" "),(_vm.tripInfo.isCharter || _vm.tripInfo.isRental)?_c('div',{staticClass:"data-field col col1"},[_c('div',{staticClass:"label all-caps"},[_vm._v("Duration:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.tripInfo.eta / 60)+" mins")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col3"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.createdOn'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.tripInfo.created))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col2"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.driverPayment'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[(!_vm.useLocalCurrency)?_c('span',[_vm._v("$"+_vm._s(_vm.totalDriverPayment))]):_c('span',[_vm._v(_vm._s(_vm.totalDriverPaymentIntl))]),_vm._v(" "),_c('a',{staticClass:"payment-trigger",on:{"click":function($event){return _vm.setShowPaymentBreakdown(true)}}},[_vm._v("\n              "+_vm._s(_vm.$t('rsvpDetails.tripInformation.seePaymentBreakdown'))+"\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col3"},[(_vm.tripInfo.isCharter || _vm.tripInfo.isRental)?_c('div',{staticClass:"label"},[_vm._v("Start Date:")]):_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.pickupDate'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.tripInfo.pickupDate))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col1"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.tip'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[(!_vm.useLocalCurrency)?_c('span',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.tripInfo.tip)))]):_c('span',[_vm._v(_vm._s(_vm.xcurrency.format({code: _vm.currency.currency, val: _vm.currency.tipAmount})))])])]),_vm._v(" "),_c('div',{staticClass:"data-field col col1"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.airportFee'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.tripInfo.airportFee !== null && _vm.tripInfo.airportFee > 0)?_c('span',[(!_vm.useLocalCurrency)?_c('span',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.tripInfo.airportFee)))]):_c('span',[_vm._v(_vm._s(_vm.xcurrency.format({code: _vm.currency.currency, val: _vm.currency.airportFee})))])]):_c('span',[_vm._v("N/A")])])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[(_vm.tripInfo.isCharter || _vm.tripInfo.isRental)?_c('div',{staticClass:"data-field col col3"},[_c('div',{staticClass:"label"},[_vm._v("End Date:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.computeEndDate(_vm.tripInfo)))])]):(_vm.mtech.enabled)?_c('div',{staticClass:"data-field col col3"},[_c('div',{staticClass:"label"},[_vm._v("LOCAL PICKUP DATE/TIME:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.mtech.details.localPickupDate))])]):(_vm.isD2d || (_vm.tripInfo.localPickupTime && _vm.tripInfo.localPickupTime != _vm.tripInfo.pickupDate))?_c('div',{staticClass:"data-field col col3"},[_c('div',{staticClass:"label"},[_vm._v("LOCAL PICKUP DATE/TIME:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.tripInfo.localPickupTime))])]):_c('div',{staticClass:"data-field col col3"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.pickupType'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.tripInfo.pickup.geofenceType === 'airport')?_c('span',[(_vm.isTncService && _vm.tripInfo.pickup.airportCode === 'LAX')?_c('span',[_vm._v("\n                LAXit 20A\n              ")]):(!_vm.tripInfo.meetAndGreet)?_c('span',[_vm._v("Curbside")]):_c('span',[_vm._v("\n                Meet & Greet\n                (\n                  "),(_vm.tripInfo.pickupFee && !_vm.useLocalCurrency)?_c('span',[_vm._v(_vm._s('$' + _vm.toFixed(_vm.tripInfo.pickupFee)))]):(_vm.tripInfo.pickupFee && _vm.useLocalCurrency)?_c('span',[_vm._v(_vm._s(_vm.xcurrency.format({code: _vm.currency.currency, val: _vm.currency.pickupFee})))]):_c('span',[_vm._v("Complimentary")]),_vm._v("\n                )\n              ")])]):_c('span',[_vm._v("N/A")])])]),_vm._v(" "),(!_vm.tripInfo.isCharter || _vm.tripInfo.isRental)?_c('div',{staticClass:"data-field col col1"},[_c('div',{staticClass:"label all-caps"},[_vm._v(_vm._s(_vm.travelInsuranceLabel)+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[(!_vm.useLocalCurrency)?_c('span',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.tripInfo.travelInsurance)))]):_c('span',[_vm._v(_vm._s(_vm.xcurrency.format({code: _vm.currency.currency, val: _vm.currency.travelInsurance})))])])]):_vm._e(),_vm._v(" "),(_vm.tripInfo.gasFee !== null && _vm.tripInfo.gasFee > 0)?_c('div',{staticClass:"data-field col col1"},[_c('div',{staticClass:"label"},[_vm._v("Fuel Surcharge:")]),_vm._v(" "),_c('div',{staticClass:"value"},[(!_vm.useLocalCurrency)?_c('span',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.tripInfo.gasFee)))]):_c('span',[_vm._v(_vm._s(_vm.xcurrency.format({code: _vm.currency.currency, val: _vm.currency.gasFee})))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col5"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.pickup'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.tripInfo.pickup.title))])])]),_vm._v(" "),(_vm.extraStops.length)?_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col5"},[_c('div',{staticClass:"label"},[_vm._v("Extra Stop:")]),_vm._v(" "),_vm._l((_vm.extraStops),function(stop,index){return _c('div',{key:index,staticClass:"value"},[_vm._v(_vm._s(_vm.extraStopAddress(stop)))])})],2)]):_vm._e(),_vm._v(" "),(!_vm.tripInfo.isCharter && !_vm.tripInfo.isRental)?_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col5"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.dropoff'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.tripInfo.dropoff.title))])])]):_vm._e(),_vm._v(" "),(!_vm.tripInfo.isCharter && !_vm.tripInfo.isRental)?_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col3"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.beThereTime'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.tripInfo.beThereTime))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col2"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.distance'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.tripInfo.distance)+"mi")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col3"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.flightInfo'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n            "+_vm._s(_vm.flightInfo)+"\n            "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.flightInfo !== 'N/A' && !_vm.isD2d),expression:"flightInfo !== 'N/A' && !isD2d"}],staticClass:"flightLabel"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.flightLoading),expression:"flightLoading"}],staticClass:"fa fa-circle-notch fa-spin"}),_vm._v(" "),(!_vm.flightLoading && !_vm.statusDone)?_c('label',{class:[_vm.flightStatus.class],on:{"click":_vm.showFlightStatus}},[_vm._v(_vm._s(_vm.flightStatus.label))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"data-field col col1"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.passenger'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.tripInfo.passenger))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col1"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.luggage'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.tripInfo.luggage))])])]),_vm._v(" "),(!!_vm.tripInfo.terminal)?_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col5"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.terminal'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.tripInfo.terminal))])])]):_vm._e(),_vm._v(" "),(_vm.tripInfo.portalFee)?_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col5"},[_c('div',{staticClass:"label"},[_vm._v("Convenience Fee:")]),_vm._v(" "),_c('div',{staticClass:"value"},[(!_vm.useLocalCurrency)?_c('span',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.tripInfo.portalFee)))]):_c('span',[_vm._v(_vm._s(_vm.convenienceFeeIntl))])])])]):_vm._e(),_vm._v(" "),(_vm.tripInfo.rating > 0)?_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col1"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.rating'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('i',{staticClass:"fa fa-star"}),_vm._v(" "+_vm._s(_vm.tripInfo.rating))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.tripInfo.userReview),expression:"!!tripInfo.userReview"}],staticClass:"data-field col col4"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.userReview'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.tripInfo.userReview))])])]):_vm._e(),_vm._v(" "),(_vm.customerInfo.externalId || _vm.customerInfo.alternatePhone)?_c('div',{staticClass:"field-row"},[(_vm.customerInfo.externalId)?_c('div',{staticClass:"data-field col col3"},[_c('div',{staticClass:"label"},[_vm._v("External ID:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.customerInfo.externalId))])]):_vm._e(),_vm._v(" "),(_vm.customerInfo.alternatePhone)?_c('div',{staticClass:"data-field col col2"},[_c('div',{staticClass:"label"},[_vm._v("Alternate Phone:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{on:{"click":function($event){return _vm.call({mobile: _vm.customerInfo.alternatePhone, firstName: _vm.customerInfo.firstName, lastName: _vm.customerInfo.lastName})}}},[_vm._v(_vm._s(_vm.customerInfo.alternatePhone))])])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tripInfo.notes !== '' && _vm.tripInfo.notes !== null),expression:"tripInfo.notes !== '' && tripInfo.notes !== null"}],staticClass:"field-row"},[_c('div',{staticClass:"data-field col col5"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.notes'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.tripInfo.notes))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[(_vm.tripInfo.optinShared.isOptinShared && _vm.tripInfo.status === 'upcoming' && !_vm.tripInfo.packageId)?_c('a',{staticClass:"button cta small right",on:{"click":function($event){_vm.optinModal = true}}},[(_vm.tripInfo.optinShared.current === 'exclusive')?_c('span',[_vm._v("Convert to Shared")]):_c('span',[_vm._v("Convert back to Exclusive")])]):_vm._e()])])]),_vm._v(" "),_c('div',{class:{'collapsible':true, 'collapse':!_vm.contentShow.otherInfo}},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.contentShow.otherInfo = !_vm.contentShow.otherInfo}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentShow.otherInfo),expression:"contentShow.otherInfo"}],staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentShow.otherInfo),expression:"!contentShow.otherInfo"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('span',[_vm._v("Other Information")])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col3"},[_c('div',{staticClass:"label"},[_vm._v("Hudson ID:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.otherInfo.externalId))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col2"},[_c('div',{staticClass:"label"},[_vm._v("Alternate Phone:")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.otherInfo.alternatePhone === 'N/A')?_c('span',[_vm._v("N/A")]):_c('a',{on:{"click":function($event){return _vm.call({mobile: _vm.otherInfo.alternatePhone, firstName: _vm.otherInfo.firstName, lastName: _vm.otherInfo.lastName})}}},[_vm._v(_vm._s(_vm.otherInfo.alternatePhone))])])])])])]),_vm._v(" "),(_vm.isCorporate)?_c('div',{class:{'collapsible':true, 'collapse':!_vm.contentShow.businessInfo}},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.contentShow.businessInfo = !_vm.contentShow.businessInfo}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentShow.businessInfo),expression:"contentShow.businessInfo"}],staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentShow.businessInfo),expression:"!contentShow.businessInfo"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('span',[_vm._v("Business Information")])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col3"},[_c('div',{staticClass:"label"},[_vm._v("Corporate Name:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.businessInfo.corporateName))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col1"},[_c('div',{staticClass:"label"},[_vm._v("ID:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":'/#/corporate/' + _vm.businessInfo.id,"target":"_blank"}},[_vm._v(_vm._s(_vm.businessInfo.id))])])]),_vm._v(" "),_c('div',{staticClass:"data-field col col1"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.customerInformation.paidWith'))+":")]),_vm._v(" "),_c('div',{staticClass:"value credit-card"},[_vm._v(_vm._s(_vm.creditCard))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col3"},[_c('div',{staticClass:"label"},[_vm._v("Passenger Name:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.businessInfo.firstName + ' ' + _vm.businessInfo.lastName))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col2"},[_c('div',{staticClass:"label"},[_vm._v("Passenger Mobile:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{on:{"click":function($event){return _vm.call(_vm.businessInfo)}}},[_vm._v(_vm._s(_vm.businessInfo.mobile))])])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[(_vm.tripInfo.reservationState !== 'NOSHOW')?_c('a',{class:{'button cta success small right':true, 'disabled':_vm.emailLoading},on:{"click":_vm.sendEmail}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showConfirmEmail && !_vm.emailLoading),expression:"showConfirmEmail && !emailLoading"}]},[_vm._v("\n            "+_vm._s(_vm.$t('rsvpDetails.sendConfirmationEmail'))+"\n          ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpStatus === 'complete' && !_vm.emailLoading),expression:"rsvpStatus === 'complete' && !emailLoading"}]},[_vm._v("\n            "+_vm._s(_vm.$t('rsvpDetails.sendReceiptEmail'))+"\n          ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpStatus === 'canceled' && !_vm.emailLoading),expression:"rsvpStatus === 'canceled' && !emailLoading"}]},[_vm._v("\n            "+_vm._s(_vm.$t('rsvpDetails.sendCancellationEmail'))+"\n          ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.emailLoading),expression:"emailLoading"}]},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v("\n            "+_vm._s(_vm.$t('rsvpDetails.sending'))+"\n          ")])]):_vm._e(),_vm._v(" "),_c('div',[(!_vm.hideReminderButton)?_c('a',{class:{'button cta small right trip-reminder-btn':true, 'disabled':_vm.tripRemindLoading},on:{"click":_vm.sendTripReminder}},[(!_vm.tripRemindLoading)?_c('span',[_vm._v("Send Trip Reminder")]):_c('span',[_vm._v(_vm._s(_vm.$t('rsvpDetails.sending')))])]):_vm._e()]),_vm._v(" "),(_vm.showConfirmEmail && _vm.driverInfo.id)?_c('div',[(!_vm.noShow.forceHide)?_c('a',{class:['button cta small right no-show-btn', _vm.hasRSVPControl ? 'warning' : 'secondary disabled', {'disabled':_vm.noShow.loading}],on:{"click":_vm.sendNoShow}},[_vm._v(_vm._s(_vm.$t('rsvpDetails.noShow.label')))]):_vm._e()]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCorporate),expression:"!isCorporate"}],class:{'collapsible':true, 'collapse':!_vm.contentShow.customerInfo}},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.contentShow.customerInfo = !_vm.contentShow.customerInfo}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentShow.customerInfo),expression:"contentShow.customerInfo"}],staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentShow.customerInfo),expression:"!contentShow.customerInfo"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('rsvpDetails.customerInformation.label')))])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col3"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.customerInformation.name'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.customerName))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col1"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.customerInformation.id'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":'/#/consumer/' + _vm.customerInfo.id,"target":"_blank"}},[_vm._v(_vm._s(_vm.customerInfo.id))])])]),_vm._v(" "),_c('div',{staticClass:"data-field col col1"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.customerInformation.paidWith'))+":")]),_vm._v(" "),_c('div',{staticClass:"value credit-card"},[_vm._v(_vm._s(_vm.creditCard))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col3"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.customerInformation.email'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('p',{staticClass:"truncate"},[_c('a',{attrs:{"href":'mailto:' + _vm.customerInfo.email}},[_vm._v(_vm._s(_vm.customerInfo.email))])])])]),_vm._v(" "),_c('div',{staticClass:"data-field col col2"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.customerInformation.mobile'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.customerInfo.mobile === 'N/A')?_c('span',[_vm._v(_vm._s(_vm.customerInfo.mobile))]):_c('a',{on:{"click":function($event){return _vm.call(_vm.customerInfo)}}},[_vm._v(_vm._s(_vm.displayPhone(_vm.customerInfo.phone)))])])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[((_vm.showConfirmEmail && !_vm.isD2d) || !_vm.showConfirmEmail)?_c('a',{class:{'button cta success small right':true, 'disabled':_vm.emailLoading},on:{"click":_vm.sendEmail}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showConfirmEmail && !_vm.emailLoading),expression:"showConfirmEmail && !emailLoading"}]},[_vm._v("\n            "+_vm._s(_vm.$t('rsvpDetails.sendConfirmationEmail'))+"\n          ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpStatus === 'complete' && !_vm.emailLoading),expression:"rsvpStatus === 'complete' && !emailLoading"}]},[_vm._v("\n            "+_vm._s(_vm.$t('rsvpDetails.sendReceiptEmail'))+"\n          ")]),_vm._v(" "),(_vm.tripInfo.reservationState === 'NOSHOW' && !_vm.emailLoading)?_c('span',[_vm._v("\n            SEND NO SHOW EMAIL\n          ")]):(_vm.rsvpStatus === 'canceled' && !_vm.emailLoading)?_c('span',[_vm._v("\n            "+_vm._s(_vm.$t('rsvpDetails.sendCancellationEmail'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.emailLoading),expression:"emailLoading"}]},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v("\n            "+_vm._s(_vm.$t('rsvpDetails.sending'))+"\n          ")])]):_vm._e(),_vm._v(" "),_c('div',[(!_vm.hideReminderButton)?_c('a',{class:{'button cta small right trip-reminder-btn':true, 'disabled':_vm.tripRemindLoading},on:{"click":_vm.sendTripReminder}},[(!_vm.tripRemindLoading)?_c('span',[_vm._v("Send Trip Reminder")]):_c('span',[_vm._v(_vm._s(_vm.$t('rsvpDetails.sending')))])]):_vm._e()]),_vm._v(" "),(_vm.showConfirmEmail && _vm.driverInfo.id && ((_vm.lyft.show && ['dispatched', 'ontheway', 'onboard', 'pickup'].indexOf(_vm.tripInfo.bidStatus) == -1 ) || !_vm.lyft.show))?_c('div',[(!_vm.noShow.forceHide)?_c('a',{class:['button cta small right no-show-btn', _vm.hasRSVPControl ? 'warning' : 'secondary disabled', {'disabled':_vm.noShow.loading}],on:{"click":_vm.sendNoShow}},[_vm._v(_vm._s(_vm.$t('rsvpDetails.noShow.label')))]):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCorporate),expression:"!isCorporate"}],class:{'collapsible':true, 'collapse':!_vm.contentShow.guestInfo}},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.contentShow.guestInfo = !_vm.contentShow.guestInfo}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentShow.guestInfo),expression:"contentShow.guestInfo"}],staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentShow.guestInfo),expression:"!contentShow.guestInfo"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('rsvpDetails.guestInformation.label')))])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.noGuest),expression:"!noGuest"}],staticClass:"field-row"},[_c('div',{staticClass:"data-field col col3"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.guestInformation.name'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.guestName))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col2"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.guestInformation.mobile'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.guestInfo.mobile !== '' && _vm.guestInfo.mobile !== '+1')?_c('a',{on:{"click":function($event){return _vm.call(_vm.guestInfo)}}},[_vm._v(_vm._s(_vm.guestInfo.mobile))]):_c('span',[_vm._v("N/A")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.noGuest),expression:"noGuest"}],staticClass:"empty-state"},[_c('p',[_vm._v(_vm._s(_vm.$t('rsvpDetails.guestInformation.emptyState')))])])])]),_vm._v(" "),(!_vm.lyft.show)?_c('div',{class:{'collapsible':true, 'collapse':!_vm.contentShow.driverInfo}},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.contentShow.driverInfo = !_vm.contentShow.driverInfo}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentShow.driverInfo),expression:"contentShow.driverInfo"}],staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentShow.driverInfo),expression:"!contentShow.driverInfo"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('rsvpDetails.driverInformation.label')))])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.noDriver),expression:"!noDriver"}]},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col3"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.driverInformation.name'))+":")]),_vm._v(" "),_c('div',{staticClass:"value driver-name"},[_c('div',{staticClass:"name"},[_vm._v("\n              "+_vm._s(_vm.driverName)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"prov-options",on:{"mouseover":_vm.clearOptionDelay,"mouseout":_vm.hideOptions}},[_c('i',{staticClass:"fas fa-ellipsis-v fa-lg",on:{"click":function($event){_vm.showOptions = !_vm.showOptions}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOptions),expression:"showOptions"}],staticClass:"options"},[_c('div',{staticClass:"button cta success block call",on:{"click":function($event){return _vm.call(_vm.driverInfo)}}},[_c('i',{staticClass:"fa fa-phone"}),_vm._v(_vm._s(_vm.$t('provider.call'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"button cta block send-sms",on:{"click":function($event){return _vm.sendSMS(_vm.driverInfo)}}},[_c('i',{staticClass:"fas fa-comment-dots"}),_vm._v(_vm._s(_vm.$t('provider.sms'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"button cta warning block send-notif",on:{"click":_vm.showNotif}},[_c('i',{staticClass:"fas fa-bell"}),_vm._v(_vm._s(_vm.$t('provider.notify'))+"\n                    ")])])])],1)])]),_vm._v(" "),_c('div',{staticClass:"data-field col col1"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.driverInformation.id'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":'/#/provider/' + _vm.driverInfo.id,"target":"_blank"}},[_vm._v(_vm._s(_vm.driverInfo.driverNum))])])]),_vm._v(" "),_c('div',{staticClass:"data-field col col1"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.driverInformation.avgRating'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('i',{staticClass:"fa fa-star"}),_vm._v(_vm._s(_vm.driverInfo.rating))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col1"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.driverInformation.make'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.driverInfo.make))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col2"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.driverInformation.model'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.driverInfo.model))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col2"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.driverInformation.licensePlate'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.driverInfo.licensePlate))])])]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col3"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.driverInformation.email'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('p',{staticClass:"truncate"},[_c('a',{attrs:{"href":'mailto:' + _vm.driverInfo.email}},[_vm._v(_vm._s(_vm.driverInfo.email))])])])]),_vm._v(" "),_c('div',{staticClass:"data-field col col2"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.driverInformation.mobile'))+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{on:{"click":function($event){return _vm.call(_vm.driverInfo)}}},[_vm._v("+"+_vm._s(_vm.driverInfo.countryCode)+" "+_vm._s(_vm.driverInfo.nationalNumber))])])])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showReleaseButton),expression:"showReleaseButton"}],staticClass:"button small cta error",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$store.commit('rsvpDetails/showReleaseConfirmation')}}},[_vm._v("\n          "+_vm._s(_vm.$t('rsvpDetails.driverInformation.releaseBtn'))+"\n        ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.noDriver),expression:"noDriver"}],staticClass:"empty-state"},[_c('p',[_vm._v(_vm._s(_vm.$t('rsvpDetails.driverInformation.emptyState')))])])])]):_vm._e(),_vm._v(" "),(_vm.lyft.show)?_c('div',{class:{'collapsible':true, 'collapse':!_vm.contentShow.lyft}},[_c('div',{staticClass:"heading",on:{"click":function($event){_vm.contentShow.lyft = !_vm.contentShow.lyft}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentShow.lyft),expression:"contentShow.lyft"}],staticClass:"fa fa-minus-circle"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentShow.lyft),expression:"!contentShow.lyft"}],staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('span',[_vm._v("Lyft Information")])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col3"},[_c('div',{staticClass:"label"},[_vm._v("Lyft Ride ID:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.lyft.rideId))])]),_vm._v(" "),(_vm.lyft.date)?_c('div',{staticClass:"data-field col col2"},[_c('div',{staticClass:"label"},[_vm._v("Send Date:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.lyft.date))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col3"},[_c('div',{staticClass:"label"},[_vm._v("Lyft Ride Type:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.lyftServiceLabel(_vm.lyft.rideType)))])])]),_vm._v(" "),(_vm.lyft.driver.id)?_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col5"},[_c('div',{staticClass:"label"},[_vm._v("Driver:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.lyft.driver.first_name))])])]):_vm._e(),_vm._v(" "),(_vm.lyft.driver.id)?_c('div',{staticClass:"field-row"},[_c('div',{staticClass:"data-field col col3"},[_c('div',{staticClass:"label"},[_vm._v("Mobile:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.lyft.driver.phone_number))])]),_vm._v(" "),_c('div',{staticClass:"data-field col col2"},[_c('div',{staticClass:"label"},[_vm._v("Rating:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.lyft.driver.rating))])])]):_vm._e()])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transactions_vue__ = __webpack_require__(610);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a1be77c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transactions_vue__ = __webpack_require__(1804);
function injectStyle (ssrContext) {
  __webpack_require__(1802)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a1be77c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transactions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a1be77c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transactions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1803);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("14fe9475", content, true, {});

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.trx-page[data-v-5a1be77c] {\n  padding: 10px;\n}\n.loading[data-v-5a1be77c] {\n  text-align: center;\n  padding: 10px;\n  font-size: 18px;\n}\n.loading .fa[data-v-5a1be77c] {\n    margin-right: 5px;\n    color: #555;\n}\n.loading span[data-v-5a1be77c] {\n    color: #888;\n}\n.empty-state[data-v-5a1be77c] {\n  padding: 10px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\ntable[data-v-5a1be77c] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-5a1be77c] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n    text-align: center;\n}\ntable thead th[data-v-5a1be77c] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-5a1be77c] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-5a1be77c] {\n      padding: 10px 8px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.card[data-v-5a1be77c] {\n        -webkit-box-shadow: none;\n                box-shadow: none;\n        border: none;\n}\ntable tbody tr td.date-time[data-v-5a1be77c] {\n        width: 80px;\n        line-height: 1.25;\n}\ntable tbody tr td.cancel-fee[data-v-5a1be77c], table tbody tr td.promo-used[data-v-5a1be77c] {\n        width: 60px;\n}\ntable tbody tr td.table-block[data-v-5a1be77c] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-5a1be77c] {\n          color: #ccc;\n}\n.status-label[data-v-5a1be77c] {\n  line-height: 1;\n  color: #fff;\n  padding: 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 10px !important;\n  background: #999;\n  display: inline-block;\n}\n.status-label.Purchased[data-v-5a1be77c], .status-label.Purchase[data-v-5a1be77c] {\n    background: #4aadf3;\n}\n.status-label.Completed[data-v-5a1be77c] {\n    background: #26D97A;\n}\n.status-label.Promo[data-v-5a1be77c] {\n    background: #f3904a;\n}\n.status-label.Edited[data-v-5a1be77c], .status-label.Refund[data-v-5a1be77c] {\n    background: #797979;\n}\n.status-label.No.Show[data-v-5a1be77c], .status-label.Cancelled[data-v-5a1be77c], .status-label.Declined[data-v-5a1be77c] {\n    background: #f54f4f;\n}\n.status-label.Pending.Refund[data-v-5a1be77c] {\n    background: #098769;\n    color: #fff;\n    line-height: 1.3;\n}\n.status-label.NOT_PROCESSED[data-v-5a1be77c] {\n    background: #FFCC00 !important;\n    color: #505050 !important;\n}\n.status-label.Credit.Conversion[data-v-5a1be77c] {\n    background: #29c3c3;\n}\n.status-label.Credit.Conversion.RECLAIMED[data-v-5a1be77c] {\n    background: #bbbbbb;\n}\n.table-cards[data-v-5a1be77c] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\ntable[data-v-5a1be77c] {\n    display: none;\n}\n.table-cards[data-v-5a1be77c] {\n    display: block;\n}\n.trans-card[data-v-5a1be77c] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    background-color: #fff;\n}\n.trans-card a[data-v-5a1be77c] {\n      font-weight: 900;\n}\n.trans-card .time[data-v-5a1be77c] {\n      font-size: 12px;\n      color: #777;\n}\n.trans-card .card-header[data-v-5a1be77c] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      text-transform: uppercase;\n}\n.trans-card .card-header .amount[data-v-5a1be77c] {\n        font-weight: 900;\n        font-size: 20px;\n}\n.trans-card .card-header .amount a[data-v-5a1be77c] {\n          text-decoration: none;\n}\n.trans-card .card-header .amount i[data-v-5a1be77c] {\n          font-size: 15px;\n}\n.trans-card .title[data-v-5a1be77c] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.trans-card .label[data-v-5a1be77c] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.trans-card .value[data-v-5a1be77c] {\n      margin-right: 10px;\n      font-size: 13px;\n      font-weight: 900;\n}\n}\n.switch[data-v-5a1be77c] {\n  position: relative;\n  display: inline-block;\n  height: 23px;\n}\n.switch .slider[data-v-5a1be77c] {\n    position: relative;\n    display: inline-block;\n    width: 50px;\n    height: 23px;\n    border-radius: 20px;\n    background: #ccc;\n    position: relative;\n    cursor: pointer;\n    -webkit-transition: all .25s ease-in-out;\n    transition: all .25s ease-in-out;\n}\n.switch .slider[data-v-5a1be77c]:before {\n      content: '';\n      position: absolute;\n      top: 4px;\n      left: 4px;\n      width: 15px;\n      height: 15px;\n      border-radius: 50%;\n      background: #fff;\n      -webkit-transition: all .25s ease-in-out;\n      transition: all .25s ease-in-out;\n      -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n}\n.switch .slider.active[data-v-5a1be77c] {\n      background: #57d1b7;\n}\n.switch .slider.active[data-v-5a1be77c]:before {\n        left: 30px;\n}\n.switch .label[data-v-5a1be77c] {\n    display: inline-block;\n    vertical-align: 10px;\n    margin-left: 5px;\n    font-size: 14px;\n    color: #555;\n    text-transform: uppercase;\n}\n.local-currency-box[data-v-5a1be77c] {\n  margin-bottom: 10px;\n  background: #fff792;\n  border: 1px solid #cdc23d;\n  padding: 5px;\n  border-radius: 5px;\n}\n.local-currency-box label[data-v-5a1be77c] {\n    font-size: 13px;\n    color: #565656;\n    margin-left: 5px;\n    font-family: 'Space Grotesk';\n    font-weight: 600;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/RsvpDetails/Transactions.vue"],"names":[],"mappings":";AACA;EACE,cAAc;CACf;AACD;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;CACjB;AACD;IACI,kBAAkB;IAClB,YAAY;CACf;AACD;IACI,YAAY;CACf;AACD;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;CACpB;AACD;EACE,0BAA0B;EAC1B,YAAY;CACb;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;IAC1B,mBAAmB;CACtB;AACD;MACM,kBAAkB;CACvB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,kBAAkB;MAClB,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,yBAAyB;gBACjB,iBAAiB;QACzB,aAAa;CACpB;AACD;QACQ,YAAY;QACZ,kBAAkB;CACzB;AACD;QACQ,YAAY;CACnB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;IACpB,YAAY;IACZ,iBAAiB;CACpB;AACD;IACI,+BAA+B;IAC/B,0BAA0B;CAC7B;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,cAAc;CACf;AACD;AACA;IACI,cAAc;CACjB;AACD;IACI,eAAe;CAClB;AACD;IACI,uBAAuB;IACvB,oBAAoB;IACpB,aAAa;IACb,oBAAoB;IACpB,+BAA+B;IAC/B,oBAAoB;IACpB,uBAAuB;CAC1B;AACD;MACM,iBAAiB;CACtB;AACD;MACM,gBAAgB;MAChB,YAAY;CACjB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;MAC5B,0BAA0B;CAC/B;AACD;QACQ,iBAAiB;QACjB,gBAAgB;CACvB;AACD;UACU,sBAAsB;CAC/B;AACD;UACU,gBAAgB;CACzB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;MACM,gBAAgB;MAChB,0BAA0B;MAC1B,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;CACvB;AACD;MACM,mBAAmB;MACnB,gBAAgB;MAChB,iBAAiB;CACtB;CACA;AACD;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;CACd;AACD;IACI,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,iCAAiC;CACpC;AACD;MACM,YAAY;MACZ,mBAAmB;MACnB,SAAS;MACT,UAAU;MACV,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,iBAAiB;MACjB,yCAAyC;MACzC,iCAAiC;MACjC,oDAAoD;cAC5C,4CAA4C;CACzD;AACD;MACM,oBAAoB;CACzB;AACD;QACQ,WAAW;CAClB;AACD;IACI,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;CAC7B;AACD;EACE,oBAAoB;EACpB,oBAAoB;EACpB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;CACpB;AACD;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,iBAAiB;CACpB","file":"Transactions.vue","sourcesContent":["\n.trx-page[data-v-5a1be77c] {\n  padding: 10px;\n}\n.loading[data-v-5a1be77c] {\n  text-align: center;\n  padding: 10px;\n  font-size: 18px;\n}\n.loading .fa[data-v-5a1be77c] {\n    margin-right: 5px;\n    color: #555;\n}\n.loading span[data-v-5a1be77c] {\n    color: #888;\n}\n.empty-state[data-v-5a1be77c] {\n  padding: 10px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\ntable[data-v-5a1be77c] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-5a1be77c] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n    text-align: center;\n}\ntable thead th[data-v-5a1be77c] {\n      padding: 5px 10px;\n}\ntable tbody tr[data-v-5a1be77c] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-5a1be77c] {\n      padding: 10px 8px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.card[data-v-5a1be77c] {\n        -webkit-box-shadow: none;\n                box-shadow: none;\n        border: none;\n}\ntable tbody tr td.date-time[data-v-5a1be77c] {\n        width: 80px;\n        line-height: 1.25;\n}\ntable tbody tr td.cancel-fee[data-v-5a1be77c], table tbody tr td.promo-used[data-v-5a1be77c] {\n        width: 60px;\n}\ntable tbody tr td.table-block[data-v-5a1be77c] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-5a1be77c] {\n          color: #ccc;\n}\n.status-label[data-v-5a1be77c] {\n  line-height: 1;\n  color: #fff;\n  padding: 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 10px !important;\n  background: #999;\n  display: inline-block;\n}\n.status-label.Purchased[data-v-5a1be77c], .status-label.Purchase[data-v-5a1be77c] {\n    background: #4aadf3;\n}\n.status-label.Completed[data-v-5a1be77c] {\n    background: #26D97A;\n}\n.status-label.Promo[data-v-5a1be77c] {\n    background: #f3904a;\n}\n.status-label.Edited[data-v-5a1be77c], .status-label.Refund[data-v-5a1be77c] {\n    background: #797979;\n}\n.status-label.No.Show[data-v-5a1be77c], .status-label.Cancelled[data-v-5a1be77c], .status-label.Declined[data-v-5a1be77c] {\n    background: #f54f4f;\n}\n.status-label.Pending.Refund[data-v-5a1be77c] {\n    background: #098769;\n    color: #fff;\n    line-height: 1.3;\n}\n.status-label.NOT_PROCESSED[data-v-5a1be77c] {\n    background: #FFCC00 !important;\n    color: #505050 !important;\n}\n.status-label.Credit.Conversion[data-v-5a1be77c] {\n    background: #29c3c3;\n}\n.status-label.Credit.Conversion.RECLAIMED[data-v-5a1be77c] {\n    background: #bbbbbb;\n}\n.table-cards[data-v-5a1be77c] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\ntable[data-v-5a1be77c] {\n    display: none;\n}\n.table-cards[data-v-5a1be77c] {\n    display: block;\n}\n.trans-card[data-v-5a1be77c] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    background-color: #fff;\n}\n.trans-card a[data-v-5a1be77c] {\n      font-weight: 900;\n}\n.trans-card .time[data-v-5a1be77c] {\n      font-size: 12px;\n      color: #777;\n}\n.trans-card .card-header[data-v-5a1be77c] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      text-transform: uppercase;\n}\n.trans-card .card-header .amount[data-v-5a1be77c] {\n        font-weight: 900;\n        font-size: 20px;\n}\n.trans-card .card-header .amount a[data-v-5a1be77c] {\n          text-decoration: none;\n}\n.trans-card .card-header .amount i[data-v-5a1be77c] {\n          font-size: 15px;\n}\n.trans-card .title[data-v-5a1be77c] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.trans-card .label[data-v-5a1be77c] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.trans-card .value[data-v-5a1be77c] {\n      margin-right: 10px;\n      font-size: 13px;\n      font-weight: 900;\n}\n}\n.switch[data-v-5a1be77c] {\n  position: relative;\n  display: inline-block;\n  height: 23px;\n}\n.switch .slider[data-v-5a1be77c] {\n    position: relative;\n    display: inline-block;\n    width: 50px;\n    height: 23px;\n    border-radius: 20px;\n    background: #ccc;\n    position: relative;\n    cursor: pointer;\n    -webkit-transition: all .25s ease-in-out;\n    transition: all .25s ease-in-out;\n}\n.switch .slider[data-v-5a1be77c]:before {\n      content: '';\n      position: absolute;\n      top: 4px;\n      left: 4px;\n      width: 15px;\n      height: 15px;\n      border-radius: 50%;\n      background: #fff;\n      -webkit-transition: all .25s ease-in-out;\n      transition: all .25s ease-in-out;\n      -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);\n}\n.switch .slider.active[data-v-5a1be77c] {\n      background: #57d1b7;\n}\n.switch .slider.active[data-v-5a1be77c]:before {\n        left: 30px;\n}\n.switch .label[data-v-5a1be77c] {\n    display: inline-block;\n    vertical-align: 10px;\n    margin-left: 5px;\n    font-size: 14px;\n    color: #555;\n    text-transform: uppercase;\n}\n.local-currency-box[data-v-5a1be77c] {\n  margin-bottom: 10px;\n  background: #fff792;\n  border: 1px solid #cdc23d;\n  padding: 5px;\n  border-radius: 5px;\n}\n.local-currency-box label[data-v-5a1be77c] {\n    font-size: 13px;\n    color: #565656;\n    margin-left: 5px;\n    font-family: 'Space Grotesk';\n    font-weight: 600;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trx-page"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading"},[_c('i',{staticClass:"fa fa-circle-notch fa-spin"}),_vm._v(" "),_c('span',[_vm._v("Getting Transactions Records...")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions.length === 0 && !_vm.loading),expression:"transactions.length === 0 && !loading"}],staticClass:"empty-state"},[_c('span',[_vm._v("No transaction records yet.")])]),_vm._v(" "),_c('table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && _vm.transactions.length > 0),expression:"!loading && transactions.length > 0"}]},[_c('thead',[_c('td',[_vm._v(_vm._s(_vm.$t('rsvpDetails.transactions.dateTime')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('rsvpDetails.transactions.invoiceId')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('rsvpDetails.transactions.card')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('rsvpDetails.transactions.finalOffer')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('rsvpDetails.transactions.chargedAmount')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('rsvpDetails.transactions.cancelFee')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('rsvpDetails.transactions.bonus')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('rsvpDetails.transactions.promoUsed')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('rsvpDetails.transactions.status')))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.transactions),function(trx){return _c('tr',[_c('td',{staticClass:"date-time"},[_vm._v(_vm._s(trx.date))]),_vm._v(" "),_c('td',{staticClass:"trx"},[(trx.trxId !== '0')?_c('span',[_vm._v(_vm._s(trx.trxId))]):_c('span',[_vm._v("--")])]),_vm._v(" "),_c('td',{staticClass:"card"},[_vm._v(_vm._s(trx.cardId))]),_vm._v(" "),_c('td',{staticClass:"fare"},[(_vm.useLocalCurrency)?_c('span',[_vm._v(_vm._s(_vm.applyCurrency(trx.fare)))]):_c('span',[_vm._v(_vm._s(trx.fare))])]),_vm._v(" "),_c('td',{staticClass:"paid"},[(_vm.useLocalCurrency)?_c('span',[_vm._v(_vm._s(_vm.applyCurrency(trx.paid)))]):_c('span',[_vm._v(_vm._s(trx.paid))])]),_vm._v(" "),_c('td',{staticClass:"cancel-fee"},[(_vm.useLocalCurrency)?_c('span',[_vm._v(_vm._s(_vm.applyCurrency(trx.cancelFee)))]):_c('span',[_vm._v(_vm._s(trx.cancelFee))])]),_vm._v(" "),_c('td',{staticClass:"bonus"},[(_vm.useLocalCurrency)?_c('span',[_vm._v(_vm._s(_vm.applyCurrency(trx.bonus)))]):_c('span',[_vm._v(_vm._s(trx.bonus))])]),_vm._v(" "),_c('td',{staticClass:"promo-used"},[(_vm.useLocalCurrency)?_c('span',[_vm._v(_vm._s(_vm.applyCurrency(trx.promoUsed)))]):_c('span',[_vm._v(_vm._s(trx.promoUsed))])]),_vm._v(" "),_c('td',{staticClass:"tbl-status"},[_c('span',{class:['status-label', trx.statusLabel, trx.notes === 'NOT_PROCESSED' ? 'NOT_PROCESSED' : '', _vm.checkReclaimed(trx)]},[_vm._v(_vm._s(_vm.relabel(trx)))])]),_vm._v(" "),_c('td',[(trx.paymentURL === null)?_c('span',[_vm._v("--")]):_c('a',{attrs:{"href":trx.paymentURL,"target":"_blank"}},[_c('i',{staticClass:"fa fa-link"})])])])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && _vm.transactions.length > 0),expression:"!loading && transactions.length > 0"}],staticClass:"table-cards"},_vm._l((_vm.transactions),function(trx,i){return _c('div',{key:i,staticClass:"trans-card"},[_c('div',{staticClass:"time"},[_vm._v("\n        "+_vm._s(trx.date)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"status"},[_c('span',{class:['status-label', trx.statusLabel, trx.notes === 'NOT_PROCESSED' ? 'NOT_PROCESSED' : '', _vm.checkReclaimed(trx)]},[_vm._v(_vm._s(_vm.relabel(trx)))])]),_vm._v(" "),_c('div',{staticClass:"amount"},[(trx.paymentURL === null)?_c('span',[_vm._v(_vm._s(trx.paid))]):_c('a',{attrs:{"href":trx.paymentURL,"target":"_blank"}},[_vm._v(_vm._s(trx.paid)+" "),_c('i',{staticClass:"fa fa-link"})])])]),_vm._v(" "),(trx.trxId !== '0')?_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Invoice ID: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(trx.trxId))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Card:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(trx.cardId))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Charged Amount:")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.useLocalCurrency)?_c('span',[_vm._v(_vm._s(_vm.applyCurrency(trx.paid)))]):_c('span',[_vm._v(_vm._s(trx.paid))])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Cancel Fee:")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.useLocalCurrency)?_c('span',[_vm._v(_vm._s(_vm.applyCurrency(trx.cancelFee)))]):_c('span',[_vm._v(_vm._s(trx.cancelFee))])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Bonus:")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.useLocalCurrency)?_c('span',[_vm._v(_vm._s(_vm.applyCurrency(trx.bonus)))]):_c('span',[_vm._v(_vm._s(trx.bonus))])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Promo Used:")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.useLocalCurrency)?_c('span',[_vm._v(_vm._s(_vm.applyCurrency(trx.promoUsed)))]):_c('span',[_vm._v(_vm._s(trx.promoUsed))])])])])}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('i',{staticClass:"stripe-icon fab fa-stripe-s"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemLogs_vue__ = __webpack_require__(611);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11315206_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemLogs_vue__ = __webpack_require__(1808);
function injectStyle (ssrContext) {
  __webpack_require__(1806)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11315206"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemLogs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11315206_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemLogs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1807);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("6159f68d", content, true, {});

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.empty-state[data-v-11315206] {\n  padding: 30px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\n.empty-state .fa[data-v-11315206] {\n    display: block;\n    margin-bottom: 5px;\n    color: #ccc;\n    text-shadow: 0 0 5px white;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/RsvpDetails/SystemLogs.vue"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;CAC9B","file":"SystemLogs.vue","sourcesContent":["\n.empty-state[data-v-11315206] {\n  padding: 30px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\n.empty-state .fa[data-v-11315206] {\n    display: block;\n    margin-bottom: 5px;\n    color: #ccc;\n    text-shadow: 0 0 5px white;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"empty-state"},[_c('i',{staticClass:"fa fa-address-book fa-4x"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('rsvpDetails.systemLogs.emptyState')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchLogs_vue__ = __webpack_require__(612);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbc2d324_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchLogs_vue__ = __webpack_require__(1812);
function injectStyle (ssrContext) {
  __webpack_require__(1810)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dbc2d324"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchLogs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbc2d324_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchLogs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1811);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("75792fc0", content, true, {});

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.empty-state[data-v-dbc2d324] {\n  padding: 30px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\n.empty-state .fa[data-v-dbc2d324] {\n    display: block;\n    margin-bottom: 5px;\n    color: #ccc;\n    text-shadow: 0 0 5px white;\n}\n.log[data-v-dbc2d324] {\n  border: 1px solid #ddd;\n  width: 100%;\n  max-height: auto;\n  padding: 10px;\n  background: #fafafa;\n  overflow: hidden;\n  margin-bottom: 10px;\n}\n.log .list[data-v-dbc2d324] {\n    font-size: 11px;\n    color: #666;\n}\n.log .list .message[data-v-dbc2d324] {\n      font-weight: bold;\n}\n.log .list .status[data-v-dbc2d324] {\n      text-transform: capitalize;\n      font-style: italic;\n}\n.log .list .driver-detail[data-v-dbc2d324] {\n      margin-top: 15px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/RsvpDetails/DispatchLogs.vue"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;CAC9B;AACD;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;CACrB;AACD;IACI,gBAAgB;IAChB,YAAY;CACf;AACD;MACM,kBAAkB;CACvB;AACD;MACM,2BAA2B;MAC3B,mBAAmB;CACxB;AACD;MACM,iBAAiB;CACtB","file":"DispatchLogs.vue","sourcesContent":["\n.empty-state[data-v-dbc2d324] {\n  padding: 30px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\n.empty-state .fa[data-v-dbc2d324] {\n    display: block;\n    margin-bottom: 5px;\n    color: #ccc;\n    text-shadow: 0 0 5px white;\n}\n.log[data-v-dbc2d324] {\n  border: 1px solid #ddd;\n  width: 100%;\n  max-height: auto;\n  padding: 10px;\n  background: #fafafa;\n  overflow: hidden;\n  margin-bottom: 10px;\n}\n.log .list[data-v-dbc2d324] {\n    font-size: 11px;\n    color: #666;\n}\n.log .list .message[data-v-dbc2d324] {\n      font-weight: bold;\n}\n.log .list .status[data-v-dbc2d324] {\n      text-transform: capitalize;\n      font-style: italic;\n}\n.log .list .driver-detail[data-v-dbc2d324] {\n      margin-top: 15px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dispatches.length === 0),expression:"dispatches.length === 0"}],staticClass:"empty-state"},[_c('i',{staticClass:"fa fa-address-book fa-4x"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('rsvpDetails.dispatchLogs.emptyState')))])]),_vm._v(" "),_vm._l((_vm.dispatches),function(log,i){return _c('div',{key:i,staticClass:"log"},[_c('div',{staticClass:"list"},[_c('div',{staticClass:"date"},[_vm._v(_vm._s(log.created))]),_vm._v(" "),_c('div',{staticClass:"message"},[_c('span',{staticClass:"status"},[_vm._v("("+_vm._s(log.status)+") ")]),_vm._v(_vm._s(log.message))]),_vm._v(" "),_c('div',{staticClass:"driver-detail"},[_c('div',{staticClass:"id"},[_vm._v("Driver ID: "),_c('b',[_c('a',{attrs:{"href":'/#/provider/' + log.driver.id,"target":"_blank"}},[_vm._v(_vm._s(log.driver.id))])])]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("Driver Name: "),_c('b',[_vm._v(_vm._s(log.driver.firstName)+" "+_vm._s(log.driver.lastName))])]),_vm._v(" "),_c('div',{staticClass:"email"},[_vm._v("Driver Email: "),_c('b',[_vm._v(_vm._s(log.driver.email))])])])])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notes_vue__ = __webpack_require__(613);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4007d8ea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notes_vue__ = __webpack_require__(1816);
function injectStyle (ssrContext) {
  __webpack_require__(1814)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4007d8ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4007d8ea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1815);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("567ee2f1", content, true, {});

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.loading[data-v-4007d8ea] {\n  text-align: center;\n  padding: 30px;\n  font-size: 18px;\n}\n.loading .fa[data-v-4007d8ea] {\n    margin-right: 5px;\n    color: #555;\n}\n.loading span[data-v-4007d8ea] {\n    color: #888;\n}\n.empty-state[data-v-4007d8ea] {\n  padding: 30px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\n.empty-state .fa[data-v-4007d8ea] {\n    display: block;\n    margin-bottom: 5px;\n    color: #ddd;\n}\n.note[data-v-4007d8ea] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 10px 20px;\n  position: relative;\n}\n.user[data-v-4007d8ea] {\n  text-align: center;\n  width: 170px;\n  padding: 0 10px;\n  display: inline-block;\n  vertical-align: top;\n  position: relative;\n  z-index: 1;\n}\n.user .img-holder[data-v-4007d8ea] {\n    width: 75px;\n    height: 75px;\n    border-radius: 100%;\n    overflow: hidden;\n    display: inline-block;\n}\n.user span[data-v-4007d8ea] {\n    display: block;\n}\n.user .name[data-v-4007d8ea] {\n    font-weight: 600;\n    font-size: 14px;\n    color: #555;\n}\n.user .date[data-v-4007d8ea] {\n    font-size: 11px;\n    color: #999;\n}\n.note-content[data-v-4007d8ea] {\n  background: #f5f5f5;\n  padding: 15px;\n  display: inline-block;\n  width: calc(100% - 170px);\n  /*min-height: 100px;*/\n  position: relative;\n  z-index: 2;\n  border-radius: 2px;\n  -webkit-box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);\n}\n.note-content .arrow[data-v-4007d8ea] {\n    position: absolute;\n    z-index: 2;\n    top: 30px;\n    right: 100%;\n    margin-right: -20px;\n    width: 20px;\n    height: 20px;\n    background: #f5f5f5;\n    -webkit-box-shadow: -2px 2px 1px rgba(0, 0, 0, 0.15);\n            box-shadow: -2px 2px 1px rgba(0, 0, 0, 0.15);\n    -webkit-transform: translate(-50%, 0) rotate(45deg);\n            transform: translate(-50%, 0) rotate(45deg);\n}\n.note-content .status[data-v-4007d8ea] {\n    font-size: 10px;\n    font-weight: 600;\n    padding: 2px 7px;\n    color: #fff;\n    text-transform: uppercase;\n    border-radius: 4px;\n    font-style: italic;\n    float: left;\n}\n.note-content .status.resolved[data-v-4007d8ea] {\n      background: #26D97A;\n}\n.note-content .status.investigation[data-v-4007d8ea] {\n      background: #F25E0D;\n}\n.note-content .status.new[data-v-4007d8ea] {\n      background: #F20D0D;\n}\n.note-content p[data-v-4007d8ea] {\n    position: relative;\n    z-index: 3;\n    font-size: 13px;\n    margin: 0;\n    color: #555;\n    min-height: 60px;\n    word-wrap: break-word;\n}\n.note-content .actions[data-v-4007d8ea] {\n    text-align: right;\n    font-size: 12px;\n    margin-top: 10px;\n    font-weight: 600;\n}\n.note-content .actions span[data-v-4007d8ea] {\n      color: #0D79F2;\n      display: inline-block;\n      margin: 0 2px;\n      cursor: pointer;\n}\n.delete-block[data-v-4007d8ea] {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  width: 100%;\n  height: 0%;\n  visibility: hidden;\n  z-index: 2;\n  text-align: center;\n  overflow: hidden;\n  -webkit-transition: background .2s, height .2s, top .2s;\n  transition: background .2s, height .2s, top .2s;\n}\n.delete-block .content[data-v-4007d8ea] {\n    display: none;\n}\n.delete-block .content p[data-v-4007d8ea] {\n      color: #fff;\n      font-weight: 600;\n}\n.delete-block .content p span[data-v-4007d8ea] {\n        color: #ff1b1b;\n        font-style: italic;\n}\n.delete-block .content .button[data-v-4007d8ea] {\n      min-width: 100px;\n      margin: 0 5px;\n      display: inline-block;\n}\n.delete-block .content.disabled .button[data-v-4007d8ea] {\n      opacity: .5;\n      cursor: default;\n      font-weight: 100;\n      color: #f00;\n}\n.delete-block.show[data-v-4007d8ea] {\n    visibility: visible;\n    background: rgba(0, 0, 0, 0.8);\n    height: 100%;\n    top: 0;\n}\n.delete-block.show .content[data-v-4007d8ea] {\n      display: block;\n}\n.note-mobile[data-v-4007d8ea] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.note[data-v-4007d8ea] {\n    display: none;\n}\n.note-mobile[data-v-4007d8ea] {\n    display: block;\n    padding: 8px 15px;\n    position: relative;\n}\n.note-mobile .note-content[data-v-4007d8ea] {\n      width: 100%;\n}\n.note-mobile .note-content .user[data-v-4007d8ea] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        width: 100%;\n        padding: 0;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        gap: 5px;\n        margin-bottom: 5px;\n}\n.note-mobile .note-content .user .img-holder[data-v-4007d8ea] {\n          width: 50px;\n          height: 50px;\n}\n.note-mobile .note-content .user .details[data-v-4007d8ea] {\n          text-align: left;\n}\n.note-mobile .note-content .actions[data-v-4007d8ea] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/RsvpDetails/Notes.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;CACjB;AACD;IACI,kBAAkB;IAClB,YAAY;CACf;AACD;IACI,YAAY;CACf;AACD;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;CACf;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;CACZ;AACD;IACI,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;CACzB;AACD;IACI,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;IACI,gBAAgB;IAChB,YAAY;CACf;AACD;EACE,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;CACpD;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,oBAAoB;IACpB,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,qDAAqD;YAC7C,6CAA6C;IACrD,oDAAoD;YAC5C,4CAA4C;CACvD;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;CACf;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;CACzB;AACD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;CACpB;AACD;MACM,eAAe;MACf,sBAAsB;MACtB,cAAc;MACd,gBAAgB;CACrB;AACD;EACE,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,wDAAwD;EACxD,gDAAgD;CACjD;AACD;IACI,cAAc;CACjB;AACD;MACM,YAAY;MACZ,iBAAiB;CACtB;AACD;QACQ,eAAe;QACf,mBAAmB;CAC1B;AACD;MACM,iBAAiB;MACjB,cAAc;MACd,sBAAsB;CAC3B;AACD;MACM,YAAY;MACZ,gBAAgB;MAChB,iBAAiB;MACjB,YAAY;CACjB;AACD;IACI,oBAAoB;IACpB,+BAA+B;IAC/B,aAAa;IACb,OAAO;CACV;AACD;MACM,eAAe;CACpB;AACD;EACE,cAAc;CACf;AACD;AACA;IACI,cAAc;CACjB;AACD;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,YAAY;CACjB;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,YAAY;QACZ,WAAW;QACX,0BAA0B;YACtB,uBAAuB;gBACnB,oBAAoB;QAC5B,SAAS;QACT,mBAAmB;CAC1B;AACD;UACU,YAAY;UACZ,aAAa;CACtB;AACD;UACU,iBAAiB;CAC1B;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,+BAA+B;CAC9C;CACA","file":"Notes.vue","sourcesContent":["\n.loading[data-v-4007d8ea] {\n  text-align: center;\n  padding: 30px;\n  font-size: 18px;\n}\n.loading .fa[data-v-4007d8ea] {\n    margin-right: 5px;\n    color: #555;\n}\n.loading span[data-v-4007d8ea] {\n    color: #888;\n}\n.empty-state[data-v-4007d8ea] {\n  padding: 30px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\n.empty-state .fa[data-v-4007d8ea] {\n    display: block;\n    margin-bottom: 5px;\n    color: #ddd;\n}\n.note[data-v-4007d8ea] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 10px 20px;\n  position: relative;\n}\n.user[data-v-4007d8ea] {\n  text-align: center;\n  width: 170px;\n  padding: 0 10px;\n  display: inline-block;\n  vertical-align: top;\n  position: relative;\n  z-index: 1;\n}\n.user .img-holder[data-v-4007d8ea] {\n    width: 75px;\n    height: 75px;\n    border-radius: 100%;\n    overflow: hidden;\n    display: inline-block;\n}\n.user span[data-v-4007d8ea] {\n    display: block;\n}\n.user .name[data-v-4007d8ea] {\n    font-weight: 600;\n    font-size: 14px;\n    color: #555;\n}\n.user .date[data-v-4007d8ea] {\n    font-size: 11px;\n    color: #999;\n}\n.note-content[data-v-4007d8ea] {\n  background: #f5f5f5;\n  padding: 15px;\n  display: inline-block;\n  width: calc(100% - 170px);\n  /*min-height: 100px;*/\n  position: relative;\n  z-index: 2;\n  border-radius: 2px;\n  -webkit-box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);\n}\n.note-content .arrow[data-v-4007d8ea] {\n    position: absolute;\n    z-index: 2;\n    top: 30px;\n    right: 100%;\n    margin-right: -20px;\n    width: 20px;\n    height: 20px;\n    background: #f5f5f5;\n    -webkit-box-shadow: -2px 2px 1px rgba(0, 0, 0, 0.15);\n            box-shadow: -2px 2px 1px rgba(0, 0, 0, 0.15);\n    -webkit-transform: translate(-50%, 0) rotate(45deg);\n            transform: translate(-50%, 0) rotate(45deg);\n}\n.note-content .status[data-v-4007d8ea] {\n    font-size: 10px;\n    font-weight: 600;\n    padding: 2px 7px;\n    color: #fff;\n    text-transform: uppercase;\n    border-radius: 4px;\n    font-style: italic;\n    float: left;\n}\n.note-content .status.resolved[data-v-4007d8ea] {\n      background: #26D97A;\n}\n.note-content .status.investigation[data-v-4007d8ea] {\n      background: #F25E0D;\n}\n.note-content .status.new[data-v-4007d8ea] {\n      background: #F20D0D;\n}\n.note-content p[data-v-4007d8ea] {\n    position: relative;\n    z-index: 3;\n    font-size: 13px;\n    margin: 0;\n    color: #555;\n    min-height: 60px;\n    word-wrap: break-word;\n}\n.note-content .actions[data-v-4007d8ea] {\n    text-align: right;\n    font-size: 12px;\n    margin-top: 10px;\n    font-weight: 600;\n}\n.note-content .actions span[data-v-4007d8ea] {\n      color: #0D79F2;\n      display: inline-block;\n      margin: 0 2px;\n      cursor: pointer;\n}\n.delete-block[data-v-4007d8ea] {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  width: 100%;\n  height: 0%;\n  visibility: hidden;\n  z-index: 2;\n  text-align: center;\n  overflow: hidden;\n  -webkit-transition: background .2s, height .2s, top .2s;\n  transition: background .2s, height .2s, top .2s;\n}\n.delete-block .content[data-v-4007d8ea] {\n    display: none;\n}\n.delete-block .content p[data-v-4007d8ea] {\n      color: #fff;\n      font-weight: 600;\n}\n.delete-block .content p span[data-v-4007d8ea] {\n        color: #ff1b1b;\n        font-style: italic;\n}\n.delete-block .content .button[data-v-4007d8ea] {\n      min-width: 100px;\n      margin: 0 5px;\n      display: inline-block;\n}\n.delete-block .content.disabled .button[data-v-4007d8ea] {\n      opacity: .5;\n      cursor: default;\n      font-weight: 100;\n      color: #f00;\n}\n.delete-block.show[data-v-4007d8ea] {\n    visibility: visible;\n    background: rgba(0, 0, 0, 0.8);\n    height: 100%;\n    top: 0;\n}\n.delete-block.show .content[data-v-4007d8ea] {\n      display: block;\n}\n.note-mobile[data-v-4007d8ea] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.note[data-v-4007d8ea] {\n    display: none;\n}\n.note-mobile[data-v-4007d8ea] {\n    display: block;\n    padding: 8px 15px;\n    position: relative;\n}\n.note-mobile .note-content[data-v-4007d8ea] {\n      width: 100%;\n}\n.note-mobile .note-content .user[data-v-4007d8ea] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        width: 100%;\n        padding: 0;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        gap: 5px;\n        margin-bottom: 5px;\n}\n.note-mobile .note-content .user .img-holder[data-v-4007d8ea] {\n          width: 50px;\n          height: 50px;\n}\n.note-mobile .note-content .user .details[data-v-4007d8ea] {\n          text-align: left;\n}\n.note-mobile .note-content .actions[data-v-4007d8ea] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading"},[_c('i',{staticClass:"fa fa-circle-notch fa-spin"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('rsvpDetails.notes.loading')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.notes.length === 0 && !_vm.loading),expression:"notes.length === 0 && !loading"}],staticClass:"empty-state"},[_c('i',{staticClass:"fa fa-address-card fa-4x"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('rsvpDetails.notes.emptyState')))])]),_vm._v(" "),_vm._l((_vm.notes),function(note){return _c('div',{staticClass:"note"},[_c('div',{staticClass:"user"},[_c('div',{staticClass:"img-holder"},[_c('img',{attrs:{"src":note.picture}})]),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(note.name))]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v(_vm._s(note.date))])]),_vm._v(" "),_c('div',{staticClass:"note-content"},[_c('div',{staticClass:"arrow"}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(note.message)}}),_vm._v(" "),_c('div',{staticClass:"actions"},[(_vm.adminId === note.userId)?_c('div',[_c('span',{on:{"click":function($event){return _vm.editNote(note)}}},[_vm._v(_vm._s(_vm.$t('rsvpDetails.notes.edit')))]),_vm._v(" |\n          "),_c('span',{on:{"click":function($event){return _vm.deleteNote(note)}}},[_vm._v(_vm._s(_vm.$t('rsvpDetails.notes.delete')))])]):_vm._e(),_vm._v(" "),_c('label',{class:['status', note.status]},[_vm._v(_vm._s(note.status))])])]),_vm._v(" "),_c('div',{class:{'delete-block':true, 'show':_vm.noteDeleteId === note.id}},[_c('div',{class:{'content':true, 'disabled':_vm.deleteLoading}},[_c('p',[_vm._v("\n          "+_vm._s(_vm.$t('rsvpDetails.notes.deleteMessage'))+"\n          "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.deleteMessage),expression:"!!deleteMessage"}]},[_c('br'),_vm._v(" "+_vm._s(_vm.deleteMessage)+"\n          ")])]),_vm._v(" "),_c('a',{staticClass:"button cta warning small",on:{"click":_vm.hideDelete}},[_vm._v(_vm._s(_vm.$t('rsvpDetails.notes.no')))]),_vm._v(" "),_c('a',{staticClass:"button cta success small",on:{"click":function($event){return _vm.deleteConfirm(note.id)}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.deleteLoading),expression:"!deleteLoading"}]},[_vm._v(_vm._s(_vm.$t('rsvpDetails.notes.yes')))]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.deleteLoading),expression:"deleteLoading"}],staticClass:"fa fa-spinner fa-spin fa-fw"})])])])])}),_vm._v(" "),_vm._l((_vm.notes),function(note){return _c('div',{staticClass:"note-mobile"},[_c('div',{staticClass:"note-content"},[_c('div',{staticClass:"user"},[_c('div',{staticClass:"img-holder"},[_c('img',{attrs:{"src":note.picture}})]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(note.name))]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v(_vm._s(note.date))])])]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(note.message)}}),_vm._v(" "),_c('div',{staticClass:"actions"},[(_vm.adminId === note.userId)?_c('div',[_c('span',{on:{"click":function($event){return _vm.editNote(note)}}},[_vm._v(_vm._s(_vm.$t('rsvpDetails.notes.edit')))]),_vm._v(" |\n          "),_c('span',{on:{"click":function($event){return _vm.deleteNote(note)}}},[_vm._v(_vm._s(_vm.$t('rsvpDetails.notes.delete')))])]):_vm._e(),_vm._v(" "),_c('label',{class:['status', note.status]},[_vm._v(_vm._s(note.status))])])]),_vm._v(" "),_c('div',{class:{'delete-block':true, 'show':_vm.noteDeleteId === note.id}},[_c('div',{class:{'content':true, 'disabled':_vm.deleteLoading}},[_c('p',[_vm._v("\n          "+_vm._s(_vm.$t('rsvpDetails.notes.deleteMessage'))+"\n          "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.deleteMessage),expression:"!!deleteMessage"}]},[_c('br'),_vm._v(" "+_vm._s(_vm.deleteMessage)+"\n          ")])]),_vm._v(" "),_c('a',{staticClass:"button cta warning small",on:{"click":_vm.hideDelete}},[_vm._v(_vm._s(_vm.$t('rsvpDetails.notes.no')))]),_vm._v(" "),_c('a',{staticClass:"button cta success small",on:{"click":function($event){return _vm.deleteConfirm(note.id)}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.deleteLoading),expression:"!deleteLoading"}]},[_vm._v(_vm._s(_vm.$t('rsvpDetails.notes.yes')))]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.deleteLoading),expression:"deleteLoading"}],staticClass:"fa fa-spinner fa-spin fa-fw"})])])])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionLogs_vue__ = __webpack_require__(615);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d370083_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionLogs_vue__ = __webpack_require__(1823);
function injectStyle (ssrContext) {
  __webpack_require__(1818)
  __webpack_require__(1820)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d370083"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionLogs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d370083_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionLogs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1819);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5a83662c", content, true, {});

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.empty-state[data-v-1d370083] {\n  padding: 30px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\n.empty-state .fa[data-v-1d370083] {\n    display: block;\n    margin-bottom: 5px;\n    color: #ccc;\n    text-shadow: 0 0 5px white;\n}\n.action[data-v-1d370083] {\n  border: 1px solid #ddd;\n  width: 100%;\n  max-height: auto;\n  padding: 10px;\n  background: #fafafa;\n  overflow: hidden;\n  -webkit-transition: all .35s ease-in-out;\n  transition: all .35s ease-in-out;\n  cursor: pointer;\n  margin-bottom: 10px;\n}\n.action[data-v-1d370083]:hover {\n    background: #fff8dc;\n}\n.action.collapsed[data-v-1d370083] {\n    padding: 10px;\n    background: #fff8dc;\n}\n.action .action-item[data-v-1d370083] {\n    padding-left: 15px;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.action .action-item .icon-display[data-v-1d370083] {\n      float: left;\n      width: 5%;\n}\n.action .action-item .icon-display i[data-v-1d370083] {\n        font-size: 11px;\n        color: #666;\n}\n.action .action-item .icon-display.hide-icon i[data-v-1d370083] {\n        color: #fafafa;\n}\n.action .action-item .action-display[data-v-1d370083] {\n      float: left;\n      width: 95%;\n}\n.action .action-item .action-display p[data-v-1d370083] {\n        margin: 0;\n}\n.action .action-item .log-details[data-v-1d370083] {\n      font-size: 11px;\n      color: #666;\n}\n.action .action-item .log-details[data-v-1d370083] br {\n        content: 'a';\n        display: block;\n        margin-bottom: 15px;\n}\n.action .action-item .log-details[data-v-1d370083] i.float-mt {\n        float: left;\n        clear: both;\n        margin: 10px 0;\n        line-height: 1.25;\n        letter-spacing: .3px;\n}\n.action .minimize[data-v-1d370083] {\n    font-size: 11px;\n    color: #666;\n    content: \"\";\n    clear: both;\n}\n.action .minimize .icon-display[data-v-1d370083] {\n      float: left;\n      width: 5%;\n}\n.action .minimize .icon-display i[data-v-1d370083] {\n        font-size: 11px;\n        color: #666;\n}\n.action .minimize .icon-display.hide-icon i[data-v-1d370083] {\n        color: #fafafa;\n}\n.action .minimize .action-display[data-v-1d370083] {\n      float: left;\n      width: 95%;\n}\n.action .minimize .action-display p[data-v-1d370083] {\n        margin: 0;\n}\n.action .field[data-v-1d370083] {\n    font-size: 12px;\n    padding: 4px 0 4px 10px;\n}\n.action .field span[data-v-1d370083] {\n      display: inline-block;\n}\n.action .field .label[data-v-1d370083] {\n      font-weight: 600;\n      margin-right: 10px;\n      color: #28b560;\n      display: block;\n}\n.action .field i[data-v-1d370083] {\n      margin: 0 5px;\n      color: #0D79F2;\n}\n.action .field .old[data-v-1d370083] {\n      color: #d0d0d0;\n}\n.action .field .old.last[data-v-1d370083] {\n        display: none;\n}\n.action .field .new[data-v-1d370083] {\n      color: #555;\n      font-weight: 600;\n}\n.action .field.no-arrow i[data-v-1d370083] {\n      display: none;\n}\n.action .field.no-arrow .new[data-v-1d370083] {\n      display: block;\n}\n.action .field.no-arrow .old.first[data-v-1d370083] {\n      display: none;\n}\n.action .field.no-arrow .old.last[data-v-1d370083] {\n      display: block;\n      font-size: 12px;\n}\n.slide-down-enter-active[data-v-1d370083], .slide-down-leave-active[data-v-1d370083] {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.slide-down-enter[data-v-1d370083], .slide-down-leave-to[data-v-1d370083] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/RsvpDetails/ActionLogs.vue"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;CAC9B;AACD;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,yCAAyC;EACzC,iCAAiC;EACjC,gBAAgB;EAChB,oBAAoB;CACrB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,cAAc;IACd,oBAAoB;CACvB;AACD;IACI,mBAAmB;IACnB,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;MACM,YAAY;MACZ,UAAU;CACf;AACD;QACQ,gBAAgB;QAChB,YAAY;CACnB;AACD;QACQ,eAAe;CACtB;AACD;MACM,YAAY;MACZ,WAAW;CAChB;AACD;QACQ,UAAU;CACjB;AACD;MACM,gBAAgB;MAChB,YAAY;CACjB;AACD;QACQ,aAAa;QACb,eAAe;QACf,oBAAoB;CAC3B;AACD;QACQ,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,qBAAqB;CAC5B;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,YAAY;CACf;AACD;MACM,YAAY;MACZ,UAAU;CACf;AACD;QACQ,gBAAgB;QAChB,YAAY;CACnB;AACD;QACQ,eAAe;CACtB;AACD;MACM,YAAY;MACZ,WAAW;CAChB;AACD;QACQ,UAAU;CACjB;AACD;IACI,gBAAgB;IAChB,wBAAwB;CAC3B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;MACjB,mBAAmB;MACnB,eAAe;MACf,eAAe;CACpB;AACD;MACM,cAAc;MACd,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;QACQ,cAAc;CACrB;AACD;MACM,YAAY;MACZ,iBAAiB;CACtB;AACD;MACM,cAAc;CACnB;AACD;MACM,eAAe;CACpB;AACD;MACM,cAAc;CACnB;AACD;MACM,eAAe;MACf,gBAAgB;CACrB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ","file":"ActionLogs.vue","sourcesContent":["\n.empty-state[data-v-1d370083] {\n  padding: 30px;\n  font-size: 18px;\n  color: #999;\n  text-align: center;\n}\n.empty-state .fa[data-v-1d370083] {\n    display: block;\n    margin-bottom: 5px;\n    color: #ccc;\n    text-shadow: 0 0 5px white;\n}\n.action[data-v-1d370083] {\n  border: 1px solid #ddd;\n  width: 100%;\n  max-height: auto;\n  padding: 10px;\n  background: #fafafa;\n  overflow: hidden;\n  -webkit-transition: all .35s ease-in-out;\n  transition: all .35s ease-in-out;\n  cursor: pointer;\n  margin-bottom: 10px;\n}\n.action[data-v-1d370083]:hover {\n    background: #fff8dc;\n}\n.action.collapsed[data-v-1d370083] {\n    padding: 10px;\n    background: #fff8dc;\n}\n.action .action-item[data-v-1d370083] {\n    padding-left: 15px;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.action .action-item .icon-display[data-v-1d370083] {\n      float: left;\n      width: 5%;\n}\n.action .action-item .icon-display i[data-v-1d370083] {\n        font-size: 11px;\n        color: #666;\n}\n.action .action-item .icon-display.hide-icon i[data-v-1d370083] {\n        color: #fafafa;\n}\n.action .action-item .action-display[data-v-1d370083] {\n      float: left;\n      width: 95%;\n}\n.action .action-item .action-display p[data-v-1d370083] {\n        margin: 0;\n}\n.action .action-item .log-details[data-v-1d370083] {\n      font-size: 11px;\n      color: #666;\n}\n.action .action-item .log-details[data-v-1d370083] br {\n        content: 'a';\n        display: block;\n        margin-bottom: 15px;\n}\n.action .action-item .log-details[data-v-1d370083] i.float-mt {\n        float: left;\n        clear: both;\n        margin: 10px 0;\n        line-height: 1.25;\n        letter-spacing: .3px;\n}\n.action .minimize[data-v-1d370083] {\n    font-size: 11px;\n    color: #666;\n    content: \"\";\n    clear: both;\n}\n.action .minimize .icon-display[data-v-1d370083] {\n      float: left;\n      width: 5%;\n}\n.action .minimize .icon-display i[data-v-1d370083] {\n        font-size: 11px;\n        color: #666;\n}\n.action .minimize .icon-display.hide-icon i[data-v-1d370083] {\n        color: #fafafa;\n}\n.action .minimize .action-display[data-v-1d370083] {\n      float: left;\n      width: 95%;\n}\n.action .minimize .action-display p[data-v-1d370083] {\n        margin: 0;\n}\n.action .field[data-v-1d370083] {\n    font-size: 12px;\n    padding: 4px 0 4px 10px;\n}\n.action .field span[data-v-1d370083] {\n      display: inline-block;\n}\n.action .field .label[data-v-1d370083] {\n      font-weight: 600;\n      margin-right: 10px;\n      color: #28b560;\n      display: block;\n}\n.action .field i[data-v-1d370083] {\n      margin: 0 5px;\n      color: #0D79F2;\n}\n.action .field .old[data-v-1d370083] {\n      color: #d0d0d0;\n}\n.action .field .old.last[data-v-1d370083] {\n        display: none;\n}\n.action .field .new[data-v-1d370083] {\n      color: #555;\n      font-weight: 600;\n}\n.action .field.no-arrow i[data-v-1d370083] {\n      display: none;\n}\n.action .field.no-arrow .new[data-v-1d370083] {\n      display: block;\n}\n.action .field.no-arrow .old.first[data-v-1d370083] {\n      display: none;\n}\n.action .field.no-arrow .old.last[data-v-1d370083] {\n      display: block;\n      font-size: 12px;\n}\n.slide-down-enter-active[data-v-1d370083], .slide-down-leave-active[data-v-1d370083] {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.slide-down-enter[data-v-1d370083], .slide-down-leave-to[data-v-1d370083] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1821);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("77975466", content, true, {});

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.__service-label {\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 12px;\n  display: inline-block;\n  margin-top: 2px;\n  text-transform: capitalize;\n}\n.__service-label.shared {\n    background: #f38d56;\n}\n.__service-label.opoli {\n    background: #26D97A;\n}\n.__service-label.black {\n    background: #777;\n}\n.__service-label.SUV, .__service-label.suv {\n    background: #dc3168;\n}\n.__service-label.shuttle {\n    background: #6dabc3;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/RsvpDetails/ActionLogs.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;CAC5B;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB","file":"ActionLogs.vue","sourcesContent":["\n.__service-label {\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 12px;\n  display: inline-block;\n  margin-top: 2px;\n  text-transform: capitalize;\n}\n.__service-label.shared {\n    background: #f38d56;\n}\n.__service-label.opoli {\n    background: #26D97A;\n}\n.__service-label.black {\n    background: #777;\n}\n.__service-label.SUV, .__service-label.suv {\n    background: #dc3168;\n}\n.__service-label.shuttle {\n    background: #6dabc3;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__featureToggle__ = __webpack_require__(5);




/* harmony default export */ __webpack_exports__["a"] = ({
  getActionLogs: function getActionLogs(VueApp, rsvpId, callback) {
    VueApp.$sdk.get('/admin/rsvp/' + rsvpId + '/logs', {
      token: VueApp.$store.state.session.sessionToken,
      order: 'created',
      orderAsc: 1
    }, function (res) {
      if (!res.error) {
        var actions = [];
        var basicInfo = {};
        res.list.forEach(function (data) {
          basicInfo = {
            id: data.id,
            action: data.action,
            created: __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.created, 'X').tz('America/Los_Angeles').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_2__featureToggle__["a" /* default */].timeFormat(VueApp, true)),
            admin: data.admin ? {
              name: data.admin.firstName + ' ' + data.admin.lastName,
              id: data.admin.id,
              email: data.admin.email,
              phone: data.admin.phone
            } : null,
            consumer: data.contact && data.contact.type === 'consumer' ? {
              name: data.contact.firstName + ' ' + data.contact.lastName,
              id: data.contact.ID,
              email: data.contact.email,
              phone: data.contact.phone
            } : null,
            provider: data.contact && data.contact.type === 'provider' ? {
              name: data.contact.firstName + ' ' + data.contact.lastName,
              id: data.contact.ID,
              email: data.contact.email,
              phone: data.contact.phone
            } : null,
            recipient: data.details.driver ? {
              id: data.details.driver.ID,
              name: data.details.driver.firstName + ' ' + data.details.driver.lastName,
              email: data.details.driver.email,
              phone: data.details.driver.phone
            } : null,
            details: data.details,
            collapsed: false
          };
          if (data.action === 'release_driver') {
            basicInfo.opted = data.details.params.charge == 1 ? true : false;
          }
          switch (data.action) {
            default:
              actions.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, basicInfo));
              break;
            case 'edit_rsvp':
              var fields = [];
              data.details.changes.forEach(function (data2) {
                fields.push({
                  field: data2.field,
                  old: data2.old,
                  new: data2.new
                });
              });

              // Combine Flight Info
              // let pickupFlightNoIndex = fields.findIndex(x => x.field === 'flightNumber')
              // let pickupAirlineIndex = fields.findIndex(x => x.field === 'flightName')
              // if (pickupFlightNoIndex > -1 && pickupAirlineIndex > -1) {
              //   fields.push({
              //     field: 'Flight Information',
              //     old: fields[pickupAirlineIndex].old + ' ' + fields[pickupFlightNoIndex].old,
              //     new: fields[pickupAirlineIndex].new + ' ' + fields[pickupFlightNoIndex].new
              //   })
              // }
              // let dropoffFlightNoIndex = fields.findIndex(x => x.field === 'dropoffFlightNumber')
              // let dropoffAirlineIndex = fields.findIndex(x => x.field === 'dropoffFlightName')
              // if (dropoffFlightNoIndex > -1 && dropoffAirlineIndex > -1) {
              //   fields.push({
              //     field: 'Flight Information',
              //     old: fields[dropoffFlightNoIndex].old + ' ' + fields[dropoffAirlineIndex].old,
              //     new: fields[dropoffFlightNoIndex].new + ' ' + fields[dropoffAirlineIndex].new
              //   })
              // }

              var pickupNumber = fields.findIndex(function (x) {
                return x.field === 'flightNumber';
              });
              var pickupAirline = fields.findIndex(function (x) {
                return x.field === 'flightName';
              });
              var dropoffNumber = fields.findIndex(function (x) {
                return x.field === 'dropoffFlightNumber';
              });
              var dropoffAirline = fields.findIndex(function (x) {
                return x.field === 'dropoffFlightName';
              });

              var swapPosition = function swapPosition(arr, indexA, indexB) {
                var temp = arr[indexA];
                arr[indexA] = arr[indexB];
                arr[indexB] = temp;
              };

              if (pickupNumber !== -1 && pickupAirline !== -1) {
                swapPosition(fields, pickupNumber, pickupAirline);
              }
              if (dropoffAirline !== -1 && dropoffNumber !== -1) {
                swapPosition(fields, dropoffNumber, dropoffAirline);
              }

              if (data.details.params.freeChange) {
                fields.unshift({
                  field: 'waive_payment',
                  old: false,
                  new: true
                });
              }

              actions.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, basicInfo, {
                fields: fields
              }));
              break;
          }
        });

        VueApp.$store.commit('rsvpDetails/setAction', actions);
      }
      callback(res);
    });
  }
});

/***/ }),
/* 1823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.actions.length === 0),expression:"actions.length === 0"}],staticClass:"empty-state"},[_c('i',{staticClass:"fa fa-clipboard-list fa-4x"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('rsvpDetails.activityLogs.emptyState')))])]),_vm._v(" "),_vm._l((_vm.actions),function(log,i){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkLogToShow(log)),expression:"checkLogToShow(log)"}],key:i,class:['action', {'collapsed':log.collapsed}],on:{"click":function($event){log.collapsed = !log.collapsed}}},[_c('div',{staticClass:"minimize"},[_c('div',{class:['icon-display', {'hide-icon': log.consumer && log.consumer.id === _vm.quickResUserId}]},[(!log.collapsed)?_c('i',{staticClass:"fa fa-plus-circle"}):_c('i',{staticClass:"fa fa-minus-circle"})]),_vm._v(" "),_c('div',{staticClass:"action-display"},[_c('span',[_vm._v(_vm._s(_vm.dateSplit(log.created).date)+" "+_vm._s(_vm.dateSplit(log.created).time)+"  "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.displayAction(log))}})])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(log.collapsed),expression:"log.collapsed"}],staticClass:"action-item",attrs:{"id":'log' + i}},[_c('div',{staticClass:"icon-display"}),_vm._v(" "),_c('div',{staticClass:"action-display"},[_c('span',{staticClass:"log-details",domProps:{"innerHTML":_vm._s(_vm.displayLog(log, i))}})])])])],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AsapModal_vue__ = __webpack_require__(616);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7205e8ce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AsapModal_vue__ = __webpack_require__(1827);
function injectStyle (ssrContext) {
  __webpack_require__(1825)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7205e8ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AsapModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7205e8ce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AsapModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1826);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1188c15a", content, true, {});

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.modal[data-v-7205e8ce] {\n  position: fixed;\n  z-index: 22;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: none;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  resize: vertical;\n}\n.modal .bg-overlay[data-v-7205e8ce] {\n    position: absolute;\n    z-index: 1;\n    background: rgba(0, 0, 0, 0.5);\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n}\n.modal .modal-content[data-v-7205e8ce] {\n    position: relative;\n    z-index: 2;\n    background: #fff;\n    max-width: 600px;\n    border-radius: 6px;\n    padding: 20px;\n    margin: auto;\n    -webkit-box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal.show[data-v-7205e8ce] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.modal.show .modal-content[data-v-7205e8ce] {\n      display: block;\n      -webkit-animation: slide-down .15s ease-out;\n      -moz-animation: slide-down .15s ease-out;\n}\n.loader-box[data-v-7205e8ce] {\n  text-align: center;\n}\n.loader-box label[data-v-7205e8ce] {\n    color: #666;\n    display: block;\n    line-height: 1;\n    letter-spacing: .5px;\n    margin-top: 20px;\n    font-size: 14px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/RsvpDetails/AsapModal.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,iBAAiB;CAClB;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,OAAO;IACP,QAAQ;CACX;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,uDAAuD;YAC/C,+CAA+C;IACvD,cAAc;CACjB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;MACM,eAAe;MACf,4CAA4C;MAC5C,yCAAyC;CAC9C;AACD;EACE,mBAAmB;CACpB;AACD;IACI,YAAY;IACZ,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;CACnB","file":"AsapModal.vue","sourcesContent":["\n.modal[data-v-7205e8ce] {\n  position: fixed;\n  z-index: 22;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: none;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  resize: vertical;\n}\n.modal .bg-overlay[data-v-7205e8ce] {\n    position: absolute;\n    z-index: 1;\n    background: rgba(0, 0, 0, 0.5);\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n}\n.modal .modal-content[data-v-7205e8ce] {\n    position: relative;\n    z-index: 2;\n    background: #fff;\n    max-width: 600px;\n    border-radius: 6px;\n    padding: 20px;\n    margin: auto;\n    -webkit-box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal.show[data-v-7205e8ce] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.modal.show .modal-content[data-v-7205e8ce] {\n      display: block;\n      -webkit-animation: slide-down .15s ease-out;\n      -moz-animation: slide-down .15s ease-out;\n}\n.loader-box[data-v-7205e8ce] {\n  text-align: center;\n}\n.loader-box label[data-v-7205e8ce] {\n    color: #666;\n    display: block;\n    line-height: 1;\n    letter-spacing: .5px;\n    margin-top: 20px;\n    font-size: 14px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'modal':true, 'show':_vm.show}},[_c('div',{staticClass:"bg-overlay"}),_vm._v(" "),_c('div',{staticClass:"modal-content"},[(_vm.loading)?_c('div',{staticClass:"loader-box"},[_c('i',{staticClass:"fas fa-spinner fa-spin fa-fw fa-2x"}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.msg))])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CancelUpcomingModal_vue__ = __webpack_require__(617);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3822ffa9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CancelUpcomingModal_vue__ = __webpack_require__(1831);
function injectStyle (ssrContext) {
  __webpack_require__(1829)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3822ffa9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CancelUpcomingModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3822ffa9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CancelUpcomingModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1830);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("26f35375", content, true, {});

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.modal[data-v-3822ffa9] {\n  position: fixed;\n  z-index: 12;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: none;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  resize: vertical;\n}\n.modal .bg-overlay[data-v-3822ffa9] {\n    position: absolute;\n    z-index: 1;\n    background: rgba(0, 0, 0, 0.5);\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n}\n.modal .modal-content[data-v-3822ffa9] {\n    position: relative;\n    z-index: 2;\n    background: #fff;\n    width: 400px;\n    min-height: 150px;\n    border-radius: 6px;\n    padding: 20px;\n    margin: auto;\n    -webkit-box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal.show[data-v-3822ffa9] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.modal.show .modal-content[data-v-3822ffa9] {\n      display: block;\n      -webkit-animation: slide-down .15s ease-out;\n      -moz-animation: slide-down .15s ease-out;\n}\n.top-msg[data-v-3822ffa9] {\n  padding: 10px 5px;\n  background: #edffed;\n  border: 1px solid #53b34f;\n  border-radius: 4px;\n  font-size: 15px;\n  text-align: center;\n}\n.rsvp-box[data-v-3822ffa9] {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  max-height: 250px;\n  overflow: auto;\n  margin-bottom: 10px;\n}\n.rsvp-item[data-v-3822ffa9] {\n  padding: 7px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border-bottom: 1px solid #ddd;\n  cursor: pointer;\n}\n.rsvp-item[data-v-3822ffa9]:hover {\n    background: #f6f6f6;\n}\n.rsvp-item input[data-v-3822ffa9] {\n    padding: 0;\n    margin: 0;\n    width: auto;\n}\n.rsvp-info[data-v-3822ffa9] {\n  width: 100%;\n  padding-left: 10px;\n  line-height: 1;\n  font-size: 14px;\n  text-align: left;\n}\n.rsvp-info b[data-v-3822ffa9] {\n    margin-bottom: 2px;\n    font-size: 18px;\n    color: #2f3547;\n}\n.rsvp-info b b[data-v-3822ffa9] {\n      font-size: 15px;\n      font-weight: 500;\n      vertical-align: 3px;\n      margin-left: 3px;\n      color: #d64343;\n}\n.rsvp-info b span[data-v-3822ffa9] {\n      color: #999;\n      font-weight: 500;\n      font-size: 14px;\n      display: block;\n      margin: 3px 0;\n}\n.rsvp-info div[data-v-3822ffa9] {\n    text-align: left;\n}\n.txt[data-v-3822ffa9] {\n  font-size: 14px;\n  font-weight: 600;\n  text-align: center;\n  color: #2f3547;\n  margin-bottom: 8px;\n}\n.button.warning[data-v-3822ffa9] {\n  margin: 15px 0 10px;\n}\n.button.warning.disabled[data-v-3822ffa9] {\n    cursor: not-allowed !important;\n}\n.cancel-btn[data-v-3822ffa9] {\n  display: block;\n  text-align: center;\n  margin-top: 5px;\n}\n.cancel-btn.disabled[data-v-3822ffa9] {\n    color: #999;\n    cursor: not-allowed !important;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/App/CancelUpcomingModal.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,iBAAiB;CAClB;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,OAAO;IACP,QAAQ;CACX;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,uDAAuD;YAC/C,+CAA+C;IACvD,cAAc;CACjB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;MACM,eAAe;MACf,4CAA4C;MAC5C,yCAAyC;CAC9C;AACD;EACE,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;CACpB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;CACrB;AACD;EACE,aAAa;EACb,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,8BAA8B;EAC9B,gBAAgB;CACjB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,WAAW;IACX,UAAU;IACV,YAAY;CACf;AACD;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;CAClB;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;CAClB;AACD;MACM,gBAAgB;MAChB,iBAAiB;MACjB,oBAAoB;MACpB,iBAAiB;MACjB,eAAe;CACpB;AACD;MACM,YAAY;MACZ,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,cAAc;CACnB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;IACI,+BAA+B;CAClC;AACD;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;CACjB;AACD;IACI,YAAY;IACZ,+BAA+B;CAClC","file":"CancelUpcomingModal.vue","sourcesContent":["\n.modal[data-v-3822ffa9] {\n  position: fixed;\n  z-index: 12;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: none;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  resize: vertical;\n}\n.modal .bg-overlay[data-v-3822ffa9] {\n    position: absolute;\n    z-index: 1;\n    background: rgba(0, 0, 0, 0.5);\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n}\n.modal .modal-content[data-v-3822ffa9] {\n    position: relative;\n    z-index: 2;\n    background: #fff;\n    width: 400px;\n    min-height: 150px;\n    border-radius: 6px;\n    padding: 20px;\n    margin: auto;\n    -webkit-box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n            box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.3);\n    display: none;\n}\n.modal.show[data-v-3822ffa9] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.modal.show .modal-content[data-v-3822ffa9] {\n      display: block;\n      -webkit-animation: slide-down .15s ease-out;\n      -moz-animation: slide-down .15s ease-out;\n}\n.top-msg[data-v-3822ffa9] {\n  padding: 10px 5px;\n  background: #edffed;\n  border: 1px solid #53b34f;\n  border-radius: 4px;\n  font-size: 15px;\n  text-align: center;\n}\n.rsvp-box[data-v-3822ffa9] {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  max-height: 250px;\n  overflow: auto;\n  margin-bottom: 10px;\n}\n.rsvp-item[data-v-3822ffa9] {\n  padding: 7px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border-bottom: 1px solid #ddd;\n  cursor: pointer;\n}\n.rsvp-item[data-v-3822ffa9]:hover {\n    background: #f6f6f6;\n}\n.rsvp-item input[data-v-3822ffa9] {\n    padding: 0;\n    margin: 0;\n    width: auto;\n}\n.rsvp-info[data-v-3822ffa9] {\n  width: 100%;\n  padding-left: 10px;\n  line-height: 1;\n  font-size: 14px;\n  text-align: left;\n}\n.rsvp-info b[data-v-3822ffa9] {\n    margin-bottom: 2px;\n    font-size: 18px;\n    color: #2f3547;\n}\n.rsvp-info b b[data-v-3822ffa9] {\n      font-size: 15px;\n      font-weight: 500;\n      vertical-align: 3px;\n      margin-left: 3px;\n      color: #d64343;\n}\n.rsvp-info b span[data-v-3822ffa9] {\n      color: #999;\n      font-weight: 500;\n      font-size: 14px;\n      display: block;\n      margin: 3px 0;\n}\n.rsvp-info div[data-v-3822ffa9] {\n    text-align: left;\n}\n.txt[data-v-3822ffa9] {\n  font-size: 14px;\n  font-weight: 600;\n  text-align: center;\n  color: #2f3547;\n  margin-bottom: 8px;\n}\n.button.warning[data-v-3822ffa9] {\n  margin: 15px 0 10px;\n}\n.button.warning.disabled[data-v-3822ffa9] {\n    cursor: not-allowed !important;\n}\n.cancel-btn[data-v-3822ffa9] {\n  display: block;\n  text-align: center;\n  margin-top: 5px;\n}\n.cancel-btn.disabled[data-v-3822ffa9] {\n    color: #999;\n    cursor: not-allowed !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['modal', {'show':_vm.show}]},[_c('div',{staticClass:"bg-overlay"}),_vm._v(" "),_c('div',{staticClass:"modal-content"},[(!_vm.showResults)?_c('p',{staticClass:"top-msg",domProps:{"innerHTML":_vm._s(_vm.msg)}}):_vm._e(),_vm._v(" "),(_vm.rsvps.length && !_vm.showResults)?_c('div',[_c('div',{staticClass:"txt"},[_vm._v("\n        This user has other active reservations.\n        "),_c('br'),_vm._v(" "),(_vm.isRefund)?_c('span',[_vm._v("Would you like to convert any of these reservations into ride credits?")]):_c('span',[_vm._v("Would you like to cancel any of these reservations?")])]),_vm._v(" "),_c('div',{staticClass:"rsvp-box"},_vm._l((_vm.rsvps),function(rsvp,i){return _c('label',{key:i,staticClass:"rsvp-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],attrs:{"type":"checkbox","id":"asd"},domProps:{"value":rsvp.id,"checked":Array.isArray(_vm.selected)?_vm._i(_vm.selected,rsvp.id)>-1:(_vm.selected)},on:{"change":function($event){var $$a=_vm.selected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=rsvp.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selected=$$c}}}}),_vm._v(" "),_c('div',{staticClass:"rsvp-info"},[_c('b',[_vm._v("\n              Res "+_vm._s(rsvp.id)+"\n              "),(!_vm.isRefund)?_c('b',[_vm._v("(Cancel Fee: $"+_vm._s(parseInt(_vm.data.cancelFee) ? rsvp.cancellationFee : 0)+")")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(rsvp.pickupDate))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(rsvp.pickup)+" > "+_vm._s(rsvp.dropoff))])])])}),0),_vm._v(" "),_c('a',{class:['button cta warning block small', {'disabled secondary':!_vm.selected.length}],attrs:{"href":"javascript:;"},on:{"click":_vm.initRsvpCxl}},[(_vm.isRefund)?_c('span',[_vm._v("Yes, convert the selected reservations")]):_c('span',[_vm._v("Yes, cancel the selected reservations")])]),_vm._v(" "),_c('a',{staticClass:"cancel-btn",attrs:{"href":"javascript:;"},on:{"click":_vm.close}},[_vm._v("\n        No, keep the other reservations\n      ")])]):_vm._e(),_vm._v(" "),(_vm.showResults)?_c('div',[_c('div',{staticClass:"top-msg"},[_c('span',[_vm._v("\n          Successfully\n          "),(_vm.isRefund)?_c('span',[_vm._v("credited")]):_c('span',[_vm._v("cancelled")]),_vm._v(" "),_c('b',[_vm._v("Reservation(s) "+_vm._s(_vm.success.join(', '))+".")])])]),_vm._v(" "),_c('a',{staticClass:"button cta warning block small",on:{"click":_vm.close}},[_vm._v("\n        "+_vm._s(_vm.$t('rsvpDetails.close'))+"\n      ")])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'editing':_vm.editEnabled}},[_c('div',{class:['map-box', _vm.showMapMobile ? 'showMapBox' : '']},[_c('div',{staticClass:"map-here",attrs:{"id":"mapHere"}}),_vm._v(" "),(_vm.rsvpDetails.tripInfo.status !== 'canceled')?_c('div',{staticClass:"legend"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"show-up"}},[(_vm.rsvpDetails.tripInfo.status === 'canceled')?_c('div',{staticClass:"cancel-data-box"},[_c('ul',[_vm._l((_vm.cancelData),function(data){return _c('li',[_c('label',[_c('div',{class:['icon', data.status]}),_vm._v(_vm._s(data.label))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(data.date))])])}),_vm._v(" "),_c('li',[_c('label',[_c('div',{staticClass:"icon canceled"}),_vm._v("Cancelled")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rsvpDetails.tripInfo.canceled))])])],2)]):_vm._e()])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mapLoader.show),expression:"mapLoader.show"}],staticClass:"render-loader"},[_c('div',{staticClass:"map-loading"},[_c('i',{staticClass:"fas fa-circle-notch fa-spin"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.mapLoader.label))])])]),_vm._v(" "),_c('div',{staticClass:"left-panel"},[_c('div',{staticClass:"heading"},[_c('div',{staticClass:"row",staticStyle:{"max-width":"100%"}},[_c('div',{class:['columns small-12', _vm.rsvpStatus.class === 'canceled' ? 'medium-12' : 'medium-8']},[(!_vm.isNewRsvp)?_c('span',{staticClass:"label"},[_vm._v("\n            "+_vm._s(_vm.$t('rsvpDetails.rsvpId', {id: _vm.$route.params.id}))+"\n            "),(_vm.rsvpDetails.tripInfo.isMtech && (_vm.mtechData.loading || _vm.mtechData.id))?_c('span',{staticClass:"mtech-id"},[_vm._v("\n              MTECH \n              "),(!_vm.mtechData.loading)?_c('span',[_vm._v("#"+_vm._s(_vm.mtechData.id))]):_c('i',{staticClass:"fa fa-spinner fa-spin fa-fw"})]):_vm._e(),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.isPackage),expression:"!!isPackage"}],attrs:{"href":'/#/package/' + _vm.isPackage,"target":"_blank"}},[_c('i',{staticClass:"fa fa-cube"})]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpDetails.tripInfo.wheelchair),expression:"rsvpDetails.tripInfo.wheelchair"}],attrs:{"href":"#"}},[_c('i',{staticClass:"fas fa-wheelchair"})]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvpDetails.tripInfo.serviceDog),expression:"rsvpDetails.tripInfo.serviceDog"}],attrs:{"href":"#"}},[_c('i',{staticClass:"fas fa-dog"})]),_vm._v(" "),(_vm.rsvpDetails.tripInfo.optinShared.isOptinShared)?_c('span',{staticClass:"lr-tooltip"},[_c('img',{staticClass:"optin-icon",attrs:{"src":__webpack_require__(152)}}),_vm._v(" "),_c('div',{staticClass:"tp-desc"},[_vm._v("Opted in to a shared service")])]):_vm._e()]):_c('span',{staticClass:"label",staticStyle:{"padding-top":"5px"}},[_vm._v("NEW RESERVATION")]),_vm._v(" "),(!_vm.isNewRsvp)?_c('span',{key:_vm.$route.params.id,class:['status', _vm.rsvpStatus.class, _vm.dispatchStatusX]},[_vm._v(_vm._s(_vm.rsvpStatus.label))]):_vm._e(),_vm._v(" "),(_vm.rsvpStatus.class === 'canceled')?_c('span',{staticClass:"cxl-reason"},[_vm._v(_vm._s(_vm.rsvpDetails.tripInfo.paxReason))]):_vm._e(),_vm._v(" "),(['onboard', 'dispatched'].indexOf(_vm.rsvpStatus.class) > -1)?_c('a',{staticClass:"track-link",attrs:{"target":"_blank","href":_vm.trackLink}},[_vm._v("<Track Link>")]):_vm._e(),_vm._v(" "),(_vm.lyft.show && _vm.lyft.routeUrl)?_c('a',{staticClass:"track-link lyft-link",attrs:{"target":"_blank","href":_vm.lyft.routeUrl}},[_vm._v("<LYFT Track Link>")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"columns medium-4 small-12 edit-btn-div"},[(_vm.rsvpStatus.class !== 'complete' && _vm.rsvpStatus.class !== 'canceled' && _vm.rsvpStatus.class !== 'auto-dispatch' && !_vm.isNewRsvp && _vm.editAccess && !_vm.isAsapRsvp && _vm.rsvpStatus.class !== 'open-credit' && !_vm.isTerminal && !_vm.rsvpDetails.tripInfo.isMtech && _vm.tripInfo.serviceType.label !== 'Lyft')?_c('a',{class:['button cta small edit', _vm.editEnabled ? 'error' : 'success', _vm.rsvpEditIsSaving || _vm.rsvpStatus.class === '' ? 'disabled' : ''],on:{"click":_vm.toggleEdit}},[_c('b',{directives:[{name:"show",rawName:"v-show",value:(!_vm.editEnabled),expression:"!editEnabled"}]},[_vm._v(_vm._s(_vm.$t('rsvpDetails.editRsvp')))]),_vm._v(" "),_c('b',{directives:[{name:"show",rawName:"v-show",value:(_vm.editEnabled),expression:"editEnabled"}]},[_vm._v(_vm._s(_vm.$t('rsvpDetails.cancelEdit')))])]):_vm._e()])])]),_vm._v(" "),(!_vm.isNewRsvp)?_c('ul',{staticClass:"tab"},[_c('li',{class:{'grow': true, 'active':_vm.activeTab.left === 0},on:{"click":function($event){return _vm.switchTab('left', 0)}}},[_vm._v("\n        "+_vm._s(_vm.$t('rsvpDetails.tabLabel.basicInfo'))+"\n      ")]),_vm._v(" "),_c('li',{class:{'grow': true, 'active':_vm.activeTab.left === 1, 'disabled':_vm.editEnabled},on:{"click":function($event){return _vm.switchTab('left', 1)}}},[_vm._v("\n        "+_vm._s(_vm.$t('rsvpDetails.tabLabel.transactions'))+"\n      ")]),_vm._v(" "),_c('li',{class:{'grow': true, 'active':_vm.activeTab.left === 2, 'disabled':_vm.editEnabled},on:{"click":function($event){return _vm.switchTab('left', 2)}}},[_vm._v("\n        "+_vm._s(_vm.$t('rsvpDetails.tabLabel.notes'))+"\n      ")])]):_vm._e(),_vm._v(" "),_c('div',{class:{'tab-contents':true, 'transaction-tab':_vm.activeTab.left == 1}},[_c('div',{class:{'tab-content':true, 'active':_vm.activeTab.left == 0}},[_c('edit-reservation',{directives:[{name:"show",rawName:"v-show",value:(_vm.editEnabled),expression:"editEnabled"}],ref:"edit"}),_vm._v(" "),_c('basic-information',{directives:[{name:"show",rawName:"v-show",value:(!_vm.editEnabled),expression:"!editEnabled"}]})],1),_vm._v(" "),_c('div',{class:{'tab-content no-H-padding':true, 'active':_vm.activeTab.left == 1}},[_c('transactions',{ref:"transactions",attrs:{"rsvpId":_vm.$route.params.id}})],1),_vm._v(" "),_c('div',{class:{'tab-content no-H-padding':true, 'active':_vm.activeTab.left == 2}},[_c('notes',{ref:"notes",attrs:{"rsvpId":_vm.$route.params.id}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showButtons),expression:"showButtons"}],staticClass:"fixed-bottom"},[(_vm.activeTab.left !== 2 && _vm.showCancelButton && !_vm.editEnabled)?_c('a',{staticClass:"button cta error small",on:{"click":_vm.cancelRsvp}},[_vm._v("\n        "+_vm._s(_vm.$t('rsvpDetails.cancelRsvp'))+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.activeTab.left !== 2 && _vm.rsvpStatus.class !== 'complete' && _vm.rsvpStatus.class !== 'canceled' && !_vm.editEnabled && _vm.rsvpStatus.class !== 'open-credit')?_c('a',{class:['button cta small', _vm.hasRSVPControl ? 'success' : 'secondary disabled'],attrs:{"href":"javascript:;"},on:{"click":_vm.markAsComplete}},[_vm._v("\n        "+_vm._s(_vm.$t('rsvpDetails.markComplete'))+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.showRTGButton && _vm.activeTab.left !== 2 && !_vm.rsvpDetails.tripInfo.isMtech)?_c('a',{staticClass:"rtg button cta small",on:{"click":function($event){return _vm.showRTG(_vm.$route.params.id)}}},[_vm._v("Ready to go")]):_vm._e(),_vm._v(" "),(_vm.activeTab.left === 2 && _vm.noteAccess)?_c('a',{staticClass:"button cta success small",on:{"click":_vm.AddNotes}},[_vm._v("\n        "+_vm._s(_vm.$t('rsvpDetails.addNote'))+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.editEnabled && !_vm.isNewRsvp)?_c('a',{class:{'button cta error small right':true, 'disabled':_vm.rsvpEditIsSaving},on:{"click":_vm.toggleEdit}},[_vm._v("\n        "+_vm._s(_vm.$t('rsvpDetails.cancelEdit'))+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.editEnabled)?_c('a',{class:{'button cta success small right':true, 'disabled':_vm.rsvpEditIsSaving, 'create':_vm.isNewRsvp},on:{"click":_vm.editRsvpSave}},[(!_vm.isNewRsvp)?_c('span',[_vm._v(_vm._s(_vm.$t('rsvpDetails.saveChanges')))]):_c('span',[_vm._v("Create")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"toggle-mobile",on:{"click":function($event){_vm.showMapMobile = !_vm.showMapMobile}}},[(!_vm.showMapMobile)?_c('span',[_vm._v("Show Map "),_c('i',{staticClass:"fa fa-chevron-up"})]):_c('span',[_vm._v("Hide Map "),_c('i',{staticClass:"fa fa-chevron-down"})])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showIconLog),expression:"showIconLog"}],class:{'logs-toggle':true, on: _vm.showRightPanel},on:{"click":_vm.toggleRightPanel}},[_c('i',{class:_vm.iconToggleRightPanel})])]),_vm._v(" "),_c('div',{class:{'right-panel': true, hide: _vm.showRightPanel}},[_c('div',{staticClass:"heading"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.history')))]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.dispatches > 0),expression:"dispatches > 0"}],staticClass:"tab"},[_c('li',{class:{'grow':true, 'active':_vm.activeTab.right === 0},on:{"click":function($event){return _vm.switchTab('right', 0)}}},[_vm._v("\n        "+_vm._s(_vm.$t('rsvpDetails.tabLabel.actionLogs'))+"\n      ")]),_vm._v(" "),_c('li',{class:{'grow':true, 'active':_vm.activeTab.right === 1},on:{"click":function($event){return _vm.switchTab('right', 1)}}},[_vm._v("\n        "+_vm._s(_vm.$t('rsvpDetails.tabLabel.dispatchLogs'))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"tab-contents"},[_c('div',{class:{'tab-content':true, 'active':_vm.activeTab.right == 0}},[_c('action-logs',{ref:"actionLogs",attrs:{"rsvpId":_vm.$route.params.id}})],1),_vm._v(" "),_c('div',{class:{'tab-content dispatch-log':true, 'active':_vm.activeTab.right == 1}},[_c('dispatch-logs',{attrs:{"rsvpId":_vm.$route.params.id}})],1)])]),_vm._v(" "),_c('loading-modal',{attrs:{"showModal":(_vm.loading && !_vm.rsvpAction.show) || _vm.servicesLoading,"modalMessage":"Loading"}}),_vm._v(" "),_c('loading-modal',{attrs:{"showModal":_vm.rsvpEditIsSaving,"modalMessage":_vm.$t('rsvpDetails.edit.updatingReservation')}}),_vm._v(" "),_c('loading-modal',{attrs:{"showModal":_vm.createRsvpLoading,"modalMessage":"Creating reservation..."}}),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.showBreakdownPayment}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeBreakdown}}),_vm._v(" "),_c('div',{staticClass:"modal-content breakdown"},[_c('div',{staticClass:"head d-flex justify-space-between align-center"},[_c('span',[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.paymentBreakdown')))]),_vm._v(" "),(_vm.allowOverridePayment)?_c('span',{staticClass:"op-link",on:{"click":_vm.showOverrideModal}},[_vm._v("Override Payment")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.fareAmount')))]),_vm._v(" "),_c('span',{staticClass:"value"},[(!_vm.useLocalCurrency)?_c('span',[_vm._v("$"+_vm._s(_vm.driverPaymentBreakdown.fare))]):_c('span',[_vm._v(_vm._s(_vm.applyCurrency(_vm.driverPaymentBreakdown.fare)))])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.bonus')))]),_vm._v(" "),_c('span',{staticClass:"value"},[(!_vm.useLocalCurrency)?_c('span',[_vm._v("$"+_vm._s(_vm.driverPaymentBreakdown.bonus))]):_c('span',[_vm._v(_vm._s(_vm.applyCurrency(_vm.driverPaymentBreakdown.bonus)))])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('span',{staticClass:"label"},[_vm._v("Fuel Surcharge")]),_vm._v(" "),_c('span',{staticClass:"value"},[(!_vm.useLocalCurrency)?_c('span',[_vm._v("$"+_vm._s(_vm.driverPaymentBreakdown.gasFee))]):_c('span',[_vm._v(_vm._s(_vm.xcurrency.format({code: _vm.currency.currency, val: _vm.currency.gasFee.toFixed(2)})))])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.tip')))]),_vm._v(" "),_c('span',{staticClass:"value"},[(!_vm.useLocalCurrency)?_c('span',[_vm._v("$"+_vm._s(_vm.driverPaymentBreakdown.tip))]):_c('span',[_vm._v(_vm._s(_vm.xcurrency.format({code: _vm.currency.currency, val: _vm.currency.tipAmount.toFixed(2)})))])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.pickupFee')))]),_vm._v(" "),_c('span',{staticClass:"value"},[(!_vm.useLocalCurrency)?_c('span',[_vm._v("$"+_vm._s(_vm.driverPaymentBreakdown.pickupFee))]):_c('span',[_vm._v(_vm._s(_vm.xcurrency.format({code: _vm.currency.currency, val: _vm.currency.pickupFee.toFixed(2)})))])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.tripInformation.paymentBonus')))]),_vm._v(" "),_c('span',{staticClass:"value"},[(!_vm.useLocalCurrency)?_c('span',[_vm._v("$"+_vm._s(_vm.driverPaymentBreakdown.paymentBonus))]):_c('span',[_vm._v(_vm._s(_vm.applyCurrency(_vm.driverPaymentBreakdown.paymentBonus)))])])]),_vm._v(" "),_c('a',{staticClass:"button cta block small",attrs:{"href":"javascript:;"},on:{"click":_vm.closeBreakdown}},[_vm._v("\n        "+_vm._s(_vm.$t('rsvpDetails.tripInformation.close'))+"\n      ")])])]),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.overrideModal.show}},[_c('div',{staticClass:"bg-overlay",on:{"click":function($event){_vm.overrideModal.show = false}}}),_vm._v(" "),_c('div',{staticClass:"modal-content breakdown"},[_c('div',{staticClass:"head"},[_vm._v("Driver Payment Override")]),_vm._v(" "),_c('div',{staticClass:"dpo-field"},[_c('span',[_vm._v("$")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.overrideModal.value),expression:"overrideModal.value"}],attrs:{"type":"number","placeholder":"Amount...","step":".1","min":"0","onkeydown":"if(event.key==='-'){event.preventDefault();}","onpaste":"e => e.preventDefault()"},domProps:{"value":(_vm.overrideModal.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.overrideModal, "value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-space-between",staticStyle:{"gap":"20px"}},[_c('a',{staticClass:"button cta block small secondary",attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.overrideModal.show = false}}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('a',{staticClass:"button cta block small",attrs:{"href":"javascript:;"},on:{"click":_vm.submitDriverPaymentOverride}},[_vm._v("\n          Submit\n        ")])])])]),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.showFlightStatus}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeFlightStatus}}),_vm._v(" "),_c('div',{staticClass:"modal-content flightStatusModal"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.flightStatusLoading),expression:"flightStatusLoading"}],staticClass:"loading"},[_c('i',{staticClass:"fa fa-circle-notch fa-spin"}),_vm._v("\n        "+_vm._s(_vm.$t('rsvpDetails.flightStatus.loading'))+"\n      ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.flightStatusLoading && _vm.flightStatusError),expression:"!flightStatusLoading && flightStatusError"}],staticClass:"flight-error"},[_c('i',{staticClass:"fa fa-frown fa-4x"}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Oops!")]),_vm._v(" "),_c('span',{staticClass:"body"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.flightStatus.error')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.flightStatusLoading && !_vm.flightStatusError),expression:"!flightStatusLoading && !flightStatusError"}]},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.flightStatus.status')))]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.flightStatus.status))]),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.flightStatus.departureAirport')))]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.flightStatus.departureAirport))]),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.flightStatus.arrivalAirport')))]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.flightStatus.arrivalAirport))]),_vm._v(" "),(!_vm.isAirportDropoff)?_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.flightStatus.arrivalDate')))]):_vm._e(),_vm._v(" "),(_vm.isAirportDropoff)?_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.flightStatus.departureDate')))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.flightStatus.arrivalTime))])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.flightStatusError),expression:"flightStatusError"}],staticClass:"button cta warning block small try-again",attrs:{"href":"javascript:;"},on:{"click":_vm.updateFlightStatus}},[_vm._v("\n        "+_vm._s(_vm.$t('rsvpDetails.flightStatus.tryAgain'))+"\n      ")]),_vm._v(" "),_c('a',{staticClass:"button cta block small",attrs:{"href":"javascript:;"},on:{"click":_vm.closeFlightStatus}},[_vm._v("\n        "+_vm._s(_vm.$t('rsvpDetails.tripInformation.close'))+"\n      ")])])]),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.sendEmail.show}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeEmailResult}}),_vm._v(" "),_c('div',{staticClass:"modal-content email-result"},[_c('p',[_vm._v(_vm._s(_vm.sendEmail.message))]),_vm._v(" "),_c('a',{staticClass:"button cta warning block small",on:{"click":_vm.closeEmailResult}},[_vm._v("\n        "+_vm._s(_vm.$t('rsvpDetails.close'))+"\n      ")])])]),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.sendNoShow.showModal}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeNoShowResult}}),_vm._v(" "),_c('div',{staticClass:"modal-content email-result"},[(!!_vm.sendNoShow.message)?_c('div',[_c('p',[_vm._v(_vm._s(_vm.sendNoShow.message))]),_vm._v(" "),_c('a',{staticClass:"button cta warning block small",on:{"click":_vm.closeNoShowResult}},[_vm._v("\n          "+_vm._s(_vm.$t('rsvpDetails.close'))+"\n        ")])]):_c('div',[_c('span',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t('rsvpDetails.noShow.header')))]),_vm._v(" "),_c('span',{staticClass:"body",domProps:{"innerHTML":_vm._s(_vm.noShowMessage())}}),_vm._v(" "),_c('a',{class:{'button cta warning block small':true, 'disabled':_vm.sendNoShow.loading},on:{"click":_vm.applyNoShow}},[(!_vm.sendNoShow.loading)?_c('span',[_vm._v(_vm._s(_vm.$t('rsvpDetails.noShow.yes')))]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin fa-fw"}),_vm._v("\n            "+_vm._s(_vm.$t('rsvpDetails.noShow.loading'))+"\n          ")])]),_vm._v(" "),_c('a',{staticClass:"cancel",on:{"click":_vm.closeNoShowResult}},[_vm._v(_vm._s(_vm.$t('rsvpDetails.noShow.cancel')))])])])]),_vm._v(" "),_c('div',{class:{'release-modal': true, show: _vm.showReleaseModal}},[_c('div',{staticClass:"release-modal-container",on:{"click":function($event){return _vm.$store.commit('rsvpDetails/hideReleaseConfirmation')}}},[_c('div',{staticClass:"release-modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.releasingDriver),expression:"!releasingDriver"}],staticClass:"confirm-release"},[_c('div',{staticClass:"title"},[(!_vm.release.loading)?_c('span',[_vm._v("CONFIRM THE RELEASE")]):(_vm.release.error.show)?_c('span',[_vm._v("ERROR")]):_c('span',[_vm._v("Loading...")])]),_vm._v(" "),(_vm.release.loading && !_vm.release.error.show)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-fw fa-5x"}),_vm._v(" "),_c('div',[_vm._v("Please wait...")])]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[(_vm.release.error.show)?_c('div',{staticClass:"error"},[_c('i',{staticClass:"fas fa-exclamation-triangle fa-fw fa-5x"}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.release.error.message))])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[(_vm.release.showContent && !_vm.release.error.show)?_c('div',[_c('div',{staticClass:"message"},[_vm._v("\n                Are you sure you want to un-assign this reservation from\n                "),_c('a',{attrs:{"href":'/#/provider/' + _vm.$store.state.rsvpDetails.basicInfo.driverInfo.id,"target":"_blank"}},[_vm._v(_vm._s(_vm.$store.state.rsvpDetails.basicInfo.driverInfo.firstName)+" "+_vm._s(_vm.$store.state.rsvpDetails.basicInfo.driverInfo.lastName))]),_vm._v("?\n              ")]),_vm._v(" "),(_vm.release.fee > 0)?_c('div',{staticClass:"fee"},[_c('p',[_vm._v("The driver will have to pay an unassign fee of "),_c('b',[_vm._v("$"+_vm._s((_vm.release.fee).toFixed(2)))]),_vm._v(". Do you want to charge the unassign fee?")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.release.charge),expression:"release.charge"}],attrs:{"type":"radio","name":"release","value":"1"},domProps:{"checked":_vm._q(_vm.release.charge,"1")},on:{"change":function($event){return _vm.$set(_vm.release, "charge", "1")}}}),_vm._v(" Yes\n                ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.release.charge),expression:"release.charge"}],attrs:{"type":"radio","name":"release","value":"0"},domProps:{"checked":_vm._q(_vm.release.charge,"0")},on:{"change":function($event){return _vm.$set(_vm.release, "charge", "0")}}}),_vm._v(" No\n                ")]),_vm._v(" "),_c('div',{staticClass:"clear"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sub-message"},[_vm._v("\n                If you are un-assigning the driver in order to edit this reservation, make sure that you "),_c('strong',[_vm._v("assign it back to the same driver")]),_vm._v(". Otherwise, make sure that you "),_c('strong',[_vm._v("find another driver to cover this reservation")]),_vm._v(" or\n                "),_c('strong',[_vm._v("push it back again to the pool")]),_vm._v(".\n              ")]),_vm._v(" "),_c('div',{staticClass:"row controls"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('a',{staticClass:"button cta block small",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$store.commit('rsvpDetails/hideReleaseConfirmation')}}},[_vm._v("NO")])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('a',{staticClass:"button cta block small warning",attrs:{"href":"javascript:;"},on:{"click":_vm.releaseDriver}},[_vm._v("YES")])])])]):_vm._e()])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.releasingDriver),expression:"releasingDriver"}],staticClass:"releasing"},[_c('i',{class:{
            'fas fa-circle-notch fa-spin': !_vm.releaseSuccess,
            'fas fa-check-circle': _vm.releaseSuccess,
            'fa-fw fa-2x': true,
            success: _vm.releaseSuccess
          }}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.releaseSuccess),expression:"!releaseSuccess"}],staticClass:"message"},[_vm._v("Un-assigning driver from this reservation...")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.releaseSuccess),expression:"releaseSuccess"}],staticClass:"message"},[_vm._v("Successfully un-assigned driver from the reservation.")])])])])]),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.rsvpAction.show}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeActionModal}}),_vm._v(" "),_c('div',{staticClass:"modal-content emailResult"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.rsvpAction.message)}}),_vm._v(" "),_c('a',{staticClass:"button cta warning block small",on:{"click":_vm.closeActionModal}},[_vm._v("\n        "+_vm._s(_vm.$t('rsvpDetails.close'))+"\n      ")])])]),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.rsvpEditSubmit.show}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeEditSubmit}}),_vm._v(" "),_c('div',{staticClass:"modal-content emailResult"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.rsvpEditSubmit.message)}}),_vm._v(" "),_c('a',{staticClass:"button cta warning block small",on:{"click":function($event){return _vm.closeEditSubmit(_vm.rsvpEditSubmit.status)}}},[_vm._v("\n        "+_vm._s(_vm.$t('rsvpDetails.close'))+"\n      ")])])]),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.suggestedTimeShow && !_vm.asapEnable}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeSuggestedTime}}),_vm._v(" "),_c('div',{staticClass:"modal-content suggested-time-modal"},[_c('div',{staticClass:"title"},[_vm._v("Suggested Pickup Time")]),_vm._v(" "),(_vm.isAirportPickup)?_c('p',[_vm._v("To make sure that the passenger can be picked up as soon as he/she arrives at the airport, the suggested pickup time is:")]):_c('p',[_vm._v("To make sure that the passenger doesn't miss his/her flight, the suggested pickup time is:")]),_vm._v(" "),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.suggestedTime()))]),_vm._v(" "),_c('span',{staticClass:"button cta success block large",on:{"click":_vm.applySuggestedTime}},[_vm._v("Yes, use the suggested pickup time.")]),_vm._v(" "),_c('a',{staticClass:"keep",on:{"click":_vm.closeSuggestedTime}},[_vm._v("No, I want to keep my pickup time.")])])]),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.showSelectUser}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeShowSelectUser}}),_vm._v(" "),_c('div',{staticClass:"modal-content select-user"},[_c('div',{staticClass:"title"},[_vm._v("Select User")]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.users.input),expression:"users.input"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Type in customer name, email or mobile...","disabled":_vm.users.loading},domProps:{"value":(_vm.users.input)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchUser.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.users, "input", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"column small-3 padding-L"},[_c('a',{staticClass:"button block",on:{"click":_vm.searchUser}},[_vm._v("Search")])])]),_vm._v(" "),_c('div',{staticClass:"box-list"},[_c('ul',{staticClass:"list"},_vm._l((_vm.users.list),function(user,index){return _c('li',{key:index,on:{"click":function($event){return _vm.selectUser(index)}}},[_c('div',{staticClass:"d-flex justify-space-between"},[_c('div',[_c('span',{staticClass:"name"},[_vm._v(_vm._s(user.firstName + ' ' + user.lastName))]),_vm._v(" "),_c('span',{staticClass:"email"},[_vm._v(_vm._s(user.email))]),_vm._v(" "),_c('span',{staticClass:"mobile"},[_vm._v("+"+_vm._s(user.countryCode)+" "+_vm._s(user.nationalNumber || user.mobile))])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"id"},[_c('b',[_vm._v("ID:")]),_vm._v(" "+_vm._s(user.id)),_c('br'),_vm._v(" "),(user.isD2d)?_c('span',{staticClass:"is-d2d"},[_vm._v("D2D")]):_vm._e()])])])])}),0),_vm._v(" "),_c('transition',{attrs:{"name":"appear"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.users.loading),expression:"users.loading"}],staticClass:"loader"},[_c('div',{staticClass:"v-center"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-fw fa-2x"}),_vm._v("Loading...\n              ")])])])],1),_vm._v(" "),_c('div',{staticClass:"row actions"},[_c('div',{staticClass:"column small-12"},[_c('a',{staticClass:"button cta small error block btn-close",on:{"click":_vm.closeShowSelectUser}},[_vm._v("Close")])])])])])]),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.showSelectCorporate}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeShowSelectCorporate}}),_vm._v(" "),_c('div',{staticClass:"modal-content select-user"},[_c('div',{staticClass:"title"},[_vm._v("Select User")]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.corporate.input),expression:"corporate.input"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Type in customer name, email or mobile...","disabled":_vm.corporate.loading},domProps:{"value":(_vm.corporate.input)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchCorporate.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.corporate, "input", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"column small-3 padding-L"},[_c('a',{staticClass:"button block",on:{"click":_vm.searchCorporate}},[_vm._v("Search")])])]),_vm._v(" "),_c('div',{staticClass:"box-list"},[_c('ul',{staticClass:"list"},_vm._l((_vm.corporate.list),function(users,index){return _c('li',{key:index,class:{disabled:!users.active},on:{"click":function($event){return _vm.selectCorporate(index)}}},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(users.firstName + ' ' + users.lastName))]),_c('span',{staticClass:"id"},[_c('b',[_vm._v("ID:")]),_vm._v(" "+_vm._s(users.id))]),_vm._v(" "),_c('span',{staticClass:"email"},[_vm._v(_vm._s(users.email))]),_vm._v(" "),_c('span',{staticClass:"mobile"},[_vm._v(_vm._s(users.displayMobile))]),_vm._v(" "),(!users.active)?_c('span',{staticClass:"status"},[_vm._v("DISABLED")]):_vm._e()])}),0),_vm._v(" "),_c('transition',{attrs:{"name":"appear"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.corporate.loading),expression:"corporate.loading"}],staticClass:"loader"},[_c('div',{staticClass:"v-center"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-fw fa-2x"}),_vm._v("Loading...\n              ")])])])],1),_vm._v(" "),_c('div',{staticClass:"row actions"},[_c('div',{staticClass:"column small-12"},[_c('a',{staticClass:"button cta small error block btn-close",on:{"click":_vm.closeShowSelectCorporate}},[_vm._v("Close")])])])])])]),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.showAsapModal}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeCreateError}}),_vm._v(" "),_c('div',{staticClass:"modal-content asap-modal"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.asapLoading && !_vm.asapNoDriver),expression:"asapLoading && !asapNoDriver"}]},[_vm._m(1),_vm._v(" "),_c('span',{staticClass:"looking-for"},[_vm._v("Looking for nearby drivers...")]),_vm._v(" "),_c('span',{staticClass:"button cta warning cancel-asap small",on:{"click":_vm.cancelAsap}},[_vm._v("Cancel")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.asapDriverInfoLoading),expression:"asapDriverInfoLoading"}]},[_c('i',{staticClass:"fas fa-spinner fa-spin fa-3x"}),_vm._v(" "),_c('span',{staticClass:"looking-for"},[_vm._v("Getting driver info...")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.asapDriverInfo.fullName),expression:"!!asapDriverInfo.fullName"}],staticClass:"driver-info"},[_c('div',{staticClass:"title"},[_vm._v("Driver Info")]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":_vm.asapDriverInfo.profilePic}})]),_vm._v(" "),_c('div',{staticClass:"desc"},[_c('div',{staticClass:"rating"},[_c('i',{staticClass:"fas fa-star fa-fw"}),_vm._v(_vm._s(_vm.asapDriverInfo.rating))]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.asapDriverInfo.fullName))]),_vm._v(" "),_c('div',{staticClass:"email"},[_vm._v(_vm._s(_vm.asapDriverInfo.email))])])]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":_vm.asapDriverInfo.vehiclePick}})]),_vm._v(" "),_c('div',{staticClass:"desc"},[_c('div',{staticClass:"model"},[_vm._v(_vm._s(_vm.asapDriverInfo.model))]),_vm._v(" "),_c('div',{staticClass:"plate"},[_vm._v(_vm._s(_vm.asapDriverInfo.plate))])])]),_vm._v(" "),_c('span',{staticClass:"button cta success xsmall close-asap",on:{"click":_vm.closeDoneAsap}},[_vm._v("Close")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.asapNoDriver),expression:"asapNoDriver"}],staticClass:"no-driver"},[_c('i',{staticClass:"far fa-user-circle fa-4x"}),_vm._v(" "),_c('span',{staticClass:"message"},[_vm._v("No drivers available at this moment")]),_vm._v(" "),_c('span',{staticClass:"button cta xsmall block change-service",on:{"click":_vm.asapChangeService}},[_vm._v("Choose a Different Service")]),_vm._v(" "),_c('span',{staticClass:"button cta warning xsmall block",on:{"click":_vm.asapTryAgain}},[_vm._v("Try again")])])])]),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.createError.show}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeCreateError}}),_vm._v(" "),_c('div',{staticClass:"modal-content create-error"},[_c('i',{staticClass:"fas fa-exclamation-circle fa-4x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.createError.message))]),_vm._v(" "),_c('span',{staticClass:"button cta warning xsmall block",on:{"click":_vm.closeCreateError}},[_vm._v("Close")])])]),_vm._v(" "),_c('div',{class:{'modal':true, 'show':_vm.emailRecipientModal.show}},[_c('div',{staticClass:"bg-overlay",on:{"click":_vm.closeEmailRecipientModal}}),_vm._v(" "),_c('div',{staticClass:"modal-content select-email-recipient"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.emailRecipientModal.title))]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('span',{staticClass:"label"},[_vm._v("Please select email recipient.")]),_vm._v(" "),_c('ul',[_c('li',[_c('label',{on:{"click":function($event){return _vm.emailRecipientSelect('customer')}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailRecipientModal.selected),expression:"emailRecipientModal.selected"}],attrs:{"type":"radio","name":"emailRecipient","value":"customer"},domProps:{"checked":_vm._q(_vm.emailRecipientModal.selected,"customer")},on:{"change":function($event){return _vm.$set(_vm.emailRecipientModal, "selected", "customer")}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rsvpDetails.customerInfo.email))])])]),_vm._v(" "),_c('li',[_c('label',{on:{"click":function($event){return _vm.emailRecipientSelect('custom')}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailRecipientModal.selected),expression:"emailRecipientModal.selected"}],attrs:{"type":"radio","name":"emailRecipient","value":"custom"},domProps:{"checked":_vm._q(_vm.emailRecipientModal.selected,"custom")},on:{"change":function($event){return _vm.$set(_vm.emailRecipientModal, "selected", "custom")}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customEmailRecipient),expression:"customEmailRecipient"}],class:{'has-error':!!_vm.customEmailFieldError},attrs:{"type":"input"},domProps:{"value":(_vm.customEmailRecipient)},on:{"change":_vm.updateCustomEmailRecipient,"input":function($event){if($event.target.composing){ return; }_vm.customEmailRecipient=$event.target.value}}})]),_vm._v(" "),(_vm.customEmailFieldError)?_c('span',{staticClass:"has-error"},[_vm._v(_vm._s(_vm.customEmailFieldError))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column medium-6"},[_c('a',{class:{'button cta small error block':true, 'disabled':_vm.customEmailLoading},on:{"click":_vm.closeEmailRecipientModal}},[_vm._v("Cancel")])]),_vm._v(" "),_c('div',{staticClass:"column medium-6 padding-L"},[_c('a',{class:{'button cta small success block':true, 'disabled':_vm.customEmailLoading},on:{"click":_vm.submitEmailRecipient}},[_vm._v("Send")])])])])])]),_vm._v(" "),_c('div',{class:['modal', {'show':_vm.optinModal}],on:{"click":function($event){_vm.optinModal = false}}},[_c('div',{staticClass:"bg-overlay"}),_vm._v(" "),_c('div',{staticClass:"modal-content optin-modal",on:{"click":function($event){$event.stopPropagation();}}},[_c('label',[_vm._v("Are you sure you want to convert this reservation?")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-space-between"},[_c('a',{staticClass:"button cta small right",on:{"click":function($event){_vm.optinModal = false}}},[_vm._v("No")]),_vm._v(" "),_c('a',{staticClass:"button cta success small right",on:{"click":function($event){return _vm.optinServiceConvert(_vm.tripInfo.optinShared.current)}}},[_vm._v("Yes")])])])]),_vm._v(" "),_c('ready-to-go-modal'),_vm._v(" "),_c('asap-modal',{on:{"success":_vm.saveNotes}}),_vm._v(" "),(_vm.renderFix)?_c('div',{staticStyle:{"display":"none"}},[_c('here-info-bubble-car',{key:_vm.rsvpId + 'car',ref:"HCar",attrs:{"id":"HCar"}}),_vm._v(" "),_c('here-info-bubble-pickup',{key:_vm.rsvpId + 'pickup',ref:"HPickup",attrs:{"id":"HPickup"}}),_vm._v(" "),_c('here-info-bubble-dropoff',{key:_vm.rsvpId + 'dropoff',ref:"HDropoff",attrs:{"id":"HDropoff"}}),_vm._v(" "),_vm._l((_vm.totalExtraStops),function(i){return _c('here-info-bubble-extra-stop',{key:((i-1) + "extraStop"),ref:("HExtraStop" + (i-1)),refInFor:true,attrs:{"id":("HExtraStop" + (i-1)),"onEdit":_vm.editEnabled,"index":i - 1}})})],2):_vm._e(),_vm._v(" "),_c('notification-modal',{ref:"notif",attrs:{"isList":false,"provId":_vm.driverId,"removeAllActiveUserOption":true,"hideTargetOption":true}}),_vm._v(" "),_c('sms-modal',{ref:"sms",attrs:{"isList":false,"provId":_vm.driverId,"removeAllActiveUserOption":true,"hideTargetOption":true}}),_vm._v(" "),_c('cancel-upcoming-modal')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('div',{staticClass:"icon pickup"}),_vm._v(" "),_c('span',[_vm._v("Pickup")])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"icon extra-stop"}),_vm._v(" "),_c('span',[_vm._v("Extra Stop")])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"icon dropoff"}),_vm._v(" "),_c('span',[_vm._v("Dropoff")])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"icon ontheway"}),_vm._v(" "),_c('span',[_vm._v("On the way")])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"icon arrived"}),_vm._v(" "),_c('span',[_vm._v("Arrived / On Board")])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"icon completed"}),_vm._v(" "),_c('span',[_vm._v("Completed")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fa-stack fa-3x asap-loader"},[_c('i',{staticClass:"fas fa-car fa-stack-1x"}),_vm._v(" "),_c('i',{staticClass:"fas fa-spinner fa-spin fa-stack-2x"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(618);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e472535_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1851);
function injectStyle (ssrContext) {
  __webpack_require__(1834)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e472535"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e472535_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1835);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1ddaa7c4", content, true, {});

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.showDesktop[data-v-7e472535], .showMobile[data-v-7e472535] {\n  display: inline-block;\n}\n.hideDesktop[data-v-7e472535], .hideMobile[data-v-7e472535] {\n  display: none;\n}\n.header[data-v-7e472535] {\n  margin-left: 50px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n}\n.header .title[data-v-7e472535] {\n    padding: 10px;\n    font-size: 22px;\n    font-weight: 600;\n    text-transform: uppercase;\n    line-height: 50px;\n    color: #3F2975;\n}\n.manager-link[data-v-7e472535], .new-rsvp-link[data-v-7e472535] {\n  float: right;\n  padding: 7px 10px;\n  margin-right: 30px;\n}\n.manager-link.new-rsvp-link[data-v-7e472535], .new-rsvp-link.new-rsvp-link[data-v-7e472535] {\n    margin-right: 0;\n}\n.manager-link a[data-v-7e472535], .new-rsvp-link a[data-v-7e472535] {\n    text-decoration: none;\n}\n.manager-link i[data-v-7e472535], .new-rsvp-link i[data-v-7e472535] {\n    font-size: 16px;\n}\n.manager-link span[data-v-7e472535], .new-rsvp-link span[data-v-7e472535] {\n    display: inline-block;\n    font-size: 14px;\n    margin-left: 3px;\n}\n.stats[data-v-7e472535] {\n  float: right;\n  margin-right: 20px;\n  padding: 5px 0;\n}\n.stats .stat[data-v-7e472535] {\n    border: 1px solid #aaa;\n    display: inline-block;\n    height: 40px;\n    border-radius: 4px;\n    overflow: hidden;\n    position: relative;\n    -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);\n            box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);\n}\n.stats .stat label[data-v-7e472535], .stats .stat div[data-v-7e472535] {\n      float: left;\n      padding: 8px;\n      height: 100%;\n      font-weight: 600;\n}\n.stats .stat label[data-v-7e472535] {\n      font-size: 12px;\n      vertical-align: middle;\n      color: #fff;\n      line-height: 20px;\n}\n.stats .stat label small[data-v-7e472535] {\n        display: block;\n        font-weight: 100;\n        font-size: 11px;\n        margin-top: 1px;\n}\n.stats .stat div[data-v-7e472535] {\n      background: #fff;\n      border-left: 1px solid #ccc;\n      font-size: 21px;\n      line-height: 1;\n      -webkit-transition: all .5s ease;\n      transition: all .5s ease;\n      max-width: 200px;\n}\n.stats .stat div i[data-v-7e472535] {\n        display: none;\n}\n.stats .stat div.loading span[data-v-7e472535] {\n        display: none;\n}\n.stats .stat div.loading i[data-v-7e472535] {\n        display: block;\n}\n.stats .stat.gross[data-v-7e472535] {\n      margin-right: 10px;\n      border-color: #0baf58;\n}\n.stats .stat.gross label[data-v-7e472535] {\n        background: #26d97a;\n        line-height: 1;\n}\n.stats .stat.gross div[data-v-7e472535] {\n        color: #26d97a;\n}\n.stats .stat.credit[data-v-7e472535] {\n      border-color: #1283a5;\n}\n.stats .stat.credit label[data-v-7e472535] {\n        background: #26b0d9;\n}\n.stats .stat.credit div[data-v-7e472535] {\n        color: #26b0d9;\n}\n.stats .stat.prov-online[data-v-7e472535] {\n      border-color: #333;\n}\n.stats .stat.prov-online label[data-v-7e472535] {\n        background: #555;\n}\n.stats .stat.prov-online div[data-v-7e472535] {\n        color: #555;\n}\n.body[data-v-7e472535] {\n  padding: 20px;\n}\n@media only screen and (max-width: 430px) {\n.body[data-v-7e472535] {\n    padding-bottom: 40px;\n}\n.header[data-v-7e472535] {\n    margin-left: 0;\n    height: auto;\n}\n.header .title[data-v-7e472535] {\n      margin-left: 50px;\n}\n.header .stats[data-v-7e472535] {\n      float: none;\n      margin: 0;\n      text-align: center;\n}\n.header .stats .gross[data-v-7e472535] {\n        margin-right: 0;\n}\n.header .manager-link[data-v-7e472535] {\n      float: none;\n      margin: 0;\n      text-align: center;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Transactions/index.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;CACvB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,8BAA8B;CAC/B;AACD;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;CAClB;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;CACpB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,sBAAsB;CACzB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;CACpB;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;CAChB;AACD;IACI,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;MACM,YAAY;MACZ,aAAa;MACb,aAAa;MACb,iBAAiB;CACtB;AACD;MACM,gBAAgB;MAChB,uBAAuB;MACvB,YAAY;MACZ,kBAAkB;CACvB;AACD;QACQ,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,gBAAgB;CACvB;AACD;MACM,iBAAiB;MACjB,4BAA4B;MAC5B,gBAAgB;MAChB,eAAe;MACf,iCAAiC;MACjC,yBAAyB;MACzB,iBAAiB;CACtB;AACD;QACQ,cAAc;CACrB;AACD;QACQ,cAAc;CACrB;AACD;QACQ,eAAe;CACtB;AACD;MACM,mBAAmB;MACnB,sBAAsB;CAC3B;AACD;QACQ,oBAAoB;QACpB,eAAe;CACtB;AACD;QACQ,eAAe;CACtB;AACD;MACM,sBAAsB;CAC3B;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,eAAe;CACtB;AACD;MACM,mBAAmB;CACxB;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,YAAY;CACnB;AACD;EACE,cAAc;CACf;AACD;AACA;IACI,qBAAqB;CACxB;AACD;IACI,eAAe;IACf,aAAa;CAChB;AACD;MACM,kBAAkB;CACvB;AACD;MACM,YAAY;MACZ,UAAU;MACV,mBAAmB;CACxB;AACD;QACQ,gBAAgB;CACvB;AACD;MACM,YAAY;MACZ,UAAU;MACV,mBAAmB;CACxB;CACA","file":"index.vue","sourcesContent":["\n.showDesktop[data-v-7e472535], .showMobile[data-v-7e472535] {\n  display: inline-block;\n}\n.hideDesktop[data-v-7e472535], .hideMobile[data-v-7e472535] {\n  display: none;\n}\n.header[data-v-7e472535] {\n  margin-left: 50px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n}\n.header .title[data-v-7e472535] {\n    padding: 10px;\n    font-size: 22px;\n    font-weight: 600;\n    text-transform: uppercase;\n    line-height: 50px;\n    color: #3F2975;\n}\n.manager-link[data-v-7e472535], .new-rsvp-link[data-v-7e472535] {\n  float: right;\n  padding: 7px 10px;\n  margin-right: 30px;\n}\n.manager-link.new-rsvp-link[data-v-7e472535], .new-rsvp-link.new-rsvp-link[data-v-7e472535] {\n    margin-right: 0;\n}\n.manager-link a[data-v-7e472535], .new-rsvp-link a[data-v-7e472535] {\n    text-decoration: none;\n}\n.manager-link i[data-v-7e472535], .new-rsvp-link i[data-v-7e472535] {\n    font-size: 16px;\n}\n.manager-link span[data-v-7e472535], .new-rsvp-link span[data-v-7e472535] {\n    display: inline-block;\n    font-size: 14px;\n    margin-left: 3px;\n}\n.stats[data-v-7e472535] {\n  float: right;\n  margin-right: 20px;\n  padding: 5px 0;\n}\n.stats .stat[data-v-7e472535] {\n    border: 1px solid #aaa;\n    display: inline-block;\n    height: 40px;\n    border-radius: 4px;\n    overflow: hidden;\n    position: relative;\n    -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);\n            box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);\n}\n.stats .stat label[data-v-7e472535], .stats .stat div[data-v-7e472535] {\n      float: left;\n      padding: 8px;\n      height: 100%;\n      font-weight: 600;\n}\n.stats .stat label[data-v-7e472535] {\n      font-size: 12px;\n      vertical-align: middle;\n      color: #fff;\n      line-height: 20px;\n}\n.stats .stat label small[data-v-7e472535] {\n        display: block;\n        font-weight: 100;\n        font-size: 11px;\n        margin-top: 1px;\n}\n.stats .stat div[data-v-7e472535] {\n      background: #fff;\n      border-left: 1px solid #ccc;\n      font-size: 21px;\n      line-height: 1;\n      -webkit-transition: all .5s ease;\n      transition: all .5s ease;\n      max-width: 200px;\n}\n.stats .stat div i[data-v-7e472535] {\n        display: none;\n}\n.stats .stat div.loading span[data-v-7e472535] {\n        display: none;\n}\n.stats .stat div.loading i[data-v-7e472535] {\n        display: block;\n}\n.stats .stat.gross[data-v-7e472535] {\n      margin-right: 10px;\n      border-color: #0baf58;\n}\n.stats .stat.gross label[data-v-7e472535] {\n        background: #26d97a;\n        line-height: 1;\n}\n.stats .stat.gross div[data-v-7e472535] {\n        color: #26d97a;\n}\n.stats .stat.credit[data-v-7e472535] {\n      border-color: #1283a5;\n}\n.stats .stat.credit label[data-v-7e472535] {\n        background: #26b0d9;\n}\n.stats .stat.credit div[data-v-7e472535] {\n        color: #26b0d9;\n}\n.stats .stat.prov-online[data-v-7e472535] {\n      border-color: #333;\n}\n.stats .stat.prov-online label[data-v-7e472535] {\n        background: #555;\n}\n.stats .stat.prov-online div[data-v-7e472535] {\n        color: #555;\n}\n.body[data-v-7e472535] {\n  padding: 20px;\n}\n@media only screen and (max-width: 430px) {\n.body[data-v-7e472535] {\n    padding-bottom: 40px;\n}\n.header[data-v-7e472535] {\n    margin-left: 0;\n    height: auto;\n}\n.header .title[data-v-7e472535] {\n      margin-left: 50px;\n}\n.header .stats[data-v-7e472535] {\n      float: none;\n      margin: 0;\n      text-align: center;\n}\n.header .stats .gross[data-v-7e472535] {\n        margin-right: 0;\n}\n.header .manager-link[data-v-7e472535] {\n      float: none;\n      margin: 0;\n      text-align: center;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RefundCreditModal_vue__ = __webpack_require__(619);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d833e4fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RefundCreditModal_vue__ = __webpack_require__(1841);
function injectStyle (ssrContext) {
  __webpack_require__(1837)
  __webpack_require__(1839)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d833e4fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RefundCreditModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d833e4fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RefundCreditModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1838);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("23295a6c", content, true, {});

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.reservation-notes-modal[data-v-d833e4fe] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.reservation-notes-modal.show[data-v-d833e4fe] {\n    top: 0;\n    opacity: 1;\n}\n.reservation-notes-modal-container[data-v-d833e4fe] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.reservation-notes-modal-content[data-v-d833e4fe] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.notes-modal .title[data-v-d833e4fe] {\n  color: #fff;\n  background-color: #0D79F2;\n  padding: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.notes-modal .customer-label[data-v-d833e4fe] {\n  padding: 15px 15px 5px;\n  font-size: 14px;\n  color: #333;\n}\n.notes-modal label[data-v-d833e4fe] {\n  display: block;\n  font-weight: 700;\n  font-size: 14px;\n  color: #555;\n  margin-bottom: 5px;\n}\n.notes-modal .cancel-reason[data-v-d833e4fe] {\n  margin-top: 15px;\n}\n.notes-modal .notes[data-v-d833e4fe], .notes-modal .cancel-reason[data-v-d833e4fe] {\n  text-align: left;\n  padding: 15px;\n}\n.notes-modal .notes textarea[data-v-d833e4fe], .notes-modal .notes .textarea[data-v-d833e4fe], .notes-modal .cancel-reason textarea[data-v-d833e4fe], .notes-modal .cancel-reason .textarea[data-v-d833e4fe] {\n    resize: none;\n    display: block;\n    outline: 0;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    width: 100%;\n    border: 1px solid rgba(0, 0, 0, 0.35);\n    height: 100px;\n    font-size: 14px;\n    padding: 10px;\n    line-height: inherit;\n    border-radius: 3px;\n    overflow: auto;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.notes-modal .notes textarea.error[data-v-d833e4fe], .notes-modal .notes .textarea.error[data-v-d833e4fe], .notes-modal .cancel-reason textarea.error[data-v-d833e4fe], .notes-modal .cancel-reason .textarea.error[data-v-d833e4fe] {\n      border-color: #F20D0D;\n      border-width: 2px;\n      background-color: rgba(242, 13, 13, 0.03);\n      border-radius: 0;\n      border-top-left-radius: 3px;\n      border-top-right-radius: 3px;\n}\n.notes-modal .notes span[data-v-d833e4fe], .notes-modal .cancel-reason span[data-v-d833e4fe] {\n    display: block;\n    text-align: left;\n    font-size: 14px;\n    margin-top: 2px;\n    font-weight: 700;\n    color: #777;\n}\n.notes-modal .status[data-v-d833e4fe], .notes-modal .cancel-reason[data-v-d833e4fe] {\n  text-align: left;\n  padding: 0 20px 15px;\n}\n.notes-modal .status select[data-v-d833e4fe], .notes-modal .cancel-reason select[data-v-d833e4fe] {\n    display: block;\n    outline: 0;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    border: 1px solid rgba(0, 0, 0, 0.35);\n    font-size: 14px;\n    padding: 10px;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n}\n.notes-modal .controls[data-v-d833e4fe] {\n  padding: 0 15px 15px;\n}\n.notes-modal .controls .padding-L[data-v-d833e4fe] {\n    padding-left: 7px;\n}\n.notes-modal .controls .padding-R[data-v-d833e4fe] {\n    padding-right: 7px;\n}\n.notes-modal .error-message[data-v-d833e4fe] {\n  background-color: #F20D0D;\n  color: #fff;\n  font-size: 12px;\n  text-align: center;\n  font-weight: 700;\n  padding: 0 3px;\n  height: 0;\n  overflow: hidden;\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.notes-modal .error-message.show[data-v-d833e4fe] {\n    height: 26px;\n    padding: 3px 3px;\n}\n.success-modal[data-v-d833e4fe] {\n  padding: 15px 0;\n}\n.success-modal i[data-v-d833e4fe] {\n    color: #26D97A;\n    margin-bottom: 10px;\n}\n.success-modal .message[data-v-d833e4fe] {\n    font-weight: 700;\n    color: #555;\n}\n.full-refund[data-v-d833e4fe] {\n  padding: 10px 20px;\n  font-size: 13px;\n  background: #f7eeb2;\n  border: 1px solid #d0be42;\n  border-radius: 4px;\n  margin: 10px 10px 0;\n  line-height: 140%;\n}\n.full-refund span[data-v-d833e4fe] {\n    display: block;\n}\n.full-refund label[data-v-d833e4fe] {\n    display: inline-block;\n    margin: 10px 20px 0;\n    cursor: pointer;\n}\n.full-refund label input[data-v-d833e4fe] {\n      margin: 0 3px 0 0;\n      width: auto;\n      display: inline-block;\n      vertical-align: -1px;\n}\n.cancel-fee-loader[data-v-d833e4fe] {\n  color: #5da3f0;\n  margin-top: 10px;\n}\n.cancellation-fee[data-v-d833e4fe] {\n  padding: 10px 20px;\n  font-size: 12.5px;\n  background: #f4c6c6;\n  border: 1px solid #e75e5e;\n  border-radius: 4px;\n  margin: 10px 10px 0;\n  line-height: 140%;\n}\n.cancellation-fee span[data-v-d833e4fe] {\n    display: block;\n}\n.cancellation-fee label[data-v-d833e4fe] {\n    display: inline-block;\n    margin: 10px 20px 0;\n    cursor: pointer;\n}\n.cancellation-fee label input[data-v-d833e4fe] {\n      margin: 0 3px 0 0;\n      width: auto;\n      display: inline-block;\n      vertical-align: -1px;\n}\n.partial-refund[data-v-d833e4fe] {\n  padding: 10px;\n  text-align: left;\n}\n.partial-refund label[data-v-d833e4fe] {\n    line-height: 1;\n}\n.refund-field[data-v-d833e4fe] {\n  line-height: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.refund-field select[data-v-d833e4fe] {\n    padding: 5px;\n    font-size: 15px;\n    height: 40px;\n    vertical-align: top;\n}\n.refund-field .refund-input[data-v-d833e4fe] {\n    vertical-align: top;\n    width: 0;\n    opacity: 0;\n    position: relative;\n    -webkit-transition: all .3s ease-in;\n    transition: all .3s ease-in;\n}\n.refund-field .refund-input i[data-v-d833e4fe] {\n      position: absolute;\n      z-index: 2;\n      top: 50%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      left: 5px;\n      color: #ccc;\n}\n.refund-field .refund-input input[data-v-d833e4fe] {\n      margin: 0;\n      height: 40px;\n      border-color: #999;\n      padding-left: 22px;\n      position: relative;\n      border-radius: 0 3px 3px 0;\n      z-index: 1;\n}\n.refund-field .refund-input input.has-error[data-v-d833e4fe] {\n        border-color: #ff6115;\n}\n.refund-field span.has-error[data-v-d833e4fe] {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    padding: 4px 5px;\n    background: #ff6115;\n    color: #fff;\n    font-size: 13px;\n    line-height: 1;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.refund-field.show-input select[data-v-d833e4fe] {\n    border-right: none;\n    border-radius: 3px 0 0 3px;\n}\n.refund-field.show-input .refund-input[data-v-d833e4fe] {\n    width: 120px;\n    opacity: 1;\n}\n.refund-fail[data-v-d833e4fe] {\n  padding: 20px;\n}\n.refund-fail i[data-v-d833e4fe] {\n    margin-bottom: 10px;\n}\n.refund-fail i.fa-exclamation-triangle[data-v-d833e4fe] {\n      color: #ffc800;\n}\n.refund-fail i.fa-thumbs-up[data-v-d833e4fe] {\n      color: #26d97a;\n}\n.refund-fail .message[data-v-d833e4fe] {\n    font-size: 15px;\n    margin-bottom: 20px;\n}\n.cancel-error[data-v-d833e4fe] {\n  background-color: red;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  text-align: center;\n  padding: 5px;\n}\n.select-error[data-v-d833e4fe] {\n  border: 2px solid red !important;\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.cancellation[data-v-d833e4fe] {\n  text-align: left;\n  padding: 20px;\n  padding-bottom: 5px;\n}\n.cancellation label[data-v-d833e4fe] {\n    display: table-cell;\n}\n.cancellation input[data-v-d833e4fe] {\n    width: auto !important;\n    display: inline-block;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Transactions/RefundCreditModal.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,iBAAiB;CAClB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,cAAc;EACd,iBAAiB;EACjB,0BAA0B;CAC3B;AACD;EACE,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;CACb;AACD;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;CACpB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,cAAc;CACf;AACD;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,yBAAyB;OACtB,sBAAsB;YACjB,iBAAiB;IACzB,+BAA+B;YACvB,uBAAuB;IAC/B,YAAY;IACZ,sCAAsC;IACtC,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;MACM,sBAAsB;MACtB,kBAAkB;MAClB,0CAA0C;MAC1C,iBAAiB;MACjB,4BAA4B;MAC5B,6BAA6B;CAClC;AACD;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,iBAAiB;EACjB,qBAAqB;CACtB;AACD;IACI,eAAe;IACf,WAAW;IACX,+BAA+B;YACvB,uBAAuB;IAC/B,sCAAsC;IACtC,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,wDAAwD;IACxD,6BAA6B;IAC7B,+BAA+B;CAClC;AACD;EACE,qBAAqB;CACtB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,mBAAmB;CACtB;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,+BAA+B;EAC/B,gCAAgC;EAChC,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,aAAa;IACb,iBAAiB;CACpB;AACD;EACE,gBAAgB;CACjB;AACD;IACI,eAAe;IACf,oBAAoB;CACvB;AACD;IACI,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;CACnB;AACD;IACI,eAAe;CAClB;AACD;IACI,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;MACM,kBAAkB;MAClB,YAAY;MACZ,sBAAsB;MACtB,qBAAqB;CAC1B;AACD;EACE,eAAe;EACf,iBAAiB;CAClB;AACD;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;CACnB;AACD;IACI,eAAe;CAClB;AACD;IACI,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;CACnB;AACD;MACM,kBAAkB;MAClB,YAAY;MACZ,sBAAsB;MACtB,qBAAqB;CAC1B;AACD;EACE,cAAc;EACd,iBAAiB;CAClB;AACD;IACI,eAAe;CAClB;AACD;EACE,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;CACpB;AACD;IACI,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,oBAAoB;CACvB;AACD;IACI,oBAAoB;IACpB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,oCAAoC;IACpC,4BAA4B;CAC/B;AACD;MACM,mBAAmB;MACnB,WAAW;MACX,SAAS;MACT,oCAAoC;cAC5B,4BAA4B;MACpC,UAAU;MACV,YAAY;CACjB;AACD;MACM,UAAU;MACV,aAAa;MACb,mBAAmB;MACnB,mBAAmB;MACnB,mBAAmB;MACnB,2BAA2B;MAC3B,WAAW;CAChB;AACD;QACQ,sBAAsB;CAC7B;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,qCAAqC;YAC7B,6BAA6B;CACxC;AACD;IACI,mBAAmB;IACnB,2BAA2B;CAC9B;AACD;IACI,aAAa;IACb,WAAW;CACd;AACD;EACE,cAAc;CACf;AACD;IACI,oBAAoB;CACvB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;CACd;AACD;EACE,iCAAiC;EACjC,yCAAyC;EACzC,wCAAwC;CACzC;AACD;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;CACrB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,uBAAuB;IACvB,sBAAsB;CACzB","file":"RefundCreditModal.vue","sourcesContent":["\n.reservation-notes-modal[data-v-d833e4fe] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.reservation-notes-modal.show[data-v-d833e4fe] {\n    top: 0;\n    opacity: 1;\n}\n.reservation-notes-modal-container[data-v-d833e4fe] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.reservation-notes-modal-content[data-v-d833e4fe] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.notes-modal .title[data-v-d833e4fe] {\n  color: #fff;\n  background-color: #0D79F2;\n  padding: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.notes-modal .customer-label[data-v-d833e4fe] {\n  padding: 15px 15px 5px;\n  font-size: 14px;\n  color: #333;\n}\n.notes-modal label[data-v-d833e4fe] {\n  display: block;\n  font-weight: 700;\n  font-size: 14px;\n  color: #555;\n  margin-bottom: 5px;\n}\n.notes-modal .cancel-reason[data-v-d833e4fe] {\n  margin-top: 15px;\n}\n.notes-modal .notes[data-v-d833e4fe], .notes-modal .cancel-reason[data-v-d833e4fe] {\n  text-align: left;\n  padding: 15px;\n}\n.notes-modal .notes textarea[data-v-d833e4fe], .notes-modal .notes .textarea[data-v-d833e4fe], .notes-modal .cancel-reason textarea[data-v-d833e4fe], .notes-modal .cancel-reason .textarea[data-v-d833e4fe] {\n    resize: none;\n    display: block;\n    outline: 0;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    width: 100%;\n    border: 1px solid rgba(0, 0, 0, 0.35);\n    height: 100px;\n    font-size: 14px;\n    padding: 10px;\n    line-height: inherit;\n    border-radius: 3px;\n    overflow: auto;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.notes-modal .notes textarea.error[data-v-d833e4fe], .notes-modal .notes .textarea.error[data-v-d833e4fe], .notes-modal .cancel-reason textarea.error[data-v-d833e4fe], .notes-modal .cancel-reason .textarea.error[data-v-d833e4fe] {\n      border-color: #F20D0D;\n      border-width: 2px;\n      background-color: rgba(242, 13, 13, 0.03);\n      border-radius: 0;\n      border-top-left-radius: 3px;\n      border-top-right-radius: 3px;\n}\n.notes-modal .notes span[data-v-d833e4fe], .notes-modal .cancel-reason span[data-v-d833e4fe] {\n    display: block;\n    text-align: left;\n    font-size: 14px;\n    margin-top: 2px;\n    font-weight: 700;\n    color: #777;\n}\n.notes-modal .status[data-v-d833e4fe], .notes-modal .cancel-reason[data-v-d833e4fe] {\n  text-align: left;\n  padding: 0 20px 15px;\n}\n.notes-modal .status select[data-v-d833e4fe], .notes-modal .cancel-reason select[data-v-d833e4fe] {\n    display: block;\n    outline: 0;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    border: 1px solid rgba(0, 0, 0, 0.35);\n    font-size: 14px;\n    padding: 10px;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"/assets/img/dropdown-arrow.png\");\n    background-repeat: no-repeat;\n    background-position: right 50%;\n}\n.notes-modal .controls[data-v-d833e4fe] {\n  padding: 0 15px 15px;\n}\n.notes-modal .controls .padding-L[data-v-d833e4fe] {\n    padding-left: 7px;\n}\n.notes-modal .controls .padding-R[data-v-d833e4fe] {\n    padding-right: 7px;\n}\n.notes-modal .error-message[data-v-d833e4fe] {\n  background-color: #F20D0D;\n  color: #fff;\n  font-size: 12px;\n  text-align: center;\n  font-weight: 700;\n  padding: 0 3px;\n  height: 0;\n  overflow: hidden;\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.notes-modal .error-message.show[data-v-d833e4fe] {\n    height: 26px;\n    padding: 3px 3px;\n}\n.success-modal[data-v-d833e4fe] {\n  padding: 15px 0;\n}\n.success-modal i[data-v-d833e4fe] {\n    color: #26D97A;\n    margin-bottom: 10px;\n}\n.success-modal .message[data-v-d833e4fe] {\n    font-weight: 700;\n    color: #555;\n}\n.full-refund[data-v-d833e4fe] {\n  padding: 10px 20px;\n  font-size: 13px;\n  background: #f7eeb2;\n  border: 1px solid #d0be42;\n  border-radius: 4px;\n  margin: 10px 10px 0;\n  line-height: 140%;\n}\n.full-refund span[data-v-d833e4fe] {\n    display: block;\n}\n.full-refund label[data-v-d833e4fe] {\n    display: inline-block;\n    margin: 10px 20px 0;\n    cursor: pointer;\n}\n.full-refund label input[data-v-d833e4fe] {\n      margin: 0 3px 0 0;\n      width: auto;\n      display: inline-block;\n      vertical-align: -1px;\n}\n.cancel-fee-loader[data-v-d833e4fe] {\n  color: #5da3f0;\n  margin-top: 10px;\n}\n.cancellation-fee[data-v-d833e4fe] {\n  padding: 10px 20px;\n  font-size: 12.5px;\n  background: #f4c6c6;\n  border: 1px solid #e75e5e;\n  border-radius: 4px;\n  margin: 10px 10px 0;\n  line-height: 140%;\n}\n.cancellation-fee span[data-v-d833e4fe] {\n    display: block;\n}\n.cancellation-fee label[data-v-d833e4fe] {\n    display: inline-block;\n    margin: 10px 20px 0;\n    cursor: pointer;\n}\n.cancellation-fee label input[data-v-d833e4fe] {\n      margin: 0 3px 0 0;\n      width: auto;\n      display: inline-block;\n      vertical-align: -1px;\n}\n.partial-refund[data-v-d833e4fe] {\n  padding: 10px;\n  text-align: left;\n}\n.partial-refund label[data-v-d833e4fe] {\n    line-height: 1;\n}\n.refund-field[data-v-d833e4fe] {\n  line-height: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.refund-field select[data-v-d833e4fe] {\n    padding: 5px;\n    font-size: 15px;\n    height: 40px;\n    vertical-align: top;\n}\n.refund-field .refund-input[data-v-d833e4fe] {\n    vertical-align: top;\n    width: 0;\n    opacity: 0;\n    position: relative;\n    -webkit-transition: all .3s ease-in;\n    transition: all .3s ease-in;\n}\n.refund-field .refund-input i[data-v-d833e4fe] {\n      position: absolute;\n      z-index: 2;\n      top: 50%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      left: 5px;\n      color: #ccc;\n}\n.refund-field .refund-input input[data-v-d833e4fe] {\n      margin: 0;\n      height: 40px;\n      border-color: #999;\n      padding-left: 22px;\n      position: relative;\n      border-radius: 0 3px 3px 0;\n      z-index: 1;\n}\n.refund-field .refund-input input.has-error[data-v-d833e4fe] {\n        border-color: #ff6115;\n}\n.refund-field span.has-error[data-v-d833e4fe] {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    padding: 4px 5px;\n    background: #ff6115;\n    color: #fff;\n    font-size: 13px;\n    line-height: 1;\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n}\n.refund-field.show-input select[data-v-d833e4fe] {\n    border-right: none;\n    border-radius: 3px 0 0 3px;\n}\n.refund-field.show-input .refund-input[data-v-d833e4fe] {\n    width: 120px;\n    opacity: 1;\n}\n.refund-fail[data-v-d833e4fe] {\n  padding: 20px;\n}\n.refund-fail i[data-v-d833e4fe] {\n    margin-bottom: 10px;\n}\n.refund-fail i.fa-exclamation-triangle[data-v-d833e4fe] {\n      color: #ffc800;\n}\n.refund-fail i.fa-thumbs-up[data-v-d833e4fe] {\n      color: #26d97a;\n}\n.refund-fail .message[data-v-d833e4fe] {\n    font-size: 15px;\n    margin-bottom: 20px;\n}\n.cancel-error[data-v-d833e4fe] {\n  background-color: red;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  text-align: center;\n  padding: 5px;\n}\n.select-error[data-v-d833e4fe] {\n  border: 2px solid red !important;\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.cancellation[data-v-d833e4fe] {\n  text-align: left;\n  padding: 20px;\n  padding-bottom: 5px;\n}\n.cancellation label[data-v-d833e4fe] {\n    display: table-cell;\n}\n.cancellation input[data-v-d833e4fe] {\n    width: auto !important;\n    display: inline-block;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1840);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4d3c6652", content, true, {});

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.notes-custom-label {\n  padding: 15px;\n  font-size: 14px;\n}\n.notes-custom-label .text-left {\n    text-align: left;\n}\n.notes-custom-label .price-difference {\n    margin-top: 10px;\n}\n.notes-custom-label .price-difference span {\n      display: inline-block;\n      margin: 0 10px;\n      font-weight: 600;\n}\n.notes-custom-label .price-difference span.lower {\n        color: #F20D0D;\n}\n.notes-custom-label .price-difference span.higher {\n        color: #26D97A;\n}\n.slide-down-enter-active, .slide-down-leave-active {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter, .slide-down-leave-to {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.reservation-notes-modal.show .notes-modal {\n    height: 100vh;\n    overflow: scroll;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Transactions/RefundCreditModal.vue"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,gBAAgB;CACjB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,iBAAiB;CACpB;AACD;MACM,sBAAsB;MACtB,eAAe;MACf,iBAAiB;CACtB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,eAAe;CACtB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;AACA;IACI,cAAc;IACd,iBAAiB;CACpB;CACA","file":"RefundCreditModal.vue","sourcesContent":["\n.notes-custom-label {\n  padding: 15px;\n  font-size: 14px;\n}\n.notes-custom-label .text-left {\n    text-align: left;\n}\n.notes-custom-label .price-difference {\n    margin-top: 10px;\n}\n.notes-custom-label .price-difference span {\n      display: inline-block;\n      margin: 0 10px;\n      font-weight: 600;\n}\n.notes-custom-label .price-difference span.lower {\n        color: #F20D0D;\n}\n.notes-custom-label .price-difference span.higher {\n        color: #26D97A;\n}\n.slide-down-enter-active, .slide-down-leave-active {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter, .slide-down-leave-to {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.reservation-notes-modal.show .notes-modal {\n    height: 100vh;\n    overflow: scroll;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'reservation-notes-modal': true, show: _vm.show }},[_c('div',{staticClass:"reservation-notes-modal-container"},[_c('div',{staticClass:"reservation-notes-modal-content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"notes-modal"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"cancellation"},[_c('span',[_vm._v("\n             Select refund option:\n           ")]),_vm._v(" "),_c('div',{staticClass:"optionRefund"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cancelFee),expression:"cancelFee"}],attrs:{"type":"radio","name":"cancelFee","value":"0"},domProps:{"checked":_vm._q(_vm.cancelFee,"0")},on:{"change":function($event){_vm.cancelFee="0"}}}),_vm._v("\n               Refund as Credit\n             ")])]),_vm._v(" "),_c('div',{staticClass:"optionRefund"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cancelFee),expression:"cancelFee"}],attrs:{"type":"radio","name":"cancelFee","value":"1"},domProps:{"checked":_vm._q(_vm.cancelFee,"1")},on:{"change":function($event){_vm.cancelFee="1"}}}),_vm._v("\n               Refund Immediately\n             ")])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"controls row"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('a',{class:{'button cta warning block small':true, 'disabled':_vm.isSubmitting},attrs:{"href":"javascript:;"},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('rsvpNotes.cancel')))])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('a',{class:{ 'button cta success block small': true, disabled: _vm.isSubmitting},attrs:{"href":"javascript:;"},on:{"click":_vm.submit}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSubmitting),expression:"isSubmitting"}],staticClass:"fa fa-spinner fa-spin fa-fw"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSubmitting),expression:"!isSubmitting"}]},[_vm._v(_vm._s(_vm.$t('rsvpNotes.confirm')))])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showComplete),expression:"showComplete"}],staticClass:"success-modal"},[_c('i',{staticClass:"fas fa-check-circle fa-fw fa-3x"}),_vm._v(" "),_vm._m(2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('span',[_vm._v("Refund Options")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cancel-reason"},[_c('span',[_vm._v("Notes:")]),_vm._v(" "),_c('textarea')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message"},[_vm._v("\n           Success marked\n           "),_vm._v(" "),_c('span',[_vm._v("reservation")]),_vm._v("\n           as complete.\n         ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filters_vue__ = __webpack_require__(620);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05f03268_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Filters_vue__ = __webpack_require__(1845);
function injectStyle (ssrContext) {
  __webpack_require__(1843)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05f03268"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05f03268_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Filters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1844);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("301a9bdc", content, true, {});

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.filter-box[data-v-05f03268] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  x-justify-content: space-around;\n  x-align-items: stretch;\n  max-width: 100%;\n  margin-bottom: 15px;\n  background: #fafafa;\n  border: 1px solid #aaa;\n  border-radius: 2px;\n}\n.filter[data-v-05f03268] {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: -webkit-fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n}\n.field-label[data-v-05f03268] {\n  font-size: 13px;\n  color: #999;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.search-box[data-v-05f03268] {\n  display: inline-block;\n  padding: 20px 0 20px 15px;\n  position: relative;\n}\n.search-box .error-msg[data-v-05f03268] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: calc(100% - 15px);\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    margin-left: 15px;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: bottom center;\n            transform-origin: bottom center;\n}\n.search[data-v-05f03268] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 330px;\n}\n.search .search-input-box[data-v-05f03268] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-05f03268] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 5px 0 0 5px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-05f03268] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-05f03268] {\n      position: absolute;\n      top: 50%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n}\n.search button[data-v-05f03268] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 5px 5px 0;\n    padding: 0 20px;\n}\n.status[data-v-05f03268] {\n  display: inline-block;\n  padding: 20px 15px;\n  width: 150px;\n}\nselect[data-v-05f03268] {\n  padding: 10px;\n  height: 46px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-05f03268] {\n    background-color: #ebebe4;\n}\n.date-range[data-v-05f03268] {\n  display: inline-block;\n  padding: 20px 20px 25px;\n  background: #f3f3f3;\n  height: 100%;\n  position: relative;\n}\n.date-range select[data-v-05f03268] {\n    width: 150px;\n    margin-right: 5px;\n}\n.date-range .error-msg[data-v-05f03268] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: bottom center;\n            transform-origin: bottom center;\n}\n.datepicker-box[data-v-05f03268] {\n  display: inline-block;\n  width: 110px;\n}\n.extra[data-v-05f03268] {\n  padding: 20px 15px;\n}\n.extra .cta[data-v-05f03268] {\n    margin-top: 15px;\n}\n.export[data-v-05f03268] {\n  text-align: right;\n  padding: 30px 10px 0;\n  width: 130px;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 130px;\n          flex: 0 130px;\n}\n.slide-up-enter-active[data-v-05f03268], .slide-up-leave-active[data-v-05f03268] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-05f03268], .slide-up-leave-to[data-v-05f03268] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.filter-box[data-v-05f03268] {\n    display: block;\n}\n.filter-box .filter[data-v-05f03268] {\n      display: block;\n}\n.filter-box .filter .search-box[data-v-05f03268] {\n        width: 100%;\n        padding: 15px;\n}\n.filter-box .filter .search-box .search[data-v-05f03268] {\n          width: 100%;\n}\n.filter-box .filter .status[data-v-05f03268] {\n        padding: 15px;\n        padding-top: 0;\n}\n.filter-box .filter .date-range[data-v-05f03268] {\n        display: block;\n}\n.filter-box .filter .date-range select[data-v-05f03268] {\n          width: 100%;\n}\n.filter-box .filter .date-range .datepicker-box[data-v-05f03268] {\n          width: 49%;\n          margin-top: 10px;\n}\n.filter-box .filter .extra[data-v-05f03268] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        padding: 20px;\n        padding-top: 10px;\n}\n.filter-box .filter .extra .status[data-v-05f03268] {\n          padding: 0;\n}\n.filter-box .filter .extra .cta[data-v-05f03268] {\n          margin-top: 0;\n}\n.filter-box .export[data-v-05f03268] {\n      display: none;\n}\n.filter-box .brand .status[data-v-05f03268] {\n      width: 100%;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Transactions/Filters.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,gCAAgC;EAChC,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;CACpB;AACD;EACE,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,4BAA4B;EAC5B,yBAAyB;EACzB,oBAAoB;CACrB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;CACpB;AACD;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,wCAAwC;YAChC,gCAAgC;CAC3C;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,aAAa;CACd;AACD;IACI,YAAY;IACZ,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,uBAAuB;MACvB,cAAc;MACd,2BAA2B;MAC3B,oBAAoB;CACzB;AACD;QACQ,sBAAsB;CAC7B;AACD;MACM,mBAAmB;MACnB,SAAS;MACT,oCAAoC;cAC5B,4BAA4B;MACpC,WAAW;MACX,eAAe;MACf,gBAAgB;CACrB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;CACnB;AACD;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;CACd;AACD;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,+BAA+B;CAChC;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;CACpB;AACD;IACI,aAAa;IACb,kBAAkB;CACrB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,wCAAwC;YAChC,gCAAgC;CAC3C;AACD;EACE,sBAAsB;EACtB,aAAa;CACd;AACD;EACE,mBAAmB;CACpB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,oBAAoB;MAChB,kBAAkB;UACd,cAAc;CACvB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;AACA;IACI,eAAe;CAClB;AACD;MACM,eAAe;CACpB;AACD;QACQ,YAAY;QACZ,cAAc;CACrB;AACD;UACU,YAAY;CACrB;AACD;QACQ,cAAc;QACd,eAAe;CACtB;AACD;QACQ,eAAe;CACtB;AACD;UACU,YAAY;CACrB;AACD;UACU,WAAW;UACX,iBAAiB;CAC1B;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,uBAAuB;YACnB,oBAAoB;gBAChB,sBAAsB;QAC9B,0BAA0B;YACtB,uBAAuB;gBACnB,+BAA+B;QACvC,cAAc;QACd,kBAAkB;CACzB;AACD;UACU,WAAW;CACpB;AACD;UACU,cAAc;CACvB;AACD;MACM,cAAc;CACnB;AACD;MACM,YAAY;CACjB;CACA","file":"Filters.vue","sourcesContent":["\n.filter-box[data-v-05f03268] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  x-justify-content: space-around;\n  x-align-items: stretch;\n  max-width: 100%;\n  margin-bottom: 15px;\n  background: #fafafa;\n  border: 1px solid #aaa;\n  border-radius: 2px;\n}\n.filter[data-v-05f03268] {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: -webkit-fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n}\n.field-label[data-v-05f03268] {\n  font-size: 13px;\n  color: #999;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.search-box[data-v-05f03268] {\n  display: inline-block;\n  padding: 20px 0 20px 15px;\n  position: relative;\n}\n.search-box .error-msg[data-v-05f03268] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: calc(100% - 15px);\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    margin-left: 15px;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: bottom center;\n            transform-origin: bottom center;\n}\n.search[data-v-05f03268] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 330px;\n}\n.search .search-input-box[data-v-05f03268] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-05f03268] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 5px 0 0 5px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-05f03268] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-05f03268] {\n      position: absolute;\n      top: 50%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%);\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n}\n.search button[data-v-05f03268] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 5px 5px 0;\n    padding: 0 20px;\n}\n.status[data-v-05f03268] {\n  display: inline-block;\n  padding: 20px 15px;\n  width: 150px;\n}\nselect[data-v-05f03268] {\n  padding: 10px;\n  height: 46px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n}\nselect[disabled][data-v-05f03268] {\n    background-color: #ebebe4;\n}\n.date-range[data-v-05f03268] {\n  display: inline-block;\n  padding: 20px 20px 25px;\n  background: #f3f3f3;\n  height: 100%;\n  position: relative;\n}\n.date-range select[data-v-05f03268] {\n    width: 150px;\n    margin-right: 5px;\n}\n.date-range .error-msg[data-v-05f03268] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: center;\n    background: #ff6115;\n    color: #fff;\n    -webkit-transform-origin: bottom center;\n            transform-origin: bottom center;\n}\n.datepicker-box[data-v-05f03268] {\n  display: inline-block;\n  width: 110px;\n}\n.extra[data-v-05f03268] {\n  padding: 20px 15px;\n}\n.extra .cta[data-v-05f03268] {\n    margin-top: 15px;\n}\n.export[data-v-05f03268] {\n  text-align: right;\n  padding: 30px 10px 0;\n  width: 130px;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 130px;\n          flex: 0 130px;\n}\n.slide-up-enter-active[data-v-05f03268], .slide-up-leave-active[data-v-05f03268] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-05f03268], .slide-up-leave-to[data-v-05f03268] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.filter-box[data-v-05f03268] {\n    display: block;\n}\n.filter-box .filter[data-v-05f03268] {\n      display: block;\n}\n.filter-box .filter .search-box[data-v-05f03268] {\n        width: 100%;\n        padding: 15px;\n}\n.filter-box .filter .search-box .search[data-v-05f03268] {\n          width: 100%;\n}\n.filter-box .filter .status[data-v-05f03268] {\n        padding: 15px;\n        padding-top: 0;\n}\n.filter-box .filter .date-range[data-v-05f03268] {\n        display: block;\n}\n.filter-box .filter .date-range select[data-v-05f03268] {\n          width: 100%;\n}\n.filter-box .filter .date-range .datepicker-box[data-v-05f03268] {\n          width: 49%;\n          margin-top: 10px;\n}\n.filter-box .filter .extra[data-v-05f03268] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        padding: 20px;\n        padding-top: 10px;\n}\n.filter-box .filter .extra .status[data-v-05f03268] {\n          padding: 0;\n}\n.filter-box .filter .extra .cta[data-v-05f03268] {\n          margin-top: 0;\n}\n.filter-box .export[data-v-05f03268] {\n      display: none;\n}\n.filter-box .brand .status[data-v-05f03268] {\n      width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"filter-box"},[_c('div',{staticClass:"filter"},[_c('div',{staticClass:"search-box"},[_c('label',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.$t('transactions.filter.search'))+":")]),_vm._v(" "),_c('div',{staticClass:"search"},[_c('div',{staticClass:"search-input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],ref:"search",class:{'has-error':!!_vm.hasError.searchMsg},attrs:{"type":"text","disabled":_vm.isLoading},domProps:{"value":(_vm.searchInput)},on:{"keypress":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search.apply(null, arguments)},_vm.isNumber],"blur":_vm.blurSearch,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchInput.length > 0),expression:"searchInput.length > 0"}],staticClass:"far fa-times-circle fa-lg",on:{"click":_vm.clearSearch}})])],1),_vm._v(" "),_c('button',{class:{'button xsmall success':true, 'disabled':_vm.isLoading},on:{"click":_vm.search}},[_c('i',{staticClass:"fas fa-search fa-lg"})])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.hasError.searchMsg),expression:"!!hasError.searchMsg"}],staticClass:"error-msg"},[_vm._v("\n            "+_vm._s(_vm.hasError.searchMsg)+"\n          ")])])],1),_vm._v(" "),(!_vm.isMobile)?_c('div',{staticClass:"status"},[_c('label',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.$t('transactions.filter.status'))+":")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],attrs:{"disabled":_vm.isLoading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('transactions.filter.all')))]),_vm._v(" "),_c('option',{attrs:{"value":"Declined"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.declined')))]),_vm._v(" "),_c('option',{attrs:{"value":"Cancelled"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.cancelled')))]),_vm._v(" "),_c('option',{attrs:{"value":"Purchased"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.purchased')))]),_vm._v(" "),_c('option',{attrs:{"value":"Promo"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.promo')))]),_vm._v(" "),_c('option',{attrs:{"value":"Authorized"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.authorized')))]),_vm._v(" "),_c('option',{attrs:{"value":"No Show"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.noShow')))]),_vm._v(" "),_c('option',{attrs:{"value":"Completed"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.completed')))]),_vm._v(" "),_c('option',{attrs:{"value":"Refund"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.refund')))]),_vm._v(" "),_c('option',{attrs:{"value":"Edited"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.edited')))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"brand"},[_c('div',{staticClass:"status"},[_c('label',{staticClass:"field-label"},[_vm._v("Brand:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.brand),expression:"brand"}],attrs:{"disabled":_vm.isLoading || _vm.brands.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.brand=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("All Brands")]),_vm._v(" "),_vm._l((_vm.brands.list),function(br,i){return _c('option',{key:i,domProps:{"value":br.id}},[_vm._v(_vm._s(_vm.brandLabel(br)))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"date-range"},[_c('label',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.$t('transactions.filter.dateRange'))+":")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateType),expression:"dateType"}],attrs:{"disabled":_vm.isLoading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dateType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.all')))]),_vm._v(" "),_c('option',{attrs:{"value":"custom"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.custom')))]),_vm._v(" "),_c('option',{attrs:{"value":"withinDay"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.withinDay')))]),_vm._v(" "),_c('option',{attrs:{"value":"monthToDate"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.monthToDate')))]),_vm._v(" "),_c('option',{attrs:{"value":"lastMonth"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.lastMonth')))]),_vm._v(" "),_c('option',{attrs:{"value":"lastWeek"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.lastWeek')))]),_vm._v(" "),_c('option',{attrs:{"value":"last2Week"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.last2Week')))]),_vm._v(" "),_c('option',{attrs:{"value":"last30Days"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.last30Days')))]),_vm._v(" "),_c('option',{attrs:{"value":"last60Days"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.last60Days')))]),_vm._v(" "),_c('option',{attrs:{"value":"last90Days"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.last90Days')))])]),_vm._v(" "),_c('div',{staticClass:"datepicker-box"},[_c('datepicker',{staticClass:"datepicker inline",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.isLoading,"input-class":{'datepicker-empty':_vm.hasError.from},"placeholder":_vm.$t('transactions.filter.from')},on:{"input":function($event){return _vm.changeDate('from')}},model:{value:(_vm.date.from),callback:function ($$v) {_vm.$set(_vm.date, "from", $$v)},expression:"date.from"}})],1),_vm._v(" "),_c('div',{staticClass:"datepicker-box"},[_c('datepicker',{staticClass:"datepicker inline",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.isLoading,"input-class":{'datepicker-empty':_vm.hasError.to},"placeholder":_vm.$t('transactions.filter.to')},on:{"input":function($event){return _vm.changeDate('to')}},model:{value:(_vm.date.to),callback:function ($$v) {_vm.$set(_vm.date, "to", $$v)},expression:"date.to"}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.hasError.fromToMsg),expression:"!!hasError.fromToMsg"}],staticClass:"error-msg"},[_vm._v("\n            "+_vm._s(_vm.hasError.fromToMsg)+"\n          ")])])],1),_vm._v(" "),_c('div',{staticClass:"extra"},[(_vm.isMobile)?_c('div',{staticClass:"status"},[_c('label',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.$t('transactions.filter.status'))+":")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],attrs:{"disabled":_vm.isLoading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('transactions.filter.all')))]),_vm._v(" "),_c('option',{attrs:{"value":"Declined"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.declined')))]),_vm._v(" "),_c('option',{attrs:{"value":"Cancelled"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.cancelled')))]),_vm._v(" "),_c('option',{attrs:{"value":"Purchased"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.purchased')))]),_vm._v(" "),_c('option',{attrs:{"value":"Promo"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.promo')))]),_vm._v(" "),_c('option',{attrs:{"value":"Authorized"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.authorized')))]),_vm._v(" "),_c('option',{attrs:{"value":"No Show"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.noShow')))]),_vm._v(" "),_c('option',{attrs:{"value":"Completed"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.completed')))]),_vm._v(" "),_c('option',{attrs:{"value":"Refund"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.refund')))]),_vm._v(" "),_c('option',{attrs:{"value":"Edited"}},[_vm._v(_vm._s(_vm.$t('transactions.filter.edited')))])])]):_vm._e(),_vm._v(" "),_c('a',{class:{'button cta':true, 'disabled':!_vm.isListEmpty || _vm.isLoading},on:{"click":_vm.refresh}},[_c('i',{class:{'fas fa-sync-alt':true, 'fa-spin':_vm.refreshLoading}}),_vm._v("\n          "+_vm._s(_vm.$t('transactions.filter.refresh'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"export"},[_c('a',{class:{'button cta success':true, 'disabled':!_vm.isListEmpty || _vm.isLoading},on:{"click":_vm.exportTrx}},[_vm._v(_vm._s(_vm.$t('transactions.filter.export')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(622);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376c3714_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1850);
function injectStyle (ssrContext) {
  __webpack_require__(1847)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-376c3714"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376c3714_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1848);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("50debfa4", content, true, {});

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\ntable[data-v-376c3714] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-376c3714] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-376c3714] {\n      padding: 5px 10px;\n}\ntable thead th[data-v-376c3714]:last-child {\n        cursor: default;\n}\ntable thead th i[data-v-376c3714] {\n        display: none;\n}\ntable thead th i.stripe-icon[data-v-376c3714] {\n        display: inline-block;\n}\ntable thead th .fa-sort-up[data-v-376c3714] {\n        vertical-align: -2px;\n}\ntable thead th .fa-sort-down[data-v-376c3714] {\n        vertical-align: 2px;\n}\ntable thead th.sortable[data-v-376c3714] {\n        cursor: pointer;\n        color: #333;\n}\ntable thead th.sortable span[data-v-376c3714] {\n          font-weight: 600;\n          text-decoration: underline;\n}\ntable thead th.sort i[data-v-376c3714] {\n        display: inline-block;\n}\ntable tbody tr[data-v-376c3714] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr[data-v-376c3714]:nth-child(even) {\n      background: #f3f3f3;\n}\ntable tbody tr[data-v-376c3714]:not(.special):hover {\n      background: #d7dbe4;\n}\ntable tbody tr td[data-v-376c3714] {\n      padding: 10px 5px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-376c3714] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-376c3714] {\n          color: #ccc;\n}\ntable tbody tr td.table-block .empty i[data-v-376c3714] {\n          display: block;\n          margin-bottom: 5px;\n          color: #ddd;\n}\ntable tbody tr td a[data-v-376c3714] {\n        font-weight: 600;\n}\ntable a[data-v-376c3714] {\n    cursor: pointer;\n}\ntable .date[data-v-376c3714] {\n    font-size: 12px;\n    color: #777;\n    word-spacing: 5px;\n    width: 135px;\n}\ntable .rsvpId[data-v-376c3714] {\n    position: relative;\n}\ntable .rsvpId a[data-v-376c3714] {\n      position: relative;\n      z-index: 4;\n}\ntable .rsvpId .package-link[data-v-376c3714] {\n      text-decoration: none;\n}\ntable .rsvpId .popup[data-v-376c3714] {\n      width: 370px;\n      /*height: 130px;*/\n      position: absolute;\n      top: 0;\n      left: calc(100% - 8px);\n      z-index: 3;\n      border: 1px solid #777;\n      border-radius: 3px;\n      padding: 5px 10px;\n      background: #fbf9bd;\n      -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);\n              box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);\n      text-align: left;\n      font-size: 13px;\n}\ntable .rsvpId .popup .datetime[data-v-376c3714] {\n        color: #555;\n        margin-bottom: 5px;\n}\ntable .rsvpId .popup .datetime i[data-v-376c3714] {\n          margin-right: 2px;\n}\ntable .rsvpId .popup .field[data-v-376c3714] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        margin-bottom: 2px;\n}\ntable .rsvpId .popup .field .label[data-v-376c3714] {\n          width: 80px;\n          font-weight: 600;\n          font-size: 12px;\n          color: #444;\n}\ntable .rsvpId .popup .field i[data-v-376c3714] {\n          margin-right: 3px;\n}\ntable .rsvpId .popup .field .pickup[data-v-376c3714] {\n          color: #ff8585;\n}\ntable .rsvpId .popup .field .dropoff[data-v-376c3714] {\n          color: #18d22f;\n}\ntable .rsvpId .popup .field .value[data-v-376c3714] {\n          width: 100%;\n          padding-left: 7px;\n}\ntable .rsvpId .popup .paxLuggage-box[data-v-376c3714] {\n        margin-top: 10px;\n}\ntable .rsvpId .popup .paxLuggage[data-v-376c3714] {\n        display: inline-block;\n        margin-right: 10px;\n        font-size: 15px;\n        border-radius: 3px;\n        overflow: hidden;\n        border: 1px solid #444;\n        background: #fafafa;\n        line-height: 1;\n        padding-right: 5px;\n}\ntable .rsvpId .popup .paxLuggage i[data-v-376c3714] {\n          background: #444;\n          padding: 3px 7px;\n          color: #fff;\n}\ntable .type[data-v-376c3714] {\n    width: 74px;\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n}\ntable .type span[data-v-376c3714] {\n      padding: 3px 5px;\n      color: #fff;\n      border-radius: 4px;\n}\ntable .type span.rsvp[data-v-376c3714] {\n        background: #5771d0;\n}\ntable .type span.asap[data-v-376c3714] {\n        background: #d05757;\n}\ntable .type span.package[data-v-376c3714] {\n        background: #26d97a;\n}\ntable .source[data-v-376c3714] {\n    width: 100px;\n}\ntable .source span[data-v-376c3714] {\n      padding: 3px 5px;\n      background: #ccc;\n      color: #fff;\n      border-radius: 3px;\n      font-size: 12px;\n      font-weight: 700;\n}\ntable .source span.Web[data-v-376c3714] {\n        background: #a26d5d;\n}\ntable .source span.Admin[data-v-376c3714] {\n        background: #2b83f1;\n}\ntable .source span.Android[data-v-376c3714] {\n        background: #78c259;\n}\ntable .source span.iOS[data-v-376c3714] {\n        background: #7fc8de;\n}\ntable .source span.CSR[data-v-376c3714] {\n        background: #bb4a91;\n}\ntable .source span.Provider[data-v-376c3714] {\n        background: #3f3f3f;\n}\ntable .final-offer[data-v-376c3714] {\n    width: 85px;\n}\ntable .charge-amount[data-v-376c3714] {\n    width: 120px;\n}\ntable .promo-used[data-v-376c3714] {\n    width: 100px;\n}\ntable .refund i[data-v-376c3714] {\n    color: #ff5f45;\n    font-size: 21px;\n    cursor: pointer;\n}\ntable .refund i.fa-spin[data-v-376c3714] {\n      color: #0D79F2;\n}\n.service-label[data-v-376c3714] {\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 12px;\n  display: inline-block;\n}\n.service-label.shared[data-v-376c3714] {\n    background: #f38d56;\n}\n.service-label.opoli[data-v-376c3714] {\n    background: #26D97A;\n}\n.service-label.black[data-v-376c3714] {\n    background: #777;\n}\n.service-label.SUV[data-v-376c3714], .service-label.suv[data-v-376c3714] {\n    background: #dc3168;\n}\n.service-label.shuttle[data-v-376c3714] {\n    background: #6dabc3;\n}\n.perPage[data-v-376c3714] {\n  padding: 15px 0;\n}\n.perPage span[data-v-376c3714] {\n    font-size: 13px;\n    color: #555;\n    display: inline-block;\n}\n.perPage select[data-v-376c3714] {\n    vertical-align: middle;\n    width: 60px;\n    margin: 0 5px;\n}\n.pagination[data-v-376c3714] {\n  padding: 15px 0;\n  text-align: right;\n}\n.pagination .displaying[data-v-376c3714] {\n    display: inline-block;\n    margin-right: 10px;\n    font-size: 13px;\n    vertical-align: -1px;\n    color: #555;\n}\n.pagination .paging[data-v-376c3714] {\n    display: inline-block;\n    opacity: 1;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.pagination .paging.disabled[data-v-376c3714] {\n      pointer-events: none;\n      opacity: 0.6;\n}\n.pagination .paging .page[data-v-376c3714] {\n      display: inline-block;\n      vertical-align: middle;\n      width: auto;\n}\n.pagination .paging .page[data-v-376c3714]:not([disabled]) {\n        cursor: pointer;\n}\n.pagination .paging .page[data-v-376c3714]:not(:first-child) {\n        margin-left: -5px;\n}\n.pagination .paging .page-btn[data-v-376c3714] {\n      background-color: #f5f5f5;\n      border: 1px solid rgba(0, 0, 0, 0.25);\n      color: #777;\n      padding: 5px 5px;\n      font-size: 12px;\n}\n.pagination .paging .page-btn.disabled[data-v-376c3714] {\n        pointer-events: none;\n        opacity: 0.5;\n}\n.pagination .paging .page-btn i[data-v-376c3714] {\n        line-height: inherit;\n}\n.pagination .paging .page-btn.back[data-v-376c3714] {\n        border-top-left-radius: 3px;\n        border-bottom-left-radius: 3px;\n        border-right: 0;\n}\n.pagination .paging .page-btn.next[data-v-376c3714] {\n        border-top-right-radius: 3px;\n        border-bottom-right-radius: 3px;\n}\n.pagination .paging .page-number[data-v-376c3714] {\n      border-radius: 0;\n      background-color: #fff;\n      border: 1px solid rgba(0, 0, 0, 0.3);\n      line-height: inherit;\n      font-size: 12px;\n      margin: 0;\n      width: 50px;\n      font-weight: 700;\n      padding: 5px 10px;\n      color: #333;\n      text-align: center;\n      -webkit-appearance: none;\n         -moz-appearance: none;\n              appearance: none;\n      outline: 0;\n      -moz-text-align-last: center;\n           text-align-last: center;\n      border-right: 0;\n}\n.status-label[data-v-376c3714] {\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 12px;\n  background: #999;\n  display: inline-block;\n}\n.status-label.Purchased[data-v-376c3714], .status-label.Purchase[data-v-376c3714] {\n    background: #4aadf3;\n}\n.status-label.Completed[data-v-376c3714] {\n    background: #26D97A;\n}\n.status-label.Promo[data-v-376c3714] {\n    background: #f3904a;\n}\n.status-label.Edited[data-v-376c3714], .status-label.Refund[data-v-376c3714] {\n    background: #797979;\n}\n.status-label.No.Show[data-v-376c3714], .status-label.Cancelled[data-v-376c3714], .status-label.Declined[data-v-376c3714] {\n    background: #f54f4f;\n}\n.status-label.Pending.Refund[data-v-376c3714] {\n    background: #098769;\n    color: #fff;\n}\n.status-label.Pending.Refund.NOT_PROCESSED[data-v-376c3714] {\n    background: #FFCC00;\n    color: #505050;\n}\n.status-label.Credit.Conversion[data-v-376c3714] {\n    background: #29c3c3;\n}\n.status-label.Credit.Conversion.RECLAIMED[data-v-376c3714] {\n    background: #bbbbbb;\n}\n.clear[data-v-376c3714] {\n  clear: both;\n}\n.op--modal-container[data-v-376c3714] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-376c3714] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-376c3714] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-376c3714] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.other-means-box[data-v-376c3714], .credit-convert-refund[data-v-376c3714] {\n  background-color: #fff;\n  max-width: 440px;\n  margin: 10px auto;\n  padding: 20px;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  position: relative;\n}\n.other-means-box .title[data-v-376c3714], .credit-convert-refund .title[data-v-376c3714] {\n    text-align: center;\n    display: block;\n    margin-bottom: 10px;\n    font-size: 18px;\n    font-weight: 600;\n    color: #f25e0d;\n}\n.other-means-box .message[data-v-376c3714], .credit-convert-refund .message[data-v-376c3714] {\n    font-size: 14px;\n    text-align: left;\n    display: block;\n    margin-bottom: 20px;\n}\n.credit-convert-refund[data-v-376c3714] {\n  max-width: 400px;\n}\n.credit-convert-refund .message[data-v-376c3714] {\n    text-align: center;\n    font-size: 18px;\n    font-weight: 600;\n    color: #555;\n}\n.credit-convert-refund .note[data-v-376c3714] {\n    text-align: center;\n    font-size: 14px;\n    color: #555;\n    margin-bottom: 30px;\n    display: block;\n}\n.credit-convert-refund a[data-v-376c3714] {\n    text-align: center;\n    display: block;\n    margin-top: 10px;\n    cursor: pointer;\n}\n.slide-right-enter-active[data-v-376c3714], .slide-right-leave-active[data-v-376c3714] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-right-enter[data-v-376c3714], .slide-right-leave-to[data-v-376c3714] {\n  -webkit-transform: translateX(-20px) rotateX(50deg);\n          transform: translateX(-20px) rotateX(50deg);\n  opacity: 0;\n}\n.slide-up-enter-active[data-v-376c3714], .slide-up-leave-active[data-v-376c3714] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-376c3714], .slide-up-leave-to[data-v-376c3714] {\n  -webkit-transform: translateY(30px) rotateX(50deg);\n          transform: translateY(30px) rotateX(50deg);\n  opacity: 0;\n}\n.hideMobile[data-v-376c3714], .hideDesktop[data-v-376c3714] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\ntable[data-v-376c3714] {\n    font-size: 13px;\n}\ntable .type[data-v-376c3714] {\n      width: auto;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      height: 24px;\n      margin-right: 5px;\n}\ntable > div[data-v-376c3714] {\n      margin-bottom: 3px;\n}\n.trans-card[data-v-376c3714] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    background-color: #fff;\n}\n.trans-card a[data-v-376c3714] {\n      font-weight: 900;\n}\n.trans-card .card-header[data-v-376c3714] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n}\n.trans-card .card-header .time[data-v-376c3714] {\n        font-size: 12px;\n        color: #777;\n        word-spacing: 5px;\n}\n.trans-card .card-header .amount[data-v-376c3714] {\n        font-weight: 900;\n        font-size: 20px;\n}\n.trans-card .card-header .amount a[data-v-376c3714] {\n          text-decoration: none;\n}\n.trans-card .card-header .amount i[data-v-376c3714] {\n          font-size: 15px;\n}\n.trans-card .tags[data-v-376c3714] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n}\n.trans-card .tags .rsvp-stats[data-v-376c3714] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n}\n.trans-card .tags .status[data-v-376c3714] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.trans-card .tags .status .refund i[data-v-376c3714] {\n          margin-left: 5px;\n          font-size: 24px;\n}\n.trans-card .title[data-v-376c3714] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      font-size: 16px;\n}\n.trans-card .title .rsvpId[data-v-376c3714] {\n        margin-right: 10px;\n        font-weight: 900;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.trans-card .title .rsvpId .source[data-v-376c3714] {\n          width: auto;\n}\n.trans-card .clock i[data-v-376c3714] {\n      color: #F25E0D;\n}\n.trans-card .clock span[data-v-376c3714] {\n      font-size: 13px;\n}\n.trans-card .pickup i[data-v-376c3714] {\n      color: #d92626;\n}\n.trans-card .dropoff i[data-v-376c3714] {\n      color: #26D97A;\n}\n.trans-card .service-area[data-v-376c3714] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.trans-card .service-area .source[data-v-376c3714] {\n        width: auto;\n        margin-right: 10px;\n}\n.trans-card .toggle-div[data-v-376c3714] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.trans-card .toggle-div .toggle[data-v-376c3714] {\n        font-size: 16px;\n        color: #0e79f2;\n}\n.trans-card .see-more .amount .label[data-v-376c3714] {\n      font-size: 12px;\n}\n.trans-card .see-more > div[data-v-376c3714] {\n      margin: 5px 0;\n}\n}\n.icon[data-v-376c3714] {\n  color: dimgray;\n  font-size: 12px;\n}\n.slide-down-enter-active[data-v-376c3714], .slide-down-leave-active[data-v-376c3714] {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.slide-down-enter[data-v-376c3714], .slide-down-leave-to[data-v-376c3714] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n.pagination[data-v-376c3714] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: reverse;\n      -ms-flex-direction: column-reverse;\n          flex-direction: column-reverse;\n}\n.pagination .displaying[data-v-376c3714] {\n    margin-right: 0;\n}\n.pagination .paging[data-v-376c3714] {\n    margin-bottom: 5px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Transactions/List.vue"],"names":[],"mappings":";AACA;EACE,0BAA0B;EAC1B,YAAY;CACb;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;QACQ,gBAAgB;CACvB;AACD;QACQ,cAAc;CACrB;AACD;QACQ,sBAAsB;CAC7B;AACD;QACQ,qBAAqB;CAC5B;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,gBAAgB;QAChB,YAAY;CACnB;AACD;UACU,iBAAiB;UACjB,2BAA2B;CACpC;AACD;QACQ,sBAAsB;CAC7B;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,kBAAkB;MAClB,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;UACU,eAAe;UACf,mBAAmB;UACnB,YAAY;CACrB;AACD;QACQ,iBAAiB;CACxB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,aAAa;CAChB;AACD;IACI,mBAAmB;CACtB;AACD;MACM,mBAAmB;MACnB,WAAW;CAChB;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,aAAa;MACb,kBAAkB;MAClB,mBAAmB;MACnB,OAAO;MACP,uBAAuB;MACvB,WAAW;MACX,uBAAuB;MACvB,mBAAmB;MACnB,kBAAkB;MAClB,oBAAoB;MACpB,mDAAmD;cAC3C,2CAA2C;MACnD,iBAAiB;MACjB,gBAAgB;CACrB;AACD;QACQ,YAAY;QACZ,mBAAmB;CAC1B;AACD;UACU,kBAAkB;CAC3B;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,mBAAmB;CAC1B;AACD;UACU,YAAY;UACZ,iBAAiB;UACjB,gBAAgB;UAChB,YAAY;CACrB;AACD;UACU,kBAAkB;CAC3B;AACD;UACU,eAAe;CACxB;AACD;UACU,eAAe;CACxB;AACD;UACU,YAAY;UACZ,kBAAkB;CAC3B;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,sBAAsB;QACtB,mBAAmB;QACnB,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,uBAAuB;QACvB,oBAAoB;QACpB,eAAe;QACf,mBAAmB;CAC1B;AACD;UACU,iBAAiB;UACjB,iBAAiB;UACjB,YAAY;CACrB;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;CAC7B;AACD;MACM,iBAAiB;MACjB,YAAY;MACZ,mBAAmB;CACxB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,oBAAoB;CAC3B;AACD;IACI,aAAa;CAChB;AACD;MACM,iBAAiB;MACjB,iBAAiB;MACjB,YAAY;MACZ,mBAAmB;MACnB,gBAAgB;MAChB,iBAAiB;CACtB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,oBAAoB;CAC3B;AACD;IACI,YAAY;CACf;AACD;IACI,aAAa;CAChB;AACD;IACI,aAAa;CAChB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;CACnB;AACD;MACM,eAAe;CACpB;AACD;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,gBAAgB;CACjB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;CACzB;AACD;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;CACjB;AACD;EACE,gBAAgB;EAChB,kBAAkB;CACnB;AACD;IACI,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;CACf;AACD;IACI,sBAAsB;IACtB,WAAW;IACX,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;MACM,qBAAqB;MACrB,aAAa;CAClB;AACD;MACM,sBAAsB;MACtB,uBAAuB;MACvB,YAAY;CACjB;AACD;QACQ,gBAAgB;CACvB;AACD;QACQ,kBAAkB;CACzB;AACD;MACM,0BAA0B;MAC1B,sCAAsC;MACtC,YAAY;MACZ,iBAAiB;MACjB,gBAAgB;CACrB;AACD;QACQ,qBAAqB;QACrB,aAAa;CACpB;AACD;QACQ,qBAAqB;CAC5B;AACD;QACQ,4BAA4B;QAC5B,+BAA+B;QAC/B,gBAAgB;CACvB;AACD;QACQ,6BAA6B;QAC7B,gCAAgC;CACvC;AACD;MACM,iBAAiB;MACjB,uBAAuB;MACvB,qCAAqC;MACrC,qBAAqB;MACrB,gBAAgB;MAChB,UAAU;MACV,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;MAClB,YAAY;MACZ,mBAAmB;MACnB,yBAAyB;SACtB,sBAAsB;cACjB,iBAAiB;MACzB,WAAW;MACX,6BAA6B;WACxB,wBAAwB;MAC7B,gBAAgB;CACrB;AACD;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;IACpB,YAAY;CACf;AACD;IACI,oBAAoB;IACpB,eAAe;CAClB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,YAAY;CACb;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,WAAW;EACX,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,iDAAiD;UACzC,yCAAyC;EACjD,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,oBAAoB;CACvB;AACD;EACE,iBAAiB;CAClB;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;IACpB,eAAe;CAClB;AACD;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;CACnB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,oDAAoD;UAC5C,4CAA4C;EACpD,WAAW;CACZ;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mDAAmD;UAC3C,2CAA2C;EACnD,WAAW;CACZ;AACD;EACE,cAAc;CACf;AACD;AACA;IACI,gBAAgB;CACnB;AACD;MACM,YAAY;MACZ,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,aAAa;MACb,kBAAkB;CACvB;AACD;MACM,mBAAmB;CACxB;AACD;IACI,uBAAuB;IACvB,oBAAoB;IACpB,aAAa;IACb,oBAAoB;IACpB,+BAA+B;IAC/B,oBAAoB;IACpB,uBAAuB;CAC1B;AACD;MACM,iBAAiB;CACtB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,uBAAuB;UACnB,oBAAoB;cAChB,sBAAsB;CACnC;AACD;QACQ,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;CACzB;AACD;QACQ,iBAAiB;QACjB,gBAAgB;CACvB;AACD;UACU,sBAAsB;CAC/B;AACD;UACU,gBAAgB;CACzB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;CAC5C;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,uBAAuB;YACnB,oBAAoB;gBAChB,sBAAsB;CACrC;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;CACrB;AACD;UACU,iBAAiB;UACjB,gBAAgB;CACzB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,gBAAgB;CACrB;AACD;QACQ,mBAAmB;QACnB,iBAAiB;QACjB,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;CACrB;AACD;UACU,YAAY;CACrB;AACD;MACM,eAAe;CACpB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;CACnB;AACD;QACQ,YAAY;QACZ,mBAAmB;CAC1B;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;QACQ,gBAAgB;QAChB,eAAe;CACtB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,cAAc;CACnB;CACA;AACD;EACE,eAAe;EACf,gBAAgB;CACjB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,+BAA+B;MAC3B,mCAAmC;UAC/B,+BAA+B;CACxC;AACD;IACI,gBAAgB;CACnB;AACD;IACI,mBAAmB;CACtB","file":"List.vue","sourcesContent":["\ntable[data-v-376c3714] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-376c3714] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-376c3714] {\n      padding: 5px 10px;\n}\ntable thead th[data-v-376c3714]:last-child {\n        cursor: default;\n}\ntable thead th i[data-v-376c3714] {\n        display: none;\n}\ntable thead th i.stripe-icon[data-v-376c3714] {\n        display: inline-block;\n}\ntable thead th .fa-sort-up[data-v-376c3714] {\n        vertical-align: -2px;\n}\ntable thead th .fa-sort-down[data-v-376c3714] {\n        vertical-align: 2px;\n}\ntable thead th.sortable[data-v-376c3714] {\n        cursor: pointer;\n        color: #333;\n}\ntable thead th.sortable span[data-v-376c3714] {\n          font-weight: 600;\n          text-decoration: underline;\n}\ntable thead th.sort i[data-v-376c3714] {\n        display: inline-block;\n}\ntable tbody tr[data-v-376c3714] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr[data-v-376c3714]:nth-child(even) {\n      background: #f3f3f3;\n}\ntable tbody tr[data-v-376c3714]:not(.special):hover {\n      background: #d7dbe4;\n}\ntable tbody tr td[data-v-376c3714] {\n      padding: 10px 5px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-376c3714] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-376c3714] {\n          color: #ccc;\n}\ntable tbody tr td.table-block .empty i[data-v-376c3714] {\n          display: block;\n          margin-bottom: 5px;\n          color: #ddd;\n}\ntable tbody tr td a[data-v-376c3714] {\n        font-weight: 600;\n}\ntable a[data-v-376c3714] {\n    cursor: pointer;\n}\ntable .date[data-v-376c3714] {\n    font-size: 12px;\n    color: #777;\n    word-spacing: 5px;\n    width: 135px;\n}\ntable .rsvpId[data-v-376c3714] {\n    position: relative;\n}\ntable .rsvpId a[data-v-376c3714] {\n      position: relative;\n      z-index: 4;\n}\ntable .rsvpId .package-link[data-v-376c3714] {\n      text-decoration: none;\n}\ntable .rsvpId .popup[data-v-376c3714] {\n      width: 370px;\n      /*height: 130px;*/\n      position: absolute;\n      top: 0;\n      left: calc(100% - 8px);\n      z-index: 3;\n      border: 1px solid #777;\n      border-radius: 3px;\n      padding: 5px 10px;\n      background: #fbf9bd;\n      -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);\n              box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);\n      text-align: left;\n      font-size: 13px;\n}\ntable .rsvpId .popup .datetime[data-v-376c3714] {\n        color: #555;\n        margin-bottom: 5px;\n}\ntable .rsvpId .popup .datetime i[data-v-376c3714] {\n          margin-right: 2px;\n}\ntable .rsvpId .popup .field[data-v-376c3714] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        margin-bottom: 2px;\n}\ntable .rsvpId .popup .field .label[data-v-376c3714] {\n          width: 80px;\n          font-weight: 600;\n          font-size: 12px;\n          color: #444;\n}\ntable .rsvpId .popup .field i[data-v-376c3714] {\n          margin-right: 3px;\n}\ntable .rsvpId .popup .field .pickup[data-v-376c3714] {\n          color: #ff8585;\n}\ntable .rsvpId .popup .field .dropoff[data-v-376c3714] {\n          color: #18d22f;\n}\ntable .rsvpId .popup .field .value[data-v-376c3714] {\n          width: 100%;\n          padding-left: 7px;\n}\ntable .rsvpId .popup .paxLuggage-box[data-v-376c3714] {\n        margin-top: 10px;\n}\ntable .rsvpId .popup .paxLuggage[data-v-376c3714] {\n        display: inline-block;\n        margin-right: 10px;\n        font-size: 15px;\n        border-radius: 3px;\n        overflow: hidden;\n        border: 1px solid #444;\n        background: #fafafa;\n        line-height: 1;\n        padding-right: 5px;\n}\ntable .rsvpId .popup .paxLuggage i[data-v-376c3714] {\n          background: #444;\n          padding: 3px 7px;\n          color: #fff;\n}\ntable .type[data-v-376c3714] {\n    width: 74px;\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n}\ntable .type span[data-v-376c3714] {\n      padding: 3px 5px;\n      color: #fff;\n      border-radius: 4px;\n}\ntable .type span.rsvp[data-v-376c3714] {\n        background: #5771d0;\n}\ntable .type span.asap[data-v-376c3714] {\n        background: #d05757;\n}\ntable .type span.package[data-v-376c3714] {\n        background: #26d97a;\n}\ntable .source[data-v-376c3714] {\n    width: 100px;\n}\ntable .source span[data-v-376c3714] {\n      padding: 3px 5px;\n      background: #ccc;\n      color: #fff;\n      border-radius: 3px;\n      font-size: 12px;\n      font-weight: 700;\n}\ntable .source span.Web[data-v-376c3714] {\n        background: #a26d5d;\n}\ntable .source span.Admin[data-v-376c3714] {\n        background: #2b83f1;\n}\ntable .source span.Android[data-v-376c3714] {\n        background: #78c259;\n}\ntable .source span.iOS[data-v-376c3714] {\n        background: #7fc8de;\n}\ntable .source span.CSR[data-v-376c3714] {\n        background: #bb4a91;\n}\ntable .source span.Provider[data-v-376c3714] {\n        background: #3f3f3f;\n}\ntable .final-offer[data-v-376c3714] {\n    width: 85px;\n}\ntable .charge-amount[data-v-376c3714] {\n    width: 120px;\n}\ntable .promo-used[data-v-376c3714] {\n    width: 100px;\n}\ntable .refund i[data-v-376c3714] {\n    color: #ff5f45;\n    font-size: 21px;\n    cursor: pointer;\n}\ntable .refund i.fa-spin[data-v-376c3714] {\n      color: #0D79F2;\n}\n.service-label[data-v-376c3714] {\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 12px;\n  display: inline-block;\n}\n.service-label.shared[data-v-376c3714] {\n    background: #f38d56;\n}\n.service-label.opoli[data-v-376c3714] {\n    background: #26D97A;\n}\n.service-label.black[data-v-376c3714] {\n    background: #777;\n}\n.service-label.SUV[data-v-376c3714], .service-label.suv[data-v-376c3714] {\n    background: #dc3168;\n}\n.service-label.shuttle[data-v-376c3714] {\n    background: #6dabc3;\n}\n.perPage[data-v-376c3714] {\n  padding: 15px 0;\n}\n.perPage span[data-v-376c3714] {\n    font-size: 13px;\n    color: #555;\n    display: inline-block;\n}\n.perPage select[data-v-376c3714] {\n    vertical-align: middle;\n    width: 60px;\n    margin: 0 5px;\n}\n.pagination[data-v-376c3714] {\n  padding: 15px 0;\n  text-align: right;\n}\n.pagination .displaying[data-v-376c3714] {\n    display: inline-block;\n    margin-right: 10px;\n    font-size: 13px;\n    vertical-align: -1px;\n    color: #555;\n}\n.pagination .paging[data-v-376c3714] {\n    display: inline-block;\n    opacity: 1;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.pagination .paging.disabled[data-v-376c3714] {\n      pointer-events: none;\n      opacity: 0.6;\n}\n.pagination .paging .page[data-v-376c3714] {\n      display: inline-block;\n      vertical-align: middle;\n      width: auto;\n}\n.pagination .paging .page[data-v-376c3714]:not([disabled]) {\n        cursor: pointer;\n}\n.pagination .paging .page[data-v-376c3714]:not(:first-child) {\n        margin-left: -5px;\n}\n.pagination .paging .page-btn[data-v-376c3714] {\n      background-color: #f5f5f5;\n      border: 1px solid rgba(0, 0, 0, 0.25);\n      color: #777;\n      padding: 5px 5px;\n      font-size: 12px;\n}\n.pagination .paging .page-btn.disabled[data-v-376c3714] {\n        pointer-events: none;\n        opacity: 0.5;\n}\n.pagination .paging .page-btn i[data-v-376c3714] {\n        line-height: inherit;\n}\n.pagination .paging .page-btn.back[data-v-376c3714] {\n        border-top-left-radius: 3px;\n        border-bottom-left-radius: 3px;\n        border-right: 0;\n}\n.pagination .paging .page-btn.next[data-v-376c3714] {\n        border-top-right-radius: 3px;\n        border-bottom-right-radius: 3px;\n}\n.pagination .paging .page-number[data-v-376c3714] {\n      border-radius: 0;\n      background-color: #fff;\n      border: 1px solid rgba(0, 0, 0, 0.3);\n      line-height: inherit;\n      font-size: 12px;\n      margin: 0;\n      width: 50px;\n      font-weight: 700;\n      padding: 5px 10px;\n      color: #333;\n      text-align: center;\n      -webkit-appearance: none;\n         -moz-appearance: none;\n              appearance: none;\n      outline: 0;\n      -moz-text-align-last: center;\n           text-align-last: center;\n      border-right: 0;\n}\n.status-label[data-v-376c3714] {\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 12px;\n  background: #999;\n  display: inline-block;\n}\n.status-label.Purchased[data-v-376c3714], .status-label.Purchase[data-v-376c3714] {\n    background: #4aadf3;\n}\n.status-label.Completed[data-v-376c3714] {\n    background: #26D97A;\n}\n.status-label.Promo[data-v-376c3714] {\n    background: #f3904a;\n}\n.status-label.Edited[data-v-376c3714], .status-label.Refund[data-v-376c3714] {\n    background: #797979;\n}\n.status-label.No.Show[data-v-376c3714], .status-label.Cancelled[data-v-376c3714], .status-label.Declined[data-v-376c3714] {\n    background: #f54f4f;\n}\n.status-label.Pending.Refund[data-v-376c3714] {\n    background: #098769;\n    color: #fff;\n}\n.status-label.Pending.Refund.NOT_PROCESSED[data-v-376c3714] {\n    background: #FFCC00;\n    color: #505050;\n}\n.status-label.Credit.Conversion[data-v-376c3714] {\n    background: #29c3c3;\n}\n.status-label.Credit.Conversion.RECLAIMED[data-v-376c3714] {\n    background: #bbbbbb;\n}\n.clear[data-v-376c3714] {\n  clear: both;\n}\n.op--modal-container[data-v-376c3714] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-376c3714] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-376c3714] {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content[data-v-376c3714] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.other-means-box[data-v-376c3714], .credit-convert-refund[data-v-376c3714] {\n  background-color: #fff;\n  max-width: 440px;\n  margin: 10px auto;\n  padding: 20px;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  position: relative;\n}\n.other-means-box .title[data-v-376c3714], .credit-convert-refund .title[data-v-376c3714] {\n    text-align: center;\n    display: block;\n    margin-bottom: 10px;\n    font-size: 18px;\n    font-weight: 600;\n    color: #f25e0d;\n}\n.other-means-box .message[data-v-376c3714], .credit-convert-refund .message[data-v-376c3714] {\n    font-size: 14px;\n    text-align: left;\n    display: block;\n    margin-bottom: 20px;\n}\n.credit-convert-refund[data-v-376c3714] {\n  max-width: 400px;\n}\n.credit-convert-refund .message[data-v-376c3714] {\n    text-align: center;\n    font-size: 18px;\n    font-weight: 600;\n    color: #555;\n}\n.credit-convert-refund .note[data-v-376c3714] {\n    text-align: center;\n    font-size: 14px;\n    color: #555;\n    margin-bottom: 30px;\n    display: block;\n}\n.credit-convert-refund a[data-v-376c3714] {\n    text-align: center;\n    display: block;\n    margin-top: 10px;\n    cursor: pointer;\n}\n.slide-right-enter-active[data-v-376c3714], .slide-right-leave-active[data-v-376c3714] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-right-enter[data-v-376c3714], .slide-right-leave-to[data-v-376c3714] {\n  -webkit-transform: translateX(-20px) rotateX(50deg);\n          transform: translateX(-20px) rotateX(50deg);\n  opacity: 0;\n}\n.slide-up-enter-active[data-v-376c3714], .slide-up-leave-active[data-v-376c3714] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-376c3714], .slide-up-leave-to[data-v-376c3714] {\n  -webkit-transform: translateY(30px) rotateX(50deg);\n          transform: translateY(30px) rotateX(50deg);\n  opacity: 0;\n}\n.hideMobile[data-v-376c3714], .hideDesktop[data-v-376c3714] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\ntable[data-v-376c3714] {\n    font-size: 13px;\n}\ntable .type[data-v-376c3714] {\n      width: auto;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      height: 24px;\n      margin-right: 5px;\n}\ntable > div[data-v-376c3714] {\n      margin-bottom: 3px;\n}\n.trans-card[data-v-376c3714] {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    background-color: #fff;\n}\n.trans-card a[data-v-376c3714] {\n      font-weight: 900;\n}\n.trans-card .card-header[data-v-376c3714] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n}\n.trans-card .card-header .time[data-v-376c3714] {\n        font-size: 12px;\n        color: #777;\n        word-spacing: 5px;\n}\n.trans-card .card-header .amount[data-v-376c3714] {\n        font-weight: 900;\n        font-size: 20px;\n}\n.trans-card .card-header .amount a[data-v-376c3714] {\n          text-decoration: none;\n}\n.trans-card .card-header .amount i[data-v-376c3714] {\n          font-size: 15px;\n}\n.trans-card .tags[data-v-376c3714] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n}\n.trans-card .tags .rsvp-stats[data-v-376c3714] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n}\n.trans-card .tags .status[data-v-376c3714] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.trans-card .tags .status .refund i[data-v-376c3714] {\n          margin-left: 5px;\n          font-size: 24px;\n}\n.trans-card .title[data-v-376c3714] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      font-size: 16px;\n}\n.trans-card .title .rsvpId[data-v-376c3714] {\n        margin-right: 10px;\n        font-weight: 900;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.trans-card .title .rsvpId .source[data-v-376c3714] {\n          width: auto;\n}\n.trans-card .clock i[data-v-376c3714] {\n      color: #F25E0D;\n}\n.trans-card .clock span[data-v-376c3714] {\n      font-size: 13px;\n}\n.trans-card .pickup i[data-v-376c3714] {\n      color: #d92626;\n}\n.trans-card .dropoff i[data-v-376c3714] {\n      color: #26D97A;\n}\n.trans-card .service-area[data-v-376c3714] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.trans-card .service-area .source[data-v-376c3714] {\n        width: auto;\n        margin-right: 10px;\n}\n.trans-card .toggle-div[data-v-376c3714] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.trans-card .toggle-div .toggle[data-v-376c3714] {\n        font-size: 16px;\n        color: #0e79f2;\n}\n.trans-card .see-more .amount .label[data-v-376c3714] {\n      font-size: 12px;\n}\n.trans-card .see-more > div[data-v-376c3714] {\n      margin: 5px 0;\n}\n}\n.icon[data-v-376c3714] {\n  color: dimgray;\n  font-size: 12px;\n}\n.slide-down-enter-active[data-v-376c3714], .slide-down-leave-active[data-v-376c3714] {\n  -webkit-transition: all .2s ease;\n  transition: all .2s ease;\n}\n.slide-down-enter[data-v-376c3714], .slide-down-leave-to[data-v-376c3714] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n.pagination[data-v-376c3714] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: reverse;\n      -ms-flex-direction: column-reverse;\n          flex-direction: column-reverse;\n}\n.pagination .displaying[data-v-376c3714] {\n    margin-right: 0;\n}\n.pagination .paging[data-v-376c3714] {\n    margin-bottom: 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getRefundFee: function getRefundFee(VueApp, id, callback) {
    VueApp.$sdk.get('/transaction/' + id + '/fee', {
      token: VueApp.$store.state.session.sessionToken
    }, function (res) {
      callback(res);
    });
  }
});

/***/ }),
/* 1850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{class:{ 'hideMobile':_vm.isMobile }},[_c('thead',[_vm._l((_vm.tableHeader),function(header){return _c('th',{class:{'sort':_vm.sort.active === header.code && !!header.code, 'sortable':!!header.code},on:{"click":function($event){return _vm.sortTable(header.code)}}},[_c('span',[_vm._v(_vm._s(header.label))]),_vm._v(" "),_c('i',{class:['fas', _vm.sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']})])}),_vm._v(" "),_c('th'),_vm._v(" "),_vm._m(0)],2),_vm._v(" "),_c('tbody',[_vm._l((_vm.transactions),function(trx,index){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],key:index},[_c('td',{staticClass:"date"},[_vm._v(_vm._s(trx.date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.serviceArea))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'/#/provider/' + trx.providerId,"target":"_blank"}},[_vm._v(_vm._s(trx.company))])]),_vm._v(" "),_c('td',{staticClass:"rsvpId"},[(!!trx.rsvpId)?_c('a',{attrs:{"href":'/#/reservation/' + trx.rsvpId,"target":"_blank"},on:{"mouseover":function($event){return _vm.showToolTip(index, trx)},"mouseout":function($event){_vm.hoverRsvpInfo = ''}}},[_vm._v(_vm._s(_vm.convertBrand(trx.brandId) + trx.rsvpId))]):_c('a',{staticClass:"package-link",attrs:{"href":'/#/package/' + trx.pkgId,"target":"_blank"}},[_vm._v("\n            "+_vm._s(trx.pkgId)+"\n            "),_c('i',{staticClass:"fas fa-box"})]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-right"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hoverRsvpInfo === index),expression:"hoverRsvpInfo === index"}],staticClass:"popup"},[_c('div',{staticClass:"datetime"},[_c('i',{staticClass:"far fa-clock"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(trx.pickupDate))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('span',{staticClass:"label"},[_c('i',{staticClass:"fas fa-map-marker-alt pickup"}),_vm._v("\n                  "+_vm._s(_vm.$t('transactions.list.pickup'))+"\n                ")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(trx.pickup))])]),_vm._v(" "),(_vm.extraStops[trx.rsvpId] && _vm.extraStops[trx.rsvpId] !== 'none')?_c('div',{staticClass:"field"},[_c('span',{staticClass:"label"},[_c('i',{staticClass:"fas fa-map-marker-alt pickup"}),_vm._v("\n                  Stop\n                ")]),_vm._v(" "),(_vm.extraStops[trx.rsvpId] === 'loading')?_c('span',{staticClass:"value"},[_c('i',{staticClass:"fas fa-spinner fa-spin"})]):_c('span',{staticClass:"value",domProps:{"innerHTML":_vm._s(_vm.extraStops[trx.rsvpId])}})]):_vm._e(),_vm._v(" "),(!trx.isCharter)?_c('div',{staticClass:"field"},[_c('span',{staticClass:"label"},[_c('i',{staticClass:"fas fa-map-marker-alt dropoff"}),_vm._v("\n                  "+_vm._s(_vm.$t('transactions.list.dropoff'))+"\n                ")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(trx.dropoff))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"paxLuggage-box"},[_c('span',{staticClass:"paxLuggage"},[_c('i',{staticClass:"fas fa-user-friends"}),_vm._v("\n                  "+_vm._s(trx.passenger)+"\n                ")]),_vm._v(" "),_c('span',{staticClass:"paxLuggage"},[_c('i',{staticClass:"fas fa-suitcase"}),_vm._v("\n                  "+_vm._s(trx.luggage)+"\n                ")])])])])],1),_vm._v(" "),_c('td',[(trx.eventId === '0')?_c('span',[_vm._v("--")]):_c('span',[_vm._v(_vm._s(trx.eventId))])]),_vm._v(" "),_c('td',{staticClass:"type"},[(trx.pkgId)?_c('span',{staticClass:"package"},[_vm._v("PKG")]):_c('span',{class:[trx.type]},[_vm._v(_vm._s(trx.type))])]),_vm._v(" "),_c('td',[(_vm.useOldQuatation)?_c('span',{class:['service-label', trx.serviceCode]},[_vm._v(_vm._s(trx.serviceLabel))]):_c('span',{staticClass:"service-label",style:({backgroundColor: trx.serviceType.color})},[_vm._v(_vm._s(trx.serviceType.label))])]),_vm._v(" "),_c('td',[(trx.pkgId)?_c('span',[_vm._v("--")]):_c('a',{attrs:{"href":'/#/consumer/' + trx.consumerId,"target":"_blank"}},[_vm._v(_vm._s(trx.firstName + ' ' + trx.lastName))])]),_vm._v(" "),_c('td',[(trx.pkgId)?_c('span',[_vm._v("--")]):_c('span',[_vm._v(_vm._s(trx.email))])]),_vm._v(" "),_c('td',[(trx.pkgId)?_c('span',[_vm._v("--")]):_c('a',{on:{"click":function($event){return _vm.call(trx)}}},[_vm._v(_vm._s(trx.mobile))])]),_vm._v(" "),_c('td',[(trx.pkgId)?_c('span',[_vm._v("--")]):_c('span',[_vm._v(_vm._s(trx.creditCard))])]),_vm._v(" "),_c('td',{staticClass:"source"},[(trx.pkgId)?_c('label',[_vm._v("--")]):_c('span',{class:[trx.source]},[_vm._v(_vm._s(trx.source))])]),_vm._v(" "),_c('td',{staticClass:"final-offer"},[_vm._v(_vm._s(_vm.toFixed(trx.finalOffer)))]),_vm._v(" "),_c('td',{staticClass:"charge-amount"},[_vm._v(_vm._s(_vm.toFixed(trx.chargedAmount)))]),_vm._v(" "),_c('td',{staticClass:"bonus"},[_vm._v(_vm._s(_vm.toFixed(trx.bonus)))]),_vm._v(" "),_c('td',{staticClass:"promo-used"},[_vm._v(_vm._s(_vm.toFixed(trx.promo)))]),_vm._v(" "),_c('td',{staticClass:"cancel-fee"},[_vm._v(_vm._s(_vm.toFixed(trx.cancelFee)))]),_vm._v(" "),_c('td',[_c('span',{class:['status-label', trx.status, trx.notes === 'NOT_PROCESSED' ? 'NOT_PROCESSED' : '', _vm.checkReclaimed(trx)]},[_vm._v(_vm._s(_vm.relabel(trx)))])]),_vm._v(" "),_c('td',{staticClass:"refund"},[(trx.status === 'Pending Refund' && trx.notes === 'NOT_PROCESSED' && trx.creditCard !== 'Terminal')?_c('div',[(_vm.processRefund.loading && _vm.refundTarget === trx.id)?_c('i',{staticClass:"fas fa-spinner fa-lg fa-spin"}):_c('i',{staticClass:"fas fa-hand-holding-usd fa-lg",on:{"click":function($event){return _vm.showProcessRefundModal(trx)}}})]):_vm._e(),_vm._v(" "),(trx.status === 'Credit Conversion' && trx.notes !== 'RECLAIMED' && trx.creditCard !== 'Terminal')?_c('div',[(_vm.cxlConvert.loading && _vm.refundTarget === trx.id)?_c('i',{staticClass:"fas fa-spinner fa-lg fa-spin"}):_c('i',{staticClass:"fas fa-hand-holding-usd fa-lg",on:{"click":function($event){return _vm.showConvertCreditModal(trx)}}})]):(!_vm.hideRefundIcon(trx) && _vm.refundAccess && trx.creditCard !== 'Terminal')?_c('div',[(_vm.refundLoading && _vm.refundTarget === trx.id)?_c('i',{staticClass:"fas fa-spinner fa-lg fa-spin"}):_c('i',{staticClass:"fas fa-hand-holding-usd fa-lg",on:{"click":function($event){return _vm.checkCancellationFee(trx)}}})]):_vm._e()]),_vm._v(" "),_c('td',[(trx.paymentURL === null)?_c('span',[_vm._v("--")]):_c('a',{attrs:{"href":trx.paymentURL,"target":"_blank"}},[_c('i',{staticClass:"fa fa-link"})])])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"special"},[_c('td',{staticClass:"table-block",attrs:{"colspan":"20"}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n              "+_vm._s(_vm.$t('transactions.list.loading'))+"\n            ")])])],1)]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions.length === 0 && !_vm.isLoading),expression:"transactions.length === 0 && !isLoading"}],staticClass:"special"},[_c('td',{staticClass:"table-block",attrs:{"colspan":"20"}},[_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactions.length === 0 && !_vm.isLoading),expression:"transactions.length === 0 && !isLoading"}],staticClass:"empty"},[_c('i',{staticClass:"far fa-frown-open fa-3x"}),_vm._v("\n              "+_vm._s(_vm.$t('transactions.list.empty'))+"\n            ")])])],1)])],2)]),_vm._v(" "),_c('div',{class:[{'hideDesktop':!_vm.isMobile}, 'trans-cards']},_vm._l((_vm.transactions),function(trx,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],key:index,staticClass:"trans-card"},[_c('table',[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"time"},[_vm._v("\n            "+_vm._s(trx.date)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"amount"},[(trx.paymentURL === null)?_c('span',[_vm._v(_vm._s(_vm.toFixed(trx.chargedAmount)))]):_c('a',{attrs:{"href":trx.paymentURL,"target":"_blank"}},[_vm._v(_vm._s(_vm.toFixed(trx.chargedAmount))+" "),_c('i',{staticClass:"fa fa-link"})])])]),_vm._v(" "),_c('div',{staticClass:"tags"},[_c('div',{staticClass:"rsvp-stats"},[_c('div',{staticClass:"type"},[(trx.pkgId)?_c('span',{staticClass:"package"},[_vm._v("PKG")]):_c('span',{class:[trx.type]},[_vm._v(_vm._s(trx.type))])]),_vm._v(" "),_c('div',[(_vm.useOldQuatation)?_c('span',{class:['service-label', trx.serviceCode]},[_vm._v(_vm._s(trx.serviceLabel))]):_c('span',{staticClass:"service-label",style:({backgroundColor: trx.serviceType.color})},[_vm._v(_vm._s(trx.serviceType.label))])])]),_vm._v(" "),_c('div',{staticClass:"status"},[_c('div',[_c('span',{class:['status-label', trx.status, trx.notes === 'NOT_PROCESSED' ? 'NOT_PROCESSED' : '', _vm.checkReclaimed(trx)]},[_vm._v(_vm._s(_vm.relabel(trx)))])]),_vm._v(" "),_c('div',{staticClass:"refund"},[(trx.status === 'Pending Refund' && trx.notes === 'NOT_PROCESSED')?_c('div',[(_vm.processRefund.loading && _vm.refundTarget === trx.id)?_c('i',{staticClass:"fas fa-spinner fa-lg fa-spin"}):_c('i',{staticClass:"fas fa-hand-holding-usd fa-lg",on:{"click":function($event){return _vm.showProcessRefundModal(trx)}}})]):_vm._e(),_vm._v(" "),(trx.status === 'Credit Conversion' && trx.notes !== 'RECLAIMED')?_c('div',[(_vm.cxlConvert.loading && _vm.refundTarget === trx.id)?_c('i',{staticClass:"fas fa-spinner fa-lg fa-spin"}):_c('i',{staticClass:"fas fa-hand-holding-usd fa-lg",on:{"click":function($event){return _vm.showConvertCreditModal(trx)}}})]):(!_vm.hideRefundIcon(trx) && _vm.refundAccess)?_c('div',[(_vm.refundLoading && _vm.refundTarget === trx.id)?_c('i',{staticClass:"fas fa-spinner fa-lg fa-spin"}):_c('i',{staticClass:"fas fa-hand-holding-usd fa-lg",on:{"click":function($event){return _vm.checkCancellationFee(trx)}}})]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"rsvpId"},[(!!trx.rsvpId)?_c('a',{attrs:{"href":'/#/reservation/' + trx.rsvpId,"target":"_blank"},on:{"mouseover":function($event){_vm.hoverRsvpInfo = index},"mouseout":function($event){_vm.hoverRsvpInfo = ''}}},[_vm._v(_vm._s(_vm.convertBrand(trx.brandId) + trx.rsvpId))]):_c('a',{staticClass:"package-link",attrs:{"href":'/#/package/' + trx.pkgId,"target":"_blank"}},[_vm._v("\n              "+_vm._s(trx.pkgId)+"\n              "),_c('i',{staticClass:"fas fa-box"})])]),_vm._v(" "),_c('div',[(trx.eventId === '0')?_c('span',[_vm._v("--")]):_c('span',[_vm._v(_vm._s(trx.eventId))])])]),_vm._v(" "),_c('div',{staticClass:"clock"},[_c('i',{staticClass:"fas fa-clock icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(trx.pickupDate))])]),_vm._v(" "),_c('div',{staticClass:"pickup"},[_c('i',{staticClass:"fas fa-map-marker-alt icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(trx.pickup))])]),_vm._v(" "),_c('div',{staticClass:"dropoff"},[_c('i',{staticClass:"fas fa-location-arrow icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(trx.dropoff))])]),_vm._v(" "),_c('div',[_c('i',{staticClass:"fas fa-user-friends icon"}),_vm._v("\n          "+_vm._s(trx.passenger)+"\n          "),_c('i',{staticClass:"fas fa-suitcase icon"}),_vm._v("\n          "+_vm._s(trx.luggage)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"toggle-div"},[_c('div',{staticClass:"name"},[_c('i',{staticClass:"fas fa-user icon"}),_vm._v(" "),(trx.pkgId)?_c('span',[_vm._v("--")]):_c('a',{attrs:{"href":'/#/consumer/' + trx.consumerId,"target":"_blank"}},[_vm._v(_vm._s(trx.firstName + ' ' + trx.lastName))])]),_vm._v(" "),_c('div',{staticClass:"toggle",on:{"click":function($event){trx.isCollapsible = !trx.isCollapsible}}},[(!trx.isCollapsible)?_c('span',[_c('i',{staticClass:"fas fa-plus-circle"})]):_c('span',[_c('i',{staticClass:"fas fa-minus-circle"})])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(trx.isCollapsible),expression:"trx.isCollapsible"}],staticClass:"see-more"},[_c('div',[_c('i',{staticClass:"fas fa-envelope icon"}),_vm._v(" "),(trx.pkgId)?_c('span',[_vm._v("--")]):_c('span',[_vm._v(_vm._s(trx.email))])]),_vm._v(" "),_c('div',[_c('i',{staticClass:"fas fa-phone icon"}),_vm._v(" "),(trx.pkgId)?_c('span',[_vm._v("--")]):_c('a',{on:{"click":function($event){return _vm.call(trx)}}},[_vm._v(_vm._s(trx.mobile))])]),_vm._v(" "),_c('div',[_c('i',{staticClass:"fas fa-credit-card icon"}),_vm._v(" "),(trx.pkgId)?_c('span',[_vm._v("--")]):_c('span',[_vm._v(_vm._s(trx.creditCard))])]),_vm._v(" "),_c('div',{staticClass:"amount"},[_c('span',{staticClass:"label"},[_vm._v("Final Offer:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.toFixed(trx.finalOffer)))])]),_vm._v(" "),_c('div',{staticClass:"amount"},[_c('span',{staticClass:"label"},[_vm._v("Charged Amount:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.toFixed(trx.chargedAmount)))])]),_vm._v(" "),_c('div',{staticClass:"amount"},[_c('span',{staticClass:"label"},[_vm._v("Bonus:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.toFixed(trx.bonus)))])]),_vm._v(" "),_c('div',{staticClass:"amount"},[_c('span',{staticClass:"label"},[_vm._v("Promo Used:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.toFixed(trx.promo)))])]),_vm._v(" "),_c('div',{staticClass:"amount"},[_c('span',{staticClass:"label"},[_vm._v("Cancel Fee:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.toFixed(trx.cancelFee)))])]),_vm._v(" "),_c('div',{staticClass:"service-area"},[_c('div',{staticClass:"source"},[(trx.pkgId)?_c('label',[_vm._v("--")]):_c('span',{class:[trx.source]},[_vm._v(_vm._s(trx.source))])]),_vm._v(" "),_c('div',{staticClass:"service"},[_vm._v("\n                "+_vm._s(trx.serviceArea)+"\n              ")])])])])],1)])}),0),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('div',{staticClass:"perPage"},[_c('span',[_vm._v(_vm._s(_vm.$t('transactions.list.display')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],attrs:{"disabled":_vm.isLoading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('transactions.list.resultsPerPage')))])])]),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('div',{staticClass:"pagination"},[(_vm.transactions.length)?_c('div',{staticClass:"displaying"},[_vm._v("\n        "+_vm._s(_vm.$t('transactions.list.displaying', _vm.displayingData))+"\n      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"paging"},[_c('a',{class:{'page page-btn back':true, 'disabled':_vm.pagingDisable.prev},on:{"click":function($event){return _vm.getTrasactions('prev', false)}}},[_c('i',{staticClass:"fas fa-fw fa-chevron-left"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.page),expression:"page"}],staticClass:"page page-number",attrs:{"disabled":_vm.pagingDisable.select},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.page=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.totalPage),function(page){return _c('option',{domProps:{"value":page}},[_vm._v(_vm._s(page))])}),0),_vm._v(" "),_c('a',{class:{'page page-btn next':true, 'disabled':_vm.pagingDisable.next},on:{"click":function($event){return _vm.getTrasactions('next', false)}}},[_c('i',{staticClass:"fas fa-fw fa-chevron-right"})])])])]),_vm._v(" "),_c('div',{staticClass:"clear"}),_vm._v(" "),_c('div',{class:{ 'op--modal-container':true, 'hide':!_vm.trxErrorModal },on:{"click":function($event){_vm.trxErrorModal = true}}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content"},[_c('div',{staticClass:"other-means-box",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('transactions.unableToRefund')))]),_vm._v(" "),_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.$t('transactions.otherMeans')))]),_vm._v(" "),_c('a',{staticClass:"button cta warning block",on:{"click":function($event){_vm.trxErrorModal = false}}},[_vm._v(_vm._s(_vm.$t('transactions.close')))])])])])])]),_vm._v(" "),_c('div',{class:{ 'op--modal-container':true, 'hide':!_vm.processRefund.show },on:{"click":function($event){_vm.processRefund.show = false}}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content"},[_c('div',{staticClass:"credit-convert-refund",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',[_c('span',{staticClass:"message"},[_vm._v("Are you sure you want to mark this transaction as processed?")]),_vm._v(" "),_c('div',{staticClass:"button cta success small block",on:{"click":_vm.processRefundExec}},[(!_vm.processRefund.loading)?_c('span',[_vm._v("Yes")]):_c('span',[_vm._v("Loading...")])]),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.processRefund.show = false}}},[_vm._v("No, I changed my mind.")])])])])])]),_vm._v(" "),_c('div',{class:{ 'op--modal-container':true, 'hide':!_vm.cxlConvert.show },on:{"click":function($event){_vm.cxlConvert.show = false}}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content"},[_c('div',{staticClass:"credit-convert-refund",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',[_c('span',{staticClass:"message"},[_vm._v("Are you sure you want to refund this transaction?")]),_vm._v(" "),_c('span',{staticClass:"note"},[_vm._v("This will remove the credits and refund the transactions for this reservation.")]),_vm._v(" "),_c('div',{staticClass:"button cta success small block",on:{"click":_vm.convertCredit}},[(!_vm.cxlConvert.loading)?_c('span',[_vm._v("Yes")]):_c('span',[_vm._v("Loading...")])]),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.cxlConvert.show = false}}},[_vm._v("No, I changed my mind.")])])])])])]),_vm._v(" "),_c('div',{class:{ 'op--modal-container':true, 'hide':!_vm.cxlConvert.error },on:{"click":function($event){_vm.cxlConvert.error = false}}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content"},[_c('div',{staticClass:"other-means-box",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('transactions.unableToRefund')))]),_vm._v(" "),_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.cxlConvert.message))]),_vm._v(" "),_c('a',{staticClass:"button cta warning block",on:{"click":function($event){_vm.cxlConvert.error = false}}},[_vm._v(_vm._s(_vm.$t('transactions.close')))])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('i',{staticClass:"stripe-icon fab fa-stripe-s"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('transactions.title')))]),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('div',{staticClass:"stat gross"},[_c('label',[_vm._v("\n          "+_vm._s(_vm.$t('transactions.gross'))+"\n          "),_c('small',[_vm._v(_vm._s(_vm.$t('transactions.ofDateRange')))])]),_vm._v(" "),_c('div',{class:{'loading':_vm.stats.loading}},[_c('span',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.stats.gross)))]),_vm._v(" "),_c('i',{staticClass:"fas fa-spinner fa-spin"})])]),_vm._v(" "),_c('div',{staticClass:"stat credit"},[_c('label',[_vm._v(_vm._s(_vm.$t('transactions.creditUsed')))]),_vm._v(" "),_c('div',{class:{'loading':_vm.stats.loading}},[_c('span',[_vm._v("$"+_vm._s(_vm.toFixed(_vm.stats.credits)))]),_vm._v(" "),_c('i',{staticClass:"fas fa-spinner fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"manager-link"},[_vm._m(0),_vm._v(" "),_c('a',{class:{'button cta success xsmall':true, 'disabled':!_vm.isListEmpty || _vm.isLoading, 'showMobile':_vm.isMobile, 'hideDesktop':_vm.isDesktop},on:{"click":_vm.exportTrx}},[_c('i',{staticClass:"fas fa-file-export"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('transactions.filter.export')))])])])]),_vm._v(" "),_c('div',{staticClass:"body",attrs:{"id":"top"}},[_c('transactions-filter',{ref:"filter",attrs:{"isMobile":_vm.isMobile}}),_vm._v(" "),_c('transactions-list',{attrs:{"isMobile":_vm.isMobile},on:{"scrollToTop":_vm.scrollToTop}})],1),_vm._v(" "),_c('refund-credit-modal')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button cta warning xsmall",attrs:{"href":"#/code","target":"_blank"}},[_c('i',{staticClass:"fas fa-chart-line"}),_vm._v(" "),_c('span',[_vm._v("Backend Manager")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index2_vue__ = __webpack_require__(623);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2874d92b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index2_vue__ = __webpack_require__(1858);
function injectStyle (ssrContext) {
  __webpack_require__(1853)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2874d92b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2874d92b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1854);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4bd6856d", content, true, {});

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.status[data-v-2874d92b] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-2874d92b], .status.completed[data-v-2874d92b] {\n    background: #26D97A;\n}\n.status.canceled[data-v-2874d92b], .status.cancelled[data-v-2874d92b], .status.failed[data-v-2874d92b] {\n    background: #bbb;\n}\n.status.upcoming[data-v-2874d92b] {\n    background: #f38d56;\n}\n.status.onboard[data-v-2874d92b] {\n    background: #dc3168;\n}\n.status.ready[data-v-2874d92b] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-2874d92b], .status.requires_dispatch[data-v-2874d92b] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-2874d92b] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-2874d92b] {\n    background: #5662f3;\n}\n.flight-status[data-v-2874d92b] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-2874d92b] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-2874d92b] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-2874d92b] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-2874d92b] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-2874d92b] {\n    background-color: #f35656;\n}\n.service-type[data-v-2874d92b] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-2874d92b] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-2874d92b] {\n    background: #26D97A;\n}\n.service-type.black[data-v-2874d92b] {\n    background: #777;\n}\n.service-type.suv[data-v-2874d92b] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-2874d92b] {\n    background: #6dabc3;\n}\n.license-type[data-v-2874d92b] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-2874d92b] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-2874d92b] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-2874d92b] {\n    background-color: #de6c2a;\n}\n.fixed-bottom[data-v-2874d92b] {\n  -webkit-transition: all .6s ease;\n  transition: all .6s ease;\n}\n.toggle-mobile[data-v-2874d92b] {\n  display: none;\n}\n.package-container[data-v-2874d92b] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 500px;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 4px rgba(0, 0, 0, 0.35);\n          box-shadow: 2px 0 4px rgba(0, 0, 0, 0.35);\n  padding: 0 20px 20px;\n  overflow: auto;\n}\n.package-container > .title[data-v-2874d92b] {\n    width: 100%;\n    padding-left: 45px;\n    height: 65px;\n    margin-bottom: 15px;\n}\n.package-container > .title .header[data-v-2874d92b] {\n      font-size: 20px;\n      font-weight: 700;\n      color: #3F2975;\n      line-height: 40px;\n      margin-right: 10px;\n      display: block;\n}\n.package-container > .title .status[data-v-2874d92b] {\n      margin-top: -12px;\n}\n.package-container > .title span[data-v-2874d92b] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.package-map[data-v-2874d92b] {\n  position: fixed;\n  top: 0;\n  left: 500px;\n  height: 100%;\n  width: calc(100% - 500px);\n  display: none;\n}\n.map-here[data-v-2874d92b] {\n  position: fixed;\n  top: 0;\n  left: 500px;\n  height: 100%;\n  width: calc(100% - 500px);\n}\n.label-value[data-v-2874d92b] {\n  margin-top: 10px;\n}\n.label-value .label[data-v-2874d92b] {\n    font-size: 12px;\n    font-weight: 700;\n    margin-bottom: 0;\n    color: #8DA0A9;\n}\n.label-value .value[data-v-2874d92b] {\n    color: #333;\n    word-wrap: break-word;\n}\n.label-value .value.driver-name[data-v-2874d92b] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.label-value .value.service-type[data-v-2874d92b] {\n      color: #fff;\n}\n.label-value .value.status[data-v-2874d92b] {\n      color: #fff;\n      font-size: 16px;\n}\n.label-value .value .info[data-v-2874d92b] {\n      font-weight: 700;\n      margin-top: 5px;\n      margin-bottom: 10px;\n      font-size: 14px;\n}\na[data-v-2874d92b] {\n  font-weight: 700;\n}\n.divider[data-v-2874d92b] {\n  display: block;\n  width: 350px;\n  margin: 20px auto;\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n}\n.stops[data-v-2874d92b] {\n  padding-bottom: 50px;\n}\n.stops .stop[data-v-2874d92b] {\n    padding: 10px;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    background-color: #fff;\n    margin-bottom: 5px;\n    border-radius: 3px;\n    border-top: 3px solid #CA3538;\n    position: relative;\n}\n.stops .stop.pickup[data-v-2874d92b] {\n      border-top: 3px solid #2EE47D;\n}\n.stops .title[data-v-2874d92b] {\n    font-size: 12px;\n    font-weight: 700;\n    margin-bottom: 30px;\n    color: #8DA0A9;\n}\n.stops .name[data-v-2874d92b] {\n    font-size: 14px;\n    margin-bottom: 3px;\n}\n.stops .name i[data-v-2874d92b] {\n      display: inline-block;\n      margin-right: 2px;\n      color: #CA3538;\n}\n.stops .name i.pickup[data-v-2874d92b] {\n        color: #2EE47D;\n}\n.stops .time[data-v-2874d92b] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #555;\n}\n.stops .address[data-v-2874d92b] {\n    margin-top: 5px;\n    font-size: 16px;\n    font-weight: 700;\n    color: #555;\n}\n.stops .misc[data-v-2874d92b] {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    font-size: 14px;\n    color: #555;\n    text-align: right;\n}\n.stops .misc .pax-luggage[data-v-2874d92b] {\n      color: #777;\n      font-size: 12px;\n      font-weight: 700;\n}\n.stops .misc .pax-luggage *[data-v-2874d92b] {\n        display: inline-block;\n        vertical-align: middle;\n}\n.stops .misc .pax-luggage i[data-v-2874d92b] {\n        margin-left: 5px;\n        display: inline-block;\n}\n.stops .misc .pax-luggage span[data-v-2874d92b] {\n        margin-left: 2px;\n}\na.payment-breakdown-button[data-v-2874d92b] {\n  font-size: 10px;\n  display: block;\n}\n.modal-container[data-v-2874d92b] {\n  position: fixed;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 999;\n  background-color: rgba(0, 0, 0, 0.4);\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.modal-container.show[data-v-2874d92b] {\n    opacity: 1;\n    top: 0;\n}\n.modal-container .modal[data-v-2874d92b] {\n    display: table;\n    width: 100%;\n    height: 100%;\n}\n.modal-container .modal-content[data-v-2874d92b] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.payment-breakdown[data-v-2874d92b] {\n  width: 300px;\n  background-color: #fff;\n  margin: 0 auto;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  position: relative;\n}\n.payment-breakdown .close[data-v-2874d92b] {\n    display: block;\n    position: absolute;\n    color: #fff;\n    top: 0;\n    right: 0;\n    padding: 10px 10px;\n}\n.payment-breakdown .title[data-v-2874d92b] {\n    background-color: #333;\n    color: #fff;\n    font-weight: 700;\n    text-align: center;\n    padding: 10px 5px;\n}\n.payment-breakdown .breakdown[data-v-2874d92b] {\n    padding: 5px 15px;\n    font-size: 14px;\n    text-transform: uppercase;\n}\n.payment-breakdown .breakdown.total[data-v-2874d92b] {\n      font-size: 16px;\n      padding: 10px 0 10px;\n      margin: 0 15px;\n      border-top: 1px solid rgba(0, 0, 0, 0.15);\n}\n.payment-breakdown .label[data-v-2874d92b] {\n    text-align: left;\n    color: #555;\n}\n.payment-breakdown .value[data-v-2874d92b] {\n    text-align: right;\n    font-weight: 700;\n}\n.loading-modal-container[data-v-2874d92b] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.loading-modal-container.show[data-v-2874d92b] {\n    top: 0;\n    opacity: 1;\n}\n.loading-modal[data-v-2874d92b] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.loading-modal-content[data-v-2874d92b] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 250px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n  padding: 15px;\n}\n.loading-modal-content i[data-v-2874d92b] {\n    color: #0D79F2;\n}\n.loading-modal-content .message[data-v-2874d92b] {\n    font-weight: 700;\n    color: #777;\n    margin-top: 5px;\n}\n.loading-modal-content .message-sub[data-v-2874d92b] {\n    padding: 0 15px;\n    margin-bottom: 15px;\n}\n.release-modal[data-v-2874d92b] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.release-modal.show[data-v-2874d92b] {\n    top: 0;\n    opacity: 1;\n}\n.release-modal .release-modal-container[data-v-2874d92b] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.unassign[data-v-2874d92b] {\n  margin-top: 25px;\n}\n.release-modal-content[data-v-2874d92b] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.release-modal-content .title[data-v-2874d92b] {\n    font-weight: 700;\n    background-color: #333;\n    color: #fff;\n    padding: 10px;\n}\n.release-modal-content .loading[data-v-2874d92b], .release-modal-content .error[data-v-2874d92b] {\n    text-align: center;\n    padding: 25px 0;\n}\n.release-modal-content .loading i[data-v-2874d92b] {\n    color: #4fa1f7;\n}\n.release-modal-content .loading div[data-v-2874d92b] {\n    color: #999;\n}\n.release-modal-content .error i[data-v-2874d92b] {\n    color: #f3e26d;\n}\n.release-modal-content .error div[data-v-2874d92b] {\n    color: #777;\n    margin-top: 15px;\n}\n.release-modal-content .fee[data-v-2874d92b] {\n    padding: 10px;\n    margin: 10px;\n    background: #f3f3f3;\n    border-radius: 10px;\n    color: #656565;\n    border: 1px solid #808080;\n    -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n            box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n}\n.release-modal-content .fee p[data-v-2874d92b] {\n      margin: 0 0 5px;\n      font-size: 14px;\n}\n.release-modal-content .fee label[data-v-2874d92b] {\n      float: left;\n      width: 50%;\n      font-weight: 600;\n}\n.release-modal-content .fee input[data-v-2874d92b] {\n      width: initial;\n      display: inline-block;\n      margin: 0;\n}\n.release-modal-content .fee .clear[data-v-2874d92b] {\n      clear: both;\n}\n.release-modal-content .message[data-v-2874d92b] {\n    padding: 15px;\n    font-weight: 700;\n    color: #555;\n}\n.release-modal-content .sub-message[data-v-2874d92b] {\n    font-size: 14px;\n    padding: 0 15px 15px;\n    font-weight: 700;\n    color: #777;\n}\n.release-modal-content .sub-message strong[data-v-2874d92b] {\n      color: #555;\n      text-decoration: underline;\n}\n.release-modal-content .controls[data-v-2874d92b] {\n    padding: 0px 15px 15px;\n}\n.release-modal-content .controls .padding-R[data-v-2874d92b] {\n      padding-right: 5px;\n}\n.release-modal-content .controls .padding-L[data-v-2874d92b] {\n      padding-left: 5px;\n}\n.release-modal-content .releasing .message[data-v-2874d92b] {\n    padding-top: 10px;\n}\n.release-modal-content .releasing i[data-v-2874d92b] {\n    margin-top: 18px;\n    color: #0D79F2;\n}\n.release-modal-content .releasing i.success[data-v-2874d92b] {\n      color: #26D97A;\n}\n.release-modal-content .releasing .button[data-v-2874d92b] {\n    margin-top: 10px;\n}\n.fixed-bottom[data-v-2874d92b] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 500px;\n  height: 60px;\n  z-index: 3;\n  background: #eee;\n  padding: 10px 15px 10px 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.25);\n          box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.25);\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.refresh-success[data-v-2874d92b] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  font-size: 15px;\n  line-height: 60px;\n  font-weight: 600;\n  color: #2ed376;\n  background: #fff;\n  z-index: 2;\n}\n.prov-options[data-v-2874d92b] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-left: 5px;\n  cursor: pointer;\n  color: #0D79F2;\n  -webkit-transition: all .4s ease;\n  transition: all .4s ease;\n  position: relative;\n  z-index: 5;\n}\n.prov-options .fa-ellipsis-v[data-v-2874d92b] {\n    font-size: 18px;\n}\n.prov-options[data-v-2874d92b]:hover {\n    color: #333;\n}\n.prov-options .options[data-v-2874d92b] {\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n    position: absolute;\n    top: 120%;\n    width: 200px;\n    background: #fff;\n    padding: 10px;\n    border-radius: 4px;\n    -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);\n            box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);\n}\n.prov-options .options .button[data-v-2874d92b] {\n      margin-bottom: 3px;\n}\n.prov-options .options .button i[data-v-2874d92b] {\n        margin-right: 5px;\n}\n.slide-up-enter-active[data-v-2874d92b], .slide-up-leave-active[data-v-2874d92b] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-2874d92b], .slide-up-leave-to[data-v-2874d92b] {\n  -webkit-transform: translateY(20px);\n          transform: translateY(20px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.map-here[data-v-2874d92b] {\n    width: 100%;\n    z-index: 5;\n}\n.map-here#mapHere[data-v-2874d92b] {\n      left: 0;\n      width: 100%;\n      top: 100%;\n      -webkit-transition: all 0.3s ease;\n      transition: all 0.3s ease;\n}\n.map-here.showMapBox#mapHere[data-v-2874d92b] {\n      top: 0;\n}\n.heading .edit[data-v-2874d92b] {\n    float: none;\n    margin: 0;\n}\n.package-container[data-v-2874d92b] {\n    width: 100%;\n    padding-bottom: 85px;\n}\n.package-container .edit-btn-div[data-v-2874d92b] {\n      padding-left: 13px;\n}\n.package-container .tab[data-v-2874d92b] {\n      margin-top: 50px;\n      display: table;\n}\n.package-container .tab li[data-v-2874d92b] {\n        padding: 12px 10px;\n        vertical-align: middle;\n        display: table-cell;\n        font-size: 12px;\n}\n.toggle-mobile[data-v-2874d92b] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.editing .left-panel[data-v-2874d92b],\n  .editing .fixed-bottom[data-v-2874d92b] {\n    width: 100%;\n}\n.editing .tab li[data-v-2874d92b] {\n    padding: 5px 13px;\n}\n.tab-contents .tab-content[data-v-2874d92b] {\n    padding: 10px;\n}\n.transaction-tab[data-v-2874d92b] {\n    width: -webkit-max-content;\n    width: -moz-max-content;\n    width: max-content;\n}\n.select-user[data-v-2874d92b] {\n    width: 95vw !important;\n    height: auto;\n}\n.right-panel[data-v-2874d92b] {\n    width: calc(100vw - 55px) !important;\n}\n.button.small[data-v-2874d92b] {\n    font-size: 11px;\n    width: auto;\n    padding: 7px;\n}\n.fixed-bottom[data-v-2874d92b] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    width: 100vw;\n    bottom: 45px;\n}\n.fixed-bottom .button.small[data-v-2874d92b] {\n      font-size: 10px;\n      width: auto;\n      padding: 7px 15px;\n}\n.fixed-bottom .create[data-v-2874d92b] {\n      font-size: 14px !important;\n      padding: 10px 22px !important;\n}\n.modal .modal-content[data-v-2874d92b] {\n    width: 100%;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/PackageDetails/index2.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;CAC3B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,cAAc;CACf;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;EAClD,qBAAqB;EACrB,eAAe;CAChB;AACD;IACI,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,oBAAoB;CACvB;AACD;MACM,gBAAgB;MAChB,iBAAiB;MACjB,eAAe;MACf,kBAAkB;MAClB,mBAAmB;MACnB,eAAe;CACpB;AACD;MACM,kBAAkB;CACvB;AACD;MACM,sBAAsB;MACtB,uBAAuB;CAC5B;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,cAAc;CACf;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,YAAY;EACZ,aAAa;EACb,0BAA0B;CAC3B;AACD;EACE,iBAAiB;CAClB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,YAAY;IACZ,sBAAsB;CACzB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;CACnB;AACD;MACM,YAAY;CACjB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;MACM,iBAAiB;MACjB,gBAAgB;MAChB,oBAAoB;MACpB,gBAAgB;CACrB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,yCAAyC;CAC1C;AACD;EACE,qBAAqB;CACtB;AACD;IACI,cAAc;IACd,qCAAqC;IACrC,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;CACtB;AACD;MACM,8BAA8B;CACnC;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;CAClB;AACD;IACI,gBAAgB;IAChB,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,kBAAkB;MAClB,eAAe;CACpB;AACD;QACQ,eAAe;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;CACrB;AACD;MACM,YAAY;MACZ,gBAAgB;MAChB,iBAAiB;CACtB;AACD;QACQ,sBAAsB;QACtB,uBAAuB;CAC9B;AACD;QACQ,iBAAiB;QACjB,sBAAsB;CAC7B;AACD;QACQ,iBAAiB;CACxB;AACD;EACE,gBAAgB;EAChB,eAAe;CAChB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,WAAW;IACX,OAAO;CACV;AACD;IACI,eAAe;IACf,YAAY;IACZ,aAAa;CAChB;AACD;IACI,oBAAoB;IACpB,uBAAuB;CAC1B;AACD;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,iDAAiD;UACzC,yCAAyC;EACjD,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,OAAO;IACP,SAAS;IACT,mBAAmB;CACtB;AACD;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;CACrB;AACD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;CAC7B;AACD;MACM,gBAAgB;MAChB,qBAAqB;MACrB,eAAe;MACf,0CAA0C;CAC/C;AACD;IACI,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,kBAAkB;IAClB,iBAAiB;CACpB;AACD;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;CACf;AACD;IACI,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,oBAAoB;CACvB;AACD;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;IACI,oBAAoB;IACpB,uBAAuB;CAC1B;AACD;EACE,iBAAiB;CAClB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,iBAAiB;CAClB;AACD;IACI,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,cAAc;CACjB;AACD;IACI,mBAAmB;IACnB,gBAAgB;CACnB;AACD;IACI,eAAe;CAClB;AACD;IACI,YAAY;CACf;AACD;IACI,eAAe;CAClB;AACD;IACI,YAAY;IACZ,iBAAiB;CACpB;AACD;IACI,cAAc;IACd,aAAa;IACb,oBAAoB;IACpB,oBAAoB;IACpB,eAAe;IACf,0BAA0B;IAC1B,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;MACM,gBAAgB;MAChB,gBAAgB;CACrB;AACD;MACM,YAAY;MACZ,WAAW;MACX,iBAAiB;CACtB;AACD;MACM,eAAe;MACf,sBAAsB;MACtB,UAAU;CACf;AACD;MACM,YAAY;CACjB;AACD;IACI,cAAc;IACd,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,YAAY;CACf;AACD;MACM,YAAY;MACZ,2BAA2B;CAChC;AACD;IACI,uBAAuB;CAC1B;AACD;MACM,mBAAmB;CACxB;AACD;MACM,kBAAkB;CACvB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,iBAAiB;IACjB,eAAe;CAClB;AACD;MACM,eAAe;CACpB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,aAAa;EACb,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,6BAA6B;EAC7B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,mDAAmD;UAC3C,2CAA2C;EACnD,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;CACjC;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,WAAW;CACZ;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;CACZ;AACD;IACI,gBAAgB;CACnB;AACD;IACI,YAAY;CACf;AACD;IACI,qCAAqC;YAC7B,6BAA6B;IACrC,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;MACM,mBAAmB;CACxB;AACD;QACQ,kBAAkB;CACzB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;AACA;IACI,YAAY;IACZ,WAAW;CACd;AACD;MACM,QAAQ;MACR,YAAY;MACZ,UAAU;MACV,kCAAkC;MAClC,0BAA0B;CAC/B;AACD;MACM,OAAO;CACZ;AACD;IACI,YAAY;IACZ,UAAU;CACb;AACD;IACI,YAAY;IACZ,qBAAqB;CACxB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,iBAAiB;MACjB,eAAe;CACpB;AACD;QACQ,mBAAmB;QACnB,uBAAuB;QACvB,oBAAoB;QACpB,gBAAgB;CACvB;AACD;IACI,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;IACrB,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;CACpB;AACD;;IAEI,YAAY;CACf;AACD;IACI,kBAAkB;CACrB;AACD;IACI,cAAc;CACjB;AACD;IACI,2BAA2B;IAC3B,wBAAwB;IACxB,mBAAmB;CACtB;AACD;IACI,uBAAuB;IACvB,aAAa;CAChB;AACD;IACI,qCAAqC;CACxC;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;CAChB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,yBAAyB;QACrB,sBAAsB;YAClB,wBAAwB;IAChC,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;IAC5B,aAAa;IACb,aAAa;CAChB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,kBAAkB;CACvB;AACD;MACM,2BAA2B;MAC3B,8BAA8B;CACnC;AACD;IACI,YAAY;CACf;CACA","file":"index2.vue","sourcesContent":["\n.status[data-v-2874d92b] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-2874d92b], .status.completed[data-v-2874d92b] {\n    background: #26D97A;\n}\n.status.canceled[data-v-2874d92b], .status.cancelled[data-v-2874d92b], .status.failed[data-v-2874d92b] {\n    background: #bbb;\n}\n.status.upcoming[data-v-2874d92b] {\n    background: #f38d56;\n}\n.status.onboard[data-v-2874d92b] {\n    background: #dc3168;\n}\n.status.ready[data-v-2874d92b] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-2874d92b], .status.requires_dispatch[data-v-2874d92b] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-2874d92b] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-2874d92b] {\n    background: #5662f3;\n}\n.flight-status[data-v-2874d92b] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-2874d92b] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-2874d92b] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-2874d92b] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-2874d92b] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-2874d92b] {\n    background-color: #f35656;\n}\n.service-type[data-v-2874d92b] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-2874d92b] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-2874d92b] {\n    background: #26D97A;\n}\n.service-type.black[data-v-2874d92b] {\n    background: #777;\n}\n.service-type.suv[data-v-2874d92b] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-2874d92b] {\n    background: #6dabc3;\n}\n.license-type[data-v-2874d92b] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-2874d92b] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-2874d92b] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-2874d92b] {\n    background-color: #de6c2a;\n}\n.fixed-bottom[data-v-2874d92b] {\n  -webkit-transition: all .6s ease;\n  transition: all .6s ease;\n}\n.toggle-mobile[data-v-2874d92b] {\n  display: none;\n}\n.package-container[data-v-2874d92b] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 500px;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 4px rgba(0, 0, 0, 0.35);\n          box-shadow: 2px 0 4px rgba(0, 0, 0, 0.35);\n  padding: 0 20px 20px;\n  overflow: auto;\n}\n.package-container > .title[data-v-2874d92b] {\n    width: 100%;\n    padding-left: 45px;\n    height: 65px;\n    margin-bottom: 15px;\n}\n.package-container > .title .header[data-v-2874d92b] {\n      font-size: 20px;\n      font-weight: 700;\n      color: #3F2975;\n      line-height: 40px;\n      margin-right: 10px;\n      display: block;\n}\n.package-container > .title .status[data-v-2874d92b] {\n      margin-top: -12px;\n}\n.package-container > .title span[data-v-2874d92b] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.package-map[data-v-2874d92b] {\n  position: fixed;\n  top: 0;\n  left: 500px;\n  height: 100%;\n  width: calc(100% - 500px);\n  display: none;\n}\n.map-here[data-v-2874d92b] {\n  position: fixed;\n  top: 0;\n  left: 500px;\n  height: 100%;\n  width: calc(100% - 500px);\n}\n.label-value[data-v-2874d92b] {\n  margin-top: 10px;\n}\n.label-value .label[data-v-2874d92b] {\n    font-size: 12px;\n    font-weight: 700;\n    margin-bottom: 0;\n    color: #8DA0A9;\n}\n.label-value .value[data-v-2874d92b] {\n    color: #333;\n    word-wrap: break-word;\n}\n.label-value .value.driver-name[data-v-2874d92b] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.label-value .value.service-type[data-v-2874d92b] {\n      color: #fff;\n}\n.label-value .value.status[data-v-2874d92b] {\n      color: #fff;\n      font-size: 16px;\n}\n.label-value .value .info[data-v-2874d92b] {\n      font-weight: 700;\n      margin-top: 5px;\n      margin-bottom: 10px;\n      font-size: 14px;\n}\na[data-v-2874d92b] {\n  font-weight: 700;\n}\n.divider[data-v-2874d92b] {\n  display: block;\n  width: 350px;\n  margin: 20px auto;\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n}\n.stops[data-v-2874d92b] {\n  padding-bottom: 50px;\n}\n.stops .stop[data-v-2874d92b] {\n    padding: 10px;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    background-color: #fff;\n    margin-bottom: 5px;\n    border-radius: 3px;\n    border-top: 3px solid #CA3538;\n    position: relative;\n}\n.stops .stop.pickup[data-v-2874d92b] {\n      border-top: 3px solid #2EE47D;\n}\n.stops .title[data-v-2874d92b] {\n    font-size: 12px;\n    font-weight: 700;\n    margin-bottom: 30px;\n    color: #8DA0A9;\n}\n.stops .name[data-v-2874d92b] {\n    font-size: 14px;\n    margin-bottom: 3px;\n}\n.stops .name i[data-v-2874d92b] {\n      display: inline-block;\n      margin-right: 2px;\n      color: #CA3538;\n}\n.stops .name i.pickup[data-v-2874d92b] {\n        color: #2EE47D;\n}\n.stops .time[data-v-2874d92b] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #555;\n}\n.stops .address[data-v-2874d92b] {\n    margin-top: 5px;\n    font-size: 16px;\n    font-weight: 700;\n    color: #555;\n}\n.stops .misc[data-v-2874d92b] {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    font-size: 14px;\n    color: #555;\n    text-align: right;\n}\n.stops .misc .pax-luggage[data-v-2874d92b] {\n      color: #777;\n      font-size: 12px;\n      font-weight: 700;\n}\n.stops .misc .pax-luggage *[data-v-2874d92b] {\n        display: inline-block;\n        vertical-align: middle;\n}\n.stops .misc .pax-luggage i[data-v-2874d92b] {\n        margin-left: 5px;\n        display: inline-block;\n}\n.stops .misc .pax-luggage span[data-v-2874d92b] {\n        margin-left: 2px;\n}\na.payment-breakdown-button[data-v-2874d92b] {\n  font-size: 10px;\n  display: block;\n}\n.modal-container[data-v-2874d92b] {\n  position: fixed;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 999;\n  background-color: rgba(0, 0, 0, 0.4);\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.modal-container.show[data-v-2874d92b] {\n    opacity: 1;\n    top: 0;\n}\n.modal-container .modal[data-v-2874d92b] {\n    display: table;\n    width: 100%;\n    height: 100%;\n}\n.modal-container .modal-content[data-v-2874d92b] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.payment-breakdown[data-v-2874d92b] {\n  width: 300px;\n  background-color: #fff;\n  margin: 0 auto;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  position: relative;\n}\n.payment-breakdown .close[data-v-2874d92b] {\n    display: block;\n    position: absolute;\n    color: #fff;\n    top: 0;\n    right: 0;\n    padding: 10px 10px;\n}\n.payment-breakdown .title[data-v-2874d92b] {\n    background-color: #333;\n    color: #fff;\n    font-weight: 700;\n    text-align: center;\n    padding: 10px 5px;\n}\n.payment-breakdown .breakdown[data-v-2874d92b] {\n    padding: 5px 15px;\n    font-size: 14px;\n    text-transform: uppercase;\n}\n.payment-breakdown .breakdown.total[data-v-2874d92b] {\n      font-size: 16px;\n      padding: 10px 0 10px;\n      margin: 0 15px;\n      border-top: 1px solid rgba(0, 0, 0, 0.15);\n}\n.payment-breakdown .label[data-v-2874d92b] {\n    text-align: left;\n    color: #555;\n}\n.payment-breakdown .value[data-v-2874d92b] {\n    text-align: right;\n    font-weight: 700;\n}\n.loading-modal-container[data-v-2874d92b] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.loading-modal-container.show[data-v-2874d92b] {\n    top: 0;\n    opacity: 1;\n}\n.loading-modal[data-v-2874d92b] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.loading-modal-content[data-v-2874d92b] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 250px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n  padding: 15px;\n}\n.loading-modal-content i[data-v-2874d92b] {\n    color: #0D79F2;\n}\n.loading-modal-content .message[data-v-2874d92b] {\n    font-weight: 700;\n    color: #777;\n    margin-top: 5px;\n}\n.loading-modal-content .message-sub[data-v-2874d92b] {\n    padding: 0 15px;\n    margin-bottom: 15px;\n}\n.release-modal[data-v-2874d92b] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.release-modal.show[data-v-2874d92b] {\n    top: 0;\n    opacity: 1;\n}\n.release-modal .release-modal-container[data-v-2874d92b] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.unassign[data-v-2874d92b] {\n  margin-top: 25px;\n}\n.release-modal-content[data-v-2874d92b] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.release-modal-content .title[data-v-2874d92b] {\n    font-weight: 700;\n    background-color: #333;\n    color: #fff;\n    padding: 10px;\n}\n.release-modal-content .loading[data-v-2874d92b], .release-modal-content .error[data-v-2874d92b] {\n    text-align: center;\n    padding: 25px 0;\n}\n.release-modal-content .loading i[data-v-2874d92b] {\n    color: #4fa1f7;\n}\n.release-modal-content .loading div[data-v-2874d92b] {\n    color: #999;\n}\n.release-modal-content .error i[data-v-2874d92b] {\n    color: #f3e26d;\n}\n.release-modal-content .error div[data-v-2874d92b] {\n    color: #777;\n    margin-top: 15px;\n}\n.release-modal-content .fee[data-v-2874d92b] {\n    padding: 10px;\n    margin: 10px;\n    background: #f3f3f3;\n    border-radius: 10px;\n    color: #656565;\n    border: 1px solid #808080;\n    -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n            box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n}\n.release-modal-content .fee p[data-v-2874d92b] {\n      margin: 0 0 5px;\n      font-size: 14px;\n}\n.release-modal-content .fee label[data-v-2874d92b] {\n      float: left;\n      width: 50%;\n      font-weight: 600;\n}\n.release-modal-content .fee input[data-v-2874d92b] {\n      width: initial;\n      display: inline-block;\n      margin: 0;\n}\n.release-modal-content .fee .clear[data-v-2874d92b] {\n      clear: both;\n}\n.release-modal-content .message[data-v-2874d92b] {\n    padding: 15px;\n    font-weight: 700;\n    color: #555;\n}\n.release-modal-content .sub-message[data-v-2874d92b] {\n    font-size: 14px;\n    padding: 0 15px 15px;\n    font-weight: 700;\n    color: #777;\n}\n.release-modal-content .sub-message strong[data-v-2874d92b] {\n      color: #555;\n      text-decoration: underline;\n}\n.release-modal-content .controls[data-v-2874d92b] {\n    padding: 0px 15px 15px;\n}\n.release-modal-content .controls .padding-R[data-v-2874d92b] {\n      padding-right: 5px;\n}\n.release-modal-content .controls .padding-L[data-v-2874d92b] {\n      padding-left: 5px;\n}\n.release-modal-content .releasing .message[data-v-2874d92b] {\n    padding-top: 10px;\n}\n.release-modal-content .releasing i[data-v-2874d92b] {\n    margin-top: 18px;\n    color: #0D79F2;\n}\n.release-modal-content .releasing i.success[data-v-2874d92b] {\n      color: #26D97A;\n}\n.release-modal-content .releasing .button[data-v-2874d92b] {\n    margin-top: 10px;\n}\n.fixed-bottom[data-v-2874d92b] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 500px;\n  height: 60px;\n  z-index: 3;\n  background: #eee;\n  padding: 10px 15px 10px 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.25);\n          box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.25);\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.refresh-success[data-v-2874d92b] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  font-size: 15px;\n  line-height: 60px;\n  font-weight: 600;\n  color: #2ed376;\n  background: #fff;\n  z-index: 2;\n}\n.prov-options[data-v-2874d92b] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-left: 5px;\n  cursor: pointer;\n  color: #0D79F2;\n  -webkit-transition: all .4s ease;\n  transition: all .4s ease;\n  position: relative;\n  z-index: 5;\n}\n.prov-options .fa-ellipsis-v[data-v-2874d92b] {\n    font-size: 18px;\n}\n.prov-options[data-v-2874d92b]:hover {\n    color: #333;\n}\n.prov-options .options[data-v-2874d92b] {\n    -webkit-transform-origin: top center;\n            transform-origin: top center;\n    position: absolute;\n    top: 120%;\n    width: 200px;\n    background: #fff;\n    padding: 10px;\n    border-radius: 4px;\n    -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);\n            box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);\n}\n.prov-options .options .button[data-v-2874d92b] {\n      margin-bottom: 3px;\n}\n.prov-options .options .button i[data-v-2874d92b] {\n        margin-right: 5px;\n}\n.slide-up-enter-active[data-v-2874d92b], .slide-up-leave-active[data-v-2874d92b] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-2874d92b], .slide-up-leave-to[data-v-2874d92b] {\n  -webkit-transform: translateY(20px);\n          transform: translateY(20px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.map-here[data-v-2874d92b] {\n    width: 100%;\n    z-index: 5;\n}\n.map-here#mapHere[data-v-2874d92b] {\n      left: 0;\n      width: 100%;\n      top: 100%;\n      -webkit-transition: all 0.3s ease;\n      transition: all 0.3s ease;\n}\n.map-here.showMapBox#mapHere[data-v-2874d92b] {\n      top: 0;\n}\n.heading .edit[data-v-2874d92b] {\n    float: none;\n    margin: 0;\n}\n.package-container[data-v-2874d92b] {\n    width: 100%;\n    padding-bottom: 85px;\n}\n.package-container .edit-btn-div[data-v-2874d92b] {\n      padding-left: 13px;\n}\n.package-container .tab[data-v-2874d92b] {\n      margin-top: 50px;\n      display: table;\n}\n.package-container .tab li[data-v-2874d92b] {\n        padding: 12px 10px;\n        vertical-align: middle;\n        display: table-cell;\n        font-size: 12px;\n}\n.toggle-mobile[data-v-2874d92b] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.editing .left-panel[data-v-2874d92b],\n  .editing .fixed-bottom[data-v-2874d92b] {\n    width: 100%;\n}\n.editing .tab li[data-v-2874d92b] {\n    padding: 5px 13px;\n}\n.tab-contents .tab-content[data-v-2874d92b] {\n    padding: 10px;\n}\n.transaction-tab[data-v-2874d92b] {\n    width: -webkit-max-content;\n    width: -moz-max-content;\n    width: max-content;\n}\n.select-user[data-v-2874d92b] {\n    width: 95vw !important;\n    height: auto;\n}\n.right-panel[data-v-2874d92b] {\n    width: calc(100vw - 55px) !important;\n}\n.button.small[data-v-2874d92b] {\n    font-size: 11px;\n    width: auto;\n    padding: 7px;\n}\n.fixed-bottom[data-v-2874d92b] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    width: 100vw;\n    bottom: 45px;\n}\n.fixed-bottom .button.small[data-v-2874d92b] {\n      font-size: 10px;\n      width: auto;\n      padding: 7px 15px;\n}\n.fixed-bottom .create[data-v-2874d92b] {\n      font-size: 14px !important;\n      padding: 10px 22px !important;\n}\n.modal .modal-content[data-v-2874d92b] {\n    width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__featureToggle__ = __webpack_require__(5);




/* harmony default export */ __webpack_exports__["a"] = ({
  getPackage: function getPackage(VueApp, id, callback) {
    var self = this;
    VueApp.$sdk.get('/admin/package/' + id, {
      token: VueApp.$store.state.session.sessionToken
    }, function (r) {
      if (r.error) {
        callback(r);
        return;
      }

      if (r.rsvp.length <= 0) {
        callback({
          error: 'Dead Package'
        });
        return;
      }

      callback(self.formatPackage(VueApp, r));
    });
  },
  formatRsvp: function formatRsvp(VueApp, item) {
    var driver = null;
    if (item.provider.ID !== null) {
      driver = {
        id: item.provider.ID,
        driverNum: item.provider.driverNum || item.provider.ID,
        firstName: item.provider.firstName,
        lastName: item.provider.lastName,
        email: item.provider.email,
        phone: item.provider.displayPhone,
        photoUrl: item.provider.avatarUrl
      };
    }
    var flight = null;
    if (item.airline !== null && item.fligtNumber !== null) {
      flight = item.airline + ' ' + item.flightNumber;
    }

    var guest = null;
    if (item.guest.firstName !== null && item.guest.firstName !== '') {
      guest = {
        firstName: item.guest.firstName,
        lastName: item.guest.lastName,
        phone: item.guest.phone
      };
    }

    var statusClass = item.dispatchStatus;
    var status = item.dispatchStatus.toUpperCase();
    if (statusClass === 'requires_dispatch') {
      statusClass = 'requires-dispatch';
      status = 'REQUIRES DISPATCH';
    }

    if (statusClass === 'autodispatch') {
      statusClass = 'auto-dispatch';
      status = 'AUTO DISPATCH';
    }

    if (statusClass === 'complete') {
      status = 'COMPLETED';
    }

    if (statusClass === 'ready') {
      status = 'READY TO GO';
    }

    var serviceType = item.serviceCode.toLowerCase().replace(/(^| )(\w)/g, function (s) {
      return s.toUpperCase();
    });
    if (serviceType === 'Suv') {
      serviceType = 'SUV';
    }
    var serviceLabel = __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].getServiceName(item.serviceCode);
    var serviceBg = '';
    if (item.optinShared && item.optinShared.isOptinShared) {
      serviceLabel = item.serviceType.name;
      serviceBg = item.serviceType.color;
    }

    var completedTime = null;
    if (item.complete) {
      completedTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.complete, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY hh:mmA');
    }

    return {
      isPackage: false,
      airportFee: item.airportFee,
      id: item.ID,
      pickup: {
        address1: item.pickupLocation.addressLine1,
        address2: item.pickupLocation.addressLine2,
        city: item.pickupLocation.city,
        state: item.pickupLocation.state,
        zip: item.pickupLocation.zip,
        lat: item.pickupLocation.lat,
        lng: item.pickupLocation.lng,
        geofenceName: item.pickupLocation.geofenceName,
        geofenceType: item.pickupLocation.geofenceType,
        terminal: item.terminal,
        title: item.pickupLocation.title
      },
      dropoff: {
        address1: item.dropoffLocation.addressLine1,
        address2: item.dropoffLocation.addressLine2,
        city: item.dropoffLocation.city,
        state: item.dropoffLocation.state,
        zip: item.dropoffLocation.zip,
        lat: item.dropoffLocation.lat,
        lng: item.dropoffLocation.lng,
        geofenceName: item.dropoffLocation.geofenceName,
        geofenceType: item.dropoffLocation.geofenceType,
        title: item.dropoffLocation.title
      },
      pickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_2__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      status: status,
      statusClass: statusClass,
      rsvpStatus: item.status,
      customer: {
        id: item.consumer.ID,
        firstName: item.consumer.firstName,
        lastName: item.consumer.lastName,
        email: item.consumer.email,
        phone: item.consumer.displayPhone
      },
      guest: guest,
      driver: driver,
      meetAndGreet: item.pickupType === 'MeetAndGreet',
      airline: item.airline,
      airlineCode: item.airlineCode,
      flightNumber: item.flightNumber,
      flight: flight,
      ada: item.ada ? item.ada : null,
      pax: item.passengers,
      luggage: item.luggage === null ? 0 : item.luggage,
      stops: 1,
      serviceType: serviceType,
      serviceLabel: serviceLabel,
      serviceBg: serviceBg,
      serviceClass: item.serviceCode,
      distance: item.distance,
      etaInSec: item.etaInSec,
      fare: item.payment.fareAmount,
      driverPayment: {
        base: item.payment.driverPay === null ? 0 : item.payment.driverPay,
        bonus: item.payment.driverBonus === null ? 0 : item.payment.driverBonus,
        tip: item.payment.tipAmount === null ? 0 : item.payment.tipAmount,
        pickupFee: item.payment.pickupFee === null ? 0 : item.payment.pickupFee
      },
      completed: completedTime,
      optinShared: item.optinShared || null
    };
  },
  formatPackage: function formatPackage(VueApp, item) {
    var self = this;
    var firstRsvp = item.rsvp.filter(function (rsvp) {
      return rsvp.ID === item.stops[0].reservationID;
    })[0];
    var lastRsvp = item.rsvp.filter(function (rsvp) {
      return rsvp.ID === item.stops[item.stops.length - 1].reservationID;
    })[0];

    var statusClass = item.package.packageStatus ? item.package.packageStatus : item.package.status;
    var status = item.package.packageStatus ? item.package.packageStatus.toUpperCase() : item.package.status.toUpperCase();

    if (statusClass === 'requires_dispatch') {
      statusClass = 'requires-dispatch';
      status = 'REQUIRES DISPATCH';
    }

    if (statusClass === 'autodispatch') {
      statusClass = 'auto-dispatch';
      status = 'AUTO DISPATCH';
    }

    if (statusClass === 'cancelled') {
      statusClass = 'canceled';
      status = 'CANCELED';
    }

    if (statusClass === 'ready') {
      status = 'READY TO GO';
    }

    var luggage = 0;
    var fare = 0;
    var driverPayment = {
      base: item.package.paidForProvider,
      bonus: item.package.bonusToProvider !== null ? item.package.bonusToProvider : 0,
      tip: 0,
      pickupFee: 0,
      gasFee: 0
    };
    var ada = {
      serviceDog: 0,
      wheelChairLift: 0
    };
    var reservations = [];
    var airportFee = 0;
    var tranvelInsurance = 0;
    for (var i = 0; i < item.rsvp.length; i++) {
      var rsvp = item.rsvp[i];
      luggage += rsvp.luggage === null ? 0 : rsvp.luggage;
      fare += rsvp.payment.fareAmount;
      fare += rsvp.payment.tipAmount === null ? 0 : rsvp.payment.tipAmount;
      // driverPayment.base += (rsvp.payment.driverPay === null ? 0 : rsvp.payment.driverPay)
      driverPayment.tip += rsvp.payment.tipAmount === null ? 0 : rsvp.payment.tipAmount;
      driverPayment.pickupFee += rsvp.payment.pickupFee === null ? 0 : rsvp.payment.pickupFee;
      driverPayment.gasFee += rsvp.gasFee === null ? 0 : rsvp.gasFee;

      rsvp.serviceCode = 'shared';
      reservations.push(self.formatRsvp(VueApp, rsvp));

      if (rsvp.travelInsurance !== null) {
        tranvelInsurance += rsvp.travelInsurance;
      }

      if (rsvp.airportFee !== null) {
        airportFee += rsvp.airportFee;
      }

      if (rsvp.ada.serviceDog === 1) {
        ada.serviceDog = 1;
      }
      if (rsvp.ada.wheelChairLift === 1) {
        ada.wheelChairLift = 1;
      }
    }

    var route = [];
    var legs = [];

    var _loop = function _loop(_i) {
      var rsvp = item.rsvp.filter(function (rsvp) {
        return rsvp.ID === item.stops[_i].reservationID;
      })[0];
      var location = rsvp.dropoffLocation;
      if (item.stops[_i].isPickup) {
        location = rsvp.pickupLocation;
      }
      route.push({
        rsvpID: rsvp.ID,
        isPickup: item.stops[_i].isPickup,
        address1: location.addressLine1,
        address2: location.addressLine2,
        city: location.city,
        state: location.state,
        zip: location.zip,
        lat: location.lat,
        lng: location.lng,
        geofenceName: location.geofenceName,
        geofenceType: location.geofenceType,
        status: rsvp.dispatchStatus,
        guestName: rsvp.guest.firstName ? rsvp.guest.firstName + ' ' + rsvp.guest.lastName : rsvp.consumer.firstName + ' ' + rsvp.consumer.lastName
      });

      var leg = self.formatRsvp(VueApp, rsvp);
      leg.isPickup = item.stops[_i].isPickup;
      leg.arrivalTime = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.tz(item.package.pickupTime, 'YYYY-MM-DD@HH:mm', 'America/Los_Angeles').add(item.stops[_i].eta, 'seconds').format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_2__featureToggle__["a" /* default */].timeFormat(VueApp, false));

      legs.push(leg);
    };

    for (var _i = 0; _i < item.stops.length; _i++) {
      _loop(_i);
    }

    var driver = null;
    if (item.driver != null) {
      driver = {
        id: item.driver.ID,
        driverNum: item.driver.driverNum || item.driver.ID,
        firstName: item.driver.firstName,
        lastName: item.driver.lastName,
        email: item.driver.email,
        phone: item.driver.phone,
        photoUrl: item.driver.avatarUrl,
        vehicle: {
          name: item.driver.vehicle.manufacturer + ' ' + item.driver.vehicle.model,
          photoUrl: item.driver.vehicle.photo,
          licensePlate: item.driver.vehicle.licensePlate
        }
      };
    }
    return {
      isPackage: true,
      airportFee: airportFee,
      id: item.package.id,
      pickup: {
        address1: firstRsvp.pickupLocation.addressLine1,
        address2: firstRsvp.pickupLocation.addressLine2,
        city: firstRsvp.pickupLocation.city,
        state: firstRsvp.pickupLocation.state,
        zip: firstRsvp.pickupLocation.zip,
        lat: firstRsvp.pickupLocation.lat,
        lng: firstRsvp.pickupLocation.lng,
        geofenceName: firstRsvp.pickupLocation.geofenceName,
        geofenceType: firstRsvp.pickupLocation.geofenceType,
        title: firstRsvp.pickupLocation.title
      },
      dropoff: {
        address1: lastRsvp.dropoffLocation.addressLine1,
        address2: lastRsvp.dropoffLocation.addressLine2,
        city: lastRsvp.dropoffLocation.city,
        state: lastRsvp.dropoffLocation.state,
        zip: lastRsvp.dropoffLocation.zip,
        lat: lastRsvp.dropoffLocation.lat,
        lng: lastRsvp.dropoffLocation.lng,
        geofenceName: lastRsvp.dropoffLocation.geofenceName,
        geofenceType: lastRsvp.dropoffLocation.geofenceType,
        title: lastRsvp.dropoffLocation.title
      },
      pickupTime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.package.localPickupTime).format('MM/DD/YYYY ' + __WEBPACK_IMPORTED_MODULE_2__featureToggle__["a" /* default */].timeFormat(VueApp, false)),
      status: status,
      statusClass: statusClass,
      customer: null,
      guest: null,
      driver: driver,
      meetAndGreet: false,
      airline: null,
      airlineCode: null,
      flightNumber: null,
      flight: null,
      ada: ada,
      pax: item.package.pax,
      luggage: luggage,
      rsvps: reservations,
      stops: item.package.stops / 2,
      legs: legs,
      route: route,
      serviceType: 'Shared',
      serviceLabel: __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].getServiceName('shared'),
      serviceClass: 'shared',
      fare: fare,
      driverPayment: driverPayment,
      tranvelInsurance: tranvelInsurance
    };
  }
});

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1857);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22), __webpack_require__(156)))

/***/ }),
/* 1858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:['map-here', _vm.showMapMobile ? 'showMapBox' : ''],attrs:{"id":"mapHere"}}),_vm._v(" "),(_vm.package != null)?_c('div',{staticClass:"package-container"},[_c('div',{staticClass:"title"},[_c('span',{staticClass:"header"},[_vm._v("Package "+_vm._s(_vm.packageID)+"\n        "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.package.ada.serviceDog),expression:"package.ada.serviceDog"}],attrs:{"href":"#"}},[_c('i',{staticClass:"fas fa-wheelchair"})]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.package.ada.wheelChairLift),expression:"package.ada.wheelChairLift"}],attrs:{"href":"#"}},[_c('i',{staticClass:"fas fa-dog"})])]),_vm._v(" "),_c('span',{class:'status ' + _vm.package.statusClass},[_vm._v(" "+_vm._s(_vm.package.status))])]),_vm._v(" "),_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.packagePickup')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.getAddress(_vm.package.pickup)))])]),_vm._v(" "),_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.packageDropoff')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.getAddress(_vm.package.dropoff)))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.pickupTime')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.package.pickupTime))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v("PASSENGER / LUGGAGE / STOPS")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.package.pax)+" / "+_vm._s(_vm.package.luggage)+" / "+_vm._s(_vm.package.stops))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.serviceType')))]),_vm._v(" "),(_vm.package.rsvps.length && _vm.package.rsvps[0].optinShared && _vm.package.rsvps[0].optinShared.isOptinShared)?_c('div',{staticClass:"value service-type",style:({backgroundColor: _vm.package.rsvps[0].serviceBg})},[_vm._v("\n            "+_vm._s(_vm.package.rsvps[0].serviceLabel)+"\n          ")]):_c('div',{class:['value service-type', _vm.package.serviceClass]},[_vm._v(_vm._s(_vm.package.serviceLabel))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.status')))]),_vm._v(" "),_c('div',{class:['value status', _vm.package.statusClass]},[_vm._v(_vm._s(_vm.package.status))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v("FARE AMOUNT")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("$"+_vm._s((_vm.package.fare + _vm.package.airportFee + _vm.package.tranvelInsurance + _vm.package.driverPayment.gasFee).toFixed(2)))])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v("DRIVER PAYMENT")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("$"+_vm._s(_vm.getDriverPayment(_vm.package.driverPayment).toFixed(2)))]),_vm._v(" "),_c('a',{staticClass:"payment-breakdown-button",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.showBreakdown(true)}}},[_vm._v("See Payment Breakdown")])])])]),_vm._v(" "),(_vm.isCompleted())?_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v("COMPLETED")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.isCompleted()))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),(_vm.package.driver !== null)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.driverName')))]),_vm._v(" "),_c('div',{staticClass:"value driver-name"},[_c('div',{staticClass:"name"},[_c('strong',[_vm._v("\n                  "+_vm._s(_vm.package.driver.firstName)+" "+_vm._s(_vm.package.driver.lastName)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"prov-options"},[_c('i',{staticClass:"fas fa-ellipsis-v fa-lg",on:{"click":function($event){_vm.showOptions = !_vm.showOptions}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOptions),expression:"showOptions"}],staticClass:"options"},[_c('div',{staticClass:"button cta success block call",on:{"click":function($event){return _vm.callDriver(_vm.package.driver)}}},[_c('i',{staticClass:"fa fa-phone"}),_vm._v(_vm._s(_vm.$t('provider.call'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"button cta block send-sms",on:{"click":function($event){return _vm.sendSMS()}}},[_c('i',{staticClass:"fas fa-comment-dots"}),_vm._v(_vm._s(_vm.$t('provider.sms'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"button cta warning block send-notif",on:{"click":_vm.showNotif}},[_c('i',{staticClass:"fas fa-bell"}),_vm._v(_vm._s(_vm.$t('provider.notify'))+"\n                    ")])])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v("ID")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":'/#/provider/' + _vm.package.driver.id,"target":"_blank"}},[_vm._v("\n                "+_vm._s(_vm.package.driver.driverNum)+"\n              ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.driverPhone')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":'tel:' + _vm.package.driver.phone}},[_vm._v("\n                "+_vm._s(_vm.package.driver.phone)+"\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns"},[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.driverEmail')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":'mailto:' + _vm.package.driver.email}},[_vm._v("\n                "+_vm._s(_vm.package.driver.email)+"\n              ")])])])])]),_vm._v(" "),(['CANCELED', 'COMPLETED'].indexOf(_vm.package.status) === -1)?_c('a',{staticClass:"button error cta small unassign",on:{"click":_vm.showReleaseModal}},[_vm._v("Release Driver")]):_vm._e()]):_c('div',[_c('div',{staticClass:"label-value"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.driverInfo')))]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.$t('dispatch.mapDetails.packageDriverNone')))])])])]),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"stops"},[_c('div',{staticClass:"title"},[_vm._v("STOPS FOR PACKAGE "+_vm._s(_vm.package.id))]),_vm._v(" "),_vm._l((_vm.package.legs),function(leg,index){return _c('div',{class:{ stop: true, pickup: leg.isPickup }},[_c('div',{staticClass:"name"},[_c('i',{class:{ 'fas fa-map-marker-alt fa-fw': true, pickup: leg.isPickup }}),_vm._v(" "),_c('a',{attrs:{"href":'/#/consumer/' + leg.customer.id,"target":"_blank"}},[_vm._v(_vm._s(leg.customer.firstName)+" "+_vm._s(leg.customer.lastName))])]),_vm._v(" "),_c('div',{staticClass:"time"},[_c('span',[_vm._v(_vm._s(leg.arrivalTime))])]),_vm._v(" "),_c('div',{staticClass:"address"},[(leg.isPickup)?_c('span',[_vm._v(_vm._s(_vm.getAddress(leg.pickup)))]):_c('span',[_vm._v(_vm._s(_vm.getAddress(leg.dropoff)))])]),_vm._v(" "),_c('div',{class:'status ' + leg.statusClass},[_vm._v(_vm._s(leg.status))]),_vm._v(" "),_c('div',{staticClass:"misc"},[_c('div',{staticClass:"rsvp-id"},[_c('span',[_vm._v("ID:")]),_vm._v(" "),_c('a',{attrs:{"href":'/#/reservation/' + leg.id,"target":"_blank"}},[_vm._v(_vm._s(leg.id))])]),_vm._v(" "),_c('div',{staticClass:"pax-luggage"},[_c('i',{staticClass:"fas fa-user fa-fw"}),_c('span',[_vm._v(_vm._s(leg.pax))]),_vm._v(" "),_c('i',{staticClass:"fas fa-suitcase fa-fw"}),_c('span',[_vm._v(_vm._s(leg.luggage))])])])])}),_vm._v(" "),_c('div',{staticClass:"fixed-bottom"},[_c('transition',{attrs:{"name":"slide-up"}},[(_vm.refreshPkg.success)?_c('div',{staticClass:"refresh-success"},[_vm._v("Package Details updated!")]):_vm._e()]),_vm._v(" "),_c('a',{class:{'button cta':true, 'disabled':_vm.refreshLoading},on:{"click":_vm.refresh}},[_c('i',{class:{'fas fa-sync-alt':true, 'fa-spin':_vm.refreshLoading}}),_vm._v(" "),(_vm.refreshLoading)?_c('span',[_vm._v("Loading")]):_c('span',[_vm._v(_vm._s(_vm.$t('transactions.filter.refresh')))])])],1)],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"toggle-mobile",on:{"click":function($event){_vm.showMapMobile = !_vm.showMapMobile}}},[(!_vm.showMapMobile)?_c('span',[_vm._v("Show Map "),_c('i',{staticClass:"fa fa-chevron-up"})]):_c('span',[_vm._v("Hide Map "),_c('i',{staticClass:"fa fa-chevron-down"})])]),_vm._v(" "),(_vm.package !== null)?_c('div',{class:{ 'modal-container': true, show: _vm.showPaymentBreakdown },on:{"click":function($event){return _vm.showBreakdown(false)}}},[_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"payment-breakdown",on:{"click":function($event){$event.stopPropagation();}}},[_c('a',{staticClass:"close",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.showBreakdown(false)}}},[_c('i',{staticClass:"far fa-times-circle fa-fw"})]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("PAYMENT BREAKDOWN")]),_vm._v(" "),_c('div',{staticClass:"row breakdown"},[_c('div',{staticClass:"small-6 columns label"},[_vm._v("Fare Amount:")]),_vm._v(" "),_c('div',{staticClass:"small-6 columns value"},[_vm._v("$"+_vm._s(_vm.package.driverPayment.base.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"row breakdown"},[_c('div',{staticClass:"small-6 columns label"},[_vm._v("Fuel Surcharge:")]),_vm._v(" "),_c('div',{staticClass:"small-6 columns value"},[_vm._v("$"+_vm._s(_vm.package.driverPayment.gasFee.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"row breakdown"},[_c('div',{staticClass:"small-6 columns label"},[_vm._v("Bonus:")]),_vm._v(" "),_c('div',{staticClass:"small-6 columns value"},[_vm._v("$"+_vm._s(_vm.package.driverPayment.bonus.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"row breakdown"},[_c('div',{staticClass:"small-6 columns label"},[_vm._v("Tip:")]),_vm._v(" "),_c('div',{staticClass:"small-6 columns value"},[_vm._v("$"+_vm._s(_vm.package.driverPayment.tip.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"row breakdown"},[_c('div',{staticClass:"small-6 columns label"},[_vm._v("Pickup Fee:")]),_vm._v(" "),_c('div',{staticClass:"small-6 columns value"},[_vm._v("$"+_vm._s(_vm.package.driverPayment.pickupFee.toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"row breakdown total"},[_c('div',{staticClass:"small-6 columns label"},[_vm._v("Total:")]),_vm._v(" "),_c('div',{staticClass:"small-6 columns value"},[_vm._v("$"+_vm._s(_vm.getDriverPayment(_vm.package.driverPayment).toFixed(2)))])])])])])]):_vm._e(),_vm._v(" "),_c('div',{class:{ 'loading-modal-container': true, show: _vm.isLoading }},[_c('div',{staticClass:"loading-modal"},[_c('div',{staticClass:"loading-modal-content"},[_c('i',{staticClass:"fas fa-circle-notch fa-spin fa-2x fa-fw"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("Loading package "+_vm._s(_vm.packageID)+"...")])])])]),_vm._v(" "),_c('div',{class:{'release-modal': true, show: _vm.release.show}},[_c('div',{staticClass:"release-modal-container",on:{"click":function($event){_vm.release.show = false}}},[_c('div',{staticClass:"release-modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.release.processing),expression:"!release.processing"}],staticClass:"confirm-release"},[_c('div',{staticClass:"title"},[(!_vm.release.loading)?_c('span',[_vm._v("CONFIRM THE RELEASE")]):(_vm.release.error.show)?_c('span',[_vm._v("ERROR")]):_c('span',[_vm._v("Loading...")])]),_vm._v(" "),(_vm.release.loading && !_vm.release.error.show)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-fw fa-5x"}),_vm._v(" "),_c('div',[_vm._v("Please wait...")])]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[(_vm.release.error.show)?_c('div',{staticClass:"error"},[_c('i',{staticClass:"fas fa-exclamation-triangle fa-fw fa-5x"}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.release.error.message))])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[(_vm.release.showContent && !_vm.release.error.show)?_c('div',[_c('div',{staticClass:"message"},[_vm._v("\n                Are you sure you want to un-assign this package from\n                "),_c('a',{attrs:{"href":'/#/provider/' + _vm.package.driver.id,"target":"_blank"}},[_vm._v(_vm._s(_vm.package.driver.firstName)+" "+_vm._s(_vm.package.driver.lastName))]),_vm._v("?\n              ")]),_vm._v(" "),(_vm.release.fee > 0)?_c('div',{staticClass:"fee"},[_c('p',[_vm._v("The driver will have to pay an unassign fee of "),_c('b',[_vm._v("$"+_vm._s(_vm.release.fee))]),_vm._v(". Do you want to charge the unassign fee?")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.release.charge),expression:"release.charge"}],attrs:{"type":"radio","name":"release","value":"1"},domProps:{"checked":_vm._q(_vm.release.charge,"1")},on:{"change":function($event){return _vm.$set(_vm.release, "charge", "1")}}}),_vm._v(" Yes\n                ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.release.charge),expression:"release.charge"}],attrs:{"type":"radio","name":"release","value":"0"},domProps:{"checked":_vm._q(_vm.release.charge,"0")},on:{"change":function($event){return _vm.$set(_vm.release, "charge", "0")}}}),_vm._v(" No\n                ")]),_vm._v(" "),_c('div',{staticClass:"clear"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sub-message"},[_vm._v("\n                If you are un-assigning the driver in order to edit this package, make sure that you "),_c('strong',[_vm._v("assign it back to the same driver")]),_vm._v(". Otherwise, make sure that you "),_c('strong',[_vm._v("find another driver to cover this package")]),_vm._v(" or\n                "),_c('strong',[_vm._v("push it back again to the pool")]),_vm._v(".\n              ")]),_vm._v(" "),_c('div',{staticClass:"row controls"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('a',{staticClass:"button cta block small",attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.release.show = false}}},[_vm._v("NO")])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('a',{staticClass:"button cta block small warning",attrs:{"href":"javascript:;"},on:{"click":_vm.releaseDriver}},[_vm._v("YES")])])])]):_vm._e()])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.release.processing),expression:"release.processing"}],staticClass:"releasing"},[_c('i',{class:{
            'fas fa-circle-notch fa-spin': _vm.release.loading,
            'fas fa-exclamation-triangle': !_vm.release.success && !_vm.release.loading,
            'fas fa-check-circle': _vm.release.success,
            'fa-fw fa-2x': true,
            success: _vm.release.success
          }}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.release.loading),expression:"release.loading"}],staticClass:"message"},[_vm._v("Un-assigning driver from this reservation...")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.release.success),expression:"release.success"}],staticClass:"message"},[_vm._v("Successfully un-assigned driver from the reservation.")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.release.error.show),expression:"release.error.show"}],staticClass:"message"},[_vm._v(_vm._s(_vm.release.error.message))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.release.error.show),expression:"release.error.show"}],staticClass:"message-sub"},[_vm._v("Please Try again.")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.release.loading),expression:"!release.loading"}],staticClass:"button cta block small warning",attrs:{"href":"javascript:;"},on:{"click":_vm.closeRelease}},[_vm._v("Close")])])])])]),_vm._v(" "),_c('div',{class:{'release-modal': true, show: _vm.refreshPkg.show}},[_c('div',{staticClass:"release-modal-container",on:{"click":function($event){_vm.refreshPkg.show = false}}},[_c('div',{staticClass:"release-modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"confirm-release"},[_c('transition',{attrs:{"name":"slide-up"}},[(_vm.refreshPkg.error)?_c('div',{staticClass:"error"},[_c('i',{staticClass:"fas fa-exclamation-triangle fa-fw fa-5x"}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.refreshPkg.message))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"message-sub"},[_vm._v("Please try again.")]),_vm._v(" "),_c('div',{staticClass:"releasing"},[_c('a',{staticClass:"button cta block small warning",attrs:{"href":"javascript:;"},on:{"click":_vm.closeRelease}},[_vm._v("Close")])])],1)])])]),_vm._v(" "),_c('notification-modal',{ref:"notif",attrs:{"isList":false,"provId":_vm.package!== null && _vm.package.driver ? _vm.package.driver.id : null,"removeAllActiveUserOption":true,"hideTargetOption":true}}),_vm._v(" "),_c('sms-modal',{ref:"sms",attrs:{"isList":false,"provId":_vm.package!== null && _vm.package.driver ? _vm.package.driver.id : null,"removeAllActiveUserOption":true,"hideTargetOption":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(624);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fad4454_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1866);
function injectStyle (ssrContext) {
  __webpack_require__(1860)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fad4454"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fad4454_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1861);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("13567c6b", content, true, {});

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.heading[data-v-7fad4454] {\n  margin-left: 50px;\n  padding-left: 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.list-box[data-v-7fad4454] {\n  overflow-y: auto;\n  height: calc(100vh - 200px);\n  border-top: 1px solid #ccc;\n}\n.list-box thead[data-v-7fad4454] {\n    color: #8DA0A9;\n    font-size: 12px;\n}\n.list-box thead th[data-v-7fad4454] {\n      border-bottom: 1px solid #ccc;\n      background-color: #f5f5f5;\n      position: sticky;\n      top: 0px;\n}\n.list-box thead .sortable[data-v-7fad4454] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\n.list-box thead .sortable i[data-v-7fad4454] {\n        margin-left: 2px;\n}\ntable[data-v-7fad4454] {\n  border-collapse: collapse;\n  width: 100%;\n}\nth[data-v-7fad4454], td[data-v-7fad4454] {\n  padding: 5px;\n  text-align: center;\n}\ntr[data-v-7fad4454] {\n  border-bottom: 1px solid #ddd;\n  background: #f5f5f5;\n  position: relative;\n}\ntr[data-v-7fad4454]:nth-child(odd) {\n    background: #fbfbfb;\n}\ntr[data-v-7fad4454]:hover {\n    -webkit-box-shadow: 0 0 3px rgba(0, 0, 0, 0.3), inset 0 1px 1px #999;\n            box-shadow: 0 0 3px rgba(0, 0, 0, 0.3), inset 0 1px 1px #999;\n    z-index: 2;\n}\ntr td[data-v-7fad4454] {\n    font-size: 14px;\n    padding: 8px 5px;\n}\n.refundable[data-v-7fad4454] {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n  padding: 5px 10px;\n  background: #41b430;\n  color: #fff;\n  border-radius: 4px;\n}\n.refundable.non[data-v-7fad4454] {\n    background: #ccc;\n    color: #333;\n}\n.status[data-v-7fad4454] {\n  font-size: 12px;\n  color: #ccc;\n  padding: 5px;\n  background: #333;\n  text-transform: uppercase;\n  font-weight: 600;\n  border-radius: 4px;\n}\n.status.PENDING[data-v-7fad4454] {\n    background: #e3b925;\n    color: #fff;\n}\n.status.UPCOMING[data-v-7fad4454] {\n    background: #ed922c;\n    color: #fff;\n}\n.fix-footer[data-v-7fad4454] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 50px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-7fad4454] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-7fad4454] {\n    max-width: 100px;\n    height: 30px;\n    padding: 5px;\n}\n.fix-footer .per-page[data-v-7fad4454] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 10px 0;\n}\n.fix-footer .per-page span[data-v-7fad4454] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-7fad4454] {\n    text-align: center;\n    line-height: 30px;\n    padding: 10px 0;\n}\n.fix-footer .pagination[data-v-7fad4454] {\n    text-align: right;\n    padding: 10px 10px;\n    -webkit-transition: all ease-in .2s;\n    transition: all ease-in .2s;\n}\n.fix-footer .pagination span[data-v-7fad4454] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-7fad4454] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-7fad4454] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-7fad4454] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-7fad4454] {\n        opacity: .4;\n        cursor: default;\n}\n.fix-footer .pagination.move-right[data-v-7fad4454] {\n      padding-right: 60px;\n}\n.lr-modal[data-v-7fad4454] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.05s ease;\n  transition: all 0.05s ease;\n}\n.lr-modal .lr-box[data-v-7fad4454] {\n    background: #fff;\n    padding: 20px;\n    border-radius: 6px;\n    -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n    text-align: center;\n    min-width: 200px;\n    max-width: 300px;\n    -webkit-transition: all 0.1s ease;\n    transition: all 0.1s ease;\n}\n.lr-modal .lr-alert-msg[data-v-7fad4454] {\n    margin-bottom: 20px;\n    color: #45505b;\n}\n.lr-modal.hide[data-v-7fad4454] {\n    z-index: -1;\n    opacity: 0;\n}\n.lr-modal.hide .lr-box[data-v-7fad4454] {\n      -webkit-transform: scale(90%) translateY(30px);\n              transform: scale(90%) translateY(30px);\n}\n.lr-modal a[data-v-7fad4454] {\n    margin-top: 10px;\n}\n.slide-up-enter-active[data-v-7fad4454], .slide-up-leave-active[data-v-7fad4454] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-7fad4454], .slide-up-leave-to[data-v-7fad4454] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Flights/index.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;CAC3B;AACD;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,2BAA2B;CAC5B;AACD;IACI,eAAe;IACf,gBAAgB;CACnB;AACD;MACM,8BAA8B;MAC9B,0BAA0B;MAC1B,iBAAiB;MACjB,SAAS;CACd;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,2BAA2B;CAChC;AACD;QACQ,iBAAiB;CACxB;AACD;EACE,0BAA0B;EAC1B,YAAY;CACb;AACD;EACE,aAAa;EACb,mBAAmB;CACpB;AACD;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,qEAAqE;YAC7D,6DAA6D;IACrE,WAAW;CACd;AACD;IACI,gBAAgB;IAChB,iBAAiB;CACpB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;CACpB;AACD;IACI,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;IACpB,YAAY;CACf;AACD;IACI,oBAAoB;IACpB,YAAY;CACf;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;CACb;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;IACjB,aAAa;IACb,aAAa;CAChB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;CACnB;AACD;MACM,sBAAsB;MACtB,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;CACnB;AACD;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;IACpC,4BAA4B;CAC/B;AACD;MACM,sBAAsB;MACtB,kBAAkB;CACvB;AACD;MACM,aAAa;MACb,uBAAuB;CAC5B;AACD;MACM,cAAc;MACd,eAAe;MACf,uBAAuB;MACvB,iBAAiB;MACjB,gBAAgB;MAChB,uBAAuB;MACvB,aAAa;CAClB;AACD;QACQ,kBAAkB;CACzB;AACD;QACQ,YAAY;QACZ,gBAAgB;CACvB;AACD;MACM,oBAAoB;CACzB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oCAAoC;MAChC,iCAAiC;UAC7B,mCAAmC;EAC3C,qCAAqC;MACjC,kCAAkC;UAC9B,+BAA+B;EACvC,mCAAmC;EACnC,2BAA2B;CAC5B;AACD;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,mDAAmD;YAC3C,2CAA2C;IACnD,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;IACI,oBAAoB;IACpB,eAAe;CAClB;AACD;IACI,YAAY;IACZ,WAAW;CACd;AACD;MACM,+CAA+C;cACvC,uCAAuC;CACpD;AACD;IACI,iBAAiB;CACpB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ","file":"index.vue","sourcesContent":["\n.heading[data-v-7fad4454] {\n  margin-left: 50px;\n  padding-left: 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.list-box[data-v-7fad4454] {\n  overflow-y: auto;\n  height: calc(100vh - 200px);\n  border-top: 1px solid #ccc;\n}\n.list-box thead[data-v-7fad4454] {\n    color: #8DA0A9;\n    font-size: 12px;\n}\n.list-box thead th[data-v-7fad4454] {\n      border-bottom: 1px solid #ccc;\n      background-color: #f5f5f5;\n      position: sticky;\n      top: 0px;\n}\n.list-box thead .sortable[data-v-7fad4454] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\n.list-box thead .sortable i[data-v-7fad4454] {\n        margin-left: 2px;\n}\ntable[data-v-7fad4454] {\n  border-collapse: collapse;\n  width: 100%;\n}\nth[data-v-7fad4454], td[data-v-7fad4454] {\n  padding: 5px;\n  text-align: center;\n}\ntr[data-v-7fad4454] {\n  border-bottom: 1px solid #ddd;\n  background: #f5f5f5;\n  position: relative;\n}\ntr[data-v-7fad4454]:nth-child(odd) {\n    background: #fbfbfb;\n}\ntr[data-v-7fad4454]:hover {\n    -webkit-box-shadow: 0 0 3px rgba(0, 0, 0, 0.3), inset 0 1px 1px #999;\n            box-shadow: 0 0 3px rgba(0, 0, 0, 0.3), inset 0 1px 1px #999;\n    z-index: 2;\n}\ntr td[data-v-7fad4454] {\n    font-size: 14px;\n    padding: 8px 5px;\n}\n.refundable[data-v-7fad4454] {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n  padding: 5px 10px;\n  background: #41b430;\n  color: #fff;\n  border-radius: 4px;\n}\n.refundable.non[data-v-7fad4454] {\n    background: #ccc;\n    color: #333;\n}\n.status[data-v-7fad4454] {\n  font-size: 12px;\n  color: #ccc;\n  padding: 5px;\n  background: #333;\n  text-transform: uppercase;\n  font-weight: 600;\n  border-radius: 4px;\n}\n.status.PENDING[data-v-7fad4454] {\n    background: #e3b925;\n    color: #fff;\n}\n.status.UPCOMING[data-v-7fad4454] {\n    background: #ed922c;\n    color: #fff;\n}\n.fix-footer[data-v-7fad4454] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 50px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-7fad4454] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-7fad4454] {\n    max-width: 100px;\n    height: 30px;\n    padding: 5px;\n}\n.fix-footer .per-page[data-v-7fad4454] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 10px 0;\n}\n.fix-footer .per-page span[data-v-7fad4454] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-7fad4454] {\n    text-align: center;\n    line-height: 30px;\n    padding: 10px 0;\n}\n.fix-footer .pagination[data-v-7fad4454] {\n    text-align: right;\n    padding: 10px 10px;\n    -webkit-transition: all ease-in .2s;\n    transition: all ease-in .2s;\n}\n.fix-footer .pagination span[data-v-7fad4454] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-7fad4454] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-7fad4454] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-7fad4454] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-7fad4454] {\n        opacity: .4;\n        cursor: default;\n}\n.fix-footer .pagination.move-right[data-v-7fad4454] {\n      padding-right: 60px;\n}\n.lr-modal[data-v-7fad4454] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.05s ease;\n  transition: all 0.05s ease;\n}\n.lr-modal .lr-box[data-v-7fad4454] {\n    background: #fff;\n    padding: 20px;\n    border-radius: 6px;\n    -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n    text-align: center;\n    min-width: 200px;\n    max-width: 300px;\n    -webkit-transition: all 0.1s ease;\n    transition: all 0.1s ease;\n}\n.lr-modal .lr-alert-msg[data-v-7fad4454] {\n    margin-bottom: 20px;\n    color: #45505b;\n}\n.lr-modal.hide[data-v-7fad4454] {\n    z-index: -1;\n    opacity: 0;\n}\n.lr-modal.hide .lr-box[data-v-7fad4454] {\n      -webkit-transform: scale(90%) translateY(30px);\n              transform: scale(90%) translateY(30px);\n}\n.lr-modal a[data-v-7fad4454] {\n    margin-top: 10px;\n}\n.slide-up-enter-active[data-v-7fad4454], .slide-up-leave-active[data-v-7fad4454] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-7fad4454], .slide-up-leave-to[data-v-7fad4454] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filter_vue__ = __webpack_require__(625);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e02e7710_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Filter_vue__ = __webpack_require__(1865);
function injectStyle (ssrContext) {
  __webpack_require__(1863)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e02e7710"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e02e7710_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1864);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("213dcfc1", content, true, {});

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.filter-box[data-v-e02e7710] {\n  padding: 10px 20px;\n  gap: 15px;\n}\n.filter-label[data-v-e02e7710] {\n  font-size: 13px;\n  color: #999;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.search-box[data-v-e02e7710] {\n  height: 80px;\n}\n.search-box input[data-v-e02e7710] {\n    width: 200px !important;\n    margin-top: 0;\n    line-height: 1;\n    font-size: 14px;\n    border-radius: 4px 0 0 4px;\n    padding: 0 10px;\n    line-height: 38px;\n    height: 38px;\n}\n.search-box .search-icon[data-v-e02e7710] {\n    height: 38px;\n    padding: 10px;\n    background: #26D97A;\n    color: #fff;\n    border-radius: 0 4px 4px 0;\n    cursor: pointer;\n}\n.search-box .search-icon i[data-v-e02e7710] {\n      font-size: 18px;\n}\n.search-box .search-icon[data-v-e02e7710]:hover {\n      background: #2aa764;\n}\n.status[data-v-e02e7710] {\n  max-width: 140px;\n  height: 38px;\n  padding: 0 8px;\n}\n.error-msg[data-v-e02e7710] {\n  color: #ff6115;\n  font-size: 14px;\n}\n.search-btn-box[data-v-e02e7710] {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n.search-btn[data-v-e02e7710] {\n  margin-top: 17px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Flights/Filter.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,UAAU;CACX;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;CACpB;AACD;EACE,aAAa;CACd;AACD;IACI,wBAAwB;IACxB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;CAChB;AACD;IACI,aAAa;IACb,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,2BAA2B;IAC3B,gBAAgB;CACnB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,oBAAoB;CACzB;AACD;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;CAChB;AACD;EACE,eAAe;EACf,gBAAgB;CACjB;AACD;EACE,oBAAoB;MAChB,qBAAqB;UACjB,aAAa;CACtB;AACD;EACE,iBAAiB;CAClB","file":"Filter.vue","sourcesContent":["\n.filter-box[data-v-e02e7710] {\n  padding: 10px 20px;\n  gap: 15px;\n}\n.filter-label[data-v-e02e7710] {\n  font-size: 13px;\n  color: #999;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.search-box[data-v-e02e7710] {\n  height: 80px;\n}\n.search-box input[data-v-e02e7710] {\n    width: 200px !important;\n    margin-top: 0;\n    line-height: 1;\n    font-size: 14px;\n    border-radius: 4px 0 0 4px;\n    padding: 0 10px;\n    line-height: 38px;\n    height: 38px;\n}\n.search-box .search-icon[data-v-e02e7710] {\n    height: 38px;\n    padding: 10px;\n    background: #26D97A;\n    color: #fff;\n    border-radius: 0 4px 4px 0;\n    cursor: pointer;\n}\n.search-box .search-icon i[data-v-e02e7710] {\n      font-size: 18px;\n}\n.search-box .search-icon[data-v-e02e7710]:hover {\n      background: #2aa764;\n}\n.status[data-v-e02e7710] {\n  max-width: 140px;\n  height: 38px;\n  padding: 0 8px;\n}\n.error-msg[data-v-e02e7710] {\n  color: #ff6115;\n  font-size: 14px;\n}\n.search-btn-box[data-v-e02e7710] {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n.search-btn[data-v-e02e7710] {\n  margin-top: 17px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-box d-flex align-start"},[_c('div',{staticClass:"search-box"},[_c('label',{staticClass:"filter-label"},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.search)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getFlights.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"date-box"},[_c('label',{staticClass:"filter-label"},[_vm._v("Booking Date")]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('datepicker',{staticClass:"datepicker small inline fl-filter",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"clear-button":true,"input-class":{'datepicker-empty':_vm.error.booking.from},"placeholder":_vm.$t('transactions.filter.from')},on:{"input":function($event){return _vm.changeDate('from')}},model:{value:(_vm.booking.from),callback:function ($$v) {_vm.$set(_vm.booking, "from", $$v)},expression:"booking.from"}}),_vm._v(" "),_c('datepicker',{staticClass:"datepicker small inline fl-filter",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"clear-button":true,"input-class":{'datepicker-empty':_vm.error.booking.to},"placeholder":_vm.$t('transactions.filter.to')},on:{"input":function($event){return _vm.changeDate('to')}},model:{value:(_vm.booking.to),callback:function ($$v) {_vm.$set(_vm.booking, "to", $$v)},expression:"booking.to"}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.message.bookingDate),expression:"!!error.message.bookingDate"}],staticClass:"error-msg"},[_vm._v("\n        "+_vm._s(_vm.error.message.bookingDate)+"\n      ")])])],1),_vm._v(" "),_c('div',{staticClass:"date-box"},[_c('label',{staticClass:"filter-label"},[_vm._v("Travelling Date")]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('datepicker',{staticClass:"datepicker small inline fl-filter",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"clear-button":true,"input-class":{'datepicker-empty':_vm.error.travel.from},"placeholder":_vm.$t('transactions.filter.from')},on:{"input":function($event){return _vm.changeDate('travelFrom')}},model:{value:(_vm.travel.from),callback:function ($$v) {_vm.$set(_vm.travel, "from", $$v)},expression:"travel.from"}}),_vm._v(" "),_c('datepicker',{staticClass:"datepicker small inline fl-filter",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"clear-button":true,"input-class":{'datepicker-empty':_vm.error.travel.to},"placeholder":_vm.$t('transactions.filter.to')},on:{"input":function($event){return _vm.changeDate('travelTo')}},model:{value:(_vm.travel.to),callback:function ($$v) {_vm.$set(_vm.travel, "to", $$v)},expression:"travel.to"}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.error.message.travelDate),expression:"!!error.message.travelDate"}],staticClass:"error-msg"},[_vm._v("\n        "+_vm._s(_vm.error.message.travelDate)+"\n      ")])])],1),_vm._v(" "),_c('div',[_c('label',{staticClass:"filter-label"},[_vm._v("Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"status",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("All")]),_vm._v(" "),_c('option',{attrs:{"value":"UPCOMING"}},[_vm._v("Upcoming")]),_vm._v(" "),_c('option',{attrs:{"value":"COMPLETED"}},[_vm._v("Completed")]),_vm._v(" "),_c('option',{attrs:{"value":"CANCELED"}},[_vm._v("Canceled")]),_vm._v(" "),_c('option',{attrs:{"value":"PENDING"}},[_vm._v("Pending")]),_vm._v(" "),_c('option',{attrs:{"value":"STATUS7"}},[_vm._v("Status7")])])]),_vm._v(" "),_c('div',{staticClass:"search-btn-box d-flex"},[_c('div',{staticClass:"button cta success small search-btn",on:{"click":_vm.getFlights}},[_c('span',[_vm._v("SEARCH")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"heading"},[_vm._v("Flights")]),_vm._v(" "),_c('list-filter',{ref:"listFilter"}),_vm._v(" "),_c('div',{staticClass:"list-box"},[_c('table',[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._l((_vm.flights.list),function(f,i){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],key:i},[_c('td',[_c('a',{attrs:{"href":("#/flight/" + (f.id)),"target":"_blank"}},[_vm._v(_vm._s(f.id))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(f.bookingId))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(f.created))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(f.paxName))]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(f.origin.airportCode)+" -\n            "+_vm._s(f.origin.airportName)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(f.destination.airportCode)+" -\n            "+_vm._s(f.destination.airportName)+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"rsvp-td"},[(f.rsvp1)?_c('a',{attrs:{"href":("#/reservation/" + (f.rsvp1)),"target":"_blank"}},[_vm._v(_vm._s(f.rsvp1))]):_vm._e(),_vm._v(" "),(f.rsvp1 && f.rsvp2)?_c('span',[_vm._v(",")]):_c('span',[_vm._v("Opt Out")]),_vm._v(" "),(f.rsvp2)?_c('a',{attrs:{"href":("#/reservation/" + (f.rsvp2)),"target":"_blank"}},[_vm._v(_vm._s(f.rsvp2))]):_vm._e()]),_vm._v(" "),_c('td',[_c('span',{class:['refundable', {'non': !f.isRefundable}]},[_vm._v(_vm._s(f.isRefundable ? 'REFUNDABLE' : 'NON-REFUNDABLE'))])]),_vm._v(" "),_c('td',[_c('span',{class:['status', f.status]},[_vm._v(_vm._s(f.status))])])])}),_vm._v(" "),(!_vm.loading && !_vm.flights.list.length)?_c('tr',[_c('td',{staticClass:"a-center loading",attrs:{"colspan":"9"}},[_vm._v("\n            No flight found.\n          ")])]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('tr',[_vm._m(1)]):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"fix-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-3 columns per-page"},[_c('span',[_vm._v("Displaying")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" "),_c('span',[_vm._v("per page")])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns page-data"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.flights.list.length > 0),expression:"flights.list.length > 0"}]},[_vm._v("\n          Displaying\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.start))]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.pageData.end))]),_vm._v(" of\n          "),_c('b',[_vm._v(_vm._s(_vm.pageData.max))])])]),_vm._v(" "),_c('div',{class:['small-3 columns pagination', {'move-right': _vm.enableSearchGlobal}]},[_c('span',[_vm._v("Page")]),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.currentPage === 1 || _vm.loading},on:{"click":_vm.prev}},[_c('i',{staticClass:"fas fa-chevron-left"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentPage),expression:"currentPage"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.totalPage),function(i){return _c('option',{key:i,domProps:{"value":i}},[_vm._v(_vm._s(i))])}),0),_vm._v(" "),_c('span',{class:{'prevNext':true, 'disabled':_vm.isLastPage || _vm.loading},on:{"click":_vm.next}},[_c('i',{staticClass:"fas fa-chevron-right"})])])])]),_vm._v(" "),_c('div',{class:['lr-modal', {'hide': !_vm.showCxlConfirm}]},[_c('div',{staticClass:"lr-box"},[_vm._v("\n      Are you sure you want to cancel this fliight?\n      "),_c('a',{staticClass:"button cta xsmall primary block",on:{"click":_vm.cxlFLight}},[_vm._v("\n        Yes, cancel this flight\n      ")]),_vm._v(" "),_c('a',{staticClass:"button cta xsmall secondary block",on:{"click":function($event){_vm.showCxlConfirm = false}}},[_vm._v("\n        No, i change my mind\n      ")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',[_vm._v("Flight ID")]),_vm._v(" "),_c('th',[_vm._v("Booking ID")]),_vm._v(" "),_c('th',[_vm._v("Created")]),_vm._v(" "),_c('th',[_vm._v("Passenger Name")]),_vm._v(" "),_c('th',[_vm._v("Departure")]),_vm._v(" "),_c('th',[_vm._v("Arrival")]),_vm._v(" "),_c('th',[_vm._v("Ground Transportation")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("Status")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"a-center loading",attrs:{"colspan":"9"}},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n            Getting flight list...\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(626);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_848ec06c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1883);
function injectStyle (ssrContext) {
  __webpack_require__(1868)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-848ec06c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_848ec06c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1869);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("3c273a68", content, true, {});

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.heading[data-v-848ec06c] {\n  height: 50px;\n  padding-left: 50px;\n}\n.heading .txt[data-v-848ec06c] {\n    line-height: 50px;\n    padding-left: 20px;\n    font-size: 21px;\n    font-weight: 600;\n}\n.wrap-box[data-v-848ec06c] {\n  width: 100%;\n}\n.tabs[data-v-848ec06c] {\n  padding: 10px;\n}\n.tabs .tab[data-v-848ec06c] {\n    margin-right: 20px;\n    font-weight: 600;\n    padding-bottom: 5px;\n    color: #777;\n    cursor: pointer;\n}\n.tabs .active[data-v-848ec06c] {\n    color: #0D79F2;\n    border-bottom: 2px solid #0D79F2;\n}\n.info-box[data-v-848ec06c] {\n  margin-bottom: 20px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/FlightDetails/index.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,mBAAmB;CACpB;AACD;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;CACpB;AACD;EACE,YAAY;CACb;AACD;EACE,cAAc;CACf;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;CACnB;AACD;IACI,eAAe;IACf,iCAAiC;CACpC;AACD;EACE,oBAAoB;CACrB","file":"index.vue","sourcesContent":["\n.heading[data-v-848ec06c] {\n  height: 50px;\n  padding-left: 50px;\n}\n.heading .txt[data-v-848ec06c] {\n    line-height: 50px;\n    padding-left: 20px;\n    font-size: 21px;\n    font-weight: 600;\n}\n.wrap-box[data-v-848ec06c] {\n  width: 100%;\n}\n.tabs[data-v-848ec06c] {\n  padding: 10px;\n}\n.tabs .tab[data-v-848ec06c] {\n    margin-right: 20px;\n    font-weight: 600;\n    padding-bottom: 5px;\n    color: #777;\n    cursor: pointer;\n}\n.tabs .active[data-v-848ec06c] {\n    color: #0D79F2;\n    border-bottom: 2px solid #0D79F2;\n}\n.info-box[data-v-848ec06c] {\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_details_vue__ = __webpack_require__(627);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_513f46ee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_details_vue__ = __webpack_require__(1877);
function injectStyle (ssrContext) {
  __webpack_require__(1871)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-513f46ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_513f46ee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1872);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0be5739a", content, true, {});

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.status[data-v-513f46ee] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-513f46ee], .status.completed[data-v-513f46ee] {\n    background: #26D97A;\n}\n.status.canceled[data-v-513f46ee], .status.cancelled[data-v-513f46ee], .status.failed[data-v-513f46ee] {\n    background: #bbb;\n}\n.status.upcoming[data-v-513f46ee] {\n    background: #f38d56;\n}\n.status.onboard[data-v-513f46ee] {\n    background: #dc3168;\n}\n.status.ready[data-v-513f46ee] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-513f46ee], .status.requires_dispatch[data-v-513f46ee] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-513f46ee] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-513f46ee] {\n    background: #5662f3;\n}\n.flight-status[data-v-513f46ee] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-513f46ee] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-513f46ee] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-513f46ee] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-513f46ee] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-513f46ee] {\n    background-color: #f35656;\n}\n.details-box[data-v-513f46ee] {\n  background: #fbfbfb;\n  border-radius: 2px;\n  border-top: 1px solid #ddd;\n  -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n          box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n}\n.top-details[data-v-513f46ee] {\n  padding: 20px 10px 0;\n}\n.top-details .f-field[data-v-513f46ee] {\n    padding-left: 10px;\n}\n.top-details .refund-label[data-v-513f46ee] {\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1;\n    padding: 5px 10px;\n    background: #41b430;\n    color: #fff;\n    border-radius: 4px;\n    letter-spacing: .6px;\n}\n.top-details .refund-label.non[data-v-513f46ee] {\n      background: #ccc;\n      color: #333;\n}\n.pending-txt[data-v-513f46ee] {\n  font-weight: 600;\n  color: #f00;\n}\n.left-box[data-v-513f46ee] {\n  width: 65%;\n  padding: 10px 0 20px;\n}\n.f-field[data-v-513f46ee] {\n  padding: 0 20px;\n  margin-bottom: 10px;\n}\n.f-field .value[data-v-513f46ee] {\n    font-weight: 600;\n    font-size: 18px;\n}\n.f-label[data-v-513f46ee] {\n  font-size: 11px;\n  color: #888;\n  line-height: 1;\n  font-weight: 600;\n}\n.table-head[data-v-513f46ee] {\n  background: #333;\n  color: #fff;\n  margin-bottom: 0 !important;\n  padding: 10px;\n  letter-spacing: .6px;\n}\n.journey[data-v-513f46ee] {\n  margin: 10px 20px 25px;\n}\n.journey .f-label[data-v-513f46ee] {\n    margin-bottom: 5px;\n}\n.journey table[data-v-513f46ee] {\n    border: 1px solid #999;\n    width: 100%;\n    background: #fff;\n}\n.journey table .head[data-v-513f46ee] {\n      padding: 3px 10px;\n      font-weight: 600;\n      line-height: 20px;\n      background: #eaeaea;\n      color: #333;\n      font-size: 13px;\n}\n.journey table td[data-v-513f46ee] {\n      vertical-align: top;\n      padding: 10px;\n}\n.journey table td[data-v-513f46ee]:nth-child(1) {\n        min-width: 120px;\n}\n.journey table tr:nth-child(even):not(.head) td[data-v-513f46ee] {\n      background: #f7f7f7;\n}\n.journey .rsvp-link[data-v-513f46ee] {\n    font-weight: 600;\n    font-size: 13px;\n    line-height: 1;\n    margin: 7px 0;\n    display: block;\n}\n.journey .service[data-v-513f46ee] {\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 1;\n}\n.journey .flight-tr td[data-v-513f46ee] {\n    border-bottom: 1px solid #ccc;\n}\n.journey .flight-name div[data-v-513f46ee] {\n    line-height: 1;\n    margin-bottom: 1px;\n    font-size: 15px;\n    color: #777;\n}\n.journey .flight-name b[data-v-513f46ee] {\n    font-size: 18px;\n}\n.journey .loc[data-v-513f46ee] {\n    max-width: 400px;\n}\n.journey .loc b[data-v-513f46ee] {\n      font-size: 16x;\n      margin-bottom: 2px;\n}\n.journey .loc div[data-v-513f46ee] {\n      line-height: 1;\n      font-size: 14px;\n}\n.journey .loc .date[data-v-513f46ee] {\n      margin-top: 5px;\n      color: #777;\n}\n.journey .loc .date .local-tz[data-v-513f46ee] {\n        background: #ccc;\n        color: #fff;\n        letter-spacing: .7px;\n        display: inline-block;\n        border-radius: 3px;\n        font-size: 12.5px;\n        padding: 4px;\n        line-height: 1;\n        margin-left: 4px;\n        vertical-align: 1px;\n}\n.journey .loc .date .local-tz.la[data-v-513f46ee] {\n          background: #76d3ff;\n}\n.journey .td-action[data-v-513f46ee] {\n    width: 100px;\n    text-align: right;\n    vertical-align: middle;\n}\n.journey .td-action i[data-v-513f46ee] {\n      cursor: pointer;\n      color: #0D79F2;\n}\n.pax[data-v-513f46ee] {\n  margin: 0 20px 15px;\n}\n.pax .f-label[data-v-513f46ee] {\n    margin-bottom: 5px;\n}\n.pax table[data-v-513f46ee] {\n    width: 100%;\n    border: 1px solid  #999;\n    text-align: left;\n}\n.pax table th[data-v-513f46ee] {\n      padding: 10px;\n      background: #eaeaea;\n      color: #333;\n      font-size: 13px;\n      line-height: 1;\n}\n.pax table td[data-v-513f46ee] {\n      padding: 10px;\n}\n.pax table th[data-v-513f46ee]:last-child, .pax table td[data-v-513f46ee]:last-child {\n      border-right: none;\n}\n.right-box[data-v-513f46ee] {\n  width: 35%;\n  padding: 20px 10px;\n}\n.payment-box[data-v-513f46ee] {\n  margin-bottom: 20px;\n}\n.payment-box .f-label[data-v-513f46ee] {\n    margin-bottom: 5px;\n}\n.payment-box table[data-v-513f46ee] {\n    width: 100%;\n    border: 1px solid #999;\n}\n.payment-box table td[data-v-513f46ee] {\n      padding: 5px 10px;\n      border-bottom: 1px solid #ccc;\n}\n.payment-box table td[data-v-513f46ee]:nth-child(1) {\n      color: #333;\n      font-weight: 600;\n      font-size: 13px;\n      border-right: 1px solid #ccc;\n}\n.payment-box table td[data-v-513f46ee]:nth-child(2) {\n      font-weight: 600;\n      font-size: 18px;\n      text-align: right;\n      color: #444;\n}\n.payment-box table .total td[data-v-513f46ee] {\n      background: #f3f3f3;\n}\n.payment-box table .total td[data-v-513f46ee]:nth-child(2) {\n      color: #111;\n      font-size: 21px;\n}\n.lr-modal[data-v-513f46ee] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.05s ease;\n  transition: all 0.05s ease;\n}\n.lr-modal .lr-box[data-v-513f46ee] {\n    background: #fff;\n    padding: 20px;\n    border-radius: 6px;\n    -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n    text-align: center;\n    min-width: 200px;\n    max-width: 420px;\n    -webkit-transition: all 0.1s ease;\n    transition: all 0.1s ease;\n}\n.lr-modal.hide[data-v-513f46ee] {\n    z-index: -1;\n    opacity: 0;\n}\n.lr-modal.hide .lr-box[data-v-513f46ee] {\n      -webkit-transform: scale(90%) translateY(30px);\n              transform: scale(90%) translateY(30px);\n}\n.lr-modal .cxl-fee-box[data-v-513f46ee] {\n    text-align: left;\n    margin-top: 20px;\n}\n.lr-modal .cxl-fee-box .d-flex[data-v-513f46ee] {\n      margin-top: 5px;\n}\n.lr-modal .cxl-fee-box .d-flex b[data-v-513f46ee] {\n        margin-left: 5px;\n}\n.lr-modal .fee-breakdown[data-v-513f46ee] {\n    margin: 10px 0;\n    padding: 0 20px;\n    line-height: 1.5;\n}\n.lr-modal .fee-breakdown b[data-v-513f46ee] {\n      margin-left: 3px;\n}\n.lr-modal a[data-v-513f46ee] {\n    margin-top: 10px;\n}\n.check-list[data-v-513f46ee] {\n  margin: 15px 0;\n  padding: 0;\n  border: 1px solid #ccc;\n  list-style: none;\n  text-align: left;\n}\n.check-list li[data-v-513f46ee] {\n    border-bottom: 1px solid #ccc;\n    padding: 7px 5px;\n    font-size: 14px;\n    background: #f9f9f9;\n}\n.check-list li[data-v-513f46ee]:last-child {\n      border-bottom: none;\n}\n.check-list li[data-v-513f46ee]:hover {\n      background: #fff;\n}\n.check-list label[data-v-513f46ee] {\n    display: block;\n    cursor: pointer;\n}\n.check-list input[data-v-513f46ee] {\n    cursor: pointer;\n    width: auto;\n    vertical-align: -1px;\n    margin: 0 5px 0 0;\n    display: inline-block;\n}\n.lr2-box[data-v-513f46ee] {\n  width: 100%;\n  max-width: 400px;\n}\n.rsvp-modal[data-v-513f46ee] {\n  text-align: left;\n}\n.rsvp-modal .id[data-v-513f46ee] {\n    font-size: 21px;\n    font-weight: 600;\n    color: #365074;\n    line-height: 1;\n}\n.rsvp-modal .service[data-v-513f46ee] {\n    margin-bottom: 10px;\n}\n.rsvp-modal .loc[data-v-513f46ee] {\n    margin-bottom: 10px;\n    line-height: 1;\n}\n.rsvp-modal .loc .label[data-v-513f46ee] {\n      font-size: 11px;\n      color: #aaa;\n      font-weight: 600;\n      letter-spacing: .6px;\n      margin-bottom: 2px;\n}\n.rsvp-modal .loc .val[data-v-513f46ee] {\n      font-weight: 600;\n      font-size: 15px;\n}\n.rsvp-modal .actions[data-v-513f46ee] {\n    margin-top: 30px;\n}\n.rsvp-modal .actions .button[data-v-513f46ee]:first-child {\n      margin-bottom: 10px;\n}\n.cxl-fee-box[data-v-513f46ee] {\n  padding: 10px 20px;\n  font-size: 13px;\n  background: #f4c6c6;\n  border: 1px solid #e75e5e;\n  border-radius: 4px;\n  margin: 10px 0 0;\n  line-height: 140%;\n}\n.cxl-fee-box input[data-v-513f46ee] {\n    width: auto;\n    display: inline-block;\n    margin: 10px 3px 0 0;\n    vertical-align: -2px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/FlightDetails/details.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;CAC3B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,mDAAmD;UAC3C,2CAA2C;CACpD;AACD;EACE,qBAAqB;CACtB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;CACxB;AACD;MACM,iBAAiB;MACjB,YAAY;CACjB;AACD;EACE,iBAAiB;EACjB,YAAY;CACb;AACD;EACE,WAAW;EACX,qBAAqB;CACtB;AACD;EACE,gBAAgB;EAChB,oBAAoB;CACrB;AACD;IACI,iBAAiB;IACjB,gBAAgB;CACnB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,4BAA4B;EAC5B,cAAc;EACd,qBAAqB;CACtB;AACD;EACE,uBAAuB;CACxB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;CACpB;AACD;MACM,kBAAkB;MAClB,iBAAiB;MACjB,kBAAkB;MAClB,oBAAoB;MACpB,YAAY;MACZ,gBAAgB;CACrB;AACD;MACM,oBAAoB;MACpB,cAAc;CACnB;AACD;QACQ,iBAAiB;CACxB;AACD;MACM,oBAAoB;CACzB;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;CAClB;AACD;IACI,8BAA8B;CACjC;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;CACf;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;CACpB;AACD;MACM,eAAe;MACf,mBAAmB;CACxB;AACD;MACM,eAAe;MACf,gBAAgB;CACrB;AACD;MACM,gBAAgB;MAChB,YAAY;CACjB;AACD;QACQ,iBAAiB;QACjB,YAAY;QACZ,qBAAqB;QACrB,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;QAClB,aAAa;QACb,eAAe;QACf,iBAAiB;QACjB,oBAAoB;CAC3B;AACD;UACU,oBAAoB;CAC7B;AACD;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;CAC1B;AACD;MACM,gBAAgB;MAChB,eAAe;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;CACpB;AACD;MACM,cAAc;MACd,oBAAoB;MACpB,YAAY;MACZ,gBAAgB;MAChB,eAAe;CACpB;AACD;MACM,cAAc;CACnB;AACD;MACM,mBAAmB;CACxB;AACD;EACE,WAAW;EACX,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,YAAY;IACZ,uBAAuB;CAC1B;AACD;MACM,kBAAkB;MAClB,8BAA8B;CACnC;AACD;MACM,YAAY;MACZ,iBAAiB;MACjB,gBAAgB;MAChB,6BAA6B;CAClC;AACD;MACM,iBAAiB;MACjB,gBAAgB;MAChB,kBAAkB;MAClB,YAAY;CACjB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oCAAoC;MAChC,iCAAiC;UAC7B,mCAAmC;EAC3C,qCAAqC;MACjC,kCAAkC;UAC9B,+BAA+B;EACvC,mCAAmC;EACnC,2BAA2B;CAC5B;AACD;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,mDAAmD;YAC3C,2CAA2C;IACnD,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;IACI,YAAY;IACZ,WAAW;CACd;AACD;MACM,+CAA+C;cACvC,uCAAuC;CACpD;AACD;IACI,iBAAiB;IACjB,iBAAiB;CACpB;AACD;MACM,gBAAgB;CACrB;AACD;QACQ,iBAAiB;CACxB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;CACpB;AACD;MACM,iBAAiB;CACtB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;CAClB;AACD;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;CACvB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,iBAAiB;CACtB;AACD;IACI,eAAe;IACf,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;CACzB;AACD;EACE,YAAY;EACZ,iBAAiB;CAClB;AACD;EACE,iBAAiB;CAClB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,eAAe;CAClB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;IACpB,eAAe;CAClB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,iBAAiB;MACjB,qBAAqB;MACrB,mBAAmB;CACxB;AACD;MACM,iBAAiB;MACjB,gBAAgB;CACrB;AACD;IACI,iBAAiB;CACpB;AACD;MACM,oBAAoB;CACzB;AACD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;CACnB;AACD;IACI,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;IACrB,qBAAqB;CACxB","file":"details.vue","sourcesContent":["\n.status[data-v-513f46ee] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-513f46ee], .status.completed[data-v-513f46ee] {\n    background: #26D97A;\n}\n.status.canceled[data-v-513f46ee], .status.cancelled[data-v-513f46ee], .status.failed[data-v-513f46ee] {\n    background: #bbb;\n}\n.status.upcoming[data-v-513f46ee] {\n    background: #f38d56;\n}\n.status.onboard[data-v-513f46ee] {\n    background: #dc3168;\n}\n.status.ready[data-v-513f46ee] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-513f46ee], .status.requires_dispatch[data-v-513f46ee] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-513f46ee] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-513f46ee] {\n    background: #5662f3;\n}\n.flight-status[data-v-513f46ee] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-513f46ee] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-513f46ee] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-513f46ee] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-513f46ee] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-513f46ee] {\n    background-color: #f35656;\n}\n.details-box[data-v-513f46ee] {\n  background: #fbfbfb;\n  border-radius: 2px;\n  border-top: 1px solid #ddd;\n  -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n          box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n}\n.top-details[data-v-513f46ee] {\n  padding: 20px 10px 0;\n}\n.top-details .f-field[data-v-513f46ee] {\n    padding-left: 10px;\n}\n.top-details .refund-label[data-v-513f46ee] {\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1;\n    padding: 5px 10px;\n    background: #41b430;\n    color: #fff;\n    border-radius: 4px;\n    letter-spacing: .6px;\n}\n.top-details .refund-label.non[data-v-513f46ee] {\n      background: #ccc;\n      color: #333;\n}\n.pending-txt[data-v-513f46ee] {\n  font-weight: 600;\n  color: #f00;\n}\n.left-box[data-v-513f46ee] {\n  width: 65%;\n  padding: 10px 0 20px;\n}\n.f-field[data-v-513f46ee] {\n  padding: 0 20px;\n  margin-bottom: 10px;\n}\n.f-field .value[data-v-513f46ee] {\n    font-weight: 600;\n    font-size: 18px;\n}\n.f-label[data-v-513f46ee] {\n  font-size: 11px;\n  color: #888;\n  line-height: 1;\n  font-weight: 600;\n}\n.table-head[data-v-513f46ee] {\n  background: #333;\n  color: #fff;\n  margin-bottom: 0 !important;\n  padding: 10px;\n  letter-spacing: .6px;\n}\n.journey[data-v-513f46ee] {\n  margin: 10px 20px 25px;\n}\n.journey .f-label[data-v-513f46ee] {\n    margin-bottom: 5px;\n}\n.journey table[data-v-513f46ee] {\n    border: 1px solid #999;\n    width: 100%;\n    background: #fff;\n}\n.journey table .head[data-v-513f46ee] {\n      padding: 3px 10px;\n      font-weight: 600;\n      line-height: 20px;\n      background: #eaeaea;\n      color: #333;\n      font-size: 13px;\n}\n.journey table td[data-v-513f46ee] {\n      vertical-align: top;\n      padding: 10px;\n}\n.journey table td[data-v-513f46ee]:nth-child(1) {\n        min-width: 120px;\n}\n.journey table tr:nth-child(even):not(.head) td[data-v-513f46ee] {\n      background: #f7f7f7;\n}\n.journey .rsvp-link[data-v-513f46ee] {\n    font-weight: 600;\n    font-size: 13px;\n    line-height: 1;\n    margin: 7px 0;\n    display: block;\n}\n.journey .service[data-v-513f46ee] {\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 1;\n}\n.journey .flight-tr td[data-v-513f46ee] {\n    border-bottom: 1px solid #ccc;\n}\n.journey .flight-name div[data-v-513f46ee] {\n    line-height: 1;\n    margin-bottom: 1px;\n    font-size: 15px;\n    color: #777;\n}\n.journey .flight-name b[data-v-513f46ee] {\n    font-size: 18px;\n}\n.journey .loc[data-v-513f46ee] {\n    max-width: 400px;\n}\n.journey .loc b[data-v-513f46ee] {\n      font-size: 16x;\n      margin-bottom: 2px;\n}\n.journey .loc div[data-v-513f46ee] {\n      line-height: 1;\n      font-size: 14px;\n}\n.journey .loc .date[data-v-513f46ee] {\n      margin-top: 5px;\n      color: #777;\n}\n.journey .loc .date .local-tz[data-v-513f46ee] {\n        background: #ccc;\n        color: #fff;\n        letter-spacing: .7px;\n        display: inline-block;\n        border-radius: 3px;\n        font-size: 12.5px;\n        padding: 4px;\n        line-height: 1;\n        margin-left: 4px;\n        vertical-align: 1px;\n}\n.journey .loc .date .local-tz.la[data-v-513f46ee] {\n          background: #76d3ff;\n}\n.journey .td-action[data-v-513f46ee] {\n    width: 100px;\n    text-align: right;\n    vertical-align: middle;\n}\n.journey .td-action i[data-v-513f46ee] {\n      cursor: pointer;\n      color: #0D79F2;\n}\n.pax[data-v-513f46ee] {\n  margin: 0 20px 15px;\n}\n.pax .f-label[data-v-513f46ee] {\n    margin-bottom: 5px;\n}\n.pax table[data-v-513f46ee] {\n    width: 100%;\n    border: 1px solid  #999;\n    text-align: left;\n}\n.pax table th[data-v-513f46ee] {\n      padding: 10px;\n      background: #eaeaea;\n      color: #333;\n      font-size: 13px;\n      line-height: 1;\n}\n.pax table td[data-v-513f46ee] {\n      padding: 10px;\n}\n.pax table th[data-v-513f46ee]:last-child, .pax table td[data-v-513f46ee]:last-child {\n      border-right: none;\n}\n.right-box[data-v-513f46ee] {\n  width: 35%;\n  padding: 20px 10px;\n}\n.payment-box[data-v-513f46ee] {\n  margin-bottom: 20px;\n}\n.payment-box .f-label[data-v-513f46ee] {\n    margin-bottom: 5px;\n}\n.payment-box table[data-v-513f46ee] {\n    width: 100%;\n    border: 1px solid #999;\n}\n.payment-box table td[data-v-513f46ee] {\n      padding: 5px 10px;\n      border-bottom: 1px solid #ccc;\n}\n.payment-box table td[data-v-513f46ee]:nth-child(1) {\n      color: #333;\n      font-weight: 600;\n      font-size: 13px;\n      border-right: 1px solid #ccc;\n}\n.payment-box table td[data-v-513f46ee]:nth-child(2) {\n      font-weight: 600;\n      font-size: 18px;\n      text-align: right;\n      color: #444;\n}\n.payment-box table .total td[data-v-513f46ee] {\n      background: #f3f3f3;\n}\n.payment-box table .total td[data-v-513f46ee]:nth-child(2) {\n      color: #111;\n      font-size: 21px;\n}\n.lr-modal[data-v-513f46ee] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.05s ease;\n  transition: all 0.05s ease;\n}\n.lr-modal .lr-box[data-v-513f46ee] {\n    background: #fff;\n    padding: 20px;\n    border-radius: 6px;\n    -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n            box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n    text-align: center;\n    min-width: 200px;\n    max-width: 420px;\n    -webkit-transition: all 0.1s ease;\n    transition: all 0.1s ease;\n}\n.lr-modal.hide[data-v-513f46ee] {\n    z-index: -1;\n    opacity: 0;\n}\n.lr-modal.hide .lr-box[data-v-513f46ee] {\n      -webkit-transform: scale(90%) translateY(30px);\n              transform: scale(90%) translateY(30px);\n}\n.lr-modal .cxl-fee-box[data-v-513f46ee] {\n    text-align: left;\n    margin-top: 20px;\n}\n.lr-modal .cxl-fee-box .d-flex[data-v-513f46ee] {\n      margin-top: 5px;\n}\n.lr-modal .cxl-fee-box .d-flex b[data-v-513f46ee] {\n        margin-left: 5px;\n}\n.lr-modal .fee-breakdown[data-v-513f46ee] {\n    margin: 10px 0;\n    padding: 0 20px;\n    line-height: 1.5;\n}\n.lr-modal .fee-breakdown b[data-v-513f46ee] {\n      margin-left: 3px;\n}\n.lr-modal a[data-v-513f46ee] {\n    margin-top: 10px;\n}\n.check-list[data-v-513f46ee] {\n  margin: 15px 0;\n  padding: 0;\n  border: 1px solid #ccc;\n  list-style: none;\n  text-align: left;\n}\n.check-list li[data-v-513f46ee] {\n    border-bottom: 1px solid #ccc;\n    padding: 7px 5px;\n    font-size: 14px;\n    background: #f9f9f9;\n}\n.check-list li[data-v-513f46ee]:last-child {\n      border-bottom: none;\n}\n.check-list li[data-v-513f46ee]:hover {\n      background: #fff;\n}\n.check-list label[data-v-513f46ee] {\n    display: block;\n    cursor: pointer;\n}\n.check-list input[data-v-513f46ee] {\n    cursor: pointer;\n    width: auto;\n    vertical-align: -1px;\n    margin: 0 5px 0 0;\n    display: inline-block;\n}\n.lr2-box[data-v-513f46ee] {\n  width: 100%;\n  max-width: 400px;\n}\n.rsvp-modal[data-v-513f46ee] {\n  text-align: left;\n}\n.rsvp-modal .id[data-v-513f46ee] {\n    font-size: 21px;\n    font-weight: 600;\n    color: #365074;\n    line-height: 1;\n}\n.rsvp-modal .service[data-v-513f46ee] {\n    margin-bottom: 10px;\n}\n.rsvp-modal .loc[data-v-513f46ee] {\n    margin-bottom: 10px;\n    line-height: 1;\n}\n.rsvp-modal .loc .label[data-v-513f46ee] {\n      font-size: 11px;\n      color: #aaa;\n      font-weight: 600;\n      letter-spacing: .6px;\n      margin-bottom: 2px;\n}\n.rsvp-modal .loc .val[data-v-513f46ee] {\n      font-weight: 600;\n      font-size: 15px;\n}\n.rsvp-modal .actions[data-v-513f46ee] {\n    margin-top: 30px;\n}\n.rsvp-modal .actions .button[data-v-513f46ee]:first-child {\n      margin-bottom: 10px;\n}\n.cxl-fee-box[data-v-513f46ee] {\n  padding: 10px 20px;\n  font-size: 13px;\n  background: #f4c6c6;\n  border: 1px solid #e75e5e;\n  border-radius: 4px;\n  margin: 10px 0 0;\n  line-height: 140%;\n}\n.cxl-fee-box input[data-v-513f46ee] {\n    width: auto;\n    display: inline-block;\n    margin: 10px 3px 0 0;\n    vertical-align: -2px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fmap_vue__ = __webpack_require__(628);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57eb673a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fmap_vue__ = __webpack_require__(1876);
function injectStyle (ssrContext) {
  __webpack_require__(1874)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57eb673a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fmap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57eb673a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fmap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1875);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0fba8642", content, true, {});

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n#mapHere[data-v-57eb673a] {\n  width: 100%;\n  height: 400px;\n  margin-bottom: 20px;\n  -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n  border-radius: 4px;\n  overflow: hidden;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/FlightDetails/fmap.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mDAAmD;UAC3C,2CAA2C;EACnD,mBAAmB;EACnB,iBAAiB;CAClB","file":"fmap.vue","sourcesContent":["\n#mapHere[data-v-57eb673a] {\n  width: 100%;\n  height: 400px;\n  margin-bottom: 20px;\n  -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n  border-radius: 4px;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"mapHere"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details-box"},[_c('div',{staticClass:"d-flex justify-space-between top-details"},[_c('div',{staticClass:"d-flex align-center"},[_c('div',{staticClass:"f-field"},[_c('div',{staticClass:"f-label"},[_vm._v("BOOKING ID")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.isPending)?_c('span',{staticClass:"pending-txt"},[_vm._v("PENDING")]):_c('span',[_vm._v(_vm._s(_vm.details.bookingId))])])]),_vm._v(" "),_c('div',{staticClass:"f-field"},[_c('div',{staticClass:"f-label"},[_vm._v("BOOKED")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.details.bookedDate))])]),_vm._v(" "),_c('div',{staticClass:"f-field"},[_c('div',{staticClass:"f-label"},[_vm._v("AIRLINE PNR")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.isPending && !_vm.details.airlinePNR)?_c('span',{staticClass:"pending-txt"},[_vm._v("PENDING")]):_c('span',[_vm._v(_vm._s(_vm.details.airlinePNR))])])]),_vm._v(" "),_c('div',{staticClass:"f-field"},[_c('div',{staticClass:"value"},[_c('span',{class:['refund-label', {non:!_vm.details.isRefundable}]},[_vm._v(_vm._s(_vm.details.isRefundable ? 'REFUNDABLE' : 'NON-REFUNDABLE'))])])])]),_vm._v(" "),_c('div',{staticClass:"action-box"},[_c('div',{staticClass:"button cta primary small",on:{"click":_vm.sendEmail}},[_c('span',[_vm._v("SEND EMAIL")])]),_vm._v(" "),(_vm.details.status === 'UPCOMING')?_c('div',{class:['button cta small', _vm.details.isRefundable ? 'error' : 'secondary', {disabled:!_vm.details.isRefundable}],on:{"click":function($event){return _vm.getCancelFee(false)}}},[_c('span',[_vm._v("CANCEL FLIGHT")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"left-box"},[_c('div',{staticClass:"journey"},[_c('div',{staticClass:"f-label table-head"},[_vm._v("\n          JOURNEY DETAILS\n          "),(_vm.hasReturnTrip)?_c('span',[_vm._v("- FIRST TRIP")]):_vm._e()]),_vm._v(" "),_c('table',{attrs:{"cellspacing":"0"}},[(_vm.hasRsvp(_vm.rsvp1))?_c('tr',{staticClass:"head"},[_c('td',[_vm._v("Service")]),_vm._v(" "),_c('td',[_vm._v("Pickup")]),_vm._v(" "),_c('td',[_vm._v("Dropoff")]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('div',{class:['status', _vm.rsvp1.status]},[_vm._v(_vm._s(_vm.rsvp1.status))])])]):_vm._e(),_vm._v(" "),(_vm.hasRsvp(_vm.rsvp1))?_c('tr',[_c('td',[_c('div',{staticClass:"service"},[_vm._v(_vm._s(_vm.rsvp1.service))]),_vm._v(" "),_c('a',{staticClass:"rsvp-link",attrs:{"href":("#/reservation/" + (_vm.rsvp1.id)),"target":"_blank"}},[_vm._v("RSVP "+_vm._s(_vm.rsvp1.id))])]),_vm._v(" "),_c('td',{staticClass:"loc"},[_c('b',[_vm._v(_vm._s(_vm.rsvp1.pickup ? _vm.rsvp1.pickup.title : ''))]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                "+_vm._s(_vm.rsvp1.pickupDate)+"\n                "),_c('span',{staticClass:"local-tz"},[_vm._v("Local")])]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                "+_vm._s(_vm.rsvp1.pickupDateLA)+"\n                "),_c('span',{staticClass:"local-tz la"},[_vm._v("Pacific Time")])])]),_vm._v(" "),_c('td',{staticClass:"loc"},[_c('b',[_vm._v(_vm._s(_vm.rsvp1.dropoff ? _vm.rsvp1.dropoff.airportCode : ''))])]),_vm._v(" "),_c('td',{staticClass:"td-action"},[_c('i',{staticClass:"fas fa-ellipsis-v fa-2x",on:{"click":function($event){return _vm.showOptions(_vm.rsvp1, 'rsvp1')}}})])]):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._l((_vm.details.flights.oneway),function(flight,i){return _c('tr',{key:i,class:{'flight-tr': i + 1 < _vm.details.flights.oneway.length}},[_c('td',{staticClass:"flight-name"},[_c('div',[_vm._v(_vm._s(flight.flightName))]),_vm._v(" "),_c('b',[_vm._v(_vm._s(flight.flightCode)+" - "+_vm._s(flight.flightNo))])]),_vm._v(" "),_c('td',{staticClass:"loc"},[_c('b',[_vm._v(_vm._s(flight.origin.code))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(flight.origin.name))]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                "+_vm._s(flight.origin.date)+"\n                "),_c('span',{staticClass:"local-tz"},[_vm._v("Local")])]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                "+_vm._s(flight.origin.dateLA)+"\n                "),_c('span',{staticClass:"local-tz la"},[_vm._v("Pacific Time")])])]),_vm._v(" "),_c('td',{staticClass:"loc",attrs:{"colspan":"2"}},[_c('b',[_vm._v(_vm._s(flight.destination.code))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(flight.destination.name))]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                "+_vm._s(flight.destination.date)+"\n                "),_c('span',{staticClass:"local-tz"},[_vm._v("Local")])]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                "+_vm._s(flight.destination.dateLA)+"\n                "),_c('span',{staticClass:"local-tz la"},[_vm._v("Pacific Time")])])])])}),_vm._v(" "),(_vm.hasRsvp(_vm.rsvp2))?_c('tr',{staticClass:"head"},[_c('td',[_vm._v("Service")]),_vm._v(" "),_c('td',[_vm._v("Pickup")]),_vm._v(" "),_c('td',[_vm._v("Dropoff")]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('div',{class:['status', _vm.rsvp2.status]},[_vm._v(_vm._s(_vm.rsvp2.status))])])]):_vm._e(),_vm._v(" "),(_vm.hasRsvp(_vm.rsvp2))?_c('tr',[_c('td',[_c('div',{staticClass:"service"},[_vm._v(_vm._s(_vm.rsvp2.service))]),_vm._v(" "),_c('a',{staticClass:"rsvp-link",attrs:{"href":("#/reservation/" + (_vm.rsvp2.id)),"target":"_blank"}},[_vm._v("RSVP "+_vm._s(_vm.rsvp2.id))])]),_vm._v(" "),_c('td',{staticClass:"loc"},[_c('b',[_vm._v(_vm._s(_vm.rsvp2.pickup ? _vm.rsvp2.pickup.airportCode : ''))]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                "+_vm._s(_vm.rsvp2.pickupDate)+"\n                "),_c('span',{staticClass:"local-tz"},[_vm._v("Local")])]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                "+_vm._s(_vm.rsvp2.pickupDateLA)+"\n                "),_c('span',{staticClass:"local-tz la"},[_vm._v("Pacific Time")])])]),_vm._v(" "),_c('td',{staticClass:"loc"},[_c('b',[_vm._v(_vm._s(_vm.rsvp2.dropoff ? _vm.rsvp2.dropoff.title : ''))])]),_vm._v(" "),_c('td',{staticClass:"td-action"},[_c('i',{staticClass:"fas fa-ellipsis-v fa-2x",on:{"click":function($event){return _vm.showOptions(_vm.rsvp2, 'rsvp2')}}})])]):_vm._e()],2)]),_vm._v(" "),(_vm.hasReturnTrip)?_c('div',{staticClass:"journey"},[_c('div',{staticClass:"f-label table-head"},[_vm._v("JOURNEY DETAILS - RETURN TRIP")]),_vm._v(" "),_c('table',{attrs:{"cellspacing":"0"}},[(_vm.hasRsvp(_vm.rsvp3))?_c('tr',{staticClass:"head"},[_c('td',[_vm._v("Service")]),_vm._v(" "),_c('td',[_vm._v("Pickup")]),_vm._v(" "),_c('td',[_vm._v("Dropoff")]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('div',{class:['status', _vm.rsvp3.status]},[_vm._v(_vm._s(_vm.rsvp3.status))])])]):_vm._e(),_vm._v(" "),(_vm.hasRsvp(_vm.rsvp3))?_c('tr',[_c('td',[_c('div',{staticClass:"service"},[_vm._v(_vm._s(_vm.rsvp3.service))]),_vm._v(" "),_c('a',{staticClass:"rsvp-link",attrs:{"href":("#/reservation/" + (_vm.rsvp3.id)),"target":"_blank"}},[_vm._v("RSVP "+_vm._s(_vm.rsvp3.id))])]),_vm._v(" "),_c('td',{staticClass:"loc"},[_c('b',[_vm._v(_vm._s(_vm.rsvp3.pickup ? _vm.rsvp3.pickup.title : ''))]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                "+_vm._s(_vm.rsvp3.pickupDate)+"\n                "),_c('span',{staticClass:"local-tz"},[_vm._v("Local")])]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                "+_vm._s(_vm.rsvp3.pickupDateLA)+"\n                "),_c('span',{staticClass:"local-tz la"},[_vm._v("Pacific Time")])])]),_vm._v(" "),_c('td',{staticClass:"loc"},[_c('b',[_vm._v(_vm._s(_vm.rsvp3.dropoff ? _vm.rsvp3.dropoff.airportCode : ''))])]),_vm._v(" "),_c('td',{staticClass:"td-action"},[_c('i',{staticClass:"fas fa-ellipsis-v fa-2x",on:{"click":function($event){return _vm.showOptions(_vm.rsvp3, 'rsvp3')}}})])]):_vm._e(),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._l((_vm.details.flights.return),function(flight,i){return _c('tr',{key:i,class:{'flight-tr': i + 1 < _vm.details.flights.return.length}},[_c('td',{staticClass:"flight-name"},[_c('div',[_vm._v(_vm._s(flight.flightName))]),_vm._v(" "),_c('b',[_vm._v(_vm._s(flight.flightCode)+" - "+_vm._s(flight.flightNo))])]),_vm._v(" "),_c('td',{staticClass:"loc"},[_c('b',[_vm._v(_vm._s(flight.origin.code))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(flight.origin.name))]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                "+_vm._s(flight.origin.date)+"\n                "),_c('span',{staticClass:"local-tz"},[_vm._v("Local")])]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                "+_vm._s(flight.origin.dateLA)+"\n                "),_c('span',{staticClass:"local-tz la"},[_vm._v("Pacific Time")])])]),_vm._v(" "),_c('td',{staticClass:"loc",attrs:{"colspan":"2"}},[_c('b',[_vm._v(_vm._s(flight.destination.code))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(flight.destination.name))]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                "+_vm._s(flight.destination.date)+"\n                "),_c('span',{staticClass:"local-tz"},[_vm._v("Local")])]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                "+_vm._s(flight.destination.dateLA)+"\n                "),_c('span',{staticClass:"local-tz la"},[_vm._v("Pacific Time")])])])])}),_vm._v(" "),(_vm.hasRsvp(_vm.rsvp4))?_c('tr',{staticClass:"head"},[_c('td',[_vm._v("Service")]),_vm._v(" "),_c('td',[_vm._v("Pickup")]),_vm._v(" "),_c('td',[_vm._v("Dropoff")]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('div',{class:['status', _vm.rsvp4.status]},[_vm._v(_vm._s(_vm.rsvp4.status))])])]):_vm._e(),_vm._v(" "),(_vm.hasRsvp(_vm.rsvp4))?_c('tr',[_c('td',[_c('div',{staticClass:"service"},[_vm._v(_vm._s(_vm.rsvp4.service))]),_vm._v(" "),_c('a',{staticClass:"rsvp-link",attrs:{"href":("#/reservation/" + (_vm.rsvp4.id)),"target":"_blank"}},[_vm._v("RSVP "+_vm._s(_vm.rsvp4.id))])]),_vm._v(" "),_c('td',{staticClass:"loc"},[_c('b',[_vm._v(_vm._s(_vm.rsvp4.pickup ? _vm.rsvp4.pickup.airportCode : ''))]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                "+_vm._s(_vm.rsvp4.pickupDate)+"\n                "),_c('span',{staticClass:"local-tz"},[_vm._v("Local")])]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                "+_vm._s(_vm.rsvp4.pickupDateLA)+"\n                "),_c('span',{staticClass:"local-tz la"},[_vm._v("Pacific Time")])])]),_vm._v(" "),_c('td',{staticClass:"loc"},[_c('b',[_vm._v(_vm._s(_vm.rsvp4.dropoff ? _vm.rsvp4.dropoff.title : ''))])]),_vm._v(" "),_c('td',{staticClass:"td-action"},[_c('i',{staticClass:"fas fa-ellipsis-v fa-2x",on:{"click":function($event){return _vm.showOptions(_vm.rsvp4, 'rsvp4')}}})])]):_vm._e()],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pax"},[_c('div',{staticClass:"f-label table-head"},[_vm._v("PASSENGER")]),_vm._v(" "),_c('table',{attrs:{"cellspacing":"0"}},[_vm._m(2),_vm._v(" "),_vm._l((_vm.details.pax),function(p,i){return (!_vm.isPending)?_c('tr',{key:i},[_c('td',[_vm._v(_vm._s(p.firstName)+" "+_vm._s(p.lastName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(p.ticketId))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(p.ticketNo))])]):_vm._e()}),_vm._v(" "),(_vm.isPending)?_c('tr',[_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)]):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"right-box"},[_c('div',{staticClass:"payment-box"},[_c('div',{staticClass:"f-label table-head"},[_vm._v("PAYMENT BREAKDOWN")]),_vm._v(" "),_c('table',{attrs:{"cellspacing":"0"}},[_c('tr',[_c('td',[_vm._v("Air Fare and Taxes")]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.priceFormat(_vm.details.airFareTotal)))])]),_vm._v(" "),(_vm.hasRsvp(_vm.rsvp1))?_c('tr',[_c('td',[(_vm.hasReturnTrip)?_c('span',[_vm._v("Leg 1:")]):_vm._e(),_vm._v("\n              "+_vm._s(_vm.shortenLoc(_vm.rsvp1.pickup))+" to "+_vm._s(_vm.shortenLoc(_vm.rsvp1.dropoff))+"\n            ")]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.priceFormat(_vm.rsvp1.payment)))])]):_vm._e(),_vm._v(" "),(_vm.hasRsvp(_vm.rsvp2))?_c('tr',[_c('td',[(_vm.hasReturnTrip)?_c('span',[_vm._v("Leg 2:")]):_vm._e(),_vm._v("\n              "+_vm._s(_vm.shortenLoc(_vm.rsvp2.pickup))+" to "+_vm._s(_vm.shortenLoc(_vm.rsvp2.dropoff))+"\n            ")]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.priceFormat(_vm.rsvp2.payment)))])]):_vm._e(),_vm._v(" "),(_vm.hasReturnTrip && _vm.hasRsvp(_vm.rsvp3))?_c('tr',[_c('td',[_vm._v("\n              Leg 3:\n              "+_vm._s(_vm.shortenLoc(_vm.rsvp3.pickup))+" to "+_vm._s(_vm.shortenLoc(_vm.rsvp3.dropoff))+"\n            ")]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.priceFormat(_vm.rsvp3.payment)))])]):_vm._e(),_vm._v(" "),(_vm.hasReturnTrip && _vm.hasRsvp(_vm.rsvp4))?_c('tr',[_c('td',[_vm._v("\n              Leg 4:\n              "+_vm._s(_vm.shortenLoc(_vm.rsvp4.pickup))+" to "+_vm._s(_vm.shortenLoc(_vm.rsvp4.dropoff))+"\n            ")]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.priceFormat(_vm.rsvp4.payment)))])]):_vm._e(),_vm._v(" "),_c('tr',{staticClass:"total"},[_c('td',[_vm._v("TOTAL")]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.priceFormat(_vm.totalPayment)))])])])]),_vm._v(" "),_c('div',{staticClass:"map-box"},[_c('fmap',{ref:"refmap"})],1)])]),_vm._v(" "),_c('div',{class:['lr-modal', {'hide': !_vm.showCxlConfirm}],on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.showCxlConfirm = false}}},[_c('div',{staticClass:"lr-box"},[_vm._v("\n      Are you sure you want to cancel this flight?\n\n      "),_c('div',{staticClass:"cxl-fee-box"},[_c('span',[_vm._v("\n          The customer will have to pay a cancellaton fee of \n          "),_c('b',[_vm._v("$"+_vm._s(_vm.currentFlightFee))]),_vm._v(". \n          Do you want to charge the cancellation fee?\n        ")]),_vm._v(" "),_c('div',{staticClass:"fee-breakdown"},[_vm._v("\n          Flight Fee: "),_c('b',[_vm._v("$"+_vm._s(_vm.flightAction.cxlFee.flight))]),_vm._v(" "),(_vm.rsvp1.status === 'upcoming')?_c('div',[_vm._v("RSVP 1 Fee: "),_c('b',[_vm._v("$"+_vm._s(_vm.flightAction.cxlFee.rsvp1))])]):_vm._e(),_vm._v(" "),(_vm.rsvp2.status === 'upcoming')?_c('div',[_vm._v("RSVP 2 Fee: "),_c('b',[_vm._v("$"+_vm._s(_vm.flightAction.cxlFee.rsvp2))])]):_vm._e(),_vm._v(" "),(_vm.hasReturnTrip)?_c('div',[(_vm.rsvp3.status === 'upcoming')?_c('div',[_vm._v("RSVP 3 Fee: "),_c('b',[_vm._v("$"+_vm._s(_vm.flightAction.cxlFee.rsvp3))])]):_vm._e(),_vm._v(" "),(_vm.rsvp4.status === 'upcoming')?_c('div',[_vm._v("RSVP 4 Fee: "),_c('b',[_vm._v("$"+_vm._s(_vm.flightAction.cxlFee.rsvp4))])]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.flightAction.charge),expression:"flightAction.charge"}],attrs:{"type":"radio","name":"cancelFee","value":"1"},domProps:{"checked":_vm._q(_vm.flightAction.charge,"1")},on:{"change":function($event){return _vm.$set(_vm.flightAction, "charge", "1")}}}),_vm._v("\n            Yes, refund "),_c('b',[_vm._v("$"+_vm._s(_vm.priceFormat((_vm.totalPayment - _vm.currentFlightFee).toFixed(2))))]),_vm._v(" only\n          ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.flightAction.charge),expression:"flightAction.charge"}],attrs:{"type":"radio","name":"cancelFee","value":"0"},domProps:{"checked":_vm._q(_vm.flightAction.charge,"0")},on:{"change":function($event){return _vm.$set(_vm.flightAction, "charge", "0")}}}),_vm._v("\n            No, refund full amount of "),_c('b',[_vm._v("$"+_vm._s(_vm.priceFormat(_vm.totalPayment.toFixed(2))))])])])]),_vm._v(" "),_c('ul',{staticClass:"check-list"},[_c('li',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cancelAllGround),expression:"cancelAllGround"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.cancelAllGround)?_vm._i(_vm.cancelAllGround,null)>-1:(_vm.cancelAllGround)},on:{"change":function($event){var $$a=_vm.cancelAllGround,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.cancelAllGround=$$a.concat([$$v]))}else{$$i>-1&&(_vm.cancelAllGround=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.cancelAllGround=$$c}}}}),_vm._v("\n            Cancel all ground RSVP\n          ")])]),_vm._v(" "),_c('li',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notifyUser),expression:"notifyUser"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.notifyUser)?_vm._i(_vm.notifyUser,null)>-1:(_vm.notifyUser)},on:{"change":function($event){var $$a=_vm.notifyUser,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.notifyUser=$$a.concat([$$v]))}else{$$i>-1&&(_vm.notifyUser=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.notifyUser=$$c}}}}),_vm._v("\n            Notify the user\n          ")])])]),_vm._v(" "),_c('a',{staticClass:"button cta xsmall primary block",on:{"click":_vm.cxlFLight}},[_vm._v("\n        Yes, cancel this flight\n      ")]),_vm._v(" "),_c('a',{staticClass:"button cta xsmall secondary block",on:{"click":function($event){_vm.showCxlConfirm = false}}},[_vm._v("\n        No, i change my mind\n      ")])])]),_vm._v(" "),_c('div',{class:['lr2-modal', {'hide': !_vm.rsvpAction.show}],on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.rsvpAction.show = false}}},[(_vm.rsvpAction.confirm)?_c('div',{staticClass:"lr2-box rsvp-modal"},[(_vm.rsvpAction.type === 'cancel')?_c('div',[_vm._v("\n        Are you sure you want to cancel "),_c('b',[_vm._v("RSVP "+_vm._s(_vm.rsvpAction.data.id))]),_vm._v("?\n\n        "),_c('div',{staticClass:"cxl-fee-box"},[_c('span',[_vm._v("\n            The customer will have to pay a cancellaton fee of \n            "),_c('b',[_vm._v("$"+_vm._s(_vm.flightAction.cxlFee[_vm.rsvpAction.target]))]),_vm._v(". \n            Do you want to charge the cancellation fee?\n          ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-space-around align-center"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rsvpAction.charge),expression:"rsvpAction.charge"}],attrs:{"type":"radio","name":"cancelFee","value":"1"},domProps:{"checked":_vm._q(_vm.rsvpAction.charge,"1")},on:{"change":function($event){return _vm.$set(_vm.rsvpAction, "charge", "1")}}}),_vm._v("\n              Yes\n            ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rsvpAction.charge),expression:"rsvpAction.charge"}],attrs:{"type":"radio","name":"cancelFee","value":"0"},domProps:{"checked":_vm._q(_vm.rsvpAction.charge,"0")},on:{"change":function($event){return _vm.$set(_vm.rsvpAction, "charge", "0")}}}),_vm._v("\n              No\n            ")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"button cta primary block small",on:{"click":function($event){return _vm.proccessAction(_vm.rsvpAction.data.id)}}},[(_vm.rsvpAction.type === 'cancel')?_c('span',[_vm._v("Yes, cancel this RSVP")]):_vm._e(),_vm._v(" "),(_vm.rsvpAction.type === 'refund')?_c('span',[_vm._v("Yes, refund this RSVP")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"button cta secondary block small",on:{"click":function($event){_vm.rsvpAction.show = false}}},[(_vm.rsvpAction.type === 'cancel')?_c('span',[_vm._v("No, I change my mind")]):_vm._e(),_vm._v(" "),(_vm.rsvpAction.type === 'refund')?_c('span',[_vm._v("Cancel Refund")]):_vm._e()])])]):_c('div',{staticClass:"lr2-box rsvp-modal"},[_c('div',{staticClass:"d-flex align-center justify-space-between"},[_c('div',{staticClass:"id"},[_vm._v("RSVP "+_vm._s(_vm.rsvpAction.data.id))]),_vm._v(" "),_c('div',{class:['status', _vm.rsvpAction.data.status]},[_vm._v(_vm._s(_vm.rsvpAction.data.status))])]),_vm._v(" "),_c('div',{staticClass:"service"},[_vm._v(_vm._s(_vm.rsvpAction.data.service))]),_vm._v(" "),_c('div',{staticClass:"loc"},[_c('div',{staticClass:"label"},[_vm._v("PICKUP")]),_vm._v(" "),_c('div',{staticClass:"val"},[_vm._v(_vm._s(_vm.rsvpAction.data.pickup ? _vm.rsvpAction.data.pickup.title : ''))])]),_vm._v(" "),_c('div',{staticClass:"loc"},[_c('div',{staticClass:"label"},[_vm._v("DROPOFF")]),_vm._v(" "),_c('div',{staticClass:"val"},[_vm._v(_vm._s(_vm.rsvpAction.data.dropoff ? _vm.rsvpAction.data.dropoff.title : ''))])]),_vm._v(" "),_c('div',{staticClass:"actions"},[(_vm.rsvpAction.data.status === 'upcoming')?_c('div',{staticClass:"button cta block small error",on:{"click":function($event){return _vm.showConfirm('cancel')}}},[_c('span',[_vm._v("CANCEL RSVP")])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"head"},[_c('td',[_vm._v("Flight")]),_vm._v(" "),_c('td',[_vm._v("Departing")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("Arriving")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"head"},[_c('td',[_vm._v("Flight")]),_vm._v(" "),_c('td',[_vm._v("Departing")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("Arriving")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Ticket ID")]),_vm._v(" "),_c('th',[_vm._v("Ticket Number")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('span',{staticClass:"pending-txt"},[_vm._v("PENDING")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('span',{staticClass:"pending-txt"},[_vm._v("PENDING")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('span',{staticClass:"pending-txt"},[_vm._v("PENDING")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trx_vue__ = __webpack_require__(629);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd92f67c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trx_vue__ = __webpack_require__(1881);
function injectStyle (ssrContext) {
  __webpack_require__(1879)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dd92f67c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trx_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd92f67c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trx_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1880);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("7b33b004", content, true, {});

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.trx-box[data-v-dd92f67c] {\n  background: #fbfbfb;\n  border-radius: 2px;\n  border: 1px solid #ddd;\n  -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n          box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n  padding: 20px;\n}\ntable[data-v-dd92f67c] {\n  border: 1px solid #999;\n  width: 100%;\n  background: #fff;\n}\ntable thead[data-v-dd92f67c] {\n    font-weight: 600;\n    line-height: 1;\n    background: #eaeaea;\n    color: #333;\n    font-size: 13px;\n}\ntable thead th[data-v-dd92f67c] {\n      padding: 10px;\n}\ntable td[data-v-dd92f67c] {\n    vertical-align: top;\n    padding: 10px;\n    font-size: 14px;\n}\ntable tr:nth-child(even):not(.head) td[data-v-dd92f67c] {\n    background: #f7f7f7;\n}\ntable .stripe-id[data-v-dd92f67c] {\n    color: #777;\n    font-style: italic;\n}\n.a-left[data-v-dd92f67c] {\n  text-align: left;\n}\n.a-center[data-v-dd92f67c] {\n  text-align: center;\n}\n.status[data-v-dd92f67c] {\n  padding: 3px 10px;\n  font-size: 12px;\n  background: #333;\n  color: #fff;\n  border-radius: 4px;\n  font-weight: 600;\n  letter-spacing: .6px;\n}\n.status.PAID[data-v-dd92f67c], .status.SUCCESS[data-v-dd92f67c] {\n    background: #3bbb3b;\n}\n.loading[data-v-dd92f67c] {\n  font-size: 21px;\n  color: #888;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/FlightDetails/trx.vue"],"names":[],"mappings":";AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mDAAmD;UAC3C,2CAA2C;EACnD,oBAAoB;EACpB,cAAc;CACf;AACD;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;CAClB;AACD;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;CACnB;AACD;MACM,cAAc;CACnB;AACD;IACI,oBAAoB;IACpB,cAAc;IACd,gBAAgB;CACnB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,YAAY;IACZ,mBAAmB;CACtB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;CACtB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,gBAAgB;EAChB,YAAY;CACb","file":"trx.vue","sourcesContent":["\n.trx-box[data-v-dd92f67c] {\n  background: #fbfbfb;\n  border-radius: 2px;\n  border: 1px solid #ddd;\n  -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n          box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n  padding: 20px;\n}\ntable[data-v-dd92f67c] {\n  border: 1px solid #999;\n  width: 100%;\n  background: #fff;\n}\ntable thead[data-v-dd92f67c] {\n    font-weight: 600;\n    line-height: 1;\n    background: #eaeaea;\n    color: #333;\n    font-size: 13px;\n}\ntable thead th[data-v-dd92f67c] {\n      padding: 10px;\n}\ntable td[data-v-dd92f67c] {\n    vertical-align: top;\n    padding: 10px;\n    font-size: 14px;\n}\ntable tr:nth-child(even):not(.head) td[data-v-dd92f67c] {\n    background: #f7f7f7;\n}\ntable .stripe-id[data-v-dd92f67c] {\n    color: #777;\n    font-style: italic;\n}\n.a-left[data-v-dd92f67c] {\n  text-align: left;\n}\n.a-center[data-v-dd92f67c] {\n  text-align: center;\n}\n.status[data-v-dd92f67c] {\n  padding: 3px 10px;\n  font-size: 12px;\n  background: #333;\n  color: #fff;\n  border-radius: 4px;\n  font-weight: 600;\n  letter-spacing: .6px;\n}\n.status.PAID[data-v-dd92f67c], .status.SUCCESS[data-v-dd92f67c] {\n    background: #3bbb3b;\n}\n.loading[data-v-dd92f67c] {\n  font-size: 21px;\n  color: #888;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trx-box"},[_c('table',{attrs:{"cellspacing":"0"}},[_vm._m(0),_vm._v(" "),_vm._l((_vm.trx),function(t,i){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],key:i},[_c('td',{staticClass:"a-left"},[_vm._v(_vm._s(t.created))]),_vm._v(" "),_c('td',{staticClass:"a-left"},[_vm._v("$"+_vm._s(_vm.priceFormat(t.amount)))]),_vm._v(" "),_c('td',{staticClass:"a-left stripe-id"},[_vm._v(_vm._s(t.stripeChargeId))]),_vm._v(" "),_c('td',{staticClass:"a-center"},[_c('b',[_vm._v(_vm._s(t.trxType))])]),_vm._v(" "),_c('td',{staticClass:"a-center"},[_c('span',{class:['status', t.status]},[_vm._v(_vm._s(t.status))])]),_vm._v(" "),_c('td',{staticClass:"a-center"},[(!t.url)?_c('span',[_vm._v("--")]):_c('a',{attrs:{"href":t.url,"target":"_blank"}},[_c('i',{staticClass:"fa fa-link"})])])])}),_vm._v(" "),(!_vm.loading && !_vm.trx.length)?_c('tr',[_c('td',{staticClass:"a-center loading",attrs:{"colspan":"6"}},[_vm._v("\n        No transaction for this flight...\n      ")])]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('tr',[_vm._m(1)]):_vm._e()],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',{staticClass:"a-left"},[_vm._v("Date")]),_vm._v(" "),_c('th',{staticClass:"a-left"},[_vm._v("Amount")]),_vm._v(" "),_c('th',{staticClass:"a-left"},[_vm._v("Stripe Charge ID")]),_vm._v(" "),_c('th',{staticClass:"a-center"},[_vm._v("Transaction Type")]),_vm._v(" "),_c('th',{staticClass:"a-center"},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"a-center"},[_vm._v("URL")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"a-center loading",attrs:{"colspan":"6"}},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n        Getting Transactions...\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1882 */
/***/ (function(module, exports) {

module.exports = {
  AAA: 'Pacific/Tahiti',
  AAB: 'Australia/Brisbane',
  AAC: 'Africa/Cairo',
  AAD: 'Africa/Mogadishu',
  AAE: 'Africa/Algiers',
  AAF: 'America/New_York',
  AAG: 'America/Sao_Paulo',
  AAH: 'Europe/Berlin',
  AAI: 'America/Araguaina',
  AAJ: 'America/Paramaribo',
  AAK: 'Pacific/Tarawa',
  AAL: 'Europe/Copenhagen',
  AAM: 'Africa/Johannesburg',
  AAN: 'Asia/Dubai',
  AAO: 'America/Caracas',
  AAP: 'Asia/Makassar',
  AAQ: 'Europe/Moscow',
  AAR: 'Europe/Copenhagen',
  AAS: 'Asia/Jayapura',
  AAT: 'Asia/Urumqi',
  AAU: 'Pacific/Apia',
  AAV: 'Asia/Manila',
  AAX: 'America/Sao_Paulo',
  AAY: 'Asia/Aden',
  AAZ: 'America/Guatemala',
  ABA: 'Asia/Krasnoyarsk',
  ABB: 'Africa/Lagos',
  ABC: 'Europe/Madrid',
  ABD: 'Asia/Tehran',
  ABE: 'America/New_York',
  ABF: 'Pacific/Tarawa',
  ABG: 'Australia/Brisbane',
  ABH: 'Australia/Brisbane',
  ABI: 'America/Chicago',
  ABJ: 'Africa/Abidjan',
  ABK: 'Africa/Addis_Ababa',
  ABL: 'America/Anchorage',
  ABM: 'Australia/Brisbane',
  ABN: 'America/Paramaribo',
  ABO: 'Africa/Abidjan',
  ABP: 'Pacific/Port_Moresby',
  ABQ: 'America/Denver',
  ABR: 'America/Chicago',
  ABS: 'Africa/Cairo',
  ABT: 'Asia/Riyadh',
  ABU: 'Asia/Makassar',
  ABV: 'Africa/Lagos',
  ABW: 'Pacific/Port_Moresby',
  ABX: 'Australia/Sydney',
  ABY: 'America/New_York',
  ABZ: 'Europe/London',
  ACA: 'America/Mexico_City',
  ACB: 'America/Detroit',
  ACC: 'Africa/Accra',
  ACD: 'America/Bogota',
  ACE: 'Atlantic/Canary',
  ACH: 'Europe/Zurich',
  ACI: 'Europe/Guernsey',
  ACJ: 'Asia/Colombo',
  ACK: 'America/New_York',
  ACL: 'America/Bogota',
  ACM: 'America/Bogota',
  ACN: 'America/Matamoros',
  ACP: 'Asia/Tehran',
  ACR: 'America/Bogota',
  ACS: 'Asia/Krasnoyarsk',
  ACT: 'America/Chicago',
  ACU: 'America/Panama',
  ACV: 'America/Los_Angeles',
  ACX: 'Asia/Shanghai',
  ACY: 'America/New_York',
  ACZ: 'Asia/Tehran',
  ADA: 'Europe/Istanbul',
  ADB: 'Europe/Istanbul',
  ADC: 'Pacific/Port_Moresby',
  ADD: 'Africa/Addis_Ababa',
  ADE: 'Asia/Aden',
  ADF: 'Europe/Istanbul',
  ADG: 'America/Detroit',
  ADH: 'Asia/Yakutsk',
  ADI: 'Africa/Windhoek',
  ADJ: 'Asia/Amman',
  ADK: 'America/Adak',
  ADL: 'Australia/Adelaide',
  ADM: 'America/Chicago',
  ADN: 'America/Bogota',
  ADO: 'Australia/Adelaide',
  ADP: 'Asia/Colombo',
  ADQ: 'America/Anchorage',
  ADR: 'America/New_York',
  ADS: 'America/Chicago',
  ADT: 'America/Chicago',
  ADU: 'Asia/Tehran',
  ADV: 'Africa/Khartoum',
  ADW: 'America/New_York',
  ADX: 'Europe/London',
  ADY: 'Africa/Johannesburg',
  ADZ: 'America/Bogota',
  AEA: 'Pacific/Tarawa',
  AEB: 'Asia/Shanghai',
  AEE: 'Africa/Juba',
  AEG: 'Asia/Jakarta',
  AEH: 'Africa/Ndjamena',
  AEK: 'Pacific/Port_Moresby',
  AEL: 'America/Chicago',
  AEM: 'Asia/Vladivostok',
  AEO: 'Africa/Nouakchott',
  AEP: 'America/Argentina/Buenos_Aires',
  AEQ: 'Asia/Shanghai',
  AER: 'Europe/Moscow',
  AES: 'Europe/Oslo',
  AET: 'America/Anchorage',
  AEU: 'Asia/Tehran',
  AEX: 'America/Chicago',
  AEY: 'Atlantic/Reykjavik',
  AFA: 'America/Argentina/Mendoza',
  AFD: 'Africa/Johannesburg',
  AFF: 'America/Denver',
  AFI: 'America/Bogota',
  AFK: 'Asia/Colombo',
  AFL: 'America/Cuiaba',
  AFN: 'America/New_York',
  AFO: 'America/Denver',
  AFR: 'Pacific/Port_Moresby',
  AFS: 'Asia/Samarkand',
  AFT: 'Pacific/Guadalcanal',
  AFW: 'America/Chicago',
  AFY: 'Europe/Istanbul',
  AFZ: 'Asia/Tehran',
  AGA: 'Africa/Casablanca',
  AGB: 'Europe/Berlin',
  AGC: 'America/New_York',
  AGD: 'Asia/Jayapura',
  AGE: 'Europe/Berlin',
  AGF: 'Europe/Paris',
  AGG: 'Pacific/Port_Moresby',
  AGH: 'Europe/Stockholm',
  AGI: 'America/Paramaribo',
  AGJ: 'Asia/Tokyo',
  AGK: 'Pacific/Port_Moresby',
  AGL: 'Pacific/Port_Moresby',
  AGN: 'America/Juneau',
  AGO: 'America/Chicago',
  AGP: 'Europe/Madrid',
  AGQ: 'Europe/Athens',
  AGR: 'Asia/Kolkata',
  AGS: 'America/New_York',
  AGT: 'America/Asuncion',
  AGU: 'America/Mexico_City',
  AGV: 'America/Caracas',
  AGW: 'Australia/Brisbane',
  AGX: 'Asia/Kolkata',
  AGZ: 'Africa/Johannesburg',
  AHB: 'Asia/Riyadh',
  AHC: 'America/Los_Angeles',
  AHD: 'America/Chicago',
  AHE: 'Pacific/Tahiti',
  AHF: 'America/Chicago',
  AHH: 'America/Chicago',
  AHI: 'Asia/Jayapura',
  AHJ: 'Asia/Shanghai',
  AHL: 'America/Guyana',
  AHM: 'America/Los_Angeles',
  AHN: 'America/New_York',
  AHO: 'Europe/Rome',
  AHS: 'America/Tegucigalpa',
  AHU: 'Africa/Casablanca',
  AHW: 'Asia/Muscat',
  AHY: 'Indian/Antananarivo',
  AHZ: 'Europe/Paris',
  AIA: 'America/Denver',
  AIC: 'Pacific/Kwajalein',
  AID: 'America/Indiana/Indianapolis',
  AIE: 'Pacific/Port_Moresby',
  AIF: 'America/Sao_Paulo',
  AIG: 'Africa/Bangui',
  AIH: 'Pacific/Port_Moresby',
  AII: 'Africa/Djibouti',
  AIK: 'America/New_York',
  AIL: 'America/Panama',
  AIM: 'Pacific/Kwajalein',
  AIN: 'America/Anchorage',
  AIO: 'America/Chicago',
  AIP: 'Asia/Kolkata',
  AIR: 'America/Cuiaba',
  AIS: 'Pacific/Tarawa',
  AIT: 'Pacific/Rarotonga',
  AIU: 'Pacific/Rarotonga',
  AIV: 'America/Chicago',
  AIW: 'Africa/Windhoek',
  AIZ: 'America/Chicago',
  AJA: 'Europe/Paris',
  AJF: 'Asia/Riyadh',
  AJI: 'Europe/Istanbul',
  AJJ: 'Africa/Nouakchott',
  AJK: 'Asia/Tehran',
  AJL: 'Asia/Kolkata',
  AJN: 'Indian/Comoro',
  AJR: 'Europe/Stockholm',
  AJS: 'America/Hermosillo',
  AJU: 'America/Noronha',
  AJY: 'Africa/Niamey',
  AKA: 'Asia/Shanghai',
  AKB: 'America/Adak',
  AKC: 'America/New_York',
  AKD: 'Asia/Kolkata',
  AKE: 'Africa/Libreville',
  AKF: 'Africa/Tripoli',
  AKG: 'Pacific/Port_Moresby',
  AKH: 'Asia/Riyadh',
  AKI: 'America/Anchorage',
  AKJ: 'Asia/Tokyo',
  AKK: 'America/Anchorage',
  AKL: 'Pacific/Auckland',
  AKM: 'Africa/Ndjamena',
  AKN: 'America/Anchorage',
  AKO: 'America/Denver',
  AKP: 'America/Anchorage',
  AKQ: 'Asia/Jakarta',
  AKR: 'Africa/Lagos',
  AKS: 'Pacific/Guadalcanal',
  AKT: 'Asia/Nicosia',
  AKU: 'Asia/Shanghai',
  AKV: 'America/Toronto',
  AKW: 'Asia/Tehran',
  AKX: 'Asia/Aqtobe',
  AKY: 'Asia/Yangon',
  ALA: 'Asia/Almaty',
  ALB: 'America/New_York',
  ALC: 'Europe/Madrid',
  ALD: 'America/Lima',
  ALE: 'America/Chicago',
  ALF: 'Europe/Oslo',
  ALG: 'Africa/Algiers',
  ALH: 'Australia/Perth',
  ALI: 'America/Chicago',
  ALJ: 'Africa/Johannesburg',
  ALK: 'Africa/Addis_Ababa',
  ALL: 'Europe/Rome',
  ALM: 'America/Denver',
  ALN: 'America/Chicago',
  ALO: 'America/Chicago',
  ALP: 'Asia/Damascus',
  ALQ: 'America/Sao_Paulo',
  ALR: 'Pacific/Auckland',
  ALS: 'America/Denver',
  ALT: 'America/Santarem',
  ALU: 'Africa/Mogadishu',
  ALW: 'America/Los_Angeles',
  ALX: 'America/Chicago',
  ALY: 'Africa/Cairo',
  ALZ: 'America/Anchorage',
  AMA: 'America/Chicago',
  AMB: 'Indian/Antananarivo',
  AMC: 'Africa/Ndjamena',
  AMD: 'Asia/Kolkata',
  AME: 'Africa/Maputo',
  AMF: 'Pacific/Port_Moresby',
  AMG: 'Pacific/Port_Moresby',
  AMH: 'Africa/Addis_Ababa',
  AMI: 'Asia/Makassar',
  AMJ: 'America/Sao_Paulo',
  AMK: 'America/Denver',
  AML: 'America/Panama',
  AMM: 'Asia/Amman',
  AMN: 'America/Detroit',
  AMO: 'Africa/Ndjamena',
  AMP: 'Indian/Antananarivo',
  AMQ: 'Asia/Jayapura',
  AMS: 'Europe/Amsterdam',
  AMT: 'Australia/Adelaide',
  AMU: 'Pacific/Port_Moresby',
  AMV: 'Europe/Moscow',
  AMW: 'America/Chicago',
  AMX: 'Australia/Darwin',
  AMY: 'Indian/Antananarivo',
  AMZ: 'Pacific/Auckland',
  ANA: 'Africa/Nairobi',
  ANB: 'America/Chicago',
  ANC: 'America/Anchorage',
  AND: 'America/New_York',
  ANE: 'Europe/Paris',
  ANF: 'America/Santiago',
  ANG: 'Europe/Paris',
  ANI: 'America/Anchorage',
  ANJ: 'Africa/Brazzaville',
  ANK: 'Europe/Istanbul',
  ANL: 'Africa/Luanda',
  ANM: 'Indian/Antananarivo',
  ANN: 'America/Metlakatla',
  ANO: 'Africa/Maputo',
  ANP: 'America/New_York',
  ANQ: 'America/Indiana/Indianapolis',
  ANR: 'Europe/Brussels',
  ANS: 'America/Lima',
  ANU: 'America/Antigua',
  ANV: 'America/Anchorage',
  ANW: 'America/Chicago',
  ANX: 'Europe/Oslo',
  ANY: 'America/Chicago',
  ANZ: 'Australia/Darwin',
  AOA: 'Pacific/Port_Moresby',
  AOB: 'Pacific/Port_Moresby',
  AOC: 'Europe/Berlin',
  AOD: 'Africa/Ndjamena',
  AOE: 'Europe/Istanbul',
  AOG: 'Asia/Shanghai',
  AOH: 'America/New_York',
  AOI: 'Europe/Rome',
  AOJ: 'Asia/Tokyo',
  AOK: 'Europe/Athens',
  AOL: 'America/Argentina/Cordoba',
  AOM: 'Asia/Muscat',
  AON: 'Pacific/Port_Moresby',
  AOO: 'America/New_York',
  AOP: 'America/Lima',
  AOR: 'Asia/Kuala_Lumpur',
  AOS: 'America/Anchorage',
  AOT: 'Europe/Rome',
  AOU: 'Asia/Vientiane',
  APA: 'America/Denver',
  APB: 'America/La_Paz',
  APC: 'America/Los_Angeles',
  APF: 'America/New_York',
  APG: 'America/New_York',
  APH: 'America/New_York',
  API: 'America/Bogota',
  APK: 'Pacific/Tahiti',
  APL: 'Africa/Maputo',
  APN: 'America/Detroit',
  APO: 'America/Bogota',
  APP: 'Pacific/Port_Moresby',
  APQ: 'America/Maceio',
  APR: 'Pacific/Port_Moresby',
  APS: 'America/Sao_Paulo',
  APT: 'America/Chicago',
  APU: 'America/Sao_Paulo',
  APV: 'America/Los_Angeles',
  APW: 'Pacific/Apia',
  APX: 'America/Sao_Paulo',
  APY: 'America/Fortaleza',
  APZ: 'America/Argentina/Salta',
  AQA: 'America/Sao_Paulo',
  AQB: 'America/Guatemala',
  AQG: 'Asia/Shanghai',
  AQI: 'Asia/Riyadh',
  AQJ: 'Asia/Amman',
  AQM: 'America/Porto_Velho',
  AQP: 'America/Lima',
  AQS: 'Pacific/Fiji',
  AQY: 'America/Anchorage',
  ARA: 'America/Chicago',
  ARB: 'America/Detroit',
  ARC: 'America/Anchorage',
  ARD: 'Asia/Makassar',
  ARE: 'America/Puerto_Rico',
  ARF: 'America/Bogota',
  ARG: 'America/Chicago',
  ARH: 'Europe/Moscow',
  ARI: 'America/Santiago',
  ARJ: 'Asia/Jayapura',
  ARK: 'Africa/Dar_es_Salaam',
  ARL: 'Africa/Ouagadougou',
  ARM: 'Australia/Sydney',
  ARN: 'Europe/Stockholm',
  ARO: 'America/Bogota',
  ARP: 'Pacific/Port_Moresby',
  ARQ: 'America/Bogota',
  ARR: 'America/Argentina/Catamarca',
  ARS: 'America/Sao_Paulo',
  ART: 'America/New_York',
  ARU: 'America/Sao_Paulo',
  ARV: 'America/Chicago',
  ARW: 'Europe/Bucharest',
  ARX: 'America/Fortaleza',
  ARY: 'Australia/Melbourne',
  ARZ: 'Africa/Luanda',
  ASA: 'Africa/Asmara',
  ASB: 'Asia/Ashgabat',
  ASC: 'America/La_Paz',
  ASD: 'America/Nassau',
  ASE: 'America/Denver',
  ASF: 'Europe/Astrakhan',
  ASG: 'Pacific/Auckland',
  ASH: 'America/New_York',
  ASI: 'Atlantic/St_Helena',
  ASJ: 'Asia/Tokyo',
  ASK: 'Africa/Abidjan',
  ASL: 'America/Chicago',
  ASM: 'Africa/Asmara',
  ASN: 'America/Chicago',
  ASO: 'Africa/Addis_Ababa',
  ASP: 'Australia/Darwin',
  ASQ: 'America/Los_Angeles',
  ASR: 'Europe/Istanbul',
  ASS: 'Africa/Johannesburg',
  AST: 'America/Los_Angeles',
  ASU: 'America/Asuncion',
  ASV: 'Africa/Nairobi',
  ASW: 'Africa/Cairo',
  ASX: 'America/Chicago',
  ASY: 'America/Chicago',
  ASZ: 'Pacific/Port_Moresby',
  ATA: 'America/Lima',
  ATB: 'Africa/Khartoum',
  ATC: 'America/Nassau',
  ATD: 'Pacific/Guadalcanal',
  ATE: 'America/Chicago',
  ATF: 'America/Guayaquil',
  ATG: 'Asia/Karachi',
  ATH: 'Europe/Athens',
  ATI: 'America/Montevideo',
  ATJ: 'Indian/Antananarivo',
  ATK: 'America/Anchorage',
  ATL: 'America/New_York',
  ATM: 'America/Manaus',
  ATN: 'Pacific/Port_Moresby',
  ATO: 'America/New_York',
  ATP: 'Pacific/Port_Moresby',
  ATQ: 'Asia/Kolkata',
  ATR: 'Africa/Nouakchott',
  ATS: 'America/Denver',
  ATT: 'America/Nome',
  ATU: 'America/Adak',
  ATV: 'Africa/Ndjamena',
  ATW: 'America/Chicago',
  ATX: 'Asia/Almaty',
  ATY: 'America/Chicago',
  ATZ: 'Africa/Cairo',
  AUA: 'America/Aruba',
  AUC: 'America/Bogota',
  AUD: 'Australia/Brisbane',
  AUE: 'Africa/Cairo',
  AUF: 'Europe/Paris',
  AUG: 'America/New_York',
  AUH: 'Asia/Dubai',
  AUI: 'Pacific/Port_Moresby',
  AUJ: 'Pacific/Port_Moresby',
  AUK: 'America/Nome',
  AUL: 'Pacific/Majuro',
  AUM: 'America/Chicago',
  AUN: 'America/Los_Angeles',
  AUO: 'America/Chicago',
  AUP: 'Pacific/Port_Moresby',
  AUQ: 'Pacific/Marquesas',
  AUR: 'Europe/Paris',
  AUS: 'America/Chicago',
  AUT: 'Asia/Dili',
  AUU: 'Australia/Brisbane',
  AUV: 'Pacific/Port_Moresby',
  AUW: 'America/Chicago',
  AUX: 'America/Araguaina',
  AUY: 'Pacific/Efate',
  AUZ: 'America/Chicago',
  AVA: 'Asia/Shanghai',
  AVB: 'Europe/Rome',
  AVG: 'Australia/Darwin',
  AVI: 'America/Havana',
  AVK: 'Asia/Ulaanbaatar',
  AVL: 'America/New_York',
  AVN: 'Europe/Paris',
  AVO: 'America/New_York',
  AVP: 'America/New_York',
  AVR: 'Europe/Lisbon',
  AVU: 'Pacific/Guadalcanal',
  AVV: 'Australia/Melbourne',
  AVW: 'America/Phoenix',
  AVX: 'America/Los_Angeles',
  AWA: 'Africa/Addis_Ababa',
  AWB: 'Pacific/Port_Moresby',
  AWD: 'Pacific/Efate',
  AWE: 'Africa/Libreville',
  AWK: 'Pacific/Wake',
  AWM: 'America/Chicago',
  AWN: 'Australia/Adelaide',
  AWP: 'Australia/Darwin',
  AWR: 'Pacific/Port_Moresby',
  AWZ: 'Asia/Tehran',
  AXA: 'America/Anguilla',
  AXB: 'America/New_York',
  AXC: 'Australia/Brisbane',
  AXD: 'Europe/Athens',
  AXE: 'America/Sao_Paulo',
  AXF: 'Asia/Shanghai',
  AXG: 'America/Chicago',
  AXJ: 'Asia/Tokyo',
  AXK: 'Asia/Aden',
  AXL: 'Australia/Darwin',
  AXM: 'America/Bogota',
  AXN: 'America/Chicago',
  AXP: 'America/Nassau',
  AXR: 'Pacific/Tahiti',
  AXS: 'America/Chicago',
  AXT: 'Asia/Tokyo',
  AXU: 'Africa/Addis_Ababa',
  AXV: 'America/New_York',
  AXX: 'America/Denver',
  AYA: 'America/Bogota',
  AYC: 'America/Bogota',
  AYD: 'Australia/Darwin',
  AYG: 'America/Bogota',
  AYI: 'America/Bogota',
  AYK: 'Asia/Almaty',
  AYL: 'Australia/Darwin',
  AYM: 'Asia/Dubai',
  AYN: 'Asia/Shanghai',
  AYO: 'America/Asuncion',
  AYP: 'America/Lima',
  AYQ: 'Australia/Darwin',
  AYR: 'Australia/Brisbane',
  AYS: 'America/New_York',
  AYT: 'Europe/Istanbul',
  AYU: 'Pacific/Port_Moresby',
  AYW: 'Asia/Jayapura',
  AYY: 'Asia/Colombo',
  AZA: 'America/Phoenix',
  AZB: 'Pacific/Port_Moresby',
  AZD: 'Asia/Tehran',
  AZG: 'America/Mexico_City',
  AZI: 'Asia/Dubai',
  AZL: 'America/Cuiaba',
  AZN: 'Asia/Tashkent',
  AZO: 'America/Detroit',
  AZP: 'America/Mexico_City',
  AZR: 'Africa/Algiers',
  AZS: 'America/Santo_Domingo',
  AZT: 'America/Bogota',
  AZZ: 'Africa/Luanda',
  BAA: 'Pacific/Port_Moresby',
  BAB: 'America/Los_Angeles',
  BAC: 'America/Bogota',
  BAD: 'America/Chicago',
  BAE: 'Europe/Paris',
  BAF: 'America/New_York',
  BAG: 'Asia/Manila',
  BAH: 'Asia/Bahrain',
  BAI: 'America/Costa_Rica',
  BAJ: 'Pacific/Port_Moresby',
  BAK: 'Asia/Baku',
  BAL: 'Europe/Istanbul',
  BAM: 'America/Los_Angeles',
  BAN: 'Africa/Lubumbashi',
  BAP: 'Pacific/Port_Moresby',
  BAQ: 'America/Bogota',
  BAR: 'Asia/Shanghai',
  BAS: 'Pacific/Guadalcanal',
  BAT: 'America/Sao_Paulo',
  BAV: 'Asia/Shanghai',
  BAW: 'Africa/Libreville',
  BAX: 'Asia/Omsk',
  BAY: 'Europe/Bucharest',
  BAZ: 'America/Manaus',
  BBA: 'America/Santiago',
  BBB: 'America/Chicago',
  BBC: 'America/Chicago',
  BBD: 'America/Chicago',
  BBG: 'Pacific/Tarawa',
  BBH: 'Europe/Berlin',
  BBI: 'Asia/Kolkata',
  BBJ: 'Europe/Berlin',
  BBK: 'Africa/Gaborone',
  BBL: 'Australia/Brisbane',
  BBM: 'Asia/Phnom_Penh',
  BBN: 'Asia/Kuching',
  BBO: 'Africa/Mogadishu',
  BBP: 'Europe/London',
  BBQ: 'America/Antigua',
  BBR: 'America/Guadeloupe',
  BBS: 'Europe/London',
  BBT: 'Africa/Bangui',
  BBU: 'Europe/Bucharest',
  BBV: 'Africa/Abidjan',
  BBW: 'America/Chicago',
  BBX: 'America/New_York',
  BBY: 'Africa/Bangui',
  BBZ: 'Africa/Lusaka',
  BCA: 'America/Havana',
  BCB: 'America/New_York',
  BCC: 'America/Anchorage',
  BCD: 'Asia/Manila',
  BCE: 'America/Denver',
  BCF: 'Africa/Bangui',
  BCG: 'America/Guyana',
  BCH: 'Asia/Dili',
  BCI: 'Australia/Brisbane',
  BCK: 'Australia/Brisbane',
  BCL: 'America/Costa_Rica',
  BCM: 'Europe/Bucharest',
  BCN: 'Europe/Madrid',
  BCO: 'Africa/Addis_Ababa',
  BCP: 'Pacific/Port_Moresby',
  BCQ: 'Africa/Tripoli',
  BCR: 'America/Manaus',
  BCS: 'America/Chicago',
  BCT: 'America/New_York',
  BCU: 'Africa/Lagos',
  BCV: 'America/Belize',
  BCW: 'Africa/Maputo',
  BCX: 'Asia/Yekaterinburg',
  BCY: 'Africa/Addis_Ababa',
  BCZ: 'Australia/Darwin',
  BDA: 'Atlantic/Bermuda',
  BDB: 'Australia/Brisbane',
  BDC: 'America/Fortaleza',
  BDD: 'Australia/Brisbane',
  BDE: 'America/Chicago',
  BDF: 'America/Chicago',
  BDG: 'America/Denver',
  BDH: 'Asia/Tehran',
  BDI: 'Indian/Mahe',
  BDJ: 'Asia/Makassar',
  BDK: 'Africa/Abidjan',
  BDL: 'America/New_York',
  BDM: 'Europe/Istanbul',
  BDN: 'Asia/Karachi',
  BDO: 'Asia/Jakarta',
  BDP: 'Asia/Kathmandu',
  BDQ: 'Asia/Kolkata',
  BDR: 'America/New_York',
  BDS: 'Europe/Rome',
  BDT: 'Africa/Kinshasa',
  BDU: 'Europe/Oslo',
  BDV: 'Africa/Lubumbashi',
  BDW: 'Australia/Perth',
  BDX: 'America/Denver',
  BDY: 'America/Los_Angeles',
  BDZ: 'Pacific/Port_Moresby',
  BEA: 'Pacific/Port_Moresby',
  BEB: 'Europe/London',
  BEC: 'America/Chicago',
  BED: 'America/New_York',
  BEE: 'Australia/Perth',
  BEF: 'America/Managua',
  BEG: 'Europe/Belgrade',
  BEH: 'America/Detroit',
  BEI: 'Africa/Addis_Ababa',
  BEJ: 'Asia/Makassar',
  BEK: 'Asia/Kolkata',
  BEL: 'America/Belem',
  BEM: 'Africa/Casablanca',
  BEN: 'Africa/Tripoli',
  BEO: 'Australia/Sydney',
  BEP: 'Asia/Kolkata',
  BEQ: 'Europe/London',
  BER: 'Europe/Berlin',
  BES: 'Europe/Paris',
  BET: 'America/Anchorage',
  BEU: 'Australia/Brisbane',
  BEV: 'Asia/Jerusalem',
  BEW: 'Africa/Maputo',
  BEX: 'Europe/London',
  BEY: 'Asia/Beirut',
  BEZ: 'Pacific/Tarawa',
  BFA: 'America/Asuncion',
  BFC: 'Australia/Brisbane',
  BFD: 'America/New_York',
  BFE: 'Europe/Berlin',
  BFF: 'America/Denver',
  BFG: 'America/Denver',
  BFH: 'America/Sao_Paulo',
  BFI: 'America/Los_Angeles',
  BFJ: 'Asia/Shanghai',
  BFK: 'America/Denver',
  BFL: 'America/Los_Angeles',
  BFM: 'America/Chicago',
  BFN: 'Africa/Johannesburg',
  BFO: 'Africa/Harare',
  BFP: 'America/New_York',
  BFQ: 'America/Panama',
  BFR: 'America/Indiana/Indianapolis',
  BFS: 'Europe/London',
  BFT: 'America/New_York',
  BFU: 'Asia/Shanghai',
  BFV: 'Asia/Bangkok',
  BFW: 'Africa/Algiers',
  BFX: 'Africa/Douala',
  BGA: 'America/Bogota',
  BGB: 'Africa/Libreville',
  BGC: 'Europe/Lisbon',
  BGD: 'America/Chicago',
  BGE: 'America/New_York',
  BGF: 'Africa/Bangui',
  BGG: 'Europe/Istanbul',
  BGH: 'Africa/Nouakchott',
  BGI: 'America/Barbados',
  BGJ: 'Atlantic/Reykjavik',
  BGK: 'America/Belize',
  BGL: 'Asia/Kathmandu',
  BGM: 'America/New_York',
  BGN: 'Asia/Magadan',
  BGO: 'Europe/Oslo',
  BGP: 'Africa/Libreville',
  BGQ: 'America/Anchorage',
  BGR: 'America/New_York',
  BGT: 'America/Phoenix',
  BGU: 'Africa/Bangui',
  BGV: 'America/Sao_Paulo',
  BGW: 'Asia/Baghdad',
  BGX: 'America/Sao_Paulo',
  BGY: 'Europe/Rome',
  BGZ: 'Europe/Lisbon',
  BHA: 'America/Guayaquil',
  BHB: 'America/New_York',
  BHD: 'Europe/London',
  BHE: 'Pacific/Auckland',
  BHF: 'America/Bogota',
  BHG: 'America/Tegucigalpa',
  BHH: 'Asia/Riyadh',
  BHI: 'America/Argentina/Buenos_Aires',
  BHJ: 'Asia/Kolkata',
  BHK: 'Asia/Samarkand',
  BHL: 'America/Tijuana',
  BHM: 'America/Chicago',
  BHN: 'Asia/Aden',
  BHO: 'Asia/Kolkata',
  BHP: 'Asia/Kathmandu',
  BHQ: 'Australia/Broken_Hill',
  BHR: 'Asia/Kathmandu',
  BHS: 'Australia/Sydney',
  BHT: 'Australia/Brisbane',
  BHU: 'Asia/Kolkata',
  BHV: 'Asia/Karachi',
  BHW: 'Asia/Karachi',
  BHX: 'Europe/London',
  BHY: 'Asia/Shanghai',
  BHZ: 'America/Sao_Paulo',
  BIA: 'Europe/Paris',
  BIB: 'Africa/Mogadishu',
  BID: 'America/New_York',
  BIE: 'America/Chicago',
  BIF: 'America/Denver',
  BIG: 'America/Anchorage',
  BIH: 'America/Los_Angeles',
  BII: 'Pacific/Kwajalein',
  BIJ: 'Pacific/Port_Moresby',
  BIK: 'Asia/Jayapura',
  BIL: 'America/Denver',
  BIM: 'America/Nassau',
  BIN: 'Asia/Kabul',
  BIO: 'Europe/Madrid',
  BIP: 'Australia/Brisbane',
  BIQ: 'Europe/Paris',
  BIR: 'Asia/Kathmandu',
  BIS: 'America/Chicago',
  BIT: 'Asia/Kathmandu',
  BIU: 'Atlantic/Reykjavik',
  BIV: 'Africa/Bangui',
  BIW: 'Australia/Perth',
  BIX: 'America/Chicago',
  BIY: 'Africa/Johannesburg',
  BIZ: 'Pacific/Port_Moresby',
  BJA: 'Africa/Algiers',
  BJB: 'Asia/Tehran',
  BJC: 'America/Denver',
  BJD: 'Atlantic/Reykjavik',
  BJE: 'Africa/Khartoum',
  BJF: 'Europe/Oslo',
  BJG: 'Asia/Makassar',
  BJH: 'Asia/Kathmandu',
  BJI: 'America/Chicago',
  BJJ: 'America/New_York',
  BJK: 'Asia/Jayapura',
  BJL: 'Africa/Banjul',
  BJM: 'Africa/Bujumbura',
  BJN: 'Africa/Maputo',
  BJO: 'America/La_Paz',
  BJP: 'America/Sao_Paulo',
  BJQ: 'Asia/Muscat',
  BJR: 'Africa/Addis_Ababa',
  BJS: 'Asia/Shanghai',
  BJT: 'Asia/Colombo',
  BJU: 'Asia/Kathmandu',
  BJV: 'Europe/Istanbul',
  BJW: 'Asia/Makassar',
  BJX: 'America/Mexico_City',
  BJY: 'Europe/Belgrade',
  BJZ: 'Europe/Madrid',
  BKB: 'Asia/Kolkata',
  BKC: 'America/Anchorage',
  BKD: 'America/Chicago',
  BKE: 'America/Los_Angeles',
  BKF: 'America/Anchorage',
  BKG: 'America/Chicago',
  BKH: 'Pacific/Honolulu',
  BKI: 'Asia/Kuching',
  BKJ: 'Africa/Conakry',
  BKK: 'Asia/Bangkok',
  BKL: 'America/New_York',
  BKM: 'Asia/Kuching',
  BKN: 'Asia/Ashgabat',
  BKO: 'Africa/Bamako',
  BKP: 'Australia/Brisbane',
  BKQ: 'Australia/Brisbane',
  BKR: 'Africa/Ndjamena',
  BKS: 'Asia/Jakarta',
  BKT: 'America/New_York',
  BKU: 'Indian/Antananarivo',
  BKV: 'Asia/Shanghai',
  BKW: 'America/New_York',
  BKX: 'America/Chicago',
  BKY: 'Africa/Lubumbashi',
  BKZ: 'Africa/Dar_es_Salaam',
  BLA: 'America/Caracas',
  BLB: 'America/Panama',
  BLC: 'Africa/Douala',
  BLD: 'America/Los_Angeles',
  BLE: 'Europe/Stockholm',
  BLF: 'America/New_York',
  BLG: 'Asia/Kuching',
  BLH: 'America/Los_Angeles',
  BLI: 'America/Los_Angeles',
  BLJ: 'Africa/Algiers',
  BLK: 'Europe/London',
  BLL: 'Europe/Copenhagen',
  BLM: 'America/New_York',
  BLN: 'Australia/Melbourne',
  BLO: 'Atlantic/Reykjavik',
  BLP: 'America/Lima',
  BLQ: 'Europe/Rome',
  BLR: 'Asia/Kolkata',
  BLS: 'Australia/Brisbane',
  BLT: 'Australia/Brisbane',
  BLU: 'America/Los_Angeles',
  BLV: 'America/Chicago',
  BLW: 'Africa/Mogadishu',
  BLX: 'Europe/Rome',
  BLY: 'Europe/Dublin',
  BLZ: 'Africa/Blantyre',
  BMA: 'Europe/Stockholm',
  BMB: 'Africa/Kinshasa',
  BMC: 'America/Denver',
  BMD: 'Indian/Antananarivo',
  BME: 'Australia/Perth',
  BMF: 'Africa/Bangui',
  BMG: 'America/Indiana/Indianapolis',
  BMH: 'Pacific/Port_Moresby',
  BMI: 'America/Chicago',
  BMJ: 'America/Guyana',
  BMK: 'Europe/Berlin',
  BML: 'America/New_York',
  BMM: 'Africa/Libreville',
  BMN: 'Asia/Baghdad',
  BMO: 'Asia/Yangon',
  BMP: 'Australia/Brisbane',
  BMQ: 'Africa/Nairobi',
  BMR: 'Europe/Berlin',
  BMS: 'America/Bahia',
  BMT: 'America/Chicago',
  BMU: 'Asia/Makassar',
  BMV: 'Asia/Ho_Chi_Minh',
  BMW: 'Africa/Algiers',
  BMX: 'America/Anchorage',
  BMY: 'Pacific/Noumea',
  BMZ: 'Pacific/Port_Moresby',
  BNA: 'America/Chicago',
  BNB: 'Africa/Kinshasa',
  BNC: 'Africa/Lubumbashi',
  BND: 'Asia/Tehran',
  BNE: 'Australia/Brisbane',
  BNF: 'America/Sitka',
  BNG: 'America/Los_Angeles',
  BNH: 'America/New_York',
  BNI: 'Africa/Lagos',
  BNK: 'Australia/Sydney',
  BNL: 'America/New_York',
  BNM: 'Pacific/Port_Moresby',
  BNN: 'Europe/Oslo',
  BNO: 'America/Los_Angeles',
  BNP: 'Asia/Karachi',
  BNQ: 'Asia/Manila',
  BNR: 'Africa/Ouagadougou',
  BNS: 'America/Caracas',
  BNT: 'Pacific/Port_Moresby',
  BNU: 'America/Sao_Paulo',
  BNV: 'Pacific/Port_Moresby',
  BNW: 'America/Chicago',
  BNX: 'Europe/Sarajevo',
  BNY: 'Pacific/Guadalcanal',
  BNZ: 'Pacific/Port_Moresby',
  BOA: 'Africa/Kinshasa',
  BOB: 'Pacific/Tahiti',
  BOC: 'America/Panama',
  BOD: 'Europe/Paris',
  BOE: 'Africa/Brazzaville',
  BOG: 'America/Bogota',
  BOH: 'Europe/London',
  BOI: 'America/Boise',
  BOJ: 'Europe/Sofia',
  BOK: 'America/Los_Angeles',
  BOL: 'Europe/London',
  BOM: 'Asia/Kolkata',
  BON: 'America/Kralendijk',
  BOO: 'Europe/Oslo',
  BOP: 'Africa/Bangui',
  BOQ: 'Pacific/Port_Moresby',
  BOS: 'America/New_York',
  BOT: 'Pacific/Port_Moresby',
  BOU: 'Europe/Paris',
  BOV: 'Pacific/Port_Moresby',
  BOW: 'America/New_York',
  BOX: 'Australia/Darwin',
  BOY: 'Africa/Ouagadougou',
  BOZ: 'Africa/Bangui',
  BPB: 'Pacific/Port_Moresby',
  BPC: 'Africa/Douala',
  BPD: 'Pacific/Port_Moresby',
  BPE: 'Asia/Shanghai',
  BPF: 'Pacific/Guadalcanal',
  BPG: 'America/Cuiaba',
  BPH: 'Asia/Manila',
  BPI: 'America/Denver',
  BPK: 'Pacific/Port_Moresby',
  BPL: 'Asia/Shanghai',
  BPM: 'Asia/Kolkata',
  BPN: 'Asia/Makassar',
  BPS: 'America/Bahia',
  BPT: 'America/Chicago',
  BPX: 'Asia/Urumqi',
  BPY: 'Indian/Antananarivo',
  BQA: 'Asia/Manila',
  BQB: 'Australia/Perth',
  BQE: 'Africa/Bissau',
  BQG: 'Asia/Vladivostok',
  BQH: 'Europe/London',
  BQI: 'Africa/Windhoek',
  BQJ: 'Asia/Vladivostok',
  BQK: 'America/New_York',
  BQL: 'Australia/Brisbane',
  BQN: 'America/Puerto_Rico',
  BQO: 'Africa/Abidjan',
  BQQ: 'America/Bahia',
  BQS: 'Asia/Yakutsk',
  BQT: 'Europe/Minsk',
  BQU: 'America/St_Vincent',
  BQV: 'America/Juneau',
  BQW: 'Australia/Perth',
  BRA: 'America/Bahia',
  BRB: 'America/Fortaleza',
  BRC: 'America/Argentina/Salta',
  BRD: 'America/Chicago',
  BRE: 'Europe/Berlin',
  BRH: 'Pacific/Port_Moresby',
  BRI: 'Europe/Rome',
  BRJ: 'Australia/Melbourne',
  BRK: 'Australia/Sydney',
  BRL: 'America/Chicago',
  BRM: 'America/Caracas',
  BRN: 'Europe/Zurich',
  BRO: 'America/Chicago',
  BRP: 'Pacific/Port_Moresby',
  BRQ: 'Europe/Prague',
  BRR: 'Europe/London',
  BRS: 'Europe/London',
  BRT: 'Australia/Darwin',
  BRU: 'Europe/Brussels',
  BRV: 'Europe/Berlin',
  BRW: 'America/Anchorage',
  BRX: 'America/Santo_Domingo',
  BRY: 'America/New_York',
  BSA: 'Africa/Mogadishu',
  BSB: 'America/Sao_Paulo',
  BSC: 'America/Bogota',
  BSD: 'Asia/Shanghai',
  BSE: 'Asia/Kuching',
  BSF: 'Pacific/Honolulu',
  BSG: 'Africa/Malabo',
  BSI: 'Asia/Manila',
  BSJ: 'Australia/Melbourne',
  BSK: 'Africa/Algiers',
  BSL: 'Europe/Paris',
  BSM: 'Asia/Tehran',
  BSN: 'Africa/Bangui',
  BSO: 'Asia/Manila',
  BSP: 'Pacific/Port_Moresby',
  BSQ: 'America/Phoenix',
  BSR: 'Asia/Baghdad',
  BSS: 'America/Fortaleza',
  BST: 'Asia/Kabul',
  BSU: 'Africa/Kinshasa',
  BSV: 'Indian/Antananarivo',
  BSW: 'America/Anchorage',
  BSX: 'Asia/Yangon',
  BSY: 'Africa/Mogadishu',
  BTA: 'Africa/Douala',
  BTB: 'Africa/Brazzaville',
  BTC: 'Asia/Colombo',
  BTD: 'Australia/Darwin',
  BTE: 'Africa/Freetown',
  BTF: 'America/Denver',
  BTG: 'Africa/Bangui',
  BTH: 'Asia/Jakarta',
  BTI: 'America/Anchorage',
  BTJ: 'Asia/Jakarta',
  BTK: 'Asia/Irkutsk',
  BTL: 'America/Detroit',
  BTM: 'America/Denver',
  BTN: 'America/New_York',
  BTO: 'America/Paramaribo',
  BTP: 'America/New_York',
  BTQ: 'Africa/Kigali',
  BTR: 'America/Chicago',
  BTS: 'Europe/Bratislava',
  BTT: 'America/Anchorage',
  BTU: 'Asia/Kuching',
  BTV: 'America/New_York',
  BTW: 'Asia/Jakarta',
  BTX: 'Australia/Brisbane',
  BTY: 'America/Los_Angeles',
  BUA: 'Pacific/Bougainville',
  BUB: 'America/Chicago',
  BUC: 'Australia/Brisbane',
  BUD: 'Europe/Budapest',
  BUE: 'America/Argentina/Buenos_Aires',
  BUF: 'America/New_York',
  BUG: 'Africa/Luanda',
  BUH: 'Europe/Bucharest',
  BUI: 'Asia/Jayapura',
  BUJ: 'Africa/Algiers',
  BUK: 'Asia/Aden',
  BUL: 'Pacific/Port_Moresby',
  BUM: 'America/Chicago',
  BUN: 'America/Bogota',
  BUO: 'Africa/Mogadishu',
  BUP: 'Asia/Kolkata',
  BUQ: 'Africa/Harare',
  BUR: 'America/Los_Angeles',
  BUS: 'Asia/Tbilisi',
  BUT: 'Asia/Thimphu',
  BUU: 'Asia/Jakarta',
  BUV: 'America/Montevideo',
  BUW: 'Asia/Makassar',
  BUX: 'Africa/Lubumbashi',
  BUY: 'Australia/Perth',
  BUZ: 'Asia/Tehran',
  BVA: 'Europe/Paris',
  BVB: 'America/Boa_Vista',
  BVC: 'Atlantic/Cape_Verde',
  BVE: 'Europe/Paris',
  BVF: 'Pacific/Fiji',
  BVG: 'Europe/Oslo',
  BVH: 'America/Cuiaba',
  BVI: 'Australia/Brisbane',
  BVK: 'America/La_Paz',
  BVL: 'America/La_Paz',
  BVM: 'America/Bahia',
  BVO: 'America/Chicago',
  BVP: 'Pacific/Port_Moresby',
  BVR: 'Atlantic/Cape_Verde',
  BVS: 'America/Santarem',
  BVU: 'America/Anchorage',
  BVV: 'Asia/Sakhalin',
  BVW: 'Australia/Brisbane',
  BVX: 'America/Chicago',
  BVY: 'America/New_York',
  BVZ: 'Australia/Perth',
  BWA: 'Asia/Kathmandu',
  BWB: 'Australia/Perth',
  BWC: 'America/Los_Angeles',
  BWD: 'America/Chicago',
  BWE: 'Europe/Berlin',
  BWF: 'Europe/London',
  BWG: 'America/Chicago',
  BWH: 'Asia/Kuala_Lumpur',
  BWI: 'America/New_York',
  BWJ: 'Pacific/Port_Moresby',
  BWK: 'Europe/Zagreb',
  BWL: 'America/Chicago',
  BWM: 'America/Denver',
  BWN: 'Asia/Brunei',
  BWO: 'Europe/Saratov',
  BWP: 'Pacific/Port_Moresby',
  BWQ: 'Australia/Sydney',
  BWT: 'Australia/Hobart',
  BWU: 'Australia/Sydney',
  BWW: 'America/Havana',
  BWX: 'Asia/Jakarta',
  BXA: 'America/Chicago',
  BXB: 'Asia/Jayapura',
  BXD: 'Asia/Jayapura',
  BXE: 'Africa/Dakar',
  BXF: 'Australia/Perth',
  BXG: 'Australia/Melbourne',
  BXH: 'Asia/Almaty',
  BXI: 'Africa/Abidjan',
  BXJ: 'Asia/Almaty',
  BXK: 'America/Phoenix',
  BXL: 'Pacific/Fiji',
  BXM: 'Asia/Jayapura',
  BXN: 'Europe/Istanbul',
  BXO: 'Europe/Zurich',
  BXP: 'Europe/Warsaw',
  BXR: 'Asia/Tehran',
  BXS: 'America/Los_Angeles',
  BXT: 'Asia/Makassar',
  BXU: 'Asia/Manila',
  BXV: 'Atlantic/Reykjavik',
  BXW: 'Asia/Jakarta',
  BXX: 'Africa/Mogadishu',
  BXY: 'Asia/Qostanay',
  BXZ: 'Pacific/Port_Moresby',
  BYA: 'America/Anchorage',
  BYB: 'Asia/Muscat',
  BYC: 'America/La_Paz',
  BYD: 'Asia/Aden',
  BYF: 'Europe/Paris',
  BYG: 'America/Denver',
  BYH: 'America/Chicago',
  BYI: 'America/Boise',
  BYJ: 'Europe/Lisbon',
  BYK: 'Africa/Abidjan',
  BYL: 'Africa/Monrovia',
  BYM: 'America/Havana',
  BYN: 'Asia/Ulaanbaatar',
  BYO: 'America/Campo_Grande',
  BYP: 'Australia/Perth',
  BYQ: 'Asia/Makassar',
  BYR: 'Europe/Copenhagen',
  BYS: 'America/Los_Angeles',
  BYT: 'Europe/Dublin',
  BYU: 'Europe/Berlin',
  BYV: 'Asia/Colombo',
  BYW: 'America/Los_Angeles',
  BYX: 'Australia/Darwin',
  BZA: 'America/Managua',
  BZB: 'Africa/Maputo',
  BZC: 'America/Sao_Paulo',
  BZD: 'Australia/Sydney',
  BZE: 'America/Belize',
  BZF: 'America/Los_Angeles',
  BZG: 'Europe/Warsaw',
  BZH: 'Africa/Harare',
  BZI: 'Europe/Istanbul',
  BZK: 'Europe/Moscow',
  BZL: 'Asia/Dhaka',
  BZM: 'Indian/Antananarivo',
  BZN: 'America/Denver',
  BZO: 'Europe/Rome',
  BZP: 'Australia/Brisbane',
  BZR: 'Europe/Paris',
  BZT: 'America/Chicago',
  BZU: 'Africa/Lubumbashi',
  BZV: 'Africa/Brazzaville',
  BZX: 'Asia/Shanghai',
  BZY: 'Europe/Chisinau',
  BZZ: 'Europe/London',
  CAA: 'America/Tegucigalpa',
  CAB: 'Africa/Luanda',
  CAC: 'America/Sao_Paulo',
  CAD: 'America/Detroit',
  CAE: 'America/New_York',
  CAF: 'America/Manaus',
  CAG: 'Europe/Rome',
  CAH: 'Asia/Ho_Chi_Minh',
  CAI: 'Africa/Cairo',
  CAJ: 'America/Caracas',
  CAK: 'America/New_York',
  CAL: 'Europe/London',
  CAM: 'America/La_Paz',
  CAN: 'Asia/Shanghai',
  CAO: 'America/Denver',
  CAP: 'America/Port-au-Prince',
  CAQ: 'America/Bogota',
  CAR: 'America/New_York',
  CAS: 'Africa/Casablanca',
  CAT: 'Europe/Lisbon',
  CAU: 'America/Recife',
  CAV: 'Africa/Luanda',
  CAW: 'America/Sao_Paulo',
  CAX: 'Europe/London',
  CAY: 'America/Cayenne',
  CAZ: 'Australia/Sydney',
  CBB: 'America/La_Paz',
  CBC: 'Australia/Perth',
  CBD: 'Asia/Kolkata',
  CBE: 'America/New_York',
  CBF: 'America/Chicago',
  CBG: 'Europe/London',
  CBH: 'Africa/Algiers',
  CBI: 'Australia/Hobart',
  CBJ: 'America/Santo_Domingo',
  CBK: 'America/Chicago',
  CBL: 'America/Caracas',
  CBM: 'America/Chicago',
  CBN: 'Asia/Jakarta',
  CBO: 'Asia/Manila',
  CBP: 'Europe/Lisbon',
  CBQ: 'Africa/Lagos',
  CBR: 'Australia/Sydney',
  CBS: 'America/Caracas',
  CBT: 'Africa/Luanda',
  CBU: 'Europe/Berlin',
  CBV: 'America/Guatemala',
  CBW: 'America/Sao_Paulo',
  CBX: 'Australia/Sydney',
  CBY: 'Australia/Brisbane',
  CCA: 'America/La_Paz',
  CCB: 'America/Los_Angeles',
  CCC: 'America/Havana',
  CCE: 'Africa/Cairo',
  CCF: 'Europe/Paris',
  CCG: 'America/Chicago',
  CCH: 'America/Santiago',
  CCI: 'America/Sao_Paulo',
  CCJ: 'Asia/Kolkata',
  CCK: 'Indian/Cocos',
  CCL: 'Australia/Brisbane',
  CCM: 'America/Sao_Paulo',
  CCN: 'Asia/Kabul',
  CCO: 'America/Bogota',
  CCP: 'America/Santiago',
  CCR: 'America/Los_Angeles',
  CCS: 'America/Caracas',
  CCT: 'America/Argentina/Salta',
  CCU: 'Asia/Kolkata',
  CCV: 'Pacific/Efate',
  CCW: 'Australia/Adelaide',
  CCX: 'America/Cuiaba',
  CCY: 'America/Chicago',
  CCZ: 'America/Nassau',
  CDA: 'Australia/Darwin',
  CDB: 'America/Nome',
  CDC: 'America/Denver',
  CDD: 'America/Tegucigalpa',
  CDE: 'Asia/Shanghai',
  CDG: 'Europe/Paris',
  CDH: 'America/Chicago',
  CDI: 'America/Sao_Paulo',
  CDJ: 'America/Araguaina',
  CDK: 'America/New_York',
  CDL: 'America/Anchorage',
  CDN: 'America/New_York',
  CDO: 'Africa/Johannesburg',
  CDP: 'Asia/Kolkata',
  CDQ: 'Australia/Brisbane',
  CDR: 'America/Denver',
  CDS: 'America/Chicago',
  CDT: 'Europe/Madrid',
  CDU: 'Australia/Sydney',
  CDV: 'America/Anchorage',
  CDW: 'America/New_York',
  CDY: 'Asia/Manila',
  CEA: 'America/Chicago',
  CEB: 'Asia/Manila',
  CEC: 'America/Los_Angeles',
  CED: 'Australia/Adelaide',
  CEE: 'Europe/Moscow',
  CEF: 'America/New_York',
  CEG: 'Europe/London',
  CEH: 'Africa/Blantyre',
  CEI: 'Asia/Bangkok',
  CEK: 'Asia/Yekaterinburg',
  CEM: 'America/Anchorage',
  CEN: 'America/Hermosillo',
  CEO: 'Africa/Luanda',
  CEP: 'America/La_Paz',
  CEQ: 'Europe/Paris',
  CER: 'Europe/Paris',
  CES: 'Australia/Sydney',
  CET: 'Europe/Paris',
  CEU: 'America/New_York',
  CEV: 'America/Indiana/Indianapolis',
  CEW: 'America/Chicago',
  CEX: 'America/Anchorage',
  CEY: 'America/Chicago',
  CEZ: 'America/Denver',
  CFB: 'America/Sao_Paulo',
  CFC: 'America/Sao_Paulo',
  CFD: 'America/Chicago',
  CFE: 'Europe/Paris',
  CFF: 'Africa/Luanda',
  CFG: 'America/Havana',
  CFH: 'Australia/Adelaide',
  CFI: 'Australia/Darwin',
  CFK: 'Africa/Algiers',
  CFM: 'America/Edmonton',
  CFN: 'Europe/Dublin',
  CFO: 'America/Cuiaba',
  CFP: 'Australia/Brisbane',
  CFQ: 'America/Creston',
  CFR: 'Europe/Paris',
  CFS: 'Australia/Sydney',
  CFT: 'America/Phoenix',
  CFU: 'Europe/Athens',
  CFV: 'America/Chicago',
  CGA: 'America/Juneau',
  CGB: 'America/Cuiaba',
  CGC: 'Pacific/Port_Moresby',
  CGD: 'Asia/Shanghai',
  CGE: 'America/New_York',
  CGF: 'America/New_York',
  CGG: 'Asia/Manila',
  CGH: 'America/Sao_Paulo',
  CGI: 'America/Chicago',
  CGJ: 'Africa/Lusaka',
  CGK: 'Asia/Jakarta',
  CGM: 'Asia/Manila',
  CGN: 'Europe/Berlin',
  CGO: 'Asia/Shanghai',
  CGP: 'Asia/Dhaka',
  CGQ: 'Asia/Shanghai',
  CGR: 'America/Campo_Grande',
  CGS: 'America/New_York',
  CGT: 'Africa/Nouakchott',
  CGV: 'Australia/Perth',
  CGY: 'Asia/Manila',
  CGZ: 'America/Phoenix',
  CHA: 'America/New_York',
  CHB: 'Asia/Karachi',
  CHC: 'Pacific/Auckland',
  CHF: 'Asia/Seoul',
  CHG: 'Asia/Shanghai',
  CHH: 'America/Lima',
  CHI: 'America/Chicago',
  CHJ: 'Africa/Harare',
  CHK: 'America/Chicago',
  CHL: 'America/Boise',
  CHM: 'America/Lima',
  CHN: 'Asia/Seoul',
  CHO: 'America/New_York',
  CHP: 'America/Anchorage',
  CHQ: 'Europe/Athens',
  CHR: 'Europe/Paris',
  CHS: 'America/New_York',
  CHT: 'Pacific/Chatham',
  CHU: 'America/Anchorage',
  CHV: 'Europe/Lisbon',
  CHX: 'America/Panama',
  CHY: 'Pacific/Guadalcanal',
  CHZ: 'America/Los_Angeles',
  CIA: 'Europe/Rome',
  CIC: 'America/Los_Angeles',
  CID: 'America/Chicago',
  CIE: 'Australia/Perth',
  CIF: 'Asia/Shanghai',
  CIG: 'America/Denver',
  CIH: 'Asia/Shanghai',
  CII: 'Europe/Istanbul',
  CIJ: 'America/La_Paz',
  CIK: 'America/Anchorage',
  CIL: 'America/Nome',
  CIM: 'America/Bogota',
  CIN: 'America/Chicago',
  CIO: 'America/Asuncion',
  CIP: 'Africa/Lusaka',
  CIQ: 'America/Guatemala',
  CIR: 'America/Chicago',
  CIS: 'Pacific/Enderbury',
  CIT: 'Asia/Almaty',
  CIU: 'America/Detroit',
  CIW: 'America/St_Vincent',
  CIX: 'America/Lima',
  CIY: 'Europe/Rome',
  CIZ: 'America/Manaus',
  CJA: 'America/Lima',
  CJB: 'Asia/Kolkata',
  CJC: 'America/Santiago',
  CJD: 'America/Bogota',
  CJF: 'Australia/Perth',
  CJH: 'America/Vancouver',
  CJJ: 'Asia/Seoul',
  CJL: 'Asia/Karachi',
  CJM: 'Asia/Bangkok',
  CJN: 'Asia/Jakarta',
  CJS: 'America/Ojinaga',
  CJT: 'America/Mexico_City',
  CJU: 'Asia/Seoul',
  CKA: 'America/Chicago',
  CKB: 'America/New_York',
  CKC: 'Europe/Kiev',
  CKD: 'America/Anchorage',
  CKE: 'America/Los_Angeles',
  CKG: 'Asia/Shanghai',
  CKH: 'Asia/Magadan',
  CKI: 'Australia/Darwin',
  CKK: 'America/Chicago',
  CKL: 'Europe/Moscow',
  CKM: 'America/Chicago',
  CKN: 'America/Chicago',
  CKO: 'America/Sao_Paulo',
  CKR: 'America/Los_Angeles',
  CKS: 'America/Araguaina',
  CKT: 'Asia/Tehran',
  CKU: 'America/Anchorage',
  CKV: 'America/Chicago',
  CKW: 'Australia/Perth',
  CKX: 'America/Anchorage',
  CKY: 'Africa/Conakry',
  CKZ: 'Europe/Istanbul',
  CLA: 'Asia/Dhaka',
  CLD: 'America/Los_Angeles',
  CLE: 'America/New_York',
  CLG: 'America/Los_Angeles',
  CLH: 'Australia/Sydney',
  CLI: 'America/Chicago',
  CLJ: 'Europe/Bucharest',
  CLK: 'America/Chicago',
  CLL: 'America/Chicago',
  CLM: 'America/Los_Angeles',
  CLN: 'America/Araguaina',
  CLO: 'America/Bogota',
  CLP: 'America/Anchorage',
  CLQ: 'America/Mexico_City',
  CLR: 'America/Los_Angeles',
  CLS: 'America/Los_Angeles',
  CLT: 'America/New_York',
  CLU: 'America/Indiana/Indianapolis',
  CLV: 'America/Sao_Paulo',
  CLW: 'America/New_York',
  CLX: 'America/Argentina/Cordoba',
  CLY: 'Europe/Paris',
  CLZ: 'America/Caracas',
  CMA: 'Australia/Brisbane',
  CMB: 'Asia/Colombo',
  CMC: 'America/Fortaleza',
  CMD: 'Australia/Sydney',
  CME: 'America/Merida',
  CMF: 'Europe/Paris',
  CMG: 'America/Campo_Grande',
  CMH: 'America/New_York',
  CMI: 'America/Chicago',
  CMJ: 'Asia/Taipei',
  CMK: 'Africa/Blantyre',
  CML: 'Australia/Brisbane',
  CMM: 'America/Guatemala',
  CMN: 'Africa/Casablanca',
  CMO: 'Africa/Mogadishu',
  CMP: 'America/Santarem',
  CMQ: 'Australia/Brisbane',
  CMR: 'Europe/Paris',
  CMS: 'Africa/Mogadishu',
  CMT: 'America/Belem',
  CMU: 'Pacific/Port_Moresby',
  CMV: 'Pacific/Auckland',
  CMW: 'America/Havana',
  CMX: 'America/Detroit',
  CMY: 'America/Chicago',
  CMZ: 'Africa/Maputo',
  CNA: 'America/Hermosillo',
  CNB: 'Australia/Sydney',
  CNC: 'Australia/Brisbane',
  CND: 'Europe/Bucharest',
  CNE: 'America/Denver',
  CNF: 'America/Sao_Paulo',
  CNG: 'Europe/Paris',
  CNH: 'America/New_York',
  CNI: 'Asia/Shanghai',
  CNJ: 'Australia/Brisbane',
  CNK: 'America/Chicago',
  CNL: 'Europe/Copenhagen',
  CNM: 'America/Denver',
  CNN: 'Asia/Kolkata',
  CNO: 'America/Los_Angeles',
  CNP: 'America/Scoresbysund',
  CNQ: 'America/Argentina/Cordoba',
  CNR: 'America/Santiago',
  CNS: 'Australia/Brisbane',
  CNT: 'America/Argentina/Cordoba',
  CNU: 'America/Chicago',
  CNV: 'America/Bahia',
  CNW: 'America/Chicago',
  CNX: 'Asia/Bangkok',
  CNY: 'America/Denver',
  CNZ: 'Africa/Luanda',
  COA: 'America/Los_Angeles',
  COB: 'Australia/Darwin',
  COC: 'America/Argentina/Cordoba',
  COD: 'America/Denver',
  COE: 'America/Los_Angeles',
  COF: 'America/New_York',
  COG: 'America/Bogota',
  COH: 'Asia/Kolkata',
  COI: 'America/New_York',
  COJ: 'Australia/Sydney',
  COK: 'Asia/Kolkata',
  COL: 'Europe/London',
  COM: 'America/Chicago',
  CON: 'America/New_York',
  COO: 'Africa/Porto-Novo',
  COP: 'America/New_York',
  COQ: 'Asia/Choibalsan',
  COR: 'America/Argentina/Cordoba',
  COS: 'America/Denver',
  COT: 'America/Chicago',
  COU: 'America/Chicago',
  COW: 'America/Santiago',
  COY: 'Australia/Perth',
  COZ: 'America/Santo_Domingo',
  CPA: 'Africa/Monrovia',
  CPB: 'America/Bogota',
  CPC: 'America/Argentina/Salta',
  CPD: 'Australia/Adelaide',
  CPE: 'America/Merida',
  CPF: 'Asia/Jakarta',
  CPG: 'America/Argentina/Buenos_Aires',
  CPH: 'Europe/Copenhagen',
  CPI: 'Pacific/Port_Moresby',
  CPL: 'America/Bogota',
  CPM: 'America/Los_Angeles',
  CPN: 'Pacific/Port_Moresby',
  CPO: 'America/Santiago',
  CPP: 'America/Santiago',
  CPR: 'America/Denver',
  CPS: 'America/Chicago',
  CPT: 'Africa/Johannesburg',
  CPU: 'America/Fortaleza',
  CPV: 'America/Recife',
  CPX: 'America/Puerto_Rico',
  CQA: 'America/Cuiaba',
  CQD: 'Asia/Tehran',
  CQF: 'Europe/Paris',
  CQM: 'Europe/Madrid',
  CQP: 'Australia/Brisbane',
  CQS: 'America/Porto_Velho',
  CQT: 'America/Bogota',
  CRA: 'Europe/Bucharest',
  CRB: 'Australia/Sydney',
  CRC: 'America/Bogota',
  CRD: 'America/Argentina/Catamarca',
  CRE: 'America/New_York',
  CRF: 'Africa/Bangui',
  CRG: 'America/New_York',
  CRH: 'Australia/Brisbane',
  CRI: 'America/Nassau',
  CRJ: 'Australia/Adelaide',
  CRK: 'Asia/Manila',
  CRL: 'Europe/Brussels',
  CRM: 'Asia/Manila',
  CRO: 'America/Los_Angeles',
  CRP: 'America/Chicago',
  CRQ: 'America/Bahia',
  CRR: 'America/Argentina/Cordoba',
  CRS: 'America/Chicago',
  CRT: 'America/Chicago',
  CRU: 'America/Grenada',
  CRV: 'Europe/Rome',
  CRW: 'America/New_York',
  CRX: 'America/Chicago',
  CRY: 'Australia/Perth',
  CRZ: 'Asia/Ashgabat',
  CSA: 'Europe/London',
  CSB: 'Europe/Bucharest',
  CSC: 'America/Costa_Rica',
  CSD: 'Australia/Darwin',
  CSE: 'America/Denver',
  CSF: 'Europe/Paris',
  CSG: 'America/New_York',
  CSH: 'Europe/Moscow',
  CSI: 'Australia/Sydney',
  CSK: 'Africa/Dakar',
  CSM: 'America/Chicago',
  CSN: 'America/Los_Angeles',
  CSO: 'Europe/Berlin',
  CSQ: 'America/Chicago',
  CSR: 'America/Bogota',
  CSS: 'America/Campo_Grande',
  CST: 'Pacific/Fiji',
  CSU: 'America/Sao_Paulo',
  CSV: 'America/Chicago',
  CSX: 'Asia/Shanghai',
  CSY: 'Europe/Moscow',
  CSZ: 'America/Argentina/Buenos_Aires',
  CTA: 'Europe/Rome',
  CTB: 'America/Denver',
  CTC: 'America/Argentina/Catamarca',
  CTD: 'America/Panama',
  CTE: 'America/Panama',
  CTF: 'America/Guatemala',
  CTG: 'America/Bogota',
  CTH: 'America/New_York',
  CTI: 'Africa/Luanda',
  CTK: 'America/Chicago',
  CTL: 'Australia/Brisbane',
  CTM: 'America/Merida',
  CTN: 'Australia/Brisbane',
  CTO: 'America/New_York',
  CTP: 'America/Fortaleza',
  CTQ: 'America/Sao_Paulo',
  CTR: 'Australia/Darwin',
  CTS: 'Asia/Tokyo',
  CTT: 'Europe/Paris',
  CTU: 'Asia/Shanghai',
  CTW: 'America/Phoenix',
  CTX: 'America/New_York',
  CTY: 'America/New_York',
  CTZ: 'America/New_York',
  CUA: 'America/Mazatlan',
  CUB: 'America/New_York',
  CUC: 'America/Bogota',
  CUD: 'Australia/Brisbane',
  CUE: 'America/Guayaquil',
  CUF: 'Europe/Rome',
  CUG: 'Australia/Sydney',
  CUH: 'America/Chicago',
  CUI: 'America/Bogota',
  CUJ: 'Asia/Manila',
  CUK: 'America/Belize',
  CUL: 'America/Mazatlan',
  CUM: 'America/Caracas',
  CUN: 'America/Cancun',
  CUO: 'America/Bogota',
  CUP: 'America/Caracas',
  CUQ: 'Australia/Brisbane',
  CUR: 'America/Curacao',
  CUS: 'America/Denver',
  CUT: 'America/Argentina/Salta',
  CUU: 'America/Chihuahua',
  CUV: 'America/Caracas',
  CUX: 'America/Chicago',
  CUY: 'Australia/Perth',
  CUZ: 'America/Lima',
  CVB: 'Pacific/Port_Moresby',
  CVC: 'Australia/Adelaide',
  CVE: 'America/Bogota',
  CVF: 'Europe/Paris',
  CVG: 'America/New_York',
  CVH: 'America/Argentina/Salta',
  CVI: 'America/Argentina/Rio_Gallegos',
  CVJ: 'America/Mexico_City',
  CVL: 'Pacific/Port_Moresby',
  CVM: 'America/Monterrey',
  CVN: 'America/Denver',
  CVO: 'America/Los_Angeles',
  CVQ: 'Australia/Perth',
  CVS: 'America/Denver',
  CVT: 'Europe/London',
  CVU: 'Atlantic/Azores',
  CWA: 'America/Chicago',
  CWB: 'America/Sao_Paulo',
  CWC: 'Europe/Uzhgorod',
  CWF: 'America/Chicago',
  CWI: 'America/Chicago',
  CWJ: 'Asia/Shanghai',
  CWL: 'Europe/London',
  CWR: 'Australia/Adelaide',
  CWS: 'America/Los_Angeles',
  CWT: 'Australia/Sydney',
  CWW: 'Australia/Sydney',
  CWX: 'America/Phoenix',
  CXA: 'America/Caracas',
  CXB: 'Asia/Dhaka',
  CXC: 'America/Anchorage',
  CXF: 'America/Anchorage',
  CXH: 'America/Vancouver',
  CXI: 'Pacific/Kiritimati',
  CXJ: 'America/Sao_Paulo',
  CXL: 'America/Los_Angeles',
  CXN: 'Africa/Mogadishu',
  CXO: 'America/Chicago',
  CXP: 'Asia/Jakarta',
  CXQ: 'Australia/Perth',
  CXR: 'Asia/Ho_Chi_Minh',
  CXT: 'Australia/Brisbane',
  CXY: 'America/Nassau',
  CYA: 'America/Port-au-Prince',
  CYB: 'America/Cayman',
  CYC: 'America/Belize',
  CYD: 'America/Belize',
  CYF: 'America/Nome',
  CYG: 'Australia/Melbourne',
  CYI: 'Asia/Taipei',
  CYL: 'America/Tegucigalpa',
  CYM: 'America/Sitka',
  CYO: 'America/Havana',
  CYP: 'Asia/Manila',
  CYR: 'America/Montevideo',
  CYS: 'America/Denver',
  CYT: 'America/Anchorage',
  CYU: 'Asia/Manila',
  CYW: 'America/Mexico_City',
  CYX: 'Asia/Magadan',
  CYZ: 'Asia/Manila',
  CZA: 'America/Merida',
  CZB: 'America/Sao_Paulo',
  CZC: 'America/Anchorage',
  CZE: 'America/Caracas',
  CZF: 'America/Nome',
  CZH: 'America/Belize',
  CZJ: 'America/Panama',
  CZK: 'America/Los_Angeles',
  CZL: 'Africa/Algiers',
  CZM: 'America/Cancun',
  CZN: 'America/Anchorage',
  CZO: 'America/Anchorage',
  CZP: 'America/Juneau',
  CZS: 'America/Eirunepe',
  CZT: 'America/Chicago',
  CZU: 'America/Bogota',
  CZW: 'Europe/Warsaw',
  CZX: 'Asia/Shanghai',
  CZY: 'Australia/Brisbane',
  DAA: 'America/New_York',
  DAB: 'America/New_York',
  DAC: 'Asia/Dhaka',
  DAD: 'Asia/Ho_Chi_Minh',
  DAF: 'Pacific/Port_Moresby',
  DAG: 'America/Los_Angeles',
  DAH: 'Asia/Aden',
  DAK: 'Africa/Cairo',
  DAL: 'America/Chicago',
  DAM: 'Asia/Damascus',
  DAN: 'America/New_York',
  DAO: 'Pacific/Port_Moresby',
  DAP: 'Asia/Kathmandu',
  DAR: 'Africa/Dar_es_Salaam',
  DAS: 'America/Yellowknife',
  DAT: 'Asia/Shanghai',
  DAU: 'Pacific/Port_Moresby',
  DAV: 'America/Panama',
  DAX: 'Asia/Shanghai',
  DAY: 'America/New_York',
  DAZ: 'Asia/Kabul',
  DBA: 'Asia/Karachi',
  DBB: 'Africa/Cairo',
  DBC: 'Asia/Shanghai',
  DBD: 'Asia/Kolkata',
  DBK: 'Asia/Colombo',
  DBM: 'Africa/Addis_Ababa',
  DBN: 'America/New_York',
  DBO: 'Australia/Sydney',
  DBP: 'Pacific/Port_Moresby',
  DBQ: 'America/Chicago',
  DBS: 'America/Boise',
  DBT: 'Africa/Addis_Ababa',
  DBU: 'Asia/Colombo',
  DBV: 'Europe/Zagreb',
  DBY: 'Australia/Brisbane',
  DCA: 'America/New_York',
  DCF: 'America/Dominica',
  DCG: 'Asia/Dubai',
  DCI: 'Europe/Rome',
  DCK: 'America/Anchorage',
  DCM: 'Europe/Paris',
  DCN: 'Australia/Perth',
  DCT: 'America/Nassau',
  DCU: 'America/Chicago',
  DCY: 'Asia/Shanghai',
  DDC: 'America/Chicago',
  DDD: 'Indian/Maldives',
  DDG: 'Asia/Shanghai',
  DDM: 'Pacific/Port_Moresby',
  DDN: 'Australia/Brisbane',
  DDU: 'Asia/Karachi',
  DEA: 'Asia/Karachi',
  DEB: 'Europe/Budapest',
  DEC: 'America/Chicago',
  DED: 'Asia/Kolkata',
  DEE: 'Asia/Sakhalin',
  DEF: 'Asia/Tehran',
  DEH: 'America/Chicago',
  DEI: 'Indian/Mahe',
  DEL: 'Asia/Kolkata',
  DEM: 'Africa/Addis_Ababa',
  DEN: 'America/Denver',
  DEP: 'Asia/Kolkata',
  DER: 'Pacific/Port_Moresby',
  DES: 'Indian/Mahe',
  DET: 'America/Detroit',
  DEX: 'Asia/Jayapura',
  DEZ: 'Asia/Damascus',
  DFI: 'America/New_York',
  DFP: 'Australia/Brisbane',
  DFW: 'America/Chicago',
  DGA: 'America/Belize',
  DGC: 'Africa/Addis_Ababa',
  DGD: 'Australia/Perth',
  DGE: 'Australia/Sydney',
  DGF: 'America/Vancouver',
  DGK: 'Africa/Maputo',
  DGL: 'America/Phoenix',
  DGM: 'Asia/Colombo',
  DGN: 'America/New_York',
  DGO: 'America/Monterrey',
  DGP: 'Europe/Riga',
  DGR: 'Pacific/Auckland',
  DGT: 'Asia/Manila',
  DGU: 'Africa/Ouagadougou',
  DGW: 'America/Denver',
  DHA: 'Asia/Riyadh',
  DHB: 'America/Los_Angeles',
  DHD: 'Australia/Brisbane',
  DHF: 'Asia/Dubai',
  DHG: 'Asia/Vladivostok',
  DHI: 'Asia/Kathmandu',
  DHL: 'Asia/Aden',
  DHM: 'Asia/Kolkata',
  DHN: 'America/Chicago',
  DHR: 'Europe/Amsterdam',
  DHT: 'America/Chicago',
  DIA: 'Asia/Qatar',
  DIB: 'Asia/Kolkata',
  DIE: 'Indian/Antananarivo',
  DIG: 'Asia/Shanghai',
  DIJ: 'Europe/Paris',
  DIK: 'America/Denver',
  DIL: 'Asia/Dili',
  DIM: 'Africa/Abidjan',
  DIN: 'Asia/Ho_Chi_Minh',
  DIP: 'Africa/Ouagadougou',
  DIQ: 'America/Sao_Paulo',
  DIR: 'Africa/Addis_Ababa',
  DIS: 'Africa/Brazzaville',
  DIU: 'Asia/Kolkata',
  DIV: 'Africa/Abidjan',
  DIW: 'Asia/Colombo',
  DIY: 'Europe/Istanbul',
  DJA: 'Africa/Porto-Novo',
  DJB: 'Asia/Jakarta',
  DJE: 'Africa/Tunis',
  DJG: 'Africa/Algiers',
  DJH: 'Asia/Dubai',
  DJJ: 'Asia/Jayapura',
  DJM: 'Africa/Brazzaville',
  DJN: 'America/Anchorage',
  DJO: 'Africa/Abidjan',
  DJU: 'Atlantic/Reykjavik',
  DKA: 'Africa/Lagos',
  DKI: 'Australia/Lindeman',
  DKK: 'America/New_York',
  DKR: 'Africa/Dakar',
  DKS: 'Asia/Krasnoyarsk',
  DKV: 'Australia/Darwin',
  DLA: 'Africa/Douala',
  DLB: 'Pacific/Port_Moresby',
  DLC: 'Asia/Shanghai',
  DLE: 'Europe/Paris',
  DLF: 'America/Chicago',
  DLG: 'America/Anchorage',
  DLH: 'America/Chicago',
  DLI: 'Asia/Ho_Chi_Minh',
  DLK: 'Australia/Adelaide',
  DLL: 'America/New_York',
  DLM: 'Europe/Istanbul',
  DLN: 'America/Denver',
  DLR: 'Asia/Vladivostok',
  DLS: 'America/Los_Angeles',
  DLU: 'Asia/Shanghai',
  DLV: 'Australia/Darwin',
  DLY: 'Pacific/Efate',
  DLZ: 'Asia/Ulaanbaatar',
  DMA: 'America/Phoenix',
  DMB: 'Asia/Almaty',
  DMD: 'Australia/Brisbane',
  DME: 'Europe/Moscow',
  DMK: 'Asia/Bangkok',
  DMM: 'Asia/Riyadh',
  DMN: 'America/Denver',
  DMO: 'America/Chicago',
  DMR: 'Asia/Aden',
  DMT: 'America/Cuiaba',
  DMU: 'Asia/Kolkata',
  DNA: 'Asia/Tokyo',
  DNB: 'Australia/Brisbane',
  DND: 'Europe/London',
  DNF: 'Africa/Tripoli',
  DNG: 'Australia/Perth',
  DNH: 'Asia/Urumqi',
  DNI: 'Africa/Khartoum',
  DNK: 'Europe/Zaporozhye',
  DNL: 'America/New_York',
  DNM: 'Australia/Perth',
  DNN: 'America/New_York',
  DNO: 'America/Araguaina',
  DNP: 'Asia/Kathmandu',
  DNQ: 'Australia/Sydney',
  DNR: 'Europe/Paris',
  DNS: 'America/Chicago',
  DNU: 'Pacific/Port_Moresby',
  DNV: 'America/Chicago',
  DNX: 'Africa/Khartoum',
  DNZ: 'Europe/Istanbul',
  DOA: 'Indian/Antananarivo',
  DOB: 'Asia/Jayapura',
  DOC: 'Europe/London',
  DOD: 'Africa/Dar_es_Salaam',
  DOE: 'America/Paramaribo',
  DOG: 'Africa/Khartoum',
  DOH: 'Asia/Qatar',
  DOI: 'Pacific/Port_Moresby',
  DOK: 'Europe/Zaporozhye',
  DOL: 'Europe/Paris',
  DOM: 'America/Dominica',
  DON: 'America/Guatemala',
  DOO: 'Pacific/Port_Moresby',
  DOP: 'Asia/Kathmandu',
  DOR: 'Africa/Ouagadougou',
  DOS: 'Pacific/Bougainville',
  DOU: 'America/Campo_Grande',
  DOV: 'America/Indiana/Indianapolis',
  DOX: 'Australia/Perth',
  DOY: 'Asia/Shanghai',
  DPA: 'America/Chicago',
  DPB: 'America/Punta_Arenas',
  DPE: 'Europe/Paris',
  DPG: 'America/Denver',
  DPL: 'Asia/Manila',
  DPO: 'Australia/Hobart',
  DPS: 'Asia/Makassar',
  DPT: 'Asia/Vladivostok',
  DPU: 'Pacific/Port_Moresby',
  DQA: 'Asia/Shanghai',
  DQM: 'Asia/Muscat',
  DRA: 'America/Los_Angeles',
  DRB: 'Australia/Perth',
  DRC: 'Africa/Luanda',
  DRD: 'Australia/Brisbane',
  DRE: 'America/Detroit',
  DRF: 'America/Anchorage',
  DRG: 'America/Nome',
  DRH: 'Asia/Jayapura',
  DRI: 'America/Chicago',
  DRJ: 'America/Paramaribo',
  DRK: 'America/Costa_Rica',
  DRN: 'Australia/Brisbane',
  DRO: 'America/Denver',
  DRR: 'Australia/Brisbane',
  DRS: 'Europe/Berlin',
  DRT: 'America/Chicago',
  DRU: 'America/Denver',
  DRV: 'Indian/Maldives',
  DRW: 'Australia/Darwin',
  DRY: 'Australia/Perth',
  DSA: 'Europe/London',
  DSC: 'Africa/Douala',
  DSD: 'America/Guadeloupe',
  DSE: 'Africa/Addis_Ababa',
  DSG: 'Asia/Manila',
  DSI: 'America/Chicago',
  DSK: 'Asia/Karachi',
  DSM: 'America/Chicago',
  DSN: 'Asia/Shanghai',
  DSO: 'Asia/Pyongyang',
  DSS: 'Africa/Dakar',
  DSV: 'America/New_York',
  DSX: 'Asia/Taipei',
  DTA: 'America/Denver',
  DTB: 'Asia/Jakarta',
  DTD: 'Asia/Makassar',
  DTE: 'Asia/Manila',
  DTH: 'America/Los_Angeles',
  DTI: 'America/Sao_Paulo',
  DTL: 'America/Chicago',
  DTM: 'Europe/Berlin',
  DTN: 'America/Chicago',
  DTR: 'America/Los_Angeles',
  DTT: 'America/Detroit',
  DTU: 'Asia/Shanghai',
  DTW: 'America/Detroit',
  DUA: 'America/Chicago',
  DUB: 'Europe/Dublin',
  DUC: 'America/Chicago',
  DUD: 'Pacific/Auckland',
  DUE: 'Africa/Luanda',
  DUF: 'America/New_York',
  DUG: 'America/Phoenix',
  DUJ: 'America/New_York',
  DUK: 'Africa/Johannesburg',
  DUM: 'Asia/Jakarta',
  DUQ: 'America/Vancouver',
  DUR: 'Africa/Johannesburg',
  DUS: 'Europe/Berlin',
  DUT: 'America/Anchorage',
  DVD: 'Indian/Antananarivo',
  DVK: 'America/Yellowknife',
  DVL: 'America/Chicago',
  DVN: 'America/Chicago',
  DVO: 'Asia/Manila',
  DVP: 'Australia/Brisbane',
  DVR: 'Australia/Darwin',
  DVT: 'America/Phoenix',
  DWA: 'Africa/Blantyre',
  DWB: 'Indian/Antananarivo',
  DWC: 'Asia/Dubai',
  DWD: 'Asia/Riyadh',
  DWH: 'America/Chicago',
  DWO: 'Asia/Colombo',
  DWR: 'Asia/Kabul',
  DXB: 'Asia/Dubai',
  DXD: 'Australia/Brisbane',
  DXE: 'America/Chicago',
  DXR: 'America/New_York',
  DYA: 'Australia/Brisbane',
  DYG: 'Asia/Shanghai',
  DYL: 'America/New_York',
  DYM: 'Australia/Brisbane',
  DYR: 'Asia/Anadyr',
  DYS: 'America/Chicago',
  DYU: 'Asia/Dushanbe',
  DYW: 'Australia/Darwin',
  DZA: 'Indian/Mayotte',
  DZI: 'America/Bogota',
  DZN: 'Asia/Almaty',
  DZO: 'America/Montevideo',
  DZU: 'Asia/Shanghai',
  EAA: 'America/Anchorage',
  EAB: 'Asia/Aden',
  EAE: 'Pacific/Efate',
  EAL: 'Pacific/Kwajalein',
  EAM: 'Asia/Riyadh',
  EAN: 'America/Denver',
  EAP: 'Europe/Zurich',
  EAR: 'America/Chicago',
  EAS: 'Europe/Madrid',
  EAT: 'America/Los_Angeles',
  EAU: 'America/Chicago',
  EBA: 'Europe/Rome',
  EBB: 'Africa/Kampala',
  EBD: 'Africa/Khartoum',
  EBG: 'America/Bogota',
  EBH: 'Africa/Algiers',
  EBJ: 'Europe/Copenhagen',
  EBL: 'Asia/Baghdad',
  EBM: 'Africa/Tunis',
  EBN: 'Pacific/Kwajalein',
  EBO: 'Pacific/Majuro',
  EBS: 'America/Chicago',
  EBU: 'Europe/Paris',
  EBW: 'Africa/Douala',
  ECA: 'America/Detroit',
  ECG: 'America/New_York',
  ECH: 'Australia/Melbourne',
  ECI: 'America/Managua',
  ECN: 'Asia/Nicosia',
  ECO: 'America/Bogota',
  ECP: 'America/Chicago',
  ECR: 'America/Bogota',
  ECS: 'America/Denver',
  EDA: 'America/Sitka',
  EDB: 'Africa/Khartoum',
  EDD: 'Australia/Darwin',
  EDE: 'America/New_York',
  EDF: 'America/Anchorage',
  EDI: 'Europe/London',
  EDK: 'America/Chicago',
  EDL: 'Africa/Nairobi',
  EDM: 'Europe/Paris',
  EDN: 'Asia/Vladivostok',
  EDO: 'Europe/Istanbul',
  EDQ: 'America/Tegucigalpa',
  EDR: 'Australia/Brisbane',
  EDW: 'America/Los_Angeles',
  EED: 'America/Los_Angeles',
  EEK: 'America/Nome',
  EEN: 'America/New_York',
  EFD: 'America/Chicago',
  EFG: 'Pacific/Port_Moresby',
  EFK: 'America/New_York',
  EFL: 'Europe/Athens',
  EFW: 'America/Chicago',
  EGA: 'Pacific/Port_Moresby',
  EGC: 'Europe/Paris',
  EGE: 'America/Denver',
  EGI: 'America/Chicago',
  EGL: 'Africa/Addis_Ababa',
  EGM: 'Pacific/Guadalcanal',
  EGN: 'Africa/Khartoum',
  EGO: 'Europe/Moscow',
  EGP: 'America/Chicago',
  EGS: 'Atlantic/Reykjavik',
  EGV: 'America/Chicago',
  EGX: 'America/Anchorage',
  EHL: 'America/Argentina/Salta',
  EHM: 'America/Nome',
  EIA: 'Pacific/Port_Moresby',
  EIB: 'Europe/Berlin',
  EIE: 'Asia/Krasnoyarsk',
  EIH: 'Australia/Brisbane',
  EIK: 'Europe/Moscow',
  EIL: 'America/Anchorage',
  EIN: 'Europe/Amsterdam',
  EIS: 'America/Tortola',
  EIY: 'Asia/Jerusalem',
  EJA: 'America/Bogota',
  EJH: 'Asia/Riyadh',
  EJN: 'Asia/Shanghai',
  EJT: 'Pacific/Majuro',
  EKA: 'America/Los_Angeles',
  EKB: 'Asia/Almaty',
  EKD: 'Australia/Darwin',
  EKE: 'America/Guyana',
  EKI: 'America/Indiana/Indianapolis',
  EKN: 'America/New_York',
  EKO: 'America/Los_Angeles',
  EKS: 'Asia/Sakhalin',
  EKT: 'Europe/Stockholm',
  EKX: 'America/New_York',
  ELA: 'America/Chicago',
  ELB: 'America/Bogota',
  ELC: 'Australia/Darwin',
  ELD: 'America/Chicago',
  ELE: 'America/Panama',
  ELF: 'Africa/Khartoum',
  ELG: 'Africa/Algiers',
  ELH: 'America/Nassau',
  ELI: 'America/Nome',
  ELJ: 'America/Bogota',
  ELK: 'America/Chicago',
  ELL: 'Africa/Johannesburg',
  ELM: 'America/New_York',
  ELN: 'America/Los_Angeles',
  ELO: 'America/Argentina/Cordoba',
  ELP: 'America/Denver',
  ELQ: 'Asia/Riyadh',
  ELR: 'Asia/Jayapura',
  ELS: 'Africa/Johannesburg',
  ELT: 'Africa/Cairo',
  ELU: 'Africa/Algiers',
  ELV: 'America/Juneau',
  ELW: 'America/Anchorage',
  ELX: 'America/Caracas',
  ELY: 'America/Los_Angeles',
  ELZ: 'America/New_York',
  EMA: 'Europe/London',
  EMD: 'Australia/Brisbane',
  EME: 'Europe/Berlin',
  EMG: 'Africa/Johannesburg',
  EMI: 'Pacific/Port_Moresby',
  EMK: 'America/Nome',
  EML: 'Europe/Zurich',
  EMM: 'America/Denver',
  EMN: 'Africa/Nouakchott',
  EMO: 'Pacific/Port_Moresby',
  EMP: 'America/Chicago',
  EMS: 'Pacific/Port_Moresby',
  EMT: 'America/Los_Angeles',
  EMX: 'America/Argentina/Catamarca',
  EMY: 'Africa/Cairo',
  ENA: 'America/Anchorage',
  ENB: 'Australia/Perth',
  ENC: 'Europe/Paris',
  END: 'America/Chicago',
  ENE: 'Asia/Makassar',
  ENF: 'Europe/Helsinki',
  ENH: 'Asia/Shanghai',
  ENI: 'Asia/Manila',
  ENJ: 'America/Guatemala',
  ENK: 'Europe/London',
  ENL: 'America/Chicago',
  ENN: 'America/Anchorage',
  ENO: 'America/Asuncion',
  ENS: 'Europe/Amsterdam',
  ENT: 'Pacific/Kwajalein',
  ENU: 'Africa/Lagos',
  ENV: 'America/Denver',
  ENW: 'America/Chicago',
  ENY: 'Asia/Shanghai',
  EOH: 'America/Bogota',
  EOI: 'Europe/London',
  EOK: 'America/Chicago',
  EOR: 'America/Caracas',
  EOS: 'America/Chicago',
  EOZ: 'America/Caracas',
  EPA: 'America/Argentina/Buenos_Aires',
  EPG: 'America/Chicago',
  EPH: 'America/Los_Angeles',
  EPL: 'Europe/Paris',
  EPN: 'Africa/Brazzaville',
  EPR: 'Australia/Perth',
  EPS: 'America/Santo_Domingo',
  EPT: 'Pacific/Port_Moresby',
  EPU: 'Europe/Tallinn',
  EQS: 'America/Argentina/Catamarca',
  ERA: 'Africa/Mogadishu',
  ERB: 'Australia/Adelaide',
  ERC: 'Europe/Istanbul',
  ERD: 'Europe/Zaporozhye',
  ERE: 'Pacific/Port_Moresby',
  ERF: 'Europe/Berlin',
  ERG: 'Asia/Irkutsk',
  ERH: 'Africa/Casablanca',
  ERI: 'America/New_York',
  ERL: 'Asia/Shanghai',
  ERM: 'America/Sao_Paulo',
  ERN: 'America/Manaus',
  ERQ: 'Australia/Brisbane',
  ERR: 'America/New_York',
  ERS: 'Africa/Windhoek',
  ERT: 'Asia/Ulaanbaatar',
  ERU: 'Pacific/Port_Moresby',
  ERV: 'America/Chicago',
  ERZ: 'Europe/Istanbul',
  ESA: 'Pacific/Port_Moresby',
  ESB: 'Europe/Istanbul',
  ESC: 'America/Detroit',
  ESD: 'America/Los_Angeles',
  ESE: 'America/Tijuana',
  ESF: 'America/Chicago',
  ESG: 'America/Asuncion',
  ESH: 'Europe/London',
  ESI: 'America/Sao_Paulo',
  ESK: 'Europe/Istanbul',
  ESL: 'Europe/Moscow',
  ESM: 'America/Guayaquil',
  ESN: 'America/New_York',
  ESO: 'America/Denver',
  ESP: 'America/New_York',
  ESR: 'America/Santiago',
  ESS: 'Europe/Berlin',
  EST: 'America/Chicago',
  ESU: 'Africa/Casablanca',
  ESW: 'America/Los_Angeles',
  ETB: 'America/Chicago',
  ETD: 'Australia/Adelaide',
  ETE: 'Africa/Addis_Ababa',
  ETH: 'Asia/Jerusalem',
  ETL: 'Asia/Vladivostok',
  ETM: 'Asia/Jerusalem',
  ETN: 'America/Chicago',
  ETR: 'America/Guayaquil',
  ETS: 'America/Chicago',
  ETZ: 'Europe/Paris',
  EUA: 'Pacific/Tongatapu',
  EUC: 'Australia/Eucla',
  EUE: 'America/Los_Angeles',
  EUF: 'America/Chicago',
  EUG: 'America/Los_Angeles',
  EUM: 'Europe/Berlin',
  EUN: 'Africa/Casablanca',
  EUO: 'America/Bogota',
  EUQ: 'Asia/Manila',
  EUX: 'America/Kralendijk',
  EVA: 'America/Chicago',
  EVD: 'Australia/Darwin',
  EVE: 'Europe/Oslo',
  EVG: 'Europe/Stockholm',
  EVH: 'Australia/Sydney',
  EVM: 'America/Chicago',
  EVN: 'Asia/Yerevan',
  EVV: 'America/Chicago',
  EVW: 'America/Denver',
  EVX: 'Europe/Paris',
  EWB: 'America/New_York',
  EWE: 'Asia/Jayapura',
  EWI: 'Asia/Jayapura',
  EWK: 'America/Chicago',
  EWN: 'America/New_York',
  EWO: 'Africa/Brazzaville',
  EWR: 'America/New_York',
  EXI: 'America/Juneau',
  EXM: 'Australia/Perth',
  EXT: 'Europe/London',
  EYK: 'Asia/Yekaterinburg',
  EYL: 'Africa/Bamako',
  EYP: 'America/Bogota',
  EYR: 'America/Los_Angeles',
  EYS: 'Africa/Nairobi',
  EYW: 'America/New_York',
  EZE: 'America/Argentina/Buenos_Aires',
  EZS: 'Europe/Istanbul',
  EZV: 'Asia/Yekaterinburg',
  FAA: 'Africa/Conakry',
  FAB: 'Europe/London',
  FAC: 'Pacific/Tahiti',
  FAE: 'Atlantic/Faroe',
  FAF: 'America/New_York',
  FAG: 'Atlantic/Reykjavik',
  FAH: 'Asia/Kabul',
  FAI: 'America/Anchorage',
  FAJ: 'America/Puerto_Rico',
  FAK: 'America/Sitka',
  FAM: 'America/Chicago',
  FAO: 'Europe/Lisbon',
  FAQ: 'Pacific/Port_Moresby',
  FAR: 'America/Chicago',
  FAS: 'Atlantic/Reykjavik',
  FAT: 'America/Los_Angeles',
  FAU: 'Asia/Muscat',
  FAV: 'Pacific/Tahiti',
  FAY: 'America/New_York',
  FAZ: 'Asia/Tehran',
  FBA: 'America/Manaus',
  FBD: 'Asia/Kabul',
  FBE: 'America/Sao_Paulo',
  FBG: 'America/New_York',
  FBK: 'America/Anchorage',
  FBL: 'America/Chicago',
  FBM: 'Africa/Lubumbashi',
  FBR: 'America/Denver',
  FBS: 'America/Los_Angeles',
  FBY: 'America/Chicago',
  FCA: 'America/Denver',
  FCB: 'Africa/Johannesburg',
  FCH: 'America/Los_Angeles',
  FCM: 'America/Chicago',
  FCN: 'Europe/Berlin',
  FCO: 'Europe/Rome',
  FCS: 'America/Denver',
  FCY: 'America/Chicago',
  FDE: 'Europe/Oslo',
  FDF: 'America/Martinique',
  FDH: 'Europe/Berlin',
  FDK: 'America/New_York',
  FDR: 'America/Chicago',
  FDU: 'Africa/Kinshasa',
  FDY: 'America/New_York',
  FEA: 'Europe/London',
  FEB: 'Asia/Kathmandu',
  FEC: 'America/Bahia',
  FEG: 'Asia/Tashkent',
  FEJ: 'America/Rio_Branco',
  FEK: 'Africa/Abidjan',
  FEL: 'Europe/Berlin',
  FEN: 'America/Noronha',
  FEP: 'America/Chicago',
  FET: 'America/Chicago',
  FEZ: 'Africa/Casablanca',
  FFA: 'America/New_York',
  FFD: 'Europe/London',
  FFL: 'America/Chicago',
  FFM: 'America/Chicago',
  FFO: 'America/New_York',
  FFT: 'America/New_York',
  FFU: 'America/Santiago',
  FGD: 'Africa/Nouakchott',
  FGI: 'Pacific/Apia',
  FGU: 'Pacific/Tahiti',
  FHU: 'America/Phoenix',
  FHZ: 'Pacific/Tahiti',
  FID: 'America/New_York',
  FIE: 'Europe/London',
  FIG: 'Africa/Conakry',
  FIH: 'Africa/Kinshasa',
  FIK: 'Australia/Darwin',
  FIL: 'America/Denver',
  FIN: 'Pacific/Port_Moresby',
  FIZ: 'Australia/Perth',
  FJR: 'Asia/Dubai',
  FKB: 'Europe/Berlin',
  FKI: 'Africa/Lubumbashi',
  FKJ: 'Asia/Tokyo',
  FKL: 'America/New_York',
  FKN: 'America/New_York',
  FKQ: 'Asia/Jayapura',
  FKS: 'Asia/Tokyo',
  FLA: 'America/Bogota',
  FLB: 'America/Fortaleza',
  FLD: 'America/Chicago',
  FLF: 'Europe/Berlin',
  FLG: 'America/Phoenix',
  FLH: 'Europe/London',
  FLI: 'Atlantic/Reykjavik',
  FLL: 'America/New_York',
  FLM: 'America/Asuncion',
  FLN: 'America/Sao_Paulo',
  FLO: 'America/New_York',
  FLP: 'America/Chicago',
  FLR: 'Europe/Rome',
  FLS: 'Australia/Hobart',
  FLT: 'America/Anchorage',
  FLV: 'America/Chicago',
  FLW: 'Atlantic/Azores',
  FLX: 'America/Los_Angeles',
  FLY: 'Australia/Sydney',
  FLZ: 'Asia/Jakarta',
  FMA: 'America/Argentina/Cordoba',
  FME: 'America/New_York',
  FMH: 'America/New_York',
  FMI: 'Africa/Lubumbashi',
  FMM: 'Europe/Berlin',
  FMN: 'America/Denver',
  FMO: 'Europe/Berlin',
  FMS: 'America/Chicago',
  FMU: 'America/Los_Angeles',
  FMY: 'America/New_York',
  FNA: 'Africa/Freetown',
  FNB: 'Europe/Berlin',
  FNC: 'Atlantic/Madeira',
  FNE: 'Pacific/Port_Moresby',
  FNG: 'Africa/Ouagadougou',
  FNH: 'Africa/Addis_Ababa',
  FNI: 'Europe/Paris',
  FNJ: 'Asia/Pyongyang',
  FNL: 'America/Denver',
  FNR: 'America/Juneau',
  FNT: 'America/Detroit',
  FNU: 'Europe/Rome',
  FOA: 'Europe/London',
  FOB: 'America/Los_Angeles',
  FOC: 'Asia/Shanghai',
  FOD: 'America/Chicago',
  FOE: 'America/Chicago',
  FOG: 'Europe/Rome',
  FOK: 'America/New_York',
  FOM: 'Africa/Douala',
  FON: 'America/Costa_Rica',
  FOO: 'Asia/Jayapura',
  FOR: 'America/Fortaleza',
  FOS: 'Australia/Perth',
  FOT: 'Australia/Sydney',
  FOU: 'Africa/Libreville',
  FOY: 'Africa/Monrovia',
  FPO: 'America/Nassau',
  FPR: 'America/New_York',
  FPY: 'America/New_York',
  FRA: 'Europe/Berlin',
  FRB: 'Australia/Sydney',
  FRC: 'America/Sao_Paulo',
  FRD: 'America/Los_Angeles',
  FRE: 'Pacific/Guadalcanal',
  FRG: 'America/New_York',
  FRH: 'America/Indiana/Indianapolis',
  FRI: 'America/Chicago',
  FRK: 'Indian/Mahe',
  FRL: 'Europe/Rome',
  FRM: 'America/Chicago',
  FRN: 'America/Anchorage',
  FRO: 'Europe/Oslo',
  FRQ: 'Pacific/Port_Moresby',
  FRR: 'America/New_York',
  FRS: 'America/Guatemala',
  FRT: 'America/Santiago',
  FRU: 'Asia/Bishkek',
  FRW: 'Africa/Gaborone',
  FRY: 'America/New_York',
  FRZ: 'Europe/Berlin',
  FSC: 'Europe/Paris',
  FSD: 'America/Chicago',
  FSI: 'America/Chicago',
  FSK: 'America/Chicago',
  FSL: 'Australia/Perth',
  FSM: 'America/Chicago',
  FSP: 'America/Miquelon',
  FSS: 'Europe/London',
  FST: 'America/Chicago',
  FSU: 'America/Denver',
  FSZ: 'Asia/Tokyo',
  FTA: 'Pacific/Efate',
  FTE: 'America/Argentina/Rio_Gallegos',
  FTI: 'Pacific/Pago_Pago',
  FTK: 'America/New_York',
  FTU: 'Indian/Antananarivo',
  FTW: 'America/Chicago',
  FTX: 'Africa/Brazzaville',
  FTY: 'America/New_York',
  FUB: 'Pacific/Port_Moresby',
  FUE: 'Atlantic/Canary',
  FUG: 'Asia/Shanghai',
  FUJ: 'Asia/Tokyo',
  FUK: 'Asia/Tokyo',
  FUL: 'America/Los_Angeles',
  FUM: 'Pacific/Port_Moresby',
  FUN: 'Pacific/Funafuti',
  FUO: 'Asia/Shanghai',
  FUT: 'Pacific/Wallis',
  FVL: 'Australia/Perth',
  FVM: 'Indian/Maldives',
  FVR: 'Australia/Perth',
  FWA: 'America/Indiana/Indianapolis',
  FWH: 'America/Chicago',
  FWL: 'America/Anchorage',
  FXE: 'America/New_York',
  FXO: 'Africa/Maputo',
  FXY: 'America/Chicago',
  FYJ: 'Asia/Shanghai',
  FYM: 'America/Chicago',
  FYN: 'Asia/Urumqi',
  FYT: 'Africa/Ndjamena',
  FYU: 'America/Anchorage',
  FYV: 'America/Chicago',
  FZO: 'Europe/London',
  GAA: 'America/Bogota',
  GAB: 'America/Los_Angeles',
  GAC: 'America/Tegucigalpa',
  GAD: 'America/Chicago',
  GAE: 'Africa/Tunis',
  GAF: 'Africa/Tunis',
  GAG: 'America/Chicago',
  GAH: 'Australia/Brisbane',
  GAI: 'America/New_York',
  GAJ: 'Asia/Tokyo',
  GAL: 'America/Anchorage',
  GAM: 'America/Nome',
  GAN: 'Indian/Maldives',
  GAO: 'America/Havana',
  GAP: 'Pacific/Port_Moresby',
  GAQ: 'Africa/Bamako',
  GAR: 'Pacific/Port_Moresby',
  GAS: 'Africa/Nairobi',
  GAT: 'Europe/Paris',
  GAU: 'Asia/Kolkata',
  GAV: 'Asia/Jayapura',
  GAW: 'Asia/Yangon',
  GAX: 'Africa/Libreville',
  GAY: 'Asia/Kolkata',
  GAZ: 'Pacific/Port_Moresby',
  GBA: 'Europe/London',
  GBB: 'Asia/Baku',
  GBC: 'Pacific/Port_Moresby',
  GBD: 'America/Chicago',
  GBE: 'Africa/Gaborone',
  GBF: 'Pacific/Port_Moresby',
  GBG: 'America/Chicago',
  GBH: 'America/Anchorage',
  GBJ: 'America/Guadeloupe',
  GBK: 'Africa/Freetown',
  GBL: 'Australia/Darwin',
  GBM: 'Africa/Mogadishu',
  GBP: 'Australia/Brisbane',
  GBR: 'America/New_York',
  GBT: 'Asia/Tehran',
  GBU: 'Africa/Khartoum',
  GBV: 'Australia/Perth',
  GBW: 'Australia/Perth',
  GBZ: 'Pacific/Auckland',
  GCA: 'America/Bogota',
  GCC: 'America/Denver',
  GCD: 'America/Los_Angeles',
  GCH: 'Asia/Tehran',
  GCI: 'Europe/Guernsey',
  GCJ: 'Africa/Johannesburg',
  GCK: 'America/Chicago',
  GCM: 'America/Cayman',
  GCN: 'America/Phoenix',
  GCT: 'America/Phoenix',
  GCW: 'America/Phoenix',
  GCY: 'America/New_York',
  GDA: 'Africa/Bangui',
  GDC: 'America/New_York',
  GDD: 'Australia/Perth',
  GDE: 'Africa/Addis_Ababa',
  GDG: 'Asia/Yakutsk',
  GDH: 'America/Anchorage',
  GDI: 'Africa/Bangui',
  GDJ: 'Africa/Lubumbashi',
  GDL: 'America/Mexico_City',
  GDM: 'America/New_York',
  GDN: 'Europe/Warsaw',
  GDO: 'America/Caracas',
  GDP: 'America/Fortaleza',
  GDQ: 'Africa/Addis_Ababa',
  GDT: 'America/Grand_Turk',
  GDV: 'America/Denver',
  GDW: 'America/Detroit',
  GDX: 'Asia/Magadan',
  GDZ: 'Europe/Moscow',
  GEA: 'Pacific/Noumea',
  GEB: 'Asia/Jayapura',
  GEC: 'Asia/Famagusta',
  GED: 'America/New_York',
  GEE: 'Australia/Hobart',
  GEF: 'Pacific/Guadalcanal',
  GEG: 'America/Los_Angeles',
  GEL: 'America/Sao_Paulo',
  GEM: 'Africa/Malabo',
  GEO: 'America/Guyana',
  GER: 'America/Havana',
  GES: 'Asia/Manila',
  GET: 'Australia/Perth',
  GEV: 'Europe/Stockholm',
  GEW: 'Pacific/Port_Moresby',
  GEX: 'Australia/Melbourne',
  GEY: 'America/Denver',
  GFD: 'America/Indiana/Indianapolis',
  GFE: 'Australia/Sydney',
  GFF: 'Australia/Sydney',
  GFK: 'America/Chicago',
  GFL: 'America/New_York',
  GFN: 'Australia/Sydney',
  GFO: 'America/Guyana',
  GFR: 'Europe/Paris',
  GFY: 'Africa/Windhoek',
  GGC: 'Africa/Luanda',
  GGD: 'Australia/Brisbane',
  GGE: 'America/New_York',
  GGG: 'America/Chicago',
  GGL: 'America/Bogota',
  GGM: 'Africa/Nairobi',
  GGN: 'Africa/Abidjan',
  GGO: 'Africa/Abidjan',
  GGR: 'Africa/Mogadishu',
  GGS: 'America/Argentina/Rio_Gallegos',
  GGT: 'America/Nassau',
  GGW: 'America/Denver',
  GHA: 'Africa/Algiers',
  GHB: 'America/Nassau',
  GHC: 'America/Nassau',
  GHE: 'America/Panama',
  GHF: 'Europe/Berlin',
  GHK: 'America/Yellowknife',
  GHM: 'America/Chicago',
  GHN: 'Asia/Shanghai',
  GHS: 'Asia/Makassar',
  GHT: 'Africa/Tripoli',
  GHU: 'America/Argentina/Cordoba',
  GIB: 'Europe/Gibraltar',
  GIC: 'Pacific/Port_Moresby',
  GID: 'Africa/Bujumbura',
  GIF: 'America/New_York',
  GIG: 'America/Sao_Paulo',
  GII: 'Africa/Conakry',
  GIL: 'Asia/Karachi',
  GIM: 'Africa/Libreville',
  GIR: 'America/Bogota',
  GIS: 'Pacific/Auckland',
  GIT: 'Africa/Dar_es_Salaam',
  GIU: 'Asia/Colombo',
  GIY: 'Africa/Johannesburg',
  GIZ: 'Asia/Riyadh',
  GJA: 'America/Tegucigalpa',
  GJL: 'Africa/Algiers',
  GJM: 'America/Porto_Velho',
  GJR: 'Atlantic/Reykjavik',
  GJT: 'America/Denver',
  GKA: 'Pacific/Port_Moresby',
  GKD: 'Europe/Istanbul',
  GKE: 'Europe/Berlin',
  GKH: 'Asia/Kathmandu',
  GKK: 'Indian/Maldives',
  GKL: 'Australia/Brisbane',
  GKN: 'America/Anchorage',
  GKO: 'Africa/Libreville',
  GKT: 'America/New_York',
  GLA: 'Europe/London',
  GLB: 'America/Phoenix',
  GLC: 'Africa/Addis_Ababa',
  GLD: 'America/Denver',
  GLE: 'America/Chicago',
  GLF: 'America/Costa_Rica',
  GLG: 'Australia/Brisbane',
  GLH: 'America/Chicago',
  GLI: 'Australia/Sydney',
  GLK: 'Africa/Mogadishu',
  GLL: 'Europe/Oslo',
  GLM: 'Australia/Brisbane',
  GLN: 'Africa/Casablanca',
  GLO: 'Europe/London',
  GLP: 'Pacific/Port_Moresby',
  GLR: 'America/Detroit',
  GLS: 'America/Chicago',
  GLT: 'Australia/Brisbane',
  GLU: 'Asia/Thimphu',
  GLV: 'America/Nome',
  GLW: 'America/Chicago',
  GLX: 'Asia/Jayapura',
  GLY: 'Australia/Perth',
  GLZ: 'Europe/Amsterdam',
  GMA: 'Africa/Kinshasa',
  GMB: 'Africa/Addis_Ababa',
  GMC: 'America/Bogota',
  GMD: 'Africa/Casablanca',
  GME: 'Europe/Minsk',
  GMI: 'Pacific/Port_Moresby',
  GMM: 'Africa/Brazzaville',
  GMN: 'Pacific/Auckland',
  GMO: 'Africa/Lagos',
  GMP: 'Asia/Seoul',
  GMQ: 'Asia/Shanghai',
  GMR: 'Pacific/Gambier',
  GMS: 'America/Fortaleza',
  GMT: 'America/Anchorage',
  GMU: 'America/New_York',
  GMV: 'America/Denver',
  GMZ: 'Atlantic/Canary',
  GNA: 'Europe/Minsk',
  GNB: 'Europe/Paris',
  GND: 'America/Grenada',
  GNF: 'America/Los_Angeles',
  GNG: 'America/Boise',
  GNI: 'Asia/Taipei',
  GNM: 'America/Bahia',
  GNN: 'Africa/Addis_Ababa',
  GNR: 'America/Argentina/Salta',
  GNS: 'Asia/Jakarta',
  GNT: 'America/Denver',
  GNU: 'America/Anchorage',
  GNV: 'America/New_York',
  GNY: 'Europe/Istanbul',
  GNZ: 'Africa/Gaborone',
  GOA: 'Europe/Rome',
  GOB: 'Africa/Addis_Ababa',
  GOC: 'Pacific/Port_Moresby',
  GOE: 'Pacific/Port_Moresby',
  GOG: 'Africa/Windhoek',
  GOH: 'America/Godthab',
  GOI: 'Asia/Kolkata',
  GOJ: 'Europe/Moscow',
  GOK: 'America/Chicago',
  GOL: 'America/Los_Angeles',
  GOM: 'Africa/Lubumbashi',
  GON: 'America/New_York',
  GOO: 'Australia/Brisbane',
  GOP: 'Asia/Kolkata',
  GOQ: 'Asia/Urumqi',
  GOR: 'Africa/Addis_Ababa',
  GOS: 'Australia/Sydney',
  GOT: 'Europe/Stockholm',
  GOU: 'Africa/Douala',
  GOV: 'Australia/Darwin',
  GOZ: 'Europe/Sofia',
  GPA: 'Europe/Athens',
  GPB: 'America/Sao_Paulo',
  GPD: 'Australia/Brisbane',
  GPI: 'America/Bogota',
  GPL: 'America/Costa_Rica',
  GPN: 'Australia/Darwin',
  GPO: 'America/Argentina/Salta',
  GPS: 'Pacific/Galapagos',
  GPT: 'America/Chicago',
  GPZ: 'America/Chicago',
  GQQ: 'America/New_York',
  GRA: 'America/Bogota',
  GRB: 'America/Chicago',
  GRC: 'Africa/Monrovia',
  GRD: 'America/New_York',
  GRE: 'America/Chicago',
  GRF: 'America/Los_Angeles',
  GRG: 'Asia/Kabul',
  GRH: 'Pacific/Port_Moresby',
  GRI: 'America/Chicago',
  GRJ: 'Africa/Johannesburg',
  GRK: 'America/Chicago',
  GRL: 'Pacific/Port_Moresby',
  GRM: 'America/Chicago',
  GRN: 'America/Denver',
  GRO: 'Europe/Madrid',
  GRP: 'America/Araguaina',
  GRQ: 'Europe/Amsterdam',
  GRR: 'America/Detroit',
  GRS: 'Europe/Rome',
  GRT: 'Asia/Karachi',
  GRU: 'America/Sao_Paulo',
  GRV: 'Europe/Moscow',
  GRW: 'Atlantic/Azores',
  GRX: 'Europe/Madrid',
  GRY: 'Atlantic/Reykjavik',
  GRZ: 'Europe/Vienna',
  GSA: 'Asia/Kuching',
  GSB: 'America/New_York',
  GSC: 'Australia/Perth',
  GSE: 'Europe/Stockholm',
  GSH: 'America/Indiana/Indianapolis',
  GSI: 'America/Cayenne',
  GSJ: 'America/Guatemala',
  GSL: 'America/Yellowknife',
  GSM: 'Asia/Tehran',
  GSN: 'Australia/Adelaide',
  GSO: 'America/New_York',
  GSP: 'America/New_York',
  GSQ: 'Africa/Cairo',
  GSR: 'Africa/Mogadishu',
  GSS: 'Africa/Johannesburg',
  GST: 'America/Juneau',
  GSU: 'Africa/Khartoum',
  GTA: 'Pacific/Guadalcanal',
  GTE: 'Australia/Darwin',
  GTF: 'America/Denver',
  GTG: 'America/Chicago',
  GTI: 'Europe/Berlin',
  GTN: 'Pacific/Auckland',
  GTO: 'Asia/Makassar',
  GTP: 'America/Los_Angeles',
  GTR: 'America/Chicago',
  GTS: 'Australia/Darwin',
  GTT: 'Australia/Brisbane',
  GTW: 'Europe/Prague',
  GTY: 'America/New_York',
  GTZ: 'Africa/Dar_es_Salaam',
  GUA: 'America/Guatemala',
  GUB: 'America/Tijuana',
  GUC: 'America/Denver',
  GUD: 'Africa/Bamako',
  GUE: 'Pacific/Port_Moresby',
  GUF: 'America/Chicago',
  GUG: 'Pacific/Port_Moresby',
  GUH: 'Australia/Sydney',
  GUI: 'America/Caracas',
  GUJ: 'America/Sao_Paulo',
  GUL: 'Australia/Sydney',
  GUM: 'Pacific/Guam',
  GUO: 'Africa/Mogadishu',
  GUP: 'America/Denver',
  GUQ: 'America/Caracas',
  GUR: 'Pacific/Port_Moresby',
  GUS: 'America/Indiana/Indianapolis',
  GUT: 'Europe/Berlin',
  GUU: 'Atlantic/Reykjavik',
  GUV: 'Pacific/Port_Moresby',
  GUW: 'Asia/Atyrau',
  GUX: 'Asia/Kolkata',
  GUY: 'America/Chicago',
  GUZ: 'America/Sao_Paulo',
  GVA: 'Europe/Zurich',
  GVE: 'America/New_York',
  GVI: 'Pacific/Port_Moresby',
  GVL: 'America/New_York',
  GVN: 'Asia/Vladivostok',
  GVP: 'Australia/Brisbane',
  GVR: 'America/Sao_Paulo',
  GVT: 'America/Chicago',
  GVX: 'Europe/Stockholm',
  GWA: 'Asia/Yangon',
  GWD: 'Asia/Karachi',
  GWE: 'Africa/Harare',
  GWL: 'Asia/Kolkata',
  GWN: 'Pacific/Port_Moresby',
  GWO: 'America/Chicago',
  GWS: 'America/Denver',
  GWT: 'Europe/Berlin',
  GWV: 'America/New_York',
  GWY: 'Europe/Dublin',
  GXA: 'Asia/Pontianak',
  GXF: 'Asia/Aden',
  GXG: 'Africa/Luanda',
  GXH: 'Asia/Shanghai',
  GXQ: 'America/Santiago',
  GXX: 'Africa/Douala',
  GXY: 'America/Denver',
  GYA: 'America/La_Paz',
  GYD: 'Asia/Baku',
  GYE: 'America/Guayaquil',
  GYG: 'Asia/Yakutsk',
  GYI: 'Africa/Kigali',
  GYL: 'Australia/Perth',
  GYM: 'America/Hermosillo',
  GYN: 'America/Sao_Paulo',
  GYP: 'Australia/Brisbane',
  GYR: 'America/Phoenix',
  GYS: 'Asia/Shanghai',
  GYU: 'Asia/Shanghai',
  GZA: 'Asia/Gaza',
  GZI: 'Asia/Kabul',
  GZO: 'Pacific/Guadalcanal',
  GZP: 'Europe/Istanbul',
  GZT: 'Europe/Istanbul',
  GZW: 'Asia/Tehran',
  HAA: 'Europe/Oslo',
  HAB: 'America/Chicago',
  HAC: 'Asia/Tokyo',
  HAD: 'Europe/Stockholm',
  HAF: 'America/Los_Angeles',
  HAH: 'Indian/Comoro',
  HAI: 'America/Detroit',
  HAJ: 'Europe/Berlin',
  HAK: 'Asia/Shanghai',
  HAL: 'Africa/Windhoek',
  HAM: 'Europe/Berlin',
  HAN: 'Asia/Ho_Chi_Minh',
  HAO: 'America/New_York',
  HAQ: 'Indian/Maldives',
  HAR: 'America/New_York',
  HAS: 'Asia/Riyadh',
  HAT: 'Australia/Brisbane',
  HAU: 'Europe/Oslo',
  HAV: 'America/Havana',
  HAW: 'Europe/London',
  HAZ: 'Pacific/Port_Moresby',
  HBA: 'Australia/Hobart',
  HBB: 'America/Denver',
  HBD: 'Pacific/Port_Moresby',
  HBE: 'Africa/Cairo',
  HBG: 'America/Chicago',
  HBH: 'America/Juneau',
  HBK: 'America/Phoenix',
  HBQ: 'Asia/Shanghai',
  HBR: 'America/Chicago',
  HBT: 'Asia/Colombo',
  HBU: 'Asia/Hovd',
  HBX: 'Asia/Kolkata',
  HCA: 'America/Chicago',
  HCC: 'America/New_York',
  HCJ: 'Asia/Shanghai',
  HCM: 'Africa/Mogadishu',
  HCN: 'Asia/Taipei',
  HCQ: 'Australia/Perth',
  HCR: 'America/Anchorage',
  HCW: 'America/New_York',
  HDB: 'Europe/Berlin',
  HDD: 'Asia/Karachi',
  HDE: 'America/Chicago',
  HDF: 'Europe/Berlin',
  HDG: 'Asia/Shanghai',
  HDH: 'Pacific/Honolulu',
  HDM: 'Asia/Tehran',
  HDN: 'America/Denver',
  HDR: 'Asia/Tehran',
  HDS: 'Africa/Johannesburg',
  HDY: 'Asia/Bangkok',
  HEA: 'Asia/Kabul',
  HEB: 'Asia/Yangon',
  HED: 'America/Anchorage',
  HEE: 'America/Chicago',
  HEH: 'Asia/Yangon',
  HEI: 'Europe/Berlin',
  HEK: 'Asia/Shanghai',
  HEL: 'Europe/Helsinki',
  HEM: 'Europe/Helsinki',
  HEO: 'Pacific/Port_Moresby',
  HER: 'Europe/Athens',
  HES: 'America/Los_Angeles',
  HET: 'Asia/Shanghai',
  HEZ: 'America/Chicago',
  HFA: 'Asia/Jerusalem',
  HFD: 'America/New_York',
  HFE: 'Asia/Shanghai',
  HFF: 'America/New_York',
  HFN: 'Atlantic/Reykjavik',
  HFS: 'Europe/Stockholm',
  HFT: 'Europe/Oslo',
  HGA: 'Africa/Mogadishu',
  HGD: 'Australia/Brisbane',
  HGE: 'America/Caracas',
  HGH: 'Asia/Shanghai',
  HGI: 'Africa/Khartoum',
  HGL: 'Europe/Berlin',
  HGN: 'Asia/Bangkok',
  HGO: 'Africa/Abidjan',
  HGR: 'America/New_York',
  HGS: 'Africa/Freetown',
  HGU: 'Pacific/Port_Moresby',
  HGZ: 'America/Anchorage',
  HHE: 'Asia/Tokyo',
  HHH: 'America/New_York',
  HHI: 'Pacific/Honolulu',
  HHN: 'Europe/Berlin',
  HHQ: 'Asia/Bangkok',
  HHR: 'America/Los_Angeles',
  HHZ: 'Pacific/Tahiti',
  HIA: 'Asia/Shanghai',
  HIB: 'America/Chicago',
  HID: 'Australia/Brisbane',
  HIE: 'America/New_York',
  HIF: 'America/Denver',
  HIG: 'Australia/Brisbane',
  HII: 'America/Phoenix',
  HIJ: 'Asia/Tokyo',
  HIL: 'Africa/Addis_Ababa',
  HIM: 'Asia/Colombo',
  HIN: 'Asia/Seoul',
  HIO: 'America/Los_Angeles',
  HIP: 'Australia/Brisbane',
  HIR: 'Pacific/Guadalcanal',
  HIT: 'Pacific/Port_Moresby',
  HIW: 'Asia/Tokyo',
  HJJ: 'Asia/Shanghai',
  HJR: 'Asia/Kolkata',
  HJT: 'Asia/Ulaanbaatar',
  HKA: 'America/Chicago',
  HKB: 'America/Anchorage',
  HKD: 'Asia/Tokyo',
  HKG: 'Asia/Hong_Kong',
  HKK: 'Pacific/Auckland',
  HKN: 'Pacific/Port_Moresby',
  HKR: 'Africa/Nairobi',
  HKS: 'America/Chicago',
  HKT: 'Asia/Bangkok',
  HKV: 'Europe/Sofia',
  HKY: 'America/New_York',
  HLA: 'Africa/Johannesburg',
  HLB: 'America/Indiana/Indianapolis',
  HLC: 'America/Chicago',
  HLD: 'Asia/Shanghai',
  HLE: 'Atlantic/St_Helena',
  HLF: 'Europe/Stockholm',
  HLG: 'America/New_York',
  HLH: 'Asia/Shanghai',
  HLI: 'America/Los_Angeles',
  HLL: 'Australia/Perth',
  HLM: 'America/Detroit',
  HLN: 'America/Denver',
  HLP: 'Asia/Jakarta',
  HLR: 'America/Chicago',
  HLS: 'Australia/Hobart',
  HLT: 'Australia/Melbourne',
  HLV: 'Australia/Brisbane',
  HLW: 'Africa/Johannesburg',
  HLZ: 'Pacific/Auckland',
  HMA: 'Asia/Yekaterinburg',
  HMB: 'Africa/Cairo',
  HME: 'Africa/Algiers',
  HMG: 'Australia/Darwin',
  HMI: 'Asia/Urumqi',
  HMJ: 'Europe/Kiev',
  HMN: 'America/Denver',
  HMO: 'America/Hermosillo',
  HMR: 'Europe/Oslo',
  HMT: 'America/Los_Angeles',
  HMV: 'Europe/Stockholm',
  HMY: 'Asia/Seoul',
  HNA: 'Asia/Tokyo',
  HNB: 'America/Indiana/Vincennes',
  HNC: 'America/New_York',
  HND: 'Asia/Tokyo',
  HNH: 'America/Juneau',
  HNI: 'Pacific/Port_Moresby',
  HNL: 'Pacific/Honolulu',
  HNM: 'Pacific/Honolulu',
  HNN: 'Pacific/Port_Moresby',
  HNS: 'America/Juneau',
  HNY: 'Asia/Shanghai',
  HOA: 'Africa/Nairobi',
  HOB: 'America/Denver',
  HOC: 'Pacific/Port_Moresby',
  HOD: 'Asia/Aden',
  HOE: 'Asia/Vientiane',
  HOF: 'Asia/Riyadh',
  HOG: 'America/Havana',
  HOH: 'Europe/Vienna',
  HOI: 'Pacific/Tahiti',
  HOK: 'Australia/Darwin',
  HOM: 'America/Anchorage',
  HON: 'America/Chicago',
  HOO: 'Asia/Ho_Chi_Minh',
  HOP: 'America/Chicago',
  HOQ: 'Europe/Berlin',
  HOR: 'Atlantic/Azores',
  HOS: 'America/Argentina/Salta',
  HOT: 'America/Chicago',
  HOU: 'America/Chicago',
  HOV: 'Europe/Oslo',
  HOX: 'Asia/Yangon',
  HOY: 'Europe/London',
  HPA: 'Pacific/Tongatapu',
  HPB: 'America/Nome',
  HPE: 'Australia/Brisbane',
  HPG: 'Asia/Shanghai',
  HPH: 'Asia/Ho_Chi_Minh',
  HPN: 'America/New_York',
  HPT: 'America/Chicago',
  HPV: 'Pacific/Honolulu',
  HPY: 'America/Chicago',
  HQM: 'America/Los_Angeles',
  HRB: 'Asia/Shanghai',
  HRC: 'Asia/Almaty',
  HRE: 'Africa/Harare',
  HRG: 'Africa/Cairo',
  HRI: 'Asia/Colombo',
  HRK: 'Europe/Zaporozhye',
  HRL: 'America/Chicago',
  HRM: 'Africa/Algiers',
  HRO: 'America/Chicago',
  HRR: 'America/Bogota',
  HRS: 'Africa/Johannesburg',
  HRT: 'Europe/London',
  HRY: 'Australia/Darwin',
  HRZ: 'America/Sao_Paulo',
  HSB: 'America/Chicago',
  HSC: 'Asia/Shanghai',
  HSG: 'Asia/Tokyo',
  HSH: 'America/Los_Angeles',
  HSI: 'America/Chicago',
  HSJ: 'Asia/Shanghai',
  HSK: 'Europe/Madrid',
  HSL: 'America/Anchorage',
  HSM: 'Australia/Melbourne',
  HSN: 'Asia/Shanghai',
  HSP: 'America/New_York',
  HSS: 'Asia/Kolkata',
  HST: 'America/New_York',
  HSV: 'America/Chicago',
  HSZ: 'Asia/Taipei',
  HTA: 'Asia/Yakutsk',
  HTG: 'Asia/Krasnoyarsk',
  HTH: 'America/Los_Angeles',
  HTI: 'Australia/Lindeman',
  HTL: 'America/Detroit',
  HTM: 'Asia/Ulaanbaatar',
  HTN: 'Asia/Shanghai',
  HTO: 'America/New_York',
  HTR: 'Asia/Tokyo',
  HTS: 'America/New_York',
  HTT: 'Asia/Urumqi',
  HTU: 'Australia/Melbourne',
  HTV: 'America/Chicago',
  HTW: 'America/New_York',
  HTY: 'Europe/Istanbul',
  HTZ: 'America/Bogota',
  HUA: 'America/Chicago',
  HUB: 'Australia/Darwin',
  HUC: 'America/Puerto_Rico',
  HUD: 'America/Chicago',
  HUE: 'Africa/Addis_Ababa',
  HUF: 'America/Indiana/Indianapolis',
  HUG: 'America/Guatemala',
  HUH: 'Pacific/Tahiti',
  HUI: 'Asia/Ho_Chi_Minh',
  HUJ: 'America/Chicago',
  HUK: 'Africa/Gaborone',
  HUL: 'America/New_York',
  HUM: 'America/Chicago',
  HUN: 'Asia/Taipei',
  HUO: 'Asia/Shanghai',
  HUQ: 'Africa/Tripoli',
  HUS: 'America/Anchorage',
  HUT: 'America/Chicago',
  HUU: 'America/Lima',
  HUV: 'Europe/Stockholm',
  HUW: 'America/Manaus',
  HUX: 'America/Mexico_City',
  HUY: 'Europe/London',
  HUZ: 'Asia/Shanghai',
  HVA: 'Indian/Antananarivo',
  HVB: 'Australia/Brisbane',
  HVD: 'Asia/Hovd',
  HVE: 'America/Denver',
  HVG: 'Europe/Oslo',
  HVK: 'Atlantic/Reykjavik',
  HVN: 'America/New_York',
  HVR: 'America/Denver',
  HVS: 'America/New_York',
  HWA: 'Pacific/Port_Moresby',
  HWD: 'America/Los_Angeles',
  HWI: 'America/Juneau',
  HWK: 'Australia/Adelaide',
  HWN: 'Africa/Harare',
  HWO: 'America/New_York',
  HXD: 'Asia/Urumqi',
  HXX: 'Australia/Sydney',
  HYA: 'America/New_York',
  HYC: 'Europe/London',
  HYD: 'Asia/Kolkata',
  HYF: 'Pacific/Port_Moresby',
  HYG: 'America/Metlakatla',
  HYL: 'America/Juneau',
  HYN: 'Asia/Shanghai',
  HYR: 'America/Chicago',
  HYS: 'America/Chicago',
  HYV: 'Europe/Helsinki',
  HZB: 'Europe/Paris',
  HZG: 'Asia/Shanghai',
  HZH: 'Asia/Shanghai',
  HZK: 'Atlantic/Reykjavik',
  HZL: 'America/New_York',
  HZP: 'America/Edmonton',
  HZV: 'Africa/Johannesburg',
  IAA: 'Asia/Krasnoyarsk',
  IAB: 'America/Chicago',
  IAD: 'America/New_York',
  IAG: 'America/New_York',
  IAH: 'America/Chicago',
  IAM: 'Africa/Algiers',
  IAN: 'America/Anchorage',
  IAO: 'Asia/Manila',
  IAQ: 'Asia/Tehran',
  IAR: 'Europe/Moscow',
  IAS: 'Europe/Bucharest',
  IAU: 'Pacific/Port_Moresby',
  IBA: 'Africa/Lagos',
  IBB: 'Pacific/Galapagos',
  IBE: 'America/Bogota',
  IBI: 'Pacific/Port_Moresby',
  IBL: 'Africa/Maputo',
  IBO: 'Africa/Maputo',
  IBP: 'America/Lima',
  IBR: 'Asia/Tokyo',
  IBZ: 'Europe/Madrid',
  ICA: 'America/Caracas',
  ICC: 'America/Caracas',
  ICI: 'Pacific/Fiji',
  ICK: 'America/Paramaribo',
  ICL: 'America/Chicago',
  ICN: 'Asia/Seoul',
  ICO: 'Asia/Manila',
  ICS: 'America/Boise',
  ICT: 'America/Chicago',
  ICY: 'America/Anchorage',
  IDA: 'America/Boise',
  IDB: 'Europe/Stockholm',
  IDC: 'Africa/Maputo',
  IDF: 'Africa/Kinshasa',
  IDG: 'America/Chicago',
  IDH: 'America/Los_Angeles',
  IDI: 'America/New_York',
  IDK: 'Australia/Adelaide',
  IDN: 'Pacific/Port_Moresby',
  IDO: 'America/Araguaina',
  IDP: 'America/Chicago',
  IDR: 'Asia/Kolkata',
  IDY: 'Europe/Paris',
  IEG: 'Europe/Warsaw',
  IEJ: 'Asia/Tokyo',
  IES: 'Europe/Berlin',
  IEV: 'Europe/Kiev',
  IFA: 'America/Chicago',
  IFF: 'Australia/Brisbane',
  IFH: 'Asia/Tehran',
  IFJ: 'Atlantic/Reykjavik',
  IFL: 'Australia/Brisbane',
  IFN: 'Asia/Tehran',
  IFO: 'Europe/Uzhgorod',
  IFP: 'America/Phoenix',
  IFU: 'Indian/Maldives',
  IGA: 'America/Nassau',
  IGB: 'America/Argentina/Salta',
  IGD: 'Europe/Istanbul',
  IGE: 'Africa/Libreville',
  IGG: 'America/Anchorage',
  IGH: 'Australia/Brisbane',
  IGL: 'Europe/Istanbul',
  IGM: 'America/Phoenix',
  IGN: 'Asia/Manila',
  IGO: 'America/Bogota',
  IGR: 'America/Argentina/Cordoba',
  IGS: 'Europe/Berlin',
  IGT: 'Europe/Moscow',
  IGU: 'America/Sao_Paulo',
  IHC: 'Africa/Maputo',
  IHN: 'Asia/Aden',
  IHO: 'Indian/Antananarivo',
  IHR: 'Asia/Tehran',
  IHU: 'Pacific/Port_Moresby',
  IIA: 'Europe/Dublin',
  IIL: 'Asia/Tehran',
  IIS: 'Pacific/Bougainville',
  IJK: 'Europe/Samara',
  IJU: 'America/Sao_Paulo',
  IJX: 'America/Chicago',
  IKA: 'Asia/Tehran',
  IKB: 'America/New_York',
  IKI: 'Asia/Tokyo',
  IKK: 'America/Chicago',
  IKL: 'Africa/Kinshasa',
  IKO: 'America/Adak',
  IKP: 'Australia/Brisbane',
  IKS: 'Asia/Yakutsk',
  IKT: 'Asia/Irkutsk',
  IKU: 'Asia/Bishkek',
  ILA: 'Asia/Jayapura',
  ILD: 'Europe/Madrid',
  ILE: 'America/Chicago',
  ILF: 'America/Winnipeg',
  ILG: 'America/New_York',
  ILH: 'Europe/Berlin',
  ILI: 'America/Anchorage',
  ILK: 'Indian/Antananarivo',
  ILL: 'America/Chicago',
  ILM: 'America/New_York',
  ILN: 'America/New_York',
  ILO: 'Asia/Manila',
  ILP: 'Pacific/Noumea',
  ILQ: 'America/Lima',
  ILR: 'Africa/Lagos',
  ILS: 'America/El_Salvador',
  ILU: 'Africa/Nairobi',
  ILX: 'Pacific/Port_Moresby',
  ILY: 'Europe/London',
  ILZ: 'Europe/Bratislava',
  IMA: 'Pacific/Port_Moresby',
  IMB: 'America/Guyana',
  IMD: 'Pacific/Port_Moresby',
  IMF: 'Asia/Kolkata',
  IMG: 'Africa/Maputo',
  IMI: 'Pacific/Majuro',
  IMK: 'Asia/Kathmandu',
  IML: 'America/Denver',
  IMM: 'America/New_York',
  IMN: 'Pacific/Port_Moresby',
  IMO: 'Africa/Bangui',
  IMP: 'America/Araguaina',
  IMQ: 'Asia/Tehran',
  IMT: 'America/Menominee',
  INA: 'Europe/Moscow',
  INB: 'America/Belize',
  INC: 'Asia/Shanghai',
  IND: 'America/Indiana/Indianapolis',
  INE: 'Africa/Maputo',
  INF: 'Africa/Algiers',
  INH: 'Africa/Maputo',
  INI: 'Europe/Belgrade',
  INJ: 'Australia/Brisbane',
  INK: 'America/Chicago',
  INL: 'America/Chicago',
  INM: 'Australia/Adelaide',
  INN: 'Europe/Vienna',
  INO: 'Africa/Kinshasa',
  INQ: 'Europe/Dublin',
  INS: 'America/Los_Angeles',
  INT: 'America/New_York',
  INU: 'Pacific/Nauru',
  INV: 'Europe/London',
  INW: 'America/Phoenix',
  INX: 'Asia/Jayapura',
  INY: 'Africa/Johannesburg',
  INZ: 'Africa/Algiers',
  IOA: 'Europe/Athens',
  IOK: 'Pacific/Port_Moresby',
  IOM: 'Europe/Isle_of_Man',
  ION: 'Africa/Brazzaville',
  IOP: 'Pacific/Port_Moresby',
  IOR: 'Europe/Dublin',
  IOS: 'America/Bahia',
  IOW: 'America/Chicago',
  IPA: 'Pacific/Efate',
  IPC: 'Pacific/Easter',
  IPE: 'Asia/Manila',
  IPG: 'America/Manaus',
  IPH: 'Asia/Kuala_Lumpur',
  IPI: 'America/Bogota',
  IPL: 'America/Los_Angeles',
  IPN: 'America/Sao_Paulo',
  IPT: 'America/New_York',
  IPU: 'America/Bahia',
  IPZ: 'America/Costa_Rica',
  IQA: 'Asia/Baghdad',
  IQM: 'Asia/Urumqi',
  IQN: 'Asia/Shanghai',
  IQQ: 'America/Santiago',
  IQT: 'America/Lima',
  IRA: 'Pacific/Guadalcanal',
  IRB: 'America/Chicago',
  IRC: 'America/Anchorage',
  IRD: 'Asia/Dhaka',
  IRE: 'America/Bahia',
  IRG: 'Australia/Brisbane',
  IRI: 'Africa/Dar_es_Salaam',
  IRJ: 'America/Argentina/La_Rioja',
  IRK: 'America/Chicago',
  IRM: 'Asia/Yekaterinburg',
  IRN: 'America/Tegucigalpa',
  IRO: 'Africa/Bangui',
  IRP: 'Africa/Lubumbashi',
  IRS: 'America/Detroit',
  IRU: 'Asia/Colombo',
  IRZ: 'America/Manaus',
  ISA: 'Australia/Brisbane',
  ISB: 'Asia/Karachi',
  ISC: 'Europe/London',
  ISD: 'America/Bogota',
  ISE: 'Europe/Istanbul',
  ISG: 'Asia/Tokyo',
  ISI: 'Australia/Brisbane',
  ISJ: 'America/Cancun',
  ISK: 'Asia/Kolkata',
  ISL: 'Europe/Istanbul',
  ISM: 'America/New_York',
  ISN: 'America/Chicago',
  ISO: 'America/New_York',
  ISP: 'America/New_York',
  ISQ: 'America/Detroit',
  ISS: 'America/New_York',
  IST: 'Europe/Istanbul',
  ISU: 'Asia/Baghdad',
  ISW: 'America/Chicago',
  ITA: 'America/Manaus',
  ITB: 'America/Manaus',
  ITE: 'America/Bahia',
  ITH: 'America/New_York',
  ITI: 'America/Sao_Paulo',
  ITK: 'Pacific/Port_Moresby',
  ITM: 'Asia/Tokyo',
  ITN: 'America/Bahia',
  ITO: 'Pacific/Honolulu',
  ITP: 'America/Sao_Paulo',
  ITQ: 'America/Sao_Paulo',
  ITR: 'America/Sao_Paulo',
  ITU: 'Asia/Magadan',
  IUE: 'Pacific/Niue',
  IUL: 'Asia/Jayapura',
  IUS: 'Pacific/Port_Moresby',
  IVA: 'Indian/Antananarivo',
  IVC: 'Pacific/Auckland',
  IVG: 'Europe/Podgorica',
  IVI: 'America/Panama',
  IVL: 'Europe/Helsinki',
  IVO: 'America/Bogota',
  IVR: 'Australia/Sydney',
  IVW: 'Australia/Darwin',
  IWA: 'Europe/Moscow',
  IWD: 'America/Menominee',
  IWJ: 'Asia/Tokyo',
  IWK: 'Asia/Tokyo',
  IWO: 'Asia/Tokyo',
  IWS: 'America/Chicago',
  IXA: 'Asia/Kolkata',
  IXB: 'Asia/Kolkata',
  IXC: 'Asia/Kolkata',
  IXD: 'Asia/Kolkata',
  IXE: 'Asia/Kolkata',
  IXG: 'Asia/Kolkata',
  IXH: 'Asia/Kolkata',
  IXI: 'Asia/Kolkata',
  IXJ: 'Asia/Kolkata',
  IXK: 'Asia/Kolkata',
  IXL: 'Asia/Kolkata',
  IXM: 'Asia/Kolkata',
  IXN: 'Asia/Kolkata',
  IXP: 'Asia/Kolkata',
  IXQ: 'Asia/Kolkata',
  IXR: 'Asia/Kolkata',
  IXS: 'Asia/Kolkata',
  IXT: 'Asia/Kolkata',
  IXU: 'Asia/Kolkata',
  IXV: 'Asia/Kolkata',
  IXW: 'Asia/Kolkata',
  IXY: 'Asia/Kolkata',
  IXZ: 'Asia/Kolkata',
  IYK: 'America/Los_Angeles',
  IZA: 'America/Sao_Paulo',
  IZM: 'Europe/Istanbul',
  IZO: 'Asia/Tokyo',
  IZT: 'America/Mexico_City',
  JAA: 'Asia/Kabul',
  JAB: 'Australia/Darwin',
  JAC: 'America/Denver',
  JAD: 'Australia/Perth',
  JAE: 'America/Lima',
  JAF: 'Asia/Colombo',
  JAG: 'Asia/Karachi',
  JAI: 'Asia/Kolkata',
  JAK: 'America/Port-au-Prince',
  JAL: 'America/Mexico_City',
  JAM: 'Europe/Sofia',
  JAN: 'America/Chicago',
  JAP: 'America/Costa_Rica',
  JAQ: 'Pacific/Port_Moresby',
  JAR: 'Asia/Tehran',
  JAS: 'America/Chicago',
  JAT: 'Pacific/Majuro',
  JAU: 'America/Lima',
  JAV: 'America/Godthab',
  JAX: 'America/New_York',
  JBB: 'Asia/Jakarta',
  JBQ: 'America/Santo_Domingo',
  JBR: 'America/Chicago',
  JBT: 'America/Anchorage',
  JCB: 'America/Sao_Paulo',
  JCH: 'America/Godthab',
  JCI: 'America/Chicago',
  JCK: 'Australia/Brisbane',
  JCM: 'America/Bahia',
  JCR: 'America/Manaus',
  JCT: 'America/Chicago',
  JCY: 'America/Chicago',
  JDA: 'America/Los_Angeles',
  JDF: 'America/Sao_Paulo',
  JDG: 'Asia/Seoul',
  JDH: 'Asia/Kolkata',
  JDN: 'America/Denver',
  JDO: 'America/Fortaleza',
  JDR: 'America/Sao_Paulo',
  JDZ: 'Asia/Shanghai',
  JED: 'Asia/Riyadh',
  JEE: 'America/Port-au-Prince',
  JEF: 'America/Chicago',
  JEG: 'America/Godthab',
  JEJ: 'Pacific/Majuro',
  JEK: 'Africa/Lusaka',
  JEQ: 'America/Bahia',
  JER: 'Europe/Jersey',
  JFK: 'America/New_York',
  JFN: 'America/New_York',
  JFR: 'America/Godthab',
  JGA: 'Asia/Kolkata',
  JGB: 'Asia/Kolkata',
  JGD: 'Asia/Shanghai',
  JGN: 'Asia/Shanghai',
  JGS: 'Asia/Shanghai',
  JHB: 'Asia/Kuala_Lumpur',
  JHG: 'Asia/Shanghai',
  JHL: 'America/Edmonton',
  JHM: 'Pacific/Honolulu',
  JHS: 'America/Godthab',
  JHW: 'America/New_York',
  JIA: 'America/Cuiaba',
  JIB: 'Africa/Djibouti',
  JIC: 'Asia/Shanghai',
  JIJ: 'Africa/Addis_Ababa',
  JIK: 'Europe/Athens',
  JIL: 'Asia/Shanghai',
  JIM: 'Africa/Addis_Ababa',
  JIN: 'Africa/Kampala',
  JIO: 'Asia/Jayapura',
  JIP: 'America/Guayaquil',
  JIQ: 'Asia/Shanghai',
  JIR: 'Asia/Kathmandu',
  JIU: 'Asia/Shanghai',
  JIW: 'Asia/Karachi',
  JJA: 'Pacific/Guadalcanal',
  JJD: 'America/Fortaleza',
  JJG: 'America/Sao_Paulo',
  JJI: 'America/Lima',
  JJM: 'Africa/Nairobi',
  JJN: 'Asia/Shanghai',
  JKG: 'Europe/Stockholm',
  JKH: 'Europe/Athens',
  JKL: 'Europe/Athens',
  JKR: 'Asia/Kathmandu',
  JKT: 'Asia/Jakarta',
  JKV: 'America/Chicago',
  JLA: 'America/Anchorage',
  JLN: 'America/Chicago',
  JLR: 'Asia/Kolkata',
  JLS: 'America/Sao_Paulo',
  JMB: 'Africa/Luanda',
  JMJ: 'Asia/Shanghai',
  JMK: 'Europe/Athens',
  JMO: 'Asia/Kathmandu',
  JMS: 'America/Chicago',
  JMU: 'Asia/Shanghai',
  JNA: 'America/Sao_Paulo',
  JNB: 'Africa/Johannesburg',
  JNG: 'Asia/Shanghai',
  JNI: 'America/Argentina/Buenos_Aires',
  JNJ: 'Asia/Muscat',
  JNU: 'America/Juneau',
  JNX: 'Europe/Athens',
  JNZ: 'Asia/Shanghai',
  JOE: 'Europe/Helsinki',
  JOG: 'Asia/Jakarta',
  JOH: 'Africa/Johannesburg',
  JOI: 'America/Sao_Paulo',
  JOJ: 'America/Cambridge_Bay',
  JOK: 'Europe/Moscow',
  JOL: 'Asia/Manila',
  JOM: 'Africa/Dar_es_Salaam',
  JOP: 'Pacific/Port_Moresby',
  JOS: 'Africa/Lagos',
  JOT: 'America/Chicago',
  JPA: 'America/Fortaleza',
  JPR: 'America/Porto_Velho',
  JQA: 'America/Godthab',
  JQE: 'America/Panama',
  JRF: 'Pacific/Honolulu',
  JRG: 'Asia/Kolkata',
  JRH: 'Asia/Kolkata',
  JRN: 'America/Cuiaba',
  JRO: 'Africa/Dar_es_Salaam',
  JRS: 'Asia/Hebron',
  JSA: 'Asia/Kolkata',
  JSH: 'Europe/Athens',
  JSI: 'Europe/Athens',
  JSJ: 'Asia/Shanghai',
  JSK: 'Asia/Tehran',
  JSM: 'America/Argentina/Catamarca',
  JSR: 'Asia/Dhaka',
  JST: 'America/New_York',
  JSU: 'America/Godthab',
  JSY: 'Europe/Athens',
  JTC: 'America/Sao_Paulo',
  JTI: 'America/Sao_Paulo',
  JTR: 'Europe/Athens',
  JTY: 'Europe/Athens',
  JUA: 'America/Cuiaba',
  JUB: 'Africa/Juba',
  JUH: 'Asia/Shanghai',
  JUI: 'Europe/Berlin',
  JUJ: 'America/Argentina/Jujuy',
  JUL: 'America/Lima',
  JUM: 'Asia/Kathmandu',
  JUN: 'Australia/Brisbane',
  JUO: 'America/Bogota',
  JUR: 'Australia/Perth',
  JUT: 'America/Tegucigalpa',
  JUV: 'America/Godthab',
  JUZ: 'Asia/Shanghai',
  JVA: 'Indian/Antananarivo',
  JVI: 'America/New_York',
  JVL: 'America/Chicago',
  JWA: 'Africa/Gaborone',
  JWN: 'Asia/Tehran',
  JWO: 'Asia/Seoul',
  JXA: 'Asia/Shanghai',
  JXN: 'America/Detroit',
  JYR: 'Asia/Tehran',
  JYV: 'Europe/Helsinki',
  JZH: 'Asia/Shanghai',
  KAA: 'Africa/Lusaka',
  KAB: 'Africa/Harare',
  KAC: 'Asia/Damascus',
  KAD: 'Africa/Lagos',
  KAE: 'America/Sitka',
  KAF: 'Pacific/Bougainville',
  KAG: 'Asia/Seoul',
  KAI: 'America/Guyana',
  KAJ: 'Europe/Helsinki',
  KAK: 'Pacific/Port_Moresby',
  KAL: 'America/Anchorage',
  KAM: 'Asia/Aden',
  KAN: 'Africa/Lagos',
  KAO: 'Europe/Helsinki',
  KAP: 'Africa/Lubumbashi',
  KAQ: 'Pacific/Port_Moresby',
  KAR: 'America/Guyana',
  KAS: 'Africa/Windhoek',
  KAT: 'Pacific/Auckland',
  KAU: 'Europe/Helsinki',
  KAV: 'America/Caracas',
  KAW: 'Asia/Yangon',
  KAX: 'Australia/Perth',
  KAY: 'Pacific/Fiji',
  KAZ: 'Asia/Jayapura',
  KBA: 'Africa/Freetown',
  KBB: 'Australia/Darwin',
  KBC: 'America/Anchorage',
  KBD: 'Australia/Perth',
  KBE: 'America/Sitka',
  KBF: 'Asia/Jayapura',
  KBG: 'Africa/Kampala',
  KBH: 'Africa/Dar_es_Salaam',
  KBI: 'Africa/Douala',
  KBJ: 'Australia/Darwin',
  KBL: 'Asia/Kabul',
  KBM: 'Pacific/Port_Moresby',
  KBN: 'Africa/Lubumbashi',
  KBO: 'Africa/Lubumbashi',
  KBP: 'Europe/Kiev',
  KBQ: 'Africa/Blantyre',
  KBR: 'Asia/Kuala_Lumpur',
  KBS: 'Africa/Freetown',
  KBT: 'Pacific/Majuro',
  KBU: 'Asia/Makassar',
  KBV: 'Asia/Bangkok',
  KBW: 'America/Anchorage',
  KBX: 'Asia/Jayapura',
  KBY: 'Australia/Adelaide',
  KBZ: 'Pacific/Auckland',
  KCA: 'Asia/Urumqi',
  KCB: 'America/Paramaribo',
  KCC: 'America/Metlakatla',
  KCD: 'Asia/Jayapura',
  KCE: 'Australia/Brisbane',
  KCF: 'Asia/Karachi',
  KCG: 'America/Anchorage',
  KCH: 'Asia/Kuching',
  KCJ: 'Pacific/Port_Moresby',
  KCK: 'Asia/Irkutsk',
  KCL: 'America/Anchorage',
  KCM: 'Europe/Istanbul',
  KCN: 'America/Adak',
  KCO: 'Europe/Istanbul',
  KCP: 'Europe/Kiev',
  KCQ: 'America/Anchorage',
  KCR: 'America/Anchorage',
  KCS: 'Australia/Darwin',
  KCT: 'Asia/Colombo',
  KCU: 'Africa/Kampala',
  KCZ: 'Asia/Tokyo',
  KDA: 'Africa/Dakar',
  KDB: 'Australia/Perth',
  KDC: 'Africa/Porto-Novo',
  KDD: 'Asia/Karachi',
  KDE: 'Pacific/Port_Moresby',
  KDH: 'Asia/Kabul',
  KDI: 'Asia/Makassar',
  KDJ: 'Africa/Libreville',
  KDK: 'America/Anchorage',
  KDL: 'Europe/Tallinn',
  KDM: 'Indian/Maldives',
  KDN: 'Africa/Libreville',
  KDO: 'Indian/Maldives',
  KDP: 'Pacific/Port_Moresby',
  KDQ: 'Pacific/Port_Moresby',
  KDR: 'Pacific/Port_Moresby',
  KDS: 'Australia/Brisbane',
  KDT: 'Asia/Bangkok',
  KDU: 'Asia/Karachi',
  KDV: 'Pacific/Fiji',
  KDW: 'Asia/Colombo',
  KDX: 'Africa/Khartoum',
  KDY: 'Asia/Vladivostok',
  KDZ: 'Asia/Colombo',
  KEB: 'America/Anchorage',
  KEC: 'Africa/Lubumbashi',
  KED: 'Africa/Nouakchott',
  KEE: 'Africa/Brazzaville',
  KEF: 'Atlantic/Reykjavik',
  KEG: 'Pacific/Port_Moresby',
  KEH: 'America/Los_Angeles',
  KEI: 'Asia/Jayapura',
  KEJ: 'Asia/Novokuznetsk',
  KEK: 'America/Anchorage',
  KEL: 'Europe/Berlin',
  KEM: 'Europe/Helsinki',
  KEN: 'Africa/Freetown',
  KEO: 'Africa/Abidjan',
  KEP: 'Asia/Kathmandu',
  KEQ: 'Asia/Jayapura',
  KER: 'Asia/Tehran',
  KES: 'America/Winnipeg',
  KET: 'Asia/Yangon',
  KEU: 'Africa/Nairobi',
  KEV: 'Europe/Helsinki',
  KEW: 'America/Winnipeg',
  KEX: 'Pacific/Port_Moresby',
  KEY: 'Africa/Nairobi',
  KEZ: 'Asia/Colombo',
  KFA: 'Africa/Nouakchott',
  KFE: 'Australia/Perth',
  KFG: 'Australia/Darwin',
  KFP: 'America/Nome',
  KFS: 'Europe/Istanbul',
  KGA: 'Africa/Lubumbashi',
  KGB: 'Pacific/Port_Moresby',
  KGC: 'Australia/Adelaide',
  KGD: 'Europe/Kaliningrad',
  KGE: 'Pacific/Guadalcanal',
  KGF: 'Asia/Almaty',
  KGG: 'Africa/Dakar',
  KGH: 'Pacific/Port_Moresby',
  KGI: 'Australia/Perth',
  KGJ: 'Africa/Blantyre',
  KGK: 'America/Anchorage',
  KGL: 'Africa/Kigali',
  KGM: 'Pacific/Port_Moresby',
  KGN: 'Africa/Kinshasa',
  KGO: 'Europe/Zaporozhye',
  KGP: 'Asia/Yekaterinburg',
  KGR: 'Australia/Darwin',
  KGS: 'Europe/Athens',
  KGT: 'Asia/Shanghai',
  KGU: 'Asia/Kuching',
  KGW: 'Pacific/Port_Moresby',
  KGX: 'America/Anchorage',
  KGY: 'Australia/Brisbane',
  KGZ: 'America/Anchorage',
  KHA: 'Asia/Tehran',
  KHC: 'Europe/Simferopol',
  KHD: 'Asia/Tehran',
  KHE: 'Europe/Simferopol',
  KHG: 'Asia/Shanghai',
  KHH: 'Asia/Taipei',
  KHI: 'Asia/Karachi',
  KHJ: 'Europe/Helsinki',
  KHK: 'Asia/Tehran',
  KHM: 'Asia/Yangon',
  KHN: 'Asia/Shanghai',
  KHO: 'Africa/Johannesburg',
  KHR: 'Asia/Ulaanbaatar',
  KHS: 'Asia/Muscat',
  KHT: 'Asia/Kabul',
  KHU: 'Europe/Kiev',
  KHV: 'Asia/Vladivostok',
  KHW: 'Africa/Gaborone',
  KHX: 'Africa/Kampala',
  KHY: 'Asia/Tehran',
  KHZ: 'Pacific/Tahiti',
  KIA: 'Pacific/Port_Moresby',
  KIB: 'America/Anchorage',
  KIC: 'America/Los_Angeles',
  KID: 'Europe/Stockholm',
  KIE: 'Pacific/Bougainville',
  KIF: 'America/Winnipeg',
  KIG: 'Africa/Johannesburg',
  KIH: 'Asia/Tehran',
  KII: 'Pacific/Port_Moresby',
  KIJ: 'Asia/Tokyo',
  KIK: 'Asia/Baghdad',
  KIL: 'Africa/Lubumbashi',
  KIM: 'Africa/Johannesburg',
  KIN: 'America/Jamaica',
  KIO: 'Pacific/Majuro',
  KIP: 'America/Chicago',
  KIQ: 'Pacific/Port_Moresby',
  KIR: 'Europe/Dublin',
  KIS: 'Africa/Nairobi',
  KIT: 'Europe/Athens',
  KIU: 'Africa/Nairobi',
  KIV: 'Europe/Chisinau',
  KIW: 'Africa/Lusaka',
  KIX: 'Asia/Tokyo',
  KIY: 'Africa/Dar_es_Salaam',
  KIZ: 'Pacific/Port_Moresby',
  KJA: 'Asia/Krasnoyarsk',
  KJH: 'Asia/Shanghai',
  KJI: 'Asia/Urumqi',
  KJK: 'Europe/Brussels',
  KJP: 'Asia/Tokyo',
  KJT: 'Asia/Jakarta',
  KJU: 'Pacific/Port_Moresby',
  KJX: 'Asia/Jakarta',
  KKA: 'America/Nome',
  KKB: 'America/Anchorage',
  KKC: 'Asia/Bangkok',
  KKD: 'Pacific/Port_Moresby',
  KKE: 'Pacific/Auckland',
  KKG: 'America/Guyana',
  KKH: 'America/Nome',
  KKI: 'America/Anchorage',
  KKJ: 'Asia/Tokyo',
  KKK: 'America/Anchorage',
  KKL: 'America/Anchorage',
  KKM: 'Asia/Bangkok',
  KKN: 'Europe/Oslo',
  KKO: 'Pacific/Auckland',
  KKP: 'Australia/Brisbane',
  KKQ: 'Asia/Yekaterinburg',
  KKR: 'Pacific/Tahiti',
  KKS: 'Asia/Tehran',
  KKT: 'America/Chicago',
  KKU: 'America/Anchorage',
  KKW: 'Africa/Kinshasa',
  KKX: 'Asia/Tokyo',
  KKY: 'Europe/Dublin',
  KKZ: 'Asia/Phnom_Penh',
  KLB: 'Africa/Lusaka',
  KLC: 'Africa/Dakar',
  KLD: 'Europe/Moscow',
  KLE: 'Africa/Douala',
  KLF: 'Europe/Moscow',
  KLG: 'America/Anchorage',
  KLH: 'Asia/Kolkata',
  KLI: 'Africa/Kinshasa',
  KLK: 'Africa/Nairobi',
  KLL: 'America/Anchorage',
  KLM: 'Asia/Tehran',
  KLN: 'America/Anchorage',
  KLO: 'Asia/Manila',
  KLP: 'Asia/Pontianak',
  KLQ: 'Asia/Pontianak',
  KLR: 'Europe/Stockholm',
  KLS: 'America/Los_Angeles',
  KLU: 'Europe/Vienna',
  KLV: 'Europe/Prague',
  KLW: 'America/Juneau',
  KLX: 'Europe/Athens',
  KLY: 'Africa/Lubumbashi',
  KLZ: 'Africa/Johannesburg',
  KMA: 'Pacific/Port_Moresby',
  KMB: 'Pacific/Port_Moresby',
  KMC: 'Asia/Riyadh',
  KME: 'Africa/Kigali',
  KMF: 'Pacific/Port_Moresby',
  KMG: 'Asia/Shanghai',
  KMH: 'Africa/Johannesburg',
  KMI: 'Asia/Tokyo',
  KMJ: 'Asia/Tokyo',
  KMK: 'Africa/Brazzaville',
  KML: 'Australia/Brisbane',
  KMM: 'Asia/Jayapura',
  KMN: 'Africa/Lubumbashi',
  KMO: 'America/Anchorage',
  KMP: 'Africa/Windhoek',
  KMQ: 'Asia/Tokyo',
  KMR: 'Pacific/Port_Moresby',
  KMS: 'Africa/Accra',
  KMT: 'Asia/Phnom_Penh',
  KMU: 'Africa/Mogadishu',
  KMV: 'Asia/Yangon',
  KMW: 'Europe/Moscow',
  KMX: 'Asia/Riyadh',
  KMY: 'America/Anchorage',
  KMZ: 'Africa/Lusaka',
  KNA: 'America/Santiago',
  KNB: 'America/Denver',
  KND: 'Africa/Lubumbashi',
  KNE: 'Pacific/Port_Moresby',
  KNF: 'Europe/London',
  KNG: 'Asia/Jayapura',
  KNH: 'Asia/Taipei',
  KNI: 'Australia/Perth',
  KNJ: 'Africa/Brazzaville',
  KNK: 'America/Anchorage',
  KNL: 'Pacific/Port_Moresby',
  KNM: 'Africa/Lubumbashi',
  KNN: 'Africa/Conakry',
  KNO: 'Asia/Jakarta',
  KNP: 'Africa/Luanda',
  KNQ: 'Pacific/Noumea',
  KNR: 'Asia/Tehran',
  KNS: 'Australia/Currie',
  KNT: 'America/Chicago',
  KNU: 'Asia/Kolkata',
  KNW: 'America/Anchorage',
  KNX: 'Australia/Perth',
  KNZ: 'Africa/Bamako',
  KOA: 'Pacific/Honolulu',
  KOC: 'Pacific/Noumea',
  KOD: 'Asia/Makassar',
  KOE: 'Asia/Makassar',
  KOF: 'Africa/Johannesburg',
  KOG: 'Asia/Vientiane',
  KOH: 'Australia/Brisbane',
  KOI: 'Europe/London',
  KOJ: 'Asia/Tokyo',
  KOK: 'Europe/Helsinki',
  KOL: 'Africa/Bangui',
  KOM: 'Pacific/Port_Moresby',
  KON: 'Asia/Ho_Chi_Minh',
  KOO: 'Africa/Lubumbashi',
  KOP: 'Asia/Bangkok',
  KOQ: 'Europe/Berlin',
  KOR: 'Pacific/Port_Moresby',
  KOS: 'Asia/Phnom_Penh',
  KOT: 'America/Nome',
  KOU: 'Africa/Libreville',
  KOV: 'Asia/Almaty',
  KOW: 'Asia/Shanghai',
  KOX: 'Asia/Jayapura',
  KOY: 'America/Anchorage',
  KOZ: 'America/Anchorage',
  KPA: 'Pacific/Port_Moresby',
  KPB: 'America/Metlakatla',
  KPC: 'America/Nome',
  KPE: 'Pacific/Port_Moresby',
  KPF: 'Pacific/Port_Moresby',
  KPG: 'America/Guyana',
  KPI: 'Asia/Kuching',
  KPL: 'Pacific/Port_Moresby',
  KPM: 'Pacific/Port_Moresby',
  KPN: 'America/Nome',
  KPO: 'Asia/Seoul',
  KPP: 'Australia/Brisbane',
  KPR: 'America/Anchorage',
  KPS: 'Australia/Sydney',
  KPT: 'America/Los_Angeles',
  KPV: 'America/Anchorage',
  KPW: 'Asia/Anadyr',
  KPY: 'America/Anchorage',
  KQA: 'America/Anchorage',
  KQH: 'Asia/Kolkata',
  KQL: 'Pacific/Port_Moresby',
  KQR: 'Australia/Perth',
  KQT: 'Asia/Dushanbe',
  KRA: 'Australia/Melbourne',
  KRB: 'Australia/Brisbane',
  KRC: 'Asia/Jakarta',
  KRD: 'Australia/Darwin',
  KRE: 'Africa/Bujumbura',
  KRF: 'Europe/Stockholm',
  KRG: 'America/Guyana',
  KRI: 'Pacific/Port_Moresby',
  KRJ: 'Pacific/Port_Moresby',
  KRK: 'Europe/Warsaw',
  KRL: 'Asia/Urumqi',
  KRM: 'America/Guyana',
  KRN: 'Europe/Stockholm',
  KRO: 'Asia/Yekaterinburg',
  KRP: 'Europe/Copenhagen',
  KRQ: 'Europe/Zaporozhye',
  KRR: 'Europe/Moscow',
  KRS: 'Europe/Oslo',
  KRT: 'Africa/Khartoum',
  KRU: 'Pacific/Port_Moresby',
  KRV: 'Africa/Nairobi',
  KRW: 'Asia/Ashgabat',
  KRX: 'Pacific/Port_Moresby',
  KRY: 'Asia/Urumqi',
  KRZ: 'Africa/Kinshasa',
  KSA: 'Pacific/Kosrae',
  KSB: 'Pacific/Port_Moresby',
  KSC: 'Europe/Bratislava',
  KSD: 'Europe/Stockholm',
  KSE: 'Africa/Kampala',
  KSF: 'Europe/Berlin',
  KSG: 'Pacific/Port_Moresby',
  KSH: 'Asia/Tehran',
  KSI: 'Africa/Conakry',
  KSJ: 'Europe/Athens',
  KSK: 'Europe/Stockholm',
  KSL: 'Africa/Khartoum',
  KSM: 'America/Nome',
  KSN: 'Asia/Qostanay',
  KSO: 'Europe/Athens',
  KSP: 'Pacific/Port_Moresby',
  KSQ: 'Asia/Samarkand',
  KSR: 'Asia/Makassar',
  KSS: 'Africa/Bamako',
  KST: 'Africa/Khartoum',
  KSU: 'Europe/Oslo',
  KSV: 'Australia/Brisbane',
  KSW: 'Asia/Jerusalem',
  KSX: 'Pacific/Port_Moresby',
  KSY: 'Europe/Istanbul',
  KSZ: 'Europe/Moscow',
  KTA: 'Australia/Perth',
  KTB: 'America/Metlakatla',
  KTC: 'Africa/Abidjan',
  KTD: 'Asia/Tokyo',
  KTE: 'Asia/Kuala_Lumpur',
  KTF: 'Pacific/Auckland',
  KTG: 'Asia/Pontianak',
  KTH: 'America/Anchorage',
  KTI: 'Asia/Phnom_Penh',
  KTJ: 'Africa/Nairobi',
  KTK: 'Pacific/Bougainville',
  KTL: 'Africa/Nairobi',
  KTM: 'Asia/Kathmandu',
  KTN: 'America/Sitka',
  KTO: 'America/Guyana',
  KTP: 'America/Jamaica',
  KTQ: 'Europe/Helsinki',
  KTR: 'Australia/Darwin',
  KTS: 'America/Nome',
  KTT: 'Europe/Helsinki',
  KTU: 'Asia/Kolkata',
  KTV: 'America/Caracas',
  KTW: 'Europe/Warsaw',
  KTX: 'Africa/Bamako',
  KTY: 'Asia/Colombo',
  KUA: 'Asia/Kuala_Lumpur',
  KUC: 'Pacific/Tarawa',
  KUD: 'Asia/Kuching',
  KUE: 'Pacific/Guadalcanal',
  KUF: 'Europe/Samara',
  KUG: 'Australia/Brisbane',
  KUH: 'Asia/Tokyo',
  KUK: 'America/Nome',
  KUL: 'Asia/Kuala_Lumpur',
  KUM: 'Asia/Tokyo',
  KUN: 'Europe/Vilnius',
  KUO: 'Europe/Helsinki',
  KUP: 'Pacific/Port_Moresby',
  KUQ: 'Pacific/Port_Moresby',
  KUR: 'Asia/Kabul',
  KUS: 'America/Godthab',
  KUT: 'Asia/Tbilisi',
  KUU: 'Asia/Kolkata',
  KUV: 'Asia/Seoul',
  KUX: 'Pacific/Port_Moresby',
  KUY: 'Pacific/Port_Moresby',
  KVA: 'Europe/Athens',
  KVB: 'Europe/Stockholm',
  KVC: 'America/Nome',
  KVD: 'Asia/Baku',
  KVE: 'Pacific/Port_Moresby',
  KVG: 'Pacific/Port_Moresby',
  KVK: 'Europe/Moscow',
  KVL: 'America/Nome',
  KVM: 'Asia/Anadyr',
  KVR: 'Asia/Vladivostok',
  KVU: 'Pacific/Fiji',
  KVX: 'Europe/Kirov',
  KWA: 'Pacific/Kwajalein',
  KWB: 'Asia/Jakarta',
  KWD: 'Africa/Bangui',
  KWE: 'Asia/Shanghai',
  KWF: 'America/Juneau',
  KWG: 'Europe/Zaporozhye',
  KWH: 'Asia/Kabul',
  KWI: 'Asia/Kuwait',
  KWJ: 'Asia/Seoul',
  KWK: 'America/Nome',
  KWL: 'Asia/Shanghai',
  KWM: 'Australia/Brisbane',
  KWN: 'America/Anchorage',
  KWO: 'Pacific/Port_Moresby',
  KWP: 'America/Anchorage',
  KWR: 'Pacific/Guadalcanal',
  KWS: 'Pacific/Guadalcanal',
  KWT: 'America/Anchorage',
  KWV: 'Pacific/Port_Moresby',
  KWX: 'Pacific/Port_Moresby',
  KWY: 'Africa/Nairobi',
  KWZ: 'Africa/Lubumbashi',
  KXA: 'America/Juneau',
  KXD: 'Asia/Yekaterinburg',
  KXE: 'Africa/Johannesburg',
  KXF: 'Pacific/Fiji',
  KXK: 'Asia/Vladivostok',
  KXR: 'Pacific/Bougainville',
  KXU: 'Pacific/Tahiti',
  KYA: 'Europe/Istanbul',
  KYD: 'Asia/Taipei',
  KYE: 'Asia/Beirut',
  KYF: 'Australia/Perth',
  KYI: 'Australia/Adelaide',
  KYK: 'America/Anchorage',
  KYO: 'America/New_York',
  KYP: 'Asia/Yangon',
  KYS: 'Africa/Bamako',
  KYT: 'Asia/Yangon',
  KYU: 'America/Anchorage',
  KYX: 'Pacific/Port_Moresby',
  KYZ: 'Asia/Krasnoyarsk',
  KZB: 'America/Anchorage',
  KZC: 'Asia/Phnom_Penh',
  KZD: 'Asia/Phnom_Penh',
  KZF: 'Pacific/Port_Moresby',
  KZG: 'Europe/Berlin',
  KZI: 'Europe/Athens',
  KZN: 'Europe/Moscow',
  KZO: 'Asia/Qyzylorda',
  KZR: 'Europe/Istanbul',
  KZS: 'Europe/Athens',
  LAA: 'America/Denver',
  LAB: 'Pacific/Port_Moresby',
  LAC: 'Asia/Kuching',
  LAD: 'Africa/Luanda',
  LAE: 'Pacific/Port_Moresby',
  LAF: 'America/Indiana/Indianapolis',
  LAH: 'Asia/Jayapura',
  LAI: 'Europe/Paris',
  LAJ: 'America/Sao_Paulo',
  LAK: 'America/Yellowknife',
  LAL: 'America/New_York',
  LAM: 'America/Denver',
  LAN: 'America/Detroit',
  LAO: 'Asia/Manila',
  LAP: 'America/Mazatlan',
  LAQ: 'Africa/Tripoli',
  LAR: 'America/Denver',
  LAS: 'America/Los_Angeles',
  LAU: 'Africa/Nairobi',
  LAW: 'America/Chicago',
  LAX: 'America/Los_Angeles',
  LAY: 'Africa/Johannesburg',
  LAZ: 'America/Bahia',
  LBA: 'Europe/London',
  LBB: 'America/Chicago',
  LBC: 'Europe/Berlin',
  LBD: 'Asia/Dushanbe',
  LBE: 'America/New_York',
  LBF: 'America/Chicago',
  LBG: 'Europe/Paris',
  LBH: 'Australia/Sydney',
  LBI: 'Europe/Paris',
  LBJ: 'Asia/Makassar',
  LBK: 'Africa/Nairobi',
  LBL: 'America/Chicago',
  LBM: 'Africa/Maputo',
  LBN: 'Africa/Nairobi',
  LBO: 'Africa/Lubumbashi',
  LBP: 'Asia/Kuching',
  LBQ: 'Africa/Libreville',
  LBR: 'America/Manaus',
  LBS: 'Pacific/Fiji',
  LBT: 'America/New_York',
  LBU: 'Asia/Kuching',
  LBV: 'Africa/Libreville',
  LBW: 'Asia/Makassar',
  LBX: 'Asia/Manila',
  LBY: 'Europe/Paris',
  LBZ: 'Africa/Luanda',
  LCA: 'Asia/Nicosia',
  LCB: 'America/Cuiaba',
  LCC: 'Europe/Rome',
  LCD: 'Africa/Johannesburg',
  LCE: 'America/Tegucigalpa',
  LCF: 'America/Guatemala',
  LCG: 'Europe/Madrid',
  LCH: 'America/Chicago',
  LCI: 'America/New_York',
  LCJ: 'Europe/Warsaw',
  LCK: 'America/New_York',
  LCL: 'America/Havana',
  LCM: 'America/Argentina/Cordoba',
  LCN: 'Australia/Adelaide',
  LCO: 'Africa/Brazzaville',
  LCP: 'America/Argentina/Salta',
  LCQ: 'America/New_York',
  LCR: 'America/Bogota',
  LCV: 'Europe/Rome',
  LCX: 'Asia/Shanghai',
  LCY: 'Europe/London',
  LDA: 'Asia/Kolkata',
  LDB: 'America/Sao_Paulo',
  LDC: 'Australia/Lindeman',
  LDE: 'Europe/Paris',
  LDG: 'Europe/Moscow',
  LDH: 'Australia/Lord_Howe',
  LDI: 'Africa/Dar_es_Salaam',
  LDJ: 'America/New_York',
  LDK: 'Europe/Stockholm',
  LDM: 'America/Detroit',
  LDN: 'Asia/Kathmandu',
  LDO: 'America/Paramaribo',
  LDR: 'Asia/Aden',
  LDS: 'Asia/Shanghai',
  LDU: 'Asia/Kuching',
  LDV: 'Europe/Paris',
  LDW: 'Australia/Perth',
  LDX: 'America/Cayenne',
  LDY: 'Europe/London',
  LDZ: 'Africa/Johannesburg',
  LEA: 'Australia/Perth',
  LEB: 'America/New_York',
  LEC: 'America/Bahia',
  LED: 'Europe/Moscow',
  LEE: 'America/New_York',
  LEF: 'Africa/Maseru',
  LEG: 'Africa/Nouakchott',
  LEH: 'Europe/Paris',
  LEI: 'Europe/Madrid',
  LEJ: 'Europe/Berlin',
  LEK: 'Africa/Conakry',
  LEL: 'Australia/Darwin',
  LEM: 'America/Denver',
  LEN: 'Europe/Madrid',
  LEO: 'Africa/Libreville',
  LEP: 'America/Sao_Paulo',
  LEQ: 'Europe/London',
  LER: 'Australia/Perth',
  LES: 'Africa/Maseru',
  LET: 'America/Bogota',
  LEU: 'Europe/Madrid',
  LEV: 'Pacific/Fiji',
  LEW: 'America/New_York',
  LEX: 'America/New_York',
  LEY: 'Europe/Amsterdam',
  LEZ: 'America/Tegucigalpa',
  LFB: 'Africa/Maputo',
  LFI: 'America/New_York',
  LFK: 'America/Chicago',
  LFM: 'Asia/Tehran',
  LFN: 'America/New_York',
  LFO: 'Africa/Addis_Ababa',
  LFP: 'Australia/Brisbane',
  LFQ: 'Asia/Shanghai',
  LFR: 'America/Caracas',
  LFT: 'America/Chicago',
  LFW: 'Africa/Lome',
  LGA: 'America/New_York',
  LGB: 'America/Los_Angeles',
  LGC: 'America/New_York',
  LGD: 'America/Los_Angeles',
  LGE: 'Australia/Perth',
  LGF: 'America/Phoenix',
  LGG: 'Europe/Brussels',
  LGH: 'Australia/Adelaide',
  LGI: 'America/Nassau',
  LGK: 'Asia/Kuala_Lumpur',
  LGL: 'Asia/Kuching',
  LGM: 'Pacific/Port_Moresby',
  LGN: 'Pacific/Port_Moresby',
  LGO: 'Europe/Berlin',
  LGP: 'Asia/Manila',
  LGQ: 'America/Guayaquil',
  LGR: 'America/Santiago',
  LGS: 'America/Argentina/Mendoza',
  LGT: 'America/Bogota',
  LGU: 'America/Denver',
  LGW: 'Europe/London',
  LGX: 'Africa/Mogadishu',
  LGY: 'America/Caracas',
  LHA: 'Europe/Berlin',
  LHE: 'Asia/Karachi',
  LHG: 'Australia/Sydney',
  LHI: 'Asia/Jayapura',
  LHK: 'Asia/Shanghai',
  LHP: 'Pacific/Bougainville',
  LHR: 'Europe/London',
  LHS: 'America/Argentina/Rio_Gallegos',
  LHU: 'Africa/Windhoek',
  LHV: 'America/New_York',
  LHW: 'Asia/Shanghai',
  LIA: 'Asia/Shanghai',
  LIB: 'Australia/Darwin',
  LIC: 'America/Denver',
  LIE: 'Africa/Kinshasa',
  LIF: 'Pacific/Noumea',
  LIG: 'Europe/Paris',
  LIH: 'Pacific/Honolulu',
  LII: 'Asia/Jayapura',
  LIK: 'Pacific/Kwajalein',
  LIL: 'Europe/Paris',
  LIM: 'America/Lima',
  LIN: 'Europe/Rome',
  LIO: 'America/Costa_Rica',
  LIP: 'America/Sao_Paulo',
  LIQ: 'Africa/Kinshasa',
  LIR: 'America/Costa_Rica',
  LIS: 'Europe/Lisbon',
  LIT: 'America/Chicago',
  LIV: 'America/Anchorage',
  LIW: 'Asia/Yangon',
  LIX: 'Africa/Blantyre',
  LIY: 'America/New_York',
  LIZ: 'America/New_York',
  LJA: 'Africa/Lubumbashi',
  LJG: 'Asia/Shanghai',
  LJN: 'America/Chicago',
  LJU: 'Europe/Ljubljana',
  LKA: 'Asia/Makassar',
  LKB: 'Pacific/Fiji',
  LKC: 'Africa/Brazzaville',
  LKD: 'Australia/Brisbane',
  LKE: 'America/Los_Angeles',
  LKG: 'Africa/Nairobi',
  LKH: 'Asia/Kuching',
  LKK: 'America/Anchorage',
  LKL: 'Europe/Oslo',
  LKN: 'Europe/Oslo',
  LKO: 'Asia/Kolkata',
  LKP: 'America/New_York',
  LKR: 'Africa/Mogadishu',
  LKU: 'Africa/Nairobi',
  LKV: 'America/Los_Angeles',
  LKW: 'Asia/Muscat',
  LKY: 'Africa/Dar_es_Salaam',
  LKZ: 'Europe/London',
  LLA: 'Europe/Stockholm',
  LLB: 'Asia/Shanghai',
  LLC: 'Asia/Manila',
  LLE: 'Africa/Johannesburg',
  LLF: 'Asia/Shanghai',
  LLG: 'Australia/Brisbane',
  LLH: 'America/Tegucigalpa',
  LLI: 'Africa/Addis_Ababa',
  LLJ: 'Asia/Dhaka',
  LLK: 'Asia/Baku',
  LLL: 'Australia/Perth',
  LLM: 'Pacific/Guadalcanal',
  LLN: 'Asia/Jayapura',
  LLO: 'Asia/Makassar',
  LLP: 'Australia/Brisbane',
  LLS: 'America/Argentina/Cordoba',
  LLT: 'Africa/Luanda',
  LLV: 'Asia/Shanghai',
  LLW: 'Africa/Blantyre',
  LLX: 'America/New_York',
  LLY: 'America/New_York',
  LMA: 'America/Anchorage',
  LMB: 'Africa/Blantyre',
  LMC: 'America/Bogota',
  LMD: 'America/Argentina/Salta',
  LME: 'Europe/Paris',
  LMG: 'Pacific/Port_Moresby',
  LMH: 'America/Tegucigalpa',
  LMI: 'Pacific/Port_Moresby',
  LML: 'Pacific/Kwajalein',
  LMM: 'America/Mazatlan',
  LMN: 'Asia/Kuching',
  LMO: 'Europe/London',
  LMP: 'Europe/Rome',
  LMQ: 'Africa/Tripoli',
  LMR: 'Africa/Johannesburg',
  LMS: 'America/Chicago',
  LMT: 'America/Los_Angeles',
  LMU: 'Asia/Pontianak',
  LMX: 'America/Bogota',
  LMY: 'Pacific/Port_Moresby',
  LMZ: 'Africa/Maputo',
  LNA: 'America/New_York',
  LNB: 'Pacific/Efate',
  LNC: 'Pacific/Port_Moresby',
  LND: 'America/Denver',
  LNE: 'Pacific/Efate',
  LNF: 'Pacific/Port_Moresby',
  LNG: 'Pacific/Port_Moresby',
  LNH: 'Australia/Darwin',
  LNI: 'America/Anchorage',
  LNJ: 'Asia/Shanghai',
  LNK: 'America/Chicago',
  LNL: 'Asia/Shanghai',
  LNM: 'Pacific/Port_Moresby',
  LNN: 'America/New_York',
  LNO: 'Australia/Perth',
  LNP: 'America/New_York',
  LNQ: 'Pacific/Port_Moresby',
  LNR: 'America/Chicago',
  LNS: 'America/New_York',
  LNU: 'Asia/Makassar',
  LNV: 'Pacific/Port_Moresby',
  LNX: 'Europe/Moscow',
  LNY: 'Pacific/Honolulu',
  LNZ: 'Europe/Vienna',
  LOA: 'Australia/Brisbane',
  LOB: 'America/Santiago',
  LOC: 'Australia/Adelaide',
  LOD: 'Pacific/Efate',
  LOE: 'Asia/Bangkok',
  LOF: 'Pacific/Kwajalein',
  LOH: 'America/Guayaquil',
  LOI: 'America/Sao_Paulo',
  LOK: 'Africa/Nairobi',
  LOL: 'America/Los_Angeles',
  LOM: 'America/Mexico_City',
  LON: 'Europe/London',
  LOO: 'Africa/Algiers',
  LOP: 'Asia/Makassar',
  LOQ: 'Africa/Gaborone',
  LOS: 'Africa/Lagos',
  LOT: 'America/Chicago',
  LOU: 'America/Kentucky/Louisville',
  LOV: 'America/Monterrey',
  LOW: 'America/New_York',
  LOX: 'America/Guatemala',
  LOY: 'Africa/Nairobi',
  LOZ: 'America/New_York',
  LPA: 'Atlantic/Canary',
  LPB: 'America/La_Paz',
  LPC: 'America/Los_Angeles',
  LPD: 'America/Bogota',
  LPE: 'America/Bogota',
  LPF: 'Asia/Shanghai',
  LPG: 'America/Argentina/Buenos_Aires',
  LPI: 'Europe/Stockholm',
  LPJ: 'America/Caracas',
  LPK: 'Europe/Moscow',
  LPL: 'Europe/London',
  LPM: 'Pacific/Efate',
  LPN: 'Pacific/Port_Moresby',
  LPO: 'America/Chicago',
  LPP: 'Europe/Helsinki',
  LPQ: 'Asia/Vientiane',
  LPS: 'America/Los_Angeles',
  LPT: 'Asia/Bangkok',
  LPU: 'Asia/Makassar',
  LPX: 'Europe/Riga',
  LPY: 'Europe/Paris',
  LQK: 'America/New_York',
  LQM: 'America/Bogota',
  LQN: 'Asia/Kabul',
  LRA: 'Europe/Athens',
  LRB: 'Africa/Maseru',
  LRD: 'America/Chicago',
  LRE: 'Australia/Brisbane',
  LRF: 'America/Chicago',
  LRG: 'Asia/Karachi',
  LRH: 'Europe/Paris',
  LRI: 'America/Bogota',
  LRJ: 'America/Chicago',
  LRL: 'Africa/Lome',
  LRM: 'America/Santo_Domingo',
  LRQ: 'America/Winnipeg',
  LRR: 'Asia/Tehran',
  LRS: 'Europe/Athens',
  LRT: 'Europe/Paris',
  LRU: 'America/Denver',
  LRV: 'America/Caracas',
  LSA: 'Pacific/Port_Moresby',
  LSB: 'America/Denver',
  LSC: 'America/Santiago',
  LSE: 'America/Chicago',
  LSF: 'America/New_York',
  LSH: 'Asia/Yangon',
  LSI: 'Europe/London',
  LSJ: 'Pacific/Port_Moresby',
  LSK: 'America/Denver',
  LSL: 'America/Costa_Rica',
  LSM: 'Asia/Kuching',
  LSN: 'America/Los_Angeles',
  LSO: 'Europe/Paris',
  LSP: 'America/Caracas',
  LSQ: 'America/Santiago',
  LSS: 'America/Guadeloupe',
  LST: 'Australia/Hobart',
  LSU: 'Asia/Kuching',
  LSV: 'America/Los_Angeles',
  LSW: 'Asia/Jakarta',
  LSX: 'Asia/Jakarta',
  LSY: 'Australia/Sydney',
  LSZ: 'Europe/Zagreb',
  LTA: 'Africa/Johannesburg',
  LTB: 'Australia/Hobart',
  LTC: 'Africa/Ndjamena',
  LTD: 'Africa/Tripoli',
  LTF: 'Pacific/Port_Moresby',
  LTG: 'Asia/Kathmandu',
  LTI: 'Asia/Hovd',
  LTK: 'Asia/Damascus',
  LTL: 'Africa/Libreville',
  LTM: 'America/Guyana',
  LTN: 'Europe/London',
  LTO: 'America/Hermosillo',
  LTP: 'Australia/Brisbane',
  LTQ: 'Europe/Paris',
  LTR: 'Europe/Dublin',
  LTS: 'America/Chicago',
  LTT: 'Europe/Paris',
  LTU: 'Asia/Kolkata',
  LTV: 'Australia/Brisbane',
  LTW: 'America/New_York',
  LTX: 'America/Guayaquil',
  LUA: 'Asia/Kathmandu',
  LUB: 'America/Guyana',
  LUC: 'Pacific/Fiji',
  LUD: 'Africa/Windhoek',
  LUE: 'Europe/Bratislava',
  LUF: 'America/Phoenix',
  LUG: 'Europe/Zurich',
  LUH: 'Asia/Kolkata',
  LUI: 'America/Tegucigalpa',
  LUK: 'America/New_York',
  LUL: 'America/Chicago',
  LUM: 'Asia/Shanghai',
  LUN: 'Africa/Lusaka',
  LUO: 'Africa/Luanda',
  LUP: 'Pacific/Honolulu',
  LUQ: 'America/Argentina/San_Luis',
  LUR: 'America/Nome',
  LUS: 'Africa/Kinshasa',
  LUT: 'Australia/Brisbane',
  LUU: 'Australia/Brisbane',
  LUV: 'Asia/Jayapura',
  LUW: 'Asia/Makassar',
  LUX: 'Europe/Luxembourg',
  LUZ: 'Europe/Warsaw',
  LVA: 'Europe/Paris',
  LVB: 'America/Sao_Paulo',
  LVD: 'America/Anchorage',
  LVI: 'Africa/Lusaka',
  LVK: 'America/Los_Angeles',
  LVL: 'America/New_York',
  LVM: 'America/Denver',
  LVO: 'Australia/Perth',
  LVP: 'Asia/Tehran',
  LVR: 'America/Cuiaba',
  LVS: 'America/Denver',
  LWA: 'Asia/Manila',
  LWB: 'America/New_York',
  LWC: 'America/Chicago',
  LWE: 'Asia/Makassar',
  LWH: 'Australia/Brisbane',
  LWI: 'Pacific/Port_Moresby',
  LWK: 'Europe/London',
  LWL: 'America/Los_Angeles',
  LWM: 'America/New_York',
  LWN: 'Asia/Yerevan',
  LWO: 'Europe/Uzhgorod',
  LWR: 'Europe/Amsterdam',
  LWS: 'America/Los_Angeles',
  LWT: 'America/Denver',
  LWV: 'America/Chicago',
  LWY: 'Asia/Kuching',
  LXA: 'Asia/Urumqi',
  LXG: 'Asia/Vientiane',
  LXN: 'America/Chicago',
  LXR: 'Africa/Cairo',
  LXS: 'Europe/Athens',
  LXU: 'Africa/Lusaka',
  LXV: 'America/Denver',
  LYA: 'Asia/Shanghai',
  LYB: 'America/Cayman',
  LYC: 'Europe/Stockholm',
  LYE: 'Europe/London',
  LYG: 'Asia/Shanghai',
  LYH: 'America/New_York',
  LYI: 'Asia/Shanghai',
  LYK: 'Asia/Makassar',
  LYN: 'Europe/Paris',
  LYO: 'America/Chicago',
  LYP: 'Asia/Karachi',
  LYR: 'Arctic/Longyearbyen',
  LYS: 'Europe/Paris',
  LYT: 'Australia/Brisbane',
  LYU: 'America/Chicago',
  LYX: 'Europe/London',
  LZA: 'Africa/Lubumbashi',
  LZC: 'America/Mexico_City',
  LZH: 'Asia/Shanghai',
  LZI: 'Africa/Kinshasa',
  LZM: 'Africa/Luanda',
  LZN: 'Asia/Taipei',
  LZO: 'Asia/Shanghai',
  LZR: 'Australia/Lindeman',
  LZU: 'America/New_York',
  LZY: 'Asia/Urumqi',
  MAA: 'Asia/Kolkata',
  MAB: 'America/Araguaina',
  MAC: 'America/New_York',
  MAD: 'Europe/Madrid',
  MAE: 'America/Los_Angeles',
  MAF: 'America/Chicago',
  MAG: 'Pacific/Port_Moresby',
  MAH: 'Europe/Madrid',
  MAI: 'Africa/Blantyre',
  MAJ: 'Pacific/Majuro',
  MAK: 'Africa/Juba',
  MAL: 'Asia/Jayapura',
  MAM: 'America/Matamoros',
  MAN: 'Europe/London',
  MAO: 'America/Manaus',
  MAP: 'Pacific/Port_Moresby',
  MAQ: 'Asia/Bangkok',
  MAR: 'America/Caracas',
  MAS: 'Pacific/Port_Moresby',
  MAT: 'Africa/Kinshasa',
  MAU: 'Pacific/Tahiti',
  MAV: 'Pacific/Majuro',
  MAW: 'America/Chicago',
  MAX: 'Africa/Dakar',
  MAY: 'America/Nassau',
  MAZ: 'America/Puerto_Rico',
  MBA: 'Africa/Nairobi',
  MBB: 'Australia/Perth',
  MBC: 'Africa/Libreville',
  MBD: 'Africa/Johannesburg',
  MBE: 'Asia/Tokyo',
  MBF: 'Australia/Melbourne',
  MBG: 'America/Chicago',
  MBH: 'Australia/Brisbane',
  MBI: 'Africa/Dar_es_Salaam',
  MBJ: 'America/Jamaica',
  MBK: 'America/Cuiaba',
  MBL: 'America/Detroit',
  MBM: 'Africa/Johannesburg',
  MBN: 'Australia/Perth',
  MBO: 'Asia/Manila',
  MBP: 'America/Lima',
  MBQ: 'Africa/Kampala',
  MBR: 'Africa/Nouakchott',
  MBS: 'America/Detroit',
  MBT: 'Asia/Manila',
  MBU: 'Pacific/Guadalcanal',
  MBV: 'Pacific/Port_Moresby',
  MBW: 'Australia/Melbourne',
  MBX: 'Europe/Ljubljana',
  MBY: 'America/Chicago',
  MBZ: 'America/Manaus',
  MCA: 'Africa/Conakry',
  MCB: 'America/Chicago',
  MCC: 'America/Los_Angeles',
  MCD: 'America/Detroit',
  MCE: 'America/Los_Angeles',
  MCF: 'America/New_York',
  MCG: 'America/Anchorage',
  MCH: 'America/Guayaquil',
  MCI: 'America/Chicago',
  MCJ: 'America/Bogota',
  MCK: 'America/Chicago',
  MCL: 'America/Anchorage',
  MCN: 'America/New_York',
  MCO: 'America/New_York',
  MCP: 'America/Belem',
  MCQ: 'Europe/Budapest',
  MCS: 'America/Argentina/Cordoba',
  MCT: 'Asia/Muscat',
  MCU: 'Europe/Paris',
  MCV: 'Australia/Darwin',
  MCW: 'America/Chicago',
  MCX: 'Europe/Moscow',
  MCY: 'Australia/Brisbane',
  MCZ: 'America/Maceio',
  MDB: 'America/Belize',
  MDC: 'Asia/Makassar',
  MDD: 'America/Chicago',
  MDE: 'America/Bogota',
  MDF: 'America/Chicago',
  MDG: 'Asia/Shanghai',
  MDH: 'America/Chicago',
  MDI: 'Africa/Lagos',
  MDJ: 'America/Los_Angeles',
  MDK: 'Africa/Kinshasa',
  MDL: 'Asia/Yangon',
  MDM: 'Pacific/Port_Moresby',
  MDN: 'America/Indiana/Indianapolis',
  MDO: 'America/Anchorage',
  MDP: 'Asia/Jayapura',
  MDQ: 'America/Argentina/Buenos_Aires',
  MDR: 'America/Anchorage',
  MDS: 'America/Grand_Turk',
  MDT: 'America/New_York',
  MDU: 'Pacific/Port_Moresby',
  MDV: 'Africa/Libreville',
  MDW: 'America/Chicago',
  MDX: 'America/Argentina/Cordoba',
  MDY: 'Pacific/Midway',
  MDZ: 'America/Argentina/Mendoza',
  MEA: 'America/Sao_Paulo',
  MEB: 'Australia/Melbourne',
  MEC: 'America/Guayaquil',
  MED: 'Asia/Riyadh',
  MEE: 'Pacific/Noumea',
  MEF: 'Africa/Ndjamena',
  MEG: 'Africa/Luanda',
  MEH: 'Europe/Oslo',
  MEI: 'America/Chicago',
  MEJ: 'America/New_York',
  MEK: 'Africa/Casablanca',
  MEL: 'Australia/Melbourne',
  MEM: 'America/Chicago',
  MEN: 'Europe/Paris',
  MEO: 'America/New_York',
  MEP: 'Asia/Kuala_Lumpur',
  MEQ: 'Asia/Jakarta',
  MER: 'America/Los_Angeles',
  MES: 'Asia/Jakarta',
  MET: 'Australia/Brisbane',
  MEU: 'America/Santarem',
  MEV: 'America/Los_Angeles',
  MEW: 'Africa/Lubumbashi',
  MEX: 'America/Mexico_City',
  MEY: 'Asia/Kathmandu',
  MEZ: 'Africa/Johannesburg',
  MFA: 'Africa/Dar_es_Salaam',
  MFB: 'America/Bogota',
  MFC: 'Africa/Maseru',
  MFD: 'America/New_York',
  MFE: 'America/Chicago',
  MFF: 'Africa/Libreville',
  MFG: 'Asia/Karachi',
  MFH: 'America/Los_Angeles',
  MFI: 'America/Chicago',
  MFJ: 'Pacific/Fiji',
  MFK: 'Asia/Taipei',
  MFL: 'Australia/Brisbane',
  MFM: 'Asia/Macau',
  MFN: 'Pacific/Auckland',
  MFO: 'Pacific/Port_Moresby',
  MFP: 'Australia/Darwin',
  MFQ: 'Africa/Niamey',
  MFR: 'America/Los_Angeles',
  MFS: 'America/Bogota',
  MFU: 'Africa/Lusaka',
  MFV: 'America/New_York',
  MFW: 'Africa/Maputo',
  MFX: 'Europe/Paris',
  MFY: 'Asia/Aden',
  MFZ: 'Pacific/Port_Moresby',
  MGA: 'America/Managua',
  MGB: 'Australia/Adelaide',
  MGC: 'America/Chicago',
  MGD: 'America/La_Paz',
  MGE: 'America/New_York',
  MGF: 'America/Sao_Paulo',
  MGG: 'Pacific/Port_Moresby',
  MGH: 'Africa/Johannesburg',
  MGI: 'America/Chicago',
  MGJ: 'America/New_York',
  MGK: 'Asia/Yangon',
  MGL: 'Europe/Berlin',
  MGM: 'America/Chicago',
  MGN: 'America/Bogota',
  MGO: 'Africa/Libreville',
  MGP: 'Pacific/Port_Moresby',
  MGQ: 'Africa/Mogadishu',
  MGR: 'America/New_York',
  MGS: 'Pacific/Rarotonga',
  MGT: 'Australia/Darwin',
  MGU: 'Asia/Yangon',
  MGV: 'Australia/Perth',
  MGW: 'America/New_York',
  MGX: 'Africa/Libreville',
  MGY: 'America/New_York',
  MGZ: 'Asia/Yangon',
  MHA: 'America/Guyana',
  MHC: 'America/Santiago',
  MHD: 'Asia/Tehran',
  MHE: 'America/Chicago',
  MHF: 'America/Bogota',
  MHG: 'Europe/Berlin',
  MHH: 'America/Nassau',
  MHI: 'Africa/Djibouti',
  MHK: 'America/Chicago',
  MHL: 'America/Chicago',
  MHM: 'America/Anchorage',
  MHN: 'America/Denver',
  MHO: 'Australia/Perth',
  MHP: 'Europe/Minsk',
  MHQ: 'Europe/Mariehamn',
  MHR: 'America/Los_Angeles',
  MHS: 'America/Los_Angeles',
  MHT: 'America/New_York',
  MHU: 'Australia/Melbourne',
  MHV: 'America/Los_Angeles',
  MHW: 'America/La_Paz',
  MHX: 'Pacific/Rarotonga',
  MHY: 'Pacific/Port_Moresby',
  MHZ: 'Europe/London',
  MIA: 'America/New_York',
  MIB: 'America/Chicago',
  MIC: 'America/Chicago',
  MID: 'America/Merida',
  MIE: 'America/Indiana/Indianapolis',
  MIF: 'America/Chicago',
  MIG: 'Asia/Shanghai',
  MIH: 'Australia/Perth',
  MII: 'America/Sao_Paulo',
  MIJ: 'Pacific/Majuro',
  MIK: 'Europe/Helsinki',
  MIL: 'Europe/Rome',
  MIM: 'Australia/Sydney',
  MIN: 'Australia/Adelaide',
  MIO: 'America/Chicago',
  MIP: 'Asia/Jerusalem',
  MIQ: 'America/Chicago',
  MIR: 'Africa/Tunis',
  MIS: 'Pacific/Port_Moresby',
  MIT: 'America/Los_Angeles',
  MIU: 'Africa/Lagos',
  MIV: 'America/New_York',
  MIW: 'America/Chicago',
  MIX: 'America/Bogota',
  MIY: 'Australia/Darwin',
  MIZ: 'Australia/Darwin',
  MJA: 'Indian/Antananarivo',
  MJB: 'Pacific/Majuro',
  MJC: 'Africa/Abidjan',
  MJD: 'Asia/Karachi',
  MJE: 'Pacific/Majuro',
  MJF: 'Europe/Oslo',
  MJI: 'Africa/Tripoli',
  MJJ: 'Pacific/Port_Moresby',
  MJK: 'Australia/Perth',
  MJL: 'Africa/Libreville',
  MJM: 'Africa/Lubumbashi',
  MJN: 'Indian/Antananarivo',
  MJO: 'Africa/Windhoek',
  MJP: 'Australia/Perth',
  MJQ: 'America/Chicago',
  MJR: 'America/Argentina/Buenos_Aires',
  MJS: 'Africa/Maputo',
  MJT: 'Europe/Athens',
  MJU: 'Asia/Makassar',
  MJV: 'Europe/Madrid',
  MJW: 'Africa/Harare',
  MJX: 'America/New_York',
  MJZ: 'Asia/Yakutsk',
  MKA: 'Europe/Prague',
  MKB: 'Africa/Libreville',
  MKC: 'America/Chicago',
  MKE: 'America/Chicago',
  MKG: 'America/Detroit',
  MKH: 'Africa/Maseru',
  MKI: 'Africa/Bangui',
  MKJ: 'Africa/Brazzaville',
  MKK: 'Pacific/Honolulu',
  MKL: 'America/Chicago',
  MKM: 'Asia/Kuching',
  MKN: 'Pacific/Port_Moresby',
  MKO: 'America/Chicago',
  MKP: 'Pacific/Tahiti',
  MKQ: 'Asia/Jayapura',
  MKR: 'Australia/Perth',
  MKS: 'Africa/Addis_Ababa',
  MKT: 'America/Chicago',
  MKU: 'Africa/Libreville',
  MKV: 'Australia/Darwin',
  MKW: 'Asia/Jayapura',
  MKY: 'Australia/Brisbane',
  MKZ: 'Asia/Kuala_Lumpur',
  MLA: 'Europe/Malta',
  MLB: 'America/New_York',
  MLC: 'America/Chicago',
  MLD: 'America/Boise',
  MLE: 'Indian/Maldives',
  MLF: 'America/Denver',
  MLG: 'Asia/Jakarta',
  MLH: 'Europe/Paris',
  MLI: 'America/Chicago',
  MLJ: 'America/New_York',
  MLK: 'America/Denver',
  MLL: 'America/Nome',
  MLM: 'America/Mexico_City',
  MLN: 'Africa/Ceuta',
  MLO: 'Europe/Athens',
  MLP: 'Asia/Manila',
  MLQ: 'Pacific/Port_Moresby',
  MLR: 'Australia/Adelaide',
  MLS: 'America/Denver',
  MLT: 'America/New_York',
  MLU: 'America/Chicago',
  MLV: 'Australia/Brisbane',
  MLW: 'Africa/Monrovia',
  MLX: 'Europe/Istanbul',
  MLY: 'America/Anchorage',
  MLZ: 'America/Montevideo',
  MMA: 'Europe/Stockholm',
  MMB: 'Asia/Tokyo',
  MMC: 'America/Monterrey',
  MMD: 'Asia/Tokyo',
  MME: 'Europe/London',
  MMF: 'Africa/Douala',
  MMG: 'Australia/Perth',
  MMH: 'America/Los_Angeles',
  MMI: 'America/New_York',
  MMJ: 'Asia/Tokyo',
  MMK: 'Europe/Moscow',
  MML: 'America/Chicago',
  MMM: 'Australia/Brisbane',
  MMN: 'America/New_York',
  MMO: 'Atlantic/Cape_Verde',
  MMP: 'America/Bogota',
  MMQ: 'Africa/Lusaka',
  MMS: 'America/Chicago',
  MMT: 'America/New_York',
  MMU: 'America/New_York',
  MMV: 'Pacific/Port_Moresby',
  MMW: 'Africa/Maputo',
  MMX: 'Europe/Stockholm',
  MMY: 'Asia/Tokyo',
  MMZ: 'Asia/Kabul',
  MNA: 'Asia/Makassar',
  MNB: 'Africa/Kinshasa',
  MNC: 'Africa/Maputo',
  MND: 'America/Bogota',
  MNE: 'Australia/Adelaide',
  MNF: 'Pacific/Fiji',
  MNG: 'Australia/Darwin',
  MNH: 'Asia/Muscat',
  MNI: 'America/Montserrat',
  MNJ: 'Indian/Antananarivo',
  MNK: 'Pacific/Tarawa',
  MNL: 'Asia/Manila',
  MNM: 'America/Menominee',
  MNN: 'America/New_York',
  MNO: 'Africa/Lubumbashi',
  MNP: 'Pacific/Port_Moresby',
  MNQ: 'Australia/Brisbane',
  MNR: 'Africa/Lusaka',
  MNS: 'Africa/Lusaka',
  MNT: 'America/Anchorage',
  MNU: 'Asia/Yangon',
  MNV: 'Australia/Darwin',
  MNW: 'Australia/Darwin',
  MNX: 'America/Manaus',
  MNY: 'Pacific/Guadalcanal',
  MNZ: 'America/New_York',
  MOA: 'America/Havana',
  MOB: 'America/Chicago',
  MOC: 'America/Bahia',
  MOD: 'America/Los_Angeles',
  MOE: 'Asia/Yangon',
  MOF: 'Asia/Makassar',
  MOG: 'Asia/Yangon',
  MOH: 'Asia/Makassar',
  MOI: 'Pacific/Rarotonga',
  MOJ: 'America/Paramaribo',
  MOL: 'Europe/Oslo',
  MOM: 'Africa/Nouakchott',
  MON: 'Pacific/Auckland',
  MOO: 'Australia/Adelaide',
  MOP: 'America/Detroit',
  MOQ: 'Indian/Antananarivo',
  MOR: 'America/New_York',
  MOS: 'America/Nome',
  MOT: 'America/Chicago',
  MOU: 'America/Nome',
  MOV: 'Australia/Brisbane',
  MOW: 'Europe/Moscow',
  MOX: 'America/Chicago',
  MOY: 'America/Bogota',
  MOZ: 'Pacific/Tahiti',
  MPA: 'Africa/Windhoek',
  MPB: 'America/New_York',
  MPC: 'Asia/Jakarta',
  MPD: 'Asia/Karachi',
  MPF: 'Pacific/Port_Moresby',
  MPG: 'Pacific/Port_Moresby',
  MPH: 'Asia/Manila',
  MPI: 'America/Panama',
  MPJ: 'America/Chicago',
  MPL: 'Europe/Paris',
  MPM: 'Africa/Maputo',
  MPN: 'Atlantic/Stanley',
  MPO: 'America/New_York',
  MPP: 'America/Panama',
  MPQ: 'Asia/Amman',
  MPR: 'America/Chicago',
  MPS: 'America/Chicago',
  MPT: 'Asia/Dili',
  MPU: 'Pacific/Port_Moresby',
  MPV: 'America/New_York',
  MPW: 'Europe/Zaporozhye',
  MPX: 'Pacific/Port_Moresby',
  MPY: 'America/Cayenne',
  MPZ: 'America/Chicago',
  MQA: 'Australia/Perth',
  MQB: 'America/Chicago',
  MQC: 'America/Miquelon',
  MQD: 'America/Argentina/Salta',
  MQE: 'Australia/Darwin',
  MQF: 'Asia/Yekaterinburg',
  MQG: 'Africa/Windhoek',
  MQH: 'America/Sao_Paulo',
  MQJ: 'Asia/Magadan',
  MQK: 'America/La_Paz',
  MQL: 'Australia/Melbourne',
  MQM: 'Europe/Istanbul',
  MQN: 'Europe/Oslo',
  MQO: 'Pacific/Port_Moresby',
  MQP: 'Africa/Johannesburg',
  MQQ: 'Africa/Ndjamena',
  MQR: 'America/Bogota',
  MQS: 'America/St_Vincent',
  MQT: 'America/Detroit',
  MQU: 'America/Bogota',
  MQV: 'Africa/Algiers',
  MQW: 'America/New_York',
  MQX: 'Africa/Addis_Ababa',
  MQY: 'America/Chicago',
  MQZ: 'Australia/Perth',
  MRA: 'Africa/Tripoli',
  MRB: 'America/New_York',
  MRC: 'America/Chicago',
  MRD: 'America/Caracas',
  MRE: 'Africa/Nairobi',
  MRF: 'America/Chicago',
  MRG: 'Australia/Brisbane',
  MRH: 'Pacific/Port_Moresby',
  MRI: 'America/Anchorage',
  MRJ: 'America/Tegucigalpa',
  MRK: 'America/New_York',
  MRL: 'Australia/Brisbane',
  MRM: 'Pacific/Port_Moresby',
  MRN: 'America/New_York',
  MRO: 'Pacific/Auckland',
  MRP: 'Australia/Adelaide',
  MRQ: 'Asia/Manila',
  MRR: 'America/Guayaquil',
  MRS: 'Europe/Paris',
  MRT: 'Australia/Darwin',
  MRU: 'Indian/Mauritius',
  MRV: 'Europe/Moscow',
  MRW: 'Europe/Copenhagen',
  MRX: 'Asia/Tehran',
  MRY: 'America/Los_Angeles',
  MRZ: 'Australia/Sydney',
  MSA: 'America/Winnipeg',
  MSC: 'America/Phoenix',
  MSD: 'America/Denver',
  MSE: 'Europe/London',
  MSF: 'Australia/Darwin',
  MSG: 'Africa/Maseru',
  MSH: 'Asia/Muscat',
  MSI: 'Asia/Pontianak',
  MSJ: 'Asia/Tokyo',
  MSL: 'America/Chicago',
  MSM: 'Africa/Kinshasa',
  MSN: 'America/Chicago',
  MSO: 'America/Denver',
  MSP: 'America/Chicago',
  MSQ: 'Europe/Minsk',
  MSR: 'Europe/Istanbul',
  MSS: 'America/New_York',
  MST: 'Europe/Amsterdam',
  MSU: 'Africa/Maseru',
  MSV: 'America/New_York',
  MSW: 'Africa/Asmara',
  MSX: 'Africa/Brazzaville',
  MSY: 'America/Chicago',
  MSZ: 'Africa/Luanda',
  MTA: 'Pacific/Auckland',
  MTB: 'America/Bogota',
  MTC: 'America/Detroit',
  MTD: 'Australia/Darwin',
  MTE: 'America/Santarem',
  MTF: 'Africa/Addis_Ababa',
  MTG: 'America/Cuiaba',
  MTH: 'America/New_York',
  MTI: 'Atlantic/Cape_Verde',
  MTJ: 'America/Denver',
  MTK: 'Pacific/Tarawa',
  MTL: 'Australia/Sydney',
  MTM: 'America/Metlakatla',
  MTN: 'America/New_York',
  MTO: 'America/Chicago',
  MTP: 'America/New_York',
  MTQ: 'Australia/Brisbane',
  MTR: 'America/Bogota',
  MTS: 'Africa/Mbabane',
  MTT: 'America/Mexico_City',
  MTU: 'Africa/Maputo',
  MTV: 'Pacific/Efate',
  MTW: 'America/Chicago',
  MTX: 'America/Anchorage',
  MTY: 'America/Monterrey',
  MTZ: 'Asia/Jerusalem',
  MUA: 'Pacific/Guadalcanal',
  MUB: 'Africa/Gaborone',
  MUC: 'Europe/Berlin',
  MUD: 'Africa/Maputo',
  MUE: 'Pacific/Honolulu',
  MUF: 'Asia/Jayapura',
  MUG: 'America/Mazatlan',
  MUH: 'Africa/Cairo',
  MUI: 'America/New_York',
  MUJ: 'Africa/Addis_Ababa',
  MUK: 'Pacific/Rarotonga',
  MUL: 'America/New_York',
  MUN: 'America/Caracas',
  MUO: 'America/Boise',
  MUP: 'Australia/Darwin',
  MUQ: 'Australia/Perth',
  MUR: 'Asia/Kuching',
  MUS: 'Asia/Tokyo',
  MUT: 'America/Chicago',
  MUW: 'Africa/Algiers',
  MUX: 'Asia/Karachi',
  MUY: 'Africa/Brazzaville',
  MUZ: 'Africa/Dar_es_Salaam',
  MVA: 'Atlantic/Reykjavik',
  MVB: 'Africa/Libreville',
  MVC: 'America/Chicago',
  MVD: 'America/Montevideo',
  MVE: 'America/Chicago',
  MVF: 'America/Fortaleza',
  MVG: 'Africa/Libreville',
  MVH: 'Australia/Sydney',
  MVI: 'Pacific/Port_Moresby',
  MVK: 'Australia/Adelaide',
  MVL: 'America/New_York',
  MVM: 'America/Denver',
  MVN: 'America/Chicago',
  MVO: 'Africa/Ndjamena',
  MVP: 'America/Bogota',
  MVQ: 'Europe/Minsk',
  MVR: 'Africa/Douala',
  MVS: 'America/Bahia',
  MVT: 'Pacific/Tahiti',
  MVU: 'Australia/Brisbane',
  MVV: 'Europe/Paris',
  MVW: 'America/Los_Angeles',
  MVX: 'Africa/Libreville',
  MVY: 'America/New_York',
  MVZ: 'Africa/Harare',
  MWA: 'America/Chicago',
  MWB: 'Australia/Perth',
  MWC: 'America/Chicago',
  MWD: 'Asia/Karachi',
  MWE: 'Africa/Khartoum',
  MWF: 'Pacific/Efate',
  MWG: 'Pacific/Port_Moresby',
  MWH: 'America/Los_Angeles',
  MWI: 'Pacific/Port_Moresby',
  MWJ: 'America/Guyana',
  MWK: 'Asia/Jakarta',
  MWL: 'America/Chicago',
  MWM: 'America/Chicago',
  MWN: 'Africa/Dar_es_Salaam',
  MWO: 'America/New_York',
  MWQ: 'Asia/Yangon',
  MWR: 'Africa/Johannesburg',
  MWT: 'Australia/Adelaide',
  MWU: 'Pacific/Port_Moresby',
  MWV: 'Asia/Phnom_Penh',
  MWX: 'Asia/Seoul',
  MWY: 'Australia/Brisbane',
  MWZ: 'Africa/Dar_es_Salaam',
  MXA: 'America/Chicago',
  MXB: 'Asia/Makassar',
  MXC: 'America/Denver',
  MXD: 'Australia/Brisbane',
  MXE: 'America/New_York',
  MXF: 'America/Chicago',
  MXG: 'America/New_York',
  MXH: 'Pacific/Port_Moresby',
  MXI: 'Asia/Manila',
  MXJ: 'Africa/Lagos',
  MXK: 'Pacific/Port_Moresby',
  MXL: 'America/Tijuana',
  MXM: 'Indian/Antananarivo',
  MXN: 'Europe/Paris',
  MXO: 'America/Chicago',
  MXP: 'Europe/Rome',
  MXR: 'Europe/Kiev',
  MXS: 'Pacific/Apia',
  MXT: 'Indian/Antananarivo',
  MXU: 'Australia/Perth',
  MXV: 'Asia/Ulaanbaatar',
  MXW: 'Asia/Ulaanbaatar',
  MXX: 'Europe/Stockholm',
  MXY: 'America/Anchorage',
  MXZ: 'Asia/Shanghai',
  MYA: 'Australia/Sydney',
  MYB: 'Africa/Libreville',
  MYC: 'America/Caracas',
  MYD: 'Africa/Nairobi',
  MYE: 'Asia/Tokyo',
  MYF: 'America/Los_Angeles',
  MYG: 'America/Nassau',
  MYH: 'America/Phoenix',
  MYI: 'Australia/Lindeman',
  MYJ: 'Asia/Tokyo',
  MYK: 'America/Anchorage',
  MYL: 'America/Boise',
  MYM: 'America/Guyana',
  MYN: 'Asia/Aden',
  MYO: 'Australia/Perth',
  MYP: 'Asia/Ashgabat',
  MYQ: 'Asia/Kolkata',
  MYR: 'America/New_York',
  MYT: 'Asia/Yangon',
  MYU: 'America/Nome',
  MYV: 'America/Los_Angeles',
  MYW: 'Africa/Dar_es_Salaam',
  MYX: 'Pacific/Port_Moresby',
  MYY: 'Asia/Kuching',
  MYZ: 'Africa/Blantyre',
  MZA: 'America/Lima',
  MZB: 'Africa/Maputo',
  MZC: 'Africa/Libreville',
  MZD: 'America/Guayaquil',
  MZE: 'America/New_York',
  MZF: 'Africa/Johannesburg',
  MZG: 'Asia/Taipei',
  MZH: 'Europe/Istanbul',
  MZI: 'Africa/Bamako',
  MZJ: 'America/Phoenix',
  MZK: 'Pacific/Tarawa',
  MZL: 'America/Bogota',
  MZM: 'Europe/Paris',
  MZN: 'Pacific/Port_Moresby',
  MZO: 'America/Havana',
  MZP: 'Pacific/Auckland',
  MZQ: 'Africa/Johannesburg',
  MZR: 'Asia/Kabul',
  MZT: 'America/Mazatlan',
  MZU: 'Asia/Kolkata',
  MZV: 'Asia/Kuching',
  MZW: 'Africa/Algiers',
  MZX: 'Africa/Addis_Ababa',
  MZY: 'Africa/Johannesburg',
  MZZ: 'America/Indiana/Indianapolis',
  NAA: 'Australia/Sydney',
  NAC: 'Australia/Adelaide',
  NAD: 'America/Bogota',
  NAE: 'Africa/Porto-Novo',
  NAF: 'Asia/Makassar',
  NAG: 'Asia/Kolkata',
  NAH: 'Asia/Makassar',
  NAI: 'America/Guyana',
  NAJ: 'Asia/Baku',
  NAK: 'Asia/Bangkok',
  NAL: 'Europe/Moscow',
  NAM: 'Asia/Jayapura',
  NAN: 'Pacific/Fiji',
  NAO: 'Asia/Shanghai',
  NAP: 'Europe/Rome',
  NAQ: 'America/Thule',
  NAR: 'America/Bogota',
  NAS: 'America/Nassau',
  NAT: 'America/Fortaleza',
  NAU: 'Pacific/Tahiti',
  NAV: 'Europe/Istanbul',
  NAW: 'Asia/Bangkok',
  NAY: 'Asia/Shanghai',
  NAZ: 'Pacific/Guadalcanal',
  NBA: 'Pacific/Port_Moresby',
  NBB: 'America/Bogota',
  NBC: 'Europe/Moscow',
  NBE: 'Africa/Tunis',
  NBG: 'America/Chicago',
  NBH: 'Australia/Sydney',
  NBL: 'America/Panama',
  NBN: 'Africa/Malabo',
  NBO: 'Africa/Nairobi',
  NBS: 'Asia/Shanghai',
  NBW: 'America/Havana',
  NBX: 'Asia/Jayapura',
  NCA: 'America/Grand_Turk',
  NCE: 'Europe/Paris',
  NCG: 'America/Chihuahua',
  NCH: 'Africa/Dar_es_Salaam',
  NCI: 'America/Bogota',
  NCJ: 'America/Argentina/Cordoba',
  NCL: 'Europe/London',
  NCN: 'America/Anchorage',
  NCO: 'America/New_York',
  NCR: 'America/Managua',
  NCS: 'Africa/Johannesburg',
  NCT: 'America/Costa_Rica',
  NCU: 'Asia/Samarkand',
  NCY: 'Europe/Paris',
  NDA: 'Asia/Jayapura',
  NDB: 'Africa/Nouakchott',
  NDC: 'Asia/Kolkata',
  NDD: 'Africa/Luanda',
  NDE: 'Africa/Nairobi',
  NDF: 'Africa/Luanda',
  NDG: 'Asia/Shanghai',
  NDI: 'Pacific/Port_Moresby',
  NDJ: 'Africa/Ndjamena',
  NDK: 'Pacific/Majuro',
  NDL: 'Africa/Bangui',
  NDM: 'Africa/Addis_Ababa',
  NDN: 'Pacific/Port_Moresby',
  NDR: 'Africa/Casablanca',
  NDS: 'Australia/Perth',
  NDU: 'Africa/Windhoek',
  NDY: 'Europe/London',
  NEC: 'America/Argentina/Buenos_Aires',
  NEF: 'Asia/Yekaterinburg',
  NEG: 'America/Jamaica',
  NEI: 'Asia/Vladivostok',
  NEJ: 'Africa/Addis_Ababa',
  NEK: 'Africa/Addis_Ababa',
  NEL: 'America/New_York',
  NEN: 'America/New_York',
  NER: 'Asia/Yakutsk',
  NEU: 'Asia/Vientiane',
  NEV: 'America/St_Kitts',
  NEW: 'America/Chicago',
  NFG: 'Asia/Yekaterinburg',
  NFL: 'America/Los_Angeles',
  NFO: 'Pacific/Tongatapu',
  NFR: 'Africa/Tripoli',
  NGA: 'Australia/Sydney',
  NGB: 'Asia/Shanghai',
  NGD: 'America/Tortola',
  NGE: 'Africa/Douala',
  NGF: 'Pacific/Honolulu',
  NGI: 'Pacific/Fiji',
  NGK: 'Asia/Sakhalin',
  NGL: 'Africa/Johannesburg',
  NGN: 'America/Panama',
  NGO: 'Asia/Tokyo',
  NGP: 'America/Chicago',
  NGQ: 'Asia/Shanghai',
  NGR: 'Pacific/Port_Moresby',
  NGS: 'Asia/Tokyo',
  NGU: 'America/New_York',
  NGW: 'America/Chicago',
  NGX: 'Asia/Kathmandu',
  NHA: 'Asia/Ho_Chi_Minh',
  NHD: 'Asia/Dubai',
  NHF: 'Africa/Khartoum',
  NHK: 'America/New_York',
  NHS: 'Asia/Karachi',
  NHT: 'Europe/London',
  NHV: 'Pacific/Tahiti',
  NHX: 'America/Chicago',
  NHZ: 'America/New_York',
  NIA: 'Africa/Monrovia',
  NIB: 'America/Anchorage',
  NIC: 'Asia/Nicosia',
  NIF: 'Australia/Perth',
  NIG: 'Pacific/Tarawa',
  NIK: 'Africa/Dakar',
  NIM: 'Africa/Niamey',
  NIN: 'America/Anchorage',
  NIO: 'Africa/Kinshasa',
  NIP: 'America/New_York',
  NIR: 'America/Chicago',
  NIS: 'Pacific/Port_Moresby',
  NIT: 'Europe/Paris',
  NIU: 'Pacific/Tahiti',
  NIX: 'Africa/Bamako',
  NJA: 'Asia/Tokyo',
  NJC: 'Asia/Yekaterinburg',
  NJF: 'Asia/Baghdad',
  NJJ: 'Asia/Shanghai',
  NJK: 'America/Los_Angeles',
  NKA: 'Africa/Libreville',
  NKB: 'Australia/Perth',
  NKC: 'Africa/Nouakchott',
  NKD: 'Asia/Jayapura',
  NKG: 'Asia/Shanghai',
  NKI: 'America/Juneau',
  NKL: 'Africa/Kinshasa',
  NKM: 'Asia/Tokyo',
  NKN: 'Pacific/Port_Moresby',
  NKO: 'Indian/Antananarivo',
  NKP: 'Pacific/Tahiti',
  NKS: 'Africa/Douala',
  NKT: 'Europe/Istanbul',
  NKU: 'Africa/Maseru',
  NKX: 'America/Los_Angeles',
  NKY: 'Africa/Brazzaville',
  NLA: 'Africa/Lusaka',
  NLC: 'America/Los_Angeles',
  NLD: 'America/Matamoros',
  NLE: 'America/Detroit',
  NLF: 'Pacific/Port_Moresby',
  NLG: 'America/Anchorage',
  NLH: 'Asia/Shanghai',
  NLI: 'Asia/Vladivostok',
  NLK: 'Pacific/Norfolk',
  NLL: 'Australia/Perth',
  NLN: 'America/Los_Angeles',
  NLO: 'Africa/Kinshasa',
  NLP: 'Africa/Johannesburg',
  NLS: 'Australia/Perth',
  NLT: 'Asia/Urumqi',
  NLU: 'America/Mexico_City',
  NLV: 'Europe/Kiev',
  NMA: 'Asia/Tashkent',
  NMB: 'Asia/Kolkata',
  NMC: 'America/Nassau',
  NME: 'America/Nome',
  NMG: 'America/Panama',
  NML: 'America/Edmonton',
  NMN: 'Pacific/Port_Moresby',
  NMP: 'Australia/Brisbane',
  NMR: 'Australia/Brisbane',
  NMS: 'Asia/Yangon',
  NMT: 'Asia/Yangon',
  NNA: 'Africa/Casablanca',
  NNB: 'Pacific/Guadalcanal',
  NND: 'Africa/Maputo',
  NNG: 'Asia/Shanghai',
  NNI: 'Africa/Windhoek',
  NNK: 'America/Anchorage',
  NNL: 'America/Anchorage',
  NNM: 'Europe/Moscow',
  NNR: 'Europe/Dublin',
  NNT: 'Asia/Bangkok',
  NNU: 'America/Sao_Paulo',
  NNX: 'Asia/Makassar',
  NNY: 'Asia/Shanghai',
  NOA: 'Australia/Sydney',
  NOB: 'America/Costa_Rica',
  NOC: 'Europe/Dublin',
  NOD: 'Europe/Berlin',
  NOG: 'America/Hermosillo',
  NOI: 'Europe/Moscow',
  NOJ: 'Asia/Yekaterinburg',
  NOK: 'America/Cuiaba',
  NOM: 'Pacific/Port_Moresby',
  NON: 'Pacific/Tarawa',
  NOO: 'Pacific/Port_Moresby',
  NOP: 'Europe/Istanbul',
  NOR: 'Atlantic/Reykjavik',
  NOS: 'Indian/Antananarivo',
  NOT: 'America/Los_Angeles',
  NOU: 'Pacific/Noumea',
  NOV: 'Africa/Luanda',
  NOZ: 'Asia/Novokuznetsk',
  NPA: 'America/Chicago',
  NPE: 'Pacific/Auckland',
  NPG: 'Pacific/Port_Moresby',
  NPH: 'America/Denver',
  NPL: 'Pacific/Auckland',
  NPO: 'Asia/Pontianak',
  NPP: 'Australia/Darwin',
  NPR: 'America/Santarem',
  NPT: 'America/New_York',
  NPU: 'America/Bogota',
  NQA: 'America/Chicago',
  NQI: 'America/Chicago',
  NQL: 'America/Sao_Paulo',
  NQN: 'America/Argentina/Salta',
  NQT: 'Europe/London',
  NQU: 'America/Bogota',
  NQX: 'America/New_York',
  NQY: 'Europe/London',
  NRA: 'Australia/Sydney',
  NRB: 'America/New_York',
  NRC: 'America/Los_Angeles',
  NRD: 'Europe/Berlin',
  NRE: 'Asia/Jayapura',
  NRG: 'Australia/Perth',
  NRI: 'America/Chicago',
  NRK: 'Europe/Stockholm',
  NRL: 'Europe/London',
  NRM: 'Africa/Bamako',
  NRN: 'Europe/Berlin',
  NRR: 'America/Puerto_Rico',
  NRS: 'America/Los_Angeles',
  NRT: 'Asia/Tokyo',
  NRY: 'Australia/Darwin',
  NSB: 'America/Nassau',
  NSE: 'America/Chicago',
  NSH: 'Asia/Tehran',
  NSI: 'Africa/Douala',
  NSK: 'Asia/Krasnoyarsk',
  NSL: 'America/Chicago',
  NSM: 'Australia/Perth',
  NSN: 'Pacific/Auckland',
  NSO: 'Australia/Sydney',
  NST: 'Asia/Bangkok',
  NSV: 'Australia/Brisbane',
  NSY: 'Europe/Rome',
  NTA: 'Pacific/Fiji',
  NTB: 'Europe/Oslo',
  NTC: 'Africa/Maputo',
  NTD: 'America/Los_Angeles',
  NTE: 'Europe/Paris',
  NTG: 'Asia/Shanghai',
  NTI: 'Asia/Jayapura',
  NTJ: 'America/Denver',
  NTL: 'Australia/Sydney',
  NTM: 'America/Araguaina',
  NTN: 'Australia/Brisbane',
  NTO: 'Atlantic/Cape_Verde',
  NTQ: 'Asia/Tokyo',
  NTR: 'America/Monterrey',
  NTT: 'Pacific/Tongatapu',
  NTU: 'America/New_York',
  NTX: 'Asia/Jakarta',
  NTY: 'Africa/Johannesburg',
  NUA: 'Asia/Colombo',
  NUB: 'Australia/Darwin',
  NUD: 'Africa/Khartoum',
  NUE: 'Europe/Berlin',
  NUF: 'Asia/Colombo',
  NUG: 'Pacific/Bougainville',
  NUH: 'America/Bogota',
  NUI: 'America/Anchorage',
  NUJ: 'Asia/Tehran',
  NUK: 'Pacific/Tahiti',
  NUL: 'America/Anchorage',
  NUN: 'America/Chicago',
  NUP: 'America/Nome',
  NUQ: 'America/Los_Angeles',
  NUR: 'Australia/Adelaide',
  NUS: 'Pacific/Efate',
  NUT: 'Pacific/Port_Moresby',
  NUU: 'Africa/Nairobi',
  NUW: 'America/Los_Angeles',
  NUX: 'Asia/Yekaterinburg',
  NVA: 'America/Bogota',
  NVD: 'America/Chicago',
  NVG: 'America/Managua',
  NVI: 'Asia/Samarkand',
  NVK: 'Europe/Oslo',
  NVN: 'America/Los_Angeles',
  NVP: 'America/Manaus',
  NVR: 'Europe/Moscow',
  NVS: 'Europe/Paris',
  NVT: 'America/Sao_Paulo',
  NVY: 'Asia/Kolkata',
  NWA: 'Indian/Comoro',
  NWH: 'America/New_York',
  NWI: 'Europe/London',
  NWT: 'Pacific/Port_Moresby',
  NYA: 'Asia/Yekaterinburg',
  NYC: 'America/New_York',
  NYE: 'Africa/Nairobi',
  NYG: 'America/New_York',
  NYI: 'Africa/Accra',
  NYK: 'Africa/Nairobi',
  NYM: 'Asia/Yekaterinburg',
  NYN: 'Australia/Sydney',
  NYO: 'Europe/Stockholm',
  NYR: 'Asia/Yakutsk',
  NYS: 'America/New_York',
  NYT: 'Asia/Yangon',
  NYU: 'Asia/Yangon',
  NYW: 'Asia/Yangon',
  NZA: 'Africa/Luanda',
  NZC: 'America/Lima',
  NZE: 'Africa/Conakry',
  NZH: 'Asia/Shanghai',
  NZL: 'Asia/Shanghai',
  NZY: 'America/Los_Angeles',
  OAA: 'Asia/Kabul',
  OAG: 'Australia/Sydney',
  OAH: 'Asia/Kabul',
  OAI: 'Asia/Kabul',
  OAJ: 'America/New_York',
  OAK: 'America/Los_Angeles',
  OAL: 'America/Porto_Velho',
  OAM: 'Pacific/Auckland',
  OAN: 'America/Tegucigalpa',
  OAR: 'America/Los_Angeles',
  OAS: 'Asia/Kabul',
  OAX: 'America/Mexico_City',
  OAZ: 'Asia/Kabul',
  OBA: 'Australia/Sydney',
  OBC: 'Africa/Djibouti',
  OBD: 'Asia/Jayapura',
  OBE: 'America/New_York',
  OBF: 'Europe/Berlin',
  OBI: 'America/Santarem',
  OBL: 'Europe/Brussels',
  OBM: 'Pacific/Port_Moresby',
  OBN: 'Europe/London',
  OBO: 'Asia/Tokyo',
  OBS: 'Europe/Paris',
  OBU: 'America/Anchorage',
  OBX: 'Pacific/Port_Moresby',
  OCA: 'America/New_York',
  OCC: 'America/Guayaquil',
  OCE: 'America/New_York',
  OCF: 'America/New_York',
  OCH: 'America/Chicago',
  OCJ: 'America/Jamaica',
  OCM: 'Australia/Perth',
  OCN: 'America/Los_Angeles',
  OCS: 'Africa/Malabo',
  OCV: 'America/Bogota',
  OCW: 'America/New_York',
  ODA: 'Africa/Bangui',
  ODB: 'Europe/Madrid',
  ODC: 'America/Los_Angeles',
  ODD: 'Australia/Adelaide',
  ODE: 'Europe/Copenhagen',
  ODH: 'Europe/London',
  ODJ: 'Africa/Bangui',
  ODL: 'Australia/Adelaide',
  ODM: 'America/New_York',
  ODN: 'Asia/Kuching',
  ODO: 'Asia/Irkutsk',
  ODR: 'Australia/Perth',
  ODS: 'Europe/Simferopol',
  ODW: 'America/Los_Angeles',
  ODY: 'Asia/Vientiane',
  OEC: 'Asia/Dili',
  OEL: 'Europe/Moscow',
  OEM: 'America/Paramaribo',
  OEO: 'America/Chicago',
  OER: 'Europe/Stockholm',
  OES: 'America/Argentina/Salta',
  OFF: 'America/Chicago',
  OFI: 'Africa/Abidjan',
  OFJ: 'Atlantic/Reykjavik',
  OFK: 'America/Chicago',
  OFU: 'Pacific/Pago_Pago',
  OGA: 'America/Denver',
  OGB: 'America/New_York',
  OGD: 'America/Denver',
  OGE: 'Pacific/Port_Moresby',
  OGG: 'Pacific/Honolulu',
  OGL: 'America/Guyana',
  OGM: 'America/Panama',
  OGN: 'Asia/Tokyo',
  OGO: 'Africa/Abidjan',
  OGR: 'Africa/Ndjamena',
  OGS: 'America/New_York',
  OGU: 'Europe/Istanbul',
  OGV: 'Africa/Windhoek',
  OGX: 'Africa/Algiers',
  OGZ: 'Europe/Moscow',
  OHA: 'Pacific/Auckland',
  OHB: 'Indian/Antananarivo',
  OHD: 'Europe/Skopje',
  OHE: 'Asia/Shanghai',
  OHH: 'Asia/Sakhalin',
  OHI: 'Africa/Windhoek',
  OHO: 'Asia/Vladivostok',
  OHR: 'Europe/Berlin',
  OHS: 'Asia/Muscat',
  OHT: 'Asia/Karachi',
  OIA: 'America/Santarem',
  OIC: 'America/New_York',
  OIM: 'Asia/Tokyo',
  OIR: 'Asia/Tokyo',
  OIT: 'Asia/Tokyo',
  OJC: 'America/Chicago',
  OJU: 'Asia/Makassar',
  OKA: 'Asia/Tokyo',
  OKB: 'Australia/Brisbane',
  OKC: 'America/Chicago',
  OKD: 'Asia/Tokyo',
  OKE: 'Asia/Tokyo',
  OKF: 'Africa/Windhoek',
  OKG: 'Africa/Brazzaville',
  OKH: 'Europe/London',
  OKI: 'Asia/Tokyo',
  OKJ: 'Asia/Tokyo',
  OKK: 'America/Indiana/Indianapolis',
  OKL: 'Asia/Jayapura',
  OKM: 'America/Chicago',
  OKN: 'Africa/Libreville',
  OKO: 'Asia/Tokyo',
  OKP: 'Pacific/Port_Moresby',
  OKQ: 'Asia/Jayapura',
  OKR: 'Australia/Brisbane',
  OKS: 'America/Denver',
  OKT: 'Asia/Yekaterinburg',
  OKU: 'Africa/Windhoek',
  OKV: 'Pacific/Port_Moresby',
  OKY: 'Australia/Brisbane',
  OLA: 'Europe/Oslo',
  OLB: 'Europe/Rome',
  OLC: 'America/Manaus',
  OLD: 'America/New_York',
  OLE: 'America/New_York',
  OLF: 'America/Denver',
  OLG: 'Africa/Nairobi',
  OLH: 'America/Anchorage',
  OLI: 'Atlantic/Reykjavik',
  OLJ: 'Pacific/Efate',
  OLK: 'America/Asuncion',
  OLL: 'Africa/Brazzaville',
  OLM: 'America/Los_Angeles',
  OLN: 'America/Argentina/Catamarca',
  OLO: 'Europe/Prague',
  OLP: 'Australia/Adelaide',
  OLQ: 'Pacific/Port_Moresby',
  OLR: 'Asia/Kabul',
  OLS: 'America/Phoenix',
  OLU: 'America/Chicago',
  OLV: 'America/Chicago',
  OLX: 'Africa/Nairobi',
  OLY: 'America/Chicago',
  OLZ: 'Asia/Yakutsk',
  OMA: 'America/Chicago',
  OMB: 'Africa/Libreville',
  OMC: 'Asia/Manila',
  OMD: 'Africa/Windhoek',
  OME: 'America/Nome',
  OMF: 'Asia/Amman',
  OMG: 'Africa/Windhoek',
  OMH: 'Asia/Tehran',
  OMI: 'Asia/Tehran',
  OMJ: 'Asia/Tokyo',
  OMK: 'America/Los_Angeles',
  OML: 'Pacific/Port_Moresby',
  OMM: 'Asia/Muscat',
  OMO: 'Europe/Sarajevo',
  OMR: 'Europe/Bucharest',
  OMS: 'Asia/Omsk',
  OMY: 'Asia/Phnom_Penh',
  ONA: 'America/Chicago',
  ONB: 'Pacific/Port_Moresby',
  OND: 'Africa/Windhoek',
  ONE: 'Pacific/Guadalcanal',
  ONG: 'Australia/Brisbane',
  ONH: 'America/New_York',
  ONI: 'Asia/Jayapura',
  ONJ: 'Asia/Tokyo',
  ONK: 'Asia/Yakutsk',
  ONL: 'America/Chicago',
  ONM: 'America/Denver',
  ONO: 'America/Boise',
  ONP: 'America/Los_Angeles',
  ONQ: 'Europe/Istanbul',
  ONR: 'Australia/Brisbane',
  ONS: 'Australia/Perth',
  ONT: 'America/Los_Angeles',
  ONU: 'Pacific/Fiji',
  ONX: 'America/Panama',
  ONY: 'America/Chicago',
  OOA: 'America/Chicago',
  OOK: 'America/Nome',
  OOL: 'Australia/Brisbane',
  OOM: 'Australia/Sydney',
  OOR: 'Australia/Brisbane',
  OOT: 'Pacific/Tarawa',
  OPA: 'Atlantic/Reykjavik',
  OPB: 'Pacific/Port_Moresby',
  OPF: 'America/New_York',
  OPI: 'Australia/Darwin',
  OPL: 'America/Chicago',
  OPO: 'Europe/Lisbon',
  OPS: 'America/Cuiaba',
  OPU: 'Pacific/Port_Moresby',
  OPW: 'Africa/Windhoek',
  ORA: 'America/Argentina/Salta',
  ORB: 'Europe/Stockholm',
  ORC: 'America/Bogota',
  ORD: 'America/Chicago',
  ORE: 'Europe/Paris',
  ORF: 'America/New_York',
  ORG: 'America/Paramaribo',
  ORH: 'America/New_York',
  ORI: 'America/Anchorage',
  ORJ: 'America/Guyana',
  ORK: 'Europe/Dublin',
  ORL: 'America/New_York',
  ORM: 'Europe/London',
  ORN: 'Africa/Algiers',
  ORO: 'America/Tegucigalpa',
  ORP: 'Africa/Gaborone',
  ORR: 'Australia/Adelaide',
  ORS: 'Australia/Lindeman',
  ORT: 'America/Anchorage',
  ORU: 'America/La_Paz',
  ORV: 'America/Anchorage',
  ORW: 'Asia/Karachi',
  ORX: 'America/Santarem',
  ORY: 'Europe/Paris',
  ORZ: 'America/Belize',
  OSA: 'Asia/Tokyo',
  OSB: 'America/Chicago',
  OSC: 'America/Detroit',
  OSD: 'Europe/Stockholm',
  OSE: 'Pacific/Port_Moresby',
  OSF: 'Europe/Moscow',
  OSG: 'Pacific/Port_Moresby',
  OSH: 'America/Chicago',
  OSI: 'Europe/Zagreb',
  OSJ: 'Africa/Nairobi',
  OSK: 'Europe/Stockholm',
  OSL: 'Europe/Oslo',
  OSM: 'Asia/Baghdad',
  OSN: 'Asia/Seoul',
  OSO: 'Australia/Brisbane',
  OSR: 'Europe/Prague',
  OSS: 'Asia/Bishkek',
  OST: 'Europe/Brussels',
  OSU: 'America/New_York',
  OSW: 'Asia/Yekaterinburg',
  OSX: 'America/Chicago',
  OSY: 'Europe/Oslo',
  OSZ: 'Europe/Warsaw',
  OTA: 'Africa/Addis_Ababa',
  OTC: 'Africa/Ndjamena',
  OTD: 'America/Panama',
  OTG: 'America/Chicago',
  OTH: 'America/Los_Angeles',
  OTI: 'Asia/Jayapura',
  OTJ: 'Africa/Windhoek',
  OTK: 'America/Los_Angeles',
  OTL: 'Africa/Nouakchott',
  OTM: 'America/Chicago',
  OTN: 'America/Indiana/Vincennes',
  OTP: 'Europe/Bucharest',
  OTR: 'America/Costa_Rica',
  OTS: 'America/Los_Angeles',
  OTT: 'America/Cuiaba',
  OTU: 'America/Bogota',
  OTV: 'Pacific/Guadalcanal',
  OTY: 'Pacific/Bougainville',
  OTZ: 'America/Nome',
  OUA: 'Africa/Ouagadougou',
  OUD: 'Africa/Casablanca',
  OUE: 'Africa/Brazzaville',
  OUG: 'Africa/Ouagadougou',
  OUH: 'Africa/Johannesburg',
  OUK: 'Europe/London',
  OUL: 'Europe/Helsinki',
  OUM: 'Africa/Ndjamena',
  OUN: 'America/Chicago',
  OUR: 'Africa/Douala',
  OUS: 'America/Sao_Paulo',
  OUT: 'Africa/Ndjamena',
  OUU: 'Africa/Libreville',
  OUZ: 'Africa/Nouakchott',
  OVA: 'Indian/Antananarivo',
  OVB: 'Asia/Novosibirsk',
  OVD: 'Europe/Madrid',
  OVE: 'America/Los_Angeles',
  OVG: 'Africa/Johannesburg',
  OVL: 'America/Santiago',
  OVR: 'America/Argentina/Buenos_Aires',
  OVS: 'Asia/Yekaterinburg',
  OWA: 'America/Chicago',
  OWB: 'America/Chicago',
  OWD: 'America/New_York',
  OWE: 'Africa/Libreville',
  OWK: 'America/New_York',
  OXB: 'Africa/Bissau',
  OXC: 'America/New_York',
  OXD: 'America/New_York',
  OXF: 'Europe/London',
  OXO: 'Australia/Brisbane',
  OXR: 'America/Los_Angeles',
  OXY: 'Australia/Brisbane',
  OYA: 'America/Argentina/Cordoba',
  OYE: 'Africa/Libreville',
  OYG: 'Africa/Kampala',
  OYK: 'America/Belem',
  OYL: 'Africa/Nairobi',
  OYN: 'Australia/Sydney',
  OYO: 'America/Argentina/Buenos_Aires',
  OYP: 'America/Cayenne',
  OZA: 'America/Chicago',
  OZC: 'Asia/Manila',
  OZG: 'Africa/Casablanca',
  OZH: 'Europe/Zaporozhye',
  OZP: 'Europe/Madrid',
  OZR: 'America/Chicago',
  OZZ: 'Africa/Casablanca',
  PAA: 'Asia/Yangon',
  PAB: 'Asia/Kolkata',
  PAC: 'America/Panama',
  PAD: 'Europe/Berlin',
  PAE: 'America/Los_Angeles',
  PAF: 'Africa/Kampala',
  PAG: 'Asia/Manila',
  PAH: 'America/Chicago',
  PAJ: 'Asia/Karachi',
  PAK: 'Pacific/Honolulu',
  PAL: 'America/Bogota',
  PAM: 'America/Chicago',
  PAN: 'Asia/Bangkok',
  PAO: 'America/Los_Angeles',
  PAP: 'America/Port-au-Prince',
  PAQ: 'America/Anchorage',
  PAR: 'Europe/Paris',
  PAS: 'Europe/Athens',
  PAT: 'Asia/Kolkata',
  PAU: 'Asia/Yangon',
  PAV: 'America/Maceio',
  PAW: 'Pacific/Port_Moresby',
  PAX: 'America/Port-au-Prince',
  PAY: 'Asia/Kuching',
  PAZ: 'America/Mexico_City',
  PBB: 'America/Campo_Grande',
  PBC: 'America/Mexico_City',
  PBD: 'Asia/Kolkata',
  PBE: 'America/Bogota',
  PBF: 'America/Chicago',
  PBG: 'America/New_York',
  PBH: 'Asia/Thimphu',
  PBI: 'America/New_York',
  PBJ: 'Pacific/Efate',
  PBL: 'America/Caracas',
  PBM: 'America/Paramaribo',
  PBN: 'Africa/Luanda',
  PBO: 'Australia/Perth',
  PBP: 'America/Costa_Rica',
  PBQ: 'America/Porto_Velho',
  PBR: 'America/Guatemala',
  PBT: 'America/Asuncion',
  PBU: 'Asia/Yangon',
  PBV: 'America/Cuiaba',
  PBX: 'America/Cuiaba',
  PBZ: 'Africa/Johannesburg',
  PCA: 'America/Anchorage',
  PCB: 'Asia/Jakarta',
  PCC: 'America/Bogota',
  PCD: 'America/Chicago',
  PCF: 'Africa/Johannesburg',
  PCH: 'America/Tegucigalpa',
  PCJ: 'America/Asuncion',
  PCL: 'America/Lima',
  PCM: 'America/Cancun',
  PCN: 'Pacific/Auckland',
  PCO: 'America/Mazatlan',
  PCP: 'Africa/Sao_Tome',
  PCQ: 'Asia/Vientiane',
  PCR: 'America/Bogota',
  PCS: 'America/Fortaleza',
  PCT: 'America/New_York',
  PCU: 'America/Chicago',
  PCV: 'America/Hermosillo',
  PDA: 'America/Bogota',
  PDB: 'America/Anchorage',
  PDC: 'Pacific/Noumea',
  PDD: 'Africa/Maputo',
  PDE: 'Australia/Adelaide',
  PDF: 'America/Bahia',
  PDG: 'Asia/Jakarta',
  PDI: 'Pacific/Port_Moresby',
  PDK: 'America/New_York',
  PDL: 'Atlantic/Azores',
  PDM: 'America/Panama',
  PDN: 'Australia/Adelaide',
  PDO: 'Asia/Jakarta',
  PDP: 'America/Montevideo',
  PDR: 'America/Fortaleza',
  PDS: 'America/Matamoros',
  PDT: 'America/Los_Angeles',
  PDU: 'America/Montevideo',
  PDV: 'Europe/Sofia',
  PDX: 'America/Los_Angeles',
  PDZ: 'America/Caracas',
  PEA: 'Australia/Adelaide',
  PEB: 'Africa/Maputo',
  PEC: 'America/Juneau',
  PED: 'Europe/Prague',
  PEE: 'Asia/Yekaterinburg',
  PEF: 'Europe/Berlin',
  PEG: 'Europe/Rome',
  PEH: 'America/Argentina/Buenos_Aires',
  PEI: 'America/Bogota',
  PEK: 'Asia/Shanghai',
  PEL: 'Africa/Maseru',
  PEM: 'America/Lima',
  PEN: 'Asia/Kuala_Lumpur',
  PEP: 'Australia/Darwin',
  PEQ: 'America/Chicago',
  PER: 'Australia/Perth',
  PES: 'Europe/Moscow',
  PET: 'America/Sao_Paulo',
  PEU: 'America/Tegucigalpa',
  PEV: 'Europe/Budapest',
  PEW: 'Asia/Karachi',
  PEX: 'Europe/Moscow',
  PEY: 'Australia/Adelaide',
  PEZ: 'Europe/Moscow',
  PFB: 'America/Sao_Paulo',
  PFC: 'America/Los_Angeles',
  PFJ: 'Atlantic/Reykjavik',
  PFM: 'America/Edmonton',
  PFO: 'Asia/Nicosia',
  PFQ: 'Asia/Tehran',
  PFR: 'Africa/Lubumbashi',
  PGA: 'America/Phoenix',
  PGB: 'Pacific/Port_Moresby',
  PGC: 'America/New_York',
  PGD: 'America/New_York',
  PGE: 'Pacific/Port_Moresby',
  PGF: 'Europe/Paris',
  PGH: 'Asia/Kolkata',
  PGI: 'Africa/Luanda',
  PGK: 'Asia/Jakarta',
  PGL: 'America/Chicago',
  PGM: 'America/Anchorage',
  PGN: 'Pacific/Port_Moresby',
  PGO: 'America/Denver',
  PGQ: 'Asia/Jayapura',
  PGR: 'America/Chicago',
  PGS: 'America/Phoenix',
  PGU: 'Asia/Tehran',
  PGV: 'America/New_York',
  PGX: 'Europe/Paris',
  PGZ: 'America/Sao_Paulo',
  PHA: 'Asia/Ho_Chi_Minh',
  PHB: 'America/Fortaleza',
  PHC: 'Africa/Lagos',
  PHD: 'America/New_York',
  PHE: 'Australia/Perth',
  PHF: 'America/New_York',
  PHG: 'Africa/Lagos',
  PHI: 'America/Fortaleza',
  PHK: 'America/New_York',
  PHL: 'America/New_York',
  PHN: 'America/Detroit',
  PHO: 'America/Nome',
  PHP: 'America/Denver',
  PHQ: 'Australia/Brisbane',
  PHR: 'Pacific/Fiji',
  PHS: 'Asia/Bangkok',
  PHT: 'America/Chicago',
  PHU: 'Asia/Ho_Chi_Minh',
  PHW: 'Africa/Johannesburg',
  PHX: 'America/Phoenix',
  PHY: 'Asia/Bangkok',
  PIA: 'America/Chicago',
  PIB: 'America/Chicago',
  PIC: 'America/Grand_Turk',
  PIE: 'America/New_York',
  PIF: 'Asia/Taipei',
  PIH: 'America/Boise',
  PIK: 'Europe/London',
  PIL: 'America/Asuncion',
  PIM: 'America/New_York',
  PIN: 'America/Manaus',
  PIO: 'America/Lima',
  PIP: 'America/Anchorage',
  PIQ: 'America/Guyana',
  PIR: 'America/Chicago',
  PIS: 'Europe/Paris',
  PIT: 'America/New_York',
  PIU: 'America/Lima',
  PIV: 'America/Sao_Paulo',
  PIW: 'America/Winnipeg',
  PIX: 'Atlantic/Azores',
  PIZ: 'America/Nome',
  PJA: 'Europe/Stockholm',
  PJB: 'America/Phoenix',
  PJC: 'America/Asuncion',
  PJG: 'Asia/Karachi',
  PJM: 'America/Costa_Rica',
  PKA: 'America/Anchorage',
  PKB: 'America/New_York',
  PKC: 'Asia/Kamchatka',
  PKD: 'America/Chicago',
  PKE: 'Australia/Sydney',
  PKF: 'America/Chicago',
  PKG: 'Asia/Kuala_Lumpur',
  PKH: 'Europe/Athens',
  PKJ: 'America/Guatemala',
  PKK: 'Asia/Yangon',
  PKM: 'America/Guyana',
  PKN: 'Asia/Pontianak',
  PKO: 'Africa/Porto-Novo',
  PKP: 'Pacific/Tahiti',
  PKR: 'Asia/Kathmandu',
  PKT: 'Australia/Darwin',
  PKU: 'Asia/Jakarta',
  PKV: 'Europe/Moscow',
  PKW: 'Africa/Gaborone',
  PKX: 'Asia/Shanghai',
  PKY: 'Asia/Pontianak',
  PKZ: 'Asia/Vientiane',
  PLA: 'America/Bogota',
  PLC: 'America/Bogota',
  PLD: 'America/Costa_Rica',
  PLE: 'Pacific/Port_Moresby',
  PLF: 'Africa/Ndjamena',
  PLH: 'Europe/London',
  PLI: 'America/St_Vincent',
  PLJ: 'America/Belize',
  PLK: 'America/Chicago',
  PLL: 'America/Manaus',
  PLM: 'Asia/Jakarta',
  PLN: 'America/Detroit',
  PLO: 'Australia/Adelaide',
  PLP: 'America/Panama',
  PLQ: 'Europe/Vilnius',
  PLR: 'America/Chicago',
  PLS: 'America/Grand_Turk',
  PLT: 'America/Bogota',
  PLU: 'America/Sao_Paulo',
  PLV: 'Europe/Zaporozhye',
  PLW: 'Asia/Makassar',
  PLX: 'Asia/Almaty',
  PLY: 'America/Indiana/Indianapolis',
  PLZ: 'Africa/Johannesburg',
  PMA: 'Africa/Dar_es_Salaam',
  PMB: 'America/Chicago',
  PMC: 'America/Santiago',
  PMD: 'America/Los_Angeles',
  PMF: 'Europe/Rome',
  PMG: 'America/Campo_Grande',
  PMH: 'America/New_York',
  PMI: 'Europe/Madrid',
  PMK: 'Australia/Lindeman',
  PML: 'America/Anchorage',
  PMN: 'Pacific/Port_Moresby',
  PMO: 'Europe/Rome',
  PMP: 'Pacific/Port_Moresby',
  PMQ: 'America/Argentina/Rio_Gallegos',
  PMR: 'Pacific/Auckland',
  PMS: 'Asia/Damascus',
  PMT: 'America/Guyana',
  PMV: 'America/Caracas',
  PMW: 'America/Araguaina',
  PMX: 'America/New_York',
  PMY: 'America/Argentina/Catamarca',
  PMZ: 'America/Costa_Rica',
  PNA: 'Europe/Madrid',
  PNB: 'America/Araguaina',
  PNC: 'America/Chicago',
  PND: 'America/Belize',
  PNE: 'America/New_York',
  PNG: 'America/Sao_Paulo',
  PNH: 'Asia/Phnom_Penh',
  PNI: 'Pacific/Pohnpei',
  PNJ: 'Asia/Shanghai',
  PNK: 'Asia/Pontianak',
  PNL: 'Europe/Rome',
  PNN: 'America/New_York',
  PNP: 'Pacific/Port_Moresby',
  PNQ: 'Asia/Kolkata',
  PNR: 'Africa/Brazzaville',
  PNS: 'America/Chicago',
  PNT: 'America/Punta_Arenas',
  PNU: 'America/Denver',
  PNV: 'Europe/Vilnius',
  PNX: 'America/Chicago',
  PNY: 'Asia/Kolkata',
  PNZ: 'America/Bahia',
  POA: 'America/Sao_Paulo',
  POB: 'America/New_York',
  POC: 'America/Los_Angeles',
  POD: 'Africa/Dakar',
  POE: 'America/Chicago',
  POF: 'America/Chicago',
  POG: 'Africa/Libreville',
  POH: 'America/Chicago',
  POI: 'America/La_Paz',
  POJ: 'America/Sao_Paulo',
  POL: 'Africa/Maputo',
  POM: 'Pacific/Port_Moresby',
  PON: 'America/Guatemala',
  POO: 'America/Sao_Paulo',
  POP: 'America/Santo_Domingo',
  POR: 'Europe/Helsinki',
  POS: 'America/Port_of_Spain',
  POT: 'America/Jamaica',
  POU: 'America/New_York',
  POV: 'Europe/Bratislava',
  POW: 'Europe/Ljubljana',
  POX: 'Europe/Paris',
  POY: 'America/Denver',
  POZ: 'Europe/Warsaw',
  PPA: 'America/Chicago',
  PPB: 'America/Sao_Paulo',
  PPC: 'America/Anchorage',
  PPE: 'America/Hermosillo',
  PPF: 'America/Chicago',
  PPG: 'Pacific/Pago_Pago',
  PPH: 'America/Caracas',
  PPI: 'Australia/Adelaide',
  PPJ: 'Asia/Jakarta',
  PPK: 'Asia/Almaty',
  PPL: 'Asia/Kathmandu',
  PPM: 'America/New_York',
  PPN: 'America/Bogota',
  PPP: 'Australia/Brisbane',
  PPQ: 'Pacific/Auckland',
  PPR: 'Asia/Jakarta',
  PPS: 'Asia/Manila',
  PPT: 'Pacific/Tahiti',
  PPU: 'Asia/Yangon',
  PPV: 'America/Metlakatla',
  PPW: 'Europe/London',
  PPX: 'Pacific/Port_Moresby',
  PPY: 'America/Sao_Paulo',
  PPZ: 'America/Caracas',
  PQC: 'Asia/Ho_Chi_Minh',
  PQD: 'Asia/Colombo',
  PQI: 'America/New_York',
  PQM: 'America/Mexico_City',
  PQQ: 'Australia/Sydney',
  PQS: 'America/Nome',
  PRA: 'America/Argentina/Cordoba',
  PRB: 'America/Los_Angeles',
  PRC: 'America/Phoenix',
  PRD: 'Australia/Perth',
  PRE: 'America/Bogota',
  PRG: 'Europe/Prague',
  PRH: 'Asia/Bangkok',
  PRI: 'Indian/Mahe',
  PRK: 'Africa/Johannesburg',
  PRM: 'Europe/Lisbon',
  PRN: 'Europe/Belgrade',
  PRO: 'America/Chicago',
  PRP: 'Europe/Paris',
  PRQ: 'America/Argentina/Cordoba',
  PRR: 'America/Guyana',
  PRS: 'Pacific/Guadalcanal',
  PRU: 'Asia/Yangon',
  PRV: 'Europe/Prague',
  PRW: 'America/Chicago',
  PRX: 'America/Chicago',
  PRY: 'Africa/Johannesburg',
  PRZ: 'America/Los_Angeles',
  PSA: 'Europe/Rome',
  PSB: 'America/New_York',
  PSC: 'America/Los_Angeles',
  PSD: 'Africa/Cairo',
  PSE: 'America/Puerto_Rico',
  PSF: 'America/New_York',
  PSG: 'America/Juneau',
  PSH: 'Europe/Berlin',
  PSI: 'Asia/Karachi',
  PSJ: 'Asia/Makassar',
  PSK: 'America/New_York',
  PSL: 'Europe/London',
  PSM: 'America/New_York',
  PSN: 'America/Chicago',
  PSO: 'America/Bogota',
  PSP: 'America/Los_Angeles',
  PSQ: 'America/New_York',
  PSR: 'Europe/Rome',
  PSS: 'America/Argentina/Cordoba',
  PSU: 'Asia/Pontianak',
  PSV: 'Europe/London',
  PSW: 'America/Sao_Paulo',
  PSX: 'America/Chicago',
  PSY: 'Atlantic/Stanley',
  PSZ: 'America/La_Paz',
  PTA: 'America/Anchorage',
  PTB: 'America/New_York',
  PTC: 'America/Metlakatla',
  PTD: 'America/Sitka',
  PTF: 'Pacific/Fiji',
  PTG: 'Africa/Johannesburg',
  PTH: 'America/Anchorage',
  PTJ: 'Australia/Melbourne',
  PTK: 'America/Detroit',
  PTM: 'America/Caracas',
  PTN: 'America/Chicago',
  PTO: 'America/Sao_Paulo',
  PTP: 'America/Guadeloupe',
  PTQ: 'America/Santarem',
  PTS: 'America/Chicago',
  PTT: 'America/Chicago',
  PTU: 'America/Nome',
  PTV: 'America/Los_Angeles',
  PTW: 'America/New_York',
  PTX: 'America/Bogota',
  PTY: 'America/Panama',
  PTZ: 'America/Guayaquil',
  PUA: 'Pacific/Port_Moresby',
  PUB: 'America/Denver',
  PUC: 'America/Denver',
  PUD: 'America/Argentina/Rio_Gallegos',
  PUE: 'America/Panama',
  PUF: 'Europe/Paris',
  PUG: 'Australia/Adelaide',
  PUI: 'Pacific/Port_Moresby',
  PUJ: 'America/Santo_Domingo',
  PUK: 'Pacific/Tahiti',
  PUL: 'America/Los_Angeles',
  PUM: 'Asia/Makassar',
  PUN: 'Africa/Lubumbashi',
  PUP: 'Africa/Ouagadougou',
  PUQ: 'America/Punta_Arenas',
  PUR: 'America/La_Paz',
  PUS: 'Asia/Seoul',
  PUT: 'Asia/Kolkata',
  PUU: 'America/Bogota',
  PUV: 'Pacific/Noumea',
  PUW: 'America/Los_Angeles',
  PUX: 'America/Santiago',
  PUY: 'Europe/Zagreb',
  PUZ: 'America/Managua',
  PVA: 'America/Bogota',
  PVC: 'America/New_York',
  PVD: 'America/New_York',
  PVE: 'America/Panama',
  PVF: 'America/Los_Angeles',
  PVG: 'Asia/Shanghai',
  PVH: 'America/Porto_Velho',
  PVI: 'America/Sao_Paulo',
  PVK: 'Europe/Athens',
  PVL: 'America/New_York',
  PVO: 'America/Guayaquil',
  PVR: 'America/Mexico_City',
  PVS: 'Asia/Anadyr',
  PVU: 'America/Denver',
  PVW: 'America/Chicago',
  PWA: 'America/Chicago',
  PWD: 'America/Denver',
  PWE: 'Asia/Anadyr',
  PWI: 'Africa/Addis_Ababa',
  PWK: 'America/Chicago',
  PWL: 'Asia/Jakarta',
  PWM: 'America/New_York',
  PWN: 'America/Nassau',
  PWO: 'Africa/Lubumbashi',
  PWQ: 'Asia/Almaty',
  PWR: 'America/Sitka',
  PWT: 'America/Los_Angeles',
  PWY: 'America/Denver',
  PXA: 'Asia/Jakarta',
  PXH: 'Australia/Adelaide',
  PXL: 'America/Phoenix',
  PXM: 'America/Mexico_City',
  PXO: 'Atlantic/Madeira',
  PXR: 'Asia/Bangkok',
  PXU: 'Asia/Ho_Chi_Minh',
  PYA: 'America/Bogota',
  PYB: 'Asia/Kolkata',
  PYC: 'America/Panama',
  PYE: 'Pacific/Rarotonga',
  PYG: 'Asia/Kolkata',
  PYH: 'America/Caracas',
  PYJ: 'Asia/Yakutsk',
  PYK: 'Asia/Tehran',
  PYL: 'America/Anchorage',
  PYM: 'America/New_York',
  PYN: 'America/Bogota',
  PYO: 'America/Guayaquil',
  PYR: 'Europe/Athens',
  PYS: 'America/Los_Angeles',
  PYV: 'America/Panama',
  PYY: 'Asia/Bangkok',
  PZA: 'America/Bogota',
  PZB: 'Africa/Johannesburg',
  PZH: 'Asia/Karachi',
  PZI: 'Asia/Shanghai',
  PZK: 'Pacific/Rarotonga',
  PZL: 'Africa/Johannesburg',
  PZO: 'America/Caracas',
  PZS: 'America/Santiago',
  PZU: 'Africa/Khartoum',
  PZY: 'Europe/Bratislava',
  QAQ: 'Europe/Rome',
  QBC: 'America/Vancouver',
  QCY: 'Europe/London',
  QHU: 'Europe/Berlin',
  QLR: 'Europe/Lisbon',
  QOW: 'Africa/Lagos',
  QPG: 'Asia/Singapore',
  QRA: 'Africa/Johannesburg',
  QRO: 'America/Mexico_City',
  QRW: 'Africa/Lagos',
  QSC: 'America/Sao_Paulo',
  QSF: 'Africa/Algiers',
  QSR: 'Europe/Rome',
  QSZ: 'Asia/Shanghai',
  QUB: 'Africa/Tripoli',
  QUG: 'Europe/London',
  QUO: 'Africa/Lagos',
  QUY: 'Europe/London',
  QWG: 'America/New_York',
  RAA: 'Pacific/Port_Moresby',
  RAB: 'Pacific/Port_Moresby',
  RAC: 'America/Chicago',
  RAD: 'America/Tortola',
  RAE: 'Asia/Riyadh',
  RAF: 'America/Argentina/Cordoba',
  RAG: 'Pacific/Auckland',
  RAH: 'Asia/Riyadh',
  RAI: 'Atlantic/Cape_Verde',
  RAJ: 'Asia/Kolkata',
  RAK: 'Africa/Casablanca',
  RAL: 'America/Los_Angeles',
  RAM: 'Australia/Darwin',
  RAN: 'Europe/Rome',
  RAO: 'America/Sao_Paulo',
  RAP: 'America/Denver',
  RAQ: 'Asia/Makassar',
  RAR: 'Pacific/Rarotonga',
  RAS: 'Asia/Tehran',
  RAT: 'Asia/Yekaterinburg',
  RAV: 'America/Bogota',
  RAW: 'Pacific/Port_Moresby',
  RAX: 'Pacific/Port_Moresby',
  RAZ: 'Asia/Karachi',
  RBA: 'Africa/Casablanca',
  RBB: 'America/Manaus',
  RBC: 'Australia/Melbourne',
  RBD: 'America/Chicago',
  RBE: 'Asia/Phnom_Penh',
  RBF: 'America/Los_Angeles',
  RBG: 'America/Los_Angeles',
  RBI: 'Pacific/Fiji',
  RBJ: 'Asia/Tokyo',
  RBK: 'America/Los_Angeles',
  RBL: 'America/Los_Angeles',
  RBM: 'Europe/Berlin',
  RBO: 'America/La_Paz',
  RBP: 'Pacific/Port_Moresby',
  RBQ: 'America/La_Paz',
  RBR: 'America/Rio_Branco',
  RBS: 'Australia/Melbourne',
  RBT: 'Africa/Nairobi',
  RBU: 'Australia/Perth',
  RBV: 'Pacific/Guadalcanal',
  RBW: 'America/New_York',
  RBX: 'Africa/Juba',
  RBY: 'America/Anchorage',
  RCA: 'America/Denver',
  RCB: 'Africa/Johannesburg',
  RCE: 'America/Los_Angeles',
  RCH: 'America/Bogota',
  RCK: 'America/Chicago',
  RCL: 'Pacific/Efate',
  RCM: 'Australia/Brisbane',
  RCN: 'Australia/Adelaide',
  RCO: 'Europe/Paris',
  RCQ: 'America/Argentina/Cordoba',
  RCR: 'America/Indiana/Indianapolis',
  RCS: 'Europe/London',
  RCT: 'America/Detroit',
  RCU: 'America/Argentina/Cordoba',
  RCY: 'America/Nassau',
  RDA: 'Australia/Darwin',
  RDB: 'America/Nome',
  RDC: 'America/Santarem',
  RDD: 'America/Los_Angeles',
  RDE: 'Asia/Jayapura',
  RDG: 'America/New_York',
  RDM: 'America/Los_Angeles',
  RDN: 'Asia/Kuala_Lumpur',
  RDO: 'Europe/Warsaw',
  RDP: 'Asia/Kolkata',
  RDR: 'America/Chicago',
  RDS: 'America/Argentina/Salta',
  RDT: 'Africa/Dakar',
  RDU: 'America/New_York',
  RDV: 'America/Anchorage',
  RDZ: 'Europe/Paris',
  REA: 'Pacific/Tahiti',
  REB: 'Europe/Berlin',
  REC: 'America/Recife',
  RED: 'America/New_York',
  REE: 'America/Chicago',
  REG: 'Europe/Rome',
  REI: 'America/Cayenne',
  REK: 'Atlantic/Reykjavik',
  REL: 'America/Argentina/Catamarca',
  REN: 'Asia/Yekaterinburg',
  REO: 'America/Boise',
  REP: 'Asia/Phnom_Penh',
  REQ: 'Asia/Karachi',
  RER: 'America/Guatemala',
  RES: 'America/Argentina/Cordoba',
  RET: 'Europe/Oslo',
  REU: 'Europe/Madrid',
  REW: 'Asia/Kolkata',
  REX: 'America/Matamoros',
  REY: 'America/La_Paz',
  REZ: 'America/Sao_Paulo',
  RFA: 'Africa/Bangui',
  RFD: 'America/Chicago',
  RFG: 'America/Chicago',
  RFK: 'America/Chicago',
  RFN: 'Atlantic/Reykjavik',
  RFP: 'Pacific/Tahiti',
  RFR: 'America/Costa_Rica',
  RFS: 'America/Managua',
  RGA: 'America/Argentina/Ushuaia',
  RGE: 'Pacific/Port_Moresby',
  RGH: 'Asia/Kolkata',
  RGI: 'Pacific/Tahiti',
  RGK: 'Asia/Omsk',
  RGL: 'America/Argentina/Rio_Gallegos',
  RGN: 'Asia/Yangon',
  RGO: 'Asia/Pyongyang',
  RGR: 'America/Chicago',
  RGS: 'Europe/Madrid',
  RGT: 'Asia/Jakarta',
  RHA: 'Atlantic/Reykjavik',
  RHD: 'America/Argentina/Cordoba',
  RHE: 'Europe/Paris',
  RHG: 'Africa/Kigali',
  RHI: 'America/Chicago',
  RHL: 'Australia/Perth',
  RHN: 'Africa/Windhoek',
  RHO: 'Europe/Athens',
  RHP: 'Asia/Kathmandu',
  RHR: 'Asia/Dubai',
  RHT: 'Asia/Shanghai',
  RHV: 'America/Los_Angeles',
  RIA: 'America/Sao_Paulo',
  RIB: 'America/La_Paz',
  RIC: 'America/New_York',
  RID: 'America/Indiana/Indianapolis',
  RIE: 'America/Chicago',
  RIF: 'America/Denver',
  RIG: 'America/Sao_Paulo',
  RIH: 'America/Panama',
  RIJ: 'America/Lima',
  RIL: 'America/Denver',
  RIM: 'America/Lima',
  RIN: 'Pacific/Guadalcanal',
  RIO: 'America/Sao_Paulo',
  RIR: 'America/Los_Angeles',
  RIS: 'Asia/Tokyo',
  RIV: 'America/Los_Angeles',
  RIW: 'America/Denver',
  RIX: 'Europe/Riga',
  RIY: 'Asia/Aden',
  RIZ: 'Asia/Shanghai',
  RJA: 'Asia/Kolkata',
  RJB: 'Asia/Kathmandu',
  RJH: 'Asia/Dhaka',
  RJI: 'Asia/Kolkata',
  RJK: 'Europe/Zagreb',
  RJL: 'Europe/Madrid',
  RJM: 'Asia/Jayapura',
  RJN: 'Asia/Tehran',
  RKA: 'Pacific/Tahiti',
  RKD: 'America/New_York',
  RKE: 'Europe/Copenhagen',
  RKH: 'America/New_York',
  RKI: 'Asia/Jakarta',
  RKP: 'America/Chicago',
  RKR: 'America/Chicago',
  RKS: 'America/Denver',
  RKT: 'Asia/Dubai',
  RKU: 'Pacific/Port_Moresby',
  RKV: 'Atlantic/Reykjavik',
  RKW: 'America/Chicago',
  RKY: 'Australia/Brisbane',
  RKZ: 'Asia/Urumqi',
  RLD: 'America/Los_Angeles',
  RLG: 'Europe/Berlin',
  RLK: 'Asia/Shanghai',
  RLO: 'America/Argentina/San_Luis',
  RLP: 'Australia/Brisbane',
  RLR: 'Indian/Antananarivo',
  RLT: 'Africa/Niamey',
  RMA: 'Australia/Brisbane',
  RMB: 'Asia/Muscat',
  RMD: 'Asia/Kolkata',
  RME: 'America/New_York',
  RMF: 'Africa/Cairo',
  RMG: 'America/New_York',
  RMI: 'Europe/Rome',
  RMK: 'Australia/Adelaide',
  RML: 'Asia/Colombo',
  RMN: 'Pacific/Port_Moresby',
  RMP: 'America/Anchorage',
  RMQ: 'Asia/Taipei',
  RMS: 'Europe/Berlin',
  RMT: 'Pacific/Tahiti',
  RMU: 'Europe/Madrid',
  RMY: 'America/Los_Angeles',
  RNA: 'Pacific/Guadalcanal',
  RNB: 'Europe/Stockholm',
  RNC: 'America/Chicago',
  RND: 'America/Chicago',
  RNE: 'Europe/Paris',
  RNG: 'America/Denver',
  RNH: 'America/Chicago',
  RNI: 'America/Managua',
  RNJ: 'Asia/Tokyo',
  RNL: 'Pacific/Guadalcanal',
  RNM: 'Asia/Muscat',
  RNN: 'Europe/Copenhagen',
  RNO: 'America/Los_Angeles',
  RNP: 'Pacific/Kwajalein',
  RNR: 'Pacific/Port_Moresby',
  RNS: 'Europe/Paris',
  RNT: 'America/Los_Angeles',
  RNU: 'Asia/Kuching',
  RNZ: 'America/Chicago',
  ROA: 'America/New_York',
  ROB: 'Africa/Monrovia',
  ROC: 'America/New_York',
  ROD: 'Africa/Johannesburg',
  ROF: 'America/Los_Angeles',
  ROG: 'America/Chicago',
  ROH: 'Australia/Brisbane',
  ROI: 'Asia/Bangkok',
  ROK: 'Australia/Brisbane',
  ROL: 'America/Denver',
  ROM: 'Europe/Rome',
  RON: 'America/Bogota',
  ROO: 'America/Cuiaba',
  ROP: 'Pacific/Saipan',
  ROR: 'Pacific/Palau',
  ROS: 'America/Argentina/Cordoba',
  ROT: 'Pacific/Auckland',
  ROU: 'Europe/Sofia',
  ROV: 'Europe/Moscow',
  ROW: 'America/Denver',
  ROX: 'America/Chicago',
  ROY: 'America/Argentina/Catamarca',
  ROZ: 'Europe/Madrid',
  RPA: 'Asia/Kathmandu',
  RPB: 'Australia/Darwin',
  RPM: 'Australia/Darwin',
  RPN: 'Asia/Jerusalem',
  RPR: 'Asia/Kolkata',
  RPV: 'Australia/Darwin',
  RPX: 'America/Denver',
  RQA: 'Asia/Urumqi',
  RQW: 'Asia/Baghdad',
  RRE: 'Australia/Adelaide',
  RRG: 'Indian/Mauritius',
  RRI: 'Pacific/Guadalcanal',
  RRK: 'Asia/Kolkata',
  RRL: 'America/Chicago',
  RRM: 'Africa/Maputo',
  RRR: 'Pacific/Tahiti',
  RRS: 'Europe/Oslo',
  RRT: 'America/Chicago',
  RRV: 'Australia/Darwin',
  RSA: 'America/Argentina/Salta',
  RSB: 'Australia/Brisbane',
  RSD: 'America/Nassau',
  RSE: 'Australia/Sydney',
  RSH: 'America/Anchorage',
  RSJ: 'America/Los_Angeles',
  RSK: 'Asia/Jayapura',
  RSL: 'America/Chicago',
  RSN: 'America/Chicago',
  RSS: 'Africa/Khartoum',
  RST: 'America/Chicago',
  RSU: 'Asia/Seoul',
  RSW: 'America/New_York',
  RSX: 'America/New_York',
  RTA: 'Pacific/Fiji',
  RTB: 'America/Tegucigalpa',
  RTC: 'Asia/Kolkata',
  RTG: 'Asia/Makassar',
  RTI: 'Asia/Makassar',
  RTL: 'America/Chicago',
  RTM: 'Europe/Amsterdam',
  RTN: 'America/Denver',
  RTP: 'Australia/Brisbane',
  RTS: 'Australia/Perth',
  RTW: 'Europe/Volgograd',
  RTY: 'Australia/Adelaide',
  RUA: 'Africa/Kampala',
  RUD: 'Asia/Tehran',
  RUE: 'Africa/Lubumbashi',
  RUF: 'Asia/Jayapura',
  RUG: 'Asia/Shanghai',
  RUH: 'Asia/Riyadh',
  RUI: 'America/Denver',
  RUK: 'Asia/Kathmandu',
  RUM: 'Asia/Kathmandu',
  RUN: 'Indian/Reunion',
  RUP: 'Asia/Kolkata',
  RUR: 'Pacific/Tahiti',
  RUS: 'Pacific/Guadalcanal',
  RUT: 'America/New_York',
  RUU: 'Pacific/Port_Moresby',
  RUV: 'America/Guatemala',
  RUY: 'America/Tegucigalpa',
  RVA: 'Indian/Antananarivo',
  RVC: 'Africa/Monrovia',
  RVD: 'America/Sao_Paulo',
  RVE: 'America/Bogota',
  RVH: 'Europe/Moscow',
  RVK: 'Europe/Oslo',
  RVN: 'Europe/Helsinki',
  RVO: 'Africa/Johannesburg',
  RVR: 'America/Denver',
  RVS: 'America/Chicago',
  RVT: 'Australia/Perth',
  RVV: 'Pacific/Tahiti',
  RVY: 'America/Montevideo',
  RWF: 'America/Chicago',
  RWI: 'America/New_York',
  RWL: 'America/Denver',
  RWN: 'Europe/Kiev',
  RXA: 'Asia/Aden',
  RXE: 'America/Boise',
  RXS: 'Asia/Manila',
  RYB: 'Europe/Moscow',
  RYG: 'Europe/Oslo',
  RYK: 'Asia/Karachi',
  RYL: 'Africa/Lusaka',
  RYN: 'Europe/Paris',
  RYO: 'America/Argentina/Rio_Gallegos',
  RZA: 'America/Argentina/Rio_Gallegos',
  RZE: 'Europe/Warsaw',
  RZH: 'Asia/Vladivostok',
  RZN: 'Europe/Moscow',
  RZP: 'Asia/Manila',
  RZR: 'Asia/Tehran',
  RZS: 'Asia/Karachi',
  RZZ: 'America/New_York',
  SAA: 'America/Denver',
  SAB: 'America/Kralendijk',
  SAC: 'America/Los_Angeles',
  SAD: 'America/Phoenix',
  SAF: 'America/Denver',
  SAG: 'Asia/Kolkata',
  SAH: 'Asia/Aden',
  SAK: 'Atlantic/Reykjavik',
  SAL: 'America/El_Salvador',
  SAM: 'Pacific/Port_Moresby',
  SAN: 'America/Los_Angeles',
  SAO: 'America/Sao_Paulo',
  SAP: 'America/Tegucigalpa',
  SAQ: 'America/Nassau',
  SAR: 'America/Chicago',
  SAS: 'America/Los_Angeles',
  SAT: 'America/Chicago',
  SAU: 'Asia/Makassar',
  SAV: 'America/New_York',
  SAW: 'Europe/Istanbul',
  SAX: 'America/Panama',
  SAY: 'Europe/Rome',
  SAZ: 'Africa/Monrovia',
  SBA: 'America/Los_Angeles',
  SBB: 'America/Caracas',
  SBC: 'Pacific/Port_Moresby',
  SBD: 'America/Los_Angeles',
  SBE: 'Pacific/Port_Moresby',
  SBF: 'Asia/Kabul',
  SBG: 'Asia/Jakarta',
  SBH: 'America/St_Barthelemy',
  SBI: 'Africa/Conakry',
  SBJ: 'America/Sao_Paulo',
  SBK: 'Europe/Paris',
  SBL: 'America/La_Paz',
  SBM: 'America/Chicago',
  SBN: 'America/Indiana/Indianapolis',
  SBO: 'America/Denver',
  SBP: 'America/Los_Angeles',
  SBQ: 'Asia/Karachi',
  SBR: 'Australia/Brisbane',
  SBS: 'America/Denver',
  SBT: 'Asia/Yekaterinburg',
  SBU: 'Africa/Johannesburg',
  SBV: 'Pacific/Bougainville',
  SBW: 'Asia/Kuching',
  SBX: 'America/Denver',
  SBY: 'America/New_York',
  SBZ: 'Europe/Bucharest',
  SCA: 'America/Bogota',
  SCB: 'America/Chicago',
  SCC: 'America/Anchorage',
  SCD: 'America/Tegucigalpa',
  SCE: 'America/New_York',
  SCF: 'America/Phoenix',
  SCG: 'Australia/Brisbane',
  SCH: 'America/New_York',
  SCI: 'America/Caracas',
  SCK: 'America/Los_Angeles',
  SCL: 'America/Santiago',
  SCM: 'America/Nome',
  SCN: 'Europe/Berlin',
  SCO: 'Asia/Aqtau',
  SCP: 'Europe/Paris',
  SCQ: 'Europe/Madrid',
  SCS: 'Europe/London',
  SCT: 'Asia/Aden',
  SCU: 'America/Havana',
  SCV: 'Europe/Bucharest',
  SCW: 'Europe/Moscow',
  SCX: 'America/Mexico_City',
  SCY: 'Pacific/Galapagos',
  SCZ: 'Pacific/Guadalcanal',
  SDB: 'Africa/Johannesburg',
  SDC: 'America/Guyana',
  SDD: 'Africa/Luanda',
  SDE: 'America/Argentina/Cordoba',
  SDF: 'America/Kentucky/Louisville',
  SDG: 'Asia/Tehran',
  SDH: 'America/Tegucigalpa',
  SDI: 'Pacific/Port_Moresby',
  SDJ: 'Asia/Tokyo',
  SDK: 'Asia/Kuching',
  SDL: 'Europe/Stockholm',
  SDM: 'America/Los_Angeles',
  SDN: 'Europe/Oslo',
  SDP: 'America/Anchorage',
  SDQ: 'America/Santo_Domingo',
  SDR: 'Europe/Madrid',
  SDS: 'Asia/Tokyo',
  SDT: 'Asia/Karachi',
  SDU: 'America/Sao_Paulo',
  SDV: 'Asia/Jerusalem',
  SDX: 'America/Phoenix',
  SDY: 'America/Denver',
  SDZ: 'Europe/London',
  SEA: 'America/Los_Angeles',
  SEB: 'Africa/Tripoli',
  SED: 'Asia/Jerusalem',
  SEE: 'America/Los_Angeles',
  SEF: 'America/New_York',
  SEG: 'America/New_York',
  SEH: 'Asia/Jayapura',
  SEK: 'Asia/Magadan',
  SEL: 'Asia/Seoul',
  SEM: 'America/Chicago',
  SEN: 'Europe/London',
  SEO: 'Africa/Abidjan',
  SEP: 'America/Chicago',
  SEQ: 'Asia/Pontianak',
  SER: 'America/Indiana/Indianapolis',
  SET: 'America/Recife',
  SEU: 'Africa/Dar_es_Salaam',
  SEV: 'Europe/Zaporozhye',
  SEW: 'Africa/Cairo',
  SEY: 'Africa/Nouakchott',
  SEZ: 'Indian/Mahe',
  SFA: 'Africa/Tunis',
  SFB: 'America/New_York',
  SFC: 'America/Guadeloupe',
  SFD: 'America/Caracas',
  SFE: 'Asia/Manila',
  SFF: 'America/Los_Angeles',
  SFG: 'America/Marigot',
  SFH: 'America/Tijuana',
  SFJ: 'America/Godthab',
  SFK: 'America/Belem',
  SFL: 'Atlantic/Cape_Verde',
  SFM: 'America/New_York',
  SFN: 'America/Argentina/Cordoba',
  SFO: 'America/Los_Angeles',
  SFQ: 'Europe/Istanbul',
  SFS: 'Asia/Manila',
  SFT: 'Europe/Stockholm',
  SFU: 'Pacific/Port_Moresby',
  SFV: 'America/Sao_Paulo',
  SFX: 'America/Caracas',
  SFY: 'America/New_York',
  SFZ: 'America/New_York',
  SGA: 'Asia/Kabul',
  SGB: 'Pacific/Port_Moresby',
  SGC: 'Asia/Yekaterinburg',
  SGD: 'Europe/Copenhagen',
  SGE: 'Europe/Berlin',
  SGF: 'America/Chicago',
  SGH: 'America/New_York',
  SGI: 'Asia/Karachi',
  SGJ: 'Pacific/Port_Moresby',
  SGK: 'Pacific/Port_Moresby',
  SGL: 'Asia/Manila',
  SGM: 'America/Mazatlan',
  SGN: 'Asia/Ho_Chi_Minh',
  SGO: 'Australia/Brisbane',
  SGP: 'Australia/Perth',
  SGQ: 'Asia/Makassar',
  SGR: 'America/Chicago',
  SGT: 'America/Chicago',
  SGU: 'America/Denver',
  SGV: 'America/Argentina/Salta',
  SGW: 'America/Juneau',
  SGX: 'Africa/Dar_es_Salaam',
  SGY: 'America/Juneau',
  SGZ: 'Asia/Bangkok',
  SHA: 'Asia/Shanghai',
  SHB: 'Asia/Tokyo',
  SHC: 'Africa/Addis_Ababa',
  SHD: 'America/New_York',
  SHE: 'Asia/Shanghai',
  SHF: 'Asia/Urumqi',
  SHG: 'America/Anchorage',
  SHH: 'America/Nome',
  SHI: 'Asia/Tokyo',
  SHJ: 'Asia/Dubai',
  SHK: 'Africa/Maseru',
  SHL: 'Asia/Kolkata',
  SHM: 'Asia/Tokyo',
  SHN: 'America/Los_Angeles',
  SHO: 'Africa/Mbabane',
  SHQ: 'Australia/Brisbane',
  SHR: 'America/Denver',
  SHS: 'Asia/Shanghai',
  SHT: 'Australia/Melbourne',
  SHU: 'Australia/Darwin',
  SHV: 'America/Chicago',
  SHW: 'Asia/Riyadh',
  SHX: 'America/Anchorage',
  SHY: 'Africa/Dar_es_Salaam',
  SHZ: 'Africa/Maseru',
  SIA: 'Asia/Shanghai',
  SIB: 'Africa/Brazzaville',
  SIC: 'America/Panama',
  SID: 'Atlantic/Cape_Verde',
  SIE: 'Europe/Lisbon',
  SIF: 'Asia/Kathmandu',
  SIG: 'America/Puerto_Rico',
  SIH: 'Asia/Kathmandu',
  SII: 'Africa/Casablanca',
  SIJ: 'Atlantic/Reykjavik',
  SIK: 'America/Chicago',
  SIL: 'Pacific/Port_Moresby',
  SIM: 'Pacific/Port_Moresby',
  SIN: 'Asia/Singapore',
  SIO: 'Australia/Hobart',
  SIP: 'Europe/Simferopol',
  SIQ: 'Asia/Pontianak',
  SIR: 'Europe/Zurich',
  SIS: 'Africa/Johannesburg',
  SIT: 'America/Sitka',
  SIU: 'America/Managua',
  SIV: 'America/Indiana/Indianapolis',
  SIW: 'Asia/Jakarta',
  SIX: 'Australia/Sydney',
  SIY: 'America/Los_Angeles',
  SIZ: 'Pacific/Port_Moresby',
  SJA: 'America/Lima',
  SJB: 'America/La_Paz',
  SJC: 'America/Los_Angeles',
  SJD: 'America/Mazatlan',
  SJE: 'America/Bogota',
  SJF: 'America/St_Thomas',
  SJG: 'America/Bogota',
  SJH: 'America/Bogota',
  SJI: 'Asia/Manila',
  SJJ: 'Europe/Sarajevo',
  SJK: 'America/Sao_Paulo',
  SJL: 'America/Boa_Vista',
  SJN: 'America/Phoenix',
  SJO: 'America/Costa_Rica',
  SJP: 'America/Sao_Paulo',
  SJQ: 'Africa/Lusaka',
  SJR: 'America/Bogota',
  SJS: 'America/La_Paz',
  SJT: 'America/Chicago',
  SJU: 'America/Puerto_Rico',
  SJV: 'America/La_Paz',
  SJW: 'Asia/Shanghai',
  SJX: 'America/Belize',
  SJY: 'Europe/Helsinki',
  SJZ: 'Atlantic/Azores',
  SKA: 'America/Los_Angeles',
  SKB: 'America/St_Kitts',
  SKC: 'Pacific/Port_Moresby',
  SKD: 'Asia/Samarkand',
  SKE: 'Europe/Oslo',
  SKF: 'America/Chicago',
  SKG: 'Europe/Athens',
  SKH: 'Asia/Kathmandu',
  SKI: 'Africa/Algiers',
  SKK: 'America/Anchorage',
  SKL: 'Europe/London',
  SKM: 'America/Paramaribo',
  SKN: 'Europe/Oslo',
  SKO: 'Africa/Lagos',
  SKP: 'Europe/Skopje',
  SKQ: 'Africa/Maseru',
  SKR: 'Africa/Addis_Ababa',
  SKS: 'Europe/Copenhagen',
  SKT: 'Asia/Karachi',
  SKU: 'Europe/Athens',
  SKV: 'Africa/Cairo',
  SKW: 'America/Anchorage',
  SKX: 'Europe/Moscow',
  SKY: 'America/New_York',
  SKZ: 'Asia/Karachi',
  SLA: 'America/Argentina/Salta',
  SLB: 'America/Chicago',
  SLC: 'America/Denver',
  SLD: 'Europe/Bratislava',
  SLE: 'America/Los_Angeles',
  SLF: 'Asia/Riyadh',
  SLG: 'America/Chicago',
  SLH: 'Pacific/Efate',
  SLI: 'Africa/Lusaka',
  SLJ: 'Australia/Perth',
  SLK: 'America/New_York',
  SLL: 'Asia/Muscat',
  SLM: 'Europe/Madrid',
  SLN: 'America/Chicago',
  SLO: 'America/Chicago',
  SLP: 'America/Mexico_City',
  SLQ: 'America/Anchorage',
  SLR: 'America/Chicago',
  SLS: 'Europe/Sofia',
  SLT: 'America/Denver',
  SLU: 'America/St_Lucia',
  SLV: 'Asia/Kolkata',
  SLW: 'America/Monterrey',
  SLX: 'America/Grand_Turk',
  SLY: 'Asia/Yekaterinburg',
  SLZ: 'America/Belem',
  SMA: 'Atlantic/Azores',
  SMB: 'America/Punta_Arenas',
  SMC: 'America/Bogota',
  SMD: 'America/Indiana/Indianapolis',
  SME: 'America/New_York',
  SMF: 'America/Los_Angeles',
  SMG: 'America/Lima',
  SMH: 'Pacific/Port_Moresby',
  SMI: 'Europe/Athens',
  SMJ: 'Pacific/Port_Moresby',
  SMK: 'America/Nome',
  SML: 'America/Nassau',
  SMM: 'Asia/Kuching',
  SMN: 'America/Boise',
  SMO: 'America/Los_Angeles',
  SMP: 'Pacific/Port_Moresby',
  SMQ: 'Asia/Pontianak',
  SMR: 'America/Bogota',
  SMS: 'Indian/Antananarivo',
  SMT: 'America/Cuiaba',
  SMU: 'America/Anchorage',
  SMV: 'Europe/Zurich',
  SMW: 'Africa/Casablanca',
  SMX: 'America/Los_Angeles',
  SMY: 'Africa/Dakar',
  SMZ: 'America/Paramaribo',
  SNA: 'America/Los_Angeles',
  SNB: 'Australia/Darwin',
  SNC: 'America/Guayaquil',
  SNE: 'Atlantic/Cape_Verde',
  SNF: 'America/Caracas',
  SNG: 'America/La_Paz',
  SNH: 'Australia/Brisbane',
  SNI: 'Africa/Monrovia',
  SNJ: 'America/Havana',
  SNK: 'America/Chicago',
  SNL: 'America/Chicago',
  SNM: 'America/La_Paz',
  SNN: 'Europe/Dublin',
  SNO: 'Asia/Bangkok',
  SNP: 'America/Adak',
  SNQ: 'America/Tijuana',
  SNR: 'Europe/Paris',
  SNS: 'America/Los_Angeles',
  SNT: 'America/Bogota',
  SNU: 'America/Havana',
  SNV: 'America/Caracas',
  SNW: 'Asia/Yangon',
  SNX: 'Asia/Tehran',
  SNY: 'America/Denver',
  SNZ: 'America/Sao_Paulo',
  SOA: 'Asia/Ho_Chi_Minh',
  SOB: 'Europe/Budapest',
  SOC: 'Asia/Jakarta',
  SOD: 'America/Sao_Paulo',
  SOE: 'Africa/Brazzaville',
  SOF: 'Europe/Sofia',
  SOG: 'Europe/Oslo',
  SOH: 'America/Bogota',
  SOJ: 'Europe/Oslo',
  SOK: 'Africa/Maseru',
  SOL: 'America/Nome',
  SOM: 'America/Caracas',
  SON: 'Pacific/Efate',
  SOO: 'Europe/Stockholm',
  SOP: 'America/New_York',
  SOQ: 'Asia/Jayapura',
  SOR: 'Asia/Damascus',
  SOT: 'Europe/Helsinki',
  SOU: 'Europe/London',
  SOV: 'America/Anchorage',
  SOW: 'America/Phoenix',
  SOX: 'America/Bogota',
  SOY: 'Europe/London',
  SOZ: 'Europe/Paris',
  SPA: 'America/New_York',
  SPB: 'America/St_Thomas',
  SPC: 'Atlantic/Canary',
  SPD: 'Asia/Dhaka',
  SPE: 'Asia/Kuching',
  SPF: 'America/Denver',
  SPG: 'America/New_York',
  SPH: 'Pacific/Port_Moresby',
  SPI: 'America/Chicago',
  SPJ: 'Europe/Athens',
  SPK: 'Asia/Tokyo',
  SPM: 'Europe/Berlin',
  SPN: 'Pacific/Saipan',
  SPP: 'Africa/Luanda',
  SPR: 'America/Belize',
  SPS: 'America/Chicago',
  SPT: 'Asia/Kuching',
  SPU: 'Europe/Zagreb',
  SPV: 'Pacific/Port_Moresby',
  SPW: 'America/Chicago',
  SPX: 'Africa/Cairo',
  SPY: 'Africa/Abidjan',
  SPZ: 'America/Chicago',
  SQA: 'America/Los_Angeles',
  SQB: 'America/Bogota',
  SQC: 'Australia/Perth',
  SQD: 'Asia/Shanghai',
  SQE: 'America/Bogota',
  SQF: 'America/Bogota',
  SQG: 'Asia/Pontianak',
  SQH: 'Asia/Ho_Chi_Minh',
  SQI: 'America/Chicago',
  SQJ: 'Asia/Shanghai',
  SQK: 'Africa/Cairo',
  SQL: 'America/Los_Angeles',
  SQM: 'America/Sao_Paulo',
  SQN: 'Asia/Jayapura',
  SQO: 'Europe/Stockholm',
  SQQ: 'Europe/Vilnius',
  SQR: 'Asia/Makassar',
  SQS: 'America/Belize',
  SQT: 'Pacific/Port_Moresby',
  SQU: 'America/Lima',
  SQV: 'America/Los_Angeles',
  SQW: 'Europe/Copenhagen',
  SQX: 'America/Sao_Paulo',
  SQY: 'America/Sao_Paulo',
  SQZ: 'Europe/London',
  SRA: 'America/Sao_Paulo',
  SRB: 'America/La_Paz',
  SRC: 'America/Chicago',
  SRD: 'America/La_Paz',
  SRE: 'America/La_Paz',
  SRF: 'America/Los_Angeles',
  SRG: 'Asia/Jakarta',
  SRH: 'Africa/Ndjamena',
  SRI: 'Asia/Makassar',
  SRJ: 'America/La_Paz',
  SRL: 'America/Mazatlan',
  SRM: 'Australia/Brisbane',
  SRN: 'Australia/Hobart',
  SRO: 'America/Bogota',
  SRP: 'Europe/Oslo',
  SRQ: 'America/New_York',
  SRR: 'Australia/Brisbane',
  SRS: 'America/Bogota',
  SRT: 'Africa/Kampala',
  SRV: 'America/Anchorage',
  SRW: 'America/New_York',
  SRX: 'Africa/Tripoli',
  SRY: 'Asia/Tehran',
  SRZ: 'America/La_Paz',
  SSA: 'America/Bahia',
  SSB: 'America/St_Thomas',
  SSC: 'America/New_York',
  SSD: 'America/Bogota',
  SSE: 'Asia/Kolkata',
  SSF: 'America/Chicago',
  SSG: 'Africa/Malabo',
  SSH: 'Africa/Cairo',
  SSI: 'America/New_York',
  SSJ: 'Europe/Oslo',
  SSK: 'Australia/Perth',
  SSL: 'America/Bogota',
  SSM: 'America/Detroit',
  SSN: 'Asia/Seoul',
  SSO: 'America/Sao_Paulo',
  SSP: 'Australia/Brisbane',
  SSQ: 'America/Toronto',
  SSR: 'Pacific/Efate',
  SSS: 'Pacific/Port_Moresby',
  SST: 'America/Argentina/Buenos_Aires',
  SSV: 'Asia/Manila',
  SSW: 'America/Los_Angeles',
  SSX: 'Africa/Johannesburg',
  SSY: 'Africa/Luanda',
  SSZ: 'America/Sao_Paulo',
  STA: 'Europe/Copenhagen',
  STB: 'America/Caracas',
  STC: 'America/Chicago',
  STD: 'America/Caracas',
  STE: 'America/Chicago',
  STF: 'Australia/Brisbane',
  STG: 'America/Adak',
  STH: 'Australia/Brisbane',
  STI: 'America/Santo_Domingo',
  STJ: 'America/Chicago',
  STK: 'America/Denver',
  STL: 'America/Chicago',
  STM: 'America/Manaus',
  STN: 'Europe/London',
  STO: 'Europe/Stockholm',
  STP: 'America/Chicago',
  STQ: 'America/New_York',
  STR: 'Europe/Berlin',
  STS: 'America/Los_Angeles',
  STT: 'America/St_Thomas',
  STV: 'Asia/Kolkata',
  STW: 'Europe/Moscow',
  STX: 'America/St_Thomas',
  STY: 'America/Montevideo',
  STZ: 'America/Cuiaba',
  SUA: 'America/New_York',
  SUB: 'Asia/Jakarta',
  SUD: 'America/Chicago',
  SUE: 'America/Chicago',
  SUF: 'Europe/Rome',
  SUG: 'Asia/Manila',
  SUH: 'Asia/Muscat',
  SUI: 'Asia/Tbilisi',
  SUJ: 'Europe/Bucharest',
  SUK: 'Asia/Yakutsk',
  SUL: 'Asia/Karachi',
  SUM: 'America/New_York',
  SUN: 'America/Boise',
  SUO: 'America/Los_Angeles',
  SUP: 'Asia/Jakarta',
  SUQ: 'America/Guayaquil',
  SUR: 'America/Toronto',
  SUS: 'America/Chicago',
  SUT: 'Africa/Dar_es_Salaam',
  SUU: 'America/Los_Angeles',
  SUV: 'Pacific/Fiji',
  SUW: 'America/Chicago',
  SUX: 'America/Chicago',
  SUY: 'Asia/Yakutsk',
  SUZ: 'Pacific/Port_Moresby',
  SVA: 'America/Nome',
  SVB: 'Indian/Antananarivo',
  SVC: 'America/Denver',
  SVD: 'America/St_Vincent',
  SVE: 'America/Los_Angeles',
  SVF: 'Africa/Porto-Novo',
  SVG: 'Europe/Oslo',
  SVH: 'America/New_York',
  SVI: 'America/Bogota',
  SVJ: 'Europe/Oslo',
  SVK: 'America/Belize',
  SVL: 'Europe/Helsinki',
  SVM: 'Australia/Brisbane',
  SVN: 'America/New_York',
  SVO: 'Europe/Moscow',
  SVP: 'Africa/Luanda',
  SVQ: 'Europe/Madrid',
  SVS: 'America/Anchorage',
  SVT: 'Africa/Gaborone',
  SVU: 'Pacific/Fiji',
  SVV: 'America/Caracas',
  SVW: 'America/Anchorage',
  SVX: 'Asia/Yekaterinburg',
  SVY: 'Pacific/Guadalcanal',
  SVZ: 'America/Caracas',
  SWA: 'Asia/Shanghai',
  SWB: 'Australia/Perth',
  SWC: 'Australia/Melbourne',
  SWD: 'America/Anchorage',
  SWE: 'Pacific/Port_Moresby',
  SWF: 'America/New_York',
  SWG: 'Pacific/Port_Moresby',
  SWH: 'Australia/Melbourne',
  SWJ: 'Pacific/Efate',
  SWL: 'Asia/Manila',
  SWM: 'America/Cuiaba',
  SWN: 'Asia/Karachi',
  SWO: 'America/Chicago',
  SWP: 'Africa/Windhoek',
  SWQ: 'Asia/Makassar',
  SWR: 'Pacific/Port_Moresby',
  SWS: 'Europe/London',
  SWT: 'Asia/Tomsk',
  SWU: 'Asia/Seoul',
  SWV: 'Asia/Magadan',
  SWW: 'America/Chicago',
  SWX: 'Africa/Gaborone',
  SWY: 'Asia/Kuala_Lumpur',
  SXA: 'Pacific/Port_Moresby',
  SXB: 'Europe/Paris',
  SXE: 'Australia/Melbourne',
  SXF: 'Europe/Berlin',
  SXG: 'Africa/Lusaka',
  SXH: 'Pacific/Port_Moresby',
  SXI: 'Asia/Tehran',
  SXJ: 'Asia/Urumqi',
  SXK: 'Asia/Jayapura',
  SXL: 'Europe/Dublin',
  SXM: 'America/Lower_Princes',
  SXN: 'Africa/Gaborone',
  SXO: 'America/Cuiaba',
  SXP: 'America/Nome',
  SXQ: 'America/Anchorage',
  SXR: 'Asia/Kolkata',
  SXS: 'Asia/Kuching',
  SXT: 'Asia/Kuala_Lumpur',
  SXU: 'Africa/Addis_Ababa',
  SXV: 'Asia/Kolkata',
  SXW: 'Pacific/Port_Moresby',
  SXX: 'America/Santarem',
  SXY: 'America/New_York',
  SXZ: 'Europe/Istanbul',
  SYA: 'America/Adak',
  SYB: 'America/Anchorage',
  SYC: 'America/Lima',
  SYD: 'Australia/Sydney',
  SYE: 'Asia/Aden',
  SYF: 'America/Vancouver',
  SYH: 'Asia/Kathmandu',
  SYI: 'America/Chicago',
  SYJ: 'Asia/Tehran',
  SYK: 'Atlantic/Reykjavik',
  SYM: 'Asia/Shanghai',
  SYN: 'America/Chicago',
  SYO: 'Asia/Tokyo',
  SYP: 'America/Panama',
  SYQ: 'America/Costa_Rica',
  SYR: 'America/New_York',
  SYS: 'Asia/Yakutsk',
  SYT: 'Europe/Paris',
  SYU: 'Australia/Brisbane',
  SYV: 'America/New_York',
  SYW: 'Asia/Karachi',
  SYX: 'Asia/Shanghai',
  SYY: 'Europe/London',
  SYZ: 'Asia/Tehran',
  SZA: 'Africa/Luanda',
  SZB: 'Asia/Kuala_Lumpur',
  SZE: 'Africa/Addis_Ababa',
  SZF: 'Europe/Istanbul',
  SZG: 'Europe/Vienna',
  SZI: 'Asia/Almaty',
  SZJ: 'America/Havana',
  SZK: 'Africa/Johannesburg',
  SZL: 'America/Chicago',
  SZM: 'Africa/Windhoek',
  SZN: 'America/Los_Angeles',
  SZP: 'America/Los_Angeles',
  SZR: 'Europe/Sofia',
  SZS: 'Pacific/Auckland',
  SZU: 'Africa/Bamako',
  SZV: 'Asia/Shanghai',
  SZW: 'Europe/Berlin',
  SZX: 'Asia/Shanghai',
  SZY: 'Europe/Warsaw',
  SZZ: 'Europe/Warsaw',
  TAA: 'Pacific/Guadalcanal',
  TAB: 'America/Port_of_Spain',
  TAC: 'Asia/Manila',
  TAD: 'America/Denver',
  TAE: 'Asia/Seoul',
  TAF: 'Africa/Algiers',
  TAG: 'Asia/Manila',
  TAH: 'Pacific/Efate',
  TAI: 'Asia/Aden',
  TAJ: 'Pacific/Port_Moresby',
  TAK: 'Asia/Tokyo',
  TAL: 'America/Anchorage',
  TAM: 'America/Monterrey',
  TAN: 'Australia/Brisbane',
  TAO: 'Asia/Shanghai',
  TAP: 'America/Merida',
  TAQ: 'Australia/Adelaide',
  TAR: 'Europe/Rome',
  TAS: 'Asia/Tashkent',
  TAT: 'Europe/Bratislava',
  TAU: 'America/Bogota',
  TAV: 'Pacific/Pago_Pago',
  TAW: 'America/Montevideo',
  TAX: 'Asia/Jayapura',
  TAY: 'Europe/Tallinn',
  TAZ: 'Asia/Ashgabat',
  TBA: 'Pacific/Port_Moresby',
  TBB: 'Asia/Ho_Chi_Minh',
  TBC: 'America/Denver',
  TBD: 'America/Bogota',
  TBE: 'Pacific/Port_Moresby',
  TBF: 'Pacific/Tarawa',
  TBG: 'Pacific/Port_Moresby',
  TBH: 'Asia/Manila',
  TBI: 'America/Nassau',
  TBJ: 'Africa/Tunis',
  TBK: 'Australia/Darwin',
  TBL: 'Australia/Perth',
  TBM: 'Asia/Pontianak',
  TBN: 'America/Chicago',
  TBO: 'Africa/Dar_es_Salaam',
  TBP: 'America/Lima',
  TBQ: 'Pacific/Port_Moresby',
  TBR: 'America/New_York',
  TBS: 'Asia/Tbilisi',
  TBT: 'America/Porto_Velho',
  TBU: 'Pacific/Tongatapu',
  TBV: 'Pacific/Majuro',
  TBW: 'Europe/Moscow',
  TBY: 'Africa/Gaborone',
  TBZ: 'Asia/Tehran',
  TCA: 'Australia/Darwin',
  TCB: 'America/Nassau',
  TCC: 'America/Denver',
  TCD: 'America/Bogota',
  TCE: 'Europe/Bucharest',
  TCF: 'America/Tegucigalpa',
  TCG: 'Asia/Urumqi',
  TCH: 'Africa/Libreville',
  TCI: 'Atlantic/Canary',
  TCJ: 'Pacific/Port_Moresby',
  TCK: 'Pacific/Port_Moresby',
  TCL: 'America/Chicago',
  TCM: 'America/Los_Angeles',
  TCN: 'America/Mexico_City',
  TCO: 'America/Bogota',
  TCP: 'Africa/Cairo',
  TCQ: 'America/Lima',
  TCR: 'Asia/Kolkata',
  TCS: 'America/Denver',
  TCT: 'America/Anchorage',
  TCU: 'Africa/Johannesburg',
  TCW: 'Australia/Sydney',
  TCX: 'Asia/Tehran',
  TCY: 'Africa/Windhoek',
  TCZ: 'Asia/Shanghai',
  TDA: 'America/Bogota',
  TDB: 'Pacific/Port_Moresby',
  TDD: 'America/La_Paz',
  TDG: 'Asia/Manila',
  TDJ: 'Africa/Djibouti',
  TDK: 'Asia/Almaty',
  TDL: 'America/Argentina/Buenos_Aires',
  TDN: 'Australia/Perth',
  TDO: 'America/Los_Angeles',
  TDP: 'America/Lima',
  TDR: 'Australia/Brisbane',
  TDS: 'Pacific/Port_Moresby',
  TDT: 'Africa/Johannesburg',
  TDV: 'Indian/Antananarivo',
  TDW: 'America/Chicago',
  TDX: 'Asia/Bangkok',
  TDZ: 'America/New_York',
  TEA: 'America/Tegucigalpa',
  TEB: 'America/New_York',
  TEC: 'America/Sao_Paulo',
  TED: 'Europe/Copenhagen',
  TEE: 'Africa/Algiers',
  TEF: 'Australia/Perth',
  TEG: 'Africa/Ouagadougou',
  TEH: 'America/Anchorage',
  TEI: 'Asia/Kolkata',
  TEK: 'America/Anchorage',
  TEL: 'Asia/Kuching',
  TEM: 'Australia/Sydney',
  TEN: 'Asia/Shanghai',
  TEO: 'Pacific/Port_Moresby',
  TEP: 'Pacific/Port_Moresby',
  TEQ: 'Europe/Istanbul',
  TER: 'Atlantic/Azores',
  TES: 'Africa/Asmara',
  TET: 'Africa/Maputo',
  TEU: 'Pacific/Auckland',
  TEV: 'Europe/Madrid',
  TEX: 'America/Denver',
  TEY: 'Atlantic/Reykjavik',
  TEZ: 'Asia/Kolkata',
  TFB: 'Pacific/Port_Moresby',
  TFF: 'America/Manaus',
  TFI: 'Pacific/Port_Moresby',
  TFL: 'America/Sao_Paulo',
  TFM: 'Pacific/Port_Moresby',
  TFN: 'Atlantic/Canary',
  TFR: 'Africa/Cairo',
  TFS: 'Atlantic/Canary',
  TFT: 'Asia/Karachi',
  TFY: 'Asia/Jakarta',
  TGA: 'Asia/Singapore',
  TGB: 'Asia/Manila',
  TGC: 'Asia/Kuching',
  TGD: 'Europe/Podgorica',
  TGE: 'America/Chicago',
  TGG: 'Asia/Kuala_Lumpur',
  TGH: 'Pacific/Efate',
  TGI: 'America/Lima',
  TGJ: 'Pacific/Noumea',
  TGK: 'Europe/Moscow',
  TGL: 'Pacific/Port_Moresby',
  TGM: 'Europe/Bucharest',
  TGN: 'Australia/Melbourne',
  TGO: 'Asia/Shanghai',
  TGP: 'Asia/Krasnoyarsk',
  TGQ: 'America/Cuiaba',
  TGR: 'Africa/Algiers',
  TGS: 'Africa/Maputo',
  TGT: 'Africa/Dar_es_Salaam',
  TGU: 'America/Tegucigalpa',
  TGV: 'Europe/Sofia',
  TGZ: 'America/Mexico_City',
  THA: 'America/Chicago',
  THB: 'Africa/Maseru',
  THC: 'Africa/Monrovia',
  THD: 'Asia/Ho_Chi_Minh',
  THE: 'America/Fortaleza',
  THG: 'Australia/Brisbane',
  THH: 'Pacific/Auckland',
  THI: 'Africa/Nouakchott',
  THK: 'Asia/Vientiane',
  THL: 'Asia/Yangon',
  THM: 'America/Denver',
  THN: 'Europe/Stockholm',
  THO: 'Atlantic/Reykjavik',
  THP: 'America/Denver',
  THQ: 'Asia/Shanghai',
  THR: 'Asia/Tehran',
  THS: 'Asia/Bangkok',
  THT: 'Africa/Nouakchott',
  THU: 'America/Thule',
  THV: 'America/New_York',
  THW: 'Asia/Colombo',
  THX: 'Asia/Krasnoyarsk',
  THY: 'Africa/Johannesburg',
  THZ: 'Africa/Niamey',
  TIA: 'Europe/Tirane',
  TIB: 'America/Bogota',
  TIC: 'Pacific/Majuro',
  TID: 'Africa/Algiers',
  TIE: 'Africa/Addis_Ababa',
  TIF: 'Asia/Riyadh',
  TIG: 'Pacific/Port_Moresby',
  TIH: 'Pacific/Tahiti',
  TII: 'Asia/Kabul',
  TIJ: 'America/Tijuana',
  TIK: 'America/Chicago',
  TIL: 'America/Edmonton',
  TIM: 'Asia/Jayapura',
  TIN: 'Africa/Algiers',
  TIO: 'Asia/Yangon',
  TIP: 'Africa/Tripoli',
  TIQ: 'Pacific/Saipan',
  TIR: 'Asia/Kolkata',
  TIU: 'Pacific/Auckland',
  TIV: 'Europe/Podgorica',
  TIW: 'America/Los_Angeles',
  TIX: 'America/New_York',
  TIY: 'Africa/Nouakchott',
  TIZ: 'Pacific/Port_Moresby',
  TJA: 'America/La_Paz',
  TJB: 'Asia/Jakarta',
  TJC: 'America/Panama',
  TJG: 'Asia/Jakarta',
  TJH: 'Asia/Tokyo',
  TJI: 'America/Tegucigalpa',
  TJK: 'Europe/Istanbul',
  TJL: 'America/Campo_Grande',
  TJM: 'Asia/Yekaterinburg',
  TJN: 'Pacific/Tahiti',
  TJQ: 'Asia/Jakarta',
  TJS: 'Asia/Makassar',
  TJU: 'Asia/Dushanbe',
  TJV: 'Asia/Kolkata',
  TKA: 'America/Anchorage',
  TKB: 'Pacific/Port_Moresby',
  TKC: 'Africa/Douala',
  TKD: 'Africa/Accra',
  TKE: 'America/Juneau',
  TKF: 'America/Los_Angeles',
  TKG: 'Asia/Jakarta',
  TKH: 'Asia/Bangkok',
  TKI: 'America/Metlakatla',
  TKJ: 'America/Anchorage',
  TKK: 'Pacific/Chuuk',
  TKL: 'America/Juneau',
  TKN: 'Asia/Tokyo',
  TKO: 'Africa/Maseru',
  TKP: 'Pacific/Tahiti',
  TKQ: 'Africa/Dar_es_Salaam',
  TKR: 'Asia/Dhaka',
  TKS: 'Asia/Tokyo',
  TKT: 'Asia/Bangkok',
  TKU: 'Europe/Helsinki',
  TKV: 'Pacific/Tahiti',
  TKW: 'Pacific/Port_Moresby',
  TKX: 'Pacific/Tahiti',
  TKY: 'Australia/Perth',
  TKZ: 'Pacific/Auckland',
  TLA: 'America/Nome',
  TLB: 'Asia/Karachi',
  TLC: 'America/Mexico_City',
  TLD: 'Africa/Gaborone',
  TLE: 'Indian/Antananarivo',
  TLF: 'America/Anchorage',
  TLG: 'Pacific/Guadalcanal',
  TLH: 'America/New_York',
  TLI: 'Asia/Makassar',
  TLJ: 'America/Anchorage',
  TLK: 'Asia/Yakutsk',
  TLL: 'Europe/Tallinn',
  TLM: 'Africa/Algiers',
  TLN: 'Europe/Paris',
  TLO: 'Pacific/Port_Moresby',
  TLP: 'Pacific/Port_Moresby',
  TLQ: 'Asia/Urumqi',
  TLR: 'America/Los_Angeles',
  TLS: 'Europe/Paris',
  TLT: 'America/Anchorage',
  TLU: 'America/Bogota',
  TLV: 'Asia/Jerusalem',
  TLW: 'Pacific/Port_Moresby',
  TLX: 'America/Santiago',
  TLY: 'Asia/Vladivostok',
  TLZ: 'America/Sao_Paulo',
  TMA: 'America/New_York',
  TMB: 'America/New_York',
  TMC: 'Asia/Makassar',
  TMD: 'Africa/Nouakchott',
  TME: 'America/Bogota',
  TMF: 'Indian/Maldives',
  TMG: 'Asia/Kuching',
  TMH: 'Asia/Jayapura',
  TMI: 'Asia/Kathmandu',
  TMJ: 'Asia/Samarkand',
  TMK: 'Asia/Ho_Chi_Minh',
  TML: 'Africa/Accra',
  TMM: 'Indian/Antananarivo',
  TMN: 'Pacific/Tarawa',
  TMO: 'America/Caracas',
  TMP: 'Europe/Helsinki',
  TMQ: 'Africa/Ouagadougou',
  TMR: 'Africa/Algiers',
  TMS: 'Africa/Sao_Tome',
  TMT: 'America/Santarem',
  TMU: 'America/Costa_Rica',
  TMW: 'Australia/Sydney',
  TMX: 'Africa/Algiers',
  TMY: 'Asia/Jayapura',
  TMZ: 'Pacific/Auckland',
  TNA: 'Asia/Shanghai',
  TNB: 'Asia/Makassar',
  TNC: 'America/Nome',
  TND: 'America/Havana',
  TNE: 'Asia/Tokyo',
  TNF: 'Europe/Paris',
  TNG: 'Africa/Casablanca',
  TNH: 'Asia/Shanghai',
  TNI: 'Asia/Kolkata',
  TNJ: 'Asia/Pontianak',
  TNK: 'America/Nome',
  TNL: 'Europe/Uzhgorod',
  TNM: 'Antarctica/Palmer',
  TNN: 'Asia/Taipei',
  TNO: 'America/Costa_Rica',
  TNP: 'America/Los_Angeles',
  TNQ: 'Pacific/Kiritimati',
  TNR: 'Indian/Antananarivo',
  TNS: 'America/Yellowknife',
  TNT: 'America/New_York',
  TNU: 'America/Chicago',
  TNV: 'Pacific/Kiritimati',
  TNW: 'America/Guayaquil',
  TNX: 'Asia/Phnom_Penh',
  TNZ: 'Asia/Hovd',
  TOA: 'America/Los_Angeles',
  TOB: 'Africa/Tripoli',
  TOC: 'America/New_York',
  TOD: 'Asia/Kuala_Lumpur',
  TOE: 'Africa/Tunis',
  TOF: 'Asia/Tomsk',
  TOG: 'America/Anchorage',
  TOH: 'Pacific/Efate',
  TOI: 'America/Chicago',
  TOJ: 'Europe/Madrid',
  TOK: 'Pacific/Port_Moresby',
  TOL: 'America/New_York',
  TOM: 'Africa/Bamako',
  TON: 'Pacific/Bougainville',
  TOO: 'America/Costa_Rica',
  TOP: 'America/Chicago',
  TOQ: 'America/Santiago',
  TOR: 'America/Denver',
  TOS: 'Europe/Oslo',
  TOT: 'America/Paramaribo',
  TOU: 'Pacific/Noumea',
  TOV: 'America/Tortola',
  TOW: 'America/Sao_Paulo',
  TOX: 'Asia/Yekaterinburg',
  TOY: 'Asia/Tokyo',
  TOZ: 'Africa/Abidjan',
  TPA: 'America/New_York',
  TPC: 'America/Guayaquil',
  TPE: 'Asia/Taipei',
  TPF: 'America/New_York',
  TPG: 'Asia/Kuala_Lumpur',
  TPH: 'America/Los_Angeles',
  TPI: 'Pacific/Port_Moresby',
  TPJ: 'Asia/Kathmandu',
  TPK: 'Asia/Jakarta',
  TPL: 'America/Chicago',
  TPN: 'America/Guayaquil',
  TPP: 'America/Lima',
  TPQ: 'America/Mazatlan',
  TPR: 'Australia/Perth',
  TPS: 'Europe/Rome',
  TPT: 'Africa/Monrovia',
  TPU: 'Asia/Kathmandu',
  TPX: 'Pacific/Tahiti',
  TQD: 'Asia/Baghdad',
  TQL: 'Asia/Yekaterinburg',
  TQN: 'Asia/Kabul',
  TQP: 'Australia/Brisbane',
  TQQ: 'Asia/Makassar',
  TQS: 'America/Bogota',
  TRA: 'Asia/Tokyo',
  TRB: 'America/Bogota',
  TRC: 'America/Monterrey',
  TRD: 'Europe/Oslo',
  TRE: 'Europe/London',
  TRF: 'Europe/Oslo',
  TRG: 'Pacific/Auckland',
  TRH: 'America/Los_Angeles',
  TRI: 'America/New_York',
  TRJ: 'Pacific/Port_Moresby',
  TRK: 'Asia/Makassar',
  TRL: 'America/Chicago',
  TRM: 'America/Los_Angeles',
  TRN: 'Europe/Rome',
  TRO: 'Australia/Sydney',
  TRQ: 'America/Eirunepe',
  TRR: 'Asia/Colombo',
  TRS: 'Europe/Rome',
  TRU: 'America/Lima',
  TRV: 'Asia/Kolkata',
  TRW: 'Pacific/Tarawa',
  TRX: 'America/Chicago',
  TRY: 'Africa/Kampala',
  TRZ: 'Asia/Kolkata',
  TSA: 'Asia/Taipei',
  TSB: 'Africa/Windhoek',
  TSC: 'America/Guayaquil',
  TSD: 'Africa/Johannesburg',
  TSE: 'Asia/Almaty',
  TSF: 'Europe/Rome',
  TSG: 'America/Anchorage',
  TSH: 'Africa/Lubumbashi',
  TSI: 'Pacific/Port_Moresby',
  TSJ: 'Asia/Tokyo',
  TSK: 'Pacific/Port_Moresby',
  TSL: 'America/Mexico_City',
  TSM: 'America/Denver',
  TSN: 'Asia/Shanghai',
  TSP: 'America/Los_Angeles',
  TSQ: 'America/Sao_Paulo',
  TSR: 'Europe/Bucharest',
  TST: 'Asia/Bangkok',
  TSU: 'Pacific/Tarawa',
  TSV: 'Australia/Brisbane',
  TSW: 'Pacific/Port_Moresby',
  TSX: 'Asia/Makassar',
  TSY: 'Asia/Jakarta',
  TSZ: 'Asia/Ulaanbaatar',
  TTA: 'Africa/Casablanca',
  TTB: 'Europe/Rome',
  TTC: 'America/Santiago',
  TTD: 'America/Los_Angeles',
  TTE: 'Asia/Jayapura',
  TTG: 'America/Argentina/Salta',
  TTH: 'Asia/Muscat',
  TTI: 'Pacific/Tahiti',
  TTJ: 'Asia/Tokyo',
  TTL: 'Pacific/Fiji',
  TTM: 'America/Bogota',
  TTN: 'America/New_York',
  TTO: 'America/Chicago',
  TTQ: 'America/Costa_Rica',
  TTR: 'Asia/Makassar',
  TTS: 'Indian/Antananarivo',
  TTT: 'Asia/Taipei',
  TTU: 'Africa/Casablanca',
  TTW: 'Asia/Colombo',
  TTX: 'Australia/Perth',
  TUA: 'America/Guayaquil',
  TUB: 'Pacific/Tahiti',
  TUC: 'America/Argentina/Tucuman',
  TUD: 'Africa/Dakar',
  TUF: 'Europe/Paris',
  TUG: 'Asia/Manila',
  TUI: 'Asia/Riyadh',
  TUJ: 'Africa/Addis_Ababa',
  TUK: 'Asia/Karachi',
  TUL: 'America/Chicago',
  TUM: 'Australia/Sydney',
  TUN: 'Africa/Tunis',
  TUO: 'Pacific/Auckland',
  TUP: 'America/Chicago',
  TUQ: 'Africa/Ouagadougou',
  TUR: 'America/Belem',
  TUS: 'America/Phoenix',
  TUT: 'Pacific/Port_Moresby',
  TUU: 'Asia/Riyadh',
  TUV: 'America/Caracas',
  TUW: 'America/Panama',
  TUX: 'America/Dawson_Creek',
  TUY: 'America/Cancun',
  TUZ: 'America/Santarem',
  TVA: 'Indian/Antananarivo',
  TVC: 'America/Detroit',
  TVF: 'America/Chicago',
  TVI: 'America/New_York',
  TVL: 'America/Los_Angeles',
  TVS: 'Asia/Shanghai',
  TVU: 'Pacific/Fiji',
  TVY: 'Asia/Yangon',
  TWA: 'America/Anchorage',
  TWB: 'Australia/Brisbane',
  TWC: 'Asia/Shanghai',
  TWD: 'America/Los_Angeles',
  TWE: 'America/Nome',
  TWF: 'America/Boise',
  TWN: 'Australia/Brisbane',
  TWP: 'Australia/Brisbane',
  TWT: 'Asia/Manila',
  TWU: 'Asia/Kuching',
  TWY: 'Pacific/Port_Moresby',
  TWZ: 'Pacific/Auckland',
  TXE: 'Asia/Jakarta',
  TXF: 'America/Bahia',
  TXK: 'America/Chicago',
  TXL: 'Europe/Berlin',
  TXM: 'Asia/Jayapura',
  TXN: 'Asia/Shanghai',
  TXR: 'Australia/Brisbane',
  TXU: 'Africa/Abidjan',
  TYA: 'Europe/Moscow',
  TYB: 'Australia/Sydney',
  TYD: 'Asia/Yakutsk',
  TYE: 'America/Anchorage',
  TYF: 'Europe/Stockholm',
  TYG: 'Australia/Brisbane',
  TYL: 'America/Lima',
  TYM: 'America/Nassau',
  TYN: 'Asia/Shanghai',
  TYO: 'Asia/Tokyo',
  TYP: 'Australia/Darwin',
  TYR: 'America/Chicago',
  TYS: 'America/New_York',
  TYT: 'America/Montevideo',
  TYZ: 'America/Phoenix',
  TZA: 'America/Belize',
  TZC: 'America/Detroit',
  TZL: 'Europe/Sarajevo',
  TZM: 'America/Merida',
  TZN: 'America/Nassau',
  TZO: 'Indian/Antananarivo',
  TZX: 'Europe/Istanbul',
  UAB: 'Europe/Istanbul',
  UAC: 'America/Hermosillo',
  UAE: 'Pacific/Port_Moresby',
  UAH: 'Pacific/Marquesas',
  UAI: 'Asia/Dili',
  UAK: 'America/Godthab',
  UAL: 'Africa/Luanda',
  UAM: 'Pacific/Guam',
  UAP: 'Pacific/Marquesas',
  UAQ: 'America/Argentina/San_Juan',
  UAR: 'Africa/Casablanca',
  UAS: 'Africa/Nairobi',
  UAX: 'America/Guatemala',
  UBA: 'America/Sao_Paulo',
  UBB: 'Australia/Brisbane',
  UBI: 'Pacific/Bougainville',
  UBJ: 'Asia/Tokyo',
  UBN: 'Asia/Ulaanbaatar',
  UBP: 'Asia/Bangkok',
  UBR: 'Asia/Jayapura',
  UBS: 'America/Chicago',
  UBT: 'America/Sao_Paulo',
  UBU: 'Australia/Perth',
  UCB: 'Asia/Shanghai',
  UCC: 'America/Los_Angeles',
  UCE: 'America/Chicago',
  UCK: 'Europe/Uzhgorod',
  UCN: 'Africa/Monrovia',
  UCT: 'Europe/Moscow',
  UCY: 'America/Chicago',
  UDA: 'Australia/Brisbane',
  UDD: 'America/Los_Angeles',
  UDE: 'Europe/Amsterdam',
  UDI: 'America/Sao_Paulo',
  UDJ: 'Europe/Uzhgorod',
  UDN: 'Europe/Rome',
  UDR: 'Asia/Kolkata',
  UEE: 'Australia/Hobart',
  UEL: 'Africa/Maputo',
  UEN: 'Asia/Yekaterinburg',
  UEO: 'Asia/Tokyo',
  UES: 'America/Chicago',
  UET: 'Asia/Karachi',
  UFA: 'Asia/Yekaterinburg',
  UGA: 'Asia/Ulaanbaatar',
  UGB: 'America/Anchorage',
  UGC: 'Asia/Samarkand',
  UGI: 'America/Anchorage',
  UGN: 'America/Chicago',
  UGO: 'Africa/Luanda',
  UGS: 'America/Anchorage',
  UGT: 'Asia/Ulaanbaatar',
  UGU: 'Asia/Jayapura',
  UHE: 'Europe/Prague',
  UIB: 'America/Bogota',
  UIH: 'Asia/Ho_Chi_Minh',
  UII: 'America/Tegucigalpa',
  UIK: 'Asia/Irkutsk',
  UIL: 'America/Los_Angeles',
  UIN: 'America/Chicago',
  UIO: 'America/Guayaquil',
  UIP: 'Europe/Paris',
  UIQ: 'Pacific/Efate',
  UIR: 'Australia/Sydney',
  UIT: 'Pacific/Majuro',
  UJE: 'Pacific/Kwajalein',
  UJN: 'Asia/Seoul',
  UJU: 'Asia/Pyongyang',
  UKA: 'Africa/Nairobi',
  UKB: 'Asia/Tokyo',
  UKG: 'Asia/Vladivostok',
  UKH: 'Asia/Muscat',
  UKI: 'America/Los_Angeles',
  UKK: 'Asia/Almaty',
  UKN: 'America/Chicago',
  UKR: 'Asia/Aden',
  UKS: 'Europe/Simferopol',
  UKT: 'America/New_York',
  UKU: 'Pacific/Port_Moresby',
  UKX: 'Asia/Irkutsk',
  ULA: 'America/Argentina/Rio_Gallegos',
  ULB: 'Pacific/Efate',
  ULD: 'Africa/Johannesburg',
  ULE: 'Pacific/Port_Moresby',
  ULG: 'Asia/Hovd',
  ULH: 'Asia/Riyadh',
  ULI: 'Pacific/Chuuk',
  ULK: 'Asia/Yakutsk',
  ULL: 'Europe/London',
  ULM: 'America/Chicago',
  ULN: 'Asia/Ulaanbaatar',
  ULO: 'Asia/Hovd',
  ULP: 'Australia/Brisbane',
  ULQ: 'America/Bogota',
  ULS: 'America/Bogota',
  ULU: 'Africa/Kampala',
  ULV: 'Europe/Ulyanovsk',
  ULX: 'Africa/Johannesburg',
  ULY: 'Europe/Ulyanovsk',
  ULZ: 'Asia/Hovd',
  UMA: 'America/Havana',
  UMC: 'Pacific/Port_Moresby',
  UME: 'Europe/Stockholm',
  UMI: 'America/Lima',
  UMM: 'America/Anchorage',
  UMR: 'Australia/Adelaide',
  UMS: 'Asia/Vladivostok',
  UMT: 'America/Anchorage',
  UMU: 'America/Sao_Paulo',
  UMY: 'Europe/Kiev',
  UMZ: 'America/Chicago',
  UNA: 'America/Bahia',
  UNC: 'America/Bogota',
  UND: 'Asia/Kabul',
  UNE: 'Africa/Maseru',
  UNG: 'Pacific/Port_Moresby',
  UNI: 'America/St_Vincent',
  UNK: 'America/Anchorage',
  UNN: 'Asia/Bangkok',
  UNR: 'Asia/Ulaanbaatar',
  UNT: 'Europe/London',
  UNU: 'America/Chicago',
  UOA: 'Pacific/Tahiti',
  UOL: 'Asia/Makassar',
  UOS: 'America/Chicago',
  UOX: 'America/Chicago',
  UPB: 'America/Havana',
  UPG: 'Asia/Makassar',
  UPL: 'America/Costa_Rica',
  UPN: 'America/Mexico_City',
  UPP: 'Pacific/Honolulu',
  UPR: 'Pacific/Port_Moresby',
  UPV: 'Europe/London',
  URA: 'Asia/Oral',
  URB: 'America/Sao_Paulo',
  URC: 'Asia/Urumqi',
  URD: 'Europe/Berlin',
  URE: 'Europe/Tallinn',
  URG: 'America/Sao_Paulo',
  URI: 'America/Bogota',
  URJ: 'Asia/Yekaterinburg',
  URM: 'America/Caracas',
  URN: 'Asia/Kabul',
  URO: 'Europe/Paris',
  URR: 'America/Bogota',
  URS: 'Europe/Moscow',
  URT: 'Asia/Bangkok',
  URU: 'Pacific/Port_Moresby',
  URY: 'Asia/Riyadh',
  URZ: 'Asia/Kabul',
  USA: 'America/New_York',
  USC: 'America/New_York',
  USH: 'America/Argentina/Ushuaia',
  USI: 'America/Guyana',
  USJ: 'Asia/Almaty',
  USK: 'Europe/Moscow',
  USL: 'Australia/Perth',
  USM: 'Asia/Bangkok',
  USN: 'Asia/Seoul',
  USO: 'Pacific/Port_Moresby',
  USQ: 'Europe/Istanbul',
  USR: 'Asia/Magadan',
  USS: 'America/Havana',
  UST: 'America/New_York',
  USU: 'Asia/Manila',
  UTA: 'Africa/Harare',
  UTB: 'Australia/Brisbane',
  UTC: 'Europe/Amsterdam',
  UTD: 'Australia/Darwin',
  UTG: 'Africa/Maseru',
  UTH: 'Asia/Bangkok',
  UTI: 'Europe/Helsinki',
  UTK: 'Pacific/Kwajalein',
  UTM: 'America/Chicago',
  UTN: 'Africa/Johannesburg',
  UTO: 'America/Anchorage',
  UTP: 'Asia/Bangkok',
  UTS: 'Europe/Moscow',
  UTT: 'Africa/Johannesburg',
  UTU: 'America/Panama',
  UTW: 'Africa/Johannesburg',
  UUA: 'Europe/Moscow',
  UUD: 'Asia/Irkutsk',
  UUK: 'America/Anchorage',
  UUN: 'Asia/Choibalsan',
  UUS: 'Asia/Sakhalin',
  UUU: 'Pacific/Port_Moresby',
  UVA: 'America/Chicago',
  UVE: 'Pacific/Noumea',
  UVF: 'America/St_Lucia',
  UVL: 'Africa/Cairo',
  UVO: 'Pacific/Port_Moresby',
  UWA: 'America/New_York',
  UYL: 'Africa/Khartoum',
  UYN: 'Asia/Shanghai',
  UYU: 'America/La_Paz',
  UZC: 'Europe/Belgrade',
  UZM: 'America/Cambridge_Bay',
  UZR: 'Asia/Almaty',
  UZU: 'America/Argentina/Cordoba',
  VAA: 'Europe/Helsinki',
  VAB: 'America/Bogota',
  VAC: 'Europe/Berlin',
  VAD: 'America/New_York',
  VAF: 'Europe/Paris',
  VAG: 'America/Sao_Paulo',
  VAH: 'America/La_Paz',
  VAI: 'Pacific/Port_Moresby',
  VAK: 'America/Nome',
  VAL: 'America/Bahia',
  VAM: 'Indian/Maldives',
  VAN: 'Europe/Istanbul',
  VAO: 'Pacific/Guadalcanal',
  VAP: 'America/Santiago',
  VAR: 'Europe/Sofia',
  VAS: 'Europe/Istanbul',
  VAT: 'Indian/Antananarivo',
  VAU: 'Pacific/Fiji',
  VAV: 'Pacific/Tongatapu',
  VAW: 'Europe/Oslo',
  VBA: 'Asia/Yangon',
  VBC: 'Asia/Yangon',
  VBG: 'America/Los_Angeles',
  VBP: 'Asia/Yangon',
  VBS: 'Europe/Rome',
  VBV: 'Pacific/Fiji',
  VBY: 'Europe/Stockholm',
  VCA: 'Asia/Ho_Chi_Minh',
  VCD: 'Australia/Darwin',
  VCE: 'Europe/Rome',
  VCF: 'America/Argentina/Salta',
  VCH: 'America/Montevideo',
  VCL: 'Asia/Ho_Chi_Minh',
  VCP: 'America/Sao_Paulo',
  VCR: 'America/Caracas',
  VCS: 'Asia/Ho_Chi_Minh',
  VCT: 'America/Chicago',
  VCV: 'America/Los_Angeles',
  VDA: 'Asia/Jerusalem',
  VDB: 'Europe/Oslo',
  VDC: 'America/Bahia',
  VDE: 'Atlantic/Canary',
  VDH: 'Asia/Ho_Chi_Minh',
  VDI: 'America/New_York',
  VDM: 'America/Argentina/Salta',
  VDO: 'Asia/Ho_Chi_Minh',
  VDP: 'America/Caracas',
  VDR: 'America/Argentina/Cordoba',
  VDS: 'Europe/Oslo',
  VDY: 'Asia/Kolkata',
  VDZ: 'America/Anchorage',
  VEE: 'America/Anchorage',
  VEG: 'America/Guyana',
  VEL: 'America/Denver',
  VER: 'America/Mexico_City',
  VEV: 'Pacific/Guadalcanal',
  VEX: 'America/Chicago',
  VEY: 'Atlantic/Reykjavik',
  VFA: 'Africa/Harare',
  VGA: 'Asia/Kolkata',
  VGD: 'Europe/Moscow',
  VGO: 'Europe/Madrid',
  VGS: 'America/Argentina/Buenos_Aires',
  VGT: 'America/Los_Angeles',
  VGZ: 'America/Bogota',
  VHC: 'Africa/Luanda',
  VHM: 'Europe/Stockholm',
  VHN: 'America/Chicago',
  VHV: 'Asia/Yakutsk',
  VHY: 'Europe/Paris',
  VHZ: 'Pacific/Tahiti',
  VIA: 'America/Sao_Paulo',
  VIB: 'America/Mazatlan',
  VIC: 'Europe/Rome',
  VIE: 'Europe/Vienna',
  VIG: 'America/Caracas',
  VIH: 'America/Chicago',
  VII: 'Asia/Ho_Chi_Minh',
  VIJ: 'America/Tortola',
  VIL: 'Africa/Casablanca',
  VIN: 'Europe/Kiev',
  VIQ: 'Asia/Dili',
  VIR: 'Africa/Johannesburg',
  VIS: 'America/Los_Angeles',
  VIT: 'Europe/Madrid',
  VIU: 'Pacific/Guadalcanal',
  VIV: 'Pacific/Port_Moresby',
  VIX: 'America/Sao_Paulo',
  VIY: 'Europe/Paris',
  VJB: 'Africa/Maputo',
  VJI: 'America/New_York',
  VJQ: 'Africa/Maputo',
  VKG: 'Asia/Ho_Chi_Minh',
  VKO: 'Europe/Moscow',
  VKS: 'America/Chicago',
  VKT: 'Europe/Moscow',
  VLA: 'America/Chicago',
  VLC: 'Europe/Madrid',
  VLD: 'America/New_York',
  VLE: 'America/Phoenix',
  VLG: 'America/Argentina/Buenos_Aires',
  VLI: 'Pacific/Efate',
  VLK: 'Europe/Moscow',
  VLL: 'Europe/Madrid',
  VLM: 'America/La_Paz',
  VLN: 'America/Caracas',
  VLP: 'America/Cuiaba',
  VLR: 'America/Santiago',
  VLS: 'Pacific/Efate',
  VLU: 'Europe/Moscow',
  VLV: 'America/Caracas',
  VLY: 'Europe/London',
  VME: 'America/Argentina/San_Luis',
  VMI: 'America/Asuncion',
  VMU: 'Pacific/Port_Moresby',
  VNA: 'Asia/Vientiane',
  VNC: 'America/New_York',
  VND: 'Indian/Antananarivo',
  VNE: 'Europe/Paris',
  VNO: 'Europe/Vilnius',
  VNR: 'Australia/Brisbane',
  VNS: 'Asia/Kolkata',
  VNT: 'Europe/Riga',
  VNX: 'Africa/Maputo',
  VNY: 'America/Los_Angeles',
  VOD: 'Europe/Prague',
  VOG: 'Europe/Volgograd',
  VOH: 'Indian/Antananarivo',
  VOI: 'Africa/Monrovia',
  VOK: 'America/Chicago',
  VOL: 'Europe/Athens',
  VOT: 'America/Sao_Paulo',
  VOZ: 'Europe/Moscow',
  VPE: 'Africa/Luanda',
  VPG: 'Africa/Nairobi',
  VPN: 'Atlantic/Reykjavik',
  VPS: 'America/Chicago',
  VPY: 'Africa/Maputo',
  VPZ: 'America/Chicago',
  VQQ: 'America/New_York',
  VQS: 'America/Puerto_Rico',
  VRA: 'America/Havana',
  VRB: 'America/New_York',
  VRC: 'Asia/Manila',
  VRE: 'Africa/Johannesburg',
  VRI: 'Europe/Moscow',
  VRK: 'Europe/Helsinki',
  VRL: 'Europe/Lisbon',
  VRN: 'Europe/Rome',
  VRO: 'America/Havana',
  VRS: 'America/Chicago',
  VRU: 'Africa/Johannesburg',
  VSA: 'America/Merida',
  VSE: 'Europe/Lisbon',
  VSF: 'America/New_York',
  VSG: 'Europe/Zaporozhye',
  VSO: 'Asia/Ho_Chi_Minh',
  VST: 'Europe/Stockholm',
  VTB: 'Europe/Minsk',
  VTE: 'Asia/Vientiane',
  VTF: 'Pacific/Fiji',
  VTG: 'Asia/Ho_Chi_Minh',
  VTL: 'Europe/Paris',
  VTM: 'Asia/Jerusalem',
  VTN: 'America/Chicago',
  VTU: 'America/Havana',
  VTZ: 'Asia/Kolkata',
  VUP: 'America/Bogota',
  VUS: 'Europe/Moscow',
  VUU: 'Africa/Blantyre',
  VVB: 'Indian/Antananarivo',
  VVC: 'America/Bogota',
  VVI: 'America/La_Paz',
  VVK: 'Europe/Stockholm',
  VVN: 'America/Lima',
  VVO: 'Asia/Vladivostok',
  VVZ: 'Africa/Algiers',
  VXC: 'Africa/Maputo',
  VXE: 'Atlantic/Cape_Verde',
  VXO: 'Europe/Stockholm',
  VYD: 'Africa/Johannesburg',
  VYI: 'Asia/Yakutsk',
  VYS: 'America/Chicago',
  WAA: 'America/Nome',
  WAB: 'Pacific/Port_Moresby',
  WAC: 'Africa/Addis_Ababa',
  WAD: 'Indian/Antananarivo',
  WAE: 'Asia/Riyadh',
  WAF: 'Asia/Karachi',
  WAG: 'Pacific/Auckland',
  WAH: 'America/Chicago',
  WAI: 'Indian/Antananarivo',
  WAJ: 'Pacific/Port_Moresby',
  WAK: 'Indian/Antananarivo',
  WAL: 'America/New_York',
  WAM: 'Indian/Antananarivo',
  WAO: 'Pacific/Port_Moresby',
  WAP: 'America/Santiago',
  WAQ: 'Indian/Antananarivo',
  WAR: 'Asia/Jayapura',
  WAS: 'America/New_York',
  WAT: 'Europe/Dublin',
  WAU: 'Australia/Sydney',
  WAV: 'Australia/Darwin',
  WAW: 'Europe/Warsaw',
  WAX: 'Africa/Tripoli',
  WAY: 'America/New_York',
  WAZ: 'Australia/Brisbane',
  WBA: 'Asia/Jayapura',
  WBB: 'America/Nome',
  WBC: 'Pacific/Port_Moresby',
  WBD: 'Indian/Antananarivo',
  WBE: 'Indian/Antananarivo',
  WBG: 'Europe/Berlin',
  WBK: 'America/Detroit',
  WBM: 'Pacific/Port_Moresby',
  WBO: 'Indian/Antananarivo',
  WBQ: 'America/Anchorage',
  WBR: 'America/Detroit',
  WBU: 'America/Denver',
  WBW: 'America/New_York',
  WCA: 'America/Santiago',
  WCD: 'Australia/Perth',
  WCH: 'America/Santiago',
  WCR: 'America/Anchorage',
  WDA: 'Asia/Aden',
  WDG: 'America/Chicago',
  WDH: 'Africa/Windhoek',
  WDI: 'Australia/Brisbane',
  WDN: 'America/Los_Angeles',
  WDR: 'America/New_York',
  WDS: 'Asia/Shanghai',
  WEA: 'America/Chicago',
  WED: 'Pacific/Port_Moresby',
  WEF: 'Asia/Shanghai',
  WEH: 'Asia/Shanghai',
  WEI: 'Australia/Brisbane',
  WEL: 'Africa/Johannesburg',
  WEP: 'Pacific/Port_Moresby',
  WES: 'Africa/Monrovia',
  WET: 'Asia/Jayapura',
  WEW: 'Australia/Sydney',
  WFB: 'America/Sitka',
  WFD: 'Europe/London',
  WFI: 'Indian/Antananarivo',
  WFK: 'America/New_York',
  WGA: 'Australia/Sydney',
  WGC: 'Asia/Kolkata',
  WGE: 'Australia/Sydney',
  WGN: 'Asia/Shanghai',
  WGO: 'America/New_York',
  WGP: 'Asia/Makassar',
  WGT: 'Australia/Melbourne',
  WGU: 'Pacific/Port_Moresby',
  WGY: 'Africa/Libreville',
  WHD: 'America/Metlakatla',
  WHF: 'Africa/Khartoum',
  WHK: 'Pacific/Auckland',
  WHL: 'Australia/Melbourne',
  WHO: 'Pacific/Auckland',
  WHP: 'America/Los_Angeles',
  WHS: 'Europe/London',
  WHT: 'America/Chicago',
  WHU: 'Asia/Shanghai',
  WIB: 'America/Chicago',
  WIC: 'Europe/London',
  WIE: 'Europe/Berlin',
  WIK: 'Pacific/Auckland',
  WIL: 'Africa/Nairobi',
  WIN: 'Australia/Brisbane',
  WIO: 'Australia/Sydney',
  WIR: 'Pacific/Auckland',
  WIT: 'Australia/Perth',
  WIU: 'Pacific/Port_Moresby',
  WJA: 'Pacific/Kwajalein',
  WJF: 'America/Los_Angeles',
  WJR: 'Africa/Nairobi',
  WJU: 'Asia/Seoul',
  WKA: 'Pacific/Auckland',
  WKB: 'Australia/Melbourne',
  WKF: 'Africa/Johannesburg',
  WKI: 'Africa/Harare',
  WKJ: 'Asia/Tokyo',
  WKK: 'America/Anchorage',
  WKN: 'Pacific/Port_Moresby',
  WKR: 'America/Nassau',
  WLA: 'Australia/Perth',
  WLC: 'Australia/Sydney',
  WLD: 'America/Chicago',
  WLE: 'Australia/Brisbane',
  WLG: 'Pacific/Auckland',
  WLH: 'Pacific/Efate',
  WLK: 'America/Anchorage',
  WLL: 'Australia/Darwin',
  WLO: 'Australia/Darwin',
  WLP: 'Australia/Perth',
  WLR: 'America/Sitka',
  WLS: 'Pacific/Wallis',
  WLW: 'America/Los_Angeles',
  WMA: 'Indian/Antananarivo',
  WMB: 'Australia/Melbourne',
  WMC: 'America/Los_Angeles',
  WMD: 'Indian/Antananarivo',
  WME: 'Australia/Perth',
  WMH: 'America/Chicago',
  WMI: 'Europe/Warsaw',
  WMK: 'America/Juneau',
  WML: 'Indian/Antananarivo',
  WMN: 'Indian/Antananarivo',
  WMO: 'America/Nome',
  WMP: 'Indian/Antananarivo',
  WMR: 'Indian/Antananarivo',
  WMT: 'Asia/Shanghai',
  WMV: 'Indian/Antananarivo',
  WMX: 'Asia/Jayapura',
  WNA: 'America/Anchorage',
  WND: 'Australia/Perth',
  WNE: 'Africa/Libreville',
  WNH: 'Asia/Shanghai',
  WNI: 'Asia/Makassar',
  WNN: 'America/Winnipeg',
  WNP: 'Asia/Manila',
  WNR: 'Australia/Brisbane',
  WNS: 'Asia/Karachi',
  WNU: 'Pacific/Port_Moresby',
  WNZ: 'Asia/Shanghai',
  WOA: 'Pacific/Port_Moresby',
  WOE: 'Europe/Amsterdam',
  WOG: 'Australia/Darwin',
  WOK: 'America/Caracas',
  WOL: 'Australia/Sydney',
  WON: 'Australia/Brisbane',
  WOR: 'Indian/Antananarivo',
  WOS: 'Asia/Pyongyang',
  WOT: 'Asia/Taipei',
  WOW: 'America/Anchorage',
  WPA: 'America/Santiago',
  WPB: 'Indian/Antananarivo',
  WPC: 'America/Edmonton',
  WPK: 'Australia/Brisbane',
  WPL: 'America/Vancouver',
  WPM: 'Pacific/Port_Moresby',
  WPO: 'America/Denver',
  WPR: 'America/Punta_Arenas',
  WPU: 'America/Punta_Arenas',
  WRA: 'Africa/Addis_Ababa',
  WRB: 'America/New_York',
  WRE: 'Pacific/Auckland',
  WRG: 'America/Sitka',
  WRI: 'America/New_York',
  WRL: 'America/Denver',
  WRN: 'Australia/Perth',
  WRO: 'Europe/Warsaw',
  WRT: 'Europe/London',
  WRW: 'Australia/Perth',
  WRY: 'Europe/London',
  WRZ: 'Asia/Colombo',
  WSA: 'Pacific/Port_Moresby',
  WSB: 'America/Metlakatla',
  WSD: 'America/Denver',
  WSF: 'America/Anchorage',
  WSG: 'America/New_York',
  WSH: 'America/New_York',
  WSK: 'Asia/Shanghai',
  WSM: 'America/Anchorage',
  WSN: 'America/Anchorage',
  WSO: 'America/Paramaribo',
  WSP: 'America/Managua',
  WSR: 'Asia/Jayapura',
  WST: 'America/New_York',
  WSU: 'Pacific/Port_Moresby',
  WSX: 'America/Los_Angeles',
  WSY: 'Australia/Brisbane',
  WSZ: 'Pacific/Auckland',
  WTA: 'Indian/Antananarivo',
  WTB: 'Australia/Brisbane',
  WTD: 'America/Nassau',
  WTE: 'Pacific/Majuro',
  WTK: 'America/Nome',
  WTL: 'America/Nome',
  WTN: 'Europe/London',
  WTO: 'Pacific/Kwajalein',
  WTP: 'Pacific/Port_Moresby',
  WTR: 'America/Phoenix',
  WTS: 'Indian/Antananarivo',
  WTT: 'Pacific/Port_Moresby',
  WTZ: 'Pacific/Auckland',
  WUA: 'Asia/Shanghai',
  WUD: 'Australia/Adelaide',
  WUG: 'Pacific/Port_Moresby',
  WUH: 'Asia/Shanghai',
  WUI: 'Australia/Perth',
  WUM: 'Pacific/Port_Moresby',
  WUN: 'Australia/Perth',
  WUS: 'Asia/Shanghai',
  WUT: 'Asia/Shanghai',
  WUU: 'Africa/Juba',
  WUV: 'Pacific/Port_Moresby',
  WUX: 'Asia/Shanghai',
  WUZ: 'Asia/Shanghai',
  WVB: 'Africa/Windhoek',
  WVI: 'America/Los_Angeles',
  WVK: 'Indian/Antananarivo',
  WVL: 'America/New_York',
  WVN: 'Europe/Berlin',
  WWA: 'America/Anchorage',
  WWD: 'America/New_York',
  WWI: 'Australia/Perth',
  WWK: 'Pacific/Port_Moresby',
  WWP: 'America/Metlakatla',
  WWR: 'America/Chicago',
  WWT: 'America/Nome',
  WWY: 'Australia/Sydney',
  WXN: 'Asia/Shanghai',
  WYA: 'Australia/Adelaide',
  WYB: 'America/Sitka',
  WYE: 'Africa/Freetown',
  WYN: 'Australia/Perth',
  WYS: 'America/Denver',
  WZQ: 'Asia/Shanghai',
  XAI: 'Asia/Shanghai',
  XAL: 'America/Hermosillo',
  XAP: 'America/Sao_Paulo',
  XAR: 'Africa/Ouagadougou',
  XAU: 'America/Cayenne',
  XBB: 'America/Vancouver',
  XBE: 'America/Winnipeg',
  XBG: 'Africa/Ouagadougou',
  XBJ: 'Asia/Tehran',
  XBL: 'Africa/Addis_Ababa',
  XBN: 'Pacific/Port_Moresby',
  XBO: 'Africa/Ouagadougou',
  XBR: 'America/Toronto',
  XCH: 'Indian/Christmas',
  XCL: 'America/Regina',
  XCM: 'America/Toronto',
  XCN: 'Asia/Manila',
  XCO: 'Australia/Melbourne',
  XCR: 'Europe/Paris',
  XDE: 'Africa/Ouagadougou',
  XDJ: 'Africa/Ouagadougou',
  XEN: 'Asia/Shanghai',
  XES: 'America/Chicago',
  XFN: 'Asia/Shanghai',
  XFW: 'Europe/Berlin',
  XGA: 'Africa/Ouagadougou',
  XGG: 'Africa/Ouagadougou',
  XGN: 'Africa/Luanda',
  XGR: 'America/Iqaluit',
  XIC: 'Asia/Shanghai',
  XIE: 'Asia/Vientiane',
  XIG: 'America/Belem',
  XIJ: 'Asia/Kuwait',
  XIL: 'Asia/Shanghai',
  XIN: 'Asia/Shanghai',
  XIY: 'Asia/Shanghai',
  XJD: 'Asia/Qatar',
  XJM: 'Asia/Karachi',
  XKA: 'Africa/Ouagadougou',
  XKH: 'Asia/Vientiane',
  XKS: 'America/Winnipeg',
  XKY: 'Africa/Ouagadougou',
  XLB: 'America/Winnipeg',
  XLO: 'Asia/Ho_Chi_Minh',
  XLS: 'Africa/Dakar',
  XLU: 'Africa/Ouagadougou',
  XLW: 'Europe/Berlin',
  XMA: 'Asia/Manila',
  XMC: 'Australia/Melbourne',
  XMD: 'America/Chicago',
  XMG: 'Asia/Kathmandu',
  XMH: 'Pacific/Tahiti',
  XMI: 'Africa/Dar_es_Salaam',
  XML: 'Australia/Adelaide',
  XMN: 'Asia/Shanghai',
  XMP: 'America/Whitehorse',
  XMS: 'America/Guayaquil',
  XMY: 'Australia/Lindeman',
  XNA: 'America/Chicago',
  XNB: 'Asia/Dubai',
  XNG: 'Asia/Ho_Chi_Minh',
  XNH: 'Asia/Baghdad',
  XNN: 'Asia/Shanghai',
  XNT: 'Asia/Shanghai',
  XNU: 'Africa/Ouagadougou',
  XPA: 'Africa/Ouagadougou',
  XPK: 'America/Winnipeg',
  XPL: 'America/Tegucigalpa',
  XPP: 'America/Winnipeg',
  XPR: 'America/Denver',
  XQP: 'America/Costa_Rica',
  XQU: 'America/Vancouver',
  XRH: 'Australia/Sydney',
  XRQ: 'Asia/Shanghai',
  XRR: 'America/Whitehorse',
  XRY: 'Europe/Madrid',
  XSB: 'Asia/Dubai',
  XSC: 'America/Grand_Turk',
  XSD: 'America/Los_Angeles',
  XSE: 'Africa/Ouagadougou',
  XSI: 'America/Winnipeg',
  XSO: 'Asia/Manila',
  XSP: 'Asia/Singapore',
  XTG: 'Australia/Brisbane',
  XTL: 'America/Winnipeg',
  XTO: 'Australia/Brisbane',
  XTR: 'Australia/Brisbane',
  XUZ: 'Asia/Shanghai',
  XVL: 'Asia/Ho_Chi_Minh',
  XYA: 'Pacific/Guadalcanal',
  XYE: 'Asia/Yangon',
  XYR: 'Pacific/Port_Moresby',
  XZA: 'Africa/Ouagadougou',
  YAA: 'America/Vancouver',
  YAB: 'America/Rankin_Inlet',
  YAC: 'America/Winnipeg',
  YAD: 'America/Winnipeg',
  YAG: 'America/Winnipeg',
  YAH: 'America/Toronto',
  YAI: 'America/Santiago',
  YAJ: 'America/Vancouver',
  YAK: 'America/Yakutat',
  YAL: 'America/Vancouver',
  YAM: 'America/Toronto',
  YAN: 'Africa/Lubumbashi',
  YAO: 'Africa/Douala',
  YAP: 'Pacific/Chuuk',
  YAQ: 'America/Vancouver',
  YAR: 'America/Toronto',
  YAS: 'Pacific/Fiji',
  YAT: 'America/Toronto',
  YAU: 'America/Toronto',
  YAV: 'America/Vancouver',
  YAX: 'America/Winnipeg',
  YAY: 'America/St_Johns',
  YAZ: 'America/Vancouver',
  YBA: 'America/Edmonton',
  YBB: 'America/Cambridge_Bay',
  YBC: 'America/Toronto',
  YBE: 'America/Regina',
  YBF: 'America/Vancouver',
  YBG: 'America/Toronto',
  YBH: 'America/Vancouver',
  YBI: 'America/St_Johns',
  YBJ: 'America/Toronto',
  YBK: 'America/Rankin_Inlet',
  YBL: 'America/Vancouver',
  YBO: 'America/Vancouver',
  YBP: 'Asia/Shanghai',
  YBQ: 'America/Vancouver',
  YBR: 'America/Winnipeg',
  YBS: 'America/Winnipeg',
  YBT: 'America/Winnipeg',
  YBV: 'America/Winnipeg',
  YBW: 'America/Vancouver',
  YBX: 'America/Blanc-Sablon',
  YBY: 'America/Edmonton',
  YCA: 'America/Vancouver',
  YCB: 'America/Cambridge_Bay',
  YCC: 'America/Toronto',
  YCD: 'America/Vancouver',
  YCE: 'America/Toronto',
  YCF: 'America/Vancouver',
  YCG: 'America/Vancouver',
  YCH: 'America/Moncton',
  YCK: 'America/Yellowknife',
  YCL: 'America/Moncton',
  YCM: 'America/Toronto',
  YCN: 'America/Toronto',
  YCO: 'America/Cambridge_Bay',
  YCQ: 'America/Dawson_Creek',
  YCR: 'America/Winnipeg',
  YCS: 'America/Rankin_Inlet',
  YCT: 'America/Edmonton',
  YCU: 'Asia/Shanghai',
  YCW: 'America/Vancouver',
  YCY: 'America/Iqaluit',
  YCZ: 'America/Edmonton',
  YDA: 'America/Whitehorse',
  YDB: 'America/Whitehorse',
  YDC: 'America/Edmonton',
  YDE: 'America/St_Johns',
  YDF: 'America/St_Johns',
  YDG: 'America/Halifax',
  YDJ: 'America/Regina',
  YDL: 'America/Vancouver',
  YDN: 'America/Winnipeg',
  YDO: 'America/Toronto',
  YDP: 'America/Goose_Bay',
  YDQ: 'America/Dawson_Creek',
  YDT: 'America/Vancouver',
  YDU: 'America/Yellowknife',
  YDV: 'America/Winnipeg',
  YDW: 'America/Yellowknife',
  YEA: 'America/Edmonton',
  YEB: 'America/Toronto',
  YEC: 'Asia/Seoul',
  YEG: 'America/Edmonton',
  YEH: 'Asia/Shanghai',
  YEI: 'Europe/Istanbul',
  YEK: 'America/Rankin_Inlet',
  YEL: 'America/Toronto',
  YEM: 'America/Toronto',
  YEN: 'America/Regina',
  YEO: 'Europe/London',
  YEQ: 'Pacific/Port_Moresby',
  YER: 'America/Toronto',
  YES: 'Asia/Tehran',
  YET: 'America/Edmonton',
  YEU: 'America/Rankin_Inlet',
  YEV: 'America/Inuvik',
  YEY: 'America/Toronto',
  YFA: 'America/Toronto',
  YFB: 'America/Iqaluit',
  YFC: 'America/Moncton',
  YFE: 'America/Toronto',
  YFG: 'America/Toronto',
  YFH: 'America/Toronto',
  YFI: 'America/Edmonton',
  YFJ: 'America/Yellowknife',
  YFL: 'America/Yellowknife',
  YFO: 'America/Winnipeg',
  YFR: 'America/Yellowknife',
  YFS: 'America/Yellowknife',
  YFX: 'America/St_Johns',
  YGB: 'America/Vancouver',
  YGC: 'America/Vancouver',
  YGE: 'America/Vancouver',
  YGG: 'America/Vancouver',
  YGH: 'America/Yellowknife',
  YGJ: 'Asia/Tokyo',
  YGK: 'America/Toronto',
  YGL: 'America/Toronto',
  YGM: 'America/Winnipeg',
  YGN: 'America/Vancouver',
  YGO: 'America/Winnipeg',
  YGP: 'America/Toronto',
  YGQ: 'America/Toronto',
  YGR: 'America/Halifax',
  YGT: 'America/Iqaluit',
  YGV: 'America/Toronto',
  YGW: 'America/Toronto',
  YGX: 'America/Winnipeg',
  YGZ: 'America/Iqaluit',
  YHA: 'America/St_Johns',
  YHB: 'America/Regina',
  YHC: 'America/Vancouver',
  YHD: 'America/Winnipeg',
  YHE: 'America/Vancouver',
  YHF: 'America/Toronto',
  YHG: 'America/St_Johns',
  YHH: 'America/Vancouver',
  YHI: 'America/Yellowknife',
  YHK: 'America/Cambridge_Bay',
  YHM: 'America/Toronto',
  YHN: 'America/Toronto',
  YHO: 'America/Goose_Bay',
  YHP: 'America/Winnipeg',
  YHR: 'America/Blanc-Sablon',
  YHS: 'America/Vancouver',
  YHT: 'America/Whitehorse',
  YHU: 'America/Toronto',
  YHY: 'America/Yellowknife',
  YHZ: 'America/Halifax',
  YIA: 'Asia/Jakarta',
  YIB: 'America/Atikokan',
  YIC: 'Asia/Shanghai',
  YIE: 'Asia/Shanghai',
  YIF: 'America/Blanc-Sablon',
  YIG: 'America/Vancouver',
  YIH: 'Asia/Shanghai',
  YIK: 'America/Toronto',
  YIN: 'Asia/Shanghai',
  YIO: 'America/Iqaluit',
  YIP: 'America/Detroit',
  YIV: 'America/Winnipeg',
  YIW: 'Asia/Shanghai',
  YJA: 'America/Edmonton',
  YJF: 'America/Yellowknife',
  YJN: 'America/Toronto',
  YJP: 'America/Edmonton',
  YJS: 'Asia/Pyongyang',
  YJT: 'America/St_Johns',
  YKA: 'America/Vancouver',
  YKC: 'America/Regina',
  YKD: 'America/Toronto',
  YKE: 'America/Winnipeg',
  YKF: 'America/Toronto',
  YKG: 'America/Toronto',
  YKH: 'Asia/Shanghai',
  YKJ: 'America/Regina',
  YKK: 'America/Vancouver',
  YKL: 'America/Toronto',
  YKM: 'America/Los_Angeles',
  YKN: 'America/Chicago',
  YKO: 'Europe/Istanbul',
  YKQ: 'America/Toronto',
  YKS: 'Asia/Yakutsk',
  YKT: 'America/Vancouver',
  YKU: 'America/Toronto',
  YKX: 'America/Toronto',
  YKY: 'America/Regina',
  YKZ: 'America/Toronto',
  YLB: 'America/Edmonton',
  YLC: 'America/Iqaluit',
  YLD: 'America/Toronto',
  YLE: 'America/Yellowknife',
  YLG: 'Australia/Perth',
  YLH: 'America/Toronto',
  YLI: 'Europe/Helsinki',
  YLJ: 'America/Regina',
  YLK: 'America/Toronto',
  YLL: 'America/Edmonton',
  YLM: 'America/Whitehorse',
  YLN: 'Asia/Shanghai',
  YLP: 'America/Toronto',
  YLQ: 'America/Toronto',
  YLR: 'America/Winnipeg',
  YLS: 'America/Toronto',
  YLT: 'America/Pangnirtung',
  YLV: 'Asia/Baku',
  YLW: 'America/Vancouver',
  YLY: 'America/Vancouver',
  YMA: 'America/Whitehorse',
  YMB: 'America/Vancouver',
  YMD: 'America/Yellowknife',
  YME: 'America/Toronto',
  YMF: 'America/Vancouver',
  YMG: 'America/Toronto',
  YMH: 'America/St_Johns',
  YMJ: 'America/Regina',
  YMK: 'Asia/Yekaterinburg',
  YML: 'America/Toronto',
  YMM: 'America/Edmonton',
  YMN: 'America/Goose_Bay',
  YMO: 'America/Toronto',
  YMP: 'America/Vancouver',
  YMQ: 'America/Toronto',
  YMS: 'America/Lima',
  YMT: 'America/Toronto',
  YMU: 'America/Vancouver',
  YMV: 'America/Iqaluit',
  YMW: 'America/Toronto',
  YMX: 'America/Toronto',
  YNA: 'America/Toronto',
  YNB: 'Asia/Riyadh',
  YNC: 'America/Toronto',
  YND: 'America/Toronto',
  YNE: 'America/Winnipeg',
  YNG: 'America/New_York',
  YNH: 'America/Dawson_Creek',
  YNJ: 'Asia/Shanghai',
  YNL: 'America/Regina',
  YNM: 'America/Toronto',
  YNN: 'Australia/Perth',
  YNO: 'America/Winnipeg',
  YNP: 'America/Goose_Bay',
  YNS: 'America/Toronto',
  YNT: 'Asia/Shanghai',
  YNX: 'America/Yellowknife',
  YNY: 'Asia/Seoul',
  YNZ: 'Asia/Shanghai',
  YOA: 'America/Yellowknife',
  YOC: 'America/Whitehorse',
  YOD: 'America/Edmonton',
  YOE: 'America/Edmonton',
  YOG: 'America/Toronto',
  YOH: 'America/Winnipeg',
  YOI: 'America/Toronto',
  YOJ: 'America/Edmonton',
  YOL: 'Africa/Lagos',
  YON: 'Asia/Thimphu',
  YOO: 'America/Toronto',
  YOP: 'America/Edmonton',
  YOS: 'America/Toronto',
  YOT: 'Asia/Jerusalem',
  YOW: 'America/Toronto',
  YPA: 'America/Regina',
  YPB: 'America/Vancouver',
  YPC: 'America/Yellowknife',
  YPD: 'America/Toronto',
  YPE: 'America/Edmonton',
  YPG: 'America/Winnipeg',
  YPH: 'America/Toronto',
  YPI: 'America/Vancouver',
  YPJ: 'America/Toronto',
  YPL: 'America/Toronto',
  YPM: 'America/Winnipeg',
  YPN: 'America/Toronto',
  YPO: 'America/Toronto',
  YPQ: 'America/Toronto',
  YPR: 'America/Vancouver',
  YPS: 'America/Halifax',
  YPT: 'America/Vancouver',
  YPW: 'America/Vancouver',
  YPX: 'America/Toronto',
  YPY: 'America/Edmonton',
  YPZ: 'America/Vancouver',
  YQA: 'America/Toronto',
  YQB: 'America/Toronto',
  YQC: 'America/Toronto',
  YQD: 'America/Winnipeg',
  YQF: 'America/Edmonton',
  YQG: 'America/Toronto',
  YQH: 'America/Whitehorse',
  YQI: 'America/Halifax',
  YQJ: 'America/Vancouver',
  YQK: 'America/Winnipeg',
  YQL: 'America/Edmonton',
  YQM: 'America/Moncton',
  YQN: 'America/Toronto',
  YQQ: 'America/Vancouver',
  YQR: 'America/Regina',
  YQS: 'America/Toronto',
  YQT: 'America/Thunder_Bay',
  YQU: 'America/Edmonton',
  YQV: 'America/Regina',
  YQW: 'America/Regina',
  YQX: 'America/St_Johns',
  YQY: 'America/Glace_Bay',
  YQZ: 'America/Vancouver',
  YRA: 'America/Yellowknife',
  YRB: 'America/Resolute',
  YRC: 'America/Vancouver',
  YRD: 'America/Vancouver',
  YRF: 'America/Goose_Bay',
  YRG: 'America/Goose_Bay',
  YRI: 'America/Toronto',
  YRJ: 'America/Toronto',
  YRL: 'America/Winnipeg',
  YRM: 'America/Edmonton',
  YRN: 'America/Vancouver',
  YRO: 'America/Toronto',
  YRQ: 'America/Toronto',
  YRR: 'America/Vancouver',
  YRS: 'America/Winnipeg',
  YRT: 'America/Rankin_Inlet',
  YRV: 'America/Vancouver',
  YSA: 'America/Halifax',
  YSB: 'America/Toronto',
  YSC: 'America/Toronto',
  YSE: 'America/Vancouver',
  YSF: 'America/Regina',
  YSG: 'America/Yellowknife',
  YSH: 'America/Toronto',
  YSI: 'America/Toronto',
  YSJ: 'America/Moncton',
  YSK: 'America/Iqaluit',
  YSL: 'America/Moncton',
  YSM: 'America/Yellowknife',
  YSN: 'America/Vancouver',
  YSO: 'America/Goose_Bay',
  YSP: 'America/Toronto',
  YSQ: 'Asia/Shanghai',
  YST: 'America/Winnipeg',
  YSU: 'America/Halifax',
  YSX: 'America/Vancouver',
  YSY: 'America/Yellowknife',
  YTA: 'America/Toronto',
  YTB: 'America/Vancouver',
  YTD: 'America/Winnipeg',
  YTE: 'America/Iqaluit',
  YTF: 'America/Toronto',
  YTG: 'America/Vancouver',
  YTH: 'America/Winnipeg',
  YTL: 'America/Winnipeg',
  YTM: 'America/Toronto',
  YTO: 'America/Toronto',
  YTP: 'America/Vancouver',
  YTQ: 'America/Toronto',
  YTR: 'America/Toronto',
  YTS: 'America/Toronto',
  YTT: 'America/Regina',
  YTU: 'America/Vancouver',
  YTX: 'America/Vancouver',
  YTY: 'Asia/Shanghai',
  YTZ: 'America/Toronto',
  YUA: 'Asia/Shanghai',
  YUB: 'America/Yellowknife',
  YUD: 'America/Toronto',
  YUE: 'Australia/Darwin',
  YUL: 'America/Toronto',
  YUM: 'America/Phoenix',
  YUS: 'Asia/Urumqi',
  YUT: 'America/Rankin_Inlet',
  YUX: 'America/Iqaluit',
  YUY: 'America/Toronto',
  YVA: 'Indian/Comoro',
  YVB: 'America/Toronto',
  YVC: 'America/Regina',
  YVD: 'Pacific/Port_Moresby',
  YVE: 'America/Vancouver',
  YVG: 'America/Edmonton',
  YVM: 'America/Pangnirtung',
  YVN: 'America/Pangnirtung',
  YVO: 'America/Toronto',
  YVP: 'America/Toronto',
  YVQ: 'America/Yellowknife',
  YVR: 'America/Vancouver',
  YVT: 'America/Regina',
  YVV: 'America/Toronto',
  YVZ: 'America/Winnipeg',
  YWA: 'America/Toronto',
  YWB: 'America/Toronto',
  YWG: 'America/Winnipeg',
  YWH: 'America/Vancouver',
  YWJ: 'America/Yellowknife',
  YWK: 'America/Goose_Bay',
  YWL: 'America/Vancouver',
  YWM: 'America/St_Johns',
  YWP: 'America/Toronto',
  YWQ: 'America/Toronto',
  YWR: 'America/Toronto',
  YWS: 'America/Vancouver',
  YWY: 'America/Yellowknife',
  YXC: 'America/Edmonton',
  YXD: 'America/Edmonton',
  YXE: 'America/Regina',
  YXH: 'America/Edmonton',
  YXJ: 'America/Dawson_Creek',
  YXK: 'America/Toronto',
  YXL: 'America/Winnipeg',
  YXN: 'America/Rankin_Inlet',
  YXP: 'America/Pangnirtung',
  YXQ: 'America/Whitehorse',
  YXR: 'America/Toronto',
  YXS: 'America/Vancouver',
  YXT: 'America/Vancouver',
  YXU: 'America/Toronto',
  YXX: 'America/Vancouver',
  YXY: 'America/Whitehorse',
  YXZ: 'America/Toronto',
  YYA: 'Asia/Shanghai',
  YYB: 'America/Toronto',
  YYC: 'America/Edmonton',
  YYD: 'America/Vancouver',
  YYE: 'America/Fort_Nelson',
  YYF: 'America/Vancouver',
  YYG: 'America/Halifax',
  YYH: 'America/Cambridge_Bay',
  YYI: 'America/Winnipeg',
  YYJ: 'America/Vancouver',
  YYL: 'America/Winnipeg',
  YYM: 'America/Edmonton',
  YYN: 'America/Regina',
  YYQ: 'America/Winnipeg',
  YYR: 'America/Goose_Bay',
  YYT: 'America/St_Johns',
  YYU: 'America/Toronto',
  YYW: 'America/Toronto',
  YYY: 'America/Toronto',
  YYZ: 'America/Toronto',
  YZA: 'America/Vancouver',
  YZE: 'America/Toronto',
  YZF: 'America/Yellowknife',
  YZG: 'America/Toronto',
  YZH: 'America/Edmonton',
  YZP: 'America/Vancouver',
  YZR: 'America/Toronto',
  YZS: 'America/Atikokan',
  YZT: 'America/Vancouver',
  YZU: 'America/Edmonton',
  YZV: 'America/Toronto',
  YZW: 'America/Whitehorse',
  YZX: 'America/Halifax',
  YZY: 'Asia/Shanghai',
  YZZ: 'America/Vancouver',
  ZAA: 'America/Vancouver',
  ZAC: 'America/Winnipeg',
  ZAD: 'Europe/Zagreb',
  ZAG: 'Europe/Zagreb',
  ZAH: 'Asia/Tehran',
  ZAJ: 'Asia/Kabul',
  ZAL: 'America/Santiago',
  ZAM: 'Asia/Manila',
  ZAO: 'Europe/Paris',
  ZAR: 'Africa/Lagos',
  ZAT: 'Asia/Shanghai',
  ZAZ: 'Europe/Madrid',
  ZBE: 'Europe/Prague',
  ZBF: 'America/Moncton',
  ZBK: 'Europe/Podgorica',
  ZBL: 'Australia/Brisbane',
  ZBM: 'America/Toronto',
  ZBO: 'Australia/Brisbane',
  ZBR: 'Asia/Tehran',
  ZBY: 'Asia/Vientiane',
  ZCL: 'America/Monterrey',
  ZCO: 'America/Santiago',
  ZDY: 'Asia/Dubai',
  ZEC: 'Africa/Johannesburg',
  ZEG: 'Asia/Jayapura',
  ZEL: 'America/Vancouver',
  ZEM: 'America/Toronto',
  ZEN: 'Pacific/Port_Moresby',
  ZER: 'Asia/Kolkata',
  ZFA: 'America/Whitehorse',
  ZFD: 'America/Regina',
  ZFM: 'America/Yellowknife',
  ZFN: 'America/Yellowknife',
  ZFW: 'America/Edmonton',
  ZGF: 'America/Vancouver',
  ZGI: 'America/Winnipeg',
  ZGL: 'Australia/Brisbane',
  ZGM: 'Africa/Lusaka',
  ZGR: 'America/Winnipeg',
  ZGS: 'America/Blanc-Sablon',
  ZGU: 'Pacific/Efate',
  ZHA: 'Asia/Urumqi',
  ZHM: 'Asia/Dhaka',
  ZHP: 'America/Edmonton',
  ZHY: 'Asia/Shanghai',
  ZIA: 'Europe/Moscow',
  ZIC: 'America/Santiago',
  ZIG: 'Africa/Dakar',
  ZIH: 'America/Mexico_City',
  ZIS: 'Africa/Tripoli',
  ZIX: 'Asia/Yakutsk',
  ZIZ: 'Asia/Karachi',
  ZJG: 'America/Winnipeg',
  ZJN: 'America/Winnipeg',
  ZJT: 'Asia/Kuala_Lumpur',
  ZKB: 'Africa/Lusaka',
  ZKE: 'America/Toronto',
  ZKG: 'America/Blanc-Sablon',
  ZKL: 'Asia/Shanghai',
  ZKP: 'Asia/Magadan',
  ZLO: 'America/Mexico_City',
  ZLT: 'America/Blanc-Sablon',
  ZLW: 'Asia/Kuala_Lumpur',
  ZLX: 'Africa/Khartoum',
  ZMD: 'America/Rio_Branco',
  ZMH: 'America/Vancouver',
  ZMM: 'America/Mexico_City',
  ZMT: 'America/Vancouver',
  ZNA: 'America/Vancouver',
  ZNC: 'America/Anchorage',
  ZND: 'Africa/Niamey',
  ZNE: 'Australia/Perth',
  ZNU: 'America/Vancouver',
  ZNZ: 'Africa/Dar_es_Salaam',
  ZOF: 'America/Vancouver',
  ZOS: 'America/Santiago',
  ZPB: 'America/Winnipeg',
  ZPC: 'America/Santiago',
  ZPH: 'America/New_York',
  ZPO: 'America/Regina',
  ZQN: 'Pacific/Auckland',
  ZQS: 'America/Vancouver',
  ZQW: 'Europe/Berlin',
  ZQZ: 'Asia/Shanghai',
  ZRH: 'Europe/Zurich',
  ZRI: 'Asia/Jayapura',
  ZRJ: 'America/Winnipeg',
  ZRM: 'Asia/Jayapura',
  ZSA: 'America/Nassau',
  ZSE: 'Indian/Reunion',
  ZSJ: 'America/Winnipeg',
  ZSS: 'Africa/Abidjan',
  ZST: 'America/Vancouver',
  ZSW: 'America/Vancouver',
  ZTA: 'Pacific/Tahiti',
  ZTB: 'America/Blanc-Sablon',
  ZTH: 'Europe/Athens',
  ZTM: 'America/Winnipeg',
  ZTR: 'Europe/Kiev',
  ZTS: 'America/Vancouver',
  ZTU: 'Asia/Baku',
  ZUC: 'America/Winnipeg',
  ZUD: 'America/Santiago',
  ZUH: 'Asia/Shanghai',
  ZUL: 'Asia/Riyadh',
  ZUM: 'America/Goose_Bay',
  ZVA: 'Indian/Antananarivo',
  ZVG: 'Australia/Perth',
  ZVK: 'Asia/Vientiane',
  ZWA: 'Indian/Antananarivo',
  ZWL: 'America/Regina',
  ZXT: 'Asia/Baku',
  ZYI: 'Asia/Shanghai',
  ZYL: 'Asia/Dhaka',
  ZZO: 'Asia/Sakhalin',
  ZZU: 'Africa/Blantyre',
  ZZV: 'America/New_York'
};

/***/ }),
/* 1883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"heading"},[_c('div',{staticClass:"txt"},[_vm._v("\n      Flight "+_vm._s(_vm.flightId)+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"wrap-box"},[_c('div',{staticClass:"d-flex justify-space-between align-center"},[_c('div',{staticClass:"tabs d-flex"},[_c('div',{class:['tab', {active:_vm.activeTab === 'info'}],on:{"click":function($event){return _vm.switchTab('info')}}},[_vm._v("BASIC INFORMATION")]),_vm._v(" "),_c('div',{class:['tab', {active:_vm.activeTab === 'trx'}],on:{"click":function($event){return _vm.switchTab('trx')}}},[_vm._v("TRANSACTION")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === 'info'),expression:"activeTab === 'info'"}],staticClass:"info-box"},[(_vm.doneAllLoading)?_c('fdetails',{ref:"fDetails"}):_vm._e()],1),_vm._v(" "),_c('trx',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === 'trx'),expression:"activeTab === 'trx'"}],ref:"trx"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(630);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce92dc62_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1891);
function injectStyle (ssrContext) {
  __webpack_require__(1885)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ce92dc62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce92dc62_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1886);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4b272fbb", content, true, {});

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.heading[data-v-ce92dc62] {\n  height: 50px;\n  padding-left: 50px;\n}\n.heading .txt[data-v-ce92dc62] {\n    line-height: 50px;\n    padding-left: 20px;\n    font-size: 21px;\n    font-weight: 600;\n}\n.body[data-v-ce92dc62] {\n  background: #fafafa;\n  width: 100%;\n  min-height: calc(100vh - 50px);\n  border-top: 2px solid #ccc;\n}\n.body .left[data-v-ce92dc62] {\n    width: 50%;\n    padding: 15px 20px;\n}\n.body .right[data-v-ce92dc62] {\n    width: 50%;\n    border-left: 1px solid #ccc;\n}\n.field[data-v-ce92dc62] {\n  margin-bottom: 20px;\n}\n.field .label[data-v-ce92dc62] {\n    font-size: 13px;\n    color: #888;\n    line-height: 1;\n    font-weight: 600;\n}\n.dep-label[data-v-ce92dc62] {\n  margin-bottom: 5px;\n}\n.trip-type[data-v-ce92dc62] {\n  padding: 3px 5px;\n  outline: none;\n  width: auto;\n  margin-left: 10px;\n  font-size: 14px;\n}\n.sub-label[data-v-ce92dc62] {\n  font-size: 12px;\n  color: #777;\n  margin: 2px 0 3px;\n}\n.traveller[data-v-ce92dc62] {\n  width: 35%;\n  max-width: 170px;\n  margin-right: 10px;\n}\n.traveller[data-v-ce92dc62]:last-child {\n    margin-right: 0;\n}\n.traveller select[data-v-ce92dc62] {\n    padding: 3px 5px;\n}\n.error-msg[data-v-ce92dc62] {\n  font-size: 11px;\n  line-height: 1.6;\n  color: #f20d0d;\n  font-style: italic;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/FlightCreate/index.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,mBAAmB;CACpB;AACD;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;CACpB;AACD;EACE,oBAAoB;EACpB,YAAY;EACZ,+BAA+B;EAC/B,2BAA2B;CAC5B;AACD;IACI,WAAW;IACX,mBAAmB;CACtB;AACD;IACI,WAAW;IACX,4BAA4B;CAC/B;AACD;EACE,oBAAoB;CACrB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;CACpB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;CACnB;AACD;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;CACpB","file":"index.vue","sourcesContent":["\n.heading[data-v-ce92dc62] {\n  height: 50px;\n  padding-left: 50px;\n}\n.heading .txt[data-v-ce92dc62] {\n    line-height: 50px;\n    padding-left: 20px;\n    font-size: 21px;\n    font-weight: 600;\n}\n.body[data-v-ce92dc62] {\n  background: #fafafa;\n  width: 100%;\n  min-height: calc(100vh - 50px);\n  border-top: 2px solid #ccc;\n}\n.body .left[data-v-ce92dc62] {\n    width: 50%;\n    padding: 15px 20px;\n}\n.body .right[data-v-ce92dc62] {\n    width: 50%;\n    border-left: 1px solid #ccc;\n}\n.field[data-v-ce92dc62] {\n  margin-bottom: 20px;\n}\n.field .label[data-v-ce92dc62] {\n    font-size: 13px;\n    color: #888;\n    line-height: 1;\n    font-weight: 600;\n}\n.dep-label[data-v-ce92dc62] {\n  margin-bottom: 5px;\n}\n.trip-type[data-v-ce92dc62] {\n  padding: 3px 5px;\n  outline: none;\n  width: auto;\n  margin-left: 10px;\n  font-size: 14px;\n}\n.sub-label[data-v-ce92dc62] {\n  font-size: 12px;\n  color: #777;\n  margin: 2px 0 3px;\n}\n.traveller[data-v-ce92dc62] {\n  width: 35%;\n  max-width: 170px;\n  margin-right: 10px;\n}\n.traveller[data-v-ce92dc62]:last-child {\n    margin-right: 0;\n}\n.traveller select[data-v-ce92dc62] {\n    padding: 3px 5px;\n}\n.error-msg[data-v-ce92dc62] {\n  font-size: 11px;\n  line-height: 1.6;\n  color: #f20d0d;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationInputNEW_vue__ = __webpack_require__(631);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3093e351_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationInputNEW_vue__ = __webpack_require__(1890);
function injectStyle (ssrContext) {
  __webpack_require__(1888)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3093e351"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationInputNEW_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3093e351_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationInputNEW_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1889);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("3ce27c1e", content, true, {});

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.autocomplete[data-v-3093e351] {\n  position: relative;\n  width: 100%;\n}\n.suggestions[data-v-3093e351] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  max-height: 150px;\n  z-index: 2;\n  list-style: none;\n  overflow: auto;\n  padding: 0;\n  margin: 0;\n  -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);\n}\n.suggestions li[data-v-3093e351] {\n    background: #f6f6f6;\n    padding: 8px 10px;\n    width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor: pointer;\n    border-bottom: 1px solid #bbb;\n    color: #333;\n}\n.suggestions li[data-v-3093e351]:last-child {\n      border-bottom: none;\n}\n.suggestions li i[data-v-3093e351] {\n      margin-right: 5px;\n}\n.suggestions li span[data-v-3093e351] {\n      font-size: 13px;\n}\n.suggestions li .fa-exclamation-triangle[data-v-3093e351] {\n      color: #e2c84a;\n}\n.suggestions li .fa-map-marker[data-v-3093e351] {\n      color: #ea5c5c;\n}\n.suggestions li[data-v-3093e351]:hover {\n      background: #0D79F2;\n      color: #fff;\n}\n.suggestions li:hover i[data-v-3093e351] {\n        color: #fff;\n}\n.suggestions li.empty[data-v-3093e351] {\n      cursor: default;\n}\n.input[data-v-3093e351] {\n  margin: 5px 0 0;\n  color: #333;\n  line-height: inherit;\n  -webkit-transition: all .15s ease;\n  transition: all .15s ease;\n}\n.input.loading[data-v-3093e351] {\n    padding-right: 40px;\n}\n.input.has-error[data-v-3093e351] {\n    border-color: #f20d0d;\n}\n.input[data-v-3093e351]:disabled {\n    background: #eee;\n}\n.error-msg[data-v-3093e351] {\n  font-size: 11px;\n  line-height: 1.6;\n  color: #f20d0d;\n  font-style: italic;\n  display: block;\n}\n.loader[data-v-3093e351] {\n  position: absolute;\n  top: 8px;\n  right: 5px;\n  z-index: 2;\n  color: #aaa;\n}\n.slide-down-enter-active[data-v-3093e351], .slide-down-leave-active[data-v-3093e351] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-3093e351], .slide-down-leave-to[data-v-3093e351] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Partials/LocationInputNEW.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,UAAU;EACV,mDAAmD;UAC3C,2CAA2C;CACpD;AACD;IACI,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,8BAA8B;IAC9B,YAAY;CACf;AACD;MACM,oBAAoB;CACzB;AACD;MACM,kBAAkB;CACvB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,oBAAoB;MACpB,YAAY;CACjB;AACD;QACQ,YAAY;CACnB;AACD;MACM,gBAAgB;CACrB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;IACI,oBAAoB;CACvB;AACD;IACI,sBAAsB;CACzB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,eAAe;CAChB;AACD;EACE,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;CACb;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;EACrC,WAAW;CACZ","file":"LocationInputNEW.vue","sourcesContent":["\n.autocomplete[data-v-3093e351] {\n  position: relative;\n  width: 100%;\n}\n.suggestions[data-v-3093e351] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  max-height: 150px;\n  z-index: 2;\n  list-style: none;\n  overflow: auto;\n  padding: 0;\n  margin: 0;\n  -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);\n}\n.suggestions li[data-v-3093e351] {\n    background: #f6f6f6;\n    padding: 8px 10px;\n    width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor: pointer;\n    border-bottom: 1px solid #bbb;\n    color: #333;\n}\n.suggestions li[data-v-3093e351]:last-child {\n      border-bottom: none;\n}\n.suggestions li i[data-v-3093e351] {\n      margin-right: 5px;\n}\n.suggestions li span[data-v-3093e351] {\n      font-size: 13px;\n}\n.suggestions li .fa-exclamation-triangle[data-v-3093e351] {\n      color: #e2c84a;\n}\n.suggestions li .fa-map-marker[data-v-3093e351] {\n      color: #ea5c5c;\n}\n.suggestions li[data-v-3093e351]:hover {\n      background: #0D79F2;\n      color: #fff;\n}\n.suggestions li:hover i[data-v-3093e351] {\n        color: #fff;\n}\n.suggestions li.empty[data-v-3093e351] {\n      cursor: default;\n}\n.input[data-v-3093e351] {\n  margin: 5px 0 0;\n  color: #333;\n  line-height: inherit;\n  -webkit-transition: all .15s ease;\n  transition: all .15s ease;\n}\n.input.loading[data-v-3093e351] {\n    padding-right: 40px;\n}\n.input.has-error[data-v-3093e351] {\n    border-color: #f20d0d;\n}\n.input[data-v-3093e351]:disabled {\n    background: #eee;\n}\n.error-msg[data-v-3093e351] {\n  font-size: 11px;\n  line-height: 1.6;\n  color: #f20d0d;\n  font-style: italic;\n  display: block;\n}\n.loader[data-v-3093e351] {\n  position: absolute;\n  top: 8px;\n  right: 5px;\n  z-index: 2;\n  color: #aaa;\n}\n.slide-down-enter-active[data-v-3093e351], .slide-down-leave-active[data-v-3093e351] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-3093e351], .slide-down-leave-to[data-v-3093e351] {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"autocomplete"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyInput),expression:"keyInput"}],class:['input', {'loading':_vm.loading, 'has-error':!!_vm.error}],attrs:{"type":"text","disabled":_vm.extra.disabled || _vm.loading},domProps:{"value":(_vm.keyInput)},on:{"keyup":_vm.query,"blur":_vm.clickOut,"input":function($event){if($event.target.composing){ return; }_vm.keyInput=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error))]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"fa fa-spinner fa-spin loader fa-2x"}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSuggestion),expression:"showSuggestion"}],staticClass:"suggestions"},_vm._l((_vm.suggestions),function(item,index){return _c('li',{key:index,class:{'empty':item.title === 'Sorry'},on:{"click":function($event){return _vm.selectLocation(index)}}},[_c('i',{class:['fas', item.icon]}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.title + ', ' + item.subtitle))])])}),0)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"body d-flex"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("PICK UP LOCATION")]),_vm._v(" "),_c('location',{attrs:{"value":_vm.pickup.title,"extra":_vm.locationExtra,"error":_vm.error.pickup},on:{"change":function($event){return _vm.locationUpdate($event, 'pickup')}}})],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("DROP OFF LOCATION")]),_vm._v(" "),_c('location',{attrs:{"value":_vm.dropoff.title,"extra":_vm.locationExtra,"error":_vm.error.dropoff},on:{"change":function($event){return _vm.locationUpdate($event, 'dropoff')}}})],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"d-flex align-center dep-label"},[_c('div',{staticClass:"label"},[_vm._v("DEPARTURE DATE")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.isReturnTrip),expression:"isReturnTrip"}],staticClass:"trip-type",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.isReturnTrip=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":false}},[_vm._v("Single TRIP")]),_vm._v(" "),_c('option',{domProps:{"value":true}},[_vm._v("Return TRIP")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('div',[_c('div',{staticClass:"sub-label"},[_vm._v("LEG 1")]),_vm._v(" "),_c('datepicker',{class:['datepicker inline', {'has-error':!!_vm.error.pickupDate}],attrs:{"format":_vm.calendarFormat,"disabled-picker":false,"disabled":_vm.disabledDate},on:{"input":_vm.departureUpdate},model:{value:(_vm.pickupDate),callback:function ($$v) {_vm.pickupDate=$$v},expression:"pickupDate"}}),_vm._v(" "),_c('div',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.pickupDate))])],1),_vm._v(" "),_c('div',{staticClass:"m-L-5"},[_c('div',{staticClass:"sub-label"},[_vm._v("LEG 2")]),_vm._v(" "),_c('datepicker',{class:['datepicker inline', {'has-error':!!_vm.error.pickupDateReturn}],attrs:{"format":_vm.calendarFormat,"disabled-picker":!_vm.isReturnTrip,"disabled":_vm.disabledDate},on:{"input":_vm.departureUpdate},model:{value:(_vm.pickupDateReturn),callback:function ($$v) {_vm.pickupDateReturn=$$v},expression:"pickupDateReturn"}}),_vm._v(" "),_c('div',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.pickupDateReturn))])],1)])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("TRAVELLERS")]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"traveller"},[_c('div',{staticClass:"sub-label"},[_vm._v("Adult (13+)")]),_vm._v(" "),_c('select',_vm._l((10),function(i){return _c('option',{key:i,domProps:{"value":i}},[_vm._v(_vm._s(i))])}),0)]),_vm._v(" "),_c('div',{staticClass:"traveller"},[_c('div',{staticClass:"sub-label"},[_vm._v("Children (2-12)")]),_vm._v(" "),_c('select',_vm._l((11),function(i){return _c('option',{key:i,domProps:{"value":i - 1}},[_vm._v(_vm._s(i - 1))])}),0)]),_vm._v(" "),_c('div',{staticClass:"traveller"},[_c('div',{staticClass:"sub-label"},[_vm._v("Infants (below 2 years old)")]),_vm._v(" "),_c('select',_vm._l((11),function(i){return _c('option',{key:i,domProps:{"value":i - 1}},[_vm._v(_vm._s(i - 1))])}),0)])])]),_vm._v(" "),_c('div',{on:{"click":_vm.processFlights}},[_vm._v("SUBMIT")])]),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._v("\n      wee\n    ")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading"},[_c('div',{staticClass:"txt"},[_vm._v("\n      Book a Flight\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(632);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ddd0305_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1899);
function injectStyle (ssrContext) {
  __webpack_require__(1893)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ddd0305"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ddd0305_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1894);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("25d383d4", content, true, {});

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.header[data-v-1ddd0305] {\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/MarketingAds/index.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,6CAA6C;CAC9C","file":"index.vue","sourcesContent":["\n.header[data-v-1ddd0305] {\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdsTable_vue__ = __webpack_require__(633);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22f9fdb3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdsTable_vue__ = __webpack_require__(1898);
function injectStyle (ssrContext) {
  __webpack_require__(1896)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22f9fdb3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22f9fdb3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1897);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("43212436", content, true, {});

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\ntable[data-v-22f9fdb3] {\n  border-collapse: collapse;\n  width: 100%;\n}\n.table-header[data-v-22f9fdb3] {\n  color: #8DA0A9;\n  font-size: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n}\n.table-header th[data-v-22f9fdb3] {\n    padding: 5px;\n}\n.ads-table-container[data-v-22f9fdb3] {\n  padding: 20px;\n}\n.ad-item[data-v-22f9fdb3] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.ad-item td[data-v-22f9fdb3] {\n    padding: 10px 5px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.ad-item .ad-type[data-v-22f9fdb3] {\n    display: inline-block;\n    text-transform: uppercase;\n    font-size: 10px;\n    font-weight: 700;\n    color: #fff;\n    padding: 3px 5px;\n    border-radius: 3px;\n    background-color: #333;\n}\n.ad-item .ad-type.provider[data-v-22f9fdb3] {\n      background-color: #333;\n}\n.ad-item .ad-type.consumer[data-v-22f9fdb3] {\n      background-color: #26D97A;\n}\n.ad-item .ad-type.web[data-v-22f9fdb3] {\n      background-color: #F25E0D;\n}\n.new-ad[data-v-22f9fdb3] {\n  margin-bottom: 20px;\n  text-align: right;\n}\n.loader[data-v-22f9fdb3] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.7);\n  color: #fff;\n}\n.loader i[data-v-22f9fdb3] {\n    vertical-align: middle;\n    margin-right: 5px;\n}\n.loader .v-center[data-v-22f9fdb3] {\n    text-align: center;\n    width: 100%;\n    position: absolute;\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n}\n@media only screen and (max-width: 430px) {\n.new-ad[data-v-22f9fdb3] {\n    text-align: center;\n}\n.card-holder[data-v-22f9fdb3] {\n    margin-top: 15px;\n    padding-bottom: 40px;\n}\n.cards .card[data-v-22f9fdb3] {\n    border: 1px solid #ccc;\n    margin: 0 10px;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-size: 12px;\n}\n.cards .card > div[data-v-22f9fdb3] {\n      margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-22f9fdb3] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      padding-bottom: 3px;\n      border-bottom: 1px solid #eee;\n}\n.cards .card .card-header .name[data-v-22f9fdb3] {\n        font-weight: 900;\n}\n.cards .card .card-header .ad-type[data-v-22f9fdb3] {\n        display: inline-block;\n        text-transform: uppercase;\n        font-size: 10px;\n        font-weight: 700;\n        color: #fff;\n        padding: 3px 5px;\n        border-radius: 3px;\n        background-color: #333;\n}\n.cards .card .card-header .ad-type.provider[data-v-22f9fdb3] {\n          background-color: #333;\n}\n.cards .card .card-header .ad-type.consumer[data-v-22f9fdb3] {\n          background-color: #26D97A;\n}\n.cards .card .card-header .ad-type.web[data-v-22f9fdb3] {\n          background-color: #F25E0D;\n}\n.cards .card .card-header .header[data-v-22f9fdb3] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.cards .card .title[data-v-22f9fdb3] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .label[data-v-22f9fdb3] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-22f9fdb3] {\n      margin-right: 10px;\n      font-weight: 500;\n      text-align: left;\n}\n.cards .card .actions[data-v-22f9fdb3] {\n      border-top: 1px solid #eee;\n      padding-top: 10px;\n      padding-bottom: 5px;\n      margin-top: 10px;\n      text-align: right;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      gap: 10px;\n}\n.cards .card .actions .button[data-v-22f9fdb3] {\n        -webkit-box-flex: 1;\n            -ms-flex: 1;\n                flex: 1;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/MarketingAds/AdsTable.vue"],"names":[],"mappings":";AACA;EACE,0BAA0B;EAC1B,YAAY;CACb;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,0BAA0B;CAC3B;AACD;IACI,aAAa;CAChB;AACD;EACE,cAAc;CACf;AACD;EACE,uBAAuB;EACvB,qCAAqC;CACtC;AACD;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;CACtB;AACD;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;CAC1B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,0BAA0B;CAC/B;AACD;MACM,0BAA0B;CAC/B;AACD;EACE,oBAAoB;EACpB,kBAAkB;CACnB;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,YAAY;CACb;AACD;IACI,uBAAuB;IACvB,kBAAkB;CACrB;AACD;IACI,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,SAAS;IACT,oCAAoC;YAC5B,4BAA4B;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;AACD;IACI,iBAAiB;IACjB,qBAAqB;CACxB;AACD;IACI,uBAAuB;IACvB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,oBAAoB;IACpB,+BAA+B;IAC/B,oBAAoB;IACpB,gBAAgB;CACnB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;MAC5B,oBAAoB;MACpB,8BAA8B;CACnC;AACD;QACQ,iBAAiB;CACxB;AACD;QACQ,sBAAsB;QACtB,0BAA0B;QAC1B,gBAAgB;QAChB,iBAAiB;QACjB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;QACnB,uBAAuB;CAC9B;AACD;UACU,uBAAuB;CAChC;AACD;UACU,0BAA0B;CACnC;AACD;UACU,0BAA0B;CACnC;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;CACrB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;MACM,gBAAgB;MAChB,0BAA0B;MAC1B,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;CACvB;AACD;MACM,mBAAmB;MACnB,iBAAiB;MACjB,iBAAiB;CACtB;AACD;MACM,2BAA2B;MAC3B,kBAAkB;MAClB,oBAAoB;MACpB,iBAAiB;MACjB,kBAAkB;MAClB,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,UAAU;CACf;AACD;QACQ,oBAAoB;YAChB,YAAY;gBACR,QAAQ;CACvB;CACA","file":"AdsTable.vue","sourcesContent":["\ntable[data-v-22f9fdb3] {\n  border-collapse: collapse;\n  width: 100%;\n}\n.table-header[data-v-22f9fdb3] {\n  color: #8DA0A9;\n  font-size: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n}\n.table-header th[data-v-22f9fdb3] {\n    padding: 5px;\n}\n.ads-table-container[data-v-22f9fdb3] {\n  padding: 20px;\n}\n.ad-item[data-v-22f9fdb3] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.ad-item td[data-v-22f9fdb3] {\n    padding: 10px 5px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.ad-item .ad-type[data-v-22f9fdb3] {\n    display: inline-block;\n    text-transform: uppercase;\n    font-size: 10px;\n    font-weight: 700;\n    color: #fff;\n    padding: 3px 5px;\n    border-radius: 3px;\n    background-color: #333;\n}\n.ad-item .ad-type.provider[data-v-22f9fdb3] {\n      background-color: #333;\n}\n.ad-item .ad-type.consumer[data-v-22f9fdb3] {\n      background-color: #26D97A;\n}\n.ad-item .ad-type.web[data-v-22f9fdb3] {\n      background-color: #F25E0D;\n}\n.new-ad[data-v-22f9fdb3] {\n  margin-bottom: 20px;\n  text-align: right;\n}\n.loader[data-v-22f9fdb3] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.7);\n  color: #fff;\n}\n.loader i[data-v-22f9fdb3] {\n    vertical-align: middle;\n    margin-right: 5px;\n}\n.loader .v-center[data-v-22f9fdb3] {\n    text-align: center;\n    width: 100%;\n    position: absolute;\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n}\n@media only screen and (max-width: 430px) {\n.new-ad[data-v-22f9fdb3] {\n    text-align: center;\n}\n.card-holder[data-v-22f9fdb3] {\n    margin-top: 15px;\n    padding-bottom: 40px;\n}\n.cards .card[data-v-22f9fdb3] {\n    border: 1px solid #ccc;\n    margin: 0 10px;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-size: 12px;\n}\n.cards .card > div[data-v-22f9fdb3] {\n      margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-22f9fdb3] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      padding-bottom: 3px;\n      border-bottom: 1px solid #eee;\n}\n.cards .card .card-header .name[data-v-22f9fdb3] {\n        font-weight: 900;\n}\n.cards .card .card-header .ad-type[data-v-22f9fdb3] {\n        display: inline-block;\n        text-transform: uppercase;\n        font-size: 10px;\n        font-weight: 700;\n        color: #fff;\n        padding: 3px 5px;\n        border-radius: 3px;\n        background-color: #333;\n}\n.cards .card .card-header .ad-type.provider[data-v-22f9fdb3] {\n          background-color: #333;\n}\n.cards .card .card-header .ad-type.consumer[data-v-22f9fdb3] {\n          background-color: #26D97A;\n}\n.cards .card .card-header .ad-type.web[data-v-22f9fdb3] {\n          background-color: #F25E0D;\n}\n.cards .card .card-header .header[data-v-22f9fdb3] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.cards .card .title[data-v-22f9fdb3] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .label[data-v-22f9fdb3] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-22f9fdb3] {\n      margin-right: 10px;\n      font-weight: 500;\n      text-align: left;\n}\n.cards .card .actions[data-v-22f9fdb3] {\n      border-top: 1px solid #eee;\n      padding-top: 10px;\n      padding-bottom: 5px;\n      margin-top: 10px;\n      text-align: right;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      gap: 10px;\n}\n.cards .card .actions .button[data-v-22f9fdb3] {\n        -webkit-box-flex: 1;\n            -ms-flex: 1;\n                flex: 1;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ads-table-container"},[_vm._m(0),_vm._v(" "),(!_vm.isMobile)?_c('table',[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{staticClass:"ad-item"},[_c('td',[_vm._v(_vm._s(item.ID))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.brandId))]),_vm._v(" "),_c('td',[_c('span',{class:['ad-type', item.type]},[_vm._v(_vm._s(item.type))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tooltipTitle))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tooltipDescription))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.startDateStr))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.endDateStr))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.published ? 'YES' : 'NO'))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button cta xsmall",attrs:{"href":'/#/ads/' + item.ID}},[_vm._v("EDIT")]),_vm._v(" "),(item.published)?_c('a',{class:{'button cta warning xsmall': true, disabled: item.saving },attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.publish(item, index)}}},[_vm._v("UNPUBLISH")]):_c('a',{class:{'button cta success xsmall': true, disabled: item.saving },attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.publish(item, index)}}},[_vm._v("PUBLISH")]),_vm._v(" "),_c('a',{class:{'button cta error xsmall': true, disabled: item.deleting },attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.remove(item, index)}}},[_vm._v("DELETE")])])])}),0)]):_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"loader"},[_vm._m(2)]),_vm._v(" "),_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"cards"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"header"},[_c('span',{staticClass:"label"},[_vm._v("ID: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(item.ID))]),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("Brand:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(item.brandId))]),_vm._v(" "),_c('span',{class:['ad-type', item.type]},[_vm._v(_vm._s(item.type))])]),_vm._v(" "),_c('div',{staticClass:"header"},[_c('span',{staticClass:"label"},[_vm._v("Published: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(item.published ? 'YES' : 'NO'))])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Title: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(item.tooltipTitle))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Description: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n            "+_vm._s(item.tooltipDescription)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Start Date: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(item.startDateStr))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("End Date: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(item.endDateStr))])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('a',{staticClass:"button cta xsmall",attrs:{"href":'/#/ads/' + item.ID}},[_vm._v("EDIT")]),_vm._v(" "),(item.published)?_c('a',{class:{'button cta warning xsmall': true, disabled: item.saving },attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.publish(item, index)}}},[_vm._v("UNPUBLISH")]):_c('a',{class:{'button cta success xsmall': true, disabled: item.saving },attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.publish(item, index)}}},[_vm._v("PUBLISH")]),_vm._v(" "),_c('a',{class:{'button cta error xsmall': true, disabled: item.deleting },attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.remove(item, index)}}},[_vm._v("DELETE")])])])])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-ad"},[_c('a',{staticClass:"button cta small",attrs:{"href":"/#/ads/new"}},[_vm._v("CREATE NEW AD")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"table-header"},[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("BRAND")]),_vm._v(" "),_c('th',[_vm._v("TYPE")]),_vm._v(" "),_c('th',[_vm._v("TITLE")]),_vm._v(" "),_c('th',[_vm._v("DESCRIPTION")]),_vm._v(" "),_c('th',[_vm._v("START DATE")]),_vm._v(" "),_c('th',[_vm._v("END DATE")]),_vm._v(" "),_c('th',[_vm._v("PUBLISHED")]),_vm._v(" "),_c('th',[_vm._v("ACTIONS")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-center"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-fw fa-2x"}),_vm._v("Loading...\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reports"},[_c('div',{staticClass:"header"},[_vm._v("MARKETING ADS")]),_vm._v(" "),_c('ads-table')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdDetails_vue__ = __webpack_require__(634);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31582a75_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdDetails_vue__ = __webpack_require__(1911);
function injectStyle (ssrContext) {
  __webpack_require__(1901)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31582a75"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31582a75_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1902);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1a7f081b", content, true, {});

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.header[data-v-31582a75] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 51px;\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  z-index: 10;\n}\n.field-container[data-v-31582a75] {\n  margin: 51px 0 30px;\n}\n.card[data-v-31582a75] {\n  padding: 15px;\n  margin-top: 15px;\n}\n.card-title[data-v-31582a75] {\n  font-weight: 700;\n  font-size: 12px;\n  color: #0D79F2;\n}\n.image-input[data-v-31582a75] {\n  width: 140px;\n  height: 140px;\n  position: relative;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n}\n.image-input img[data-v-31582a75] {\n    width: 160px;\n}\n.image-input .guideline[data-v-31582a75] {\n    font-size: 12px;\n    color: #fff;\n    background-color: rgba(0, 0, 0, 0.4);\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    padding: 5px;\n    text-align: center;\n    font-weight: 700;\n}\n.image-input input[type=\"file\"][data-v-31582a75] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 140px;\n    height: 140px;\n    cursor: pointer;\n    opacity: 0;\n    z-index: 8;\n}\n.image-input .uploading[data-v-31582a75] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 140px;\n    height: 140px;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 9;\n}\n.image-input .uploading i[data-v-31582a75] {\n      display: block;\n      text-align: center;\n      line-height: 140px;\n      color: #fff;\n}\n.label-value[data-v-31582a75] {\n  margin-top: 10px;\n}\n.label-value label[data-v-31582a75] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #555;\n}\n.label-value input[data-v-31582a75], .label-value textarea[data-v-31582a75], .label-value select[data-v-31582a75] {\n    margin-top: 0;\n}\n.label-value textarea[data-v-31582a75] {\n    resize: none;\n    height: 300px;\n}\n.label-value .select-input[data-v-31582a75] {\n    position: relative;\n}\n.label-value .select-input i[data-v-31582a75] {\n      position: absolute;\n      color: #777;\n      top: 12px;\n      right: 10px;\n}\n.label-value select[data-v-31582a75] {\n    outline: 0;\n    padding: 10px;\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    background-color: #fff;\n}\n.excerpt-fields[data-v-31582a75] {\n  position: relative;\n}\n.excerpt-fields .image-input[data-v-31582a75] {\n    position: absolute;\n    bottom: 15px;\n    left: 15px;\n}\n.excerpt-fields .label-value[data-v-31582a75] {\n    margin-left: 155px;\n}\n.content-fields[data-v-31582a75] {\n  position: relative;\n}\n.content-fields .image-input[data-v-31582a75] {\n    position: absolute;\n    top: 42px;\n    left: 15px;\n}\n.content-fields .label-value.margin-image[data-v-31582a75] {\n    margin-left: 155px;\n}\n.error-message[data-v-31582a75] {\n  color: #F20D0D;\n  border: 3px solid #F20D0D;\n  text-align: center;\n  padding: 5px;\n  font-weight: 700;\n  border-radius: 3px;\n  margin-bottom: 10px;\n}\n.loader[data-v-31582a75] {\n  position: fixed;\n  z-index: 12;\n  background-color: rgba(0, 0, 0, 0.75);\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: table;\n}\n.loader-content[data-v-31582a75] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.loading[data-v-31582a75] {\n  max-width: 300px;\n  margin: 0 auto;\n  background-color: #fff;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  border-radius: 3px;\n  text-align: center;\n  padding: 20px;\n}\n.loading .message[data-v-31582a75] {\n    margin-top: 5px;\n}\n.loading i.fa-check-circle[data-v-31582a75] {\n    color: #26D97A;\n}\n.loading i.fa-times-circle[data-v-31582a75] {\n    color: #F20D0D;\n}\n.margin-T-z[data-v-31582a75] {\n  margin-top: 0;\n}\n.padding-L[data-v-31582a75] {\n  padding-left: 7px;\n}\n.padding-R[data-v-31582a75] {\n  padding-right: 7px;\n}\n@media only screen and (max-width: 430px) {\n.field-container[data-v-31582a75] {\n    margin-top: 35px;\n}\n.card[data-v-31582a75] {\n    margin: 30px;\n}\n.card.action-div[data-v-31582a75] {\n      margin: 0;\n}\n.small-6[data-v-31582a75] {\n    width: 100%;\n}\n.padding-L[data-v-31582a75], .padding-R[data-v-31582a75] {\n    padding: 0;\n}\n.content-fields[data-v-31582a75] {\n    margin-bottom: 80px;\n}\n.content-fields .image-input[data-v-31582a75] {\n      position: relative;\n      margin: 0 auto;\n      top: 0;\n      left: 0;\n}\n.content-fields .label-value.margin-image[data-v-31582a75] {\n      margin-left: 0;\n}\n.excerpt-fields .image-input[data-v-31582a75] {\n    position: relative;\n    margin: 0 auto;\n    top: 0;\n    left: 0;\n}\n.excerpt-fields .label-value[data-v-31582a75] {\n    margin-left: 0;\n}\n.action-div[data-v-31582a75] {\n    position: fixed;\n    bottom: 0;\n    z-index: 1;\n    width: 100%;\n}\n.action-btns .small-6[data-v-31582a75] {\n    width: 50%;\n    padding: 0 3px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/MarketingAds/AdDetails.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,6CAA6C;EAC7C,YAAY;CACb;AACD;EACE,oBAAoB;CACrB;AACD;EACE,cAAc;EACd,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;CAChB;AACD;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kDAAkD;UAC1C,0CAA0C;EAClD,gBAAgB;CACjB;AACD;IACI,aAAa;CAChB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,qCAAqC;IACrC,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;CACpB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,WAAW;CACd;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,aAAa;IACb,cAAc;IACd,qCAAqC;IACrC,WAAW;CACd;AACD;MACM,eAAe;MACf,mBAAmB;MACnB,mBAAmB;MACnB,YAAY;CACjB;AACD;EACE,iBAAiB;CAClB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,cAAc;CACjB;AACD;IACI,aAAa;IACb,cAAc;CACjB;AACD;IACI,mBAAmB;CACtB;AACD;MACM,mBAAmB;MACnB,YAAY;MACZ,UAAU;MACV,YAAY;CACjB;AACD;IACI,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,4BAA4B;IAC5B,+BAA+B;IAC/B,yBAAyB;IACzB,sBAAsB;IACtB,sCAAsC;IACtC,uBAAuB;CAC1B;AACD;EACE,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;CACd;AACD;IACI,mBAAmB;CACtB;AACD;EACE,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,WAAW;CACd;AACD;IACI,mBAAmB;CACtB;AACD;EACE,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;CACrB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,sCAAsC;EACtC,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,eAAe;CAChB;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,iDAAiD;UACzC,yCAAyC;EACjD,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;CACf;AACD;IACI,gBAAgB;CACnB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;AACA;IACI,iBAAiB;CACpB;AACD;IACI,aAAa;CAChB;AACD;MACM,UAAU;CACf;AACD;IACI,YAAY;CACf;AACD;IACI,WAAW;CACd;AACD;IACI,oBAAoB;CACvB;AACD;MACM,mBAAmB;MACnB,eAAe;MACf,OAAO;MACP,QAAQ;CACb;AACD;MACM,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,eAAe;IACf,OAAO;IACP,QAAQ;CACX;AACD;IACI,eAAe;CAClB;AACD;IACI,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,YAAY;CACf;AACD;IACI,WAAW;IACX,eAAe;CAClB;CACA","file":"AdDetails.vue","sourcesContent":["\n.header[data-v-31582a75] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 51px;\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  z-index: 10;\n}\n.field-container[data-v-31582a75] {\n  margin: 51px 0 30px;\n}\n.card[data-v-31582a75] {\n  padding: 15px;\n  margin-top: 15px;\n}\n.card-title[data-v-31582a75] {\n  font-weight: 700;\n  font-size: 12px;\n  color: #0D79F2;\n}\n.image-input[data-v-31582a75] {\n  width: 140px;\n  height: 140px;\n  position: relative;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n}\n.image-input img[data-v-31582a75] {\n    width: 160px;\n}\n.image-input .guideline[data-v-31582a75] {\n    font-size: 12px;\n    color: #fff;\n    background-color: rgba(0, 0, 0, 0.4);\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    padding: 5px;\n    text-align: center;\n    font-weight: 700;\n}\n.image-input input[type=\"file\"][data-v-31582a75] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 140px;\n    height: 140px;\n    cursor: pointer;\n    opacity: 0;\n    z-index: 8;\n}\n.image-input .uploading[data-v-31582a75] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 140px;\n    height: 140px;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 9;\n}\n.image-input .uploading i[data-v-31582a75] {\n      display: block;\n      text-align: center;\n      line-height: 140px;\n      color: #fff;\n}\n.label-value[data-v-31582a75] {\n  margin-top: 10px;\n}\n.label-value label[data-v-31582a75] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #555;\n}\n.label-value input[data-v-31582a75], .label-value textarea[data-v-31582a75], .label-value select[data-v-31582a75] {\n    margin-top: 0;\n}\n.label-value textarea[data-v-31582a75] {\n    resize: none;\n    height: 300px;\n}\n.label-value .select-input[data-v-31582a75] {\n    position: relative;\n}\n.label-value .select-input i[data-v-31582a75] {\n      position: absolute;\n      color: #777;\n      top: 12px;\n      right: 10px;\n}\n.label-value select[data-v-31582a75] {\n    outline: 0;\n    padding: 10px;\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    background-color: #fff;\n}\n.excerpt-fields[data-v-31582a75] {\n  position: relative;\n}\n.excerpt-fields .image-input[data-v-31582a75] {\n    position: absolute;\n    bottom: 15px;\n    left: 15px;\n}\n.excerpt-fields .label-value[data-v-31582a75] {\n    margin-left: 155px;\n}\n.content-fields[data-v-31582a75] {\n  position: relative;\n}\n.content-fields .image-input[data-v-31582a75] {\n    position: absolute;\n    top: 42px;\n    left: 15px;\n}\n.content-fields .label-value.margin-image[data-v-31582a75] {\n    margin-left: 155px;\n}\n.error-message[data-v-31582a75] {\n  color: #F20D0D;\n  border: 3px solid #F20D0D;\n  text-align: center;\n  padding: 5px;\n  font-weight: 700;\n  border-radius: 3px;\n  margin-bottom: 10px;\n}\n.loader[data-v-31582a75] {\n  position: fixed;\n  z-index: 12;\n  background-color: rgba(0, 0, 0, 0.75);\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: table;\n}\n.loader-content[data-v-31582a75] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.loading[data-v-31582a75] {\n  max-width: 300px;\n  margin: 0 auto;\n  background-color: #fff;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  border-radius: 3px;\n  text-align: center;\n  padding: 20px;\n}\n.loading .message[data-v-31582a75] {\n    margin-top: 5px;\n}\n.loading i.fa-check-circle[data-v-31582a75] {\n    color: #26D97A;\n}\n.loading i.fa-times-circle[data-v-31582a75] {\n    color: #F20D0D;\n}\n.margin-T-z[data-v-31582a75] {\n  margin-top: 0;\n}\n.padding-L[data-v-31582a75] {\n  padding-left: 7px;\n}\n.padding-R[data-v-31582a75] {\n  padding-right: 7px;\n}\n@media only screen and (max-width: 430px) {\n.field-container[data-v-31582a75] {\n    margin-top: 35px;\n}\n.card[data-v-31582a75] {\n    margin: 30px;\n}\n.card.action-div[data-v-31582a75] {\n      margin: 0;\n}\n.small-6[data-v-31582a75] {\n    width: 100%;\n}\n.padding-L[data-v-31582a75], .padding-R[data-v-31582a75] {\n    padding: 0;\n}\n.content-fields[data-v-31582a75] {\n    margin-bottom: 80px;\n}\n.content-fields .image-input[data-v-31582a75] {\n      position: relative;\n      margin: 0 auto;\n      top: 0;\n      left: 0;\n}\n.content-fields .label-value.margin-image[data-v-31582a75] {\n      margin-left: 0;\n}\n.excerpt-fields .image-input[data-v-31582a75] {\n    position: relative;\n    margin: 0 auto;\n    top: 0;\n    left: 0;\n}\n.excerpt-fields .label-value[data-v-31582a75] {\n    margin-left: 0;\n}\n.action-div[data-v-31582a75] {\n    position: fixed;\n    bottom: 0;\n    z-index: 1;\n    width: 100%;\n}\n.action-btns .small-6[data-v-31582a75] {\n    width: 50%;\n    padding: 0 3px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConsumerAdPreview_vue__ = __webpack_require__(635);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_002e3996_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConsumerAdPreview_vue__ = __webpack_require__(1906);
function injectStyle (ssrContext) {
  __webpack_require__(1904)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-002e3996"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConsumerAdPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_002e3996_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConsumerAdPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1905);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("7db7cc13", content, true, {});

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.card[data-v-002e3996] {\n  padding: 15px;\n  margin-top: 15px;\n}\n.card-title[data-v-002e3996] {\n  font-weight: 700;\n  font-size: 12px;\n  color: #0D79F2;\n}\n.ad-preview[data-v-002e3996] {\n  position: relative;\n}\n.ad-preview .bg-image[data-v-002e3996] {\n    width: 300px;\n    margin: 10px auto 0;\n    display: block;\n}\n.ad-preview .map-image[data-v-002e3996] {\n    position: absolute;\n    top: 76px;\n    left: 105px;\n    width: 259px;\n    height: 461px;\n}\n.preview-excerpt[data-v-002e3996] {\n  position: absolute;\n  bottom: 101px;\n  left: 115px;\n  width: 239px;\n  height: 49px;\n  border-radius: 3px;\n  background-color: #fff;\n}\n.preview-excerpt img[data-v-002e3996] {\n    position: absolute;\n    top: 7px;\n    left: 7px;\n    width: 35px;\n}\n.preview-excerpt .ad-text[data-v-002e3996] {\n    margin-left: 49px;\n    margin-right: 22px;\n    padding: 11px 0;\n}\n.preview-excerpt .ad-text-title[data-v-002e3996] {\n    font-weight: 400;\n    font-size: 11px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: #F20D5E;\n    margin-top: -1px;\n}\n.preview-excerpt .ad-text-message[data-v-002e3996] {\n    font-size: 9px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin-top: -1px;\n}\n.preview-excerpt i[data-v-002e3996] {\n    display: block;\n    position: absolute;\n    top: 18px;\n    right: 8px;\n    color: #999;\n    font-size: 11px;\n}\n.ad-title[data-v-002e3996] {\n  position: absolute;\n  top: 84px;\n  left: 140px;\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n  width: 200px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ad-container[data-v-002e3996] {\n  position: absolute;\n  top: 115px;\n  left: 105px;\n  width: 259px;\n  height: 422px;\n}\n.ad-content[data-v-002e3996] {\n  overflow: auto;\n  height: 100%;\n}\n.ad-image[data-v-002e3996] {\n  display: block;\n  width: 259px;\n}\n.ad-content-title[data-v-002e3996] {\n  font-weight: 400;\n  font-size: 11px;\n  color: #F20D5E;\n  padding: 8px 5px;\n  text-align: center;\n}\n.ad-content-body[data-v-002e3996] {\n  text-align: justify;\n  padding: 0 8px;\n  font-size: 9px;\n}\n.ad-cta[data-v-002e3996] {\n  background-color: #009688;\n  font-weight: 400;\n  font-size: 11px;\n  color: #fff;\n  text-decoration: none;\n  display: block;\n  text-align: center;\n  padding: 6px;\n  margin: 8px;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);\n}\n@media screen and (max-width: 430px) {\n.preview-excerpt[data-v-002e3996] {\n    position: relative;\n    left: 0;\n    width: 240px;\n    margin: 0 auto;\n    bottom: 73px;\n}\n.preview[data-v-002e3996] {\n    padding-bottom: 100px;\n}\n.preview[data-v-002e3996]:last-child {\n      margin-bottom: 60px;\n}\n.ad-title[data-v-002e3996] {\n    left: 80px;\n}\n.ad-preview[data-v-002e3996] {\n    margin-bottom: 20px;\n}\n.ad-preview .map-image[data-v-002e3996], .ad-preview .ad-container[data-v-002e3996] {\n      display: block;\n      position: relative;\n      top: 0;\n      left: 0;\n      height: 461px;\n      width: 260px;\n      margin: 0 auto;\n      margin-top: -537px;\n}\n.ad-preview .ad-container[data-v-002e3996] {\n      margin-top: -422px;\n      height: 422px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/MarketingAds/ConsumerAdPreview.vue"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;CAChB;AACD;EACE,mBAAmB;CACpB;AACD;IACI,aAAa;IACb,oBAAoB;IACpB,eAAe;CAClB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,cAAc;CACjB;AACD;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;CACxB;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,YAAY;CACf;AACD;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;CACnB;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,eAAe;IACf,iBAAiB;CACpB;AACD;IACI,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,iBAAiB;CACpB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,gBAAgB;CACnB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;CACzB;AACD;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;CACf;AACD;EACE,eAAe;EACf,aAAa;CACd;AACD;EACE,eAAe;EACf,aAAa;CACd;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;CACpB;AACD;EACE,oBAAoB;EACpB,eAAe;EACf,eAAe;CAChB;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,iDAAiD;EACjD,yCAAyC;CAC1C;AACD;AACA;IACI,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,eAAe;IACf,aAAa;CAChB;AACD;IACI,sBAAsB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;IACI,WAAW;CACd;AACD;IACI,oBAAoB;CACvB;AACD;MACM,eAAe;MACf,mBAAmB;MACnB,OAAO;MACP,QAAQ;MACR,cAAc;MACd,aAAa;MACb,eAAe;MACf,mBAAmB;CACxB;AACD;MACM,mBAAmB;MACnB,cAAc;CACnB;CACA","file":"ConsumerAdPreview.vue","sourcesContent":["\n.card[data-v-002e3996] {\n  padding: 15px;\n  margin-top: 15px;\n}\n.card-title[data-v-002e3996] {\n  font-weight: 700;\n  font-size: 12px;\n  color: #0D79F2;\n}\n.ad-preview[data-v-002e3996] {\n  position: relative;\n}\n.ad-preview .bg-image[data-v-002e3996] {\n    width: 300px;\n    margin: 10px auto 0;\n    display: block;\n}\n.ad-preview .map-image[data-v-002e3996] {\n    position: absolute;\n    top: 76px;\n    left: 105px;\n    width: 259px;\n    height: 461px;\n}\n.preview-excerpt[data-v-002e3996] {\n  position: absolute;\n  bottom: 101px;\n  left: 115px;\n  width: 239px;\n  height: 49px;\n  border-radius: 3px;\n  background-color: #fff;\n}\n.preview-excerpt img[data-v-002e3996] {\n    position: absolute;\n    top: 7px;\n    left: 7px;\n    width: 35px;\n}\n.preview-excerpt .ad-text[data-v-002e3996] {\n    margin-left: 49px;\n    margin-right: 22px;\n    padding: 11px 0;\n}\n.preview-excerpt .ad-text-title[data-v-002e3996] {\n    font-weight: 400;\n    font-size: 11px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: #F20D5E;\n    margin-top: -1px;\n}\n.preview-excerpt .ad-text-message[data-v-002e3996] {\n    font-size: 9px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin-top: -1px;\n}\n.preview-excerpt i[data-v-002e3996] {\n    display: block;\n    position: absolute;\n    top: 18px;\n    right: 8px;\n    color: #999;\n    font-size: 11px;\n}\n.ad-title[data-v-002e3996] {\n  position: absolute;\n  top: 84px;\n  left: 140px;\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n  width: 200px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ad-container[data-v-002e3996] {\n  position: absolute;\n  top: 115px;\n  left: 105px;\n  width: 259px;\n  height: 422px;\n}\n.ad-content[data-v-002e3996] {\n  overflow: auto;\n  height: 100%;\n}\n.ad-image[data-v-002e3996] {\n  display: block;\n  width: 259px;\n}\n.ad-content-title[data-v-002e3996] {\n  font-weight: 400;\n  font-size: 11px;\n  color: #F20D5E;\n  padding: 8px 5px;\n  text-align: center;\n}\n.ad-content-body[data-v-002e3996] {\n  text-align: justify;\n  padding: 0 8px;\n  font-size: 9px;\n}\n.ad-cta[data-v-002e3996] {\n  background-color: #009688;\n  font-weight: 400;\n  font-size: 11px;\n  color: #fff;\n  text-decoration: none;\n  display: block;\n  text-align: center;\n  padding: 6px;\n  margin: 8px;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);\n}\n@media screen and (max-width: 430px) {\n.preview-excerpt[data-v-002e3996] {\n    position: relative;\n    left: 0;\n    width: 240px;\n    margin: 0 auto;\n    bottom: 73px;\n}\n.preview[data-v-002e3996] {\n    padding-bottom: 100px;\n}\n.preview[data-v-002e3996]:last-child {\n      margin-bottom: 60px;\n}\n.ad-title[data-v-002e3996] {\n    left: 80px;\n}\n.ad-preview[data-v-002e3996] {\n    margin-bottom: 20px;\n}\n.ad-preview .map-image[data-v-002e3996], .ad-preview .ad-container[data-v-002e3996] {\n      display: block;\n      position: relative;\n      top: 0;\n      left: 0;\n      height: 461px;\n      width: 260px;\n      margin: 0 auto;\n      margin-top: -537px;\n}\n.ad-preview .ad-container[data-v-002e3996] {\n      margin-top: -422px;\n      height: 422px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card preview"},[_c('div',{staticClass:"card-title"},[_vm._v("EXCERPT PREVIEW")]),_vm._v(" "),_c('div',{staticClass:"ad-preview"},[_c('img',{staticClass:"bg-image",attrs:{"src":"/assets/img/iphone_6.png"}}),_vm._v(" "),_c('img',{staticClass:"map-image",attrs:{"src":"/assets/img/ad-excerpt.png"}}),_vm._v(" "),_c('div',{staticClass:"preview-excerpt"},[_c('img',{attrs:{"src":_vm.ad.tooltipImage}}),_vm._v(" "),_c('div',{staticClass:"ad-text"},[_c('div',{staticClass:"ad-text-title"},[_vm._v(_vm._s(_vm.ad.tooltipTitle))]),_vm._v(" "),_c('div',{staticClass:"ad-text-message"},[_vm._v(_vm._s(_vm.ad.tooltipDescription))])]),_vm._v(" "),_c('i',{staticClass:"fa fa-chevron-right"})])])]),_vm._v(" "),_c('div',{staticClass:"card preview"},[_c('div',{staticClass:"card-title"},[_vm._v("CONTENT PREVIEW")]),_vm._v(" "),_c('div',{staticClass:"ad-preview"},[_c('img',{staticClass:"bg-image",attrs:{"src":"/assets/img/iphone_6.png"}}),_vm._v(" "),_c('img',{staticClass:"map-image",attrs:{"src":"/assets/img/ad-content.png"}}),_vm._v(" "),_c('div',{staticClass:"ad-title"},[_vm._v(_vm._s(_vm.ad.mainHeader))]),_vm._v(" "),_c('div',{staticClass:"ad-container"},[_c('div',{staticClass:"ad-content"},[_c('img',{staticClass:"ad-image",attrs:{"src":_vm.ad.mainImage}}),_vm._v(" "),_c('div',{staticClass:"ad-content-title"},[_vm._v(_vm._s(_vm.ad.mainTitle))]),_vm._v(" "),_c('div',{staticClass:"ad-content-body",domProps:{"innerHTML":_vm._s(_vm.ad.mainBody)}}),_vm._v(" "),_c('a',{staticClass:"ad-cta",attrs:{"href":"javascript:;"}},[_vm._v(_vm._s(_vm.ad.ctaText))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WebAdPreview_vue__ = __webpack_require__(636);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76f5ea56_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WebAdPreview_vue__ = __webpack_require__(1910);
function injectStyle (ssrContext) {
  __webpack_require__(1908)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76f5ea56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WebAdPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76f5ea56_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WebAdPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1909);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("70b01a5c", content, true, {});

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.card[data-v-76f5ea56] {\n  padding: 15px;\n  margin-top: 15px;\n}\n.card-title[data-v-76f5ea56] {\n  font-weight: 700;\n  font-size: 12px;\n  color: #0D79F2;\n}\n.preview-excerpt[data-v-76f5ea56] {\n  margin-top: 15px;\n  position: relative;\n  background-color: #fff;\n  padding: 10px;\n  height: 90px;\n  border-radius: 3px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);\n}\n.preview-excerpt img[data-v-76f5ea56] {\n    position: absolute;\n    top: 10px;\n    left: 15px;\n    width: 70px;\n    height: 70px;\n}\n.preview-excerpt .ad-text[data-v-76f5ea56] {\n    margin-left: 90px;\n    padding: 10px 0;\n}\n.preview-excerpt .ad-text-title[data-v-76f5ea56] {\n    font-size: 17px;\n    font-weight: 700;\n    color: #26BCAC;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.preview-excerpt .ad-text-message[data-v-76f5ea56] {\n    color: #333;\n    font-size: 14px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.ad-preview[data-v-76f5ea56] {\n  margin-top: 15px;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);\n}\n.ad-preview .ad-title[data-v-76f5ea56] {\n    position: relative;\n    text-align: center;\n    font-weight: 700;\n    font-size: 16px;\n    padding: 15px;\n}\n.ad-preview .ad-title i[data-v-76f5ea56] {\n      position: absolute;\n      top: 18px;\n      right: 15px;\n      color: #F20D0D;\n}\n.ad-preview .ad-image[data-v-76f5ea56] {\n    display: block;\n    width: 100%;\n}\n.ad-preview .ad-content-body[data-v-76f5ea56] {\n    padding: 15px;\n}\n.ad-preview .ad-cta-container[data-v-76f5ea56] {\n    text-align: center;\n}\n.ad-preview .ad-cta[data-v-76f5ea56] {\n    background-color: #26BCAC;\n    font-weight: 400;\n    font-size: 16px;\n    color: #fff;\n    text-decoration: none;\n    display: inline-block;\n    text-align: center;\n    padding: 15px;\n    margin-bottom: 15px;\n    border-radius: 3px;\n    -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);\n}\n@media screen and (max-width: 430px) {\n.preview[data-v-76f5ea56] {\n    padding-bottom: 100px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/MarketingAds/WebAdPreview.vue"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;CAChB;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,kDAAkD;UAC1C,0CAA0C;CACnD;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;CAChB;AACD;IACI,kBAAkB;IAClB,gBAAgB;CACnB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;CAC3B;AACD;IACI,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;CAC3B;AACD;EACE,iBAAiB;EACjB,uBAAuB;EACvB,sCAAsC;EACtC,kDAAkD;UAC1C,0CAA0C;CACnD;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;CACjB;AACD;MACM,mBAAmB;MACnB,UAAU;MACV,YAAY;MACZ,eAAe;CACpB;AACD;IACI,eAAe;IACf,YAAY;CACf;AACD;IACI,cAAc;CACjB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,iDAAiD;IACjD,yCAAyC;CAC5C;AACD;AACA;IACI,sBAAsB;CACzB;CACA","file":"WebAdPreview.vue","sourcesContent":["\n.card[data-v-76f5ea56] {\n  padding: 15px;\n  margin-top: 15px;\n}\n.card-title[data-v-76f5ea56] {\n  font-weight: 700;\n  font-size: 12px;\n  color: #0D79F2;\n}\n.preview-excerpt[data-v-76f5ea56] {\n  margin-top: 15px;\n  position: relative;\n  background-color: #fff;\n  padding: 10px;\n  height: 90px;\n  border-radius: 3px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);\n}\n.preview-excerpt img[data-v-76f5ea56] {\n    position: absolute;\n    top: 10px;\n    left: 15px;\n    width: 70px;\n    height: 70px;\n}\n.preview-excerpt .ad-text[data-v-76f5ea56] {\n    margin-left: 90px;\n    padding: 10px 0;\n}\n.preview-excerpt .ad-text-title[data-v-76f5ea56] {\n    font-size: 17px;\n    font-weight: 700;\n    color: #26BCAC;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.preview-excerpt .ad-text-message[data-v-76f5ea56] {\n    color: #333;\n    font-size: 14px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.ad-preview[data-v-76f5ea56] {\n  margin-top: 15px;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);\n}\n.ad-preview .ad-title[data-v-76f5ea56] {\n    position: relative;\n    text-align: center;\n    font-weight: 700;\n    font-size: 16px;\n    padding: 15px;\n}\n.ad-preview .ad-title i[data-v-76f5ea56] {\n      position: absolute;\n      top: 18px;\n      right: 15px;\n      color: #F20D0D;\n}\n.ad-preview .ad-image[data-v-76f5ea56] {\n    display: block;\n    width: 100%;\n}\n.ad-preview .ad-content-body[data-v-76f5ea56] {\n    padding: 15px;\n}\n.ad-preview .ad-cta-container[data-v-76f5ea56] {\n    text-align: center;\n}\n.ad-preview .ad-cta[data-v-76f5ea56] {\n    background-color: #26BCAC;\n    font-weight: 400;\n    font-size: 16px;\n    color: #fff;\n    text-decoration: none;\n    display: inline-block;\n    text-align: center;\n    padding: 15px;\n    margin-bottom: 15px;\n    border-radius: 3px;\n    -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);\n}\n@media screen and (max-width: 430px) {\n.preview[data-v-76f5ea56] {\n    padding-bottom: 100px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-title"},[_vm._v("EXCERPT PREVIEW")]),_vm._v(" "),_c('div',{staticClass:"preview-excerpt"},[_c('img',{attrs:{"src":_vm.ad.tooltipImage}}),_vm._v(" "),_c('div',{staticClass:"ad-text"},[_c('div',{staticClass:"ad-text-title"},[_vm._v(_vm._s(_vm.ad.tooltipTitle))]),_vm._v(" "),_c('div',{staticClass:"ad-text-message"},[_vm._v(_vm._s(_vm.ad.tooltipDescription))])])])]),_vm._v(" "),_c('div',{staticClass:"card preview"},[_c('div',{staticClass:"card-title"},[_vm._v("CONTENT PREVIEW")]),_vm._v(" "),_c('div',{staticClass:"ad-preview"},[_c('div',{staticClass:"ad-title"},[_vm._v(_vm._s(_vm.ad.mainHeader)+" "),_c('i',{staticClass:"fa fa-times"})]),_vm._v(" "),_c('div',{staticClass:"ad-container"},[_c('div',{staticClass:"ad-content"},[_c('img',{staticClass:"ad-image",attrs:{"src":_vm.ad.mainImage}}),_vm._v(" "),_c('div',{staticClass:"ad-content-body",domProps:{"innerHTML":_vm._s(_vm.ad.mainBody)}}),_vm._v(" "),_c('div',{staticClass:"ad-cta-container"},[_c('a',{staticClass:"ad-cta",attrs:{"href":"javascript:;"}},[_vm._v(_vm._s(_vm.ad.ctaText))])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.original.ID !== null)?_c('div',{staticClass:"consumer-ad"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.original.type === '' ? 'NEW' : _vm.original.type.toUpperCase())+" AD "+_vm._s(_vm.adId !== 'new' ? _vm.adId : ''))]),_vm._v(" "),_c('div',{staticClass:"row field-container"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-title"},[_vm._v("AD SETTINGS")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('div',{staticClass:"label-value"},[_c('label',[_vm._v("Start Date")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MM/dd/yyyy"},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('div',{staticClass:"label-value"},[_c('label',[_vm._v("End Date")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"format":"MM/dd/yyyy"},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('div',{staticClass:"label-value"},[_c('label',[_vm._v("Ad Type")]),_vm._v(" "),_c('div',{staticClass:"select-input"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.adType),expression:"adType"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.adType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"web"}},[_vm._v("Web")]),_vm._v(" "),_c('option',{attrs:{"value":"consumer"}},[_vm._v("Consumer")]),_vm._v(" "),_c('option',{attrs:{"value":"provider"}},[_vm._v("Provider")])]),_vm._v(" "),_c('i',{staticClass:"fa fa-angle-down"})])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('div',{staticClass:"label-value"},[_c('label',[_vm._v("Brand")]),_vm._v(" "),_c('div',{staticClass:"select-input"},[_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.brandId),expression:"brandId",modifiers:{"number":true}}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.brandId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.brands),function(brand){return _c('option',{domProps:{"value":brand.id,"selected":brand.id === _vm.original.brandId}},[_vm._v(_vm._s(brand.name))])}),0),_vm._v(" "),_c('i',{staticClass:"fa fa-angle-down"})])])])])]),_vm._v(" "),_c('div',{staticClass:"card excerpt-fields"},[_c('div',{staticClass:"card-title"},[_vm._v("AD EXCERPT")]),_vm._v(" "),_c('div',{staticClass:"image-input"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.uploading.excerpt),expression:"uploading.excerpt"}],staticClass:"uploading"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-2x"})]),_vm._v(" "),_c('input',{attrs:{"type":"file","accept":"image/*"},on:{"change":function($event){return _vm.uploadImage($event, true)}}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.tooltipImage}}),_vm._v(" "),_c('div',{staticClass:"guideline"},[_vm._v("300 x 300")])]),_vm._v(" "),_c('div',{staticClass:"label-value margin-T-z"},[_c('label',[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tooltipTitle),expression:"tooltipTitle"}],attrs:{"type":"text"},domProps:{"value":(_vm.tooltipTitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.tooltipTitle=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"label-value"},[_c('label',[_vm._v("Message")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tooltipDescription),expression:"tooltipDescription"}],attrs:{"type":"text"},domProps:{"value":(_vm.tooltipDescription)},on:{"input":function($event){if($event.target.composing){ return; }_vm.tooltipDescription=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"card content-fields"},[_c('div',{staticClass:"card-title"},[_vm._v("AD CONTENT")]),_vm._v(" "),_c('div',{staticClass:"image-input"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.uploading.main),expression:"uploading.main"}],staticClass:"uploading"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-2x"})]),_vm._v(" "),_c('input',{attrs:{"type":"file","accept":"image/*"},on:{"change":function($event){return _vm.uploadImage($event, false)}}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.mainImage}}),_vm._v(" "),_c('div',{staticClass:"guideline"},[_vm._v("700 x 700")])]),_vm._v(" "),_c('div',{staticClass:"label-value margin-T-z margin-image"},[_c('label',[_vm._v("Page Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mainHeader),expression:"mainHeader"}],attrs:{"type":"text"},domProps:{"value":(_vm.mainHeader)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mainHeader=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"label-value margin-image"},[_c('label',[_vm._v("Content Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mainTitle),expression:"mainTitle"}],attrs:{"type":"text"},domProps:{"value":(_vm.mainTitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mainTitle=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"label-value"},[_c('label',[_vm._v("Content Body")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.mainBody),expression:"mainBody"}],domProps:{"value":(_vm.mainBody)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mainBody=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('div',{staticClass:"label-value"},[_c('label',[_vm._v("CTA Label")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ctaText),expression:"ctaText"}],attrs:{"type":"text"},domProps:{"value":(_vm.ctaText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ctaText=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('div',{staticClass:"label-value"},[_c('label',[_vm._v("CTA Link (Optional)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ctaLink),expression:"ctaLink"}],attrs:{"type":"text"},domProps:{"value":(_vm.ctaLink)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ctaLink=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"card action-div"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.show),expression:"error.show"}],staticClass:"error-message"},[_vm._v(_vm._s(_vm.error.message))])])]),_vm._v(" "),_c('div',{staticClass:"row action-btns"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('a',{staticClass:"button cta small block secondary",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("CANCEL")])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('a',{class:{'button cta small block success': true, disabled: _vm.saving},attrs:{"href":"javascript:;"},on:{"click":_vm.save}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.saving),expression:"saving"}],staticClass:"fa fa-spin fa-spinner"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.saving),expression:"!saving"}]},[_vm._v("SAVE")])])])])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[(_vm.adType === 'consumer')?_c('consumer-ad-preview'):_vm._e(),_vm._v(" "),(_vm.adType === 'web')?_c('web-ad-preview'):_vm._e()],1)])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('div',{staticClass:"loader-content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.done),expression:"!done"}],staticClass:"loading"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-2x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("Saving Ad...")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.done && _vm.success),expression:"done && success"}],staticClass:"loading"},[_c('i',{staticClass:"fas fa-check-circle fa-2x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("Ad successfully saved.")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.done && !_vm.success),expression:"done && !success"}],staticClass:"loading"},[_c('i',{staticClass:"fas fa-times-circle fa-2x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("Oops something went wrong.")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(637);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46cbdafe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1919);
function injectStyle (ssrContext) {
  __webpack_require__(1913)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46cbdafe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46cbdafe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1914);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("48c321af", content, true, {});

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.header[data-v-46cbdafe] {\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Filters/index.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,6CAA6C;CAC9C","file":"index.vue","sourcesContent":["\n.header[data-v-46cbdafe] {\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterTable_vue__ = __webpack_require__(638);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ad4e718_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterTable_vue__ = __webpack_require__(1918);
function injectStyle (ssrContext) {
  __webpack_require__(1916)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ad4e718"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ad4e718_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1917);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("20513289", content, true, {});

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.filter-table-container[data-v-3ad4e718] {\n  width: 1200px;\n  margin: 30px auto;\n}\n.filter-table-container .new-button[data-v-3ad4e718] {\n    margin-bottom: 15px;\n    float: right;\n}\ntable[data-v-3ad4e718] {\n  border-collapse: collapse;\n  width: 100%;\n  overflow: auto;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n  padding-top: 47px;\n  height: 100%;\n  table-layout: fixed;\n}\n.table-header[data-v-3ad4e718] {\n  color: #8DA0A9;\n  font-size: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n}\n.table-header th[data-v-3ad4e718] {\n    padding: 5px;\n}\n.filter[data-v-3ad4e718] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.filter td[data-v-3ad4e718] {\n    padding: 10px 10px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.delete-modal-wrapper[data-v-3ad4e718] {\n  position: fixed;\n  top: -100%;\n  opacity: 0;\n  left: 0;\n  display: table;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: 13;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.delete-modal-wrapper.show[data-v-3ad4e718] {\n    top: 0;\n    opacity: 1;\n}\n.delete-modal-wrapper .delete-modal-content[data-v-3ad4e718] {\n    display: table-cell;\n    text-align: center;\n    vertical-align: middle;\n}\n.delete-modal-wrapper .delete-modal[data-v-3ad4e718] {\n    background-color: #fff;\n    border-radius: 3px;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    width: 300px;\n    margin: 0 auto;\n    padding: 15px;\n    font-size: 14px;\n}\n.delete-modal-wrapper .delete-modal .controls[data-v-3ad4e718] {\n      margin-top: 10px;\n}\n.more-text[data-v-3ad4e718] {\n  text-decoration: underline;\n  color: #0D79F2;\n}\n@media only screen and (max-width: 430px) {\n.filter-table-container[data-v-3ad4e718] {\n    text-align: center;\n    width: 100%;\n    margin: 15px auto;\n}\n.filter-table-container .new-button[data-v-3ad4e718] {\n      float: none;\n      margin-bottom: 0;\n}\n.card-holder[data-v-3ad4e718] {\n    margin-top: 15px;\n    padding-bottom: 40px;\n}\n.cards .card[data-v-3ad4e718] {\n    border: 1px solid #ccc;\n    margin: 0 25px;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-size: 12px;\n}\n.cards .card > div[data-v-3ad4e718] {\n      margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-3ad4e718] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      padding-bottom: 3px;\n      border-bottom: 1px solid #eee;\n}\n.cards .card .card-header .name[data-v-3ad4e718] {\n        font-weight: 900;\n}\n.cards .card .title[data-v-3ad4e718] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .label[data-v-3ad4e718] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-3ad4e718] {\n      margin-right: 10px;\n      font-weight: 500;\n      text-align: left;\n}\n.cards .card .value .comma ~ .comma[data-v-3ad4e718]:not(:empty):before {\n        content: \", \";\n}\n.cards .card .actions[data-v-3ad4e718] {\n      border-top: 1px solid #eee;\n      padding-top: 10px;\n      padding-bottom: 5px;\n      margin-top: 10px;\n      text-align: right;\n}\n.delete-modal-wrapper .delete-modal[data-v-3ad4e718] {\n    width: 90%;\n    padding: 20px 40px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Filters/FilterTable.vue"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,kBAAkB;CACnB;AACD;IACI,oBAAoB;IACpB,aAAa;CAChB;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,oBAAoB;CACrB;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,0BAA0B;CAC3B;AACD;IACI,aAAa;CAChB;AACD;EACE,uBAAuB;EACvB,qCAAqC;CACtC;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;CACtB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;CAC1B;AACD;IACI,uBAAuB;IACvB,mBAAmB;IACnB,iDAAiD;YACzC,yCAAyC;IACjD,aAAa;IACb,eAAe;IACf,cAAc;IACd,gBAAgB;CACnB;AACD;MACM,iBAAiB;CACtB;AACD;EACE,2BAA2B;EAC3B,eAAe;CAChB;AACD;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;CACrB;AACD;MACM,YAAY;MACZ,iBAAiB;CACtB;AACD;IACI,iBAAiB;IACjB,qBAAqB;CACxB;AACD;IACI,uBAAuB;IACvB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,oBAAoB;IACpB,+BAA+B;IAC/B,oBAAoB;IACpB,gBAAgB;CACnB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;MAC5B,oBAAoB;MACpB,8BAA8B;CACnC;AACD;QACQ,iBAAiB;CACxB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;MACM,gBAAgB;MAChB,0BAA0B;MAC1B,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;CACvB;AACD;MACM,mBAAmB;MACnB,iBAAiB;MACjB,iBAAiB;CACtB;AACD;QACQ,cAAc;CACrB;AACD;MACM,2BAA2B;MAC3B,kBAAkB;MAClB,oBAAoB;MACpB,iBAAiB;MACjB,kBAAkB;CACvB;AACD;IACI,WAAW;IACX,mBAAmB;CACtB;CACA","file":"FilterTable.vue","sourcesContent":["\n.filter-table-container[data-v-3ad4e718] {\n  width: 1200px;\n  margin: 30px auto;\n}\n.filter-table-container .new-button[data-v-3ad4e718] {\n    margin-bottom: 15px;\n    float: right;\n}\ntable[data-v-3ad4e718] {\n  border-collapse: collapse;\n  width: 100%;\n  overflow: auto;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n  padding-top: 47px;\n  height: 100%;\n  table-layout: fixed;\n}\n.table-header[data-v-3ad4e718] {\n  color: #8DA0A9;\n  font-size: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n}\n.table-header th[data-v-3ad4e718] {\n    padding: 5px;\n}\n.filter[data-v-3ad4e718] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.filter td[data-v-3ad4e718] {\n    padding: 10px 10px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.delete-modal-wrapper[data-v-3ad4e718] {\n  position: fixed;\n  top: -100%;\n  opacity: 0;\n  left: 0;\n  display: table;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: 13;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.delete-modal-wrapper.show[data-v-3ad4e718] {\n    top: 0;\n    opacity: 1;\n}\n.delete-modal-wrapper .delete-modal-content[data-v-3ad4e718] {\n    display: table-cell;\n    text-align: center;\n    vertical-align: middle;\n}\n.delete-modal-wrapper .delete-modal[data-v-3ad4e718] {\n    background-color: #fff;\n    border-radius: 3px;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    width: 300px;\n    margin: 0 auto;\n    padding: 15px;\n    font-size: 14px;\n}\n.delete-modal-wrapper .delete-modal .controls[data-v-3ad4e718] {\n      margin-top: 10px;\n}\n.more-text[data-v-3ad4e718] {\n  text-decoration: underline;\n  color: #0D79F2;\n}\n@media only screen and (max-width: 430px) {\n.filter-table-container[data-v-3ad4e718] {\n    text-align: center;\n    width: 100%;\n    margin: 15px auto;\n}\n.filter-table-container .new-button[data-v-3ad4e718] {\n      float: none;\n      margin-bottom: 0;\n}\n.card-holder[data-v-3ad4e718] {\n    margin-top: 15px;\n    padding-bottom: 40px;\n}\n.cards .card[data-v-3ad4e718] {\n    border: 1px solid #ccc;\n    margin: 0 25px;\n    margin-bottom: 15px;\n    padding: 8px;\n    padding-bottom: 3px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-size: 12px;\n}\n.cards .card > div[data-v-3ad4e718] {\n      margin-bottom: 3px;\n}\n.cards .card .card-header[data-v-3ad4e718] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      padding-bottom: 3px;\n      border-bottom: 1px solid #eee;\n}\n.cards .card .card-header .name[data-v-3ad4e718] {\n        font-weight: 900;\n}\n.cards .card .title[data-v-3ad4e718] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.cards .card .label[data-v-3ad4e718] {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #bbb;\n      font-weight: 600;\n      margin-right: 5px;\n}\n.cards .card .value[data-v-3ad4e718] {\n      margin-right: 10px;\n      font-weight: 500;\n      text-align: left;\n}\n.cards .card .value .comma ~ .comma[data-v-3ad4e718]:not(:empty):before {\n        content: \", \";\n}\n.cards .card .actions[data-v-3ad4e718] {\n      border-top: 1px solid #eee;\n      padding-top: 10px;\n      padding-bottom: 5px;\n      margin-top: 10px;\n      text-align: right;\n}\n.delete-modal-wrapper .delete-modal[data-v-3ad4e718] {\n    width: 90%;\n    padding: 20px 40px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"filter-table-container"},[_c('a',{staticClass:"button cta success small new-button",attrs:{"href":"#/filter/new"}},[_vm._v("CREATE NEW FILTER")]),_vm._v(" "),(!_vm.isMobile)?_c('table',[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{staticClass:"filter"},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.beforePickupMins))]),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(item.afterPickupMins))]),_vm._v(" "),_c('span',[_vm._v("minutes")])]),_vm._v(" "),_c('td',_vm._l((item.tripDirection),function(direction){return _c('div',[(direction === 'p2p')?_c('span',[_vm._v("Point to Point")]):_c('span',[_vm._v(_vm._s(_vm.capitalize(direction)))])])}),0),_vm._v(" "),_c('td',[_vm._l((_vm.getItemsToDisplay(item.rsvpStatus).items),function(status){return _c('div',[_vm._v(_vm._s(status))])}),_vm._v(" "),(_vm.getItemsToDisplay(item.rsvpStatus).more !== null)?_c('div',{staticClass:"more-text"},[_c('strong',[_vm._v(_vm._s(_vm.getItemsToDisplay(item.rsvpStatus).more))])]):_vm._e()],2),_vm._v(" "),_c('td',[(item.geofences.length <= 0)?_c('div',[_vm._v("NONE")]):_vm._e(),_vm._v(" "),_vm._l((_vm.getItemsToDisplay(item.geofences).items),function(geofence){return _c('div',[_vm._v(_vm._s(geofence))])}),_vm._v(" "),(_vm.getItemsToDisplay(item.geofences).more !== null)?_c('div',{staticClass:"more-text"},[_c('strong',[_vm._v(_vm._s(_vm.getItemsToDisplay(item.geofences).more))])]):_vm._e()],2),_vm._v(" "),_c('td',[_c('a',{staticClass:"button cta xsmall",attrs:{"href":'#/filter/' + item.id}},[_vm._v("EDIT")]),_vm._v(" "),_c('a',{staticClass:"button cta xsmall warning",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.confirmDelete(item.id, item.name)}}},[_vm._v("DELETE")])])])}),0)]):_c('div',{staticClass:"card-holder"},[_c('loading-modal',{attrs:{"showModal":_vm.items.length == 0,"modalMessage":'Loading'}}),_vm._v(" "),_vm._l((_vm.items),function(item,i){return _c('div',{key:i,staticClass:"cards"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"range"},[_c('strong',[_vm._v(_vm._s(item.beforePickupMins))]),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(item.afterPickupMins))]),_vm._v(" "),_c('span',[_vm._v("mins")])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Trip Direction: ")]),_vm._v(" "),_c('div',{staticClass:"value"},_vm._l((item.tripDirection),function(direction,i){return _c('span',{key:i,staticClass:"comma"},[(direction === 'p2p')?_c('span',[_vm._v("Point to Point")]):_c('span',[_vm._v(_vm._s(_vm.capitalize(direction)))])])}),0)]),_vm._v(" "),_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"value"},[_vm._l((_vm.getItemsToDisplay(item.rsvpStatus).items),function(status){return _c('span',{key:status,staticClass:"comma"},[_vm._v(_vm._s(status))])}),_vm._v(" "),(_vm.getItemsToDisplay(item.rsvpStatus).more !== null)?_c('span',{staticClass:"more-text"},[_c('strong',[_vm._v(_vm._s(_vm.getItemsToDisplay(item.rsvpStatus).more))])]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('a',{staticClass:"button cta xsmall",attrs:{"href":'#/filter/' + item.id}},[_vm._v("EDIT")]),_vm._v(" "),_c('a',{staticClass:"button cta xsmall warning",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.confirmDelete(item.id, item.name)}}},[_vm._v("DELETE")])])])])})],2)]),_vm._v(" "),_c('div',{class:{ 'delete-modal-wrapper': true, show: _vm.deleteFilter.show }},[_c('div',{staticClass:"delete-modal-content"},[_c('div',{staticClass:"delete-modal"},[_c('div',{staticClass:"message"},[_vm._v("\n          Are you sure you want to delete filter "),_c('strong',[_vm._v(_vm._s(_vm.deleteFilter.name))]),_vm._v("?\n        ")]),_vm._v(" "),_c('div',{staticClass:"controls"},[_c('a',{staticClass:"button cta xsmall",attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.deleteFilter.show = false}}},[_vm._v("NO")]),_vm._v(" "),_c('a',{staticClass:"button warning cta xsmall",attrs:{"href":"javascript:;"},on:{"click":_vm.executeDelete}},[_vm._v("YES")])])])])]),_vm._v(" "),_c('loading-modal',{attrs:{"showModal":_vm.deleteFilter.deleting,"modalMessage":'Deleting Filter'}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"table-header"},[_c('th',[_vm._v("NAME")]),_vm._v(" "),_c('th',[_vm._v("TIME RANGE")]),_vm._v(" "),_c('th',[_vm._v("TRIP DIRECTION")]),_vm._v(" "),_c('th',[_vm._v("RESERVATION STATUS")]),_vm._v(" "),_c('th',[_vm._v("GEOFENCE AREAS")]),_vm._v(" "),_c('th',[_vm._v("ACTIONS")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('span',{staticClass:"label"},[_vm._v("Reservation Status: ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filters"},[_c('div',{staticClass:"header"},[_vm._v("FILTERS")]),_vm._v(" "),_c('filter-table')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterDetails_vue__ = __webpack_require__(639);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_053fae04_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterDetails_vue__ = __webpack_require__(1923);
function injectStyle (ssrContext) {
  __webpack_require__(1921)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-053fae04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_053fae04_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1922);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("c34cc6dc", content, true, {});

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.header[data-v-053fae04] {\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.filter-inputs[data-v-053fae04] {\n  margin: 30px 0;\n  background-color: #fff;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  padding: 15px;\n}\n.field-group-label[data-v-053fae04] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #0D79F2;\n}\n.input-field > label[data-v-053fae04] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #0D79F2;\n}\n.input-field > input[data-v-053fae04] {\n  margin-top: 5px;\n  padding: 10px;\n  font-size: 14px;\n  background-color: #fff;\n}\n.input-field .error-msg[data-v-053fae04] {\n  font-size: 10px;\n  font-weight: 700;\n  color: #F20D0D;\n  margin-top: 3px;\n  display: none;\n}\n.input-field.error > input[data-v-053fae04] {\n  border-color: #F20D0D;\n}\n.input-field.error > .error-msg[data-v-053fae04] {\n  display: block;\n}\n.input-checkbox[data-v-053fae04] {\n  display: block;\n  font-size: 14px;\n}\n.input-checkbox > *[data-v-053fae04] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.input-checkbox > input[data-v-053fae04] {\n    width: auto;\n    margin-top: 0;\n    margin-right: 5px;\n}\n.input-address[data-v-053fae04] {\n  display: block;\n  margin-top: 10px;\n}\n.input-address > *[data-v-053fae04] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.input-address input[type=\"text\"][data-v-053fae04],\n  .input-address select[data-v-053fae04] {\n    margin-top: 0;\n    width: 290px;\n    font-size: 14px;\n    outline: 0;\n    padding: 10px;\n}\n.input-address input[type=\"text\"].disabled[data-v-053fae04],\n    .input-address select.disabled[data-v-053fae04] {\n      color: rgba(0, 0, 0, 0.3);\n      background-color: #eee;\n}\n.input-address select[data-v-053fae04] {\n    font-size: 14px;\n    height: 43px;\n    outline: 0;\n    padding: 10px;\n    display: inline-block;\n    width: 290px;\n    border-color: rgba(0, 0, 0, 0.15);\n    background-color: #fff;\n    border-radius: 3px;\n}\n.input-address input[type=\"radio\"][data-v-053fae04] {\n    margin-top: 0;\n    margin-right: 5px;\n    width: auto;\n}\n.field-group .error-msg[data-v-053fae04] {\n  font-size: 10px;\n  font-weight: 700;\n  color: #F20D0D;\n  margin-top: 3px;\n  display: none;\n}\n.field-group.error > input[data-v-053fae04] {\n  border-color: #F20D0D;\n}\n.field-group.error > .error-msg[data-v-053fae04] {\n  display: block;\n}\n.controls[data-v-053fae04] {\n  text-align: center;\n  border-top: 1px solid rgba(0, 0, 0, 0.15);\n  padding: 20px 0 5px;\n  margin-top: 10px;\n}\n.services[data-v-053fae04] {\n  margin-bottom: 10px;\n}\n.services .brand[data-v-053fae04] {\n    display: block;\n    font-weight: 600;\n}\n.services ul[data-v-053fae04] {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    -webkit-column-count: 3;\n    -moz-column-count: 3;\n    column-count: 3;\n    -webkit-column-gap: 5px;\n       -moz-column-gap: 5px;\n            column-gap: 5px;\n}\n.services ul li[data-v-053fae04] {\n      font-size: 14px;\n}\n.services ul li input[data-v-053fae04] {\n        display: inline;\n        width: inherit;\n        vertical-align: -2px;\n        margin: 0 5px 0 0;\n}\n.servicearea-list[data-v-053fae04] {\n  margin-bottom: 10px;\n}\n.servicearea-list .label[data-v-053fae04] {\n    font-weight: 600;\n}\n.margin-T[data-v-053fae04] {\n  margin-top: 15px;\n}\n.padding-L[data-v-053fae04] {\n  padding-left: 7px;\n}\n.padding-R[data-v-053fae04] {\n  padding-right: 7px;\n}\n@media only screen and (max-width: 430px) {\n.input-checkbox[data-v-053fae04] {\n    font-size: 13px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    gap: 5px;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    margin-bottom: 8px;\n}\n.small-6[data-v-053fae04], .small-9[data-v-053fae04] {\n    width: 100%;\n}\n.small-6[data-v-053fae04] {\n    margin-bottom: 10px;\n}\n.small-3[data-v-053fae04], .small-4[data-v-053fae04] {\n    width: 50%;\n    padding-left: 0;\n}\n.padding-L[data-v-053fae04] {\n    padding-left: 0;\n}\n.services ul[data-v-053fae04] {\n    -webkit-column-count: 2;\n       -moz-column-count: 2;\n            column-count: 2;\n}\n.services ul li[data-v-053fae04] {\n      font-size: 13px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Filters/FilterDetails.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,6CAA6C;CAC9C;AACD;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,kDAAkD;UAC1C,0CAA0C;EAClD,cAAc;CACf;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;CAChB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;CAChB;AACD;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;CACxB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;CACf;AACD;EACE,sBAAsB;CACvB;AACD;EACE,eAAe;CAChB;AACD;EACE,eAAe;EACf,gBAAgB;CACjB;AACD;IACI,sBAAsB;IACtB,uBAAuB;CAC1B;AACD;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;CACrB;AACD;EACE,eAAe;EACf,iBAAiB;CAClB;AACD;IACI,sBAAsB;IACtB,uBAAuB;CAC1B;AACD;;IAEI,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,cAAc;CACjB;AACD;;MAEM,0BAA0B;MAC1B,uBAAuB;CAC5B;AACD;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,kCAAkC;IAClC,uBAAuB;IACvB,mBAAmB;CACtB;AACD;IACI,cAAc;IACd,kBAAkB;IAClB,YAAY;CACf;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;CACf;AACD;EACE,sBAAsB;CACvB;AACD;EACE,eAAe;CAChB;AACD;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,oBAAoB;EACpB,iBAAiB;CAClB;AACD;EACE,oBAAoB;CACrB;AACD;IACI,eAAe;IACf,iBAAiB;CACpB;AACD;IACI,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;IAChB,wBAAwB;OACrB,qBAAqB;YAChB,gBAAgB;CAC3B;AACD;MACM,gBAAgB;CACrB;AACD;QACQ,gBAAgB;QAChB,eAAe;QACf,qBAAqB;QACrB,kBAAkB;CACzB;AACD;EACE,oBAAoB;CACrB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;AACA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,SAAS;IACT,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;IAC5B,mBAAmB;CACtB;AACD;IACI,YAAY;CACf;AACD;IACI,oBAAoB;CACvB;AACD;IACI,WAAW;IACX,gBAAgB;CACnB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,wBAAwB;OACrB,qBAAqB;YAChB,gBAAgB;CAC3B;AACD;MACM,gBAAgB;CACrB;CACA","file":"FilterDetails.vue","sourcesContent":["\n.header[data-v-053fae04] {\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.filter-inputs[data-v-053fae04] {\n  margin: 30px 0;\n  background-color: #fff;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  padding: 15px;\n}\n.field-group-label[data-v-053fae04] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #0D79F2;\n}\n.input-field > label[data-v-053fae04] {\n  font-size: 12px;\n  font-weight: 700;\n  color: #0D79F2;\n}\n.input-field > input[data-v-053fae04] {\n  margin-top: 5px;\n  padding: 10px;\n  font-size: 14px;\n  background-color: #fff;\n}\n.input-field .error-msg[data-v-053fae04] {\n  font-size: 10px;\n  font-weight: 700;\n  color: #F20D0D;\n  margin-top: 3px;\n  display: none;\n}\n.input-field.error > input[data-v-053fae04] {\n  border-color: #F20D0D;\n}\n.input-field.error > .error-msg[data-v-053fae04] {\n  display: block;\n}\n.input-checkbox[data-v-053fae04] {\n  display: block;\n  font-size: 14px;\n}\n.input-checkbox > *[data-v-053fae04] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.input-checkbox > input[data-v-053fae04] {\n    width: auto;\n    margin-top: 0;\n    margin-right: 5px;\n}\n.input-address[data-v-053fae04] {\n  display: block;\n  margin-top: 10px;\n}\n.input-address > *[data-v-053fae04] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.input-address input[type=\"text\"][data-v-053fae04],\n  .input-address select[data-v-053fae04] {\n    margin-top: 0;\n    width: 290px;\n    font-size: 14px;\n    outline: 0;\n    padding: 10px;\n}\n.input-address input[type=\"text\"].disabled[data-v-053fae04],\n    .input-address select.disabled[data-v-053fae04] {\n      color: rgba(0, 0, 0, 0.3);\n      background-color: #eee;\n}\n.input-address select[data-v-053fae04] {\n    font-size: 14px;\n    height: 43px;\n    outline: 0;\n    padding: 10px;\n    display: inline-block;\n    width: 290px;\n    border-color: rgba(0, 0, 0, 0.15);\n    background-color: #fff;\n    border-radius: 3px;\n}\n.input-address input[type=\"radio\"][data-v-053fae04] {\n    margin-top: 0;\n    margin-right: 5px;\n    width: auto;\n}\n.field-group .error-msg[data-v-053fae04] {\n  font-size: 10px;\n  font-weight: 700;\n  color: #F20D0D;\n  margin-top: 3px;\n  display: none;\n}\n.field-group.error > input[data-v-053fae04] {\n  border-color: #F20D0D;\n}\n.field-group.error > .error-msg[data-v-053fae04] {\n  display: block;\n}\n.controls[data-v-053fae04] {\n  text-align: center;\n  border-top: 1px solid rgba(0, 0, 0, 0.15);\n  padding: 20px 0 5px;\n  margin-top: 10px;\n}\n.services[data-v-053fae04] {\n  margin-bottom: 10px;\n}\n.services .brand[data-v-053fae04] {\n    display: block;\n    font-weight: 600;\n}\n.services ul[data-v-053fae04] {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    -webkit-column-count: 3;\n    -moz-column-count: 3;\n    column-count: 3;\n    -webkit-column-gap: 5px;\n       -moz-column-gap: 5px;\n            column-gap: 5px;\n}\n.services ul li[data-v-053fae04] {\n      font-size: 14px;\n}\n.services ul li input[data-v-053fae04] {\n        display: inline;\n        width: inherit;\n        vertical-align: -2px;\n        margin: 0 5px 0 0;\n}\n.servicearea-list[data-v-053fae04] {\n  margin-bottom: 10px;\n}\n.servicearea-list .label[data-v-053fae04] {\n    font-weight: 600;\n}\n.margin-T[data-v-053fae04] {\n  margin-top: 15px;\n}\n.padding-L[data-v-053fae04] {\n  padding-left: 7px;\n}\n.padding-R[data-v-053fae04] {\n  padding-right: 7px;\n}\n@media only screen and (max-width: 430px) {\n.input-checkbox[data-v-053fae04] {\n    font-size: 13px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    gap: 5px;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    margin-bottom: 8px;\n}\n.small-6[data-v-053fae04], .small-9[data-v-053fae04] {\n    width: 100%;\n}\n.small-6[data-v-053fae04] {\n    margin-bottom: 10px;\n}\n.small-3[data-v-053fae04], .small-4[data-v-053fae04] {\n    width: 50%;\n    padding-left: 0;\n}\n.padding-L[data-v-053fae04] {\n    padding-left: 0;\n}\n.services ul[data-v-053fae04] {\n    -webkit-column-count: 2;\n       -moz-column-count: 2;\n            column-count: 2;\n}\n.services ul li[data-v-053fae04] {\n      font-size: 13px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"filter-details"},[_c('div',{staticClass:"header"},[(_vm.filterId !== 'new')?_c('span',[_c('span',[_vm._v("EDITING FILTER")]),_vm._v(" "),(_vm.filter !== null)?_c('span',[_vm._v("\""+_vm._s(_vm.filter.name)+"\"")]):_vm._e()]):_c('span',[_vm._v("CREATE NEW FILTER")])]),_vm._v(" "),(_vm.editedFilter !== null)?_c('div',{staticClass:"filter-inputs row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('div',{class:{ 'input-field': true, error: _vm.formErrors.name }},[_c('label',[_vm._v("FILTER NAME")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.name),expression:"editedFilter.name"}],attrs:{"type":"text","placeholder":"Type here."},domProps:{"value":(_vm.editedFilter.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editedFilter, "name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"error-msg"},[_vm._v("This field is required.")])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns padding-L padding-R"},[_c('div',{class:{ 'input-field': true, error: _vm.formErrors.beforePickupMins }},[_c('label',[_vm._v("MINUTES BEFORE PICKUP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.beforePickupMins),expression:"editedFilter.beforePickupMins"}],attrs:{"type":"number","placeholder":"Type here."},domProps:{"value":(_vm.editedFilter.beforePickupMins)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editedFilter, "beforePickupMins", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"error-msg"},[_vm._v("This must be greater than 0.")])])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns padding-L"},[_c('div',{class:{ 'input-field': true, error: _vm.formErrors.afterPickupMins }},[_c('label',[_vm._v("MINUTES AFTER PICKUP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.afterPickupMins),expression:"editedFilter.afterPickupMins"}],attrs:{"type":"number","placeholder":"Type here."},domProps:{"value":(_vm.editedFilter.afterPickupMins)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editedFilter, "afterPickupMins", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"error-msg"},[_vm._v("This must be greater than 0.")])])])]),_vm._v(" "),_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-3 columns padding-R"},[_c('div',{class:{ 'field-group': true, error: _vm.formErrors.tripDirection }},[_c('span',{staticClass:"field-group-label"},[_vm._v("TRIP DIRECTIONS")]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedAllTripDirection),expression:"checkedAllTripDirection"}],attrs:{"type":"checkbox"},domProps:{"value":'all',"checked":Array.isArray(_vm.checkedAllTripDirection)?_vm._i(_vm.checkedAllTripDirection,'all')>-1:(_vm.checkedAllTripDirection)},on:{"change":function($event){var $$a=_vm.checkedAllTripDirection,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='all',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedAllTripDirection=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedAllTripDirection=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedAllTripDirection=$$c}}}}),_vm._v(" "),_c('span',[_vm._v("All")])]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.tripDirection),expression:"editedFilter.tripDirection"}],attrs:{"type":"checkbox"},domProps:{"value":'p2p',"checked":Array.isArray(_vm.editedFilter.tripDirection)?_vm._i(_vm.editedFilter.tripDirection,'p2p')>-1:(_vm.editedFilter.tripDirection)},on:{"change":function($event){var $$a=_vm.editedFilter.tripDirection,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='p2p',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "tripDirection", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "tripDirection", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "tripDirection", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Point to Point")])]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.tripDirection),expression:"editedFilter.tripDirection"}],attrs:{"type":"checkbox"},domProps:{"value":'in',"checked":Array.isArray(_vm.editedFilter.tripDirection)?_vm._i(_vm.editedFilter.tripDirection,'in')>-1:(_vm.editedFilter.tripDirection)},on:{"change":function($event){var $$a=_vm.editedFilter.tripDirection,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='in',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "tripDirection", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "tripDirection", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "tripDirection", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("In")])]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.tripDirection),expression:"editedFilter.tripDirection"}],attrs:{"type":"checkbox"},domProps:{"value":'out',"checked":Array.isArray(_vm.editedFilter.tripDirection)?_vm._i(_vm.editedFilter.tripDirection,'out')>-1:(_vm.editedFilter.tripDirection)},on:{"change":function($event){var $$a=_vm.editedFilter.tripDirection,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='out',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "tripDirection", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "tripDirection", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "tripDirection", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Out")])]),_vm._v(" "),_c('div',{staticClass:"error-msg"},[_vm._v("Please select at least one.")])])]),_vm._v(" "),_c('div',{staticClass:"small-9 columns padding-L"},[_c('div',{class:{ 'field-group': true, error: _vm.formErrors.rsvpStatus }},[_c('span',{staticClass:"field-group-label"},[_vm._v("RESERVATION STATUS")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-4 columns"},[_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedAllRsvpStatus),expression:"checkedAllRsvpStatus"}],attrs:{"type":"checkbox"},domProps:{"value":'all',"checked":Array.isArray(_vm.checkedAllRsvpStatus)?_vm._i(_vm.checkedAllRsvpStatus,'all')>-1:(_vm.checkedAllRsvpStatus)},on:{"change":function($event){var $$a=_vm.checkedAllRsvpStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='all',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedAllRsvpStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedAllRsvpStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedAllRsvpStatus=$$c}}}}),_vm._v(" "),_c('span',[_vm._v("All")])]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.rsvpStatus),expression:"editedFilter.rsvpStatus"}],attrs:{"type":"checkbox"},domProps:{"value":'upcoming',"checked":Array.isArray(_vm.editedFilter.rsvpStatus)?_vm._i(_vm.editedFilter.rsvpStatus,'upcoming')>-1:(_vm.editedFilter.rsvpStatus)},on:{"change":function($event){var $$a=_vm.editedFilter.rsvpStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='upcoming',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "rsvpStatus", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Upcoming")])]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.rsvpStatus),expression:"editedFilter.rsvpStatus"}],attrs:{"type":"checkbox"},domProps:{"value":'auto-dispatch',"checked":Array.isArray(_vm.editedFilter.rsvpStatus)?_vm._i(_vm.editedFilter.rsvpStatus,'auto-dispatch')>-1:(_vm.editedFilter.rsvpStatus)},on:{"change":function($event){var $$a=_vm.editedFilter.rsvpStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='auto-dispatch',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "rsvpStatus", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Auto Dispatch")])]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.rsvpStatus),expression:"editedFilter.rsvpStatus"}],attrs:{"type":"checkbox"},domProps:{"value":'ready',"checked":Array.isArray(_vm.editedFilter.rsvpStatus)?_vm._i(_vm.editedFilter.rsvpStatus,'ready')>-1:(_vm.editedFilter.rsvpStatus)},on:{"change":function($event){var $$a=_vm.editedFilter.rsvpStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='ready',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "rsvpStatus", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Ready to Go")])]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.rsvpStatus),expression:"editedFilter.rsvpStatus"}],attrs:{"type":"checkbox"},domProps:{"value":'require-dispatch',"checked":Array.isArray(_vm.editedFilter.rsvpStatus)?_vm._i(_vm.editedFilter.rsvpStatus,'require-dispatch')>-1:(_vm.editedFilter.rsvpStatus)},on:{"change":function($event){var $$a=_vm.editedFilter.rsvpStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='require-dispatch',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "rsvpStatus", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Requires Dispatch")])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.rsvpStatus),expression:"editedFilter.rsvpStatus"}],attrs:{"type":"checkbox"},domProps:{"value":'driver-response',"checked":Array.isArray(_vm.editedFilter.rsvpStatus)?_vm._i(_vm.editedFilter.rsvpStatus,'driver-response')>-1:(_vm.editedFilter.rsvpStatus)},on:{"change":function($event){var $$a=_vm.editedFilter.rsvpStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='driver-response',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "rsvpStatus", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Pending Driver Response")])]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.rsvpStatus),expression:"editedFilter.rsvpStatus"}],attrs:{"type":"checkbox"},domProps:{"value":'dispatched',"checked":Array.isArray(_vm.editedFilter.rsvpStatus)?_vm._i(_vm.editedFilter.rsvpStatus,'dispatched')>-1:(_vm.editedFilter.rsvpStatus)},on:{"change":function($event){var $$a=_vm.editedFilter.rsvpStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='dispatched',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "rsvpStatus", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Dispatched")])]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.rsvpStatus),expression:"editedFilter.rsvpStatus"}],attrs:{"type":"checkbox"},domProps:{"value":'onboard',"checked":Array.isArray(_vm.editedFilter.rsvpStatus)?_vm._i(_vm.editedFilter.rsvpStatus,'onboard')>-1:(_vm.editedFilter.rsvpStatus)},on:{"change":function($event){var $$a=_vm.editedFilter.rsvpStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='onboard',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "rsvpStatus", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("On Board")])]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.rsvpStatus),expression:"editedFilter.rsvpStatus"}],attrs:{"type":"checkbox"},domProps:{"value":'completed',"checked":Array.isArray(_vm.editedFilter.rsvpStatus)?_vm._i(_vm.editedFilter.rsvpStatus,'completed')>-1:(_vm.editedFilter.rsvpStatus)},on:{"change":function($event){var $$a=_vm.editedFilter.rsvpStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='completed',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "rsvpStatus", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Completed")])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns"},[_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.rsvpStatus),expression:"editedFilter.rsvpStatus"}],attrs:{"type":"checkbox"},domProps:{"value":'cancelled',"checked":Array.isArray(_vm.editedFilter.rsvpStatus)?_vm._i(_vm.editedFilter.rsvpStatus,'cancelled')>-1:(_vm.editedFilter.rsvpStatus)},on:{"change":function($event){var $$a=_vm.editedFilter.rsvpStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='cancelled',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "rsvpStatus", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Cancelled")])]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.rsvpStatus),expression:"editedFilter.rsvpStatus"}],attrs:{"type":"checkbox"},domProps:{"value":'packaged',"checked":Array.isArray(_vm.editedFilter.rsvpStatus)?_vm._i(_vm.editedFilter.rsvpStatus,'packaged')>-1:(_vm.editedFilter.rsvpStatus)},on:{"change":function($event){var $$a=_vm.editedFilter.rsvpStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='packaged',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "rsvpStatus", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Packaged")])]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.rsvpStatus),expression:"editedFilter.rsvpStatus"}],attrs:{"type":"checkbox"},domProps:{"value":'un-packaged',"checked":Array.isArray(_vm.editedFilter.rsvpStatus)?_vm._i(_vm.editedFilter.rsvpStatus,'un-packaged')>-1:(_vm.editedFilter.rsvpStatus)},on:{"change":function($event){var $$a=_vm.editedFilter.rsvpStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='un-packaged',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "rsvpStatus", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Unpackaged")])]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.rsvpStatus),expression:"editedFilter.rsvpStatus"}],attrs:{"type":"checkbox"},domProps:{"value":'none',"checked":Array.isArray(_vm.editedFilter.rsvpStatus)?_vm._i(_vm.editedFilter.rsvpStatus,'none')>-1:(_vm.editedFilter.rsvpStatus)},on:{"change":function($event){var $$a=_vm.editedFilter.rsvpStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='none',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "rsvpStatus", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "rsvpStatus", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("None")])])])]),_vm._v(" "),_c('div',{staticClass:"error-msg"},[_vm._v("Please select at least one.")])])])]),_vm._v(" "),_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-3 columns padding-R"},[_c('div',{class:{ 'field-group': true, error: _vm.formErrors.bidSource }},[_c('span',{staticClass:"field-group-label"},[_vm._v("BOOKING SOURCE")]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.bidSource),expression:"editedFilter.bidSource"}],attrs:{"type":"checkbox"},domProps:{"value":'ios',"checked":Array.isArray(_vm.editedFilter.bidSource)?_vm._i(_vm.editedFilter.bidSource,'ios')>-1:(_vm.editedFilter.bidSource)},on:{"change":function($event){var $$a=_vm.editedFilter.bidSource,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='ios',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "bidSource", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "bidSource", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "bidSource", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("iOS Consumer App")])]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.bidSource),expression:"editedFilter.bidSource"}],attrs:{"type":"checkbox"},domProps:{"value":'android',"checked":Array.isArray(_vm.editedFilter.bidSource)?_vm._i(_vm.editedFilter.bidSource,'android')>-1:(_vm.editedFilter.bidSource)},on:{"change":function($event){var $$a=_vm.editedFilter.bidSource,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='android',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "bidSource", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "bidSource", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "bidSource", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Android Consumer App")])]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.bidSource),expression:"editedFilter.bidSource"}],attrs:{"type":"checkbox"},domProps:{"value":'admin',"checked":Array.isArray(_vm.editedFilter.bidSource)?_vm._i(_vm.editedFilter.bidSource,'admin')>-1:(_vm.editedFilter.bidSource)},on:{"change":function($event){var $$a=_vm.editedFilter.bidSource,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='admin',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "bidSource", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "bidSource", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "bidSource", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Backoffice")])]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.bidSource),expression:"editedFilter.bidSource"}],attrs:{"type":"checkbox"},domProps:{"value":'ww',"checked":Array.isArray(_vm.editedFilter.bidSource)?_vm._i(_vm.editedFilter.bidSource,'ww')>-1:(_vm.editedFilter.bidSource)},on:{"change":function($event){var $$a=_vm.editedFilter.bidSource,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='ww',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "bidSource", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "bidSource", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "bidSource", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Website")])]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.bidSource),expression:"editedFilter.bidSource"}],attrs:{"type":"checkbox"},domProps:{"value":'CSR',"checked":Array.isArray(_vm.editedFilter.bidSource)?_vm._i(_vm.editedFilter.bidSource,'CSR')>-1:(_vm.editedFilter.bidSource)},on:{"change":function($event){var $$a=_vm.editedFilter.bidSource,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='CSR',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "bidSource", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "bidSource", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "bidSource", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("CSR")])]),_vm._v(" "),_c('div',{staticClass:"error-msg"},[_vm._v("Please select at least one.")])])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-L padding-R end"},[_c('div',{class:{ 'field-group': true, error: _vm.formErrors.ada }},[_c('span',{staticClass:"field-group-label"},[_vm._v("ADA")]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.ada),expression:"editedFilter.ada"}],attrs:{"type":"checkbox"},domProps:{"value":'all',"checked":Array.isArray(_vm.editedFilter.ada)?_vm._i(_vm.editedFilter.ada,'all')>-1:(_vm.editedFilter.ada)},on:{"change":function($event){var $$a=_vm.editedFilter.ada,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='all',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "ada", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "ada", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "ada", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Non ADA")])]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.ada),expression:"editedFilter.ada"}],attrs:{"type":"checkbox"},domProps:{"value":'wheelChairLift',"checked":Array.isArray(_vm.editedFilter.ada)?_vm._i(_vm.editedFilter.ada,'wheelChairLift')>-1:(_vm.editedFilter.ada)},on:{"change":function($event){var $$a=_vm.editedFilter.ada,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='wheelChairLift',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "ada", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "ada", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "ada", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Wheelchair Lift")])]),_vm._v(" "),_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.ada),expression:"editedFilter.ada"}],attrs:{"type":"checkbox"},domProps:{"value":'serviceDog',"checked":Array.isArray(_vm.editedFilter.ada)?_vm._i(_vm.editedFilter.ada,'serviceDog')>-1:(_vm.editedFilter.ada)},on:{"change":function($event){var $$a=_vm.editedFilter.ada,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='serviceDog',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "ada", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "ada", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "ada", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Service Dog")])]),_vm._v(" "),_c('div',{staticClass:"error-msg"},[_vm._v("Please select at least one.")])])])]),_vm._v(" "),_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-12 columns padding-R"},[_c('div',{class:{ 'field-group': true, error: _vm.formErrors.serviceTypes }},[_c('span',{staticClass:"field-group-label"},[_vm._v("SERVICE TYPES")]),_vm._v(" "),_c('div',{staticClass:"services"},[_c('span',{staticClass:"brand"},[_vm._v("UNBRANDED")]),_vm._v(" "),_c('ul',{staticClass:"body"},_vm._l((_vm.getServiceTypes()),function(service){return _c('li',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.serviceTypes),expression:"editedFilter.serviceTypes"}],attrs:{"type":"checkbox"},domProps:{"value":service.id,"checked":Array.isArray(_vm.editedFilter.serviceTypes)?_vm._i(_vm.editedFilter.serviceTypes,service.id)>-1:(_vm.editedFilter.serviceTypes)},on:{"change":function($event){var $$a=_vm.editedFilter.serviceTypes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=service.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "serviceTypes", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "serviceTypes", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "serviceTypes", $$c)}}}}),_vm._v("\n                        "+_vm._s(service.name)+"\n                      ")])])}),0)]),_vm._v(" "),_vm._l((_vm.brands),function(brand){return (_vm.serviceList(brand.id).length)?_c('div',{staticClass:"services"},[_c('span',{staticClass:"brand"},[_vm._v(_vm._s(brand.name))]),_vm._v(" "),_c('ul',{staticClass:"body"},_vm._l((_vm.serviceList(brand.id)),function(service){return _c('li',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.serviceTypes),expression:"editedFilter.serviceTypes"}],attrs:{"type":"checkbox"},domProps:{"value":service.id,"checked":Array.isArray(_vm.editedFilter.serviceTypes)?_vm._i(_vm.editedFilter.serviceTypes,service.id)>-1:(_vm.editedFilter.serviceTypes)},on:{"change":function($event){var $$a=_vm.editedFilter.serviceTypes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=service.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "serviceTypes", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "serviceTypes", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "serviceTypes", $$c)}}}}),_vm._v("\n                        "+_vm._s(service.label)+"\n                      ")])])}),0)]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"error-msg"},[_vm._v("Please select at least one.")])],2)])]),_vm._v(" "),_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{class:{ 'field-group': true, error: _vm.formErrors.serviceAreas }},[_c('span',{staticClass:"field-group-label"},[_vm._v("GEOFENCE SERVICE AREAS")]),_vm._v(" "),_c('div',{staticClass:"row servicearea-list"},[_c('div',{staticClass:"small-12 columns label"},[_vm._v("UNBRANDED")]),_vm._v(" "),_vm._l((_vm.unbrandedServicearea()),function(serviceArea){return _c('div',{staticClass:"small-4 columns end"},[_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.geofenceIds),expression:"editedFilter.geofenceIds"}],attrs:{"type":"checkbox"},domProps:{"value":serviceArea.id,"checked":Array.isArray(_vm.editedFilter.geofenceIds)?_vm._i(_vm.editedFilter.geofenceIds,serviceArea.id)>-1:(_vm.editedFilter.geofenceIds)},on:{"change":function($event){var $$a=_vm.editedFilter.geofenceIds,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=serviceArea.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "geofenceIds", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "geofenceIds", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "geofenceIds", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(serviceArea.name))])])])})],2),_vm._v(" "),_vm._l((_vm.brands),function(brand){return (_vm.serviceList(brand.id).length)?_c('div',{staticClass:"row servicearea-list"},[_c('div',{staticClass:"small-12 columns label"},[_vm._v(_vm._s(brand.name))]),_vm._v(" "),_vm._l((_vm.brandedServicearea(brand.id)),function(serviceArea){return _c('div',{staticClass:"small-4 columns end"},[_c('label',{staticClass:"input-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedFilter.geofenceIds),expression:"editedFilter.geofenceIds"}],attrs:{"type":"checkbox"},domProps:{"value":serviceArea.id,"checked":Array.isArray(_vm.editedFilter.geofenceIds)?_vm._i(_vm.editedFilter.geofenceIds,serviceArea.id)>-1:(_vm.editedFilter.geofenceIds)},on:{"change":function($event){var $$a=_vm.editedFilter.geofenceIds,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=serviceArea.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.editedFilter, "geofenceIds", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.editedFilter, "geofenceIds", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.editedFilter, "geofenceIds", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(serviceArea.name))])])])})],2):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"error-msg"},[_vm._v("Please select at least one.")])],2)])]),_vm._v(" "),_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"controls"},[_c('a',{staticClass:"button cta secondary small",attrs:{"href":"#/filters"}},[_vm._v("GO BACK")]),_vm._v(" "),_c('a',{staticClass:"button cta success small",attrs:{"href":"javscript:;"},on:{"click":_vm.save}},[_vm._v("SAVE CHANGES")])])])])])]):_vm._e()]),_vm._v(" "),_c('loading-modal',{attrs:{"showModal":_vm.fetchingFilter,"modalMessage":'Loading Filter'}}),_vm._v(" "),_c('loading-modal',{attrs:{"showModal":_vm.savingFilter,"modalMessage":'Saving Filter'}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(640);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c1e991d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1995);
function injectStyle (ssrContext) {
  __webpack_require__(1925)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c1e991d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c1e991d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1926);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("f4d3b0da", content, true, {});

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.settings[data-v-5c1e991d] {\n  margin-bottom: 70px;\n}\n.header[data-v-5c1e991d] {\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.padding-L[data-v-5c1e991d] {\n  padding-left: 7px;\n}\n.padding-R[data-v-5c1e991d] {\n  padding-right: 7px;\n}\n.controls[data-v-5c1e991d] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  background-color: #fff;\n  width: 100%;\n  -webkit-box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.2);\n  padding: 15px 0;\n  text-align: center;\n}\n.controls > .button[data-v-5c1e991d] {\n    width: 200px;\n}\n.success-message[data-v-5c1e991d] {\n  font-weight: 700;\n  color: #555;\n  padding: 3px 0;\n}\n.success-message > *[data-v-5c1e991d] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.success-message > i[data-v-5c1e991d] {\n    color: #26D97A;\n}\n@media only screen and (max-width: 430px) {\n.small-6[data-v-5c1e991d] {\n    width: 100%;\n}\n.padding-L[data-v-5c1e991d], .padding-R[data-v-5c1e991d] {\n    padding: 10px 25px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Settings/index.vue"],"names":[],"mappings":";AACA;EACE,oBAAoB;CACrB;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,6CAA6C;CAC9C;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,kDAAkD;UAC1C,0CAA0C;EAClD,gBAAgB;EAChB,mBAAmB;CACpB;AACD;IACI,aAAa;CAChB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;CAChB;AACD;IACI,sBAAsB;IACtB,uBAAuB;CAC1B;AACD;IACI,eAAe;CAClB;AACD;AACA;IACI,YAAY;CACf;AACD;IACI,mBAAmB;CACtB;CACA","file":"index.vue","sourcesContent":["\n.settings[data-v-5c1e991d] {\n  margin-bottom: 70px;\n}\n.header[data-v-5c1e991d] {\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.padding-L[data-v-5c1e991d] {\n  padding-left: 7px;\n}\n.padding-R[data-v-5c1e991d] {\n  padding-right: 7px;\n}\n.controls[data-v-5c1e991d] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  background-color: #fff;\n  width: 100%;\n  -webkit-box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.2);\n  padding: 15px 0;\n  text-align: center;\n}\n.controls > .button[data-v-5c1e991d] {\n    width: 200px;\n}\n.success-message[data-v-5c1e991d] {\n  font-weight: 700;\n  color: #555;\n  padding: 3px 0;\n}\n.success-message > *[data-v-5c1e991d] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.success-message > i[data-v-5c1e991d] {\n    color: #26D97A;\n}\n@media only screen and (max-width: 430px) {\n.small-6[data-v-5c1e991d] {\n    width: 100%;\n}\n.padding-L[data-v-5c1e991d], .padding-R[data-v-5c1e991d] {\n    padding: 10px 25px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ({
  title: 'INDUSTRY SETTINGS',
  items: {
    HotelSetting: {
      label: 'Hotel',
      type: 'boolean'
    }
  }
});

/***/ }),
/* 1928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'PROVIDER CANCELLATION FEES',
  items: {
    EnableChargeCancels: {
      label: 'Enable Provider Cancellation Fees',
      type: 'boolean'
    },
    CancellationFeeBonusFarePercentage: {
      label: 'Bonus Fare Percentage',
      type: 'integer',
      unit: 'percent'
    },
    EnableNoChargeCancel: {
      label: 'Enable No Cancellation Fee ',
      type: 'boolean'
    },
    NoChargeCancelTimeLtPUTime: {
      label: 'No Cancellation Fee Window',
      type: 'integer',
      unit: 'seconds'
    },
    EnableChargeCancelTier1: {
      label: 'Tier 1 - Enable Cancellation Fee',
      type: 'boolean'
    },
    ChargeCancelTimeLtPUTimeTier1: {
      label: 'Tier 1 - Cancellation Fee Window',
      type: 'integer',
      unit: 'seconds'
    },
    ChargeCancelPercentTier1: {
      label: 'Tier 1 - Cancellation Fee Percentage',
      type: 'integer',
      unit: 'percent'
    },
    EnableChargeCancelTier2: {
      label: 'Tier 2 - Enable Cancellation Fee',
      type: 'boolean'
    },
    ChargeCancelTimeLtPUTimeTier2: {
      label: 'Tier 2 - Cancellation Fee Window',
      type: 'integer',
      unit: 'seconds'
    },
    ChargeCancelPercentTier2: {
      label: 'Tier 2 - Cancellation Fee Percentage',
      type: 'integer',
      unit: 'percent'
    },
    EnableFinalChargeCancel: {
      label: 'Final Tier - Enable Cancellation Fee',
      type: 'boolean'
    },
    FinalChargeCancelPercent: {
      label: 'Final Tier - Cancellation Fee Percentage',
      type: 'integer',
      unit: 'percent'
    },
    CancelFeeTimeout: {
      label: 'Cancellation Fee Timeout',
      type: 'integer',
      unit: 'minutes'
    }
  }
});

/***/ }),
/* 1929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'PROVIDER PAYMENT',
  items: {
    ProviderPaymentBonusLimit: {
      label: 'Provider Payment Bonus Limit',
      type: 'integer',
      unit: '0 - 50%'
    }
  }
});

/***/ }),
/* 1930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'PROVIDER AVAILABILITY SETTINGS',
  items: {
    ProviderRequireAvailability: {
      label: 'Provider Require Availability',
      type: 'boolean'
    },
    ProviderAvailabilityNotifications: {
      label: 'Provider Availability Notifications',
      type: 'boolean'
    }
  }
});

/***/ }),
/* 1931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'PROVIDER PROFILE SETTINGS',
  items: {
    EnableTCPDocToTNC: {
      label: 'Enable TCP doc to TNC & TCP profiles',
      type: 'boolean'
    }
  }
});

/***/ }),
/* 1932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'ASAP SETTINGS',
  items: {
    UseOldAsap: {
      label: 'Use Old Asap',
      type: 'string',
      unit: ''
    },
    ConsumerAppAllowLAXSharedASAP: {
      label: 'Consumer App allow LAX Shared',
      type: 'boolean'
    },
    ConsumerAppAllowNonLAXSharedASAP: {
      label: 'Consumer App allow Non-LAX Shared',
      type: 'boolean'
    },
    ASAPNoDriverIncentiveCode: {
      label: 'No Driver - Incentive CODE',
      type: 'string',
      unit: ''
    }
  }
});

/***/ }),
/* 1933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'EXCLUSIVE RIDE SETTINGS',
  items: {
    ExclusiveNoShowTimeout: {
      label: 'No Show Timeout',
      type: 'integer',
      unit: 'seconds'
    },
    ExclusiveNoShowFee: {
      label: 'No Show Fee',
      type: 'integer',
      unit: '$'
    }
  }
});

/***/ }),
/* 1934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'PROVIDER ARRIVAL/COMPLETED PROXIMITY SETTINGS',
  items: {
    ShowArrivedAndCompletedButtons: {
      label: 'Show Arrived and Complete Buttons',
      type: 'boolean'
    },
    ArrivalProximityRadius: {
      label: 'Arrival Proximity Radius',
      type: 'integer',
      unit: 'miles'
    },
    CompletedProximityRadius: {
      label: 'Completed Proximity Radius',
      type: 'integer',
      unit: 'miles'
    }
  }
});

/***/ }),
/* 1935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'TIME DELAY SETTINGS',
  items: {
    ProviderRatingDelay: {
      label: 'Provider Rating Delay',
      type: 'integer',
      unit: 'seconds'
    },
    TipRatingDelay: {
      label: 'Tip Rating Delay',
      type: 'integer',
      unit: 'seconds'
    },
    HereMapsRouteDelay: {
      label: 'HERE maps Route delay',
      type: 'integer',
      unit: 'seconds'
    }
  }
});

/***/ }),
/* 1936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'REFERRAL CODE SETTINGS',
  items: {
    RefHostUserCredit: {
      label: 'Amount Credited to User',
      type: 'integer',
      unit: '$'
    },
    RefUserCredit: {
      label: 'Amount Credited to Referrals',
      type: 'integer',
      unit: '$'
    },
    RefCreditValidDay: {
      label: 'No. of Days the Referral Credit is Valid',
      type: 'integer',
      unit: 'days'
    }
  }
});

/***/ }),
/* 1937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'OFFER SETTINGS',
  items: {
    ProviderOfferDistanceForASAP: {
      label: 'Provider Offer Distance for ASAP',
      type: 'integer',
      unit: 'miles'
    },
    MaxOffersForASAP: {
      label: 'Max Offers for ASAP',
      type: 'integer',
      unit: 'offers'
    },
    ProviderOfferDistanceForRSVP: {
      label: 'Provider Offer Distance for RSVP',
      type: 'integer',
      unit: 'miles'
    },
    MaxOffersForRSVP: {
      label: 'Max Offers for RSVP',
      type: 'integer',
      unit: 'offers'
    },
    DriverConfirmationTimeBuffer: {
      label: 'Driver Confirmation Time Buffer',
      type: 'integer',
      unit: 'minutes'
    },
    DriverConfirmationTimeOut: {
      label: 'Driver Confirmation Timeout',
      type: 'integer',
      unit: 'minutes'
    }
  }
});

/***/ }),
/* 1938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'APP VERSION SETTINGS',
  items: {
    ForceUpdateProviderToVersion: {
      label: 'iOS - Force Update PA to Version',
      type: 'string',
      unit: 'version'
    },
    ForceUpdateConsumerToVersion: {
      label: 'iOS - Force Update CA to Version',
      type: 'string',
      unit: 'version'
    },
    ForceUpdateAndroidProviderToVersion: {
      label: 'Android - Force Update PA to Version',
      type: 'string',
      unit: 'version'
    },
    ForceUpdateAndroidConsumerToVersion: {
      label: 'Android - Force Update CA to Version',
      type: 'string',
      unit: 'version'
    }
  }
});

/***/ }),
/* 1939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'STAGING LOT SETTINGS',
  items: {
    SanDiegoAirportPing: {
      label: 'San Diego Airport Ping Geofence',
      type: 'integer',
      unit: 'geofence ID'
    },
    OnDeckTimeout: {
      label: 'Timeout for On Deck',
      type: 'integer',
      unit: 'seconds'
    },
    AmountOfChances: {
      label: 'Number of Chances',
      type: 'integer',
      unit: 'chances'
    },
    ActiveTimerPassengerLoading: {
      label: 'Active Timer (Passenger Loading)',
      type: 'integer',
      unit: 'minutes'
    },
    StagingOfflineMins: {
      label: 'Staging Offline Minutes',
      type: 'integer',
      unit: 'minutes'
    }
  }
});

/***/ }),
/* 1940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'AUTO DISPATCH SETTINGS',
  items: {
    DisableAutoDispatch: {
      label: 'Disable Auto Dispatch',
      type: 'boolean'
    },
    AutoDispatchTime: {
      label: 'Auto Dispatch Time',
      type: 'integer',
      unit: 'minutes'
    },
    DispatchRetryAttempt: {
      label: 'Retry Attempts',
      type: 'integer',
      unit: 'retries'
    },
    DriverConfirmationPhoneNumber: {
      label: 'Driver Notification Phone Number',
      type: 'string',
      unit: ''
    }
    // RunAutopackageEnabled: {
    //   label: 'Enable Auto-package Runs',
    //   type: 'boolean',
    // },
    // RunAutodispatchEnabled: {
    //   label: 'Enable Auto-dispatching Runs',
    //   type: 'boolean',
    // },
    // RunAutodispatchNormalMode: {
    //   label: 'Run Auto Dispatch Normal Mode',
    //   type: 'dropdown',
    //   values: [
    //     'send',
    //     'assign'
    //   ]
    // },
    // RunAutodispatchExtendedMode: {
    //   label: 'Run Auto Dispatch Extended Mode',
    //   type: 'dropdown',
    //   values: [
    //     'send',
    //     'assign'
    //   ]
    // },
    // RunAutodispatchExtendedMins: {
    //   label: 'Run Auto Dispatch Extended Minutes',
    //   type: 'integer',
    //   unit: 'mins'
    // },
  }
});

/***/ }),
/* 1941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'AUTO PACKAGE FOR RUNS SETTINGS',
  items: {
    RunAutopackageEnabled: {
      label: 'Enable Auto-package Runs',
      type: 'boolean'
    },
    RunAutopackageEtaOffsetSecs: {
      label: 'Run Auto Package ETA Offset Seconds',
      type: 'integer',
      unit: 'seconds'
    },
    RunAutopackageIgnoreLicense: {
      label: 'Run Auto Package Ignore License',
      type: 'boolean'
    },
    RunAutopackageRunLimit: {
      label: 'Run Auto Package Run Limit',
      type: 'integer',
      unit: ''
    },
    RunAutopackageRunDurationLimit: {
      label: 'Run Auto Package Run Duration Limit',
      type: 'integer',
      unit: 'seconds'
    },
    RunAutopackageMaxTNCRuns: {
      label: 'Run Auto Package Max TNC Runs',
      type: 'integer',
      unit: ''
    },
    RunAutopackageMaxTNCForTCP: {
      label: 'Run Auto Package Max TNC for TCP',
      type: 'integer',
      unit: ''
    }
  }
});

/***/ }),
/* 1942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'AUTO DISPATCH FOR RUNS SETTINGS',
  items: {
    RunNewdispatchEnabled: {
      label: 'RUN Auto Dispatch Enabled',
      type: 'boolean'
    },
    RunNewdispatchRadius: {
      label: 'RUN Auto Dispatch Radius',
      type: 'integer',
      unit: ''
    },
    RunNewdispatchAnnounce: {
      label: 'RUN Auto Dispatch Announce',
      type: 'boolean'
    },
    RunAutodispatch3Enabled: {
      label: 'RUN Auto Dispatch Enabled v3',
      type: 'boolean'
    },
    RunAutodispatch3UpcomingHours: {
      label: 'RUN Auto Dispatch Upcoming Hours v3',
      type: 'integer',
      unit: 'Hours'
    },
    RunAutodispatch3MaxOfferMiles: {
      label: 'RUN Auto Dispatch Max Miles v3',
      type: 'integer',
      unit: 'Miles'
    },
    RunNewdispatchTimer: {
      label: 'Run New Dispatch Timer',
      type: 'integer',
      unit: 'seconds'
    }
  }
});

/***/ }),
/* 1943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'KIOSK APP SETTINGS',
  items: {
    KioskRideRequestTimeout: {
      label: 'Ride Request Timeout',
      type: 'integer',
      unit: 'seconds'
    }
  }
});

/***/ }),
/* 1944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'AUTO PACKAGING SETTINGS',
  items: {
    PackageDirectionAngle: {
      label: 'Maximum Bearing',
      type: 'integer',
      unit: 'degress (0-360)'
    },
    PackageDirectionDistance: {
      label: 'Max Distance from Pickup and Dropoff',
      type: 'integer',
      unit: 'miles (1-999)'
    },
    PackageSharedMaxPassengers: {
      label: 'Max Passengers',
      type: 'integer',
      unit: 'passengers'
    },
    PackageSharedMaxThresholdTime: {
      label: 'RSVP Inclusion Window',
      type: 'integer',
      unit: 'minutes'
    },
    PackageSharedMaxPickupThresholdTime: {
      label: 'Pickup Time Adjustment Window',
      type: 'integer',
      unit: 'minutes'
    }
  }
});

/***/ }),
/* 1945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'AIRPORT - SHARED TIME AVAILABILITY',
  items: {
    AirportStart: {
      label: 'Start Time',
      type: 'string',
      unit: 'time (e.g. 8:00am)'
    },
    AirportEnd: {
      label: 'End Time',
      type: 'string',
      unit: 'time (e.g. 11:00pm)'
    }
  }
});

/***/ }),
/* 1946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'AIRPORT - SUGGESTED PICKUP TIME',
  items: {
    ArrivalDomesticDelay: {
      label: 'Airport Pickup: Domestic',
      type: 'integer',
      unit: 'minutes'
    },
    ArrivalInternationalDelay: {
      label: 'Airport Pickup: International',
      type: 'integer',
      unit: 'minutes'
    },
    DepartureDomesticBuffer: {
      label: 'Airport Dropoff: Domestic',
      type: 'integer',
      unit: 'minutes'
    },
    DepartureInternationalBuffer: {
      label: 'Airport Dropoff: International',
      type: 'integer',
      unit: 'minutes'
    }
  }
});

/***/ }),
/* 1947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'DRIVER BAD RATING NOTIFICATION',
  items: {
    BadReviewEmail: {
      label: 'Emails to Notify',
      type: 'string',
      unit: 'email (comma-separated)'
    },
    BadReviewSms: {
      label: 'Phone Numbers To Notify',
      type: 'string',
      unit: 'phone (comma-separated)'
    }
  }
});

/***/ }),
/* 1948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'DISPATCH NOTIFICATION SETTINGS',
  items: {
    DispatchWarningMins: {
      label: 'Warning - Minutes Before Pickup',
      type: 'integer',
      unit: 'minutes'
    },
    DispatchCriticalMins: {
      label: 'Critical - Minutes Before Pickup',
      type: 'integer',
      unit: 'minutes'
    },
    DispatchCriticalSms: {
      label: 'Critical - Phones to Notify via SMS',
      type: 'string',
      unit: 'phone (comma-separated)'
    },
    DispatchLateWarningMins: {
      label: 'Driver Late Warning - Minutes Before Pickup',
      type: 'integer',
      unit: 'minutes'
    },
    DispatchLateCriticalMins: {
      label: 'Driver Late Critical - Minutes Before Pickup',
      type: 'integer',
      unit: 'minutes'
    }
  }
});

/***/ }),
/* 1949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'DISPATCH SETTINGS',
  items: {
    findNearbyDriverLimit: {
      label: 'Find Nearby driver time limit',
      type: 'integer',
      unit: 'minutes'
    },
    AssignsRequireShifts: {
      label: 'Restriction based availability',
      type: 'boolean'
    }
    // DispatchShowDriverPayment: {
    //   label: 'Show Driver Payment Column',
    //   type: 'boolean'
    // }
  }
});

/***/ }),
/* 1950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'RSVP POOL SETTINGS',
  items: {
    SharedP2P: {
      label: 'SharedP2P',
      type: 'boolean'
    },
    SharedToAirport: {
      label: 'SharedToAirport',
      type: 'boolean'
    },
    SharedFromAirport: {
      label: 'SharedFromAirport',
      type: 'boolean'
    },
    OpoliP2P: {
      label: 'OpoliP2P',
      type: 'boolean'
    },
    OpoliToAirport: {
      label: 'OpoliToAirport',
      type: 'boolean'
    },
    OpoliFromAirport: {
      label: 'OpoliFromAirport',
      type: 'boolean'
    },
    BlackP2P: {
      label: 'BlackP2P',
      type: 'boolean'
    },
    BlackToAirport: {
      label: 'BlackToAirport',
      type: 'boolean'
    },
    BlackFromAirport: {
      label: 'BlackFromAirport',
      type: 'boolean'
    },
    SUVP2P: {
      label: 'SUVP2P',
      type: 'boolean'
    },
    SUVToAirport: {
      label: 'SUVToAirport',
      type: 'boolean'
    },
    SUVFromAirport: {
      label: 'SUVFromAirport',
      type: 'boolean'
    },
    PrivateShuttleP2P: {
      label: 'PrivateShuttleP2P',
      type: 'boolean'
    },
    PrivateShuttleToAirport: {
      label: 'PrivateShuttleToAirport',
      type: 'boolean'
    },
    PrivateShuttleFromAirport: {
      label: 'PrivateShuttleFromAirport',
      type: 'boolean'
    },
    MaxDailyRSVP: {
      label: 'Max Daily RSVP',
      type: 'integer',
      unit: '1-999'
    },
    TimeRangeRSVP: {
      label: 'Time Range',
      type: 'integer',
      unit: 'minutes'
    }
  }
});

/***/ }),
/* 1951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'RSVP OPT-IN SETTINGS',
  items: {
    SharedConversionEnabled: {
      label: 'Shared Conversion Enabled',
      type: 'boolean'
    },
    SharedConversionMinutes: {
      label: 'Shared Conversion Minutes',
      type: 'integer',
      unit: 'minutes'
    },
    OptinAirportStart: {
      label: 'Airport Pickup - Start Time',
      type: 'string',
      unit: 'time (e.g. 8:00am)'
    },
    OptinAirportEnd: {
      label: 'Airport Pickup - End Time',
      type: 'string',
      unit: 'time (e.g. 11:00pm)'
    },
    OptinCombineAirportPickup: {
      label: 'Enable Airport Pickup from Auto Package',
      type: 'boolean'
    },
    OptinCombineAirportDropoff: {
      label: 'Enable Airport Dropoff from Auto Package',
      type: 'boolean'
    },
    OptinMaxRsvpPerPackage: {
      label: 'RSVP Count Per Package',
      type: 'integer',
      unit: 'RSVP'
    },
    OptinDirectionAngle: {
      label: 'Maximum Bearing',
      type: 'integer',
      unit: 'degress (0-360)'
    },
    OptinDirectionDistance: {
      label: 'Max Distance from Pickup and Dropoff',
      type: 'integer',
      unit: 'miles (1-999)'
    },
    OptinMaxThresholdTime: {
      label: 'RSVP Inclusion Window',
      type: 'integer',
      unit: 'minutes'
    },
    OptinMaxPickupThresholdTime: {
      label: 'Pickup Time Adjustment Window',
      type: 'integer',
      unit: 'minutes'
    }
  }
});

/***/ }),
/* 1952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'TRANSPORTATION TIMEOUT SETTINGS',
  items: {
    DriverResponseTime: {
      label: 'Driver Response Time',
      type: 'integer',
      unit: 'seconds'
    },
    CustomerResponseTime: {
      label: 'Customer Response Time',
      type: 'integer',
      unit: 'seconds'
    },
    CarInactiveTimeout: {
      label: 'Car Inactive Timeout',
      type: 'integer',
      unit: 'hours'
    },
    ServerConnectionTimeout: {
      label: 'Server Connection Timeout',
      type: 'integer',
      unit: 'seconds'
    },
    ChainNoShowTimeout: {
      label: 'Shared No Show Timeout',
      type: 'integer',
      unit: 'seconds'
    },
    ChainRequestTimeout: {
      label: 'Shared Accept Timeout',
      type: 'integer',
      unit: 'seconds'
    },
    ASAPRequestTimeout: {
      label: 'ASAP Request Timeout',
      type: 'integer',
      unit: 'seconds'
    },
    DriverLocationReminder: {
      label: 'Driver Location Reminder',
      type: 'integer',
      unit: 'seconds'
    }
  }
});

/***/ }),
/* 1953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'HOTEL TIMEOUT SETTINGS',
  items: {
    HotelResponseTime: {
      label: 'Hotel Response Time',
      type: 'integer',
      unit: 'seconds'
    },
    HotelCustomerResponseTime: {
      label: 'Customer Response Time',
      type: 'integer',
      unit: 'seconds'
    },
    HotelServerConnectionTimeout: {
      label: 'Server Connection Timeout',
      type: 'integer',
      unit: 'seconds'
    }
  }
});

/***/ }),
/* 1954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'OFFER LIMITS',
  items: {
    ConsumerOfferLimitChange: {
      label: 'Consumer Offer Limit Change',
      type: 'integer',
      unit: 'percent'
    },
    ProviderOfferLimitChange: {
      label: 'Provider Offer Limit Change',
      type: 'integer',
      unit: 'percent'
    },
    OfferLimitThreshold: {
      label: 'Offer Limit Threshold',
      type: 'integer',
      unit: '%'
    },
    OfferLimitFraudDetection: {
      label: 'Fraud Detection Limit',
      type: 'integer',
      unit: '$'
    }
  }
});

/***/ }),
/* 1955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'URL SETTINGS',
  items: {
    TermsProvider: {
      label: 'Provider Terms URL',
      type: 'string',
      unit: ''
    },
    FaqsProvider: {
      label: 'Provider FAQs URL',
      type: 'string',
      unit: ''
    },
    ForgotpassProvider: {
      label: 'Provider Forgot Password URL',
      type: 'string',
      unit: ''
    }
  }
});

/***/ }),
/* 1956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'GEOFENCE UNIVERSAL SETTINGS',
  items: {
    RadiusDistance: {
      label: 'Radius Distance',
      type: 'integer',
      unit: 'miles'
    },
    GeofenceExit: {
      label: 'Confirm Geofence Exit',
      type: 'integer',
      unit: 'no. of times'
    },
    FrequencyCheckAroundRadius: {
      label: 'Interval of checking drivers around radius',
      type: 'integer',
      unit: 'seconds'
    },
    FrequencyCheckWithinRadius: {
      label: 'Interval of checking drivers within radius',
      type: 'integer',
      unit: 'seconds'
    },
    FrequencyCheckWithinGeofence: {
      label: 'Interval of checking drivers within geofence',
      type: 'integer',
      unit: 'seconds'
    }
  }
});

/***/ }),
/* 1957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'WEBSITE RSVP FORM',
  items: {
    isP2PReservation: {
      label: 'Allow P2P RSVP',
      type: 'boolean'
    }
  }
});

/***/ }),
/* 1958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'RESERVATION SETTINGS',
  items: {
    WebTimeBuffer: {
      label: 'WebForm New RSVP Time Buffer',
      type: 'integer',
      unit: 'minutes (0-999)'
    },
    AdminTimeBuffer: {
      label: 'Admin New RSVP Time Buffer',
      type: 'integer',
      unit: 'minutes (0-999)'
    },
    AppTimeBuffer: {
      label: 'App New RSVP Time Buffer',
      type: 'integer',
      unit: 'minutes (0-999)'
    },
    ReadyToGoTime: {
      label: 'Ready To Go Time Buffer',
      type: 'integer',
      unit: 'minutes (0-999)'
    },
    // CharterEnabled: {
    //   label: 'Charter Enabled',
    //   type: 'boolean'
    // },
    CharterEnabledBrands: {
      label: 'Brands Charter Enabled',
      type: 'string',
      unit: 'Brand IDs'
    },
    CharterMinDuration: {
      label: 'Charter Booking Min Duration',
      type: 'integer',
      unit: 'minutes'
    },
    CharterMinServiceTypeIds: {
      label: 'Charter Service Applied Min Duration',
      type: 'string',
      unit: 'Service IDs'
    },
    CharterMaxDuration: {
      label: 'Charter Booking Max Duration',
      type: 'integer',
      unit: 'minutes'
    },
    ReservationGapTime: {
      label: 'Time Gap Between Reservations in Runs',
      type: 'integer',
      unit: 'minutes'
    },
    ShowTotalInServiceSelect: {
      label: 'Show Full Price on Service select',
      type: 'boolean'
    }
  }
});

/***/ }),
/* 1959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'CANCELLATION FEES',
  items: {
    RideCreditOffer: {
      label: 'Feature Toggle for Ride Credit Offer',
      type: 'boolean'
    },
    RefundDelayMins: {
      label: 'Refund Delay in Minutes',
      type: 'integer',
      unit: 'minutes',
      extra: '(To disable refund delays, set this value to 0)'
    },
    NumberFreeChances: {
      label: 'Number of Free Chances',
      type: 'integer',
      unit: 'chances (0-99)'
    },
    CancellationFee: {
      label: 'Cancellation Fee',
      type: 'integer',
      unit: 'fee'
    },
    CancelationFeeCurrency: {
      label: 'Cancellation Fee Currency',
      type: 'dropdown',
      values: ['$', '%']
    },
    ResetFrequency: {
      label: 'Reset Frequency',
      type: 'integer',
      unit: 'days (0-999)'
    },
    ChargeCancelationHours: {
      label: 'RSVP Cancellation',
      type: 'integer',
      unit: 'hours from pickup time'
    },
    CancellationFeeHours: {
      label: 'Late Cancel Fee',
      type: 'integer',
      unit: 'fee'
    },
    CancellationFeeHoursCurrency: {
      label: 'Late Cancel Fee Currency',
      type: 'dropdown',
      values: ['$', '%']
    },
    ChainNoShowFee: {
      label: 'Shared No Show Fee',
      type: 'integer',
      unit: '$ ($0 - $99.99)'
    }
  }
});

/***/ }),
/* 1960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'CONSUMER CLIENTS',
  items: {
    HideUnavailableServices: {
      label: 'Hide Unavailable Services',
      type: 'boolean'
    }
  }
});

/***/ }),
/* 1961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'ENABLE MILITARY TIME',
  items: {
    MilitaryTimeConsumerApp: {
      label: 'Consumer App',
      type: 'boolean'
    },
    MilitaryTimeProviderApp: {
      label: 'Provider App',
      type: 'boolean'
    },
    MilitaryTimeBackoffice: {
      label: 'Backoffice',
      type: 'boolean'
    },
    MilitaryTimeWidget: {
      label: 'Booking Widget',
      type: 'boolean'
    },
    MilitaryTimeNotification: {
      label: 'Notifications',
      type: 'boolean'
    }
  }
});

/***/ }),
/* 1962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'FRAUD DETECTION',
  items: {
    FraudDetectionEnabled: {
      label: 'Enable Fraud Detection',
      type: 'boolean'
    },
    FraudDaysCheck: {
      label: 'Fraud Time Window',
      type: 'integer',
      unit: 'days'
    },
    FraudCardUseCount: {
      label: 'No. of Times a Card Was Used',
      type: 'integer',
      unit: 'times'
    },
    FraudConsumerBooks: {
      label: 'No. of RSVPs Booked',
      type: 'integer',
      unit: 'times'
    },
    FraudStateCheck: {
      label: 'Verify Billing State',
      type: 'boolean'
    },
    FraudNotifyEmail: {
      label: 'Email to Notify',
      type: 'string',
      unit: 'email (comma-separated)'
    }
  }
});

/***/ }),
/* 1963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'AIRPORT - PICKUP TIME OFFSETS',
  items: {
    PickupTimeOffsets: {
      label: 'Pickup Time Offsets',
      type: 'pickuptime-offsets'
    }
  }
});

/***/ }),
/* 1964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'CORPORATE PROFILE',
  items: {
    CorporateApproveEmails: {
      label: 'Recipient for new signup',
      type: 'string',
      unit: ''
    }
  }
});

/***/ }),
/* 1965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'MTech Settings',
  items: {
    MTechMarkupValue: {
      label: 'Markup Value',
      type: 'integer',
      unit: 'fee'
    },
    MTechMarkupType: {
      label: 'Markup Type',
      type: 'dropdown',
      values: ['$', '%']
    }
  }
});

/***/ }),
/* 1966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'PROVIDER WORK LIMIT',
  items: {
    ProviderMinRestMins: {
      label: 'Provider Minimum Rest Minutes',
      type: 'integer',
      unit: 'minutes'
    },
    ProviderMaxWorkMins: {
      label: 'Provider Maximum Work Minutes',
      type: 'integer',
      unit: 'minutes'
    }
    // ProviderMaxGapMins: {
    //   label: 'Provider Maximum Gap Minutes',
    //   type: 'integer',
    //   unit: 'minutes'
    // },
  }
});

/***/ }),
/* 1967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'TIGHT ROUTE SETTINGS',
  items: {
    TightRouteSecPerMile: {
      label: 'Tight Route Seconds Per Mile',
      type: 'integer',
      unit: 'seconds'
    }
  }
});

/***/ }),
/* 1968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'D2D Settings',
  items: {
    D2DMarkupPercent: {
      label: 'Mark up Percent',
      type: 'integer',
      unit: ''
    },
    D2DTimeBuffer: {
      label: 'Earliest Pickup Date',
      type: 'integer',
      unit: 'minutes'
    },
    D2DArrivalDomesticSuggestedMins: {
      label: 'Arrival Domestic Buffer',
      type: 'integer',
      unit: 'minutes'
    },
    D2DArrivalInternationalSuggestedMins: {
      label: 'Arrival International Buffer',
      type: 'integer',
      unit: 'minutes'
    },
    D2DDepartureDomesticSuggestedMins: {
      label: 'Departure Domestic Buffer',
      type: 'integer',
      unit: 'minutes'
    },
    D2DDepartureInternationalSuggestedMins: {
      label: 'Departure International Buffer',
      type: 'integer',
      unit: 'minutes'
    },
    D2DAirportDistanceLimitMiles: {
      label: 'Nearby Airport Distance Limit',
      type: 'integer',
      unit: 'miles'
    },
    D2DForceGroundMiles: {
      label: 'Distance to Force ground booking',
      type: 'integer',
      unit: 'miles'
    },
    ForceUpdateAndroidD2DConsumerVersion: {
      label: 'Force update Android - CA',
      type: 'string',
      unit: ''
    },
    ForceUpdateIOSD2DConsumerVersion: {
      label: 'Force update IOS - CA',
      type: 'string',
      unit: ''
    },
    ForceUpdateAndroidD2DProviderVersion: {
      label: 'Force update Android - PA',
      type: 'string',
      unit: ''
    },
    ForceUpdateIOSD2DProviderVersion: {
      label: 'Force update IOS - PA',
      type: 'string',
      unit: ''
    },
    D2DFlightCancelFeeType: {
      label: 'Cancellation Fee Currency - FLIGHT',
      type: 'dropdown',
      values: ['$', '%']
    },
    D2DFlightCancelFeeValue: {
      label: 'Cancellation Fee - FLIGHT',
      type: 'integer',
      unit: 'fee'
    },
    D2DGroundCancelFeeType: {
      label: 'Cancellation Fee Currency - GROUND',
      type: 'dropdown',
      values: ['$', '%']
    },
    D2DGroundCancelFeeValue: {
      label: 'Cancellation Fee - GROUND',
      type: 'integer',
      unit: 'fee'
    },
    D2DGroundLeg1Discount: {
      label: 'Ground Leg1 Discount',
      type: 'discountField',
      fields: {
        type: {
          id: 'D2DGroundLeg1DiscountType',
          label: 'Type',
          type: 'dropdown',
          values: ['$', '%']
        },
        amount: {
          id: 'D2DGroundLeg1Discount',
          label: 'Amount',
          type: 'integer',
          unit: ''
        }
      }
    },
    D2DGroundLeg2Discount: {
      label: 'Ground Leg2 Discount',
      type: 'discountField',
      fields: {
        type: {
          id: 'D2DGroundLeg2DiscountType',
          label: 'Type',
          type: 'dropdown',
          values: ['$', '%']
        },
        amount: {
          id: 'D2DGroundLeg2Discount',
          label: 'Amount',
          type: 'integer',
          unit: ''
        }
      }
    },
    D2DGroundLeg3Discount: {
      label: 'Ground Leg3 Discount',
      type: 'discountField',
      fields: {
        type: {
          id: 'D2DGroundLeg3DiscountType',
          label: 'Type',
          type: 'dropdown',
          values: ['$', '%']
        },
        amount: {
          id: 'D2DGroundLeg3Discount',
          label: 'Amount',
          type: 'integer',
          unit: ''
        }
      }
    },
    D2DGroundLeg4Discount: {
      label: 'Ground Leg4 Discount',
      type: 'discountField',
      fields: {
        type: {
          id: 'D2DGroundLeg4DiscountType',
          label: 'Type',
          type: 'dropdown',
          values: ['$', '%']
        },
        amount: {
          id: 'D2DGroundLeg4Discount',
          label: 'Amount',
          type: 'integer',
          unit: ''
        }
      }
    },
    D2DPhoneRequire: {
      label: 'Phone Require before Flight Quote',
      type: 'boolean'
    },
    D2DSessionTimeoutSecs: {
      label: 'Session Duration',
      type: 'integer',
      unit: 'seconds'
    },
    D2DSessionWarningSecs: {
      label: 'Session Time Left - Show Warning',
      type: 'integer',
      unit: 'seconds'
    }
  }
});

/***/ }),
/* 1969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'Lyft Settings',
  items: {
    LyftPriceAdditionPercentage: {
      label: 'Additional Price Percentage',
      type: 'integer',
      unit: '%'
    },
    LyftPriceSubstractionPercentage: {
      label: 'Deduction Price Percentage',
      type: 'integer',
      unit: '%'
    },
    LyftDispatchRestrictPercent: {
      label: 'Lyft Assign Price Limit',
      type: 'integer',
      unit: '%'
    }
  }
});

/***/ }),
/* 1970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'Rental SETTINGS',
  items: {
    RentalEnabled: {
      label: 'Enable Rental',
      type: 'boolean'
    },
    RentalMaxDuration: {
      label: 'Rental Max Duration',
      type: 'integer',
      unit: 'minutes'
    }
  }
});

/***/ }),
/* 1971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsGroup_vue__ = __webpack_require__(642);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_854ef138_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsGroup_vue__ = __webpack_require__(1994);
function injectStyle (ssrContext) {
  __webpack_require__(1972)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-854ef138"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_854ef138_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1973);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1f2067be", content, true, {});

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.card[data-v-854ef138] {\n  padding: 15px;\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n.card-title[data-v-854ef138] {\n  font-weight: 700;\n  font-size: 12px;\n  color: #0D79F2;\n}\n.config-item[data-v-854ef138] {\n  padding: 5px 0 10px;\n}\n.config-item label[data-v-854ef138] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #555;\n}\n.config-item label i[data-v-854ef138] {\n      font-weight: 400;\n}\n.config-item[data-v-854ef138]:not(:first-child) {\n    margin-top: 5px;\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n.dc-field[data-v-854ef138] {\n  gap: 5px;\n}\n.dc-field .dc-type[data-v-854ef138] {\n    width: 60px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Settings/SettingsGroup.vue"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;CACrB;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;CAChB;AACD;EACE,oBAAoB;CACrB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;MACM,iBAAiB;CACtB;AACD;IACI,gBAAgB;IAChB,yCAAyC;CAC5C;AACD;EACE,SAAS;CACV;AACD;IACI,YAAY;CACf","file":"SettingsGroup.vue","sourcesContent":["\n.card[data-v-854ef138] {\n  padding: 15px;\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n.card-title[data-v-854ef138] {\n  font-weight: 700;\n  font-size: 12px;\n  color: #0D79F2;\n}\n.config-item[data-v-854ef138] {\n  padding: 5px 0 10px;\n}\n.config-item label[data-v-854ef138] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #555;\n}\n.config-item label i[data-v-854ef138] {\n      font-weight: 400;\n}\n.config-item[data-v-854ef138]:not(:first-child) {\n    margin-top: 5px;\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n.dc-field[data-v-854ef138] {\n  gap: 5px;\n}\n.dc-field .dc-type[data-v-854ef138] {\n    width: 60px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__(643);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_629ad530_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__(1977);
function injectStyle (ssrContext) {
  __webpack_require__(1975)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-629ad530"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_629ad530_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1976);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("29f71e6c", content, true, {});

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\nselect[data-v-629ad530] {\n  font-size: 14px;\n  height: 37px;\n  outline: 0;\n  padding: 7px 10px;\n  display: inline-block;\n  width: 100%;\n  max-width: 200px;\n  border-color: rgba(0, 0, 0, 0.15);\n  background-color: #fff;\n  border-radius: 3px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Settings/controls/Dropdown.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;CACpB","file":"Dropdown.vue","sourcesContent":["\nselect[data-v-629ad530] {\n  font-size: 14px;\n  height: 37px;\n  outline: 0;\n  padding: 7px 10px;\n  display: inline-block;\n  width: 100%;\n  max-width: 200px;\n  border-color: rgba(0, 0, 0, 0.15);\n  background-color: #fff;\n  border-radius: 3px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dropdownValue),expression:"dropdownValue"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dropdownValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":''}},[_vm._v("Choose one")]),_vm._v(" "),_vm._l((_vm.values),function(value){return _c('option',{domProps:{"value":value}},[_vm._v(_vm._s(value))])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputInteger_vue__ = __webpack_require__(644);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29f30099_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputInteger_vue__ = __webpack_require__(1981);
function injectStyle (ssrContext) {
  __webpack_require__(1979)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29f30099"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputInteger_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29f30099_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputInteger_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1980);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("fca0c198", content, true, {});

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.input-integer > *[data-v-29f30099] {\n  display: inline-block;\n  vertical-align: middle;\n  margin-top: 5px;\n}\n.input-integer.no-mt > *[data-v-29f30099] {\n  margin-top: 0;\n}\ninput[type=\"number\"][data-v-29f30099] {\n  font-size: 14px;\n  padding: 7px 10px;\n  display: inline-block;\n  width: 200px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\nspan[data-v-29f30099] {\n  font-size: 12px;\n  background-color: #555;\n  color: #fff;\n  padding: 9px 10px 10px;\n  margin-left: -5px;\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n.extra[data-v-29f30099] {\n  display: block;\n  font-size: 12px;\n  color: #777;\n}\n@media only screen and (max-width: 430px) {\n.input-integer[data-v-29f30099] {\n    display: grid;\n    grid-template-areas: \"a b\"\r \"c c\";\n    grid-auto-columns: 3fr 1fr;\n}\n.input-integer input[type=\"number\"][data-v-29f30099] {\n      grid-area: a;\n      width: 100%;\n}\n.input-integer span[data-v-29f30099] {\n      grid-area: b;\n      width: 100%;\n}\n.input-integer div.extra[data-v-29f30099] {\n      grid-area: c;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Settings/controls/InputInteger.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,2BAA2B;EAC3B,8BAA8B;CAC/B;AACD;EACE,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;CACjC;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;CACb;AACD;AACA;IACI,cAAc;IACd,kCACG;IACH,2BAA2B;CAC9B;AACD;MACM,aAAa;MACb,YAAY;CACjB;AACD;MACM,aAAa;MACb,YAAY;CACjB;AACD;MACM,aAAa;CAClB;CACA","file":"InputInteger.vue","sourcesContent":["\n.input-integer > *[data-v-29f30099] {\n  display: inline-block;\n  vertical-align: middle;\n  margin-top: 5px;\n}\n.input-integer.no-mt > *[data-v-29f30099] {\n  margin-top: 0;\n}\ninput[type=\"number\"][data-v-29f30099] {\n  font-size: 14px;\n  padding: 7px 10px;\n  display: inline-block;\n  width: 200px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\nspan[data-v-29f30099] {\n  font-size: 12px;\n  background-color: #555;\n  color: #fff;\n  padding: 9px 10px 10px;\n  margin-left: -5px;\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n.extra[data-v-29f30099] {\n  display: block;\n  font-size: 12px;\n  color: #777;\n}\n@media only screen and (max-width: 430px) {\n.input-integer[data-v-29f30099] {\n    display: grid;\n    grid-template-areas: \"a b\"\r \"c c\";\n    grid-auto-columns: 3fr 1fr;\n}\n.input-integer input[type=\"number\"][data-v-29f30099] {\n      grid-area: a;\n      width: 100%;\n}\n.input-integer span[data-v-29f30099] {\n      grid-area: b;\n      width: 100%;\n}\n.input-integer div.extra[data-v-29f30099] {\n      grid-area: c;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['input-integer', {'no-mt': _vm.removeMT}]},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.integerValue),expression:"integerValue"}],attrs:{"type":"number"},domProps:{"value":(_vm.integerValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.integerValue=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.unit !== ''),expression:"unit !== ''"}]},[_vm._v(_vm._s(_vm.unit))]),_vm._v(" "),_c('div',{staticClass:"extra"},[_vm._v(_vm._s(_vm.extra))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputString_vue__ = __webpack_require__(645);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17862fed_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputString_vue__ = __webpack_require__(1985);
function injectStyle (ssrContext) {
  __webpack_require__(1983)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17862fed"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputString_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17862fed_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputString_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1984);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1294f8a6", content, true, {});

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.input-string > *[data-v-17862fed] {\n  display: inline-block;\n  vertical-align: middle;\n  margin-top: 5px;\n}\ninput[type=\"text\"][data-v-17862fed] {\n  font-size: 14px;\n  padding: 7px 10px;\n}\n.input-string.with-unit input[type=\"text\"][data-v-17862fed] {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  width: 250px;\n}\n.input-string.with-unit span[data-v-17862fed] {\n  font-size: 12px;\n  background-color: #555;\n  color: #fff;\n  padding: 9px 10px 10px;\n  margin-left: -5px;\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n@media only screen and (max-width: 430px) {\n.input-string.with-unit input[type=\"text\"][data-v-17862fed] {\n    width: 100%;\n}\n.input-string.with-unit span[data-v-17862fed] {\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n    margin-left: 0;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Settings/controls/InputString.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;CACjB;AACD;EACE,gBAAgB;EAChB,kBAAkB;CACnB;AACD;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,aAAa;CACd;AACD;EACE,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;CACjC;AACD;AACA;IACI,YAAY;CACf;AACD;IACI,2BAA2B;IAC3B,wBAAwB;IACxB,mBAAmB;IACnB,eAAe;CAClB;CACA","file":"InputString.vue","sourcesContent":["\n.input-string > *[data-v-17862fed] {\n  display: inline-block;\n  vertical-align: middle;\n  margin-top: 5px;\n}\ninput[type=\"text\"][data-v-17862fed] {\n  font-size: 14px;\n  padding: 7px 10px;\n}\n.input-string.with-unit input[type=\"text\"][data-v-17862fed] {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  width: 250px;\n}\n.input-string.with-unit span[data-v-17862fed] {\n  font-size: 12px;\n  background-color: #555;\n  color: #fff;\n  padding: 9px 10px 10px;\n  margin-left: -5px;\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n@media only screen and (max-width: 430px) {\n.input-string.with-unit input[type=\"text\"][data-v-17862fed] {\n    width: 100%;\n}\n.input-string.with-unit span[data-v-17862fed] {\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n    margin-left: 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'input-string': true, 'with-unit': _vm.unit !== '' }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.stringValue),expression:"stringValue"}],attrs:{"type":"text"},domProps:{"value":(_vm.stringValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.stringValue=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.unit !== ''),expression:"unit !== ''"}]},[_vm._v(_vm._s(_vm.unit))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioBoolean_vue__ = __webpack_require__(646);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f7f0c45_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioBoolean_vue__ = __webpack_require__(1989);
function injectStyle (ssrContext) {
  __webpack_require__(1987)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f7f0c45"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioBoolean_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f7f0c45_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioBoolean_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1988);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("017b6229", content, true, {});

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\ninput[type=\"radio\"][data-v-2f7f0c45], span[data-v-2f7f0c45] {\n  display: inline-block;\n  width: auto;\n  vertical-align: middle;\n  margin-top: 0;\n}\nlabel[data-v-2f7f0c45] {\n  margin-right: 20px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Settings/controls/RadioBoolean.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,cAAc;CACf;AACD;EACE,mBAAmB;CACpB","file":"RadioBoolean.vue","sourcesContent":["\ninput[type=\"radio\"][data-v-2f7f0c45], span[data-v-2f7f0c45] {\n  display: inline-block;\n  width: auto;\n  vertical-align: middle;\n  margin-top: 0;\n}\nlabel[data-v-2f7f0c45] {\n  margin-right: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.booleanValue),expression:"booleanValue",modifiers:{"number":true}}],attrs:{"type":"radio","name":_vm.settingKey},domProps:{"value":1,"checked":_vm._q(_vm.booleanValue,_vm._n(1))},on:{"change":function($event){_vm.booleanValue=_vm._n(1)}}}),_vm._v(" "),_c('span',[_vm._v("YES")])]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.booleanValue),expression:"booleanValue",modifiers:{"number":true}}],attrs:{"type":"radio","name":_vm.settingKey},domProps:{"value":0,"checked":_vm._q(_vm.booleanValue,_vm._n(0))},on:{"change":function($event){_vm.booleanValue=_vm._n(0)}}}),_vm._v(" "),_c('span',[_vm._v("NO")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PickupTimeOffsets_vue__ = __webpack_require__(647);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d31768b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PickupTimeOffsets_vue__ = __webpack_require__(1993);
function injectStyle (ssrContext) {
  __webpack_require__(1991)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d31768b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PickupTimeOffsets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d31768b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PickupTimeOffsets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1992);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("07fd72ae", content, true, {});

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\nul[data-v-3d31768b] {\n  display: block;\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  font-size: 14px;\n}\nul .offset[data-v-3d31768b] {\n    display: block;\n    position: relative;\n    padding: 5px 0 15px;\n}\nul .offset > *[data-v-3d31768b] {\n      display: inline-block;\n      vertical-align: middle;\n}\nul .offset strong[data-v-3d31768b] {\n      text-decoration: underline;\n}\nul .offset > a.button[data-v-3d31768b] {\n      position: absolute;\n      top: 0;\n      right: 72px;\n}\nul .offset > a.button.error[data-v-3d31768b] {\n        right: 0;\n}\n.add-container[data-v-3d31768b] {\n  text-align: center;\n  border-top: 1px solid rgba(0, 0, 0, 0.15);\n  padding-top: 10px;\n}\n.field-modal[data-v-3d31768b] {\n  position: fixed;\n  z-index: 13;\n  background-color: rgba(0, 0, 0, 0.5);\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.field-modal.show[data-v-3d31768b] {\n    top: 0;\n    opacity: 1;\n}\n.field-container[data-v-3d31768b] {\n  display: table;\n  position: absolute;\n  z-index: 14;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.field-container .field-content[data-v-3d31768b] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.field-container .fields[data-v-3d31768b] {\n    background-color: #fff;\n    border-radius: 3px;\n    -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n    max-width: 500px;\n    margin: 0 auto;\n    padding: 15px;\n}\n.field-container .field-title[data-v-3d31768b] {\n    text-align: center;\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n    margin-bottom: 10px;\n    margin-top: 5px;\n}\n.field-container .cta[data-v-3d31768b] {\n    margin-top: 20px;\n}\n.select-input label[data-v-3d31768b] {\n  font-size: 11px;\n  font-weight: 700;\n}\n.select-input select[data-v-3d31768b] {\n  font-size: 14px;\n  height: 37px;\n  outline: 0;\n  padding: 7px 10px;\n  display: block;\n  border-color: rgba(0, 0, 0, 0.15);\n  background-color: #fff;\n  border-radius: 3px;\n}\n.number-input label[data-v-3d31768b] {\n  font-size: 11px;\n  font-weight: 700;\n}\n.number-input input[data-v-3d31768b] {\n  margin-top: 0;\n  font-size: 14px;\n  padding: 7px 10px;\n}\n.padding-R[data-v-3d31768b] {\n  padding-right: 7px;\n}\n.padding-L[data-v-3d31768b] {\n  padding-left: 7px;\n}\n.margin-T[data-v-3d31768b] {\n  margin-top: 15px;\n}\n@media only screen and (max-width: 430px) {\n.field-container .fields[data-v-3d31768b] {\n    margin: 0 10px;\n}\nul .offset .btn-actions[data-v-3d31768b] {\n    margin-top: 6px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Settings/controls/PickupTimeOffsets.vue"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,gBAAgB;CACjB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,oBAAoB;CACvB;AACD;MACM,sBAAsB;MACtB,uBAAuB;CAC5B;AACD;MACM,2BAA2B;CAChC;AACD;MACM,mBAAmB;MACnB,OAAO;MACP,YAAY;CACjB;AACD;QACQ,SAAS;CAChB;AACD;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;CACnB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;EACrC,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;CACd;AACD;IACI,oBAAoB;IACpB,uBAAuB;CAC1B;AACD;IACI,uBAAuB;IACvB,mBAAmB;IACnB,iDAAiD;YACzC,yCAAyC;IACjD,iBAAiB;IACjB,eAAe;IACf,cAAc;CACjB;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;CACnB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,gBAAgB;EAChB,iBAAiB;CAClB;AACD;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;CACpB;AACD;EACE,gBAAgB;EAChB,iBAAiB;CAClB;AACD;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,iBAAiB;CAClB;AACD;AACA;IACI,eAAe;CAClB;AACD;IACI,gBAAgB;CACnB;CACA","file":"PickupTimeOffsets.vue","sourcesContent":["\nul[data-v-3d31768b] {\n  display: block;\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  font-size: 14px;\n}\nul .offset[data-v-3d31768b] {\n    display: block;\n    position: relative;\n    padding: 5px 0 15px;\n}\nul .offset > *[data-v-3d31768b] {\n      display: inline-block;\n      vertical-align: middle;\n}\nul .offset strong[data-v-3d31768b] {\n      text-decoration: underline;\n}\nul .offset > a.button[data-v-3d31768b] {\n      position: absolute;\n      top: 0;\n      right: 72px;\n}\nul .offset > a.button.error[data-v-3d31768b] {\n        right: 0;\n}\n.add-container[data-v-3d31768b] {\n  text-align: center;\n  border-top: 1px solid rgba(0, 0, 0, 0.15);\n  padding-top: 10px;\n}\n.field-modal[data-v-3d31768b] {\n  position: fixed;\n  z-index: 13;\n  background-color: rgba(0, 0, 0, 0.5);\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.field-modal.show[data-v-3d31768b] {\n    top: 0;\n    opacity: 1;\n}\n.field-container[data-v-3d31768b] {\n  display: table;\n  position: absolute;\n  z-index: 14;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.field-container .field-content[data-v-3d31768b] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.field-container .fields[data-v-3d31768b] {\n    background-color: #fff;\n    border-radius: 3px;\n    -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n    max-width: 500px;\n    margin: 0 auto;\n    padding: 15px;\n}\n.field-container .field-title[data-v-3d31768b] {\n    text-align: center;\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n    margin-bottom: 10px;\n    margin-top: 5px;\n}\n.field-container .cta[data-v-3d31768b] {\n    margin-top: 20px;\n}\n.select-input label[data-v-3d31768b] {\n  font-size: 11px;\n  font-weight: 700;\n}\n.select-input select[data-v-3d31768b] {\n  font-size: 14px;\n  height: 37px;\n  outline: 0;\n  padding: 7px 10px;\n  display: block;\n  border-color: rgba(0, 0, 0, 0.15);\n  background-color: #fff;\n  border-radius: 3px;\n}\n.number-input label[data-v-3d31768b] {\n  font-size: 11px;\n  font-weight: 700;\n}\n.number-input input[data-v-3d31768b] {\n  margin-top: 0;\n  font-size: 14px;\n  padding: 7px 10px;\n}\n.padding-R[data-v-3d31768b] {\n  padding-right: 7px;\n}\n.padding-L[data-v-3d31768b] {\n  padding-left: 7px;\n}\n.margin-T[data-v-3d31768b] {\n  margin-top: 15px;\n}\n@media only screen and (max-width: 430px) {\n.field-container .fields[data-v-3d31768b] {\n    margin: 0 10px;\n}\nul .offset .btn-actions[data-v-3d31768b] {\n    margin-top: 6px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.items.length > 0)?_c('ul',_vm._l((_vm.items),function(item,index){return _c('li',{staticClass:"offset"},[_c('i',{staticClass:"fa fa-caret-right fa-fw"}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(item.dayString))]),_vm._v(" "),_c('span',[_vm._v("from")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(item.timeFromString))]),_vm._v(" "),_c('span',[_vm._v("to")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(item.timeToString))]),_vm._v(" "),_c('span',[_vm._v(":")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(item.offset)+" mins")]),_vm._v(" "),_c('span',{staticClass:"btn-actions"},[_c('a',{staticClass:"button cta xsmall",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.edit(index)}}},[_vm._v("EDIT")]),_vm._v(" "),_c('a',{staticClass:"button cta xsmall error",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.remove(index)}}},[_vm._v("DELETE")])])])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"add-container"},[_c('a',{staticClass:"button cta xsmall success",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.edit(-1)}}},[_vm._v("ADD NEW ITEM")])]),_vm._v(" "),_c('div',{class:{ 'field-modal': true, show: _vm.showFieldModal },on:{"click":function($event){_vm.showFieldModal = false}}},[_c('div',{staticClass:"field-container"},[_c('div',{staticClass:"field-content"},[_c('div',{staticClass:"fields",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"field-title"},[_vm._v("SET PICKUP TIME OFFSET")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"select-input"},[_c('label',[_vm._v("DAY OF WEEK")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.fieldItem.dayOfWeek),expression:"fieldItem.dayOfWeek",modifiers:{"number":true}}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.$set(_vm.fieldItem, "dayOfWeek", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Sunday")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Monday")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Tuesday")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Wednesday")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Thursday")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Friday")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("Saturday")])])])])]),_vm._v(" "),_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('div',{staticClass:"time-input select-input"},[_c('label',[_vm._v("TIME FROM")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldItem.timeFromHH),expression:"fieldItem.timeFromHH"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.fieldItem, "timeFromHH", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((24),function(i){return _c('option',{domProps:{"value":(i - 1) < 10 ? ('0' + (i - 1)) : ('' + i - 1)}},[_vm._v("\n                        "+_vm._s((i - 1) < 10 ? ('0' + (i - 1)) : ('' + i - 1))+"\n                      ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldItem.timeFromMM),expression:"fieldItem.timeFromMM"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.fieldItem, "timeFromMM", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((60),function(i){return _c('option',{domProps:{"value":(i - 1) < 10 ? ('0' + (i - 1)) : ('' + i - 1)}},[_vm._v("\n                        "+_vm._s((i - 1) < 10 ? ('0' + (i - 1)) : ('' + i - 1))+"\n                      ")])}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('div',{staticClass:"time-input select-input"},[_c('label',[_vm._v("TIME TO")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldItem.timeToHH),expression:"fieldItem.timeToHH"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.fieldItem, "timeToHH", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((24),function(i){return _c('option',{domProps:{"value":(i - 1) < 10 ? ('0' + (i - 1)) : ('' + i - 1)}},[_vm._v("\n                        "+_vm._s((i - 1) < 10 ? ('0' + (i - 1)) : ('' + i - 1))+"\n                      ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldItem.timeToMM),expression:"fieldItem.timeToMM"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.fieldItem, "timeToMM", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((60),function(i){return _c('option',{domProps:{"value":(i - 1) < 10 ? ('0' + (i - 1)) : ('' + i - 1)}},[_vm._v("\n                        "+_vm._s((i - 1) < 10 ? ('0' + (i - 1)) : ('' + i - 1))+"\n                      ")])}),0)])])])])]),_vm._v(" "),_c('div',{staticClass:"row margin-T"},[_c('div',{staticClass:"small-12 columns"},[_c('div',{staticClass:"number-input"},[_c('label',[_vm._v("OFFSET (IN MINUTES)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.fieldItem.offset),expression:"fieldItem.offset",modifiers:{"number":true}}],attrs:{"type":"number"},domProps:{"value":(_vm.fieldItem.offset)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fieldItem, "offset", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])])]),_vm._v(" "),_c('a',{staticClass:"button cta xsmall block success",attrs:{"href":"javascript:;"},on:{"click":_vm.save}},[_vm._v("SAVE PICKUP TIME OFFSET")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.groupTitle))]),_vm._v(" "),_c('div',{staticClass:"configuration"},_vm._l((_vm.itemKeys),function(key,n){return _c('div',{key:n,staticClass:"config-item"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.getConfig(key).label))]),_vm._v(" "),_c('i',[_vm._v("-- "+_vm._s(key))])]),_vm._v(" "),(_vm.getConfig(key).type === 'dropdown')?_c('dropdown',{attrs:{"values":_vm.getConfig(key).values,"settingKey":key}}):_vm._e(),_vm._v(" "),(_vm.getConfig(key).type === 'integer')?_c('input-integer',{attrs:{"unit":_vm.getConfig(key).unit,"settingKey":key,"extra":_vm.getConfig(key).extra}}):_vm._e(),_vm._v(" "),(_vm.getConfig(key).type === 'string')?_c('input-string',{attrs:{"unit":_vm.getConfig(key).unit,"settingKey":key}}):_vm._e(),_vm._v(" "),(_vm.getConfig(key).type === 'boolean')?_c('radio-boolean',{attrs:{"settingKey":key}}):_vm._e(),_vm._v(" "),(_vm.getConfig(key).type === 'pickuptime-offsets')?_c('pickup-time-offsets',{attrs:{"settingKey":key}}):_vm._e(),_vm._v(" "),(_vm.getConfig(key).type === 'discountField')?_c('div',{staticClass:"d-flex dc-field align-start"},[(_vm.getConfig(key).fields.type)?_c('dropdown',{staticClass:"dc-type",attrs:{"values":_vm.getConfig(key).fields.type.values,"settingKey":_vm.getConfig(key).fields.type.id}}):_vm._e(),_vm._v(" "),(_vm.getConfig(key).fields.amount)?_c('input-integer',{attrs:{"settingKey":_vm.getConfig(key).fields.amount.id,"unit":"","removeMT":"true"}}):_vm._e()],1):_vm._e()],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings"},[_c('div',{staticClass:"header"},[_vm._v("SETTINGS")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-6 columns padding-R"},_vm._l((_vm.getGroup(0)),function(group,index){return _c('settings-group',{key:'col1_' + index,attrs:{"column":0,"groupKey":group.key,"groupTitle":group.object.title,"itemKeys":_vm.getKeys(group.object.items)}})}),1),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},_vm._l((_vm.getGroup(1)),function(group,index){return _c('settings-group',{key:'col2_' + index,attrs:{"column":1,"groupKey":group.key,"groupTitle":group.object.title,"itemKeys":_vm.getKeys(group.object.items)}})}),1)]),_vm._v(" "),_c('div',{staticClass:"controls"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.success),expression:"!success"}],class:{ 'button cta success small': true, disabled: _vm.saving },attrs:{"href":"javascript:;"},on:{"click":_vm.save}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.saving),expression:"saving"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.saving),expression:"!saving"}]},[_vm._v("SAVE CHANGES")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.success),expression:"success"}],staticClass:"success-message"},[_c('i',{staticClass:"fa fa-check-circle fa-2x"}),_vm._v(" "),_c('span',[_vm._v("SETTINGS SUCCESSFULLY UPDATED!")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(648);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f920109_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2025);
function injectStyle (ssrContext) {
  __webpack_require__(1997)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f920109"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f920109_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1998);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("152cd3d7", content, true, {});

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.coverage[data-v-3f920109] {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n}\n.map-container[data-v-3f920109] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 60%;\n}\n.sector-list[data-v-3f920109] {\n  position: absolute;\n  top: 0;\n  left: 60%;\n  height: 100%;\n  width: calc(100% - (60%));\n  background-color: #F4F8F9;\n  -webkit-box-shadow: -2px 0 6px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 6px rgba(0, 0, 0, 0.2);\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Coverage/index.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,WAAW;CACZ;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,UAAU;EACV,aAAa;EACb,0BAA0B;EAC1B,0BAA0B;EAC1B,kDAAkD;UAC1C,0CAA0C;CACnD","file":"index.vue","sourcesContent":["\n.coverage[data-v-3f920109] {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n}\n.map-container[data-v-3f920109] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 60%;\n}\n.sector-list[data-v-3f920109] {\n  position: absolute;\n  top: 0;\n  left: 60%;\n  height: 100%;\n  width: calc(100% - (60%));\n  background-color: #F4F8F9;\n  -webkit-box-shadow: -2px 0 6px rgba(0, 0, 0, 0.2);\n          box-shadow: -2px 0 6px rgba(0, 0, 0, 0.2);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__(649);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29097dd0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__(2002);
function injectStyle (ssrContext) {
  __webpack_require__(2000)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29097dd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29097dd0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2001);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("bdf25c50", content, true, {});

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.map-container[data-v-29097dd0] {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n.coverage-map[data-v-29097dd0] {\n  width: 100%;\n  height: 100%;\n}\n.driver-info[data-v-29097dd0] {\n  font-family: 'Open Sans', sans-serif;\n  padding: 5px 0 0 5px;\n}\n.driver-info .header[data-v-29097dd0] {\n    position: relative;\n    min-height: 50px;\n    padding-left: 60px;\n    padding-top: 0px;\n}\n.driver-info .photo[data-v-29097dd0] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 50px;\n    height: 50px;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    border-radius: 50px;\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.driver-info .name[data-v-29097dd0] {\n    font-size: 14px;\n    line-height: 14px;\n    font-weight: 700;\n}\n.driver-info .email[data-v-29097dd0] {\n    font-size: 12px;\n    line-height: 12px;\n    margin-top: 5px;\n}\n.driver-info .vehicle[data-v-29097dd0] {\n    margin-top: 10px;\n    position: relative;\n    min-height: 50px;\n    padding-left: 60px;\n    padding-top: 10px;\n}\n.driver-info .shift-info[data-v-29097dd0] {\n    font-size: 14px;\n    line-height: 14px;\n    margin-top: 15px;\n    text-align: center;\n}\n.driver-info .shift-info > *[data-v-29097dd0] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.driver-info .shift-info i[data-v-29097dd0] {\n      color: #26D97A;\n}\n.driver-info .shift-info .shift-value[data-v-29097dd0] {\n      font-weight: 700;\n      color: #0D79F2;\n}\n.driver-info .rsvp-info[data-v-29097dd0] {\n    font-size: 14px;\n    line-height: 16px;\n    margin-top: 15px;\n    text-align: center;\n}\n.driver-info .rsvp-info .highlight[data-v-29097dd0], .driver-info .rsvp-info a[data-v-29097dd0] {\n      font-weight: 700;\n      color: #0D79F2;\n}\n.driver-info .controls[data-v-29097dd0] {\n    margin-top: 15px;\n}\n.driver-info .controls .padding-R[data-v-29097dd0] {\n      padding-right: 3px;\n}\n.driver-info .controls .padding-L[data-v-29097dd0] {\n      padding-left: 3px;\n}\n.driver-info .controls .button[data-v-29097dd0] {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n}\n.driver-info .is-home[data-v-29097dd0] {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    width: 30px;\n    height: 30px;\n    border-radius: 30px;\n    background-color: #26D97A;\n    text-align: center;\n    line-height: 30px;\n    color: #fff;\n}\n.no-drivers[data-v-29097dd0] {\n  position: absolute;\n  top: 12px;\n  right: -400px;\n  background-color: #fff;\n  text-align: center;\n  width: 300px;\n  -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n  border-radius: 3px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  font-size: 14px;\n  padding: 15px;\n}\n.no-drivers.show[data-v-29097dd0] {\n    right: 15px;\n}\n.no-drivers .message[data-v-29097dd0] {\n    margin-top: 10px;\n}\n.no-drivers .message > *[data-v-29097dd0] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.no-drivers .message .highlight[data-v-29097dd0] {\n      font-weight: 700;\n}\n.untracked-drivers[data-v-29097dd0] {\n  position: absolute;\n  top: 12px;\n  right: -400px;\n  background-color: #fff;\n  -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n  border-radius: 3px;\n  width: 350px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  max-height: 90%;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.untracked-drivers.show[data-v-29097dd0] {\n    right: 15px;\n}\n.untracked-drivers .title[data-v-29097dd0] {\n    text-align: center;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 12px;\n    padding: 10px 0 7px;\n    color: #555;\n}\n.untracked-drivers .driver[data-v-29097dd0] {\n    padding: 10px 10px 5px;\n    border-top: 1px solid rgba(0, 0, 0, 0.2);\n    position: relative;\n}\n.untracked-drivers .is-home[data-v-29097dd0] {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    width: 30px;\n    height: 30px;\n    border-radius: 30px;\n    background-color: #26D97A;\n    text-align: center;\n    line-height: 30px;\n    color: #fff;\n}\n.untracked-drivers .header[data-v-29097dd0] {\n    position: relative;\n    min-height: 50px;\n    padding-left: 60px;\n}\n.untracked-drivers .header .photo[data-v-29097dd0] {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 50px;\n      height: 50px;\n      background-position: 50% 50%;\n      background-repeat: no-repeat;\n      background-size: cover;\n      border-radius: 50px;\n      -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n      border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.untracked-drivers .header .name[data-v-29097dd0] {\n      font-size: 14px;\n      line-height: 14px;\n      font-weight: 700;\n}\n.untracked-drivers .header .email[data-v-29097dd0] {\n      font-size: 12px;\n      line-height: 12px;\n      margin-top: 5px;\n}\n.untracked-drivers .vehicle[data-v-29097dd0] {\n    position: relative;\n    padding-left: 60px;\n    padding-top: 8px;\n    margin-top: 5px;\n    height: 50px;\n}\n.untracked-drivers .vehicle .photo[data-v-29097dd0] {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 50px;\n      height: 50px;\n      background-position: 50% 50%;\n      background-repeat: no-repeat;\n      background-size: cover;\n      border-radius: 50px;\n      -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n      border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.untracked-drivers .vehicle .name[data-v-29097dd0] {\n      font-size: 14px;\n      font-weight: 700;\n      line-height: 14px;\n}\n.untracked-drivers .vehicle .plate-number[data-v-29097dd0] {\n      font-size: 14px;\n      line-height: 14px;\n      margin-top: 5px;\n}\n.untracked-drivers .shift-info[data-v-29097dd0] {\n    font-size: 14px;\n    line-height: 14px;\n    margin-top: 15px;\n    text-align: center;\n}\n.untracked-drivers .shift-info > *[data-v-29097dd0] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.untracked-drivers .shift-info i[data-v-29097dd0] {\n      color: #26D97A;\n}\n.untracked-drivers .shift-info .shift-value[data-v-29097dd0] {\n      font-weight: 700;\n      color: #0D79F2;\n}\n.untracked-drivers .rsvp-info[data-v-29097dd0] {\n    font-size: 14px;\n    line-height: 16px;\n    margin-top: 15px;\n    text-align: center;\n}\n.untracked-drivers .rsvp-info .highlight[data-v-29097dd0], .untracked-drivers .rsvp-info a[data-v-29097dd0] {\n      font-weight: 700;\n      color: #0D79F2;\n}\n.untracked-drivers .controls[data-v-29097dd0] {\n    margin-top: 15px;\n}\n.untracked-drivers .controls .padding-R[data-v-29097dd0] {\n      padding-right: 3px;\n}\n.untracked-drivers .controls .padding-L[data-v-29097dd0] {\n      padding-left: 3px;\n}\n.untracked-drivers .controls .button[data-v-29097dd0] {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n}\n.point-info[data-v-29097dd0] {\n  padding: 0 0 5px 5px;\n  background-color: #fff;\n  font-family: 'Open Sans', sans-serif;\n}\n.point-info label[data-v-29097dd0] {\n    font-weight: 700;\n    font-size: 10px;\n    line-height: 10px;\n    color: #0D79F2;\n}\n.point-info .value[data-v-29097dd0] {\n    font-size: 14px;\n    font-weight: 700;\n}\n.point-info .label-value[data-v-29097dd0]:not(:first-child) {\n    margin-top: 10px;\n}\n.submission-modal[data-v-29097dd0] {\n  display: table;\n  position: fixed;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 12;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.submission-modal.show[data-v-29097dd0] {\n    top: 0;\n    opacity: 1;\n}\n.submission-modal .modal-container[data-v-29097dd0] {\n    display: table-cell;\n    vertical-align: middle;\n    text-align: center;\n}\n.submission-modal .modal-content[data-v-29097dd0] {\n    background-color: #fff;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    width: 350px;\n    margin: 0 auto;\n    padding: 20px 15px;\n    border-radius: 5px;\n}\n.submission-modal .loader .message[data-v-29097dd0] {\n    font-size: 16px;\n    line-height: 16px;\n    font-weight: 700;\n    margin-top: 10px;\n}\n.submission-modal .success-icon[data-v-29097dd0] {\n    color: #26D97A;\n}\n.submission-modal .error-icon[data-v-29097dd0] {\n    color: #F25E0D;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Coverage/Map.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;CACpB;AACD;EACE,YAAY;EACZ,aAAa;CACd;AACD;EACE,qCAAqC;EACrC,qBAAqB;CACtB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;CACpB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,6BAA6B;IAC7B,uBAAuB;IACvB,oBAAoB;IACpB,iDAAiD;YACzC,yCAAyC;IACjD,qCAAqC;CACxC;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;CACpB;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;CACnB;AACD;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;CACrB;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,uBAAuB;CAC5B;AACD;MACM,eAAe;CACpB;AACD;MACM,iBAAiB;MACjB,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;CACtB;AACD;MACM,iBAAiB;MACjB,eAAe;CACpB;AACD;IACI,iBAAiB;CACpB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,kBAAkB;CACvB;AACD;MACM,iBAAiB;MACjB,wBAAwB;MACxB,oBAAoB;CACzB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;CACf;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;CACf;AACD;IACI,YAAY;CACf;AACD;IACI,iBAAiB;CACpB;AACD;MACM,sBAAsB;MACtB,uBAAuB;CAC5B;AACD;MACM,iBAAiB;CACtB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,YAAY;CACf;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;CACf;AACD;IACI,uBAAuB;IACvB,yCAAyC;IACzC,mBAAmB;CACtB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;CACf;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;CACtB;AACD;MACM,mBAAmB;MACnB,OAAO;MACP,QAAQ;MACR,YAAY;MACZ,aAAa;MACb,6BAA6B;MAC7B,6BAA6B;MAC7B,uBAAuB;MACvB,oBAAoB;MACpB,iDAAiD;cACzC,yCAAyC;MACjD,qCAAqC;CAC1C;AACD;MACM,gBAAgB;MAChB,kBAAkB;MAClB,iBAAiB;CACtB;AACD;MACM,gBAAgB;MAChB,kBAAkB;MAClB,gBAAgB;CACrB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;CAChB;AACD;MACM,mBAAmB;MACnB,OAAO;MACP,QAAQ;MACR,YAAY;MACZ,aAAa;MACb,6BAA6B;MAC7B,6BAA6B;MAC7B,uBAAuB;MACvB,oBAAoB;MACpB,iDAAiD;cACzC,yCAAyC;MACjD,qCAAqC;CAC1C;AACD;MACM,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;CACvB;AACD;MACM,gBAAgB;MAChB,kBAAkB;MAClB,gBAAgB;CACrB;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,uBAAuB;CAC5B;AACD;MACM,eAAe;CACpB;AACD;MACM,iBAAiB;MACjB,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;CACtB;AACD;MACM,iBAAiB;MACjB,eAAe;CACpB;AACD;IACI,iBAAiB;CACpB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,kBAAkB;CACvB;AACD;MACM,iBAAiB;MACjB,wBAAwB;MACxB,oBAAoB;CACzB;AACD;EACE,qBAAqB;EACrB,uBAAuB;EACvB,qCAAqC;CACtC;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;CAClB;AACD;IACI,gBAAgB;IAChB,iBAAiB;CACpB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;IACI,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;CACtB;AACD;IACI,uBAAuB;IACvB,iDAAiD;YACzC,yCAAyC;IACjD,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,mBAAmB;CACtB;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;CACpB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB","file":"Map.vue","sourcesContent":["\n.map-container[data-v-29097dd0] {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n.coverage-map[data-v-29097dd0] {\n  width: 100%;\n  height: 100%;\n}\n.driver-info[data-v-29097dd0] {\n  font-family: 'Open Sans', sans-serif;\n  padding: 5px 0 0 5px;\n}\n.driver-info .header[data-v-29097dd0] {\n    position: relative;\n    min-height: 50px;\n    padding-left: 60px;\n    padding-top: 0px;\n}\n.driver-info .photo[data-v-29097dd0] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 50px;\n    height: 50px;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    border-radius: 50px;\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.driver-info .name[data-v-29097dd0] {\n    font-size: 14px;\n    line-height: 14px;\n    font-weight: 700;\n}\n.driver-info .email[data-v-29097dd0] {\n    font-size: 12px;\n    line-height: 12px;\n    margin-top: 5px;\n}\n.driver-info .vehicle[data-v-29097dd0] {\n    margin-top: 10px;\n    position: relative;\n    min-height: 50px;\n    padding-left: 60px;\n    padding-top: 10px;\n}\n.driver-info .shift-info[data-v-29097dd0] {\n    font-size: 14px;\n    line-height: 14px;\n    margin-top: 15px;\n    text-align: center;\n}\n.driver-info .shift-info > *[data-v-29097dd0] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.driver-info .shift-info i[data-v-29097dd0] {\n      color: #26D97A;\n}\n.driver-info .shift-info .shift-value[data-v-29097dd0] {\n      font-weight: 700;\n      color: #0D79F2;\n}\n.driver-info .rsvp-info[data-v-29097dd0] {\n    font-size: 14px;\n    line-height: 16px;\n    margin-top: 15px;\n    text-align: center;\n}\n.driver-info .rsvp-info .highlight[data-v-29097dd0], .driver-info .rsvp-info a[data-v-29097dd0] {\n      font-weight: 700;\n      color: #0D79F2;\n}\n.driver-info .controls[data-v-29097dd0] {\n    margin-top: 15px;\n}\n.driver-info .controls .padding-R[data-v-29097dd0] {\n      padding-right: 3px;\n}\n.driver-info .controls .padding-L[data-v-29097dd0] {\n      padding-left: 3px;\n}\n.driver-info .controls .button[data-v-29097dd0] {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n}\n.driver-info .is-home[data-v-29097dd0] {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    width: 30px;\n    height: 30px;\n    border-radius: 30px;\n    background-color: #26D97A;\n    text-align: center;\n    line-height: 30px;\n    color: #fff;\n}\n.no-drivers[data-v-29097dd0] {\n  position: absolute;\n  top: 12px;\n  right: -400px;\n  background-color: #fff;\n  text-align: center;\n  width: 300px;\n  -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n  border-radius: 3px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  font-size: 14px;\n  padding: 15px;\n}\n.no-drivers.show[data-v-29097dd0] {\n    right: 15px;\n}\n.no-drivers .message[data-v-29097dd0] {\n    margin-top: 10px;\n}\n.no-drivers .message > *[data-v-29097dd0] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.no-drivers .message .highlight[data-v-29097dd0] {\n      font-weight: 700;\n}\n.untracked-drivers[data-v-29097dd0] {\n  position: absolute;\n  top: 12px;\n  right: -400px;\n  background-color: #fff;\n  -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n  border-radius: 3px;\n  width: 350px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  max-height: 90%;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.untracked-drivers.show[data-v-29097dd0] {\n    right: 15px;\n}\n.untracked-drivers .title[data-v-29097dd0] {\n    text-align: center;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 12px;\n    padding: 10px 0 7px;\n    color: #555;\n}\n.untracked-drivers .driver[data-v-29097dd0] {\n    padding: 10px 10px 5px;\n    border-top: 1px solid rgba(0, 0, 0, 0.2);\n    position: relative;\n}\n.untracked-drivers .is-home[data-v-29097dd0] {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    width: 30px;\n    height: 30px;\n    border-radius: 30px;\n    background-color: #26D97A;\n    text-align: center;\n    line-height: 30px;\n    color: #fff;\n}\n.untracked-drivers .header[data-v-29097dd0] {\n    position: relative;\n    min-height: 50px;\n    padding-left: 60px;\n}\n.untracked-drivers .header .photo[data-v-29097dd0] {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 50px;\n      height: 50px;\n      background-position: 50% 50%;\n      background-repeat: no-repeat;\n      background-size: cover;\n      border-radius: 50px;\n      -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n      border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.untracked-drivers .header .name[data-v-29097dd0] {\n      font-size: 14px;\n      line-height: 14px;\n      font-weight: 700;\n}\n.untracked-drivers .header .email[data-v-29097dd0] {\n      font-size: 12px;\n      line-height: 12px;\n      margin-top: 5px;\n}\n.untracked-drivers .vehicle[data-v-29097dd0] {\n    position: relative;\n    padding-left: 60px;\n    padding-top: 8px;\n    margin-top: 5px;\n    height: 50px;\n}\n.untracked-drivers .vehicle .photo[data-v-29097dd0] {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 50px;\n      height: 50px;\n      background-position: 50% 50%;\n      background-repeat: no-repeat;\n      background-size: cover;\n      border-radius: 50px;\n      -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n      border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.untracked-drivers .vehicle .name[data-v-29097dd0] {\n      font-size: 14px;\n      font-weight: 700;\n      line-height: 14px;\n}\n.untracked-drivers .vehicle .plate-number[data-v-29097dd0] {\n      font-size: 14px;\n      line-height: 14px;\n      margin-top: 5px;\n}\n.untracked-drivers .shift-info[data-v-29097dd0] {\n    font-size: 14px;\n    line-height: 14px;\n    margin-top: 15px;\n    text-align: center;\n}\n.untracked-drivers .shift-info > *[data-v-29097dd0] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.untracked-drivers .shift-info i[data-v-29097dd0] {\n      color: #26D97A;\n}\n.untracked-drivers .shift-info .shift-value[data-v-29097dd0] {\n      font-weight: 700;\n      color: #0D79F2;\n}\n.untracked-drivers .rsvp-info[data-v-29097dd0] {\n    font-size: 14px;\n    line-height: 16px;\n    margin-top: 15px;\n    text-align: center;\n}\n.untracked-drivers .rsvp-info .highlight[data-v-29097dd0], .untracked-drivers .rsvp-info a[data-v-29097dd0] {\n      font-weight: 700;\n      color: #0D79F2;\n}\n.untracked-drivers .controls[data-v-29097dd0] {\n    margin-top: 15px;\n}\n.untracked-drivers .controls .padding-R[data-v-29097dd0] {\n      padding-right: 3px;\n}\n.untracked-drivers .controls .padding-L[data-v-29097dd0] {\n      padding-left: 3px;\n}\n.untracked-drivers .controls .button[data-v-29097dd0] {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n}\n.point-info[data-v-29097dd0] {\n  padding: 0 0 5px 5px;\n  background-color: #fff;\n  font-family: 'Open Sans', sans-serif;\n}\n.point-info label[data-v-29097dd0] {\n    font-weight: 700;\n    font-size: 10px;\n    line-height: 10px;\n    color: #0D79F2;\n}\n.point-info .value[data-v-29097dd0] {\n    font-size: 14px;\n    font-weight: 700;\n}\n.point-info .label-value[data-v-29097dd0]:not(:first-child) {\n    margin-top: 10px;\n}\n.submission-modal[data-v-29097dd0] {\n  display: table;\n  position: fixed;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 12;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.submission-modal.show[data-v-29097dd0] {\n    top: 0;\n    opacity: 1;\n}\n.submission-modal .modal-container[data-v-29097dd0] {\n    display: table-cell;\n    vertical-align: middle;\n    text-align: center;\n}\n.submission-modal .modal-content[data-v-29097dd0] {\n    background-color: #fff;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    width: 350px;\n    margin: 0 auto;\n    padding: 20px 15px;\n    border-radius: 5px;\n}\n.submission-modal .loader .message[data-v-29097dd0] {\n    font-size: 16px;\n    line-height: 16px;\n    font-weight: 700;\n    margin-top: 10px;\n}\n.submission-modal .success-icon[data-v-29097dd0] {\n    color: #26D97A;\n}\n.submission-modal .error-icon[data-v-29097dd0] {\n    color: #F25E0D;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-container"},[_c('gmap-map',{ref:"CoverageMap",staticClass:"coverage-map",attrs:{"center":_vm.center,"zoom":13,"options":_vm.mapOptions,"map-type-id":"roadmap"}},[_vm._l((_vm.sectorItems),function(sector,index){return (_vm.showPolygons)?_c('gmap-polygon',{key:'P' + sector.ID,attrs:{"paths":sector.polygon,"options":{
        strokeColor: sector.overlayColor,
        strokeOpacity: 1,
        strokeWeight: sector.polygonOptions.strokeWeight,
        fillColor: sector.overlayColor,
        fillOpacity: sector.polygonOptions.fillOpacity,
        zIndex: sector.polygonOptions.zIndex
      }},on:{"click":function($event){return _vm.centerSector(sector, index)}}}):_vm._e()}),_vm._v(" "),_vm._l((_vm.sectorItems),function(sector,index){return (_vm.showPolygons)?_c('gmap-marker',{key:'M' + sector.ID,attrs:{"position":_vm.getCenter(sector),"icon":_vm.map.labelBackground,"label":{
        text: sector.name,
        color: '#333333',
        fontSize: '14px',
        fontFamily: 'Open Sans',
        fontWeight: '700'
      },"zIndex":2},on:{"click":function($event){return _vm.centerSector(sector, index)}}}):_vm._e()}),_vm._v(" "),(_vm.rsvp !== null && !_vm.rsvp.isPackage)?_c('gmap-marker',{key:'RSVP_PU',attrs:{"icon":_vm.map.poiPin,"position":{ lat: _vm.rsvp.pickupLocation.lat, lng: _vm.rsvp.pickupLocation.lng },"zIndex":2},on:{"click":function($event){_vm.infoWindows.pickup = !_vm.infoWindows.pickup}}}):_vm._e(),_vm._v(" "),(_vm.rsvp !== null && !_vm.rsvp.isPackage && _vm.infoWindows.pickup)?_c('gmap-info-window',{key:'RSVP_PUINFO',attrs:{"position":{ lat: _vm.rsvp.pickupLocation.lat, lng: _vm.rsvp.pickupLocation.lng },"zIndex":3},on:{"closeclick":function($event){_vm.infoWindows.pickup = false}}},[_c('div',{staticClass:"point-info"},[(_vm.rsvpInfo.pickupTime !== null)?_c('div',{staticClass:"label-value"},[_c('label',[_vm._v("PICKUP TIME")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.rsvpInfo.pickupTime.format('MM/DD/YYYY hh:mmA')))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.rsvp !== null && !_vm.rsvp.isPackage)?_c('gmap-marker',{key:'RSVP_DO',attrs:{"icon":_vm.map.poiPin,"position":{ lat: _vm.rsvp.dropoffLocation.lat, lng: _vm.rsvp.dropoffLocation.lng },"zIndex":2},on:{"click":function($event){_vm.infoWindows.dropoff = !_vm.infoWindows.dropoff}}}):_vm._e(),_vm._v(" "),(_vm.rsvp !== null && !_vm.rsvp.isPackage && _vm.infoWindows.dropoff)?_c('gmap-info-window',{key:'RSVP_DOINFO',attrs:{"position":{ lat: _vm.rsvp.dropoffLocation.lat, lng: _vm.rsvp.dropoffLocation.lng },"zIndex":3},on:{"closeclick":function($event){_vm.infoWindows.dropoff = false}}},[_c('div',{staticClass:"point-info"},[(_vm.rsvpInfo.dropoffTime !== null)?_c('div',{staticClass:"label-value"},[_c('label',[_vm._v("ESTIMATED DROP-OFF TIME")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.rsvpInfo.dropoffTime.format('MM/DD/YYYY hh:mmA')))])]):_vm._e(),_vm._v(" "),(_vm.rsvpInfo.distanceInMiles !== null)?_c('div',{staticClass:"label-value"},[_c('label',[_vm._v("TRAVEL DISTANCE")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.rsvpInfo.distanceInMiles.toFixed(2))+" miles")])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.rsvp !== null && _vm.rsvp.isPackage)?_c('div',[_vm._l((_vm.rsvp.stops),function(stop,index){return _c('gmap-marker',{key:'PACKAGE_POI' + index,attrs:{"icon":_vm.map.poiPin,"position":{ lat: stop.lat, lng: stop.lng },"zIndex":2},on:{"click":function($event){return _vm.toggleStopsInfo(index)}}})}),_vm._v(" "),_vm._l((_vm.rsvp.stops),function(stop,index){return (_vm.stopsInfo[index])?_c('gmap-info-window',{key:'PACKAGE_INFO' + index,attrs:{"position":{ lat: stop.lat, lng: stop.lng },"zIndex":3},on:{"closeclick":function($event){return _vm.toggleStopsInfo(index)}}},[_c('div',{staticClass:"point-info"},[_c('div',{staticClass:"label-value"},[_c('label',[_vm._v("RESERVATION ID")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":'/#/reservation/' + stop.reservationID,"target":"_blank"}},[_vm._v(_vm._s(stop.reservationID))])])]),_vm._v(" "),_c('div',{staticClass:"label-value"},[(stop.isPickup)?_c('label',[_vm._v("ESTIMATED PICK-UP TIME")]):_c('label',[_vm._v("ESTIMATED DROP-OFF TIME")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(stop.etaTime.format('MM/DD/YYYY hh:mmA')))])])])]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.rsvp !== null)?_c('gmap-polyline',{attrs:{"path":_vm.path.base,"options":{strokeColor:'#999999'},"zIndex":1}}):_vm._e(),_vm._v(" "),(_vm.rsvp !== null)?_c('gmap-polyline',{attrs:{"path":_vm.path.animated,"options":{strokeColor:'#333333'},"zIndex":2}}):_vm._e(),_vm._v(" "),_vm._l((_vm.drivers.sector),function(driver,index){return (driver.location !== null)?_c('gmap-marker',{key:'DS_' + driver.driverId,attrs:{"icon":driver.location.pin,"position":{ lat: driver.location.lat, lng: driver.location.lng },"zIndex":4},on:{"click":function($event){return _vm.toggleDriverInfo(index)}}}):_vm._e()}),_vm._v(" "),_vm._l((_vm.drivers.sector),function(driver,index){return (driver.location !== null && driver.location.showInfo)?_c('gmap-info-window',{key:'DI_' + driver.driverId,attrs:{"position":{ lat: driver.location.lat, lng: driver.location.lng },"zIndex":5},on:{"closeclick":function($event){return _vm.closeDriverInfo(index)}}},[_c('div',{staticClass:"driver-info"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"photo",style:({ 'background-image': 'url(\'' + driver.photo + '\')'})}),_vm._v(" "),_c('div',{staticClass:"name"},[_c('a',{attrs:{"href":'/#/provider/' + driver.driverId,"target":"_blank"}},[_vm._v(_vm._s(driver.name))])]),_vm._v(" "),_c('div',{staticClass:"email"},[_c('a',{attrs:{"href":'mailto:' + driver.email}},[_vm._v(_vm._s(driver.email))])]),_vm._v(" "),_c('div',{staticClass:"email"},[_c('a',{attrs:{"href":"javscript:;"},on:{"click":function($event){return _vm.callDriver(driver)}}},[_vm._v(_vm._s(driver.phone))])])]),_vm._v(" "),_c('div',{staticClass:"vehicle"},[_c('div',{staticClass:"photo",style:({ 'background-image': 'url(\'' + driver.vehicle.photoUrl + '\')'})}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(driver.vehicle.manufacturer)+" "+_vm._s(driver.vehicle.model))]),_vm._v(" "),_c('div',{staticClass:"plate-number"},[_vm._v(_vm._s(driver.vehicle.licensePlate))])]),_vm._v(" "),(driver.shiftStart !== null && driver.shiftEnd !== null)?_c('div',{staticClass:"shift-info"},[_c('i',{staticClass:"fa fa-check-circle"}),_vm._v(" "),_c('span',[_vm._v("Available from")]),_vm._v(" "),_c('span',{staticClass:"shift-value"},[_vm._v(_vm._s(driver.shiftStart.format('hh:mmA')))]),_vm._v(" "),_c('span',[_vm._v("to")]),_vm._v(" "),_c('span',{staticClass:"shift-value"},[_vm._v(_vm._s(driver.shiftEnd.format('hh:mmA')))])]):_vm._e(),_vm._v(" "),(driver.rsvpId !== null)?_c('div',{staticClass:"rsvp-info"},[_c('i',{staticClass:"fa fa-car"}),_vm._v(" "),_c('span',[_vm._v("Reservation")]),_vm._v(" "),_c('a',{attrs:{"href":'/#/reservation/' + driver.rsvpId}},[_vm._v(_vm._s(driver.rsvpId))]),_vm._v(" "),_c('span',[_vm._v("set to clear at")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"highlight"},[_vm._v(_vm._s(driver.dropoffTime.format('MM/DD hh:mmA'))+".")])]):_vm._e(),_vm._v(" "),(_vm.rsvp !== null)?_c('div',{staticClass:"row controls"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('a',{staticClass:"button cta xsmall block",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.sendToDriver(driver)}}},[_vm._v("SEND TO "+_vm._s(driver.firstName))])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('a',{staticClass:"button cta xsmall block warning",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.assignToDriver(driver)}}},[_vm._v("ASSIGN TO "+_vm._s(driver.firstName))])])]):_vm._e(),_vm._v(" "),(_vm.rsvp === null)?_c('div',{staticClass:"row controls"},[_c('div',{staticClass:"small-12 columns"},[_c('a',{staticClass:"button cta xsmall block",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.createShift(driver)}}},[_vm._v("CREATE A SHIFT FOR "+_vm._s(driver.firstName))])])]):_vm._e(),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(driver.isHomeBase),expression:"driver.isHomeBase"}],staticClass:"fa fa-home is-home"})])]):_vm._e()})],2),_vm._v(" "),_c('div',{class:{ 'untracked-drivers': true, show: _vm.hasAvailableDrivers }},[_c('div',{staticClass:"title"},[_vm._v("DRIVERS WITH AVAILABILITY")]),_vm._v(" "),_vm._l((_vm.drivers.sector),function(driver,index){return (driver.shiftStart !== null && driver.shiftEnd !== null)?_c('div',{staticClass:"driver"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"photo",style:({ 'background-image': 'url(\'' + driver.photo + '\')'})}),_vm._v(" "),_c('div',{staticClass:"name"},[_c('a',{attrs:{"href":'/#/provider/' + driver.driverId,"target":"_blank"}},[_vm._v(_vm._s(driver.name))])]),_vm._v(" "),_c('div',{staticClass:"email"},[_c('a',{attrs:{"href":'mailto:' + driver.email}},[_vm._v(_vm._s(driver.email))])]),_vm._v(" "),_c('div',{staticClass:"email"},[_c('a',{attrs:{"href":"javscript:;"},on:{"click":function($event){return _vm.callDriver(driver)}}},[_vm._v(_vm._s(driver.phone))])])]),_vm._v(" "),_c('div',{staticClass:"vehicle"},[_c('div',{staticClass:"photo",style:({ 'background-image': 'url(\'' + driver.vehicle.photoUrl + '\')'})}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(driver.vehicle.manufacturer)+" "+_vm._s(driver.vehicle.model))]),_vm._v(" "),_c('div',{staticClass:"plate-number"},[_vm._v(_vm._s(driver.vehicle.licensePlate))])]),_vm._v(" "),(driver.shiftStart !== null && driver.shiftEnd !== null)?_c('div',{staticClass:"shift-info"},[_c('i',{staticClass:"fa fa-check-circle"}),_vm._v(" "),_c('span',[_vm._v("Available from")]),_vm._v(" "),_c('span',{staticClass:"shift-value"},[_vm._v(_vm._s(driver.shiftStart.format('hh:mmA')))]),_vm._v(" "),_c('span',[_vm._v("to")]),_vm._v(" "),_c('span',{staticClass:"shift-value"},[_vm._v(_vm._s(driver.shiftEnd.format('hh:mmA')))])]):_vm._e(),_vm._v(" "),(driver.rsvpId !== null)?_c('div',{staticClass:"rsvp-info"},[_c('i',{staticClass:"fa fa-car"}),_vm._v(" "),_c('span',[_vm._v("Reservation")]),_vm._v(" "),_c('a',{attrs:{"href":'/#/reservation/' + driver.rsvpId}},[_vm._v(_vm._s(driver.rsvpId))]),_vm._v(" "),_c('span',[_vm._v("set to clear at")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"highlight"},[_vm._v(_vm._s(driver.dropoffTime.format('MM/DD hh:mmA'))+".")])]):_vm._e(),_vm._v(" "),(_vm.rsvp !== null)?_c('div',{staticClass:"row controls"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('a',{staticClass:"button cta xsmall block",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.sendToDriver(driver)}}},[_vm._v("SEND TO "+_vm._s(driver.firstName))])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('a',{staticClass:"button cta xsmall block warning",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.assignToDriver(driver)}}},[_vm._v("ASSIGN TO "+_vm._s(driver.firstName))])])]):_vm._e(),_vm._v(" "),(_vm.rsvp === null)?_c('div',{staticClass:"row controls"},[_c('div',{staticClass:"small-12 columns"},[_c('a',{staticClass:"button cta xsmall block",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.createShift(driver)}}},[_vm._v("CREATE A SHIFT FOR "+_vm._s(driver.firstName))])])]):_vm._e(),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(driver.isHomeBase),expression:"driver.isHomeBase"}],staticClass:"fa fa-home is-home"})]):_vm._e()})],2),_vm._v(" "),_c('div',{class:{ 'no-drivers': true, show: _vm.drivers.sector.length <= 0 && _vm.noDrivers }},[_c('i',{staticClass:"far fa-frown fa-2x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_c('span',[_vm._v("Sorry but we can't find any drivers")]),_vm._v(" "),(_vm.rsvp !== null)?_c('span',[_c('span',[_vm._v("to cover Reservation")]),_vm._v(" "),_c('a',{attrs:{"href":'/#/reservation/' + _vm.rsvp.ID,"target":"_blank"}},[_vm._v(_vm._s(_vm.rsvp.ID))])]):_vm._e(),_vm._v(" "),(_vm.coverageGap !== null)?_c('span',[_c('span',[_vm._v("to cover the")]),_vm._v(" "),_c('span',{staticClass:"highlight"},[_vm._v(_vm._s(_vm.coverageGap.start.format('MMM DD hh:mmA')))]),_vm._v(" "),_c('span',[_vm._v("to")]),_vm._v(" "),_c('span',{staticClass:"highlight"},[_vm._v(_vm._s(_vm.coverageGap.end.format('MMM DD hh:mmA')))]),_vm._v(" "),_c('span',[_vm._v("shift.")])]):_vm._e()])]),_vm._v(" "),_c('div',{class:{ 'submission-modal': true, show: _vm.modal.show }},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modal.loading),expression:"modal.loading"}],staticClass:"loader"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-lg"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.modal.loadingMessage))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.modal.loading),expression:"!modal.loading"}],staticClass:"loader"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.modal.success),expression:"modal.success"}],staticClass:"fa fa-check-circle fa-lg success-icon"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.modal.success),expression:"!modal.success"}],staticClass:"fas fa-exclamation-triangle fa-lg error-icon"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.modal.doneMessage))])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map2_vue__ = __webpack_require__(650);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74de62bc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map2_vue__ = __webpack_require__(2010);
function injectStyle (ssrContext) {
  __webpack_require__(2004)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74de62bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74de62bc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2005);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("3698268e", content, true, {});

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.map-container[data-v-74de62bc] {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n.coverage-map[data-v-74de62bc] {\n  display: none;\n}\n.coverage-map[data-v-74de62bc], .map-here[data-v-74de62bc] {\n  width: 100%;\n  height: 100%;\n}\n.driver-info[data-v-74de62bc] {\n  font-family: 'Open Sans', sans-serif;\n  padding: 5px 0 0 5px;\n}\n.driver-info .header[data-v-74de62bc] {\n    position: relative;\n    min-height: 50px;\n    padding-left: 60px;\n    padding-top: 0px;\n}\n.driver-info .photo[data-v-74de62bc] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 50px;\n    height: 50px;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    border-radius: 50px;\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.driver-info .name[data-v-74de62bc] {\n    font-size: 14px;\n    line-height: 14px;\n    font-weight: 700;\n}\n.driver-info .email[data-v-74de62bc] {\n    font-size: 12px;\n    line-height: 12px;\n    margin-top: 5px;\n}\n.driver-info .vehicle[data-v-74de62bc] {\n    margin-top: 10px;\n    position: relative;\n    min-height: 50px;\n    padding-left: 60px;\n    padding-top: 10px;\n}\n.driver-info .shift-info[data-v-74de62bc] {\n    font-size: 14px;\n    line-height: 14px;\n    margin-top: 15px;\n    text-align: center;\n}\n.driver-info .shift-info > *[data-v-74de62bc] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.driver-info .shift-info i[data-v-74de62bc] {\n      color: #26D97A;\n}\n.driver-info .shift-info .shift-value[data-v-74de62bc] {\n      font-weight: 700;\n      color: #0D79F2;\n}\n.driver-info .rsvp-info[data-v-74de62bc] {\n    font-size: 14px;\n    line-height: 16px;\n    margin-top: 15px;\n    text-align: center;\n}\n.driver-info .rsvp-info .highlight[data-v-74de62bc], .driver-info .rsvp-info a[data-v-74de62bc] {\n      font-weight: 700;\n      color: #0D79F2;\n}\n.driver-info .controls[data-v-74de62bc] {\n    margin-top: 15px;\n}\n.driver-info .controls .padding-R[data-v-74de62bc] {\n      padding-right: 3px;\n}\n.driver-info .controls .padding-L[data-v-74de62bc] {\n      padding-left: 3px;\n}\n.driver-info .controls .button[data-v-74de62bc] {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n}\n.driver-info .is-home[data-v-74de62bc] {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    width: 30px;\n    height: 30px;\n    border-radius: 30px;\n    background-color: #26D97A;\n    text-align: center;\n    line-height: 30px;\n    color: #fff;\n}\n.no-drivers[data-v-74de62bc] {\n  position: absolute;\n  top: 12px;\n  right: -400px;\n  background-color: #fff;\n  text-align: center;\n  width: 300px;\n  -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n  border-radius: 3px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  font-size: 14px;\n  padding: 15px;\n}\n.no-drivers.show[data-v-74de62bc] {\n    right: 15px;\n}\n.no-drivers .message[data-v-74de62bc] {\n    margin-top: 10px;\n}\n.no-drivers .message > *[data-v-74de62bc] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.no-drivers .message .highlight[data-v-74de62bc] {\n      font-weight: 700;\n}\n.untracked-drivers[data-v-74de62bc] {\n  position: absolute;\n  top: 12px;\n  right: -400px;\n  background-color: #fff;\n  -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n  border-radius: 3px;\n  width: 350px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  max-height: 90%;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.untracked-drivers.show[data-v-74de62bc] {\n    right: 15px;\n}\n.untracked-drivers .title[data-v-74de62bc] {\n    text-align: center;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 12px;\n    padding: 10px 0 7px;\n    color: #555;\n}\n.untracked-drivers .driver[data-v-74de62bc] {\n    padding: 10px 10px 5px;\n    border-top: 1px solid rgba(0, 0, 0, 0.2);\n    position: relative;\n}\n.untracked-drivers .is-home[data-v-74de62bc] {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    width: 30px;\n    height: 30px;\n    border-radius: 30px;\n    background-color: #26D97A;\n    text-align: center;\n    line-height: 30px;\n    color: #fff;\n}\n.untracked-drivers .header[data-v-74de62bc] {\n    position: relative;\n    min-height: 50px;\n    padding-left: 60px;\n}\n.untracked-drivers .header .photo[data-v-74de62bc] {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 50px;\n      height: 50px;\n      background-position: 50% 50%;\n      background-repeat: no-repeat;\n      background-size: cover;\n      border-radius: 50px;\n      -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n      border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.untracked-drivers .header .name[data-v-74de62bc] {\n      font-size: 14px;\n      line-height: 14px;\n      font-weight: 700;\n}\n.untracked-drivers .header .email[data-v-74de62bc] {\n      font-size: 12px;\n      line-height: 12px;\n      margin-top: 5px;\n}\n.untracked-drivers .vehicle[data-v-74de62bc] {\n    position: relative;\n    padding-left: 60px;\n    padding-top: 8px;\n    margin-top: 5px;\n    height: 50px;\n}\n.untracked-drivers .vehicle .photo[data-v-74de62bc] {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 50px;\n      height: 50px;\n      background-position: 50% 50%;\n      background-repeat: no-repeat;\n      background-size: cover;\n      border-radius: 50px;\n      -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n      border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.untracked-drivers .vehicle .name[data-v-74de62bc] {\n      font-size: 14px;\n      font-weight: 700;\n      line-height: 14px;\n}\n.untracked-drivers .vehicle .plate-number[data-v-74de62bc] {\n      font-size: 14px;\n      line-height: 14px;\n      margin-top: 5px;\n}\n.untracked-drivers .shift-info[data-v-74de62bc] {\n    font-size: 14px;\n    line-height: 14px;\n    margin-top: 15px;\n    text-align: center;\n}\n.untracked-drivers .shift-info > *[data-v-74de62bc] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.untracked-drivers .shift-info i[data-v-74de62bc] {\n      color: #26D97A;\n}\n.untracked-drivers .shift-info .shift-value[data-v-74de62bc] {\n      font-weight: 700;\n      color: #0D79F2;\n}\n.untracked-drivers .rsvp-info[data-v-74de62bc] {\n    font-size: 14px;\n    line-height: 16px;\n    margin-top: 15px;\n    text-align: center;\n}\n.untracked-drivers .rsvp-info .highlight[data-v-74de62bc], .untracked-drivers .rsvp-info a[data-v-74de62bc] {\n      font-weight: 700;\n      color: #0D79F2;\n}\n.untracked-drivers .controls[data-v-74de62bc] {\n    margin-top: 15px;\n}\n.untracked-drivers .controls .padding-R[data-v-74de62bc] {\n      padding-right: 3px;\n}\n.untracked-drivers .controls .padding-L[data-v-74de62bc] {\n      padding-left: 3px;\n}\n.untracked-drivers .controls .button[data-v-74de62bc] {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n}\n.point-info[data-v-74de62bc] {\n  padding: 0 0 5px 5px;\n  background-color: #fff;\n  font-family: 'Open Sans', sans-serif;\n}\n.point-info label[data-v-74de62bc] {\n    font-weight: 700;\n    font-size: 10px;\n    line-height: 10px;\n    color: #0D79F2;\n}\n.point-info .value[data-v-74de62bc] {\n    font-size: 14px;\n    font-weight: 700;\n}\n.point-info .label-value[data-v-74de62bc]:not(:first-child) {\n    margin-top: 10px;\n}\n.submission-modal[data-v-74de62bc] {\n  display: table;\n  position: fixed;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 12;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.submission-modal.show[data-v-74de62bc] {\n    top: 0;\n    opacity: 1;\n}\n.submission-modal .modal-container[data-v-74de62bc] {\n    display: table-cell;\n    vertical-align: middle;\n    text-align: center;\n}\n.submission-modal .modal-content[data-v-74de62bc] {\n    background-color: #fff;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    width: 350px;\n    margin: 0 auto;\n    padding: 20px 15px;\n    border-radius: 5px;\n}\n.submission-modal .loader .message[data-v-74de62bc] {\n    font-size: 16px;\n    line-height: 16px;\n    font-weight: 700;\n    margin-top: 10px;\n}\n.submission-modal .success-icon[data-v-74de62bc] {\n    color: #26D97A;\n}\n.submission-modal .error-icon[data-v-74de62bc] {\n    color: #F25E0D;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Coverage/Map2.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;CACpB;AACD;EACE,cAAc;CACf;AACD;EACE,YAAY;EACZ,aAAa;CACd;AACD;EACE,qCAAqC;EACrC,qBAAqB;CACtB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;CACpB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,6BAA6B;IAC7B,uBAAuB;IACvB,oBAAoB;IACpB,iDAAiD;YACzC,yCAAyC;IACjD,qCAAqC;CACxC;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;CACpB;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;CACnB;AACD;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;CACrB;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,uBAAuB;CAC5B;AACD;MACM,eAAe;CACpB;AACD;MACM,iBAAiB;MACjB,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;CACtB;AACD;MACM,iBAAiB;MACjB,eAAe;CACpB;AACD;IACI,iBAAiB;CACpB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,kBAAkB;CACvB;AACD;MACM,iBAAiB;MACjB,wBAAwB;MACxB,oBAAoB;CACzB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;CACf;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;CACf;AACD;IACI,YAAY;CACf;AACD;IACI,iBAAiB;CACpB;AACD;MACM,sBAAsB;MACtB,uBAAuB;CAC5B;AACD;MACM,iBAAiB;CACtB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,YAAY;CACf;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;CACf;AACD;IACI,uBAAuB;IACvB,yCAAyC;IACzC,mBAAmB;CACtB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;CACf;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;CACtB;AACD;MACM,mBAAmB;MACnB,OAAO;MACP,QAAQ;MACR,YAAY;MACZ,aAAa;MACb,6BAA6B;MAC7B,6BAA6B;MAC7B,uBAAuB;MACvB,oBAAoB;MACpB,iDAAiD;cACzC,yCAAyC;MACjD,qCAAqC;CAC1C;AACD;MACM,gBAAgB;MAChB,kBAAkB;MAClB,iBAAiB;CACtB;AACD;MACM,gBAAgB;MAChB,kBAAkB;MAClB,gBAAgB;CACrB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;CAChB;AACD;MACM,mBAAmB;MACnB,OAAO;MACP,QAAQ;MACR,YAAY;MACZ,aAAa;MACb,6BAA6B;MAC7B,6BAA6B;MAC7B,uBAAuB;MACvB,oBAAoB;MACpB,iDAAiD;cACzC,yCAAyC;MACjD,qCAAqC;CAC1C;AACD;MACM,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;CACvB;AACD;MACM,gBAAgB;MAChB,kBAAkB;MAClB,gBAAgB;CACrB;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,uBAAuB;CAC5B;AACD;MACM,eAAe;CACpB;AACD;MACM,iBAAiB;MACjB,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;CACtB;AACD;MACM,iBAAiB;MACjB,eAAe;CACpB;AACD;IACI,iBAAiB;CACpB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,kBAAkB;CACvB;AACD;MACM,iBAAiB;MACjB,wBAAwB;MACxB,oBAAoB;CACzB;AACD;EACE,qBAAqB;EACrB,uBAAuB;EACvB,qCAAqC;CACtC;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;CAClB;AACD;IACI,gBAAgB;IAChB,iBAAiB;CACpB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;IACI,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;CACtB;AACD;IACI,uBAAuB;IACvB,iDAAiD;YACzC,yCAAyC;IACjD,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,mBAAmB;CACtB;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;CACpB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB","file":"Map2.vue","sourcesContent":["\n.map-container[data-v-74de62bc] {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n.coverage-map[data-v-74de62bc] {\n  display: none;\n}\n.coverage-map[data-v-74de62bc], .map-here[data-v-74de62bc] {\n  width: 100%;\n  height: 100%;\n}\n.driver-info[data-v-74de62bc] {\n  font-family: 'Open Sans', sans-serif;\n  padding: 5px 0 0 5px;\n}\n.driver-info .header[data-v-74de62bc] {\n    position: relative;\n    min-height: 50px;\n    padding-left: 60px;\n    padding-top: 0px;\n}\n.driver-info .photo[data-v-74de62bc] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 50px;\n    height: 50px;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    border-radius: 50px;\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.driver-info .name[data-v-74de62bc] {\n    font-size: 14px;\n    line-height: 14px;\n    font-weight: 700;\n}\n.driver-info .email[data-v-74de62bc] {\n    font-size: 12px;\n    line-height: 12px;\n    margin-top: 5px;\n}\n.driver-info .vehicle[data-v-74de62bc] {\n    margin-top: 10px;\n    position: relative;\n    min-height: 50px;\n    padding-left: 60px;\n    padding-top: 10px;\n}\n.driver-info .shift-info[data-v-74de62bc] {\n    font-size: 14px;\n    line-height: 14px;\n    margin-top: 15px;\n    text-align: center;\n}\n.driver-info .shift-info > *[data-v-74de62bc] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.driver-info .shift-info i[data-v-74de62bc] {\n      color: #26D97A;\n}\n.driver-info .shift-info .shift-value[data-v-74de62bc] {\n      font-weight: 700;\n      color: #0D79F2;\n}\n.driver-info .rsvp-info[data-v-74de62bc] {\n    font-size: 14px;\n    line-height: 16px;\n    margin-top: 15px;\n    text-align: center;\n}\n.driver-info .rsvp-info .highlight[data-v-74de62bc], .driver-info .rsvp-info a[data-v-74de62bc] {\n      font-weight: 700;\n      color: #0D79F2;\n}\n.driver-info .controls[data-v-74de62bc] {\n    margin-top: 15px;\n}\n.driver-info .controls .padding-R[data-v-74de62bc] {\n      padding-right: 3px;\n}\n.driver-info .controls .padding-L[data-v-74de62bc] {\n      padding-left: 3px;\n}\n.driver-info .controls .button[data-v-74de62bc] {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n}\n.driver-info .is-home[data-v-74de62bc] {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    width: 30px;\n    height: 30px;\n    border-radius: 30px;\n    background-color: #26D97A;\n    text-align: center;\n    line-height: 30px;\n    color: #fff;\n}\n.no-drivers[data-v-74de62bc] {\n  position: absolute;\n  top: 12px;\n  right: -400px;\n  background-color: #fff;\n  text-align: center;\n  width: 300px;\n  -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n  border-radius: 3px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  font-size: 14px;\n  padding: 15px;\n}\n.no-drivers.show[data-v-74de62bc] {\n    right: 15px;\n}\n.no-drivers .message[data-v-74de62bc] {\n    margin-top: 10px;\n}\n.no-drivers .message > *[data-v-74de62bc] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.no-drivers .message .highlight[data-v-74de62bc] {\n      font-weight: 700;\n}\n.untracked-drivers[data-v-74de62bc] {\n  position: absolute;\n  top: 12px;\n  right: -400px;\n  background-color: #fff;\n  -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);\n  border-radius: 3px;\n  width: 350px;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  max-height: 90%;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.untracked-drivers.show[data-v-74de62bc] {\n    right: 15px;\n}\n.untracked-drivers .title[data-v-74de62bc] {\n    text-align: center;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 12px;\n    padding: 10px 0 7px;\n    color: #555;\n}\n.untracked-drivers .driver[data-v-74de62bc] {\n    padding: 10px 10px 5px;\n    border-top: 1px solid rgba(0, 0, 0, 0.2);\n    position: relative;\n}\n.untracked-drivers .is-home[data-v-74de62bc] {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    width: 30px;\n    height: 30px;\n    border-radius: 30px;\n    background-color: #26D97A;\n    text-align: center;\n    line-height: 30px;\n    color: #fff;\n}\n.untracked-drivers .header[data-v-74de62bc] {\n    position: relative;\n    min-height: 50px;\n    padding-left: 60px;\n}\n.untracked-drivers .header .photo[data-v-74de62bc] {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 50px;\n      height: 50px;\n      background-position: 50% 50%;\n      background-repeat: no-repeat;\n      background-size: cover;\n      border-radius: 50px;\n      -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n      border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.untracked-drivers .header .name[data-v-74de62bc] {\n      font-size: 14px;\n      line-height: 14px;\n      font-weight: 700;\n}\n.untracked-drivers .header .email[data-v-74de62bc] {\n      font-size: 12px;\n      line-height: 12px;\n      margin-top: 5px;\n}\n.untracked-drivers .vehicle[data-v-74de62bc] {\n    position: relative;\n    padding-left: 60px;\n    padding-top: 8px;\n    margin-top: 5px;\n    height: 50px;\n}\n.untracked-drivers .vehicle .photo[data-v-74de62bc] {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 50px;\n      height: 50px;\n      background-position: 50% 50%;\n      background-repeat: no-repeat;\n      background-size: cover;\n      border-radius: 50px;\n      -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n      border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.untracked-drivers .vehicle .name[data-v-74de62bc] {\n      font-size: 14px;\n      font-weight: 700;\n      line-height: 14px;\n}\n.untracked-drivers .vehicle .plate-number[data-v-74de62bc] {\n      font-size: 14px;\n      line-height: 14px;\n      margin-top: 5px;\n}\n.untracked-drivers .shift-info[data-v-74de62bc] {\n    font-size: 14px;\n    line-height: 14px;\n    margin-top: 15px;\n    text-align: center;\n}\n.untracked-drivers .shift-info > *[data-v-74de62bc] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.untracked-drivers .shift-info i[data-v-74de62bc] {\n      color: #26D97A;\n}\n.untracked-drivers .shift-info .shift-value[data-v-74de62bc] {\n      font-weight: 700;\n      color: #0D79F2;\n}\n.untracked-drivers .rsvp-info[data-v-74de62bc] {\n    font-size: 14px;\n    line-height: 16px;\n    margin-top: 15px;\n    text-align: center;\n}\n.untracked-drivers .rsvp-info .highlight[data-v-74de62bc], .untracked-drivers .rsvp-info a[data-v-74de62bc] {\n      font-weight: 700;\n      color: #0D79F2;\n}\n.untracked-drivers .controls[data-v-74de62bc] {\n    margin-top: 15px;\n}\n.untracked-drivers .controls .padding-R[data-v-74de62bc] {\n      padding-right: 3px;\n}\n.untracked-drivers .controls .padding-L[data-v-74de62bc] {\n      padding-left: 3px;\n}\n.untracked-drivers .controls .button[data-v-74de62bc] {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n}\n.point-info[data-v-74de62bc] {\n  padding: 0 0 5px 5px;\n  background-color: #fff;\n  font-family: 'Open Sans', sans-serif;\n}\n.point-info label[data-v-74de62bc] {\n    font-weight: 700;\n    font-size: 10px;\n    line-height: 10px;\n    color: #0D79F2;\n}\n.point-info .value[data-v-74de62bc] {\n    font-size: 14px;\n    font-weight: 700;\n}\n.point-info .label-value[data-v-74de62bc]:not(:first-child) {\n    margin-top: 10px;\n}\n.submission-modal[data-v-74de62bc] {\n  display: table;\n  position: fixed;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 12;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.submission-modal.show[data-v-74de62bc] {\n    top: 0;\n    opacity: 1;\n}\n.submission-modal .modal-container[data-v-74de62bc] {\n    display: table-cell;\n    vertical-align: middle;\n    text-align: center;\n}\n.submission-modal .modal-content[data-v-74de62bc] {\n    background-color: #fff;\n    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    width: 350px;\n    margin: 0 auto;\n    padding: 20px 15px;\n    border-radius: 5px;\n}\n.submission-modal .loader .message[data-v-74de62bc] {\n    font-size: 16px;\n    line-height: 16px;\n    font-weight: 700;\n    margin-top: 10px;\n}\n.submission-modal .success-icon[data-v-74de62bc] {\n    color: #26D97A;\n}\n.submission-modal .error-icon[data-v-74de62bc] {\n    color: #F25E0D;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverModal_vue__ = __webpack_require__(651);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54d7f738_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverModal_vue__ = __webpack_require__(2009);
function injectStyle (ssrContext) {
  __webpack_require__(2007)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54d7f738"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54d7f738_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2008);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1d585fea", content, true, {});

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.driver-info[data-v-54d7f738] {\n  font-family: 'Open Sans', sans-serif;\n  padding: 5px 0 0 5px;\n  text-align: left;\n}\n.driver-info .header[data-v-54d7f738] {\n    position: relative;\n    min-height: 50px;\n    padding-left: 60px;\n    padding-top: 0px;\n    padding-right: 15px;\n}\n.driver-info .photo[data-v-54d7f738] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 50px;\n    height: 50px;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    border-radius: 50px;\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.driver-info .name[data-v-54d7f738] {\n    font-size: 14px;\n    line-height: 14px;\n    font-weight: 700;\n}\n.driver-info .email[data-v-54d7f738] {\n    font-size: 12px;\n    line-height: 12px;\n    margin-top: 5px;\n    word-break: break-word;\n}\n.driver-info .vehicle[data-v-54d7f738] {\n    margin-top: 10px;\n    position: relative;\n    min-height: 50px;\n    padding-left: 60px;\n    padding-top: 10px;\n}\n.driver-info .shift-info[data-v-54d7f738] {\n    font-size: 14px;\n    line-height: 14px;\n    margin-top: 15px;\n    text-align: center;\n}\n.driver-info .shift-info > *[data-v-54d7f738] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.driver-info .shift-info i[data-v-54d7f738] {\n      color: #26D97A;\n}\n.driver-info .shift-info .shift-value[data-v-54d7f738] {\n      font-weight: 700;\n      color: #0D79F2;\n}\n.driver-info .rsvp-info[data-v-54d7f738] {\n    font-size: 14px;\n    line-height: 16px;\n    margin-top: 15px;\n    text-align: center;\n}\n.driver-info .rsvp-info .highlight[data-v-54d7f738], .driver-info .rsvp-info a[data-v-54d7f738] {\n      font-weight: 700;\n      color: #0D79F2;\n}\n.driver-info .controls[data-v-54d7f738] {\n    margin-top: 15px;\n}\n.driver-info .controls .padding-R[data-v-54d7f738] {\n      padding-right: 3px;\n}\n.driver-info .controls .padding-L[data-v-54d7f738] {\n      padding-left: 3px;\n}\n.driver-info .controls .adjust-right[data-v-54d7f738] {\n      position: relative;\n      left: 10px;\n}\n.driver-info .controls .button[data-v-54d7f738] {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n}\n.driver-info .is-home[data-v-54d7f738] {\n    position: absolute;\n    top: 35px;\n    right: 10px;\n    width: 30px;\n    height: 30px;\n    border-radius: 30px;\n    background-color: #26D97A;\n    text-align: center;\n    line-height: 30px;\n    color: #fff;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Coverage/DriverModal.vue"],"names":[],"mappings":";AACA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,iBAAiB;CAClB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;CACvB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,6BAA6B;IAC7B,uBAAuB;IACvB,oBAAoB;IACpB,iDAAiD;YACzC,yCAAyC;IACjD,qCAAqC;CACxC;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;CACpB;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;CAC1B;AACD;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;CACrB;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,uBAAuB;CAC5B;AACD;MACM,eAAe;CACpB;AACD;MACM,iBAAiB;MACjB,eAAe;CACpB;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;CACtB;AACD;MACM,iBAAiB;MACjB,eAAe;CACpB;AACD;IACI,iBAAiB;CACpB;AACD;MACM,mBAAmB;CACxB;AACD;MACM,kBAAkB;CACvB;AACD;MACM,mBAAmB;MACnB,WAAW;CAChB;AACD;MACM,iBAAiB;MACjB,wBAAwB;MACxB,oBAAoB;CACzB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;CACf","file":"DriverModal.vue","sourcesContent":["\n.driver-info[data-v-54d7f738] {\n  font-family: 'Open Sans', sans-serif;\n  padding: 5px 0 0 5px;\n  text-align: left;\n}\n.driver-info .header[data-v-54d7f738] {\n    position: relative;\n    min-height: 50px;\n    padding-left: 60px;\n    padding-top: 0px;\n    padding-right: 15px;\n}\n.driver-info .photo[data-v-54d7f738] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 50px;\n    height: 50px;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    border-radius: 50px;\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.driver-info .name[data-v-54d7f738] {\n    font-size: 14px;\n    line-height: 14px;\n    font-weight: 700;\n}\n.driver-info .email[data-v-54d7f738] {\n    font-size: 12px;\n    line-height: 12px;\n    margin-top: 5px;\n    word-break: break-word;\n}\n.driver-info .vehicle[data-v-54d7f738] {\n    margin-top: 10px;\n    position: relative;\n    min-height: 50px;\n    padding-left: 60px;\n    padding-top: 10px;\n}\n.driver-info .shift-info[data-v-54d7f738] {\n    font-size: 14px;\n    line-height: 14px;\n    margin-top: 15px;\n    text-align: center;\n}\n.driver-info .shift-info > *[data-v-54d7f738] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.driver-info .shift-info i[data-v-54d7f738] {\n      color: #26D97A;\n}\n.driver-info .shift-info .shift-value[data-v-54d7f738] {\n      font-weight: 700;\n      color: #0D79F2;\n}\n.driver-info .rsvp-info[data-v-54d7f738] {\n    font-size: 14px;\n    line-height: 16px;\n    margin-top: 15px;\n    text-align: center;\n}\n.driver-info .rsvp-info .highlight[data-v-54d7f738], .driver-info .rsvp-info a[data-v-54d7f738] {\n      font-weight: 700;\n      color: #0D79F2;\n}\n.driver-info .controls[data-v-54d7f738] {\n    margin-top: 15px;\n}\n.driver-info .controls .padding-R[data-v-54d7f738] {\n      padding-right: 3px;\n}\n.driver-info .controls .padding-L[data-v-54d7f738] {\n      padding-left: 3px;\n}\n.driver-info .controls .adjust-right[data-v-54d7f738] {\n      position: relative;\n      left: 10px;\n}\n.driver-info .controls .button[data-v-54d7f738] {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n}\n.driver-info .is-home[data-v-54d7f738] {\n    position: absolute;\n    top: 35px;\n    right: 10px;\n    width: 30px;\n    height: 30px;\n    border-radius: 30px;\n    background-color: #26D97A;\n    text-align: center;\n    line-height: 30px;\n    color: #fff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"here-info-window-content coverage driver driver-info"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"photo",style:({ 'background-image': 'url(\'' + _vm.driver.photo + '\')'})}),_vm._v(" "),_c('div',{staticClass:"name"},[_c('a',{attrs:{"href":'/#/provider/' + _vm.driver.driverId,"target":"_blank"}},[_vm._v(_vm._s(_vm.driver.name))])]),_vm._v(" "),_c('div',{staticClass:"email"},[_c('a',{attrs:{"href":'mailto:' + _vm.driver.email}},[_vm._v(_vm._s(_vm.driver.email))])]),_vm._v(" "),_c('div',{staticClass:"email"},[_c('a',{attrs:{"href":"javscript:;"},on:{"click":function($event){return _vm.callDriver(_vm.driver)}}},[_vm._v(_vm._s(_vm.driver.phone))])])]),_vm._v(" "),_c('div',{staticClass:"vehicle"},[_c('div',{staticClass:"photo",style:({ 'background-image': 'url(\'' + _vm.driver.vehicle.photoUrl + '\')'})}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.driver.vehicle.manufacturer)+" "+_vm._s(_vm.driver.vehicle.model))]),_vm._v(" "),_c('div',{staticClass:"plate-number"},[_vm._v(_vm._s(_vm.driver.vehicle.licensePlate))])]),_vm._v(" "),(_vm.driver.shiftStart !== null && _vm.driver.shiftEnd !== null)?_c('div',{staticClass:"shift-info"},[_c('i',{staticClass:"fa fa-check-circle"}),_vm._v(" "),_c('span',[_vm._v("Available from")]),_vm._v(" "),_c('span',{staticClass:"shift-value"},[_vm._v(_vm._s(_vm.driver.shiftStart.format('hh:mmA')))]),_vm._v(" "),_c('span',[_vm._v("to")]),_vm._v(" "),_c('span',{staticClass:"shift-value"},[_vm._v(_vm._s(_vm.driver.shiftEnd.format('hh:mmA')))])]):_vm._e(),_vm._v(" "),(_vm.driver.rsvpId !== null)?_c('div',{staticClass:"rsvp-info"},[_c('i',{staticClass:"fa fa-car"}),_vm._v(" "),_c('span',[_vm._v("Reservation")]),_vm._v(" "),_c('a',{attrs:{"href":'/#/reservation/' + _vm.driver.rsvpId}},[_vm._v(_vm._s(_vm.driver.rsvpId))]),_vm._v(" "),_c('span',[_vm._v("set to clear at")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"highlight"},[_vm._v(_vm._s(_vm.driver.dropoffTime.format('hh:mmA'))+".")])]):_vm._e(),_vm._v(" "),(_vm.rsvp !== null)?_c('div',{staticClass:"row controls"},[_c('div',{staticClass:"small-6 columns"},[_c('a',{staticClass:"button cta xsmall block",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.sendToDriver(_vm.driver)}}},[_vm._v("SEND TO "+_vm._s(_vm.driver.firstName))])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns adjust-right"},[_c('a',{staticClass:"button cta xsmall block warning",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.assignToDriver(_vm.driver)}}},[_vm._v("ASSIGN TO "+_vm._s(_vm.driver.firstName))])])]):_vm._e(),_vm._v(" "),(_vm.rsvp === null)?_c('div',{staticClass:"row controls"},[_c('div',{staticClass:"small-12 columns"},[_c('a',{staticClass:"button cta xsmall block",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.createShift(_vm.driver)}}},[_vm._v("CREATE A SHIFT FOR "+_vm._s(_vm.driver.firstName))])])]):_vm._e(),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.driver.isHomeBase),expression:"driver.isHomeBase"}],staticClass:"fa fa-home is-home"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-container"},[_c('div',{staticClass:"map-here",attrs:{"id":"mapHere"}}),_vm._v(" "),_c('div',{class:{ 'untracked-drivers': true, show: _vm.hasAvailableDrivers }},[_c('div',{staticClass:"title"},[_vm._v("DRIVERS WITH AVAILABILITY")]),_vm._v(" "),_vm._l((_vm.drivers.sector),function(driver,index){return (driver.shiftStart !== null && driver.shiftEnd !== null)?_c('div',{staticClass:"driver"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"photo",style:({ 'background-image': 'url(\'' + driver.photo + '\')'})}),_vm._v(" "),_c('div',{staticClass:"name"},[_c('a',{attrs:{"href":'/#/provider/' + driver.driverId,"target":"_blank"}},[_vm._v(_vm._s(driver.name))])]),_vm._v(" "),_c('div',{staticClass:"email"},[_c('a',{attrs:{"href":'mailto:' + driver.email}},[_vm._v(_vm._s(driver.email))])]),_vm._v(" "),_c('div',{staticClass:"email"},[_c('a',{attrs:{"href":"javscript:;"},on:{"click":function($event){return _vm.callDriver(driver)}}},[_vm._v(_vm._s(driver.phone))])])]),_vm._v(" "),_c('div',{staticClass:"vehicle"},[_c('div',{staticClass:"photo",style:({ 'background-image': 'url(\'' + driver.vehicle.photoUrl + '\')'})}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(driver.vehicle.manufacturer)+" "+_vm._s(driver.vehicle.model))]),_vm._v(" "),_c('div',{staticClass:"plate-number"},[_vm._v(_vm._s(driver.vehicle.licensePlate))])]),_vm._v(" "),(driver.shiftStart !== null && driver.shiftEnd !== null)?_c('div',{staticClass:"shift-info"},[_c('i',{staticClass:"fa fa-check-circle"}),_vm._v(" "),_c('span',[_vm._v("Available from")]),_vm._v(" "),_c('span',{staticClass:"shift-value"},[_vm._v(_vm._s(driver.shiftStart.format('hh:mmA')))]),_vm._v(" "),_c('span',[_vm._v("to")]),_vm._v(" "),_c('span',{staticClass:"shift-value"},[_vm._v(_vm._s(driver.shiftEnd.format('hh:mmA')))])]):_vm._e(),_vm._v(" "),(driver.rsvpId !== null)?_c('div',{staticClass:"rsvp-info"},[_c('i',{staticClass:"fa fa-car"}),_vm._v(" "),_c('span',[_vm._v("Reservation")]),_vm._v(" "),_c('a',{attrs:{"href":'/#/reservation/' + driver.rsvpId}},[_vm._v(_vm._s(driver.rsvpId))]),_vm._v(" "),_c('span',[_vm._v("set to clear at")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"highlight"},[_vm._v(_vm._s(driver.dropoffTime.format('MM/DD hh:mmA'))+".")])]):_vm._e(),_vm._v(" "),(_vm.rsvp !== null)?_c('div',{staticClass:"row controls"},[_c('div',{staticClass:"small-6 columns padding-R"},[_c('a',{staticClass:"button cta xsmall block",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.sendToDriver(driver)}}},[_vm._v("SEND TO "+_vm._s(driver.firstName))])]),_vm._v(" "),_c('div',{staticClass:"small-6 columns padding-L"},[_c('a',{staticClass:"button cta xsmall block warning",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.assignToDriver(driver)}}},[_vm._v("ASSIGN TO "+_vm._s(driver.firstName))])])]):_vm._e(),_vm._v(" "),(_vm.rsvp === null)?_c('div',{staticClass:"row controls"},[_c('div',{staticClass:"small-12 columns"},[_c('a',{staticClass:"button cta xsmall block",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.createShift(driver)}}},[_vm._v("CREATE A SHIFT FOR "+_vm._s(driver.firstName))])])]):_vm._e(),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(driver.isHomeBase),expression:"driver.isHomeBase"}],staticClass:"fa fa-home is-home"})]):_vm._e()})],2),_vm._v(" "),_c('div',{class:{ 'no-drivers': true, show: _vm.drivers.sector.length <= 0 && _vm.noDrivers }},[_c('i',{staticClass:"far fa-frown fa-2x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_c('span',[_vm._v("Sorry but we can't find any drivers")]),_vm._v(" "),(_vm.rsvp !== null)?_c('span',[_c('span',[_vm._v("to cover Reservation")]),_vm._v(" "),_c('a',{attrs:{"href":'/#/reservation/' + _vm.rsvp.ID,"target":"_blank"}},[_vm._v(_vm._s(_vm.rsvp.ID))])]):_vm._e(),_vm._v(" "),(_vm.coverageGap !== null)?_c('span',[_c('span',[_vm._v("to cover the")]),_vm._v(" "),_c('span',{staticClass:"highlight"},[_vm._v(_vm._s(_vm.coverageGap.start.format('MMM DD hh:mmA')))]),_vm._v(" "),_c('span',[_vm._v("to")]),_vm._v(" "),_c('span',{staticClass:"highlight"},[_vm._v(_vm._s(_vm.coverageGap.end.format('MMM DD hh:mmA')))]),_vm._v(" "),_c('span',[_vm._v("shift.")])]):_vm._e()])]),_vm._v(" "),_c('div',{class:{ 'submission-modal': true, show: _vm.modal.show }},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modal.loading),expression:"modal.loading"}],staticClass:"loader"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-lg"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.modal.loadingMessage))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.modal.loading),expression:"!modal.loading"}],staticClass:"loader"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.modal.success),expression:"modal.success"}],staticClass:"fa fa-check-circle fa-lg success-icon"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.modal.success),expression:"!modal.success"}],staticClass:"fas fa-exclamation-triangle fa-lg error-icon"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.modal.doneMessage))])])])])]),_vm._v(" "),_c('div',{staticStyle:{"width":"1px","height":"0","overflow":"hidden"}},[_c('driver-modal',{key:"car",ref:"HCar",attrs:{"id":"HCar"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShiftForm_vue__ = __webpack_require__(652);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_565a2a32_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShiftForm_vue__ = __webpack_require__(2014);
function injectStyle (ssrContext) {
  __webpack_require__(2012)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-565a2a32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShiftForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_565a2a32_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShiftForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2013);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4cf12f9a", content, true, {});

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.modal-container[data-v-565a2a32] {\n  position: fixed;\n  display: table;\n  top: -100%;\n  left: 0;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 12;\n  background-color: rgba(0, 0, 0, 0.5);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.modal-container.show[data-v-565a2a32] {\n    top: 0;\n    opacity: 1;\n}\n.modal-content[data-v-565a2a32] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.shift-form[data-v-565a2a32] {\n  background-color: #fff;\n  border-radius: 5px;\n  width: 300px;\n  margin: 0 auto;\n  overflow: hidden;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n}\n.form-title[data-v-565a2a32] {\n  text-transform: uppercase;\n  text-align: center;\n  padding: 10px 10px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n  margin-bottom: 10px;\n  font-size: 14px;\n  background-color: #333;\n  color: #e5e5e5;\n}\n.form-title > *[data-v-565a2a32] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.form-title .highlight[data-v-565a2a32] {\n    font-weight: 700;\n    color: #fff;\n}\n.time-picker[data-v-565a2a32] {\n  width: 100%;\n  padding: 0 15px;\n  height: 90px;\n}\n.time-picker label[data-v-565a2a32] {\n    color: #0D79F2;\n    font-weight: 700;\n    font-size: 10px;\n    line-height: 10px;\n    display: block;\n    margin-bottom: 10px;\n}\n.time-picker .inline[data-v-565a2a32] {\n    display: inline-block;\n    vertical-align: middle;\n    float: left;\n    text-align: center;\n}\n.time-picker .selection[data-v-565a2a32] {\n    text-align: center;\n    width: 30%;\n}\n.time-picker .selection .value[data-v-565a2a32] {\n      font-size: 22px;\n      font-weight: 700;\n      color: #555;\n}\n.time-picker .selection .control[data-v-565a2a32] {\n      font-size: 12px;\n      color: #0D79F2;\n      cursor: pointer;\n      width: 100%;\n}\n.time-picker .separator[data-v-565a2a32] {\n    line-height: 69px;\n    height: 69px;\n    color: #777;\n    padding: 0 5px;\n    width: 5%;\n}\n.field-input[data-v-565a2a32] {\n  padding: 5px 15px 15px;\n}\n.field-input label[data-v-565a2a32] {\n    color: #0D79F2;\n    font-weight: 700;\n    font-size: 10px;\n    line-height: 10px;\n}\n.field-input select[data-v-565a2a32] {\n    font-size: 14px;\n    height: 37px;\n    outline: 0;\n    padding: 7px 7px;\n    display: block;\n    border-color: rgba(0, 0, 0, 0.15);\n    background-color: #fff;\n    border-radius: 3px;\n}\n.controls[data-v-565a2a32] {\n  padding: 0 15px 15px;\n}\n.controls .padding-L[data-v-565a2a32] {\n    padding-left: 5px;\n}\n.controls .padding-R[data-v-565a2a32] {\n    padding-right: 5px;\n}\n.notice[data-v-565a2a32] {\n  padding: 9px 15px 24px;\n  text-align: center;\n  font-size: 14px;\n  line-height: 14px;\n  font-weight: 700;\n}\n.notice > div > *[data-v-565a2a32] {\n    vertical-align: middle;\n    display: inline-block;\n}\n.notice .success i[data-v-565a2a32] {\n    color: #26D97A;\n}\n.notice .fail i[data-v-565a2a32] {\n    color: #F25E0D;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Coverage/ShiftForm.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,qCAAqC;EACrC,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,kDAAkD;UAC1C,0CAA0C;CACnD;AACD;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;CAChB;AACD;IACI,sBAAsB;IACtB,uBAAuB;CAC1B;AACD;IACI,iBAAiB;IACjB,YAAY;CACf;AACD;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;CACd;AACD;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;CACvB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;CACtB;AACD;IACI,mBAAmB;IACnB,WAAW;CACd;AACD;MACM,gBAAgB;MAChB,iBAAiB;MACjB,YAAY;CACjB;AACD;MACM,gBAAgB;MAChB,eAAe;MACf,gBAAgB;MAChB,YAAY;CACjB;AACD;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,UAAU;CACb;AACD;EACE,uBAAuB;CACxB;AACD;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;CACrB;AACD;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,kCAAkC;IAClC,uBAAuB;IACvB,mBAAmB;CACtB;AACD;EACE,qBAAqB;CACtB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,mBAAmB;CACtB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;CAClB;AACD;IACI,uBAAuB;IACvB,sBAAsB;CACzB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB","file":"ShiftForm.vue","sourcesContent":["\n.modal-container[data-v-565a2a32] {\n  position: fixed;\n  display: table;\n  top: -100%;\n  left: 0;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 12;\n  background-color: rgba(0, 0, 0, 0.5);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.modal-container.show[data-v-565a2a32] {\n    top: 0;\n    opacity: 1;\n}\n.modal-content[data-v-565a2a32] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.shift-form[data-v-565a2a32] {\n  background-color: #fff;\n  border-radius: 5px;\n  width: 300px;\n  margin: 0 auto;\n  overflow: hidden;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n}\n.form-title[data-v-565a2a32] {\n  text-transform: uppercase;\n  text-align: center;\n  padding: 10px 10px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n  margin-bottom: 10px;\n  font-size: 14px;\n  background-color: #333;\n  color: #e5e5e5;\n}\n.form-title > *[data-v-565a2a32] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.form-title .highlight[data-v-565a2a32] {\n    font-weight: 700;\n    color: #fff;\n}\n.time-picker[data-v-565a2a32] {\n  width: 100%;\n  padding: 0 15px;\n  height: 90px;\n}\n.time-picker label[data-v-565a2a32] {\n    color: #0D79F2;\n    font-weight: 700;\n    font-size: 10px;\n    line-height: 10px;\n    display: block;\n    margin-bottom: 10px;\n}\n.time-picker .inline[data-v-565a2a32] {\n    display: inline-block;\n    vertical-align: middle;\n    float: left;\n    text-align: center;\n}\n.time-picker .selection[data-v-565a2a32] {\n    text-align: center;\n    width: 30%;\n}\n.time-picker .selection .value[data-v-565a2a32] {\n      font-size: 22px;\n      font-weight: 700;\n      color: #555;\n}\n.time-picker .selection .control[data-v-565a2a32] {\n      font-size: 12px;\n      color: #0D79F2;\n      cursor: pointer;\n      width: 100%;\n}\n.time-picker .separator[data-v-565a2a32] {\n    line-height: 69px;\n    height: 69px;\n    color: #777;\n    padding: 0 5px;\n    width: 5%;\n}\n.field-input[data-v-565a2a32] {\n  padding: 5px 15px 15px;\n}\n.field-input label[data-v-565a2a32] {\n    color: #0D79F2;\n    font-weight: 700;\n    font-size: 10px;\n    line-height: 10px;\n}\n.field-input select[data-v-565a2a32] {\n    font-size: 14px;\n    height: 37px;\n    outline: 0;\n    padding: 7px 7px;\n    display: block;\n    border-color: rgba(0, 0, 0, 0.15);\n    background-color: #fff;\n    border-radius: 3px;\n}\n.controls[data-v-565a2a32] {\n  padding: 0 15px 15px;\n}\n.controls .padding-L[data-v-565a2a32] {\n    padding-left: 5px;\n}\n.controls .padding-R[data-v-565a2a32] {\n    padding-right: 5px;\n}\n.notice[data-v-565a2a32] {\n  padding: 9px 15px 24px;\n  text-align: center;\n  font-size: 14px;\n  line-height: 14px;\n  font-weight: 700;\n}\n.notice > div > *[data-v-565a2a32] {\n    vertical-align: middle;\n    display: inline-block;\n}\n.notice .success i[data-v-565a2a32] {\n    color: #26D97A;\n}\n.notice .fail i[data-v-565a2a32] {\n    color: #F25E0D;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'modal-container': true, show: _vm.show }},[_c('div',{staticClass:"modal-content"},[(_vm.gap !== null && _vm.driver !== null && _vm.sector !== null)?_c('div',{staticClass:"shift-form"},[_c('div',{staticClass:"form-title"},[_c('span',{staticClass:"highlight"},[_vm._v(_vm._s(_vm.gap.start.format('MMM DD')))]),_vm._v(" "),_c('span',[_vm._v("SHIFT FOR")]),_vm._v(" "),_c('span',{staticClass:"highlight"},[_vm._v(_vm._s(_vm.sector.name))])]),_vm._v(" "),_c('div',{staticClass:"time-picker"},[_c('label',[_vm._v("START TIME FOR THE SHIFT:")]),_vm._v(" "),_c('span',{staticClass:"inline selection"},[_c('div',{staticClass:"control",on:{"click":function($event){return _vm.setHour(true)}}},[_c('i',{staticClass:"fa fa-chevron-up"})]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.timeHour < 10 ? '0' + _vm.timeHour :  _vm.timeHour))]),_vm._v(" "),_c('div',{staticClass:"control",on:{"click":function($event){return _vm.setHour(false)}}},[_c('i',{staticClass:"fa fa-chevron-down"})])]),_vm._v(" "),_c('span',{staticClass:"inline separator"},[_vm._v(":")]),_vm._v(" "),_c('span',{staticClass:"inline selection"},[_c('div',{staticClass:"control",on:{"click":function($event){return _vm.setMinute(true)}}},[_c('i',{staticClass:"fa fa-chevron-up"})]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.timeMinute < 10 ? '0' + _vm.timeMinute : _vm.timeMinute))]),_vm._v(" "),_c('div',{staticClass:"control",on:{"click":function($event){return _vm.setMinute(false)}}},[_c('i',{staticClass:"fa fa-chevron-down"})])]),_vm._v(" "),_c('span',{staticClass:"inline separator"},[_vm._v(":")]),_vm._v(" "),_c('span',{staticClass:"inline selection"},[_c('div',{staticClass:"control",on:{"click":_vm.setAmPm}},[_c('i',{staticClass:"fa fa-chevron-up"})]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.timeAmPm))]),_vm._v(" "),_c('div',{staticClass:"control",on:{"click":_vm.setAmPm}},[_c('i',{staticClass:"fa fa-chevron-down"})])])]),_vm._v(" "),_c('div',{staticClass:"field-input shift-duration"},[_c('label',[_vm._v("DURATION FOR THE SHIFT:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.shiftDuration),expression:"shiftDuration",modifiers:{"number":true}}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.shiftDuration=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.durationRange),function(n){return _c('option',{domProps:{"value":n}},[_vm._v(_vm._s(n + (n > 1 ? ' hours' : ' hour')))])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.submitting),expression:"!submitting"}],staticClass:"row controls"},[_c('div',{staticClass:"small-4 columns padding-R"},[_c('a',{staticClass:"button cta xsmall block secondary",attrs:{"href":"javascript:;"},on:{"click":_vm.close}},[_vm._v("CANCEL")])]),_vm._v(" "),_c('div',{staticClass:"small-8 columns padding-L"},[_c('a',{staticClass:"button cta xsmall block",attrs:{"href":"javascript:;"},on:{"click":_vm.sendShift}},[_vm._v("SEND SHIFT TO "+_vm._s(_vm.driver.firstName))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.submitting),expression:"submitting"}],staticClass:"notice"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.done),expression:"!done"}]},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-lg"}),_vm._v(" "),_c('span',[_vm._v("Sending shift to "+_vm._s(_vm.driver.firstName)+"...")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.done && _vm.success),expression:"done && success"}],staticClass:"success"},[_c('i',{staticClass:"fa fa-check-circle fa-lg"}),_vm._v(" "),_c('span',[_vm._v("Sent shift to "+_vm._s(_vm.driver.firstName)+"!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.done && !_vm.success),expression:"done && !success"}],staticClass:"fail"},[_c('i',{staticClass:"fa fa-exclamation-triangle fa-lg"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.errorMessage))])])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectorList_vue__ = __webpack_require__(653);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_755c7672_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectorList_vue__ = __webpack_require__(2024);
function injectStyle (ssrContext) {
  __webpack_require__(2016)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-755c7672"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectorList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_755c7672_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectorList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2017);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("56f09ca3", content, true, {});

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.sectors[data-v-755c7672] {\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n}\n.sector-filters[data-v-755c7672] {\n  position: fixed;\n  width: 40%;\n  top: 0;\n  background-color: #fff;\n  z-index: 1;\n  padding: 5px 13px 13px;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n.sector-filters .report-btn[data-v-755c7672] {\n    margin-top: 25px;\n}\n.sector-items[data-v-755c7672] {\n  margin-top: 93px;\n  height: calc(100% - 80px);\n  overflow-y: auto;\n  overflow-x: auto;\n}\n.sector[data-v-755c7672] {\n  background-color: #fff;\n  font-size: 14px;\n  margin: 12px 12px;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  border-radius: 3px;\n}\n.sector .header[data-v-755c7672] {\n    position: relative;\n    cursor: pointer;\n    background-color: #fff;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n    padding: 10px 13px 12px;\n    cursor: pointer;\n}\n.sector .header[data-v-755c7672]:hover {\n      background-color: #f5f5f5;\n}\n.sector .header .expand-icon[data-v-755c7672] {\n      position: absolute;\n      top: 23px;\n      right: 13px;\n      color: #777;\n}\n.sector .header .alert-icon[data-v-755c7672] {\n      position: absolute;\n      top: 20px;\n      right: 40px;\n}\n.sector .header .alert-icon .fa-check-circle[data-v-755c7672] {\n        color: #26D97A;\n}\n.sector .header .alert-icon .fa-exclamation-circle[data-v-755c7672] {\n        color: #F25E0D;\n}\n.sector .sector-label > span[data-v-755c7672] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.sector .sector-label .sector-color[data-v-755c7672] {\n    width: 15px;\n    height: 15px;\n    margin-right: 3px;\n}\n.sector .sector-label .mainlabel[data-v-755c7672] {\n    font-size: 18px;\n    line-height: 18px;\n    font-weight: 700;\n    color: #333;\n}\n.sector .sublabel[data-v-755c7672] {\n    font-size: 12px;\n    line-height: 12px;\n    margin-top: 5px;\n    color: #555;\n}\n.sector-body[data-v-755c7672] {\n  height: 0;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  border-top: 1px solid rgba(0, 0, 0, 0.15);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.sector-body.show[data-v-755c7672] {\n    height: 526px;\n}\n.sector-loading[data-v-755c7672] {\n  position: fixed;\n  top: -100%;\n  right: 0;\n  opacity: 0;\n  z-index: 2;\n  background-color: rgba(0, 0, 0, 0.5);\n  width: 40%;\n  height: 100%;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.sector-loading.show[data-v-755c7672] {\n    top: 0;\n    opacity: 1;\n}\n.sector-loading .loading-label[data-v-755c7672] {\n    text-align: center;\n    color: #fff;\n    margin-top: 300px;\n}\n.sector-loading .loading-label div[data-v-755c7672] {\n      font-size: 18px;\n}\n.field-input label[data-v-755c7672] {\n  color: #0D79F2;\n  font-weight: 700;\n  font-size: 10px;\n}\n.field-input input[data-v-755c7672] {\n  margin-top: 0;\n  font-size: 14px;\n  padding: 7px 7px;\n}\n.field-input select[data-v-755c7672] {\n  font-size: 14px;\n  height: 37px;\n  outline: 0;\n  padding: 7px 7px;\n  display: block;\n  border-color: rgba(0, 0, 0, 0.15);\n  background-color: #fff;\n  border-radius: 3px;\n}\n.padding-L[data-v-755c7672] {\n  padding-left: 7px;\n}\n.padding-R[data-v-755c7672] {\n  padding-right: 7px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Coverage/SectorList.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;CAClB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,OAAO;EACP,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,kDAAkD;UAC1C,0CAA0C;CACnD;AACD;IACI,iBAAiB;CACpB;AACD;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;CAClB;AACD;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,iDAAiD;UACzC,yCAAyC;EACjD,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,8BAA8B;IAC9B,sBAAsB;IACtB,wBAAwB;IACxB,gBAAgB;CACnB;AACD;MACM,0BAA0B;CAC/B;AACD;MACM,mBAAmB;MACnB,UAAU;MACV,YAAY;MACZ,YAAY;CACjB;AACD;MACM,mBAAmB;MACnB,UAAU;MACV,YAAY;CACjB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,eAAe;CACtB;AACD;IACI,sBAAsB;IACtB,uBAAuB;CAC1B;AACD;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;CACrB;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;CACf;AACD;EACE,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,cAAc;CACjB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;CACrB;AACD;MACM,gBAAgB;CACrB;AACD;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;CACjB;AACD;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;CAClB;AACD;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB","file":"SectorList.vue","sourcesContent":["\n.sectors[data-v-755c7672] {\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n}\n.sector-filters[data-v-755c7672] {\n  position: fixed;\n  width: 40%;\n  top: 0;\n  background-color: #fff;\n  z-index: 1;\n  padding: 5px 13px 13px;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n.sector-filters .report-btn[data-v-755c7672] {\n    margin-top: 25px;\n}\n.sector-items[data-v-755c7672] {\n  margin-top: 93px;\n  height: calc(100% - 80px);\n  overflow-y: auto;\n  overflow-x: auto;\n}\n.sector[data-v-755c7672] {\n  background-color: #fff;\n  font-size: 14px;\n  margin: 12px 12px;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  border-radius: 3px;\n}\n.sector .header[data-v-755c7672] {\n    position: relative;\n    cursor: pointer;\n    background-color: #fff;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n    padding: 10px 13px 12px;\n    cursor: pointer;\n}\n.sector .header[data-v-755c7672]:hover {\n      background-color: #f5f5f5;\n}\n.sector .header .expand-icon[data-v-755c7672] {\n      position: absolute;\n      top: 23px;\n      right: 13px;\n      color: #777;\n}\n.sector .header .alert-icon[data-v-755c7672] {\n      position: absolute;\n      top: 20px;\n      right: 40px;\n}\n.sector .header .alert-icon .fa-check-circle[data-v-755c7672] {\n        color: #26D97A;\n}\n.sector .header .alert-icon .fa-exclamation-circle[data-v-755c7672] {\n        color: #F25E0D;\n}\n.sector .sector-label > span[data-v-755c7672] {\n    display: inline-block;\n    vertical-align: middle;\n}\n.sector .sector-label .sector-color[data-v-755c7672] {\n    width: 15px;\n    height: 15px;\n    margin-right: 3px;\n}\n.sector .sector-label .mainlabel[data-v-755c7672] {\n    font-size: 18px;\n    line-height: 18px;\n    font-weight: 700;\n    color: #333;\n}\n.sector .sublabel[data-v-755c7672] {\n    font-size: 12px;\n    line-height: 12px;\n    margin-top: 5px;\n    color: #555;\n}\n.sector-body[data-v-755c7672] {\n  height: 0;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  border-top: 1px solid rgba(0, 0, 0, 0.15);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.sector-body.show[data-v-755c7672] {\n    height: 526px;\n}\n.sector-loading[data-v-755c7672] {\n  position: fixed;\n  top: -100%;\n  right: 0;\n  opacity: 0;\n  z-index: 2;\n  background-color: rgba(0, 0, 0, 0.5);\n  width: 40%;\n  height: 100%;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.sector-loading.show[data-v-755c7672] {\n    top: 0;\n    opacity: 1;\n}\n.sector-loading .loading-label[data-v-755c7672] {\n    text-align: center;\n    color: #fff;\n    margin-top: 300px;\n}\n.sector-loading .loading-label div[data-v-755c7672] {\n      font-size: 18px;\n}\n.field-input label[data-v-755c7672] {\n  color: #0D79F2;\n  font-weight: 700;\n  font-size: 10px;\n}\n.field-input input[data-v-755c7672] {\n  margin-top: 0;\n  font-size: 14px;\n  padding: 7px 7px;\n}\n.field-input select[data-v-755c7672] {\n  font-size: 14px;\n  height: 37px;\n  outline: 0;\n  padding: 7px 7px;\n  display: block;\n  border-color: rgba(0, 0, 0, 0.15);\n  background-color: #fff;\n  border-radius: 3px;\n}\n.padding-L[data-v-755c7672] {\n  padding-left: 7px;\n}\n.padding-R[data-v-755c7672] {\n  padding-right: 7px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

/*!
  * vue-scrollto v2.20.0
  * (c) 2019 Randjelovic Igor
  * @license MIT
  */
(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global['vue-scrollto'] = factory());
}(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  /**
   * https://github.com/gre/bezier-easing
   * BezierEasing - use bezier curve for transition easing function
   * by Gaëtan Renaudeau 2014 - 2015 – MIT License
   */

  // These values are established by empiricism with tests (tradeoff: performance VS precision)
  var NEWTON_ITERATIONS = 4;
  var NEWTON_MIN_SLOPE = 0.001;
  var SUBDIVISION_PRECISION = 0.0000001;
  var SUBDIVISION_MAX_ITERATIONS = 10;

  var kSplineTableSize = 11;
  var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

  var float32ArraySupported = typeof Float32Array === 'function';

  function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
  function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
  function C (aA1)      { return 3.0 * aA1; }

  // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
  function calcBezier (aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT; }

  // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
  function getSlope (aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1); }

  function binarySubdivide (aX, aA, aB, mX1, mX2) {
    var currentX, currentT, i = 0;
    do {
      currentT = aA + (aB - aA) / 2.0;
      currentX = calcBezier(currentT, mX1, mX2) - aX;
      if (currentX > 0.0) {
        aB = currentT;
      } else {
        aA = currentT;
      }
    } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
    return currentT;
  }

  function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
   for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
     var currentSlope = getSlope(aGuessT, mX1, mX2);
     if (currentSlope === 0.0) {
       return aGuessT;
     }
     var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
     aGuessT -= currentX / currentSlope;
   }
   return aGuessT;
  }

  function LinearEasing (x) {
    return x;
  }

  var src = function bezier (mX1, mY1, mX2, mY2) {
    if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
      throw new Error('bezier x values must be in [0, 1] range');
    }

    if (mX1 === mY1 && mX2 === mY2) {
      return LinearEasing;
    }

    // Precompute samples table
    var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
    for (var i = 0; i < kSplineTableSize; ++i) {
      sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
    }

    function getTForX (aX) {
      var intervalStart = 0.0;
      var currentSample = 1;
      var lastSample = kSplineTableSize - 1;

      for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
        intervalStart += kSampleStepSize;
      }
      --currentSample;

      // Interpolate to provide an initial guess for t
      var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
      var guessForT = intervalStart + dist * kSampleStepSize;

      var initialSlope = getSlope(guessForT, mX1, mX2);
      if (initialSlope >= NEWTON_MIN_SLOPE) {
        return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
      } else if (initialSlope === 0.0) {
        return guessForT;
      } else {
        return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
      }
    }

    return function BezierEasing (x) {
      // Because JavaScript number are imprecise, we should guarantee the extremes are right.
      if (x === 0) {
        return 0;
      }
      if (x === 1) {
        return 1;
      }
      return calcBezier(getTForX(x), mY1, mY2);
    };
  };

  var easings = {
    ease: [0.25, 0.1, 0.25, 1.0],
    linear: [0.0, 0.0, 1.0, 1.0],
    'ease-in': [0.42, 0.0, 1.0, 1.0],
    'ease-out': [0.0, 0.0, 0.58, 1.0],
    'ease-in-out': [0.42, 0.0, 0.58, 1.0]
  };

  // https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
  var supportsPassive = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassive = true;
      }
    });
    window.addEventListener('test', null, opts);
  } catch (e) {}

  var _ = {
    $: function $(selector) {
      if (typeof selector !== 'string') {
        return selector;
      }

      return document.querySelector(selector);
    },
    on: function on(element, events, handler) {
      var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        passive: false
      };

      if (!(events instanceof Array)) {
        events = [events];
      }

      for (var i = 0; i < events.length; i++) {
        element.addEventListener(events[i], handler, supportsPassive ? opts : false);
      }
    },
    off: function off(element, events, handler) {
      if (!(events instanceof Array)) {
        events = [events];
      }

      for (var i = 0; i < events.length; i++) {
        element.removeEventListener(events[i], handler);
      }
    },
    cumulativeOffset: function cumulativeOffset(element) {
      var top = 0;
      var left = 0;

      do {
        top += element.offsetTop || 0;
        left += element.offsetLeft || 0;
        element = element.offsetParent;
      } while (element);

      return {
        top: top,
        left: left
      };
    }
  };

  var abortEvents = ['mousedown', 'wheel', 'DOMMouseScroll', 'mousewheel', 'keyup', 'touchmove'];
  var defaults = {
    container: 'body',
    duration: 500,
    lazy: true,
    easing: 'ease',
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
  };
  function setDefaults(options) {
    defaults = _extends({}, defaults, options);
  }
  var scroller = function scroller() {
    var element; // element to scroll to

    var container; // container to scroll

    var duration; // duration of the scrolling

    var easing; // easing to be used when scrolling

    var lazy; // checks the target position at each step

    var offset; // offset to be added (subtracted)

    var force; // force scroll, even if element is visible

    var cancelable; // indicates if user can cancel the scroll or not.

    var onStart; // callback when scrolling is started

    var onDone; // callback when scrolling is done

    var onCancel; // callback when scrolling is canceled / aborted

    var x; // scroll on x axis

    var y; // scroll on y axis

    var initialX; // initial X of container

    var targetX; // target X of container

    var initialY; // initial Y of container

    var targetY; // target Y of container

    var diffX; // difference

    var diffY; // difference

    var abort; // is scrolling aborted

    var cumulativeOffsetContainer;
    var cumulativeOffsetElement;
    var abortEv; // event that aborted scrolling

    var abortFn = function abortFn(e) {
      if (!cancelable) return;
      abortEv = e;
      abort = true;
    };

    var easingFn;
    var timeStart; // time when scrolling started

    var timeElapsed; // time elapsed since scrolling started

    var progress; // progress

    function scrollTop(container) {
      var scrollTop = container.scrollTop;

      if (container.tagName.toLowerCase() === 'body') {
        // in firefox body.scrollTop always returns 0
        // thus if we are trying to get scrollTop on a body tag
        // we need to get it from the documentElement
        scrollTop = scrollTop || document.documentElement.scrollTop;
      }

      return scrollTop;
    }

    function scrollLeft(container) {
      var scrollLeft = container.scrollLeft;

      if (container.tagName.toLowerCase() === 'body') {
        // in firefox body.scrollLeft always returns 0
        // thus if we are trying to get scrollLeft on a body tag
        // we need to get it from the documentElement
        scrollLeft = scrollLeft || document.documentElement.scrollLeft;
      }

      return scrollLeft;
    }

    function recalculateTargets() {
      cumulativeOffsetContainer = _.cumulativeOffset(container);
      cumulativeOffsetElement = _.cumulativeOffset(element);

      if (x) {
        targetX = cumulativeOffsetElement.left - cumulativeOffsetContainer.left + offset;
        diffX = targetX - initialX;
      }

      if (y) {
        targetY = cumulativeOffsetElement.top - cumulativeOffsetContainer.top + offset;
        diffY = targetY - initialY;
      }
    }

    function step(timestamp) {
      if (abort) return done();
      if (!timeStart) timeStart = timestamp; // When a site has a lot of media that can be loaded asynchronously,
      // the targetY/targetX may end up in the wrong place during scrolling.
      // So we will check this at each step

      if (!lazy) {
        recalculateTargets();
      }

      timeElapsed = timestamp - timeStart;
      progress = Math.min(timeElapsed / duration, 1);
      progress = easingFn(progress);
      topLeft(container, initialY + diffY * progress, initialX + diffX * progress);
      timeElapsed < duration ? window.requestAnimationFrame(step) : done();
    }

    function done() {
      if (!abort) topLeft(container, targetY, targetX);
      timeStart = false;

      _.off(container, abortEvents, abortFn);

      if (abort && onCancel) onCancel(abortEv, element);
      if (!abort && onDone) onDone(element);
    }

    function topLeft(element, top, left) {
      if (y) element.scrollTop = top;
      if (x) element.scrollLeft = left;

      if (element.tagName.toLowerCase() === 'body') {
        // in firefox body.scrollTop doesn't scroll the page
        // thus if we are trying to scrollTop on a body tag
        // we need to scroll on the documentElement
        if (y) document.documentElement.scrollTop = top;
        if (x) document.documentElement.scrollLeft = left;
      }
    }

    function scrollTo(target, _duration) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (_typeof(_duration) === 'object') {
        options = _duration;
      } else if (typeof _duration === 'number') {
        options.duration = _duration;
      }

      element = _.$(target);

      if (!element) {
        return console.warn('[vue-scrollto warn]: Trying to scroll to an element that is not on the page: ' + target);
      }

      container = _.$(options.container || defaults.container);
      duration = options.hasOwnProperty('duration') ? options.duration : defaults.duration;
      lazy = options.hasOwnProperty('lazy') ? options.lazy : defaults.lazy;
      easing = options.easing || defaults.easing;
      offset = options.hasOwnProperty('offset') ? options.offset : defaults.offset;
      force = options.hasOwnProperty('force') ? options.force !== false : defaults.force;
      cancelable = options.hasOwnProperty('cancelable') ? options.cancelable !== false : defaults.cancelable;
      onStart = options.onStart || defaults.onStart;
      onDone = options.onDone || defaults.onDone;
      onCancel = options.onCancel || defaults.onCancel;
      x = options.x === undefined ? defaults.x : options.x;
      y = options.y === undefined ? defaults.y : options.y;

      if (typeof offset === 'function') {
        offset = offset(element, container);
      }

      initialX = scrollLeft(container);
      initialY = scrollTop(container); // calculates cumulative offsets and targetX/Y + diffX/Y

      recalculateTargets();
      abort = false;

      if (!force) {
        // When the container is the default (body) we need to use the viewport
        // height, not the entire body height
        var containerHeight = container.tagName.toLowerCase() === 'body' ? document.documentElement.clientHeight || window.innerHeight : container.offsetHeight;
        var containerTop = initialY;
        var containerBottom = containerTop + containerHeight;
        var elementTop = targetY - offset;
        var elementBottom = elementTop + element.offsetHeight;

        if (elementTop >= containerTop && elementBottom <= containerBottom) {
          // make sure to call the onDone callback even if there is no need to
          // scroll the container. Fixes #111 (ref #118)
          if (onDone) onDone(element);
          return;
        }
      }

      if (onStart) onStart(element);

      if (!diffY && !diffX) {
        if (onDone) onDone(element);
        return;
      }

      if (typeof easing === 'string') {
        easing = easings[easing] || easings['ease'];
      }

      easingFn = src.apply(src, easing);

      _.on(container, abortEvents, abortFn, {
        passive: true
      });

      window.requestAnimationFrame(step);
      return function () {
        abortEv = null;
        abort = true;
      };
    }

    return scrollTo;
  };

  var _scroller = scroller();

  var bindings = []; // store binding data

  function deleteBinding(el) {
    for (var i = 0; i < bindings.length; ++i) {
      if (bindings[i].el === el) {
        bindings.splice(i, 1);
        return true;
      }
    }

    return false;
  }

  function findBinding(el) {
    for (var i = 0; i < bindings.length; ++i) {
      if (bindings[i].el === el) {
        return bindings[i];
      }
    }
  }

  function getBinding(el) {
    var binding = findBinding(el);

    if (binding) {
      return binding;
    }

    bindings.push(binding = {
      el: el,
      binding: {}
    });
    return binding;
  }

  function handleClick(e) {
    var ctx = getBinding(this).binding;
    if (!ctx.value) return;
    e.preventDefault();

    if (typeof ctx.value === 'string') {
      return _scroller(ctx.value);
    }

    _scroller(ctx.value.el || ctx.value.element, ctx.value);
  }

  var directiveHooks = {
    bind: function bind(el, binding) {
      getBinding(el).binding = binding;

      _.on(el, 'click', handleClick);
    },
    unbind: function unbind(el) {
      deleteBinding(el);

      _.off(el, 'click', handleClick);
    },
    update: function update(el, binding) {
      getBinding(el).binding = binding;
    }
  };
  var VueScrollTo = {
    bind: directiveHooks.bind,
    unbind: directiveHooks.unbind,
    update: directiveHooks.update,
    beforeMount: directiveHooks.bind,
    unmounted: directiveHooks.unbind,
    updated: directiveHooks.update,
    scrollTo: _scroller,
    bindings: bindings
  };

  var install = function install(Vue, options) {
    if (options) setDefaults(options);
    Vue.directive('scroll-to', VueScrollTo);
    var properties = Vue.config.globalProperties || Vue.prototype;
    properties.$scrollTo = VueScrollTo.scrollTo;
  };

  if (typeof window !== 'undefined' && window.Vue) {
    window.VueScrollTo = VueScrollTo;
    window.VueScrollTo.setDefaults = setDefaults;
    window.VueScrollTo.scroller = scroller;
    if (window.Vue.use) window.Vue.use(install);
  }

  VueScrollTo.install = install;

  return VueScrollTo;

})));


/***/ }),
/* 2019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__ = __webpack_require__(654);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a91d6c48_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__ = __webpack_require__(2022);
function injectStyle (ssrContext) {
  __webpack_require__(2020)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a91d6c48"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a91d6c48_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2021);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1a58e4cd", content, true, {});

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.coverage-calendar[data-v-a91d6c48] {\n  position: relative;\n}\n.calendar-loader[data-v-a91d6c48] {\n  text-align: center;\n  font-size: 18px;\n  font-weight: 700;\n  padding: 20px;\n  color: #555;\n}\n.calendar-loader .title[data-v-a91d6c48] {\n    margin-top: 5px;\n}\n.calendar-info[data-v-a91d6c48] {\n  position: absolute;\n  top: 0;\n  left: calc(100% + 10px);\n  width: 100%;\n  background-color: #fff;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.3);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.3);\n}\n.calendar-info.show[data-v-a91d6c48] {\n    left: 0;\n}\n.calendar-info .info-title[data-v-a91d6c48] {\n    position: relative;\n    text-align: center;\n    font-size: 14px;\n    line-height: 14px;\n    font-weight: 700;\n    color: #777;\n    padding: 15px;\n    background-color: #fff;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    cursor: pointer;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.calendar-info .info-title[data-v-a91d6c48]:hover {\n      background-color: #f9f9f9;\n}\n.calendar-info .info-title .back-icon[data-v-a91d6c48] {\n      position: absolute;\n      top: 15px;\n      left: 15px;\n}\n.service-type-overview[data-v-a91d6c48] {\n  padding: 15px 15px 15px;\n  max-height: 200px;\n  overflow-y: auto;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.service-type-overview .title[data-v-a91d6c48] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n}\n.service-type-overview table[data-v-a91d6c48] {\n    margin-top: 15px;\n    border-collapse: collapse;\n    width: 100%;\n    text-align: center;\n}\n.service-type-overview table thead[data-v-a91d6c48] {\n      color: #8DA0A9;\n      font-size: 12px;\n      border: 1px solid rgba(0, 0, 0, 0.3);\n      background-color: #f5f5f5;\n}\n.service-type-overview table thead th[data-v-a91d6c48] {\n        padding: 5px 10px;\n}\n.service-type-overview table tbody tr[data-v-a91d6c48] {\n      background-color: #fff;\n      border: 1px solid rgba(0, 0, 0, 0.3);\n      position: relative;\n}\n.service-type-overview table tbody tr td[data-v-a91d6c48] {\n        padding: 10px;\n        text-align: center;\n        font-size: 12px;\n        margin-bottom: 5px;\n}\n.shift-gaps[data-v-a91d6c48] {\n  padding: 0 15px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  height: 140px;\n  overflow: auto;\n}\n.shift-gaps .title[data-v-a91d6c48] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n    margin-top: 15px;\n}\n.shift-gaps .all-covered[data-v-a91d6c48] {\n    margin: 15px 0;\n    color: #26D97A;\n    font-weight: 700;\n}\n.shift-gaps .all-covered > *[data-v-a91d6c48] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.shift-gaps .shift-gap[data-v-a91d6c48] {\n    position: relative;\n    font-weight: 700;\n    color: #F25E0D;\n    padding: 15px 0;\n}\n.shift-gaps .shift-gap > *[data-v-a91d6c48] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.shift-gaps .shift-gap > .button[data-v-a91d6c48] {\n      position: absolute;\n      top: 13px;\n      right: 0;\n}\n.shift-gaps .shift-gap.ok[data-v-a91d6c48] {\n      color: #26D97A;\n}\n.shift-gaps .shift-gap .time-value[data-v-a91d6c48] {\n      color: #0D79F2;\n}\n.unassigned-rsvps[data-v-a91d6c48] {\n  padding: 0 15px;\n  height: 140px;\n  overflow: auto;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.unassigned-rsvps .title[data-v-a91d6c48] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n    margin-top: 15px;\n}\n.unassigned-rsvps .all-assigned[data-v-a91d6c48] {\n    margin: 15px 0;\n    color: #26D97A;\n    font-weight: 700;\n}\n.unassigned-rsvps .all-assigned > *[data-v-a91d6c48] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.unassigned-rsvps .rsvp[data-v-a91d6c48] {\n    position: relative;\n    font-weight: 700;\n    color: #F25E0D;\n    padding: 15px 0;\n}\n.unassigned-rsvps .rsvp > *[data-v-a91d6c48] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.unassigned-rsvps .rsvp > .button[data-v-a91d6c48] {\n      position: absolute;\n      top: 13px;\n      right: 0;\n}\n.unassigned-rsvps .rsvp.ok[data-v-a91d6c48] {\n      color: #26D97A;\n}\n.unassigned-rsvps .rsvp .time-value[data-v-a91d6c48] {\n      color: #0D79F2;\n}\n.calendar-days[data-v-a91d6c48] {\n  padding: 0 13px;\n}\n.op-calendar[data-v-a91d6c48] {\n  display: block;\n  width: 100%;\n  margin: 15px 0;\n}\n.op-calendar .op-calendar-title[data-v-a91d6c48] {\n    text-align: center;\n    font-weight: 700;\n    color: #0D79F2;\n    text-transform: uppercase;\n}\n.op-calendar .op-calendar-days[data-v-a91d6c48] {\n    display: block;\n    width: 100%;\n    margin-top: 15px;\n}\n.op-calendar .op-calendar-day[data-v-a91d6c48] {\n    width: calc(100%/7);\n    display: inline-block;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    border-right: 0;\n    background-color: #fff;\n    cursor: pointer;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.op-calendar .op-calendar-day[data-v-a91d6c48]:nth-child(7n+7), .op-calendar .op-calendar-day[data-v-a91d6c48]:last-child {\n      border-right: 1px solid rgba(0, 0, 0, 0.15);\n}\n.op-calendar .op-calendar-day[data-v-a91d6c48]:hover {\n      background-color: #f5f5f5;\n}\n.op-calendar .op-calendar-day.no-border[data-v-a91d6c48] {\n      border: 0;\n}\n.op-calendar .op-calendar-day .op-date[data-v-a91d6c48] {\n      color: #0D79F2;\n      font-size: 24px;\n      font-weight: 700;\n      line-height: 24px;\n      text-align: center;\n      margin-bottom: 5px;\n}\n.op-calendar .op-calendar-day .op-day[data-v-a91d6c48] {\n      color: #555;\n      text-align: center;\n      font-size: 12px;\n      line-height: 12px;\n      margin-bottom: 10px;\n}\n.op-calendar .op-calendar-day .op-icon[data-v-a91d6c48] {\n      text-align: center;\n      margin-top: 10px;\n      margin-bottom: 5px;\n}\n.op-calendar .op-calendar-day .op-icon .fa-check-circle[data-v-a91d6c48] {\n        color: #26D97A;\n}\n.op-calendar .op-calendar-day .op-icon .fa-exclamation-circle[data-v-a91d6c48] {\n        color: #F25E0D;\n}\n.service-label[data-v-a91d6c48] {\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 12px;\n  display: inline-block;\n  margin-top: 2px;\n}\n.service-label.shared[data-v-a91d6c48] {\n    background: #f38d56;\n}\n.service-label.opoli[data-v-a91d6c48] {\n    background: #26D97A;\n}\n.service-label.black[data-v-a91d6c48] {\n    background: #777;\n}\n.service-label.SUV[data-v-a91d6c48], .service-label.suv[data-v-a91d6c48] {\n    background: #dc3168;\n}\n.service-label.shuttle[data-v-a91d6c48] {\n    background: #6dabc3;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Coverage/Calendar.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,YAAY;CACb;AACD;IACI,gBAAgB;CACnB;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,wBAAwB;EACxB,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,kDAAkD;UAC1C,0CAA0C;CACnD;AACD;IACI,QAAQ;CACX;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,cAAc;IACd,uBAAuB;IACvB,6CAA6C;IAC7C,gBAAgB;IAChB,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;MACM,0BAA0B;CAC/B;AACD;MACM,mBAAmB;MACnB,UAAU;MACV,WAAW;CAChB;AACD;EACE,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,6CAA6C;CAC9C;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,YAAY;IACZ,mBAAmB;CACtB;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,qCAAqC;MACrC,0BAA0B;CAC/B;AACD;QACQ,kBAAkB;CACzB;AACD;MACM,uBAAuB;MACvB,qCAAqC;MACrC,mBAAmB;CACxB;AACD;QACQ,cAAc;QACd,mBAAmB;QACnB,gBAAgB;QAChB,mBAAmB;CAC1B;AACD;EACE,gBAAgB;EAChB,6CAA6C;EAC7C,cAAc;EACd,eAAe;CAChB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;CACpB;AACD;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;CACpB;AACD;MACM,sBAAsB;MACtB,uBAAuB;CAC5B;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;CACnB;AACD;MACM,sBAAsB;MACtB,uBAAuB;CAC5B;AACD;MACM,mBAAmB;MACnB,UAAU;MACV,SAAS;CACd;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,6CAA6C;CAC9C;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;CACpB;AACD;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;CACpB;AACD;MACM,sBAAsB;MACtB,uBAAuB;CAC5B;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;CACnB;AACD;MACM,sBAAsB;MACtB,uBAAuB;CAC5B;AACD;MACM,mBAAmB;MACnB,UAAU;MACV,SAAS;CACd;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,eAAe;EACf,YAAY;EACZ,eAAe;CAChB;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,0BAA0B;CAC7B;AACD;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;CACpB;AACD;IACI,oBAAoB;IACpB,sBAAsB;IACtB,sCAAsC;IACtC,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;MACM,4CAA4C;CACjD;AACD;MACM,0BAA0B;CAC/B;AACD;MACM,UAAU;CACf;AACD;MACM,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;MAClB,mBAAmB;MACnB,mBAAmB;CACxB;AACD;MACM,YAAY;MACZ,mBAAmB;MACnB,gBAAgB;MAChB,kBAAkB;MAClB,oBAAoB;CACzB;AACD;MACM,mBAAmB;MACnB,iBAAiB;MACjB,mBAAmB;CACxB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,eAAe;CACtB;AACD;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;CACjB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB","file":"Calendar.vue","sourcesContent":["\n.coverage-calendar[data-v-a91d6c48] {\n  position: relative;\n}\n.calendar-loader[data-v-a91d6c48] {\n  text-align: center;\n  font-size: 18px;\n  font-weight: 700;\n  padding: 20px;\n  color: #555;\n}\n.calendar-loader .title[data-v-a91d6c48] {\n    margin-top: 5px;\n}\n.calendar-info[data-v-a91d6c48] {\n  position: absolute;\n  top: 0;\n  left: calc(100% + 10px);\n  width: 100%;\n  background-color: #fff;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n  -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, 0.3);\n          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.3);\n}\n.calendar-info.show[data-v-a91d6c48] {\n    left: 0;\n}\n.calendar-info .info-title[data-v-a91d6c48] {\n    position: relative;\n    text-align: center;\n    font-size: 14px;\n    line-height: 14px;\n    font-weight: 700;\n    color: #777;\n    padding: 15px;\n    background-color: #fff;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    cursor: pointer;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.calendar-info .info-title[data-v-a91d6c48]:hover {\n      background-color: #f9f9f9;\n}\n.calendar-info .info-title .back-icon[data-v-a91d6c48] {\n      position: absolute;\n      top: 15px;\n      left: 15px;\n}\n.service-type-overview[data-v-a91d6c48] {\n  padding: 15px 15px 15px;\n  max-height: 200px;\n  overflow-y: auto;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.service-type-overview .title[data-v-a91d6c48] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n}\n.service-type-overview table[data-v-a91d6c48] {\n    margin-top: 15px;\n    border-collapse: collapse;\n    width: 100%;\n    text-align: center;\n}\n.service-type-overview table thead[data-v-a91d6c48] {\n      color: #8DA0A9;\n      font-size: 12px;\n      border: 1px solid rgba(0, 0, 0, 0.3);\n      background-color: #f5f5f5;\n}\n.service-type-overview table thead th[data-v-a91d6c48] {\n        padding: 5px 10px;\n}\n.service-type-overview table tbody tr[data-v-a91d6c48] {\n      background-color: #fff;\n      border: 1px solid rgba(0, 0, 0, 0.3);\n      position: relative;\n}\n.service-type-overview table tbody tr td[data-v-a91d6c48] {\n        padding: 10px;\n        text-align: center;\n        font-size: 12px;\n        margin-bottom: 5px;\n}\n.shift-gaps[data-v-a91d6c48] {\n  padding: 0 15px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  height: 140px;\n  overflow: auto;\n}\n.shift-gaps .title[data-v-a91d6c48] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n    margin-top: 15px;\n}\n.shift-gaps .all-covered[data-v-a91d6c48] {\n    margin: 15px 0;\n    color: #26D97A;\n    font-weight: 700;\n}\n.shift-gaps .all-covered > *[data-v-a91d6c48] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.shift-gaps .shift-gap[data-v-a91d6c48] {\n    position: relative;\n    font-weight: 700;\n    color: #F25E0D;\n    padding: 15px 0;\n}\n.shift-gaps .shift-gap > *[data-v-a91d6c48] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.shift-gaps .shift-gap > .button[data-v-a91d6c48] {\n      position: absolute;\n      top: 13px;\n      right: 0;\n}\n.shift-gaps .shift-gap.ok[data-v-a91d6c48] {\n      color: #26D97A;\n}\n.shift-gaps .shift-gap .time-value[data-v-a91d6c48] {\n      color: #0D79F2;\n}\n.unassigned-rsvps[data-v-a91d6c48] {\n  padding: 0 15px;\n  height: 140px;\n  overflow: auto;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.unassigned-rsvps .title[data-v-a91d6c48] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n    margin-top: 15px;\n}\n.unassigned-rsvps .all-assigned[data-v-a91d6c48] {\n    margin: 15px 0;\n    color: #26D97A;\n    font-weight: 700;\n}\n.unassigned-rsvps .all-assigned > *[data-v-a91d6c48] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.unassigned-rsvps .rsvp[data-v-a91d6c48] {\n    position: relative;\n    font-weight: 700;\n    color: #F25E0D;\n    padding: 15px 0;\n}\n.unassigned-rsvps .rsvp > *[data-v-a91d6c48] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.unassigned-rsvps .rsvp > .button[data-v-a91d6c48] {\n      position: absolute;\n      top: 13px;\n      right: 0;\n}\n.unassigned-rsvps .rsvp.ok[data-v-a91d6c48] {\n      color: #26D97A;\n}\n.unassigned-rsvps .rsvp .time-value[data-v-a91d6c48] {\n      color: #0D79F2;\n}\n.calendar-days[data-v-a91d6c48] {\n  padding: 0 13px;\n}\n.op-calendar[data-v-a91d6c48] {\n  display: block;\n  width: 100%;\n  margin: 15px 0;\n}\n.op-calendar .op-calendar-title[data-v-a91d6c48] {\n    text-align: center;\n    font-weight: 700;\n    color: #0D79F2;\n    text-transform: uppercase;\n}\n.op-calendar .op-calendar-days[data-v-a91d6c48] {\n    display: block;\n    width: 100%;\n    margin-top: 15px;\n}\n.op-calendar .op-calendar-day[data-v-a91d6c48] {\n    width: calc(100%/7);\n    display: inline-block;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    border-right: 0;\n    background-color: #fff;\n    cursor: pointer;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.op-calendar .op-calendar-day[data-v-a91d6c48]:nth-child(7n+7), .op-calendar .op-calendar-day[data-v-a91d6c48]:last-child {\n      border-right: 1px solid rgba(0, 0, 0, 0.15);\n}\n.op-calendar .op-calendar-day[data-v-a91d6c48]:hover {\n      background-color: #f5f5f5;\n}\n.op-calendar .op-calendar-day.no-border[data-v-a91d6c48] {\n      border: 0;\n}\n.op-calendar .op-calendar-day .op-date[data-v-a91d6c48] {\n      color: #0D79F2;\n      font-size: 24px;\n      font-weight: 700;\n      line-height: 24px;\n      text-align: center;\n      margin-bottom: 5px;\n}\n.op-calendar .op-calendar-day .op-day[data-v-a91d6c48] {\n      color: #555;\n      text-align: center;\n      font-size: 12px;\n      line-height: 12px;\n      margin-bottom: 10px;\n}\n.op-calendar .op-calendar-day .op-icon[data-v-a91d6c48] {\n      text-align: center;\n      margin-top: 10px;\n      margin-bottom: 5px;\n}\n.op-calendar .op-calendar-day .op-icon .fa-check-circle[data-v-a91d6c48] {\n        color: #26D97A;\n}\n.op-calendar .op-calendar-day .op-icon .fa-exclamation-circle[data-v-a91d6c48] {\n        color: #F25E0D;\n}\n.service-label[data-v-a91d6c48] {\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  font-weight: 700;\n  font-size: 12px;\n  display: inline-block;\n  margin-top: 2px;\n}\n.service-label.shared[data-v-a91d6c48] {\n    background: #f38d56;\n}\n.service-label.opoli[data-v-a91d6c48] {\n    background: #26D97A;\n}\n.service-label.black[data-v-a91d6c48] {\n    background: #777;\n}\n.service-label.SUV[data-v-a91d6c48], .service-label.suv[data-v-a91d6c48] {\n    background: #dc3168;\n}\n.service-label.shuttle[data-v-a91d6c48] {\n    background: #6dabc3;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coverage-calendar",attrs:{"div":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.initializingCalendar && _vm.serviceLoading),expression:"initializingCalendar && serviceLoading"}],staticClass:"calendar-loader"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Initializing Calendar...")])]),_vm._v(" "),_c('div',{class:{ 'calendar-info': true, show: !_vm.serviceLoading }},[(_vm.shownInfo !== null)?_c('div',{staticClass:"info-title"},[_c('span',[_vm._v(_vm._s(_vm.shownInfo.date.format('DD MMMM, dddd')))])]):_vm._e(),_vm._v(" "),(_vm.shownInfo !== null)?_c('div',{staticClass:"info-content"},[_c('div',{staticClass:"service-type-overview"},[_c('div',{staticClass:"title"},[_vm._v("SERVICES SUMMARY")]),_vm._v(" "),_c('table',[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.servicesSorted),function(service){return (service.enabled)?_c('tr',[_c('td',[_c('span',{staticClass:"service-label",style:({'background': service.color})},[_vm._v("\n                  ["+_vm._s(_vm.getBrandCode(service.brandId))+"] "+_vm._s(service.name)+"\n                ")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getOpenCount(service.id)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getAvailableCount(service.id)))])]):_vm._e()}),0)])]),_vm._v(" "),_c('div',{staticClass:"shift-gaps"},[_c('div',{staticClass:"title"},[_vm._v("DRIVER AVAILABILITY")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shownInfo.shiftGaps.length <= 0 && _vm.shownInfo.workDrivers.length <= 0),expression:"shownInfo.shiftGaps.length <= 0 && shownInfo.workDrivers.length <= 0"}],staticClass:"all-covered"},[_c('i',{staticClass:"fa fa-check-circle"}),_vm._v(" "),_c('span',[_vm._v("No Driver shifts for this day.")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shownInfo.workDrivers.length <= 0),expression:"shownInfo.workDrivers.length <= 0"}],staticClass:"shift-gap"},[_c('i',{staticClass:"fa fa-exclamation-circle"}),_vm._v(" "),_c('span',[_vm._v("No available drivers for this day.")])]),_vm._v(" "),_vm._l((_vm.shownInfo.workDrivers),function(driver,index){return _c('div',{staticClass:"shift-gap ok"},[_c('i',{staticClass:"fa fa-check-circle"}),_vm._v(" "),_c('span',[_vm._v("Driver")]),_vm._v(" "),_c('a',{attrs:{"href":'/#/provider/' + driver.driverId,"target":"_blank"}},[_vm._v(_vm._s(driver.firstName)+" "+_vm._s(driver.lastName))]),_vm._v(" "),_c('span',[_vm._v("from")]),_vm._v(" "),(_vm.shownInfo.date.format('MM/DD') !== driver.shiftStart.format('MM/DD'))?_c('span',{staticClass:"time-value"},[_vm._v("(-1)")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"time-value"},[_vm._v(_vm._s(driver.shiftStart.format('hh:mmA')))]),_vm._v(" "),_c('span',[_vm._v("to")]),_vm._v(" "),_c('span',{staticClass:"time-value"},[_vm._v(_vm._s(driver.shiftEnd.format('hh:mmA')))]),_vm._v(" "),(_vm.shownInfo.date.format('MM/DD') !== driver.shiftEnd.format('MM/DD'))?_c('span',{staticClass:"time-value"},[_vm._v("(+1)")]):_vm._e()])})],2),_vm._v(" "),_c('div',{staticClass:"unassigned-rsvps"},[_c('div',{staticClass:"title"},[_vm._v("RESERVATIONS")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shownInfo.availableRsvp.length <= 0 && _vm.shownInfo.assignedRsvp.length <= 0),expression:"shownInfo.availableRsvp.length <= 0 && shownInfo.assignedRsvp.length <= 0"}],staticClass:"all-assigned"},[_c('i',{staticClass:"fa fa-check-circle"}),_vm._v(" "),_c('span',[_vm._v("No reservations for this day.")])]),_vm._v(" "),_vm._l((_vm.shownInfo.availableRsvp),function(rsvp,index){return _c('div',{staticClass:"rsvp"},[_c('i',{staticClass:"fa fa-exclamation-circle"}),_vm._v(" "),(rsvp.packageID !== null)?_c('a',{attrs:{"target":"_blank","href":'/#/package/' + rsvp.packageID}},[_c('i',{staticClass:"fas fa-box"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(rsvp.packageID))])]):_c('a',{attrs:{"target":"_blank","href":'/#/reservation/' + rsvp.rsvpId}},[_vm._v(_vm._s(rsvp.rsvpId))]),_vm._v(" "),_c('span',[_vm._v("pickup at")]),_vm._v(" "),(rsvp.packageID !== null)?_c('span',{staticClass:"time-value"},[_vm._v(_vm._s(rsvp.firstPickup.format('hh:mmA')))]):_c('span',{staticClass:"time-value"},[_vm._v(_vm._s(rsvp.pickupTime.format('hh:mmA')))]),_vm._v(" "),_c('a',{class:{ 'button xsmall': true, disabled: _vm.disabledButtons },attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.findRsvpDrivers(rsvp)}}},[_vm._v("FIND DRIVERS")])])}),_vm._v(" "),_vm._l((_vm.shownInfo.assignedRsvp),function(rsvp,index){return _c('div',{staticClass:"rsvp ok"},[_c('i',{staticClass:"fa fa-check-circle"}),_vm._v(" "),(rsvp.packageID !== null)?_c('a',{attrs:{"target":"_blank","href":'/#/package/' + rsvp.packageID}},[_c('i',{staticClass:"fas fa-box"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(rsvp.packageID))])]):_c('a',{attrs:{"target":"_blank","href":'/#/reservation/' + rsvp.rsvpId}},[_vm._v(_vm._s(rsvp.rsvpId))]),_vm._v(" "),_c('span',[_vm._v("pickup at")]),_vm._v(" "),(rsvp.packageID !== null)?_c('span',{staticClass:"time-value"},[_vm._v(_vm._s(rsvp.firstPickup.format('hh:mmA')))]):_c('span',{staticClass:"time-value"},[_vm._v(_vm._s(rsvp.pickupTime.format('hh:mmA')))]),_vm._v(" "),_c('span',[_vm._v("assigned to")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":'/#/provider/' + rsvp.driverId}},[_vm._v(_vm._s(rsvp.firstName)+" "+_vm._s(rsvp.lastName))])])})],2)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Service Type")]),_vm._v(" "),_c('th',[_vm._v("Open Business")]),_vm._v(" "),_c('th',[_vm._v("Available Drivers")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_xlsx_populate_browser_xlsx_populate__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_xlsx_populate_browser_xlsx_populate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_xlsx_populate_browser_xlsx_populate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



/* harmony default export */ __webpack_exports__["a"] = ({
  generateReport: function generateReport(VueApp, done) {
    var self = this;
    var sectors = VueApp.$store.state.coverage.report.sectors;
    // console.log('GENERATE REPORT MODULE', sectors)

    var masterList = [];
    __WEBPACK_IMPORTED_MODULE_0_xlsx_populate_browser_xlsx_populate__["fromBlankAsync"]().then(function (workbook) {
      for (var i = 0; i < sectors.length; i++) {
        var sector = sectors[i];
        var sheetName = sector.name.replace(/\//g, '-').substring(0, 31);
        workbook.addSheet(sheetName);
        masterList.push(self.renderDaysAndTime(workbook, sheetName, sector));
      }

      workbook.deleteSheet('Sheet1');
      self.renderMasterList(workbook, masterList);

      workbook.outputAsync().then(function (blob) {
        var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(VueApp.$store.state.coverage.filters.startDate);
        var end = __WEBPACK_IMPORTED_MODULE_1_moment___default()(VueApp.$store.state.coverage.filters.endDate);
        var filename = 'CoverageReport_' + start.format('MMDDYYYY') + '_' + end.format('MMDDYYYY');
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // If IE, you must uses a different method.
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }
        done();
      });
    });
  },
  renderMasterList: function renderMasterList(workbook, masterList) {
    var font = 'Calibri';
    var sheets = workbook.sheets();
    var sheetName = 'Master List';
    workbook.addSheet(sheetName, sheets[0]);

    // render dates
    var cellNumber = 2;
    var totals = [];
    var dates = masterList[0].days;
    for (var i = 0; i < dates.length; i++) {
      var day = dates[i];
      workbook.sheet(sheetName).row(1).cell(cellNumber).style({
        fontColor: 'FFFFFF', fontSize: 11, fontFamily: font, bold: true,
        verticalAlignment: 'center', horizontalAlignment: 'center',
        fill: { color: '59C198' },
        border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
      }).value(day.date.format('MM/DD/YYYY'));
      totals.push({
        openBusiness: 0,
        availableDrivers: 0
      });
      cellNumber++;
    }

    // render list
    var rowNumber = 2;
    var openFill = 'CEDEEF';
    var availableFill = 'CEDEEF';
    workbook.sheet(sheetName).column('A').width(40);
    for (var _i = 0; _i < masterList.length; _i++) {
      var sector = masterList[_i];

      workbook.sheet(sheetName).cell('A' + rowNumber).style({
        fontColor: 'FFFFFF', fontSize: 11, fontFamily: font, bold: true,
        verticalAlignment: 'center', horizontalAlignment: 'center',
        fill: { color: '4A85C9' },
        border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
      }).value(sector.name);
      workbook.sheet(sheetName).cell('A' + (rowNumber + 1)).style({
        fontColor: '333333', fontSize: 11, fontFamily: font, bold: true,
        verticalAlignment: 'center', horizontalAlignment: 'right',
        fill: { color: openFill },
        border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
      }).value('Open Business');
      workbook.sheet(sheetName).cell('A' + (rowNumber + 2)).style({
        fontColor: '333333', fontSize: 11, fontFamily: font, bold: true,
        verticalAlignment: 'center', horizontalAlignment: 'right',
        fill: { color: availableFill },
        border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
      }).value('Available Drivers');

      var days = sector.days;
      cellNumber = 2;
      for (var j = 0; j < days.length; j++) {
        var _day = days[j];

        workbook.sheet(sheetName).row(rowNumber).cell(cellNumber).style({
          fill: { color: '4A85C9' },
          border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
        }).value('');
        workbook.sheet(sheetName).row(rowNumber + 1).cell(cellNumber).style({
          fontColor: '333333', fontSize: 11, bold: true,
          verticalAlignment: 'center', horizontalAlignment: 'center',
          fill: { color: openFill },
          border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
        }).value(_day.openBusiness);
        workbook.sheet(sheetName).row(rowNumber + 2).cell(cellNumber).style({
          fontColor: '333333', fontSize: 11, bold: true,
          verticalAlignment: 'center', horizontalAlignment: 'center',
          fill: { color: availableFill },
          border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
        }).value(_day.availableDrivers);

        totals[j].openBusiness += _day.openBusiness;
        totals[j].availableDrivers += _day.availableDrivers;
        cellNumber++;
      }

      rowNumber = rowNumber + 3;
    }

    // render totals
    var totalOpenRow = rowNumber + 1;
    var totalAvailableRow = rowNumber + 2;
    workbook.sheet(sheetName).cell('A' + totalOpenRow).style({
      fontColor: 'FFFFFF', fontSize: 11, fontFamily: font, bold: true,
      verticalAlignment: 'center', horizontalAlignment: 'right',
      fill: { color: 'CC042A' },
      border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
    }).value('Total Open Business');
    workbook.sheet(sheetName).cell('A' + totalAvailableRow).style({
      fontColor: 'FFFFFF', fontSize: 11, fontFamily: font, bold: true,
      verticalAlignment: 'center', horizontalAlignment: 'right',
      fill: { color: '27C664' },
      border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
    }).value('Total Available Drivers');

    var totalOpenFill = 'F9CFD9';
    var totalAvailableFill = 'D6F7E2';
    cellNumber = 2;
    for (var _i2 = 0; _i2 < totals.length; _i2++) {
      var total = totals[_i2];
      workbook.sheet(sheetName).row(totalOpenRow).cell(cellNumber).style({
        fontColor: '333333', fontSize: 11, bold: true,
        verticalAlignment: 'center', horizontalAlignment: 'center',
        fill: { color: totalOpenFill },
        border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
      }).value(total.openBusiness);
      workbook.sheet(sheetName).row(totalAvailableRow).cell(cellNumber).style({
        fontColor: '333333', fontSize: 11, bold: true,
        verticalAlignment: 'center', horizontalAlignment: 'center',
        fill: { color: totalAvailableFill },
        border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
      }).value(total.availableDrivers);
      cellNumber++;
    }
  },
  renderDaysAndTime: function renderDaysAndTime(workbook, sheetName, sector) {
    var sectorData = sector.data;
    var font = 'Calibri';

    var master = {
      name: sector.name,
      days: []
      // render dates
    };var cellNumber = 2;
    var homeDrivers = {};
    for (var prop in sectorData) {
      if (!sectorData.hasOwnProperty(prop)) {
        continue;
      }

      var days = sectorData[prop].days;
      for (var i = 0; i < days.length; i++) {
        var day = days[i];
        if (day === null) {
          continue;
        }
        var dayStart = day.date.unix();
        var dayEnd = __WEBPACK_IMPORTED_MODULE_1_moment___default()(day.date.format('MM/DD/YYYY') + ' 11:59:59PM', 'MM/DD/YYYY hh:mm:ssA').unix();
        workbook.sheet(sheetName).row(1).cell(cellNumber).style({
          fontColor: 'FFFFFF', fontSize: 11, fontFamily: font, bold: true,
          verticalAlignment: 'center', horizontalAlignment: 'center',
          fill: { color: '59C198' },
          border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
        }).value(day.date.format('MM/DD/YYYY'));

        workbook.sheet(sheetName).column(cellNumber).width(40);

        // open rsvp
        var openBusiness = 0;
        for (var j = 0; j < day.availableRsvp.length; j++) {
          var rsvp = day.availableRsvp[j];
          var pickupHour = parseInt(rsvp.pickupTime.format('HH')) + 2;
          if (rsvp.packageID !== null) {
            pickupHour = parseInt(rsvp.firstPickup.format('HH')) + 2;
          }

          var textValue = 'Open ' + (rsvp.packageID !== null ? 'Package ' + rsvp.packageID : 'Reservation ' + rsvp.rsvpId) + ' at ' + rsvp.pickupTime.format('hh:mmA');
          workbook.sheet(sheetName).row(pickupHour).cell(cellNumber).style({
            fontColor: '333333', fontSize: 11, bold: true,
            verticalAlignment: 'center', horizontalAlignment: 'left'
          }).value(textValue);
          openBusiness++;
        }
        workbook.sheet(sheetName).row(27).cell(cellNumber).style({
          fontColor: '333333', fontSize: 11, bold: true,
          verticalAlignment: 'center', horizontalAlignment: 'left',
          fill: { color: 'EECDCD' },
          border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
        }).value(openBusiness.toString());
        // open rsvp end

        // open availability
        var gapText = null;
        for (var _j = 0; _j < day.shiftGaps.length; _j++) {
          var gap = day.shiftGaps[_j];
          var gapStr = gap.start.format('hh:mmA') + ' - ' + gap.end.format('hh:mmA');
          if (gapText !== null) {
            gapText = gapText + '\n';
          } else {
            gapText = '';
          }
          gapText = gapText + gapStr;
        }
        workbook.sheet(sheetName).row(28).cell(cellNumber).style({
          fontColor: '333333', fontSize: 11, bold: true,
          verticalAlignment: 'center', horizontalAlignment: 'left',
          fill: { color: 'EECDCD' },
          border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
        }).value(gapText);
        // open availability end

        // covered rsvp
        var coveredBusiness = 0;
        for (var _j2 = 0; _j2 < day.assignedRsvp.length; _j2++) {
          var _rsvp = day.assignedRsvp[_j2];
          var _pickupHour = parseInt(_rsvp.pickupTime.format('HH')) + 2;
          if (_rsvp.packageID !== null) {
            _pickupHour = parseInt(_rsvp.firstPickup.format('HH')) + 2;
          }

          var existingValue = workbook.sheet(sheetName).row(_pickupHour).cell(cellNumber).value();

          var _textValue = 'Assigned ' + (_rsvp.packageID !== null ? 'Package ' + _rsvp.packageID : 'Reservation ' + _rsvp.rsvpId) + ' at ' + _rsvp.pickupTime.format('hh:mmA');

          if (existingValue !== null && typeof existingValue !== 'undefined') {
            _textValue = existingValue + '\n' + _textValue;
          }
          workbook.sheet(sheetName).row(_pickupHour).cell(cellNumber).style({
            fontColor: '333333', fontSize: 11, bold: true,
            verticalAlignment: 'center', horizontalAlignment: 'left'
          }).value(_textValue);
          coveredBusiness++;
        }
        workbook.sheet(sheetName).row(29).cell(cellNumber).style({
          fontColor: '333333', fontSize: 11, bold: true,
          verticalAlignment: 'center', horizontalAlignment: 'left',
          fill: { color: 'DCE9D5' },
          border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
        }).value(coveredBusiness.toString());
        // covered rsvp end

        // available drivers
        var availableDrivers = 0;
        for (var _j3 = 0; _j3 < day.workDrivers.length; _j3++) {
          var driver = day.workDrivers[_j3];
          var start = driver.shiftStart;
          var end = driver.shiftEnd;

          var startHour = parseInt(start.format('HH')) + 2;
          var endHour = parseInt(end.format('HH')) + 2;

          var existingStartValue = workbook.sheet(sheetName).row(startHour).cell(cellNumber).value();
          var startValue = driver.driverId + ' - ' + driver.firstName + ' ' + driver.lastName + ' starts at ' + start.format('hh:mmA');
          if (existingStartValue !== null && typeof existingStartValue !== 'undefined') {
            startValue = existingStartValue + '\n' + startValue;
          }
          workbook.sheet(sheetName).row(startHour).cell(cellNumber).style({
            fontColor: '333333', fontSize: 11, bold: true,
            verticalAlignment: 'center', horizontalAlignment: 'left'
          }).value(startValue);

          var existingEndValue = workbook.sheet(sheetName).row(endHour).cell(cellNumber).value();
          var endValue = driver.driverId + ' - ' + driver.firstName + ' ' + driver.lastName + ' ends at ' + end.format('hh:mmA');
          if (existingEndValue !== null && typeof existingEndValue !== 'undefined') {
            endValue = existingEndValue + '\n' + endValue;
          }
          workbook.sheet(sheetName).row(endHour).cell(cellNumber).style({
            fontColor: '333333', fontSize: 11, bold: true,
            verticalAlignment: 'center', horizontalAlignment: 'left'
          }).value(endValue);
          // TODO: render drivers on calendar
          availableDrivers++;
        }
        workbook.sheet(sheetName).row(30).cell(cellNumber).style({
          fontColor: '333333', fontSize: 11, bold: true,
          verticalAlignment: 'center', horizontalAlignment: 'left',
          fill: { color: 'DCE9D5' },
          border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
        }).value(availableDrivers.toString());
        // available drivers end

        // home drivers
        for (var _j4 = 0; _j4 < day.homeDrivers.length; _j4++) {
          var _driver = day.homeDrivers[_j4];
          homeDrivers[_driver.driverId] = {
            name: _driver.firstName + ' ' + _driver.lastName
          };
        }
        // home drivers end

        master.days.push({
          date: day.date,
          openBusiness: openBusiness,
          availableDrivers: availableDrivers
        });
        cellNumber++;
      }
    }

    // render times
    var timeStyle = {
      fontColor: 'FFFFFF', fontSize: 11, fontFamily: font, bold: true,
      verticalAlignment: 'center', horizontalAlignment: 'right',
      fill: { color: '4A85C9' },
      border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
    };

    workbook.sheet(sheetName).cell('A2').style(timeStyle).value('12:00AM');
    workbook.sheet(sheetName).cell('A3').style(timeStyle).value('01:00AM');
    workbook.sheet(sheetName).cell('A4').style(timeStyle).value('02:00AM');
    workbook.sheet(sheetName).cell('A5').style(timeStyle).value('03:00AM');
    workbook.sheet(sheetName).cell('A6').style(timeStyle).value('04:00AM');
    workbook.sheet(sheetName).cell('A7').style(timeStyle).value('05:00AM');
    workbook.sheet(sheetName).cell('A8').style(timeStyle).value('06:00AM');
    workbook.sheet(sheetName).cell('A9').style(timeStyle).value('07:00AM');
    workbook.sheet(sheetName).cell('A10').style(timeStyle).value('08:00AM');
    workbook.sheet(sheetName).cell('A11').style(timeStyle).value('09:00AM');
    workbook.sheet(sheetName).cell('A12').style(timeStyle).value('10:00AM');
    workbook.sheet(sheetName).cell('A13').style(timeStyle).value('11:00AM');
    workbook.sheet(sheetName).cell('A14').style(timeStyle).value('12:00PM');
    workbook.sheet(sheetName).cell('A15').style(timeStyle).value('01:00PM');
    workbook.sheet(sheetName).cell('A16').style(timeStyle).value('02:00PM');
    workbook.sheet(sheetName).cell('A17').style(timeStyle).value('03:00PM');
    workbook.sheet(sheetName).cell('A18').style(timeStyle).value('04:00PM');
    workbook.sheet(sheetName).cell('A19').style(timeStyle).value('05:00PM');
    workbook.sheet(sheetName).cell('A20').style(timeStyle).value('06:00PM');
    workbook.sheet(sheetName).cell('A21').style(timeStyle).value('07:00PM');
    workbook.sheet(sheetName).cell('A22').style(timeStyle).value('08:00PM');
    workbook.sheet(sheetName).cell('A23').style(timeStyle).value('09:00PM');
    workbook.sheet(sheetName).cell('A24').style(timeStyle).value('10:00PM');
    workbook.sheet(sheetName).cell('A25').style(timeStyle).value('11:00PM');

    // totals
    workbook.sheet(sheetName).cell('A27').style({
      fontColor: 'FFFFFF', fontSize: 11, fontFamily: font, bold: true,
      verticalAlignment: 'center', horizontalAlignment: 'right',
      fill: { color: 'CC042A' },
      border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
    }).value('Open Business');
    workbook.sheet(sheetName).cell('A28').style({
      fontColor: 'FFFFFF', fontSize: 11, fontFamily: font, bold: true,
      verticalAlignment: 'center', horizontalAlignment: 'right',
      fill: { color: 'CC042A' },
      border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
    }).value('Open Availability');
    workbook.sheet(sheetName).cell('A29').style({
      fontColor: 'FFFFFF', fontSize: 11, fontFamily: font, bold: true,
      verticalAlignment: 'center', horizontalAlignment: 'right',
      fill: { color: '27C664' },
      border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
    }).value('Covered Business');
    workbook.sheet(sheetName).cell('A30').style({
      fontColor: 'FFFFFF', fontSize: 11, fontFamily: font, bold: true,
      verticalAlignment: 'center', horizontalAlignment: 'right',
      fill: { color: '27C664' },
      border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
    }).value('Available Drivers');

    // home drivers
    workbook.sheet(sheetName).cell('A32').style({
      fontColor: 'FFFFFF', fontSize: 11, fontFamily: font, bold: true,
      verticalAlignment: 'center', horizontalAlignment: 'right',
      fill: { color: '27C664' },
      border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
    }).value('Home-Based Drivers');

    var homeDriversValue = '';
    for (var _prop in homeDrivers) {
      if (!homeDrivers.hasOwnProperty(_prop)) {
        continue;
      }
      var driverText = _prop + ' - ' + homeDrivers[_prop].name;
      homeDriversValue = homeDriversValue + driverText;
    }

    if (homeDriversValue === '') {
      homeDriversValue = '0';
    }
    workbook.sheet(sheetName).row(32).cell(2).style({
      fontColor: '333333', fontSize: 11, bold: true,
      verticalAlignment: 'center', horizontalAlignment: 'left',
      fill: { color: 'DCE9D5' },
      border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
    }).value(homeDriversValue);
    // home drivers end

    // column width
    workbook.sheet(sheetName).column('A').width(20);
    return master;
  }
});

/***/ }),
/* 2024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sectors",attrs:{"id":"SectorListContainer"}},[_c('div',{staticClass:"sector-filters"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-5 columns padding-R"},[_c('div',{staticClass:"field-input"},[_c('label',[_vm._v("COVERAGE DATE")]),_vm._v(" "),_c('date-picker',{attrs:{"format":"MM/dd/yyyy","input-class":"sectorfilter-dateinput","calendar-class":"sectorfilter-calendar"},on:{"selected":function($event){return _vm.filterSectors(false)}},model:{value:(_vm.filterStartDate),callback:function ($$v) {_vm.filterStartDate=$$v},expression:"filterStartDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"small-2 columns padding-L padding-R"},[_c('a',{class:{ 'button cta xsmall success report-btn': true, disabled: _vm.filterBtnDisabled },on:{"click":function($event){return _vm.filterSectors(true)}}},[_vm._v("REFRESH")])]),_vm._v(" "),_c('div',{staticClass:"small-5 columns padding-L"},[_c('a',{class:{ 'button cta xsmall block report-btn': true, disabled: _vm.filterBtnDisabled || _vm.generatingReport },attrs:{"href":"javascript:;"},on:{"click":_vm.generateReport}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.generatingReport),expression:"generatingReport"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.generatingReport),expression:"!generatingReport"}]},[_vm._v("GENERATE REPORT")])])])])]),_vm._v(" "),_c('div',{staticClass:"sector-items"},_vm._l((_vm.sectorItems),function(sector,index){return _c('div',{key:index,staticClass:"sector",attrs:{"id":sector.identifier}},[_c('div',{staticClass:"header",on:{"click":function($event){return _vm.togglePanel(index)}}},[_c('div',{staticClass:"sector-label"},[_c('span',{staticClass:"sector-color",style:({ backgroundColor: sector.overlayColor})}),_vm._v(" "),_c('span',{staticClass:"mainlabel"},[_vm._v(_vm._s(sector.name))])]),_vm._v(" "),_c('div',{staticClass:"sublabel"},[_vm._v(_vm._s(sector.identifier))]),_vm._v(" "),_c('div',{staticClass:"alert-icon"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(sector.issueState === 'ok'),expression:"sector.issueState === 'ok'"}],staticClass:"fa fa-check-circle fa-lg"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(sector.issueState === 'has-issues'),expression:"sector.issueState === 'has-issues'"}],staticClass:"fa fa-exclamation-circle fa-lg"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(sector.issueState === 'loading'),expression:"sector.issueState === 'loading'"}],staticClass:"fa fa-spinner fa-spin fa-lg"})]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!sector.showPanel),expression:"!sector.showPanel"}],staticClass:"fa fa-chevron-down expand-icon"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(sector.showPanel),expression:"sector.showPanel"}],staticClass:"fa fa-chevron-up expand-icon"})]),_vm._v(" "),_c('div',{class:['sector-body', {show: sector.showPanel}]},[_c('coverage-calendar',{ref:'coverageCalendar' + index,refInFor:true,attrs:{"sector":sector}})],1)])}),0),_vm._v(" "),_c('div',{class:{ 'sector-loading': true, show: _vm.sectorLoading }},[_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-label"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('div',[_vm._v("LOADING")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coverage"},[_c('div',{staticClass:"map-container"},[_c('coverage-map2')],1),_vm._v(" "),_c('div',{staticClass:"sector-list"},[_c('sector-list')],1),_vm._v(" "),_c('coverage-shift-form')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(655);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_233696c0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2100);
function injectStyle (ssrContext) {
  __webpack_require__(2027)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-233696c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_233696c0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2028);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("c2c291da", content, true, {});

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.left-panel[data-v-233696c0],\n.middle-panel[data-v-233696c0],\n.right-panel[data-v-233696c0] {\n  height: 100%;\n  position: fixed;\n  top: 0;\n}\n.left-panel[data-v-233696c0] {\n  width: 35%;\n  left: 0;\n  -webkit-box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.2);\n  z-index: 3;\n}\n.middle-panel[data-v-233696c0] {\n  width: 30%;\n  left: 35%;\n  z-index: 2;\n}\n.right-panel[data-v-233696c0] {\n  width: 35%;\n  left: 65%;\n  -webkit-box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.2);\n  z-index: 3;\n}\n.right-panel .top[data-v-233696c0],\n  .right-panel .bottom[data-v-233696c0] {\n    height: calc((100vh - 80px) / 2);\n}\n.search-box[data-v-233696c0] {\n  width: 100%;\n  height: 51px;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n.search-box input[data-v-233696c0] {\n    margin: 0 0 0 50px;\n    border-radius: 0;\n    padding: 0 5px;\n    height: 50px;\n    line-height: 50px;\n    width: calc(100% - 50px);\n    border: 0;\n}\n.left-side-table[data-v-233696c0] {\n  height: calc((100vh - 50px) / 2);\n  position: relative;\n}\n.left-side-table .header[data-v-233696c0] {\n    background: #0d79f2;\n    padding: 5px;\n    text-align: center;\n    color: #fff;\n    font-size: 14px;\n    font-weight: 600;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n}\n.left-side-table .table-box[data-v-233696c0] {\n    overflow-y: auto;\n    overflow-x: hidden;\n    height: 100%;\n}\n.refresh-icon i[data-v-233696c0] {\n  margin-left: 5px;\n}\n.refresh-icon .tooltiptext[data-v-233696c0] {\n  visibility: hidden;\n  width: 80px;\n  background-color: #4e4e4e;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 1px 0;\n  position: absolute;\n  z-index: 1;\n  opacity: 0;\n  -webkit-transition: opacity .6s;\n  transition: opacity .6s;\n  top: 120%;\n  left: 60%;\n  font-size: 14px;\n}\n.refresh-icon[data-v-233696c0]:hover {\n  cursor: pointer;\n  color: #26D97A;\n}\n.refresh-icon:hover .tooltiptext[data-v-233696c0] {\n    opacity: 1;\n    visibility: visible;\n}\n.middle-box[data-v-233696c0] {\n  height: 50vh;\n  position: relative;\n}\n.table-loader[data-v-233696c0] {\n  position: relative;\n  width: 100%;\n  margin: 50px auto;\n  text-align: center;\n}\n.table-loader .loader-title[data-v-233696c0] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.table-loader .loader-text[data-v-233696c0] {\n    font-weight: 700;\n    font-size: 16px;\n    color: #777;\n}\n.infinity-loader[data-v-233696c0] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  -webkit-transform-origin: bottom center;\n          transform-origin: bottom center;\n  text-align: center;\n  font-size: 18px;\n  line-height: 40px;\n}\n.tnc-reservations[data-v-233696c0] {\n  padding: 30px 0 43px;\n}\n.tnc-reservations .control[data-v-233696c0] {\n    padding: 5px 10px;\n    background: #3a3a3a;\n}\n.tnc-reservations .infinity-loader[data-v-233696c0] {\n    bottom: 43px;\n}\n.empty-reservations[data-v-233696c0] {\n  max-width: 450px;\n  margin: 50px auto;\n  text-align: center;\n}\n.empty-reservations .title[data-v-233696c0] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.empty-reservations .content[data-v-233696c0] {\n    font-weight: 700;\n    font-size: 16px;\n    color: #777;\n}\n.other-reservations[data-v-233696c0] {\n  padding: 30px 0 0;\n}\n.slide-up-enter-active[data-v-233696c0], .slide-up-leave-active[data-v-233696c0] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-233696c0], .slide-up-leave-to[data-v-233696c0] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media screen and (max-width: 430px) {\n.tnc-reservations .control[data-v-233696c0] {\n    position: relative;\n    bottom: 12px;\n}\n.tabs-mobile[data-v-233696c0] {\n    position: relative;\n    z-index: 1;\n    padding-top: 6px;\n    padding-left: 51px;\n}\n.tabs-mobile .tab[data-v-233696c0] {\n      display: inline-block;\n      background-color: rgba(255, 255, 255, 0);\n      font-size: 14px;\n      font-weight: 700;\n      padding: 10px 20px;\n      border: 1px solid rgba(0, 0, 0, 0.2);\n      border-bottom: 0;\n      text-decoration: none;\n      -webkit-transition: all 250ms;\n      transition: all 250ms;\n      width: 49%;\n      text-align: center;\n}\n.tabs-mobile .tab.active[data-v-233696c0] {\n        background-color: #f5f5f5;\n        pointer-events: none;\n}\n.search-box input[data-v-233696c0] {\n    margin: 0;\n    width: 100%;\n}\n.tab-contents[data-v-233696c0] {\n    margin-top: -1px;\n    border-top: 1px solid rgba(0, 0, 0, 0.2);\n    background-color: #f5f5f5;\n    position: relative;\n    z-index: 0;\n    width: 100%;\n    height: calc(100% - 102px);\n}\n.tab-contents .tab-content[data-v-233696c0] {\n      display: none;\n      height: 100%;\n      overflow: auto;\n}\n.tab-contents .tab-content.active[data-v-233696c0] {\n        display: block;\n}\n.tab-contents .tab-content.with-control[data-v-233696c0] {\n        height: calc(100% - 80px);\n}\n.tab-contents .tab-control[data-v-233696c0] {\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      background-color: #fff;\n      width: 100%;\n      border-top: 1px solid rgba(0, 0, 0, 0.3);\n      padding: 20px 10px;\n}\n.toggle-mobile[data-v-233696c0] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 20;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.tab-contents .tab-control[data-v-233696c0] {\n    bottom: 45px;\n    padding: 10px 5px;\n}\n.left-panel[data-v-233696c0] {\n    width: 100%;\n    top: 50px;\n}\n.left-panel .other-reservations .table-box[data-v-233696c0] {\n      padding-bottom: 100px;\n}\n.middle-panel[data-v-233696c0] {\n    left: 0;\n    width: 100%;\n    top: 100%;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n}\n.middle-panel.showMapBox[data-v-233696c0] {\n      top: 0;\n      z-index: 6;\n}\n.middle-box[data-v-233696c0] {\n    background-color: #fff;\n}\n.middle-box.map-box[data-v-233696c0] {\n      height: 35vh;\n}\n.middle-box.drop-box[data-v-233696c0] {\n      height: 65vh;\n}\n.right-panel[data-v-233696c0] {\n    left: 100%;\n    width: 100%;\n    z-index: 4;\n    top: 50px;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n    background-color: #fff;\n}\n.right-panel.active[data-v-233696c0] {\n      left: 0;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Laxit/index.vue"],"names":[],"mappings":";AACA;;;EAGE,aAAa;EACb,gBAAgB;EAChB,OAAO;CACR;AACD;EACE,WAAW;EACX,QAAQ;EACR,mDAAmD;UAC3C,2CAA2C;EACnD,WAAW;CACZ;AACD;EACE,WAAW;EACX,UAAU;EACV,WAAW;CACZ;AACD;EACE,WAAW;EACX,UAAU;EACV,mDAAmD;UAC3C,2CAA2C;EACnD,WAAW;CACZ;AACD;;IAEI,iCAAiC;CACpC;AACD;EACE,YAAY;EACZ,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;CACnD;AACD;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;CACb;AACD;EACE,iCAAiC;EACjC,mBAAmB;CACpB;AACD;IACI,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;CACf;AACD;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;CAChB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,wBAAwB;EACxB,UAAU;EACV,UAAU;EACV,gBAAgB;CACjB;AACD;EACE,gBAAgB;EAChB,eAAe;CAChB;AACD;IACI,WAAW;IACX,oBAAoB;CACvB;AACD;EACE,aAAa;EACb,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;CACpB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,wCAAwC;UAChC,gCAAgC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;EACE,qBAAqB;CACtB;AACD;IACI,kBAAkB;IAClB,oBAAoB;CACvB;AACD;IACI,aAAa;CAChB;AACD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;CACpB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;EACE,kBAAkB;CACnB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;AACA;IACI,mBAAmB;IACnB,aAAa;CAChB;AACD;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,yCAAyC;MACzC,gBAAgB;MAChB,iBAAiB;MACjB,mBAAmB;MACnB,qCAAqC;MACrC,iBAAiB;MACjB,sBAAsB;MACtB,8BAA8B;MAC9B,sBAAsB;MACtB,WAAW;MACX,mBAAmB;CACxB;AACD;QACQ,0BAA0B;QAC1B,qBAAqB;CAC5B;AACD;IACI,UAAU;IACV,YAAY;CACf;AACD;IACI,iBAAiB;IACjB,yCAAyC;IACzC,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,2BAA2B;CAC9B;AACD;MACM,cAAc;MACd,aAAa;MACb,eAAe;CACpB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,0BAA0B;CACjC;AACD;MACM,mBAAmB;MACnB,UAAU;MACV,QAAQ;MACR,uBAAuB;MACvB,YAAY;MACZ,yCAAyC;MACzC,mBAAmB;CACxB;AACD;IACI,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;IACrB,YAAY;IACZ,0BAA0B;IAC1B,iBAAiB;CACpB;AACD;IACI,aAAa;IACb,kBAAkB;CACrB;AACD;IACI,YAAY;IACZ,UAAU;CACb;AACD;MACM,sBAAsB;CAC3B;AACD;IACI,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,OAAO;MACP,WAAW;CAChB;AACD;IACI,uBAAuB;CAC1B;AACD;MACM,aAAa;CAClB;AACD;MACM,aAAa;CAClB;AACD;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,UAAU;IACV,kCAAkC;IAClC,0BAA0B;IAC1B,uBAAuB;CAC1B;AACD;MACM,QAAQ;CACb;CACA","file":"index.vue","sourcesContent":["\n.left-panel[data-v-233696c0],\n.middle-panel[data-v-233696c0],\n.right-panel[data-v-233696c0] {\n  height: 100%;\n  position: fixed;\n  top: 0;\n}\n.left-panel[data-v-233696c0] {\n  width: 35%;\n  left: 0;\n  -webkit-box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.2);\n  z-index: 3;\n}\n.middle-panel[data-v-233696c0] {\n  width: 30%;\n  left: 35%;\n  z-index: 2;\n}\n.right-panel[data-v-233696c0] {\n  width: 35%;\n  left: 65%;\n  -webkit-box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.2);\n  z-index: 3;\n}\n.right-panel .top[data-v-233696c0],\n  .right-panel .bottom[data-v-233696c0] {\n    height: calc((100vh - 80px) / 2);\n}\n.search-box[data-v-233696c0] {\n  width: 100%;\n  height: 51px;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n.search-box input[data-v-233696c0] {\n    margin: 0 0 0 50px;\n    border-radius: 0;\n    padding: 0 5px;\n    height: 50px;\n    line-height: 50px;\n    width: calc(100% - 50px);\n    border: 0;\n}\n.left-side-table[data-v-233696c0] {\n  height: calc((100vh - 50px) / 2);\n  position: relative;\n}\n.left-side-table .header[data-v-233696c0] {\n    background: #0d79f2;\n    padding: 5px;\n    text-align: center;\n    color: #fff;\n    font-size: 14px;\n    font-weight: 600;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n}\n.left-side-table .table-box[data-v-233696c0] {\n    overflow-y: auto;\n    overflow-x: hidden;\n    height: 100%;\n}\n.refresh-icon i[data-v-233696c0] {\n  margin-left: 5px;\n}\n.refresh-icon .tooltiptext[data-v-233696c0] {\n  visibility: hidden;\n  width: 80px;\n  background-color: #4e4e4e;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 1px 0;\n  position: absolute;\n  z-index: 1;\n  opacity: 0;\n  -webkit-transition: opacity .6s;\n  transition: opacity .6s;\n  top: 120%;\n  left: 60%;\n  font-size: 14px;\n}\n.refresh-icon[data-v-233696c0]:hover {\n  cursor: pointer;\n  color: #26D97A;\n}\n.refresh-icon:hover .tooltiptext[data-v-233696c0] {\n    opacity: 1;\n    visibility: visible;\n}\n.middle-box[data-v-233696c0] {\n  height: 50vh;\n  position: relative;\n}\n.table-loader[data-v-233696c0] {\n  position: relative;\n  width: 100%;\n  margin: 50px auto;\n  text-align: center;\n}\n.table-loader .loader-title[data-v-233696c0] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.table-loader .loader-text[data-v-233696c0] {\n    font-weight: 700;\n    font-size: 16px;\n    color: #777;\n}\n.infinity-loader[data-v-233696c0] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  -webkit-transform-origin: bottom center;\n          transform-origin: bottom center;\n  text-align: center;\n  font-size: 18px;\n  line-height: 40px;\n}\n.tnc-reservations[data-v-233696c0] {\n  padding: 30px 0 43px;\n}\n.tnc-reservations .control[data-v-233696c0] {\n    padding: 5px 10px;\n    background: #3a3a3a;\n}\n.tnc-reservations .infinity-loader[data-v-233696c0] {\n    bottom: 43px;\n}\n.empty-reservations[data-v-233696c0] {\n  max-width: 450px;\n  margin: 50px auto;\n  text-align: center;\n}\n.empty-reservations .title[data-v-233696c0] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.empty-reservations .content[data-v-233696c0] {\n    font-weight: 700;\n    font-size: 16px;\n    color: #777;\n}\n.other-reservations[data-v-233696c0] {\n  padding: 30px 0 0;\n}\n.slide-up-enter-active[data-v-233696c0], .slide-up-leave-active[data-v-233696c0] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-up-enter[data-v-233696c0], .slide-up-leave-to[data-v-233696c0] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media screen and (max-width: 430px) {\n.tnc-reservations .control[data-v-233696c0] {\n    position: relative;\n    bottom: 12px;\n}\n.tabs-mobile[data-v-233696c0] {\n    position: relative;\n    z-index: 1;\n    padding-top: 6px;\n    padding-left: 51px;\n}\n.tabs-mobile .tab[data-v-233696c0] {\n      display: inline-block;\n      background-color: rgba(255, 255, 255, 0);\n      font-size: 14px;\n      font-weight: 700;\n      padding: 10px 20px;\n      border: 1px solid rgba(0, 0, 0, 0.2);\n      border-bottom: 0;\n      text-decoration: none;\n      -webkit-transition: all 250ms;\n      transition: all 250ms;\n      width: 49%;\n      text-align: center;\n}\n.tabs-mobile .tab.active[data-v-233696c0] {\n        background-color: #f5f5f5;\n        pointer-events: none;\n}\n.search-box input[data-v-233696c0] {\n    margin: 0;\n    width: 100%;\n}\n.tab-contents[data-v-233696c0] {\n    margin-top: -1px;\n    border-top: 1px solid rgba(0, 0, 0, 0.2);\n    background-color: #f5f5f5;\n    position: relative;\n    z-index: 0;\n    width: 100%;\n    height: calc(100% - 102px);\n}\n.tab-contents .tab-content[data-v-233696c0] {\n      display: none;\n      height: 100%;\n      overflow: auto;\n}\n.tab-contents .tab-content.active[data-v-233696c0] {\n        display: block;\n}\n.tab-contents .tab-content.with-control[data-v-233696c0] {\n        height: calc(100% - 80px);\n}\n.tab-contents .tab-control[data-v-233696c0] {\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      background-color: #fff;\n      width: 100%;\n      border-top: 1px solid rgba(0, 0, 0, 0.3);\n      padding: 20px 10px;\n}\n.toggle-mobile[data-v-233696c0] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 20;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n.tab-contents .tab-control[data-v-233696c0] {\n    bottom: 45px;\n    padding: 10px 5px;\n}\n.left-panel[data-v-233696c0] {\n    width: 100%;\n    top: 50px;\n}\n.left-panel .other-reservations .table-box[data-v-233696c0] {\n      padding-bottom: 100px;\n}\n.middle-panel[data-v-233696c0] {\n    left: 0;\n    width: 100%;\n    top: 100%;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n}\n.middle-panel.showMapBox[data-v-233696c0] {\n      top: 0;\n      z-index: 6;\n}\n.middle-box[data-v-233696c0] {\n    background-color: #fff;\n}\n.middle-box.map-box[data-v-233696c0] {\n      height: 35vh;\n}\n.middle-box.drop-box[data-v-233696c0] {\n      height: 65vh;\n}\n.right-panel[data-v-233696c0] {\n    left: 100%;\n    width: 100%;\n    z-index: 4;\n    top: 50px;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n    background-color: #fff;\n}\n.right-panel.active[data-v-233696c0] {\n      left: 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropzone_vue__ = __webpack_require__(656);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e064a6b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropzone_vue__ = __webpack_require__(2036);
function injectStyle (ssrContext) {
  __webpack_require__(2030)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e064a6b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropzone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e064a6b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropzone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2031);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1abae82e", content, true, {});

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.routing-dropzone[data-v-5e064a6b] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.empty-container[data-v-5e064a6b] {\n  display: table;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0);\n  -webkit-transition: all 500ms;\n  transition: all 500ms;\n}\n.empty-container.dragover[data-v-5e064a6b] {\n    background-color: rgba(0, 0, 0, 0.6);\n}\n.empty-container .empty[data-v-5e064a6b] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.empty-container .empty-content[data-v-5e064a6b] {\n    max-width: 350px;\n    padding: 0 15px;\n    margin: 0 auto;\n    text-align: center;\n    font-weight: 700;\n}\n.empty-container .empty-content img[data-v-5e064a6b] {\n      display: block;\n      width: 200px;\n      margin: 0 auto;\n}\n.empty-container .empty-content .title[data-v-5e064a6b] {\n      font-size: 22px;\n      color: #3F2975;\n      margin-top: 15px;\n}\n.empty-container .empty-content .message[data-v-5e064a6b] {\n      margin-top: 5px;\n      font-size: 16px;\n      color: #555;\n}\n.dropzone[data-v-5e064a6b] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.75);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.dropzone.show[data-v-5e064a6b] {\n    top: 0;\n}\n.dropzone .empty-content i[data-v-5e064a6b] {\n    color: #fff;\n}\n.dropzone .empty-content .title[data-v-5e064a6b] {\n    color: #fff;\n}\n.dropzone-items[data-v-5e064a6b] {\n  padding: 10px 10px 5px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 70px);\n  overflow: auto;\n}\n.dropzone-item[data-v-5e064a6b] {\n  position: relative;\n  background-color: #fff;\n  margin-bottom: 5px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  border-radius: 3px;\n}\n.dropzone-item .remove-item[data-v-5e064a6b] {\n    position: absolute;\n    top: 17px;\n    right: 10px;\n    text-decoration: none;\n    color: #F20D0D;\n}\n.dropzone-item a[data-v-5e064a6b] {\n    font-weight: 700;\n}\n.dropzone-item .header[data-v-5e064a6b] {\n    font-size: 12px;\n    padding: 5px;\n}\n.dropzone-item .order[data-v-5e064a6b] {\n    display: inline-block;\n    margin-right: 5px;\n    background-color: #26D97A;\n    color: #fff;\n    width: 20px;\n    height: 20px;\n    line-height: 20px;\n    text-align: center;\n    font-weight: 700;\n    border-radius: 100%;\n}\n.dropzone-item .order.dropoff[data-v-5e064a6b] {\n      background-color: #F20D0D;\n}\n.dropzone-item .icon-label[data-v-5e064a6b] {\n    display: inline-block;\n    margin-left: 10px;\n    color: #555;\n}\n.dropzone-item .icon-label.location[data-v-5e064a6b] {\n      margin: 0;\n      padding: 0 25px 0 5px;\n      color: #555;\n      font-weight: 700;\n      display: block;\n      margin: 5px 0;\n}\n.dropzone-item .icon-label.location i[data-v-5e064a6b] {\n        color: #26D97A;\n}\n.dropzone-item .icon-label.location i.dropoff[data-v-5e064a6b] {\n        color: #F20D0D;\n}\n.dropzone-item .icon-label.time .value[data-v-5e064a6b] {\n      font-weight: 700;\n}\n.dropzone-item .icon-label.validation[data-v-5e064a6b] {\n      color: #229e5c;\n}\n.dropzone-item .icon-label.validation i.success[data-v-5e064a6b] {\n        display: inline-block;\n}\n.dropzone-item .icon-label.validation i.warning[data-v-5e064a6b] {\n        display: none;\n}\n.dropzone-item .icon-label.validation.warning[data-v-5e064a6b] {\n        color: #F25E0D;\n}\n.dropzone-item .icon-label.validation.warning i.success[data-v-5e064a6b] {\n          display: none;\n}\n.dropzone-item .icon-label.validation.warning i.warning[data-v-5e064a6b] {\n          display: inline-block;\n}\n.dropzone-item .body[data-v-5e064a6b] {\n    font-size: 12px;\n    padding: 0 15px 10px 0;\n    text-align: left;\n}\n.check-route-loading[data-v-5e064a6b] {\n  display: table;\n  position: absolute;\n  bottom: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.9);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.check-route-loading.show[data-v-5e064a6b] {\n    bottom: 0;\n}\n.check-route-loading .title[data-v-5e064a6b] {\n    display: table-cell;\n    vertical-align: middle;\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    color: #555;\n    font-weight: 700;\n    font-size: 18px;\n}\n.check-route-loading .title .text[data-v-5e064a6b] {\n      display: inline-block;\n      margin-top: 100px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Laxit/Dropzone.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;CACd;AACD;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,qCAAqC;CACxC;AACD;IACI,oBAAoB;IACpB,uBAAuB;CAC1B;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;CACpB;AACD;MACM,eAAe;MACf,aAAa;MACb,eAAe;CACpB;AACD;MACM,gBAAgB;MAChB,eAAe;MACf,iBAAiB;CACtB;AACD;MACM,gBAAgB;MAChB,gBAAgB;MAChB,YAAY;CACjB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;CACV;AACD;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,0BAA0B;EAC1B,eAAe;CAChB;AACD;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,eAAe;CAClB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,gBAAgB;IAChB,aAAa;CAChB;AACD;IACI,sBAAsB;IACtB,kBAAkB;IAClB,0BAA0B;IAC1B,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;CACvB;AACD;MACM,0BAA0B;CAC/B;AACD;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;CACf;AACD;MACM,UAAU;MACV,sBAAsB;MACtB,YAAY;MACZ,iBAAiB;MACjB,eAAe;MACf,cAAc;CACnB;AACD;QACQ,eAAe;CACtB;AACD;QACQ,eAAe;CACtB;AACD;MACM,iBAAiB;CACtB;AACD;MACM,eAAe;CACpB;AACD;QACQ,sBAAsB;CAC7B;AACD;QACQ,cAAc;CACrB;AACD;QACQ,eAAe;CACtB;AACD;UACU,cAAc;CACvB;AACD;UACU,sBAAsB;CAC/B;AACD;IACI,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;CACpB;AACD;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,2CAA2C;EAC3C,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,UAAU;CACb;AACD;IACI,oBAAoB;IACpB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;CACnB;AACD;MACM,sBAAsB;MACtB,kBAAkB;CACvB","file":"Dropzone.vue","sourcesContent":["\n.routing-dropzone[data-v-5e064a6b] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.empty-container[data-v-5e064a6b] {\n  display: table;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0);\n  -webkit-transition: all 500ms;\n  transition: all 500ms;\n}\n.empty-container.dragover[data-v-5e064a6b] {\n    background-color: rgba(0, 0, 0, 0.6);\n}\n.empty-container .empty[data-v-5e064a6b] {\n    display: table-cell;\n    vertical-align: middle;\n}\n.empty-container .empty-content[data-v-5e064a6b] {\n    max-width: 350px;\n    padding: 0 15px;\n    margin: 0 auto;\n    text-align: center;\n    font-weight: 700;\n}\n.empty-container .empty-content img[data-v-5e064a6b] {\n      display: block;\n      width: 200px;\n      margin: 0 auto;\n}\n.empty-container .empty-content .title[data-v-5e064a6b] {\n      font-size: 22px;\n      color: #3F2975;\n      margin-top: 15px;\n}\n.empty-container .empty-content .message[data-v-5e064a6b] {\n      margin-top: 5px;\n      font-size: 16px;\n      color: #555;\n}\n.dropzone[data-v-5e064a6b] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.75);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.dropzone.show[data-v-5e064a6b] {\n    top: 0;\n}\n.dropzone .empty-content i[data-v-5e064a6b] {\n    color: #fff;\n}\n.dropzone .empty-content .title[data-v-5e064a6b] {\n    color: #fff;\n}\n.dropzone-items[data-v-5e064a6b] {\n  padding: 10px 10px 5px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 70px);\n  overflow: auto;\n}\n.dropzone-item[data-v-5e064a6b] {\n  position: relative;\n  background-color: #fff;\n  margin-bottom: 5px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  border-radius: 3px;\n}\n.dropzone-item .remove-item[data-v-5e064a6b] {\n    position: absolute;\n    top: 17px;\n    right: 10px;\n    text-decoration: none;\n    color: #F20D0D;\n}\n.dropzone-item a[data-v-5e064a6b] {\n    font-weight: 700;\n}\n.dropzone-item .header[data-v-5e064a6b] {\n    font-size: 12px;\n    padding: 5px;\n}\n.dropzone-item .order[data-v-5e064a6b] {\n    display: inline-block;\n    margin-right: 5px;\n    background-color: #26D97A;\n    color: #fff;\n    width: 20px;\n    height: 20px;\n    line-height: 20px;\n    text-align: center;\n    font-weight: 700;\n    border-radius: 100%;\n}\n.dropzone-item .order.dropoff[data-v-5e064a6b] {\n      background-color: #F20D0D;\n}\n.dropzone-item .icon-label[data-v-5e064a6b] {\n    display: inline-block;\n    margin-left: 10px;\n    color: #555;\n}\n.dropzone-item .icon-label.location[data-v-5e064a6b] {\n      margin: 0;\n      padding: 0 25px 0 5px;\n      color: #555;\n      font-weight: 700;\n      display: block;\n      margin: 5px 0;\n}\n.dropzone-item .icon-label.location i[data-v-5e064a6b] {\n        color: #26D97A;\n}\n.dropzone-item .icon-label.location i.dropoff[data-v-5e064a6b] {\n        color: #F20D0D;\n}\n.dropzone-item .icon-label.time .value[data-v-5e064a6b] {\n      font-weight: 700;\n}\n.dropzone-item .icon-label.validation[data-v-5e064a6b] {\n      color: #229e5c;\n}\n.dropzone-item .icon-label.validation i.success[data-v-5e064a6b] {\n        display: inline-block;\n}\n.dropzone-item .icon-label.validation i.warning[data-v-5e064a6b] {\n        display: none;\n}\n.dropzone-item .icon-label.validation.warning[data-v-5e064a6b] {\n        color: #F25E0D;\n}\n.dropzone-item .icon-label.validation.warning i.success[data-v-5e064a6b] {\n          display: none;\n}\n.dropzone-item .icon-label.validation.warning i.warning[data-v-5e064a6b] {\n          display: inline-block;\n}\n.dropzone-item .body[data-v-5e064a6b] {\n    font-size: 12px;\n    padding: 0 15px 10px 0;\n    text-align: left;\n}\n.check-route-loading[data-v-5e064a6b] {\n  display: table;\n  position: absolute;\n  bottom: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.9);\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.check-route-loading.show[data-v-5e064a6b] {\n    bottom: 0;\n}\n.check-route-loading .title[data-v-5e064a6b] {\n    display: table-cell;\n    vertical-align: middle;\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    color: #555;\n    font-weight: 700;\n    font-size: 18px;\n}\n.check-route-loading .title .text[data-v-5e064a6b] {\n      display: inline-block;\n      margin-top: 100px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropzoneControls_vue__ = __webpack_require__(657);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e88c064_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropzoneControls_vue__ = __webpack_require__(2035);
function injectStyle (ssrContext) {
  __webpack_require__(2033)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e88c064"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropzoneControls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e88c064_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropzoneControls_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2034);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("50967b38", content, true, {});

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.dropzone-controls[data-v-7e88c064] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: #fff;\n  border-top: 1px solid rgba(0, 0, 0, 0.3);\n  padding: 15px 10px;\n}\n.row[data-v-7e88c064] {\n  padding: 0 10px;\n}\n.padding-L[data-v-7e88c064] {\n  padding-left: 5px;\n}\n.padding-R[data-v-7e88c064] {\n  padding-right: 5px;\n}\n.button[data-v-7e88c064] {\n  line-height: 135%;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Laxit/DropzoneControls.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,yCAAyC;EACzC,mBAAmB;CACpB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB","file":"DropzoneControls.vue","sourcesContent":["\n.dropzone-controls[data-v-7e88c064] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: #fff;\n  border-top: 1px solid rgba(0, 0, 0, 0.3);\n  padding: 15px 10px;\n}\n.row[data-v-7e88c064] {\n  padding: 0 10px;\n}\n.padding-L[data-v-7e88c064] {\n  padding-left: 5px;\n}\n.padding-R[data-v-7e88c064] {\n  padding-right: 5px;\n}\n.button[data-v-7e88c064] {\n  line-height: 135%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length > 0),expression:"items.length > 0"}],staticClass:"dropzone-controls"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-4 columns padding-R"},[_c('a',{staticClass:"button cta small block warning",attrs:{"href":"javascript:;"},on:{"click":_vm.clearMap}},[_vm._v("CLEAR MAP")])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-L padding-R"},[_c('a',{staticClass:"button cta small block",attrs:{"href":"javascript:;"},on:{"click":_vm.optimizeRoute}},[_vm._v("OPTIMIZE ROUTE")])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-L"},[_c('a',{staticClass:"button cta small block success",attrs:{"href":"javascript:;"},on:{"click":_vm.savePackage}},[_vm._v("SAVE PACKAGE")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"routing-dropzone"},[_c('draggable',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length > 0),expression:"items.length > 0"}],staticClass:"dropzone-items",model:{value:(_vm.items),callback:function ($$v) {_vm.items=$$v},expression:"items"}},_vm._l((_vm.items),function(item,index){return _c('div',{staticClass:"dropzone-item"},[_c('div',{staticClass:"header"},[_c('span',{class:{ order: true, dropoff: !item.isPickup }},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('a',{attrs:{"href":'/#/reservation/' + item.reservationID,"target":"_blank"}},[_vm._v(_vm._s(item.reservationID))]),_vm._v(" "),(item.packageID !== null)?_c('span',[_vm._v("-")]):_vm._e(),_vm._v(" "),(item.packageID !== null)?_c('a',{attrs:{"href":'/#/package/' + item.packageID,"target":"_blank"}},[_vm._v(_vm._s(item.packageID))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"icon-label"},[_c('i',{staticClass:"fas fa-suitcase"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.luggage))])]),_vm._v(" "),_c('span',{staticClass:"icon-label"},[_c('i',{staticClass:"fas fa-user"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.passengers))])]),_vm._v(" "),_c('span',{staticClass:"icon-label location"},[_c('i',{class:{ 'fas fa-map-marker-alt fa-fw': true, dropoff: !item.isPickup }}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getAddress(item.location)))])])]),_vm._v(" "),_c('div',{staticClass:"body"},[(item.isPickup)?_c('span',{staticClass:"icon-label time"},[_c('i',{staticClass:"fas fa-clock"}),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("PUT:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(item.originalPickupTime))])]):_vm._e(),_vm._v(" "),(index > 0 && !item.isPickup)?_c('span',{staticClass:"icon-label time"},[_c('i',{staticClass:"fas fa-clock"}),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("BTT:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.computeOriginalBTT(item)))])]):_vm._e(),_vm._v(" "),(index > 0)?_c('span',{staticClass:"icon-label time"},[_c('i',{staticClass:"fas fa-clock"}),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("ETA:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.computeEta(item)))])]):_vm._e(),_vm._v(" "),(index > 0)?_c('span',{class:{ 'icon-label validation': true, warning: _vm.showWarning(item) }},[_c('i',{staticClass:"fas fa-exclamation-triangle fa-fw warning"}),_vm._v(" "),_c('i',{staticClass:"fas fa-check-circle fa-fw success"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.hasIssues(item)))])]):_vm._e()]),_vm._v(" "),(item.isPickup && item.status !== 'COMPLETED' && item.status !== 'CANCELED')?_c('a',{staticClass:"remove-item",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.removeFromMap(item)}}},[_c('i',{staticClass:"fas fa-minus-square"})]):_vm._e()])}),0),_vm._v(" "),_c('dropzone-controls'),_vm._v(" "),_c('div',{class:{ 'check-route-loading': true, show: _vm.checkRouteLoading }},[_c('loader-map-marker'),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length <= 0),expression:"items.length <= 0"}],staticClass:"empty-container"},[_vm._m(1)]),_vm._v(" "),_c('drop',{class:{ dropzone: true, show: _vm.showDropzone, 'empty-container': true },on:{"drop":_vm.handleDrop}},[_c('div',{staticClass:"empty"},[_c('div',{staticClass:"empty-content"},[_c('i',{staticClass:"fas fa-arrow-alt-circle-down fa-4x"}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Drop it here!")])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"text"},[_vm._v("Finding optimal route...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('div',{staticClass:"empty-content"},[_c('img',{attrs:{"src":"/assets/img/routing-empty.png"}}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Nothing here yet!")]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("Drop a shared reservation/package here or click on the map marker icons to begin routing.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TncReservationsControl_vue__ = __webpack_require__(658);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eb9e090_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TncReservationsControl_vue__ = __webpack_require__(2040);
function injectStyle (ssrContext) {
  __webpack_require__(2038)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0eb9e090"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TncReservationsControl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eb9e090_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TncReservationsControl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2039);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4354de31", content, true, {});

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.padding-L[data-v-0eb9e090] {\n  padding-left: 7px;\n}\n.padding-R[data-v-0eb9e090] {\n  padding-right: 7px;\n}\n.button.cta[data-v-0eb9e090] {\n  font-size: 11px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Laxit/TncReservationsControl.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,gBAAgB;CACjB","file":"TncReservationsControl.vue","sourcesContent":["\n.padding-L[data-v-0eb9e090] {\n  padding-left: 7px;\n}\n.padding-R[data-v-0eb9e090] {\n  padding-right: 7px;\n}\n.button.cta[data-v-0eb9e090] {\n  font-size: 11px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"packages-control"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-3 columns padding-R"},[_c('a',{staticClass:"button cta block xsmall",attrs:{"href":"javascript:;"},on:{"click":_vm.moveToPool}},[_vm._v("MOVE TO POOL")])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns"},[_c('a',{staticClass:"button cta block xsmall warning",attrs:{"href":"javascript:;"},on:{"click":_vm.removeFromPool}},[_vm._v("REMOVE FROM POOL")])]),_vm._v(" "),_c('div',{staticClass:"small-3 columns padding-L"},[_c('a',{class:{'button cta block xsmall error':true, 'disabled':_vm.disableBreakPkg},attrs:{"href":"javascript:;"},on:{"click":_vm.breakPackage}},[_vm._v("BREAK PACKAGE")])]),_vm._v(" "),_c('div',{staticClass:"columns small-3 padding-L"},[_c('a',{staticClass:"button cta success block xsmall",attrs:{"href":"javascript:;"},on:{"click":_vm.markAsComplete}},[_vm._v("MARK AS COMPLETE")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultsModal_vue__ = __webpack_require__(659);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc96faea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResultsModal_vue__ = __webpack_require__(2044);
function injectStyle (ssrContext) {
  __webpack_require__(2042)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fc96faea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc96faea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResultsModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2043);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1b95ceb0", content, true, {});

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.dispatch-modal[data-v-fc96faea] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.dispatch-modal.show[data-v-fc96faea] {\n    top: 0;\n    opacity: 1;\n}\n.dispatch-modal-container[data-v-fc96faea] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.dispatch-modal-content[data-v-fc96faea] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.validation-modal .title[data-v-fc96faea] {\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n  background-color: #F25E0D;\n  padding: 8px 15px;\n}\n.validation-modal .message[data-v-fc96faea] {\n  font-size: 16px;\n  font-weight: 700;\n  color: #555;\n  padding: 15px 15px 10px;\n}\n.validation-modal .button[data-v-fc96faea] {\n  margin: 10px 15px 15px;\n  font-weight: 700;\n}\n.action-modal[data-v-fc96faea] {\n  padding: 15px;\n}\n.action-modal .message[data-v-fc96faea] {\n    font-weight: 700;\n    color: #777;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.action-modal .message.success[data-v-fc96faea] {\n      color: #26D97A;\n}\n.action-modal .message.error[data-v-fc96faea] {\n      color: #F20D0D;\n}\n.circle-loader[data-v-fc96faea] {\n  margin: 0 0 10px 10px;\n  border: 5px solid rgba(0, 0, 0, 0.2);\n  border-left-color: #26D97A;\n  -webkit-animation-name: loader-spin-data-v-fc96faea;\n          animation-name: loader-spin-data-v-fc96faea;\n  -webkit-animation-duration: 1s;\n          animation-duration: 1s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n.circle-loader[data-v-fc96faea],\n.circle-loader[data-v-fc96faea]:after {\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n}\n.load-complete[data-v-fc96faea] {\n  -webkit-animation: none;\n  animation: none;\n  border-color: #26D97A;\n  -webkit-transition: border 500ms ease-out;\n  transition: border 500ms ease-out;\n}\n.load-error[data-v-fc96faea] {\n  -webkit-animation: none;\n  animation: none;\n  border-color: #F20D0D;\n  -webkit-transition: border 500ms ease-out;\n  transition: border 500ms ease-out;\n}\n.checkmark[data-v-fc96faea] {\n  opacity: 0;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n.checkmark.draw[data-v-fc96faea] {\n    opacity: 1;\n}\n.checkmark.draw[data-v-fc96faea]:after {\n    opacity: 1;\n    height: 25px;\n    width: 12.5px;\n    -webkit-transform-origin: left top;\n            transform-origin: left top;\n    border-right: 5px solid #26D97A;\n    border-top: 5px solid #26D97A;\n    content: '';\n    left: calc(12.5px - 5px);\n    top: calc(25px + 2px);\n    position: absolute;\n    -webkit-animation-duration: 1.2s;\n            animation-duration: 1.2s;\n    -webkit-animation-timing-function: ease;\n            animation-timing-function: ease;\n    -webkit-animation-name: checkmark-data-v-fc96faea;\n            animation-name: checkmark-data-v-fc96faea;\n    -webkit-transform: scaleX(-1) rotate(135deg);\n            transform: scaleX(-1) rotate(135deg);\n}\n.checkmark.error[data-v-fc96faea] {\n    position: absolute;\n    left: calc(12.5px - 2px);\n    top: 12.5px;\n    width: 25px;\n    height: 25px;\n    opacity: 0;\n}\n.checkmark.error.show[data-v-fc96faea] {\n      opacity: 1;\n}\n.checkmark.error[data-v-fc96faea]:before, .checkmark.error[data-v-fc96faea]:after {\n      position: absolute;\n      content: ' ';\n      height: 25px;\n      width: 5px;\n      background-color: #f00;\n}\n.checkmark.error[data-v-fc96faea]:before {\n      -webkit-transform: rotate(45deg);\n              transform: rotate(45deg);\n}\n.checkmark.error[data-v-fc96faea]:after {\n      -webkit-transform: rotate(-45deg);\n              transform: rotate(-45deg);\n}\n@-webkit-keyframes loader-spin-data-v-fc96faea {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes loader-spin-data-v-fc96faea {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@-webkit-keyframes checkmark-data-v-fc96faea {\n0% {\n    height: 0;\n    width: 0;\n    opacity: 1;\n}\n20% {\n    height: 0;\n    width: 12.5px;\n    opacity: 1;\n}\n40% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n100% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n}\n@keyframes checkmark-data-v-fc96faea {\n0% {\n    height: 0;\n    width: 0;\n    opacity: 1;\n}\n20% {\n    height: 0;\n    width: 12.5px;\n    opacity: 1;\n}\n40% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n100% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Laxit/ResultsModal.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,iBAAiB;CAClB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;CACnB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;CACzB;AACD;EACE,uBAAuB;EACvB,iBAAiB;CAClB;AACD;EACE,cAAc;CACf;AACD;IACI,iBAAiB;IACjB,YAAY;IACZ,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;EACE,sBAAsB;EACtB,qCAAqC;EACrC,2BAA2B;EAC3B,oDAAoD;UAC5C,4CAA4C;EACpD,+BAA+B;UACvB,uBAAuB;EAC/B,4CAA4C;UACpC,oCAAoC;EAC5C,0CAA0C;UAClC,kCAAkC;EAC1C,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,gCAAgC;UACxB,wBAAwB;CACjC;AACD;;EAEE,mBAAmB;EACnB,YAAY;EACZ,aAAa;CACd;AACD;EACE,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,kCAAkC;CACnC;AACD;EACE,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,kCAAkC;CACnC;AACD;EACE,WAAW;EACX,gCAAgC;UACxB,wBAAwB;CACjC;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,mCAAmC;YAC3B,2BAA2B;IACnC,gCAAgC;IAChC,8BAA8B;IAC9B,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,iCAAiC;YACzB,yBAAyB;IACjC,wCAAwC;YAChC,gCAAgC;IACxC,kDAAkD;YAC1C,0CAA0C;IAClD,6CAA6C;YACrC,qCAAqC;CAChD;AACD;IACI,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,WAAW;CACd;AACD;MACM,WAAW;CAChB;AACD;MACM,mBAAmB;MACnB,aAAa;MACb,aAAa;MACb,WAAW;MACX,uBAAuB;CAC5B;AACD;MACM,iCAAiC;cACzB,yBAAyB;CACtC;AACD;MACM,kCAAkC;cAC1B,0BAA0B;CACvC;AACD;AACA;IACI,gCAAgC;YACxB,wBAAwB;CACnC;AACD;IACI,kCAAkC;YAC1B,0BAA0B;CACrC;CACA;AACD;AACA;IACI,gCAAgC;YACxB,wBAAwB;CACnC;AACD;IACI,kCAAkC;YAC1B,0BAA0B;CACrC;CACA;AACD;AACA;IACI,UAAU;IACV,SAAS;IACT,WAAW;CACd;AACD;IACI,UAAU;IACV,cAAc;IACd,WAAW;CACd;AACD;IACI,aAAa;IACb,cAAc;IACd,WAAW;CACd;AACD;IACI,aAAa;IACb,cAAc;IACd,WAAW;CACd;CACA;AACD;AACA;IACI,UAAU;IACV,SAAS;IACT,WAAW;CACd;AACD;IACI,UAAU;IACV,cAAc;IACd,WAAW;CACd;AACD;IACI,aAAa;IACb,cAAc;IACd,WAAW;CACd;AACD;IACI,aAAa;IACb,cAAc;IACd,WAAW;CACd;CACA","file":"ResultsModal.vue","sourcesContent":["\n.dispatch-modal[data-v-fc96faea] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.dispatch-modal.show[data-v-fc96faea] {\n    top: 0;\n    opacity: 1;\n}\n.dispatch-modal-container[data-v-fc96faea] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.dispatch-modal-content[data-v-fc96faea] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.validation-modal .title[data-v-fc96faea] {\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n  background-color: #F25E0D;\n  padding: 8px 15px;\n}\n.validation-modal .message[data-v-fc96faea] {\n  font-size: 16px;\n  font-weight: 700;\n  color: #555;\n  padding: 15px 15px 10px;\n}\n.validation-modal .button[data-v-fc96faea] {\n  margin: 10px 15px 15px;\n  font-weight: 700;\n}\n.action-modal[data-v-fc96faea] {\n  padding: 15px;\n}\n.action-modal .message[data-v-fc96faea] {\n    font-weight: 700;\n    color: #777;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.action-modal .message.success[data-v-fc96faea] {\n      color: #26D97A;\n}\n.action-modal .message.error[data-v-fc96faea] {\n      color: #F20D0D;\n}\n.circle-loader[data-v-fc96faea] {\n  margin: 0 0 10px 10px;\n  border: 5px solid rgba(0, 0, 0, 0.2);\n  border-left-color: #26D97A;\n  -webkit-animation-name: loader-spin-data-v-fc96faea;\n          animation-name: loader-spin-data-v-fc96faea;\n  -webkit-animation-duration: 1s;\n          animation-duration: 1s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n.circle-loader[data-v-fc96faea],\n.circle-loader[data-v-fc96faea]:after {\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n}\n.load-complete[data-v-fc96faea] {\n  -webkit-animation: none;\n  animation: none;\n  border-color: #26D97A;\n  -webkit-transition: border 500ms ease-out;\n  transition: border 500ms ease-out;\n}\n.load-error[data-v-fc96faea] {\n  -webkit-animation: none;\n  animation: none;\n  border-color: #F20D0D;\n  -webkit-transition: border 500ms ease-out;\n  transition: border 500ms ease-out;\n}\n.checkmark[data-v-fc96faea] {\n  opacity: 0;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n.checkmark.draw[data-v-fc96faea] {\n    opacity: 1;\n}\n.checkmark.draw[data-v-fc96faea]:after {\n    opacity: 1;\n    height: 25px;\n    width: 12.5px;\n    -webkit-transform-origin: left top;\n            transform-origin: left top;\n    border-right: 5px solid #26D97A;\n    border-top: 5px solid #26D97A;\n    content: '';\n    left: calc(12.5px - 5px);\n    top: calc(25px + 2px);\n    position: absolute;\n    -webkit-animation-duration: 1.2s;\n            animation-duration: 1.2s;\n    -webkit-animation-timing-function: ease;\n            animation-timing-function: ease;\n    -webkit-animation-name: checkmark-data-v-fc96faea;\n            animation-name: checkmark-data-v-fc96faea;\n    -webkit-transform: scaleX(-1) rotate(135deg);\n            transform: scaleX(-1) rotate(135deg);\n}\n.checkmark.error[data-v-fc96faea] {\n    position: absolute;\n    left: calc(12.5px - 2px);\n    top: 12.5px;\n    width: 25px;\n    height: 25px;\n    opacity: 0;\n}\n.checkmark.error.show[data-v-fc96faea] {\n      opacity: 1;\n}\n.checkmark.error[data-v-fc96faea]:before, .checkmark.error[data-v-fc96faea]:after {\n      position: absolute;\n      content: ' ';\n      height: 25px;\n      width: 5px;\n      background-color: #f00;\n}\n.checkmark.error[data-v-fc96faea]:before {\n      -webkit-transform: rotate(45deg);\n              transform: rotate(45deg);\n}\n.checkmark.error[data-v-fc96faea]:after {\n      -webkit-transform: rotate(-45deg);\n              transform: rotate(-45deg);\n}\n@-webkit-keyframes loader-spin-data-v-fc96faea {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes loader-spin-data-v-fc96faea {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@-webkit-keyframes checkmark-data-v-fc96faea {\n0% {\n    height: 0;\n    width: 0;\n    opacity: 1;\n}\n20% {\n    height: 0;\n    width: 12.5px;\n    opacity: 1;\n}\n40% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n100% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n}\n@keyframes checkmark-data-v-fc96faea {\n0% {\n    height: 0;\n    width: 0;\n    opacity: 1;\n}\n20% {\n    height: 0;\n    width: 12.5px;\n    opacity: 1;\n}\n40% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n100% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'dispatch-modal': true, show: _vm.validationModal.show || _vm.actionModal.show },on:{"click":_vm.close}},[_c('div',{staticClass:"dispatch-modal-container"},[_c('div',{staticClass:"dispatch-modal-content",on:{"click":function($event){$event.stopPropagation();}}},[(_vm.validationModal.show)?_c('div',{staticClass:"validation-modal"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.validationModal.title))]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.validationModal.message))]),_vm._v(" "),_c('a',{staticClass:"button success",attrs:{"href":"javascript:;"},on:{"click":_vm.close}},[_vm._v("GOT IT.")])]):_vm._e(),_vm._v(" "),(_vm.actionModal.show)?_c('div',{staticClass:"action-modal"},[_c('div',{class:{
            'circle-loader': true,
            'load-complete': _vm.actionModal.done && _vm.actionModal.success,
            'load-error': _vm.actionModal.done && !_vm.actionModal.success
          }},[_c('div',{class:{
              checkmark: true,
              draw: _vm.actionModal.done && _vm.actionModal.success,
              'error show': _vm.actionModal.done && !_vm.actionModal.success
            }})]),_vm._v(" "),_c('div',{class:{
            message: true,
            success: _vm.actionModal.done && _vm.actionModal.success,
            error: _vm.actionModal.done && !_vm.actionModal.success
          }},[(_vm.actionModal.done)?_c('span',[_vm._v(_vm._s(_vm.actionModal.doneMessage))]):_c('span',[_vm._v(_vm._s(_vm.actionModal.ongoingMessage))])])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoutingModal_vue__ = __webpack_require__(660);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01dce994_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoutingModal_vue__ = __webpack_require__(2048);
function injectStyle (ssrContext) {
  __webpack_require__(2046)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01dce994"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoutingModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01dce994_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoutingModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2047);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("3e3b59b4", content, true, {});

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.routing-modal-container[data-v-01dce994] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.routing-modal-container.show[data-v-01dce994] {\n    top: 0;\n    opacity: 1;\n}\n.routing-modal[data-v-01dce994] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.routing-modal-content[data-v-01dce994] {\n  position: relative;\n  background-color: #fff;\n  border-radius: 3px;\n  width: 350px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.ajax-modal[data-v-01dce994] {\n  padding: 15px;\n}\n.ajax-modal i[data-v-01dce994] {\n    color: #777;\n    display: block;\n    margin-bottom: 10px;\n}\n.ajax-modal .message[data-v-01dce994] {\n    font-weight: 700;\n    color: #555;\n}\n.ajax-modal.success i[data-v-01dce994] {\n    color: #26D97A;\n}\n.ajax-modal.error i[data-v-01dce994] {\n    color: #F20D0D;\n}\n.validation-modal .title[data-v-01dce994] {\n  background-color: #333;\n  color: #fff;\n  padding: 10px;\n}\n.validation-modal .message[data-v-01dce994] {\n  font-weight: 700;\n  color: #555;\n  padding: 20px;\n}\n.validation-modal .button[data-v-01dce994] {\n  margin-bottom: 15px;\n}\n.confirmation-modal .title[data-v-01dce994] {\n  background-color: #333;\n  color: #fff;\n  padding: 10px;\n}\n.confirmation-modal .message[data-v-01dce994] {\n  font-weight: 700;\n  color: #555;\n  padding: 15px 20px 20px;\n}\n.confirmation-modal .controls[data-v-01dce994] {\n  padding: 0 20px 0px;\n}\n.confirmation-modal .close-button[data-v-01dce994] {\n  display: block;\n  font-weight: 700;\n  padding: 10px 15px 15px;\n  font-size: 12px;\n}\n.confirmation-modal .text-left[data-v-01dce994] {\n  text-align: left;\n}\n.confirmation-modal .text-left .message[data-v-01dce994] {\n    font-size: 14px;\n    padding: 15px;\n}\n.confirmation-modal .drivers[data-v-01dce994] {\n  padding: 0 15px;\n}\n.confirmation-modal .drivers .driver[data-v-01dce994] {\n    padding: 10px 15px;\n    margin-bottom: 5px;\n    background-color: #f5f5f5;\n    border-radius: 3px;\n    font-size: 14px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.confirmation-modal .drivers .driver a[data-v-01dce994] {\n      font-weight: 700;\n      display: inline-block;\n      margin-right: 5px;\n}\n.confirmation-modal .drivers .driver .name[data-v-01dce994] {\n      font-weight: 700;\n      text-decoration: none;\n}\n.padding-R[data-v-01dce994] {\n  padding-right: 7px;\n}\n.padding-L[data-v-01dce994] {\n  padding-left: 7px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Laxit/RoutingModal.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;EACE,cAAc;CACf;AACD;IACI,YAAY;IACZ,eAAe;IACf,oBAAoB;CACvB;AACD;IACI,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;CACf;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;CACf;AACD;EACE,oBAAoB;CACrB;AACD;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;CACf;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;CACzB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;CACjB;AACD;EACE,iBAAiB;CAClB;AACD;IACI,gBAAgB;IAChB,cAAc;CACjB;AACD;EACE,gBAAgB;CACjB;AACD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,qCAAqC;CACxC;AACD;MACM,iBAAiB;MACjB,sBAAsB;MACtB,kBAAkB;CACvB;AACD;MACM,iBAAiB;MACjB,sBAAsB;CAC3B;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB","file":"RoutingModal.vue","sourcesContent":["\n.routing-modal-container[data-v-01dce994] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.routing-modal-container.show[data-v-01dce994] {\n    top: 0;\n    opacity: 1;\n}\n.routing-modal[data-v-01dce994] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.routing-modal-content[data-v-01dce994] {\n  position: relative;\n  background-color: #fff;\n  border-radius: 3px;\n  width: 350px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.ajax-modal[data-v-01dce994] {\n  padding: 15px;\n}\n.ajax-modal i[data-v-01dce994] {\n    color: #777;\n    display: block;\n    margin-bottom: 10px;\n}\n.ajax-modal .message[data-v-01dce994] {\n    font-weight: 700;\n    color: #555;\n}\n.ajax-modal.success i[data-v-01dce994] {\n    color: #26D97A;\n}\n.ajax-modal.error i[data-v-01dce994] {\n    color: #F20D0D;\n}\n.validation-modal .title[data-v-01dce994] {\n  background-color: #333;\n  color: #fff;\n  padding: 10px;\n}\n.validation-modal .message[data-v-01dce994] {\n  font-weight: 700;\n  color: #555;\n  padding: 20px;\n}\n.validation-modal .button[data-v-01dce994] {\n  margin-bottom: 15px;\n}\n.confirmation-modal .title[data-v-01dce994] {\n  background-color: #333;\n  color: #fff;\n  padding: 10px;\n}\n.confirmation-modal .message[data-v-01dce994] {\n  font-weight: 700;\n  color: #555;\n  padding: 15px 20px 20px;\n}\n.confirmation-modal .controls[data-v-01dce994] {\n  padding: 0 20px 0px;\n}\n.confirmation-modal .close-button[data-v-01dce994] {\n  display: block;\n  font-weight: 700;\n  padding: 10px 15px 15px;\n  font-size: 12px;\n}\n.confirmation-modal .text-left[data-v-01dce994] {\n  text-align: left;\n}\n.confirmation-modal .text-left .message[data-v-01dce994] {\n    font-size: 14px;\n    padding: 15px;\n}\n.confirmation-modal .drivers[data-v-01dce994] {\n  padding: 0 15px;\n}\n.confirmation-modal .drivers .driver[data-v-01dce994] {\n    padding: 10px 15px;\n    margin-bottom: 5px;\n    background-color: #f5f5f5;\n    border-radius: 3px;\n    font-size: 14px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.confirmation-modal .drivers .driver a[data-v-01dce994] {\n      font-weight: 700;\n      display: inline-block;\n      margin-right: 5px;\n}\n.confirmation-modal .drivers .driver .name[data-v-01dce994] {\n      font-weight: 700;\n      text-decoration: none;\n}\n.padding-R[data-v-01dce994] {\n  padding-right: 7px;\n}\n.padding-L[data-v-01dce994] {\n  padding-left: 7px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'routing-modal-container': true, show: _vm.modal.show },on:{"click":_vm.close}},[_c('div',{staticClass:"routing-modal"},[_c('div',{staticClass:"routing-modal-content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modal.validation.show),expression:"modal.validation.show"}],class:{ 'validation-modal': true },on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.modal.validation.title))]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.modal.validation.message))]),_vm._v(" "),_c('a',{staticClass:"button small cta",attrs:{"href":"javascript:;"},on:{"click":_vm.close}},[_vm._v("OK, GOT IT.")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modal.ajax.show),expression:"modal.ajax.show"}],class:{
              'ajax-modal': true,
              error: !_vm.modal.ajax.loading && !_vm.modal.ajax.success,
              success: !_vm.modal.ajax.loading && _vm.modal.ajax.success
            },on:{"click":function($event){$event.stopPropagation();}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.modal.ajax.loading),expression:"modal.ajax.loading"}],staticClass:"fas fa-circle-notch fa-spin fa-3x"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.modal.ajax.loading && !_vm.modal.ajax.success),expression:"!modal.ajax.loading && !modal.ajax.success"}],staticClass:"fas fa-times-circle fa-3x"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.modal.ajax.loading && _vm.modal.ajax.success),expression:"!modal.ajax.loading && modal.ajax.success"}],staticClass:"fas fa-check-circle fa-3x"}),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.modal.ajax.message))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modal.confirmation.show),expression:"modal.confirmation.show"}],staticClass:"confirmation-modal",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.modal.confirmation.title))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasMultipleDrivers),expression:"!hasMultipleDrivers"}]},[_c('div',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.modal.confirmation.message)}}),_vm._v(" "),_c('div',{staticClass:"row controls"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modal.confirmation.action === 'SAVE_PACKAGE_KEEP_DRIVER'),expression:"modal.confirmation.action === 'SAVE_PACKAGE_KEEP_DRIVER'"}],staticClass:"small-6 columns padding-R"},[_c('a',{staticClass:"button cta small block",attrs:{"href":"javascript:;"},on:{"click":_vm.closeAction}},[_vm._v("UNASSIGN IT.")])]),_vm._v(" "),_c('div',{class:{
              'columns': true,
              'small-6 padding-L': _vm.modal.confirmation.action === 'SAVE_PACKAGE_KEEP_DRIVER',
              'small-12': _vm.modal.confirmation.action === 'SAVE_PACKAGE'
            }},[_c('a',{staticClass:"button cta small success block",attrs:{"href":"javascript:;"},on:{"click":_vm.confirmAction}},[_vm._v("YES, I DO.")])])])]),_vm._v(" "),(_vm.hasMultipleDrivers)?_c('div',{staticClass:"text-left"},[_c('div',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.modal.confirmation.message)}}),_vm._v(" "),_c('div',{staticClass:"drivers"},[_vm._l((_vm.dropzoneDrivers),function(item,index){return _c('div',{staticClass:"driver"},[_c('a',{attrs:{"href":'/#/provider/' + item.driver.ID,"target":"_blank"},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(_vm._s(item.driver.ID))]),_vm._v(" "),_c('a',{staticClass:"name",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.savePackage(item.driver.ID)}}},[_vm._v(_vm._s(item.driver.firstName)+" "+_vm._s(item.driver.lastName))])])}),_vm._v(" "),_c('div',{staticClass:"driver"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.savePackage(null)}}},[_vm._v("I'll assign this package later.")])])],2)]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"close-button",attrs:{"href":"javascript:;"},on:{"click":_vm.close}},[_vm._v("Cancel my changes.")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__(661);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11459c06_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__(2052);
function injectStyle (ssrContext) {
  __webpack_require__(2050)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11459c06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11459c06_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2051);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("e1228154", content, true, {});

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.routing-map[data-v-11459c06] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.routing-map .routing-map[data-v-11459c06] {\n    display: none;\n}\n.map-here[data-v-11459c06] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.stop-info[data-v-11459c06] {\n  color: #333;\n  font-size: 12px;\n}\n.stop-info a[data-v-11459c06], .stop-info .value[data-v-11459c06] {\n    font-weight: 700;\n}\n.stop-info .value[data-v-11459c06] {\n    color: #555;\n}\n.stop-info .stop-id[data-v-11459c06] {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    padding: 0 0 7px 0;\n    margin-bottom: 10px;\n}\n.stop-info .stop-id > *[data-v-11459c06] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.stop-info .stop-location[data-v-11459c06] {\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    line-height: 16px;\n    text-align: center;\n    border-radius: 100%;\n    background-color: #F20D0D;\n    margin-right: 5px;\n    color: #fff;\n    font-weight: 700;\n}\n.stop-info .stop-location.pickup[data-v-11459c06] {\n      background-color: #26D97A;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Laxit/Map.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;CACd;AACD;IACI,cAAc;CACjB;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;CACd;AACD;EACE,YAAY;EACZ,gBAAgB;CACjB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,YAAY;CACf;AACD;IACI,6CAA6C;IAC7C,mBAAmB;IACnB,oBAAoB;CACvB;AACD;MACM,sBAAsB;MACtB,uBAAuB;CAC5B;AACD;IACI,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;CACpB;AACD;MACM,0BAA0B;CAC/B","file":"Map.vue","sourcesContent":["\n.routing-map[data-v-11459c06] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.routing-map .routing-map[data-v-11459c06] {\n    display: none;\n}\n.map-here[data-v-11459c06] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.stop-info[data-v-11459c06] {\n  color: #333;\n  font-size: 12px;\n}\n.stop-info a[data-v-11459c06], .stop-info .value[data-v-11459c06] {\n    font-weight: 700;\n}\n.stop-info .value[data-v-11459c06] {\n    color: #555;\n}\n.stop-info .stop-id[data-v-11459c06] {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    padding: 0 0 7px 0;\n    margin-bottom: 10px;\n}\n.stop-info .stop-id > *[data-v-11459c06] {\n      display: inline-block;\n      vertical-align: middle;\n}\n.stop-info .stop-location[data-v-11459c06] {\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    line-height: 16px;\n    text-align: center;\n    border-radius: 100%;\n    background-color: #F20D0D;\n    margin-right: 5px;\n    color: #fff;\n    font-weight: 700;\n}\n.stop-info .stop-location.pickup[data-v-11459c06] {\n      background-color: #26D97A;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"routing-map"},[_c('div',{staticClass:"map-here",attrs:{"id":"mapHere2"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TncReservations_vue__ = __webpack_require__(662);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_122aae2e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TncReservations_vue__ = __webpack_require__(2060);
function injectStyle (ssrContext) {
  __webpack_require__(2054)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-122aae2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TncReservations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_122aae2e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TncReservations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2055);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2cf52068", content, true, {});

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.table-loader[data-v-122aae2e] {\n  position: relative;\n  width: 100%;\n  margin: 50px auto;\n  text-align: center;\n}\n.table-loader .loader-title[data-v-122aae2e] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.table-loader .loader-text[data-v-122aae2e] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\ntable[data-v-122aae2e] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-122aae2e] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    border-right: none;\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-122aae2e] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-122aae2e] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-122aae2e] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-122aae2e] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-122aae2e] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-122aae2e] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-122aae2e] {\n          color: #ccc;\n}\ntable input[data-v-122aae2e] {\n    display: inline-block;\n    width: auto;\n}\ntable .type[data-v-122aae2e] {\n    display: inline-block;\n    padding: 3px 6px;\n    text-transform: uppercase;\n    border-radius: 4px;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 600;\n}\ntable .type.tnc[data-v-122aae2e] {\n      background: #2ab77c;\n}\ntable .type.tcp[data-v-122aae2e] {\n      background: #3f81a0;\n}\ntable .type.psc[data-v-122aae2e] {\n      background: #de6c2a;\n}\ntable .status[data-v-122aae2e] {\n    text-transform: capitalize;\n}\ntable .expired[data-v-122aae2e] {\n    color: #de2929;\n}\ntable .fa-check-circle[data-v-122aae2e] {\n    color: #0fda4e;\n}\ntable .fa-times-circle[data-v-122aae2e] {\n    color: #ef3535;\n}\ntable a[data-v-122aae2e] {\n    cursor: pointer;\n}\ntable .date[data-v-122aae2e] {\n    word-spacing: 5px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Laxit/TncReservations.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;CACpB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;CAClB;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;EACE,0BAA0B;EAC1B,YAAY;CACb;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,mBAAmB;IACnB,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,2BAA2B;CAChC;AACD;QACQ,iBAAiB;CACxB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;IACI,sBAAsB;IACtB,YAAY;CACf;AACD;IACI,sBAAsB;IACtB,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;CACpB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;IACI,2BAA2B;CAC9B;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,kBAAkB;CACrB","file":"TncReservations.vue","sourcesContent":["\n.table-loader[data-v-122aae2e] {\n  position: relative;\n  width: 100%;\n  margin: 50px auto;\n  text-align: center;\n}\n.table-loader .loader-title[data-v-122aae2e] {\n    font-weight: 700;\n    margin-top: 20px;\n    font-size: 20px;\n    color: #3F2975;\n}\n.table-loader .loader-text[data-v-122aae2e] {\n    font-weight: 700;\n    margin-top: 10px;\n    font-size: 16px;\n    color: #777;\n}\ntable[data-v-122aae2e] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-122aae2e] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    border-right: none;\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-122aae2e] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-122aae2e] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-122aae2e] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-122aae2e] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-122aae2e] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-122aae2e] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-122aae2e] {\n          color: #ccc;\n}\ntable input[data-v-122aae2e] {\n    display: inline-block;\n    width: auto;\n}\ntable .type[data-v-122aae2e] {\n    display: inline-block;\n    padding: 3px 6px;\n    text-transform: uppercase;\n    border-radius: 4px;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 600;\n}\ntable .type.tnc[data-v-122aae2e] {\n      background: #2ab77c;\n}\ntable .type.tcp[data-v-122aae2e] {\n      background: #3f81a0;\n}\ntable .type.psc[data-v-122aae2e] {\n      background: #de6c2a;\n}\ntable .status[data-v-122aae2e] {\n    text-transform: capitalize;\n}\ntable .expired[data-v-122aae2e] {\n    color: #de2929;\n}\ntable .fa-check-circle[data-v-122aae2e] {\n    color: #0fda4e;\n}\ntable .fa-times-circle[data-v-122aae2e] {\n    color: #ef3535;\n}\ntable a[data-v-122aae2e] {\n    cursor: pointer;\n}\ntable .date[data-v-122aae2e] {\n    word-spacing: 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TncReservationsRow_vue__ = __webpack_require__(663);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de22fbda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TncReservationsRow_vue__ = __webpack_require__(2059);
function injectStyle (ssrContext) {
  __webpack_require__(2057)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-de22fbda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TncReservationsRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de22fbda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TncReservationsRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2058);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("9a35ca52", content, true, {});

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.status[data-v-de22fbda] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-de22fbda], .status.completed[data-v-de22fbda] {\n    background: #26D97A;\n}\n.status.canceled[data-v-de22fbda], .status.cancelled[data-v-de22fbda], .status.failed[data-v-de22fbda] {\n    background: #bbb;\n}\n.status.upcoming[data-v-de22fbda] {\n    background: #f38d56;\n}\n.status.onboard[data-v-de22fbda] {\n    background: #dc3168;\n}\n.status.ready[data-v-de22fbda] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-de22fbda], .status.requires_dispatch[data-v-de22fbda] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-de22fbda] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-de22fbda] {\n    background: #5662f3;\n}\n.flight-status[data-v-de22fbda] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-de22fbda] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-de22fbda] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-de22fbda] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-de22fbda] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-de22fbda] {\n    background-color: #f35656;\n}\n.service-type[data-v-de22fbda] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-de22fbda] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-de22fbda] {\n    background: #26D97A;\n}\n.service-type.black[data-v-de22fbda] {\n    background: #777;\n}\n.service-type.suv[data-v-de22fbda] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-de22fbda] {\n    background: #6dabc3;\n}\n.license-type[data-v-de22fbda] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-de22fbda] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-de22fbda] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-de22fbda] {\n    background-color: #de6c2a;\n}\n.dragslot[data-v-de22fbda] {\n  font-weight: 700;\n  background-color: #fff;\n  padding: 5px;\n  -webkit-box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(0, 0, 0, 0.4);\n  border-radius: 3px;\n}\n.table-item[data-v-de22fbda] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.table-item input[type=\"checkbox\"][data-v-de22fbda] {\n    margin-top: 0;\n    width: auto;\n}\n.table-item td[data-v-de22fbda] {\n    padding: 5px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.table-item td a[data-v-de22fbda] {\n      font-weight: 700;\n}\n.table-item td.map-button[data-v-de22fbda] {\n      padding: 10px;\n}\n.table-item td.map-button a[data-v-de22fbda] {\n        color: #fff;\n        background-color: #aaa;\n        width: 30px;\n        height: 30px;\n        line-height: 30px;\n        text-align: center;\n        display: inline-block;\n        border-radius: 30px;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.table-item td.map-button a i[data-v-de22fbda] {\n          line-height: inherit;\n}\n.table-item td.map-button a.disabled[data-v-de22fbda] {\n          pointer-events: none;\n          opacity: 0.5;\n          background-color: #bbb;\n}\n.table-item td.map-button a.selected[data-v-de22fbda] {\n          background-color: #26D97A;\n}\n.table-item td.pool-yes[data-v-de22fbda] {\n      color: #26D97A;\n}\n.table-item td.pool-no[data-v-de22fbda] {\n      color: #F20D0D;\n}\n.table-item td.pkg-check[data-v-de22fbda] {\n      width: 24px !important;\n}\n.table-item td.pkg-check input[data-v-de22fbda] {\n        margin: 0 auto;\n}\n.table-item td.pkg-id[data-v-de22fbda] {\n      width: 53px !important;\n}\n.table-item td.pkg-id i[data-v-de22fbda] {\n        font-size: 12px;\n}\n.table-item td.pkg-status[data-v-de22fbda] {\n      width: 90px !important;\n}\n.table-item td.pkg-pickup-time[data-v-de22fbda] {\n      width: 80px !important;\n}\n.table-item td.pkg-pickup[data-v-de22fbda], .table-item td.pkg-dropoff[data-v-de22fbda] {\n      width: 140px !important;\n}\n.table-item td.pkg-driver[data-v-de22fbda] {\n      width: 86px !important;\n}\n.table-item td.pkg-payment[data-v-de22fbda] {\n      width: 65px !important;\n}\n.table-item td.pkg-ada[data-v-de22fbda] {\n      width: 50px !important;\n}\n.table-item td.pkg-stops[data-v-de22fbda] {\n      width: 47px !important;\n}\n.table-item td.pkg-pax[data-v-de22fbda] {\n      width: 32px !important;\n}\n.table-item td.pkg-luggage[data-v-de22fbda] {\n      width: 66px !important;\n}\n.table-item td.pkg-in-pool[data-v-de22fbda] {\n      width: 43px !important;\n}\n.table-item td.pkg-map[data-v-de22fbda] {\n      width: 40px !important;\n}\n.last-dropoff[data-v-de22fbda] {\n  position: relative;\n  text-decoration: underline;\n  font-weight: 700;\n}\n.last-dropoff .eta-popup[data-v-de22fbda] {\n    position: absolute;\n    top: 0;\n    left: 100%;\n    background-color: #e5e5e5;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n    padding: 10px;\n    overflow: hidden;\n    height: 0;\n    width: 0;\n    padding: 0;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n    text-decoration: none;\n    font-weight: 400;\n    border-radius: 3px;\n    text-align: center;\n}\n.last-dropoff .eta-popup.show[data-v-de22fbda] {\n      padding: 5px;\n      width: 170px;\n      height: auto;\n}\n.rtg[data-v-de22fbda] {\n  color: #fff;\n  line-height: 1;\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 600;\n  margin: 2px 4px;\n  cursor: pointer;\n  padding: 3px 15px;\n  border-radius: 4px;\n  background: #2586f3;\n  letter-spacing: 1px;\n  border-bottom: 3px solid #084991;\n}\n.notes[data-v-de22fbda] {\n  color: #fff;\n  line-height: 1;\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 600;\n  margin: 2px 4px;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  background: #f44336;\n  letter-spacing: 1px;\n  border-bottom: 3px solid #863a34;\n}\n@media only screen and (max-width: 430px) {\n.table-card[data-v-de22fbda] {\n    border: 1px solid #ccc;\n    margin: 10px;\n    margin-bottom: 15px;\n    padding: 10px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-size: 13px;\n}\n.table-card a[data-v-de22fbda] {\n      font-weight: 900;\n}\n.table-card i[data-v-de22fbda] {\n      color: #0d79f2;\n}\n.table-card .pool-yes i[data-v-de22fbda] {\n      color: #26D97A;\n}\n.table-card .pool-no i[data-v-de22fbda] {\n      color: #F20D0D;\n}\n.table-card > div[data-v-de22fbda] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n      margin-bottom: 3px;\n}\n.table-card > div.see-more[data-v-de22fbda] {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        -webkit-box-pack: start;\n            -ms-flex-pack: start;\n                justify-content: flex-start;\n        -webkit-box-align: start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n}\n.table-card .toggle-div[data-v-de22fbda] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .toggle-div .toggle[data-v-de22fbda] {\n        font-size: 16px;\n        color: #0e79f2;\n}\n.table-card .row-1 .link[data-v-de22fbda] {\n      padding-bottom: 5px;\n      display: inline-block;\n}\n.table-card .row-1 .rtg[data-v-de22fbda] {\n      display: inline-block;\n      margin: 4px;\n}\n.table-card .row-1 i[data-v-de22fbda] {\n      color: #26D97A;\n}\n.table-card .row-1 input[data-v-de22fbda] {\n      display: inline-block;\n      margin: 0;\n      width: 15px;\n      height: 15px;\n      margin-right: 5px;\n}\n.table-card .row-1 .map-button a[data-v-de22fbda] {\n      background-color: #aaa;\n      width: 30px;\n      height: 30px;\n      line-height: 30px;\n      text-align: center;\n      border-radius: 30px;\n      -webkit-transition: all 250ms;\n      transition: all 250ms;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      text-decoration: none;\n}\n.table-card .row-1 .map-button a i[data-v-de22fbda] {\n        color: #fff;\n}\n.table-card .row-1 .map-button a.disabled[data-v-de22fbda] {\n        pointer-events: none;\n        opacity: 0.5;\n        background-color: #bbb;\n}\n.table-card .row-1 .map-button a.selected[data-v-de22fbda] {\n        background-color: #26D97A;\n}\n.table-card .row-2[data-v-de22fbda] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: unset;\n          -ms-flex-pack: unset;\n              justify-content: unset;\n      gap: 5px;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .row-2 .image img[data-v-de22fbda] {\n        min-width: 30px;\n        max-width: 30px;\n}\n.table-card .row-7 strong[data-v-de22fbda] {\n      color: #666;\n}\n.table-card .row-7 i[data-v-de22fbda] {\n      color: #666;\n      margin: 0 3px;\n}\n.table-card .row-8[data-v-de22fbda] {\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.table-card .row-8 .actions[data-v-de22fbda] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.table-card .row-8 .actions span[data-v-de22fbda] {\n          padding: 8px 20px;\n}\n.table-card .row-8 .actions .notes i[data-v-de22fbda] {\n          color: #fff;\n}\n.table-card .clock i[data-v-de22fbda] {\n      color: #F25E0D;\n}\n.table-card .pickup i[data-v-de22fbda] {\n      color: #d92626;\n}\n.table-card .dropoff i[data-v-de22fbda] {\n      color: #26D97A;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Laxit/TncReservationsRow.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;CAC3B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;EAClD,qCAAqC;EACrC,mBAAmB;CACpB;AACD;EACE,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;CACpB;AACD;IACI,cAAc;IACd,YAAY;CACf;AACD;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;CACtB;AACD;MACM,iBAAiB;CACtB;AACD;MACM,cAAc;CACnB;AACD;QACQ,YAAY;QACZ,uBAAuB;QACvB,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,mBAAmB;QACnB,sBAAsB;QACtB,oBAAoB;QACpB,8BAA8B;QAC9B,sBAAsB;CAC7B;AACD;UACU,qBAAqB;CAC9B;AACD;UACU,qBAAqB;UACrB,aAAa;UACb,uBAAuB;CAChC;AACD;UACU,0BAA0B;CACnC;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,uBAAuB;CAC5B;AACD;QACQ,eAAe;CACtB;AACD;MACM,uBAAuB;CAC5B;AACD;QACQ,gBAAgB;CACvB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,wBAAwB;CAC7B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;CAClB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,WAAW;IACX,0BAA0B;IAC1B,qCAAqC;IACrC,kDAAkD;YAC1C,0CAA0C;IAClD,cAAc;IACd,iBAAiB;IACjB,UAAU;IACV,SAAS;IACT,WAAW;IACX,8BAA8B;IAC9B,sBAAsB;IACtB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;CACtB;AACD;MACM,aAAa;MACb,aAAa;MACb,aAAa;CAClB;AACD;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,iCAAiC;CAClC;AACD;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,iCAAiC;CAClC;AACD;AACA;IACI,uBAAuB;IACvB,aAAa;IACb,oBAAoB;IACpB,cAAc;IACd,+BAA+B;IAC/B,oBAAoB;IACpB,gBAAgB;CACnB;AACD;MACM,iBAAiB;CACtB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,uBAAuB;UACnB,oBAAoB;cAChB,sBAAsB;MAC9B,mBAAmB;CACxB;AACD;QACQ,6BAA6B;QAC7B,8BAA8B;YAC1B,2BAA2B;gBACvB,uBAAuB;QAC/B,wBAAwB;YACpB,qBAAqB;gBACjB,4BAA4B;QACpC,yBAAyB;YACrB,sBAAsB;gBAClB,wBAAwB;CACvC;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,+BAA+B;MACvC,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;QACQ,gBAAgB;QAChB,eAAe;CACtB;AACD;MACM,oBAAoB;MACpB,sBAAsB;CAC3B;AACD;MACM,sBAAsB;MACtB,YAAY;CACjB;AACD;MACM,eAAe;CACpB;AACD;MACM,sBAAsB;MACtB,UAAU;MACV,YAAY;MACZ,aAAa;MACb,kBAAkB;CACvB;AACD;MACM,uBAAuB;MACvB,YAAY;MACZ,aAAa;MACb,kBAAkB;MAClB,mBAAmB;MACnB,oBAAoB;MACpB,8BAA8B;MAC9B,sBAAsB;MACtB,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;MAC5B,yBAAyB;UACrB,sBAAsB;cAClB,wBAAwB;MAChC,sBAAsB;CAC3B;AACD;QACQ,YAAY;CACnB;AACD;QACQ,qBAAqB;QACrB,aAAa;QACb,uBAAuB;CAC9B;AACD;QACQ,0BAA0B;CACjC;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,wBAAwB;UACpB,qBAAqB;cACjB,uBAAuB;MAC/B,SAAS;MACT,0BAA0B;UACtB,uBAAuB;cACnB,oBAAoB;CACjC;AACD;QACQ,gBAAgB;QAChB,gBAAgB;CACvB;AACD;MACM,YAAY;CACjB;AACD;MACM,YAAY;MACZ,cAAc;CACnB;AACD;MACM,yBAAyB;UACrB,sBAAsB;cAClB,wBAAwB;CACrC;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;CACrB;AACD;UACU,kBAAkB;CAC3B;AACD;UACU,YAAY;CACrB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;CACA","file":"TncReservationsRow.vue","sourcesContent":["\n.status[data-v-de22fbda] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-de22fbda], .status.completed[data-v-de22fbda] {\n    background: #26D97A;\n}\n.status.canceled[data-v-de22fbda], .status.cancelled[data-v-de22fbda], .status.failed[data-v-de22fbda] {\n    background: #bbb;\n}\n.status.upcoming[data-v-de22fbda] {\n    background: #f38d56;\n}\n.status.onboard[data-v-de22fbda] {\n    background: #dc3168;\n}\n.status.ready[data-v-de22fbda] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-de22fbda], .status.requires_dispatch[data-v-de22fbda] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-de22fbda] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-de22fbda] {\n    background: #5662f3;\n}\n.flight-status[data-v-de22fbda] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-de22fbda] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-de22fbda] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-de22fbda] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-de22fbda] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-de22fbda] {\n    background-color: #f35656;\n}\n.service-type[data-v-de22fbda] {\n  display: inline-block;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n}\n.service-type.shared[data-v-de22fbda] {\n    background: #f38d56;\n}\n.service-type.opoli[data-v-de22fbda] {\n    background: #26D97A;\n}\n.service-type.black[data-v-de22fbda] {\n    background: #777;\n}\n.service-type.suv[data-v-de22fbda] {\n    background: #dc3168;\n}\n.service-type.shuttle[data-v-de22fbda] {\n    background: #6dabc3;\n}\n.license-type[data-v-de22fbda] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.license-type.tnc[data-v-de22fbda] {\n    background-color: #2ab77c;\n}\n.license-type.tcp[data-v-de22fbda] {\n    background-color: #3f81a0;\n}\n.license-type.psc[data-v-de22fbda] {\n    background-color: #de6c2a;\n}\n.dragslot[data-v-de22fbda] {\n  font-weight: 700;\n  background-color: #fff;\n  padding: 5px;\n  -webkit-box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(0, 0, 0, 0.4);\n  border-radius: 3px;\n}\n.table-item[data-v-de22fbda] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.table-item input[type=\"checkbox\"][data-v-de22fbda] {\n    margin-top: 0;\n    width: auto;\n}\n.table-item td[data-v-de22fbda] {\n    padding: 5px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.table-item td a[data-v-de22fbda] {\n      font-weight: 700;\n}\n.table-item td.map-button[data-v-de22fbda] {\n      padding: 10px;\n}\n.table-item td.map-button a[data-v-de22fbda] {\n        color: #fff;\n        background-color: #aaa;\n        width: 30px;\n        height: 30px;\n        line-height: 30px;\n        text-align: center;\n        display: inline-block;\n        border-radius: 30px;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.table-item td.map-button a i[data-v-de22fbda] {\n          line-height: inherit;\n}\n.table-item td.map-button a.disabled[data-v-de22fbda] {\n          pointer-events: none;\n          opacity: 0.5;\n          background-color: #bbb;\n}\n.table-item td.map-button a.selected[data-v-de22fbda] {\n          background-color: #26D97A;\n}\n.table-item td.pool-yes[data-v-de22fbda] {\n      color: #26D97A;\n}\n.table-item td.pool-no[data-v-de22fbda] {\n      color: #F20D0D;\n}\n.table-item td.pkg-check[data-v-de22fbda] {\n      width: 24px !important;\n}\n.table-item td.pkg-check input[data-v-de22fbda] {\n        margin: 0 auto;\n}\n.table-item td.pkg-id[data-v-de22fbda] {\n      width: 53px !important;\n}\n.table-item td.pkg-id i[data-v-de22fbda] {\n        font-size: 12px;\n}\n.table-item td.pkg-status[data-v-de22fbda] {\n      width: 90px !important;\n}\n.table-item td.pkg-pickup-time[data-v-de22fbda] {\n      width: 80px !important;\n}\n.table-item td.pkg-pickup[data-v-de22fbda], .table-item td.pkg-dropoff[data-v-de22fbda] {\n      width: 140px !important;\n}\n.table-item td.pkg-driver[data-v-de22fbda] {\n      width: 86px !important;\n}\n.table-item td.pkg-payment[data-v-de22fbda] {\n      width: 65px !important;\n}\n.table-item td.pkg-ada[data-v-de22fbda] {\n      width: 50px !important;\n}\n.table-item td.pkg-stops[data-v-de22fbda] {\n      width: 47px !important;\n}\n.table-item td.pkg-pax[data-v-de22fbda] {\n      width: 32px !important;\n}\n.table-item td.pkg-luggage[data-v-de22fbda] {\n      width: 66px !important;\n}\n.table-item td.pkg-in-pool[data-v-de22fbda] {\n      width: 43px !important;\n}\n.table-item td.pkg-map[data-v-de22fbda] {\n      width: 40px !important;\n}\n.last-dropoff[data-v-de22fbda] {\n  position: relative;\n  text-decoration: underline;\n  font-weight: 700;\n}\n.last-dropoff .eta-popup[data-v-de22fbda] {\n    position: absolute;\n    top: 0;\n    left: 100%;\n    background-color: #e5e5e5;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n    padding: 10px;\n    overflow: hidden;\n    height: 0;\n    width: 0;\n    padding: 0;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n    text-decoration: none;\n    font-weight: 400;\n    border-radius: 3px;\n    text-align: center;\n}\n.last-dropoff .eta-popup.show[data-v-de22fbda] {\n      padding: 5px;\n      width: 170px;\n      height: auto;\n}\n.rtg[data-v-de22fbda] {\n  color: #fff;\n  line-height: 1;\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 600;\n  margin: 2px 4px;\n  cursor: pointer;\n  padding: 3px 15px;\n  border-radius: 4px;\n  background: #2586f3;\n  letter-spacing: 1px;\n  border-bottom: 3px solid #084991;\n}\n.notes[data-v-de22fbda] {\n  color: #fff;\n  line-height: 1;\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 600;\n  margin: 2px 4px;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  background: #f44336;\n  letter-spacing: 1px;\n  border-bottom: 3px solid #863a34;\n}\n@media only screen and (max-width: 430px) {\n.table-card[data-v-de22fbda] {\n    border: 1px solid #ccc;\n    margin: 10px;\n    margin-bottom: 15px;\n    padding: 10px;\n    border-bottom: 5px solid #aaa9;\n    border-radius: 10px;\n    font-size: 13px;\n}\n.table-card a[data-v-de22fbda] {\n      font-weight: 900;\n}\n.table-card i[data-v-de22fbda] {\n      color: #0d79f2;\n}\n.table-card .pool-yes i[data-v-de22fbda] {\n      color: #26D97A;\n}\n.table-card .pool-no i[data-v-de22fbda] {\n      color: #F20D0D;\n}\n.table-card > div[data-v-de22fbda] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n      margin-bottom: 3px;\n}\n.table-card > div.see-more[data-v-de22fbda] {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        -webkit-box-pack: start;\n            -ms-flex-pack: start;\n                justify-content: flex-start;\n        -webkit-box-align: start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n}\n.table-card .toggle-div[data-v-de22fbda] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .toggle-div .toggle[data-v-de22fbda] {\n        font-size: 16px;\n        color: #0e79f2;\n}\n.table-card .row-1 .link[data-v-de22fbda] {\n      padding-bottom: 5px;\n      display: inline-block;\n}\n.table-card .row-1 .rtg[data-v-de22fbda] {\n      display: inline-block;\n      margin: 4px;\n}\n.table-card .row-1 i[data-v-de22fbda] {\n      color: #26D97A;\n}\n.table-card .row-1 input[data-v-de22fbda] {\n      display: inline-block;\n      margin: 0;\n      width: 15px;\n      height: 15px;\n      margin-right: 5px;\n}\n.table-card .row-1 .map-button a[data-v-de22fbda] {\n      background-color: #aaa;\n      width: 30px;\n      height: 30px;\n      line-height: 30px;\n      text-align: center;\n      border-radius: 30px;\n      -webkit-transition: all 250ms;\n      transition: all 250ms;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      text-decoration: none;\n}\n.table-card .row-1 .map-button a i[data-v-de22fbda] {\n        color: #fff;\n}\n.table-card .row-1 .map-button a.disabled[data-v-de22fbda] {\n        pointer-events: none;\n        opacity: 0.5;\n        background-color: #bbb;\n}\n.table-card .row-1 .map-button a.selected[data-v-de22fbda] {\n        background-color: #26D97A;\n}\n.table-card .row-2[data-v-de22fbda] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: unset;\n          -ms-flex-pack: unset;\n              justify-content: unset;\n      gap: 5px;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.table-card .row-2 .image img[data-v-de22fbda] {\n        min-width: 30px;\n        max-width: 30px;\n}\n.table-card .row-7 strong[data-v-de22fbda] {\n      color: #666;\n}\n.table-card .row-7 i[data-v-de22fbda] {\n      color: #666;\n      margin: 0 3px;\n}\n.table-card .row-8[data-v-de22fbda] {\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.table-card .row-8 .actions[data-v-de22fbda] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.table-card .row-8 .actions span[data-v-de22fbda] {\n          padding: 8px 20px;\n}\n.table-card .row-8 .actions .notes i[data-v-de22fbda] {\n          color: #fff;\n}\n.table-card .clock i[data-v-de22fbda] {\n      color: #F25E0D;\n}\n.table-card .pickup i[data-v-de22fbda] {\n      color: #d92626;\n}\n.table-card .dropoff i[data-v-de22fbda] {\n      color: #26D97A;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('drag',{staticClass:"table-item",attrs:{"tag":"tr","transfer-data":_vm.opPackage,"draggable":!_vm.inMap && _vm.opPackage.type === 'package'},on:{"dragstart":_vm.dragstart,"dragend":function($event){return _vm.$store.commit('laxit/setDropzoneShow', false)}}},[_c('div',{staticClass:"dragslot",attrs:{"slot":"image"},slot:"image"},[_vm._v("Package "+_vm._s(_vm.opPackage.id))]),_vm._v(" "),_c('td',{staticClass:"pkg-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedPackages),expression:"checkedPackages"}],attrs:{"type":"checkbox"},domProps:{"value":_vm.opPackage.id,"checked":Array.isArray(_vm.checkedPackages)?_vm._i(_vm.checkedPackages,_vm.opPackage.id)>-1:(_vm.checkedPackages)},on:{"change":function($event){var $$a=_vm.checkedPackages,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.opPackage.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedPackages=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedPackages=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedPackages=$$c}}}})]),_vm._v(" "),_c('td',{staticClass:"map-button pkg-map"},[_c('a',{class:{ selected: _vm.inMap },attrs:{"href":"javascript:;"},on:{"click":_vm.toggleInMap}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])]),_vm._v(" "),_c('td',{staticClass:"pkg-id"},[(_vm.opPackage.type === 'package')?_c('a',{attrs:{"href":'/#/package/' + _vm.opPackage.id,"target":"_blank"}},[_c('i',{staticClass:"fas fa-cube fa-fw fa-lg"}),_vm._v("\n      "+_vm._s(_vm.opPackage.id)+"\n    ")]):_c('a',{attrs:{"href":'/#/reservation/' + _vm.opPackage.id,"target":"_blank"}},[_vm._v(_vm._s(_vm.opPackage.id))])]),_vm._v(" "),_c('td',{staticClass:"pkg-status"},[_c('div',{class:'status ' + _vm.opPackage.statusClass},[_vm._v(_vm._s(_vm.opPackage.status))]),_vm._v(" "),(_vm.opPackage.statusClass === 'upcoming' && _vm.opPackage.type === 'rsvp')?_c('span',{staticClass:"rtg",on:{"click":function($event){return _vm.showRTG(_vm.opPackage.id)}}},[_vm._v("RTG")]):_vm._e(),_vm._v(" "),(_vm.opPackage.notes != null && _vm.opPackage.notes.length > 0)?_c('span',{staticClass:"notes",on:{"click":function($event){return _vm.showNotes(_vm.opPackage.notes)}}},[_c('i',{staticClass:"fas fa-sticky-note"}),_vm._v(" NOTES")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"pkg-pickup-time"},[_vm._v(_vm._s(_vm.opPackage.pickupTime))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"service-type",style:({background: _vm.opPackage.serviceType.color})},[_vm._v(_vm._s(_vm.opPackage.serviceType.label))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.opPackage.sector))]),_vm._v(" "),_c('td',{staticClass:"pkg-ada"},[(_vm.opPackage.ada === null || (!_vm.opPackage.ada.wheelchair && !_vm.opPackage.ada.serviceDog))?_c('div',[_vm._v("N/A")]):_c('div',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.opPackage.ada.serviceDog),expression:"opPackage.ada.serviceDog"}]},[_c('svg-dog')],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.opPackage.ada.wheelchair),expression:"opPackage.ada.wheelchair"}]},[_c('svg-wheelchair')],1)])]),_vm._v(" "),_c('td',{staticClass:"pkg-pax"},[_vm._v(_vm._s(_vm.opPackage.passengers))]),_vm._v(" "),_c('td',{staticClass:"pkg-luggage"},[_vm._v(_vm._s(_vm.opPackage.luggage))])]):_c('div',{staticClass:"table-card"},[_c('div',{staticClass:"row-1"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedPackages),expression:"checkedPackages"}],attrs:{"type":"checkbox"},domProps:{"value":_vm.opPackage.id,"checked":Array.isArray(_vm.checkedPackages)?_vm._i(_vm.checkedPackages,_vm.opPackage.id)>-1:(_vm.checkedPackages)},on:{"change":function($event){var $$a=_vm.checkedPackages,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.opPackage.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedPackages=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedPackages=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedPackages=$$c}}}}),_vm._v(" "),_c('a',{attrs:{"href":'/#/package/' + _vm.opPackage.id,"target":"_blank"}},[_vm._v(_vm._s(_vm.opPackage.id))]),_vm._v(" "),_c('div',{class:'status ' + _vm.opPackage.statusClass},[_vm._v(_vm._s(_vm.opPackage.status))])]),_vm._v(" "),_c('div',{staticClass:"map-button",on:{"click":_vm.toggleInMap}},[_c('a',{class:{ selected: _vm.inMap },attrs:{"href":"javascript:;"}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])])]),_vm._v(" "),_c('div',[_c('div',[_vm._v("Pickup Time: "+_vm._s(_vm.opPackage.pickupTime))])]),_vm._v(" "),_c('div',{staticClass:"toggle-div"},[_c('div',{staticClass:"row-7"},[_c('div',[_c('span',[_c('i',{staticClass:"fas fa-user-friends icon"}),_vm._v(_vm._s(_vm.opPackage.pax))]),_vm._v(" "),_c('span',[_c('i',{staticClass:"fas fa-suitcase icon"}),_vm._v(_vm._s(_vm.opPackage.luggage))]),_vm._v(" "),_c('span',[_c('strong',[_vm._v("ADA:")]),_vm._v(" "),(_vm.opPackage.ada === null || (!_vm.opPackage.ada.wheelchair && !_vm.opPackage.ada.serviceDog))?_c('span',[_vm._v("N/A")]):_c('span',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.opPackage.ada.serviceDog),expression:"opPackage.ada.serviceDog"}]},[_c('svg-dog')],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.opPackage.ada.wheelchair),expression:"opPackage.ada.wheelchair"}]},[_c('svg-wheelchair')],1)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',[(!_vm.isMobile)?_c('thead',[_c('th',{staticClass:"status"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkAll),expression:"checkAll"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkAll)?_vm._i(_vm.checkAll,null)>-1:(_vm.checkAll)},on:{"click":_vm.toggleAll,"change":function($event){var $$a=_vm.checkAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkAll=$$c}}}})]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'r.ID'},on:{"click":function($event){return _vm.sort('r.ID')}}},[_vm._v("\n        ID\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'r.ID'),expression:"currentOrder.field === 'r.ID'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',[_vm._v("STATUS")]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'cb.pickupTime'},on:{"click":function($event){return _vm.sort('cb.pickupTime')}}},[_vm._v("\n        PICKUP TIME\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'cb.pickupTime'),expression:"currentOrder.field === 'cb.pickupTime'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'serviceTypeId'},on:{"click":function($event){return _vm.sort('serviceTypeId')}}},[_vm._v("\n        SERVICE TYPE\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'serviceTypeId'),expression:"currentOrder.field === 'serviceTypeId'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',[_vm._v("SECTOR")]),_vm._v(" "),_c('th',[_vm._v("ADA")]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'cb.passengers'},on:{"click":function($event){return _vm.sort('cb.passengers')}}},[_vm._v("\n        PAX\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'cb.passengers'),expression:"currentOrder.field === 'cb.passengers'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'cb.luggage'},on:{"click":function($event){return _vm.sort('cb.luggage')}}},[_vm._v("\n        LUGGAGE\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'cb.luggage'),expression:"currentOrder.field === 'cb.luggage'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})])]):_vm._e(),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(opPackage,index){return _c('tnc-reservations-row',{key:index,attrs:{"opPackage":opPackage,"isMobile":_vm.isMobile}})}),1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnroutedReservations_vue__ = __webpack_require__(664);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_680519f1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnroutedReservations_vue__ = __webpack_require__(2068);
function injectStyle (ssrContext) {
  __webpack_require__(2062)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-680519f1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnroutedReservations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_680519f1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnroutedReservations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2063);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("7353cc39", content, true, {});

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\ntable[data-v-680519f1] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-680519f1] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    border-right: none;\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-680519f1] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-680519f1] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-680519f1] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-680519f1] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-680519f1] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-680519f1] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-680519f1] {\n          color: #ccc;\n}\ntable input[data-v-680519f1] {\n    display: inline-block;\n    width: auto;\n}\ntable .type[data-v-680519f1] {\n    display: inline-block;\n    padding: 3px 6px;\n    text-transform: uppercase;\n    border-radius: 4px;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 600;\n}\ntable .type.tnc[data-v-680519f1] {\n      background: #2ab77c;\n}\ntable .type.tcp[data-v-680519f1] {\n      background: #3f81a0;\n}\ntable .type.psc[data-v-680519f1] {\n      background: #de6c2a;\n}\ntable .status[data-v-680519f1] {\n    text-transform: capitalize;\n}\ntable .expired[data-v-680519f1] {\n    color: #de2929;\n}\ntable .fa-check-circle[data-v-680519f1] {\n    color: #0fda4e;\n}\ntable .fa-times-circle[data-v-680519f1] {\n    color: #ef3535;\n}\ntable a[data-v-680519f1] {\n    cursor: pointer;\n}\ntable .date[data-v-680519f1] {\n    word-spacing: 5px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Laxit/UnroutedReservations.vue"],"names":[],"mappings":";AACA;EACE,0BAA0B;EAC1B,YAAY;CACb;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,mBAAmB;IACnB,0BAA0B;CAC7B;AACD;MACM,kBAAkB;CACvB;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,2BAA2B;CAChC;AACD;QACQ,iBAAiB;CACxB;AACD;IACI,uBAAuB;IACvB,qCAAqC;CACxC;AACD;MACM,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;CACxB;AACD;QACQ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;CAC1B;AACD;UACU,YAAY;CACrB;AACD;IACI,sBAAsB;IACtB,YAAY;CACf;AACD;IACI,sBAAsB;IACtB,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;CACpB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,oBAAoB;CACzB;AACD;IACI,2BAA2B;CAC9B;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,kBAAkB;CACrB","file":"UnroutedReservations.vue","sourcesContent":["\ntable[data-v-680519f1] {\n  border-collapse: collapse;\n  width: 100%;\n}\ntable thead[data-v-680519f1] {\n    color: #8DA0A9;\n    font-size: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    border-right: none;\n    background-color: #f5f5f5;\n}\ntable thead th[data-v-680519f1] {\n      padding: 5px 10px;\n}\ntable thead .sortable[data-v-680519f1] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\ntable thead .sortable i[data-v-680519f1] {\n        margin-left: 2px;\n}\ntable tbody tr[data-v-680519f1] {\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\ntable tbody tr td[data-v-680519f1] {\n      padding: 10px;\n      text-align: center;\n      font-size: 12px;\n      margin-bottom: 5px;\n}\ntable tbody tr td.table-block[data-v-680519f1] {\n        padding: 30px;\n        font-size: 24px;\n        color: #777;\n        font-weight: 600;\n        font-style: italic;\n}\ntable tbody tr td.table-block .fa[data-v-680519f1] {\n          color: #ccc;\n}\ntable input[data-v-680519f1] {\n    display: inline-block;\n    width: auto;\n}\ntable .type[data-v-680519f1] {\n    display: inline-block;\n    padding: 3px 6px;\n    text-transform: uppercase;\n    border-radius: 4px;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 600;\n}\ntable .type.tnc[data-v-680519f1] {\n      background: #2ab77c;\n}\ntable .type.tcp[data-v-680519f1] {\n      background: #3f81a0;\n}\ntable .type.psc[data-v-680519f1] {\n      background: #de6c2a;\n}\ntable .status[data-v-680519f1] {\n    text-transform: capitalize;\n}\ntable .expired[data-v-680519f1] {\n    color: #de2929;\n}\ntable .fa-check-circle[data-v-680519f1] {\n    color: #0fda4e;\n}\ntable .fa-times-circle[data-v-680519f1] {\n    color: #ef3535;\n}\ntable a[data-v-680519f1] {\n    cursor: pointer;\n}\ntable .date[data-v-680519f1] {\n    word-spacing: 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnroutedReservationsRow_vue__ = __webpack_require__(665);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ca6fe66_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnroutedReservationsRow_vue__ = __webpack_require__(2067);
function injectStyle (ssrContext) {
  __webpack_require__(2065)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ca6fe66"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnroutedReservationsRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ca6fe66_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnroutedReservationsRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2066);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("71e684b0", content, true, {});

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.status[data-v-4ca6fe66] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-4ca6fe66], .status.completed[data-v-4ca6fe66] {\n    background: #26D97A;\n}\n.status.canceled[data-v-4ca6fe66], .status.cancelled[data-v-4ca6fe66], .status.failed[data-v-4ca6fe66] {\n    background: #bbb;\n}\n.status.upcoming[data-v-4ca6fe66] {\n    background: #f38d56;\n}\n.status.onboard[data-v-4ca6fe66] {\n    background: #dc3168;\n}\n.status.ready[data-v-4ca6fe66] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-4ca6fe66], .status.requires_dispatch[data-v-4ca6fe66] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-4ca6fe66] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-4ca6fe66] {\n    background: #5662f3;\n}\n.flight-status[data-v-4ca6fe66] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-4ca6fe66] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-4ca6fe66] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-4ca6fe66] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-4ca6fe66] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-4ca6fe66] {\n    background-color: #f35656;\n}\n.dragslot[data-v-4ca6fe66] {\n  font-weight: 700;\n  background-color: #fff;\n  padding: 5px;\n  -webkit-box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(0, 0, 0, 0.4);\n  border-radius: 3px;\n}\n.table-item[data-v-4ca6fe66] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.table-item input[type=\"checkbox\"][data-v-4ca6fe66] {\n    margin-top: 0;\n    width: auto;\n}\n.table-item td[data-v-4ca6fe66] {\n    padding: 10px 5px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.table-item td a[data-v-4ca6fe66] {\n      font-weight: 700;\n}\n.table-item td.map-button[data-v-4ca6fe66] {\n      padding: 10px;\n}\n.table-item td.map-button a[data-v-4ca6fe66] {\n        color: #fff;\n        background-color: #aaa;\n        width: 30px;\n        height: 30px;\n        line-height: 30px;\n        text-align: center;\n        display: inline-block;\n        border-radius: 30px;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.table-item td.map-button a i[data-v-4ca6fe66] {\n          line-height: inherit;\n}\n.table-item td.map-button a.disabled[data-v-4ca6fe66] {\n          pointer-events: none;\n          opacity: 0.5;\n          background-color: #bbb;\n}\n.table-item td.map-button a.selected[data-v-4ca6fe66] {\n          background-color: #26D97A;\n}\n.table-item td.flight-column[data-v-4ca6fe66] {\n      width: 130px;\n}\n.table-item td .flight-img[data-v-4ca6fe66] {\n      width: 30px;\n      display: inline-block;\n      vertical-align: top;\n}\n.table-item td .flight-info[data-v-4ca6fe66] {\n      width: 70px;\n      display: inline-block;\n}\n.table-item td .flight-status[data-v-4ca6fe66] {\n      padding: 1px 4px;\n      font-size: 10px;\n}\n.table-item td.pool-yes[data-v-4ca6fe66] {\n      color: #26D97A;\n}\n.table-item td.pool-no[data-v-4ca6fe66] {\n      color: #F20D0D;\n}\n.table-item td.un-check[data-v-4ca6fe66] {\n      width: 24px !important;\n}\n.table-item td.un-id a[data-v-4ca6fe66] {\n      width: 50px !important;\n      display: block;\n}\n.table-item td.un-luggage[data-v-4ca6fe66] {\n      width: 70px !important;\n}\n.table-item td.un-pickup-time span[data-v-4ca6fe66], .table-item td.un-btt span[data-v-4ca6fe66] {\n      width: 65px !important;\n      display: block;\n}\n.table-item td.un-pickup span[data-v-4ca6fe66], .table-item td.un-dropoff span[data-v-4ca6fe66] {\n      width: 211px !important;\n      display: block;\n}\n.table-item td.un-flight .flight-box[data-v-4ca6fe66] {\n      width: 118px !important;\n      display: block;\n}\n.table-item td.un-ada[data-v-4ca6fe66] {\n      width: 50px !important;\n}\n.table-item td.un-pax[data-v-4ca6fe66] {\n      width: 38px !important;\n}\n.table-item td.un-map[data-v-4ca6fe66] {\n      width: 40px !important;\n}\n.table-item .sector-data ul[data-v-4ca6fe66] {\n    text-align: left;\n    margin: 0;\n    padding-left: 15px;\n}\n.rtg[data-v-4ca6fe66] {\n  color: #fff;\n  line-height: 1;\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  margin: 2px 4px;\n  cursor: pointer;\n  padding: 3px 10px;\n  border-radius: 4px;\n  background: #2586f3;\n  letter-spacing: 1px;\n  border-bottom: 3px solid #084991;\n}\n.image img[data-v-4ca6fe66] {\n  width: 30px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Laxit/UnroutedReservationsRow.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,oBAAoB;CACvB;AACD;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;CAC3B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;EACE,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;EAClD,qCAAqC;EACrC,mBAAmB;CACpB;AACD;EACE,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;CACpB;AACD;IACI,cAAc;IACd,YAAY;CACf;AACD;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;CACtB;AACD;MACM,iBAAiB;CACtB;AACD;MACM,cAAc;CACnB;AACD;QACQ,YAAY;QACZ,uBAAuB;QACvB,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,mBAAmB;QACnB,sBAAsB;QACtB,oBAAoB;QACpB,8BAA8B;QAC9B,sBAAsB;CAC7B;AACD;UACU,qBAAqB;CAC9B;AACD;UACU,qBAAqB;UACrB,aAAa;UACb,uBAAuB;CAChC;AACD;UACU,0BAA0B;CACnC;AACD;MACM,aAAa;CAClB;AACD;MACM,YAAY;MACZ,sBAAsB;MACtB,oBAAoB;CACzB;AACD;MACM,YAAY;MACZ,sBAAsB;CAC3B;AACD;MACM,iBAAiB;MACjB,gBAAgB;CACrB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;MACvB,eAAe;CACpB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;MACvB,eAAe;CACpB;AACD;MACM,wBAAwB;MACxB,eAAe;CACpB;AACD;MACM,wBAAwB;MACxB,eAAe;CACpB;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;MACM,uBAAuB;CAC5B;AACD;IACI,iBAAiB;IACjB,UAAU;IACV,mBAAmB;CACtB;AACD;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,iCAAiC;CAClC;AACD;EACE,YAAY;CACb","file":"UnroutedReservationsRow.vue","sourcesContent":["\n.status[data-v-4ca6fe66] {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 100%;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  text-transform: uppercase;\n  font-weight: 700;\n  text-align: center;\n}\n.status.complete[data-v-4ca6fe66], .status.completed[data-v-4ca6fe66] {\n    background: #26D97A;\n}\n.status.canceled[data-v-4ca6fe66], .status.cancelled[data-v-4ca6fe66], .status.failed[data-v-4ca6fe66] {\n    background: #bbb;\n}\n.status.upcoming[data-v-4ca6fe66] {\n    background: #f38d56;\n}\n.status.onboard[data-v-4ca6fe66] {\n    background: #dc3168;\n}\n.status.ready[data-v-4ca6fe66] {\n    background: #6dabc3;\n}\n.status.requires-dispatch[data-v-4ca6fe66], .status.requires_dispatch[data-v-4ca6fe66] {\n    background: #f35656;\n}\n.status.auto-dispatch[data-v-4ca6fe66] {\n    background: #41c0f1;\n}\n.status.dispatched[data-v-4ca6fe66] {\n    background: #5662f3;\n}\n.flight-status[data-v-4ca6fe66] {\n  display: inline-block;\n  color: #fff;\n  padding: 3px 5px 4px;\n  border-radius: 3px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n.flight-status.ontime[data-v-4ca6fe66] {\n    background-color: #26D97A;\n}\n.flight-status.onair[data-v-4ca6fe66] {\n    background-color: #26D97A;\n}\n.flight-status.arrived[data-v-4ca6fe66] {\n    background-color: #26D97A;\n}\n.flight-status.delayed[data-v-4ca6fe66] {\n    background-color: #f38d56;\n}\n.flight-status.cancelled[data-v-4ca6fe66] {\n    background-color: #f35656;\n}\n.dragslot[data-v-4ca6fe66] {\n  font-weight: 700;\n  background-color: #fff;\n  padding: 5px;\n  -webkit-box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(0, 0, 0, 0.4);\n  border-radius: 3px;\n}\n.table-item[data-v-4ca6fe66] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.table-item input[type=\"checkbox\"][data-v-4ca6fe66] {\n    margin-top: 0;\n    width: auto;\n}\n.table-item td[data-v-4ca6fe66] {\n    padding: 10px 5px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.table-item td a[data-v-4ca6fe66] {\n      font-weight: 700;\n}\n.table-item td.map-button[data-v-4ca6fe66] {\n      padding: 10px;\n}\n.table-item td.map-button a[data-v-4ca6fe66] {\n        color: #fff;\n        background-color: #aaa;\n        width: 30px;\n        height: 30px;\n        line-height: 30px;\n        text-align: center;\n        display: inline-block;\n        border-radius: 30px;\n        -webkit-transition: all 250ms;\n        transition: all 250ms;\n}\n.table-item td.map-button a i[data-v-4ca6fe66] {\n          line-height: inherit;\n}\n.table-item td.map-button a.disabled[data-v-4ca6fe66] {\n          pointer-events: none;\n          opacity: 0.5;\n          background-color: #bbb;\n}\n.table-item td.map-button a.selected[data-v-4ca6fe66] {\n          background-color: #26D97A;\n}\n.table-item td.flight-column[data-v-4ca6fe66] {\n      width: 130px;\n}\n.table-item td .flight-img[data-v-4ca6fe66] {\n      width: 30px;\n      display: inline-block;\n      vertical-align: top;\n}\n.table-item td .flight-info[data-v-4ca6fe66] {\n      width: 70px;\n      display: inline-block;\n}\n.table-item td .flight-status[data-v-4ca6fe66] {\n      padding: 1px 4px;\n      font-size: 10px;\n}\n.table-item td.pool-yes[data-v-4ca6fe66] {\n      color: #26D97A;\n}\n.table-item td.pool-no[data-v-4ca6fe66] {\n      color: #F20D0D;\n}\n.table-item td.un-check[data-v-4ca6fe66] {\n      width: 24px !important;\n}\n.table-item td.un-id a[data-v-4ca6fe66] {\n      width: 50px !important;\n      display: block;\n}\n.table-item td.un-luggage[data-v-4ca6fe66] {\n      width: 70px !important;\n}\n.table-item td.un-pickup-time span[data-v-4ca6fe66], .table-item td.un-btt span[data-v-4ca6fe66] {\n      width: 65px !important;\n      display: block;\n}\n.table-item td.un-pickup span[data-v-4ca6fe66], .table-item td.un-dropoff span[data-v-4ca6fe66] {\n      width: 211px !important;\n      display: block;\n}\n.table-item td.un-flight .flight-box[data-v-4ca6fe66] {\n      width: 118px !important;\n      display: block;\n}\n.table-item td.un-ada[data-v-4ca6fe66] {\n      width: 50px !important;\n}\n.table-item td.un-pax[data-v-4ca6fe66] {\n      width: 38px !important;\n}\n.table-item td.un-map[data-v-4ca6fe66] {\n      width: 40px !important;\n}\n.table-item .sector-data ul[data-v-4ca6fe66] {\n    text-align: left;\n    margin: 0;\n    padding-left: 15px;\n}\n.rtg[data-v-4ca6fe66] {\n  color: #fff;\n  line-height: 1;\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  margin: 2px 4px;\n  cursor: pointer;\n  padding: 3px 10px;\n  border-radius: 4px;\n  background: #2586f3;\n  letter-spacing: 1px;\n  border-bottom: 3px solid #084991;\n}\n.image img[data-v-4ca6fe66] {\n  width: 30px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('drag',{staticClass:"table-item",attrs:{"tag":"tr","transfer-data":_vm.rsvp,"draggable":!_vm.inMap},on:{"dragstart":function($event){return _vm.$store.commit('laxit/setDropzoneShow', true)},"dragend":function($event){return _vm.$store.commit('laxit/setDropzoneShow', false)}}},[_c('div',{staticClass:"dragslot",attrs:{"slot":"image"},slot:"image"},[_vm._v("Reservation "+_vm._s(_vm.rsvp.id))]),_vm._v(" "),_c('td',{staticClass:"map-button un-map",on:{"click":_vm.toggleInMap}},[_c('a',{class:{ selected: _vm.inMap },attrs:{"href":"javascript:;"}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])]),_vm._v(" "),_c('td',{staticClass:"un-id"},[_c('a',{attrs:{"href":"javascript:;","href":'/#/reservation/' + _vm.rsvp.id,"target":"_blank"}},[_vm._v(_vm._s(_vm.rsvp.id))])]),_vm._v(" "),_c('td',[_c('div',{class:'status ' + _vm.rsvp.statusClass},[_vm._v(_vm._s(_vm.rsvp.status))]),_vm._v(" "),(_vm.acceptedRTGStatus(_vm.rsvp.status) && _vm.rsvp.pickup.geofenceType === 'airport')?_c('span',{staticClass:"rtg",on:{"click":function($event){return _vm.showRTG(_vm.rsvp.id)}}},[_vm._v("RTG")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"un-pickup-time"},[_c('span',[_vm._v(_vm._s(_vm.rsvp.pickupTime))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getAddress(_vm.rsvp.dropoff)))]),_vm._v(" "),_c('td',{staticClass:"image"},[(_vm.rsvp.flight !== null)?_c('span',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.showFlightInfo}},[_c('span',[_vm._v(_vm._s(_vm.rsvp.flight.airline))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rsvp.flight.flightNumber))])]),_vm._v(" "),(_vm.flightStatus !== null)?_c('span',{class:'flight-status ' + _vm.flightStatus.class},[_vm._v(_vm._s(_vm.flightStatus.label))]):_vm._e()]):_c('span',[_vm._v("N/A")])]),_vm._v(" "),_c('td',{staticClass:"un-ada"},[(_vm.rsvp.ada === null || (!_vm.rsvp.ada.wheelchair && !_vm.rsvp.ada.serviceDog))?_c('div',[_vm._v("N/A")]):_c('div',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvp.ada.serviceDog),expression:"rsvp.ada.serviceDog"}]},[_c('svg-dog')],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvp.ada.wheelchair),expression:"rsvp.ada.wheelchair"}]},[_c('svg-wheelchair')],1)])]),_vm._v(" "),_c('td',{staticClass:"un-pax"},[_vm._v(_vm._s(_vm.rsvp.passengers))]),_vm._v(" "),_c('td',{staticClass:"un-luggage"},[_vm._v(_vm._s(_vm.rsvp.luggage))])]):_c('div',{staticClass:"table-card"},[_c('div',{staticClass:"row-1"},[_c('div',[_c('a',{attrs:{"href":"javascript:;","href":'/#/reservation/' + _vm.rsvp.id,"target":"_blank"}},[_vm._v(_vm._s(_vm.rsvp.id))]),_vm._v(" "),_c('div',{class:'status ' + _vm.rsvp.statusClass},[_vm._v(_vm._s(_vm.rsvp.status))]),_vm._v(" "),(_vm.acceptedRTGStatus(_vm.rsvp.status) && _vm.rsvp.pickup.geofenceType === 'airport')?_c('span',{staticClass:"rtg",on:{"click":function($event){return _vm.showRTG(_vm.rsvp.id)}}},[_vm._v("RTG")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"map-button",on:{"click":_vm.toggleInMap}},[_c('a',{class:{ selected: _vm.inMap },attrs:{"href":"javascript:;"}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])])]),_vm._v(" "),_c('div',[_c('div',[_vm._v("Pickup Time: "+_vm._s(_vm.rsvp.pickupTime))])]),_vm._v(" "),_c('div',[_c('div',[_vm._v("Dropoff: "+_vm._s(_vm.getAddress(_vm.rsvp.dropoff)))])]),_vm._v(" "),_c('div',{staticClass:"image"},[(_vm.rsvp.flight !== null)?_c('span',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.showFlightInfo}},[_c('span',[_vm._v(_vm._s(_vm.rsvp.flight.airline))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rsvp.flight.flightNumber))])]),_vm._v(" "),(_vm.flightStatus !== null)?_c('span',{class:'flight-status ' + _vm.flightStatus.class},[_vm._v(_vm._s(_vm.flightStatus.label))]):_vm._e()]):_c('span',[_vm._v("N/A")])]),_vm._v(" "),_c('div',{staticClass:"toggle-div"},[_c('div',{staticClass:"row-7"},[_c('div',[_c('span',[_c('i',{staticClass:"fas fa-user-friends icon"}),_vm._v(_vm._s(_vm.rsvp.passengers))]),_vm._v(" "),_c('span',[_c('i',{staticClass:"fas fa-suitcase icon"}),_vm._v(_vm._s(_vm.rsvp.luggage))]),_vm._v(" "),_c('span',[_c('strong',[_vm._v("ADA:")]),_vm._v(" "),(_vm.rsvp.ada === null || (!_vm.rsvp.ada.wheelchair && !_vm.rsvp.ada.serviceDog))?_c('span',[_vm._v("N/A")]):_c('span',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvp.ada.serviceDog),expression:"rsvp.ada.serviceDog"}]},[_c('svg-dog')],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rsvp.ada.wheelchair),expression:"rsvp.ada.wheelchair"}]},[_c('svg-wheelchair')],1)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',[(!_vm.isMobile)?_c('thead',[_c('th'),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'r.ID'},on:{"click":function($event){return _vm.sort('r.ID')}}},[_vm._v("\n        ID\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'r.ID'),expression:"currentOrder.field === 'r.ID'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',[_vm._v("STATUS")]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'cb.pickupTime'},on:{"click":function($event){return _vm.sort('cb.pickupTime')}}},[_vm._v("\n        PICKUP TIME\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'cb.pickupTime'),expression:"currentOrder.field === 'cb.pickupTime'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',[_vm._v("DROPOFF")]),_vm._v(" "),_c('th',{staticClass:"un-btt"},[_vm._v("FLIGHT")]),_vm._v(" "),_c('th',[_vm._v("ADA")]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'cb.passengers'},on:{"click":function($event){return _vm.sort('cb.passengers')}}},[_vm._v("\n        PAX\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'cb.passengers'),expression:"currentOrder.field === 'cb.passengers'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:{'sortable':true, 'active':_vm.currentOrder.field === 'cb.luggage'},on:{"click":function($event){return _vm.sort('cb.luggage')}}},[_vm._v("\n        LUGGAGE\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'cb.luggage'),expression:"currentOrder.field === 'cb.luggage'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})])]):_vm._e(),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(rsvp,index){return _c('unrouted-reservations-row',{key:index,attrs:{"rsvp":_vm.addMapOnlyData(rsvp),"isMobile":_vm.isMobile}})}),1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverTnc_vue__ = __webpack_require__(666);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5de3db60_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverTnc_vue__ = __webpack_require__(2072);
function injectStyle (ssrContext) {
  __webpack_require__(2070)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5de3db60"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverTnc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5de3db60_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverTnc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2071);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("ad04f58c", content, true, {});

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.container[data-v-5de3db60] {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n.container .top-label[data-v-5de3db60] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: #0d79f2;\n    color: #fff;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n.container .top-label .refresh-icon i[data-v-5de3db60] {\n      margin-left: 5px;\n}\n.container .top-label .refresh-icon .tooltiptext[data-v-5de3db60] {\n      visibility: hidden;\n      width: 80px;\n      background-color: #4e4e4e;\n      color: #fff;\n      text-align: center;\n      border-radius: 6px;\n      padding: 1px 0;\n      position: absolute;\n      z-index: 1;\n      opacity: 0;\n      -webkit-transition: opacity .6s;\n      transition: opacity .6s;\n      top: 120%;\n      left: 60%;\n      font-size: 14px;\n}\n.container .top-label .refresh-icon[data-v-5de3db60]:hover {\n      cursor: pointer;\n      color: #26D97A;\n}\n.container .top-label .refresh-icon:hover .tooltiptext[data-v-5de3db60] {\n        opacity: 1;\n        visibility: visible;\n}\n.container .driver-container[data-v-5de3db60] {\n    overflow-y: auto;\n    margin-top: 30px;\n    height: calc((100vh - 110px) / 2);\n    padding: 10px;\n}\n.container .driver-container .filter-container[data-v-5de3db60] {\n      text-align: right;\n}\n.container .driver-container .filter-container .filter-staging[data-v-5de3db60] {\n        width: auto;\n        margin-bottom: 8px;\n}\n.container .driver-container table[data-v-5de3db60] {\n      width: 100%;\n      border-collapse: collapse;\n}\n.container .driver-container table tr[data-v-5de3db60]:nth-child(even) {\n        background-color: #f3f3f3;\n}\n.container .driver-container table td[data-v-5de3db60] {\n        font-size: 12px;\n        padding: 5px;\n        text-align: center;\n}\n.container .driver-container table tr[data-v-5de3db60]:hover {\n        background-color: #fff8dc;\n}\n.staging-lots .loader[data-v-5de3db60] {\n  text-align: center;\n  font-weight: 700;\n  padding: 15px;\n}\n.staging-area-error[data-v-5de3db60] {\n  text-align: center;\n  padding: 20px 0;\n  font-weight: 700;\n  color: #F20D0D;\n}\n.driver-list[data-v-5de3db60] {\n  margin-top: 8px;\n}\n.driver-list .service-drivers[data-v-5de3db60] {\n    position: relative;\n}\n.driver-list .service-title[data-v-5de3db60] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n    margin-bottom: 3px;\n}\ntable[data-v-5de3db60] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-bottom: 10px;\n}\n.table-header[data-v-5de3db60] {\n  color: #8DA0A9;\n  font-size: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n}\n.table-header th[data-v-5de3db60] {\n    padding: 5px 10px;\n}\n.driver[data-v-5de3db60] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.driver td[data-v-5de3db60] {\n    padding: 10px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.driver td input[data-v-5de3db60] {\n      margin-top: 0;\n      width: 13px;\n}\n.driver a[data-v-5de3db60] {\n    font-weight: 700;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Laxit/DriverTnc.vue"],"names":[],"mappings":";AACA;EACE,qCAAqC;EACrC,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,0BAA0B;IAC1B,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,4CAA4C;IAC5C,kDAAkD;IAClD,0CAA0C;CAC7C;AACD;MACM,iBAAiB;CACtB;AACD;MACM,mBAAmB;MACnB,YAAY;MACZ,0BAA0B;MAC1B,YAAY;MACZ,mBAAmB;MACnB,mBAAmB;MACnB,eAAe;MACf,mBAAmB;MACnB,WAAW;MACX,WAAW;MACX,gCAAgC;MAChC,wBAAwB;MACxB,UAAU;MACV,UAAU;MACV,gBAAgB;CACrB;AACD;MACM,gBAAgB;MAChB,eAAe;CACpB;AACD;QACQ,WAAW;QACX,oBAAoB;CAC3B;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kCAAkC;IAClC,cAAc;CACjB;AACD;MACM,kBAAkB;CACvB;AACD;QACQ,YAAY;QACZ,mBAAmB;CAC1B;AACD;MACM,YAAY;MACZ,0BAA0B;CAC/B;AACD;QACQ,0BAA0B;CACjC;AACD;QACQ,gBAAgB;QAChB,aAAa;QACb,mBAAmB;CAC1B;AACD;QACQ,0BAA0B;CACjC;AACD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;CACf;AACD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;CAChB;AACD;EACE,gBAAgB;CACjB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;CACtB;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,oBAAoB;CACrB;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,0BAA0B;CAC3B;AACD;IACI,kBAAkB;CACrB;AACD;EACE,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;CACpB;AACD;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;CACtB;AACD;MACM,cAAc;MACd,YAAY;CACjB;AACD;IACI,iBAAiB;CACpB","file":"DriverTnc.vue","sourcesContent":["\n.container[data-v-5de3db60] {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n.container .top-label[data-v-5de3db60] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: #0d79f2;\n    color: #fff;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n.container .top-label .refresh-icon i[data-v-5de3db60] {\n      margin-left: 5px;\n}\n.container .top-label .refresh-icon .tooltiptext[data-v-5de3db60] {\n      visibility: hidden;\n      width: 80px;\n      background-color: #4e4e4e;\n      color: #fff;\n      text-align: center;\n      border-radius: 6px;\n      padding: 1px 0;\n      position: absolute;\n      z-index: 1;\n      opacity: 0;\n      -webkit-transition: opacity .6s;\n      transition: opacity .6s;\n      top: 120%;\n      left: 60%;\n      font-size: 14px;\n}\n.container .top-label .refresh-icon[data-v-5de3db60]:hover {\n      cursor: pointer;\n      color: #26D97A;\n}\n.container .top-label .refresh-icon:hover .tooltiptext[data-v-5de3db60] {\n        opacity: 1;\n        visibility: visible;\n}\n.container .driver-container[data-v-5de3db60] {\n    overflow-y: auto;\n    margin-top: 30px;\n    height: calc((100vh - 110px) / 2);\n    padding: 10px;\n}\n.container .driver-container .filter-container[data-v-5de3db60] {\n      text-align: right;\n}\n.container .driver-container .filter-container .filter-staging[data-v-5de3db60] {\n        width: auto;\n        margin-bottom: 8px;\n}\n.container .driver-container table[data-v-5de3db60] {\n      width: 100%;\n      border-collapse: collapse;\n}\n.container .driver-container table tr[data-v-5de3db60]:nth-child(even) {\n        background-color: #f3f3f3;\n}\n.container .driver-container table td[data-v-5de3db60] {\n        font-size: 12px;\n        padding: 5px;\n        text-align: center;\n}\n.container .driver-container table tr[data-v-5de3db60]:hover {\n        background-color: #fff8dc;\n}\n.staging-lots .loader[data-v-5de3db60] {\n  text-align: center;\n  font-weight: 700;\n  padding: 15px;\n}\n.staging-area-error[data-v-5de3db60] {\n  text-align: center;\n  padding: 20px 0;\n  font-weight: 700;\n  color: #F20D0D;\n}\n.driver-list[data-v-5de3db60] {\n  margin-top: 8px;\n}\n.driver-list .service-drivers[data-v-5de3db60] {\n    position: relative;\n}\n.driver-list .service-title[data-v-5de3db60] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n    margin-bottom: 3px;\n}\ntable[data-v-5de3db60] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-bottom: 10px;\n}\n.table-header[data-v-5de3db60] {\n  color: #8DA0A9;\n  font-size: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n}\n.table-header th[data-v-5de3db60] {\n    padding: 5px 10px;\n}\n.driver[data-v-5de3db60] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.driver td[data-v-5de3db60] {\n    padding: 10px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.driver td input[data-v-5de3db60] {\n      margin-top: 0;\n      width: 13px;\n}\n.driver a[data-v-5de3db60] {\n    font-weight: 700;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"top-label"},[_c('span',[_vm._v("TNC / Staging\n      "),_c('span',{staticClass:"refresh-icon",on:{"click":function($event){return _vm.getList()}}},[_c('i',{class:{'fas fa-sync-alt':true, 'fa-spin':_vm.staging.loading}}),_vm._v(" "),_c('span',{staticClass:"tooltiptext"},[_vm._v("Refresh")])])])]),_vm._v(" "),_c('div',{staticClass:"driver-container"},[_c('div',{staticClass:"staging-lots"},[_c('div',{staticClass:"filter-container"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.stagingType),expression:"stagingType"}],staticClass:"filter-staging",attrs:{"name":"tnc-staging-list"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.stagingType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v("ALL")]),_vm._v(" "),_vm._l((_vm.stagingLists),function(stagingList,key){return _c('option',{key:key,domProps:{"value":stagingList.id}},[_vm._v(_vm._s(stagingList.name))])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.staging.loading),expression:"staging.loading"}],staticClass:"loader"},[_c('i',{staticClass:"fa fa-spinner fa-spin"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.staging.error),expression:"staging.error"}],staticClass:"staging-area-error"},[_vm._v("\n      There are no drivers listed in TNC / Staging.\n    ")])]),_vm._v(" "),(_vm.driversDisplayed !== null)?_c('div',{staticClass:"driver-list"},_vm._l((_vm.driversDisplayed),function(value,key){return (_vm.checkLicense(value))?_c('div',{staticClass:"service-drivers"},[(value.length > 0)?_c('div',{staticClass:"service-title"},[(key === 'shared')?_c('span',[_vm._v("Shared Ride")]):(key === 'opoli')?_c('span',[_vm._v("Direct Non-Stop")]):(key === 'black')?_c('span',[_vm._v("Sedan")]):(key === 'suv')?_c('span',[_vm._v("SUV")]):(key === 'shuttle')?_c('span',[_vm._v("Private Van")]):_c('span',[_vm._v(_vm._s(_vm.getServiceName(value[0].serviceTypeId)))])]):_vm._e(),_vm._v(" "),(value.length > 0)?_c('table',[_c('tbody',_vm._l((value),function(queue){return (queue.provider.providerAccountType === 'tnc')?_c('tr',{staticClass:"driver"},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDriver),expression:"selectedDriver"}],attrs:{"type":"radio"},domProps:{"value":queue.provider.ID+'-'+key,"checked":_vm._q(_vm.selectedDriver,queue.provider.ID+'-'+key)},on:{"change":function($event){_vm.selectedDriver=queue.provider.ID+'-'+key}}})]),_vm._v(" "),_c('td',{attrs:{"width":"160"}},[_c('a',{attrs:{"href":'#/provider/' + queue.provider.ID,"target":"_blank"}},[_vm._v("\n                "+_vm._s(queue.provider.firstName)+" "+_vm._s(queue.provider.lastName)+"\n              ")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(queue.seatCapacity)+" PAX ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(queue.status))])]):_vm._e()}),0)]):_vm._e()]):_vm._e()}),0):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverTcp_vue__ = __webpack_require__(668);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd0e2044_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverTcp_vue__ = __webpack_require__(2076);
function injectStyle (ssrContext) {
  __webpack_require__(2074)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dd0e2044"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverTcp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd0e2044_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverTcp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2075);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("59aaf4f8", content, true, {});

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.container[data-v-dd0e2044] {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n.container .top-label[data-v-dd0e2044] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: #0d79f2;\n    color: #fff;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n.container .top-label .refresh-icon i[data-v-dd0e2044] {\n      margin-left: 5px;\n}\n.container .top-label .refresh-icon .tooltiptext[data-v-dd0e2044] {\n      visibility: hidden;\n      width: 80px;\n      background-color: #4e4e4e;\n      color: #fff;\n      text-align: center;\n      border-radius: 6px;\n      padding: 1px 0;\n      position: absolute;\n      z-index: 1;\n      opacity: 0;\n      -webkit-transition: opacity .6s;\n      transition: opacity .6s;\n      top: 120%;\n      left: 60%;\n      font-size: 14px;\n}\n.container .top-label .refresh-icon[data-v-dd0e2044]:hover {\n      cursor: pointer;\n      color: #26D97A;\n}\n.container .top-label .refresh-icon:hover .tooltiptext[data-v-dd0e2044] {\n        opacity: 1;\n        visibility: visible;\n}\n.container .driver-container[data-v-dd0e2044] {\n    overflow-y: auto;\n    margin-top: 30px;\n    height: calc((100vh - 110px) / 2);\n    padding: 10px;\n}\n.container .driver-container .filter-container[data-v-dd0e2044] {\n      text-align: right;\n}\n.container .driver-container .filter-container .filter-staging[data-v-dd0e2044] {\n        width: auto;\n        margin-bottom: 8px;\n}\n.container .driver-container table[data-v-dd0e2044] {\n      width: 100%;\n      border-collapse: collapse;\n}\n.container .driver-container table tr[data-v-dd0e2044]:nth-child(even) {\n        background-color: #f3f3f3;\n}\n.container .driver-container table td[data-v-dd0e2044] {\n        font-size: 12px;\n        padding: 5px;\n        text-align: center;\n}\n.container .driver-container table tr[data-v-dd0e2044]:hover {\n        background-color: #fff8dc;\n}\n.staging-lots .loader[data-v-dd0e2044] {\n  text-align: center;\n  font-weight: 700;\n  padding: 15px;\n}\n.staging-area-error[data-v-dd0e2044] {\n  text-align: center;\n  padding: 20px 0;\n  font-weight: 700;\n  color: #F20D0D;\n}\n.driver-list[data-v-dd0e2044] {\n  margin-top: 8px;\n}\n.driver-list .service-drivers[data-v-dd0e2044] {\n    position: relative;\n}\n.driver-list .service-title[data-v-dd0e2044] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n    margin-bottom: 3px;\n}\ntable[data-v-dd0e2044] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-bottom: 10px;\n}\n.table-header[data-v-dd0e2044] {\n  color: #8DA0A9;\n  font-size: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n}\n.table-header th[data-v-dd0e2044] {\n    padding: 5px 10px;\n}\n.driver[data-v-dd0e2044] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.driver td[data-v-dd0e2044] {\n    padding: 10px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.driver td input[data-v-dd0e2044] {\n      margin-top: 0;\n      width: 13px;\n}\n.driver a[data-v-dd0e2044] {\n    font-weight: 700;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Laxit/DriverTcp.vue"],"names":[],"mappings":";AACA;EACE,qCAAqC;EACrC,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,0BAA0B;IAC1B,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,4CAA4C;IAC5C,kDAAkD;IAClD,0CAA0C;CAC7C;AACD;MACM,iBAAiB;CACtB;AACD;MACM,mBAAmB;MACnB,YAAY;MACZ,0BAA0B;MAC1B,YAAY;MACZ,mBAAmB;MACnB,mBAAmB;MACnB,eAAe;MACf,mBAAmB;MACnB,WAAW;MACX,WAAW;MACX,gCAAgC;MAChC,wBAAwB;MACxB,UAAU;MACV,UAAU;MACV,gBAAgB;CACrB;AACD;MACM,gBAAgB;MAChB,eAAe;CACpB;AACD;QACQ,WAAW;QACX,oBAAoB;CAC3B;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kCAAkC;IAClC,cAAc;CACjB;AACD;MACM,kBAAkB;CACvB;AACD;QACQ,YAAY;QACZ,mBAAmB;CAC1B;AACD;MACM,YAAY;MACZ,0BAA0B;CAC/B;AACD;QACQ,0BAA0B;CACjC;AACD;QACQ,gBAAgB;QAChB,aAAa;QACb,mBAAmB;CAC1B;AACD;QACQ,0BAA0B;CACjC;AACD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;CACf;AACD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;CAChB;AACD;EACE,gBAAgB;CACjB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;CACtB;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,oBAAoB;CACrB;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,0BAA0B;CAC3B;AACD;IACI,kBAAkB;CACrB;AACD;EACE,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;CACpB;AACD;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;CACtB;AACD;MACM,cAAc;MACd,YAAY;CACjB;AACD;IACI,iBAAiB;CACpB","file":"DriverTcp.vue","sourcesContent":["\n.container[data-v-dd0e2044] {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n.container .top-label[data-v-dd0e2044] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: #0d79f2;\n    color: #fff;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n.container .top-label .refresh-icon i[data-v-dd0e2044] {\n      margin-left: 5px;\n}\n.container .top-label .refresh-icon .tooltiptext[data-v-dd0e2044] {\n      visibility: hidden;\n      width: 80px;\n      background-color: #4e4e4e;\n      color: #fff;\n      text-align: center;\n      border-radius: 6px;\n      padding: 1px 0;\n      position: absolute;\n      z-index: 1;\n      opacity: 0;\n      -webkit-transition: opacity .6s;\n      transition: opacity .6s;\n      top: 120%;\n      left: 60%;\n      font-size: 14px;\n}\n.container .top-label .refresh-icon[data-v-dd0e2044]:hover {\n      cursor: pointer;\n      color: #26D97A;\n}\n.container .top-label .refresh-icon:hover .tooltiptext[data-v-dd0e2044] {\n        opacity: 1;\n        visibility: visible;\n}\n.container .driver-container[data-v-dd0e2044] {\n    overflow-y: auto;\n    margin-top: 30px;\n    height: calc((100vh - 110px) / 2);\n    padding: 10px;\n}\n.container .driver-container .filter-container[data-v-dd0e2044] {\n      text-align: right;\n}\n.container .driver-container .filter-container .filter-staging[data-v-dd0e2044] {\n        width: auto;\n        margin-bottom: 8px;\n}\n.container .driver-container table[data-v-dd0e2044] {\n      width: 100%;\n      border-collapse: collapse;\n}\n.container .driver-container table tr[data-v-dd0e2044]:nth-child(even) {\n        background-color: #f3f3f3;\n}\n.container .driver-container table td[data-v-dd0e2044] {\n        font-size: 12px;\n        padding: 5px;\n        text-align: center;\n}\n.container .driver-container table tr[data-v-dd0e2044]:hover {\n        background-color: #fff8dc;\n}\n.staging-lots .loader[data-v-dd0e2044] {\n  text-align: center;\n  font-weight: 700;\n  padding: 15px;\n}\n.staging-area-error[data-v-dd0e2044] {\n  text-align: center;\n  padding: 20px 0;\n  font-weight: 700;\n  color: #F20D0D;\n}\n.driver-list[data-v-dd0e2044] {\n  margin-top: 8px;\n}\n.driver-list .service-drivers[data-v-dd0e2044] {\n    position: relative;\n}\n.driver-list .service-title[data-v-dd0e2044] {\n    font-size: 12px;\n    font-weight: 700;\n    color: #0D79F2;\n    margin-bottom: 3px;\n}\ntable[data-v-dd0e2044] {\n  border-collapse: collapse;\n  width: 100%;\n  margin-bottom: 10px;\n}\n.table-header[data-v-dd0e2044] {\n  color: #8DA0A9;\n  font-size: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n}\n.table-header th[data-v-dd0e2044] {\n    padding: 5px 10px;\n}\n.driver[data-v-dd0e2044] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.driver td[data-v-dd0e2044] {\n    padding: 10px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.driver td input[data-v-dd0e2044] {\n      margin-top: 0;\n      width: 13px;\n}\n.driver a[data-v-dd0e2044] {\n    font-weight: 700;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"top-label"},[_c('span',[_vm._v("TCP\n      "),_c('span',{staticClass:"refresh-icon",on:{"click":function($event){return _vm.getList()}}},[_c('i',{class:{'fas fa-sync-alt':true, 'fa-spin':_vm.staging.loading}}),_vm._v(" "),_c('span',{staticClass:"tooltiptext"},[_vm._v("Refresh")])])])]),_vm._v(" "),_c('div',{staticClass:"driver-container"},[_c('div',{staticClass:"staging-lots"},[_c('div',{staticClass:"filter-container"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.stagingType),expression:"stagingType"}],staticClass:"filter-staging",attrs:{"name":"tcp-staging-list"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.stagingType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v("ALL")]),_vm._v(" "),_vm._l((_vm.stagingLists),function(stagingList,key){return _c('option',{key:key,domProps:{"value":stagingList.id}},[_vm._v(_vm._s(stagingList.name))])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.staging.loading),expression:"staging.loading"}],staticClass:"loader"},[_c('i',{staticClass:"fa fa-spinner fa-spin"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.staging.error),expression:"staging.error"}],staticClass:"staging-area-error"},[_vm._v("\n      There are no drivers listed in TCP.\n    ")])]),_vm._v(" "),(_vm.driversDisplayed !== null)?_c('div',{staticClass:"driver-list"},_vm._l((_vm.driversDisplayed),function(value,key){return (_vm.checkLicense(value))?_c('div',{staticClass:"service-drivers"},[(value.length > 0)?_c('div',{staticClass:"service-title"},[(key === 'shared')?_c('span',[_vm._v("Shared Ride")]):(key === 'opoli')?_c('span',[_vm._v("Direct Non-Stop")]):(key === 'black')?_c('span',[_vm._v("Sedan")]):(key === 'suv')?_c('span',[_vm._v("SUV")]):(key === 'shuttle')?_c('span',[_vm._v("Private Van")]):_c('span',[_vm._v(_vm._s(_vm.getServiceName(value[0].serviceTypeId)))])]):_vm._e(),_vm._v(" "),(value.length > 0)?_c('table',[_c('tbody',_vm._l((value),function(queue){return (queue.provider.providerAccountType=='tcp')?_c('tr',{staticClass:"driver"},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDriver),expression:"selectedDriver"}],attrs:{"type":"radio"},domProps:{"value":queue.provider.ID+'-'+key,"checked":_vm._q(_vm.selectedDriver,queue.provider.ID+'-'+key)},on:{"change":function($event){_vm.selectedDriver=queue.provider.ID+'-'+key}}})]),_vm._v(" "),_c('td',{attrs:{"width":"160"}},[_c('a',{attrs:{"href":'#/provider/' + queue.provider.ID,"target":"_blank"}},[_vm._v("\n                "+_vm._s(queue.provider.firstName)+" "+_vm._s(queue.provider.lastName)+"\n              ")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(queue.seatCapacity)+" PAX ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(queue.status))])]):_vm._e()}),0)]):_vm._e()]):_vm._e()}),0):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverOutbound_vue__ = __webpack_require__(669);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61ebf911_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverOutbound_vue__ = __webpack_require__(2080);
function injectStyle (ssrContext) {
  __webpack_require__(2078)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61ebf911"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverOutbound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61ebf911_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverOutbound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2079);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("8671a578", content, true, {});

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.container[data-v-61ebf911] {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n.container .top-label[data-v-61ebf911] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: #0d79f2;\n    color: #fff;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n.container .top-label .refresh-icon i[data-v-61ebf911] {\n      margin-left: 5px;\n}\n.container .top-label .refresh-icon .tooltiptext[data-v-61ebf911] {\n      visibility: hidden;\n      width: 80px;\n      background-color: #4e4e4e;\n      color: #fff;\n      text-align: center;\n      border-radius: 6px;\n      padding: 1px 0;\n      position: absolute;\n      z-index: 1;\n      opacity: 0;\n      -webkit-transition: opacity .6s;\n      transition: opacity .6s;\n      top: 120%;\n      left: 60%;\n      font-size: 14px;\n}\n.container .top-label .refresh-icon[data-v-61ebf911]:hover {\n      cursor: pointer;\n      color: #26D97A;\n}\n.container .top-label .refresh-icon:hover .tooltiptext[data-v-61ebf911] {\n        opacity: 1;\n        visibility: visible;\n}\n.container .driver-container[data-v-61ebf911] {\n    overflow-y: auto;\n    margin-top: 30px;\n    height: calc((100vh - 110px) / 2);\n    padding: 10px;\n}\n.container .driver-container .filter-container[data-v-61ebf911] {\n      text-align: right;\n}\n.container .driver-container .filter-container .filter-license[data-v-61ebf911] {\n        width: 100px;\n        margin-bottom: 8px;\n}\n.container .driver-container table[data-v-61ebf911] {\n      width: 100%;\n      border-collapse: collapse;\n}\n.container .driver-container table .table-header[data-v-61ebf911] {\n        color: #8DA0A9;\n        font-size: 11px;\n        border: 1px solid rgba(0, 0, 0, 0.3);\n        background-color: #f5f5f5;\n}\n.container .driver-container table .table-header th[data-v-61ebf911] {\n          padding: 5px 10px;\n}\n.container .driver-container table tr[data-v-61ebf911]:nth-child(even) {\n        background-color: #f3f3f3;\n}\n.container .driver-container table td[data-v-61ebf911] {\n        font-size: 12px;\n        padding: 5px;\n        text-align: center;\n}\n.container .driver-container table tbody tr[data-v-61ebf911]:hover {\n        background-color: #fff8dc;\n}\n.staging-lots .loader[data-v-61ebf911] {\n  text-align: center;\n  font-weight: 700;\n  padding: 15px;\n}\n.staging-area-error[data-v-61ebf911] {\n  text-align: center;\n  padding: 20px 0;\n  font-weight: 700;\n  color: #F20D0D;\n}\n.driver[data-v-61ebf911] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.driver td[data-v-61ebf911] {\n    padding: 10px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.driver td input[data-v-61ebf911] {\n      margin-top: 0;\n      width: 13px;\n}\n.driver a[data-v-61ebf911] {\n    font-weight: 700;\n}\n.infinity-loader[data-v-61ebf911] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  -webkit-transform-origin: bottom center;\n          transform-origin: bottom center;\n  text-align: center;\n  font-size: 18px;\n  line-height: 40px;\n}\n@media screen and (max-width: 430px) {\n.top-label[data-v-61ebf911] {\n    font-size: 12px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Laxit/DriverOutbound.vue"],"names":[],"mappings":";AACA;EACE,qCAAqC;EACrC,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,0BAA0B;IAC1B,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,4CAA4C;IAC5C,kDAAkD;IAClD,0CAA0C;CAC7C;AACD;MACM,iBAAiB;CACtB;AACD;MACM,mBAAmB;MACnB,YAAY;MACZ,0BAA0B;MAC1B,YAAY;MACZ,mBAAmB;MACnB,mBAAmB;MACnB,eAAe;MACf,mBAAmB;MACnB,WAAW;MACX,WAAW;MACX,gCAAgC;MAChC,wBAAwB;MACxB,UAAU;MACV,UAAU;MACV,gBAAgB;CACrB;AACD;MACM,gBAAgB;MAChB,eAAe;CACpB;AACD;QACQ,WAAW;QACX,oBAAoB;CAC3B;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kCAAkC;IAClC,cAAc;CACjB;AACD;MACM,kBAAkB;CACvB;AACD;QACQ,aAAa;QACb,mBAAmB;CAC1B;AACD;MACM,YAAY;MACZ,0BAA0B;CAC/B;AACD;QACQ,eAAe;QACf,gBAAgB;QAChB,qCAAqC;QACrC,0BAA0B;CACjC;AACD;UACU,kBAAkB;CAC3B;AACD;QACQ,0BAA0B;CACjC;AACD;QACQ,gBAAgB;QAChB,aAAa;QACb,mBAAmB;CAC1B;AACD;QACQ,0BAA0B;CACjC;AACD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;CACf;AACD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;CAChB;AACD;EACE,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;CACpB;AACD;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;CACtB;AACD;MACM,cAAc;MACd,YAAY;CACjB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,wCAAwC;UAChC,gCAAgC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;AACA;IACI,gBAAgB;CACnB;CACA","file":"DriverOutbound.vue","sourcesContent":["\n.container[data-v-61ebf911] {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n.container .top-label[data-v-61ebf911] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: #0d79f2;\n    color: #fff;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n.container .top-label .refresh-icon i[data-v-61ebf911] {\n      margin-left: 5px;\n}\n.container .top-label .refresh-icon .tooltiptext[data-v-61ebf911] {\n      visibility: hidden;\n      width: 80px;\n      background-color: #4e4e4e;\n      color: #fff;\n      text-align: center;\n      border-radius: 6px;\n      padding: 1px 0;\n      position: absolute;\n      z-index: 1;\n      opacity: 0;\n      -webkit-transition: opacity .6s;\n      transition: opacity .6s;\n      top: 120%;\n      left: 60%;\n      font-size: 14px;\n}\n.container .top-label .refresh-icon[data-v-61ebf911]:hover {\n      cursor: pointer;\n      color: #26D97A;\n}\n.container .top-label .refresh-icon:hover .tooltiptext[data-v-61ebf911] {\n        opacity: 1;\n        visibility: visible;\n}\n.container .driver-container[data-v-61ebf911] {\n    overflow-y: auto;\n    margin-top: 30px;\n    height: calc((100vh - 110px) / 2);\n    padding: 10px;\n}\n.container .driver-container .filter-container[data-v-61ebf911] {\n      text-align: right;\n}\n.container .driver-container .filter-container .filter-license[data-v-61ebf911] {\n        width: 100px;\n        margin-bottom: 8px;\n}\n.container .driver-container table[data-v-61ebf911] {\n      width: 100%;\n      border-collapse: collapse;\n}\n.container .driver-container table .table-header[data-v-61ebf911] {\n        color: #8DA0A9;\n        font-size: 11px;\n        border: 1px solid rgba(0, 0, 0, 0.3);\n        background-color: #f5f5f5;\n}\n.container .driver-container table .table-header th[data-v-61ebf911] {\n          padding: 5px 10px;\n}\n.container .driver-container table tr[data-v-61ebf911]:nth-child(even) {\n        background-color: #f3f3f3;\n}\n.container .driver-container table td[data-v-61ebf911] {\n        font-size: 12px;\n        padding: 5px;\n        text-align: center;\n}\n.container .driver-container table tbody tr[data-v-61ebf911]:hover {\n        background-color: #fff8dc;\n}\n.staging-lots .loader[data-v-61ebf911] {\n  text-align: center;\n  font-weight: 700;\n  padding: 15px;\n}\n.staging-area-error[data-v-61ebf911] {\n  text-align: center;\n  padding: 20px 0;\n  font-weight: 700;\n  color: #F20D0D;\n}\n.driver[data-v-61ebf911] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.driver td[data-v-61ebf911] {\n    padding: 10px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.driver td input[data-v-61ebf911] {\n      margin-top: 0;\n      width: 13px;\n}\n.driver a[data-v-61ebf911] {\n    font-weight: 700;\n}\n.infinity-loader[data-v-61ebf911] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  -webkit-transform-origin: bottom center;\n          transform-origin: bottom center;\n  text-align: center;\n  font-size: 18px;\n  line-height: 40px;\n}\n@media screen and (max-width: 430px) {\n.top-label[data-v-61ebf911] {\n    font-size: 12px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"top-label"},[_c('span',[_vm._v("Outbound Assigned Business\n      "),_c('span',{staticClass:"refresh-icon",on:{"click":function($event){return _vm.refreshList()}}},[_c('i',{class:{'fas fa-sync-alt':true, 'fa-spin':_vm.driverOutbound.loading}}),_vm._v(" "),_c('span',{staticClass:"tooltiptext"},[_vm._v("Refresh")])])])]),_vm._v(" "),_c('div',{staticClass:"driver-container",on:{"scroll":_vm.loadMoreDrivers}},[_c('div',{staticClass:"staging-lots"},[_c('div',{staticClass:"filter-container"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.licenseType),expression:"licenseType"}],staticClass:"filter-license",attrs:{"name":"oab"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.licenseType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v("TNC / TCP")]),_vm._v(" "),_c('option',{attrs:{"value":"tnc"}},[_vm._v("TNC")]),_vm._v(" "),_c('option',{attrs:{"value":"tcp"}},[_vm._v("TCP")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.driverOutbound.loading),expression:"driverOutbound.loading"}],staticClass:"loader"},[_c('i',{staticClass:"fa fa-spinner fa-spin"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.driverOutbound.error),expression:"driverOutbound.error"}],staticClass:"staging-area-error"},[_vm._v("\n      There are no drivers listed in Outbound Assigned Business.\n    ")])]),_vm._v(" "),_c('table',[_c('thead',{directives:[{name:"show",rawName:"v-show",value:(!_vm.driverOutbound.loading && (!_vm.driverOutbound.error && !_vm.driverOutbound.loading)),expression:"!driverOutbound.loading && (!driverOutbound.error && !driverOutbound.loading)"}]},[_vm._m(0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.drivers),function(driver,index){return _c('tr',{key:index,staticClass:"driver"},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDriver),expression:"selectedDriver"}],attrs:{"type":"radio"},domProps:{"value":driver.id+'-'+driver.reservationID,"checked":_vm._q(_vm.selectedDriver,driver.id+'-'+driver.reservationID)},on:{"change":function($event){_vm.selectedDriver=driver.id+'-'+driver.reservationID}}})]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'#/reservation/' + driver.reservationID,"target":"_blank"}},[_vm._v(_vm._s(driver.reservationID))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(driver.pickupTime))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'#/provider/' + driver.id,"target":"_blank"}},[_c('span',[_vm._v(_vm._s(driver.name))])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(driver.pax))])])}),0)]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading && _vm.drivers.length > 0),expression:"loading && drivers.length > 0"}],staticClass:"infinity-loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" Loading\n      ")])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"table-header"},[_c('th'),_vm._v(" "),_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("PICKUP TIME")]),_vm._v(" "),_c('th',[_vm._v("NAME")]),_vm._v(" "),_c('th',[_vm._v("PAX")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverInbound_vue__ = __webpack_require__(670);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fc47cf0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverInbound_vue__ = __webpack_require__(2084);
function injectStyle (ssrContext) {
  __webpack_require__(2082)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5fc47cf0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverInbound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fc47cf0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverInbound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2083);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("f7064d46", content, true, {});

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.container[data-v-5fc47cf0] {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n.container .top-label[data-v-5fc47cf0] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: #0d79f2;\n    color: #fff;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n.container .top-label .refresh-icon i[data-v-5fc47cf0] {\n      margin-left: 5px;\n}\n.container .top-label .refresh-icon .tooltiptext[data-v-5fc47cf0] {\n      visibility: hidden;\n      width: 80px;\n      background-color: #4e4e4e;\n      color: #fff;\n      text-align: center;\n      border-radius: 6px;\n      padding: 1px 0;\n      position: absolute;\n      z-index: 1;\n      opacity: 0;\n      -webkit-transition: opacity .6s;\n      transition: opacity .6s;\n      top: 120%;\n      left: 60%;\n      font-size: 14px;\n}\n.container .top-label .refresh-icon[data-v-5fc47cf0]:hover {\n      cursor: pointer;\n      color: #26D97A;\n}\n.container .top-label .refresh-icon:hover .tooltiptext[data-v-5fc47cf0] {\n        opacity: 1;\n        visibility: visible;\n}\n.container .driver-container[data-v-5fc47cf0] {\n    overflow-y: auto;\n    margin-top: 30px;\n    height: calc((100vh - 110px) / 2);\n    padding: 10px;\n}\n.container .driver-container .filter-container[data-v-5fc47cf0] {\n      text-align: right;\n}\n.container .driver-container .filter-container .filter-license[data-v-5fc47cf0] {\n        width: 100px;\n        margin-bottom: 8px;\n}\n.container .driver-container table[data-v-5fc47cf0] {\n      width: 100%;\n      border-collapse: collapse;\n}\n.container .driver-container table .table-header[data-v-5fc47cf0] {\n        color: #8DA0A9;\n        font-size: 11px;\n        border: 1px solid rgba(0, 0, 0, 0.3);\n        background-color: #f5f5f5;\n}\n.container .driver-container table .table-header th[data-v-5fc47cf0] {\n          padding: 5px 10px;\n}\n.container .driver-container table tr[data-v-5fc47cf0]:nth-child(even) {\n        background-color: #f3f3f3;\n}\n.container .driver-container table td[data-v-5fc47cf0] {\n        font-size: 12px;\n        padding: 5px;\n        text-align: center;\n}\n.container .driver-container table tbody tr[data-v-5fc47cf0]:hover {\n        background-color: #fff8dc;\n}\n.staging-lots .loader[data-v-5fc47cf0] {\n  text-align: center;\n  font-weight: 700;\n  padding: 15px;\n}\n.staging-area-error[data-v-5fc47cf0] {\n  text-align: center;\n  padding: 20px 0;\n  font-weight: 700;\n  color: #F20D0D;\n}\n.driver[data-v-5fc47cf0] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.driver td[data-v-5fc47cf0] {\n    padding: 10px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.driver td input[data-v-5fc47cf0] {\n      margin-top: 0;\n      width: 13px;\n}\n.driver a[data-v-5fc47cf0] {\n    font-weight: 700;\n}\n.infinity-loader[data-v-5fc47cf0] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  -webkit-transform-origin: bottom center;\n          transform-origin: bottom center;\n  text-align: center;\n  font-size: 18px;\n  line-height: 40px;\n}\n@media screen and (max-width: 430px) {\n.top-label[data-v-5fc47cf0] {\n    font-size: 12px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Laxit/DriverInbound.vue"],"names":[],"mappings":";AACA;EACE,qCAAqC;EACrC,mBAAmB;CACpB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,0BAA0B;IAC1B,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,4CAA4C;IAC5C,kDAAkD;IAClD,0CAA0C;CAC7C;AACD;MACM,iBAAiB;CACtB;AACD;MACM,mBAAmB;MACnB,YAAY;MACZ,0BAA0B;MAC1B,YAAY;MACZ,mBAAmB;MACnB,mBAAmB;MACnB,eAAe;MACf,mBAAmB;MACnB,WAAW;MACX,WAAW;MACX,gCAAgC;MAChC,wBAAwB;MACxB,UAAU;MACV,UAAU;MACV,gBAAgB;CACrB;AACD;MACM,gBAAgB;MAChB,eAAe;CACpB;AACD;QACQ,WAAW;QACX,oBAAoB;CAC3B;AACD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kCAAkC;IAClC,cAAc;CACjB;AACD;MACM,kBAAkB;CACvB;AACD;QACQ,aAAa;QACb,mBAAmB;CAC1B;AACD;MACM,YAAY;MACZ,0BAA0B;CAC/B;AACD;QACQ,eAAe;QACf,gBAAgB;QAChB,qCAAqC;QACrC,0BAA0B;CACjC;AACD;UACU,kBAAkB;CAC3B;AACD;QACQ,0BAA0B;CACjC;AACD;QACQ,gBAAgB;QAChB,aAAa;QACb,mBAAmB;CAC1B;AACD;QACQ,0BAA0B;CACjC;AACD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;CACf;AACD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;CAChB;AACD;EACE,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;CACpB;AACD;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;CACtB;AACD;MACM,cAAc;MACd,YAAY;CACjB;AACD;IACI,iBAAiB;CACpB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,wCAAwC;UAChC,gCAAgC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;AACA;IACI,gBAAgB;CACnB;CACA","file":"DriverInbound.vue","sourcesContent":["\n.container[data-v-5fc47cf0] {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n.container .top-label[data-v-5fc47cf0] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: #0d79f2;\n    color: #fff;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n.container .top-label .refresh-icon i[data-v-5fc47cf0] {\n      margin-left: 5px;\n}\n.container .top-label .refresh-icon .tooltiptext[data-v-5fc47cf0] {\n      visibility: hidden;\n      width: 80px;\n      background-color: #4e4e4e;\n      color: #fff;\n      text-align: center;\n      border-radius: 6px;\n      padding: 1px 0;\n      position: absolute;\n      z-index: 1;\n      opacity: 0;\n      -webkit-transition: opacity .6s;\n      transition: opacity .6s;\n      top: 120%;\n      left: 60%;\n      font-size: 14px;\n}\n.container .top-label .refresh-icon[data-v-5fc47cf0]:hover {\n      cursor: pointer;\n      color: #26D97A;\n}\n.container .top-label .refresh-icon:hover .tooltiptext[data-v-5fc47cf0] {\n        opacity: 1;\n        visibility: visible;\n}\n.container .driver-container[data-v-5fc47cf0] {\n    overflow-y: auto;\n    margin-top: 30px;\n    height: calc((100vh - 110px) / 2);\n    padding: 10px;\n}\n.container .driver-container .filter-container[data-v-5fc47cf0] {\n      text-align: right;\n}\n.container .driver-container .filter-container .filter-license[data-v-5fc47cf0] {\n        width: 100px;\n        margin-bottom: 8px;\n}\n.container .driver-container table[data-v-5fc47cf0] {\n      width: 100%;\n      border-collapse: collapse;\n}\n.container .driver-container table .table-header[data-v-5fc47cf0] {\n        color: #8DA0A9;\n        font-size: 11px;\n        border: 1px solid rgba(0, 0, 0, 0.3);\n        background-color: #f5f5f5;\n}\n.container .driver-container table .table-header th[data-v-5fc47cf0] {\n          padding: 5px 10px;\n}\n.container .driver-container table tr[data-v-5fc47cf0]:nth-child(even) {\n        background-color: #f3f3f3;\n}\n.container .driver-container table td[data-v-5fc47cf0] {\n        font-size: 12px;\n        padding: 5px;\n        text-align: center;\n}\n.container .driver-container table tbody tr[data-v-5fc47cf0]:hover {\n        background-color: #fff8dc;\n}\n.staging-lots .loader[data-v-5fc47cf0] {\n  text-align: center;\n  font-weight: 700;\n  padding: 15px;\n}\n.staging-area-error[data-v-5fc47cf0] {\n  text-align: center;\n  padding: 20px 0;\n  font-weight: 700;\n  color: #F20D0D;\n}\n.driver[data-v-5fc47cf0] {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.driver td[data-v-5fc47cf0] {\n    padding: 10px;\n    text-align: center;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n.driver td input[data-v-5fc47cf0] {\n      margin-top: 0;\n      width: 13px;\n}\n.driver a[data-v-5fc47cf0] {\n    font-weight: 700;\n}\n.infinity-loader[data-v-5fc47cf0] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  -webkit-transform-origin: bottom center;\n          transform-origin: bottom center;\n  text-align: center;\n  font-size: 18px;\n  line-height: 40px;\n}\n@media screen and (max-width: 430px) {\n.top-label[data-v-5fc47cf0] {\n    font-size: 12px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"top-label"},[_c('span',[_vm._v("Inbound Assigned Business\n      "),_c('span',{staticClass:"refresh-icon",on:{"click":function($event){return _vm.refreshList()}}},[_c('i',{class:{'fas fa-sync-alt':true, 'fa-spin':_vm.driverInbound.loading}}),_vm._v(" "),_c('span',{staticClass:"tooltiptext"},[_vm._v("Refresh")])])])]),_vm._v(" "),_c('div',{staticClass:"driver-container",on:{"scroll":_vm.loadMoreDrivers}},[_c('div',{staticClass:"staging-lots"},[_c('div',{staticClass:"filter-container"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.licenseType),expression:"licenseType"}],staticClass:"filter-license",attrs:{"name":"iab"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.licenseType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v("TNC / TCP")]),_vm._v(" "),_c('option',{attrs:{"value":"tnc"}},[_vm._v("TNC")]),_vm._v(" "),_c('option',{attrs:{"value":"tcp"}},[_vm._v("TCP")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.driverInbound.loading),expression:"driverInbound.loading"}],staticClass:"loader"},[_c('i',{staticClass:"fa fa-spinner fa-spin"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.driverInbound.error),expression:"driverInbound.error"}],staticClass:"staging-area-error"},[_vm._v("\n      There are no drivers listed in Inbound Assigned Business.\n    ")])]),_vm._v(" "),_c('table',[_c('thead',{directives:[{name:"show",rawName:"v-show",value:(!_vm.driverInbound.loading && (!_vm.driverInbound.error && !_vm.driverInbound.loading)),expression:"!driverInbound.loading && (!driverInbound.error && !driverInbound.loading)"}]},[_vm._m(0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.drivers),function(driver,index){return _c('tr',{key:index,staticClass:"driver"},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDriver),expression:"selectedDriver"}],attrs:{"type":"radio"},domProps:{"value":driver.id+'-'+driver.reservationID,"checked":_vm._q(_vm.selectedDriver,driver.id+'-'+driver.reservationID)},on:{"change":function($event){_vm.selectedDriver=driver.id+'-'+driver.reservationID}}})]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'#/reservation/' + driver.reservationID,"target":"_blank"}},[_vm._v(_vm._s(driver.reservationID))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(driver.eta))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'#/provider/' + driver.id,"target":"_blank"}},[_c('span',[_vm._v(_vm._s(driver.name))])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(driver.pax))])])}),0)]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading && _vm.drivers.length > 0),expression:"loading && drivers.length > 0"}],staticClass:"infinity-loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" Loading\n      ")])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"table-header"},[_c('th'),_vm._v(" "),_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("ETA")]),_vm._v(" "),_c('th',[_vm._v("NAME")]),_vm._v(" "),_c('th',[_vm._v("PAX")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverControls_vue__ = __webpack_require__(671);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5afe5a76_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverControls_vue__ = __webpack_require__(2088);
function injectStyle (ssrContext) {
  __webpack_require__(2086)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5afe5a76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverControls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5afe5a76_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverControls_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2087);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("17b64fbb", content, true, {});

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.driver-controls[data-v-5afe5a76] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 5px 15px;\n  background-color: #3a3a3a;\n  border-left: 1px solid rgba(0, 0, 0, 0.2);\n  border-right: 1px solid rgba(0, 0, 0, 0.2);\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n}\n.padding-R[data-v-5afe5a76] {\n  padding-right: 5px;\n}\n.padding-L[data-v-5afe5a76] {\n  padding-left: 5px;\n}\n.margin-T[data-v-5afe5a76] {\n  margin-top: 10px;\n}\n.dispatch-modal[data-v-5afe5a76] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.dispatch-modal.show[data-v-5afe5a76] {\n    top: 0;\n    opacity: 1;\n}\n.dispatch-modal .option[data-v-5afe5a76] {\n    display: block;\n    width: 300px;\n    margin: 0 auto;\n    text-align: left;\n}\n.dispatch-modal .option input[type=radio][data-v-5afe5a76] {\n      width: auto;\n      display: inline-block;\n      margin-right: 5px;\n      margin-top: 0;\n}\n.dispatch-modal .option span.s[data-v-5afe5a76] {\n      display: inline-block;\n      font-size: 14px;\n      color: #444;\n}\n.dispatch-modal-container[data-v-5afe5a76] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.dispatch-modal-content[data-v-5afe5a76] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.validation-modal .title[data-v-5afe5a76] {\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n  background-color: #F25E0D;\n  padding: 8px 15px;\n}\n.validation-modal .message[data-v-5afe5a76] {\n  font-size: 16px;\n  font-weight: 700;\n  color: #555;\n  padding: 15px 15px 10px;\n}\n.validation-modal .button[data-v-5afe5a76] {\n  font-weight: 700;\n}\n.validation-modal .cancel[data-v-5afe5a76] {\n  margin-top: 10px;\n  color: #999;\n  display: inline-block;\n}\n.action-modal[data-v-5afe5a76] {\n  padding: 15px;\n}\n.action-modal .message[data-v-5afe5a76] {\n    font-weight: 700;\n    color: #777;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.action-modal .message.success[data-v-5afe5a76] {\n      color: #26D97A;\n}\n.action-modal .message.error[data-v-5afe5a76] {\n      color: #F20D0D;\n}\n.circle-loader[data-v-5afe5a76] {\n  margin: 0 0 10px 10px;\n  border: 5px solid rgba(0, 0, 0, 0.2);\n  border-left-color: #26D97A;\n  -webkit-animation-name: loader-spin-data-v-5afe5a76;\n          animation-name: loader-spin-data-v-5afe5a76;\n  -webkit-animation-duration: 1s;\n          animation-duration: 1s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n.circle-loader[data-v-5afe5a76],\n.circle-loader[data-v-5afe5a76]:after {\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n}\n.load-complete[data-v-5afe5a76] {\n  -webkit-animation: none;\n  animation: none;\n  border-color: #26D97A;\n  -webkit-transition: border 500ms ease-out;\n  transition: border 500ms ease-out;\n}\n.load-error[data-v-5afe5a76] {\n  -webkit-animation: none;\n  animation: none;\n  border-color: #F20D0D;\n  -webkit-transition: border 500ms ease-out;\n  transition: border 500ms ease-out;\n}\n.checkmark[data-v-5afe5a76] {\n  opacity: 0;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n.checkmark.draw[data-v-5afe5a76] {\n    opacity: 1;\n}\n.checkmark.draw[data-v-5afe5a76]:after {\n    opacity: 1;\n    height: 25px;\n    width: 12.5px;\n    -webkit-transform-origin: left top;\n            transform-origin: left top;\n    border-right: 5px solid #26D97A;\n    border-top: 5px solid #26D97A;\n    content: '';\n    left: calc(12.5px - 5px);\n    top: calc(25px + 2px);\n    position: absolute;\n    -webkit-animation-duration: 1.2s;\n            animation-duration: 1.2s;\n    -webkit-animation-timing-function: ease;\n            animation-timing-function: ease;\n    -webkit-animation-name: checkmark-data-v-5afe5a76;\n            animation-name: checkmark-data-v-5afe5a76;\n    -webkit-transform: scaleX(-1) rotate(135deg);\n            transform: scaleX(-1) rotate(135deg);\n}\n.checkmark.error[data-v-5afe5a76] {\n    position: absolute;\n    left: calc(12.5px - 2px);\n    top: 12.5px;\n    width: 25px;\n    height: 25px;\n    opacity: 0;\n}\n.checkmark.error.show[data-v-5afe5a76] {\n      opacity: 1;\n}\n.checkmark.error[data-v-5afe5a76]:before, .checkmark.error[data-v-5afe5a76]:after {\n      position: absolute;\n      content: ' ';\n      height: 25px;\n      width: 5px;\n      background-color: #f00;\n}\n.checkmark.error[data-v-5afe5a76]:before {\n      -webkit-transform: rotate(45deg);\n              transform: rotate(45deg);\n}\n.checkmark.error[data-v-5afe5a76]:after {\n      -webkit-transform: rotate(-45deg);\n              transform: rotate(-45deg);\n}\n@-webkit-keyframes loader-spin-data-v-5afe5a76 {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes loader-spin-data-v-5afe5a76 {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@-webkit-keyframes checkmark-data-v-5afe5a76 {\n0% {\n    height: 0;\n    width: 0;\n    opacity: 1;\n}\n20% {\n    height: 0;\n    width: 12.5px;\n    opacity: 1;\n}\n40% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n100% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n}\n@keyframes checkmark-data-v-5afe5a76 {\n0% {\n    height: 0;\n    width: 0;\n    opacity: 1;\n}\n20% {\n    height: 0;\n    width: 12.5px;\n    opacity: 1;\n}\n40% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n100% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n}\n.input-integer > *[data-v-5afe5a76] {\n  display: inline-block;\n  vertical-align: middle;\n  margin-top: 5px;\n}\ninput[type=\"number\"][data-v-5afe5a76] {\n  font-size: 14px;\n  padding: 7px 10px;\n  display: inline-block;\n  width: 200px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-integer span[data-v-5afe5a76] {\n  font-size: 12px;\n  background-color: #555;\n  color: #fff;\n  padding: 9px 10px 10px;\n  margin-left: -5px;\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Laxit/DriverControls.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,0CAA0C;EAC1C,2CAA2C;EAC3C,yCAAyC;CAC1C;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;IACI,eAAe;IACf,aAAa;IACb,eAAe;IACf,iBAAiB;CACpB;AACD;MACM,YAAY;MACZ,sBAAsB;MACtB,kBAAkB;MAClB,cAAc;CACnB;AACD;MACM,sBAAsB;MACtB,gBAAgB;MAChB,YAAY;CACjB;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,iBAAiB;CAClB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;CACnB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;CACzB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;CACvB;AACD;EACE,cAAc;CACf;AACD;IACI,iBAAiB;IACjB,YAAY;IACZ,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;MACM,eAAe;CACpB;AACD;MACM,eAAe;CACpB;AACD;EACE,sBAAsB;EACtB,qCAAqC;EACrC,2BAA2B;EAC3B,oDAAoD;UAC5C,4CAA4C;EACpD,+BAA+B;UACvB,uBAAuB;EAC/B,4CAA4C;UACpC,oCAAoC;EAC5C,0CAA0C;UAClC,kCAAkC;EAC1C,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,gCAAgC;UACxB,wBAAwB;CACjC;AACD;;EAEE,mBAAmB;EACnB,YAAY;EACZ,aAAa;CACd;AACD;EACE,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,kCAAkC;CACnC;AACD;EACE,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,kCAAkC;CACnC;AACD;EACE,WAAW;EACX,gCAAgC;UACxB,wBAAwB;CACjC;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,mCAAmC;YAC3B,2BAA2B;IACnC,gCAAgC;IAChC,8BAA8B;IAC9B,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,iCAAiC;YACzB,yBAAyB;IACjC,wCAAwC;YAChC,gCAAgC;IACxC,kDAAkD;YAC1C,0CAA0C;IAClD,6CAA6C;YACrC,qCAAqC;CAChD;AACD;IACI,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,WAAW;CACd;AACD;MACM,WAAW;CAChB;AACD;MACM,mBAAmB;MACnB,aAAa;MACb,aAAa;MACb,WAAW;MACX,uBAAuB;CAC5B;AACD;MACM,iCAAiC;cACzB,yBAAyB;CACtC;AACD;MACM,kCAAkC;cAC1B,0BAA0B;CACvC;AACD;AACA;IACI,gCAAgC;YACxB,wBAAwB;CACnC;AACD;IACI,kCAAkC;YAC1B,0BAA0B;CACrC;CACA;AACD;AACA;IACI,gCAAgC;YACxB,wBAAwB;CACnC;AACD;IACI,kCAAkC;YAC1B,0BAA0B;CACrC;CACA;AACD;AACA;IACI,UAAU;IACV,SAAS;IACT,WAAW;CACd;AACD;IACI,UAAU;IACV,cAAc;IACd,WAAW;CACd;AACD;IACI,aAAa;IACb,cAAc;IACd,WAAW;CACd;AACD;IACI,aAAa;IACb,cAAc;IACd,WAAW;CACd;CACA;AACD;AACA;IACI,UAAU;IACV,SAAS;IACT,WAAW;CACd;AACD;IACI,UAAU;IACV,cAAc;IACd,WAAW;CACd;AACD;IACI,aAAa;IACb,cAAc;IACd,WAAW;CACd;AACD;IACI,aAAa;IACb,cAAc;IACd,WAAW;CACd;CACA;AACD;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;CACjB;AACD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,2BAA2B;EAC3B,8BAA8B;CAC/B;AACD;EACE,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;CACjC","file":"DriverControls.vue","sourcesContent":["\n.driver-controls[data-v-5afe5a76] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 5px 15px;\n  background-color: #3a3a3a;\n  border-left: 1px solid rgba(0, 0, 0, 0.2);\n  border-right: 1px solid rgba(0, 0, 0, 0.2);\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n}\n.padding-R[data-v-5afe5a76] {\n  padding-right: 5px;\n}\n.padding-L[data-v-5afe5a76] {\n  padding-left: 5px;\n}\n.margin-T[data-v-5afe5a76] {\n  margin-top: 10px;\n}\n.dispatch-modal[data-v-5afe5a76] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.dispatch-modal.show[data-v-5afe5a76] {\n    top: 0;\n    opacity: 1;\n}\n.dispatch-modal .option[data-v-5afe5a76] {\n    display: block;\n    width: 300px;\n    margin: 0 auto;\n    text-align: left;\n}\n.dispatch-modal .option input[type=radio][data-v-5afe5a76] {\n      width: auto;\n      display: inline-block;\n      margin-right: 5px;\n      margin-top: 0;\n}\n.dispatch-modal .option span.s[data-v-5afe5a76] {\n      display: inline-block;\n      font-size: 14px;\n      color: #444;\n}\n.dispatch-modal-container[data-v-5afe5a76] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.dispatch-modal-content[data-v-5afe5a76] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 400px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.validation-modal .title[data-v-5afe5a76] {\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n  background-color: #F25E0D;\n  padding: 8px 15px;\n}\n.validation-modal .message[data-v-5afe5a76] {\n  font-size: 16px;\n  font-weight: 700;\n  color: #555;\n  padding: 15px 15px 10px;\n}\n.validation-modal .button[data-v-5afe5a76] {\n  font-weight: 700;\n}\n.validation-modal .cancel[data-v-5afe5a76] {\n  margin-top: 10px;\n  color: #999;\n  display: inline-block;\n}\n.action-modal[data-v-5afe5a76] {\n  padding: 15px;\n}\n.action-modal .message[data-v-5afe5a76] {\n    font-weight: 700;\n    color: #777;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n}\n.action-modal .message.success[data-v-5afe5a76] {\n      color: #26D97A;\n}\n.action-modal .message.error[data-v-5afe5a76] {\n      color: #F20D0D;\n}\n.circle-loader[data-v-5afe5a76] {\n  margin: 0 0 10px 10px;\n  border: 5px solid rgba(0, 0, 0, 0.2);\n  border-left-color: #26D97A;\n  -webkit-animation-name: loader-spin-data-v-5afe5a76;\n          animation-name: loader-spin-data-v-5afe5a76;\n  -webkit-animation-duration: 1s;\n          animation-duration: 1s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n.circle-loader[data-v-5afe5a76],\n.circle-loader[data-v-5afe5a76]:after {\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n}\n.load-complete[data-v-5afe5a76] {\n  -webkit-animation: none;\n  animation: none;\n  border-color: #26D97A;\n  -webkit-transition: border 500ms ease-out;\n  transition: border 500ms ease-out;\n}\n.load-error[data-v-5afe5a76] {\n  -webkit-animation: none;\n  animation: none;\n  border-color: #F20D0D;\n  -webkit-transition: border 500ms ease-out;\n  transition: border 500ms ease-out;\n}\n.checkmark[data-v-5afe5a76] {\n  opacity: 0;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n.checkmark.draw[data-v-5afe5a76] {\n    opacity: 1;\n}\n.checkmark.draw[data-v-5afe5a76]:after {\n    opacity: 1;\n    height: 25px;\n    width: 12.5px;\n    -webkit-transform-origin: left top;\n            transform-origin: left top;\n    border-right: 5px solid #26D97A;\n    border-top: 5px solid #26D97A;\n    content: '';\n    left: calc(12.5px - 5px);\n    top: calc(25px + 2px);\n    position: absolute;\n    -webkit-animation-duration: 1.2s;\n            animation-duration: 1.2s;\n    -webkit-animation-timing-function: ease;\n            animation-timing-function: ease;\n    -webkit-animation-name: checkmark-data-v-5afe5a76;\n            animation-name: checkmark-data-v-5afe5a76;\n    -webkit-transform: scaleX(-1) rotate(135deg);\n            transform: scaleX(-1) rotate(135deg);\n}\n.checkmark.error[data-v-5afe5a76] {\n    position: absolute;\n    left: calc(12.5px - 2px);\n    top: 12.5px;\n    width: 25px;\n    height: 25px;\n    opacity: 0;\n}\n.checkmark.error.show[data-v-5afe5a76] {\n      opacity: 1;\n}\n.checkmark.error[data-v-5afe5a76]:before, .checkmark.error[data-v-5afe5a76]:after {\n      position: absolute;\n      content: ' ';\n      height: 25px;\n      width: 5px;\n      background-color: #f00;\n}\n.checkmark.error[data-v-5afe5a76]:before {\n      -webkit-transform: rotate(45deg);\n              transform: rotate(45deg);\n}\n.checkmark.error[data-v-5afe5a76]:after {\n      -webkit-transform: rotate(-45deg);\n              transform: rotate(-45deg);\n}\n@-webkit-keyframes loader-spin-data-v-5afe5a76 {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes loader-spin-data-v-5afe5a76 {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@-webkit-keyframes checkmark-data-v-5afe5a76 {\n0% {\n    height: 0;\n    width: 0;\n    opacity: 1;\n}\n20% {\n    height: 0;\n    width: 12.5px;\n    opacity: 1;\n}\n40% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n100% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n}\n@keyframes checkmark-data-v-5afe5a76 {\n0% {\n    height: 0;\n    width: 0;\n    opacity: 1;\n}\n20% {\n    height: 0;\n    width: 12.5px;\n    opacity: 1;\n}\n40% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n100% {\n    height: 25px;\n    width: 12.5px;\n    opacity: 1;\n}\n}\n.input-integer > *[data-v-5afe5a76] {\n  display: inline-block;\n  vertical-align: middle;\n  margin-top: 5px;\n}\ninput[type=\"number\"][data-v-5afe5a76] {\n  font-size: 14px;\n  padding: 7px 10px;\n  display: inline-block;\n  width: 200px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-integer span[data-v-5afe5a76] {\n  font-size: 12px;\n  background-color: #555;\n  color: #fff;\n  padding: 9px 10px 10px;\n  margin-left: -5px;\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"driver-controls"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns padding-R small-4"},[_c('a',{staticClass:"button cta small success block",attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.modal.show = true}}},[_vm._v("SEND TO DRIVER")])]),_vm._v(" "),_c('div',{staticClass:"small-4 columns padding-L padding-R"},[_c('a',{staticClass:"button cta small block",attrs:{"href":"javascript:;"},on:{"click":_vm.assignToDriver}},[_vm._v("ASSIGN TO DRIVER")])]),_vm._v(" "),_c('div',{staticClass:"columns padding-L small-4"},[_c('a',{staticClass:"button cta small warning block",attrs:{"href":"javascript:;"},on:{"click":_vm.sendAsAsap}},[_vm._v("SEND AS ASAP")])])]),_vm._v(" "),_c('div',{class:['dispatch-modal', {show: _vm.modal.show}],on:{"click":_vm.close}},[_c('div',{staticClass:"dispatch-modal-container"},[_c('div',{staticClass:"dispatch-modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"validation-modal"},[_c('div',{staticClass:"title"},[_vm._v("Send to driver")]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("Accept Request Timeout")]),_vm._v(" "),_c('label',{staticClass:"option",on:{"click":function($event){_vm.modal.option = 'default'}}},[(_vm.modal.show)?_c('input',{attrs:{"type":"radio","name":"crt","checked":"checked"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"s"},[_vm._v("Default ("+_vm._s(_vm.$settings.get('ASAPRequestTimeout'))+" sec)")])]),_vm._v(" "),_c('label',{staticClass:"option",on:{"click":function($event){_vm.modal.option = 'custom'}}},[(_vm.modal.show)?_c('input',{attrs:{"type":"radio","name":"crt"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-integer",staticStyle:{"display":"inline-block"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modal.custom),expression:"modal.custom"}],attrs:{"type":"number"},domProps:{"value":(_vm.modal.custom)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modal, "custom", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v("secs")])])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"10px 50px","margin":"30px 0 10px"}},[_c('a',{staticClass:"button success block",attrs:{"href":"javascript:;"},on:{"click":_vm.sendToDriver}},[_vm._v("Yes")]),_vm._v(" "),_c('a',{staticClass:"cancel",attrs:{"href":"javascript:;"},on:{"click":_vm.close}},[_vm._v("No, I change my mind")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReadyToGoModal_vue__ = __webpack_require__(672);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70f1c443_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReadyToGoModal_vue__ = __webpack_require__(2092);
function injectStyle (ssrContext) {
  __webpack_require__(2090)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70f1c443"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReadyToGoModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70f1c443_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReadyToGoModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2091);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("74416deb", content, true, {});

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.rtg-modal[data-v-70f1c443] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.rtg-modal.show[data-v-70f1c443] {\n    top: 0;\n    opacity: 1;\n}\n.rtg-modal-container[data-v-70f1c443] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.rtg-modal-content[data-v-70f1c443] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 500px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.confirmation[data-v-70f1c443] {\n  padding: 30px;\n  position: relative;\n}\n.confirmation label[data-v-70f1c443] {\n    display: block;\n    margin-bottom: 30px;\n    font-size: 15px;\n    font-weight: 600;\n    color: #444;\n}\n.confirmation .button[data-v-70f1c443] {\n    margin: 0 5px;\n}\n.confirmation .error i[data-v-70f1c443] {\n    display: block;\n    margin-bottom: 10px;\n    color: #ecaa32;\n}\n.confirmation .success i[data-v-70f1c443] {\n    display: block;\n    margin-bottom: 10px;\n    color: #26d97a;\n}\n.confirmation .loader[data-v-70f1c443] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    font-weight: 600;\n    color: #333;\n    background: rgba(255, 255, 255, 0.8);\n}\n.confirmation .loader i[data-v-70f1c443] {\n      margin-top: 30px;\n      color: #2669bd;\n      display: block;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Laxit/ReadyToGoModal.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,iBAAiB;CAClB;AACD;EACE,cAAc;EACd,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,cAAc;CACjB;AACD;IACI,eAAe;IACf,oBAAoB;IACpB,eAAe;CAClB;AACD;IACI,eAAe;IACf,oBAAoB;IACpB,eAAe;CAClB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,qCAAqC;CACxC;AACD;MACM,iBAAiB;MACjB,eAAe;MACf,eAAe;CACpB","file":"ReadyToGoModal.vue","sourcesContent":["\n.rtg-modal[data-v-70f1c443] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.rtg-modal.show[data-v-70f1c443] {\n    top: 0;\n    opacity: 1;\n}\n.rtg-modal-container[data-v-70f1c443] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.rtg-modal-content[data-v-70f1c443] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 500px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.confirmation[data-v-70f1c443] {\n  padding: 30px;\n  position: relative;\n}\n.confirmation label[data-v-70f1c443] {\n    display: block;\n    margin-bottom: 30px;\n    font-size: 15px;\n    font-weight: 600;\n    color: #444;\n}\n.confirmation .button[data-v-70f1c443] {\n    margin: 0 5px;\n}\n.confirmation .error i[data-v-70f1c443] {\n    display: block;\n    margin-bottom: 10px;\n    color: #ecaa32;\n}\n.confirmation .success i[data-v-70f1c443] {\n    display: block;\n    margin-bottom: 10px;\n    color: #26d97a;\n}\n.confirmation .loader[data-v-70f1c443] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    font-weight: 600;\n    color: #333;\n    background: rgba(255, 255, 255, 0.8);\n}\n.confirmation .loader i[data-v-70f1c443] {\n      margin-top: 30px;\n      color: #2669bd;\n      display: block;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'rtg-modal':true, show:_vm.show },on:{"click":_vm.close}},[_c('div',{staticClass:"rtg-modal-container"},[_c('div',{staticClass:"rtg-modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"confirmation"},[(_vm.error === '' && !_vm.success)?_c('div',[_c('label',[_vm._v("Confirm \"Ready to go\" status for Reservation #"+_vm._s(_vm.rsvpID))]),_vm._v(" "),_c('div',{staticClass:"button cta error",on:{"click":_vm.close}},[_vm._v("Cancel")]),_vm._v(" "),_c('div',{staticClass:"button cta success",on:{"click":_vm.confirm}},[_vm._v("Confirm")])]):(!_vm.success)?_c('div',{staticClass:"error"},[_c('i',{staticClass:"fas fa-exclamation-triangle fa-3x"}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.error))]),_vm._v(" "),_c('div',{staticClass:"button cta error small block",on:{"click":_vm.close}},[_vm._v("Close")])]):_vm._e(),_vm._v(" "),(_vm.success)?_c('div',{staticClass:"success"},[_c('i',{staticClass:"far fa-check-circle fa-3x"}),_vm._v(" "),_c('label',[_vm._v("Successfully applied \"Ready to go\" status on Reservation #"+_vm._s(_vm.rsvpID))]),_vm._v(" "),_c('div',{staticClass:"button cta success small block",on:{"click":_vm.close}},[_vm._v("Close")])]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin fa-4x"}),_vm._v("\n            Please wait...\n          ")])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotesModal_vue__ = __webpack_require__(673);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ebca594_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotesModal_vue__ = __webpack_require__(2098);
function injectStyle (ssrContext) {
  __webpack_require__(2094)
  __webpack_require__(2096)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ebca594"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotesModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ebca594_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotesModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2095);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("fbd7d9b8", content, true, {});

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.rtg-modal[data-v-2ebca594] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.rtg-modal.show[data-v-2ebca594] {\n    top: 0;\n    opacity: 1;\n}\n.rtg-modal-container[data-v-2ebca594] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.rtg-modal-content[data-v-2ebca594] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 500px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.top[data-v-2ebca594] {\n  background-color: #0d79f2;\n  color: #fff;\n  font-size: 18px;\n  font-weight: 600;\n  padding: 10px 0;\n}\n.confirmation[data-v-2ebca594] {\n  padding: 30px;\n  position: relative;\n}\n.confirmation label[data-v-2ebca594] {\n    display: block;\n    margin-bottom: 30px;\n    font-size: 15px;\n    font-weight: 600;\n    color: #444;\n}\n.confirmation .button[data-v-2ebca594] {\n    margin: 0 5px;\n}\n.confirmation .error i[data-v-2ebca594] {\n    display: block;\n    margin-bottom: 10px;\n    color: #ecaa32;\n}\n.confirmation .success i[data-v-2ebca594] {\n    display: block;\n    margin-bottom: 10px;\n    color: #26d97a;\n}\n.confirmation .loader[data-v-2ebca594] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    font-weight: 600;\n    color: #333;\n    background: rgba(255, 255, 255, 0.8);\n}\n.confirmation .loader i[data-v-2ebca594] {\n      margin-top: 30px;\n      color: #2669bd;\n      display: block;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Laxit/NotesModal.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;IACI,OAAO;IACP,WAAW;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;UAC1C,0CAA0C;EAClD,mBAAmB;EACnB,iBAAiB;CAClB;AACD;EACE,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;CACjB;AACD;EACE,cAAc;EACd,mBAAmB;CACpB;AACD;IACI,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,cAAc;CACjB;AACD;IACI,eAAe;IACf,oBAAoB;IACpB,eAAe;CAClB;AACD;IACI,eAAe;IACf,oBAAoB;IACpB,eAAe;CAClB;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,qCAAqC;CACxC;AACD;MACM,iBAAiB;MACjB,eAAe;MACf,eAAe;CACpB","file":"NotesModal.vue","sourcesContent":["\n.rtg-modal[data-v-2ebca594] {\n  position: fixed;\n  z-index: 999;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: table;\n  opacity: 0;\n  -webkit-transition: all 250ms;\n  transition: all 250ms;\n}\n.rtg-modal.show[data-v-2ebca594] {\n    top: 0;\n    opacity: 1;\n}\n.rtg-modal-container[data-v-2ebca594] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.rtg-modal-content[data-v-2ebca594] {\n  background-color: #fff;\n  border-radius: 3px;\n  max-width: 500px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  overflow: hidden;\n}\n.top[data-v-2ebca594] {\n  background-color: #0d79f2;\n  color: #fff;\n  font-size: 18px;\n  font-weight: 600;\n  padding: 10px 0;\n}\n.confirmation[data-v-2ebca594] {\n  padding: 30px;\n  position: relative;\n}\n.confirmation label[data-v-2ebca594] {\n    display: block;\n    margin-bottom: 30px;\n    font-size: 15px;\n    font-weight: 600;\n    color: #444;\n}\n.confirmation .button[data-v-2ebca594] {\n    margin: 0 5px;\n}\n.confirmation .error i[data-v-2ebca594] {\n    display: block;\n    margin-bottom: 10px;\n    color: #ecaa32;\n}\n.confirmation .success i[data-v-2ebca594] {\n    display: block;\n    margin-bottom: 10px;\n    color: #26d97a;\n}\n.confirmation .loader[data-v-2ebca594] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    font-weight: 600;\n    color: #333;\n    background: rgba(255, 255, 255, 0.8);\n}\n.confirmation .loader i[data-v-2ebca594] {\n      margin-top: 30px;\n      color: #2669bd;\n      display: block;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2097);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("6ddd374d", content, true, {});

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\ndiv[data-v-2ebca594] .message {\r\n    display:block;\r\n    margin-bottom: 30px;\r\n    font-size:15px;\r\n    font-weight: 600;\r\n    color:#444;\n}\r\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Laxit/NotesModal.vue"],"names":[],"mappings":";AACA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,WAAW;CACd","file":"NotesModal.vue","sourcesContent":["\ndiv[data-v-2ebca594] .message {\r\n    display:block;\r\n    margin-bottom: 30px;\r\n    font-size:15px;\r\n    font-weight: 600;\r\n    color:#444;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'rtg-modal':true, show:_vm.show },on:{"click":_vm.close}},[_c('div',{staticClass:"rtg-modal-container"},[_c('div',{staticClass:"rtg-modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"confirmation"},[_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.message)}}),_vm._v(" "),_c('div',{staticClass:"button cta success",on:{"click":_vm.close}},[_vm._v("OK")])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin fa-4x"}),_vm._v("\n            Please wait...\n          ")])])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},[_c('span',[_vm._v("NOTES TO DRIVER")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  getOnDutyDrivers: function getOnDutyDrivers(VueApp, callback) {
    var self = this;
    var token = VueApp.$store.state.session.sessionToken;
    var request = {
      token: token,
      duty: 1,
      pageNum: VueApp.$store.state.laxit.onDuty.pageNum,
      pageSize: VueApp.$store.state.laxit.onDuty.pageSize,
      order: VueApp.$store.state.laxit.onDuty.order,
      orderAsc: VueApp.$store.state.laxit.onDuty.asc ? 1 : 0
    };
    VueApp.$sdk.get('/provider', request, function (r) {
      console.log(5, r);
      if (r.error) {
        console.log('ON DUTY ERROR:', r);
        callback(r);
        return;
      }

      var result = [];
      for (var i = 0; i < r.list.length; i++) {
        result.push(self.formatData(r.list[i], false, VueApp));
      }

      // VueApp.$store.commit('dispatch/setServiceCount', r.services)
      VueApp.$store.commit('laxit/setOnDutyDrivers', result);
      if (r.paging) {
        VueApp.$store.commit('laxit/setOnDutyTotalPages', r.paging.totalItems);
      }
      callback(r);
    });
  },
  formatData: function formatData(item, isNew, VueApp) {
    var serviceTypes = [];

    if (Array.isArray(item.services)) {
      for (var i = 0; i < item.services.length; i++) {
        serviceTypes.push({
          label: __WEBPACK_IMPORTED_MODULE_0__services__["a" /* default */].getServiceName(item.services[i]),
          class: item.services[i].toLowerCase()
        });
      }
    } else {
      for (var property in item.services) {
        if (!item.services.hasOwnProperty(property) || property === 'undefined') {
          continue;
        }
        serviceTypes.push({
          label: __WEBPACK_IMPORTED_MODULE_0__services__["a" /* default */].getServiceName(property),
          class: property.toLowerCase()
        });
      }
    }

    var onBoard = 0;
    var status = 'Available';
    if (item.rsvp !== null) {
      onBoard = item.rsvp.passengers;
      status = 'Ongoing';
    }

    if (item.stagingLot !== null && item.rsvp === null) {
      status = 'On Staging';
    }

    var stagingLot = null;

    if (item.stagingLot) {
      stagingLot = {};
      stagingLot.id = item.stagingLot.geofenceId;
      stagingLot.name = item.stagingLot.geofenceName;
      stagingLot.services = [];

      var stagingServices = item.stagingLot.services;

      var _loop = function _loop(_i) {
        var stagingService = stagingServices[_i];
        var serviceName = '';
        if (!stagingService.serviceType) {
          var serviceList = VueApp.$store.state.services.list;
          var index = serviceList.findIndex(function (x) {
            return x.id === stagingService.serviceTypeId;
          });
          if (index > -1) {
            serviceName = serviceList[index].label;
          }
        } else {
          serviceName = stagingService.serviceType === 'suv' ? 'SUV' : stagingService.serviceType.toLowerCase().replace(/(^| )(\w)/g, function (s) {
            return s.toUpperCase();
          });
        }
        // let serviceName = stagingService.serviceType === 'suv' ? 'SUV' :
        // stagingService.serviceType.toLowerCase().replace(/(^| )(\w)/g, s => s.toUpperCase())
        var serviceStatus = stagingService.status === 'ondeck' ? 'OnDeck' : stagingService.status.toLowerCase().replace(/(^| )(\w)/g, function (s) {
          return s.toUpperCase();
        });

        stagingLot.services.push({
          serviceTypeId: stagingService.serviceTypeId,
          serviceName: serviceName,
          serviceClass: stagingService.serviceType,
          status: serviceStatus,
          priority: stagingService.priority
        });
      };

      for (var _i = 0; _i < stagingServices.length; _i++) {
        _loop(_i);
      }
    }

    var driverData = {
      id: item.ID,
      firstName: item.firstName,
      lastName: item.lastName,
      phone: item.phone,
      email: item.email,
      photoUrl: item.avatarUrl,
      licenseType: item.providerAccountType,
      serviceTypes: serviceTypes,
      businessName: item.businessName,
      capacity: item.vehicle.seatCapacity,
      onBoard: onBoard,
      status: status,
      isNew: isNew,
      coords: {
        lat: null,
        lng: null
      },
      vehicle: {
        name: item.vehicle.manufacturer + ' ' + item.vehicle.model,
        licensePlate: item.vehicle.licensePlate,
        photoUrl: item.vehicle.photoUrl ? item.vehicle.photoUrl : item.vehicle.photo
      },
      rsvp: item.rsvp,
      stagingLot: stagingLot
      // if (!CONFIG.useOldQuatation) {
      //   driverData.serviceTypes
      // }

    };return driverData;
  }
});

/***/ }),
/* 2100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dispatch-laxit"},[(_vm.isMobile)?_c('div',{staticClass:"tabs-mobile"},[_c('a',{class:{ tab: true, active: _vm.activeTabIndex === 0 },attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.activeTabIndex = 0}}},[_vm._v("\n      LEFT PANEL\n    ")]),_vm._v(" "),_c('a',{class:{ tab: true, active: _vm.activeTabIndex === 1 },attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.activeTabIndex = 1}}},[_vm._v("\n      RIGHT PANEL\n    ")])]):_vm._e(),_vm._v(" "),_c('div',{class:['panel left-panel', _vm.activeTabIndex === 0 && _vm.isMobile ? 'active' : '']},[_c('div',{staticClass:"search-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],attrs:{"type":"text","placeholder":_vm.$t('dispatch.rsvpSearchPlaceholder')},domProps:{"value":(_vm.searchInput)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"tnc-reservations left-side-table"},[_c('div',{staticClass:"header"},[_vm._v("\n        Customer / Packages TNC\n        "),_c('span',{staticClass:"refresh-icon",on:{"click":function($event){return _vm.refresh('tncReservations')}}},[_c('i',{class:{'fas fa-sync-alt':true, 'fa-spin':_vm.tncLoading}}),_vm._v(" "),_c('span',{staticClass:"tooltiptext"},[_vm._v("Refresh")])])]),_vm._v(" "),_c('div',{staticClass:"table-box",on:{"scroll":_vm.onScrollPackage}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tncLoading && !_vm.tncList.length),expression:"tncLoading && !tncList.length"}],staticClass:"table-loader"},[_c('ellipsis-loader'),_vm._v(" "),_c('div',{staticClass:"loader-title"},[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.loadingData.title')))]),_vm._v(" "),_c('div',{staticClass:"loader-text"},[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.loadingData.content')))])],1),_vm._v(" "),_c('tnc-reservations',{directives:[{name:"show",rawName:"v-show",value:(_vm.tncList.length),expression:"tncList.length"}],ref:"tncReservations",attrs:{"isMobile":_vm.isMobile}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tncLoading && _vm.tncList.length > 0),expression:"tncLoading && tncList.length > 0"}],staticClass:"infinity-loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" Loading\n          ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tncList.length <= 0 && !_vm.tncLoading),expression:"tncList.length <= 0 && !tncLoading"}],staticClass:"empty-reservations"},[_c('div',{staticClass:"title"},[_vm._v("Oops. Looks like we found nothing.")]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v("\n            No available reservations/packages as of yet.\n          ")])])],1),_vm._v(" "),_c('div',{staticClass:"control"},[_c('tnc-reservations-control')],1)]),_vm._v(" "),_c('div',{staticClass:"other-reservations left-side-table"},[_c('div',{staticClass:"header"},[_vm._v("\n        Upcoming / Unrouted\n        "),_c('span',{staticClass:"refresh-icon",on:{"click":function($event){return _vm.refresh('unrouted')}}},[_c('i',{class:{'fas fa-sync-alt':true, 'fa-spin':_vm.unroutedLoading}}),_vm._v(" "),_c('span',{staticClass:"tooltiptext"},[_vm._v("Refresh")])])]),_vm._v(" "),_c('div',{staticClass:"table-box",on:{"scroll":_vm.onScrollUnpackage}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.unroutedLoading && !_vm.unroutedList.length),expression:"unroutedLoading && !unroutedList.length"}],staticClass:"table-loader"},[_c('ellipsis-loader'),_vm._v(" "),_c('div',{staticClass:"loader-title"},[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.loadingData.title')))]),_vm._v(" "),_c('div',{staticClass:"loader-text"},[_vm._v(_vm._s(_vm.$t('dispatch.rsvpTable.loadingData.content')))])],1),_vm._v(" "),_c('unrouted-reservations',{directives:[{name:"show",rawName:"v-show",value:(_vm.unroutedList.length),expression:"unroutedList.length"}],ref:"unrouted",attrs:{"isMobile":_vm.isMobile}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.unroutedLoading && _vm.unroutedList.length > 0),expression:"unroutedLoading && unroutedList.length > 0"}],staticClass:"infinity-loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" Loading\n          ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.unroutedList.length <= 0 && !_vm.unroutedLoading),expression:"unroutedList.length <= 0 && !unroutedLoading"}],staticClass:"empty-reservations"},[_c('div',{staticClass:"title"},[_vm._v("Oops. Looks like we found nothing.")]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v("\n            No available reservations as of yet.\n          ")])])],1)])]),_vm._v(" "),_c('div',{staticClass:"toggle-mobile",on:{"click":function($event){_vm.showMapMobile = !_vm.showMapMobile}}},[(!_vm.showMapMobile)?_c('span',[_vm._v("Show Map "),_c('i',{staticClass:"fa fa-chevron-up"})]):_c('span',[_vm._v("Hide Map "),_c('i',{staticClass:"fa fa-chevron-down"})])]),_vm._v(" "),_c('div',{class:['middle-panel', _vm.showMapMobile ? 'showMapBox' : '']},[_c('div',{staticClass:"map-box middle-box"},[_c('laxit-map')],1),_vm._v(" "),_c('div',{staticClass:"drop-box middle-box"},[_c('dropzone')],1)]),_vm._v(" "),_c('div',{class:['panel right-panel', _vm.activeTabIndex === 1 && _vm.isMobile ? 'active' : '']},[_c('div',{staticClass:"row top"},[_c('div',{staticClass:"columns small-6"},[_c('driver-tnc')],1),_vm._v(" "),_c('div',{staticClass:"columns small-6"},[_c('driver-tcp')],1)]),_vm._v(" "),_c('div',{staticClass:"row bottom"},[_c('div',{staticClass:"columns small-6"},[_c('driver-inbound')],1),_vm._v(" "),_c('div',{staticClass:"columns small-6"},[_c('driver-outbound')],1)]),_vm._v(" "),_c('div',{staticClass:"driver-controls"},[_c('driver-controls')],1)]),_vm._v(" "),_c('results-modal'),_vm._v(" "),_c('routing-modal'),_vm._v(" "),_c('ready-to-go-modal'),_vm._v(" "),_c('notes-modal')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(674);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_457d326a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2104);
function injectStyle (ssrContext) {
  __webpack_require__(2102)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-457d326a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_457d326a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2103);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("7aeb8655", content, true, {});

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.panel[data-v-457d326a] {\n  z-index: 1;\n  position: fixed;\n  width: 995px;\n  top: 0;\n  left: 0;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n}\n.tabs[data-v-457d326a] {\n  position: relative;\n  z-index: 2;\n  width: 995px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: stretch;\n      -ms-flex-align: stretch;\n          align-items: stretch;\n  height: 54px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n  border-top: 1px solid rgba(0, 0, 0, 0.3);\n}\n.tabs .tab[data-v-457d326a] {\n    padding: 0 10px;\n    white-space: nowrap;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    color: #0D79F2;\n    position: relative;\n    z-index: 2;\n    font-weight: 700;\n    font-size: 14px;\n    text-decoration: underline;\n    cursor: pointer;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n    border-left: 1px solid transparent;\n    border-right: 1px solid transparent;\n}\n.tabs .tab.selected[data-v-457d326a] {\n      background-color: #fff;\n      border-left: 1px solid rgba(0, 0, 0, 0.3);\n      border-right: 1px solid rgba(0, 0, 0, 0.3);\n      text-decoration: none;\n      cursor: default;\n}\n.tabs .upd-box[data-v-457d326a] {\n    width: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    padding: 0 10px;\n    font-size: 13px;\n    gap: 5px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    color: transparent;\n    cursor: default;\n}\n.tabs .upd-box div[data-v-457d326a]:hover {\n      color: #777;\n}\n.tabs .total[data-v-457d326a] {\n    z-index: 1;\n    padding: 0 20px;\n    font-size: 14px;\n    color: #333;\n    font-weight: 600;\n    white-space: nowrap;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 5px;\n}\n.tabs .total .filter-date[data-v-457d326a] {\n      color: #555;\n      display: inline-block;\n      margin-left: 3px;\n      font-size: 14px;\n      position: relative;\n      top: -1px;\n      font-weight: 500;\n}\n.tabs .total .filter-date .cal-trigger[data-v-457d326a] {\n        cursor: pointer;\n        position: relative;\n}\n.tabs .total .filter-date .cal-trigger[data-v-457d326a]:hover {\n          text-decoration: underline;\n}\n.tabs .total .filter-date .cal-trigger.disabled[data-v-457d326a] {\n          cursor: not-allowed;\n          text-decoration: none;\n}\n.datepicker.inline[data-v-457d326a] {\n  white-space: normal;\n  position: absolute;\n  top: 100%;\n  right: 0;\n}\n.filter-date[data-v-457d326a] {\n  letter-spacing: .4px;\n}\n.rsvp-panel[data-v-457d326a] {\n  position: fixed;\n  top: 101px;\n  left: 0;\n  overflow-y: auto;\n  width: 995px;\n  height: calc(100% - (50px + 51px));\n  z-index: 1;\n  margin-top: 2px;\n}\n.tab-content[data-v-457d326a] {\n  display: none;\n  height: 100%;\n  overflow: auto;\n}\n.tab-content.with-action[data-v-457d326a] {\n    padding-bottom: 70px;\n}\n.tab-content.show[data-v-457d326a] {\n    display: block;\n}\n.tab-content.with-control[data-v-457d326a] {\n    height: calc(100% - 80px);\n}\n.tab-content .tab-control[data-v-457d326a] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    background-color: #fff;\n    width: 100%;\n    border-top: 1px solid rgba(0, 0, 0, 0.3);\n    padding: 20px 10px;\n}\n.reservation-controls[data-v-457d326a] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 15px;\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n  border-right: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #fff;\n}\n.padding-R[data-v-457d326a] {\n  padding-right: 5px;\n}\n.padding-L[data-v-457d326a] {\n  padding-left: 5px;\n}\n.right-panel[data-v-457d326a] {\n  z-index: 1;\n  position: fixed;\n  top: 0;\n  left: 995px;\n  width: calc(100% - 995px);\n  height: 100%;\n}\n.right-panel .map[data-v-457d326a] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 55%;\n    z-index: 2;\n}\n.right-panel .dropzone-container[data-v-457d326a] {\n    position: absolute;\n    top: 55%;\n    left: 0;\n    width: 100%;\n    height: 45%;\n    -webkit-box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.25);\n            box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.25);\n}\n.toggle-mobile[data-v-457d326a] {\n  display: none;\n}\n@media screen and (max-width: 430px) {\n.panel[data-v-457d326a], .tabs[data-v-457d326a], .rsvp-panel[data-v-457d326a] {\n    width: 100% !important;\n}\n.right-panel[data-v-457d326a] {\n    left: 0;\n    width: 100%;\n    z-index: 5;\n    top: 100%;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n    background-color: #fff;\n}\n.right-panel.showMapBox[data-v-457d326a] {\n      top: 0;\n}\n.right-panel .map[data-v-457d326a] {\n      height: 35%;\n}\n.right-panel .dropzone-container[data-v-457d326a] {\n      top: 35%;\n      height: 65%;\n}\n.tabs[data-v-457d326a] {\n    z-index: 100;\n    display: grid;\n    grid-template-areas: 'tab1 tab2'\r 'total total';\n}\n.tabs .tab[data-v-457d326a] {\n      text-align: center;\n}\n.tabs .tab[data-v-457d326a]:nth-child(1) {\n      grid-area: tab1;\n}\n.tabs .tab[data-v-457d326a]:nth-child(2) {\n      grid-area: tab2;\n}\n.tabs .total[data-v-457d326a] {\n      grid-area: total;\n      width: 100%;\n      text-align: right;\n      background-color: #fff;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n      border-top: 1px solid rgba(0, 0, 0, 0.3);\n}\n.toggle-mobile[data-v-457d326a] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 10;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Runs/index.vue"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,OAAO;EACP,QAAQ;EACR,aAAa;EACb,kDAAkD;UAC1C,0CAA0C;CACnD;AACD;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;MACvB,wBAAwB;UACpB,qBAAqB;EAC7B,aAAa;EACb,4CAA4C;EAC5C,yCAAyC;CAC1C;AACD;IACI,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;IAC5B,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB,8BAA8B;IAC9B,sBAAsB;IACtB,mCAAmC;IACnC,oCAAoC;CACvC;AACD;MACM,uBAAuB;MACvB,0CAA0C;MAC1C,2CAA2C;MAC3C,sBAAsB;MACtB,gBAAgB;CACrB;AACD;IACI,YAAY;IACZ,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;IAC5B,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,yBAAyB;QACrB,sBAAsB;YAClB,wBAAwB;IAChC,mBAAmB;IACnB,gBAAgB;CACnB;AACD;MACM,YAAY;CACjB;AACD;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;IAC5B,SAAS;CACZ;AACD;MACM,YAAY;MACZ,sBAAsB;MACtB,iBAAiB;MACjB,gBAAgB;MAChB,mBAAmB;MACnB,UAAU;MACV,iBAAiB;CACtB;AACD;QACQ,gBAAgB;QAChB,mBAAmB;CAC1B;AACD;UACU,2BAA2B;CACpC;AACD;UACU,oBAAoB;UACpB,sBAAsB;CAC/B;AACD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,SAAS;CACV;AACD;EACE,qBAAqB;CACtB;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,mCAAmC;EACnC,WAAW;EACX,gBAAgB;CACjB;AACD;EACE,cAAc;EACd,aAAa;EACb,eAAe;CAChB;AACD;IACI,qBAAqB;CACxB;AACD;IACI,eAAe;CAClB;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,mBAAmB;IACnB,UAAU;IACV,QAAQ;IACR,uBAAuB;IACvB,YAAY;IACZ,yCAAyC;IACzC,mBAAmB;CACtB;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,yCAAyC;EACzC,2CAA2C;EAC3C,uBAAuB;CACxB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,WAAW;EACX,gBAAgB;EAChB,OAAO;EACP,YAAY;EACZ,0BAA0B;EAC1B,aAAa;CACd;AACD;IACI,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,WAAW;CACd;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,mDAAmD;YAC3C,2CAA2C;CACtD;AACD;EACE,cAAc;CACf;AACD;AACA;IACI,uBAAuB;CAC1B;AACD;IACI,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,UAAU;IACV,kCAAkC;IAClC,0BAA0B;IAC1B,uBAAuB;CAC1B;AACD;MACM,OAAO;CACZ;AACD;MACM,YAAY;CACjB;AACD;MACM,SAAS;MACT,YAAY;CACjB;AACD;IACI,aAAa;IACb,cAAc;IACd,gDACW;CACd;AACD;MACM,mBAAmB;CACxB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,iBAAiB;MACjB,YAAY;MACZ,kBAAkB;MAClB,uBAAuB;MACvB,4CAA4C;MAC5C,yCAAyC;CAC9C;AACD;IACI,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;IACrB,YAAY;IACZ,0BAA0B;IAC1B,iBAAiB;CACpB;CACA","file":"index.vue","sourcesContent":["\n.panel[data-v-457d326a] {\n  z-index: 1;\n  position: fixed;\n  width: 995px;\n  top: 0;\n  left: 0;\n  height: 100%;\n  -webkit-box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.25);\n}\n.tabs[data-v-457d326a] {\n  position: relative;\n  z-index: 2;\n  width: 995px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: stretch;\n      -ms-flex-align: stretch;\n          align-items: stretch;\n  height: 54px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n  border-top: 1px solid rgba(0, 0, 0, 0.3);\n}\n.tabs .tab[data-v-457d326a] {\n    padding: 0 10px;\n    white-space: nowrap;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    color: #0D79F2;\n    position: relative;\n    z-index: 2;\n    font-weight: 700;\n    font-size: 14px;\n    text-decoration: underline;\n    cursor: pointer;\n    -webkit-transition: all 250ms;\n    transition: all 250ms;\n    border-left: 1px solid transparent;\n    border-right: 1px solid transparent;\n}\n.tabs .tab.selected[data-v-457d326a] {\n      background-color: #fff;\n      border-left: 1px solid rgba(0, 0, 0, 0.3);\n      border-right: 1px solid rgba(0, 0, 0, 0.3);\n      text-decoration: none;\n      cursor: default;\n}\n.tabs .upd-box[data-v-457d326a] {\n    width: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    padding: 0 10px;\n    font-size: 13px;\n    gap: 5px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    color: transparent;\n    cursor: default;\n}\n.tabs .upd-box div[data-v-457d326a]:hover {\n      color: #777;\n}\n.tabs .total[data-v-457d326a] {\n    z-index: 1;\n    padding: 0 20px;\n    font-size: 14px;\n    color: #333;\n    font-weight: 600;\n    white-space: nowrap;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 5px;\n}\n.tabs .total .filter-date[data-v-457d326a] {\n      color: #555;\n      display: inline-block;\n      margin-left: 3px;\n      font-size: 14px;\n      position: relative;\n      top: -1px;\n      font-weight: 500;\n}\n.tabs .total .filter-date .cal-trigger[data-v-457d326a] {\n        cursor: pointer;\n        position: relative;\n}\n.tabs .total .filter-date .cal-trigger[data-v-457d326a]:hover {\n          text-decoration: underline;\n}\n.tabs .total .filter-date .cal-trigger.disabled[data-v-457d326a] {\n          cursor: not-allowed;\n          text-decoration: none;\n}\n.datepicker.inline[data-v-457d326a] {\n  white-space: normal;\n  position: absolute;\n  top: 100%;\n  right: 0;\n}\n.filter-date[data-v-457d326a] {\n  letter-spacing: .4px;\n}\n.rsvp-panel[data-v-457d326a] {\n  position: fixed;\n  top: 101px;\n  left: 0;\n  overflow-y: auto;\n  width: 995px;\n  height: calc(100% - (50px + 51px));\n  z-index: 1;\n  margin-top: 2px;\n}\n.tab-content[data-v-457d326a] {\n  display: none;\n  height: 100%;\n  overflow: auto;\n}\n.tab-content.with-action[data-v-457d326a] {\n    padding-bottom: 70px;\n}\n.tab-content.show[data-v-457d326a] {\n    display: block;\n}\n.tab-content.with-control[data-v-457d326a] {\n    height: calc(100% - 80px);\n}\n.tab-content .tab-control[data-v-457d326a] {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    background-color: #fff;\n    width: 100%;\n    border-top: 1px solid rgba(0, 0, 0, 0.3);\n    padding: 20px 10px;\n}\n.reservation-controls[data-v-457d326a] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 15px;\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n  border-right: 1px solid rgba(0, 0, 0, 0.3);\n  background-color: #fff;\n}\n.padding-R[data-v-457d326a] {\n  padding-right: 5px;\n}\n.padding-L[data-v-457d326a] {\n  padding-left: 5px;\n}\n.right-panel[data-v-457d326a] {\n  z-index: 1;\n  position: fixed;\n  top: 0;\n  left: 995px;\n  width: calc(100% - 995px);\n  height: 100%;\n}\n.right-panel .map[data-v-457d326a] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 55%;\n    z-index: 2;\n}\n.right-panel .dropzone-container[data-v-457d326a] {\n    position: absolute;\n    top: 55%;\n    left: 0;\n    width: 100%;\n    height: 45%;\n    -webkit-box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.25);\n            box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.25);\n}\n.toggle-mobile[data-v-457d326a] {\n  display: none;\n}\n@media screen and (max-width: 430px) {\n.panel[data-v-457d326a], .tabs[data-v-457d326a], .rsvp-panel[data-v-457d326a] {\n    width: 100% !important;\n}\n.right-panel[data-v-457d326a] {\n    left: 0;\n    width: 100%;\n    z-index: 5;\n    top: 100%;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n    background-color: #fff;\n}\n.right-panel.showMapBox[data-v-457d326a] {\n      top: 0;\n}\n.right-panel .map[data-v-457d326a] {\n      height: 35%;\n}\n.right-panel .dropzone-container[data-v-457d326a] {\n      top: 35%;\n      height: 65%;\n}\n.tabs[data-v-457d326a] {\n    z-index: 100;\n    display: grid;\n    grid-template-areas: 'tab1 tab2'\r 'total total';\n}\n.tabs .tab[data-v-457d326a] {\n      text-align: center;\n}\n.tabs .tab[data-v-457d326a]:nth-child(1) {\n      grid-area: tab1;\n}\n.tabs .tab[data-v-457d326a]:nth-child(2) {\n      grid-area: tab2;\n}\n.tabs .total[data-v-457d326a] {\n      grid-area: total;\n      width: 100%;\n      text-align: right;\n      background-color: #fff;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.3);\n      border-top: 1px solid rgba(0, 0, 0, 0.3);\n}\n.toggle-mobile[data-v-457d326a] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 10;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"runs-page"},[_c('div',{staticClass:"panel"},[_c('tableFilter',{ref:"tableFilter"}),_vm._v(" "),_c('div',{staticClass:"tabs"},[_c('div',{class:['tab', {selected: _vm.tabIndex === 2 }],on:{"click":function($event){_vm.tabIndex = 2}}},[_vm._v("UNPACKAGED RESERVATIONS")]),_vm._v(" "),_c('div',{class:['tab', {selected: _vm.tabIndex === 1 }],on:{"click":function($event){_vm.tabIndex = 1}}},[_vm._v("RUNS")]),_vm._v(" "),_c('div',{staticClass:"upd-box"},[_c('div',[_vm._v("Updated: "),_c('b',[_vm._v(_vm._s(_vm.lastSync))])])]),_vm._v(" "),_c('div',{staticClass:"total"},[_vm._v("\n        Total:\n        "),(_vm.tabIndex === 1)?_c('b',[_vm._v(_vm._s(_vm.runs.list.length))]):_c('b',[_vm._v(_vm._s(_vm.runs.exclusive.list.length))]),_vm._v(" |\n        "),_vm._v(" "),(_vm.since !== 'Invalid date')?_c('span',{staticClass:"filter-date"},[_c('span',{class:['cal-trigger', {disabled: _vm.runs.exclusive.loading || _vm.runs.loading}]},[_c('span',{on:{"click":function($event){$event.stopPropagation();return _vm.toggleCal('since')}}},[_vm._v(_vm._s(_vm.since))]),_vm._v(" "),_c('datepicker',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCal.since),expression:"showCal.since"},{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropdown),expression:"closeDropdown"}],staticClass:"datepicker inline",attrs:{"inline":true,"v-model":_vm.sinceCal,"format":_vm.calendarFormat,"disabled-picker":_vm.runs.exclusive.loading || _vm.runs.loading,"value":_vm.sinceCal},on:{"input":function($event){return _vm.changeDate($event, 'since')}}})],1),_vm._v(" -\n          "),_c('span',{class:['cal-trigger', {disabled: _vm.runs.exclusive.loading || _vm.runs.loading}]},[_c('span',{on:{"click":function($event){$event.stopPropagation();return _vm.toggleCal('until')}}},[_vm._v(_vm._s(_vm.until))]),_vm._v(" "),_c('datepicker',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCal.until),expression:"showCal.until"},{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropdown),expression:"closeDropdown"}],staticClass:"datepicker inline",attrs:{"inline":true,"v-model":_vm.untilCal,"format":_vm.calendarFormat,"disabled-picker":_vm.runs.exclusive.loading || _vm.runs.loading,"value":_vm.untilCal},on:{"input":function($event){return _vm.changeDate($event, 'until')}}})],1)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"rsvp-panel"},[_c('div',{class:['tab-content', {'show with-action': _vm.tabIndex === 1}]},[_c('runs-table',{ref:"runsTable"}),_vm._v(" "),_c('div',{staticClass:"reservation-controls"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns end small-3 medium-3 medium-offset-3 padding-R"},[_c('a',{staticClass:"button cta small block",attrs:{"href":"javascript:;"},on:{"click":_vm.moveToPool}},[_vm._v("MOVE TO POOL")])]),_vm._v(" "),_c('div',{staticClass:"columns end small-3 padding-L"},[_c('a',{staticClass:"button cta small block error",on:{"click":_vm.removeFromPool}},[_vm._v("REMOVE FROM POOL")])])])])],1),_vm._v(" "),_c('div',{class:['tab-content', {show: _vm.tabIndex === 2 }]},[_c('exclusive-table',{ref:"exclusiveTable"})],1)])],1),_vm._v(" "),_c('div',{staticClass:"toggle-mobile",on:{"click":function($event){_vm.showMapMobile = !_vm.showMapMobile}}},[(!_vm.showMapMobile)?_c('span',[_vm._v("Show Map "),_c('i',{staticClass:"fa fa-chevron-up"})]):_c('span',[_vm._v("Hide Map "),_c('i',{staticClass:"fa fa-chevron-down"})])]),_vm._v(" "),_c('div',{class:['right-panel', _vm.showMapMobile ? 'showMapBox' : '']},[_c('div',{staticClass:"map"},[_c('runs-map')],1),_vm._v(" "),_c('div',{staticClass:"dropzone-container"},[_c('drop-zone')],1)]),_vm._v(" "),(_vm.route === 'Runs')?_c('routing-modal'):_vm._e(),_vm._v(" "),_c('dispatch-modal')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(675);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_282c82ea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2108);
function injectStyle (ssrContext) {
  __webpack_require__(2106)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-282c82ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_282c82ea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2107);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("9517e270", content, true, {});

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.head[data-v-282c82ea] {\n  height: 50px;\n  font-weight: 600;\n  color: #fff;\n  padding: 0 10px;\n  width: calc(100% - 50px);\n  margin-left: 50px;\n  font-size: 21px;\n  line-height: 50px;\n  background: #333;\n}\n.log-box[data-v-282c82ea] {\n  font-family: 'Space Grotesk', sans-serif;\n  margin: 20px 10px;\n  padding: 15px;\n}\n.log-label[data-v-282c82ea] {\n  font-size: 21px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n.log-label .loader[data-v-282c82ea] {\n    margin-left: 10px;\n    color: #5291d8;\n}\n.refresh[data-v-282c82ea] {\n  font-size: 16px;\n  color: #0D79F2;\n  cursor: pointer;\n}\n.box[data-v-282c82ea] {\n  border-radius: 6px;\n  border: 1px solid #aaa;\n  background: #fff;\n  overflow: hidden;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 20px;\n}\n.box .details[data-v-282c82ea] {\n    padding: 10px;\n    background: #eaeff3;\n    width: 370px;\n    border-right: 1px solid #aaa;\n}\n.box .details table[data-v-282c82ea] {\n      width: 100%;\n      font-size: 14px;\n}\n.box .details table td[data-v-282c82ea]:nth-child(1) {\n        color: #717b85;\n        width: 120px;\n}\n.box .details table td[data-v-282c82ea]:nth-child(2) {\n        text-align: right;\n        font-weight: 600;\n        color: #343d45;\n}\n.box .details table td:nth-child(2) a[data-v-282c82ea] {\n          margin: 0 2px;\n}\n.box .data[data-v-282c82ea] {\n    background: #fff;\n    width: calc(100% - 351px);\n    padding: 15px;\n    font-size: 15px;\n    font-family: monospace,monospace;\n}\n.box .data b[data-v-282c82ea] {\n      margin-right: 10px;\n}\n.box .data a[data-v-282c82ea] {\n      cursor: pointer;\n}\n.box .data div[data-v-282c82ea] {\n      word-wrap: break-word;\n}\n@media only screen and (max-width: 900px) {\n.box[data-v-282c82ea] {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: normal !important;\n        -ms-flex-direction: column !important;\n            flex-direction: column !important;\n}\n.box .details[data-v-282c82ea] {\n      width: 100%;\n      border-right: none;\n      border-bottom: 1px solid #aaa;\n}\n.box .data[data-v-282c82ea] {\n      width: 100%;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/devlogs/index.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;CACf;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;CACrB;AACD;IACI,kBAAkB;IAClB,eAAe;CAClB;AACD;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;CACjB;AACD;EACE,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oBAAoB;CACrB;AACD;IACI,cAAc;IACd,oBAAoB;IACpB,aAAa;IACb,6BAA6B;CAChC;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;QACQ,eAAe;QACf,aAAa;CACpB;AACD;QACQ,kBAAkB;QAClB,iBAAiB;QACjB,eAAe;CACtB;AACD;UACU,cAAc;CACvB;AACD;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;IAChB,iCAAiC;CACpC;AACD;MACM,mBAAmB;CACxB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,sBAAsB;CAC3B;AACD;AACA;IACI,wCAAwC;IACxC,yCAAyC;QACrC,sCAAsC;YAClC,kCAAkC;CAC7C;AACD;MACM,YAAY;MACZ,mBAAmB;MACnB,8BAA8B;CACnC;AACD;MACM,YAAY;CACjB;CACA","file":"index.vue","sourcesContent":["\n.head[data-v-282c82ea] {\n  height: 50px;\n  font-weight: 600;\n  color: #fff;\n  padding: 0 10px;\n  width: calc(100% - 50px);\n  margin-left: 50px;\n  font-size: 21px;\n  line-height: 50px;\n  background: #333;\n}\n.log-box[data-v-282c82ea] {\n  font-family: 'Space Grotesk', sans-serif;\n  margin: 20px 10px;\n  padding: 15px;\n}\n.log-label[data-v-282c82ea] {\n  font-size: 21px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n.log-label .loader[data-v-282c82ea] {\n    margin-left: 10px;\n    color: #5291d8;\n}\n.refresh[data-v-282c82ea] {\n  font-size: 16px;\n  color: #0D79F2;\n  cursor: pointer;\n}\n.box[data-v-282c82ea] {\n  border-radius: 6px;\n  border: 1px solid #aaa;\n  background: #fff;\n  overflow: hidden;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 20px;\n}\n.box .details[data-v-282c82ea] {\n    padding: 10px;\n    background: #eaeff3;\n    width: 370px;\n    border-right: 1px solid #aaa;\n}\n.box .details table[data-v-282c82ea] {\n      width: 100%;\n      font-size: 14px;\n}\n.box .details table td[data-v-282c82ea]:nth-child(1) {\n        color: #717b85;\n        width: 120px;\n}\n.box .details table td[data-v-282c82ea]:nth-child(2) {\n        text-align: right;\n        font-weight: 600;\n        color: #343d45;\n}\n.box .details table td:nth-child(2) a[data-v-282c82ea] {\n          margin: 0 2px;\n}\n.box .data[data-v-282c82ea] {\n    background: #fff;\n    width: calc(100% - 351px);\n    padding: 15px;\n    font-size: 15px;\n    font-family: monospace,monospace;\n}\n.box .data b[data-v-282c82ea] {\n      margin-right: 10px;\n}\n.box .data a[data-v-282c82ea] {\n      cursor: pointer;\n}\n.box .data div[data-v-282c82ea] {\n      word-wrap: break-word;\n}\n@media only screen and (max-width: 900px) {\n.box[data-v-282c82ea] {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: normal !important;\n        -ms-flex-direction: column !important;\n            flex-direction: column !important;\n}\n.box .details[data-v-282c82ea] {\n      width: 100%;\n      border-right: none;\n      border-bottom: 1px solid #aaa;\n}\n.box .data[data-v-282c82ea] {\n      width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"head"},[_vm._v("\n    Admin Logs\n  ")]),_vm._v(" "),_c('div',{staticClass:"log-box"},[_c('div',{staticClass:"log-label d-flex justify-space-between"},[_c('div',[_vm._v("\n        Auto Dispatch RUN\n        "),(_vm.loading)?_c('i',{staticClass:"fas fa-spinner fa-spin loader"}):_vm._e()]),_vm._v(" "),(!_vm.loading)?_c('b',{staticClass:"refresh",on:{"click":_vm.getLogs}},[_vm._v("REFRESH")]):_vm._e()]),_vm._v(" "),_vm._l((_vm.logs),function(log,i){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],key:i,staticClass:"box"},[_c('div',{staticClass:"details"},[_c('table',[_c('tr',[_c('td',[_vm._v("ID")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.id))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Created UTC")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.createdUTC))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Driver IDs")]),_vm._v(" "),_c('td',[_vm._v("\n              ["),_vm._l((log.driverIds),function(prov,p){return _c('a',{key:p,attrs:{"href":("#/provider/" + prov),"target":"_blank"}},[_vm._v(_vm._s(prov))])}),_vm._v("]\n            ")],2)]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Execute TOD")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.executeTOD))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Executed UTC")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.executedUTC))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Extended Mode")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.extendedMode))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Normal Mode")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.normalMode))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Run IDs")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.runIds))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Trigger")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.trigger))])])])]),_vm._v(" "),_c('div',{staticClass:"data"},[_c('b',[_vm._v("DATA")]),_vm._v("\n        ["),_c('a',{on:{"click":function($event){return _vm.toggleView(log.id)}}},[_vm._v("switch view")]),_vm._v("]\n        "),(_vm.beautify.indexOf(log.id) > -1)?_c('pre',[_vm._v(_vm._s(log.data))]):_c('div',[_vm._v(_vm._s(log.data))])])])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auto_dispatch_vue__ = __webpack_require__(676);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3426aff0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_auto_dispatch_vue__ = __webpack_require__(2112);
function injectStyle (ssrContext) {
  __webpack_require__(2110)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3426aff0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auto_dispatch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3426aff0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_auto_dispatch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2111);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("60cbf462", content, true, {});

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.head[data-v-3426aff0] {\n  height: 50px;\n  font-weight: 600;\n  color: #fff;\n  padding: 0 10px;\n  width: calc(100% - 50px);\n  margin-left: 50px;\n  font-size: 21px;\n  line-height: 50px;\n  background: #333;\n}\n.log-box[data-v-3426aff0] {\n  font-family: 'Space Grotesk', sans-serif;\n  margin: 20px 10px;\n  padding: 15px;\n}\n.log-label[data-v-3426aff0] {\n  font-size: 21px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n.log-label .loader[data-v-3426aff0] {\n    margin-left: 10px;\n    color: #5291d8;\n}\n.refresh[data-v-3426aff0] {\n  font-size: 16px;\n  color: #0D79F2;\n  cursor: pointer;\n}\n.box[data-v-3426aff0] {\n  border-radius: 6px;\n  border: 1px solid #aaa;\n  background: #fff;\n  overflow: hidden;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 20px;\n}\n.box .details[data-v-3426aff0] {\n    padding: 10px;\n    background: #eaeff3;\n    width: 370px;\n    border-right: 1px solid #aaa;\n}\n.box .details table[data-v-3426aff0] {\n      width: 100%;\n      font-size: 14px;\n}\n.box .details table td[data-v-3426aff0]:nth-child(1) {\n        color: #717b85;\n        width: 120px;\n}\n.box .details table td[data-v-3426aff0]:nth-child(2) {\n        text-align: right;\n        font-weight: 600;\n        color: #343d45;\n}\n.box .details table td:nth-child(2) a[data-v-3426aff0] {\n          margin: 0 2px;\n}\n.box .data[data-v-3426aff0] {\n    background: #fff;\n    width: calc(100% - 351px);\n    padding: 15px;\n    font-size: 15px;\n    font-family: monospace,monospace;\n}\n.box .data b[data-v-3426aff0] {\n      margin-right: 10px;\n}\n.box .data a[data-v-3426aff0] {\n      cursor: pointer;\n}\n.box .data pre[data-v-3426aff0] {\n      width: 100%;\n      white-space: pre-wrap;\n}\n.box .data .raw[data-v-3426aff0] {\n      word-wrap: break-word;\n}\n.box .data .data-box[data-v-3426aff0] {\n      border-bottom: 1px solid #ccc;\n      padding-bottom: 10px;\n      margin-bottom: 10px;\n}\n@media only screen and (max-width: 900px) {\n.box[data-v-3426aff0] {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: normal !important;\n        -ms-flex-direction: column !important;\n            flex-direction: column !important;\n}\n.box .details[data-v-3426aff0] {\n      width: 100%;\n      border-right: none;\n      border-bottom: 1px solid #aaa;\n}\n.box .data[data-v-3426aff0] {\n      width: 100%;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/devlogs/auto-dispatch.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;CACf;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;CACrB;AACD;IACI,kBAAkB;IAClB,eAAe;CAClB;AACD;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;CACjB;AACD;EACE,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oBAAoB;CACrB;AACD;IACI,cAAc;IACd,oBAAoB;IACpB,aAAa;IACb,6BAA6B;CAChC;AACD;MACM,YAAY;MACZ,gBAAgB;CACrB;AACD;QACQ,eAAe;QACf,aAAa;CACpB;AACD;QACQ,kBAAkB;QAClB,iBAAiB;QACjB,eAAe;CACtB;AACD;UACU,cAAc;CACvB;AACD;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;IAChB,iCAAiC;CACpC;AACD;MACM,mBAAmB;CACxB;AACD;MACM,gBAAgB;CACrB;AACD;MACM,YAAY;MACZ,sBAAsB;CAC3B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,8BAA8B;MAC9B,qBAAqB;MACrB,oBAAoB;CACzB;AACD;AACA;IACI,wCAAwC;IACxC,yCAAyC;QACrC,sCAAsC;YAClC,kCAAkC;CAC7C;AACD;MACM,YAAY;MACZ,mBAAmB;MACnB,8BAA8B;CACnC;AACD;MACM,YAAY;CACjB;CACA","file":"auto-dispatch.vue","sourcesContent":["\n.head[data-v-3426aff0] {\n  height: 50px;\n  font-weight: 600;\n  color: #fff;\n  padding: 0 10px;\n  width: calc(100% - 50px);\n  margin-left: 50px;\n  font-size: 21px;\n  line-height: 50px;\n  background: #333;\n}\n.log-box[data-v-3426aff0] {\n  font-family: 'Space Grotesk', sans-serif;\n  margin: 20px 10px;\n  padding: 15px;\n}\n.log-label[data-v-3426aff0] {\n  font-size: 21px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n.log-label .loader[data-v-3426aff0] {\n    margin-left: 10px;\n    color: #5291d8;\n}\n.refresh[data-v-3426aff0] {\n  font-size: 16px;\n  color: #0D79F2;\n  cursor: pointer;\n}\n.box[data-v-3426aff0] {\n  border-radius: 6px;\n  border: 1px solid #aaa;\n  background: #fff;\n  overflow: hidden;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 20px;\n}\n.box .details[data-v-3426aff0] {\n    padding: 10px;\n    background: #eaeff3;\n    width: 370px;\n    border-right: 1px solid #aaa;\n}\n.box .details table[data-v-3426aff0] {\n      width: 100%;\n      font-size: 14px;\n}\n.box .details table td[data-v-3426aff0]:nth-child(1) {\n        color: #717b85;\n        width: 120px;\n}\n.box .details table td[data-v-3426aff0]:nth-child(2) {\n        text-align: right;\n        font-weight: 600;\n        color: #343d45;\n}\n.box .details table td:nth-child(2) a[data-v-3426aff0] {\n          margin: 0 2px;\n}\n.box .data[data-v-3426aff0] {\n    background: #fff;\n    width: calc(100% - 351px);\n    padding: 15px;\n    font-size: 15px;\n    font-family: monospace,monospace;\n}\n.box .data b[data-v-3426aff0] {\n      margin-right: 10px;\n}\n.box .data a[data-v-3426aff0] {\n      cursor: pointer;\n}\n.box .data pre[data-v-3426aff0] {\n      width: 100%;\n      white-space: pre-wrap;\n}\n.box .data .raw[data-v-3426aff0] {\n      word-wrap: break-word;\n}\n.box .data .data-box[data-v-3426aff0] {\n      border-bottom: 1px solid #ccc;\n      padding-bottom: 10px;\n      margin-bottom: 10px;\n}\n@media only screen and (max-width: 900px) {\n.box[data-v-3426aff0] {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: normal !important;\n        -ms-flex-direction: column !important;\n            flex-direction: column !important;\n}\n.box .details[data-v-3426aff0] {\n      width: 100%;\n      border-right: none;\n      border-bottom: 1px solid #aaa;\n}\n.box .data[data-v-3426aff0] {\n      width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"head"},[_vm._v("\n    Admin Logs\n  ")]),_vm._v(" "),_c('div',{staticClass:"log-box"},[_c('div',{staticClass:"log-label d-flex justify-space-between"},[_c('div',[_vm._v("\n        Auto Dispatch RUN\n        "),(_vm.loading)?_c('i',{staticClass:"fas fa-spinner fa-spin loader"}):_vm._e()]),_vm._v(" "),(!_vm.loading)?_c('b',{staticClass:"refresh",on:{"click":_vm.getLogs}},[_vm._v("REFRESH")]):_vm._e()]),_vm._v(" "),_vm._l((_vm.logs),function(log,i){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],key:i,staticClass:"box"},[_c('div',{staticClass:"details"},[_c('table',[_c('tr',[_c('td',[_vm._v("ID")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.id))])]),_vm._v(" "),_c('tr'),_c('tr',[_c('td',[_vm._v("RUN ID")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.runId))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Created UTC")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.createdUTC))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Executed UTC")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.executedUTC))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("RSVP IDs")]),_vm._v(" "),_c('td',[_vm._v("\n              ["),_vm._l((log.rsvpIds),function(rsvp,r){return _c('a',{key:r,attrs:{"href":("#/reservation/" + rsvp),"target":"_blank"}},[_vm._v(_vm._s(rsvp))])}),_vm._v("]\n            ")],2)]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Sector ID")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.sectorId || '--'))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Qualified Sector")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.qualifiedSector || '--'))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Qualified Miles")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.qualifiedMiles))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Sent Driver ID")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.sentDriverId || '--'))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Moved Pool")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.movedPool))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Message")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.message))])])])]),_vm._v(" "),_c('div',{staticClass:"data"},[_c('div',{staticClass:"data-box"},[_c('b',[_vm._v("ERROR")]),_vm._v(" "),(log.error)?_c('span',[_vm._v("["),_c('a',{on:{"click":function($event){return _vm.toggleView(log.id, 'beautifyError')}}},[_vm._v("switch view")]),_vm._v("]")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(log.error)?_c('div',[(_vm.beautifyError.indexOf(log.id) > -1)?_c('pre',[_vm._v(_vm._s(log.error))]):_c('div',{staticClass:"raw"},[_vm._v(_vm._s(log.error))])]):_c('div',[_vm._v("No error.")])]),_vm._v(" "),_c('div',{staticClass:"data-box"},[_c('b',[_vm._v("Send Payload")]),_vm._v(" "),(log.sendPayload)?_c('span',[_vm._v("["),_c('a',{on:{"click":function($event){return _vm.toggleView(log.id, 'beautifySendPayload')}}},[_vm._v("switch view")]),_vm._v("]")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(log.sendPayload)?_c('div',[(_vm.beautifySendPayload.indexOf(log.id) > -1)?_c('pre',[_vm._v(_vm._s(log.sendPayload))]):_c('div',{staticClass:"raw"},[_vm._v(_vm._s(log.sendPayload))])]):_c('div',[_vm._v("--")])])])])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(677);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49e7eb8c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2124);
function injectStyle (ssrContext) {
  __webpack_require__(2114)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49e7eb8c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49e7eb8c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2115);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("02e6a20a", content, true, {});

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.heading[data-v-49e7eb8c] {\n  margin-left: 50px;\n  padding-left: 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.filter[data-v-49e7eb8c] {\n  border-bottom: 1px solid #bbb;\n  background: #fcfcfc;\n  border-radius: 2px;\n  padding: 10px 15px;\n}\n.search-box[data-v-49e7eb8c] {\n  position: relative;\n  margin-bottom: 10px;\n}\n.field-label[data-v-49e7eb8c] {\n  font-size: 13px;\n  color: #999;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.search[data-v-49e7eb8c] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.search .search-input-box[data-v-49e7eb8c] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-49e7eb8c] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 5px 0 0 5px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-49e7eb8c] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-49e7eb8c] {\n      position: absolute;\n      top: 0;\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n      line-height: 46px;\n}\n.search button[data-v-49e7eb8c] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 5px 5px 0;\n    padding: 0 20px;\n}\n.fix-footer[data-v-49e7eb8c] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 50px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-49e7eb8c] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-49e7eb8c] {\n    max-width: 100px;\n    height: 30px;\n    padding: 5px;\n}\n.fix-footer .per-page[data-v-49e7eb8c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 10px 0;\n}\n.fix-footer .per-page span[data-v-49e7eb8c] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-49e7eb8c] {\n    text-align: center;\n    line-height: 30px;\n    padding: 10px 0;\n}\n.fix-footer .pagination[data-v-49e7eb8c] {\n    text-align: right;\n    padding: 10px 10px;\n}\n.fix-footer .pagination span[data-v-49e7eb8c] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-49e7eb8c] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-49e7eb8c] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-49e7eb8c] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-49e7eb8c] {\n        opacity: .4;\n        cursor: default;\n}\n@media screen and (max-width: 430px) {\n.filter[data-v-49e7eb8c] {\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-pack: center !important;\n        -ms-flex-pack: center !important;\n            justify-content: center !important;\n}\n.filter .search-box[data-v-49e7eb8c] {\n      width: 100%;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/DiscountCodes/index.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;CAC3B;AACD;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,oBAAoB;CACrB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;CACpB;AACD;EACE,+BAA+B;UACvB,uBAAuB;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;CACb;AACD;IACI,YAAY;IACZ,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,uBAAuB;MACvB,cAAc;MACd,2BAA2B;MAC3B,oBAAoB;CACzB;AACD;QACQ,sBAAsB;CAC7B;AACD;MACM,mBAAmB;MACnB,OAAO;MACP,WAAW;MACX,eAAe;MACf,gBAAgB;MAChB,kBAAkB;CACvB;AACD;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;CACnB;AACD;EACE,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;CACb;AACD;IACI,gBAAgB;CACnB;AACD;IACI,iBAAiB;IACjB,aAAa;IACb,aAAa;CAChB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;CACnB;AACD;MACM,sBAAsB;MACtB,eAAe;CACpB;AACD;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;CACnB;AACD;IACI,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,sBAAsB;MACtB,kBAAkB;CACvB;AACD;MACM,aAAa;MACb,uBAAuB;CAC5B;AACD;MACM,cAAc;MACd,eAAe;MACf,uBAAuB;MACvB,iBAAiB;MACjB,gBAAgB;MAChB,uBAAuB;MACvB,aAAa;CAClB;AACD;QACQ,kBAAkB;CACzB;AACD;QACQ,YAAY;QACZ,gBAAgB;CACvB;AACD;AACA;IACI,oBAAoB;QAChB,gBAAgB;IACpB,oCAAoC;QAChC,iCAAiC;YAC7B,mCAAmC;CAC9C;AACD;MACM,YAAY;CACjB;CACA","file":"index.vue","sourcesContent":["\n.heading[data-v-49e7eb8c] {\n  margin-left: 50px;\n  padding-left: 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.filter[data-v-49e7eb8c] {\n  border-bottom: 1px solid #bbb;\n  background: #fcfcfc;\n  border-radius: 2px;\n  padding: 10px 15px;\n}\n.search-box[data-v-49e7eb8c] {\n  position: relative;\n  margin-bottom: 10px;\n}\n.field-label[data-v-49e7eb8c] {\n  font-size: 13px;\n  color: #999;\n  line-height: 1;\n  display: block;\n  margin-bottom: 4px;\n}\n.search[data-v-49e7eb8c] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.search .search-input-box[data-v-49e7eb8c] {\n    width: 100%;\n    position: relative;\n}\n.search .search-input-box input[data-v-49e7eb8c] {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0;\n      border-radius: 5px 0 0 5px;\n      padding-right: 30px;\n}\n.search .search-input-box input.has-error[data-v-49e7eb8c] {\n        border-color: #f33a27;\n}\n.search .search-input-box i[data-v-49e7eb8c] {\n      position: absolute;\n      top: 0;\n      right: 5px;\n      color: #d92626;\n      cursor: pointer;\n      line-height: 46px;\n}\n.search button[data-v-49e7eb8c] {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 1;\n    border-radius: 0 5px 5px 0;\n    padding: 0 20px;\n}\n.fix-footer[data-v-49e7eb8c] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 50px;\n  background: #eaeaea;\n  border-top: 1px solid #aaa;\n  font-size: 13px;\n  color: #555;\n}\n.fix-footer .row[data-v-49e7eb8c] {\n    max-width: 100%;\n}\n.fix-footer select[data-v-49e7eb8c] {\n    max-width: 100px;\n    height: 30px;\n    padding: 5px;\n}\n.fix-footer .per-page[data-v-49e7eb8c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    line-height: 30px;\n    padding: 10px 0;\n}\n.fix-footer .per-page span[data-v-49e7eb8c] {\n      display: inline-block;\n      margin: 0 10px;\n}\n.fix-footer .page-data[data-v-49e7eb8c] {\n    text-align: center;\n    line-height: 30px;\n    padding: 10px 0;\n}\n.fix-footer .pagination[data-v-49e7eb8c] {\n    text-align: right;\n    padding: 10px 10px;\n}\n.fix-footer .pagination span[data-v-49e7eb8c] {\n      display: inline-block;\n      margin-right: 5px;\n}\n.fix-footer .pagination select[data-v-49e7eb8c] {\n      height: 30px;\n      vertical-align: middle;\n}\n.fix-footer .pagination .prevNext[data-v-49e7eb8c] {\n      margin: 0 2px;\n      padding: 0 8px;\n      border: 1px solid #bbb;\n      background: #fff;\n      cursor: pointer;\n      vertical-align: middle;\n      height: 30px;\n}\n.fix-footer .pagination .prevNext i[data-v-49e7eb8c] {\n        line-height: 28px;\n}\n.fix-footer .pagination .prevNext.disabled[data-v-49e7eb8c] {\n        opacity: .4;\n        cursor: default;\n}\n@media screen and (max-width: 430px) {\n.filter[data-v-49e7eb8c] {\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-pack: center !important;\n        -ms-flex-pack: center !important;\n            justify-content: center !important;\n}\n.filter .search-box[data-v-49e7eb8c] {\n      width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(678);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12e24026_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(2119);
function injectStyle (ssrContext) {
  __webpack_require__(2117)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12e24026"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12e24026_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2118);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("43c30a5c", content, true, {});

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.list-box[data-v-12e24026] {\n  overflow-y: auto;\n  height: calc(100vh - 50px);\n}\n.list-box thead[data-v-12e24026] {\n    color: #8DA0A9;\n    font-size: 12px;\n}\n.list-box thead th[data-v-12e24026] {\n      border-bottom: 1px solid #ccc;\n      background-color: #f5f5f5;\n      position: sticky;\n      top: 0px;\n}\n.list-box thead .sortable[data-v-12e24026] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\n.list-box thead .sortable i[data-v-12e24026] {\n        margin-left: 2px;\n}\ntable[data-v-12e24026] {\n  border-collapse: collapse;\n  width: 100%;\n}\nth[data-v-12e24026], td[data-v-12e24026] {\n  padding: 5px;\n  text-align: center;\n}\ntr[data-v-12e24026] {\n  border-bottom: 1px solid #ddd;\n}\ntr[data-v-12e24026]:nth-child(even) {\n    background: #fbfbfb;\n}\ntr td[data-v-12e24026] {\n    font-size: 14px;\n    padding: 8px 5px;\n}\n.status[data-v-12e24026] {\n  font-size: 13px;\n  color: #999;\n  cursor: pointer;\n  text-decoration: underline;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n.status.enabled[data-v-12e24026] {\n    color: #33b219;\n}\n.status i[data-v-12e24026] {\n    color: #3e7dbf;\n    font-size: 18px;\n}\n.cards[data-v-12e24026] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.list-box table[data-v-12e24026] {\n    display: none;\n}\n.list-box .cards[data-v-12e24026] {\n    display: block;\n    padding-bottom: 75px;\n    margin-top: 20px;\n}\n.list-box .cards .card[data-v-12e24026] {\n      border: 1px solid #ccc;\n      margin: 0 10px;\n      margin-bottom: 15px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n}\n.list-box .cards .card > div[data-v-12e24026] {\n        margin-bottom: 3px;\n}\n.list-box .cards .card .card-info[data-v-12e24026] {\n        padding: 12px;\n        padding-bottom: 0;\n}\n.list-box .cards .card .card-info .card-header[data-v-12e24026] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          margin-bottom: 5px;\n}\n.list-box .cards .card .card-info .card-header .name[data-v-12e24026] {\n            font-weight: 900;\n}\n.list-box .cards .card .card-info .card-header .amount[data-v-12e24026] {\n            margin-left: 5px;\n            font-weight: 900;\n            font-size: 16px;\n}\n.list-box .cards .card .card-info .card-header .status[data-v-12e24026] {\n            text-transform: uppercase;\n            font-size: 14px;\n            font-weight: 900;\n}\n.list-box .cards .card .card-info .title[data-v-12e24026] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n}\n.list-box .cards .card .card-info .title a[data-v-12e24026] {\n            font-weight: 900;\n}\n.list-box .cards .card .card-info .label[data-v-12e24026] {\n          font-size: 12px;\n          text-transform: uppercase;\n          color: #bbb;\n          font-weight: 600;\n          margin-right: 5px;\n}\n.list-box .cards .card .card-info .value[data-v-12e24026] {\n          margin-right: 10px;\n          font-size: 14px;\n          font-weight: 900;\n}\n.list-box .cards .card .widget-app[data-v-12e24026] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        margin-bottom: 0;\n        margin-top: 10px;\n}\n.list-box .cards .card .widget-app .widget[data-v-12e24026], .list-box .cards .card .widget-app .app[data-v-12e24026] {\n          background-color: #f4f8f9;\n          width: 100%;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          -webkit-box-orient: vertical;\n          -webkit-box-direction: normal;\n              -ms-flex-direction: column;\n                  flex-direction: column;\n          padding: 7px;\n          border: 1px solid #eee;\n}\n.list-box .cards .card .widget-app .widget span[data-v-12e24026], .list-box .cards .card .widget-app .app span[data-v-12e24026] {\n            font-size: 12px;\n            text-transform: uppercase;\n            font-weight: 900;\n}\n.list-box .cards .card .widget-app .widget .status span[data-v-12e24026], .list-box .cards .card .widget-app .app .status span[data-v-12e24026] {\n            font-size: 14px;\n}\n.list-box .cards .card .actions[data-v-12e24026] {\n        width: 100%;\n        background: #f3f3f3;\n        border-top: 1px solid #ccc;\n        padding: 15px 10px;\n        text-align: center;\n        border-radius: 0 0 10px 10px;\n        margin-bottom: 0;\n}\n.list-box .cards .card .actions .button[data-v-12e24026] {\n          line-height: 14px;\n          font-size: 14px;\n          padding: 10px 18px 9px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/DiscountCodes/List.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,2BAA2B;CAC5B;AACD;IACI,eAAe;IACf,gBAAgB;CACnB;AACD;MACM,8BAA8B;MAC9B,0BAA0B;MAC1B,iBAAiB;MACjB,SAAS;CACd;AACD;MACM,gBAAgB;MAChB,YAAY;MACZ,2BAA2B;CAChC;AACD;QACQ,iBAAiB;CACxB;AACD;EACE,0BAA0B;EAC1B,YAAY;CACb;AACD;EACE,aAAa;EACb,mBAAmB;CACpB;AACD;EACE,8BAA8B;CAC/B;AACD;IACI,oBAAoB;CACvB;AACD;IACI,gBAAgB;IAChB,iBAAiB;CACpB;AACD;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,0BAA0B;EAC1B,iBAAiB;CAClB;AACD;IACI,eAAe;CAClB;AACD;IACI,eAAe;IACf,gBAAgB;CACnB;AACD;EACE,cAAc;CACf;AACD;AACA;IACI,cAAc;CACjB;AACD;IACI,eAAe;IACf,qBAAqB;IACrB,iBAAiB;CACpB;AACD;MACM,uBAAuB;MACvB,eAAe;MACf,oBAAoB;MACpB,+BAA+B;MAC/B,oBAAoB;CACzB;AACD;QACQ,mBAAmB;CAC1B;AACD;QACQ,cAAc;QACd,kBAAkB;CACzB;AACD;UACU,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;UACd,0BAA0B;cACtB,uBAAuB;kBACnB,+BAA+B;UACvC,0BAA0B;cACtB,uBAAuB;kBACnB,oBAAoB;UAC5B,mBAAmB;CAC5B;AACD;YACY,iBAAiB;CAC5B;AACD;YACY,iBAAiB;YACjB,iBAAiB;YACjB,gBAAgB;CAC3B;AACD;YACY,0BAA0B;YAC1B,gBAAgB;YAChB,iBAAiB;CAC5B;AACD;UACU,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;UACd,0BAA0B;cACtB,uBAAuB;kBACnB,oBAAoB;CACrC;AACD;YACY,iBAAiB;CAC5B;AACD;UACU,gBAAgB;UAChB,0BAA0B;UAC1B,YAAY;UACZ,iBAAiB;UACjB,kBAAkB;CAC3B;AACD;UACU,mBAAmB;UACnB,gBAAgB;UAChB,iBAAiB;CAC1B;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,iBAAiB;QACjB,iBAAiB;CACxB;AACD;UACU,0BAA0B;UAC1B,YAAY;UACZ,qBAAqB;UACrB,qBAAqB;UACrB,cAAc;UACd,yBAAyB;cACrB,sBAAsB;kBAClB,wBAAwB;UAChC,0BAA0B;cACtB,uBAAuB;kBACnB,oBAAoB;UAC5B,6BAA6B;UAC7B,8BAA8B;cAC1B,2BAA2B;kBACvB,uBAAuB;UAC/B,aAAa;UACb,uBAAuB;CAChC;AACD;YACY,gBAAgB;YAChB,0BAA0B;YAC1B,iBAAiB;CAC5B;AACD;YACY,gBAAgB;CAC3B;AACD;QACQ,YAAY;QACZ,oBAAoB;QACpB,2BAA2B;QAC3B,mBAAmB;QACnB,mBAAmB;QACnB,6BAA6B;QAC7B,iBAAiB;CACxB;AACD;UACU,kBAAkB;UAClB,gBAAgB;UAChB,uBAAuB;CAChC;CACA","file":"List.vue","sourcesContent":["\n.list-box[data-v-12e24026] {\n  overflow-y: auto;\n  height: calc(100vh - 50px);\n}\n.list-box thead[data-v-12e24026] {\n    color: #8DA0A9;\n    font-size: 12px;\n}\n.list-box thead th[data-v-12e24026] {\n      border-bottom: 1px solid #ccc;\n      background-color: #f5f5f5;\n      position: sticky;\n      top: 0px;\n}\n.list-box thead .sortable[data-v-12e24026] {\n      cursor: pointer;\n      color: #333;\n      text-decoration: underline;\n}\n.list-box thead .sortable i[data-v-12e24026] {\n        margin-left: 2px;\n}\ntable[data-v-12e24026] {\n  border-collapse: collapse;\n  width: 100%;\n}\nth[data-v-12e24026], td[data-v-12e24026] {\n  padding: 5px;\n  text-align: center;\n}\ntr[data-v-12e24026] {\n  border-bottom: 1px solid #ddd;\n}\ntr[data-v-12e24026]:nth-child(even) {\n    background: #fbfbfb;\n}\ntr td[data-v-12e24026] {\n    font-size: 14px;\n    padding: 8px 5px;\n}\n.status[data-v-12e24026] {\n  font-size: 13px;\n  color: #999;\n  cursor: pointer;\n  text-decoration: underline;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n.status.enabled[data-v-12e24026] {\n    color: #33b219;\n}\n.status i[data-v-12e24026] {\n    color: #3e7dbf;\n    font-size: 18px;\n}\n.cards[data-v-12e24026] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.list-box table[data-v-12e24026] {\n    display: none;\n}\n.list-box .cards[data-v-12e24026] {\n    display: block;\n    padding-bottom: 75px;\n    margin-top: 20px;\n}\n.list-box .cards .card[data-v-12e24026] {\n      border: 1px solid #ccc;\n      margin: 0 10px;\n      margin-bottom: 15px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n}\n.list-box .cards .card > div[data-v-12e24026] {\n        margin-bottom: 3px;\n}\n.list-box .cards .card .card-info[data-v-12e24026] {\n        padding: 12px;\n        padding-bottom: 0;\n}\n.list-box .cards .card .card-info .card-header[data-v-12e24026] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          margin-bottom: 5px;\n}\n.list-box .cards .card .card-info .card-header .name[data-v-12e24026] {\n            font-weight: 900;\n}\n.list-box .cards .card .card-info .card-header .amount[data-v-12e24026] {\n            margin-left: 5px;\n            font-weight: 900;\n            font-size: 16px;\n}\n.list-box .cards .card .card-info .card-header .status[data-v-12e24026] {\n            text-transform: uppercase;\n            font-size: 14px;\n            font-weight: 900;\n}\n.list-box .cards .card .card-info .title[data-v-12e24026] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n}\n.list-box .cards .card .card-info .title a[data-v-12e24026] {\n            font-weight: 900;\n}\n.list-box .cards .card .card-info .label[data-v-12e24026] {\n          font-size: 12px;\n          text-transform: uppercase;\n          color: #bbb;\n          font-weight: 600;\n          margin-right: 5px;\n}\n.list-box .cards .card .card-info .value[data-v-12e24026] {\n          margin-right: 10px;\n          font-size: 14px;\n          font-weight: 900;\n}\n.list-box .cards .card .widget-app[data-v-12e24026] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        margin-bottom: 0;\n        margin-top: 10px;\n}\n.list-box .cards .card .widget-app .widget[data-v-12e24026], .list-box .cards .card .widget-app .app[data-v-12e24026] {\n          background-color: #f4f8f9;\n          width: 100%;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          -webkit-box-orient: vertical;\n          -webkit-box-direction: normal;\n              -ms-flex-direction: column;\n                  flex-direction: column;\n          padding: 7px;\n          border: 1px solid #eee;\n}\n.list-box .cards .card .widget-app .widget span[data-v-12e24026], .list-box .cards .card .widget-app .app span[data-v-12e24026] {\n            font-size: 12px;\n            text-transform: uppercase;\n            font-weight: 900;\n}\n.list-box .cards .card .widget-app .widget .status span[data-v-12e24026], .list-box .cards .card .widget-app .app .status span[data-v-12e24026] {\n            font-size: 14px;\n}\n.list-box .cards .card .actions[data-v-12e24026] {\n        width: 100%;\n        background: #f3f3f3;\n        border-top: 1px solid #ccc;\n        padding: 15px 10px;\n        text-align: center;\n        border-radius: 0 0 10px 10px;\n        margin-bottom: 0;\n}\n.list-box .cards .card .actions .button[data-v-12e24026] {\n          line-height: 14px;\n          font-size: 14px;\n          padding: 10px 18px 9px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-box"},[_c('table',[_c('thead',[_c('tr',[_c('th',{class:['sortable', {'active':_vm.currentOrder.field === 'code'}],on:{"click":function($event){return _vm.sort('code')}}},[_vm._v("\n          Code\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'code'),expression:"currentOrder.field === 'code'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:['sortable', {'active':_vm.currentOrder.field === 'amount'}],on:{"click":function($event){return _vm.sort('amount')}}},[_vm._v("\n          Amount\n           "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'amount'),expression:"currentOrder.field === 'amount'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:['sortable', {'active':_vm.currentOrder.field === 'id'}],on:{"click":function($event){return _vm.sort('id')}}},[_vm._v("\n          Created Date\n           "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'id'),expression:"currentOrder.field === 'id'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:['sortable', {'active':_vm.currentOrder.field === 'startUTC'}],on:{"click":function($event){return _vm.sort('startUTC')}}},[_vm._v("\n          Start Date\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'startUTC'),expression:"currentOrder.field === 'startUTC'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',{class:['sortable', {'active':_vm.currentOrder.field === 'endUTC'}],on:{"click":function($event){return _vm.sort('endUTC')}}},[_vm._v("\n          End Date\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentOrder.field === 'endUTC'),expression:"currentOrder.field === 'endUTC'"}],class:['fas', _vm.currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']})]),_vm._v(" "),_c('th',[_vm._v("Widget")]),_vm._v(" "),_c('th',[_vm._v("App")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((_vm.discountCodes.list),function(data,i){return _c('tr',{key:i},[_c('td',[_c('a',{attrs:{"href":("#/discount-codes/" + (data.id))}},[_vm._v(_vm._s(data.code))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(data.amount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(data.created))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(data.start))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(data.end))]),_vm._v(" "),_c('td',[_c('div',{class:['status', {enabled:data.enabled}],on:{"click":function($event){return _vm.update(data.id, !data.enabled, 'widget')}}},[(_vm.widgetLoading.indexOf(data.id) > -1)?_c('i',{staticClass:"fas fa-spinner fa-spin"}):_c('span',[_vm._v(_vm._s(data.enabled ? 'Enabled' : 'Disabled'))])])]),_vm._v(" "),_c('td',[_c('div',{class:['status', {enabled:data.appEnabled}],on:{"click":function($event){return _vm.update(data.id, !data.appEnabled, 'app')}}},[(_vm.appLoading.indexOf(data.id) > -1)?_c('i',{staticClass:"fas fa-spinner fa-spin"}):_c('span',[_vm._v(_vm._s(data.appEnabled ? 'Enabled' : 'Disabled'))])])]),_vm._v(" "),_c('td',[_c('a',{class:['button cta xsmall success', {disabled: _vm.exportLoading.indexOf(data.id) > -1}],on:{"click":function($event){return _vm.exportDC(data)}}},[(_vm.exportLoading.indexOf(data.id) > -1)?_c('span',[_vm._v("\n              Loading\n              "),_c('i',{staticClass:"fas fa-spinner fa-spin"})]):_c('span',[_vm._v("Export")])])])])}),0)]),_vm._v(" "),_c('div',{staticClass:"cards"},_vm._l((_vm.discountCodes.list),function(data,i){return _c('div',{key:i,staticClass:"card"},[_c('div',{staticClass:"card-info"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"title"},[_c('a',{attrs:{"href":("#/discount-codes/" + (data.id))}},[_vm._v(_vm._s(data.code))])]),_vm._v(" "),_c('div',{staticClass:"amount"},[_c('span',{staticClass:"amount"},[_vm._v(_vm._s(data.amount))])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Created Date: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(data.created))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Start Date: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(data.start))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("End Date: ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(data.end))])])]),_vm._v(" "),_c('div',{staticClass:"widget-app"},[_c('div',{staticClass:"widget"},[_c('span',[_vm._v("Widget")]),_vm._v(" "),_c('div',{class:['status', {enabled:data.enabled}],on:{"click":function($event){return _vm.update(data.id, !data.enabled, 'widget')}}},[(_vm.widgetLoading.indexOf(data.id) > -1)?_c('i',{staticClass:"fas fa-spinner fa-spin"}):_c('span',[_vm._v(_vm._s(data.enabled ? 'Enabled' : 'Disabled'))])])]),_vm._v(" "),_c('div',{staticClass:"app"},[_c('span',[_vm._v("App")]),_vm._v(" "),_c('div',{class:['status', {enabled:data.appEnabled}],on:{"click":function($event){return _vm.update(data.id, !data.appEnabled, 'app')}}},[(_vm.appLoading.indexOf(data.id) > -1)?_c('i',{staticClass:"fas fa-spinner fa-spin"}):_c('span',[_vm._v(_vm._s(data.appEnabled ? 'Enabled' : 'Disabled'))])])])]),_vm._v(" "),_c('div',{staticClass:"actions"},[(_vm.exportLoading.indexOf(data.id) > -1)?_c('span',[_vm._v("\n            Loading\n            "),_c('i',{staticClass:"fas fa-spinner fa-spin"})]):_c('a',{staticClass:"button cta xsmall success",on:{"click":function($event){return _vm.exportDC(data)}}},[_vm._v("Export")])])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddModal_vue__ = __webpack_require__(679);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f4a739b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddModal_vue__ = __webpack_require__(2123);
function injectStyle (ssrContext) {
  __webpack_require__(2121)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f4a739b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f4a739b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2122);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5837c0ec", content, true, {});

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.op--modal-container[data-v-6f4a739b] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-6f4a739b] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-6f4a739b] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content.center[data-v-6f4a739b] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.promo-form[data-v-6f4a739b] {\n  background-color: #fff;\n  width: 600px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.heading[data-v-6f4a739b] {\n  background: #333;\n  color: #fff;\n  font-weight: 600;\n  font-size: 21px;\n  padding: 10px 20px;\n  margin-bottom: 20px;\n}\n.clear[data-v-6f4a739b] {\n  clear: both;\n}\n.data-field[data-v-6f4a739b] {\n  position: relative;\n  margin-bottom: 10px;\n}\n.data-field .label[data-v-6f4a739b] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 130%;\n    margin-bottom: 1px;\n}\n.data-field .label.has-error[data-v-6f4a739b] {\n      color: #f20d0d;\n}\n.data-field .label.underline[data-v-6f4a739b] {\n      padding-bottom: 3px;\n      margin-bottom: 10px;\n      border-bottom: 1px solid #ccc;\n}\n.data-field .label .secondary[data-v-6f4a739b] {\n      color: #5390dc;\n      display: inline-block;\n      margin-left: 3px;\n}\n.data-field .input[data-v-6f4a739b] {\n    margin: 1px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-6f4a739b] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-6f4a739b]:disabled {\n      background: #eee;\n}\n.data-field textarea[data-v-6f4a739b] {\n    border: 1px solid #ddd;\n    width: 100%;\n    height: 100px;\n    resize: none;\n    padding: 10px;\n    font-size: 13px;\n    color: #555;\n    outline: none;\n    margin-top: 5px;\n}\n.data-field textarea.has-error[data-v-6f4a739b] {\n      border-color: #f20d0d;\n}\n.data-field .error-msg[data-v-6f4a739b] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\nselect[data-v-6f4a739b] {\n  margin-top: 1px;\n  border: 1px solid #ddd;\n  padding: 10px;\n  color: #333;\n  height: 45px;\n  position: relative;\n  font-size: 14px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n  -webkit-transition: all .35s ease;\n  transition: all .35s ease;\n}\nselect.has-error[data-v-6f4a739b] {\n    border-color: #f20d0d;\n}\nselect[data-v-6f4a739b]:disabled {\n    background-color: #eee;\n}\n.time[data-v-6f4a739b] {\n  display: inline-block;\n  line-height: 45px;\n}\n.row-button[data-v-6f4a739b] {\n  background: #f6f6f6;\n  border-top: 1px solid #ddd;\n  text-align: center;\n  padding: 10px 0;\n}\n.row-button .button[data-v-6f4a739b] {\n    margin: 0 5px;\n    min-width: 150px;\n}\n.check-field[data-v-6f4a739b] {\n  font-size: 14px;\n  margin-bottom: 10px;\n  display: inline-block;\n  color: #888;\n  font-weight: 600;\n}\n.check-field input[data-v-6f4a739b] {\n    width: auto;\n    display: inline-block;\n    margin-right: 3px;\n    vertical-align: -1px;\n}\n.row[data-v-6f4a739b] {\n  max-width: 100%;\n}\n.row-padding[data-v-6f4a739b] {\n  padding: 5px 15px;\n}\n.padding-L[data-v-6f4a739b] {\n  padding-left: 10px;\n}\n.padding-R[data-v-6f4a739b] {\n  padding-right: 10px;\n}\n.margin-B[data-v-6f4a739b] {\n  margin-bottom: 20px;\n}\n.text-center[data-v-6f4a739b] {\n  text-align: center;\n}\n.error-box[data-v-6f4a739b] {\n  margin: 0 30px;\n  border: 1px solid #f34c31;\n  color: #f34c31;\n  padding: 5px;\n  margin-bottom: 15px;\n  font-size: 14px;\n  font-weight: 600;\n}\n.slide-down-enter-active[data-v-6f4a739b], .slide-down-leave-active[data-v-6f4a739b] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-6f4a739b], .slide-down-leave-to[data-v-6f4a739b] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.padding-L[data-v-6f4a739b], .padding-R[data-v-6f4a739b] {\n    padding: 0;\n}\n.small-5[data-v-6f4a739b], .small-4[data-v-6f4a739b], .small-6[data-v-6f4a739b], .promo-form[data-v-6f4a739b] {\n    width: 100%;\n}\n.promo-form[data-v-6f4a739b] {\n    height: 100%;\n    overflow: auto;\n}\n.small-3[data-v-6f4a739b] {\n    width: 45%;\n}\n.small-1[data-v-6f4a739b] {\n    width: 10%;\n}\n.small-5[data-v-6f4a739b] {\n    margin-bottom: 10px;\n}\n.data-field textarea[data-v-6f4a739b] {\n    height: 80px;\n}\n.input-date .small-5[data-v-6f4a739b] {\n    width: 45%;\n    padding-right: 5%;\n}\n.input-date .small-3[data-v-6f4a739b] {\n    width: 25%;\n    padding: 0;\n    margin: 0;\n    float: left;\n}\n.input-date .small-1[data-v-6f4a739b] {\n    width: 5%;\n}\n.promo-code[data-v-6f4a739b] {\n    width: 50%;\n    padding-right: 5%;\n}\n.credit-amount[data-v-6f4a739b] {\n    width: 50%;\n}\n.w-50[data-v-6f4a739b] {\n    width: 50%;\n}\n.w-50.padding-r[data-v-6f4a739b] {\n      padding-right: 5%;\n}\n}\n@media screen and (max-width: 430px) {\n.op--modal[data-v-6f4a739b] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    width: 98%;\n    margin: 0 auto;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/DiscountCodes/AddModal.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,qCAAqC;MACjC,kCAAkC;UAC9B,+BAA+B;EACvC,YAAY;EACZ,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,iDAAiD;UACzC,yCAAyC;EACjD,mBAAmB;CACpB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;CACrB;AACD;EACE,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,oBAAoB;CACrB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;MACM,oBAAoB;MACpB,oBAAoB;MACpB,8BAA8B;CACnC;AACD;MACM,eAAe;MACf,sBAAsB;MACtB,iBAAiB;CACtB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,gBAAgB;CACnB;AACD;MACM,sBAAsB;CAC3B;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;IACI,sBAAsB;CACzB;AACD;IACI,uBAAuB;CAC1B;AACD;EACE,sBAAsB;EACtB,kBAAkB;CACnB;AACD;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;CACjB;AACD;IACI,cAAc;IACd,iBAAiB;CACpB;AACD;EACE,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;CAClB;AACD;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;CACxB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;CAClB;AACD;EACE,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,mCAAmC;UAC3B,2BAA2B;EACnC,WAAW;CACZ;AACD;AACA;IACI,WAAW;CACd;AACD;IACI,YAAY;CACf;AACD;IACI,aAAa;IACb,eAAe;CAClB;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,oBAAoB;CACvB;AACD;IACI,aAAa;CAChB;AACD;IACI,WAAW;IACX,kBAAkB;CACrB;AACD;IACI,WAAW;IACX,WAAW;IACX,UAAU;IACV,YAAY;CACf;AACD;IACI,UAAU;CACb;AACD;IACI,WAAW;IACX,kBAAkB;CACrB;AACD;IACI,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;MACM,kBAAkB;CACvB;CACA;AACD;AACA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;IAC5B,WAAW;IACX,eAAe;CAClB;CACA","file":"AddModal.vue","sourcesContent":["\n.op--modal-container[data-v-6f4a739b] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.op--modal-container.hide[data-v-6f4a739b] {\n    top: -100%;\n    opacity: 0;\n}\n.op--modal[data-v-6f4a739b] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  width: 100%;\n  height: 100%;\n}\n.op--modal-content.center[data-v-6f4a739b] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.promo-form[data-v-6f4a739b] {\n  background-color: #fff;\n  width: 600px;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n.heading[data-v-6f4a739b] {\n  background: #333;\n  color: #fff;\n  font-weight: 600;\n  font-size: 21px;\n  padding: 10px 20px;\n  margin-bottom: 20px;\n}\n.clear[data-v-6f4a739b] {\n  clear: both;\n}\n.data-field[data-v-6f4a739b] {\n  position: relative;\n  margin-bottom: 10px;\n}\n.data-field .label[data-v-6f4a739b] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 130%;\n    margin-bottom: 1px;\n}\n.data-field .label.has-error[data-v-6f4a739b] {\n      color: #f20d0d;\n}\n.data-field .label.underline[data-v-6f4a739b] {\n      padding-bottom: 3px;\n      margin-bottom: 10px;\n      border-bottom: 1px solid #ccc;\n}\n.data-field .label .secondary[data-v-6f4a739b] {\n      color: #5390dc;\n      display: inline-block;\n      margin-left: 3px;\n}\n.data-field .input[data-v-6f4a739b] {\n    margin: 1px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-6f4a739b] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-6f4a739b]:disabled {\n      background: #eee;\n}\n.data-field textarea[data-v-6f4a739b] {\n    border: 1px solid #ddd;\n    width: 100%;\n    height: 100px;\n    resize: none;\n    padding: 10px;\n    font-size: 13px;\n    color: #555;\n    outline: none;\n    margin-top: 5px;\n}\n.data-field textarea.has-error[data-v-6f4a739b] {\n      border-color: #f20d0d;\n}\n.data-field .error-msg[data-v-6f4a739b] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\nselect[data-v-6f4a739b] {\n  margin-top: 1px;\n  border: 1px solid #ddd;\n  padding: 10px;\n  color: #333;\n  height: 45px;\n  position: relative;\n  font-size: 14px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n  -webkit-transition: all .35s ease;\n  transition: all .35s ease;\n}\nselect.has-error[data-v-6f4a739b] {\n    border-color: #f20d0d;\n}\nselect[data-v-6f4a739b]:disabled {\n    background-color: #eee;\n}\n.time[data-v-6f4a739b] {\n  display: inline-block;\n  line-height: 45px;\n}\n.row-button[data-v-6f4a739b] {\n  background: #f6f6f6;\n  border-top: 1px solid #ddd;\n  text-align: center;\n  padding: 10px 0;\n}\n.row-button .button[data-v-6f4a739b] {\n    margin: 0 5px;\n    min-width: 150px;\n}\n.check-field[data-v-6f4a739b] {\n  font-size: 14px;\n  margin-bottom: 10px;\n  display: inline-block;\n  color: #888;\n  font-weight: 600;\n}\n.check-field input[data-v-6f4a739b] {\n    width: auto;\n    display: inline-block;\n    margin-right: 3px;\n    vertical-align: -1px;\n}\n.row[data-v-6f4a739b] {\n  max-width: 100%;\n}\n.row-padding[data-v-6f4a739b] {\n  padding: 5px 15px;\n}\n.padding-L[data-v-6f4a739b] {\n  padding-left: 10px;\n}\n.padding-R[data-v-6f4a739b] {\n  padding-right: 10px;\n}\n.margin-B[data-v-6f4a739b] {\n  margin-bottom: 20px;\n}\n.text-center[data-v-6f4a739b] {\n  text-align: center;\n}\n.error-box[data-v-6f4a739b] {\n  margin: 0 30px;\n  border: 1px solid #f34c31;\n  color: #f34c31;\n  padding: 5px;\n  margin-bottom: 15px;\n  font-size: 14px;\n  font-weight: 600;\n}\n.slide-down-enter-active[data-v-6f4a739b], .slide-down-leave-active[data-v-6f4a739b] {\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n}\n.slide-down-enter[data-v-6f4a739b], .slide-down-leave-to[data-v-6f4a739b] {\n  -webkit-transform: rotateX(-90deg);\n          transform: rotateX(-90deg);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.padding-L[data-v-6f4a739b], .padding-R[data-v-6f4a739b] {\n    padding: 0;\n}\n.small-5[data-v-6f4a739b], .small-4[data-v-6f4a739b], .small-6[data-v-6f4a739b], .promo-form[data-v-6f4a739b] {\n    width: 100%;\n}\n.promo-form[data-v-6f4a739b] {\n    height: 100%;\n    overflow: auto;\n}\n.small-3[data-v-6f4a739b] {\n    width: 45%;\n}\n.small-1[data-v-6f4a739b] {\n    width: 10%;\n}\n.small-5[data-v-6f4a739b] {\n    margin-bottom: 10px;\n}\n.data-field textarea[data-v-6f4a739b] {\n    height: 80px;\n}\n.input-date .small-5[data-v-6f4a739b] {\n    width: 45%;\n    padding-right: 5%;\n}\n.input-date .small-3[data-v-6f4a739b] {\n    width: 25%;\n    padding: 0;\n    margin: 0;\n    float: left;\n}\n.input-date .small-1[data-v-6f4a739b] {\n    width: 5%;\n}\n.promo-code[data-v-6f4a739b] {\n    width: 50%;\n    padding-right: 5%;\n}\n.credit-amount[data-v-6f4a739b] {\n    width: 50%;\n}\n.w-50[data-v-6f4a739b] {\n    width: 50%;\n}\n.w-50.padding-r[data-v-6f4a739b] {\n      padding-right: 5%;\n}\n}\n@media screen and (max-width: 430px) {\n.op--modal[data-v-6f4a739b] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    width: 98%;\n    margin: 0 auto;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['op--modal-container', {'hide':!_vm.show}],on:{"click":function($event){_vm.show = false}}},[_c('div',{staticClass:"op--modal"},[_c('div',{staticClass:"op--modal-content promo-form",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"heading",attrs:{"id":"addPromo"}},[_vm._v("Create Discount Code")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.errorReturn),expression:"!!errorReturn"}],staticClass:"error-box"},[_vm._v(_vm._s(_vm.errorReturn))]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],class:['input', {'has-error':!!_vm.errorMsg.code}],attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.code)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return (function (event) { return event.preventDefault(); }).apply(null, arguments)},"paste":_vm.removeEventSpaces,"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.code))])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.desc),expression:"desc"}],attrs:{"disabled":_vm.loading},domProps:{"value":(_vm.desc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.desc=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.desc))])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"column small-6 padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Type")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.type),expression:"type"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"$"}},[_vm._v("$")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])])]),_vm._v(" "),_c('div',{staticClass:"column small-6 padding-L"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Amount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],class:{'input':true, 'has-error':!!_vm.errorMsg.amount},attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.amount))])])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"column small-12 end"},[_c('div',{staticClass:"data-field input-date"},[_c('div',{staticClass:"label"},[_vm._v("Start Date")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-5 padding-R"},[_c('datepicker',{staticClass:"datepicker inline",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"disabled":_vm.startDateDisabled,"input-class":{'datepicker-empty':_vm.errorMsg.startDate}},on:{"input":function($event){return _vm.changeDate('startDate')}},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.startDate || _vm.errorMsg.startDateHour || _vm.errorMsg.startDateMinute))])],1),_vm._v(" "),_c('div',{staticClass:"column small-3 padding-L"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDateHour),expression:"startDateHour"}],class:{'has-error':!!_vm.errorMsg.startDateHour},attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.startDateHour=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Hour")]),_vm._v(" "),_vm._l((24),function(x){return _c('option',{key:x,domProps:{"value":_vm.leadingZero(x - 1)}},[_vm._v(_vm._s(_vm.leadingZero(x - 1)))])})],2)]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column small-3 padding-R"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDateMinute),expression:"startDateMinute"}],class:{'has-error':!!_vm.errorMsg.startDateMinute},attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.startDateMinute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Minute")]),_vm._v(" "),_vm._l((12),function(x){return _c('option',{key:x,domProps:{"value":_vm.leadingZero((x - 1) * 5)}},[_vm._v(_vm._s(_vm.leadingZero((x - 1) * 5)))])})],2)])])])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"column small-12 end"},[_c('div',{staticClass:"data-field input-date"},[_c('div',{staticClass:"label"},[_vm._v("End Date")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-5 padding-R"},[_c('datepicker',{staticClass:"datepicker inline",attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading,"disabled":_vm.endDateDisabled,"input-class":{'datepicker-empty':_vm.errorMsg.expirationDate}},on:{"input":function($event){return _vm.changeDate('endDate')}},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.endDate || _vm.errorMsg.endDateHour || _vm.errorMsg.endDateMinute))])],1),_vm._v(" "),_c('div',{staticClass:"column small-3 padding-L"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDateHour),expression:"endDateHour"}],class:{'has-error':!!_vm.errorMsg.endDateHour},attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.endDateHour=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Hour")]),_vm._v(" "),_vm._l((24),function(x){return _c('option',{key:x,domProps:{"value":_vm.leadingZero(x - 1)}},[_vm._v(_vm._s(_vm.leadingZero(x - 1)))])})],2)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"column small-3 padding-R"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDateMinute),expression:"endDateMinute"}],class:{'has-error':!!_vm.errorMsg.endDateMinute},attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.endDateMinute=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Minute")]),_vm._v(" "),_vm._l((12),function(x){return _c('option',{key:x,domProps:{"value":_vm.leadingZero((x - 1) * 5)}},[_vm._v(_vm._s(_vm.leadingZero((x - 1) * 5)))])})],2)])])])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"column small-4 padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Valid Only for New Users")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newUsers),expression:"newUsers"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.newUsers=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Yes")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("No")])])])]),_vm._v(" "),_c('div',{staticClass:"column small-4"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Redeemable once per user")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reedemOnce),expression:"reedemOnce"}],attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.reedemOnce=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Yes")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("No")])])])]),_vm._v(" "),_c('div',{staticClass:"column small-4 padding-L"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Number of Codes to Redeem")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxUse),expression:"maxUse"}],class:['input', {'has-error':!!_vm.errorMsg.maxUse}],attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.maxUse)},on:{"keypress":_vm.onlyNumber,"input":function($event){if($event.target.composing){ return; }_vm.maxUse=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg.maxUse))])])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"column small-6"},[_c('div',{staticClass:"data-field"},[_c('label',{staticClass:"check-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isWidget),expression:"isWidget"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isWidget)?_vm._i(_vm.isWidget,null)>-1:(_vm.isWidget)},on:{"change":function($event){var $$a=_vm.isWidget,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isWidget=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isWidget=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isWidget=$$c}}}}),_vm._v("\n              Enable on Widget\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('div',{staticClass:"data-field"},[_c('label',{staticClass:"check-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isApp),expression:"isApp"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isApp)?_vm._i(_vm.isApp,null)>-1:(_vm.isApp)},on:{"change":function($event){var $$a=_vm.isApp,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isApp=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isApp=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isApp=$$c}}}}),_vm._v("\n              Enable on App\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"row row-button"},[_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"button cta error small",on:{"click":function($event){_vm.show = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('div',{staticClass:"button cta success small",on:{"click":_vm.save}},[_vm._v("Save")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-1 text-center"},[_c('span',{staticClass:"time"},[_vm._v(":")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-1 text-center"},[_c('span',{staticClass:"time"},[_vm._v(":")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"heading"},[_vm._v("Discount Codes")]),_vm._v(" "),_c('div',{staticClass:"filter d-flex justify-space-between align-center"},[_c('div',{staticClass:"search-box"},[_c('label',{staticClass:"field-label"},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"search"},[_c('div',{staticClass:"search-input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchKey),expression:"searchKey"}],ref:"search",attrs:{"type":"text","disabled":_vm.loading},domProps:{"value":(_vm.searchKey)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search.apply(null, arguments)},"blur":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.searchKey=$event.target.value}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide-left"}},[(_vm.searchKey.length > 0)?_c('i',{staticClass:"far fa-times-circle fa-lg",on:{"click":_vm.clearSearch}}):_vm._e()])],1),_vm._v(" "),_c('button',{class:{'button xsmall success':true, 'disabled':_vm.loading},on:{"click":_vm.search}},[_c('i',{staticClass:"fas fa-search fa-lg"})])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"button cta success",on:{"click":_vm.showCreateModal}},[_vm._v("Add Discount Code")])])]),_vm._v(" "),_c('list',{on:{"search":_vm.search}}),_vm._v(" "),_c('add-modal',{ref:"addModal",on:{"refresh":_vm.search}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Details_vue__ = __webpack_require__(680);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9124c82_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__ = __webpack_require__(2132);
function injectStyle (ssrContext) {
  __webpack_require__(2126)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e9124c82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9124c82_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2127);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4179dc0c", content, true, {});

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.heading[data-v-e9124c82] {\n  margin-left: 50px;\n  padding: 0 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify !important;\n      -ms-flex-pack: justify !important;\n          justify-content: space-between !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n}\n.details-box[data-v-e9124c82] {\n  padding: 10px;\n  width: 50%;\n  max-width: 700px;\n  height: calc(100vh - 50px);\n  border-right: 1px solid #ccc;\n  overflow: auto;\n}\n.data-field[data-v-e9124c82] {\n  position: relative;\n  margin-bottom: 10px;\n}\n.data-field .label[data-v-e9124c82] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 130%;\n    margin-bottom: 1px;\n}\n.data-field .label.has-error[data-v-e9124c82] {\n      color: #f20d0d;\n}\n.data-field .label.underline[data-v-e9124c82] {\n      padding-bottom: 3px;\n      margin-bottom: 10px;\n      border-bottom: 1px solid #ccc;\n}\n.data-field .label .secondary[data-v-e9124c82] {\n      color: #5390dc;\n      display: inline-block;\n      margin-left: 3px;\n}\n.data-field .input[data-v-e9124c82] {\n    margin: 1px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-e9124c82] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-e9124c82]:disabled {\n      background: #eee;\n}\n.data-field textarea[data-v-e9124c82] {\n    border: 1px solid #ddd;\n    width: 100%;\n    height: 100px;\n    resize: none;\n    padding: 10px;\n    font-size: 13px;\n    color: #555;\n    outline: none;\n    margin-top: 5px;\n}\n.data-field textarea.has-error[data-v-e9124c82] {\n      border-color: #f20d0d;\n}\n.data-field .error-msg[data-v-e9124c82] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\nselect[data-v-e9124c82] {\n  margin-top: 1px;\n  border: 1px solid #aaa;\n  padding: 10px;\n  color: #333;\n  height: 45px;\n  position: relative;\n  font-size: 14px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n  -webkit-transition: all .35s ease;\n  transition: all .35s ease;\n}\nselect.has-error[data-v-e9124c82] {\n    border-color: #f20d0d;\n}\nselect[data-v-e9124c82]:disabled {\n    background-color: #eee;\n}\n.check-field[data-v-e9124c82] {\n  font-size: 15px;\n  margin-bottom: 10px;\n  display: inline-block;\n}\n.check-field input[data-v-e9124c82] {\n    width: auto;\n    display: inline-block;\n    margin-right: 3px;\n    vertical-align: -1px;\n}\n.row[data-v-e9124c82] {\n  max-width: 100%;\n}\n.row-padding[data-v-e9124c82] {\n  padding: 5px 15px;\n}\n.padding-L[data-v-e9124c82] {\n  padding-left: 10px;\n}\n.padding-R[data-v-e9124c82] {\n  padding-right: 10px;\n}\n.margin-B[data-v-e9124c82] {\n  margin-bottom: 20px;\n}\n.text-center[data-v-e9124c82] {\n  text-align: center;\n}\n.usage-box[data-v-e9124c82] {\n  width: 100%;\n  background: #fff;\n}\n.toggle-mobile[data-v-e9124c82] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.heading[data-v-e9124c82] {\n    font-size: 16px;\n}\n.data-field .label[data-v-e9124c82] {\n    font-size: 10px;\n}\n.d-flex .details-box[data-v-e9124c82] {\n    width: 100%;\n    height: 110vh;\n}\n.d-flex .usage-box[data-v-e9124c82] {\n    top: 100%;\n    position: fixed;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n}\n.d-flex.mobile-right-panel .details-box[data-v-e9124c82] {\n    display: none;\n}\n.d-flex.mobile-right-panel .usage-box[data-v-e9124c82] {\n    top: 50px;\n}\n.toggle-mobile[data-v-e9124c82] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/DiscountCodes/Details.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,qCAAqC;MACjC,kCAAkC;UAC9B,0CAA0C;EAClD,qCAAqC;MACjC,kCAAkC;UAC9B,+BAA+B;CACxC;AACD;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,6BAA6B;EAC7B,eAAe;CAChB;AACD;EACE,mBAAmB;EACnB,oBAAoB;CACrB;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;CACtB;AACD;MACM,eAAe;CACpB;AACD;MACM,oBAAoB;MACpB,oBAAoB;MACpB,8BAA8B;CACnC;AACD;MACM,eAAe;MACf,sBAAsB;MACtB,iBAAiB;CACtB;AACD;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;MACM,sBAAsB;CAC3B;AACD;MACM,iBAAiB;CACtB;AACD;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,gBAAgB;CACnB;AACD;MACM,sBAAsB;CAC3B;AACD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;CAClB;AACD;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;IACI,sBAAsB;CACzB;AACD;IACI,uBAAuB;CAC1B;AACD;EACE,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;CACvB;AACD;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;CACxB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,YAAY;EACZ,iBAAiB;CAClB;AACD;EACE,cAAc;CACf;AACD;AACA;IACI,gBAAgB;CACnB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,YAAY;IACZ,cAAc;CACjB;AACD;IACI,UAAU;IACV,gBAAgB;IAChB,kCAAkC;IAClC,0BAA0B;CAC7B;AACD;IACI,cAAc;CACjB;AACD;IACI,UAAU;CACb;AACD;IACI,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;IACrB,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;CACpB;CACA","file":"Details.vue","sourcesContent":["\n.heading[data-v-e9124c82] {\n  margin-left: 50px;\n  padding: 0 10px;\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  line-height: 50px;\n  color: #3F2975;\n  font-size: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify !important;\n      -ms-flex-pack: justify !important;\n          justify-content: space-between !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n}\n.details-box[data-v-e9124c82] {\n  padding: 10px;\n  width: 50%;\n  max-width: 700px;\n  height: calc(100vh - 50px);\n  border-right: 1px solid #ccc;\n  overflow: auto;\n}\n.data-field[data-v-e9124c82] {\n  position: relative;\n  margin-bottom: 10px;\n}\n.data-field .label[data-v-e9124c82] {\n    color: #888;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 130%;\n    margin-bottom: 1px;\n}\n.data-field .label.has-error[data-v-e9124c82] {\n      color: #f20d0d;\n}\n.data-field .label.underline[data-v-e9124c82] {\n      padding-bottom: 3px;\n      margin-bottom: 10px;\n      border-bottom: 1px solid #ccc;\n}\n.data-field .label .secondary[data-v-e9124c82] {\n      color: #5390dc;\n      display: inline-block;\n      margin-left: 3px;\n}\n.data-field .input[data-v-e9124c82] {\n    margin: 1px 0 0;\n    color: #333;\n    line-height: inherit;\n    -webkit-transition: all .35s ease;\n    transition: all .35s ease;\n}\n.data-field .input.has-error[data-v-e9124c82] {\n      border-color: #f20d0d;\n}\n.data-field .input[data-v-e9124c82]:disabled {\n      background: #eee;\n}\n.data-field textarea[data-v-e9124c82] {\n    border: 1px solid #ddd;\n    width: 100%;\n    height: 100px;\n    resize: none;\n    padding: 10px;\n    font-size: 13px;\n    color: #555;\n    outline: none;\n    margin-top: 5px;\n}\n.data-field textarea.has-error[data-v-e9124c82] {\n      border-color: #f20d0d;\n}\n.data-field .error-msg[data-v-e9124c82] {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #f20d0d;\n    font-style: italic;\n    display: block;\n}\nselect[data-v-e9124c82] {\n  margin-top: 1px;\n  border: 1px solid #aaa;\n  padding: 10px;\n  color: #333;\n  height: 45px;\n  position: relative;\n  font-size: 14px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"/assets/img/dropdown-arrow.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n  -webkit-transition: all .35s ease;\n  transition: all .35s ease;\n}\nselect.has-error[data-v-e9124c82] {\n    border-color: #f20d0d;\n}\nselect[data-v-e9124c82]:disabled {\n    background-color: #eee;\n}\n.check-field[data-v-e9124c82] {\n  font-size: 15px;\n  margin-bottom: 10px;\n  display: inline-block;\n}\n.check-field input[data-v-e9124c82] {\n    width: auto;\n    display: inline-block;\n    margin-right: 3px;\n    vertical-align: -1px;\n}\n.row[data-v-e9124c82] {\n  max-width: 100%;\n}\n.row-padding[data-v-e9124c82] {\n  padding: 5px 15px;\n}\n.padding-L[data-v-e9124c82] {\n  padding-left: 10px;\n}\n.padding-R[data-v-e9124c82] {\n  padding-right: 10px;\n}\n.margin-B[data-v-e9124c82] {\n  margin-bottom: 20px;\n}\n.text-center[data-v-e9124c82] {\n  text-align: center;\n}\n.usage-box[data-v-e9124c82] {\n  width: 100%;\n  background: #fff;\n}\n.toggle-mobile[data-v-e9124c82] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.heading[data-v-e9124c82] {\n    font-size: 16px;\n}\n.data-field .label[data-v-e9124c82] {\n    font-size: 10px;\n}\n.d-flex .details-box[data-v-e9124c82] {\n    width: 100%;\n    height: 110vh;\n}\n.d-flex .usage-box[data-v-e9124c82] {\n    top: 100%;\n    position: fixed;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n}\n.d-flex.mobile-right-panel .details-box[data-v-e9124c82] {\n    display: none;\n}\n.d-flex.mobile-right-panel .usage-box[data-v-e9124c82] {\n    top: 50px;\n}\n.toggle-mobile[data-v-e9124c82] {\n    display: block;\n    color: #fff;\n    background-color: #333;\n    cursor: pointer;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    padding: 8px 0;\n    height: 45px;\n    -webkit-transition: top .25s;\n    transition: top .25s;\n    z-index: 9;\n    text-transform: uppercase;\n    font-weight: 900;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RsvpList_vue__ = __webpack_require__(681);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_740d6d99_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RsvpList_vue__ = __webpack_require__(2131);
function injectStyle (ssrContext) {
  __webpack_require__(2129)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-740d6d99"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RsvpList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_740d6d99_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RsvpList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2130);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("6dbeeaba", content, true, {});

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.list-box[data-v-740d6d99] {\n  overflow-y: auto;\n  height: calc(100vh - 50px);\n}\n.list-box thead[data-v-740d6d99] {\n    color: #8DA0A9;\n    font-size: 12px;\n}\n.list-box thead th[data-v-740d6d99] {\n      border-bottom: 1px solid #ccc;\n      background-color: #f5f5f5;\n      position: sticky;\n      top: 0px;\n}\ntable[data-v-740d6d99] {\n  border-collapse: collapse;\n  width: 100%;\n}\nth[data-v-740d6d99], td[data-v-740d6d99] {\n  padding: 5px;\n  text-align: center;\n}\ntr[data-v-740d6d99] {\n  border-bottom: 1px solid #ddd;\n}\ntr[data-v-740d6d99]:nth-child(even) {\n    background: #fbfbfb;\n}\ntr td[data-v-740d6d99] {\n    font-size: 14px;\n    padding: 8px 5px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/DiscountCodes/RsvpList.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,2BAA2B;CAC5B;AACD;IACI,eAAe;IACf,gBAAgB;CACnB;AACD;MACM,8BAA8B;MAC9B,0BAA0B;MAC1B,iBAAiB;MACjB,SAAS;CACd;AACD;EACE,0BAA0B;EAC1B,YAAY;CACb;AACD;EACE,aAAa;EACb,mBAAmB;CACpB;AACD;EACE,8BAA8B;CAC/B;AACD;IACI,oBAAoB;CACvB;AACD;IACI,gBAAgB;IAChB,iBAAiB;CACpB","file":"RsvpList.vue","sourcesContent":["\n.list-box[data-v-740d6d99] {\n  overflow-y: auto;\n  height: calc(100vh - 50px);\n}\n.list-box thead[data-v-740d6d99] {\n    color: #8DA0A9;\n    font-size: 12px;\n}\n.list-box thead th[data-v-740d6d99] {\n      border-bottom: 1px solid #ccc;\n      background-color: #f5f5f5;\n      position: sticky;\n      top: 0px;\n}\ntable[data-v-740d6d99] {\n  border-collapse: collapse;\n  width: 100%;\n}\nth[data-v-740d6d99], td[data-v-740d6d99] {\n  padding: 5px;\n  text-align: center;\n}\ntr[data-v-740d6d99] {\n  border-bottom: 1px solid #ddd;\n}\ntr[data-v-740d6d99]:nth-child(even) {\n    background: #fbfbfb;\n}\ntr td[data-v-740d6d99] {\n    font-size: 14px;\n    padding: 8px 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"list-box"},[_c('table',[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(data,i){return _c('tr',{key:i},[_c('td',[_c('a',{attrs:{"href":("#/reservation/" + (data.rsvpId)),"target":"_blank"}},[_vm._v(_vm._s(data.rsvpId))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(data.created))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(Math.abs(data.amount)))])])}),0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("RSVP ID")]),_vm._v(" "),_c('th',[_vm._v("Created")]),_vm._v(" "),_c('th',[_vm._v("Discount Amount")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"heading"},[_c('div',[_vm._v("Discount Code Details")]),_vm._v(" "),_c('div',{staticClass:"button cta small success",on:{"click":function($event){return _vm.exportDC()}}},[_vm._v("export")])]),_vm._v(" "),_c('div',{class:['d-flex', _vm.showRecords ? 'mobile-right-panel' : '']},[_c('div',{staticClass:"details-box"},[_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],class:{'input':true, 'has-error':!!_vm.error.code},attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.code))])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.desc),expression:"desc"}],domProps:{"value":(_vm.desc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.desc=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"column small-6 padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Type")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.type),expression:"type"}],attrs:{"disabled":_vm.view.list.length > 0},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"$"}},[_vm._v("$")]),_vm._v(" "),_c('option',{attrs:{"value":"%"}},[_vm._v("%")])])])]),_vm._v(" "),_c('div',{staticClass:"column small-6 padding-L"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Amount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],class:{'input':true, 'has-error':!!_vm.error.amount},attrs:{"type":"text","disabled":_vm.view.list.length > 0},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.amount))])])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"column small-12 end"},[_c('div',{staticClass:"data-field input-date"},[_c('div',{staticClass:"label"},[_vm._v("Start Date")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-5 padding-R"},[_c('datepicker',{staticClass:"datepicker inline",attrs:{"format":_vm.calendarFormat,"disabled":_vm.startDateDisabled,"input-class":{'datepicker-empty':_vm.error.startDate}},on:{"input":function($event){return _vm.changeDate('startDate')}},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.startDate || _vm.error.startHr || _vm.error.startMin))])],1),_vm._v(" "),_c('div',{staticClass:"column small-3 padding-L"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startHr),expression:"startHr"}],class:{'has-error':!!_vm.error.startHr},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.startHr=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Hour")]),_vm._v(" "),_vm._l((24),function(x){return _c('option',{key:x,domProps:{"value":_vm.leadingZero(x - 1)}},[_vm._v(_vm._s(_vm.leadingZero(x - 1)))])})],2)]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column small-3 padding-R"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.startMin),expression:"startMin"}],class:{'has-error':!!_vm.error.startMin},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.startMin=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Minute")]),_vm._v(" "),_vm._l((12),function(x){return _c('option',{key:x,domProps:{"value":_vm.leadingZero((x - 1) * 5)}},[_vm._v(_vm._s(_vm.leadingZero((x - 1) * 5)))])})],2)])])])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"column small-12 end"},[_c('div',{staticClass:"data-field input-date"},[_c('div',{staticClass:"label"},[_vm._v("End Date")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-5 padding-R"},[_c('datepicker',{staticClass:"datepicker inline",attrs:{"format":_vm.calendarFormat,"disabled":_vm.endDateDisabled,"input-class":{'datepicker-empty':_vm.error.endDate}},on:{"input":function($event){return _vm.changeDate('endDate')}},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.endDate || _vm.error.endHr || _vm.error.endMin))])],1),_vm._v(" "),_c('div',{staticClass:"column small-3 padding-L"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.endHr),expression:"endHr"}],class:{'has-error':!!_vm.error.endHr},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.endHr=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Hour")]),_vm._v(" "),_vm._l((24),function(x){return _c('option',{key:x,domProps:{"value":_vm.leadingZero(x - 1)}},[_vm._v(_vm._s(_vm.leadingZero(x - 1)))])})],2)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"column small-3 padding-R"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.endMin),expression:"endMin"}],class:{'has-error':!!_vm.error.endMin},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.endMin=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Minute")]),_vm._v(" "),_vm._l((12),function(x){return _c('option',{key:x,domProps:{"value":_vm.leadingZero((x - 1) * 5)}},[_vm._v(_vm._s(_vm.leadingZero((x - 1) * 5)))])})],2)])])])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"column small-4 padding-R"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Valid Only for New Users")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newUsers),expression:"newUsers"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.newUsers=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Yes")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("No")])])])]),_vm._v(" "),_c('div',{staticClass:"column small-4 padding-R padding-L"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Redeemable once per user")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reedemOnce),expression:"reedemOnce"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.reedemOnce=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Yes")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("No")])])])]),_vm._v(" "),_c('div',{staticClass:"column small-4 padding-L"},[_c('div',{staticClass:"data-field"},[_c('div',{staticClass:"label"},[_vm._v("Number of Codes to Redeem")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxUse),expression:"maxUse"}],class:['input', {'has-error':!!_vm.error.maxUse}],attrs:{"type":"text"},domProps:{"value":(_vm.maxUse)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxUse=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.maxUse))])])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"column small-6 padding-R"},[_c('label',{staticClass:"check-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isWidget),expression:"isWidget"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isWidget)?_vm._i(_vm.isWidget,null)>-1:(_vm.isWidget)},on:{"change":function($event){var $$a=_vm.isWidget,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isWidget=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isWidget=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isWidget=$$c}}}}),_vm._v("\n            Enable on Widget\n          ")])]),_vm._v(" "),_c('div',{staticClass:"column small-6 padding-R"},[_c('label',{staticClass:"check-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isApp),expression:"isApp"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isApp)?_vm._i(_vm.isApp,null)>-1:(_vm.isApp)},on:{"change":function($event){var $$a=_vm.isApp,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isApp=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isApp=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isApp=$$c}}}}),_vm._v("\n            Enable on App\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"row row-padding"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"button cta success block",on:{"click":_vm.update}},[_vm._v("Update")])])])]),_vm._v(" "),_c('div',{staticClass:"usage-box"},[_c('rsvp-list',{ref:"rsvpList"})],1)]),_vm._v(" "),_c('div',{staticClass:"toggle-mobile",on:{"click":function($event){_vm.showRecords = !_vm.showRecords}}},[(!_vm.showRecords)?_c('span',[_vm._v("Show Records "),_c('i',{staticClass:"fa fa-chevron-up"})]):_c('span',[_vm._v("Hide Records "),_c('i',{staticClass:"fa fa-chevron-down"})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-1 text-center"},[_c('span',{staticClass:"time"},[_vm._v(":")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-1 text-center"},[_c('span',{staticClass:"time"},[_vm._v(":")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(682);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39ea7e07_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2136);
function injectStyle (ssrContext) {
  __webpack_require__(2134)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39ea7e07"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39ea7e07_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2135);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("a1e6f88c", content, true, {});

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.head[data-v-39ea7e07] {\n  height: 50px;\n  font-weight: 600;\n  color: #fff;\n  padding: 0 10px;\n  width: calc(100% - 50px);\n  margin-left: 50px;\n  font-size: 21px;\n  line-height: 50px;\n  background: #333;\n}\n.wrap-box[data-v-39ea7e07] {\n  width: 100%;\n  max-width: 1100px;\n  padding: 10px;\n  margin: 0 auto;\n}\n.filter-box[data-v-39ea7e07] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  border: 1px solid #ccc;\n  background: #fafafa;\n  padding: 15px;\n  border-radius: 4px;\n  -webkit-box-align: start !important;\n      -ms-flex-align: start !important;\n          align-items: start !important;\n}\n.filter-box .error-msg[data-v-39ea7e07] {\n    font-size: 13px;\n    color: #f00;\n}\n.filter-box .button[data-v-39ea7e07] {\n    line-height: 20px;\n    padding: 10px 20px;\n}\n.datepicker[data-v-39ea7e07] {\n  margin-right: 10px;\n}\n.table-box[data-v-39ea7e07] {\n  margin-top: 30px;\n  width: 100%;\n  border: 1px solid #ccc;\n  background: #fafafa;\n  border-radius: 4px;\n  overflow: hidden;\n}\n.table-box th[data-v-39ea7e07] {\n    border-bottom: 1px solid #ddd;\n    padding: 5px;\n    background: #333;\n    color: #fff;\n}\n.table-box tr[data-v-39ea7e07] {\n    text-align: center;\n}\n.table-box td[data-v-39ea7e07] {\n    padding: 7px;\n}\n.table-box tr:nth-child(odd) td[data-v-39ea7e07] {\n    background: #f3f3f3;\n}\n.table-box .empty[data-v-39ea7e07] {\n    padding: 30px;\n    font-weight: 600;\n    font-size: 28px;\n    color: #777;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Quotation/index.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;CAChB;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,oCAAoC;MAChC,iCAAiC;UAC7B,8BAA8B;CACvC;AACD;IACI,gBAAgB;IAChB,YAAY;CACf;AACD;IACI,kBAAkB;IAClB,mBAAmB;CACtB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;CAClB;AACD;IACI,8BAA8B;IAC9B,aAAa;IACb,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,mBAAmB;CACtB;AACD;IACI,aAAa;CAChB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf","file":"index.vue","sourcesContent":["\n.head[data-v-39ea7e07] {\n  height: 50px;\n  font-weight: 600;\n  color: #fff;\n  padding: 0 10px;\n  width: calc(100% - 50px);\n  margin-left: 50px;\n  font-size: 21px;\n  line-height: 50px;\n  background: #333;\n}\n.wrap-box[data-v-39ea7e07] {\n  width: 100%;\n  max-width: 1100px;\n  padding: 10px;\n  margin: 0 auto;\n}\n.filter-box[data-v-39ea7e07] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  border: 1px solid #ccc;\n  background: #fafafa;\n  padding: 15px;\n  border-radius: 4px;\n  -webkit-box-align: start !important;\n      -ms-flex-align: start !important;\n          align-items: start !important;\n}\n.filter-box .error-msg[data-v-39ea7e07] {\n    font-size: 13px;\n    color: #f00;\n}\n.filter-box .button[data-v-39ea7e07] {\n    line-height: 20px;\n    padding: 10px 20px;\n}\n.datepicker[data-v-39ea7e07] {\n  margin-right: 10px;\n}\n.table-box[data-v-39ea7e07] {\n  margin-top: 30px;\n  width: 100%;\n  border: 1px solid #ccc;\n  background: #fafafa;\n  border-radius: 4px;\n  overflow: hidden;\n}\n.table-box th[data-v-39ea7e07] {\n    border-bottom: 1px solid #ddd;\n    padding: 5px;\n    background: #333;\n    color: #fff;\n}\n.table-box tr[data-v-39ea7e07] {\n    text-align: center;\n}\n.table-box td[data-v-39ea7e07] {\n    padding: 7px;\n}\n.table-box tr:nth-child(odd) td[data-v-39ea7e07] {\n    background: #f3f3f3;\n}\n.table-box .empty[data-v-39ea7e07] {\n    padding: 30px;\n    font-weight: 600;\n    font-size: 28px;\n    color: #777;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"head"},[_vm._v("\n    Quatation Summary\n  ")]),_vm._v(" "),_c('div',{staticClass:"wrap-box"},[_c('div',{staticClass:"filter-box"},[_c('div',[_c('datepicker',{class:['datepicker inline', {'has-error':!!_vm.validation.start}],attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading},model:{value:(_vm.start),callback:function ($$v) {_vm.start=$$v},expression:"start"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.start))])],1),_vm._v(" "),_c('datepicker',{class:['datepicker inline', {'has-error':!!_vm.validation.end}],attrs:{"format":_vm.calendarFormat,"disabled-picker":_vm.loading},model:{value:(_vm.end),callback:function ($$v) {_vm.end=$$v},expression:"end"}}),_vm._v(" "),_c('button',{class:['button cta small', {disabled: _vm.loading}],attrs:{"disabeld":_vm.loading},on:{"click":_vm.getSummary}},[_vm._v("\n        Submit\n      ")])],1),_vm._v(" "),_c('table',{staticClass:"table-box",attrs:{"cellspacing":"0"}},[_vm._m(0),_vm._v(" "),_c('tbody',[(!_vm.list.length)?_c('tr',[_c('td',{staticClass:"empty",attrs:{"colspan":"3"}},[_vm._v("No record found.")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(dat){return _c('tr',[_c('td',[_vm._v(_vm._s(dat.date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(dat.count))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(dat.time)+"s")])])})],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("API Call count")]),_vm._v(" "),_c('th',[_vm._v("Duration")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadProfile_vue__ = __webpack_require__(683);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ad19dbd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadProfile_vue__ = __webpack_require__(2140);
function injectStyle (ssrContext) {
  __webpack_require__(2138)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ad19dbd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2139);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("64d8585e", content, true, {});

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n@page {\n  margin: 0;\n  size: A4;\n}\nbody {\n  background: #fff;\n}\n#side-menu, .phone-app {\n  display: none;\n}\n#prov-pdf-view {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#prov-pdf-view .page {\n    padding: 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n    background: #fff;\n}\n#prov-pdf-view .page .page-count {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#prov-pdf-view .d-name {\n    font-size: 28px;\n    font-weight: 600;\n}\n#prov-pdf-view .vehicle-no span {\n    color: #999;\n    font-weight: 600;\n}\n#prov-pdf-view .top-box {\n    border: 1px solid #ccc;\n    background: #fafafa;\n    border-radius: 4px;\n    padding: 10px;\n    margin: 10px 0 20px;\n}\n#prov-pdf-view .top-box .left {\n      text-align: left;\n}\n#prov-pdf-view .title {\n    font-weight: 600;\n    font-size: 21px;\n    margin: 50px 0 20px;\n    color: #09539f;\n}\n#prov-pdf-view .title:first-child, #prov-pdf-view .title.no-tm {\n      margin-top: 0;\n}\n#prov-pdf-view .title b {\n      color: #333;\n      margin-left: 10px;\n      text-transform: uppercase;\n}\n#prov-pdf-view .left {\n    width: 40%;\n    text-align: center;\n}\n#prov-pdf-view .img-label {\n    display: block;\n    margin: 0 0 5px;\n    font-weight: 600;\n    color: #333;\n}\n#prov-pdf-view .img-label:first-child {\n      margin-top: 0;\n}\n#prov-pdf-view .right {\n    width: 60%;\n    padding-left: 20px;\n}\n#prov-pdf-view .f-margin {\n    margin-bottom: 20px;\n}\n#prov-pdf-view .field {\n    width: 100%;\n    line-height: 1;\n}\n#prov-pdf-view .field .label {\n      font-weight: 600;\n      font-size: 12px;\n      color: #757575;\n      margin-bottom: 3px;\n      text-transform: uppercase;\n}\n#prov-pdf-view .field .value.signature {\n      padding: 10px;\n      border: 1px solid #ccc;\n      background: #eee;\n      color: #777;\n      border-radius: 4px;\n      line-height: 1;\n}\n#prov-pdf-view .field p {\n      line-height: 1.3;\n      color: #777;\n      margin: 30px 0 5px;\n      font-size: 14px;\n}\n#prov-pdf-view .field p:first-child {\n        margin-top: 0;\n}\n#prov-pdf-view .field b {\n      font-size: 18px;\n      letter-spacing: .5px;\n}\n#prov-pdf-view .out-label {\n    color: #333;\n    font-weight: 600;\n    font-size: 18x;\n    letter-spacing: .5px;\n    margin-bottom: 10px;\n    display: block;\n    border-bottom: 1px solid #ddd;\n}\n#prov-pdf-view input {\n    width: auto;\n    display: inline-block;\n    margin: 0 5px 10px 0;\n}\n#prov-pdf-view .a {\n    line-height: 1.4;\n}\n#prov-pdf-view .a input {\n      margin-bottom: 0;\n}\n#prov-pdf-view img {\n    max-height: 180px;\n}\n#prov-pdf-view .img1 {\n    max-height: 230px;\n}\n#prov-pdf-view .img10 {\n    max-height: 200px;\n}\n.df-created {\n  text-align: center;\n  letter-spacing: .6px;\n  font-size: 14px;\n  color: #777;\n  line-height: 1;\n  margin-top: 10px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Provider/DownloadProfile.vue"],"names":[],"mappings":";AACA;EACE,UAAU;EACV,SAAS;CACV;AACD;EACE,iBAAiB;CAClB;AACD;EACE,cAAc;CACf;AACD;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,eAAe;EACf,iBAAiB;CAClB;AACD;IACI,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,iBAAiB;CACpB;AACD;MACM,mBAAmB;MACnB,aAAa;MACb,YAAY;MACZ,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;CACxB;AACD;IACI,gBAAgB;IAChB,iBAAiB;CACpB;AACD;IACI,YAAY;IACZ,iBAAiB;CACpB;AACD;IACI,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;CACvB;AACD;MACM,iBAAiB;CACtB;AACD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;CAClB;AACD;MACM,cAAc;CACnB;AACD;MACM,YAAY;MACZ,kBAAkB;MAClB,0BAA0B;CAC/B;AACD;IACI,WAAW;IACX,mBAAmB;CACtB;AACD;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;CACf;AACD;MACM,cAAc;CACnB;AACD;IACI,WAAW;IACX,mBAAmB;CACtB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,YAAY;IACZ,eAAe;CAClB;AACD;MACM,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;MACnB,0BAA0B;CAC/B;AACD;MACM,cAAc;MACd,uBAAuB;MACvB,iBAAiB;MACjB,YAAY;MACZ,mBAAmB;MACnB,eAAe;CACpB;AACD;MACM,iBAAiB;MACjB,YAAY;MACZ,mBAAmB;MACnB,gBAAgB;CACrB;AACD;QACQ,cAAc;CACrB;AACD;MACM,gBAAgB;MAChB,qBAAqB;CAC1B;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,oBAAoB;IACpB,eAAe;IACf,8BAA8B;CACjC;AACD;IACI,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;CACxB;AACD;IACI,iBAAiB;CACpB;AACD;MACM,iBAAiB;CACtB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,kBAAkB;CACrB;AACD;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;CAClB","file":"DownloadProfile.vue","sourcesContent":["\n@page {\n  margin: 0;\n  size: A4;\n}\nbody {\n  background: #fff;\n}\n#side-menu, .phone-app {\n  display: none;\n}\n#prov-pdf-view {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 793px;\n  height: 1122px;\n  background: #fff;\n}\n#prov-pdf-view .page {\n    padding: 30px;\n    position: relative;\n    width: 100%;\n    height: 100%;\n    background: #fff;\n}\n#prov-pdf-view .page .page-count {\n      position: absolute;\n      bottom: 10px;\n      right: 30px;\n      color: #aaa;\n      font-size: 12px;\n      text-align: right;\n      font-style: italic;\n}\n#prov-pdf-view .d-name {\n    font-size: 28px;\n    font-weight: 600;\n}\n#prov-pdf-view .vehicle-no span {\n    color: #999;\n    font-weight: 600;\n}\n#prov-pdf-view .top-box {\n    border: 1px solid #ccc;\n    background: #fafafa;\n    border-radius: 4px;\n    padding: 10px;\n    margin: 10px 0 20px;\n}\n#prov-pdf-view .top-box .left {\n      text-align: left;\n}\n#prov-pdf-view .title {\n    font-weight: 600;\n    font-size: 21px;\n    margin: 50px 0 20px;\n    color: #09539f;\n}\n#prov-pdf-view .title:first-child, #prov-pdf-view .title.no-tm {\n      margin-top: 0;\n}\n#prov-pdf-view .title b {\n      color: #333;\n      margin-left: 10px;\n      text-transform: uppercase;\n}\n#prov-pdf-view .left {\n    width: 40%;\n    text-align: center;\n}\n#prov-pdf-view .img-label {\n    display: block;\n    margin: 0 0 5px;\n    font-weight: 600;\n    color: #333;\n}\n#prov-pdf-view .img-label:first-child {\n      margin-top: 0;\n}\n#prov-pdf-view .right {\n    width: 60%;\n    padding-left: 20px;\n}\n#prov-pdf-view .f-margin {\n    margin-bottom: 20px;\n}\n#prov-pdf-view .field {\n    width: 100%;\n    line-height: 1;\n}\n#prov-pdf-view .field .label {\n      font-weight: 600;\n      font-size: 12px;\n      color: #757575;\n      margin-bottom: 3px;\n      text-transform: uppercase;\n}\n#prov-pdf-view .field .value.signature {\n      padding: 10px;\n      border: 1px solid #ccc;\n      background: #eee;\n      color: #777;\n      border-radius: 4px;\n      line-height: 1;\n}\n#prov-pdf-view .field p {\n      line-height: 1.3;\n      color: #777;\n      margin: 30px 0 5px;\n      font-size: 14px;\n}\n#prov-pdf-view .field p:first-child {\n        margin-top: 0;\n}\n#prov-pdf-view .field b {\n      font-size: 18px;\n      letter-spacing: .5px;\n}\n#prov-pdf-view .out-label {\n    color: #333;\n    font-weight: 600;\n    font-size: 18x;\n    letter-spacing: .5px;\n    margin-bottom: 10px;\n    display: block;\n    border-bottom: 1px solid #ddd;\n}\n#prov-pdf-view input {\n    width: auto;\n    display: inline-block;\n    margin: 0 5px 10px 0;\n}\n#prov-pdf-view .a {\n    line-height: 1.4;\n}\n#prov-pdf-view .a input {\n      margin-bottom: 0;\n}\n#prov-pdf-view img {\n    max-height: 180px;\n}\n#prov-pdf-view .img1 {\n    max-height: 230px;\n}\n#prov-pdf-view .img10 {\n    max-height: 200px;\n}\n.df-created {\n  text-align: center;\n  letter-spacing: .6px;\n  font-size: 14px;\n  color: #777;\n  line-height: 1;\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"prov-pdf-view"}},[_c('div',{staticClass:"page page1"},[_c('div',{staticClass:"title"},[_vm._v("VEHICLE INFORMATION:")]),_vm._v(" "),_c('div',{staticClass:"d-flex f-margin"},[_c('div',{staticClass:"left"},[(_vm.vehicleInfo.img)?_c('img',{staticClass:"img2",attrs:{"src":_vm.vehicleInfo.img}}):_c('img',{attrs:{"src":_vm.noPhotoUrl}})]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"d-flex f-margin"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("MANUFACTURER")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.vehicleInfo.manufacturer))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("MODEL")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.vehicleInfo.model))])])]),_vm._v(" "),_c('div',{staticClass:"d-flex f-margin"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("YEAR")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.vehicleInfo.year))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("VEHICLE TYPE")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.vehicleInfo.type || '--'))])])]),_vm._v(" "),_c('div',{staticClass:"d-flex f-margin"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("LICENSE PLATE")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.vehicleInfo.licensePlate))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("VEHICLE IDENTIFICATION NUMBER")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.vehicleInfo.identificationNumber))])])]),_vm._v(" "),_c('div',{staticClass:"d-flex f-margin"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("DOOR")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.vehicleInfo.door))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("CAPACITY")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.vehicleInfo.capacity))])])]),_vm._v(" "),_c('div',{},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.vehicleInfo.wheelchair}}),_vm._v("\n            Equipped with wheelchair lift.\n          ")]),_vm._v(" "),_c('div',{staticClass:"f-margin"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.vehicleInfo.serviceDog}}),_vm._v("\n            Can accommodate a service dog.\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"left"},[(_vm.documentation.vehicleRegistrationImg)?_c('img',{staticClass:"img3",attrs:{"src":_vm.documentation.vehicleRegistrationImg}}):_c('img',{attrs:{"src":_vm.noPhotoUrl}})]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"out-label"},[_vm._v("VEHICLE REGISTRATION")]),_vm._v(" "),_c('div',{staticClass:"field f-margin"},[_c('div',{staticClass:"label"},[_vm._v("EXP. DATE")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.documentation.vehicleRegistrationExp || '--'))])])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n        ACCOUNT TYPE:\n        "),_c('b',[_vm._v(_vm._s(_vm.accountType.type))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("BUSINESS INFORMATION:")]),_vm._v(" "),_c('div',{staticClass:"d-flex f-margin"},[_c('div',{staticClass:"left"},[(_vm.businessInfo.type === 'Sole Proprietorship')?_c('div',[_c('div',{staticClass:"img-label"},[_vm._v("SSN image")]),_vm._v(" "),(_vm.businessInfo.ssnImg)?_c('img',{staticClass:"img4",attrs:{"src":_vm.businessInfo.ssnImg}}):_c('img',{attrs:{"src":_vm.noPhotoUrl}})]):_c('div',[_c('div',{staticClass:"img-label"},[_vm._v("EIN image")]),_vm._v(" "),(_vm.businessInfo.einImg)?_c('img',{staticClass:"img4",attrs:{"src":_vm.businessInfo.einImg}}):_c('img',{attrs:{"src":_vm.noPhotoUrl}}),_vm._v(" "),_c('div',{staticClass:"img-label",staticStyle:{"margin-top":"20px"}},[_vm._v("W-9 FORM")]),_vm._v(" "),(_vm.businessInfo.w9fileImg)?_c('img',{staticClass:"img4",attrs:{"src":_vm.businessInfo.w9fileImg}}):_c('img',{attrs:{"src":_vm.noPhotoUrl}})])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"d-flex f-margin"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("BUSINESS NAME")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.businessInfo.name))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("TYPE OF BUSINESS")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.businessInfo.type))])])]),_vm._v(" "),_c('div',{staticClass:"d-flex f-margin"},[(_vm.businessInfo.type === 'Sole Proprietorship')?_c('div',{staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("SOCIAL SECURITY NUMBER (SSN)")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.businessInfo.ssn || '--'))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("EMPLOYER ID NUMBER (EIN)")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.businessInfo.ein || '--'))])])]),_vm._v(" "),_c('div',{staticClass:"d-flex f-margin"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("ADDRESS")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.businessInfo.address1 || '--'))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("ADDRESS 2")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.businessInfo.address2 || '--'))])])]),_vm._v(" "),_c('div',{staticClass:"d-flex f-margin"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("CITY")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.businessInfo.city))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("COUNTRY")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.businessInfo.country))])])]),_vm._v(" "),_c('div',{staticClass:"d-flex f-margin"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.businessInfo.country === 'United States'),expression:"businessInfo.country === 'United States'"}],staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("STATE")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.businessInfo.state))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("ZIP")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.businessInfo.zip))])])])])])]),_vm._v(" "),_c('div',{staticClass:"page page2"},[(_vm.businessInfo.type === 'Sole Proprietorship')?_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"img-label"},[_vm._v("EIN image")]),_vm._v(" "),(_vm.businessInfo.einImg)?_c('img',{staticClass:"img4",attrs:{"src":_vm.businessInfo.einImg}}):_c('img',{attrs:{"src":_vm.noPhotoUrl}})]),_vm._v(" "),_c('div',{staticClass:"right text-center"},[_c('div',{staticClass:"img-label"},[_vm._v("W-9 FORM")]),_vm._v(" "),(_vm.businessInfo.w9fileImg)?_c('img',{staticClass:"img4",attrs:{"src":_vm.businessInfo.w9fileImg}}):_c('img',{attrs:{"src":_vm.noPhotoUrl}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("DOCUMENTATION")]),_vm._v(" "),_c('div',{staticClass:"d-flex f-margin"},[_c('div',{staticClass:"left"},[(_vm.documentation.insuranceImg)?_c('img',{staticClass:"img5",attrs:{"src":_vm.documentation.insuranceImg}}):_c('img',{attrs:{"src":_vm.noPhotoUrl}})]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"field f-margin"},[_c('div',{staticClass:"label"},[_vm._v("INSURANCE COMPANY NAME")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.documentation.insuranceCompany || '--'))])]),_vm._v(" "),_c('div',{staticClass:"field f-margin"},[_c('div',{staticClass:"label"},[_vm._v("INSURANCE POLICY #")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.documentation.insurancePolicy || '--'))])]),_vm._v(" "),_c('div',{staticClass:"field f-margin"},[_c('div',{staticClass:"label"},[_vm._v("EXP. DATE")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.documentation.insuranceExp || '--'))])])])]),_vm._v(" "),_c('div',{staticClass:"d-flex f-margin"},[_c('div',{staticClass:"left"},[(_vm.documentation.cityLicenseImg)?_c('img',{staticClass:"img6",attrs:{"src":_vm.documentation.cityLicenseImg}}):_c('img',{attrs:{"src":_vm.noPhotoUrl}})]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"field f-margin"},[_c('div',{staticClass:"label"},[_vm._v("CITY LICENSE #")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.documentation.cityLicense || '--'))])]),_vm._v(" "),_c('div',{staticClass:"field f-margin"},[_c('div',{staticClass:"label"},[_vm._v("EXP. DATE")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.documentation.cityLicenseExp || '--'))])])])]),_vm._v(" "),(_vm.accountType.type === 'tcp')?_c('div',{staticClass:"d-flex f-margin"},[_c('div',{staticClass:"left"},[(_vm.documentation.tcpPermitImg)?_c('img',{staticClass:"img6",attrs:{"src":_vm.documentation.tcpPermitImg}}):_c('img',{attrs:{"src":_vm.noPhotoUrl}})]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"field f-margin"},[_c('div',{staticClass:"label"},[_vm._v("TCP PERMIT #")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.documentation.tcpPermit || '--'))])]),_vm._v(" "),_c('div',{staticClass:"field f-margin"},[_c('div',{staticClass:"label"},[_vm._v("EXP. DATE")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.documentation.tcpPermitExp || '--'))])])])]):_vm._e(),_vm._v(" "),(_vm.accountType.type === 'tcp')?_c('div',{staticClass:"d-flex f-margin"},[_c('div',{staticClass:"left"},[(_vm.documentation.airportPermitImg)?_c('img',{staticClass:"img6",attrs:{"src":_vm.documentation.airportPermitImg}}):_c('img',{attrs:{"src":_vm.noPhotoUrl}})]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"field f-margin"},[_c('div',{staticClass:"label"},[_vm._v("AIRPORT PERMIT #")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.documentation.airportPermit || '--'))])]),_vm._v(" "),_c('div',{staticClass:"field f-margin"},[_c('div',{staticClass:"label"},[_vm._v("EXP. DATE")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.documentation.airportPermitExp || '--'))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex f-margin"},[_c('div',{staticClass:"left"},[(_vm.documentation.vehicleInspectionImg)?_c('img',{staticClass:"img8",attrs:{"src":_vm.documentation.vehicleInspectionImg}}):_c('img',{attrs:{"src":_vm.noPhotoUrl}})]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"field f-margin"},[_c('div',{staticClass:"label"},[_vm._v("VEHICLE SAFETY INSPECTION PERFORMED BY")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.documentation.vehicleInspection || '--'))])]),_vm._v(" "),_c('div',{staticClass:"field f-margin"},[_c('div',{staticClass:"label"},[_vm._v("EXP. DATE")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.documentation.vehicleInspectionExp || '--'))])])])])]),_vm._v(" "),_c('div',{staticClass:"page page3"},[_c('div',{staticClass:"title"},[_vm._v("ELIGIBILITY:")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('p',[_vm._v("HAVE YOU BEEN CONVICTED, WITHIN THE PAST 7 YEARS, OF DRIVING UNDER THE INFLUENCE OF DRUGS OR ALCOHOL, FRAUD, SEXUAL OFFENSES, USE OF A MOTOR VEHICLE TO COMMIT A FELONY, A CRIME INVOLVING PROPERTY DAMAGE AND/OR THEFT, ACTS OF VIOLENCE, OR ACTS OF TERROR?")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.eligibility.convicted ? 'YES' : 'NO'))]),_vm._v(" "),_c('p',[_vm._v("HAVE YOU EVER HAD A CONVICTION FOR RECKLESS DRIVING, DRIVING UNDER THE INFLUENCE, HIT AND RUN, OR DRIVING WITH A SUSPENDED OR REVOKED LICENSE?")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.eligibility.conviction ? 'YES' : 'NO'))]),_vm._v(" "),_c('p',[_vm._v("DO YOU PERSONALLY OWN THIS VEHICLE?")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.eligibility.ownVehicle ? 'YES' : 'NO'))]),_vm._v(" "),_c('p',[_vm._v("HAS THIS VEHICLE EVER BEEN SIGNIFICANTLY MODIFIED FROM FACTORY SPECIFICATIONS (E.G. \"STRETCH VEHICLE\", MADE NOT STREET LEGAL, ETC.)?")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.eligibility.modifiedVehicle ? 'YES' : 'NO'))]),_vm._v(" "),_c('p',[_vm._v("HAVE YOU HAD YOUR DRIVER'S LICENSE FOR AT LEAST 2 YEARS?")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.eligibility.driversLicense ? 'YES' : 'NO'))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("AGREEMENTS:")]),_vm._v(" "),_c('div',{staticClass:"field"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"f-margin a"},[_c('input',{attrs:{"type":"checkbox","checked":""}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('provider.agreements.agree', _vm.aggreementsLink))}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"label"},[_vm._v("SIGNATURE")]),_vm._v(" "),_c('div',{staticClass:"value signature"},[_vm._v(_vm._s(_vm.signature))]),_vm._v(" "),_c('div',{staticClass:"df-created"},[_vm._v(_vm._s(_vm.created))])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-margin a"},[_c('input',{attrs:{"type":"checkbox","checked":""}}),_vm._v("\n          I declare under penalty of perjury under the laws of the State of California that I am the driver listed on this application all of the information provided herein is true and correct.\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(684);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_271d2a67_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2152);
function injectStyle (ssrContext) {
  __webpack_require__(2142)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-271d2a67"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_271d2a67_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2143);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1fb7f726", content, true, {});

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.head[data-v-271d2a67] {\n  height: 50px;\n  font-weight: 600;\n  color: #fff;\n  padding: 0 10px;\n  width: calc(100% - 50px);\n  margin-left: 50px;\n  font-size: 21px;\n  line-height: 50px;\n  background: #333;\n}\n.wrap-box[data-v-271d2a67] {\n  width: 100%;\n  max-width: 1100px;\n  padding: 10px;\n  margin: 0 auto;\n}\n.stats[data-v-271d2a67] {\n  background: #fafafa;\n  border: 1px solid #ccc;\n  margin-top: 30px;\n  font-size: 14px;\n  letter-spacing: .7px;\n  border-radius: 2px;\n}\n.stats div[data-v-271d2a67] {\n    padding: 5px 10px;\n}\n.stats span[data-v-271d2a67] {\n    font-weight: 600;\n    display: inline-block;\n}\n.table-box[data-v-271d2a67] {\n  margin-top: 10px;\n  width: 100%;\n  border: 1px solid #ccc;\n  background: #fafafa;\n  border-radius: 4px;\n  overflow: hidden;\n}\n.table-box th[data-v-271d2a67] {\n    border-bottom: 1px solid #ddd;\n    padding: 5px;\n    background: #333;\n    color: #fff;\n}\n.table-box tr[data-v-271d2a67] {\n    text-align: center;\n}\n.table-box tr:hover td[data-v-271d2a67] {\n      background: #eaeaea !important;\n}\n.table-box td[data-v-271d2a67] {\n    padding: 7px;\n    font-size: 14px;\n}\n.table-box tr:nth-child(odd) td[data-v-271d2a67] {\n    background: #f3f3f3;\n}\n.table-box .empty[data-v-271d2a67] {\n    padding: 30px;\n    font-weight: 600;\n    font-size: 28px;\n    color: #777;\n}\n.table-box .check[data-v-271d2a67] {\n    width: 50px;\n}\n.table-box input[data-v-271d2a67] {\n    margin: 0;\n}\n.table-box .rsvp[data-v-271d2a67] {\n    display: inline-block;\n    margin: 2px 5px;\n}\n.table-box .fulfilled[data-v-271d2a67] {\n    color: #17bb2b;\n    font-weight: 600;\n    letter-spacing: .6px;\n}\n.table-box .void[data-v-271d2a67] {\n    letter-spacing: .7px;\n    font-size: 13px;\n    background: #333;\n    color: #fff;\n    padding: 2px 5px;\n    border-radius: 2px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Airtag/index.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;CAChB;AACD;EACE,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;CACpB;AACD;IACI,kBAAkB;CACrB;AACD;IACI,iBAAiB;IACjB,sBAAsB;CACzB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;CAClB;AACD;IACI,8BAA8B;IAC9B,aAAa;IACb,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,mBAAmB;CACtB;AACD;MACM,+BAA+B;CACpC;AACD;IACI,aAAa;IACb,gBAAgB;CACnB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;IACI,YAAY;CACf;AACD;IACI,UAAU;CACb;AACD;IACI,sBAAsB;IACtB,gBAAgB;CACnB;AACD;IACI,eAAe;IACf,iBAAiB;IACjB,qBAAqB;CACxB;AACD;IACI,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;CACtB","file":"index.vue","sourcesContent":["\n.head[data-v-271d2a67] {\n  height: 50px;\n  font-weight: 600;\n  color: #fff;\n  padding: 0 10px;\n  width: calc(100% - 50px);\n  margin-left: 50px;\n  font-size: 21px;\n  line-height: 50px;\n  background: #333;\n}\n.wrap-box[data-v-271d2a67] {\n  width: 100%;\n  max-width: 1100px;\n  padding: 10px;\n  margin: 0 auto;\n}\n.stats[data-v-271d2a67] {\n  background: #fafafa;\n  border: 1px solid #ccc;\n  margin-top: 30px;\n  font-size: 14px;\n  letter-spacing: .7px;\n  border-radius: 2px;\n}\n.stats div[data-v-271d2a67] {\n    padding: 5px 10px;\n}\n.stats span[data-v-271d2a67] {\n    font-weight: 600;\n    display: inline-block;\n}\n.table-box[data-v-271d2a67] {\n  margin-top: 10px;\n  width: 100%;\n  border: 1px solid #ccc;\n  background: #fafafa;\n  border-radius: 4px;\n  overflow: hidden;\n}\n.table-box th[data-v-271d2a67] {\n    border-bottom: 1px solid #ddd;\n    padding: 5px;\n    background: #333;\n    color: #fff;\n}\n.table-box tr[data-v-271d2a67] {\n    text-align: center;\n}\n.table-box tr:hover td[data-v-271d2a67] {\n      background: #eaeaea !important;\n}\n.table-box td[data-v-271d2a67] {\n    padding: 7px;\n    font-size: 14px;\n}\n.table-box tr:nth-child(odd) td[data-v-271d2a67] {\n    background: #f3f3f3;\n}\n.table-box .empty[data-v-271d2a67] {\n    padding: 30px;\n    font-weight: 600;\n    font-size: 28px;\n    color: #777;\n}\n.table-box .check[data-v-271d2a67] {\n    width: 50px;\n}\n.table-box input[data-v-271d2a67] {\n    margin: 0;\n}\n.table-box .rsvp[data-v-271d2a67] {\n    display: inline-block;\n    margin: 2px 5px;\n}\n.table-box .fulfilled[data-v-271d2a67] {\n    color: #17bb2b;\n    font-weight: 600;\n    letter-spacing: .6px;\n}\n.table-box .void[data-v-271d2a67] {\n    letter-spacing: .7px;\n    font-size: 13px;\n    background: #333;\n    color: #fff;\n    padding: 2px 5px;\n    border-radius: 2px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generate_vue__ = __webpack_require__(685);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0195afbc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generate_vue__ = __webpack_require__(2147);
function injectStyle (ssrContext) {
  __webpack_require__(2145)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0195afbc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0195afbc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2146);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("731848de", content, true, {});

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.lr-modal[data-v-0195afbc] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-0195afbc] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-0195afbc] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  min-width: 300px;\n  max-width: 500px;\n}\n.header[data-v-0195afbc] {\n  color: #45505b;\n  font-size: 18px;\n  font-weight: 600;\n}\n.button[data-v-0195afbc] {\n  margin-bottom: 10px;\n}\n.cta[data-v-0195afbc] {\n  cursor: pointer;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Airtag/generate.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oCAAoC;MAChC,iCAAiC;UAC7B,mCAAmC;EAC3C,qCAAqC;MACjC,kCAAkC;UAC9B,+BAA+B;EACvC,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;EACnD,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;CAClB;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;CAClB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,gBAAgB;CACjB","file":"generate.vue","sourcesContent":["\n.lr-modal[data-v-0195afbc] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-0195afbc] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-0195afbc] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  min-width: 300px;\n  max-width: 500px;\n}\n.header[data-v-0195afbc] {\n  color: #45505b;\n  font-size: 18px;\n  font-weight: 600;\n}\n.button[data-v-0195afbc] {\n  margin-bottom: 10px;\n}\n.cta[data-v-0195afbc] {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['lr-modal', {'hide': !_vm.show}]},[_c('div',{staticClass:"lr-box"},[_c('div',{staticClass:"header"},[_vm._v("Generate Codes")]),_vm._v(" "),_c('label',[_vm._v("How many codes to generate")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.count),expression:"count"}],attrs:{"type":"number"},domProps:{"value":(_vm.count)},on:{"keypress":_vm.isNumber,"input":function($event){if($event.target.composing){ return; }_vm.count=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticClass:"button cta small success block",on:{"click":_vm.generate}},[_vm._v("\n      Generate\n    ")]),_vm._v(" "),_c('a',{staticClass:"cta small block",on:{"click":function($event){_vm.show = false}}},[_vm._v("\n      Close\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirm_vue__ = __webpack_require__(686);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85cd6f00_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirm_vue__ = __webpack_require__(2151);
function injectStyle (ssrContext) {
  __webpack_require__(2149)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-85cd6f00"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85cd6f00_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2150);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("960cf47a", content, true, {});

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.lr-modal[data-v-85cd6f00] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-85cd6f00] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-85cd6f00] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  width: 300px;\n}\nlabel[data-v-85cd6f00] {\n  margin-bottom: 20px;\n  display: block;\n}\n.button[data-v-85cd6f00] {\n  margin-bottom: 10px;\n}\n.cta[data-v-85cd6f00] {\n  cursor: pointer;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Airtag/confirm.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oCAAoC;MAChC,iCAAiC;UAC7B,mCAAmC;EAC3C,qCAAqC;MACjC,kCAAkC;UAC9B,+BAA+B;EACvC,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;EACnD,mBAAmB;EACnB,aAAa;CACd;AACD;EACE,oBAAoB;EACpB,eAAe;CAChB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,gBAAgB;CACjB","file":"confirm.vue","sourcesContent":["\n.lr-modal[data-v-85cd6f00] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-85cd6f00] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-85cd6f00] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  width: 300px;\n}\nlabel[data-v-85cd6f00] {\n  margin-bottom: 20px;\n  display: block;\n}\n.button[data-v-85cd6f00] {\n  margin-bottom: 10px;\n}\n.cta[data-v-85cd6f00] {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['lr-modal', {'hide': !_vm.show}]},[_c('div',{staticClass:"lr-box"},[_c('label',[_vm._v("Are you sure you want to "),_c('b',[_vm._v(_vm._s(_vm.action))]),_vm._v(" the selected items?")]),_vm._v(" "),_c('a',{staticClass:"button cta small success block",on:{"click":_vm.confirm}},[_vm._v("\n      Confirm\n    ")]),_vm._v(" "),_c('a',{staticClass:"cta small block",on:{"click":function($event){_vm.show = false}}},[_vm._v("\n      Close\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"head"},[_vm._v("\n    Airtag List\n  ")]),_vm._v(" "),_c('div',{staticClass:"wrap-box"},[_c('div',{staticClass:"action d-flex justify-space-between align-center"},[_c('div',[_c('button',{staticClass:"button cta small",on:{"click":function($event){return _vm.getList(false)}}},[_c('i',{staticClass:"fas fa-redo fa-fw"}),_vm._v(" Refresh\n        ")]),_vm._v(" "),_c('button',{staticClass:"button cta small",on:{"click":_vm.showGenerateModal}},[_c('i',{staticClass:"fas fa-plus fa-fw"}),_vm._v(" Generate Codes\n        ")]),_vm._v(" "),_c('button',{staticClass:"button cta small success",on:{"click":function($event){return _vm.getList(true)}}},[_vm._v("\n          Export\n        ")])]),_vm._v(" "),_c('div',[_c('button',{staticClass:"button cta small error",on:{"click":function($event){return _vm.confirm('void')}}},[_vm._v("\n          Void\n        ")]),_vm._v(" "),_c('button',{staticClass:"button cta small success",on:{"click":function($event){return _vm.confirm('fulfill')}}},[_vm._v("\n          Fulfill\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"stats d-flex justify-space-between align-center"},[_c('div',[_c('label',[_vm._v("Total:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.total))])]),_vm._v(" "),_c('div',[_c('label',[_vm._v("Emailed:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.emailed))])]),_vm._v(" "),_c('div',[_c('label',[_vm._v("Redeem:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.redeem))])]),_vm._v(" "),_c('div',[_c('label',[_vm._v("Fulfilled:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.fulfilled))])]),_vm._v(" "),_c('div',[_c('label',[_vm._v("Voided:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.voided))])])]),_vm._v(" "),_c('table',{staticClass:"table-box",attrs:{"cellspacing":"0"}},[_vm._m(0),_vm._v(" "),_c('tbody',[(!_vm.list.length)?_c('tr',[_c('td',{staticClass:"empty",attrs:{"colspan":"8"}},[_vm._v("No record found.")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(dat){return _c('tr',[_c('td',{staticClass:"check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],attrs:{"type":"checkbox"},domProps:{"value":dat.id,"checked":Array.isArray(_vm.selected)?_vm._i(_vm.selected,dat.id)>-1:(_vm.selected)},on:{"change":function($event){var $$a=_vm.selected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=dat.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selected=$$c}}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(dat.code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(dat.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(dat.phone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(dat.address))]),_vm._v(" "),_c('td',[(!dat.rsvp.length)?_c('span',[_vm._v("--")]):_c('span',_vm._l((dat.rsvp),function(rsvp,r){return _c('a',{key:r,staticClass:"rsvp",attrs:{"href":("#/reservation/" + rsvp),"target":"_blank"}},[_vm._v(_vm._s(rsvp))])}),0)]),_vm._v(" "),_c('td',{class:{'fulfilled':dat.fulfill !== '--'}},[_vm._v(_vm._s(dat.fulfill))]),_vm._v(" "),_c('td',[(dat.voided)?_c('span',{staticClass:"void"},[_vm._v("VOID")]):_vm._e()])])})],2)])]),_vm._v(" "),_c('generate',{ref:"generate",on:{"refreshList":_vm.getList}}),_vm._v(" "),_c('confirm',{ref:"confirm",attrs:{"action":_vm.action},on:{"proceed":_vm.proceed}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Code")]),_vm._v(" "),_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Phone")]),_vm._v(" "),_c('th',[_vm._v("Mailing Address")]),_vm._v(" "),_c('th',[_vm._v("RSVP")]),_vm._v(" "),_c('th',[_vm._v("Fulfill")]),_vm._v(" "),_c('th')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(687);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e327e8b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2164);
function injectStyle (ssrContext) {
  __webpack_require__(2154)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e327e8b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e327e8b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2155);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4ad63037", content, true, {});

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.header[data-v-6e327e8b] {\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.ins-body[data-v-6e327e8b] {\n  padding: 20px;\n}\n.table-box[data-v-6e327e8b] {\n  margin-top: 30px;\n  width: 100%;\n  border: 1px solid #333;\n  background: #fafafa;\n  border-radius: 4px;\n  overflow: hidden;\n}\n.table-box th[data-v-6e327e8b] {\n    border-bottom: 1px solid #ddd;\n    padding: 5px;\n    background: #333;\n    color: #fff;\n}\n.table-box tr[data-v-6e327e8b] {\n    text-align: center;\n}\n.table-box td[data-v-6e327e8b] {\n    font-size: 14px;\n    padding: 7px;\n}\n.table-box tr:nth-child(odd) td[data-v-6e327e8b] {\n    background: #f3f3f3;\n}\n.table-box .empty[data-v-6e327e8b] {\n    padding: 30px;\n    font-weight: 600;\n    font-size: 28px;\n    color: #777;\n}\n.fa-link[data-v-6e327e8b] {\n  color: #3083f0;\n}\n.status[data-v-6e327e8b] {\n  font-size: 12px;\n  letter-spacing: .3px;\n  padding: 3px 10px;\n  background: #333;\n  color: #fff;\n  border-radius: 3px;\n  text-transform: uppercase;\n  display: inline-block;\n  font-family: monospace;\n}\n.status.ready[data-v-6e327e8b] {\n    color: #3a92e4;\n    border: 1px solid #3a92e4;\n    background: #cfe8ff;\n}\n.status.creating[data-v-6e327e8b] {\n    color: #cbaf17;\n    border: 1px solid #cbaf17;\n    background: #fdf9e3;\n}\n.status.uploaded[data-v-6e327e8b] {\n    color: #16bb48;\n    background: #c1ffd4;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.status.error[data-v-6e327e8b] {\n    color: #df2323;\n    background: #ffb1b1;\n    border: 1px solid #df2323;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Insurance/index.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,6CAA6C;CAC9C;AACD;EACE,cAAc;CACf;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;CAClB;AACD;IACI,8BAA8B;IAC9B,aAAa;IACb,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,mBAAmB;CACtB;AACD;IACI,gBAAgB;IAChB,aAAa;CAChB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;EACE,eAAe;CAChB;AACD;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;CACxB;AACD;IACI,eAAe;IACf,0BAA0B;IAC1B,oBAAoB;CACvB;AACD;IACI,eAAe;IACf,0BAA0B;IAC1B,oBAAoB;CACvB;AACD;IACI,eAAe;IACf,oBAAoB;IACpB,qCAAqC;CACxC;AACD;IACI,eAAe;IACf,oBAAoB;IACpB,0BAA0B;CAC7B","file":"index.vue","sourcesContent":["\n.header[data-v-6e327e8b] {\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n.ins-body[data-v-6e327e8b] {\n  padding: 20px;\n}\n.table-box[data-v-6e327e8b] {\n  margin-top: 30px;\n  width: 100%;\n  border: 1px solid #333;\n  background: #fafafa;\n  border-radius: 4px;\n  overflow: hidden;\n}\n.table-box th[data-v-6e327e8b] {\n    border-bottom: 1px solid #ddd;\n    padding: 5px;\n    background: #333;\n    color: #fff;\n}\n.table-box tr[data-v-6e327e8b] {\n    text-align: center;\n}\n.table-box td[data-v-6e327e8b] {\n    font-size: 14px;\n    padding: 7px;\n}\n.table-box tr:nth-child(odd) td[data-v-6e327e8b] {\n    background: #f3f3f3;\n}\n.table-box .empty[data-v-6e327e8b] {\n    padding: 30px;\n    font-weight: 600;\n    font-size: 28px;\n    color: #777;\n}\n.fa-link[data-v-6e327e8b] {\n  color: #3083f0;\n}\n.status[data-v-6e327e8b] {\n  font-size: 12px;\n  letter-spacing: .3px;\n  padding: 3px 10px;\n  background: #333;\n  color: #fff;\n  border-radius: 3px;\n  text-transform: uppercase;\n  display: inline-block;\n  font-family: monospace;\n}\n.status.ready[data-v-6e327e8b] {\n    color: #3a92e4;\n    border: 1px solid #3a92e4;\n    background: #cfe8ff;\n}\n.status.creating[data-v-6e327e8b] {\n    color: #cbaf17;\n    border: 1px solid #cbaf17;\n    background: #fdf9e3;\n}\n.status.uploaded[data-v-6e327e8b] {\n    color: #16bb48;\n    background: #c1ffd4;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.status.error[data-v-6e327e8b] {\n    color: #df2323;\n    background: #ffb1b1;\n    border: 1px solid #df2323;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateModal_vue__ = __webpack_require__(688);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6a49ff6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateModal_vue__ = __webpack_require__(2159);
function injectStyle (ssrContext) {
  __webpack_require__(2157)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c6a49ff6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6a49ff6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2158);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2c6a5194", content, true, {});

/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.lr-modal[data-v-c6a49ff6] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-c6a49ff6] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-c6a49ff6] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  width: 460px;\n  line-height: 1;\n}\n.ins-field[data-v-c6a49ff6] {\n  margin-bottom: 20px;\n  text-align: left;\n}\n.ins-field label[data-v-c6a49ff6] {\n    letter-spacing: .4px;\n    font-size: 14px;\n    color: #777;\n    line-height: 1;\n    text-transform: uppercase;\n}\n.error-msg[data-v-c6a49ff6] {\n  line-height: 1;\n  display: block;\n  font-size: 14px;\n  color: #e34545;\n  margin-top: 3px;\n}\ninput[data-v-c6a49ff6] {\n  margin: 5px 0 0;\n}\n.button.success[data-v-c6a49ff6] {\n  margin-top: 20px;\n}\n.button.secondary[data-v-c6a49ff6] {\n  margin-top: 10px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Insurance/CreateModal.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oCAAoC;MAChC,iCAAiC;UAC7B,mCAAmC;EAC3C,qCAAqC;MACjC,kCAAkC;UAC9B,+BAA+B;EACvC,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;EACnD,mBAAmB;EACnB,aAAa;EACb,eAAe;CAChB;AACD;EACE,oBAAoB;EACpB,iBAAiB;CAClB;AACD;IACI,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,0BAA0B;CAC7B;AACD;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;CACjB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,iBAAiB;CAClB","file":"CreateModal.vue","sourcesContent":["\n.lr-modal[data-v-c6a49ff6] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-c6a49ff6] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-c6a49ff6] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  width: 460px;\n  line-height: 1;\n}\n.ins-field[data-v-c6a49ff6] {\n  margin-bottom: 20px;\n  text-align: left;\n}\n.ins-field label[data-v-c6a49ff6] {\n    letter-spacing: .4px;\n    font-size: 14px;\n    color: #777;\n    line-height: 1;\n    text-transform: uppercase;\n}\n.error-msg[data-v-c6a49ff6] {\n  line-height: 1;\n  display: block;\n  font-size: 14px;\n  color: #e34545;\n  margin-top: 3px;\n}\ninput[data-v-c6a49ff6] {\n  margin: 5px 0 0;\n}\n.button.success[data-v-c6a49ff6] {\n  margin-top: 20px;\n}\n.button.secondary[data-v-c6a49ff6] {\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['lr-modal', {'hide': !_vm.insurance.showCreate}]},[_c('div',{staticClass:"lr-box"},[_c('div',{staticClass:"d-flex justify-space-between align-start"},[_c('div',{staticClass:"ins-field"},[_c('label',[_vm._v("Start Date")]),_vm._v(" "),_c('datepicker',{class:['datepicker inline', {'has-error':!!_vm.validation.start}],attrs:{"format":_vm.calendarFormat},model:{value:(_vm.start),callback:function ($$v) {_vm.start=$$v},expression:"start"}}),_vm._v(" "),(_vm.validation.start)?_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.start))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"ins-field"},[_c('label',[_vm._v("END Date")]),_vm._v(" "),_c('datepicker',{class:['datepicker inline', {'has-error':!!_vm.validation.end}],attrs:{"format":_vm.calendarFormat},model:{value:(_vm.end),callback:function ($$v) {_vm.end=$$v},expression:"end"}}),_vm._v(" "),(_vm.validation.end)?_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.end))]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"ins-field"},[_c('label',[_vm._v("Miles per day")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.miles),expression:"miles"}],attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.miles)},on:{"input":function($event){if($event.target.composing){ return; }_vm.miles=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"ins-field"},[_c('label',[_vm._v("Whitelist")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.whitelist),expression:"whitelist"}],attrs:{"type":"text","placeholder":"e.g. 12345, 67"},domProps:{"value":(_vm.whitelist)},on:{"input":function($event){if($event.target.composing){ return; }_vm.whitelist=$event.target.value}}})]),_vm._v(" "),_c('a',{staticClass:"button cta success block",on:{"click":_vm.create}},[_vm._v("Create")]),_vm._v(" "),_c('a',{staticClass:"button cta block secondary",on:{"click":_vm.cancel}},[_vm._v("Cancel")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmUpload_vue__ = __webpack_require__(689);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e63a0eb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmUpload_vue__ = __webpack_require__(2163);
function injectStyle (ssrContext) {
  __webpack_require__(2161)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e63a0eb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e63a0eb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2162);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("25869dcb", content, true, {});

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.lr-modal[data-v-4e63a0eb] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-4e63a0eb] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-4e63a0eb] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  width: 400px;\n  line-height: 1;\n}\n.button[data-v-4e63a0eb] {\n  margin-top: 30px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Insurance/ConfirmUpload.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oCAAoC;MAChC,iCAAiC;UAC7B,mCAAmC;EAC3C,qCAAqC;MACjC,kCAAkC;UAC9B,+BAA+B;EACvC,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;EACnD,mBAAmB;EACnB,aAAa;EACb,eAAe;CAChB;AACD;EACE,iBAAiB;CAClB","file":"ConfirmUpload.vue","sourcesContent":["\n.lr-modal[data-v-4e63a0eb] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.lr-modal.hide[data-v-4e63a0eb] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-box[data-v-4e63a0eb] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  width: 400px;\n  line-height: 1;\n}\n.button[data-v-4e63a0eb] {\n  margin-top: 30px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['lr-modal', {'hide': !_vm.insurance.showConfirm}]},[_c('div',{staticClass:"lr-box"},[_vm._v("\n    Are you sure you want to upload Report ID: "),_c('b',[_vm._v(_vm._s(_vm.id))]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-space-between align-start",staticStyle:{"gap":"20px"}},[_c('a',{staticClass:"button cta secondary block xsmall",on:{"click":_vm.cancel}},[_vm._v("No")]),_vm._v(" "),_c('a',{staticClass:"button cta success block xsmall",on:{"click":_vm.upload}},[_vm._v("Yes")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[_vm._v("INSURANCE REPORT")]),_vm._v(" "),_c('div',{staticClass:"ins-body"},[_c('a',{staticClass:"button cta small success",on:{"click":_vm.getList}},[_vm._v("Refresh List")]),_vm._v(" "),_c('a',{staticClass:"button cta small",on:{"click":_vm.showCreate}},[_vm._v("Create Insurance")]),_vm._v(" "),_c('table',{staticClass:"table-box",attrs:{"cellspacing":"0"}},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.insurance.list && !_vm.insurance.list.length)?_c('tr',[_c('td',{staticClass:"empty",attrs:{"colspan":"9"}},[_vm._v("No record found.")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.insurance.list),function(dat){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.formatdate(dat.createdUTC, true)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(dat.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatdate(dat.startUTC)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatdate(dat.endUTC)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(dat.milesPerDay))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(dat.whitelist.join(', ')))]),_vm._v(" "),_c('td',[(dat.fileUrl)?_c('a',{attrs:{"href":dat.fileUrl,"target":"_blank"}},[_c('i',{staticClass:"fas fa-link fa-fw"})]):_c('span',[_vm._v("--")])]),_vm._v(" "),_c('td',[_c('div',{class:['status', dat.status]},[_vm._v(_vm._s(dat.status))])]),_vm._v(" "),_c('td',[(dat.status == 'ready')?_c('a',{staticClass:"button cta small error",on:{"click":function($event){return _vm.confirmUpload(dat.id)}}},[_vm._v("UPLOAD")]):_vm._e()])])})],2)])]),_vm._v(" "),_c('create-modal',{on:{"refreshList":_vm.getList}}),_vm._v(" "),_c('confirm-upload',{attrs:{"id":_vm.target},on:{"refreshList":_vm.getList}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',[_vm._v("Created Date")]),_vm._v(" "),_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("Start Date")]),_vm._v(" "),_c('th',[_vm._v("End Date")]),_vm._v(" "),_c('th',[_vm._v("Miles per day")]),_vm._v(" "),_c('th',[_vm._v("RSVP Whitelist")]),_vm._v(" "),_c('th',[_vm._v("File")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',{staticStyle:{"width":"120px"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(690);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29d9c641_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2194);
function injectStyle (ssrContext) {
  __webpack_require__(2166)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29d9c641"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29d9c641_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2167);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("f0d34982", content, true, {});

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.header[data-v-29d9c641] {\n  background: #fafafa;\n  height: 50px;\n  border-bottom: 2px solid #eee;\n  line-height: 50px;\n  padding-left: 60px;\n  letter-spacing: .6px;\n  color: #555;\n  font-weight: 600;\n  font-size: 21px;\n  margin-bottom: 20px;\n}\n.tabs[data-v-29d9c641] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 10px;\n  border-bottom: 1px solid #ccc;\n}\n.tabs .tab[data-v-29d9c641] {\n    padding: 10px 15px;\n    font-size: 16px;\n    line-height: 1;\n    cursor: pointer;\n    border-bottom: 4px solid transparent;\n    font-weight: 600;\n    color: #333;\n}\n.tabs .tab i[data-v-29d9c641] {\n      color: #999;\n      margin-right: 5px;\n}\n.tabs .tab.active[data-v-29d9c641] {\n      border-bottom: 4px solid #57D1B7;\n      color: #57D1B7;\n}\n.tabs .tab.active i[data-v-29d9c641] {\n        color: #b1dad1;\n}\n.content[data-v-29d9c641] {\n  background: #fafafa;\n}\n.slide-up-enter-active[data-v-29d9c641], .slide-up-leave-active[data-v-29d9c641] {\n  -webkit-transition: all .25s ease-in-out;\n  transition: all .25s ease-in-out;\n}\n.slide-up-enter[data-v-29d9c641], .slide-up-leave-to[data-v-29d9c641] {\n  -webkit-transform: translateY(10px);\n          transform: translateY(10px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.tabs[data-v-29d9c641] {\n    width: 100%;\n    overflow-x: auto;\n    white-space: nowrap;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/AdminCode/index.vue"],"names":[],"mappings":";AACA;EACE,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;CACrB;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,UAAU;EACV,8BAA8B;CAC/B;AACD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,YAAY;CACf;AACD;MACM,YAAY;MACZ,kBAAkB;CACvB;AACD;MACM,iCAAiC;MACjC,eAAe;CACpB;AACD;QACQ,eAAe;CACtB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,oCAAoC;UAC5B,4BAA4B;EACpC,WAAW;CACZ;AACD;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;CACvB;CACA","file":"index.vue","sourcesContent":["\n.header[data-v-29d9c641] {\n  background: #fafafa;\n  height: 50px;\n  border-bottom: 2px solid #eee;\n  line-height: 50px;\n  padding-left: 60px;\n  letter-spacing: .6px;\n  color: #555;\n  font-weight: 600;\n  font-size: 21px;\n  margin-bottom: 20px;\n}\n.tabs[data-v-29d9c641] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 10px;\n  border-bottom: 1px solid #ccc;\n}\n.tabs .tab[data-v-29d9c641] {\n    padding: 10px 15px;\n    font-size: 16px;\n    line-height: 1;\n    cursor: pointer;\n    border-bottom: 4px solid transparent;\n    font-weight: 600;\n    color: #333;\n}\n.tabs .tab i[data-v-29d9c641] {\n      color: #999;\n      margin-right: 5px;\n}\n.tabs .tab.active[data-v-29d9c641] {\n      border-bottom: 4px solid #57D1B7;\n      color: #57D1B7;\n}\n.tabs .tab.active i[data-v-29d9c641] {\n        color: #b1dad1;\n}\n.content[data-v-29d9c641] {\n  background: #fafafa;\n}\n.slide-up-enter-active[data-v-29d9c641], .slide-up-leave-active[data-v-29d9c641] {\n  -webkit-transition: all .25s ease-in-out;\n  transition: all .25s ease-in-out;\n}\n.slide-up-enter[data-v-29d9c641], .slide-up-leave-to[data-v-29d9c641] {\n  -webkit-transform: translateY(10px);\n          transform: translateY(10px);\n  opacity: 0;\n}\n@media only screen and (max-width: 430px) {\n.tabs[data-v-29d9c641] {\n    width: 100%;\n    overflow-x: auto;\n    white-space: nowrap;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_commands_vue__ = __webpack_require__(691);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28a2e556_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_commands_vue__ = __webpack_require__(2171);
function injectStyle (ssrContext) {
  __webpack_require__(2169)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28a2e556"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_commands_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28a2e556_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_commands_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2170);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4c0972da", content, true, {});

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.cmd-box[data-v-28a2e556] {\n  padding: 15px;\n}\n.btn-only[data-v-28a2e556] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 15px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #dfdfdf;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.field-box[data-v-28a2e556] {\n  padding: 20px 0 25px;\n  border-bottom: 1px solid #dfdfdf;\n}\n.field-box label[data-v-28a2e556] {\n    font-weight: 600;\n    line-height: 1;\n    font-size: 15px;\n    color: #333;\n}\n.field-box .fields[data-v-28a2e556] {\n    gap: 10px;\n}\n.field-box input[data-v-28a2e556] {\n    margin: 0;\n    padding: 5px;\n    line-height: 1;\n    font-size: 16px;\n    letter-spacing: .5px;\n    width: 200px;\n}\n.field-box input.error[data-v-28a2e556] {\n      border-color: #f00;\n}\n.lr-modal[data-v-28a2e556] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.15s ease-in;\n  transition: all 0.15s ease-in;\n}\n.lr-modal.hide[data-v-28a2e556] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-modal .btns[data-v-28a2e556] {\n    gap: 10px;\n}\n.lr-box[data-v-28a2e556] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  min-width: 300px;\n  max-width: 500px;\n}\n.lr-alert-msg[data-v-28a2e556] {\n  margin-bottom: 20px;\n  color: #45505b;\n  font-size: 15px;\n}\n@media only screen and (max-width: 430px) {\n.btn-only[data-v-28a2e556] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n        -ms-flex-direction: column-reverse;\n            flex-direction: column-reverse;\n}\n.btn-only .btns[data-v-28a2e556] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      width: 100%;\n      gap: 20px;\n}\n.btn-only .btns .button[data-v-28a2e556] {\n        padding: 12px 15px 14px;\n}\n.field-box .fields[data-v-28a2e556] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.field-box input[data-v-28a2e556] {\n    width: 100%;\n    border: 1px solid #aaa;\n}\n.field-box .button[data-v-28a2e556] {\n    line-height: 14px;\n    font-size: 14px;\n    padding: 10px 15px 11px;\n    width: 100%;\n}\n.lr-box[data-v-28a2e556] {\n    padding: 10px;\n}\n.btn-only .button[data-v-28a2e556] {\n    width: 100%;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/AdminCode/commands.vue"],"names":[],"mappings":";AACA;EACE,cAAc;CACf;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,UAAU;EACV,qBAAqB;EACrB,iCAAiC;EACjC,0BAA0B;MACtB,uBAAuB;UACnB,+BAA+B;EACvC,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;CAC7B;AACD;EACE,qBAAqB;EACrB,iCAAiC;CAClC;AACD;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,YAAY;CACf;AACD;IACI,UAAU;CACb;AACD;IACI,UAAU;IACV,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;CAChB;AACD;MACM,mBAAmB;CACxB;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oCAAoC;MAChC,iCAAiC;UAC7B,mCAAmC;EAC3C,qCAAqC;MACjC,kCAAkC;UAC9B,+BAA+B;EACvC,sCAAsC;EACtC,8BAA8B;CAC/B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;IACI,UAAU;CACb;AACD;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;EACnD,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;CAClB;AACD;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;CACjB;AACD;AACA;IACI,6BAA6B;IAC7B,+BAA+B;QAC3B,mCAAmC;YAC/B,+BAA+B;CAC1C;AACD;MACM,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,YAAY;MACZ,UAAU;CACf;AACD;QACQ,wBAAwB;CAC/B;AACD;IACI,6BAA6B;IAC7B,8BAA8B;QAC1B,2BAA2B;YACvB,uBAAuB;CAClC;AACD;IACI,YAAY;IACZ,uBAAuB;CAC1B;AACD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,YAAY;CACf;AACD;IACI,cAAc;CACjB;AACD;IACI,YAAY;CACf;CACA","file":"commands.vue","sourcesContent":["\n.cmd-box[data-v-28a2e556] {\n  padding: 15px;\n}\n.btn-only[data-v-28a2e556] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 15px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #dfdfdf;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.field-box[data-v-28a2e556] {\n  padding: 20px 0 25px;\n  border-bottom: 1px solid #dfdfdf;\n}\n.field-box label[data-v-28a2e556] {\n    font-weight: 600;\n    line-height: 1;\n    font-size: 15px;\n    color: #333;\n}\n.field-box .fields[data-v-28a2e556] {\n    gap: 10px;\n}\n.field-box input[data-v-28a2e556] {\n    margin: 0;\n    padding: 5px;\n    line-height: 1;\n    font-size: 16px;\n    letter-spacing: .5px;\n    width: 200px;\n}\n.field-box input.error[data-v-28a2e556] {\n      border-color: #f00;\n}\n.lr-modal[data-v-28a2e556] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.15s ease-in;\n  transition: all 0.15s ease-in;\n}\n.lr-modal.hide[data-v-28a2e556] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-modal .btns[data-v-28a2e556] {\n    gap: 10px;\n}\n.lr-box[data-v-28a2e556] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  min-width: 300px;\n  max-width: 500px;\n}\n.lr-alert-msg[data-v-28a2e556] {\n  margin-bottom: 20px;\n  color: #45505b;\n  font-size: 15px;\n}\n@media only screen and (max-width: 430px) {\n.btn-only[data-v-28a2e556] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n        -ms-flex-direction: column-reverse;\n            flex-direction: column-reverse;\n}\n.btn-only .btns[data-v-28a2e556] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      width: 100%;\n      gap: 20px;\n}\n.btn-only .btns .button[data-v-28a2e556] {\n        padding: 12px 15px 14px;\n}\n.field-box .fields[data-v-28a2e556] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.field-box input[data-v-28a2e556] {\n    width: 100%;\n    border: 1px solid #aaa;\n}\n.field-box .button[data-v-28a2e556] {\n    line-height: 14px;\n    font-size: 14px;\n    padding: 10px 15px 11px;\n    width: 100%;\n}\n.lr-box[data-v-28a2e556] {\n    padding: 10px;\n}\n.btn-only .button[data-v-28a2e556] {\n    width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cmd-box"},[_c('div',{staticClass:"btn-only"},[_c('div',{staticClass:"btns"},[_c('div',{staticClass:"button cta primary",on:{"click":function($event){return _vm.confirm('Flush Host')}}},[_vm._v("FLUSH Hosts")]),_vm._v(" "),_c('div',{staticClass:"button cta warning",on:{"click":function($event){return _vm.confirm('Unstuck DB')}}},[_vm._v("Unstuck DB")]),_vm._v(" "),(_vm.env !== 'production')?_c('div',{staticClass:"button cta success",on:{"click":function($event){return _vm.confirm('Create Reservation')}}},[_vm._v("CREATE RES")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"field-box"},[_c('label',[_vm._v("Consumer ID")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-center fields"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.consumer.email),expression:"consumer.email"}],class:['email', {'error':_vm.error.consumerEmail}],attrs:{"placeholder":"Email"},domProps:{"value":(_vm.consumer.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.consumer, "email", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.consumer.level),expression:"consumer.level"}],staticClass:"level",attrs:{"placeholder":"Level (Optional)"},domProps:{"value":(_vm.consumer.level)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.consumer, "level", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"button cta small",on:{"click":function($event){return _vm.submitAction('Consumer ID')}}},[_vm._v("SUBMIT")])])]),_vm._v(" "),_c('div',{staticClass:"field-box"},[_c('label',[_vm._v("Remove CB")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-center fields"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.removeCBRsvpID),expression:"removeCBRsvpID"}],class:['rsvpid', {'error':_vm.error.removeCBRsvpID}],attrs:{"type":"text","placeholder":"RSVP ID"},domProps:{"value":(_vm.removeCBRsvpID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.removeCBRsvpID=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"button cta small",on:{"click":function($event){return _vm.submitAction('Remove CB')}}},[_vm._v("SUBMIT")])])]),_vm._v(" "),_c('div',{staticClass:"field-box"},[_c('label',[_vm._v("Force No Show")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-center fields"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forceNoShowRsvpID),expression:"forceNoShowRsvpID"}],class:['rsvpid', {'error':_vm.error.forceNoShowRsvpID}],attrs:{"type":"text","placeholder":"RSVP ID"},domProps:{"value":(_vm.forceNoShowRsvpID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.forceNoShowRsvpID=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"button cta small",on:{"click":function($event){return _vm.submitAction('Force No Show')}}},[_vm._v("SUBMIT")])])]),_vm._v(" "),_c('div',{staticClass:"field-box"},[_c('label',[_vm._v("Force Complete")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-center fields"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forceCompleteRsvpID),expression:"forceCompleteRsvpID"}],class:['rsvpid', {'error':_vm.error.forceCompleteRsvpID}],attrs:{"type":"text","placeholder":"RSVP ID"},domProps:{"value":(_vm.forceCompleteRsvpID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.forceCompleteRsvpID=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"button cta small",on:{"click":function($event){return _vm.submitAction('Force Complete')}}},[_vm._v("SUBMIT")])])]),_vm._v(" "),_c('div',{staticClass:"field-box"},[_c('label',[_vm._v("Force Cancel")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-center fields"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forceCancelRsvpID),expression:"forceCancelRsvpID"}],class:['rsvpid', {'error':_vm.error.forceCancelRsvpID}],attrs:{"type":"text","placeholder":"RSVP ID"},domProps:{"value":(_vm.forceCancelRsvpID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.forceCancelRsvpID=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"button cta small",on:{"click":function($event){return _vm.submitAction('Force Cancel')}}},[_vm._v("SUBMIT")])])]),_vm._v(" "),_c('div',{staticClass:"field-box"},[_c('label',[_vm._v("Remove M&G")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-center fields"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.removeMNGRsvpID),expression:"removeMNGRsvpID"}],class:['rsvpid', {'error':_vm.error.removeMNGRsvpID}],attrs:{"type":"text","placeholder":"RSVP ID"},domProps:{"value":(_vm.removeMNGRsvpID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.removeMNGRsvpID=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"button cta small",on:{"click":function($event){return _vm.submitAction('Remove M&G')}}},[_vm._v("SUBMIT")])])]),_vm._v(" "),_c('div',{staticClass:"field-box"},[_c('label',[_vm._v("Reset RSVP")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-center fields"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.resetRsvpID),expression:"resetRsvpID"}],class:['rsvpid', {'error':_vm.error.resetRsvpID}],attrs:{"type":"text","placeholder":"RSVP ID"},domProps:{"value":(_vm.resetRsvpID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.resetRsvpID=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"button cta small",on:{"click":function($event){return _vm.submitAction('Reset RSVP')}}},[_vm._v("SUBMIT")])])]),_vm._v(" "),_c('div',{staticClass:"field-box"},[_c('label',[_vm._v("Undo No Show")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-center fields"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.undoNoShowRsvpID),expression:"undoNoShowRsvpID"}],class:['rsvpid', {'error':_vm.error.undoNoShowRsvpID}],attrs:{"type":"text","placeholder":"RSVP ID"},domProps:{"value":(_vm.undoNoShowRsvpID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.undoNoShowRsvpID=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"button cta small",on:{"click":function($event){return _vm.submitAction('Undo No Show')}}},[_vm._v("SUBMIT")])])]),_vm._v(" "),_c('div',{staticClass:"field-box"},[_c('label',[_vm._v("Undo Complete")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-center fields"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.undoCompleteRsvpID),expression:"undoCompleteRsvpID"}],class:['rsvpid', {'error':_vm.error.undoCompleteRsvpID}],attrs:{"type":"text","placeholder":"RSVP ID"},domProps:{"value":(_vm.undoCompleteRsvpID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.undoCompleteRsvpID=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"button cta small",on:{"click":function($event){return _vm.submitAction('Undo Complete')}}},[_vm._v("SUBMIT")])])]),_vm._v(" "),_c('div',{staticClass:"field-box"},[_c('label',[_vm._v("Driver Payment")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-center fields"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.driverPayment.rsvpId),expression:"driverPayment.rsvpId"}],class:['rsvpid', {'error':_vm.error.driverPaymentRsvpID}],attrs:{"type":"text","placeholder":"RSVP ID"},domProps:{"value":(_vm.driverPayment.rsvpId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.driverPayment, "rsvpId", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.driverPayment.amount),expression:"driverPayment.amount"}],class:['level', {'error':_vm.error.driverPaymentAmount}],attrs:{"type":"text","placeholder":"Amount"},domProps:{"value":(_vm.driverPayment.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.driverPayment, "amount", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"button cta small",on:{"click":function($event){return _vm.submitAction('Driver Payment')}}},[_vm._v("SUBMIT")])])]),_vm._v(" "),_c('div',{staticClass:"field-box"},[_c('label',[_vm._v("Private Van")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-center fields"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.privateVanRsvpID),expression:"privateVanRsvpID"}],class:['rsvpid', {'error':_vm.error.privateVanRsvpID}],attrs:{"type":"text","placeholder":"RSVP ID"},domProps:{"value":(_vm.privateVanRsvpID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.privateVanRsvpID=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"button cta small",on:{"click":function($event){return _vm.submitAction('Private Van')}}},[_vm._v("SUBMIT")])])]),_vm._v(" "),_c('div',{staticClass:"field-box"},[_c('label',[_vm._v("Not Failed")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-center fields"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notFailedRsvpID),expression:"notFailedRsvpID"}],class:['rsvpid', {'error':_vm.error.notFailedRsvpID}],attrs:{"type":"text","placeholder":"RSVP ID"},domProps:{"value":(_vm.notFailedRsvpID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.notFailedRsvpID=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"button cta small",on:{"click":function($event){return _vm.submitAction('Not Failed')}}},[_vm._v("SUBMIT")])])]),_vm._v(" "),_c('div',{class:['lr-modal', {'hide': !_vm.show}]},[_c('div',{staticClass:"lr-box"},[_c('div',{staticClass:"lr-alert-msg"},[_vm._v("\n        Are you sure you want to run\n        "),_c('b',[_vm._v(_vm._s(_vm.confirmTarget))]),_vm._v("?\n      ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-space-around btns"},[_c('a',{staticClass:"button cta small secondary block",on:{"click":function($event){_vm.show = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('a',{staticClass:"button cta small primary block",on:{"click":_vm.btnTrigger}},[_vm._v("Confirm")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_failed_vue__ = __webpack_require__(692);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6423740c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_failed_vue__ = __webpack_require__(2175);
function injectStyle (ssrContext) {
  __webpack_require__(2173)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6423740c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_failed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6423740c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_failed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2174);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2cadd884", content, true, {});

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.failed-box[data-v-6423740c] {\n  padding: 15px;\n}\n.filter-box[data-v-6423740c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  border: 1px solid #ccc;\n  background: #fafafa;\n  padding: 15px;\n  border-radius: 4px;\n  -webkit-box-align: start !important;\n      -ms-flex-align: start !important;\n          align-items: start !important;\n}\n.filter-box .error-msg[data-v-6423740c] {\n    font-size: 13px;\n    color: #f00;\n}\n.filter-box .button[data-v-6423740c] {\n    line-height: 20px;\n    padding: 10px 20px;\n}\n.datepicker[data-v-6423740c] {\n  margin-right: 10px;\n}\n.table-box[data-v-6423740c] {\n  margin-top: 30px;\n  width: 100%;\n  border: 1px solid #333;\n  background: #fafafa;\n  border-radius: 4px;\n  overflow: hidden;\n}\n.table-box th[data-v-6423740c] {\n    border-bottom: 1px solid #ddd;\n    padding: 5px;\n    background: #333;\n    color: #fff;\n}\n.table-box tr[data-v-6423740c] {\n    text-align: center;\n}\n.table-box td[data-v-6423740c] {\n    padding: 7px;\n}\n.table-box tr:nth-child(odd) td[data-v-6423740c] {\n    background: #f3f3f3;\n}\n.table-box .empty[data-v-6423740c] {\n    padding: 30px;\n    font-weight: 600;\n    font-size: 28px;\n    color: #777;\n}\n.link[data-v-6423740c] {\n  font-size: 14px;\n  font-weight: 600;\n}\n@media only screen and (max-width: 430px) {\n.filter-box[data-v-6423740c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n.filter-box .date-input[data-v-6423740c] {\n      width: 50%;\n}\n.filter-box .date-input:nth-of-type(2) .datepicker[data-v-6423740c] {\n        margin: 0;\n}\n.filter-box .date-input[data-v-6423740c]:nth-of-type(2) .vdp-datepicker__calendar {\n        right: 0;\n}\n.filter-box .button[data-v-6423740c] {\n      width: 100%;\n      margin-top: 10px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/AdminCode/failed.vue"],"names":[],"mappings":";AACA;EACE,cAAc;CACf;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,oCAAoC;MAChC,iCAAiC;UAC7B,8BAA8B;CACvC;AACD;IACI,gBAAgB;IAChB,YAAY;CACf;AACD;IACI,kBAAkB;IAClB,mBAAmB;CACtB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;CAClB;AACD;IACI,8BAA8B;IAC9B,aAAa;IACb,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,mBAAmB;CACtB;AACD;IACI,aAAa;CAChB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;EACE,gBAAgB;EAChB,iBAAiB;CAClB;AACD;AACA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,oBAAoB;QAChB,gBAAgB;CACvB;AACD;MACM,WAAW;CAChB;AACD;QACQ,UAAU;CACjB;AACD;QACQ,SAAS;CAChB;AACD;MACM,YAAY;MACZ,iBAAiB;CACtB;CACA","file":"failed.vue","sourcesContent":["\n.failed-box[data-v-6423740c] {\n  padding: 15px;\n}\n.filter-box[data-v-6423740c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  border: 1px solid #ccc;\n  background: #fafafa;\n  padding: 15px;\n  border-radius: 4px;\n  -webkit-box-align: start !important;\n      -ms-flex-align: start !important;\n          align-items: start !important;\n}\n.filter-box .error-msg[data-v-6423740c] {\n    font-size: 13px;\n    color: #f00;\n}\n.filter-box .button[data-v-6423740c] {\n    line-height: 20px;\n    padding: 10px 20px;\n}\n.datepicker[data-v-6423740c] {\n  margin-right: 10px;\n}\n.table-box[data-v-6423740c] {\n  margin-top: 30px;\n  width: 100%;\n  border: 1px solid #333;\n  background: #fafafa;\n  border-radius: 4px;\n  overflow: hidden;\n}\n.table-box th[data-v-6423740c] {\n    border-bottom: 1px solid #ddd;\n    padding: 5px;\n    background: #333;\n    color: #fff;\n}\n.table-box tr[data-v-6423740c] {\n    text-align: center;\n}\n.table-box td[data-v-6423740c] {\n    padding: 7px;\n}\n.table-box tr:nth-child(odd) td[data-v-6423740c] {\n    background: #f3f3f3;\n}\n.table-box .empty[data-v-6423740c] {\n    padding: 30px;\n    font-weight: 600;\n    font-size: 28px;\n    color: #777;\n}\n.link[data-v-6423740c] {\n  font-size: 14px;\n  font-weight: 600;\n}\n@media only screen and (max-width: 430px) {\n.filter-box[data-v-6423740c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n.filter-box .date-input[data-v-6423740c] {\n      width: 50%;\n}\n.filter-box .date-input:nth-of-type(2) .datepicker[data-v-6423740c] {\n        margin: 0;\n}\n.filter-box .date-input[data-v-6423740c]:nth-of-type(2) .vdp-datepicker__calendar {\n        right: 0;\n}\n.filter-box .button[data-v-6423740c] {\n      width: 100%;\n      margin-top: 10px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"failed-box"},[_c('div',{staticClass:"filter-box"},[_c('div',{staticClass:"date-input"},[_c('datepicker',{class:['datepicker inline', {'has-error':!!_vm.validation.start}],attrs:{"format":_vm.calendarFormat},model:{value:(_vm.start),callback:function ($$v) {_vm.start=$$v},expression:"start"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.start))])],1),_vm._v(" "),_c('div',{staticClass:"date-input"},[_c('datepicker',{class:['datepicker inline', {'has-error':!!_vm.validation.end}],attrs:{"format":_vm.calendarFormat},model:{value:(_vm.end),callback:function ($$v) {_vm.end=$$v},expression:"end"}})],1),_vm._v(" "),_c('button',{staticClass:"button cta small",on:{"click":_vm.getFailedList}},[_vm._v("\n      Submit\n    ")])]),_vm._v(" "),_c('table',{staticClass:"table-box",attrs:{"cellspacing":"0"}},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.list && !_vm.list.length)?_c('tr',[_c('td',{staticClass:"empty",attrs:{"colspan":"2"}},[_vm._v("No record found.")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(dat){return _c('tr',[_c('td',[_c('a',{staticClass:"link",attrs:{"href":'/#/reservation/' + dat.rsvpId,"target":"_blank"}},[_vm._v(_vm._s(dat.rsvpId))])]),_vm._v(" "),_c('td',[_c('a',{staticClass:"stripe link",attrs:{"href":_vm.stripLink(dat.stripeCustId),"target":"_blank"}},[_vm._v(_vm._s(dat.stripeCustId))])])])})],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',[_vm._v("RSVP")]),_vm._v(" "),_c('th',[_vm._v("Stripe")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rsvp_vue__ = __webpack_require__(693);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58b6b1dd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rsvp_vue__ = __webpack_require__(2179);
function injectStyle (ssrContext) {
  __webpack_require__(2177)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58b6b1dd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rsvp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58b6b1dd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rsvp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2178);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("a21d1112", content, true, {});

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.rsvp-box[data-v-58b6b1dd] {\n  padding: 15px;\n}\n.filter-box[data-v-58b6b1dd] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  border: 1px solid #ccc;\n  background: #fafafa;\n  padding: 15px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  -webkit-box-align: start !important;\n      -ms-flex-align: start !important;\n          align-items: start !important;\n}\n.filter-box .error-msg[data-v-58b6b1dd] {\n    font-size: 13px;\n    color: #f00;\n}\n.filter-box .button[data-v-58b6b1dd] {\n    line-height: 20px;\n    padding: 10px 20px;\n}\n.datepicker[data-v-58b6b1dd] {\n  margin-right: 10px;\n}\n.card-box[data-v-58b6b1dd] {\n  border: 1px solid #ccc;\n  background: #fff;\n  border-radius: 4px;\n  gap: 10px;\n  padding: 10px;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  margin-bottom: 10px;\n}\n.card-box .data[data-v-58b6b1dd] {\n    padding: 10px;\n    background: #fafafa;\n    border: 1px solid #eee;\n    border-radius: 2px;\n    width: 120px;\n}\n.card-box .data.grayed[data-v-58b6b1dd] {\n      background: #f2f2f2;\n}\n.card-box .data label[data-v-58b6b1dd] {\n      display: block;\n      line-height: 1;\n      letter-spacing: .5px;\n      margin-bottom: 10px;\n      color: #777;\n      font-size: 15px;\n      font-weight: 600;\n}\n.card-box .data b[data-v-58b6b1dd] {\n      font-size: 32px;\n      line-height: 1;\n}\n.card-box .data.charged[data-v-58b6b1dd] {\n      background: #e0ffd6;\n      color: #338509;\n      border-color: #338509;\n}\n.card-box .data.charged label[data-v-58b6b1dd] {\n        color: #338509;\n}\n.card-box .data.no-show[data-v-58b6b1dd] {\n      background: #ffe9c1;\n      color: #d37f02;\n      border-color: #d37f02;\n}\n.card-box .data.no-show label[data-v-58b6b1dd] {\n        color: #d37f02;\n}\n.card-box .data.canceled[data-v-58b6b1dd] {\n      background: #ffd1d1;\n      color: #b30202;\n      border-color: #b30202;\n}\n.card-box .data.canceled label[data-v-58b6b1dd] {\n        color: #b30202;\n}\n.card-box .data.failed[data-v-58b6b1dd] {\n      background: #b3b3b3;\n      border-color: #333;\n}\n.card-box .data.failed label[data-v-58b6b1dd] {\n        color: #333;\n}\n.table-box[data-v-58b6b1dd] {\n  margin-top: 30px;\n  width: 100%;\n  border: 1px solid #333;\n  background: #fafafa;\n  border-radius: 4px;\n  overflow: hidden;\n}\n.table-box th[data-v-58b6b1dd] {\n    border-bottom: 1px solid #ddd;\n    padding: 5px;\n    background: #333;\n    color: #fff;\n}\n.table-box tr[data-v-58b6b1dd] {\n    text-align: center;\n}\n.table-box td[data-v-58b6b1dd] {\n    font-size: 14px;\n    padding: 7px;\n}\n.table-box tr:nth-child(odd) td[data-v-58b6b1dd] {\n    background: #f3f3f3;\n}\n.table-box .empty[data-v-58b6b1dd] {\n    padding: 30px;\n    font-weight: 600;\n    font-size: 28px;\n    color: #777;\n}\n@media only screen and (max-width: 430px) {\n.filter-box[data-v-58b6b1dd] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n.filter-box .date-input[data-v-58b6b1dd] {\n      width: 50%;\n}\n.filter-box .date-input:nth-of-type(2) .datepicker[data-v-58b6b1dd] {\n        margin: 0;\n}\n.filter-box .date-input[data-v-58b6b1dd]:nth-of-type(2) .vdp-datepicker__calendar {\n        right: 0;\n}\n.filter-box .button[data-v-58b6b1dd] {\n      width: 100%;\n      margin-top: 10px;\n}\n.card-box[data-v-58b6b1dd] {\n    width: 100%;\n}\n.card-box[data-v-58b6b1dd]:nth-of-type(3) {\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n}\n.card-box:nth-of-type(3) .data[data-v-58b6b1dd] {\n        width: 100px;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/AdminCode/rsvp.vue"],"names":[],"mappings":";AACA;EACE,cAAc;CACf;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;MAChC,iCAAiC;UAC7B,8BAA8B;CACvC;AACD;IACI,gBAAgB;IAChB,YAAY;CACf;AACD;IACI,kBAAkB;IAClB,mBAAmB;CACtB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;CACrB;AACD;IACI,cAAc;IACd,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;CAChB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,eAAe;MACf,eAAe;MACf,qBAAqB;MACrB,oBAAoB;MACpB,YAAY;MACZ,gBAAgB;MAChB,iBAAiB;CACtB;AACD;MACM,gBAAgB;MAChB,eAAe;CACpB;AACD;MACM,oBAAoB;MACpB,eAAe;MACf,sBAAsB;CAC3B;AACD;QACQ,eAAe;CACtB;AACD;MACM,oBAAoB;MACpB,eAAe;MACf,sBAAsB;CAC3B;AACD;QACQ,eAAe;CACtB;AACD;MACM,oBAAoB;MACpB,eAAe;MACf,sBAAsB;CAC3B;AACD;QACQ,eAAe;CACtB;AACD;MACM,oBAAoB;MACpB,mBAAmB;CACxB;AACD;QACQ,YAAY;CACnB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;CAClB;AACD;IACI,8BAA8B;IAC9B,aAAa;IACb,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,mBAAmB;CACtB;AACD;IACI,gBAAgB;IAChB,aAAa;CAChB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;AACA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,oBAAoB;QAChB,gBAAgB;CACvB;AACD;MACM,WAAW;CAChB;AACD;QACQ,UAAU;CACjB;AACD;QACQ,SAAS;CAChB;AACD;MACM,YAAY;MACZ,iBAAiB;CACtB;AACD;IACI,YAAY;CACf;AACD;MACM,oBAAoB;UAChB,gBAAgB;CACzB;AACD;QACQ,aAAa;CACpB;CACA","file":"rsvp.vue","sourcesContent":["\n.rsvp-box[data-v-58b6b1dd] {\n  padding: 15px;\n}\n.filter-box[data-v-58b6b1dd] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  border: 1px solid #ccc;\n  background: #fafafa;\n  padding: 15px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  -webkit-box-align: start !important;\n      -ms-flex-align: start !important;\n          align-items: start !important;\n}\n.filter-box .error-msg[data-v-58b6b1dd] {\n    font-size: 13px;\n    color: #f00;\n}\n.filter-box .button[data-v-58b6b1dd] {\n    line-height: 20px;\n    padding: 10px 20px;\n}\n.datepicker[data-v-58b6b1dd] {\n  margin-right: 10px;\n}\n.card-box[data-v-58b6b1dd] {\n  border: 1px solid #ccc;\n  background: #fff;\n  border-radius: 4px;\n  gap: 10px;\n  padding: 10px;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  margin-bottom: 10px;\n}\n.card-box .data[data-v-58b6b1dd] {\n    padding: 10px;\n    background: #fafafa;\n    border: 1px solid #eee;\n    border-radius: 2px;\n    width: 120px;\n}\n.card-box .data.grayed[data-v-58b6b1dd] {\n      background: #f2f2f2;\n}\n.card-box .data label[data-v-58b6b1dd] {\n      display: block;\n      line-height: 1;\n      letter-spacing: .5px;\n      margin-bottom: 10px;\n      color: #777;\n      font-size: 15px;\n      font-weight: 600;\n}\n.card-box .data b[data-v-58b6b1dd] {\n      font-size: 32px;\n      line-height: 1;\n}\n.card-box .data.charged[data-v-58b6b1dd] {\n      background: #e0ffd6;\n      color: #338509;\n      border-color: #338509;\n}\n.card-box .data.charged label[data-v-58b6b1dd] {\n        color: #338509;\n}\n.card-box .data.no-show[data-v-58b6b1dd] {\n      background: #ffe9c1;\n      color: #d37f02;\n      border-color: #d37f02;\n}\n.card-box .data.no-show label[data-v-58b6b1dd] {\n        color: #d37f02;\n}\n.card-box .data.canceled[data-v-58b6b1dd] {\n      background: #ffd1d1;\n      color: #b30202;\n      border-color: #b30202;\n}\n.card-box .data.canceled label[data-v-58b6b1dd] {\n        color: #b30202;\n}\n.card-box .data.failed[data-v-58b6b1dd] {\n      background: #b3b3b3;\n      border-color: #333;\n}\n.card-box .data.failed label[data-v-58b6b1dd] {\n        color: #333;\n}\n.table-box[data-v-58b6b1dd] {\n  margin-top: 30px;\n  width: 100%;\n  border: 1px solid #333;\n  background: #fafafa;\n  border-radius: 4px;\n  overflow: hidden;\n}\n.table-box th[data-v-58b6b1dd] {\n    border-bottom: 1px solid #ddd;\n    padding: 5px;\n    background: #333;\n    color: #fff;\n}\n.table-box tr[data-v-58b6b1dd] {\n    text-align: center;\n}\n.table-box td[data-v-58b6b1dd] {\n    font-size: 14px;\n    padding: 7px;\n}\n.table-box tr:nth-child(odd) td[data-v-58b6b1dd] {\n    background: #f3f3f3;\n}\n.table-box .empty[data-v-58b6b1dd] {\n    padding: 30px;\n    font-weight: 600;\n    font-size: 28px;\n    color: #777;\n}\n@media only screen and (max-width: 430px) {\n.filter-box[data-v-58b6b1dd] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n.filter-box .date-input[data-v-58b6b1dd] {\n      width: 50%;\n}\n.filter-box .date-input:nth-of-type(2) .datepicker[data-v-58b6b1dd] {\n        margin: 0;\n}\n.filter-box .date-input[data-v-58b6b1dd]:nth-of-type(2) .vdp-datepicker__calendar {\n        right: 0;\n}\n.filter-box .button[data-v-58b6b1dd] {\n      width: 100%;\n      margin-top: 10px;\n}\n.card-box[data-v-58b6b1dd] {\n    width: 100%;\n}\n.card-box[data-v-58b6b1dd]:nth-of-type(3) {\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n}\n.card-box:nth-of-type(3) .data[data-v-58b6b1dd] {\n        width: 100px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rsvp-box"},[_c('div',{staticClass:"filter-box"},[_c('div',{staticClass:"date-input"},[_c('datepicker',{class:['datepicker inline', {'has-error':!!_vm.validation.start}],attrs:{"format":_vm.calendarFormat},model:{value:(_vm.start),callback:function ($$v) {_vm.start=$$v},expression:"start"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.start))])],1),_vm._v(" "),_c('div',{staticClass:"date-input"},[_c('datepicker',{class:['datepicker inline', {'has-error':!!_vm.validation.end}],attrs:{"format":_vm.calendarFormat},model:{value:(_vm.end),callback:function ($$v) {_vm.end=$$v},expression:"end"}})],1),_vm._v(" "),_c('button',{staticClass:"button cta small",on:{"click":_vm.getRsvpList}},[_vm._v("\n      Submit\n    ")])]),_vm._v(" "),_c('div',{staticClass:"card-box summary d-flex align-stretch"},[_c('div',{staticClass:"data d-flex flex-column justify-space-between"},[_c('label',[_vm._v("All")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.summary.all))])]),_vm._v(" "),_c('div',{staticClass:"data d-flex flex-column justify-space-between grayed"},[_c('label',[_vm._v("Card")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.summary.card))])]),_vm._v(" "),_c('div',{staticClass:"data d-flex flex-column justify-space-between grayed"},[_c('label',[_vm._v("Not Canceled")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.summary.notCanceled))])])]),_vm._v(" "),_c('div',{staticClass:"card-box summary d-flex align-stretch"},[_c('div',{staticClass:"data d-flex flex-column justify-space-between"},[_c('label',[_vm._v("Auth")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.stats.auth))])]),_vm._v(" "),_c('div',{staticClass:"data d-flex flex-column justify-space-between charged"},[_c('label',[_vm._v("Charged")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.stats.charged))])]),_vm._v(" "),_c('div',{staticClass:"data d-flex flex-column justify-space-between no-show"},[_c('label',[_vm._v("No Show")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.stats.noshow))])]),_vm._v(" "),_c('div',{staticClass:"data d-flex flex-column justify-space-between canceled"},[_c('label',[_vm._v("Canceled")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.stats.canceled))])]),_vm._v(" "),_c('div',{staticClass:"data d-flex flex-column justify-space-between failed"},[_c('label',[_vm._v("Failed")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.stats.failed))])])]),_vm._v(" "),_c('table',{staticClass:"table-box",attrs:{"cellspacing":"0"}},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.list && !_vm.list.length)?_c('tr',[_c('td',{staticClass:"empty",attrs:{"colspan":"3"}},[_vm._v("No record found.")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(dat){return _c('tr',[_c('td',[_vm._v(_vm._s(dat.brand))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(dat.service))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(dat.count))])])})],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',[_vm._v("Brand")]),_vm._v(" "),_c('th',[_vm._v("Service")]),_vm._v(" "),_c('th',[_vm._v("Count")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_asap_vue__ = __webpack_require__(694);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_276be9a6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_asap_vue__ = __webpack_require__(2189);
function injectStyle (ssrContext) {
  __webpack_require__(2181)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-276be9a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_asap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_276be9a6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_asap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2182);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("13324857", content, true, {});

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.asap-box[data-v-276be9a6] {\n  padding: 15px;\n}\n.filter-box[data-v-276be9a6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  border: 1px solid #ccc;\n  background: #fafafa;\n  padding: 15px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  -webkit-box-align: start !important;\n      -ms-flex-align: start !important;\n          align-items: start !important;\n}\n.filter-box .error-msg[data-v-276be9a6] {\n    font-size: 13px;\n    color: #f00;\n}\n.filter-box .button[data-v-276be9a6] {\n    line-height: 20px;\n    padding: 10px 20px;\n}\n.datepicker[data-v-276be9a6] {\n  margin-right: 10px;\n}\n.card-box[data-v-276be9a6] {\n  border: 1px solid #ccc;\n  background: #fff;\n  border-radius: 4px;\n  gap: 10px;\n  padding: 10px;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  margin-bottom: 10px;\n}\n.card-box .data[data-v-276be9a6] {\n    padding: 10px;\n    background: #fafafa;\n    border: 1px solid #eee;\n    border-radius: 2px;\n    width: 120px;\n}\n.card-box .data.grayed[data-v-276be9a6] {\n      background: #f2f2f2;\n}\n.card-box .data label[data-v-276be9a6] {\n      display: block;\n      line-height: 1;\n      letter-spacing: .5px;\n      margin-bottom: 10px;\n      color: #777;\n      font-size: 15px;\n      font-weight: 600;\n}\n.card-box .data b[data-v-276be9a6] {\n      font-size: 32px;\n      line-height: 1;\n}\n.card-box .data.charged[data-v-276be9a6] {\n      background: #e0ffd6;\n      color: #338509;\n      border-color: #338509;\n}\n.card-box .data.charged label[data-v-276be9a6] {\n        color: #338509;\n}\n.card-box .data.no-show[data-v-276be9a6] {\n      background: #ffe9c1;\n      color: #d37f02;\n      border-color: #d37f02;\n}\n.card-box .data.no-show label[data-v-276be9a6] {\n        color: #d37f02;\n}\n.card-box .data.canceled[data-v-276be9a6] {\n      background: #ffd1d1;\n      color: #b30202;\n      border-color: #b30202;\n}\n.card-box .data.canceled label[data-v-276be9a6] {\n        color: #b30202;\n}\n.card-box .data.failed[data-v-276be9a6] {\n      background: #b3b3b3;\n      border-color: #333;\n}\n.card-box .data.failed label[data-v-276be9a6] {\n        color: #333;\n}\n.table-box[data-v-276be9a6] {\n  margin-top: 30px;\n  width: 100%;\n  border: 1px solid #333;\n  background: #fafafa;\n  border-radius: 4px;\n  overflow: hidden;\n}\n.table-box th[data-v-276be9a6] {\n    border-bottom: 1px solid #ddd;\n    padding: 5px;\n    background: #333;\n    color: #fff;\n}\n.table-box tr[data-v-276be9a6] {\n    text-align: center;\n}\n.table-box td[data-v-276be9a6] {\n    font-size: 14px;\n    padding: 7px;\n}\n.table-box tr:nth-child(odd) td[data-v-276be9a6] {\n    background: #f3f3f3;\n}\n.table-box .empty[data-v-276be9a6] {\n    padding: 30px;\n    font-weight: 600;\n    font-size: 28px;\n    color: #777;\n}\n.isSub td[data-v-276be9a6] {\n  font-size: 12px;\n  background: #e8f6ff !important;\n}\n.date[data-v-276be9a6] {\n  color: #777;\n}\n.date.cancel[data-v-276be9a6] {\n    color: #f00;\n}\n.cons-id[data-v-276be9a6] {\n  padding-right: 27px;\n}\n.cons-id div[data-v-276be9a6] {\n    position: relative;\n    display: inline-block;\n}\n.cons-id i[data-v-276be9a6] {\n    position: absolute;\n    top: 4px;\n    right: -20px;\n    cursor: pointer;\n}\n.token[data-v-276be9a6] {\n  font-size: 13px;\n  color: #777;\n}\n.cards[data-v-276be9a6] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.filter-box[data-v-276be9a6] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n.filter-box .date-input[data-v-276be9a6] {\n      width: 50%;\n}\n.filter-box .date-input:nth-of-type(2) .datepicker[data-v-276be9a6] {\n        margin: 0;\n}\n.filter-box .date-input[data-v-276be9a6]:nth-of-type(2) .vdp-datepicker__calendar {\n        right: 0;\n}\n.filter-box .button[data-v-276be9a6] {\n      width: 100%;\n      margin-top: 10px;\n}\n.table-box[data-v-276be9a6] {\n    display: none;\n}\n.cards[data-v-276be9a6] {\n    display: block;\n    padding-top: 10px;\n    padding-bottom: 100px;\n}\n.cards .card[data-v-276be9a6] {\n      border: 1px solid #ccc;\n      margin: 15px 0;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n      font-weight: 700;\n}\n.cards .card.in-group[data-v-276be9a6] {\n        margin: 0;\n        border-bottom: 2px solid #aaa9;\n        border-radius: 0;\n}\n.cards .card > div[data-v-276be9a6] {\n        margin-bottom: 3px;\n}\n.cards .card .title[data-v-276be9a6] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n}\n.cards .card .title.head-title[data-v-276be9a6] {\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n          -webkit-box-align: start;\n              -ms-flex-align: start;\n                  align-items: start;\n}\n.cards .card .title.head-title .value[data-v-276be9a6] {\n            margin: 0;\n            font-weight: 400;\n}\n.cards .card .label[data-v-276be9a6] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards .card .value[data-v-276be9a6] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards .card .value i[data-v-276be9a6] {\n          opacity: 0.3;\n}\n.cards .card .value.token[data-v-276be9a6] {\n          font-size: 10px;\n}\n.cards .card .edit[data-v-276be9a6] {\n        text-align: right;\n        margin-bottom: 10px;\n        text-transform: uppercase;\n}\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/AdminCode/asap.vue"],"names":[],"mappings":";AACA;EACE,cAAc;CACf;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;MAChC,iCAAiC;UAC7B,8BAA8B;CACvC;AACD;IACI,gBAAgB;IAChB,YAAY;CACf;AACD;IACI,kBAAkB;IAClB,mBAAmB;CACtB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;CACrB;AACD;IACI,cAAc;IACd,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;CAChB;AACD;MACM,oBAAoB;CACzB;AACD;MACM,eAAe;MACf,eAAe;MACf,qBAAqB;MACrB,oBAAoB;MACpB,YAAY;MACZ,gBAAgB;MAChB,iBAAiB;CACtB;AACD;MACM,gBAAgB;MAChB,eAAe;CACpB;AACD;MACM,oBAAoB;MACpB,eAAe;MACf,sBAAsB;CAC3B;AACD;QACQ,eAAe;CACtB;AACD;MACM,oBAAoB;MACpB,eAAe;MACf,sBAAsB;CAC3B;AACD;QACQ,eAAe;CACtB;AACD;MACM,oBAAoB;MACpB,eAAe;MACf,sBAAsB;CAC3B;AACD;QACQ,eAAe;CACtB;AACD;MACM,oBAAoB;MACpB,mBAAmB;CACxB;AACD;QACQ,YAAY;CACnB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;CAClB;AACD;IACI,8BAA8B;IAC9B,aAAa;IACb,iBAAiB;IACjB,YAAY;CACf;AACD;IACI,mBAAmB;CACtB;AACD;IACI,gBAAgB;IAChB,aAAa;CAChB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CACf;AACD;EACE,gBAAgB;EAChB,+BAA+B;CAChC;AACD;EACE,YAAY;CACb;AACD;IACI,YAAY;CACf;AACD;EACE,oBAAoB;CACrB;AACD;IACI,mBAAmB;IACnB,sBAAsB;CACzB;AACD;IACI,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,gBAAgB;CACnB;AACD;EACE,gBAAgB;EAChB,YAAY;CACb;AACD;EACE,cAAc;CACf;AACD;AACA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,oBAAoB;QAChB,gBAAgB;CACvB;AACD;MACM,WAAW;CAChB;AACD;QACQ,UAAU;CACjB;AACD;QACQ,SAAS;CAChB;AACD;MACM,YAAY;MACZ,iBAAiB;CACtB;AACD;IACI,cAAc;CACjB;AACD;IACI,eAAe;IACf,kBAAkB;IAClB,sBAAsB;CACzB;AACD;MACM,uBAAuB;MACvB,eAAe;MACf,aAAa;MACb,oBAAoB;MACpB,+BAA+B;MAC/B,oBAAoB;MACpB,iBAAiB;CACtB;AACD;QACQ,UAAU;QACV,+BAA+B;QAC/B,iBAAiB;CACxB;AACD;QACQ,mBAAmB;CAC1B;AACD;QACQ,qBAAqB;QACrB,qBAAqB;QACrB,cAAc;QACd,0BAA0B;YACtB,uBAAuB;gBACnB,oBAAoB;CACnC;AACD;UACU,0BAA0B;cACtB,uBAAuB;kBACnB,+BAA+B;UACvC,yBAAyB;cACrB,sBAAsB;kBAClB,mBAAmB;CACpC;AACD;YACY,UAAU;YACV,iBAAiB;CAC5B;AACD;QACQ,gBAAgB;QAChB,0BAA0B;QAC1B,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;CACzB;AACD;QACQ,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;CACxB;AACD;UACU,aAAa;CACtB;AACD;UACU,gBAAgB;CACzB;AACD;QACQ,kBAAkB;QAClB,oBAAoB;QACpB,0BAA0B;CACjC;CACA","file":"asap.vue","sourcesContent":["\n.asap-box[data-v-276be9a6] {\n  padding: 15px;\n}\n.filter-box[data-v-276be9a6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  border: 1px solid #ccc;\n  background: #fafafa;\n  padding: 15px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  -webkit-box-align: start !important;\n      -ms-flex-align: start !important;\n          align-items: start !important;\n}\n.filter-box .error-msg[data-v-276be9a6] {\n    font-size: 13px;\n    color: #f00;\n}\n.filter-box .button[data-v-276be9a6] {\n    line-height: 20px;\n    padding: 10px 20px;\n}\n.datepicker[data-v-276be9a6] {\n  margin-right: 10px;\n}\n.card-box[data-v-276be9a6] {\n  border: 1px solid #ccc;\n  background: #fff;\n  border-radius: 4px;\n  gap: 10px;\n  padding: 10px;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  margin-bottom: 10px;\n}\n.card-box .data[data-v-276be9a6] {\n    padding: 10px;\n    background: #fafafa;\n    border: 1px solid #eee;\n    border-radius: 2px;\n    width: 120px;\n}\n.card-box .data.grayed[data-v-276be9a6] {\n      background: #f2f2f2;\n}\n.card-box .data label[data-v-276be9a6] {\n      display: block;\n      line-height: 1;\n      letter-spacing: .5px;\n      margin-bottom: 10px;\n      color: #777;\n      font-size: 15px;\n      font-weight: 600;\n}\n.card-box .data b[data-v-276be9a6] {\n      font-size: 32px;\n      line-height: 1;\n}\n.card-box .data.charged[data-v-276be9a6] {\n      background: #e0ffd6;\n      color: #338509;\n      border-color: #338509;\n}\n.card-box .data.charged label[data-v-276be9a6] {\n        color: #338509;\n}\n.card-box .data.no-show[data-v-276be9a6] {\n      background: #ffe9c1;\n      color: #d37f02;\n      border-color: #d37f02;\n}\n.card-box .data.no-show label[data-v-276be9a6] {\n        color: #d37f02;\n}\n.card-box .data.canceled[data-v-276be9a6] {\n      background: #ffd1d1;\n      color: #b30202;\n      border-color: #b30202;\n}\n.card-box .data.canceled label[data-v-276be9a6] {\n        color: #b30202;\n}\n.card-box .data.failed[data-v-276be9a6] {\n      background: #b3b3b3;\n      border-color: #333;\n}\n.card-box .data.failed label[data-v-276be9a6] {\n        color: #333;\n}\n.table-box[data-v-276be9a6] {\n  margin-top: 30px;\n  width: 100%;\n  border: 1px solid #333;\n  background: #fafafa;\n  border-radius: 4px;\n  overflow: hidden;\n}\n.table-box th[data-v-276be9a6] {\n    border-bottom: 1px solid #ddd;\n    padding: 5px;\n    background: #333;\n    color: #fff;\n}\n.table-box tr[data-v-276be9a6] {\n    text-align: center;\n}\n.table-box td[data-v-276be9a6] {\n    font-size: 14px;\n    padding: 7px;\n}\n.table-box tr:nth-child(odd) td[data-v-276be9a6] {\n    background: #f3f3f3;\n}\n.table-box .empty[data-v-276be9a6] {\n    padding: 30px;\n    font-weight: 600;\n    font-size: 28px;\n    color: #777;\n}\n.isSub td[data-v-276be9a6] {\n  font-size: 12px;\n  background: #e8f6ff !important;\n}\n.date[data-v-276be9a6] {\n  color: #777;\n}\n.date.cancel[data-v-276be9a6] {\n    color: #f00;\n}\n.cons-id[data-v-276be9a6] {\n  padding-right: 27px;\n}\n.cons-id div[data-v-276be9a6] {\n    position: relative;\n    display: inline-block;\n}\n.cons-id i[data-v-276be9a6] {\n    position: absolute;\n    top: 4px;\n    right: -20px;\n    cursor: pointer;\n}\n.token[data-v-276be9a6] {\n  font-size: 13px;\n  color: #777;\n}\n.cards[data-v-276be9a6] {\n  display: none;\n}\n@media only screen and (max-width: 430px) {\n.filter-box[data-v-276be9a6] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n.filter-box .date-input[data-v-276be9a6] {\n      width: 50%;\n}\n.filter-box .date-input:nth-of-type(2) .datepicker[data-v-276be9a6] {\n        margin: 0;\n}\n.filter-box .date-input[data-v-276be9a6]:nth-of-type(2) .vdp-datepicker__calendar {\n        right: 0;\n}\n.filter-box .button[data-v-276be9a6] {\n      width: 100%;\n      margin-top: 10px;\n}\n.table-box[data-v-276be9a6] {\n    display: none;\n}\n.cards[data-v-276be9a6] {\n    display: block;\n    padding-top: 10px;\n    padding-bottom: 100px;\n}\n.cards .card[data-v-276be9a6] {\n      border: 1px solid #ccc;\n      margin: 15px 0;\n      padding: 8px;\n      padding-bottom: 3px;\n      border-bottom: 5px solid #aaa9;\n      border-radius: 10px;\n      font-weight: 700;\n}\n.cards .card.in-group[data-v-276be9a6] {\n        margin: 0;\n        border-bottom: 2px solid #aaa9;\n        border-radius: 0;\n}\n.cards .card > div[data-v-276be9a6] {\n        margin-bottom: 3px;\n}\n.cards .card .title[data-v-276be9a6] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n}\n.cards .card .title.head-title[data-v-276be9a6] {\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n          -webkit-box-align: start;\n              -ms-flex-align: start;\n                  align-items: start;\n}\n.cards .card .title.head-title .value[data-v-276be9a6] {\n            margin: 0;\n            font-weight: 400;\n}\n.cards .card .label[data-v-276be9a6] {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #bbb;\n        font-weight: 600;\n        margin-right: 5px;\n}\n.cards .card .value[data-v-276be9a6] {\n        margin-right: 10px;\n        font-size: 13px;\n        font-weight: 900;\n}\n.cards .card .value i[data-v-276be9a6] {\n          opacity: 0.3;\n}\n.cards .card .value.token[data-v-276be9a6] {\n          font-size: 10px;\n}\n.cards .card .edit[data-v-276be9a6] {\n        text-align: right;\n        margin-bottom: 10px;\n        text-transform: uppercase;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2184), __esModule: true };

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105);
__webpack_require__(56);
__webpack_require__(70);
__webpack_require__(2185);
__webpack_require__(2186);
__webpack_require__(2187);
__webpack_require__(2188);
module.exports = __webpack_require__(12).Map;


/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(538);
var validate = __webpack_require__(159);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(539)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(15);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(540)('Map') });


/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(541)('Map');


/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(542)('Map');


/***/ }),
/* 2189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asap-box"},[_c('div',{staticClass:"filter-box"},[_c('div',{staticClass:"date-input"},[_c('datepicker',{class:['datepicker inline', {'has-error':!!_vm.validation.start}],attrs:{"format":_vm.calendarFormat},model:{value:(_vm.start),callback:function ($$v) {_vm.start=$$v},expression:"start"}}),_vm._v(" "),_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.validation.start))])],1),_vm._v(" "),_c('div',{staticClass:"date-input"},[_c('datepicker',{class:['datepicker inline', {'has-error':!!_vm.validation.end}],attrs:{"format":_vm.calendarFormat},model:{value:(_vm.end),callback:function ($$v) {_vm.end=$$v},expression:"end"}})],1),_vm._v(" "),_c('button',{staticClass:"button cta small",on:{"click":_vm.getServices}},[_vm._v("\n      Submit\n    ")])]),_vm._v(" "),_c('div',{staticClass:"card-box summary d-flex align-stretch"},[_c('div',{staticClass:"data d-flex flex-column justify-space-between"},[_c('label',[_vm._v("Attempts")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.stats.attempts))])]),_vm._v(" "),_c('div',{staticClass:"data d-flex flex-column justify-space-between"},[_c('label',[_vm._v("Unique Consumer")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.stats.cons))])]),_vm._v(" "),_c('div',{staticClass:"data d-flex flex-column justify-space-between"},[_c('label',[_vm._v("Unique Reservation")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.stats.rsvpId))])]),_vm._v(" "),_c('div',{staticClass:"data d-flex flex-column justify-space-between charged"},[_c('label',[_vm._v("Completed")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.stats.success))])]),_vm._v(" "),_c('div',{staticClass:"data d-flex flex-column justify-space-between canceled"},[_c('label',[_vm._v("Canceled")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.stats.canceled))])]),_vm._v(" "),_c('div',{staticClass:"data d-flex flex-column justify-space-between failed"},[_c('label',[_vm._v("Failed")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.stats.failedAttempts))])])]),_vm._v(" "),_c('table',{staticClass:"table-box",attrs:{"cellspacing":"0"}},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.list && !_vm.list.length)?_c('tr',[_c('td',{staticClass:"empty",attrs:{"colspan":"13"}},[_vm._v("No record found.")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(dat){return (!dat.isGroupMember || _vm.showGroup.indexOf(dat.consId) > -1)?_c('tr',{class:{isSub:dat.isGroupMember}},[_c('td',[_vm._v(_vm._s(dat.custBid))]),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v(_vm._s(_vm.formatDate(dat.created)))]),_vm._v(" "),_c('td',{staticClass:"cons-id"},[_c('div',[(dat.consId)?_c('a',{staticClass:"link",attrs:{"href":'/#/consumer/' + dat.consId,"target":"_blank"}},[_vm._v(_vm._s(dat.consId))]):_vm._e(),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(dat.hasMultipleItems && !dat.isGroupMember),expression:"dat.hasMultipleItems && !dat.isGroupMember"}],class:['fas', _vm.showGroup.indexOf(dat.consId) == -1 ? 'fa-chevron-down' : 'fa-chevron-up'],on:{"click":function($event){return _vm.toggleGroup(dat.consId)}}})])]),_vm._v(" "),_c('td',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.deviceLabel(dat.deviceType)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.brandLabel(dat.brandId)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.serviceTypeLabel(dat.serviceTypeId)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(dat.pickupTitle || '--'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(dat.dropoffTitle || '--'))]),_vm._v(" "),_c('td',[(dat.amount)?_c('b',[_vm._v("$"+_vm._s(dat.amount))]):_c('span',[_vm._v("--")])]),_vm._v(" "),_c('td',[(dat.rsvpId)?_c('a',{staticClass:"link",attrs:{"href":'/#/reservation/' + dat.rsvpId,"target":"_blank"}},[_vm._v(_vm._s(dat.rsvpId))]):_c('span',[_vm._v("--")])]),_vm._v(" "),_c('td',[(dat.canceled)?_c('span',{staticClass:"date cancel"},[_vm._v(_vm._s(_vm.formatDate(dat.canceled, true)))]):_c('span',[_vm._v("--")])]),_vm._v(" "),_c('td',[(dat.lyftError)?_c('span',{staticClass:"date cancel"},[_vm._v(_vm._s(dat.lyftError))]):_c('span',[_vm._v("--")])])]):_vm._e()}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.list.length),expression:"list.length"}]},[_c('td',{attrs:{"colspan":"8"}}),_vm._v(" "),_c('td',[_c('b',{staticStyle:{"font-size":"18px"}},[_vm._v("$"+_vm._s(_vm.total.amount.toFixed(2)))])]),_vm._v(" "),_c('td',{attrs:{"colspan":"3"}})])],2)]),_vm._v(" "),_c('div',{staticClass:"cards"},[(_vm.list && !_vm.list.length)?_c('div',[_c('td',{staticClass:"empty",attrs:{"colspan":"10"}},[_vm._v("No record found.")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(dat){return _c('div',{key:dat.custBid,class:['card', {'in-group':dat.isGroupMember || dat.hasMultipleItems}]},[_c('div',{staticClass:"title head-title"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"label"},[_vm._v("Bid ID")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(dat.custBid))])]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.formatDate(dat.created)))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Consumer")]),_vm._v(" "),_c('div',{staticClass:"value"},[(dat.consId)?_c('a',{staticClass:"link",attrs:{"href":'/#/consumer/' + dat.consId,"target":"_blank"}},[_vm._v(_vm._s(dat.consId))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Pickup")]),_vm._v(" "),_c('div',{staticClass:"value token"},[_vm._v(_vm._s(dat.pickupTitle || '--'))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Dropoff")]),_vm._v(" "),_c('div',{staticClass:"value token"},[_vm._v(_vm._s(dat.dropoffTitle || '--'))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Amount")]),_vm._v(" "),_c('div',{staticClass:"value"},[(dat.amount)?_c('b',[_vm._v("$"+_vm._s(dat.amount))]):_c('span',[_vm._v("--")])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Stripe")]),_vm._v(" "),_c('div',{staticClass:"value"},[(dat.stripeChargeId)?_c('a',{staticClass:"stripe link",attrs:{"href":_vm.stripLink(dat.stripeChargeId),"target":"_blank"}},[_vm._v(_vm._s(dat.stripeChargeId))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("RSVP ID")]),_vm._v(" "),_c('div',{staticClass:"value"},[(dat.rsvpId)?_c('a',{staticClass:"link",attrs:{"href":'/#/reservation/' + dat.rsvpId,"target":"_blank"}},[_vm._v(_vm._s(dat.rsvpId))]):_c('span',[_vm._v("--")])])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Last Sent to")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(dat.sendTo || '--'))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Assigned Prov")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(dat.acceptProv || '--'))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"label"},[_vm._v("Canceled")]),_vm._v(" "),_c('div',{staticClass:"value"},[(dat.canceled)?_c('span',{staticClass:"date cancel"},[_vm._v(_vm._s(_vm.formatDate(dat.canceled, true)))]):_c('span',[_vm._v("--")])])])])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',[_vm._v("Bid ID")]),_vm._v(" "),_c('th',[_vm._v("Created")]),_vm._v(" "),_c('th',[_vm._v("Consumer")]),_vm._v(" "),_c('th',[_vm._v("Device Type")]),_vm._v(" "),_c('th',[_vm._v("Brand")]),_vm._v(" "),_c('th',[_vm._v("Service Type")]),_vm._v(" "),_c('th',[_vm._v("Pickup")]),_vm._v(" "),_c('th',[_vm._v("Dropoff")]),_vm._v(" "),_c('th',[_vm._v("Amount")]),_vm._v(" "),_c('th',[_vm._v("RSVP ID")]),_vm._v(" "),_c('th',[_vm._v("Canceled")]),_vm._v(" "),_c('th',[_vm._v("Notes")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_services_vue__ = __webpack_require__(695);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73afddda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_services_vue__ = __webpack_require__(2193);
function injectStyle (ssrContext) {
  __webpack_require__(2191)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73afddda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_services_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73afddda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_services_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2192);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("b40dac16", content, true, {});

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(true);
// imports


// module
exports.push([module.i, "\n.service-box[data-v-73afddda] {\n  padding: 15px;\n}\n.tables[data-v-73afddda] {\n  gap: 10px;\n  margin: 10px 0 20px;\n}\n.rsp-box[data-v-73afddda] {\n  max-width: 650px;\n}\n.table-box[data-v-73afddda] {\n  width: 100%;\n  max-width: 650px;\n  border: 1px solid #333;\n  background: #fafafa;\n  border-radius: 4px;\n  font-size: 14px;\n}\n.table-box.hwtnc[data-v-73afddda] {\n    max-width: 300px;\n}\n.table-box .table-header[data-v-73afddda] {\n    background: #333;\n    color: #fff;\n    padding: 5px;\n    font-size: 18px;\n    font-weight: 600;\n}\n.table-box .col-head[data-v-73afddda] {\n    font-size: 12px;\n    letter-spacing: .6px;\n    text-align: center;\n}\n.table-box .col-head td[data-v-73afddda] {\n      border-bottom: 1px solid #333;\n      background: #e9f2ff;\n      font-weight: 600;\n}\n.table-box .th-box[data-v-73afddda] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 20px;\n}\n.table-box .sv-action-group[data-v-73afddda] {\n    position: relative;\n}\n.table-box .sv-a-options[data-v-73afddda] {\n    position: absolute;\n    top: calc(100% + 5px);\n    right: 0;\n    background: #fff;\n    color: #333;\n    -webkit-box-shadow: 1px 1px 4px;\n            box-shadow: 1px 1px 4px;\n    width: 100px;\n}\n.table-box .sv-a-options div[data-v-73afddda] {\n      font-size: 14px;\n      padding: 8px 7px;\n      line-height: 1;\n      letter-spacing: .5px;\n      border-bottom: 1px solid #ddd;\n      cursor: pointer;\n}\n.table-box .sv-a-options div[data-v-73afddda]:hover {\n        background: #f3f3f3;\n}\n.table-box .sv-a-options div[data-v-73afddda]:last-child {\n        border-bottom: none;\n}\n.table-box .server-action[data-v-73afddda] {\n    font-size: 14px;\n    background: #0d79f2;\n    padding: 4px 12px;\n    border-radius: 4px;\n    -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.9);\n            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.9);\n    cursor: pointer;\n}\n.table-box .server-action[data-v-73afddda]:hover {\n      background: #2798e9;\n}\n.table-box .fa-info-circle[data-v-73afddda] {\n    cursor: pointer;\n    color: #a8aeb3;\n    font-size: 16px;\n    vertical-align: -1px;\n}\n.table-box .fa-info-circle.active[data-v-73afddda] {\n      color: #2798e9;\n}\n.table-box td[data-v-73afddda] {\n    padding: 5px 8px;\n}\n.table-box .label[data-v-73afddda] {\n    text-transform: capitalize;\n    color: #444;\n    letter-spacing: .5px;\n}\n.table-box .value[data-v-73afddda] {\n    text-align: right;\n    font-weight: 600;\n    color: #f00;\n}\n.table-box .value.OK[data-v-73afddda] {\n      color: #48cf28;\n}\n.table-box .value.red[data-v-73afddda] {\n      background: #ed5a5a !important;\n}\n.table-box .value.green[data-v-73afddda] {\n      background: #4ae171 !important;\n}\n.table-box .value.black[data-v-73afddda] {\n      background: transparent !important;\n}\n.raw-pre[data-v-73afddda] {\n  background: #ebebeb;\n  padding: 10px;\n  overflow: auto;\n  height: 200px;\n  font-size: 13px;\n  line-height: 1.3;\n}\nhr[data-v-73afddda] {\n  margin: 30px 0;\n}\n.db-vals[data-v-73afddda] {\n  text-align: center;\n}\n.db-vals.red[data-v-73afddda] {\n    background: #ffa6a6 !important;\n}\n.lr-modal[data-v-73afddda] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.15s ease-in;\n  transition: all 0.15s ease-in;\n}\n.lr-modal.hide[data-v-73afddda] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-modal .btns[data-v-73afddda] {\n    gap: 10px;\n}\n.lr-box[data-v-73afddda] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  min-width: 300px;\n  max-width: 500px;\n}\n.lr-alert-msg[data-v-73afddda] {\n  margin-bottom: 20px;\n  color: #45505b;\n  font-size: 15px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/AdminCode/services.vue"],"names":[],"mappings":";AACA;EACE,cAAc;CACf;AACD;EACE,UAAU;EACV,oBAAoB;CACrB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;CACjB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;CACpB;AACD;IACI,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;CACtB;AACD;MACM,8BAA8B;MAC9B,oBAAoB;MACpB,iBAAiB;CACtB;AACD;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,0BAA0B;QACtB,uBAAuB;YACnB,+BAA+B;IACvC,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;IAC5B,UAAU;CACb;AACD;IACI,mBAAmB;CACtB;AACD;IACI,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,YAAY;IACZ,gCAAgC;YACxB,wBAAwB;IAChC,aAAa;CAChB;AACD;MACM,gBAAgB;MAChB,iBAAiB;MACjB,eAAe;MACf,qBAAqB;MACrB,8BAA8B;MAC9B,gBAAgB;CACrB;AACD;QACQ,oBAAoB;CAC3B;AACD;QACQ,oBAAoB;CAC3B;AACD;IACI,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,mDAAmD;YAC3C,2CAA2C;IACnD,gBAAgB;CACnB;AACD;MACM,oBAAoB;CACzB;AACD;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;CACxB;AACD;MACM,eAAe;CACpB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,2BAA2B;IAC3B,YAAY;IACZ,qBAAqB;CACxB;AACD;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;CACf;AACD;MACM,eAAe;CACpB;AACD;MACM,+BAA+B;CACpC;AACD;MACM,+BAA+B;CACpC;AACD;MACM,mCAAmC;CACxC;AACD;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;CAClB;AACD;EACE,eAAe;CAChB;AACD;EACE,mBAAmB;CACpB;AACD;IACI,+BAA+B;CAClC;AACD;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oCAAoC;MAChC,iCAAiC;UAC7B,mCAAmC;EAC3C,qCAAqC;MACjC,kCAAkC;UAC9B,+BAA+B;EACvC,sCAAsC;EACtC,8BAA8B;CAC/B;AACD;IACI,WAAW;IACX,WAAW;CACd;AACD;IACI,UAAU;CACb;AACD;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mDAAmD;UAC3C,2CAA2C;EACnD,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;CAClB;AACD;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;CACjB","file":"services.vue","sourcesContent":["\n.service-box[data-v-73afddda] {\n  padding: 15px;\n}\n.tables[data-v-73afddda] {\n  gap: 10px;\n  margin: 10px 0 20px;\n}\n.rsp-box[data-v-73afddda] {\n  max-width: 650px;\n}\n.table-box[data-v-73afddda] {\n  width: 100%;\n  max-width: 650px;\n  border: 1px solid #333;\n  background: #fafafa;\n  border-radius: 4px;\n  font-size: 14px;\n}\n.table-box.hwtnc[data-v-73afddda] {\n    max-width: 300px;\n}\n.table-box .table-header[data-v-73afddda] {\n    background: #333;\n    color: #fff;\n    padding: 5px;\n    font-size: 18px;\n    font-weight: 600;\n}\n.table-box .col-head[data-v-73afddda] {\n    font-size: 12px;\n    letter-spacing: .6px;\n    text-align: center;\n}\n.table-box .col-head td[data-v-73afddda] {\n      border-bottom: 1px solid #333;\n      background: #e9f2ff;\n      font-weight: 600;\n}\n.table-box .th-box[data-v-73afddda] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 20px;\n}\n.table-box .sv-action-group[data-v-73afddda] {\n    position: relative;\n}\n.table-box .sv-a-options[data-v-73afddda] {\n    position: absolute;\n    top: calc(100% + 5px);\n    right: 0;\n    background: #fff;\n    color: #333;\n    -webkit-box-shadow: 1px 1px 4px;\n            box-shadow: 1px 1px 4px;\n    width: 100px;\n}\n.table-box .sv-a-options div[data-v-73afddda] {\n      font-size: 14px;\n      padding: 8px 7px;\n      line-height: 1;\n      letter-spacing: .5px;\n      border-bottom: 1px solid #ddd;\n      cursor: pointer;\n}\n.table-box .sv-a-options div[data-v-73afddda]:hover {\n        background: #f3f3f3;\n}\n.table-box .sv-a-options div[data-v-73afddda]:last-child {\n        border-bottom: none;\n}\n.table-box .server-action[data-v-73afddda] {\n    font-size: 14px;\n    background: #0d79f2;\n    padding: 4px 12px;\n    border-radius: 4px;\n    -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.9);\n            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.9);\n    cursor: pointer;\n}\n.table-box .server-action[data-v-73afddda]:hover {\n      background: #2798e9;\n}\n.table-box .fa-info-circle[data-v-73afddda] {\n    cursor: pointer;\n    color: #a8aeb3;\n    font-size: 16px;\n    vertical-align: -1px;\n}\n.table-box .fa-info-circle.active[data-v-73afddda] {\n      color: #2798e9;\n}\n.table-box td[data-v-73afddda] {\n    padding: 5px 8px;\n}\n.table-box .label[data-v-73afddda] {\n    text-transform: capitalize;\n    color: #444;\n    letter-spacing: .5px;\n}\n.table-box .value[data-v-73afddda] {\n    text-align: right;\n    font-weight: 600;\n    color: #f00;\n}\n.table-box .value.OK[data-v-73afddda] {\n      color: #48cf28;\n}\n.table-box .value.red[data-v-73afddda] {\n      background: #ed5a5a !important;\n}\n.table-box .value.green[data-v-73afddda] {\n      background: #4ae171 !important;\n}\n.table-box .value.black[data-v-73afddda] {\n      background: transparent !important;\n}\n.raw-pre[data-v-73afddda] {\n  background: #ebebeb;\n  padding: 10px;\n  overflow: auto;\n  height: 200px;\n  font-size: 13px;\n  line-height: 1.3;\n}\nhr[data-v-73afddda] {\n  margin: 30px 0;\n}\n.db-vals[data-v-73afddda] {\n  text-align: center;\n}\n.db-vals.red[data-v-73afddda] {\n    background: #ffa6a6 !important;\n}\n.lr-modal[data-v-73afddda] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n  overflow: auto;\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-transition: all 0.15s ease-in;\n  transition: all 0.15s ease-in;\n}\n.lr-modal.hide[data-v-73afddda] {\n    top: -100%;\n    opacity: 0;\n}\n.lr-modal .btns[data-v-73afddda] {\n    gap: 10px;\n}\n.lr-box[data-v-73afddda] {\n  background: #fff;\n  padding: 20px;\n  border-radius: 6px;\n  -webkit-box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  min-width: 300px;\n  max-width: 500px;\n}\n.lr-alert-msg[data-v-73afddda] {\n  margin-bottom: 20px;\n  color: #45505b;\n  font-size: 15px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 2193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service-box"},[_c('div',{staticClass:"button cta small primary",on:{"click":_vm.getServiceList}},[_vm._v("\n    Refresh\n  ")]),_vm._v(" "),_c('div',{staticClass:"d-flex tables align-start"},[_c('div',{staticClass:"rsp-box"},[_c('table',{staticClass:"table-box",attrs:{"cellspacing":"1"}},[_c('tr',[_c('td',{staticClass:"table-header",attrs:{"colspan":"7"}},[_c('div',{staticClass:"th-box"},[_c('span',[_vm._v("Ride Share PRO")]),_vm._v(" "),_c('div',{staticClass:"sv-action-group"},[_c('span',{staticClass:"server-action",on:{"click":function($event){_vm.svAction.list = !_vm.svAction.list; _vm.svAction.listHolo = false}}},[_c('i',{staticClass:"fas fa-bars"})]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.svAction.list),expression:"svAction.list"}],staticClass:"sv-a-options"},[_c('div',{on:{"click":function($event){return _vm.confirm('Flush Hosts', 'rsp')}}},[_vm._v("Flush Hosts")]),_vm._v(" "),_c('div',{on:{"click":function($event){return _vm.confirm('Unstuck DB', 'rsp')}}},[_vm._v("Unstuck DB")])])])],1)])])]),_vm._v(" "),(_vm.rsp && !Object.keys(_vm.rsp).length)?_c('tr',[_c('td',{attrs:{"colspan":"7"}},[_vm._v("No record found.")])]):_vm._e(),_vm._v(" "),(_vm.rsp && Object.keys(_vm.rsp).length)?_c('tr',{staticClass:"col-head"},[_c('td'),_vm._v(" "),_c('td',[_vm._v("State")]),_vm._v(" "),_c('td',[_vm._v("Master")]),_vm._v(" "),_c('td',[_vm._v("Slave 1")]),_vm._v(" "),_c('td',[_vm._v("Slave 2")]),_vm._v(" "),_c('td',[_vm._v("Slave 3")]),_vm._v(" "),_c('td',[_vm._v("Location")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.rsp),function(key,i){return _c('tr',{key:i},[_c('td',{staticClass:"label"},[_c('i',{class:['fas fa-info-circle fa-fw', {active: i === _vm.raw.rsp.field}],on:{"click":function($event){return _vm.toggleRaw(i, key, 'rsp')}}}),_vm._v("\n            "+_vm._s(i)+"\n          ")]),_vm._v(" "),_c('td',{class:['value', _vm.statusCheck(key, 'error')]}),_vm._v(" "),_c('td',{class:['value', _vm.statusCheck(key, 'master')]}),_vm._v(" "),_c('td',{class:['value', _vm.statusCheck(key, 'slave1')]}),_vm._v(" "),_c('td',{class:['value', _vm.statusCheck(key, 'slave2')]}),_vm._v(" "),_c('td',{class:['value', _vm.statusCheck(key, 'slave3')]}),_vm._v(" "),_c('td',{class:['value', _vm.statusCheck(key, 'location')]})])})],2),_vm._v(" "),_c('pre',{directives:[{name:"show",rawName:"v-show",value:(_vm.raw.rsp.msg),expression:"raw.rsp.msg"}],staticClass:"raw-pre"},[_vm._v(_vm._s(_vm.raw.rsp.msg))])]),_vm._v(" "),_c('div',{staticClass:"rsp-box"},[_c('table',{staticClass:"table-box",attrs:{"cellspacing":"1"}},[_c('tr',[_c('td',{staticClass:"table-header",attrs:{"colspan":"7"}},[_c('div',{staticClass:"th-box"},[_c('span',[_vm._v("Holoholo TNC")]),_vm._v(" "),_c('div',{staticClass:"sv-action-group"},[_c('span',{staticClass:"server-action",on:{"click":function($event){_vm.svAction.listHolo = !_vm.svAction.listHolo; _vm.svAction.list = false}}},[_c('i',{staticClass:"fas fa-bars"})]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.svAction.listHolo),expression:"svAction.listHolo"}],staticClass:"sv-a-options"},[_c('div',{on:{"click":function($event){return _vm.confirm('Flush Hosts', 'holotnc')}}},[_vm._v("Flush Hosts")]),_vm._v(" "),_c('div',{on:{"click":function($event){return _vm.confirm('Unstuck DB', 'holotnc')}}},[_vm._v("Unstuck DB")])])])],1)])])]),_vm._v(" "),(_vm.rsp && !Object.keys(_vm.rsp).length)?_c('tr',[_c('td',{attrs:{"colspan":"7"}},[_vm._v("No record found.")])]):_vm._e(),_vm._v(" "),(_vm.rsp && Object.keys(_vm.rsp).length)?_c('tr',{staticClass:"col-head"},[_c('td'),_vm._v(" "),_c('td',[_vm._v("State")]),_vm._v(" "),_c('td',[_vm._v("Master")]),_vm._v(" "),_c('td',[_vm._v("Slave 1")]),_vm._v(" "),_c('td',[_vm._v("Slave 2")]),_vm._v(" "),_c('td',[_vm._v("Slave 3")]),_vm._v(" "),_c('td',[_vm._v("Location")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.holotnc),function(key,i){return _c('tr',{key:i},[_c('td',{staticClass:"label"},[_c('i',{class:['fas fa-info-circle fa-fw', {active: i === _vm.raw.holotnc.field}],on:{"click":function($event){return _vm.toggleRaw(i, key, 'holotnc')}}}),_vm._v("\n            "+_vm._s(i)+"\n          ")]),_vm._v(" "),_c('td',{class:['value', _vm.statusCheck(key, 'error')]}),_vm._v(" "),_c('td',{class:['value', _vm.statusCheck(key, 'master')]}),_vm._v(" "),_c('td',{class:['value', _vm.statusCheck(key, 'slave1')]}),_vm._v(" "),_c('td',{class:['value', _vm.statusCheck(key, 'slave2')]}),_vm._v(" "),_c('td',{class:['value', _vm.statusCheck(key, 'slave3')]}),_vm._v(" "),_c('td',{class:['value', _vm.statusCheck(key, 'location')]})])})],2),_vm._v(" "),_c('pre',{directives:[{name:"show",rawName:"v-show",value:(_vm.raw.holotnc.msg),expression:"raw.holotnc.msg"}],staticClass:"raw-pre"},[_vm._v(_vm._s(_vm.raw.holotnc.msg))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"button cta small primary",on:{"click":_vm.getDBStatus}},[_vm._v("Refresh DB Stats")]),_vm._v(" "),_c('div',{staticClass:"d-flex tables align-start"},[_c('table',{staticClass:"table-box full",attrs:{"cellspacing":"0"}},[_vm._m(0),_vm._v(" "),(!_vm.db.main.length)?_c('tr',[_c('td',{attrs:{"colspan":"5"}},[_vm._v("No record found.")])]):_c('tr',{staticClass:"col-head"},[_c('td',[_vm._v("ID")]),_vm._v(" "),_c('td',[_vm._v("Host")]),_vm._v(" "),_c('td',[_vm._v("Command")]),_vm._v(" "),_c('td',[_vm._v("Query")]),_vm._v(" "),_c('td',[_vm._v("Time")])]),_vm._v(" "),_vm._l((_vm.db.main),function(key,i){return _c('tr',{key:i,class:['db-vals', {red:key.time >= 10 && key.query}]},[_c('td',{staticClass:"label"},[_vm._v(_vm._s(key.id))]),_vm._v(" "),_c('td',{staticClass:"label"},[_vm._v(_vm._s(key.host))]),_vm._v(" "),_c('td',{staticClass:"label"},[_vm._v(_vm._s(key.command))]),_vm._v(" "),_c('td',{staticClass:"label"},[_vm._v(_vm._s(key.query))]),_vm._v(" "),_c('td',{staticClass:"label"},[_vm._v(_vm._s(key.time))])])})],2),_vm._v(" "),_c('table',{staticClass:"table-box full",attrs:{"cellspacing":"0"}},[_vm._m(1),_vm._v(" "),(!_vm.db.slave1.length)?_c('tr',[_c('td',{attrs:{"colspan":"5"}},[_vm._v("No record found.")])]):_c('tr',{staticClass:"col-head"},[_c('td',[_vm._v("ID")]),_vm._v(" "),_c('td',[_vm._v("Host")]),_vm._v(" "),_c('td',[_vm._v("Command")]),_vm._v(" "),_c('td',[_vm._v("Query")]),_vm._v(" "),_c('td',[_vm._v("Time")])]),_vm._v(" "),_vm._l((_vm.db.slave1),function(key,i){return _c('tr',{key:i,class:['db-vals', {red:key.time >= 10 && key.query}]},[_c('td',{staticClass:"label"},[_vm._v(_vm._s(key.id))]),_vm._v(" "),_c('td',{staticClass:"label"},[_vm._v(_vm._s(key.host))]),_vm._v(" "),_c('td',{staticClass:"label"},[_vm._v(_vm._s(key.command))]),_vm._v(" "),_c('td',{staticClass:"label"},[_vm._v(_vm._s(key.query))]),_vm._v(" "),_c('td',{staticClass:"label"},[_vm._v(_vm._s(key.time))])])})],2)]),_vm._v(" "),_c('div',{staticClass:"d-flex tables align-start"},[_c('table',{staticClass:"table-box full",attrs:{"cellspacing":"0"}},[_vm._m(2),_vm._v(" "),(!_vm.db.slave2.length)?_c('tr',[_c('td',{attrs:{"colspan":"5"}},[_vm._v("No record found.")])]):_c('tr',{staticClass:"col-head"},[_c('td',[_vm._v("ID")]),_vm._v(" "),_c('td',[_vm._v("Host")]),_vm._v(" "),_c('td',[_vm._v("Command")]),_vm._v(" "),_c('td',[_vm._v("Query")]),_vm._v(" "),_c('td',[_vm._v("Time")])]),_vm._v(" "),_vm._l((_vm.db.slave2),function(key,i){return _c('tr',{key:i,class:['db-vals', {red:key.time >= 10 && key.query}]},[_c('td',{staticClass:"label"},[_vm._v(_vm._s(key.id))]),_vm._v(" "),_c('td',{staticClass:"label"},[_vm._v(_vm._s(key.host))]),_vm._v(" "),_c('td',{staticClass:"label"},[_vm._v(_vm._s(key.command))]),_vm._v(" "),_c('td',{staticClass:"label"},[_vm._v(_vm._s(key.query))]),_vm._v(" "),_c('td',{staticClass:"label"},[_vm._v(_vm._s(key.time))])])})],2),_vm._v(" "),_c('table',{staticClass:"table-box full",attrs:{"cellspacing":"0"}},[_vm._m(3),_vm._v(" "),(!_vm.db.slave3.length)?_c('tr',[_c('td',{attrs:{"colspan":"5"}},[_vm._v("No record found.")])]):_c('tr',{staticClass:"col-head"},[_c('td',[_vm._v("ID")]),_vm._v(" "),_c('td',[_vm._v("Host")]),_vm._v(" "),_c('td',[_vm._v("Command")]),_vm._v(" "),_c('td',[_vm._v("Query")]),_vm._v(" "),_c('td',[_vm._v("Time")])]),_vm._v(" "),_vm._l((_vm.db.slave3),function(key,i){return _c('tr',{key:i,class:['db-vals', {red:key.time >= 10 && key.query}]},[_c('td',{staticClass:"label"},[_vm._v(_vm._s(key.id))]),_vm._v(" "),_c('td',{staticClass:"label"},[_vm._v(_vm._s(key.host))]),_vm._v(" "),_c('td',{staticClass:"label"},[_vm._v(_vm._s(key.command))]),_vm._v(" "),_c('td',{staticClass:"label"},[_vm._v(_vm._s(key.query))]),_vm._v(" "),_c('td',{staticClass:"label"},[_vm._v(_vm._s(key.time))])])})],2)]),_vm._v(" "),_c('div',{class:['lr-modal', {'hide': !_vm.svAction.show}]},[_c('div',{staticClass:"lr-box"},[_c('div',{staticClass:"lr-alert-msg"},[_vm._v("\n        Are you sure you want to run\n        "),_c('b',[_vm._v(_vm._s(_vm.svAction.action))]),_vm._v("?\n      ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-space-around btns"},[_c('a',{staticClass:"button cta small secondary block",on:{"click":function($event){_vm.svAction.show = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('a',{staticClass:"button cta small primary block",on:{"click":_vm.btnTrigger}},[_vm._v("Confirm")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"table-header",attrs:{"colspan":"5"}},[_vm._v("MAIN")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"table-header",attrs:{"colspan":"5"}},[_vm._v("Slave 1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"table-header",attrs:{"colspan":"5"}},[_vm._v("Slave 2")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"table-header",attrs:{"colspan":"5"}},[_vm._v("Slave 3")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[_vm._v("ADMIN CODE")]),_vm._v(" "),_c('div',{staticClass:"tabs"},[_c('div',{class:['tab', {active:_vm.tab === 'command'}],on:{"click":function($event){_vm.tab = 'command'}}},[_c('i',{staticClass:"fa fa-code fa-fw",attrs:{"aria-hidden":"true"}}),_vm._v("\n      Commands\n    ")]),_vm._v(" "),_c('div',{class:['tab', {active:_vm.tab === 'rsvp'}],on:{"click":function($event){_vm.tab = 'rsvp'}}},[_c('i',{staticClass:"fa fa-id-card fa-fw",attrs:{"aria-hidden":"true"}}),_vm._v("\n      RSVP\n    ")]),_vm._v(" "),_c('div',{class:['tab', {active:_vm.tab === 'asap'}],on:{"click":function($event){_vm.tab = 'asap'}}},[_c('i',{staticClass:"fa fa-id-card fa-fw",attrs:{"aria-hidden":"true"}}),_vm._v("\n      ASAP\n    ")]),_vm._v(" "),_c('div',{class:['tab', {active:_vm.tab === 'failed'}],on:{"click":function($event){_vm.tab = 'failed'}}},[_c('i',{staticClass:"fa fa-eye fa-fw",attrs:{"aria-hidden":"true"}}),_vm._v("\n      Failed\n    ")]),_vm._v(" "),_c('div',{class:['tab', {active:_vm.tab === 'services'}],on:{"click":function($event){_vm.tab = 'services'}}},[_c('i',{staticClass:"fa fa-globe fa-fw",attrs:{"aria-hidden":"true"}}),_vm._v("\n      Services\n    ")])]),_vm._v(" "),_c('div',{staticClass:"tabs-content"},[_c('transition-group',{attrs:{"mode":"out-in","name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tab === 'command'),expression:"tab === 'command'"}],key:"1",staticClass:"content"},[_c('commands')],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tab === 'failed'),expression:"tab === 'failed'"}],key:"2",staticClass:"content"},[_c('failed',{ref:"failed"})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tab === 'rsvp'),expression:"tab === 'rsvp'"}],key:"3",staticClass:"content"},[_c('rsvp',{ref:"rsvp"})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tab === 'asap'),expression:"tab === 'asap'"}],key:"4",staticClass:"content"},[_c('asap',{ref:"asap"})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tab === 'services'),expression:"tab === 'services'"}],key:"5",staticClass:"content"},[_c('services',{ref:"services"})],1)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gateway_sdk__ = __webpack_require__(2196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_settings__ = __webpack_require__(2201);





var GatewayPlugin = function () {
  function GatewayPlugin() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GatewayPlugin);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(GatewayPlugin, [{
    key: 'install',
    value: function install(Vue, options) {
      Vue.prototype.$sdk = new __WEBPACK_IMPORTED_MODULE_2__gateway_sdk__["a" /* default */](options, Vue.prototype);
      Vue.prototype.$settings = new __WEBPACK_IMPORTED_MODULE_3__app_settings__["a" /* default */](Vue.prototype.$sdk);
    }
  }]);

  return GatewayPlugin;
}();

/* harmony default export */ __webpack_exports__["a"] = (new GatewayPlugin());

/***/ }),
/* 2196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);




// const axios = require('axios')
var request = __webpack_require__(13);
var queryString = __webpack_require__(2197);

var GatewaySDK = function () {
  function GatewaySDK(options, app) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, GatewaySDK);

    this.url = options.url;
    this.optHost = options.optimizationHost.replace(/\/$/gi, '');
    this.app = app;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(GatewaySDK, [{
    key: 'get',
    value: function get(route, params, callback, version) {
      var qs = '';
      var self = this;
      var v = '1.1';
      if (version || typeof version !== 'undefined' && version.length === 0) {
        v = version + '';
      }
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(params).length > 0) {
        qs = '?' + queryString.stringify(params);
      }
      request.get({
        url: self.url + v + route + qs,
        json: true,
        body: params
      }, function (err, res, body) {
        if (err) throw err;
        callback(body);
      });
    }
  }, {
    key: 'post',
    value: function post(route, params, callback, version) {
      var self = this;
      var v = '1.1';
      if (version || typeof version !== 'undefined' && version.length === 0) {
        v = version + '';
      }
      request.post({
        url: self.url + v + route,
        json: true,
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)
      }, function (err, res, body) {
        if (err) throw err;
        callback(body);
      });
    }
  }, {
    key: 'delete',
    value: function _delete(route, params, callback, version) {
      var self = this;
      var v = '1.1';
      if (version || typeof version !== 'undefined' && version.length === 0) {
        v = version + '';
      }
      request({
        method: 'DELETE',
        url: self.url + v + route,
        json: true,
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)
      }, function (err, res, body) {
        if (err) throw err;
        callback(body);
      });
    }
  }, {
    key: 'download',
    value: function download(route, params, callback, version) {
      var qs = '';
      var self = this;
      var v = '1.1';
      if (version || typeof version !== 'undefined' && version.length === 0) {
        v = version + '';
      }
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(params).length > 0) {
        qs = '?' + queryString.stringify(params);
      }
      request.get({
        url: self.url + v + route + qs,
        body: params
      }, function (err, res, body) {
        console.log('body', body);
        if (err) throw err;
        callback(body);
      });
    }
  }, {
    key: 'opt',
    value: function opt(route, params, callback) {
      request.post({
        url: this.optHost + '/' + route.replace(/^\//gi, ''),
        json: true,
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)
      }, function (err, res, body) {
        if (err) throw err;
        callback(body);
      });
    }
  }, {
    key: 'post2',
    value: function post2(url, params, callback) {
      request.post({
        url: url,
        json: true,
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)
      }, function (err, res, body) {
        if (err) throw err;
        callback(body);
      });
    }
  }, {
    key: 'get2',
    value: function get2(url, params, callback) {
      request.get({
        url: url,
        json: true,
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)
      }, function (err, res, body) {
        if (err) throw err;
        callback(body);
      });
    }
  }]);

  return GatewaySDK;
}();

/* harmony default export */ __webpack_exports__["a"] = (GatewaySDK);

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(2198);
var objectAssign = __webpack_require__(2199);
var decodeComponent = __webpack_require__(2200);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 2201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var AppSettings = function () {
  function AppSettings(sdk) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AppSettings);

    sdk.get('/appsettings', {}, function (response) {
      _this.config = response;
    }, '');
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AppSettings, [{
    key: 'get',
    value: function get(configName) {
      return this.config[configName];
    }
  }]);

  return AppSettings;
}();

/* harmony default export */ __webpack_exports__["a"] = (AppSettings);

/***/ }),
/* 2202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__smooth_scroll__ = __webpack_require__(2203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_storage__ = __webpack_require__(2204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__twilio_phone__ = __webpack_require__(2205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fcm__ = __webpack_require__(2206);







var Plugins = function () {
  function Plugins() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Plugins);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Plugins, [{
    key: 'install',
    value: function install(Vue, options) {
      var plugins = {
        storage: new __WEBPACK_IMPORTED_MODULE_3__local_storage__["a" /* default */](),
        phone: new __WEBPACK_IMPORTED_MODULE_4__twilio_phone__["a" /* default */](),
        smoothScroll: new __WEBPACK_IMPORTED_MODULE_2__smooth_scroll__["a" /* default */](),
        fcm: new __WEBPACK_IMPORTED_MODULE_5__fcm__["a" /* default */]()
      };
      Vue.prototype.$plugins = plugins;
    }
  }]);

  return Plugins;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Plugins());

/***/ }),
/* 2203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var SmoothScroll = function () {
  function SmoothScroll() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SmoothScroll);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(SmoothScroll, [{
    key: "scrollTo",
    value: function scrollTo(element) {
      var start = element.scrollTop,
          to = 0,
          duration = 250,
          change = to - start,
          currentTime = 0,
          increment = 20;

      var easeInOutQuad = function easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
      };

      var animateScroll = function animateScroll() {
        currentTime += increment;
        var val = easeInOutQuad(currentTime, start, change, duration);
        element.scrollTop = val;
        if (currentTime < duration) {
          setTimeout(animateScroll, increment);
        }
      };
      animateScroll();
    }
  }]);

  return SmoothScroll;
}();

/* harmony default export */ __webpack_exports__["a"] = (SmoothScroll);

/***/ }),
/* 2204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var LocalStorage = function () {
  function LocalStorage() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LocalStorage);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(LocalStorage, [{
    key: 'set',
    value: function set(key, value) {
      window.localStorage.setItem(key, value);
    }
  }, {
    key: 'get',
    value: function get(key) {
      return window.localStorage.getItem(key);
    }
  }, {
    key: 'remove',
    value: function remove(key) {
      window.localStorage.removeItem(key);
    }
  }, {
    key: 'setSessionToken',
    value: function setSessionToken(token) {
      this.set('ADMIN.SESSION_TOKEN', token);
    }
  }, {
    key: 'getSessionToken',
    value: function getSessionToken() {
      return this.get('ADMIN.SESSION_TOKEN');
    }
  }, {
    key: 'removeSessionToken',
    value: function removeSessionToken() {
      this.remove('ADMIN.SESSION_TOKEN');
    }

    // Geofences

  }, {
    key: 'setGeofenceByType',
    value: function setGeofenceByType(value) {
      this.set('geofenceType', value);
    }
  }, {
    key: 'getGeofenceByType',
    value: function getGeofenceByType() {
      return this.get('geofenceType');
    }
  }, {
    key: 'setGeofenceByStatus',
    value: function setGeofenceByStatus(value) {
      this.set('geofenceStatus', value);
    }
  }, {
    key: 'getGeofenceByStatus',
    value: function getGeofenceByStatus() {
      return this.get('geofenceStatus');
    }
  }, {
    key: 'setGeofenceByBrand',
    value: function setGeofenceByBrand(value) {
      this.set('geofenceBrand', value);
    }
  }, {
    key: 'getGeofenceByBrand',
    value: function getGeofenceByBrand() {
      return this.get('geofenceBrand');
    }

    // Pricing

  }, {
    key: 'setBrandInPricing',
    value: function setBrandInPricing(value) {
      this.set('pricingBrand', value);
    }
  }, {
    key: 'getBrandInPricing',
    value: function getBrandInPricing() {
      return this.get('pricingBrand');
    }

    // Service Management

  }, {
    key: 'setServiceBrand',
    value: function setServiceBrand(value) {
      this.set('serviceBrand', value);
    }
  }, {
    key: 'getServiceBrand',
    value: function getServiceBrand(value) {
      return this.get('serviceBrand');
    }
  }]);

  return LocalStorage;
}();

/* harmony default export */ __webpack_exports__["a"] = (LocalStorage);

/***/ }),
/* 2205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var TwilioPhone = function () {
  function TwilioPhone() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TwilioPhone);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(TwilioPhone, [{
    key: 'startCall',
    value: function startCall(VueApp, user) {
      if (true) return;
      // Check if there is an ongoing call
      if (VueApp.$store.state.phone.ongoing) {
        return;
      }
      console.log('CALLING');
      console.log(user);
      VueApp.$store.commit('phone/startCall', user);
      VueApp.$sdk.get('/twilio/token', {
        token: VueApp.$store.state.session.sessionToken
      }, function (r) {
        if (r.error) {
          return;
        }
        Twilio.Device.setup(r.token); // eslint-disable-line no-undef
      });

      Twilio.Device.ready(function (device) {
        // eslint-disable-line no-undef
        console.log('TWILIO READY');
        console.log(device);

        var connection = Twilio.Device.connect({ // eslint-disable-line no-undef
          'phone_number': user.phone
        });
        console.log(connection);
      });
      Twilio.Device.error(function (error) {
        // eslint-disable-line no-undef
        console.log(error);
        console.log('TWILIO ERROR: ' + error.message);
        // VueApp.$store.commit('phone/endCall')
      });
      Twilio.Device.connect(function (connection) {
        // eslint-disable-line no-undef
        console.log('TWILIO CONNECT');
        console.log(connection);
      });
      Twilio.Device.disconnect(function (connection) {
        // eslint-disable-line no-undef
        console.log('TWILIO DISCONNECT');
        console.log(connection);
        VueApp.$store.commit('phone/endCall');
      });
      Twilio.Device.offline(function (device) {
        // eslint-disable-line no-undef
        console.log('TWILIO OFFLINE');
        console.log(device);
        // VueApp.$store.commit('phone/endCall')
      });
      Twilio.Device.cancel(function (connection) {
        // eslint-disable-line no-undef
        console.log('TWILIO CANCEL');
        console.log(connection);
        // VueApp.$store.commit('phone/endCall')
      });
    }
  }, {
    key: 'endCall',
    value: function endCall(VueApp) {
      Twilio.Device.disconnectAll(); // eslint-disable-line no-undef
    }
  }, {
    key: 'toggleMute',
    value: function toggleMute(VueApp) {
      var connection = Twilio.Device.activeConnection();
      var isMute = connection.isMuted();

      connection.mute(function (mute, connection) {
        VueApp.$store.commit('phone/setMute', !isMute);
        console.log('MUTE');
        console.log(mute);
        console.log(connection);
      });

      connection.mute(!isMute);
    }
  }]);

  return TwilioPhone;
}();

/* harmony default export */ __webpack_exports__["a"] = (TwilioPhone);

/***/ }),
/* 2206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(2207);


/* global firebase */


var FCM = function () {
  function FCM() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FCM);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(FCM, [{
    key: 'init',
    value: function init(config) {
      var self = this;
      firebase.initializeApp(config);
    }
  }, {
    key: 'start',
    value: function start(VueApp) {
      var self = this;
      var messaging = firebase.messaging();
      messaging.requestPermission().then(function () {
        console.log('Notification permission granted.');
        VueApp.$store.commit('notificationPermission/hide');
        self.getToken(VueApp);
      }).catch(function (err) {
        console.log('Unable to get permission to notify.', err);
        VueApp.$store.commit('notificationPermission/show');
      });
    }
  }, {
    key: 'getToken',
    value: function getToken(VueApp) {
      var self = this;
      var messaging = firebase.messaging();

      var onError = function onError(err) {
        console.log('An error occurred while retrieving token. ', err);
      };

      var getToken = function getToken(currentToken) {
        if (currentToken) {
          console.log('FCM Token: ' + currentToken);
          VueApp.$store.commit('session/setNotificationToken', currentToken);
          VueApp.$sdk.post('/admin/notification/token', {
            token: VueApp.$store.state.session.sessionToken,
            notificationToken: currentToken
          }, function (r) {
            if (r.error) {
              console.log(r);
            }
          });
          return;
        }
        // Show permission request.
        console.log('No Instance ID token available. Request permission to generate one.');
      };

      // Get initial token
      messaging.getToken().then(getToken).catch(onError);

      // Monitor token refresh
      messaging.onTokenRefresh(function () {
        console.log('FCM Token Refresh');
        messaging.getToken().then(getToken).catch(onError);
      });

      // start listening to notifications
      messaging.onMessage(function (payload) {
        __WEBPACK_IMPORTED_MODULE_2__notifications__["a" /* default */].process(VueApp, payload);
      });
    }
  }, {
    key: 'deleteToken',
    value: function deleteToken(VueApp) {
      var notificationToken = VueApp.$store.state.session.notificationToken;
      if (notificationToken !== null) {
        var messaging = firebase.messaging();
        messaging.deleteToken(notificationToken);
      }
    }
  }]);

  return FCM;
}();

/* harmony default export */ __webpack_exports__["a"] = (FCM);

/***/ }),
/* 2207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notif_dispatch_accept__ = __webpack_require__(2208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notif_driver_status__ = __webpack_require__(2209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notif_reservation__ = __webpack_require__(2210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__notif_onoffduty__ = __webpack_require__(2211);







var Notifications = function () {
  function Notifications() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Notifications);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Notifications, [{
    key: 'process',
    value: function process(VueApp, payload) {
      console.log(payload);
      // read NID here...
      var data = payload.data;

      if (data.AID === 'BOOKING_STATUS') {
        __WEBPACK_IMPORTED_MODULE_4__notif_reservation__["a" /* default */].process(VueApp, data);
        return;
      }

      if (data.AID === 'DRIVER_STATUS') {
        __WEBPACK_IMPORTED_MODULE_3__notif_driver_status__["a" /* default */].process(VueApp, data);
        return;
      }

      if (data.AID === 'DISPATCH_ACCEPT') {
        __WEBPACK_IMPORTED_MODULE_2__notif_dispatch_accept__["a" /* default */].process(VueApp, data);
        return;
      }

      if (data.AID === 'ONOFF_DUTY') {
        __WEBPACK_IMPORTED_MODULE_5__notif_onoffduty__["a" /* default */].process(VueApp, data);
        return;
      }
    }
  }]);

  return Notifications;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Notifications());

/***/ }),
/* 2208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var NotifDispatchAccept = function () {
  function NotifDispatchAccept() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NotifDispatchAccept);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NotifDispatchAccept, [{
    key: 'process',
    value: function process(VueApp, payload) {
      VueApp.$store.commit('dispatch/showDispatchAcceptNotification', {
        show: true,
        accept: payload.accept === 'true',
        isPackage: payload.isPackage === 'true',
        id: parseInt(payload.id),
        driverId: payload.driverId === '' ? payload.driverId : parseInt(payload.driverId),
        driverName: payload.driverName,
        runsDeclined: false
      });
    }
  }]);

  return NotifDispatchAccept;
}();

/* harmony default export */ __webpack_exports__["a"] = (new NotifDispatchAccept());

/***/ }),
/* 2209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_dispatch_drivers__ = __webpack_require__(37);




var NotifDriverStatus = function () {
  function NotifDriverStatus() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NotifDriverStatus);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NotifDriverStatus, [{
    key: 'process',
    value: function process(VueApp, payload) {
      __WEBPACK_IMPORTED_MODULE_2__api_dispatch_drivers__["a" /* default */].updateDriverStatus(VueApp, payload.driverId);
    }
  }]);

  return NotifDriverStatus;
}();

/* harmony default export */ __webpack_exports__["a"] = (new NotifDriverStatus());

/***/ }),
/* 2210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_api_dispatch_reservations__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_api_routing_reservations__ = __webpack_require__(48);





var NotifReservation = function () {
  function NotifReservation() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NotifReservation);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NotifReservation, [{
    key: 'process',
    value: function process(VueApp, payload) {
      var self = this;
      var status = payload.status;

      if (payload.isPackage === 'true' && (payload.status === 'remove-from-pool' || payload.status === 'move-to-pool' || payload.status === 'break')) {
        self.updatePackagePoolStatus(VueApp, payload);
      }
      self.update(VueApp, payload);
    }
  }, {
    key: 'updatePackagePoolStatus',
    value: function updatePackagePoolStatus(VueApp, payload) {
      if (payload.status === 'break') {
        // TODO: show reservations in unpackaged
        return;
      }
      VueApp.$store.commit('routing/updatePackagePoolStatus', {
        id: parseInt(payload.id),
        inPool: payload.status === 'move-to-pool'
      });
    }
  }, {
    key: 'update',
    value: function update(VueApp, payload) {
      var item = {
        id: parseInt(payload.id),
        isPackage: payload.isPackage === 'true'
      };

      if (payload.forRouting === 'false') {
        __WEBPACK_IMPORTED_MODULE_2__modules_api_dispatch_reservations__["a" /* default */].updateItemInTable(VueApp, item);
      }
      __WEBPACK_IMPORTED_MODULE_3__modules_api_routing_reservations__["a" /* default */].updateItemsInTables(VueApp, item);
      /*
      if (payload.isPackage === 'true' &&
         (payload.status === 'update' ||
          payload.status === 'accept' ||
          payload.status === 'create' ||
          payload.status === 'cancel' ||
          payload.status === 'break')) {
        ApiRoutingReservation.updateItemsInTables(VueApp, item)
        return
      }
        if (payload.isPackage !== 'true') {
        ApiRoutingReservation.updateItemsInTables(VueApp, item)
      }
      */
    }
  }]);

  return NotifReservation;
}();

/* harmony default export */ __webpack_exports__["a"] = (new NotifReservation());

/***/ }),
/* 2211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_dispatch_drivers__ = __webpack_require__(37);




var NotifOnOffDuty = function () {
  function NotifOnOffDuty() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NotifOnOffDuty);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NotifOnOffDuty, [{
    key: 'process',
    value: function process(VueApp, payload) {
      var onDuty = payload.onDuty === 'true';
      var driverId = payload.driverId;

      __WEBPACK_IMPORTED_MODULE_2__api_dispatch_drivers__["a" /* default */].updateDriverLists(VueApp, driverId, onDuty);
    }
  }]);

  return NotifOnOffDuty;
}();

/* harmony default export */ __webpack_exports__["a"] = (new NotifOnOffDuty());

/***/ }),
/* 2212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.3
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */
var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;
function Promise$1(executor) {
  this.state = PENDING;
  this.value = undefined;
  this.deferred = [];
  var promise = this;

  try {
    executor(function (x) {
      promise.resolve(x);
    }, function (r) {
      promise.reject(r);
    });
  } catch (e) {
    promise.reject(e);
  }
}

Promise$1.reject = function (r) {
  return new Promise$1(function (resolve, reject) {
    reject(r);
  });
};

Promise$1.resolve = function (x) {
  return new Promise$1(function (resolve, reject) {
    resolve(x);
  });
};

Promise$1.all = function all(iterable) {
  return new Promise$1(function (resolve, reject) {
    var count = 0,
        result = [];

    if (iterable.length === 0) {
      resolve(result);
    }

    function resolver(i) {
      return function (x) {
        result[i] = x;
        count += 1;

        if (count === iterable.length) {
          resolve(result);
        }
      };
    }

    for (var i = 0; i < iterable.length; i += 1) {
      Promise$1.resolve(iterable[i]).then(resolver(i), reject);
    }
  });
};

Promise$1.race = function race(iterable) {
  return new Promise$1(function (resolve, reject) {
    for (var i = 0; i < iterable.length; i += 1) {
      Promise$1.resolve(iterable[i]).then(resolve, reject);
    }
  });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
  var promise = this;

  if (promise.state === PENDING) {
    if (x === promise) {
      throw new TypeError('Promise settled with itself.');
    }

    var called = false;

    try {
      var then = x && x['then'];

      if (x !== null && typeof x === 'object' && typeof then === 'function') {
        then.call(x, function (x) {
          if (!called) {
            promise.resolve(x);
          }

          called = true;
        }, function (r) {
          if (!called) {
            promise.reject(r);
          }

          called = true;
        });
        return;
      }
    } catch (e) {
      if (!called) {
        promise.reject(e);
      }

      return;
    }

    promise.state = RESOLVED;
    promise.value = x;
    promise.notify();
  }
};

p.reject = function reject(reason) {
  var promise = this;

  if (promise.state === PENDING) {
    if (reason === promise) {
      throw new TypeError('Promise settled with itself.');
    }

    promise.state = REJECTED;
    promise.value = reason;
    promise.notify();
  }
};

p.notify = function notify() {
  var promise = this;
  nextTick(function () {
    if (promise.state !== PENDING) {
      while (promise.deferred.length) {
        var deferred = promise.deferred.shift(),
            onResolved = deferred[0],
            onRejected = deferred[1],
            resolve = deferred[2],
            reject = deferred[3];

        try {
          if (promise.state === RESOLVED) {
            if (typeof onResolved === 'function') {
              resolve(onResolved.call(undefined, promise.value));
            } else {
              resolve(promise.value);
            }
          } else if (promise.state === REJECTED) {
            if (typeof onRejected === 'function') {
              resolve(onRejected.call(undefined, promise.value));
            } else {
              reject(promise.value);
            }
          }
        } catch (e) {
          reject(e);
        }
      }
    }
  });
};

p.then = function then(onResolved, onRejected) {
  var promise = this;
  return new Promise$1(function (resolve, reject) {
    promise.deferred.push([onResolved, onRejected, resolve, reject]);
    promise.notify();
  });
};

p["catch"] = function (onRejected) {
  return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
  window.Promise = Promise$1;
}

function PromiseObj(executor, context) {
  if (executor instanceof Promise) {
    this.promise = executor;
  } else {
    this.promise = new Promise(executor.bind(context));
  }

  this.context = context;
}

PromiseObj.all = function (iterable, context) {
  return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
  return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
  return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
  return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
  this.context = context;
  return this;
};

p$1.then = function (fulfilled, rejected) {
  if (fulfilled && fulfilled.bind && this.context) {
    fulfilled = fulfilled.bind(this.context);
  }

  if (rejected && rejected.bind && this.context) {
    rejected = rejected.bind(this.context);
  }

  return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1["catch"] = function (rejected) {
  if (rejected && rejected.bind && this.context) {
    rejected = rejected.bind(this.context);
  }

  return new PromiseObj(this.promise["catch"](rejected), this.context);
};

p$1["finally"] = function (callback) {
  return this.then(function (value) {
    callback.call(this);
    return value;
  }, function (reason) {
    callback.call(this);
    return Promise.reject(reason);
  });
};

/**
 * Utility functions.
 */
var _ref = {},
    hasOwnProperty = _ref.hasOwnProperty,
    slice = [].slice,
    debug = false,
    ntick;
var inBrowser = typeof window !== 'undefined';
function Util (_ref2) {
  var config = _ref2.config,
      nextTick = _ref2.nextTick;
  ntick = nextTick;
  debug = config.debug || !config.silent;
}
function warn(msg) {
  if (typeof console !== 'undefined' && debug) {
    console.warn('[VueResource warn]: ' + msg);
  }
}
function error(msg) {
  if (typeof console !== 'undefined') {
    console.error(msg);
  }
}
function nextTick(cb, ctx) {
  return ntick(cb, ctx);
}
function trim(str) {
  return str ? str.replace(/^\s*|\s*$/g, '') : '';
}
function trimEnd(str, chars) {
  if (str && chars === undefined) {
    return str.replace(/\s+$/, '');
  }

  if (!str || !chars) {
    return str;
  }

  return str.replace(new RegExp("[" + chars + "]+$"), '');
}
function toLower(str) {
  return str ? str.toLowerCase() : '';
}
function toUpper(str) {
  return str ? str.toUpperCase() : '';
}
var isArray = Array.isArray;
function isString(val) {
  return typeof val === 'string';
}
function isFunction(val) {
  return typeof val === 'function';
}
function isObject(obj) {
  return obj !== null && typeof obj === 'object';
}
function isPlainObject(obj) {
  return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}
function isBlob(obj) {
  return typeof Blob !== 'undefined' && obj instanceof Blob;
}
function isFormData(obj) {
  return typeof FormData !== 'undefined' && obj instanceof FormData;
}
function when(value, fulfilled, rejected) {
  var promise = PromiseObj.resolve(value);

  if (arguments.length < 2) {
    return promise;
  }

  return promise.then(fulfilled, rejected);
}
function options(fn, obj, opts) {
  opts = opts || {};

  if (isFunction(opts)) {
    opts = opts.call(obj);
  }

  return merge(fn.bind({
    $vm: obj,
    $options: opts
  }), fn, {
    $options: opts
  });
}
function each(obj, iterator) {
  var i, key;

  if (isArray(obj)) {
    for (i = 0; i < obj.length; i++) {
      iterator.call(obj[i], obj[i], i);
    }
  } else if (isObject(obj)) {
    for (key in obj) {
      if (hasOwnProperty.call(obj, key)) {
        iterator.call(obj[key], obj[key], key);
      }
    }
  }

  return obj;
}
var assign = Object.assign || _assign;
function merge(target) {
  var args = slice.call(arguments, 1);
  args.forEach(function (source) {
    _merge(target, source, true);
  });
  return target;
}
function defaults(target) {
  var args = slice.call(arguments, 1);
  args.forEach(function (source) {
    for (var key in source) {
      if (target[key] === undefined) {
        target[key] = source[key];
      }
    }
  });
  return target;
}

function _assign(target) {
  var args = slice.call(arguments, 1);
  args.forEach(function (source) {
    _merge(target, source);
  });
  return target;
}

function _merge(target, source, deep) {
  for (var key in source) {
    if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
      if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
        target[key] = {};
      }

      if (isArray(source[key]) && !isArray(target[key])) {
        target[key] = [];
      }

      _merge(target[key], source[key], deep);
    } else if (source[key] !== undefined) {
      target[key] = source[key];
    }
  }
}

/**
 * Root Prefix Transform.
 */
function root (options$$1, next) {
  var url = next(options$$1);

  if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
    url = trimEnd(options$$1.root, '/') + '/' + url;
  }

  return url;
}

/**
 * Query Parameter Transform.
 */
function query (options$$1, next) {
  var urlParams = Object.keys(Url.options.params),
      query = {},
      url = next(options$$1);
  each(options$$1.params, function (value, key) {
    if (urlParams.indexOf(key) === -1) {
      query[key] = value;
    }
  });
  query = Url.params(query);

  if (query) {
    url += (url.indexOf('?') == -1 ? '?' : '&') + query;
  }

  return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */
function expand(url, params, variables) {
  var tmpl = parse(url),
      expanded = tmpl.expand(params);

  if (variables) {
    variables.push.apply(variables, tmpl.vars);
  }

  return expanded;
}
function parse(template) {
  var operators = ['+', '#', '.', '/', ';', '?', '&'],
      variables = [];
  return {
    vars: variables,
    expand: function expand(context) {
      return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
        if (expression) {
          var operator = null,
              values = [];

          if (operators.indexOf(expression.charAt(0)) !== -1) {
            operator = expression.charAt(0);
            expression = expression.substr(1);
          }

          expression.split(/,/g).forEach(function (variable) {
            var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
            values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
            variables.push(tmp[1]);
          });

          if (operator && operator !== '+') {
            var separator = ',';

            if (operator === '?') {
              separator = '&';
            } else if (operator !== '#') {
              separator = operator;
            }

            return (values.length !== 0 ? operator : '') + values.join(separator);
          } else {
            return values.join(',');
          }
        } else {
          return encodeReserved(literal);
        }
      });
    }
  };
}

function getValues(context, operator, key, modifier) {
  var value = context[key],
      result = [];

  if (isDefined(value) && value !== '') {
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      value = value.toString();

      if (modifier && modifier !== '*') {
        value = value.substring(0, parseInt(modifier, 10));
      }

      result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
    } else {
      if (modifier === '*') {
        if (Array.isArray(value)) {
          value.filter(isDefined).forEach(function (value) {
            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
          });
        } else {
          Object.keys(value).forEach(function (k) {
            if (isDefined(value[k])) {
              result.push(encodeValue(operator, value[k], k));
            }
          });
        }
      } else {
        var tmp = [];

        if (Array.isArray(value)) {
          value.filter(isDefined).forEach(function (value) {
            tmp.push(encodeValue(operator, value));
          });
        } else {
          Object.keys(value).forEach(function (k) {
            if (isDefined(value[k])) {
              tmp.push(encodeURIComponent(k));
              tmp.push(encodeValue(operator, value[k].toString()));
            }
          });
        }

        if (isKeyOperator(operator)) {
          result.push(encodeURIComponent(key) + '=' + tmp.join(','));
        } else if (tmp.length !== 0) {
          result.push(tmp.join(','));
        }
      }
    }
  } else {
    if (operator === ';') {
      result.push(encodeURIComponent(key));
    } else if (value === '' && (operator === '&' || operator === '?')) {
      result.push(encodeURIComponent(key) + '=');
    } else if (value === '') {
      result.push('');
    }
  }

  return result;
}

function isDefined(value) {
  return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
  return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {
  value = operator === '+' || operator === '#' ? encodeReserved(value) : encodeURIComponent(value);

  if (key) {
    return encodeURIComponent(key) + '=' + value;
  } else {
    return value;
  }
}

function encodeReserved(str) {
  return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
    if (!/%[0-9A-Fa-f]/.test(part)) {
      part = encodeURI(part);
    }

    return part;
  }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */
function template (options) {
  var variables = [],
      url = expand(options.url, options.params, variables);
  variables.forEach(function (key) {
    delete options.params[key];
  });
  return url;
}

/**
 * Service for URL templating.
 */
function Url(url, params) {
  var self = this || {},
      options$$1 = url,
      transform;

  if (isString(url)) {
    options$$1 = {
      url: url,
      params: params
    };
  }

  options$$1 = merge({}, Url.options, self.$options, options$$1);
  Url.transforms.forEach(function (handler) {
    if (isString(handler)) {
      handler = Url.transform[handler];
    }

    if (isFunction(handler)) {
      transform = factory(handler, transform, self.$vm);
    }
  });
  return transform(options$$1);
}
/**
 * Url options.
 */

Url.options = {
  url: '',
  root: null,
  params: {}
};
/**
 * Url transforms.
 */

Url.transform = {
  template: template,
  query: query,
  root: root
};
Url.transforms = ['template', 'query', 'root'];
/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {
  var params = [],
      escape = encodeURIComponent;

  params.add = function (key, value) {
    if (isFunction(value)) {
      value = value();
    }

    if (value === null) {
      value = '';
    }

    this.push(escape(key) + '=' + escape(value));
  };

  serialize(params, obj);
  return params.join('&').replace(/%20/g, '+');
};
/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */


Url.parse = function (url) {
  var el = document.createElement('a');

  if (document.documentMode) {
    el.href = url;
    url = el.href;
  }

  el.href = url;
  return {
    href: el.href,
    protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
    port: el.port,
    host: el.host,
    hostname: el.hostname,
    pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
    search: el.search ? el.search.replace(/^\?/, '') : '',
    hash: el.hash ? el.hash.replace(/^#/, '') : ''
  };
};

function factory(handler, next, vm) {
  return function (options$$1) {
    return handler.call(vm, options$$1, next);
  };
}

function serialize(params, obj, scope) {
  var array = isArray(obj),
      plain = isPlainObject(obj),
      hash;
  each(obj, function (value, key) {
    hash = isObject(value) || isArray(value);

    if (scope) {
      key = scope + '[' + (plain || hash ? key : '') + ']';
    }

    if (!scope && array) {
      params.add(value.name, value.value);
    } else if (hash) {
      serialize(params, value, key);
    } else {
      params.add(key, value);
    }
  });
}

/**
 * XDomain client (Internet Explorer).
 */
function xdrClient (request) {
  return new PromiseObj(function (resolve) {
    var xdr = new XDomainRequest(),
        handler = function handler(_ref) {
      var type = _ref.type;
      var status = 0;

      if (type === 'load') {
        status = 200;
      } else if (type === 'error') {
        status = 500;
      }

      resolve(request.respondWith(xdr.responseText, {
        status: status
      }));
    };

    request.abort = function () {
      return xdr.abort();
    };

    xdr.open(request.method, request.getUrl());

    if (request.timeout) {
      xdr.timeout = request.timeout;
    }

    xdr.onload = handler;
    xdr.onabort = handler;
    xdr.onerror = handler;
    xdr.ontimeout = handler;

    xdr.onprogress = function () {};

    xdr.send(request.getBody());
  });
}

/**
 * CORS Interceptor.
 */
var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();
function cors (request) {
  if (inBrowser) {
    var orgUrl = Url.parse(location.href);
    var reqUrl = Url.parse(request.getUrl());

    if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {
      request.crossOrigin = true;
      request.emulateHTTP = false;

      if (!SUPPORTS_CORS) {
        request.client = xdrClient;
      }
    }
  }
}

/**
 * Form data Interceptor.
 */
function form (request) {
  if (isFormData(request.body)) {
    request.headers["delete"]('Content-Type');
  } else if (isObject(request.body) && request.emulateJSON) {
    request.body = Url.params(request.body);
    request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
  }
}

/**
 * JSON Interceptor.
 */
function json (request) {
  var type = request.headers.get('Content-Type') || '';

  if (isObject(request.body) && type.indexOf('application/json') === 0) {
    request.body = JSON.stringify(request.body);
  }

  return function (response) {
    return response.bodyText ? when(response.text(), function (text) {
      var type = response.headers.get('Content-Type') || '';

      if (type.indexOf('application/json') === 0 || isJson(text)) {
        try {
          response.body = JSON.parse(text);
        } catch (e) {
          response.body = null;
        }
      } else {
        response.body = text;
      }

      return response;
    }) : response;
  };
}

function isJson(str) {
  var start = str.match(/^\s*(\[|\{)/);
  var end = {
    '[': /]\s*$/,
    '{': /}\s*$/
  };
  return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */
function jsonpClient (request) {
  return new PromiseObj(function (resolve) {
    var name = request.jsonp || 'callback',
        callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2),
        body = null,
        handler,
        script;

    handler = function handler(_ref) {
      var type = _ref.type;
      var status = 0;

      if (type === 'load' && body !== null) {
        status = 200;
      } else if (type === 'error') {
        status = 500;
      }

      if (status && window[callback]) {
        delete window[callback];
        document.body.removeChild(script);
      }

      resolve(request.respondWith(body, {
        status: status
      }));
    };

    window[callback] = function (result) {
      body = JSON.stringify(result);
    };

    request.abort = function () {
      handler({
        type: 'abort'
      });
    };

    request.params[name] = callback;

    if (request.timeout) {
      setTimeout(request.abort, request.timeout);
    }

    script = document.createElement('script');
    script.src = request.getUrl();
    script.type = 'text/javascript';
    script.async = true;
    script.onload = handler;
    script.onerror = handler;
    document.body.appendChild(script);
  });
}

/**
 * JSONP Interceptor.
 */
function jsonp (request) {
  if (request.method == 'JSONP') {
    request.client = jsonpClient;
  }
}

/**
 * Before Interceptor.
 */
function before (request) {
  if (isFunction(request.before)) {
    request.before.call(this, request);
  }
}

/**
 * HTTP method override Interceptor.
 */
function method (request) {
  if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
    request.headers.set('X-HTTP-Method-Override', request.method);
    request.method = 'POST';
  }
}

/**
 * Header Interceptor.
 */
function header (request) {
  var headers = assign({}, Http.headers.common, !request.crossOrigin ? Http.headers.custom : {}, Http.headers[toLower(request.method)]);
  each(headers, function (value, name) {
    if (!request.headers.has(name)) {
      request.headers.set(name, value);
    }
  });
}

/**
 * XMLHttp client (Browser).
 */
function xhrClient (request) {
  return new PromiseObj(function (resolve) {
    var xhr = new XMLHttpRequest(),
        handler = function handler(event) {
      var response = request.respondWith('response' in xhr ? xhr.response : xhr.responseText, {
        status: xhr.status === 1223 ? 204 : xhr.status,
        // IE9 status bug
        statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
      });
      each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
        response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
      });
      resolve(response);
    };

    request.abort = function () {
      return xhr.abort();
    };

    xhr.open(request.method, request.getUrl(), true);

    if (request.timeout) {
      xhr.timeout = request.timeout;
    }

    if (request.responseType && 'responseType' in xhr) {
      xhr.responseType = request.responseType;
    }

    if (request.withCredentials || request.credentials) {
      xhr.withCredentials = true;
    }

    if (!request.crossOrigin) {
      request.headers.set('X-Requested-With', 'XMLHttpRequest');
    } // deprecated use downloadProgress


    if (isFunction(request.progress) && request.method === 'GET') {
      xhr.addEventListener('progress', request.progress);
    }

    if (isFunction(request.downloadProgress)) {
      xhr.addEventListener('progress', request.downloadProgress);
    } // deprecated use uploadProgress


    if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
      xhr.upload.addEventListener('progress', request.progress);
    }

    if (isFunction(request.uploadProgress) && xhr.upload) {
      xhr.upload.addEventListener('progress', request.uploadProgress);
    }

    request.headers.forEach(function (value, name) {
      xhr.setRequestHeader(name, value);
    });
    xhr.onload = handler;
    xhr.onabort = handler;
    xhr.onerror = handler;
    xhr.ontimeout = handler;
    xhr.send(request.getBody());
  });
}

/**
 * Http client (Node).
 */
function nodeClient (request) {
  var client = __webpack_require__(2213);

  return new PromiseObj(function (resolve) {
    var url = request.getUrl();
    var body = request.getBody();
    var method = request.method;
    var headers = {},
        handler;
    request.headers.forEach(function (value, name) {
      headers[name] = value;
    });
    client(url, {
      body: body,
      method: method,
      headers: headers
    }).then(handler = function handler(resp) {
      var response = request.respondWith(resp.body, {
        status: resp.statusCode,
        statusText: trim(resp.statusMessage)
      });
      each(resp.headers, function (value, name) {
        response.headers.set(name, value);
      });
      resolve(response);
    }, function (error$$1) {
      return handler(error$$1.response);
    });
  });
}

/**
 * Base client.
 */
function Client (context) {
  var reqHandlers = [sendRequest],
      resHandlers = [];

  if (!isObject(context)) {
    context = null;
  }

  function Client(request) {
    while (reqHandlers.length) {
      var handler = reqHandlers.pop();

      if (isFunction(handler)) {
        var _ret = function () {
          var response = void 0,
              next = void 0;
          response = handler.call(context, request, function (val) {
            return next = val;
          }) || next;

          if (isObject(response)) {
            return {
              v: new PromiseObj(function (resolve, reject) {
                resHandlers.forEach(function (handler) {
                  response = when(response, function (response) {
                    return handler.call(context, response) || response;
                  }, reject);
                });
                when(response, resolve, reject);
              }, context)
            };
          }

          if (isFunction(response)) {
            resHandlers.unshift(response);
          }
        }();

        if (typeof _ret === "object") return _ret.v;
      } else {
        warn("Invalid interceptor of type " + typeof handler + ", must be a function");
      }
    }
  }

  Client.use = function (handler) {
    reqHandlers.push(handler);
  };

  return Client;
}

function sendRequest(request) {
  var client = request.client || (inBrowser ? xhrClient : nodeClient);
  return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = /*#__PURE__*/function () {
  function Headers(headers) {
    var _this = this;

    this.map = {};
    each(headers, function (value, name) {
      return _this.append(name, value);
    });
  }

  var _proto = Headers.prototype;

  _proto.has = function has(name) {
    return getName(this.map, name) !== null;
  };

  _proto.get = function get(name) {
    var list = this.map[getName(this.map, name)];
    return list ? list.join() : null;
  };

  _proto.getAll = function getAll(name) {
    return this.map[getName(this.map, name)] || [];
  };

  _proto.set = function set(name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
  };

  _proto.append = function append(name, value) {
    var list = this.map[getName(this.map, name)];

    if (list) {
      list.push(trim(value));
    } else {
      this.set(name, value);
    }
  };

  _proto["delete"] = function _delete(name) {
    delete this.map[getName(this.map, name)];
  };

  _proto.deleteAll = function deleteAll() {
    this.map = {};
  };

  _proto.forEach = function forEach(callback, thisArg) {
    var _this2 = this;

    each(this.map, function (list, name) {
      each(list, function (value) {
        return callback.call(thisArg, value, name, _this2);
      });
    });
  };

  return Headers;
}();

function getName(map, name) {
  return Object.keys(map).reduce(function (prev, curr) {
    return toLower(name) === toLower(curr) ? curr : prev;
  }, null);
}

function normalizeName(name) {
  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
    throw new TypeError('Invalid character in header field name');
  }

  return trim(name);
}

/**
 * HTTP Response.
 */

var Response = /*#__PURE__*/function () {
  function Response(body, _ref) {
    var url = _ref.url,
        headers = _ref.headers,
        status = _ref.status,
        statusText = _ref.statusText;
    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {
      this.bodyText = body;
    } else if (isBlob(body)) {
      this.bodyBlob = body;

      if (isBlobText(body)) {
        this.bodyText = blobText(body);
      }
    }
  }

  var _proto = Response.prototype;

  _proto.blob = function blob() {
    return when(this.bodyBlob);
  };

  _proto.text = function text() {
    return when(this.bodyText);
  };

  _proto.json = function json() {
    return when(this.text(), function (text) {
      return JSON.parse(text);
    });
  };

  return Response;
}();
Object.defineProperty(Response.prototype, 'data', {
  get: function get() {
    return this.body;
  },
  set: function set(body) {
    this.body = body;
  }
});

function blobText(body) {
  return new PromiseObj(function (resolve) {
    var reader = new FileReader();
    reader.readAsText(body);

    reader.onload = function () {
      resolve(reader.result);
    };
  });
}

function isBlobText(body) {
  return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = /*#__PURE__*/function () {
  function Request(options$$1) {
    this.body = null;
    this.params = {};
    assign(this, options$$1, {
      method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
      this.headers = new Headers(this.headers);
    }
  }

  var _proto = Request.prototype;

  _proto.getUrl = function getUrl() {
    return Url(this);
  };

  _proto.getBody = function getBody() {
    return this.body;
  };

  _proto.respondWith = function respondWith(body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {
      url: this.getUrl()
    }));
  };

  return Request;
}();

/**
 * Service for sending network requests.
 */
var COMMON_HEADERS = {
  'Accept': 'application/json, text/plain, */*'
};
var JSON_CONTENT_TYPE = {
  'Content-Type': 'application/json;charset=utf-8'
};
function Http(options$$1) {
  var self = this || {},
      client = Client(self.$vm);
  defaults(options$$1 || {}, self.$options, Http.options);
  Http.interceptors.forEach(function (handler) {
    if (isString(handler)) {
      handler = Http.interceptor[handler];
    }

    if (isFunction(handler)) {
      client.use(handler);
    }
  });
  return client(new Request(options$$1)).then(function (response) {
    return response.ok ? response : PromiseObj.reject(response);
  }, function (response) {
    if (response instanceof Error) {
      error(response);
    }

    return PromiseObj.reject(response);
  });
}
Http.options = {};
Http.headers = {
  put: JSON_CONTENT_TYPE,
  post: JSON_CONTENT_TYPE,
  patch: JSON_CONTENT_TYPE,
  "delete": JSON_CONTENT_TYPE,
  common: COMMON_HEADERS,
  custom: {}
};
Http.interceptor = {
  before: before,
  method: method,
  jsonp: jsonp,
  json: json,
  form: form,
  header: header,
  cors: cors
};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];
['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {
  Http[method$$1] = function (url, options$$1) {
    return this(assign(options$$1 || {}, {
      url: url,
      method: method$$1
    }));
  };
});
['post', 'put', 'patch'].forEach(function (method$$1) {
  Http[method$$1] = function (url, body, options$$1) {
    return this(assign(options$$1 || {}, {
      url: url,
      method: method$$1,
      body: body
    }));
  };
});

/**
 * Service for interacting with RESTful services.
 */
function Resource(url, params, actions, options$$1) {
  var self = this || {},
      resource = {};
  actions = assign({}, Resource.actions, actions);
  each(actions, function (action, name) {
    action = merge({
      url: url,
      params: assign({}, params)
    }, options$$1, action);

    resource[name] = function () {
      return (self.$http || Http)(opts(action, arguments));
    };
  });
  return resource;
}

function opts(action, args) {
  var options$$1 = assign({}, action),
      params = {},
      body;

  switch (args.length) {
    case 2:
      params = args[0];
      body = args[1];
      break;

    case 1:
      if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
        body = args[0];
      } else {
        params = args[0];
      }

      break;

    case 0:
      break;

    default:
      throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
  }

  options$$1.body = body;
  options$$1.params = assign({}, options$$1.params, params);
  return options$$1;
}

Resource.actions = {
  get: {
    method: 'GET'
  },
  save: {
    method: 'POST'
  },
  query: {
    method: 'GET'
  },
  update: {
    method: 'PUT'
  },
  remove: {
    method: 'DELETE'
  },
  "delete": {
    method: 'DELETE'
  }
};

/**
 * Install plugin.
 */

function plugin(Vue) {
  if (plugin.installed) {
    return;
  }

  Util(Vue);
  Vue.url = Url;
  Vue.http = Http;
  Vue.resource = Resource;
  Vue.Promise = PromiseObj;
  Object.defineProperties(Vue.prototype, {
    $url: {
      get: function get() {
        return options(Vue.url, this, this.$options.url);
      }
    },
    $http: {
      get: function get() {
        return options(Vue.http, this, this.$options.http);
      }
    },
    $resource: {
      get: function get() {
        return Vue.resource.bind(this);
      }
    },
    $promise: {
      get: function get() {
        var _this = this;

        return function (executor) {
          return new Vue.Promise(executor, _this);
        };
      }
    }
  });
}

if (typeof window !== 'undefined' && window.Vue && !window.Vue.resource) {
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 2213 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {module.exports=function(modules){function __webpack_require__(moduleId){if(installedModules[moduleId])return installedModules[moduleId].exports;var module=installedModules[moduleId]={i:moduleId,l:!1,exports:{}};return modules[moduleId].call(module.exports,module,module.exports,__webpack_require__),module.l=!0,module.exports}var installedModules={};return __webpack_require__.m=modules,__webpack_require__.c=installedModules,__webpack_require__.d=function(exports,name,getter){__webpack_require__.o(exports,name)||Object.defineProperty(exports,name,{configurable:!1,enumerable:!0,get:getter})},__webpack_require__.n=function(module){var getter=module&&module.__esModule?function(){return module.default}:function(){return module};return __webpack_require__.d(getter,"a",getter),getter},__webpack_require__.o=function(object,property){return Object.prototype.hasOwnProperty.call(object,property)},__webpack_require__.p="",__webpack_require__(__webpack_require__.s=19)}([function(module,exports){var global=module.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=global)},function(module,exports){var core=module.exports={version:"2.5.3"};"number"==typeof __e&&(__e=core)},function(module,exports){module.exports=function(it){return"object"==typeof it?null!==it:"function"==typeof it}},function(module,exports,__webpack_require__){var dP=__webpack_require__(23),createDesc=__webpack_require__(28);module.exports=__webpack_require__(4)?function(object,key,value){return dP.f(object,key,createDesc(1,value))}:function(object,key,value){return object[key]=value,object}},function(module,exports,__webpack_require__){module.exports=!__webpack_require__(6)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(module,exports,__webpack_require__){var global=__webpack_require__(0),core=__webpack_require__(1),hide=__webpack_require__(3),redefine=__webpack_require__(29),ctx=__webpack_require__(8),$export=function(type,name,source){var key,own,out,exp,IS_FORCED=type&$export.F,IS_GLOBAL=type&$export.G,IS_STATIC=type&$export.S,IS_PROTO=type&$export.P,IS_BIND=type&$export.B,target=IS_GLOBAL?global:IS_STATIC?global[name]||(global[name]={}):(global[name]||{}).prototype,exports=IS_GLOBAL?core:core[name]||(core[name]={}),expProto=exports.prototype||(exports.prototype={});IS_GLOBAL&&(source=name);for(key in source)own=!IS_FORCED&&target&&void 0!==target[key],out=(own?target:source)[key],exp=IS_BIND&&own?ctx(out,global):IS_PROTO&&"function"==typeof out?ctx(Function.call,out):out,target&&redefine(target,key,out,type&$export.U),exports[key]!=out&&hide(exports,key,exp),IS_PROTO&&expProto[key]!=out&&(expProto[key]=out)};global.core=core,$export.F=1,$export.G=2,$export.S=4,$export.P=8,$export.B=16,$export.W=32,$export.U=64,$export.R=128,module.exports=$export},function(module,exports){module.exports=function(exec){try{return!!exec()}catch(e){return!0}}},function(module,exports){var id=0,px=Math.random();module.exports=function(key){return"Symbol(".concat(void 0===key?"":key,")_",(++id+px).toString(36))}},function(module,exports,__webpack_require__){var aFunction=__webpack_require__(31);module.exports=function(fn,that,length){if(aFunction(fn),void 0===that)return fn;switch(length){case 1:return function(a){return fn.call(that,a)};case 2:return function(a,b){return fn.call(that,a,b)};case 3:return function(a,b,c){return fn.call(that,a,b,c)}}return function(){return fn.apply(that,arguments)}}},function(module,exports,__webpack_require__){var cof=__webpack_require__(10);module.exports=Object("z").propertyIsEnumerable(0)?Object:function(it){return"String"==cof(it)?it.split(""):Object(it)}},function(module,exports){var toString={}.toString;module.exports=function(it){return toString.call(it).slice(8,-1)}},function(module,exports){module.exports=function(it){if(void 0==it)throw TypeError("Can't call method on  "+it);return it}},function(module,exports,__webpack_require__){var toInteger=__webpack_require__(13),min=Math.min;module.exports=function(it){return it>0?min(toInteger(it),9007199254740991):0}},function(module,exports){var ceil=Math.ceil,floor=Math.floor;module.exports=function(it){return isNaN(it=+it)?0:(it>0?floor:ceil)(it)}},function(module,exports,__webpack_require__){var UNSCOPABLES=__webpack_require__(15)("unscopables"),ArrayProto=Array.prototype;void 0==ArrayProto[UNSCOPABLES]&&__webpack_require__(3)(ArrayProto,UNSCOPABLES,{}),module.exports=function(key){ArrayProto[UNSCOPABLES][key]=!0}},function(module,exports,__webpack_require__){var store=__webpack_require__(35)("wks"),uid=__webpack_require__(7),Symbol=__webpack_require__(0).Symbol,USE_SYMBOL="function"==typeof Symbol;(module.exports=function(name){return store[name]||(store[name]=USE_SYMBOL&&Symbol[name]||(USE_SYMBOL?Symbol:uid)("Symbol."+name))}).store=store},function(module,exports){module.exports=function(rawScriptExports,compiledTemplate,injectStyles,scopeId,moduleIdentifier){var esModule,scriptExports=rawScriptExports=rawScriptExports||{},type=typeof rawScriptExports.default;"object"!==type&&"function"!==type||(esModule=rawScriptExports,scriptExports=rawScriptExports.default);var options="function"==typeof scriptExports?scriptExports.options:scriptExports;compiledTemplate&&(options.render=compiledTemplate.render,options.staticRenderFns=compiledTemplate.staticRenderFns),scopeId&&(options._scopeId=scopeId);var hook;if(moduleIdentifier?(hook=function(context){context=context||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,context||"undefined"==typeof __VUE_SSR_CONTEXT__||(context=__VUE_SSR_CONTEXT__),injectStyles&&injectStyles.call(this,context),context&&context._registeredComponents&&context._registeredComponents.add(moduleIdentifier)},options._ssrRegister=hook):injectStyles&&(hook=injectStyles),hook){var functional=options.functional,existing=functional?options.render:options.beforeCreate;functional?options.render=function(h,context){return hook.call(context),existing(h,context)}:options.beforeCreate=existing?[].concat(existing,hook):[hook]}return{esModule:esModule,exports:scriptExports,options:options}}},function(module,exports,__webpack_require__){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.transferDataStore={}},function(module,exports,__webpack_require__){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var keyMirror=function(keys){return keys.reduce(function(acc,k){return(acc[k]=k)&&acc},{})},mimeType=exports.mimeType="text/x-vue-drag-drop-key",mimeDelimiter=exports.mimeDelimiter=":";exports.smuggleKeyMimeType=""+mimeType+mimeDelimiter,exports.events=keyMirror(["drag","dragend","dragenter","dragleave","dragstart","dragover","drop"]),exports.dropEffects=keyMirror(["copy","move","link","none"]),exports.effectsAllowed=keyMirror(["none","copy","copyLink","copyMove","link","linkMove","move","all","uninitialized"])},function(module,exports,__webpack_require__){__webpack_require__(20),module.exports=__webpack_require__(43)},function(module,exports,__webpack_require__){"use strict";__webpack_require__(21),__webpack_require__(36)},function(module,exports,__webpack_require__){__webpack_require__(22),module.exports=__webpack_require__(1).Array.includes},function(module,exports,__webpack_require__){"use strict";var $export=__webpack_require__(5),$includes=__webpack_require__(32)(!0);$export($export.P,"Array",{includes:function(el){return $includes(this,el,arguments.length>1?arguments[1]:void 0)}}),__webpack_require__(14)("includes")},function(module,exports,__webpack_require__){var anObject=__webpack_require__(24),IE8_DOM_DEFINE=__webpack_require__(25),toPrimitive=__webpack_require__(27),dP=Object.defineProperty;exports.f=__webpack_require__(4)?Object.defineProperty:function(O,P,Attributes){if(anObject(O),P=toPrimitive(P,!0),anObject(Attributes),IE8_DOM_DEFINE)try{return dP(O,P,Attributes)}catch(e){}if("get"in Attributes||"set"in Attributes)throw TypeError("Accessors not supported!");return"value"in Attributes&&(O[P]=Attributes.value),O}},function(module,exports,__webpack_require__){var isObject=__webpack_require__(2);module.exports=function(it){if(!isObject(it))throw TypeError(it+" is not an object!");return it}},function(module,exports,__webpack_require__){module.exports=!__webpack_require__(4)&&!__webpack_require__(6)(function(){return 7!=Object.defineProperty(__webpack_require__(26)("div"),"a",{get:function(){return 7}}).a})},function(module,exports,__webpack_require__){var isObject=__webpack_require__(2),document=__webpack_require__(0).document,is=isObject(document)&&isObject(document.createElement);module.exports=function(it){return is?document.createElement(it):{}}},function(module,exports,__webpack_require__){var isObject=__webpack_require__(2);module.exports=function(it,S){if(!isObject(it))return it;var fn,val;if(S&&"function"==typeof(fn=it.toString)&&!isObject(val=fn.call(it)))return val;if("function"==typeof(fn=it.valueOf)&&!isObject(val=fn.call(it)))return val;if(!S&&"function"==typeof(fn=it.toString)&&!isObject(val=fn.call(it)))return val;throw TypeError("Can't convert object to primitive value")}},function(module,exports){module.exports=function(bitmap,value){return{enumerable:!(1&bitmap),configurable:!(2&bitmap),writable:!(4&bitmap),value:value}}},function(module,exports,__webpack_require__){var global=__webpack_require__(0),hide=__webpack_require__(3),has=__webpack_require__(30),SRC=__webpack_require__(7)("src"),$toString=Function.toString,TPL=(""+$toString).split("toString");__webpack_require__(1).inspectSource=function(it){return $toString.call(it)},(module.exports=function(O,key,val,safe){var isFunction="function"==typeof val;isFunction&&(has(val,"name")||hide(val,"name",key)),O[key]!==val&&(isFunction&&(has(val,SRC)||hide(val,SRC,O[key]?""+O[key]:TPL.join(String(key)))),O===global?O[key]=val:safe?O[key]?O[key]=val:hide(O,key,val):(delete O[key],hide(O,key,val)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[SRC]||$toString.call(this)})},function(module,exports){var hasOwnProperty={}.hasOwnProperty;module.exports=function(it,key){return hasOwnProperty.call(it,key)}},function(module,exports){module.exports=function(it){if("function"!=typeof it)throw TypeError(it+" is not a function!");return it}},function(module,exports,__webpack_require__){var toIObject=__webpack_require__(33),toLength=__webpack_require__(12),toAbsoluteIndex=__webpack_require__(34);module.exports=function(IS_INCLUDES){return function($this,el,fromIndex){var value,O=toIObject($this),length=toLength(O.length),index=toAbsoluteIndex(fromIndex,length);if(IS_INCLUDES&&el!=el){for(;length>index;)if((value=O[index++])!=value)return!0}else for(;length>index;index++)if((IS_INCLUDES||index in O)&&O[index]===el)return IS_INCLUDES||index||0;return!IS_INCLUDES&&-1}}},function(module,exports,__webpack_require__){var IObject=__webpack_require__(9),defined=__webpack_require__(11);module.exports=function(it){return IObject(defined(it))}},function(module,exports,__webpack_require__){var toInteger=__webpack_require__(13),max=Math.max,min=Math.min;module.exports=function(index,length){return index=toInteger(index),index<0?max(index+length,0):min(index,length)}},function(module,exports,__webpack_require__){var global=__webpack_require__(0),store=global["__core-js_shared__"]||(global["__core-js_shared__"]={});module.exports=function(key){return store[key]||(store[key]={})}},function(module,exports,__webpack_require__){__webpack_require__(37),module.exports=__webpack_require__(1).Array.find},function(module,exports,__webpack_require__){"use strict";var $export=__webpack_require__(5),$find=__webpack_require__(38)(5),forced=!0;"find"in[]&&Array(1).find(function(){forced=!1}),$export($export.P+$export.F*forced,"Array",{find:function(callbackfn){return $find(this,callbackfn,arguments.length>1?arguments[1]:void 0)}}),__webpack_require__(14)("find")},function(module,exports,__webpack_require__){var ctx=__webpack_require__(8),IObject=__webpack_require__(9),toObject=__webpack_require__(39),toLength=__webpack_require__(12),asc=__webpack_require__(40);module.exports=function(TYPE,$create){var IS_MAP=1==TYPE,IS_FILTER=2==TYPE,IS_SOME=3==TYPE,IS_EVERY=4==TYPE,IS_FIND_INDEX=6==TYPE,NO_HOLES=5==TYPE||IS_FIND_INDEX,create=$create||asc;return function($this,callbackfn,that){for(var val,res,O=toObject($this),self=IObject(O),f=ctx(callbackfn,that,3),length=toLength(self.length),index=0,result=IS_MAP?create($this,length):IS_FILTER?create($this,0):void 0;length>index;index++)if((NO_HOLES||index in self)&&(val=self[index],res=f(val,index,O),TYPE))if(IS_MAP)result[index]=res;else if(res)switch(TYPE){case 3:return!0;case 5:return val;case 6:return index;case 2:result.push(val)}else if(IS_EVERY)return!1;return IS_FIND_INDEX?-1:IS_SOME||IS_EVERY?IS_EVERY:result}}},function(module,exports,__webpack_require__){var defined=__webpack_require__(11);module.exports=function(it){return Object(defined(it))}},function(module,exports,__webpack_require__){var speciesConstructor=__webpack_require__(41);module.exports=function(original,length){return new(speciesConstructor(original))(length)}},function(module,exports,__webpack_require__){var isObject=__webpack_require__(2),isArray=__webpack_require__(42),SPECIES=__webpack_require__(15)("species");module.exports=function(original){var C;return isArray(original)&&(C=original.constructor,"function"!=typeof C||C!==Array&&!isArray(C.prototype)||(C=void 0),isObject(C)&&null===(C=C[SPECIES])&&(C=void 0)),void 0===C?Array:C}},function(module,exports,__webpack_require__){var cof=__webpack_require__(10);module.exports=Array.isArray||function(arg){return"Array"==cof(arg)}},function(module,exports,__webpack_require__){"use strict";function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function install(Vue){Vue.component("drag",_Drag2.default),Vue.component("drop",_Drop2.default)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.Drop=exports.Drag=void 0,exports.install=install;var _Drag=__webpack_require__(44),_Drag2=_interopRequireDefault(_Drag),_Drop=__webpack_require__(49),_Drop2=_interopRequireDefault(_Drop);exports.Drag=_Drag2.default,exports.Drop=_Drop2.default;var plugin={version:"0.2.4",install:install};exports.default=plugin;var GlobalVue=null;"undefined"!=typeof window?GlobalVue=window.Vue:"undefined"!=typeof global&&(GlobalVue=global.Vue),GlobalVue&&GlobalVue.use(plugin)},function(module,__webpack_exports__,__webpack_require__){"use strict";Object.defineProperty(__webpack_exports__,"__esModule",{value:!0});var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drag_vue__=__webpack_require__(45),__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drag_vue___default=__webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drag_vue__),__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d486dca_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Drag_vue__=__webpack_require__(48),normalizeComponent=__webpack_require__(16),Component=normalizeComponent(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drag_vue___default.a,__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d486dca_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Drag_vue__.a,null,null,"98274e0e");__webpack_exports__.default=Component.exports},function(module,exports,__webpack_require__){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var _uniqid=__webpack_require__(46),_uniqid2=function(obj){return obj&&obj.__esModule?obj:{default:obj}}(_uniqid),_stores=__webpack_require__(17),_constants=__webpack_require__(18);exports.default={props:{draggable:{type:Boolean,default:!0},transferData:{},dropEffect:{validator:function(value){return value in _constants.dropEffects}},effectAllowed:{validator:function(value){return value in _constants.effectsAllowed}},image:String,imageXOffset:{type:Number,default:0},imageYOffset:{type:Number,default:0},hideImageHtml:{type:Boolean,default:!0},tag:{type:String,default:"div"}},data:function(){return{id:(0,_uniqid2.default)(),dragging:!1}},computed:{events:function(){return _constants.events},scopedData:function(){return this.dragging&&this.transferData},hideImageStyle:function(){return{position:"fixed",top:"-1000px"}}},methods:{emitEvent:function(name,nativeEvent){var transfer=nativeEvent.dataTransfer;if([_constants.events.dragenter,_constants.events.dragover].includes(name)&&this.dropEffect&&(transfer.dropEffect=this.dropEffect),name===_constants.events.dragstart){if(this.effectsAllowed&&(transfer.effectsAllowed=this.effectsAllowed),this.image||this.$slots.image){var image=void 0;this.image?(image=new Image,image.src=this.image):this.$slots.image&&(image=this.$slots.image[0].elm),transfer.setDragImage&&transfer.setDragImage(image,this.imageXOffset,this.imageYOffset)}void 0!==this.transferData&&(this.$set(_stores.transferDataStore,this.id,this.transferData),transfer.setData(_constants.mimeType,this.id),transfer.setData(""+_constants.smuggleKeyMimeType+this.id,this.id)),this.dragging=!0}this.$emit(name,this.transferData,nativeEvent),name===_constants.events.dragend&&(this.$delete(_stores.transferDataStore,this.id),this.dragging=!1)}}}},function(module,exports,__webpack_require__){(function(module){function now(){var time=Date.now(),last=now.last||time;return now.last=time>last?time:last+1}var pid=process&&process.pid?process.pid.toString(36):"",mac=null,address=mac?parseInt(mac.replace(/\:|\D+/gi,"")).toString(36):"";module.exports=function(prefix){return(prefix||"")+address+pid+now().toString(36)},module.exports.process=function(prefix){return(prefix||"")+pid+now().toString(36)},module.exports.time=function(prefix){return(prefix||"")+now().toString(36)}}).call(exports,__webpack_require__(47)(module))},function(module,exports){module.exports=function(module){return module.webpackPolyfill||(module.deprecate=function(){},module.paths=[],module.children||(module.children=[]),Object.defineProperty(module,"loaded",{enumerable:!0,get:function(){return module.l}}),Object.defineProperty(module,"id",{enumerable:!0,get:function(){return module.i}}),module.webpackPolyfill=1),module}},function(module,__webpack_exports__,__webpack_require__){"use strict";var render=function(){var _vm=this,_h=_vm.$createElement,_c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",attrs:{draggable:_vm.draggable},on:{drag:function($event){_vm.emitEvent(_vm.events.drag,$event)},dragstart:function($event){_vm.emitEvent(_vm.events.dragstart,$event)},dragenter:function($event){_vm.emitEvent(_vm.events.dragenter,$event)},dragleave:function($event){_vm.emitEvent(_vm.events.dragleave,$event)},dragend:function($event){_vm.emitEvent(_vm.events.dragend,$event)}}},[_vm._t("default",null,{transferData:_vm.scopedData}),_vm._v(" "),_vm.hideImageHtml?_c("div",{style:_vm.hideImageStyle},[_vm._t("image",null,{transferData:_vm.scopedData})],2):_vm._t("image",null,{transferData:_vm.scopedData})],2)},staticRenderFns=[],esExports={render:render,staticRenderFns:staticRenderFns};__webpack_exports__.a=esExports},function(module,__webpack_exports__,__webpack_require__){"use strict";Object.defineProperty(__webpack_exports__,"__esModule",{value:!0});var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drop_vue__=__webpack_require__(50),__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drop_vue___default=__webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drop_vue__),__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c831554_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Drop_vue__=__webpack_require__(51),normalizeComponent=__webpack_require__(16),Component=normalizeComponent(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drop_vue___default.a,__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c831554_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Drop_vue__.a,null,null,"6761f598");__webpack_exports__.default=Component.exports},function(module,exports,__webpack_require__){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var _stores=__webpack_require__(17),_constants=__webpack_require__(18),insideElements=new Set;exports.default={props:{tag:{type:String,default:"div"}},data:function(){return{dataKey:null}},computed:{events:function(){return _constants.events},transferDataStore:function(){return _stores.transferDataStore},transferData:function(){return this.transferDataStore[this.dataKey]}},methods:{emitEvent:function(name,nativeEvent){if(name===_constants.events.drop)this.dataKey=nativeEvent.dataTransfer.getData(_constants.mimeType);else if(!this.dataKey){for(var types=nativeEvent.dataTransfer.types,typesArray=[],i=types.length>>>0;i--;)typesArray[i]=types[i];var type=typesArray.find(function(t){return t.startsWith(_constants.smuggleKeyMimeType)});type&&(this.dataKey=type.split(_constants.mimeDelimiter)[1])}this.$emit(name,this.transferData,nativeEvent),name===_constants.events.dragenter&&(insideElements.size||nativeEvent.target===this.$el)&&insideElements.add(nativeEvent.target),name===_constants.events.dragleave&&(insideElements.delete(nativeEvent.target),insideElements.size||(this.dataKey=null)),name===_constants.events.drop&&(this.dataKey=null,insideElements.clear())}}}},function(module,__webpack_exports__,__webpack_require__){"use strict";var render=function(){var _vm=this,_h=_vm.$createElement;return(_vm._self._c||_h)(_vm.tag,{tag:"component",on:{dragenter:function($event){_vm.emitEvent(_vm.events.dragenter,$event)},dragleave:function($event){_vm.emitEvent(_vm.events.dragleave,$event)},dragover:function($event){$event.preventDefault(),_vm.emitEvent(_vm.events.dragover,$event)},drop:function($event){_vm.emitEvent(_vm.events.drop,$event)}}},[_vm._t("default",null,{transferData:_vm.transferData})],2)},staticRenderFns=[],esExports={render:render,staticRenderFns:staticRenderFns};__webpack_exports__.a=esExports}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22), __webpack_require__(156)))

/***/ }),
/* 2215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__en__ = __webpack_require__(2216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__es__ = __webpack_require__(2217);



/* harmony default export */ __webpack_exports__["a"] = ({
  en: __WEBPACK_IMPORTED_MODULE_0__en__["a" /* default */],
  es: __WEBPACK_IMPORTED_MODULE_1__es__["a" /* default */]
});

/***/ }),
/* 2216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  sideMenu: {
    admin: 'Admin',
    brands: 'Brands',
    consumers: 'Consumers',
    dispatch: 'Dispatch',
    laxit: 'LAXit',
    promo: 'Promo',
    providers: 'Providers',
    providerAvailability: 'Provider Availability',
    providerDeductions: 'Provider Deductions',
    providerPayouts: 'Provider Payouts',
    geofences: 'Geofences',
    routing: 'Routing',
    reports: 'Reports',
    transactions: 'Transactions',
    marketingAds: 'Marketing Ads',
    filters: 'Filters',
    settings: 'Settings',
    serviceTypes: 'Service Types',
    pricing: 'Pricing'
  },
  login: {
    ctaDefault: 'LOG IN',
    ctaLoading: 'LOGGING IN...',
    inputEmail: 'Email',
    inputPassword: 'Password',
    forgotLink: 'Forgot Password?',
    errorLogin: 'Invalid email/password combination.'
  },
  consumer: {
    loading: 'Loading...',
    tabLabel: {
      referrals: 'Referrals',
      transactions: 'Transactions',
      bids: 'Bids',
      ratings: 'Ratings',
      creditCard: 'Credit Card',
      promoCodes: 'Promo Codes',
      reservations: 'Reservations'
    },
    call: 'Call',
    personalInfo: {
      label: 'Personal Information',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      mobile: 'Mobile'
    },
    accountInfo: {
      label: 'Account Information',
      created: 'Account Created',
      referralCode: 'Referral Code',
      numberOfReferral: 'Number Of Referral'
    },
    referrals: {
      search: 'Search',
      export: 'Export',
      id: 'ID',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      mobile: 'Mobile',
      accountCreatedDate: 'Account Created Date',
      lastTrx: 'Last TRX Date',
      totalTrx: 'Total TRX',
      avgRating: 'Avg Rating',
      referralCode: 'Referral Code',
      totalReferral: 'Total Referrals',
      emptyState: 'No Referrals as of yet.'
    },
    transactions: {
      search: 'Search',
      from: 'From',
      to: 'To',
      export: 'Export',
      date: 'Date/Time',
      providerId: 'Provider ID',
      company: 'Company',
      rsvpId: 'RSVP ID',
      invoiceId: 'Invoice ID',
      type: 'Type',
      guestFirstName: 'Guest First Name',
      guestLastName: 'Guest Last Name',
      mobile: 'Mobile',
      creditCard: 'Credit Card',
      bookedThrough: 'Booked Through',
      finalOffer: 'Final Offer',
      chargedAmount: 'Charged Amount',
      promoUsed: 'Promo Used',
      status: 'Status',
      loading: 'Getting transactions...',
      emptyState: 'No Transactions as of yet.'
    },
    ratings: {
      export: 'Export',
      date: 'Date/Time',
      rsvpId: 'Reservation ID',
      provBusinessName: 'Provider Business Name',
      rating: 'Rating',
      msg: 'Message',
      loading: 'Getting the reviews you submit...',
      emptyState: 'No Ratings as of yet.'
    },
    creditCards: {
      export: 'Export',
      addedOn: 'Added On',
      creditCard: 'Credit Card #',
      address: 'Billing Address',
      city: 'Billing City',
      state: 'Billing State',
      zip: 'Billing Zip',
      status: 'Status',
      loading: 'Getting your credit cards...',
      emptyState: 'No Credit Cards as of yet.'
    },
    promoCodes: {
      date: 'Date Redeemed',
      code: 'Promo Code',
      value: 'Value',
      type: 'Type',
      expires: 'Expires',
      amountUsed: 'Amount Used',
      loading: 'Getting your promo codes...',
      emptyState: 'No Promo Codes as of yet.'
    },
    save: 'Save',
    saving: 'Saving...',
    sendResetPassword: 'Send Reset Password',
    sending: 'Sending...',
    passwordSent: 'Success! Password sent!',
    formSuccessful: 'Consumer\'s profile successfully updated.',
    emptyField: 'This field cannot be empty.',
    list: {
      heading: 'Consumer List',
      reactivate: 'Re-Activate',
      disable: 'Disable',
      update: 'update',
      confirmLabel: 'Are you sure you want to {action} selected user(s)?',
      yesUpdate: 'Yes, Update Selected Users',
      statusUpdateLoading: 'Updating status...',
      statusUpdateSuccess: 'Status Update Success!',
      errorMsg: 'Oops! Something went wrong.',
      close: 'Close',
      sendNotif: 'Send Notification',
      pushNotif: 'Push Notification',
      target: 'Target',
      zeroSelected: 'Please select user(s) from the list',
      allUser: 'All Users',
      selectedUser: 'Selected User',
      brands: 'Brands',
      emptyBrand: 'Please select which brand to send notification(s).',
      title: 'Title',
      message: 'Message',
      charLeft: '{count} character(s) left',
      img: 'Image',
      send: 'Send',
      cancel: 'Cancel',
      sendingNotif: 'Sending Notification...',
      sendNotifSuccess: 'Send Notification Success!',
      selectImgFile: 'Please select an image file.',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      mobile: 'Mobile',
      created: 'Created Date',
      lastTrx: 'Last TRX Date',
      totalTrx: 'Total # of TRX',
      referralCode: 'Referral Code',
      referralCount: '# of Referrals',
      referrals: 'Refferals',
      details: 'Details',
      status: 'Status',
      gettingUsers: 'Getting Users...'
    }
  },
  dispatch: {
    driverCall: 'CALL {driverName}',
    driverSend: 'SEND TO {driverName}',
    driverAssign: 'ASSIGN TO {driverName}',
    title: 'DISPATCH',
    rsvpSearchPlaceholder: 'Type and hit enter to search.',
    filterPlaceholder: 'Select a filter.',
    filter: {
      invalidDateRange: 'Invalid Date Range.',
      emptyDate: 'Field cannot be empty.',
      noServiceSelected: 'Please select at least one service.',
      noServiceStatus: 'Please select at least one status.'
    },
    openMap: 'OPEN MAP',
    rsvpTable: {
      id: 'ID',
      status: 'STATUS',
      pickup: 'PICKUP',
      dropoff: 'DROP-OFF',
      pickupTime: 'PICKUP TIME',
      dropoffTime: 'DROPOFF TIME',
      customer: 'CUSTOMER',
      driver: 'DRIVER',
      serviceType: 'SERVICE TYPE',
      pickupType: 'PICKUP TYPE',
      flight: 'FLIGHT',
      ada: 'ADA',
      pax: 'PASSENGERS/<br/>LUGGAGE/<br/>STOPS',
      emptyRsvp: {
        title: 'Use the form at the top.',
        content: 'To start, please select a filter or search for a reservation or package using the form at the top of the page.'
      },
      loadingData: {
        title: 'Loading Reservations',
        content: 'Hold tight! This will be quick.'
      },
      noData: {
        title: 'Oops. Looks like we found nothing.',
        content: 'We can\'t find any reservations or package for that filter. Please use another one from the form at the top.'
      }
    },
    driverTable: {
      id: 'ID',
      name: 'NAME',
      services: 'SERVICES',
      pax: 'PAX',
      license: 'LICENSE',
      status: 'STATUS',
      phone: 'PHONE',
      loading: {
        title: 'Looking for Drivers',
        content: 'Sit tight! We\'re looking for drivers.'
      },
      empty: {
        title: 'Oh no! No one\'s online',
        content: 'It looks like there\'s no available drivers at the moment.'
      }
    },
    mapDetails: {
      package: 'Package',
      reservation: 'Reservation',
      packagePickup: 'FIRST PICKUP ADDRESS',
      packageDropoff: 'LAST DROP-OFF ADDRESS',
      pickup: 'PICKUP ADDRESS',
      dropoff: 'DROP-OFF ADDRESS',
      pickupTime: 'PICKUP TIME',
      flight: 'FLIGHT INFORMATION',
      paxLuggageStops: 'PASSENGER/LUGGAGE/STOPS',
      paxLuggage: 'PASSENGER/LUGGAGE',
      serviceType: 'SERVICE TYPE',
      status: 'STATUS',
      paxName: 'PASSENGER NAME',
      paxEmail: 'PASSENGER EMAIL',
      paxPhone: 'PASSENGER PHONE',
      paxNote: 'PASSENGER NOTE',
      guestInfo: 'GUEST INFORMATION',
      guestName: 'GUEST NAME',
      guestPhone: 'GUEST PHONE',
      guestNone: 'There\'s no guest information for this reservation.',
      guestAdd: 'ADD GUEST INFORMATION',
      driverName: 'DRIVER NAME',
      driverPhone: 'DRIVER PHONE',
      driverEmail: 'DRIVER EMAIL',
      driverInfo: 'DRIVER INFORMATION',
      packageDriverNone: 'There\'s no driver yet for this package.',
      driverNone: 'There\'s no driver yet for this reservation.',
      emptyTitle: 'I have nothing to display right now.',
      emptyContent: 'To begin, please select a reservation/package from the <a href="/#/dispatch/reservations" target="_blank">list</a>.'
    },
    map: {
      filterControls: {
        title: 'Use the form below to look for drivers.',
        labelRadius: 'SEARCH RADIUS (IN MILES):',
        labelServices: 'INCLUDED SERVICE TYPES:',
        labelButton: 'FIND DRIVERS',
        labelLoading: 'Finding Drivers...'
      }
    }
  },
  provider: {
    list: {
      title: 'Provider List',
      filter: {
        search: 'Search',
        type: 'Type',
        all: 'All',
        tcp: 'TCP',
        tnc: 'TNC',
        status: 'Status',
        allNonArchive: 'All (Non-Archived)',
        active: 'Active',
        inactive: 'Inactive',
        pending: 'Pending',
        deactivated: 'Deactivated',
        archived: 'Archived',
        activate: 'Activate',
        deactivate: 'Deactivate',
        archive: 'Archive'
      },
      table: {
        businessName: 'Business Name',
        type: 'Type',
        status: 'Status',
        lastUpdate: 'Last Update',
        city: 'City',
        phone: 'Phone',
        license: 'License',
        insurance: 'Insurance',
        permit: 'Permit',
        cityLicense: 'City License',
        airport: 'Airport',
        drivingRecord: 'Driving Record',
        safetyInspect: 'Safety Inspect',
        lastWeeksEarning: 'Last week\'s Earning',
        avgRating: 'AVG Rating',
        lastLogin: 'Last Login Timestamp',
        bgCheck: 'BG Check',
        archived: 'Archived',
        verified: 'Verified',
        vehicle: 'Vehicle Type'
      },
      notif: {
        header: 'Push Notification',
        allUser: 'All Active User',
        selectedUser: 'Selected User',
        brand: 'Brand',
        title: 'Title',
        message: 'Message',
        send: 'Send',
        cancel: 'Cancel',
        close: 'Close'
      },
      sms: {
        header: 'Send SMS',
        allUser: 'All Active User',
        selectedUser: 'Selected User',
        brand: 'Brand',
        title: 'Title',
        message: 'Message',
        send: 'Send',
        cancel: 'Cancel',
        close: 'Close'
      }
    },
    availability: {
      title: 'Provider Availability',
      businessName: 'Business Name',
      type: 'Type',
      homeSector: 'Home Sector',
      vehicle: 'Vehicle Type',
      phone: 'Phone',
      availableFrom: 'Available From',
      availableUntil: 'Available Until'
    },
    tabLabel: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
      accountDetails: 'Account',
      services: 'Services',
      payout: 'Payouts',
      statistics: 'Statistics',
      availability: 'Availability',
      reviews: 'Reviews',
      notes: 'Notes',
      upcoming: 'Upcoming',
      completed: 'Completed'
    }, 'payout', 'Payouts'),
    active: 'Active',
    deactive: 'Deactivated',
    modal: {
      toActivate: 'Are you sure you want to activate <b>{provider}</b>?',
      toDeactivate: 'Are you sure you want to deactivate <b>{provider}</b>?',
      no: 'No',
      yes: 'Yes'
    },
    notify: 'Notify',
    sms: 'Send SMS',
    call: 'Call',
    print: 'Print Placard',
    enableServices: 'Enabled Services',
    backgroundSubmitted: 'Background check submitted',
    backgroundPassed: 'Background check passed',
    maxRsvp: 'Max Daily Reservations',
    default: 'Default',
    custom: 'Custom',
    basicInfo: {
      label: 'Basic Information',
      firstName: 'First Name',
      lastName: 'Last Name',
      deviceOS: 'Device Operating System',
      deviceModel: 'Device Model',
      email: 'Email Address',
      language: 'Language',
      mobile: 'Mobile',
      birthday: 'Birthday',
      resetPassword: 'Reset Password',
      password: 'Password',
      repassword: 'Repeat Password'
    },
    vehicleInfo: {
      label: 'Vehicle Information',
      type: 'Vehicle Type',
      year: 'Year',
      capacity: 'Capacity',
      boxCapacity: 'Box Capacity',
      door: 'Door',
      manufacturer: 'Manufacturer',
      model: 'Model',
      identificationNumber: 'Vehicle Identification Number',
      licensePlate: 'License Plate',
      wheelchair: 'Equipped with wheelchair lift.',
      serviceDog: 'Can accommodate a service dog.'
    },
    accountType: {
      label: 'Account Type',
      tcpPermit: 'Do you already have a TCP (Transportation Charter Permit) Permit?',
      type: 'Account Type Override'
    },
    businessInfo: {
      label: 'Business Information',
      name: 'Business Name',
      city: 'City',
      address1: 'Address',
      address2: 'Address 2',
      country: 'Country',
      state: 'State',
      zip: 'ZIP',
      type: 'Type of Business'
    },
    documentation: {
      label: 'Documentation',
      insuranceCompany: 'Insurance Company Name',
      insurancePolicy: 'Insurance Policy #',
      insuranceExp: 'Exp. Date',
      cityLicense: 'City License #',
      cityLicenseExp: 'Exp. Date',
      tcpPermit: 'TCP Permit #',
      tcpPermitExp: 'Exp. Date',
      airportPermit: 'Airport Permit #',
      airportPermitExp: 'Exp. Date',
      driversLicense: 'Driver\'s License #',
      driversLicenseExp: 'Exp. Date',
      vehicleInspection: 'Vehicle Safety Inspection Performed by',
      vehicleInspectionExp: 'Exp. Date',
      drivingRecord: 'Driver\'s Background Check',
      drivingRecordExp: 'Exp. Date'
    },
    eligibility: {
      label: 'Eligibility',
      convicted: 'Have you been convicted, within the past 7 years, of driving under the influence of drugs or alcohol, fraud, sexual offenses, use of a motor vehicle to commit a felony, a crime involving property damage and/or theft, acts of violence, or acts of terror?',
      conviction: 'Have you ever had a conviction for reckless driving, driving under the influence, hit and run, or driving with a suspended or revoked license?',
      ownVehicle: 'Do you personally own this vehicle?',
      modifiedVehicle: 'Has this vehicle ever been significantly modified from factory specifications (e.g. "stretch vehicle", made not street legal, etc.)?',
      driversLicense: 'Have you had your driver\'s license for at least 2 years?'
    },
    agreements: {
      label: 'Agreements',
      declarePenalty: 'I declare under penalty of perjury under the laws of the State of California that I am the driver listed on this application all of the information provided herein is true and correct.',
      agree: 'I  agree to abide by Prime Time Rideshare\'s Rules of Driver Conduct ({conductRules}) as well as the terms of use ({terms}) and privacy policy ({privacy}). I understand that my failure to comply with them may result in the termination of my partnership with Prime Time Rideshare. I understand that Prime Time Rideshare is not a transportation carrier but a tool to connect drivers and riders.',
      signature: 'Signature'
    },
    save: 'Save',
    saving: 'Saving...',
    close: 'Close',
    cancel: 'Cancel',
    addNotes: 'Add Notes',
    statistics: {
      export: 'Export Statistics',
      dateRange: 'Select Date Range',
      hours: 'Hours on Duty',
      bids: 'Bids Made',
      rsvpComplete: 'Reservations Completed',
      rsvpCancelledProv: 'Reservations Cancelled by Provider',
      rsvpCancelledCon: 'Reservations Cancelled by Consumer',
      earned: 'Amount Earned'
    },
    reviews: {
      average: 'Average Review',
      fiveStar: '5-Star Reviews',
      total: 'Total Reviews',
      date: 'Date',
      name: 'Name',
      message: 'Message',
      rating: 'Rating',
      loading: 'Getting Reviews...',
      emptyState: 'No Reviews as of yet...'
    },
    notes: {
      loading: 'Getting Notes...',
      emptyState: 'No notes as of yet.',
      name: 'Name',
      date: 'Date',
      message: 'Message',
      status: 'Status',
      edit: 'Edit',
      delete: 'Delete'
    },
    provReservation: '{provider}\'s Reservations',
    reservations: {
      from: 'from',
      to: 'to',
      id: 'ID',
      pickupTime: 'Pickup Time',
      pickup: 'Pickup',
      dropoff: 'Drop-off',
      service: 'Service',
      customer: 'Customer',
      paxLuggage: 'PAX / Luggage',
      flight: 'Flight',
      driverPayment: 'Driver Payment',
      totalDriverPayment: 'Total Driver Payment',
      loading: 'Getting Reservations...',
      hudson: 'Hudson ID',
      emptyState: {
        upcoming: 'No Upcoming Reservation as of yet.',
        history: 'No Completed Reservation as of yet.'
      }
    },
    formSuccessful: 'Driver\'s profile successfully updated.',
    formFail: 'Fail to update driver\'s profile.',
    emptyField: 'This field cannot be empty.',
    invalidEmail: 'Invalid email format.',
    emptyServices: 'At least one service type for this transportation provider must be chosen before your changes can be saved.',
    sendEmailLabel: 'Send a reset password link to this provider.',
    sendToEmail: 'Send to email',
    sending: 'Sending...',
    orTypeIn: 'OR TYPE-IN',
    passwordNotMatch: 'Password and repeat password doesnt not match.',
    passwordSuccess: 'Success! Driver\'s password has been changed!',
    passwordSent: 'Success! Password sent!',
    upload: 'Upload',
    uploading: 'Uploading...',
    uploadError: 'Oops! Something went wrong. Please try again.',
    documenationNotice: 'Attach scanned or photograped images of your documents below. <br />Please make sure that uploading file types are one of the following formats: <i><b>PDF, JPEG, JPG, GIF, PNG</b></i>.'
  },
  rsvpDetails: {
    rsvpId: 'Reservation {id}',
    tabLabel: {
      basicInfo: 'Basic Information',
      transactions: 'Transactions',
      notes: 'notes',
      activityLogs: 'Activity Logs',
      systemLogs: 'System Logs',
      actionLogs: 'Action Logs',
      dispatchLogs: 'Dispatch Logs'
    },
    tripInformation: {
      label: 'Trip Information',
      brand: 'Brand',
      bookedThrough: 'Source',
      createdOn: 'Created On',
      pickupDate: 'Pickup Date/Time',
      driverPayment: 'Driver Payment',
      seePaymentBreakdown: 'See payment Breakdown',
      paymentBreakdown: 'Payment Breakdown',
      fareAmount: 'Fare Amount',
      bonus: 'Release Bonus',
      paymentBonus: 'Payment Bonus',
      pickupType: 'Pickup Type',
      tip: 'Tip',
      airportFee: 'Airport Fee',
      pickupFee: 'Pickup Fee',
      close: 'Close',
      fare: 'Fare',
      serviceType: 'Service Type',
      pickup: 'Pickup Location',
      dropoff: 'Drop-off Location',
      beThereTime: 'Be There Time',
      distance: 'Distance',
      flightInfo: 'Flight Information',
      terminal: 'Terminal',
      passenger: 'Passenger',
      luggage: 'Luggage',
      notes: 'Consumer Notes',
      serviceArea: 'Service Area',
      rating: 'Rating',
      userReview: 'User Review'
    },
    customerInformation: {
      label: 'Customer Information',
      name: 'Name',
      id: 'Id',
      paidWith: 'Paid With',
      email: 'Email Address',
      mobile: 'Mobile Phone'
    },
    guestInformation: {
      label: 'Guest Information',
      name: 'Name',
      mobile: 'Mobile Phone',
      emptyState: 'This wasn\'t booked for a guest.',
      addBtn: 'Add Guest Information'
    },
    driverInformation: {
      label: 'Driver Information',
      name: 'Name',
      id: 'Id',
      avgRating: 'Average Rating',
      driversLicense: 'Driver\'s License',
      make: 'Make',
      model: 'Model',
      licensePlate: 'License Plate',
      mobile: 'Mobile Phone',
      email: 'Email',
      emptyState: 'There\'s no driver for this reservation.',
      findBtn: 'Find A Driver',
      releaseBtn: 'Release Driver'
    },
    transactions: {
      dateTime: 'Date',
      invoiceId: 'Invoice ID',
      card: 'Card',
      finalOffer: 'Final Offer',
      chargedAmount: 'Charged Amount',
      cancelFee: 'Cancel Fee',
      bonus: 'Bonus',
      promoUsed: 'Promo Used',
      status: 'Status'
    },
    notes: {
      loading: 'Getting Notes...',
      emptyState: 'No notes yet.',
      edit: 'Edit',
      delete: 'Delete',
      deleteMessage: 'Are you sure you want to delete this note?',
      no: 'No',
      yes: 'Yes'
    },
    history: 'History',
    activityLogs: {
      emptyState: 'No activity logs yet.',
      dateTime: 'Date/Time',
      activity: 'Activity',
      placeholder: '<b>{author}</b> made an update last <b>{date}</b> at <b>{time}</b>'
    },
    systemLogs: {
      emptyState: 'No system logs yet.'
    },
    dispatchLogs: {
      emptyState: 'No dispatch logs available'
    },
    cancelRsvp: 'Cancel Reservation',
    sendRefund: 'Send Refund',
    markComplete: 'Mark As Complete',
    addNote: 'Add A New Note',
    sendConfirmationEmail: 'Send Confirmation Email',
    noShow: {
      label: 'Mark as No Show',
      loading: 'Loading...',
      header: 'Passenger No Show',
      bodyConsumer: 'The passenger will be informed that they are a no-show. ',
      bodyProvider: 'The driver will be paid a no-show fee of <b>${fee}</b>.',
      bodyConfirm: 'Do you want to Continue?',
      yes: 'Yes',
      cancel: 'Cancel'
    },
    sendReceiptEmail: 'Send Receipt Email',
    sendCancellationEmail: 'Send Cancellation Email',
    editRsvp: 'Edit this Reservation',
    cancelEdit: 'Cancel edit',
    saveChanges: 'Save Changes',
    flightStatus: {
      loading: 'Updating Flight Status...',
      error: 'Something went wrong on our side. Please try again.',
      status: 'Status',
      departureAirport: 'Departure Airport',
      arrivalAirport: 'Arrival Airport',
      arrivalDate: 'Arrival Time',
      departureDate: 'Departure Time',
      tryAgain: 'Try Again'
    },
    sending: 'Sending...',
    close: 'Close',
    emailSent: 'Email sent.',
    noShowSent: 'No Show is being processed, please refresh the page after a few moments.',
    cancelSuccess: 'Successfully canceled <b>Reservation {rsvpid}</b>.',
    edit: {
      rideRetails: 'Ride Details',
      customerInfo: 'Customer Information',
      aptGate: 'Apartment # / Gate #',
      airline: 'Airline',
      flight: 'Flight',
      wheelchair: 'Wheelchair',
      serviceDog: 'Service Dog',
      services: 'Services',
      priceOverride: {
        label: 'Price Override',
        desc: 'This will override the total trip price including the pickup type fee.'
      },
      driverOverride: {
        label: 'Driver Payment Override',
        desc: 'This will override the payment for provider excluding the pickup type fee.'
      },
      bookingForSomeone: 'Book this reservation for someone else.',
      guestFirstName: 'Guest\'s First Name',
      guestLastName: 'Guest\'s Last Name',
      guestMobile: 'Guest\'s Mobile',
      driverNotes: 'Note to driver',
      paymentSummary: 'Payment Summary',
      fare: 'Fare',
      airportFee: 'Airport Fee',
      tip: 'Tip',
      creditsUsed: 'Credits Used',
      total: 'Total',
      complimentary: 'Complimentary',
      curbside: 'Curbside (free)',
      meetAndGreet: 'Meet & Greet',
      priceChange: 'Your edits have changed the price of this reservation, be sure to inform the customer of the price update.',
      totalFareChange: 'Total fare change from',
      updateSuccessMsg: 'Successfully updated <b>Reservation {id}</b>',
      updatingReservation: 'Updating Reservation...',
      emptyField: 'This field cannot be empty.',
      adminTimeBufferError: 'Dispatch Time must be greater than {min} minutes from current time.',
      selectError: 'Please select from the list.',
      selectService: 'Please select a service for this reservation.',
      serviceRestrictions: 'Certain services are not available due to service area restrictions.',
      zeroValue: 'Value cannot be less than or equal to zero.',
      beyondLimit: 'Bonus should not be greater than ${fare}.'
    }
  },
  rsvpNotes: {
    title: {
      regular: 'Please leave a note.',
      refund: 'Refund Reservation',
      confirmRefund: 'Confirm Refund',
      noShowRefund: 'Confirm No Show Refund'
    },
    payCancellationFee: 'The customer will have to pay a cancellation fee of <b>{amount}</b>. Do you want to charge the cancellation fee?',
    yes: 'Yes',
    no: 'No',
    refundType: 'Refund Type',
    fullRefund: 'Full Refund',
    partialRefund: 'Partial Refund',
    issueCredit: 'Issue Credit',
    additionalCharge: 'Additional Charge',
    refundAmountEmpty: 'Field cannot be empty.',
    notNumber: 'Invalid number.',
    lowNumber: 'Cannot be lower or equal to zero.',
    close: 'Close',
    notes: 'Notes',
    emptyNotes: 'Please put in a note in the text box.',
    charLeft: '{value} character(s) left.',
    status: 'Status',
    new: 'NEW',
    investigation: 'INVESTIGATION',
    resolved: 'RESOLVED',
    cancel: 'Cancel',
    confirm: 'Confirm',
    successCredit: 'Issued credit successfully!'
  },
  transactions: {
    title: 'Transactions',
    gross: 'Gross Revenue',
    ofDateRange: 'of date range',
    creditUsed: 'Credit Used',
    onlineProv: 'Online Providers',
    filter: {
      search: 'Search',
      searchEmpty: 'Selecting "All" from date range requires search keyword.',
      status: 'Status',
      dateRange: 'Date Range',
      all: 'All',
      custom: 'Custom',
      declined: 'Declined',
      cancelled: 'Cancelled',
      promo: 'Promo',
      purchased: 'Purchased',
      authorized: 'Authorized',
      noShow: 'No Show',
      completed: 'Completed',
      refund: 'Refund',
      edited: 'Edited',
      withinDay: 'Within a day',
      monthToDate: 'Month to date',
      lastMonth: 'Last month',
      lastWeek: 'Last week',
      last2Week: 'Last 2 weeks',
      last30Days: 'Last 30 days',
      last60Days: 'Last 60 days',
      last90Days: 'Last 90 days',
      from: 'From',
      to: 'To',
      invalidDateRange: 'Invalid Date Range.',
      emptyDate: 'Field cannot be empty.',
      refresh: 'Refresh',
      export: 'Export'
    },
    list: {
      date: 'Date',
      serviceArea: 'Service Area',
      company: 'Company',
      invoiceId: 'Invoice ID',
      rsvpId: 'RSVP ID',
      pickup: 'Pickup',
      dropoff: 'Dropoff',
      type: 'Type',
      service: 'Service',
      customerName: 'Customer Name',
      email: 'Email',
      mobile: 'Mobile',
      creditCard: 'Credit Card',
      source: 'Source',
      finalOffer: 'Final Offer',
      chargedAmount: 'Charged Amount',
      bonus: 'Bonus',
      promoUsed: 'Promo Used',
      cancelFee: 'Cancel Fee',
      status: 'Status',
      loading: 'Getting Transactions...',
      empty: 'No record found!',
      display: 'Display',
      resultsPerPage: 'results per page.',
      displaying: 'Displaying {min} - {max} of {total}'
    },
    unableToRefund: 'Unable to Refund',
    otherMeans: 'This transaction was paid through means other than a credit card. It cannot be refunded automatically through the system. Please cancel the reservation through the Edit RSVP page.',
    close: 'Close'
  }
});

/***/ }),
/* 2217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  sideMenu: {
    admin: 'Admin',
    brands: 'Brands',
    consumers: 'Consumidores',
    dispatch: 'Envío',
    laxit: 'LAXit',
    promo: 'Promoción',
    providers: 'Providers',
    providerDeductions: 'Provider Deductions',
    providerPayouts: 'Provider Payouts',
    geofences: 'Geofences',
    routing: 'Enrutamiento',
    reports: 'Informes',
    transactions: 'Actas',
    marketingAds: 'Marketing Ads',
    filters: 'Filters',
    settings: 'Settings',
    serviceTypes: 'Tipos de servicio',
    pricing: 'Precios'
  },
  login: {
    ctaDefault: 'INICIAR',
    ctaLoading: 'INICIAR SESIÓN...',
    inputEmail: 'Email',
    inputPassword: 'Contraseña',
    forgotLink: 'Se te olvidó tu contraseña?',
    errorLogin: 'Combinación inválida de correo electrónico/contraseña.'
  },
  consumer: {
    loading: 'Obteniendo ofertas...',
    tabLabel: {
      referrals: 'Referencias',
      transactions: 'Actas',
      bids: 'Ofertas',
      ratings: 'Calificaciones',
      creditCard: 'Tarjeta de crédito',
      promoCodes: 'Códigos promocionales'
    },
    call: 'Llama ',
    personalInfo: {
      label: 'Informacion personal',
      firstName: 'Nombre de pila',
      lastName: 'Apellido',
      email: 'Email',
      mobile: 'Móvil'
    },
    accountInfo: {
      label: 'Información de la cuenta',
      created: 'Cuenta creada',
      referralCode: 'código de referencia',
      numberOfReferral: 'Número de referencia'
    },
    referrals: {
      search: 'Buscar',
      export: 'Exportar',
      id: 'ID',
      firstName: 'Nombre de pila',
      lastName: 'Apellido',
      email: 'Email',
      mobile: 'Móvil',
      accountCreatedDate: 'Fecha de creación de la cuenta',
      lastTrx: 'Ultima TRX Cita',
      totalTrx: 'Total TRX',
      avgRating: 'Puntuación media',
      referralCode: 'Código de referencia',
      totalReferral: 'Referencias totales',
      emptyState: 'Sin referencias hasta el momento.'
    },
    transactions: {
      search: 'Buscar',
      from: 'De',
      to: 'A',
      export: 'Exportar',
      date: 'Fecha',
      providerId: 'Proveedor ID',
      company: 'Empresa',
      rsvpId: 'RSVP ID',
      invoiceId: 'Factura ID',
      type: 'Tipo',
      guestFirstName: 'Nombre del huésped',
      guestLastName: 'Apellido del invitado',
      mobile: 'Móvil',
      creditCard: 'Tarjeta de crédito',
      bookedThrough: 'Libro a través',
      finalOffer: 'Oferta final',
      chargedAmount: 'Cantidad cobrada',
      promoUsed: 'Promoción utilizada',
      status: 'Estado',
      loading: 'Obtener transacciones...',
      emptyState: 'No hay transacciones hasta el momento.'
    },
    ratings: {
      export: 'Exportar',
      date: 'Fecha',
      rsvpId: 'Reserva ID',
      provBusinessName: 'Nombre comercial del proveedor',
      rating: 'Clasificación',
      msg: 'Mensaje',
      loading: 'Obteniendo los comentarios que enviaste...',
      emptyState: 'Sin calificaciones hasta el momento.'
    },
    creditCards: {
      export: 'Exportar',
      addedOn: 'Añadido',
      creditCard: 'Tarjeta de crédito #',
      address: 'Dirección de Envio',
      city: 'Billing City',
      state: 'Estado de cuenta',
      zip: 'Facturación Zip',
      status: 'Estado',
      loading: 'Obtener sus tarjetas de crédito...',
      emptyState: 'No hay tarjetas de crédito hasta el momento.'
    },
    promoCodes: {
      date: 'Fecha de canje',
      code: 'Código promocional',
      value: 'Valor',
      type: 'Tipo',
      expires: 'Vence',
      amountUsed: 'Cantidad usada',
      loading: 'Obteniendo tus códigos promocionales...',
      emptyState: 'No hay códigos promocionales aún.'
    },
    save: 'Salvar',
    saving: 'Ahorro...',
    sendResetPassword: 'Enviar Restablecer Password',
    sending: 'Enviando...',
    passwordSent: 'Éxito! Contraseña enviada!',
    formSuccessful: 'El perfil del consumidor se ha actualizado con éxito.',
    emptyField: 'Este campo no puede estar vacío.',
    list: {
      heading: 'Lista de consumidores',
      reactivate: 'Reactivar',
      disable: 'Disable',
      update: 'inhabilitar',
      confirmLabel: 'Seguro que quieres {action} usuario (s) seleccionado (s)?',
      yesUpdate: 'Sí, actualizar usuarios seleccionados',
      statusUpdateLoading: 'Estado de actualización...',
      statusUpdateSuccess: 'Estado actualización éxito!',
      errorMsg: 'Oops! Algo salió mal.',
      close: 'Cerca',
      sendNotif: 'Enviar notificación',
      pushNotif: 'Notificación de inserción',
      target: 'Objetivo',
      zeroSelected: 'Seleccione usuario (s) de la lista',
      allUser: 'Todos los usuarios',
      selectedUser: 'Usuario Seleccionado',
      brands: 'Marcas',
      emptyBrand: 'Por favor seleccione qué marca desea enviar notificación (es).',
      title: 'Título',
      message: 'Mensaje',
      charLeft: '{count} Personaje (s) dejado (s)',
      img: 'Imagen',
      send: 'Enviar',
      cancel: 'Cancelar',
      sendingNotif: 'Envío de notificaciones...',
      sendNotifSuccess: 'Enviar notificación de éxito!',
      selectImgFile: 'Seleccione un archivo de imagen.',
      firstName: 'Nombre de pila',
      lastName: 'Apellido',
      email: 'Email',
      mobile: 'Móvil',
      created: 'Fecha de creación',
      lastTrx: 'Última fecha TRX',
      totalTrx: 'Número total de TRX',
      referralCode: 'Código de referencia',
      referralCount: 'Número de referencias',
      referrals: 'Referencias',
      details: 'Detalles',
      status: 'Estado',
      gettingUsers: 'Obtener usuarios...'
    }
  },
  dispatch: {
    driverCall: 'LLAME A {driverName}',
    driverSend: 'ENVIAR A {driverName}',
    driverAssign: 'ASIGNAR A {driverName}',
    title: 'ENVÍO',
    rsvpSearchPlaceholder: 'Escriba y presione enter para buscar.',
    filterPlaceholder: 'Seleccione un filtro.',
    openMap: 'MAPA ABIERTO',
    rsvpTable: {
      id: 'ID',
      status: 'ESTADO',
      pickup: 'RECOGER',
      dropoff: 'DESTINO',
      pickupTime: 'HORA DE RECOGIDA',
      customer: 'CLIENTE',
      driver: 'CONDUCTOR',
      serviceType: 'TIPO DE SERVICIO',
      pickupType: 'TIPO DE RECOGIDA',
      flight: 'VUELO',
      ada: 'ADA',
      pax: 'PASAJERO/<br/>EQUIPAJE/<br/>PARE',
      emptyRsvp: {
        title: 'Use el formulario en la parte superior.',
        content: 'Para comenzar, seleccione un filtro o busque una reserva o paquete usando el formulario en la parte superior de la página.'
      },
      loadingData: {
        title: 'Cargando Reservas',
        content: 'Agárrate fuerte! Esto será rápido.'
      },
      noData: {
        title: 'Oops. Parece que no encontramos nada.',
        content: 'No podemos encontrar ninguna reserva o paquete para ese filtro. Utilice otro del formulario en la parte superior.'
      }
    },
    driverTable: {
      id: 'ID',
      name: 'NOMBRE',
      services: 'SERVICIOS',
      pax: 'PASAJERO',
      license: 'LICENCIA',
      status: 'ESTADO',
      phone: 'TELÉFONO',
      loading: {
        title: 'Buscando conductores',
        content: '¡Estarse quieto! Estamos buscando conductores.'
      },
      empty: {
        title: '¡Oh no! Nadie está en línea',
        content: 'Parece que no hay controladores disponibles en este momento.'
      }
    },
    mapDetails: {
      package: 'Paquete',
      reservation: 'Reserva',
      packagePickup: 'PRIMERO DIRECCIÓN DE ENTREGA',
      packageDropoff: 'ÚLTIMO DIRECCIÓN DE DESTINO',
      pickup: 'DIRECCIÓN DE ENTREGA',
      dropoff: 'DIRECCIÓN DE DESTINO',
      pickupTime: 'HORA DE RECOGIDA',
      flight: 'INFORMACION DE VUELO',
      paxLuggageStops: 'PASAJERO/EQUIPAJE/PARE',
      paxLuggage: 'PASAJERO/EQUIPAJE',
      serviceType: 'TIPO DE SERVICIO',
      status: 'ESTADO',
      paxName: 'NOMBRE DEL PASAJERO',
      paxEmail: 'EMAIL DEL PASAJERO',
      paxPhone: 'TELÉFONO DEL PASAJERO',
      paxNote: 'NOTA DEL PASAJERO',
      guestInfo: 'INFORMACION DEL INVITADO',
      guestName: 'NOMBRE DEL INVITADO',
      guestPhone: 'TELÉFONO DEL INVITADO',
      guestNone: 'No hay información de invitado para esta reserva',
      guestAdd: 'ADD GUEST INFORMACION',
      driverName: 'NOMBRE DEL CONDUCTOR',
      driverPhone: 'TELÉFONO DEL CONDUCTOR',
      driverEmail: 'EMAIL DEL CONDUCTOR',
      driverInfo: 'INFORMACIÓN DEL CONDUCTOR',
      packageDriverNone: 'No hay conductor todavía para esta paquete.',
      driverNone: 'No hay conductor todavía para esta reserva.',
      emptyTitle: 'No tengo nada para mostrar en este momento.',
      emptyContent: 'Para comenzar, seleccione una reserva/paquete de la <a href="/es/#/dispatch/reservations" target="_blank">lista</a>.'
    },
    map: {
      filterControls: {
        title: 'Use esto para buscar controladores.',
        labelRadius: 'BUSCAR RADIO (EN MILLAS):',
        labelServices: 'TIPOS DE SERVICIO INCLUIDOS:',
        labelButton: 'ENCUENTRA CONDUCTORES',
        labelLoading: 'Encontrar Conductores...'
      }
    }
  },
  provider: {
    tabLabel: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
      accountDetails: 'Account',
      services: 'Servicios',
      payout: 'Payouts',
      statistics: 'Estadística',
      availability: 'Availability',
      shift: 'Shifts',
      reviews: 'Comentarios',
      notes: 'Notas',
      upcoming: 'Próximo',
      completed: 'Terminado'
    }, 'payout', 'Payouts'),
    active: 'Activo',
    deactive: 'Desactivar',
    modal: {
      toActivate: 'Seguro que quieres activar <b>{provider}</b>?',
      toDeactivate: 'Estás seguro de que quieres desactivar <b>{provider}</b>?',
      no: 'No',
      yes: 'Yes'
    },
    call: 'Llama ',
    enableServices: 'Servicios habilitados',
    backgroundSubmitted: 'Verificación de antecedentes enviada',
    backgroundPassed: 'Verificación de antecedentes pasada',
    maxRsvp: 'Max reservas diarias',
    default: 'Defecto',
    custom: 'Personalizado',
    basicInfo: {
      label: 'Información básica',
      firstName: 'Nombre de pila',
      lastName: 'Apellido',
      deviceOS: 'Sistema operativo del dispositivo',
      deviceModel: 'Modelo de dispositivo',
      email: 'Dirección de correo electrónico',
      language: 'Idioma',
      mobile: 'Teléfono',
      birthday: 'Cumpleaños',
      resetPassword: 'Restablecer la contraseña',
      password: 'Contraseña',
      repassword: 'Repite la contraseña'
    },
    vehicleInfo: {
      label: 'Información del vehículo',
      type: 'Tipo de vehiculo',
      year: 'Año',
      capacity: 'Capacidad',
      boxCapacity: 'Box Capacidad',
      door: 'Puerta',
      manufacturer: 'Fabricante',
      model: 'Modelo',
      identificationNumber: 'Número de identificación del vehículo',
      licensePlate: 'Placa',
      wheelchair: 'Equipado con elevador de silla de ruedas.',
      serviceDog: 'Puede acomodar un perro de servicio.'
    },
    accountType: {
      label: 'Tipo de cuenta',
      tcpPermit: 'Ya tienes un TCP (Transportation Charter Permit) Permiso?',
      type: 'Anular el tipo de cuenta'
    },
    businessInfo: {
      label: 'Información de negocios',
      name: 'Nombre del Negocio',
      city: 'Ciudad',
      address1: 'Dirección',
      address2: 'Dirección 2',
      country: 'País',
      state: 'Estado',
      zip: 'cremallera',
      type: 'Tipo de negocio'
    },
    documentation: {
      label: 'Documentación',
      insuranceCompany: 'Nombre de la compañía de seguros',
      insurancePolicy: 'Póliza de seguros #',
      insuranceExp: 'fecha de caducidad',
      cityLicense: 'Licencia de ciudad #',
      cityLicenseExp: 'fecha de caducidad',
      tcpPermit: 'TCP Permiso #',
      tcpPermitExp: 'fecha de caducidad',
      airportPermit: 'Permiso de aeropuerto #',
      airportPermitExp: 'fecha de caducidad',
      driversLicense: 'Licencia de conducir #',
      driversLicenseExp: 'fecha de caducidad',
      vehicleInspection: 'Inspección de seguridad del vehículo realizada por',
      vehicleInspectionExp: 'fecha de caducidad',
      drivingRecord: 'Verificación de antecedentes del conductor',
      drivingRecordExp: 'Fecha de caducidad'
    },
    eligibility: {
      label: 'Elegibilidad',
      convicted: 'Ha sido condenado, en los últimos 7 años, por manejar bajo la influencia de drogas o alcohol, fraude, delitos sexuales, uso de un vehículo de motor para cometer un delito grave, un delito que involucra daños a la propiedad y / o robo, actos de violencia, o actos de terror?',
      conviction: 'Alguna vez ha tenido una condena por conducir imprudentemente, conducir bajo la influencia, golpear y correr o conducir con una licencia suspendida o revocada?',
      ownVehicle: 'Eres el propietario de este vehículo?',
      modifiedVehicle: 'Alguna vez este vehículo ha sido modificado significativamente de las especificaciones de fábrica (por ejemplo, "vehículo elástico", no legalizado en la calle, etc.)?',
      driversLicense: 'Ha tenido su licencia de conducir por al menos 2 años?'
    },
    agreements: {
      label: 'Acuerdos',
      declarePenalty: 'Declaro bajo pena de perjurio bajo las leyes del Estado de California que soy el conductor que figura en esta solicitud, toda la información aquí proporcionada es verdadera y correcta.',
      agree: 'Acepto cumplir con las Reglas de Conducta del Conductor de Prime Time Rideshare ({conductRules}) así como los términos de uso ({terms}) y política de privacidad ({privacy}). Entiendo que mi incumplimiento de ellos puede dar como resultado la terminación de mi asociación con Prime Time Rideshare. Entiendo que Prime Time Rideshare no es un transportista sino una herramienta para conectar a conductores y pasajeros.',
      signature: 'Firma'
    },
    save: 'Salvar',
    saving: 'Ahorro...',
    close: 'Cerca',
    cancel: 'Cancelar',
    addNotes: 'Agregar notas',
    statistics: {
      export: 'Estadísticas de exportación',
      dateRange: 'Seleccionar rango de fechas',
      hours: 'Horas de servicio',
      bids: 'Ofertas hechas',
      rsvpComplete: 'Reservaciones completadas',
      rsvpCancelledProv: 'Reservaciones canceladas por el proveedor',
      rsvpCancelledCon: 'Reservas canceladas por el consumidor',
      earned: 'Monto ganado'
    },
    reviews: {
      average: 'Revisión promedio',
      fiveStar: 'Reseñas de 5 estrellas',
      total: 'Reseñas totales',
      date: 'Fecha',
      name: 'Nombre',
      message: 'Mensaje',
      rating: 'Clasificación',
      loading: 'Obtener revisiones...',
      emptyState: 'No hay comentarios hasta el momento...'
    },
    notes: {
      loading: 'Obteniendo notas...',
      emptyState: 'No hay notas hasta el momento.',
      name: 'Nombre',
      date: 'Fecha',
      message: 'Mensaje',
      status: 'Estado',
      edit: 'Editar',
      delete: 'Borrar'
    },
    provReservation: '{provider}\'s Reservas',
    reservations: {
      from: 'de',
      to: 'a',
      id: 'ID',
      pickupTime: 'Hora de recogida',
      pickup: 'Recoger',
      dropoff: 'Drop-off',
      service: 'Servicio',
      customer: 'Cliente',
      paxLuggage: 'PAX / Equipaje',
      flight: 'Vuelo',
      loading: 'Obtener reservas...',
      driverPayment: 'Pago del conductor',
      totalDriverPayment: 'Pago total del conductor',
      emptyState: {
        upcoming: 'No hay próxima reserva aún.',
        history: 'No hay reserva completada hasta el momento.'
      }
    },
    formSuccessful: 'El perfil del conductor se ha actualizado con éxito.',
    formFail: 'Error al actualizar el perfil del conductor.',
    emptyField: 'Este campo no puede estar vacío.',
    invalidEmail: 'Formato de correo inválido.',
    emptyServices: 'Se debe elegir al menos un tipo de servicio para este proveedor de transporte antes de poder guardar sus cambios.',
    sendEmailLabel: 'Envíe un enlace de restablecimiento de contraseña a este proveedor.',
    sendToEmail: 'Enviar al correo electrónico',
    sending: 'Enviando...',
    orTypeIn: 'O TIPO DE ENTRADA',
    passwordNotMatch: 'La contraseña y la contraseña de repetición no coinciden.',
    passwordSuccess: 'Éxito! La contraseña del conductor ha sido cambiada!',
    passwordSent: 'Éxito! Contraseña enviada!',
    upload: 'Subir',
    uploading: 'Cargando...',
    uploadError: 'Oops! Algo salió mal. Inténtalo de nuevo.',
    documenationNotice: 'Adjunte imágenes escaneadas o fotografiadas de sus documentos a continuación. <br />Asegúrese de que los tipos de archivos que se cargan tengan uno de los siguientes formatos: <i><b>PDF, JPEG, JPG, GIF, PNG</b></i>.'
  },
  rsvpDetails: {
    rsvpId: 'Reserva {id}',
    tabLabel: {
      basicInfo: 'Informacion basica',
      transactions: 'Actas',
      notes: 'notas',
      activityLogs: 'Registros de actividad',
      systemLogs: 'Registros del sistema'
    },
    tripInformation: {
      label: 'Información de viaje',
      brand: 'Marca',
      bookedThrough: 'Fuente',
      createdOn: 'Creado en',
      pickupDate: 'Fecha de recogida',
      driverPayment: 'Pago del conductor',
      seePaymentBreakdown: 'Ver el desglose del pago',
      paymentBreakdown: 'Desglose de pago',
      fareAmount: 'Tarifa de tarifa',
      bonus: 'Prima',
      pickupType: 'Tipo de pastilla',
      tip: 'Propina',
      airportFee: 'Tarifa de aeropuerto',
      pickupFee: 'Tasa De Recogida',
      close: 'Cerca',
      fare: 'Tarifa',
      serviceType: 'Tipo de servicio',
      pickup: 'Lugar de recogida',
      dropoff: 'Punto de entrega',
      beThereTime: 'Tómese tiempo',
      distance: 'Distancia',
      flightInfo: 'Informacion de vuelo',
      terminal: 'Terminal',
      passenger: 'Pasajero',
      luggage: 'Equipaje',
      notes: 'Notas',
      serviceName: 'Área de servicio',
      rating: 'Clasificación',
      userReview: 'Revisión del usuario'
    },
    customerInformation: {
      label: 'Informacion al cliente',
      name: 'Nombre',
      id: 'Id',
      paidWith: 'Pagado con',
      email: 'Direccion de correo electronico',
      mobile: 'Telefono movil'
    },
    guestInformation: {
      label: 'Informacion del Invitado',
      name: 'Nombre',
      mobile: 'Telefono movil',
      emptyState: 'Esto no fue reservado para un invitado.',
      addBtn: 'Agregar información del huésped'
    },
    driverInformation: {
      label: 'Información del conductor',
      name: 'Nombre',
      id: 'Id',
      avgRating: 'Puntuación media',
      driversLicense: 'Licencia de conducir',
      make: 'Hacer',
      model: 'Modelo',
      licensePlate: 'Placa',
      mobile: 'Telefono movil',
      email: 'Email',
      emptyState: 'No hay conductor para esta reserva.',
      findBtn: 'Encuentra un conductor',
      releaseBtn: 'Release Driver'
    },
    transactions: {
      dateTime: 'Fecha',
      invoiceId: 'Factura ID',
      card: 'Tarjeta',
      finalOffer: 'Oferta Final',
      chargedAmount: 'Cantidad cobrada',
      cancelFee: 'Cancelar tarifa',
      bonus: 'Prima',
      promoUsed: 'Promoción utilizada',
      status: 'Estado'
    },
    notes: {
      loading: 'Obteniendo notas...',
      emptyState: 'No hay notas todavia.',
      edit: 'Editar',
      delete: 'Borrar',
      deleteMessage: 'Estás seguro que quieres eliminar esta nota?',
      no: 'No',
      yes: 'Sí'
    },
    history: 'Historia',
    activityLogs: {
      emptyState: 'Aun no hay registros de actividad.',
      dateTime: 'Fecha',
      activity: 'Actividad',
      placeholder: '<b>{author}</b> hizo una actualización el último <b>{date}</b> al <b>{time}</b>'
    },
    systemLogs: {
      emptyState: 'No hay registros del sistema todavia.'
    },
    cancelRsvp: 'Cancelar esta reserva',
    sendRefund: 'Enviar reembolso',
    markComplete: 'Marcar como completo',
    addNote: 'Agregar una nueva nota',
    sendConfirmationEmail: 'Enviar correo electronico de confirmacion',
    sendReceiptEmail: 'Enviar correo electrónico de recibo',
    sendCancellationEmail: 'Enviar correo electrónico de cancelación',
    editRsvp: 'Editar esta reserva',
    cancelEdit: 'Cancelar editar',
    saveChanges: 'Guardar cambios',
    flightStatus: {
      loading: 'Actualización del estado del vuelo...',
      error: 'Algo salió mal de nuestro lado. Inténtalo de nuevo.',
      status: 'Estado',
      departureAirport: 'Aeropuerto de salida',
      arrivalAirport: 'Aeropuerto de llegada',
      arrivalDate: 'Fecha de llegada',
      departureDate: 'Fecha de salida',
      tryAgain: 'Inténtalo de nuevo'
    },
    sending: 'Enviando...',
    close: 'Cerca',
    emailSent: 'Email enviado.',
    cancelSuccess: '<b>Reserva {rsvpid}</b> cancelada exitosamente',
    edit: {
      rideRetails: 'Detalles de viaje',
      customerInfo: 'Información al cliente',
      aptGate: 'Apartamento # / portón #',
      airline: 'Aerolínea',
      flight: 'Vuelo',
      wheelchair: 'Silla de ruedas',
      serviceDog: 'Perro de servicio',
      services: 'Servicios',
      priceOverride: {
        label: 'Price Override',
        desc: 'Esto anulará el precio total del viaje, incluida la tarifa del tipo de recogida.'
      },
      driverOverride: {
        label: 'Anular el pago del conductor',
        desc: 'Esto anulará el pago para el proveedor excluyendo el tipo de tarifa de recolección.'
      },
      bookingForSomeone: 'Reserve esta reservación para otra persona.',
      guestFirstName: 'Nombre del huésped',
      guestLastName: 'Apellido del huésped',
      guestMobile: 'Móvil del invitado',
      driverNotes: 'Nota para el conductor',
      paymentSummary: 'Resumen de pago',
      fare: 'Tarifa',
      airportFee: 'Tarifa de aeropuerto',
      tip: 'Propina',
      total: 'Total',
      complimentary: 'Complementario',
      curbside: 'Acera (gratis)',
      meetAndGreet: 'Meet & Greet',
      priceChange: 'Sus ediciones han cambiado el precio de esta reserva, asegúrese de informar al cliente de la actualización del precio.',
      totalFareChange: 'Cambio de tarifa total desde',
      updateSuccessMsg: '<b>Reserva {id}</b> actualizada con éxito',
      updatingReservation: 'Actualización de reserva...',
      emptyField: 'Este campo no puede estar vacío.',
      adminTimeBufferError: 'El tiempo de envío debe ser mayor a {min} minutos desde la hora actual.',
      selectError: 'Seleccione de la lista.',
      selectService: 'Seleccione un servicio para esta reserva.',
      serviceRestrictions: 'Ciertos servicios no están disponibles debido a restricciones del área de servicio.',
      zeroValue: 'El valor no puede ser menor o igual a cero.'
    }
  },
  rsvpNotes: {
    title: {
      regular: 'Por favor deja una nota.',
      refund: 'Reserva de reembolso',
      confirmRefund: 'Confirmar reembolso',
      noShowRefund: 'Confirmar No Show Refund'
    },
    payCancellationFee: 'El cliente deberá pagar una tarifa de cancelación de <b> {amount} </ b>. ¿Quieres cobrar la tarifa de cancelación?',
    yes: 'Sí',
    no: 'No',
    refundType: 'Tipo de reembolso',
    fullRefund: 'Reembolso completo',
    partialRefund: 'Reembolso parcial',
    issueCredit: 'Emitir crédito',
    additionalCharge: 'Cargos adicionales',
    refundAmountEmpty: 'El campo no puede estar vacío.',
    notNumber: 'Número invalido.',
    lowNumber: 'No puede ser menor o igual a cero.',
    close: 'Cerca',
    notes: 'Notas',
    emptyNotes: 'Por favor ponga una nota en el cuadro de texto.',
    charLeft: '{value} Personaje(s) dejado.',
    status: 'Estado',
    new: 'NUEVO',
    investigation: 'INVESTIGACIÓN',
    resolved: 'RESUELTO',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    successCredit: 'Emitió crédito exitosamente!'
  },
  transactions: {
    title: 'Actas',
    gross: 'Ingresos brutos',
    ofDateRange: 'del rango de fechas',
    creditUsed: 'Crédito utilizado',
    onlineProv: 'Proveedores en línea',
    filter: {
      search: 'Buscar',
      searchEmpty: 'Seleccionar "Todo" del rango de fechas requiere buscar palabra clave.',
      status: 'Estado',
      dateRange: 'Rango de fechas',
      all: 'Todas',
      custom: 'Personalizado',
      declined: 'Rechazado',
      cancelled: 'Cancelado',
      promo: 'Promoción',
      purchased: 'Comprado',
      authorized: 'Autorizado',
      noShow: 'No Show',
      completed: 'Terminado',
      refund: 'Reembolso',
      edited: 'Editado',
      withinDay: 'En un día',
      monthToDate: 'Mes hasta la fecha',
      lastMonth: 'El mes pasado',
      lastWeek: 'La semana pasada',
      last2Week: 'Las últimas 2 semanas',
      last30Days: 'Últimos 30 días',
      last60Days: 'Últimos 60 días',
      last90Days: 'Últimos 90 días',
      from: 'De',
      to: 'A',
      invalidDateRange: 'Rango de fecha no válido.',
      emptyDate: 'El campo no puede estar vacío.',
      refresh: 'Refrescar',
      export: 'Exportar'
    },
    list: {
      date: 'Fecha',
      serviceArea: 'Área de servicio',
      company: 'Empresa',
      invoiceId: 'Factura ID',
      rsvpId: 'RSVP ID',
      pickup: 'Recoger',
      dropoff: 'Dropoff',
      type: 'Tipo',
      service: 'Servicio',
      customerName: 'Nombre del cliente',
      email: 'Email',
      mobile: 'Móvil',
      creditCard: 'Tarjeta de crédito',
      source: 'Fuente',
      finalOffer: 'Oferta final',
      chargedAmount: 'Cantidad cobrada',
      bonus: 'Prima',
      promoUsed: 'Promoción utilizada',
      cancelFee: 'Cancelar tarifa',
      status: 'Estado',
      loading: 'Obteniendo Transacciones...',
      empty: 'Ningún record fue encontrado!',
      display: 'Monitor',
      resultsPerPage: 'resultados por página.',
      displaying: 'Mostrando {min} - {max} de {total}'
    },
    unableToRefund: 'No se puede reembolsar',
    otherMeans: 'Esta transacción se pagó a través de medios que no sean una tarjeta de crédito. No puede ser reembolsado automáticamente a través del sistema. Por favor cancele la reserva a través de la página Editar RSVP.',
    close: 'Cerca'
  }
});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// all.js